webpackJsonp([1,0,2],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _freeze = __webpack_require__(770);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	var _toConsumableArray2 = __webpack_require__(99);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	__webpack_require__(634);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _vue = __webpack_require__(164);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(120);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _index = __webpack_require__(172);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _vueRouter = __webpack_require__(532);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _customValidate = __webpack_require__(627);
	
	var _customValidate2 = _interopRequireDefault(_customValidate);
	
	var _vueSmoothScroll = __webpack_require__(2229);
	
	var _vueSmoothScroll2 = _interopRequireDefault(_vueSmoothScroll);
	
	var _vMdDateRangePicker = __webpack_require__(556);
	
	var _vMdDateRangePicker2 = _interopRequireDefault(_vMdDateRangePicker);
	
	var _vue2Datepicker = __webpack_require__(533);
	
	var _vue2Datepicker2 = _interopRequireDefault(_vue2Datepicker);
	
	var _jsCookie = __webpack_require__(1695);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _filters = __webpack_require__(633);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _validators = __webpack_require__(760);
	
	var _validators2 = _interopRequireDefault(_validators);
	
	var _directives = __webpack_require__(629);
	
	var _directives2 = _interopRequireDefault(_directives);
	
	var _components = __webpack_require__(620);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _vueMixin = __webpack_require__(764);
	
	var _vueMixin2 = _interopRequireDefault(_vueMixin);
	
	var _routes = __webpack_require__(97);
	
	var _config = __webpack_require__(626);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _vue2TouchEvents = __webpack_require__(2230);
	
	var _vue2TouchEvents2 = _interopRequireDefault(_vue2TouchEvents);
	
	var _mobile = __webpack_require__(635);
	
	var _mobile2 = _interopRequireDefault(_mobile);
	
	var _documents = __webpack_require__(234);
	
	var _documents2 = _interopRequireDefault(_documents);
	
	var _documents3 = __webpack_require__(748);
	
	var _documents4 = _interopRequireDefault(_documents3);
	
	__webpack_require__(1502);
	
	__webpack_require__(779);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.config.errorHandler = function (err, vm) {
	  console.error(err);
	  console.error("Context:");
	  console.error(vm);
	};
	
	var configValidator = {
	  delay: 500,
	  strict: false
	};
	
	_vue2.default.use(_customValidate2.default, configValidator);
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_filters2.default);
	_vue2.default.use(_validators2.default);
	_vue2.default.use(_directives2.default);
	_vue2.default.use(_components2.default);
	_vue2.default.use(_vueSmoothScroll2.default);
	_vue2.default.use(_vue2TouchEvents2.default);
	_vue2.default.use(_vMdDateRangePicker2.default);
	_vue2.default.use(_vue2Datepicker2.default);
	_vue2.default.use(_jsCookie2.default);
	_vue2.default.use(_vuex2.default);
	_vue2.default.mixin(_vueMixin2.default);
	
	_config2.default.run();
	
	_documents4.default.getDocumentsByInterface(["WEBSITE", "MOBILE"]).then(function (res) {
	  if (res.status.code == 0) {
	    _documents2.default.push.apply(_documents2.default, (0, _toConsumableArray3.default)(res.ListDoc));
	    (0, _freeze2.default)(_documents2.default);
	
	    new _vue2.default({
	      router: _routes.router,
	      store: _index2.default
	    }).$mount('#app');
	  } else {
	    console.error("Falha ao carregar documentos. Código:", res.status.code);
	  }
	}).catch(function (err) {
	  console.error("Erro na requisição dos documentos:", err);
	  new _vue2.default({
	    router: _routes.router,
	    store: _index2.default
	  }).$mount('#app');
	});
	
	window.$mobile = _mobile2.default;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = requiredArgs;
	
	function requiredArgs(required, args) {
	  if (args.length < required) {
	    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = function normalizeComponent (
	  rawScriptExports,
	  compiledTemplate,
	  scopeId,
	  cssModules
	) {
	  var esModule
	  var scriptExports = rawScriptExports = rawScriptExports || {}
	
	  // ES6 modules interop
	  var type = typeof rawScriptExports.default
	  if (type === 'object' || type === 'function') {
	    esModule = rawScriptExports
	    scriptExports = rawScriptExports.default
	  }
	
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (compiledTemplate) {
	    options.render = compiledTemplate.render
	    options.staticRenderFns = compiledTemplate.staticRenderFns
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = scopeId
	  }
	
	  // inject cssModules
	  if (cssModules) {
	    var computed = options.computed || (options.computed = {})
	    Object.keys(cssModules).forEach(function (key) {
	      var module = cssModules[key]
	      computed[key] = function () { return module }
	    })
	  }
	
	  return {
	    esModule: esModule,
	    exports: scriptExports,
	    options: options
	  }
	}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key;
	                for (i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i;
	            for (i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
	                    matched,
	                    p1,
	                    p2,
	                    p3,
	                    p4
	                ) {
	                    return p1 || p2 || p3 || p4;
	                })
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
	            '_'
	        ),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(1697)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^)]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
	        input,
	        array,
	        config,
	        token
	    ) {
	        var era = config._locale.erasParse(input, token, config._strict);
	        if (era) {
	            getParsingFlags(config).era = era;
	        } else {
	            getParsingFlags(config).invalidEra = input;
	        }
	    });
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.1';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(534)(module)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toDate;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name toDate
	 * @category Common Helpers
	 * @summary Convert the given argument to an instance of Date.
	 *
	 * @description
	 * Convert the given argument to an instance of Date.
	 *
	 * If the argument is an instance of Date, the function returns its clone.
	 *
	 * If the argument is a number, it is treated as a timestamp.
	 *
	 * If the argument is none of the above, the function returns Invalid Date.
	 *
	 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
	 *
	 * @param {Date|Number} argument - the value to convert
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Clone the date:
	 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert the timestamp to date:
	 * const result = toDate(1392098430000)
	 * //=> Tue Feb 11 2014 11:30:30
	 */
	function toDate(argument) {
	  (0, _index.default)(1, arguments);
	  var argStr = Object.prototype.toString.call(argument); // Clone the date
	
	  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
	    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
	    return new Date(argument.getTime());
	  } else if (typeof argument === 'number' || argStr === '[object Number]') {
	    return new Date(argument);
	  } else {
	    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
	      // eslint-disable-next-line no-console
	      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
	
	      console.warn(new Error().stack);
	    }
	
	    return new Date(NaN);
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.6.0
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright OpenJS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2021-03-02T17:08Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var flat = arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};
	
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
			// Support: Chrome <=57, Firefox <=52
			// In some browsers, typeof returns "function" for HTML <object> elements
			// (i.e., `typeof document.createElement( "object" ) === "function"`).
			// We don't want to classify *any* DOM node as a function.
			// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
			// Plus for old WebKit, typeof returns "function" for HTML collections
			// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
			return typeof obj === "function" && typeof obj.nodeType !== "number" &&
				typeof obj.item !== "function";
		};
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	var document = window.document;
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.6.0",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},
	
		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
							[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return flat( ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
		function( _i, name ) {
			class2type[ "[object " + name + "]" ] = name.toLowerCase();
		} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.6
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://js.foundation/
	 *
	 * Date: 2021-02-16
	 */
	( function( window ) {
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ( {} ).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		pushNative = arr.push,
		push = arr.push,
		slice = arr.slice,
	
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[ i ] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
			"ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
	
			// "Attribute values must be CSS identifiers [capture 5]
			// or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
	
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
			whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
			"*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
	
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rhtml = /HTML$/i,
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;
	
			return nonHex ?
	
				// Strip the backslash prefix from a non-hex escape sequence
				nonHex :
	
				// Replace a hexadecimal escape sequence with the encoded Unicode code point
				// Support: IE <=11+
				// For values outside the Basic Multilingual Plane (BMP), manually construct a
				// surrogate pair
				high < 0 ?
					String.fromCharCode( high + 0x10000 ) :
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" +
					ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);
	
		// Support: Android<4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
	
				// Can't trust NodeList.length
				while ( ( target[ j++ ] = els[ i++ ] ) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {
	
					// ID selector
					if ( ( m = match[ 1 ] ) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&
	
					// Support: IE 8 only
					// Exclude object elements
					( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
	
						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						if ( newContext !== context || !support.scope ) {
	
							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = nid.replace( rcssescape, fcssescape );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
	
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
	
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );
	
		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {
	
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
	
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split( "|" ),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[ i ] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( ( cur = cur.nextSibling ) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return ( name === "input" || name === "button" ) && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;
	
		// Support: IE <=8
		// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
		// https://bugs.jquery.com/ticket/4833
		return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
		// Safari 4 - 5 only, Opera <=11.6 - 12.x only
		// IE/Edge & older browsers don't support the :scope pseudo-class.
		// Support: Safari 6.0 only
		// Safari 6.0 supports :scope but it's an alias of :root there.
		support.scope = assert( function( el ) {
			docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
			return typeof el.querySelectorAll !== "undefined" &&
				!el.querySelectorAll( ":scope fieldset div" ).length;
		} );
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert( function( el ) {
			el.className = "i";
			return !el.getAttribute( "className" );
		} );
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert( function( el ) {
			el.appendChild( document.createComment( "" ) );
			return !el.getElementsByTagName( "*" ).length;
		} );
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		} );
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter[ "ID" ] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter[ "ID" ] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find[ "TAG" ] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
	
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( ( elem = results[ i++ ] ) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {
	
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert( function( el ) {
	
				var input;
	
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll( "[selected]" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push( "~=" );
				}
	
				// Support: IE 11+, Edge 15 - 18+
				// IE 11/Edge don't find elements on a `[name='']` query in some cases.
				// Adding a temporary attribute to the document before the selection works
				// around the issue.
				// Interestingly, IE 10 & older don't seem to have the issue.
				input = document.createElement( "input" );
				input.setAttribute( "name", "" );
				el.appendChild( input );
				if ( !el.querySelectorAll( "[name='']" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
						whitespace + "*(?:''|\"\")" );
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll( ":checked" ).length ) {
					rbuggyQSA.push( ":checked" );
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push( ".#.+[+~]" );
				}
	
				// Support: Firefox <=3.6 - 5 only
				// Old Firefox doesn't throw on a badly-escaped identifier.
				el.querySelectorAll( "\\\f" );
				rbuggyQSA.push( "[\\r\\n\\f]" );
			} );
	
			assert( function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement( "input" );
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll( "[name=d]" ).length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: Opera 10 - 11 only
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll( "*,:x" );
				rbuggyQSA.push( ",.*:" );
			} );
		}
	
		if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector ) ) ) ) {
	
			assert( function( el ) {
	
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			} );
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				) );
			} :
			function( a, b ) {
				if ( b ) {
					while ( ( b = b.parentNode ) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {
	
				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a == document || a.ownerDocument == preferredDoc &&
					contains( preferredDoc, a ) ) {
					return -1;
				}
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b == document || b.ownerDocument == preferredDoc &&
					contains( preferredDoc, b ) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
	
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				return a == document ? -1 :
					b == document ? 1 :
					/* eslint-enable eqeqeq */
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( ( cur = cur.parentNode ) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( ( cur = cur.parentNode ) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[ i ] === bp[ i ] ) {
				i++;
			}
	
			return i ?
	
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[ i ], bp[ i ] ) :
	
				// Otherwise nodes in our document sort first
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				ap[ i ] == preferredDoc ? -1 :
				bp[ i ] == preferredDoc ? 1 :
				/* eslint-enable eqeqeq */
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		setDocument( elem );
	
		if ( support.matchesSelector && documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
	
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
	
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
	
			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {
	
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
	
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
	
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
	
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
					match[ 5 ] || "" ).replace( runescape, funescape );
	
				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
	
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();
	
				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {
	
					// nth-* requires argument
					if ( !match[ 3 ] ) {
						Sizzle.error( match[ 0 ] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );
	
					// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];
	
				if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
	
					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&
	
					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {
	
					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace +
						")" + className + "(" + whitespace + "|$)" ) ) && classCache(
							className, function( elem ) {
								return pattern.test(
									typeof elem.className === "string" && elem.className ||
									typeof elem.getAttribute !== "undefined" &&
										elem.getAttribute( "class" ) ||
									""
								);
					} );
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					/* eslint-disable max-len */
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
					/* eslint-enable max-len */
	
				};
			},
	
			"CHILD": function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, _context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
	
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || ( node[ expando ] = {} );
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
	
								// Use previously-cached element index if available
								if ( useCache ) {
	
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || ( node[ expando ] = {} );
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										( outerCache[ node.uniqueID ] = {} );
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
	
									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													( outerCache[ node.uniqueID ] = {} );
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
	
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
	
			// Potentially complex pseudos
			"not": markFunction( function( selector ) {
	
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );
	
						// Don't keep the element (issue #299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),
	
			"has": markFunction( function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			} ),
	
			"contains": markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
				};
			} ),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
	
				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement &&
					( !document.hasFocus || document.hasFocus() ) &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
	
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return ( nodeName === "input" && !!elem.checked ) ||
					( nodeName === "option" && !!elem.selected );
			},
	
			"selected": function( elem ) {
	
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
	
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos[ "empty" ]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo( function() {
				return [ 0 ];
			} ),
	
			"last": createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),
	
			"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),
	
			"even": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"odd": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ?
					argument + length :
					argument > length ?
						length :
						argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};
	
	Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {
	
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}
	
			matched = false;
	
			// Combinators
			if ( ( match = rcombinators.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
	
					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrim, " " )
				} );
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
	
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
	
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] ||
								( outerCache[ elem.uniqueID ] = {} );
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = uniqueCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {
	
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[ i ], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts(
					selector || "*",
					context.nodeType ? [ context ] : context,
					[]
				),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
	
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
	
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {
	
								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {
	
							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
	
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
	
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
	
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens
							.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;
	
				if ( outermost ) {
	
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
	
						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
	
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
	
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache(
				selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers )
			);
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {
	
				context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
					.replace( runescape, funescape ), context ) || [] )[ 0 ];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {
	
					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
							context
					) ) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {
	
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert( function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute( "href" ) === "#";
	} ) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		} );
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert( function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	} ) ) {
		addHandle( "value", function( elem, _name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		} );
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert( function( el ) {
		return el.getAttribute( "disabled" ) == null;
	} ) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
					( val = elem.getAttributeNode( name ) ) && val.specified ?
						val.value :
						null;
			}
		} );
	}
	
	return Sizzle;
	
	} )( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	}
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&
	
				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {
	
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the primary Deferred
				primary = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							primary.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( primary.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return primary.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
			}
	
			return primary.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
							value :
							value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 - 11+
	// focus() and blur() are asynchronous, except when they are no-op.
	// So expect focus to be synchronous when the element is already active,
	// and blur to be synchronous when the element is not already active.
	// (focus and blur are always synchronous in other supported browsers,
	// this just defines when we can count on it).
	function expectSync( elem, type ) {
		return ( elem === safeActiveElement() ) === ( type === "focus" );
	}
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),
	
				handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
							return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
							return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", returnTrue );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, expectSync ) {
	
		// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
		if ( !expectSync ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var notAsync, result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					// Saved data should be false in such cases, but might be a leftover capture object
					// from an async native handler (gh-4350)
					if ( !saved.length ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						// Support: IE <=9 - 11+
						// focus() and blur() are asynchronous
						notAsync = expectSync( this, type );
						this[ type ]();
						result = dataPriv.get( this, type );
						if ( saved !== result || notAsync ) {
							dataPriv.set( this, type, false );
						} else {
							result = {};
						}
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
	
							// Support: Chrome 86+
							// In Chrome, if an element having a focusout handler is blurred by
							// clicking outside of it, it invokes the handler synchronously. If
							// that handler calls `.remove()` on the element, the data is cleared,
							// leaving `result` undefined. We need to guard against this.
							return result && result.value;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering the
					// native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved.length ) {
	
					// ...and capture the result
					dataPriv.set( this, type, {
						value: jQuery.event.trigger(
	
							// Support: IE <=9 - 11+
							// Extend with the prototype to reset the above stopImmediatePropagation()
							jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
							saved.slice( 1 ),
							this
						)
					} );
	
					// Abort handling of the native event
					event.stopImmediatePropagation();
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
		which: true
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, expectSync );
	
				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			// Suppress native focus or blur as it's already being fired
			// in leverageNative.
			_default: function() {
				return true;
			},
	
			delegateType: delegateType
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;
	
			if ( events ) {
				dataPriv.remove( dest, "handle events" );
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = flat( args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.call( elem );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},
	
			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			//
			// Support: Firefox 70+
			// Only Firefox includes border widths
			// in computed dimensions. (gh-4529)
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );
	
					table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
					tr.style.cssText = "border:1px solid";
	
					// Support: Chrome 86+
					// Height set through cssText does not get applied.
					// Computed height then comes back as 0.
					tr.style.height = "1px";
					trChild.style.height = "9px";
	
					// Support: Android 8 Chrome 86+
					// In our bodyBackground.html iframe,
					// display for all div elements is set to "inline",
					// which causes a problem only in Android 8 Chrome 86.
					// Ensuring the div is display: block
					// gets around this issue.
					trChild.style.display = "block";
	
					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );
	
					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
						parseInt( trStyle.borderTopWidth, 10 ) +
						parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;
	
					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( _elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||
	
			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||
	
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
	
			// Make sure the element is visible & connected
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"gridArea": true,
			"gridColumn": true,
			"gridColumnEnd": true,
			"gridColumnStart": true,
			"gridRow": true,
			"gridRowEnd": true,
			"gridRowStart": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
				) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
					/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
	
			doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( isValidValue ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
								"" :
								dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	support.focusin = "onfocusin" in window;
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
	
					// Handle: regular nodes (via `this.ownerDocument`), window
					// (via `this.document`) & document (via `this`).
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = { guid: Date.now() };
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, parserErrorElem;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {}
	
		parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
		if ( !xml || parserErrorElem ) {
			jQuery.error( "Invalid XML: " + (
				parserErrorElem ?
					jQuery.map( parserErrorElem.childNodes, function( el ) {
						return el.textContent;
					} ).join( "\n" ) :
					data
			) );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} ).filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} ).map( function( _i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
	
	originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Use a noop converter for missing script but not if jsonp
				if ( !isSuccess &&
					jQuery.inArray( "script", s.dataTypes ) > -1 &&
					jQuery.inArray( "json", s.dataTypes ) < 0 ) {
					s.converters[ "text script" ] = function() {};
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );
	
	
	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( {
			padding: "inner" + name,
			content: type,
			"": "outer" + name
		}, function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
	
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	jQuery.each(
		( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {
	
			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		}
	);
	
	
	
	
	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	};
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildFormatLongFn;
	
	function buildFormatLongFn(args) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    // TODO: Remove String()
	    var width = options.width ? String(options.width) : args.defaultWidth;
	    var format = args.formats[width] || args.formats[args.defaultWidth];
	    return format;
	  };
	}
	
	module.exports = exports.default;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildLocalizeFn;
	
	function buildLocalizeFn(args) {
	  return function (dirtyIndex, dirtyOptions) {
	    var options = dirtyOptions || {};
	    var context = options.context ? String(options.context) : 'standalone';
	    var valuesArray;
	
	    if (context === 'formatting' && args.formattingValues) {
	      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
	      var width = options.width ? String(options.width) : defaultWidth;
	      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
	    } else {
	      var _defaultWidth = args.defaultWidth;
	
	      var _width = options.width ? String(options.width) : args.defaultWidth;
	
	      valuesArray = args.values[_width] || args.values[_defaultWidth];
	    }
	
	    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challange you to try to remove it!
	
	    return valuesArray[index];
	  };
	}
	
	module.exports = exports.default;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchFn;
	
	function buildMatchFn(args) {
	  return function (string) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var width = options.width;
	    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
	    var matchResult = string.match(matchPattern);
	
	    if (!matchResult) {
	      return null;
	    }
	
	    var matchedString = matchResult[0];
	    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
	    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
	      return pattern.test(matchedString);
	    }) : findKey(parsePatterns, function (pattern) {
	      return pattern.test(matchedString);
	    });
	    var value;
	    value = args.valueCallback ? args.valueCallback(key) : key;
	    value = options.valueCallback ? options.valueCallback(value) : value;
	    var rest = string.slice(matchedString.length);
	    return {
	      value: value,
	      rest: rest
	    };
	  };
	}
	
	function findKey(object, predicate) {
	  for (var key in object) {
	    if (object.hasOwnProperty(key) && predicate(object[key])) {
	      return key;
	    }
	  }
	
	  return undefined;
	}
	
	function findIndex(array, predicate) {
	  for (var key = 0; key < array.length; key++) {
	    if (predicate(array[key])) {
	      return key;
	    }
	  }
	
	  return undefined;
	}
	
	module.exports = exports.default;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchPatternFn;
	
	function buildMatchPatternFn(args) {
	  return function (string) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var matchResult = string.match(args.matchPattern);
	    if (!matchResult) return null;
	    var matchedString = matchResult[0];
	    var parseResult = string.match(args.parsePattern);
	    if (!parseResult) return null;
	    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
	    value = options.valueCallback ? options.valueCallback(value) : value;
	    var rest = string.slice(matchedString.length);
	    return {
	      value: value,
	      rest: rest
	    };
	  };
	}
	
	module.exports = exports.default;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toInteger;
	
	function toInteger(dirtyNumber) {
	  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
	    return NaN;
	  }
	
	  var number = Number(dirtyNumber);
	
	  if (isNaN(number)) {
	    return number;
	  }
	
	  return number < 0 ? Math.ceil(number) : Math.floor(number);
	}
	
	module.exports = exports.default;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _assign = __webpack_require__(122);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _stringify = __webpack_require__(70);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getPrototypeOf = __webpack_require__(175);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(28);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(247);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(246);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vue = __webpack_require__(164);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _utils = __webpack_require__(34);
	
	var Utils = _interopRequireWildcard(_utils);
	
	var _encryptSjcl = __webpack_require__(632);
	
	var _encryptSjcl2 = _interopRequireDefault(_encryptSjcl);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthService = function (_Vue) {
	  (0, _inherits3.default)(AuthService, _Vue);
	
	  function AuthService() {
	    (0, _classCallCheck3.default)(this, AuthService);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AuthService.__proto__ || (0, _getPrototypeOf2.default)(AuthService)).call(this));
	
	    if (!!localStorage.getItem("currentUser")) {
	      _this._currentUser = JSON.parse(localStorage.getItem("currentUser"));
	      _this._parentUser = JSON.parse(localStorage.getItem("parentUser"));
	    }
	    return _this;
	  }
	
	  (0, _createClass3.default)(AuthService, [{
	    key: "checkUserLoggedGuard",
	    value: function checkUserLoggedGuard(route_to, route_from, next) {
	      if (route_to.name == "login") {
	        if (!!this.currentUser) next({ name: "plans" });
	
	        next();
	        return;
	      }
	      if (route_to.name == "2fa-interno") {
	        next();
	        return;
	      }
	      if (!this.currentUser) {
	        next({ name: "login" });
	      } else {
	        next();
	      }
	    }
	  }, {
	    key: "updateLocalStorage",
	    value: function updateLocalStorage() {
	      localStorage.setItem("currentUser", (0, _stringify2.default)(this._currentUser));
	    }
	  }, {
	    key: "login",
	    value: function login(username, password, email) {
	      var _this2 = this;
	
	      return _axios2.default.post("/v2/auth/login", {
	        login: {
	          taxIdNumber: username,
	          password: password,
	          email: email,
	          _interface: window.document.webview ? "MOBILE" : "WEBSITE"
	        },
	        versionMobile: window.document.webview ? 10 : undefined
	      }).then(function (r) {
	        var redirect2FA = r.data.redirect_2fa;
	        _this2.saveLoginTFA(redirect2FA);
	        if (redirect2FA === "Y") {
	          return r.data;
	        } else {
	          return _axios2.default.get("/v2/getUserAndAddressByMoveMaisId/" + r.data.token.movemaisId).then(function (res) {
	            if (res.data.user.salesReferenceOther !== "REPOM") {
	              var user = res.data.user;
	              user.ssa = res.data.ssa;
	              user.sessionId = res.data.sessionId;
	              user.address = res.data.address;
	              _this2.currentUser = res.data.user;
	              _this2.parentUser = res.data.user;
	              _this2.$emit("loginSucessful", _this2.currentUser);
	              _this2.$emit("userChanged", _this2.currentUser);
	            } else {
	              return res.data.user;
	            }
	            return _this2.currentUser;
	          });
	        }
	      });
	    }
	  }, {
	    key: "checkUserPassword",
	    value: function checkUserPassword(taxIdNumber, password) {
	      return _axios2.default.post("/v2/checkUserPassword", {
	        taxIdNumber: taxIdNumber,
	        password: password
	      }).then(function (r) {
	        return r.data;
	      });
	    }
	  }, {
	    key: "checkCpfValidationPermission",
	    value: function checkCpfValidationPermission() {
	      var _this3 = this;
	
	      var now = Date.now();
	      if (this._internalToken && this._internalTokenExpiry && now < this._internalTokenExpiry) {
	        return _promise2.default.resolve({ token: this._internalToken });
	      }
	
	      return _axios2.default.get("/v2/internal/token", {}).then(function (r) {
	        if (r.data && r.data.token) {
	          _this3._internalToken = r.data.token;
	          _this3._internalTokenExpiry = Date.now() + 4 * 60 * 1000;
	        }
	        return r.data;
	      });
	    }
	  }, {
	    key: "checkUserPasswordTransfer",
	    value: function checkUserPasswordTransfer(taxIdNumber, password) {
	      return _axios2.default.post("/v2/checkUserPasswordTransfer", {
	        taxIdNumber: taxIdNumber,
	        password: password
	      }).then(function (r) {
	        return r.data;
	      });
	    }
	  }, {
	    key: "logout",
	    value: function logout() {
	      this.currentUser = undefined;
	      this.parentUser = undefined;
	      localStorage.removeItem("contracts_current_user");
	      localStorage.removeItem("currentUser");
	      return _promise2.default.resolve(null);
	    }
	  }, {
	    key: "requestPasswordReset",
	    value: function requestPasswordReset(username) {
	      return _axios2.default.post("/v1/requestPasswordReset", {
	        taxIdNumber: username,
	        _interface: "WEBSITE"
	      }).then(function (res) {
	        return _promise2.default.resolve(true);
	      });
	    }
	  }, {
	    key: "newRequestPasswordReset",
	    value: function newRequestPasswordReset(userName, movemaisId) {
	      return _axios2.default.post("/v2/auth/genHashM", {
	        taxIdNumber: userName,
	        movemaisId: movemaisId
	      }).then(function (res) {
	        return _promise2.default.resolve(true);
	      });
	    }
	  }, {
	    key: "validarTokenPorMoveMaisId",
	    value: function validarTokenPorMoveMaisId(moveMaisId, codigo) {
	      return _axios2.default.post("/v2/auth/validarTokenPorMoveMaisId/" + moveMaisId + "/" + codigo).then(function (res) {
	        return _promise2.default.resolve(res.data);
	      }).catch(function (err) {
	        return _promise2.default.reject(err);
	      });
	    }
	  }, {
	    key: "resetPassword",
	    value: function resetPassword(newPassword, movemaisId) {
	      return _axios2.default.post("/v2/auth/resetPassword", {
	        newPassword: newPassword,
	        moveMaisId: Number(movemaisId),
	        _interface: "WEBSITE"
	      }).then(function (res) {
	        return _promise2.default.resolve(true);
	      });
	    }
	  }, {
	    key: "resetPasswordV1",
	    value: function resetPasswordV1(token, password) {
	      return _axios2.default.post("/v1/resetPassword", {
	        newPassword: password,
	        passwordToken: token,
	        _interface: "WEBSITE"
	      }).then(function (res) {
	        return _promise2.default.resolve(true);
	      });
	    }
	  }, {
	    key: "changePassword",
	    value: function changePassword(currentPassword, newPassword) {
	      return _axios2.default.post("/v2/auth/changePassword", {
	        currentPassword: currentPassword,
	        newPassword: newPassword,
	        taxIdNumber: this._currentUser.taxIdNumber
	      }).then(function (res) {
	        return _promise2.default.resolve(true);
	      });
	    }
	  }, {
	    key: "changeCurrentUser",
	    value: function changeCurrentUser(moveMaisId) {
	      var _this4 = this;
	
	      return _axios2.default.get("/v2/getUserAndAddressByMoveMaisId/" + moveMaisId).then(function (res) {
	        var userAndAddress = (0, _assign2.default)(res.data.user, {
	          address: res.data.address
	        });
	        _this4.currentUser = userAndAddress;
	      });
	    }
	  }, {
	    key: "loginAtendente",
	    value: function loginAtendente(passwordSiva, accessToken) {
	      var _this5 = this;
	
	      return _axios2.default.post("/v2/lgnAtn/" + passwordSiva, { GZK: accessToken }).then(function (r) {
	        return _axios2.default.get("/v2/getUserAndAddressByMoveMaisId/" + r.data.id);
	      }).then(function (res) {
	        var user = res.data.user;
	        user.address = res.data.address;
	        _this5.currentUser = res.data.user;
	        _this5.parentUser = res.data.user;
	        return _this5.currentUser;
	      });
	    }
	  }, {
	    key: "loginSSA",
	    value: function loginSSA(taxIdNumber, sessionId) {
	      var _this6 = this;
	
	      return _axios2.default.post("/v1/loginSSA", { taxIdNumber: taxIdNumber, sessionId: sessionId }).then(function (r) {
	        return _axios2.default.get("/v2/getUserAndAddressByTaxIdNumber/" + taxIdNumber);
	      }).then(function (res) {
	        var user = res.data.user;
	        user.address = res.data.address;
	        _this6.currentUser = res.data.user;
	        _this6.parentUser = res.data.user;
	        return _this6.currentUser;
	      });
	    }
	  }, {
	    key: "saveTaxId",
	    value: function saveTaxId(taxId, pass) {
	      var password = _encryptSjcl2.default.encrypt("password", pass);
	      localStorage.setItem("taxId", taxId);
	      localStorage.setItem("password", password);
	    }
	  }, {
	    key: "saveTaxIdNumber",
	    value: function saveTaxIdNumber(taxIdNumber) {
	      localStorage.setItem("taxIdNumber", taxIdNumber);
	    }
	  }, {
	    key: "getTaxIdNumber",
	    value: function getTaxIdNumber() {
	      return localStorage.getItem("taxIdNumber");
	    }
	  }, {
	    key: "getTaxId",
	    value: function getTaxId(taxId) {
	      return localStorage.getItem("taxId");
	    }
	  }, {
	    key: "getTaxIdFromSession",
	    value: function getTaxIdFromSession() {
	      var cookie = Utils.getCookie("PLAY_SESSION");
	      return cookie.substr(cookie.indexOf("taxId"), 16).split("=")[1];
	    }
	  }, {
	    key: "getPass",
	    value: function getPass(pass) {
	      return _encryptSjcl2.default.decrypt("password", localStorage.getItem("password"));
	    }
	  }, {
	    key: "deleteTaxId",
	    value: function deleteTaxId() {
	      localStorage.removeItem("taxId");
	    }
	  }, {
	    key: "saveHash",
	    value: function saveHash(hash) {
	      localStorage.setItem("hash", hash);
	    }
	  }, {
	    key: "getHash",
	    value: function getHash() {
	      return localStorage.getItem("hash");
	    }
	  }, {
	    key: "validUserResetPassword",
	    value: function validUserResetPassword(taxIdNumber, phone, email) {
	      return _axios2.default.post("/v2/auth/validUserResetPassword", {
	        taxIdNumber: taxIdNumber,
	        phone: phone,
	        email: email
	      }).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "twoFactorAuthentication",
	    value: function twoFactorAuthentication(taxIdNumber, token, origin) {
	      return _axios2.default.post("/v2/twoFactorAuthentication/checkOTP", {
	        taxIdNumber: taxIdNumber,
	        token: token,
	        origin: origin,
	        _interface: "WEBSITE"
	      }).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "tokenGenerateResend",
	    value: function tokenGenerateResend(taxIdNumber, origin, channel) {
	      return _axios2.default.post("/v2/twoFactorAuthentication/tokenGenerateResend", {
	        taxIdNumber: taxIdNumber,
	        origin: origin,
	        channel: channel
	      }).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "twoFactorAuthenticationNew",
	    value: function twoFactorAuthenticationNew(taxIdNumber, token, origin, to) {
	      return _axios2.default.post("/v2/twoFactorAuthenticationNew/checkOTP", {
	        taxIdNumber: taxIdNumber,
	        token: token,
	        origin: origin,
	        _interface: "WEBSITE",
	        to: to
	      }).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "tokenGenerateResendNew",
	    value: function tokenGenerateResendNew(taxIdNumber, origin, to) {
	      return _axios2.default.post("/v2/twoFactorAuthenticationNew/tokenGenerateResend", {
	        taxIdNumber: taxIdNumber,
	        origin: origin,
	        to: to
	      }).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "retrieveEmail",
	    value: function retrieveEmail(taxIdNumber, phone) {
	      return _axios2.default.post("/v2/auth/retrieveEmail", {
	        taxIdNumber: taxIdNumber,
	        phone: phone
	      }).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "saveToken",
	    value: function saveToken(token) {
	      localStorage.setItem("token", token);
	    }
	  }, {
	    key: "getToken",
	    value: function getToken() {
	      return localStorage.getItem("token");
	    }
	  }, {
	    key: "saveMoveMaisId",
	    value: function saveMoveMaisId(movemaisId) {
	      localStorage.setItem("movemaisId", movemaisId);
	    }
	  }, {
	    key: "getMoveMaisId",
	    value: function getMoveMaisId() {
	      return localStorage.getItem("movemaisId");
	    }
	  }, {
	    key: "requestChangePassword",
	    value: function requestChangePassword(taxIdNumber) {
	      return _axios2.default.post("/v2/auth/requestChangePassword", { taxIdNumber: taxIdNumber }).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "validToken",
	    value: function validToken(password, hashUrl) {
	      return _axios2.default.post("/v2/auth/validToken", { token: hashUrl, password: password }).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "sendTokenNewUserData",
	    value: function sendTokenNewUserData(taxIdNumber, phone, email) {
	      return _axios2.default.post("/v2/sendTokenNewUserData", {
	        taxIdNumber: taxIdNumber,
	        phone: phone,
	        email: email
	      }).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "sendEmailValidationCode",
	    value: function sendEmailValidationCode(taxIdNumber) {
	      return _axios2.default.post("/v2/auth/sendEmailValidationCode", {
	        taxIdNumber: taxIdNumber,
	        _interface: "WEBSITE"
	      }).then(function (res) {
	        return _promise2.default.resolve(res.data);
	      }).catch(function (err) {
	        return _promise2.default.reject(err);
	      });
	    }
	  }, {
	    key: "generateTokenSite",
	    value: function generateTokenSite(moveMaisId, channel) {
	      if (!channel) {
	        return _promise2.default.reject(new Error("Canal de notificação é obrigatório"));
	      }
	
	      var channelMap = {
	        WHATSAPP: "WHATSAPP",
	        SMS: "SMS",
	        EMAIL: "E-MAIL"
	      };
	
	      var apiChannel = channelMap[channel] || channel;
	
	      return _axios2.default.post("/v2/auth/generateTokenSite/" + moveMaisId + "/" + apiChannel).then(function (res) {
	        return _promise2.default.resolve(res.data);
	      }).catch(function (err) {
	        return _promise2.default.reject(err);
	      });
	    }
	  }, {
	    key: "validateEmailCode",
	    value: function validateEmailCode(taxIdNumber, code) {
	      return _axios2.default.post("/v2/auth/validateEmailCode", {
	        taxIdNumber: taxIdNumber,
	        code: code,
	        _interface: "WEBSITE"
	      }).then(function (res) {
	        return _promise2.default.resolve(res.data);
	      }).catch(function (err) {
	        return _promise2.default.reject(err);
	      });
	    }
	  }, {
	    key: "updateNewUserEmail",
	    value: function updateNewUserEmail(taxIdNumber, email) {
	      return _axios2.default.post("/v2/updateNewUserEmail", {
	        taxIdNumber: taxIdNumber,
	        email: email
	      }).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "updateNewUserPhone",
	    value: function updateNewUserPhone(taxIdNumber, newCellPhone) {
	      return _axios2.default.post("/v2/updateNewUserPhone", {
	        taxIdNumber: taxIdNumber,
	        phone: newCellPhone
	      }).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "currentUserData",
	    value: function currentUserData(taxIdNumber) {
	      return _axios2.default.get("/v2/getUserAndAddressByTaxIdNumber/" + taxIdNumber).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "calculateHMAC",
	    value: function calculateHMAC(data, secret) {
	      try {
	        var crypto = __webpack_require__(131);
	        return crypto.createHmac("sha256", secret).update(data).digest("hex");
	      } catch (e) {
	        console.error("Error calculating HMAC:", e);
	        throw new Error("Falha ao calcular assinatura HMAC. Certifique-se de que a biblioteca crypto está disponível.");
	      }
	    }
	  }, {
	    key: "constantTimeEquals",
	    value: function constantTimeEquals(a, b) {
	      if (a.length !== b.length) {
	        return false;
	      }
	      var result = 0;
	      for (var i = 0; i < a.length; i++) {
	        result |= a.charCodeAt(i) ^ b.charCodeAt(i);
	      }
	      return result === 0;
	    }
	  }, {
	    key: "buildAuthHeaders",
	    value: function buildAuthHeaders() {
	      var authOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var requestPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	      var requestBody = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
	
	      var headers = {};
	
	      if (authOptions.bearerToken) {
	        headers["Authorization"] = "Bearer " + authOptions.bearerToken;
	        return headers;
	      }
	
	      if (authOptions.apiKey && authOptions.timestamp && authOptions.secret) {
	        var dataToSign = authOptions.apiKey + authOptions.timestamp + requestPath + requestBody;
	        var signature = this.calculateHMAC(dataToSign, authOptions.secret);
	
	        if (signature) {
	          headers["X-API-Key"] = authOptions.apiKey;
	          headers["X-Timestamp"] = authOptions.timestamp;
	          headers["X-Signature"] = signature;
	          return headers;
	        }
	      }
	
	      if (authOptions.apiKey) {
	        headers["X-API-Key"] = authOptions.apiKey;
	        return headers;
	      }
	
	      return headers;
	    }
	  }, {
	    key: "generateRandomHash",
	    value: function generateRandomHash() {
	      var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
	      var hash = "";
	      var timestamp = Date.now().toString(36);
	
	      for (var i = 0; i < 40; i++) {
	        if (i < timestamp.length) {
	          hash += timestamp[i];
	        } else {
	          hash += chars.charAt(Math.floor(Math.random() * chars.length));
	        }
	      }
	
	      hash += Math.random().toString(36).substring(2, 15);
	      hash += Math.random().toString(36).substring(2, 15);
	
	      return hash.substring(0, 40);
	    }
	  }, {
	    key: "decryptToken",
	    value: function decryptToken(encryptedToken) {
	      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      if (!key) {
	        key = "fbf920c9-7847-43c6-ae66-ae3ede546c5b";
	      }
	
	      try {
	        var decrypted = _encryptSjcl2.default.decrypt(key, encryptedToken);
	        return decrypted;
	      } catch (error) {
	        console.error("Erro ao descriptografar token:", error);
	
	        return encryptedToken;
	      }
	    }
	  }, {
	    key: "generateCpfJwt",
	    value: function generateCpfJwt(taxIdNumber) {
	      var _this7 = this;
	
	      var hashAleatorio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      if (!hashAleatorio) {
	        hashAleatorio = this.generateRandomHash();
	      }
	
	      var headers = {
	        "X-Frontend-Hash": hashAleatorio,
	        "Content-Type": "application/json"
	      };
	
	      return _axios2.default.post("/v2/generateCpfJwt", {
	        cpf: taxIdNumber,
	        hashAleatorio: hashAleatorio
	      }, { headers: headers }).then(function (res) {
	        if (res.data && res.data.status && res.data.status.code === 0) {
	          if (res.data.token) {
	            var decryptedToken = _this7.decryptToken(res.data.token);
	            return decryptedToken;
	          }
	          throw new Error("Token não encontrado na resposta");
	        }
	        var errorMessage = res.data && res.data.status && res.data.status.message ? res.data.status.message : "Erro ao gerar token";
	        throw new Error(errorMessage);
	      }).catch(function (error) {
	        console.error("Erro ao gerar JWT:", error);
	        throw error;
	      });
	    }
	  }, {
	    key: "getUserAndAddressByTaxIdNumberNoSession",
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(taxIdNumber) {
	        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        var requestPath, bearerToken, hashAleatorio, headers;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                requestPath = "/v2/getUserAndAddressByTaxIdNumberNoSession/" + taxIdNumber;
	                bearerToken = options.bearerToken;
	                hashAleatorio = options.hashAleatorio;
	
	                if (bearerToken) {
	                  _context.next = 15;
	                  break;
	                }
	
	                if (!hashAleatorio) {
	                  hashAleatorio = this.generateRandomHash();
	                }
	
	                _context.prev = 5;
	                _context.next = 8;
	                return this.generateCpfJwt(taxIdNumber, hashAleatorio);
	
	              case 8:
	                bearerToken = _context.sent;
	                _context.next = 15;
	                break;
	
	              case 11:
	                _context.prev = 11;
	                _context.t0 = _context["catch"](5);
	
	                console.error("Erro ao gerar JWT:", _context.t0);
	                throw new Error("Não foi possível gerar token JWT. Verifique se o endpoint /v2/generateCpfJwt está disponível.");
	
	              case 15:
	                if (!hashAleatorio) {
	                  hashAleatorio = this.generateRandomHash();
	                }
	
	                headers = {
	                  Authorization: "Bearer " + bearerToken,
	                  "X-Frontend-Hash": hashAleatorio,
	                  "Content-Type": "application/json"
	                };
	                return _context.abrupt("return", _axios2.default.get(requestPath, { headers: headers }).then(function (res) {
	                  return res.data;
	                }).catch(function (error) {
	                  if (error.response && error.response.status === 401) {
	                    console.error("Erro de autenticação. Verifique se o token JWT é válido.");
	                  }
	                  throw error;
	                }));
	
	              case 18:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[5, 11]]);
	      }));
	
	      function getUserAndAddressByTaxIdNumberNoSession(_x6) {
	        return _ref.apply(this, arguments);
	      }
	
	      return getUserAndAddressByTaxIdNumberNoSession;
	    }()
	  }, {
	    key: "saveNewEmail",
	    value: function saveNewEmail(newEmail) {
	      localStorage.setItem("newEmail", newEmail);
	    }
	  }, {
	    key: "getNewEmail",
	    value: function getNewEmail() {
	      return localStorage.getItem("newEmail");
	    }
	  }, {
	    key: "saveNewPhone",
	    value: function saveNewPhone(newPhone) {
	      localStorage.setItem("newPhone", newPhone);
	    }
	  }, {
	    key: "getNewPhone",
	    value: function getNewPhone() {
	      return localStorage.getItem("newPhone");
	    }
	  }, {
	    key: "saveLoginTFA",
	    value: function saveLoginTFA(redirect_2fa) {
	      localStorage.setItem("redirect_2fa", redirect_2fa);
	    }
	  }, {
	    key: "getLoginTFA",
	    value: function getLoginTFA() {
	      return localStorage.getItem("redirect_2fa");
	    }
	  }, {
	    key: "isGrouper",
	    value: function isGrouper(moveMaisId) {
	      var _this8 = this;
	
	      return _axios2.default.get("/v2/agrupadorVPO/getIsClienteVPO/" + moveMaisId).then(function (res) {
	        if (res.data && res.data.status && res.data.status.code === 0) {
	          var isGrouper = res.data.isGrouper || false;
	          _this8.saveIsGrouper(isGrouper);
	          return isGrouper;
	        }
	        return false;
	      }).catch(function (error) {
	        console.error("Erro ao verificar se é grouper:", error);
	        return false;
	      });
	    }
	  }, {
	    key: "saveIsGrouper",
	    value: function saveIsGrouper(grouper) {
	      localStorage.setItem("grouper", grouper);
	    }
	  }, {
	    key: "getNotificationStatus",
	    value: function getNotificationStatus() {
	      return _axios2.default.get("/v2/getNotficationStatus/Site").then(function (res) {
	        return _promise2.default.resolve(res.data);
	      }).catch(function (err) {
	        return _promise2.default.reject(err);
	      });
	    }
	  }, {
	    key: "currentUser",
	    get: function get() {
	      return this._currentUser;
	    },
	    set: function set(user) {
	      if (user) {
	        localStorage.setItem("currentUser", (0, _stringify2.default)(user));
	      } else {
	        localStorage.removeItem("currentUser");
	      }
	
	      this._currentUser = user;
	      this.$emit("userChanged", user);
	    }
	  }, {
	    key: "parentUser",
	    get: function get() {
	      return this._parentUser;
	    },
	    set: function set(user) {
	      if (user) {
	        localStorage.setItem("parentUser", (0, _stringify2.default)(user));
	      } else {
	        localStorage.removeItem("parentUser");
	      }
	
	      this._parentUser = user;
	      this.$emit("parentUserChanged", user);
	    }
	  }]);
	  return AuthService;
	}(_vue2.default);
	
	var instance = new AuthService();
	exports.default = instance;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(49);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(28);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CHECKOUT_BASE_URL = "https://aegis.movemais.com/finalizar-pedido";
	
	
	var PAYMENT_METHODS_BASE_URL = "https://aegis.movemais.com/formas-pagamento";
	
	
	function _redirectToCheckout(salesToken) {
	  if (!salesToken) {
	    return false;
	  }
	  try {
	    var isLogged = !!localStorage.getItem("currentUser");
	    var backUrl = isLogged ? "/conta/meus-planos" : "/adesao";
	    window.history.replaceState(null, "", backUrl);
	  } catch (e) {}
	  window.location.href = CHECKOUT_BASE_URL + "/" + encodeURIComponent(salesToken);
	  return true;
	}
	
	function processOrderCreated(data) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var payload = data && data.order ? data.order : data;
	  if (options.skipCheckout && payload && payload.status === 0) {
	    return _promise2.default.resolve(payload);
	  }
	  if (payload && payload.status === 0 && payload.salesToken) {
	    _redirectToCheckout(payload.salesToken);
	    return new _promise2.default(function () {});
	  }
	  var code = payload && typeof payload.status === "number" ? payload.status : -1;
	  var message = payload && payload.message || "Não foi possível concluir o pedido";
	  return _promise2.default.reject({ data: { status: { code: code, message: message }, message: message } });
	}
	
	function processOrderError(err) {
	  if (err && err.data && err.data.status && (0, _typeof3.default)(err.data.status) === "object") {
	    return _promise2.default.reject(err);
	  }
	  var response = err && err.response || err || {};
	  var raw = response && response.data || {};
	  if (typeof raw.status === "number") {
	    return _promise2.default.reject({
	      data: {
	        status: {
	          code: raw.status,
	          message: raw.message || "Erro ao criar pedido"
	        },
	        message: raw.message || "Erro ao criar pedido"
	      }
	    });
	  }
	  if (raw && raw.status && (0, _typeof3.default)(raw.status) === "object") {
	    return _promise2.default.reject({ data: raw });
	  }
	  return _promise2.default.reject(err);
	}
	
	var SalesService = function () {
	  function SalesService() {
	    (0, _classCallCheck3.default)(this, SalesService);
	  }
	
	  (0, _createClass3.default)(SalesService, [{
	    key: "calculateRechargeRate",
	    value: function calculateRechargeRate(request) {
	      return _axios2.default.post("/v2/calculateRechargeRate", request).then(function (resp) {
	        return resp.data.response;
	      });
	    }
	  }, {
	    key: "getBannersParceiro",
	    value: function getBannersParceiro() {
	      return _axios2.default.get("/v2/banners/ativo").then(function (resp) {
	        return resp.data;
	      });
	    }
	  }, {
	    key: "getBannerAccess",
	    value: function getBannerAccess(data) {
	      return _axios2.default.post("/v2/parceiros/acesso", data).then(function (resp) {
	        return resp.data;
	      });
	    }
	  }, {
	    key: "getBannersSite",
	    value: function getBannersSite(isMobile) {
	      return _axios2.default.get("/v2/getBannersSite/" + isMobile).then(function (resp) {
	        return resp.data;
	      });
	    }
	  }, {
	    key: "getBannersSiteMob",
	    value: function getBannersSiteMob(isMobile) {
	      return _axios2.default.get("/v2/getBannersSiteMob/" + isMobile).then(function (resp) {
	        return resp.data;
	      });
	    }
	  }, {
	    key: "listSalesOrders",
	    value: function listSalesOrders(filter) {
	      return _axios2.default.post("/v2/listSalesOrders", filter).then(function (res) {
	        if (res.data.status.code == 0) {
	          res.data.itens.forEach(function (o) {
	            if (o.salesType == "REPLACETAG") {
	              o.salesDescription = "SUBSTITUIÇÃO DE TAG";
	            } else if (o.salesType == "ADHESION") {
	              o.salesDescription = "ADESÃO";
	            } else if (o.salesType == "RECHARGE") {
	              o.salesDescription = "RECARGA";
	            } else if (o.salesType == "TRANSFER") {
	              o.salesDescription = "TRANSFERÊNCIA";
	            } else if (o.salesType == "TAGPURCHASEREQUEST") {
	              o.salesDescription = "SOLICITAÇÃO DE TAG";
	            } else if (o.salesType == "ADHESIONVEHICLEADDITIONAL") {
	              o.salesDescription = "ADESÃO VEÍCULO ADICIONAL";
	            } else if (o.salesType == "ADHESIOACONTRACTADDITIONAL") {
	              o.salesDescription = "ADESÃO DE NOVO CONTRATO";
	            } else if (o.salesType == "PAYMENTPERUSE") {
	              o.salesDescription = "PASSAGEM";
	            } else if (o.salesType == "CANCELAMENTO_CONTRATO") {
	              o.salesDescription = "CANCELAMENTO DE CONTRATO";
	            } else if (o.salesType == "TAXA_CANCELAMENTO") {
	              o.salesDescription = "TAXA DE CANCELAMENTO";
	            } else if (o.salesType == "MIGRATIONPLAN") {
	              o.salesDescription = "MIGRAÇÃO DE PLANO";
	            }
	          });
	          return res.data;
	        } else {
	          return res.data.status;
	        }
	      });
	    }
	  }, {
	    key: "getSalesOrderId",
	    value: function getSalesOrderId(orderId) {
	      return _axios2.default.get("/v2/getSalesOrder/" + orderId).then(function (res) {
	        if (res.data.status.code == 0 && res.data.order) {
	          res.data.order.products.forEach(function (o) {
	            if (o.product) {
	              o.productName = o.product.description;
	              o.productId = o.product.productId;
	            }
	          });
	          return res.data;
	        } else {
	          return res.data.status;
	        }
	      });
	    }
	  }, {
	    key: "updateSenffOrder",
	    value: function updateSenffOrder(orderId) {
	      return _axios2.default.get("/v2/updateSenffOrder/" + orderId).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "getDateTimeTransaction",
	    value: function getDateTimeTransaction() {
	      return _axios2.default.get("/v2/getDateTimeTransaction").then(function (res) {
	        return res.data.now;
	      });
	    }
	  }, {
	    key: "gravaLogRedirecionamentoBanner",
	    value: function gravaLogRedirecionamentoBanner(moveMaisId, idBanner, idParceiro) {
	      return _axios2.default.get("/v2/gravaLogRedirecionamentoBanner/" + moveMaisId + "/" + idBanner + "/" + idParceiro).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "createLead",
	    value: function createLead(lead) {
	      return _axios2.default.post("/v2/createLead", lead);
	    }
	  }, {
	    key: "updateLead",
	    value: function updateLead(lead) {
	      return _axios2.default.post("/v2/updateLead", lead).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: "createANewProposal",
	    value: function createANewProposal(lead) {
	      return _axios2.default.post("/v1/createANewProposal", lead).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: "recharge",
	    value: function recharge(request) {
	      return _axios2.default.post("/v2/recharge", request).then(function (res) {
	        return processOrderCreated(res.data);
	      }).catch(function (err) {
	        return processOrderError(err);
	      });
	    }
	  }, {
	    key: "redirectToCheckout",
	    value: function redirectToCheckout(salesToken) {
	      return _redirectToCheckout(salesToken);
	    }
	  }, {
	    key: "redirectToContractPayment",
	    value: function redirectToContractPayment(contractId) {
	      return _axios2.default.post("/v2/contract-token/" + contractId).then(function (res) {
	        var token = res.data && (typeof res.data === "string" ? res.data : res.data.token);
	        console.log(token, "token");
	        if (!token) return _promise2.default.reject(new Error("Token não recebido"));
	        window.open(PAYMENT_METHODS_BASE_URL + "/" + encodeURIComponent(token), "_blank");
	      });
	    }
	  }, {
	    key: "handleOrderCreated",
	    value: function handleOrderCreated(data) {
	      return processOrderCreated(data);
	    }
	  }, {
	    key: "getPlan",
	    value: function getPlan() {
	      return _axios2.default.get("/v2/getPlan").then(function (res) {
	        var plans = res.data.plans.plan;
	        return {
	          plans: plans,
	          confirmCellphone: res.data.confirmCellphone,
	          confirmEmail: res.data.confirmEmail
	        };
	      });
	    }
	  }, {
	    key: "getPlanPj",
	    value: function getPlanPj() {
	      return _axios2.default.get("/v2/getPlanPj").then(function (res) {
	        var plans = res.data.plans.plan;
	        return (0, _extends3.default)({}, plans, {
	          confirmCellphone: res.data.confirmCellphone,
	          confirmEmail: res.data.confirmEmail
	        });
	      });
	    }
	  }, {
	    key: "getPlanById",
	    value: function getPlanById(planId) {
	      return this.getPlan().then(function (r) {
	        console.log(r, "r filter");
	
	        return _.filter(r.plans, function (o) {
	          return o.planId == planId;
	        })[0];
	      });
	    }
	  }, {
	    key: "adhesion",
	    value: function adhesion(request) {
	      return _axios2.default.post("/v2/adhesion", request).then(function (res) {
	        return processOrderCreated(res.data);
	      }).catch(function (err) {
	        return processOrderError(err);
	      });
	    }
	  }, {
	    key: "adhesionAggregate",
	    value: function adhesionAggregate(request) {
	      return _axios2.default.post("/v2/adhesionAggregate", request).then(function (res) {
	        return processOrderCreated(res.data);
	      }).catch(function (err) {
	        return processOrderError(err);
	      });
	    }
	  }, {
	    key: "adhesionVehicleAddition",
	    value: function adhesionVehicleAddition(request) {
	      return _axios2.default.post("/v2/adhesionVehicleAddition", request).then(function (res) {
	        return processOrderCreated(res.data);
	      }).catch(function (err) {
	        return processOrderError(err);
	      });
	    }
	  }, {
	    key: "requestTagReplacement",
	    value: function requestTagReplacement(request) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return _axios2.default.post("/v2/requestTagReplacement", request).then(function (res) {
	        return processOrderCreated(res.data, options);
	      }).catch(function (err) {
	        return processOrderError(err);
	      });
	    }
	  }, {
	    key: "getLead",
	    value: function getLead(request) {
	      return _axios2.default.post("/v2/getLead", request).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "calculateDiscount",
	    value: function calculateDiscount(request) {
	      return _axios2.default.post("/v2/calculateDiscount", request).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "adhesionContractAdditional",
	    value: function adhesionContractAdditional(request) {
	      return _axios2.default.post("/v2/adhesionContractAdditional", request).then(function (res) {
	        return processOrderCreated(res.data);
	      }).catch(function (err) {
	        return processOrderError(err);
	      });
	    }
	  }, {
	    key: "migrationPlan",
	    value: function migrationPlan(request) {
	      return _axios2.default.post("/v2/migrationPlan", request).then(function (res) {
	        return processOrderCreated(res.data);
	      }).catch(function (err) {
	        return processOrderError(err);
	      });
	    }
	  }, {
	    key: "hasPromotion",
	    value: function hasPromotion(filter) {
	      return _axios2.default.get("/v1/hasPromotion" + (filter.promotionCode ? "?promotionCode=" + filter.promotionCode : "")).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "findPlate",
	    value: function findPlate(plate) {
	      return _axios2.default.get("/v1/getVehicleData/" + plate).then(function (res) {
	        return res.data.vehicle;
	      });
	    }
	  }, {
	    key: "findPlateV2",
	    value: function findPlateV2(plate) {
	      return _axios2.default.get("/v2/getVehicleDataSiteVP/" + (plate || "NOTPLATE")).then(function (res) {
	        return res.data.vehicle;
	      });
	    }
	  }, {
	    key: "getProcessingOrders",
	    value: function getProcessingOrders(contract, type) {
	      return _axios2.default.get("/v1/getProcessingOrders/" + contract + "/" + type).then(function (res) {
	        return res.data.orders;
	      });
	    }
	  }, {
	    key: "getProcessingOrders",
	    value: function getProcessingOrders(contract, type) {
	      return _axios2.default.get("/v2/getProcessingOrders/" + contract + "/" + type).then(function (res) {
	        return res.data.orders;
	      });
	    }
	  }, {
	    key: "transferCredit",
	    value: function transferCredit(request) {
	      return _axios2.default.post("/v2/transferCredit", request).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "transferCreditAggregate",
	    value: function transferCreditAggregate(request) {
	      return _axios2.default.post("/v2/transferCreditAggregate", request).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "getTransferData",
	    value: function getTransferData(transferId) {
	      return _axios2.default.get("/v2/getTransferData/" + transferId).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "captchaAdhesion",
	    value: function captchaAdhesion(request) {
	      return _axios2.default.get("/zeus/captcha", request).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "captchaAdhesionPost",
	    value: function captchaAdhesionPost(request) {
	      return _axios2.default.post("/zeus/captcha", request).then(function (res) {
	        return res;
	      }).catch(function (err) {
	        return false;
	      });
	    }
	  }, {
	    key: "findByUf",
	    value: function findByUf(uf) {
	      return _axios2.default.post("/v2/findByUf", uf).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "checkChargeValue",
	    value: function checkChargeValue(req) {
	      return _axios2.default.post("/v2/checkChargeValue", req).then(function (res) {
	        return res.data.status;
	      });
	    }
	  }, {
	    key: "firstValueRecharge",
	    value: function firstValueRecharge(req) {
	      return _axios2.default.post("/v2/firstValueRecharge", req).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "validarFraudeContrato",
	    value: function validarFraudeContrato(contractId, salesOrderId, contractPaymentMethodId) {
	      return _axios2.default.post("/v2/validarFraudeContrato/" + contractId + "/" + salesOrderId + "/" + contractPaymentMethodId).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "validateCoupon",
	    value: function validateCoupon(coupon) {
	      return _axios2.default.get("/v2/validateCoupon/" + coupon).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "consultarRNTRC",
	    value: function consultarRNTRC(transportador, placas) {
	      return _axios2.default.post("/v2/rntrc/consultar", { transportador: transportador, placas: placas }).then(function (res) {
	        return res.data;
	      });
	    }
	  }]);
	  return SalesService;
	}();
	
	var instance = new SalesService();
	
	exports.default = instance;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.21';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function',
	      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading whitespace. */
	  var reTrimStart = /^\s+/;
	
	  /** Used to match a single whitespace character. */
	  var reWhitespace = /\s/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */
	  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */
	  function baseTrim(string) {
	    return string
	      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	      : string;
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedEndIndex(string) {
	    var index = string.length;
	
	    while (index-- && reWhitespace.test(string.charAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }
	
	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }
	
	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Throw an error if a forbidden character was found in `variable`, to prevent
	      // potential command injection attacks.
	      else if (reForbiddenIdentifierChars.test(variable)) {
	        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
	      }
	
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return baseTrim(string);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.slice(0, trimmedEndIndex(string) + 1);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(534)(module)))

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1515)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(53),
	  /* template */
	  __webpack_require__(2047),
	  /* scopeId */
	  "data-v-0f115cce",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(805), __esModule: true };

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  PLAN_RNTRC_PF: 2,
	  PLAN_RNTRC_PJ: 3,
	  PLAN_AUT: 22,
	  PLAN_MAN: 21,
	  PLAN_MAN_ECONOMICO: 51,
	  PLAN_AUT_ECONOMICO: 52,
	  PLAN_POS: 28,
	  PLAN_PRE_SEM_TAXA: 30,
	  PLAN_MAN_PJ: 31,
	  PLAN_AUT_PJ: 32,
	  PLAN_ROADCARD_PF: 70,
	  PLAN_ROADCARD_PJ: 71,
	  PLAN_MOVE_PAGUE: 33,
	  PLAN_PREMEN_PF: 4,
	  PLAN_PREMEN_PJ: 5,
	  PLAN_PRE_MAN_CAM_PARANA_PF: 35,
	  PLAN_PRE_AUT_CAM_PARANA_PF: 36,
	  PLAN_PRE_MAN_CAM_PARANA_PJ: 37,
	  PLAN_PRE_AUT_CAM_PARANA_PJ: 38,
	  PLAN_PRE_AUT_MEN_SODRE_PF: 45,
	  PLAN_PRE_AUT_MEN_SODRE_PJ: 55,
	  PLAN_PRE_AUT_RODOSOL_PF: 62,
	  PLAN_PRE_AUT_RODOSOL_PJ: 64,
	  PLAN_EMBARCADOR_PJ: 6,
	  RECHARGE_UNIT: 5000,
	  RECHARGE_UNIT_ROADCARD_PF: 10000,
	  RECHARGE_UNIT_ROADCARD_PJ: 25000,
	  NEW_ADHESION_TAXID: 10,
	  NEW_VEHICLE_TAXID: 67,
	  GUARANTEE_TAXID: 12,
	  LINK_RNTRC: 14,
	  MONTHLY_TAX: 15,
	  REPLACE_TAXID: 11,
	  MSG_01_REPLACE_IN_HAND_SUCCESS: "Substituição e ativação realizadas com sucesso!",
	  MSG_02_TAG_NOT_FOUND: "TAG não encontrada. Verifique o número e tente novamente.",
	
	  RECHARGE_UNIT_PJ: 50000,
	  RECHARGE_UNIT_ECONOMICO: 2500,
	  LIMIT_VEHICLES: -1,
	  CAMINHOS_PARANA_CADASTRADO: 'CADASTRADO',
	  ADHESION: 1,
	  SALES_TYPE: {
	    ADHESION: 1,
	    RECHARGE: 2,
	    ADHESIONVEHICLEADDITIONAL: 4,
	    REPLACETAG: 6,
	    GUARANTEE: 8
	  },
	
	  isPJ: function isPJ(planId) {
	    var self = this;
	    switch (parseInt(planId)) {
	      case self.PLAN_PRE_MAN_CAM_PARANA_PF:
	      case self.PLAN_PRE_AUT_CAM_PARANA_PF:
	      case self.PLAN_MAN:
	      case self.PLAN_AUT:
	      case self.PLAN_PRE_SEM_TAXA:
	      case self.PLAN_MOVE_PAGUE:
	      case self.PLAN_ROTA_LIVRE:
	      case self.PLAN_RNTRC_PF:
	      case self.PLAN_PREMEN_PF:
	      case self.PLAN_PRE_AUT_RODOSOL_PF:
	        return false;
	        break;
	      case self.PLAN_PRE_MAN_CAM_PARANA_PJ:
	      case self.PLAN_PRE_AUT_CAM_PARANA_PJ:
	      case self.PLAN_MAN_PJ:
	      case self.PLAN_AUT_PJ:
	      case self.PLAN_POS:
	      case self.PLAN_RNTRC_PJ:
	      case self.PLAN_PREMEN_PJ:
	      case self.PLAN_EMBARCADOR_PJ:
	      case self.PLAN_PRE_AUT_RODOSOL_PJ:
	        return true;
	        break;
	
	    }
	  },
	
	  Axes: [{
	    value: 1,
	    caption: "2 eixos, rodagem simples",
	    category_artesp_id: 1,
	    aut: true
	  }, {
	    value: 2,
	    caption: "2 eixos, rodagem dupla",
	    category_artesp_id: 2,
	    bus: true,
	    truck: true
	  }, {
	    value: 3,
	    caption: "3 eixos, rodagem dupla",
	    category_artesp_id: 3,
	    bus: true,
	    truck: true
	  }, {
	    value: 4,
	    caption: "4 eixos, rodagem dupla",
	    category_artesp_id: 4,
	    bus: true,
	    truck: true
	  }, {
	    value: 5,
	    caption: "5 eixos, rodagem dupla",
	    category_artesp_id: 5,
	    truck: true
	  }, {
	    value: 6,
	    caption: "6 eixos, rodagem dupla",
	    category_artesp_id: 6,
	    truck: true
	  }, {
	    value: 7,
	    caption: "3 eixos, rodagem simples",
	    category_artesp_id: 7,
	    aut: true
	  }, {
	    value: 8,
	    caption: "4 eixos, rodagem simples",
	    category_artesp_id: 8,
	    aut: true
	  }, {
	    value: 9,
	    caption: "7 eixos, rodagem dupla",
	    category_artesp_id: 61,
	    truck: true
	  }, {
	    value: 10,
	    caption: "8 eixos, rodagem dupla",
	    category_artesp_id: 62,
	    truck: true
	  }, {
	    value: 11,
	    caption: "9 eixos, rodagem dupla",
	    category_artesp_id: 63,
	    truck: true
	  }, {
	    value: 12,
	    caption: "10 eixos, rodagem dupla",
	    category_artesp_id: 64,
	    truck: true
	  }, {
	    value: 13,
	    caption: "11 eixos, rodagem dupla",
	    category_artesp_id: 65,
	    truck: true
	  }, {
	    value: 14,
	    caption: "12 eixos, rodagem dupla",
	    category_artesp_id: 66,
	    truck: true
	  }, {
	    value: 15,
	    caption: "13 eixos, rodagem dupla",
	    category_artesp_id: 67,
	    truck: true
	  }, {
	    value: 16,
	    caption: "14 eixos, rodagem dupla",
	    category_artesp_id: 68,
	    truck: true
	  }, {
	    value: 17,
	    caption: "15 eixos, rodagem dupla",
	    category_artesp_id: 69
	  }, {
	    value: 18,
	    caption: "16 eixos, rodagem dupla",
	    category_artesp_id: 16,
	    truck: true
	  }, {
	    value: 19,
	    caption: "17 eixos, rodagem dupla",
	    category_artesp_id: 17,
	    truck: true
	  }, {
	    value: 20,
	    caption: "18 eixos, rodagem dupla",
	    category_artesp_id: 18,
	    truck: true
	  }, {
	    value: 21,
	    caption: "19 eixos, rodagem dupla",
	    category_artesp_id: 19,
	    truck: true
	  }, {
	    value: 22,
	    caption: "20 eixos, rodagem dupla",
	    category_artesp_id: 20,
	    truck: true
	  }, {
	    value: 23,
	    caption: "21 eixos, rodagem dupla",
	    category_artesp_id: 21,
	    truck: true
	  }, {
	    value: 24,
	    caption: "22 eixos, rodagem dupla",
	    category_artesp_id: 22,
	    truck: true
	  }, {
	    value: 25,
	    caption: "23 eixos, rodagem dupla",
	    category_artesp_id: 23,
	    truck: true
	  }, {
	    value: 26,
	    caption: "24 eixos, rodagem dupla",
	    category_artesp_id: 24,
	    truck: true
	  }, {
	    value: 27,
	    caption: "25 eixos, rodagem dupla",
	    category_artesp_id: 25,
	    truck: true
	  }, {
	    value: 28,
	    caption: "26 eixos, rodagem dupla",
	    category_artesp_id: 26,
	    truck: true
	  }, {
	    value: 29,
	    caption: "27 eixos, rodagem dupla",
	    category_artesp_id: 27,
	    truck: true
	  }, {
	    value: 30,
	    caption: "28 eixos, rodagem dupla",
	    category_artesp_id: 28,
	    truck: true
	  }, {
	    value: 31,
	    caption: "29 eixos, rodagem dupla",
	    category_artesp_id: 29,
	    truck: true
	  }, {
	    value: 32,
	    caption: "30 eixos, rodagem dupla",
	    category_artesp_id: 30,
	    truck: true
	  }, {
	    value: 33,
	    caption: "31 eixos, rodagem dupla",
	    category_artesp_id: 31,
	    truck: true
	  }, {
	    value: 34,
	    caption: "32 eixos, rodagem dupla",
	    category_artesp_id: 32,
	    truck: true
	  }, {
	    value: 35,
	    caption: "33 eixos, rodagem dupla",
	    category_artesp_id: 33,
	    truck: true
	  }, {
	    value: 36,
	    caption: "34 eixos, rodagem dupla",
	    category_artesp_id: 34,
	    truck: true
	  }, {
	    value: 37,
	    caption: "35 eixos, rodagem dupla",
	    category_artesp_id: 35,
	    truck: true
	  }, {
	    value: 38,
	    caption: "36 eixos, rodagem dupla",
	    category_artesp_id: 36,
	    truck: true
	  }, {
	    value: 39,
	    caption: "37 eixos, rodagem dupla",
	    category_artesp_id: 37,
	    truck: true
	  }, {
	    value: 40,
	    caption: "38 eixos, rodagem dupla",
	    category_artesp_id: 38,
	    truck: true
	  }, {
	    value: 41,
	    caption: "39 eixos, rodagem dupla",
	    category_artesp_id: 39,
	    truck: true
	  }, {
	    value: 42,
	    caption: "40 eixos, rodagem dupla",
	    category_artesp_id: 40,
	    truck: true
	  }, {
	    value: 43,
	    caption: "41 eixos, rodagem dupla",
	    category_artesp_id: 41,
	    truck: true
	  }, {
	    value: 44,
	    caption: "42 eixos, rodagem dupla",
	    category_artesp_id: 42,
	    truck: true
	  }, {
	    value: 45,
	    caption: "43 eixos, rodagem dupla",
	    category_artesp_id: 43,
	    truck: true
	  }, {
	    value: 46,
	    caption: "44 eixos, rodagem dupla",
	    category_artesp_id: 44,
	    truck: true
	  }, {
	    value: 47,
	    caption: "45 eixos, rodagem dupla",
	    category_artesp_id: 45,
	    truck: true
	  }, {
	    value: 48,
	    caption: "46 eixos, rodagem dupla",
	    category_artesp_id: 46,
	    truck: true
	  }, {
	    value: 49,
	    caption: "47 eixos, rodagem dupla",
	    category_artesp_id: 47,
	    truck: true
	  }, {
	    value: 50,
	    caption: "48 eixos, rodagem dupla",
	    category_artesp_id: 48,
	    truck: true
	  }]
	
	};

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	/**
	 * Wraps a GeoJSON {@link Geometry} in a GeoJSON {@link Feature}.
	 *
	 * @name feature
	 * @param {Geometry} geometry input geometry
	 * @param {Object} properties properties
	 * @returns {FeatureCollection} a FeatureCollection of input features
	 * @example
	 * var geometry = {
	 *      "type": "Point",
	 *      "coordinates": [
	 *        67.5,
	 *        32.84267363195431
	 *      ]
	 *    }
	 *
	 * var feature = turf.feature(geometry);
	 *
	 * //=feature
	 */
	function feature(geometry, properties) {
	    return {
	        type: 'Feature',
	        properties: properties || {},
	        geometry: geometry
	    };
	}
	
	module.exports.feature = feature;
	
	/**
	 * Takes coordinates and properties (optional) and returns a new {@link Point} feature.
	 *
	 * @name point
	 * @param {number[]} coordinates longitude, latitude position (each in decimal degrees)
	 * @param {Object=} properties an Object that is used as the {@link Feature}'s
	 * properties
	 * @returns {Feature<Point>} a Point feature
	 * @example
	 * var pt1 = turf.point([-75.343, 39.984]);
	 *
	 * //=pt1
	 */
	module.exports.point = function (coordinates, properties) {
	    if (!Array.isArray(coordinates)) throw new Error('Coordinates must be an array');
	    if (coordinates.length < 2) throw new Error('Coordinates must be at least 2 numbers long');
	    return feature({
	        type: 'Point',
	        coordinates: coordinates.slice()
	    }, properties);
	};
	
	/**
	 * Takes an array of LinearRings and optionally an {@link Object} with properties and returns a {@link Polygon} feature.
	 *
	 * @name polygon
	 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
	 * @param {Object=} properties a properties object
	 * @returns {Feature<Polygon>} a Polygon feature
	 * @throws {Error} throw an error if a LinearRing of the polygon has too few positions
	 * or if a LinearRing of the Polygon does not have matching Positions at the
	 * beginning & end.
	 * @example
	 * var polygon = turf.polygon([[
	 *  [-2.275543, 53.464547],
	 *  [-2.275543, 53.489271],
	 *  [-2.215118, 53.489271],
	 *  [-2.215118, 53.464547],
	 *  [-2.275543, 53.464547]
	 * ]], { name: 'poly1', population: 400});
	 *
	 * //=polygon
	 */
	module.exports.polygon = function (coordinates, properties) {
	
	    if (!coordinates) throw new Error('No coordinates passed');
	
	    for (var i = 0; i < coordinates.length; i++) {
	        var ring = coordinates[i];
	        if (ring.length < 4) {
	            throw new Error('Each LinearRing of a Polygon must have 4 or more Positions.');
	        }
	        for (var j = 0; j < ring[ring.length - 1].length; j++) {
	            if (ring[ring.length - 1][j] !== ring[0][j]) {
	                throw new Error('First and last Position are not equivalent.');
	            }
	        }
	    }
	
	    return feature({
	        type: 'Polygon',
	        coordinates: coordinates
	    }, properties);
	};
	
	/**
	 * Creates a {@link LineString} based on a
	 * coordinate array. Properties can be added optionally.
	 *
	 * @name lineString
	 * @param {Array<Array<number>>} coordinates an array of Positions
	 * @param {Object=} properties an Object of key-value pairs to add as properties
	 * @returns {Feature<LineString>} a LineString feature
	 * @throws {Error} if no coordinates are passed
	 * @example
	 * var linestring1 = turf.lineString([
	 *	[-21.964416, 64.148203],
	 *	[-21.956176, 64.141316],
	 *	[-21.93901, 64.135924],
	 *	[-21.927337, 64.136673]
	 * ]);
	 * var linestring2 = turf.lineString([
	 *	[-21.929054, 64.127985],
	 *	[-21.912918, 64.134726],
	 *	[-21.916007, 64.141016],
	 * 	[-21.930084, 64.14446]
	 * ], {name: 'line 1', distance: 145});
	 *
	 * //=linestring1
	 *
	 * //=linestring2
	 */
	module.exports.lineString = function (coordinates, properties) {
	    if (!coordinates) {
	        throw new Error('No coordinates passed');
	    }
	    return feature({
	        type: 'LineString',
	        coordinates: coordinates
	    }, properties);
	};
	
	/**
	 * Takes one or more {@link Feature|Features} and creates a {@link FeatureCollection}.
	 *
	 * @name featureCollection
	 * @param {Feature[]} features input features
	 * @returns {FeatureCollection} a FeatureCollection of input features
	 * @example
	 * var features = [
	 *  turf.point([-75.343, 39.984], {name: 'Location A'}),
	 *  turf.point([-75.833, 39.284], {name: 'Location B'}),
	 *  turf.point([-75.534, 39.123], {name: 'Location C'})
	 * ];
	 *
	 * var fc = turf.featureCollection(features);
	 *
	 * //=fc
	 */
	module.exports.featureCollection = function (features) {
	    return {
	        type: 'FeatureCollection',
	        features: features
	    };
	};
	
	/**
	 * Creates a {@link Feature<MultiLineString>} based on a
	 * coordinate array. Properties can be added optionally.
	 *
	 * @name multiLineString
	 * @param {Array<Array<Array<number>>>} coordinates an array of LineStrings
	 * @param {Object=} properties an Object of key-value pairs to add as properties
	 * @returns {Feature<MultiLineString>} a MultiLineString feature
	 * @throws {Error} if no coordinates are passed
	 * @example
	 * var multiLine = turf.multiLineString([[[0,0],[10,10]]]);
	 *
	 * //=multiLine
	 *
	 */
	module.exports.multiLineString = function (coordinates, properties) {
	    if (!coordinates) {
	        throw new Error('No coordinates passed');
	    }
	    return feature({
	        type: 'MultiLineString',
	        coordinates: coordinates
	    }, properties);
	};
	
	/**
	 * Creates a {@link Feature<MultiPoint>} based on a
	 * coordinate array. Properties can be added optionally.
	 *
	 * @name multiPoint
	 * @param {Array<Array<number>>} coordinates an array of Positions
	 * @param {Object=} properties an Object of key-value pairs to add as properties
	 * @returns {Feature<MultiPoint>} a MultiPoint feature
	 * @throws {Error} if no coordinates are passed
	 * @example
	 * var multiPt = turf.multiPoint([[0,0],[10,10]]);
	 *
	 * //=multiPt
	 *
	 */
	module.exports.multiPoint = function (coordinates, properties) {
	    if (!coordinates) {
	        throw new Error('No coordinates passed');
	    }
	    return feature({
	        type: 'MultiPoint',
	        coordinates: coordinates
	    }, properties);
	};
	
	
	/**
	 * Creates a {@link Feature<MultiPolygon>} based on a
	 * coordinate array. Properties can be added optionally.
	 *
	 * @name multiPolygon
	 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygons
	 * @param {Object=} properties an Object of key-value pairs to add as properties
	 * @returns {Feature<MultiPolygon>} a multipolygon feature
	 * @throws {Error} if no coordinates are passed
	 * @example
	 * var multiPoly = turf.multiPolygon([[[[0,0],[0,10],[10,10],[10,0],[0,0]]]);
	 *
	 * //=multiPoly
	 *
	 */
	module.exports.multiPolygon = function (coordinates, properties) {
	    if (!coordinates) {
	        throw new Error('No coordinates passed');
	    }
	    return feature({
	        type: 'MultiPolygon',
	        coordinates: coordinates
	    }, properties);
	};
	
	/**
	 * Creates a {@link Feature<GeometryCollection>} based on a
	 * coordinate array. Properties can be added optionally.
	 *
	 * @name geometryCollection
	 * @param {Array<{Geometry}>} geometries an array of GeoJSON Geometries
	 * @param {Object=} properties an Object of key-value pairs to add as properties
	 * @returns {Feature<GeometryCollection>} a geometrycollection feature
	 * @example
	 * var pt = {
	 *     "type": "Point",
	 *       "coordinates": [100, 0]
	 *     };
	 * var line = {
	 *     "type": "LineString",
	 *     "coordinates": [ [101, 0], [102, 1] ]
	 *   };
	 * var collection = turf.geometrycollection([[0,0],[10,10]]);
	 *
	 * //=collection
	 */
	module.exports.geometryCollection = function (geometries, properties) {
	    return feature({
	        type: 'GeometryCollection',
	        geometries: geometries
	    }, properties);
	};
	
	var factors = {
	    miles: 3960,
	    nauticalmiles: 3441.145,
	    degrees: 57.2957795,
	    radians: 1,
	    inches: 250905600,
	    yards: 6969600,
	    meters: 6373000,
	    metres: 6373000,
	    kilometers: 6373,
	    kilometres: 6373
	};
	
	/*
	 * Convert a distance measurement from radians to a more friendly unit.
	 *
	 * @name radiansToDistance
	 * @param {number} distance in radians across the sphere
	 * @param {string=kilometers} units: one of miles, nauticalmiles, degrees, radians,
	 * inches, yards, metres, meters, kilometres, kilometers.
	 * @returns {number} distance
	 */
	module.exports.radiansToDistance = function (radians, units) {
	    var factor = factors[units || 'kilometers'];
	    if (factor === undefined) {
	        throw new Error('Invalid unit');
	    }
	    return radians * factor;
	};
	
	/*
	 * Convert a distance measurement from a real-world unit into radians
	 *
	 * @name distanceToRadians
	 * @param {number} distance in real units
	 * @param {string=kilometers} units: one of miles, nauticalmiles, degrees, radians,
	 * inches, yards, metres, meters, kilometres, kilometers.
	 * @returns {number} radians
	 */
	module.exports.distanceToRadians = function (distance, units) {
	    var factor = factors[units || 'kilometers'];
	    if (factor === undefined) {
	        throw new Error('Invalid unit');
	    }
	    return distance / factor;
	};
	
	/*
	 * Convert a distance measurement from a real-world unit into degrees
	 *
	 * @name distanceToRadians
	 * @param {number} distance in real units
	 * @param {string=kilometers} units: one of miles, nauticalmiles, degrees, radians,
	 * inches, yards, metres, meters, kilometres, kilometers.
	 * @returns {number} degrees
	 */
	module.exports.distanceToDegrees = function (distance, units) {
	    var factor = factors[units || 'kilometers'];
	    if (factor === undefined) {
	        throw new Error('Invalid unit');
	    }
	    return (distance / factor) * 57.2958;
	};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(539);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new _promise2.default(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return _promise2.default.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1712);


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(28);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccountService = function () {
	  function AccountService() {
	    (0, _classCallCheck3.default)(this, AccountService);
	  }
	
	  (0, _createClass3.default)(AccountService, [{
	    key: 'getAddressMailing',
	    value: function getAddressMailing(moveMaisId) {
	      return _axios2.default.get('/v2/getAddressByMoveMaisId/' + moveMaisId).then(function (res) {
	        var address = _.find(res.data.address, function (o) {
	          return o.type == "MAILING";
	        });
	        return address;
	      });
	    }
	  }, {
	    key: 'getAddressDeliveryList',
	    value: function getAddressDeliveryList(moveMaisId) {
	      return _axios2.default.get('/v2/getAddressByMoveMaisId/' + moveMaisId).then(function (res) {
	        var address = _.filter(res.data.address, function (o) {
	          return o.type == "DELIVERY";
	        });
	        return address;
	      });
	    }
	  }, {
	    key: 'updateUser',
	    value: function updateUser(user) {
	      if (user.active == null) {
	        user.active = 0;
	      }
	      return _axios2.default.post('/v2/updateUser', { account: user });
	    }
	  }, {
	    key: 'updateAddress',
	    value: function updateAddress(address) {
	      return _axios2.default.post("/v2/updateAddress", { address: address });
	    }
	  }, {
	    key: 'insertAddress',
	    value: function insertAddress(address) {
	      return _axios2.default.post("/v2/insertAddress", { address: address });
	    }
	  }, {
	    key: 'queryAddress',
	    value: function queryAddress(zipCode) {
	      zipCode = zipCode.replace(/[^0-9]/g, '');
	      return _axios2.default.get('/v2/queryAddress/' + zipCode, { zipCode: zipCode }).then(function (res) {
	        return res.data.address.zipCode;
	      });
	    }
	  }, {
	    key: 'accountExists',
	    value: function accountExists(obj) {
	      var url = void 0;
	      if (obj.email) url = '/v2/accountExists?email=' + obj.email;
	
	      if (obj.taxIdNumber) url = '/v2/accountExists?taxIdNumberCPF=' + obj.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase();
	
	      return _axios2.default.get(url).then(function (r) {
	        return true;
	      }).catch(function (err) {
	        if (err.response.status == 488) return false;
	
	        return true;
	      });
	    }
	  }, {
	    key: 'getListChildAccount',
	    value: function getListChildAccount(moveMaisId) {
	      return _axios2.default.get('/v2/getListChildAccount/' + moveMaisId).then(function (res) {
	        return res.data.childAccountList && res.data.childAccountList.childAccount;
	      });
	    }
	  }, {
	    key: 'getUserSimple',
	    value: function getUserSimple(taxId) {
	      return _axios2.default.get('/v2/getUserSimple/' + taxId).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getContractByTaxPayerId',
	    value: function getContractByTaxPayerId(taxPayerId) {
	      return _axios2.default.get('/v2/getContractByTaxPayerId/' + taxPayerId).then(function (res) {
	        return res.data.response;
	      });
	    }
	  }, {
	    key: 'getContractByTaxPayerIdSite',
	    value: function getContractByTaxPayerIdSite(taxPayerId, contractId) {
	      return _axios2.default.get('/v2/getContractByTaxPayerIdSite/' + taxPayerId + '/' + contractId).then(function (res) {
	        return res.data.response;
	      });
	    }
	  }, {
	    key: 'getNotification',
	    value: function getNotification() {
	      return _axios2.default.post('/v2/getNotification', {}).then(function (res) {
	        return res.data.notifications.notification;
	      });
	    }
	  }, {
	    key: 'upSertNotification',
	    value: function upSertNotification(request) {
	      return _axios2.default.post('/v2/upSertNotification', request).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'isSSA',
	    value: function isSSA(moveMaisId) {
	      return _axios2.default.get('/v1/isSSA/' + moveMaisId, {}).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getUserByMoveMaisId',
	    value: function getUserByMoveMaisId(moveMaisId) {
	      return _axios2.default.get('/v2/getUserByMoveMaisId/' + moveMaisId).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getUserVpAggregateByPlate',
	    value: function getUserVpAggregateByPlate(plate) {
	      return _axios2.default.get('/v2/getUserVpAggregateByPlate/' + plate).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'buscaEnderecoConveniado',
	    value: function buscaEnderecoConveniado(cnpj) {
	      return _axios2.default.get('/v2/conveniado/buscaEnderecoConveniado/' + cnpj).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'buscaConveniadosProximos',
	    value: function buscaConveniadosProximos(request) {
	      return _axios2.default.post('/v2/conveniado/buscaConveniadosProximos', request).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getUserAndAddressByTaxIdNumber',
	    value: function getUserAndAddressByTaxIdNumber(taxIdNumber) {
	      return _axios2.default.get('/v2/getUserAndAddressByTaxIdNumber/' + taxIdNumber).then(function (r) {
	        return r.data;
	      });
	    }
	  }, {
	    key: '_buildAuthHeaders',
	    value: function _buildAuthHeaders() {
	      var authOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var requestPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var requestBody = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	      var headers = {};
	
	      if (authOptions.bearerToken) {
	        headers['Authorization'] = 'Bearer ' + authOptions.bearerToken;
	        return headers;
	      }
	
	      if (authOptions.apiKey && authOptions.timestamp && authOptions.secret) {
	        try {
	          var crypto = __webpack_require__(131);
	          var dataToSign = authOptions.apiKey + authOptions.timestamp + requestPath + requestBody;
	          var signature = crypto.createHmac('sha256', authOptions.secret).update(dataToSign).digest('hex');
	
	          headers['X-API-Key'] = authOptions.apiKey;
	          headers['X-Timestamp'] = authOptions.timestamp;
	          headers['X-Signature'] = signature;
	          return headers;
	        } catch (e) {
	          console.error('Error calculating HMAC:', e);
	        }
	      }
	
	      if (authOptions.apiKey) {
	        headers['X-API-Key'] = authOptions.apiKey;
	        return headers;
	      }
	
	      return headers;
	    }
	  }, {
	    key: 'getUserAndAddressByTaxIdNumberNoSession',
	    value: function getUserAndAddressByTaxIdNumberNoSession(taxIdNumber) {
	      var auth = __webpack_require__(11).default;
	      return auth.getUserAndAddressByTaxIdNumberNoSession(taxIdNumber);
	    }
	  }, {
	    key: 'getPartnersByPosition',
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(request) {
	        var res;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _axios2.default.get('/v2/conveniado/findPartnersByPosition?latitude=' + request.latitude + '&longitude=' + request.longitude + '&range=' + request.range);
	
	              case 2:
	                res = _context.sent;
	                return _context.abrupt('return', res.data.partners);
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function getPartnersByPosition(_x4) {
	        return _ref.apply(this, arguments);
	      }
	
	      return getPartnersByPosition;
	    }()
	  }, {
	    key: 'getPartnersByCity',
	    value: function () {
	      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(city, state, position) {
	        var latitude, longitude, res;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                latitude = position.latitude, longitude = position.longitude;
	                _context2.next = 3;
	                return _axios2.default.get('/v2/conveniado/findPartnersByCity?city=' + city + '&state=' + state + '&latitude=' + latitude + '&longitude=' + longitude);
	
	              case 3:
	                res = _context2.sent;
	                return _context2.abrupt('return', res.data.partners);
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function getPartnersByCity(_x5, _x6, _x7) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return getPartnersByCity;
	    }()
	  }, {
	    key: 'getUserAndAddressByTaxIdNumberAggregate',
	    value: function getUserAndAddressByTaxIdNumberAggregate(taxIdNumber) {
	      return _axios2.default.get('/v2/getUserAndAddressByTaxIdNumberAggregate/' + taxIdNumber).then(function (r) {
	        return r.data;
	      });
	    }
	  }, {
	    key: 'getHorariosParceiros',
	    value: function getHorariosParceiros(moveMaisId) {
	      return _axios2.default.get('/v2/getHorariosParceiros/' + moveMaisId).then(function (r) {
	        return r.data;
	      });
	    }
	  }, {
	    key: 'requestChangeUserEmail',
	    value: function requestChangeUserEmail(taxIdNumber) {
	      return _axios2.default.post('/v2/requestChangeUserEmail', { taxIdNumber: taxIdNumber }).then(function (res) {
	        return _promise2.default.resolve(true);
	      });
	    }
	  }, {
	    key: 'requestChangeUserPhone',
	    value: function requestChangeUserPhone(taxIdNumber) {
	      return _axios2.default.post('/v2/requestChangeUserPhone', { taxIdNumber: taxIdNumber }).then(function (res) {
	        return _promise2.default.resolve(true);
	      });
	    }
	  }]);
	  return AccountService;
	}();
	
	var instance = new AccountService();
	exports.default = instance;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(28);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contracts = function () {
	  function Contracts() {
	    (0, _classCallCheck3.default)(this, Contracts);
	  }
	
	  (0, _createClass3.default)(Contracts, [{
	    key: "getMoveMaisIdParent",
	    value: function getMoveMaisIdParent(contractId) {
	      return _axios2.default.get("/v2/getMoveMaisIdParentByContractId/" + contractId).then(function (res) {
	        return res.data.moveMaisId;
	      });
	    }
	  }, {
	    key: "findAll",
	    value: function findAll(moveMaisId) {
	      return _axios2.default.get("/v2/getContractByMoveMaisId/" + moveMaisId).then(function (res) {
	        return res.data.contracts;
	      });
	    }
	  }, {
	    key: "getGeneralParameter",
	    value: function getGeneralParameter(key) {
	      return _axios2.default.post("/v2/getGeneralParameter", { key: key }).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "findAllContractsVw",
	    value: function findAllContractsVw(moveMaisId) {
	      return _axios2.default.get("/v2/getContractByMoveMaisIdVw/" + moveMaisId).then(function (res) {
	        return res.data.contracts;
	      });
	    }
	  }, {
	    key: "getContract",
	    value: function getContract() {
	      return _axios2.default.get("/v2/getContract").then(function (res) {
	        return res.data.contracts;
	      });
	    }
	  }, {
	    key: "getContractData",
	    value: function getContractData(moveMaisId) {
	      return _axios2.default.get("/v2/getContractData/" + moveMaisId).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "getContractByContractId",
	    value: function getContractByContractId(contractId) {
	      return _axios2.default.get("/v2/getContractByContractId/" + contractId).then(function (res) {
	        return res.data.contract;
	      });
	    }
	  }, {
	    key: "cancel",
	    value: function cancel(contractId) {
	      return _axios2.default.delete("/v1/cancelContract/" + contractId);
	    }
	  }, {
	    key: "updateContract",
	    value: function updateContract(contract) {
	      return _axios2.default.post("/v2/updateRechargeTax", contract);
	    }
	  }, {
	    key: "updateContractValueRecharge",
	    value: function updateContractValueRecharge(contractId, valueRecharge) {
	      return _axios2.default.get("/v2/updateContractValueRecharge/" + contractId + "/" + valueRecharge);
	    }
	  }, {
	    key: "getPaymentMethod",
	    value: function getPaymentMethod(contractId) {
	      var url = "/v2/getPaymentMethod";
	      url += contractId ? "/" + contractId : "";
	      return _axios2.default.get(url).then(function (res) {
	        return res.data.list;
	      });
	    }
	  }, {
	    key: "getPaymentMethodPm",
	    value: function getPaymentMethodPm(contractId) {
	      var url = "/v2/getPaymentMethodPm";
	      url += contractId ? "/" + contractId : "";
	      return _axios2.default.get(url).then(function (res) {
	        return res.data.list;
	      });
	    }
	  }, {
	    key: "ValidacaoNetrim",
	    value: function ValidacaoNetrim(cpf, dataNascimento) {
	      return _axios2.default.get("/v2/netrim/validacaoNetrim/" + cpf + "/" + dataNascimento).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "InsereNetrimLog",
	    value: function InsereNetrimLog(cpf, dataNascimento, codeError) {
	      return _axios2.default.post("/v2/netrim/InsereNetrimLog/" + cpf + "/" + dataNascimento + "/" + codeError).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "ConsultaNetrimLog",
	    value: function ConsultaNetrimLog(cpf, dataNascimento, token) {
	      return _axios2.default.get("/v2/netrim/ConsultaNetrimLog/" + cpf + "/" + dataNascimento, {
	        headers: {
	          Authorization: "Bearer " + token
	        }
	      }).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "getRechargesRoadcard",
	    value: function getRechargesRoadcard(planId) {
	      return _axios2.default.get("/v2/roadcard/informacoes-do-plano/" + planId).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "updateContractName",
	    value: function updateContractName(contractId, name) {
	      return _axios2.default.post("/v2/updateContractName", {
	        contractId: contractId,
	        name: name
	      });
	    }
	  }, {
	    key: "cancelContract",
	    value: function cancelContract(contractId) {
	      return _axios2.default.delete("/v1/updateContractName/" + contractId);
	    }
	  }, {
	    key: "getListChildAccount",
	    value: function getListChildAccount() {
	      return _axios2.default.get("/v2/getListChildAccount").then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "getListInvoice",
	    value: function getListInvoice(contractId) {
	      return _axios2.default.get("/v1/getListInvoice/" + contractId).then(function (res) {
	        return res.data.invoices.invoice;
	      });
	    }
	  }, {
	    key: "getSummaryVehicles",
	    value: function getSummaryVehicles(contractId) {
	      return _axios2.default.get("/v2/getSummaryVehicles/" + contractId).then(function (res) {
	        return res.data.summary;
	      });
	    }
	  }, {
	    key: "getContractListSimple",
	    value: function getContractListSimple(taxId, currentTaxId) {
	      var planId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	      return _axios2.default.get("/v2/getContractListSimple/" + taxId + "/" + currentTaxId + "/" + planId).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "getUpdateValueAlert",
	    value: function getUpdateValueAlert(lcFlag, limitCredit, contractId) {
	      return _axios2.default.get("/v2/getUpdateValueAlert/" + lcFlag + "/" + limitCredit + "/" + contractId).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "checkStatusMigration",
	    value: function checkStatusMigration(moveMaisId) {
	      return _axios2.default.get("/v2/checkStatusMigration/" + moveMaisId).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "getRoadcardTax",
	    value: function getRoadcardTax() {
	      return _axios2.default.get("/v2/roadcard/getAdhesionTaxHotsite").then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "getGroupers",
	    value: function getGroupers(moveMaisId) {
	      return _axios2.default.get("/v2/agrupadorVPO/getAgrupadoresByIdCliente/" + moveMaisId).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "getUrlMoveCargo",
	    value: function getUrlMoveCargo() {
	      return _axios2.default.get("/v2/getUrlMoveCargo").then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "getDetailPlanVp",
	    value: function getDetailPlanVp(newVal) {
	      return _axios2.default.get("/v2/getDetailPlanVp/" + newVal).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "disableGrouper",
	    value: function disableGrouper(idAgrupador) {
	      return _axios2.default.post("/v2/agrupadorVPO/inactivateAgrupador", { idAgrupador: idAgrupador }).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "addGrouper",
	    value: function addGrouper(name, description, moveMaisId) {
	      return _axios2.default.post("/v2/agrupadorVPO/createAgrupador", {
	        nome: name,
	        descricao: description,
	        idClienteVpo: moveMaisId
	      }).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "editGrouper",
	    value: function editGrouper(name, description, idAgrupador) {
	      return _axios2.default.post("/v2/agrupadorVPO/updateAgrupador", {
	        nome: name,
	        descricao: description,
	        idAgrupador: idAgrupador
	      }).then(function (res) {
	        return res.data;
	      });
	    }
	  }]);
	  return Contracts;
	}();
	
	var instance = new Contracts();
	exports.default = instance;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.money = money;
	exports.centss = centss;
	exports.cents = cents;
	exports.percent = percent;
	exports.centsNoSymbol = centsNoSymbol;
	exports.moneyNoCents = moneyNoCents;
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function money(value) {
	  var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'BRL';
	  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'pt-BR';
	
	  if (value === undefined || value === null) return value;
	
	  if (_.isString(value)) {
	    value = parseFloat(value);
	  }
	
	  return value.toLocaleString(locale, {
	    style: 'currency',
	    currency: currency
	  });
	}
	
	function centss(value) {
	  var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'BRL';
	  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'pt-BR';
	
	  if (value === undefined || value === null || !$.isNumeric(value)) return value;
	
	  if (_.isString(value)) {
	    value = parseFloat(value);
	  }
	
	  value /= 100.0;
	
	  return value.toLocaleString(locale, {
	    style: 'currency',
	    currency: currency
	  }).replace(/^[^0-9]*/g, '');
	}
	
	function cents(value) {
	  var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'BRL';
	  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'pt-BR';
	
	  if (value === undefined || value === null || !$.isNumeric(value)) return value || "";
	
	  var re = '\\d(?=(\\d{' + (3 || 3) + '})+' + (2 > 0 ? '\\D' : '$') + ')',
	      num = (value / 100).toFixed(Math.max(0, ~~2));
	
	  return 'R$ ' + (',' ? num.replace('.', ',') : num).replace(new RegExp(re, 'g'), '$&' + ('.' || ','));
	}
	
	function percent(value) {
	  if (value === undefined || value === null) return value;
	
	  if (_.isString(value)) {
	    value = parseFloat(value);
	  }
	
	  value *= 100.0;
	  return Math.round(value);
	}
	
	function centsNoSymbol(value) {
	  var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'BRL';
	  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'pt-BR';
	
	  if (value === undefined || value === null || !$.isNumeric(value)) return value || "";
	
	  var re = '\\d(?=(\\d{' + (3 || 3) + '})+' + (2 > 0 ? '\\D' : '$') + ')',
	      num = (value / 100).toFixed(Math.max(0, ~~2));
	
	  return (',' ? num.replace('.', ',') : num).replace(new RegExp(re, 'g'), '$&' + ('.' || ','));
	}
	
	function moneyNoCents(value) {
	  var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'BRL';
	  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'pt-BR';
	
	  if (value === undefined || value === null || !$.isNumeric(value)) return value || "";
	
	  var re = '\\d(?=(\\d{' + (3 || 3) + '})+' + (2 > 0 ? '\\D' : '$') + ')',
	      num = (value / 100).toFixed(Math.max(0, ~~2));
	
	  var n = (',' ? num.replace('.', ',') : num).replace(new RegExp(re, 'g'), '$&' + ('.' || ','));
	  return n.substring(0, n.length - 3);
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EventBus = undefined;
	
	var _vue = __webpack_require__(164);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventBus = exports.EventBus = new _vue2.default();

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(28);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TollService = function () {
	  function TollService() {
	    (0, _classCallCheck3.default)(this, TollService);
	  }
	
	  (0, _createClass3.default)(TollService, [{
	    key: 'getTollsByState',
	    value: function getTollsByState(state) {
	      return _axios2.default.get('/v1/getTolls/' + state).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getListTolls',
	    value: function getListTolls() {
	      return _axios2.default.get('/v2/getListTolls').then(function (res) {
	        res.data.forEach(function (o) {
	          if (o.state == 'BA') {
	            o.state = 'BAHIA';
	          } else if (o.state == 'ES') {
	            o.state = 'ESPIRITO SANTO';
	          } else if (o.state == 'GO') {
	            o.state = 'GOIÁS';
	          } else if (o.state == 'MG') {
	            o.state = 'MINAS GERAIS';
	          } else if (o.state == 'MS') {
	            o.state = 'MATO GROSSO DO SUL';
	          } else if (o.state == 'MT') {
	            o.state = 'MATO GROSSO';
	          } else if (o.state == 'PE') {
	            o.state = 'PERNAMBUCO';
	          } else if (o.state == 'PR') {
	            o.state = 'PARANÁ';
	          } else if (o.state == 'PA') {
	            o.state = 'PARÁ';
	          } else if (o.state == 'RJ') {
	            o.state = 'RIO DE JANEIRO';
	          } else if (o.state == 'RS') {
	            o.state = 'RIO GRANDE DO SUL';
	          } else if (o.state == 'SC') {
	            o.state = 'SANTA CATARINA';
	          } else if (o.state == 'SP') {
	            o.state = 'SÃO PAULO';
	          } else if (o.state == 'PI') {
	            o.state = 'PIAUÍ';
	          }
	        });
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getStatePercent',
	    value: function getStatePercent(state) {
	      return _axios2.default.get('/v1/getStatePercent').then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getTolls',
	    value: function getTolls() {
	      return _axios2.default.get('/v2/routing/getTolls').then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getPriceTolls',
	    value: function getPriceTolls(request) {
	      return _axios2.default.post('/v2/routing/getTollsPrice', request).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getValePedagio',
	    value: function getValePedagio(contractId) {
	      return _axios2.default.get('/v2/vp/list/' + contractId).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getById',
	    value: function getById(idVP) {
	      return _axios2.default.get('/v2/vp/getById/' + idVP).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'insertValePedagio',
	    value: function insertValePedagio(request) {
	      return _axios2.default.post('/v2/vp/inserirValePedagio', request).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getFilter',
	    value: function getFilter(filter) {
	      return _axios2.default.post('/v2/vp/filter', filter).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getFilterLimited',
	    value: function getFilterLimited(filter) {
	      return _axios2.default.post('/v2/vp/filterLimited', filter).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getInfo',
	    value: function getInfo() {
	      return _axios2.default.get('/v2/vp/getInfo').then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getSaldoVeiculo',
	    value: function getSaldoVeiculo(plate) {
	      return _axios2.default.get('/v2/vp/getSaldoVeiculo/' + plate).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'cancelar',
	    value: function cancelar(req) {
	      return _axios2.default.post('/v2/vp/cancelar', req).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'transferirEmbarcador',
	    value: function transferirEmbarcador(request) {
	      return _axios2.default.post('/v2/vp/transferirEmbarcador', request).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getTransfer',
	    value: function getTransfer(transferId) {
	      return _axios2.default.get('/v2/vp/getTransfer/' + transferId).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'exportarRelatorioAcompanhamento',
	    value: function exportarRelatorioAcompanhamento(req) {
	      var config = { responseType: "blob" };
	      return _axios2.default.post('/v2/vp/exportarRelatorioAcompanhamento', req, config).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'exportarRelatorioCompleto',
	    value: function exportarRelatorioCompleto(filter) {
	      var config = { responseType: "blob" };
	      return _axios2.default.post('/v2/vp/exportarExtratoCompletoVP/', filter, config).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'exportarRelatorioParent',
	    value: function exportarRelatorioParent(filter) {
	      var config = { responseType: "blob" };
	      return _axios2.default.post('/v2/vp/exportarRelatorioAcompanhamentoParent/', filter, config).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getVehicleDataVp',
	    value: function getVehicleDataVp(plate, document) {
	      var queryParams = document ? '?cpfCnpj=' + document : '';
	
	      return _axios2.default.get('/v2/getVehicleDataSiteVP/' + (plate || 'NOTPLATE') + queryParams).then(function (res) {
	        return res.data.vehicle;
	      });
	    }
	  }, {
	    key: 'cadastrarExcecao',
	    value: function cadastrarExcecao(request) {
	      return _axios2.default.post('/v2/vp/site/criarExcecaoRntrc', request).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'exportReceiptVp',
	    value: function exportReceiptVp(req) {
	      var config = { responseType: "blob" };
	      return _axios2.default.post('/v2/vp/exportReceiptVP', req, config).then(function (res) {
	        return res.data;
	      });
	    }
	  }]);
	  return TollService;
	}();
	
	var instance = new TollService();
	exports.default = instance;

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(244);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(28);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var xlsSignature = [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1];
	
	function readBlob(blob, mode) {
	  return new _promise2.default(function (resolve, reject) {
	    if (typeof FileReader === 'undefined') {
	      reject(new Error('Leitura do arquivo não suportada pelo navegador.'));
	      return;
	    }
	    var reader = new FileReader();
	    reader.onload = function () {
	      return resolve(reader.result);
	    };
	    reader.onerror = function () {
	      return reject(reader.error);
	    };
	    mode === 'text' ? reader.readAsText(blob) : reader.readAsArrayBuffer(blob);
	  });
	}
	
	function invalidReportError(statusCode) {
	  var error = new Error('Resposta inválida ao exportar veículos.');
	  error.exportStatusCode = statusCode;
	  return error;
	}
	
	function readStatusCode(data) {
	  if (data && data.status) return _promise2.default.resolve(data.status.code);
	  if (!data) return _promise2.default.resolve(undefined);
	
	  return readBlob(data, 'text').then(function (rawPayload) {
	    try {
	      var payload = JSON.parse(rawPayload);
	      return payload && payload.status && payload.status.code;
	    } catch (e) {
	      return undefined;
	    }
	  });
	}
	
	var VehiclesService = function () {
	  function VehiclesService() {
	    (0, _classCallCheck3.default)(this, VehiclesService);
	  }
	
	  (0, _createClass3.default)(VehiclesService, [{
	    key: 'exportVehicles',
	    value: function exportVehicles(contractId) {
	      return _axios2.default.get('/v2/gerarRelatorioVeiculoExcel/' + contractId + '/relatorio_veiculos.xls', { responseType: 'blob' }).then(function (res) {
	        var responseType = res.headers && res.headers['content-type'] || res.data && res.data.type || '';
	        var contentType = responseType.split(';')[0].trim().toLowerCase();
	        var invalidTypes = ['application/json', 'text/html', 'text/plain'];
	
	        if (!res.data || !res.data.size || invalidTypes.indexOf(contentType) !== -1) {
	          if (res.data && contentType === 'application/json') {
	            return readStatusCode(res.data).then(function (statusCode) {
	              throw invalidReportError(statusCode);
	            });
	          }
	
	          throw invalidReportError();
	        }
	
	        return readBlob(res.data.slice(0, xlsSignature.length), 'buffer').then(function (buffer) {
	          if (buffer) {
	            var bytes = new Uint8Array(buffer);
	            var validSignature = xlsSignature.every(function (value, index) {
	              return bytes[index] === value;
	            });
	            if (!validSignature) throw invalidReportError();
	          }
	          return res.data;
	        });
	      }).catch(function (err) {
	        var response = err && (err.response || (err.status ? err : undefined));
	        if (!response) throw err;
	
	        var responseType = response.headers && response.headers['content-type'] || response.data && response.data.type || '';
	        var contentType = responseType.split(';')[0].trim().toLowerCase();
	
	        if (response.data && contentType === 'application/json') {
	          return readStatusCode(response.data).then(function (statusCode) {
	            err.exportStatusCode = statusCode;
	            throw err;
	          });
	        }
	
	        throw err;
	      });
	    }
	  }, {
	    key: 'getVehiclesForActivate',
	    value: function getVehiclesForActivate() {
	      return _axios2.default.get('/v2/getVehiclesForActivate').then(function (res) {
	        return res.data.vehicles;
	      });
	    }
	  }, {
	    key: 'getVehiclesForActivateAgg',
	    value: function getVehiclesForActivateAgg() {
	      return _axios2.default.get('/v2/getVehiclesForActivateAgg').then(function (res) {
	        return res.data.vehicles;
	      });
	    }
	  }, {
	    key: 'getVehiclesForActivateByPlate',
	    value: function getVehiclesForActivateByPlate(filter) {
	      return _axios2.default.post('/v2/getVehiclesForActivateByPlate', filter).then(function (res) {
	        return res.data.vehicles;
	      });
	    }
	  }, {
	    key: 'getVehiclesToVinculateRNTRC',
	    value: function getVehiclesToVinculateRNTRC() {
	      return _axios2.default.get('/v1/getVehiclesForActivate').then(function (res) {
	        return res.data.vehicleList.vehicle;
	      });
	    }
	  }, {
	    key: 'getVehicleByContractId',
	    value: function getVehicleByContractId(contractId) {
	      return _axios2.default.get('/v1/getVehicleByContractId/' + contractId).then(function (res) {
	        return res.data.vehicleList.vehicle;
	      });
	    }
	  }, {
	    key: 'getVehicleByContractIdV2',
	    value: function getVehicleByContractIdV2(contractId) {
	      return _axios2.default.get('/v2/getVehiclesByContractId/' + contractId).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getVehicleByContractIdContagem',
	    value: function getVehicleByContractIdContagem(contractId) {
	      return _axios2.default.get('/v2/getVehiclesByContractId/' + contractId).then(function (res) {
	        return res.data.Vehicles;
	      });
	    }
	  }, {
	    key: 'getVehicleMercosulPlate',
	    value: function getVehicleMercosulPlate(plate) {
	      return _axios2.default.get('/v2/getMercosulPlate/' + plate).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'alterToMercosulPlate',
	    value: function alterToMercosulPlate(plate) {
	      return _axios2.default.post('/v2/alterPlateMercosul', { plate: plate }).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getVehicle',
	    value: function getVehicle(filter) {
	      return _axios2.default.post('/v2/getVehicleSimplePaged', filter).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getVehicleById',
	    value: function getVehicleById(id) {
	      return _axios2.default.get('v2/getVehiclebyId/' + id).then(function (res) {
	        return res.data.vehicle;
	      });
	    }
	  }, {
	    key: 'getVehicleBrand',
	    value: function getVehicleBrand() {
	      return _axios2.default.get('/v2/getVehicleBrand').then(function (res) {
	        return res.data.brands;
	      });
	    }
	  }, {
	    key: 'listaEixosBase',
	    value: function listaEixosBase(categoryId, token) {
	      return _axios2.default.get('/v2/netrim/listaEixosBase/' + categoryId, {
	        headers: { Authorization: 'Bearer ' + token }
	      }).then(function (res) {
	        return res.data.Axes;
	      });
	    }
	  }, {
	    key: 'getPlacaNetrim',
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(plate, token) {
	        var response;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _axios2.default.get('/v2/netrim/getPlacaNetrim/' + plate, {
	                  headers: { Authorization: 'Bearer ' + token }
	                }).then(function (res) {
	                  return res.data;
	                });
	
	              case 2:
	                response = _context.sent;
	                return _context.abrupt('return', response);
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function getPlacaNetrim(_x, _x2) {
	        return _ref.apply(this, arguments);
	      }
	
	      return getPlacaNetrim;
	    }()
	  }, {
	    key: 'postAxes',
	    value: function () {
	      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(brand, model, fipeId, token) {
	        var response;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return _axios2.default.post('/v2/netrim/listaEixosProc', {
	                  marca: '' + brand,
	                  modelo: '' + model,
	                  fipe: '' + fipeId
	                }, {
	                  headers: { Authorization: 'Bearer ' + token }
	                }).then(function (res) {
	                  return res.data;
	                });
	
	              case 2:
	                response = _context2.sent;
	                return _context2.abrupt('return', response);
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function postAxes(_x3, _x4, _x5, _x6) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return postAxes;
	    }()
	  }, {
	    key: 'getVehicleModel',
	    value: function getVehicleModel(brandId) {
	      return _axios2.default.get('/v2/getVehicleModel/' + brandId).then(function (res) {
	        return res.data.models;
	      });
	    }
	  }, {
	    key: 'getContractUserList',
	    value: function getContractUserList(moveMaisId) {
	      return _axios2.default.get('/v2/getContractUserList/' + moveMaisId).then(function (res) {
	        return res.data.response;
	      });
	    }
	  }, {
	    key: 'updateVehicle',
	    value: function updateVehicle(enabledPap, vehicleId) {
	      return _axios2.default.post('/v2/updateVehicle2/' + enabledPap + '/' + vehicleId).then(function (res) {
	        return res.data;
	      }).catch(function (res) {
	        return res.data.status;
	      });
	    }
	  }, {
	    key: 'find',
	    value: function find(filter) {
	      var f = filter;
	      var url = '/v1/getVehicleByContractIdPaged/' + f.contractId + '/' + f.page.size() + '/' + f.page.page();
	
	      return _axios2.default.get(url).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'listPassage',
	    value: function listPassage(filter) {
	      var f = filter;
	      var url = '/v2/listPassage/' + f.contractId + '/' + f.vehicleId + '/' + f.startDate + '/' + f.endDate;
	      return _axios2.default.get(url).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getVehicleByPlateAndContract',
	    value: function getVehicleByPlateAndContract(plate, contractId) {
	      var url = '/v1/getVehicleByPlateAndContract/' + plate + '/' + contractId;
	
	      return _axios2.default.get(url).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getByObuid',
	    value: function getByObuid(obuid) {
	      var url = '/v1/getVehicleByPublicId/' + obuid;
	
	      return _axios2.default.get(url).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'vehicleNotExists',
	    value: function vehicleNotExists(plate) {
	      return _axios2.default.get('/v2/vehicleNotExists?plate=' + plate).then(function (r) {
	        return true;
	      }).catch(function (err) {
	        var status = err && err.response ? err.response.status : err && err.status;
	        if (status == 488) return false;
	
	        return true;
	      });
	    }
	  }, {
	    key: 'checkVehicleByMoveMaisId',
	    value: function checkVehicleByMoveMaisId(moveMaisId) {
	      return _axios2.default.get('/v2/checkVehicleByMoveMaisId/' + moveMaisId).then(function (res) {
	
	        return res.data;
	      });
	    }
	  }, {
	    key: 'deleteAggregateVehicleAndUser',
	    value: function deleteAggregateVehicleAndUser(filter) {
	      return _axios2.default.post('/v2/deleteAggregateVehicleAndUser', filter).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getVehiclesAggregate',
	    value: function getVehiclesAggregate(filter) {
	      return _axios2.default.post('/v2/getVehiclesAggregate', filter).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getVehiclesAggregateWithBalance',
	    value: function getVehiclesAggregateWithBalance(filter) {
	      return _axios2.default.post('/v2/getVehiclesAggregateWithBalance', filter).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'createVehicleGrouper',
	    value: function createVehicleGrouper(vehicleId, idAgrupadorCliente) {
	      return _axios2.default.post('/v2/agrupadorVPO/createVeiculoAgrupador', {
	        idAgrupadorCliente: idAgrupadorCliente,
	        vehicleId: vehicleId
	      }).then(function (res) {
	        return res.data;
	      });
	    }
	  }]);
	  return VehiclesService;
	}();
	
	var instance = new VehiclesService();
	exports.default = instance;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.secondsInMinute = exports.secondsInHour = exports.quartersInYear = exports.monthsInYear = exports.monthsInQuarter = exports.minutesInHour = exports.minTime = exports.millisecondsInSecond = exports.millisecondsInHour = exports.millisecondsInMinute = exports.maxTime = exports.daysInWeek = void 0;
	
	/**
	 * Days in 1 week.
	 *
	 * @name daysInWeek
	 * @constant
	 * @type {number}
	 * @default
	 */
	var daysInWeek = 7;
	/**
	 * Maximum allowed time.
	 *
	 * @name maxTime
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.daysInWeek = daysInWeek;
	var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
	/**
	 * Milliseconds in 1 minute
	 *
	 * @name millisecondsInMinute
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.maxTime = maxTime;
	var millisecondsInMinute = 60000;
	/**
	 * Milliseconds in 1 hour
	 *
	 * @name millisecondsInHour
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.millisecondsInMinute = millisecondsInMinute;
	var millisecondsInHour = 3600000;
	/**
	 * Milliseconds in 1 second
	 *
	 * @name millisecondsInSecond
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.millisecondsInHour = millisecondsInHour;
	var millisecondsInSecond = 1000;
	/**
	 * Minimum allowed time.
	 *
	 * @name minTime
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.millisecondsInSecond = millisecondsInSecond;
	var minTime = -maxTime;
	/**
	 * Minutes in 1 hour
	 *
	 * @name minutesInHour
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.minTime = minTime;
	var minutesInHour = 60;
	/**
	 * Months in 1 quarter
	 *
	 * @name monthsInQuarter
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.minutesInHour = minutesInHour;
	var monthsInQuarter = 3;
	/**
	 * Months in 1 year
	 *
	 * @name monthsInYear
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.monthsInQuarter = monthsInQuarter;
	var monthsInYear = 12;
	/**
	 * Quarters in 1 year
	 *
	 * @name quartersInYear
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.monthsInYear = monthsInYear;
	var quartersInYear = 4;
	/**
	 * Seconds in 1 hour
	 *
	 * @name secondsInHour
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.quartersInYear = quartersInYear;
	var secondsInHour = 3600;
	/**
	 * Seconds in 1 minute
	 *
	 * @name secondsInMinute
	 * @constant
	 * @type {number}
	 * @default
	 */
	
	exports.secondsInHour = secondsInHour;
	var secondsInMinute = 60;
	exports.secondsInMinute = secondsInMinute;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(36);
	var core = __webpack_require__(23);
	var ctx = __webpack_require__(56);
	var hide = __webpack_require__(62);
	var has = __webpack_require__(72);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(777)
	var ieee754 = __webpack_require__(1692)
	var isArray = __webpack_require__(344)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Page = undefined;
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(28);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Page = function () {
	  function Page() {
	    (0, _classCallCheck3.default)(this, Page);
	
	    this._size = 10;
	
	    this._offset = 0;
	
	    this._itemCount = 0;
	  }
	
	  (0, _createClass3.default)(Page, [{
	    key: 'build',
	    value: function build() {
	      return {
	        pageSize: this.size(),
	        pageNumber: this.page()
	      };
	    }
	  }, {
	    key: 'size',
	    value: function size(_size) {
	      if (_size === undefined) return this._size;else {
	        var x = _.clone(this);
	        x._size = _size;
	        x._offset = 0;
	        return x;
	      }
	    }
	  }, {
	    key: 'offset',
	    value: function offset(_offset) {
	      if (_offset === undefined) {
	        return this._offset;
	      } else {
	        var x = _.clone(this);
	        x._offset = _offset;
	        return x;
	      }
	    }
	  }, {
	    key: 'itemCount',
	    value: function itemCount(count) {
	      if (count === undefined) {
	        return this._itemCount;
	      } else {
	        var x = _.clone(this);
	        x._itemCount = count;
	        return x;
	      }
	    }
	  }, {
	    key: 'pages',
	    value: function pages() {
	      var start = this.page() - 5;
	      var end = this.page() + 4;
	      while (start < 1) {
	        start++;
	      }
	
	      while (end - start < 9) {
	        end++;
	      }
	
	      while (end > this.pageCount()) {
	        end--;
	      }
	
	      return _.range(start, end + 1);
	    }
	  }, {
	    key: 'firstIndexShown',
	    value: function firstIndexShown() {
	      if (this._itemCount == 0) return 0;
	
	      return this.offset() + 1;
	    }
	  }, {
	    key: 'lastIndexShown',
	    value: function lastIndexShown() {
	      return Math.min(this.offset() + this.size(), this.itemCount());
	    }
	  }, {
	    key: 'page',
	    value: function page(_page) {
	      if (_page === undefined) {
	        return Math.floor(this.offset() / this.size()) + 1;
	      } else {
	        return this.offset(this.size() * (_page - 1));
	      }
	    }
	  }, {
	    key: 'pageCount',
	    value: function pageCount(pages) {
	      if (pages === undefined) {
	        return Math.ceil(this.itemCount() / this.size());
	      } else {
	        return this.itemCount(pages * this.size());
	      }
	    }
	  }]);
	  return Page;
	}();
	
	exports.Page = Page;
	
	
	var template = __webpack_require__(1691);
	
	exports.default = {
	  template: template,
	
	  props: ['model'],
	
	  methods: {
	    previous: function previous() {
	      var page = this.model.page();
	      if (page > 1) {
	        this.$emit('page-change', page - 1);
	      }
	    },
	    next: function next() {
	      var page = this.model.page();
	      if (page < this.model.pageCount()) {
	        this.$emit('page-change', page + 1);
	      }
	    },
	    toPage: function toPage(p) {
	      if (p > 0 && p <= this.model.pageCount()) {
	        this.$emit('page-change', p);
	      }
	    }
	  }
	
	};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getCookie = getCookie;
	exports.validateCreditCard = validateCreditCard;
	exports.isCaminhoParana = isCaminhoParana;
	exports.getPaymentMethodId = getPaymentMethodId;
	exports.getCardBrand = getCardBrand;
	exports.isCardValid = isCardValid;
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getCookie(cname) {
	    var name = cname + "=";
	    var decodedCookie = decodeURIComponent(document.cookie);
	    var ca = decodedCookie.split(';');
	    for (var i = 0; i < ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) == ' ') {
	            c = c.substring(1);
	        }
	        if (c.indexOf(name) == 0) {
	            return c.substring(name.length, c.length);
	        }
	    }
	    return "";
	}
	
	function validateCreditCard(month, year) {
	    var currentDate = new Date();
	    var currentYear = currentDate.getFullYear();
	    var currentMonth = currentDate.getMonth() + 1;
	    if (year > currentYear) {
	        return true;
	    } else if (year == currentYear) {
	
	        if (month >= currentMonth) return true;else return false;
	    }
	    return false;
	}
	
	function isCaminhoParana(planId) {
	    switch (parseInt(planId)) {
	        case _constantes2.default.PLAN_PRE_MAN_CAM_PARANA_PF:
	        case _constantes2.default.PLAN_PRE_AUT_CAM_PARANA_PF:
	        case _constantes2.default.PLAN_PRE_MAN_CAM_PARANA_PJ:
	        case _constantes2.default.PLAN_PRE_AUT_CAM_PARANA_PJ:
	            return true;
	        default:
	            return false;
	
	    }
	}
	
	function getPaymentMethodId(brand) {
	    switch (brand) {
	        case "Visa":
	            return 6;
	        case "Mastercard":
	            return 7;
	        case "Diners":
	            return 9;
	        case 'American Express':
	            return 8;
	        case 'Elo':
	            return 10;
	        case 'HiperCard':
	            return 11;
	    }
	}
	
	function getCardBrand(cardNumber) {
	    cardNumber = cardNumber.replace(/[^0-9]/g, '');
	
	    var digit1 = cardNumber.substring(0, 1);
	    var digit2 = cardNumber.substring(0, 2);
	    var digit3 = cardNumber.substring(0, 3);
	    var digit4 = cardNumber.substring(0, 4);
	    var digit5 = cardNumber.substring(0, 5);
	    var digit6 = cardNumber.substring(0, 6);
	
	    if (cardNumber.length > 2) {
	        if (digit1 == 4) {
	            return "Visa";
	        } else if (digit2 >= 51 && digit2 <= 55 || digit2 == 59) {
	                return "Mastercard";
	            } else if (digit2 == 34 || digit2 == 37) {
	                    return "American Express";
	                } else if (digit6 == 636368 || digit6 == 438935 || digit6 == 504175 || digit6 == 451416 || digit6 == 509048 || digit6 == 509067 || digit6 == 509049 || digit6 == 509069 || digit6 == 509050 || digit6 == 509074 || digit6 == 509068 || digit6 == 509040 || digit6 == 509045 || digit6 == 509051 || digit6 == 509046 || digit6 == 509066 || digit6 == 509047 || digit6 == 509042 || digit6 == 509052 || digit6 == 509043 || digit6 == 636368 || digit6 == 509064 || digit6 == 509040 || digit4 == 5067 || digit4 == 4576 || digit4 == 4011 || digit5 == 36297) {
	
	                        return "Elo";
	                    }
	    }
	    return "";
	}
	
	function isCardValid(cardNumber) {
	    cardNumber = cardNumber.replace(/[^0-9]/g, '');
	    var valid = 0;
	
	    var digit1 = cardNumber.substring(0, 1);
	    var digit2 = cardNumber.substring(0, 2);
	    var digit3 = cardNumber.substring(0, 3);
	    var digit4 = cardNumber.substring(0, 4);
	
	    if (cardNumber.length > 2) {
	        if (digit1 == 4) {
	            if (cardNumber.length == 13 || cardNumber.length == 16) return true;
	        } else if (digit2 >= 51 && digit2 <= 55 || digit2 == 59) {
	                if (cardNumber.length == 16) return true;
	            } else if (digit2 == 36 || digit2 == 38 || digit3 >= 300 && digit3 <= 305) {
	                    if (cardNumber.length == 14) return true;
	                }
	    }
	    return false;
	}

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.join = join;
	exports.cpfCnpj = cpfCnpj;
	exports.phone = phone;
	exports.firstWord = firstWord;
	exports.fromSecWord = fromSecWord;
	exports.removeMascara = removeMascara;
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function join(value) {
	  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ', ';
	
	  return _.join(value, separator);
	}
	
	function cpfCnpj(data) {
	  if (!data) return '';
	  data = String(data).replace(/[.\-\/ ]/g, '').toUpperCase();
	
	  if (data.length <= 11) {
	    return data.slice(0, 3) + '.' + data.slice(3, 6) + '.' + data.slice(6, 9) + '-' + data.slice(9, 11);
	  } else {
	    return data.slice(0, 2) + '.' + data.slice(2, 5) + '.' + data.slice(5, 8) + '/' + data.slice(8, 12) + '-' + data.slice(12, 14);
	  }
	}
	
	function phone(data) {
	  if (!data) return "";
	
	  data = data.replace(/[^0-9]/g, "");
	  if (data.length < 2) return data;else if (data.length <= 6) {
	    return '(' + data.substring(0, 2) + ')' + data.substring(2, 6);
	  } else if (data.length <= 10) {
	    return '(' + data.substring(0, 2) + ')' + data.substring(2, 6) + '-' + data.substring(6, 10);
	  } else {
	    return '(' + data.substring(0, 2) + ')' + data.substring(2, 7) + '-' + data.substring(7, 11);
	  }
	}
	
	function firstWord(data) {
	  if (!data) return "";
	
	  return data.substring(0, data.indexOf(" "));
	}
	
	function fromSecWord(data) {
	  if (!data) return "";
	
	  return data.substring(data.indexOf(" ")).trim();
	}
	
	function removeMascara(value) {
	  return value.replace(/[.\-\/]/g, '').toUpperCase();
	}

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(192)('wks');
	var uid = __webpack_require__(129);
	var Symbol = __webpack_require__(36).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.date = date;
	exports.shortDate = shortDate;
	exports.dateTime = dateTime;
	exports.time = time;
	exports.brToAm = brToAm;
	exports.AmToBr = AmToBr;
	exports.dateFull = dateFull;
	exports.secondsFormat = secondsFormat;
	exports.secondsFormatShort = secondsFormatShort;
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_moment2.default.locale('pt-br');
	
	function date(value) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'L';
	
	  if (value === undefined || value === null) return value;
	
	  var d = (0, _moment2.default)(value).format(format);
	  return d == "Invalid date" ? value : d;
	}
	
	function shortDate(value) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD/MM/YY';
	
	  return date(value, format);
	}
	
	function dateTime(value) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'L LT';
	
	  return date(value, format);
	}
	
	function time(value) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'LT';
	
	  return date(value, format);
	}
	
	function brToAm(data) {
	  if (data.length != 10) return "";
	  var d = data.split("/");
	  return d[2] + '-' + d[1] + '-' + d[0];
	}
	
	function AmToBr(data) {
	  if (data.length != 10) return "";
	  var d = data.split("-");
	  return d[2] + '/' + d[1] + '/' + d[0];
	}
	
	function dateFull(value) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD [de] MMMM [de] YYYY';
	
	  return date(value, format);
	}
	
	function secondsFormat(value) {
	  if (!value) return "";
	  var days = Math.floor(value / 86400);
	  var hours = Math.floor((value - days * 86400) / 3600);
	  var minutes = Math.floor((value - days * 86400 - hours * 3600) / 60);
	  var str = "";
	  if (days > 0) str += days + " dias ";
	
	  if (hours > 0) str += hours + " horas e ";
	
	  str += minutes + ' minutos';
	
	  return str;
	}
	
	function secondsFormatShort(value) {
	  if (!value) return "";
	  var days = Math.floor(value / 86400) + "";
	  var hours = Math.floor((value - days * 86400) / 3600) + "";
	  var minutes = Math.floor((value - days * 86400 - hours * 3600) / 60) + "";
	  var str = days.padStart(2, "0") + ":" + hours.padStart(2, "0") + ":" + minutes.padStart(2, "0");
	
	  return str;
	}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var getCoord = __webpack_require__(150).getCoord;
	var radiansToDistance = __webpack_require__(17).radiansToDistance;
	//http://en.wikipedia.org/wiki/Haversine_formula
	//http://www.movable-type.co.uk/scripts/latlong.html
	
	/**
	 * Calculates the distance between two {@link Point|points} in degrees, radians,
	 * miles, or kilometers. This uses the
	 * [Haversine formula](http://en.wikipedia.org/wiki/Haversine_formula)
	 * to account for global curvature.
	 *
	 * @name distance
	 * @param {Feature<Point>} from origin point
	 * @param {Feature<Point>} to destination point
	 * @param {String} [units=kilometers] can be degrees, radians, miles, or kilometers
	 * @return {Number} distance between the two points
	 * @example
	 * var from = {
	 *   "type": "Feature",
	 *   "properties": {},
	 *   "geometry": {
	 *     "type": "Point",
	 *     "coordinates": [-75.343, 39.984]
	 *   }
	 * };
	 * var to = {
	 *   "type": "Feature",
	 *   "properties": {},
	 *   "geometry": {
	 *     "type": "Point",
	 *     "coordinates": [-75.534, 39.123]
	 *   }
	 * };
	 * var units = "miles";
	 *
	 * var points = {
	 *   "type": "FeatureCollection",
	 *   "features": [from, to]
	 * };
	 *
	 * //=points
	 *
	 * var distance = turf.distance(from, to, units);
	 *
	 * //=distance
	 */
	module.exports = function (from, to, units) {
	    var degrees2radians = Math.PI / 180;
	    var coordinates1 = getCoord(from);
	    var coordinates2 = getCoord(to);
	    var dLat = degrees2radians * (coordinates2[1] - coordinates1[1]);
	    var dLon = degrees2radians * (coordinates2[0] - coordinates1[0]);
	    var lat1 = degrees2radians * coordinates1[1];
	    var lat2 = degrees2radians * coordinates2[1];
	
	    var a = Math.pow(Math.sin(dLat / 2), 2) +
	          Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);
	
	    return radiansToDistance(2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)), units);
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(233);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createElement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(71)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik04Ljk3ODQ1IDEzLjY5NjJDOC41ODMwNCAxMy4zMDA4IDcuOTQxOTYgMTMuMzAwOCA3LjU0NjU1IDEzLjY5NjJDNy4xNTExNSAxNC4wOTE2IDcuMTUxMTUgMTQuNzMyNyA3LjU0NjU1IDE1LjEyODFMMTEuMjIxNyAxOC44MDMzQzExLjYxNzEgMTkuMTk4NyAxMi4yNTgyIDE5LjE5ODcgMTIuNjUzNiAxOC44MDMzTDIxLjM1MzQgMTAuMTAzNEMyMS43NDg5IDkuNzA4MDQgMjEuNzQ4OSA5LjA2Njk2IDIxLjM1MzQgOC42NzE1NUMyMC45NTggOC4yNzYxNSAyMC4zMTcgOC4yNzYxNSAxOS45MjE2IDguNjcxNTVMMTEuOTM3NyAxNi42NTU0TDguOTc4NDUgMTMuNjk2MloiIGZpbGw9IiMxNTg0NDQiLz4NCjwvc3ZnPg0K"

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function account() {
	  return {
	    "type": "1",
	    "taxIdNumber": undefined,
	    "taxIdNumberFormatted": undefined,
	    "person": {
	      "birthDate": undefined,
	
	      "birthDateBR": "",
	      "fullName": undefined,
	      "name": undefined,
	      "lastName": undefined
	    },
	    "accountAuthentication": {
	      "login": undefined,
	      "password": undefined,
	      "confirmPassword": undefined,
	      "active": "Y"
	    },
	    "nroCellphone": "",
	    "dddCellphone": "",
	
	    "typePhone": "RESIDENCIAL",
	    "dddPhone": "",
	    "nroPhone": "",
	
	    "typePhone2": "COMERCIAL",
	    "dddPhone2": "",
	    "nroPhone2": ""
	
	  };
	};
	
	function address() {
	  return {
	    "type": "MAILING",
	    "number": undefined,
	    "complement": undefined,
	    "address": undefined,
	    "neighborhood": undefined,
	    "city": undefined,
	    "state": undefined,
	    "zipCode": undefined
	  };
	};
	
	function contract() {
	  return {
	    "plan": {
	      "planId": 21
	    },
	    "paymentMethods": {
	      "paymentMethod": [{
	        "priority": "1",
	        "paymentMethodId": undefined
	      }]
	    },
	    "rechargeValue": undefined,
	    "changeFlagEmail": "0",
	    "limitCredit": undefined,
	    "lcFlag": undefined
	  };
	};
	
	function payment() {
	  return {
	    "priority": "1",
	    "paymentMethodId": undefined
	  };
	};
	
	function businessActivity() {
	  return [{
	    id: "1",
	    label: "Agricultura",
	    value: "AGRICULTURA"
	  }, {
	    id: "2",
	    label: "Alimentos e Bebidas",
	    value: "ALIMENTOS_E_BEBIDAS"
	  }, {
	    id: "3",
	    label: "Biotecnologia",
	    value: "BIOTECNOLOGIA"
	  }, {
	    id: "4",
	    label: "Comunicações",
	    value: "COMUNICACOES"
	  }, {
	    id: "5",
	    label: "Contrução Civil",
	    value: "CONSTRUCAO_CIVIL"
	  }, {
	    id: "6",
	    label: "Consultoria",
	    value: "CONSULTORIA"
	  }, {
	    id: "7",
	    label: "Educação",
	    value: "EDUCACAO"
	  }, {
	    id: "8",
	    label: "Eletrônica",
	    value: "ELETRONICA"
	  }, {
	    id: "9",
	    label: "Energia",
	    value: "ENERGIA"
	  }, {
	    id: "10",
	    label: "Engenharia",
	    value: "ENGENHARIA"
	  }, {
	    id: "11",
	    label: "Entretenimento",
	    value: "ENTRETENIMENTO"
	  }, {
	    id: "12",
	    label: "Equipamentos",
	    value: "EQUIPAMENTOS"
	  }, {
	    id: "13",
	    label: "Expedição",
	    value: "EXPEDICAO"
	  }, {
	    id: "14",
	    label: "Finanças",
	    value: "FINANCAS"
	  }, {
	    id: "15",
	    label: "Governo",
	    value: "GOVERNO"
	  }, {
	    id: "16",
	    label: "Hotelaria",
	    value: "HOTELARIA"
	  }, {
	    id: "17",
	    label: "Manufatura",
	    value: "MANUFATURA"
	  }, {
	    id: "18",
	    label: "Meio Ambiente",
	    value: "MEIO_AMBIENTE"
	  }, {
	    id: "19",
	    label: "Mídia",
	    value: "MIDIA"
	  }, {
	    id: "20",
	    label: "Produtos Químicos",
	    value: "PRODUTOS_QUIMICOS"
	  }, {
	    id: "21",
	    label: "Recreação",
	    value: "RECREACAO"
	  }, {
	    id: "22",
	    label: "Saúde",
	    value: "SAUDE"
	  }, {
	    id: "23",
	    label: "Seguros",
	    value: "SEGUROS"
	  }, {
	    id: "24",
	    label: "Sem fins lucrativos",
	    value: "SEM_FINS_LUCRATIVOS"
	  }, {
	    id: "25",
	    label: "Serviços bancários",
	    value: "SERVICOS_BANCARIOS"
	  }, {
	    id: "26",
	    label: "Serviços públicos",
	    value: "SERVICOS_PUBLICOS"
	  }, {
	    id: "27",
	    label: "Tecnologia",
	    value: "TECNOLOGIA"
	  }, {
	    id: "28",
	    label: "Telecomunicações",
	    value: "TELECOMUNICACOES"
	  }, {
	    id: "29",
	    label: "Transporte",
	    value: "TRANSPORTE"
	  }, {
	    id: "30",
	    label: "Outras",
	    value: "OUTRAS"
	  }];
	};
	
	function vehicle() {
	  return {
	    "plate": "",
	    "enabled": "",
	    "isTransportador": false,
	    "cpfCnpjTransportador": undefined,
	    "categoryAxes": {
	      "categoryAxesId": 1,
	      "name": "AUTOMÓVEIS"
	    },
	    "model": {
	      "modelId": "",
	      "name": "",
	      "brand": {
	        "brandId": "",
	        "name": ""
	      },
	      "categoryAxes": {
	        "categoryAxesId": "1",
	        "name": "2 eixos, rodagem simples"
	      }
	    }
	  };
	}
	
	function states() {
	  return [{
	    "id": "1",
	    "sigla": "AC",
	    "name": "Acre"
	  }, {
	    "id": "2",
	    "sigla": "AL",
	    "name": "Alagoas"
	  }, {
	    "id": "3",
	    "sigla": "AM",
	    "name": "Amazonas"
	  }, {
	    "id": "4",
	    "sigla": "AP",
	    "name": "Amapá"
	  }, {
	    "id": "5",
	    "sigla": "BA",
	    "name": "Bahia"
	  }, {
	    "id": "6",
	    "sigla": "CE",
	    "name": "Ceará"
	  }, {
	    "id": "7",
	    "sigla": "DF",
	    "name": "Distrito Federal"
	  }, {
	    "id": "8",
	    "sigla": "ES",
	    "name": "Espírito Santo"
	  }, {
	    "id": "9",
	    "sigla": "GO",
	    "name": "Goiás"
	  }, {
	    "id": "10",
	    "sigla": "MA",
	    "name": "Maranhão"
	  }, {
	    "id": "11",
	    "sigla": "MG",
	    "name": "Minas Gerais"
	  }, {
	    "id": "12",
	    "sigla": "MS",
	    "name": "Mato Grosso do Sul"
	  }, {
	    "id": "13",
	    "sigla": "MT",
	    "name": "Mato Grosso"
	  }, {
	    "id": "14",
	    "sigla": "PA",
	    "name": "Pará"
	  }, {
	    "id": "15",
	    "sigla": "PB",
	    "name": "Paraíba"
	  }, {
	    "id": "16",
	    "sigla": "PE",
	    "name": "Pernambuco"
	  }, {
	    "id": "17",
	    "sigla": "PI",
	    "name": "Piauí"
	  }, {
	    "id": "18",
	    "sigla": "PR",
	    "name": "Paraná"
	  }, {
	    "id": "19",
	    "sigla": "RJ",
	    "name": "Rio de Janeiro"
	  }, {
	    "id": "20",
	    "sigla": "RN",
	    "name": "Rio Grande do Norte"
	  }, {
	    "id": "21",
	    "sigla": "RO",
	    "name": "Rondônia"
	  }, {
	    "id": "22",
	    "sigla": "RR",
	    "name": "Roraima"
	  }, {
	    "id": "23",
	    "sigla": "RS",
	    "name": "Rio Grande do Sul"
	  }, {
	    "id": "24",
	    "sigla": "SC",
	    "name": "Santa Catarina"
	  }, {
	    "id": "25",
	    "sigla": "SE",
	    "name": "Sergipe"
	  }, {
	    "id": "26",
	    "sigla": "SP",
	    "name": "São Paulo"
	  }, {
	    "id": "27",
	    "sigla": "TO",
	    "name": "Tocantins"
	  }];
	};
	
	function companyAccount() {
	  return {
	    type: "2",
	    company: {},
	    accountAuthentication: {
	      "active": "Y"
	    },
	    "nroCellphone": "",
	    "dddCellphone": "",
	
	    "typePhone": "COMERCIAL",
	    "dddPhone": "",
	    "nroPhone": "",
	
	    "typePhone2": "COMERCIAL",
	    "dddPhone2": "",
	    "nroPhone2": ""
	  };
	}
	exports.account = account;
	exports.address = address;
	exports.contract = contract;
	exports.payment = payment;
	exports.businessActivity = businessActivity;
	exports.states = states;
	exports.companyAccount = companyAccount;
	exports.vehicle = vehicle;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(50);
	var IE8_DOM_DEFINE = __webpack_require__(259);
	var toPrimitive = __webpack_require__(194);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(41) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameUTCWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(109));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function isSameUTCWeek(dirtyDateLeft, dirtyDateRight, options) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfWeek = (0, _index.default)(dirtyDateLeft, options);
	  var dateRightStartOfWeek = (0, _index.default)(dirtyDateRight, options);
	  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1629)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(583),
	  /* template */
	  __webpack_require__(2168),
	  /* scopeId */
	  "data-v-73458ad8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(244);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(122);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(42);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValid;
	
	var _index = _interopRequireDefault(__webpack_require__(310));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isValid
	 * @category Common Helpers
	 * @summary Is the given date valid?
	 *
	 * @description
	 * Returns false if argument is Invalid Date and true otherwise.
	 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * Invalid Date is a Date, whose time value is NaN.
	 *
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - Now `isValid` doesn't throw an exception
	 *   if the first argument is not an instance of Date.
	 *   Instead, argument is converted beforehand using `toDate`.
	 *
	 *   Examples:
	 *
	 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
	 *   |---------------------------|---------------|---------------|
	 *   | `new Date()`              | `true`        | `true`        |
	 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
	 *   | `new Date('')`            | `false`       | `false`       |
	 *   | `new Date(1488370835081)` | `true`        | `true`        |
	 *   | `new Date(NaN)`           | `false`       | `false`       |
	 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
	 *   | `''`                      | `TypeError`   | `false`       |
	 *   | `1488370835081`           | `TypeError`   | `true`        |
	 *   | `NaN`                     | `TypeError`   | `false`       |
	 *
	 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
	 *   that try to coerce arguments to the expected type
	 *   (which is also the case with other *date-fns* functions).
	 *
	 * @param {*} date - the date to check
	 * @returns {Boolean} the date is valid
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // For the valid date:
	 * const result = isValid(new Date(2014, 1, 31))
	 * //=> true
	 *
	 * @example
	 * // For the value, convertable into a date:
	 * const result = isValid(1393804800000)
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * const result = isValid(new Date(''))
	 * //=> false
	 */
	function isValid(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	
	  if (!(0, _index.default)(dirtyDate) && typeof dirtyDate !== 'number') {
	    return false;
	  }
	
	  var date = (0, _index2.default)(dirtyDate);
	  return !isNaN(Number(date));
	}
	
	module.exports = exports.default;

/***/ }),
/* 52 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = {
	  dialog: undefined
	};
	
	exports.default = {
	  data: function data() {
	    return {
	      title: undefined,
	      message: undefined,
	      type: undefined,
	      headerClass: undefined,
	      resultCallback: undefined,
	      contract: undefined,
	      startDate: undefined,
	      endDate: undefined,
	      filter: undefined,
	      transactions: undefined,
	      urlBlank: undefined,
	      txtBlank: undefined,
	      colorTxtBlank: undefined,
	      showContactText: undefined
	    };
	  },
	  mounted: function mounted() {
	    store.dialog = this;
	  },
	
	  methods: {
	    result: function result(res) {
	      $(this.$el).modal('hide');
	      this.resultCallback(res);
	    },
	    close: function close() {
	      $('#messageDialog').modal('hide');
	    },
	    generateFileName: function generateFileName(ext, start, end) {
	      var startString = (0, _moment2.default)(start).format('DD-MM-YYYY');
	      var endString = (0, _moment2.default)(end).format('DD-MM-YYYY');
	      return 'extrato_' + startString + '_a_' + endString + '.' + ext;
	    }
	  },
	
	  computed: {
	    urlExcel: function urlExcel() {
	      var file = this.generateFileName('xls', store.dialog.startDate, store.dialog.endDate);
	
	      var url = '/api/v2/statement/excel/' + store.dialog.contract + '/' + store.dialog.startDate + '/' + store.dialog.endDate + '/' + file;
	      url = !store.dialog.filter ? url : url + ('/' + store.dialog.filter);
	      url = store.dialog.transactions ? url + '?transactions=' + store.dialog.transactions : url;
	      return { url: url, file: file };
	    },
	    urlPdf: function urlPdf() {
	      var file = this.generateFileName('pdf', store.dialog.startDate, store.dialog.endDate);
	      var url = '/api/v2/statement/pdf/' + store.dialog.contract + '/' + store.dialog.startDate + '/' + store.dialog.endDate + '/' + file;
	
	      url = !store.dialog.filter ? url : url + ('/' + store.dialog.filter);
	      url = store.dialog.transactions ? url + '?transactions=' + store.dialog.transactions : url;
	      return { url: url, file: file };
	    },
	    urlJson: function urlJson() {
	      var file = this.generateFileName('zip', store.dialog.startDate, store.dialog.endDate);
	      var url = '/api/v2/statement/json/' + store.dialog.contract + '/' + store.dialog.startDate + '/' + store.dialog.endDate + '/' + file;
	
	      url = !store.dialog.filter ? url : url + ('/' + store.dialog.filter);
	      url = store.dialog.transactions ? url + '?transactions=' + store.dialog.transactions : url;
	      return { url: url, file: file };
	    }
	  },
	  show: function show(options) {
	
	    if (options.statement) {
	      store.dialog.contract = options.statement.contract;
	      store.dialog.startDate = options.statement.startDate;
	      store.dialog.endDate = options.statement.endDate;
	      store.dialog.filter = options.statement.filter;
	      store.dialog.transactions = options.statement.transactions;
	    }
	
	    return new _promise2.default(function (resolve, reject) {
	      store.dialog.title = options.title || '';
	      store.dialog.headerClass = options.headerClass || 'modal-info';
	      store.dialog.message = options.message || '';
	      store.dialog.type = options.type || 'OK';
	      store.dialog.txtBlank = options.txtBlank || '';
	      store.dialog.urlBlank = options.urlBlank || '';
	      store.dialog.colorTxtBlank = options.colorTxtBlank || '#000000';
	      store.dialog.showContactText = options.showContactText;
	      store.dialog.resultCallback = resolve;
	      $(store.dialog.$el).modal('show');
	    });
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(28);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _extends2 = __webpack_require__(49);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getIterator2 = __webpack_require__(69);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createPendingRedirectPromise() {
	  return new _promise2.default(function () {});
	}
	
	function extractSalesToken(payload) {
	  if (!payload || (typeof payload === 'undefined' ? 'undefined' : (0, _typeof3.default)(payload)) !== 'object') {
	    return undefined;
	  }
	
	  if (payload.salesToken) {
	    return payload.salesToken;
	  }
	
	  if (payload.order && payload.order.salesToken) {
	    return payload.order.salesToken;
	  }
	
	  if (payload.salesOrder && payload.salesOrder.salesToken) {
	    return payload.salesOrder.salesToken;
	  }
	
	  return undefined;
	}
	
	function extractStatusCode(payload) {
	  if (!payload || (typeof payload === 'undefined' ? 'undefined' : (0, _typeof3.default)(payload)) !== 'object') {
	    return undefined;
	  }
	
	  var statusCandidates = [payload.status, payload.order && payload.order.status, payload.salesOrder && payload.salesOrder.status];
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = (0, _getIterator3.default)(statusCandidates), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var status = _step.value;
	
	      if (typeof status === 'number') {
	        return status;
	      }
	
	      if (status && (typeof status === 'undefined' ? 'undefined' : (0, _typeof3.default)(status)) === 'object' && typeof status.code === 'number') {
	        return status.code;
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return undefined;
	}
	
	function shouldRedirectToCheckout(payload, salesToken) {
	  if (!salesToken) {
	    return false;
	  }
	
	  var statusCode = extractStatusCode(payload);
	  return statusCode === undefined || statusCode === 0;
	}
	
	function normalizeReprocessRequest(orderRequest) {
	  if (!orderRequest || (typeof orderRequest === 'undefined' ? 'undefined' : (0, _typeof3.default)(orderRequest)) !== 'object') {
	    return orderRequest;
	  }
	
	  var payload = (0, _extends3.default)({}, orderRequest);
	
	  if (payload.salesOrderId === undefined && payload.orderId !== undefined) {
	    payload.salesOrderId = payload.orderId;
	  }
	
	  if (payload.orderId === undefined && payload.salesOrderId !== undefined) {
	    payload.orderId = payload.salesOrderId;
	  }
	
	  return payload;
	}
	
	var Financial = function () {
	  function Financial() {
	    (0, _classCallCheck3.default)(this, Financial);
	  }
	
	  (0, _createClass3.default)(Financial, [{
	    key: 'reprocessPayout',
	    value: function reprocessPayout(orderRequest) {
	      var payload = normalizeReprocessRequest(orderRequest);
	      return _axios2.default.post('/v2/financial/reprocessPayout', payload).then(function (res) {
	        var salesToken = extractSalesToken(res.data);
	        if (shouldRedirectToCheckout(res.data, salesToken) && _sales2.default.redirectToCheckout(salesToken)) {
	          return createPendingRedirectPromise();
	        }
	
	        if (res.data.url) {
	          var redirectUrl = res.data.url.substring(1, res.data.url.length - 1);
	          window.location.assign(redirectUrl);
	          return createPendingRedirectPromise();
	        }
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getNovasTaxas',
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _axios2.default.get('/v2/financial/getPlansTaxes');
	
	              case 2:
	                return _context.abrupt('return', _context.sent);
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function getNovasTaxas() {
	        return _ref.apply(this, arguments);
	      }
	
	      return getNovasTaxas;
	    }()
	  }, {
	    key: 'getMeiosDePagamentoAdesao',
	    value: function () {
	      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(planId) {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return _axios2.default.get('/v2/paymentMethodsByPlan/' + planId);
	
	              case 2:
	                return _context2.abrupt('return', _context2.sent);
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function getMeiosDePagamentoAdesao(_x) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return getMeiosDePagamentoAdesao;
	    }()
	  }, {
	    key: 'getPaymentMethodUnauthorized',
	    value: function () {
	      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(taxIdNumber) {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return _axios2.default.get('/v2/payment-method-unauthorized/getPaymentMethodUnauthorized/' + taxIdNumber);
	
	              case 2:
	                return _context3.abrupt('return', _context3.sent);
	
	              case 3:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function getPaymentMethodUnauthorized(_x2) {
	        return _ref3.apply(this, arguments);
	      }
	
	      return getPaymentMethodUnauthorized;
	    }()
	  }]);
	  return Financial;
	}();
	
	var instance = new Financial();
	exports.default = instance;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(28);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function emptyTagReservaCtx() {
	  return {
	    elegivel: false,
	    cnpjPossuiEstoque: false,
	    saldoLiquido: 0,
	    saldoContratual: 0,
	    contractIds: [],
	    saldoContratualByContract: {},
	    saldoLiquidoByContract: {},
	    isEligibleForContract: function isEligibleForContract() {
	      return false;
	    }
	  };
	}
	
	var TagService = function () {
	  function TagService() {
	    (0, _classCallCheck3.default)(this, TagService);
	  }
	
	  (0, _createClass3.default)(TagService, [{
	    key: 'activateTag',
	    value: function activateTag(serialNumber, vehicleId) {
	      return _axios2.default.post('/v1/activateTag', { serialNumber: serialNumber, vehicleId: vehicleId }).then(function (r) {
	        return r.data;
	      });
	    }
	  }, {
	    key: 'activateTagGeneral',
	    value: function activateTagGeneral(filter) {
	      return _axios2.default.post('/v2/activateTagGeneral', filter).then(function (r) {
	        return r.data;
	      });
	    }
	  }, {
	    key: 'activateTagSite',
	    value: function activateTagSite(req) {
	      return _axios2.default.post('/v2/tag/activateTagSite', req).then(function (r) {
	        return r.data;
	      });
	    }
	  }, {
	    key: 'blockTagTemp',
	    value: function blockTagTemp(serialNumber, reason) {
	      return _axios2.default.post('/v2/blockTag', { serialNumber: serialNumber, reasonId: 8, reasonDescription: reason });
	    }
	  }, {
	    key: 'unblockTag',
	    value: function unblockTag(serialNumber, contractId, reason) {
	      return _axios2.default.post('/v2/unblockTag', { serialNumber: serialNumber, contractId: contractId });
	    }
	  }, {
	    key: 'hasStockTagReserva',
	    value: function hasStockTagReserva(contractId) {
	      return _axios2.default.get('/v2/verificarDisponibilidadeTagReserva/' + contractId).then(function (r) {
	        return r.data;
	      });
	    }
	  }, {
	    key: 'getSaldoTagReservaByMoveMaisId',
	    value: function getSaldoTagReservaByMoveMaisId(moveMaisId) {
	      return _axios2.default.get('/v2/getSaldoTagReservaByMoveMaisId/' + moveMaisId).then(function (r) {
	        return r.data && r.data.saldos ? r.data.saldos : [];
	      }).catch(function () {
	        return [];
	      });
	    }
	  }, {
	    key: 'getTagReservaContexto',
	    value: function getTagReservaContexto() {
	      var cnpj = _auth2.default.currentUser && _auth2.default.currentUser.taxIdNumber;
	      var moveMaisId = _auth2.default.currentUser && _auth2.default.currentUser.moveMaisId;
	      if (!cnpj || !moveMaisId) return _promise2.default.resolve(emptyTagReservaCtx());
	
	      return this.getSaldoTagReservaByMoveMaisId(moveMaisId).then(function (saldos) {
	        var entrada = (saldos || []).find(function (s) {
	          return s && s.cnpj === cnpj;
	        });
	        if (!entrada) return emptyTagReservaCtx();
	
	        var contractIds = entrada.contractIds || [];
	        var contractIdsStr = contractIds.map(function (c) {
	          return String(c);
	        });
	        var saldoContratual = Math.max(0, entrada.saldoContratualDisponivel != null ? entrada.saldoContratualDisponivel : 0);
	        var saldoLiquido = Math.max(0, entrada.saldoDisponivelLiquido != null ? entrada.saldoDisponivelLiquido : 0);
	        var saldoContratualByContract = {};
	        var saldoLiquidoByContract = {};
	        contractIds.forEach(function (cid) {
	          saldoContratualByContract[cid] = saldoContratual;
	          saldoLiquidoByContract[cid] = saldoLiquido;
	        });
	
	        return {
	          elegivel: contractIds.length > 0,
	          cnpjPossuiEstoque: true,
	          saldoLiquido: saldoLiquido,
	          saldoContratual: saldoContratual,
	          contractIds: contractIds,
	          saldoContratualByContract: saldoContratualByContract,
	          saldoLiquidoByContract: saldoLiquidoByContract,
	          isEligibleForContract: function isEligibleForContract(cid) {
	            return cid != null && contractIdsStr.indexOf(String(cid)) !== -1;
	          }
	        };
	      }).catch(function () {
	        return emptyTagReservaCtx();
	      });
	    }
	  }, {
	    key: 'ativarTagEmMaos',
	    value: function ativarTagEmMaos(payload) {
	      return _axios2.default.post('/v2/ativarTagEmMaos', payload).then(function (r) {
	        return r.data;
	      });
	    }
	  }, {
	    key: 'replaceTagAggregate',
	    value: function replaceTagAggregate(filter) {
	      return _axios2.default.post('/v2/tag/replaceTagAggregate', filter).then(function (res) {
	        if (res.data.response == 1) {
	          res.data.status.message = 'Veículo não encontrado';
	        } else if (res.data.response == 2) {
	          res.data.status.message = 'Contrato agregador não encontrado';
	        } else if (res.data.response == 3) {
	          res.data.status.message = 'Forma de pagamento não encontrada para o contrato';
	        } else if (res.data.response == 4) {
	          res.data.status.message = 'Tag não disponível no estoque correto';
	        } else if (res.data.response == 5) {
	          res.data.status.message = 'Erro ao inserir pedido';
	        } else if (res.data.response == 6) {
	          res.data.status.message = 'Erro ao inserir detalhes do pedido';
	        } else if (res.data.response == 7) {
	          res.data.status.message = 'Erro ao inserir envio do pedido';
	        } else if (res.data.response == 8) {
	          res.data.status.message = 'Erro ao vincular veículo ao pedido';
	        } else if (res.data.response == 9) {
	          res.data.status.message = 'Erro ao vincular tag ao pedido';
	        } else if (res.data.response == 10) {
	          res.data.status.message = 'Erro ao chamar a ativação da tag';
	        } else if (res.data.response == 11) {
	          res.data.status.message = 'Erro na ativação da tag';
	        }
	
	        return res.data;
	      });
	    }
	  }]);
	  return TagService;
	}();
	
	var instance = new TagService();
	exports.default = instance;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(100);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 57 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTimezoneOffsetInMilliseconds;
	
	/**
	 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
	 * They usually appear for dates that denote time before the timezones were introduced
	 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
	 * and GMT+01:00:00 after that date)
	 *
	 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
	 * which would lead to incorrect calculations.
	 *
	 * This function returns the timezone offset in milliseconds that takes seconds in account.
	 */
	function getTimezoneOffsetInMilliseconds(date) {
	  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
	  utcDate.setUTCFullYear(date.getFullYear());
	  return date.getTime() - utcDate.getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addDays;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addDays
	 * @category Day Helpers
	 * @summary Add the specified number of days to the given date.
	 *
	 * @description
	 * Add the specified number of days to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} - the new date with the days added
	 * @throws {TypeError} - 2 arguments required
	 *
	 * @example
	 * // Add 10 days to 1 September 2014:
	 * const result = addDays(new Date(2014, 8, 1), 10)
	 * //=> Thu Sep 11 2014 00:00:00
	 */
	function addDays(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var amount = (0, _index.default)(dirtyAmount);
	
	  if (isNaN(amount)) {
	    return new Date(NaN);
	  }
	
	  if (!amount) {
	    // If 0 days, no-op to avoid changing times in the hour before end of DST
	    return date;
	  }
	
	  date.setDate(date.getDate() + amount);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(28);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RouteService = function () {
	  function RouteService() {
	    (0, _classCallCheck3.default)(this, RouteService);
	  }
	
	  (0, _createClass3.default)(RouteService, [{
	    key: 'createRoute',
	    value: function createRoute(req) {
	      return _axios2.default.post('/v2/vp/createRoute', req).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getRoute',
	    value: function getRoute() {
	      var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	      var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	      return _axios2.default.get('/v2/vp/getRoute/' + (status ? 1 : 2) + '?search=' + search).then(function (res) {
	        return res.data.routes;
	      });
	    }
	  }]);
	  return RouteService;
	}();
	
	var instance = new RouteService();
	exports.default = instance;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.beforeOneYear = undefined;
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function beforeOneYearVal(value) {
	  if (!value || value.length != 10) return true;
	
	  return (0, _moment2.default)(value, "DD-MM-YYYY").add(1, 'y').isSameOrBefore((0, _moment2.default)());
	}
	
	var beforeOneYear = exports.beforeOneYear = {
	  messages: {
	    en: function en(field, args) {
	      return "Data não pode ser inferior a um ano";
	    },
	    'pt-BR': function ptBR(field, args) {
	      return "Data não pode ser inferior a um ano";
	    }
	  },
	  validate: function validate(value, args) {
	    return beforeOneYearVal(value, args);
	  }
	};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(775);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(774);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(45);
	var createDesc = __webpack_require__(105);
	module.exports = __webpack_require__(41) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(185);
	var defined = __webpack_require__(182);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextDay;
	
	var _index = _interopRequireDefault(__webpack_require__(58));
	
	var _index2 = _interopRequireDefault(__webpack_require__(137));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name nextDay
	 * @category Weekday Helpers
	 * @summary When is the next day of the week?
	 *
	 * @description
	 * When is the next day of the week? 0-6 the day of the week, 0 represents Sunday.
	 *
	 * @param {Date | number} date - the date to check
	 * @param {Day} day - day of the week
	 * @returns {Date} - the date is the next day of week
	 * @throws {TypeError} - 2 arguments required
	 *
	 * @example
	 * // When is the next Monday after Mar, 20, 2020?
	 * const result = nextDay(new Date(2020, 2, 20), 1)
	 * //=> Mon Mar 23 2020 00:00:00
	 *
	 * @example
	 * // When is the next Tuesday after Mar, 21, 2020?
	 * const result = nextDay(new Date(2020, 2, 21), 2)
	 * //=> Tue Mar 24 2020 00:00:00
	 */
	function nextDay(date, day) {
	  (0, _index3.default)(2, arguments);
	  var delta = day - (0, _index2.default)(date);
	  if (delta <= 0) delta += 7;
	  return (0, _index.default)(date, delta);
	}
	
	module.exports = exports.default;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousDay;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = _interopRequireDefault(__webpack_require__(137));
	
	var _index3 = _interopRequireDefault(__webpack_require__(141));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name previousDay
	 * @category Weekday Helpers
	 * @summary When is the previous day of the week?
	 *
	 * @description
	 * When is the previous day of the week? 0-6 the day of the week, 0 represents Sunday.
	 *
	 * @param {Date | number} date - the date to check
	 * @param {number} day - day of the week
	 * @returns {Date} - the date is the previous day of week
	 * @throws {TypeError} - 2 arguments required
	 *
	 * @example
	 * // When is the previous Monday before Mar, 20, 2020?
	 * const result = previousDay(new Date(2020, 2, 20), 1)
	 * //=> Mon Mar 16 2020 00:00:00
	 *
	 * @example
	 * // When is the previous Tuesday before Mar, 21, 2020?
	 * const result = previousDay(new Date(2020, 2, 21), 2)
	 * //=> Tue Mar 17 2020 00:00:00
	 */
	function previousDay(date, day) {
	  (0, _index.default)(2, arguments);
	  var delta = (0, _index2.default)(date) - day;
	  if (delta <= 0) delta += 7;
	  return (0, _index3.default)(date, delta);
	}
	
	module.exports = exports.default;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(10));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfWeek
	 * @category Week Helpers
	 * @summary Return the start of a week for the given date.
	 *
	 * @description
	 * Return the start of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the start of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The start of a week for 2 September 2014 11:55:00:
	 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
	 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfWeek(dirtyDate, dirtyOptions) {
	  (0, _index3.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index2.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index2.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setDate(date.getDate() - diff);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1572)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(582),
	  /* template */
	  __webpack_require__(2107),
	  /* scopeId */
	  "data-v-3fa3674e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(28);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Param = function () {
	  function Param() {
	    (0, _classCallCheck3.default)(this, Param);
	  }
	
	  (0, _createClass3.default)(Param, [{
	    key: 'getParm',
	    value: function getParm() {
	      return _axios2.default.get('/v1/getParams');
	    }
	  }, {
	    key: 'getGeneralParameter',
	    value: function getGeneralParameter(req) {
	      return _axios2.default.post('/v2/getGeneralParameter', req).then(function (res) {
	        return res.data;
	      });
	    }
	  }]);
	  return Param;
	}();
	
	var instance = new Param();
	exports.default = instance;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(788), __esModule: true };

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(790), __esModule: true };

/***/ }),
/* 71 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(182);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(826)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(186)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = compareAsc;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name compareAsc
	 * @category Common Helpers
	 * @summary Compare the two dates and return -1, 0 or 1.
	 *
	 * @description
	 * Compare the two dates and return 1 if the first date is after the second,
	 * -1 if the first date is before the second or 0 if dates are equal.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to compare
	 * @param {Date|Number} dateRight - the second date to compare
	 * @returns {Number} the result of the comparison
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Compare 11 February 1987 and 10 July 1989:
	 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
	 * //=> -1
	 *
	 * @example
	 * // Sort the array of dates:
	 * const result = [
	 *   new Date(1995, 6, 2),
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * ].sort(compareAsc)
	 * //=> [
	 * //   Wed Feb 11 1987 00:00:00,
	 * //   Mon Jul 10 1989 00:00:00,
	 * //   Sun Jul 02 1995 00:00:00
	 * // ]
	 */
	function compareAsc(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var diff = dateLeft.getTime() - dateRight.getTime();
	
	  if (diff < 0) {
	    return -1;
	  } else if (diff > 0) {
	    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
	  } else {
	    return diff;
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarDays;
	
	var _index = _interopRequireDefault(__webpack_require__(57));
	
	var _index2 = _interopRequireDefault(__webpack_require__(139));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_DAY = 86400000;
	/**
	 * @name differenceInCalendarDays
	 * @category Day Helpers
	 * @summary Get the number of calendar days between the given dates.
	 *
	 * @description
	 * Get the number of calendar days between the given dates. This means that the times are removed
	 * from the dates and then the difference in days is calculated.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar days
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * const result = differenceInCalendarDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 366
	 * // How many calendar days are between
	 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
	 * const result = differenceInCalendarDays(
	 *   new Date(2011, 6, 3, 0, 1),
	 *   new Date(2011, 6, 2, 23, 59)
	 * )
	 * //=> 1
	 */
	
	function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var startOfDayLeft = (0, _index2.default)(dirtyDateLeft);
	  var startOfDayRight = (0, _index2.default)(dirtyDateRight);
	  var timestampLeft = startOfDayLeft.getTime() - (0, _index.default)(startOfDayLeft);
	  var timestampRight = startOfDayRight.getTime() - (0, _index.default)(startOfDayRight); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a day is not constant
	  // (e.g. it's different in the day of the daylight saving time clock shift)
	
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
	}
	
	module.exports = exports.default;

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "'last' eeee 'at' p",
	  yesterday: "'yesterday at' p",
	  today: "'today at' p",
	  tomorrow: "'tomorrow at' p",
	  nextWeek: "eeee 'at' p",
	  other: 'P'
	};
	
	var formatRelative = function (token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['B', 'A'],
	  abbreviated: ['BC', 'AD'],
	  wide: ['Before Christ', 'Anno Domini']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
	}; // Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	};
	var dayValues = {
	  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
	  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mi',
	    noon: 'n',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mi',
	    noon: 'n',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber, _options) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`.
	  //
	  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'.
	
	  var rem100 = number % 100;
	
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + 'st';
	
	      case 2:
	        return number + 'nd';
	
	      case 3:
	        return number + 'rd';
	    }
	  }
	
	  return number + 'th';
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(8));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(b|a)/i,
	  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
	  wide: /^(before christ|before common era|anno domini|common era)/i
	};
	var parseEraPatterns = {
	  any: [/^b/i, /^(a|c)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](th|st|nd|rd)? quarter/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
	  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smtwf]/i,
	  short: /^(su|mo|tu|we|th|fr|sa)/i,
	  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
	  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
	  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
	  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mi/i,
	    noon: /^no/i,
	    morning: /morning/i,
	    afternoon: /afternoon/i,
	    evening: /evening/i,
	    night: /night/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(92));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1069));
	
	var _index3 = _interopRequireDefault(__webpack_require__(77));
	
	var _index4 = _interopRequireDefault(__webpack_require__(78));
	
	var _index5 = _interopRequireDefault(__webpack_require__(79));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (United States).
	 * @language English
	 * @iso-639-2 eng
	 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
	 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
	 */
	var locale = {
	  code: 'en-US',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(66));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfISOWeek
	 * @category ISO Week Helpers
	 * @summary Return the start of an ISO week for the given date.
	 *
	 * @description
	 * Return the start of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of an ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of an ISO week for 2 September 2014 11:55:00:
	 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, {
	    weekStartsOn: 1
	  });
	}
	
	module.exports = exports.default;

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(144);
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(107));
	util.inherits = __webpack_require__(52);
	/*</replacement>*/
	
	var Readable = __webpack_require__(482);
	var Writable = __webpack_require__(219);
	
	util.inherits(Duplex, Readable);
	
	{
	  // avoid scope creep, the keys array can then be collected
	  var keys = objectKeys(Writable.prototype);
	  for (var v = 0; v < keys.length; v++) {
	    var method = keys[v];
	    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	  }
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  pna.nextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  pna.nextTick(cb, err);
	};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1521)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(581),
	  /* template */
	  __webpack_require__(2053),
	  /* scopeId */
	  "data-v-17da348e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1543)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(726),
	  /* template */
	  __webpack_require__(2076),
	  /* scopeId */
	  "data-v-280f5c75",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cpfCnpj = exports.cnpj = exports.cpf = undefined;
	
	var _toConsumableArray2 = __webpack_require__(99);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _from = __webpack_require__(173);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validateCNPJAlfanumero(cnpj) {
	  var s = String(cnpj).replace(/[.\-\/]/g, '').toUpperCase();
	
	  if (s.length !== 14) return false;
	  if (/^(.)\1+$/.test(s)) return false;
	  if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(s)) return false;
	
	  var v = (0, _from2.default)(s.slice(0, 12), function (c) {
	    return c.charCodeAt(0) - 48;
	  });
	
	  var w1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
	  var r1 = v.reduce(function (sum, n, i) {
	    return sum + n * w1[i];
	  }, 0) % 11;
	  var dv1 = r1 < 2 ? 0 : 11 - r1;
	
	  var w2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
	  var r2 = [].concat((0, _toConsumableArray3.default)(v), [dv1]).reduce(function (sum, n, i) {
	    return sum + n * w2[i];
	  }, 0) % 11;
	  var dv2 = r2 < 2 ? 0 : 11 - r2;
	
	  return s[12] === String(dv1) && s[13] === String(dv2);
	}
	
	function validarCPF(cpf) {
	  cpf = cpf.replace(/\./g, '');
	  cpf = cpf.replace(/-/g, '');
	
	  var i;
	  var s = cpf;
	  var c = s.substr(0, 9);
	  var dv = s.substr(9, 2);
	  var d1 = 0;
	
	  if (cpf.length != 11 || cpf == "00000000000" || cpf == "11111111111" || cpf == "22222222222" || cpf == "33333333333" || cpf == "44444444444" || cpf == "55555555555" || cpf == "66666666666" || cpf == "77777777777" || cpf == "88888888888" || cpf == "99999999999") {
	    return false;
	  }
	
	  for (i = 0; i < 9; i++) {
	    d1 += c.charAt(i) * (10 - i);
	  }
	
	  if (d1 == 0) {
	    return false;
	  }
	
	  d1 = 11 - d1 % 11;
	  if (d1 > 9) {
	    d1 = 0;
	  }
	
	  if (dv.charAt(0) != d1) {
	    return false;
	  }
	
	  d1 *= 2;
	  for (i = 0; i < 9; i++) {
	    d1 += c.charAt(i) * (11 - i);
	  }
	
	  d1 = 11 - d1 % 11;
	  if (d1 > 9) {
	    d1 = 0;
	  }
	
	  if (dv.charAt(1) != d1) {
	    return false;
	  }
	
	  return true;
	};
	
	var cpf = exports.cpf = {
	  messages: {
	    en: function en(field, args) {
	      return "CPF inválido.";
	    },
	    'pt-BR': function ptBR(field, args) {
	      return "CPF inválido.";
	    }
	  },
	
	  validate: function validate(value) {
	    return validarCPF(value);
	  }
	};
	
	var cnpj = exports.cnpj = {
	  messages: {
	    en: function en(field, args) {
	      return "CNPJ inválido.";
	    },
	    'pt-BR': function ptBR(field, args) {
	      return "CNPJ inválido.";
	    }
	  },
	
	  validate: function validate(value) {
	    return validateCNPJAlfanumero(value);
	  }
	};
	
	var cpfCnpj = exports.cpfCnpj = {
	  messages: {
	    en: function en(field, args) {
	      return "CPF/CNPJ inválido.";
	    },
	    'pt-BR': function ptBR(field, args) {
	      return "CPF/CNPJ inválido.";
	    }
	  },
	  validate: function validate(value) {
	    return validateCNPJAlfanumero(value) || validarCPF(value);
	  }
	};

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(267);
	var enumBugKeys = __webpack_require__(184);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(832);
	var global = __webpack_require__(36);
	var hide = __webpack_require__(62);
	var Iterators = __webpack_require__(87);
	var TO_STRING_TAG = __webpack_require__(37)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 90 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addLeadingZeros;
	
	function addLeadingZeros(number, targetLength) {
	  var sign = number < 0 ? '-' : '';
	  var output = Math.abs(number).toString();
	
	  while (output.length < targetLength) {
	    output = '0' + output;
	  }
	
	  return sign + output;
	}
	
	module.exports = exports.default;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(81));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the ISO week-numbering year of the given date.
	 *
	 * @description
	 * Get the ISO week-numbering year of the given date,
	 * which always starts 3 days before the year's first Thursday.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `getISOYear` to `getISOWeekYear`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which ISO-week numbering year is 2 January 2005?
	 * const result = getISOWeekYear(new Date(2005, 0, 2))
	 * //=> 2004
	 */
	function getISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index2.default)(fourthOfJanuaryOfNextYear);
	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index2.default)(fourthOfJanuaryOfThisYear);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'less than a second',
	    other: 'less than {{count}} seconds'
	  },
	  xSeconds: {
	    one: '1 second',
	    other: '{{count}} seconds'
	  },
	  halfAMinute: 'half a minute',
	  lessThanXMinutes: {
	    one: 'less than a minute',
	    other: 'less than {{count}} minutes'
	  },
	  xMinutes: {
	    one: '1 minute',
	    other: '{{count}} minutes'
	  },
	  aboutXHours: {
	    one: 'about 1 hour',
	    other: 'about {{count}} hours'
	  },
	  xHours: {
	    one: '1 hour',
	    other: '{{count}} hours'
	  },
	  xDays: {
	    one: '1 day',
	    other: '{{count}} days'
	  },
	  aboutXWeeks: {
	    one: 'about 1 week',
	    other: 'about {{count}} weeks'
	  },
	  xWeeks: {
	    one: '1 week',
	    other: '{{count}} weeks'
	  },
	  aboutXMonths: {
	    one: 'about 1 month',
	    other: 'about {{count}} months'
	  },
	  xMonths: {
	    one: '1 month',
	    other: '{{count}} months'
	  },
	  aboutXYears: {
	    one: 'about 1 year',
	    other: 'about {{count}} years'
	  },
	  xYears: {
	    one: '1 year',
	    other: '{{count}} years'
	  },
	  overXYears: {
	    one: 'over 1 year',
	    other: 'over {{count}} years'
	  },
	  almostXYears: {
	    one: 'almost 1 year',
	    other: 'almost {{count}} years'
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  var result;
	  var tokenValue = formatDistanceLocale[token];
	
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    result = tokenValue.one;
	  } else {
	    result = tokenValue.other.replace('{{count}}', count.toString());
	  }
	
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'in ' + result;
	    } else {
	      return result + ' ago';
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	
		if (root === null) {
			throw new Error('Google-maps package can be used only in browser');
		}
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			module.exports = factory();
		} else {
			root.GoogleMapsLoader = factory();
		}
	
	})(typeof window !== 'undefined' ? window : null, function() {
	
	
		'use strict';
	
	
		var googleVersion = '3.31';
	
		var script = null;
	
		var google = null;
	
		var loading = false;
	
		var callbacks = [];
	
		var onLoadEvents = [];
	
		var originalCreateLoaderMethod = null;
	
	
		var GoogleMapsLoader = {};
	
	
		GoogleMapsLoader.URL = 'https://maps.googleapis.com/maps/api/js';
	
		GoogleMapsLoader.KEY = null;
	
		GoogleMapsLoader.LIBRARIES = [];
	
		GoogleMapsLoader.CLIENT = null;
	
		GoogleMapsLoader.CHANNEL = null;
	
		GoogleMapsLoader.LANGUAGE = null;
	
		GoogleMapsLoader.REGION = null;
	
		GoogleMapsLoader.VERSION = googleVersion;
	
		GoogleMapsLoader.WINDOW_CALLBACK_NAME = '__google_maps_api_provider_initializator__';
	
	
		GoogleMapsLoader._googleMockApiObject = {};
	
	
		GoogleMapsLoader.load = function(fn) {
			if (google === null) {
				if (loading === true) {
					if (fn) {
						callbacks.push(fn);
					}
				} else {
					loading = true;
	
					window[GoogleMapsLoader.WINDOW_CALLBACK_NAME] = function() {
						ready(fn);
					};
	
					GoogleMapsLoader.createLoader();
				}
			} else if (fn) {
				fn(google);
			}
		};
	
	
		GoogleMapsLoader.createLoader = function() {
			script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = GoogleMapsLoader.createUrl();
	
			document.body.appendChild(script);
		};
	
	
		GoogleMapsLoader.isLoaded = function() {
			return google !== null;
		};
	
	
		GoogleMapsLoader.createUrl = function() {
			var url = GoogleMapsLoader.URL;
	
			url += '?callback=' + GoogleMapsLoader.WINDOW_CALLBACK_NAME;
	
			if (GoogleMapsLoader.KEY) {
				url += '&key=' + GoogleMapsLoader.KEY;
			}
	
			if (GoogleMapsLoader.LIBRARIES.length > 0) {
				url += '&libraries=' + GoogleMapsLoader.LIBRARIES.join(',');
			}
	
			if (GoogleMapsLoader.CLIENT) {
				url += '&client=' + GoogleMapsLoader.CLIENT;
			}
	
			if (GoogleMapsLoader.CHANNEL) {
				url += '&channel=' + GoogleMapsLoader.CHANNEL;
			}
	
			if (GoogleMapsLoader.LANGUAGE) {
				url += '&language=' + GoogleMapsLoader.LANGUAGE;
			}
	
			if (GoogleMapsLoader.REGION) {
				url += '&region=' + GoogleMapsLoader.REGION;
			}
	
			if (GoogleMapsLoader.VERSION) {
				url += '&v=' + GoogleMapsLoader.VERSION;
			}
	
			return url;
		};
	
	
		GoogleMapsLoader.release = function(fn) {
			var release = function() {
				GoogleMapsLoader.KEY = null;
				GoogleMapsLoader.LIBRARIES = [];
				GoogleMapsLoader.CLIENT = null;
				GoogleMapsLoader.CHANNEL = null;
				GoogleMapsLoader.LANGUAGE = null;
				GoogleMapsLoader.REGION = null;
				GoogleMapsLoader.VERSION = googleVersion;
	
				google = null;
				loading = false;
				callbacks = [];
				onLoadEvents = [];
	
				if (typeof window.google !== 'undefined') {
					delete window.google;
				}
	
				if (typeof window[GoogleMapsLoader.WINDOW_CALLBACK_NAME] !== 'undefined') {
					delete window[GoogleMapsLoader.WINDOW_CALLBACK_NAME];
				}
	
				if (originalCreateLoaderMethod !== null) {
					GoogleMapsLoader.createLoader = originalCreateLoaderMethod;
					originalCreateLoaderMethod = null;
				}
	
				if (script !== null) {
					script.parentElement.removeChild(script);
					script = null;
				}
	
				if (fn) {
					fn();
				}
			};
	
			if (loading) {
				GoogleMapsLoader.load(function() {
					release();
				});
			} else {
				release();
			}
		};
	
	
		GoogleMapsLoader.onLoad = function(fn) {
			onLoadEvents.push(fn);
		};
	
	
		GoogleMapsLoader.makeMock = function() {
			originalCreateLoaderMethod = GoogleMapsLoader.createLoader;
	
			GoogleMapsLoader.createLoader = function() {
				window.google = GoogleMapsLoader._googleMockApiObject;
				window[GoogleMapsLoader.WINDOW_CALLBACK_NAME]();
			};
		};
	
	
		var ready = function(fn) {
			var i;
	
			loading = false;
	
			if (google === null) {
				google = window.google;
			}
	
			for (i = 0; i < onLoadEvents.length; i++) {
				onLoadEvents[i](google);
			}
	
			if (fn) {
				fn(google);
			}
	
			for (i = 0; i < callbacks.length; i++) {
				callbacks[i](google);
			}
	
			callbacks = [];
		};
	
	
		return GoogleMapsLoader;
	
	});


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	var invariant = __webpack_require__(150);
	
	// http://en.wikipedia.org/wiki/Even%E2%80%93odd_rule
	// modified from: https://github.com/substack/point-in-polygon/blob/master/index.js
	// which was modified from http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html
	
	/**
	 * Takes a {@link Point} and a {@link Polygon} or {@link MultiPolygon} and determines if the point resides inside the polygon. The polygon can
	 * be convex or concave. The function accounts for holes.
	 *
	 * @name inside
	 * @param {Feature<Point>} point input point
	 * @param {Feature<(Polygon|MultiPolygon)>} polygon input polygon or multipolygon
	 * @return {Boolean} `true` if the Point is inside the Polygon; `false` if the Point is not inside the Polygon
	 * @example
	 * var pt1 = {
	 *   "type": "Feature",
	 *   "properties": {
	 *     "marker-color": "#f00"
	 *   },
	 *   "geometry": {
	 *     "type": "Point",
	 *     "coordinates": [-111.467285, 40.75766]
	 *   }
	 * };
	 * var pt2 = {
	 *   "type": "Feature",
	 *   "properties": {
	 *     "marker-color": "#0f0"
	 *   },
	 *   "geometry": {
	 *     "type": "Point",
	 *     "coordinates": [-111.873779, 40.647303]
	 *   }
	 * };
	 * var poly = {
	 *   "type": "Feature",
	 *   "properties": {},
	 *   "geometry": {
	 *     "type": "Polygon",
	 *     "coordinates": [[
	 *       [-112.074279, 40.52215],
	 *       [-112.074279, 40.853293],
	 *       [-111.610107, 40.853293],
	 *       [-111.610107, 40.52215],
	 *       [-112.074279, 40.52215]
	 *     ]]
	 *   }
	 * };
	 *
	 * var features = {
	 *   "type": "FeatureCollection",
	 *   "features": [pt1, pt2, poly]
	 * };
	 *
	 * //=features
	 *
	 * var isInside1 = turf.inside(pt1, poly);
	 * //=isInside1
	 *
	 * var isInside2 = turf.inside(pt2, poly);
	 * //=isInside2
	 */
	module.exports = function input(point, polygon) {
	    var pt = invariant.getCoord(point);
	    var polys = polygon.geometry.coordinates;
	    // normalize to multipolygon
	    if (polygon.geometry.type === 'Polygon') polys = [polys];
	
	    for (var i = 0, insidePoly = false; i < polys.length && !insidePoly; i++) {
	        // check if it is in the outer ring first
	        if (inRing(pt, polys[i][0])) {
	            var inHole = false;
	            var k = 1;
	            // check for the point in any of the holes
	            while (k < polys[i].length && !inHole) {
	                if (inRing(pt, polys[i][k])) {
	                    inHole = true;
	                }
	                k++;
	            }
	            if (!inHole) insidePoly = true;
	        }
	    }
	    return insidePoly;
	};
	
	// pt is [x,y] and ring is [[x,y], [x,y],..]
	function inRing(pt, ring) {
	    var isInside = false;
	    for (var i = 0, j = ring.length - 1; i < ring.length; j = i++) {
	        var xi = ring[i][0], yi = ring[i][1];
	        var xj = ring[j][0], yj = ring[j][1];
	        var intersect = ((yi > pt[1]) !== (yj > pt[1])) &&
	        (pt[0] < (xj - xi) * (pt[1] - yi) / (yj - yi) + xi);
	        if (intersect) isInside = !isInside;
	    }
	    return isInside;
	}


/***/ }),
/* 95 */
/***/ (function(module, exports) {

	/**
	 * Iterate over coordinates in any GeoJSON object, similar to
	 * Array.forEach.
	 *
	 * @param {Object} layer any GeoJSON object
	 * @param {Function} callback a method that takes (value)
	 * @param {boolean=} excludeWrapCoord whether or not to include
	 * the final coordinate of LinearRings that wraps the ring in its iteration.
	 * @example
	 * var point = { type: 'Point', coordinates: [0, 0] };
	 * coordEach(point, function(coords) {
	 *   // coords is equal to [0, 0]
	 * });
	 */
	function coordEach(layer, callback, excludeWrapCoord) {
	    var i, j, k, g, l, geometry, stopG, coords,
	        geometryMaybeCollection,
	        wrapShrink = 0,
	        isGeometryCollection,
	        isFeatureCollection = layer.type === 'FeatureCollection',
	        isFeature = layer.type === 'Feature',
	        stop = isFeatureCollection ? layer.features.length : 1;
	
	  // This logic may look a little weird. The reason why it is that way
	  // is because it's trying to be fast. GeoJSON supports multiple kinds
	  // of objects at its root: FeatureCollection, Features, Geometries.
	  // This function has the responsibility of handling all of them, and that
	  // means that some of the `for` loops you see below actually just don't apply
	  // to certain inputs. For instance, if you give this just a
	  // Point geometry, then both loops are short-circuited and all we do
	  // is gradually rename the input until it's called 'geometry'.
	  //
	  // This also aims to allocate as few resources as possible: just a
	  // few numbers and booleans, rather than any temporary arrays as would
	  // be required with the normalization approach.
	    for (i = 0; i < stop; i++) {
	
	        geometryMaybeCollection = (isFeatureCollection ? layer.features[i].geometry :
	        (isFeature ? layer.geometry : layer));
	        isGeometryCollection = geometryMaybeCollection.type === 'GeometryCollection';
	        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
	
	        for (g = 0; g < stopG; g++) {
	            geometry = isGeometryCollection ?
	            geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
	            coords = geometry.coordinates;
	
	            wrapShrink = (excludeWrapCoord &&
	                (geometry.type === 'Polygon' || geometry.type === 'MultiPolygon')) ?
	                1 : 0;
	
	            if (geometry.type === 'Point') {
	                callback(coords);
	            } else if (geometry.type === 'LineString' || geometry.type === 'MultiPoint') {
	                for (j = 0; j < coords.length; j++) callback(coords[j]);
	            } else if (geometry.type === 'Polygon' || geometry.type === 'MultiLineString') {
	                for (j = 0; j < coords.length; j++)
	                    for (k = 0; k < coords[j].length - wrapShrink; k++)
	                        callback(coords[j][k]);
	            } else if (geometry.type === 'MultiPolygon') {
	                for (j = 0; j < coords.length; j++)
	                    for (k = 0; k < coords[j].length; k++)
	                        for (l = 0; l < coords[j][k].length - wrapShrink; l++)
	                            callback(coords[j][k][l]);
	            } else {
	                throw new Error('Unknown Geometry Type');
	            }
	        }
	    }
	}
	module.exports.coordEach = coordEach;
	
	/**
	 * Reduce coordinates in any GeoJSON object into a single value,
	 * similar to how Array.reduce works. However, in this case we lazily run
	 * the reduction, so an array of all coordinates is unnecessary.
	 *
	 * @param {Object} layer any GeoJSON object
	 * @param {Function} callback a method that takes (memo, value) and returns
	 * a new memo
	 * @param {*} memo the starting value of memo: can be any type.
	 * @param {boolean=} excludeWrapCoord whether or not to include
	 * the final coordinate of LinearRings that wraps the ring in its iteration.
	 * @return {*} combined value
	 */
	function coordReduce(layer, callback, memo, excludeWrapCoord) {
	    coordEach(layer, function (coord) {
	        memo = callback(memo, coord);
	    }, excludeWrapCoord);
	    return memo;
	}
	module.exports.coordReduce = coordReduce;
	
	/**
	 * Iterate over property objects in any GeoJSON object, similar to
	 * Array.forEach.
	 *
	 * @param {Object} layer any GeoJSON object
	 * @param {Function} callback a method that takes (value)
	 * @example
	 * var point = { type: 'Feature', geometry: null, properties: { foo: 1 } };
	 * propEach(point, function(props) {
	 *   // props is equal to { foo: 1}
	 * });
	 */
	function propEach(layer, callback) {
	    var i;
	    switch (layer.type) {
	    case 'FeatureCollection':
	        for (i = 0; i < layer.features.length; i++) {
	            callback(layer.features[i].properties);
	        }
	        break;
	    case 'Feature':
	        callback(layer.properties);
	        break;
	    }
	}
	module.exports.propEach = propEach;
	
	/**
	 * Reduce properties in any GeoJSON object into a single value,
	 * similar to how Array.reduce works. However, in this case we lazily run
	 * the reduction, so an array of all properties is unnecessary.
	 *
	 * @param {Object} layer any GeoJSON object
	 * @param {Function} callback a method that takes (memo, coord) and returns
	 * a new memo
	 * @param {*} memo the starting value of memo: can be any type.
	 * @return {*} combined value
	 */
	function propReduce(layer, callback, memo) {
	    propEach(layer, function (prop) {
	        memo = callback(memo, prop);
	    });
	    return memo;
	}
	module.exports.propReduce = propReduce;
	
	/**
	 * Iterate over features in any GeoJSON object, similar to
	 * Array.forEach.
	 *
	 * @param {Object} layer any GeoJSON object
	 * @param {Function} callback a method that takes (value)
	 * @example
	 * var feature = { type: 'Feature', geometry: null, properties: {} };
	 * featureEach(feature, function(feature) {
	 *   // feature == feature
	 * });
	 */
	function featureEach(layer, callback) {
	    if (layer.type === 'Feature') {
	        callback(layer);
	    } else if (layer.type === 'FeatureCollection') {
	        for (var i = 0; i < layer.features.length; i++) {
	            callback(layer.features[i]);
	        }
	    }
	}
	module.exports.featureEach = featureEach;
	
	/**
	 * Get all coordinates from any GeoJSON object, returning an array of coordinate
	 * arrays.
	 * @param {Object} layer any GeoJSON object
	 * @return {Array<Array<Number>>} coordinate position array
	 */
	function coordAll(layer) {
	    var coords = [];
	    coordEach(layer, function (coord) {
	        coords.push(coord);
	    });
	    return coords;
	}
	module.exports.coordAll = coordAll;


/***/ }),
/* 96 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @module helpers
	 */
	/**
	 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
	 *
	 * @memberof helpers
	 * @type {number}
	 */
	exports.earthRadius = 6371008.8;
	/**
	 * Unit of measurement factors using a spherical (non-ellipsoid) earth radius.
	 *
	 * @memberof helpers
	 * @type {Object}
	 */
	exports.factors = {
	    centimeters: exports.earthRadius * 100,
	    centimetres: exports.earthRadius * 100,
	    degrees: exports.earthRadius / 111325,
	    feet: exports.earthRadius * 3.28084,
	    inches: exports.earthRadius * 39.37,
	    kilometers: exports.earthRadius / 1000,
	    kilometres: exports.earthRadius / 1000,
	    meters: exports.earthRadius,
	    metres: exports.earthRadius,
	    miles: exports.earthRadius / 1609.344,
	    millimeters: exports.earthRadius * 1000,
	    millimetres: exports.earthRadius * 1000,
	    nauticalmiles: exports.earthRadius / 1852,
	    radians: 1,
	    yards: exports.earthRadius * 1.0936,
	};
	/**
	 * Units of measurement factors based on 1 meter.
	 *
	 * @memberof helpers
	 * @type {Object}
	 */
	exports.unitsFactors = {
	    centimeters: 100,
	    centimetres: 100,
	    degrees: 1 / 111325,
	    feet: 3.28084,
	    inches: 39.37,
	    kilometers: 1 / 1000,
	    kilometres: 1 / 1000,
	    meters: 1,
	    metres: 1,
	    miles: 1 / 1609.344,
	    millimeters: 1000,
	    millimetres: 1000,
	    nauticalmiles: 1 / 1852,
	    radians: 1 / exports.earthRadius,
	    yards: 1.0936133,
	};
	/**
	 * Area of measurement factors based on 1 square meter.
	 *
	 * @memberof helpers
	 * @type {Object}
	 */
	exports.areaFactors = {
	    acres: 0.000247105,
	    centimeters: 10000,
	    centimetres: 10000,
	    feet: 10.763910417,
	    hectares: 0.0001,
	    inches: 1550.003100006,
	    kilometers: 0.000001,
	    kilometres: 0.000001,
	    meters: 1,
	    metres: 1,
	    miles: 3.86e-7,
	    millimeters: 1000000,
	    millimetres: 1000000,
	    yards: 1.195990046,
	};
	/**
	 * Wraps a GeoJSON {@link Geometry} in a GeoJSON {@link Feature}.
	 *
	 * @name feature
	 * @param {Geometry} geometry input geometry
	 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
	 * @param {Object} [options={}] Optional Parameters
	 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
	 * @param {string|number} [options.id] Identifier associated with the Feature
	 * @returns {Feature} a GeoJSON Feature
	 * @example
	 * var geometry = {
	 *   "type": "Point",
	 *   "coordinates": [110, 50]
	 * };
	 *
	 * var feature = turf.feature(geometry);
	 *
	 * //=feature
	 */
	function feature(geom, properties, options) {
	    if (options === void 0) { options = {}; }
	    var feat = { type: "Feature" };
	    if (options.id === 0 || options.id) {
	        feat.id = options.id;
	    }
	    if (options.bbox) {
	        feat.bbox = options.bbox;
	    }
	    feat.properties = properties || {};
	    feat.geometry = geom;
	    return feat;
	}
	exports.feature = feature;
	/**
	 * Creates a GeoJSON {@link Geometry} from a Geometry string type & coordinates.
	 * For GeometryCollection type use `helpers.geometryCollection`
	 *
	 * @name geometry
	 * @param {string} type Geometry Type
	 * @param {Array<any>} coordinates Coordinates
	 * @param {Object} [options={}] Optional Parameters
	 * @returns {Geometry} a GeoJSON Geometry
	 * @example
	 * var type = "Point";
	 * var coordinates = [110, 50];
	 * var geometry = turf.geometry(type, coordinates);
	 * // => geometry
	 */
	function geometry(type, coordinates, _options) {
	    if (_options === void 0) { _options = {}; }
	    switch (type) {
	        case "Point":
	            return point(coordinates).geometry;
	        case "LineString":
	            return lineString(coordinates).geometry;
	        case "Polygon":
	            return polygon(coordinates).geometry;
	        case "MultiPoint":
	            return multiPoint(coordinates).geometry;
	        case "MultiLineString":
	            return multiLineString(coordinates).geometry;
	        case "MultiPolygon":
	            return multiPolygon(coordinates).geometry;
	        default:
	            throw new Error(type + " is invalid");
	    }
	}
	exports.geometry = geometry;
	/**
	 * Creates a {@link Point} {@link Feature} from a Position.
	 *
	 * @name point
	 * @param {Array<number>} coordinates longitude, latitude position (each in decimal degrees)
	 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
	 * @param {Object} [options={}] Optional Parameters
	 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
	 * @param {string|number} [options.id] Identifier associated with the Feature
	 * @returns {Feature<Point>} a Point feature
	 * @example
	 * var point = turf.point([-75.343, 39.984]);
	 *
	 * //=point
	 */
	function point(coordinates, properties, options) {
	    if (options === void 0) { options = {}; }
	    if (!coordinates) {
	        throw new Error("coordinates is required");
	    }
	    if (!Array.isArray(coordinates)) {
	        throw new Error("coordinates must be an Array");
	    }
	    if (coordinates.length < 2) {
	        throw new Error("coordinates must be at least 2 numbers long");
	    }
	    if (!isNumber(coordinates[0]) || !isNumber(coordinates[1])) {
	        throw new Error("coordinates must contain numbers");
	    }
	    var geom = {
	        type: "Point",
	        coordinates: coordinates,
	    };
	    return feature(geom, properties, options);
	}
	exports.point = point;
	/**
	 * Creates a {@link Point} {@link FeatureCollection} from an Array of Point coordinates.
	 *
	 * @name points
	 * @param {Array<Array<number>>} coordinates an array of Points
	 * @param {Object} [properties={}] Translate these properties to each Feature
	 * @param {Object} [options={}] Optional Parameters
	 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north]
	 * associated with the FeatureCollection
	 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
	 * @returns {FeatureCollection<Point>} Point Feature
	 * @example
	 * var points = turf.points([
	 *   [-75, 39],
	 *   [-80, 45],
	 *   [-78, 50]
	 * ]);
	 *
	 * //=points
	 */
	function points(coordinates, properties, options) {
	    if (options === void 0) { options = {}; }
	    return featureCollection(coordinates.map(function (coords) {
	        return point(coords, properties);
	    }), options);
	}
	exports.points = points;
	/**
	 * Creates a {@link Polygon} {@link Feature} from an Array of LinearRings.
	 *
	 * @name polygon
	 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
	 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
	 * @param {Object} [options={}] Optional Parameters
	 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
	 * @param {string|number} [options.id] Identifier associated with the Feature
	 * @returns {Feature<Polygon>} Polygon Feature
	 * @example
	 * var polygon = turf.polygon([[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]], { name: 'poly1' });
	 *
	 * //=polygon
	 */
	function polygon(coordinates, properties, options) {
	    if (options === void 0) { options = {}; }
	    for (var _i = 0, coordinates_1 = coordinates; _i < coordinates_1.length; _i++) {
	        var ring = coordinates_1[_i];
	        if (ring.length < 4) {
	            throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
	        }
	        for (var j = 0; j < ring[ring.length - 1].length; j++) {
	            // Check if first point of Polygon contains two numbers
	            if (ring[ring.length - 1][j] !== ring[0][j]) {
	                throw new Error("First and last Position are not equivalent.");
	            }
	        }
	    }
	    var geom = {
	        type: "Polygon",
	        coordinates: coordinates,
	    };
	    return feature(geom, properties, options);
	}
	exports.polygon = polygon;
	/**
	 * Creates a {@link Polygon} {@link FeatureCollection} from an Array of Polygon coordinates.
	 *
	 * @name polygons
	 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygon coordinates
	 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
	 * @param {Object} [options={}] Optional Parameters
	 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
	 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
	 * @returns {FeatureCollection<Polygon>} Polygon FeatureCollection
	 * @example
	 * var polygons = turf.polygons([
	 *   [[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]],
	 *   [[[-15, 42], [-14, 46], [-12, 41], [-17, 44], [-15, 42]]],
	 * ]);
	 *
	 * //=polygons
	 */
	function polygons(coordinates, properties, options) {
	    if (options === void 0) { options = {}; }
	    return featureCollection(coordinates.map(function (coords) {
	        return polygon(coords, properties);
	    }), options);
	}
	exports.polygons = polygons;
	/**
	 * Creates a {@link LineString} {@link Feature} from an Array of Positions.
	 *
	 * @name lineString
	 * @param {Array<Array<number>>} coordinates an array of Positions
	 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
	 * @param {Object} [options={}] Optional Parameters
	 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
	 * @param {string|number} [options.id] Identifier associated with the Feature
	 * @returns {Feature<LineString>} LineString Feature
	 * @example
	 * var linestring1 = turf.lineString([[-24, 63], [-23, 60], [-25, 65], [-20, 69]], {name: 'line 1'});
	 * var linestring2 = turf.lineString([[-14, 43], [-13, 40], [-15, 45], [-10, 49]], {name: 'line 2'});
	 *
	 * //=linestring1
	 * //=linestring2
	 */
	function lineString(coordinates, properties, options) {
	    if (options === void 0) { options = {}; }
	    if (coordinates.length < 2) {
	        throw new Error("coordinates must be an array of two or more positions");
	    }
	    var geom = {
	        type: "LineString",
	        coordinates: coordinates,
	    };
	    return feature(geom, properties, options);
	}
	exports.lineString = lineString;
	/**
	 * Creates a {@link LineString} {@link FeatureCollection} from an Array of LineString coordinates.
	 *
	 * @name lineStrings
	 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
	 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
	 * @param {Object} [options={}] Optional Parameters
	 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north]
	 * associated with the FeatureCollection
	 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
	 * @returns {FeatureCollection<LineString>} LineString FeatureCollection
	 * @example
	 * var linestrings = turf.lineStrings([
	 *   [[-24, 63], [-23, 60], [-25, 65], [-20, 69]],
	 *   [[-14, 43], [-13, 40], [-15, 45], [-10, 49]]
	 * ]);
	 *
	 * //=linestrings
	 */
	function lineStrings(coordinates, properties, options) {
	    if (options === void 0) { options = {}; }
	    return featureCollection(coordinates.map(function (coords) {
	        return lineString(coords, properties);
	    }), options);
	}
	exports.lineStrings = lineStrings;
	/**
	 * Takes one or more {@link Feature|Features} and creates a {@link FeatureCollection}.
	 *
	 * @name featureCollection
	 * @param {Feature[]} features input features
	 * @param {Object} [options={}] Optional Parameters
	 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
	 * @param {string|number} [options.id] Identifier associated with the Feature
	 * @returns {FeatureCollection} FeatureCollection of Features
	 * @example
	 * var locationA = turf.point([-75.343, 39.984], {name: 'Location A'});
	 * var locationB = turf.point([-75.833, 39.284], {name: 'Location B'});
	 * var locationC = turf.point([-75.534, 39.123], {name: 'Location C'});
	 *
	 * var collection = turf.featureCollection([
	 *   locationA,
	 *   locationB,
	 *   locationC
	 * ]);
	 *
	 * //=collection
	 */
	function featureCollection(features, options) {
	    if (options === void 0) { options = {}; }
	    var fc = { type: "FeatureCollection" };
	    if (options.id) {
	        fc.id = options.id;
	    }
	    if (options.bbox) {
	        fc.bbox = options.bbox;
	    }
	    fc.features = features;
	    return fc;
	}
	exports.featureCollection = featureCollection;
	/**
	 * Creates a {@link Feature<MultiLineString>} based on a
	 * coordinate array. Properties can be added optionally.
	 *
	 * @name multiLineString
	 * @param {Array<Array<Array<number>>>} coordinates an array of LineStrings
	 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
	 * @param {Object} [options={}] Optional Parameters
	 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
	 * @param {string|number} [options.id] Identifier associated with the Feature
	 * @returns {Feature<MultiLineString>} a MultiLineString feature
	 * @throws {Error} if no coordinates are passed
	 * @example
	 * var multiLine = turf.multiLineString([[[0,0],[10,10]]]);
	 *
	 * //=multiLine
	 */
	function multiLineString(coordinates, properties, options) {
	    if (options === void 0) { options = {}; }
	    var geom = {
	        type: "MultiLineString",
	        coordinates: coordinates,
	    };
	    return feature(geom, properties, options);
	}
	exports.multiLineString = multiLineString;
	/**
	 * Creates a {@link Feature<MultiPoint>} based on a
	 * coordinate array. Properties can be added optionally.
	 *
	 * @name multiPoint
	 * @param {Array<Array<number>>} coordinates an array of Positions
	 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
	 * @param {Object} [options={}] Optional Parameters
	 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
	 * @param {string|number} [options.id] Identifier associated with the Feature
	 * @returns {Feature<MultiPoint>} a MultiPoint feature
	 * @throws {Error} if no coordinates are passed
	 * @example
	 * var multiPt = turf.multiPoint([[0,0],[10,10]]);
	 *
	 * //=multiPt
	 */
	function multiPoint(coordinates, properties, options) {
	    if (options === void 0) { options = {}; }
	    var geom = {
	        type: "MultiPoint",
	        coordinates: coordinates,
	    };
	    return feature(geom, properties, options);
	}
	exports.multiPoint = multiPoint;
	/**
	 * Creates a {@link Feature<MultiPolygon>} based on a
	 * coordinate array. Properties can be added optionally.
	 *
	 * @name multiPolygon
	 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygons
	 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
	 * @param {Object} [options={}] Optional Parameters
	 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
	 * @param {string|number} [options.id] Identifier associated with the Feature
	 * @returns {Feature<MultiPolygon>} a multipolygon feature
	 * @throws {Error} if no coordinates are passed
	 * @example
	 * var multiPoly = turf.multiPolygon([[[[0,0],[0,10],[10,10],[10,0],[0,0]]]]);
	 *
	 * //=multiPoly
	 *
	 */
	function multiPolygon(coordinates, properties, options) {
	    if (options === void 0) { options = {}; }
	    var geom = {
	        type: "MultiPolygon",
	        coordinates: coordinates,
	    };
	    return feature(geom, properties, options);
	}
	exports.multiPolygon = multiPolygon;
	/**
	 * Creates a {@link Feature<GeometryCollection>} based on a
	 * coordinate array. Properties can be added optionally.
	 *
	 * @name geometryCollection
	 * @param {Array<Geometry>} geometries an array of GeoJSON Geometries
	 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
	 * @param {Object} [options={}] Optional Parameters
	 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
	 * @param {string|number} [options.id] Identifier associated with the Feature
	 * @returns {Feature<GeometryCollection>} a GeoJSON GeometryCollection Feature
	 * @example
	 * var pt = turf.geometry("Point", [100, 0]);
	 * var line = turf.geometry("LineString", [[101, 0], [102, 1]]);
	 * var collection = turf.geometryCollection([pt, line]);
	 *
	 * // => collection
	 */
	function geometryCollection(geometries, properties, options) {
	    if (options === void 0) { options = {}; }
	    var geom = {
	        type: "GeometryCollection",
	        geometries: geometries,
	    };
	    return feature(geom, properties, options);
	}
	exports.geometryCollection = geometryCollection;
	/**
	 * Round number to precision
	 *
	 * @param {number} num Number
	 * @param {number} [precision=0] Precision
	 * @returns {number} rounded number
	 * @example
	 * turf.round(120.4321)
	 * //=120
	 *
	 * turf.round(120.4321, 2)
	 * //=120.43
	 */
	function round(num, precision) {
	    if (precision === void 0) { precision = 0; }
	    if (precision && !(precision >= 0)) {
	        throw new Error("precision must be a positive number");
	    }
	    var multiplier = Math.pow(10, precision || 0);
	    return Math.round(num * multiplier) / multiplier;
	}
	exports.round = round;
	/**
	 * Convert a distance measurement (assuming a spherical Earth) from radians to a more friendly unit.
	 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
	 *
	 * @name radiansToLength
	 * @param {number} radians in radians across the sphere
	 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
	 * meters, kilometres, kilometers.
	 * @returns {number} distance
	 */
	function radiansToLength(radians, units) {
	    if (units === void 0) { units = "kilometers"; }
	    var factor = exports.factors[units];
	    if (!factor) {
	        throw new Error(units + " units is invalid");
	    }
	    return radians * factor;
	}
	exports.radiansToLength = radiansToLength;
	/**
	 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into radians
	 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
	 *
	 * @name lengthToRadians
	 * @param {number} distance in real units
	 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
	 * meters, kilometres, kilometers.
	 * @returns {number} radians
	 */
	function lengthToRadians(distance, units) {
	    if (units === void 0) { units = "kilometers"; }
	    var factor = exports.factors[units];
	    if (!factor) {
	        throw new Error(units + " units is invalid");
	    }
	    return distance / factor;
	}
	exports.lengthToRadians = lengthToRadians;
	/**
	 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into degrees
	 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, centimeters, kilometres, feet
	 *
	 * @name lengthToDegrees
	 * @param {number} distance in real units
	 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
	 * meters, kilometres, kilometers.
	 * @returns {number} degrees
	 */
	function lengthToDegrees(distance, units) {
	    return radiansToDegrees(lengthToRadians(distance, units));
	}
	exports.lengthToDegrees = lengthToDegrees;
	/**
	 * Converts any bearing angle from the north line direction (positive clockwise)
	 * and returns an angle between 0-360 degrees (positive clockwise), 0 being the north line
	 *
	 * @name bearingToAzimuth
	 * @param {number} bearing angle, between -180 and +180 degrees
	 * @returns {number} angle between 0 and 360 degrees
	 */
	function bearingToAzimuth(bearing) {
	    var angle = bearing % 360;
	    if (angle < 0) {
	        angle += 360;
	    }
	    return angle;
	}
	exports.bearingToAzimuth = bearingToAzimuth;
	/**
	 * Converts an angle in radians to degrees
	 *
	 * @name radiansToDegrees
	 * @param {number} radians angle in radians
	 * @returns {number} degrees between 0 and 360 degrees
	 */
	function radiansToDegrees(radians) {
	    var degrees = radians % (2 * Math.PI);
	    return (degrees * 180) / Math.PI;
	}
	exports.radiansToDegrees = radiansToDegrees;
	/**
	 * Converts an angle in degrees to radians
	 *
	 * @name degreesToRadians
	 * @param {number} degrees angle between 0 and 360 degrees
	 * @returns {number} angle in radians
	 */
	function degreesToRadians(degrees) {
	    var radians = degrees % 360;
	    return (radians * Math.PI) / 180;
	}
	exports.degreesToRadians = degreesToRadians;
	/**
	 * Converts a length to the requested unit.
	 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
	 *
	 * @param {number} length to be converted
	 * @param {Units} [originalUnit="kilometers"] of the length
	 * @param {Units} [finalUnit="kilometers"] returned unit
	 * @returns {number} the converted length
	 */
	function convertLength(length, originalUnit, finalUnit) {
	    if (originalUnit === void 0) { originalUnit = "kilometers"; }
	    if (finalUnit === void 0) { finalUnit = "kilometers"; }
	    if (!(length >= 0)) {
	        throw new Error("length must be a positive number");
	    }
	    return radiansToLength(lengthToRadians(length, originalUnit), finalUnit);
	}
	exports.convertLength = convertLength;
	/**
	 * Converts a area to the requested unit.
	 * Valid units: kilometers, kilometres, meters, metres, centimetres, millimeters, acres, miles, yards, feet, inches, hectares
	 * @param {number} area to be converted
	 * @param {Units} [originalUnit="meters"] of the distance
	 * @param {Units} [finalUnit="kilometers"] returned unit
	 * @returns {number} the converted area
	 */
	function convertArea(area, originalUnit, finalUnit) {
	    if (originalUnit === void 0) { originalUnit = "meters"; }
	    if (finalUnit === void 0) { finalUnit = "kilometers"; }
	    if (!(area >= 0)) {
	        throw new Error("area must be a positive number");
	    }
	    var startFactor = exports.areaFactors[originalUnit];
	    if (!startFactor) {
	        throw new Error("invalid original units");
	    }
	    var finalFactor = exports.areaFactors[finalUnit];
	    if (!finalFactor) {
	        throw new Error("invalid final units");
	    }
	    return (area / startFactor) * finalFactor;
	}
	exports.convertArea = convertArea;
	/**
	 * isNumber
	 *
	 * @param {*} num Number to validate
	 * @returns {boolean} true/false
	 * @example
	 * turf.isNumber(123)
	 * //=true
	 * turf.isNumber('foo')
	 * //=false
	 */
	function isNumber(num) {
	    return !isNaN(num) && num !== null && !Array.isArray(num);
	}
	exports.isNumber = isNumber;
	/**
	 * isObject
	 *
	 * @param {*} input variable to validate
	 * @returns {boolean} true/false
	 * @example
	 * turf.isObject({elevation: 10})
	 * //=true
	 * turf.isObject('foo')
	 * //=false
	 */
	function isObject(input) {
	    return !!input && input.constructor === Object;
	}
	exports.isObject = isObject;
	/**
	 * Validate BBox
	 *
	 * @private
	 * @param {Array<number>} bbox BBox to validate
	 * @returns {void}
	 * @throws Error if BBox is not valid
	 * @example
	 * validateBBox([-180, -40, 110, 50])
	 * //=OK
	 * validateBBox([-180, -40])
	 * //=Error
	 * validateBBox('Foo')
	 * //=Error
	 * validateBBox(5)
	 * //=Error
	 * validateBBox(null)
	 * //=Error
	 * validateBBox(undefined)
	 * //=Error
	 */
	function validateBBox(bbox) {
	    if (!bbox) {
	        throw new Error("bbox is required");
	    }
	    if (!Array.isArray(bbox)) {
	        throw new Error("bbox must be an Array");
	    }
	    if (bbox.length !== 4 && bbox.length !== 6) {
	        throw new Error("bbox must be an Array of 4 or 6 numbers");
	    }
	    bbox.forEach(function (num) {
	        if (!isNumber(num)) {
	            throw new Error("bbox must only contain numbers");
	        }
	    });
	}
	exports.validateBBox = validateBBox;
	/**
	 * Validate Id
	 *
	 * @private
	 * @param {string|number} id Id to validate
	 * @returns {void}
	 * @throws Error if Id is not valid
	 * @example
	 * validateId([-180, -40, 110, 50])
	 * //=Error
	 * validateId([-180, -40])
	 * //=Error
	 * validateId('Foo')
	 * //=OK
	 * validateId(5)
	 * //=OK
	 * validateId(null)
	 * //=Error
	 * validateId(undefined)
	 * //=Error
	 */
	function validateId(id) {
	    if (!id) {
	        throw new Error("id is required");
	    }
	    if (["string", "number"].indexOf(typeof id) === -1) {
	        throw new Error("id must be a number or a string");
	    }
	}
	exports.validateId = validateId;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.router = undefined;
	
	var _vueRouter = __webpack_require__(532);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _app = __webpack_require__(1891);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _promoBolt = __webpack_require__(2013);
	
	var _promoBolt2 = _interopRequireDefault(_promoBolt);
	
	var _missingCompany = __webpack_require__(2005);
	
	var _missingCompany2 = _interopRequireDefault(_missingCompany);
	
	var _promoTollTicket = __webpack_require__(2014);
	
	var _promoTollTicket2 = _interopRequireDefault(_promoTollTicket);
	
	var _login = __webpack_require__(1973);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _passwordRequest = __webpack_require__(1976);
	
	var _passwordRequest2 = _interopRequireDefault(_passwordRequest);
	
	var _passwordSet = __webpack_require__(1977);
	
	var _passwordSet2 = _interopRequireDefault(_passwordSet);
	
	var _passwordChangeConfirmation = __webpack_require__(1974);
	
	var _passwordChangeConfirmation2 = _interopRequireDefault(_passwordChangeConfirmation);
	
	var _faInterno = __webpack_require__(526);
	
	var _faInterno2 = _interopRequireDefault(_faInterno);
	
	var _passwordChange = __webpack_require__(1975);
	
	var _passwordChange2 = _interopRequireDefault(_passwordChange);
	
	var _userContactsChange = __webpack_require__(1978);
	
	var _userContactsChange2 = _interopRequireDefault(_userContactsChange);
	
	var _chooseChannel = __webpack_require__(1972);
	
	var _chooseChannel2 = _interopRequireDefault(_chooseChannel);
	
	var _authEmailCnpjReq = __webpack_require__(1969);
	
	var _authEmailCnpjReq2 = _interopRequireDefault(_authEmailCnpjReq);
	
	var _authEmailTelReq = __webpack_require__(1970);
	
	var _authEmailTelReq2 = _interopRequireDefault(_authEmailTelReq);
	
	var _plans = __webpack_require__(1918);
	
	var _plans2 = _interopRequireDefault(_plans);
	
	var _profile = __webpack_require__(1920);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _refund = __webpack_require__(1927);
	
	var _refund2 = _interopRequireDefault(_refund);
	
	var _statement = __webpack_require__(1948);
	
	var _statement2 = _interopRequireDefault(_statement);
	
	var _vehicles = __webpack_require__(1967);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	var _vehiclesPToP = __webpack_require__(1966);
	
	var _vehiclesPToP2 = _interopRequireDefault(_vehiclesPToP);
	
	var _requests = __webpack_require__(1934);
	
	var _requests2 = _interopRequireDefault(_requests);
	
	var _reprocessOrders = __webpack_require__(1932);
	
	var _reprocessOrders2 = _interopRequireDefault(_reprocessOrders);
	
	var _requestDetail = __webpack_require__(1933);
	
	var _requestDetail2 = _interopRequireDefault(_requestDetail);
	
	var _myAccount = __webpack_require__(1916);
	
	var _myAccount2 = _interopRequireDefault(_myAccount);
	
	var _homeAccount = __webpack_require__(1914);
	
	var _homeAccount2 = _interopRequireDefault(_homeAccount);
	
	var _newContract = __webpack_require__(1910);
	
	var _newContract2 = _interopRequireDefault(_newContract);
	
	var _migrationPlan = __webpack_require__(1909);
	
	var _migrationPlan2 = _interopRequireDefault(_migrationPlan);
	
	var _tagActivate = __webpack_require__(1949);
	
	var _tagActivate2 = _interopRequireDefault(_tagActivate);
	
	var _vehicleEdit = __webpack_require__(1960);
	
	var _vehicleEdit2 = _interopRequireDefault(_vehicleEdit);
	
	var _recharge = __webpack_require__(1926);
	
	var _recharge2 = _interopRequireDefault(_recharge);
	
	var _accessionMonthlypayment = __webpack_require__(1892);
	
	var _accessionMonthlypayment2 = _interopRequireDefault(_accessionMonthlypayment);
	
	var _invoiceHistory = __webpack_require__(1915);
	
	var _invoiceHistory2 = _interopRequireDefault(_invoiceHistory);
	
	var _vehicleMovement = __webpack_require__(1965);
	
	var _vehicleMovement2 = _interopRequireDefault(_vehicleMovement);
	
	var _replaceTag = __webpack_require__(1928);
	
	var _replaceTag2 = _interopRequireDefault(_replaceTag);
	
	var _resultActivateTag = __webpack_require__(1935);
	
	var _resultActivateTag2 = _interopRequireDefault(_resultActivateTag);
	
	var _routing = __webpack_require__(1942);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _routes = __webpack_require__(1940);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _routeDetail = __webpack_require__(1939);
	
	var _routeDetail2 = _interopRequireDefault(_routeDetail);
	
	var _notification = __webpack_require__(1917);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	var _rntrcVinculation = __webpack_require__(1936);
	
	var _rntrcVinculation2 = _interopRequireDefault(_rntrcVinculation);
	
	var _routingTeste = __webpack_require__(1941);
	
	var _routingTeste2 = _interopRequireDefault(_routingTeste);
	
	var _transferShipper = __webpack_require__(1947);
	
	var _transferShipper2 = _interopRequireDefault(_transferShipper);
	
	var _transferShipperVouchers = __webpack_require__(1946);
	
	var _transferShipperVouchers2 = _interopRequireDefault(_transferShipperVouchers);
	
	var _transferShipperVoucherDetail = __webpack_require__(1945);
	
	var _transferShipperVoucherDetail2 = _interopRequireDefault(_transferShipperVoucherDetail);
	
	var _validarCartao = __webpack_require__(1959);
	
	var _validarCartao2 = _interopRequireDefault(_validarCartao);
	
	var _withdrawalPoints = __webpack_require__(2031);
	
	var _withdrawalPoints2 = _interopRequireDefault(_withdrawalPoints);
	
	var _transferCredit = __webpack_require__(1913);
	
	var _transferCredit2 = _interopRequireDefault(_transferCredit);
	
	var _transferCreditReceipt = __webpack_require__(1911);
	
	var _transferCreditReceipt2 = _interopRequireDefault(_transferCreditReceipt);
	
	var _conveniadoVoucher = __webpack_require__(1930);
	
	var _conveniadoVoucher2 = _interopRequireDefault(_conveniadoVoucher);
	
	var _buyCredit = __webpack_require__(1952);
	
	var _buyCredit2 = _interopRequireDefault(_buyCredit);
	
	var _tollTicket = __webpack_require__(1958);
	
	var _tollTicket2 = _interopRequireDefault(_tollTicket);
	
	var _accompaniment = __webpack_require__(1950);
	
	var _accompaniment2 = _interopRequireDefault(_accompaniment);
	
	var _myTollTicket = __webpack_require__(1953);
	
	var _myTollTicket2 = _interopRequireDefault(_myTollTicket);
	
	var _summaryAccompaniment = __webpack_require__(1957);
	
	var _summaryAccompaniment2 = _interopRequireDefault(_summaryAccompaniment);
	
	var _receipt = __webpack_require__(1955);
	
	var _receipt2 = _interopRequireDefault(_receipt);
	
	var _receiptCredit = __webpack_require__(1954);
	
	var _receiptCredit2 = _interopRequireDefault(_receiptCredit);
	
	var _balanceStatement = __webpack_require__(1951);
	
	var _balanceStatement2 = _interopRequireDefault(_balanceStatement);
	
	var _statementConsolidated = __webpack_require__(1956);
	
	var _statementConsolidated2 = _interopRequireDefault(_statementConsolidated);
	
	var _home = __webpack_require__(2001);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _fa = __webpack_require__(1968);
	
	var _fa2 = _interopRequireDefault(_fa);
	
	var _hotsite = __webpack_require__(1989);
	
	var _hotsite2 = _interopRequireDefault(_hotsite);
	
	var _proposal = __webpack_require__(2015);
	
	var _proposal2 = _interopRequireDefault(_proposal);
	
	var _forYou = __webpack_require__(1999);
	
	var _forYou2 = _interopRequireDefault(_forYou);
	
	var _forBusiness = __webpack_require__(1998);
	
	var _forBusiness2 = _interopRequireDefault(_forBusiness);
	
	var _services = __webpack_require__(2030);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _servicesB2b = __webpack_require__(2024);
	
	var _servicesB2b2 = _interopRequireDefault(_servicesB2b);
	
	var _servicesB2c = __webpack_require__(2026);
	
	var _servicesB2c2 = _interopRequireDefault(_servicesB2c);
	
	var _servicesVpo = __webpack_require__(2029);
	
	var _servicesVpo2 = _interopRequireDefault(_servicesVpo);
	
	var _servicesSenff = __webpack_require__(2027);
	
	var _servicesSenff2 = _interopRequireDefault(_servicesSenff);
	
	var _servicesB2bPrepay = __webpack_require__(2022);
	
	var _servicesB2bPrepay2 = _interopRequireDefault(_servicesB2bPrepay);
	
	var _range = __webpack_require__(2017);
	
	var _range2 = _interopRequireDefault(_range);
	
	var _guide = __webpack_require__(2000);
	
	var _guide2 = _interopRequireDefault(_guide);
	
	var _faq = __webpack_require__(1997);
	
	var _faq2 = _interopRequireDefault(_faq);
	
	var _moveMais = __webpack_require__(2006);
	
	var _moveMais2 = _interopRequireDefault(_moveMais);
	
	var _contact = __webpack_require__(1996);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _contactPartner = __webpack_require__(1995);
	
	var _contactPartner2 = _interopRequireDefault(_contactPartner);
	
	var _repomRedirect = __webpack_require__(2020);
	
	var _repomRedirect2 = _interopRequireDefault(_repomRedirect);
	
	var _adhesion = __webpack_require__(1994);
	
	var _adhesion2 = _interopRequireDefault(_adhesion);
	
	var _contractDetail = __webpack_require__(1908);
	
	var _contractDetail2 = _interopRequireDefault(_contractDetail);
	
	var _newVehicle = __webpack_require__(1962);
	
	var _newVehicle2 = _interopRequireDefault(_newVehicle);
	
	var _loginAtendente = __webpack_require__(2002);
	
	var _loginAtendente2 = _interopRequireDefault(_loginAtendente);
	
	var _companyData = __webpack_require__(228);
	
	var _companyData2 = _interopRequireDefault(_companyData);
	
	var _rechargeValueB2b = __webpack_require__(2018);
	
	var _rechargeValueB2b2 = _interopRequireDefault(_rechargeValueB2b);
	
	var _rechargeValueB2c = __webpack_require__(2019);
	
	var _rechargeValueB2c2 = _interopRequireDefault(_rechargeValueB2c);
	
	var _planPrepayManualB2c = __webpack_require__(2012);
	
	var _planPrepayManualB2c2 = _interopRequireDefault(_planPrepayManualB2c);
	
	var _planPrepayAutoB2c = __webpack_require__(2010);
	
	var _planPrepayAutoB2c2 = _interopRequireDefault(_planPrepayAutoB2c);
	
	var _planMovepayB2c = __webpack_require__(2009);
	
	var _planMovepayB2c2 = _interopRequireDefault(_planMovepayB2c);
	
	var _paranaWay = __webpack_require__(2008);
	
	var _paranaWay2 = _interopRequireDefault(_paranaWay);
	
	var _adhesionShipper = __webpack_require__(1993);
	
	var _adhesionShipper2 = _interopRequireDefault(_adhesionShipper);
	
	var _ombudsman = __webpack_require__(2007);
	
	var _ombudsman2 = _interopRequireDefault(_ombudsman);
	
	var _retornoSenff = __webpack_require__(2021);
	
	var _retornoSenff2 = _interopRequireDefault(_retornoSenff);
	
	var _reprocessOrder = __webpack_require__(1929);
	
	var _reprocessOrder2 = _interopRequireDefault(_reprocessOrder);
	
	var _servicesSodre = __webpack_require__(2028);
	
	var _servicesSodre2 = _interopRequireDefault(_servicesSodre);
	
	var _servicesB2bSodre = __webpack_require__(2023);
	
	var _servicesB2bSodre2 = _interopRequireDefault(_servicesB2bSodre);
	
	var _servicesB2cSodre = __webpack_require__(2025);
	
	var _servicesB2cSodre2 = _interopRequireDefault(_servicesB2cSodre);
	
	var _planPrepayAutoSodre = __webpack_require__(2011);
	
	var _planPrepayAutoSodre2 = _interopRequireDefault(_planPrepayAutoSodre);
	
	var _loginSsa = __webpack_require__(2003);
	
	var _loginSsa2 = _interopRequireDefault(_loginSsa);
	
	var _success = __webpack_require__(47);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _aggregateList = __webpack_require__(1893);
	
	var _aggregateList2 = _interopRequireDefault(_aggregateList);
	
	var _rescueBalance = __webpack_require__(1904);
	
	var _rescueBalance2 = _interopRequireDefault(_rescueBalance);
	
	var _vpVehicleMovement = __webpack_require__(1905);
	
	var _vpVehicleMovement2 = _interopRequireDefault(_vpVehicleMovement);
	
	var _chooseChannelInterno = __webpack_require__(1971);
	
	var _chooseChannelInterno2 = _interopRequireDefault(_chooseChannelInterno);
	
	var _extract = __webpack_require__(2032);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routes = [{
	  path: '/', component: _app2.default, redirect: '/inicio', name: 'inicio',
	  children: [{ name: 'hotsite', path: 'hotsite', component: _hotsite2.default }, { name: 'footer-hotsite', path: '/footer-hotsite', component: _hotsite2.default }, { name: 'login', path: 'login', component: _login2.default, beforeEnter: _auth2.default.checkUserLoggedGuard.bind(_auth2.default) }, { name: 'success', path: '/success', component: _success2.default }, { name: 'view-qrcode-pix', path: '/visualizar-qrcode-pix', component: _success2.default, props: true }, { name: 'request-proposal', path: 'solicitar-proposta', component: _proposal2.default }, { name: 'range', path: 'cobertura', component: _range2.default }, { path: '/vale-pedagio', component: _promoTollTicket2.default, name: 'promo-toll-ticket' }, { path: '/valepedagio', component: _promoTollTicket2.default, name: 'promo-toll-ticket' }, { name: 'guide', path: 'guia-de-instalacao', component: _guide2.default }, { name: 'move-mais', path: 'move-mais', component: _moveMais2.default }, { name: 'home', path: 'inicio', component: _home2.default }, { name: '2fa', path: '2fa', component: _fa2.default }, { name: '2fa-login', path: 'login/2fa/:type', component: _faInterno2.default }, { name: 'choose-channel-interno', path: 'choose-channel-interno', component: _chooseChannelInterno2.default }, { name: 'services', path: 'servicos', component: _services2.default }, { name: 'services-vpo', path: 'servicos-vpo', component: _servicesVpo2.default }, { name: 'services-b2b', path: 'servicos-b2b', component: _servicesB2b2.default }, { name: 'services-b2b-prepay', path: 'servicos-b2b-pre-pagos', component: _servicesB2bPrepay2.default }, { name: 'services-senff', path: 'servicos-senff', component: _servicesSenff2.default }, { name: 'services-b2c', path: 'servicos-b2c', component: _servicesB2c2.default, props: { type: 'PF' } }, { name: 'recharge-value-b2c', path: 'valores-recarga-b2c', component: _rechargeValueB2c2.default }, { name: 'recharge-value-b2b', path: 'valores-recarga-b2b', component: _rechargeValueB2b2.default }, { name: 'plan-prepay-manual-b2c', redirect: '/inicio', path: 'servicos-b2c-plano-controle', component: _app2.default }, { name: 'plan-prepay-auto-b2c', redirect: '/inicio', path: 'servicos-b2c-plano-conforto', component: _app2.default }, { name: 'plan-movepay-b2c', path: 'servicos-b2c-plano-move-e-pague', component: _planMovepayB2c2.default, redirect: '/inicio' }, { name: 'for-you', path: 'para-voce', component: _forYou2.default }, { name: 'for-business', path: 'para-empresas', component: _forBusiness2.default }, { name: 'contact', path: 'contato', component: _contact2.default }, { name: 'contact-partner', path: 'contato-parceiro', component: _contactPartner2.default }, { name: 'ombudsman', path: 'ouvidoria', component: _ombudsman2.default }, { name: 'FAQ', path: 'FAQ', component: _faq2.default }, { name: 'password-request', path: 'autenticacao/requerer-senha/:type', component: _passwordRequest2.default }, { name: 'password-set', path: 'autenticacao/definir-senha/:type', component: _passwordSet2.default }, { name: 'choose-channel', path: 'autenticacao/escolher-canal/:type', component: _chooseChannel2.default }, { name: 'auth-email-cnpj-req', path: 'esqueci-email', component: _authEmailCnpjReq2.default }, { name: 'auth-email-tel-req', path: 'inserir-número-celular', component: _authEmailTelReq2.default }, { name: 'extract', path: 'pdf/extrato', component: _extract2.default }, { name: 'repom', path: 'repom', component: _repomRedirect2.default }, { name: 'adhesion', path: 'adesao', component: _adhesion2.default, props: true }, { name: 'login-atendente', path: 'login-atendente', component: _loginAtendente2.default }, { name: 'company-data', path: 'dados-empresa', component: _companyData2.default }, { name: 'parana-way', path: 'caminhos-parana', component: _paranaWay2.default }, { name: 'rodosol', path: 'rodosol', component: _home2.default }, { name: 'adhesion-shipper', path: 'adesao-embarcador', component: _adhesionShipper2.default, props: true }, { name: 'services-sodre', path: 'sodre', component: _servicesSodre2.default }, { name: 'services-b2b-sodre', path: 'servicos-b2b-sodre', component: _servicesB2bSodre2.default }, { name: 'services-b2c-sodre', path: 'servicos-b2c-sodre', component: _servicesB2cSodre2.default, props: { type: 'PF' } }, { name: 'plan-prepay-auto-sodre', redirect: '/inicio', path: 'servicos-sodre-plano-conforto', component: _app2.default }, { name: 'withdrawall-points', path: 'pontos-de-retirada', component: _withdrawalPoints2.default }, {
	    path: 'conta', component: _homeAccount2.default,
	
	    beforeEnter: _auth2.default.checkUserLoggedGuard.bind(_auth2.default),
	    children: [{ name: 'plans', path: 'meus-planos', component: _plans2.default, props: true }, { name: 'profile', path: 'perfil', component: _profile2.default }, { name: 'password-change-confirmation', path: 'autenticacao/confirmar-troca', component: _passwordChangeConfirmation2.default }, { name: '2fa-interno', path: 'autenticacao/2fa/:type', component: _faInterno2.default }, { name: 'password-change', path: 'autenticacao/alterar-senha', component: _passwordChange2.default }, { name: 'user-contacts-change', path: 'contato/alterar-info/:type', component: _userContactsChange2.default }, { name: 'buy-credit', path: 'comprar-credito', component: _buyCredit2.default }, { name: 'toll-ticket', path: 'vale-pedagio/:contractId', component: _tollTicket2.default }, { name: 'accompaniment', path: 'acompanhamento/:contractId', component: _accompaniment2.default }, { name: 'my-toll-ticket', path: 'meus-vales-pedagio', component: _myTollTicket2.default }, { name: 'summary-accompaniment', path: 'resumo-acompanhamento/:contractId/:idVP', component: _summaryAccompaniment2.default }, { name: 'statement-consolidated', path: 'extrato-consolidado', component: _statementConsolidated2.default }, { name: 'receipt', path: 'comprovante-vale-pedagio/:contractId/:idVP', component: _receipt2.default }, { name: 'receipt-credit', path: 'comprovante-creditos/:orderId', component: _receiptCredit2.default }, { name: 'balance-statement', path: 'saldo-extrato', component: _balanceStatement2.default }, { name: 'refund', path: 'contestacao', component: _refund2.default }, {
	      name: 'contract-vehicles',
	      path: 'contrato/:contractId/veiculos',
	      component: _vehicles2.default
	    }, {
	      name: 'contract-vehicles-edit',
	      path: 'contrato/:contractId/veiculo/:vehicleId',
	      component: _vehicleEdit2.default
	    }, {
	      name: 'vehicles-p-to-p',
	      path: 'contrato/:contractId/veiculos/ponto-a-ponto',
	      component: _vehiclesPToP2.default
	    }, {
	      name: 'contract-vehicles-new',
	      path: 'contrato/:contractId/veiculos/novo',
	      component: _newVehicle2.default
	    }, {
	      name: 'invoice-history',
	      path: 'contrato/:contractId/faturas',
	      component: _invoiceHistory2.default
	    }, {
	      name: 'contract-recharge',
	      path: 'contrato/:contractId/:planId/recarregar',
	      component: _recharge2.default
	    }, { name: 'contract-statement', path: 'contrato/:contractId/:planId/extrato', component: _statement2.default }, { name: 'tag-activate', path: 'ativar-tag', component: _tagActivate2.default }, { name: 'rntrc-vinculation', path: 'rntrc-vinculacao', component: _rntrcVinculation2.default }, { name: 'notification', path: 'notification', component: _notification2.default }, { name: 'accession-monthlypayment', path: 'adesao-e-mensalidades', component: _accessionMonthlypayment2.default }, { name: 'account-history', path: 'historico-de-contas', component: _invoiceHistory2.default }, { name: 'requests', path: 'meus-pedidos', component: _requests2.default }, { name: 'reprocess-orders', path: 'reprocessar-pedidos/:contractId', component: _reprocessOrders2.default }, { name: 'request-detail', path: 'detalhes/:orderId', component: _requestDetail2.default }, {
	      name: 'vehicle-movement',
	      path: 'contrato/:contractId/veiculo/:vehicleId/movimento',
	      component: _vehicleMovement2.default
	    }, { name: 'replace-tag', path: 'substituicao-tag/:contractId/:vehicleId', component: _replaceTag2.default }, { name: 'contract-detail', path: 'contrato/:contractId/detalhes', component: _contractDetail2.default }, { name: 'my-account', path: 'minha-conta', component: _myAccount2.default }, { name: 'new-contract', path: 'novo-contrato', props: true, component: _newContract2.default }, { name: 'migration-plan', path: 'migration-plan', props: true, component: _migrationPlan2.default }, { name: 'result-activate-tag', path: 'resumo-ativacao-tag/:plate/:serial', component: _resultActivateTag2.default }, { name: 'routing', path: 'rotas', component: _routing2.default }, { name: 'routes', path: 'rotas-embarcador', component: _routes2.default }, { name: 'route-detail', path: 'rota-detalhe/:routeId/:version', component: _routeDetail2.default }, { name: 'routing-teste', path: 'rotas-teste', component: _routingTeste2.default }, { name: 'transfer-shipper', path: 'transferir-creditos/', props: true, component: _transferShipper2.default }, { name: 'transfer-shipper-vouchers', path: 'comprovantes-de-transferencias', component: _transferShipperVouchers2.default }, { name: 'transfer-shipper-voucher-detail', path: 'comprovante-da-transferencia', component: _transferShipperVoucherDetail2.default }, { name: 'reprocess-order', path: 'pagamento-pedido/:orderId', component: _reprocessOrder2.default }, { path: 'senff-retorno', component: _retornoSenff2.default, name: 'retorno-senff' }, { path: 'transferir-creditos-pre-pago/:contractId', name: 'transfer-credit', component: _transferCredit2.default }, { path: 'comprovante-transferencia-credito/:orderId', name: 'transfer-credit-receipt', component: _transferCreditReceipt2.default }, { path: 'conveniado-voucher', name: 'conveniado-voucher', component: _conveniadoVoucher2.default }, { path: 'contrato/:contractId/:moveMaisId/agregados', name: 'aggregate-list', props: true, component: _aggregateList2.default }, { path: 'resgatar-saldo/:contractId', name: 'rescue-balance', component: _rescueBalance2.default }, { path: 'veiculo/movimentacao-vp', name: 'vp-vehicle-movement', component: _vpVehicleMovement2.default }, { path: 'validar-cartao', name: 'validar-cartao', component: _validarCartao2.default }]
	  }]
	}, { path: '/promocao-relampago', component: _promoBolt2.default, name: 'promo-bolt' }, { path: '/so-falta-sua-empresa', component: _missingCompany2.default, name: 'missing-company' }, { path: '/vp', component: _promoTollTicket2.default, name: 'promo-toll-ticket' }, { path: '/senff/retorno', component: _retornoSenff2.default, name: 'retorno-senff' }, { path: '/ssa', component: _loginSsa2.default, name: 'login-ssa' }];
	
	var router = new _vueRouter2.default({
	  routes: routes,
	  linkActiveClass: 'active'
	});
	
	router.beforeEach(function (to, from, next) {
	  $('body').stop().animate({ scrollTop: 0 }, '500', 'swing');
	  next();
	});
	
	router.afterEach(function (to, from) {
	  setTimeout(function () {
	    $('[data-toggle="tooltip"]').tooltip();
	  }, 3000);
	
	  if (to.path.indexOf('/conta/') > -1 && $(window).width() < 767) {
	    setTimeout(function () {
	      $('footer').hide();
	    }, 30);
	  } else {
	    setTimeout(function () {
	      $('footer').show();
	    }, 30);
	  }
	
	  if (window.ga) window.ga('send', 'pageview', to.path);
	});
	
	exports.router = router;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _number = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function recargaValida(val, args) {
	
	  var min = parseInt(args[0]);
	  if (!val) return false;
	
	  val = parseInt(val.toString().replace(/[^0-9]/g, ''));
	
	  if (val > min) return true;
	
	  return false;
	}
	
	exports.default = {
	  messages: {
	    en: function en(field, args) {
	      var min = args[0];
	      return 'Valor deve ser maior que ' + (0, _number.cents)(min);
	    },
	    'pt-BR': function ptBR(field, args) {
	      var min = args[0];
	      return 'Valor deve ser maior que ' + (0, _number.cents)(min);
	    }
	  },
	  validate: function validate(value, args) {
	    return recargaValida(value, args);
	  }
	};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(173);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 101 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(56);
	var call = __webpack_require__(262);
	var isArrayIter = __webpack_require__(260);
	var anObject = __webpack_require__(50);
	var toLength = __webpack_require__(128);
	var getIterFn = __webpack_require__(198);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 103 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 104 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 105 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(45).f;
	var has = __webpack_require__(72);
	var TAG = __webpack_require__(37)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(32).Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}


/***/ }),
/* 108 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRoundingMethod = getRoundingMethod;
	var roundingMap = {
	  ceil: Math.ceil,
	  round: Math.round,
	  floor: Math.floor,
	  trunc: function (value) {
	    return value < 0 ? Math.ceil(value) : Math.floor(value);
	  } // Math.trunc is not supported by IE
	
	};
	var defaultRoundingMethod = 'trunc';
	
	function getRoundingMethod(method) {
	  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
	}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCWeek(dirtyDate, dirtyOptions) {
	  (0, _index3.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index2.default)(dirtyDate);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addMilliseconds
	 * @category Millisecond Helpers
	 * @summary Add the specified number of milliseconds to the given date.
	 *
	 * @description
	 * Add the specified number of milliseconds to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the milliseconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
	 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:30.750
	 */
	function addMilliseconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var timestamp = (0, _index2.default)(dirtyDate).getTime();
	  var amount = (0, _index.default)(dirtyAmount);
	  return new Date(timestamp + amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addMonths
	 * @category Month Helpers
	 * @summary Add the specified number of months to the given date.
	 *
	 * @description
	 * Add the specified number of months to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the months added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 months to 1 September 2014:
	 * const result = addMonths(new Date(2014, 8, 1), 5)
	 * //=> Sun Feb 01 2015 00:00:00
	 */
	function addMonths(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var amount = (0, _index.default)(dirtyAmount);
	
	  if (isNaN(amount)) {
	    return new Date(NaN);
	  }
	
	  if (!amount) {
	    // If 0 months, no-op to avoid changing times in the hour before end of DST
	    return date;
	  }
	
	  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
	  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
	  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
	  // want except that dates will wrap around the end of a month, meaning that
	  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
	  // we'll default to the end of the desired month by adding 1 to the desired
	  // month and using a date of 0 to back up one day to the end of the desired
	  // month.
	
	  var endOfDesiredMonth = new Date(date.getTime());
	  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
	  var daysInMonth = endOfDesiredMonth.getDate();
	
	  if (dayOfMonth >= daysInMonth) {
	    // If we're already at the end of the month, then this is the correct date
	    // and we're done.
	    return endOfDesiredMonth;
	  } else {
	    // Otherwise, we now know that setting the original day-of-month value won't
	    // cause an overflow, so set the desired day-of-month. Note that we can't
	    // just set the date of `endOfDesiredMonth` because that object may have had
	    // its time changed in the unusual case where where a DST transition was on
	    // the last day of the month and its local time was in the hour skipped or
	    // repeated next to a DST transition.  So we use `date` instead which is
	    // guaranteed to still have the original time.
	    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
	    return date;
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameDay;
	
	var _index = _interopRequireDefault(__webpack_require__(139));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameDay
	 * @category Day Helpers
	 * @summary Are the given dates in the same day?
	 *
	 * @description
	 * Are the given dates in the same day?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same day
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
	 * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
	 * //=> true
	 */
	function isSameDay(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfDay = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfDay = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(91));
	
	var _index2 = _interopRequireDefault(__webpack_require__(81));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the start of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the start of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of an ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of an ISO week-numbering year for 2 July 2005:
	 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
	 * //=> Mon Jan 03 2005 00:00:00
	 */
	function startOfISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setFullYear(year, 0, 4);
	  fourthOfJanuary.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(110));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subMilliseconds
	 * @category Millisecond Helpers
	 * @summary Subtract the specified number of milliseconds from the given date.
	 *
	 * @description
	 * Subtract the specified number of milliseconds from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the milliseconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
	 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:29.250
	 */
	function subMilliseconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjkiIHN0cm9rZT0iI0Y1OTYzOCIgc3Ryb2tlLXdpZHRoPSIyIi8+DQo8cGF0aCBkPSJNMTIuNSA3LjVDMTIuNSA3Ljc3NjE0IDEyLjI3NjEgOCAxMiA4QzExLjcyMzkgOCAxMS41IDcuNzc2MTQgMTEuNSA3LjVDMTEuNSA3LjIyMzg2IDExLjcyMzkgNyAxMiA3QzEyLjI3NjEgNyAxMi41IDcuMjIzODYgMTIuNSA3LjVaIiBmaWxsPSIjRjU5NjM4IiBzdHJva2U9IiNGNTk2MzgiLz4NCjxwYXRoIGQ9Ik0xMiAxN1YxMCIgc3Ryb2tlPSIjRjU5NjM4IiBzdHJva2Utd2lkdGg9IjIiLz4NCjwvc3ZnPg0K"

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/rule_color.a3dd2e6.png";

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAyMCAzMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjAgMzA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOiNGREQzNDE7fQ0KPC9zdHlsZT4NCjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xNi4zLDExbC01LjgsMS4zbDQuNy04LjhsLTYsMS4zTDMuNywxNi43bDQuOS0xTDMuNywyNi41TDE2LjMsMTF6Ii8+DQo8L3N2Zz4NCg=="

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1650)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(725),
	  /* template */
	  __webpack_require__(2191),
	  /* scopeId */
	  "data-v-925108f4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1592)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(736),
	  /* template */
	  __webpack_require__(2127),
	  /* scopeId */
	  "data-v-52106e5c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * vuex v2.5.0
	 * (c) 2017 Evan You
	 * @license MIT
	 */
	'use strict';
	
	var applyMixin = function (Vue) {
	  var version = Number(Vue.version.split('.')[0]);
	
	  if (version >= 2) {
	    Vue.mixin({ beforeCreate: vuexInit });
	  } else {
	    // override init and inject vuex init procedure
	    // for 1.x backwards compatibility.
	    var _init = Vue.prototype._init;
	    Vue.prototype._init = function (options) {
	      if ( options === void 0 ) options = {};
	
	      options.init = options.init
	        ? [vuexInit].concat(options.init)
	        : vuexInit;
	      _init.call(this, options);
	    };
	  }
	
	  /**
	   * Vuex init hook, injected into each instances init hooks list.
	   */
	
	  function vuexInit () {
	    var options = this.$options;
	    // store injection
	    if (options.store) {
	      this.$store = typeof options.store === 'function'
	        ? options.store()
	        : options.store;
	    } else if (options.parent && options.parent.$store) {
	      this.$store = options.parent.$store;
	    }
	  }
	};
	
	var devtoolHook =
	  typeof window !== 'undefined' &&
	  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
	
	function devtoolPlugin (store) {
	  if (!devtoolHook) { return }
	
	  store._devtoolHook = devtoolHook;
	
	  devtoolHook.emit('vuex:init', store);
	
	  devtoolHook.on('vuex:travel-to-state', function (targetState) {
	    store.replaceState(targetState);
	  });
	
	  store.subscribe(function (mutation, state) {
	    devtoolHook.emit('vuex:mutation', mutation, state);
	  });
	}
	
	/**
	 * Get the first item that pass the test
	 * by second argument function
	 *
	 * @param {Array} list
	 * @param {Function} f
	 * @return {*}
	 */
	/**
	 * Deep copy the given object considering circular structure.
	 * This function caches all nested objects and its copies.
	 * If it detects circular structure, use cached copy to avoid infinite loop.
	 *
	 * @param {*} obj
	 * @param {Array<Object>} cache
	 * @return {*}
	 */
	
	
	/**
	 * forEach for object
	 */
	function forEachValue (obj, fn) {
	  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
	}
	
	function isObject (obj) {
	  return obj !== null && typeof obj === 'object'
	}
	
	function isPromise (val) {
	  return val && typeof val.then === 'function'
	}
	
	function assert (condition, msg) {
	  if (!condition) { throw new Error(("[vuex] " + msg)) }
	}
	
	var Module = function Module (rawModule, runtime) {
	  this.runtime = runtime;
	  this._children = Object.create(null);
	  this._rawModule = rawModule;
	  var rawState = rawModule.state;
	  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
	};
	
	var prototypeAccessors$1 = { namespaced: { configurable: true } };
	
	prototypeAccessors$1.namespaced.get = function () {
	  return !!this._rawModule.namespaced
	};
	
	Module.prototype.addChild = function addChild (key, module) {
	  this._children[key] = module;
	};
	
	Module.prototype.removeChild = function removeChild (key) {
	  delete this._children[key];
	};
	
	Module.prototype.getChild = function getChild (key) {
	  return this._children[key]
	};
	
	Module.prototype.update = function update (rawModule) {
	  this._rawModule.namespaced = rawModule.namespaced;
	  if (rawModule.actions) {
	    this._rawModule.actions = rawModule.actions;
	  }
	  if (rawModule.mutations) {
	    this._rawModule.mutations = rawModule.mutations;
	  }
	  if (rawModule.getters) {
	    this._rawModule.getters = rawModule.getters;
	  }
	};
	
	Module.prototype.forEachChild = function forEachChild (fn) {
	  forEachValue(this._children, fn);
	};
	
	Module.prototype.forEachGetter = function forEachGetter (fn) {
	  if (this._rawModule.getters) {
	    forEachValue(this._rawModule.getters, fn);
	  }
	};
	
	Module.prototype.forEachAction = function forEachAction (fn) {
	  if (this._rawModule.actions) {
	    forEachValue(this._rawModule.actions, fn);
	  }
	};
	
	Module.prototype.forEachMutation = function forEachMutation (fn) {
	  if (this._rawModule.mutations) {
	    forEachValue(this._rawModule.mutations, fn);
	  }
	};
	
	Object.defineProperties( Module.prototype, prototypeAccessors$1 );
	
	var ModuleCollection = function ModuleCollection (rawRootModule) {
	  // register root module (Vuex.Store options)
	  this.register([], rawRootModule, false);
	};
	
	ModuleCollection.prototype.get = function get (path) {
	  return path.reduce(function (module, key) {
	    return module.getChild(key)
	  }, this.root)
	};
	
	ModuleCollection.prototype.getNamespace = function getNamespace (path) {
	  var module = this.root;
	  return path.reduce(function (namespace, key) {
	    module = module.getChild(key);
	    return namespace + (module.namespaced ? key + '/' : '')
	  }, '')
	};
	
	ModuleCollection.prototype.update = function update$1 (rawRootModule) {
	  update([], this.root, rawRootModule);
	};
	
	ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
	    var this$1 = this;
	    if ( runtime === void 0 ) runtime = true;
	
	  if (false) {
	    assertRawModule(path, rawModule);
	  }
	
	  var newModule = new Module(rawModule, runtime);
	  if (path.length === 0) {
	    this.root = newModule;
	  } else {
	    var parent = this.get(path.slice(0, -1));
	    parent.addChild(path[path.length - 1], newModule);
	  }
	
	  // register nested modules
	  if (rawModule.modules) {
	    forEachValue(rawModule.modules, function (rawChildModule, key) {
	      this$1.register(path.concat(key), rawChildModule, runtime);
	    });
	  }
	};
	
	ModuleCollection.prototype.unregister = function unregister (path) {
	  var parent = this.get(path.slice(0, -1));
	  var key = path[path.length - 1];
	  if (!parent.getChild(key).runtime) { return }
	
	  parent.removeChild(key);
	};
	
	function update (path, targetModule, newModule) {
	  if (false) {
	    assertRawModule(path, newModule);
	  }
	
	  // update target module
	  targetModule.update(newModule);
	
	  // update nested modules
	  if (newModule.modules) {
	    for (var key in newModule.modules) {
	      if (!targetModule.getChild(key)) {
	        if (false) {
	          console.warn(
	            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
	            'manual reload is needed'
	          );
	        }
	        return
	      }
	      update(
	        path.concat(key),
	        targetModule.getChild(key),
	        newModule.modules[key]
	      );
	    }
	  }
	}
	
	var functionAssert = {
	  assert: function (value) { return typeof value === 'function'; },
	  expected: 'function'
	};
	
	var objectAssert = {
	  assert: function (value) { return typeof value === 'function' ||
	    (typeof value === 'object' && typeof value.handler === 'function'); },
	  expected: 'function or object with "handler" function'
	};
	
	var assertTypes = {
	  getters: functionAssert,
	  mutations: functionAssert,
	  actions: objectAssert
	};
	
	function assertRawModule (path, rawModule) {
	  Object.keys(assertTypes).forEach(function (key) {
	    if (!rawModule[key]) { return }
	
	    var assertOptions = assertTypes[key];
	
	    forEachValue(rawModule[key], function (value, type) {
	      assert(
	        assertOptions.assert(value),
	        makeAssertionMessage(path, key, type, value, assertOptions.expected)
	      );
	    });
	  });
	}
	
	function makeAssertionMessage (path, key, type, value, expected) {
	  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
	  if (path.length > 0) {
	    buf += " in module \"" + (path.join('.')) + "\"";
	  }
	  buf += " is " + (JSON.stringify(value)) + ".";
	  return buf
	}
	
	var Vue; // bind on install
	
	var Store = function Store (options) {
	  var this$1 = this;
	  if ( options === void 0 ) options = {};
	
	  // Auto install if it is not done yet and `window` has `Vue`.
	  // To allow users to avoid auto-installation in some cases,
	  // this code should be placed here. See #731
	  if (!Vue && typeof window !== 'undefined' && window.Vue) {
	    install(window.Vue);
	  }
	
	  if (false) {
	    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
	    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
	    assert(this instanceof Store, "Store must be called with the new operator.");
	  }
	
	  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
	  var strict = options.strict; if ( strict === void 0 ) strict = false;
	
	  var state = options.state; if ( state === void 0 ) state = {};
	  if (typeof state === 'function') {
	    state = state() || {};
	  }
	
	  // store internal state
	  this._committing = false;
	  this._actions = Object.create(null);
	  this._actionSubscribers = [];
	  this._mutations = Object.create(null);
	  this._wrappedGetters = Object.create(null);
	  this._modules = new ModuleCollection(options);
	  this._modulesNamespaceMap = Object.create(null);
	  this._subscribers = [];
	  this._watcherVM = new Vue();
	
	  // bind commit and dispatch to self
	  var store = this;
	  var ref = this;
	  var dispatch = ref.dispatch;
	  var commit = ref.commit;
	  this.dispatch = function boundDispatch (type, payload) {
	    return dispatch.call(store, type, payload)
	  };
	  this.commit = function boundCommit (type, payload, options) {
	    return commit.call(store, type, payload, options)
	  };
	
	  // strict mode
	  this.strict = strict;
	
	  // init root module.
	  // this also recursively registers all sub-modules
	  // and collects all module getters inside this._wrappedGetters
	  installModule(this, state, [], this._modules.root);
	
	  // initialize the store vm, which is responsible for the reactivity
	  // (also registers _wrappedGetters as computed properties)
	  resetStoreVM(this, state);
	
	  // apply plugins
	  plugins.forEach(function (plugin) { return plugin(this$1); });
	
	  if (Vue.config.devtools) {
	    devtoolPlugin(this);
	  }
	};
	
	var prototypeAccessors = { state: { configurable: true } };
	
	prototypeAccessors.state.get = function () {
	  return this._vm._data.$$state
	};
	
	prototypeAccessors.state.set = function (v) {
	  if (false) {
	    assert(false, "Use store.replaceState() to explicit replace store state.");
	  }
	};
	
	Store.prototype.commit = function commit (_type, _payload, _options) {
	    var this$1 = this;
	
	  // check object-style commit
	  var ref = unifyObjectStyle(_type, _payload, _options);
	    var type = ref.type;
	    var payload = ref.payload;
	    var options = ref.options;
	
	  var mutation = { type: type, payload: payload };
	  var entry = this._mutations[type];
	  if (!entry) {
	    if (false) {
	      console.error(("[vuex] unknown mutation type: " + type));
	    }
	    return
	  }
	  this._withCommit(function () {
	    entry.forEach(function commitIterator (handler) {
	      handler(payload);
	    });
	  });
	  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });
	
	  if (
	    false
	  ) {
	    console.warn(
	      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
	      'Use the filter functionality in the vue-devtools'
	    );
	  }
	};
	
	Store.prototype.dispatch = function dispatch (_type, _payload) {
	    var this$1 = this;
	
	  // check object-style dispatch
	  var ref = unifyObjectStyle(_type, _payload);
	    var type = ref.type;
	    var payload = ref.payload;
	
	  var action = { type: type, payload: payload };
	  var entry = this._actions[type];
	  if (!entry) {
	    if (false) {
	      console.error(("[vuex] unknown action type: " + type));
	    }
	    return
	  }
	
	  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });
	
	  return entry.length > 1
	    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
	    : entry[0](payload)
	};
	
	Store.prototype.subscribe = function subscribe (fn) {
	  return genericSubscribe(fn, this._subscribers)
	};
	
	Store.prototype.subscribeAction = function subscribeAction (fn) {
	  return genericSubscribe(fn, this._actionSubscribers)
	};
	
	Store.prototype.watch = function watch (getter, cb, options) {
	    var this$1 = this;
	
	  if (false) {
	    assert(typeof getter === 'function', "store.watch only accepts a function.");
	  }
	  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
	};
	
	Store.prototype.replaceState = function replaceState (state) {
	    var this$1 = this;
	
	  this._withCommit(function () {
	    this$1._vm._data.$$state = state;
	  });
	};
	
	Store.prototype.registerModule = function registerModule (path, rawModule, options) {
	    if ( options === void 0 ) options = {};
	
	  if (typeof path === 'string') { path = [path]; }
	
	  if (false) {
	    assert(Array.isArray(path), "module path must be a string or an Array.");
	    assert(path.length > 0, 'cannot register the root module by using registerModule.');
	  }
	
	  this._modules.register(path, rawModule);
	  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
	  // reset store to update getters...
	  resetStoreVM(this, this.state);
	};
	
	Store.prototype.unregisterModule = function unregisterModule (path) {
	    var this$1 = this;
	
	  if (typeof path === 'string') { path = [path]; }
	
	  if (false) {
	    assert(Array.isArray(path), "module path must be a string or an Array.");
	  }
	
	  this._modules.unregister(path);
	  this._withCommit(function () {
	    var parentState = getNestedState(this$1.state, path.slice(0, -1));
	    Vue.delete(parentState, path[path.length - 1]);
	  });
	  resetStore(this);
	};
	
	Store.prototype.hotUpdate = function hotUpdate (newOptions) {
	  this._modules.update(newOptions);
	  resetStore(this, true);
	};
	
	Store.prototype._withCommit = function _withCommit (fn) {
	  var committing = this._committing;
	  this._committing = true;
	  fn();
	  this._committing = committing;
	};
	
	Object.defineProperties( Store.prototype, prototypeAccessors );
	
	function genericSubscribe (fn, subs) {
	  if (subs.indexOf(fn) < 0) {
	    subs.push(fn);
	  }
	  return function () {
	    var i = subs.indexOf(fn);
	    if (i > -1) {
	      subs.splice(i, 1);
	    }
	  }
	}
	
	function resetStore (store, hot) {
	  store._actions = Object.create(null);
	  store._mutations = Object.create(null);
	  store._wrappedGetters = Object.create(null);
	  store._modulesNamespaceMap = Object.create(null);
	  var state = store.state;
	  // init all modules
	  installModule(store, state, [], store._modules.root, true);
	  // reset vm
	  resetStoreVM(store, state, hot);
	}
	
	function resetStoreVM (store, state, hot) {
	  var oldVm = store._vm;
	
	  // bind store public getters
	  store.getters = {};
	  var wrappedGetters = store._wrappedGetters;
	  var computed = {};
	  forEachValue(wrappedGetters, function (fn, key) {
	    // use computed to leverage its lazy-caching mechanism
	    computed[key] = function () { return fn(store); };
	    Object.defineProperty(store.getters, key, {
	      get: function () { return store._vm[key]; },
	      enumerable: true // for local getters
	    });
	  });
	
	  // use a Vue instance to store the state tree
	  // suppress warnings just in case the user has added
	  // some funky global mixins
	  var silent = Vue.config.silent;
	  Vue.config.silent = true;
	  store._vm = new Vue({
	    data: {
	      $$state: state
	    },
	    computed: computed
	  });
	  Vue.config.silent = silent;
	
	  // enable strict mode for new vm
	  if (store.strict) {
	    enableStrictMode(store);
	  }
	
	  if (oldVm) {
	    if (hot) {
	      // dispatch changes in all subscribed watchers
	      // to force getter re-evaluation for hot reloading.
	      store._withCommit(function () {
	        oldVm._data.$$state = null;
	      });
	    }
	    Vue.nextTick(function () { return oldVm.$destroy(); });
	  }
	}
	
	function installModule (store, rootState, path, module, hot) {
	  var isRoot = !path.length;
	  var namespace = store._modules.getNamespace(path);
	
	  // register in namespace map
	  if (module.namespaced) {
	    store._modulesNamespaceMap[namespace] = module;
	  }
	
	  // set state
	  if (!isRoot && !hot) {
	    var parentState = getNestedState(rootState, path.slice(0, -1));
	    var moduleName = path[path.length - 1];
	    store._withCommit(function () {
	      Vue.set(parentState, moduleName, module.state);
	    });
	  }
	
	  var local = module.context = makeLocalContext(store, namespace, path);
	
	  module.forEachMutation(function (mutation, key) {
	    var namespacedType = namespace + key;
	    registerMutation(store, namespacedType, mutation, local);
	  });
	
	  module.forEachAction(function (action, key) {
	    var type = action.root ? key : namespace + key;
	    var handler = action.handler || action;
	    registerAction(store, type, handler, local);
	  });
	
	  module.forEachGetter(function (getter, key) {
	    var namespacedType = namespace + key;
	    registerGetter(store, namespacedType, getter, local);
	  });
	
	  module.forEachChild(function (child, key) {
	    installModule(store, rootState, path.concat(key), child, hot);
	  });
	}
	
	/**
	 * make localized dispatch, commit, getters and state
	 * if there is no namespace, just use root ones
	 */
	function makeLocalContext (store, namespace, path) {
	  var noNamespace = namespace === '';
	
	  var local = {
	    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
	      var args = unifyObjectStyle(_type, _payload, _options);
	      var payload = args.payload;
	      var options = args.options;
	      var type = args.type;
	
	      if (!options || !options.root) {
	        type = namespace + type;
	        if (false) {
	          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
	          return
	        }
	      }
	
	      return store.dispatch(type, payload)
	    },
	
	    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
	      var args = unifyObjectStyle(_type, _payload, _options);
	      var payload = args.payload;
	      var options = args.options;
	      var type = args.type;
	
	      if (!options || !options.root) {
	        type = namespace + type;
	        if (false) {
	          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
	          return
	        }
	      }
	
	      store.commit(type, payload, options);
	    }
	  };
	
	  // getters and state object must be gotten lazily
	  // because they will be changed by vm update
	  Object.defineProperties(local, {
	    getters: {
	      get: noNamespace
	        ? function () { return store.getters; }
	        : function () { return makeLocalGetters(store, namespace); }
	    },
	    state: {
	      get: function () { return getNestedState(store.state, path); }
	    }
	  });
	
	  return local
	}
	
	function makeLocalGetters (store, namespace) {
	  var gettersProxy = {};
	
	  var splitPos = namespace.length;
	  Object.keys(store.getters).forEach(function (type) {
	    // skip if the target getter is not match this namespace
	    if (type.slice(0, splitPos) !== namespace) { return }
	
	    // extract local getter type
	    var localType = type.slice(splitPos);
	
	    // Add a port to the getters proxy.
	    // Define as getter property because
	    // we do not want to evaluate the getters in this time.
	    Object.defineProperty(gettersProxy, localType, {
	      get: function () { return store.getters[type]; },
	      enumerable: true
	    });
	  });
	
	  return gettersProxy
	}
	
	function registerMutation (store, type, handler, local) {
	  var entry = store._mutations[type] || (store._mutations[type] = []);
	  entry.push(function wrappedMutationHandler (payload) {
	    handler.call(store, local.state, payload);
	  });
	}
	
	function registerAction (store, type, handler, local) {
	  var entry = store._actions[type] || (store._actions[type] = []);
	  entry.push(function wrappedActionHandler (payload, cb) {
	    var res = handler.call(store, {
	      dispatch: local.dispatch,
	      commit: local.commit,
	      getters: local.getters,
	      state: local.state,
	      rootGetters: store.getters,
	      rootState: store.state
	    }, payload, cb);
	    if (!isPromise(res)) {
	      res = Promise.resolve(res);
	    }
	    if (store._devtoolHook) {
	      return res.catch(function (err) {
	        store._devtoolHook.emit('vuex:error', err);
	        throw err
	      })
	    } else {
	      return res
	    }
	  });
	}
	
	function registerGetter (store, type, rawGetter, local) {
	  if (store._wrappedGetters[type]) {
	    if (false) {
	      console.error(("[vuex] duplicate getter key: " + type));
	    }
	    return
	  }
	  store._wrappedGetters[type] = function wrappedGetter (store) {
	    return rawGetter(
	      local.state, // local state
	      local.getters, // local getters
	      store.state, // root state
	      store.getters // root getters
	    )
	  };
	}
	
	function enableStrictMode (store) {
	  store._vm.$watch(function () { return this._data.$$state }, function () {
	    if (false) {
	      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
	    }
	  }, { deep: true, sync: true });
	}
	
	function getNestedState (state, path) {
	  return path.length
	    ? path.reduce(function (state, key) { return state[key]; }, state)
	    : state
	}
	
	function unifyObjectStyle (type, payload, options) {
	  if (isObject(type) && type.type) {
	    options = payload;
	    payload = type;
	    type = type.type;
	  }
	
	  if (false) {
	    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
	  }
	
	  return { type: type, payload: payload, options: options }
	}
	
	function install (_Vue) {
	  if (Vue && _Vue === Vue) {
	    if (false) {
	      console.error(
	        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
	      );
	    }
	    return
	  }
	  Vue = _Vue;
	  applyMixin(Vue);
	}
	
	var mapState = normalizeNamespace(function (namespace, states) {
	  var res = {};
	  normalizeMap(states).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedState () {
	      var state = this.$store.state;
	      var getters = this.$store.getters;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
	        if (!module) {
	          return
	        }
	        state = module.context.state;
	        getters = module.context.getters;
	      }
	      return typeof val === 'function'
	        ? val.call(this, state, getters)
	        : state[val]
	    };
	    // mark vuex getter for devtools
	    res[key].vuex = true;
	  });
	  return res
	});
	
	var mapMutations = normalizeNamespace(function (namespace, mutations) {
	  var res = {};
	  normalizeMap(mutations).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedMutation () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	      var commit = this.$store.commit;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
	        if (!module) {
	          return
	        }
	        commit = module.context.commit;
	      }
	      return typeof val === 'function'
	        ? val.apply(this, [commit].concat(args))
	        : commit.apply(this.$store, [val].concat(args))
	    };
	  });
	  return res
	});
	
	var mapGetters = normalizeNamespace(function (namespace, getters) {
	  var res = {};
	  normalizeMap(getters).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    val = namespace + val;
	    res[key] = function mappedGetter () {
	      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
	        return
	      }
	      if (false) {
	        console.error(("[vuex] unknown getter: " + val));
	        return
	      }
	      return this.$store.getters[val]
	    };
	    // mark vuex getter for devtools
	    res[key].vuex = true;
	  });
	  return res
	});
	
	var mapActions = normalizeNamespace(function (namespace, actions) {
	  var res = {};
	  normalizeMap(actions).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedAction () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	      var dispatch = this.$store.dispatch;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
	        if (!module) {
	          return
	        }
	        dispatch = module.context.dispatch;
	      }
	      return typeof val === 'function'
	        ? val.apply(this, [dispatch].concat(args))
	        : dispatch.apply(this.$store, [val].concat(args))
	    };
	  });
	  return res
	});
	
	var createNamespacedHelpers = function (namespace) { return ({
	  mapState: mapState.bind(null, namespace),
	  mapGetters: mapGetters.bind(null, namespace),
	  mapMutations: mapMutations.bind(null, namespace),
	  mapActions: mapActions.bind(null, namespace)
	}); };
	
	function normalizeMap (map) {
	  return Array.isArray(map)
	    ? map.map(function (key) { return ({ key: key, val: key }); })
	    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
	}
	
	function normalizeNamespace (fn) {
	  return function (namespace, map) {
	    if (typeof namespace !== 'string') {
	      map = namespace;
	      namespace = '';
	    } else if (namespace.charAt(namespace.length - 1) !== '/') {
	      namespace += '/';
	    }
	    return fn(namespace, map)
	  }
	}
	
	function getModuleByNamespace (store, helper, namespace) {
	  var module = store._modulesNamespaceMap[namespace];
	  if (false) {
	    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
	  }
	  return module
	}
	
	var index = {
	  Store: Store,
	  install: install,
	  version: '2.5.0',
	  mapState: mapState,
	  mapMutations: mapMutations,
	  mapGetters: mapGetters,
	  mapActions: mapActions,
	  createNamespacedHelpers: createNamespacedHelpers
	};
	
	module.exports = index;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(791), __esModule: true };

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(796), __esModule: true };

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = xor;
	function xor(a, b) {
	  var len = Math.min(a.length, b.length);
	  var out = new Buffer(len);
	  var i = -1;
	  while (++i < len) {
	    out.writeUInt8(a[i] ^ b[i], i);
	  }
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32).Buffer))

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(101);
	var TAG = __webpack_require__(37)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(129)('meta');
	var isObject = __webpack_require__(42);
	var has = __webpack_require__(72);
	var setDesc = __webpack_require__(45).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(71)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(50);
	var dPs = __webpack_require__(822);
	var enumBugKeys = __webpack_require__(184);
	var IE_PROTO = __webpack_require__(191)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(183)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(258).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(31);
	var core = __webpack_require__(23);
	var fails = __webpack_require__(71);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(193);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 129 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 130 */
/***/ (function(module, exports) {



/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var rng = __webpack_require__(864)
	
	function error () {
	  var m = [].slice.call(arguments).join(' ')
	  throw new Error([
	    m,
	    'we accept pull requests',
	    'http://github.com/dominictarr/crypto-browserify'
	    ].join('\n'))
	}
	
	exports.createHash = __webpack_require__(276)
	
	exports.createHmac = __webpack_require__(860)
	
	exports.randomBytes = function(size, callback) {
	  if (callback && callback.call) {
	    try {
	      callback.call(this, undefined, new Buffer(rng(size)))
	    } catch (err) { callback(err) }
	  } else {
	    return new Buffer(rng(size))
	  }
	}
	
	function each(a, f) {
	  for(var i in a)
	    f(a[i], i)
	}
	
	exports.getHashes = function () {
	  return ['sha1', 'sha256', 'sha512', 'md5', 'rmd160']
	}
	
	var p = __webpack_require__(863)(exports)
	exports.pbkdf2 = p.pbkdf2
	exports.pbkdf2Sync = p.pbkdf2Sync
	__webpack_require__(782)(exports, module.exports);
	
	// the least I can do is make error messages for the rest of the node.js/crypto api.
	each(['createCredentials'
	, 'createSign'
	, 'createVerify'
	, 'createDiffieHellman'
	], function (name) {
	  exports[name] = function () {
	    error('sorry,', name, 'is not implemented yet')
	  }
	})
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32).Buffer))

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var isValue         = __webpack_require__(496)
	  , isPlainFunction = __webpack_require__(1763)
	  , assign          = __webpack_require__(1479)
	  , normalizeOpts   = __webpack_require__(1485)
	  , contains        = __webpack_require__(1487);
	
	var d = (module.exports = function (dscr, value/*, options*/) {
		var c, e, w, options, desc;
		if (arguments.length < 2 || typeof dscr !== "string") {
			options = value;
			value = dscr;
			dscr = null;
		} else {
			options = arguments[2];
		}
		if (isValue(dscr)) {
			c = contains.call(dscr, "c");
			e = contains.call(dscr, "e");
			w = contains.call(dscr, "w");
		} else {
			c = w = true;
			e = false;
		}
	
		desc = { value: value, configurable: c, enumerable: e, writable: w };
		return !options ? desc : assign(normalizeOpts(options), desc);
	});
	
	d.gs = function (dscr, get, set/*, options*/) {
		var c, e, options, desc;
		if (typeof dscr !== "string") {
			options = set;
			set = get;
			get = dscr;
			dscr = null;
		} else {
			options = arguments[3];
		}
		if (!isValue(get)) {
			get = undefined;
		} else if (!isPlainFunction(get)) {
			options = get;
			get = set = undefined;
		} else if (!isValue(set)) {
			set = undefined;
		} else if (!isPlainFunction(set)) {
			options = set;
			set = undefined;
		}
		if (isValue(dscr)) {
			c = contains.call(dscr, "c");
			e = contains.call(dscr, "e");
		} else {
			c = true;
			e = false;
		}
	
		desc = { get: get, set: set, configurable: c, enumerable: e };
		return !options ? desc : assign(normalizeOpts(options), desc);
	};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var weekStartsOn = 1;
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(58));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addWeeks
	 * @category Week Helpers
	 * @summary Add the specified number of weeks to the given date.
	 *
	 * @description
	 * Add the specified number of week to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the weeks added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 4 weeks to 1 September 2014:
	 * const result = addWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Sep 29 2014 00:00:00
	 */
	function addWeeks(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  var days = amount * 7;
	  return (0, _index2.default)(dirtyDate, days);
	}
	
	module.exports = exports.default;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInMilliseconds
	 * @category Millisecond Helpers
	 * @summary Get the number of milliseconds between the given dates.
	 *
	 * @description
	 * Get the number of milliseconds between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of milliseconds
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many milliseconds are between
	 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
	 * const result = differenceInMilliseconds(
	 *   new Date(2014, 6, 2, 12, 30, 21, 700),
	 *   new Date(2014, 6, 2, 12, 30, 20, 600)
	 * )
	 * //=> 1100
	 */
	function differenceInMilliseconds(dateLeft, dateRight) {
	  (0, _index2.default)(2, arguments);
	  return (0, _index.default)(dateLeft).getTime() - (0, _index.default)(dateRight).getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(290));
	
	var _index3 = _interopRequireDefault(__webpack_require__(75));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	var _index5 = _interopRequireDefault(__webpack_require__(311));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInMonths
	 * @category Month Helpers
	 * @summary Get the number of full months between the given dates.
	 *
	 * @description
	 * Get the number of full months between the given dates using trunc as a default rounding method.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full months
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full months are between 31 January 2014 and 1 September 2014?
	 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
	 * //=> 7
	 */
	function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
	  (0, _index4.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = (0, _index3.default)(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  var result; // Check for the difference of less than month
	
	  if (difference < 1) {
	    result = 0;
	  } else {
	    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
	      // This will check if the date is end of Feb and assign a higher end of month date
	      // to compare it with Jan
	      dateLeft.setDate(30);
	    }
	
	    dateLeft.setMonth(dateLeft.getMonth() - sign * difference); // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
	    // If so, result must be decreased by 1 in absolute value
	
	    var isLastMonthNotFull = (0, _index3.default)(dateLeft, dateRight) === -sign; // Check for cases of one full calendar month
	
	    if ((0, _index5.default)((0, _index.default)(dirtyDateLeft)) && difference === 1 && (0, _index3.default)(dirtyDateLeft, dateRight) === 1) {
	      isLastMonthNotFull = false;
	    }
	
	    result = sign * (difference - Number(isLastMonthNotFull));
	  } // Prevent negative zero
	
	
	  return result === 0 ? 0 : result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDay;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDay
	 * @category Weekday Helpers
	 * @summary Get the day of the week of the given date.
	 *
	 * @description
	 * Get the day of the week of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the week is 29 February 2012?
	 * const result = getDay(new Date(2012, 1, 29))
	 * //=> 3
	 */
	function getDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  return day;
	}
	
	module.exports = exports.default;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWeekend;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isWeekend
	 * @category Weekday Helpers
	 * @summary Does the given date fall on a weekend?
	 *
	 * @description
	 * Does the given date fall on a weekend?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date falls on a weekend
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Does 5 October 2014 fall on a weekend?
	 * const result = isWeekend(new Date(2014, 9, 5))
	 * //=> true
	 */
	function isWeekend(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  return day === 0 || day === 6;
	}
	
	module.exports = exports.default;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfDay;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfDay
	 * @category Day Helpers
	 * @summary Return the start of a day for the given date.
	 *
	 * @description
	 * Return the start of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a day
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a day for 2 September 2014 11:55:00:
	 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 00:00:00
	 */
	function startOfDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfMonth
	 * @category Month Helpers
	 * @summary Return the start of a month for the given date.
	 *
	 * @description
	 * Return the start of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a month for 2 September 2014 11:55:00:
	 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subDays;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(58));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subDays
	 * @category Day Helpers
	 * @summary Subtract the specified number of days from the given date.
	 *
	 * @description
	 * Subtract the specified number of days from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the days subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 10 days from 1 September 2014:
	 * const result = subDays(new Date(2014, 8, 1), 10)
	 * //=> Fri Aug 22 2014 00:00:00
	 */
	function subDays(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = __webpack_require__(1499)() ? globalThis : __webpack_require__(1498);


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	// JSTS. See https://github.com/bjornharrtell/jsts
	// Licenses:
	// https://github.com/bjornharrtell/jsts/blob/master/LICENSE_EDLv1.txt
	// https://github.com/bjornharrtell/jsts/blob/master/LICENSE_EPLv1.txt
	// https://github.com/bjornharrtell/jsts/blob/master/LICENSE_LICENSE_ES6_COLLECTIONS.txt
	!function(t,e){ true?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e(t.jsts=t.jsts||{})}(this,function(t){"use strict";function e(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])}function n(){}function i(){}function r(){}function s(){}function o(){}function a(){}function u(){}function l(t){this.message=t}function h(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t}function c(){if(0===arguments.length)l.call(this);else if(1===arguments.length){var t=arguments[0];l.call(this,t)}}function f(){}function g(){if(this.x=null,this.y=null,this.z=null,0===arguments.length)g.call(this,0,0);else if(1===arguments.length){var t=arguments[0];g.call(this,t.x,t.y,t.z)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];g.call(this,e,n,g.NULL_ORDINATE)}else if(3===arguments.length){var i=arguments[0],r=arguments[1],s=arguments[2];this.x=i,this.y=r,this.z=s}}function d(){if(this.dimensionsToTest=2,0===arguments.length)d.call(this,2);else if(1===arguments.length){var t=arguments[0];if(2!==t&&3!==t)throw new i("only 2 or 3 dimensions may be specified");this.dimensionsToTest=t}}function p(){}function v(){}function m(t){this.message=t||""}function y(){}function x(t){this.message=t||""}function E(t){this.message=t||""}function I(){this.array_=[],arguments[0]instanceof v&&this.addAll(arguments[0])}function N(){if(I.apply(this),0===arguments.length);else if(1===arguments.length){var t=arguments[0];this.ensureCapacity(t.length),this.add(t,!0)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this.ensureCapacity(e.length),this.add(e,n)}}function C(){if(this.minx=null,this.maxx=null,this.miny=null,this.maxy=null,0===arguments.length)this.init();else if(1===arguments.length){if(arguments[0]instanceof g){var t=arguments[0];this.init(t.x,t.x,t.y,t.y)}else if(arguments[0]instanceof C){var e=arguments[0];this.init(e)}}else if(2===arguments.length){var n=arguments[0],i=arguments[1];this.init(n.x,i.x,n.y,i.y)}else if(4===arguments.length){var r=arguments[0],s=arguments[1],o=arguments[2],a=arguments[3];this.init(r,s,o,a)}}function S(){}function w(){S.call(this,"Projective point not representable on the Cartesian plane.")}function L(){}function R(t,e){return t.interfaces_&&t.interfaces_().indexOf(e)>-1}function T(){}function P(t){this.str=t}function b(t){this.value=t}function O(){}function _(){if(this.hi=0,this.lo=0,0===arguments.length)this.init(0);else if(1===arguments.length){if("number"==typeof arguments[0]){var t=arguments[0];this.init(t)}else if(arguments[0]instanceof _){var e=arguments[0];this.init(e)}else if("string"==typeof arguments[0]){var n=arguments[0];_.call(this,_.parse(n))}}else if(2===arguments.length){var i=arguments[0],r=arguments[1];this.init(i,r)}}function M(){}function D(){}function A(){}function F(){if(this.x=null,this.y=null,this.w=null,0===arguments.length)this.x=0,this.y=0,this.w=1;else if(1===arguments.length){var t=arguments[0];this.x=t.x,this.y=t.y,this.w=1}else if(2===arguments.length){if("number"==typeof arguments[0]&&"number"==typeof arguments[1]){var e=arguments[0],n=arguments[1];this.x=e,this.y=n,this.w=1}else if(arguments[0]instanceof F&&arguments[1]instanceof F){var i=arguments[0],r=arguments[1];this.x=i.y*r.w-r.y*i.w,this.y=r.x*i.w-i.x*r.w,this.w=i.x*r.y-r.x*i.y}else if(arguments[0]instanceof g&&arguments[1]instanceof g){var s=arguments[0],o=arguments[1];this.x=s.y-o.y,this.y=o.x-s.x,this.w=s.x*o.y-o.x*s.y}}else if(3===arguments.length){var a=arguments[0],u=arguments[1],l=arguments[2];this.x=a,this.y=u,this.w=l}else if(4===arguments.length){var h=arguments[0],c=arguments[1],f=arguments[2],d=arguments[3],p=h.y-c.y,v=c.x-h.x,m=h.x*c.y-c.x*h.y,y=f.y-d.y,x=d.x-f.x,E=f.x*d.y-d.x*f.y;this.x=v*E-x*m,this.y=y*m-p*E,this.w=p*x-y*v}}function G(){}function q(){}function B(){this.envelope=null,this.factory=null,this.SRID=null,this.userData=null;var t=arguments[0];this.factory=t,this.SRID=t.getSRID()}function z(){}function V(){}function k(){}function Y(){}function U(){}function X(){}function H(){}function W(){}function j(){}function K(){}function Z(){}function Q(){}function J(){this.array_=[],arguments[0]instanceof v&&this.addAll(arguments[0])}function $(t){return null==t?$s:t.color}function tt(t){return null==t?null:t.parent}function et(t,e){null!==t&&(t.color=e)}function nt(t){return null==t?null:t.left}function it(t){return null==t?null:t.right}function rt(){this.root_=null,this.size_=0}function st(){}function ot(){}function at(){this.array_=[],arguments[0]instanceof v&&this.addAll(arguments[0])}function ut(){}function lt(){}function ht(){}function ct(){}function ft(){this.geometries=null;var t=arguments[0],e=arguments[1];if(B.call(this,e),null===t&&(t=[]),B.hasNullElements(t))throw new i("geometries must not contain null elements");this.geometries=t}function gt(){var t=arguments[0],e=arguments[1];ft.call(this,t,e)}function dt(){if(this.geom=null,this.geomFact=null,this.bnRule=null,this.endpointMap=null,1===arguments.length){var t=arguments[0];dt.call(this,t,V.MOD2_BOUNDARY_RULE)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this.geom=e,this.geomFact=e.getFactory(),this.bnRule=n}}function pt(){this.count=null}function vt(){}function mt(){}function yt(){}function xt(){}function Et(){}function It(){}function Nt(){}function Ct(){}function St(){this.points=null;var t=arguments[0],e=arguments[1];B.call(this,e),this.init(t)}function wt(){}function Lt(){this.coordinates=null;var t=arguments[0],e=arguments[1];B.call(this,e),this.init(t)}function Rt(){}function Tt(){this.shell=null,this.holes=null;var t=arguments[0],e=arguments[1],n=arguments[2];if(B.call(this,n),null===t&&(t=this.getFactory().createLinearRing()),null===e&&(e=[]),B.hasNullElements(e))throw new i("holes must not contain null elements");if(t.isEmpty()&&B.hasNonEmptyElements(e))throw new i("shell is empty but holes are not");this.shell=t,this.holes=e}function Pt(){var t=arguments[0],e=arguments[1];ft.call(this,t,e)}function bt(){if(arguments[0]instanceof g&&arguments[1]instanceof ie){var t=arguments[0],e=arguments[1];bt.call(this,e.getCoordinateSequenceFactory().create(t),e)}else if(R(arguments[0],D)&&arguments[1]instanceof ie){var n=arguments[0],i=arguments[1];St.call(this,n,i),this.validateConstruction()}}function Ot(){var t=arguments[0],e=arguments[1];ft.call(this,t,e)}function _t(){if(this.factory=null,this.isUserDataCopied=!1,0===arguments.length);else if(1===arguments.length){var t=arguments[0];this.factory=t}}function Mt(){}function Dt(){}function At(){}function Ft(){}function Gt(){if(this.dimension=3,this.coordinates=null,1===arguments.length){if(arguments[0]instanceof Array){var t=arguments[0];Gt.call(this,t,3)}else if(Number.isInteger(arguments[0])){var e=arguments[0];this.coordinates=new Array(e).fill(null);for(var n=0;e>n;n++)this.coordinates[n]=new g}else if(R(arguments[0],D)){var i=arguments[0];if(null===i)return this.coordinates=new Array(0).fill(null),null;this.dimension=i.getDimension(),this.coordinates=new Array(i.size()).fill(null);for(var n=0;n<this.coordinates.length;n++)this.coordinates[n]=i.getCoordinateCopy(n)}}else if(2===arguments.length)if(arguments[0]instanceof Array&&Number.isInteger(arguments[1])){var r=arguments[0],s=arguments[1];this.coordinates=r,this.dimension=s,null===r&&(this.coordinates=new Array(0).fill(null))}else if(Number.isInteger(arguments[0])&&Number.isInteger(arguments[1])){var o=arguments[0],a=arguments[1];this.coordinates=new Array(o).fill(null),this.dimension=a;for(var n=0;o>n;n++)this.coordinates[n]=new g}}function qt(){}function Bt(t,e){return t===e||t!==t&&e!==e}function zt(t,e){function n(t){return this&&this.constructor===n?(this._keys=[],this._values=[],this._itp=[],this.objectOnly=e,void(t&&Vt.call(this,t))):new n(t)}return e||io(t,"size",{get:Jt}),t.constructor=n,n.prototype=t,n}function Vt(t){this.add?t.forEach(this.add,this):t.forEach(function(t){this.set(t[0],t[1])},this)}function kt(t){return this.has(t)&&(this._keys.splice(no,1),this._values.splice(no,1),this._itp.forEach(function(t){no<t[0]&&t[0]--})),no>-1}function Yt(t){return this.has(t)?this._values[no]:void 0}function Ut(t,e){if(this.objectOnly&&e!==Object(e))throw new TypeError("Invalid value used as weak collection key");if(e!==e||0===e)for(no=t.length;no--&&!Bt(t[no],e););else no=t.indexOf(e);return no>-1}function Xt(t){return Ut.call(this,this._keys,t)}function Ht(t,e){return this.has(t)?this._values[no]=e:this._values[this._keys.push(t)-1]=e,this}function Wt(){(this._keys||0).length=this._values.length=0}function jt(){return Qt(this._itp,this._keys)}function Kt(){return Qt(this._itp,this._values)}function Zt(){return Qt(this._itp,this._keys,this._values)}function Qt(t,e,n){var i=[0],r=!1;return t.push(i),{next:function(){var s,o=i[0];return!r&&o<e.length?(s=n?[e[o],n[o]]:e[o],i[0]++):(r=!0,t.splice(t.indexOf(i),1)),{done:r,value:s}}}}function Jt(){return this._values.length}function $t(t,e){for(var n=this.entries();;){var i=n.next();if(i.done)break;t.call(e,i.value[1],i.value[0],this)}}function te(){this.map_=new so}function ee(){if(this.modelType=null,this.scale=null,0===arguments.length)this.modelType=ee.FLOATING;else if(1===arguments.length)if(arguments[0]instanceof ne){var t=arguments[0];this.modelType=t,t===ee.FIXED&&this.setScale(1)}else if("number"==typeof arguments[0]){var e=arguments[0];this.modelType=ee.FIXED,this.setScale(e)}else if(arguments[0]instanceof ee){var n=arguments[0];this.modelType=n.modelType,this.scale=n.scale}}function ne(){this.name=null;var t=arguments[0];this.name=t,ne.nameToTypeMap.put(t,this)}function ie(){if(this.precisionModel=null,this.coordinateSequenceFactory=null,this.SRID=null,0===arguments.length)ie.call(this,new ee,0);else if(1===arguments.length){if(R(arguments[0],G)){var t=arguments[0];ie.call(this,new ee,0,t)}else if(arguments[0]instanceof ee){var e=arguments[0];ie.call(this,e,0,ie.getDefaultCoordinateSequenceFactory())}}else if(2===arguments.length){var n=arguments[0],i=arguments[1];ie.call(this,n,i,ie.getDefaultCoordinateSequenceFactory())}else if(3===arguments.length){var r=arguments[0],s=arguments[1],o=arguments[2];this.precisionModel=r,this.coordinateSequenceFactory=o,this.SRID=s}}function re(t){this.geometryFactory=t||new ie}function se(t){this.parser=new re(t)}function oe(){this.result=null,this.inputLines=Array(2).fill().map(function(){return Array(2)}),this.intPt=new Array(2).fill(null),this.intLineIndex=null,this._isProper=null,this.pa=null,this.pb=null,this.precisionModel=null,this.intPt[0]=new g,this.intPt[1]=new g,this.pa=this.intPt[0],this.pb=this.intPt[1],this.result=0}function ae(){oe.apply(this)}function ue(){}function le(){this.p=null,this.crossingCount=0,this.isPointOnSegment=!1;var t=arguments[0];this.p=t}function he(){}function ce(){if(this.p0=null,this.p1=null,0===arguments.length)ce.call(this,new g,new g);else if(1===arguments.length){var t=arguments[0];ce.call(this,t.p0,t.p1)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this.p0=e,this.p1=n}else if(4===arguments.length){var i=arguments[0],r=arguments[1],s=arguments[2],o=arguments[3];ce.call(this,new g(i,r),new g(s,o))}}function fe(){if(this.matrix=null,0===arguments.length)this.matrix=Array(3).fill().map(function(){return Array(3)}),this.setAll(lt.FALSE);else if(1===arguments.length)if("string"==typeof arguments[0]){var t=arguments[0];fe.call(this),this.set(t)}else if(arguments[0]instanceof fe){var e=arguments[0];fe.call(this),this.matrix[L.INTERIOR][L.INTERIOR]=e.matrix[L.INTERIOR][L.INTERIOR],this.matrix[L.INTERIOR][L.BOUNDARY]=e.matrix[L.INTERIOR][L.BOUNDARY],this.matrix[L.INTERIOR][L.EXTERIOR]=e.matrix[L.INTERIOR][L.EXTERIOR],this.matrix[L.BOUNDARY][L.INTERIOR]=e.matrix[L.BOUNDARY][L.INTERIOR],this.matrix[L.BOUNDARY][L.BOUNDARY]=e.matrix[L.BOUNDARY][L.BOUNDARY],this.matrix[L.BOUNDARY][L.EXTERIOR]=e.matrix[L.BOUNDARY][L.EXTERIOR],this.matrix[L.EXTERIOR][L.INTERIOR]=e.matrix[L.EXTERIOR][L.INTERIOR],this.matrix[L.EXTERIOR][L.BOUNDARY]=e.matrix[L.EXTERIOR][L.BOUNDARY],this.matrix[L.EXTERIOR][L.EXTERIOR]=e.matrix[L.EXTERIOR][L.EXTERIOR]}}function ge(){this.areaBasePt=null,this.triangleCent3=new g,this.areasum2=0,this.cg3=new g,this.lineCentSum=new g,this.totalLength=0,this.ptCount=0,this.ptCentSum=new g;var t=arguments[0];this.areaBasePt=null,this.add(t)}function de(t){this.message=t||""}function pe(){this.array_=[]}function ve(){this.treeSet=new at,this.list=new I}function me(){if(this.geomFactory=null,this.inputPts=null,1===arguments.length){var t=arguments[0];me.call(this,me.extractCoordinates(t),t.getFactory())}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this.inputPts=ve.filterCoordinates(e),this.geomFactory=n}}function ye(){this.origin=null;var t=arguments[0];this.origin=t}function xe(){this.inputGeom=null,this.factory=null,this.pruneEmptyGeometry=!0,this.preserveGeometryCollectionType=!0,this.preserveCollections=!1,this.preserveType=!1}function Ee(){if(this.snapTolerance=0,this.srcPts=null,this.seg=new ce,this.allowSnappingToSourceVertices=!1,this._isClosed=!1,arguments[0]instanceof St&&"number"==typeof arguments[1]){var t=arguments[0],e=arguments[1];Ee.call(this,t.getCoordinates(),e)}else if(arguments[0]instanceof Array&&"number"==typeof arguments[1]){var n=arguments[0],i=arguments[1];this.srcPts=n,this._isClosed=Ee.isClosed(n),this.snapTolerance=i}}function Ie(){this.srcGeom=null;var t=arguments[0];this.srcGeom=t}function Ne(){if(xe.apply(this),this.snapTolerance=null,this.snapPts=null,this.isSelfSnap=!1,2===arguments.length){var t=arguments[0],e=arguments[1];this.snapTolerance=t,this.snapPts=e}else if(3===arguments.length){var n=arguments[0],i=arguments[1],r=arguments[2];this.snapTolerance=n,this.snapPts=i,this.isSelfSnap=r}}function Ce(){this.isFirst=!0,this.commonMantissaBitsCount=53,this.commonBits=0,this.commonSignExp=null}function Se(){this.commonCoord=null,this.ccFilter=new we}function we(){this.commonBitsX=new Ce,this.commonBitsY=new Ce}function Le(){this.trans=null;var t=arguments[0];this.trans=t}function Re(){this.parent=null,this.atStart=null,this.max=null,this.index=null,this.subcollectionIterator=null;var t=arguments[0];this.parent=t,this.atStart=!0,this.index=0,this.max=t.getNumGeometries()}function Te(){if(this.boundaryRule=V.OGC_SFS_BOUNDARY_RULE,this.isIn=null,this.numBoundaries=null,0===arguments.length);else if(1===arguments.length){var t=arguments[0];if(null===t)throw new i("Rule must be non-null");this.boundaryRule=t}}function Pe(){}function be(){}function Oe(){this.pts=null,this.data=null;var t=arguments[0],e=arguments[1];this.pts=t,this.data=e}function _e(){}function Me(){this.bounds=null,this.item=null;var t=arguments[0],e=arguments[1];this.bounds=t,this.item=e}function De(){this._size=null,this.items=null,this._size=0,this.items=new I,this.items.add(null)}function Ae(){}function Fe(){}function Ge(){if(this.childBoundables=new I,this.bounds=null,this.level=null,0===arguments.length);else if(1===arguments.length){var t=arguments[0];this.level=t}}function qe(){this.boundable1=null,this.boundable2=null,this._distance=null,this.itemDistance=null;var t=arguments[0],e=arguments[1],n=arguments[2];this.boundable1=t,this.boundable2=e,this.itemDistance=n,this._distance=this.distance()}function Be(){if(this.root=null,this.built=!1,this.itemBoundables=new I,this.nodeCapacity=null,0===arguments.length)Be.call(this,Be.DEFAULT_NODE_CAPACITY);else if(1===arguments.length){var t=arguments[0];f.isTrue(t>1,"Node capacity must be greater than 1"),this.nodeCapacity=t}}function ze(){}function Ve(){}function ke(){if(0===arguments.length)ke.call(this,ke.DEFAULT_NODE_CAPACITY);else if(1===arguments.length){var t=arguments[0];Be.call(this,t)}}function Ye(){var t=arguments[0];Ge.call(this,t)}function Ue(){}function Xe(){this.segString=null,this.coord=null,this.segmentIndex=null,this.segmentOctant=null,this._isInterior=null;var t=arguments[0],e=arguments[1],n=arguments[2],i=arguments[3];this.segString=t,this.coord=new g(e),this.segmentIndex=n,this.segmentOctant=i,this._isInterior=!e.equals2D(t.getCoordinate(n))}function He(){this.nodeMap=new rt,this.edge=null;var t=arguments[0];this.edge=t}function We(){this.nodeList=null,this.edge=null,this.nodeIt=null,this.currNode=null,this.nextNode=null,this.currSegIndex=0;var t=arguments[0];this.nodeList=t,this.edge=t.getEdge(),this.nodeIt=t.iterator(),this.readNextNode()}function je(){}function Ke(){this.nodeList=new He(this),this.pts=null,this.data=null;var t=arguments[0],e=arguments[1];this.pts=t,this.data=e}function Ze(){this.tempEnv1=new C,this.tempEnv2=new C,this.overlapSeg1=new ce,this.overlapSeg2=new ce}function Qe(){this.pts=null,this.start=null,this.end=null,this.env=null,this.context=null,this.id=null;var t=arguments[0],e=arguments[1],n=arguments[2],i=arguments[3];this.pts=t,this.start=e,this.end=n,this.context=i}function Je(){}function $e(){}function tn(){}function en(){if(this.segInt=null,0===arguments.length);else if(1===arguments.length){var t=arguments[0];this.setSegmentIntersector(t)}}function nn(){if(this.monoChains=new I,this.index=new ke,this.idCounter=0,this.nodedSegStrings=null,this.nOverlaps=0,0===arguments.length);else if(1===arguments.length){var t=arguments[0];en.call(this,t)}}function rn(){Ze.apply(this),this.si=null;var t=arguments[0];this.si=t}function sn(){if(this.pt=null,1===arguments.length){var t=arguments[0];l.call(this,t)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];l.call(this,sn.msgWithCoord(e,n)),this.pt=new g(n)}}function on(){}function an(){this.findAllIntersections=!1,this.isCheckEndSegmentsOnly=!1,this.li=null,this.interiorIntersection=null,this.intSegments=null,this.intersections=new I,this.intersectionCount=0,this.keepIntersections=!0;var t=arguments[0];this.li=t,this.interiorIntersection=null}function un(){this.li=new ae,this.segStrings=null,this.findAllIntersections=!1,this.segInt=null,this._isValid=!0;var t=arguments[0];this.segStrings=t}function ln(){this.nv=null;var t=arguments[0];this.nv=new un(ln.toSegmentStrings(t))}function hn(){this.mapOp=null;var t=arguments[0];this.mapOp=t}function cn(){}function fn(){if(this.location=null,1===arguments.length){if(arguments[0]instanceof Array){var t=arguments[0];this.init(t.length)}else if(Number.isInteger(arguments[0])){var e=arguments[0];this.init(1),this.location[cn.ON]=e}else if(arguments[0]instanceof fn){var n=arguments[0];if(this.init(n.location.length),null!==n)for(var i=0;i<this.location.length;i++)this.location[i]=n.location[i]}}else if(3===arguments.length){var r=arguments[0],s=arguments[1],o=arguments[2];this.init(3),this.location[cn.ON]=r,this.location[cn.LEFT]=s,this.location[cn.RIGHT]=o}}function gn(){if(this.elt=new Array(2).fill(null),1===arguments.length){if(Number.isInteger(arguments[0])){var t=arguments[0];this.elt[0]=new fn(t),this.elt[1]=new fn(t)}else if(arguments[0]instanceof gn){var e=arguments[0];this.elt[0]=new fn(e.elt[0]),this.elt[1]=new fn(e.elt[1])}}else if(2===arguments.length){var n=arguments[0],i=arguments[1];this.elt[0]=new fn(L.NONE),this.elt[1]=new fn(L.NONE),this.elt[n].setLocation(i)}else if(3===arguments.length){var r=arguments[0],s=arguments[1],o=arguments[2];this.elt[0]=new fn(r,s,o),this.elt[1]=new fn(r,s,o)}else if(4===arguments.length){var a=arguments[0],u=arguments[1],l=arguments[2],h=arguments[3];this.elt[0]=new fn(L.NONE,L.NONE,L.NONE),this.elt[1]=new fn(L.NONE,L.NONE,L.NONE),this.elt[a].setLocations(u,l,h)}}function dn(){this.startDe=null,this.maxNodeDegree=-1,this.edges=new I,this.pts=new I,this.label=new gn(L.NONE),this.ring=null,this._isHole=null,this.shell=null,this.holes=new I,this.geometryFactory=null;var t=arguments[0],e=arguments[1];this.geometryFactory=e,this.computePoints(t),this.computeRing()}function pn(){var t=arguments[0],e=arguments[1];dn.call(this,t,e)}function vn(){var t=arguments[0],e=arguments[1];dn.call(this,t,e)}function mn(){if(this.label=null,this._isInResult=!1,this._isCovered=!1,this._isCoveredSet=!1,this._isVisited=!1,0===arguments.length);else if(1===arguments.length){var t=arguments[0];this.label=t}}function yn(){mn.apply(this),this.coord=null,this.edges=null;var t=arguments[0],e=arguments[1];this.coord=t,this.edges=e,this.label=new gn(0,L.NONE)}function xn(){this.nodeMap=new rt,this.nodeFact=null;var t=arguments[0];this.nodeFact=t}function En(){if(this.edge=null,this.label=null,this.node=null,this.p0=null,this.p1=null,this.dx=null,this.dy=null,this.quadrant=null,1===arguments.length){var t=arguments[0];this.edge=t}else if(3===arguments.length){var e=arguments[0],n=arguments[1],i=arguments[2];En.call(this,e,n,i,null)}else if(4===arguments.length){var r=arguments[0],s=arguments[1],o=arguments[2],a=arguments[3];En.call(this,r),this.init(s,o),this.label=a}}function In(){this._isForward=null,this._isInResult=!1,this._isVisited=!1,this.sym=null,this.next=null,this.nextMin=null,this.edgeRing=null,this.minEdgeRing=null,this.depth=[0,-999,-999];var t=arguments[0],e=arguments[1];if(En.call(this,t),this._isForward=e,e)this.init(t.getCoordinate(0),t.getCoordinate(1));else{var n=t.getNumPoints()-1;this.init(t.getCoordinate(n),t.getCoordinate(n-1))}this.computeDirectedLabel()}function Nn(){}function Cn(){if(this.edges=new I,this.nodes=null,this.edgeEndList=new I,0===arguments.length)this.nodes=new xn(new Nn);else if(1===arguments.length){var t=arguments[0];this.nodes=new xn(t)}}function Sn(){this.geometryFactory=null,this.shellList=new I;var t=arguments[0];this.geometryFactory=t}function wn(){this.op=null,this.geometryFactory=null,this.ptLocator=null,this.lineEdgesList=new I,this.resultLineList=new I;var t=arguments[0],e=arguments[1],n=arguments[2];this.op=t,this.geometryFactory=e,this.ptLocator=n}function Ln(){this.op=null,this.geometryFactory=null,this.resultPointList=new I;var t=arguments[0],e=arguments[1];arguments[2];this.op=t,this.geometryFactory=e}function Rn(){}function Tn(){this.geom=null;var t=arguments[0];this.geom=t}function Pn(){this.edgeMap=new rt,this.edgeList=null,this.ptInAreaLocation=[L.NONE,L.NONE]}function bn(){Pn.apply(this),this.resultAreaEdgeList=null,this.label=null,this.SCANNING_FOR_INCOMING=1,this.LINKING_TO_OUTGOING=2}function On(){Nn.apply(this)}function _n(){this.mce=null,this.chainIndex=null;var t=arguments[0],e=arguments[1];this.mce=t,this.chainIndex=e}function Mn(){if(this.label=null,this.xValue=null,this.eventType=null,this.insertEvent=null,this.deleteEventIndex=null,this.obj=null,2===arguments.length){var t=arguments[0],e=arguments[1];this.eventType=Mn.DELETE,this.xValue=t,this.insertEvent=e}else if(3===arguments.length){var n=arguments[0],i=arguments[1],r=arguments[2];this.eventType=Mn.INSERT,this.label=n,this.xValue=i,this.obj=r}}function Dn(){}function An(){this._hasIntersection=!1,this.hasProper=!1,this.hasProperInterior=!1,this.properIntersectionPoint=null,this.li=null,this.includeProper=null,this.recordIsolated=null,this.isSelfIntersection=null,this.numIntersections=0,this.numTests=0,this.bdyNodes=null,this._isDone=!1,this.isDoneWhenProperInt=!1;var t=arguments[0],e=arguments[1],n=arguments[2];this.li=t,this.includeProper=e,this.recordIsolated=n}function Fn(){Dn.apply(this),this.events=new I,this.nOverlaps=null}function Gn(){this.min=r.POSITIVE_INFINITY,this.max=r.NEGATIVE_INFINITY}function qn(){}function Bn(){Gn.apply(this),this.item=null;var t=arguments[0],e=arguments[1],n=arguments[2];this.min=t,this.max=e,this.item=n}function zn(){Gn.apply(this),this.node1=null,this.node2=null;var t=arguments[0],e=arguments[1];this.node1=t,this.node2=e,this.buildExtent(this.node1,this.node2)}function Vn(){this.leaves=new I,this.root=null,this.level=0}function kn(){if(this.lines=null,this.isForcedToLineString=!1,1===arguments.length){var t=arguments[0];this.lines=t}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this.lines=e,this.isForcedToLineString=n}}function Yn(){this.items=new I}function Un(){this.index=null;var t=arguments[0];if(!R(t,Rt))throw new i("Argument must be Polygonal");this.index=new Hn(t)}function Xn(){this.counter=null;var t=arguments[0];this.counter=t}function Hn(){this.index=new Vn;var t=arguments[0];this.init(t)}function Wn(){this.coord=null,this.segmentIndex=null,this.dist=null;var t=arguments[0],e=arguments[1],n=arguments[2];this.coord=new g(t),this.segmentIndex=e,this.dist=n}function jn(){this.nodeMap=new rt,this.edge=null;var t=arguments[0];this.edge=t}function Kn(){}function Zn(){this.e=null,this.pts=null,this.startIndex=null,this.env1=new C,this.env2=new C;var t=arguments[0];this.e=t,this.pts=t.getCoordinates();var e=new Kn;this.startIndex=e.getChainStartIndices(this.pts)}function Qn(){this.depth=Array(2).fill().map(function(){return Array(3)});for(var t=0;2>t;t++)for(var e=0;3>e;e++)this.depth[t][e]=Qn.NULL_VALUE}function Jn(){if(mn.apply(this),this.pts=null,this.env=null,this.eiList=new jn(this),this.name=null,this.mce=null,this._isIsolated=!0,this.depth=new Qn,this.depthDelta=0,1===arguments.length){var t=arguments[0];Jn.call(this,t,null)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this.pts=e,this.label=n}}function $n(){if(Cn.apply(this),this.parentGeom=null,this.lineEdgeMap=new te,this.boundaryNodeRule=null,this.useBoundaryDeterminationRule=!0,this.argIndex=null,this.boundaryNodes=null,this._hasTooFewPoints=!1,this.invalidPoint=null,this.areaPtLocator=null,this.ptLocator=new Te,2===arguments.length){var t=arguments[0],e=arguments[1];$n.call(this,t,e,V.OGC_SFS_BOUNDARY_RULE)}else if(3===arguments.length){var n=arguments[0],i=arguments[1],r=arguments[2];this.argIndex=n,this.parentGeom=i,this.boundaryNodeRule=r,null!==i&&this.add(i)}}function ti(){if(this.li=new ae,this.resultPrecisionModel=null,this.arg=null,1===arguments.length){var t=arguments[0];this.setComputationPrecision(t.getPrecisionModel()),this.arg=new Array(1).fill(null),this.arg[0]=new $n(0,t)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];ti.call(this,e,n,V.OGC_SFS_BOUNDARY_RULE)}else if(3===arguments.length){var i=arguments[0],r=arguments[1],s=arguments[2];i.getPrecisionModel().compareTo(r.getPrecisionModel())>=0?this.setComputationPrecision(i.getPrecisionModel()):this.setComputationPrecision(r.getPrecisionModel()),this.arg=new Array(2).fill(null),this.arg[0]=new $n(0,i,s),this.arg[1]=new $n(1,r,s)}}function ei(){this.pts=null,this._orientation=null;var t=arguments[0];this.pts=t,this._orientation=ei.orientation(t)}function ni(){this.edges=new I,this.ocaMap=new rt}function ii(){this.ptLocator=new Te,this.geomFact=null,this.resultGeom=null,this.graph=null,this.edgeList=new ni,this.resultPolyList=new I,this.resultLineList=new I,this.resultPointList=new I;var t=arguments[0],e=arguments[1];ti.call(this,t,e),this.graph=new Cn(new On),this.geomFact=t.getFactory()}function ri(){this.geom=new Array(2).fill(null),this.snapTolerance=null,this.cbr=null;var t=arguments[0],e=arguments[1];this.geom[0]=t,this.geom[1]=e,this.computeSnapTolerance()}function si(){this.geom=new Array(2).fill(null);var t=arguments[0],e=arguments[1];this.geom[0]=t,this.geom[1]=e}function oi(){this.factory=null,this.interiorPoint=null,this.maxWidth=0;var t=arguments[0];this.factory=t.getFactory(),this.add(t)}function ai(){this.poly=null,this.centreY=null,this.hiY=r.MAX_VALUE,this.loY=-r.MAX_VALUE;var t=arguments[0];this.poly=t,this.hiY=t.getEnvelopeInternal().getMaxY(),this.loY=t.getEnvelopeInternal().getMinY(),this.centreY=oi.avg(this.loY,this.hiY)}function ui(){this.centroid=null,this.minDistance=r.MAX_VALUE,this.interiorPoint=null;var t=arguments[0];this.centroid=t.getCentroid().getCoordinate(),this.addInterior(t),null===this.interiorPoint&&this.addEndpoints(t)}function li(){this.centroid=null,this.minDistance=r.MAX_VALUE,this.interiorPoint=null;var t=arguments[0];this.centroid=t.getCentroid().getCoordinate(),this.add(t)}function hi(){}function ci(){this.p0=null,this.p1=null,this.p2=null;var t=arguments[0],e=arguments[1],n=arguments[2];this.p0=t,this.p1=e,this.p2=n}function fi(){this.input=null,this.extremalPts=null,this.centre=null,this.radius=0;var t=arguments[0];this.input=t}function gi(){if(this.inputGeom=null,this.isConvex=null,this.convexHullPts=null,this.minBaseSeg=new ce,this.minWidthPt=null,this.minPtIndex=null,this.minWidth=0,1===arguments.length){var t=arguments[0];gi.call(this,t,!1)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this.inputGeom=e,this.isConvex=n}}function di(){this.inputGeom=null,this.distanceTolerance=null;var t=arguments[0];this.inputGeom=t}function pi(){xe.apply(this),this.distanceTolerance=null;var t=arguments[0];this.distanceTolerance=t}function vi(){this._orig=null,this._sym=null,this._next=null;var t=arguments[0];this._orig=t}function mi(){this._isMarked=!1;var t=arguments[0];vi.call(this,t)}function yi(){this.vertexMap=new te}function xi(){this._isStart=!1;var t=arguments[0];mi.call(this,t)}function Ei(){yi.apply(this)}function Ii(){this.result=null,this.factory=null,this.graph=null,this.lines=new I,this.nodeEdgeStack=new pe,this.ringStartEdge=null,this.graph=new Ei}function Ni(){this.items=new I,this.subnode=new Array(4).fill(null)}function Ci(){}function Si(t,e){var n,i,r,s,o={32:{d:127,c:128,b:0,a:0},64:{d:32752,c:0,b:0,a:0}},a={32:8,64:11}[t];if(s||(n=0>e||0>1/e,isFinite(e)||(s=o[t],n&&(s.d+=1<<t/4-1),i=Math.pow(2,a)-1,r=0)),!s){for(i={32:127,64:1023}[t],r=Math.abs(e);r>=2;)i++,r/=2;for(;1>r&&i>0;)i--,r*=2;0>=i&&(r/=2),32===t&&i>254&&(s={d:n?255:127,c:128,b:0,a:0},i=Math.pow(2,a)-1,r=0)}return i}function wi(){this.pt=new g,this.level=0,this.env=null;var t=arguments[0];this.computeKey(t)}function Li(){Ni.apply(this),this.env=null,this.centrex=null,this.centrey=null,this.level=null;var t=arguments[0],e=arguments[1];this.env=t,this.level=e,this.centrex=(t.getMinX()+t.getMaxX())/2,this.centrey=(t.getMinY()+t.getMaxY())/2}function Ri(){}function Ti(){Ni.apply(this)}function Pi(){this.root=null,this.minExtent=1,this.root=new Ti}function bi(t){this.geometryFactory=t||new ie}function Oi(t){this.geometryFactory=t||new ie,this.precisionModel=this.geometryFactory.getPrecisionModel(),this.parser=new bi(this.geometryFactory)}function _i(){this.parser=new bi(this.geometryFactory)}function Mi(t){this.geometryFactory=t||new ie,this.precisionModel=this.geometryFactory.getPrecisionModel(),this.parser=new re(this.geometryFactory)}function Di(t){return[t.x,t.y]}function Ai(t){this.geometryFactory=t||new ie}function Fi(){if(this.noder=null,this.scaleFactor=null,this.offsetX=null,this.offsetY=null,this.isScaled=!1,2===arguments.length){var t=arguments[0],e=arguments[1];Fi.call(this,t,e,0,0)}else if(4===arguments.length){var n=arguments[0],i=arguments[1];arguments[2],arguments[3];this.noder=n,this.scaleFactor=i,this.isScaled=!this.isIntegerPrecision()}}function Gi(){if(this.inputGeom=null,this.isClosedEndpointsInInterior=!0,this.nonSimpleLocation=null,1===arguments.length){var t=arguments[0];this.inputGeom=t}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this.inputGeom=e,this.isClosedEndpointsInInterior=!n.isInBoundary(2)}}function qi(){this.pt=null,this.isClosed=null,this.degree=null;var t=arguments[0];this.pt=t,this.isClosed=!1,this.degree=0}function Bi(){if(this.quadrantSegments=Bi.DEFAULT_QUADRANT_SEGMENTS,this.endCapStyle=Bi.CAP_ROUND,this.joinStyle=Bi.JOIN_ROUND,this.mitreLimit=Bi.DEFAULT_MITRE_LIMIT,this._isSingleSided=!1,this.simplifyFactor=Bi.DEFAULT_SIMPLIFY_FACTOR,0===arguments.length);else if(1===arguments.length){var t=arguments[0];this.setQuadrantSegments(t)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this.setQuadrantSegments(e),this.setEndCapStyle(n)}else if(4===arguments.length){var i=arguments[0],r=arguments[1],s=arguments[2],o=arguments[3];this.setQuadrantSegments(i),this.setEndCapStyle(r),this.setJoinStyle(s),this.setMitreLimit(o)}}function zi(){this.minIndex=-1,this.minCoord=null,this.minDe=null,this.orientedDe=null}function Vi(){this.array_=[]}function ki(){this.finder=null,this.dirEdgeList=new I,this.nodes=new I,this.rightMostCoord=null,this.env=null,this.finder=new zi}function Yi(){this.inputLine=null,
	this.distanceTol=null,this.isDeleted=null,this.angleOrientation=he.COUNTERCLOCKWISE;var t=arguments[0];this.inputLine=t}function Ui(){this.ptList=null,this.precisionModel=null,this.minimimVertexDistance=0,this.ptList=new I}function Xi(){this.maxCurveSegmentError=0,this.filletAngleQuantum=null,this.closingSegLengthFactor=1,this.segList=null,this.distance=0,this.precisionModel=null,this.bufParams=null,this.li=null,this.s0=null,this.s1=null,this.s2=null,this.seg0=new ce,this.seg1=new ce,this.offset0=new ce,this.offset1=new ce,this.side=0,this._hasNarrowConcaveAngle=!1;var t=arguments[0],e=arguments[1],n=arguments[2];this.precisionModel=t,this.bufParams=e,this.li=new ae,this.filletAngleQuantum=Math.PI/2/e.getQuadrantSegments(),e.getQuadrantSegments()>=8&&e.getJoinStyle()===Bi.JOIN_ROUND&&(this.closingSegLengthFactor=Xi.MAX_CLOSING_SEG_LEN_FACTOR),this.init(n)}function Hi(){this.distance=0,this.precisionModel=null,this.bufParams=null;var t=arguments[0],e=arguments[1];this.precisionModel=t,this.bufParams=e}function Wi(){this.subgraphs=null,this.seg=new ce,this.cga=new he;var t=arguments[0];this.subgraphs=t}function ji(){this.upwardSeg=null,this.leftDepth=null;var t=arguments[0],e=arguments[1];this.upwardSeg=new ce(t),this.leftDepth=e}function Ki(){this.inputGeom=null,this.distance=null,this.curveBuilder=null,this.curveList=new I;var t=arguments[0],e=arguments[1],n=arguments[2];this.inputGeom=t,this.distance=e,this.curveBuilder=n}function Zi(){this._hasIntersection=!1,this.hasProper=!1,this.hasProperInterior=!1,this.hasInterior=!1,this.properIntersectionPoint=null,this.li=null,this.isSelfIntersection=null,this.numIntersections=0,this.numInteriorIntersections=0,this.numProperIntersections=0,this.numTests=0;var t=arguments[0];this.li=t}function Qi(){this.bufParams=null,this.workingPrecisionModel=null,this.workingNoder=null,this.geomFact=null,this.graph=null,this.edgeList=new ni;var t=arguments[0];this.bufParams=t}function Ji(){this.li=new ae,this.segStrings=null;var t=arguments[0];this.segStrings=t}function $i(){this.li=null,this.pt=null,this.originalPt=null,this.ptScaled=null,this.p0Scaled=null,this.p1Scaled=null,this.scaleFactor=null,this.minx=null,this.maxx=null,this.miny=null,this.maxy=null,this.corner=new Array(4).fill(null),this.safeEnv=null;var t=arguments[0],e=arguments[1],n=arguments[2];if(this.originalPt=t,this.pt=t,this.scaleFactor=e,this.li=n,0>=e)throw new i("Scale factor must be non-zero");1!==e&&(this.pt=new g(this.scale(t.x),this.scale(t.y)),this.p0Scaled=new g,this.p1Scaled=new g),this.initCorners(this.pt)}function tr(){this.tempEnv1=new C,this.selectedSegment=new ce}function er(){this.index=null;var t=arguments[0];this.index=t}function nr(){tr.apply(this),this.hotPixel=null,this.parentEdge=null,this.hotPixelVertexIndex=null,this._isNodeAdded=!1;var t=arguments[0],e=arguments[1],n=arguments[2];this.hotPixel=t,this.parentEdge=e,this.hotPixelVertexIndex=n}function ir(){this.li=null,this.interiorIntersections=null;var t=arguments[0];this.li=t,this.interiorIntersections=new I}function rr(){this.pm=null,this.li=null,this.scaleFactor=null,this.noder=null,this.pointSnapper=null,this.nodedSegStrings=null;var t=arguments[0];this.pm=t,this.li=new ae,this.li.setPrecisionModel(t),this.scaleFactor=t.getScale()}function sr(){if(this.argGeom=null,this.distance=null,this.bufParams=new Bi,this.resultGeometry=null,this.saveException=null,1===arguments.length){var t=arguments[0];this.argGeom=t}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this.argGeom=e,this.bufParams=n}}function or(){this.comps=null;var t=arguments[0];this.comps=t}function ar(){if(this.component=null,this.segIndex=null,this.pt=null,2===arguments.length){var t=arguments[0],e=arguments[1];ar.call(this,t,ar.INSIDE_AREA,e)}else if(3===arguments.length){var n=arguments[0],i=arguments[1],r=arguments[2];this.component=n,this.segIndex=i,this.pt=r}}function ur(){this.pts=null;var t=arguments[0];this.pts=t}function lr(){this.locations=null;var t=arguments[0];this.locations=t}function hr(){if(this.geom=null,this.terminateDistance=0,this.ptLocator=new Te,this.minDistanceLocation=null,this.minDistance=r.MAX_VALUE,2===arguments.length){var t=arguments[0],e=arguments[1];hr.call(this,t,e,0)}else if(3===arguments.length){var n=arguments[0],i=arguments[1],s=arguments[2];this.geom=new Array(2).fill(null),this.geom[0]=n,this.geom[1]=i,this.terminateDistance=s}}function cr(){this.factory=null,this.directedEdges=new I,this.coordinates=null;var t=arguments[0];this.factory=t}function fr(){this._isMarked=!1,this._isVisited=!1,this.data=null}function gr(){fr.apply(this),this.parentEdge=null,this.from=null,this.to=null,this.p0=null,this.p1=null,this.sym=null,this.edgeDirection=null,this.quadrant=null,this.angle=null;var t=arguments[0],e=arguments[1],n=arguments[2],i=arguments[3];this.from=t,this.to=e,this.edgeDirection=i,this.p0=t.getCoordinate(),this.p1=n;var r=this.p1.x-this.p0.x,s=this.p1.y-this.p0.y;this.quadrant=Je.quadrant(r,s),this.angle=Math.atan2(s,r)}function dr(){var t=arguments[0],e=arguments[1],n=arguments[2],i=arguments[3];gr.call(this,t,e,n,i)}function pr(){if(fr.apply(this),this.dirEdge=null,0===arguments.length);else if(2===arguments.length){var t=arguments[0],e=arguments[1];this.setDirectedEdges(t,e)}}function vr(){this.outEdges=new I,this.sorted=!1}function mr(){if(fr.apply(this),this.pt=null,this.deStar=null,1===arguments.length){var t=arguments[0];mr.call(this,t,new vr)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this.pt=e,this.deStar=n}}function yr(){pr.apply(this),this.line=null;var t=arguments[0];this.line=t}function xr(){this.nodeMap=new rt}function Er(){this.edges=new J,this.dirEdges=new J,this.nodeMap=new xr}function Ir(){Er.apply(this)}function Nr(){this.graph=new Ir,this.mergedLineStrings=null,this.factory=null,this.edgeStrings=null}function Cr(){this.edgeRing=null,this.next=null,this.label=-1;var t=arguments[0],e=arguments[1],n=arguments[2],i=arguments[3];gr.call(this,t,e,n,i)}function Sr(){pr.apply(this),this.line=null;var t=arguments[0];this.line=t}function wr(){this.factory=null,this.deList=new I,this.lowestEdge=null,this.ring=null,this.ringPts=null,this.holes=null,this.shell=null,this._isHole=null,this._isProcessed=!1,this._isIncludedSet=!1,this._isIncluded=!1;var t=arguments[0];this.factory=t}function Lr(){}function Rr(){Er.apply(this),this.factory=null;var t=arguments[0];this.factory=t}function Tr(){if(this.lineStringAdder=new Pr(this),this.graph=null,this.dangles=new I,this.cutEdges=new I,this.invalidRingLines=new I,this.holeList=null,this.shellList=null,this.polyList=null,this.isCheckingRingsValid=!0,this.extractOnlyPolygonal=null,this.geomFactory=null,0===arguments.length)Tr.call(this,!1);else if(1===arguments.length){var t=arguments[0];this.extractOnlyPolygonal=t}}function Pr(){this.p=null;var t=arguments[0];this.p=t}function br(){}function Or(){if(this.edgeEnds=new I,1===arguments.length){var t=arguments[0];Or.call(this,null,t)}else if(2===arguments.length){var e=(arguments[0],arguments[1]);En.call(this,e.getEdge(),e.getCoordinate(),e.getDirectedCoordinate(),new gn(e.getLabel())),this.insert(e)}}function _r(){Pn.apply(this)}function Mr(){var t=arguments[0],e=arguments[1];yn.call(this,t,e)}function Dr(){Nn.apply(this)}function Ar(){this.li=new ae,this.ptLocator=new Te,this.arg=null,this.nodes=new xn(new Dr),this.im=null,this.isolatedEdges=new I,this.invalidPoint=null;var t=arguments[0];this.arg=t}function Fr(){this.rectEnv=null;var t=arguments[0];this.rectEnv=t.getEnvelopeInternal()}function Gr(){this.li=new ae,this.rectEnv=null,this.diagUp0=null,this.diagUp1=null,this.diagDown0=null,this.diagDown1=null;var t=arguments[0];this.rectEnv=t,this.diagUp0=new g(t.getMinX(),t.getMinY()),this.diagUp1=new g(t.getMaxX(),t.getMaxY()),this.diagDown0=new g(t.getMinX(),t.getMaxY()),this.diagDown1=new g(t.getMaxX(),t.getMinY())}function qr(){this._isDone=!1}function Br(){this.rectangle=null,this.rectEnv=null;var t=arguments[0];this.rectangle=t,this.rectEnv=t.getEnvelopeInternal()}function zr(){qr.apply(this),this.rectEnv=null,this._intersects=!1;var t=arguments[0];this.rectEnv=t}function Vr(){qr.apply(this),this.rectSeq=null,this.rectEnv=null,this._containsPoint=!1;var t=arguments[0];this.rectSeq=t.getExteriorRing().getCoordinateSequence(),this.rectEnv=t.getEnvelopeInternal()}function kr(){qr.apply(this),this.rectEnv=null,this.rectIntersector=null,this.hasIntersection=!1,this.p0=new g,this.p1=new g;var t=arguments[0];this.rectEnv=t.getEnvelopeInternal(),this.rectIntersector=new Gr(this.rectEnv)}function Yr(){if(this._relate=null,2===arguments.length){var t=arguments[0],e=arguments[1];ti.call(this,t,e),this._relate=new Ar(this.arg)}else if(3===arguments.length){var n=arguments[0],i=arguments[1],r=arguments[2];ti.call(this,n,i,r),this._relate=new Ar(this.arg)}}function Ur(){this.geomFactory=null,this.skipEmpty=!1,this.inputGeoms=null;var t=arguments[0];this.geomFactory=Ur.extractFactory(t),this.inputGeoms=t}function Xr(){this.pointGeom=null,this.otherGeom=null,this.geomFact=null;var t=arguments[0],e=arguments[1];this.pointGeom=t,this.otherGeom=e,this.geomFact=e.getFactory()}function Hr(){this.sortIndex=-1,this.comps=null;var t=arguments[0],e=arguments[1];this.sortIndex=t,this.comps=e}function Wr(){this.inputPolys=null,this.geomFactory=null;var t=arguments[0];this.inputPolys=t,null===this.inputPolys&&(this.inputPolys=new I)}function jr(){if(this.polygons=new I,this.lines=new I,this.points=new I,this.geomFact=null,1===arguments.length){if(R(arguments[0],v)){var t=arguments[0];this.extract(t)}else if(arguments[0]instanceof B){var e=arguments[0];this.extract(e)}}else if(2===arguments.length){var n=arguments[0],i=arguments[1];this.geomFact=i,this.extract(n)}}function Kr(){this.geometryFactory=new ie,this.geomGraph=null,this.disconnectedRingcoord=null;var t=arguments[0];this.geomGraph=t}function Zr(){this.items=new I,this.subnode=[null,null]}function Qr(){if(this.min=null,this.max=null,0===arguments.length)this.min=0,this.max=0;else if(1===arguments.length){var t=arguments[0];this.init(t.min,t.max)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this.init(e,n)}}function Jr(){this.pt=0,this.level=0,this.interval=null;var t=arguments[0];this.computeKey(t)}function $r(){Zr.apply(this),this.interval=null,this.centre=null,this.level=null;var t=arguments[0],e=arguments[1];this.interval=t,this.level=e,this.centre=(t.getMin()+t.getMax())/2}function ts(){Zr.apply(this)}function es(){this.root=null,this.minExtent=1,this.root=new ts}function ns(){}function is(){this.ring=null,this.tree=null,this.crossings=0,this.interval=new Qr;var t=arguments[0];this.ring=t,this.buildIndex()}function rs(){tr.apply(this),this.mcp=null,this.p=null;var t=arguments[0],e=arguments[1];this.mcp=t,this.p=e}function ss(){this.nodes=new xn(new Dr)}function os(){this.li=new ae,this.geomGraph=null,this.nodeGraph=new ss,this.invalidPoint=null;var t=arguments[0];this.geomGraph=t}function as(){this.graph=null,this.rings=new I,this.totalEnv=new C,this.index=null,this.nestedPt=null;var t=arguments[0];this.graph=t}function us(){if(this.errorType=null,this.pt=null,1===arguments.length){var t=arguments[0];us.call(this,t,null)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this.errorType=e,null!==n&&(this.pt=n.copy())}}function ls(){this.parentGeometry=null,this.isSelfTouchingRingFormingHoleValid=!1,this.validErr=null;var t=arguments[0];this.parentGeometry=t}function hs(){_t.CoordinateOperation.apply(this),this.targetPM=null,this.removeCollapsed=!0;var t=arguments[0],e=arguments[1];this.targetPM=t,this.removeCollapsed=e}function cs(){this.targetPM=null,this.removeCollapsed=!0,this.changePrecisionModel=!1,this.isPointwise=!1;var t=arguments[0];this.targetPM=t}function fs(){this.pts=null,this.usePt=null,this.distanceTolerance=null,this.seg=new ce;var t=arguments[0];this.pts=t}function gs(){this.inputGeom=null,this.distanceTolerance=null,this.isEnsureValidTopology=!0;var t=arguments[0];this.inputGeom=t}function ds(){xe.apply(this),this.isEnsureValidTopology=!0,this.distanceTolerance=null;var t=arguments[0],e=arguments[1];this.isEnsureValidTopology=t,this.distanceTolerance=e}function ps(){if(this.parent=null,this.index=null,2===arguments.length){var t=arguments[0],e=arguments[1];ps.call(this,t,e,null,-1)}else if(4===arguments.length){var n=arguments[0],i=arguments[1],r=arguments[2],s=arguments[3];ce.call(this,n,i),this.parent=r,this.index=s}}function vs(){if(this.parentLine=null,this.segs=null,this.resultSegs=new I,this.minimumSize=null,1===arguments.length){var t=arguments[0];vs.call(this,t,2)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this.parentLine=e,this.minimumSize=n,this.init()}}function ms(){this.index=new Pi}function ys(){this.querySeg=null,this.items=new I;var t=arguments[0];this.querySeg=t}function xs(){this.li=new ae,this.inputIndex=new ms,this.outputIndex=new ms,this.line=null,this.linePts=null,this.distanceTolerance=0;var t=arguments[0],e=arguments[1];this.inputIndex=t,this.outputIndex=e}function Es(){this.inputIndex=new ms,this.outputIndex=new ms,this.distanceTolerance=0}function Is(){this.inputGeom=null,this.lineSimplifier=new Es,this.linestringMap=null;var t=arguments[0];this.inputGeom=t}function Ns(){xe.apply(this),this.linestringMap=null;var t=arguments[0];this.linestringMap=t}function Cs(){this.tps=null;var t=arguments[0];this.tps=t}function Ss(){this.seg=null,this.segLen=null,this.splitPt=null,this.minimumLen=0;var t=arguments[0];this.seg=t,this.segLen=t.getLength()}function ws(){}function Ls(){}function Rs(){}function Ts(){if(this.p=null,1===arguments.length){var t=arguments[0];this.p=new g(t)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this.p=new g(e,n)}else if(3===arguments.length){var i=arguments[0],r=arguments[1],s=arguments[2];this.p=new g(i,r,s)}}function Ps(){this._isOnConstraint=null,this.constraint=null;var t=arguments[0];Ts.call(this,t)}function bs(){this._rot=null,this.vertex=null,this.next=null,this.data=null}function Os(){this.subdiv=null,this.isUsingTolerance=!1;var t=arguments[0];this.subdiv=t,this.isUsingTolerance=t.getTolerance()>0}function _s(){}function Ms(){this.subdiv=null,this.lastEdge=null;var t=arguments[0];this.subdiv=t,this.init()}function Ds(){if(this.seg=null,1===arguments.length){if("string"==typeof arguments[0]){var t=arguments[0];l.call(this,t)}else if(arguments[0]instanceof ce){var e=arguments[0];l.call(this,"Locate failed to converge (at edge: "+e+").  Possible causes include invalid Subdivision topology or very close sites"),this.seg=new ce(e)}}else if(2===arguments.length){var n=arguments[0],i=arguments[1];l.call(this,Ds.msgWithSpatial(n,i)),this.seg=new ce(i)}}function As(){}function Fs(){this.visitedKey=0,this.quadEdges=new I,this.startingEdge=null,this.tolerance=null,this.edgeCoincidenceTolerance=null,this.frameVertex=new Array(3).fill(null),this.frameEnv=null,this.locator=null,this.seg=new ce,this.triEdges=new Array(3).fill(null);var t=arguments[0],e=arguments[1];this.tolerance=e,this.edgeCoincidenceTolerance=e/Fs.EDGE_COINCIDENCE_TOL_FACTOR,this.createFrame(t),this.startingEdge=this.initSubdiv(),this.locator=new Ms(this)}function Gs(){}function qs(){this.triList=new I}function Bs(){this.triList=new I}function zs(){this.coordList=new N,this.triCoords=new I}function Vs(){if(this.ls=null,this.data=null,2===arguments.length){var t=arguments[0],e=arguments[1];this.ls=new ce(t,e)}else if(3===arguments.length){var n=arguments[0],i=arguments[1],r=arguments[2];this.ls=new ce(n,i),this.data=r}else if(6===arguments.length){var s=arguments[0],o=arguments[1],a=arguments[2],u=arguments[3],l=arguments[4],h=arguments[5];Vs.call(this,new g(s,o,a),new g(u,l,h))}else if(7===arguments.length){var c=arguments[0],f=arguments[1],d=arguments[2],p=arguments[3],v=arguments[4],m=arguments[5],y=arguments[6];Vs.call(this,new g(c,f,d),new g(p,v,m),y)}}function ks(){}function Ys(){if(this.p=null,this.data=null,this.left=null,this.right=null,this.count=null,2===arguments.length){var t=arguments[0],e=arguments[1];this.p=new g(t),this.left=null,this.right=null,this.count=1,this.data=e}else if(3===arguments.length){var n=arguments[0],i=arguments[1],r=arguments[2];this.p=new g(n,i),this.left=null,this.right=null,this.count=1,this.data=r}}function Us(){if(this.root=null,this.numberOfNodes=null,this.tolerance=null,0===arguments.length)Us.call(this,0);else if(1===arguments.length){var t=arguments[0];this.tolerance=t}}function Xs(){this.tolerance=null,this.matchNode=null,this.matchDist=0,this.p=null;var t=arguments[0],e=arguments[1];this.p=t,this.tolerance=e}function Hs(){this.initialVertices=null,this.segVertices=null,this.segments=new I,this.subdiv=null,this.incDel=null,this.convexHull=null,this.splitFinder=new Ls,this.kdt=null,this.vertexFactory=null,this.computeAreaEnv=null,this.splitPt=null,this.tolerance=null;var t=arguments[0],e=arguments[1];this.initialVertices=new I(t),this.tolerance=e,this.kdt=new Us(e)}function Ws(){this.siteCoords=null,this.tolerance=0,this.subdiv=null}function js(){this.siteCoords=null,this.constraintLines=null,this.tolerance=0,this.subdiv=null,this.constraintVertexMap=new rt}function Ks(){this.siteCoords=null,this.tolerance=0,this.subdiv=null,this.clipEnv=null,this.diagramEnv=null}function Zs(){}Array.prototype.fill||(Array.prototype.fill=function(t){for(var e=Object(this),n=parseInt(e.length,10),i=arguments[1],r=parseInt(i,10)||0,s=0>r?Math.max(n+r,0):Math.min(r,n),o=arguments[2],a=void 0===o?n:parseInt(o,10)||0,u=0>a?Math.max(n+a,0):Math.min(a,n);u>s;s++)e[s]=t;return e}),Number.isFinite=Number.isFinite||function(t){return"number"==typeof t&&isFinite(t)},Number.isInteger=Number.isInteger||function(t){return"number"==typeof t&&isFinite(t)&&Math.floor(t)===t},Number.parseFloat=Number.parseFloat||parseFloat,Number.isNaN=Number.isNaN||function(t){return t!==t},Math.trunc=Math.trunc||function(t){return 0>t?Math.ceil(t):Math.floor(t)},e(n.prototype,{interfaces_:function(){return[]},getClass:function(){return n}}),n.equalsWithTolerance=function(t,e,n){return Math.abs(t-e)<=n},r.isNaN=function(t){return Number.isNaN(t)},r.doubleToLongBits=function(t){return t},r.longBitsToDouble=function(t){return t},r.isInfinite=function(t){return!Number.isFinite(t)},r.MAX_VALUE=Number.MAX_VALUE,h(c,l),e(c.prototype,{interfaces_:function(){return[]},getClass:function(){return c}}),e(f.prototype,{interfaces_:function(){return[]},getClass:function(){return f}}),f.shouldNeverReachHere=function(){if(0===arguments.length)f.shouldNeverReachHere(null);else if(1===arguments.length){var t=arguments[0];throw new c("Should never reach here"+(null!==t?": "+t:""))}},f.isTrue=function(){if(1===arguments.length){var t=arguments[0];f.isTrue(t,null)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];if(!e)throw null===n?new c:new c(n)}},f.equals=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];f.equals(t,e,null)}else if(3===arguments.length){var n=arguments[0],i=arguments[1],r=arguments[2];if(!i.equals(n))throw new c("Expected "+n+" but encountered "+i+(null!==r?": "+r:""))}},e(g.prototype,{setOrdinate:function(t,e){switch(t){case g.X:this.x=e;break;case g.Y:this.y=e;break;case g.Z:this.z=e;break;default:throw new i("Invalid ordinate index: "+t)}},equals2D:function(){if(1===arguments.length){var t=arguments[0];return this.x!==t.x?!1:this.y===t.y}if(2===arguments.length){var e=arguments[0],i=arguments[1];return n.equalsWithTolerance(this.x,e.x,i)?!!n.equalsWithTolerance(this.y,e.y,i):!1}},getOrdinate:function(t){switch(t){case g.X:return this.x;case g.Y:return this.y;case g.Z:return this.z}throw new i("Invalid ordinate index: "+t)},equals3D:function(t){return this.x===t.x&&this.y===t.y&&(this.z===t.z||r.isNaN(this.z)&&r.isNaN(t.z))},equals:function(t){return t instanceof g?this.equals2D(t):!1},equalInZ:function(t,e){return n.equalsWithTolerance(this.z,t.z,e)},compareTo:function(t){var e=t;return this.x<e.x?-1:this.x>e.x?1:this.y<e.y?-1:this.y>e.y?1:0},clone:function(){try{var t=null;return t}catch(t){if(t instanceof CloneNotSupportedException)return f.shouldNeverReachHere("this shouldn't happen because this class is Cloneable"),null;throw t}finally{}},copy:function(){return new g(this)},toString:function(){return"("+this.x+", "+this.y+", "+this.z+")"},distance3D:function(t){var e=this.x-t.x,n=this.y-t.y,i=this.z-t.z;return Math.sqrt(e*e+n*n+i*i)},distance:function(t){var e=this.x-t.x,n=this.y-t.y;return Math.sqrt(e*e+n*n)},hashCode:function(){var t=17;return t=37*t+g.hashCode(this.x),t=37*t+g.hashCode(this.y)},setCoordinate:function(t){this.x=t.x,this.y=t.y,this.z=t.z},interfaces_:function(){return[s,o,u]},getClass:function(){return g}}),g.hashCode=function(){if(1===arguments.length){var t=arguments[0],e=r.doubleToLongBits(t);return Math.trunc(e^e>>>32)}},e(d.prototype,{compare:function(t,e){var n=t,i=e,r=d.compare(n.x,i.x);if(0!==r)return r;var s=d.compare(n.y,i.y);if(0!==s)return s;if(this.dimensionsToTest<=2)return 0;var o=d.compare(n.z,i.z);return o},interfaces_:function(){return[a]},getClass:function(){return d}}),d.compare=function(t,e){return e>t?-1:t>e?1:r.isNaN(t)?r.isNaN(e)?0:-1:r.isNaN(e)?1:0},g.DimensionalComparator=d,g.serialVersionUID=0x5cbf2c235c7e5800,g.NULL_ORDINATE=r.NaN,g.X=0,g.Y=1,g.Z=2,p.prototype.hasNext=function(){},p.prototype.next=function(){},p.prototype.remove=function(){},v.prototype.add=function(){},v.prototype.addAll=function(){},v.prototype.isEmpty=function(){},v.prototype.iterator=function(){},v.prototype.size=function(){},v.prototype.toArray=function(){},v.prototype.remove=function(){},m.prototype=new Error,m.prototype.name="IndexOutOfBoundsException",y.prototype=Object.create(v.prototype),y.prototype.constructor=y,y.prototype.get=function(){},y.prototype.set=function(){},y.prototype.isEmpty=function(){},x.prototype=new Error,x.prototype.name="NoSuchElementException",E.prototype=new Error,E.prototype.name="OperationNotSupported",I.prototype=Object.create(y.prototype),I.prototype.constructor=I,I.prototype.ensureCapacity=function(){},I.prototype.interfaces_=function(){return[y,v]},I.prototype.add=function(t){return this.array_.push(t),!0},I.prototype.clear=function(){this.array_=[]},I.prototype.addAll=function(t){for(var e=t.iterator();e.hasNext();)this.add(e.next());return!0},I.prototype.set=function(t,e){var n=this.array_[t];return this.array_[t]=e,n},I.prototype.iterator=function(){return new Qs(this)},I.prototype.get=function(t){if(0>t||t>=this.size())throw new m;return this.array_[t]},I.prototype.isEmpty=function(){return 0===this.array_.length},I.prototype.size=function(){return this.array_.length},I.prototype.toArray=function(){for(var t=[],e=0,n=this.array_.length;n>e;e++)t.push(this.array_[e]);return t},I.prototype.remove=function(t){for(var e=!1,n=0,i=this.array_.length;i>n;n++)if(this.array_[n]===t){this.array_.splice(n,1),e=!0;break}return e};var Qs=function(t){this.arrayList_=t,this.position_=0};Qs.prototype.next=function(){if(this.position_===this.arrayList_.size())throw new x;return this.arrayList_.get(this.position_++)},Qs.prototype.hasNext=function(){return this.position_<this.arrayList_.size()},Qs.prototype.set=function(t){return this.arrayList_.set(this.position_-1,t)},Qs.prototype.remove=function(){throw new E},h(N,I),e(N.prototype,{getCoordinate:function(t){return this.get(t)},addAll:function(){if(2===arguments.length){for(var t=arguments[0],e=arguments[1],n=!1,i=t.iterator();i.hasNext();)this.add(i.next(),e),n=!0;return n}return I.prototype.addAll.apply(this,arguments)},clone:function t(){for(var t=I.prototype.clone.call(this),e=0;e<this.size();e++)t.add(e,this.get(e).copy());return t},toCoordinateArray:function(){return this.toArray(N.coordArrayType)},add:function(){if(1===arguments.length){var t=arguments[0];I.prototype.add.call(this,t)}else if(2===arguments.length){if(arguments[0]instanceof Array&&"boolean"==typeof arguments[1]){var e=arguments[0],n=arguments[1];return this.add(e,n,!0),!0}if(arguments[0]instanceof g&&"boolean"==typeof arguments[1]){var i=arguments[0],r=arguments[1];if(!r&&this.size()>=1){var s=this.get(this.size()-1);if(s.equals2D(i))return null}I.prototype.add.call(this,i)}else if(arguments[0]instanceof Object&&"boolean"==typeof arguments[1]){var o=arguments[0],a=arguments[1];return this.add(o,a),!0}}else if(3===arguments.length){if("boolean"==typeof arguments[2]&&arguments[0]instanceof Array&&"boolean"==typeof arguments[1]){var u=arguments[0],l=arguments[1],h=arguments[2];if(h)for(var c=0;c<u.length;c++)this.add(u[c],l);else for(var c=u.length-1;c>=0;c--)this.add(u[c],l);return!0}if("boolean"==typeof arguments[2]&&Number.isInteger(arguments[0])&&arguments[1]instanceof g){var f=arguments[0],d=arguments[1],p=arguments[2];if(!p){var v=this.size();if(v>0){if(f>0){var m=this.get(f-1);if(m.equals2D(d))return null}if(v>f){var y=this.get(f);if(y.equals2D(d))return null}}}I.prototype.add.call(this,f,d)}}else if(4===arguments.length){var x=arguments[0],E=arguments[1],N=arguments[2],C=arguments[3],S=1;N>C&&(S=-1);for(var c=N;c!==C;c+=S)this.add(x[c],E);return!0}},closeRing:function(){this.size()>0&&this.add(new g(this.get(0)),!1)},interfaces_:function(){return[]},getClass:function(){return N}}),N.coordArrayType=new Array(0).fill(null),e(C.prototype,{getArea:function(){return this.getWidth()*this.getHeight()},equals:function(t){if(!(t instanceof C))return!1;var e=t;return this.isNull()?e.isNull():this.maxx===e.getMaxX()&&this.maxy===e.getMaxY()&&this.minx===e.getMinX()&&this.miny===e.getMinY()},intersection:function(t){if(this.isNull()||t.isNull()||!this.intersects(t))return new C;var e=this.minx>t.minx?this.minx:t.minx,n=this.miny>t.miny?this.miny:t.miny,i=this.maxx<t.maxx?this.maxx:t.maxx,r=this.maxy<t.maxy?this.maxy:t.maxy;return new C(e,i,n,r)},isNull:function(){return this.maxx<this.minx},getMaxX:function(){return this.maxx},covers:function(){if(1===arguments.length){if(arguments[0]instanceof g){var t=arguments[0];return this.covers(t.x,t.y)}if(arguments[0]instanceof C){var e=arguments[0];return this.isNull()||e.isNull()?!1:e.getMinX()>=this.minx&&e.getMaxX()<=this.maxx&&e.getMinY()>=this.miny&&e.getMaxY()<=this.maxy}}else if(2===arguments.length){var n=arguments[0],i=arguments[1];return this.isNull()?!1:n>=this.minx&&n<=this.maxx&&i>=this.miny&&i<=this.maxy}},intersects:function(){if(1===arguments.length){if(arguments[0]instanceof C){var t=arguments[0];return this.isNull()||t.isNull()?!1:!(t.minx>this.maxx||t.maxx<this.minx||t.miny>this.maxy||t.maxy<this.miny)}if(arguments[0]instanceof g){var e=arguments[0];return this.intersects(e.x,e.y)}}else if(2===arguments.length){var n=arguments[0],i=arguments[1];return this.isNull()?!1:!(n>this.maxx||n<this.minx||i>this.maxy||i<this.miny)}},getMinY:function(){return this.miny},getMinX:function(){return this.minx},expandToInclude:function(){if(1===arguments.length){if(arguments[0]instanceof g){var t=arguments[0];this.expandToInclude(t.x,t.y)}else if(arguments[0]instanceof C){var e=arguments[0];if(e.isNull())return null;this.isNull()?(this.minx=e.getMinX(),this.maxx=e.getMaxX(),this.miny=e.getMinY(),this.maxy=e.getMaxY()):(e.minx<this.minx&&(this.minx=e.minx),e.maxx>this.maxx&&(this.maxx=e.maxx),e.miny<this.miny&&(this.miny=e.miny),e.maxy>this.maxy&&(this.maxy=e.maxy))}}else if(2===arguments.length){var n=arguments[0],i=arguments[1];this.isNull()?(this.minx=n,this.maxx=n,this.miny=i,this.maxy=i):(n<this.minx&&(this.minx=n),n>this.maxx&&(this.maxx=n),i<this.miny&&(this.miny=i),i>this.maxy&&(this.maxy=i))}},minExtent:function(){if(this.isNull())return 0;var t=this.getWidth(),e=this.getHeight();return e>t?t:e},getWidth:function(){return this.isNull()?0:this.maxx-this.minx},compareTo:function(t){var e=t;return this.isNull()?e.isNull()?0:-1:e.isNull()?1:this.minx<e.minx?-1:this.minx>e.minx?1:this.miny<e.miny?-1:this.miny>e.miny?1:this.maxx<e.maxx?-1:this.maxx>e.maxx?1:this.maxy<e.maxy?-1:this.maxy>e.maxy?1:0},translate:function(t,e){return this.isNull()?null:void this.init(this.getMinX()+t,this.getMaxX()+t,this.getMinY()+e,this.getMaxY()+e)},toString:function(){return"Env["+this.minx+" : "+this.maxx+", "+this.miny+" : "+this.maxy+"]"},setToNull:function(){this.minx=0,this.maxx=-1,this.miny=0,this.maxy=-1},getHeight:function(){return this.isNull()?0:this.maxy-this.miny},maxExtent:function(){if(this.isNull())return 0;var t=this.getWidth(),e=this.getHeight();return t>e?t:e},expandBy:function(){if(1===arguments.length){var t=arguments[0];this.expandBy(t,t)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];if(this.isNull())return null;this.minx-=e,this.maxx+=e,this.miny-=n,this.maxy+=n,(this.minx>this.maxx||this.miny>this.maxy)&&this.setToNull()}},contains:function(){if(1===arguments.length){if(arguments[0]instanceof C){var t=arguments[0];return this.covers(t)}if(arguments[0]instanceof g){var e=arguments[0];return this.covers(e)}}else if(2===arguments.length){var n=arguments[0],i=arguments[1];return this.covers(n,i)}},centre:function(){return this.isNull()?null:new g((this.getMinX()+this.getMaxX())/2,(this.getMinY()+this.getMaxY())/2)},init:function(){if(0===arguments.length)this.setToNull();else if(1===arguments.length){if(arguments[0]instanceof g){var t=arguments[0];this.init(t.x,t.x,t.y,t.y)}else if(arguments[0]instanceof C){var e=arguments[0];this.minx=e.minx,this.maxx=e.maxx,this.miny=e.miny,this.maxy=e.maxy}}else if(2===arguments.length){var n=arguments[0],i=arguments[1];this.init(n.x,i.x,n.y,i.y)}else if(4===arguments.length){var r=arguments[0],s=arguments[1],o=arguments[2],a=arguments[3];s>r?(this.minx=r,this.maxx=s):(this.minx=s,this.maxx=r),a>o?(this.miny=o,this.maxy=a):(this.miny=a,this.maxy=o)}},getMaxY:function(){return this.maxy},distance:function(t){if(this.intersects(t))return 0;var e=0;this.maxx<t.minx?e=t.minx-this.maxx:this.minx>t.maxx&&(e=this.minx-t.maxx);var n=0;return this.maxy<t.miny?n=t.miny-this.maxy:this.miny>t.maxy&&(n=this.miny-t.maxy),0===e?n:0===n?e:Math.sqrt(e*e+n*n)},hashCode:function(){var t=17;return t=37*t+g.hashCode(this.minx),t=37*t+g.hashCode(this.maxx),t=37*t+g.hashCode(this.miny),t=37*t+g.hashCode(this.maxy)},interfaces_:function(){return[s,u]},getClass:function(){return C}}),C.intersects=function(){if(3===arguments.length){var t=arguments[0],e=arguments[1],n=arguments[2];return n.x>=(t.x<e.x?t.x:e.x)&&n.x<=(t.x>e.x?t.x:e.x)&&n.y>=(t.y<e.y?t.y:e.y)&&n.y<=(t.y>e.y?t.y:e.y)}if(4===arguments.length){var i=arguments[0],r=arguments[1],s=arguments[2],o=arguments[3],a=Math.min(s.x,o.x),u=Math.max(s.x,o.x),l=Math.min(i.x,r.x),h=Math.max(i.x,r.x);return l>u?!1:a>h?!1:(a=Math.min(s.y,o.y),u=Math.max(s.y,o.y),l=Math.min(i.y,r.y),h=Math.max(i.y,r.y),l>u?!1:!(a>h))}},C.serialVersionUID=0x51845cd552189800,h(w,S),e(w.prototype,{interfaces_:function(){return[]},getClass:function(){return w}}),e(L.prototype,{interfaces_:function(){return[]},getClass:function(){return L}}),L.toLocationSymbol=function(t){switch(t){case L.EXTERIOR:return"e";case L.BOUNDARY:return"b";case L.INTERIOR:return"i";case L.NONE:return"-"}throw new i("Unknown location value: "+t)},L.INTERIOR=0,L.BOUNDARY=1,L.EXTERIOR=2,L.NONE=-1,e(T.prototype,{interfaces_:function(){return[]},getClass:function(){return T}}),T.log10=function(t){var e=Math.log(t);return r.isInfinite(e)?e:r.isNaN(e)?e:e/T.LOG_10},T.min=function(t,e,n,i){var r=t;return r>e&&(r=e),r>n&&(r=n),r>i&&(r=i),r},T.clamp=function(){if("number"==typeof arguments[2]&&"number"==typeof arguments[0]&&"number"==typeof arguments[1]){var t=arguments[0],e=arguments[1],n=arguments[2];return e>t?e:t>n?n:t}if(Number.isInteger(arguments[2])&&Number.isInteger(arguments[0])&&Number.isInteger(arguments[1])){var i=arguments[0],r=arguments[1],s=arguments[2];return r>i?r:i>s?s:i}},T.wrap=function(t,e){return 0>t?e- -t%e:t%e},T.max=function(){if(3===arguments.length){var t=arguments[0],e=arguments[1],n=arguments[2],i=t;return e>i&&(i=e),n>i&&(i=n),i}if(4===arguments.length){var r=arguments[0],s=arguments[1],o=arguments[2],a=arguments[3],i=r;return s>i&&(i=s),o>i&&(i=o),a>i&&(i=a),i}},T.average=function(t,e){
	return(t+e)/2},T.LOG_10=Math.log(10),P.prototype.append=function(t){this.str+=t},P.prototype.setCharAt=function(t,e){return this.str.substr(0,t)+e+this.str.substr(t+1)},P.prototype.toString=function(t){return this.str},b.prototype.intValue=function(){return this.value},b.prototype.compareTo=function(t){return this.value<t?-1:this.value>t?1:0},b.isNaN=function(t){return Number.isNaN(t)},O.isWhitespace=function(t){return 32>=t&&t>=0||127==t},O.toUpperCase=function(t){return t.toUpperCase()},e(_.prototype,{le:function(t){return this.hi<t.hi||this.hi===t.hi&&this.lo<=t.lo},extractSignificantDigits:function(t,e){var n=this.abs(),i=_.magnitude(n.hi),r=_.TEN.pow(i);n=n.divide(r),n.gt(_.TEN)?(n=n.divide(_.TEN),i+=1):n.lt(_.ONE)&&(n=n.multiply(_.TEN),i-=1);for(var s=i+1,o=new P,a=_.MAX_PRINT_DIGITS-1,u=0;a>=u;u++){t&&u===s&&o.append(".");var l=Math.trunc(n.hi);if(0>l)break;var h=!1,c=0;l>9?(h=!0,c="9"):c="0"+l,o.append(c),n=n.subtract(_.valueOf(l)).multiply(_.TEN),h&&n.selfAdd(_.TEN);var f=!0,g=_.magnitude(n.hi);if(0>g&&Math.abs(g)>=a-u&&(f=!1),!f)break}return e[0]=i,o.toString()},sqr:function(){return this.multiply(this)},doubleValue:function(){return this.hi+this.lo},subtract:function(){if(arguments[0]instanceof _){var t=arguments[0];return this.add(t.negate())}if("number"==typeof arguments[0]){var e=arguments[0];return this.add(-e)}},equals:function(){if(1===arguments.length){var t=arguments[0];return this.hi===t.hi&&this.lo===t.lo}},isZero:function(){return 0===this.hi&&0===this.lo},selfSubtract:function(){if(arguments[0]instanceof _){var t=arguments[0];return this.isNaN()?this:this.selfAdd(-t.hi,-t.lo)}if("number"==typeof arguments[0]){var e=arguments[0];return this.isNaN()?this:this.selfAdd(-e,0)}},getSpecialNumberString:function(){return this.isZero()?"0.0":this.isNaN()?"NaN ":null},min:function(t){return this.le(t)?this:t},selfDivide:function(){if(1===arguments.length){if(arguments[0]instanceof _){var t=arguments[0];return this.selfDivide(t.hi,t.lo)}if("number"==typeof arguments[0]){var e=arguments[0];return this.selfDivide(e,0)}}else if(2===arguments.length){var n=arguments[0],i=arguments[1],r=null,s=null,o=null,a=null,u=null,l=null,h=null,c=null;return u=this.hi/n,l=_.SPLIT*u,r=l-u,c=_.SPLIT*n,r=l-r,s=u-r,o=c-n,h=u*n,o=c-o,a=n-o,c=r*o-h+r*a+s*o+s*a,l=(this.hi-h-c+this.lo-u*i)/n,c=u+l,this.hi=c,this.lo=u-c+l,this}},dump:function(){return"DD<"+this.hi+", "+this.lo+">"},divide:function(){if(arguments[0]instanceof _){var t=arguments[0],e=null,n=null,i=null,s=null,o=null,a=null,u=null,l=null;o=this.hi/t.hi,a=_.SPLIT*o,e=a-o,l=_.SPLIT*t.hi,e=a-e,n=o-e,i=l-t.hi,u=o*t.hi,i=l-i,s=t.hi-i,l=e*i-u+e*s+n*i+n*s,a=(this.hi-u-l+this.lo-o*t.lo)/t.hi,l=o+a;var h=l,c=o-l+a;return new _(h,c)}if("number"==typeof arguments[0]){var f=arguments[0];return r.isNaN(f)?_.createNaN():_.copy(this).selfDivide(f,0)}},ge:function(t){return this.hi>t.hi||this.hi===t.hi&&this.lo>=t.lo},pow:function(t){if(0===t)return _.valueOf(1);var e=new _(this),n=_.valueOf(1),i=Math.abs(t);if(i>1)for(;i>0;)i%2===1&&n.selfMultiply(e),i/=2,i>0&&(e=e.sqr());else n=e;return 0>t?n.reciprocal():n},ceil:function(){if(this.isNaN())return _.NaN;var t=Math.ceil(this.hi),e=0;return t===this.hi&&(e=Math.ceil(this.lo)),new _(t,e)},compareTo:function(t){var e=t;return this.hi<e.hi?-1:this.hi>e.hi?1:this.lo<e.lo?-1:this.lo>e.lo?1:0},rint:function(){if(this.isNaN())return this;var t=this.add(.5);return t.floor()},setValue:function(){if(arguments[0]instanceof _){var t=arguments[0];return this.init(t),this}if("number"==typeof arguments[0]){var e=arguments[0];return this.init(e),this}},max:function(t){return this.ge(t)?this:t},sqrt:function(){if(this.isZero())return _.valueOf(0);if(this.isNegative())return _.NaN;var t=1/Math.sqrt(this.hi),e=this.hi*t,n=_.valueOf(e),i=this.subtract(n.sqr()),r=i.hi*(.5*t);return n.add(r)},selfAdd:function(){if(1===arguments.length){if(arguments[0]instanceof _){var t=arguments[0];return this.selfAdd(t.hi,t.lo)}if("number"==typeof arguments[0]){var e=arguments[0],n=null,i=null,r=null,s=null,o=null,a=null;return r=this.hi+e,o=r-this.hi,s=r-o,s=e-o+(this.hi-s),a=s+this.lo,n=r+a,i=a+(r-n),this.hi=n+i,this.lo=i+(n-this.hi),this}}else if(2===arguments.length){var u=arguments[0],l=arguments[1],n=null,i=null,h=null,c=null,r=null,s=null,o=null,a=null;r=this.hi+u,h=this.lo+l,o=r-this.hi,a=h-this.lo,s=r-o,c=h-a,s=u-o+(this.hi-s),c=l-a+(this.lo-c),o=s+h,n=r+o,i=o+(r-n),o=c+i;var f=n+o,g=o+(n-f);return this.hi=f,this.lo=g,this}},selfMultiply:function(){if(1===arguments.length){if(arguments[0]instanceof _){var t=arguments[0];return this.selfMultiply(t.hi,t.lo)}if("number"==typeof arguments[0]){var e=arguments[0];return this.selfMultiply(e,0)}}else if(2===arguments.length){var n=arguments[0],i=arguments[1],r=null,s=null,o=null,a=null,u=null,l=null;u=_.SPLIT*this.hi,r=u-this.hi,l=_.SPLIT*n,r=u-r,s=this.hi-r,o=l-n,u=this.hi*n,o=l-o,a=n-o,l=r*o-u+r*a+s*o+s*a+(this.hi*i+this.lo*n);var h=u+l;r=u-h;var c=l+r;return this.hi=h,this.lo=c,this}},selfSqr:function(){return this.selfMultiply(this)},floor:function(){if(this.isNaN())return _.NaN;var t=Math.floor(this.hi),e=0;return t===this.hi&&(e=Math.floor(this.lo)),new _(t,e)},negate:function(){return this.isNaN()?this:new _(-this.hi,-this.lo)},clone:function(){try{return null}catch(t){if(t instanceof CloneNotSupportedException)return null;throw t}finally{}},multiply:function(){if(arguments[0]instanceof _){var t=arguments[0];return t.isNaN()?_.createNaN():_.copy(this).selfMultiply(t)}if("number"==typeof arguments[0]){var e=arguments[0];return r.isNaN(e)?_.createNaN():_.copy(this).selfMultiply(e,0)}},isNaN:function(){return r.isNaN(this.hi)},intValue:function(){return Math.trunc(this.hi)},toString:function(){var t=_.magnitude(this.hi);return t>=-3&&20>=t?this.toStandardNotation():this.toSciNotation()},toStandardNotation:function(){var t=this.getSpecialNumberString();if(null!==t)return t;var e=new Array(1).fill(null),n=this.extractSignificantDigits(!0,e),i=e[0]+1,r=n;if("."===n.charAt(0))r="0"+n;else if(0>i)r="0."+_.stringOfChar("0",-i)+n;else if(-1===n.indexOf(".")){var s=i-n.length,o=_.stringOfChar("0",s);r=n+o+".0"}return this.isNegative()?"-"+r:r},reciprocal:function(){var t=null,e=null,n=null,i=null,r=null,s=null,o=null,a=null;r=1/this.hi,s=_.SPLIT*r,t=s-r,a=_.SPLIT*this.hi,t=s-t,e=r-t,n=a-this.hi,o=r*this.hi,n=a-n,i=this.hi-n,a=t*n-o+t*i+e*n+e*i,s=(1-o-a-r*this.lo)/this.hi;var u=r+s,l=r-u+s;return new _(u,l)},toSciNotation:function(){if(this.isZero())return _.SCI_NOT_ZERO;var t=this.getSpecialNumberString();if(null!==t)return t;var e=new Array(1).fill(null),n=this.extractSignificantDigits(!1,e),i=_.SCI_NOT_EXPONENT_CHAR+e[0];if("0"===n.charAt(0))throw new IllegalStateException("Found leading zero: "+n);var r="";n.length>1&&(r=n.substring(1));var s=n.charAt(0)+"."+r;return this.isNegative()?"-"+s+i:s+i},abs:function(){return this.isNaN()?_.NaN:this.isNegative()?this.negate():new _(this)},isPositive:function(){return this.hi>0||0===this.hi&&this.lo>0},lt:function(t){return this.hi<t.hi||this.hi===t.hi&&this.lo<t.lo},add:function(){if(arguments[0]instanceof _){var t=arguments[0];return _.copy(this).selfAdd(t)}if("number"==typeof arguments[0]){var e=arguments[0];return _.copy(this).selfAdd(e)}},init:function(){if(1===arguments.length){if("number"==typeof arguments[0]){var t=arguments[0];this.hi=t,this.lo=0}else if(arguments[0]instanceof _){var e=arguments[0];this.hi=e.hi,this.lo=e.lo}}else if(2===arguments.length){var n=arguments[0],i=arguments[1];this.hi=n,this.lo=i}},gt:function(t){return this.hi>t.hi||this.hi===t.hi&&this.lo>t.lo},isNegative:function(){return this.hi<0||0===this.hi&&this.lo<0},trunc:function(){return this.isNaN()?_.NaN:this.isPositive()?this.floor():this.ceil()},signum:function(){return this.hi>0?1:this.hi<0?-1:this.lo>0?1:this.lo<0?-1:0},interfaces_:function(){return[u,s,o]},getClass:function(){return _}}),_.sqr=function(t){return _.valueOf(t).selfMultiply(t)},_.valueOf=function(){if("string"==typeof arguments[0]){var t=arguments[0];return _.parse(t)}if("number"==typeof arguments[0]){var e=arguments[0];return new _(e)}},_.sqrt=function(t){return _.valueOf(t).sqrt()},_.parse=function(t){for(var e=0,n=t.length;O.isWhitespace(t.charAt(e));)e++;var i=!1;if(n>e){var r=t.charAt(e);"-"!==r&&"+"!==r||(e++,"-"===r&&(i=!0))}for(var s=new _,o=0,a=0,u=0;;){if(e>=n)break;var l=t.charAt(e);if(e++,O.isDigit(l)){var h=l-"0";s.selfMultiply(_.TEN),s.selfAdd(h),o++}else{if("."!==l){if("e"===l||"E"===l){var c=t.substring(e);try{u=b.parseInt(c)}catch(e){throw e instanceof NumberFormatException?new NumberFormatException("Invalid exponent "+c+" in string "+t):e}finally{}break}throw new NumberFormatException("Unexpected character '"+l+"' at position "+e+" in string "+t)}a=o}}var f=s,g=o-a-u;if(0===g)f=s;else if(g>0){var d=_.TEN.pow(g);f=s.divide(d)}else if(0>g){var d=_.TEN.pow(-g);f=s.multiply(d)}return i?f.negate():f},_.createNaN=function(){return new _(r.NaN,r.NaN)},_.copy=function(t){return new _(t)},_.magnitude=function(t){var e=Math.abs(t),n=Math.log(e)/Math.log(10),i=Math.trunc(Math.floor(n)),r=Math.pow(10,i);return e>=10*r&&(i+=1),i},_.stringOfChar=function(t,e){for(var n=new P,i=0;e>i;i++)n.append(t);return n.toString()},_.PI=new _(3.141592653589793,1.2246467991473532e-16),_.TWO_PI=new _(6.283185307179586,2.4492935982947064e-16),_.PI_2=new _(1.5707963267948966,6.123233995736766e-17),_.E=new _(2.718281828459045,1.4456468917292502e-16),_.NaN=new _(r.NaN,r.NaN),_.EPS=1.23259516440783e-32,_.SPLIT=134217729,_.MAX_PRINT_DIGITS=32,_.TEN=_.valueOf(10),_.ONE=_.valueOf(1),_.SCI_NOT_EXPONENT_CHAR="E",_.SCI_NOT_ZERO="0.0E0",e(M.prototype,{interfaces_:function(){return[]},getClass:function(){return M}}),M.orientationIndex=function(t,e,n){var i=M.orientationIndexFilter(t,e,n);if(1>=i)return i;var r=_.valueOf(e.x).selfAdd(-t.x),s=_.valueOf(e.y).selfAdd(-t.y),o=_.valueOf(n.x).selfAdd(-e.x),a=_.valueOf(n.y).selfAdd(-e.y);return r.selfMultiply(a).selfSubtract(s.selfMultiply(o)).signum()},M.signOfDet2x2=function(t,e,n,i){var r=t.multiply(i).selfSubtract(e.multiply(n));return r.signum()},M.intersection=function(t,e,n,i){var r=_.valueOf(i.y).selfSubtract(n.y).selfMultiply(_.valueOf(e.x).selfSubtract(t.x)),s=_.valueOf(i.x).selfSubtract(n.x).selfMultiply(_.valueOf(e.y).selfSubtract(t.y)),o=r.subtract(s),a=_.valueOf(i.x).selfSubtract(n.x).selfMultiply(_.valueOf(t.y).selfSubtract(n.y)),u=_.valueOf(i.y).selfSubtract(n.y).selfMultiply(_.valueOf(t.x).selfSubtract(n.x)),l=a.subtract(u),h=l.selfDivide(o).doubleValue(),c=_.valueOf(t.x).selfAdd(_.valueOf(e.x).selfSubtract(t.x).selfMultiply(h)).doubleValue(),f=_.valueOf(e.x).selfSubtract(t.x).selfMultiply(_.valueOf(t.y).selfSubtract(n.y)),d=_.valueOf(e.y).selfSubtract(t.y).selfMultiply(_.valueOf(t.x).selfSubtract(n.x)),p=f.subtract(d),v=p.selfDivide(o).doubleValue(),m=_.valueOf(n.y).selfAdd(_.valueOf(i.y).selfSubtract(n.y).selfMultiply(v)).doubleValue();return new g(c,m)},M.orientationIndexFilter=function(t,e,n){var i=null,r=(t.x-n.x)*(e.y-n.y),s=(t.y-n.y)*(e.x-n.x),o=r-s;if(r>0){if(0>=s)return M.signum(o);i=r+s}else{if(!(0>r))return M.signum(o);if(s>=0)return M.signum(o);i=-r-s}var a=M.DP_SAFE_EPSILON*i;return o>=a||-o>=a?M.signum(o):2},M.signum=function(t){return t>0?1:0>t?-1:0},M.DP_SAFE_EPSILON=1e-15,e(D.prototype,{setOrdinate:function(t,e,n){},size:function(){},getOrdinate:function(t,e){},getCoordinate:function(){if(1===arguments.length){arguments[0]}else if(2===arguments.length){arguments[0],arguments[1]}},getCoordinateCopy:function(t){},getDimension:function(){},getX:function(t){},clone:function(){},expandEnvelope:function(t){},copy:function(){},getY:function(t){},toCoordinateArray:function(){},interfaces_:function(){return[o]},getClass:function(){return D}}),D.X=0,D.Y=1,D.Z=2,D.M=3,A.arraycopy=function(t,e,n,i,r){for(var s=0,o=e;e+r>o;o++)n[i+s]=t[o],s++},A.getProperty=function(t){return{"line.separator":"\n"}[t]},e(F.prototype,{getY:function(){var t=this.y/this.w;if(r.isNaN(t)||r.isInfinite(t))throw new w;return t},getX:function(){var t=this.x/this.w;if(r.isNaN(t)||r.isInfinite(t))throw new w;return t},getCoordinate:function(){var t=new g;return t.x=this.getX(),t.y=this.getY(),t},interfaces_:function(){return[]},getClass:function(){return F}}),F.intersection=function(t,e,n,i){var s=t.y-e.y,o=e.x-t.x,a=t.x*e.y-e.x*t.y,u=n.y-i.y,l=i.x-n.x,h=n.x*i.y-i.x*n.y,c=o*h-l*a,f=u*a-s*h,d=s*l-u*o,p=c/d,v=f/d;if(r.isNaN(p)||r.isInfinite(p)||r.isNaN(v)||r.isInfinite(v))throw new w;return new g(p,v)},e(G.prototype,{create:function(){if(1===arguments.length){if(arguments[0]instanceof Array){arguments[0]}else if(R(arguments[0],D)){arguments[0]}}else if(2===arguments.length){arguments[0],arguments[1]}},interfaces_:function(){return[]},getClass:function(){return G}}),e(q.prototype,{filter:function(t){},interfaces_:function(){return[]},getClass:function(){return q}}),e(B.prototype,{isGeometryCollection:function(){return this.getSortIndex()===B.SORTINDEX_GEOMETRYCOLLECTION},getFactory:function(){return this.factory},getGeometryN:function(t){return this},getArea:function(){return 0},isRectangle:function(){return!1},equals:function(){if(1===arguments.length){if(arguments[0]instanceof B){var t=arguments[0];return null===t?!1:this.equalsTopo(t)}if(arguments[0]instanceof Object){var e=arguments[0];if(!(e instanceof B))return!1;var n=e;return this.equalsExact(n)}}},equalsExact:function(t){return this===t||this.equalsExact(t,0)},geometryChanged:function(){this.apply(B.geometryChangedFilter)},geometryChangedAction:function(){this.envelope=null},equalsNorm:function(t){return null===t?!1:this.norm().equalsExact(t.norm())},getLength:function(){return 0},getNumGeometries:function(){return 1},compareTo:function(){if(1===arguments.length){var t=arguments[0],e=t;return this.getSortIndex()!==e.getSortIndex()?this.getSortIndex()-e.getSortIndex():this.isEmpty()&&e.isEmpty()?0:this.isEmpty()?-1:e.isEmpty()?1:this.compareToSameClass(t)}if(2===arguments.length){var n=arguments[0],i=arguments[1],e=n;return this.getSortIndex()!==e.getSortIndex()?this.getSortIndex()-e.getSortIndex():this.isEmpty()&&e.isEmpty()?0:this.isEmpty()?-1:e.isEmpty()?1:this.compareToSameClass(n,i)}},getUserData:function(){return this.userData},getSRID:function(){return this.SRID},getEnvelope:function(){return this.getFactory().toGeometry(this.getEnvelopeInternal())},checkNotGeometryCollection:function(t){if(t.getSortIndex()===B.SORTINDEX_GEOMETRYCOLLECTION)throw new i("This method does not support GeometryCollection arguments")},equal:function(t,e,n){return 0===n?t.equals(e):t.distance(e)<=n},norm:function(){var t=this.copy();return t.normalize(),t},getPrecisionModel:function(){return this.factory.getPrecisionModel()},getEnvelopeInternal:function(){return null===this.envelope&&(this.envelope=this.computeEnvelopeInternal()),new C(this.envelope)},setSRID:function(t){this.SRID=t},setUserData:function(t){this.userData=t},compare:function(t,e){for(var n=t.iterator(),i=e.iterator();n.hasNext()&&i.hasNext();){var r=n.next(),s=i.next(),o=r.compareTo(s);if(0!==o)return o}return n.hasNext()?1:i.hasNext()?-1:0},hashCode:function(){return this.getEnvelopeInternal().hashCode()},isGeometryCollectionOrDerived:function(){return this.getSortIndex()===B.SORTINDEX_GEOMETRYCOLLECTION||this.getSortIndex()===B.SORTINDEX_MULTIPOINT||this.getSortIndex()===B.SORTINDEX_MULTILINESTRING||this.getSortIndex()===B.SORTINDEX_MULTIPOLYGON},interfaces_:function(){return[o,s,u]},getClass:function(){return B}}),B.hasNonEmptyElements=function(t){for(var e=0;e<t.length;e++)if(!t[e].isEmpty())return!0;return!1},B.hasNullElements=function(t){for(var e=0;e<t.length;e++)if(null===t[e])return!0;return!1},B.serialVersionUID=0x799ea46522854c00,B.SORTINDEX_POINT=0,B.SORTINDEX_MULTIPOINT=1,B.SORTINDEX_LINESTRING=2,B.SORTINDEX_LINEARRING=3,B.SORTINDEX_MULTILINESTRING=4,B.SORTINDEX_POLYGON=5,B.SORTINDEX_MULTIPOLYGON=6,B.SORTINDEX_GEOMETRYCOLLECTION=7,B.geometryChangedFilter={interfaces_:function(){return[q]},filter:function(t){t.geometryChangedAction()}},e(z.prototype,{filter:function(t){},interfaces_:function(){return[]},getClass:function(){return z}}),e(V.prototype,{isInBoundary:function(t){},interfaces_:function(){return[]},getClass:function(){return V}}),e(k.prototype,{isInBoundary:function(t){return t%2===1},interfaces_:function(){return[V]},getClass:function(){return k}}),e(Y.prototype,{isInBoundary:function(t){return t>0},interfaces_:function(){return[V]},getClass:function(){return Y}}),e(U.prototype,{isInBoundary:function(t){return t>1},interfaces_:function(){return[V]},getClass:function(){return U}}),e(X.prototype,{isInBoundary:function(t){return 1===t},interfaces_:function(){return[V]},getClass:function(){return X}}),V.Mod2BoundaryNodeRule=k,V.EndPointBoundaryNodeRule=Y,V.MultiValentEndPointBoundaryNodeRule=U,V.MonoValentEndPointBoundaryNodeRule=X,V.MOD2_BOUNDARY_RULE=new k,V.ENDPOINT_BOUNDARY_RULE=new Y,V.MULTIVALENT_ENDPOINT_BOUNDARY_RULE=new U,V.MONOVALENT_ENDPOINT_BOUNDARY_RULE=new X,V.OGC_SFS_BOUNDARY_RULE=V.MOD2_BOUNDARY_RULE,e(H.prototype,{interfaces_:function(){return[]},getClass:function(){return H}}),H.isRing=function(t){return t.length<4?!1:!!t[0].equals2D(t[t.length-1])},H.ptNotInList=function(t,e){for(var n=0;n<t.length;n++){var i=t[n];if(H.indexOf(i,e)<0)return i}return null},H.scroll=function(t,e){var n=H.indexOf(e,t);if(0>n)return null;var i=new Array(t.length).fill(null);A.arraycopy(t,n,i,0,t.length-n),A.arraycopy(t,0,i,t.length-n,n),A.arraycopy(i,0,t,0,t.length)},H.equals=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];if(t===e)return!0;if(null===t||null===e)return!1;if(t.length!==e.length)return!1;for(var n=0;n<t.length;n++)if(!t[n].equals(e[n]))return!1;return!0}if(3===arguments.length){var i=arguments[0],r=arguments[1],s=arguments[2];if(i===r)return!0;if(null===i||null===r)return!1;if(i.length!==r.length)return!1;for(var n=0;n<i.length;n++)if(0!==s.compare(i[n],r[n]))return!1;return!0}},H.intersection=function(t,e){for(var n=new N,i=0;i<t.length;i++)e.intersects(t[i])&&n.add(t[i],!0);return n.toCoordinateArray()},H.hasRepeatedPoints=function(t){for(var e=1;e<t.length;e++)if(t[e-1].equals(t[e]))return!0;return!1},H.removeRepeatedPoints=function(t){if(!H.hasRepeatedPoints(t))return t;var e=new N(t,!1);return e.toCoordinateArray()},H.reverse=function(t){for(var e=t.length-1,n=Math.trunc(e/2),i=0;n>=i;i++){var r=t[i];t[i]=t[e-i],t[e-i]=r}},H.removeNull=function(t){for(var e=0,n=0;n<t.length;n++)null!==t[n]&&e++;var i=new Array(e).fill(null);if(0===e)return i;for(var r=0,n=0;n<t.length;n++)null!==t[n]&&(i[r++]=t[n]);return i},H.copyDeep=function(){if(1===arguments.length){for(var t=arguments[0],e=new Array(t.length).fill(null),n=0;n<t.length;n++)e[n]=new g(t[n]);return e}if(5===arguments.length)for(var i=arguments[0],r=arguments[1],s=arguments[2],o=arguments[3],a=arguments[4],n=0;a>n;n++)s[o+n]=new g(i[r+n])},H.isEqualReversed=function(t,e){for(var n=0;n<t.length;n++){var i=t[n],r=e[t.length-n-1];if(0!==i.compareTo(r))return!1}return!0},H.envelope=function(t){for(var e=new C,n=0;n<t.length;n++)e.expandToInclude(t[n]);return e},H.toCoordinateArray=function(t){return t.toArray(H.coordArrayType)},H.atLeastNCoordinatesOrNothing=function(t,e){return e.length>=t?e:[]},H.indexOf=function(t,e){for(var n=0;n<e.length;n++)if(t.equals(e[n]))return n;return-1},H.increasingDirection=function(t){for(var e=0;e<Math.trunc(t.length/2);e++){var n=t.length-1-e,i=t[e].compareTo(t[n]);if(0!==i)return i}return 1},H.compare=function(t,e){for(var n=0;n<t.length&&n<e.length;){var i=t[n].compareTo(e[n]);if(0!==i)return i;n++}return n<e.length?-1:n<t.length?1:0},H.minCoordinate=function(t){for(var e=null,n=0;n<t.length;n++)(null===e||e.compareTo(t[n])>0)&&(e=t[n]);return e},H.extract=function(t,e,n){e=T.clamp(e,0,t.length),n=T.clamp(n,-1,t.length);var i=n-e+1;0>n&&(i=0),e>=t.length&&(i=0),e>n&&(i=0);var r=new Array(i).fill(null);if(0===i)return r;for(var s=0,o=e;n>=o;o++)r[s++]=t[o];return r},e(W.prototype,{compare:function(t,e){var n=t,i=e;return H.compare(n,i)},interfaces_:function(){return[a]},getClass:function(){return W}}),e(j.prototype,{compare:function(t,e){var n=t,i=e;if(n.length<i.length)return-1;if(n.length>i.length)return 1;if(0===n.length)return 0;var r=H.compare(n,i),s=H.isEqualReversed(n,i);return s?0:r},OLDcompare:function(t,e){var n=t,i=e;if(n.length<i.length)return-1;if(n.length>i.length)return 1;if(0===n.length)return 0;for(var r=H.increasingDirection(n),s=H.increasingDirection(i),o=r>0?0:n.length-1,a=s>0?0:n.length-1,u=0;u<n.length;u++){var l=n[o].compareTo(i[a]);if(0!==l)return l;o+=r,a+=s}return 0},interfaces_:function(){return[a]},getClass:function(){return j}}),H.ForwardComparator=W,H.BidirectionalComparator=j,H.coordArrayType=new Array(0).fill(null),K.prototype.get=function(){},K.prototype.put=function(){},K.prototype.size=function(){},K.prototype.values=function(){},K.prototype.entrySet=function(){},Z.prototype=new K,Q.prototype=new v,Q.prototype.contains=function(){},J.prototype=new Q,J.prototype.contains=function(t){for(var e=0,n=this.array_.length;n>e;e++){var i=this.array_[e];if(i===t)return!0}return!1},J.prototype.add=function(t){return this.contains(t)?!1:(this.array_.push(t),!0)},J.prototype.addAll=function(t){for(var e=t.iterator();e.hasNext();)this.add(e.next());return!0},J.prototype.remove=function(t){throw new javascript.util.OperationNotSupported},J.prototype.size=function(){return this.array_.length},J.prototype.isEmpty=function(){return 0===this.array_.length},J.prototype.toArray=function(){for(var t=[],e=0,n=this.array_.length;n>e;e++)t.push(this.array_[e]);return t},J.prototype.iterator=function(){return new Js(this)};var Js=function(t){this.hashSet_=t,this.position_=0};Js.prototype.next=function(){if(this.position_===this.hashSet_.size())throw new x;return this.hashSet_.array_[this.position_++]},Js.prototype.hasNext=function(){return this.position_<this.hashSet_.size()},Js.prototype.remove=function(){throw new E};var $s=0,to=1;rt.prototype=new Z,rt.prototype.get=function(t){for(var e=this.root_;null!==e;){var n=t.compareTo(e.key);if(0>n)e=e.left;else{if(!(n>0))return e.value;e=e.right}}return null},rt.prototype.put=function(t,e){if(null===this.root_)return this.root_={key:t,value:e,left:null,right:null,parent:null,color:$s,getValue:function(){return this.value},getKey:function(){return this.key}},this.size_=1,null;var n,i,r=this.root_;do if(n=r,i=t.compareTo(r.key),0>i)r=r.left;else{if(!(i>0)){var s=r.value;return r.value=e,s}r=r.right}while(null!==r);var o={key:t,left:null,right:null,value:e,parent:n,color:$s,getValue:function(){return this.value},getKey:function(){return this.key}};return 0>i?n.left=o:n.right=o,this.fixAfterInsertion(o),this.size_++,null},rt.prototype.fixAfterInsertion=function(t){for(t.color=to;null!=t&&t!=this.root_&&t.parent.color==to;)if(tt(t)==nt(tt(tt(t)))){var e=it(tt(tt(t)));$(e)==to?(et(tt(t),$s),et(e,$s),et(tt(tt(t)),to),t=tt(tt(t))):(t==it(tt(t))&&(t=tt(t),this.rotateLeft(t)),et(tt(t),$s),et(tt(tt(t)),to),this.rotateRight(tt(tt(t))))}else{var e=nt(tt(tt(t)));$(e)==to?(et(tt(t),$s),et(e,$s),et(tt(tt(t)),to),t=tt(tt(t))):(t==nt(tt(t))&&(t=tt(t),this.rotateRight(t)),et(tt(t),$s),et(tt(tt(t)),to),this.rotateLeft(tt(tt(t))))}this.root_.color=$s},rt.prototype.values=function(){var t=new I,e=this.getFirstEntry();if(null!==e)for(t.add(e.value);null!==(e=rt.successor(e));)t.add(e.value);return t},rt.prototype.entrySet=function(){var t=new J,e=this.getFirstEntry();if(null!==e)for(t.add(e);null!==(e=rt.successor(e));)t.add(e);return t},rt.prototype.rotateLeft=function(t){if(null!=t){var e=t.right;t.right=e.left,null!=e.left&&(e.left.parent=t),e.parent=t.parent,null==t.parent?this.root_=e:t.parent.left==t?t.parent.left=e:t.parent.right=e,e.left=t,t.parent=e}},rt.prototype.rotateRight=function(t){if(null!=t){var e=t.left;t.left=e.right,null!=e.right&&(e.right.parent=t),e.parent=t.parent,null==t.parent?this.root_=e:t.parent.right==t?t.parent.right=e:t.parent.left=e,e.right=t,t.parent=e}},rt.prototype.getFirstEntry=function(){var t=this.root_;if(null!=t)for(;null!=t.left;)t=t.left;return t},rt.successor=function(t){if(null===t)return null;if(null!==t.right){for(var e=t.right;null!==e.left;)e=e.left;return e}for(var e=t.parent,n=t;null!==e&&n===e.right;)n=e,e=e.parent;return e},rt.prototype.size=function(){return this.size_},e(st.prototype,{interfaces_:function(){return[]},getClass:function(){return st}}),ot.prototype=new Q,at.prototype=new ot,at.prototype.contains=function(t){for(var e=0,n=this.array_.length;n>e;e++){var i=this.array_[e];if(0===i.compareTo(t))return!0}return!1},at.prototype.add=function(t){if(this.contains(t))return!1;for(var e=0,n=this.array_.length;n>e;e++){var i=this.array_[e];if(1===i.compareTo(t))return this.array_.splice(e,0,t),!0}return this.array_.push(t),!0},at.prototype.addAll=function(t){for(var e=t.iterator();e.hasNext();)this.add(e.next());return!0},at.prototype.remove=function(t){throw new E},at.prototype.size=function(){return this.array_.length},at.prototype.isEmpty=function(){return 0===this.array_.length},at.prototype.toArray=function(){for(var t=[],e=0,n=this.array_.length;n>e;e++)t.push(this.array_[e]);return t},at.prototype.iterator=function(){return new eo(this)};var eo=function(t){this.treeSet_=t,this.position_=0};eo.prototype.next=function(){if(this.position_===this.treeSet_.size())throw new x;return this.treeSet_.array_[this.position_++]},eo.prototype.hasNext=function(){return this.position_<this.treeSet_.size()},eo.prototype.remove=function(){throw new E},ut.sort=function(){var t,e,n,i,r=arguments[0];if(1===arguments.length)return i=function(t,e){return t.compareTo(e)},void r.sort(i);if(2===arguments.length)n=arguments[1],i=function(t,e){return n.compare(t,e)},r.sort(i);else{if(3===arguments.length){e=r.slice(arguments[1],arguments[2]),e.sort();var s=r.slice(0,arguments[1]).concat(e,r.slice(arguments[2],r.length));for(r.splice(0,r.length),t=0;t<s.length;t++)r.push(s[t]);return}if(4===arguments.length){for(e=r.slice(arguments[1],arguments[2]),n=arguments[3],i=function(t,e){return n.compare(t,e)},e.sort(i),s=r.slice(0,arguments[1]).concat(e,r.slice(arguments[2],r.length)),r.splice(0,r.length),t=0;t<s.length;t++)r.push(s[t]);return}}},ut.asList=function(t){for(var e=new I,n=0,i=t.length;i>n;n++)e.add(t[n]);return e},e(lt.prototype,{interfaces_:function(){return[]},getClass:function(){return lt}}),lt.toDimensionSymbol=function(t){switch(t){case lt.FALSE:return lt.SYM_FALSE;case lt.TRUE:return lt.SYM_TRUE;case lt.DONTCARE:return lt.SYM_DONTCARE;case lt.P:return lt.SYM_P;case lt.L:return lt.SYM_L;case lt.A:return lt.SYM_A}throw new i("Unknown dimension value: "+t)},lt.toDimensionValue=function(t){switch(O.toUpperCase(t)){case lt.SYM_FALSE:return lt.FALSE;case lt.SYM_TRUE:return lt.TRUE;case lt.SYM_DONTCARE:return lt.DONTCARE;case lt.SYM_P:return lt.P;case lt.SYM_L:return lt.L;case lt.SYM_A:return lt.A}throw new i("Unknown dimension symbol: "+t)},lt.P=0,lt.L=1,lt.A=2,lt.FALSE=-1,lt.TRUE=-2,lt.DONTCARE=-3,lt.SYM_FALSE="F",lt.SYM_TRUE="T",lt.SYM_DONTCARE="*",lt.SYM_P="0",lt.SYM_L="1",lt.SYM_A="2",e(ht.prototype,{filter:function(t){},interfaces_:function(){return[]},getClass:function(){return ht}}),e(ct.prototype,{filter:function(t,e){},isDone:function(){},isGeometryChanged:function(){},interfaces_:function(){return[]},getClass:function(){return ct}}),h(ft,B),e(ft.prototype,{computeEnvelopeInternal:function(){for(var t=new C,e=0;e<this.geometries.length;e++)t.expandToInclude(this.geometries[e].getEnvelopeInternal());return t},getGeometryN:function(t){return this.geometries[t]},getSortIndex:function(){return B.SORTINDEX_GEOMETRYCOLLECTION},getCoordinates:function(){for(var t=new Array(this.getNumPoints()).fill(null),e=-1,n=0;n<this.geometries.length;n++)for(var i=this.geometries[n].getCoordinates(),r=0;r<i.length;r++)e++,t[e]=i[r];return t},getArea:function(){for(var t=0,e=0;e<this.geometries.length;e++)t+=this.geometries[e].getArea();return t},equalsExact:function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];if(!this.isEquivalentClass(t))return!1;var n=t;if(this.geometries.length!==n.geometries.length)return!1;for(var i=0;i<this.geometries.length;i++)if(!this.geometries[i].equalsExact(n.geometries[i],e))return!1;return!0}return B.prototype.equalsExact.apply(this,arguments)},normalize:function(){for(var t=0;t<this.geometries.length;t++)this.geometries[t].normalize();ut.sort(this.geometries)},getCoordinate:function(){return this.isEmpty()?null:this.geometries[0].getCoordinate()},getBoundaryDimension:function(){for(var t=lt.FALSE,e=0;e<this.geometries.length;e++)t=Math.max(t,this.geometries[e].getBoundaryDimension());return t},getDimension:function(){for(var t=lt.FALSE,e=0;e<this.geometries.length;e++)t=Math.max(t,this.geometries[e].getDimension());return t},getLength:function(){for(var t=0,e=0;e<this.geometries.length;e++)t+=this.geometries[e].getLength();return t},getNumPoints:function(){for(var t=0,e=0;e<this.geometries.length;e++)t+=this.geometries[e].getNumPoints();return t},getNumGeometries:function(){return this.geometries.length},reverse:function(){for(var t=this.geometries.length,e=new Array(t).fill(null),n=0;n<this.geometries.length;n++)e[n]=this.geometries[n].reverse();return this.getFactory().createGeometryCollection(e)},compareToSameClass:function(){if(1===arguments.length){var t=arguments[0],e=new at(ut.asList(this.geometries)),n=new at(ut.asList(t.geometries));return this.compare(e,n)}if(2===arguments.length){for(var i=arguments[0],r=arguments[1],s=i,o=this.getNumGeometries(),a=s.getNumGeometries(),u=0;o>u&&a>u;){var l=this.getGeometryN(u),h=s.getGeometryN(u),c=l.compareToSameClass(h,r);if(0!==c)return c;u++}return o>u?1:a>u?-1:0}},apply:function(){if(R(arguments[0],z))for(var t=arguments[0],e=0;e<this.geometries.length;e++)this.geometries[e].apply(t);else if(R(arguments[0],ct)){var n=arguments[0];if(0===this.geometries.length)return null;for(var e=0;e<this.geometries.length&&(this.geometries[e].apply(n),!n.isDone());e++);n.isGeometryChanged()&&this.geometryChanged()}else if(R(arguments[0],ht)){var i=arguments[0];i.filter(this);for(var e=0;e<this.geometries.length;e++)this.geometries[e].apply(i)}else if(R(arguments[0],q)){var r=arguments[0];r.filter(this);for(var e=0;e<this.geometries.length;e++)this.geometries[e].apply(r)}},getBoundary:function(){return this.checkNotGeometryCollection(this),f.shouldNeverReachHere(),null},clone:function(){var t=B.prototype.clone.call(this);t.geometries=new Array(this.geometries.length).fill(null);for(var e=0;e<this.geometries.length;e++)t.geometries[e]=this.geometries[e].clone();return t},getGeometryType:function(){return"GeometryCollection"},copy:function(){for(var t=new Array(this.geometries.length).fill(null),e=0;e<t.length;e++)t[e]=this.geometries[e].copy();return new ft(t,this.factory)},isEmpty:function(){for(var t=0;t<this.geometries.length;t++)if(!this.geometries[t].isEmpty())return!1;return!0},interfaces_:function(){return[]},getClass:function(){return ft}}),ft.serialVersionUID=-0x4f07bcb1f857d800,h(gt,ft),e(gt.prototype,{getSortIndex:function(){return B.SORTINDEX_MULTILINESTRING},equalsExact:function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];return this.isEquivalentClass(t)?ft.prototype.equalsExact.call(this,t,e):!1}return ft.prototype.equalsExact.apply(this,arguments)},getBoundaryDimension:function(){return this.isClosed()?lt.FALSE:0},isClosed:function(){if(this.isEmpty())return!1;for(var t=0;t<this.geometries.length;t++)if(!this.geometries[t].isClosed())return!1;return!0},getDimension:function(){return 1},reverse:function(){for(var t=this.geometries.length,e=new Array(t).fill(null),n=0;n<this.geometries.length;n++)e[t-1-n]=this.geometries[n].reverse();return this.getFactory().createMultiLineString(e)},getBoundary:function(){return new dt(this).getBoundary()},getGeometryType:function(){return"MultiLineString"},copy:function(){for(var t=new Array(this.geometries.length).fill(null),e=0;e<t.length;e++)t[e]=this.geometries[e].copy();return new gt(t,this.factory)},interfaces_:function(){
	return[st]},getClass:function(){return gt}}),gt.serialVersionUID=0x7155d2ab4afa8000,e(dt.prototype,{boundaryMultiLineString:function(t){if(this.geom.isEmpty())return this.getEmptyMultiPoint();var e=this.computeBoundaryCoordinates(t);return 1===e.length?this.geomFact.createPoint(e[0]):this.geomFact.createMultiPointFromCoords(e)},getBoundary:function(){return this.geom instanceof St?this.boundaryLineString(this.geom):this.geom instanceof gt?this.boundaryMultiLineString(this.geom):this.geom.getBoundary()},boundaryLineString:function(t){if(this.geom.isEmpty())return this.getEmptyMultiPoint();if(t.isClosed()){var e=this.bnRule.isInBoundary(2);return e?t.getStartPoint():this.geomFact.createMultiPoint()}return this.geomFact.createMultiPoint([t.getStartPoint(),t.getEndPoint()])},getEmptyMultiPoint:function(){return this.geomFact.createMultiPoint()},computeBoundaryCoordinates:function(t){var e=new I;this.endpointMap=new rt;for(var n=0;n<t.getNumGeometries();n++){var i=t.getGeometryN(n);0!==i.getNumPoints()&&(this.addEndpoint(i.getCoordinateN(0)),this.addEndpoint(i.getCoordinateN(i.getNumPoints()-1)))}for(var r=this.endpointMap.entrySet().iterator();r.hasNext();){var s=r.next(),o=s.getValue(),a=o.count;this.bnRule.isInBoundary(a)&&e.add(s.getKey())}return H.toCoordinateArray(e)},addEndpoint:function(t){var e=this.endpointMap.get(t);null===e&&(e=new pt,this.endpointMap.put(t,e)),e.count++},interfaces_:function(){return[]},getClass:function(){return dt}}),dt.getBoundary=function(){if(1===arguments.length){var t=arguments[0],e=new dt(t);return e.getBoundary()}if(2===arguments.length){var n=arguments[0],i=arguments[1],e=new dt(n,i);return e.getBoundary()}},e(pt.prototype,{interfaces_:function(){return[]},getClass:function(){return pt}}),e(Nt.prototype,{interfaces_:function(){return[]},getClass:function(){return Nt}}),Nt.chars=function(t,e){for(var n=new Array(e).fill(null),i=0;e>i;i++)n[i]=t;return new String(n)},Nt.getStackTrace=function(){if(1===arguments.length){var t=arguments[0],e=new xt,n=new vt(e);return t.printStackTrace(n),e.toString()}if(2===arguments.length){for(var i=arguments[0],r=arguments[1],s="",o=new mt(Nt.getStackTrace(i)),a=new It(o),u=0;r>u;u++)try{s+=a.readLine()+Nt.NEWLINE}catch(t){if(!(t instanceof Et))throw t;f.shouldNeverReachHere()}finally{}return s}},Nt.split=function(t,e){for(var n=e.length,i=new I,r=""+t,s=r.indexOf(e);s>=0;){var o=r.substring(0,s);i.add(o),r=r.substring(s+n),s=r.indexOf(e)}r.length>0&&i.add(r);for(var a=new Array(i.size()).fill(null),u=0;u<a.length;u++)a[u]=i.get(u);return a},Nt.toString=function(){if(1===arguments.length){var t=arguments[0];return Nt.SIMPLE_ORDINATE_FORMAT.format(t)}},Nt.spaces=function(t){return Nt.chars(" ",t)},Nt.NEWLINE=A.getProperty("line.separator"),Nt.SIMPLE_ORDINATE_FORMAT=new yt("0.#"),e(Ct.prototype,{interfaces_:function(){return[]},getClass:function(){return Ct}}),Ct.copyCoord=function(t,e,n,i){for(var r=Math.min(t.getDimension(),n.getDimension()),s=0;r>s;s++)n.setOrdinate(i,s,t.getOrdinate(e,s))},Ct.isRing=function(t){var e=t.size();return 0===e?!0:3>=e?!1:t.getOrdinate(0,D.X)===t.getOrdinate(e-1,D.X)&&t.getOrdinate(0,D.Y)===t.getOrdinate(e-1,D.Y)},Ct.isEqual=function(t,e){var n=t.size(),i=e.size();if(n!==i)return!1;for(var s=Math.min(t.getDimension(),e.getDimension()),o=0;n>o;o++)for(var a=0;s>a;a++){var u=t.getOrdinate(o,a),l=e.getOrdinate(o,a);if(!(t.getOrdinate(o,a)===e.getOrdinate(o,a)||r.isNaN(u)&&r.isNaN(l)))return!1}return!0},Ct.extend=function(t,e,n){var i=t.create(n,e.getDimension()),r=e.size();if(Ct.copy(e,0,i,0,r),r>0)for(var s=r;n>s;s++)Ct.copy(e,r-1,i,s,1);return i},Ct.reverse=function(t){for(var e=t.size()-1,n=Math.trunc(e/2),i=0;n>=i;i++)Ct.swap(t,i,e-i)},Ct.swap=function(t,e,n){if(e===n)return null;for(var i=0;i<t.getDimension();i++){var r=t.getOrdinate(e,i);t.setOrdinate(e,i,t.getOrdinate(n,i)),t.setOrdinate(n,i,r)}},Ct.copy=function(t,e,n,i,r){for(var s=0;r>s;s++)Ct.copyCoord(t,e+s,n,i+s)},Ct.toString=function(){if(1===arguments.length){var t=arguments[0],e=t.size();if(0===e)return"()";var n=t.getDimension(),i=new P;i.append("(");for(var r=0;e>r;r++){r>0&&i.append(" ");for(var s=0;n>s;s++)s>0&&i.append(","),i.append(Nt.toString(t.getOrdinate(r,s)))}return i.append(")"),i.toString()}},Ct.ensureValidRing=function(t,e){var n=e.size();if(0===n)return e;if(3>=n)return Ct.createClosedRing(t,e,4);var i=e.getOrdinate(0,D.X)===e.getOrdinate(n-1,D.X)&&e.getOrdinate(0,D.Y)===e.getOrdinate(n-1,D.Y);return i?e:Ct.createClosedRing(t,e,n+1)},Ct.createClosedRing=function(t,e,n){var i=t.create(n,e.getDimension()),r=e.size();Ct.copy(e,0,i,0,r);for(var s=r;n>s;s++)Ct.copy(e,0,i,s,1);return i},h(St,B),e(St.prototype,{computeEnvelopeInternal:function(){return this.isEmpty()?new C:this.points.expandEnvelope(new C)},isRing:function(){return this.isClosed()&&this.isSimple()},getSortIndex:function(){return B.SORTINDEX_LINESTRING},getCoordinates:function(){return this.points.toCoordinateArray()},equalsExact:function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];if(!this.isEquivalentClass(t))return!1;var n=t;if(this.points.size()!==n.points.size())return!1;for(var i=0;i<this.points.size();i++)if(!this.equal(this.points.getCoordinate(i),n.points.getCoordinate(i),e))return!1;return!0}return B.prototype.equalsExact.apply(this,arguments)},normalize:function(){for(var t=0;t<Math.trunc(this.points.size()/2);t++){var e=this.points.size()-1-t;if(!this.points.getCoordinate(t).equals(this.points.getCoordinate(e)))return this.points.getCoordinate(t).compareTo(this.points.getCoordinate(e))>0&&Ct.reverse(this.points),null}},getCoordinate:function(){return this.isEmpty()?null:this.points.getCoordinate(0)},getBoundaryDimension:function(){return this.isClosed()?lt.FALSE:0},isClosed:function(){return this.isEmpty()?!1:this.getCoordinateN(0).equals2D(this.getCoordinateN(this.getNumPoints()-1))},getEndPoint:function(){return this.isEmpty()?null:this.getPointN(this.getNumPoints()-1)},getDimension:function(){return 1},getLength:function(){return he.computeLength(this.points)},getNumPoints:function(){return this.points.size()},reverse:function(){var t=this.points.copy();Ct.reverse(t);var e=this.getFactory().createLineString(t);return e},compareToSameClass:function(){if(1===arguments.length){for(var t=arguments[0],e=t,n=0,i=0;n<this.points.size()&&i<e.points.size();){var r=this.points.getCoordinate(n).compareTo(e.points.getCoordinate(i));if(0!==r)return r;n++,i++}return n<this.points.size()?1:i<e.points.size()?-1:0}if(2===arguments.length){var s=arguments[0],o=arguments[1],e=s;return o.compare(this.points,e.points)}},apply:function(){if(R(arguments[0],z))for(var t=arguments[0],e=0;e<this.points.size();e++)t.filter(this.points.getCoordinate(e));else if(R(arguments[0],ct)){var n=arguments[0];if(0===this.points.size())return null;for(var e=0;e<this.points.size()&&(n.filter(this.points,e),!n.isDone());e++);n.isGeometryChanged()&&this.geometryChanged()}else if(R(arguments[0],ht)){var i=arguments[0];i.filter(this)}else if(R(arguments[0],q)){var r=arguments[0];r.filter(this)}},getBoundary:function(){return new dt(this).getBoundary()},isEquivalentClass:function(t){return t instanceof St},clone:function(){var t=B.prototype.clone.call(this);return t.points=this.points.clone(),t},getCoordinateN:function(t){return this.points.getCoordinate(t)},getGeometryType:function(){return"LineString"},copy:function(){return new St(this.points.copy(),this.factory)},getCoordinateSequence:function(){return this.points},isEmpty:function(){return 0===this.points.size()},init:function(t){if(null===t&&(t=this.getFactory().getCoordinateSequenceFactory().create([])),1===t.size())throw new i("Invalid number of points in LineString (found "+t.size()+" - must be 0 or >= 2)");this.points=t},isCoordinate:function(t){for(var e=0;e<this.points.size();e++)if(this.points.getCoordinate(e).equals(t))return!0;return!1},getStartPoint:function(){return this.isEmpty()?null:this.getPointN(0)},getPointN:function(t){return this.getFactory().createPoint(this.points.getCoordinate(t))},interfaces_:function(){return[st]},getClass:function(){return St}}),St.serialVersionUID=0x2b2b51ba435c8e00,e(wt.prototype,{interfaces_:function(){return[]},getClass:function(){return wt}}),h(Lt,B),e(Lt.prototype,{computeEnvelopeInternal:function(){if(this.isEmpty())return new C;var t=new C;return t.expandToInclude(this.coordinates.getX(0),this.coordinates.getY(0)),t},getSortIndex:function(){return B.SORTINDEX_POINT},getCoordinates:function(){return this.isEmpty()?[]:[this.getCoordinate()]},equalsExact:function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];return this.isEquivalentClass(t)?this.isEmpty()&&t.isEmpty()?!0:this.isEmpty()!==t.isEmpty()?!1:this.equal(t.getCoordinate(),this.getCoordinate(),e):!1}return B.prototype.equalsExact.apply(this,arguments)},normalize:function(){},getCoordinate:function(){return 0!==this.coordinates.size()?this.coordinates.getCoordinate(0):null},getBoundaryDimension:function(){return lt.FALSE},getDimension:function(){return 0},getNumPoints:function(){return this.isEmpty()?0:1},reverse:function(){return this.copy()},getX:function(){if(null===this.getCoordinate())throw new IllegalStateException("getX called on empty Point");return this.getCoordinate().x},compareToSameClass:function(){if(1===arguments.length){var t=arguments[0],e=t;return this.getCoordinate().compareTo(e.getCoordinate())}if(2===arguments.length){var n=arguments[0],i=arguments[1],e=n;return i.compare(this.coordinates,e.coordinates)}},apply:function(){if(R(arguments[0],z)){var t=arguments[0];if(this.isEmpty())return null;t.filter(this.getCoordinate())}else if(R(arguments[0],ct)){var e=arguments[0];if(this.isEmpty())return null;e.filter(this.coordinates,0),e.isGeometryChanged()&&this.geometryChanged()}else if(R(arguments[0],ht)){var n=arguments[0];n.filter(this)}else if(R(arguments[0],q)){var i=arguments[0];i.filter(this)}},getBoundary:function(){return this.getFactory().createGeometryCollection(null)},clone:function(){var t=B.prototype.clone.call(this);return t.coordinates=this.coordinates.clone(),t},getGeometryType:function(){return"Point"},copy:function(){return new Lt(this.coordinates.copy(),this.factory)},getCoordinateSequence:function(){return this.coordinates},getY:function(){if(null===this.getCoordinate())throw new IllegalStateException("getY called on empty Point");return this.getCoordinate().y},isEmpty:function(){return 0===this.coordinates.size()},init:function(t){null===t&&(t=this.getFactory().getCoordinateSequenceFactory().create([])),f.isTrue(t.size()<=1),this.coordinates=t},isSimple:function(){return!0},interfaces_:function(){return[wt]},getClass:function(){return Lt}}),Lt.serialVersionUID=0x44077bad161cbc00,e(Rt.prototype,{interfaces_:function(){return[]},getClass:function(){return Rt}}),h(Tt,B),e(Tt.prototype,{computeEnvelopeInternal:function(){return this.shell.getEnvelopeInternal()},getSortIndex:function(){return B.SORTINDEX_POLYGON},getCoordinates:function(){if(this.isEmpty())return[];for(var t=new Array(this.getNumPoints()).fill(null),e=-1,n=this.shell.getCoordinates(),i=0;i<n.length;i++)e++,t[e]=n[i];for(var r=0;r<this.holes.length;r++)for(var s=this.holes[r].getCoordinates(),o=0;o<s.length;o++)e++,t[e]=s[o];return t},getArea:function(){var t=0;t+=Math.abs(he.signedArea(this.shell.getCoordinateSequence()));for(var e=0;e<this.holes.length;e++)t-=Math.abs(he.signedArea(this.holes[e].getCoordinateSequence()));return t},isRectangle:function(){if(0!==this.getNumInteriorRing())return!1;if(null===this.shell)return!1;if(5!==this.shell.getNumPoints())return!1;for(var t=this.shell.getCoordinateSequence(),e=this.getEnvelopeInternal(),n=0;5>n;n++){var i=t.getX(n);if(i!==e.getMinX()&&i!==e.getMaxX())return!1;var r=t.getY(n);if(r!==e.getMinY()&&r!==e.getMaxY())return!1}for(var s=t.getX(0),o=t.getY(0),n=1;4>=n;n++){var i=t.getX(n),r=t.getY(n),a=i!==s,u=r!==o;if(a===u)return!1;s=i,o=r}return!0},equalsExact:function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];if(!this.isEquivalentClass(t))return!1;var n=t,i=this.shell,r=n.shell;if(!i.equalsExact(r,e))return!1;if(this.holes.length!==n.holes.length)return!1;for(var s=0;s<this.holes.length;s++)if(!this.holes[s].equalsExact(n.holes[s],e))return!1;return!0}return B.prototype.equalsExact.apply(this,arguments)},normalize:function(){if(0===arguments.length){this.normalize(this.shell,!0);for(var t=0;t<this.holes.length;t++)this.normalize(this.holes[t],!1);ut.sort(this.holes)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];if(e.isEmpty())return null;var i=new Array(e.getCoordinates().length-1).fill(null);A.arraycopy(e.getCoordinates(),0,i,0,i.length);var r=H.minCoordinate(e.getCoordinates());H.scroll(i,r),A.arraycopy(i,0,e.getCoordinates(),0,i.length),e.getCoordinates()[i.length]=i[0],he.isCCW(e.getCoordinates())===n&&H.reverse(e.getCoordinates())}},getCoordinate:function(){return this.shell.getCoordinate()},getNumInteriorRing:function(){return this.holes.length},getBoundaryDimension:function(){return 1},getDimension:function(){return 2},getLength:function(){var t=0;t+=this.shell.getLength();for(var e=0;e<this.holes.length;e++)t+=this.holes[e].getLength();return t},getNumPoints:function(){for(var t=this.shell.getNumPoints(),e=0;e<this.holes.length;e++)t+=this.holes[e].getNumPoints();return t},reverse:function(){var t=this.copy();t.shell=this.shell.copy().reverse(),t.holes=new Array(this.holes.length).fill(null);for(var e=0;e<this.holes.length;e++)t.holes[e]=this.holes[e].copy().reverse();return t},convexHull:function(){return this.getExteriorRing().convexHull()},compareToSameClass:function(){if(1===arguments.length){var t=arguments[0],e=this.shell,n=t.shell;return e.compareToSameClass(n)}if(2===arguments.length){var i=arguments[0],r=arguments[1],s=i,e=this.shell,n=s.shell,o=e.compareToSameClass(n,r);if(0!==o)return o;for(var a=this.getNumInteriorRing(),u=s.getNumInteriorRing(),l=0;a>l&&u>l;){var h=this.getInteriorRingN(l),c=s.getInteriorRingN(l),f=h.compareToSameClass(c,r);if(0!==f)return f;l++}return a>l?1:u>l?-1:0}},apply:function(){if(R(arguments[0],z)){var t=arguments[0];this.shell.apply(t);for(var e=0;e<this.holes.length;e++)this.holes[e].apply(t)}else if(R(arguments[0],ct)){var n=arguments[0];if(this.shell.apply(n),!n.isDone())for(var e=0;e<this.holes.length&&(this.holes[e].apply(n),!n.isDone());e++);n.isGeometryChanged()&&this.geometryChanged()}else if(R(arguments[0],ht)){var i=arguments[0];i.filter(this)}else if(R(arguments[0],q)){var r=arguments[0];r.filter(this),this.shell.apply(r);for(var e=0;e<this.holes.length;e++)this.holes[e].apply(r)}},getBoundary:function(){if(this.isEmpty())return this.getFactory().createMultiLineString();var t=new Array(this.holes.length+1).fill(null);t[0]=this.shell;for(var e=0;e<this.holes.length;e++)t[e+1]=this.holes[e];return t.length<=1?this.getFactory().createLinearRing(t[0].getCoordinateSequence()):this.getFactory().createMultiLineString(t)},clone:function(){var t=B.prototype.clone.call(this);t.shell=this.shell.clone(),t.holes=new Array(this.holes.length).fill(null);for(var e=0;e<this.holes.length;e++)t.holes[e]=this.holes[e].clone();return t},getGeometryType:function(){return"Polygon"},copy:function(){for(var t=this.shell.copy(),e=new Array(this.holes.length).fill(null),n=0;n<e.length;n++)e[n]=this.holes[n].copy();return new Tt(t,e,this.factory)},getExteriorRing:function(){return this.shell},isEmpty:function(){return this.shell.isEmpty()},getInteriorRingN:function(t){return this.holes[t]},interfaces_:function(){return[Rt]},getClass:function(){return Tt}}),Tt.serialVersionUID=-0x307ffefd8dc97200,h(Pt,ft),e(Pt.prototype,{getSortIndex:function(){return B.SORTINDEX_MULTIPOINT},isValid:function(){return!0},equalsExact:function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];return this.isEquivalentClass(t)?ft.prototype.equalsExact.call(this,t,e):!1}return ft.prototype.equalsExact.apply(this,arguments)},getCoordinate:function(){if(1===arguments.length){var t=arguments[0];return this.geometries[t].getCoordinate()}return ft.prototype.getCoordinate.apply(this,arguments)},getBoundaryDimension:function(){return lt.FALSE},getDimension:function(){return 0},getBoundary:function(){return this.getFactory().createGeometryCollection(null)},getGeometryType:function(){return"MultiPoint"},copy:function(){for(var t=new Array(this.geometries.length).fill(null),e=0;e<t.length;e++)t[e]=this.geometries[e].copy();return new Pt(t,this.factory)},interfaces_:function(){return[wt]},getClass:function(){return Pt}}),Pt.serialVersionUID=-0x6fb1ed4162e0fc00,h(bt,St),e(bt.prototype,{getSortIndex:function(){return B.SORTINDEX_LINEARRING},getBoundaryDimension:function(){return lt.FALSE},isClosed:function(){return this.isEmpty()?!0:St.prototype.isClosed.call(this)},reverse:function(){var t=this.points.copy();Ct.reverse(t);var e=this.getFactory().createLinearRing(t);return e},validateConstruction:function(){if(!this.isEmpty()&&!St.prototype.isClosed.call(this))throw new i("Points of LinearRing do not form a closed linestring");if(this.getCoordinateSequence().size()>=1&&this.getCoordinateSequence().size()<bt.MINIMUM_VALID_SIZE)throw new i("Invalid number of points in LinearRing (found "+this.getCoordinateSequence().size()+" - must be 0 or >= 4)")},getGeometryType:function(){return"LinearRing"},copy:function(){return new bt(this.points.copy(),this.factory)},interfaces_:function(){return[]},getClass:function(){return bt}}),bt.MINIMUM_VALID_SIZE=4,bt.serialVersionUID=-0x3b229e262367a600,h(Ot,ft),e(Ot.prototype,{getSortIndex:function(){return B.SORTINDEX_MULTIPOLYGON},equalsExact:function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];return this.isEquivalentClass(t)?ft.prototype.equalsExact.call(this,t,e):!1}return ft.prototype.equalsExact.apply(this,arguments)},getBoundaryDimension:function(){return 1},getDimension:function(){return 2},reverse:function(){for(var t=this.geometries.length,e=new Array(t).fill(null),n=0;n<this.geometries.length;n++)e[n]=this.geometries[n].reverse();return this.getFactory().createMultiPolygon(e)},getBoundary:function(){if(this.isEmpty())return this.getFactory().createMultiLineString();for(var t=new I,e=0;e<this.geometries.length;e++)for(var n=this.geometries[e],i=n.getBoundary(),r=0;r<i.getNumGeometries();r++)t.add(i.getGeometryN(r));var s=new Array(t.size()).fill(null);return this.getFactory().createMultiLineString(t.toArray(s))},getGeometryType:function(){return"MultiPolygon"},copy:function(){for(var t=new Array(this.geometries.length).fill(null),e=0;e<t.length;e++)t[e]=this.geometries[e].copy();return new Ot(t,this.factory)},interfaces_:function(){return[Rt]},getClass:function(){return Ot}}),Ot.serialVersionUID=-0x7a5aa1369171980,e(_t.prototype,{setCopyUserData:function(t){this.isUserDataCopied=t},edit:function(t,e){if(null===t)return null;var n=this.editInternal(t,e);return this.isUserDataCopied&&n.setUserData(t.getUserData()),n},editInternal:function(t,e){return null===this.factory&&(this.factory=t.getFactory()),t instanceof ft?this.editGeometryCollection(t,e):t instanceof Tt?this.editPolygon(t,e):t instanceof Lt?e.edit(t,this.factory):t instanceof St?e.edit(t,this.factory):(f.shouldNeverReachHere("Unsupported Geometry class: "+t.getClass().getName()),null)},editGeometryCollection:function(t,e){for(var n=e.edit(t,this.factory),i=new I,r=0;r<n.getNumGeometries();r++){var s=this.edit(n.getGeometryN(r),e);null===s||s.isEmpty()||i.add(s)}return n.getClass()===Pt?this.factory.createMultiPoint(i.toArray([])):n.getClass()===gt?this.factory.createMultiLineString(i.toArray([])):n.getClass()===Ot?this.factory.createMultiPolygon(i.toArray([])):this.factory.createGeometryCollection(i.toArray([]))},editPolygon:function(t,e){var n=e.edit(t,this.factory);if(null===n&&(n=this.factory.createPolygon(null)),n.isEmpty())return n;var i=this.edit(n.getExteriorRing(),e);if(null===i||i.isEmpty())return this.factory.createPolygon();for(var r=new I,s=0;s<n.getNumInteriorRing();s++){var o=this.edit(n.getInteriorRingN(s),e);null===o||o.isEmpty()||r.add(o)}return this.factory.createPolygon(i,r.toArray([]))},interfaces_:function(){return[]},getClass:function(){return _t}}),_t.GeometryEditorOperation=Mt,e(Dt.prototype,{edit:function(t,e){return t},interfaces_:function(){return[Mt]},getClass:function(){return Dt}}),e(At.prototype,{edit:function(t,e){if(t instanceof bt)return e.createLinearRing(this.editCoordinates(t.getCoordinates(),t));if(t instanceof St)return e.createLineString(this.editCoordinates(t.getCoordinates(),t));if(t instanceof Lt){var n=this.editCoordinates(t.getCoordinates(),t);return n.length>0?e.createPoint(n[0]):e.createPoint()}return t},interfaces_:function(){return[Mt]},getClass:function(){return At}}),e(Ft.prototype,{edit:function(t,e){return t instanceof bt?e.createLinearRing(this.edit(t.getCoordinateSequence(),t)):t instanceof St?e.createLineString(this.edit(t.getCoordinateSequence(),t)):t instanceof Lt?e.createPoint(this.edit(t.getCoordinateSequence(),t)):t},interfaces_:function(){return[Mt]},getClass:function(){return Ft}}),_t.NoOpGeometryOperation=Dt,_t.CoordinateOperation=At,_t.CoordinateSequenceOperation=Ft,e(Gt.prototype,{setOrdinate:function(t,e,n){switch(e){case D.X:this.coordinates[t].x=n;break;case D.Y:this.coordinates[t].y=n;break;case D.Z:this.coordinates[t].z=n;break;default:throw new i("invalid ordinateIndex")}},size:function(){return this.coordinates.length},getOrdinate:function(t,e){switch(e){case D.X:return this.coordinates[t].x;case D.Y:return this.coordinates[t].y;case D.Z:return this.coordinates[t].z}return r.NaN},getCoordinate:function(){if(1===arguments.length){var t=arguments[0];return this.coordinates[t]}if(2===arguments.length){var e=arguments[0],n=arguments[1];n.x=this.coordinates[e].x,n.y=this.coordinates[e].y,n.z=this.coordinates[e].z}},getCoordinateCopy:function(t){return new g(this.coordinates[t])},getDimension:function(){return this.dimension},getX:function(t){return this.coordinates[t].x},clone:function(){for(var t=new Array(this.size()).fill(null),e=0;e<this.coordinates.length;e++)t[e]=this.coordinates[e].clone();return new Gt(t,this.dimension)},expandEnvelope:function(t){for(var e=0;e<this.coordinates.length;e++)t.expandToInclude(this.coordinates[e]);return t},copy:function(){for(var t=new Array(this.size()).fill(null),e=0;e<this.coordinates.length;e++)t[e]=this.coordinates[e].copy();return new Gt(t,this.dimension)},toString:function(){if(this.coordinates.length>0){var t=new P(17*this.coordinates.length);t.append("("),t.append(this.coordinates[0]);for(var e=1;e<this.coordinates.length;e++)t.append(", "),t.append(this.coordinates[e]);return t.append(")"),t.toString()}return"()"},getY:function(t){return this.coordinates[t].y},toCoordinateArray:function(){return this.coordinates},interfaces_:function(){return[D,u]},getClass:function(){return Gt}}),Gt.serialVersionUID=-0xcb44a778db18e00,e(qt.prototype,{readResolve:function(){return qt.instance()},create:function(){if(1===arguments.length){if(arguments[0]instanceof Array){var t=arguments[0];return new Gt(t)}if(R(arguments[0],D)){var e=arguments[0];return new Gt(e)}}else if(2===arguments.length){var n=arguments[0],i=arguments[1];return i>3&&(i=3),2>i?new Gt(n):new Gt(n,i)}},interfaces_:function(){return[G,u]},getClass:function(){return qt}}),qt.instance=function(){return qt.instanceObject},qt.serialVersionUID=-0x38e49fa6cf6f2e00,qt.instanceObject=new qt;var no,io=Object.defineProperty,ro=zt({delete:kt,has:Xt,get:Yt,set:Ht,keys:jt,values:Kt,entries:Zt,forEach:$t,clear:Wt}),so="undefined"!=typeof Map&&Map.prototype.values?Map:ro;te.prototype=new K,te.prototype.get=function(t){return this.map_.get(t)||null},te.prototype.put=function(t,e){return this.map_.set(t,e),e},te.prototype.values=function(){for(var t=new I,e=this.map_.values(),n=e.next();!n.done;)t.add(n.value),n=e.next();return t},te.prototype.entrySet=function(){var t=new J;return this.map_.entries().forEach(function(e){return t.add(e)}),t},te.prototype.size=function(){return this.map_.size()},e(ee.prototype,{equals:function(t){if(!(t instanceof ee))return!1;var e=t;return this.modelType===e.modelType&&this.scale===e.scale},compareTo:function(t){var e=t,n=this.getMaximumSignificantDigits(),i=e.getMaximumSignificantDigits();return new b(n).compareTo(new b(i))},getScale:function(){return this.scale},isFloating:function(){return this.modelType===ee.FLOATING||this.modelType===ee.FLOATING_SINGLE},getType:function(){return this.modelType},toString:function(){var t="UNKNOWN";return this.modelType===ee.FLOATING?t="Floating":this.modelType===ee.FLOATING_SINGLE?t="Floating-Single":this.modelType===ee.FIXED&&(t="Fixed (Scale="+this.getScale()+")"),t},makePrecise:function(){if("number"==typeof arguments[0]){var t=arguments[0];if(r.isNaN(t))return t;if(this.modelType===ee.FLOATING_SINGLE){var e=t;return e}return this.modelType===ee.FIXED?Math.round(t*this.scale)/this.scale:t}if(arguments[0]instanceof g){var n=arguments[0];if(this.modelType===ee.FLOATING)return null;n.x=this.makePrecise(n.x),n.y=this.makePrecise(n.y)}},getMaximumSignificantDigits:function(){var t=16;return this.modelType===ee.FLOATING?t=16:this.modelType===ee.FLOATING_SINGLE?t=6:this.modelType===ee.FIXED&&(t=1+Math.trunc(Math.ceil(Math.log(this.getScale())/Math.log(10)))),t},setScale:function(t){this.scale=Math.abs(t)},interfaces_:function(){return[u,s]},getClass:function(){return ee}}),ee.mostPrecise=function(t,e){return t.compareTo(e)>=0?t:e},e(ne.prototype,{readResolve:function(){return ne.nameToTypeMap.get(this.name)},toString:function(){return this.name},interfaces_:function(){return[u]},getClass:function(){return ne}}),ne.serialVersionUID=-552860263173159e4,ne.nameToTypeMap=new te,ee.Type=ne,ee.serialVersionUID=0x6bee6404e9a25c00,ee.FIXED=new ne("FIXED"),ee.FLOATING=new ne("FLOATING"),ee.FLOATING_SINGLE=new ne("FLOATING SINGLE"),ee.maximumPreciseValue=9007199254740992,e(ie.prototype,{toGeometry:function(t){return t.isNull()?this.createPoint(null):t.getMinX()===t.getMaxX()&&t.getMinY()===t.getMaxY()?this.createPoint(new g(t.getMinX(),t.getMinY())):t.getMinX()===t.getMaxX()||t.getMinY()===t.getMaxY()?this.createLineString([new g(t.getMinX(),t.getMinY()),new g(t.getMaxX(),t.getMaxY())]):this.createPolygon(this.createLinearRing([new g(t.getMinX(),t.getMinY()),new g(t.getMinX(),t.getMaxY()),new g(t.getMaxX(),t.getMaxY()),new g(t.getMaxX(),t.getMinY()),new g(t.getMinX(),t.getMinY())]),null)},createLineString:function(){if(0===arguments.length)return this.createLineString(this.getCoordinateSequenceFactory().create([]));if(1===arguments.length){if(arguments[0]instanceof Array){var t=arguments[0];return this.createLineString(null!==t?this.getCoordinateSequenceFactory().create(t):null)}if(R(arguments[0],D)){var e=arguments[0];return new St(e,this)}}},createMultiLineString:function(){if(0===arguments.length)return new gt(null,this);if(1===arguments.length){var t=arguments[0];return new gt(t,this)}},buildGeometry:function(t){for(var e=null,n=!1,i=!1,r=t.iterator();r.hasNext();){var s=r.next(),o=s.getClass();null===e&&(e=o),o!==e&&(n=!0),s.isGeometryCollectionOrDerived()&&(i=!0)}if(null===e)return this.createGeometryCollection();if(n||i)return this.createGeometryCollection(ie.toGeometryArray(t));var a=t.iterator().next(),u=t.size()>1;if(u){if(a instanceof Tt)return this.createMultiPolygon(ie.toPolygonArray(t));if(a instanceof St)return this.createMultiLineString(ie.toLineStringArray(t));if(a instanceof Lt)return this.createMultiPoint(ie.toPointArray(t));f.shouldNeverReachHere("Unhandled class: "+a.getClass().getName())}return a},createMultiPointFromCoords:function(t){return this.createMultiPoint(null!==t?this.getCoordinateSequenceFactory().create(t):null)},createPoint:function(){if(0===arguments.length)return this.createPoint(this.getCoordinateSequenceFactory().create([]));if(1===arguments.length){if(arguments[0]instanceof g){var t=arguments[0];return this.createPoint(null!==t?this.getCoordinateSequenceFactory().create([t]):null)}if(R(arguments[0],D)){var e=arguments[0];return new Lt(e,this)}}},getCoordinateSequenceFactory:function(){return this.coordinateSequenceFactory},createPolygon:function(){if(0===arguments.length)return new Tt(null,null,this);if(1===arguments.length){if(R(arguments[0],D)){var t=arguments[0];return this.createPolygon(this.createLinearRing(t))}if(arguments[0]instanceof Array){var e=arguments[0];return this.createPolygon(this.createLinearRing(e))}if(arguments[0]instanceof bt){var n=arguments[0];return this.createPolygon(n,null)}}else if(2===arguments.length){var i=arguments[0],r=arguments[1];return new Tt(i,r,this)}},getSRID:function(){return this.SRID},createGeometryCollection:function(){if(0===arguments.length)return new ft(null,this);if(1===arguments.length){var t=arguments[0];return new ft(t,this)}},createGeometry:function(t){var e=new _t(this);return e.edit(t,{edit:function(){if(2===arguments.length){var t=arguments[0];arguments[1];return this.coordinateSequenceFactory.create(t)}}})},getPrecisionModel:function(){return this.precisionModel},createLinearRing:function(){if(0===arguments.length)return this.createLinearRing(this.getCoordinateSequenceFactory().create([]));if(1===arguments.length){if(arguments[0]instanceof Array){var t=arguments[0];return this.createLinearRing(null!==t?this.getCoordinateSequenceFactory().create(t):null)}if(R(arguments[0],D)){var e=arguments[0];return new bt(e,this)}}},createMultiPolygon:function(){if(0===arguments.length)return new Ot(null,this);if(1===arguments.length){var t=arguments[0];return new Ot(t,this)}},createMultiPoint:function(){if(0===arguments.length)return new Pt(null,this);if(1===arguments.length){if(arguments[0]instanceof Array){var t=arguments[0];return new Pt(t,this)}if(arguments[0]instanceof Array){var e=arguments[0];return this.createMultiPoint(null!==e?this.getCoordinateSequenceFactory().create(e):null)}if(R(arguments[0],D)){var n=arguments[0];if(null===n)return this.createMultiPoint(new Array(0).fill(null));for(var i=new Array(n.size()).fill(null),r=0;r<n.size();r++){var s=this.getCoordinateSequenceFactory().create(1,n.getDimension());Ct.copy(n,r,s,0,1),i[r]=this.createPoint(s)}return this.createMultiPoint(i)}}},interfaces_:function(){return[u]},getClass:function(){return ie}}),ie.toMultiPolygonArray=function(t){var e=new Array(t.size()).fill(null);return t.toArray(e)},ie.toGeometryArray=function(t){if(null===t)return null;var e=new Array(t.size()).fill(null);return t.toArray(e)},ie.getDefaultCoordinateSequenceFactory=function(){return qt.instance()},ie.toMultiLineStringArray=function(t){var e=new Array(t.size()).fill(null);return t.toArray(e)},ie.toLineStringArray=function(t){var e=new Array(t.size()).fill(null);return t.toArray(e)},ie.toMultiPointArray=function(t){var e=new Array(t.size()).fill(null);return t.toArray(e)},ie.toLinearRingArray=function(t){var e=new Array(t.size()).fill(null);return t.toArray(e)},ie.toPointArray=function(t){var e=new Array(t.size()).fill(null);return t.toArray(e)},ie.toPolygonArray=function(t){var e=new Array(t.size()).fill(null);return t.toArray(e)},ie.createPointFromInternalCoord=function(t,e){return e.getPrecisionModel().makePrecise(t),e.getFactory().createPoint(t)},ie.serialVersionUID=-0x5ea75f2051eeb400;var oo={typeStr:/^\s*(\w+)\s*\(\s*(.*)\s*\)\s*$/,emptyTypeStr:/^\s*(\w+)\s*EMPTY\s*$/,spaces:/\s+/,parenComma:/\)\s*,\s*\(/,doubleParenComma:/\)\s*\)\s*,\s*\(\s*\(/,trimParens:/^\s*\(?(.*?)\)?\s*$/};e(re.prototype,{read:function(t){var e,n,i;t=t.replace(/[\n\r]/g," ");var r=oo.typeStr.exec(t);if(-1!==t.search("EMPTY")&&(r=oo.emptyTypeStr.exec(t),r[2]=void 0),r&&(n=r[1].toLowerCase(),i=r[2],uo[n]&&(e=uo[n].apply(this,[i]))),void 0===e)throw new Error("Could not parse WKT "+t);return e},write:function(t){return this.extractGeometry(t)},extractGeometry:function(t){var e=t.getGeometryType().toLowerCase();if(!ao[e])return null;var n,i=e.toUpperCase();return n=t.isEmpty()?i+" EMPTY":i+"("+ao[e].apply(this,[t])+")"}});var ao={coordinate:function(t){return t.x+" "+t.y},point:function(t){
	return ao.coordinate.call(this,t.coordinates.coordinates[0])},multipoint:function(t){for(var e=[],n=0,i=t.geometries.length;i>n;++n)e.push("("+ao.point.apply(this,[t.geometries[n]])+")");return e.join(",")},linestring:function(t){for(var e=[],n=0,i=t.points.coordinates.length;i>n;++n)e.push(ao.coordinate.apply(this,[t.points.coordinates[n]]));return e.join(",")},linearring:function(t){for(var e=[],n=0,i=t.points.coordinates.length;i>n;++n)e.push(ao.coordinate.apply(this,[t.points.coordinates[n]]));return e.join(",")},multilinestring:function(t){for(var e=[],n=0,i=t.geometries.length;i>n;++n)e.push("("+ao.linestring.apply(this,[t.geometries[n]])+")");return e.join(",")},polygon:function(t){var e=[];e.push("("+ao.linestring.apply(this,[t.shell])+")");for(var n=0,i=t.holes.length;i>n;++n)e.push("("+ao.linestring.apply(this,[t.holes[n]])+")");return e.join(",")},multipolygon:function(t){for(var e=[],n=0,i=t.geometries.length;i>n;++n)e.push("("+ao.polygon.apply(this,[t.geometries[n]])+")");return e.join(",")},geometrycollection:function(t){for(var e=[],n=0,i=t.geometries.length;i>n;++n)e.push(this.extractGeometry(t.geometries[n]));return e.join(",")}},uo={point:function(t){if(void 0===t)return this.geometryFactory.createPoint();var e=t.trim().split(oo.spaces);return this.geometryFactory.createPoint(new g(Number.parseFloat(e[0]),Number.parseFloat(e[1])))},multipoint:function(t){if(void 0===t)return this.geometryFactory.createMultiPoint();for(var e,n=t.trim().split(","),i=[],r=0,s=n.length;s>r;++r)e=n[r].replace(oo.trimParens,"$1"),i.push(uo.point.apply(this,[e]));return this.geometryFactory.createMultiPoint(i)},linestring:function(t){if(void 0===t)return this.geometryFactory.createLineString();for(var e,n=t.trim().split(","),i=[],r=0,s=n.length;s>r;++r)e=n[r].trim().split(oo.spaces),i.push(new g(Number.parseFloat(e[0]),Number.parseFloat(e[1])));return this.geometryFactory.createLineString(i)},linearring:function(t){if(void 0===t)return this.geometryFactory.createLinearRing();for(var e,n=t.trim().split(","),i=[],r=0,s=n.length;s>r;++r)e=n[r].trim().split(oo.spaces),i.push(new g(Number.parseFloat(e[0]),Number.parseFloat(e[1])));return this.geometryFactory.createLinearRing(i)},multilinestring:function(t){if(void 0===t)return this.geometryFactory.createMultiLineString();for(var e,n=t.trim().split(oo.parenComma),i=[],r=0,s=n.length;s>r;++r)e=n[r].replace(oo.trimParens,"$1"),i.push(uo.linestring.apply(this,[e]));return this.geometryFactory.createMultiLineString(i)},polygon:function(t){if(void 0===t)return this.geometryFactory.createPolygon();for(var e,n,i,r,s=t.trim().split(oo.parenComma),o=[],a=0,u=s.length;u>a;++a)e=s[a].replace(oo.trimParens,"$1"),n=uo.linestring.apply(this,[e]),i=this.geometryFactory.createLinearRing(n.points),0===a?r=i:o.push(i);return this.geometryFactory.createPolygon(r,o)},multipolygon:function(t){if(void 0===t)return this.geometryFactory.createMultiPolygon();for(var e,n=t.trim().split(oo.doubleParenComma),i=[],r=0,s=n.length;s>r;++r)e=n[r].replace(oo.trimParens,"$1"),i.push(uo.polygon.apply(this,[e]));return this.geometryFactory.createMultiPolygon(i)},geometrycollection:function(t){if(void 0===t)return this.geometryFactory.createGeometryCollection();t=t.replace(/,\s*([A-Za-z])/g,"|$1");for(var e=t.trim().split("|"),n=[],i=0,r=e.length;r>i;++i)n.push(this.read(e[i]));return this.geometryFactory.createGeometryCollection(n)}};e(se.prototype,{write:function(t){return this.parser.write(t)}}),e(se,{toLineString:function(t,e){if(2!==arguments.length)throw new Error("Not implemented");return"LINESTRING ( "+t.x+" "+t.y+", "+e.x+" "+e.y+" )"}}),e(oe.prototype,{getIndexAlongSegment:function(t,e){return this.computeIntLineIndex(),this.intLineIndex[t][e]},getTopologySummary:function(){var t=new P;return this.isEndPoint()&&t.append(" endpoint"),this._isProper&&t.append(" proper"),this.isCollinear()&&t.append(" collinear"),t.toString()},computeIntersection:function(t,e,n,i){this.inputLines[0][0]=t,this.inputLines[0][1]=e,this.inputLines[1][0]=n,this.inputLines[1][1]=i,this.result=this.computeIntersect(t,e,n,i)},getIntersectionNum:function(){return this.result},computeIntLineIndex:function(){if(0===arguments.length)null===this.intLineIndex&&(this.intLineIndex=Array(2).fill().map(function(){return Array(2)}),this.computeIntLineIndex(0),this.computeIntLineIndex(1));else if(1===arguments.length){var t=arguments[0],e=this.getEdgeDistance(t,0),n=this.getEdgeDistance(t,1);e>n?(this.intLineIndex[t][0]=0,this.intLineIndex[t][1]=1):(this.intLineIndex[t][0]=1,this.intLineIndex[t][1]=0)}},isProper:function(){return this.hasIntersection()&&this._isProper},setPrecisionModel:function(t){this.precisionModel=t},isInteriorIntersection:function(){if(0===arguments.length)return this.isInteriorIntersection(0)?!0:!!this.isInteriorIntersection(1);if(1===arguments.length){for(var t=arguments[0],e=0;e<this.result;e++)if(!this.intPt[e].equals2D(this.inputLines[t][0])&&!this.intPt[e].equals2D(this.inputLines[t][1]))return!0;return!1}},getIntersection:function(t){return this.intPt[t]},isEndPoint:function(){return this.hasIntersection()&&!this._isProper},hasIntersection:function(){return this.result!==oe.NO_INTERSECTION},getEdgeDistance:function(t,e){var n=oe.computeEdgeDistance(this.intPt[e],this.inputLines[t][0],this.inputLines[t][1]);return n},isCollinear:function(){return this.result===oe.COLLINEAR_INTERSECTION},toString:function(){return se.toLineString(this.inputLines[0][0],this.inputLines[0][1])+" - "+se.toLineString(this.inputLines[1][0],this.inputLines[1][1])+this.getTopologySummary()},getEndpoint:function(t,e){return this.inputLines[t][e]},isIntersection:function(t){for(var e=0;e<this.result;e++)if(this.intPt[e].equals2D(t))return!0;return!1},getIntersectionAlongSegment:function(t,e){return this.computeIntLineIndex(),this.intPt[this.intLineIndex[t][e]]},interfaces_:function(){return[]},getClass:function(){return oe}}),oe.computeEdgeDistance=function(t,e,n){var i=Math.abs(n.x-e.x),r=Math.abs(n.y-e.y),s=-1;if(t.equals(e))s=0;else if(t.equals(n))s=i>r?i:r;else{var o=Math.abs(t.x-e.x),a=Math.abs(t.y-e.y);s=i>r?o:a,0!==s||t.equals(e)||(s=Math.max(o,a))}return f.isTrue(!(0===s&&!t.equals(e)),"Bad distance calculation"),s},oe.nonRobustComputeEdgeDistance=function(t,e,n){var i=t.x-e.x,r=t.y-e.y,s=Math.sqrt(i*i+r*r);return f.isTrue(!(0===s&&!t.equals(e)),"Invalid distance calculation"),s},oe.DONT_INTERSECT=0,oe.DO_INTERSECT=1,oe.COLLINEAR=2,oe.NO_INTERSECTION=0,oe.POINT_INTERSECTION=1,oe.COLLINEAR_INTERSECTION=2,h(ae,oe),e(ae.prototype,{isInSegmentEnvelopes:function(t){var e=new C(this.inputLines[0][0],this.inputLines[0][1]),n=new C(this.inputLines[1][0],this.inputLines[1][1]);return e.contains(t)&&n.contains(t)},computeIntersection:function(){if(3!==arguments.length)return oe.prototype.computeIntersection.apply(this,arguments);var t=arguments[0],e=arguments[1],n=arguments[2];return this._isProper=!1,C.intersects(e,n,t)&&0===he.orientationIndex(e,n,t)&&0===he.orientationIndex(n,e,t)?(this._isProper=!0,(t.equals(e)||t.equals(n))&&(this._isProper=!1),this.result=oe.POINT_INTERSECTION,null):void(this.result=oe.NO_INTERSECTION)},normalizeToMinimum:function(t,e,n,i,r){r.x=this.smallestInAbsValue(t.x,e.x,n.x,i.x),r.y=this.smallestInAbsValue(t.y,e.y,n.y,i.y),t.x-=r.x,t.y-=r.y,e.x-=r.x,e.y-=r.y,n.x-=r.x,n.y-=r.y,i.x-=r.x,i.y-=r.y},safeHCoordinateIntersection:function(t,e,n,i){var r=null;try{r=F.intersection(t,e,n,i)}catch(s){if(!(s instanceof w))throw s;r=ae.nearestEndpoint(t,e,n,i)}finally{}return r},intersection:function(t,e,n,i){var r=this.intersectionWithNormalization(t,e,n,i);return this.isInSegmentEnvelopes(r)||(r=new g(ae.nearestEndpoint(t,e,n,i))),null!==this.precisionModel&&this.precisionModel.makePrecise(r),r},smallestInAbsValue:function(t,e,n,i){var r=t,s=Math.abs(r);return Math.abs(e)<s&&(r=e,s=Math.abs(e)),Math.abs(n)<s&&(r=n,s=Math.abs(n)),Math.abs(i)<s&&(r=i),r},checkDD:function(t,e,n,i,r){var s=M.intersection(t,e,n,i),o=this.isInSegmentEnvelopes(s);A.out.println("DD in env = "+o+"  --------------------- "+s),r.distance(s)>1e-4&&A.out.println("Distance = "+r.distance(s))},intersectionWithNormalization:function(t,e,n,i){var r=new g(t),s=new g(e),o=new g(n),a=new g(i),u=new g;this.normalizeToEnvCentre(r,s,o,a,u);var l=this.safeHCoordinateIntersection(r,s,o,a);return l.x+=u.x,l.y+=u.y,l},computeCollinearIntersection:function(t,e,n,i){var r=C.intersects(t,e,n),s=C.intersects(t,e,i),o=C.intersects(n,i,t),a=C.intersects(n,i,e);return r&&s?(this.intPt[0]=n,this.intPt[1]=i,oe.COLLINEAR_INTERSECTION):o&&a?(this.intPt[0]=t,this.intPt[1]=e,oe.COLLINEAR_INTERSECTION):r&&o?(this.intPt[0]=n,this.intPt[1]=t,!n.equals(t)||s||a?oe.COLLINEAR_INTERSECTION:oe.POINT_INTERSECTION):r&&a?(this.intPt[0]=n,this.intPt[1]=e,!n.equals(e)||s||o?oe.COLLINEAR_INTERSECTION:oe.POINT_INTERSECTION):s&&o?(this.intPt[0]=i,this.intPt[1]=t,!i.equals(t)||r||a?oe.COLLINEAR_INTERSECTION:oe.POINT_INTERSECTION):s&&a?(this.intPt[0]=i,this.intPt[1]=e,!i.equals(e)||r||o?oe.COLLINEAR_INTERSECTION:oe.POINT_INTERSECTION):oe.NO_INTERSECTION},normalizeToEnvCentre:function(t,e,n,i,r){var s=t.x<e.x?t.x:e.x,o=t.y<e.y?t.y:e.y,a=t.x>e.x?t.x:e.x,u=t.y>e.y?t.y:e.y,l=n.x<i.x?n.x:i.x,h=n.y<i.y?n.y:i.y,c=n.x>i.x?n.x:i.x,f=n.y>i.y?n.y:i.y,g=s>l?s:l,d=c>a?a:c,p=o>h?o:h,v=f>u?u:f,m=(g+d)/2,y=(p+v)/2;r.x=m,r.y=y,t.x-=r.x,t.y-=r.y,e.x-=r.x,e.y-=r.y,n.x-=r.x,n.y-=r.y,i.x-=r.x,i.y-=r.y},computeIntersect:function(t,e,n,i){if(this._isProper=!1,!C.intersects(t,e,n,i))return oe.NO_INTERSECTION;var r=he.orientationIndex(t,e,n),s=he.orientationIndex(t,e,i);if(r>0&&s>0||0>r&&0>s)return oe.NO_INTERSECTION;var o=he.orientationIndex(n,i,t),a=he.orientationIndex(n,i,e);if(o>0&&a>0||0>o&&0>a)return oe.NO_INTERSECTION;var u=0===r&&0===s&&0===o&&0===a;return u?this.computeCollinearIntersection(t,e,n,i):(0===r||0===s||0===o||0===a?(this._isProper=!1,t.equals2D(n)||t.equals2D(i)?this.intPt[0]=t:e.equals2D(n)||e.equals2D(i)?this.intPt[0]=e:0===r?this.intPt[0]=new g(n):0===s?this.intPt[0]=new g(i):0===o?this.intPt[0]=new g(t):0===a&&(this.intPt[0]=new g(e))):(this._isProper=!0,this.intPt[0]=this.intersection(t,e,n,i)),oe.POINT_INTERSECTION)},interfaces_:function(){return[]},getClass:function(){return ae}}),ae.nearestEndpoint=function(t,e,n,i){var r=t,s=he.distancePointLine(t,n,i),o=he.distancePointLine(e,n,i);return s>o&&(s=o,r=e),o=he.distancePointLine(n,t,e),s>o&&(s=o,r=n),o=he.distancePointLine(i,t,e),s>o&&(s=o,r=i),r},e(ue.prototype,{interfaces_:function(){return[]},getClass:function(){return ue}}),ue.orientationIndex=function(t,e,n){var i=e.x-t.x,r=e.y-t.y,s=n.x-e.x,o=n.y-e.y;return ue.signOfDet2x2(i,r,s,o)},ue.signOfDet2x2=function(t,e,n,i){var r=null,s=null,o=null,a=0;if(r=1,0===t||0===i)return 0===e||0===n?0:e>0?n>0?-r:r:n>0?r:-r;if(0===e||0===n)return i>0?t>0?r:-r:t>0?-r:r;if(e>0?i>0?i>=e||(r=-r,s=t,t=n,n=s,s=e,e=i,i=s):-i>=e?(r=-r,n=-n,i=-i):(s=t,t=-n,n=s,s=e,e=-i,i=s):i>0?i>=-e?(r=-r,t=-t,e=-e):(s=-t,t=n,n=s,s=-e,e=i,i=s):e>=i?(t=-t,e=-e,n=-n,i=-i):(r=-r,s=-t,t=-n,n=s,s=-e,e=-i,i=s),t>0){if(!(n>0))return r;if(!(n>=t))return r}else{if(n>0)return-r;if(!(t>=n))return-r;r=-r,t=-t,n=-n}for(;;){if(a+=1,o=Math.floor(n/t),n-=o*t,i-=o*e,0>i)return-r;if(i>e)return r;if(t>n+n){if(i+i>e)return r}else{if(e>i+i)return-r;n=t-n,i=e-i,r=-r}if(0===i)return 0===n?0:-r;if(0===n)return r;if(o=Math.floor(t/n),t-=o*n,e-=o*i,0>e)return r;if(e>i)return-r;if(n>t+t){if(e+e>i)return-r}else{if(i>e+e)return r;t=n-t,e=i-e,r=-r}if(0===e)return 0===t?0:r;if(0===t)return-r}},e(le.prototype,{countSegment:function(t,e){if(t.x<this.p.x&&e.x<this.p.x)return null;if(this.p.x===e.x&&this.p.y===e.y)return this.isPointOnSegment=!0,null;if(t.y===this.p.y&&e.y===this.p.y){var n=t.x,i=e.x;return n>i&&(n=e.x,i=t.x),this.p.x>=n&&this.p.x<=i&&(this.isPointOnSegment=!0),null}if(t.y>this.p.y&&e.y<=this.p.y||e.y>this.p.y&&t.y<=this.p.y){var r=t.x-this.p.x,s=t.y-this.p.y,o=e.x-this.p.x,a=e.y-this.p.y,u=ue.signOfDet2x2(r,s,o,a);if(0===u)return this.isPointOnSegment=!0,null;s>a&&(u=-u),u>0&&this.crossingCount++}},isPointInPolygon:function(){return this.getLocation()!==L.EXTERIOR},getLocation:function(){return this.isPointOnSegment?L.BOUNDARY:this.crossingCount%2===1?L.INTERIOR:L.EXTERIOR},isOnSegment:function(){return this.isPointOnSegment},interfaces_:function(){return[]},getClass:function(){return le}}),le.locatePointInRing=function(){if(arguments[0]instanceof g&&R(arguments[1],D)){for(var t=arguments[0],e=arguments[1],n=new le(t),i=new g,r=new g,s=1;s<e.size();s++)if(e.getCoordinate(s,i),e.getCoordinate(s-1,r),n.countSegment(i,r),n.isOnSegment())return n.getLocation();return n.getLocation()}if(arguments[0]instanceof g&&arguments[1]instanceof Array){for(var o=arguments[0],a=arguments[1],n=new le(o),s=1;s<a.length;s++){var i=a[s],r=a[s-1];if(n.countSegment(i,r),n.isOnSegment())return n.getLocation()}return n.getLocation()}},e(he.prototype,{interfaces_:function(){return[]},getClass:function(){return he}}),he.orientationIndex=function(t,e,n){return M.orientationIndex(t,e,n)},he.signedArea=function(){if(arguments[0]instanceof Array){var t=arguments[0];if(t.length<3)return 0;for(var e=0,n=t[0].x,i=1;i<t.length-1;i++){var r=t[i].x-n,s=t[i+1].y,o=t[i-1].y;e+=r*(o-s)}return e/2}if(R(arguments[0],D)){var a=arguments[0],u=a.size();if(3>u)return 0;var l=new g,h=new g,c=new g;a.getCoordinate(0,h),a.getCoordinate(1,c);var n=h.x;c.x-=n;for(var e=0,i=1;u-1>i;i++)l.y=h.y,h.x=c.x,h.y=c.y,a.getCoordinate(i+1,c),c.x-=n,e+=h.x*(l.y-c.y);return e/2}},he.distanceLineLine=function(t,e,n,i){if(t.equals(e))return he.distancePointLine(t,n,i);if(n.equals(i))return he.distancePointLine(i,t,e);var r=!1;if(C.intersects(t,e,n,i)){var s=(e.x-t.x)*(i.y-n.y)-(e.y-t.y)*(i.x-n.x);if(0===s)r=!0;else{var o=(t.y-n.y)*(i.x-n.x)-(t.x-n.x)*(i.y-n.y),a=(t.y-n.y)*(e.x-t.x)-(t.x-n.x)*(e.y-t.y),u=a/s,l=o/s;(0>l||l>1||0>u||u>1)&&(r=!0)}}else r=!0;return r?T.min(he.distancePointLine(t,n,i),he.distancePointLine(e,n,i),he.distancePointLine(n,t,e),he.distancePointLine(i,t,e)):0},he.isPointInRing=function(t,e){return he.locatePointInRing(t,e)!==L.EXTERIOR},he.computeLength=function(t){var e=t.size();if(1>=e)return 0;var n=0,i=new g;t.getCoordinate(0,i);for(var r=i.x,s=i.y,o=1;e>o;o++){t.getCoordinate(o,i);var a=i.x,u=i.y,l=a-r,h=u-s;n+=Math.sqrt(l*l+h*h),r=a,s=u}return n},he.isCCW=function(t){var e=t.length-1;if(3>e)throw new i("Ring has fewer than 4 points, so orientation cannot be determined");for(var n=t[0],r=0,s=1;e>=s;s++){var o=t[s];o.y>n.y&&(n=o,r=s)}var a=r;do a-=1,0>a&&(a=e);while(t[a].equals2D(n)&&a!==r);var u=r;do u=(u+1)%e;while(t[u].equals2D(n)&&u!==r);var l=t[a],h=t[u];if(l.equals2D(n)||h.equals2D(n)||l.equals2D(h))return!1;var c=he.computeOrientation(l,n,h),f=!1;return f=0===c?l.x>h.x:c>0},he.locatePointInRing=function(t,e){return le.locatePointInRing(t,e)},he.distancePointLinePerpendicular=function(t,e,n){var i=(n.x-e.x)*(n.x-e.x)+(n.y-e.y)*(n.y-e.y),r=((e.y-t.y)*(n.x-e.x)-(e.x-t.x)*(n.y-e.y))/i;return Math.abs(r)*Math.sqrt(i)},he.computeOrientation=function(t,e,n){return he.orientationIndex(t,e,n)},he.distancePointLine=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];if(0===e.length)throw new i("Line array must contain at least one vertex");for(var n=t.distance(e[0]),r=0;r<e.length-1;r++){var s=he.distancePointLine(t,e[r],e[r+1]);n>s&&(n=s)}return n}if(3===arguments.length){var o=arguments[0],a=arguments[1],u=arguments[2];if(a.x===u.x&&a.y===u.y)return o.distance(a);var l=(u.x-a.x)*(u.x-a.x)+(u.y-a.y)*(u.y-a.y),h=((o.x-a.x)*(u.x-a.x)+(o.y-a.y)*(u.y-a.y))/l;if(0>=h)return o.distance(a);if(h>=1)return o.distance(u);var c=((a.y-o.y)*(u.x-a.x)-(a.x-o.x)*(u.y-a.y))/l;return Math.abs(c)*Math.sqrt(l)}},he.isOnLine=function(t,e){for(var n=new ae,i=1;i<e.length;i++){var r=e[i-1],s=e[i];if(n.computeIntersection(t,r,s),n.hasIntersection())return!0}return!1},he.CLOCKWISE=-1,he.RIGHT=he.CLOCKWISE,he.COUNTERCLOCKWISE=1,he.LEFT=he.COUNTERCLOCKWISE,he.COLLINEAR=0,he.STRAIGHT=he.COLLINEAR,e(ce.prototype,{minX:function(){return Math.min(this.p0.x,this.p1.x)},orientationIndex:function(){if(arguments[0]instanceof ce){var t=arguments[0],e=he.orientationIndex(this.p0,this.p1,t.p0),n=he.orientationIndex(this.p0,this.p1,t.p1);return e>=0&&n>=0?Math.max(e,n):0>=e&&0>=n?Math.max(e,n):0}if(arguments[0]instanceof g){var i=arguments[0];return he.orientationIndex(this.p0,this.p1,i)}},toGeometry:function(t){return t.createLineString([this.p0,this.p1])},isVertical:function(){return this.p0.x===this.p1.x},equals:function(t){if(!(t instanceof ce))return!1;var e=t;return this.p0.equals(e.p0)&&this.p1.equals(e.p1)},intersection:function(t){var e=new ae;return e.computeIntersection(this.p0,this.p1,t.p0,t.p1),e.hasIntersection()?e.getIntersection(0):null},project:function(){if(arguments[0]instanceof g){var t=arguments[0];if(t.equals(this.p0)||t.equals(this.p1))return new g(t);var e=this.projectionFactor(t),n=new g;return n.x=this.p0.x+e*(this.p1.x-this.p0.x),n.y=this.p0.y+e*(this.p1.y-this.p0.y),n}if(arguments[0]instanceof ce){var i=arguments[0],r=this.projectionFactor(i.p0),s=this.projectionFactor(i.p1);if(r>=1&&s>=1)return null;if(0>=r&&0>=s)return null;var o=this.project(i.p0);0>r&&(o=this.p0),r>1&&(o=this.p1);var a=this.project(i.p1);return 0>s&&(a=this.p0),s>1&&(a=this.p1),new ce(o,a)}},normalize:function(){this.p1.compareTo(this.p0)<0&&this.reverse()},angle:function(){return Math.atan2(this.p1.y-this.p0.y,this.p1.x-this.p0.x)},getCoordinate:function(t){return 0===t?this.p0:this.p1},distancePerpendicular:function(t){return he.distancePointLinePerpendicular(t,this.p0,this.p1)},minY:function(){return Math.min(this.p0.y,this.p1.y)},midPoint:function(){return ce.midPoint(this.p0,this.p1)},projectionFactor:function(t){if(t.equals(this.p0))return 0;if(t.equals(this.p1))return 1;var e=this.p1.x-this.p0.x,n=this.p1.y-this.p0.y,i=e*e+n*n;if(0>=i)return r.NaN;var s=((t.x-this.p0.x)*e+(t.y-this.p0.y)*n)/i;return s},closestPoints:function(t){var e=this.intersection(t);if(null!==e)return[e,e];var n=new Array(2).fill(null),i=r.MAX_VALUE,s=null,o=this.closestPoint(t.p0);i=o.distance(t.p0),n[0]=o,n[1]=t.p0;var a=this.closestPoint(t.p1);s=a.distance(t.p1),i>s&&(i=s,n[0]=a,n[1]=t.p1);var u=t.closestPoint(this.p0);s=u.distance(this.p0),i>s&&(i=s,n[0]=this.p0,n[1]=u);var l=t.closestPoint(this.p1);return s=l.distance(this.p1),i>s&&(i=s,n[0]=this.p1,n[1]=l),n},closestPoint:function(t){var e=this.projectionFactor(t);if(e>0&&1>e)return this.project(t);var n=this.p0.distance(t),i=this.p1.distance(t);return i>n?this.p0:this.p1},maxX:function(){return Math.max(this.p0.x,this.p1.x)},getLength:function(){return this.p0.distance(this.p1)},compareTo:function(t){var e=t,n=this.p0.compareTo(e.p0);return 0!==n?n:this.p1.compareTo(e.p1)},reverse:function(){var t=this.p0;this.p0=this.p1,this.p1=t},equalsTopo:function(t){return this.p0.equals(t.p0)&&this.p1.equals(t.p1)||this.p0.equals(t.p1)&&this.p1.equals(t.p0)},lineIntersection:function(t){try{var e=F.intersection(this.p0,this.p1,t.p0,t.p1);return e}catch(t){if(!(t instanceof w))throw t}finally{}return null},maxY:function(){return Math.max(this.p0.y,this.p1.y)},pointAlongOffset:function(t,e){var n=this.p0.x+t*(this.p1.x-this.p0.x),i=this.p0.y+t*(this.p1.y-this.p0.y),r=this.p1.x-this.p0.x,s=this.p1.y-this.p0.y,o=Math.sqrt(r*r+s*s),a=0,u=0;if(0!==e){if(0>=o)throw new IllegalStateException("Cannot compute offset from zero-length line segment");a=e*r/o,u=e*s/o}var l=n-u,h=i+a,c=new g(l,h);return c},setCoordinates:function(){if(1===arguments.length){var t=arguments[0];this.setCoordinates(t.p0,t.p1)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this.p0.x=e.x,this.p0.y=e.y,this.p1.x=n.x,this.p1.y=n.y}},segmentFraction:function(t){var e=this.projectionFactor(t);return 0>e?e=0:(e>1||r.isNaN(e))&&(e=1),e},toString:function(){return"LINESTRING( "+this.p0.x+" "+this.p0.y+", "+this.p1.x+" "+this.p1.y+")"},isHorizontal:function(){return this.p0.y===this.p1.y},distance:function(){if(arguments[0]instanceof ce){var t=arguments[0];return he.distanceLineLine(this.p0,this.p1,t.p0,t.p1)}if(arguments[0]instanceof g){var e=arguments[0];return he.distancePointLine(e,this.p0,this.p1)}},pointAlong:function(t){var e=new g;return e.x=this.p0.x+t*(this.p1.x-this.p0.x),e.y=this.p0.y+t*(this.p1.y-this.p0.y),e},hashCode:function(){var t=java.lang.Double.doubleToLongBits(this.p0.x);t^=31*java.lang.Double.doubleToLongBits(this.p0.y);var e=Math.trunc(t)^Math.trunc(t>>32),n=java.lang.Double.doubleToLongBits(this.p1.x);n^=31*java.lang.Double.doubleToLongBits(this.p1.y);var i=Math.trunc(n)^Math.trunc(n>>32);return e^i},interfaces_:function(){return[s,u]},getClass:function(){return ce}}),ce.midPoint=function(t,e){return new g((t.x+e.x)/2,(t.y+e.y)/2)},ce.serialVersionUID=0x2d2172135f411c00,e(fe.prototype,{isIntersects:function(){return!this.isDisjoint()},isCovers:function(){var t=fe.isTrue(this.matrix[L.INTERIOR][L.INTERIOR])||fe.isTrue(this.matrix[L.INTERIOR][L.BOUNDARY])||fe.isTrue(this.matrix[L.BOUNDARY][L.INTERIOR])||fe.isTrue(this.matrix[L.BOUNDARY][L.BOUNDARY]);return t&&this.matrix[L.EXTERIOR][L.INTERIOR]===lt.FALSE&&this.matrix[L.EXTERIOR][L.BOUNDARY]===lt.FALSE},isCoveredBy:function(){var t=fe.isTrue(this.matrix[L.INTERIOR][L.INTERIOR])||fe.isTrue(this.matrix[L.INTERIOR][L.BOUNDARY])||fe.isTrue(this.matrix[L.BOUNDARY][L.INTERIOR])||fe.isTrue(this.matrix[L.BOUNDARY][L.BOUNDARY]);return t&&this.matrix[L.INTERIOR][L.EXTERIOR]===lt.FALSE&&this.matrix[L.BOUNDARY][L.EXTERIOR]===lt.FALSE},set:function(){if(1===arguments.length)for(var t=arguments[0],e=0;e<t.length;e++){var n=Math.trunc(e/3),i=e%3;this.matrix[n][i]=lt.toDimensionValue(t.charAt(e))}else if(3===arguments.length){var r=arguments[0],s=arguments[1],o=arguments[2];this.matrix[r][s]=o}},isContains:function(){return fe.isTrue(this.matrix[L.INTERIOR][L.INTERIOR])&&this.matrix[L.EXTERIOR][L.INTERIOR]===lt.FALSE&&this.matrix[L.EXTERIOR][L.BOUNDARY]===lt.FALSE},setAtLeast:function(){if(1===arguments.length)for(var t=arguments[0],e=0;e<t.length;e++){var n=Math.trunc(e/3),i=e%3;this.setAtLeast(n,i,lt.toDimensionValue(t.charAt(e)))}else if(3===arguments.length){var r=arguments[0],s=arguments[1],o=arguments[2];this.matrix[r][s]<o&&(this.matrix[r][s]=o)}},setAtLeastIfValid:function(t,e,n){t>=0&&e>=0&&this.setAtLeast(t,e,n)},isWithin:function(){return fe.isTrue(this.matrix[L.INTERIOR][L.INTERIOR])&&this.matrix[L.INTERIOR][L.EXTERIOR]===lt.FALSE&&this.matrix[L.BOUNDARY][L.EXTERIOR]===lt.FALSE},isTouches:function(t,e){return t>e?this.isTouches(e,t):t===lt.A&&e===lt.A||t===lt.L&&e===lt.L||t===lt.L&&e===lt.A||t===lt.P&&e===lt.A||t===lt.P&&e===lt.L?this.matrix[L.INTERIOR][L.INTERIOR]===lt.FALSE&&(fe.isTrue(this.matrix[L.INTERIOR][L.BOUNDARY])||fe.isTrue(this.matrix[L.BOUNDARY][L.INTERIOR])||fe.isTrue(this.matrix[L.BOUNDARY][L.BOUNDARY])):!1},isOverlaps:function(t,e){return t===lt.P&&e===lt.P||t===lt.A&&e===lt.A?fe.isTrue(this.matrix[L.INTERIOR][L.INTERIOR])&&fe.isTrue(this.matrix[L.INTERIOR][L.EXTERIOR])&&fe.isTrue(this.matrix[L.EXTERIOR][L.INTERIOR]):t===lt.L&&e===lt.L?1===this.matrix[L.INTERIOR][L.INTERIOR]&&fe.isTrue(this.matrix[L.INTERIOR][L.EXTERIOR])&&fe.isTrue(this.matrix[L.EXTERIOR][L.INTERIOR]):!1},isEquals:function(t,e){return t!==e?!1:fe.isTrue(this.matrix[L.INTERIOR][L.INTERIOR])&&this.matrix[L.INTERIOR][L.EXTERIOR]===lt.FALSE&&this.matrix[L.BOUNDARY][L.EXTERIOR]===lt.FALSE&&this.matrix[L.EXTERIOR][L.INTERIOR]===lt.FALSE&&this.matrix[L.EXTERIOR][L.BOUNDARY]===lt.FALSE},toString:function(){for(var t=new P("123456789"),e=0;3>e;e++)for(var n=0;3>n;n++)t.setCharAt(3*e+n,lt.toDimensionSymbol(this.matrix[e][n]));return t.toString()},setAll:function(t){for(var e=0;3>e;e++)for(var n=0;3>n;n++)this.matrix[e][n]=t},get:function(t,e){return this.matrix[t][e]},transpose:function(){var t=this.matrix[1][0];return this.matrix[1][0]=this.matrix[0][1],this.matrix[0][1]=t,t=this.matrix[2][0],this.matrix[2][0]=this.matrix[0][2],this.matrix[0][2]=t,t=this.matrix[2][1],this.matrix[2][1]=this.matrix[1][2],this.matrix[1][2]=t,this},matches:function(t){if(9!==t.length)throw new i("Should be length 9: "+t);for(var e=0;3>e;e++)for(var n=0;3>n;n++)if(!fe.matches(this.matrix[e][n],t.charAt(3*e+n)))return!1;return!0},add:function(t){for(var e=0;3>e;e++)for(var n=0;3>n;n++)this.setAtLeast(e,n,t.get(e,n))},isDisjoint:function(){return this.matrix[L.INTERIOR][L.INTERIOR]===lt.FALSE&&this.matrix[L.INTERIOR][L.BOUNDARY]===lt.FALSE&&this.matrix[L.BOUNDARY][L.INTERIOR]===lt.FALSE&&this.matrix[L.BOUNDARY][L.BOUNDARY]===lt.FALSE},isCrosses:function(t,e){return t===lt.P&&e===lt.L||t===lt.P&&e===lt.A||t===lt.L&&e===lt.A?fe.isTrue(this.matrix[L.INTERIOR][L.INTERIOR])&&fe.isTrue(this.matrix[L.INTERIOR][L.EXTERIOR]):t===lt.L&&e===lt.P||t===lt.A&&e===lt.P||t===lt.A&&e===lt.L?fe.isTrue(this.matrix[L.INTERIOR][L.INTERIOR])&&fe.isTrue(this.matrix[L.EXTERIOR][L.INTERIOR]):t===lt.L&&e===lt.L?0===this.matrix[L.INTERIOR][L.INTERIOR]:!1},interfaces_:function(){return[o]},getClass:function(){return fe}}),fe.matches=function(){if(Number.isInteger(arguments[0])&&"string"==typeof arguments[1]){var t=arguments[0],e=arguments[1];return e===lt.SYM_DONTCARE?!0:e===lt.SYM_TRUE&&(t>=0||t===lt.TRUE)?!0:e===lt.SYM_FALSE&&t===lt.FALSE?!0:e===lt.SYM_P&&t===lt.P?!0:e===lt.SYM_L&&t===lt.L?!0:e===lt.SYM_A&&t===lt.A}if("string"==typeof arguments[0]&&"string"==typeof arguments[1]){var n=arguments[0],i=arguments[1],r=new fe(n);return r.matches(i)}},fe.isTrue=function(t){return t>=0||t===lt.TRUE};var lo=Object.freeze({Coordinate:g,CoordinateList:N,Envelope:C,LineSegment:ce,GeometryFactory:ie,Geometry:B,Point:Lt,LineString:St,LinearRing:bt,Polygon:Tt,GeometryCollection:ft,MultiPoint:Pt,MultiLineString:gt,MultiPolygon:Ot,Dimension:lt,IntersectionMatrix:fe});e(ge.prototype,{addPoint:function(t){this.ptCount+=1,this.ptCentSum.x+=t.x,this.ptCentSum.y+=t.y},setBasePoint:function(t){null===this.areaBasePt&&(this.areaBasePt=t)},addLineSegments:function(t){for(var e=0,n=0;n<t.length-1;n++){var i=t[n].distance(t[n+1]);if(0!==i){e+=i;var r=(t[n].x+t[n+1].x)/2;this.lineCentSum.x+=i*r;var s=(t[n].y+t[n+1].y)/2;this.lineCentSum.y+=i*s}}this.totalLength+=e,0===e&&t.length>0&&this.addPoint(t[0])},addHole:function(t){for(var e=he.isCCW(t),n=0;n<t.length-1;n++)this.addTriangle(this.areaBasePt,t[n],t[n+1],e);this.addLineSegments(t)},getCentroid:function(){var t=new g;if(Math.abs(this.areasum2)>0)t.x=this.cg3.x/3/this.areasum2,t.y=this.cg3.y/3/this.areasum2;else if(this.totalLength>0)t.x=this.lineCentSum.x/this.totalLength,t.y=this.lineCentSum.y/this.totalLength;else{if(!(this.ptCount>0))return null;t.x=this.ptCentSum.x/this.ptCount,t.y=this.ptCentSum.y/this.ptCount}return t},addShell:function(t){t.length>0&&this.setBasePoint(t[0]);for(var e=!he.isCCW(t),n=0;n<t.length-1;n++)this.addTriangle(this.areaBasePt,t[n],t[n+1],e);this.addLineSegments(t)},addTriangle:function(t,e,n,i){var r=i?1:-1;ge.centroid3(t,e,n,this.triangleCent3);var s=ge.area2(t,e,n);this.cg3.x+=r*s*this.triangleCent3.x,this.cg3.y+=r*s*this.triangleCent3.y,this.areasum2+=r*s},add:function(){if(arguments[0]instanceof Tt){var t=arguments[0];this.addShell(t.getExteriorRing().getCoordinates());for(var e=0;e<t.getNumInteriorRing();e++)this.addHole(t.getInteriorRingN(e).getCoordinates())}else if(arguments[0]instanceof B){var n=arguments[0];if(n.isEmpty())return null;if(n instanceof Lt)this.addPoint(n.getCoordinate());else if(n instanceof St)this.addLineSegments(n.getCoordinates());else if(n instanceof Tt){var i=n;this.add(i)}else if(n instanceof ft)for(var r=n,e=0;e<r.getNumGeometries();e++)this.add(r.getGeometryN(e))}},interfaces_:function(){return[]},getClass:function(){return ge}}),ge.area2=function(t,e,n){return(e.x-t.x)*(n.y-t.y)-(n.x-t.x)*(e.y-t.y)},ge.centroid3=function(t,e,n,i){return i.x=t.x+e.x+n.x,i.y=t.y+e.y+n.y,null},ge.getCentroid=function(t){var e=new ge(t);return e.getCentroid()},de.prototype=new Error,de.prototype.name="EmptyStackException",pe.prototype=new y,pe.prototype.add=function(t){return this.array_.push(t),!0},pe.prototype.get=function(t){if(0>t||t>=this.size())throw new IndexOutOfBoundsException;return this.array_[t]},pe.prototype.push=function(t){return this.array_.push(t),t},pe.prototype.pop=function(t){if(0===this.array_.length)throw new de;return this.array_.pop()},pe.prototype.peek=function(){if(0===this.array_.length)throw new de;return this.array_[this.array_.length-1]},pe.prototype.empty=function(){return 0===this.array_.length},pe.prototype.isEmpty=function(){return this.empty()},pe.prototype.search=function(t){return this.array_.indexOf(t)},pe.prototype.size=function(){return this.array_.length},pe.prototype.toArray=function(){for(var t=[],e=0,n=this.array_.length;n>e;e++)t.push(this.array_[e]);return t},e(ve.prototype,{filter:function(t){this.treeSet.contains(t)||(this.list.add(t),this.treeSet.add(t))},getCoordinates:function(){var t=new Array(this.list.size()).fill(null);return this.list.toArray(t)},interfaces_:function(){return[z]},getClass:function(){return ve}}),ve.filterCoordinates=function(t){for(var e=new ve,n=0;n<t.length;n++)e.filter(t[n]);return e.getCoordinates()},e(me.prototype,{preSort:function(t){for(var e=null,n=1;n<t.length;n++)(t[n].y<t[0].y||t[n].y===t[0].y&&t[n].x<t[0].x)&&(e=t[0],t[0]=t[n],t[n]=e);return ut.sort(t,1,t.length,new ye(t[0])),t},computeOctRing:function(t){var e=this.computeOctPts(t),n=new N;return n.add(e,!1),n.size()<3?null:(n.closeRing(),n.toCoordinateArray())},lineOrPolygon:function(t){if(t=this.cleanRing(t),3===t.length)return this.geomFactory.createLineString([t[0],t[1]]);var e=this.geomFactory.createLinearRing(t);return this.geomFactory.createPolygon(e,null)},cleanRing:function(t){f.equals(t[0],t[t.length-1]);for(var e=new I,n=null,i=0;i<=t.length-2;i++){var r=t[i],s=t[i+1];r.equals(s)||null!==n&&this.isBetween(n,r,s)||(e.add(r),n=r)}e.add(t[t.length-1]);var o=new Array(e.size()).fill(null);return e.toArray(o)},isBetween:function(t,e,n){if(0!==he.computeOrientation(t,e,n))return!1;if(t.x!==n.x){if(t.x<=e.x&&e.x<=n.x)return!0;if(n.x<=e.x&&e.x<=t.x)return!0}if(t.y!==n.y){if(t.y<=e.y&&e.y<=n.y)return!0;if(n.y<=e.y&&e.y<=t.y)return!0}return!1},reduce:function(t){var e=this.computeOctRing(t);if(null===e)return t;for(var n=new at,i=0;i<e.length;i++)n.add(e[i]);for(var i=0;i<t.length;i++)he.isPointInRing(t[i],e)||n.add(t[i]);var r=H.toCoordinateArray(n);return r.length<3?this.padArray3(r):r},getConvexHull:function(){if(0===this.inputPts.length)return this.geomFactory.createGeometryCollection(null);if(1===this.inputPts.length)return this.geomFactory.createPoint(this.inputPts[0]);if(2===this.inputPts.length)return this.geomFactory.createLineString(this.inputPts);var t=this.inputPts;this.inputPts.length>50&&(t=this.reduce(this.inputPts));var e=this.preSort(t),n=this.grahamScan(e),i=this.toCoordinateArray(n);return this.lineOrPolygon(i)},padArray3:function(t){for(var e=new Array(3).fill(null),n=0;n<e.length;n++)n<t.length?e[n]=t[n]:e[n]=t[0];return e},computeOctPts:function(t){for(var e=new Array(8).fill(null),n=0;n<e.length;n++)e[n]=t[0];for(var i=1;i<t.length;i++)t[i].x<e[0].x&&(e[0]=t[i]),t[i].x-t[i].y<e[1].x-e[1].y&&(e[1]=t[i]),t[i].y>e[2].y&&(e[2]=t[i]),t[i].x+t[i].y>e[3].x+e[3].y&&(e[3]=t[i]),t[i].x>e[4].x&&(e[4]=t[i]),t[i].x-t[i].y>e[5].x-e[5].y&&(e[5]=t[i]),t[i].y<e[6].y&&(e[6]=t[i]),t[i].x+t[i].y<e[7].x+e[7].y&&(e[7]=t[i]);return e},toCoordinateArray:function(t){for(var e=new Array(t.size()).fill(null),n=0;n<t.size();n++){var i=t.get(n);e[n]=i}return e},grahamScan:function(t){var e=null,n=new pe;e=n.push(t[0]),e=n.push(t[1]),e=n.push(t[2]);for(var i=3;i<t.length;i++){for(e=n.pop();!n.empty()&&he.computeOrientation(n.peek(),e,t[i])>0;)e=n.pop();e=n.push(e),e=n.push(t[i])}return e=n.push(t[0]),n},interfaces_:function(){return[]},getClass:function(){return me}}),me.extractCoordinates=function(t){var e=new ve;return t.apply(e),e.getCoordinates()},e(ye.prototype,{compare:function(t,e){var n=t,i=e;return ye.polarCompare(this.origin,n,i)},interfaces_:function(){return[a]},getClass:function(){return ye}}),ye.polarCompare=function(t,e,n){var i=e.x-t.x,r=e.y-t.y,s=n.x-t.x,o=n.y-t.y,a=he.computeOrientation(t,e,n);
	if(a===he.COUNTERCLOCKWISE)return 1;if(a===he.CLOCKWISE)return-1;var u=i*i+r*r,l=s*s+o*o;return l>u?-1:u>l?1:0},me.RadialComparator=ye,e(xe.prototype,{transformPoint:function(t,e){return this.factory.createPoint(this.transformCoordinates(t.getCoordinateSequence(),t))},transformPolygon:function(t,e){var n=!0,i=this.transformLinearRing(t.getExteriorRing(),t);null!==i&&i instanceof bt&&!i.isEmpty()||(n=!1);for(var r=new I,s=0;s<t.getNumInteriorRing();s++){var o=this.transformLinearRing(t.getInteriorRingN(s),t);null===o||o.isEmpty()||(o instanceof bt||(n=!1),r.add(o))}if(n)return this.factory.createPolygon(i,r.toArray([]));var a=new I;return null!==i&&a.add(i),a.addAll(r),this.factory.buildGeometry(a)},createCoordinateSequence:function(t){return this.factory.getCoordinateSequenceFactory().create(t)},getInputGeometry:function(){return this.inputGeom},transformMultiLineString:function(t,e){for(var n=new I,i=0;i<t.getNumGeometries();i++){var r=this.transformLineString(t.getGeometryN(i),t);null!==r&&(r.isEmpty()||n.add(r))}return this.factory.buildGeometry(n)},transformCoordinates:function(t,e){return this.copy(t)},transformLineString:function(t,e){return this.factory.createLineString(this.transformCoordinates(t.getCoordinateSequence(),t))},transformMultiPoint:function(t,e){for(var n=new I,i=0;i<t.getNumGeometries();i++){var r=this.transformPoint(t.getGeometryN(i),t);null!==r&&(r.isEmpty()||n.add(r))}return this.factory.buildGeometry(n)},transformMultiPolygon:function(t,e){for(var n=new I,i=0;i<t.getNumGeometries();i++){var r=this.transformPolygon(t.getGeometryN(i),t);null!==r&&(r.isEmpty()||n.add(r))}return this.factory.buildGeometry(n)},copy:function(t){return t.copy()},transformGeometryCollection:function(t,e){for(var n=new I,i=0;i<t.getNumGeometries();i++){var r=this.transform(t.getGeometryN(i));null!==r&&(this.pruneEmptyGeometry&&r.isEmpty()||n.add(r))}return this.preserveGeometryCollectionType?this.factory.createGeometryCollection(ie.toGeometryArray(n)):this.factory.buildGeometry(n)},transform:function(t){if(this.inputGeom=t,this.factory=t.getFactory(),t instanceof Lt)return this.transformPoint(t,null);if(t instanceof Pt)return this.transformMultiPoint(t,null);if(t instanceof bt)return this.transformLinearRing(t,null);if(t instanceof St)return this.transformLineString(t,null);if(t instanceof gt)return this.transformMultiLineString(t,null);if(t instanceof Tt)return this.transformPolygon(t,null);if(t instanceof Ot)return this.transformMultiPolygon(t,null);if(t instanceof ft)return this.transformGeometryCollection(t,null);throw new i("Unknown Geometry subtype: "+t.getClass().getName())},transformLinearRing:function(t,e){var n=this.transformCoordinates(t.getCoordinateSequence(),t);if(null===n)return this.factory.createLinearRing(null);var i=n.size();return i>0&&4>i&&!this.preserveType?this.factory.createLineString(n):this.factory.createLinearRing(n)},interfaces_:function(){return[]},getClass:function(){return xe}}),e(Ee.prototype,{snapVertices:function(t,e){for(var n=this._isClosed?t.size()-1:t.size(),i=0;n>i;i++){var r=t.get(i),s=this.findSnapForVertex(r,e);null!==s&&(t.set(i,new g(s)),0===i&&this._isClosed&&t.set(t.size()-1,new g(s)))}},findSnapForVertex:function(t,e){for(var n=0;n<e.length;n++){if(t.equals2D(e[n]))return null;if(t.distance(e[n])<this.snapTolerance)return e[n]}return null},snapTo:function(t){var e=new N(this.srcPts);this.snapVertices(e,t),this.snapSegments(e,t);var n=e.toCoordinateArray();return n},snapSegments:function(t,e){if(0===e.length)return null;var n=e.length;e[0].equals2D(e[e.length-1])&&(n=e.length-1);for(var i=0;n>i;i++){var r=e[i],s=this.findSegmentIndexToSnap(r,t);s>=0&&t.add(s+1,new g(r),!1)}},findSegmentIndexToSnap:function(t,e){for(var n=r.MAX_VALUE,i=-1,s=0;s<e.size()-1;s++){if(this.seg.p0=e.get(s),this.seg.p1=e.get(s+1),this.seg.p0.equals2D(t)||this.seg.p1.equals2D(t)){if(this.allowSnappingToSourceVertices)continue;return-1}var o=this.seg.distance(t);o<this.snapTolerance&&n>o&&(n=o,i=s)}return i},setAllowSnappingToSourceVertices:function(t){this.allowSnappingToSourceVertices=t},interfaces_:function(){return[]},getClass:function(){return Ee}}),Ee.isClosed=function(t){return t.length<=1?!1:t[0].equals2D(t[t.length-1])},e(Ie.prototype,{snapTo:function(t,e){var n=this.extractTargetCoordinates(t),i=new Ne(e,n);return i.transform(this.srcGeom)},snapToSelf:function(t,e){var n=this.extractTargetCoordinates(this.srcGeom),i=new Ne(t,n,!0),r=i.transform(this.srcGeom),s=r;return e&&R(s,Rt)&&(s=r.buffer(0)),s},computeSnapTolerance:function(t){var e=this.computeMinimumSegmentLength(t),n=e/10;return n},extractTargetCoordinates:function(t){for(var e=new at,n=t.getCoordinates(),i=0;i<n.length;i++)e.add(n[i]);return e.toArray(new Array(0).fill(null))},computeMinimumSegmentLength:function(t){for(var e=r.MAX_VALUE,n=0;n<t.length-1;n++){var i=t[n].distance(t[n+1]);e>i&&(e=i)}return e},interfaces_:function(){return[]},getClass:function(){return Ie}}),Ie.snap=function(t,e,n){var i=new Array(2).fill(null),r=new Ie(t);i[0]=r.snapTo(e,n);var s=new Ie(e);return i[1]=s.snapTo(i[0],n),i},Ie.computeOverlaySnapTolerance=function(){if(1===arguments.length){var t=arguments[0],e=Ie.computeSizeBasedSnapTolerance(t),n=t.getPrecisionModel();if(n.getType()===ee.FIXED){var i=1/n.getScale()*2/1.415;i>e&&(e=i)}return e}if(2===arguments.length){var r=arguments[0],s=arguments[1];return Math.min(Ie.computeOverlaySnapTolerance(r),Ie.computeOverlaySnapTolerance(s))}},Ie.computeSizeBasedSnapTolerance=function(t){var e=t.getEnvelopeInternal(),n=Math.min(e.getHeight(),e.getWidth()),i=n*Ie.SNAP_PRECISION_FACTOR;return i},Ie.snapToSelf=function(t,e,n){var i=new Ie(t);return i.snapToSelf(e,n)},Ie.SNAP_PRECISION_FACTOR=1e-9,h(Ne,xe),e(Ne.prototype,{snapLine:function(t,e){var n=new Ee(t,this.snapTolerance);return n.setAllowSnappingToSourceVertices(this.isSelfSnap),n.snapTo(e)},transformCoordinates:function(t,e){var n=t.toCoordinateArray(),i=this.snapLine(n,this.snapPts);return this.factory.getCoordinateSequenceFactory().create(i)},interfaces_:function(){return[]},getClass:function(){return Ne}}),e(Ce.prototype,{getCommon:function(){return r.longBitsToDouble(this.commonBits)},add:function(t){var e=r.doubleToLongBits(t);if(this.isFirst)return this.commonBits=e,this.commonSignExp=Ce.signExpBits(this.commonBits),this.isFirst=!1,null;var n=Ce.signExpBits(e);return n!==this.commonSignExp?(this.commonBits=0,null):(this.commonMantissaBitsCount=Ce.numCommonMostSigMantissaBits(this.commonBits,e),void(this.commonBits=Ce.zeroLowerBits(this.commonBits,64-(12+this.commonMantissaBitsCount))))},toString:function(){if(1===arguments.length){var t=arguments[0],e=r.longBitsToDouble(t),n=Long.toBinaryString(t),i="0000000000000000000000000000000000000000000000000000000000000000"+n,s=i.substring(i.length-64),o=s.substring(0,1)+"  "+s.substring(1,12)+"(exp) "+s.substring(12)+" [ "+e+" ]";return o}},interfaces_:function(){return[]},getClass:function(){return Ce}}),Ce.getBit=function(t,e){var n=1<<e;return 0!==(t&n)?1:0},Ce.signExpBits=function(t){return t>>52},Ce.zeroLowerBits=function(t,e){var n=(1<<e)-1,i=~n,r=t&i;return r},Ce.numCommonMostSigMantissaBits=function(t,e){for(var n=0,i=52;i>=0;i--){if(Ce.getBit(t,i)!==Ce.getBit(e,i))return n;n++}return 52},e(Se.prototype,{addCommonBits:function(t){var e=new Le(this.commonCoord);t.apply(e),t.geometryChanged()},removeCommonBits:function(t){if(0===this.commonCoord.x&&0===this.commonCoord.y)return t;var e=new g(this.commonCoord);e.x=-e.x,e.y=-e.y;var n=new Le(e);return t.apply(n),t.geometryChanged(),t},getCommonCoordinate:function(){return this.commonCoord},add:function(t){t.apply(this.ccFilter),this.commonCoord=this.ccFilter.getCommonCoordinate()},interfaces_:function(){return[]},getClass:function(){return Se}}),e(we.prototype,{filter:function(t){this.commonBitsX.add(t.x),this.commonBitsY.add(t.y)},getCommonCoordinate:function(){return new g(this.commonBitsX.getCommon(),this.commonBitsY.getCommon())},interfaces_:function(){return[z]},getClass:function(){return we}}),e(Le.prototype,{filter:function(t,e){var n=t.getOrdinate(e,0)+this.trans.x,i=t.getOrdinate(e,1)+this.trans.y;t.setOrdinate(e,0,n),t.setOrdinate(e,1,i)},isDone:function(){return!1},isGeometryChanged:function(){return!0},interfaces_:function(){return[ct]},getClass:function(){return Le}}),Se.CommonCoordinateFilter=we,Se.Translater=Le,e(Re.prototype,{next:function(){if(this.atStart)return this.atStart=!1,Re.isAtomic(this.parent)&&this.index++,this.parent;if(null!==this.subcollectionIterator){if(this.subcollectionIterator.hasNext())return this.subcollectionIterator.next();this.subcollectionIterator=null}if(this.index>=this.max)throw new x;var t=this.parent.getGeometryN(this.index++);return t instanceof ft?(this.subcollectionIterator=new Re(t),this.subcollectionIterator.next()):t},remove:function(){throw new UnsupportedOperationException(this.getClass().getName())},hasNext:function(){if(this.atStart)return!0;if(null!==this.subcollectionIterator){if(this.subcollectionIterator.hasNext())return!0;this.subcollectionIterator=null}return!(this.index>=this.max)},interfaces_:function(){return[p]},getClass:function(){return Re}}),Re.isAtomic=function(t){return!(t instanceof ft)},e(Te.prototype,{locateInternal:function(){if(arguments[0]instanceof g&&arguments[1]instanceof Tt){var t=arguments[0],e=arguments[1];if(e.isEmpty())return L.EXTERIOR;var n=e.getExteriorRing(),i=this.locateInPolygonRing(t,n);if(i===L.EXTERIOR)return L.EXTERIOR;if(i===L.BOUNDARY)return L.BOUNDARY;for(var r=0;r<e.getNumInteriorRing();r++){var s=e.getInteriorRingN(r),o=this.locateInPolygonRing(t,s);if(o===L.INTERIOR)return L.EXTERIOR;if(o===L.BOUNDARY)return L.BOUNDARY}return L.INTERIOR}if(arguments[0]instanceof g&&arguments[1]instanceof St){var a=arguments[0],u=arguments[1];if(!u.getEnvelopeInternal().intersects(a))return L.EXTERIOR;var l=u.getCoordinates();return u.isClosed()||!a.equals(l[0])&&!a.equals(l[l.length-1])?he.isOnLine(a,l)?L.INTERIOR:L.EXTERIOR:L.BOUNDARY}if(arguments[0]instanceof g&&arguments[1]instanceof Lt){var h=arguments[0],c=arguments[1],f=c.getCoordinate();return f.equals2D(h)?L.INTERIOR:L.EXTERIOR}},locateInPolygonRing:function(t,e){return e.getEnvelopeInternal().intersects(t)?he.locatePointInRing(t,e.getCoordinates()):L.EXTERIOR},intersects:function(t,e){return this.locate(t,e)!==L.EXTERIOR},updateLocationInfo:function(t){t===L.INTERIOR&&(this.isIn=!0),t===L.BOUNDARY&&this.numBoundaries++},computeLocation:function(t,e){if(e instanceof Lt&&this.updateLocationInfo(this.locateInternal(t,e)),e instanceof St)this.updateLocationInfo(this.locateInternal(t,e));else if(e instanceof Tt)this.updateLocationInfo(this.locateInternal(t,e));else if(e instanceof gt)for(var n=e,i=0;i<n.getNumGeometries();i++){var r=n.getGeometryN(i);this.updateLocationInfo(this.locateInternal(t,r))}else if(e instanceof Ot)for(var s=e,i=0;i<s.getNumGeometries();i++){var o=s.getGeometryN(i);this.updateLocationInfo(this.locateInternal(t,o))}else if(e instanceof ft)for(var a=new Re(e);a.hasNext();){var u=a.next();u!==e&&this.computeLocation(t,u)}},locate:function(t,e){return e.isEmpty()?L.EXTERIOR:e instanceof St?this.locateInternal(t,e):e instanceof Tt?this.locateInternal(t,e):(this.isIn=!1,this.numBoundaries=0,this.computeLocation(t,e),this.boundaryRule.isInBoundary(this.numBoundaries)?L.BOUNDARY:this.numBoundaries>0||this.isIn?L.INTERIOR:L.EXTERIOR)},interfaces_:function(){return[]},getClass:function(){return Te}}),e(Pe.prototype,{interfaces_:function(){return[]},getClass:function(){return Pe}}),Pe.octant=function(){if("number"==typeof arguments[0]&&"number"==typeof arguments[1]){var t=arguments[0],e=arguments[1];if(0===t&&0===e)throw new i("Cannot compute the octant for point ( "+t+", "+e+" )");var n=Math.abs(t),r=Math.abs(e);return t>=0?e>=0?n>=r?0:1:n>=r?7:6:e>=0?n>=r?3:2:n>=r?4:5}if(arguments[0]instanceof g&&arguments[1]instanceof g){var s=arguments[0],o=arguments[1],a=o.x-s.x,u=o.y-s.y;if(0===a&&0===u)throw new i("Cannot compute the octant for two identical points "+s);return Pe.octant(a,u)}},e(be.prototype,{getCoordinates:function(){},size:function(){},getCoordinate:function(t){},isClosed:function(){},setData:function(t){},getData:function(){},interfaces_:function(){return[]},getClass:function(){return be}}),e(Oe.prototype,{getCoordinates:function(){return this.pts},size:function(){return this.pts.length},getCoordinate:function(t){return this.pts[t]},isClosed:function(){return this.pts[0].equals(this.pts[this.pts.length-1])},getSegmentOctant:function(t){return t===this.pts.length-1?-1:Pe.octant(this.getCoordinate(t),this.getCoordinate(t+1))},setData:function(t){this.data=t},getData:function(){return this.data},toString:function(){return se.toLineString(new Gt(this.pts))},interfaces_:function(){return[be]},getClass:function(){return Oe}}),e(_e.prototype,{getBounds:function(){},interfaces_:function(){return[]},getClass:function(){return _e}}),e(Me.prototype,{getItem:function(){return this.item},getBounds:function(){return this.bounds},interfaces_:function(){return[_e,u]},getClass:function(){return Me}}),e(De.prototype,{poll:function(){if(this.isEmpty())return null;var t=this.items.get(1);return this.items.set(1,this.items.get(this._size)),this._size-=1,this.reorder(1),t},size:function(){return this._size},reorder:function(t){for(var e=null,n=this.items.get(t);2*t<=this._size&&(e=2*t,e!==this._size&&this.items.get(e+1).compareTo(this.items.get(e))<0&&e++,this.items.get(e).compareTo(n)<0);t=e)this.items.set(t,this.items.get(e));this.items.set(t,n)},clear:function(){this._size=0,this.items.clear()},isEmpty:function(){return 0===this._size},add:function(t){this.items.add(null),this._size+=1;var e=this._size;for(this.items.set(0,t);t.compareTo(this.items.get(Math.trunc(e/2)))<0;e/=2)this.items.set(e,this.items.get(Math.trunc(e/2)));this.items.set(e,t)},interfaces_:function(){return[]},getClass:function(){return De}}),e(Ae.prototype,{visitItem:function(t){},interfaces_:function(){return[]},getClass:function(){return Ae}}),e(Fe.prototype,{insert:function(t,e){},remove:function(t,e){},query:function(){if(1===arguments.length){arguments[0]}else if(2===arguments.length){arguments[0],arguments[1]}},interfaces_:function(){return[]},getClass:function(){return Fe}}),e(Ge.prototype,{getLevel:function(){return this.level},size:function(){return this.childBoundables.size()},getChildBoundables:function(){return this.childBoundables},addChildBoundable:function(t){f.isTrue(null===this.bounds),this.childBoundables.add(t)},isEmpty:function(){return this.childBoundables.isEmpty()},getBounds:function(){return null===this.bounds&&(this.bounds=this.computeBounds()),this.bounds},interfaces_:function(){return[_e,u]},getClass:function(){return Ge}}),Ge.serialVersionUID=0x5a1e55ec41369800;var ho={reverseOrder:function(){return{compare:function(t,e){return e.compareTo(t)}}},min:function(t){return ho.sort(t),t.get(0)},sort:function(t,e){var n=t.toArray();e?ut.sort(n,e):ut.sort(n);for(var i=t.iterator(),r=0,s=n.length;s>r;r++)i.next(),i.set(n[r])},singletonList:function(t){var e=new I;return e.add(t),e}};e(qe.prototype,{expandToQueue:function(t,e){var n=qe.isComposite(this.boundable1),r=qe.isComposite(this.boundable2);if(n&&r)return qe.area(this.boundable1)>qe.area(this.boundable2)?(this.expand(this.boundable1,this.boundable2,t,e),null):(this.expand(this.boundable2,this.boundable1,t,e),null);if(n)return this.expand(this.boundable1,this.boundable2,t,e),null;if(r)return this.expand(this.boundable2,this.boundable1,t,e),null;throw new i("neither boundable is composite")},isLeaves:function(){return!(qe.isComposite(this.boundable1)||qe.isComposite(this.boundable2))},compareTo:function(t){var e=t;return this._distance<e._distance?-1:this._distance>e._distance?1:0},expand:function(t,e,n,i){for(var r=t.getChildBoundables(),s=r.iterator();s.hasNext();){var o=s.next(),a=new qe(o,e,this.itemDistance);a.getDistance()<i&&n.add(a)}},getBoundable:function(t){return 0===t?this.boundable1:this.boundable2},getDistance:function(){return this._distance},distance:function(){return this.isLeaves()?this.itemDistance.distance(this.boundable1,this.boundable2):this.boundable1.getBounds().distance(this.boundable2.getBounds())},interfaces_:function(){return[s]},getClass:function(){return qe}}),qe.area=function(t){return t.getBounds().getArea()},qe.isComposite=function(t){return t instanceof Ge},e(Be.prototype,{getNodeCapacity:function(){return this.nodeCapacity},lastNode:function(t){return t.get(t.size()-1)},size:function t(){if(0===arguments.length)return this.isEmpty()?0:(this.build(),this.size(this.root));if(1===arguments.length){for(var e=arguments[0],t=0,n=e.getChildBoundables().iterator();n.hasNext();){var i=n.next();i instanceof Ge?t+=this.size(i):i instanceof Me&&(t+=1)}return t}},removeItem:function(t,e){for(var n=null,i=t.getChildBoundables().iterator();i.hasNext();){var r=i.next();r instanceof Me&&r.getItem()===e&&(n=r)}return null!==n?(t.getChildBoundables().remove(n),!0):!1},itemsTree:function(){if(0===arguments.length){this.build();var t=this.itemsTree(this.root);return null===t?new I:t}if(1===arguments.length){for(var e=arguments[0],n=new I,i=e.getChildBoundables().iterator();i.hasNext();){var r=i.next();if(r instanceof Ge){var s=this.itemsTree(r);null!==s&&n.add(s)}else r instanceof Me?n.add(r.getItem()):f.shouldNeverReachHere()}return n.size()<=0?null:n}},insert:function(t,e){f.isTrue(!this.built,"Cannot insert items into an STR packed R-tree after it has been built."),this.itemBoundables.add(new Me(t,e))},boundablesAtLevel:function(){if(1===arguments.length){var t=arguments[0],e=new I;return this.boundablesAtLevel(t,this.root,e),e}if(3===arguments.length){var n=arguments[0],i=arguments[1],r=arguments[2];if(f.isTrue(n>-2),i.getLevel()===n)return r.add(i),null;for(var s=i.getChildBoundables().iterator();s.hasNext();){var o=s.next();o instanceof Ge?this.boundablesAtLevel(n,o,r):(f.isTrue(o instanceof Me),-1===n&&r.add(o))}return null}},query:function(){if(1===arguments.length){var t=arguments[0];this.build();var e=new I;return this.isEmpty()?e:(this.getIntersectsOp().intersects(this.root.getBounds(),t)&&this.query(t,this.root,e),e)}if(2===arguments.length){var n=arguments[0],i=arguments[1];if(this.build(),this.isEmpty())return null;this.getIntersectsOp().intersects(this.root.getBounds(),n)&&this.query(n,this.root,i)}else if(3===arguments.length)if(R(arguments[2],Ae)&&arguments[0]instanceof Object&&arguments[1]instanceof Ge)for(var r=arguments[0],s=arguments[1],o=arguments[2],a=s.getChildBoundables(),u=0;u<a.size();u++){var l=a.get(u);this.getIntersectsOp().intersects(l.getBounds(),r)&&(l instanceof Ge?this.query(r,l,o):l instanceof Me?o.visitItem(l.getItem()):f.shouldNeverReachHere())}else if(R(arguments[2],y)&&arguments[0]instanceof Object&&arguments[1]instanceof Ge)for(var h=arguments[0],c=arguments[1],g=arguments[2],a=c.getChildBoundables(),u=0;u<a.size();u++){var l=a.get(u);this.getIntersectsOp().intersects(l.getBounds(),h)&&(l instanceof Ge?this.query(h,l,g):l instanceof Me?g.add(l.getItem()):f.shouldNeverReachHere())}},build:function(){return this.built?null:(this.root=this.itemBoundables.isEmpty()?this.createNode(0):this.createHigherLevels(this.itemBoundables,-1),this.itemBoundables=null,void(this.built=!0))},getRoot:function(){return this.build(),this.root},remove:function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];return this.build(),this.getIntersectsOp().intersects(this.root.getBounds(),t)?this.remove(t,this.root,e):!1}if(3===arguments.length){var n=arguments[0],i=arguments[1],r=arguments[2],s=this.removeItem(i,r);if(s)return!0;for(var o=null,a=i.getChildBoundables().iterator();a.hasNext();){var u=a.next();if(this.getIntersectsOp().intersects(u.getBounds(),n)&&u instanceof Ge&&(s=this.remove(n,u,r))){o=u;break}}return null!==o&&o.getChildBoundables().isEmpty()&&i.getChildBoundables().remove(o),s}},createHigherLevels:function(t,e){f.isTrue(!t.isEmpty());var n=this.createParentBoundables(t,e+1);return 1===n.size()?n.get(0):this.createHigherLevels(n,e+1)},depth:function(){if(0===arguments.length)return this.isEmpty()?0:(this.build(),this.depth(this.root));if(1===arguments.length){for(var t=arguments[0],e=0,n=t.getChildBoundables().iterator();n.hasNext();){var i=n.next();if(i instanceof Ge){var r=this.depth(i);r>e&&(e=r)}}return e+1}},createParentBoundables:function(t,e){f.isTrue(!t.isEmpty());var n=new I;n.add(this.createNode(e));var i=new I(t);ho.sort(i,this.getComparator());for(var r=i.iterator();r.hasNext();){var s=r.next();this.lastNode(n).getChildBoundables().size()===this.getNodeCapacity()&&n.add(this.createNode(e)),this.lastNode(n).addChildBoundable(s)}return n},isEmpty:function(){return this.built?this.root.isEmpty():this.itemBoundables.isEmpty()},interfaces_:function(){return[u]},getClass:function(){return Be}}),Be.compareDoubles=function(t,e){return t>e?1:e>t?-1:0},Be.IntersectsOp=ze,Be.serialVersionUID=-0x35ef64c82d4c5400,Be.DEFAULT_NODE_CAPACITY=10,e(Ve.prototype,{distance:function(t,e){},interfaces_:function(){return[]},getClass:function(){return Ve}}),h(ke,Be),e(ke.prototype,{createParentBoundablesFromVerticalSlices:function(t,e){f.isTrue(t.length>0);for(var n=new I,i=0;i<t.length;i++)n.addAll(this.createParentBoundablesFromVerticalSlice(t[i],e));return n},createNode:function(t){return new Ye(t)},size:function(){return 0===arguments.length?Be.prototype.size.call(this):Be.prototype.size.apply(this,arguments)},insert:function(){if(2!==arguments.length)return Be.prototype.insert.apply(this,arguments);var t=arguments[0],e=arguments[1];return t.isNull()?null:void Be.prototype.insert.call(this,t,e)},getIntersectsOp:function(){return ke.intersectsOp},verticalSlices:function(t,e){for(var n=Math.trunc(Math.ceil(t.size()/e)),i=new Array(e).fill(null),r=t.iterator(),s=0;e>s;s++){i[s]=new I;for(var o=0;r.hasNext()&&n>o;){var a=r.next();i[s].add(a),o++}}return i},query:function(){if(1===arguments.length){var t=arguments[0];return Be.prototype.query.call(this,t)}if(2===arguments.length){var e=arguments[0],n=arguments[1];Be.prototype.query.call(this,e,n)}else if(3===arguments.length)if(R(arguments[2],Ae)&&arguments[0]instanceof Object&&arguments[1]instanceof Ge){var i=arguments[0],r=arguments[1],s=arguments[2];Be.prototype.query.call(this,i,r,s)}else if(R(arguments[2],y)&&arguments[0]instanceof Object&&arguments[1]instanceof Ge){var o=arguments[0],a=arguments[1],u=arguments[2];Be.prototype.query.call(this,o,a,u)}},getComparator:function(){return ke.yComparator},createParentBoundablesFromVerticalSlice:function(t,e){return Be.prototype.createParentBoundables.call(this,t,e)},remove:function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];return Be.prototype.remove.call(this,t,e)}return Be.prototype.remove.apply(this,arguments)},depth:function(){return 0===arguments.length?Be.prototype.depth.call(this):Be.prototype.depth.apply(this,arguments)},createParentBoundables:function(t,e){f.isTrue(!t.isEmpty());var n=Math.trunc(Math.ceil(t.size()/this.getNodeCapacity())),i=new I(t);ho.sort(i,ke.xComparator);var r=this.verticalSlices(i,Math.trunc(Math.ceil(Math.sqrt(n))));return this.createParentBoundablesFromVerticalSlices(r,e)},nearestNeighbour:function(){if(1===arguments.length){if(R(arguments[0],Ve)){var t=arguments[0],e=new qe(this.getRoot(),this.getRoot(),t);return this.nearestNeighbour(e)}if(arguments[0]instanceof qe){var n=arguments[0];return this.nearestNeighbour(n,r.POSITIVE_INFINITY)}}else if(2===arguments.length){if(arguments[0]instanceof ke&&R(arguments[1],Ve)){var i=arguments[0],s=arguments[1],e=new qe(this.getRoot(),i.getRoot(),s);return this.nearestNeighbour(e)}if(arguments[0]instanceof qe&&"number"==typeof arguments[1]){var o=arguments[0],a=arguments[1],u=a,l=null,h=new De;for(h.add(o);!h.isEmpty()&&u>0;){var c=h.poll(),f=c.getDistance();if(f>=u)break;c.isLeaves()?(u=f,l=c):c.expandToQueue(h,u)}return[l.getBoundable(0).getItem(),l.getBoundable(1).getItem()]}}else if(3===arguments.length){var g=arguments[0],d=arguments[1],p=arguments[2],v=new Me(g,d),e=new qe(this.getRoot(),v,p);return this.nearestNeighbour(e)[0]}},interfaces_:function(){return[Fe,u]},getClass:function(){return ke}}),ke.centreX=function(t){return ke.avg(t.getMinX(),t.getMaxX())},ke.avg=function(t,e){return(t+e)/2},ke.centreY=function(t){return ke.avg(t.getMinY(),t.getMaxY())},h(Ye,Ge),e(Ye.prototype,{computeBounds:function(){for(var t=null,e=this.getChildBoundables().iterator();e.hasNext();){var n=e.next();null===t?t=new C(n.getBounds()):t.expandToInclude(n.getBounds())}return t},interfaces_:function(){return[]},getClass:function(){return Ye}}),ke.STRtreeNode=Ye,ke.serialVersionUID=0x39920f7d5f261e0,ke.xComparator={interfaces_:function(){return[a]},compare:function(t,e){return Be.compareDoubles(ke.centreX(t.getBounds()),ke.centreX(e.getBounds()))}},ke.yComparator={interfaces_:function(){return[a]},compare:function(t,e){return Be.compareDoubles(ke.centreY(t.getBounds()),ke.centreY(e.getBounds()))}},ke.intersectsOp={interfaces_:function(){return[IntersectsOp]},intersects:function(t,e){return t.intersects(e)}},ke.DEFAULT_NODE_CAPACITY=10,e(Ue.prototype,{interfaces_:function(){return[]},getClass:function(){return Ue}}),Ue.relativeSign=function(t,e){return e>t?-1:t>e?1:0},Ue.compare=function(t,e,n){if(e.equals2D(n))return 0;var i=Ue.relativeSign(e.x,n.x),r=Ue.relativeSign(e.y,n.y);switch(t){case 0:return Ue.compareValue(i,r);case 1:return Ue.compareValue(r,i);case 2:return Ue.compareValue(r,-i);case 3:return Ue.compareValue(-i,r);case 4:return Ue.compareValue(-i,-r);case 5:return Ue.compareValue(-r,-i);case 6:return Ue.compareValue(-r,i);case 7:return Ue.compareValue(i,-r)}return f.shouldNeverReachHere("invalid octant value"),0},Ue.compareValue=function(t,e){return 0>t?-1:t>0?1:0>e?-1:e>0?1:0},e(Xe.prototype,{getCoordinate:function(){return this.coord},print:function(t){t.print(this.coord),t.print(" seg # = "+this.segmentIndex)},compareTo:function(t){var e=t;return this.segmentIndex<e.segmentIndex?-1:this.segmentIndex>e.segmentIndex?1:this.coord.equals2D(e.coord)?0:Ue.compare(this.segmentOctant,this.coord,e.coord)},isEndPoint:function(t){return 0!==this.segmentIndex||this._isInterior?this.segmentIndex===t:!0},isInterior:function(){return this._isInterior},interfaces_:function(){return[s]},getClass:function(){return Xe}}),e(He.prototype,{getSplitCoordinates:function(){var t=new N;this.addEndpoints();for(var e=this.iterator(),n=e.next();e.hasNext();){var i=e.next();this.addEdgeCoordinates(n,i,t),n=i}return t.toCoordinateArray()},addCollapsedNodes:function(){var t=new I;this.findCollapsesFromInsertedNodes(t),this.findCollapsesFromExistingVertices(t);for(var e=t.iterator();e.hasNext();){var n=e.next().intValue();this.add(this.edge.getCoordinate(n),n)}},print:function(t){t.println("Intersections:");for(var e=this.iterator();e.hasNext();){var n=e.next();n.print(t)}},findCollapsesFromExistingVertices:function(t){for(var e=0;e<this.edge.size()-2;e++){var n=this.edge.getCoordinate(e),i=(this.edge.getCoordinate(e+1),this.edge.getCoordinate(e+2));n.equals2D(i)&&t.add(new b(e+1))}},addEdgeCoordinates:function(t,e,n){var i=e.segmentIndex-t.segmentIndex+2,r=this.edge.getCoordinate(e.segmentIndex),s=e.isInterior()||!e.coord.equals2D(r);s||i--;n.add(new g(t.coord),!1);for(var o=t.segmentIndex+1;o<=e.segmentIndex;o++)n.add(this.edge.getCoordinate(o));s&&n.add(new g(e.coord))},iterator:function(){return this.nodeMap.values().iterator()},addSplitEdges:function(t){this.addEndpoints(),this.addCollapsedNodes();for(var e=this.iterator(),n=e.next();e.hasNext();){var i=e.next(),r=this.createSplitEdge(n,i);t.add(r),n=i}},findCollapseIndex:function(t,e,n){if(!t.coord.equals2D(e.coord))return!1;var i=e.segmentIndex-t.segmentIndex;return e.isInterior()||i--,1===i?(n[0]=t.segmentIndex+1,!0):!1},findCollapsesFromInsertedNodes:function(t){for(var e=new Array(1).fill(null),n=this.iterator(),i=n.next();n.hasNext();){var r=n.next(),s=this.findCollapseIndex(i,r,e);s&&t.add(new b(e[0])),i=r}},getEdge:function(){return this.edge},addEndpoints:function(){var t=this.edge.size()-1;this.add(this.edge.getCoordinate(0),0),this.add(this.edge.getCoordinate(t),t)},createSplitEdge:function(t,e){var n=e.segmentIndex-t.segmentIndex+2,i=this.edge.getCoordinate(e.segmentIndex),r=e.isInterior()||!e.coord.equals2D(i);r||n--;var s=new Array(n).fill(null),o=0;s[o++]=new g(t.coord);for(var a=t.segmentIndex+1;a<=e.segmentIndex;a++)s[o++]=this.edge.getCoordinate(a);return r&&(s[o]=new g(e.coord)),new Ke(s,this.edge.getData())},add:function(t,e){var n=new Xe(this.edge,t,e,this.edge.getSegmentOctant(e)),i=this.nodeMap.get(n);return null!==i?(f.isTrue(i.coord.equals2D(t),"Found equal nodes with different coordinates"),i):(this.nodeMap.put(n,n),n)},checkSplitEdgesCorrectness:function(t){var e=this.edge.getCoordinates(),n=t.get(0),i=n.getCoordinate(0);if(!i.equals2D(e[0]))throw new l("bad split edge start point at "+i);var r=t.get(t.size()-1),s=r.getCoordinates(),o=s[s.length-1];if(!o.equals2D(e[e.length-1]))throw new l("bad split edge end point at "+o)},interfaces_:function(){return[]},getClass:function(){return He}}),e(We.prototype,{next:function(){return null===this.currNode?(this.currNode=this.nextNode,this.currSegIndex=this.currNode.segmentIndex,this.readNextNode(),this.currNode):null===this.nextNode?null:this.nextNode.segmentIndex===this.currNode.segmentIndex?(this.currNode=this.nextNode,this.currSegIndex=this.currNode.segmentIndex,this.readNextNode(),this.currNode):(this.nextNode.segmentIndex>this.currNode.segmentIndex,null)},remove:function(){throw new UnsupportedOperationException(this.getClass().getName())},hasNext:function(){return null!==this.nextNode},readNextNode:function(){this.nodeIt.hasNext()?this.nextNode=this.nodeIt.next():this.nextNode=null},interfaces_:function(){return[p]},getClass:function(){return We}}),e(je.prototype,{addIntersection:function(t,e){},interfaces_:function(){return[be]},getClass:function(){return je}}),e(Ke.prototype,{getCoordinates:function(){return this.pts},size:function(){return this.pts.length},getCoordinate:function(t){return this.pts[t]},isClosed:function(){return this.pts[0].equals(this.pts[this.pts.length-1])},getSegmentOctant:function(t){return t===this.pts.length-1?-1:this.safeOctant(this.getCoordinate(t),this.getCoordinate(t+1))},setData:function(t){this.data=t},safeOctant:function(t,e){return t.equals2D(e)?0:Pe.octant(t,e)},getData:function(){return this.data},addIntersection:function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];this.addIntersectionNode(t,e)}else if(4===arguments.length){var n=arguments[0],i=arguments[1],r=(arguments[2],arguments[3]),s=new g(n.getIntersection(r));this.addIntersection(s,i)}},toString:function(){return se.toLineString(new Gt(this.pts))},getNodeList:function(){return this.nodeList},addIntersectionNode:function(t,e){var n=e,i=n+1;if(i<this.pts.length){var r=this.pts[i];t.equals2D(r)&&(n=i)}var s=this.nodeList.add(t,n);return s},addIntersections:function(t,e,n){for(var i=0;i<t.getIntersectionNum();i++)this.addIntersection(t,e,n,i)},interfaces_:function(){return[je]},getClass:function(){return Ke}}),Ke.getNodedSubstrings=function(){if(1===arguments.length){var t=arguments[0],e=new I;return Ke.getNodedSubstrings(t,e),e}if(2===arguments.length)for(var n=arguments[0],i=arguments[1],r=n.iterator();r.hasNext();){var s=r.next();s.getNodeList().addSplitEdges(i)}},e(Ze.prototype,{overlap:function(){if(2===arguments.length){arguments[0],arguments[1]}else if(4===arguments.length){var t=arguments[0],e=arguments[1],n=arguments[2],i=arguments[3];t.getLineSegment(e,this.overlapSeg1),n.getLineSegment(i,this.overlapSeg2),this.overlap(this.overlapSeg1,this.overlapSeg2)}},interfaces_:function(){return[]},getClass:function(){return Ze}}),e(Qe.prototype,{getLineSegment:function(t,e){e.p0=this.pts[t],e.p1=this.pts[t+1]},computeSelect:function(t,e,n,i){var r=this.pts[e],s=this.pts[n];if(i.tempEnv1.init(r,s),n-e===1)return i.select(this,e),null;if(!t.intersects(i.tempEnv1))return null;var o=Math.trunc((e+n)/2);
	o>e&&this.computeSelect(t,e,o,i),n>o&&this.computeSelect(t,o,n,i)},getCoordinates:function(){for(var t=new Array(this.end-this.start+1).fill(null),e=0,n=this.start;n<=this.end;n++)t[e++]=this.pts[n];return t},computeOverlaps:function(t,e){this.computeOverlapsInternal(this.start,this.end,t,t.start,t.end,e)},setId:function(t){this.id=t},select:function(t,e){this.computeSelect(t,this.start,this.end,e)},getEnvelope:function(){if(null===this.env){var t=this.pts[this.start],e=this.pts[this.end];this.env=new C(t,e)}return this.env},getEndIndex:function(){return this.end},getStartIndex:function(){return this.start},getContext:function(){return this.context},getId:function(){return this.id},computeOverlapsInternal:function(t,e,n,i,r,s){var o=this.pts[t],a=this.pts[e],u=n.pts[i],l=n.pts[r];if(e-t===1&&r-i===1)return s.overlap(this,t,n,i),null;if(s.tempEnv1.init(o,a),s.tempEnv2.init(u,l),!s.tempEnv1.intersects(s.tempEnv2))return null;var h=Math.trunc((t+e)/2),c=Math.trunc((i+r)/2);h>t&&(c>i&&this.computeOverlapsInternal(t,h,n,i,c,s),r>c&&this.computeOverlapsInternal(t,h,n,c,r,s)),e>h&&(c>i&&this.computeOverlapsInternal(h,e,n,i,c,s),r>c&&this.computeOverlapsInternal(h,e,n,c,r,s))},interfaces_:function(){return[]},getClass:function(){return Qe}}),e(Je.prototype,{interfaces_:function(){return[]},getClass:function(){return Je}}),Je.isNorthern=function(t){return t===Je.NE||t===Je.NW},Je.isOpposite=function(t,e){if(t===e)return!1;var n=(t-e+4)%4;return 2===n},Je.commonHalfPlane=function(t,e){if(t===e)return t;var n=(t-e+4)%4;if(2===n)return-1;var i=e>t?t:e,r=t>e?t:e;return 0===i&&3===r?3:i},Je.isInHalfPlane=function(t,e){return e===Je.SE?t===Je.SE||t===Je.SW:t===e||t===e+1},Je.quadrant=function(){if("number"==typeof arguments[0]&&"number"==typeof arguments[1]){var t=arguments[0],e=arguments[1];if(0===t&&0===e)throw new i("Cannot compute the quadrant for point ( "+t+", "+e+" )");return t>=0?e>=0?Je.NE:Je.SE:e>=0?Je.NW:Je.SW}if(arguments[0]instanceof g&&arguments[1]instanceof g){var n=arguments[0],r=arguments[1];if(r.x===n.x&&r.y===n.y)throw new i("Cannot compute the quadrant for two identical points "+n);return r.x>=n.x?r.y>=n.y?Je.NE:Je.SE:r.y>=n.y?Je.NW:Je.SW}},Je.NE=0,Je.NW=1,Je.SW=2,Je.SE=3,e($e.prototype,{interfaces_:function(){return[]},getClass:function(){return $e}}),$e.getChainStartIndices=function(t){var e=0,n=new I;n.add(new b(e));do{var i=$e.findChainEnd(t,e);n.add(new b(i)),e=i}while(e<t.length-1);var r=$e.toIntArray(n);return r},$e.findChainEnd=function(t,e){for(var n=e;n<t.length-1&&t[n].equals2D(t[n+1]);)n++;if(n>=t.length-1)return t.length-1;for(var i=Je.quadrant(t[n],t[n+1]),r=e+1;r<t.length;){if(!t[r-1].equals2D(t[r])){var s=Je.quadrant(t[r-1],t[r]);if(s!==i)break}r++}return r-1},$e.getChains=function(){if(1===arguments.length){var t=arguments[0];return $e.getChains(t,null)}if(2===arguments.length){for(var e=arguments[0],n=arguments[1],i=new I,r=$e.getChainStartIndices(e),s=0;s<r.length-1;s++){var o=new Qe(e,r[s],r[s+1],n);i.add(o)}return i}},$e.toIntArray=function(t){for(var e=new Array(t.size()).fill(null),n=0;n<e.length;n++)e[n]=t.get(n).intValue();return e},e(tn.prototype,{computeNodes:function(t){},getNodedSubstrings:function(){},interfaces_:function(){return[]},getClass:function(){return tn}}),e(en.prototype,{setSegmentIntersector:function(t){this.segInt=t},interfaces_:function(){return[tn]},getClass:function(){return en}}),h(nn,en),e(nn.prototype,{getMonotoneChains:function(){return this.monoChains},getNodedSubstrings:function(){return Ke.getNodedSubstrings(this.nodedSegStrings)},getIndex:function(){return this.index},add:function(t){for(var e=$e.getChains(t.getCoordinates(),t),n=e.iterator();n.hasNext();){var i=n.next();i.setId(this.idCounter++),this.index.insert(i.getEnvelope(),i),this.monoChains.add(i)}},computeNodes:function(t){this.nodedSegStrings=t;for(var e=t.iterator();e.hasNext();)this.add(e.next());this.intersectChains()},intersectChains:function(){for(var t=new rn(this.segInt),e=this.monoChains.iterator();e.hasNext();)for(var n=e.next(),i=this.index.query(n.getEnvelope()),r=i.iterator();r.hasNext();){var s=r.next();if(s.getId()>n.getId()&&(n.computeOverlaps(s,t),this.nOverlaps++),this.segInt.isDone())return null}},interfaces_:function(){return[]},getClass:function(){return nn}}),h(rn,Ze),e(rn.prototype,{overlap:function(){if(4!==arguments.length)return Ze.prototype.overlap.apply(this,arguments);var t=arguments[0],e=arguments[1],n=arguments[2],i=arguments[3],r=t.getContext(),s=n.getContext();this.si.processIntersections(r,e,s,i)},interfaces_:function(){return[]},getClass:function(){return rn}}),nn.SegmentOverlapAction=rn,h(sn,l),e(sn.prototype,{getCoordinate:function(){return this.pt},interfaces_:function(){return[]},getClass:function(){return sn}}),sn.msgWithCoord=function(t,e){return null!==e?t+" [ "+e+" ]":t},e(on.prototype,{processIntersections:function(t,e,n,i){},isDone:function(){},interfaces_:function(){return[]},getClass:function(){return on}}),e(an.prototype,{getInteriorIntersection:function(){return this.interiorIntersection},setCheckEndSegmentsOnly:function(t){this.isCheckEndSegmentsOnly=t},getIntersectionSegments:function(){return this.intSegments},count:function(){return this.intersectionCount},getIntersections:function(){return this.intersections},setFindAllIntersections:function(t){this.findAllIntersections=t},setKeepIntersections:function(t){this.keepIntersections=t},processIntersections:function(t,e,n,i){if(!this.findAllIntersections&&this.hasIntersection())return null;if(t===n&&e===i)return null;if(this.isCheckEndSegmentsOnly){var r=this.isEndSegment(t,e)||this.isEndSegment(n,i);if(!r)return null}var s=t.getCoordinates()[e],o=t.getCoordinates()[e+1],a=n.getCoordinates()[i],u=n.getCoordinates()[i+1];this.li.computeIntersection(s,o,a,u),this.li.hasIntersection()&&this.li.isInteriorIntersection()&&(this.intSegments=new Array(4).fill(null),this.intSegments[0]=s,this.intSegments[1]=o,this.intSegments[2]=a,this.intSegments[3]=u,this.interiorIntersection=this.li.getIntersection(0),this.keepIntersections&&this.intersections.add(this.interiorIntersection),this.intersectionCount++)},isEndSegment:function(t,e){return 0===e?!0:e>=t.size()-2},hasIntersection:function(){return null!==this.interiorIntersection},isDone:function(){return this.findAllIntersections?!1:null!==this.interiorIntersection},interfaces_:function(){return[on]},getClass:function(){return an}}),an.createAllIntersectionsFinder=function(t){var e=new an(t);return e.setFindAllIntersections(!0),e},an.createAnyIntersectionFinder=function(t){return new an(t)},an.createIntersectionCounter=function(t){var e=new an(t);return e.setFindAllIntersections(!0),e.setKeepIntersections(!1),e},e(un.prototype,{execute:function(){return null!==this.segInt?null:void this.checkInteriorIntersections()},getIntersections:function(){return this.segInt.getIntersections()},isValid:function(){return this.execute(),this._isValid},setFindAllIntersections:function(t){this.findAllIntersections=t},checkInteriorIntersections:function(){this._isValid=!0,this.segInt=new an(this.li),this.segInt.setFindAllIntersections(this.findAllIntersections);var t=new nn;return t.setSegmentIntersector(this.segInt),t.computeNodes(this.segStrings),this.segInt.hasIntersection()?(this._isValid=!1,null):void 0},checkValid:function(){if(this.execute(),!this._isValid)throw new sn(this.getErrorMessage(),this.segInt.getInteriorIntersection())},getErrorMessage:function(){if(this._isValid)return"no intersections found";var t=this.segInt.getIntersectionSegments();return"found non-noded intersection between "+se.toLineString(t[0],t[1])+" and "+se.toLineString(t[2],t[3])},interfaces_:function(){return[]},getClass:function(){return un}}),un.computeIntersections=function(t){var e=new un(t);return e.setFindAllIntersections(!0),e.isValid(),e.getIntersections()},e(ln.prototype,{checkValid:function(){this.nv.checkValid()},interfaces_:function(){return[]},getClass:function(){return ln}}),ln.toSegmentStrings=function(t){for(var e=new I,n=t.iterator();n.hasNext();){var i=n.next();e.add(new Oe(i.getCoordinates(),i))}return e},ln.checkValid=function(t){var e=new ln(t);e.checkValid()},e(hn.prototype,{map:function(t){for(var e=new I,n=0;n<t.getNumGeometries();n++){var i=this.mapOp.map(t.getGeometryN(n));i.isEmpty()||e.add(i)}return t.getFactory().createGeometryCollection(ie.toGeometryArray(e))},interfaces_:function(){return[]},getClass:function(){return hn}}),hn.map=function(t,e){var n=new hn(e);return n.map(t)},e(cn.prototype,{interfaces_:function(){return[]},getClass:function(){return cn}}),cn.opposite=function(t){return t===cn.LEFT?cn.RIGHT:t===cn.RIGHT?cn.LEFT:t},cn.ON=0,cn.LEFT=1,cn.RIGHT=2,e(fn.prototype,{setAllLocations:function(t){for(var e=0;e<this.location.length;e++)this.location[e]=t},isNull:function(){for(var t=0;t<this.location.length;t++)if(this.location[t]!==L.NONE)return!1;return!0},setAllLocationsIfNull:function(t){for(var e=0;e<this.location.length;e++)this.location[e]===L.NONE&&(this.location[e]=t)},isLine:function(){return 1===this.location.length},merge:function(t){if(t.location.length>this.location.length){var e=new Array(3).fill(null);e[cn.ON]=this.location[cn.ON],e[cn.LEFT]=L.NONE,e[cn.RIGHT]=L.NONE,this.location=e}for(var n=0;n<this.location.length;n++)this.location[n]===L.NONE&&n<t.location.length&&(this.location[n]=t.location[n])},getLocations:function(){return this.location},flip:function(){if(this.location.length<=1)return null;var t=this.location[cn.LEFT];this.location[cn.LEFT]=this.location[cn.RIGHT],this.location[cn.RIGHT]=t},toString:function(){var t=new P;return this.location.length>1&&t.append(L.toLocationSymbol(this.location[cn.LEFT])),t.append(L.toLocationSymbol(this.location[cn.ON])),this.location.length>1&&t.append(L.toLocationSymbol(this.location[cn.RIGHT])),t.toString()},setLocations:function(t,e,n){this.location[cn.ON]=t,this.location[cn.LEFT]=e,this.location[cn.RIGHT]=n},get:function(t){return t<this.location.length?this.location[t]:L.NONE},isArea:function(){return this.location.length>1},isAnyNull:function(){for(var t=0;t<this.location.length;t++)if(this.location[t]===L.NONE)return!0;return!1},setLocation:function(){if(1===arguments.length){var t=arguments[0];this.setLocation(cn.ON,t)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this.location[e]=n}},init:function(t){this.location=new Array(t).fill(null),this.setAllLocations(L.NONE)},isEqualOnSide:function(t,e){return this.location[e]===t.location[e]},allPositionsEqual:function(t){for(var e=0;e<this.location.length;e++)if(this.location[e]!==t)return!1;return!0},interfaces_:function(){return[]},getClass:function(){return fn}}),e(gn.prototype,{getGeometryCount:function(){var t=0;return this.elt[0].isNull()||t++,this.elt[1].isNull()||t++,t},setAllLocations:function(t,e){this.elt[t].setAllLocations(e)},isNull:function(t){return this.elt[t].isNull()},setAllLocationsIfNull:function(){if(1===arguments.length){var t=arguments[0];this.setAllLocationsIfNull(0,t),this.setAllLocationsIfNull(1,t)}else if(2===arguments.length){var e=arguments[0],n=arguments[1];this.elt[e].setAllLocationsIfNull(n)}},isLine:function(t){return this.elt[t].isLine()},merge:function(t){for(var e=0;2>e;e++)null===this.elt[e]&&null!==t.elt[e]?this.elt[e]=new fn(t.elt[e]):this.elt[e].merge(t.elt[e])},flip:function(){this.elt[0].flip(),this.elt[1].flip()},getLocation:function(){if(1===arguments.length){var t=arguments[0];return this.elt[t].get(cn.ON)}if(2===arguments.length){var e=arguments[0],n=arguments[1];return this.elt[e].get(n)}},toString:function(){var t=new P;return null!==this.elt[0]&&(t.append("A:"),t.append(this.elt[0].toString())),null!==this.elt[1]&&(t.append(" B:"),t.append(this.elt[1].toString())),t.toString()},isArea:function(){if(0===arguments.length)return this.elt[0].isArea()||this.elt[1].isArea();if(1===arguments.length){var t=arguments[0];return this.elt[t].isArea()}},isAnyNull:function(t){return this.elt[t].isAnyNull()},setLocation:function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];this.elt[t].setLocation(cn.ON,e)}else if(3===arguments.length){var n=arguments[0],i=arguments[1],r=arguments[2];this.elt[n].setLocation(i,r)}},isEqualOnSide:function(t,e){return this.elt[0].isEqualOnSide(t.elt[0],e)&&this.elt[1].isEqualOnSide(t.elt[1],e)},allPositionsEqual:function(t,e){return this.elt[t].allPositionsEqual(e)},toLine:function(t){this.elt[t].isArea()&&(this.elt[t]=new fn(this.elt[t].location[0]))},interfaces_:function(){return[]},getClass:function(){return gn}}),gn.toLineLabel=function(t){for(var e=new gn(L.NONE),n=0;2>n;n++)e.setLocation(n,t.getLocation(n));return e},e(dn.prototype,{computeRing:function(){if(null!==this.ring)return null;for(var t=new Array(this.pts.size()).fill(null),e=0;e<this.pts.size();e++)t[e]=this.pts.get(e);this.ring=this.geometryFactory.createLinearRing(t),this._isHole=he.isCCW(this.ring.getCoordinates())},isIsolated:function(){return 1===this.label.getGeometryCount()},computePoints:function(t){this.startDe=t;var e=t,n=!0;do{if(null===e)throw new sn("Found null DirectedEdge");if(e.getEdgeRing()===this)throw new sn("Directed Edge visited twice during ring-building at "+e.getCoordinate());this.edges.add(e);var i=e.getLabel();f.isTrue(i.isArea()),this.mergeLabel(i),this.addPoints(e.getEdge(),e.isForward(),n),n=!1,this.setEdgeRing(e,this),e=this.getNext(e)}while(e!==this.startDe)},getLinearRing:function(){return this.ring},getCoordinate:function(t){return this.pts.get(t)},computeMaxNodeDegree:function(){this.maxNodeDegree=0;var t=this.startDe;do{var e=t.getNode(),n=e.getEdges().getOutgoingDegree(this);n>this.maxNodeDegree&&(this.maxNodeDegree=n),t=this.getNext(t)}while(t!==this.startDe);this.maxNodeDegree*=2},addPoints:function(t,e,n){var i=t.getCoordinates();if(e){var r=1;n&&(r=0);for(var s=r;s<i.length;s++)this.pts.add(i[s])}else{var r=i.length-2;n&&(r=i.length-1);for(var s=r;s>=0;s--)this.pts.add(i[s])}},isHole:function(){return this._isHole},setInResult:function(){var t=this.startDe;do t.getEdge().setInResult(!0),t=t.getNext();while(t!==this.startDe)},containsPoint:function(t){var e=this.getLinearRing(),n=e.getEnvelopeInternal();if(!n.contains(t))return!1;if(!he.isPointInRing(t,e.getCoordinates()))return!1;for(var i=this.holes.iterator();i.hasNext();){var r=i.next();if(r.containsPoint(t))return!1}return!0},addHole:function(t){this.holes.add(t)},isShell:function(){return null===this.shell},getLabel:function(){return this.label},getEdges:function(){return this.edges},getMaxNodeDegree:function(){return this.maxNodeDegree<0&&this.computeMaxNodeDegree(),this.maxNodeDegree},getShell:function(){return this.shell},mergeLabel:function(){if(1===arguments.length){var t=arguments[0];this.mergeLabel(t,0),this.mergeLabel(t,1)}else if(2===arguments.length){var e=arguments[0],n=arguments[1],i=e.getLocation(n,cn.RIGHT);if(i===L.NONE)return null;if(this.label.getLocation(n)===L.NONE)return this.label.setLocation(n,i),null}},setShell:function(t){this.shell=t,null!==t&&t.addHole(this)},toPolygon:function(t){for(var e=new Array(this.holes.size()).fill(null),n=0;n<this.holes.size();n++)e[n]=this.holes.get(n).getLinearRing();var i=t.createPolygon(this.getLinearRing(),e);return i},interfaces_:function(){return[]},getClass:function(){return dn}}),h(pn,dn),e(pn.prototype,{setEdgeRing:function(t,e){t.setMinEdgeRing(e)},getNext:function(t){return t.getNextMin()},interfaces_:function(){return[]},getClass:function(){return pn}}),h(vn,dn),e(vn.prototype,{buildMinimalRings:function(){var t=new I,e=this.startDe;do{if(null===e.getMinEdgeRing()){var n=new pn(e,this.geometryFactory);t.add(n)}e=e.getNext()}while(e!==this.startDe);return t},setEdgeRing:function(t,e){t.setEdgeRing(e)},linkDirectedEdgesForMinimalEdgeRings:function(){var t=this.startDe;do{var e=t.getNode();e.getEdges().linkMinimalDirectedEdges(this),t=t.getNext()}while(t!==this.startDe)},getNext:function(t){return t.getNext()},interfaces_:function(){return[]},getClass:function(){return vn}}),e(mn.prototype,{setVisited:function(t){this._isVisited=t},setInResult:function(t){this._isInResult=t},isCovered:function(){return this._isCovered},isCoveredSet:function(){return this._isCoveredSet},setLabel:function(t){this.label=t},getLabel:function(){return this.label},setCovered:function(t){this._isCovered=t,this._isCoveredSet=!0},updateIM:function(t){f.isTrue(this.label.getGeometryCount()>=2,"found partial label"),this.computeIM(t)},isInResult:function(){return this._isInResult},isVisited:function(){return this._isVisited},interfaces_:function(){return[]},getClass:function(){return mn}}),h(yn,mn),e(yn.prototype,{isIncidentEdgeInResult:function(){for(var t=this.getEdges().getEdges().iterator();t.hasNext();){var e=t.next();if(e.getEdge().isInResult())return!0}return!1},isIsolated:function(){return 1===this.label.getGeometryCount()},getCoordinate:function(){return this.coord},print:function(t){t.println("node "+this.coord+" lbl: "+this.label)},computeIM:function(t){},computeMergedLocation:function(t,e){var n=L.NONE;if(n=this.label.getLocation(e),!t.isNull(e)){var i=t.getLocation(e);n!==L.BOUNDARY&&(n=i)}return n},setLabel:function(){if(2!==arguments.length)return mn.prototype.setLabel.apply(this,arguments);var t=arguments[0],e=arguments[1];null===this.label?this.label=new gn(t,e):this.label.setLocation(t,e)},getEdges:function(){return this.edges},mergeLabel:function(){if(arguments[0]instanceof yn){var t=arguments[0];this.mergeLabel(t.label)}else if(arguments[0]instanceof gn)for(var e=arguments[0],n=0;2>n;n++){var i=this.computeMergedLocation(e,n),r=this.label.getLocation(n);r===L.NONE&&this.label.setLocation(n,i)}},add:function(t){this.edges.insert(t),t.setNode(this)},setLabelBoundary:function(t){if(null===this.label)return null;var e=L.NONE;null!==this.label&&(e=this.label.getLocation(t));var n=null;switch(e){case L.BOUNDARY:n=L.INTERIOR;break;case L.INTERIOR:n=L.BOUNDARY;break;default:n=L.BOUNDARY}this.label.setLocation(t,n)},interfaces_:function(){return[]},getClass:function(){return yn}}),e(xn.prototype,{find:function(t){return this.nodeMap.get(t)},addNode:function(){if(arguments[0]instanceof g){var t=arguments[0],e=this.nodeMap.get(t);return null===e&&(e=this.nodeFact.createNode(t),this.nodeMap.put(t,e)),e}if(arguments[0]instanceof yn){var n=arguments[0],e=this.nodeMap.get(n.getCoordinate());return null===e?(this.nodeMap.put(n.getCoordinate(),n),n):(e.mergeLabel(n),e)}},print:function(t){for(var e=this.iterator();e.hasNext();){var n=e.next();n.print(t)}},iterator:function(){return this.nodeMap.values().iterator()},values:function(){return this.nodeMap.values()},getBoundaryNodes:function(t){for(var e=new I,n=this.iterator();n.hasNext();){var i=n.next();i.getLabel().getLocation(t)===L.BOUNDARY&&e.add(i)}return e},add:function(t){var e=t.getCoordinate(),n=this.addNode(e);n.add(t)},interfaces_:function(){return[]},getClass:function(){return xn}}),e(En.prototype,{compareDirection:function(t){return this.dx===t.dx&&this.dy===t.dy?0:this.quadrant>t.quadrant?1:this.quadrant<t.quadrant?-1:he.computeOrientation(t.p0,t.p1,this.p1)},getDy:function(){return this.dy},getCoordinate:function(){return this.p0},setNode:function(t){this.node=t},print:function(t){var e=Math.atan2(this.dy,this.dx),n=this.getClass().getName(),i=n.lastIndexOf("."),r=n.substring(i+1);t.print("  "+r+": "+this.p0+" - "+this.p1+" "+this.quadrant+":"+e+"   "+this.label)},compareTo:function(t){var e=t;return this.compareDirection(e)},getDirectedCoordinate:function(){return this.p1},getDx:function(){return this.dx},getLabel:function(){return this.label},getEdge:function(){return this.edge},getQuadrant:function(){return this.quadrant},getNode:function(){return this.node},toString:function(){var t=Math.atan2(this.dy,this.dx),e=this.getClass().getName(),n=e.lastIndexOf("."),i=e.substring(n+1);return"  "+i+": "+this.p0+" - "+this.p1+" "+this.quadrant+":"+t+"   "+this.label},computeLabel:function(t){},init:function(t,e){this.p0=t,this.p1=e,this.dx=e.x-t.x,this.dy=e.y-t.y,this.quadrant=Je.quadrant(this.dx,this.dy),f.isTrue(!(0===this.dx&&0===this.dy),"EdgeEnd with identical endpoints found")},interfaces_:function(){return[s]},getClass:function(){return En}}),h(In,En),e(In.prototype,{getNextMin:function(){return this.nextMin},getDepth:function(t){return this.depth[t]},setVisited:function(t){this._isVisited=t},computeDirectedLabel:function(){this.label=new gn(this.edge.getLabel()),this._isForward||this.label.flip()},getNext:function(){return this.next},setDepth:function(t,e){if(-999!==this.depth[t]&&this.depth[t]!==e)throw new sn("assigned depths do not match",this.getCoordinate());this.depth[t]=e},isInteriorAreaEdge:function t(){for(var t=!0,e=0;2>e;e++)this.label.isArea(e)&&this.label.getLocation(e,cn.LEFT)===L.INTERIOR&&this.label.getLocation(e,cn.RIGHT)===L.INTERIOR||(t=!1);return t},setNextMin:function(t){this.nextMin=t},print:function(t){En.prototype.print.call(this,t),t.print(" "+this.depth[cn.LEFT]+"/"+this.depth[cn.RIGHT]),t.print(" ("+this.getDepthDelta()+")"),this._isInResult&&t.print(" inResult")},setMinEdgeRing:function(t){this.minEdgeRing=t},isLineEdge:function(){var t=this.label.isLine(0)||this.label.isLine(1),e=!this.label.isArea(0)||this.label.allPositionsEqual(0,L.EXTERIOR),n=!this.label.isArea(1)||this.label.allPositionsEqual(1,L.EXTERIOR);return t&&e&&n},setEdgeRing:function(t){this.edgeRing=t},getMinEdgeRing:function(){return this.minEdgeRing},getDepthDelta:function(){var t=this.edge.getDepthDelta();return this._isForward||(t=-t),t},setInResult:function(t){this._isInResult=t},getSym:function(){return this.sym},isForward:function(){return this._isForward},getEdge:function(){return this.edge},printEdge:function(t){this.print(t),t.print(" "),this._isForward?this.edge.print(t):this.edge.printReverse(t)},setSym:function(t){this.sym=t},setVisitedEdge:function(t){this.setVisited(t),this.sym.setVisited(t)},setEdgeDepths:function(t,e){var n=this.getEdge().getDepthDelta();this._isForward||(n=-n);var i=1;t===cn.LEFT&&(i=-1);var r=cn.opposite(t),s=n*i,o=e+s;this.setDepth(t,e),this.setDepth(r,o)},getEdgeRing:function(){return this.edgeRing},isInResult:function(){return this._isInResult},setNext:function(t){this.next=t},isVisited:function(){return this._isVisited},interfaces_:function(){return[]},getClass:function(){return In}}),In.depthFactor=function(t,e){return t===L.EXTERIOR&&e===L.INTERIOR?1:t===L.INTERIOR&&e===L.EXTERIOR?-1:0},e(Nn.prototype,{createNode:function(t){return new yn(t,null)},interfaces_:function(){return[]},getClass:function(){return Nn}}),e(Cn.prototype,{printEdges:function(t){t.println("Edges:");for(var e=0;e<this.edges.size();e++){t.println("edge "+e+":");var n=this.edges.get(e);n.print(t),n.eiList.print(t)}},find:function(t){return this.nodes.find(t)},addNode:function(){if(arguments[0]instanceof yn){var t=arguments[0];return this.nodes.addNode(t)}if(arguments[0]instanceof g){var e=arguments[0];return this.nodes.addNode(e)}},getNodeIterator:function(){return this.nodes.iterator()},linkResultDirectedEdges:function(){for(var t=this.nodes.iterator();t.hasNext();){var e=t.next();e.getEdges().linkResultDirectedEdges()}},debugPrintln:function(t){A.out.println(t)},isBoundaryNode:function(t,e){var n=this.nodes.find(e);if(null===n)return!1;var i=n.getLabel();return null!==i&&i.getLocation(t)===L.BOUNDARY},linkAllDirectedEdges:function(){for(var t=this.nodes.iterator();t.hasNext();){var e=t.next();e.getEdges().linkAllDirectedEdges()}},matchInSameDirection:function(t,e,n,i){return t.equals(n)?he.computeOrientation(t,e,i)===he.COLLINEAR&&Je.quadrant(t,e)===Je.quadrant(n,i):!1},getEdgeEnds:function(){return this.edgeEndList},debugPrint:function(t){A.out.print(t)},getEdgeIterator:function(){return this.edges.iterator()},findEdgeInSameDirection:function(t,e){for(var n=0;n<this.edges.size();n++){var i=this.edges.get(n),r=i.getCoordinates();if(this.matchInSameDirection(t,e,r[0],r[1]))return i;if(this.matchInSameDirection(t,e,r[r.length-1],r[r.length-2]))return i}return null},insertEdge:function(t){this.edges.add(t)},findEdgeEnd:function(t){for(var e=this.getEdgeEnds().iterator();e.hasNext();){var n=e.next();if(n.getEdge()===t)return n}return null},addEdges:function(t){for(var e=t.iterator();e.hasNext();){var n=e.next();this.edges.add(n);var i=new In(n,!0),r=new In(n,!1);i.setSym(r),r.setSym(i),this.add(i),this.add(r)}},add:function(t){this.nodes.add(t),this.edgeEndList.add(t)},getNodes:function(){return this.nodes.values()},findEdge:function(t,e){for(var n=0;n<this.edges.size();n++){var i=this.edges.get(n),r=i.getCoordinates();if(t.equals(r[0])&&e.equals(r[1]))return i}return null},interfaces_:function(){return[]},getClass:function(){return Cn}}),Cn.linkResultDirectedEdges=function(t){for(var e=t.iterator();e.hasNext();){var n=e.next();n.getEdges().linkResultDirectedEdges()}},e(Sn.prototype,{sortShellsAndHoles:function(t,e,n){for(var i=t.iterator();i.hasNext();){var r=i.next();r.isHole()?n.add(r):e.add(r)}},computePolygons:function(t){for(var e=new I,n=t.iterator();n.hasNext();){var i=n.next(),r=i.toPolygon(this.geometryFactory);e.add(r)}return e},placeFreeHoles:function(t,e){for(var n=e.iterator();n.hasNext();){var i=n.next();if(null===i.getShell()){var r=this.findEdgeRingContaining(i,t);if(null===r)throw new sn("unable to assign hole to a shell",i.getCoordinate(0));i.setShell(r)}}},buildMinimalEdgeRings:function(t,e,n){for(var i=new I,r=t.iterator();r.hasNext();){var s=r.next();if(s.getMaxNodeDegree()>2){s.linkDirectedEdgesForMinimalEdgeRings();var o=s.buildMinimalRings(),a=this.findShell(o);null!==a?(this.placePolygonHoles(a,o),e.add(a)):n.addAll(o)}else i.add(s)}return i},containsPoint:function(t){for(var e=this.shellList.iterator();e.hasNext();){var n=e.next();if(n.containsPoint(t))return!0}return!1},buildMaximalEdgeRings:function(t){for(var e=new I,n=t.iterator();n.hasNext();){var i=n.next();if(i.isInResult()&&i.getLabel().isArea()&&null===i.getEdgeRing()){var r=new vn(i,this.geometryFactory);e.add(r),r.setInResult()}}return e},placePolygonHoles:function(t,e){for(var n=e.iterator();n.hasNext();){var i=n.next();i.isHole()&&i.setShell(t)}},getPolygons:function(){var t=this.computePolygons(this.shellList);return t},findEdgeRingContaining:function(t,e){for(var n=t.getLinearRing(),i=n.getEnvelopeInternal(),r=n.getCoordinateN(0),s=null,o=null,a=e.iterator();a.hasNext();){var u=a.next(),l=u.getLinearRing(),h=l.getEnvelopeInternal();null!==s&&(o=s.getLinearRing().getEnvelopeInternal());var c=!1;h.contains(i)&&he.isPointInRing(r,l.getCoordinates())&&(c=!0),c&&(null===s||o.contains(h))&&(s=u)}return s},findShell:function(t){for(var e=0,n=null,i=t.iterator();i.hasNext();){var r=i.next();r.isHole()||(n=r,e++)}return f.isTrue(1>=e,"found two shells in MinimalEdgeRing list"),n},add:function(){if(1===arguments.length){var t=arguments[0];this.add(t.getEdgeEnds(),t.getNodes())}else if(2===arguments.length){var e=arguments[0],n=arguments[1];Cn.linkResultDirectedEdges(n);var i=this.buildMaximalEdgeRings(e),r=new I,s=this.buildMinimalEdgeRings(i,this.shellList,r);this.sortShellsAndHoles(s,this.shellList,r),this.placeFreeHoles(this.shellList,r)}},interfaces_:function(){return[]},getClass:function(){return Sn}}),e(wn.prototype,{collectLines:function(t){for(var e=this.op.getGraph().getEdgeEnds().iterator();e.hasNext();){var n=e.next();this.collectLineEdge(n,t,this.lineEdgesList),this.collectBoundaryTouchEdge(n,t,this.lineEdgesList)}},labelIsolatedLine:function(t,e){var n=this.ptLocator.locate(t.getCoordinate(),this.op.getArgGeometry(e));t.getLabel().setLocation(e,n)},build:function(t){return this.findCoveredLineEdges(),this.collectLines(t),this.buildLines(t),this.resultLineList},collectLineEdge:function(t,e,n){var i=t.getLabel(),r=t.getEdge();t.isLineEdge()&&(t.isVisited()||!ii.isResultOfOp(i,e)||r.isCovered()||(n.add(r),t.setVisitedEdge(!0)))},findCoveredLineEdges:function(){for(var t=this.op.getGraph().getNodes().iterator();t.hasNext();){var e=t.next();e.getEdges().findCoveredLineEdges()}for(var n=this.op.getGraph().getEdgeEnds().iterator();n.hasNext();){var i=n.next(),r=i.getEdge();if(i.isLineEdge()&&!r.isCoveredSet()){var s=this.op.isCoveredByA(i.getCoordinate());r.setCovered(s)}}},labelIsolatedLines:function(t){for(var e=t.iterator();e.hasNext();){var n=e.next(),i=n.getLabel();n.isIsolated()&&(i.isNull(0)?this.labelIsolatedLine(n,0):this.labelIsolatedLine(n,1))}},buildLines:function(t){for(var e=this.lineEdgesList.iterator();e.hasNext();){var n=e.next(),i=(n.getLabel(),this.geometryFactory.createLineString(n.getCoordinates()));this.resultLineList.add(i),n.setInResult(!0)}},collectBoundaryTouchEdge:function(t,e,n){var i=t.getLabel();return t.isLineEdge()?null:t.isVisited()?null:t.isInteriorAreaEdge()?null:t.getEdge().isInResult()?null:(f.isTrue(!(t.isInResult()||t.getSym().isInResult())||!t.getEdge().isInResult()),void(ii.isResultOfOp(i,e)&&e===ii.INTERSECTION&&(n.add(t.getEdge()),t.setVisitedEdge(!0))))},interfaces_:function(){return[]},getClass:function(){return wn}}),e(Ln.prototype,{filterCoveredNodeToPoint:function(t){var e=t.getCoordinate();if(!this.op.isCoveredByLA(e)){var n=this.geometryFactory.createPoint(e);this.resultPointList.add(n)}},extractNonCoveredResultNodes:function(t){for(var e=this.op.getGraph().getNodes().iterator();e.hasNext();){var n=e.next();if(!(n.isInResult()||n.isIncidentEdgeInResult()||0!==n.getEdges().getDegree()&&t!==ii.INTERSECTION)){var i=n.getLabel();ii.isResultOfOp(i,t)&&this.filterCoveredNodeToPoint(n)}}},build:function(t){return this.extractNonCoveredResultNodes(t),this.resultPointList},interfaces_:function(){return[]},getClass:function(){return Ln}}),e(Rn.prototype,{locate:function(t){},interfaces_:function(){return[]},getClass:function(){return Rn}}),e(Tn.prototype,{locate:function(t){return Tn.locate(t,this.geom)},interfaces_:function(){return[Rn]},getClass:function(){return Tn}}),Tn.isPointInRing=function(t,e){return e.getEnvelopeInternal().intersects(t)?he.isPointInRing(t,e.getCoordinates()):!1},Tn.containsPointInPolygon=function(t,e){if(e.isEmpty())return!1;var n=e.getExteriorRing();if(!Tn.isPointInRing(t,n))return!1;for(var i=0;i<e.getNumInteriorRing();i++){var r=e.getInteriorRingN(i);if(Tn.isPointInRing(t,r))return!1}return!0},Tn.containsPoint=function(t,e){if(e instanceof Tt)return Tn.containsPointInPolygon(t,e);if(e instanceof ft)for(var n=new Re(e);n.hasNext();){var i=n.next();if(i!==e&&Tn.containsPoint(t,i))return!0}return!1},Tn.locate=function(t,e){return e.isEmpty()?L.EXTERIOR:Tn.containsPoint(t,e)?L.INTERIOR:L.EXTERIOR},e(Pn.prototype,{getNextCW:function(t){this.getEdges();var e=this.edgeList.indexOf(t),n=e-1;return 0===e&&(n=this.edgeList.size()-1),this.edgeList.get(n)},propagateSideLabels:function(t){for(var e=L.NONE,n=this.iterator();n.hasNext();){var i=n.next(),r=i.getLabel();r.isArea(t)&&r.getLocation(t,cn.LEFT)!==L.NONE&&(e=r.getLocation(t,cn.LEFT))}if(e===L.NONE)return null;for(var s=e,n=this.iterator();n.hasNext();){var i=n.next(),r=i.getLabel();if(r.getLocation(t,cn.ON)===L.NONE&&r.setLocation(t,cn.ON,s),r.isArea(t)){var o=r.getLocation(t,cn.LEFT),a=r.getLocation(t,cn.RIGHT);if(a!==L.NONE){if(a!==s)throw new sn("side location conflict",i.getCoordinate());o===L.NONE&&f.shouldNeverReachHere("found single null side (at "+i.getCoordinate()+")"),s=o}else f.isTrue(r.getLocation(t,cn.LEFT)===L.NONE,"found single null side"),r.setLocation(t,cn.RIGHT,s),r.setLocation(t,cn.LEFT,s)}}},getCoordinate:function(){var t=this.iterator();if(!t.hasNext())return null;var e=t.next();return e.getCoordinate()},print:function(t){A.out.println("EdgeEndStar:   "+this.getCoordinate());for(var e=this.iterator();e.hasNext();){var n=e.next();n.print(t)}},isAreaLabelsConsistent:function(t){return this.computeEdgeEndLabels(t.getBoundaryNodeRule()),this.checkAreaLabelsConsistent(0)},checkAreaLabelsConsistent:function(t){var e=this.getEdges();if(e.size()<=0)return!0;var n=e.size()-1,i=e.get(n).getLabel(),r=i.getLocation(t,cn.LEFT);f.isTrue(r!==L.NONE,"Found unlabelled area edge");for(var s=r,o=this.iterator();o.hasNext();){var a=o.next(),u=a.getLabel();
	f.isTrue(u.isArea(t),"Found non-area edge");var l=u.getLocation(t,cn.LEFT),h=u.getLocation(t,cn.RIGHT);if(l===h)return!1;if(h!==s)return!1;s=l}return!0},findIndex:function(t){this.iterator();for(var e=0;e<this.edgeList.size();e++){var n=this.edgeList.get(e);if(n===t)return e}return-1},iterator:function(){return this.getEdges().iterator()},getEdges:function(){return null===this.edgeList&&(this.edgeList=new I(this.edgeMap.values())),this.edgeList},getLocation:function(t,e,n){return this.ptInAreaLocation[t]===L.NONE&&(this.ptInAreaLocation[t]=Tn.locate(e,n[t].getGeometry())),this.ptInAreaLocation[t]},toString:function(){var t=new P;t.append("EdgeEndStar:   "+this.getCoordinate()),t.append("\n");for(var e=this.iterator();e.hasNext();){var n=e.next();t.append(n),t.append("\n")}return t.toString()},computeEdgeEndLabels:function(t){for(var e=this.iterator();e.hasNext();){var n=e.next();n.computeLabel(t)}},computeLabelling:function(t){this.computeEdgeEndLabels(t[0].getBoundaryNodeRule()),this.propagateSideLabels(0),this.propagateSideLabels(1);for(var e=[!1,!1],n=this.iterator();n.hasNext();)for(var i=n.next(),r=i.getLabel(),s=0;2>s;s++)r.isLine(s)&&r.getLocation(s)===L.BOUNDARY&&(e[s]=!0);for(var n=this.iterator();n.hasNext();)for(var i=n.next(),r=i.getLabel(),s=0;2>s;s++)if(r.isAnyNull(s)){var o=L.NONE;if(e[s])o=L.EXTERIOR;else{var a=i.getCoordinate();o=this.getLocation(s,a,t)}r.setAllLocationsIfNull(s,o)}},getDegree:function(){return this.edgeMap.size()},insertEdgeEnd:function(t,e){this.edgeMap.put(t,e),this.edgeList=null},interfaces_:function(){return[]},getClass:function(){return Pn}}),h(bn,Pn),e(bn.prototype,{linkResultDirectedEdges:function(){this.getResultAreaEdges();for(var t=null,e=null,n=this.SCANNING_FOR_INCOMING,i=0;i<this.resultAreaEdgeList.size();i++){var r=this.resultAreaEdgeList.get(i),s=r.getSym();if(r.getLabel().isArea())switch(null===t&&r.isInResult()&&(t=r),n){case this.SCANNING_FOR_INCOMING:if(!s.isInResult())continue;e=s,n=this.LINKING_TO_OUTGOING;break;case this.LINKING_TO_OUTGOING:if(!r.isInResult())continue;e.setNext(r),n=this.SCANNING_FOR_INCOMING}}if(n===this.LINKING_TO_OUTGOING){if(null===t)throw new sn("no outgoing dirEdge found",this.getCoordinate());f.isTrue(t.isInResult(),"unable to link last incoming dirEdge"),e.setNext(t)}},insert:function(t){var e=t;this.insertEdgeEnd(e,e)},getRightmostEdge:function(){var t=this.getEdges(),e=t.size();if(1>e)return null;var n=t.get(0);if(1===e)return n;var i=t.get(e-1),r=n.getQuadrant(),s=i.getQuadrant();if(Je.isNorthern(r)&&Je.isNorthern(s))return n;if(!Je.isNorthern(r)&&!Je.isNorthern(s))return i;return 0!==n.getDy()?n:0!==i.getDy()?i:(f.shouldNeverReachHere("found two horizontal edges incident on node"),null)},print:function(t){A.out.println("DirectedEdgeStar: "+this.getCoordinate());for(var e=this.iterator();e.hasNext();){var n=e.next();t.print("out "),n.print(t),t.println(),t.print("in "),n.getSym().print(t),t.println()}},getResultAreaEdges:function(){if(null!==this.resultAreaEdgeList)return this.resultAreaEdgeList;this.resultAreaEdgeList=new I;for(var t=this.iterator();t.hasNext();){var e=t.next();(e.isInResult()||e.getSym().isInResult())&&this.resultAreaEdgeList.add(e)}return this.resultAreaEdgeList},updateLabelling:function(t){for(var e=this.iterator();e.hasNext();){var n=e.next(),i=n.getLabel();i.setAllLocationsIfNull(0,t.getLocation(0)),i.setAllLocationsIfNull(1,t.getLocation(1))}},linkAllDirectedEdges:function(){this.getEdges();for(var t=null,e=null,n=this.edgeList.size()-1;n>=0;n--){var i=this.edgeList.get(n),r=i.getSym();null===e&&(e=r),null!==t&&r.setNext(t),t=i}e.setNext(t)},computeDepths:function(){if(1===arguments.length){var t=arguments[0],e=this.findIndex(t),n=(t.getLabel(),t.getDepth(cn.LEFT)),i=t.getDepth(cn.RIGHT),r=this.computeDepths(e+1,this.edgeList.size(),n),s=this.computeDepths(0,e,r);if(s!==i)throw new sn("depth mismatch at "+t.getCoordinate())}else if(3===arguments.length){for(var o=arguments[0],a=arguments[1],u=arguments[2],l=u,h=o;a>h;h++){var c=this.edgeList.get(h);c.getLabel();c.setEdgeDepths(cn.RIGHT,l),l=c.getDepth(cn.LEFT)}return l}},mergeSymLabels:function(){for(var t=this.iterator();t.hasNext();){var e=t.next(),n=e.getLabel();n.merge(e.getSym().getLabel())}},linkMinimalDirectedEdges:function(t){for(var e=null,n=null,i=this.SCANNING_FOR_INCOMING,r=this.resultAreaEdgeList.size()-1;r>=0;r--){var s=this.resultAreaEdgeList.get(r),o=s.getSym();switch(null===e&&s.getEdgeRing()===t&&(e=s),i){case this.SCANNING_FOR_INCOMING:if(o.getEdgeRing()!==t)continue;n=o,i=this.LINKING_TO_OUTGOING;break;case this.LINKING_TO_OUTGOING:if(s.getEdgeRing()!==t)continue;n.setNextMin(s),i=this.SCANNING_FOR_INCOMING}}i===this.LINKING_TO_OUTGOING&&(f.isTrue(null!==e,"found null for first outgoing dirEdge"),f.isTrue(e.getEdgeRing()===t,"unable to link last incoming dirEdge"),n.setNextMin(e))},getOutgoingDegree:function(){if(0===arguments.length){for(var t=0,e=this.iterator();e.hasNext();){var n=e.next();n.isInResult()&&t++}return t}if(1===arguments.length){for(var i=arguments[0],t=0,e=this.iterator();e.hasNext();){var n=e.next();n.getEdgeRing()===i&&t++}return t}},getLabel:function(){return this.label},findCoveredLineEdges:function(){for(var t=L.NONE,e=this.iterator();e.hasNext();){var n=e.next(),i=n.getSym();if(!n.isLineEdge()){if(n.isInResult()){t=L.INTERIOR;break}if(i.isInResult()){t=L.EXTERIOR;break}}}if(t===L.NONE)return null;for(var r=t,e=this.iterator();e.hasNext();){var n=e.next(),i=n.getSym();n.isLineEdge()?n.getEdge().setCovered(r===L.INTERIOR):(n.isInResult()&&(r=L.EXTERIOR),i.isInResult()&&(r=L.INTERIOR))}},computeLabelling:function(t){Pn.prototype.computeLabelling.call(this,t),this.label=new gn(L.NONE);for(var e=this.iterator();e.hasNext();)for(var n=e.next(),i=n.getEdge(),r=i.getLabel(),s=0;2>s;s++){var o=r.getLocation(s);o!==L.INTERIOR&&o!==L.BOUNDARY||this.label.setLocation(s,L.INTERIOR)}},interfaces_:function(){return[]},getClass:function(){return bn}}),h(On,Nn),e(On.prototype,{createNode:function(t){return new yn(t,new bn)},interfaces_:function(){return[]},getClass:function(){return On}}),e(_n.prototype,{computeIntersections:function(t,e){this.mce.computeIntersectsForChain(this.chainIndex,t.mce,t.chainIndex,e)},interfaces_:function(){return[]},getClass:function(){return _n}}),e(Mn.prototype,{isDelete:function(){return this.eventType===Mn.DELETE},setDeleteEventIndex:function(t){this.deleteEventIndex=t},getObject:function(){return this.obj},compareTo:function(t){var e=t;return this.xValue<e.xValue?-1:this.xValue>e.xValue?1:this.eventType<e.eventType?-1:this.eventType>e.eventType?1:0},getInsertEvent:function(){return this.insertEvent},isInsert:function(){return this.eventType===Mn.INSERT},isSameLabel:function(t){return null===this.label?!1:this.label===t.label},getDeleteEventIndex:function(){return this.deleteEventIndex},interfaces_:function(){return[s]},getClass:function(){return Mn}}),Mn.INSERT=1,Mn.DELETE=2,e(Dn.prototype,{interfaces_:function(){return[]},getClass:function(){return Dn}}),e(An.prototype,{isTrivialIntersection:function(t,e,n,i){if(t===n&&1===this.li.getIntersectionNum()){if(An.isAdjacentSegments(e,i))return!0;if(t.isClosed()){var r=t.getNumPoints()-1;if(0===e&&i===r||0===i&&e===r)return!0}}return!1},getProperIntersectionPoint:function(){return this.properIntersectionPoint},setIsDoneIfProperInt:function(t){this.isDoneWhenProperInt=t},hasProperInteriorIntersection:function(){return this.hasProperInterior},isBoundaryPointInternal:function(t,e){for(var n=e.iterator();n.hasNext();){var i=n.next(),r=i.getCoordinate();if(t.isIntersection(r))return!0}return!1},hasProperIntersection:function(){return this.hasProper},hasIntersection:function(){return this._hasIntersection},isDone:function(){return this._isDone},isBoundaryPoint:function(t,e){return null===e?!1:this.isBoundaryPointInternal(t,e[0])?!0:!!this.isBoundaryPointInternal(t,e[1])},setBoundaryNodes:function(t,e){this.bdyNodes=new Array(2).fill(null),this.bdyNodes[0]=t,this.bdyNodes[1]=e},addIntersections:function(t,e,n,i){if(t===n&&e===i)return null;this.numTests++;var r=t.getCoordinates()[e],s=t.getCoordinates()[e+1],o=n.getCoordinates()[i],a=n.getCoordinates()[i+1];this.li.computeIntersection(r,s,o,a),this.li.hasIntersection()&&(this.recordIsolated&&(t.setIsolated(!1),n.setIsolated(!1)),this.numIntersections++,this.isTrivialIntersection(t,e,n,i)||(this._hasIntersection=!0,!this.includeProper&&this.li.isProper()||(t.addIntersections(this.li,e,0),n.addIntersections(this.li,i,1)),this.li.isProper()&&(this.properIntersectionPoint=this.li.getIntersection(0).copy(),this.hasProper=!0,this.isDoneWhenProperInt&&(this._isDone=!0),this.isBoundaryPoint(this.li,this.bdyNodes)||(this.hasProperInterior=!0))))},interfaces_:function(){return[]},getClass:function(){return An}}),An.isAdjacentSegments=function(t,e){return 1===Math.abs(t-e)},h(Fn,Dn),e(Fn.prototype,{prepareEvents:function(){ho.sort(this.events);for(var t=0;t<this.events.size();t++){var e=this.events.get(t);e.isDelete()&&e.getInsertEvent().setDeleteEventIndex(t)}},computeIntersections:function(){if(1===arguments.length){var t=arguments[0];this.nOverlaps=0,this.prepareEvents();for(var e=0;e<this.events.size();e++){var n=this.events.get(e);if(n.isInsert()&&this.processOverlaps(e,n.getDeleteEventIndex(),n,t),t.isDone())break}}else if(3===arguments.length)if(arguments[2]instanceof An&&R(arguments[0],y)&&R(arguments[1],y)){var i=arguments[0],r=arguments[1],s=arguments[2];this.addEdges(i,i),this.addEdges(r,r),this.computeIntersections(s)}else if("boolean"==typeof arguments[2]&&R(arguments[0],y)&&arguments[1]instanceof An){var o=arguments[0],a=arguments[1],u=arguments[2];u?this.addEdges(o,null):this.addEdges(o),this.computeIntersections(a)}},addEdge:function(t,e){for(var n=t.getMonotoneChainEdge(),i=n.getStartIndexes(),r=0;r<i.length-1;r++){var s=new _n(n,r),o=new Mn(e,n.getMinX(r),s);this.events.add(o),this.events.add(new Mn(n.getMaxX(r),o))}},processOverlaps:function(t,e,n,i){for(var r=n.getObject(),s=t;e>s;s++){var o=this.events.get(s);if(o.isInsert()){var a=o.getObject();n.isSameLabel(o)||(r.computeIntersections(a,i),this.nOverlaps++)}}},addEdges:function(){if(1===arguments.length)for(var t=arguments[0],e=t.iterator();e.hasNext();){var n=e.next();this.addEdge(n,n)}else if(2===arguments.length)for(var i=arguments[0],r=arguments[1],e=i.iterator();e.hasNext();){var n=e.next();this.addEdge(n,r)}},interfaces_:function(){return[]},getClass:function(){return Fn}}),e(Gn.prototype,{getMin:function(){return this.min},intersects:function(t,e){return!(this.min>e||this.max<t)},getMax:function(){return this.max},toString:function(){return se.toLineString(new g(this.min,0),new g(this.max,0))},interfaces_:function(){return[]},getClass:function(){return Gn}}),e(qn.prototype,{compare:function(t,e){var n=t,i=e,r=(n.min+n.max)/2,s=(i.min+i.max)/2;return s>r?-1:r>s?1:0},interfaces_:function(){return[a]},getClass:function(){return qn}}),Gn.NodeComparator=qn,h(Bn,Gn),e(Bn.prototype,{query:function(t,e,n){return this.intersects(t,e)?void n.visitItem(this.item):null},interfaces_:function(){return[]},getClass:function(){return Bn}}),h(zn,Gn),e(zn.prototype,{buildExtent:function(t,e){this.min=Math.min(t.min,e.min),this.max=Math.max(t.max,e.max)},query:function(t,e,n){return this.intersects(t,e)?(null!==this.node1&&this.node1.query(t,e,n),void(null!==this.node2&&this.node2.query(t,e,n))):null},interfaces_:function(){return[]},getClass:function(){return zn}}),e(Vn.prototype,{buildTree:function(){ho.sort(this.leaves,new IntervalRTreeNode.NodeComparator);for(var t=this.leaves,e=null,n=new I;;){if(this.buildLevel(t,n),1===n.size())return n.get(0);e=t,t=n,n=e}},insert:function(t,e,n){if(null!==this.root)throw new IllegalStateException("Index cannot be added to once it has been queried");this.leaves.add(new Bn(t,e,n))},query:function(t,e,n){this.init(),this.root.query(t,e,n)},buildRoot:function(){return null!==this.root?null:void(this.root=this.buildTree())},printNode:function(t){A.out.println(se.toLineString(new g(t.min,this.level),new g(t.max,this.level)))},init:function(){return null!==this.root?null:void this.buildRoot()},buildLevel:function(t,e){this.level++,e.clear();for(var n=0;n<t.size();n+=2){var i=t.get(n),r=n+1<t.size()?t.get(n):null;if(null===r)e.add(i);else{var s=new zn(t.get(n),t.get(n+1));e.add(s)}}},interfaces_:function(){return[]},getClass:function(){return Vn}}),e(kn.prototype,{filter:function(t){if(this.isForcedToLineString&&t instanceof bt){var e=t.getFactory().createLineString(t.getCoordinateSequence());return this.lines.add(e),null}t instanceof St&&this.lines.add(t)},setForceToLineString:function(t){this.isForcedToLineString=t},interfaces_:function(){return[q]},getClass:function(){return kn}}),kn.getGeometry=function(){if(1===arguments.length){var t=arguments[0];return t.getFactory().buildGeometry(kn.getLines(t))}if(2===arguments.length){var e=arguments[0],n=arguments[1];return e.getFactory().buildGeometry(kn.getLines(e,n))}},kn.getLines=function(){if(1===arguments.length){var t=arguments[0];return kn.getLines(t,!1)}if(2===arguments.length){if(R(arguments[0],v)&&R(arguments[1],v)){for(var e=arguments[0],n=arguments[1],i=e.iterator();i.hasNext();){var r=i.next();kn.getLines(r,n)}return n}if(arguments[0]instanceof B&&"boolean"==typeof arguments[1]){var s=arguments[0],o=arguments[1],a=new I;return s.apply(new kn(a,o)),a}if(arguments[0]instanceof B&&R(arguments[1],v)){var u=arguments[0],l=arguments[1];return u instanceof St?l.add(u):u.apply(new kn(l)),l}}else if(3===arguments.length){if("boolean"==typeof arguments[2]&&R(arguments[0],v)&&R(arguments[1],v)){for(var h=arguments[0],c=arguments[1],f=arguments[2],i=h.iterator();i.hasNext();){var r=i.next();kn.getLines(r,c,f)}return c}if("boolean"==typeof arguments[2]&&arguments[0]instanceof B&&R(arguments[1],v)){var g=arguments[0],d=arguments[1],p=arguments[2];return g.apply(new kn(d,p)),d}}},e(Yn.prototype,{visitItem:function(t){this.items.add(t)},getItems:function(){return this.items},interfaces_:function(){return[Ae]},getClass:function(){return Yn}}),e(Un.prototype,{locate:function(t){var e=new le(t),n=new Xn(e);return this.index.query(t.y,t.y,n),e.getLocation()},interfaces_:function(){return[Rn]},getClass:function(){return Un}}),e(Xn.prototype,{visitItem:function(t){var e=t;this.counter.countSegment(e.getCoordinate(0),e.getCoordinate(1))},interfaces_:function(){return[Ae]},getClass:function(){return Xn}}),e(Hn.prototype,{init:function(t){for(var e=kn.getLines(t),n=e.iterator();n.hasNext();){var i=n.next(),r=i.getCoordinates();this.addLine(r)}},addLine:function(t){for(var e=1;e<t.length;e++){var n=new ce(t[e-1],t[e]),i=Math.min(n.p0.y,n.p1.y),r=Math.max(n.p0.y,n.p1.y);this.index.insert(i,r,n)}},query:function(){if(2===arguments.length){var t=arguments[0],e=arguments[1],n=new Yn;return this.index.query(t,e,n),n.getItems()}if(3===arguments.length){var i=arguments[0],r=arguments[1],s=arguments[2];this.index.query(i,r,s)}},interfaces_:function(){return[]},getClass:function(){return Hn}}),Un.SegmentVisitor=Xn,Un.IntervalIndexedGeometry=Hn,e(Wn.prototype,{getSegmentIndex:function(){return this.segmentIndex},getCoordinate:function(){return this.coord},print:function(t){t.print(this.coord),t.print(" seg # = "+this.segmentIndex),t.println(" dist = "+this.dist)},compareTo:function(t){var e=t;return this.compare(e.segmentIndex,e.dist)},isEndPoint:function(t){return 0===this.segmentIndex&&0===this.dist?!0:this.segmentIndex===t},toString:function(){return this.coord+" seg # = "+this.segmentIndex+" dist = "+this.dist},getDistance:function(){return this.dist},compare:function(t,e){return this.segmentIndex<t?-1:this.segmentIndex>t?1:this.dist<e?-1:this.dist>e?1:0},interfaces_:function(){return[s]},getClass:function(){return Wn}}),e(jn.prototype,{print:function(t){t.println("Intersections:");for(var e=this.iterator();e.hasNext();){var n=e.next();n.print(t)}},iterator:function(){return this.nodeMap.values().iterator()},addSplitEdges:function(t){this.addEndpoints();for(var e=this.iterator(),n=e.next();e.hasNext();){var i=e.next(),r=this.createSplitEdge(n,i);t.add(r),n=i}},addEndpoints:function(){var t=this.edge.pts.length-1;this.add(this.edge.pts[0],0,0),this.add(this.edge.pts[t],t,0)},createSplitEdge:function(t,e){var n=e.segmentIndex-t.segmentIndex+2,i=this.edge.pts[e.segmentIndex],r=e.dist>0||!e.coord.equals2D(i);r||n--;var s=new Array(n).fill(null),o=0;s[o++]=new g(t.coord);for(var a=t.segmentIndex+1;a<=e.segmentIndex;a++)s[o++]=this.edge.pts[a];return r&&(s[o]=e.coord),new Jn(s,new gn(this.edge.label))},add:function(t,e,n){var i=new Wn(t,e,n),r=this.nodeMap.get(i);return null!==r?r:(this.nodeMap.put(i,i),i)},isIntersection:function(t){for(var e=this.iterator();e.hasNext();){var n=e.next();if(n.coord.equals(t))return!0}return!1},interfaces_:function(){return[]},getClass:function(){return jn}}),e(Kn.prototype,{getChainStartIndices:function(t){var e=0,n=new I;n.add(new b(e));do{var i=this.findChainEnd(t,e);n.add(new b(i)),e=i}while(e<t.length-1);var r=Kn.toIntArray(n);return r},findChainEnd:function(t,e){for(var n=Je.quadrant(t[e],t[e+1]),i=e+1;i<t.length;){var r=Je.quadrant(t[i-1],t[i]);if(r!==n)break;i++}return i-1},interfaces_:function(){return[]},getClass:function(){return Kn}}),Kn.toIntArray=function(t){for(var e=new Array(t.size()).fill(null),n=0;n<e.length;n++)e[n]=t.get(n).intValue();return e},e(Zn.prototype,{getCoordinates:function(){return this.pts},getMaxX:function(t){var e=this.pts[this.startIndex[t]].x,n=this.pts[this.startIndex[t+1]].x;return e>n?e:n},getMinX:function(t){var e=this.pts[this.startIndex[t]].x,n=this.pts[this.startIndex[t+1]].x;return n>e?e:n},computeIntersectsForChain:function(){if(4===arguments.length){var t=arguments[0],e=arguments[1],n=arguments[2],i=arguments[3];this.computeIntersectsForChain(this.startIndex[t],this.startIndex[t+1],e,e.startIndex[n],e.startIndex[n+1],i)}else if(6===arguments.length){var r=arguments[0],s=arguments[1],o=arguments[2],a=arguments[3],u=arguments[4],l=arguments[5],h=this.pts[r],c=this.pts[s],f=o.pts[a],g=o.pts[u];if(s-r===1&&u-a===1)return l.addIntersections(this.e,r,o.e,a),null;if(this.env1.init(h,c),this.env2.init(f,g),!this.env1.intersects(this.env2))return null;var d=Math.trunc((r+s)/2),p=Math.trunc((a+u)/2);d>r&&(p>a&&this.computeIntersectsForChain(r,d,o,a,p,l),u>p&&this.computeIntersectsForChain(r,d,o,p,u,l)),s>d&&(p>a&&this.computeIntersectsForChain(d,s,o,a,p,l),u>p&&this.computeIntersectsForChain(d,s,o,p,u,l))}},getStartIndexes:function(){return this.startIndex},computeIntersects:function(t,e){for(var n=0;n<this.startIndex.length-1;n++)for(var i=0;i<t.startIndex.length-1;i++)this.computeIntersectsForChain(n,t,i,e)},interfaces_:function(){return[]},getClass:function(){return Zn}}),e(Qn.prototype,{getDepth:function(t,e){return this.depth[t][e]},setDepth:function(t,e,n){this.depth[t][e]=n},isNull:function(){if(0===arguments.length){for(var t=0;2>t;t++)for(var e=0;3>e;e++)if(this.depth[t][e]!==Qn.NULL_VALUE)return!1;return!0}if(1===arguments.length){var n=arguments[0];return this.depth[n][1]===Qn.NULL_VALUE}if(2===arguments.length){var i=arguments[0],r=arguments[1];return this.depth[i][r]===Qn.NULL_VALUE}},normalize:function(){for(var t=0;2>t;t++)if(!this.isNull(t)){var e=this.depth[t][1];this.depth[t][2]<e&&(e=this.depth[t][2]),0>e&&(e=0);for(var n=1;3>n;n++){var i=0;this.depth[t][n]>e&&(i=1),this.depth[t][n]=i}}},getDelta:function(t){return this.depth[t][cn.RIGHT]-this.depth[t][cn.LEFT]},getLocation:function(t,e){return this.depth[t][e]<=0?L.EXTERIOR:L.INTERIOR},toString:function(){return"A: "+this.depth[0][1]+","+this.depth[0][2]+" B: "+this.depth[1][1]+","+this.depth[1][2]},add:function(){if(1===arguments.length)for(var t=arguments[0],e=0;2>e;e++)for(var n=1;3>n;n++){var i=t.getLocation(e,n);i!==L.EXTERIOR&&i!==L.INTERIOR||(this.isNull(e,n)?this.depth[e][n]=Qn.depthAtLocation(i):this.depth[e][n]+=Qn.depthAtLocation(i))}else if(3===arguments.length){var r=arguments[0],s=arguments[1],o=arguments[2];o===L.INTERIOR&&this.depth[r][s]++}},interfaces_:function(){return[]},getClass:function(){return Qn}}),Qn.depthAtLocation=function(t){return t===L.EXTERIOR?0:t===L.INTERIOR?1:Qn.NULL_VALUE},Qn.NULL_VALUE=-1,h(Jn,mn),e(Jn.prototype,{getDepth:function(){return this.depth},getCollapsedEdge:function(){var t=new Array(2).fill(null);t[0]=this.pts[0],t[1]=this.pts[1];var e=new Jn(t,gn.toLineLabel(this.label));return e},isIsolated:function(){return this._isIsolated},getCoordinates:function(){return this.pts},setIsolated:function(t){this._isIsolated=t},setName:function(t){this.name=t},equals:function(t){if(!(t instanceof Jn))return!1;var e=t;if(this.pts.length!==e.pts.length)return!1;for(var n=!0,i=!0,r=this.pts.length,s=0;s<this.pts.length;s++)if(this.pts[s].equals2D(e.pts[s])||(n=!1),this.pts[s].equals2D(e.pts[--r])||(i=!1),!n&&!i)return!1;return!0},getCoordinate:function(){if(0===arguments.length)return this.pts.length>0?this.pts[0]:null;if(1===arguments.length){var t=arguments[0];return this.pts[t]}},print:function(t){t.print("edge "+this.name+": "),t.print("LINESTRING (");for(var e=0;e<this.pts.length;e++)e>0&&t.print(","),t.print(this.pts[e].x+" "+this.pts[e].y);t.print(")  "+this.label+" "+this.depthDelta)},computeIM:function(t){Jn.updateIM(this.label,t)},isCollapsed:function(){return this.label.isArea()?3!==this.pts.length?!1:!!this.pts[0].equals(this.pts[2]):!1},isClosed:function(){return this.pts[0].equals(this.pts[this.pts.length-1])},getMaximumSegmentIndex:function(){return this.pts.length-1},getDepthDelta:function(){return this.depthDelta},getNumPoints:function(){return this.pts.length},printReverse:function(t){t.print("edge "+this.name+": ");for(var e=this.pts.length-1;e>=0;e--)t.print(this.pts[e]+" ");t.println("")},getMonotoneChainEdge:function(){return null===this.mce&&(this.mce=new Zn(this)),this.mce},getEnvelope:function(){if(null===this.env){this.env=new C;for(var t=0;t<this.pts.length;t++)this.env.expandToInclude(this.pts[t])}return this.env},addIntersection:function(t,e,n,i){var r=new g(t.getIntersection(i)),s=e,o=t.getEdgeDistance(n,i),a=s+1;if(a<this.pts.length){var u=this.pts[a];r.equals2D(u)&&(s=a,o=0)}this.eiList.add(r,s,o)},toString:function(){var t=new P;t.append("edge "+this.name+": "),t.append("LINESTRING (");for(var e=0;e<this.pts.length;e++)e>0&&t.append(","),t.append(this.pts[e].x+" "+this.pts[e].y);return t.append(")  "+this.label+" "+this.depthDelta),t.toString()},isPointwiseEqual:function(t){if(this.pts.length!==t.pts.length)return!1;for(var e=0;e<this.pts.length;e++)if(!this.pts[e].equals2D(t.pts[e]))return!1;return!0},setDepthDelta:function(t){this.depthDelta=t},getEdgeIntersectionList:function(){return this.eiList},addIntersections:function(t,e,n){for(var i=0;i<t.getIntersectionNum();i++)this.addIntersection(t,e,n,i)},interfaces_:function(){return[]},getClass:function(){return Jn}}),Jn.updateIM=function(){if(2!==arguments.length)return mn.prototype.updateIM.apply(this,arguments);var t=arguments[0],e=arguments[1];e.setAtLeastIfValid(t.getLocation(0,cn.ON),t.getLocation(1,cn.ON),1),t.isArea()&&(e.setAtLeastIfValid(t.getLocation(0,cn.LEFT),t.getLocation(1,cn.LEFT),2),e.setAtLeastIfValid(t.getLocation(0,cn.RIGHT),t.getLocation(1,cn.RIGHT),2))},h($n,Cn),e($n.prototype,{insertBoundaryPoint:function(t,e){var n=this.nodes.addNode(e),i=n.getLabel(),r=1,s=L.NONE;s=i.getLocation(t,cn.ON),s===L.BOUNDARY&&r++;var o=$n.determineBoundary(this.boundaryNodeRule,r);i.setLocation(t,o)},computeSelfNodes:function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];return this.computeSelfNodes(t,e,!1)}if(3===arguments.length){var n=arguments[0],i=arguments[1],r=arguments[2],s=new An(n,!0,!1);s.setIsDoneIfProperInt(r);var o=this.createEdgeSetIntersector(),a=this.parentGeom instanceof bt||this.parentGeom instanceof Tt||this.parentGeom instanceof Ot,u=i||!a;return o.computeIntersections(this.edges,s,u),this.addSelfIntersectionNodes(this.argIndex),s}},computeSplitEdges:function(t){for(var e=this.edges.iterator();e.hasNext();){var n=e.next();n.eiList.addSplitEdges(t)}},computeEdgeIntersections:function(t,e,n){var i=new An(e,n,!0);i.setBoundaryNodes(this.getBoundaryNodes(),t.getBoundaryNodes());var r=this.createEdgeSetIntersector();return r.computeIntersections(this.edges,t.edges,i),i},getGeometry:function(){return this.parentGeom},getBoundaryNodeRule:function(){return this.boundaryNodeRule},hasTooFewPoints:function(){return this._hasTooFewPoints},addPoint:function(){if(arguments[0]instanceof Lt){var t=arguments[0],e=t.getCoordinate();this.insertPoint(this.argIndex,e,L.INTERIOR)}else if(arguments[0]instanceof g){var n=arguments[0];this.insertPoint(this.argIndex,n,L.INTERIOR)}},addPolygon:function(t){this.addPolygonRing(t.getExteriorRing(),L.EXTERIOR,L.INTERIOR);for(var e=0;e<t.getNumInteriorRing();e++){var n=t.getInteriorRingN(e);this.addPolygonRing(n,L.INTERIOR,L.EXTERIOR)}},addEdge:function(t){this.insertEdge(t);var e=t.getCoordinates();this.insertPoint(this.argIndex,e[0],L.BOUNDARY),this.insertPoint(this.argIndex,e[e.length-1],L.BOUNDARY)},addLineString:function(t){var e=H.removeRepeatedPoints(t.getCoordinates());if(e.length<2)return this._hasTooFewPoints=!0,this.invalidPoint=e[0],null;var n=new Jn(e,new gn(this.argIndex,L.INTERIOR));this.lineEdgeMap.put(t,n),this.insertEdge(n),f.isTrue(e.length>=2,"found LineString with single point"),this.insertBoundaryPoint(this.argIndex,e[0]),this.insertBoundaryPoint(this.argIndex,e[e.length-1])},getInvalidPoint:function(){return this.invalidPoint},getBoundaryPoints:function(){for(var t=this.getBoundaryNodes(),e=new Array(t.size()).fill(null),n=0,i=t.iterator();i.hasNext();){var r=i.next();e[n++]=r.getCoordinate().copy()}return e},getBoundaryNodes:function(){return null===this.boundaryNodes&&(this.boundaryNodes=this.nodes.getBoundaryNodes(this.argIndex)),this.boundaryNodes},addSelfIntersectionNode:function(t,e,n){return this.isBoundaryNode(t,e)?null:void(n===L.BOUNDARY&&this.useBoundaryDeterminationRule?this.insertBoundaryPoint(t,e):this.insertPoint(t,e,n))},addPolygonRing:function(t,e,n){if(t.isEmpty())return null;var i=H.removeRepeatedPoints(t.getCoordinates());if(i.length<4)return this._hasTooFewPoints=!0,this.invalidPoint=i[0],null;var r=e,s=n;he.isCCW(i)&&(r=n,s=e);var o=new Jn(i,new gn(this.argIndex,L.BOUNDARY,r,s));this.lineEdgeMap.put(t,o),this.insertEdge(o),this.insertPoint(this.argIndex,i[0],L.BOUNDARY)},insertPoint:function(t,e,n){var i=this.nodes.addNode(e),r=i.getLabel();null===r?i.label=new gn(t,n):r.setLocation(t,n)},createEdgeSetIntersector:function(){return new Fn},addSelfIntersectionNodes:function(t){for(var e=this.edges.iterator();e.hasNext();)for(var n=e.next(),i=n.getLabel().getLocation(t),r=n.eiList.iterator();r.hasNext();){var s=r.next();this.addSelfIntersectionNode(t,s.coord,i)}},add:function(){if(1!==arguments.length)return Cn.prototype.add.apply(this,arguments);var t=arguments[0];if(t.isEmpty())return null;if(t instanceof Ot&&(this.useBoundaryDeterminationRule=!1),t instanceof Tt)this.addPolygon(t);else if(t instanceof St)this.addLineString(t);else if(t instanceof Lt)this.addPoint(t);else if(t instanceof Pt)this.addCollection(t);else if(t instanceof gt)this.addCollection(t);else if(t instanceof Ot)this.addCollection(t);else{if(!(t instanceof ft))throw new UnsupportedOperationException(t.getClass().getName());this.addCollection(t)}},addCollection:function(t){for(var e=0;e<t.getNumGeometries();e++){var n=t.getGeometryN(e);this.add(n)}},locate:function(t){return R(this.parentGeom,Rt)&&this.parentGeom.getNumGeometries()>50?(null===this.areaPtLocator&&(this.areaPtLocator=new Un(this.parentGeom)),this.areaPtLocator.locate(t)):this.ptLocator.locate(t,this.parentGeom)},findEdge:function(){if(1===arguments.length){var t=arguments[0];return this.lineEdgeMap.get(t)}return Cn.prototype.findEdge.apply(this,arguments)},interfaces_:function(){return[]},getClass:function(){return $n}}),$n.determineBoundary=function(t,e){return t.isInBoundary(e)?L.BOUNDARY:L.INTERIOR},e(ti.prototype,{getArgGeometry:function(t){return this.arg[t].getGeometry()},setComputationPrecision:function(t){this.resultPrecisionModel=t,this.li.setPrecisionModel(this.resultPrecisionModel)},interfaces_:function(){return[]},getClass:function(){return ti}}),e(ei.prototype,{compareTo:function(t){var e=t,n=ei.compareOriented(this.pts,this._orientation,e.pts,e._orientation);return n},interfaces_:function(){return[s]},getClass:function(){return ei}}),ei.orientation=function(t){return 1===H.increasingDirection(t)},ei.compareOriented=function(t,e,n,i){for(var r=e?1:-1,s=i?1:-1,o=e?t.length:-1,a=i?n.length:-1,u=e?0:t.length-1,l=i?0:n.length-1;;){var h=t[u].compareTo(n[l]);if(0!==h)return h;u+=r,l+=s;var c=u===o,f=l===a;if(c&&!f)return-1;if(!c&&f)return 1;if(c&&f)return 0}},e(ni.prototype,{print:function(t){t.print("MULTILINESTRING ( ");for(var e=0;e<this.edges.size();e++){var n=this.edges.get(e);e>0&&t.print(","),t.print("(");for(var i=n.getCoordinates(),r=0;r<i.length;r++)r>0&&t.print(","),t.print(i[r].x+" "+i[r].y);t.println(")")}t.print(")  ")},addAll:function(t){for(var e=t.iterator();e.hasNext();)this.add(e.next())},findEdgeIndex:function(t){for(var e=0;e<this.edges.size();e++)if(this.edges.get(e).equals(t))return e;return-1},iterator:function(){return this.edges.iterator()},getEdges:function(){return this.edges},get:function(t){return this.edges.get(t)},findEqualEdge:function(t){var e=new ei(t.getCoordinates()),n=this.ocaMap.get(e);return n},add:function(t){this.edges.add(t);var e=new ei(t.getCoordinates());this.ocaMap.put(e,t)},interfaces_:function(){return[]},getClass:function(){return ni}}),h(ii,ti),e(ii.prototype,{insertUniqueEdge:function(t){var e=this.edgeList.findEqualEdge(t);if(null!==e){var n=e.getLabel(),i=t.getLabel();e.isPointwiseEqual(t)||(i=new gn(t.getLabel()),i.flip());var r=e.getDepth();r.isNull()&&r.add(n),r.add(i),n.merge(i)}else this.edgeList.add(t)},getGraph:function(){return this.graph},cancelDuplicateResultEdges:function(){for(var t=this.graph.getEdgeEnds().iterator();t.hasNext();){var e=t.next(),n=e.getSym();e.isInResult()&&n.isInResult()&&(e.setInResult(!1),n.setInResult(!1))}},isCoveredByLA:function(t){return this.isCovered(t,this.resultLineList)?!0:!!this.isCovered(t,this.resultPolyList)},computeGeometry:function(t,e,n,i){var r=new I;return r.addAll(t),r.addAll(e),r.addAll(n),r.isEmpty()?ii.createEmptyResult(i,this.arg[0].getGeometry(),this.arg[1].getGeometry(),this.geomFact):this.geomFact.buildGeometry(r)},mergeSymLabels:function(){for(var t=this.graph.getNodes().iterator();t.hasNext();){var e=t.next();e.getEdges().mergeSymLabels()}},isCovered:function(t,e){for(var n=e.iterator();n.hasNext();){var i=n.next(),r=this.ptLocator.locate(t,i);if(r!==L.EXTERIOR)return!0}return!1},replaceCollapsedEdges:function(){for(var t=new I,e=this.edgeList.iterator();e.hasNext();){var n=e.next();n.isCollapsed()&&(e.remove(),t.add(n.getCollapsedEdge()))}this.edgeList.addAll(t)},updateNodeLabelling:function(){for(var t=this.graph.getNodes().iterator();t.hasNext();){var e=t.next(),n=e.getEdges().getLabel();e.getLabel().merge(n)}},getResultGeometry:function(t){return this.computeOverlay(t),this.resultGeom},insertUniqueEdges:function(t){for(var e=t.iterator();e.hasNext();){var n=e.next();this.insertUniqueEdge(n)}},computeOverlay:function(t){this.copyPoints(0),this.copyPoints(1),this.arg[0].computeSelfNodes(this.li,!1),this.arg[1].computeSelfNodes(this.li,!1),this.arg[0].computeEdgeIntersections(this.arg[1],this.li,!0);var e=new I;this.arg[0].computeSplitEdges(e),this.arg[1].computeSplitEdges(e);this.insertUniqueEdges(e),this.computeLabelsFromDepths(),this.replaceCollapsedEdges(),ln.checkValid(this.edgeList.getEdges()),this.graph.addEdges(this.edgeList.getEdges()),this.computeLabelling(),this.labelIncompleteNodes(),this.findResultAreaEdges(t),this.cancelDuplicateResultEdges();var n=new Sn(this.geomFact);n.add(this.graph),this.resultPolyList=n.getPolygons();var i=new wn(this,this.geomFact,this.ptLocator);this.resultLineList=i.build(t);var r=new Ln(this,this.geomFact,this.ptLocator);this.resultPointList=r.build(t),
	this.resultGeom=this.computeGeometry(this.resultPointList,this.resultLineList,this.resultPolyList,t)},labelIncompleteNode:function(t,e){var n=this.ptLocator.locate(t.getCoordinate(),this.arg[e].getGeometry());t.getLabel().setLocation(e,n)},copyPoints:function(t){for(var e=this.arg[t].getNodeIterator();e.hasNext();){var n=e.next(),i=this.graph.addNode(n.getCoordinate());i.setLabel(t,n.getLabel().getLocation(t))}},findResultAreaEdges:function(t){for(var e=this.graph.getEdgeEnds().iterator();e.hasNext();){var n=e.next(),i=n.getLabel();i.isArea()&&!n.isInteriorAreaEdge()&&ii.isResultOfOp(i.getLocation(0,cn.RIGHT),i.getLocation(1,cn.RIGHT),t)&&n.setInResult(!0)}},computeLabelsFromDepths:function(){for(var t=this.edgeList.iterator();t.hasNext();){var e=t.next(),n=e.getLabel(),i=e.getDepth();if(!i.isNull()){i.normalize();for(var r=0;2>r;r++)n.isNull(r)||!n.isArea()||i.isNull(r)||(0===i.getDelta(r)?n.toLine(r):(f.isTrue(!i.isNull(r,cn.LEFT),"depth of LEFT side has not been initialized"),n.setLocation(r,cn.LEFT,i.getLocation(r,cn.LEFT)),f.isTrue(!i.isNull(r,cn.RIGHT),"depth of RIGHT side has not been initialized"),n.setLocation(r,cn.RIGHT,i.getLocation(r,cn.RIGHT))))}}},computeLabelling:function(){for(var t=this.graph.getNodes().iterator();t.hasNext();){var e=t.next();e.getEdges().computeLabelling(this.arg)}this.mergeSymLabels(),this.updateNodeLabelling()},labelIncompleteNodes:function(){for(var t=0,e=this.graph.getNodes().iterator();e.hasNext();){var n=e.next(),i=n.getLabel();n.isIsolated()&&(t++,i.isNull(0)?this.labelIncompleteNode(n,0):this.labelIncompleteNode(n,1)),n.getEdges().updateLabelling(i)}},isCoveredByA:function(t){return!!this.isCovered(t,this.resultPolyList)},interfaces_:function(){return[]},getClass:function(){return ii}}),ii.overlayOp=function(t,e,n){var i=new ii(t,e),r=i.getResultGeometry(n);return r},ii.intersection=function(t,e){if(t.isEmpty()||e.isEmpty())return ii.createEmptyResult(ii.INTERSECTION,t,e,t.getFactory());if(t.isGeometryCollection()){var n=e;return hn.map(t,{interfaces_:function(){return[MapOp]},map:function(t){return t.intersection(n)}})}return t.checkNotGeometryCollection(t),t.checkNotGeometryCollection(e),si.overlayOp(t,e,ii.INTERSECTION)},ii.symDifference=function(t,e){if(t.isEmpty()||e.isEmpty()){if(t.isEmpty()&&e.isEmpty())return ii.createEmptyResult(ii.SYMDIFFERENCE,t,e,t.getFactory());if(t.isEmpty())return e.copy();if(e.isEmpty())return t.copy()}return t.checkNotGeometryCollection(t),t.checkNotGeometryCollection(e),si.overlayOp(t,e,ii.SYMDIFFERENCE)},ii.resultDimension=function(t,e,n){var i=e.getDimension(),r=n.getDimension(),s=-1;switch(t){case ii.INTERSECTION:s=Math.min(i,r);break;case ii.UNION:s=Math.max(i,r);break;case ii.DIFFERENCE:s=i;break;case ii.SYMDIFFERENCE:s=Math.max(i,r)}return s},ii.createEmptyResult=function(t,e,n,i){var r=null;switch(ii.resultDimension(t,e,n)){case-1:r=i.createGeometryCollection(new Array(0).fill(null));break;case 0:r=i.createPoint();break;case 1:r=i.createLineString();break;case 2:r=i.createPolygon()}return r},ii.difference=function(t,e){return t.isEmpty()?ii.createEmptyResult(ii.DIFFERENCE,t,e,t.getFactory()):e.isEmpty()?t.copy():(t.checkNotGeometryCollection(t),t.checkNotGeometryCollection(e),si.overlayOp(t,e,ii.DIFFERENCE))},ii.isResultOfOp=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1],n=t.getLocation(0),i=t.getLocation(1);return ii.isResultOfOp(n,i,e)}if(3===arguments.length){var r=arguments[0],s=arguments[1],o=arguments[2];switch(r===L.BOUNDARY&&(r=L.INTERIOR),s===L.BOUNDARY&&(s=L.INTERIOR),o){case ii.INTERSECTION:return r===L.INTERIOR&&s===L.INTERIOR;case ii.UNION:return r===L.INTERIOR||s===L.INTERIOR;case ii.DIFFERENCE:return r===L.INTERIOR&&s!==L.INTERIOR;case ii.SYMDIFFERENCE:return r===L.INTERIOR&&s!==L.INTERIOR||r!==L.INTERIOR&&s===L.INTERIOR}return!1}},ii.INTERSECTION=1,ii.UNION=2,ii.DIFFERENCE=3,ii.SYMDIFFERENCE=4,e(ri.prototype,{selfSnap:function(t){var e=new Ie(t),n=e.snapTo(t,this.snapTolerance);return n},removeCommonBits:function(t){this.cbr=new Se,this.cbr.add(t[0]),this.cbr.add(t[1]);var e=new Array(2).fill(null);return e[0]=this.cbr.removeCommonBits(t[0].copy()),e[1]=this.cbr.removeCommonBits(t[1].copy()),e},prepareResult:function(t){return this.cbr.addCommonBits(t),t},getResultGeometry:function(t){var e=this.snap(this.geom),n=ii.overlayOp(e[0],e[1],t);return this.prepareResult(n)},checkValid:function(t){t.isValid()||A.out.println("Snapped geometry is invalid")},computeSnapTolerance:function(){this.snapTolerance=Ie.computeOverlaySnapTolerance(this.geom[0],this.geom[1])},snap:function(t){var e=this.removeCommonBits(t),n=Ie.snap(e[0],e[1],this.snapTolerance);return n},interfaces_:function(){return[]},getClass:function(){return ri}}),ri.overlayOp=function(t,e,n){var i=new ri(t,e);return i.getResultGeometry(n)},ri.union=function(t,e){return ri.overlayOp(t,e,ii.UNION)},ri.intersection=function(t,e){return ri.overlayOp(t,e,ii.INTERSECTION)},ri.symDifference=function(t,e){return ri.overlayOp(t,e,ii.SYMDIFFERENCE)},ri.difference=function(t,e){return ri.overlayOp(t,e,ii.DIFFERENCE)},e(si.prototype,{getResultGeometry:function(t){var e=null,n=!1,i=null;try{e=ii.overlayOp(this.geom[0],this.geom[1],t);var r=!0;r&&(n=!0)}catch(t){if(!(t instanceof l))throw t;i=t}finally{}if(!n)try{e=ri.overlayOp(this.geom[0],this.geom[1],t)}catch(t){throw t instanceof l?i:t}finally{}return e},interfaces_:function(){return[]},getClass:function(){return si}}),si.overlayOp=function(t,e,n){var i=new si(t,e);return i.getResultGeometry(n)},si.union=function(t,e){return si.overlayOp(t,e,ii.UNION)},si.intersection=function(t,e){return si.overlayOp(t,e,ii.INTERSECTION)},si.symDifference=function(t,e){return si.overlayOp(t,e,ii.SYMDIFFERENCE)},si.difference=function(t,e){return si.overlayOp(t,e,ii.DIFFERENCE)},e(oi.prototype,{addPolygon:function(t){if(t.isEmpty())return null;var e=null,n=0,i=this.horizontalBisector(t);if(0===i.getLength())n=0,e=i.getCoordinate();else{var r=si.overlayOp(i,t,ii.INTERSECTION),s=this.widestGeometry(r);n=s.getEnvelopeInternal().getWidth(),e=oi.centre(s.getEnvelopeInternal())}(null===this.interiorPoint||n>this.maxWidth)&&(this.interiorPoint=e,this.maxWidth=n)},getInteriorPoint:function(){return this.interiorPoint},widestGeometry:function t(){if(arguments[0]instanceof ft){var e=arguments[0];if(e.isEmpty())return e;for(var t=e.getGeometryN(0),n=1;n<e.getNumGeometries();n++)e.getGeometryN(n).getEnvelopeInternal().getWidth()>t.getEnvelopeInternal().getWidth()&&(t=e.getGeometryN(n));return t}if(arguments[0]instanceof B){var i=arguments[0];return i instanceof ft?this.widestGeometry(i):i}},horizontalBisector:function(t){var e=t.getEnvelopeInternal(),n=ai.getBisectorY(t);return this.factory.createLineString([new g(e.getMinX(),n),new g(e.getMaxX(),n)])},add:function(t){if(t instanceof Tt)this.addPolygon(t);else if(t instanceof ft)for(var e=t,n=0;n<e.getNumGeometries();n++)this.add(e.getGeometryN(n))},interfaces_:function(){return[]},getClass:function(){return oi}}),oi.centre=function(t){return new g(oi.avg(t.getMinX(),t.getMaxX()),oi.avg(t.getMinY(),t.getMaxY()))},oi.avg=function(t,e){return(t+e)/2},e(ai.prototype,{updateInterval:function(t){t<=this.centreY?t>this.loY&&(this.loY=t):t>this.centreY&&t<this.hiY&&(this.hiY=t)},getBisectorY:function(){this.process(this.poly.getExteriorRing());for(var t=0;t<this.poly.getNumInteriorRing();t++)this.process(this.poly.getInteriorRingN(t));var e=oi.avg(this.hiY,this.loY);return e},process:function(t){for(var e=t.getCoordinateSequence(),n=0;n<e.size();n++){var i=e.getY(n);this.updateInterval(i)}},interfaces_:function(){return[]},getClass:function(){return ai}}),ai.getBisectorY=function(t){var e=new ai(t);return e.getBisectorY()},oi.SafeBisectorFinder=ai,e(ui.prototype,{addEndpoints:function(){if(arguments[0]instanceof B){var t=arguments[0];if(t instanceof St)this.addEndpoints(t.getCoordinates());else if(t instanceof ft)for(var e=t,n=0;n<e.getNumGeometries();n++)this.addEndpoints(e.getGeometryN(n))}else if(arguments[0]instanceof Array){var i=arguments[0];this.add(i[0]),this.add(i[i.length-1])}},getInteriorPoint:function(){return this.interiorPoint},addInterior:function(){if(arguments[0]instanceof B){var t=arguments[0];if(t instanceof St)this.addInterior(t.getCoordinates());else if(t instanceof ft)for(var e=t,n=0;n<e.getNumGeometries();n++)this.addInterior(e.getGeometryN(n))}else if(arguments[0]instanceof Array)for(var i=arguments[0],n=1;n<i.length-1;n++)this.add(i[n])},add:function(t){var e=t.distance(this.centroid);e<this.minDistance&&(this.interiorPoint=new g(t),this.minDistance=e)},interfaces_:function(){return[]},getClass:function(){return ui}}),e(li.prototype,{getInteriorPoint:function(){return this.interiorPoint},add:function(){if(arguments[0]instanceof B){var t=arguments[0];if(t instanceof Lt)this.add(t.getCoordinate());else if(t instanceof ft)for(var e=t,n=0;n<e.getNumGeometries();n++)this.add(e.getGeometryN(n))}else if(arguments[0]instanceof g){var i=arguments[0],r=i.distance(this.centroid);r<this.minDistance&&(this.interiorPoint=new g(i),this.minDistance=r)}},interfaces_:function(){return[]},getClass:function(){return li}}),e(hi.prototype,{interfaces_:function(){return[]},getClass:function(){return hi}}),hi.toDegrees=function(t){return 180*t/Math.PI},hi.normalize=function(t){for(;t>Math.PI;)t-=hi.PI_TIMES_2;for(;t<=-Math.PI;)t+=hi.PI_TIMES_2;return t},hi.angle=function(){if(1===arguments.length){var t=arguments[0];return Math.atan2(t.y,t.x)}if(2===arguments.length){var e=arguments[0],n=arguments[1],i=n.x-e.x,r=n.y-e.y;return Math.atan2(r,i)}},hi.isAcute=function(t,e,n){var i=t.x-e.x,r=t.y-e.y,s=n.x-e.x,o=n.y-e.y,a=i*s+r*o;return a>0},hi.isObtuse=function(t,e,n){var i=t.x-e.x,r=t.y-e.y,s=n.x-e.x,o=n.y-e.y,a=i*s+r*o;return 0>a},hi.interiorAngle=function(t,e,n){var i=hi.angle(e,t),r=hi.angle(e,n);return Math.abs(r-i)},hi.normalizePositive=function(t){if(0>t){for(;0>t;)t+=hi.PI_TIMES_2;t>=hi.PI_TIMES_2&&(t=0)}else{for(;t>=hi.PI_TIMES_2;)t-=hi.PI_TIMES_2;0>t&&(t=0)}return t},hi.angleBetween=function(t,e,n){var i=hi.angle(e,t),r=hi.angle(e,n);return hi.diff(i,r)},hi.diff=function(t,e){var n=null;return n=e>t?e-t:t-e,n>Math.PI&&(n=2*Math.PI-n),n},hi.toRadians=function(t){return t*Math.PI/180},hi.getTurn=function(t,e){var n=Math.sin(e-t);return n>0?hi.COUNTERCLOCKWISE:0>n?hi.CLOCKWISE:hi.NONE},hi.angleBetweenOriented=function(t,e,n){var i=hi.angle(e,t),r=hi.angle(e,n),s=r-i;return s<=-Math.PI?s+hi.PI_TIMES_2:s>Math.PI?s-hi.PI_TIMES_2:s},hi.PI_TIMES_2=2*Math.PI,hi.PI_OVER_2=Math.PI/2,hi.PI_OVER_4=Math.PI/4,hi.COUNTERCLOCKWISE=he.COUNTERCLOCKWISE,hi.CLOCKWISE=he.CLOCKWISE,hi.NONE=he.COLLINEAR,e(ci.prototype,{area:function(){return ci.area(this.p0,this.p1,this.p2)},signedArea:function(){return ci.signedArea(this.p0,this.p1,this.p2)},interpolateZ:function(t){if(null===t)throw new i("Supplied point is null.");return ci.interpolateZ(t,this.p0,this.p1,this.p2)},longestSideLength:function(){return ci.longestSideLength(this.p0,this.p1,this.p2)},isAcute:function(){return ci.isAcute(this.p0,this.p1,this.p2)},circumcentre:function(){return ci.circumcentre(this.p0,this.p1,this.p2)},area3D:function(){return ci.area3D(this.p0,this.p1,this.p2)},centroid:function(){return ci.centroid(this.p0,this.p1,this.p2)},inCentre:function(){return ci.inCentre(this.p0,this.p1,this.p2)},interfaces_:function(){return[]},getClass:function(){return ci}}),ci.area=function(t,e,n){return Math.abs(((n.x-t.x)*(e.y-t.y)-(e.x-t.x)*(n.y-t.y))/2)},ci.signedArea=function(t,e,n){return((n.x-t.x)*(e.y-t.y)-(e.x-t.x)*(n.y-t.y))/2},ci.det=function(t,e,n,i){return t*i-e*n},ci.interpolateZ=function(t,e,n,i){var r=e.x,s=e.y,o=n.x-r,a=i.x-r,u=n.y-s,l=i.y-s,h=o*l-a*u,c=t.x-r,f=t.y-s,g=(l*c-a*f)/h,d=(-u*c+o*f)/h,p=e.z+g*(n.z-e.z)+d*(i.z-e.z);return p},ci.longestSideLength=function(t,e,n){var i=t.distance(e),r=e.distance(n),s=n.distance(t),o=i;return r>o&&(o=r),s>o&&(o=s),o},ci.isAcute=function(t,e,n){return hi.isAcute(t,e,n)&&hi.isAcute(e,n,t)?!!hi.isAcute(n,t,e):!1},ci.circumcentre=function(t,e,n){var i=n.x,r=n.y,s=t.x-i,o=t.y-r,a=e.x-i,u=e.y-r,l=2*ci.det(s,o,a,u),h=ci.det(o,s*s+o*o,u,a*a+u*u),c=ci.det(s,s*s+o*o,a,a*a+u*u),f=i-h/l,d=r+c/l;return new g(f,d)},ci.perpendicularBisector=function(t,e){var n=e.x-t.x,i=e.y-t.y,r=new F(t.x+n/2,t.y+i/2,1),s=new F(t.x-i+n/2,t.y+n+i/2,1);return new F(r,s)},ci.angleBisector=function(t,e,n){var i=e.distance(t),r=e.distance(n),s=i/(i+r),o=n.x-t.x,a=n.y-t.y,u=new g(t.x+s*o,t.y+s*a);return u},ci.area3D=function(t,e,n){var i=e.x-t.x,r=e.y-t.y,s=e.z-t.z,o=n.x-t.x,a=n.y-t.y,u=n.z-t.z,l=r*u-s*a,h=s*o-i*u,c=i*a-r*o,f=l*l+h*h+c*c,g=Math.sqrt(f)/2;return g},ci.centroid=function(t,e,n){var i=(t.x+e.x+n.x)/3,r=(t.y+e.y+n.y)/3;return new g(i,r)},ci.inCentre=function(t,e,n){var i=e.distance(n),r=t.distance(n),s=t.distance(e),o=i+r+s,a=(i*t.x+r*e.x+s*n.x)/o,u=(i*t.y+r*e.y+s*n.y)/o;return new g(a,u)},e(fi.prototype,{getRadius:function(){return this.compute(),this.radius},getDiameter:function(){switch(this.compute(),this.extremalPts.length){case 0:return this.input.getFactory().createLineString();case 1:return this.input.getFactory().createPoint(this.centre)}var t=this.extremalPts[0],e=this.extremalPts[1];return this.input.getFactory().createLineString([t,e])},getExtremalPoints:function(){return this.compute(),this.extremalPts},computeCirclePoints:function(){if(this.input.isEmpty())return this.extremalPts=new Array(0).fill(null),null;if(1===this.input.getNumPoints()){var t=this.input.getCoordinates();return this.extremalPts=[new g(t[0])],null}var e=this.input.convexHull(),n=e.getCoordinates(),t=n;if(n[0].equals2D(n[n.length-1])&&(t=new Array(n.length-1).fill(null),H.copyDeep(n,0,t,0,n.length-1)),t.length<=2)return this.extremalPts=H.copyDeep(t),null;for(var i=fi.lowestPoint(t),r=fi.pointWitMinAngleWithX(t,i),s=0;s<t.length;s++){var o=fi.pointWithMinAngleWithSegment(t,i,r);if(hi.isObtuse(i,o,r))return this.extremalPts=[new g(i),new g(r)],null;if(hi.isObtuse(o,i,r))i=o;else{if(!hi.isObtuse(o,r,i))return this.extremalPts=[new g(i),new g(r),new g(o)],null;r=o}}f.shouldNeverReachHere("Logic failure in Minimum Bounding Circle algorithm!")},compute:function(){return null!==this.extremalPts?null:(this.computeCirclePoints(),this.computeCentre(),void(null!==this.centre&&(this.radius=this.centre.distance(this.extremalPts[0]))))},getFarthestPoints:function(){switch(this.compute(),this.extremalPts.length){case 0:return this.input.getFactory().createLineString();case 1:return this.input.getFactory().createPoint(this.centre)}var t=this.extremalPts[0],e=this.extremalPts[this.extremalPts.length-1];return this.input.getFactory().createLineString([t,e])},getCircle:function(){if(this.compute(),null===this.centre)return this.input.getFactory().createPolygon();var t=this.input.getFactory().createPoint(this.centre);return 0===this.radius?t:t.buffer(this.radius)},getCentre:function(){return this.compute(),this.centre},computeCentre:function(){switch(this.extremalPts.length){case 0:this.centre=null;break;case 1:this.centre=this.extremalPts[0];break;case 2:this.centre=new g((this.extremalPts[0].x+this.extremalPts[1].x)/2,(this.extremalPts[0].y+this.extremalPts[1].y)/2);break;case 3:this.centre=ci.circumcentre(this.extremalPts[0],this.extremalPts[1],this.extremalPts[2])}},interfaces_:function(){return[]},getClass:function(){return fi}}),fi.pointWitMinAngleWithX=function(t,e){for(var n=r.MAX_VALUE,i=null,s=0;s<t.length;s++){var o=t[s];if(o!==e){var a=o.x-e.x,u=o.y-e.y;0>u&&(u=-u);var l=Math.sqrt(a*a+u*u),h=u/l;n>h&&(n=h,i=o)}}return i},fi.lowestPoint=function(t){for(var e=t[0],n=1;n<t.length;n++)t[n].y<e.y&&(e=t[n]);return e},fi.pointWithMinAngleWithSegment=function(t,e,n){for(var i=r.MAX_VALUE,s=null,o=0;o<t.length;o++){var a=t[o];if(a!==e&&a!==n){var u=hi.angleBetween(e,a,n);i>u&&(i=u,s=a)}}return s},e(gi.prototype,{getWidthCoordinate:function(){return this.computeMinimumDiameter(),this.minWidthPt},getSupportingSegment:function(){return this.computeMinimumDiameter(),this.inputGeom.getFactory().createLineString([this.minBaseSeg.p0,this.minBaseSeg.p1])},getDiameter:function(){if(this.computeMinimumDiameter(),null===this.minWidthPt)return this.inputGeom.getFactory().createLineString(null);var t=this.minBaseSeg.project(this.minWidthPt);return this.inputGeom.getFactory().createLineString([t,this.minWidthPt])},computeWidthConvex:function(t){t instanceof Tt?this.convexHullPts=t.getExteriorRing().getCoordinates():this.convexHullPts=t.getCoordinates(),0===this.convexHullPts.length?(this.minWidth=0,this.minWidthPt=null,this.minBaseSeg=null):1===this.convexHullPts.length?(this.minWidth=0,this.minWidthPt=this.convexHullPts[0],this.minBaseSeg.p0=this.convexHullPts[0],this.minBaseSeg.p1=this.convexHullPts[0]):2===this.convexHullPts.length||3===this.convexHullPts.length?(this.minWidth=0,this.minWidthPt=this.convexHullPts[0],this.minBaseSeg.p0=this.convexHullPts[0],this.minBaseSeg.p1=this.convexHullPts[1]):this.computeConvexRingMinDiameter(this.convexHullPts)},computeConvexRingMinDiameter:function(t){this.minWidth=r.MAX_VALUE;for(var e=1,n=new ce,i=0;i<t.length-1;i++)n.p0=t[i],n.p1=t[i+1],e=this.findMaxPerpDistance(t,n,e)},computeMinimumDiameter:function(){if(null!==this.minWidthPt)return null;if(this.isConvex)this.computeWidthConvex(this.inputGeom);else{var t=new me(this.inputGeom).getConvexHull();this.computeWidthConvex(t)}},getLength:function(){return this.computeMinimumDiameter(),this.minWidth},findMaxPerpDistance:function(t,e,n){for(var i=e.distancePerpendicular(t[n]),r=i,s=n,o=s;r>=i;)i=r,s=o,o=gi.nextIndex(t,s),r=e.distancePerpendicular(t[o]);return i<this.minWidth&&(this.minPtIndex=s,this.minWidth=i,this.minWidthPt=t[this.minPtIndex],this.minBaseSeg=new ce(e)),s},getMinimumRectangle:function(){if(this.computeMinimumDiameter(),0===this.minWidth)return this.minBaseSeg.p0.equals2D(this.minBaseSeg.p1)?this.inputGeom.getFactory().createPoint(this.minBaseSeg.p0):this.minBaseSeg.toGeometry(this.inputGeom.getFactory());for(var t=this.minBaseSeg.p1.x-this.minBaseSeg.p0.x,e=this.minBaseSeg.p1.y-this.minBaseSeg.p0.y,n=r.MAX_VALUE,i=-r.MAX_VALUE,s=r.MAX_VALUE,o=-r.MAX_VALUE,a=0;a<this.convexHullPts.length;a++){var u=gi.computeC(t,e,this.convexHullPts[a]);u>i&&(i=u),n>u&&(n=u);var l=gi.computeC(-e,t,this.convexHullPts[a]);l>o&&(o=l),s>l&&(s=l)}var h=gi.computeSegmentForLine(-t,-e,o),c=gi.computeSegmentForLine(-t,-e,s),f=gi.computeSegmentForLine(-e,t,i),g=gi.computeSegmentForLine(-e,t,n),d=f.lineIntersection(h),p=g.lineIntersection(h),v=g.lineIntersection(c),m=f.lineIntersection(c),y=this.inputGeom.getFactory().createLinearRing([d,p,v,m,d]);return this.inputGeom.getFactory().createPolygon(y,null)},interfaces_:function(){return[]},getClass:function(){return gi}}),gi.nextIndex=function(t,e){return e++,e>=t.length&&(e=0),e},gi.computeC=function(t,e,n){return t*n.y-e*n.x},gi.getMinimumDiameter=function(t){return new gi(t).getDiameter()},gi.getMinimumRectangle=function(t){return new gi(t).getMinimumRectangle()},gi.computeSegmentForLine=function(t,e,n){var i=null,r=null;return Math.abs(e)>Math.abs(t)?(i=new g(0,n/e),r=new g(1,n/e-t/e)):(i=new g(n/t,0),r=new g(n/t-e/t,1)),new ce(i,r)};var co=Object.freeze({Centroid:ge,CGAlgorithms:he,ConvexHull:me,InteriorPointArea:oi,InteriorPointLine:ui,InteriorPointPoint:li,RobustLineIntersector:ae,MinimumBoundingCircle:fi,MinimumDiameter:gi});e(di.prototype,{getResultGeometry:function(){return new pi(this.distanceTolerance).transform(this.inputGeom)},setDistanceTolerance:function(t){if(0>=t)throw new i("Tolerance must be positive");this.distanceTolerance=t},interfaces_:function(){return[]},getClass:function(){return di}}),di.densifyPoints=function(t,e,n){for(var i=new ce,r=new N,s=0;s<t.length-1;s++){i.p0=t[s],i.p1=t[s+1],r.add(i.p0,!1);var o=i.getLength(),a=Math.trunc(o/e)+1;if(a>1)for(var u=o/a,l=1;a>l;l++){var h=l*u/o,c=i.pointAlong(h);n.makePrecise(c),r.add(c,!1)}}return r.add(t[t.length-1],!1),r.toCoordinateArray()},di.densify=function(t,e){var n=new di(t);return n.setDistanceTolerance(e),n.getResultGeometry()},h(pi,xe),e(pi.prototype,{transformMultiPolygon:function(t,e){var n=xe.prototype.transformMultiPolygon.call(this,t,e);return this.createValidArea(n)},transformPolygon:function(t,e){var n=xe.prototype.transformPolygon.call(this,t,e);return e instanceof Ot?n:this.createValidArea(n)},transformCoordinates:function(t,e){var n=t.toCoordinateArray(),i=di.densifyPoints(n,this.distanceTolerance,e.getPrecisionModel());return e instanceof St&&1===i.length&&(i=new Array(0).fill(null)),this.factory.getCoordinateSequenceFactory().create(i)},createValidArea:function(t){return t.buffer(0)},interfaces_:function(){return[]},getClass:function(){return pi}}),di.DensifyTransformer=pi;var fo=Object.freeze({Densifier:di});e(vi.prototype,{find:function(t){var e=this;do{if(null===e)return null;if(e.dest().equals2D(t))return e;e=e.oNext()}while(e!==this);return null},dest:function(){return this._sym._orig},oNext:function(){return this._sym._next},insert:function(t){if(this.oNext()===this)return this.insertAfter(t),null;var e=this.compareTo(t),n=this;do{var i=n.oNext(),r=i.compareTo(t);if(r!==e||i===this)return n.insertAfter(t),null;n=i}while(n!==this);f.shouldNeverReachHere()},insertAfter:function(t){f.equals(this._orig,t.orig());var e=this.oNext();this._sym.setNext(t),t.sym().setNext(e)},degree:function t(){var t=0,e=this;do t++,e=e.oNext();while(e!==this);return t},equals:function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];return this._orig.equals2D(t)&&this._sym._orig.equals(e)}},deltaY:function(){return this._sym._orig.y-this._orig.y},sym:function(){return this._sym},prev:function(){return this._sym.next()._sym},compareAngularDirection:function(t){var e=this.deltaX(),n=this.deltaY(),i=t.deltaX(),r=t.deltaY();if(e===i&&n===r)return 0;var s=Je.quadrant(e,n),o=Je.quadrant(i,r);return s>o?1:o>s?-1:he.computeOrientation(t._orig,t.dest(),this.dest())},prevNode:function(){for(var t=this;2===t.degree();)if(t=t.prev(),t===this)return null;return t},compareTo:function(t){var e=t,n=this.compareAngularDirection(e);return n},next:function(){return this._next},setSym:function(t){this._sym=t},orig:function(){return this._orig},toString:function(){return"HE("+this._orig.x+" "+this._orig.y+", "+this._sym._orig.x+" "+this._sym._orig.y+")"},setNext:function(t){this._next=t},init:function(t){this.setSym(t),t.setSym(this),this.setNext(t),t.setNext(this)},deltaX:function(){return this._sym._orig.x-this._orig.x},interfaces_:function(){return[]},getClass:function(){return vi}}),vi.init=function(t,e){if(null!==t._sym||null!==e._sym||null!==t._next||null!==e._next)throw new IllegalStateException("Edges are already initialized");return t.init(e),t},vi.create=function(t,e){var n=new vi(t),i=new vi(e);return n.init(i),n},h(mi,vi),e(mi.prototype,{mark:function(){this._isMarked=!0},setMark:function(t){this._isMarked=t},isMarked:function(){return this._isMarked},interfaces_:function(){return[]},getClass:function(){return mi}}),mi.setMarkBoth=function(t,e){t.setMark(e),t.sym().setMark(e)},mi.isMarked=function(t){return t.isMarked()},mi.setMark=function(t,e){t.setMark(e)},mi.markBoth=function(t){t.mark(),t.sym().mark()},mi.mark=function(t){t.mark()},e(yi.prototype,{insert:function(t,e,n){var i=this.create(t,e);null!==n?n.insert(i):this.vertexMap.put(t,i);var r=this.vertexMap.get(e);return null!==r?r.insert(i.sym()):this.vertexMap.put(e,i.sym()),i},create:function(t,e){var n=this.createEdge(t),i=this.createEdge(e);return vi.init(n,i),n},createEdge:function(t){return new vi(t)},addEdge:function(t,e){if(!yi.isValidEdge(t,e))return null;var n=this.vertexMap.get(t),i=null;if(null!==n&&(i=n.find(e)),null!==i)return i;var r=this.insert(t,e,n);return r},getVertexEdges:function(){return this.vertexMap.values()},findEdge:function(t,e){var n=this.vertexMap.get(t);return null===n?null:n.find(e)},interfaces_:function(){return[]},getClass:function(){return yi}}),yi.isValidEdge=function(t,e){var n=e.compareTo(t);return 0!==n},h(xi,mi),e(xi.prototype,{setStart:function(){this._isStart=!0},isStart:function(){return this._isStart},interfaces_:function(){return[]},getClass:function(){return xi}}),h(Ei,yi),e(Ei.prototype,{createEdge:function(t){return new xi(t)},interfaces_:function(){return[]},getClass:function(){return Ei}}),e(Ii.prototype,{addLine:function(t){this.lines.add(this.factory.createLineString(t.toCoordinateArray()))},updateRingStartEdge:function(t){return t.isStart()||(t=t.sym(),t.isStart())?null===this.ringStartEdge?(this.ringStartEdge=t,null):void(t.orig().compareTo(this.ringStartEdge.orig())<0&&(this.ringStartEdge=t)):null},getResult:function(){return null===this.result&&this.computeResult(),this.result},process:function(t){var e=t.prevNode();null===e&&(e=t),this.stackEdges(e),this.buildLines()},buildRing:function(t){var e=new N,n=t;for(e.add(n.orig().copy(),!1);2===n.sym().degree();){var i=n.next();if(i===t)break;e.add(i.orig().copy(),!1),n=i}e.add(n.dest().copy(),!1),this.addLine(e)},buildLine:function(t){var e=new N,n=t;for(this.ringStartEdge=null,mi.markBoth(n),e.add(n.orig().copy(),!1);2===n.sym().degree();){this.updateRingStartEdge(n);var i=n.next();if(i===t)return this.buildRing(this.ringStartEdge),null;e.add(i.orig().copy(),!1),n=i,mi.markBoth(n)}e.add(n.dest().copy(),!1),this.stackEdges(n.sym()),this.addLine(e)},stackEdges:function(t){var e=t;do mi.isMarked(e)||this.nodeEdgeStack.add(e),e=e.oNext();while(e!==t)},computeResult:function(){for(var t=this.graph.getVertexEdges(),e=t.iterator();e.hasNext();){var n=e.next();mi.isMarked(n)||this.process(n)}this.result=this.factory.buildGeometry(this.lines)},buildLines:function(){for(;!this.nodeEdgeStack.empty();){var t=this.nodeEdgeStack.pop();mi.isMarked(t)||this.buildLine(t)}},add:function(){if(arguments[0]instanceof B){var t=arguments[0];t.apply({interfaces_:function(){return[q]},filter:function(t){t instanceof St&&this.add(t)}})}else if(R(arguments[0],v))for(var e=arguments[0],n=e.iterator();n.hasNext();){var i=n.next();this.add(i)}else if(arguments[0]instanceof St){var r=arguments[0];null===this.factory&&(this.factory=r.getFactory());for(var s=r.getCoordinateSequence(),o=!1,n=1;n<s.size();n++){var a=this.graph.addEdge(s.getCoordinate(n-1),s.getCoordinate(n));null!==a&&(o||(a.setStart(),o=!0))}}},interfaces_:function(){return[]},getClass:function(){return Ii}}),Ii.dissolve=function(t){var e=new Ii;return e.add(t),e.getResult()};var go=Object.freeze({LineDissolver:Ii});e(Ni.prototype,{hasChildren:function(){for(var t=0;4>t;t++)if(null!==this.subnode[t])return!0;return!1},isPrunable:function(){return!(this.hasChildren()||this.hasItems())},addAllItems:function(t){t.addAll(this.items);for(var e=0;4>e;e++)null!==this.subnode[e]&&this.subnode[e].addAllItems(t);return t},getNodeCount:function(){for(var t=0,e=0;4>e;e++)null!==this.subnode[e]&&(t+=this.subnode[e].size());return t+1},size:function(){for(var t=0,e=0;4>e;e++)null!==this.subnode[e]&&(t+=this.subnode[e].size());return t+this.items.size()},addAllItemsFromOverlapping:function(t,e){if(!this.isSearchMatch(t))return null;e.addAll(this.items);for(var n=0;4>n;n++)null!==this.subnode[n]&&this.subnode[n].addAllItemsFromOverlapping(t,e)},visitItems:function(t,e){for(var n=this.items.iterator();n.hasNext();)e.visitItem(n.next())},hasItems:function(){return!this.items.isEmpty()},remove:function(t,e){if(!this.isSearchMatch(t))return!1;for(var n=!1,i=0;4>i;i++)if(null!==this.subnode[i]&&(n=this.subnode[i].remove(t,e))){this.subnode[i].isPrunable()&&(this.subnode[i]=null);break}return n?n:n=this.items.remove(e)},visit:function(t,e){if(!this.isSearchMatch(t))return null;this.visitItems(t,e);for(var n=0;4>n;n++)null!==this.subnode[n]&&this.subnode[n].visit(t,e)},getItems:function(){return this.items},depth:function(){for(var t=0,e=0;4>e;e++)if(null!==this.subnode[e]){var n=this.subnode[e].depth();n>t&&(t=n)}return t+1},isEmpty:function t(){var t=!0;this.items.isEmpty()||(t=!1);for(var e=0;4>e;e++)null!==this.subnode[e]&&(this.subnode[e].isEmpty()||(t=!1));return t},add:function(t){this.items.add(t)},interfaces_:function(){return[u]},getClass:function(){return Ni}}),Ni.getSubnodeIndex=function(t,e,n){var i=-1;return t.getMinX()>=e&&(t.getMinY()>=n&&(i=3),t.getMaxY()<=n&&(i=1)),t.getMaxX()<=e&&(t.getMinY()>=n&&(i=2),t.getMaxY()<=n&&(i=0)),i},Ci.exponent=function(t){return Si(64,t)-1023},Ci.powerOf2=function(t){return Math.pow(2,t)},e(wi.prototype,{getLevel:function(){return this.level},computeKey:function(){if(1===arguments.length){var t=arguments[0];for(this.level=wi.computeQuadLevel(t),this.env=new C,this.computeKey(this.level,t);!this.env.contains(t);)this.level+=1,this.computeKey(this.level,t)}else if(2===arguments.length){var e=arguments[0],n=arguments[1],i=Ci.powerOf2(e);this.pt.x=Math.floor(n.getMinX()/i)*i,this.pt.y=Math.floor(n.getMinY()/i)*i,this.env.init(this.pt.x,this.pt.x+i,this.pt.y,this.pt.y+i)}},getEnvelope:function(){return this.env},getCentre:function(){return new g((this.env.getMinX()+this.env.getMaxX())/2,(this.env.getMinY()+this.env.getMaxY())/2)},getPoint:function(){return this.pt},interfaces_:function(){return[]},getClass:function(){return wi}}),wi.computeQuadLevel=function(t){var e=t.getWidth(),n=t.getHeight(),i=e>n?e:n,r=Ci.exponent(i)+1;return r},h(Li,Ni),e(Li.prototype,{find:function(t){var e=Ni.getSubnodeIndex(t,this.centrex,this.centrey);if(-1===e)return this;if(null!==this.subnode[e]){var n=this.subnode[e];return n.find(t)}return this},isSearchMatch:function(t){return this.env.intersects(t)},getSubnode:function(t){return null===this.subnode[t]&&(this.subnode[t]=this.createSubnode(t)),this.subnode[t]},getEnvelope:function(){return this.env},getNode:function(t){var e=Ni.getSubnodeIndex(t,this.centrex,this.centrey);if(-1!==e){var n=this.getSubnode(e);return n.getNode(t)}return this},createSubnode:function(t){var e=0,n=0,i=0,r=0;switch(t){case 0:e=this.env.getMinX(),n=this.centrex,i=this.env.getMinY(),r=this.centrey;break;case 1:e=this.centrex,n=this.env.getMaxX(),i=this.env.getMinY(),r=this.centrey;break;case 2:e=this.env.getMinX(),n=this.centrex,i=this.centrey,r=this.env.getMaxY();break;case 3:e=this.centrex,n=this.env.getMaxX(),i=this.centrey,r=this.env.getMaxY()}var s=new C(e,n,i,r),o=new Li(s,this.level-1);return o},insertNode:function(t){f.isTrue(null===this.env||this.env.contains(t.env));var e=Ni.getSubnodeIndex(t.env,this.centrex,this.centrey);if(t.level===this.level-1)this.subnode[e]=t;else{var n=this.createSubnode(e);n.insertNode(t),this.subnode[e]=n}},interfaces_:function(){return[]},getClass:function(){return Li}}),Li.createNode=function(t){var e=new wi(t),n=new Li(e.getEnvelope(),e.getLevel());return n},Li.createExpanded=function(t,e){var n=new C(e);null!==t&&n.expandToInclude(t.env);var i=Li.createNode(n);return null!==t&&i.insertNode(t),i},e(Ri.prototype,{interfaces_:function(){return[]},getClass:function(){return Ri}}),Ri.isZeroWidth=function(t,e){var n=e-t;if(0===n)return!0;var i=Math.max(Math.abs(t),Math.abs(e)),r=n/i,s=Ci.exponent(r);return s<=Ri.MIN_BINARY_EXPONENT},Ri.MIN_BINARY_EXPONENT=-50,h(Ti,Ni),e(Ti.prototype,{insert:function(t,e){var n=Ni.getSubnodeIndex(t,Ti.origin.x,Ti.origin.y);if(-1===n)return this.add(e),null;var i=this.subnode[n];if(null===i||!i.getEnvelope().contains(t)){var r=Li.createExpanded(i,t);this.subnode[n]=r}this.insertContained(this.subnode[n],t,e)},isSearchMatch:function(t){return!0},insertContained:function(t,e,n){f.isTrue(t.getEnvelope().contains(e));var i=Ri.isZeroWidth(e.getMinX(),e.getMaxX()),r=Ri.isZeroWidth(e.getMinY(),e.getMaxY()),s=null;s=i||r?t.find(e):t.getNode(e),s.add(n)},interfaces_:function(){return[]},getClass:function(){return Ti}}),Ti.origin=new g(0,0),e(Pi.prototype,{size:function(){return null!==this.root?this.root.size():0},insert:function(t,e){this.collectStats(t);var n=Pi.ensureExtent(t,this.minExtent);this.root.insert(n,e)},query:function(){if(1===arguments.length){var t=arguments[0],e=new Yn;return this.query(t,e),e.getItems()}if(2===arguments.length){var n=arguments[0],i=arguments[1];this.root.visit(n,i)}},queryAll:function(){var t=new I;return this.root.addAllItems(t),
	t},remove:function(t,e){var n=Pi.ensureExtent(t,this.minExtent);return this.root.remove(n,e)},collectStats:function(t){var e=t.getWidth();e<this.minExtent&&e>0&&(this.minExtent=e);var n=t.getHeight();n<this.minExtent&&n>0&&(this.minExtent=n)},depth:function(){return null!==this.root?this.root.depth():0},isEmpty:function(){return null===this.root},interfaces_:function(){return[Fe,u]},getClass:function(){return Pi}}),Pi.ensureExtent=function(t,e){var n=t.getMinX(),i=t.getMaxX(),r=t.getMinY(),s=t.getMaxY();return n!==i&&r!==s?t:(n===i&&(n-=e/2,i=n+e/2),r===s&&(r-=e/2,s=r+e/2),new C(n,i,r,s))},Pi.serialVersionUID=-0x678b60c967a25400;var po=Object.freeze({Quadtree:Pi}),vo=Object.freeze({STRtree:ke}),mo=Object.freeze({quadtree:po,strtree:vo}),yo=["Point","MultiPoint","LineString","MultiLineString","Polygon","MultiPolygon"];e(bi.prototype,{read:function(t){var e=void 0;e="string"==typeof t?JSON.parse(t):t;var n=e.type;if(!xo[n])throw new Error("Unknown GeoJSON type: "+e.type);return-1!==yo.indexOf(n)?xo[n].apply(this,[e.coordinates]):"GeometryCollection"===n?xo[n].apply(this,[e.geometries]):xo[n].apply(this,[e])},write:function(t){var e=t.getGeometryType();if(!Eo[e])throw new Error("Geometry is not supported");return Eo[e].apply(this,[t])}});var xo={Feature:function(t){var e={};for(var n in t)e[n]=t[n];if(t.geometry){var i=t.geometry.type;if(!xo[i])throw new Error("Unknown GeoJSON type: "+t.type);e.geometry=this.read(t.geometry)}return t.bbox&&(e.bbox=xo.bbox.apply(this,[t.bbox])),e},FeatureCollection:function(t){var e={};if(t.features){e.features=[];for(var n=0;n<t.features.length;++n)e.features.push(this.read(t.features[n]))}return t.bbox&&(e.bbox=this.parse.bbox.apply(this,[t.bbox])),e},coordinates:function t(e){for(var t=[],n=0;n<e.length;++n){var i=e[n];t.push(new g(i[0],i[1]))}return t},bbox:function(t){return this.geometryFactory.createLinearRing([new g(t[0],t[1]),new g(t[2],t[1]),new g(t[2],t[3]),new g(t[0],t[3]),new g(t[0],t[1])])},Point:function(t){var e=new g(t[0],t[1]);return this.geometryFactory.createPoint(e)},MultiPoint:function(t){for(var e=[],n=0;n<t.length;++n)e.push(xo.Point.apply(this,[t[n]]));return this.geometryFactory.createMultiPoint(e)},LineString:function(t){var e=xo.coordinates.apply(this,[t]);return this.geometryFactory.createLineString(e)},MultiLineString:function(t){for(var e=[],n=0;n<t.length;++n)e.push(xo.LineString.apply(this,[t[n]]));return this.geometryFactory.createMultiLineString(e)},Polygon:function(t){for(var e=xo.coordinates.apply(this,[t[0]]),n=this.geometryFactory.createLinearRing(e),i=[],r=1;r<t.length;++r){var s=t[r],o=xo.coordinates.apply(this,[s]),a=this.geometryFactory.createLinearRing(o);i.push(a)}return this.geometryFactory.createPolygon(n,i)},MultiPolygon:function(t){for(var e=[],n=0;n<t.length;++n){var i=t[n];e.push(xo.Polygon.apply(this,[i]))}return this.geometryFactory.createMultiPolygon(e)},GeometryCollection:function(t){for(var e=[],n=0;n<t.length;++n){var i=t[n];e.push(this.read(i))}return this.geometryFactory.createGeometryCollection(e)}},Eo={coordinate:function(t){return[t.x,t.y]},Point:function(t){var e=Eo.coordinate.apply(this,[t.getCoordinate()]);return{type:"Point",coordinates:e}},MultiPoint:function(t){for(var e=[],n=0;n<t.geometries.length;++n){var i=t.geometries[n],r=Eo.Point.apply(this,[i]);e.push(r.coordinates)}return{type:"MultiPoint",coordinates:e}},LineString:function(t){for(var e=[],n=t.getCoordinates(),i=0;i<n.length;++i){var r=n[i];e.push(Eo.coordinate.apply(this,[r]))}return{type:"LineString",coordinates:e}},MultiLineString:function(t){for(var e=[],n=0;n<t.geometries.length;++n){var i=t.geometries[n],r=Eo.LineString.apply(this,[i]);e.push(r.coordinates)}return{type:"MultiLineString",coordinates:e}},Polygon:function(t){var e=[],n=Eo.LineString.apply(this,[t.shell]);e.push(n.coordinates);for(var i=0;i<t.holes.length;++i){var r=t.holes[i],s=Eo.LineString.apply(this,[r]);e.push(s.coordinates)}return{type:"Polygon",coordinates:e}},MultiPolygon:function(t){for(var e=[],n=0;n<t.geometries.length;++n){var i=t.geometries[n],r=Eo.Polygon.apply(this,[i]);e.push(r.coordinates)}return{type:"MultiPolygon",coordinates:e}},GeometryCollection:function(t){for(var e=[],n=0;n<t.geometries.length;++n){var i=t.geometries[n],r=i.getGeometryType();e.push(Eo[r].apply(this,[i]))}return{type:"GeometryCollection",geometries:e}}};e(Oi.prototype,{read:function(t){var e=this.parser.read(t);return this.precisionModel.getType()===ee.FIXED&&this.reducePrecision(e),e},reducePrecision:function(t){var e,n;if(t.coordinate)this.precisionModel.makePrecise(t.coordinate);else if(t.points)for(e=0,n=t.points.length;n>e;e++)this.precisionModel.makePrecise(t.points[e]);else if(t.geometries)for(e=0,n=t.geometries.length;n>e;e++)this.reducePrecision(t.geometries[e])}}),e(_i.prototype,{write:function(t){return this.parser.write(t)}}),e(Mi.prototype,{read:function(t){var e=this.parser.read(t);return this.precisionModel.getType()===ee.FIXED&&this.reducePrecision(e),e},reducePrecision:function(t){if(t.coordinate)this.precisionModel.makePrecise(t.coordinate);else if(t.points)for(var e=0,n=t.points.coordinates.length;n>e;e++)this.precisionModel.makePrecise(t.points.coordinates[e]);else if(t.geometries)for(var i=0,r=t.geometries.length;r>i;i++)this.reducePrecision(t.geometries[i])}}),e(Ai.prototype,{read:function(t){return t instanceof ol.geom.Point?this.convertFromPoint(t):t instanceof ol.geom.LineString?this.convertFromLineString(t):t instanceof ol.geom.LinearRing?this.convertFromLinearRing(t):t instanceof ol.geom.Polygon?this.convertFromPolygon(t):t instanceof ol.geom.MultiPoint?this.convertFromMultiPoint(t):t instanceof ol.geom.MultiLineString?this.convertFromMultiLineString(t):t instanceof ol.geom.MultiPolygon?this.convertFromMultiPolygon(t):t instanceof ol.geom.GeometryCollection?this.convertFromCollection(t):void 0},convertFromPoint:function(t){var e=t.getCoordinates();return this.geometryFactory.createPoint(new g(e[0],e[1]))},convertFromLineString:function(t){return this.geometryFactory.createLineString(t.getCoordinates().map(function(t){return new g(t[0],t[1])}))},convertFromLinearRing:function(t){return this.geometryFactory.createLinearRing(t.getCoordinates().map(function(t){return new g(t[0],t[1])}))},convertFromPolygon:function(t){for(var e=t.getLinearRings(),n=null,i=[],r=0;r<e.length;r++){var s=this.convertFromLinearRing(e[r]);0===r?n=s:i.push(s)}return this.geometryFactory.createPolygon(n,i)},convertFromMultiPoint:function(t){var e=t.getPoints().map(function(t){return this.convertFromPoint(t)},this);return this.geometryFactory.createMultiPoint(e)},convertFromMultiLineString:function(t){var e=t.getLineStrings().map(function(t){return this.convertFromLineString(t)},this);return this.geometryFactory.createMultiLineString(e)},convertFromMultiPolygon:function(t){var e=t.getPolygons().map(function(t){return this.convertFromPolygon(t)},this);return this.geometryFactory.createMultiPolygon(e)},convertFromCollection:function(t){var e=t.getGeometries().map(function(t){return this.read(t)},this);return this.geometryFactory.createGeometryCollection(e)},write:function(t){return"Point"===t.getGeometryType()?this.convertToPoint(t.getCoordinate()):"LineString"===t.getGeometryType()?this.convertToLineString(t):"LinearRing"===t.getGeometryType()?this.convertToLinearRing(t):"Polygon"===t.getGeometryType()?this.convertToPolygon(t):"MultiPoint"===t.getGeometryType()?this.convertToMultiPoint(t):"MultiLineString"===t.getGeometryType()?this.convertToMultiLineString(t):"MultiPolygon"===t.getGeometryType()?this.convertToMultiPolygon(t):"GeometryCollection"===t.getGeometryType()?this.convertToCollection(t):void 0},convertToPoint:function(t){return new ol.geom.Point([t.x,t.y])},convertToLineString:function(t){var e=t.points.coordinates.map(Di);return new ol.geom.LineString(e)},convertToLinearRing:function(t){var e=t.points.coordinates.map(Di);return new ol.geom.LinearRing(e)},convertToPolygon:function(t){for(var e=[t.shell.points.coordinates.map(Di)],n=0;n<t.holes.length;n++)e.push(t.holes[n].points.coordinates.map(Di));return new ol.geom.Polygon(e)},convertToMultiPoint:function(t){return new ol.geom.MultiPoint(t.getCoordinates().map(Di))},convertToMultiLineString:function(t){for(var e=[],n=0;n<t.geometries.length;n++)e.push(this.convertToLineString(t.geometries[n]).getCoordinates());return new ol.geom.MultiLineString(e)},convertToMultiPolygon:function(t){for(var e=[],n=0;n<t.geometries.length;n++)e.push(this.convertToPolygon(t.geometries[n]).getCoordinates());return new ol.geom.MultiPolygon(e)},convertToCollection:function(t){for(var e=[],n=0;n<t.geometries.length;n++){var i=t.geometries[n];e.push(this.write(i))}return new ol.geom.GeometryCollection(e)}});var Io=Object.freeze({GeoJSONReader:Oi,GeoJSONWriter:_i,OL3Parser:Ai,WKTReader:Mi,WKTWriter:se});e(Fi.prototype,{rescale:function(){if(R(arguments[0],v))for(var t=arguments[0],e=t.iterator();e.hasNext();){var n=e.next();this.rescale(n.getCoordinates())}else if(arguments[0]instanceof Array){var i=arguments[0],r=null,s=null;2===i.length&&(r=new g(i[0]),s=new g(i[1]));for(var e=0;e<i.length;e++)i[e].x=i[e].x/this.scaleFactor+this.offsetX,i[e].y=i[e].y/this.scaleFactor+this.offsetY;2===i.length&&i[0].equals2D(i[1])&&A.out.println(i)}},scale:function(){if(R(arguments[0],v)){for(var t=arguments[0],e=new I,n=t.iterator();n.hasNext();){var i=n.next();e.add(new Ke(this.scale(i.getCoordinates()),i.getData()))}return e}if(arguments[0]instanceof Array){for(var r=arguments[0],s=new Array(r.length).fill(null),n=0;n<r.length;n++)s[n]=new g(Math.round((r[n].x-this.offsetX)*this.scaleFactor),Math.round((r[n].y-this.offsetY)*this.scaleFactor),r[n].z);var o=H.removeRepeatedPoints(s);return o}},isIntegerPrecision:function(){return 1===this.scaleFactor},getNodedSubstrings:function(){var t=this.noder.getNodedSubstrings();return this.isScaled&&this.rescale(t),t},computeNodes:function(t){var e=t;this.isScaled&&(e=this.scale(t)),this.noder.computeNodes(e)},interfaces_:function(){return[tn]},getClass:function(){return Fi}});var No=Object.freeze({MCIndexNoder:nn,ScaledNoder:Fi,SegmentString:be});e(Gi.prototype,{isSimpleMultiPoint:function(t){if(t.isEmpty())return!0;for(var e=new at,n=0;n<t.getNumGeometries();n++){var i=t.getGeometryN(n),r=i.getCoordinate();if(e.contains(r))return this.nonSimpleLocation=r,!1;e.add(r)}return!0},isSimplePolygonal:function(t){for(var e=kn.getLines(t),n=e.iterator();n.hasNext();){var i=n.next();if(!this.isSimpleLinearGeometry(i))return!1}return!0},hasClosedEndpointIntersection:function(t){for(var e=new rt,n=t.getEdgeIterator();n.hasNext();){var i=n.next(),r=(i.getMaximumSegmentIndex(),i.isClosed()),s=i.getCoordinate(0);this.addEndpoint(e,s,r);var o=i.getCoordinate(i.getNumPoints()-1);this.addEndpoint(e,o,r)}for(var n=e.values().iterator();n.hasNext();){var a=n.next();if(a.isClosed&&2!==a.degree)return this.nonSimpleLocation=a.getCoordinate(),!0}return!1},getNonSimpleLocation:function(){return this.nonSimpleLocation},isSimpleLinearGeometry:function(t){if(t.isEmpty())return!0;var e=new $n(0,t),n=new ae,i=e.computeSelfNodes(n,!0);return i.hasIntersection()?i.hasProperIntersection()?(this.nonSimpleLocation=i.getProperIntersectionPoint(),!1):this.hasNonEndpointIntersection(e)?!1:!this.isClosedEndpointsInInterior||!this.hasClosedEndpointIntersection(e):!0},hasNonEndpointIntersection:function(t){for(var e=t.getEdgeIterator();e.hasNext();)for(var n=e.next(),i=n.getMaximumSegmentIndex(),r=n.getEdgeIntersectionList().iterator();r.hasNext();){var s=r.next();if(!s.isEndPoint(i))return this.nonSimpleLocation=s.getCoordinate(),!0}return!1},addEndpoint:function(t,e,n){var i=t.get(e);null===i&&(i=new qi(e),t.put(e,i)),i.addEndpoint(n)},computeSimple:function(t){return this.nonSimpleLocation=null,t.isEmpty()?!0:t instanceof St?this.isSimpleLinearGeometry(t):t instanceof gt?this.isSimpleLinearGeometry(t):t instanceof Pt?this.isSimpleMultiPoint(t):R(t,Rt)?this.isSimplePolygonal(t):t instanceof ft?this.isSimpleGeometryCollection(t):!0},isSimple:function(){return this.nonSimpleLocation=null,this.computeSimple(this.inputGeom)},isSimpleGeometryCollection:function(t){for(var e=0;e<t.getNumGeometries();e++){var n=t.getGeometryN(e);if(!this.computeSimple(n))return!1}return!0},interfaces_:function(){return[]},getClass:function(){return Gi}}),e(qi.prototype,{addEndpoint:function(t){this.degree++,this.isClosed|=t},getCoordinate:function(){return this.pt},interfaces_:function(){return[]},getClass:function(){return qi}}),Gi.EndpointInfo=qi,e(Bi.prototype,{getEndCapStyle:function(){return this.endCapStyle},isSingleSided:function(){return this._isSingleSided},setQuadrantSegments:function(t){this.quadrantSegments=t,0===this.quadrantSegments&&(this.joinStyle=Bi.JOIN_BEVEL),this.quadrantSegments<0&&(this.joinStyle=Bi.JOIN_MITRE,this.mitreLimit=Math.abs(this.quadrantSegments)),0>=t&&(this.quadrantSegments=1),this.joinStyle!==Bi.JOIN_ROUND&&(this.quadrantSegments=Bi.DEFAULT_QUADRANT_SEGMENTS)},getJoinStyle:function(){return this.joinStyle},setJoinStyle:function(t){this.joinStyle=t},setSimplifyFactor:function(t){this.simplifyFactor=0>t?0:t},getSimplifyFactor:function(){return this.simplifyFactor},getQuadrantSegments:function(){return this.quadrantSegments},setEndCapStyle:function(t){this.endCapStyle=t},getMitreLimit:function(){return this.mitreLimit},setMitreLimit:function(t){this.mitreLimit=t},setSingleSided:function(t){this._isSingleSided=t},interfaces_:function(){return[]},getClass:function(){return Bi}}),Bi.bufferDistanceError=function(t){var e=Math.PI/2/t;return 1-Math.cos(e/2)},Bi.CAP_ROUND=1,Bi.CAP_FLAT=2,Bi.CAP_SQUARE=3,Bi.JOIN_ROUND=1,Bi.JOIN_MITRE=2,Bi.JOIN_BEVEL=3,Bi.DEFAULT_QUADRANT_SEGMENTS=8,Bi.DEFAULT_MITRE_LIMIT=5,Bi.DEFAULT_SIMPLIFY_FACTOR=.01,e(zi.prototype,{getCoordinate:function(){return this.minCoord},getRightmostSide:function(t,e){var n=this.getRightmostSideOfSegment(t,e);return 0>n&&(n=this.getRightmostSideOfSegment(t,e-1)),0>n&&(this.minCoord=null,this.checkForRightmostCoordinate(t)),n},findRightmostEdgeAtVertex:function(){var t=this.minDe.getEdge().getCoordinates();f.isTrue(this.minIndex>0&&this.minIndex<t.length,"rightmost point expected to be interior vertex of edge");var e=t[this.minIndex-1],n=t[this.minIndex+1],i=he.computeOrientation(this.minCoord,n,e),r=!1;e.y<this.minCoord.y&&n.y<this.minCoord.y&&i===he.COUNTERCLOCKWISE?r=!0:e.y>this.minCoord.y&&n.y>this.minCoord.y&&i===he.CLOCKWISE&&(r=!0),r&&(this.minIndex=this.minIndex-1)},getRightmostSideOfSegment:function(t,e){var n=t.getEdge(),i=n.getCoordinates();if(0>e||e+1>=i.length)return-1;if(i[e].y===i[e+1].y)return-1;var r=cn.LEFT;return i[e].y<i[e+1].y&&(r=cn.RIGHT),r},getEdge:function(){return this.orientedDe},checkForRightmostCoordinate:function(t){for(var e=t.getEdge().getCoordinates(),n=0;n<e.length-1;n++)(null===this.minCoord||e[n].x>this.minCoord.x)&&(this.minDe=t,this.minIndex=n,this.minCoord=e[n])},findRightmostEdgeAtNode:function(){var t=this.minDe.getNode(),e=t.getEdges();this.minDe=e.getRightmostEdge(),this.minDe.isForward()||(this.minDe=this.minDe.getSym(),this.minIndex=this.minDe.getEdge().getCoordinates().length-1)},findEdge:function(t){for(var e=t.iterator();e.hasNext();){var n=e.next();n.isForward()&&this.checkForRightmostCoordinate(n)}f.isTrue(0!==this.minIndex||this.minCoord.equals(this.minDe.getCoordinate()),"inconsistency in rightmost processing"),0===this.minIndex?this.findRightmostEdgeAtNode():this.findRightmostEdgeAtVertex(),this.orientedDe=this.minDe;var i=this.getRightmostSide(this.minDe,this.minIndex);i===cn.LEFT&&(this.orientedDe=this.minDe.getSym())},interfaces_:function(){return[]},getClass:function(){return zi}}),Vi.prototype.addLast=function(t){this.array_.push(t)},Vi.prototype.removeFirst=function(){return this.array_.shift()},Vi.prototype.isEmpty=function(){return 0===this.array_.length},e(ki.prototype,{clearVisitedEdges:function(){for(var t=this.dirEdgeList.iterator();t.hasNext();){var e=t.next();e.setVisited(!1)}},getRightmostCoordinate:function(){return this.rightMostCoord},computeNodeDepth:function(t){for(var e=null,n=t.getEdges().iterator();n.hasNext();){var i=n.next();if(i.isVisited()||i.getSym().isVisited()){e=i;break}}if(null===e)throw new sn("unable to find edge to compute depths at "+t.getCoordinate());t.getEdges().computeDepths(e);for(var n=t.getEdges().iterator();n.hasNext();){var i=n.next();i.setVisited(!0),this.copySymDepths(i)}},computeDepth:function(t){this.clearVisitedEdges();var e=this.finder.getEdge();e.getNode(),e.getLabel();e.setEdgeDepths(cn.RIGHT,t),this.copySymDepths(e),this.computeDepths(e)},create:function(t){this.addReachable(t),this.finder.findEdge(this.dirEdgeList),this.rightMostCoord=this.finder.getCoordinate()},findResultEdges:function(){for(var t=this.dirEdgeList.iterator();t.hasNext();){var e=t.next();e.getDepth(cn.RIGHT)>=1&&e.getDepth(cn.LEFT)<=0&&!e.isInteriorAreaEdge()&&e.setInResult(!0)}},computeDepths:function(t){var e=new J,n=new Vi,i=t.getNode();for(n.addLast(i),e.add(i),t.setVisited(!0);!n.isEmpty();){var r=n.removeFirst();e.add(r),this.computeNodeDepth(r);for(var s=r.getEdges().iterator();s.hasNext();){var o=s.next(),a=o.getSym();if(!a.isVisited()){var u=a.getNode();e.contains(u)||(n.addLast(u),e.add(u))}}}},compareTo:function(t){var e=t;return this.rightMostCoord.x<e.rightMostCoord.x?-1:this.rightMostCoord.x>e.rightMostCoord.x?1:0},getEnvelope:function(){if(null===this.env){for(var t=new C,e=this.dirEdgeList.iterator();e.hasNext();)for(var n=e.next(),i=n.getEdge().getCoordinates(),r=0;r<i.length-1;r++)t.expandToInclude(i[r]);this.env=t}return this.env},addReachable:function(t){var e=new pe;for(e.add(t);!e.empty();){var n=e.pop();this.add(n,e)}},copySymDepths:function(t){var e=t.getSym();e.setDepth(cn.LEFT,t.getDepth(cn.RIGHT)),e.setDepth(cn.RIGHT,t.getDepth(cn.LEFT))},add:function(t,e){t.setVisited(!0),this.nodes.add(t);for(var n=t.getEdges().iterator();n.hasNext();){var i=n.next();this.dirEdgeList.add(i);var r=i.getSym(),s=r.getNode();s.isVisited()||e.push(s)}},getNodes:function(){return this.nodes},getDirectedEdges:function(){return this.dirEdgeList},interfaces_:function(){return[s]},getClass:function(){return ki}}),e(Yi.prototype,{isDeletable:function(t,e,n,i){var r=this.inputLine[t],s=this.inputLine[e],o=this.inputLine[n];return this.isConcave(r,s,o)&&this.isShallow(r,s,o,i)?this.isShallowSampled(r,s,t,n,i):!1},deleteShallowConcavities:function(){for(var t=1,e=(this.inputLine.length-1,this.findNextNonDeletedIndex(t)),n=this.findNextNonDeletedIndex(e),i=!1;n<this.inputLine.length;){var r=!1;this.isDeletable(t,e,n,this.distanceTol)&&(this.isDeleted[e]=Yi.DELETE,r=!0,i=!0),t=r?n:e,e=this.findNextNonDeletedIndex(t),n=this.findNextNonDeletedIndex(e)}return i},isShallowConcavity:function(t,e,n,i){var r=he.computeOrientation(t,e,n),s=r===this.angleOrientation;if(!s)return!1;var o=he.distancePointLine(e,t,n);return i>o},isShallowSampled:function(t,e,n,i,r){var s=Math.trunc((i-n)/Yi.NUM_PTS_TO_CHECK);0>=s&&(s=1);for(var o=n;i>o;o+=s)if(!this.isShallow(t,e,this.inputLine[o],r))return!1;return!0},isConcave:function t(e,n,i){var r=he.computeOrientation(e,n,i),t=r===this.angleOrientation;return t},simplify:function(t){this.distanceTol=Math.abs(t),0>t&&(this.angleOrientation=he.CLOCKWISE),this.isDeleted=new Array(this.inputLine.length).fill(null);var e=!1;do e=this.deleteShallowConcavities();while(e);return this.collapseLine()},findNextNonDeletedIndex:function(t){for(var e=t+1;e<this.inputLine.length&&this.isDeleted[e]===Yi.DELETE;)e++;return e},isShallow:function(t,e,n,i){var r=he.distancePointLine(e,t,n);return i>r},collapseLine:function(){for(var t=new N,e=0;e<this.inputLine.length;e++)this.isDeleted[e]!==Yi.DELETE&&t.add(this.inputLine[e]);return t.toCoordinateArray()},interfaces_:function(){return[]},getClass:function(){return Yi}}),Yi.simplify=function(t,e){var n=new Yi(t);return n.simplify(e)},Yi.INIT=0,Yi.DELETE=1,Yi.KEEP=1,Yi.NUM_PTS_TO_CHECK=10,e(Ui.prototype,{getCoordinates:function(){var t=this.ptList.toArray(Ui.COORDINATE_ARRAY_TYPE);return t},setPrecisionModel:function(t){this.precisionModel=t},addPt:function(t){var e=new g(t);return this.precisionModel.makePrecise(e),this.isRedundant(e)?null:void this.ptList.add(e)},reverse:function(){},addPts:function(t,e){if(e)for(var n=0;n<t.length;n++)this.addPt(t[n]);else for(var n=t.length-1;n>=0;n--)this.addPt(t[n])},isRedundant:function(t){if(this.ptList.size()<1)return!1;var e=this.ptList.get(this.ptList.size()-1),n=t.distance(e);return n<this.minimimVertexDistance},toString:function(){var t=new ie,e=t.createLineString(this.getCoordinates());return e.toString()},closeRing:function(){if(this.ptList.size()<1)return null;var t=new g(this.ptList.get(0)),e=this.ptList.get(this.ptList.size()-1),n=null;return this.ptList.size()>=2&&(n=this.ptList.get(this.ptList.size()-2)),t.equals(e)?null:void this.ptList.add(t)},setMinimumVertexDistance:function(t){this.minimimVertexDistance=t},interfaces_:function(){return[]},getClass:function(){return Ui}}),Ui.COORDINATE_ARRAY_TYPE=new Array(0).fill(null),e(Xi.prototype,{addNextSegment:function(t,e){if(this.s0=this.s1,this.s1=this.s2,this.s2=t,this.seg0.setCoordinates(this.s0,this.s1),this.computeOffsetSegment(this.seg0,this.side,this.distance,this.offset0),this.seg1.setCoordinates(this.s1,this.s2),this.computeOffsetSegment(this.seg1,this.side,this.distance,this.offset1),this.s1.equals(this.s2))return null;var n=he.computeOrientation(this.s0,this.s1,this.s2),i=n===he.CLOCKWISE&&this.side===cn.LEFT||n===he.COUNTERCLOCKWISE&&this.side===cn.RIGHT;0===n?this.addCollinear(e):i?this.addOutsideTurn(n,e):this.addInsideTurn(n,e)},addLineEndCap:function(t,e){var n=new ce(t,e),i=new ce;this.computeOffsetSegment(n,cn.LEFT,this.distance,i);var r=new ce;this.computeOffsetSegment(n,cn.RIGHT,this.distance,r);var s=e.x-t.x,o=e.y-t.y,a=Math.atan2(o,s);switch(this.bufParams.getEndCapStyle()){case Bi.CAP_ROUND:this.segList.addPt(i.p1),this.addFilletArc(e,a+Math.PI/2,a-Math.PI/2,he.CLOCKWISE,this.distance),this.segList.addPt(r.p1);break;case Bi.CAP_FLAT:this.segList.addPt(i.p1),this.segList.addPt(r.p1);break;case Bi.CAP_SQUARE:var u=new g;u.x=Math.abs(this.distance)*Math.cos(a),u.y=Math.abs(this.distance)*Math.sin(a);var l=new g(i.p1.x+u.x,i.p1.y+u.y),h=new g(r.p1.x+u.x,r.p1.y+u.y);this.segList.addPt(l),this.segList.addPt(h)}},getCoordinates:function(){var t=this.segList.getCoordinates();return t},addMitreJoin:function(t,e,n,i){var r=!0,s=null;try{s=F.intersection(e.p0,e.p1,n.p0,n.p1);var o=0>=i?1:s.distance(t)/Math.abs(i);o>this.bufParams.getMitreLimit()&&(r=!1)}catch(t){if(!(t instanceof w))throw t;s=new g(0,0),r=!1}finally{}r?this.segList.addPt(s):this.addLimitedMitreJoin(e,n,i,this.bufParams.getMitreLimit())},addFilletCorner:function(t,e,n,i,r){var s=e.x-t.x,o=e.y-t.y,a=Math.atan2(o,s),u=n.x-t.x,l=n.y-t.y,h=Math.atan2(l,u);i===he.CLOCKWISE?h>=a&&(a+=2*Math.PI):a>=h&&(a-=2*Math.PI),this.segList.addPt(e),this.addFilletArc(t,a,h,i,r),this.segList.addPt(n)},addOutsideTurn:function(t,e){return this.offset0.p1.distance(this.offset1.p0)<this.distance*Xi.OFFSET_SEGMENT_SEPARATION_FACTOR?(this.segList.addPt(this.offset0.p1),null):void(this.bufParams.getJoinStyle()===Bi.JOIN_MITRE?this.addMitreJoin(this.s1,this.offset0,this.offset1,this.distance):this.bufParams.getJoinStyle()===Bi.JOIN_BEVEL?this.addBevelJoin(this.offset0,this.offset1):(e&&this.segList.addPt(this.offset0.p1),this.addFilletCorner(this.s1,this.offset0.p1,this.offset1.p0,t,this.distance),this.segList.addPt(this.offset1.p0)))},createSquare:function(t){this.segList.addPt(new g(t.x+this.distance,t.y+this.distance)),this.segList.addPt(new g(t.x+this.distance,t.y-this.distance)),this.segList.addPt(new g(t.x-this.distance,t.y-this.distance)),this.segList.addPt(new g(t.x-this.distance,t.y+this.distance)),this.segList.closeRing()},addSegments:function(t,e){this.segList.addPts(t,e)},addFirstSegment:function(){this.segList.addPt(this.offset1.p0)},addLastSegment:function(){this.segList.addPt(this.offset1.p1)},initSideSegments:function(t,e,n){this.s1=t,this.s2=e,this.side=n,this.seg1.setCoordinates(t,e),this.computeOffsetSegment(this.seg1,n,this.distance,this.offset1)},addLimitedMitreJoin:function(t,e,n,i){var r=this.seg0.p1,s=hi.angle(r,this.seg0.p0),o=(hi.angle(r,this.seg1.p1),hi.angleBetweenOriented(this.seg0.p0,r,this.seg1.p1)),a=o/2,u=hi.normalize(s+a),l=hi.normalize(u+Math.PI),h=i*n,c=h*Math.abs(Math.sin(a)),f=n-c,d=r.x+h*Math.cos(l),p=r.y+h*Math.sin(l),v=new g(d,p),m=new ce(r,v),y=m.pointAlongOffset(1,f),x=m.pointAlongOffset(1,-f);this.side===cn.LEFT?(this.segList.addPt(y),this.segList.addPt(x)):(this.segList.addPt(x),this.segList.addPt(y))},computeOffsetSegment:function(t,e,n,i){var r=e===cn.LEFT?1:-1,s=t.p1.x-t.p0.x,o=t.p1.y-t.p0.y,a=Math.sqrt(s*s+o*o),u=r*n*s/a,l=r*n*o/a;i.p0.x=t.p0.x-l,i.p0.y=t.p0.y+u,i.p1.x=t.p1.x-l,i.p1.y=t.p1.y+u},addFilletArc:function(t,e,n,i,r){var s=i===he.CLOCKWISE?-1:1,o=Math.abs(e-n),a=Math.trunc(o/this.filletAngleQuantum+.5);if(1>a)return null;var u=null,l=null;u=0,l=o/a;for(var h=u,c=new g;o>h;){var f=e+s*h;c.x=t.x+r*Math.cos(f),c.y=t.y+r*Math.sin(f),this.segList.addPt(c),h+=l}},addInsideTurn:function(t,e){if(this.li.computeIntersection(this.offset0.p0,this.offset0.p1,this.offset1.p0,this.offset1.p1),this.li.hasIntersection())this.segList.addPt(this.li.getIntersection(0));else if(this._hasNarrowConcaveAngle=!0,this.offset0.p1.distance(this.offset1.p0)<this.distance*Xi.INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR)this.segList.addPt(this.offset0.p1);else{if(this.segList.addPt(this.offset0.p1),this.closingSegLengthFactor>0){var n=new g((this.closingSegLengthFactor*this.offset0.p1.x+this.s1.x)/(this.closingSegLengthFactor+1),(this.closingSegLengthFactor*this.offset0.p1.y+this.s1.y)/(this.closingSegLengthFactor+1));this.segList.addPt(n);var i=new g((this.closingSegLengthFactor*this.offset1.p0.x+this.s1.x)/(this.closingSegLengthFactor+1),(this.closingSegLengthFactor*this.offset1.p0.y+this.s1.y)/(this.closingSegLengthFactor+1));this.segList.addPt(i)}else this.segList.addPt(this.s1);this.segList.addPt(this.offset1.p0)}},createCircle:function(t){var e=new g(t.x+this.distance,t.y);this.segList.addPt(e),this.addFilletArc(t,0,2*Math.PI,-1,this.distance),this.segList.closeRing()},addBevelJoin:function(t,e){this.segList.addPt(t.p1),this.segList.addPt(e.p0)},init:function(t){this.distance=t,this.maxCurveSegmentError=t*(1-Math.cos(this.filletAngleQuantum/2)),this.segList=new Ui,this.segList.setPrecisionModel(this.precisionModel),this.segList.setMinimumVertexDistance(t*Xi.CURVE_VERTEX_SNAP_DISTANCE_FACTOR)},addCollinear:function(t){this.li.computeIntersection(this.s0,this.s1,this.s1,this.s2);var e=this.li.getIntersectionNum();e>=2&&(this.bufParams.getJoinStyle()===Bi.JOIN_BEVEL||this.bufParams.getJoinStyle()===Bi.JOIN_MITRE?(t&&this.segList.addPt(this.offset0.p1),this.segList.addPt(this.offset1.p0)):this.addFilletCorner(this.s1,this.offset0.p1,this.offset1.p0,he.CLOCKWISE,this.distance))},closeRing:function(){this.segList.closeRing()},hasNarrowConcaveAngle:function(){return this._hasNarrowConcaveAngle},interfaces_:function(){return[]},getClass:function(){return Xi}}),Xi.OFFSET_SEGMENT_SEPARATION_FACTOR=.001,Xi.INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR=.001,Xi.CURVE_VERTEX_SNAP_DISTANCE_FACTOR=1e-6,Xi.MAX_CLOSING_SEG_LEN_FACTOR=80,e(Hi.prototype,{getOffsetCurve:function(t,e){if(this.distance=e,0===e)return null;var n=0>e,i=Math.abs(e),r=this.getSegGen(i);t.length<=1?this.computePointCurve(t[0],r):this.computeOffsetCurve(t,n,r);var s=r.getCoordinates();return n&&H.reverse(s),s},computeSingleSidedBufferCurve:function(t,e,n){var i=this.simplifyTolerance(this.distance);if(e){n.addSegments(t,!0);var r=Yi.simplify(t,-i),s=r.length-1;n.initSideSegments(r[s],r[s-1],cn.LEFT),n.addFirstSegment();for(var o=s-2;o>=0;o--)n.addNextSegment(r[o],!0)}else{n.addSegments(t,!1);var a=Yi.simplify(t,i),u=a.length-1;n.initSideSegments(a[0],a[1],cn.LEFT),n.addFirstSegment();for(var o=2;u>=o;o++)n.addNextSegment(a[o],!0)}n.addLastSegment(),n.closeRing()},computeRingBufferCurve:function(t,e,n){var i=this.simplifyTolerance(this.distance);e===cn.RIGHT&&(i=-i);var r=Yi.simplify(t,i),s=r.length-1;n.initSideSegments(r[s-1],r[0],e);for(var o=1;s>=o;o++){var a=1!==o;n.addNextSegment(r[o],a)}n.closeRing()},computeLineBufferCurve:function(t,e){var n=this.simplifyTolerance(this.distance),i=Yi.simplify(t,n),r=i.length-1;e.initSideSegments(i[0],i[1],cn.LEFT);for(var s=2;r>=s;s++)e.addNextSegment(i[s],!0);e.addLastSegment(),e.addLineEndCap(i[r-1],i[r]);var o=Yi.simplify(t,-n),a=o.length-1;e.initSideSegments(o[a],o[a-1],cn.LEFT);for(var s=a-2;s>=0;s--)e.addNextSegment(o[s],!0);e.addLastSegment(),e.addLineEndCap(o[1],o[0]),e.closeRing()},computePointCurve:function(t,e){switch(this.bufParams.getEndCapStyle()){case Bi.CAP_ROUND:e.createCircle(t);break;case Bi.CAP_SQUARE:e.createSquare(t)}},getLineCurve:function(t,e){if(this.distance=e,0>e&&!this.bufParams.isSingleSided())return null;if(0===e)return null;var n=Math.abs(e),i=this.getSegGen(n);if(t.length<=1)this.computePointCurve(t[0],i);else if(this.bufParams.isSingleSided()){var r=0>e;this.computeSingleSidedBufferCurve(t,r,i)}else this.computeLineBufferCurve(t,i);var s=i.getCoordinates();return s},getBufferParameters:function(){return this.bufParams},simplifyTolerance:function(t){return t*this.bufParams.getSimplifyFactor()},getRingCurve:function(t,e,n){if(this.distance=n,t.length<=2)return this.getLineCurve(t,n);if(0===n)return Hi.copyCoordinates(t);var i=this.getSegGen(n);return this.computeRingBufferCurve(t,e,i),i.getCoordinates()},computeOffsetCurve:function(t,e,n){var i=this.simplifyTolerance(this.distance);if(e){var r=Yi.simplify(t,-i),s=r.length-1;n.initSideSegments(r[s],r[s-1],cn.LEFT),n.addFirstSegment();for(var o=s-2;o>=0;o--)n.addNextSegment(r[o],!0)}else{var a=Yi.simplify(t,i),u=a.length-1;n.initSideSegments(a[0],a[1],cn.LEFT),n.addFirstSegment();for(var o=2;u>=o;o++)n.addNextSegment(a[o],!0)}n.addLastSegment()},getSegGen:function(t){return new Xi(this.precisionModel,this.bufParams,t)},interfaces_:function(){return[]},getClass:function(){return Hi}}),Hi.copyCoordinates=function(t){for(var e=new Array(t.length).fill(null),n=0;n<e.length;n++)e[n]=new g(t[n]);return e},e(Wi.prototype,{findStabbedSegments:function(){if(1===arguments.length){for(var t=arguments[0],e=new I,n=this.subgraphs.iterator();n.hasNext();){var i=n.next(),r=i.getEnvelope();t.y<r.getMinY()||t.y>r.getMaxY()||this.findStabbedSegments(t,i.getDirectedEdges(),e)}return e}if(3===arguments.length)if(R(arguments[2],y)&&arguments[0]instanceof g&&arguments[1]instanceof In)for(var s=arguments[0],o=arguments[1],a=arguments[2],u=o.getEdge().getCoordinates(),n=0;n<u.length-1;n++){this.seg.p0=u[n],this.seg.p1=u[n+1],this.seg.p0.y>this.seg.p1.y&&this.seg.reverse();var l=Math.max(this.seg.p0.x,this.seg.p1.x);if(!(l<s.x||this.seg.isHorizontal()||s.y<this.seg.p0.y||s.y>this.seg.p1.y||he.computeOrientation(this.seg.p0,this.seg.p1,s)===he.RIGHT)){var h=o.getDepth(cn.LEFT);this.seg.p0.equals(u[n])||(h=o.getDepth(cn.RIGHT));var c=new ji(this.seg,h);a.add(c)}}else if(R(arguments[2],y)&&arguments[0]instanceof g&&R(arguments[1],y))for(var f=arguments[0],d=arguments[1],p=arguments[2],n=d.iterator();n.hasNext();){var v=n.next();v.isForward()&&this.findStabbedSegments(f,v,p)}},getDepth:function(t){var e=this.findStabbedSegments(t);if(0===e.size())return 0;var n=ho.min(e);return n.leftDepth},interfaces_:function(){return[]},getClass:function(){return Wi}}),e(ji.prototype,{compareTo:function(t){var e=t;if(this.upwardSeg.minX()>=e.upwardSeg.maxX())return 1;if(this.upwardSeg.maxX()<=e.upwardSeg.minX())return-1;var n=this.upwardSeg.orientationIndex(e.upwardSeg);return 0!==n?n:(n=-1*e.upwardSeg.orientationIndex(this.upwardSeg),0!==n?n:this.upwardSeg.compareTo(e.upwardSeg))},compareX:function(t,e){var n=t.p0.compareTo(e.p0);return 0!==n?n:t.p1.compareTo(e.p1)},toString:function(){return this.upwardSeg.toString()},interfaces_:function(){return[s]},getClass:function(){return ji}}),Wi.DepthSegment=ji,e(Ki.prototype,{addPoint:function(t){if(this.distance<=0)return null;
	var e=t.getCoordinates(),n=this.curveBuilder.getLineCurve(e,this.distance);this.addCurve(n,L.EXTERIOR,L.INTERIOR)},addPolygon:function(t){var e=this.distance,n=cn.LEFT;this.distance<0&&(e=-this.distance,n=cn.RIGHT);var i=t.getExteriorRing(),r=H.removeRepeatedPoints(i.getCoordinates());if(this.distance<0&&this.isErodedCompletely(i,this.distance))return null;if(this.distance<=0&&r.length<3)return null;this.addPolygonRing(r,e,n,L.EXTERIOR,L.INTERIOR);for(var s=0;s<t.getNumInteriorRing();s++){var o=t.getInteriorRingN(s),a=H.removeRepeatedPoints(o.getCoordinates());this.distance>0&&this.isErodedCompletely(o,-this.distance)||this.addPolygonRing(a,e,cn.opposite(n),L.INTERIOR,L.EXTERIOR)}},isTriangleErodedCompletely:function(t,e){var n=new ci(t[0],t[1],t[2]),i=n.inCentre(),r=he.distancePointLine(i,n.p0,n.p1);return r<Math.abs(e)},addLineString:function(t){if(this.distance<=0&&!this.curveBuilder.getBufferParameters().isSingleSided())return null;var e=H.removeRepeatedPoints(t.getCoordinates()),n=this.curveBuilder.getLineCurve(e,this.distance);this.addCurve(n,L.EXTERIOR,L.INTERIOR)},addCurve:function(t,e,n){if(null===t||t.length<2)return null;var i=new Ke(t,new gn(0,L.BOUNDARY,e,n));this.curveList.add(i)},getCurves:function(){return this.add(this.inputGeom),this.curveList},addPolygonRing:function(t,e,n,i,r){if(0===e&&t.length<bt.MINIMUM_VALID_SIZE)return null;var s=i,o=r;t.length>=bt.MINIMUM_VALID_SIZE&&he.isCCW(t)&&(s=r,o=i,n=cn.opposite(n));var a=this.curveBuilder.getRingCurve(t,n,e);this.addCurve(a,s,o)},add:function(t){if(t.isEmpty())return null;if(t instanceof Tt)this.addPolygon(t);else if(t instanceof St)this.addLineString(t);else if(t instanceof Lt)this.addPoint(t);else if(t instanceof Pt)this.addCollection(t);else if(t instanceof gt)this.addCollection(t);else if(t instanceof Ot)this.addCollection(t);else{if(!(t instanceof ft))throw new UnsupportedOperationException(t.getClass().getName());this.addCollection(t)}},isErodedCompletely:function(t,e){var n=t.getCoordinates();if(n.length<4)return 0>e;if(4===n.length)return this.isTriangleErodedCompletely(n,e);var i=t.getEnvelopeInternal(),r=Math.min(i.getHeight(),i.getWidth());return 0>e&&2*Math.abs(e)>r},addCollection:function(t){for(var e=0;e<t.getNumGeometries();e++){var n=t.getGeometryN(e);this.add(n)}},interfaces_:function(){return[]},getClass:function(){return Ki}}),e(Zi.prototype,{isTrivialIntersection:function(t,e,n,i){if(t===n&&1===this.li.getIntersectionNum()){if(Zi.isAdjacentSegments(e,i))return!0;if(t.isClosed()){var r=t.size()-1;if(0===e&&i===r||0===i&&e===r)return!0}}return!1},getProperIntersectionPoint:function(){return this.properIntersectionPoint},hasProperInteriorIntersection:function(){return this.hasProperInterior},getLineIntersector:function(){return this.li},hasProperIntersection:function(){return this.hasProper},processIntersections:function(t,e,n,i){if(t===n&&e===i)return null;this.numTests++;var r=t.getCoordinates()[e],s=t.getCoordinates()[e+1],o=n.getCoordinates()[i],a=n.getCoordinates()[i+1];this.li.computeIntersection(r,s,o,a),this.li.hasIntersection()&&(this.numIntersections++,this.li.isInteriorIntersection()&&(this.numInteriorIntersections++,this.hasInterior=!0),this.isTrivialIntersection(t,e,n,i)||(this._hasIntersection=!0,t.addIntersections(this.li,e,0),n.addIntersections(this.li,i,1),this.li.isProper()&&(this.numProperIntersections++,this.hasProper=!0,this.hasProperInterior=!0)))},hasIntersection:function(){return this._hasIntersection},isDone:function(){return!1},hasInteriorIntersection:function(){return this.hasInterior},interfaces_:function(){return[on]},getClass:function(){return Zi}}),Zi.isAdjacentSegments=function(t,e){return 1===Math.abs(t-e)},e(Qi.prototype,{setWorkingPrecisionModel:function(t){this.workingPrecisionModel=t},insertUniqueEdge:function(t){var e=this.edgeList.findEqualEdge(t);if(null!==e){var n=e.getLabel(),i=t.getLabel();e.isPointwiseEqual(t)||(i=new gn(t.getLabel()),i.flip()),n.merge(i);var r=Qi.depthDelta(i),s=e.getDepthDelta(),o=s+r;e.setDepthDelta(o)}else this.edgeList.add(t),t.setDepthDelta(Qi.depthDelta(t.getLabel()))},buildSubgraphs:function(t,e){for(var n=new I,i=t.iterator();i.hasNext();){var r=i.next(),s=r.getRightmostCoordinate(),o=new Wi(n),a=o.getDepth(s);r.computeDepth(a),r.findResultEdges(),n.add(r),e.add(r.getDirectedEdges(),r.getNodes())}},createSubgraphs:function(t){for(var e=new I,n=t.getNodes().iterator();n.hasNext();){var i=n.next();if(!i.isVisited()){var r=new ki;r.create(i),e.add(r)}}return ho.sort(e,ho.reverseOrder()),e},createEmptyResultGeometry:function(){var t=this.geomFact.createPolygon();return t},getNoder:function(t){if(null!==this.workingNoder)return this.workingNoder;var e=new nn,n=new ae;return n.setPrecisionModel(t),e.setSegmentIntersector(new Zi(n)),e},buffer:function(t,e){var n=this.workingPrecisionModel;null===n&&(n=t.getPrecisionModel()),this.geomFact=t.getFactory();var i=new Hi(n,this.bufParams),r=new Ki(t,e,i),s=r.getCurves();if(s.size()<=0)return this.createEmptyResultGeometry();this.computeNodedEdges(s,n),this.graph=new Cn(new On),this.graph.addEdges(this.edgeList.getEdges());var o=this.createSubgraphs(this.graph),a=new Sn(this.geomFact);this.buildSubgraphs(o,a);var u=a.getPolygons();if(u.size()<=0)return this.createEmptyResultGeometry();var l=this.geomFact.buildGeometry(u);return l},computeNodedEdges:function(t,e){var n=this.getNoder(e);n.computeNodes(t);for(var i=n.getNodedSubstrings(),r=i.iterator();r.hasNext();){var s=r.next(),o=s.getCoordinates();if(2!==o.length||!o[0].equals2D(o[1])){var a=s.getData(),u=new Jn(s.getCoordinates(),new gn(a));this.insertUniqueEdge(u)}}},setNoder:function(t){this.workingNoder=t},interfaces_:function(){return[]},getClass:function(){return Qi}}),Qi.depthDelta=function(t){var e=t.getLocation(0,cn.LEFT),n=t.getLocation(0,cn.RIGHT);return e===L.INTERIOR&&n===L.EXTERIOR?1:e===L.EXTERIOR&&n===L.INTERIOR?-1:0},Qi.convertSegStrings=function(t){for(var e=new ie,n=new I;t.hasNext();){var i=t.next(),r=e.createLineString(i.getCoordinates());n.add(r)}return e.buildGeometry(n)},e(Ji.prototype,{checkEndPtVertexIntersections:function(){if(0===arguments.length)for(var t=this.segStrings.iterator();t.hasNext();){var e=t.next(),n=e.getCoordinates();this.checkEndPtVertexIntersections(n[0],this.segStrings),this.checkEndPtVertexIntersections(n[n.length-1],this.segStrings)}else if(2===arguments.length)for(var i=arguments[0],r=arguments[1],t=r.iterator();t.hasNext();)for(var e=t.next(),n=e.getCoordinates(),s=1;s<n.length-1;s++)if(n[s].equals(i))throw new l("found endpt/interior pt intersection at index "+s+" :pt "+i)},checkInteriorIntersections:function(){if(0===arguments.length)for(var t=this.segStrings.iterator();t.hasNext();)for(var e=t.next(),n=this.segStrings.iterator();n.hasNext();){var i=n.next();this.checkInteriorIntersections(e,i)}else if(2===arguments.length)for(var r=arguments[0],s=arguments[1],o=r.getCoordinates(),a=s.getCoordinates(),u=0;u<o.length-1;u++)for(var h=0;h<a.length-1;h++)this.checkInteriorIntersections(r,u,s,h);else if(4===arguments.length){var c=arguments[0],f=arguments[1],g=arguments[2],d=arguments[3];if(c===g&&f===d)return null;var p=c.getCoordinates()[f],v=c.getCoordinates()[f+1],m=g.getCoordinates()[d],y=g.getCoordinates()[d+1];if(this.li.computeIntersection(p,v,m,y),this.li.hasIntersection()&&(this.li.isProper()||this.hasInteriorIntersection(this.li,p,v)||this.hasInteriorIntersection(this.li,m,y)))throw new l("found non-noded intersection at "+p+"-"+v+" and "+m+"-"+y)}},checkValid:function(){this.checkEndPtVertexIntersections(),this.checkInteriorIntersections(),this.checkCollapses()},checkCollapses:function(){if(0===arguments.length)for(var t=this.segStrings.iterator();t.hasNext();){var e=t.next();this.checkCollapses(e)}else if(1===arguments.length)for(var n=arguments[0],i=n.getCoordinates(),t=0;t<i.length-2;t++)this.checkCollapse(i[t],i[t+1],i[t+2])},hasInteriorIntersection:function(t,e,n){for(var i=0;i<t.getIntersectionNum();i++){var r=t.getIntersection(i);if(!r.equals(e)&&!r.equals(n))return!0}return!1},checkCollapse:function(t,e,n){if(t.equals(n))throw new l("found non-noded collapse at "+Ji.fact.createLineString([t,e,n]))},interfaces_:function(){return[]},getClass:function(){return Ji}}),Ji.fact=new ie,e($i.prototype,{intersectsScaled:function(t,e){var n=Math.min(t.x,e.x),i=Math.max(t.x,e.x),r=Math.min(t.y,e.y),s=Math.max(t.y,e.y),o=this.maxx<n||this.minx>i||this.maxy<r||this.miny>s;if(o)return!1;var a=this.intersectsToleranceSquare(t,e);return f.isTrue(!(o&&a),"Found bad envelope test"),a},initCorners:function(t){var e=.5;this.minx=t.x-e,this.maxx=t.x+e,this.miny=t.y-e,this.maxy=t.y+e,this.corner[0]=new g(this.maxx,this.maxy),this.corner[1]=new g(this.minx,this.maxy),this.corner[2]=new g(this.minx,this.miny),this.corner[3]=new g(this.maxx,this.miny)},intersects:function(t,e){return 1===this.scaleFactor?this.intersectsScaled(t,e):(this.copyScaled(t,this.p0Scaled),this.copyScaled(e,this.p1Scaled),this.intersectsScaled(this.p0Scaled,this.p1Scaled))},scale:function(t){return Math.round(t*this.scaleFactor)},getCoordinate:function(){return this.originalPt},copyScaled:function(t,e){e.x=this.scale(t.x),e.y=this.scale(t.y)},getSafeEnvelope:function(){if(null===this.safeEnv){var t=$i.SAFE_ENV_EXPANSION_FACTOR/this.scaleFactor;this.safeEnv=new C(this.originalPt.x-t,this.originalPt.x+t,this.originalPt.y-t,this.originalPt.y+t)}return this.safeEnv},intersectsPixelClosure:function(t,e){return this.li.computeIntersection(t,e,this.corner[0],this.corner[1]),this.li.hasIntersection()?!0:(this.li.computeIntersection(t,e,this.corner[1],this.corner[2]),this.li.hasIntersection()?!0:(this.li.computeIntersection(t,e,this.corner[2],this.corner[3]),this.li.hasIntersection()?!0:(this.li.computeIntersection(t,e,this.corner[3],this.corner[0]),!!this.li.hasIntersection())))},intersectsToleranceSquare:function(t,e){var n=!1,i=!1;return this.li.computeIntersection(t,e,this.corner[0],this.corner[1]),this.li.isProper()?!0:(this.li.computeIntersection(t,e,this.corner[1],this.corner[2]),this.li.isProper()?!0:(this.li.hasIntersection()&&(n=!0),this.li.computeIntersection(t,e,this.corner[2],this.corner[3]),this.li.isProper()?!0:(this.li.hasIntersection()&&(i=!0),this.li.computeIntersection(t,e,this.corner[3],this.corner[0]),this.li.isProper()?!0:n&&i?!0:t.equals(this.pt)?!0:!!e.equals(this.pt))))},addSnappedNode:function(t,e){var n=t.getCoordinate(e),i=t.getCoordinate(e+1);return this.intersects(n,i)?(t.addIntersection(this.getCoordinate(),e),!0):!1},interfaces_:function(){return[]},getClass:function(){return $i}}),$i.SAFE_ENV_EXPANSION_FACTOR=.75,e(tr.prototype,{select:function(){if(1===arguments.length){arguments[0]}else if(2===arguments.length){var t=arguments[0],e=arguments[1];t.getLineSegment(e,this.selectedSegment),this.select(this.selectedSegment)}},interfaces_:function(){return[]},getClass:function(){return tr}}),e(er.prototype,{snap:function(){if(1===arguments.length){var t=arguments[0];return this.snap(t,null,-1)}if(3===arguments.length){var e=arguments[0],n=arguments[1],i=arguments[2],r=e.getSafeEnvelope(),s=new nr(e,n,i);return this.index.query(r,{interfaces_:function(){return[Ae]},visitItem:function(t){var e=t;e.select(r,s)}}),s.isNodeAdded()}},interfaces_:function(){return[]},getClass:function(){return er}}),h(nr,tr),e(nr.prototype,{isNodeAdded:function(){return this._isNodeAdded},select:function(){if(2!==arguments.length)return tr.prototype.select.apply(this,arguments);var t=arguments[0],e=arguments[1],n=t.getContext();return null!==this.parentEdge&&n===this.parentEdge&&e===this.hotPixelVertexIndex?null:void(this._isNodeAdded=this.hotPixel.addSnappedNode(n,e))},interfaces_:function(){return[]},getClass:function(){return nr}}),er.HotPixelSnapAction=nr,e(ir.prototype,{processIntersections:function(t,e,n,i){if(t===n&&e===i)return null;var r=t.getCoordinates()[e],s=t.getCoordinates()[e+1],o=n.getCoordinates()[i],a=n.getCoordinates()[i+1];if(this.li.computeIntersection(r,s,o,a),this.li.hasIntersection()&&this.li.isInteriorIntersection()){for(var u=0;u<this.li.getIntersectionNum();u++)this.interiorIntersections.add(this.li.getIntersection(u));t.addIntersections(this.li,e,0),n.addIntersections(this.li,i,1)}},isDone:function(){return!1},getInteriorIntersections:function(){return this.interiorIntersections},interfaces_:function(){return[on]},getClass:function(){return ir}}),e(rr.prototype,{checkCorrectness:function(t){var e=Ke.getNodedSubstrings(t),n=new Ji(e);try{n.checkValid()}catch(t){if(!(t instanceof S))throw t;t.printStackTrace()}finally{}},getNodedSubstrings:function(){return Ke.getNodedSubstrings(this.nodedSegStrings)},snapRound:function(t,e){var n=this.findInteriorIntersections(t,e);this.computeIntersectionSnaps(n),this.computeVertexSnaps(t)},findInteriorIntersections:function(t,e){var n=new ir(e);return this.noder.setSegmentIntersector(n),this.noder.computeNodes(t),n.getInteriorIntersections()},computeVertexSnaps:function(){if(R(arguments[0],v))for(var t=arguments[0],e=t.iterator();e.hasNext();){var n=e.next();this.computeVertexSnaps(n)}else if(arguments[0]instanceof Ke)for(var i=arguments[0],r=i.getCoordinates(),s=0;s<r.length;s++){var o=new $i(r[s],this.scaleFactor,this.li),a=this.pointSnapper.snap(o,i,s);a&&i.addIntersection(r[s],s)}},computeNodes:function(t){this.nodedSegStrings=t,this.noder=new nn,this.pointSnapper=new er(this.noder.getIndex()),this.snapRound(t,this.li)},computeIntersectionSnaps:function(t){for(var e=t.iterator();e.hasNext();){var n=e.next(),i=new $i(n,this.scaleFactor,this.li);this.pointSnapper.snap(i)}},interfaces_:function(){return[tn]},getClass:function(){return rr}}),e(sr.prototype,{bufferFixedPrecision:function(t){var e=new Fi(new rr(new ee(1)),t.getScale()),n=new Qi(this.bufParams);n.setWorkingPrecisionModel(t),n.setNoder(e),this.resultGeometry=n.buffer(this.argGeom,this.distance)},bufferReducedPrecision:function(){if(0===arguments.length){for(var t=sr.MAX_PRECISION_DIGITS;t>=0;t--){try{this.bufferReducedPrecision(t)}catch(t){if(!(t instanceof sn))throw t;this.saveException=t}finally{}if(null!==this.resultGeometry)return null}throw this.saveException}if(1===arguments.length){var e=arguments[0],n=sr.precisionScaleFactor(this.argGeom,this.distance,e),i=new ee(n);this.bufferFixedPrecision(i)}},computeGeometry:function(){if(this.bufferOriginalPrecision(),null!==this.resultGeometry)return null;var t=this.argGeom.getFactory().getPrecisionModel();t.getType()===ee.FIXED?this.bufferFixedPrecision(t):this.bufferReducedPrecision()},setQuadrantSegments:function(t){this.bufParams.setQuadrantSegments(t)},bufferOriginalPrecision:function(){try{var t=new Qi(this.bufParams);this.resultGeometry=t.buffer(this.argGeom,this.distance)}catch(t){if(!(t instanceof l))throw t;this.saveException=t}finally{}},getResultGeometry:function(t){return this.distance=t,this.computeGeometry(),this.resultGeometry},setEndCapStyle:function(t){this.bufParams.setEndCapStyle(t)},interfaces_:function(){return[]},getClass:function(){return sr}}),sr.bufferOp=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1],n=new sr(t),i=n.getResultGeometry(e);return i}if(3===arguments.length){if(Number.isInteger(arguments[2])&&arguments[0]instanceof B&&"number"==typeof arguments[1]){var r=arguments[0],s=arguments[1],o=arguments[2],a=new sr(r);a.setQuadrantSegments(o);var i=a.getResultGeometry(s);return i}if(arguments[2]instanceof Bi&&arguments[0]instanceof B&&"number"==typeof arguments[1]){var u=arguments[0],l=arguments[1],h=arguments[2],a=new sr(u,h),i=a.getResultGeometry(l);return i}}else if(4===arguments.length){var c=arguments[0],f=arguments[1],g=arguments[2],d=arguments[3],a=new sr(c);a.setQuadrantSegments(g),a.setEndCapStyle(d);var i=a.getResultGeometry(f);return i}},sr.precisionScaleFactor=function(t,e,n){var i=t.getEnvelopeInternal(),r=T.max(Math.abs(i.getMaxX()),Math.abs(i.getMaxY()),Math.abs(i.getMinX()),Math.abs(i.getMinY())),s=e>0?e:0,o=r+2*s,a=Math.trunc(Math.log(o)/Math.log(10)+1),u=n-a,l=Math.pow(10,u);return l},sr.CAP_ROUND=Bi.CAP_ROUND,sr.CAP_BUTT=Bi.CAP_FLAT,sr.CAP_FLAT=Bi.CAP_FLAT,sr.CAP_SQUARE=Bi.CAP_SQUARE,sr.MAX_PRECISION_DIGITS=12;var Co=Object.freeze({BufferOp:sr,BufferParameters:Bi});e(or.prototype,{filter:function(t){t instanceof Tt&&this.comps.add(t)},interfaces_:function(){return[ht]},getClass:function(){return or}}),or.getPolygons=function(){if(1===arguments.length){var t=arguments[0];return or.getPolygons(t,new I)}if(2===arguments.length){var e=arguments[0],n=arguments[1];return e instanceof Tt?n.add(e):e instanceof ft&&e.apply(new or(n)),n}},e(ar.prototype,{isInsideArea:function(){return this.segIndex===ar.INSIDE_AREA},getCoordinate:function(){return this.pt},getGeometryComponent:function(){return this.component},getSegmentIndex:function(){return this.segIndex},interfaces_:function(){return[]},getClass:function(){return ar}}),ar.INSIDE_AREA=-1,e(ur.prototype,{filter:function(t){t instanceof Lt&&this.pts.add(t)},interfaces_:function(){return[ht]},getClass:function(){return ur}}),ur.getPoints=function(){if(1===arguments.length){var t=arguments[0];return t instanceof Lt?ho.singletonList(t):ur.getPoints(t,new I)}if(2===arguments.length){var e=arguments[0],n=arguments[1];return e instanceof Lt?n.add(e):e instanceof ft&&e.apply(new ur(n)),n}},e(lr.prototype,{filter:function(t){(t instanceof Lt||t instanceof St||t instanceof Tt)&&this.locations.add(new ar(t,0,t.getCoordinate()))},interfaces_:function(){return[ht]},getClass:function(){return lr}}),lr.getLocations=function(t){var e=new I;return t.apply(new lr(e)),e},e(hr.prototype,{computeContainmentDistance:function(){if(0===arguments.length){var t=new Array(2).fill(null);if(this.computeContainmentDistance(0,t),this.minDistance<=this.terminateDistance)return null;this.computeContainmentDistance(1,t)}else if(2===arguments.length){var e=arguments[0],n=arguments[1],i=1-e,r=or.getPolygons(this.geom[e]);if(r.size()>0){var s=lr.getLocations(this.geom[i]);if(this.computeContainmentDistance(s,r,n),this.minDistance<=this.terminateDistance)return this.minDistanceLocation[i]=n[0],this.minDistanceLocation[e]=n[1],null}}else if(3===arguments.length)if(arguments[2]instanceof Array&&R(arguments[0],y)&&R(arguments[1],y)){for(var o=arguments[0],a=arguments[1],u=arguments[2],l=0;l<o.size();l++)for(var h=o.get(l),c=0;c<a.size();c++)if(this.computeContainmentDistance(h,a.get(c),u),this.minDistance<=this.terminateDistance)return null}else if(arguments[2]instanceof Array&&arguments[0]instanceof ar&&arguments[1]instanceof Tt){var f=arguments[0],g=arguments[1],d=arguments[2],p=f.getCoordinate();if(L.EXTERIOR!==this.ptLocator.locate(p,g))return this.minDistance=0,d[0]=f,d[1]=new ar(g,p),null}},computeMinDistanceLinesPoints:function(t,e,n){for(var i=0;i<t.size();i++)for(var r=t.get(i),s=0;s<e.size();s++){var o=e.get(s);if(this.computeMinDistance(r,o,n),this.minDistance<=this.terminateDistance)return null}},computeFacetDistance:function(){var t=new Array(2).fill(null),e=kn.getLines(this.geom[0]),n=kn.getLines(this.geom[1]),i=ur.getPoints(this.geom[0]),r=ur.getPoints(this.geom[1]);return this.computeMinDistanceLines(e,n,t),this.updateMinDistance(t,!1),this.minDistance<=this.terminateDistance?null:(t[0]=null,t[1]=null,this.computeMinDistanceLinesPoints(e,r,t),this.updateMinDistance(t,!1),this.minDistance<=this.terminateDistance?null:(t[0]=null,t[1]=null,this.computeMinDistanceLinesPoints(n,i,t),this.updateMinDistance(t,!0),this.minDistance<=this.terminateDistance?null:(t[0]=null,t[1]=null,this.computeMinDistancePoints(i,r,t),void this.updateMinDistance(t,!1))))},nearestLocations:function(){return this.computeMinDistance(),this.minDistanceLocation},updateMinDistance:function(t,e){return null===t[0]?null:void(e?(this.minDistanceLocation[0]=t[1],this.minDistanceLocation[1]=t[0]):(this.minDistanceLocation[0]=t[0],this.minDistanceLocation[1]=t[1]))},nearestPoints:function(){this.computeMinDistance();var t=[this.minDistanceLocation[0].getCoordinate(),this.minDistanceLocation[1].getCoordinate()];return t},computeMinDistance:function(){if(0===arguments.length){if(null!==this.minDistanceLocation)return null;if(this.minDistanceLocation=new Array(2).fill(null),this.computeContainmentDistance(),this.minDistance<=this.terminateDistance)return null;this.computeFacetDistance()}else if(3===arguments.length)if(arguments[2]instanceof Array&&arguments[0]instanceof St&&arguments[1]instanceof Lt){var t=arguments[0],e=arguments[1],n=arguments[2];if(t.getEnvelopeInternal().distance(e.getEnvelopeInternal())>this.minDistance)return null;for(var i=t.getCoordinates(),r=e.getCoordinate(),s=0;s<i.length-1;s++){var o=he.distancePointLine(r,i[s],i[s+1]);if(o<this.minDistance){this.minDistance=o;var a=new ce(i[s],i[s+1]),u=a.closestPoint(r);n[0]=new ar(t,s,u),n[1]=new ar(e,0,r)}if(this.minDistance<=this.terminateDistance)return null}}else if(arguments[2]instanceof Array&&arguments[0]instanceof St&&arguments[1]instanceof St){var l=arguments[0],h=arguments[1],c=arguments[2];if(l.getEnvelopeInternal().distance(h.getEnvelopeInternal())>this.minDistance)return null;for(var i=l.getCoordinates(),f=h.getCoordinates(),s=0;s<i.length-1;s++)for(var g=0;g<f.length-1;g++){var o=he.distanceLineLine(i[s],i[s+1],f[g],f[g+1]);if(o<this.minDistance){this.minDistance=o;var d=new ce(i[s],i[s+1]),p=new ce(f[g],f[g+1]),v=d.closestPoints(p);c[0]=new ar(l,s,v[0]),c[1]=new ar(h,g,v[1])}if(this.minDistance<=this.terminateDistance)return null}}},computeMinDistancePoints:function(t,e,n){for(var i=0;i<t.size();i++)for(var r=t.get(i),s=0;s<e.size();s++){var o=e.get(s),a=r.getCoordinate().distance(o.getCoordinate());if(a<this.minDistance&&(this.minDistance=a,n[0]=new ar(r,0,r.getCoordinate()),n[1]=new ar(o,0,o.getCoordinate())),this.minDistance<=this.terminateDistance)return null}},distance:function(){if(null===this.geom[0]||null===this.geom[1])throw new i("null geometries are not supported");return this.geom[0].isEmpty()||this.geom[1].isEmpty()?0:(this.computeMinDistance(),this.minDistance)},computeMinDistanceLines:function(t,e,n){for(var i=0;i<t.size();i++)for(var r=t.get(i),s=0;s<e.size();s++){var o=e.get(s);if(this.computeMinDistance(r,o,n),this.minDistance<=this.terminateDistance)return null}},interfaces_:function(){return[]},getClass:function(){return hr}}),hr.distance=function(t,e){var n=new hr(t,e);return n.distance()},hr.isWithinDistance=function(t,e,n){var i=new hr(t,e,n);return i.distance()<=n},hr.nearestPoints=function(t,e){var n=new hr(t,e);return n.nearestPoints()};var So=Object.freeze({DistanceOp:hr});e(cr.prototype,{getCoordinates:function(){if(null===this.coordinates){for(var t=0,e=0,n=new N,i=this.directedEdges.iterator();i.hasNext();){var r=i.next();r.getEdgeDirection()?t++:e++,n.add(r.getEdge().getLine().getCoordinates(),!1,r.getEdgeDirection())}this.coordinates=n.toCoordinateArray(),e>t&&H.reverse(this.coordinates)}return this.coordinates},toLineString:function(){return this.factory.createLineString(this.getCoordinates())},add:function(t){this.directedEdges.add(t)},interfaces_:function(){return[]},getClass:function(){return cr}}),e(fr.prototype,{setVisited:function(t){this._isVisited=t},isMarked:function(){return this._isMarked},setData:function(t){this.data=t},getData:function(){return this.data},setMarked:function(t){this._isMarked=t},getContext:function(){return this.data},isVisited:function(){return this._isVisited},setContext:function(t){this.data=t},interfaces_:function(){return[]},getClass:function(){return fr}}),fr.getComponentWithVisitedState=function(t,e){for(;t.hasNext();){var n=t.next();if(n.isVisited()===e)return n}return null},fr.setVisited=function(t,e){for(;t.hasNext();){var n=t.next();n.setVisited(e)}},fr.setMarked=function(t,e){for(;t.hasNext();){var n=t.next();n.setMarked(e)}},h(gr,fr),e(gr.prototype,{isRemoved:function(){return null===this.parentEdge},compareDirection:function(t){return this.quadrant>t.quadrant?1:this.quadrant<t.quadrant?-1:he.computeOrientation(t.p0,t.p1,this.p1)},getCoordinate:function(){return this.from.getCoordinate()},print:function(t){var e=this.getClass().getName(),n=e.lastIndexOf("."),i=e.substring(n+1);t.print("  "+i+": "+this.p0+" - "+this.p1+" "+this.quadrant+":"+this.angle)},getDirectionPt:function(){return this.p1},getAngle:function(){return this.angle},compareTo:function(t){var e=t;return this.compareDirection(e)},getFromNode:function(){return this.from},getSym:function(){return this.sym},setEdge:function(t){this.parentEdge=t},remove:function(){this.sym=null,this.parentEdge=null},getEdge:function(){return this.parentEdge},getQuadrant:function(){return this.quadrant},setSym:function(t){this.sym=t},getToNode:function(){return this.to},getEdgeDirection:function(){return this.edgeDirection},interfaces_:function(){return[s]},getClass:function(){return gr}}),gr.toEdges=function(t){for(var e=new I,n=t.iterator();n.hasNext();)e.add(n.next().parentEdge);return e},h(dr,gr),e(dr.prototype,{getNext:function(){return 2!==this.getToNode().getDegree()?null:this.getToNode().getOutEdges().getEdges().get(0)===this.getSym()?this.getToNode().getOutEdges().getEdges().get(1):(f.isTrue(this.getToNode().getOutEdges().getEdges().get(1)===this.getSym()),this.getToNode().getOutEdges().getEdges().get(0))},interfaces_:function(){return[]},getClass:function(){return dr}}),h(pr,fr),e(pr.prototype,{isRemoved:function(){return null===this.dirEdge},setDirectedEdges:function(t,e){this.dirEdge=[t,e],t.setEdge(this),e.setEdge(this),t.setSym(e),e.setSym(t),t.getFromNode().addOutEdge(t),e.getFromNode().addOutEdge(e)},getDirEdge:function(){if(Number.isInteger(arguments[0])){var t=arguments[0];return this.dirEdge[t]}if(arguments[0]instanceof mr){var e=arguments[0];return this.dirEdge[0].getFromNode()===e?this.dirEdge[0]:this.dirEdge[1].getFromNode()===e?this.dirEdge[1]:null}},remove:function(){this.dirEdge=null},getOppositeNode:function(t){return this.dirEdge[0].getFromNode()===t?this.dirEdge[0].getToNode():this.dirEdge[1].getFromNode()===t?this.dirEdge[1].getToNode():null},interfaces_:function(){return[]},getClass:function(){return pr}}),e(vr.prototype,{getNextEdge:function(t){var e=this.getIndex(t);return this.outEdges.get(this.getIndex(e+1))},getCoordinate:function(){var t=this.iterator();if(!t.hasNext())return null;var e=t.next();return e.getCoordinate()},iterator:function(){return this.sortEdges(),this.outEdges.iterator()},sortEdges:function(){this.sorted||(ho.sort(this.outEdges),this.sorted=!0)},remove:function(t){this.outEdges.remove(t)},getEdges:function(){return this.sortEdges(),this.outEdges},getNextCWEdge:function(t){var e=this.getIndex(t);return this.outEdges.get(this.getIndex(e-1))},getIndex:function(){if(arguments[0]instanceof pr){var t=arguments[0];this.sortEdges();for(var e=0;e<this.outEdges.size();e++){var n=this.outEdges.get(e);if(n.getEdge()===t)return e}return-1}if(arguments[0]instanceof gr){var i=arguments[0];this.sortEdges();for(var e=0;e<this.outEdges.size();e++){var n=this.outEdges.get(e);if(n===i)return e}return-1}if(Number.isInteger(arguments[0])){var r=arguments[0],s=r%this.outEdges.size();return 0>s&&(s+=this.outEdges.size()),s}},add:function(t){this.outEdges.add(t),this.sorted=!1},getDegree:function(){return this.outEdges.size()},interfaces_:function(){return[]},getClass:function(){return vr}}),h(mr,fr),e(mr.prototype,{isRemoved:function(){return null===this.pt},addOutEdge:function(t){this.deStar.add(t)},getCoordinate:function(){return this.pt},getOutEdges:function(){return this.deStar},remove:function(){if(0===arguments.length)this.pt=null;else if(1===arguments.length){var t=arguments[0];this.deStar.remove(t)}},getIndex:function(t){return this.deStar.getIndex(t)},getDegree:function(){return this.deStar.getDegree()},interfaces_:function(){return[]},getClass:function(){return mr}}),mr.getEdgesBetween=function(t,e){var n=gr.toEdges(t.getOutEdges().getEdges()),i=new J(n),r=gr.toEdges(e.getOutEdges().getEdges());return i.retainAll(r),i},h(yr,pr),e(yr.prototype,{getLine:function(){return this.line},interfaces_:function(){return[]},getClass:function(){return yr}}),e(xr.prototype,{find:function(t){return this.nodeMap.get(t)},iterator:function(){return this.nodeMap.values().iterator()},remove:function(t){return this.nodeMap.remove(t)},values:function(){return this.nodeMap.values()},add:function(t){return this.nodeMap.put(t.getCoordinate(),t),t},interfaces_:function(){return[]},getClass:function(){return xr}}),e(Er.prototype,{findNodesOfDegree:function(t){for(var e=new I,n=this.nodeIterator();n.hasNext();){var i=n.next();i.getDegree()===t&&e.add(i)}return e},dirEdgeIterator:function(){return this.dirEdges.iterator()},edgeIterator:function(){return this.edges.iterator()},remove:function(){if(arguments[0]instanceof pr){var t=arguments[0];this.remove(t.getDirEdge(0)),this.remove(t.getDirEdge(1)),this.edges.remove(t),t.remove()}else if(arguments[0]instanceof gr){var e=arguments[0],n=e.getSym();null!==n&&n.setSym(null),e.getFromNode().remove(e),e.remove(),this.dirEdges.remove(e)}else if(arguments[0]instanceof mr){for(var i=arguments[0],r=i.getOutEdges().getEdges(),s=r.iterator();s.hasNext();){var o=s.next(),n=o.getSym();null!==n&&this.remove(n),this.dirEdges.remove(o);var a=o.getEdge();null!==a&&this.edges.remove(a)}this.nodeMap.remove(i.getCoordinate()),i.remove()}},findNode:function(t){return this.nodeMap.find(t)},getEdges:function(){return this.edges},nodeIterator:function(){return this.nodeMap.iterator()},contains:function(){if(arguments[0]instanceof pr){var t=arguments[0];return this.edges.contains(t)}if(arguments[0]instanceof gr){var e=arguments[0];return this.dirEdges.contains(e)}},add:function(){if(arguments[0]instanceof mr){var t=arguments[0];this.nodeMap.add(t)}else if(arguments[0]instanceof pr){var e=arguments[0];this.edges.add(e),this.add(e.getDirEdge(0)),this.add(e.getDirEdge(1))}else if(arguments[0]instanceof gr){var n=arguments[0];this.dirEdges.add(n)}},getNodes:function(){return this.nodeMap.values()},interfaces_:function(){return[]},getClass:function(){return Er}}),h(Ir,Er),e(Ir.prototype,{addEdge:function(t){if(t.isEmpty())return null;var e=H.removeRepeatedPoints(t.getCoordinates());if(e.length<=1)return null;var n=e[0],i=e[e.length-1],r=this.getNode(n),s=this.getNode(i),o=new dr(r,s,e[1],!0),a=new dr(s,r,e[e.length-2],!1),u=new yr(t);u.setDirectedEdges(o,a),this.add(u)},getNode:function(t){var e=this.findNode(t);return null===e&&(e=new mr(t),this.add(e)),e},interfaces_:function(){return[]},getClass:function(){return Ir}}),e(Nr.prototype,{buildEdgeStringsForUnprocessedNodes:function(){for(var t=this.graph.getNodes().iterator();t.hasNext();){var e=t.next();e.isMarked()||(f.isTrue(2===e.getDegree()),this.buildEdgeStringsStartingAt(e),e.setMarked(!0))}},buildEdgeStringsForNonDegree2Nodes:function(){for(var t=this.graph.getNodes().iterator();t.hasNext();){var e=t.next();2!==e.getDegree()&&(this.buildEdgeStringsStartingAt(e),e.setMarked(!0))}},buildEdgeStringsForObviousStartNodes:function(){this.buildEdgeStringsForNonDegree2Nodes()},getMergedLineStrings:function(){return this.merge(),this.mergedLineStrings},buildEdgeStringsStartingAt:function(t){for(var e=t.getOutEdges().iterator();e.hasNext();){var n=e.next();n.getEdge().isMarked()||this.edgeStrings.add(this.buildEdgeStringStartingWith(n))}},merge:function(){if(null!==this.mergedLineStrings)return null;fr.setMarked(this.graph.nodeIterator(),!1),fr.setMarked(this.graph.edgeIterator(),!1),this.edgeStrings=new I,this.buildEdgeStringsForObviousStartNodes(),this.buildEdgeStringsForIsolatedLoops(),this.mergedLineStrings=new I;for(var t=this.edgeStrings.iterator();t.hasNext();){var e=t.next();this.mergedLineStrings.add(e.toLineString())}},buildEdgeStringStartingWith:function(t){var e=new cr(this.factory),n=t;do e.add(n),n.getEdge().setMarked(!0),n=n.getNext();while(null!==n&&n!==t);return e},add:function(){if(arguments[0]instanceof B){var t=arguments[0];t.apply({interfaces_:function(){return[q]},filter:function(t){t instanceof St&&this.add(t)}})}else if(R(arguments[0],v)){var e=arguments[0];this.mergedLineStrings=null;for(var n=e.iterator();n.hasNext();){
	var i=n.next();this.add(i)}}else if(arguments[0]instanceof St){var r=arguments[0];null===this.factory&&(this.factory=r.getFactory()),this.graph.addEdge(r)}},buildEdgeStringsForIsolatedLoops:function(){this.buildEdgeStringsForUnprocessedNodes()},interfaces_:function(){return[]},getClass:function(){return Nr}});var wo=Object.freeze({LineMerger:Nr}),Lo=Object.freeze({OverlayOp:ii});h(Cr,gr),e(Cr.prototype,{getNext:function(){return this.next},isInRing:function(){return null!==this.edgeRing},setRing:function(t){this.edgeRing=t},setLabel:function(t){this.label=t},getLabel:function(){return this.label},setNext:function(t){this.next=t},getRing:function(){return this.edgeRing},interfaces_:function(){return[]},getClass:function(){return Cr}}),h(Sr,pr),e(Sr.prototype,{getLine:function(){return this.line},interfaces_:function(){return[]},getClass:function(){return Sr}}),e(wr.prototype,{isIncluded:function(){return this._isIncluded},getCoordinates:function(){if(null===this.ringPts){for(var t=new N,e=this.deList.iterator();e.hasNext();){var n=e.next(),i=n.getEdge();wr.addEdge(i.getLine().getCoordinates(),n.getEdgeDirection(),t)}this.ringPts=t.toCoordinateArray()}return this.ringPts},isIncludedSet:function(){return this._isIncludedSet},isValid:function(){return this.getCoordinates(),this.ringPts.length<=3?!1:(this.getRing(),this.ring.isValid())},build:function(t){var e=t;do this.add(e),e.setRing(this),e=e.getNext(),f.isTrue(null!==e,"found null DE in ring"),f.isTrue(e===t||!e.isInRing(),"found DE already in ring");while(e!==t)},isOuterHole:function(){return this._isHole?!this.hasShell():!1},getPolygon:function(){var t=null;if(null!==this.holes){t=new Array(this.holes.size()).fill(null);for(var e=0;e<this.holes.size();e++)t[e]=this.holes.get(e)}var n=this.factory.createPolygon(this.ring,t);return n},isHole:function(){return this._isHole},isProcessed:function(){return this._isProcessed},addHole:function(){if(arguments[0]instanceof bt){var t=arguments[0];null===this.holes&&(this.holes=new I),this.holes.add(t)}else if(arguments[0]instanceof wr){var e=arguments[0];e.setShell(this);var n=e.getRing();null===this.holes&&(this.holes=new I),this.holes.add(n)}},setIncluded:function(t){this._isIncluded=t,this._isIncludedSet=!0},getOuterHole:function(){if(this.isHole())return null;for(var t=0;t<this.deList.size();t++){var e=this.deList.get(t),n=e.getSym().getRing();if(n.isOuterHole())return n}return null},computeHole:function(){var t=this.getRing();this._isHole=he.isCCW(t.getCoordinates())},hasShell:function(){return null!==this.shell},isOuterShell:function(){return null!==this.getOuterHole()},getLineString:function(){return this.getCoordinates(),this.factory.createLineString(this.ringPts)},toString:function(){return se.toLineString(new Gt(this.getCoordinates()))},getShell:function(){return this.isHole()?this.shell:this},add:function(t){this.deList.add(t)},getRing:function(){if(null!==this.ring)return this.ring;this.getCoordinates(),this.ringPts.length<3&&A.out.println(this.ringPts);try{this.ring=this.factory.createLinearRing(this.ringPts)}catch(t){if(!(t instanceof S))throw t;A.out.println(this.ringPts)}finally{}return this.ring},updateIncluded:function(){if(this.isHole())return null;for(var t=0;t<this.deList.size();t++){var e=this.deList.get(t),n=e.getSym().getRing().getShell();if(null!==n&&n.isIncludedSet())return this.setIncluded(!n.isIncluded()),null}},setShell:function(t){this.shell=t},setProcessed:function(t){this._isProcessed=t},interfaces_:function(){return[]},getClass:function(){return wr}}),wr.findDirEdgesInRing=function(t){var e=t,n=new I;do n.add(e),e=e.getNext(),f.isTrue(null!==e,"found null DE in ring"),f.isTrue(e===t||!e.isInRing(),"found DE already in ring");while(e!==t);return n},wr.addEdge=function(t,e,n){if(e)for(var i=0;i<t.length;i++)n.add(t[i],!1);else for(var i=t.length-1;i>=0;i--)n.add(t[i],!1)},wr.findEdgeRingContaining=function(t,e){for(var n=t.getRing(),i=n.getEnvelopeInternal(),r=n.getCoordinateN(0),s=null,o=null,a=e.iterator();a.hasNext();){var u=a.next(),l=u.getRing(),h=l.getEnvelopeInternal();if(!h.equals(i)&&h.contains(i)){r=H.ptNotInList(n.getCoordinates(),l.getCoordinates());var c=!1;he.isPointInRing(r,l.getCoordinates())&&(c=!0),c&&(null===s||o.contains(h))&&(s=u,o=s.getRing().getEnvelopeInternal())}}return s},e(Lr.prototype,{compare:function(t,e){var n=t,i=e;return n.getRing().getEnvelope().compareTo(i.getRing().getEnvelope())},interfaces_:function(){return[a]},getClass:function(){return Lr}}),wr.EnvelopeComparator=Lr,h(Rr,Er),e(Rr.prototype,{findEdgeRing:function(t){var e=new wr(this.factory);return e.build(t),e},computeDepthParity:function(){if(0===arguments.length)for(;;){var t=null;if(null===t)return null;this.computeDepthParity(t)}else if(1===arguments.length){arguments[0]}},computeNextCWEdges:function(){for(var t=this.nodeIterator();t.hasNext();){var e=t.next();Rr.computeNextCWEdges(e)}},addEdge:function(t){if(t.isEmpty())return null;var e=H.removeRepeatedPoints(t.getCoordinates());if(e.length<2)return null;var n=e[0],i=e[e.length-1],r=this.getNode(n),s=this.getNode(i),o=new Cr(r,s,e[1],!0),a=new Cr(s,r,e[e.length-2],!1),u=new Sr(t);u.setDirectedEdges(o,a),this.add(u)},deleteCutEdges:function(){this.computeNextCWEdges(),Rr.findLabeledEdgeRings(this.dirEdges);for(var t=new I,e=this.dirEdges.iterator();e.hasNext();){var n=e.next();if(!n.isMarked()){var i=n.getSym();if(n.getLabel()===i.getLabel()){n.setMarked(!0),i.setMarked(!0);var r=n.getEdge();t.add(r.getLine())}}}return t},getEdgeRings:function(){this.computeNextCWEdges(),Rr.label(this.dirEdges,-1);var t=Rr.findLabeledEdgeRings(this.dirEdges);this.convertMaximalToMinimalEdgeRings(t);for(var e=new I,n=this.dirEdges.iterator();n.hasNext();){var i=n.next();if(!i.isMarked()&&!i.isInRing()){var r=this.findEdgeRing(i);e.add(r)}}return e},getNode:function(t){var e=this.findNode(t);return null===e&&(e=new mr(t),this.add(e)),e},convertMaximalToMinimalEdgeRings:function(t){for(var e=t.iterator();e.hasNext();){var n=e.next(),i=n.getLabel(),r=Rr.findIntersectionNodes(n,i);if(null!==r)for(var s=r.iterator();s.hasNext();){var o=s.next();Rr.computeNextCCWEdges(o,i)}}},deleteDangles:function(){for(var t=this.findNodesOfDegree(1),e=new J,n=new pe,i=t.iterator();i.hasNext();)n.push(i.next());for(;!n.isEmpty();){var r=n.pop();Rr.deleteAllEdges(r);for(var s=r.getOutEdges().getEdges(),i=s.iterator();i.hasNext();){var o=i.next();o.setMarked(!0);var a=o.getSym();null!==a&&a.setMarked(!0);var u=o.getEdge();e.add(u.getLine());var l=o.getToNode();1===Rr.getDegreeNonDeleted(l)&&n.push(l)}}return e},interfaces_:function(){return[]},getClass:function(){return Rr}}),Rr.findLabeledEdgeRings=function(t){for(var e=new I,n=1,i=t.iterator();i.hasNext();){var r=i.next();if(!(r.isMarked()||r.getLabel()>=0)){e.add(r);var s=wr.findDirEdgesInRing(r);Rr.label(s,n),n++}}return e},Rr.getDegreeNonDeleted=function(t){for(var e=t.getOutEdges().getEdges(),n=0,i=e.iterator();i.hasNext();){var r=i.next();r.isMarked()||n++}return n},Rr.deleteAllEdges=function(t){for(var e=t.getOutEdges().getEdges(),n=e.iterator();n.hasNext();){var i=n.next();i.setMarked(!0);var r=i.getSym();null!==r&&r.setMarked(!0)}},Rr.label=function(t,e){for(var n=t.iterator();n.hasNext();){var i=n.next();i.setLabel(e)}},Rr.computeNextCWEdges=function(t){for(var e=t.getOutEdges(),n=null,i=null,r=e.getEdges().iterator();r.hasNext();){var s=r.next();if(!s.isMarked()){if(null===n&&(n=s),null!==i){var o=i.getSym();o.setNext(s)}i=s}}if(null!==i){var o=i.getSym();o.setNext(n)}},Rr.computeNextCCWEdges=function(t,e){for(var n=t.getOutEdges(),i=null,r=null,s=n.getEdges(),o=s.size()-1;o>=0;o--){var a=s.get(o),u=a.getSym(),l=null;a.getLabel()===e&&(l=a);var h=null;u.getLabel()===e&&(h=u),null===l&&null===h||(null!==h&&(r=h),null!==l&&(null!==r&&(r.setNext(l),r=null),null===i&&(i=l)))}null!==r&&(f.isTrue(null!==i),r.setNext(i))},Rr.getDegree=function(t,e){for(var n=t.getOutEdges().getEdges(),i=0,r=n.iterator();r.hasNext();){var s=r.next();s.getLabel()===e&&i++}return i},Rr.findIntersectionNodes=function(t,e){var n=t,i=null;do{var r=n.getFromNode();Rr.getDegree(r,e)>1&&(null===i&&(i=new I),i.add(r)),n=n.getNext(),f.isTrue(null!==n,"found null DE in ring"),f.isTrue(n===t||!n.isInRing(),"found DE already in ring")}while(n!==t);return i},e(Tr.prototype,{getGeometry:function(){return null===this.geomFactory&&(this.geomFactory=new ie),this.polygonize(),this.extractOnlyPolygonal?this.geomFactory.buildGeometry(this.polyList):this.geomFactory.createGeometryCollection(ie.toGeometryArray(this.polyList))},getInvalidRingLines:function(){return this.polygonize(),this.invalidRingLines},findValidRings:function(t,e,n){for(var i=t.iterator();i.hasNext();){var r=i.next();r.isValid()?e.add(r):n.add(r.getLineString())}},polygonize:function(){if(null!==this.polyList)return null;if(this.polyList=new I,null===this.graph)return null;this.dangles=this.graph.deleteDangles(),this.cutEdges=this.graph.deleteCutEdges();var t=this.graph.getEdgeRings(),e=new I;this.invalidRingLines=new I,this.isCheckingRingsValid?this.findValidRings(t,e,this.invalidRingLines):e=t,this.findShellsAndHoles(e),Tr.assignHolesToShells(this.holeList,this.shellList),ho.sort(this.shellList,new wr.EnvelopeComparator);var n=!0;this.extractOnlyPolygonal&&(Tr.findDisjointShells(this.shellList),n=!1),this.polyList=Tr.extractPolygons(this.shellList,n)},getDangles:function(){return this.polygonize(),this.dangles},getCutEdges:function(){return this.polygonize(),this.cutEdges},getPolygons:function(){return this.polygonize(),this.polyList},add:function(){if(R(arguments[0],v))for(var t=arguments[0],e=t.iterator();e.hasNext();){var n=e.next();this.add(n)}else if(arguments[0]instanceof St){var i=arguments[0];this.geomFactory=i.getFactory(),null===this.graph&&(this.graph=new Rr(this.geomFactory)),this.graph.addEdge(i)}else if(arguments[0]instanceof B){var r=arguments[0];r.apply(this.lineStringAdder)}},setCheckRingsValid:function(t){this.isCheckingRingsValid=t},findShellsAndHoles:function(t){this.holeList=new I,this.shellList=new I;for(var e=t.iterator();e.hasNext();){var n=e.next();n.computeHole(),n.isHole()?this.holeList.add(n):this.shellList.add(n)}},interfaces_:function(){return[]},getClass:function(){return Tr}}),Tr.findOuterShells=function(t){for(var e=t.iterator();e.hasNext();){var n=e.next(),i=n.getOuterHole();null===i||i.isProcessed()||(n.setIncluded(!0),i.setProcessed(!0))}},Tr.extractPolygons=function(t,e){for(var n=new I,i=t.iterator();i.hasNext();){var r=i.next();(e||r.isIncluded())&&n.add(r.getPolygon())}return n},Tr.assignHolesToShells=function(t,e){for(var n=t.iterator();n.hasNext();){var i=n.next();Tr.assignHoleToShell(i,e)}},Tr.assignHoleToShell=function(t,e){var n=wr.findEdgeRingContaining(t,e);null!==n&&n.addHole(t)},Tr.findDisjointShells=function(t){Tr.findOuterShells(t);var e=null;do{e=!1;for(var n=t.iterator();n.hasNext();){var i=n.next();i.isIncludedSet()||(i.updateIncluded(),i.isIncludedSet()||(e=!0))}}while(e)},e(Pr.prototype,{filter:function(t){t instanceof St&&this.p.add(t)},interfaces_:function(){return[q]},getClass:function(){return Pr}}),Tr.LineStringAdder=Pr;var Ro=Object.freeze({Polygonizer:Tr});e(br.prototype,{createEdgeEndForNext:function(t,e,n,i){var r=n.segmentIndex+1;if(r>=t.getNumPoints()&&null===i)return null;var s=t.getCoordinate(r);null!==i&&i.segmentIndex===n.segmentIndex&&(s=i.coord);var o=new En(t,n.coord,s,new gn(t.getLabel()));e.add(o)},createEdgeEndForPrev:function(t,e,n,i){var r=n.segmentIndex;if(0===n.dist){if(0===r)return null;r--}var s=t.getCoordinate(r);null!==i&&i.segmentIndex>=r&&(s=i.coord);var o=new gn(t.getLabel());o.flip();var a=new En(t,n.coord,s,o);e.add(a)},computeEdgeEnds:function(){if(1===arguments.length){for(var t=arguments[0],e=new I,n=t;n.hasNext();){var i=n.next();this.computeEdgeEnds(i,e)}return e}if(2===arguments.length){var r=arguments[0],s=arguments[1],o=r.getEdgeIntersectionList();o.addEndpoints();var a=o.iterator(),u=null,l=null;if(!a.hasNext())return null;var h=a.next();do u=l,l=h,h=null,a.hasNext()&&(h=a.next()),null!==l&&(this.createEdgeEndForPrev(r,s,l,u),this.createEdgeEndForNext(r,s,l,h));while(null!==l)}},interfaces_:function(){return[]},getClass:function(){return br}}),h(Or,En),e(Or.prototype,{insert:function(t){this.edgeEnds.add(t)},print:function(t){t.println("EdgeEndBundle--> Label: "+this.label);for(var e=this.iterator();e.hasNext();){var n=e.next();n.print(t),t.println()}},iterator:function(){return this.edgeEnds.iterator()},getEdgeEnds:function(){return this.edgeEnds},computeLabelOn:function(t,e){for(var n=0,i=!1,r=this.iterator();r.hasNext();){var s=r.next(),o=s.getLabel().getLocation(t);o===L.BOUNDARY&&n++,o===L.INTERIOR&&(i=!0)}var o=L.NONE;i&&(o=L.INTERIOR),n>0&&(o=$n.determineBoundary(e,n)),this.label.setLocation(t,o)},computeLabelSide:function(t,e){for(var n=this.iterator();n.hasNext();){var i=n.next();if(i.getLabel().isArea()){var r=i.getLabel().getLocation(t,e);if(r===L.INTERIOR)return this.label.setLocation(t,e,L.INTERIOR),null;r===L.EXTERIOR&&this.label.setLocation(t,e,L.EXTERIOR)}}},getLabel:function(){return this.label},computeLabelSides:function(t){this.computeLabelSide(t,cn.LEFT),this.computeLabelSide(t,cn.RIGHT)},updateIM:function(t){Jn.updateIM(this.label,t)},computeLabel:function(t){for(var e=!1,n=this.iterator();n.hasNext();){var i=n.next();i.getLabel().isArea()&&(e=!0)}e?this.label=new gn(L.NONE,L.NONE,L.NONE):this.label=new gn(L.NONE);for(var r=0;2>r;r++)this.computeLabelOn(r,t),e&&this.computeLabelSides(r)},interfaces_:function(){return[]},getClass:function(){return Or}}),h(_r,Pn),e(_r.prototype,{updateIM:function(t){for(var e=this.iterator();e.hasNext();){var n=e.next();n.updateIM(t)}},insert:function(t){var e=this.edgeMap.get(t);null===e?(e=new Or(t),this.insertEdgeEnd(t,e)):e.insert(t)},interfaces_:function(){return[]},getClass:function(){return _r}}),h(Mr,yn),e(Mr.prototype,{updateIMFromEdges:function(t){this.edges.updateIM(t)},computeIM:function(t){t.setAtLeastIfValid(this.label.getLocation(0),this.label.getLocation(1),0)},interfaces_:function(){return[]},getClass:function(){return Mr}}),h(Dr,Nn),e(Dr.prototype,{createNode:function(t){return new Mr(t,new _r)},interfaces_:function(){return[]},getClass:function(){return Dr}}),e(Ar.prototype,{insertEdgeEnds:function(t){for(var e=t.iterator();e.hasNext();){var n=e.next();this.nodes.add(n)}},computeProperIntersectionIM:function(t,e){var n=this.arg[0].getGeometry().getDimension(),i=this.arg[1].getGeometry().getDimension(),r=t.hasProperIntersection(),s=t.hasProperInteriorIntersection();2===n&&2===i?r&&e.setAtLeast("212101212"):2===n&&1===i?(r&&e.setAtLeast("FFF0FFFF2"),s&&e.setAtLeast("1FFFFF1FF")):1===n&&2===i?(r&&e.setAtLeast("F0FFFFFF2"),s&&e.setAtLeast("1F1FFFFFF")):1===n&&1===i&&s&&e.setAtLeast("0FFFFFFFF")},labelIsolatedEdges:function(t,e){for(var n=this.arg[t].getEdgeIterator();n.hasNext();){var i=n.next();i.isIsolated()&&(this.labelIsolatedEdge(i,e,this.arg[e].getGeometry()),this.isolatedEdges.add(i))}},labelIsolatedEdge:function(t,e,n){if(n.getDimension()>0){var i=this.ptLocator.locate(t.getCoordinate(),n);t.getLabel().setAllLocations(e,i)}else t.getLabel().setAllLocations(e,L.EXTERIOR)},computeIM:function(){var t=new fe;if(t.set(L.EXTERIOR,L.EXTERIOR,2),!this.arg[0].getGeometry().getEnvelopeInternal().intersects(this.arg[1].getGeometry().getEnvelopeInternal()))return this.computeDisjointIM(t),t;this.arg[0].computeSelfNodes(this.li,!1),this.arg[1].computeSelfNodes(this.li,!1);var e=this.arg[0].computeEdgeIntersections(this.arg[1],this.li,!1);this.computeIntersectionNodes(0),this.computeIntersectionNodes(1),this.copyNodesAndLabels(0),this.copyNodesAndLabels(1),this.labelIsolatedNodes(),this.computeProperIntersectionIM(e,t);var n=new br,i=n.computeEdgeEnds(this.arg[0].getEdgeIterator());this.insertEdgeEnds(i);var r=n.computeEdgeEnds(this.arg[1].getEdgeIterator());return this.insertEdgeEnds(r),this.labelNodeEdges(),this.labelIsolatedEdges(0,1),this.labelIsolatedEdges(1,0),this.updateIM(t),t},labelNodeEdges:function(){for(var t=this.nodes.iterator();t.hasNext();){var e=t.next();e.getEdges().computeLabelling(this.arg)}},copyNodesAndLabels:function(t){for(var e=this.arg[t].getNodeIterator();e.hasNext();){var n=e.next(),i=this.nodes.addNode(n.getCoordinate());i.setLabel(t,n.getLabel().getLocation(t))}},labelIntersectionNodes:function(t){for(var e=this.arg[t].getEdgeIterator();e.hasNext();)for(var n=e.next(),i=n.getLabel().getLocation(t),r=n.getEdgeIntersectionList().iterator();r.hasNext();){var s=r.next(),o=this.nodes.find(s.coord);o.getLabel().isNull(t)&&(i===L.BOUNDARY?o.setLabelBoundary(t):o.setLabel(t,L.INTERIOR))}},labelIsolatedNode:function(t,e){var n=this.ptLocator.locate(t.getCoordinate(),this.arg[e].getGeometry());t.getLabel().setAllLocations(e,n)},computeIntersectionNodes:function(t){for(var e=this.arg[t].getEdgeIterator();e.hasNext();)for(var n=e.next(),i=n.getLabel().getLocation(t),r=n.getEdgeIntersectionList().iterator();r.hasNext();){var s=r.next(),o=this.nodes.addNode(s.coord);i===L.BOUNDARY?o.setLabelBoundary(t):o.getLabel().isNull(t)&&o.setLabel(t,L.INTERIOR)}},labelIsolatedNodes:function(){for(var t=this.nodes.iterator();t.hasNext();){var e=t.next(),n=e.getLabel();f.isTrue(n.getGeometryCount()>0,"node with empty label found"),e.isIsolated()&&(n.isNull(0)?this.labelIsolatedNode(e,0):this.labelIsolatedNode(e,1))}},updateIM:function(t){for(var e=this.isolatedEdges.iterator();e.hasNext();){var n=e.next();n.updateIM(t)}for(var i=this.nodes.iterator();i.hasNext();){var r=i.next();r.updateIM(t),r.updateIMFromEdges(t)}},computeDisjointIM:function(t){var e=this.arg[0].getGeometry();e.isEmpty()||(t.set(L.INTERIOR,L.EXTERIOR,e.getDimension()),t.set(L.BOUNDARY,L.EXTERIOR,e.getBoundaryDimension()));var n=this.arg[1].getGeometry();n.isEmpty()||(t.set(L.EXTERIOR,L.INTERIOR,n.getDimension()),t.set(L.EXTERIOR,L.BOUNDARY,n.getBoundaryDimension()))},interfaces_:function(){return[]},getClass:function(){return Ar}}),e(Fr.prototype,{isContainedInBoundary:function(t){if(t instanceof Tt)return!1;if(t instanceof Lt)return this.isPointContainedInBoundary(t);if(t instanceof St)return this.isLineStringContainedInBoundary(t);for(var e=0;e<t.getNumGeometries();e++){var n=t.getGeometryN(e);if(!this.isContainedInBoundary(n))return!1}return!0},isLineSegmentContainedInBoundary:function(t,e){if(t.equals(e))return this.isPointContainedInBoundary(t);if(t.x===e.x){if(t.x===this.rectEnv.getMinX()||t.x===this.rectEnv.getMaxX())return!0}else if(t.y===e.y&&(t.y===this.rectEnv.getMinY()||t.y===this.rectEnv.getMaxY()))return!0;return!1},isLineStringContainedInBoundary:function(t){for(var e=t.getCoordinateSequence(),n=new g,i=new g,r=0;r<e.size()-1;r++)if(e.getCoordinate(r,n),e.getCoordinate(r+1,i),!this.isLineSegmentContainedInBoundary(n,i))return!1;return!0},isPointContainedInBoundary:function(){if(arguments[0]instanceof Lt){var t=arguments[0];return this.isPointContainedInBoundary(t.getCoordinate())}if(arguments[0]instanceof g){var e=arguments[0];return e.x===this.rectEnv.getMinX()||e.x===this.rectEnv.getMaxX()||e.y===this.rectEnv.getMinY()||e.y===this.rectEnv.getMaxY()}},contains:function(t){return this.rectEnv.contains(t.getEnvelopeInternal())?!this.isContainedInBoundary(t):!1},interfaces_:function(){return[]},getClass:function(){return Fr}}),Fr.contains=function(t,e){var n=new Fr(t);return n.contains(e)},e(Gr.prototype,{intersects:function(t,e){var n=new C(t,e);if(!this.rectEnv.intersects(n))return!1;if(this.rectEnv.intersects(t))return!0;if(this.rectEnv.intersects(e))return!0;if(t.compareTo(e)>0){var i=t;t=e,e=i}var r=!1;return e.y>t.y&&(r=!0),r?this.li.computeIntersection(t,e,this.diagDown0,this.diagDown1):this.li.computeIntersection(t,e,this.diagUp0,this.diagUp1),!!this.li.hasIntersection()},interfaces_:function(){return[]},getClass:function(){return Gr}}),e(qr.prototype,{applyTo:function(t){for(var e=0;e<t.getNumGeometries()&&!this._isDone;e++){var n=t.getGeometryN(e);if(n instanceof ft)this.applyTo(n);else if(this.visit(n),this.isDone())return this._isDone=!0,null}},interfaces_:function(){return[]},getClass:function(){return qr}}),e(Br.prototype,{intersects:function(t){if(!this.rectEnv.intersects(t.getEnvelopeInternal()))return!1;var e=new zr(this.rectEnv);if(e.applyTo(t),e.intersects())return!0;var n=new Vr(this.rectangle);if(n.applyTo(t),n.containsPoint())return!0;var i=new kr(this.rectangle);return i.applyTo(t),!!i.intersects()},interfaces_:function(){return[]},getClass:function(){return Br}}),Br.intersects=function(t,e){var n=new Br(t);return n.intersects(e)},h(zr,qr),e(zr.prototype,{isDone:function(){return this._intersects===!0},visit:function(t){var e=t.getEnvelopeInternal();return this.rectEnv.intersects(e)?this.rectEnv.contains(e)?(this._intersects=!0,null):e.getMinX()>=this.rectEnv.getMinX()&&e.getMaxX()<=this.rectEnv.getMaxX()?(this._intersects=!0,null):e.getMinY()>=this.rectEnv.getMinY()&&e.getMaxY()<=this.rectEnv.getMaxY()?(this._intersects=!0,null):void 0:null},intersects:function(){return this._intersects},interfaces_:function(){return[]},getClass:function(){return zr}}),h(Vr,qr),e(Vr.prototype,{isDone:function(){return this._containsPoint===!0},visit:function(t){if(!(t instanceof Tt))return null;var e=t.getEnvelopeInternal();if(!this.rectEnv.intersects(e))return null;for(var n=new g,i=0;4>i;i++)if(this.rectSeq.getCoordinate(i,n),e.contains(n)&&Tn.containsPointInPolygon(n,t))return this._containsPoint=!0,null},containsPoint:function(){return this._containsPoint},interfaces_:function(){return[]},getClass:function(){return Vr}}),h(kr,qr),e(kr.prototype,{intersects:function(){return this.hasIntersection},isDone:function(){return this.hasIntersection===!0},visit:function(t){var e=t.getEnvelopeInternal();if(!this.rectEnv.intersects(e))return null;var n=kn.getLines(t);this.checkIntersectionWithLineStrings(n)},checkIntersectionWithLineStrings:function(t){for(var e=t.iterator();e.hasNext();){var n=e.next();if(this.checkIntersectionWithSegments(n),this.hasIntersection)return null}},checkIntersectionWithSegments:function(t){for(var e=t.getCoordinateSequence(),n=1;n<e.size();n++)if(e.getCoordinate(n-1,this.p0),e.getCoordinate(n,this.p1),this.rectIntersector.intersects(this.p0,this.p1))return this.hasIntersection=!0,null},interfaces_:function(){return[]},getClass:function(){return kr}}),h(Yr,ti),e(Yr.prototype,{getIntersectionMatrix:function(){return this._relate.computeIM()},interfaces_:function(){return[]},getClass:function(){return Yr}}),Yr.covers=function(t,e){return t.getEnvelopeInternal().covers(e.getEnvelopeInternal())?t.isRectangle()?!0:Yr.relate(t,e).isCovers():!1},Yr.intersects=function(t,e){return t.getEnvelopeInternal().intersects(e.getEnvelopeInternal())?t.isRectangle()?Br.intersects(t,e):e.isRectangle()?Br.intersects(e,t):Yr.relate(t,e).isIntersects():!1},Yr.touches=function(t,e){return t.getEnvelopeInternal().intersects(e.getEnvelopeInternal())?Yr.relate(t,e).isTouches(t.getDimension(),e.getDimension()):!1},Yr.within=function(t,e){return e.contains(t)},Yr.coveredBy=function(t,e){return Yr.covers(e,t)},Yr.relate=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1],n=new Yr(t,e),i=n.getIntersectionMatrix();return i}if(3===arguments.length){if("string"==typeof arguments[2]&&arguments[0]instanceof B&&arguments[1]instanceof B){var r=arguments[0],s=arguments[1],o=arguments[2];return Yr.relateWithCheck(r,s).matches(o)}if(R(arguments[2],V)&&arguments[0]instanceof B&&arguments[1]instanceof B){var a=arguments[0],u=arguments[1],l=arguments[2],n=new Yr(a,u,l),i=n.getIntersectionMatrix();return i}}},Yr.overlaps=function(t,e){return t.getEnvelopeInternal().intersects(e.getEnvelopeInternal())?Yr.relate(t,e).isOverlaps(t.getDimension(),e.getDimension()):!1},Yr.disjoint=function(t,e){return!t.intersects(e)},Yr.relateWithCheck=function(t,e){return t.checkNotGeometryCollection(t),t.checkNotGeometryCollection(e),Yr.relate(t,e)},Yr.crosses=function(t,e){return t.getEnvelopeInternal().intersects(e.getEnvelopeInternal())?Yr.relate(t,e).isCrosses(t.getDimension(),e.getDimension()):!1},Yr.contains=function(t,e){return t.getEnvelopeInternal().contains(e.getEnvelopeInternal())?t.isRectangle()?Fr.contains(t,e):Yr.relate(t,e).isContains():!1};var To=Object.freeze({RelateOp:Yr});e(Ur.prototype,{extractElements:function(t,e){if(null===t)return null;for(var n=0;n<t.getNumGeometries();n++){var i=t.getGeometryN(n);this.skipEmpty&&i.isEmpty()||e.add(i)}},combine:function(){for(var t=new I,e=this.inputGeoms.iterator();e.hasNext();){var n=e.next();this.extractElements(n,t)}return 0===t.size()?null!==this.geomFactory?this.geomFactory.createGeometryCollection(null):null:this.geomFactory.buildGeometry(t)},interfaces_:function(){return[]},getClass:function(){return Ur}}),Ur.combine=function(){if(1===arguments.length){var t=arguments[0],e=new Ur(t);return e.combine()}if(2===arguments.length){var n=arguments[0],i=arguments[1],e=new Ur(Ur.createList(n,i));return e.combine()}if(3===arguments.length){var r=arguments[0],s=arguments[1],o=arguments[2],e=new Ur(Ur.createList(r,s,o));return e.combine()}},Ur.extractFactory=function(t){return t.isEmpty()?null:t.iterator().next().getFactory()},Ur.createList=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1],n=new I;return n.add(t),n.add(e),n}if(3===arguments.length){var i=arguments[0],r=arguments[1],s=arguments[2],n=new I;return n.add(i),n.add(r),n.add(s),n}},e(Xr.prototype,{union:function(){for(var t=new Te,e=new at,n=0;n<this.pointGeom.getNumGeometries();n++){var i=this.pointGeom.getGeometryN(n),r=i.getCoordinate(),s=t.locate(r,this.otherGeom);s===L.EXTERIOR&&e.add(r)}if(0===e.size())return this.otherGeom;var o=null,a=H.toCoordinateArray(e);return o=1===a.length?this.geomFact.createPoint(a[0]):this.geomFact.createMultiPointFromCoords(a),Ur.combine(o,this.otherGeom)},interfaces_:function(){return[]},getClass:function(){return Xr}}),Xr.union=function(t,e){var n=new Xr(t,e);return n.union()},e(Hr.prototype,{filter:function(t){-1!==this.sortIndex&&t.getSortIndex()!==this.sortIndex||this.comps.add(t)},interfaces_:function(){return[ht]},getClass:function(){return Hr}}),Hr.extract=function(){if(2===arguments.length){var t=arguments[0],e=arguments[1];return Hr.extract(t,e,new I)}if(3===arguments.length){var n=arguments[0],i=arguments[1],r=arguments[2];return n.getSortIndex()===i?r.add(n):n instanceof ft&&n.apply(new Hr(i,r)),r}},e(Wr.prototype,{reduceToGeometries:function(t){for(var e=new I,n=t.iterator();n.hasNext();){var i=n.next(),r=null;R(i,y)?r=this.unionTree(i):i instanceof B&&(r=i),e.add(r)}return e},extractByEnvelope:function(t,e,n){for(var i=new I,r=0;r<e.getNumGeometries();r++){var s=e.getGeometryN(r);s.getEnvelopeInternal().intersects(t)?i.add(s):n.add(s)}return this.geomFactory.buildGeometry(i)},unionOptimized:function(t,e){var n=t.getEnvelopeInternal(),i=e.getEnvelopeInternal();if(!n.intersects(i)){var r=Ur.combine(t,e);return r}if(t.getNumGeometries()<=1&&e.getNumGeometries()<=1)return this.unionActual(t,e);var s=n.intersection(i);return this.unionUsingEnvelopeIntersection(t,e,s)},union:function(){if(null===this.inputPolys)throw new IllegalStateException("union() method cannot be called twice");if(this.inputPolys.isEmpty())return null;this.geomFactory=this.inputPolys.iterator().next().getFactory();for(var t=new ke(Wr.STRTREE_NODE_CAPACITY),e=this.inputPolys.iterator();e.hasNext();){var n=e.next();t.insert(n.getEnvelopeInternal(),n)}this.inputPolys=null;var i=t.itemsTree(),r=this.unionTree(i);return r},binaryUnion:function(){if(1===arguments.length){var t=arguments[0];return this.binaryUnion(t,0,t.size())}if(3===arguments.length){var e=arguments[0],n=arguments[1],i=arguments[2];if(1>=i-n){var r=Wr.getGeometry(e,n);return this.unionSafe(r,null)}if(i-n===2)return this.unionSafe(Wr.getGeometry(e,n),Wr.getGeometry(e,n+1));var s=Math.trunc((i+n)/2),r=this.binaryUnion(e,n,s),o=this.binaryUnion(e,s,i);return this.unionSafe(r,o)}},repeatedUnion:function(t){for(var e=null,n=t.iterator();n.hasNext();){var i=n.next();e=null===e?i.copy():e.union(i)}return e},unionSafe:function(t,e){return null===t&&null===e?null:null===t?e.copy():null===e?t.copy():this.unionOptimized(t,e)},unionActual:function(t,e){return Wr.restrictToPolygons(t.union(e))},unionTree:function(t){var e=this.reduceToGeometries(t),n=this.binaryUnion(e);return n},unionUsingEnvelopeIntersection:function(t,e,n){var i=new I,r=this.extractByEnvelope(n,t,i),s=this.extractByEnvelope(n,e,i),o=this.unionActual(r,s);i.add(o);var a=Ur.combine(i);return a},bufferUnion:function(){if(1===arguments.length){var t=arguments[0],e=t.get(0).getFactory(),n=e.buildGeometry(t),i=n.buffer(0);return i}if(2===arguments.length){var r=arguments[0],s=arguments[1],e=r.getFactory(),n=e.createGeometryCollection([r,s]),i=n.buffer(0);return i}},interfaces_:function(){return[]},getClass:function(){return Wr}}),Wr.restrictToPolygons=function(t){if(R(t,Rt))return t;var e=or.getPolygons(t);return 1===e.size()?e.get(0):t.getFactory().createMultiPolygon(ie.toPolygonArray(e))},Wr.getGeometry=function(t,e){return e>=t.size()?null:t.get(e)},Wr.union=function(t){var e=new Wr(t);return e.union()},Wr.STRTREE_NODE_CAPACITY=4,e(jr.prototype,{unionNoOpt:function(t){var e=this.geomFact.createPoint();return si.overlayOp(t,e,ii.UNION)},unionWithNull:function(t,e){return null===t&&null===e?null:null===e?t:null===t?e:t.union(e)},extract:function(){if(R(arguments[0],v))for(var t=arguments[0],e=t.iterator();e.hasNext();){var n=e.next();this.extract(n)}else if(arguments[0]instanceof B){var i=arguments[0];null===this.geomFact&&(this.geomFact=i.getFactory()),Hr.extract(i,B.SORTINDEX_POLYGON,this.polygons),Hr.extract(i,B.SORTINDEX_LINESTRING,this.lines),Hr.extract(i,B.SORTINDEX_POINT,this.points)}},union:function t(){if(null===this.geomFact)return null;var e=null;if(this.points.size()>0){var n=this.geomFact.buildGeometry(this.points);e=this.unionNoOpt(n)}var i=null;if(this.lines.size()>0){var r=this.geomFact.buildGeometry(this.lines);i=this.unionNoOpt(r)}var s=null;this.polygons.size()>0&&(s=Wr.union(this.polygons));var o=this.unionWithNull(i,s),t=null;return t=null===e?o:null===o?e:Xr.union(e,o),null===t?this.geomFact.createGeometryCollection():t},interfaces_:function(){return[]},getClass:function(){return jr}}),jr.union=function(){if(1===arguments.length){if(R(arguments[0],v)){var t=arguments[0],e=new jr(t);return e.union()}if(arguments[0]instanceof B){var n=arguments[0],e=new jr(n);return e.union()}}else if(2===arguments.length){var i=arguments[0],r=arguments[1],e=new jr(i,r);return e.union()}};var Po=Object.freeze({UnaryUnionOp:jr});e(Kr.prototype,{visitInteriorRing:function(t,e){var n=t.getCoordinates(),i=n[0],r=Kr.findDifferentPoint(n,i),s=e.findEdgeInSameDirection(i,r),o=e.findEdgeEnd(s),a=null;o.getLabel().getLocation(0,cn.RIGHT)===L.INTERIOR?a=o:o.getSym().getLabel().getLocation(0,cn.RIGHT)===L.INTERIOR&&(a=o.getSym()),f.isTrue(null!==a,"unable to find dirEdge with Interior on RHS"),this.visitLinkedDirectedEdges(a)},visitShellInteriors:function(t,e){if(t instanceof Tt){var n=t;this.visitInteriorRing(n.getExteriorRing(),e)}if(t instanceof Ot)for(var i=t,r=0;r<i.getNumGeometries();r++){var n=i.getGeometryN(r);this.visitInteriorRing(n.getExteriorRing(),e)}},getCoordinate:function(){return this.disconnectedRingcoord},setInteriorEdgesInResult:function(t){for(var e=t.getEdgeEnds().iterator();e.hasNext();){var n=e.next();n.getLabel().getLocation(0,cn.RIGHT)===L.INTERIOR&&n.setInResult(!0)}},visitLinkedDirectedEdges:function(t){var e=t,n=t;do f.isTrue(null!==n,"found null Directed Edge"),n.setVisited(!0),n=n.getNext();while(n!==e)},buildEdgeRings:function(t){for(var e=new I,n=t.iterator();n.hasNext();){var i=n.next();if(i.isInResult()&&null===i.getEdgeRing()){var r=new vn(i,this.geometryFactory);r.linkDirectedEdgesForMinimalEdgeRings();var s=r.buildMinimalRings();e.addAll(s)}}return e},hasUnvisitedShellEdge:function(t){for(var e=0;e<t.size();e++){var n=t.get(e);if(!n.isHole()){var i=n.getEdges(),r=i.get(0);if(r.getLabel().getLocation(0,cn.RIGHT)===L.INTERIOR)for(var s=0;s<i.size();s++)if(r=i.get(s),
	!r.isVisited())return this.disconnectedRingcoord=r.getCoordinate(),!0}}return!1},isInteriorsConnected:function(){var t=new I;this.geomGraph.computeSplitEdges(t);var e=new Cn(new On);e.addEdges(t),this.setInteriorEdgesInResult(e),e.linkResultDirectedEdges();var n=this.buildEdgeRings(e.getEdgeEnds());return this.visitShellInteriors(this.geomGraph.getGeometry(),e),!this.hasUnvisitedShellEdge(n)},interfaces_:function(){return[]},getClass:function(){return Kr}}),Kr.findDifferentPoint=function(t,e){for(var n=0;n<t.length;n++)if(!t[n].equals(e))return t[n];return null},e(Zr.prototype,{hasChildren:function(){for(var t=0;2>t;t++)if(null!==this.subnode[t])return!0;return!1},isPrunable:function(){return!(this.hasChildren()||this.hasItems())},addAllItems:function(t){t.addAll(this.items);for(var e=0;2>e;e++)null!==this.subnode[e]&&this.subnode[e].addAllItems(t);return t},size:function(){for(var t=0,e=0;2>e;e++)null!==this.subnode[e]&&(t+=this.subnode[e].size());return t+this.items.size()},addAllItemsFromOverlapping:function(t,e){return null===t||this.isSearchMatch(t)?(e.addAll(this.items),null!==this.subnode[0]&&this.subnode[0].addAllItemsFromOverlapping(t,e),void(null!==this.subnode[1]&&this.subnode[1].addAllItemsFromOverlapping(t,e))):null},hasItems:function(){return!this.items.isEmpty()},remove:function(t,e){if(!this.isSearchMatch(t))return!1;for(var n=!1,i=0;2>i;i++)if(null!==this.subnode[i]&&(n=this.subnode[i].remove(t,e))){this.subnode[i].isPrunable()&&(this.subnode[i]=null);break}return n?n:n=this.items.remove(e)},getItems:function(){return this.items},depth:function(){for(var t=0,e=0;2>e;e++)if(null!==this.subnode[e]){var n=this.subnode[e].depth();n>t&&(t=n)}return t+1},nodeSize:function(){for(var t=0,e=0;2>e;e++)null!==this.subnode[e]&&(t+=this.subnode[e].nodeSize());return t+1},add:function(t){this.items.add(t)},interfaces_:function(){return[]},getClass:function(){return Zr}}),Zr.getSubnodeIndex=function(t,e){var n=-1;return t.min>=e&&(n=1),t.max<=e&&(n=0),n},e(Qr.prototype,{expandToInclude:function(t){t.max>this.max&&(this.max=t.max),t.min<this.min&&(this.min=t.min)},getWidth:function(){return this.max-this.min},overlaps:function(){if(1===arguments.length){var t=arguments[0];return this.overlaps(t.min,t.max)}if(2===arguments.length){var e=arguments[0],n=arguments[1];return!(this.min>n||this.max<e)}},getMin:function(){return this.min},toString:function(){return"["+this.min+", "+this.max+"]"},contains:function(){if(1===arguments.length){if(arguments[0]instanceof Qr){var t=arguments[0];return this.contains(t.min,t.max)}if("number"==typeof arguments[0]){var e=arguments[0];return e>=this.min&&e<=this.max}}else if(2===arguments.length){var n=arguments[0],i=arguments[1];return n>=this.min&&i<=this.max}},init:function(t,e){this.min=t,this.max=e,t>e&&(this.min=e,this.max=t)},getMax:function(){return this.max},interfaces_:function(){return[]},getClass:function(){return Qr}}),e(Jr.prototype,{getInterval:function(){return this.interval},getLevel:function(){return this.level},computeKey:function(t){for(this.level=Jr.computeLevel(t),this.interval=new Qr,this.computeInterval(this.level,t);!this.interval.contains(t);)this.level+=1,this.computeInterval(this.level,t)},computeInterval:function(t,e){var n=Ci.powerOf2(t);this.pt=Math.floor(e.getMin()/n)*n,this.interval.init(this.pt,this.pt+n)},getPoint:function(){return this.pt},interfaces_:function(){return[]},getClass:function(){return Jr}}),Jr.computeLevel=function(t){var e=t.getWidth(),n=Ci.exponent(e)+1;return n},h($r,Zr),e($r.prototype,{getInterval:function(){return this.interval},find:function(t){var e=Zr.getSubnodeIndex(t,this.centre);if(-1===e)return this;if(null!==this.subnode[e]){var n=this.subnode[e];return n.find(t)}return this},insert:function(t){f.isTrue(null===this.interval||this.interval.contains(t.interval));var e=Zr.getSubnodeIndex(t.interval,this.centre);if(t.level===this.level-1)this.subnode[e]=t;else{var n=this.createSubnode(e);n.insert(t),this.subnode[e]=n}},isSearchMatch:function(t){return t.overlaps(this.interval)},getSubnode:function(t){return null===this.subnode[t]&&(this.subnode[t]=this.createSubnode(t)),this.subnode[t]},getNode:function(t){var e=Zr.getSubnodeIndex(t,this.centre);if(-1!==e){var n=this.getSubnode(e);return n.getNode(t)}return this},createSubnode:function(t){var e=0,n=0;switch(t){case 0:e=this.interval.getMin(),n=this.centre;break;case 1:e=this.centre,n=this.interval.getMax()}var i=new Qr(e,n),r=new $r(i,this.level-1);return r},interfaces_:function(){return[]},getClass:function(){return $r}}),$r.createNode=function(t){var e=new Jr(t),n=new $r(e.getInterval(),e.getLevel());return n},$r.createExpanded=function(t,e){var n=new Qr(e);null!==t&&n.expandToInclude(t.interval);var i=$r.createNode(n);return null!==t&&i.insert(t),i},h(ts,Zr),e(ts.prototype,{insert:function(t,e){var n=Zr.getSubnodeIndex(t,ts.origin);if(-1===n)return this.add(e),null;var i=this.subnode[n];if(null===i||!i.getInterval().contains(t)){var r=$r.createExpanded(i,t);this.subnode[n]=r}this.insertContained(this.subnode[n],t,e)},isSearchMatch:function(t){return!0},insertContained:function(t,e,n){f.isTrue(t.getInterval().contains(e));var i=Ri.isZeroWidth(e.getMin(),e.getMax()),r=null;r=i?t.find(e):t.getNode(e),r.add(n)},interfaces_:function(){return[]},getClass:function(){return ts}}),ts.origin=0,e(es.prototype,{size:function(){return null!==this.root?this.root.size():0},insert:function(t,e){this.collectStats(t);var n=es.ensureExtent(t,this.minExtent);this.root.insert(n,e)},query:function(){if(1===arguments.length){if("number"==typeof arguments[0]){var t=arguments[0];return this.query(new Qr(t,t))}if(arguments[0]instanceof Qr){var e=arguments[0],n=new I;return this.query(e,n),n}}else if(2===arguments.length){var i=arguments[0],r=arguments[1];this.root.addAllItemsFromOverlapping(i,r)}},iterator:function(){var t=new I;return this.root.addAllItems(t),t.iterator()},remove:function(t,e){var n=es.ensureExtent(t,this.minExtent);return this.root.remove(n,e)},collectStats:function(t){var e=t.getWidth();e<this.minExtent&&e>0&&(this.minExtent=e)},depth:function(){return null!==this.root?this.root.depth():0},nodeSize:function(){return null!==this.root?this.root.nodeSize():0},interfaces_:function(){return[]},getClass:function(){return es}}),es.ensureExtent=function(t,e){var n=t.getMin(),i=t.getMax();return n!==i?t:(n===i&&(n-=e/2,i=n+e/2),new Qr(n,i))},e(ns.prototype,{isInside:function(t){},interfaces_:function(){return[]},getClass:function(){return ns}}),e(is.prototype,{testLineSegment:function(t,e){var n=null,i=null,r=null,s=null,o=null,a=e.p0,u=e.p1;i=a.x-t.x,r=a.y-t.y,s=u.x-t.x,o=u.y-t.y,(r>0&&0>=o||o>0&&0>=r)&&(n=ue.signOfDet2x2(i,r,s,o)/(o-r),n>0&&this.crossings++)},buildIndex:function(){this.tree=new es;for(var t=H.removeRepeatedPoints(this.ring.getCoordinates()),e=$e.getChains(t),n=0;n<e.size();n++){var i=e.get(n),r=i.getEnvelope();this.interval.min=r.getMinY(),this.interval.max=r.getMaxY(),this.tree.insert(this.interval,i)}},testMonotoneChain:function(t,e,n){n.select(t,e)},isInside:function(t){this.crossings=0;var e=new C(r.NEGATIVE_INFINITY,r.POSITIVE_INFINITY,t.y,t.y);this.interval.min=t.y,this.interval.max=t.y;for(var n=this.tree.query(this.interval),i=new rs(this,t),s=n.iterator();s.hasNext();){var o=s.next();this.testMonotoneChain(e,i,o)}return this.crossings%2===1},interfaces_:function(){return[ns]},getClass:function(){return is}}),h(rs,tr),e(rs.prototype,{select:function(){if(1!==arguments.length)return tr.prototype.select.apply(this,arguments);var t=arguments[0];this.mcp.testLineSegment(this.p,t)},interfaces_:function(){return[]},getClass:function(){return rs}}),is.MCSelecter=rs,e(ss.prototype,{insertEdgeEnds:function(t){for(var e=t.iterator();e.hasNext();){var n=e.next();this.nodes.add(n)}},getNodeIterator:function(){return this.nodes.iterator()},copyNodesAndLabels:function(t,e){for(var n=t.getNodeIterator();n.hasNext();){var i=n.next(),r=this.nodes.addNode(i.getCoordinate());r.setLabel(e,i.getLabel().getLocation(e))}},build:function(t){this.computeIntersectionNodes(t,0),this.copyNodesAndLabels(t,0);var e=new br,n=e.computeEdgeEnds(t.getEdgeIterator());this.insertEdgeEnds(n)},computeIntersectionNodes:function(t,e){for(var n=t.getEdgeIterator();n.hasNext();)for(var i=n.next(),r=i.getLabel().getLocation(e),s=i.getEdgeIntersectionList().iterator();s.hasNext();){var o=s.next(),a=this.nodes.addNode(o.coord);r===L.BOUNDARY?a.setLabelBoundary(e):a.getLabel().isNull(e)&&a.setLabel(e,L.INTERIOR)}},interfaces_:function(){return[]},getClass:function(){return ss}}),e(os.prototype,{isNodeEdgeAreaLabelsConsistent:function(){for(var t=this.nodeGraph.getNodeIterator();t.hasNext();){var e=t.next();if(!e.getEdges().isAreaLabelsConsistent(this.geomGraph))return this.invalidPoint=e.getCoordinate().copy(),!1}return!0},getInvalidPoint:function(){return this.invalidPoint},hasDuplicateRings:function(){for(var t=this.nodeGraph.getNodeIterator();t.hasNext();)for(var e=t.next(),n=e.getEdges().iterator();n.hasNext();){var i=n.next();if(i.getEdgeEnds().size()>1)return this.invalidPoint=i.getEdge().getCoordinate(0),!0}return!1},isNodeConsistentArea:function(){var t=this.geomGraph.computeSelfNodes(this.li,!0,!0);return t.hasProperIntersection()?(this.invalidPoint=t.getProperIntersectionPoint(),!1):(this.nodeGraph.build(this.geomGraph),this.isNodeEdgeAreaLabelsConsistent())},interfaces_:function(){return[]},getClass:function(){return os}}),e(as.prototype,{buildIndex:function(){this.index=new ke;for(var t=0;t<this.rings.size();t++){var e=this.rings.get(t),n=e.getEnvelopeInternal();this.index.insert(n,e)}},getNestedPoint:function(){return this.nestedPt},isNonNested:function(){this.buildIndex();for(var t=0;t<this.rings.size();t++)for(var e=this.rings.get(t),n=e.getCoordinates(),i=this.index.query(e.getEnvelopeInternal()),r=0;r<i.size();r++){var s=i.get(r),o=s.getCoordinates();if(e!==s&&e.getEnvelopeInternal().intersects(s.getEnvelopeInternal())){var a=ls.findPtNotNode(n,s,this.graph);if(null!==a){var u=he.isPointInRing(a,o);if(u)return this.nestedPt=a,!1}}}return!0},add:function(t){this.rings.add(t),this.totalEnv.expandToInclude(t.getEnvelopeInternal())},interfaces_:function(){return[]},getClass:function(){return as}}),e(us.prototype,{getErrorType:function(){return this.errorType},getMessage:function(){return us.errMsg[this.errorType]},getCoordinate:function(){return this.pt},toString:function(){var t="";return null!==this.pt&&(t=" at or near point "+this.pt),this.getMessage()+t},interfaces_:function(){return[]},getClass:function(){return us}}),us.ERROR=0,us.REPEATED_POINT=1,us.HOLE_OUTSIDE_SHELL=2,us.NESTED_HOLES=3,us.DISCONNECTED_INTERIOR=4,us.SELF_INTERSECTION=5,us.RING_SELF_INTERSECTION=6,us.NESTED_SHELLS=7,us.DUPLICATE_RINGS=8,us.TOO_FEW_POINTS=9,us.INVALID_COORDINATE=10,us.RING_NOT_CLOSED=11,us.errMsg=["Topology Validation Error","Repeated Point","Hole lies outside shell","Holes are nested","Interior is disconnected","Self-intersection","Ring Self-intersection","Nested shells","Duplicate Rings","Too few distinct points in geometry component","Invalid Coordinate","Ring is not closed"],e(ls.prototype,{checkInvalidCoordinates:function(){if(arguments[0]instanceof Array){for(var t=arguments[0],e=0;e<t.length;e++)if(!ls.isValid(t[e]))return this.validErr=new us(us.INVALID_COORDINATE,t[e]),null}else if(arguments[0]instanceof Tt){var n=arguments[0];if(this.checkInvalidCoordinates(n.getExteriorRing().getCoordinates()),null!==this.validErr)return null;for(var e=0;e<n.getNumInteriorRing();e++)if(this.checkInvalidCoordinates(n.getInteriorRingN(e).getCoordinates()),null!==this.validErr)return null}},checkHolesNotNested:function(t,e){for(var n=new as(e),i=0;i<t.getNumInteriorRing();i++){var r=t.getInteriorRingN(i);n.add(r)}var s=n.isNonNested();s||(this.validErr=new us(us.NESTED_HOLES,n.getNestedPoint()))},checkConsistentArea:function(t){var e=new os(t),n=e.isNodeConsistentArea();return n?void(e.hasDuplicateRings()&&(this.validErr=new us(us.DUPLICATE_RINGS,e.getInvalidPoint()))):(this.validErr=new us(us.SELF_INTERSECTION,e.getInvalidPoint()),null)},isValid:function(){return this.checkValid(this.parentGeometry),null===this.validErr},checkShellInsideHole:function(t,e,n){var i=t.getCoordinates(),r=e.getCoordinates(),s=ls.findPtNotNode(i,e,n);if(null!==s){var o=he.isPointInRing(s,r);if(!o)return s}var a=ls.findPtNotNode(r,t,n);if(null!==a){var u=he.isPointInRing(a,i);return u?a:null}return f.shouldNeverReachHere("points in shell and hole appear to be equal"),null},checkNoSelfIntersectingRings:function(t){for(var e=t.getEdgeIterator();e.hasNext();){var n=e.next();if(this.checkNoSelfIntersectingRing(n.getEdgeIntersectionList()),null!==this.validErr)return null}},checkConnectedInteriors:function(t){var e=new Kr(t);e.isInteriorsConnected()||(this.validErr=new us(us.DISCONNECTED_INTERIOR,e.getCoordinate()))},checkNoSelfIntersectingRing:function(t){for(var e=new at,n=!0,i=t.iterator();i.hasNext();){var r=i.next();if(n)n=!1;else{if(e.contains(r.coord))return this.validErr=new us(us.RING_SELF_INTERSECTION,r.coord),null;e.add(r.coord)}}},checkHolesInShell:function(t,e){for(var n=t.getExteriorRing(),i=new is(n),r=0;r<t.getNumInteriorRing();r++){var s=t.getInteriorRingN(r),o=ls.findPtNotNode(s.getCoordinates(),n,e);if(null===o)return null;var a=!i.isInside(o);if(a)return this.validErr=new us(us.HOLE_OUTSIDE_SHELL,o),null}},checkTooFewPoints:function(t){return t.hasTooFewPoints()?(this.validErr=new us(us.TOO_FEW_POINTS,t.getInvalidPoint()),null):void 0},getValidationError:function(){return this.checkValid(this.parentGeometry),this.validErr},checkValid:function(){if(arguments[0]instanceof Lt){var t=arguments[0];this.checkInvalidCoordinates(t.getCoordinates())}else if(arguments[0]instanceof Pt){var e=arguments[0];this.checkInvalidCoordinates(e.getCoordinates())}else if(arguments[0]instanceof bt){var n=arguments[0];if(this.checkInvalidCoordinates(n.getCoordinates()),null!==this.validErr)return null;if(this.checkClosedRing(n),null!==this.validErr)return null;var i=new $n(0,n);if(this.checkTooFewPoints(i),null!==this.validErr)return null;var r=new ae;i.computeSelfNodes(r,!0,!0),this.checkNoSelfIntersectingRings(i)}else if(arguments[0]instanceof St){var s=arguments[0];if(this.checkInvalidCoordinates(s.getCoordinates()),null!==this.validErr)return null;var i=new $n(0,s);this.checkTooFewPoints(i)}else if(arguments[0]instanceof Tt){var o=arguments[0];if(this.checkInvalidCoordinates(o),null!==this.validErr)return null;if(this.checkClosedRings(o),null!==this.validErr)return null;var i=new $n(0,o);if(this.checkTooFewPoints(i),null!==this.validErr)return null;if(this.checkConsistentArea(i),null!==this.validErr)return null;if(!this.isSelfTouchingRingFormingHoleValid&&(this.checkNoSelfIntersectingRings(i),null!==this.validErr))return null;if(this.checkHolesInShell(o,i),null!==this.validErr)return null;if(this.checkHolesNotNested(o,i),null!==this.validErr)return null;this.checkConnectedInteriors(i)}else if(arguments[0]instanceof Ot){for(var a=arguments[0],u=0;u<a.getNumGeometries();u++){var l=a.getGeometryN(u);if(this.checkInvalidCoordinates(l),null!==this.validErr)return null;if(this.checkClosedRings(l),null!==this.validErr)return null}var i=new $n(0,a);if(this.checkTooFewPoints(i),null!==this.validErr)return null;if(this.checkConsistentArea(i),null!==this.validErr)return null;if(!this.isSelfTouchingRingFormingHoleValid&&(this.checkNoSelfIntersectingRings(i),null!==this.validErr))return null;for(var u=0;u<a.getNumGeometries();u++){var l=a.getGeometryN(u);if(this.checkHolesInShell(l,i),null!==this.validErr)return null}for(var u=0;u<a.getNumGeometries();u++){var l=a.getGeometryN(u);if(this.checkHolesNotNested(l,i),null!==this.validErr)return null}if(this.checkShellsNotNested(a,i),null!==this.validErr)return null;this.checkConnectedInteriors(i)}else if(arguments[0]instanceof ft)for(var h=arguments[0],u=0;u<h.getNumGeometries();u++){var c=h.getGeometryN(u);if(this.checkValid(c),null!==this.validErr)return null}else if(arguments[0]instanceof B){var f=arguments[0];if(this.validErr=null,f.isEmpty())return null;if(f instanceof Lt)this.checkValid(f);else if(f instanceof Pt)this.checkValid(f);else if(f instanceof bt)this.checkValid(f);else if(f instanceof St)this.checkValid(f);else if(f instanceof Tt)this.checkValid(f);else if(f instanceof Ot)this.checkValid(f);else{if(!(f instanceof ft))throw new UnsupportedOperationException(f.getClass().getName());this.checkValid(f)}}},setSelfTouchingRingFormingHoleValid:function(t){this.isSelfTouchingRingFormingHoleValid=t},checkShellNotNested:function(t,e,n){var i=t.getCoordinates(),r=e.getExteriorRing(),s=r.getCoordinates(),o=ls.findPtNotNode(i,r,n);if(null===o)return null;var a=he.isPointInRing(o,s);if(!a)return null;if(e.getNumInteriorRing()<=0)return this.validErr=new us(us.NESTED_SHELLS,o),null;for(var u=null,l=0;l<e.getNumInteriorRing();l++){var h=e.getInteriorRingN(l);if(u=this.checkShellInsideHole(t,h,n),null===u)return null}this.validErr=new us(us.NESTED_SHELLS,u)},checkClosedRings:function(t){if(this.checkClosedRing(t.getExteriorRing()),null!==this.validErr)return null;for(var e=0;e<t.getNumInteriorRing();e++)if(this.checkClosedRing(t.getInteriorRingN(e)),null!==this.validErr)return null},checkClosedRing:function(t){if(!t.isClosed()){var e=null;t.getNumPoints()>=1&&(e=t.getCoordinateN(0)),this.validErr=new us(us.RING_NOT_CLOSED,e)}},checkShellsNotNested:function(t,e){for(var n=0;n<t.getNumGeometries();n++)for(var i=t.getGeometryN(n),r=i.getExteriorRing(),s=0;s<t.getNumGeometries();s++)if(n!==s){var o=t.getGeometryN(s);if(this.checkShellNotNested(r,o,e),null!==this.validErr)return null}},interfaces_:function(){return[]},getClass:function(){return ls}}),ls.findPtNotNode=function(t,e,n){for(var i=n.findEdge(e),r=i.getEdgeIntersectionList(),s=0;s<t.length;s++){var o=t[s];if(!r.isIntersection(o))return o}return null},ls.isValid=function(){if(arguments[0]instanceof B){var t=arguments[0],e=new ls(t);return e.isValid()}if(arguments[0]instanceof g){var n=arguments[0];return r.isNaN(n.x)?!1:r.isInfinite(n.x)?!1:r.isNaN(n.y)?!1:!r.isInfinite(n.y)}};var bo=Object.freeze({IsValidOp:ls}),Oo=Object.freeze({BoundaryOp:dt,IsSimpleOp:Gi,buffer:Co,distance:So,linemerge:wo,overlay:Lo,polygonize:Ro,relate:To,union:Po,valid:bo});h(hs,_t.CoordinateOperation),e(hs.prototype,{editCoordinates:function(t,e){if(0===t.length)return null;for(var n=new Array(t.length).fill(null),i=0;i<t.length;i++){var r=new g(t[i]);this.targetPM.makePrecise(r),n[i]=r}var s=new N(n,!1),o=s.toCoordinateArray(),a=0;e instanceof St&&(a=2),e instanceof bt&&(a=4);var u=n;return this.removeCollapsed&&(u=null),o.length<a?u:o},interfaces_:function(){return[]},getClass:function(){return hs}}),e(cs.prototype,{fixPolygonalTopology:function(t){var e=t;this.changePrecisionModel||(e=this.changePM(t,this.targetPM));var n=e.buffer(0),i=n;return this.changePrecisionModel||(i=t.getFactory().createGeometry(n)),i},reducePointwise:function(t){var e=null;if(this.changePrecisionModel){var n=this.createFactory(t.getFactory(),this.targetPM);e=new _t(n)}else e=new _t;var i=this.removeCollapsed;t.getDimension()>=2&&(i=!0);var r=e.edit(t,new hs(this.targetPM,i));return r},changePM:function(t,e){var n=this.createEditor(t.getFactory(),e);return n.edit(t,new _t.NoOpGeometryOperation)},setRemoveCollapsedComponents:function(t){this.removeCollapsed=t},createFactory:function(t,e){var n=new ie(e,t.getSRID(),t.getCoordinateSequenceFactory());return n},setChangePrecisionModel:function(t){this.changePrecisionModel=t},reduce:function(t){var e=this.reducePointwise(t);return this.isPointwise?e:R(e,Rt)?e.isValid()?e:this.fixPolygonalTopology(e):e},setPointwise:function(t){this.isPointwise=t},createEditor:function(t,e){if(t.getPrecisionModel()===e)return new _t;var n=this.createFactory(t,e),i=new _t(n);return i},interfaces_:function(){return[]},getClass:function(){return cs}}),cs.reduce=function(t,e){var n=new cs(e);return n.reduce(t)},cs.reducePointwise=function(t,e){var n=new cs(e);return n.setPointwise(!0),n.reduce(t)};var _o=Object.freeze({GeometryPrecisionReducer:cs});e(fs.prototype,{simplifySection:function(t,e){if(t+1===e)return null;this.seg.p0=this.pts[t],this.seg.p1=this.pts[e];for(var n=-1,i=t,r=t+1;e>r;r++){var s=this.seg.distance(this.pts[r]);s>n&&(n=s,i=r)}if(n<=this.distanceTolerance)for(var r=t+1;e>r;r++)this.usePt[r]=!1;else this.simplifySection(t,i),this.simplifySection(i,e)},setDistanceTolerance:function(t){this.distanceTolerance=t},simplify:function(){this.usePt=new Array(this.pts.length).fill(null);for(var t=0;t<this.pts.length;t++)this.usePt[t]=!0;this.simplifySection(0,this.pts.length-1);for(var e=new N,t=0;t<this.pts.length;t++)this.usePt[t]&&e.add(new g(this.pts[t]));return e.toCoordinateArray()},interfaces_:function(){return[]},getClass:function(){return fs}}),fs.simplify=function(t,e){var n=new fs(t);return n.setDistanceTolerance(e),n.simplify()},e(gs.prototype,{setEnsureValid:function(t){this.isEnsureValidTopology=t},getResultGeometry:function(){return this.inputGeom.isEmpty()?this.inputGeom.copy():new ds(this.isEnsureValidTopology,this.distanceTolerance).transform(this.inputGeom)},setDistanceTolerance:function(t){if(0>t)throw new i("Tolerance must be non-negative");this.distanceTolerance=t},interfaces_:function(){return[]},getClass:function(){return gs}}),gs.simplify=function(t,e){var n=new gs(t);return n.setDistanceTolerance(e),n.getResultGeometry()},h(ds,xe),e(ds.prototype,{transformPolygon:function(t,e){if(t.isEmpty())return null;var n=xe.prototype.transformPolygon.call(this,t,e);return e instanceof Ot?n:this.createValidArea(n)},createValidArea:function(t){return this.isEnsureValidTopology?t.buffer(0):t},transformCoordinates:function(t,e){var n=t.toCoordinateArray(),i=null;return i=0===n.length?new Array(0).fill(null):fs.simplify(n,this.distanceTolerance),this.factory.getCoordinateSequenceFactory().create(i)},transformMultiPolygon:function(t,e){var n=xe.prototype.transformMultiPolygon.call(this,t,e);return this.createValidArea(n)},transformLinearRing:function(t,e){var n=e instanceof Tt,i=xe.prototype.transformLinearRing.call(this,t,e);return!n||i instanceof bt?i:null},interfaces_:function(){return[]},getClass:function(){return ds}}),gs.DPTransformer=ds,h(ps,ce),e(ps.prototype,{getIndex:function(){return this.index},getParent:function(){return this.parent},interfaces_:function(){return[]},getClass:function(){return ps}}),e(vs.prototype,{addToResult:function(t){this.resultSegs.add(t)},asLineString:function(){return this.parentLine.getFactory().createLineString(vs.extractCoordinates(this.resultSegs))},getResultSize:function(){var t=this.resultSegs.size();return 0===t?0:t+1},getParent:function(){return this.parentLine},getSegment:function(t){return this.segs[t]},getParentCoordinates:function(){return this.parentLine.getCoordinates()},getMinimumSize:function(){return this.minimumSize},asLinearRing:function(){return this.parentLine.getFactory().createLinearRing(vs.extractCoordinates(this.resultSegs))},getSegments:function(){return this.segs},init:function(){var t=this.parentLine.getCoordinates();this.segs=new Array(t.length-1).fill(null);for(var e=0;e<t.length-1;e++){var n=new ps(t[e],t[e+1],this.parentLine,e);this.segs[e]=n}},getResultCoordinates:function(){return vs.extractCoordinates(this.resultSegs)},interfaces_:function(){return[]},getClass:function(){return vs}}),vs.extractCoordinates=function(t){for(var e=new Array(t.size()+1).fill(null),n=null,i=0;i<t.size();i++)n=t.get(i),e[i]=n.p0;return e[e.length-1]=n.p1,e},e(ms.prototype,{remove:function(t){this.index.remove(new C(t.p0,t.p1),t)},add:function(){if(arguments[0]instanceof vs)for(var t=arguments[0],e=t.getSegments(),n=0;n<e.length;n++){var i=e[n];this.add(i)}else if(arguments[0]instanceof ce){var r=arguments[0];this.index.insert(new C(r.p0,r.p1),r)}},query:function(t){var e=new C(t.p0,t.p1),n=new ys(t);this.index.query(e,n);var i=n.getItems();return i},interfaces_:function(){return[]},getClass:function(){return ms}}),e(ys.prototype,{visitItem:function(t){var e=t;C.intersects(e.p0,e.p1,this.querySeg.p0,this.querySeg.p1)&&this.items.add(t)},getItems:function(){return this.items},interfaces_:function(){return[Ae]},getClass:function(){return ys}}),e(xs.prototype,{flatten:function(t,e){var n=this.linePts[t],i=this.linePts[e],r=new ce(n,i);return this.remove(this.line,t,e),this.outputIndex.add(r),r},hasBadIntersection:function(t,e,n){return this.hasBadOutputIntersection(n)?!0:!!this.hasBadInputIntersection(t,e,n)},setDistanceTolerance:function(t){this.distanceTolerance=t},simplifySection:function(t,e,n){n+=1;var i=new Array(2).fill(null);if(t+1===e){var r=this.line.getSegment(t);return this.line.addToResult(r),null}var s=!0;if(this.line.getResultSize()<this.line.getMinimumSize()){var o=n+1;o<this.line.getMinimumSize()&&(s=!1)}var a=new Array(1).fill(null),u=this.findFurthestPoint(this.linePts,t,e,a);a[0]>this.distanceTolerance&&(s=!1);var l=new ce;if(l.p0=this.linePts[t],l.p1=this.linePts[e],i[0]=t,i[1]=e,this.hasBadIntersection(this.line,i,l)&&(s=!1),s){var r=this.flatten(t,e);return this.line.addToResult(r),null}this.simplifySection(t,u,n),this.simplifySection(u,e,n)},hasBadOutputIntersection:function(t){for(var e=this.outputIndex.query(t),n=e.iterator();n.hasNext();){var i=n.next();if(this.hasInteriorIntersection(i,t))return!0}return!1},findFurthestPoint:function(t,e,n,i){var r=new ce;r.p0=t[e],r.p1=t[n];for(var s=-1,o=e,a=e+1;n>a;a++){var u=t[a],l=r.distance(u);l>s&&(s=l,o=a)}return i[0]=s,o},simplify:function(t){this.line=t,this.linePts=t.getParentCoordinates(),this.simplifySection(0,this.linePts.length-1,0)},remove:function(t,e,n){for(var i=e;n>i;i++){var r=t.getSegment(i);this.inputIndex.remove(r)}},hasInteriorIntersection:function(t,e){return this.li.computeIntersection(t.p0,t.p1,e.p0,e.p1),this.li.isInteriorIntersection()},hasBadInputIntersection:function(t,e,n){for(var i=this.inputIndex.query(n),r=i.iterator();r.hasNext();){var s=r.next();if(this.hasInteriorIntersection(s,n)){if(xs.isInLineSection(t,e,s))continue;return!0}}return!1},interfaces_:function(){return[]},getClass:function(){return xs}}),xs.isInLineSection=function(t,e,n){if(n.getParent()!==t.getParent())return!1;var i=n.getIndex();return i>=e[0]&&i<e[1]},e(Es.prototype,{setDistanceTolerance:function(t){this.distanceTolerance=t},simplify:function(t){for(var e=t.iterator();e.hasNext();)this.inputIndex.add(e.next());for(var e=t.iterator();e.hasNext();){var n=new xs(this.inputIndex,this.outputIndex);n.setDistanceTolerance(this.distanceTolerance),n.simplify(e.next())}},interfaces_:function(){return[]},getClass:function(){return Es}}),e(Is.prototype,{getResultGeometry:function(){if(this.inputGeom.isEmpty())return this.inputGeom.copy();this.linestringMap=new te,this.inputGeom.apply(new Cs(this)),this.lineSimplifier.simplify(this.linestringMap.values());var t=new Ns(this.linestringMap).transform(this.inputGeom);return t},setDistanceTolerance:function(t){if(0>t)throw new i("Tolerance must be non-negative");this.lineSimplifier.setDistanceTolerance(t)},interfaces_:function(){return[]},getClass:function(){return Is}}),Is.simplify=function(t,e){var n=new Is(t);return n.setDistanceTolerance(e),n.getResultGeometry()},h(Ns,xe),e(Ns.prototype,{transformCoordinates:function(t,e){if(0===t.size())return null;if(e instanceof St){var n=this.linestringMap.get(e);return this.createCoordinateSequence(n.getResultCoordinates())}return xe.prototype.transformCoordinates.call(this,t,e)},interfaces_:function(){return[]},getClass:function(){return Ns}}),e(Cs.prototype,{filter:function(t){if(t instanceof St){var e=t;if(e.isEmpty())return null;var n=e.isClosed()?4:2,i=new vs(e,n);this.tps.linestringMap.put(e,i)}},interfaces_:function(){return[q]},getClass:function(){return Cs}}),Is.LineStringTransformer=Ns,Is.LineStringMapBuilderFilter=Cs;var Mo=Object.freeze({DouglasPeuckerSimplifier:gs,TopologyPreservingSimplifier:Is});e(Ss.prototype,{splitAt:function(){if(1===arguments.length){var t=arguments[0],e=this.minimumLen/this.segLen;if(t.distance(this.seg.p0)<this.minimumLen)return this.splitPt=this.seg.pointAlong(e),null;if(t.distance(this.seg.p1)<this.minimumLen)return this.splitPt=Ss.pointAlongReverse(this.seg,e),null;this.splitPt=t}else if(2===arguments.length){var n=arguments[0],i=arguments[1],r=this.getConstrainedLength(n),s=r/this.segLen;i.equals2D(this.seg.p0)?this.splitPt=this.seg.pointAlong(s):this.splitPt=Ss.pointAlongReverse(this.seg,s)}},setMinimumLength:function(t){this.minimumLen=t},getConstrainedLength:function(t){return t<this.minimumLen?this.minimumLen:t},getSplitPoint:function(){return this.splitPt},interfaces_:function(){return[]},getClass:function(){return Ss}}),Ss.pointAlongReverse=function(t,e){var n=new g;return n.x=t.p1.x-e*(t.p1.x-t.p0.x),n.y=t.p1.y-e*(t.p1.y-t.p0.y),n},e(ws.prototype,{findSplitPoint:function(t,e){},interfaces_:function(){return[]},getClass:function(){return ws}}),e(Ls.prototype,{findSplitPoint:function(t,e){var n=t.getLineSegment(),i=n.getLength(),r=i/2,s=new Ss(n),o=Ls.projectedSplitPoint(t,e),a=2*o.distance(e)*.8,u=a;return u>r&&(u=r),s.setMinimumLength(u),s.splitAt(o),s.getSplitPoint()},interfaces_:function(){return[ws]},getClass:function(){return Ls}}),Ls.projectedSplitPoint=function(t,e){var n=t.getLineSegment(),i=n.project(e);return i},e(Rs.prototype,{interfaces_:function(){return[]},getClass:function(){return Rs}}),Rs.triArea=function(t,e,n){return(e.x-t.x)*(n.y-t.y)-(e.y-t.y)*(n.x-t.x)},Rs.isInCircleDDNormalized=function(t,e,n,i){var r=_.valueOf(t.x).selfSubtract(i.x),s=_.valueOf(t.y).selfSubtract(i.y),o=_.valueOf(e.x).selfSubtract(i.x),a=_.valueOf(e.y).selfSubtract(i.y),u=_.valueOf(n.x).selfSubtract(i.x),l=_.valueOf(n.y).selfSubtract(i.y),h=r.multiply(a).selfSubtract(o.multiply(s)),c=o.multiply(l).selfSubtract(u.multiply(a)),f=u.multiply(s).selfSubtract(r.multiply(l)),g=r.multiply(r).selfAdd(s.multiply(s)),d=o.multiply(o).selfAdd(a.multiply(a)),p=u.multiply(u).selfAdd(l.multiply(l)),v=g.selfMultiply(c).selfAdd(d.selfMultiply(f)).selfAdd(p.selfMultiply(h)),m=v.doubleValue()>0;return m},Rs.checkRobustInCircle=function(t,e,n,i){var r=Rs.isInCircleNonRobust(t,e,n,i),s=Rs.isInCircleDDSlow(t,e,n,i),o=Rs.isInCircleCC(t,e,n,i),a=ci.circumcentre(t,e,n);A.out.println("p radius diff a = "+Math.abs(i.distance(a)-t.distance(a))/t.distance(a)),r===s&&r===o||(A.out.println("inCircle robustness failure (double result = "+r+", DD result = "+s+", CC result = "+o+")"),A.out.println(se.toLineString(new Gt([t,e,n,i]))),A.out.println("Circumcentre = "+se.toPoint(a)+" radius = "+t.distance(a)),A.out.println("p radius diff a = "+Math.abs(i.distance(a)/t.distance(a)-1)),A.out.println("p radius diff b = "+Math.abs(i.distance(a)/e.distance(a)-1)),A.out.println("p radius diff c = "+Math.abs(i.distance(a)/n.distance(a)-1)),A.out.println())},Rs.isInCircleDDFast=function(t,e,n,i){var r=_.sqr(t.x).selfAdd(_.sqr(t.y)).selfMultiply(Rs.triAreaDDFast(e,n,i)),s=_.sqr(e.x).selfAdd(_.sqr(e.y)).selfMultiply(Rs.triAreaDDFast(t,n,i)),o=_.sqr(n.x).selfAdd(_.sqr(n.y)).selfMultiply(Rs.triAreaDDFast(t,e,i)),a=_.sqr(i.x).selfAdd(_.sqr(i.y)).selfMultiply(Rs.triAreaDDFast(t,e,n)),u=r.selfSubtract(s).selfAdd(o).selfSubtract(a),l=u.doubleValue()>0;return l},Rs.isInCircleCC=function(t,e,n,i){var r=ci.circumcentre(t,e,n),s=t.distance(r),o=i.distance(r)-s;return 0>=o},Rs.isInCircleNormalized=function(t,e,n,i){var r=t.x-i.x,s=t.y-i.y,o=e.x-i.x,a=e.y-i.y,u=n.x-i.x,l=n.y-i.y,h=r*a-o*s,c=o*l-u*a,f=u*s-r*l,g=r*r+s*s,d=o*o+a*a,p=u*u+l*l,v=g*c+d*f+p*h;return v>0},Rs.isInCircleDDSlow=function(t,e,n,i){var r=_.valueOf(i.x),s=_.valueOf(i.y),o=_.valueOf(t.x),a=_.valueOf(t.y),u=_.valueOf(e.x),l=_.valueOf(e.y),h=_.valueOf(n.x),c=_.valueOf(n.y),f=o.multiply(o).add(a.multiply(a)).multiply(Rs.triAreaDDSlow(u,l,h,c,r,s)),g=u.multiply(u).add(l.multiply(l)).multiply(Rs.triAreaDDSlow(o,a,h,c,r,s)),d=h.multiply(h).add(c.multiply(c)).multiply(Rs.triAreaDDSlow(o,a,u,l,r,s)),p=r.multiply(r).add(s.multiply(s)).multiply(Rs.triAreaDDSlow(o,a,u,l,h,c)),v=f.subtract(g).add(d).subtract(p),m=v.doubleValue()>0;
	return m},Rs.isInCircleNonRobust=function(t,e,n,i){var r=(t.x*t.x+t.y*t.y)*Rs.triArea(e,n,i)-(e.x*e.x+e.y*e.y)*Rs.triArea(t,n,i)+(n.x*n.x+n.y*n.y)*Rs.triArea(t,e,i)-(i.x*i.x+i.y*i.y)*Rs.triArea(t,e,n)>0;return r},Rs.isInCircleRobust=function(t,e,n,i){return Rs.isInCircleNormalized(t,e,n,i)},Rs.triAreaDDSlow=function(t,e,n,i,r,s){return n.subtract(t).multiply(s.subtract(e)).subtract(i.subtract(e).multiply(r.subtract(t)))},Rs.triAreaDDFast=function(t,e,n){var i=_.valueOf(e.x).selfSubtract(t.x).selfMultiply(_.valueOf(n.y).selfSubtract(t.y)),r=_.valueOf(e.y).selfSubtract(t.y).selfMultiply(_.valueOf(n.x).selfSubtract(t.x));return i.selfSubtract(r)},e(Ts.prototype,{circleCenter:function(t,e){var n=new Ts(this.getX(),this.getY()),i=this.bisector(n,t),r=this.bisector(t,e),s=new F(i,r),o=null;try{o=new Ts(s.getX(),s.getY())}catch(i){if(!(i instanceof w))throw i;A.err.println("a: "+n+"  b: "+t+"  c: "+e),A.err.println(i)}finally{}return o},dot:function(t){return this.p.x*t.getX()+this.p.y*t.getY()},magn:function(){return Math.sqrt(this.p.x*this.p.x+this.p.y*this.p.y)},getZ:function(){return this.p.z},bisector:function(t,e){var n=e.getX()-t.getX(),i=e.getY()-t.getY(),r=new F(t.getX()+n/2,t.getY()+i/2,1),s=new F(t.getX()-i+n/2,t.getY()+n+i/2,1);return new F(r,s)},equals:function(){if(1===arguments.length){var t=arguments[0];return this.p.x===t.getX()&&this.p.y===t.getY()}if(2===arguments.length){var e=arguments[0],n=arguments[1];return this.p.distance(e.getCoordinate())<n}},getCoordinate:function(){return this.p},isInCircle:function(t,e,n){return Rs.isInCircleRobust(t.p,e.p,n.p,this.p)},interpolateZValue:function(t,e,n){var i=t.getX(),r=t.getY(),s=e.getX()-i,o=n.getX()-i,a=e.getY()-r,u=n.getY()-r,l=s*u-o*a,h=this.getX()-i,c=this.getY()-r,f=(u*h-o*c)/l,g=(-a*h+s*c)/l,d=t.getZ()+f*(e.getZ()-t.getZ())+g*(n.getZ()-t.getZ());return d},midPoint:function(t){var e=(this.p.x+t.getX())/2,n=(this.p.y+t.getY())/2,i=(this.p.z+t.getZ())/2;return new Ts(e,n,i)},rightOf:function(t){return this.isCCW(t.dest(),t.orig())},isCCW:function(t,e){return(t.p.x-this.p.x)*(e.p.y-this.p.y)-(t.p.y-this.p.y)*(e.p.x-this.p.x)>0},getX:function(){return this.p.x},crossProduct:function(t){return this.p.x*t.getY()-this.p.y*t.getX()},setZ:function(t){this.p.z=t},times:function(t){return new Ts(t*this.p.x,t*this.p.y)},cross:function(){return new Ts(this.p.y,-this.p.x)},leftOf:function(t){return this.isCCW(t.orig(),t.dest())},toString:function(){return"POINT ("+this.p.x+" "+this.p.y+")"},sub:function(t){return new Ts(this.p.x-t.getX(),this.p.y-t.getY())},getY:function(){return this.p.y},classify:function(t,e){var n=this,i=e.sub(t),r=n.sub(t),s=i.crossProduct(r);return s>0?Ts.LEFT:0>s?Ts.RIGHT:i.getX()*r.getX()<0||i.getY()*r.getY()<0?Ts.BEHIND:i.magn()<r.magn()?Ts.BEYOND:t.equals(n)?Ts.ORIGIN:e.equals(n)?Ts.DESTINATION:Ts.BETWEEN},sum:function(t){return new Ts(this.p.x+t.getX(),this.p.y+t.getY())},distance:function(t,e){return Math.sqrt(Math.pow(e.getX()-t.getX(),2)+Math.pow(e.getY()-t.getY(),2))},circumRadiusRatio:function(t,e){var n=this.circleCenter(t,e),i=this.distance(n,t),r=this.distance(this,t),s=this.distance(t,e);return r>s&&(r=s),s=this.distance(e,this),r>s&&(r=s),i/r},interfaces_:function(){return[]},getClass:function(){return Ts}}),Ts.interpolateZ=function(){if(3===arguments.length){var t=arguments[0],e=arguments[1],n=arguments[2],i=e.distance(n),r=t.distance(e),s=n.z-e.z,o=e.z+s*(r/i);return o}if(4===arguments.length){var a=arguments[0],u=arguments[1],l=arguments[2],h=arguments[3],c=u.x,f=u.y,g=l.x-c,d=h.x-c,p=l.y-f,v=h.y-f,m=g*v-d*p,y=a.x-c,x=a.y-f,E=(v*y-d*x)/m,I=(-p*y+g*x)/m,N=u.z+E*(l.z-u.z)+I*(h.z-u.z);return N}},Ts.LEFT=0,Ts.RIGHT=1,Ts.BEYOND=2,Ts.BEHIND=3,Ts.BETWEEN=4,Ts.ORIGIN=5,Ts.DESTINATION=6,h(Ps,Ts),e(Ps.prototype,{getConstraint:function(){return this.constraint},setOnConstraint:function(t){this._isOnConstraint=t},merge:function(t){t._isOnConstraint&&(this._isOnConstraint=!0,this.constraint=t.constraint)},isOnConstraint:function(){return this._isOnConstraint},setConstraint:function(t){this._isOnConstraint=!0,this.constraint=t},interfaces_:function(){return[]},getClass:function(){return Ps}}),e(bs.prototype,{equalsNonOriented:function(t){return this.equalsOriented(t)?!0:!!this.equalsOriented(t.sym())},toLineSegment:function(){return new ce(this.vertex.getCoordinate(),this.dest().getCoordinate())},dest:function(){return this.sym().orig()},oNext:function(){return this.next},equalsOriented:function(t){return!(!this.orig().getCoordinate().equals2D(t.orig().getCoordinate())||!this.dest().getCoordinate().equals2D(t.dest().getCoordinate()))},dNext:function(){return this.sym().oNext().sym()},lPrev:function(){return this.next.sym()},rPrev:function(){return this.sym().oNext()},rot:function(){return this._rot},oPrev:function(){return this._rot.next._rot},sym:function(){return this._rot._rot},setOrig:function(t){this.vertex=t},lNext:function(){return this.invRot().oNext().rot()},getLength:function(){return this.orig().getCoordinate().distance(this.dest().getCoordinate())},invRot:function(){return this._rot.sym()},setDest:function(t){this.sym().setOrig(t)},setData:function(t){this.data=t},getData:function(){return this.data},delete:function(){this._rot=null},orig:function(){return this.vertex},rNext:function(){return this._rot.next.invRot()},toString:function(){var t=this.vertex.getCoordinate(),e=this.dest().getCoordinate();return se.toLineString(t,e)},isLive:function(){return null!==this._rot},getPrimary:function(){return this.orig().getCoordinate().compareTo(this.dest().getCoordinate())<=0?this:this.sym()},dPrev:function(){return this.invRot().oNext().invRot()},setNext:function(t){this.next=t},interfaces_:function(){return[]},getClass:function(){return bs}}),bs.makeEdge=function(t,e){var n=new bs,i=new bs,r=new bs,s=new bs;n._rot=i,i._rot=r,r._rot=s,s._rot=n,n.setNext(n),i.setNext(s),r.setNext(r),s.setNext(i);var o=n;return o.setOrig(t),o.setDest(e),o},bs.swap=function(t){var e=t.oPrev(),n=t.sym().oPrev();bs.splice(t,e),bs.splice(t.sym(),n),bs.splice(t,e.lNext()),bs.splice(t.sym(),n.lNext()),t.setOrig(e.dest()),t.setDest(n.dest())},bs.splice=function(t,e){var n=t.oNext().rot(),i=e.oNext().rot(),r=e.oNext(),s=t.oNext(),o=i.oNext(),a=n.oNext();t.setNext(r),e.setNext(s),n.setNext(o),i.setNext(a)},bs.connect=function(t,e){var n=bs.makeEdge(t.dest(),e.orig());return bs.splice(n,t.lNext()),bs.splice(n.sym(),e),n},e(Os.prototype,{insertSite:function(t){var e=this.subdiv.locate(t);if(this.subdiv.isVertexOfEdge(e,t))return e;this.subdiv.isOnEdge(e,t.getCoordinate())&&(e=e.oPrev(),this.subdiv.delete(e.oNext()));var n=this.subdiv.makeEdge(e.orig(),t);bs.splice(n,e);var i=n;do n=this.subdiv.connect(e,n.sym()),e=n.oPrev();while(e.lNext()!==i);for(;;){var r=e.oPrev();if(r.dest().rightOf(e)&&t.isInCircle(e.orig(),r.dest(),e.dest()))bs.swap(e),e=e.oPrev();else{if(e.oNext()===i)return n;e=e.oNext().lPrev()}}},insertSites:function(t){for(var e=t.iterator();e.hasNext();){var n=e.next();this.insertSite(n)}},interfaces_:function(){return[]},getClass:function(){return Os}}),e(_s.prototype,{locate:function(t){},interfaces_:function(){return[]},getClass:function(){return _s}}),e(Ms.prototype,{init:function(){this.lastEdge=this.findEdge()},locate:function(t){this.lastEdge.isLive()||this.init();var e=this.subdiv.locateFromEdge(t,this.lastEdge);return this.lastEdge=e,e},findEdge:function(){var t=this.subdiv.getEdges();return t.iterator().next()},interfaces_:function(){return[_s]},getClass:function(){return Ms}}),h(Ds,l),e(Ds.prototype,{getSegment:function(){return this.seg},interfaces_:function(){return[]},getClass:function(){return Ds}}),Ds.msgWithSpatial=function(t,e){return null!==e?t+" [ "+e+" ]":t},e(As.prototype,{visit:function(t){},interfaces_:function(){return[]},getClass:function(){return As}}),e(Fs.prototype,{getTriangleVertices:function(t){var e=new Bs;return this.visitTriangles(e,t),e.getTriangleVertices()},isFrameVertex:function(t){return t.equals(this.frameVertex[0])?!0:t.equals(this.frameVertex[1])?!0:!!t.equals(this.frameVertex[2])},isVertexOfEdge:function(t,e){return!(!e.equals(t.orig(),this.tolerance)&&!e.equals(t.dest(),this.tolerance))},connect:function(t,e){var n=bs.connect(t,e);return this.quadEdges.add(n),n},getVoronoiCellPolygon:function(t,e){var n=new I,i=t;do{var r=t.rot().orig().getCoordinate();n.add(r),t=t.oPrev()}while(t!==i);var s=new N;s.addAll(n,!1),s.closeRing(),s.size()<4&&(A.out.println(s),s.add(s.get(s.size()-1),!0));var o=s.toCoordinateArray(),a=e.createPolygon(e.createLinearRing(o),null),u=i.orig();return a.setUserData(u.getCoordinate()),a},setLocator:function(t){this.locator=t},initSubdiv:function(){var t=this.makeEdge(this.frameVertex[0],this.frameVertex[1]),e=this.makeEdge(this.frameVertex[1],this.frameVertex[2]);bs.splice(t.sym(),e);var n=this.makeEdge(this.frameVertex[2],this.frameVertex[0]);return bs.splice(e.sym(),n),bs.splice(n.sym(),t),t},isFrameBorderEdge:function(t){var e=new Array(3).fill(null);Fs.getTriangleEdges(t,e);var n=new Array(3).fill(null);Fs.getTriangleEdges(t.sym(),n);var i=t.lNext().dest();if(this.isFrameVertex(i))return!0;var r=t.sym().lNext().dest();return!!this.isFrameVertex(r)},makeEdge:function(t,e){var n=bs.makeEdge(t,e);return this.quadEdges.add(n),n},visitTriangles:function(t,e){this.visitedKey++;var n=new pe;n.push(this.startingEdge);for(var i=new J;!n.empty();){var r=n.pop();if(!i.contains(r)){var s=this.fetchTriangleToVisit(r,n,e,i);null!==s&&t.visit(s)}}},isFrameEdge:function(t){return!(!this.isFrameVertex(t.orig())&&!this.isFrameVertex(t.dest()))},isOnEdge:function(t,e){this.seg.setCoordinates(t.orig().getCoordinate(),t.dest().getCoordinate());var n=this.seg.distance(e);return n<this.edgeCoincidenceTolerance},getEnvelope:function(){return new C(this.frameEnv)},createFrame:function(t){var e=t.getWidth(),n=t.getHeight(),i=0;i=e>n?10*e:10*n,this.frameVertex[0]=new Ts((t.getMaxX()+t.getMinX())/2,t.getMaxY()+i),this.frameVertex[1]=new Ts(t.getMinX()-i,t.getMinY()-i),this.frameVertex[2]=new Ts(t.getMaxX()+i,t.getMinY()-i),this.frameEnv=new C(this.frameVertex[0].getCoordinate(),this.frameVertex[1].getCoordinate()),this.frameEnv.expandToInclude(this.frameVertex[2].getCoordinate())},getTriangleCoordinates:function(t){var e=new zs;return this.visitTriangles(e,t),e.getTriangles()},getVertices:function(t){for(var e=new J,n=this.quadEdges.iterator();n.hasNext();){var i=n.next(),r=i.orig();!t&&this.isFrameVertex(r)||e.add(r);var s=i.dest();!t&&this.isFrameVertex(s)||e.add(s)}return e},fetchTriangleToVisit:function(t,e,n,i){var r=t,s=0,o=!1;do{this.triEdges[s]=r,this.isFrameEdge(r)&&(o=!0);var a=r.sym();i.contains(a)||e.push(a),i.add(r),s++,r=r.lNext()}while(r!==t);return o&&!n?null:this.triEdges},getEdges:function(){if(0===arguments.length)return this.quadEdges;if(1===arguments.length){for(var t=arguments[0],e=this.getPrimaryEdges(!1),n=new Array(e.size()).fill(null),i=0,r=e.iterator();r.hasNext();){var s=r.next();n[i++]=t.createLineString([s.orig().getCoordinate(),s.dest().getCoordinate()])}return t.createMultiLineString(n)}},getVertexUniqueEdges:function(t){for(var e=new I,n=new J,i=this.quadEdges.iterator();i.hasNext();){var r=i.next(),s=r.orig();n.contains(s)||(n.add(s),!t&&this.isFrameVertex(s)||e.add(r));var o=r.sym(),a=o.orig();n.contains(a)||(n.add(a),!t&&this.isFrameVertex(a)||e.add(o))}return e},getTriangleEdges:function(t){var e=new qs;return this.visitTriangles(e,t),e.getTriangleEdges()},getPrimaryEdges:function(t){this.visitedKey++;var e=new I,n=new pe;n.push(this.startingEdge);for(var i=new J;!n.empty();){var r=n.pop();if(!i.contains(r)){var s=r.getPrimary();!t&&this.isFrameEdge(s)||e.add(s),n.push(r.oNext()),n.push(r.sym().oNext()),i.add(r),i.add(r.sym())}}return e},delete:function(t){bs.splice(t,t.oPrev()),bs.splice(t.sym(),t.sym().oPrev());var e=t.sym(),n=t.rot(),i=t.rot().sym();this.quadEdges.remove(t),this.quadEdges.remove(e),this.quadEdges.remove(n),this.quadEdges.remove(i),t.delete(),e.delete(),n.delete(),i.delete()},locateFromEdge:function(t,e){for(var n=0,i=this.quadEdges.size(),r=e;;){if(n++,n>i)throw new Ds(r.toLineSegment());if(t.equals(r.orig())||t.equals(r.dest()))break;if(t.rightOf(r))r=r.sym();else if(t.rightOf(r.oNext())){if(t.rightOf(r.dPrev()))break;r=r.dPrev()}else r=r.oNext()}return r},getTolerance:function(){return this.tolerance},getVoronoiCellPolygons:function(t){this.visitTriangles(new Gs,!0);for(var e=new I,n=this.getVertexUniqueEdges(!1),i=n.iterator();i.hasNext();){var r=i.next();e.add(this.getVoronoiCellPolygon(r,t))}return e},getVoronoiDiagram:function(t){var e=this.getVoronoiCellPolygons(t);return t.createGeometryCollection(ie.toGeometryArray(e))},getTriangles:function(t){for(var e=this.getTriangleCoordinates(!1),n=new Array(e.size()).fill(null),i=0,r=e.iterator();r.hasNext();){var s=r.next();n[i++]=t.createPolygon(t.createLinearRing(s),null)}return t.createGeometryCollection(n)},insertSite:function(t){var e=this.locate(t);if(t.equals(e.orig(),this.tolerance)||t.equals(e.dest(),this.tolerance))return e;var n=this.makeEdge(e.orig(),t);bs.splice(n,e);var i=n;do n=this.connect(e,n.sym()),e=n.oPrev();while(e.lNext()!==i);return i},locate:function(){if(1===arguments.length){if(arguments[0]instanceof Ts){var t=arguments[0];return this.locator.locate(t)}if(arguments[0]instanceof g){var e=arguments[0];return this.locator.locate(new Ts(e))}}else if(2===arguments.length){var n=arguments[0],i=arguments[1],r=this.locator.locate(new Ts(n));if(null===r)return null;var s=r;r.dest().getCoordinate().equals2D(n)&&(s=r.sym());var o=s;do{if(o.dest().getCoordinate().equals2D(i))return o;o=o.oNext()}while(o!==s);return null}},interfaces_:function(){return[]},getClass:function(){return Fs}}),Fs.getTriangleEdges=function(t,e){if(e[0]=t,e[1]=e[0].lNext(),e[2]=e[1].lNext(),e[2].lNext()!==e[0])throw new i("Edges do not form a triangle")},e(Gs.prototype,{visit:function(t){for(var e=t[0].orig().getCoordinate(),n=t[1].orig().getCoordinate(),i=t[2].orig().getCoordinate(),r=ci.circumcentre(e,n,i),s=new Ts(r),o=0;3>o;o++)t[o].rot().setOrig(s)},interfaces_:function(){return[As]},getClass:function(){return Gs}}),e(qs.prototype,{getTriangleEdges:function(){return this.triList},visit:function(t){this.triList.add(t.clone())},interfaces_:function(){return[As]},getClass:function(){return qs}}),e(Bs.prototype,{visit:function(t){this.triList.add([t[0].orig(),t[1].orig(),t[2].orig()])},getTriangleVertices:function(){return this.triList},interfaces_:function(){return[As]},getClass:function(){return Bs}}),e(zs.prototype,{checkTriangleSize:function(t){var e="";t.length>=2?e=se.toLineString(t[0],t[1]):t.length>=1&&(e=se.toPoint(t[0]))},visit:function(t){this.coordList.clear();for(var e=0;3>e;e++){var n=t[e].orig();this.coordList.add(n.getCoordinate())}if(this.coordList.size()>0){this.coordList.closeRing();var i=this.coordList.toCoordinateArray();if(4!==i.length)return null;this.triCoords.add(i)}},getTriangles:function(){return this.triCoords},interfaces_:function(){return[As]},getClass:function(){return zs}}),Fs.TriangleCircumcentreVisitor=Gs,Fs.TriangleEdgesListVisitor=qs,Fs.TriangleVertexListVisitor=Bs,Fs.TriangleCoordinatesVisitor=zs,Fs.EDGE_COINCIDENCE_TOL_FACTOR=1e3,e(Vs.prototype,{getLineSegment:function(){return this.ls},getEndZ:function(){var t=this.ls.getCoordinate(1);return t.z},getStartZ:function(){var t=this.ls.getCoordinate(0);return t.z},intersection:function(t){return this.ls.intersection(t.getLineSegment())},getStart:function(){return this.ls.getCoordinate(0)},getEnd:function(){return this.ls.getCoordinate(1)},getEndY:function(){var t=this.ls.getCoordinate(1);return t.y},getStartX:function(){var t=this.ls.getCoordinate(0);return t.x},equalsTopo:function(t){return this.ls.equalsTopo(t.getLineSegment())},getStartY:function(){var t=this.ls.getCoordinate(0);return t.y},setData:function(t){this.data=t},getData:function(){return this.data},getEndX:function(){var t=this.ls.getCoordinate(1);return t.x},toString:function(){return this.ls.toString()},interfaces_:function(){return[]},getClass:function(){return Vs}}),e(ks.prototype,{visit:function(t){},interfaces_:function(){return[]},getClass:function(){return ks}}),e(Ys.prototype,{isRepeated:function(){return this.count>1},getRight:function(){return this.right},getCoordinate:function(){return this.p},setLeft:function(t){this.left=t},getX:function(){return this.p.x},getData:function(){return this.data},getCount:function(){return this.count},getLeft:function(){return this.left},getY:function(){return this.p.y},increment:function(){this.count=this.count+1},setRight:function(t){this.right=t},interfaces_:function(){return[]},getClass:function(){return Ys}}),e(Us.prototype,{insert:function(){if(1===arguments.length){var t=arguments[0];return this.insert(t,null)}if(2===arguments.length){var e=arguments[0],n=arguments[1];if(null===this.root)return this.root=new Ys(e,n),this.root;if(this.tolerance>0){var i=this.findBestMatchNode(e);if(null!==i)return i.increment(),i}return this.insertExact(e,n)}},query:function(){var t=arguments,e=this;if(1===arguments.length){var n=arguments[0],i=new I;return this.query(n,i),i}if(2===arguments.length)if(arguments[0]instanceof C&&R(arguments[1],y))!function(){var n=t[0],i=t[1];e.queryNode(e.root,n,!0,{interfaces_:function(){return[ks]},visit:function(t){i.add(t)}})}();else if(arguments[0]instanceof C&&R(arguments[1],ks)){var r=arguments[0],s=arguments[1];this.queryNode(this.root,r,!0,s)}},queryNode:function(t,e,n,i){if(null===t)return null;var r=null,s=null,o=null;n?(r=e.getMinX(),s=e.getMaxX(),o=t.getX()):(r=e.getMinY(),s=e.getMaxY(),o=t.getY());var a=o>r,u=s>=o;a&&this.queryNode(t.getLeft(),e,!n,i),e.contains(t.getCoordinate())&&i.visit(t),u&&this.queryNode(t.getRight(),e,!n,i)},findBestMatchNode:function(t){var e=new Xs(t,this.tolerance);return this.query(e.queryEnvelope(),e),e.getNode()},isEmpty:function(){return null===this.root},insertExact:function(t,e){for(var n=this.root,i=this.root,r=!0,s=!0;null!==n;){if(null!==n){var o=t.distance(n.getCoordinate())<=this.tolerance;if(o)return n.increment(),n}s=r?t.x<n.getX():t.y<n.getY(),i=n,n=s?n.getLeft():n.getRight(),r=!r}this.numberOfNodes=this.numberOfNodes+1;var a=new Ys(t,e);return s?i.setLeft(a):i.setRight(a),a},interfaces_:function(){return[]},getClass:function(){return Us}}),Us.toCoordinates=function(){if(1===arguments.length){var t=arguments[0];return Us.toCoordinates(t,!1)}if(2===arguments.length){for(var e=arguments[0],n=arguments[1],i=new N,r=e.iterator();r.hasNext();)for(var s=r.next(),o=n?s.getCount():1,a=0;o>a;a++)i.add(s.getCoordinate(),!0);return i.toCoordinateArray()}},e(Xs.prototype,{visit:function(t){var e=this.p.distance(t.getCoordinate()),n=e<=this.tolerance;if(!n)return null;var i=!1;(null===this.matchNode||e<this.matchDist||null!==this.matchNode&&e===this.matchDist&&t.getCoordinate().compareTo(this.matchNode.getCoordinate())<1)&&(i=!0),i&&(this.matchNode=t,this.matchDist=e)},queryEnvelope:function(){var t=new C(this.p);return t.expandBy(this.tolerance),t},getNode:function(){return this.matchNode},interfaces_:function(){return[ks]},getClass:function(){return Xs}}),Us.BestMatchVisitor=Xs,e(Hs.prototype,{getInitialVertices:function(){return this.initialVertices},getKDT:function(){return this.kdt},enforceConstraints:function(){this.addConstraintVertices();var t=0,e=0;do e=this.enforceGabriel(this.segments),t++;while(e>0&&t<Hs.MAX_SPLIT_ITER)},insertSites:function(t){for(var e=t.iterator();e.hasNext();){var n=e.next();this.insertSite(n)}},getVertexFactory:function(){return this.vertexFactory},getPointArray:function(){for(var t=new Array(this.initialVertices.size()+this.segVertices.size()).fill(null),e=0,n=this.initialVertices.iterator();n.hasNext();){var i=n.next();t[e++]=i.getCoordinate()}for(var r=this.segVertices.iterator();r.hasNext();){var i=r.next();t[e++]=i.getCoordinate()}return t},setConstraints:function(t,e){this.segments=t,this.segVertices=e},computeConvexHull:function(){var t=new ie,e=this.getPointArray(),n=new me(e,t);this.convexHull=n.getConvexHull()},addConstraintVertices:function(){this.computeConvexHull(),this.insertSites(this.segVertices)},findNonGabrielPoint:function(t){var e=t.getStart(),n=t.getEnd(),i=new g((e.x+n.x)/2,(e.y+n.y)/2),s=e.distance(i),o=new C(i);o.expandBy(s);for(var a=this.kdt.query(o),u=null,l=r.MAX_VALUE,h=a.iterator();h.hasNext();){var c=h.next(),f=c.getCoordinate();if(!f.equals2D(e)&&!f.equals2D(n)){var d=i.distance(f);if(s>d){var p=d;(null===u||l>p)&&(u=f,l=p)}}}return u},getConstraintSegments:function(){return this.segments},setSplitPointFinder:function(t){this.splitFinder=t},getConvexHull:function(){return this.convexHull},getTolerance:function(){return this.tolerance},enforceGabriel:function(t){for(var e=new I,n=0,i=new I,r=t.iterator();r.hasNext();){var s=r.next(),o=this.findNonGabrielPoint(s);if(null!==o){this.splitPt=this.splitFinder.findSplitPoint(s,o);var a=this.createVertex(this.splitPt,s),u=(this.insertSite(a),new Vs(s.getStartX(),s.getStartY(),s.getStartZ(),a.getX(),a.getY(),a.getZ(),s.getData())),l=new Vs(a.getX(),a.getY(),a.getZ(),s.getEndX(),s.getEndY(),s.getEndZ(),s.getData());e.add(u),e.add(l),i.add(s),n+=1}}return t.removeAll(i),t.addAll(e),n},createVertex:function(){if(1===arguments.length){var t=arguments[0],e=null;return e=null!==this.vertexFactory?this.vertexFactory.createVertex(t,null):new Ps(t)}if(2===arguments.length){var n=arguments[0],i=arguments[1],e=null;return e=null!==this.vertexFactory?this.vertexFactory.createVertex(n,i):new Ps(n),e.setOnConstraint(!0),e}},getSubdivision:function(){return this.subdiv},computeBoundingBox:function(){var t=Hs.computeVertexEnvelope(this.initialVertices),e=Hs.computeVertexEnvelope(this.segVertices),n=new C(t);n.expandToInclude(e);var i=.2*n.getWidth(),r=.2*n.getHeight(),s=Math.max(i,r);this.computeAreaEnv=new C(n),this.computeAreaEnv.expandBy(s)},setVertexFactory:function(t){this.vertexFactory=t},formInitialDelaunay:function(){this.computeBoundingBox(),this.subdiv=new Fs(this.computeAreaEnv,this.tolerance),this.subdiv.setLocator(new Ms(this.subdiv)),this.incDel=new Os(this.subdiv),this.insertSites(this.initialVertices)},insertSite:function(){if(arguments[0]instanceof Ps){var t=arguments[0],e=this.kdt.insert(t.getCoordinate(),t);if(e.isRepeated()){var n=e.getData();return n.merge(t),n}return this.incDel.insertSite(t),t}if(arguments[0]instanceof g){var i=arguments[0];this.insertSite(this.createVertex(i))}},interfaces_:function(){return[]},getClass:function(){return Hs}}),Hs.computeVertexEnvelope=function(t){for(var e=new C,n=t.iterator();n.hasNext();){var i=n.next();e.expandToInclude(i.getCoordinate())}return e},Hs.MAX_SPLIT_ITER=99,e(Ws.prototype,{create:function(){if(null!==this.subdiv)return null;var t=Ws.envelope(this.siteCoords),e=Ws.toVertices(this.siteCoords);this.subdiv=new Fs(t,this.tolerance);var n=new Os(this.subdiv);n.insertSites(e)},setTolerance:function(t){this.tolerance=t},setSites:function(){if(arguments[0]instanceof B){var t=arguments[0];this.siteCoords=Ws.extractUniqueCoordinates(t)}else if(R(arguments[0],v)){var e=arguments[0];this.siteCoords=Ws.unique(H.toCoordinateArray(e))}},getEdges:function(t){return this.create(),this.subdiv.getEdges(t)},getSubdivision:function(){return this.create(),this.subdiv},getTriangles:function(t){return this.create(),this.subdiv.getTriangles(t)},interfaces_:function(){return[]},getClass:function(){return Ws}}),Ws.extractUniqueCoordinates=function(t){if(null===t)return new N;var e=t.getCoordinates();return Ws.unique(e)},Ws.envelope=function(t){for(var e=new C,n=t.iterator();n.hasNext();){var i=n.next();e.expandToInclude(i)}return e},Ws.unique=function(t){var e=H.copyDeep(t);ut.sort(e);var n=new N(e,!1);return n},Ws.toVertices=function(t){for(var e=new I,n=t.iterator();n.hasNext();){var i=n.next();e.add(new Ts(i))}return e},e(js.prototype,{createSiteVertices:function(t){for(var e=new I,n=t.iterator();n.hasNext();){var i=n.next();this.constraintVertexMap.containsKey(i)||e.add(new Ps(i))}return e},create:function(){if(null!==this.subdiv)return null;var t=Ws.envelope(this.siteCoords),e=new I;null!==this.constraintLines&&(t.expandToInclude(this.constraintLines.getEnvelopeInternal()),this.createVertices(this.constraintLines),e=js.createConstraintSegments(this.constraintLines));var n=this.createSiteVertices(this.siteCoords),i=new Hs(n,this.tolerance);i.setConstraints(e,new I(this.constraintVertexMap.values())),i.formInitialDelaunay(),i.enforceConstraints(),this.subdiv=i.getSubdivision()},setTolerance:function(t){this.tolerance=t},setConstraints:function(t){this.constraintLines=t},setSites:function(t){this.siteCoords=Ws.extractUniqueCoordinates(t)},getEdges:function(t){return this.create(),this.subdiv.getEdges(t)},getSubdivision:function(){return this.create(),this.subdiv},getTriangles:function(t){return this.create(),this.subdiv.getTriangles(t)},createVertices:function(t){for(var e=t.getCoordinates(),n=0;n<e.length;n++){var i=new Ps(e[n]);this.constraintVertexMap.put(e[n],i)}},interfaces_:function(){return[]},getClass:function(){return js}}),js.createConstraintSegments=function(){if(1===arguments.length){for(var t=arguments[0],e=kn.getLines(t),n=new I,i=e.iterator();i.hasNext();){var r=i.next();js.createConstraintSegments(r,n)}return n}if(2===arguments.length)for(var s=arguments[0],o=arguments[1],a=s.getCoordinates(),i=1;i<a.length;i++)o.add(new Vs(a[i-1],a[i]))},e(Ks.prototype,{create:function(){if(null!==this.subdiv)return null;var t=Ws.envelope(this.siteCoords);this.diagramEnv=t;var e=Math.max(this.diagramEnv.getWidth(),this.diagramEnv.getHeight());this.diagramEnv.expandBy(e),null!==this.clipEnv&&this.diagramEnv.expandToInclude(this.clipEnv);var n=Ws.toVertices(this.siteCoords);this.subdiv=new Fs(t,this.tolerance);var i=new Os(this.subdiv);i.insertSites(n)},getDiagram:function(t){this.create();var e=this.subdiv.getVoronoiDiagram(t);return Ks.clipGeometryCollection(e,this.diagramEnv)},setTolerance:function(t){this.tolerance=t},setSites:function(){if(arguments[0]instanceof B){var t=arguments[0];this.siteCoords=Ws.extractUniqueCoordinates(t)}else if(R(arguments[0],v)){var e=arguments[0];this.siteCoords=Ws.unique(H.toCoordinateArray(e))}},setClipEnvelope:function(t){this.clipEnv=t},getSubdivision:function(){return this.create(),this.subdiv},interfaces_:function(){return[]},getClass:function(){return Ks}}),Ks.clipGeometryCollection=function(t,e){for(var n=t.getFactory().toGeometry(e),i=new I,r=0;r<t.getNumGeometries();r++){var s=t.getGeometryN(r),o=null;e.contains(s.getEnvelopeInternal())?o=s:e.intersects(s.getEnvelopeInternal())&&(o=n.intersection(s),o.setUserData(s.getUserData())),null===o||o.isEmpty()||i.add(o)}return t.getFactory().createGeometryCollection(ie.toGeometryArray(i))};var Do=Object.freeze({ConformingDelaunayTriangulationBuilder:js,DelaunayTriangulationBuilder:Ws,VoronoiDiagramBuilder:Ks});e(Zs.prototype,{interfaces_:function(){return[]},getClass:function(){return Zs}}),Zs.union=function(t,e){if(t.isEmpty()||e.isEmpty()){if(t.isEmpty()&&e.isEmpty())return ii.createEmptyResult(ii.UNION,t,e,t.getFactory());if(t.isEmpty())return e.copy();if(e.isEmpty())return t.copy()}return t.checkNotGeometryCollection(t),t.checkNotGeometryCollection(e),si.overlayOp(t,e,ii.UNION)},e(B.prototype,{equalsTopo:function(t){return this.getEnvelopeInternal().equals(t.getEnvelopeInternal())?Yr.relate(this,t).isEquals(this.getDimension(),t.getDimension()):!1},union:function(){if(0===arguments.length)return jr.union(this);if(1===arguments.length){var t=arguments[0];return Zs.union(this,t)}},isValid:function(){return ls.isValid(this)},intersection:function(t){if(this.isEmpty()||t.isEmpty())return ii.createEmptyResult(ii.INTERSECTION,this,t,this.factory);if(this.isGeometryCollection()){var e=t;return hn.map(this,{interfaces_:function(){return[MapOp]},map:function(t){return t.intersection(e)}})}return this.checkNotGeometryCollection(this),this.checkNotGeometryCollection(t),si.overlayOp(this,t,ii.INTERSECTION)},covers:function(t){return Yr.covers(this,t)},coveredBy:function(t){return Yr.coveredBy(this,t)},touches:function(t){return Yr.touches(this,t)},intersects:function(t){return Yr.intersects(this,t)},within:function(t){return Yr.within(this,t)},overlaps:function(t){return Yr.overlaps(this,t)},disjoint:function(t){return Yr.disjoint(this,t)},crosses:function(t){return Yr.crosses(this,t)},buffer:function(){if(1===arguments.length){var t=arguments[0];return sr.bufferOp(this,t)}if(2===arguments.length){var e=arguments[0],n=arguments[1];return sr.bufferOp(this,e,n)}if(3===arguments.length){var i=arguments[0],r=arguments[1],s=arguments[2];return sr.bufferOp(this,i,r,s)}},convexHull:function(){return new me(this).getConvexHull()},relate:function(){for(var t=arguments.length,e=Array(t),n=0;t>n;n++)e[n]=arguments[n];return Yr.relate.apply(Yr,[this].concat(e))},getCentroid:function(){if(this.isEmpty())return this.factory.createPoint();var t=ge.getCentroid(this);return this.createPointFromInternalCoord(t,this)},getInteriorPoint:function(){if(this.isEmpty())return this.factory.createPoint();var t=null,e=this.getDimension();if(0===e){var n=new li(this);t=n.getInteriorPoint()}else if(1===e){var n=new ui(this);t=n.getInteriorPoint()}else{var n=new oi(this);t=n.getInteriorPoint()}return this.createPointFromInternalCoord(t,this)},symDifference:function(t){if(this.isEmpty()||t.isEmpty()){if(this.isEmpty()&&t.isEmpty())return ii.createEmptyResult(ii.SYMDIFFERENCE,this,t,this.factory);if(this.isEmpty())return t.copy();if(t.isEmpty())return this.copy()}return this.checkNotGeometryCollection(this),this.checkNotGeometryCollection(t),si.overlayOp(this,t,ii.SYMDIFFERENCE)},createPointFromInternalCoord:function(t,e){return e.getPrecisionModel().makePrecise(t),e.getFactory().createPoint(t)},toText:function(){var t=new se;return t.write(this)},toString:function(){this.toText()},contains:function(t){return Yr.contains(this,t)},difference:function(t){return this.isEmpty()?ii.createEmptyResult(ii.DIFFERENCE,this,t,this.factory):t.isEmpty()?this.copy():(this.checkNotGeometryCollection(this),this.checkNotGeometryCollection(t),si.overlayOp(this,t,ii.DIFFERENCE))},isSimple:function(){var t=new Gi(this);return t.isSimple()},isWithinDistance:function(t,e){var n=this.getEnvelopeInternal().distance(t.getEnvelopeInternal());return n>e?!1:hr.isWithinDistance(this,t,e)},distance:function(t){return hr.distance(this,t)},isEquivalentClass:function(t){return this.getClass()===t.getClass()}});var Ao="1.1.2 (248dab8)";t.version=Ao,t.algorithm=co,t.densify=fo,t.dissolve=go,t.geom=lo,t.index=mo,t.io=Io,t.noding=No,t.operation=Oo,t.precision=_o,t.simplify=Mo,t.triangulate=Do});


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (typeof process === 'undefined' ||
	    !process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = { nextTick: nextTick };
	} else {
	  module.exports = process
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(82)))

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(32)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 (c) 2017, Vladimir Agafonkin
	 Simplify.js, a high-performance JS polyline simplification library
	 mourner.github.io/simplify-js
	*/
	
	(function () { 'use strict';
	
	// to suit your point format, run search/replace for '.x' and '.y';
	// for 3D version, see 3d branch (configurability would draw significant performance overhead)
	
	// square distance between 2 points
	function getSqDist(p1, p2) {
	
	    var dx = p1.x - p2.x,
	        dy = p1.y - p2.y;
	
	    return dx * dx + dy * dy;
	}
	
	// square distance from a point to a segment
	function getSqSegDist(p, p1, p2) {
	
	    var x = p1.x,
	        y = p1.y,
	        dx = p2.x - x,
	        dy = p2.y - y;
	
	    if (dx !== 0 || dy !== 0) {
	
	        var t = ((p.x - x) * dx + (p.y - y) * dy) / (dx * dx + dy * dy);
	
	        if (t > 1) {
	            x = p2.x;
	            y = p2.y;
	
	        } else if (t > 0) {
	            x += dx * t;
	            y += dy * t;
	        }
	    }
	
	    dx = p.x - x;
	    dy = p.y - y;
	
	    return dx * dx + dy * dy;
	}
	// rest of the code doesn't care about point format
	
	// basic distance-based simplification
	function simplifyRadialDist(points, sqTolerance) {
	
	    var prevPoint = points[0],
	        newPoints = [prevPoint],
	        point;
	
	    for (var i = 1, len = points.length; i < len; i++) {
	        point = points[i];
	
	        if (getSqDist(point, prevPoint) > sqTolerance) {
	            newPoints.push(point);
	            prevPoint = point;
	        }
	    }
	
	    if (prevPoint !== point) newPoints.push(point);
	
	    return newPoints;
	}
	
	function simplifyDPStep(points, first, last, sqTolerance, simplified) {
	    var maxSqDist = sqTolerance,
	        index;
	
	    for (var i = first + 1; i < last; i++) {
	        var sqDist = getSqSegDist(points[i], points[first], points[last]);
	
	        if (sqDist > maxSqDist) {
	            index = i;
	            maxSqDist = sqDist;
	        }
	    }
	
	    if (maxSqDist > sqTolerance) {
	        if (index - first > 1) simplifyDPStep(points, first, index, sqTolerance, simplified);
	        simplified.push(points[index]);
	        if (last - index > 1) simplifyDPStep(points, index, last, sqTolerance, simplified);
	    }
	}
	
	// simplification using Ramer-Douglas-Peucker algorithm
	function simplifyDouglasPeucker(points, sqTolerance) {
	    var last = points.length - 1;
	
	    var simplified = [points[0]];
	    simplifyDPStep(points, 0, last, sqTolerance, simplified);
	    simplified.push(points[last]);
	
	    return simplified;
	}
	
	// both algorithms combined for awesome performance
	function simplify(points, tolerance, highestQuality) {
	
	    if (points.length <= 2) return points;
	
	    var sqTolerance = tolerance !== undefined ? tolerance * tolerance : 1;
	
	    points = highestQuality ? points : simplifyRadialDist(points, sqTolerance);
	    points = simplifyDouglasPeucker(points, sqTolerance);
	
	    return points;
	}
	
	// export as AMD module / Node module / browser or worker variable
	if (true) !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return simplify; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	else if (typeof module !== 'undefined') {
	    module.exports = simplify;
	    module.exports.default = simplify;
	} else if (typeof self !== 'undefined') self.simplify = simplify;
	else window.simplify = simplify;
	
	})();


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var each = __webpack_require__(95).coordEach;
	
	/**
	 * Takes a set of features, calculates the bbox of all input features, and returns a bounding box.
	 *
	 * @name bbox
	 * @param {(Feature|FeatureCollection)} geojson input features
	 * @return {Array<number>} the bounding box of `input` given
	 * as an array in WSEN order (west, south, east, north)
	 * @example
	 * var input = {
	 *   "type": "FeatureCollection",
	 *   "features": [
	 *     {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [114.175329, 22.2524]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [114.170007, 22.267969]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [114.200649, 22.274641]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [114.186744, 22.265745]
	 *       }
	 *     }
	 *   ]
	 * };
	 *
	 * var bbox = turf.bbox(input);
	 *
	 * var bboxPolygon = turf.bboxPolygon(bbox);
	 *
	 * var resultFeatures = input.features.concat(bboxPolygon);
	 * var result = {
	 *   "type": "FeatureCollection",
	 *   "features": resultFeatures
	 * };
	 *
	 * //=result
	 */
	module.exports = function (geojson) {
	    var bbox = [Infinity, Infinity, -Infinity, -Infinity];
	    each(geojson, function (coord) {
	        if (bbox[0] > coord[0]) bbox[0] = coord[0];
	        if (bbox[1] > coord[1]) bbox[1] = coord[1];
	        if (bbox[2] < coord[0]) bbox[2] = coord[0];
	        if (bbox[3] < coord[1]) bbox[3] = coord[1];
	    });
	    return bbox;
	};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	var getCoord = __webpack_require__(150).getCoord;
	//http://en.wikipedia.org/wiki/Haversine_formula
	//http://www.movable-type.co.uk/scripts/latlong.html
	
	/**
	 * Takes two {@link Point|points} and finds the geographic bearing between them.
	 *
	 * @name bearing
	 * @param {Feature<Point>} start starting Point
	 * @param {Feature<Point>} end ending Point
	 * @returns {Number} bearing in decimal degrees
	 * @example
	 * var point1 = {
	 *   "type": "Feature",
	 *   "properties": {
	 *     "marker-color": '#f00'
	 *   },
	 *   "geometry": {
	 *     "type": "Point",
	 *     "coordinates": [-75.343, 39.984]
	 *   }
	 * };
	 * var point2 = {
	 *   "type": "Feature",
	 *   "properties": {
	 *     "marker-color": '#0f0'
	 *   },
	 *   "geometry": {
	 *     "type": "Point",
	 *     "coordinates": [-75.534, 39.123]
	 *   }
	 * };
	 *
	 * var points = {
	 *   "type": "FeatureCollection",
	 *   "features": [point1, point2]
	 * };
	 *
	 * //=points
	 *
	 * var bearing = turf.bearing(point1, point2);
	 *
	 * //=bearing
	 */
	module.exports = function (start, end) {
	    var degrees2radians = Math.PI / 180;
	    var radians2degrees = 180 / Math.PI;
	    var coordinates1 = getCoord(start);
	    var coordinates2 = getCoord(end);
	
	    var lon1 = degrees2radians * coordinates1[0];
	    var lon2 = degrees2radians * coordinates2[0];
	    var lat1 = degrees2radians * coordinates1[1];
	    var lat2 = degrees2radians * coordinates2[1];
	    var a = Math.sin(lon2 - lon1) * Math.cos(lat2);
	    var b = Math.cos(lat1) * Math.sin(lat2) -
	        Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1);
	
	    var bearing = radians2degrees * Math.atan2(a, b);
	
	    return bearing;
	};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	//http://en.wikipedia.org/wiki/Haversine_formula
	//http://www.movable-type.co.uk/scripts/latlong.html
	var getCoord = __webpack_require__(150).getCoord;
	var helpers = __webpack_require__(17);
	var point = helpers.point;
	var distanceToRadians = helpers.distanceToRadians;
	
	/**
	 * Takes a {@link Point} and calculates the location of a destination point given a distance in degrees, radians, miles, or kilometers; and bearing in degrees. This uses the [Haversine formula](http://en.wikipedia.org/wiki/Haversine_formula) to account for global curvature.
	 *
	 * @name destination
	 * @param {Feature<Point>} from starting point
	 * @param {number} distance distance from the starting point
	 * @param {number} bearing ranging from -180 to 180
	 * @param {String} [units=kilometers] miles, kilometers, degrees, or radians
	 * @returns {Feature<Point>} destination point
	 * @example
	 * var point = {
	 *   "type": "Feature",
	 *   "properties": {
	 *     "marker-color": "#0f0"
	 *   },
	 *   "geometry": {
	 *     "type": "Point",
	 *     "coordinates": [-75.343, 39.984]
	 *   }
	 * };
	 * var distance = 50;
	 * var bearing = 90;
	 * var units = 'miles';
	 *
	 * var destination = turf.destination(point, distance, bearing, units);
	 * destination.properties['marker-color'] = '#f00';
	 *
	 * var result = {
	 *   "type": "FeatureCollection",
	 *   "features": [point, destination]
	 * };
	 *
	 * //=result
	 */
	module.exports = function (from, distance, bearing, units) {
	    var degrees2radians = Math.PI / 180;
	    var radians2degrees = 180 / Math.PI;
	    var coordinates1 = getCoord(from);
	    var longitude1 = degrees2radians * coordinates1[0];
	    var latitude1 = degrees2radians * coordinates1[1];
	    var bearing_rad = degrees2radians * bearing;
	
	    var radians = distanceToRadians(distance, units);
	
	    var latitude2 = Math.asin(Math.sin(latitude1) * Math.cos(radians) +
	        Math.cos(latitude1) * Math.sin(radians) * Math.cos(bearing_rad));
	    var longitude2 = longitude1 + Math.atan2(Math.sin(bearing_rad) *
	        Math.sin(radians) * Math.cos(latitude1),
	        Math.cos(radians) - Math.sin(latitude1) * Math.sin(latitude2));
	
	    return point([radians2degrees * longitude2, radians2degrees * latitude2]);
	};


/***/ }),
/* 150 */
/***/ (function(module, exports) {

	/**
	 * Unwrap a coordinate from a Feature with a Point geometry, a Point
	 * geometry, or a single coordinate.
	 *
	 * @param {*} obj any value
	 * @returns {Array<number>} a coordinate
	 */
	function getCoord(obj) {
	    if (Array.isArray(obj) &&
	        typeof obj[0] === 'number' &&
	        typeof obj[1] === 'number') {
	        return obj;
	    } else if (obj) {
	        if (obj.type === 'Feature' &&
	            obj.geometry &&
	            obj.geometry.type === 'Point' &&
	            Array.isArray(obj.geometry.coordinates)) {
	            return obj.geometry.coordinates;
	        } else if (obj.type === 'Point' &&
	            Array.isArray(obj.coordinates)) {
	            return obj.coordinates;
	        }
	    }
	    throw new Error('A coordinate, feature, or point geometry is required');
	}
	
	/**
	 * Enforce expectations about types of GeoJSON objects for Turf.
	 *
	 * @alias geojsonType
	 * @param {GeoJSON} value any GeoJSON object
	 * @param {string} type expected GeoJSON type
	 * @param {string} name name of calling function
	 * @throws {Error} if value is not the expected type.
	 */
	function geojsonType(value, type, name) {
	    if (!type || !name) throw new Error('type and name required');
	
	    if (!value || value.type !== type) {
	        throw new Error('Invalid input to ' + name + ': must be a ' + type + ', given ' + value.type);
	    }
	}
	
	/**
	 * Enforce expectations about types of {@link Feature} inputs for Turf.
	 * Internally this uses {@link geojsonType} to judge geometry types.
	 *
	 * @alias featureOf
	 * @param {Feature} feature a feature with an expected geometry type
	 * @param {string} type expected GeoJSON type
	 * @param {string} name name of calling function
	 * @throws {Error} error if value is not the expected type.
	 */
	function featureOf(feature, type, name) {
	    if (!name) throw new Error('.featureOf() requires a name');
	    if (!feature || feature.type !== 'Feature' || !feature.geometry) {
	        throw new Error('Invalid input to ' + name + ', Feature with geometry required');
	    }
	    if (!feature.geometry || feature.geometry.type !== type) {
	        throw new Error('Invalid input to ' + name + ': must be a ' + type + ', given ' + feature.geometry.type);
	    }
	}
	
	/**
	 * Enforce expectations about types of {@link FeatureCollection} inputs for Turf.
	 * Internally this uses {@link geojsonType} to judge geometry types.
	 *
	 * @alias collectionOf
	 * @param {FeatureCollection} featurecollection a featurecollection for which features will be judged
	 * @param {string} type expected GeoJSON type
	 * @param {string} name name of calling function
	 * @throws {Error} if value is not the expected type.
	 */
	function collectionOf(featurecollection, type, name) {
	    if (!name) throw new Error('.collectionOf() requires a name');
	    if (!featurecollection || featurecollection.type !== 'FeatureCollection') {
	        throw new Error('Invalid input to ' + name + ', FeatureCollection required');
	    }
	    for (var i = 0; i < featurecollection.features.length; i++) {
	        var feature = featurecollection.features[i];
	        if (!feature || feature.type !== 'Feature' || !feature.geometry) {
	            throw new Error('Invalid input to ' + name + ', Feature with geometry required');
	        }
	        if (!feature.geometry || feature.geometry.type !== type) {
	            throw new Error('Invalid input to ' + name + ': must be a ' + type + ', given ' + feature.geometry.type);
	        }
	    }
	}
	
	module.exports.geojsonType = geojsonType;
	module.exports.collectionOf = collectionOf;
	module.exports.featureOf = featureOf;
	module.exports.getCoord = getCoord;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/icon-excel-action.3a25400.svg";

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSI+PHBhdGggc3Ryb2tlPSIjRkZDMTA3IiBzdHJva2Utd2lkdGg9IjIiIGQ9Ik0xMy43MzY1IDIxLjg0ODFjMS4yOTMyLS4yMjgxIDIuNTI4OS0uNzA4NiAzLjYzNjUtMS40MTQyIDEuMTA3Ni0uNzA1NiAyLjA2NTMtMS42MjI0IDIuODE4NS0yLjY5ODEuNzUzMy0xLjA3NTggMS4yODcyLTIuMjg5MyAxLjU3MTUtMy41NzE0LjI4NDItMS4yODIxLjMxMzEtMi42MDc2LjA4NTEtMy45MDA5LS4yMjgxLTEuMjkzMjUtLjcwODYtMi41Mjg5NC0xLjQxNDItMy42MzY1LS43MDU2LTEuMTA3NTUtMS42MjI0LTIuMDY1MjktMi42OTgxLTIuODE4NTItMS4wNzU4LS43NTMyMy0yLjI4OTMtMS4yODcyMS0zLjU3MTQtMS41NzE0NC0xLjI4MjEtLjI4NDIzLTIuNjA3Ni0uMzEzMTYtMy45MDA5LS4wODUxMi0xLjI5MzI1LjIyODA0LTIuNTI4OTQuNzA4NTctMy42MzY1IDEuNDE0MTctMS4xMDc1NS43MDU1OS0yLjA2NTI5IDEuNjIyNDItMi44MTg1MiAyLjY5ODE1LS43NTMyMyAxLjA3NTcyLTEuMjg3MjEgMi4yODkyOC0xLjU3MTQ0IDMuNTcxMzctLjI4NDIzIDEuMjgyMDktLjMxMzE2IDIuNjA3NTktLjA4NTEyIDMuOTAwODlzLjcwODU3IDIuNTI4OSAxLjQxNDE3IDMuNjM2NWMuNzA1NTkgMS4xMDc2IDEuNjIyNDIgMi4wNjUzIDIuNjk4MTUgMi44MTg1IDEuMDc1NzIuNzUzMyAyLjI4OTI4IDEuMjg3MiAzLjU3MTM3IDEuNTcxNSAxLjI4MjA5LjI4NDIgMi42MDc1OS4zMTMxIDMuOTAwODkuMDg1MVoiLz48cGF0aCBzdHJva2U9IiNGRkMxMDciIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIHN0cm9rZS13aWR0aD0iMiIgZD0iTTEyIDEydjZNMTIgN1Y2Ii8+PC9zdmc+"

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/icon-invoice-action.29242ef.svg";

/***/ }),
/* 154 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48IS0tIFVwbG9hZGVkIHRvOiBTVkcgUmVwbywgd3d3LnN2Z3JlcG8uY29tLCBHZW5lcmF0b3I6IFNWRyBSZXBvIE1peGVyIFRvb2xzIC0tPg0KPHN2ZyB3aWR0aD0iODAwcHgiIGhlaWdodD0iODAwcHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMiAxMi41QzEyLjI3NjEgMTIuNSAxMi41IDEyLjI3NjEgMTIuNSAxMkMxMi41IDExLjcyMzkgMTIuMjc2MSAxMS41IDEyIDExLjVDMTEuNzIzOSAxMS41IDExLjUgMTEuNzIzOSAxMS41IDEyQzExLjUgMTIuMjc2MSAxMS43MjM5IDEyLjUgMTIgMTIuNVoiIGZpbGw9IiMwMDAwMDAiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KPHBhdGggZD0iTTEyIDE4LjVDMTIuMjc2MSAxOC41IDEyLjUgMTguMjc2MSAxMi41IDE4QzEyLjUgMTcuNzIzOSAxMi4yNzYxIDE3LjUgMTIgMTcuNUMxMS43MjM5IDE3LjUgMTEuNSAxNy43MjM5IDExLjUgMThDMTEuNSAxOC4yNzYxIDExLjcyMzkgMTguNSAxMiAxOC41WiIgZmlsbD0iIzAwMDAwMCIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8cGF0aCBkPSJNMTIgNi41QzEyLjI3NjEgNi41IDEyLjUgNi4yNzYxNCAxMi41IDZDMTIuNSA1LjcyMzg2IDEyLjI3NjEgNS41IDEyIDUuNUMxMS43MjM5IDUuNSAxMS41IDUuNzIzODYgMTEuNSA2QzExLjUgNi4yNzYxNCAxMS43MjM5IDYuNSAxMiA2LjVaIiBmaWxsPSIjMDAwMDAwIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjwvc3ZnPg=="

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/icon-nfs-action.ba89ee9.svg";

/***/ }),
/* 156 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/icon-text-action.3d7ff54.svg";

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(1868);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(1867);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(82)))

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1607)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(720),
	  /* template */
	  __webpack_require__(2143),
	  /* scopeId */
	  "data-v-5dc1d5a0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1684)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(721),
	  /* template */
	  __webpack_require__(2225),
	  /* scopeId */
	  "data-v-f27ceba4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1591)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(738),
	  /* template */
	  __webpack_require__(2126),
	  /* scopeId */
	  "data-v-51f43f5a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1615)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(739),
	  /* template */
	  __webpack_require__(2151),
	  /* scopeId */
	  "data-v-637811f5",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	if (true) {
	  module.exports = __webpack_require__(2231)
	} else {
	  module.exports = require('./vue.common.dev.js')
	}


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var helpers_1 = __webpack_require__(96);
	/**
	 * Unwrap a coordinate from a Point Feature, Geometry or a single coordinate.
	 *
	 * @name getCoord
	 * @param {Array<number>|Geometry<Point>|Feature<Point>} coord GeoJSON Point or an Array of numbers
	 * @returns {Array<number>} coordinates
	 * @example
	 * var pt = turf.point([10, 10]);
	 *
	 * var coord = turf.getCoord(pt);
	 * //= [10, 10]
	 */
	function getCoord(coord) {
	    if (!coord) {
	        throw new Error("coord is required");
	    }
	    if (!Array.isArray(coord)) {
	        if (coord.type === "Feature" &&
	            coord.geometry !== null &&
	            coord.geometry.type === "Point") {
	            return coord.geometry.coordinates;
	        }
	        if (coord.type === "Point") {
	            return coord.coordinates;
	        }
	    }
	    if (Array.isArray(coord) &&
	        coord.length >= 2 &&
	        !Array.isArray(coord[0]) &&
	        !Array.isArray(coord[1])) {
	        return coord;
	    }
	    throw new Error("coord must be GeoJSON Point or an Array of numbers");
	}
	exports.getCoord = getCoord;
	/**
	 * Unwrap coordinates from a Feature, Geometry Object or an Array
	 *
	 * @name getCoords
	 * @param {Array<any>|Geometry|Feature} coords Feature, Geometry Object or an Array
	 * @returns {Array<any>} coordinates
	 * @example
	 * var poly = turf.polygon([[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]);
	 *
	 * var coords = turf.getCoords(poly);
	 * //= [[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]
	 */
	function getCoords(coords) {
	    if (Array.isArray(coords)) {
	        return coords;
	    }
	    // Feature
	    if (coords.type === "Feature") {
	        if (coords.geometry !== null) {
	            return coords.geometry.coordinates;
	        }
	    }
	    else {
	        // Geometry
	        if (coords.coordinates) {
	            return coords.coordinates;
	        }
	    }
	    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
	}
	exports.getCoords = getCoords;
	/**
	 * Checks if coordinates contains a number
	 *
	 * @name containsNumber
	 * @param {Array<any>} coordinates GeoJSON Coordinates
	 * @returns {boolean} true if Array contains a number
	 */
	function containsNumber(coordinates) {
	    if (coordinates.length > 1 &&
	        helpers_1.isNumber(coordinates[0]) &&
	        helpers_1.isNumber(coordinates[1])) {
	        return true;
	    }
	    if (Array.isArray(coordinates[0]) && coordinates[0].length) {
	        return containsNumber(coordinates[0]);
	    }
	    throw new Error("coordinates must only contain numbers");
	}
	exports.containsNumber = containsNumber;
	/**
	 * Enforce expectations about types of GeoJSON objects for Turf.
	 *
	 * @name geojsonType
	 * @param {GeoJSON} value any GeoJSON object
	 * @param {string} type expected GeoJSON type
	 * @param {string} name name of calling function
	 * @throws {Error} if value is not the expected type.
	 */
	function geojsonType(value, type, name) {
	    if (!type || !name) {
	        throw new Error("type and name required");
	    }
	    if (!value || value.type !== type) {
	        throw new Error("Invalid input to " +
	            name +
	            ": must be a " +
	            type +
	            ", given " +
	            value.type);
	    }
	}
	exports.geojsonType = geojsonType;
	/**
	 * Enforce expectations about types of {@link Feature} inputs for Turf.
	 * Internally this uses {@link geojsonType} to judge geometry types.
	 *
	 * @name featureOf
	 * @param {Feature} feature a feature with an expected geometry type
	 * @param {string} type expected GeoJSON type
	 * @param {string} name name of calling function
	 * @throws {Error} error if value is not the expected type.
	 */
	function featureOf(feature, type, name) {
	    if (!feature) {
	        throw new Error("No feature passed");
	    }
	    if (!name) {
	        throw new Error(".featureOf() requires a name");
	    }
	    if (!feature || feature.type !== "Feature" || !feature.geometry) {
	        throw new Error("Invalid input to " + name + ", Feature with geometry required");
	    }
	    if (!feature.geometry || feature.geometry.type !== type) {
	        throw new Error("Invalid input to " +
	            name +
	            ": must be a " +
	            type +
	            ", given " +
	            feature.geometry.type);
	    }
	}
	exports.featureOf = featureOf;
	/**
	 * Enforce expectations about types of {@link FeatureCollection} inputs for Turf.
	 * Internally this uses {@link geojsonType} to judge geometry types.
	 *
	 * @name collectionOf
	 * @param {FeatureCollection} featureCollection a FeatureCollection for which features will be judged
	 * @param {string} type expected GeoJSON type
	 * @param {string} name name of calling function
	 * @throws {Error} if value is not the expected type.
	 */
	function collectionOf(featureCollection, type, name) {
	    if (!featureCollection) {
	        throw new Error("No featureCollection passed");
	    }
	    if (!name) {
	        throw new Error(".collectionOf() requires a name");
	    }
	    if (!featureCollection || featureCollection.type !== "FeatureCollection") {
	        throw new Error("Invalid input to " + name + ", FeatureCollection required");
	    }
	    for (var _i = 0, _a = featureCollection.features; _i < _a.length; _i++) {
	        var feature = _a[_i];
	        if (!feature || feature.type !== "Feature" || !feature.geometry) {
	            throw new Error("Invalid input to " + name + ", Feature with geometry required");
	        }
	        if (!feature.geometry || feature.geometry.type !== type) {
	            throw new Error("Invalid input to " +
	                name +
	                ": must be a " +
	                type +
	                ", given " +
	                feature.geometry.type);
	        }
	    }
	}
	exports.collectionOf = collectionOf;
	/**
	 * Get Geometry from Feature or Geometry Object
	 *
	 * @param {Feature|Geometry} geojson GeoJSON Feature or Geometry Object
	 * @returns {Geometry|null} GeoJSON Geometry Object
	 * @throws {Error} if geojson is not a Feature or Geometry Object
	 * @example
	 * var point = {
	 *   "type": "Feature",
	 *   "properties": {},
	 *   "geometry": {
	 *     "type": "Point",
	 *     "coordinates": [110, 40]
	 *   }
	 * }
	 * var geom = turf.getGeom(point)
	 * //={"type": "Point", "coordinates": [110, 40]}
	 */
	function getGeom(geojson) {
	    if (geojson.type === "Feature") {
	        return geojson.geometry;
	    }
	    return geojson;
	}
	exports.getGeom = getGeom;
	/**
	 * Get GeoJSON object's type, Geometry type is prioritize.
	 *
	 * @param {GeoJSON} geojson GeoJSON object
	 * @param {string} [name="geojson"] name of the variable to display in error message (unused)
	 * @returns {string} GeoJSON type
	 * @example
	 * var point = {
	 *   "type": "Feature",
	 *   "properties": {},
	 *   "geometry": {
	 *     "type": "Point",
	 *     "coordinates": [110, 40]
	 *   }
	 * }
	 * var geom = turf.getType(point)
	 * //="Point"
	 */
	function getType(geojson, _name) {
	    if (geojson.type === "FeatureCollection") {
	        return "FeatureCollection";
	    }
	    if (geojson.type === "GeometryCollection") {
	        return "GeometryCollection";
	    }
	    if (geojson.type === "Feature" && geojson.geometry !== null) {
	        return geojson.geometry.type;
	    }
	    return geojson.type;
	}
	exports.getType = getType;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// Taken from http://geomalgorithms.com/a02-_lines.html
	var invariant_1 = __webpack_require__(165);
	var meta_1 = __webpack_require__(536);
	var distance_1 = __webpack_require__(535);
	var rhumb_distance_1 = __webpack_require__(537);
	var helpers_1 = __webpack_require__(96);
	/**
	 * Returns the minimum distance between a {@link Point} and a {@link LineString}, being the distance from a line the
	 * minimum distance between the point and any segment of the `LineString`.
	 *
	 * @name pointToLineDistance
	 * @param {Feature<Point>|Array<number>} pt Feature or Geometry
	 * @param {Feature<LineString>} line GeoJSON Feature or Geometry
	 * @param {Object} [options={}] Optional parameters
	 * @param {string} [options.units='kilometers'] can be anything supported by turf/convertLength, eg degrees, radians, miles, or kilometers
	 * @param {string} [options.method='geodesic'] wehther to calculate the distance based on geodesic (spheroid) or planar (flat) method. Valid options are 'geodesic' or 'planar'.
	 * @returns {number} distance between point and line
	 * @example
	 * var pt = turf.point([0, 0]);
	 * var line = turf.lineString([[1, 1],[-1, 1]]);
	 *
	 * var distance = turf.pointToLineDistance(pt, line, {units: 'miles'});
	 * //=69.11854715938406
	 */
	function pointToLineDistance(pt, line, options) {
	    if (options === void 0) { options = {}; }
	    // Optional parameters
	    if (!options.method)
	        options.method = 'geodesic';
	    if (!options.units)
	        options.units = 'kilometers';
	    // validation
	    if (!pt)
	        throw new Error('pt is required');
	    if (Array.isArray(pt))
	        pt = helpers_1.point(pt);
	    else if (pt.type === 'Point')
	        pt = helpers_1.feature(pt);
	    else
	        invariant_1.featureOf(pt, 'Point', 'point');
	    if (!line)
	        throw new Error('line is required');
	    if (Array.isArray(line))
	        line = helpers_1.lineString(line);
	    else if (line.type === 'LineString')
	        line = helpers_1.feature(line);
	    else
	        invariant_1.featureOf(line, 'LineString', 'line');
	    var distance = Infinity;
	    var p = pt.geometry.coordinates;
	    meta_1.segmentEach(line, function (segment) {
	        var a = segment.geometry.coordinates[0];
	        var b = segment.geometry.coordinates[1];
	        var d = distanceToSegment(p, a, b, options);
	        if (d < distance)
	            distance = d;
	    });
	    return helpers_1.convertLength(distance, 'degrees', options.units);
	}
	/**
	 * Returns the distance between a point P on a segment AB.
	 *
	 * @private
	 * @param {Array<number>} p external point
	 * @param {Array<number>} a first segment point
	 * @param {Array<number>} b second segment point
	  * @param {Object} [options={}] Optional parameters
	 * @returns {number} distance
	 */
	function distanceToSegment(p, a, b, options) {
	    var v = [b[0] - a[0], b[1] - a[1]];
	    var w = [p[0] - a[0], p[1] - a[1]];
	    var c1 = dot(w, v);
	    if (c1 <= 0)
	        return calcDistance(p, a, { method: options.method, units: 'degrees' });
	    var c2 = dot(v, v);
	    if (c2 <= c1)
	        return calcDistance(p, b, { method: options.method, units: 'degrees' });
	    var b2 = c1 / c2;
	    var Pb = [a[0] + (b2 * v[0]), a[1] + (b2 * v[1])];
	    return calcDistance(p, Pb, { method: options.method, units: 'degrees' });
	}
	function dot(u, v) {
	    return (u[0] * v[0] + u[1] * v[1]);
	}
	function calcDistance(a, b, options) {
	    return options.method === 'planar' ? rhumb_distance_1.default(a, b, options) : distance_1.default(a, b, options);
	}
	exports.default = pointToLineDistance;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(40);
	var normalizeHeaderName = __webpack_require__(553);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(229);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(229);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMehtodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(82)))

/***/ }),
/* 168 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MOVE_MAIS_MARK_VIEWBOX = exports.MOVE_MAIS_MARK_VIEWBOX = '-2 -2 129 112';
	
	var MOVE_MAIS_MARK_PATH = exports.MOVE_MAIS_MARK_PATH = 'M43.9776 34.307C46.8078 37.1858 46.8078 41.8564 43.9776 44.7355C41.1473 47.6143 36.556 47.6143 33.7257 44.7355L14.5006 25.1782V82.7648L93.7404 2.15899C96.5706 -0.719664 101.162 -0.719664 103.992 2.15899C105.407 3.59818 106.115 5.4857 106.115 7.37336L106.117 43.2974C106.117 47.3705 102.871 50.6727 98.8664 50.6727C94.8624 50.6727 91.616 47.3705 91.616 43.2974V25.1772L12.4479 105.71C11.1303 107.088 9.28924 107.944 7.25019 107.944C3.24607 107.944 0 104.642 0 100.569V7.37336C0.00161364 5.4857 0.708782 3.59818 2.12439 2.15899C4.95437 -0.719664 9.54602 -0.719664 12.3762 2.15899L43.9776 34.307ZM80.4515 89.2115H91.616V100.57C91.616 104.643 94.8624 107.945 98.8664 107.945C102.871 107.945 106.117 104.643 106.117 100.57V89.2115H117.282C121.287 89.2115 124.533 85.9093 124.533 81.8363C124.533 77.763 121.287 74.4608 117.282 74.4608H106.117V63.1037C106.117 59.0304 102.871 55.7283 98.8664 55.7283C94.8624 55.7283 91.616 59.0304 91.616 63.1037V74.4608H80.4515C76.4474 74.4608 73.201 77.763 73.201 81.8363C73.201 85.9093 76.4474 89.2115 80.4515 89.2115Z';

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _creditCard = __webpack_require__(529);
	
	var _creditCard2 = _interopRequireDefault(_creditCard);
	
	var _bankAccount = __webpack_require__(528);
	
	var _bankAccount2 = _interopRequireDefault(_bankAccount);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var typeOptions = [{ caption: "Débito em conta", value: "DC" }, { caption: "Cartão de crédito", value: "CC" }];
	
	exports.default = {
	  props: ['payment', 'planId', 'addressMailing', 'creditCardOptions', 'bankAccountOptions', 'bankBillOption', 'tedOption', 'docOption'],
	  data: function data() {
	    return {
	      address: undefined,
	      loading: undefined,
	      creditCard: undefined,
	      bankAccount: undefined,
	      itemSelected: undefined,
	      valueCard: undefined,
	      valueBank: undefined,
	      type: undefined,
	      typeOptions: typeOptions,
	      creditAddress: undefined,
	      addressStart: undefined
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    if (!(this.creditCard && this.creditCard.billingAddress)) {
	      this.addressStart = _.cloneDeep(this.addressMailing);
	    }
	
	    if (this.payment.creditCard) this.type = 'CC';else if (this.payment.bankAccount) this.type = 'DC';else if (this.payment.bankBill) this.type = 'BC';else if (this.payment.ted) this.type = 'TE';else if (this.payment.doc) this.type = 'DO';else {
	      if (this.bankAccountOptions && this.bankAccountOptions.length) this.type = 'DC';else if (this.creditCardOptions && this.creditCardOptions.length) this.type = 'CC';else this.type = 'BC';
	    }
	
	    this.$watch('bankAccount', function () {
	      delete _this.payment.bankBill;
	      delete _this.payment.creditCard;
	      _this.payment.bankAccount = _this.bankAccount;
	      _this.payment.paymentMethodId = _this.bankAccount.paymentMethodId;
	      _this.payment.imagePath = _this.bankAccount.imagePath;
	      _this.payment.validForm = _this.bankAccount.validForm;
	    }, { deep: true });
	
	    this.$watch('creditCard', function () {
	      delete _this.payment.bankBill;
	      delete _this.payment.bankAccount;
	      _this.payment.paymentMethodId = _this.creditCard.paymentMethodId;
	      _this.payment.creditCard = _this.creditCard;
	      _this.payment.imagePath = _this.creditCard.imagePath;
	      _this.payment.validForm = _this.creditCard.validForm;
	    }, { deep: true });
	  },
	
	
	  computed: {
	    bankIdSelected: function bankIdSelected() {
	      return this.bankAccount && this.bankAccount.paymentMethodId || this.bankAccountOptions[0] && this.bankAccountOptions[0].value;
	    },
	    cardIdSelected: function cardIdSelected() {
	      return this.creditCard && this.creditCard.paymentMethodId || this.creditCardOptions[0] && this.creditCardOptions[0].value;
	    },
	    typesAllowed: function typesAllowed() {
	      return this.$store.getters.getPaymentsTypesByPlan(this.planId);
	    },
	    colClassPayment: function colClassPayment() {
	      if (this.typesAllowed) {
	        var c = parseInt(12 / this.typesAllowed.qtd);
	        return 'col-md-' + c;
	      }
	      return 'col-md-4';
	    }
	  },
	
	  watch: {
	    type: function type(newValue) {
	      delete this.payment.bankBill;
	      delete this.payment.bankAccount;
	      delete this.payment.creditCard;
	      if (newValue == 'BC') {
	        this.payment.paymentMethodId = this.bankBillOption.paymentMethodId;
	        this.payment.imagePath = this.bankBillOption.imagePath;
	        this.payment.type = this.bankBillOption.type;
	        this.payment.name = this.bankBillOption.name;
	        this.payment.bankBill = {
	          billNumber: this.bankBillOption.paymentMethodId,
	          imagePath: this.bankBillOption.imagePath
	        };
	        this.payment.validForm = true;
	      } else if (newValue == 'DC') {
	        this.payment.bankAccount = this.bankAccount;
	        this.payment.validForm = this.bankAccount.validForm;
	        this.payment.paymentMethodId = this.bankAccount.paymentMethodId;
	      } else if (newValue == 'CC') {
	        this.payment.creditCard = this.creditCard;
	        this.payment.validForm = this.creditCard && this.creditCard.validForm;
	        this.payment.paymentMethodId = this.creditCard && this.creditCard.paymentMethodId;
	      } else if (newValue == 'TE') {
	        this.payment.paymentMethodId = this.tedOption.paymentMethodId;
	        this.payment.imagePath = this.tedOption.imagePath;
	        this.payment.type = 'TE';
	        this.payment.name = 'TED';
	        this.payment.bankBill = {
	          billNumber: this.tedOption.paymentMethodId,
	          imagePath: this.tedOption.imagePath
	        };
	        this.payment.validForm = true;
	      } else if (newValue == 'DO') {
	        this.payment.paymentMethodId = this.docOption.paymentMethodId;
	        this.payment.imagePath = this.docOption.imagePath;
	        this.payment.type = 'DO';
	        this.payment.name = 'DOC';
	        this.payment.bankBill = {
	          billNumber: this.docOption.paymentMethodId,
	          imagePath: this.docOption.imagePath
	        };
	        this.payment.validForm = true;
	      }
	    }
	  },
	
	  methods: {
	    validateAll: function validateAll() {
	      if (this.type == 'BC') return _promise2.default.resolve(true);else if (this.type == 'CC') return this.$refs.creditCard.validateAll();else if (this.type == 'DC') return this.$refs.bankAccount.$validator.validateAll();else if (this.type == 'TE') return _promise2.default.resolve(true);else if (this.type == 'DO') return _promise2.default.resolve(true);
	
	      return _promise2.default.reject();
	    }
	  },
	
	  components: { CreditCard: _creditCard2.default, BankAccount: _bankAccount2.default }
	};

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(28);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Invoice = function () {
	  function Invoice() {
	    (0, _classCallCheck3.default)(this, Invoice);
	  }
	
	  (0, _createClass3.default)(Invoice, [{
	    key: "list",
	    value: function list(contractId) {
	      return _axios2.default.get("/v2/invoice/list/" + contractId).then(function (res) {
	        return res.data.invoices;
	      });
	    }
	  }, {
	    key: "getExtratoConsolidado",
	    value: function getExtratoConsolidado(contractId) {
	      return _axios2.default.get("/v2/getXlsxConsolidado/" + contractId).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "getTxt",
	    value: function getTxt(id) {
	      return _axios2.default.get("/v2/invoice/getTxt/" + id).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: "getLinkNFe",
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(salesOrderId) {
	        var res;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _axios2.default.get("/v2/invoice/linkNFe/" + salesOrderId);
	
	              case 2:
	                res = _context.sent;
	                return _context.abrupt("return", res.data);
	
	              case 4:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function getLinkNFe(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return getLinkNFe;
	    }()
	  }]);
	  return Invoice;
	}();
	
	var instance = new Invoice();
	exports.default = instance;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(28);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _pagination = __webpack_require__(33);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toJSONDate(s) {
	  return (0, _moment2.default)(s, "YYYY-MM-DD HH:mm").toJSON();
	}
	
	var Statements = function () {
	  function Statements() {
	    (0, _classCallCheck3.default)(this, Statements);
	  }
	
	  (0, _createClass3.default)(Statements, [{
	    key: 'find',
	    value: function find(filter) {
	      var f = filter;
	
	      return _axios2.default.post('/v2/getCustomStatement', filter).then(function (res) {
	
	        return res.data.statements;
	      }).catch(function (err) {
	        if (err.data && err.data.status && err.data.status.code == 9990) {
	          return err.data;
	        } else {
	          console.error(err);
	          throw err;
	        }
	      });
	    }
	  }, {
	    key: 'findExtratoConsolidado',
	    value: function findExtratoConsolidado(filter) {
	      var config = {
	        responseType: "blob"
	      };
	      return _axios2.default.post('/v2/getXlsxConsolidado', filter, config).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getSummary',
	    value: function getSummary(filter) {
	      return _axios2.default.post('/v2/getStatementResume', filter).then(function (res) {
	
	        return res.data.summary;
	      });
	    }
	  }, {
	    key: 'getSaldoVeiculosFull',
	    value: function getSaldoVeiculosFull(filter) {
	      return _axios2.default.post('/v2/getSaldoVeiculosFull', filter).then(function (res) {
	
	        return res.data;
	      });
	    }
	  }, {
	    key: 'downloadFile',
	    value: function downloadFile(url, transactionsRefund) {
	      return _axios2.default.get(url, {
	        params: {
	          transactions: transactionsRefund
	        }
	      }).catch(function (error) {
	        console.error(error);
	      });
	    }
	  }, {
	    key: 'exportarExtratoConsolidado',
	    value: function exportarExtratoConsolidado(filter) {
	      var config = { responseType: "blob" };
	      return _axios2.default.post('/v2/statement/exportarExtratoConsolidado', filter, config).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'exportarExtratoConsolidadoNew',
	    value: function exportarExtratoConsolidadoNew(filter) {
	      var config = { responseType: "blob" };
	      return _axios2.default.post('/v2/statement/exportarExtratoConsolidadoNew', filter, config).then(function (res) {
	        return res.data;
	      });
	    }
	  }]);
	  return Statements;
	}();
	
	var instance = new Statements();
	exports.default = instance;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(164);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(120);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vuexPersist = __webpack_require__(2234);
	
	var _vuexPersist2 = _interopRequireDefault(_vuexPersist);
	
	var _sales = __webpack_require__(754);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _loading = __webpack_require__(752);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _contract = __webpack_require__(751);
	
	var _contract2 = _interopRequireDefault(_contract);
	
	var _route = __webpack_require__(753);
	
	var _route2 = _interopRequireDefault(_route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var store = new _vuex2.default.Store({
	  modules: {
	    sales: _sales2.default,
	    loading: _loading2.default,
	    contract: _contract2.default,
	    route: _route2.default
	  }
	});
	
	exports.default = store;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(787), __esModule: true };

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(795), __esModule: true };

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(801), __esModule: true };

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(802), __esModule: true };

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(765);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(69);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var uint_max = Math.pow(2, 32);
	function fixup_uint32(x) {
	    var ret, x_pos;
	    ret = x > uint_max || x < 0 ? (x_pos = Math.abs(x) % uint_max, x < 0 ? uint_max - x_pos : x_pos) : x;
	    return ret;
	}
	function scrub_vec(v) {
	  var i, _i, _ref;
	  for (i = _i = 0, _ref = v.length; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
	    v[i] = 0;
	  }
	  return false;
	}
	
	function Global() {
	  var i;
	  this.SBOX = [];
	  this.INV_SBOX = [];
	  this.SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.INV_SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.init();
	  this.RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	}
	
	Global.prototype.init = function() {
	  var d, i, sx, t, x, x2, x4, x8, xi, _i;
	  d = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 256; i = ++_i) {
	      if (i < 128) {
	        _results.push(i << 1);
	      } else {
	        _results.push((i << 1) ^ 0x11b);
	      }
	    }
	    return _results;
	  })();
	  x = 0;
	  xi = 0;
	  for (i = _i = 0; _i < 256; i = ++_i) {
	    sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	    this.SBOX[x] = sx;
	    this.INV_SBOX[sx] = x;
	    x2 = d[x];
	    x4 = d[x2];
	    x8 = d[x4];
	    t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	    this.SUB_MIX[0][x] = (t << 24) | (t >>> 8);
	    this.SUB_MIX[1][x] = (t << 16) | (t >>> 16);
	    this.SUB_MIX[2][x] = (t << 8) | (t >>> 24);
	    this.SUB_MIX[3][x] = t;
	    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	    this.INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8);
	    this.INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16);
	    this.INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24);
	    this.INV_SUB_MIX[3][sx] = t;
	    if (x === 0) {
	      x = xi = 1;
	    } else {
	      x = x2 ^ d[d[d[x8 ^ x2]]];
	      xi ^= d[d[xi]];
	    }
	  }
	  return true;
	};
	
	var G = new Global();
	
	
	AES.blockSize = 4 * 4;
	
	AES.prototype.blockSize = AES.blockSize;
	
	AES.keySize = 256 / 8;
	
	AES.prototype.keySize = AES.keySize;
	
	AES.ivSize = AES.blockSize;
	
	AES.prototype.ivSize = AES.ivSize;
	
	 function bufferToArray(buf) {
	  var len = buf.length/4;
	  var out = new Array(len);
	  var i = -1;
	  while (++i < len) {
	    out[i] = buf.readUInt32BE(i * 4);
	  }
	  return out;
	 }
	function AES(key) {
	  this._key = bufferToArray(key);
	  this._doReset();
	}
	
	AES.prototype._doReset = function() {
	  var invKsRow, keySize, keyWords, ksRow, ksRows, t, _i, _j;
	  keyWords = this._key;
	  keySize = keyWords.length;
	  this._nRounds = keySize + 6;
	  ksRows = (this._nRounds + 1) * 4;
	  this._keySchedule = [];
	  for (ksRow = _i = 0; 0 <= ksRows ? _i < ksRows : _i > ksRows; ksRow = 0 <= ksRows ? ++_i : --_i) {
	    this._keySchedule[ksRow] = ksRow < keySize ? keyWords[ksRow] : (t = this._keySchedule[ksRow - 1], (ksRow % keySize) === 0 ? (t = (t << 8) | (t >>> 24), t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff], t ^= G.RCON[(ksRow / keySize) | 0] << 24) : keySize > 6 && ksRow % keySize === 4 ? t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff] : void 0, this._keySchedule[ksRow - keySize] ^ t);
	  }
	  this._invKeySchedule = [];
	  for (invKsRow = _j = 0; 0 <= ksRows ? _j < ksRows : _j > ksRows; invKsRow = 0 <= ksRows ? ++_j : --_j) {
	    ksRow = ksRows - invKsRow;
	    t = this._keySchedule[ksRow - (invKsRow % 4 ? 0 : 4)];
	    this._invKeySchedule[invKsRow] = invKsRow < 4 || ksRow <= 4 ? t : G.INV_SUB_MIX[0][G.SBOX[t >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[(t >>> 16) & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[(t >>> 8) & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[t & 0xff]];
	  }
	  return true;
	};
	
	AES.prototype.encryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var out = this._doCryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[1], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[3], 12);
	  return buf;
	};
	
	AES.prototype.decryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var temp = [M[3], M[1]];
	  M[1] = temp[0];
	  M[3] = temp[1];
	  var out = this._doCryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[3], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[1], 12);
	  return buf;
	};
	
	AES.prototype.scrub = function() {
	  scrub_vec(this._keySchedule);
	  scrub_vec(this._invKeySchedule);
	  scrub_vec(this._key);
	};
	
	AES.prototype._doCryptBlock = function(M, keySchedule, SUB_MIX, SBOX) {
	  var ksRow, round, s0, s1, s2, s3, t0, t1, t2, t3, _i, _ref;
	
	  s0 = M[0] ^ keySchedule[0];
	  s1 = M[1] ^ keySchedule[1];
	  s2 = M[2] ^ keySchedule[2];
	  s3 = M[3] ^ keySchedule[3];
	  ksRow = 4;
	  for (round = _i = 1, _ref = this._nRounds; 1 <= _ref ? _i < _ref : _i > _ref; round = 1 <= _ref ? ++_i : --_i) {
	    t0 = SUB_MIX[0][s0 >>> 24] ^ SUB_MIX[1][(s1 >>> 16) & 0xff] ^ SUB_MIX[2][(s2 >>> 8) & 0xff] ^ SUB_MIX[3][s3 & 0xff] ^ keySchedule[ksRow++];
	    t1 = SUB_MIX[0][s1 >>> 24] ^ SUB_MIX[1][(s2 >>> 16) & 0xff] ^ SUB_MIX[2][(s3 >>> 8) & 0xff] ^ SUB_MIX[3][s0 & 0xff] ^ keySchedule[ksRow++];
	    t2 = SUB_MIX[0][s2 >>> 24] ^ SUB_MIX[1][(s3 >>> 16) & 0xff] ^ SUB_MIX[2][(s0 >>> 8) & 0xff] ^ SUB_MIX[3][s1 & 0xff] ^ keySchedule[ksRow++];
	    t3 = SUB_MIX[0][s3 >>> 24] ^ SUB_MIX[1][(s0 >>> 16) & 0xff] ^ SUB_MIX[2][(s1 >>> 8) & 0xff] ^ SUB_MIX[3][s2 & 0xff] ^ keySchedule[ksRow++];
	    s0 = t0;
	    s1 = t1;
	    s2 = t2;
	    s3 = t3;
	  }
	  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	  return [
	    fixup_uint32(t0),
	    fixup_uint32(t1),
	    fixup_uint32(t2),
	    fixup_uint32(t3)
	  ];
	
	};
	
	
	
	
	  exports.AES = AES;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32).Buffer))

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var Transform = __webpack_require__(1725).Transform;
	var inherits = __webpack_require__(52);
	
	module.exports = CipherBase;
	inherits(CipherBase, Transform);
	function CipherBase() {
	  Transform.call(this);
	}
	CipherBase.prototype.update = function (data, inputEnd, outputEnc) {
	  this.write(data, inputEnd);
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	CipherBase.prototype.final = function (outputEnc) {
	  this.end();
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32).Buffer))

/***/ }),
/* 180 */
/***/ (function(module, exports) {

	exports['aes-128-ecb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-192-ecb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-256-ecb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-128-cbc'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-192-cbc'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-256-cbc'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes128'] = exports['aes-128-cbc'];
	exports['aes192'] = exports['aes-192-cbc'];
	exports['aes256'] = exports['aes-256-cbc'];
	exports['aes-128-cfb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-192-cfb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-256-cfb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-128-ofb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-192-ofb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-256-ofb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-128-ctr'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-192-ctr'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-256-ctr'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};

/***/ }),
/* 181 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 182 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(42);
	var document = __webpack_require__(36).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 184 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(101);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(103);
	var $export = __webpack_require__(31);
	var redefine = __webpack_require__(270);
	var hide = __webpack_require__(62);
	var Iterators = __webpack_require__(87);
	var $iterCreate = __webpack_require__(818);
	var setToStringTag = __webpack_require__(106);
	var getPrototypeOf = __webpack_require__(266);
	var ITERATOR = __webpack_require__(37)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(100);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(104);
	var createDesc = __webpack_require__(105);
	var toIObject = __webpack_require__(63);
	var toPrimitive = __webpack_require__(194);
	var has = __webpack_require__(72);
	var IE8_DOM_DEFINE = __webpack_require__(259);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(41) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 189 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(62);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(192)('keys');
	var uid = __webpack_require__(129);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(23);
	var global = __webpack_require__(36);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(103) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 193 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(42);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(42);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(36);
	var core = __webpack_require__(23);
	var LIBRARY = __webpack_require__(103);
	var wksExt = __webpack_require__(197);
	var defineProperty = __webpack_require__(45).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(37);


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(124);
	var ITERATOR = __webpack_require__(37)('iterator');
	var Iterators = __webpack_require__(87);
	module.exports = __webpack_require__(23).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(109));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCWeekYear(dirtyDate, dirtyOptions) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var year = date.getUTCFullYear();
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	
	  var firstWeekOfNextYear = new Date(0);
	  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
	  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, dirtyOptions);
	  var firstWeekOfThisYear = new Date(0);
	  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
	  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, dirtyOptions);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addHours;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(110));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_HOUR = 3600000;
	/**
	 * @name addHours
	 * @category Hour Helpers
	 * @summary Add the specified number of hours to the given date.
	 *
	 * @description
	 * Add the specified number of hours to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the hours added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 2 hours to 10 July 2014 23:00:00:
	 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
	 * //=> Fri Jul 11 2014 01:00:00
	 */
	
	function addHours(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
	}
	
	module.exports = exports.default;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(110));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_MINUTE = 60000;
	/**
	 * @name addMinutes
	 * @category Minute Helpers
	 * @summary Add the specified number of minutes to the given date.
	 *
	 * @description
	 * Add the specified number of minutes to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the minutes added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 30 minutes to 10 July 2014 12:00:00:
	 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 12:30:00
	 */
	
	function addMinutes(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
	}
	
	module.exports = exports.default;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(111));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addQuarters
	 * @category Quarter Helpers
	 * @summary Add the specified number of year quarters to the given date.
	 *
	 * @description
	 * Add the specified number of year quarters to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of quarters to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the quarters added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 1 quarter to 1 September 2014:
	 * const result = addQuarters(new Date(2014, 8, 1), 1)
	 * //=> Mon Dec 01 2014 00:00:00
	 */
	function addQuarters(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  var months = amount * 3;
	  return (0, _index2.default)(dirtyDate, months);
	}
	
	module.exports = exports.default;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInDays;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(76));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Like `compareAsc` but uses local time not UTC, which is needed
	// for accurate equality comparisons of UTC timestamps that end up
	// having the same representation in local time, e.g. one hour before
	// DST ends vs. the instant that DST ends.
	function compareLocalAsc(dateLeft, dateRight) {
	  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
	
	  if (diff < 0) {
	    return -1;
	  } else if (diff > 0) {
	    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
	  } else {
	    return diff;
	  }
	}
	/**
	 * @name differenceInDays
	 * @category Day Helpers
	 * @summary Get the number of full days between the given dates.
	 *
	 * @description
	 * Get the number of full day periods between two dates. Fractional days are
	 * truncated towards zero.
	 *
	 * One "full day" is the distance between a local time in one day to the same
	 * local time on the next or previous day. A full day can sometimes be less than
	 * or more than 24 hours if a daylight savings change happens between two dates.
	 *
	 * To ignore DST and only measure exact 24-hour periods, use this instead:
	 * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
	 *
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full days according to the local timezone
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * const result = differenceInDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 365
	 * // How many full days are between
	 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
	 * const result = differenceInDays(
	 *   new Date(2011, 6, 3, 0, 1),
	 *   new Date(2011, 6, 2, 23, 59)
	 * )
	 * //=> 0
	 * // How many full days are between
	 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
	 * // Note: because local time is used, the
	 * // result will always be 92 days, even in
	 * // time zones where DST starts and the
	 * // period has only 92*24-1 hours.
	 * const result = differenceInDays(
	 *   new Date(2020, 5, 1),
	 *   new Date(2020, 2, 1)
	 * )
	//=> 92
	 */
	
	
	function differenceInDays(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = compareLocalAsc(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  dateLeft.setDate(dateLeft.getDate() - sign * difference); // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
	  // If so, result must be decreased by 1 in absolute value
	
	  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
	  var result = sign * (difference - isLastDayNotFull); // Prevent negative zero
	
	  return result === 0 ? 0 : result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(135));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	var _index3 = __webpack_require__(108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInSeconds
	 * @category Second Helpers
	 * @summary Get the number of seconds between the given dates.
	 *
	 * @description
	 * Get the number of seconds between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Number} the number of seconds
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many seconds are between
	 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
	 * const result = differenceInSeconds(
	 *   new Date(2014, 6, 2, 12, 30, 20, 0),
	 *   new Date(2014, 6, 2, 12, 30, 7, 999)
	 * )
	 * //=> 12
	 */
	function differenceInSeconds(dateLeft, dateRight, options) {
	  (0, _index2.default)(2, arguments);
	  var diff = (0, _index.default)(dateLeft, dateRight) / 1000;
	  return (0, _index3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
	}
	
	module.exports = exports.default;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachWeekendOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(296));
	
	var _index2 = _interopRequireDefault(__webpack_require__(210));
	
	var _index3 = _interopRequireDefault(__webpack_require__(138));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachWeekendOfInterval
	 * @category Interval Helpers
	 * @summary List all the Saturdays and Sundays in the given date interval.
	 *
	 * @description
	 * Get all the Saturdays and Sundays in the given date interval.
	 *
	 * @param {Interval} interval - the given interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @returns {Date[]} an array containing all the Saturdays and Sundays
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Lists all Saturdays and Sundays in the given date interval
	 * const result = eachWeekendOfInterval({
	 *   start: new Date(2018, 8, 17),
	 *   end: new Date(2018, 8, 30)
	 * })
	 * //=> [
	 * //   Sat Sep 22 2018 00:00:00,
	 * //   Sun Sep 23 2018 00:00:00,
	 * //   Sat Sep 29 2018 00:00:00,
	 * //   Sun Sep 30 2018 00:00:00
	 * // ]
	 */
	function eachWeekendOfInterval(interval) {
	  (0, _index4.default)(1, arguments);
	  var dateInterval = (0, _index.default)(interval);
	  var weekends = [];
	  var index = 0;
	
	  while (index < dateInterval.length) {
	    var date = dateInterval[index++];
	
	    if ((0, _index3.default)(date)) {
	      weekends.push(date);
	      if ((0, _index2.default)(date)) index = index + 5;
	    }
	  }
	
	  return weekends;
	}
	
	module.exports = exports.default;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfDay;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfDay
	 * @category Day Helpers
	 * @summary Return the end of a day for the given date.
	 *
	 * @description
	 * Return the end of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a day
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a day for 2 September 2014 11:55:00:
	 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 23:59:59.999
	 */
	function endOfDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfMonth
	 * @category Month Helpers
	 * @summary Return the end of a month for the given date.
	 *
	 * @description
	 * Return the end of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a month for 2 September 2014 11:55:00:
	 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 23:59:59.999
	 */
	function endOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  date.setFullYear(date.getFullYear(), month + 1, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  add: true,
	  addBusinessDays: true,
	  addDays: true,
	  addHours: true,
	  addISOWeekYears: true,
	  addMilliseconds: true,
	  addMinutes: true,
	  addMonths: true,
	  addQuarters: true,
	  addSeconds: true,
	  addWeeks: true,
	  addYears: true,
	  areIntervalsOverlapping: true,
	  clamp: true,
	  closestIndexTo: true,
	  closestTo: true,
	  compareAsc: true,
	  compareDesc: true,
	  daysToWeeks: true,
	  differenceInBusinessDays: true,
	  differenceInCalendarDays: true,
	  differenceInCalendarISOWeekYears: true,
	  differenceInCalendarISOWeeks: true,
	  differenceInCalendarMonths: true,
	  differenceInCalendarQuarters: true,
	  differenceInCalendarWeeks: true,
	  differenceInCalendarYears: true,
	  differenceInDays: true,
	  differenceInHours: true,
	  differenceInISOWeekYears: true,
	  differenceInMilliseconds: true,
	  differenceInMinutes: true,
	  differenceInMonths: true,
	  differenceInQuarters: true,
	  differenceInSeconds: true,
	  differenceInWeeks: true,
	  differenceInYears: true,
	  eachDayOfInterval: true,
	  eachHourOfInterval: true,
	  eachMinuteOfInterval: true,
	  eachMonthOfInterval: true,
	  eachQuarterOfInterval: true,
	  eachWeekOfInterval: true,
	  eachWeekendOfInterval: true,
	  eachWeekendOfMonth: true,
	  eachWeekendOfYear: true,
	  eachYearOfInterval: true,
	  endOfDay: true,
	  endOfDecade: true,
	  endOfHour: true,
	  endOfISOWeek: true,
	  endOfISOWeekYear: true,
	  endOfMinute: true,
	  endOfMonth: true,
	  endOfQuarter: true,
	  endOfSecond: true,
	  endOfToday: true,
	  endOfTomorrow: true,
	  endOfWeek: true,
	  endOfYear: true,
	  endOfYesterday: true,
	  format: true,
	  formatDistance: true,
	  formatDistanceStrict: true,
	  formatDistanceToNow: true,
	  formatDistanceToNowStrict: true,
	  formatDuration: true,
	  formatISO: true,
	  formatISO9075: true,
	  formatISODuration: true,
	  formatRFC3339: true,
	  formatRFC7231: true,
	  formatRelative: true,
	  fromUnixTime: true,
	  getDate: true,
	  getDay: true,
	  getDayOfYear: true,
	  getDaysInMonth: true,
	  getDaysInYear: true,
	  getDecade: true,
	  getHours: true,
	  getISODay: true,
	  getISOWeek: true,
	  getISOWeekYear: true,
	  getISOWeeksInYear: true,
	  getMilliseconds: true,
	  getMinutes: true,
	  getMonth: true,
	  getOverlappingDaysInIntervals: true,
	  getQuarter: true,
	  getSeconds: true,
	  getTime: true,
	  getUnixTime: true,
	  getWeek: true,
	  getWeekOfMonth: true,
	  getWeekYear: true,
	  getWeeksInMonth: true,
	  getYear: true,
	  hoursToMilliseconds: true,
	  hoursToMinutes: true,
	  hoursToSeconds: true,
	  intervalToDuration: true,
	  intlFormat: true,
	  isAfter: true,
	  isBefore: true,
	  isDate: true,
	  isEqual: true,
	  isExists: true,
	  isFirstDayOfMonth: true,
	  isFriday: true,
	  isFuture: true,
	  isLastDayOfMonth: true,
	  isLeapYear: true,
	  isMatch: true,
	  isMonday: true,
	  isPast: true,
	  isSameDay: true,
	  isSameHour: true,
	  isSameISOWeek: true,
	  isSameISOWeekYear: true,
	  isSameMinute: true,
	  isSameMonth: true,
	  isSameQuarter: true,
	  isSameSecond: true,
	  isSameWeek: true,
	  isSameYear: true,
	  isSaturday: true,
	  isSunday: true,
	  isThisHour: true,
	  isThisISOWeek: true,
	  isThisMinute: true,
	  isThisMonth: true,
	  isThisQuarter: true,
	  isThisSecond: true,
	  isThisWeek: true,
	  isThisYear: true,
	  isThursday: true,
	  isToday: true,
	  isTomorrow: true,
	  isTuesday: true,
	  isValid: true,
	  isWednesday: true,
	  isWeekend: true,
	  isWithinInterval: true,
	  isYesterday: true,
	  lastDayOfDecade: true,
	  lastDayOfISOWeek: true,
	  lastDayOfISOWeekYear: true,
	  lastDayOfMonth: true,
	  lastDayOfQuarter: true,
	  lastDayOfWeek: true,
	  lastDayOfYear: true,
	  lightFormat: true,
	  max: true,
	  milliseconds: true,
	  millisecondsToHours: true,
	  millisecondsToMinutes: true,
	  millisecondsToSeconds: true,
	  min: true,
	  minutesToHours: true,
	  minutesToMilliseconds: true,
	  minutesToSeconds: true,
	  monthsToQuarters: true,
	  monthsToYears: true,
	  nextDay: true,
	  nextFriday: true,
	  nextMonday: true,
	  nextSaturday: true,
	  nextSunday: true,
	  nextThursday: true,
	  nextTuesday: true,
	  nextWednesday: true,
	  parse: true,
	  parseISO: true,
	  parseJSON: true,
	  previousDay: true,
	  previousFriday: true,
	  previousMonday: true,
	  previousSaturday: true,
	  previousSunday: true,
	  previousThursday: true,
	  previousTuesday: true,
	  previousWednesday: true,
	  quartersToMonths: true,
	  quartersToYears: true,
	  roundToNearestMinutes: true,
	  secondsToHours: true,
	  secondsToMilliseconds: true,
	  secondsToMinutes: true,
	  set: true,
	  setDate: true,
	  setDay: true,
	  setDayOfYear: true,
	  setHours: true,
	  setISODay: true,
	  setISOWeek: true,
	  setISOWeekYear: true,
	  setMilliseconds: true,
	  setMinutes: true,
	  setMonth: true,
	  setQuarter: true,
	  setSeconds: true,
	  setWeek: true,
	  setWeekYear: true,
	  setYear: true,
	  startOfDay: true,
	  startOfDecade: true,
	  startOfHour: true,
	  startOfISOWeek: true,
	  startOfISOWeekYear: true,
	  startOfMinute: true,
	  startOfMonth: true,
	  startOfQuarter: true,
	  startOfSecond: true,
	  startOfToday: true,
	  startOfTomorrow: true,
	  startOfWeek: true,
	  startOfWeekYear: true,
	  startOfYear: true,
	  startOfYesterday: true,
	  sub: true,
	  subBusinessDays: true,
	  subDays: true,
	  subHours: true,
	  subISOWeekYears: true,
	  subMilliseconds: true,
	  subMinutes: true,
	  subMonths: true,
	  subQuarters: true,
	  subSeconds: true,
	  subWeeks: true,
	  subYears: true,
	  toDate: true,
	  weeksToDays: true,
	  yearsToMonths: true,
	  yearsToQuarters: true
	};
	Object.defineProperty(exports, "add", {
	  enumerable: true,
	  get: function () {
	    return _index.default;
	  }
	});
	Object.defineProperty(exports, "addBusinessDays", {
	  enumerable: true,
	  get: function () {
	    return _index2.default;
	  }
	});
	Object.defineProperty(exports, "addDays", {
	  enumerable: true,
	  get: function () {
	    return _index3.default;
	  }
	});
	Object.defineProperty(exports, "addHours", {
	  enumerable: true,
	  get: function () {
	    return _index4.default;
	  }
	});
	Object.defineProperty(exports, "addISOWeekYears", {
	  enumerable: true,
	  get: function () {
	    return _index5.default;
	  }
	});
	Object.defineProperty(exports, "addMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index6.default;
	  }
	});
	Object.defineProperty(exports, "addMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index7.default;
	  }
	});
	Object.defineProperty(exports, "addMonths", {
	  enumerable: true,
	  get: function () {
	    return _index8.default;
	  }
	});
	Object.defineProperty(exports, "addQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index9.default;
	  }
	});
	Object.defineProperty(exports, "addSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index10.default;
	  }
	});
	Object.defineProperty(exports, "addWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index11.default;
	  }
	});
	Object.defineProperty(exports, "addYears", {
	  enumerable: true,
	  get: function () {
	    return _index12.default;
	  }
	});
	Object.defineProperty(exports, "areIntervalsOverlapping", {
	  enumerable: true,
	  get: function () {
	    return _index13.default;
	  }
	});
	Object.defineProperty(exports, "clamp", {
	  enumerable: true,
	  get: function () {
	    return _index14.default;
	  }
	});
	Object.defineProperty(exports, "closestIndexTo", {
	  enumerable: true,
	  get: function () {
	    return _index15.default;
	  }
	});
	Object.defineProperty(exports, "closestTo", {
	  enumerable: true,
	  get: function () {
	    return _index16.default;
	  }
	});
	Object.defineProperty(exports, "compareAsc", {
	  enumerable: true,
	  get: function () {
	    return _index17.default;
	  }
	});
	Object.defineProperty(exports, "compareDesc", {
	  enumerable: true,
	  get: function () {
	    return _index18.default;
	  }
	});
	Object.defineProperty(exports, "daysToWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index19.default;
	  }
	});
	Object.defineProperty(exports, "differenceInBusinessDays", {
	  enumerable: true,
	  get: function () {
	    return _index20.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarDays", {
	  enumerable: true,
	  get: function () {
	    return _index21.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarISOWeekYears", {
	  enumerable: true,
	  get: function () {
	    return _index22.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarISOWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index23.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarMonths", {
	  enumerable: true,
	  get: function () {
	    return _index24.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index25.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index26.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarYears", {
	  enumerable: true,
	  get: function () {
	    return _index27.default;
	  }
	});
	Object.defineProperty(exports, "differenceInDays", {
	  enumerable: true,
	  get: function () {
	    return _index28.default;
	  }
	});
	Object.defineProperty(exports, "differenceInHours", {
	  enumerable: true,
	  get: function () {
	    return _index29.default;
	  }
	});
	Object.defineProperty(exports, "differenceInISOWeekYears", {
	  enumerable: true,
	  get: function () {
	    return _index30.default;
	  }
	});
	Object.defineProperty(exports, "differenceInMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index31.default;
	  }
	});
	Object.defineProperty(exports, "differenceInMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index32.default;
	  }
	});
	Object.defineProperty(exports, "differenceInMonths", {
	  enumerable: true,
	  get: function () {
	    return _index33.default;
	  }
	});
	Object.defineProperty(exports, "differenceInQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index34.default;
	  }
	});
	Object.defineProperty(exports, "differenceInSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index35.default;
	  }
	});
	Object.defineProperty(exports, "differenceInWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index36.default;
	  }
	});
	Object.defineProperty(exports, "differenceInYears", {
	  enumerable: true,
	  get: function () {
	    return _index37.default;
	  }
	});
	Object.defineProperty(exports, "eachDayOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index38.default;
	  }
	});
	Object.defineProperty(exports, "eachHourOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index39.default;
	  }
	});
	Object.defineProperty(exports, "eachMinuteOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index40.default;
	  }
	});
	Object.defineProperty(exports, "eachMonthOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index41.default;
	  }
	});
	Object.defineProperty(exports, "eachQuarterOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index42.default;
	  }
	});
	Object.defineProperty(exports, "eachWeekOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index43.default;
	  }
	});
	Object.defineProperty(exports, "eachWeekendOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index44.default;
	  }
	});
	Object.defineProperty(exports, "eachWeekendOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index45.default;
	  }
	});
	Object.defineProperty(exports, "eachWeekendOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index46.default;
	  }
	});
	Object.defineProperty(exports, "eachYearOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index47.default;
	  }
	});
	Object.defineProperty(exports, "endOfDay", {
	  enumerable: true,
	  get: function () {
	    return _index48.default;
	  }
	});
	Object.defineProperty(exports, "endOfDecade", {
	  enumerable: true,
	  get: function () {
	    return _index49.default;
	  }
	});
	Object.defineProperty(exports, "endOfHour", {
	  enumerable: true,
	  get: function () {
	    return _index50.default;
	  }
	});
	Object.defineProperty(exports, "endOfISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index51.default;
	  }
	});
	Object.defineProperty(exports, "endOfISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index52.default;
	  }
	});
	Object.defineProperty(exports, "endOfMinute", {
	  enumerable: true,
	  get: function () {
	    return _index53.default;
	  }
	});
	Object.defineProperty(exports, "endOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index54.default;
	  }
	});
	Object.defineProperty(exports, "endOfQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index55.default;
	  }
	});
	Object.defineProperty(exports, "endOfSecond", {
	  enumerable: true,
	  get: function () {
	    return _index56.default;
	  }
	});
	Object.defineProperty(exports, "endOfToday", {
	  enumerable: true,
	  get: function () {
	    return _index57.default;
	  }
	});
	Object.defineProperty(exports, "endOfTomorrow", {
	  enumerable: true,
	  get: function () {
	    return _index58.default;
	  }
	});
	Object.defineProperty(exports, "endOfWeek", {
	  enumerable: true,
	  get: function () {
	    return _index59.default;
	  }
	});
	Object.defineProperty(exports, "endOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index60.default;
	  }
	});
	Object.defineProperty(exports, "endOfYesterday", {
	  enumerable: true,
	  get: function () {
	    return _index61.default;
	  }
	});
	Object.defineProperty(exports, "format", {
	  enumerable: true,
	  get: function () {
	    return _index62.default;
	  }
	});
	Object.defineProperty(exports, "formatDistance", {
	  enumerable: true,
	  get: function () {
	    return _index63.default;
	  }
	});
	Object.defineProperty(exports, "formatDistanceStrict", {
	  enumerable: true,
	  get: function () {
	    return _index64.default;
	  }
	});
	Object.defineProperty(exports, "formatDistanceToNow", {
	  enumerable: true,
	  get: function () {
	    return _index65.default;
	  }
	});
	Object.defineProperty(exports, "formatDistanceToNowStrict", {
	  enumerable: true,
	  get: function () {
	    return _index66.default;
	  }
	});
	Object.defineProperty(exports, "formatDuration", {
	  enumerable: true,
	  get: function () {
	    return _index67.default;
	  }
	});
	Object.defineProperty(exports, "formatISO", {
	  enumerable: true,
	  get: function () {
	    return _index68.default;
	  }
	});
	Object.defineProperty(exports, "formatISO9075", {
	  enumerable: true,
	  get: function () {
	    return _index69.default;
	  }
	});
	Object.defineProperty(exports, "formatISODuration", {
	  enumerable: true,
	  get: function () {
	    return _index70.default;
	  }
	});
	Object.defineProperty(exports, "formatRFC3339", {
	  enumerable: true,
	  get: function () {
	    return _index71.default;
	  }
	});
	Object.defineProperty(exports, "formatRFC7231", {
	  enumerable: true,
	  get: function () {
	    return _index72.default;
	  }
	});
	Object.defineProperty(exports, "formatRelative", {
	  enumerable: true,
	  get: function () {
	    return _index73.default;
	  }
	});
	Object.defineProperty(exports, "fromUnixTime", {
	  enumerable: true,
	  get: function () {
	    return _index74.default;
	  }
	});
	Object.defineProperty(exports, "getDate", {
	  enumerable: true,
	  get: function () {
	    return _index75.default;
	  }
	});
	Object.defineProperty(exports, "getDay", {
	  enumerable: true,
	  get: function () {
	    return _index76.default;
	  }
	});
	Object.defineProperty(exports, "getDayOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index77.default;
	  }
	});
	Object.defineProperty(exports, "getDaysInMonth", {
	  enumerable: true,
	  get: function () {
	    return _index78.default;
	  }
	});
	Object.defineProperty(exports, "getDaysInYear", {
	  enumerable: true,
	  get: function () {
	    return _index79.default;
	  }
	});
	Object.defineProperty(exports, "getDecade", {
	  enumerable: true,
	  get: function () {
	    return _index80.default;
	  }
	});
	Object.defineProperty(exports, "getHours", {
	  enumerable: true,
	  get: function () {
	    return _index81.default;
	  }
	});
	Object.defineProperty(exports, "getISODay", {
	  enumerable: true,
	  get: function () {
	    return _index82.default;
	  }
	});
	Object.defineProperty(exports, "getISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index83.default;
	  }
	});
	Object.defineProperty(exports, "getISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index84.default;
	  }
	});
	Object.defineProperty(exports, "getISOWeeksInYear", {
	  enumerable: true,
	  get: function () {
	    return _index85.default;
	  }
	});
	Object.defineProperty(exports, "getMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index86.default;
	  }
	});
	Object.defineProperty(exports, "getMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index87.default;
	  }
	});
	Object.defineProperty(exports, "getMonth", {
	  enumerable: true,
	  get: function () {
	    return _index88.default;
	  }
	});
	Object.defineProperty(exports, "getOverlappingDaysInIntervals", {
	  enumerable: true,
	  get: function () {
	    return _index89.default;
	  }
	});
	Object.defineProperty(exports, "getQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index90.default;
	  }
	});
	Object.defineProperty(exports, "getSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index91.default;
	  }
	});
	Object.defineProperty(exports, "getTime", {
	  enumerable: true,
	  get: function () {
	    return _index92.default;
	  }
	});
	Object.defineProperty(exports, "getUnixTime", {
	  enumerable: true,
	  get: function () {
	    return _index93.default;
	  }
	});
	Object.defineProperty(exports, "getWeek", {
	  enumerable: true,
	  get: function () {
	    return _index94.default;
	  }
	});
	Object.defineProperty(exports, "getWeekOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index95.default;
	  }
	});
	Object.defineProperty(exports, "getWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index96.default;
	  }
	});
	Object.defineProperty(exports, "getWeeksInMonth", {
	  enumerable: true,
	  get: function () {
	    return _index97.default;
	  }
	});
	Object.defineProperty(exports, "getYear", {
	  enumerable: true,
	  get: function () {
	    return _index98.default;
	  }
	});
	Object.defineProperty(exports, "hoursToMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index99.default;
	  }
	});
	Object.defineProperty(exports, "hoursToMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index100.default;
	  }
	});
	Object.defineProperty(exports, "hoursToSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index101.default;
	  }
	});
	Object.defineProperty(exports, "intervalToDuration", {
	  enumerable: true,
	  get: function () {
	    return _index102.default;
	  }
	});
	Object.defineProperty(exports, "intlFormat", {
	  enumerable: true,
	  get: function () {
	    return _index103.default;
	  }
	});
	Object.defineProperty(exports, "isAfter", {
	  enumerable: true,
	  get: function () {
	    return _index104.default;
	  }
	});
	Object.defineProperty(exports, "isBefore", {
	  enumerable: true,
	  get: function () {
	    return _index105.default;
	  }
	});
	Object.defineProperty(exports, "isDate", {
	  enumerable: true,
	  get: function () {
	    return _index106.default;
	  }
	});
	Object.defineProperty(exports, "isEqual", {
	  enumerable: true,
	  get: function () {
	    return _index107.default;
	  }
	});
	Object.defineProperty(exports, "isExists", {
	  enumerable: true,
	  get: function () {
	    return _index108.default;
	  }
	});
	Object.defineProperty(exports, "isFirstDayOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index109.default;
	  }
	});
	Object.defineProperty(exports, "isFriday", {
	  enumerable: true,
	  get: function () {
	    return _index110.default;
	  }
	});
	Object.defineProperty(exports, "isFuture", {
	  enumerable: true,
	  get: function () {
	    return _index111.default;
	  }
	});
	Object.defineProperty(exports, "isLastDayOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index112.default;
	  }
	});
	Object.defineProperty(exports, "isLeapYear", {
	  enumerable: true,
	  get: function () {
	    return _index113.default;
	  }
	});
	Object.defineProperty(exports, "isMatch", {
	  enumerable: true,
	  get: function () {
	    return _index114.default;
	  }
	});
	Object.defineProperty(exports, "isMonday", {
	  enumerable: true,
	  get: function () {
	    return _index115.default;
	  }
	});
	Object.defineProperty(exports, "isPast", {
	  enumerable: true,
	  get: function () {
	    return _index116.default;
	  }
	});
	Object.defineProperty(exports, "isSameDay", {
	  enumerable: true,
	  get: function () {
	    return _index117.default;
	  }
	});
	Object.defineProperty(exports, "isSameHour", {
	  enumerable: true,
	  get: function () {
	    return _index118.default;
	  }
	});
	Object.defineProperty(exports, "isSameISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index119.default;
	  }
	});
	Object.defineProperty(exports, "isSameISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index120.default;
	  }
	});
	Object.defineProperty(exports, "isSameMinute", {
	  enumerable: true,
	  get: function () {
	    return _index121.default;
	  }
	});
	Object.defineProperty(exports, "isSameMonth", {
	  enumerable: true,
	  get: function () {
	    return _index122.default;
	  }
	});
	Object.defineProperty(exports, "isSameQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index123.default;
	  }
	});
	Object.defineProperty(exports, "isSameSecond", {
	  enumerable: true,
	  get: function () {
	    return _index124.default;
	  }
	});
	Object.defineProperty(exports, "isSameWeek", {
	  enumerable: true,
	  get: function () {
	    return _index125.default;
	  }
	});
	Object.defineProperty(exports, "isSameYear", {
	  enumerable: true,
	  get: function () {
	    return _index126.default;
	  }
	});
	Object.defineProperty(exports, "isSaturday", {
	  enumerable: true,
	  get: function () {
	    return _index127.default;
	  }
	});
	Object.defineProperty(exports, "isSunday", {
	  enumerable: true,
	  get: function () {
	    return _index128.default;
	  }
	});
	Object.defineProperty(exports, "isThisHour", {
	  enumerable: true,
	  get: function () {
	    return _index129.default;
	  }
	});
	Object.defineProperty(exports, "isThisISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index130.default;
	  }
	});
	Object.defineProperty(exports, "isThisMinute", {
	  enumerable: true,
	  get: function () {
	    return _index131.default;
	  }
	});
	Object.defineProperty(exports, "isThisMonth", {
	  enumerable: true,
	  get: function () {
	    return _index132.default;
	  }
	});
	Object.defineProperty(exports, "isThisQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index133.default;
	  }
	});
	Object.defineProperty(exports, "isThisSecond", {
	  enumerable: true,
	  get: function () {
	    return _index134.default;
	  }
	});
	Object.defineProperty(exports, "isThisWeek", {
	  enumerable: true,
	  get: function () {
	    return _index135.default;
	  }
	});
	Object.defineProperty(exports, "isThisYear", {
	  enumerable: true,
	  get: function () {
	    return _index136.default;
	  }
	});
	Object.defineProperty(exports, "isThursday", {
	  enumerable: true,
	  get: function () {
	    return _index137.default;
	  }
	});
	Object.defineProperty(exports, "isToday", {
	  enumerable: true,
	  get: function () {
	    return _index138.default;
	  }
	});
	Object.defineProperty(exports, "isTomorrow", {
	  enumerable: true,
	  get: function () {
	    return _index139.default;
	  }
	});
	Object.defineProperty(exports, "isTuesday", {
	  enumerable: true,
	  get: function () {
	    return _index140.default;
	  }
	});
	Object.defineProperty(exports, "isValid", {
	  enumerable: true,
	  get: function () {
	    return _index141.default;
	  }
	});
	Object.defineProperty(exports, "isWednesday", {
	  enumerable: true,
	  get: function () {
	    return _index142.default;
	  }
	});
	Object.defineProperty(exports, "isWeekend", {
	  enumerable: true,
	  get: function () {
	    return _index143.default;
	  }
	});
	Object.defineProperty(exports, "isWithinInterval", {
	  enumerable: true,
	  get: function () {
	    return _index144.default;
	  }
	});
	Object.defineProperty(exports, "isYesterday", {
	  enumerable: true,
	  get: function () {
	    return _index145.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfDecade", {
	  enumerable: true,
	  get: function () {
	    return _index146.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index147.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index148.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index149.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index150.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfWeek", {
	  enumerable: true,
	  get: function () {
	    return _index151.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index152.default;
	  }
	});
	Object.defineProperty(exports, "lightFormat", {
	  enumerable: true,
	  get: function () {
	    return _index153.default;
	  }
	});
	Object.defineProperty(exports, "max", {
	  enumerable: true,
	  get: function () {
	    return _index154.default;
	  }
	});
	Object.defineProperty(exports, "milliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index155.default;
	  }
	});
	Object.defineProperty(exports, "millisecondsToHours", {
	  enumerable: true,
	  get: function () {
	    return _index156.default;
	  }
	});
	Object.defineProperty(exports, "millisecondsToMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index157.default;
	  }
	});
	Object.defineProperty(exports, "millisecondsToSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index158.default;
	  }
	});
	Object.defineProperty(exports, "min", {
	  enumerable: true,
	  get: function () {
	    return _index159.default;
	  }
	});
	Object.defineProperty(exports, "minutesToHours", {
	  enumerable: true,
	  get: function () {
	    return _index160.default;
	  }
	});
	Object.defineProperty(exports, "minutesToMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index161.default;
	  }
	});
	Object.defineProperty(exports, "minutesToSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index162.default;
	  }
	});
	Object.defineProperty(exports, "monthsToQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index163.default;
	  }
	});
	Object.defineProperty(exports, "monthsToYears", {
	  enumerable: true,
	  get: function () {
	    return _index164.default;
	  }
	});
	Object.defineProperty(exports, "nextDay", {
	  enumerable: true,
	  get: function () {
	    return _index165.default;
	  }
	});
	Object.defineProperty(exports, "nextFriday", {
	  enumerable: true,
	  get: function () {
	    return _index166.default;
	  }
	});
	Object.defineProperty(exports, "nextMonday", {
	  enumerable: true,
	  get: function () {
	    return _index167.default;
	  }
	});
	Object.defineProperty(exports, "nextSaturday", {
	  enumerable: true,
	  get: function () {
	    return _index168.default;
	  }
	});
	Object.defineProperty(exports, "nextSunday", {
	  enumerable: true,
	  get: function () {
	    return _index169.default;
	  }
	});
	Object.defineProperty(exports, "nextThursday", {
	  enumerable: true,
	  get: function () {
	    return _index170.default;
	  }
	});
	Object.defineProperty(exports, "nextTuesday", {
	  enumerable: true,
	  get: function () {
	    return _index171.default;
	  }
	});
	Object.defineProperty(exports, "nextWednesday", {
	  enumerable: true,
	  get: function () {
	    return _index172.default;
	  }
	});
	Object.defineProperty(exports, "parse", {
	  enumerable: true,
	  get: function () {
	    return _index173.default;
	  }
	});
	Object.defineProperty(exports, "parseISO", {
	  enumerable: true,
	  get: function () {
	    return _index174.default;
	  }
	});
	Object.defineProperty(exports, "parseJSON", {
	  enumerable: true,
	  get: function () {
	    return _index175.default;
	  }
	});
	Object.defineProperty(exports, "previousDay", {
	  enumerable: true,
	  get: function () {
	    return _index176.default;
	  }
	});
	Object.defineProperty(exports, "previousFriday", {
	  enumerable: true,
	  get: function () {
	    return _index177.default;
	  }
	});
	Object.defineProperty(exports, "previousMonday", {
	  enumerable: true,
	  get: function () {
	    return _index178.default;
	  }
	});
	Object.defineProperty(exports, "previousSaturday", {
	  enumerable: true,
	  get: function () {
	    return _index179.default;
	  }
	});
	Object.defineProperty(exports, "previousSunday", {
	  enumerable: true,
	  get: function () {
	    return _index180.default;
	  }
	});
	Object.defineProperty(exports, "previousThursday", {
	  enumerable: true,
	  get: function () {
	    return _index181.default;
	  }
	});
	Object.defineProperty(exports, "previousTuesday", {
	  enumerable: true,
	  get: function () {
	    return _index182.default;
	  }
	});
	Object.defineProperty(exports, "previousWednesday", {
	  enumerable: true,
	  get: function () {
	    return _index183.default;
	  }
	});
	Object.defineProperty(exports, "quartersToMonths", {
	  enumerable: true,
	  get: function () {
	    return _index184.default;
	  }
	});
	Object.defineProperty(exports, "quartersToYears", {
	  enumerable: true,
	  get: function () {
	    return _index185.default;
	  }
	});
	Object.defineProperty(exports, "roundToNearestMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index186.default;
	  }
	});
	Object.defineProperty(exports, "secondsToHours", {
	  enumerable: true,
	  get: function () {
	    return _index187.default;
	  }
	});
	Object.defineProperty(exports, "secondsToMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index188.default;
	  }
	});
	Object.defineProperty(exports, "secondsToMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index189.default;
	  }
	});
	Object.defineProperty(exports, "set", {
	  enumerable: true,
	  get: function () {
	    return _index190.default;
	  }
	});
	Object.defineProperty(exports, "setDate", {
	  enumerable: true,
	  get: function () {
	    return _index191.default;
	  }
	});
	Object.defineProperty(exports, "setDay", {
	  enumerable: true,
	  get: function () {
	    return _index192.default;
	  }
	});
	Object.defineProperty(exports, "setDayOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index193.default;
	  }
	});
	Object.defineProperty(exports, "setHours", {
	  enumerable: true,
	  get: function () {
	    return _index194.default;
	  }
	});
	Object.defineProperty(exports, "setISODay", {
	  enumerable: true,
	  get: function () {
	    return _index195.default;
	  }
	});
	Object.defineProperty(exports, "setISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index196.default;
	  }
	});
	Object.defineProperty(exports, "setISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index197.default;
	  }
	});
	Object.defineProperty(exports, "setMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index198.default;
	  }
	});
	Object.defineProperty(exports, "setMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index199.default;
	  }
	});
	Object.defineProperty(exports, "setMonth", {
	  enumerable: true,
	  get: function () {
	    return _index200.default;
	  }
	});
	Object.defineProperty(exports, "setQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index201.default;
	  }
	});
	Object.defineProperty(exports, "setSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index202.default;
	  }
	});
	Object.defineProperty(exports, "setWeek", {
	  enumerable: true,
	  get: function () {
	    return _index203.default;
	  }
	});
	Object.defineProperty(exports, "setWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index204.default;
	  }
	});
	Object.defineProperty(exports, "setYear", {
	  enumerable: true,
	  get: function () {
	    return _index205.default;
	  }
	});
	Object.defineProperty(exports, "startOfDay", {
	  enumerable: true,
	  get: function () {
	    return _index206.default;
	  }
	});
	Object.defineProperty(exports, "startOfDecade", {
	  enumerable: true,
	  get: function () {
	    return _index207.default;
	  }
	});
	Object.defineProperty(exports, "startOfHour", {
	  enumerable: true,
	  get: function () {
	    return _index208.default;
	  }
	});
	Object.defineProperty(exports, "startOfISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index209.default;
	  }
	});
	Object.defineProperty(exports, "startOfISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index210.default;
	  }
	});
	Object.defineProperty(exports, "startOfMinute", {
	  enumerable: true,
	  get: function () {
	    return _index211.default;
	  }
	});
	Object.defineProperty(exports, "startOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index212.default;
	  }
	});
	Object.defineProperty(exports, "startOfQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index213.default;
	  }
	});
	Object.defineProperty(exports, "startOfSecond", {
	  enumerable: true,
	  get: function () {
	    return _index214.default;
	  }
	});
	Object.defineProperty(exports, "startOfToday", {
	  enumerable: true,
	  get: function () {
	    return _index215.default;
	  }
	});
	Object.defineProperty(exports, "startOfTomorrow", {
	  enumerable: true,
	  get: function () {
	    return _index216.default;
	  }
	});
	Object.defineProperty(exports, "startOfWeek", {
	  enumerable: true,
	  get: function () {
	    return _index217.default;
	  }
	});
	Object.defineProperty(exports, "startOfWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index218.default;
	  }
	});
	Object.defineProperty(exports, "startOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index219.default;
	  }
	});
	Object.defineProperty(exports, "startOfYesterday", {
	  enumerable: true,
	  get: function () {
	    return _index220.default;
	  }
	});
	Object.defineProperty(exports, "sub", {
	  enumerable: true,
	  get: function () {
	    return _index221.default;
	  }
	});
	Object.defineProperty(exports, "subBusinessDays", {
	  enumerable: true,
	  get: function () {
	    return _index222.default;
	  }
	});
	Object.defineProperty(exports, "subDays", {
	  enumerable: true,
	  get: function () {
	    return _index223.default;
	  }
	});
	Object.defineProperty(exports, "subHours", {
	  enumerable: true,
	  get: function () {
	    return _index224.default;
	  }
	});
	Object.defineProperty(exports, "subISOWeekYears", {
	  enumerable: true,
	  get: function () {
	    return _index225.default;
	  }
	});
	Object.defineProperty(exports, "subMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index226.default;
	  }
	});
	Object.defineProperty(exports, "subMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index227.default;
	  }
	});
	Object.defineProperty(exports, "subMonths", {
	  enumerable: true,
	  get: function () {
	    return _index228.default;
	  }
	});
	Object.defineProperty(exports, "subQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index229.default;
	  }
	});
	Object.defineProperty(exports, "subSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index230.default;
	  }
	});
	Object.defineProperty(exports, "subWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index231.default;
	  }
	});
	Object.defineProperty(exports, "subYears", {
	  enumerable: true,
	  get: function () {
	    return _index232.default;
	  }
	});
	Object.defineProperty(exports, "toDate", {
	  enumerable: true,
	  get: function () {
	    return _index233.default;
	  }
	});
	Object.defineProperty(exports, "weeksToDays", {
	  enumerable: true,
	  get: function () {
	    return _index234.default;
	  }
	});
	Object.defineProperty(exports, "yearsToMonths", {
	  enumerable: true,
	  get: function () {
	    return _index235.default;
	  }
	});
	Object.defineProperty(exports, "yearsToQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index236.default;
	  }
	});
	
	var _index = _interopRequireDefault(__webpack_require__(873));
	
	var _index2 = _interopRequireDefault(__webpack_require__(285));
	
	var _index3 = _interopRequireDefault(__webpack_require__(58));
	
	var _index4 = _interopRequireDefault(__webpack_require__(200));
	
	var _index5 = _interopRequireDefault(__webpack_require__(286));
	
	var _index6 = _interopRequireDefault(__webpack_require__(110));
	
	var _index7 = _interopRequireDefault(__webpack_require__(201));
	
	var _index8 = _interopRequireDefault(__webpack_require__(111));
	
	var _index9 = _interopRequireDefault(__webpack_require__(202));
	
	var _index10 = _interopRequireDefault(__webpack_require__(287));
	
	var _index11 = _interopRequireDefault(__webpack_require__(134));
	
	var _index12 = _interopRequireDefault(__webpack_require__(288));
	
	var _index13 = _interopRequireDefault(__webpack_require__(874));
	
	var _index14 = _interopRequireDefault(__webpack_require__(875));
	
	var _index15 = _interopRequireDefault(__webpack_require__(876));
	
	var _index16 = _interopRequireDefault(__webpack_require__(877));
	
	var _index17 = _interopRequireDefault(__webpack_require__(75));
	
	var _index18 = _interopRequireDefault(__webpack_require__(878));
	
	var _index19 = _interopRequireDefault(__webpack_require__(879));
	
	var _index20 = _interopRequireDefault(__webpack_require__(880));
	
	var _index21 = _interopRequireDefault(__webpack_require__(76));
	
	var _index22 = _interopRequireDefault(__webpack_require__(289));
	
	var _index23 = _interopRequireDefault(__webpack_require__(881));
	
	var _index24 = _interopRequireDefault(__webpack_require__(290));
	
	var _index25 = _interopRequireDefault(__webpack_require__(882));
	
	var _index26 = _interopRequireDefault(__webpack_require__(291));
	
	var _index27 = _interopRequireDefault(__webpack_require__(292));
	
	var _index28 = _interopRequireDefault(__webpack_require__(203));
	
	var _index29 = _interopRequireDefault(__webpack_require__(293));
	
	var _index30 = _interopRequireDefault(__webpack_require__(883));
	
	var _index31 = _interopRequireDefault(__webpack_require__(135));
	
	var _index32 = _interopRequireDefault(__webpack_require__(294));
	
	var _index33 = _interopRequireDefault(__webpack_require__(136));
	
	var _index34 = _interopRequireDefault(__webpack_require__(884));
	
	var _index35 = _interopRequireDefault(__webpack_require__(204));
	
	var _index36 = _interopRequireDefault(__webpack_require__(885));
	
	var _index37 = _interopRequireDefault(__webpack_require__(295));
	
	var _index38 = _interopRequireDefault(__webpack_require__(296));
	
	var _index39 = _interopRequireDefault(__webpack_require__(886));
	
	var _index40 = _interopRequireDefault(__webpack_require__(887));
	
	var _index41 = _interopRequireDefault(__webpack_require__(888));
	
	var _index42 = _interopRequireDefault(__webpack_require__(889));
	
	var _index43 = _interopRequireDefault(__webpack_require__(890));
	
	var _index44 = _interopRequireDefault(__webpack_require__(205));
	
	var _index45 = _interopRequireDefault(__webpack_require__(891));
	
	var _index46 = _interopRequireDefault(__webpack_require__(892));
	
	var _index47 = _interopRequireDefault(__webpack_require__(893));
	
	var _index48 = _interopRequireDefault(__webpack_require__(206));
	
	var _index49 = _interopRequireDefault(__webpack_require__(894));
	
	var _index50 = _interopRequireDefault(__webpack_require__(895));
	
	var _index51 = _interopRequireDefault(__webpack_require__(897));
	
	var _index52 = _interopRequireDefault(__webpack_require__(896));
	
	var _index53 = _interopRequireDefault(__webpack_require__(898));
	
	var _index54 = _interopRequireDefault(__webpack_require__(207));
	
	var _index55 = _interopRequireDefault(__webpack_require__(899));
	
	var _index56 = _interopRequireDefault(__webpack_require__(900));
	
	var _index57 = _interopRequireDefault(__webpack_require__(901));
	
	var _index58 = _interopRequireDefault(__webpack_require__(902));
	
	var _index59 = _interopRequireDefault(__webpack_require__(297));
	
	var _index60 = _interopRequireDefault(__webpack_require__(298));
	
	var _index61 = _interopRequireDefault(__webpack_require__(903));
	
	var _index62 = _interopRequireDefault(__webpack_require__(301));
	
	var _index63 = _interopRequireDefault(__webpack_require__(300));
	
	var _index64 = _interopRequireDefault(__webpack_require__(299));
	
	var _index65 = _interopRequireDefault(__webpack_require__(905));
	
	var _index66 = _interopRequireDefault(__webpack_require__(904));
	
	var _index67 = _interopRequireDefault(__webpack_require__(906));
	
	var _index68 = _interopRequireDefault(__webpack_require__(909));
	
	var _index69 = _interopRequireDefault(__webpack_require__(907));
	
	var _index70 = _interopRequireDefault(__webpack_require__(908));
	
	var _index71 = _interopRequireDefault(__webpack_require__(910));
	
	var _index72 = _interopRequireDefault(__webpack_require__(911));
	
	var _index73 = _interopRequireDefault(__webpack_require__(912));
	
	var _index74 = _interopRequireDefault(__webpack_require__(913));
	
	var _index75 = _interopRequireDefault(__webpack_require__(302));
	
	var _index76 = _interopRequireDefault(__webpack_require__(137));
	
	var _index77 = _interopRequireDefault(__webpack_require__(914));
	
	var _index78 = _interopRequireDefault(__webpack_require__(303));
	
	var _index79 = _interopRequireDefault(__webpack_require__(915));
	
	var _index80 = _interopRequireDefault(__webpack_require__(916));
	
	var _index81 = _interopRequireDefault(__webpack_require__(917));
	
	var _index82 = _interopRequireDefault(__webpack_require__(304));
	
	var _index83 = _interopRequireDefault(__webpack_require__(305));
	
	var _index84 = _interopRequireDefault(__webpack_require__(91));
	
	var _index85 = _interopRequireDefault(__webpack_require__(918));
	
	var _index86 = _interopRequireDefault(__webpack_require__(919));
	
	var _index87 = _interopRequireDefault(__webpack_require__(920));
	
	var _index88 = _interopRequireDefault(__webpack_require__(921));
	
	var _index89 = _interopRequireDefault(__webpack_require__(922));
	
	var _index90 = _interopRequireDefault(__webpack_require__(306));
	
	var _index91 = _interopRequireDefault(__webpack_require__(923));
	
	var _index92 = _interopRequireDefault(__webpack_require__(307));
	
	var _index93 = _interopRequireDefault(__webpack_require__(924));
	
	var _index94 = _interopRequireDefault(__webpack_require__(309));
	
	var _index95 = _interopRequireDefault(__webpack_require__(925));
	
	var _index96 = _interopRequireDefault(__webpack_require__(308));
	
	var _index97 = _interopRequireDefault(__webpack_require__(926));
	
	var _index98 = _interopRequireDefault(__webpack_require__(927));
	
	var _index99 = _interopRequireDefault(__webpack_require__(928));
	
	var _index100 = _interopRequireDefault(__webpack_require__(929));
	
	var _index101 = _interopRequireDefault(__webpack_require__(930));
	
	var _index102 = _interopRequireDefault(__webpack_require__(931));
	
	var _index103 = _interopRequireDefault(__webpack_require__(932));
	
	var _index104 = _interopRequireDefault(__webpack_require__(933));
	
	var _index105 = _interopRequireDefault(__webpack_require__(934));
	
	var _index106 = _interopRequireDefault(__webpack_require__(310));
	
	var _index107 = _interopRequireDefault(__webpack_require__(935));
	
	var _index108 = _interopRequireDefault(__webpack_require__(936));
	
	var _index109 = _interopRequireDefault(__webpack_require__(937));
	
	var _index110 = _interopRequireDefault(__webpack_require__(938));
	
	var _index111 = _interopRequireDefault(__webpack_require__(939));
	
	var _index112 = _interopRequireDefault(__webpack_require__(311));
	
	var _index113 = _interopRequireDefault(__webpack_require__(312));
	
	var _index114 = _interopRequireDefault(__webpack_require__(940));
	
	var _index115 = _interopRequireDefault(__webpack_require__(941));
	
	var _index116 = _interopRequireDefault(__webpack_require__(942));
	
	var _index117 = _interopRequireDefault(__webpack_require__(112));
	
	var _index118 = _interopRequireDefault(__webpack_require__(313));
	
	var _index119 = _interopRequireDefault(__webpack_require__(314));
	
	var _index120 = _interopRequireDefault(__webpack_require__(943));
	
	var _index121 = _interopRequireDefault(__webpack_require__(315));
	
	var _index122 = _interopRequireDefault(__webpack_require__(316));
	
	var _index123 = _interopRequireDefault(__webpack_require__(317));
	
	var _index124 = _interopRequireDefault(__webpack_require__(318));
	
	var _index125 = _interopRequireDefault(__webpack_require__(209));
	
	var _index126 = _interopRequireDefault(__webpack_require__(319));
	
	var _index127 = _interopRequireDefault(__webpack_require__(320));
	
	var _index128 = _interopRequireDefault(__webpack_require__(210));
	
	var _index129 = _interopRequireDefault(__webpack_require__(944));
	
	var _index130 = _interopRequireDefault(__webpack_require__(945));
	
	var _index131 = _interopRequireDefault(__webpack_require__(946));
	
	var _index132 = _interopRequireDefault(__webpack_require__(947));
	
	var _index133 = _interopRequireDefault(__webpack_require__(948));
	
	var _index134 = _interopRequireDefault(__webpack_require__(949));
	
	var _index135 = _interopRequireDefault(__webpack_require__(950));
	
	var _index136 = _interopRequireDefault(__webpack_require__(951));
	
	var _index137 = _interopRequireDefault(__webpack_require__(952));
	
	var _index138 = _interopRequireDefault(__webpack_require__(953));
	
	var _index139 = _interopRequireDefault(__webpack_require__(954));
	
	var _index140 = _interopRequireDefault(__webpack_require__(955));
	
	var _index141 = _interopRequireDefault(__webpack_require__(51));
	
	var _index142 = _interopRequireDefault(__webpack_require__(956));
	
	var _index143 = _interopRequireDefault(__webpack_require__(138));
	
	var _index144 = _interopRequireDefault(__webpack_require__(957));
	
	var _index145 = _interopRequireDefault(__webpack_require__(958));
	
	var _index146 = _interopRequireDefault(__webpack_require__(959));
	
	var _index147 = _interopRequireDefault(__webpack_require__(961));
	
	var _index148 = _interopRequireDefault(__webpack_require__(960));
	
	var _index149 = _interopRequireDefault(__webpack_require__(321));
	
	var _index150 = _interopRequireDefault(__webpack_require__(962));
	
	var _index151 = _interopRequireDefault(__webpack_require__(322));
	
	var _index152 = _interopRequireDefault(__webpack_require__(963));
	
	var _index153 = _interopRequireDefault(__webpack_require__(964));
	
	var _index154 = _interopRequireDefault(__webpack_require__(333));
	
	var _index155 = _interopRequireDefault(__webpack_require__(1420));
	
	var _index156 = _interopRequireDefault(__webpack_require__(1417));
	
	var _index157 = _interopRequireDefault(__webpack_require__(1418));
	
	var _index158 = _interopRequireDefault(__webpack_require__(1419));
	
	var _index159 = _interopRequireDefault(__webpack_require__(334));
	
	var _index160 = _interopRequireDefault(__webpack_require__(1421));
	
	var _index161 = _interopRequireDefault(__webpack_require__(1422));
	
	var _index162 = _interopRequireDefault(__webpack_require__(1423));
	
	var _index163 = _interopRequireDefault(__webpack_require__(1424));
	
	var _index164 = _interopRequireDefault(__webpack_require__(1425));
	
	var _index165 = _interopRequireDefault(__webpack_require__(64));
	
	var _index166 = _interopRequireDefault(__webpack_require__(1426));
	
	var _index167 = _interopRequireDefault(__webpack_require__(1427));
	
	var _index168 = _interopRequireDefault(__webpack_require__(1428));
	
	var _index169 = _interopRequireDefault(__webpack_require__(1429));
	
	var _index170 = _interopRequireDefault(__webpack_require__(1430));
	
	var _index171 = _interopRequireDefault(__webpack_require__(1431));
	
	var _index172 = _interopRequireDefault(__webpack_require__(1432));
	
	var _index173 = _interopRequireDefault(__webpack_require__(335));
	
	var _index174 = _interopRequireDefault(__webpack_require__(1433));
	
	var _index175 = _interopRequireDefault(__webpack_require__(1434));
	
	var _index176 = _interopRequireDefault(__webpack_require__(65));
	
	var _index177 = _interopRequireDefault(__webpack_require__(1436));
	
	var _index178 = _interopRequireDefault(__webpack_require__(1437));
	
	var _index179 = _interopRequireDefault(__webpack_require__(1438));
	
	var _index180 = _interopRequireDefault(__webpack_require__(1439));
	
	var _index181 = _interopRequireDefault(__webpack_require__(1440));
	
	var _index182 = _interopRequireDefault(__webpack_require__(1441));
	
	var _index183 = _interopRequireDefault(__webpack_require__(1442));
	
	var _index184 = _interopRequireDefault(__webpack_require__(1443));
	
	var _index185 = _interopRequireDefault(__webpack_require__(1444));
	
	var _index186 = _interopRequireDefault(__webpack_require__(1445));
	
	var _index187 = _interopRequireDefault(__webpack_require__(1446));
	
	var _index188 = _interopRequireDefault(__webpack_require__(1447));
	
	var _index189 = _interopRequireDefault(__webpack_require__(1448));
	
	var _index190 = _interopRequireDefault(__webpack_require__(1462));
	
	var _index191 = _interopRequireDefault(__webpack_require__(1449));
	
	var _index192 = _interopRequireDefault(__webpack_require__(1451));
	
	var _index193 = _interopRequireDefault(__webpack_require__(1450));
	
	var _index194 = _interopRequireDefault(__webpack_require__(1452));
	
	var _index195 = _interopRequireDefault(__webpack_require__(1453));
	
	var _index196 = _interopRequireDefault(__webpack_require__(1454));
	
	var _index197 = _interopRequireDefault(__webpack_require__(336));
	
	var _index198 = _interopRequireDefault(__webpack_require__(1455));
	
	var _index199 = _interopRequireDefault(__webpack_require__(1456));
	
	var _index200 = _interopRequireDefault(__webpack_require__(212));
	
	var _index201 = _interopRequireDefault(__webpack_require__(1457));
	
	var _index202 = _interopRequireDefault(__webpack_require__(1458));
	
	var _index203 = _interopRequireDefault(__webpack_require__(1460));
	
	var _index204 = _interopRequireDefault(__webpack_require__(1459));
	
	var _index205 = _interopRequireDefault(__webpack_require__(1461));
	
	var _index206 = _interopRequireDefault(__webpack_require__(139));
	
	var _index207 = _interopRequireDefault(__webpack_require__(1463));
	
	var _index208 = _interopRequireDefault(__webpack_require__(337));
	
	var _index209 = _interopRequireDefault(__webpack_require__(81));
	
	var _index210 = _interopRequireDefault(__webpack_require__(113));
	
	var _index211 = _interopRequireDefault(__webpack_require__(213));
	
	var _index212 = _interopRequireDefault(__webpack_require__(140));
	
	var _index213 = _interopRequireDefault(__webpack_require__(214));
	
	var _index214 = _interopRequireDefault(__webpack_require__(338));
	
	var _index215 = _interopRequireDefault(__webpack_require__(1464));
	
	var _index216 = _interopRequireDefault(__webpack_require__(1465));
	
	var _index217 = _interopRequireDefault(__webpack_require__(66));
	
	var _index218 = _interopRequireDefault(__webpack_require__(215));
	
	var _index219 = _interopRequireDefault(__webpack_require__(216));
	
	var _index220 = _interopRequireDefault(__webpack_require__(1466));
	
	var _index221 = _interopRequireDefault(__webpack_require__(341));
	
	var _index222 = _interopRequireDefault(__webpack_require__(1467));
	
	var _index223 = _interopRequireDefault(__webpack_require__(141));
	
	var _index224 = _interopRequireDefault(__webpack_require__(1468));
	
	var _index225 = _interopRequireDefault(__webpack_require__(339));
	
	var _index226 = _interopRequireDefault(__webpack_require__(114));
	
	var _index227 = _interopRequireDefault(__webpack_require__(1469));
	
	var _index228 = _interopRequireDefault(__webpack_require__(340));
	
	var _index229 = _interopRequireDefault(__webpack_require__(1470));
	
	var _index230 = _interopRequireDefault(__webpack_require__(1471));
	
	var _index231 = _interopRequireDefault(__webpack_require__(1472));
	
	var _index232 = _interopRequireDefault(__webpack_require__(1473));
	
	var _index233 = _interopRequireDefault(__webpack_require__(4));
	
	var _index234 = _interopRequireDefault(__webpack_require__(1474));
	
	var _index235 = _interopRequireDefault(__webpack_require__(1475));
	
	var _index236 = _interopRequireDefault(__webpack_require__(1476));
	
	var _index237 = __webpack_require__(30);
	
	Object.keys(_index237).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _index237[key];
	    }
	  });
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(66));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameWeek
	 * @category Week Helpers
	 * @summary Are the given dates in the same week?
	 *
	 * @description
	 * Are the given dates in the same week?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Boolean} the dates are in the same week
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // Are 31 August 2014 and 4 September 2014 in the same week?
	 * var result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
	 * //=> true
	 *
	 * @example
	 * // If week starts with Monday,
	 * // are 31 August 2014 and 4 September 2014 in the same week?
	 * var result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
	 *   weekStartsOn: 1
	 * })
	 * //=> false
	 */
	function isSameWeek(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfWeek = (0, _index.default)(dirtyDateLeft, dirtyOptions);
	  var dateRightStartOfWeek = (0, _index.default)(dirtyDateRight, dirtyOptions);
	  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSunday;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSunday
	 * @category Weekday Helpers
	 * @summary Is the given date Sunday?
	 *
	 * @description
	 * Is the given date Sunday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 21 September 2014 Sunday?
	 * var result = isSunday(new Date(2014, 8, 21))
	 * //=> true
	 */
	function isSunday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 0;
	}
	
	module.exports = exports.default;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var numberValues = {
	  locale: {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	  },
	  number: {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	  }
	}; // CLDR #1585 - #1592
	
	var eraValues = {
	  narrow: ['ईसा-पूर्व', 'ईस्वी'],
	  abbreviated: ['ईसा-पूर्व', 'ईस्वी'],
	  wide: ['ईसा-पूर्व', 'ईसवी सन']
	}; // CLDR #1593 - #1616
	
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['ति1', 'ति2', 'ति3', 'ति4'],
	  wide: ['पहली तिमाही', 'दूसरी तिमाही', 'तीसरी तिमाही', 'चौथी तिमाही']
	}; // Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	// https://www.unicode.org/cldr/charts/32/summary/hi.html
	// CLDR #1617 - #1688
	
	var monthValues = {
	  narrow: ['ज', 'फ़', 'मा', 'अ', 'मई', 'जू', 'जु', 'अग', 'सि', 'अक्तू', 'न', 'दि'],
	  abbreviated: ['जन', 'फ़र', 'मार्च', 'अप्रैल', 'मई', 'जून', 'जुल', 'अग', 'सित', 'अक्तू', 'नव', 'दिस'],
	  wide: ['जनवरी', 'फ़रवरी', 'मार्च', 'अप्रैल', 'मई', 'जून', 'जुलाई', 'अगस्त', 'सितंबर', 'अक्तूबर', 'नवंबर', 'दिसंबर']
	}; // CLDR #1689 - #1744
	
	var dayValues = {
	  narrow: ['र', 'सो', 'मं', 'बु', 'गु', 'शु', 'श'],
	  short: ['र', 'सो', 'मं', 'बु', 'गु', 'शु', 'श'],
	  abbreviated: ['रवि', 'सोम', 'मंगल', 'बुध', 'गुरु', 'शुक्र', 'शनि'],
	  wide: ['रविवार', 'सोमवार', 'मंगलवार', 'बुधवार', 'गुरुवार', 'शुक्रवार', 'शनिवार']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'पूर्वाह्न',
	    pm: 'अपराह्न',
	    midnight: 'मध्यरात्रि',
	    noon: 'दोपहर',
	    morning: 'सुबह',
	    afternoon: 'दोपहर',
	    evening: 'शाम',
	    night: 'रात'
	  },
	  abbreviated: {
	    am: 'पूर्वाह्न',
	    pm: 'अपराह्न',
	    midnight: 'मध्यरात्रि',
	    noon: 'दोपहर',
	    morning: 'सुबह',
	    afternoon: 'दोपहर',
	    evening: 'शाम',
	    night: 'रात'
	  },
	  wide: {
	    am: 'पूर्वाह्न',
	    pm: 'अपराह्न',
	    midnight: 'मध्यरात्रि',
	    noon: 'दोपहर',
	    morning: 'सुबह',
	    afternoon: 'दोपहर',
	    evening: 'शाम',
	    night: 'रात'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'पूर्वाह्न',
	    pm: 'अपराह्न',
	    midnight: 'मध्यरात्रि',
	    noon: 'दोपहर',
	    morning: 'सुबह',
	    afternoon: 'दोपहर',
	    evening: 'शाम',
	    night: 'रात'
	  },
	  abbreviated: {
	    am: 'पूर्वाह्न',
	    pm: 'अपराह्न',
	    midnight: 'मध्यरात्रि',
	    noon: 'दोपहर',
	    morning: 'सुबह',
	    afternoon: 'दोपहर',
	    evening: 'शाम',
	    night: 'रात'
	  },
	  wide: {
	    am: 'पूर्वाह्न',
	    pm: 'अपराह्न',
	    midnight: 'मध्यरात्रि',
	    noon: 'दोपहर',
	    morning: 'सुबह',
	    afternoon: 'दोपहर',
	    evening: 'शाम',
	    night: 'रात'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = localize.localeToNumber(dirtyNumber);
	  var localeNumber = localize.numberToLocale(number);
	  var rem10 = number % 10;
	
	  switch (rem10) {
	    case 2:
	    case 3:
	    case 4:
	    case 6:
	    case 1:
	    case 5:
	    case 7:
	    case 8:
	    case 9:
	    case 0:
	      return localeNumber;
	  }
	}
	
	function localeToNumber(locale) {
	  var number = locale.toString().replace(/[१२३४५६७८९०]/g, function (match) {
	    return numberValues.number[match];
	  });
	  return Number(number);
	}
	
	function numberToLocale(number) {
	  return number.toString().replace(/\d/g, function (match) {
	    return numberValues.locale[match];
	  });
	}
	
	var localize = {
	  localeToNumber: localeToNumber,
	  numberToLocale: numberToLocale,
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(303));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setMonth
	 * @category Month Helpers
	 * @summary Set the month to the given date.
	 *
	 * @description
	 * Set the month to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} month - the month of the new date
	 * @returns {Date} the new date with the month set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set February to 1 September 2014:
	 * const result = setMonth(new Date(2014, 8, 1), 1)
	 * //=> Sat Feb 01 2014 00:00:00
	 */
	function setMonth(dirtyDate, dirtyMonth) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var month = (0, _index.default)(dirtyMonth);
	  var year = date.getFullYear();
	  var day = date.getDate();
	  var dateWithDesiredMonth = new Date(0);
	  dateWithDesiredMonth.setFullYear(year, month, 15);
	  dateWithDesiredMonth.setHours(0, 0, 0, 0);
	  var daysInMonth = (0, _index3.default)(dateWithDesiredMonth); // Set the last day of the new month
	  // if the original date was the last day of the longer month
	
	  date.setMonth(month, Math.min(day, daysInMonth));
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfMinute;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfMinute
	 * @category Minute Helpers
	 * @summary Return the start of a minute for the given date.
	 *
	 * @description
	 * Return the start of a minute for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a minute
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a minute for 1 December 2014 22:15:45.400:
	 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:00
	 */
	function startOfMinute(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setSeconds(0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfQuarter
	 * @category Quarter Helpers
	 * @summary Return the start of a year quarter for the given date.
	 *
	 * @description
	 * Return the start of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a quarter for 2 September 2014 11:55:00:
	 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Jul 01 2014 00:00:00
	 */
	function startOfQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var currentMonth = date.getMonth();
	  var month = currentMonth - currentMonth % 3;
	  date.setMonth(month, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(308));
	
	var _index2 = _interopRequireDefault(__webpack_require__(66));
	
	var _index3 = _interopRequireDefault(__webpack_require__(10));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfWeekYear
	 * @category Week-Numbering Year Helpers
	 * @summary Return the start of a local week-numbering year for the given date.
	 *
	 * @description
	 * Return the start of a local week-numbering year.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Date} the start of a week-numbering year
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // The start of an a week-numbering year for 2 July 2005 with default settings:
	 * const result = startOfWeekYear(new Date(2005, 6, 2))
	 * //=> Sun Dec 26 2004 00:00:00
	 *
	 * @example
	 * // The start of a week-numbering year for 2 July 2005
	 * // if Monday is the first day of week
	 * // and 4 January is always in the first week of the year:
	 * const result = startOfWeekYear(new Date(2005, 6, 2), {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> Mon Jan 03 2005 00:00:00
	 */
	function startOfWeekYear(dirtyDate, dirtyOptions) {
	  (0, _index4.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index3.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index3.default)(options.firstWeekContainsDate);
	  var year = (0, _index.default)(dirtyDate, dirtyOptions);
	  var firstWeek = new Date(0);
	  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
	  firstWeek.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(firstWeek, dirtyOptions);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfYear
	 * @category Year Helpers
	 * @summary Return the start of a year for the given date.
	 *
	 * @description
	 * Return the start of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a year for 2 September 2014 11:55:00:
	 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Jan 01 2014 00:00:00
	 */
	function startOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var cleanDate = (0, _index.default)(dirtyDate);
	  var date = new Date(0);
	  date.setFullYear(cleanDate.getFullYear(), 0, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _undefined = __webpack_require__(1478)(); // Support ES3 engines
	
	module.exports = function (val) { return val !== _undefined && val !== null; };


/***/ }),
/* 218 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(144);
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(107));
	util.inherits = __webpack_require__(52);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(1866)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(485);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(145).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(484);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(83);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var writableHwm = options.writableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(83);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  pna.nextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    pna.nextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    pna.nextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    pna.nextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      pna.nextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(82), __webpack_require__(487).setImmediate, (function() { return this; }())))

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(482);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(219);
	exports.Duplex = __webpack_require__(83);
	exports.Transform = __webpack_require__(483);
	exports.PassThrough = __webpack_require__(1707);


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	var twoProduct = __webpack_require__(495)
	var robustSum = __webpack_require__(1717)
	var robustScale = __webpack_require__(1715)
	var robustSubtract = __webpack_require__(1716)
	
	var NUM_EXPAND = 5
	
	var EPSILON     = 1.1102230246251565e-16
	var ERRBOUND3   = (3.0 + 16.0 * EPSILON) * EPSILON
	var ERRBOUND4   = (7.0 + 56.0 * EPSILON) * EPSILON
	
	function orientation_3(sum, prod, scale, sub) {
	  return function orientation3Exact(m0, m1, m2) {
	    var p = sum(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])))
	    var n = sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0]))
	    var d = sub(p, n)
	    return d[d.length - 1]
	  }
	}
	
	function orientation_4(sum, prod, scale, sub) {
	  return function orientation4Exact(m0, m1, m2, m3) {
	    var p = sum(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m3[2]))), sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m3[2]))))
	    var n = sum(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m3[2]))), sum(scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m2[2]))))
	    var d = sub(p, n)
	    return d[d.length - 1]
	  }
	}
	
	function orientation_5(sum, prod, scale, sub) {
	  return function orientation5Exact(m0, m1, m2, m3, m4) {
	    var p = sum(sum(sum(scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m2[2]), sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), -m3[2]), scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m4[2]))), m1[3]), sum(scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m1[2]), sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m3[2]), scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m4[2]))), -m2[3]), scale(sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m4[2]))), m3[3]))), sum(scale(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m3[2]))), -m4[3]), sum(scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m1[2]), sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m3[2]), scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m4[2]))), m0[3]), scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m3[2]), scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), m4[2]))), -m1[3])))), sum(sum(scale(sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m4[2]))), m3[3]), sum(scale(sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m3[2]))), -m4[3]), scale(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m3[2]))), m0[3]))), sum(scale(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m3[2]))), -m1[3]), sum(scale(sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m3[2]))), m2[3]), scale(sum(scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m2[2]))), -m3[3])))))
	    var n = sum(sum(sum(scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m2[2]), sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), -m3[2]), scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m4[2]))), m0[3]), scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m3[2]), scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), m4[2]))), -m2[3])), sum(scale(sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m4[2]))), m3[3]), scale(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m3[2]))), -m4[3]))), sum(sum(scale(sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m4[2]))), m0[3]), scale(sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m4[2]))), -m1[3])), sum(scale(sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m4[2]))), m2[3]), scale(sum(scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m2[2]))), -m4[3]))))
	    var d = sub(p, n)
	    return d[d.length - 1]
	  }
	}
	
	function orientation(n) {
	  var fn =
	    n === 3 ? orientation_3 :
	    n === 4 ? orientation_4 : orientation_5
	
	  return fn(robustSum, twoProduct, robustScale, robustSubtract)
	}
	
	var orientation3Exact = orientation(3)
	var orientation4Exact = orientation(4)
	
	var CACHED = [
	  function orientation0() { return 0 },
	  function orientation1() { return 0 },
	  function orientation2(a, b) {
	    return b[0] - a[0]
	  },
	  function orientation3(a, b, c) {
	    var l = (a[1] - c[1]) * (b[0] - c[0])
	    var r = (a[0] - c[0]) * (b[1] - c[1])
	    var det = l - r
	    var s
	    if(l > 0) {
	      if(r <= 0) {
	        return det
	      } else {
	        s = l + r
	      }
	    } else if(l < 0) {
	      if(r >= 0) {
	        return det
	      } else {
	        s = -(l + r)
	      }
	    } else {
	      return det
	    }
	    var tol = ERRBOUND3 * s
	    if(det >= tol || det <= -tol) {
	      return det
	    }
	    return orientation3Exact(a, b, c)
	  },
	  function orientation4(a,b,c,d) {
	    var adx = a[0] - d[0]
	    var bdx = b[0] - d[0]
	    var cdx = c[0] - d[0]
	    var ady = a[1] - d[1]
	    var bdy = b[1] - d[1]
	    var cdy = c[1] - d[1]
	    var adz = a[2] - d[2]
	    var bdz = b[2] - d[2]
	    var cdz = c[2] - d[2]
	    var bdxcdy = bdx * cdy
	    var cdxbdy = cdx * bdy
	    var cdxady = cdx * ady
	    var adxcdy = adx * cdy
	    var adxbdy = adx * bdy
	    var bdxady = bdx * ady
	    var det = adz * (bdxcdy - cdxbdy)
	            + bdz * (cdxady - adxcdy)
	            + cdz * (adxbdy - bdxady)
	    var permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * Math.abs(adz)
	                  + (Math.abs(cdxady) + Math.abs(adxcdy)) * Math.abs(bdz)
	                  + (Math.abs(adxbdy) + Math.abs(bdxady)) * Math.abs(cdz)
	    var tol = ERRBOUND4 * permanent
	    if ((det > tol) || (-det > tol)) {
	      return det
	    }
	    return orientation4Exact(a,b,c,d)
	  }
	]
	
	function slowOrient(args) {
	  var proc = CACHED[args.length]
	  if(!proc) {
	    proc = CACHED[args.length] = orientation(args.length)
	  }
	  return proc.apply(undefined, args)
	}
	
	function proc (slow, o0, o1, o2, o3, o4, o5) {
	  return function getOrientation(a0, a1, a2, a3, a4) {
	    switch (arguments.length) {
	      case 0:
	      case 1:
	        return 0;
	      case 2:
	        return o2(a0, a1)
	      case 3:
	        return o3(a0, a1, a2)
	      case 4:
	        return o4(a0, a1, a2, a3)
	      case 5:
	        return o5(a0, a1, a2, a3, a4)
	    }
	
	    var s = new Array(arguments.length)
	    for (var i = 0; i < arguments.length; ++i) {
	      s[i] = arguments[i]
	    }
	    return slow(s)
	  }
	}
	
	function generateOrientationProc() {
	  while(CACHED.length <= NUM_EXPAND) {
	    CACHED.push(orientation(CACHED.length))
	  }
	  module.exports = proc.apply(undefined, [slowOrient].concat(CACHED))
	  for(var i=0; i<=NUM_EXPAND; ++i) {
	    module.exports[i] = CACHED[i]
	  }
	}
	
	generateOrientationProc()

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	//http://en.wikipedia.org/wiki/Delaunay_triangulation
	//https://github.com/ironwallaby/delaunay
	var polygon = __webpack_require__(17).polygon;
	var featurecollection = __webpack_require__(17).featureCollection;
	
	/**
	 * Takes a set of {@link Point|points} and the name of a z-value property and
	 * creates a [Triangulated Irregular Network](http://en.wikipedia.org/wiki/Triangulated_irregular_network),
	 * or a TIN for short, returned as a collection of Polygons. These are often used
	 * for developing elevation contour maps or stepped heat visualizations.
	 *
	 * This triangulates the points, as well as adds properties called `a`, `b`,
	 * and `c` representing the value of the given `propertyName` at each of
	 * the points that represent the corners of the triangle.
	 *
	 * @name tin
	 * @param {FeatureCollection<Point>} points input points
	 * @param {String=} z name of the property from which to pull z values
	 * This is optional: if not given, then there will be no extra data added to the derived triangles.
	 * @return {FeatureCollection<Polygon>} TIN output
	 * @example
	 * // generate some random point data
	 * var points = turf.random('points', 30, {
	 *   bbox: [50, 30, 70, 50]
	 * });
	 * //=points
	 * // add a random property to each point between 0 and 9
	 * for (var i = 0; i < points.features.length; i++) {
	 *   points.features[i].properties.z = ~~(Math.random() * 9);
	 * }
	 * var tin = turf.tin(points, 'z')
	 * for (var i = 0; i < tin.features.length; i++) {
	 *   var properties  = tin.features[i].properties;
	 *   // roughly turn the properties of each
	 *   // triangle into a fill color
	 *   // so we can visualize the result
	 *   properties.fill = '#' + properties.a +
	 *     properties.b + properties.c;
	 * }
	 * //=tin
	 */
	module.exports = function (points, z) {
	    //break down points
	    return featurecollection(triangulate(points.features.map(function (p) {
	        var point = {
	            x: p.geometry.coordinates[0],
	            y: p.geometry.coordinates[1]
	        };
	        if (z) point.z = p.properties[z];
	        return point;
	    })).map(function (triangle) {
	        return polygon([[
	        [triangle.a.x, triangle.a.y],
	        [triangle.b.x, triangle.b.y],
	        [triangle.c.x, triangle.c.y],
	        [triangle.a.x, triangle.a.y]
	        ]], {
	            a: triangle.a.z,
	            b: triangle.b.z,
	            c: triangle.c.z
	        });
	    }));
	};
	
	function Triangle(a, b, c) {
	    this.a = a;
	    this.b = b;
	    this.c = c;
	
	    var A = b.x - a.x,
	        B = b.y - a.y,
	        C = c.x - a.x,
	        D = c.y - a.y,
	        E = A * (a.x + b.x) + B * (a.y + b.y),
	        F = C * (a.x + c.x) + D * (a.y + c.y),
	        G = 2 * (A * (c.y - b.y) - B * (c.x - b.x)),
	        minx, miny, dx, dy;
	
	    // If the points of the triangle are collinear, then just find the
	    // extremes and use the midpoint as the center of the circumcircle.
	    if (Math.abs(G) < 0.000001) {
	        minx = Math.min(a.x, b.x, c.x);
	        miny = Math.min(a.y, b.y, c.y);
	        dx = (Math.max(a.x, b.x, c.x) - minx) * 0.5;
	        dy = (Math.max(a.y, b.y, c.y) - miny) * 0.5;
	
	        this.x = minx + dx;
	        this.y = miny + dy;
	        this.r = dx * dx + dy * dy;
	    } else {
	        this.x = (D * E - B * F) / G;
	        this.y = (A * F - C * E) / G;
	        dx = this.x - a.x;
	        dy = this.y - a.y;
	        this.r = dx * dx + dy * dy;
	    }
	}
	
	function byX(a, b) {
	    return b.x - a.x;
	}
	
	function dedup(edges) {
	    var j = edges.length,
	        a, b, i, m, n;
	
	    outer:
	  while (j) {
	      b = edges[--j];
	      a = edges[--j];
	      i = j;
	      while (i) {
	          n = edges[--i];
	          m = edges[--i];
	          if ((a === m && b === n) || (a === n && b === m)) {
	              edges.splice(j, 2);
	              edges.splice(i, 2);
	              j -= 2;
	              continue outer;
	          }
	      }
	  }
	}
	
	function triangulate(vertices) {
	    // Bail if there aren't enough vertices to form any triangles.
	    if (vertices.length < 3)
	        return [];
	
	    // Ensure the vertex array is in order of descending X coordinate
	    // (which is needed to ensure a subquadratic runtime), and then find
	    // the bounding box around the points.
	    vertices.sort(byX);
	
	    var i = vertices.length - 1,
	        xmin = vertices[i].x,
	        xmax = vertices[0].x,
	        ymin = vertices[i].y,
	        ymax = ymin;
	
	    while (i--) {
	        if (vertices[i].y < ymin)
	            ymin = vertices[i].y;
	        if (vertices[i].y > ymax)
	            ymax = vertices[i].y;
	    }
	
	    //Find a supertriangle, which is a triangle that surrounds all the
	    //vertices. This is used like something of a sentinel value to remove
	    //cases in the main algorithm, and is removed before we return any
	    // results.
	
	    // Once found, put it in the "open" list. (The "open" list is for
	    // triangles who may still need to be considered; the "closed" list is
	    // for triangles which do not.)
	    var dx = xmax - xmin,
	        dy = ymax - ymin,
	        dmax = (dx > dy) ? dx : dy,
	        xmid = (xmax + xmin) * 0.5,
	        ymid = (ymax + ymin) * 0.5,
	        open = [
	            new Triangle({
	                x: xmid - 20 * dmax,
	                y: ymid - dmax,
	                __sentinel: true
	            }, {
	                x: xmid,
	                y: ymid + 20 * dmax,
	                __sentinel: true
	            }, {
	                x: xmid + 20 * dmax,
	                y: ymid - dmax,
	                __sentinel: true
	            }
	        )],
	        closed = [],
	        edges = [],
	        j, a, b;
	
	    // Incrementally add each vertex to the mesh.
	    i = vertices.length;
	    while (i--) {
	        // For each open triangle, check to see if the current point is
	        // inside it's circumcircle. If it is, remove the triangle and add
	        // it's edges to an edge list.
	        edges.length = 0;
	        j = open.length;
	        while (j--) {
	            // If this point is to the right of this triangle's circumcircle,
	            // then this triangle should never get checked again. Remove it
	            // from the open list, add it to the closed list, and skip.
	            dx = vertices[i].x - open[j].x;
	            if (dx > 0 && dx * dx > open[j].r) {
	                closed.push(open[j]);
	                open.splice(j, 1);
	                continue;
	            }
	
	            // If not, skip this triangle.
	            dy = vertices[i].y - open[j].y;
	            if (dx * dx + dy * dy > open[j].r)
	                continue;
	
	            // Remove the triangle and add it's edges to the edge list.
	            edges.push(
	        open[j].a, open[j].b,
	        open[j].b, open[j].c,
	        open[j].c, open[j].a
	      );
	            open.splice(j, 1);
	        }
	
	        // Remove any doubled edges.
	        dedup(edges);
	
	        // Add a new triangle for each edge.
	        j = edges.length;
	        while (j) {
	            b = edges[--j];
	            a = edges[--j];
	            open.push(new Triangle(a, b, vertices[i]));
	        }
	    }
	
	    // Copy any remaining open triangles to the closed list, and then
	    // remove any triangles that share a vertex with the supertriangle.
	    Array.prototype.push.apply(closed, open);
	
	    i = closed.length;
	    while (i--)
	        if (closed[i].a.__sentinel ||
	      closed[i].b.__sentinel ||
	      closed[i].c.__sentinel)
	            closed.splice(i, 1);
	
	    return closed;
	}


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint global-require: 0*/
	
	/**
	 * Turf is a modular geospatial analysis engine written in JavaScript. It performs geospatial
	 * processing tasks with GeoJSON data and can be run on a server or in a browser.
	 *
	 * @module turf
	 * @summary Geospatial analysis for JavaScript
	 */
	module.exports = {
	    isolines: __webpack_require__(1743),
	    convex: __webpack_require__(1735),
	    within: __webpack_require__(1759),
	    concave: __webpack_require__(1734),
	    difference: __webpack_require__(1736),
	    collect: __webpack_require__(1732),
	    flip: __webpack_require__(1738),
	    simplify: __webpack_require__(1754),
	    bezier: __webpack_require__(1728),
	    tag: __webpack_require__(1756),
	    sample: __webpack_require__(1753),
	    envelope: __webpack_require__(1737),
	    square: __webpack_require__(493),
	    midpoint: __webpack_require__(1747),
	    buffer: __webpack_require__(1730),
	    center: __webpack_require__(489),
	    centroid: __webpack_require__(1731),
	    combine: __webpack_require__(1733),
	    distance: __webpack_require__(39),
	    explode: __webpack_require__(490),
	    bbox: __webpack_require__(147),
	    tesselate: __webpack_require__(1757),
	    bboxPolygon: __webpack_require__(488),
	    inside: __webpack_require__(94),
	    intersect: __webpack_require__(1741),
	    nearest: __webpack_require__(1748),
	    planepoint: __webpack_require__(491),
	    random: __webpack_require__(1752),
	    tin: __webpack_require__(222),
	    union: __webpack_require__(494),
	    bearing: __webpack_require__(148),
	    destination: __webpack_require__(149),
	    kinks: __webpack_require__(1744),
	    pointOnSurface: __webpack_require__(1750),
	    area: __webpack_require__(1727),
	    along: __webpack_require__(1726),
	    lineDistance: __webpack_require__(1745),
	    lineSlice: __webpack_require__(1746),
	    pointOnLine: __webpack_require__(492),
	    pointGrid: __webpack_require__(1749),
	    squareGrid: __webpack_require__(1755),
	    triangleGrid: __webpack_require__(1758),
	    hexGrid: __webpack_require__(1740)
	};
	
	var helpers = __webpack_require__(17);
	
	module.exports.point = helpers.point;
	module.exports.polygon = helpers.polygon;
	module.exports.lineString = helpers.lineString;
	module.exports.multiPoint = helpers.multiPoint;
	module.exports.multiPolygon = helpers.multiPolygon;
	module.exports.multiLineString = helpers.multiLineString;
	module.exports.feature = helpers.feature;
	module.exports.featureCollection = helpers.featureCollection;
	module.exports.geometryCollection = helpers.geometryCollection;


/***/ }),
/* 224 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 225 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4NCiAgPHBhdGggaWQ9Ikljb25fZmVhdGhlci1lZGl0LTIiIGRhdGEtbmFtZT0iSWNvbiBmZWF0aGVyLWVkaXQtMiIgZD0iTTIzLjQyNSw0LjM4NWEzLjg1MSwzLjg1MSwwLDAsMSw1LjQ0Nyw1LjQ0N0wxMC40ODksMjguMjE1LDMsMzAuMjU3bDIuMDQzLTcuNDg5WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEuNSAtMS43NTcpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIzIi8+DQo8L3N2Zz4NCg=="

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 227 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2LjM1NiIgaGVpZ2h0PSIxMS4xMTYiIHZpZXdCb3g9IjAgMCA2LjM1NiAxMS4xMTYiPjxkZWZzPjxzdHlsZT4uYXtmaWxsOiMxMDcwY2E7fTwvc3R5bGU+PC9kZWZzPjxwYXRoIGNsYXNzPSJhIiBkPSJNMTUuNjg2LDExLjc1MmwtNC4yMDctNC4yYS43OTEuNzkxLDAsMCwxLDAtMS4xMjIuOC44LDAsMCwxLDEuMTI1LDBsNC43NjYsNC43NjNhLjc5My43OTMsMCwwLDEsLjAyMywxLjFsLTQuNzg2LDQuOGEuNzk1Ljc5NSwwLDEsMS0xLjEyNS0xLjEyMloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMS4yNDYgLTYuMTk2KSIvPjwvc3ZnPg=="

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1545)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(722),
	  /* template */
	  __webpack_require__(2079),
	  /* scopeId */
	  "data-v-29ddc2b9",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	var settle = __webpack_require__(545);
	var buildURL = __webpack_require__(548);
	var parseHeaders = __webpack_require__(554);
	var isURLSameOrigin = __webpack_require__(552);
	var createError = __webpack_require__(232);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(547);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(550);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        if (request.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),
/* 230 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),
/* 231 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(544);
	
	/**
	 * Create an Error with the specified message, config, error code, and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, response);
	};


/***/ }),
/* 233 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 234 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DocumentsEnum = [];
	
	exports.default = DocumentsEnum;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(49);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _map = __webpack_require__(121);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _contractName = __webpack_require__(1906);
	
	var _contractName2 = _interopRequireDefault(_contractName);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _message = __webpack_require__(749);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _number = __webpack_require__(24);
	
	var _date = __webpack_require__(38);
	
	var F = _interopRequireWildcard(_date);
	
	var _vuex = __webpack_require__(120);
	
	var _date2 = __webpack_require__(60);
	
	var _toll = __webpack_require__(26);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _tag = __webpack_require__(55);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _vehicles = __webpack_require__(29);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	var _accordion = __webpack_require__(513);
	
	var _accordion2 = _interopRequireDefault(_accordion);
	
	var _modalAutomaticValue = __webpack_require__(523);
	
	var _modalAutomaticValue2 = _interopRequireDefault(_modalAutomaticValue);
	
	var _modalChangeAutomaticValue = __webpack_require__(524);
	
	var _modalChangeAutomaticValue2 = _interopRequireDefault(_modalChangeAutomaticValue);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _modalTransfer = __webpack_require__(1883);
	
	var _modalTransfer2 = _interopRequireDefault(_modalTransfer);
	
	var _modalAggregateRegister = __webpack_require__(517);
	
	var _modalAggregateRegister2 = _interopRequireDefault(_modalAggregateRegister);
	
	var _modalTollTicket = __webpack_require__(1900);
	
	var _modalTollTicket2 = _interopRequireDefault(_modalTollTicket);
	
	var _modalRescueBalance = __webpack_require__(519);
	
	var _modalRescueBalance2 = _interopRequireDefault(_modalRescueBalance);
	
	var _modalPrintVp = __webpack_require__(1897);
	
	var _modalPrintVp2 = _interopRequireDefault(_modalPrintVp);
	
	var _modalBlockVehicle = __webpack_require__(518);
	
	var _modalBlockVehicle2 = _interopRequireDefault(_modalBlockVehicle);
	
	var _modalRouteVp = __webpack_require__(1899);
	
	var _modalRouteVp2 = _interopRequireDefault(_modalRouteVp);
	
	var _modalReceiptVp = __webpack_require__(1898);
	
	var _modalReceiptVp2 = _interopRequireDefault(_modalReceiptVp);
	
	var _paginationSm = __webpack_require__(622);
	
	var _paginationSm2 = _interopRequireDefault(_paginationSm);
	
	var _modalMyContracts = __webpack_require__(1880);
	
	var _modalMyContracts2 = _interopRequireDefault(_modalMyContracts);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RECHARGE_UNIT_VALUE = 50.0;
	
	var texts = {
	  partialBlocked: ""
	};
	
	exports.default = {
	  data: function data() {
	    return {
	      newAhesionTax: undefined,
	      newVehicleTax: undefined,
	      canMigratePlan: false,
	      currentBalance: undefined,
	      contracts: [],
	      vpSelected: undefined,
	      state: undefined,
	      newMoveMaisId: undefined,
	      invoices: new _map2.default(),
	      loading: undefined,
	      modalRecharge: {},
	      vp: undefined,
	      embarcadorVpPre: undefined,
	      embarcadorVpPos: undefined,
	      aggregateVehicles: undefined,
	      showLabSodreModal: false,
	      checkVehicle: false,
	      tagReservaSaldoByContract: {},
	      valorDebitado: "",
	      erroDebito: undefined,
	      cobrarDebito: [],
	      numeroCartao: undefined,
	      primeiroCartao: false,
	      msgErro: undefined,
	      hasRodosol: false,
	      contractSelected: undefined,
	      vpFilterDate: {},
	      typeAggregate: undefined,
	      dataAggregate: {},
	      rescueData: undefined,
	      showRescue: false,
	      showBlock: false,
	      showModalAggregate: false,
	      showModalTollTicket: false,
	      showPrintVp: false,
	      showRouteVp: false,
	      showReceiptVp: false,
	      contractAggregate: undefined,
	      contractIdAggregate: undefined,
	      contractShipper: undefined,
	      partialBlockedMessage: "",
	      open: true,
	      loadingVehiclesAggregate: false,
	      lang: {
	        formatLocale: {
	          months: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
	          monthsShort: ["Jan", "Fev", "Mar", "Abr", "Maio", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
	          weekdays: ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"],
	          weekdaysShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
	          weekdaysMin: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
	          firstDayOfWeek: 0,
	          firstWeekContainsDate: 1
	        }
	      },
	      momentFormat: {
	        stringify: function stringify(date) {
	          return date ? (0, _moment2.default)(date).format("L") : "";
	        }
	      },
	      lastDays: "31",
	      customStart: undefined,
	      customEnd: undefined,
	      dateRange: [this.customStart, this.customEnd],
	      pageSm: new _paginationSm.PageSm(),
	      pageSmVpPre: new _paginationSm.PageSm(),
	      pageSmVpPos: new _paginationSm.PageSm(),
	      contractIdVpPre: undefined,
	      contractIdVpPos: undefined,
	      totalVps: 0,
	      totalVpExpired: 0,
	      show: {
	        toll_ticket: false
	      },
	      promises: [],
	      checkMigration: undefined,
	      showModalMyContracts: false,
	      svgContent: "",
	      svgContentMobile: "",
	      parceiroUrlId: undefined,
	      urlDestino: undefined,
	      isMobile: undefined,
	      loadingPaymentMethods: {}
	    };
	  },
	
	
	  watch: {
	    contracts: {
	      handler: function handler(val, oldVal) {
	        this.checkValidContract();
	        var contract = this.contracts[0];
	        if (contract && contract.summary) {
	          var valueTaxAllVehicle = this.newVehicleTax * contract.summary.cadastrados;
	
	          this.canMigratePlan = valueTaxAllVehicle > contract.currentBalance.currentBalance ? false : true;
	        }
	      },
	      deep: true
	    },
	
	    $route: function $route() {
	      var _this = this;
	
	      this.promises.push(this.findContracts(this.$route.Query.moveMaisId).then(function () {
	        _this.checkMigrationStatus();
	      }));
	    },
	
	    promises: function promises(val) {
	      this.loading = _promise2.default.all(val);
	    }
	  },
	
	  created: function created() {
	    var _this2 = this;
	
	    window.addEventListener("scroll", function () {
	      _this2.isScrolling = window.scrollY > 0;
	    });
	
	    this.setIsMobile();
	
	    this.$watch("isMobile", function (newValue, oldValue) {
	      if (newValue !== oldValue) {
	        _this2.onMobileChange(newValue);
	      }
	    });
	
	    window.addEventListener("resize", this.setIsMobile);
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.getMessage();
	
	    this.getBannersParceiro();
	
	    this.checkValidContract();
	
	    sessionStorage.removeItem("promoCheck");
	    $('[data-toggle="tooltip"]').tooltip();
	
	    var filter = {
	      moveMaisIdDest: this.currentUser.moveMaisId,
	      page: this.pageSm.build()
	    };
	
	    this.promises.push(_toll2.default.getFilterLimited(filter).then(function (data) {
	      if (data && data.itens && data.itens.length) _this3.vp = data.itens;
	    }));
	
	    this.promises.push(this.findContracts(this.currentUser.moveMaisId).then(function (response) {}));
	
	    this.checkMigrationStatus();
	  },
	
	  computed: {
	    currentUser: function currentUser() {
	      return _auth2.default.currentUser;
	    },
	    possuiTagReserva: function possuiTagReserva() {
	      return !!(_auth2.default.currentUser && _auth2.default.currentUser.possuiTagReserva);
	    },
	    formatDate: function formatDate(date) {
	      return (0, _moment2.default)(date).format("L");
	    },
	    localeFilterDate: function localeFilterDate() {},
	    clientCellPhone: function clientCellPhone() {
	      return this.currentUser.dddCellphone + this.currentUser.nroCellphone;
	    },
	    clientName: function clientName() {
	      if (this.currentUser.person) {
	        return this.currentUser.person.name.replace(" ", "_") + "_" + this.currentUser.person.lastName.replace(" ", "_");
	      } else {
	        return this.currentUser.company.companyName.replace(/ /g, "_");
	      }
	    },
	    bannerImageLink: function bannerImageLink() {
	      if (window.document.webview || window.screen.width <= 600 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
	        return "/static/sodre/BANNER_SITE_MOBILE-combotao335.png";
	      }
	      return "/static/sodre/DESKTOP-CERTO-COM-BOTÃO.png";
	    },
	    labSodrePromotionLink: function labSodrePromotionLink() {
	      return "https://sodretox.com.br/exame-toxicologico/comprar/rede-credenciada/moveMaisHome";
	    },
	    periodStart: function periodStart() {
	      var days = this.lastDays;
	      var d = this.customStart != undefined && this.customStart != null ? (0, _moment2.default)(this.customStart) : (0, _moment2.default)().subtract(parseInt(days), "d");
	
	      return F.date(d, "YYYY-MM-DD");
	    },
	    periodEnd: function periodEnd() {
	      var days = this.lastDays;
	      var d = this.customEnd != undefined && this.customEnd != null ? (0, _moment2.default)(this.customEnd) : (0, _moment2.default)();
	
	      return F.date(d, "YYYY-MM-DD");
	    }
	  },
	
	  filters: {
	    formatPlate: function formatPlate(placa) {
	      return placa.substr(0, 3) + "-" + placa.substr(3, 7);
	    }
	  },
	
	  methods: (0, _extends3.default)({
	    openPaymentMethods: function openPaymentMethods(contractId) {
	      var _this4 = this;
	
	      this.$set(this.loadingPaymentMethods, contractId, true);
	      _sales2.default.redirectToContractPayment(contractId).catch(function () {}).finally(function () {
	        _this4.$set(_this4.loadingPaymentMethods, contractId, false);
	      });
	    },
	    setIsMobile: function setIsMobile() {
	      this.isMobile = window.innerWidth <= 769;
	    },
	    getBannersParceiro: function getBannersParceiro() {
	      var _this5 = this;
	
	      _sales2.default.getBannersParceiro().then(function (res) {
	        var banners = res && res.banners ? res.banners : {};
	        _this5.svgContent = banners.web && banners.web.svg ? banners.web.svg : "";
	        _this5.svgContentMobile = banners.mobile && banners.mobile.svg ? banners.mobile.svg : "";
	        _this5.parceiroUrlId = res ? res.parceiroUrlId : undefined;
	        _this5.urlDestino = res ? res.urlDestino : undefined;
	      }).catch(function (err) {
	        _this5.svgContent = "";
	        _this5.svgContentMobile = "";
	        console.error("erro no getBannersParceiro:", err);
	      });
	    },
	    onPartnerBannerClick: function onPartnerBannerClick(dispositivo) {
	      if (!this.urlDestino) {
	        return;
	      }
	
	      if (this.parceiroUrlId && this.currentUser && this.currentUser.moveMaisId) {
	        _sales2.default.getBannerAccess({
	          parceiroUrlId: this.parceiroUrlId,
	          moveMaisId: this.currentUser.moveMaisId,
	          dispositivo: (dispositivo || "").toUpperCase()
	        }).catch(function () {});
	      }
	
	      window.open(this.urlDestino, "_blank", "noopener,noreferrer");
	    },
	    onMobileChange: function onMobileChange() {},
	    openMyContractsModal: function openMyContractsModal() {
	      this.showModalMyContracts = true;
	    },
	    fecharModal: function fecharModal() {
	      this.showModalMyContracts = false;
	    },
	    checkValidContract: function checkValidContract() {
	      var findContract = this.contracts.find(function (contract) {
	        return contract.plan.planId == 62 || contract.plan.planId == 64;
	      });
	      if (findContract && findContract.status.contractStatusId == 0) {
	        this.checkVehicle = false;
	      }
	    },
	    zapay_inicio: function zapay_inicio() {
	      _sales2.default.gravaLogRedirecionamentoBanner(this.currentUser.moveMaisId, 2, 1).then(function (res) {});
	
	      var url = "https://www.zignet.com.br/parceiro/movemais-interno/";
	      window.open(url, "_blank");
	    },
	    cancelarVP: function cancelarVP(idIntern, placaVeiculo, embarcador) {
	      var vm = this;
	      _messageDialog2.default.show({
	        title: "Cancelar vale-pedágio",
	        message: "Deseja cancelar o vale-pedágio?",
	        type: "OK-CANCEL-ADHESION"
	      }).then(function (res) {
	        if (res == "OK") {
	          window.setTimeout(function () {
	            vm.doCancel(idIntern, placaVeiculo, embarcador);
	          }, 500);
	        }
	      });
	    },
	    checkMigrationStatus: function checkMigrationStatus() {
	      var _this6 = this;
	
	      _contracts2.default.checkStatusMigration(this.currentUser.moveMaisId).then(function (response) {
	        _this6.checkMigration = response.listCheck;
	      });
	    },
	    doCancel: function doCancel(idIntern, placaVeiculo, embarcador) {
	      var _this7 = this;
	
	      var vm = this;
	      var promise = _toll2.default.cancelar({ idIntern: idIntern, placaVeiculo: placaVeiculo }).then(function (res) {
	        if (embarcador == "pre") {
	          _this7.doFilterVpPre();
	        } else {
	          _this7.doFilterVpPos();
	        }
	      }).catch(function (err) {
	        vm.$nextTick(function () {
	          return _messageDialog2.default.show({
	            title: "Falha ao cancelar",
	            message: err.data.status.message,
	            type: "OK"
	          });
	        });
	      });
	      this.$store.dispatch("loading", promise);
	      return promise;
	    }
	  }, (0, _vuex.mapMutations)(["hasPlanEmbarcador", "setContracts", "setContractSelected"]), {
	    showModalTransfer: function showModalTransfer() {
	      $("#modal-transfer").modal("show");
	      $("#someTab").tab("show");
	    },
	    findContracts: function findContracts(moveMaisId) {
	      var _this8 = this;
	
	      this.state = "LOADING";
	
	      _tag2.default.getTagReservaContexto().then(function (ctx) {
	        _this8.tagReservaSaldoByContract = ctx.cnpjPossuiEstoque ? ctx.saldoLiquidoByContract : {};
	      });
	
	      return _contracts2.default.findAllContractsVw(moveMaisId).then(function (contracts) {
	        _this8.contracts = contracts;
	        _this8.state = "LOADED";
	        var embarcador = _.find(contracts, function (o) {
	          return _this8.getKindPlan(o.plan.planId) == "EMBARCADOR";
	        });
	        _this8.hasPlanEmbarcador(!!embarcador);
	
	        if (_this8.contracts && _this8.contracts.length > 0) {
	          _.find(_this8.contracts, function (o) {
	            if (o.plan.planId == 62 || o.plan.planId == 64) {
	              _this8.hasRodosol = true;
	              _this8.contractSelected = o;
	              _this8.setContractSelected(_this8.contractSelected);
	              _this8.currentBalance = o.currentBalance.currentBalance;
	
	              var newPlanId = void 0;
	              if (o.plan.planId == 62) {
	                o.plan.newPlanId = 22;
	              } else if (o.plan.planId == 64) {
	                o.plan.newPlanId = 32;
	              }
	              _this8.contractSelected = o;
	
	              _this8.loading = _sales2.default.getPlanById(o.plan.newPlanId).then(function (resp) {
	                _this8.newAhesionTax = _this8.newVehicleTax = _.filter(resp.adhesionTax.adhesionTax, function (o) {
	                  return o.taxId == _constantes2.default.NEW_VEHICLE_TAXID;
	                })[0].value;
	              }).catch(function (err) {});
	            }
	          });
	
	          _.forEach(_this8.contracts, function (o) {
	            _this8.$set(o, "open", false);
	            if (o.planId != 7) {
	              _contracts2.default.getSummaryVehicles(o.contractId).then(function (r) {
	                _this8.$set(o, "summary", r);
	              });
	            }
	
	            _vehicles2.default.getVehicleByContractIdContagem(o.contractId).then(function (res) {
	              _this8.numeroDeVeiculos = res.length;
	
	              if (_this8.numeroDeVeiculos >= 10 && (o.plan.planId == 70 || o.plan.planId == 71)) {
	                _this8.bloqueiaRoadcard = true;
	              }
	            });
	          });
	
	          _this8.contractShipper = _.find(_this8.contracts, function (o) {
	            return o.plan.planId == 6 || o.plan.planId == 8;
	          });
	
	          _.find(_this8.contracts, function (o) {
	            if (o.plan.planId == 45 || o.plan.planId == 46) {
	              _this8.contractIdAggregate = o.contractId;
	              _this8.doFilter();
	            }
	            if (o.plan.planId == 6) {
	              _this8.contractIdVpPre = o.contractId;
	              _this8.doFilterVpPre();
	            }
	            if (o.plan.planId == 8) {
	              _this8.contractIdVpPos = o.contractId;
	              _this8.doFilterVpPos();
	            }
	          });
	        }
	
	        _this8.setContracts(contracts);
	        return contracts;
	      }).then(function (contracts) {
	        if (contracts.length == 0) {
	          _this8.$router.push({ name: "new-contract" });
	          return;
	        }
	
	        _.forEach(contracts, function (c) {
	          _contracts2.default.getPaymentMethod(c.contractId).then(function (resp) {
	            var algumUsuarioNulo = false;
	
	            resp.forEach(function (item) {
	              if (item.usuario === null && item.deleted != "Y" && item.validado != 1 && item.validado != -1) {
	                algumUsuarioNulo = true;
	
	                if (_this8.contracts.length === 1 && resp.length === 1 && item.validado === 0) {
	                  _this8.primeiroCartao = true;
	                }
	                var validar = _.find(resp, function (o) {
	                  return o.validado === 0;
	                });
	                if (validar) {
	                  if (!_this8.numeroCartao) {
	                    _this8.numeroCartao = validar.number;
	                  }
	                  _this8.cobrarDebito.push(validar);
	                  $("#valor-debitado").modal();
	                }
	              }
	            });
	          });
	        });
	
	        if (contracts.length == 1) {
	          var c = contracts[0];
	
	          _this8.currentUser.onlyOneContract = c.contractId;
	          _this8.$store.commit("currentPlanId", c.plan.planId);
	          _auth2.default.updateLocalStorage();
	          if (c.status.contractStatusId === 0 && !sessionStorage.getItem("showed-reprocess")) {
	            return _sales2.default.listSalesOrders({
	              moveMaisId: _this8.currentUser.moveMaisId
	            }).then(function (result) {
	              var pedidoAdesao = _.filter(result.itens, function (o) {
	                return o.salesType == "ADHESION";
	              });
	              if (pedidoAdesao && pedidoAdesao.length == 1) {
	                if (pedidoAdesao[0].salesOrderStatus.salesOrderStatusId == 3) {
	                  sessionStorage.setItem("showed-reprocess", true);
	                  _this8.$router.push({
	                    name: "reprocess-order",
	                    params: { orderId: pedidoAdesao[0].salesOrderId }
	                  });
	                  return _promise2.default.reject("Pagamento não aprovado");
	                }
	              }
	            });
	          }
	        }
	        if (_this8.isLabSodrePromotionPlan()) {
	          _this8.showLabSodreModal = true;
	        }
	
	        var embarcador = _.find(contracts, function (o) {
	          return o.plan.planId == 6 || o.plan.planId == 8;
	        });
	
	        var contratosLiberados = _.find(contracts, function (o) {
	          return o.plan.typePlan == "PRE";
	        });
	        if (contratosLiberados) {
	          _contracts2.default.getContractData(_this8.currentUser.moveMaisId).then(function (res) {
	            if (res.status.code == 0) {
	              _this8.checkVehicle = true;
	            } else {
	              _this8.checkVehicle = false;
	            }
	          });
	        }
	
	        if (!contratosLiberados) {
	          _vehicles2.default.checkVehicleByMoveMaisId(_this8.currentUser.moveMaisId).then(function (res) {
	            _this8.checkVehicle = res.checkVehicle;
	
	            if (_this8.checkVehicle == false) {
	              $("#info-block").modal();
	            }
	          });
	        }
	        return contracts;
	      }).then(this.getLastInvoice);
	    },
	    getLastInvoice: function getLastInvoice(contracts) {
	      var _this9 = this;
	
	      _.each(contracts, function (o) {
	        if (getKindPlan(o.plan.planId) == "POS_PAGO") {
	          _contracts2.default.getListInvoice(o.contractId).then(function (resp) {
	            if (resp.length > 0) _this9.invoices.set(o.contractId, resp[0]);
	            _this9.$forceUpdate();
	          });
	        }
	      });
	    },
	    getDueDate: function getDueDate(contract) {
	      if (this.invoices.get(contract.contractId)) {
	        return this.invoices.get(contract.contractId).invoiceExpirationDate;
	      }
	      return "-";
	    },
	    getInvoiceValue: function getInvoiceValue(contract) {
	      if (this.invoices.get(contract.contractId)) {
	        return this.invoices.get(contract.contractId).value;
	      }
	      return "-";
	    },
	    getBillingDates: function getBillingDates(contract) {
	      var b = contract.billingDay;
	      if (contract.billingDay2) b += ", " + contract.billingDay2;
	      if (contract.billingDay3) b += ", " + contract.billingDay3;
	      return b;
	    },
	    getRechargePercent: function getRechargePercent(contract) {
	      var nom = contract.currentBalance && contract.currentBalance.currentBalance;
	      var den = contract.rechargeValue;
	      return Math.round(Math.min(Math.max(0, nom / den), 1) * 100);
	    },
	    getRechargeStyle: function getRechargeStyle(contract) {
	      var width = Math.max(Math.round(this.getRechargePercent(contract)), 1);
	      return "width: " + width + "%";
	    },
	    getRechargeClass: function getRechargeClass(contract) {
	      var per = this.getRechargePercent(contract) / 100;
	      var trigger = this.getPercentRechargeAut(contract.plan.planId) / 100;
	      if (per <= trigger) {
	        return "progress-bar-danger";
	      } else if (per < 0.6) {
	        return "progress-bar-warning";
	      } else {
	        return "progress-bar-success";
	      }
	    },
	    getContractName: function getContractName(contract) {
	      if (contract.name) return contract.name;else return contract.contractId + " " + contract.plan.name;
	    },
	    showMessageContract: function showMessageContract() {
	      _messageDialog2.default.show({
	        title: "Info",
	        headerClass: "modal-info",
	        message: "Operação disponivel somente para contratos ativos"
	      });
	    },
	    showMessage: function showMessage() {
	      _messageDialog2.default.show({
	        type: "CLOSE",
	        title: "Contrato bloqueado parcialmente",
	        message: this.partialBlockedMessage,
	        headerClass: "modal-warning",
	        showContactText: true
	      });
	    },
	    getCurrentBalance: function getCurrentBalance(c) {
	      return (0, _number.cents)(c.currentBalance.currentBalance);
	    },
	    getAutomaticRechargeValue: function getAutomaticRechargeValue(c) {
	      return c.rechargeValue;
	    },
	    openModalRecharge: function openModalRecharge(contractId) {
	      this.$set(this.modalRecharge, contractId, true);
	    },
	    closeModalRecharge: function closeModalRecharge(contractId) {
	      this.$set(this.modalRecharge, contractId, false);
	    },
	    isLabSodrePromotionPlan: function isLabSodrePromotionPlan() {
	      if (!this.$route.query.showPromotionalModal) {
	        this.showLabSodreModal = false;
	        return;
	      }
	      var plans = [21, 22, 31, 32, 45, 55];
	      if (this.contracts.length > 0) {
	        for (var c in this.contracts) {
	          if (plans.indexOf(this.contracts[c].plan.planId) !== -1) {
	            this.showLabSodreModal = true;
	            return;
	          }
	        }
	      }
	    },
	    getStatusClass: function getStatusClass(contract) {
	      if (Number(contract.isEntryBlocked) === 999) return "";
	      if (contract.status.name === "ATIVO") return "";
	      return "status-red";
	    },
	    getStatusDotsClass: function getStatusDotsClass(contract) {
	      if (Number(contract.isEntryBlocked) === 999) return "status-pending";
	      if (contract.status.name === "ATIVO") return "status-active";
	      return "status-inactive";
	    },
	    getStatusContrato: function getStatusContrato(status, isEntryBlocked) {
	      if (Number(isEntryBlocked) === 999) {
	        return texts.partialBlocked;
	      }
	
	      if (status.contractStatusId == 4 || status.contractStatusId == 7 || status.contractStatusId == 8 || status.contractStatusId == 6) {
	        return "Bloqueado";
	      } else {
	        return status.name;
	      }
	    },
	    getMobileStatusName: function getMobileStatusName(contract) {
	      if (Number(contract.isEntryBlocked) === 999) return texts.partialBlocked;
	
	      return contract.status.name;
	    },
	    bloqueiaFuncionalidades: function bloqueiaFuncionalidades(status) {
	      if (status != 0 && status != 2 && status != 3 && status != 4 && status != 6 && status != 7 && status != 8) {
	        return true;
	      } else return false;
	    },
	    handleChangeDate: function handleChangeDate(value) {
	      if (value.length > 1) {
	        this.customStart = value[0];
	        this.customEnd = value[1];
	        this.lastDays = undefined;
	      } else {
	        this.customStart = undefined;
	        this.customEnd = undefined;
	        this.lastDays = value;
	      }
	      this.doFilter(true);
	    },
	    rescueBalance: function rescueBalance(value) {
	      this.showRescue = true;
	      this.rescueData = value;
	      this.$nextTick(function () {
	        $("#modal-rescue-balance").modal();
	      });
	    },
	    modalAggregate: function modalAggregate(value) {
	      this.contractAggregate = value;
	      this.contractAggregate.moveMaisId = this.currentUser.moveMaisId;
	      this.showModalAggregate = true;
	      this.$nextTick(function () {
	        $("#modal-aggregate").modal({ backdrop: "static", keyboard: false });
	      });
	    },
	    modalTollTicket: function modalTollTicket() {
	      this.contractShipper.moveMaisId = this.currentUser.moveMaisId;
	      this.showModalTollTicket = true;
	      this.$nextTick(function () {
	        $("#modal-toll-ticket").modal();
	      });
	    },
	    modalPrintVp: function modalPrintVp(vp) {
	      this.vpSelected = vp;
	      this.showPrintVp = true;
	      this.$nextTick(function () {
	        $("#modal-print-vp").modal();
	      });
	    },
	    modalRouteVp: function modalRouteVp(contractId, idVP) {
	      this.vpData = {
	        contractId: contractId,
	        idVP: idVP
	      };
	      this.showRouteVp = true;
	      this.$nextTick(function () {
	        $("#modal-route-vp").modal();
	      });
	    },
	    modalBlock: function modalBlock(value) {
	      this.showBlock = true;
	      this.vpSelected = value;
	      this.vpSelected.moveMaisId = this.currentUser.moveMaisId;
	      this.$nextTick(function () {
	        $("#modal-block-vehicle").modal();
	      });
	    },
	    modalReceiptVp: function modalReceiptVp(contractId, idVP) {
	      this.vpData = {
	        contractId: contractId,
	        idVP: idVP
	      };
	      this.showReceiptVp = true;
	      this.$nextTick(function () {
	        $("#modal-receipt-vp").modal();
	      });
	    },
	    close: function close(filter) {
	      switch (filter.modal) {
	        case "toll-ticket":
	          this.showModalTollTicket = false;
	          this.doFilter(true);
	          break;
	        case "rescue-balance":
	          this.showRescue = false;
	          this.doFilter(true);
	          break;
	        case "route-vp":
	          this.showRouteVp = false;
	          this.vpData = undefined;
	          break;
	        case "print-vp":
	          this.showPrintVp = false;
	          break;
	        case "aggregate":
	          this.showModalAggregate = false;
	          this.doFilter(true);
	          break;
	        case "receipt-vp":
	          this.showReceiptVp = false;
	          this.vpData = undefined;
	          break;
	        case "block-vehicle":
	          this.showBlock = false;
	          this.vpSelected = undefined;
	          this.type = undefined;
	          if (filter.state == "ok") {
	            this.doFilter(true);
	          }
	          break;
	      }
	
	      this.$nextTick(function () {
	        $("#modal-" + filter.modal).modal("hide");
	      });
	    },
	    setCurrentPageVpPre: function setCurrentPageVpPre(p) {
	      this.pageSmVpPre = this.pageSmVpPre.page(p);
	      this.doFilterVpPre();
	    },
	    setCurrentPageVpPos: function setCurrentPageVpPos(p) {
	      this.pageSmVpPos = this.pageSmVpPos.page(p);
	      this.doFilterVpPos();
	    },
	    setCurrentPage: function setCurrentPage(p) {
	      this.pageSm = this.pageSm.page(p);
	      this.doFilter();
	    },
	    setPageSize: function setPageSize(size) {
	      this.pageSm = this.pageSm.size(size);
	      this.doFilter();
	    },
	    showUnblock: function showUnblock(vehicle) {
	      if (vehicle.reasonId == 8) return true;
	
	      return false;
	    },
	    doFilter: function doFilter(clearCache) {
	      var _this10 = this;
	
	      if (this.contractIdAggregate) {
	        var filterVP = {
	          contractIdAgr: this.contractIdAggregate,
	          page: this.pageSm.build()
	        };
	
	        if (clearCache) {
	          this.aggregateVehicles = {};
	          filterVP.page = 1;
	          this.pageSm = filterVP.page = this.pageSm.page(1);
	        }
	
	        if (filterVP) {
	          this.loadingVehiclesAggregate = true;
	          _vehicles2.default.getVehiclesAggregate(filterVP).then(function (data) {
	            _this10.aggregateVehicles = data.itens;
	            _.forEach(_this10.aggregateVehicles, function (o) {
	              _this10.$set(o, "open", false);
	            });
	
	            if (data.total && _this10.aggregateVehicles.length > 0) {
	              _this10.searchState = "FOUND";
	              _this10.pageSm = _this10.pageSm.itemCount(data.total);
	            } else {
	              _this10.searchState = "NOTFOUND";
	            }
	          }).catch(function (err) {
	            _this10.searchState = "NOTFOUND";
	          }).finally(function () {
	            _this10.loadingVehiclesAggregate = false;
	          });
	        }
	      }
	    },
	    doFilterVpPre: function doFilterVpPre(clearCache) {
	      var _this11 = this;
	
	      var filterVP = {
	        contratoOrig: this.contractIdVpPre,
	        page: this.pageSmVpPre.build()
	      };
	
	      if (clearCache) {
	        this.embarcadorVpPre = {};
	        filterVP.page = 1;
	        this.pageSmVpPre = filterVP.page = this.pageSmVpPre.page(1);
	      }
	      _toll2.default.getFilterLimited(filterVP).then(function (data) {
	        _this11.embarcadorVpPre = data.itens;
	
	        if (data.total && _this11.embarcadorVpPre.length > 0) {
	          _this11.searchState = "FOUND";
	          _this11.pageSmVpPre = _this11.pageSmVpPre.itemCount(data.total);
	        } else {
	          _this11.searchState = "NOTFOUND";
	        }
	      }).catch(function (err) {
	        _this11.searchState = "NOTFOUND";
	      });
	    },
	    doFilterVpPos: function doFilterVpPos(clearCache) {
	      var _this12 = this;
	
	      var filterVP = {
	        contratoOrig: this.contractIdVpPos,
	        page: this.pageSmVpPos.build()
	      };
	
	      if (clearCache) {
	        this.embarcadorVpPos = {};
	        filterVP.page = 1;
	        this.pageSmVpPos = filterVP.page = this.pageSmVpPos.page(1);
	      }
	      _toll2.default.getFilterLimited(filterVP).then(function (data) {
	        _this12.embarcadorVpPos = data.itens;
	
	        if (data.total && _this12.embarcadorVpPos.length > 0) {
	          _this12.searchState = "FOUND";
	          _this12.pageSmVpPos = _this12.pageSmVpPos.itemCount(data.total);
	        } else {
	          _this12.searchState = "NOTFOUND";
	        }
	      }).catch(function (err) {
	        _this12.searchState = "NOTFOUND";
	      });
	    },
	    getMessage: function getMessage() {
	      var _this13 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _message2.default.getMessage(_message.Message.type.BLOQUEADO_PARCIALMENTE);
	
	              case 2:
	                data = _context.sent;
	
	                _this13.partialBlockedMessage = data.message;
	
	              case 4:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, _this13);
	      }))();
	    },
	    getTooltipText: function getTooltipText(contract) {
	      if (Number(contract.isEntryBlocked) === 999) return this.partialBlockedMessage;
	    },
	    confirmCard: function confirmCard() {
	      var _this14 = this;
	
	      var valor = this.valorDebitado.replace(/[^0-9]*/g, "");
	      if (valor == 100) {
	        return _messageDialog2.default.show({
	          title: "Info",
	          headerClass: "modal-info",
	          message: "Valor cobrado deve ser entre 1,01 e 1,99"
	        }).then(function (r) {
	          _this14.valorDebitado = null;
	          $("#valor-debitado").modal();
	        });
	      }
	      if (this.valorDebitado) {
	        _messageDialog2.default.show({
	          title: "Info",
	          headerClass: "modal-info",
	          type: "YES-NO",
	          message: "Tem certeza que o valor debitado foi " + this.valorDebitado + "?"
	        }).then(function (e) {
	          if (e == "YES") {
	            var req = {
	              chargeValue: valor,
	              contractPaymentMethodId: _this14.cobrarDebito[0].contractPaymentMethodId
	            };
	            _sales2.default.checkChargeValue(req).then(function (resp) {
	              var validaValor = resp.code;
	              if (validaValor == 0) {
	                $("#contrato-ativado").modal();
	              }
	              if (_this14.cobrarDebito[0]) {
	                _this14.numeroCartao = _this14.cobrarDebito[0].number;
	              }
	              _this14.cobrarDebito.shift();
	              _this14.valorDebitado = null;
	              if (_this14.cobrarDebito.length > 0) {
	                $("#valor-debitado").modal();
	              }
	            }).catch(function (erro) {
	              var error = erro.data.status.code;
	              var salesOrder = erro.data.salesOrder;
	              if (error == 1) {
	                if (_this14.primeiroCartao) {
	                  _this14.erroDebito = 2;
	                  $("#info-block").modal("hide");
	                } else {
	                  _this14.erroDebito = 1;
	                  if (salesOrder.salesOrderId) {
	                    _this14.msgErro = "Valor informado incorreto, pedido " + salesOrder.salesOrderId + " será cancelado.";
	                  } else _this14.msgErro = "Valor informado incorreto, cartão cadastrado cancelado.";
	                }
	              } else if (error == 2) {
	                if (_this14.primeiroCartao) {
	                  _this14.erroDebito = 1;
	                  _this14.msgErro = "O prazo de validação do cartão expirou. Favor realizar um novo cadastro.";
	                  $("#info-block").modal("hide");
	                } else {
	                  _this14.erroDebito = 1;
	                  _this14.msgErro = "O prazo de validação do cartão expirou. Favor realizar um novo cadastro.";
	                }
	              } else if (error == 3) {
	                _this14.erroDebito = 1;
	                _this14.msgErro = "O prazo de validação do cartão expirou. Favor realizar um novo pedido.";
	              } else {
	                _this14.erroDebito = 1;
	                if (erro.data.status.message) {
	                  _this14.msgErro = erro.data.status.message;
	                } else _this14.msgErro = "Erro ao validar, favor entrar em contato com a CR!";
	              }
	              $("#erro-debito").modal();
	            });
	          } else $("#valor-debitado").modal();
	        });
	      } else {
	        _messageDialog2.default.show({
	          title: "Info",
	          headerClass: "modal-info",
	          message: "Por favor digite um valor numerico valido"
	        }).then(function (r) {
	          _this14.valorDebitado = null;
	          $("#valor-debitado").modal();
	        });
	      }
	    },
	    confirmaErro: function confirmaErro() {
	      var _this15 = this;
	
	      if (this.erroDebito == 2) {
	        _auth2.default.logout().then(function () {
	          return _this15.$router.push("/login");
	        });
	      }
	      this.erroDebito = 0;
	    }
	  }),
	
	  components: {
	    Accordion: _accordion2.default,
	    ContractName: _contractName2.default,
	    ModalRecharge: _modalChangeAutomaticValue2.default,
	    ModalAutomatic: _modalAutomaticValue2.default,
	    modalTransfer: _modalTransfer2.default,
	    PaginationSm: _paginationSm2.default,
	    ModalAggregate: _modalAggregateRegister2.default,
	    ModalTollTicket: _modalTollTicket2.default,
	    ModalRescueBalance: _modalRescueBalance2.default,
	    ModalPrintVp: _modalPrintVp2.default,
	    ModalBlockVehicle: _modalBlockVehicle2.default,
	    ModalRouteVp: _modalRouteVp2.default,
	    ModalReceiptVp: _modalReceiptVp2.default,
	    modalMyContracts: _modalMyContracts2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _set = __webpack_require__(245);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _googleMaps = __webpack_require__(93);
	
	var _googleMaps2 = _interopRequireDefault(_googleMaps);
	
	var _turf = __webpack_require__(223);
	
	var _turf2 = _interopRequireDefault(_turf);
	
	var _pointToLineDistance = __webpack_require__(166);
	
	var _pointToLineDistance2 = _interopRequireDefault(_pointToLineDistance);
	
	var _simplifyJs = __webpack_require__(146);
	
	var _simplifyJs2 = _interopRequireDefault(_simplifyJs);
	
	var _toll = __webpack_require__(26);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	var _route = __webpack_require__(59);
	
	var _route2 = _interopRequireDefault(_route);
	
	var _number = __webpack_require__(24);
	
	var _inputGoogleAc = __webpack_require__(1938);
	
	var _inputGoogleAc2 = _interopRequireDefault(_inputGoogleAc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      google: undefined,
	      map: undefined,
	      markers: [],
	      axes: 1,
	      directionsService: undefined,
	      locationPoints: [{ sequence: 1, type: 'origin' }, { sequence: 2, type: 'destination' }],
	      viaPoints: [],
	      qtdWayPoints: 0,
	      msgError: undefined,
	      loading: undefined,
	      distance: undefined,
	      qtdTolls: undefined,
	      valueTolls: undefined,
	      showSummary: false,
	      coord: undefined,
	      all: undefined,
	      duration: undefined,
	      result: { start: undefined, end: undefined, wayPoints: undefined, tolls: undefined,
	        totalDistance: undefined, totalTime: undefined, totaltollFeeCost: undefined, allCovered: undefined },
	      image: undefined,
	      geocoder: undefined,
	      restriction: undefined,
	      teste: { a: "asdasd" }
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    $('[data-toggle="tooltip"]').tooltip();
	    var vm = this;
	    var mapPromise = vm.initMap();
	
	    var tollsPromise = _toll2.default.getTolls().then(function (r) {
	
	      _this.all = r;
	      _this.tollsLoaded = true;
	    });
	
	    var promise = _promise2.default.all([mapPromise, tollsPromise]).then(function (result) {
	      vm.afterInit();
	    }).catch(function (err) {});
	    this.$store.dispatch('loading', promise);
	  },
	
	
	  watch: {},
	
	  methods: {
	    initMap: function initMap() {
	      var vm = this;
	      var promise = new _promise2.default(function (resolve, reject) {
	        _googleMaps2.default.KEY = 'AIzaSyAzAwCX1zCJ9idWkNdxs39j36N4lAToIjE';
	        _googleMaps2.default.LIBRARIES = ['places'];
	        _googleMaps2.default.load(function (google) {
	          vm.google = google;
	          vm.map = new google.maps.Map(document.getElementById('map'), {
	            zoom: 4,
	            center: { "lat": -21.009377008304, "lng": -48.17694799974561 }
	          });
	
	          vm.directionsDisplay = new google.maps.DirectionsRenderer({
	            draggable: true,
	            suppressMarkers: true
	          });
	          vm.directionsDisplay.setMap(vm.map);
	
	          vm.directionsService = new google.maps.DirectionsService();
	
	          vm.directionsDisplay.addListener("directions_changed", function () {
	            vm.updateNewDirections();
	          });
	
	          vm.restriction = new google.maps.LatLngBounds(new google.maps.LatLng(-57.325707, -89.222613), new google.maps.LatLng(18.480298, -33.537955));
	
	          resolve(true);
	        });
	      });
	      return promise;
	    },
	    afterInit: function afterInit() {},
	    afterUpdateDirections: function afterUpdateDirections() {},
	    placeToPointLocation: function placeToPointLocation(place, sequence, type) {
	      var p = {
	        type: type,
	        sequence: sequence
	      };
	      _.each(place.address_components, function (o) {
	        if (_.indexOf(o.types, 'postal_code') >= 0) p.zipCode = o.short_name.replace(/[^0-9]/g, '');else if (_.indexOf(o.types, 'administrative_area_level_1') >= 0) p.state = o.short_name;else if (_.indexOf(o.types, 'administrative_area_level_2') >= 0) p.city = o.short_name;else if (_.indexOf(o.types, 'sublocality') >= 0) p.neighborhood = o.short_name;else if (_.indexOf(o.types, 'route') >= 0) p.address = o.short_name;else if (_.indexOf(o.types, 'street_number') >= 0) p.number = o.short_name;else if (_.indexOf(o.types, 'country') >= 0) p.country = o.short_name;
	      });
	      try {
	        p.address = place.formatted_address;
	        p.lat = place.geometry.location.lat();
	        p.lng = place.geometry.location.lng();
	      } catch (err) {}
	      return p;
	    },
	    plotar: function plotar() {
	      var pos = this.coord.trim().split(",");
	      var marker = new google.maps.Marker({
	        position: { lat: parseFloat(pos[0]), lng: parseFloat(pos[1]) },
	        icon: '/static/pins/pin-origin.png',
	        map: this.map
	      });
	
	      var contentString = this.coord;
	
	      var infowindow = new google.maps.InfoWindow({
	        content: this.coord
	      });
	
	      marker.addListener('click', function () {
	        infowindow.open(this.map, marker);
	      });
	
	      this.markers.push(marker);
	    },
	    initAutoCompletes: function initAutoCompletes() {
	
	      var options = {
	        strictBounds: true,
	        bounds: this.restriction
	      };
	
	      this.originAc = new google.maps.places.Autocomplete(document.getElementById('origin'), options);
	      this.destinationAc = new google.maps.places.Autocomplete(document.getElementById('destination'), options);
	      var vm = this;
	      google.maps.event.addListener(this.originAc, 'place_changed', function () {});
	    },
	    putPin: function putPin(tolls) {
	      var _this2 = this;
	
	      _.each(tolls, function (o) {
	
	        var marker = new google.maps.Marker({
	          icon: o.id > 0 ? '/static/pins/pin-toll.png' : '/static/pins/pin-toll-inactive.png',
	          position: o,
	          map: _this2.map
	        });
	
	        var content = '';
	        if (o.id < 0) content += '<div class="box-toll-map"><h4 class="title-toll">' + o.description + '</h4><span class="text-toll-inactive">Ped\xE1gio n\xE3o atendido pela Move Mais.</span></div>';else content += '<div class="box-toll-map"><h4 class="title-toll">' + o.description + '</h4><span class="text-toll">Valor do Ped\xE1gio: </span><span class="text-toll-value">' + (0, _number.cents)(o.price) + '</span></div>';
	
	        var infowindow = new google.maps.InfoWindow({
	          content: content
	        });
	
	        marker.addListener('click', function () {
	          infowindow.open(this.map, marker);
	        });
	
	        _this2.markers.push(marker);
	      });
	    },
	    setRouteMarkers: function setRouteMarkers(direction) {
	      var _this3 = this;
	
	      var legs = direction.routes[0].legs;
	
	      var start = legs[0].start_location;
	      var marker = new this.google.maps.Marker({
	        position: start,
	        icon: '/static/pins/pin-origin.png',
	        map: this.map
	      });
	      this.markers.push(marker);
	      this.result.start = start;
	
	      var end = legs[legs.length - 1].end_location;
	      marker = new this.google.maps.Marker({
	        position: end,
	        icon: '/static/pins/pin-destination.png',
	        map: this.map,
	        zIndex: 999,
	        optimized: false
	      });
	      this.markers.push(marker);
	      this.result.end = end;
	
	      this.result.wayPoints = [];
	
	      var _loop = function _loop() {
	
	        var wayPoint = legs[i].start_location;
	
	        _this3.result.wayPoints.push(wayPoint);
	        var marker2 = new _this3.google.maps.Marker({
	          position: wayPoint,
	          icon: '/static/pins/pin-waypoint.png',
	          map: _this3.map
	        });
	
	        var infowindow = new google.maps.InfoWindow({
	          content: '<div>' + legs[i].start_address + '</div>'
	        });
	
	        marker2.addListener('click', function () {
	          infowindow.open(this.map, marker2);
	        });
	
	        _this3.markers.push(marker2);
	      };
	
	      for (var i = 1; i < legs.length; i++) {
	        _loop();
	      }
	    },
	    updateNewDirections: function updateNewDirections() {
	      var vm = this;
	      this.loading = new _promise2.default(function (resolve, reject) {
	        vm.reset();
	
	        if (vm.directionsDisplay.getDirections()) {}
	        var tolls = vm.discoveryTolls(vm.directionsDisplay.getDirections());
	
	        return _toll2.default.getPriceTolls({ tolls: tolls.tolls, axes: vm.axes }).then(function (r) {
	          tolls.tolls = r.tolls;
	          vm.putPin(tolls.tolls);
	          vm.result.tolls = tolls.tolls;
	          vm.result.totaltollFeeCost = r.totalValue;
	          vm.result.totalDistance = Math.round(tolls.totalRoute / 1000);
	          vm.result.totalTime = tolls.totalDuration;
	          vm.result.allCovered = r.allCovered;
	          vm.setRouteMarkers(vm.directionsDisplay.getDirections());
	          vm.showSummary = true;
	          vm.afterUpdateDirections();
	          resolve(true);
	        });
	      }).catch(function (err) {});
	    },
	    cleanMarkers: function cleanMarkers() {
	      for (var i = 0; i < this.markers.length; i++) {
	        this.markers[i].setMap(null);
	      }
	      this.markers = [];
	    },
	    reset: function reset() {
	      this.cleanMarkers();
	    },
	    calculate: function calculate() {
	      var _this4 = this;
	
	      var vm = this;
	      this.msgError = '';
	      var promises = [];
	      if (this.$refs.ac) {
	        this.$refs.ac.forEach(function (o) {
	          promises.push(o.validate());
	        });
	      }
	      return _promise2.default.all(promises).then(function (res) {
	
	        vm.msgError = undefined;
	        vm.loading = new _promise2.default(function (resolve, reject) {});
	        var origin = vm.locationPoints[0].address;
	        var destination = vm.locationPoints[vm.locationPoints.length - 1].address;
	
	        var req = {
	          origin: origin,
	          destination: destination,
	          travelMode: vm.google.maps.TravelMode.DRIVING
	        };
	
	        if (vm.locationPoints.length > 2) {
	          req.waypoints = [];
	          for (var i = 1; i < vm.locationPoints.length - 1; i++) {
	            req.waypoints.push({ location: vm.locationPoints[i].address });
	          }
	        }
	
	        for (var i = 0; i < vm.viaPoints.length; i++) {
	          if (!req.waypoints) req.waypoints = [];
	
	          var c = vm.viaPoints[i].address.split(",");
	
	          var latlng = new google.maps.LatLng({ lat: parseFloat(c[0]), lng: parseFloat(c[1]) });
	          req.waypoints.push({ location: latlng, stopover: false });
	        }
	
	        vm.directionsService.route(req, function (result, status) {
	
	          if (status === vm.google.maps.DirectionsStatus.OK) {
	            if (origin != destination || vm.locationPoints.length > 2) {
	              vm.directionsDisplay.setDirections(result);
	            } else {
	              vm.msgError = "Não foi possível calcular a rota, pois a origem e o destino são iguais.";
	              vm.loading = _promise2.default.reject(false);
	            }
	          } else {
	            vm.msgError = "Não foi possível calcular a rota, tente especificar melhor a origem, o destino e os pontos de passagem (se existirem).";
	            vm.loading = _promise2.default.reject(false);
	          }
	        });
	      }).catch(function (err) {
	        _this4.msgError = 'Por favor verifique os endereços';
	      });
	    },
	    showSavedRoute: function showSavedRoute(points) {
	      var vm = this;
	      var p1 = '|x}cC|{`eHDZb@dDHh@N~AN~AJ`BL~A??x@[v@]??d@~@b@~@j@jAj@hAl@nAn@lA??|@i@~@k@hBcAfAk@BA|Co@jCi@jCi@tCm@tCm@lAWjAYlAYfB[VEVEZK\\If@Kf@IDAvCm@d@Kr@O~A]|A_@r@OrCo@~@QjB_@~A]rAYrD{@p@Mr@MjDs@l@KvCo@dDs@pDw@fBa@dBc@??QyAS{A??vB^`BXf@FVBJDLD^RJDB@HDH@J@H?H?HANCDALALAL?L@L@L@zATn@H`@D`@DhAJ`CT`CRbCRRBRDPFRFNH??@@@@@@@@@@@@@?@@@@@?B@D@B?B?B?D?BAB?BA@A@??A@?@Ad@Ar@BvN~AzAXl@LPBNFPDNHLHLJLJ@@HJJLHNFNLR??Jh@^h@HLHHHJBBPNNHPJJDNBLBF@H@FBL@F?L?LCLCNEJELKLKJKJMHMHMHOTc@Zi@LQHOV_@HKFMDMDMB]?UPeALi@FSHUf@eAt@wA~@kBxAwCP[DIp@qAdA_BNWDG?A?CBQ??vAwB~BsDh@}@jDmFbDcFlB_DvAcC~CaFfC}D|BoDdEqGzF_JtFsI~BsDjCcEtAyBfEsG~DcGT[z@sAb@u@FKvD{FlAgBT_@Va@HMJQ@ANUfAcBZe@|AcCrB}CjAmB~BoDnCiE~DiGT_@dDgFfAcBrFqJd@y@dCkErA{BtGoK`HiKlAgBpCkEhAgBzAaCn`@mm@xEqHtSu[x@oAt@iAhAeBrAwBhAeBv@mAR]`@m@v@kAx@mAhDkFPWPWbC}DvCsE~K}PnW_a@bAaB`A{AtAuB\\i@`BgCj@{@tFuIPYT]zAiCRa@\\w@Xw@Tq@Pk@Lg@Je@Jg@Ji@N}@LcAD]B_@J{@JiAVsCHcADk@Hu@Ho@Hi@F[FYNw@J]J]Vu@Zu@P_@N[NYLSj@_AbAoAj@k@JKPQr@k@l@c@ZS|AgAJIJIxCyB~@q@b@]`@_@j@e@BAn@o@Z[j@o@X]d@o@PSV]Xa@Ze@`@m@zIeNbOeUrCsEbn@_`A~BoDbBkC|@sAHM@AFKfBoC|CwEjIkMnDsFz@sAvCuEfGiJjFgIjf@mu@pCcEFI|A}BNWfBqCVc@T]nCgExCuEhDkFpDwFbCuDzDaGxCuEtCoEbCuDdC}DdCuDfC{DlBuC~BsD|A_CxBkDpCiEjCaEzBiD`DcFjAgB|@uAbCuDfC{DfDkFrCkE|CyE|C{EtCmEzCyEvD}FhDiFpCgEpDuFdCwDpCmEbCuD|AeCj@{@rAoBj@}@zBkD@AJQJOzBoDl@{@z@sA~BmDb@q@fBoCvCsE@Cl@_A|@sAn@{@bLkQpAoBhBuCfC}DnB}CrAsBrAuBJM?AHMLQxBgDbBgClGqJjDuF`BcCxN{TxA_C|@uAvD{FxAyBdBoC~DiGzBkDbCeEzA}CtAeDv@iCp@_Ch@sBH[\\}AHg@RaA\\{An@sCR{@DO`@kBfAqF`AqElDePhAgFTeA~Lkk@tB{JjKqf@hK{e@|Ksh@l@}CjAoFt@mDLi@?ADSDU|BwKF[BMViAb@mBxJqd@tAoGLi@fCsLnHy\\pFoW~@gE`Lsh@d@yBxBaKnBoJJa@J_@VqAPu@DQb@uBXoArAaGpAuGHUFUZyAHe@Lo@Nw@Nw@hBuH|AwHz@eE`BeI^{AV{ALm@ZuAf@{B~@wDNm@Nm@Ja@F[^sAf@yAb@gAZw@Rg@R_@v@}AVa@Zg@@EzA_CXa@xC_EzB}C|@kAz@gADIn@y@h@u@dAwARU@CNShA_BlAgBb@e@`AuArCyDp@}@`@k@pDqEhCmD\\g@`AmATYj@u@V]h@u@fA{AlD{EDGFI|F{H~AyBLOvDeF@AbBwBjAcBrCyDBCjA_B|ByCT[b@k@n@s@n@i@RSTS^[pAcAz@m@xAw@j@Yt@_@^Ml@WlAa@hA[|Co@nAOvAOdBK~@CF?F?pAA^?nA@z@BN@bBP`CTB@bEd@fD^|APj@H`AJpD^zBRdCX`BPdBRlLjA`Hr@|@HfCXbJ|@fFl@`CVlC\\NB~C^v@Lx@HF@F?t@HtARxANjCXVDD?NBjD^jCVpO`B`AJrFf@vAHj@BZ?Z?f@AZ?\\CXA^E\\Ej@In@Kd@I`@I^Ml@SZMj@WhB_AhJgFxJqFhTsLr_@ySdP}IzHkEnIwE`CqAzSaLhAw@\\YVMzGwDTKPKhBcAZQ~JsFVO@?PK~@i@NI|BmAzA{@`E{BxZwPrAs@xBwAzGcEnFeDtCcBjAq@jEaClDmB`DgBhE_CRKnAs@nAs@tJmFrBiAhCwAnGmD|@a@|@i@x@g@|@e@xDwBpMiHpGmDjNyHxF}CpGoD`FmCrKaG|L{GxCcBnC{AtDsBfDiB~EmCbImEhAo@hAo@~EiC`@WDCh@[lGkDXQ|DuB@?nBiArC_BhCwArPgJrDoBFCf@Wj@[hAo@|Aw@bB{@pCcBhAq@`@Wj@Yv@e@f@Yl@]`By@rF{Cp@_@fNwH`B}@`CsAbDeBlEcCz@g@rCyA|CgB~CeB|FaDhBaA`Ai@rAo@|@_@nAe@xAg@xEcB~NcFtEaBhA_@~NeFzBw@hGsBvE_BjDoA~FsBjAa@rMqEhBo@zP_GjBq@nGyBvCcAxAg@vG{BzDuAPG~EcB^O@?h@QzBw@pBq@zDuAzBw@jGwBlHgClC}@|CgAvE_BhFiBhIqChIoC~Ak@vAe@hBo@nI{Cr@WrHiCxAi@nAc@r@WzNaFrDqArDqAdIqCbPuF`DiApC_ApAg@rAc@pFkBbA_@lC_AfA_@tAe@~HqCfBm@dA[vAa@~Cy@bEgAxC}@\\KpNcFzAi@pGyBZMnIuC~FqBnBu@j@Wp@[f@WfAm@bAq@j@_@lAaABCxAwA`AiAd@o@Za@RYb@o@d@{@f@_Ah@oANYRi@j@}AtA_Ej@aBdHiShHsSdHwShBeFjBgFzQii@|AqEb@qAfCsHtB}FfA_DrPcf@tScm@fCmHnEoMpCgIrCcIvCmIdCmHlBsFjAcDb@uAb@kAP_@Vi@^s@z@{AjBoCHOh@o@FI`AeAh@m@h@i@jAcAr@k@bBoA|@k@PKBAJGvAu@z@a@bAc@fAa@NEvAc@`B_@~@UpB]bC[hBOfBGzAAzA?dA@`AD`DJ`DJbl@rBnGTtCJzBJhFRx@?`@Ar@C`AOr@S|@a@`@SXQZUj@g@`DqCrGuFh@a@~AuA\\_@\\a@?APSNYPc@Pm@RgANs@Lq@F]H[J_@J[N_@Ta@PYRWRWRSNOXSXSh@[JEb@Qv@Yj@U\\M\\S\\YZ]T_@Xm@Ne@Ro@D]DYHaADWNs@Ja@Rg@d@cAFOXg@Zs@Rg@Na@?AJe@Ns@Dk@FaA?aACm@Ck@OaAc@mBoAyDGYG]Ga@Cg@?i@DcAJ_ArAoJt@gDLa@\\y@Ra@Te@Ze@TYz@{@bBkAr@e@dDsBlXiQdAq@XQDERKbAs@lBmApCiBt@e@nBoAr@_@LG|@]j@Qj@On@KvAQzD]zBQxBSzAKv@K|@Od@Mj@Qv@Yf@Up@]n@_@nC_BbGoDhO}I~FoDhCyAxCeBlAo@r@Yt@W\\KREf@O~H}AtEaA~LaCdGmA|@SRG^KHAb@SXM\\OTM\\S~@m@VUj@e@PQRSRURWv@eA\\m@Zm@LWPe@JYL]\\uALm@ReAF]H[La@Xw@LWHSTa@PYNURWPUTWTS\\Yp@g@`F}CTOf@Y|FsDpAw@ZOxA}@bTmMp@UZIzAWnBKrBFrDh@|BTRBdA@L@hACjC]ZI`@MpAk@rDcBfK_Fl@WpN}GdGuCdDyAlAa@NENGnCq@PEPEPCPEDAJCRCPCPCPCRAPCPAPARAP?RAP?PAjDGfK\\pKp@|@DzDRxC?dCUnBUfCs@tBw@bCqAd@[|AaAjEuCpDiCpEuCpCoBbCkB|AeAnA_Ar@m@~@cAb@c@dAgAdA_BP[z@_BjAeCTg@`@y@tD_IvD}HvAyCxA_DpD{HpBaEpAeC|AmCpAqBnA{A|AmBjBaCnKsLfEyEvQiSjHeI|AiBhCuCdAkAl@o@b@e@^c@f@i@l@o@|DgEVWLSLK@C`@g@TY`@e@p@{@jHcIjHcIdAkA|AeB|FsGd@c@lC}CDElBuBTW@?TYxCgD|@_AjD{DPQnDeEtDeE|EmF@CjE_FjE{ElE}Et@y@p@u@p@u@dEwEjF{FzEsEpE{DHIdA}@r@k@rAgATS^]LI@AVUHGl@g@^[|@u@hEkDXWj@e@p@i@p@k@ZYNMn@i@NMpJ{HdA}@z@s@TSHIFGpDyCd@_@`Aw@v@q@fA}@|@u@VSh@c@@Aj@c@tAmABCj@e@h@e@x@q@b@]j@g@ZW|@q@|@w@vBcBnAiAd@_@tAiAlB{A|@s@z@s@~@}@vFoE`G}EjBwAx@o@nA}@nBwAxA}@v@e@dAm@f@Y|@e@PKj@[z@a@l@Yp@[VKXIFCf@Wd@UjAe@\\OJEZOZKLGXKRKj@STMd@QXIHE`DsAlCgAnGmCtH{CpF}BVKdOiGrFyBrAi@pDyANGNGp@[`@O`@Q`@Q~Ao@hFuB`Aa@xAk@VMpBy@pD}AdCiA~BmArCsALG~@k@|IgFvA{@|B{AtByAxDoC@AxC}BzBiBXUfCsB`DsCvBoB`B_BdAeAhFsFhAqAdCsC`@g@b@i@pAaBpAcBrBoCbFkHrBwC|@wAz@wAz@wAx@yABEz@aBx@_Bx@aBv@aBVk@p@uAn@wABGvC{GRa@P]Na@@CL]Ti@N]HQ`@iA^iA^iA^iAvAqEn@qBh@gBh@gBnBgHt@yCz@oDf@_CZwAZqAh@oCTqANq@RaBLqAFy@F{@D{@Bs@?G?K?{B@g@?gA?qB?sBAsB?i@@{B?cHDwBLwB?ADcALiBNsBLkAZgC`@mCd@eCh@cCTaA~@gDb@uATw@Z}@`@uAp@oBBClEoNv@eCzDqLjAwDpDcLnBkGp@qBDO@CDKfBsFt@{BbA_DhByFj@eBFQFS@EdDgKfAoDfAiDp@cCb@mBjAoFx@sDjAiGzBgLd@sBnA_HpAiG~@yEf@cCXsAVyAt@uD|@kE|AeIz@cEpAmGJg@^iB@Gv@}D|@oEz@kE~Gk]Nk@Ls@vB{KtBkKr@sDzAiHHa@|AyH`A{EVsApAyGLk@d@_CF[Hg@FSBU|@iEJc@BKl@yCrCyNt@qDnCoNH_@H]Ls@rE_Ub@yB`D}NtDwRxE}Ur@mDr@sD`AsEfDcQvD{R|CiODQFWDYPy@H[v@eE~A_Il@aDp@gDjJge@lCyMbEqSdAyF@E@EZaBl@mCdIca@??`AmDRe@R]p@cAnAkAxE{Dr@e@n@[@An@Wr@Wh@MJEHGJE??tA]hA]zAe@bCq@f@MPEDAz@MTGTEp@OPEbAQRCj@Kj@Ip@Qx@S@?h@Qv@WDChAe@~Aw@zAu@PKn@]j@YRKXMp@Yj@W\\OZMbBo@RItCaAz@YdCw@f@O`@MhA[hA[z@UbAUrAYvA]r@Mp@Op@QrA_@rA_@p@Sr@Up@WnAe@nAi@|@a@|@a@h@Uh@Wf@Y`@WlAs@zA_Ab@WxCcBHEvBsAt@g@DC`@W`@WJGTO`Ak@tBsAzA}@nBmAxA}@zCkBrCcBzBsADE`CuANI~@k@`B}@JIh@_@l@a@j@]d@Y~@m@h@[|@m@~@k@vA}@jAs@z@i@XOl@_@dAo@`@Qn@_@bBcArCgB`CwAxA}@|CiBlCaBjDqBzEuCPOnDuBf@]^Wn@c@dBkArA{@|AcAd@]dAo@^URKd@Yd@WZUxDwBnC_BPK`BeAxA}@xA}@bDsBfCyA`@YdBeAtD_CpCaBXQ`@Y~@i@~FmDd@[vFmDlBeAl@[RKRKDA`CeAv@]TGfAa@r@SfA_@x@QzA]jCi@j@Kr@KnAOfAKhCUbBKh@Cj@Cr@AdAAX?rAA~AB\\@p@@`Sp@rI`@r\\bAxRt@j@Bx@@t@BfW|@tCJh@BhDJxAFlDL~CJtAFbDHtB?tCKb@CPAPArAMp@Iv@MhCe@bD}@tDcAjCs@tXuHtLeD~EsAhCu@dEkAdCs@jEmAvAc@bAYfA[|@W~@Y\\O^MjAm@n@_@l@c@j@g@`@]@Ab@c@b@c@bAwAz@_BXm@^{@pHmQl@kAP[b@s@n@eAp@cAr@_ABAt@y@v@{@x@y@tDmDLKj@g@JI@AHG`@a@j@k@n@o@n@m@\\[vAoAnAgAjAiAxJ}IpIyH`GqFvCmCxUoTrNwMpIcIxH_H|CgCx@w@tCaC|EqEdK_I|CeClIoGJGHEHGLIv@g@t@_@VMnAg@l@Sl@Qp@QxA[rEaAz@QjMmCvEgAzAYdD{@pGaBhDaApFcBNEbFyAdBk@`GsBvKuEzAo@|Ao@rAk@pAk@rAi@nF}BxCkArCkAhFiCdCyAdCyAbC}AxTyMTOPKtPeKzFkDp@a@f@Yd@Sz@a@z@[`A[`AYv@S|@QbAQ|@Mn@G`AGhBIhEG~CC|NQvLQbBApEHj@@pBDv@@tEHj[~@b@@X?j@Ap@Ah@A\\A~@I`AGv@Il@Id@Ip@Ol@Kh@Mn@Qp@Sh@Qt@Yf@Uj@UnBgArAy@fF{DzCaCbFyDbBuArBaBj@e@|EyDhEeD|CcChBwApB}AfBwAjBuAnAcAbAy@pAaAlB{AtAeAt@m@p@g@r@k@t@i@`Aq@bAo@lAs@lAq@nAo@jAg@z@_@`Bq@fBo@|Bu@x@U|Cw@zG}ADArAYrIgBxH_BpCm@hE_AlIeBjBa@dDq@rBc@hCk@zFkAv@Mv@ONEFA@?VGf@MFARGXIBA|By@tAm@tBgAt@i@nCsBJGPQ@AHIHIHGHIRSRSHKRSLMDEPUNSPUPUNSPWFIFKLQ@CNUT_@HMHOLSFMNWLYNYDKLYLYJYLYJ[DKTo@dAwClAkD`@iAv@wBN_@Ri@tAsDnSej@vAwD~BoGpAaDh@kAn@mARa@dB}CrCeE`@i@jAuAbAiAnCyCvAyA`CeCxB_CnLeMzEcFfEoEz@_AjAoAlBuB`AeA`BeBfBkB~@}@lCsChAgAd@k@NO`@c@`@c@DEDGLKBCNOPSd@i@pD{DFILI|HoIfGqGXYpBuBxAcBpAuAv@w@PQHIHIFGHIbAcA`HsHhDwDrAuAbBiBrCiDvAcB`CyClB_ChGsHl@s@hAsAj@s@`@e@h@o@p@{@`@k@~AmBpBkC~DkFPStAkBPWNQTYh@q@f@o@TYLMf@e@l@i@dBqAbAo@DE~@k@VKbHsCLGlFuBp@Yp@WfAe@`A_@`EaB~B_AdEaB~Aq@bMkFzBy@x@]vGqCfDqADA|QsHjAg@pGcCn@WLGJE?AVKjCgAjCgAxD{A`@QzIqD`CaAXKnBy@tBy@fAa@nCiApDaBzAs@l@Yl@]l@_@nH}F^[vCqCtEoELKJMrAkAhHaHdBcBBAlCiCJKFGDE@?lBiBdCcC|EeFxBeC^g@x@eAjA_B`B}BJObA{A`A_B~AeCd@_A`BcDfCgFP_@zAiDvAkDd@iAnCcGp@}AxAeD|@wBxAcDvEoKdC}FJUDMDGBG@ArBaFjFyLlFwLl@uAl@wApCoGdCwFlH}PvCqGhBeDl@aAjAmBpByCv@cAn@{@X[dBsBdBkBxAwAj@o@bFsE@ApFiFbC}B^]zBoBpBkBdB_B`@_@jBeBRS~DuDtFiFrEiEdD{CHI`@]PODE@ATSnAiAdD}Cl@k@xCqCrCmCjFcF~GcId@o@Zc@PWzCkEf@w@vAmCfB}Cj@eAv@uAlBiDzAkCVe@vAkCDIvAeCtAgC^s@r@uAr@qAvB_ExAmCb@w@j@eA@E|AwCNYxA}Cj@gAz@cBP_@|BwEn@wARe@Zq@P]bBkD^s@L[Vk@LUBEN[@?HQHQnAcCnBuDbAsBv@{A`@_Ax@eBbEoIDGfGiM|ByEx@}A??h@aAXc@`@k@f@o@`@e@\\a@VURSTSVUj@e@n@e@`@Y`@Ud@[b@Ud@WXM|Ao@^Mh@Ql@Qf@M|@SxAUf@Gn@IlAIrAItBKtEWtCQtIe@tCOPAXCt@Gz@E|@E~@G~@GdAGbAG|@G|@EfAGhAGf@CXA~@CB?v@CT?F?^?\\?h@A^?^?`B@f@@jAD`@B`@B`@BbCPfAL^D`@FZDD@^D\\F|@Nl@Jj@Lr@Nl@LvA^fAXdAZh@Rh@Rn@Rj@RpAb@|@Z`A\\~@Z~@\\hA^b@N`C|@FB|I|CZJXJt@VfKlDt@XrA`@hA^l@PzCv@fATzB\\lAN|Hh@dFFpa@BT?VAh@@h@?h@?T?h@?h@?h@?rAADAx@Av@Cd@Ef@Cd@Ed@Ed@Ef@GRCZC\\G\\ELCNC\\EZGNCLCrBa@vGoA|EgApBc@`B]`FeA`GsATEj@Oj@Oj@OTGj@Oj@OJEXIXIXKXKXKVKJEXKNITIVMJEJERKJEJERKBAPGRMTKRKTMRM^U~@k@~@k@ZQZSZSZUZSn@e@VQJGTOj@]h@S??~@g@jB_AfEeBtBq@x@W\\KDAb@Mb@Kd@Ib@Kn@KvFcAj@MbAQjCg@|GmApDq@dCc@rDm@hDm@`Dm@~@Q`AQ~@O`AOx@Mz@Mz@KdAMdAKdAKbAMjBQ|DSrEKzBCrGEzFCdFCfJEbJ?f@?dDEbDAvDArDChDC`DC`@AP?t@Cr@Ct@ERCVAt@Kd@GJAZG`@GHCl@Kv@Qp@QFCFADAt@SDA^OHCRG~Aq@VMXMXOz@g@|@i@ZSXSXSdAy@vLkJ`FyDdBsAnB}AnH{Fd@]b@]d@[d@[r@e@t@e@t@c@vA{@j@[h@Yj@YjAm@lAm@pCwAvDkBhB_Ax@a@tCyAfCoAbCmAdFgC`Bu@z@[pAa@f@Mj@Ml@MjBYtAOv@Et@C|@EpDGjFIhEGfBExFG|JUb@AD?vCElDEPAH?PAF?PAPAFAHAPANCFANCNEFAPCt@OHAREREHCHCREHCPGRGHCRIFCRIPGHEHCPKPIHEPIPKFERKFEPKNKNKFELKNKLMLKNMJKLM?A`AgAFKDEBEFM~@{AHKr@iAv@wAp@iA|AaChEeHzBiDp@cAr@{@v@_An@q@xAyAp@q@p@q@HGh@g@`Aw@vFkE~E{D|@s@vAgAf@_@n@g@DExC{Bt@m@pI}Gl@i@dC{BvA{AhAmArCsDjBqC|BoDl@aAJQNWlBwCr@mAtBcDnBcDfAgBhH_L|BqDl@}@l@}@|AyBlB_Cx@}@nEoEdCcClFuEnJqIvE_E|AoA`Au@bC_BZS\\SLG\\S\\Q^Sb@SDCLIPGZO\\QNG\\O\\O^O\\MtJsD~OeGxOcG`NgFxDyAZMZKXM|CuARKt@a@zA}@zAqAzBwBpBcCn@aA~A{ChCsF^aA`@aADOPa@BEHULY|BqFvAwCvCiFl@_AVa@nJaMJO|@qAvCyDxFoHxJeMzC}DjGkH`AcAjBmBX[V]Z_@BC^c@vIyIjE_E~E}DdAkAdAkAbAmA`AmA`AmA`AoA`AoA~@oAFKHKHKFKHKFKHKHKfAsA~@mAhBuBn@s@LQjEyE|GoH`DwDbMwMtEaF^c@@A\\_@NO\\a@\\c@^a@RSJM^_@^_@`@_@^_@`@]`@]b@]b@[`@]TMNKd@Yd@YFC@ApFgCrD_BfCkAlCoAdF_CpMcG^SdFaCjFoCtBkAl@_@`DoBnBuAlA{@fBoA|H_GbAu@bDaC`BmAv@k@TQNKFGBCBAFELILKbAq@ZQ\\Q\\QZQb@QVM^O^MZM^I^M^KFAdCk@`FaAbI_BLC^G^I\\I^I^K\\I^M\\K\\M^MNELGZM\\O\\OZOZO\\QZQZOdAo@b@YfAw@lA}@|D{CxEqDVUPODEHGNMXSzCaCvAgABCnDqCNKNMxC{BlEkDfDkCvIyGlBwArI}GpB_BxAmATSRUTSTURURURU`@c@V_@RUPWPW`@o@v@kAjAyBbA_ClAoCfBeEbAaCnCkFhAsB`BkC\\o@l@{@zBwCp@y@h@m@X[zCoD|CwDbIgJlHuIzBmCLMLOFIDELOx@aAv@_AX]X]pEmFrGwHbHiId@i@`@a@\\]f@e@d@_@`@]f@_@l@a@h@]f@YPKHERMt@]dAc@r@Wd@Qh@Od@MrA[tD{@lCm@pCo@xG{AhEgAd@QLEVKrB_AbAe@vAy@`BkAlAeAnBkBfAsAjBqC~AuCbCoFrAwCfSac@FOFM@?FQHQXq@|AcD|@cBr@sAvDcG`B{Bd@m@n@q@vBgC|A{AvAsAzCkCfCwB`CwBdEmDxAsA`FeEhB_BfF_FjCmCTUVYRSBCTWDGzEsFlEiF`@c@vUaXfAoAV[n@u@Z]vDmEdBmBFIp@u@DEj@o@pB{Bf@k@\\[d@e@f@g@bAcAvEcEfCsBdCiBTQdC_BJGxBsA@Aj@[j@[RKRMt@a@bB}@l@YzCyAtCkAbEyAhCw@nEqAtCs@hFsArGyA`Ci@rG{A`G{AvG{AHCHCFA@?JCFCHCHAHCFADAx@S~A_@lBe@|FwAbDu@vCs@xCs@`EcAHC|@SlAYnAYx@StFsA`RoEdFmAhCm@|A_@tD}@x@QjGyArA]hD{@vBm@lDgAjAa@h@S`@OZMb@Qt@[ZOv@]NGj@Y\\O\\Qj@Y\\Qp@_@hFcDdDaCtDwC\\]lDeDdAeATWHIJKRUTWHKJKJODEFIHIHIHIZ_@PUZ_@`@k@T[b@k@`@m@T[^m@`AuAh@y@jAcBxFoIlHqK`GwIT_@PUDGJORWPYvFeIdCsD`[id@jReYJOFGBEJOJOfBgCvDuFhEmGbCmD|@sAHKDGBCJQLQx@kArAkB~AwBhAuA~C{DlF{GbD_E^e@^c@d@k@b@i@hByBbAoAd@g@bBuBxAgBdE_F~DeEhAeAlAcAxDoC`CiBdBoA|AiAbBsAjBaBfCeCrB{B`@e@^g@T[t@cAp@}@HKtAmBvC{DtBsCxC{DBCnCyDfDgEn@w@f@i@d@c@hAaAf@a@b@[\\WhAq@jAk@bAe@xCaAfEkAfD}@vBm@fBi@|@Yh@WXKVK`@SNIFCXOPKXS`@UZU~@s@z@{@h@g@`@c@PS?ADET[HK\\g@DEJQ^k@n@eAfCmEFM~@}A`AiBh@cAj@iANUz@wAf@_A`AiBj@cALS\\i@`AcBjAgBv@gAv@}@x@{@jAaANOj@c@l@e@n@a@fAq@|@k@\\S`BaAhAu@z@m@p@c@zAqAtBmBRSJM`AmAHINOZa@d@m@v@eA`AoAvAkBtAkB`AmAtBqCr@aAPSl@o@VW^[x@i@@AfBcArBy@HCZKhAUz@MrAMdAG`VwAjGYtEU`CMxCO|AMtAOJAbB]v@Sf@Ql@Uf@SRKr@_@h@]`@Y^Yx@s@XWd@g@tAaBdBsBz@eApDqEn@q@d@e@VUNOBC`@[d@_@`@YTMPI\\URGb@Q^MNG`@K`@MVGPCVG\\G`@Eh@Gj@El@EtBKdJg@x@Ej@Cx@CnAId@Cj@Gn@Gh@Kh@K`ASVGNGNEn@Un@W\\Q\\Sz@g@bCmBdA}@d@e@^a@fHaH`KyJp@q@VWn@s@V[l@u@NSDGR]f@y@d@{@R]P_@^_AVs@v@}BrBiIpDsNT{@H]HYNg@Ri@Rg@NYRa@JQf@y@JMPWd@g@h@m@NKPKXQHGFE@AHGHGHGROHGHEHGJGHEHGLGJGHEJEHEVKHEJEVIJEHEJCVIJCJCJCJCJCJCJCJCJALCJCJAJAJCLAJAJAJAJALAJ?JAJAL?JAX?J?J?JAP@pEGv@?|AC@?xAAhE@hD@`BB~D@bBChCI~BKtEYpAEbBEzACxHE`KKhFIhB?t@At@C^An@An@ALCx@Kx@Ix@KjAQt@Mv@Mv@Ot@Qv@Qp@SpAc@pAe@rAg@HCp@YRIr@YDCh@Wn@]l@]l@_@j@a@l@a@j@a@j@e@XSXUPSRSx@aA^c@Za@p@u@v@}@r@s@p@u@l@m@@Av@w@^]ZWx@}@xA_Bn@m@fAeApAiAHIRUNOf@o@@ATSRSJKTSJIf@m@n@k@\\]hBmBDCp@u@p@u@`@c@NQjAsAR[l@y@|@kAx@_BHOHMf@y@n@kALUfAuCHSHWBK~@aEJm@VmBZ_Dh@_IXsEXyF`@oHf@wGhAiGt@sCl@aB|AoD~C_FjCgDdDeEtAwBbAuB`A_D|@oFd@aDp@aD\\sAZ_ATm@LYd@_Ab@u@v@gA^e@p@u@ZYh@e@b@[l@[t@_@\\Kv@Uh@Uv@W|@Uz@M`AOx@It@K~@MhAUr@GrAUxA[xAi@h@StAo@x@_@l@WfAi@dBcAvAs@~@c@pBiAdEqBfGyCdB}@fB}@PItAu@`EuBh@Sv@a@v@c@f@Yl@a@d@i@XYn@q@l@k@n@s@h@o@`@i@xAmB|B_DjHsJzBuCtAiBh@o@l@o@n@k@fA{@v@m@~A_Ah@W^S\\Mt@[v@Ul@Qn@Of@Mf@I^Gf@Gp@I^CpACRApCEhACxCCvDIfFKxDK~CE~@Ad@CtKg@vEYjPgAbF[dEUhCO|DQbEOpEIzCE??~CGf@?lOEpAA`@?`@A~@Ax@AzACtBI`BIvBOhBQbBU`AOpB[VGHCHCb@In@M|Ac@~@W@AhBk@p@S~@]n@Wf@U~@_@XMf@U\\OrAq@tAq@n@]v@a@tCuAx@a@|Au@h@Y|Au@hJsENInCsAdAg@^Qn@WVKVIh@Q\\Ir@QVCf@IRC`AIb@C\\A~AGvCGfBEv@AdBE|BGdCGlCGtCI~CIn@EdCGzAETARAF?D?~@C`BEzAE`ACj@ELA^CPCj@INANCp@Oh@Oh@OZKhAc@\\MdAa@z@_@vB{@jEeBjAa@`Bq@zCkAlBw@pCgAj@SnAc@b@Mf@Mn@O|@StAWb@GTEbAMtAQzAQhAQbFk@~Ca@vAQpBW~Ca@zDe@dCYpNaBtEm@zCa@jGy@nEk@~B[xEk@jBW`Fm@fLwApB]vAY^K^Kn@StHgCdEwA`Cy@r@U@At@ULEjEwA|@YbA]tDoAZKtBs@lC{@`@OpAg@NGZOf@URMFCLId@Y^Y`@[^]PQLMNQNOPSJMLSNQLSNSJQLUJQJUTe@Tg@HQFQHUFSJYHUX_ANe@HYNk@Ne@Pk@`@qA`@sA`@oA^eAZy@Te@Vi@Ta@Vc@f@u@NS\\c@r@y@h@m@ZYPSb@a@d@_@d@]h@]ZSXORK`@Sl@Uf@Sv@WRGb@KZIREl@Mj@Kl@KbAMl@Gz@Ih@Ch@EvAK~@GpAGdAI~@Gn@CnAIxAIt@G^A`@Er@Gb@EPCD?RCDANAx@Mf@IRE^IXGVGLEv@Wb@MbAa@n@Wt@[h@Uh@Yl@Yh@[p@_@VOZUTOl@a@^[`@[TURO\\]h@g@VW\\]j@m@d@i@h@i@r@s@b@c@X[Z[XYx@w@HI\\Yr@m@LKXWt@m@d@_@^YrB{An@_@jAu@~@k@t@c@~BsAdBcAd@Wt@c@x@e@fAs@NKt@e@h@a@z@o@`@WTSdAy@tBgBtCiCbFmEPQtAoAhAaA|AqAnA_AfAy@fAy@bAq@xCqBXQ??d@g@l@a@|@m@fBoAb@]VYTYNONYLUJYJ[FSJa@Fe@B]By@?UAUAQAQKeAIq@O}AEo@Cs@?w@BqBBkBHsCT{G@o@@k@DkBHaD@k@?WDeANcDF}BDaBA??A?A?AAA@KDyAB}@?C@g@?i@?Y?UAA?K?A?E?A?C?CAAA??AA?A?CA@k@ASCmACg@Cy@G_BCi@Aq@ImBCw@CcACs@Ci@E{ACq@GyAGwBEeAEiACaACo@Ck@CiACu@GeBGaBE}AKkCE}ACm@Ae@AaAAi@@g@?e@@a@?Q@O@m@Bg@HoA@YFm@Do@PuAFm@DWBYBSBYX}BRgBb@yDTkBv@{GD]@OBYj@_FLmAPwALkALcANsA@ONqAPoATuABMLi@L_@BM\\aADKXq@P]FOb@s@HKv@mA@Cv@gAb@o@FKLQXe@HKHMZe@Xa@RYPWXa@R[R]R]N[?AVg@?AXs@Vy@DKJ]FSBMFUBIFY@IHa@Hc@DU@IBMBOBW?AD[B]Du@Ba@Fo@Ds@LyBHkAF{@@ODq@Bg@BQD}@Dk@HkAN_CDq@@GD{@HgABYFiADg@FeA@S^yFDu@h@sIB[PmCN_CrAwSV{DNmCHeAJ_BPkCHoAFcA^yFT{D\\uFN_CNqBlAwQH}APqBJyALaBDi@FkAJeBLgBPeCR{CFw@Da@B_@Fu@Fm@Dc@Fi@NoAJcAHs@Fo@D]Do@Be@@_@?K?e@?c@Ai@AgCA_B?aA@kA@}A??FS@GB]DiADm@@[BSBIBIJQ??Do@Bm@BgABw@?w@C}AAe@AUAIAW?S@k@@I@w@@_@Bk@@o@@W@s@DkBHsCFgAB]Be@??HQ@I@E@G@IRoA??NS@CBABCDCBCBCDABADAFCPCVKNIFCDEFG@CBC@E@EBG@GDSHU@G@GBI@E@C?ABC@ABCLK??\\DjALVBN@z@HNBt@H^F|C\\v@LF@??DCB?D?DAF?B?D@rBLp@Bp@Dr@F~BTlANR@n@JD??@B@@?FHt@DRB|@FrAJ^DTBj@HRB`@F??ZEJ?d@BTBVDb@FtAXfHxAjGlATDvIfBXFPB`@JrB^jAPLBl@FH@H?N@x@?|@@h@@\\Bh@Bd@@TBrHZ`AD`AFxCPpAHRBF@L@XHVHPHNHXPb@Rj@Zb@V^\\TPDBFFVTLJHFDBHDJFTLhAj@fAd@fAf@B@ZRB@DBh@ZlIxEbAj@NJBBXPXPJFDBNH`@Tb@RRJTLx@f@TL^TTD^VVJJDJBD?L?L?JAXGRGHCNGRK??Z@RBXDZF@?\\D@@P@VFPLhAzA`@j@BBj@v@l@r@??\\_AXu@Ts@Vq@Vs@h@wATq@Z{@DMBI@E@E???QAI?GCKCQEUESESKi@AGIc@WgAO_Ac@yB???AI_@?EAE?EAC?E?E?G?O?A?C?C?I@G@G?G^eANe@Z}@`@oAH[BIBK@GBU@O@Q??sCkA??i@bBc@xAm@fBy@]A?CAA?A?A?A?A?A?';
	
	      var decode = google.maps.geometry.encoding.decodePath(p1);
	
	      var rota = new google.maps.Polyline({
	        path: decode,
	        geodesic: true,
	        strokeColor: '#FF0000',
	        strokeOpacity: 0.6,
	        strokeWeight: 2
	      });
	
	      rota.setMap(vm.map);
	    },
	    discoveryTolls: function discoveryTolls(result) {
	      var _this5 = this;
	
	      var pointsLeg = [];
	      var pointsGoogle = [];
	      var legs = result.routes[0].legs;
	
	      var totalRoute = 0;
	      var totalDuration = 0;
	      var sequence = 1;
	
	      for (var i = 0; i < legs.length; i++) {
	        pointsLeg[i] = [];
	        totalRoute += legs[i].distance.value;
	        totalDuration += legs[i].duration.value;
	        for (var j = 0; j < legs[i].steps.length; j++) {
	          for (var k = 0; k < legs[i].steps[j].path.length; k++) {
	            var p = legs[i].steps[j].path[k];
	            pointsLeg[i].push([p.lng(), p.lat()]);
	            p.y = p.lat();
	            p.x = p.lng();
	            pointsGoogle.push(p);
	          }
	        }
	      }
	
	      var tollsDirection = [];
	      var totalTolls = 0;
	
	      var _loop2 = function _loop2() {
	        var points = pointsLeg[leg];
	
	        var line = _turf2.default.lineString(points);
	
	        var tolls = [];
	        var all = _this5.all;
	        for (i = 0; i < all.length; i++) {
	          var _p = _turf2.default.point([all[i].lng, all[i].lat]);
	          var d = (0, _pointToLineDistance2.default)(_p, line, { units: 'kilometers' });
	
	          if (d * 1000 < all[i].radius) {
	
	            all[i].dist = d;
	            tolls.push(all[i]);
	          }
	        }
	
	        var setPegadios = new _set2.default();
	        for (var _j = 1; _j < points.length; _j++) {
	          for (i = 0; i < tolls.length; i++) {
	            var sc = _turf2.default.distance(_this5.toTurfPoint(tolls[i]), points[_j]);
	            if (sc < 0.1) {
	              setPegadios.add(tolls[i]);
	            }
	          }
	        }
	
	        var sequence = 0;
	        setPegadios.forEach(function (value) {
	          for (var _i = 0; _i < tolls.length; _i++) {
	            if (tolls[_i].associateId == value.associateId && tolls[_i].entryId == value.entryId) {
	              tolls[_i].sequence = sequence++;
	            }
	          }
	        });
	
	        tolls.sort(function (a, b) {
	          return a.sequence > b.sequence ? 1 : b.sequence > a.sequence ? -1 : 0;
	        });
	
	        for (i = 0; i < tolls.length; i++) {
	
	          var _p2 = 0;
	          var menorDistancia = 200;
	          for (var _j2 = 1; _j2 < points.length; _j2++) {
	            var auxD = _turf2.default.distance(_this5.toTurfPoint(tolls[i]), points[_j2]);
	            if (auxD < menorDistancia) {
	              _p2 = _j2;
	              menorDistancia = auxD;
	            }
	          }
	
	          var pontoAntesDoPedagio = points[_p2 - 1];
	          var direction = tolls[i].direction;
	          angle = _turf2.default.bearing(pontoAntesDoPedagio, _turf2.default.pointOnLine(line, _this5.toTurfPoint(tolls[i])));
	
	
	          if (direction == "A" || direction == "N" && angle >= -90 && angle <= 90 || direction == "S" && (angle <= -90 || angle >= 90) || direction == "L" && angle >= 0 && angle <= 180 || direction == "O" && angle >= -180 && angle <= 0) {
	
	            tolls[i].angle = angle;
	            tolls[i].distanciaPedagioPontoAnterior = _turf2.default.distance(_this5.toTurfPoint(tolls[i]), pontoAntesDoPedagio);
	
	            tollsDirection.push(tolls[i]);
	          }
	        }
	      };
	
	      for (var leg = 0; leg < pointsLeg.length; leg++) {
	        var i;
	        var i;
	        var i;
	        var angle;
	
	        _loop2();
	      }
	
	      return { tolls: tollsDirection, totalRoute: totalRoute, totalDuration: totalDuration };
	    },
	    toTurfPoint: function toTurfPoint(obj) {
	      return [obj.lng, obj.lat];
	    },
	    addPoint: function addPoint() {
	      var _this6 = this;
	
	      if (this.locationPoints.length < 900) {
	        this.locationPoints.splice(this.locationPoints.length - 1, 0, { sequence: this.locationPoints.length, type: 'waypoint' });
	        this.viaPoints = [];
	      }
	
	      this.$nextTick(function () {
	        var scrollContainer = _this6.$refs.scrollContainer;
	        scrollContainer.scrollTop = scrollContainer.scrollHeight;
	      });
	    },
	    removePoint: function removePoint(i) {
	      if (this.locationPoints.length > 0) {
	        this.locationPoints.splice(i, 1);
	        this.viaPoints = [];
	      }
	    },
	    placeChanged: function placeChanged() {},
	    getFirstPlace2: function getFirstPlace2(address) {
	      var vm = this;
	      var promise = new _promise2.default(function (resolve, reject) {
	        var service = new google.maps.places.AutocompleteService();
	        service.getPlacePredictions({
	          input: address,
	          componentRestrictions: {
	            country: 'br'
	          }
	        }, function (results, status) {
	          resolve(results[0]);
	        });
	      });
	      return promise;
	    },
	    getFirstPlace: function getFirstPlace(address) {
	      var vm = this;
	      var promise = new _promise2.default(function (resolve, reject) {
	        var placesService = new google.maps.places.PlacesService(document.getElementById('test'));
	        placesService.getDetails({ 'reference': "Araraquara" }, function detailsresult(detailsResult, placesServiceStatus) {});
	      });
	      return promise;
	    }
	  },
	  components: { inputAc: _inputGoogleAc2.default }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _values = __webpack_require__(773);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(49);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _keys = __webpack_require__(176);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _financial = __webpack_require__(54);
	
	var _financial2 = _interopRequireDefault(_financial);
	
	var _paymentOptions = __webpack_require__(1990);
	
	var _paymentOptions2 = _interopRequireDefault(_paymentOptions);
	
	var _success = __webpack_require__(47);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _utils = __webpack_require__(34);
	
	var Utils = _interopRequireWildcard(_utils);
	
	var _eventBus = __webpack_require__(25);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['value', 'contractId', 'payment', 'planId', 'addressMailing', 'creditCardOptions', 'bankAccountOptions', 'bankBillOption', 'value', 'showNewPayment', 'salesType', 'totalComDesconto', 'taxIdNumber'],
	  data: function data() {
	    return {
	      metodosDePagamento: [],
	      paymentMethodsAuthorized: {},
	      statusPix: undefined,
	      jaUtilizouBoletoAntes: undefined,
	      bandSelecionada: undefined,
	      arrayDebito: undefined,
	      arrayCartao: undefined,
	      boletoCadastrato: undefined,
	      boleto: undefined,
	      index: 1,
	      contractPaymentMethodId: this.value,
	      loading: undefined,
	      typesAlowed: {},
	      dateTime: undefined,
	      paymentMethods: undefined,
	      secureCodeCreditCard: undefined,
	      paymentSelected: undefined,
	      BC: undefined,
	      contaCorrente: undefined,
	      saldoCorrente: undefined,
	      statusContrato: undefined,
	      toggleRadio: true,
	      error: undefined,
	      pixUrl: undefined,
	      code: undefined,
	      vads_action_mode: "INTERACTIVE",
	      vads_amount: "1",
	      vads_ctx_mode: "TEST",
	      vads_currency: "986",
	      vads_url_return: "https://www.movemais.com",
	      vads_page_action: "PAYMENT",
	      vads_payment_cards: "PIX",
	      vads_payment_config: "SINGLE",
	      vads_site_id: "84983797",
	      vads_trans_date: "20220519172700",
	      vads_trans_id: "123456",
	      vads_version: "V2",
	      certificate: "8365335201419102",
	      signature: undefined,
	      pagar: undefined,
	      boletoUrl: undefined,
	      isMobile: true,
	      cpm: {
	        "type": "CC",
	        "ownerName": undefined,
	        "number": undefined,
	        "expirationMonth": undefined,
	        "expirationYear": undefined,
	        "cvv": undefined,
	        "brand": undefined,
	        "paymentMethodId": undefined,
	        "imagePath": undefined,
	        "error": undefined,
	        "paymentMethod": {
	          "paymentMethodId": undefined
	        }
	      },
	      android: false
	    };
	  },
	  created: function created() {
	    var vm = this;
	    this.isMobile = $(window).width() < 1140;
	    $(window).resize(function () {
	      vm.isMobile = $(window).width() < 1140;
	    });
	
	    if (navigator.userAgent.match(/Android/i)) {
	
	      this.android = true;
	    }
	  },
	
	
	  watch: {
	    cpm: {
	      handler: function handler(val) {
	        this.getPayment();
	        this.handleCC();
	      },
	
	      deep: true
	    },
	    contractPaymentMethodId: function contractPaymentMethodId() {
	      this.getPayment();
	    },
	    secureCodeCreditCard: function secureCodeCreditCard() {
	      this.getPayment();
	    }
	  },
	
	  computed: {
	    request: function request() {
	      var vm = this;
	      var request = {
	        "_interface": window.document.webview ? "MOBILE" : "WEBSITE",
	        account: vm.account,
	        addresses: {
	          address: [vm.address]
	        },
	        contract: vm.contract,
	        listVehicle: {
	          vehicle: vm.vehicles
	        },
	        value: undefined
	      };
	      return request;
	    },
	    typesAllowed: function typesAllowed() {
	      return this.$store.getters.getPaymentsTypesByPlan(this.planId);
	    },
	    checkPromoSenff: function checkPromoSenff() {
	      if (sessionStorage.getItem('promoCheck') == '#SENFF2020') return true;
	    },
	    thisYear: function thisYear() {
	      return new Date().getFullYear();
	    },
	    mostrarPagamentoPorSaldo: function mostrarPagamentoPorSaldo() {
	      return this.salesType == 'ADHESIONVEHICLEADDITIONAL';
	    },
	    mostrarNovaFormaDePagamento: function mostrarNovaFormaDePagamento() {
	      return this.salesType == 'ADHESIONVEHICLEADDITIONAL' || this.salesType == 'ADHESION' || this.salesType == 'RECHARGE';
	    },
	    hasValidActivePaymentMethod: function hasValidActivePaymentMethod() {
	      var hasValidBalance = this.mostrarPagamentoPorSaldo && this.isPaymentMethodAuthorized('DC');
	
	      var hasValidPix = this.statusPix && this.isPaymentMethodAuthorized('PX');
	
	      var hasValidCreditCard = this.isPaymentMethodAuthorized('CC') && (this.arrayCartao == null || this.arrayCartao.length < 3) && this.planId != 6;
	
	      return hasValidBalance || hasValidPix || hasValidCreditCard;
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    if (this.taxIdNumber) {
	      _financial2.default.getPaymentMethodUnauthorized(this.taxIdNumber).then(function (authResponse) {
	        var authMethods = authResponse.data.data.paymentMethods;
	
	        _this.paymentMethodsAuthorized = {};
	
	        authMethods.forEach(function (method) {
	          _this.paymentMethodsAuthorized[method.shortName] = method.authorized === 1;
	        });
	
	        _this.getMeiosDePagamento();
	        _this.loadPaymentMethods();
	      }).catch(function (error) {
	        console.error('Erro ao buscar autorizações:', error);
	        _this.getMeiosDePagamento();
	        _this.loadPaymentMethods();
	      });
	    } else {
	      this.getMeiosDePagamento();
	      this.loadPaymentMethods();
	    }
	
	    this.$store.dispatch('getPlans').then(function (resp) {
	      _this.typesAlowed = _this.$store.getters.getPaymentsTypesByPlan(_this.planId);
	    });
	    _sales2.default.getDateTimeTransaction().then(function (time) {
	      _this.dateTime = time;
	    });
	  },
	
	
	  methods: {
	    loadPaymentMethods: function loadPaymentMethods() {
	      var _this2 = this;
	
	      if (this.contractId) {
	
	        this.loading = _contracts2.default.getPaymentMethodPm(this.contractId).then(function (res) {
	          _this2.paymentMethods = res;
	
	          var filteredRes = res;
	          if (_this2.taxIdNumber && (0, _keys2.default)(_this2.paymentMethodsAuthorized).length > 0) {
	            filteredRes = res.filter(function (item) {
	              var shortName = item.paymentMethod.paymentShortName;
	              if (shortName && _this2.paymentMethodsAuthorized.hasOwnProperty(shortName)) {
	                return _this2.paymentMethodsAuthorized[shortName];
	              }
	            });
	          }
	
	          _this2.arrayDebito = _.filter(filteredRes, function (o) {
	            return o.paymentMethod.paymentShortName == 'DC';
	          });
	          _this2.arrayCartao = _.filter(filteredRes, function (o) {
	
	            return o.paymentMethod.paymentShortName == 'CC' && (o.validado == null || o.validado == 1);
	          });
	
	          _this2.BC = _.find(filteredRes, function (o) {
	            return o.paymentMethod.paymentShortName == 'BC';
	          });
	
	          _this2.contaCorrente = _.find(filteredRes, function (o) {
	            return o.paymentMethod.paymentShortName == 'CR';
	          });
	
	          _this2.pix = _.find(filteredRes, function (o) {
	            return o.paymentMethod.paymentShortName == 'PX';
	          });
	
	          if (_this2.contaCorrente) {
	            _this2.contractPaymentMethodId = _this2.contaCorrente.paymentMethod.paymentMethodId;
	          }
	        });
	
	        _contracts2.default.getContractByContractId(this.contractId).then(function (res) {
	          _this2.saldoCorrente = res.currentBalance.currentBalance;
	          _this2.statusContrato = res.status.contractStatusId;
	        });
	
	        this.getPayment();
	      }
	    },
	    getMeiosDePagamento: function getMeiosDePagamento() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var meios, Arr;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _financial2.default.getMeiosDePagamentoAdesao(_this3.planId);
	
	              case 2:
	                meios = _context.sent;
	                Arr = meios.data.list;
	
	
	                if (_this3.taxIdNumber && (0, _keys2.default)(_this3.paymentMethodsAuthorized).length > 0) {
	                  Arr = Arr.filter(function (element) {
	                    var shortName = _this3.getShortNameByPaymentMethodId(element.paymentMethodId);
	                    if (shortName && _this3.paymentMethodsAuthorized.hasOwnProperty(shortName)) {
	                      return _this3.paymentMethodsAuthorized[shortName];
	                    }
	                  });
	                }
	
	                Arr.forEach(function (element) {
	                  if (element.paymentMethodId === 120) {
	                    var pixAuthorized = _this3.isPaymentMethodAuthorized('PX');
	                    if (pixAuthorized) {
	                      if (element.isAutomatic === 1) {
	                        if (_this3.salesType === 'RECHARGE') {
	                          _this3.statusPix = true;
	                        }
	                      } else {
	                        _this3.statusPix = true;
	                      }
	                    } else {
	                      _this3.statusPix = false;
	                    }
	                  }
	                });
	
	                _this3.metodosDePagamento = Arr;
	
	              case 7:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this3);
	      }))();
	    },
	    showBandeira: function showBandeira(band) {
	      var paymentMapping = {
	        'Visa': 6,
	        'Mastercard': 7,
	        'Elo': 10,
	        'HiperCard': 11
	      };
	      var requiredPaymentMethodId = paymentMapping[band];
	
	      if (!this.metodosDePagamento || !this.metodosDePagamento.length) return false;
	
	      return this.metodosDePagamento.some(function (pm) {
	        return pm.paymentMethodId === requiredPaymentMethodId && pm.displaySite === 'Y';
	      });
	    },
	
	
	    getPayment: function () {
	      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var id, success;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                id = void 0;
	
	                this.error = undefined;
	                if (this.salesType == "RECHARGE" && this.contractPaymentMethodId == 109) {
	                  id = "";
	                } else {
	                  id = this.contractPaymentMethodId;
	                }
	
	                if (this.contractPaymentMethodId) {
	                  _context2.next = 7;
	                  break;
	                }
	
	                this.error = 'Por favor selecione uma forma de pagamento';
	                this.$emit('input', (0, _extends3.default)({}, this.cpm, { error: this.error }));
	                return _context2.abrupt('return');
	
	              case 7:
	                if (!(id == 'newPayment')) {
	                  _context2.next = 12;
	                  break;
	                }
	
	                this.error = 'Selecione uma forma de pagamento';
	                this.$emit('input', (0, _extends3.default)({}, this.cpm, { error: this.error }));
	                _context2.next = 31;
	                break;
	
	              case 12:
	                if (!(id == 'CC')) {
	                  _context2.next = 30;
	                  break;
	                }
	
	                success = void 0;
	
	                if (!this.cpm.paymentMethodId) {
	                  _context2.next = 26;
	                  break;
	                }
	
	                _context2.prev = 15;
	                _context2.next = 18;
	                return this.$validator.validateAll();
	
	              case 18:
	                success = _context2.sent;
	                _context2.next = 24;
	                break;
	
	              case 21:
	                _context2.prev = 21;
	                _context2.t0 = _context2['catch'](15);
	
	
	                this.error = 'Por favor Verifique os dados do cartão';
	
	              case 24:
	                _context2.next = 27;
	                break;
	
	              case 26:
	                this.error = 'Por favor selecione uma bandeira.';
	
	              case 27:
	
	                this.$emit('input', (0, _extends3.default)({}, this.cpm, { error: this.error }));
	
	                _context2.next = 31;
	                break;
	
	              case 30:
	                if (id == 'BC') {
	                  this.$emit('input', { paymentMethod: { paymentMethodId: 12 } });
	                } else if (id == 'PX') {
	                  if (this.pix) {
	                    this.$emit('input', (0, _extends3.default)({}, this.pix, { error: this.error }));
	                  } else {
	                    this.$emit('input', { paymentMethod: { paymentMethodId: 120 } });
	                  }
	                } else if (id == '109') {
	                  this.$emit('input', { paymentMethod: { paymentMethodId: 109 } });
	                } else if (id == "senff") {
	
	                  this.$emit('input', { paymentMethod: { paymentMethodId: 21 } });
	                } else if (id == "newBalance") {
	
	                  if (this.saldoCorrente < this.totalComDesconto) {
	                    this.error = 'Saldo insuficiente';
	                  }
	                  this.$emit('input', { paymentMethod: { paymentMethodId: 109 }, error: this.error });
	                } else {
	                  if (this.paymentSelected && this.paymentSelected.number) {
	                    if (!this.secureCodeCreditCard || this.secureCodeCreditCard.length < 3) {
	                      this.error = 'Verifique o cvv';
	                    }
	                    this.paymentSelected.cvv = this.secureCodeCreditCard;
	                  } else if (this.paymentSelected.paymentMethod.paymentShortName == 'DC') {
	                    this.error = undefined;
	                  } else {
	                    this.error = 'Favor selecionar uma forma de pagamento';
	                  }
	                  this.$emit('input', (0, _extends3.default)({}, this.paymentSelected, { error: this.error }));
	                }
	
	              case 31:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this, [[15, 21]]);
	      }));
	
	      function getPayment() {
	        return _ref.apply(this, arguments);
	      }
	
	      return getPayment;
	    }(),
	    usarSaldo: function usarSaldo() {
	      if (this.statusContrato != 1 || !this.contractId || this.salesType != "ADHESIONVEHICLEADDITIONAL") return false;
	      if (this.planId == 21 || this.planId == 22 || this.planId == 31 || this.planId == 32) {
	        return true;
	      } else return false;
	    },
	    Redirecionar: function Redirecionar() {
	      var _this4 = this;
	
	      this.$refs.summary.validateAll().then(function (r) {
	        var promise = _sales2.default.adhesion(_this4.request).then(function (r) {
	          _this4.code = r.status.code;
	          _this4.pixUrl = r.boletoUrl;
	          $('body').stop().animate({
	            scrollTop: 0
	          }, '500', 'swing');
	        }).catch(function (err) {
	          _this4.msgError = err.data.status.message;
	          _this4.code = err.data.status.code;
	          $('body').stop().animate({
	            scrollTop: 0
	          }, '500', 'swing');
	        });
	
	        _this4.$store.dispatch('loading', promise);
	      });
	    },
	    handleCC: function handleCC() {
	      if (this.contractPaymentMethodId == 'BC') {
	        return;
	      }
	
	      switch (this.cpm.paymentMethodId) {
	        case "6":
	          this.cpm.paymentMethodId = 6;
	          this.cpm.paymentMethod.paymentMethodId = 6;
	          this.cpm.brand = "Visa";
	          this.cpm.caption = "Visa";
	          this.cpm.paymentMethod.imagePath = "visa2.svg";
	          break;
	        case "7":
	          this.cpm.paymentMethodId = 7;
	          this.cpm.paymentMethod.paymentMethodId = 7;
	          this.cpm.brand = "Mastercard";
	          this.cpm.caption = "Mastercard";
	          this.cpm.paymentMethod.imagePath = "mastercard2.svg";
	          break;
	        case "8":
	          this.cpm.paymentMethodId = 8;
	          this.cpm.paymentMethod.paymentMethodId = 8;
	          this.cpm.brand = "American Express";
	          this.cpm.caption = "American Express";
	          this.cpm.paymentMethod.imagePath = "amex.svg";
	          break;
	        case "10":
	          this.cpm.paymentMethodId = 10;
	          this.cpm.paymentMethod.paymentMethodId = 10;
	          this.cpm.brand = "Elo";
	          this.cpm.caption = "Elo";
	          this.cpm.paymentMethod.imagePath = "elo2.svg";
	          break;
	        case "11":
	          this.cpm.paymentMethodId = 11;
	          this.cpm.paymentMethod.paymentMethodId = 11;
	          this.cpm.brand = "HiperCard";
	          this.cpm.caption = "HiperCard";
	          this.cpm.paymentMethod.imagePath = "hipercard2.svg";
	          break;
	        case "22":
	          this.cpm.paymentMethodId = 22;
	          this.cpm.paymentMethod.paymentMethodId = 22;
	          this.cpm.brand = "Senff";
	          this.cpm.caption = "Senff";
	          this.cpm.paymentMethod.imagePath = "senff.svg";
	          break;
	      }
	
	      if (!this.cpm.number && !this.cpm.ownerName && !this.cpm.expirationMonth && !this.cpm.expirationYear && !this.cpm.cvv) {
	        this.error = 'Por favor verifique os dados do cartão.';
	        this.$emit('input', (0, _extends3.default)({}, this.cpm, { error: this.error }));
	      }
	    },
	    getShortNameByPaymentMethodId: function getShortNameByPaymentMethodId(paymentMethodId) {
	      var mapping = {
	        6: 'CC',
	        7: 'CC',
	        8: 'CC',
	        10: 'CC',
	        11: 'CC',
	        12: 'BC',
	        21: 'SF',
	        22: 'SF',
	        109: 'CR',
	        120: 'PX' };
	
	      return mapping[paymentMethodId] || null;
	    },
	    getShortNameByPaymentShortName: function getShortNameByPaymentShortName(paymentShortName) {
	      return paymentShortName || null;
	    },
	    isPaymentMethodAuthorized: function isPaymentMethodAuthorized(shortName) {
	      if (!this.taxIdNumber) {
	        return true;
	      }
	
	      if (!this.paymentMethodsAuthorized || (0, _keys2.default)(this.paymentMethodsAuthorized).length === 0) {
	        return true;
	      }
	
	      if (!this.paymentMethodsAuthorized.hasOwnProperty(shortName)) {
	        return true;
	      }
	
	      return this.paymentMethodsAuthorized[shortName] === true;
	    },
	    hasAnyPaymentMethodAvailable: function hasAnyPaymentMethodAvailable() {
	      var _this5 = this;
	
	      if (!this.taxIdNumber) {
	        return this.hasAnyPaymentMethodInPlan();
	      }
	
	      if (!this.paymentMethodsAuthorized || (0, _keys2.default)(this.paymentMethodsAuthorized).length === 0) {
	        return this.hasAnyPaymentMethodInPlan();
	      }
	
	      var methodChecks = {
	        'DC': function DC() {
	          return _this5.isPaymentMethodAuthorized('DC') && _this5.typesAlowed.bankAccount;
	        },
	        'CC': function CC() {
	          return _this5.isPaymentMethodAuthorized('CC') && _this5.typesAlowed.creditCard;
	        },
	        'BC': function BC() {
	          return _this5.isPaymentMethodAuthorized('BC') && _this5.typesAlowed.bankBill;
	        },
	        'PX': function PX() {
	          return _this5.isPaymentMethodAuthorized('PX') && _this5.hasPixInPlan();
	        },
	        'CR': function CR() {
	          return _this5.isPaymentMethodAuthorized('CR') && _this5.hasContaCorrenteInPlan();
	        },
	        'DO': function DO() {
	          return _this5.isPaymentMethodAuthorized('DO') && _this5.typesAlowed.doc;
	        },
	        'TE': function TE() {
	          return _this5.isPaymentMethodAuthorized('TE') && _this5.typesAlowed.ted;
	        }
	      };
	
	      return (0, _values2.default)(methodChecks).some(function (check) {
	        return check();
	      });
	    },
	    hasAnyPaymentMethodInPlan: function hasAnyPaymentMethodInPlan() {
	      if (!this.typesAlowed || (0, _keys2.default)(this.typesAlowed).length === 0) {
	        return true;
	      }
	
	      return this.typesAlowed.bankAccount || this.typesAlowed.creditCard || this.typesAlowed.bankBill || this.typesAlowed.doc || this.typesAlowed.ted || this.hasPixInPlan() || this.hasContaCorrenteInPlan();
	    },
	    hasPixInPlan: function hasPixInPlan() {
	      if (!this.metodosDePagamento || !this.metodosDePagamento.length) {
	        return false;
	      }
	      return this.metodosDePagamento.some(function (pm) {
	        return pm.paymentMethodId === 120;
	      });
	    },
	    hasContaCorrenteInPlan: function hasContaCorrenteInPlan() {
	      return this.planId == 28 || this.contaCorrente !== undefined;
	    }
	  },
	
	  components: {
	    PaymentOptions: _paymentOptions2.default,
	    successPage: _success2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(28);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddressService = function () {
	  function AddressService() {
	    (0, _classCallCheck3.default)(this, AddressService);
	  }
	
	  (0, _createClass3.default)(AddressService, [{
	    key: 'getLatLng',
	    value: function getLatLng(cep) {
	      return _axios2.default.get('/v2/address/getLatLng/' + cep).then(function (r) {
	        return r.data;
	      });
	    }
	  }]);
	  return AddressService;
	}();
	
	var instance = new AddressService();
	exports.default = instance;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(28);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConveniadoService = function () {
	    function ConveniadoService() {
	        (0, _classCallCheck3.default)(this, ConveniadoService);
	    }
	
	    (0, _createClass3.default)(ConveniadoService, [{
	        key: 'listaVouchersConveniado',
	        value: function listaVouchersConveniado(request) {
	            return _axios2.default.post('/v2/conveniado/listaVouchersConveniado', request).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'listaConveniados',
	        value: function listaConveniados() {
	            return _axios2.default.get('/v2/conveniado/listaConveniados').then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'listaVouchersConveniadoComStatus',
	        value: function listaVouchersConveniadoComStatus(request) {
	            return _axios2.default.post('/v2/conveniado/listaVouchersConveniadoComStatus', request).then(function (res) {
	                return res.data;
	            });
	        }
	    }]);
	    return ConveniadoService;
	}();
	
	var instance = new ConveniadoService();
	
	exports.default = instance;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(28);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Refund = function () {
	    function Refund() {
	        (0, _classCallCheck3.default)(this, Refund);
	    }
	
	    (0, _createClass3.default)(Refund, [{
	        key: 'getRefundPassage',
	        value: function getRefundPassage(filter) {
	            return _axios2.default.post('/v2/financial/getRefundPassage', filter).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'getRefundPassageHist',
	        value: function getRefundPassageHist(refundPassageId) {
	            return _axios2.default.get('/v2/financial/getRefundPassageHist/' + refundPassageId).then(function (t) {
	                return t.data;
	            });
	        }
	    }, {
	        key: 'updateRefundPassage',
	        value: function updateRefundPassage(request) {
	            return _axios2.default.post('/v2/financial/updateRefundPassageStatus', request).then(function (t) {
	                return t.data;
	            });
	        }
	    }, {
	        key: 'findPassagesAndRefunds',
	        value: function findPassagesAndRefunds(filter) {
	            return _axios2.default.post('/v2/financial/transactionRefundInfo', filter).then(function (t) {
	                return t.data;
	            });
	        }
	    }, {
	        key: 'exportRefundReport',
	        value: function exportRefundReport(filter) {
	            var config = {
	                responseType: "blob"
	            };
	            return _axios2.default.post('/v2/financial/exportRefundReport', filter, config).then(function (t) {
	                return t.data;
	            });
	        }
	    }, {
	        key: 'exportRefundReport2',
	        value: function exportRefundReport2(data) {
	            return _axios2.default.post('/v2/financial/exportRefundReport2', data).then(function (t) {
	                return t.data;
	            });
	        }
	    }, {
	        key: 'downloadRefundFile',
	        value: function downloadRefundFile(request) {
	            var config = {
	                responseType: "blob"
	            };
	            return _axios2.default.post('v2/financial/downloadRefundFile', request, config).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'uploadRefundFiles',
	        value: function uploadRefundFiles(req) {
	            return _axios2.default.post('/v2/financial/uploadRefundFiles', req).then(function (t) {
	                return t.data;
	            });
	        }
	    }, {
	        key: 'createRefundPassageLote',
	        value: function createRefundPassageLote(req) {
	            return _axios2.default.post('/v2/financial/createRefundPassageLote', req).then(function (r) {
	                return r.data;
	            });
	        }
	    }, {
	        key: 'updateRefundPassageStatusLote',
	        value: function updateRefundPassageStatusLote(req) {
	            return _axios2.default.post('/v2/financial/updateRefundPassageStatusLote', req).then(function (t) {
	                return t.data;
	            });
	        }
	    }, {
	        key: 'createRefundPassage',
	        value: function createRefundPassage(request) {
	            return _axios2.default.post('/v2/financial/createRefundPassage', request).then(function (r) {
	                return r.data;
	            });
	        }
	    }, {
	        key: 'isRefundPassage',
	        value: function isRefundPassage(filter) {
	            return _axios2.default.post('/v2/financial/isRefundPassage', filter).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'getRefusedDebit',
	        value: function getRefusedDebit(transactionId) {
	            return _axios2.default.get('/v2/financial/getRefusedDebit/' + transactionId).then(function (t) {
	                return t.data;
	            });
	        }
	    }]);
	    return Refund;
	}();
	
	var instance = new Refund();
	exports.default = instance;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(28);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SupportService = function () {
	  function SupportService() {
	    (0, _classCallCheck3.default)(this, SupportService);
	  }
	
	  (0, _createClass3.default)(SupportService, [{
	    key: 'faleConosco',
	    value: function faleConosco(_faleConosco) {
	      return _axios2.default.post('/v2/faleConosco', _faleConosco);
	    }
	  }]);
	  return SupportService;
	}();
	
	var instance = new SupportService();
	exports.default = instance;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _number = __webpack_require__(24);
	
	function isMultiple(val, args) {
	  var multiple = parseInt(args[0]);
	
	  if (!multiple) return false;
	
	  var value = parseInt(val.toString().replace(/[^0-9]/g, ""));
	
	  return value % multiple === 0;
	}
	
	exports.default = {
	  messages: {
	    en: function en(field, args) {
	      var min = args[0];
	      return "Valor deve ser m\xFAltiplo de " + (0, _number.cents)(min);
	    },
	    "pt-BR": function ptBR(field, args) {
	      var min = args[0];
	      return "Valor deve ser m\xFAltiplo de " + (0, _number.cents)(min);
	    }
	  },
	  validate: function validate(value, args) {
	    return isMultiple(value, args);
	  }
	};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _number = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function recargaValida(val, args) {
	  var mult = args[0];
	  if (!val) return false;
	  val = val.toString().replace(/[^0-9]/g, '');
	  if (val / mult > 0 && val % mult == 0) return true;
	
	  return false;
	}
	
	exports.default = {
	  messages: {
	    en: function en(field, args) {
	      var mult = args[0];
	      return 'Valor de recarga inv\xE1lido, valor deve ser m\xFAltiplo de ' + (0, _number.cents)(mult);
	    },
	    'pt-BR': function ptBR(field, args) {
	      var mult = args[0];
	      return 'Valor de recarga inv\xE1lido, valor deve ser m\xFAltiplo de ' + (0, _number.cents)(mult);
	    }
	  },
	  validate: function validate(value, args) {
	    return recargaValida(value, args);
	  }
	};
	
	
	function getMult() {
	  return _auth2.default.currentUser.type == 'PESSOA_JURIDICA' ? _constantes2.default.RECHARGE_UNIT_PJ : _constantes2.default.RECHARGE_UNIT;
	}

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(798), __esModule: true };

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(806), __esModule: true };

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(772);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(769);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = function (crypto, password, keyLen, ivLen) {
	  keyLen = keyLen/8;
	  ivLen = ivLen || 0;
	  var ki = 0;
	  var ii = 0;
	  var key = new Buffer(keyLen);
	  var iv = new Buffer(ivLen);
	  var addmd = 0;
	  var md, md_buf;
	  var i;
	  while (true) {
	    md = crypto.createHash('md5');
	    if(addmd++ > 0) {
	       md.update(md_buf);
	    }
	    md.update(password);
	    md_buf = md.digest();
	    i = 0;
	    if(keyLen > 0) {
	      while(true) {
	        if(keyLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	        key[ki++] = md_buf[i];
	        keyLen--;
	        i++;
	       }
	    }
	    if(ivLen > 0 && i !== md_buf.length) {
	      while(true) {
	        if(ivLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	       iv[ii++] = md_buf[i];
	       ivLen--;
	       i++;
	     }
	   }
	   if(keyLen === 0 && ivLen === 0) {
	      break;
	    }
	  }
	  for(i=0;i<md_buf.length;i++) {
	    md_buf[i] = 0;
	  }
	  return {
	    key: key,
	    iv: iv
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32).Buffer))

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	var xor = __webpack_require__(123);
	exports.encrypt = function (self, block) {
	  var data = xor(block, self._prev);
	  self._prev = self._cipher.encryptBlock(data);
	  return self._prev;
	};
	exports.decrypt = function (self, block) {
	  var pad = self._prev;
	  self._prev = block;
	  var out = self._cipher.decryptBlock(block);
	  return xor(out, pad);
	};

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(123);
	exports.encrypt = function (self, data, decrypt) {
	  var out = new Buffer('');
	  var len;
	  while (data.length) {
	    if (self._cache.length === 0) {
	      self._cache = self._cipher.encryptBlock(self._prev);
	      self._prev = new Buffer('');
	    }
	    if (self._cache.length <= data.length) {
	      len = self._cache.length;
	      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)]);
	      data = data.slice(len);
	    } else {
	      out = Buffer.concat([out, encryptStart(self, data, decrypt)]);
	      break;
	    }
	  }
	  return out;
	};
	function encryptStart(self, data, decrypt) {
	  var len = data.length;
	  var out = xor(data, self._cache);
	  self._cache = self._cache.slice(len);
	  self._prev = Buffer.concat([self._prev, decrypt?data:out]);
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32).Buffer))

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(123);
	function getBlock(self) {
	  var out = self._cipher.encryptBlock(self._prev);
	  incr32(self._prev);
	  return out;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	function incr32(iv) {
	  var len = iv.length;
	  var item;
	  while (len--) {
	    item = iv.readUInt8(len);
	    if (item === 255) {
	      iv.writeUInt8(0, len);
	    } else {
	      item++;
	      iv.writeUInt8(item, len);
	      break;
	    }
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32).Buffer))

/***/ }),
/* 252 */
/***/ (function(module, exports) {

	exports.encrypt = function (self, block) {
	  return self._cipher.encryptBlock(block);
	};
	exports.decrypt = function (self, block) {
	  return self._cipher.decryptBlock(block);
	};

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(123);
	function getBlock(self) {
	  self._prev = self._cipher.encryptBlock(self._prev);
	  return self._prev;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32).Buffer))

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(178);
	var Transform = __webpack_require__(179);
	var inherits = __webpack_require__(52);
	
	inherits(StreamCipher, Transform);
	module.exports = StreamCipher;
	function StreamCipher(mode, key, iv, decrypt) {
	  if (!(this instanceof StreamCipher)) {
	    return new StreamCipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  this._cache = new Buffer('');
	  this._secCache = new Buffer('');
	  this._decrypt = decrypt;
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	StreamCipher.prototype._transform = function (chunk, _, next) {
	  next(null, this._mode.encrypt(this, chunk, this._decrypt));
	};
	StreamCipher.prototype._flush = function (next) {
	  this._cipher.scrub();
	  next();
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32).Buffer))

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(45).f;
	var create = __webpack_require__(126);
	var redefineAll = __webpack_require__(190);
	var ctx = __webpack_require__(56);
	var anInstance = __webpack_require__(181);
	var forOf = __webpack_require__(102);
	var $iterDefine = __webpack_require__(186);
	var step = __webpack_require__(264);
	var setSpecies = __webpack_require__(273);
	var DESCRIPTORS = __webpack_require__(41);
	var fastKey = __webpack_require__(125).fastKey;
	var validate = __webpack_require__(195);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(124);
	var from = __webpack_require__(810);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(36);
	var $export = __webpack_require__(31);
	var meta = __webpack_require__(125);
	var fails = __webpack_require__(71);
	var hide = __webpack_require__(62);
	var redefineAll = __webpack_require__(190);
	var forOf = __webpack_require__(102);
	var anInstance = __webpack_require__(181);
	var isObject = __webpack_require__(42);
	var setToStringTag = __webpack_require__(106);
	var dP = __webpack_require__(45).f;
	var each = __webpack_require__(812)(0);
	var DESCRIPTORS = __webpack_require__(41);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    C = wrapper(function (target, iterable) {
	      anInstance(target, C, NAME, '_c');
	      target._c = new Base();
	      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
	    });
	    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
	      var IS_ADDER = KEY == 'add' || KEY == 'set';
	      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
	        anInstance(this, C, KEY);
	        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
	        var result = this._c[KEY](a === 0 ? 0 : a, b);
	        return IS_ADDER ? this : result;
	      });
	    });
	    IS_WEAK || dP(C.prototype, 'size', {
	      get: function () {
	        return this._c.size;
	      }
	    });
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F, O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(36).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(41) && !__webpack_require__(71)(function () {
	  return Object.defineProperty(__webpack_require__(183)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(87);
	var ITERATOR = __webpack_require__(37)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(101);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(50);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(37)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 264 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(267);
	var hiddenKeys = __webpack_require__(184).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(72);
	var toObject = __webpack_require__(73);
	var IE_PROTO = __webpack_require__(191)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(72);
	var toIObject = __webpack_require__(63);
	var arrayIndexOf = __webpack_require__(811)(false);
	var IE_PROTO = __webpack_require__(191)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 268 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(50);
	var isObject = __webpack_require__(42);
	var newPromiseCapability = __webpack_require__(187);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(62);


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(31);
	var aFunction = __webpack_require__(100);
	var ctx = __webpack_require__(56);
	var forOf = __webpack_require__(102);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(31);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(36);
	var core = __webpack_require__(23);
	var dP = __webpack_require__(45);
	var DESCRIPTORS = __webpack_require__(41);
	var SPECIES = __webpack_require__(37)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(50);
	var aFunction = __webpack_require__(100);
	var SPECIES = __webpack_require__(37)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(56);
	var invoke = __webpack_require__(817);
	var html = __webpack_require__(258);
	var cel = __webpack_require__(183);
	var global = __webpack_require__(36);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(101)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(1720)
	
	var md5 = toConstructor(__webpack_require__(862))
	var rmd160 = toConstructor(__webpack_require__(1714))
	
	function toConstructor (fn) {
	  return function () {
	    var buffers = []
	    var m= {
	      update: function (data, enc) {
	        if(!Buffer.isBuffer(data)) data = new Buffer(data, enc)
	        buffers.push(data)
	        return this
	      },
	      digest: function (enc) {
	        var buf = Buffer.concat(buffers)
	        var r = fn(buf)
	        buffers = null
	        return enc ? r.toString(enc) : r
	      }
	    }
	    return m
	  }
	}
	
	module.exports = function (alg) {
	  if('md5' === alg) return new md5()
	  if('rmd160' === alg) return new rmd160()
	  return createHash(alg)
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32).Buffer))

/***/ }),
/* 277 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = assign;
	
	function assign(target, dirtyObject) {
	  if (target == null) {
	    throw new TypeError('assign requires that input parameter not be null or undefined');
	  }
	
	  dirtyObject = dirtyObject || {};
	
	  for (var property in dirtyObject) {
	    if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) {
	      target[property] = dirtyObject[property];
	    }
	  }
	
	  return target;
	}
	
	module.exports = exports.default;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cloneObject;
	
	var _index = _interopRequireDefault(__webpack_require__(277));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function cloneObject(dirtyObject) {
	  return (0, _index.default)({}, dirtyObject);
	}
	
	module.exports = exports.default;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(90));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* |                                |
	 * |  d  | Day of month                   |  D  |                                |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  y  | Year (abs)                     |  Y  |                                |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 */
	var formatters = {
	  // Year
	  y: function (date, token) {
	    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
	    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
	    // |----------|-------|----|-------|-------|-------|
	    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
	    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
	    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
	    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
	    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
	    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
	
	    var year = signedYear > 0 ? signedYear : 1 - signedYear;
	    return (0, _index.default)(token === 'yy' ? year % 100 : year, token.length);
	  },
	  // Month
	  M: function (date, token) {
	    var month = date.getUTCMonth();
	    return token === 'M' ? String(month + 1) : (0, _index.default)(month + 1, 2);
	  },
	  // Day of the month
	  d: function (date, token) {
	    return (0, _index.default)(date.getUTCDate(), token.length);
	  },
	  // AM or PM
	  a: function (date, token) {
	    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
	
	    switch (token) {
	      case 'a':
	      case 'aa':
	        return dayPeriodEnumValue.toUpperCase();
	
	      case 'aaa':
	        return dayPeriodEnumValue;
	
	      case 'aaaaa':
	        return dayPeriodEnumValue[0];
	
	      case 'aaaa':
	      default:
	        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
	    }
	  },
	  // Hour [1-12]
	  h: function (date, token) {
	    return (0, _index.default)(date.getUTCHours() % 12 || 12, token.length);
	  },
	  // Hour [0-23]
	  H: function (date, token) {
	    return (0, _index.default)(date.getUTCHours(), token.length);
	  },
	  // Minute
	  m: function (date, token) {
	    return (0, _index.default)(date.getUTCMinutes(), token.length);
	  },
	  // Second
	  s: function (date, token) {
	    return (0, _index.default)(date.getUTCSeconds(), token.length);
	  },
	  // Fraction of second
	  S: function (date, token) {
	    var numberOfDigits = token.length;
	    var milliseconds = date.getUTCMilliseconds();
	    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
	    return (0, _index.default)(fractionalSeconds, token.length);
	  }
	};
	var _default = formatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 280 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function dateLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'P':
	      return formatLong.date({
	        width: 'short'
	      });
	
	    case 'PP':
	      return formatLong.date({
	        width: 'medium'
	      });
	
	    case 'PPP':
	      return formatLong.date({
	        width: 'long'
	      });
	
	    case 'PPPP':
	    default:
	      return formatLong.date({
	        width: 'full'
	      });
	  }
	}
	
	function timeLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'p':
	      return formatLong.time({
	        width: 'short'
	      });
	
	    case 'pp':
	      return formatLong.time({
	        width: 'medium'
	      });
	
	    case 'ppp':
	      return formatLong.time({
	        width: 'long'
	      });
	
	    case 'pppp':
	    default:
	      return formatLong.time({
	        width: 'full'
	      });
	  }
	}
	
	function dateTimeLongFormatter(pattern, formatLong) {
	  var matchResult = pattern.match(/(P+)(p+)?/);
	  var datePattern = matchResult[1];
	  var timePattern = matchResult[2];
	
	  if (!timePattern) {
	    return dateLongFormatter(pattern, formatLong);
	  }
	
	  var dateTimeFormat;
	
	  switch (datePattern) {
	    case 'P':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'short'
	      });
	      break;
	
	    case 'PP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'medium'
	      });
	      break;
	
	    case 'PPP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'long'
	      });
	      break;
	
	    case 'PPPP':
	    default:
	      dateTimeFormat = formatLong.dateTime({
	        width: 'full'
	      });
	      break;
	  }
	
	  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
	}
	
	var longFormatters = {
	  p: timeLongFormatter,
	  P: dateTimeLongFormatter
	};
	var _default = longFormatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(133));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getUTCFullYear();
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index2.default)(fourthOfJanuaryOfNextYear);
	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index2.default)(fourthOfJanuaryOfThisYear);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(133));
	
	var _index3 = _interopRequireDefault(__webpack_require__(871));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	
	function getUTCISOWeek(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime(); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	
	module.exports = exports.default;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(109));
	
	var _index3 = _interopRequireDefault(__webpack_require__(872));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	
	function getUTCWeek(dirtyDate, options) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date, options).getTime() - (0, _index3.default)(date, options).getTime(); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	
	module.exports = exports.default;

/***/ }),
/* 284 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
	exports.isProtectedWeekYearToken = isProtectedWeekYearToken;
	exports.throwProtectedError = throwProtectedError;
	var protectedDayOfYearTokens = ['D', 'DD'];
	var protectedWeekYearTokens = ['YY', 'YYYY'];
	
	function isProtectedDayOfYearToken(token) {
	  return protectedDayOfYearTokens.indexOf(token) !== -1;
	}
	
	function isProtectedWeekYearToken(token) {
	  return protectedWeekYearTokens.indexOf(token) !== -1;
	}
	
	function throwProtectedError(token, format, input) {
	  if (token === 'YYYY') {
	    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
	  } else if (token === 'YY') {
	    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
	  } else if (token === 'D') {
	    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
	  } else if (token === 'DD') {
	    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
	  }
	}

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addBusinessDays;
	
	var _index = _interopRequireDefault(__webpack_require__(138));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(10));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	var _index5 = _interopRequireDefault(__webpack_require__(210));
	
	var _index6 = _interopRequireDefault(__webpack_require__(320));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addBusinessDays
	 * @category Day Helpers
	 * @summary Add the specified number of business days (mon - fri) to the given date.
	 *
	 * @description
	 * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of business days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the business days added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 10 business days to 1 September 2014:
	 * const result = addBusinessDays(new Date(2014, 8, 1), 10)
	 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
	 */
	function addBusinessDays(dirtyDate, dirtyAmount) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var startedOnWeekend = (0, _index.default)(date);
	  var amount = (0, _index3.default)(dirtyAmount);
	  if (isNaN(amount)) return new Date(NaN);
	  var hours = date.getHours();
	  var sign = amount < 0 ? -1 : 1;
	  var fullWeeks = (0, _index3.default)(amount / 5);
	  date.setDate(date.getDate() + fullWeeks * 7); // Get remaining days not part of a full week
	
	  var restDays = Math.abs(amount % 5); // Loops over remaining days
	
	  while (restDays > 0) {
	    date.setDate(date.getDate() + sign);
	    if (!(0, _index.default)(date)) restDays -= 1;
	  } // If the date is a weekend day and we reduce a dividable of
	  // 5 from it, we land on a weekend date.
	  // To counter this, we add days accordingly to land on the next business day
	
	
	  if (startedOnWeekend && (0, _index.default)(date) && amount !== 0) {
	    // If we're reducing days, we want to add days until we land on a weekday
	    // If we're adding days we want to reduce days until we land on a weekday
	    if ((0, _index6.default)(date)) date.setDate(date.getDate() + (sign < 0 ? 2 : -1));
	    if ((0, _index5.default)(date)) date.setDate(date.getDate() + (sign < 0 ? 1 : -2));
	  } // Restore hours to avoid DST lag
	
	
	  date.setHours(hours);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addISOWeekYears;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(91));
	
	var _index3 = _interopRequireDefault(__webpack_require__(336));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Add the specified number of ISO week-numbering years to the given date.
	 *
	 * @description
	 * Add the specified number of ISO week-numbering years to the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `addISOYears` to `addISOWeekYears`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of ISO week-numbering years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the ISO week-numbering years added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 ISO week-numbering years to 2 July 2010:
	 * const result = addISOWeekYears(new Date(2010, 6, 2), 5)
	 * //=> Fri Jun 26 2015 00:00:00
	 */
	function addISOWeekYears(dirtyDate, dirtyAmount) {
	  (0, _index4.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index3.default)(dirtyDate, (0, _index2.default)(dirtyDate) + amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(110));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addSeconds
	 * @category Second Helpers
	 * @summary Add the specified number of seconds to the given date.
	 *
	 * @description
	 * Add the specified number of seconds to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the seconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 30 seconds to 10 July 2014 12:45:00:
	 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
	 * //=> Thu Jul 10 2014 12:45:30
	 */
	function addSeconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * 1000);
	}
	
	module.exports = exports.default;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addYears;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(111));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addYears
	 * @category Year Helpers
	 * @summary Add the specified number of years to the given date.
	 *
	 * @description
	 * Add the specified number of years to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the years added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 years to 1 September 2014:
	 * const result = addYears(new Date(2014, 8, 1), 5)
	 * //=> Sun Sep 01 2019 00:00:00
	 */
	function addYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * 12);
	}
	
	module.exports = exports.default;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarISOWeekYears;
	
	var _index = _interopRequireDefault(__webpack_require__(91));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInCalendarISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of calendar ISO week-numbering years between the given dates.
	 *
	 * @description
	 * Get the number of calendar ISO week-numbering years between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `differenceInCalendarISOYears` to `differenceInCalendarISOWeekYears`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar ISO week-numbering years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
	 * const result = differenceInCalendarISOWeekYears(
	 *   new Date(2012, 0, 1),
	 *   new Date(2010, 0, 1)
	 * )
	 * //=> 2
	 */
	function differenceInCalendarISOWeekYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  return (0, _index.default)(dirtyDateLeft) - (0, _index.default)(dirtyDateRight);
	}
	
	module.exports = exports.default;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInCalendarMonths
	 * @category Month Helpers
	 * @summary Get the number of calendar months between the given dates.
	 *
	 * @description
	 * Get the number of calendar months between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar months
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar months are between 31 January 2014 and 1 September 2014?
	 * var result = differenceInCalendarMonths(
	 *   new Date(2014, 8, 1),
	 *   new Date(2014, 0, 31)
	 * )
	 * //=> 8
	 */
	function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
	  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
	  return yearDiff * 12 + monthDiff;
	}
	
	module.exports = exports.default;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(66));
	
	var _index2 = _interopRequireDefault(__webpack_require__(57));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name differenceInCalendarWeeks
	 * @category Week Helpers
	 * @summary Get the number of calendar weeks between the given dates.
	 *
	 * @description
	 * Get the number of calendar weeks between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the number of calendar weeks
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
	 * const result = differenceInCalendarWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5)
	 * )
	 * //=> 3
	 *
	 * @example
	 * // If the week starts on Monday,
	 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
	 * const result = differenceInCalendarWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5),
	 *   { weekStartsOn: 1 }
	 * )
	 * //=> 2
	 */
	
	function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  (0, _index3.default)(2, arguments);
	  var startOfWeekLeft = (0, _index.default)(dirtyDateLeft, dirtyOptions);
	  var startOfWeekRight = (0, _index.default)(dirtyDateRight, dirtyOptions);
	  var timestampLeft = startOfWeekLeft.getTime() - (0, _index2.default)(startOfWeekLeft);
	  var timestampRight = startOfWeekRight.getTime() - (0, _index2.default)(startOfWeekRight); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
	}
	
	module.exports = exports.default;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarYears;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInCalendarYears
	 * @category Year Helpers
	 * @summary Get the number of calendar years between the given dates.
	 *
	 * @description
	 * Get the number of calendar years between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar years are between 31 December 2013 and 11 February 2015?
	 * const result = differenceInCalendarYears(
	 *   new Date(2015, 1, 11),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 2
	 */
	function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() - dateRight.getFullYear();
	}
	
	module.exports = exports.default;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInHours;
	
	var _index = __webpack_require__(30);
	
	var _index2 = _interopRequireDefault(__webpack_require__(135));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	var _index4 = __webpack_require__(108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInHours
	 * @category Hour Helpers
	 * @summary Get the number of hours between the given dates.
	 *
	 * @description
	 * Get the number of hours between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Number} the number of hours
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
	 * const result = differenceInHours(
	 *   new Date(2014, 6, 2, 19, 0),
	 *   new Date(2014, 6, 2, 6, 50)
	 * )
	 * //=> 12
	 */
	function differenceInHours(dateLeft, dateRight, options) {
	  (0, _index3.default)(2, arguments);
	
	  var diff = (0, _index2.default)(dateLeft, dateRight) / _index.millisecondsInHour;
	
	  return (0, _index4.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
	}
	
	module.exports = exports.default;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInMinutes;
	
	var _index = __webpack_require__(30);
	
	var _index2 = _interopRequireDefault(__webpack_require__(135));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	var _index4 = __webpack_require__(108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInMinutes
	 * @category Minute Helpers
	 * @summary Get the number of minutes between the given dates.
	 *
	 * @description
	 * Get the signed number of full (rounded towards 0) minutes between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Number} the number of minutes
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
	 * const result = differenceInMinutes(
	 *   new Date(2014, 6, 2, 12, 20, 0),
	 *   new Date(2014, 6, 2, 12, 7, 59)
	 * )
	 * //=> 12
	 *
	 * @example
	 * // How many minutes are between 10:01:59 and 10:00:00
	 * const result = differenceInMinutes(
	 *   new Date(2000, 0, 1, 10, 0, 0),
	 *   new Date(2000, 0, 1, 10, 1, 59)
	 * )
	 * //=> -1
	 */
	function differenceInMinutes(dateLeft, dateRight, options) {
	  (0, _index3.default)(2, arguments);
	
	  var diff = (0, _index2.default)(dateLeft, dateRight) / _index.millisecondsInMinute;
	
	  return (0, _index4.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
	}
	
	module.exports = exports.default;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInYears;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(292));
	
	var _index3 = _interopRequireDefault(__webpack_require__(75));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInYears
	 * @category Year Helpers
	 * @summary Get the number of full years between the given dates.
	 *
	 * @description
	 * Get the number of full years between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full years are between 31 December 2013 and 11 February 2015?
	 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
	 * //=> 1
	 */
	function differenceInYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index4.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = (0, _index3.default)(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight)); // Set both dates to a valid leap year for accurate comparison when dealing
	  // with leap days
	
	  dateLeft.setFullYear(1584);
	  dateRight.setFullYear(1584); // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
	  // If so, result must be decreased by 1 in absolute value
	
	  var isLastYearNotFull = (0, _index3.default)(dateLeft, dateRight) === -sign;
	  var result = sign * (difference - Number(isLastYearNotFull)); // Prevent negative zero
	
	  return result === 0 ? 0 : result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachDayOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachDayOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of dates within the specified time interval.
	 *
	 * @description
	 * Return the array of dates within the specified time interval.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `eachDay` to `eachDayOfInterval`.
	 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
	 *
	 *   ```
	 *   2.1.3
	 *   time interval
	 *   part of the time axis limited by two instants
	 *   ```
	 *
	 *   Also, this function now accepts an object with `start` and `end` properties
	 *   instead of two arguments as an interval.
	 *   This function now throws `RangeError` if the start of the interval is after its end
	 *   or if any date in the interval is `Invalid Date`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   eachDay(new Date(2014, 0, 10), new Date(2014, 0, 20))
	 *
	 *   // v2.0.0 onward
	 *
	 *   eachDayOfInterval(
	 *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) }
	 *   )
	 *   ```
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
	 * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.step` must be a number greater than 1
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each day between 6 October 2014 and 10 October 2014:
	 * const result = eachDayOfInterval({
	 *   start: new Date(2014, 9, 6),
	 *   end: new Date(2014, 9, 10)
	 * })
	 * //=> [
	 * //   Mon Oct 06 2014 00:00:00,
	 * //   Tue Oct 07 2014 00:00:00,
	 * //   Wed Oct 08 2014 00:00:00,
	 * //   Thu Oct 09 2014 00:00:00,
	 * //   Fri Oct 10 2014 00:00:00
	 * // ]
	 */
	function eachDayOfInterval(dirtyInterval, options) {
	  (0, _index2.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index.default)(interval.start);
	  var endDate = (0, _index.default)(interval.end);
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var dates = [];
	  var currentDate = startDate;
	  currentDate.setHours(0, 0, 0, 0);
	  var step = options && 'step' in options ? Number(options.step) : 1;
	  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index.default)(currentDate));
	    currentDate.setDate(currentDate.getDate() + step);
	    currentDate.setHours(0, 0, 0, 0);
	  }
	
	  return dates;
	}
	
	module.exports = exports.default;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(10));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfWeek
	 * @category Week Helpers
	 * @summary Return the end of a week for the given date.
	 *
	 * @description
	 * Return the end of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the end of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The end of a week for 2 September 2014 11:55:00:
	 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sat Sep 06 2014 23:59:59.999
	 *
	 * @example
	 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
	 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Sun Sep 07 2014 23:59:59.999
	 */
	function endOfWeek(dirtyDate, dirtyOptions) {
	  (0, _index3.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index2.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index2.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
	  date.setDate(date.getDate() + diff);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfYear
	 * @category Year Helpers
	 * @summary Return the end of a year for the given date.
	 *
	 * @description
	 * Return the end of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a year for 2 September 2014 11:55:00:
	 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Dec 31 2014 23:59:59.999
	 */
	function endOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  date.setFullYear(year + 1, 0, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistanceStrict;
	
	var _index = _interopRequireDefault(__webpack_require__(57));
	
	var _index2 = _interopRequireDefault(__webpack_require__(75));
	
	var _index3 = _interopRequireDefault(__webpack_require__(4));
	
	var _index4 = _interopRequireDefault(__webpack_require__(278));
	
	var _index5 = _interopRequireDefault(__webpack_require__(80));
	
	var _index6 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_MINUTE = 1000 * 60;
	var MINUTES_IN_DAY = 60 * 24;
	var MINUTES_IN_MONTH = MINUTES_IN_DAY * 30;
	var MINUTES_IN_YEAR = MINUTES_IN_DAY * 365;
	/**
	 * @name formatDistanceStrict
	 * @category Common Helpers
	 * @summary Return the distance between the given dates in words.
	 *
	 * @description
	 * Return the distance between the given dates in words, using strict units.
	 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
	 * 'less than' and the like.
	 *
	 * | Distance between dates | Result              |
	 * |------------------------|---------------------|
	 * | 0 ... 59 secs          | [0..59] seconds     |
	 * | 1 ... 59 mins          | [1..59] minutes     |
	 * | 1 ... 23 hrs           | [1..23] hours       |
	 * | 1 ... 29 days          | [1..29] days        |
	 * | 1 ... 11 months        | [1..11] months      |
	 * | 1 ... N years          | [1..N]  years       |
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `distanceInWordsStrict` to `formatDistanceStrict`
	 *   to make its name consistent with `format` and `formatRelative`.
	 *
	 * - The order of arguments is swapped to make the function
	 *   consistent with `differenceIn...` functions.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   distanceInWordsStrict(
	 *     new Date(2015, 0, 2),
	 *     new Date(2014, 6, 2)
	 *   ) //=> '6 months'
	 *
	 *   // v2.0.0 onward
	 *
	 *   formatDistanceStrict(
	 *     new Date(2014, 6, 2),
	 *     new Date(2015, 0, 2)
	 *   ) //=> '6 months'
	 *   ```
	 *
	 * - `partialMethod` option is renamed to `roundingMethod`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   distanceInWordsStrict(
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     new Date(1986, 3, 4, 10, 33, 1),
	 *     { partialMethod: 'ceil' }
	 *   ) //=> '2 minutes'
	 *
	 *   // v2.0.0 onward
	 *
	 *   formatDistanceStrict(
	 *     new Date(1986, 3, 4, 10, 33, 1),
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     { roundingMethod: 'ceil' }
	 *   ) //=> '2 minutes'
	 *   ```
	 *
	 * - If `roundingMethod` is not specified, it now defaults to `round` instead of `floor`.
	 *
	 * - `unit` option now accepts one of the strings:
	 *   'second', 'minute', 'hour', 'day', 'month' or 'year' instead of 's', 'm', 'h', 'd', 'M' or 'Y'
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   distanceInWordsStrict(
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     new Date(1986, 3, 4, 10, 33, 1),
	 *     { unit: 'm' }
	 *   )
	 *
	 *   // v2.0.0 onward
	 *
	 *   formatDistanceStrict(
	 *     new Date(1986, 3, 4, 10, 33, 1),
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     { unit: 'minute' }
	 *   )
	 *   ```
	 *
	 * @param {Date|Number} date - the date
	 * @param {Date|Number} baseDate - the date to compare with
	 * @param {Object} [options] - an object with options.
	 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
	 * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
	 * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `baseDate` must not be Invalid Date
	 * @throws {RangeError} `options.roundingMethod` must be 'floor', 'ceil' or 'round'
	 * @throws {RangeError} `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // What is the distance between 2 July 2014 and 1 January 2015?
	 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
	 * //=> '6 months'
	 *
	 * @example
	 * // What is the distance between 1 January 2015 00:00:15
	 * // and 1 January 2015 00:00:00?
	 * const result = formatDistanceStrict(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   new Date(2015, 0, 1, 0, 0, 0)
	 * )
	 * //=> '15 seconds'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, with a suffix?
	 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
	 *   addSuffix: true
	 * })
	 * //=> '1 year ago'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, in minutes?
	 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
	 *   unit: 'minute'
	 * })
	 * //=> '525600 minutes'
	 *
	 * @example
	 * // What is the distance from 1 January 2015
	 * // to 28 January 2015, in months, rounded up?
	 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
	 *   unit: 'month',
	 *   roundingMethod: 'ceil'
	 * })
	 * //=> '1 month'
	 *
	 * @example
	 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
	 *   locale: eoLocale
	 * })
	 * //=> '1 jaro'
	 */
	
	function formatDistanceStrict(dirtyDate, dirtyBaseDate) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  (0, _index6.default)(2, arguments);
	  var locale = options.locale || _index5.default;
	
	  if (!locale.formatDistance) {
	    throw new RangeError('locale must contain localize.formatDistance property');
	  }
	
	  var comparison = (0, _index2.default)(dirtyDate, dirtyBaseDate);
	
	  if (isNaN(comparison)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var localizeOptions = (0, _index4.default)(options);
	  localizeOptions.addSuffix = Boolean(options.addSuffix);
	  localizeOptions.comparison = comparison;
	  var dateLeft;
	  var dateRight;
	
	  if (comparison > 0) {
	    dateLeft = (0, _index3.default)(dirtyBaseDate);
	    dateRight = (0, _index3.default)(dirtyDate);
	  } else {
	    dateLeft = (0, _index3.default)(dirtyDate);
	    dateRight = (0, _index3.default)(dirtyBaseDate);
	  }
	
	  var roundingMethod = options.roundingMethod == null ? 'round' : String(options.roundingMethod);
	  var roundingMethodFn;
	
	  if (roundingMethod === 'floor') {
	    roundingMethodFn = Math.floor;
	  } else if (roundingMethod === 'ceil') {
	    roundingMethodFn = Math.ceil;
	  } else if (roundingMethod === 'round') {
	    roundingMethodFn = Math.round;
	  } else {
	    throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
	  }
	
	  var milliseconds = dateRight.getTime() - dateLeft.getTime();
	  var minutes = milliseconds / MILLISECONDS_IN_MINUTE;
	  var timezoneOffset = (0, _index.default)(dateRight) - (0, _index.default)(dateLeft); // Use DST-normalized difference in minutes for years, months and days;
	  // use regular difference in minutes for hours, minutes and seconds.
	
	  var dstNormalizedMinutes = (milliseconds - timezoneOffset) / MILLISECONDS_IN_MINUTE;
	  var unit;
	
	  if (options.unit == null) {
	    if (minutes < 1) {
	      unit = 'second';
	    } else if (minutes < 60) {
	      unit = 'minute';
	    } else if (minutes < MINUTES_IN_DAY) {
	      unit = 'hour';
	    } else if (dstNormalizedMinutes < MINUTES_IN_MONTH) {
	      unit = 'day';
	    } else if (dstNormalizedMinutes < MINUTES_IN_YEAR) {
	      unit = 'month';
	    } else {
	      unit = 'year';
	    }
	  } else {
	    unit = String(options.unit);
	  } // 0 up to 60 seconds
	
	
	  if (unit === 'second') {
	    var seconds = roundingMethodFn(milliseconds / 1000);
	    return locale.formatDistance('xSeconds', seconds, localizeOptions); // 1 up to 60 mins
	  } else if (unit === 'minute') {
	    var roundedMinutes = roundingMethodFn(minutes);
	    return locale.formatDistance('xMinutes', roundedMinutes, localizeOptions); // 1 up to 24 hours
	  } else if (unit === 'hour') {
	    var hours = roundingMethodFn(minutes / 60);
	    return locale.formatDistance('xHours', hours, localizeOptions); // 1 up to 30 days
	  } else if (unit === 'day') {
	    var days = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_DAY);
	    return locale.formatDistance('xDays', days, localizeOptions); // 1 up to 12 months
	  } else if (unit === 'month') {
	    var months = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_MONTH);
	    return months === 12 && options.unit !== 'month' ? locale.formatDistance('xYears', 1, localizeOptions) : locale.formatDistance('xMonths', months, localizeOptions); // 1 year up to max Date
	  } else if (unit === 'year') {
	    var years = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_YEAR);
	    return locale.formatDistance('xYears', years, localizeOptions);
	  }
	
	  throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
	}
	
	module.exports = exports.default;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	
	var _index = _interopRequireDefault(__webpack_require__(75));
	
	var _index2 = _interopRequireDefault(__webpack_require__(136));
	
	var _index3 = _interopRequireDefault(__webpack_require__(204));
	
	var _index4 = _interopRequireDefault(__webpack_require__(80));
	
	var _index5 = _interopRequireDefault(__webpack_require__(4));
	
	var _index6 = _interopRequireDefault(__webpack_require__(278));
	
	var _index7 = _interopRequireDefault(__webpack_require__(57));
	
	var _index8 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MINUTES_IN_DAY = 1440;
	var MINUTES_IN_ALMOST_TWO_DAYS = 2520;
	var MINUTES_IN_MONTH = 43200;
	var MINUTES_IN_TWO_MONTHS = 86400;
	/**
	 * @name formatDistance
	 * @category Common Helpers
	 * @summary Return the distance between the given dates in words.
	 *
	 * @description
	 * Return the distance between the given dates in words.
	 *
	 * | Distance between dates                                            | Result              |
	 * |-------------------------------------------------------------------|---------------------|
	 * | 0 ... 30 secs                                                     | less than a minute  |
	 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
	 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
	 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
	 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
	 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
	 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
	 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
	 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
	 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
	 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
	 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
	 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
	 * | N yrs ... N yrs 3 months                                          | about N years       |
	 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
	 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
	 *
	 * With `options.includeSeconds == true`:
	 * | Distance between dates | Result               |
	 * |------------------------|----------------------|
	 * | 0 secs ... 5 secs      | less than 5 seconds  |
	 * | 5 secs ... 10 secs     | less than 10 seconds |
	 * | 10 secs ... 20 secs    | less than 20 seconds |
	 * | 20 secs ... 40 secs    | half a minute        |
	 * | 40 secs ... 60 secs    | less than a minute   |
	 * | 60 secs ... 90 secs    | 1 minute             |
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `distanceInWords ` to `formatDistance`
	 *   to make its name consistent with `format` and `formatRelative`.
	 *
	 * - The order of arguments is swapped to make the function
	 *   consistent with `differenceIn...` functions.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   distanceInWords(
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     new Date(1986, 3, 4, 11, 32, 0),
	 *     { addSuffix: true }
	 *   ) //=> 'in about 1 hour'
	 *
	 *   // v2.0.0 onward
	 *
	 *   formatDistance(
	 *     new Date(1986, 3, 4, 11, 32, 0),
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     { addSuffix: true }
	 *   ) //=> 'in about 1 hour'
	 *   ```
	 *
	 * @param {Date|Number} date - the date
	 * @param {Date|Number} baseDate - the date to compare with
	 * @param {Object} [options] - an object with options.
	 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
	 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `baseDate` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // What is the distance between 2 July 2014 and 1 January 2015?
	 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
	 * //=> '6 months'
	 *
	 * @example
	 * // What is the distance between 1 January 2015 00:00:15
	 * // and 1 January 2015 00:00:00, including seconds?
	 * const result = formatDistance(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   new Date(2015, 0, 1, 0, 0, 0),
	 *   { includeSeconds: true }
	 * )
	 * //=> 'less than 20 seconds'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, with a suffix?
	 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
	 *   addSuffix: true
	 * })
	 * //=> 'about 1 year ago'
	 *
	 * @example
	 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
	 *   locale: eoLocale
	 * })
	 * //=> 'pli ol 1 jaro'
	 */
	
	function formatDistance(dirtyDate, dirtyBaseDate) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  (0, _index8.default)(2, arguments);
	  var locale = options.locale || _index4.default;
	
	  if (!locale.formatDistance) {
	    throw new RangeError('locale must contain formatDistance property');
	  }
	
	  var comparison = (0, _index.default)(dirtyDate, dirtyBaseDate);
	
	  if (isNaN(comparison)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var localizeOptions = (0, _index6.default)(options);
	  localizeOptions.addSuffix = Boolean(options.addSuffix);
	  localizeOptions.comparison = comparison;
	  var dateLeft;
	  var dateRight;
	
	  if (comparison > 0) {
	    dateLeft = (0, _index5.default)(dirtyBaseDate);
	    dateRight = (0, _index5.default)(dirtyDate);
	  } else {
	    dateLeft = (0, _index5.default)(dirtyDate);
	    dateRight = (0, _index5.default)(dirtyBaseDate);
	  }
	
	  var seconds = (0, _index3.default)(dateRight, dateLeft);
	  var offsetInSeconds = ((0, _index7.default)(dateRight) - (0, _index7.default)(dateLeft)) / 1000;
	  var minutes = Math.round((seconds - offsetInSeconds) / 60);
	  var months; // 0 up to 2 mins
	
	  if (minutes < 2) {
	    if (options.includeSeconds) {
	      if (seconds < 5) {
	        return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
	      } else if (seconds < 10) {
	        return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
	      } else if (seconds < 20) {
	        return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
	      } else if (seconds < 40) {
	        return locale.formatDistance('halfAMinute', null, localizeOptions);
	      } else if (seconds < 60) {
	        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
	      } else {
	        return locale.formatDistance('xMinutes', 1, localizeOptions);
	      }
	    } else {
	      if (minutes === 0) {
	        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
	      } else {
	        return locale.formatDistance('xMinutes', minutes, localizeOptions);
	      }
	    } // 2 mins up to 0.75 hrs
	
	  } else if (minutes < 45) {
	    return locale.formatDistance('xMinutes', minutes, localizeOptions); // 0.75 hrs up to 1.5 hrs
	  } else if (minutes < 90) {
	    return locale.formatDistance('aboutXHours', 1, localizeOptions); // 1.5 hrs up to 24 hrs
	  } else if (minutes < MINUTES_IN_DAY) {
	    var hours = Math.round(minutes / 60);
	    return locale.formatDistance('aboutXHours', hours, localizeOptions); // 1 day up to 1.75 days
	  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
	    return locale.formatDistance('xDays', 1, localizeOptions); // 1.75 days up to 30 days
	  } else if (minutes < MINUTES_IN_MONTH) {
	    var days = Math.round(minutes / MINUTES_IN_DAY);
	    return locale.formatDistance('xDays', days, localizeOptions); // 1 month up to 2 months
	  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
	    months = Math.round(minutes / MINUTES_IN_MONTH);
	    return locale.formatDistance('aboutXMonths', months, localizeOptions);
	  }
	
	  months = (0, _index2.default)(dateRight, dateLeft); // 2 months up to 12 months
	
	  if (months < 12) {
	    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
	    return locale.formatDistance('xMonths', nearestMonth, localizeOptions); // 1 year up to max Date
	  } else {
	    var monthsSinceStartOfYear = months % 12;
	    var years = Math.floor(months / 12); // N years up to 1 years 3 months
	
	    if (monthsSinceStartOfYear < 3) {
	      return locale.formatDistance('aboutXYears', years, localizeOptions); // N years 3 months up to N years 9 months
	    } else if (monthsSinceStartOfYear < 9) {
	      return locale.formatDistance('overXYears', years, localizeOptions); // N years 9 months up to N year 12 months
	    } else {
	      return locale.formatDistance('almostXYears', years + 1, localizeOptions);
	    }
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = format;
	
	var _index = _interopRequireDefault(__webpack_require__(51));
	
	var _index2 = _interopRequireDefault(__webpack_require__(80));
	
	var _index3 = _interopRequireDefault(__webpack_require__(114));
	
	var _index4 = _interopRequireDefault(__webpack_require__(4));
	
	var _index5 = _interopRequireDefault(__webpack_require__(865));
	
	var _index6 = _interopRequireDefault(__webpack_require__(280));
	
	var _index7 = _interopRequireDefault(__webpack_require__(57));
	
	var _index8 = __webpack_require__(284);
	
	var _index9 = _interopRequireDefault(__webpack_require__(10));
	
	var _index10 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This RegExp consists of three parts separated by `|`:
	// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
	//   (one of the certain letters followed by `o`)
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
	// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
	
	var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	/**
	 * @name format
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format. The result may vary by locale.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://git.io/fxCyr
	 *
	 * The characters wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 * (see the last example)
	 *
	 * Format of the string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 7 below the table).
	 *
	 * Accepted patterns:
	 * | Unit                            | Pattern | Result examples                   | Notes |
	 * |---------------------------------|---------|-----------------------------------|-------|
	 * | Era                             | G..GGG  | AD, BC                            |       |
	 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 | GGGGG   | A, B                              |       |
	 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
	 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
	 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
	 * |                                 | yyyyy   | ...                               | 3,5   |
	 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
	 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
	 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
	 * |                                 | YYYYY   | ...                               | 3,5   |
	 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
	 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
	 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
	 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
	 * |                                 | RRRRR   | ...                               | 3,5,7 |
	 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
	 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
	 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
	 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
	 * |                                 | uuuuu   | ...                               | 3,5   |
	 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
	 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
	 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | qq      | 01, 02, 03, 04                    |       |
	 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
	 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
	 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | MM      | 01, 02, ..., 12                   |       |
	 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 | MMMM    | January, February, ..., December  | 2     |
	 * |                                 | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
	 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | LL      | 01, 02, ..., 12                   |       |
	 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 | LLLL    | January, February, ..., December  | 2     |
	 * |                                 | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
	 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
	 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | II      | 01, 02, ..., 53                   | 7     |
	 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
	 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
	 * |                                 | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
	 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
	 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
	 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 | DDDD    | ...                               | 3     |
	 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
	 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
	 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
	 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
	 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
	 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
	 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
	 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | ee      | 02, 03, ..., 01                   |       |
	 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | cc      | 02, 03, ..., 01                   |       |
	 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | AM, PM                          | a..aa   | AM, PM                            |       |
	 * |                                 | aaa     | am, pm                            |       |
	 * |                                 | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
	 * |                                 | bbb     | am, pm, noon, midnight            |       |
	 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
	 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
	 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
	 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
	 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          | m       | 0, 1, ..., 59                     |       |
	 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          | s       | 0, 1, ..., 59                     |       |
	 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | ss      | 00, 01, ..., 59                   |       |
	 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
	 * |                                 | SS      | 00, 01, ..., 99                   |       |
	 * |                                 | SSS     | 000, 001, ..., 999                |       |
	 * |                                 | SSSS    | ...                               | 3     |
	 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
	 * |                                 | XX      | -0800, +0530, Z                   |       |
	 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
	 * |                                 | xx      | -0800, +0530, +0000               |       |
	 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
	 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
	 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
	 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
	 * | Seconds timestamp               | t       | 512969520                         | 7     |
	 * |                                 | tt      | ...                               | 3,7   |
	 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
	 * |                                 | TT      | ...                               | 3,7   |
	 * | Long localized date             | P       | 04/29/1453                        | 7     |
	 * |                                 | PP      | Apr 29, 1453                      | 7     |
	 * |                                 | PPP     | April 29th, 1453                  | 7     |
	 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
	 * | Long localized time             | p       | 12:00 AM                          | 7     |
	 * |                                 | pp      | 12:00:00 AM                       | 7     |
	 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
	 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
	 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
	 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
	 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
	 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
	 *    the output will be the same as default pattern for this unit, usually
	 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
	 *    are marked with "2" in the last column of the table.
	 *
	 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
	 *
	 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
	 *    The output will be padded with zeros to match the length of the pattern.
	 *
	 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
	 *
	 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 5. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` always returns the last two digits of a year,
	 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
	 *
	 *    | Year | `yy` | `uu` |
	 *    |------|------|------|
	 *    | 1    |   01 |   01 |
	 *    | 14   |   14 |   14 |
	 *    | 376  |   76 |  376 |
	 *    | 1453 |   53 | 1453 |
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
	 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
	 *
	 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
	 *    so right now these tokens fall back to GMT timezones.
	 *
	 * 7. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `t`: seconds timestamp
	 *    - `T`: milliseconds timestamp
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The second argument is now required for the sake of explicitness.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   format(new Date(2016, 0, 1))
	 *
	 *   // v2.0.0 onward
	 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
	 *   ```
	 *
	 * - New format string API for `format` function
	 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
	 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
	 *
	 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {String} format - the string of tokens
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://git.io/fxCyr
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://git.io/fxCyr
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `localize` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Represent 11 February 2014 in middle-endian format:
	 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
	 * //=> '02/11/2014'
	 *
	 * @example
	 * // Represent 2 July 2014 in Esperanto:
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
	 *   locale: eoLocale
	 * })
	 * //=> '2-a de julio 2014'
	 *
	 * @example
	 * // Escape string by single quote characters:
	 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
	 * //=> "3 o'clock"
	 */
	
	function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
	  (0, _index10.default)(2, arguments);
	  var formatStr = String(dirtyFormatStr);
	  var options = dirtyOptions || {};
	  var locale = options.locale || _index2.default;
	  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index9.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index9.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	
	  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index9.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index9.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  if (!locale.localize) {
	    throw new RangeError('locale must contain localize property');
	  }
	
	  if (!locale.formatLong) {
	    throw new RangeError('locale must contain formatLong property');
	  }
	
	  var originalDate = (0, _index4.default)(dirtyDate);
	
	  if (!(0, _index.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
	
	
	  var timezoneOffset = (0, _index7.default)(originalDate);
	  var utcDate = (0, _index3.default)(originalDate, timezoneOffset);
	  var formatterOptions = {
	    firstWeekContainsDate: firstWeekContainsDate,
	    weekStartsOn: weekStartsOn,
	    locale: locale,
	    _originalDate: originalDate
	  };
	  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === 'p' || firstCharacter === 'P') {
	      var longFormatter = _index6.default[firstCharacter];
	      return longFormatter(substring, locale.formatLong, formatterOptions);
	    }
	
	    return substring;
	  }).join('').match(formattingTokensRegExp).map(function (substring) {
	    // Replace two single quote characters with one single quote character
	    if (substring === "''") {
	      return "'";
	    }
	
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === "'") {
	      return cleanEscapedString(substring);
	    }
	
	    var formatter = _index5.default[firstCharacter];
	
	    if (formatter) {
	      if (!options.useAdditionalWeekYearTokens && (0, _index8.isProtectedWeekYearToken)(substring)) {
	        (0, _index8.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
	      }
	
	      if (!options.useAdditionalDayOfYearTokens && (0, _index8.isProtectedDayOfYearToken)(substring)) {
	        (0, _index8.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
	      }
	
	      return formatter(utcDate, substring, locale.localize, formatterOptions);
	    }
	
	    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	    }
	
	    return substring;
	  }).join('');
	  return result;
	}
	
	function cleanEscapedString(input) {
	  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
	}
	
	module.exports = exports.default;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDate;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDate
	 * @category Day Helpers
	 * @summary Get the day of the month of the given date.
	 *
	 * @description
	 * Get the day of the month of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the month is 29 February 2012?
	 * const result = getDate(new Date(2012, 1, 29))
	 * //=> 29
	 */
	function getDate(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dayOfMonth = date.getDate();
	  return dayOfMonth;
	}
	
	module.exports = exports.default;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDaysInMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDaysInMonth
	 * @category Month Helpers
	 * @summary Get the number of days in a month of the given date.
	 *
	 * @description
	 * Get the number of days in a month of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the number of days in a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // How many days are in February 2000?
	 * const result = getDaysInMonth(new Date(2000, 1))
	 * //=> 29
	 */
	function getDaysInMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var monthIndex = date.getMonth();
	  var lastDayOfMonth = new Date(0);
	  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
	  lastDayOfMonth.setHours(0, 0, 0, 0);
	  return lastDayOfMonth.getDate();
	}
	
	module.exports = exports.default;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISODay;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getISODay
	 * @category Weekday Helpers
	 * @summary Get the day of the ISO week of the given date.
	 *
	 * @description
	 * Get the day of the ISO week of the given date,
	 * which is 7 for Sunday, 1 for Monday etc.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the ISO week is 26 February 2012?
	 * const result = getISODay(new Date(2012, 1, 26))
	 * //=> 7
	 */
	function getISODay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	
	  if (day === 0) {
	    day = 7;
	  }
	
	  return day;
	}
	
	module.exports = exports.default;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(81));
	
	var _index3 = _interopRequireDefault(__webpack_require__(113));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name getISOWeek
	 * @category ISO Week Helpers
	 * @summary Get the ISO week of the given date.
	 *
	 * @description
	 * Get the ISO week of the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which week of the ISO-week numbering year is 2 January 2005?
	 * const result = getISOWeek(new Date(2005, 0, 2))
	 * //=> 53
	 */
	
	function getISOWeek(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime(); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	
	module.exports = exports.default;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getQuarter
	 * @category Quarter Helpers
	 * @summary Get the year quarter of the given date.
	 *
	 * @description
	 * Get the year quarter of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which quarter is 2 July 2014?
	 * const result = getQuarter(new Date(2014, 6, 2))
	 * //=> 3
	 */
	function getQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var quarter = Math.floor(date.getMonth() / 3) + 1;
	  return quarter;
	}
	
	module.exports = exports.default;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTime;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getTime
	 * @category Timestamp Helpers
	 * @summary Get the milliseconds timestamp of the given date.
	 *
	 * @description
	 * Get the milliseconds timestamp of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the timestamp
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the timestamp of 29 February 2012 11:45:05.123:
	 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 1330515905123
	 */
	function getTime(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var timestamp = date.getTime();
	  return timestamp;
	}
	
	module.exports = exports.default;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(66));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(10));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getWeekYear
	 * @category Week-Numbering Year Helpers
	 * @summary Get the local week-numbering year of the given date.
	 *
	 * @description
	 * Get the local week-numbering year of the given date.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Number} the local week-numbering year
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Which week numbering year is 26 December 2004 with the default settings?
	 * const result = getWeekYear(new Date(2004, 11, 26))
	 * //=> 2005
	 *
	 * @example
	 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
	 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
	 * //=> 2004
	 *
	 * @example
	 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
	 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
	 * //=> 2004
	 */
	function getWeekYear(dirtyDate, options) {
	  var _options$locale, _options$locale$optio;
	
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var year = date.getFullYear();
	  var localeFirstWeekContainsDate = options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index3.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = (options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) == null ? defaultFirstWeekContainsDate : (0, _index3.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	
	  var firstWeekOfNextYear = new Date(0);
	  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
	  firstWeekOfNextYear.setHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index.default)(firstWeekOfNextYear, options);
	  var firstWeekOfThisYear = new Date(0);
	  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
	  firstWeekOfThisYear.setHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index.default)(firstWeekOfThisYear, options);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(66));
	
	var _index2 = _interopRequireDefault(__webpack_require__(215));
	
	var _index3 = _interopRequireDefault(__webpack_require__(4));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name getWeek
	 * @category Week Helpers
	 * @summary Get the local week index of the given date.
	 *
	 * @description
	 * Get the local week index of the given date.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Number} the week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Which week of the local week numbering year is 2 January 2005 with default options?
	 * const result = getISOWeek(new Date(2005, 0, 2))
	 * //=> 2
	 *
	 * // Which week of the local week numbering year is 2 January 2005,
	 * // if Monday is the first day of the week,
	 * // and the first week of the year always contains 4 January?
	 * const result = getISOWeek(new Date(2005, 0, 2), {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> 53
	 */
	
	function getWeek(dirtyDate, options) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index3.default)(dirtyDate);
	  var diff = (0, _index.default)(date, options).getTime() - (0, _index2.default)(date, options).getTime(); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	
	module.exports = exports.default;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDate;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isDate
	 * @category Common Helpers
	 * @summary Is the given value a date?
	 *
	 * @description
	 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {*} value - the value to check
	 * @returns {boolean} true if the given value is a date
	 * @throws {TypeError} 1 arguments required
	 *
	 * @example
	 * // For a valid date:
	 * const result = isDate(new Date())
	 * //=> true
	 *
	 * @example
	 * // For an invalid date:
	 * const result = isDate(new Date(NaN))
	 * //=> true
	 *
	 * @example
	 * // For some value:
	 * const result = isDate('2014-02-31')
	 * //=> false
	 *
	 * @example
	 * // For an object:
	 * const result = isDate({})
	 * //=> false
	 */
	function isDate(value) {
	  (0, _index.default)(1, arguments);
	  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
	}
	
	module.exports = exports.default;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isLastDayOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(206));
	
	var _index3 = _interopRequireDefault(__webpack_require__(207));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isLastDayOfMonth
	 * @category Month Helpers
	 * @summary Is the given date the last day of a month?
	 *
	 * @description
	 * Is the given date the last day of a month?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is the last day of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 28 February 2014 the last day of a month?
	 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
	 * //=> true
	 */
	function isLastDayOfMonth(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  return (0, _index2.default)(date).getTime() === (0, _index3.default)(date).getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isLeapYear;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isLeapYear
	 * @category Year Helpers
	 * @summary Is the given date in the leap year?
	 *
	 * @description
	 * Is the given date in the leap year?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in the leap year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 1 September 2012 in the leap year?
	 * var result = isLeapYear(new Date(2012, 8, 1))
	 * //=> true
	 */
	function isLeapYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
	}
	
	module.exports = exports.default;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameHour;
	
	var _index = _interopRequireDefault(__webpack_require__(337));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameHour
	 * @category Hour Helpers
	 * @summary Are the given dates in the same hour?
	 *
	 * @description
	 * Are the given dates in the same hour?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same hour
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
	 * var result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
	 * //=> true
	 */
	function isSameHour(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfHour = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfHour = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(209));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameISOWeek
	 * @category ISO Week Helpers
	 * @summary Are the given dates in the same ISO week?
	 *
	 * @description
	 * Are the given dates in the same ISO week?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same ISO week
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
	 * var result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
	 * //=> true
	 */
	function isSameISOWeek(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  return (0, _index.default)(dirtyDateLeft, dirtyDateRight, {
	    weekStartsOn: 1
	  });
	}
	
	module.exports = exports.default;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameMinute;
	
	var _index = _interopRequireDefault(__webpack_require__(213));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameMinute
	 * @category Minute Helpers
	 * @summary Are the given dates in the same minute?
	 *
	 * @description
	 * Are the given dates in the same minute?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same minute
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15
	 * // in the same minute?
	 * var result = isSameMinute(
	 *   new Date(2014, 8, 4, 6, 30),
	 *   new Date(2014, 8, 4, 6, 30, 15)
	 * )
	 * //=> true
	 */
	function isSameMinute(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfMinute = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfMinute = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameMonth
	 * @category Month Helpers
	 * @summary Are the given dates in the same month?
	 *
	 * @description
	 * Are the given dates in the same month?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same month
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same month?
	 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
	 * //=> true
	 */
	function isSameMonth(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
	}
	
	module.exports = exports.default;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(214));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameQuarter
	 * @category Quarter Helpers
	 * @summary Are the given dates in the same year quarter?
	 *
	 * @description
	 * Are the given dates in the same year quarter?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same quarter
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
	 * var result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
	 * //=> true
	 */
	function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfQuarter = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfQuarter = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameSecond;
	
	var _index = _interopRequireDefault(__webpack_require__(338));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameSecond
	 * @category Second Helpers
	 * @summary Are the given dates in the same second?
	 *
	 * @description
	 * Are the given dates in the same second?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same second
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500
	 * // in the same second?
	 * var result = isSameSecond(
	 *   new Date(2014, 8, 4, 6, 30, 15),
	 *   new Date(2014, 8, 4, 6, 30, 15, 500)
	 * )
	 * //=> true
	 */
	function isSameSecond(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfSecond = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfSecond = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameYear;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameYear
	 * @category Year Helpers
	 * @summary Are the given dates in the same year?
	 *
	 * @description
	 * Are the given dates in the same year?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same year
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same year?
	 * var result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
	 * //=> true
	 */
	function isSameYear(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() === dateRight.getFullYear();
	}
	
	module.exports = exports.default;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSaturday;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSaturday
	 * @category Weekday Helpers
	 * @summary Is the given date Saturday?
	 *
	 * @description
	 * Is the given date Saturday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Saturday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 27 September 2014 Saturday?
	 * var result = isSaturday(new Date(2014, 8, 27))
	 * //=> true
	 */
	function isSaturday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 6;
	}
	
	module.exports = exports.default;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfMonth
	 * @category Month Helpers
	 * @summary Return the last day of a month for the given date.
	 *
	 * @description
	 * Return the last day of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of a month for 2 September 2014 11:55:00:
	 * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function lastDayOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  date.setFullYear(date.getFullYear(), month + 1, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(10));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfWeek
	 * @category Week Helpers
	 * @summary Return the last day of a week for the given date.
	 *
	 * @description
	 * Return the last day of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the last day of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The last day of a week for 2 September 2014 11:55:00:
	 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sat Sep 06 2014 00:00:00
	 *
	 * @example
	 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
	 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function lastDayOfWeek(dirtyDate, dirtyOptions) {
	  (0, _index3.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index2.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index2.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
	  date.setHours(0, 0, 0, 0);
	  date.setDate(date.getDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var numberValues = {
	  locale: {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	  },
	  number: {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	  }
	};
	var eraValues = {
	  narrow: ['খ্রিঃপূঃ', 'খ্রিঃ'],
	  abbreviated: ['খ্রিঃপূর্ব', 'খ্রিঃ'],
	  wide: ['খ্রিস্টপূর্ব', 'খ্রিস্টাব্দ']
	};
	var quarterValues = {
	  narrow: ['১', '২', '৩', '৪'],
	  abbreviated: ['১ত্রৈ', '২ত্রৈ', '৩ত্রৈ', '৪ত্রৈ'],
	  wide: ['১ম ত্রৈমাসিক', '২য় ত্রৈমাসিক', '৩য় ত্রৈমাসিক', '৪র্থ ত্রৈমাসিক']
	};
	var monthValues = {
	  narrow: ['জানু', 'ফেব্রু', 'মার্চ', 'এপ্রিল', 'মে', 'জুন', 'জুলাই', 'আগস্ট', 'সেপ্ট', 'অক্টো', 'নভে', 'ডিসে'],
	  abbreviated: ['জানু', 'ফেব্রু', 'মার্চ', 'এপ্রিল', 'মে', 'জুন', 'জুলাই', 'আগস্ট', 'সেপ্ট', 'অক্টো', 'নভে', 'ডিসে'],
	  wide: ['জানুয়ারি', 'ফেব্রুয়ারি', 'মার্চ', 'এপ্রিল', 'মে', 'জুন', 'জুলাই', 'আগস্ট', 'সেপ্টেম্বর', 'অক্টোবর', 'নভেম্বর', 'ডিসেম্বর']
	};
	var dayValues = {
	  narrow: ['র', 'সো', 'ম', 'বু', 'বৃ', 'শু', 'শ'],
	  short: ['রবি', 'সোম', 'মঙ্গল', 'বুধ', 'বৃহ', 'শুক্র', 'শনি'],
	  abbreviated: ['রবি', 'সোম', 'মঙ্গল', 'বুধ', 'বৃহ', 'শুক্র', 'শনি'],
	  wide: ['রবিবার', 'সোমবার', 'মঙ্গলবার', 'বুধবার', 'বৃহস্পতিবার ', 'শুক্রবার', 'শনিবার']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'পূ',
	    pm: 'অপ',
	    midnight: 'মধ্যরাত',
	    noon: 'মধ্যাহ্ন',
	    morning: 'সকাল',
	    afternoon: 'বিকাল',
	    evening: 'সন্ধ্যা',
	    night: 'রাত'
	  },
	  abbreviated: {
	    am: 'পূর্বাহ্ন',
	    pm: 'অপরাহ্ন',
	    midnight: 'মধ্যরাত',
	    noon: 'মধ্যাহ্ন',
	    morning: 'সকাল',
	    afternoon: 'বিকাল',
	    evening: 'সন্ধ্যা',
	    night: 'রাত'
	  },
	  wide: {
	    am: 'পূর্বাহ্ন',
	    pm: 'অপরাহ্ন',
	    midnight: 'মধ্যরাত',
	    noon: 'মধ্যাহ্ন',
	    morning: 'সকাল',
	    afternoon: 'বিকাল',
	    evening: 'সন্ধ্যা',
	    night: 'রাত'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'পূ',
	    pm: 'অপ',
	    midnight: 'মধ্যরাত',
	    noon: 'মধ্যাহ্ন',
	    morning: 'সকাল',
	    afternoon: 'বিকাল',
	    evening: 'সন্ধ্যা',
	    night: 'রাত'
	  },
	  abbreviated: {
	    am: 'পূর্বাহ্ন',
	    pm: 'অপরাহ্ন',
	    midnight: 'মধ্যরাত',
	    noon: 'মধ্যাহ্ন',
	    morning: 'সকাল',
	    afternoon: 'বিকাল',
	    evening: 'সন্ধ্যা',
	    night: 'রাত'
	  },
	  wide: {
	    am: 'পূর্বাহ্ন',
	    pm: 'অপরাহ্ন',
	    midnight: 'মধ্যরাত',
	    noon: 'মধ্যাহ্ন',
	    morning: 'সকাল',
	    afternoon: 'বিকাল',
	    evening: 'সন্ধ্যা',
	    night: 'রাত'
	  }
	};
	
	function dateOrdinalNumber(number, localeNumber) {
	  if (number > 18 && number <= 31) {
	    return localeNumber + 'শে';
	  } else {
	    switch (number) {
	      case 1:
	        return localeNumber + 'লা';
	
	      case 2:
	      case 3:
	        return localeNumber + 'রা';
	
	      case 4:
	        return localeNumber + 'ঠা';
	
	      default:
	        return localeNumber + 'ই';
	    }
	  }
	}
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var number = localize.localeToNumber(dirtyNumber);
	  var localeNumber = localize.numberToLocale(number);
	  var unit = dirtyOptions.unit;
	
	  if (unit === 'date') {
	    return dateOrdinalNumber(number, localeNumber);
	  }
	
	  if (number > 10 || number === 0) return localeNumber + 'তম';
	  var rem10 = number % 10;
	
	  switch (rem10) {
	    case 2:
	    case 3:
	      return localeNumber + 'য়';
	
	    case 4:
	      return localeNumber + 'র্থ';
	
	    case 6:
	      return localeNumber + 'ষ্ঠ';
	
	    case 1:
	    case 5:
	    case 7:
	    case 8:
	    case 9:
	    case 0:
	      return localeNumber + 'ম';
	  }
	}
	
	function localeToNumber(locale) {
	  var number = locale.toString().replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	    return numberValues.number[match];
	  });
	  return Number(number);
	}
	
	function numberToLocale(number) {
	  return number.toString().replace(/\d/g, function (match) {
	    return numberValues.locale[match];
	  });
	}
	
	var localize = {
	  localeToNumber: localeToNumber,
	  numberToLocale: numberToLocale,
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 324 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    standalone: {
	      one: 'weniger als 1 Sekunde',
	      other: 'weniger als {{count}} Sekunden'
	    },
	    withPreposition: {
	      one: 'weniger als 1 Sekunde',
	      other: 'weniger als {{count}} Sekunden'
	    }
	  },
	  xSeconds: {
	    standalone: {
	      one: '1 Sekunde',
	      other: '{{count}} Sekunden'
	    },
	    withPreposition: {
	      one: '1 Sekunde',
	      other: '{{count}} Sekunden'
	    }
	  },
	  halfAMinute: {
	    standalone: 'halbe Minute',
	    withPreposition: 'halben Minute'
	  },
	  lessThanXMinutes: {
	    standalone: {
	      one: 'weniger als 1 Minute',
	      other: 'weniger als {{count}} Minuten'
	    },
	    withPreposition: {
	      one: 'weniger als 1 Minute',
	      other: 'weniger als {{count}} Minuten'
	    }
	  },
	  xMinutes: {
	    standalone: {
	      one: '1 Minute',
	      other: '{{count}} Minuten'
	    },
	    withPreposition: {
	      one: '1 Minute',
	      other: '{{count}} Minuten'
	    }
	  },
	  aboutXHours: {
	    standalone: {
	      one: 'etwa 1 Stunde',
	      other: 'etwa {{count}} Stunden'
	    },
	    withPreposition: {
	      one: 'etwa 1 Stunde',
	      other: 'etwa {{count}} Stunden'
	    }
	  },
	  xHours: {
	    standalone: {
	      one: '1 Stunde',
	      other: '{{count}} Stunden'
	    },
	    withPreposition: {
	      one: '1 Stunde',
	      other: '{{count}} Stunden'
	    }
	  },
	  xDays: {
	    standalone: {
	      one: '1 Tag',
	      other: '{{count}} Tage'
	    },
	    withPreposition: {
	      one: '1 Tag',
	      other: '{{count}} Tagen'
	    }
	  },
	  aboutXWeeks: {
	    standalone: {
	      one: 'etwa 1 Woche',
	      other: 'etwa {{count}} Wochen'
	    },
	    withPreposition: {
	      one: 'etwa 1 Woche',
	      other: 'etwa {{count}} Wochen'
	    }
	  },
	  xWeeks: {
	    standalone: {
	      one: '1 Woche',
	      other: '{{count}} Wochen'
	    },
	    withPreposition: {
	      one: '1 Woche',
	      other: '{{count}} Wochen'
	    }
	  },
	  aboutXMonths: {
	    standalone: {
	      one: 'etwa 1 Monat',
	      other: 'etwa {{count}} Monate'
	    },
	    withPreposition: {
	      one: 'etwa 1 Monat',
	      other: 'etwa {{count}} Monaten'
	    }
	  },
	  xMonths: {
	    standalone: {
	      one: '1 Monat',
	      other: '{{count}} Monate'
	    },
	    withPreposition: {
	      one: '1 Monat',
	      other: '{{count}} Monaten'
	    }
	  },
	  aboutXYears: {
	    standalone: {
	      one: 'etwa 1 Jahr',
	      other: 'etwa {{count}} Jahre'
	    },
	    withPreposition: {
	      one: 'etwa 1 Jahr',
	      other: 'etwa {{count}} Jahren'
	    }
	  },
	  xYears: {
	    standalone: {
	      one: '1 Jahr',
	      other: '{{count}} Jahre'
	    },
	    withPreposition: {
	      one: '1 Jahr',
	      other: '{{count}} Jahren'
	    }
	  },
	  overXYears: {
	    standalone: {
	      one: 'mehr als 1 Jahr',
	      other: 'mehr als {{count}} Jahre'
	    },
	    withPreposition: {
	      one: 'mehr als 1 Jahr',
	      other: 'mehr als {{count}} Jahren'
	    }
	  },
	  almostXYears: {
	    standalone: {
	      one: 'fast 1 Jahr',
	      other: 'fast {{count}} Jahre'
	    },
	    withPreposition: {
	      one: 'fast 1 Jahr',
	      other: 'fast {{count}} Jahren'
	    }
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  var result;
	  var tokenValue = options !== null && options !== void 0 && options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
	
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    result = tokenValue.one;
	  } else {
	    result = tokenValue.other.replace('{{count}}', String(count));
	  }
	
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'in ' + result;
	    } else {
	      return 'vor ' + result;
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
	var dateFormats = {
	  full: 'EEEE, do MMMM y',
	  // Montag, 7. Januar 2018
	  long: 'do MMMM y',
	  // 7. Januar 2018
	  medium: 'do MMM y',
	  // 7. Jan. 2018
	  short: 'dd.MM.y' // 07.01.2018
	
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'um' {{time}}",
	  long: "{{date}} 'um' {{time}}",
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 326 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "'letzten' eeee 'um' p",
	  yesterday: "'gestern um' p",
	  today: "'heute um' p",
	  tomorrow: "'morgen um' p",
	  nextWeek: "eeee 'um' p",
	  other: 'P'
	};
	
	var formatRelative = function (token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(8));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
	  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
	  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
	};
	var parseEraPatterns = {
	  any: [/^v/i, /^n/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](\.)? Quartal/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
	  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smdmf]/i,
	  short: /^(so|mo|di|mi|do|fr|sa)/i,
	  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
	  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
	};
	var parseDayPatterns = {
	  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
	  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
	  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^v/i,
	    pm: /^n/i,
	    midnight: /^Mitte/i,
	    noon: /^Mitta/i,
	    morning: /morgens/i,
	    afternoon: /nachmittags/i,
	    // will never be matched. Afternoon is matched by `pm`
	    evening: /abends/i,
	    night: /nachts/i // will never be matched. Night is matched by `pm`
	
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 328 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'moins d’une seconde',
	    other: 'moins de {{count}} secondes'
	  },
	  xSeconds: {
	    one: '1 seconde',
	    other: '{{count}} secondes'
	  },
	  halfAMinute: '30 secondes',
	  lessThanXMinutes: {
	    one: 'moins d’une minute',
	    other: 'moins de {{count}} minutes'
	  },
	  xMinutes: {
	    one: '1 minute',
	    other: '{{count}} minutes'
	  },
	  aboutXHours: {
	    one: 'environ 1 heure',
	    other: 'environ {{count}} heures'
	  },
	  xHours: {
	    one: '1 heure',
	    other: '{{count}} heures'
	  },
	  xDays: {
	    one: '1 jour',
	    other: '{{count}} jours'
	  },
	  aboutXWeeks: {
	    one: 'environ 1 semaine',
	    other: 'environ {{count}} semaines'
	  },
	  xWeeks: {
	    one: '1 semaine',
	    other: '{{count}} semaines'
	  },
	  aboutXMonths: {
	    one: 'environ 1 mois',
	    other: 'environ {{count}} mois'
	  },
	  xMonths: {
	    one: '1 mois',
	    other: '{{count}} mois'
	  },
	  aboutXYears: {
	    one: 'environ 1 an',
	    other: 'environ {{count}} ans'
	  },
	  xYears: {
	    one: '1 an',
	    other: '{{count}} ans'
	  },
	  overXYears: {
	    one: 'plus d’un an',
	    other: 'plus de {{count}} ans'
	  },
	  almostXYears: {
	    one: 'presqu’un an',
	    other: 'presque {{count}} ans'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'dans ' + result;
	    } else {
	      return 'il y a ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 329 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'dernier à' p",
	  yesterday: "'hier à' p",
	  today: "'aujourd’hui à' p",
	  tomorrow: "'demain à' p'",
	  nextWeek: "eeee 'prochain à' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['av. J.-C', 'ap. J.-C'],
	  abbreviated: ['av. J.-C', 'ap. J.-C'],
	  wide: ['avant Jésus-Christ', 'après Jésus-Christ']
	};
	var quarterValues = {
	  narrow: ['T1', 'T2', 'T3', 'T4'],
	  abbreviated: ['1er trim.', '2ème trim.', '3ème trim.', '4ème trim.'],
	  wide: ['1er trimestre', '2ème trimestre', '3ème trimestre', '4ème trimestre']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
	  wide: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']
	};
	var dayValues = {
	  narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
	  short: ['di', 'lu', 'ma', 'me', 'je', 've', 'sa'],
	  abbreviated: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
	  wide: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'minuit',
	    noon: 'midi',
	    morning: 'mat.',
	    afternoon: 'ap.m.',
	    evening: 'soir',
	    night: 'mat.'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'minuit',
	    noon: 'midi',
	    morning: 'matin',
	    afternoon: 'après-midi',
	    evening: 'soir',
	    night: 'matin'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'minuit',
	    noon: 'midi',
	    morning: 'du matin',
	    afternoon: 'de l’après-midi',
	    evening: 'du soir',
	    night: 'du matin'
	  }
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var number = Number(dirtyNumber);
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	  var suffix;
	
	  if (number === 0) {
	    return number;
	  }
	
	  if (unit === 'year' || unit === 'hour' || unit === 'week') {
	    if (number === 1) {
	      suffix = 'ère';
	    } else {
	      suffix = 'ème';
	    }
	  } else {
	    if (number === 1) {
	      suffix = 'er';
	    } else {
	      suffix = 'ème';
	    }
	  }
	
	  return number + suffix;
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
	  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
	  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
	};
	var parseEraPatterns = {
	  any: [/^av/i, /^ap/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^t[1234]/i,
	  wide: /^[1234](er|ème|e)? trimestre/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
	  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[lmjvsd]/i,
	  short: /^(di|lu|ma|me|je|ve|sa)/i,
	  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
	  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
	};
	var parseDayPatterns = {
	  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
	  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
	  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^min/i,
	    noon: /^mid/i,
	    morning: /mat/i,
	    afternoon: /ap/i,
	    evening: /soir/i,
	    night: /nuit/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "af", {
	  enumerable: true,
	  get: function () {
	    return _index.default;
	  }
	});
	Object.defineProperty(exports, "arDZ", {
	  enumerable: true,
	  get: function () {
	    return _index2.default;
	  }
	});
	Object.defineProperty(exports, "arMA", {
	  enumerable: true,
	  get: function () {
	    return _index3.default;
	  }
	});
	Object.defineProperty(exports, "arSA", {
	  enumerable: true,
	  get: function () {
	    return _index4.default;
	  }
	});
	Object.defineProperty(exports, "arTN", {
	  enumerable: true,
	  get: function () {
	    return _index5.default;
	  }
	});
	Object.defineProperty(exports, "az", {
	  enumerable: true,
	  get: function () {
	    return _index6.default;
	  }
	});
	Object.defineProperty(exports, "be", {
	  enumerable: true,
	  get: function () {
	    return _index7.default;
	  }
	});
	Object.defineProperty(exports, "bg", {
	  enumerable: true,
	  get: function () {
	    return _index8.default;
	  }
	});
	Object.defineProperty(exports, "bn", {
	  enumerable: true,
	  get: function () {
	    return _index9.default;
	  }
	});
	Object.defineProperty(exports, "bs", {
	  enumerable: true,
	  get: function () {
	    return _index10.default;
	  }
	});
	Object.defineProperty(exports, "ca", {
	  enumerable: true,
	  get: function () {
	    return _index11.default;
	  }
	});
	Object.defineProperty(exports, "cs", {
	  enumerable: true,
	  get: function () {
	    return _index12.default;
	  }
	});
	Object.defineProperty(exports, "cy", {
	  enumerable: true,
	  get: function () {
	    return _index13.default;
	  }
	});
	Object.defineProperty(exports, "da", {
	  enumerable: true,
	  get: function () {
	    return _index14.default;
	  }
	});
	Object.defineProperty(exports, "de", {
	  enumerable: true,
	  get: function () {
	    return _index15.default;
	  }
	});
	Object.defineProperty(exports, "deAT", {
	  enumerable: true,
	  get: function () {
	    return _index16.default;
	  }
	});
	Object.defineProperty(exports, "el", {
	  enumerable: true,
	  get: function () {
	    return _index17.default;
	  }
	});
	Object.defineProperty(exports, "enAU", {
	  enumerable: true,
	  get: function () {
	    return _index18.default;
	  }
	});
	Object.defineProperty(exports, "enCA", {
	  enumerable: true,
	  get: function () {
	    return _index19.default;
	  }
	});
	Object.defineProperty(exports, "enGB", {
	  enumerable: true,
	  get: function () {
	    return _index20.default;
	  }
	});
	Object.defineProperty(exports, "enIN", {
	  enumerable: true,
	  get: function () {
	    return _index21.default;
	  }
	});
	Object.defineProperty(exports, "enNZ", {
	  enumerable: true,
	  get: function () {
	    return _index22.default;
	  }
	});
	Object.defineProperty(exports, "enUS", {
	  enumerable: true,
	  get: function () {
	    return _index23.default;
	  }
	});
	Object.defineProperty(exports, "enZA", {
	  enumerable: true,
	  get: function () {
	    return _index24.default;
	  }
	});
	Object.defineProperty(exports, "eo", {
	  enumerable: true,
	  get: function () {
	    return _index25.default;
	  }
	});
	Object.defineProperty(exports, "es", {
	  enumerable: true,
	  get: function () {
	    return _index26.default;
	  }
	});
	Object.defineProperty(exports, "et", {
	  enumerable: true,
	  get: function () {
	    return _index27.default;
	  }
	});
	Object.defineProperty(exports, "eu", {
	  enumerable: true,
	  get: function () {
	    return _index28.default;
	  }
	});
	Object.defineProperty(exports, "faIR", {
	  enumerable: true,
	  get: function () {
	    return _index29.default;
	  }
	});
	Object.defineProperty(exports, "fi", {
	  enumerable: true,
	  get: function () {
	    return _index30.default;
	  }
	});
	Object.defineProperty(exports, "fr", {
	  enumerable: true,
	  get: function () {
	    return _index31.default;
	  }
	});
	Object.defineProperty(exports, "frCA", {
	  enumerable: true,
	  get: function () {
	    return _index32.default;
	  }
	});
	Object.defineProperty(exports, "frCH", {
	  enumerable: true,
	  get: function () {
	    return _index33.default;
	  }
	});
	Object.defineProperty(exports, "gd", {
	  enumerable: true,
	  get: function () {
	    return _index34.default;
	  }
	});
	Object.defineProperty(exports, "gl", {
	  enumerable: true,
	  get: function () {
	    return _index35.default;
	  }
	});
	Object.defineProperty(exports, "gu", {
	  enumerable: true,
	  get: function () {
	    return _index36.default;
	  }
	});
	Object.defineProperty(exports, "he", {
	  enumerable: true,
	  get: function () {
	    return _index37.default;
	  }
	});
	Object.defineProperty(exports, "hi", {
	  enumerable: true,
	  get: function () {
	    return _index38.default;
	  }
	});
	Object.defineProperty(exports, "hr", {
	  enumerable: true,
	  get: function () {
	    return _index39.default;
	  }
	});
	Object.defineProperty(exports, "ht", {
	  enumerable: true,
	  get: function () {
	    return _index40.default;
	  }
	});
	Object.defineProperty(exports, "hu", {
	  enumerable: true,
	  get: function () {
	    return _index41.default;
	  }
	});
	Object.defineProperty(exports, "hy", {
	  enumerable: true,
	  get: function () {
	    return _index42.default;
	  }
	});
	Object.defineProperty(exports, "id", {
	  enumerable: true,
	  get: function () {
	    return _index43.default;
	  }
	});
	Object.defineProperty(exports, "is", {
	  enumerable: true,
	  get: function () {
	    return _index44.default;
	  }
	});
	Object.defineProperty(exports, "it", {
	  enumerable: true,
	  get: function () {
	    return _index45.default;
	  }
	});
	Object.defineProperty(exports, "ja", {
	  enumerable: true,
	  get: function () {
	    return _index46.default;
	  }
	});
	Object.defineProperty(exports, "jaHira", {
	  enumerable: true,
	  get: function () {
	    return _index47.default;
	  }
	});
	Object.defineProperty(exports, "ka", {
	  enumerable: true,
	  get: function () {
	    return _index48.default;
	  }
	});
	Object.defineProperty(exports, "kk", {
	  enumerable: true,
	  get: function () {
	    return _index49.default;
	  }
	});
	Object.defineProperty(exports, "kn", {
	  enumerable: true,
	  get: function () {
	    return _index50.default;
	  }
	});
	Object.defineProperty(exports, "ko", {
	  enumerable: true,
	  get: function () {
	    return _index51.default;
	  }
	});
	Object.defineProperty(exports, "lb", {
	  enumerable: true,
	  get: function () {
	    return _index52.default;
	  }
	});
	Object.defineProperty(exports, "lt", {
	  enumerable: true,
	  get: function () {
	    return _index53.default;
	  }
	});
	Object.defineProperty(exports, "lv", {
	  enumerable: true,
	  get: function () {
	    return _index54.default;
	  }
	});
	Object.defineProperty(exports, "mk", {
	  enumerable: true,
	  get: function () {
	    return _index55.default;
	  }
	});
	Object.defineProperty(exports, "mn", {
	  enumerable: true,
	  get: function () {
	    return _index56.default;
	  }
	});
	Object.defineProperty(exports, "ms", {
	  enumerable: true,
	  get: function () {
	    return _index57.default;
	  }
	});
	Object.defineProperty(exports, "mt", {
	  enumerable: true,
	  get: function () {
	    return _index58.default;
	  }
	});
	Object.defineProperty(exports, "nb", {
	  enumerable: true,
	  get: function () {
	    return _index59.default;
	  }
	});
	Object.defineProperty(exports, "nl", {
	  enumerable: true,
	  get: function () {
	    return _index60.default;
	  }
	});
	Object.defineProperty(exports, "nlBE", {
	  enumerable: true,
	  get: function () {
	    return _index61.default;
	  }
	});
	Object.defineProperty(exports, "nn", {
	  enumerable: true,
	  get: function () {
	    return _index62.default;
	  }
	});
	Object.defineProperty(exports, "pl", {
	  enumerable: true,
	  get: function () {
	    return _index63.default;
	  }
	});
	Object.defineProperty(exports, "pt", {
	  enumerable: true,
	  get: function () {
	    return _index64.default;
	  }
	});
	Object.defineProperty(exports, "ptBR", {
	  enumerable: true,
	  get: function () {
	    return _index65.default;
	  }
	});
	Object.defineProperty(exports, "ro", {
	  enumerable: true,
	  get: function () {
	    return _index66.default;
	  }
	});
	Object.defineProperty(exports, "ru", {
	  enumerable: true,
	  get: function () {
	    return _index67.default;
	  }
	});
	Object.defineProperty(exports, "sk", {
	  enumerable: true,
	  get: function () {
	    return _index68.default;
	  }
	});
	Object.defineProperty(exports, "sl", {
	  enumerable: true,
	  get: function () {
	    return _index69.default;
	  }
	});
	Object.defineProperty(exports, "sq", {
	  enumerable: true,
	  get: function () {
	    return _index70.default;
	  }
	});
	Object.defineProperty(exports, "sr", {
	  enumerable: true,
	  get: function () {
	    return _index71.default;
	  }
	});
	Object.defineProperty(exports, "srLatn", {
	  enumerable: true,
	  get: function () {
	    return _index72.default;
	  }
	});
	Object.defineProperty(exports, "sv", {
	  enumerable: true,
	  get: function () {
	    return _index73.default;
	  }
	});
	Object.defineProperty(exports, "ta", {
	  enumerable: true,
	  get: function () {
	    return _index74.default;
	  }
	});
	Object.defineProperty(exports, "te", {
	  enumerable: true,
	  get: function () {
	    return _index75.default;
	  }
	});
	Object.defineProperty(exports, "th", {
	  enumerable: true,
	  get: function () {
	    return _index76.default;
	  }
	});
	Object.defineProperty(exports, "tr", {
	  enumerable: true,
	  get: function () {
	    return _index77.default;
	  }
	});
	Object.defineProperty(exports, "ug", {
	  enumerable: true,
	  get: function () {
	    return _index78.default;
	  }
	});
	Object.defineProperty(exports, "uk", {
	  enumerable: true,
	  get: function () {
	    return _index79.default;
	  }
	});
	Object.defineProperty(exports, "uz", {
	  enumerable: true,
	  get: function () {
	    return _index80.default;
	  }
	});
	Object.defineProperty(exports, "vi", {
	  enumerable: true,
	  get: function () {
	    return _index81.default;
	  }
	});
	Object.defineProperty(exports, "zhCN", {
	  enumerable: true,
	  get: function () {
	    return _index82.default;
	  }
	});
	Object.defineProperty(exports, "zhTW", {
	  enumerable: true,
	  get: function () {
	    return _index83.default;
	  }
	});
	
	var _index = _interopRequireDefault(__webpack_require__(970));
	
	var _index2 = _interopRequireDefault(__webpack_require__(976));
	
	var _index3 = _interopRequireDefault(__webpack_require__(982));
	
	var _index4 = _interopRequireDefault(__webpack_require__(988));
	
	var _index5 = _interopRequireDefault(__webpack_require__(994));
	
	var _index6 = _interopRequireDefault(__webpack_require__(1000));
	
	var _index7 = _interopRequireDefault(__webpack_require__(1006));
	
	var _index8 = _interopRequireDefault(__webpack_require__(1012));
	
	var _index9 = _interopRequireDefault(__webpack_require__(1017));
	
	var _index10 = _interopRequireDefault(__webpack_require__(1023));
	
	var _index11 = _interopRequireDefault(__webpack_require__(1029));
	
	var _index12 = _interopRequireDefault(__webpack_require__(1035));
	
	var _index13 = _interopRequireDefault(__webpack_require__(1041));
	
	var _index14 = _interopRequireDefault(__webpack_require__(1047));
	
	var _index15 = _interopRequireDefault(__webpack_require__(1051));
	
	var _index16 = _interopRequireDefault(__webpack_require__(1049));
	
	var _index17 = _interopRequireDefault(__webpack_require__(1057));
	
	var _index18 = _interopRequireDefault(__webpack_require__(1059));
	
	var _index19 = _interopRequireDefault(__webpack_require__(1062));
	
	var _index20 = _interopRequireDefault(__webpack_require__(1064));
	
	var _index21 = _interopRequireDefault(__webpack_require__(1066));
	
	var _index22 = _interopRequireDefault(__webpack_require__(1068));
	
	var _index23 = _interopRequireDefault(__webpack_require__(80));
	
	var _index24 = _interopRequireDefault(__webpack_require__(1071));
	
	var _index25 = _interopRequireDefault(__webpack_require__(1077));
	
	var _index26 = _interopRequireDefault(__webpack_require__(1083));
	
	var _index27 = _interopRequireDefault(__webpack_require__(1089));
	
	var _index28 = _interopRequireDefault(__webpack_require__(1095));
	
	var _index29 = _interopRequireDefault(__webpack_require__(1101));
	
	var _index30 = _interopRequireDefault(__webpack_require__(1107));
	
	var _index31 = _interopRequireDefault(__webpack_require__(1117));
	
	var _index32 = _interopRequireDefault(__webpack_require__(1109));
	
	var _index33 = _interopRequireDefault(__webpack_require__(1115));
	
	var _index34 = _interopRequireDefault(__webpack_require__(1123));
	
	var _index35 = _interopRequireDefault(__webpack_require__(1129));
	
	var _index36 = _interopRequireDefault(__webpack_require__(1135));
	
	var _index37 = _interopRequireDefault(__webpack_require__(1141));
	
	var _index38 = _interopRequireDefault(__webpack_require__(1146));
	
	var _index39 = _interopRequireDefault(__webpack_require__(1152));
	
	var _index40 = _interopRequireDefault(__webpack_require__(1158));
	
	var _index41 = _interopRequireDefault(__webpack_require__(1164));
	
	var _index42 = _interopRequireDefault(__webpack_require__(1170));
	
	var _index43 = _interopRequireDefault(__webpack_require__(1176));
	
	var _index44 = _interopRequireDefault(__webpack_require__(1182));
	
	var _index45 = _interopRequireDefault(__webpack_require__(1188));
	
	var _index46 = _interopRequireDefault(__webpack_require__(1200));
	
	var _index47 = _interopRequireDefault(__webpack_require__(1194));
	
	var _index48 = _interopRequireDefault(__webpack_require__(1206));
	
	var _index49 = _interopRequireDefault(__webpack_require__(1212));
	
	var _index50 = _interopRequireDefault(__webpack_require__(1218));
	
	var _index51 = _interopRequireDefault(__webpack_require__(1224));
	
	var _index52 = _interopRequireDefault(__webpack_require__(1230));
	
	var _index53 = _interopRequireDefault(__webpack_require__(1236));
	
	var _index54 = _interopRequireDefault(__webpack_require__(1242));
	
	var _index55 = _interopRequireDefault(__webpack_require__(1248));
	
	var _index56 = _interopRequireDefault(__webpack_require__(1254));
	
	var _index57 = _interopRequireDefault(__webpack_require__(1260));
	
	var _index58 = _interopRequireDefault(__webpack_require__(1266));
	
	var _index59 = _interopRequireDefault(__webpack_require__(1272));
	
	var _index60 = _interopRequireDefault(__webpack_require__(1284));
	
	var _index61 = _interopRequireDefault(__webpack_require__(1278));
	
	var _index62 = _interopRequireDefault(__webpack_require__(1290));
	
	var _index63 = _interopRequireDefault(__webpack_require__(1296));
	
	var _index64 = _interopRequireDefault(__webpack_require__(1308));
	
	var _index65 = _interopRequireDefault(__webpack_require__(1302));
	
	var _index66 = _interopRequireDefault(__webpack_require__(1314));
	
	var _index67 = _interopRequireDefault(__webpack_require__(1320));
	
	var _index68 = _interopRequireDefault(__webpack_require__(1326));
	
	var _index69 = _interopRequireDefault(__webpack_require__(1332));
	
	var _index70 = _interopRequireDefault(__webpack_require__(1338));
	
	var _index71 = _interopRequireDefault(__webpack_require__(1350));
	
	var _index72 = _interopRequireDefault(__webpack_require__(1344));
	
	var _index73 = _interopRequireDefault(__webpack_require__(1356));
	
	var _index74 = _interopRequireDefault(__webpack_require__(1362));
	
	var _index75 = _interopRequireDefault(__webpack_require__(1368));
	
	var _index76 = _interopRequireDefault(__webpack_require__(1374));
	
	var _index77 = _interopRequireDefault(__webpack_require__(1380));
	
	var _index78 = _interopRequireDefault(__webpack_require__(1386));
	
	var _index79 = _interopRequireDefault(__webpack_require__(1392));
	
	var _index80 = _interopRequireDefault(__webpack_require__(1398));
	
	var _index81 = _interopRequireDefault(__webpack_require__(1404));
	
	var _index82 = _interopRequireDefault(__webpack_require__(1410));
	
	var _index83 = _interopRequireDefault(__webpack_require__(1416));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = max;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name max
	 * @category Common Helpers
	 * @summary Return the latest of the given dates.
	 *
	 * @description
	 * Return the latest of the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - `max` function now accepts an array of dates rather than spread arguments.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   var date1 = new Date(1989, 6, 10)
	 *   var date2 = new Date(1987, 1, 11)
	 *   var maxDate = max(date1, date2)
	 *
	 *   // v2.0.0 onward:
	 *   var dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
	 *   var maxDate = max(dates)
	 *   ```
	 *
	 * @param {Date[]|Number[]} datesArray - the dates to compare
	 * @returns {Date} the latest of the dates
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which of these dates is the latest?
	 * var result = max([
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * ])
	 * //=> Sun Jul 02 1995 00:00:00
	 */
	function max(dirtyDatesArray) {
	  (0, _index2.default)(1, arguments);
	  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	
	  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
	  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  } else {
	    // `dirtyDatesArray` is non-iterable, return Invalid Date
	    return new Date(NaN);
	  }
	
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	
	    if (result === undefined || result < currentDate || isNaN(Number(currentDate))) {
	      result = currentDate;
	    }
	  });
	  return result || new Date(NaN);
	}
	
	module.exports = exports.default;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = min;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name min
	 * @category Common Helpers
	 * @summary Returns the earliest of the given dates.
	 *
	 * @description
	 * Returns the earliest of the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - `min` function now accepts an array of dates rather than spread arguments.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   const date1 = new Date(1989, 6, 10)
	 *   const date2 = new Date(1987, 1, 11)
	 *   const minDate = min(date1, date2)
	 *
	 *   // v2.0.0 onward:
	 *   const dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
	 *   const minDate = min(dates)
	 *   ```
	 *
	 * @param {Date[]|Number[]} datesArray - the dates to compare
	 * @returns {Date} - the earliest of the dates
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which of these dates is the earliest?
	 * const result = min([
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * ])
	 * //=> Wed Feb 11 1987 00:00:00
	 */
	function min(dirtyDatesArray) {
	  (0, _index2.default)(1, arguments);
	  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	
	  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
	  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  } else {
	    // `dirtyDatesArray` is non-iterable, return Invalid Date
	    return new Date(NaN);
	  }
	
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	
	    if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) {
	      result = currentDate;
	    }
	  });
	  return result || new Date(NaN);
	}
	
	module.exports = exports.default;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parse;
	
	var _index = _interopRequireDefault(__webpack_require__(80));
	
	var _index2 = _interopRequireDefault(__webpack_require__(114));
	
	var _index3 = _interopRequireDefault(__webpack_require__(4));
	
	var _index4 = _interopRequireDefault(__webpack_require__(277));
	
	var _index5 = _interopRequireDefault(__webpack_require__(280));
	
	var _index6 = _interopRequireDefault(__webpack_require__(57));
	
	var _index7 = __webpack_require__(284);
	
	var _index8 = _interopRequireDefault(__webpack_require__(10));
	
	var _index9 = _interopRequireDefault(__webpack_require__(1435));
	
	var _index10 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
	// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
	//   (one of the certain letters followed by `o`)
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	
	var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
	// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
	
	var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var notWhitespaceRegExp = /\S/;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	/**
	 * @name parse
	 * @category Common Helpers
	 * @summary Parse the date.
	 *
	 * @description
	 * Return the date parsed from string using the given format string.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://git.io/fxCyr
	 *
	 * The characters in the format string wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 *
	 * Format of the format string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 5 below the table).
	 *
	 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
	 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
	 *
	 * ```javascript
	 * parse('23 AM', 'HH a', new Date())
	 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
	 * ```
	 *
	 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
	 *
	 * Accepted format string patterns:
	 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
	 * |---------------------------------|-----|---------|-----------------------------------|-------|
	 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
	 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 |     | GGGGG   | A, B                              |       |
	 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
	 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
	 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
	 * |                                 |     | yyyyy   | ...                               | 2,4   |
	 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
	 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
	 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
	 * |                                 |     | YYYYY   | ...                               | 2,4   |
	 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
	 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
	 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
	 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
	 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
	 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
	 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
	 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
	 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
	 * |                                 |     | uuuuu   | ...                               | 2,4   |
	 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
	 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
	 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
	 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
	 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
	 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
	 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
	 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
	 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
	 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
	 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
	 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
	 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
	 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
	 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 |     | DDDD    | ...                               | 2     |
	 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
	 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
	 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
	 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
	 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
	 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
	 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
	 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
	 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
	 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
	 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 |     | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
	 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
	 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
	 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
	 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
	 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
	 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
	 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
	 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
	 * |                                 |     | tt      | ...                               | 2     |
	 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
	 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
	 * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
	 * |                                 |     | SSSS    | ...                               | 2     |
	 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
	 * |                                 |     | TT      | ...                               | 2     |
	 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
	 * |                                 |     | XX      | -0800, +0530, Z                   |       |
	 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
	 * |                                 |     | xx      | -0800, +0530, +0000               |       |
	 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
	 * |                                 |     | PP      | May 29, 1453                      |       |
	 * |                                 |     | PPP     | May 29th, 1453                    |       |
	 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
	 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
	 * |                                 |     | pp      | 12:00:00 AM                       |       |
	 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
	 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
	 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
	 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular.
	 *    In `format` function, they will produce different result:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 *    `parse` will try to match both formatting and stand-alone units interchangably.
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table:
	 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
	 *      as wide as the sequence
	 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
	 *      These variations are marked with "2" in the last column of the table.
	 *
	 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 4. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
	 *
	 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
	 *
	 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
	 *
	 *    while `uu` will just assign the year as is:
	 *
	 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
	 *
	 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
	 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
	 *
	 * 5. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
	 *    on the given locale.
	 *
	 *    using `en-US` locale: `P` => `MM/dd/yyyy`
	 *    using `en-US` locale: `p` => `hh:mm a`
	 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
	 *    using `pt-BR` locale: `p` => `HH:mm`
	 *
	 * Values will be assigned to the date in the descending order of its unit's priority.
	 * Units of an equal priority overwrite each other in the order of appearance.
	 *
	 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
	 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
	 *
	 * `referenceDate` must be passed for correct work of the function.
	 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
	 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
	 * In this case parsing will be done in the context of the current date.
	 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
	 * then `Invalid Date` will be returned.
	 *
	 * The result may vary by locale.
	 *
	 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
	 *
	 * If parsing failed, `Invalid Date` will be returned.
	 * Invalid Date is a Date, whose time value is NaN.
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - Old `parse` was renamed to `toDate`.
	 *   Now `parse` is a new function which parses a string using a provided format.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   parse('2016-01-01')
	 *
	 *   // v2.0.0 onward (toDate no longer accepts a string)
	 *   toDate(1392098430000) // Unix to timestamp
	 *   toDate(new Date(2014, 1, 11, 11, 30, 30)) // Cloning the date
	 *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
	 *   ```
	 *
	 * @param {String} dateString - the string to parse
	 * @param {String} formatString - the string of tokens
	 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://git.io/fxCyr
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://git.io/fxCyr
	 * @returns {Date} the parsed date
	 * @throws {TypeError} 3 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} `options.locale` must contain `match` property
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Parse 11 February 2014 from middle-endian format:
	 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
	 * //=> Tue Feb 11 2014 00:00:00
	 *
	 * @example
	 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
	 * import eo from 'date-fns/locale/eo'
	 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
	 *   locale: eo
	 * })
	 * //=> Sun Feb 28 2010 00:00:00
	 */
	
	function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
	  (0, _index10.default)(3, arguments);
	  var dateString = String(dirtyDateString);
	  var formatString = String(dirtyFormatString);
	  var options = dirtyOptions || {};
	  var locale = options.locale || _index.default;
	
	  if (!locale.match) {
	    throw new RangeError('locale must contain match property');
	  }
	
	  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index8.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index8.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	
	  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index8.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index8.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  if (formatString === '') {
	    if (dateString === '') {
	      return (0, _index3.default)(dirtyReferenceDate);
	    } else {
	      return new Date(NaN);
	    }
	  }
	
	  var subFnOptions = {
	    firstWeekContainsDate: firstWeekContainsDate,
	    weekStartsOn: weekStartsOn,
	    locale: locale
	  }; // If timezone isn't specified, it will be set to the system timezone
	
	  var setters = [{
	    priority: TIMEZONE_UNIT_PRIORITY,
	    subPriority: -1,
	    set: dateToSystemTimezone,
	    index: 0
	  }];
	  var i;
	  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === 'p' || firstCharacter === 'P') {
	      var longFormatter = _index5.default[firstCharacter];
	      return longFormatter(substring, locale.formatLong, subFnOptions);
	    }
	
	    return substring;
	  }).join('').match(formattingTokensRegExp);
	  var usedTokens = [];
	
	  for (i = 0; i < tokens.length; i++) {
	    var token = tokens[i];
	
	    if (!options.useAdditionalWeekYearTokens && (0, _index7.isProtectedWeekYearToken)(token)) {
	      (0, _index7.throwProtectedError)(token, formatString, dirtyDateString);
	    }
	
	    if (!options.useAdditionalDayOfYearTokens && (0, _index7.isProtectedDayOfYearToken)(token)) {
	      (0, _index7.throwProtectedError)(token, formatString, dirtyDateString);
	    }
	
	    var firstCharacter = token[0];
	    var parser = _index9.default[firstCharacter];
	
	    if (parser) {
	      var incompatibleTokens = parser.incompatibleTokens;
	
	      if (Array.isArray(incompatibleTokens)) {
	        var incompatibleToken = void 0;
	
	        for (var _i = 0; _i < usedTokens.length; _i++) {
	          var usedToken = usedTokens[_i].token;
	
	          if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
	            incompatibleToken = usedTokens[_i];
	            break;
	          }
	        }
	
	        if (incompatibleToken) {
	          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
	        }
	      } else if (parser.incompatibleTokens === '*' && usedTokens.length) {
	        throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
	      }
	
	      usedTokens.push({
	        token: firstCharacter,
	        fullToken: token
	      });
	      var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);
	
	      if (!parseResult) {
	        return new Date(NaN);
	      }
	
	      setters.push({
	        priority: parser.priority,
	        subPriority: parser.subPriority || 0,
	        set: parser.set,
	        validate: parser.validate,
	        value: parseResult.value,
	        index: setters.length
	      });
	      dateString = parseResult.rest;
	    } else {
	      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	      } // Replace two single quote characters with one single quote character
	
	
	      if (token === "''") {
	        token = "'";
	      } else if (firstCharacter === "'") {
	        token = cleanEscapedString(token);
	      } // Cut token from string, or, if string doesn't match the token, return Invalid Date
	
	
	      if (dateString.indexOf(token) === 0) {
	        dateString = dateString.slice(token.length);
	      } else {
	        return new Date(NaN);
	      }
	    }
	  } // Check if the remaining input contains something other than whitespace
	
	
	  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
	    return new Date(NaN);
	  }
	
	  var uniquePrioritySetters = setters.map(function (setter) {
	    return setter.priority;
	  }).sort(function (a, b) {
	    return b - a;
	  }).filter(function (priority, index, array) {
	    return array.indexOf(priority) === index;
	  }).map(function (priority) {
	    return setters.filter(function (setter) {
	      return setter.priority === priority;
	    }).sort(function (a, b) {
	      return b.subPriority - a.subPriority;
	    });
	  }).map(function (setterArray) {
	    return setterArray[0];
	  });
	  var date = (0, _index3.default)(dirtyReferenceDate);
	
	  if (isNaN(date)) {
	    return new Date(NaN);
	  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37
	
	
	  var utcDate = (0, _index2.default)(date, (0, _index6.default)(date));
	  var flags = {};
	
	  for (i = 0; i < uniquePrioritySetters.length; i++) {
	    var setter = uniquePrioritySetters[i];
	
	    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
	      return new Date(NaN);
	    }
	
	    var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)
	
	    if (result[0]) {
	      utcDate = result[0];
	      (0, _index4.default)(flags, result[1]); // Result is date
	    } else {
	      utcDate = result;
	    }
	  }
	
	  return utcDate;
	}
	
	function dateToSystemTimezone(date, flags) {
	  if (flags.timestampIsSet) {
	    return date;
	  }
	
	  var convertedDate = new Date(0);
	  convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
	  convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
	  return convertedDate;
	}
	
	function cleanEscapedString(input) {
	  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
	}
	
	module.exports = exports.default;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(113));
	
	var _index4 = _interopRequireDefault(__webpack_require__(76));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Set the ISO week-numbering year to the given date.
	 *
	 * @description
	 * Set the ISO week-numbering year to the given date,
	 * saving the week number and the weekday number.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `setISOYear` to `setISOWeekYear`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `setWeekYear`.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} isoWeekYear - the ISO week-numbering year of the new date
	 * @returns {Date} the new date with the ISO week-numbering year set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set ISO week-numbering year 2007 to 29 December 2008:
	 * const result = setISOWeekYear(new Date(2008, 11, 29), 2007)
	 * //=> Mon Jan 01 2007 00:00:00
	 */
	function setISOWeekYear(dirtyDate, dirtyISOWeekYear) {
	  (0, _index5.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var isoWeekYear = (0, _index.default)(dirtyISOWeekYear);
	  var diff = (0, _index4.default)(date, (0, _index3.default)(date));
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setFullYear(isoWeekYear, 0, 4);
	  fourthOfJanuary.setHours(0, 0, 0, 0);
	  date = (0, _index3.default)(fourthOfJanuary);
	  date.setDate(date.getDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfHour;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfHour
	 * @category Hour Helpers
	 * @summary Return the start of an hour for the given date.
	 *
	 * @description
	 * Return the start of an hour for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of an hour
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of an hour for 2 September 2014 11:55:00:
	 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
	 * //=> Tue Sep 02 2014 11:00:00
	 */
	function startOfHour(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMinutes(0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfSecond;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfSecond
	 * @category Second Helpers
	 * @summary Return the start of a second for the given date.
	 *
	 * @description
	 * Return the start of a second for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a second
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a second for 1 December 2014 22:15:45.400:
	 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:45.000
	 */
	function startOfSecond(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMilliseconds(0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subISOWeekYears;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(286));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Subtract the specified number of ISO week-numbering years from the given date.
	 *
	 * @description
	 * Subtract the specified number of ISO week-numbering years from the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `subISOYears` to `subISOWeekYears`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `setWeekYear`.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of ISO week-numbering years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the ISO week-numbering years subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 ISO week-numbering years from 1 September 2014:
	 * const result = subISOWeekYears(new Date(2014, 8, 1), 5)
	 * //=> Mon Aug 31 2009 00:00:00
	 */
	function subISOWeekYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(111));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subMonths
	 * @category Month Helpers
	 * @summary Subtract the specified number of months from the given date.
	 *
	 * @description
	 * Subtract the specified number of months from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the months subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 months from 1 February 2015:
	 * const result = subMonths(new Date(2015, 1, 1), 5)
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function subMonths(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sub;
	
	var _index = _interopRequireDefault(__webpack_require__(141));
	
	var _index2 = _interopRequireDefault(__webpack_require__(340));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	var _index4 = _interopRequireDefault(__webpack_require__(10));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name sub
	 * @category Common Helpers
	 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
	 *
	 * @description
	 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be subtracted
	 *
	 * | Key     | Description                        |
	 * |---------|------------------------------------|
	 * | years   | Amount of years to be subtracted   |
	 * | months  | Amount of months to be subtracted  |
	 * | weeks   | Amount of weeks to be subtracted   |
	 * | days    | Amount of days to be subtracted    |
	 * | hours   | Amount of hours to be subtracted   |
	 * | minutes | Amount of minutes to be subtracted |
	 * | seconds | Amount of seconds to be subtracted |
	 *
	 * All values default to 0
	 *
	 * @returns {Date} the new date with the seconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract the following duration from 15 June 2017 15:29:20
	 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
	 *   years: 2,
	 *   months: 9,
	 *   weeks: 1,
	 *   days: 7,
	 *   hours: 5,
	 *   minutes: 9,
	 *   seconds: 30
	 * })
	 * //=> Mon Sep 1 2014 10:19:50
	 */
	function sub(date, duration) {
	  (0, _index3.default)(2, arguments);
	  if (!duration || typeof duration !== 'object') return new Date(NaN);
	  var years = duration.years ? (0, _index4.default)(duration.years) : 0;
	  var months = duration.months ? (0, _index4.default)(duration.months) : 0;
	  var weeks = duration.weeks ? (0, _index4.default)(duration.weeks) : 0;
	  var days = duration.days ? (0, _index4.default)(duration.days) : 0;
	  var hours = duration.hours ? (0, _index4.default)(duration.hours) : 0;
	  var minutes = duration.minutes ? (0, _index4.default)(duration.minutes) : 0;
	  var seconds = duration.seconds ? (0, _index4.default)(duration.seconds) : 0; // Subtract years and months
	
	  var dateWithoutMonths = (0, _index2.default)(date, months + years * 12); // Subtract weeks and days
	
	  var dateWithoutDays = (0, _index.default)(dateWithoutMonths, days + weeks * 7); // Subtract hours, minutes and seconds
	
	  var minutestoSub = minutes + hours * 60;
	  var secondstoSub = seconds + minutestoSub * 60;
	  var mstoSub = secondstoSub * 1000;
	  var finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
	  return finalDate;
	}
	
	module.exports = exports.default;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var isSymbol = __webpack_require__(1493);
	
	module.exports = function (value) {
		if (!isSymbol(value)) throw new TypeError(value + " is not a symbol");
		return value;
	};


/***/ }),
/* 343 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	/* @preserve
	 * Leaflet 1.7.1, a JS library for interactive maps. http://leafletjs.com
	 * (c) 2010-2019 Vladimir Agafonkin, (c) 2010-2011 CloudMade
	 */
	
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.L = {})));
	}(this, (function (exports) { 'use strict';
	
	  var version = "1.7.1";
	
	  /*
	   * @namespace Util
	   *
	   * Various utility functions, used by Leaflet internally.
	   */
	
	  // @function extend(dest: Object, src?: Object): Object
	  // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
	  function extend(dest) {
	  	var i, j, len, src;
	
	  	for (j = 1, len = arguments.length; j < len; j++) {
	  		src = arguments[j];
	  		for (i in src) {
	  			dest[i] = src[i];
	  		}
	  	}
	  	return dest;
	  }
	
	  // @function create(proto: Object, properties?: Object): Object
	  // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
	  var create = Object.create || (function () {
	  	function F() {}
	  	return function (proto) {
	  		F.prototype = proto;
	  		return new F();
	  	};
	  })();
	
	  // @function bind(fn: Function, …): Function
	  // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
	  // Has a `L.bind()` shortcut.
	  function bind(fn, obj) {
	  	var slice = Array.prototype.slice;
	
	  	if (fn.bind) {
	  		return fn.bind.apply(fn, slice.call(arguments, 1));
	  	}
	
	  	var args = slice.call(arguments, 2);
	
	  	return function () {
	  		return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
	  	};
	  }
	
	  // @property lastId: Number
	  // Last unique ID used by [`stamp()`](#util-stamp)
	  var lastId = 0;
	
	  // @function stamp(obj: Object): Number
	  // Returns the unique ID of an object, assigning it one if it doesn't have it.
	  function stamp(obj) {
	  	/*eslint-disable */
	  	obj._leaflet_id = obj._leaflet_id || ++lastId;
	  	return obj._leaflet_id;
	  	/* eslint-enable */
	  }
	
	  // @function throttle(fn: Function, time: Number, context: Object): Function
	  // Returns a function which executes function `fn` with the given scope `context`
	  // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
	  // `fn` will be called no more than one time per given amount of `time`. The arguments
	  // received by the bound function will be any arguments passed when binding the
	  // function, followed by any arguments passed when invoking the bound function.
	  // Has an `L.throttle` shortcut.
	  function throttle(fn, time, context) {
	  	var lock, args, wrapperFn, later;
	
	  	later = function () {
	  		// reset lock and call if queued
	  		lock = false;
	  		if (args) {
	  			wrapperFn.apply(context, args);
	  			args = false;
	  		}
	  	};
	
	  	wrapperFn = function () {
	  		if (lock) {
	  			// called too soon, queue to call later
	  			args = arguments;
	
	  		} else {
	  			// call and lock until later
	  			fn.apply(context, arguments);
	  			setTimeout(later, time);
	  			lock = true;
	  		}
	  	};
	
	  	return wrapperFn;
	  }
	
	  // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
	  // Returns the number `num` modulo `range` in such a way so it lies within
	  // `range[0]` and `range[1]`. The returned value will be always smaller than
	  // `range[1]` unless `includeMax` is set to `true`.
	  function wrapNum(x, range, includeMax) {
	  	var max = range[1],
	  	    min = range[0],
	  	    d = max - min;
	  	return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
	  }
	
	  // @function falseFn(): Function
	  // Returns a function which always returns `false`.
	  function falseFn() { return false; }
	
	  // @function formatNum(num: Number, digits?: Number): Number
	  // Returns the number `num` rounded to `digits` decimals, or to 6 decimals by default.
	  function formatNum(num, digits) {
	  	var pow = Math.pow(10, (digits === undefined ? 6 : digits));
	  	return Math.round(num * pow) / pow;
	  }
	
	  // @function trim(str: String): String
	  // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
	  function trim(str) {
	  	return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	  }
	
	  // @function splitWords(str: String): String[]
	  // Trims and splits the string on whitespace and returns the array of parts.
	  function splitWords(str) {
	  	return trim(str).split(/\s+/);
	  }
	
	  // @function setOptions(obj: Object, options: Object): Object
	  // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
	  function setOptions(obj, options) {
	  	if (!Object.prototype.hasOwnProperty.call(obj, 'options')) {
	  		obj.options = obj.options ? create(obj.options) : {};
	  	}
	  	for (var i in options) {
	  		obj.options[i] = options[i];
	  	}
	  	return obj.options;
	  }
	
	  // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
	  // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
	  // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
	  // be appended at the end. If `uppercase` is `true`, the parameter names will
	  // be uppercased (e.g. `'?A=foo&B=bar'`)
	  function getParamString(obj, existingUrl, uppercase) {
	  	var params = [];
	  	for (var i in obj) {
	  		params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
	  	}
	  	return ((!existingUrl || existingUrl.indexOf('?') === -1) ? '?' : '&') + params.join('&');
	  }
	
	  var templateRe = /\{ *([\w_-]+) *\}/g;
	
	  // @function template(str: String, data: Object): String
	  // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
	  // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
	  // `('Hello foo, bar')`. You can also specify functions instead of strings for
	  // data values — they will be evaluated passing `data` as an argument.
	  function template(str, data) {
	  	return str.replace(templateRe, function (str, key) {
	  		var value = data[key];
	
	  		if (value === undefined) {
	  			throw new Error('No value provided for variable ' + str);
	
	  		} else if (typeof value === 'function') {
	  			value = value(data);
	  		}
	  		return value;
	  	});
	  }
	
	  // @function isArray(obj): Boolean
	  // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
	  var isArray = Array.isArray || function (obj) {
	  	return (Object.prototype.toString.call(obj) === '[object Array]');
	  };
	
	  // @function indexOf(array: Array, el: Object): Number
	  // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
	  function indexOf(array, el) {
	  	for (var i = 0; i < array.length; i++) {
	  		if (array[i] === el) { return i; }
	  	}
	  	return -1;
	  }
	
	  // @property emptyImageUrl: String
	  // Data URI string containing a base64-encoded empty GIF image.
	  // Used as a hack to free memory from unused images on WebKit-powered
	  // mobile devices (by setting image `src` to this string).
	  var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
	
	  // inspired by http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	
	  function getPrefixed(name) {
	  	return window['webkit' + name] || window['moz' + name] || window['ms' + name];
	  }
	
	  var lastTime = 0;
	
	  // fallback for IE 7-8
	  function timeoutDefer(fn) {
	  	var time = +new Date(),
	  	    timeToCall = Math.max(0, 16 - (time - lastTime));
	
	  	lastTime = time + timeToCall;
	  	return window.setTimeout(fn, timeToCall);
	  }
	
	  var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
	  var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') ||
	  		getPrefixed('CancelRequestAnimationFrame') || function (id) { window.clearTimeout(id); };
	
	  // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
	  // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
	  // `context` if given. When `immediate` is set, `fn` is called immediately if
	  // the browser doesn't have native support for
	  // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
	  // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
	  function requestAnimFrame(fn, context, immediate) {
	  	if (immediate && requestFn === timeoutDefer) {
	  		fn.call(context);
	  	} else {
	  		return requestFn.call(window, bind(fn, context));
	  	}
	  }
	
	  // @function cancelAnimFrame(id: Number): undefined
	  // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
	  function cancelAnimFrame(id) {
	  	if (id) {
	  		cancelFn.call(window, id);
	  	}
	  }
	
	  var Util = ({
	    extend: extend,
	    create: create,
	    bind: bind,
	    lastId: lastId,
	    stamp: stamp,
	    throttle: throttle,
	    wrapNum: wrapNum,
	    falseFn: falseFn,
	    formatNum: formatNum,
	    trim: trim,
	    splitWords: splitWords,
	    setOptions: setOptions,
	    getParamString: getParamString,
	    template: template,
	    isArray: isArray,
	    indexOf: indexOf,
	    emptyImageUrl: emptyImageUrl,
	    requestFn: requestFn,
	    cancelFn: cancelFn,
	    requestAnimFrame: requestAnimFrame,
	    cancelAnimFrame: cancelAnimFrame
	  });
	
	  // @class Class
	  // @aka L.Class
	
	  // @section
	  // @uninheritable
	
	  // Thanks to John Resig and Dean Edwards for inspiration!
	
	  function Class() {}
	
	  Class.extend = function (props) {
	
	  	// @function extend(props: Object): Function
	  	// [Extends the current class](#class-inheritance) given the properties to be included.
	  	// Returns a Javascript function that is a class constructor (to be called with `new`).
	  	var NewClass = function () {
	
	  		// call the constructor
	  		if (this.initialize) {
	  			this.initialize.apply(this, arguments);
	  		}
	
	  		// call all constructor hooks
	  		this.callInitHooks();
	  	};
	
	  	var parentProto = NewClass.__super__ = this.prototype;
	
	  	var proto = create(parentProto);
	  	proto.constructor = NewClass;
	
	  	NewClass.prototype = proto;
	
	  	// inherit parent's statics
	  	for (var i in this) {
	  		if (Object.prototype.hasOwnProperty.call(this, i) && i !== 'prototype' && i !== '__super__') {
	  			NewClass[i] = this[i];
	  		}
	  	}
	
	  	// mix static properties into the class
	  	if (props.statics) {
	  		extend(NewClass, props.statics);
	  		delete props.statics;
	  	}
	
	  	// mix includes into the prototype
	  	if (props.includes) {
	  		checkDeprecatedMixinEvents(props.includes);
	  		extend.apply(null, [proto].concat(props.includes));
	  		delete props.includes;
	  	}
	
	  	// merge options
	  	if (proto.options) {
	  		props.options = extend(create(proto.options), props.options);
	  	}
	
	  	// mix given properties into the prototype
	  	extend(proto, props);
	
	  	proto._initHooks = [];
	
	  	// add method for calling all hooks
	  	proto.callInitHooks = function () {
	
	  		if (this._initHooksCalled) { return; }
	
	  		if (parentProto.callInitHooks) {
	  			parentProto.callInitHooks.call(this);
	  		}
	
	  		this._initHooksCalled = true;
	
	  		for (var i = 0, len = proto._initHooks.length; i < len; i++) {
	  			proto._initHooks[i].call(this);
	  		}
	  	};
	
	  	return NewClass;
	  };
	
	
	  // @function include(properties: Object): this
	  // [Includes a mixin](#class-includes) into the current class.
	  Class.include = function (props) {
	  	extend(this.prototype, props);
	  	return this;
	  };
	
	  // @function mergeOptions(options: Object): this
	  // [Merges `options`](#class-options) into the defaults of the class.
	  Class.mergeOptions = function (options) {
	  	extend(this.prototype.options, options);
	  	return this;
	  };
	
	  // @function addInitHook(fn: Function): this
	  // Adds a [constructor hook](#class-constructor-hooks) to the class.
	  Class.addInitHook = function (fn) { // (Function) || (String, args...)
	  	var args = Array.prototype.slice.call(arguments, 1);
	
	  	var init = typeof fn === 'function' ? fn : function () {
	  		this[fn].apply(this, args);
	  	};
	
	  	this.prototype._initHooks = this.prototype._initHooks || [];
	  	this.prototype._initHooks.push(init);
	  	return this;
	  };
	
	  function checkDeprecatedMixinEvents(includes) {
	  	if (typeof L === 'undefined' || !L || !L.Mixin) { return; }
	
	  	includes = isArray(includes) ? includes : [includes];
	
	  	for (var i = 0; i < includes.length; i++) {
	  		if (includes[i] === L.Mixin.Events) {
	  			console.warn('Deprecated include of L.Mixin.Events: ' +
	  				'this property will be removed in future releases, ' +
	  				'please inherit from L.Evented instead.', new Error().stack);
	  		}
	  	}
	  }
	
	  /*
	   * @class Evented
	   * @aka L.Evented
	   * @inherits Class
	   *
	   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
	   *
	   * @example
	   *
	   * ```js
	   * map.on('click', function(e) {
	   * 	alert(e.latlng);
	   * } );
	   * ```
	   *
	   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
	   *
	   * ```js
	   * function onClick(e) { ... }
	   *
	   * map.on('click', onClick);
	   * map.off('click', onClick);
	   * ```
	   */
	
	  var Events = {
	  	/* @method on(type: String, fn: Function, context?: Object): this
	  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
	  	 *
	  	 * @alternative
	  	 * @method on(eventMap: Object): this
	  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	  	 */
	  	on: function (types, fn, context) {
	
	  		// types can be a map of types/handlers
	  		if (typeof types === 'object') {
	  			for (var type in types) {
	  				// we don't process space-separated events here for performance;
	  				// it's a hot path since Layer uses the on(obj) syntax
	  				this._on(type, types[type], fn);
	  			}
	
	  		} else {
	  			// types can be a string of space-separated words
	  			types = splitWords(types);
	
	  			for (var i = 0, len = types.length; i < len; i++) {
	  				this._on(types[i], fn, context);
	  			}
	  		}
	
	  		return this;
	  	},
	
	  	/* @method off(type: String, fn?: Function, context?: Object): this
	  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
	  	 *
	  	 * @alternative
	  	 * @method off(eventMap: Object): this
	  	 * Removes a set of type/listener pairs.
	  	 *
	  	 * @alternative
	  	 * @method off: this
	  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
	  	 */
	  	off: function (types, fn, context) {
	
	  		if (!types) {
	  			// clear all listeners if called without arguments
	  			delete this._events;
	
	  		} else if (typeof types === 'object') {
	  			for (var type in types) {
	  				this._off(type, types[type], fn);
	  			}
	
	  		} else {
	  			types = splitWords(types);
	
	  			for (var i = 0, len = types.length; i < len; i++) {
	  				this._off(types[i], fn, context);
	  			}
	  		}
	
	  		return this;
	  	},
	
	  	// attach listener (without syntactic sugar now)
	  	_on: function (type, fn, context) {
	  		this._events = this._events || {};
	
	  		/* get/init listeners for type */
	  		var typeListeners = this._events[type];
	  		if (!typeListeners) {
	  			typeListeners = [];
	  			this._events[type] = typeListeners;
	  		}
	
	  		if (context === this) {
	  			// Less memory footprint.
	  			context = undefined;
	  		}
	  		var newListener = {fn: fn, ctx: context},
	  		    listeners = typeListeners;
	
	  		// check if fn already there
	  		for (var i = 0, len = listeners.length; i < len; i++) {
	  			if (listeners[i].fn === fn && listeners[i].ctx === context) {
	  				return;
	  			}
	  		}
	
	  		listeners.push(newListener);
	  	},
	
	  	_off: function (type, fn, context) {
	  		var listeners,
	  		    i,
	  		    len;
	
	  		if (!this._events) { return; }
	
	  		listeners = this._events[type];
	
	  		if (!listeners) {
	  			return;
	  		}
	
	  		if (!fn) {
	  			// Set all removed listeners to noop so they are not called if remove happens in fire
	  			for (i = 0, len = listeners.length; i < len; i++) {
	  				listeners[i].fn = falseFn;
	  			}
	  			// clear all listeners for a type if function isn't specified
	  			delete this._events[type];
	  			return;
	  		}
	
	  		if (context === this) {
	  			context = undefined;
	  		}
	
	  		if (listeners) {
	
	  			// find fn and remove it
	  			for (i = 0, len = listeners.length; i < len; i++) {
	  				var l = listeners[i];
	  				if (l.ctx !== context) { continue; }
	  				if (l.fn === fn) {
	
	  					// set the removed listener to noop so that's not called if remove happens in fire
	  					l.fn = falseFn;
	
	  					if (this._firingCount) {
	  						/* copy array in case events are being fired */
	  						this._events[type] = listeners = listeners.slice();
	  					}
	  					listeners.splice(i, 1);
	
	  					return;
	  				}
	  			}
	  		}
	  	},
	
	  	// @method fire(type: String, data?: Object, propagate?: Boolean): this
	  	// Fires an event of the specified type. You can optionally provide an data
	  	// object — the first argument of the listener function will contain its
	  	// properties. The event can optionally be propagated to event parents.
	  	fire: function (type, data, propagate) {
	  		if (!this.listens(type, propagate)) { return this; }
	
	  		var event = extend({}, data, {
	  			type: type,
	  			target: this,
	  			sourceTarget: data && data.sourceTarget || this
	  		});
	
	  		if (this._events) {
	  			var listeners = this._events[type];
	
	  			if (listeners) {
	  				this._firingCount = (this._firingCount + 1) || 1;
	  				for (var i = 0, len = listeners.length; i < len; i++) {
	  					var l = listeners[i];
	  					l.fn.call(l.ctx || this, event);
	  				}
	
	  				this._firingCount--;
	  			}
	  		}
	
	  		if (propagate) {
	  			// propagate the event to parents (set with addEventParent)
	  			this._propagateEvent(event);
	  		}
	
	  		return this;
	  	},
	
	  	// @method listens(type: String): Boolean
	  	// Returns `true` if a particular event type has any listeners attached to it.
	  	listens: function (type, propagate) {
	  		var listeners = this._events && this._events[type];
	  		if (listeners && listeners.length) { return true; }
	
	  		if (propagate) {
	  			// also check parents for listeners if event propagates
	  			for (var id in this._eventParents) {
	  				if (this._eventParents[id].listens(type, propagate)) { return true; }
	  			}
	  		}
	  		return false;
	  	},
	
	  	// @method once(…): this
	  	// Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
	  	once: function (types, fn, context) {
	
	  		if (typeof types === 'object') {
	  			for (var type in types) {
	  				this.once(type, types[type], fn);
	  			}
	  			return this;
	  		}
	
	  		var handler = bind(function () {
	  			this
	  			    .off(types, fn, context)
	  			    .off(types, handler, context);
	  		}, this);
	
	  		// add a listener that's executed once and removed after that
	  		return this
	  		    .on(types, fn, context)
	  		    .on(types, handler, context);
	  	},
	
	  	// @method addEventParent(obj: Evented): this
	  	// Adds an event parent - an `Evented` that will receive propagated events
	  	addEventParent: function (obj) {
	  		this._eventParents = this._eventParents || {};
	  		this._eventParents[stamp(obj)] = obj;
	  		return this;
	  	},
	
	  	// @method removeEventParent(obj: Evented): this
	  	// Removes an event parent, so it will stop receiving propagated events
	  	removeEventParent: function (obj) {
	  		if (this._eventParents) {
	  			delete this._eventParents[stamp(obj)];
	  		}
	  		return this;
	  	},
	
	  	_propagateEvent: function (e) {
	  		for (var id in this._eventParents) {
	  			this._eventParents[id].fire(e.type, extend({
	  				layer: e.target,
	  				propagatedFrom: e.target
	  			}, e), true);
	  		}
	  	}
	  };
	
	  // aliases; we should ditch those eventually
	
	  // @method addEventListener(…): this
	  // Alias to [`on(…)`](#evented-on)
	  Events.addEventListener = Events.on;
	
	  // @method removeEventListener(…): this
	  // Alias to [`off(…)`](#evented-off)
	
	  // @method clearAllEventListeners(…): this
	  // Alias to [`off()`](#evented-off)
	  Events.removeEventListener = Events.clearAllEventListeners = Events.off;
	
	  // @method addOneTimeEventListener(…): this
	  // Alias to [`once(…)`](#evented-once)
	  Events.addOneTimeEventListener = Events.once;
	
	  // @method fireEvent(…): this
	  // Alias to [`fire(…)`](#evented-fire)
	  Events.fireEvent = Events.fire;
	
	  // @method hasEventListeners(…): Boolean
	  // Alias to [`listens(…)`](#evented-listens)
	  Events.hasEventListeners = Events.listens;
	
	  var Evented = Class.extend(Events);
	
	  /*
	   * @class Point
	   * @aka L.Point
	   *
	   * Represents a point with `x` and `y` coordinates in pixels.
	   *
	   * @example
	   *
	   * ```js
	   * var point = L.point(200, 300);
	   * ```
	   *
	   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
	   *
	   * ```js
	   * map.panBy([200, 300]);
	   * map.panBy(L.point(200, 300));
	   * ```
	   *
	   * Note that `Point` does not inherit from Leaflet's `Class` object,
	   * which means new classes can't inherit from it, and new methods
	   * can't be added to it with the `include` function.
	   */
	
	  function Point(x, y, round) {
	  	// @property x: Number; The `x` coordinate of the point
	  	this.x = (round ? Math.round(x) : x);
	  	// @property y: Number; The `y` coordinate of the point
	  	this.y = (round ? Math.round(y) : y);
	  }
	
	  var trunc = Math.trunc || function (v) {
	  	return v > 0 ? Math.floor(v) : Math.ceil(v);
	  };
	
	  Point.prototype = {
	
	  	// @method clone(): Point
	  	// Returns a copy of the current point.
	  	clone: function () {
	  		return new Point(this.x, this.y);
	  	},
	
	  	// @method add(otherPoint: Point): Point
	  	// Returns the result of addition of the current and the given points.
	  	add: function (point) {
	  		// non-destructive, returns a new point
	  		return this.clone()._add(toPoint(point));
	  	},
	
	  	_add: function (point) {
	  		// destructive, used directly for performance in situations where it's safe to modify existing point
	  		this.x += point.x;
	  		this.y += point.y;
	  		return this;
	  	},
	
	  	// @method subtract(otherPoint: Point): Point
	  	// Returns the result of subtraction of the given point from the current.
	  	subtract: function (point) {
	  		return this.clone()._subtract(toPoint(point));
	  	},
	
	  	_subtract: function (point) {
	  		this.x -= point.x;
	  		this.y -= point.y;
	  		return this;
	  	},
	
	  	// @method divideBy(num: Number): Point
	  	// Returns the result of division of the current point by the given number.
	  	divideBy: function (num) {
	  		return this.clone()._divideBy(num);
	  	},
	
	  	_divideBy: function (num) {
	  		this.x /= num;
	  		this.y /= num;
	  		return this;
	  	},
	
	  	// @method multiplyBy(num: Number): Point
	  	// Returns the result of multiplication of the current point by the given number.
	  	multiplyBy: function (num) {
	  		return this.clone()._multiplyBy(num);
	  	},
	
	  	_multiplyBy: function (num) {
	  		this.x *= num;
	  		this.y *= num;
	  		return this;
	  	},
	
	  	// @method scaleBy(scale: Point): Point
	  	// Multiply each coordinate of the current point by each coordinate of
	  	// `scale`. In linear algebra terms, multiply the point by the
	  	// [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
	  	// defined by `scale`.
	  	scaleBy: function (point) {
	  		return new Point(this.x * point.x, this.y * point.y);
	  	},
	
	  	// @method unscaleBy(scale: Point): Point
	  	// Inverse of `scaleBy`. Divide each coordinate of the current point by
	  	// each coordinate of `scale`.
	  	unscaleBy: function (point) {
	  		return new Point(this.x / point.x, this.y / point.y);
	  	},
	
	  	// @method round(): Point
	  	// Returns a copy of the current point with rounded coordinates.
	  	round: function () {
	  		return this.clone()._round();
	  	},
	
	  	_round: function () {
	  		this.x = Math.round(this.x);
	  		this.y = Math.round(this.y);
	  		return this;
	  	},
	
	  	// @method floor(): Point
	  	// Returns a copy of the current point with floored coordinates (rounded down).
	  	floor: function () {
	  		return this.clone()._floor();
	  	},
	
	  	_floor: function () {
	  		this.x = Math.floor(this.x);
	  		this.y = Math.floor(this.y);
	  		return this;
	  	},
	
	  	// @method ceil(): Point
	  	// Returns a copy of the current point with ceiled coordinates (rounded up).
	  	ceil: function () {
	  		return this.clone()._ceil();
	  	},
	
	  	_ceil: function () {
	  		this.x = Math.ceil(this.x);
	  		this.y = Math.ceil(this.y);
	  		return this;
	  	},
	
	  	// @method trunc(): Point
	  	// Returns a copy of the current point with truncated coordinates (rounded towards zero).
	  	trunc: function () {
	  		return this.clone()._trunc();
	  	},
	
	  	_trunc: function () {
	  		this.x = trunc(this.x);
	  		this.y = trunc(this.y);
	  		return this;
	  	},
	
	  	// @method distanceTo(otherPoint: Point): Number
	  	// Returns the cartesian distance between the current and the given points.
	  	distanceTo: function (point) {
	  		point = toPoint(point);
	
	  		var x = point.x - this.x,
	  		    y = point.y - this.y;
	
	  		return Math.sqrt(x * x + y * y);
	  	},
	
	  	// @method equals(otherPoint: Point): Boolean
	  	// Returns `true` if the given point has the same coordinates.
	  	equals: function (point) {
	  		point = toPoint(point);
	
	  		return point.x === this.x &&
	  		       point.y === this.y;
	  	},
	
	  	// @method contains(otherPoint: Point): Boolean
	  	// Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
	  	contains: function (point) {
	  		point = toPoint(point);
	
	  		return Math.abs(point.x) <= Math.abs(this.x) &&
	  		       Math.abs(point.y) <= Math.abs(this.y);
	  	},
	
	  	// @method toString(): String
	  	// Returns a string representation of the point for debugging purposes.
	  	toString: function () {
	  		return 'Point(' +
	  		        formatNum(this.x) + ', ' +
	  		        formatNum(this.y) + ')';
	  	}
	  };
	
	  // @factory L.point(x: Number, y: Number, round?: Boolean)
	  // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
	
	  // @alternative
	  // @factory L.point(coords: Number[])
	  // Expects an array of the form `[x, y]` instead.
	
	  // @alternative
	  // @factory L.point(coords: Object)
	  // Expects a plain object of the form `{x: Number, y: Number}` instead.
	  function toPoint(x, y, round) {
	  	if (x instanceof Point) {
	  		return x;
	  	}
	  	if (isArray(x)) {
	  		return new Point(x[0], x[1]);
	  	}
	  	if (x === undefined || x === null) {
	  		return x;
	  	}
	  	if (typeof x === 'object' && 'x' in x && 'y' in x) {
	  		return new Point(x.x, x.y);
	  	}
	  	return new Point(x, y, round);
	  }
	
	  /*
	   * @class Bounds
	   * @aka L.Bounds
	   *
	   * Represents a rectangular area in pixel coordinates.
	   *
	   * @example
	   *
	   * ```js
	   * var p1 = L.point(10, 10),
	   * p2 = L.point(40, 60),
	   * bounds = L.bounds(p1, p2);
	   * ```
	   *
	   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
	   *
	   * ```js
	   * otherBounds.intersects([[10, 10], [40, 60]]);
	   * ```
	   *
	   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
	   * which means new classes can't inherit from it, and new methods
	   * can't be added to it with the `include` function.
	   */
	
	  function Bounds(a, b) {
	  	if (!a) { return; }
	
	  	var points = b ? [a, b] : a;
	
	  	for (var i = 0, len = points.length; i < len; i++) {
	  		this.extend(points[i]);
	  	}
	  }
	
	  Bounds.prototype = {
	  	// @method extend(point: Point): this
	  	// Extends the bounds to contain the given point.
	  	extend: function (point) { // (Point)
	  		point = toPoint(point);
	
	  		// @property min: Point
	  		// The top left corner of the rectangle.
	  		// @property max: Point
	  		// The bottom right corner of the rectangle.
	  		if (!this.min && !this.max) {
	  			this.min = point.clone();
	  			this.max = point.clone();
	  		} else {
	  			this.min.x = Math.min(point.x, this.min.x);
	  			this.max.x = Math.max(point.x, this.max.x);
	  			this.min.y = Math.min(point.y, this.min.y);
	  			this.max.y = Math.max(point.y, this.max.y);
	  		}
	  		return this;
	  	},
	
	  	// @method getCenter(round?: Boolean): Point
	  	// Returns the center point of the bounds.
	  	getCenter: function (round) {
	  		return new Point(
	  		        (this.min.x + this.max.x) / 2,
	  		        (this.min.y + this.max.y) / 2, round);
	  	},
	
	  	// @method getBottomLeft(): Point
	  	// Returns the bottom-left point of the bounds.
	  	getBottomLeft: function () {
	  		return new Point(this.min.x, this.max.y);
	  	},
	
	  	// @method getTopRight(): Point
	  	// Returns the top-right point of the bounds.
	  	getTopRight: function () { // -> Point
	  		return new Point(this.max.x, this.min.y);
	  	},
	
	  	// @method getTopLeft(): Point
	  	// Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
	  	getTopLeft: function () {
	  		return this.min; // left, top
	  	},
	
	  	// @method getBottomRight(): Point
	  	// Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
	  	getBottomRight: function () {
	  		return this.max; // right, bottom
	  	},
	
	  	// @method getSize(): Point
	  	// Returns the size of the given bounds
	  	getSize: function () {
	  		return this.max.subtract(this.min);
	  	},
	
	  	// @method contains(otherBounds: Bounds): Boolean
	  	// Returns `true` if the rectangle contains the given one.
	  	// @alternative
	  	// @method contains(point: Point): Boolean
	  	// Returns `true` if the rectangle contains the given point.
	  	contains: function (obj) {
	  		var min, max;
	
	  		if (typeof obj[0] === 'number' || obj instanceof Point) {
	  			obj = toPoint(obj);
	  		} else {
	  			obj = toBounds(obj);
	  		}
	
	  		if (obj instanceof Bounds) {
	  			min = obj.min;
	  			max = obj.max;
	  		} else {
	  			min = max = obj;
	  		}
	
	  		return (min.x >= this.min.x) &&
	  		       (max.x <= this.max.x) &&
	  		       (min.y >= this.min.y) &&
	  		       (max.y <= this.max.y);
	  	},
	
	  	// @method intersects(otherBounds: Bounds): Boolean
	  	// Returns `true` if the rectangle intersects the given bounds. Two bounds
	  	// intersect if they have at least one point in common.
	  	intersects: function (bounds) { // (Bounds) -> Boolean
	  		bounds = toBounds(bounds);
	
	  		var min = this.min,
	  		    max = this.max,
	  		    min2 = bounds.min,
	  		    max2 = bounds.max,
	  		    xIntersects = (max2.x >= min.x) && (min2.x <= max.x),
	  		    yIntersects = (max2.y >= min.y) && (min2.y <= max.y);
	
	  		return xIntersects && yIntersects;
	  	},
	
	  	// @method overlaps(otherBounds: Bounds): Boolean
	  	// Returns `true` if the rectangle overlaps the given bounds. Two bounds
	  	// overlap if their intersection is an area.
	  	overlaps: function (bounds) { // (Bounds) -> Boolean
	  		bounds = toBounds(bounds);
	
	  		var min = this.min,
	  		    max = this.max,
	  		    min2 = bounds.min,
	  		    max2 = bounds.max,
	  		    xOverlaps = (max2.x > min.x) && (min2.x < max.x),
	  		    yOverlaps = (max2.y > min.y) && (min2.y < max.y);
	
	  		return xOverlaps && yOverlaps;
	  	},
	
	  	isValid: function () {
	  		return !!(this.min && this.max);
	  	}
	  };
	
	
	  // @factory L.bounds(corner1: Point, corner2: Point)
	  // Creates a Bounds object from two corners coordinate pairs.
	  // @alternative
	  // @factory L.bounds(points: Point[])
	  // Creates a Bounds object from the given array of points.
	  function toBounds(a, b) {
	  	if (!a || a instanceof Bounds) {
	  		return a;
	  	}
	  	return new Bounds(a, b);
	  }
	
	  /*
	   * @class LatLngBounds
	   * @aka L.LatLngBounds
	   *
	   * Represents a rectangular geographical area on a map.
	   *
	   * @example
	   *
	   * ```js
	   * var corner1 = L.latLng(40.712, -74.227),
	   * corner2 = L.latLng(40.774, -74.125),
	   * bounds = L.latLngBounds(corner1, corner2);
	   * ```
	   *
	   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
	   *
	   * ```js
	   * map.fitBounds([
	   * 	[40.712, -74.227],
	   * 	[40.774, -74.125]
	   * ]);
	   * ```
	   *
	   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
	   *
	   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
	   * which means new classes can't inherit from it, and new methods
	   * can't be added to it with the `include` function.
	   */
	
	  function LatLngBounds(corner1, corner2) { // (LatLng, LatLng) or (LatLng[])
	  	if (!corner1) { return; }
	
	  	var latlngs = corner2 ? [corner1, corner2] : corner1;
	
	  	for (var i = 0, len = latlngs.length; i < len; i++) {
	  		this.extend(latlngs[i]);
	  	}
	  }
	
	  LatLngBounds.prototype = {
	
	  	// @method extend(latlng: LatLng): this
	  	// Extend the bounds to contain the given point
	
	  	// @alternative
	  	// @method extend(otherBounds: LatLngBounds): this
	  	// Extend the bounds to contain the given bounds
	  	extend: function (obj) {
	  		var sw = this._southWest,
	  		    ne = this._northEast,
	  		    sw2, ne2;
	
	  		if (obj instanceof LatLng) {
	  			sw2 = obj;
	  			ne2 = obj;
	
	  		} else if (obj instanceof LatLngBounds) {
	  			sw2 = obj._southWest;
	  			ne2 = obj._northEast;
	
	  			if (!sw2 || !ne2) { return this; }
	
	  		} else {
	  			return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
	  		}
	
	  		if (!sw && !ne) {
	  			this._southWest = new LatLng(sw2.lat, sw2.lng);
	  			this._northEast = new LatLng(ne2.lat, ne2.lng);
	  		} else {
	  			sw.lat = Math.min(sw2.lat, sw.lat);
	  			sw.lng = Math.min(sw2.lng, sw.lng);
	  			ne.lat = Math.max(ne2.lat, ne.lat);
	  			ne.lng = Math.max(ne2.lng, ne.lng);
	  		}
	
	  		return this;
	  	},
	
	  	// @method pad(bufferRatio: Number): LatLngBounds
	  	// Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
	  	// For example, a ratio of 0.5 extends the bounds by 50% in each direction.
	  	// Negative values will retract the bounds.
	  	pad: function (bufferRatio) {
	  		var sw = this._southWest,
	  		    ne = this._northEast,
	  		    heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio,
	  		    widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
	
	  		return new LatLngBounds(
	  		        new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer),
	  		        new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
	  	},
	
	  	// @method getCenter(): LatLng
	  	// Returns the center point of the bounds.
	  	getCenter: function () {
	  		return new LatLng(
	  		        (this._southWest.lat + this._northEast.lat) / 2,
	  		        (this._southWest.lng + this._northEast.lng) / 2);
	  	},
	
	  	// @method getSouthWest(): LatLng
	  	// Returns the south-west point of the bounds.
	  	getSouthWest: function () {
	  		return this._southWest;
	  	},
	
	  	// @method getNorthEast(): LatLng
	  	// Returns the north-east point of the bounds.
	  	getNorthEast: function () {
	  		return this._northEast;
	  	},
	
	  	// @method getNorthWest(): LatLng
	  	// Returns the north-west point of the bounds.
	  	getNorthWest: function () {
	  		return new LatLng(this.getNorth(), this.getWest());
	  	},
	
	  	// @method getSouthEast(): LatLng
	  	// Returns the south-east point of the bounds.
	  	getSouthEast: function () {
	  		return new LatLng(this.getSouth(), this.getEast());
	  	},
	
	  	// @method getWest(): Number
	  	// Returns the west longitude of the bounds
	  	getWest: function () {
	  		return this._southWest.lng;
	  	},
	
	  	// @method getSouth(): Number
	  	// Returns the south latitude of the bounds
	  	getSouth: function () {
	  		return this._southWest.lat;
	  	},
	
	  	// @method getEast(): Number
	  	// Returns the east longitude of the bounds
	  	getEast: function () {
	  		return this._northEast.lng;
	  	},
	
	  	// @method getNorth(): Number
	  	// Returns the north latitude of the bounds
	  	getNorth: function () {
	  		return this._northEast.lat;
	  	},
	
	  	// @method contains(otherBounds: LatLngBounds): Boolean
	  	// Returns `true` if the rectangle contains the given one.
	
	  	// @alternative
	  	// @method contains (latlng: LatLng): Boolean
	  	// Returns `true` if the rectangle contains the given point.
	  	contains: function (obj) { // (LatLngBounds) or (LatLng) -> Boolean
	  		if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) {
	  			obj = toLatLng(obj);
	  		} else {
	  			obj = toLatLngBounds(obj);
	  		}
	
	  		var sw = this._southWest,
	  		    ne = this._northEast,
	  		    sw2, ne2;
	
	  		if (obj instanceof LatLngBounds) {
	  			sw2 = obj.getSouthWest();
	  			ne2 = obj.getNorthEast();
	  		} else {
	  			sw2 = ne2 = obj;
	  		}
	
	  		return (sw2.lat >= sw.lat) && (ne2.lat <= ne.lat) &&
	  		       (sw2.lng >= sw.lng) && (ne2.lng <= ne.lng);
	  	},
	
	  	// @method intersects(otherBounds: LatLngBounds): Boolean
	  	// Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
	  	intersects: function (bounds) {
	  		bounds = toLatLngBounds(bounds);
	
	  		var sw = this._southWest,
	  		    ne = this._northEast,
	  		    sw2 = bounds.getSouthWest(),
	  		    ne2 = bounds.getNorthEast(),
	
	  		    latIntersects = (ne2.lat >= sw.lat) && (sw2.lat <= ne.lat),
	  		    lngIntersects = (ne2.lng >= sw.lng) && (sw2.lng <= ne.lng);
	
	  		return latIntersects && lngIntersects;
	  	},
	
	  	// @method overlaps(otherBounds: LatLngBounds): Boolean
	  	// Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
	  	overlaps: function (bounds) {
	  		bounds = toLatLngBounds(bounds);
	
	  		var sw = this._southWest,
	  		    ne = this._northEast,
	  		    sw2 = bounds.getSouthWest(),
	  		    ne2 = bounds.getNorthEast(),
	
	  		    latOverlaps = (ne2.lat > sw.lat) && (sw2.lat < ne.lat),
	  		    lngOverlaps = (ne2.lng > sw.lng) && (sw2.lng < ne.lng);
	
	  		return latOverlaps && lngOverlaps;
	  	},
	
	  	// @method toBBoxString(): String
	  	// Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
	  	toBBoxString: function () {
	  		return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(',');
	  	},
	
	  	// @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
	  	// Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
	  	equals: function (bounds, maxMargin) {
	  		if (!bounds) { return false; }
	
	  		bounds = toLatLngBounds(bounds);
	
	  		return this._southWest.equals(bounds.getSouthWest(), maxMargin) &&
	  		       this._northEast.equals(bounds.getNorthEast(), maxMargin);
	  	},
	
	  	// @method isValid(): Boolean
	  	// Returns `true` if the bounds are properly initialized.
	  	isValid: function () {
	  		return !!(this._southWest && this._northEast);
	  	}
	  };
	
	  // TODO International date line?
	
	  // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
	  // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
	
	  // @alternative
	  // @factory L.latLngBounds(latlngs: LatLng[])
	  // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
	  function toLatLngBounds(a, b) {
	  	if (a instanceof LatLngBounds) {
	  		return a;
	  	}
	  	return new LatLngBounds(a, b);
	  }
	
	  /* @class LatLng
	   * @aka L.LatLng
	   *
	   * Represents a geographical point with a certain latitude and longitude.
	   *
	   * @example
	   *
	   * ```
	   * var latlng = L.latLng(50.5, 30.5);
	   * ```
	   *
	   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
	   *
	   * ```
	   * map.panTo([50, 30]);
	   * map.panTo({lon: 30, lat: 50});
	   * map.panTo({lat: 50, lng: 30});
	   * map.panTo(L.latLng(50, 30));
	   * ```
	   *
	   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
	   * which means new classes can't inherit from it, and new methods
	   * can't be added to it with the `include` function.
	   */
	
	  function LatLng(lat, lng, alt) {
	  	if (isNaN(lat) || isNaN(lng)) {
	  		throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
	  	}
	
	  	// @property lat: Number
	  	// Latitude in degrees
	  	this.lat = +lat;
	
	  	// @property lng: Number
	  	// Longitude in degrees
	  	this.lng = +lng;
	
	  	// @property alt: Number
	  	// Altitude in meters (optional)
	  	if (alt !== undefined) {
	  		this.alt = +alt;
	  	}
	  }
	
	  LatLng.prototype = {
	  	// @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
	  	// Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
	  	equals: function (obj, maxMargin) {
	  		if (!obj) { return false; }
	
	  		obj = toLatLng(obj);
	
	  		var margin = Math.max(
	  		        Math.abs(this.lat - obj.lat),
	  		        Math.abs(this.lng - obj.lng));
	
	  		return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
	  	},
	
	  	// @method toString(): String
	  	// Returns a string representation of the point (for debugging purposes).
	  	toString: function (precision) {
	  		return 'LatLng(' +
	  		        formatNum(this.lat, precision) + ', ' +
	  		        formatNum(this.lng, precision) + ')';
	  	},
	
	  	// @method distanceTo(otherLatLng: LatLng): Number
	  	// Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
	  	distanceTo: function (other) {
	  		return Earth.distance(this, toLatLng(other));
	  	},
	
	  	// @method wrap(): LatLng
	  	// Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
	  	wrap: function () {
	  		return Earth.wrapLatLng(this);
	  	},
	
	  	// @method toBounds(sizeInMeters: Number): LatLngBounds
	  	// Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
	  	toBounds: function (sizeInMeters) {
	  		var latAccuracy = 180 * sizeInMeters / 40075017,
	  		    lngAccuracy = latAccuracy / Math.cos((Math.PI / 180) * this.lat);
	
	  		return toLatLngBounds(
	  		        [this.lat - latAccuracy, this.lng - lngAccuracy],
	  		        [this.lat + latAccuracy, this.lng + lngAccuracy]);
	  	},
	
	  	clone: function () {
	  		return new LatLng(this.lat, this.lng, this.alt);
	  	}
	  };
	
	
	
	  // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
	  // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
	
	  // @alternative
	  // @factory L.latLng(coords: Array): LatLng
	  // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
	
	  // @alternative
	  // @factory L.latLng(coords: Object): LatLng
	  // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
	
	  function toLatLng(a, b, c) {
	  	if (a instanceof LatLng) {
	  		return a;
	  	}
	  	if (isArray(a) && typeof a[0] !== 'object') {
	  		if (a.length === 3) {
	  			return new LatLng(a[0], a[1], a[2]);
	  		}
	  		if (a.length === 2) {
	  			return new LatLng(a[0], a[1]);
	  		}
	  		return null;
	  	}
	  	if (a === undefined || a === null) {
	  		return a;
	  	}
	  	if (typeof a === 'object' && 'lat' in a) {
	  		return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
	  	}
	  	if (b === undefined) {
	  		return null;
	  	}
	  	return new LatLng(a, b, c);
	  }
	
	  /*
	   * @namespace CRS
	   * @crs L.CRS.Base
	   * Object that defines coordinate reference systems for projecting
	   * geographical points into pixel (screen) coordinates and back (and to
	   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
	   * [spatial reference system](http://en.wikipedia.org/wiki/Coordinate_reference_system).
	   *
	   * Leaflet defines the most usual CRSs by default. If you want to use a
	   * CRS not defined by default, take a look at the
	   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
	   *
	   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
	   * and can't be instantiated. Also, new classes can't inherit from them,
	   * and methods can't be added to them with the `include` function.
	   */
	
	  var CRS = {
	  	// @method latLngToPoint(latlng: LatLng, zoom: Number): Point
	  	// Projects geographical coordinates into pixel coordinates for a given zoom.
	  	latLngToPoint: function (latlng, zoom) {
	  		var projectedPoint = this.projection.project(latlng),
	  		    scale = this.scale(zoom);
	
	  		return this.transformation._transform(projectedPoint, scale);
	  	},
	
	  	// @method pointToLatLng(point: Point, zoom: Number): LatLng
	  	// The inverse of `latLngToPoint`. Projects pixel coordinates on a given
	  	// zoom into geographical coordinates.
	  	pointToLatLng: function (point, zoom) {
	  		var scale = this.scale(zoom),
	  		    untransformedPoint = this.transformation.untransform(point, scale);
	
	  		return this.projection.unproject(untransformedPoint);
	  	},
	
	  	// @method project(latlng: LatLng): Point
	  	// Projects geographical coordinates into coordinates in units accepted for
	  	// this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
	  	project: function (latlng) {
	  		return this.projection.project(latlng);
	  	},
	
	  	// @method unproject(point: Point): LatLng
	  	// Given a projected coordinate returns the corresponding LatLng.
	  	// The inverse of `project`.
	  	unproject: function (point) {
	  		return this.projection.unproject(point);
	  	},
	
	  	// @method scale(zoom: Number): Number
	  	// Returns the scale used when transforming projected coordinates into
	  	// pixel coordinates for a particular zoom. For example, it returns
	  	// `256 * 2^zoom` for Mercator-based CRS.
	  	scale: function (zoom) {
	  		return 256 * Math.pow(2, zoom);
	  	},
	
	  	// @method zoom(scale: Number): Number
	  	// Inverse of `scale()`, returns the zoom level corresponding to a scale
	  	// factor of `scale`.
	  	zoom: function (scale) {
	  		return Math.log(scale / 256) / Math.LN2;
	  	},
	
	  	// @method getProjectedBounds(zoom: Number): Bounds
	  	// Returns the projection's bounds scaled and transformed for the provided `zoom`.
	  	getProjectedBounds: function (zoom) {
	  		if (this.infinite) { return null; }
	
	  		var b = this.projection.bounds,
	  		    s = this.scale(zoom),
	  		    min = this.transformation.transform(b.min, s),
	  		    max = this.transformation.transform(b.max, s);
	
	  		return new Bounds(min, max);
	  	},
	
	  	// @method distance(latlng1: LatLng, latlng2: LatLng): Number
	  	// Returns the distance between two geographical coordinates.
	
	  	// @property code: String
	  	// Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
	  	//
	  	// @property wrapLng: Number[]
	  	// An array of two numbers defining whether the longitude (horizontal) coordinate
	  	// axis wraps around a given range and how. Defaults to `[-180, 180]` in most
	  	// geographical CRSs. If `undefined`, the longitude axis does not wrap around.
	  	//
	  	// @property wrapLat: Number[]
	  	// Like `wrapLng`, but for the latitude (vertical) axis.
	
	  	// wrapLng: [min, max],
	  	// wrapLat: [min, max],
	
	  	// @property infinite: Boolean
	  	// If true, the coordinate space will be unbounded (infinite in both axes)
	  	infinite: false,
	
	  	// @method wrapLatLng(latlng: LatLng): LatLng
	  	// Returns a `LatLng` where lat and lng has been wrapped according to the
	  	// CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
	  	wrapLatLng: function (latlng) {
	  		var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng,
	  		    lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat,
	  		    alt = latlng.alt;
	
	  		return new LatLng(lat, lng, alt);
	  	},
	
	  	// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
	  	// Returns a `LatLngBounds` with the same size as the given one, ensuring
	  	// that its center is within the CRS's bounds.
	  	// Only accepts actual `L.LatLngBounds` instances, not arrays.
	  	wrapLatLngBounds: function (bounds) {
	  		var center = bounds.getCenter(),
	  		    newCenter = this.wrapLatLng(center),
	  		    latShift = center.lat - newCenter.lat,
	  		    lngShift = center.lng - newCenter.lng;
	
	  		if (latShift === 0 && lngShift === 0) {
	  			return bounds;
	  		}
	
	  		var sw = bounds.getSouthWest(),
	  		    ne = bounds.getNorthEast(),
	  		    newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift),
	  		    newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
	
	  		return new LatLngBounds(newSw, newNe);
	  	}
	  };
	
	  /*
	   * @namespace CRS
	   * @crs L.CRS.Earth
	   *
	   * Serves as the base for CRS that are global such that they cover the earth.
	   * Can only be used as the base for other CRS and cannot be used directly,
	   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
	   * meters.
	   */
	
	  var Earth = extend({}, CRS, {
	  	wrapLng: [-180, 180],
	
	  	// Mean Earth Radius, as recommended for use by
	  	// the International Union of Geodesy and Geophysics,
	  	// see http://rosettacode.org/wiki/Haversine_formula
	  	R: 6371000,
	
	  	// distance between two geographical points using spherical law of cosines approximation
	  	distance: function (latlng1, latlng2) {
	  		var rad = Math.PI / 180,
	  		    lat1 = latlng1.lat * rad,
	  		    lat2 = latlng2.lat * rad,
	  		    sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2),
	  		    sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2),
	  		    a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon,
	  		    c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	  		return this.R * c;
	  	}
	  });
	
	  /*
	   * @namespace Projection
	   * @projection L.Projection.SphericalMercator
	   *
	   * Spherical Mercator projection — the most common projection for online maps,
	   * used by almost all free and commercial tile providers. Assumes that Earth is
	   * a sphere. Used by the `EPSG:3857` CRS.
	   */
	
	  var earthRadius = 6378137;
	
	  var SphericalMercator = {
	
	  	R: earthRadius,
	  	MAX_LATITUDE: 85.0511287798,
	
	  	project: function (latlng) {
	  		var d = Math.PI / 180,
	  		    max = this.MAX_LATITUDE,
	  		    lat = Math.max(Math.min(max, latlng.lat), -max),
	  		    sin = Math.sin(lat * d);
	
	  		return new Point(
	  			this.R * latlng.lng * d,
	  			this.R * Math.log((1 + sin) / (1 - sin)) / 2);
	  	},
	
	  	unproject: function (point) {
	  		var d = 180 / Math.PI;
	
	  		return new LatLng(
	  			(2 * Math.atan(Math.exp(point.y / this.R)) - (Math.PI / 2)) * d,
	  			point.x * d / this.R);
	  	},
	
	  	bounds: (function () {
	  		var d = earthRadius * Math.PI;
	  		return new Bounds([-d, -d], [d, d]);
	  	})()
	  };
	
	  /*
	   * @class Transformation
	   * @aka L.Transformation
	   *
	   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
	   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
	   * the reverse. Used by Leaflet in its projections code.
	   *
	   * @example
	   *
	   * ```js
	   * var transformation = L.transformation(2, 5, -1, 10),
	   * 	p = L.point(1, 2),
	   * 	p2 = transformation.transform(p), //  L.point(7, 8)
	   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
	   * ```
	   */
	
	
	  // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
	  // Creates a `Transformation` object with the given coefficients.
	  function Transformation(a, b, c, d) {
	  	if (isArray(a)) {
	  		// use array properties
	  		this._a = a[0];
	  		this._b = a[1];
	  		this._c = a[2];
	  		this._d = a[3];
	  		return;
	  	}
	  	this._a = a;
	  	this._b = b;
	  	this._c = c;
	  	this._d = d;
	  }
	
	  Transformation.prototype = {
	  	// @method transform(point: Point, scale?: Number): Point
	  	// Returns a transformed point, optionally multiplied by the given scale.
	  	// Only accepts actual `L.Point` instances, not arrays.
	  	transform: function (point, scale) { // (Point, Number) -> Point
	  		return this._transform(point.clone(), scale);
	  	},
	
	  	// destructive transform (faster)
	  	_transform: function (point, scale) {
	  		scale = scale || 1;
	  		point.x = scale * (this._a * point.x + this._b);
	  		point.y = scale * (this._c * point.y + this._d);
	  		return point;
	  	},
	
	  	// @method untransform(point: Point, scale?: Number): Point
	  	// Returns the reverse transformation of the given point, optionally divided
	  	// by the given scale. Only accepts actual `L.Point` instances, not arrays.
	  	untransform: function (point, scale) {
	  		scale = scale || 1;
	  		return new Point(
	  		        (point.x / scale - this._b) / this._a,
	  		        (point.y / scale - this._d) / this._c);
	  	}
	  };
	
	  // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
	
	  // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
	  // Instantiates a Transformation object with the given coefficients.
	
	  // @alternative
	  // @factory L.transformation(coefficients: Array): Transformation
	  // Expects an coefficients array of the form
	  // `[a: Number, b: Number, c: Number, d: Number]`.
	
	  function toTransformation(a, b, c, d) {
	  	return new Transformation(a, b, c, d);
	  }
	
	  /*
	   * @namespace CRS
	   * @crs L.CRS.EPSG3857
	   *
	   * The most common CRS for online maps, used by almost all free and commercial
	   * tile providers. Uses Spherical Mercator projection. Set in by default in
	   * Map's `crs` option.
	   */
	
	  var EPSG3857 = extend({}, Earth, {
	  	code: 'EPSG:3857',
	  	projection: SphericalMercator,
	
	  	transformation: (function () {
	  		var scale = 0.5 / (Math.PI * SphericalMercator.R);
	  		return toTransformation(scale, 0.5, -scale, 0.5);
	  	}())
	  });
	
	  var EPSG900913 = extend({}, EPSG3857, {
	  	code: 'EPSG:900913'
	  });
	
	  // @namespace SVG; @section
	  // There are several static functions which can be called without instantiating L.SVG:
	
	  // @function create(name: String): SVGElement
	  // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
	  // corresponding to the class name passed. For example, using 'line' will return
	  // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
	  function svgCreate(name) {
	  	return document.createElementNS('http://www.w3.org/2000/svg', name);
	  }
	
	  // @function pointsToPath(rings: Point[], closed: Boolean): String
	  // Generates a SVG path string for multiple rings, with each ring turning
	  // into "M..L..L.." instructions
	  function pointsToPath(rings, closed) {
	  	var str = '',
	  	i, j, len, len2, points, p;
	
	  	for (i = 0, len = rings.length; i < len; i++) {
	  		points = rings[i];
	
	  		for (j = 0, len2 = points.length; j < len2; j++) {
	  			p = points[j];
	  			str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
	  		}
	
	  		// closes the ring for polygons; "x" is VML syntax
	  		str += closed ? (svg ? 'z' : 'x') : '';
	  	}
	
	  	// SVG complains about empty path strings
	  	return str || 'M0 0';
	  }
	
	  /*
	   * @namespace Browser
	   * @aka L.Browser
	   *
	   * A namespace with static properties for browser/feature detection used by Leaflet internally.
	   *
	   * @example
	   *
	   * ```js
	   * if (L.Browser.ielt9) {
	   *   alert('Upgrade your browser, dude!');
	   * }
	   * ```
	   */
	
	  var style$1 = document.documentElement.style;
	
	  // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
	  var ie = 'ActiveXObject' in window;
	
	  // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
	  var ielt9 = ie && !document.addEventListener;
	
	  // @property edge: Boolean; `true` for the Edge web browser.
	  var edge = 'msLaunchUri' in navigator && !('documentMode' in document);
	
	  // @property webkit: Boolean;
	  // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
	  var webkit = userAgentContains('webkit');
	
	  // @property android: Boolean
	  // `true` for any browser running on an Android platform.
	  var android = userAgentContains('android');
	
	  // @property android23: Boolean; `true` for browsers running on Android 2 or Android 3.
	  var android23 = userAgentContains('android 2') || userAgentContains('android 3');
	
	  /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */
	  var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
	  // @property androidStock: Boolean; `true` for the Android stock browser (i.e. not Chrome)
	  var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);
	
	  // @property opera: Boolean; `true` for the Opera browser
	  var opera = !!window.opera;
	
	  // @property chrome: Boolean; `true` for the Chrome browser.
	  var chrome = !edge && userAgentContains('chrome');
	
	  // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
	  var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;
	
	  // @property safari: Boolean; `true` for the Safari browser.
	  var safari = !chrome && userAgentContains('safari');
	
	  var phantom = userAgentContains('phantom');
	
	  // @property opera12: Boolean
	  // `true` for the Opera browser supporting CSS transforms (version 12 or later).
	  var opera12 = 'OTransition' in style$1;
	
	  // @property win: Boolean; `true` when the browser is running in a Windows platform
	  var win = navigator.platform.indexOf('Win') === 0;
	
	  // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
	  var ie3d = ie && ('transition' in style$1);
	
	  // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
	  var webkit3d = ('WebKitCSSMatrix' in window) && ('m11' in new window.WebKitCSSMatrix()) && !android23;
	
	  // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
	  var gecko3d = 'MozPerspective' in style$1;
	
	  // @property any3d: Boolean
	  // `true` for all browsers supporting CSS transforms.
	  var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
	
	  // @property mobile: Boolean; `true` for all browsers running in a mobile device.
	  var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');
	
	  // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
	  var mobileWebkit = mobile && webkit;
	
	  // @property mobileWebkit3d: Boolean
	  // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
	  var mobileWebkit3d = mobile && webkit3d;
	
	  // @property msPointer: Boolean
	  // `true` for browsers implementing the Microsoft touch events model (notably IE10).
	  var msPointer = !window.PointerEvent && window.MSPointerEvent;
	
	  // @property pointer: Boolean
	  // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
	  var pointer = !!(window.PointerEvent || msPointer);
	
	  // @property touch: Boolean
	  // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
	  // This does not necessarily mean that the browser is running in a computer with
	  // a touchscreen, it only means that the browser is capable of understanding
	  // touch events.
	  var touch = !window.L_NO_TOUCH && (pointer || 'ontouchstart' in window ||
	  		(window.DocumentTouch && document instanceof window.DocumentTouch));
	
	  // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
	  var mobileOpera = mobile && opera;
	
	  // @property mobileGecko: Boolean
	  // `true` for gecko-based browsers running in a mobile device.
	  var mobileGecko = mobile && gecko;
	
	  // @property retina: Boolean
	  // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
	  var retina = (window.devicePixelRatio || (window.screen.deviceXDPI / window.screen.logicalXDPI)) > 1;
	
	  // @property passiveEvents: Boolean
	  // `true` for browsers that support passive events.
	  var passiveEvents = (function () {
	  	var supportsPassiveOption = false;
	  	try {
	  		var opts = Object.defineProperty({}, 'passive', {
	  			get: function () { // eslint-disable-line getter-return
	  				supportsPassiveOption = true;
	  			}
	  		});
	  		window.addEventListener('testPassiveEventSupport', falseFn, opts);
	  		window.removeEventListener('testPassiveEventSupport', falseFn, opts);
	  	} catch (e) {
	  		// Errors can safely be ignored since this is only a browser support test.
	  	}
	  	return supportsPassiveOption;
	  }());
	
	  // @property canvas: Boolean
	  // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
	  var canvas = (function () {
	  	return !!document.createElement('canvas').getContext;
	  }());
	
	  // @property svg: Boolean
	  // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
	  var svg = !!(document.createElementNS && svgCreate('svg').createSVGRect);
	
	  // @property vml: Boolean
	  // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
	  var vml = !svg && (function () {
	  	try {
	  		var div = document.createElement('div');
	  		div.innerHTML = '<v:shape adj="1"/>';
	
	  		var shape = div.firstChild;
	  		shape.style.behavior = 'url(#default#VML)';
	
	  		return shape && (typeof shape.adj === 'object');
	
	  	} catch (e) {
	  		return false;
	  	}
	  }());
	
	
	  function userAgentContains(str) {
	  	return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
	  }
	
	  var Browser = ({
	    ie: ie,
	    ielt9: ielt9,
	    edge: edge,
	    webkit: webkit,
	    android: android,
	    android23: android23,
	    androidStock: androidStock,
	    opera: opera,
	    chrome: chrome,
	    gecko: gecko,
	    safari: safari,
	    phantom: phantom,
	    opera12: opera12,
	    win: win,
	    ie3d: ie3d,
	    webkit3d: webkit3d,
	    gecko3d: gecko3d,
	    any3d: any3d,
	    mobile: mobile,
	    mobileWebkit: mobileWebkit,
	    mobileWebkit3d: mobileWebkit3d,
	    msPointer: msPointer,
	    pointer: pointer,
	    touch: touch,
	    mobileOpera: mobileOpera,
	    mobileGecko: mobileGecko,
	    retina: retina,
	    passiveEvents: passiveEvents,
	    canvas: canvas,
	    svg: svg,
	    vml: vml
	  });
	
	  /*
	   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
	   */
	
	
	  var POINTER_DOWN =   msPointer ? 'MSPointerDown'   : 'pointerdown';
	  var POINTER_MOVE =   msPointer ? 'MSPointerMove'   : 'pointermove';
	  var POINTER_UP =     msPointer ? 'MSPointerUp'     : 'pointerup';
	  var POINTER_CANCEL = msPointer ? 'MSPointerCancel' : 'pointercancel';
	
	  var _pointers = {};
	  var _pointerDocListener = false;
	
	  // Provides a touch events wrapper for (ms)pointer events.
	  // ref http://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
	
	  function addPointerListener(obj, type, handler, id) {
	  	if (type === 'touchstart') {
	  		_addPointerStart(obj, handler, id);
	
	  	} else if (type === 'touchmove') {
	  		_addPointerMove(obj, handler, id);
	
	  	} else if (type === 'touchend') {
	  		_addPointerEnd(obj, handler, id);
	  	}
	
	  	return this;
	  }
	
	  function removePointerListener(obj, type, id) {
	  	var handler = obj['_leaflet_' + type + id];
	
	  	if (type === 'touchstart') {
	  		obj.removeEventListener(POINTER_DOWN, handler, false);
	
	  	} else if (type === 'touchmove') {
	  		obj.removeEventListener(POINTER_MOVE, handler, false);
	
	  	} else if (type === 'touchend') {
	  		obj.removeEventListener(POINTER_UP, handler, false);
	  		obj.removeEventListener(POINTER_CANCEL, handler, false);
	  	}
	
	  	return this;
	  }
	
	  function _addPointerStart(obj, handler, id) {
	  	var onDown = bind(function (e) {
	  		// IE10 specific: MsTouch needs preventDefault. See #2000
	  		if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) {
	  			preventDefault(e);
	  		}
	
	  		_handlePointer(e, handler);
	  	});
	
	  	obj['_leaflet_touchstart' + id] = onDown;
	  	obj.addEventListener(POINTER_DOWN, onDown, false);
	
	  	// need to keep track of what pointers and how many are active to provide e.touches emulation
	  	if (!_pointerDocListener) {
	  		// we listen document as any drags that end by moving the touch off the screen get fired there
	  		document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
	  		document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
	  		document.addEventListener(POINTER_UP, _globalPointerUp, true);
	  		document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
	
	  		_pointerDocListener = true;
	  	}
	  }
	
	  function _globalPointerDown(e) {
	  	_pointers[e.pointerId] = e;
	  }
	
	  function _globalPointerMove(e) {
	  	if (_pointers[e.pointerId]) {
	  		_pointers[e.pointerId] = e;
	  	}
	  }
	
	  function _globalPointerUp(e) {
	  	delete _pointers[e.pointerId];
	  }
	
	  function _handlePointer(e, handler) {
	  	e.touches = [];
	  	for (var i in _pointers) {
	  		e.touches.push(_pointers[i]);
	  	}
	  	e.changedTouches = [e];
	
	  	handler(e);
	  }
	
	  function _addPointerMove(obj, handler, id) {
	  	var onMove = function (e) {
	  		// don't fire touch moves when mouse isn't down
	  		if ((e.pointerType === (e.MSPOINTER_TYPE_MOUSE || 'mouse')) && e.buttons === 0) {
	  			return;
	  		}
	
	  		_handlePointer(e, handler);
	  	};
	
	  	obj['_leaflet_touchmove' + id] = onMove;
	  	obj.addEventListener(POINTER_MOVE, onMove, false);
	  }
	
	  function _addPointerEnd(obj, handler, id) {
	  	var onUp = function (e) {
	  		_handlePointer(e, handler);
	  	};
	
	  	obj['_leaflet_touchend' + id] = onUp;
	  	obj.addEventListener(POINTER_UP, onUp, false);
	  	obj.addEventListener(POINTER_CANCEL, onUp, false);
	  }
	
	  /*
	   * Extends the event handling code with double tap support for mobile browsers.
	   */
	
	  var _touchstart = msPointer ? 'MSPointerDown' : pointer ? 'pointerdown' : 'touchstart';
	  var _touchend = msPointer ? 'MSPointerUp' : pointer ? 'pointerup' : 'touchend';
	  var _pre = '_leaflet_';
	
	  // inspired by Zepto touch code by Thomas Fuchs
	  function addDoubleTapListener(obj, handler, id) {
	  	var last, touch$$1,
	  	    doubleTap = false,
	  	    delay = 250;
	
	  	function onTouchStart(e) {
	
	  		if (pointer) {
	  			if (!e.isPrimary) { return; }
	  			if (e.pointerType === 'mouse') { return; } // mouse fires native dblclick
	  		} else if (e.touches.length > 1) {
	  			return;
	  		}
	
	  		var now = Date.now(),
	  		    delta = now - (last || now);
	
	  		touch$$1 = e.touches ? e.touches[0] : e;
	  		doubleTap = (delta > 0 && delta <= delay);
	  		last = now;
	  	}
	
	  	function onTouchEnd(e) {
	  		if (doubleTap && !touch$$1.cancelBubble) {
	  			if (pointer) {
	  				if (e.pointerType === 'mouse') { return; }
	  				// work around .type being readonly with MSPointer* events
	  				var newTouch = {},
	  				    prop, i;
	
	  				for (i in touch$$1) {
	  					prop = touch$$1[i];
	  					newTouch[i] = prop && prop.bind ? prop.bind(touch$$1) : prop;
	  				}
	  				touch$$1 = newTouch;
	  			}
	  			touch$$1.type = 'dblclick';
	  			touch$$1.button = 0;
	  			handler(touch$$1);
	  			last = null;
	  		}
	  	}
	
	  	obj[_pre + _touchstart + id] = onTouchStart;
	  	obj[_pre + _touchend + id] = onTouchEnd;
	  	obj[_pre + 'dblclick' + id] = handler;
	
	  	obj.addEventListener(_touchstart, onTouchStart, passiveEvents ? {passive: false} : false);
	  	obj.addEventListener(_touchend, onTouchEnd, passiveEvents ? {passive: false} : false);
	
	  	// On some platforms (notably, chrome<55 on win10 + touchscreen + mouse),
	  	// the browser doesn't fire touchend/pointerup events but does fire
	  	// native dblclicks. See #4127.
	  	// Edge 14 also fires native dblclicks, but only for pointerType mouse, see #5180.
	  	obj.addEventListener('dblclick', handler, false);
	
	  	return this;
	  }
	
	  function removeDoubleTapListener(obj, id) {
	  	var touchstart = obj[_pre + _touchstart + id],
	  	    touchend = obj[_pre + _touchend + id],
	  	    dblclick = obj[_pre + 'dblclick' + id];
	
	  	obj.removeEventListener(_touchstart, touchstart, passiveEvents ? {passive: false} : false);
	  	obj.removeEventListener(_touchend, touchend, passiveEvents ? {passive: false} : false);
	  	obj.removeEventListener('dblclick', dblclick, false);
	
	  	return this;
	  }
	
	  /*
	   * @namespace DomUtil
	   *
	   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
	   * tree, used by Leaflet internally.
	   *
	   * Most functions expecting or returning a `HTMLElement` also work for
	   * SVG elements. The only difference is that classes refer to CSS classes
	   * in HTML and SVG classes in SVG.
	   */
	
	
	  // @property TRANSFORM: String
	  // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
	  var TRANSFORM = testProp(
	  	['transform', 'webkitTransform', 'OTransform', 'MozTransform', 'msTransform']);
	
	  // webkitTransition comes first because some browser versions that drop vendor prefix don't do
	  // the same for the transitionend event, in particular the Android 4.1 stock browser
	
	  // @property TRANSITION: String
	  // Vendor-prefixed transition style name.
	  var TRANSITION = testProp(
	  	['webkitTransition', 'transition', 'OTransition', 'MozTransition', 'msTransition']);
	
	  // @property TRANSITION_END: String
	  // Vendor-prefixed transitionend event name.
	  var TRANSITION_END =
	  	TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';
	
	
	  // @function get(id: String|HTMLElement): HTMLElement
	  // Returns an element given its DOM id, or returns the element itself
	  // if it was passed directly.
	  function get(id) {
	  	return typeof id === 'string' ? document.getElementById(id) : id;
	  }
	
	  // @function getStyle(el: HTMLElement, styleAttrib: String): String
	  // Returns the value for a certain style attribute on an element,
	  // including computed values or values set through CSS.
	  function getStyle(el, style) {
	  	var value = el.style[style] || (el.currentStyle && el.currentStyle[style]);
	
	  	if ((!value || value === 'auto') && document.defaultView) {
	  		var css = document.defaultView.getComputedStyle(el, null);
	  		value = css ? css[style] : null;
	  	}
	  	return value === 'auto' ? null : value;
	  }
	
	  // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
	  // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
	  function create$1(tagName, className, container) {
	  	var el = document.createElement(tagName);
	  	el.className = className || '';
	
	  	if (container) {
	  		container.appendChild(el);
	  	}
	  	return el;
	  }
	
	  // @function remove(el: HTMLElement)
	  // Removes `el` from its parent element
	  function remove(el) {
	  	var parent = el.parentNode;
	  	if (parent) {
	  		parent.removeChild(el);
	  	}
	  }
	
	  // @function empty(el: HTMLElement)
	  // Removes all of `el`'s children elements from `el`
	  function empty(el) {
	  	while (el.firstChild) {
	  		el.removeChild(el.firstChild);
	  	}
	  }
	
	  // @function toFront(el: HTMLElement)
	  // Makes `el` the last child of its parent, so it renders in front of the other children.
	  function toFront(el) {
	  	var parent = el.parentNode;
	  	if (parent && parent.lastChild !== el) {
	  		parent.appendChild(el);
	  	}
	  }
	
	  // @function toBack(el: HTMLElement)
	  // Makes `el` the first child of its parent, so it renders behind the other children.
	  function toBack(el) {
	  	var parent = el.parentNode;
	  	if (parent && parent.firstChild !== el) {
	  		parent.insertBefore(el, parent.firstChild);
	  	}
	  }
	
	  // @function hasClass(el: HTMLElement, name: String): Boolean
	  // Returns `true` if the element's class attribute contains `name`.
	  function hasClass(el, name) {
	  	if (el.classList !== undefined) {
	  		return el.classList.contains(name);
	  	}
	  	var className = getClass(el);
	  	return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
	  }
	
	  // @function addClass(el: HTMLElement, name: String)
	  // Adds `name` to the element's class attribute.
	  function addClass(el, name) {
	  	if (el.classList !== undefined) {
	  		var classes = splitWords(name);
	  		for (var i = 0, len = classes.length; i < len; i++) {
	  			el.classList.add(classes[i]);
	  		}
	  	} else if (!hasClass(el, name)) {
	  		var className = getClass(el);
	  		setClass(el, (className ? className + ' ' : '') + name);
	  	}
	  }
	
	  // @function removeClass(el: HTMLElement, name: String)
	  // Removes `name` from the element's class attribute.
	  function removeClass(el, name) {
	  	if (el.classList !== undefined) {
	  		el.classList.remove(name);
	  	} else {
	  		setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
	  	}
	  }
	
	  // @function setClass(el: HTMLElement, name: String)
	  // Sets the element's class.
	  function setClass(el, name) {
	  	if (el.className.baseVal === undefined) {
	  		el.className = name;
	  	} else {
	  		// in case of SVG element
	  		el.className.baseVal = name;
	  	}
	  }
	
	  // @function getClass(el: HTMLElement): String
	  // Returns the element's class.
	  function getClass(el) {
	  	// Check if the element is an SVGElementInstance and use the correspondingElement instead
	  	// (Required for linked SVG elements in IE11.)
	  	if (el.correspondingElement) {
	  		el = el.correspondingElement;
	  	}
	  	return el.className.baseVal === undefined ? el.className : el.className.baseVal;
	  }
	
	  // @function setOpacity(el: HTMLElement, opacity: Number)
	  // Set the opacity of an element (including old IE support).
	  // `opacity` must be a number from `0` to `1`.
	  function setOpacity(el, value) {
	  	if ('opacity' in el.style) {
	  		el.style.opacity = value;
	  	} else if ('filter' in el.style) {
	  		_setOpacityIE(el, value);
	  	}
	  }
	
	  function _setOpacityIE(el, value) {
	  	var filter = false,
	  	    filterName = 'DXImageTransform.Microsoft.Alpha';
	
	  	// filters collection throws an error if we try to retrieve a filter that doesn't exist
	  	try {
	  		filter = el.filters.item(filterName);
	  	} catch (e) {
	  		// don't set opacity to 1 if we haven't already set an opacity,
	  		// it isn't needed and breaks transparent pngs.
	  		if (value === 1) { return; }
	  	}
	
	  	value = Math.round(value * 100);
	
	  	if (filter) {
	  		filter.Enabled = (value !== 100);
	  		filter.Opacity = value;
	  	} else {
	  		el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
	  	}
	  }
	
	  // @function testProp(props: String[]): String|false
	  // Goes through the array of style names and returns the first name
	  // that is a valid style name for an element. If no such name is found,
	  // it returns false. Useful for vendor-prefixed styles like `transform`.
	  function testProp(props) {
	  	var style = document.documentElement.style;
	
	  	for (var i = 0; i < props.length; i++) {
	  		if (props[i] in style) {
	  			return props[i];
	  		}
	  	}
	  	return false;
	  }
	
	  // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
	  // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
	  // and optionally scaled by `scale`. Does not have an effect if the
	  // browser doesn't support 3D CSS transforms.
	  function setTransform(el, offset, scale) {
	  	var pos = offset || new Point(0, 0);
	
	  	el.style[TRANSFORM] =
	  		(ie3d ?
	  			'translate(' + pos.x + 'px,' + pos.y + 'px)' :
	  			'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') +
	  		(scale ? ' scale(' + scale + ')' : '');
	  }
	
	  // @function setPosition(el: HTMLElement, position: Point)
	  // Sets the position of `el` to coordinates specified by `position`,
	  // using CSS translate or top/left positioning depending on the browser
	  // (used by Leaflet internally to position its layers).
	  function setPosition(el, point) {
	
	  	/*eslint-disable */
	  	el._leaflet_pos = point;
	  	/* eslint-enable */
	
	  	if (any3d) {
	  		setTransform(el, point);
	  	} else {
	  		el.style.left = point.x + 'px';
	  		el.style.top = point.y + 'px';
	  	}
	  }
	
	  // @function getPosition(el: HTMLElement): Point
	  // Returns the coordinates of an element previously positioned with setPosition.
	  function getPosition(el) {
	  	// this method is only used for elements previously positioned using setPosition,
	  	// so it's safe to cache the position for performance
	
	  	return el._leaflet_pos || new Point(0, 0);
	  }
	
	  // @function disableTextSelection()
	  // Prevents the user from generating `selectstart` DOM events, usually generated
	  // when the user drags the mouse through a page with text. Used internally
	  // by Leaflet to override the behaviour of any click-and-drag interaction on
	  // the map. Affects drag interactions on the whole document.
	
	  // @function enableTextSelection()
	  // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
	  var disableTextSelection;
	  var enableTextSelection;
	  var _userSelect;
	  if ('onselectstart' in document) {
	  	disableTextSelection = function () {
	  		on(window, 'selectstart', preventDefault);
	  	};
	  	enableTextSelection = function () {
	  		off(window, 'selectstart', preventDefault);
	  	};
	  } else {
	  	var userSelectProperty = testProp(
	  		['userSelect', 'WebkitUserSelect', 'OUserSelect', 'MozUserSelect', 'msUserSelect']);
	
	  	disableTextSelection = function () {
	  		if (userSelectProperty) {
	  			var style = document.documentElement.style;
	  			_userSelect = style[userSelectProperty];
	  			style[userSelectProperty] = 'none';
	  		}
	  	};
	  	enableTextSelection = function () {
	  		if (userSelectProperty) {
	  			document.documentElement.style[userSelectProperty] = _userSelect;
	  			_userSelect = undefined;
	  		}
	  	};
	  }
	
	  // @function disableImageDrag()
	  // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
	  // for `dragstart` DOM events, usually generated when the user drags an image.
	  function disableImageDrag() {
	  	on(window, 'dragstart', preventDefault);
	  }
	
	  // @function enableImageDrag()
	  // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
	  function enableImageDrag() {
	  	off(window, 'dragstart', preventDefault);
	  }
	
	  var _outlineElement, _outlineStyle;
	  // @function preventOutline(el: HTMLElement)
	  // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
	  // of the element `el` invisible. Used internally by Leaflet to prevent
	  // focusable elements from displaying an outline when the user performs a
	  // drag interaction on them.
	  function preventOutline(element) {
	  	while (element.tabIndex === -1) {
	  		element = element.parentNode;
	  	}
	  	if (!element.style) { return; }
	  	restoreOutline();
	  	_outlineElement = element;
	  	_outlineStyle = element.style.outline;
	  	element.style.outline = 'none';
	  	on(window, 'keydown', restoreOutline);
	  }
	
	  // @function restoreOutline()
	  // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
	  function restoreOutline() {
	  	if (!_outlineElement) { return; }
	  	_outlineElement.style.outline = _outlineStyle;
	  	_outlineElement = undefined;
	  	_outlineStyle = undefined;
	  	off(window, 'keydown', restoreOutline);
	  }
	
	  // @function getSizedParentNode(el: HTMLElement): HTMLElement
	  // Finds the closest parent node which size (width and height) is not null.
	  function getSizedParentNode(element) {
	  	do {
	  		element = element.parentNode;
	  	} while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
	  	return element;
	  }
	
	  // @function getScale(el: HTMLElement): Object
	  // Computes the CSS scale currently applied on the element.
	  // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
	  // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
	  function getScale(element) {
	  	var rect = element.getBoundingClientRect(); // Read-only in old browsers.
	
	  	return {
	  		x: rect.width / element.offsetWidth || 1,
	  		y: rect.height / element.offsetHeight || 1,
	  		boundingClientRect: rect
	  	};
	  }
	
	  var DomUtil = ({
	    TRANSFORM: TRANSFORM,
	    TRANSITION: TRANSITION,
	    TRANSITION_END: TRANSITION_END,
	    get: get,
	    getStyle: getStyle,
	    create: create$1,
	    remove: remove,
	    empty: empty,
	    toFront: toFront,
	    toBack: toBack,
	    hasClass: hasClass,
	    addClass: addClass,
	    removeClass: removeClass,
	    setClass: setClass,
	    getClass: getClass,
	    setOpacity: setOpacity,
	    testProp: testProp,
	    setTransform: setTransform,
	    setPosition: setPosition,
	    getPosition: getPosition,
	    disableTextSelection: disableTextSelection,
	    enableTextSelection: enableTextSelection,
	    disableImageDrag: disableImageDrag,
	    enableImageDrag: enableImageDrag,
	    preventOutline: preventOutline,
	    restoreOutline: restoreOutline,
	    getSizedParentNode: getSizedParentNode,
	    getScale: getScale
	  });
	
	  /*
	   * @namespace DomEvent
	   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
	   */
	
	  // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
	
	  // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
	  // Adds a listener function (`fn`) to a particular DOM event type of the
	  // element `el`. You can optionally specify the context of the listener
	  // (object the `this` keyword will point to). You can also pass several
	  // space-separated types (e.g. `'click dblclick'`).
	
	  // @alternative
	  // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
	  // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	  function on(obj, types, fn, context) {
	
	  	if (typeof types === 'object') {
	  		for (var type in types) {
	  			addOne(obj, type, types[type], fn);
	  		}
	  	} else {
	  		types = splitWords(types);
	
	  		for (var i = 0, len = types.length; i < len; i++) {
	  			addOne(obj, types[i], fn, context);
	  		}
	  	}
	
	  	return this;
	  }
	
	  var eventsKey = '_leaflet_events';
	
	  // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
	  // Removes a previously added listener function.
	  // Note that if you passed a custom context to on, you must pass the same
	  // context to `off` in order to remove the listener.
	
	  // @alternative
	  // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
	  // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	  function off(obj, types, fn, context) {
	
	  	if (typeof types === 'object') {
	  		for (var type in types) {
	  			removeOne(obj, type, types[type], fn);
	  		}
	  	} else if (types) {
	  		types = splitWords(types);
	
	  		for (var i = 0, len = types.length; i < len; i++) {
	  			removeOne(obj, types[i], fn, context);
	  		}
	  	} else {
	  		for (var j in obj[eventsKey]) {
	  			removeOne(obj, j, obj[eventsKey][j]);
	  		}
	  		delete obj[eventsKey];
	  	}
	
	  	return this;
	  }
	
	  function browserFiresNativeDblClick() {
	  	// See https://github.com/w3c/pointerevents/issues/171
	  	if (pointer) {
	  		return !(edge || safari);
	  	}
	  }
	
	  var mouseSubst = {
	  	mouseenter: 'mouseover',
	  	mouseleave: 'mouseout',
	  	wheel: !('onwheel' in window) && 'mousewheel'
	  };
	
	  function addOne(obj, type, fn, context) {
	  	var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
	
	  	if (obj[eventsKey] && obj[eventsKey][id]) { return this; }
	
	  	var handler = function (e) {
	  		return fn.call(context || obj, e || window.event);
	  	};
	
	  	var originalHandler = handler;
	
	  	if (pointer && type.indexOf('touch') === 0) {
	  		// Needs DomEvent.Pointer.js
	  		addPointerListener(obj, type, handler, id);
	
	  	} else if (touch && (type === 'dblclick') && !browserFiresNativeDblClick()) {
	  		addDoubleTapListener(obj, handler, id);
	
	  	} else if ('addEventListener' in obj) {
	
	  		if (type === 'touchstart' || type === 'touchmove' || type === 'wheel' ||  type === 'mousewheel') {
	  			obj.addEventListener(mouseSubst[type] || type, handler, passiveEvents ? {passive: false} : false);
	
	  		} else if (type === 'mouseenter' || type === 'mouseleave') {
	  			handler = function (e) {
	  				e = e || window.event;
	  				if (isExternalTarget(obj, e)) {
	  					originalHandler(e);
	  				}
	  			};
	  			obj.addEventListener(mouseSubst[type], handler, false);
	
	  		} else {
	  			obj.addEventListener(type, originalHandler, false);
	  		}
	
	  	} else if ('attachEvent' in obj) {
	  		obj.attachEvent('on' + type, handler);
	  	}
	
	  	obj[eventsKey] = obj[eventsKey] || {};
	  	obj[eventsKey][id] = handler;
	  }
	
	  function removeOne(obj, type, fn, context) {
	
	  	var id = type + stamp(fn) + (context ? '_' + stamp(context) : ''),
	  	    handler = obj[eventsKey] && obj[eventsKey][id];
	
	  	if (!handler) { return this; }
	
	  	if (pointer && type.indexOf('touch') === 0) {
	  		removePointerListener(obj, type, id);
	
	  	} else if (touch && (type === 'dblclick') && !browserFiresNativeDblClick()) {
	  		removeDoubleTapListener(obj, id);
	
	  	} else if ('removeEventListener' in obj) {
	
	  		obj.removeEventListener(mouseSubst[type] || type, handler, false);
	
	  	} else if ('detachEvent' in obj) {
	  		obj.detachEvent('on' + type, handler);
	  	}
	
	  	obj[eventsKey][id] = null;
	  }
	
	  // @function stopPropagation(ev: DOMEvent): this
	  // Stop the given event from propagation to parent elements. Used inside the listener functions:
	  // ```js
	  // L.DomEvent.on(div, 'click', function (ev) {
	  // 	L.DomEvent.stopPropagation(ev);
	  // });
	  // ```
	  function stopPropagation(e) {
	
	  	if (e.stopPropagation) {
	  		e.stopPropagation();
	  	} else if (e.originalEvent) {  // In case of Leaflet event.
	  		e.originalEvent._stopped = true;
	  	} else {
	  		e.cancelBubble = true;
	  	}
	  	skipped(e);
	
	  	return this;
	  }
	
	  // @function disableScrollPropagation(el: HTMLElement): this
	  // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
	  function disableScrollPropagation(el) {
	  	addOne(el, 'wheel', stopPropagation);
	  	return this;
	  }
	
	  // @function disableClickPropagation(el: HTMLElement): this
	  // Adds `stopPropagation` to the element's `'click'`, `'doubleclick'`,
	  // `'mousedown'` and `'touchstart'` events (plus browser variants).
	  function disableClickPropagation(el) {
	  	on(el, 'mousedown touchstart dblclick', stopPropagation);
	  	addOne(el, 'click', fakeStop);
	  	return this;
	  }
	
	  // @function preventDefault(ev: DOMEvent): this
	  // Prevents the default action of the DOM Event `ev` from happening (such as
	  // following a link in the href of the a element, or doing a POST request
	  // with page reload when a `<form>` is submitted).
	  // Use it inside listener functions.
	  function preventDefault(e) {
	  	if (e.preventDefault) {
	  		e.preventDefault();
	  	} else {
	  		e.returnValue = false;
	  	}
	  	return this;
	  }
	
	  // @function stop(ev: DOMEvent): this
	  // Does `stopPropagation` and `preventDefault` at the same time.
	  function stop(e) {
	  	preventDefault(e);
	  	stopPropagation(e);
	  	return this;
	  }
	
	  // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
	  // Gets normalized mouse position from a DOM event relative to the
	  // `container` (border excluded) or to the whole page if not specified.
	  function getMousePosition(e, container) {
	  	if (!container) {
	  		return new Point(e.clientX, e.clientY);
	  	}
	
	  	var scale = getScale(container),
	  	    offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
	
	  	return new Point(
	  		// offset.left/top values are in page scale (like clientX/Y),
	  		// whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
	  		(e.clientX - offset.left) / scale.x - container.clientLeft,
	  		(e.clientY - offset.top) / scale.y - container.clientTop
	  	);
	  }
	
	  // Chrome on Win scrolls double the pixels as in other platforms (see #4538),
	  // and Firefox scrolls device pixels, not CSS pixels
	  var wheelPxFactor =
	  	(win && chrome) ? 2 * window.devicePixelRatio :
	  	gecko ? window.devicePixelRatio : 1;
	
	  // @function getWheelDelta(ev: DOMEvent): Number
	  // Gets normalized wheel delta from a wheel DOM event, in vertical
	  // pixels scrolled (negative if scrolling down).
	  // Events from pointing devices without precise scrolling are mapped to
	  // a best guess of 60 pixels.
	  function getWheelDelta(e) {
	  	return (edge) ? e.wheelDeltaY / 2 : // Don't trust window-geometry-based delta
	  	       (e.deltaY && e.deltaMode === 0) ? -e.deltaY / wheelPxFactor : // Pixels
	  	       (e.deltaY && e.deltaMode === 1) ? -e.deltaY * 20 : // Lines
	  	       (e.deltaY && e.deltaMode === 2) ? -e.deltaY * 60 : // Pages
	  	       (e.deltaX || e.deltaZ) ? 0 :	// Skip horizontal/depth wheel events
	  	       e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : // Legacy IE pixels
	  	       (e.detail && Math.abs(e.detail) < 32765) ? -e.detail * 20 : // Legacy Moz lines
	  	       e.detail ? e.detail / -32765 * 60 : // Legacy Moz pages
	  	       0;
	  }
	
	  var skipEvents = {};
	
	  function fakeStop(e) {
	  	// fakes stopPropagation by setting a special event flag, checked/reset with skipped(e)
	  	skipEvents[e.type] = true;
	  }
	
	  function skipped(e) {
	  	var events = skipEvents[e.type];
	  	// reset when checking, as it's only used in map container and propagates outside of the map
	  	skipEvents[e.type] = false;
	  	return events;
	  }
	
	  // check if element really left/entered the event target (for mouseenter/mouseleave)
	  function isExternalTarget(el, e) {
	
	  	var related = e.relatedTarget;
	
	  	if (!related) { return true; }
	
	  	try {
	  		while (related && (related !== el)) {
	  			related = related.parentNode;
	  		}
	  	} catch (err) {
	  		return false;
	  	}
	  	return (related !== el);
	  }
	
	  var DomEvent = ({
	    on: on,
	    off: off,
	    stopPropagation: stopPropagation,
	    disableScrollPropagation: disableScrollPropagation,
	    disableClickPropagation: disableClickPropagation,
	    preventDefault: preventDefault,
	    stop: stop,
	    getMousePosition: getMousePosition,
	    getWheelDelta: getWheelDelta,
	    fakeStop: fakeStop,
	    skipped: skipped,
	    isExternalTarget: isExternalTarget,
	    addListener: on,
	    removeListener: off
	  });
	
	  /*
	   * @class PosAnimation
	   * @aka L.PosAnimation
	   * @inherits Evented
	   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
	   *
	   * @example
	   * ```js
	   * var fx = new L.PosAnimation();
	   * fx.run(el, [300, 500], 0.5);
	   * ```
	   *
	   * @constructor L.PosAnimation()
	   * Creates a `PosAnimation` object.
	   *
	   */
	
	  var PosAnimation = Evented.extend({
	
	  	// @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
	  	// Run an animation of a given element to a new position, optionally setting
	  	// duration in seconds (`0.25` by default) and easing linearity factor (3rd
	  	// argument of the [cubic bezier curve](http://cubic-bezier.com/#0,0,.5,1),
	  	// `0.5` by default).
	  	run: function (el, newPos, duration, easeLinearity) {
	  		this.stop();
	
	  		this._el = el;
	  		this._inProgress = true;
	  		this._duration = duration || 0.25;
	  		this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
	
	  		this._startPos = getPosition(el);
	  		this._offset = newPos.subtract(this._startPos);
	  		this._startTime = +new Date();
	
	  		// @event start: Event
	  		// Fired when the animation starts
	  		this.fire('start');
	
	  		this._animate();
	  	},
	
	  	// @method stop()
	  	// Stops the animation (if currently running).
	  	stop: function () {
	  		if (!this._inProgress) { return; }
	
	  		this._step(true);
	  		this._complete();
	  	},
	
	  	_animate: function () {
	  		// animation loop
	  		this._animId = requestAnimFrame(this._animate, this);
	  		this._step();
	  	},
	
	  	_step: function (round) {
	  		var elapsed = (+new Date()) - this._startTime,
	  		    duration = this._duration * 1000;
	
	  		if (elapsed < duration) {
	  			this._runFrame(this._easeOut(elapsed / duration), round);
	  		} else {
	  			this._runFrame(1);
	  			this._complete();
	  		}
	  	},
	
	  	_runFrame: function (progress, round) {
	  		var pos = this._startPos.add(this._offset.multiplyBy(progress));
	  		if (round) {
	  			pos._round();
	  		}
	  		setPosition(this._el, pos);
	
	  		// @event step: Event
	  		// Fired continuously during the animation.
	  		this.fire('step');
	  	},
	
	  	_complete: function () {
	  		cancelAnimFrame(this._animId);
	
	  		this._inProgress = false;
	  		// @event end: Event
	  		// Fired when the animation ends.
	  		this.fire('end');
	  	},
	
	  	_easeOut: function (t) {
	  		return 1 - Math.pow(1 - t, this._easeOutPower);
	  	}
	  });
	
	  /*
	   * @class Map
	   * @aka L.Map
	   * @inherits Evented
	   *
	   * The central class of the API — it is used to create a map on a page and manipulate it.
	   *
	   * @example
	   *
	   * ```js
	   * // initialize the map on the "map" div with a given center and zoom
	   * var map = L.map('map', {
	   * 	center: [51.505, -0.09],
	   * 	zoom: 13
	   * });
	   * ```
	   *
	   */
	
	  var Map = Evented.extend({
	
	  	options: {
	  		// @section Map State Options
	  		// @option crs: CRS = L.CRS.EPSG3857
	  		// The [Coordinate Reference System](#crs) to use. Don't change this if you're not
	  		// sure what it means.
	  		crs: EPSG3857,
	
	  		// @option center: LatLng = undefined
	  		// Initial geographic center of the map
	  		center: undefined,
	
	  		// @option zoom: Number = undefined
	  		// Initial map zoom level
	  		zoom: undefined,
	
	  		// @option minZoom: Number = *
	  		// Minimum zoom level of the map.
	  		// If not specified and at least one `GridLayer` or `TileLayer` is in the map,
	  		// the lowest of their `minZoom` options will be used instead.
	  		minZoom: undefined,
	
	  		// @option maxZoom: Number = *
	  		// Maximum zoom level of the map.
	  		// If not specified and at least one `GridLayer` or `TileLayer` is in the map,
	  		// the highest of their `maxZoom` options will be used instead.
	  		maxZoom: undefined,
	
	  		// @option layers: Layer[] = []
	  		// Array of layers that will be added to the map initially
	  		layers: [],
	
	  		// @option maxBounds: LatLngBounds = null
	  		// When this option is set, the map restricts the view to the given
	  		// geographical bounds, bouncing the user back if the user tries to pan
	  		// outside the view. To set the restriction dynamically, use
	  		// [`setMaxBounds`](#map-setmaxbounds) method.
	  		maxBounds: undefined,
	
	  		// @option renderer: Renderer = *
	  		// The default method for drawing vector layers on the map. `L.SVG`
	  		// or `L.Canvas` by default depending on browser support.
	  		renderer: undefined,
	
	
	  		// @section Animation Options
	  		// @option zoomAnimation: Boolean = true
	  		// Whether the map zoom animation is enabled. By default it's enabled
	  		// in all browsers that support CSS3 Transitions except Android.
	  		zoomAnimation: true,
	
	  		// @option zoomAnimationThreshold: Number = 4
	  		// Won't animate zoom if the zoom difference exceeds this value.
	  		zoomAnimationThreshold: 4,
	
	  		// @option fadeAnimation: Boolean = true
	  		// Whether the tile fade animation is enabled. By default it's enabled
	  		// in all browsers that support CSS3 Transitions except Android.
	  		fadeAnimation: true,
	
	  		// @option markerZoomAnimation: Boolean = true
	  		// Whether markers animate their zoom with the zoom animation, if disabled
	  		// they will disappear for the length of the animation. By default it's
	  		// enabled in all browsers that support CSS3 Transitions except Android.
	  		markerZoomAnimation: true,
	
	  		// @option transform3DLimit: Number = 2^23
	  		// Defines the maximum size of a CSS translation transform. The default
	  		// value should not be changed unless a web browser positions layers in
	  		// the wrong place after doing a large `panBy`.
	  		transform3DLimit: 8388608, // Precision limit of a 32-bit float
	
	  		// @section Interaction Options
	  		// @option zoomSnap: Number = 1
	  		// Forces the map's zoom level to always be a multiple of this, particularly
	  		// right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
	  		// By default, the zoom level snaps to the nearest integer; lower values
	  		// (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
	  		// means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
	  		zoomSnap: 1,
	
	  		// @option zoomDelta: Number = 1
	  		// Controls how much the map's zoom level will change after a
	  		// [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
	  		// or `-` on the keyboard, or using the [zoom controls](#control-zoom).
	  		// Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
	  		zoomDelta: 1,
	
	  		// @option trackResize: Boolean = true
	  		// Whether the map automatically handles browser window resize to update itself.
	  		trackResize: true
	  	},
	
	  	initialize: function (id, options) { // (HTMLElement or String, Object)
	  		options = setOptions(this, options);
	
	  		// Make sure to assign internal flags at the beginning,
	  		// to avoid inconsistent state in some edge cases.
	  		this._handlers = [];
	  		this._layers = {};
	  		this._zoomBoundLayers = {};
	  		this._sizeChanged = true;
	
	  		this._initContainer(id);
	  		this._initLayout();
	
	  		// hack for https://github.com/Leaflet/Leaflet/issues/1980
	  		this._onResize = bind(this._onResize, this);
	
	  		this._initEvents();
	
	  		if (options.maxBounds) {
	  			this.setMaxBounds(options.maxBounds);
	  		}
	
	  		if (options.zoom !== undefined) {
	  			this._zoom = this._limitZoom(options.zoom);
	  		}
	
	  		if (options.center && options.zoom !== undefined) {
	  			this.setView(toLatLng(options.center), options.zoom, {reset: true});
	  		}
	
	  		this.callInitHooks();
	
	  		// don't animate on browsers without hardware-accelerated transitions or old Android/Opera
	  		this._zoomAnimated = TRANSITION && any3d && !mobileOpera &&
	  				this.options.zoomAnimation;
	
	  		// zoom transitions run with the same duration for all layers, so if one of transitionend events
	  		// happens after starting zoom animation (propagating to the map pane), we know that it ended globally
	  		if (this._zoomAnimated) {
	  			this._createAnimProxy();
	  			on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
	  		}
	
	  		this._addLayers(this.options.layers);
	  	},
	
	
	  	// @section Methods for modifying map state
	
	  	// @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
	  	// Sets the view of the map (geographical center and zoom) with the given
	  	// animation options.
	  	setView: function (center, zoom, options) {
	
	  		zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
	  		center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
	  		options = options || {};
	
	  		this._stop();
	
	  		if (this._loaded && !options.reset && options !== true) {
	
	  			if (options.animate !== undefined) {
	  				options.zoom = extend({animate: options.animate}, options.zoom);
	  				options.pan = extend({animate: options.animate, duration: options.duration}, options.pan);
	  			}
	
	  			// try animating pan or zoom
	  			var moved = (this._zoom !== zoom) ?
	  				this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) :
	  				this._tryAnimatedPan(center, options.pan);
	
	  			if (moved) {
	  				// prevent resize handler call, the view will refresh after animation anyway
	  				clearTimeout(this._sizeTimer);
	  				return this;
	  			}
	  		}
	
	  		// animation didn't start, just reset the map view
	  		this._resetView(center, zoom);
	
	  		return this;
	  	},
	
	  	// @method setZoom(zoom: Number, options?: Zoom/pan options): this
	  	// Sets the zoom of the map.
	  	setZoom: function (zoom, options) {
	  		if (!this._loaded) {
	  			this._zoom = zoom;
	  			return this;
	  		}
	  		return this.setView(this.getCenter(), zoom, {zoom: options});
	  	},
	
	  	// @method zoomIn(delta?: Number, options?: Zoom options): this
	  	// Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
	  	zoomIn: function (delta, options) {
	  		delta = delta || (any3d ? this.options.zoomDelta : 1);
	  		return this.setZoom(this._zoom + delta, options);
	  	},
	
	  	// @method zoomOut(delta?: Number, options?: Zoom options): this
	  	// Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
	  	zoomOut: function (delta, options) {
	  		delta = delta || (any3d ? this.options.zoomDelta : 1);
	  		return this.setZoom(this._zoom - delta, options);
	  	},
	
	  	// @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
	  	// Zooms the map while keeping a specified geographical point on the map
	  	// stationary (e.g. used internally for scroll zoom and double-click zoom).
	  	// @alternative
	  	// @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
	  	// Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
	  	setZoomAround: function (latlng, zoom, options) {
	  		var scale = this.getZoomScale(zoom),
	  		    viewHalf = this.getSize().divideBy(2),
	  		    containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng),
	
	  		    centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale),
	  		    newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
	
	  		return this.setView(newCenter, zoom, {zoom: options});
	  	},
	
	  	_getBoundsCenterZoom: function (bounds, options) {
	
	  		options = options || {};
	  		bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
	
	  		var paddingTL = toPoint(options.paddingTopLeft || options.padding || [0, 0]),
	  		    paddingBR = toPoint(options.paddingBottomRight || options.padding || [0, 0]),
	
	  		    zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
	
	  		zoom = (typeof options.maxZoom === 'number') ? Math.min(options.maxZoom, zoom) : zoom;
	
	  		if (zoom === Infinity) {
	  			return {
	  				center: bounds.getCenter(),
	  				zoom: zoom
	  			};
	  		}
	
	  		var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2),
	
	  		    swPoint = this.project(bounds.getSouthWest(), zoom),
	  		    nePoint = this.project(bounds.getNorthEast(), zoom),
	  		    center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
	
	  		return {
	  			center: center,
	  			zoom: zoom
	  		};
	  	},
	
	  	// @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
	  	// Sets a map view that contains the given geographical bounds with the
	  	// maximum zoom level possible.
	  	fitBounds: function (bounds, options) {
	
	  		bounds = toLatLngBounds(bounds);
	
	  		if (!bounds.isValid()) {
	  			throw new Error('Bounds are not valid.');
	  		}
	
	  		var target = this._getBoundsCenterZoom(bounds, options);
	  		return this.setView(target.center, target.zoom, options);
	  	},
	
	  	// @method fitWorld(options?: fitBounds options): this
	  	// Sets a map view that mostly contains the whole world with the maximum
	  	// zoom level possible.
	  	fitWorld: function (options) {
	  		return this.fitBounds([[-90, -180], [90, 180]], options);
	  	},
	
	  	// @method panTo(latlng: LatLng, options?: Pan options): this
	  	// Pans the map to a given center.
	  	panTo: function (center, options) { // (LatLng)
	  		return this.setView(center, this._zoom, {pan: options});
	  	},
	
	  	// @method panBy(offset: Point, options?: Pan options): this
	  	// Pans the map by a given number of pixels (animated).
	  	panBy: function (offset, options) {
	  		offset = toPoint(offset).round();
	  		options = options || {};
	
	  		if (!offset.x && !offset.y) {
	  			return this.fire('moveend');
	  		}
	  		// If we pan too far, Chrome gets issues with tiles
	  		// and makes them disappear or appear in the wrong place (slightly offset) #2602
	  		if (options.animate !== true && !this.getSize().contains(offset)) {
	  			this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
	  			return this;
	  		}
	
	  		if (!this._panAnim) {
	  			this._panAnim = new PosAnimation();
	
	  			this._panAnim.on({
	  				'step': this._onPanTransitionStep,
	  				'end': this._onPanTransitionEnd
	  			}, this);
	  		}
	
	  		// don't fire movestart if animating inertia
	  		if (!options.noMoveStart) {
	  			this.fire('movestart');
	  		}
	
	  		// animate pan unless animate: false specified
	  		if (options.animate !== false) {
	  			addClass(this._mapPane, 'leaflet-pan-anim');
	
	  			var newPos = this._getMapPanePos().subtract(offset).round();
	  			this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
	  		} else {
	  			this._rawPanBy(offset);
	  			this.fire('move').fire('moveend');
	  		}
	
	  		return this;
	  	},
	
	  	// @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
	  	// Sets the view of the map (geographical center and zoom) performing a smooth
	  	// pan-zoom animation.
	  	flyTo: function (targetCenter, targetZoom, options) {
	
	  		options = options || {};
	  		if (options.animate === false || !any3d) {
	  			return this.setView(targetCenter, targetZoom, options);
	  		}
	
	  		this._stop();
	
	  		var from = this.project(this.getCenter()),
	  		    to = this.project(targetCenter),
	  		    size = this.getSize(),
	  		    startZoom = this._zoom;
	
	  		targetCenter = toLatLng(targetCenter);
	  		targetZoom = targetZoom === undefined ? startZoom : targetZoom;
	
	  		var w0 = Math.max(size.x, size.y),
	  		    w1 = w0 * this.getZoomScale(startZoom, targetZoom),
	  		    u1 = (to.distanceTo(from)) || 1,
	  		    rho = 1.42,
	  		    rho2 = rho * rho;
	
	  		function r(i) {
	  			var s1 = i ? -1 : 1,
	  			    s2 = i ? w1 : w0,
	  			    t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1,
	  			    b1 = 2 * s2 * rho2 * u1,
	  			    b = t1 / b1,
	  			    sq = Math.sqrt(b * b + 1) - b;
	
	  			    // workaround for floating point precision bug when sq = 0, log = -Infinite,
	  			    // thus triggering an infinite loop in flyTo
	  			    var log = sq < 0.000000001 ? -18 : Math.log(sq);
	
	  			return log;
	  		}
	
	  		function sinh(n) { return (Math.exp(n) - Math.exp(-n)) / 2; }
	  		function cosh(n) { return (Math.exp(n) + Math.exp(-n)) / 2; }
	  		function tanh(n) { return sinh(n) / cosh(n); }
	
	  		var r0 = r(0);
	
	  		function w(s) { return w0 * (cosh(r0) / cosh(r0 + rho * s)); }
	  		function u(s) { return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2; }
	
	  		function easeOut(t) { return 1 - Math.pow(1 - t, 1.5); }
	
	  		var start = Date.now(),
	  		    S = (r(1) - r0) / rho,
	  		    duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
	
	  		function frame() {
	  			var t = (Date.now() - start) / duration,
	  			    s = easeOut(t) * S;
	
	  			if (t <= 1) {
	  				this._flyToFrame = requestAnimFrame(frame, this);
	
	  				this._move(
	  					this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom),
	  					this.getScaleZoom(w0 / w(s), startZoom),
	  					{flyTo: true});
	
	  			} else {
	  				this
	  					._move(targetCenter, targetZoom)
	  					._moveEnd(true);
	  			}
	  		}
	
	  		this._moveStart(true, options.noMoveStart);
	
	  		frame.call(this);
	  		return this;
	  	},
	
	  	// @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
	  	// Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
	  	// but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
	  	flyToBounds: function (bounds, options) {
	  		var target = this._getBoundsCenterZoom(bounds, options);
	  		return this.flyTo(target.center, target.zoom, options);
	  	},
	
	  	// @method setMaxBounds(bounds: LatLngBounds): this
	  	// Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
	  	setMaxBounds: function (bounds) {
	  		bounds = toLatLngBounds(bounds);
	
	  		if (!bounds.isValid()) {
	  			this.options.maxBounds = null;
	  			return this.off('moveend', this._panInsideMaxBounds);
	  		} else if (this.options.maxBounds) {
	  			this.off('moveend', this._panInsideMaxBounds);
	  		}
	
	  		this.options.maxBounds = bounds;
	
	  		if (this._loaded) {
	  			this._panInsideMaxBounds();
	  		}
	
	  		return this.on('moveend', this._panInsideMaxBounds);
	  	},
	
	  	// @method setMinZoom(zoom: Number): this
	  	// Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
	  	setMinZoom: function (zoom) {
	  		var oldZoom = this.options.minZoom;
	  		this.options.minZoom = zoom;
	
	  		if (this._loaded && oldZoom !== zoom) {
	  			this.fire('zoomlevelschange');
	
	  			if (this.getZoom() < this.options.minZoom) {
	  				return this.setZoom(zoom);
	  			}
	  		}
	
	  		return this;
	  	},
	
	  	// @method setMaxZoom(zoom: Number): this
	  	// Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
	  	setMaxZoom: function (zoom) {
	  		var oldZoom = this.options.maxZoom;
	  		this.options.maxZoom = zoom;
	
	  		if (this._loaded && oldZoom !== zoom) {
	  			this.fire('zoomlevelschange');
	
	  			if (this.getZoom() > this.options.maxZoom) {
	  				return this.setZoom(zoom);
	  			}
	  		}
	
	  		return this;
	  	},
	
	  	// @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
	  	// Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
	  	panInsideBounds: function (bounds, options) {
	  		this._enforcingBounds = true;
	  		var center = this.getCenter(),
	  		    newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
	
	  		if (!center.equals(newCenter)) {
	  			this.panTo(newCenter, options);
	  		}
	
	  		this._enforcingBounds = false;
	  		return this;
	  	},
	
	  	// @method panInside(latlng: LatLng, options?: options): this
	  	// Pans the map the minimum amount to make the `latlng` visible. Use
	  	// `padding`, `paddingTopLeft` and `paddingTopRight` options to fit
	  	// the display to more restricted bounds, like [`fitBounds`](#map-fitbounds).
	  	// If `latlng` is already within the (optionally padded) display bounds,
	  	// the map will not be panned.
	  	panInside: function (latlng, options) {
	  		options = options || {};
	
	  		var paddingTL = toPoint(options.paddingTopLeft || options.padding || [0, 0]),
	  		    paddingBR = toPoint(options.paddingBottomRight || options.padding || [0, 0]),
	  		    center = this.getCenter(),
	  		    pixelCenter = this.project(center),
	  		    pixelPoint = this.project(latlng),
	  		    pixelBounds = this.getPixelBounds(),
	  		    halfPixelBounds = pixelBounds.getSize().divideBy(2),
	  		    paddedBounds = toBounds([pixelBounds.min.add(paddingTL), pixelBounds.max.subtract(paddingBR)]);
	
	  		if (!paddedBounds.contains(pixelPoint)) {
	  			this._enforcingBounds = true;
	  			var diff = pixelCenter.subtract(pixelPoint),
	  			    newCenter = toPoint(pixelPoint.x + diff.x, pixelPoint.y + diff.y);
	
	  			if (pixelPoint.x < paddedBounds.min.x || pixelPoint.x > paddedBounds.max.x) {
	  				newCenter.x = pixelCenter.x - diff.x;
	  				if (diff.x > 0) {
	  					newCenter.x += halfPixelBounds.x - paddingTL.x;
	  				} else {
	  					newCenter.x -= halfPixelBounds.x - paddingBR.x;
	  				}
	  			}
	  			if (pixelPoint.y < paddedBounds.min.y || pixelPoint.y > paddedBounds.max.y) {
	  				newCenter.y = pixelCenter.y - diff.y;
	  				if (diff.y > 0) {
	  					newCenter.y += halfPixelBounds.y - paddingTL.y;
	  				} else {
	  					newCenter.y -= halfPixelBounds.y - paddingBR.y;
	  				}
	  			}
	  			this.panTo(this.unproject(newCenter), options);
	  			this._enforcingBounds = false;
	  		}
	  		return this;
	  	},
	
	  	// @method invalidateSize(options: Zoom/pan options): this
	  	// Checks if the map container size changed and updates the map if so —
	  	// call it after you've changed the map size dynamically, also animating
	  	// pan by default. If `options.pan` is `false`, panning will not occur.
	  	// If `options.debounceMoveend` is `true`, it will delay `moveend` event so
	  	// that it doesn't happen often even if the method is called many
	  	// times in a row.
	
	  	// @alternative
	  	// @method invalidateSize(animate: Boolean): this
	  	// Checks if the map container size changed and updates the map if so —
	  	// call it after you've changed the map size dynamically, also animating
	  	// pan by default.
	  	invalidateSize: function (options) {
	  		if (!this._loaded) { return this; }
	
	  		options = extend({
	  			animate: false,
	  			pan: true
	  		}, options === true ? {animate: true} : options);
	
	  		var oldSize = this.getSize();
	  		this._sizeChanged = true;
	  		this._lastCenter = null;
	
	  		var newSize = this.getSize(),
	  		    oldCenter = oldSize.divideBy(2).round(),
	  		    newCenter = newSize.divideBy(2).round(),
	  		    offset = oldCenter.subtract(newCenter);
	
	  		if (!offset.x && !offset.y) { return this; }
	
	  		if (options.animate && options.pan) {
	  			this.panBy(offset);
	
	  		} else {
	  			if (options.pan) {
	  				this._rawPanBy(offset);
	  			}
	
	  			this.fire('move');
	
	  			if (options.debounceMoveend) {
	  				clearTimeout(this._sizeTimer);
	  				this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
	  			} else {
	  				this.fire('moveend');
	  			}
	  		}
	
	  		// @section Map state change events
	  		// @event resize: ResizeEvent
	  		// Fired when the map is resized.
	  		return this.fire('resize', {
	  			oldSize: oldSize,
	  			newSize: newSize
	  		});
	  	},
	
	  	// @section Methods for modifying map state
	  	// @method stop(): this
	  	// Stops the currently running `panTo` or `flyTo` animation, if any.
	  	stop: function () {
	  		this.setZoom(this._limitZoom(this._zoom));
	  		if (!this.options.zoomSnap) {
	  			this.fire('viewreset');
	  		}
	  		return this._stop();
	  	},
	
	  	// @section Geolocation methods
	  	// @method locate(options?: Locate options): this
	  	// Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
	  	// event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
	  	// and optionally sets the map view to the user's location with respect to
	  	// detection accuracy (or to the world view if geolocation failed).
	  	// Note that, if your page doesn't use HTTPS, this method will fail in
	  	// modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
	  	// See `Locate options` for more details.
	  	locate: function (options) {
	
	  		options = this._locateOptions = extend({
	  			timeout: 10000,
	  			watch: false
	  			// setView: false
	  			// maxZoom: <Number>
	  			// maximumAge: 0
	  			// enableHighAccuracy: false
	  		}, options);
	
	  		if (!('geolocation' in navigator)) {
	  			this._handleGeolocationError({
	  				code: 0,
	  				message: 'Geolocation not supported.'
	  			});
	  			return this;
	  		}
	
	  		var onResponse = bind(this._handleGeolocationResponse, this),
	  		    onError = bind(this._handleGeolocationError, this);
	
	  		if (options.watch) {
	  			this._locationWatchId =
	  			        navigator.geolocation.watchPosition(onResponse, onError, options);
	  		} else {
	  			navigator.geolocation.getCurrentPosition(onResponse, onError, options);
	  		}
	  		return this;
	  	},
	
	  	// @method stopLocate(): this
	  	// Stops watching location previously initiated by `map.locate({watch: true})`
	  	// and aborts resetting the map view if map.locate was called with
	  	// `{setView: true}`.
	  	stopLocate: function () {
	  		if (navigator.geolocation && navigator.geolocation.clearWatch) {
	  			navigator.geolocation.clearWatch(this._locationWatchId);
	  		}
	  		if (this._locateOptions) {
	  			this._locateOptions.setView = false;
	  		}
	  		return this;
	  	},
	
	  	_handleGeolocationError: function (error) {
	  		var c = error.code,
	  		    message = error.message ||
	  		            (c === 1 ? 'permission denied' :
	  		            (c === 2 ? 'position unavailable' : 'timeout'));
	
	  		if (this._locateOptions.setView && !this._loaded) {
	  			this.fitWorld();
	  		}
	
	  		// @section Location events
	  		// @event locationerror: ErrorEvent
	  		// Fired when geolocation (using the [`locate`](#map-locate) method) failed.
	  		this.fire('locationerror', {
	  			code: c,
	  			message: 'Geolocation error: ' + message + '.'
	  		});
	  	},
	
	  	_handleGeolocationResponse: function (pos) {
	  		var lat = pos.coords.latitude,
	  		    lng = pos.coords.longitude,
	  		    latlng = new LatLng(lat, lng),
	  		    bounds = latlng.toBounds(pos.coords.accuracy * 2),
	  		    options = this._locateOptions;
	
	  		if (options.setView) {
	  			var zoom = this.getBoundsZoom(bounds);
	  			this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
	  		}
	
	  		var data = {
	  			latlng: latlng,
	  			bounds: bounds,
	  			timestamp: pos.timestamp
	  		};
	
	  		for (var i in pos.coords) {
	  			if (typeof pos.coords[i] === 'number') {
	  				data[i] = pos.coords[i];
	  			}
	  		}
	
	  		// @event locationfound: LocationEvent
	  		// Fired when geolocation (using the [`locate`](#map-locate) method)
	  		// went successfully.
	  		this.fire('locationfound', data);
	  	},
	
	  	// TODO Appropriate docs section?
	  	// @section Other Methods
	  	// @method addHandler(name: String, HandlerClass: Function): this
	  	// Adds a new `Handler` to the map, given its name and constructor function.
	  	addHandler: function (name, HandlerClass) {
	  		if (!HandlerClass) { return this; }
	
	  		var handler = this[name] = new HandlerClass(this);
	
	  		this._handlers.push(handler);
	
	  		if (this.options[name]) {
	  			handler.enable();
	  		}
	
	  		return this;
	  	},
	
	  	// @method remove(): this
	  	// Destroys the map and clears all related event listeners.
	  	remove: function () {
	
	  		this._initEvents(true);
	  		this.off('moveend', this._panInsideMaxBounds);
	
	  		if (this._containerId !== this._container._leaflet_id) {
	  			throw new Error('Map container is being reused by another instance');
	  		}
	
	  		try {
	  			// throws error in IE6-8
	  			delete this._container._leaflet_id;
	  			delete this._containerId;
	  		} catch (e) {
	  			/*eslint-disable */
	  			this._container._leaflet_id = undefined;
	  			/* eslint-enable */
	  			this._containerId = undefined;
	  		}
	
	  		if (this._locationWatchId !== undefined) {
	  			this.stopLocate();
	  		}
	
	  		this._stop();
	
	  		remove(this._mapPane);
	
	  		if (this._clearControlPos) {
	  			this._clearControlPos();
	  		}
	  		if (this._resizeRequest) {
	  			cancelAnimFrame(this._resizeRequest);
	  			this._resizeRequest = null;
	  		}
	
	  		this._clearHandlers();
	
	  		if (this._loaded) {
	  			// @section Map state change events
	  			// @event unload: Event
	  			// Fired when the map is destroyed with [remove](#map-remove) method.
	  			this.fire('unload');
	  		}
	
	  		var i;
	  		for (i in this._layers) {
	  			this._layers[i].remove();
	  		}
	  		for (i in this._panes) {
	  			remove(this._panes[i]);
	  		}
	
	  		this._layers = [];
	  		this._panes = [];
	  		delete this._mapPane;
	  		delete this._renderer;
	
	  		return this;
	  	},
	
	  	// @section Other Methods
	  	// @method createPane(name: String, container?: HTMLElement): HTMLElement
	  	// Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
	  	// then returns it. The pane is created as a child of `container`, or
	  	// as a child of the main map pane if not set.
	  	createPane: function (name, container) {
	  		var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''),
	  		    pane = create$1('div', className, container || this._mapPane);
	
	  		if (name) {
	  			this._panes[name] = pane;
	  		}
	  		return pane;
	  	},
	
	  	// @section Methods for Getting Map State
	
	  	// @method getCenter(): LatLng
	  	// Returns the geographical center of the map view
	  	getCenter: function () {
	  		this._checkIfLoaded();
	
	  		if (this._lastCenter && !this._moved()) {
	  			return this._lastCenter;
	  		}
	  		return this.layerPointToLatLng(this._getCenterLayerPoint());
	  	},
	
	  	// @method getZoom(): Number
	  	// Returns the current zoom level of the map view
	  	getZoom: function () {
	  		return this._zoom;
	  	},
	
	  	// @method getBounds(): LatLngBounds
	  	// Returns the geographical bounds visible in the current map view
	  	getBounds: function () {
	  		var bounds = this.getPixelBounds(),
	  		    sw = this.unproject(bounds.getBottomLeft()),
	  		    ne = this.unproject(bounds.getTopRight());
	
	  		return new LatLngBounds(sw, ne);
	  	},
	
	  	// @method getMinZoom(): Number
	  	// Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
	  	getMinZoom: function () {
	  		return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
	  	},
	
	  	// @method getMaxZoom(): Number
	  	// Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
	  	getMaxZoom: function () {
	  		return this.options.maxZoom === undefined ?
	  			(this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom) :
	  			this.options.maxZoom;
	  	},
	
	  	// @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
	  	// Returns the maximum zoom level on which the given bounds fit to the map
	  	// view in its entirety. If `inside` (optional) is set to `true`, the method
	  	// instead returns the minimum zoom level on which the map view fits into
	  	// the given bounds in its entirety.
	  	getBoundsZoom: function (bounds, inside, padding) { // (LatLngBounds[, Boolean, Point]) -> Number
	  		bounds = toLatLngBounds(bounds);
	  		padding = toPoint(padding || [0, 0]);
	
	  		var zoom = this.getZoom() || 0,
	  		    min = this.getMinZoom(),
	  		    max = this.getMaxZoom(),
	  		    nw = bounds.getNorthWest(),
	  		    se = bounds.getSouthEast(),
	  		    size = this.getSize().subtract(padding),
	  		    boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(),
	  		    snap = any3d ? this.options.zoomSnap : 1,
	  		    scalex = size.x / boundsSize.x,
	  		    scaley = size.y / boundsSize.y,
	  		    scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
	
	  		zoom = this.getScaleZoom(scale, zoom);
	
	  		if (snap) {
	  			zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
	  			zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
	  		}
	
	  		return Math.max(min, Math.min(max, zoom));
	  	},
	
	  	// @method getSize(): Point
	  	// Returns the current size of the map container (in pixels).
	  	getSize: function () {
	  		if (!this._size || this._sizeChanged) {
	  			this._size = new Point(
	  				this._container.clientWidth || 0,
	  				this._container.clientHeight || 0);
	
	  			this._sizeChanged = false;
	  		}
	  		return this._size.clone();
	  	},
	
	  	// @method getPixelBounds(): Bounds
	  	// Returns the bounds of the current map view in projected pixel
	  	// coordinates (sometimes useful in layer and overlay implementations).
	  	getPixelBounds: function (center, zoom) {
	  		var topLeftPoint = this._getTopLeftPoint(center, zoom);
	  		return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
	  	},
	
	  	// TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
	  	// the map pane? "left point of the map layer" can be confusing, specially
	  	// since there can be negative offsets.
	  	// @method getPixelOrigin(): Point
	  	// Returns the projected pixel coordinates of the top left point of
	  	// the map layer (useful in custom layer and overlay implementations).
	  	getPixelOrigin: function () {
	  		this._checkIfLoaded();
	  		return this._pixelOrigin;
	  	},
	
	  	// @method getPixelWorldBounds(zoom?: Number): Bounds
	  	// Returns the world's bounds in pixel coordinates for zoom level `zoom`.
	  	// If `zoom` is omitted, the map's current zoom level is used.
	  	getPixelWorldBounds: function (zoom) {
	  		return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
	  	},
	
	  	// @section Other Methods
	
	  	// @method getPane(pane: String|HTMLElement): HTMLElement
	  	// Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
	  	getPane: function (pane) {
	  		return typeof pane === 'string' ? this._panes[pane] : pane;
	  	},
	
	  	// @method getPanes(): Object
	  	// Returns a plain object containing the names of all [panes](#map-pane) as keys and
	  	// the panes as values.
	  	getPanes: function () {
	  		return this._panes;
	  	},
	
	  	// @method getContainer: HTMLElement
	  	// Returns the HTML element that contains the map.
	  	getContainer: function () {
	  		return this._container;
	  	},
	
	
	  	// @section Conversion Methods
	
	  	// @method getZoomScale(toZoom: Number, fromZoom: Number): Number
	  	// Returns the scale factor to be applied to a map transition from zoom level
	  	// `fromZoom` to `toZoom`. Used internally to help with zoom animations.
	  	getZoomScale: function (toZoom, fromZoom) {
	  		// TODO replace with universal implementation after refactoring projections
	  		var crs = this.options.crs;
	  		fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
	  		return crs.scale(toZoom) / crs.scale(fromZoom);
	  	},
	
	  	// @method getScaleZoom(scale: Number, fromZoom: Number): Number
	  	// Returns the zoom level that the map would end up at, if it is at `fromZoom`
	  	// level and everything is scaled by a factor of `scale`. Inverse of
	  	// [`getZoomScale`](#map-getZoomScale).
	  	getScaleZoom: function (scale, fromZoom) {
	  		var crs = this.options.crs;
	  		fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
	  		var zoom = crs.zoom(scale * crs.scale(fromZoom));
	  		return isNaN(zoom) ? Infinity : zoom;
	  	},
	
	  	// @method project(latlng: LatLng, zoom: Number): Point
	  	// Projects a geographical coordinate `LatLng` according to the projection
	  	// of the map's CRS, then scales it according to `zoom` and the CRS's
	  	// `Transformation`. The result is pixel coordinate relative to
	  	// the CRS origin.
	  	project: function (latlng, zoom) {
	  		zoom = zoom === undefined ? this._zoom : zoom;
	  		return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
	  	},
	
	  	// @method unproject(point: Point, zoom: Number): LatLng
	  	// Inverse of [`project`](#map-project).
	  	unproject: function (point, zoom) {
	  		zoom = zoom === undefined ? this._zoom : zoom;
	  		return this.options.crs.pointToLatLng(toPoint(point), zoom);
	  	},
	
	  	// @method layerPointToLatLng(point: Point): LatLng
	  	// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
	  	// returns the corresponding geographical coordinate (for the current zoom level).
	  	layerPointToLatLng: function (point) {
	  		var projectedPoint = toPoint(point).add(this.getPixelOrigin());
	  		return this.unproject(projectedPoint);
	  	},
	
	  	// @method latLngToLayerPoint(latlng: LatLng): Point
	  	// Given a geographical coordinate, returns the corresponding pixel coordinate
	  	// relative to the [origin pixel](#map-getpixelorigin).
	  	latLngToLayerPoint: function (latlng) {
	  		var projectedPoint = this.project(toLatLng(latlng))._round();
	  		return projectedPoint._subtract(this.getPixelOrigin());
	  	},
	
	  	// @method wrapLatLng(latlng: LatLng): LatLng
	  	// Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
	  	// map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
	  	// CRS's bounds.
	  	// By default this means longitude is wrapped around the dateline so its
	  	// value is between -180 and +180 degrees.
	  	wrapLatLng: function (latlng) {
	  		return this.options.crs.wrapLatLng(toLatLng(latlng));
	  	},
	
	  	// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
	  	// Returns a `LatLngBounds` with the same size as the given one, ensuring that
	  	// its center is within the CRS's bounds.
	  	// By default this means the center longitude is wrapped around the dateline so its
	  	// value is between -180 and +180 degrees, and the majority of the bounds
	  	// overlaps the CRS's bounds.
	  	wrapLatLngBounds: function (latlng) {
	  		return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
	  	},
	
	  	// @method distance(latlng1: LatLng, latlng2: LatLng): Number
	  	// Returns the distance between two geographical coordinates according to
	  	// the map's CRS. By default this measures distance in meters.
	  	distance: function (latlng1, latlng2) {
	  		return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
	  	},
	
	  	// @method containerPointToLayerPoint(point: Point): Point
	  	// Given a pixel coordinate relative to the map container, returns the corresponding
	  	// pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
	  	containerPointToLayerPoint: function (point) { // (Point)
	  		return toPoint(point).subtract(this._getMapPanePos());
	  	},
	
	  	// @method layerPointToContainerPoint(point: Point): Point
	  	// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
	  	// returns the corresponding pixel coordinate relative to the map container.
	  	layerPointToContainerPoint: function (point) { // (Point)
	  		return toPoint(point).add(this._getMapPanePos());
	  	},
	
	  	// @method containerPointToLatLng(point: Point): LatLng
	  	// Given a pixel coordinate relative to the map container, returns
	  	// the corresponding geographical coordinate (for the current zoom level).
	  	containerPointToLatLng: function (point) {
	  		var layerPoint = this.containerPointToLayerPoint(toPoint(point));
	  		return this.layerPointToLatLng(layerPoint);
	  	},
	
	  	// @method latLngToContainerPoint(latlng: LatLng): Point
	  	// Given a geographical coordinate, returns the corresponding pixel coordinate
	  	// relative to the map container.
	  	latLngToContainerPoint: function (latlng) {
	  		return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
	  	},
	
	  	// @method mouseEventToContainerPoint(ev: MouseEvent): Point
	  	// Given a MouseEvent object, returns the pixel coordinate relative to the
	  	// map container where the event took place.
	  	mouseEventToContainerPoint: function (e) {
	  		return getMousePosition(e, this._container);
	  	},
	
	  	// @method mouseEventToLayerPoint(ev: MouseEvent): Point
	  	// Given a MouseEvent object, returns the pixel coordinate relative to
	  	// the [origin pixel](#map-getpixelorigin) where the event took place.
	  	mouseEventToLayerPoint: function (e) {
	  		return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
	  	},
	
	  	// @method mouseEventToLatLng(ev: MouseEvent): LatLng
	  	// Given a MouseEvent object, returns geographical coordinate where the
	  	// event took place.
	  	mouseEventToLatLng: function (e) { // (MouseEvent)
	  		return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
	  	},
	
	
	  	// map initialization methods
	
	  	_initContainer: function (id) {
	  		var container = this._container = get(id);
	
	  		if (!container) {
	  			throw new Error('Map container not found.');
	  		} else if (container._leaflet_id) {
	  			throw new Error('Map container is already initialized.');
	  		}
	
	  		on(container, 'scroll', this._onScroll, this);
	  		this._containerId = stamp(container);
	  	},
	
	  	_initLayout: function () {
	  		var container = this._container;
	
	  		this._fadeAnimated = this.options.fadeAnimation && any3d;
	
	  		addClass(container, 'leaflet-container' +
	  			(touch ? ' leaflet-touch' : '') +
	  			(retina ? ' leaflet-retina' : '') +
	  			(ielt9 ? ' leaflet-oldie' : '') +
	  			(safari ? ' leaflet-safari' : '') +
	  			(this._fadeAnimated ? ' leaflet-fade-anim' : ''));
	
	  		var position = getStyle(container, 'position');
	
	  		if (position !== 'absolute' && position !== 'relative' && position !== 'fixed') {
	  			container.style.position = 'relative';
	  		}
	
	  		this._initPanes();
	
	  		if (this._initControlPos) {
	  			this._initControlPos();
	  		}
	  	},
	
	  	_initPanes: function () {
	  		var panes = this._panes = {};
	  		this._paneRenderers = {};
	
	  		// @section
	  		//
	  		// Panes are DOM elements used to control the ordering of layers on the map. You
	  		// can access panes with [`map.getPane`](#map-getpane) or
	  		// [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
	  		// [`map.createPane`](#map-createpane) method.
	  		//
	  		// Every map has the following default panes that differ only in zIndex.
	  		//
	  		// @pane mapPane: HTMLElement = 'auto'
	  		// Pane that contains all other map panes
	
	  		this._mapPane = this.createPane('mapPane', this._container);
	  		setPosition(this._mapPane, new Point(0, 0));
	
	  		// @pane tilePane: HTMLElement = 200
	  		// Pane for `GridLayer`s and `TileLayer`s
	  		this.createPane('tilePane');
	  		// @pane overlayPane: HTMLElement = 400
	  		// Pane for overlay shadows (e.g. `Marker` shadows)
	  		this.createPane('shadowPane');
	  		// @pane shadowPane: HTMLElement = 500
	  		// Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
	  		this.createPane('overlayPane');
	  		// @pane markerPane: HTMLElement = 600
	  		// Pane for `Icon`s of `Marker`s
	  		this.createPane('markerPane');
	  		// @pane tooltipPane: HTMLElement = 650
	  		// Pane for `Tooltip`s.
	  		this.createPane('tooltipPane');
	  		// @pane popupPane: HTMLElement = 700
	  		// Pane for `Popup`s.
	  		this.createPane('popupPane');
	
	  		if (!this.options.markerZoomAnimation) {
	  			addClass(panes.markerPane, 'leaflet-zoom-hide');
	  			addClass(panes.shadowPane, 'leaflet-zoom-hide');
	  		}
	  	},
	
	
	  	// private methods that modify map state
	
	  	// @section Map state change events
	  	_resetView: function (center, zoom) {
	  		setPosition(this._mapPane, new Point(0, 0));
	
	  		var loading = !this._loaded;
	  		this._loaded = true;
	  		zoom = this._limitZoom(zoom);
	
	  		this.fire('viewprereset');
	
	  		var zoomChanged = this._zoom !== zoom;
	  		this
	  			._moveStart(zoomChanged, false)
	  			._move(center, zoom)
	  			._moveEnd(zoomChanged);
	
	  		// @event viewreset: Event
	  		// Fired when the map needs to redraw its content (this usually happens
	  		// on map zoom or load). Very useful for creating custom overlays.
	  		this.fire('viewreset');
	
	  		// @event load: Event
	  		// Fired when the map is initialized (when its center and zoom are set
	  		// for the first time).
	  		if (loading) {
	  			this.fire('load');
	  		}
	  	},
	
	  	_moveStart: function (zoomChanged, noMoveStart) {
	  		// @event zoomstart: Event
	  		// Fired when the map zoom is about to change (e.g. before zoom animation).
	  		// @event movestart: Event
	  		// Fired when the view of the map starts changing (e.g. user starts dragging the map).
	  		if (zoomChanged) {
	  			this.fire('zoomstart');
	  		}
	  		if (!noMoveStart) {
	  			this.fire('movestart');
	  		}
	  		return this;
	  	},
	
	  	_move: function (center, zoom, data) {
	  		if (zoom === undefined) {
	  			zoom = this._zoom;
	  		}
	  		var zoomChanged = this._zoom !== zoom;
	
	  		this._zoom = zoom;
	  		this._lastCenter = center;
	  		this._pixelOrigin = this._getNewPixelOrigin(center);
	
	  		// @event zoom: Event
	  		// Fired repeatedly during any change in zoom level, including zoom
	  		// and fly animations.
	  		if (zoomChanged || (data && data.pinch)) {	// Always fire 'zoom' if pinching because #3530
	  			this.fire('zoom', data);
	  		}
	
	  		// @event move: Event
	  		// Fired repeatedly during any movement of the map, including pan and
	  		// fly animations.
	  		return this.fire('move', data);
	  	},
	
	  	_moveEnd: function (zoomChanged) {
	  		// @event zoomend: Event
	  		// Fired when the map has changed, after any animations.
	  		if (zoomChanged) {
	  			this.fire('zoomend');
	  		}
	
	  		// @event moveend: Event
	  		// Fired when the center of the map stops changing (e.g. user stopped
	  		// dragging the map).
	  		return this.fire('moveend');
	  	},
	
	  	_stop: function () {
	  		cancelAnimFrame(this._flyToFrame);
	  		if (this._panAnim) {
	  			this._panAnim.stop();
	  		}
	  		return this;
	  	},
	
	  	_rawPanBy: function (offset) {
	  		setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
	  	},
	
	  	_getZoomSpan: function () {
	  		return this.getMaxZoom() - this.getMinZoom();
	  	},
	
	  	_panInsideMaxBounds: function () {
	  		if (!this._enforcingBounds) {
	  			this.panInsideBounds(this.options.maxBounds);
	  		}
	  	},
	
	  	_checkIfLoaded: function () {
	  		if (!this._loaded) {
	  			throw new Error('Set map center and zoom first.');
	  		}
	  	},
	
	  	// DOM event handling
	
	  	// @section Interaction events
	  	_initEvents: function (remove$$1) {
	  		this._targets = {};
	  		this._targets[stamp(this._container)] = this;
	
	  		var onOff = remove$$1 ? off : on;
	
	  		// @event click: MouseEvent
	  		// Fired when the user clicks (or taps) the map.
	  		// @event dblclick: MouseEvent
	  		// Fired when the user double-clicks (or double-taps) the map.
	  		// @event mousedown: MouseEvent
	  		// Fired when the user pushes the mouse button on the map.
	  		// @event mouseup: MouseEvent
	  		// Fired when the user releases the mouse button on the map.
	  		// @event mouseover: MouseEvent
	  		// Fired when the mouse enters the map.
	  		// @event mouseout: MouseEvent
	  		// Fired when the mouse leaves the map.
	  		// @event mousemove: MouseEvent
	  		// Fired while the mouse moves over the map.
	  		// @event contextmenu: MouseEvent
	  		// Fired when the user pushes the right mouse button on the map, prevents
	  		// default browser context menu from showing if there are listeners on
	  		// this event. Also fired on mobile when the user holds a single touch
	  		// for a second (also called long press).
	  		// @event keypress: KeyboardEvent
	  		// Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
	  		// @event keydown: KeyboardEvent
	  		// Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
	  		// the `keydown` event is fired for keys that produce a character value and for keys
	  		// that do not produce a character value.
	  		// @event keyup: KeyboardEvent
	  		// Fired when the user releases a key from the keyboard while the map is focused.
	  		onOff(this._container, 'click dblclick mousedown mouseup ' +
	  			'mouseover mouseout mousemove contextmenu keypress keydown keyup', this._handleDOMEvent, this);
	
	  		if (this.options.trackResize) {
	  			onOff(window, 'resize', this._onResize, this);
	  		}
	
	  		if (any3d && this.options.transform3DLimit) {
	  			(remove$$1 ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
	  		}
	  	},
	
	  	_onResize: function () {
	  		cancelAnimFrame(this._resizeRequest);
	  		this._resizeRequest = requestAnimFrame(
	  		        function () { this.invalidateSize({debounceMoveend: true}); }, this);
	  	},
	
	  	_onScroll: function () {
	  		this._container.scrollTop  = 0;
	  		this._container.scrollLeft = 0;
	  	},
	
	  	_onMoveEnd: function () {
	  		var pos = this._getMapPanePos();
	  		if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) {
	  			// https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
	  			// a pixel offset on very high values, see: http://jsfiddle.net/dg6r5hhb/
	  			this._resetView(this.getCenter(), this.getZoom());
	  		}
	  	},
	
	  	_findEventTargets: function (e, type) {
	  		var targets = [],
	  		    target,
	  		    isHover = type === 'mouseout' || type === 'mouseover',
	  		    src = e.target || e.srcElement,
	  		    dragging = false;
	
	  		while (src) {
	  			target = this._targets[stamp(src)];
	  			if (target && (type === 'click' || type === 'preclick') && !e._simulated && this._draggableMoved(target)) {
	  				// Prevent firing click after you just dragged an object.
	  				dragging = true;
	  				break;
	  			}
	  			if (target && target.listens(type, true)) {
	  				if (isHover && !isExternalTarget(src, e)) { break; }
	  				targets.push(target);
	  				if (isHover) { break; }
	  			}
	  			if (src === this._container) { break; }
	  			src = src.parentNode;
	  		}
	  		if (!targets.length && !dragging && !isHover && isExternalTarget(src, e)) {
	  			targets = [this];
	  		}
	  		return targets;
	  	},
	
	  	_handleDOMEvent: function (e) {
	  		if (!this._loaded || skipped(e)) { return; }
	
	  		var type = e.type;
	
	  		if (type === 'mousedown' || type === 'keypress' || type === 'keyup' || type === 'keydown') {
	  			// prevents outline when clicking on keyboard-focusable element
	  			preventOutline(e.target || e.srcElement);
	  		}
	
	  		this._fireDOMEvent(e, type);
	  	},
	
	  	_mouseEvents: ['click', 'dblclick', 'mouseover', 'mouseout', 'contextmenu'],
	
	  	_fireDOMEvent: function (e, type, targets) {
	
	  		if (e.type === 'click') {
	  			// Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
	  			// @event preclick: MouseEvent
	  			// Fired before mouse click on the map (sometimes useful when you
	  			// want something to happen on click before any existing click
	  			// handlers start running).
	  			var synth = extend({}, e);
	  			synth.type = 'preclick';
	  			this._fireDOMEvent(synth, synth.type, targets);
	  		}
	
	  		if (e._stopped) { return; }
	
	  		// Find the layer the event is propagating from and its parents.
	  		targets = (targets || []).concat(this._findEventTargets(e, type));
	
	  		if (!targets.length) { return; }
	
	  		var target = targets[0];
	  		if (type === 'contextmenu' && target.listens(type, true)) {
	  			preventDefault(e);
	  		}
	
	  		var data = {
	  			originalEvent: e
	  		};
	
	  		if (e.type !== 'keypress' && e.type !== 'keydown' && e.type !== 'keyup') {
	  			var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
	  			data.containerPoint = isMarker ?
	  				this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
	  			data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
	  			data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
	  		}
	
	  		for (var i = 0; i < targets.length; i++) {
	  			targets[i].fire(type, data, true);
	  			if (data.originalEvent._stopped ||
	  				(targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1)) { return; }
	  		}
	  	},
	
	  	_draggableMoved: function (obj) {
	  		obj = obj.dragging && obj.dragging.enabled() ? obj : this;
	  		return (obj.dragging && obj.dragging.moved()) || (this.boxZoom && this.boxZoom.moved());
	  	},
	
	  	_clearHandlers: function () {
	  		for (var i = 0, len = this._handlers.length; i < len; i++) {
	  			this._handlers[i].disable();
	  		}
	  	},
	
	  	// @section Other Methods
	
	  	// @method whenReady(fn: Function, context?: Object): this
	  	// Runs the given function `fn` when the map gets initialized with
	  	// a view (center and zoom) and at least one layer, or immediately
	  	// if it's already initialized, optionally passing a function context.
	  	whenReady: function (callback, context) {
	  		if (this._loaded) {
	  			callback.call(context || this, {target: this});
	  		} else {
	  			this.on('load', callback, context);
	  		}
	  		return this;
	  	},
	
	
	  	// private methods for getting map state
	
	  	_getMapPanePos: function () {
	  		return getPosition(this._mapPane) || new Point(0, 0);
	  	},
	
	  	_moved: function () {
	  		var pos = this._getMapPanePos();
	  		return pos && !pos.equals([0, 0]);
	  	},
	
	  	_getTopLeftPoint: function (center, zoom) {
	  		var pixelOrigin = center && zoom !== undefined ?
	  			this._getNewPixelOrigin(center, zoom) :
	  			this.getPixelOrigin();
	  		return pixelOrigin.subtract(this._getMapPanePos());
	  	},
	
	  	_getNewPixelOrigin: function (center, zoom) {
	  		var viewHalf = this.getSize()._divideBy(2);
	  		return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
	  	},
	
	  	_latLngToNewLayerPoint: function (latlng, zoom, center) {
	  		var topLeft = this._getNewPixelOrigin(center, zoom);
	  		return this.project(latlng, zoom)._subtract(topLeft);
	  	},
	
	  	_latLngBoundsToNewLayerBounds: function (latLngBounds, zoom, center) {
	  		var topLeft = this._getNewPixelOrigin(center, zoom);
	  		return toBounds([
	  			this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
	  			this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
	  			this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
	  			this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
	  		]);
	  	},
	
	  	// layer point of the current center
	  	_getCenterLayerPoint: function () {
	  		return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
	  	},
	
	  	// offset of the specified place to the current center in pixels
	  	_getCenterOffset: function (latlng) {
	  		return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
	  	},
	
	  	// adjust center for view to get inside bounds
	  	_limitCenter: function (center, zoom, bounds) {
	
	  		if (!bounds) { return center; }
	
	  		var centerPoint = this.project(center, zoom),
	  		    viewHalf = this.getSize().divideBy(2),
	  		    viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)),
	  		    offset = this._getBoundsOffset(viewBounds, bounds, zoom);
	
	  		// If offset is less than a pixel, ignore.
	  		// This prevents unstable projections from getting into
	  		// an infinite loop of tiny offsets.
	  		if (offset.round().equals([0, 0])) {
	  			return center;
	  		}
	
	  		return this.unproject(centerPoint.add(offset), zoom);
	  	},
	
	  	// adjust offset for view to get inside bounds
	  	_limitOffset: function (offset, bounds) {
	  		if (!bounds) { return offset; }
	
	  		var viewBounds = this.getPixelBounds(),
	  		    newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
	
	  		return offset.add(this._getBoundsOffset(newBounds, bounds));
	  	},
	
	  	// returns offset needed for pxBounds to get inside maxBounds at a specified zoom
	  	_getBoundsOffset: function (pxBounds, maxBounds, zoom) {
	  		var projectedMaxBounds = toBounds(
	  		        this.project(maxBounds.getNorthEast(), zoom),
	  		        this.project(maxBounds.getSouthWest(), zoom)
	  		    ),
	  		    minOffset = projectedMaxBounds.min.subtract(pxBounds.min),
	  		    maxOffset = projectedMaxBounds.max.subtract(pxBounds.max),
	
	  		    dx = this._rebound(minOffset.x, -maxOffset.x),
	  		    dy = this._rebound(minOffset.y, -maxOffset.y);
	
	  		return new Point(dx, dy);
	  	},
	
	  	_rebound: function (left, right) {
	  		return left + right > 0 ?
	  			Math.round(left - right) / 2 :
	  			Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
	  	},
	
	  	_limitZoom: function (zoom) {
	  		var min = this.getMinZoom(),
	  		    max = this.getMaxZoom(),
	  		    snap = any3d ? this.options.zoomSnap : 1;
	  		if (snap) {
	  			zoom = Math.round(zoom / snap) * snap;
	  		}
	  		return Math.max(min, Math.min(max, zoom));
	  	},
	
	  	_onPanTransitionStep: function () {
	  		this.fire('move');
	  	},
	
	  	_onPanTransitionEnd: function () {
	  		removeClass(this._mapPane, 'leaflet-pan-anim');
	  		this.fire('moveend');
	  	},
	
	  	_tryAnimatedPan: function (center, options) {
	  		// difference between the new and current centers in pixels
	  		var offset = this._getCenterOffset(center)._trunc();
	
	  		// don't animate too far unless animate: true specified in options
	  		if ((options && options.animate) !== true && !this.getSize().contains(offset)) { return false; }
	
	  		this.panBy(offset, options);
	
	  		return true;
	  	},
	
	  	_createAnimProxy: function () {
	
	  		var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
	  		this._panes.mapPane.appendChild(proxy);
	
	  		this.on('zoomanim', function (e) {
	  			var prop = TRANSFORM,
	  			    transform = this._proxy.style[prop];
	
	  			setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
	
	  			// workaround for case when transform is the same and so transitionend event is not fired
	  			if (transform === this._proxy.style[prop] && this._animatingZoom) {
	  				this._onZoomTransitionEnd();
	  			}
	  		}, this);
	
	  		this.on('load moveend', this._animMoveEnd, this);
	
	  		this._on('unload', this._destroyAnimProxy, this);
	  	},
	
	  	_destroyAnimProxy: function () {
	  		remove(this._proxy);
	  		this.off('load moveend', this._animMoveEnd, this);
	  		delete this._proxy;
	  	},
	
	  	_animMoveEnd: function () {
	  		var c = this.getCenter(),
	  		    z = this.getZoom();
	  		setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
	  	},
	
	  	_catchTransitionEnd: function (e) {
	  		if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) {
	  			this._onZoomTransitionEnd();
	  		}
	  	},
	
	  	_nothingToAnimate: function () {
	  		return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
	  	},
	
	  	_tryAnimatedZoom: function (center, zoom, options) {
	
	  		if (this._animatingZoom) { return true; }
	
	  		options = options || {};
	
	  		// don't animate if disabled, not supported or zoom difference is too large
	  		if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() ||
	  		        Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) { return false; }
	
	  		// offset is the pixel coords of the zoom origin relative to the current center
	  		var scale = this.getZoomScale(zoom),
	  		    offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
	
	  		// don't animate if the zoom origin isn't within one screen from the current center, unless forced
	  		if (options.animate !== true && !this.getSize().contains(offset)) { return false; }
	
	  		requestAnimFrame(function () {
	  			this
	  			    ._moveStart(true, false)
	  			    ._animateZoom(center, zoom, true);
	  		}, this);
	
	  		return true;
	  	},
	
	  	_animateZoom: function (center, zoom, startAnim, noUpdate) {
	  		if (!this._mapPane) { return; }
	
	  		if (startAnim) {
	  			this._animatingZoom = true;
	
	  			// remember what center/zoom to set after animation
	  			this._animateToCenter = center;
	  			this._animateToZoom = zoom;
	
	  			addClass(this._mapPane, 'leaflet-zoom-anim');
	  		}
	
	  		// @section Other Events
	  		// @event zoomanim: ZoomAnimEvent
	  		// Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
	  		this.fire('zoomanim', {
	  			center: center,
	  			zoom: zoom,
	  			noUpdate: noUpdate
	  		});
	
	  		// Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
	  		setTimeout(bind(this._onZoomTransitionEnd, this), 250);
	  	},
	
	  	_onZoomTransitionEnd: function () {
	  		if (!this._animatingZoom) { return; }
	
	  		if (this._mapPane) {
	  			removeClass(this._mapPane, 'leaflet-zoom-anim');
	  		}
	
	  		this._animatingZoom = false;
	
	  		this._move(this._animateToCenter, this._animateToZoom);
	
	  		// This anim frame should prevent an obscure iOS webkit tile loading race condition.
	  		requestAnimFrame(function () {
	  			this._moveEnd(true);
	  		}, this);
	  	}
	  });
	
	  // @section
	
	  // @factory L.map(id: String, options?: Map options)
	  // Instantiates a map object given the DOM ID of a `<div>` element
	  // and optionally an object literal with `Map options`.
	  //
	  // @alternative
	  // @factory L.map(el: HTMLElement, options?: Map options)
	  // Instantiates a map object given an instance of a `<div>` HTML element
	  // and optionally an object literal with `Map options`.
	  function createMap(id, options) {
	  	return new Map(id, options);
	  }
	
	  /*
	   * @class Control
	   * @aka L.Control
	   * @inherits Class
	   *
	   * L.Control is a base class for implementing map controls. Handles positioning.
	   * All other controls extend from this class.
	   */
	
	  var Control = Class.extend({
	  	// @section
	  	// @aka Control options
	  	options: {
	  		// @option position: String = 'topright'
	  		// The position of the control (one of the map corners). Possible values are `'topleft'`,
	  		// `'topright'`, `'bottomleft'` or `'bottomright'`
	  		position: 'topright'
	  	},
	
	  	initialize: function (options) {
	  		setOptions(this, options);
	  	},
	
	  	/* @section
	  	 * Classes extending L.Control will inherit the following methods:
	  	 *
	  	 * @method getPosition: string
	  	 * Returns the position of the control.
	  	 */
	  	getPosition: function () {
	  		return this.options.position;
	  	},
	
	  	// @method setPosition(position: string): this
	  	// Sets the position of the control.
	  	setPosition: function (position) {
	  		var map = this._map;
	
	  		if (map) {
	  			map.removeControl(this);
	  		}
	
	  		this.options.position = position;
	
	  		if (map) {
	  			map.addControl(this);
	  		}
	
	  		return this;
	  	},
	
	  	// @method getContainer: HTMLElement
	  	// Returns the HTMLElement that contains the control.
	  	getContainer: function () {
	  		return this._container;
	  	},
	
	  	// @method addTo(map: Map): this
	  	// Adds the control to the given map.
	  	addTo: function (map) {
	  		this.remove();
	  		this._map = map;
	
	  		var container = this._container = this.onAdd(map),
	  		    pos = this.getPosition(),
	  		    corner = map._controlCorners[pos];
	
	  		addClass(container, 'leaflet-control');
	
	  		if (pos.indexOf('bottom') !== -1) {
	  			corner.insertBefore(container, corner.firstChild);
	  		} else {
	  			corner.appendChild(container);
	  		}
	
	  		this._map.on('unload', this.remove, this);
	
	  		return this;
	  	},
	
	  	// @method remove: this
	  	// Removes the control from the map it is currently active on.
	  	remove: function () {
	  		if (!this._map) {
	  			return this;
	  		}
	
	  		remove(this._container);
	
	  		if (this.onRemove) {
	  			this.onRemove(this._map);
	  		}
	
	  		this._map.off('unload', this.remove, this);
	  		this._map = null;
	
	  		return this;
	  	},
	
	  	_refocusOnMap: function (e) {
	  		// if map exists and event is not a keyboard event
	  		if (this._map && e && e.screenX > 0 && e.screenY > 0) {
	  			this._map.getContainer().focus();
	  		}
	  	}
	  });
	
	  var control = function (options) {
	  	return new Control(options);
	  };
	
	  /* @section Extension methods
	   * @uninheritable
	   *
	   * Every control should extend from `L.Control` and (re-)implement the following methods.
	   *
	   * @method onAdd(map: Map): HTMLElement
	   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
	   *
	   * @method onRemove(map: Map)
	   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
	   */
	
	  /* @namespace Map
	   * @section Methods for Layers and Controls
	   */
	  Map.include({
	  	// @method addControl(control: Control): this
	  	// Adds the given control to the map
	  	addControl: function (control) {
	  		control.addTo(this);
	  		return this;
	  	},
	
	  	// @method removeControl(control: Control): this
	  	// Removes the given control from the map
	  	removeControl: function (control) {
	  		control.remove();
	  		return this;
	  	},
	
	  	_initControlPos: function () {
	  		var corners = this._controlCorners = {},
	  		    l = 'leaflet-',
	  		    container = this._controlContainer =
	  		            create$1('div', l + 'control-container', this._container);
	
	  		function createCorner(vSide, hSide) {
	  			var className = l + vSide + ' ' + l + hSide;
	
	  			corners[vSide + hSide] = create$1('div', className, container);
	  		}
	
	  		createCorner('top', 'left');
	  		createCorner('top', 'right');
	  		createCorner('bottom', 'left');
	  		createCorner('bottom', 'right');
	  	},
	
	  	_clearControlPos: function () {
	  		for (var i in this._controlCorners) {
	  			remove(this._controlCorners[i]);
	  		}
	  		remove(this._controlContainer);
	  		delete this._controlCorners;
	  		delete this._controlContainer;
	  	}
	  });
	
	  /*
	   * @class Control.Layers
	   * @aka L.Control.Layers
	   * @inherits Control
	   *
	   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](http://leafletjs.com/examples/layers-control/)). Extends `Control`.
	   *
	   * @example
	   *
	   * ```js
	   * var baseLayers = {
	   * 	"Mapbox": mapbox,
	   * 	"OpenStreetMap": osm
	   * };
	   *
	   * var overlays = {
	   * 	"Marker": marker,
	   * 	"Roads": roadsLayer
	   * };
	   *
	   * L.control.layers(baseLayers, overlays).addTo(map);
	   * ```
	   *
	   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
	   *
	   * ```js
	   * {
	   *     "<someName1>": layer1,
	   *     "<someName2>": layer2
	   * }
	   * ```
	   *
	   * The layer names can contain HTML, which allows you to add additional styling to the items:
	   *
	   * ```js
	   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
	   * ```
	   */
	
	  var Layers = Control.extend({
	  	// @section
	  	// @aka Control.Layers options
	  	options: {
	  		// @option collapsed: Boolean = true
	  		// If `true`, the control will be collapsed into an icon and expanded on mouse hover or touch.
	  		collapsed: true,
	  		position: 'topright',
	
	  		// @option autoZIndex: Boolean = true
	  		// If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
	  		autoZIndex: true,
	
	  		// @option hideSingleBase: Boolean = false
	  		// If `true`, the base layers in the control will be hidden when there is only one.
	  		hideSingleBase: false,
	
	  		// @option sortLayers: Boolean = false
	  		// Whether to sort the layers. When `false`, layers will keep the order
	  		// in which they were added to the control.
	  		sortLayers: false,
	
	  		// @option sortFunction: Function = *
	  		// A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
	  		// that will be used for sorting the layers, when `sortLayers` is `true`.
	  		// The function receives both the `L.Layer` instances and their names, as in
	  		// `sortFunction(layerA, layerB, nameA, nameB)`.
	  		// By default, it sorts layers alphabetically by their name.
	  		sortFunction: function (layerA, layerB, nameA, nameB) {
	  			return nameA < nameB ? -1 : (nameB < nameA ? 1 : 0);
	  		}
	  	},
	
	  	initialize: function (baseLayers, overlays, options) {
	  		setOptions(this, options);
	
	  		this._layerControlInputs = [];
	  		this._layers = [];
	  		this._lastZIndex = 0;
	  		this._handlingClick = false;
	
	  		for (var i in baseLayers) {
	  			this._addLayer(baseLayers[i], i);
	  		}
	
	  		for (i in overlays) {
	  			this._addLayer(overlays[i], i, true);
	  		}
	  	},
	
	  	onAdd: function (map) {
	  		this._initLayout();
	  		this._update();
	
	  		this._map = map;
	  		map.on('zoomend', this._checkDisabledLayers, this);
	
	  		for (var i = 0; i < this._layers.length; i++) {
	  			this._layers[i].layer.on('add remove', this._onLayerChange, this);
	  		}
	
	  		return this._container;
	  	},
	
	  	addTo: function (map) {
	  		Control.prototype.addTo.call(this, map);
	  		// Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
	  		return this._expandIfNotCollapsed();
	  	},
	
	  	onRemove: function () {
	  		this._map.off('zoomend', this._checkDisabledLayers, this);
	
	  		for (var i = 0; i < this._layers.length; i++) {
	  			this._layers[i].layer.off('add remove', this._onLayerChange, this);
	  		}
	  	},
	
	  	// @method addBaseLayer(layer: Layer, name: String): this
	  	// Adds a base layer (radio button entry) with the given name to the control.
	  	addBaseLayer: function (layer, name) {
	  		this._addLayer(layer, name);
	  		return (this._map) ? this._update() : this;
	  	},
	
	  	// @method addOverlay(layer: Layer, name: String): this
	  	// Adds an overlay (checkbox entry) with the given name to the control.
	  	addOverlay: function (layer, name) {
	  		this._addLayer(layer, name, true);
	  		return (this._map) ? this._update() : this;
	  	},
	
	  	// @method removeLayer(layer: Layer): this
	  	// Remove the given layer from the control.
	  	removeLayer: function (layer) {
	  		layer.off('add remove', this._onLayerChange, this);
	
	  		var obj = this._getLayer(stamp(layer));
	  		if (obj) {
	  			this._layers.splice(this._layers.indexOf(obj), 1);
	  		}
	  		return (this._map) ? this._update() : this;
	  	},
	
	  	// @method expand(): this
	  	// Expand the control container if collapsed.
	  	expand: function () {
	  		addClass(this._container, 'leaflet-control-layers-expanded');
	  		this._section.style.height = null;
	  		var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
	  		if (acceptableHeight < this._section.clientHeight) {
	  			addClass(this._section, 'leaflet-control-layers-scrollbar');
	  			this._section.style.height = acceptableHeight + 'px';
	  		} else {
	  			removeClass(this._section, 'leaflet-control-layers-scrollbar');
	  		}
	  		this._checkDisabledLayers();
	  		return this;
	  	},
	
	  	// @method collapse(): this
	  	// Collapse the control container if expanded.
	  	collapse: function () {
	  		removeClass(this._container, 'leaflet-control-layers-expanded');
	  		return this;
	  	},
	
	  	_initLayout: function () {
	  		var className = 'leaflet-control-layers',
	  		    container = this._container = create$1('div', className),
	  		    collapsed = this.options.collapsed;
	
	  		// makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
	  		container.setAttribute('aria-haspopup', true);
	
	  		disableClickPropagation(container);
	  		disableScrollPropagation(container);
	
	  		var section = this._section = create$1('section', className + '-list');
	
	  		if (collapsed) {
	  			this._map.on('click', this.collapse, this);
	
	  			if (!android) {
	  				on(container, {
	  					mouseenter: this.expand,
	  					mouseleave: this.collapse
	  				}, this);
	  			}
	  		}
	
	  		var link = this._layersLink = create$1('a', className + '-toggle', container);
	  		link.href = '#';
	  		link.title = 'Layers';
	
	  		if (touch) {
	  			on(link, 'click', stop);
	  			on(link, 'click', this.expand, this);
	  		} else {
	  			on(link, 'focus', this.expand, this);
	  		}
	
	  		if (!collapsed) {
	  			this.expand();
	  		}
	
	  		this._baseLayersList = create$1('div', className + '-base', section);
	  		this._separator = create$1('div', className + '-separator', section);
	  		this._overlaysList = create$1('div', className + '-overlays', section);
	
	  		container.appendChild(section);
	  	},
	
	  	_getLayer: function (id) {
	  		for (var i = 0; i < this._layers.length; i++) {
	
	  			if (this._layers[i] && stamp(this._layers[i].layer) === id) {
	  				return this._layers[i];
	  			}
	  		}
	  	},
	
	  	_addLayer: function (layer, name, overlay) {
	  		if (this._map) {
	  			layer.on('add remove', this._onLayerChange, this);
	  		}
	
	  		this._layers.push({
	  			layer: layer,
	  			name: name,
	  			overlay: overlay
	  		});
	
	  		if (this.options.sortLayers) {
	  			this._layers.sort(bind(function (a, b) {
	  				return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
	  			}, this));
	  		}
	
	  		if (this.options.autoZIndex && layer.setZIndex) {
	  			this._lastZIndex++;
	  			layer.setZIndex(this._lastZIndex);
	  		}
	
	  		this._expandIfNotCollapsed();
	  	},
	
	  	_update: function () {
	  		if (!this._container) { return this; }
	
	  		empty(this._baseLayersList);
	  		empty(this._overlaysList);
	
	  		this._layerControlInputs = [];
	  		var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
	
	  		for (i = 0; i < this._layers.length; i++) {
	  			obj = this._layers[i];
	  			this._addItem(obj);
	  			overlaysPresent = overlaysPresent || obj.overlay;
	  			baseLayersPresent = baseLayersPresent || !obj.overlay;
	  			baseLayersCount += !obj.overlay ? 1 : 0;
	  		}
	
	  		// Hide base layers section if there's only one layer.
	  		if (this.options.hideSingleBase) {
	  			baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
	  			this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
	  		}
	
	  		this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
	
	  		return this;
	  	},
	
	  	_onLayerChange: function (e) {
	  		if (!this._handlingClick) {
	  			this._update();
	  		}
	
	  		var obj = this._getLayer(stamp(e.target));
	
	  		// @namespace Map
	  		// @section Layer events
	  		// @event baselayerchange: LayersControlEvent
	  		// Fired when the base layer is changed through the [layers control](#control-layers).
	  		// @event overlayadd: LayersControlEvent
	  		// Fired when an overlay is selected through the [layers control](#control-layers).
	  		// @event overlayremove: LayersControlEvent
	  		// Fired when an overlay is deselected through the [layers control](#control-layers).
	  		// @namespace Control.Layers
	  		var type = obj.overlay ?
	  			(e.type === 'add' ? 'overlayadd' : 'overlayremove') :
	  			(e.type === 'add' ? 'baselayerchange' : null);
	
	  		if (type) {
	  			this._map.fire(type, obj);
	  		}
	  	},
	
	  	// IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see http://bit.ly/PqYLBe)
	  	_createRadioElement: function (name, checked) {
	
	  		var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' +
	  				name + '"' + (checked ? ' checked="checked"' : '') + '/>';
	
	  		var radioFragment = document.createElement('div');
	  		radioFragment.innerHTML = radioHtml;
	
	  		return radioFragment.firstChild;
	  	},
	
	  	_addItem: function (obj) {
	  		var label = document.createElement('label'),
	  		    checked = this._map.hasLayer(obj.layer),
	  		    input;
	
	  		if (obj.overlay) {
	  			input = document.createElement('input');
	  			input.type = 'checkbox';
	  			input.className = 'leaflet-control-layers-selector';
	  			input.defaultChecked = checked;
	  		} else {
	  			input = this._createRadioElement('leaflet-base-layers_' + stamp(this), checked);
	  		}
	
	  		this._layerControlInputs.push(input);
	  		input.layerId = stamp(obj.layer);
	
	  		on(input, 'click', this._onInputClick, this);
	
	  		var name = document.createElement('span');
	  		name.innerHTML = ' ' + obj.name;
	
	  		// Helps from preventing layer control flicker when checkboxes are disabled
	  		// https://github.com/Leaflet/Leaflet/issues/2771
	  		var holder = document.createElement('div');
	
	  		label.appendChild(holder);
	  		holder.appendChild(input);
	  		holder.appendChild(name);
	
	  		var container = obj.overlay ? this._overlaysList : this._baseLayersList;
	  		container.appendChild(label);
	
	  		this._checkDisabledLayers();
	  		return label;
	  	},
	
	  	_onInputClick: function () {
	  		var inputs = this._layerControlInputs,
	  		    input, layer;
	  		var addedLayers = [],
	  		    removedLayers = [];
	
	  		this._handlingClick = true;
	
	  		for (var i = inputs.length - 1; i >= 0; i--) {
	  			input = inputs[i];
	  			layer = this._getLayer(input.layerId).layer;
	
	  			if (input.checked) {
	  				addedLayers.push(layer);
	  			} else if (!input.checked) {
	  				removedLayers.push(layer);
	  			}
	  		}
	
	  		// Bugfix issue 2318: Should remove all old layers before readding new ones
	  		for (i = 0; i < removedLayers.length; i++) {
	  			if (this._map.hasLayer(removedLayers[i])) {
	  				this._map.removeLayer(removedLayers[i]);
	  			}
	  		}
	  		for (i = 0; i < addedLayers.length; i++) {
	  			if (!this._map.hasLayer(addedLayers[i])) {
	  				this._map.addLayer(addedLayers[i]);
	  			}
	  		}
	
	  		this._handlingClick = false;
	
	  		this._refocusOnMap();
	  	},
	
	  	_checkDisabledLayers: function () {
	  		var inputs = this._layerControlInputs,
	  		    input,
	  		    layer,
	  		    zoom = this._map.getZoom();
	
	  		for (var i = inputs.length - 1; i >= 0; i--) {
	  			input = inputs[i];
	  			layer = this._getLayer(input.layerId).layer;
	  			input.disabled = (layer.options.minZoom !== undefined && zoom < layer.options.minZoom) ||
	  			                 (layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom);
	
	  		}
	  	},
	
	  	_expandIfNotCollapsed: function () {
	  		if (this._map && !this.options.collapsed) {
	  			this.expand();
	  		}
	  		return this;
	  	},
	
	  	_expand: function () {
	  		// Backward compatibility, remove me in 1.1.
	  		return this.expand();
	  	},
	
	  	_collapse: function () {
	  		// Backward compatibility, remove me in 1.1.
	  		return this.collapse();
	  	}
	
	  });
	
	
	  // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
	  // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
	  var layers = function (baseLayers, overlays, options) {
	  	return new Layers(baseLayers, overlays, options);
	  };
	
	  /*
	   * @class Control.Zoom
	   * @aka L.Control.Zoom
	   * @inherits Control
	   *
	   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
	   */
	
	  var Zoom = Control.extend({
	  	// @section
	  	// @aka Control.Zoom options
	  	options: {
	  		position: 'topleft',
	
	  		// @option zoomInText: String = '+'
	  		// The text set on the 'zoom in' button.
	  		zoomInText: '+',
	
	  		// @option zoomInTitle: String = 'Zoom in'
	  		// The title set on the 'zoom in' button.
	  		zoomInTitle: 'Zoom in',
	
	  		// @option zoomOutText: String = '&#x2212;'
	  		// The text set on the 'zoom out' button.
	  		zoomOutText: '&#x2212;',
	
	  		// @option zoomOutTitle: String = 'Zoom out'
	  		// The title set on the 'zoom out' button.
	  		zoomOutTitle: 'Zoom out'
	  	},
	
	  	onAdd: function (map) {
	  		var zoomName = 'leaflet-control-zoom',
	  		    container = create$1('div', zoomName + ' leaflet-bar'),
	  		    options = this.options;
	
	  		this._zoomInButton  = this._createButton(options.zoomInText, options.zoomInTitle,
	  		        zoomName + '-in',  container, this._zoomIn);
	  		this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle,
	  		        zoomName + '-out', container, this._zoomOut);
	
	  		this._updateDisabled();
	  		map.on('zoomend zoomlevelschange', this._updateDisabled, this);
	
	  		return container;
	  	},
	
	  	onRemove: function (map) {
	  		map.off('zoomend zoomlevelschange', this._updateDisabled, this);
	  	},
	
	  	disable: function () {
	  		this._disabled = true;
	  		this._updateDisabled();
	  		return this;
	  	},
	
	  	enable: function () {
	  		this._disabled = false;
	  		this._updateDisabled();
	  		return this;
	  	},
	
	  	_zoomIn: function (e) {
	  		if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) {
	  			this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
	  		}
	  	},
	
	  	_zoomOut: function (e) {
	  		if (!this._disabled && this._map._zoom > this._map.getMinZoom()) {
	  			this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
	  		}
	  	},
	
	  	_createButton: function (html, title, className, container, fn) {
	  		var link = create$1('a', className, container);
	  		link.innerHTML = html;
	  		link.href = '#';
	  		link.title = title;
	
	  		/*
	  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
	  		 */
	  		link.setAttribute('role', 'button');
	  		link.setAttribute('aria-label', title);
	
	  		disableClickPropagation(link);
	  		on(link, 'click', stop);
	  		on(link, 'click', fn, this);
	  		on(link, 'click', this._refocusOnMap, this);
	
	  		return link;
	  	},
	
	  	_updateDisabled: function () {
	  		var map = this._map,
	  		    className = 'leaflet-disabled';
	
	  		removeClass(this._zoomInButton, className);
	  		removeClass(this._zoomOutButton, className);
	
	  		if (this._disabled || map._zoom === map.getMinZoom()) {
	  			addClass(this._zoomOutButton, className);
	  		}
	  		if (this._disabled || map._zoom === map.getMaxZoom()) {
	  			addClass(this._zoomInButton, className);
	  		}
	  	}
	  });
	
	  // @namespace Map
	  // @section Control options
	  // @option zoomControl: Boolean = true
	  // Whether a [zoom control](#control-zoom) is added to the map by default.
	  Map.mergeOptions({
	  	zoomControl: true
	  });
	
	  Map.addInitHook(function () {
	  	if (this.options.zoomControl) {
	  		// @section Controls
	  		// @property zoomControl: Control.Zoom
	  		// The default zoom control (only available if the
	  		// [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
	  		this.zoomControl = new Zoom();
	  		this.addControl(this.zoomControl);
	  	}
	  });
	
	  // @namespace Control.Zoom
	  // @factory L.control.zoom(options: Control.Zoom options)
	  // Creates a zoom control
	  var zoom = function (options) {
	  	return new Zoom(options);
	  };
	
	  /*
	   * @class Control.Scale
	   * @aka L.Control.Scale
	   * @inherits Control
	   *
	   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
	   *
	   * @example
	   *
	   * ```js
	   * L.control.scale().addTo(map);
	   * ```
	   */
	
	  var Scale = Control.extend({
	  	// @section
	  	// @aka Control.Scale options
	  	options: {
	  		position: 'bottomleft',
	
	  		// @option maxWidth: Number = 100
	  		// Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
	  		maxWidth: 100,
	
	  		// @option metric: Boolean = True
	  		// Whether to show the metric scale line (m/km).
	  		metric: true,
	
	  		// @option imperial: Boolean = True
	  		// Whether to show the imperial scale line (mi/ft).
	  		imperial: true
	
	  		// @option updateWhenIdle: Boolean = false
	  		// If `true`, the control is updated on [`moveend`](#map-moveend), otherwise it's always up-to-date (updated on [`move`](#map-move)).
	  	},
	
	  	onAdd: function (map) {
	  		var className = 'leaflet-control-scale',
	  		    container = create$1('div', className),
	  		    options = this.options;
	
	  		this._addScales(options, className + '-line', container);
	
	  		map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
	  		map.whenReady(this._update, this);
	
	  		return container;
	  	},
	
	  	onRemove: function (map) {
	  		map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
	  	},
	
	  	_addScales: function (options, className, container) {
	  		if (options.metric) {
	  			this._mScale = create$1('div', className, container);
	  		}
	  		if (options.imperial) {
	  			this._iScale = create$1('div', className, container);
	  		}
	  	},
	
	  	_update: function () {
	  		var map = this._map,
	  		    y = map.getSize().y / 2;
	
	  		var maxMeters = map.distance(
	  			map.containerPointToLatLng([0, y]),
	  			map.containerPointToLatLng([this.options.maxWidth, y]));
	
	  		this._updateScales(maxMeters);
	  	},
	
	  	_updateScales: function (maxMeters) {
	  		if (this.options.metric && maxMeters) {
	  			this._updateMetric(maxMeters);
	  		}
	  		if (this.options.imperial && maxMeters) {
	  			this._updateImperial(maxMeters);
	  		}
	  	},
	
	  	_updateMetric: function (maxMeters) {
	  		var meters = this._getRoundNum(maxMeters),
	  		    label = meters < 1000 ? meters + ' m' : (meters / 1000) + ' km';
	
	  		this._updateScale(this._mScale, label, meters / maxMeters);
	  	},
	
	  	_updateImperial: function (maxMeters) {
	  		var maxFeet = maxMeters * 3.2808399,
	  		    maxMiles, miles, feet;
	
	  		if (maxFeet > 5280) {
	  			maxMiles = maxFeet / 5280;
	  			miles = this._getRoundNum(maxMiles);
	  			this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
	
	  		} else {
	  			feet = this._getRoundNum(maxFeet);
	  			this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
	  		}
	  	},
	
	  	_updateScale: function (scale, text, ratio) {
	  		scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
	  		scale.innerHTML = text;
	  	},
	
	  	_getRoundNum: function (num) {
	  		var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1),
	  		    d = num / pow10;
	
	  		d = d >= 10 ? 10 :
	  		    d >= 5 ? 5 :
	  		    d >= 3 ? 3 :
	  		    d >= 2 ? 2 : 1;
	
	  		return pow10 * d;
	  	}
	  });
	
	
	  // @factory L.control.scale(options?: Control.Scale options)
	  // Creates an scale control with the given options.
	  var scale = function (options) {
	  	return new Scale(options);
	  };
	
	  /*
	   * @class Control.Attribution
	   * @aka L.Control.Attribution
	   * @inherits Control
	   *
	   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
	   */
	
	  var Attribution = Control.extend({
	  	// @section
	  	// @aka Control.Attribution options
	  	options: {
	  		position: 'bottomright',
	
	  		// @option prefix: String = 'Leaflet'
	  		// The HTML text shown before the attributions. Pass `false` to disable.
	  		prefix: '<a href="https://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'
	  	},
	
	  	initialize: function (options) {
	  		setOptions(this, options);
	
	  		this._attributions = {};
	  	},
	
	  	onAdd: function (map) {
	  		map.attributionControl = this;
	  		this._container = create$1('div', 'leaflet-control-attribution');
	  		disableClickPropagation(this._container);
	
	  		// TODO ugly, refactor
	  		for (var i in map._layers) {
	  			if (map._layers[i].getAttribution) {
	  				this.addAttribution(map._layers[i].getAttribution());
	  			}
	  		}
	
	  		this._update();
	
	  		return this._container;
	  	},
	
	  	// @method setPrefix(prefix: String): this
	  	// Sets the text before the attributions.
	  	setPrefix: function (prefix) {
	  		this.options.prefix = prefix;
	  		this._update();
	  		return this;
	  	},
	
	  	// @method addAttribution(text: String): this
	  	// Adds an attribution text (e.g. `'Vector data &copy; Mapbox'`).
	  	addAttribution: function (text) {
	  		if (!text) { return this; }
	
	  		if (!this._attributions[text]) {
	  			this._attributions[text] = 0;
	  		}
	  		this._attributions[text]++;
	
	  		this._update();
	
	  		return this;
	  	},
	
	  	// @method removeAttribution(text: String): this
	  	// Removes an attribution text.
	  	removeAttribution: function (text) {
	  		if (!text) { return this; }
	
	  		if (this._attributions[text]) {
	  			this._attributions[text]--;
	  			this._update();
	  		}
	
	  		return this;
	  	},
	
	  	_update: function () {
	  		if (!this._map) { return; }
	
	  		var attribs = [];
	
	  		for (var i in this._attributions) {
	  			if (this._attributions[i]) {
	  				attribs.push(i);
	  			}
	  		}
	
	  		var prefixAndAttribs = [];
	
	  		if (this.options.prefix) {
	  			prefixAndAttribs.push(this.options.prefix);
	  		}
	  		if (attribs.length) {
	  			prefixAndAttribs.push(attribs.join(', '));
	  		}
	
	  		this._container.innerHTML = prefixAndAttribs.join(' | ');
	  	}
	  });
	
	  // @namespace Map
	  // @section Control options
	  // @option attributionControl: Boolean = true
	  // Whether a [attribution control](#control-attribution) is added to the map by default.
	  Map.mergeOptions({
	  	attributionControl: true
	  });
	
	  Map.addInitHook(function () {
	  	if (this.options.attributionControl) {
	  		new Attribution().addTo(this);
	  	}
	  });
	
	  // @namespace Control.Attribution
	  // @factory L.control.attribution(options: Control.Attribution options)
	  // Creates an attribution control.
	  var attribution = function (options) {
	  	return new Attribution(options);
	  };
	
	  Control.Layers = Layers;
	  Control.Zoom = Zoom;
	  Control.Scale = Scale;
	  Control.Attribution = Attribution;
	
	  control.layers = layers;
	  control.zoom = zoom;
	  control.scale = scale;
	  control.attribution = attribution;
	
	  /*
	  	L.Handler is a base class for handler classes that are used internally to inject
	  	interaction features like dragging to classes like Map and Marker.
	  */
	
	  // @class Handler
	  // @aka L.Handler
	  // Abstract class for map interaction handlers
	
	  var Handler = Class.extend({
	  	initialize: function (map) {
	  		this._map = map;
	  	},
	
	  	// @method enable(): this
	  	// Enables the handler
	  	enable: function () {
	  		if (this._enabled) { return this; }
	
	  		this._enabled = true;
	  		this.addHooks();
	  		return this;
	  	},
	
	  	// @method disable(): this
	  	// Disables the handler
	  	disable: function () {
	  		if (!this._enabled) { return this; }
	
	  		this._enabled = false;
	  		this.removeHooks();
	  		return this;
	  	},
	
	  	// @method enabled(): Boolean
	  	// Returns `true` if the handler is enabled
	  	enabled: function () {
	  		return !!this._enabled;
	  	}
	
	  	// @section Extension methods
	  	// Classes inheriting from `Handler` must implement the two following methods:
	  	// @method addHooks()
	  	// Called when the handler is enabled, should add event hooks.
	  	// @method removeHooks()
	  	// Called when the handler is disabled, should remove the event hooks added previously.
	  });
	
	  // @section There is static function which can be called without instantiating L.Handler:
	  // @function addTo(map: Map, name: String): this
	  // Adds a new Handler to the given map with the given name.
	  Handler.addTo = function (map, name) {
	  	map.addHandler(name, this);
	  	return this;
	  };
	
	  var Mixin = {Events: Events};
	
	  /*
	   * @class Draggable
	   * @aka L.Draggable
	   * @inherits Evented
	   *
	   * A class for making DOM elements draggable (including touch support).
	   * Used internally for map and marker dragging. Only works for elements
	   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
	   *
	   * @example
	   * ```js
	   * var draggable = new L.Draggable(elementToDrag);
	   * draggable.enable();
	   * ```
	   */
	
	  var START = touch ? 'touchstart mousedown' : 'mousedown';
	  var END = {
	  	mousedown: 'mouseup',
	  	touchstart: 'touchend',
	  	pointerdown: 'touchend',
	  	MSPointerDown: 'touchend'
	  };
	  var MOVE = {
	  	mousedown: 'mousemove',
	  	touchstart: 'touchmove',
	  	pointerdown: 'touchmove',
	  	MSPointerDown: 'touchmove'
	  };
	
	
	  var Draggable = Evented.extend({
	
	  	options: {
	  		// @section
	  		// @aka Draggable options
	  		// @option clickTolerance: Number = 3
	  		// The max number of pixels a user can shift the mouse pointer during a click
	  		// for it to be considered a valid click (as opposed to a mouse drag).
	  		clickTolerance: 3
	  	},
	
	  	// @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
	  	// Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
	  	initialize: function (element, dragStartTarget, preventOutline$$1, options) {
	  		setOptions(this, options);
	
	  		this._element = element;
	  		this._dragStartTarget = dragStartTarget || element;
	  		this._preventOutline = preventOutline$$1;
	  	},
	
	  	// @method enable()
	  	// Enables the dragging ability
	  	enable: function () {
	  		if (this._enabled) { return; }
	
	  		on(this._dragStartTarget, START, this._onDown, this);
	
	  		this._enabled = true;
	  	},
	
	  	// @method disable()
	  	// Disables the dragging ability
	  	disable: function () {
	  		if (!this._enabled) { return; }
	
	  		// If we're currently dragging this draggable,
	  		// disabling it counts as first ending the drag.
	  		if (Draggable._dragging === this) {
	  			this.finishDrag();
	  		}
	
	  		off(this._dragStartTarget, START, this._onDown, this);
	
	  		this._enabled = false;
	  		this._moved = false;
	  	},
	
	  	_onDown: function (e) {
	  		// Ignore simulated events, since we handle both touch and
	  		// mouse explicitly; otherwise we risk getting duplicates of
	  		// touch events, see #4315.
	  		// Also ignore the event if disabled; this happens in IE11
	  		// under some circumstances, see #3666.
	  		if (e._simulated || !this._enabled) { return; }
	
	  		this._moved = false;
	
	  		if (hasClass(this._element, 'leaflet-zoom-anim')) { return; }
	
	  		if (Draggable._dragging || e.shiftKey || ((e.which !== 1) && (e.button !== 1) && !e.touches)) { return; }
	  		Draggable._dragging = this;  // Prevent dragging multiple objects at once.
	
	  		if (this._preventOutline) {
	  			preventOutline(this._element);
	  		}
	
	  		disableImageDrag();
	  		disableTextSelection();
	
	  		if (this._moving) { return; }
	
	  		// @event down: Event
	  		// Fired when a drag is about to start.
	  		this.fire('down');
	
	  		var first = e.touches ? e.touches[0] : e,
	  		    sizedParent = getSizedParentNode(this._element);
	
	  		this._startPoint = new Point(first.clientX, first.clientY);
	
	  		// Cache the scale, so that we can continuously compensate for it during drag (_onMove).
	  		this._parentScale = getScale(sizedParent);
	
	  		on(document, MOVE[e.type], this._onMove, this);
	  		on(document, END[e.type], this._onUp, this);
	  	},
	
	  	_onMove: function (e) {
	  		// Ignore simulated events, since we handle both touch and
	  		// mouse explicitly; otherwise we risk getting duplicates of
	  		// touch events, see #4315.
	  		// Also ignore the event if disabled; this happens in IE11
	  		// under some circumstances, see #3666.
	  		if (e._simulated || !this._enabled) { return; }
	
	  		if (e.touches && e.touches.length > 1) {
	  			this._moved = true;
	  			return;
	  		}
	
	  		var first = (e.touches && e.touches.length === 1 ? e.touches[0] : e),
	  		    offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
	
	  		if (!offset.x && !offset.y) { return; }
	  		if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) { return; }
	
	  		// We assume that the parent container's position, border and scale do not change for the duration of the drag.
	  		// Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
	  		// and we can use the cached value for the scale.
	  		offset.x /= this._parentScale.x;
	  		offset.y /= this._parentScale.y;
	
	  		preventDefault(e);
	
	  		if (!this._moved) {
	  			// @event dragstart: Event
	  			// Fired when a drag starts
	  			this.fire('dragstart');
	
	  			this._moved = true;
	  			this._startPos = getPosition(this._element).subtract(offset);
	
	  			addClass(document.body, 'leaflet-dragging');
	
	  			this._lastTarget = e.target || e.srcElement;
	  			// IE and Edge do not give the <use> element, so fetch it
	  			// if necessary
	  			if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) {
	  				this._lastTarget = this._lastTarget.correspondingUseElement;
	  			}
	  			addClass(this._lastTarget, 'leaflet-drag-target');
	  		}
	
	  		this._newPos = this._startPos.add(offset);
	  		this._moving = true;
	
	  		cancelAnimFrame(this._animRequest);
	  		this._lastEvent = e;
	  		this._animRequest = requestAnimFrame(this._updatePosition, this, true);
	  	},
	
	  	_updatePosition: function () {
	  		var e = {originalEvent: this._lastEvent};
	
	  		// @event predrag: Event
	  		// Fired continuously during dragging *before* each corresponding
	  		// update of the element's position.
	  		this.fire('predrag', e);
	  		setPosition(this._element, this._newPos);
	
	  		// @event drag: Event
	  		// Fired continuously during dragging.
	  		this.fire('drag', e);
	  	},
	
	  	_onUp: function (e) {
	  		// Ignore simulated events, since we handle both touch and
	  		// mouse explicitly; otherwise we risk getting duplicates of
	  		// touch events, see #4315.
	  		// Also ignore the event if disabled; this happens in IE11
	  		// under some circumstances, see #3666.
	  		if (e._simulated || !this._enabled) { return; }
	  		this.finishDrag();
	  	},
	
	  	finishDrag: function () {
	  		removeClass(document.body, 'leaflet-dragging');
	
	  		if (this._lastTarget) {
	  			removeClass(this._lastTarget, 'leaflet-drag-target');
	  			this._lastTarget = null;
	  		}
	
	  		for (var i in MOVE) {
	  			off(document, MOVE[i], this._onMove, this);
	  			off(document, END[i], this._onUp, this);
	  		}
	
	  		enableImageDrag();
	  		enableTextSelection();
	
	  		if (this._moved && this._moving) {
	  			// ensure drag is not fired after dragend
	  			cancelAnimFrame(this._animRequest);
	
	  			// @event dragend: DragEndEvent
	  			// Fired when the drag ends.
	  			this.fire('dragend', {
	  				distance: this._newPos.distanceTo(this._startPos)
	  			});
	  		}
	
	  		this._moving = false;
	  		Draggable._dragging = false;
	  	}
	
	  });
	
	  /*
	   * @namespace LineUtil
	   *
	   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
	   */
	
	  // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
	  // Improves rendering performance dramatically by lessening the number of points to draw.
	
	  // @function simplify(points: Point[], tolerance: Number): Point[]
	  // Dramatically reduces the number of points in a polyline while retaining
	  // its shape and returns a new array of simplified points, using the
	  // [Douglas-Peucker algorithm](http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm).
	  // Used for a huge performance boost when processing/displaying Leaflet polylines for
	  // each zoom level and also reducing visual noise. tolerance affects the amount of
	  // simplification (lesser value means higher quality but slower and with more points).
	  // Also released as a separated micro-library [Simplify.js](http://mourner.github.com/simplify-js/).
	  function simplify(points, tolerance) {
	  	if (!tolerance || !points.length) {
	  		return points.slice();
	  	}
	
	  	var sqTolerance = tolerance * tolerance;
	
	  	    // stage 1: vertex reduction
	  	    points = _reducePoints(points, sqTolerance);
	
	  	    // stage 2: Douglas-Peucker simplification
	  	    points = _simplifyDP(points, sqTolerance);
	
	  	return points;
	  }
	
	  // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
	  // Returns the distance between point `p` and segment `p1` to `p2`.
	  function pointToSegmentDistance(p, p1, p2) {
	  	return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
	  }
	
	  // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
	  // Returns the closest point from a point `p` on a segment `p1` to `p2`.
	  function closestPointOnSegment(p, p1, p2) {
	  	return _sqClosestPointOnSegment(p, p1, p2);
	  }
	
	  // Douglas-Peucker simplification, see http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm
	  function _simplifyDP(points, sqTolerance) {
	
	  	var len = points.length,
	  	    ArrayConstructor = typeof Uint8Array !== undefined + '' ? Uint8Array : Array,
	  	    markers = new ArrayConstructor(len);
	
	  	    markers[0] = markers[len - 1] = 1;
	
	  	_simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
	
	  	var i,
	  	    newPoints = [];
	
	  	for (i = 0; i < len; i++) {
	  		if (markers[i]) {
	  			newPoints.push(points[i]);
	  		}
	  	}
	
	  	return newPoints;
	  }
	
	  function _simplifyDPStep(points, markers, sqTolerance, first, last) {
	
	  	var maxSqDist = 0,
	  	index, i, sqDist;
	
	  	for (i = first + 1; i <= last - 1; i++) {
	  		sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
	
	  		if (sqDist > maxSqDist) {
	  			index = i;
	  			maxSqDist = sqDist;
	  		}
	  	}
	
	  	if (maxSqDist > sqTolerance) {
	  		markers[index] = 1;
	
	  		_simplifyDPStep(points, markers, sqTolerance, first, index);
	  		_simplifyDPStep(points, markers, sqTolerance, index, last);
	  	}
	  }
	
	  // reduce points that are too close to each other to a single point
	  function _reducePoints(points, sqTolerance) {
	  	var reducedPoints = [points[0]];
	
	  	for (var i = 1, prev = 0, len = points.length; i < len; i++) {
	  		if (_sqDist(points[i], points[prev]) > sqTolerance) {
	  			reducedPoints.push(points[i]);
	  			prev = i;
	  		}
	  	}
	  	if (prev < len - 1) {
	  		reducedPoints.push(points[len - 1]);
	  	}
	  	return reducedPoints;
	  }
	
	  var _lastCode;
	
	  // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
	  // Clips the segment a to b by rectangular bounds with the
	  // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
	  // (modifying the segment points directly!). Used by Leaflet to only show polyline
	  // points that are on the screen or near, increasing performance.
	  function clipSegment(a, b, bounds, useLastCode, round) {
	  	var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds),
	  	    codeB = _getBitCode(b, bounds),
	
	  	    codeOut, p, newCode;
	
	  	    // save 2nd code to avoid calculating it on the next segment
	  	    _lastCode = codeB;
	
	  	while (true) {
	  		// if a,b is inside the clip window (trivial accept)
	  		if (!(codeA | codeB)) {
	  			return [a, b];
	  		}
	
	  		// if a,b is outside the clip window (trivial reject)
	  		if (codeA & codeB) {
	  			return false;
	  		}
	
	  		// other cases
	  		codeOut = codeA || codeB;
	  		p = _getEdgeIntersection(a, b, codeOut, bounds, round);
	  		newCode = _getBitCode(p, bounds);
	
	  		if (codeOut === codeA) {
	  			a = p;
	  			codeA = newCode;
	  		} else {
	  			b = p;
	  			codeB = newCode;
	  		}
	  	}
	  }
	
	  function _getEdgeIntersection(a, b, code, bounds, round) {
	  	var dx = b.x - a.x,
	  	    dy = b.y - a.y,
	  	    min = bounds.min,
	  	    max = bounds.max,
	  	    x, y;
	
	  	if (code & 8) { // top
	  		x = a.x + dx * (max.y - a.y) / dy;
	  		y = max.y;
	
	  	} else if (code & 4) { // bottom
	  		x = a.x + dx * (min.y - a.y) / dy;
	  		y = min.y;
	
	  	} else if (code & 2) { // right
	  		x = max.x;
	  		y = a.y + dy * (max.x - a.x) / dx;
	
	  	} else if (code & 1) { // left
	  		x = min.x;
	  		y = a.y + dy * (min.x - a.x) / dx;
	  	}
	
	  	return new Point(x, y, round);
	  }
	
	  function _getBitCode(p, bounds) {
	  	var code = 0;
	
	  	if (p.x < bounds.min.x) { // left
	  		code |= 1;
	  	} else if (p.x > bounds.max.x) { // right
	  		code |= 2;
	  	}
	
	  	if (p.y < bounds.min.y) { // bottom
	  		code |= 4;
	  	} else if (p.y > bounds.max.y) { // top
	  		code |= 8;
	  	}
	
	  	return code;
	  }
	
	  // square distance (to avoid unnecessary Math.sqrt calls)
	  function _sqDist(p1, p2) {
	  	var dx = p2.x - p1.x,
	  	    dy = p2.y - p1.y;
	  	return dx * dx + dy * dy;
	  }
	
	  // return closest point on segment or distance to that point
	  function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
	  	var x = p1.x,
	  	    y = p1.y,
	  	    dx = p2.x - x,
	  	    dy = p2.y - y,
	  	    dot = dx * dx + dy * dy,
	  	    t;
	
	  	if (dot > 0) {
	  		t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
	
	  		if (t > 1) {
	  			x = p2.x;
	  			y = p2.y;
	  		} else if (t > 0) {
	  			x += dx * t;
	  			y += dy * t;
	  		}
	  	}
	
	  	dx = p.x - x;
	  	dy = p.y - y;
	
	  	return sqDist ? dx * dx + dy * dy : new Point(x, y);
	  }
	
	
	  // @function isFlat(latlngs: LatLng[]): Boolean
	  // Returns true if `latlngs` is a flat array, false is nested.
	  function isFlat(latlngs) {
	  	return !isArray(latlngs[0]) || (typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined');
	  }
	
	  function _flat(latlngs) {
	  	console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
	  	return isFlat(latlngs);
	  }
	
	  var LineUtil = ({
	    simplify: simplify,
	    pointToSegmentDistance: pointToSegmentDistance,
	    closestPointOnSegment: closestPointOnSegment,
	    clipSegment: clipSegment,
	    _getEdgeIntersection: _getEdgeIntersection,
	    _getBitCode: _getBitCode,
	    _sqClosestPointOnSegment: _sqClosestPointOnSegment,
	    isFlat: isFlat,
	    _flat: _flat
	  });
	
	  /*
	   * @namespace PolyUtil
	   * Various utility functions for polygon geometries.
	   */
	
	  /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
	   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
	   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
	   * performance. Note that polygon points needs different algorithm for clipping
	   * than polyline, so there's a separate method for it.
	   */
	  function clipPolygon(points, bounds, round) {
	  	var clippedPoints,
	  	    edges = [1, 4, 2, 8],
	  	    i, j, k,
	  	    a, b,
	  	    len, edge, p;
	
	  	for (i = 0, len = points.length; i < len; i++) {
	  		points[i]._code = _getBitCode(points[i], bounds);
	  	}
	
	  	// for each edge (left, bottom, right, top)
	  	for (k = 0; k < 4; k++) {
	  		edge = edges[k];
	  		clippedPoints = [];
	
	  		for (i = 0, len = points.length, j = len - 1; i < len; j = i++) {
	  			a = points[i];
	  			b = points[j];
	
	  			// if a is inside the clip window
	  			if (!(a._code & edge)) {
	  				// if b is outside the clip window (a->b goes out of screen)
	  				if (b._code & edge) {
	  					p = _getEdgeIntersection(b, a, edge, bounds, round);
	  					p._code = _getBitCode(p, bounds);
	  					clippedPoints.push(p);
	  				}
	  				clippedPoints.push(a);
	
	  			// else if b is inside the clip window (a->b enters the screen)
	  			} else if (!(b._code & edge)) {
	  				p = _getEdgeIntersection(b, a, edge, bounds, round);
	  				p._code = _getBitCode(p, bounds);
	  				clippedPoints.push(p);
	  			}
	  		}
	  		points = clippedPoints;
	  	}
	
	  	return points;
	  }
	
	  var PolyUtil = ({
	    clipPolygon: clipPolygon
	  });
	
	  /*
	   * @namespace Projection
	   * @section
	   * Leaflet comes with a set of already defined Projections out of the box:
	   *
	   * @projection L.Projection.LonLat
	   *
	   * Equirectangular, or Plate Carree projection — the most simple projection,
	   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
	   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
	   * `EPSG:4326` and `Simple` CRS.
	   */
	
	  var LonLat = {
	  	project: function (latlng) {
	  		return new Point(latlng.lng, latlng.lat);
	  	},
	
	  	unproject: function (point) {
	  		return new LatLng(point.y, point.x);
	  	},
	
	  	bounds: new Bounds([-180, -90], [180, 90])
	  };
	
	  /*
	   * @namespace Projection
	   * @projection L.Projection.Mercator
	   *
	   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
	   */
	
	  var Mercator = {
	  	R: 6378137,
	  	R_MINOR: 6356752.314245179,
	
	  	bounds: new Bounds([-20037508.34279, -15496570.73972], [20037508.34279, 18764656.23138]),
	
	  	project: function (latlng) {
	  		var d = Math.PI / 180,
	  		    r = this.R,
	  		    y = latlng.lat * d,
	  		    tmp = this.R_MINOR / r,
	  		    e = Math.sqrt(1 - tmp * tmp),
	  		    con = e * Math.sin(y);
	
	  		var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
	  		y = -r * Math.log(Math.max(ts, 1E-10));
	
	  		return new Point(latlng.lng * d * r, y);
	  	},
	
	  	unproject: function (point) {
	  		var d = 180 / Math.PI,
	  		    r = this.R,
	  		    tmp = this.R_MINOR / r,
	  		    e = Math.sqrt(1 - tmp * tmp),
	  		    ts = Math.exp(-point.y / r),
	  		    phi = Math.PI / 2 - 2 * Math.atan(ts);
	
	  		for (var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++) {
	  			con = e * Math.sin(phi);
	  			con = Math.pow((1 - con) / (1 + con), e / 2);
	  			dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
	  			phi += dphi;
	  		}
	
	  		return new LatLng(phi * d, point.x * d / r);
	  	}
	  };
	
	  /*
	   * @class Projection
	
	   * An object with methods for projecting geographical coordinates of the world onto
	   * a flat surface (and back). See [Map projection](http://en.wikipedia.org/wiki/Map_projection).
	
	   * @property bounds: Bounds
	   * The bounds (specified in CRS units) where the projection is valid
	
	   * @method project(latlng: LatLng): Point
	   * Projects geographical coordinates into a 2D point.
	   * Only accepts actual `L.LatLng` instances, not arrays.
	
	   * @method unproject(point: Point): LatLng
	   * The inverse of `project`. Projects a 2D point into a geographical location.
	   * Only accepts actual `L.Point` instances, not arrays.
	
	   * Note that the projection instances do not inherit from Leaflet's `Class` object,
	   * and can't be instantiated. Also, new classes can't inherit from them,
	   * and methods can't be added to them with the `include` function.
	
	   */
	
	  var index = ({
	    LonLat: LonLat,
	    Mercator: Mercator,
	    SphericalMercator: SphericalMercator
	  });
	
	  /*
	   * @namespace CRS
	   * @crs L.CRS.EPSG3395
	   *
	   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
	   */
	  var EPSG3395 = extend({}, Earth, {
	  	code: 'EPSG:3395',
	  	projection: Mercator,
	
	  	transformation: (function () {
	  		var scale = 0.5 / (Math.PI * Mercator.R);
	  		return toTransformation(scale, 0.5, -scale, 0.5);
	  	}())
	  });
	
	  /*
	   * @namespace CRS
	   * @crs L.CRS.EPSG4326
	   *
	   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
	   *
	   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
	   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
	   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
	   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
	   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
	   */
	
	  var EPSG4326 = extend({}, Earth, {
	  	code: 'EPSG:4326',
	  	projection: LonLat,
	  	transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
	  });
	
	  /*
	   * @namespace CRS
	   * @crs L.CRS.Simple
	   *
	   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
	   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
	   * axis should still be inverted (going from bottom to top). `distance()` returns
	   * simple euclidean distance.
	   */
	
	  var Simple = extend({}, CRS, {
	  	projection: LonLat,
	  	transformation: toTransformation(1, 0, -1, 0),
	
	  	scale: function (zoom) {
	  		return Math.pow(2, zoom);
	  	},
	
	  	zoom: function (scale) {
	  		return Math.log(scale) / Math.LN2;
	  	},
	
	  	distance: function (latlng1, latlng2) {
	  		var dx = latlng2.lng - latlng1.lng,
	  		    dy = latlng2.lat - latlng1.lat;
	
	  		return Math.sqrt(dx * dx + dy * dy);
	  	},
	
	  	infinite: true
	  });
	
	  CRS.Earth = Earth;
	  CRS.EPSG3395 = EPSG3395;
	  CRS.EPSG3857 = EPSG3857;
	  CRS.EPSG900913 = EPSG900913;
	  CRS.EPSG4326 = EPSG4326;
	  CRS.Simple = Simple;
	
	  /*
	   * @class Layer
	   * @inherits Evented
	   * @aka L.Layer
	   * @aka ILayer
	   *
	   * A set of methods from the Layer base class that all Leaflet layers use.
	   * Inherits all methods, options and events from `L.Evented`.
	   *
	   * @example
	   *
	   * ```js
	   * var layer = L.marker(latlng).addTo(map);
	   * layer.addTo(map);
	   * layer.remove();
	   * ```
	   *
	   * @event add: Event
	   * Fired after the layer is added to a map
	   *
	   * @event remove: Event
	   * Fired after the layer is removed from a map
	   */
	
	
	  var Layer = Evented.extend({
	
	  	// Classes extending `L.Layer` will inherit the following options:
	  	options: {
	  		// @option pane: String = 'overlayPane'
	  		// By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
	  		pane: 'overlayPane',
	
	  		// @option attribution: String = null
	  		// String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
	  		attribution: null,
	
	  		bubblingMouseEvents: true
	  	},
	
	  	/* @section
	  	 * Classes extending `L.Layer` will inherit the following methods:
	  	 *
	  	 * @method addTo(map: Map|LayerGroup): this
	  	 * Adds the layer to the given map or layer group.
	  	 */
	  	addTo: function (map) {
	  		map.addLayer(this);
	  		return this;
	  	},
	
	  	// @method remove: this
	  	// Removes the layer from the map it is currently active on.
	  	remove: function () {
	  		return this.removeFrom(this._map || this._mapToAdd);
	  	},
	
	  	// @method removeFrom(map: Map): this
	  	// Removes the layer from the given map
	  	//
	  	// @alternative
	  	// @method removeFrom(group: LayerGroup): this
	  	// Removes the layer from the given `LayerGroup`
	  	removeFrom: function (obj) {
	  		if (obj) {
	  			obj.removeLayer(this);
	  		}
	  		return this;
	  	},
	
	  	// @method getPane(name? : String): HTMLElement
	  	// Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
	  	getPane: function (name) {
	  		return this._map.getPane(name ? (this.options[name] || name) : this.options.pane);
	  	},
	
	  	addInteractiveTarget: function (targetEl) {
	  		this._map._targets[stamp(targetEl)] = this;
	  		return this;
	  	},
	
	  	removeInteractiveTarget: function (targetEl) {
	  		delete this._map._targets[stamp(targetEl)];
	  		return this;
	  	},
	
	  	// @method getAttribution: String
	  	// Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
	  	getAttribution: function () {
	  		return this.options.attribution;
	  	},
	
	  	_layerAdd: function (e) {
	  		var map = e.target;
	
	  		// check in case layer gets added and then removed before the map is ready
	  		if (!map.hasLayer(this)) { return; }
	
	  		this._map = map;
	  		this._zoomAnimated = map._zoomAnimated;
	
	  		if (this.getEvents) {
	  			var events = this.getEvents();
	  			map.on(events, this);
	  			this.once('remove', function () {
	  				map.off(events, this);
	  			}, this);
	  		}
	
	  		this.onAdd(map);
	
	  		if (this.getAttribution && map.attributionControl) {
	  			map.attributionControl.addAttribution(this.getAttribution());
	  		}
	
	  		this.fire('add');
	  		map.fire('layeradd', {layer: this});
	  	}
	  });
	
	  /* @section Extension methods
	   * @uninheritable
	   *
	   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
	   *
	   * @method onAdd(map: Map): this
	   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
	   *
	   * @method onRemove(map: Map): this
	   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
	   *
	   * @method getEvents(): Object
	   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
	   *
	   * @method getAttribution(): String
	   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
	   *
	   * @method beforeAdd(map: Map): this
	   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
	   */
	
	
	  /* @namespace Map
	   * @section Layer events
	   *
	   * @event layeradd: LayerEvent
	   * Fired when a new layer is added to the map.
	   *
	   * @event layerremove: LayerEvent
	   * Fired when some layer is removed from the map
	   *
	   * @section Methods for Layers and Controls
	   */
	  Map.include({
	  	// @method addLayer(layer: Layer): this
	  	// Adds the given layer to the map
	  	addLayer: function (layer) {
	  		if (!layer._layerAdd) {
	  			throw new Error('The provided object is not a Layer.');
	  		}
	
	  		var id = stamp(layer);
	  		if (this._layers[id]) { return this; }
	  		this._layers[id] = layer;
	
	  		layer._mapToAdd = this;
	
	  		if (layer.beforeAdd) {
	  			layer.beforeAdd(this);
	  		}
	
	  		this.whenReady(layer._layerAdd, layer);
	
	  		return this;
	  	},
	
	  	// @method removeLayer(layer: Layer): this
	  	// Removes the given layer from the map.
	  	removeLayer: function (layer) {
	  		var id = stamp(layer);
	
	  		if (!this._layers[id]) { return this; }
	
	  		if (this._loaded) {
	  			layer.onRemove(this);
	  		}
	
	  		if (layer.getAttribution && this.attributionControl) {
	  			this.attributionControl.removeAttribution(layer.getAttribution());
	  		}
	
	  		delete this._layers[id];
	
	  		if (this._loaded) {
	  			this.fire('layerremove', {layer: layer});
	  			layer.fire('remove');
	  		}
	
	  		layer._map = layer._mapToAdd = null;
	
	  		return this;
	  	},
	
	  	// @method hasLayer(layer: Layer): Boolean
	  	// Returns `true` if the given layer is currently added to the map
	  	hasLayer: function (layer) {
	  		return !!layer && (stamp(layer) in this._layers);
	  	},
	
	  	/* @method eachLayer(fn: Function, context?: Object): this
	  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
	  	 * ```
	  	 * map.eachLayer(function(layer){
	  	 *     layer.bindPopup('Hello');
	  	 * });
	  	 * ```
	  	 */
	  	eachLayer: function (method, context) {
	  		for (var i in this._layers) {
	  			method.call(context, this._layers[i]);
	  		}
	  		return this;
	  	},
	
	  	_addLayers: function (layers) {
	  		layers = layers ? (isArray(layers) ? layers : [layers]) : [];
	
	  		for (var i = 0, len = layers.length; i < len; i++) {
	  			this.addLayer(layers[i]);
	  		}
	  	},
	
	  	_addZoomLimit: function (layer) {
	  		if (isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
	  			this._zoomBoundLayers[stamp(layer)] = layer;
	  			this._updateZoomLevels();
	  		}
	  	},
	
	  	_removeZoomLimit: function (layer) {
	  		var id = stamp(layer);
	
	  		if (this._zoomBoundLayers[id]) {
	  			delete this._zoomBoundLayers[id];
	  			this._updateZoomLevels();
	  		}
	  	},
	
	  	_updateZoomLevels: function () {
	  		var minZoom = Infinity,
	  		    maxZoom = -Infinity,
	  		    oldZoomSpan = this._getZoomSpan();
	
	  		for (var i in this._zoomBoundLayers) {
	  			var options = this._zoomBoundLayers[i].options;
	
	  			minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
	  			maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
	  		}
	
	  		this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
	  		this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
	
	  		// @section Map state change events
	  		// @event zoomlevelschange: Event
	  		// Fired when the number of zoomlevels on the map is changed due
	  		// to adding or removing a layer.
	  		if (oldZoomSpan !== this._getZoomSpan()) {
	  			this.fire('zoomlevelschange');
	  		}
	
	  		if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) {
	  			this.setZoom(this._layersMaxZoom);
	  		}
	  		if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) {
	  			this.setZoom(this._layersMinZoom);
	  		}
	  	}
	  });
	
	  /*
	   * @class LayerGroup
	   * @aka L.LayerGroup
	   * @inherits Layer
	   *
	   * Used to group several layers and handle them as one. If you add it to the map,
	   * any layers added or removed from the group will be added/removed on the map as
	   * well. Extends `Layer`.
	   *
	   * @example
	   *
	   * ```js
	   * L.layerGroup([marker1, marker2])
	   * 	.addLayer(polyline)
	   * 	.addTo(map);
	   * ```
	   */
	
	  var LayerGroup = Layer.extend({
	
	  	initialize: function (layers, options) {
	  		setOptions(this, options);
	
	  		this._layers = {};
	
	  		var i, len;
	
	  		if (layers) {
	  			for (i = 0, len = layers.length; i < len; i++) {
	  				this.addLayer(layers[i]);
	  			}
	  		}
	  	},
	
	  	// @method addLayer(layer: Layer): this
	  	// Adds the given layer to the group.
	  	addLayer: function (layer) {
	  		var id = this.getLayerId(layer);
	
	  		this._layers[id] = layer;
	
	  		if (this._map) {
	  			this._map.addLayer(layer);
	  		}
	
	  		return this;
	  	},
	
	  	// @method removeLayer(layer: Layer): this
	  	// Removes the given layer from the group.
	  	// @alternative
	  	// @method removeLayer(id: Number): this
	  	// Removes the layer with the given internal ID from the group.
	  	removeLayer: function (layer) {
	  		var id = layer in this._layers ? layer : this.getLayerId(layer);
	
	  		if (this._map && this._layers[id]) {
	  			this._map.removeLayer(this._layers[id]);
	  		}
	
	  		delete this._layers[id];
	
	  		return this;
	  	},
	
	  	// @method hasLayer(layer: Layer): Boolean
	  	// Returns `true` if the given layer is currently added to the group.
	  	// @alternative
	  	// @method hasLayer(id: Number): Boolean
	  	// Returns `true` if the given internal ID is currently added to the group.
	  	hasLayer: function (layer) {
	  		if (!layer) { return false; }
	  		var layerId = typeof layer === 'number' ? layer : this.getLayerId(layer);
	  		return layerId in this._layers;
	  	},
	
	  	// @method clearLayers(): this
	  	// Removes all the layers from the group.
	  	clearLayers: function () {
	  		return this.eachLayer(this.removeLayer, this);
	  	},
	
	  	// @method invoke(methodName: String, …): this
	  	// Calls `methodName` on every layer contained in this group, passing any
	  	// additional parameters. Has no effect if the layers contained do not
	  	// implement `methodName`.
	  	invoke: function (methodName) {
	  		var args = Array.prototype.slice.call(arguments, 1),
	  		    i, layer;
	
	  		for (i in this._layers) {
	  			layer = this._layers[i];
	
	  			if (layer[methodName]) {
	  				layer[methodName].apply(layer, args);
	  			}
	  		}
	
	  		return this;
	  	},
	
	  	onAdd: function (map) {
	  		this.eachLayer(map.addLayer, map);
	  	},
	
	  	onRemove: function (map) {
	  		this.eachLayer(map.removeLayer, map);
	  	},
	
	  	// @method eachLayer(fn: Function, context?: Object): this
	  	// Iterates over the layers of the group, optionally specifying context of the iterator function.
	  	// ```js
	  	// group.eachLayer(function (layer) {
	  	// 	layer.bindPopup('Hello');
	  	// });
	  	// ```
	  	eachLayer: function (method, context) {
	  		for (var i in this._layers) {
	  			method.call(context, this._layers[i]);
	  		}
	  		return this;
	  	},
	
	  	// @method getLayer(id: Number): Layer
	  	// Returns the layer with the given internal ID.
	  	getLayer: function (id) {
	  		return this._layers[id];
	  	},
	
	  	// @method getLayers(): Layer[]
	  	// Returns an array of all the layers added to the group.
	  	getLayers: function () {
	  		var layers = [];
	  		this.eachLayer(layers.push, layers);
	  		return layers;
	  	},
	
	  	// @method setZIndex(zIndex: Number): this
	  	// Calls `setZIndex` on every layer contained in this group, passing the z-index.
	  	setZIndex: function (zIndex) {
	  		return this.invoke('setZIndex', zIndex);
	  	},
	
	  	// @method getLayerId(layer: Layer): Number
	  	// Returns the internal ID for a layer
	  	getLayerId: function (layer) {
	  		return stamp(layer);
	  	}
	  });
	
	
	  // @factory L.layerGroup(layers?: Layer[], options?: Object)
	  // Create a layer group, optionally given an initial set of layers and an `options` object.
	  var layerGroup = function (layers, options) {
	  	return new LayerGroup(layers, options);
	  };
	
	  /*
	   * @class FeatureGroup
	   * @aka L.FeatureGroup
	   * @inherits LayerGroup
	   *
	   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
	   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
	   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
	   * handler, it will handle events from any of the layers. This includes mouse events
	   * and custom events.
	   *  * Has `layeradd` and `layerremove` events
	   *
	   * @example
	   *
	   * ```js
	   * L.featureGroup([marker1, marker2, polyline])
	   * 	.bindPopup('Hello world!')
	   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
	   * 	.addTo(map);
	   * ```
	   */
	
	  var FeatureGroup = LayerGroup.extend({
	
	  	addLayer: function (layer) {
	  		if (this.hasLayer(layer)) {
	  			return this;
	  		}
	
	  		layer.addEventParent(this);
	
	  		LayerGroup.prototype.addLayer.call(this, layer);
	
	  		// @event layeradd: LayerEvent
	  		// Fired when a layer is added to this `FeatureGroup`
	  		return this.fire('layeradd', {layer: layer});
	  	},
	
	  	removeLayer: function (layer) {
	  		if (!this.hasLayer(layer)) {
	  			return this;
	  		}
	  		if (layer in this._layers) {
	  			layer = this._layers[layer];
	  		}
	
	  		layer.removeEventParent(this);
	
	  		LayerGroup.prototype.removeLayer.call(this, layer);
	
	  		// @event layerremove: LayerEvent
	  		// Fired when a layer is removed from this `FeatureGroup`
	  		return this.fire('layerremove', {layer: layer});
	  	},
	
	  	// @method setStyle(style: Path options): this
	  	// Sets the given path options to each layer of the group that has a `setStyle` method.
	  	setStyle: function (style) {
	  		return this.invoke('setStyle', style);
	  	},
	
	  	// @method bringToFront(): this
	  	// Brings the layer group to the top of all other layers
	  	bringToFront: function () {
	  		return this.invoke('bringToFront');
	  	},
	
	  	// @method bringToBack(): this
	  	// Brings the layer group to the back of all other layers
	  	bringToBack: function () {
	  		return this.invoke('bringToBack');
	  	},
	
	  	// @method getBounds(): LatLngBounds
	  	// Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
	  	getBounds: function () {
	  		var bounds = new LatLngBounds();
	
	  		for (var id in this._layers) {
	  			var layer = this._layers[id];
	  			bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
	  		}
	  		return bounds;
	  	}
	  });
	
	  // @factory L.featureGroup(layers?: Layer[], options?: Object)
	  // Create a feature group, optionally given an initial set of layers and an `options` object.
	  var featureGroup = function (layers, options) {
	  	return new FeatureGroup(layers, options);
	  };
	
	  /*
	   * @class Icon
	   * @aka L.Icon
	   *
	   * Represents an icon to provide when creating a marker.
	   *
	   * @example
	   *
	   * ```js
	   * var myIcon = L.icon({
	   *     iconUrl: 'my-icon.png',
	   *     iconRetinaUrl: 'my-icon@2x.png',
	   *     iconSize: [38, 95],
	   *     iconAnchor: [22, 94],
	   *     popupAnchor: [-3, -76],
	   *     shadowUrl: 'my-icon-shadow.png',
	   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
	   *     shadowSize: [68, 95],
	   *     shadowAnchor: [22, 94]
	   * });
	   *
	   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
	   * ```
	   *
	   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
	   *
	   */
	
	  var Icon = Class.extend({
	
	  	/* @section
	  	 * @aka Icon options
	  	 *
	  	 * @option iconUrl: String = null
	  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
	  	 *
	  	 * @option iconRetinaUrl: String = null
	  	 * The URL to a retina sized version of the icon image (absolute or relative to your
	  	 * script path). Used for Retina screen devices.
	  	 *
	  	 * @option iconSize: Point = null
	  	 * Size of the icon image in pixels.
	  	 *
	  	 * @option iconAnchor: Point = null
	  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
	  	 * will be aligned so that this point is at the marker's geographical location. Centered
	  	 * by default if size is specified, also can be set in CSS with negative margins.
	  	 *
	  	 * @option popupAnchor: Point = [0, 0]
	  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
	  	 *
	  	 * @option tooltipAnchor: Point = [0, 0]
	  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
	  	 *
	  	 * @option shadowUrl: String = null
	  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
	  	 *
	  	 * @option shadowRetinaUrl: String = null
	  	 *
	  	 * @option shadowSize: Point = null
	  	 * Size of the shadow image in pixels.
	  	 *
	  	 * @option shadowAnchor: Point = null
	  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
	  	 * as iconAnchor if not specified).
	  	 *
	  	 * @option className: String = ''
	  	 * A custom class name to assign to both icon and shadow images. Empty by default.
	  	 */
	
	  	options: {
	  		popupAnchor: [0, 0],
	  		tooltipAnchor: [0, 0]
	  	},
	
	  	initialize: function (options) {
	  		setOptions(this, options);
	  	},
	
	  	// @method createIcon(oldIcon?: HTMLElement): HTMLElement
	  	// Called internally when the icon has to be shown, returns a `<img>` HTML element
	  	// styled according to the options.
	  	createIcon: function (oldIcon) {
	  		return this._createIcon('icon', oldIcon);
	  	},
	
	  	// @method createShadow(oldIcon?: HTMLElement): HTMLElement
	  	// As `createIcon`, but for the shadow beneath it.
	  	createShadow: function (oldIcon) {
	  		return this._createIcon('shadow', oldIcon);
	  	},
	
	  	_createIcon: function (name, oldIcon) {
	  		var src = this._getIconUrl(name);
	
	  		if (!src) {
	  			if (name === 'icon') {
	  				throw new Error('iconUrl not set in Icon options (see the docs).');
	  			}
	  			return null;
	  		}
	
	  		var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
	  		this._setIconStyles(img, name);
	
	  		return img;
	  	},
	
	  	_setIconStyles: function (img, name) {
	  		var options = this.options;
	  		var sizeOption = options[name + 'Size'];
	
	  		if (typeof sizeOption === 'number') {
	  			sizeOption = [sizeOption, sizeOption];
	  		}
	
	  		var size = toPoint(sizeOption),
	  		    anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor ||
	  		            size && size.divideBy(2, true));
	
	  		img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
	
	  		if (anchor) {
	  			img.style.marginLeft = (-anchor.x) + 'px';
	  			img.style.marginTop  = (-anchor.y) + 'px';
	  		}
	
	  		if (size) {
	  			img.style.width  = size.x + 'px';
	  			img.style.height = size.y + 'px';
	  		}
	  	},
	
	  	_createImg: function (src, el) {
	  		el = el || document.createElement('img');
	  		el.src = src;
	  		return el;
	  	},
	
	  	_getIconUrl: function (name) {
	  		return retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
	  	}
	  });
	
	
	  // @factory L.icon(options: Icon options)
	  // Creates an icon instance with the given options.
	  function icon(options) {
	  	return new Icon(options);
	  }
	
	  /*
	   * @miniclass Icon.Default (Icon)
	   * @aka L.Icon.Default
	   * @section
	   *
	   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
	   * no icon is specified. Points to the blue marker image distributed with Leaflet
	   * releases.
	   *
	   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
	   * (which is a set of `Icon options`).
	   *
	   * If you want to _completely_ replace the default icon, override the
	   * `L.Marker.prototype.options.icon` with your own icon instead.
	   */
	
	  var IconDefault = Icon.extend({
	
	  	options: {
	  		iconUrl:       'marker-icon.png',
	  		iconRetinaUrl: 'marker-icon-2x.png',
	  		shadowUrl:     'marker-shadow.png',
	  		iconSize:    [25, 41],
	  		iconAnchor:  [12, 41],
	  		popupAnchor: [1, -34],
	  		tooltipAnchor: [16, -28],
	  		shadowSize:  [41, 41]
	  	},
	
	  	_getIconUrl: function (name) {
	  		if (!IconDefault.imagePath) {	// Deprecated, backwards-compatibility only
	  			IconDefault.imagePath = this._detectIconPath();
	  		}
	
	  		// @option imagePath: String
	  		// `Icon.Default` will try to auto-detect the location of the
	  		// blue icon images. If you are placing these images in a non-standard
	  		// way, set this option to point to the right path.
	  		return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
	  	},
	
	  	_detectIconPath: function () {
	  		var el = create$1('div',  'leaflet-default-icon-path', document.body);
	  		var path = getStyle(el, 'background-image') ||
	  		           getStyle(el, 'backgroundImage');	// IE8
	
	  		document.body.removeChild(el);
	
	  		if (path === null || path.indexOf('url') !== 0) {
	  			path = '';
	  		} else {
	  			path = path.replace(/^url\(["']?/, '').replace(/marker-icon\.png["']?\)$/, '');
	  		}
	
	  		return path;
	  	}
	  });
	
	  /*
	   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
	   */
	
	
	  /* @namespace Marker
	   * @section Interaction handlers
	   *
	   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
	   *
	   * ```js
	   * marker.dragging.disable();
	   * ```
	   *
	   * @property dragging: Handler
	   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
	   */
	
	  var MarkerDrag = Handler.extend({
	  	initialize: function (marker) {
	  		this._marker = marker;
	  	},
	
	  	addHooks: function () {
	  		var icon = this._marker._icon;
	
	  		if (!this._draggable) {
	  			this._draggable = new Draggable(icon, icon, true);
	  		}
	
	  		this._draggable.on({
	  			dragstart: this._onDragStart,
	  			predrag: this._onPreDrag,
	  			drag: this._onDrag,
	  			dragend: this._onDragEnd
	  		}, this).enable();
	
	  		addClass(icon, 'leaflet-marker-draggable');
	  	},
	
	  	removeHooks: function () {
	  		this._draggable.off({
	  			dragstart: this._onDragStart,
	  			predrag: this._onPreDrag,
	  			drag: this._onDrag,
	  			dragend: this._onDragEnd
	  		}, this).disable();
	
	  		if (this._marker._icon) {
	  			removeClass(this._marker._icon, 'leaflet-marker-draggable');
	  		}
	  	},
	
	  	moved: function () {
	  		return this._draggable && this._draggable._moved;
	  	},
	
	  	_adjustPan: function (e) {
	  		var marker = this._marker,
	  		    map = marker._map,
	  		    speed = this._marker.options.autoPanSpeed,
	  		    padding = this._marker.options.autoPanPadding,
	  		    iconPos = getPosition(marker._icon),
	  		    bounds = map.getPixelBounds(),
	  		    origin = map.getPixelOrigin();
	
	  		var panBounds = toBounds(
	  			bounds.min._subtract(origin).add(padding),
	  			bounds.max._subtract(origin).subtract(padding)
	  		);
	
	  		if (!panBounds.contains(iconPos)) {
	  			// Compute incremental movement
	  			var movement = toPoint(
	  				(Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) -
	  				(Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x),
	
	  				(Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) -
	  				(Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)
	  			).multiplyBy(speed);
	
	  			map.panBy(movement, {animate: false});
	
	  			this._draggable._newPos._add(movement);
	  			this._draggable._startPos._add(movement);
	
	  			setPosition(marker._icon, this._draggable._newPos);
	  			this._onDrag(e);
	
	  			this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
	  		}
	  	},
	
	  	_onDragStart: function () {
	  		// @section Dragging events
	  		// @event dragstart: Event
	  		// Fired when the user starts dragging the marker.
	
	  		// @event movestart: Event
	  		// Fired when the marker starts moving (because of dragging).
	
	  		this._oldLatLng = this._marker.getLatLng();
	
	  		// When using ES6 imports it could not be set when `Popup` was not imported as well
	  		this._marker.closePopup && this._marker.closePopup();
	
	  		this._marker
	  			.fire('movestart')
	  			.fire('dragstart');
	  	},
	
	  	_onPreDrag: function (e) {
	  		if (this._marker.options.autoPan) {
	  			cancelAnimFrame(this._panRequest);
	  			this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
	  		}
	  	},
	
	  	_onDrag: function (e) {
	  		var marker = this._marker,
	  		    shadow = marker._shadow,
	  		    iconPos = getPosition(marker._icon),
	  		    latlng = marker._map.layerPointToLatLng(iconPos);
	
	  		// update shadow position
	  		if (shadow) {
	  			setPosition(shadow, iconPos);
	  		}
	
	  		marker._latlng = latlng;
	  		e.latlng = latlng;
	  		e.oldLatLng = this._oldLatLng;
	
	  		// @event drag: Event
	  		// Fired repeatedly while the user drags the marker.
	  		marker
	  		    .fire('move', e)
	  		    .fire('drag', e);
	  	},
	
	  	_onDragEnd: function (e) {
	  		// @event dragend: DragEndEvent
	  		// Fired when the user stops dragging the marker.
	
	  		 cancelAnimFrame(this._panRequest);
	
	  		// @event moveend: Event
	  		// Fired when the marker stops moving (because of dragging).
	  		delete this._oldLatLng;
	  		this._marker
	  		    .fire('moveend')
	  		    .fire('dragend', e);
	  	}
	  });
	
	  /*
	   * @class Marker
	   * @inherits Interactive layer
	   * @aka L.Marker
	   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
	   *
	   * @example
	   *
	   * ```js
	   * L.marker([50.5, 30.5]).addTo(map);
	   * ```
	   */
	
	  var Marker = Layer.extend({
	
	  	// @section
	  	// @aka Marker options
	  	options: {
	  		// @option icon: Icon = *
	  		// Icon instance to use for rendering the marker.
	  		// See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
	  		// If not specified, a common instance of `L.Icon.Default` is used.
	  		icon: new IconDefault(),
	
	  		// Option inherited from "Interactive layer" abstract class
	  		interactive: true,
	
	  		// @option keyboard: Boolean = true
	  		// Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
	  		keyboard: true,
	
	  		// @option title: String = ''
	  		// Text for the browser tooltip that appear on marker hover (no tooltip by default).
	  		title: '',
	
	  		// @option alt: String = ''
	  		// Text for the `alt` attribute of the icon image (useful for accessibility).
	  		alt: '',
	
	  		// @option zIndexOffset: Number = 0
	  		// By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
	  		zIndexOffset: 0,
	
	  		// @option opacity: Number = 1.0
	  		// The opacity of the marker.
	  		opacity: 1,
	
	  		// @option riseOnHover: Boolean = false
	  		// If `true`, the marker will get on top of others when you hover the mouse over it.
	  		riseOnHover: false,
	
	  		// @option riseOffset: Number = 250
	  		// The z-index offset used for the `riseOnHover` feature.
	  		riseOffset: 250,
	
	  		// @option pane: String = 'markerPane'
	  		// `Map pane` where the markers icon will be added.
	  		pane: 'markerPane',
	
	  		// @option shadowPane: String = 'shadowPane'
	  		// `Map pane` where the markers shadow will be added.
	  		shadowPane: 'shadowPane',
	
	  		// @option bubblingMouseEvents: Boolean = false
	  		// When `true`, a mouse event on this marker will trigger the same event on the map
	  		// (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
	  		bubblingMouseEvents: false,
	
	  		// @section Draggable marker options
	  		// @option draggable: Boolean = false
	  		// Whether the marker is draggable with mouse/touch or not.
	  		draggable: false,
	
	  		// @option autoPan: Boolean = false
	  		// Whether to pan the map when dragging this marker near its edge or not.
	  		autoPan: false,
	
	  		// @option autoPanPadding: Point = Point(50, 50)
	  		// Distance (in pixels to the left/right and to the top/bottom) of the
	  		// map edge to start panning the map.
	  		autoPanPadding: [50, 50],
	
	  		// @option autoPanSpeed: Number = 10
	  		// Number of pixels the map should pan by.
	  		autoPanSpeed: 10
	  	},
	
	  	/* @section
	  	 *
	  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
	  	 */
	
	  	initialize: function (latlng, options) {
	  		setOptions(this, options);
	  		this._latlng = toLatLng(latlng);
	  	},
	
	  	onAdd: function (map) {
	  		this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
	
	  		if (this._zoomAnimated) {
	  			map.on('zoomanim', this._animateZoom, this);
	  		}
	
	  		this._initIcon();
	  		this.update();
	  	},
	
	  	onRemove: function (map) {
	  		if (this.dragging && this.dragging.enabled()) {
	  			this.options.draggable = true;
	  			this.dragging.removeHooks();
	  		}
	  		delete this.dragging;
	
	  		if (this._zoomAnimated) {
	  			map.off('zoomanim', this._animateZoom, this);
	  		}
	
	  		this._removeIcon();
	  		this._removeShadow();
	  	},
	
	  	getEvents: function () {
	  		return {
	  			zoom: this.update,
	  			viewreset: this.update
	  		};
	  	},
	
	  	// @method getLatLng: LatLng
	  	// Returns the current geographical position of the marker.
	  	getLatLng: function () {
	  		return this._latlng;
	  	},
	
	  	// @method setLatLng(latlng: LatLng): this
	  	// Changes the marker position to the given point.
	  	setLatLng: function (latlng) {
	  		var oldLatLng = this._latlng;
	  		this._latlng = toLatLng(latlng);
	  		this.update();
	
	  		// @event move: Event
	  		// Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
	  		return this.fire('move', {oldLatLng: oldLatLng, latlng: this._latlng});
	  	},
	
	  	// @method setZIndexOffset(offset: Number): this
	  	// Changes the [zIndex offset](#marker-zindexoffset) of the marker.
	  	setZIndexOffset: function (offset) {
	  		this.options.zIndexOffset = offset;
	  		return this.update();
	  	},
	
	  	// @method getIcon: Icon
	  	// Returns the current icon used by the marker
	  	getIcon: function () {
	  		return this.options.icon;
	  	},
	
	  	// @method setIcon(icon: Icon): this
	  	// Changes the marker icon.
	  	setIcon: function (icon) {
	
	  		this.options.icon = icon;
	
	  		if (this._map) {
	  			this._initIcon();
	  			this.update();
	  		}
	
	  		if (this._popup) {
	  			this.bindPopup(this._popup, this._popup.options);
	  		}
	
	  		return this;
	  	},
	
	  	getElement: function () {
	  		return this._icon;
	  	},
	
	  	update: function () {
	
	  		if (this._icon && this._map) {
	  			var pos = this._map.latLngToLayerPoint(this._latlng).round();
	  			this._setPos(pos);
	  		}
	
	  		return this;
	  	},
	
	  	_initIcon: function () {
	  		var options = this.options,
	  		    classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
	
	  		var icon = options.icon.createIcon(this._icon),
	  		    addIcon = false;
	
	  		// if we're not reusing the icon, remove the old one and init new one
	  		if (icon !== this._icon) {
	  			if (this._icon) {
	  				this._removeIcon();
	  			}
	  			addIcon = true;
	
	  			if (options.title) {
	  				icon.title = options.title;
	  			}
	
	  			if (icon.tagName === 'IMG') {
	  				icon.alt = options.alt || '';
	  			}
	  		}
	
	  		addClass(icon, classToAdd);
	
	  		if (options.keyboard) {
	  			icon.tabIndex = '0';
	  		}
	
	  		this._icon = icon;
	
	  		if (options.riseOnHover) {
	  			this.on({
	  				mouseover: this._bringToFront,
	  				mouseout: this._resetZIndex
	  			});
	  		}
	
	  		var newShadow = options.icon.createShadow(this._shadow),
	  		    addShadow = false;
	
	  		if (newShadow !== this._shadow) {
	  			this._removeShadow();
	  			addShadow = true;
	  		}
	
	  		if (newShadow) {
	  			addClass(newShadow, classToAdd);
	  			newShadow.alt = '';
	  		}
	  		this._shadow = newShadow;
	
	
	  		if (options.opacity < 1) {
	  			this._updateOpacity();
	  		}
	
	
	  		if (addIcon) {
	  			this.getPane().appendChild(this._icon);
	  		}
	  		this._initInteraction();
	  		if (newShadow && addShadow) {
	  			this.getPane(options.shadowPane).appendChild(this._shadow);
	  		}
	  	},
	
	  	_removeIcon: function () {
	  		if (this.options.riseOnHover) {
	  			this.off({
	  				mouseover: this._bringToFront,
	  				mouseout: this._resetZIndex
	  			});
	  		}
	
	  		remove(this._icon);
	  		this.removeInteractiveTarget(this._icon);
	
	  		this._icon = null;
	  	},
	
	  	_removeShadow: function () {
	  		if (this._shadow) {
	  			remove(this._shadow);
	  		}
	  		this._shadow = null;
	  	},
	
	  	_setPos: function (pos) {
	
	  		if (this._icon) {
	  			setPosition(this._icon, pos);
	  		}
	
	  		if (this._shadow) {
	  			setPosition(this._shadow, pos);
	  		}
	
	  		this._zIndex = pos.y + this.options.zIndexOffset;
	
	  		this._resetZIndex();
	  	},
	
	  	_updateZIndex: function (offset) {
	  		if (this._icon) {
	  			this._icon.style.zIndex = this._zIndex + offset;
	  		}
	  	},
	
	  	_animateZoom: function (opt) {
	  		var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
	
	  		this._setPos(pos);
	  	},
	
	  	_initInteraction: function () {
	
	  		if (!this.options.interactive) { return; }
	
	  		addClass(this._icon, 'leaflet-interactive');
	
	  		this.addInteractiveTarget(this._icon);
	
	  		if (MarkerDrag) {
	  			var draggable = this.options.draggable;
	  			if (this.dragging) {
	  				draggable = this.dragging.enabled();
	  				this.dragging.disable();
	  			}
	
	  			this.dragging = new MarkerDrag(this);
	
	  			if (draggable) {
	  				this.dragging.enable();
	  			}
	  		}
	  	},
	
	  	// @method setOpacity(opacity: Number): this
	  	// Changes the opacity of the marker.
	  	setOpacity: function (opacity) {
	  		this.options.opacity = opacity;
	  		if (this._map) {
	  			this._updateOpacity();
	  		}
	
	  		return this;
	  	},
	
	  	_updateOpacity: function () {
	  		var opacity = this.options.opacity;
	
	  		if (this._icon) {
	  			setOpacity(this._icon, opacity);
	  		}
	
	  		if (this._shadow) {
	  			setOpacity(this._shadow, opacity);
	  		}
	  	},
	
	  	_bringToFront: function () {
	  		this._updateZIndex(this.options.riseOffset);
	  	},
	
	  	_resetZIndex: function () {
	  		this._updateZIndex(0);
	  	},
	
	  	_getPopupAnchor: function () {
	  		return this.options.icon.options.popupAnchor;
	  	},
	
	  	_getTooltipAnchor: function () {
	  		return this.options.icon.options.tooltipAnchor;
	  	}
	  });
	
	
	  // factory L.marker(latlng: LatLng, options? : Marker options)
	
	  // @factory L.marker(latlng: LatLng, options? : Marker options)
	  // Instantiates a Marker object given a geographical point and optionally an options object.
	  function marker(latlng, options) {
	  	return new Marker(latlng, options);
	  }
	
	  /*
	   * @class Path
	   * @aka L.Path
	   * @inherits Interactive layer
	   *
	   * An abstract class that contains options and constants shared between vector
	   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
	   */
	
	  var Path = Layer.extend({
	
	  	// @section
	  	// @aka Path options
	  	options: {
	  		// @option stroke: Boolean = true
	  		// Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
	  		stroke: true,
	
	  		// @option color: String = '#3388ff'
	  		// Stroke color
	  		color: '#3388ff',
	
	  		// @option weight: Number = 3
	  		// Stroke width in pixels
	  		weight: 3,
	
	  		// @option opacity: Number = 1.0
	  		// Stroke opacity
	  		opacity: 1,
	
	  		// @option lineCap: String= 'round'
	  		// A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
	  		lineCap: 'round',
	
	  		// @option lineJoin: String = 'round'
	  		// A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
	  		lineJoin: 'round',
	
	  		// @option dashArray: String = null
	  		// A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
	  		dashArray: null,
	
	  		// @option dashOffset: String = null
	  		// A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
	  		dashOffset: null,
	
	  		// @option fill: Boolean = depends
	  		// Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
	  		fill: false,
	
	  		// @option fillColor: String = *
	  		// Fill color. Defaults to the value of the [`color`](#path-color) option
	  		fillColor: null,
	
	  		// @option fillOpacity: Number = 0.2
	  		// Fill opacity.
	  		fillOpacity: 0.2,
	
	  		// @option fillRule: String = 'evenodd'
	  		// A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
	  		fillRule: 'evenodd',
	
	  		// className: '',
	
	  		// Option inherited from "Interactive layer" abstract class
	  		interactive: true,
	
	  		// @option bubblingMouseEvents: Boolean = true
	  		// When `true`, a mouse event on this path will trigger the same event on the map
	  		// (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
	  		bubblingMouseEvents: true
	  	},
	
	  	beforeAdd: function (map) {
	  		// Renderer is set here because we need to call renderer.getEvents
	  		// before this.getEvents.
	  		this._renderer = map.getRenderer(this);
	  	},
	
	  	onAdd: function () {
	  		this._renderer._initPath(this);
	  		this._reset();
	  		this._renderer._addPath(this);
	  	},
	
	  	onRemove: function () {
	  		this._renderer._removePath(this);
	  	},
	
	  	// @method redraw(): this
	  	// Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
	  	redraw: function () {
	  		if (this._map) {
	  			this._renderer._updatePath(this);
	  		}
	  		return this;
	  	},
	
	  	// @method setStyle(style: Path options): this
	  	// Changes the appearance of a Path based on the options in the `Path options` object.
	  	setStyle: function (style) {
	  		setOptions(this, style);
	  		if (this._renderer) {
	  			this._renderer._updateStyle(this);
	  			if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, 'weight')) {
	  				this._updateBounds();
	  			}
	  		}
	  		return this;
	  	},
	
	  	// @method bringToFront(): this
	  	// Brings the layer to the top of all path layers.
	  	bringToFront: function () {
	  		if (this._renderer) {
	  			this._renderer._bringToFront(this);
	  		}
	  		return this;
	  	},
	
	  	// @method bringToBack(): this
	  	// Brings the layer to the bottom of all path layers.
	  	bringToBack: function () {
	  		if (this._renderer) {
	  			this._renderer._bringToBack(this);
	  		}
	  		return this;
	  	},
	
	  	getElement: function () {
	  		return this._path;
	  	},
	
	  	_reset: function () {
	  		// defined in child classes
	  		this._project();
	  		this._update();
	  	},
	
	  	_clickTolerance: function () {
	  		// used when doing hit detection for Canvas layers
	  		return (this.options.stroke ? this.options.weight / 2 : 0) + this._renderer.options.tolerance;
	  	}
	  });
	
	  /*
	   * @class CircleMarker
	   * @aka L.CircleMarker
	   * @inherits Path
	   *
	   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
	   */
	
	  var CircleMarker = Path.extend({
	
	  	// @section
	  	// @aka CircleMarker options
	  	options: {
	  		fill: true,
	
	  		// @option radius: Number = 10
	  		// Radius of the circle marker, in pixels
	  		radius: 10
	  	},
	
	  	initialize: function (latlng, options) {
	  		setOptions(this, options);
	  		this._latlng = toLatLng(latlng);
	  		this._radius = this.options.radius;
	  	},
	
	  	// @method setLatLng(latLng: LatLng): this
	  	// Sets the position of a circle marker to a new location.
	  	setLatLng: function (latlng) {
	  		var oldLatLng = this._latlng;
	  		this._latlng = toLatLng(latlng);
	  		this.redraw();
	
	  		// @event move: Event
	  		// Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
	  		return this.fire('move', {oldLatLng: oldLatLng, latlng: this._latlng});
	  	},
	
	  	// @method getLatLng(): LatLng
	  	// Returns the current geographical position of the circle marker
	  	getLatLng: function () {
	  		return this._latlng;
	  	},
	
	  	// @method setRadius(radius: Number): this
	  	// Sets the radius of a circle marker. Units are in pixels.
	  	setRadius: function (radius) {
	  		this.options.radius = this._radius = radius;
	  		return this.redraw();
	  	},
	
	  	// @method getRadius(): Number
	  	// Returns the current radius of the circle
	  	getRadius: function () {
	  		return this._radius;
	  	},
	
	  	setStyle : function (options) {
	  		var radius = options && options.radius || this._radius;
	  		Path.prototype.setStyle.call(this, options);
	  		this.setRadius(radius);
	  		return this;
	  	},
	
	  	_project: function () {
	  		this._point = this._map.latLngToLayerPoint(this._latlng);
	  		this._updateBounds();
	  	},
	
	  	_updateBounds: function () {
	  		var r = this._radius,
	  		    r2 = this._radiusY || r,
	  		    w = this._clickTolerance(),
	  		    p = [r + w, r2 + w];
	  		this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
	  	},
	
	  	_update: function () {
	  		if (this._map) {
	  			this._updatePath();
	  		}
	  	},
	
	  	_updatePath: function () {
	  		this._renderer._updateCircle(this);
	  	},
	
	  	_empty: function () {
	  		return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
	  	},
	
	  	// Needed by the `Canvas` renderer for interactivity
	  	_containsPoint: function (p) {
	  		return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
	  	}
	  });
	
	
	  // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
	  // Instantiates a circle marker object given a geographical point, and an optional options object.
	  function circleMarker(latlng, options) {
	  	return new CircleMarker(latlng, options);
	  }
	
	  /*
	   * @class Circle
	   * @aka L.Circle
	   * @inherits CircleMarker
	   *
	   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
	   *
	   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
	   *
	   * @example
	   *
	   * ```js
	   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
	   * ```
	   */
	
	  var Circle = CircleMarker.extend({
	
	  	initialize: function (latlng, options, legacyOptions) {
	  		if (typeof options === 'number') {
	  			// Backwards compatibility with 0.7.x factory (latlng, radius, options?)
	  			options = extend({}, legacyOptions, {radius: options});
	  		}
	  		setOptions(this, options);
	  		this._latlng = toLatLng(latlng);
	
	  		if (isNaN(this.options.radius)) { throw new Error('Circle radius cannot be NaN'); }
	
	  		// @section
	  		// @aka Circle options
	  		// @option radius: Number; Radius of the circle, in meters.
	  		this._mRadius = this.options.radius;
	  	},
	
	  	// @method setRadius(radius: Number): this
	  	// Sets the radius of a circle. Units are in meters.
	  	setRadius: function (radius) {
	  		this._mRadius = radius;
	  		return this.redraw();
	  	},
	
	  	// @method getRadius(): Number
	  	// Returns the current radius of a circle. Units are in meters.
	  	getRadius: function () {
	  		return this._mRadius;
	  	},
	
	  	// @method getBounds(): LatLngBounds
	  	// Returns the `LatLngBounds` of the path.
	  	getBounds: function () {
	  		var half = [this._radius, this._radiusY || this._radius];
	
	  		return new LatLngBounds(
	  			this._map.layerPointToLatLng(this._point.subtract(half)),
	  			this._map.layerPointToLatLng(this._point.add(half)));
	  	},
	
	  	setStyle: Path.prototype.setStyle,
	
	  	_project: function () {
	
	  		var lng = this._latlng.lng,
	  		    lat = this._latlng.lat,
	  		    map = this._map,
	  		    crs = map.options.crs;
	
	  		if (crs.distance === Earth.distance) {
	  			var d = Math.PI / 180,
	  			    latR = (this._mRadius / Earth.R) / d,
	  			    top = map.project([lat + latR, lng]),
	  			    bottom = map.project([lat - latR, lng]),
	  			    p = top.add(bottom).divideBy(2),
	  			    lat2 = map.unproject(p).lat,
	  			    lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) /
	  			            (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
	
	  			if (isNaN(lngR) || lngR === 0) {
	  				lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
	  			}
	
	  			this._point = p.subtract(map.getPixelOrigin());
	  			this._radius = isNaN(lngR) ? 0 : p.x - map.project([lat2, lng - lngR]).x;
	  			this._radiusY = p.y - top.y;
	
	  		} else {
	  			var latlng2 = crs.unproject(crs.project(this._latlng).subtract([this._mRadius, 0]));
	
	  			this._point = map.latLngToLayerPoint(this._latlng);
	  			this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
	  		}
	
	  		this._updateBounds();
	  	}
	  });
	
	  // @factory L.circle(latlng: LatLng, options?: Circle options)
	  // Instantiates a circle object given a geographical point, and an options object
	  // which contains the circle radius.
	  // @alternative
	  // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
	  // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
	  // Do not use in new applications or plugins.
	  function circle(latlng, options, legacyOptions) {
	  	return new Circle(latlng, options, legacyOptions);
	  }
	
	  /*
	   * @class Polyline
	   * @aka L.Polyline
	   * @inherits Path
	   *
	   * A class for drawing polyline overlays on a map. Extends `Path`.
	   *
	   * @example
	   *
	   * ```js
	   * // create a red polyline from an array of LatLng points
	   * var latlngs = [
	   * 	[45.51, -122.68],
	   * 	[37.77, -122.43],
	   * 	[34.04, -118.2]
	   * ];
	   *
	   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
	   *
	   * // zoom the map to the polyline
	   * map.fitBounds(polyline.getBounds());
	   * ```
	   *
	   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
	   *
	   * ```js
	   * // create a red polyline from an array of arrays of LatLng points
	   * var latlngs = [
	   * 	[[45.51, -122.68],
	   * 	 [37.77, -122.43],
	   * 	 [34.04, -118.2]],
	   * 	[[40.78, -73.91],
	   * 	 [41.83, -87.62],
	   * 	 [32.76, -96.72]]
	   * ];
	   * ```
	   */
	
	
	  var Polyline = Path.extend({
	
	  	// @section
	  	// @aka Polyline options
	  	options: {
	  		// @option smoothFactor: Number = 1.0
	  		// How much to simplify the polyline on each zoom level. More means
	  		// better performance and smoother look, and less means more accurate representation.
	  		smoothFactor: 1.0,
	
	  		// @option noClip: Boolean = false
	  		// Disable polyline clipping.
	  		noClip: false
	  	},
	
	  	initialize: function (latlngs, options) {
	  		setOptions(this, options);
	  		this._setLatLngs(latlngs);
	  	},
	
	  	// @method getLatLngs(): LatLng[]
	  	// Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
	  	getLatLngs: function () {
	  		return this._latlngs;
	  	},
	
	  	// @method setLatLngs(latlngs: LatLng[]): this
	  	// Replaces all the points in the polyline with the given array of geographical points.
	  	setLatLngs: function (latlngs) {
	  		this._setLatLngs(latlngs);
	  		return this.redraw();
	  	},
	
	  	// @method isEmpty(): Boolean
	  	// Returns `true` if the Polyline has no LatLngs.
	  	isEmpty: function () {
	  		return !this._latlngs.length;
	  	},
	
	  	// @method closestLayerPoint(p: Point): Point
	  	// Returns the point closest to `p` on the Polyline.
	  	closestLayerPoint: function (p) {
	  		var minDistance = Infinity,
	  		    minPoint = null,
	  		    closest = _sqClosestPointOnSegment,
	  		    p1, p2;
	
	  		for (var j = 0, jLen = this._parts.length; j < jLen; j++) {
	  			var points = this._parts[j];
	
	  			for (var i = 1, len = points.length; i < len; i++) {
	  				p1 = points[i - 1];
	  				p2 = points[i];
	
	  				var sqDist = closest(p, p1, p2, true);
	
	  				if (sqDist < minDistance) {
	  					minDistance = sqDist;
	  					minPoint = closest(p, p1, p2);
	  				}
	  			}
	  		}
	  		if (minPoint) {
	  			minPoint.distance = Math.sqrt(minDistance);
	  		}
	  		return minPoint;
	  	},
	
	  	// @method getCenter(): LatLng
	  	// Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the polyline.
	  	getCenter: function () {
	  		// throws error when not yet added to map as this center calculation requires projected coordinates
	  		if (!this._map) {
	  			throw new Error('Must add layer to map before using getCenter()');
	  		}
	
	  		var i, halfDist, segDist, dist, p1, p2, ratio,
	  		    points = this._rings[0],
	  		    len = points.length;
	
	  		if (!len) { return null; }
	
	  		// polyline centroid algorithm; only uses the first ring if there are multiple
	
	  		for (i = 0, halfDist = 0; i < len - 1; i++) {
	  			halfDist += points[i].distanceTo(points[i + 1]) / 2;
	  		}
	
	  		// The line is so small in the current view that all points are on the same pixel.
	  		if (halfDist === 0) {
	  			return this._map.layerPointToLatLng(points[0]);
	  		}
	
	  		for (i = 0, dist = 0; i < len - 1; i++) {
	  			p1 = points[i];
	  			p2 = points[i + 1];
	  			segDist = p1.distanceTo(p2);
	  			dist += segDist;
	
	  			if (dist > halfDist) {
	  				ratio = (dist - halfDist) / segDist;
	  				return this._map.layerPointToLatLng([
	  					p2.x - ratio * (p2.x - p1.x),
	  					p2.y - ratio * (p2.y - p1.y)
	  				]);
	  			}
	  		}
	  	},
	
	  	// @method getBounds(): LatLngBounds
	  	// Returns the `LatLngBounds` of the path.
	  	getBounds: function () {
	  		return this._bounds;
	  	},
	
	  	// @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
	  	// Adds a given point to the polyline. By default, adds to the first ring of
	  	// the polyline in case of a multi-polyline, but can be overridden by passing
	  	// a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
	  	addLatLng: function (latlng, latlngs) {
	  		latlngs = latlngs || this._defaultShape();
	  		latlng = toLatLng(latlng);
	  		latlngs.push(latlng);
	  		this._bounds.extend(latlng);
	  		return this.redraw();
	  	},
	
	  	_setLatLngs: function (latlngs) {
	  		this._bounds = new LatLngBounds();
	  		this._latlngs = this._convertLatLngs(latlngs);
	  	},
	
	  	_defaultShape: function () {
	  		return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
	  	},
	
	  	// recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
	  	_convertLatLngs: function (latlngs) {
	  		var result = [],
	  		    flat = isFlat(latlngs);
	
	  		for (var i = 0, len = latlngs.length; i < len; i++) {
	  			if (flat) {
	  				result[i] = toLatLng(latlngs[i]);
	  				this._bounds.extend(result[i]);
	  			} else {
	  				result[i] = this._convertLatLngs(latlngs[i]);
	  			}
	  		}
	
	  		return result;
	  	},
	
	  	_project: function () {
	  		var pxBounds = new Bounds();
	  		this._rings = [];
	  		this._projectLatlngs(this._latlngs, this._rings, pxBounds);
	
	  		if (this._bounds.isValid() && pxBounds.isValid()) {
	  			this._rawPxBounds = pxBounds;
	  			this._updateBounds();
	  		}
	  	},
	
	  	_updateBounds: function () {
	  		var w = this._clickTolerance(),
	  		    p = new Point(w, w);
	  		this._pxBounds = new Bounds([
	  			this._rawPxBounds.min.subtract(p),
	  			this._rawPxBounds.max.add(p)
	  		]);
	  	},
	
	  	// recursively turns latlngs into a set of rings with projected coordinates
	  	_projectLatlngs: function (latlngs, result, projectedBounds) {
	  		var flat = latlngs[0] instanceof LatLng,
	  		    len = latlngs.length,
	  		    i, ring;
	
	  		if (flat) {
	  			ring = [];
	  			for (i = 0; i < len; i++) {
	  				ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
	  				projectedBounds.extend(ring[i]);
	  			}
	  			result.push(ring);
	  		} else {
	  			for (i = 0; i < len; i++) {
	  				this._projectLatlngs(latlngs[i], result, projectedBounds);
	  			}
	  		}
	  	},
	
	  	// clip polyline by renderer bounds so that we have less to render for performance
	  	_clipPoints: function () {
	  		var bounds = this._renderer._bounds;
	
	  		this._parts = [];
	  		if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
	  			return;
	  		}
	
	  		if (this.options.noClip) {
	  			this._parts = this._rings;
	  			return;
	  		}
	
	  		var parts = this._parts,
	  		    i, j, k, len, len2, segment, points;
	
	  		for (i = 0, k = 0, len = this._rings.length; i < len; i++) {
	  			points = this._rings[i];
	
	  			for (j = 0, len2 = points.length; j < len2 - 1; j++) {
	  				segment = clipSegment(points[j], points[j + 1], bounds, j, true);
	
	  				if (!segment) { continue; }
	
	  				parts[k] = parts[k] || [];
	  				parts[k].push(segment[0]);
	
	  				// if segment goes out of screen, or it's the last one, it's the end of the line part
	  				if ((segment[1] !== points[j + 1]) || (j === len2 - 2)) {
	  					parts[k].push(segment[1]);
	  					k++;
	  				}
	  			}
	  		}
	  	},
	
	  	// simplify each clipped part of the polyline for performance
	  	_simplifyPoints: function () {
	  		var parts = this._parts,
	  		    tolerance = this.options.smoothFactor;
	
	  		for (var i = 0, len = parts.length; i < len; i++) {
	  			parts[i] = simplify(parts[i], tolerance);
	  		}
	  	},
	
	  	_update: function () {
	  		if (!this._map) { return; }
	
	  		this._clipPoints();
	  		this._simplifyPoints();
	  		this._updatePath();
	  	},
	
	  	_updatePath: function () {
	  		this._renderer._updatePoly(this);
	  	},
	
	  	// Needed by the `Canvas` renderer for interactivity
	  	_containsPoint: function (p, closed) {
	  		var i, j, k, len, len2, part,
	  		    w = this._clickTolerance();
	
	  		if (!this._pxBounds || !this._pxBounds.contains(p)) { return false; }
	
	  		// hit detection for polylines
	  		for (i = 0, len = this._parts.length; i < len; i++) {
	  			part = this._parts[i];
	
	  			for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
	  				if (!closed && (j === 0)) { continue; }
	
	  				if (pointToSegmentDistance(p, part[k], part[j]) <= w) {
	  					return true;
	  				}
	  			}
	  		}
	  		return false;
	  	}
	  });
	
	  // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
	  // Instantiates a polyline object given an array of geographical points and
	  // optionally an options object. You can create a `Polyline` object with
	  // multiple separate lines (`MultiPolyline`) by passing an array of arrays
	  // of geographic points.
	  function polyline(latlngs, options) {
	  	return new Polyline(latlngs, options);
	  }
	
	  // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
	  Polyline._flat = _flat;
	
	  /*
	   * @class Polygon
	   * @aka L.Polygon
	   * @inherits Polyline
	   *
	   * A class for drawing polygon overlays on a map. Extends `Polyline`.
	   *
	   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
	   *
	   *
	   * @example
	   *
	   * ```js
	   * // create a red polygon from an array of LatLng points
	   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
	   *
	   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
	   *
	   * // zoom the map to the polygon
	   * map.fitBounds(polygon.getBounds());
	   * ```
	   *
	   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
	   *
	   * ```js
	   * var latlngs = [
	   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
	   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
	   * ];
	   * ```
	   *
	   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
	   *
	   * ```js
	   * var latlngs = [
	   *   [ // first polygon
	   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
	   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
	   *   ],
	   *   [ // second polygon
	   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
	   *   ]
	   * ];
	   * ```
	   */
	
	  var Polygon = Polyline.extend({
	
	  	options: {
	  		fill: true
	  	},
	
	  	isEmpty: function () {
	  		return !this._latlngs.length || !this._latlngs[0].length;
	  	},
	
	  	getCenter: function () {
	  		// throws error when not yet added to map as this center calculation requires projected coordinates
	  		if (!this._map) {
	  			throw new Error('Must add layer to map before using getCenter()');
	  		}
	
	  		var i, j, p1, p2, f, area, x, y, center,
	  		    points = this._rings[0],
	  		    len = points.length;
	
	  		if (!len) { return null; }
	
	  		// polygon centroid algorithm; only uses the first ring if there are multiple
	
	  		area = x = y = 0;
	
	  		for (i = 0, j = len - 1; i < len; j = i++) {
	  			p1 = points[i];
	  			p2 = points[j];
	
	  			f = p1.y * p2.x - p2.y * p1.x;
	  			x += (p1.x + p2.x) * f;
	  			y += (p1.y + p2.y) * f;
	  			area += f * 3;
	  		}
	
	  		if (area === 0) {
	  			// Polygon is so small that all points are on same pixel.
	  			center = points[0];
	  		} else {
	  			center = [x / area, y / area];
	  		}
	  		return this._map.layerPointToLatLng(center);
	  	},
	
	  	_convertLatLngs: function (latlngs) {
	  		var result = Polyline.prototype._convertLatLngs.call(this, latlngs),
	  		    len = result.length;
	
	  		// remove last point if it equals first one
	  		if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) {
	  			result.pop();
	  		}
	  		return result;
	  	},
	
	  	_setLatLngs: function (latlngs) {
	  		Polyline.prototype._setLatLngs.call(this, latlngs);
	  		if (isFlat(this._latlngs)) {
	  			this._latlngs = [this._latlngs];
	  		}
	  	},
	
	  	_defaultShape: function () {
	  		return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
	  	},
	
	  	_clipPoints: function () {
	  		// polygons need a different clipping algorithm so we redefine that
	
	  		var bounds = this._renderer._bounds,
	  		    w = this.options.weight,
	  		    p = new Point(w, w);
	
	  		// increase clip padding by stroke width to avoid stroke on clip edges
	  		bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
	
	  		this._parts = [];
	  		if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
	  			return;
	  		}
	
	  		if (this.options.noClip) {
	  			this._parts = this._rings;
	  			return;
	  		}
	
	  		for (var i = 0, len = this._rings.length, clipped; i < len; i++) {
	  			clipped = clipPolygon(this._rings[i], bounds, true);
	  			if (clipped.length) {
	  				this._parts.push(clipped);
	  			}
	  		}
	  	},
	
	  	_updatePath: function () {
	  		this._renderer._updatePoly(this, true);
	  	},
	
	  	// Needed by the `Canvas` renderer for interactivity
	  	_containsPoint: function (p) {
	  		var inside = false,
	  		    part, p1, p2, i, j, k, len, len2;
	
	  		if (!this._pxBounds || !this._pxBounds.contains(p)) { return false; }
	
	  		// ray casting algorithm for detecting if point is in polygon
	  		for (i = 0, len = this._parts.length; i < len; i++) {
	  			part = this._parts[i];
	
	  			for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
	  				p1 = part[j];
	  				p2 = part[k];
	
	  				if (((p1.y > p.y) !== (p2.y > p.y)) && (p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x)) {
	  					inside = !inside;
	  				}
	  			}
	  		}
	
	  		// also check if it's on polygon stroke
	  		return inside || Polyline.prototype._containsPoint.call(this, p, true);
	  	}
	
	  });
	
	
	  // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
	  function polygon(latlngs, options) {
	  	return new Polygon(latlngs, options);
	  }
	
	  /*
	   * @class GeoJSON
	   * @aka L.GeoJSON
	   * @inherits FeatureGroup
	   *
	   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
	   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
	   *
	   * @example
	   *
	   * ```js
	   * L.geoJSON(data, {
	   * 	style: function (feature) {
	   * 		return {color: feature.properties.color};
	   * 	}
	   * }).bindPopup(function (layer) {
	   * 	return layer.feature.properties.description;
	   * }).addTo(map);
	   * ```
	   */
	
	  var GeoJSON = FeatureGroup.extend({
	
	  	/* @section
	  	 * @aka GeoJSON options
	  	 *
	  	 * @option pointToLayer: Function = *
	  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
	  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
	  	 * The default is to spawn a default `Marker`:
	  	 * ```js
	  	 * function(geoJsonPoint, latlng) {
	  	 * 	return L.marker(latlng);
	  	 * }
	  	 * ```
	  	 *
	  	 * @option style: Function = *
	  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
	  	 * called internally when data is added.
	  	 * The default value is to not override any defaults:
	  	 * ```js
	  	 * function (geoJsonFeature) {
	  	 * 	return {}
	  	 * }
	  	 * ```
	  	 *
	  	 * @option onEachFeature: Function = *
	  	 * A `Function` that will be called once for each created `Feature`, after it has
	  	 * been created and styled. Useful for attaching events and popups to features.
	  	 * The default is to do nothing with the newly created layers:
	  	 * ```js
	  	 * function (feature, layer) {}
	  	 * ```
	  	 *
	  	 * @option filter: Function = *
	  	 * A `Function` that will be used to decide whether to include a feature or not.
	  	 * The default is to include all features:
	  	 * ```js
	  	 * function (geoJsonFeature) {
	  	 * 	return true;
	  	 * }
	  	 * ```
	  	 * Note: dynamically changing the `filter` option will have effect only on newly
	  	 * added data. It will _not_ re-evaluate already included features.
	  	 *
	  	 * @option coordsToLatLng: Function = *
	  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
	  	 * The default is the `coordsToLatLng` static method.
	  	 *
	  	 * @option markersInheritOptions: Boolean = false
	  	 * Whether default Markers for "Point" type Features inherit from group options.
	  	 */
	
	  	initialize: function (geojson, options) {
	  		setOptions(this, options);
	
	  		this._layers = {};
	
	  		if (geojson) {
	  			this.addData(geojson);
	  		}
	  	},
	
	  	// @method addData( <GeoJSON> data ): this
	  	// Adds a GeoJSON object to the layer.
	  	addData: function (geojson) {
	  		var features = isArray(geojson) ? geojson : geojson.features,
	  		    i, len, feature;
	
	  		if (features) {
	  			for (i = 0, len = features.length; i < len; i++) {
	  				// only add this if geometry or geometries are set and not null
	  				feature = features[i];
	  				if (feature.geometries || feature.geometry || feature.features || feature.coordinates) {
	  					this.addData(feature);
	  				}
	  			}
	  			return this;
	  		}
	
	  		var options = this.options;
	
	  		if (options.filter && !options.filter(geojson)) { return this; }
	
	  		var layer = geometryToLayer(geojson, options);
	  		if (!layer) {
	  			return this;
	  		}
	  		layer.feature = asFeature(geojson);
	
	  		layer.defaultOptions = layer.options;
	  		this.resetStyle(layer);
	
	  		if (options.onEachFeature) {
	  			options.onEachFeature(geojson, layer);
	  		}
	
	  		return this.addLayer(layer);
	  	},
	
	  	// @method resetStyle( <Path> layer? ): this
	  	// Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
	  	// If `layer` is omitted, the style of all features in the current layer is reset.
	  	resetStyle: function (layer) {
	  		if (layer === undefined) {
	  			return this.eachLayer(this.resetStyle, this);
	  		}
	  		// reset any custom styles
	  		layer.options = extend({}, layer.defaultOptions);
	  		this._setLayerStyle(layer, this.options.style);
	  		return this;
	  	},
	
	  	// @method setStyle( <Function> style ): this
	  	// Changes styles of GeoJSON vector layers with the given style function.
	  	setStyle: function (style) {
	  		return this.eachLayer(function (layer) {
	  			this._setLayerStyle(layer, style);
	  		}, this);
	  	},
	
	  	_setLayerStyle: function (layer, style) {
	  		if (layer.setStyle) {
	  			if (typeof style === 'function') {
	  				style = style(layer.feature);
	  			}
	  			layer.setStyle(style);
	  		}
	  	}
	  });
	
	  // @section
	  // There are several static functions which can be called without instantiating L.GeoJSON:
	
	  // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
	  // Creates a `Layer` from a given GeoJSON feature. Can use a custom
	  // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
	  // functions if provided as options.
	  function geometryToLayer(geojson, options) {
	
	  	var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson,
	  	    coords = geometry ? geometry.coordinates : null,
	  	    layers = [],
	  	    pointToLayer = options && options.pointToLayer,
	  	    _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng,
	  	    latlng, latlngs, i, len;
	
	  	if (!coords && !geometry) {
	  		return null;
	  	}
	
	  	switch (geometry.type) {
	  	case 'Point':
	  		latlng = _coordsToLatLng(coords);
	  		return _pointToLayer(pointToLayer, geojson, latlng, options);
	
	  	case 'MultiPoint':
	  		for (i = 0, len = coords.length; i < len; i++) {
	  			latlng = _coordsToLatLng(coords[i]);
	  			layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
	  		}
	  		return new FeatureGroup(layers);
	
	  	case 'LineString':
	  	case 'MultiLineString':
	  		latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
	  		return new Polyline(latlngs, options);
	
	  	case 'Polygon':
	  	case 'MultiPolygon':
	  		latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
	  		return new Polygon(latlngs, options);
	
	  	case 'GeometryCollection':
	  		for (i = 0, len = geometry.geometries.length; i < len; i++) {
	  			var layer = geometryToLayer({
	  				geometry: geometry.geometries[i],
	  				type: 'Feature',
	  				properties: geojson.properties
	  			}, options);
	
	  			if (layer) {
	  				layers.push(layer);
	  			}
	  		}
	  		return new FeatureGroup(layers);
	
	  	default:
	  		throw new Error('Invalid GeoJSON object.');
	  	}
	  }
	
	  function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
	  	return pointToLayerFn ?
	  		pointToLayerFn(geojson, latlng) :
	  		new Marker(latlng, options && options.markersInheritOptions && options);
	  }
	
	  // @function coordsToLatLng(coords: Array): LatLng
	  // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
	  // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
	  function coordsToLatLng(coords) {
	  	return new LatLng(coords[1], coords[0], coords[2]);
	  }
	
	  // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
	  // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
	  // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
	  // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
	  function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
	  	var latlngs = [];
	
	  	for (var i = 0, len = coords.length, latlng; i < len; i++) {
	  		latlng = levelsDeep ?
	  			coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) :
	  			(_coordsToLatLng || coordsToLatLng)(coords[i]);
	
	  		latlngs.push(latlng);
	  	}
	
	  	return latlngs;
	  }
	
	  // @function latLngToCoords(latlng: LatLng, precision?: Number): Array
	  // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
	  function latLngToCoords(latlng, precision) {
	  	precision = typeof precision === 'number' ? precision : 6;
	  	return latlng.alt !== undefined ?
	  		[formatNum(latlng.lng, precision), formatNum(latlng.lat, precision), formatNum(latlng.alt, precision)] :
	  		[formatNum(latlng.lng, precision), formatNum(latlng.lat, precision)];
	  }
	
	  // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean): Array
	  // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
	  // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
	  function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
	  	var coords = [];
	
	  	for (var i = 0, len = latlngs.length; i < len; i++) {
	  		coords.push(levelsDeep ?
	  			latLngsToCoords(latlngs[i], levelsDeep - 1, closed, precision) :
	  			latLngToCoords(latlngs[i], precision));
	  	}
	
	  	if (!levelsDeep && closed) {
	  		coords.push(coords[0]);
	  	}
	
	  	return coords;
	  }
	
	  function getFeature(layer, newGeometry) {
	  	return layer.feature ?
	  		extend({}, layer.feature, {geometry: newGeometry}) :
	  		asFeature(newGeometry);
	  }
	
	  // @function asFeature(geojson: Object): Object
	  // Normalize GeoJSON geometries/features into GeoJSON features.
	  function asFeature(geojson) {
	  	if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') {
	  		return geojson;
	  	}
	
	  	return {
	  		type: 'Feature',
	  		properties: {},
	  		geometry: geojson
	  	};
	  }
	
	  var PointToGeoJSON = {
	  	toGeoJSON: function (precision) {
	  		return getFeature(this, {
	  			type: 'Point',
	  			coordinates: latLngToCoords(this.getLatLng(), precision)
	  		});
	  	}
	  };
	
	  // @namespace Marker
	  // @section Other methods
	  // @method toGeoJSON(precision?: Number): Object
	  // `precision` is the number of decimal places for coordinates.
	  // The default value is 6 places.
	  // Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
	  Marker.include(PointToGeoJSON);
	
	  // @namespace CircleMarker
	  // @method toGeoJSON(precision?: Number): Object
	  // `precision` is the number of decimal places for coordinates.
	  // The default value is 6 places.
	  // Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
	  Circle.include(PointToGeoJSON);
	  CircleMarker.include(PointToGeoJSON);
	
	
	  // @namespace Polyline
	  // @method toGeoJSON(precision?: Number): Object
	  // `precision` is the number of decimal places for coordinates.
	  // The default value is 6 places.
	  // Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
	  Polyline.include({
	  	toGeoJSON: function (precision) {
	  		var multi = !isFlat(this._latlngs);
	
	  		var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
	
	  		return getFeature(this, {
	  			type: (multi ? 'Multi' : '') + 'LineString',
	  			coordinates: coords
	  		});
	  	}
	  });
	
	  // @namespace Polygon
	  // @method toGeoJSON(precision?: Number): Object
	  // `precision` is the number of decimal places for coordinates.
	  // The default value is 6 places.
	  // Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
	  Polygon.include({
	  	toGeoJSON: function (precision) {
	  		var holes = !isFlat(this._latlngs),
	  		    multi = holes && !isFlat(this._latlngs[0]);
	
	  		var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
	
	  		if (!holes) {
	  			coords = [coords];
	  		}
	
	  		return getFeature(this, {
	  			type: (multi ? 'Multi' : '') + 'Polygon',
	  			coordinates: coords
	  		});
	  	}
	  });
	
	
	  // @namespace LayerGroup
	  LayerGroup.include({
	  	toMultiPoint: function (precision) {
	  		var coords = [];
	
	  		this.eachLayer(function (layer) {
	  			coords.push(layer.toGeoJSON(precision).geometry.coordinates);
	  		});
	
	  		return getFeature(this, {
	  			type: 'MultiPoint',
	  			coordinates: coords
	  		});
	  	},
	
	  	// @method toGeoJSON(precision?: Number): Object
	  	// `precision` is the number of decimal places for coordinates.
	  	// The default value is 6 places.
	  	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
	  	toGeoJSON: function (precision) {
	
	  		var type = this.feature && this.feature.geometry && this.feature.geometry.type;
	
	  		if (type === 'MultiPoint') {
	  			return this.toMultiPoint(precision);
	  		}
	
	  		var isGeometryCollection = type === 'GeometryCollection',
	  		    jsons = [];
	
	  		this.eachLayer(function (layer) {
	  			if (layer.toGeoJSON) {
	  				var json = layer.toGeoJSON(precision);
	  				if (isGeometryCollection) {
	  					jsons.push(json.geometry);
	  				} else {
	  					var feature = asFeature(json);
	  					// Squash nested feature collections
	  					if (feature.type === 'FeatureCollection') {
	  						jsons.push.apply(jsons, feature.features);
	  					} else {
	  						jsons.push(feature);
	  					}
	  				}
	  			}
	  		});
	
	  		if (isGeometryCollection) {
	  			return getFeature(this, {
	  				geometries: jsons,
	  				type: 'GeometryCollection'
	  			});
	  		}
	
	  		return {
	  			type: 'FeatureCollection',
	  			features: jsons
	  		};
	  	}
	  });
	
	  // @namespace GeoJSON
	  // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
	  // Creates a GeoJSON layer. Optionally accepts an object in
	  // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
	  // (you can alternatively add it later with `addData` method) and an `options` object.
	  function geoJSON(geojson, options) {
	  	return new GeoJSON(geojson, options);
	  }
	
	  // Backward compatibility.
	  var geoJson = geoJSON;
	
	  /*
	   * @class ImageOverlay
	   * @aka L.ImageOverlay
	   * @inherits Interactive layer
	   *
	   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
	   *
	   * @example
	   *
	   * ```js
	   * var imageUrl = 'http://www.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
	   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
	   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
	   * ```
	   */
	
	  var ImageOverlay = Layer.extend({
	
	  	// @section
	  	// @aka ImageOverlay options
	  	options: {
	  		// @option opacity: Number = 1.0
	  		// The opacity of the image overlay.
	  		opacity: 1,
	
	  		// @option alt: String = ''
	  		// Text for the `alt` attribute of the image (useful for accessibility).
	  		alt: '',
	
	  		// @option interactive: Boolean = false
	  		// If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
	  		interactive: false,
	
	  		// @option crossOrigin: Boolean|String = false
	  		// Whether the crossOrigin attribute will be added to the image.
	  		// If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
	  		// Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
	  		crossOrigin: false,
	
	  		// @option errorOverlayUrl: String = ''
	  		// URL to the overlay image to show in place of the overlay that failed to load.
	  		errorOverlayUrl: '',
	
	  		// @option zIndex: Number = 1
	  		// The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
	  		zIndex: 1,
	
	  		// @option className: String = ''
	  		// A custom class name to assign to the image. Empty by default.
	  		className: ''
	  	},
	
	  	initialize: function (url, bounds, options) { // (String, LatLngBounds, Object)
	  		this._url = url;
	  		this._bounds = toLatLngBounds(bounds);
	
	  		setOptions(this, options);
	  	},
	
	  	onAdd: function () {
	  		if (!this._image) {
	  			this._initImage();
	
	  			if (this.options.opacity < 1) {
	  				this._updateOpacity();
	  			}
	  		}
	
	  		if (this.options.interactive) {
	  			addClass(this._image, 'leaflet-interactive');
	  			this.addInteractiveTarget(this._image);
	  		}
	
	  		this.getPane().appendChild(this._image);
	  		this._reset();
	  	},
	
	  	onRemove: function () {
	  		remove(this._image);
	  		if (this.options.interactive) {
	  			this.removeInteractiveTarget(this._image);
	  		}
	  	},
	
	  	// @method setOpacity(opacity: Number): this
	  	// Sets the opacity of the overlay.
	  	setOpacity: function (opacity) {
	  		this.options.opacity = opacity;
	
	  		if (this._image) {
	  			this._updateOpacity();
	  		}
	  		return this;
	  	},
	
	  	setStyle: function (styleOpts) {
	  		if (styleOpts.opacity) {
	  			this.setOpacity(styleOpts.opacity);
	  		}
	  		return this;
	  	},
	
	  	// @method bringToFront(): this
	  	// Brings the layer to the top of all overlays.
	  	bringToFront: function () {
	  		if (this._map) {
	  			toFront(this._image);
	  		}
	  		return this;
	  	},
	
	  	// @method bringToBack(): this
	  	// Brings the layer to the bottom of all overlays.
	  	bringToBack: function () {
	  		if (this._map) {
	  			toBack(this._image);
	  		}
	  		return this;
	  	},
	
	  	// @method setUrl(url: String): this
	  	// Changes the URL of the image.
	  	setUrl: function (url) {
	  		this._url = url;
	
	  		if (this._image) {
	  			this._image.src = url;
	  		}
	  		return this;
	  	},
	
	  	// @method setBounds(bounds: LatLngBounds): this
	  	// Update the bounds that this ImageOverlay covers
	  	setBounds: function (bounds) {
	  		this._bounds = toLatLngBounds(bounds);
	
	  		if (this._map) {
	  			this._reset();
	  		}
	  		return this;
	  	},
	
	  	getEvents: function () {
	  		var events = {
	  			zoom: this._reset,
	  			viewreset: this._reset
	  		};
	
	  		if (this._zoomAnimated) {
	  			events.zoomanim = this._animateZoom;
	  		}
	
	  		return events;
	  	},
	
	  	// @method setZIndex(value: Number): this
	  	// Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
	  	setZIndex: function (value) {
	  		this.options.zIndex = value;
	  		this._updateZIndex();
	  		return this;
	  	},
	
	  	// @method getBounds(): LatLngBounds
	  	// Get the bounds that this ImageOverlay covers
	  	getBounds: function () {
	  		return this._bounds;
	  	},
	
	  	// @method getElement(): HTMLElement
	  	// Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
	  	// used by this overlay.
	  	getElement: function () {
	  		return this._image;
	  	},
	
	  	_initImage: function () {
	  		var wasElementSupplied = this._url.tagName === 'IMG';
	  		var img = this._image = wasElementSupplied ? this._url : create$1('img');
	
	  		addClass(img, 'leaflet-image-layer');
	  		if (this._zoomAnimated) { addClass(img, 'leaflet-zoom-animated'); }
	  		if (this.options.className) { addClass(img, this.options.className); }
	
	  		img.onselectstart = falseFn;
	  		img.onmousemove = falseFn;
	
	  		// @event load: Event
	  		// Fired when the ImageOverlay layer has loaded its image
	  		img.onload = bind(this.fire, this, 'load');
	  		img.onerror = bind(this._overlayOnError, this, 'error');
	
	  		if (this.options.crossOrigin || this.options.crossOrigin === '') {
	  			img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
	  		}
	
	  		if (this.options.zIndex) {
	  			this._updateZIndex();
	  		}
	
	  		if (wasElementSupplied) {
	  			this._url = img.src;
	  			return;
	  		}
	
	  		img.src = this._url;
	  		img.alt = this.options.alt;
	  	},
	
	  	_animateZoom: function (e) {
	  		var scale = this._map.getZoomScale(e.zoom),
	  		    offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
	
	  		setTransform(this._image, offset, scale);
	  	},
	
	  	_reset: function () {
	  		var image = this._image,
	  		    bounds = new Bounds(
	  		        this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
	  		        this._map.latLngToLayerPoint(this._bounds.getSouthEast())),
	  		    size = bounds.getSize();
	
	  		setPosition(image, bounds.min);
	
	  		image.style.width  = size.x + 'px';
	  		image.style.height = size.y + 'px';
	  	},
	
	  	_updateOpacity: function () {
	  		setOpacity(this._image, this.options.opacity);
	  	},
	
	  	_updateZIndex: function () {
	  		if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) {
	  			this._image.style.zIndex = this.options.zIndex;
	  		}
	  	},
	
	  	_overlayOnError: function () {
	  		// @event error: Event
	  		// Fired when the ImageOverlay layer fails to load its image
	  		this.fire('error');
	
	  		var errorUrl = this.options.errorOverlayUrl;
	  		if (errorUrl && this._url !== errorUrl) {
	  			this._url = errorUrl;
	  			this._image.src = errorUrl;
	  		}
	  	}
	  });
	
	  // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
	  // Instantiates an image overlay object given the URL of the image and the
	  // geographical bounds it is tied to.
	  var imageOverlay = function (url, bounds, options) {
	  	return new ImageOverlay(url, bounds, options);
	  };
	
	  /*
	   * @class VideoOverlay
	   * @aka L.VideoOverlay
	   * @inherits ImageOverlay
	   *
	   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
	   *
	   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
	   * HTML5 element.
	   *
	   * @example
	   *
	   * ```js
	   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
	   * 	videoBounds = [[ 32, -130], [ 13, -100]];
	   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
	   * ```
	   */
	
	  var VideoOverlay = ImageOverlay.extend({
	
	  	// @section
	  	// @aka VideoOverlay options
	  	options: {
	  		// @option autoplay: Boolean = true
	  		// Whether the video starts playing automatically when loaded.
	  		autoplay: true,
	
	  		// @option loop: Boolean = true
	  		// Whether the video will loop back to the beginning when played.
	  		loop: true,
	
	  		// @option keepAspectRatio: Boolean = true
	  		// Whether the video will save aspect ratio after the projection.
	  		// Relevant for supported browsers. Browser compatibility- https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit
	  		keepAspectRatio: true,
	
	  		// @option muted: Boolean = false
	  		// Whether the video starts on mute when loaded.
	  		muted: false
	  	},
	
	  	_initImage: function () {
	  		var wasElementSupplied = this._url.tagName === 'VIDEO';
	  		var vid = this._image = wasElementSupplied ? this._url : create$1('video');
	
	  		addClass(vid, 'leaflet-image-layer');
	  		if (this._zoomAnimated) { addClass(vid, 'leaflet-zoom-animated'); }
	  		if (this.options.className) { addClass(vid, this.options.className); }
	
	  		vid.onselectstart = falseFn;
	  		vid.onmousemove = falseFn;
	
	  		// @event load: Event
	  		// Fired when the video has finished loading the first frame
	  		vid.onloadeddata = bind(this.fire, this, 'load');
	
	  		if (wasElementSupplied) {
	  			var sourceElements = vid.getElementsByTagName('source');
	  			var sources = [];
	  			for (var j = 0; j < sourceElements.length; j++) {
	  				sources.push(sourceElements[j].src);
	  			}
	
	  			this._url = (sourceElements.length > 0) ? sources : [vid.src];
	  			return;
	  		}
	
	  		if (!isArray(this._url)) { this._url = [this._url]; }
	
	  		if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, 'objectFit')) {
	  			vid.style['objectFit'] = 'fill';
	  		}
	  		vid.autoplay = !!this.options.autoplay;
	  		vid.loop = !!this.options.loop;
	  		vid.muted = !!this.options.muted;
	  		for (var i = 0; i < this._url.length; i++) {
	  			var source = create$1('source');
	  			source.src = this._url[i];
	  			vid.appendChild(source);
	  		}
	  	}
	
	  	// @method getElement(): HTMLVideoElement
	  	// Returns the instance of [`HTMLVideoElement`](https://developer.mozilla.org/docs/Web/API/HTMLVideoElement)
	  	// used by this overlay.
	  });
	
	
	  // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
	  // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
	  // geographical bounds it is tied to.
	
	  function videoOverlay(video, bounds, options) {
	  	return new VideoOverlay(video, bounds, options);
	  }
	
	  /*
	   * @class SVGOverlay
	   * @aka L.SVGOverlay
	   * @inherits ImageOverlay
	   *
	   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
	   *
	   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
	   *
	   * @example
	   *
	   * ```js
	   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
	   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
	   * svgElement.setAttribute('viewBox', "0 0 200 200");
	   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
	   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
	   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
	   * ```
	   */
	
	  var SVGOverlay = ImageOverlay.extend({
	  	_initImage: function () {
	  		var el = this._image = this._url;
	
	  		addClass(el, 'leaflet-image-layer');
	  		if (this._zoomAnimated) { addClass(el, 'leaflet-zoom-animated'); }
	  		if (this.options.className) { addClass(el, this.options.className); }
	
	  		el.onselectstart = falseFn;
	  		el.onmousemove = falseFn;
	  	}
	
	  	// @method getElement(): SVGElement
	  	// Returns the instance of [`SVGElement`](https://developer.mozilla.org/docs/Web/API/SVGElement)
	  	// used by this overlay.
	  });
	
	
	  // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
	  // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
	  // A viewBox attribute is required on the SVG element to zoom in and out properly.
	
	  function svgOverlay(el, bounds, options) {
	  	return new SVGOverlay(el, bounds, options);
	  }
	
	  /*
	   * @class DivOverlay
	   * @inherits Layer
	   * @aka L.DivOverlay
	   * Base model for L.Popup and L.Tooltip. Inherit from it for custom popup like plugins.
	   */
	
	  // @namespace DivOverlay
	  var DivOverlay = Layer.extend({
	
	  	// @section
	  	// @aka DivOverlay options
	  	options: {
	  		// @option offset: Point = Point(0, 7)
	  		// The offset of the popup position. Useful to control the anchor
	  		// of the popup when opening it on some overlays.
	  		offset: [0, 7],
	
	  		// @option className: String = ''
	  		// A custom CSS class name to assign to the popup.
	  		className: '',
	
	  		// @option pane: String = 'popupPane'
	  		// `Map pane` where the popup will be added.
	  		pane: 'popupPane'
	  	},
	
	  	initialize: function (options, source) {
	  		setOptions(this, options);
	
	  		this._source = source;
	  	},
	
	  	onAdd: function (map) {
	  		this._zoomAnimated = map._zoomAnimated;
	
	  		if (!this._container) {
	  			this._initLayout();
	  		}
	
	  		if (map._fadeAnimated) {
	  			setOpacity(this._container, 0);
	  		}
	
	  		clearTimeout(this._removeTimeout);
	  		this.getPane().appendChild(this._container);
	  		this.update();
	
	  		if (map._fadeAnimated) {
	  			setOpacity(this._container, 1);
	  		}
	
	  		this.bringToFront();
	  	},
	
	  	onRemove: function (map) {
	  		if (map._fadeAnimated) {
	  			setOpacity(this._container, 0);
	  			this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
	  		} else {
	  			remove(this._container);
	  		}
	  	},
	
	  	// @namespace Popup
	  	// @method getLatLng: LatLng
	  	// Returns the geographical point of popup.
	  	getLatLng: function () {
	  		return this._latlng;
	  	},
	
	  	// @method setLatLng(latlng: LatLng): this
	  	// Sets the geographical point where the popup will open.
	  	setLatLng: function (latlng) {
	  		this._latlng = toLatLng(latlng);
	  		if (this._map) {
	  			this._updatePosition();
	  			this._adjustPan();
	  		}
	  		return this;
	  	},
	
	  	// @method getContent: String|HTMLElement
	  	// Returns the content of the popup.
	  	getContent: function () {
	  		return this._content;
	  	},
	
	  	// @method setContent(htmlContent: String|HTMLElement|Function): this
	  	// Sets the HTML content of the popup. If a function is passed the source layer will be passed to the function. The function should return a `String` or `HTMLElement` to be used in the popup.
	  	setContent: function (content) {
	  		this._content = content;
	  		this.update();
	  		return this;
	  	},
	
	  	// @method getElement: String|HTMLElement
	  	// Returns the HTML container of the popup.
	  	getElement: function () {
	  		return this._container;
	  	},
	
	  	// @method update: null
	  	// Updates the popup content, layout and position. Useful for updating the popup after something inside changed, e.g. image loaded.
	  	update: function () {
	  		if (!this._map) { return; }
	
	  		this._container.style.visibility = 'hidden';
	
	  		this._updateContent();
	  		this._updateLayout();
	  		this._updatePosition();
	
	  		this._container.style.visibility = '';
	
	  		this._adjustPan();
	  	},
	
	  	getEvents: function () {
	  		var events = {
	  			zoom: this._updatePosition,
	  			viewreset: this._updatePosition
	  		};
	
	  		if (this._zoomAnimated) {
	  			events.zoomanim = this._animateZoom;
	  		}
	  		return events;
	  	},
	
	  	// @method isOpen: Boolean
	  	// Returns `true` when the popup is visible on the map.
	  	isOpen: function () {
	  		return !!this._map && this._map.hasLayer(this);
	  	},
	
	  	// @method bringToFront: this
	  	// Brings this popup in front of other popups (in the same map pane).
	  	bringToFront: function () {
	  		if (this._map) {
	  			toFront(this._container);
	  		}
	  		return this;
	  	},
	
	  	// @method bringToBack: this
	  	// Brings this popup to the back of other popups (in the same map pane).
	  	bringToBack: function () {
	  		if (this._map) {
	  			toBack(this._container);
	  		}
	  		return this;
	  	},
	
	  	_prepareOpen: function (parent, layer, latlng) {
	  		if (!(layer instanceof Layer)) {
	  			latlng = layer;
	  			layer = parent;
	  		}
	
	  		if (layer instanceof FeatureGroup) {
	  			for (var id in parent._layers) {
	  				layer = parent._layers[id];
	  				break;
	  			}
	  		}
	
	  		if (!latlng) {
	  			if (layer.getCenter) {
	  				latlng = layer.getCenter();
	  			} else if (layer.getLatLng) {
	  				latlng = layer.getLatLng();
	  			} else {
	  				throw new Error('Unable to get source layer LatLng.');
	  			}
	  		}
	
	  		// set overlay source to this layer
	  		this._source = layer;
	
	  		// update the overlay (content, layout, ect...)
	  		this.update();
	
	  		return latlng;
	  	},
	
	  	_updateContent: function () {
	  		if (!this._content) { return; }
	
	  		var node = this._contentNode;
	  		var content = (typeof this._content === 'function') ? this._content(this._source || this) : this._content;
	
	  		if (typeof content === 'string') {
	  			node.innerHTML = content;
	  		} else {
	  			while (node.hasChildNodes()) {
	  				node.removeChild(node.firstChild);
	  			}
	  			node.appendChild(content);
	  		}
	  		this.fire('contentupdate');
	  	},
	
	  	_updatePosition: function () {
	  		if (!this._map) { return; }
	
	  		var pos = this._map.latLngToLayerPoint(this._latlng),
	  		    offset = toPoint(this.options.offset),
	  		    anchor = this._getAnchor();
	
	  		if (this._zoomAnimated) {
	  			setPosition(this._container, pos.add(anchor));
	  		} else {
	  			offset = offset.add(pos).add(anchor);
	  		}
	
	  		var bottom = this._containerBottom = -offset.y,
	  		    left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
	
	  		// bottom position the popup in case the height of the popup changes (images loading etc)
	  		this._container.style.bottom = bottom + 'px';
	  		this._container.style.left = left + 'px';
	  	},
	
	  	_getAnchor: function () {
	  		return [0, 0];
	  	}
	
	  });
	
	  /*
	   * @class Popup
	   * @inherits DivOverlay
	   * @aka L.Popup
	   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
	   * open popups while making sure that only one popup is open at one time
	   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
	   *
	   * @example
	   *
	   * If you want to just bind a popup to marker click and then open it, it's really easy:
	   *
	   * ```js
	   * marker.bindPopup(popupContent).openPopup();
	   * ```
	   * Path overlays like polylines also have a `bindPopup` method.
	   * Here's a more complicated way to open a popup on a map:
	   *
	   * ```js
	   * var popup = L.popup()
	   * 	.setLatLng(latlng)
	   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
	   * 	.openOn(map);
	   * ```
	   */
	
	
	  // @namespace Popup
	  var Popup = DivOverlay.extend({
	
	  	// @section
	  	// @aka Popup options
	  	options: {
	  		// @option maxWidth: Number = 300
	  		// Max width of the popup, in pixels.
	  		maxWidth: 300,
	
	  		// @option minWidth: Number = 50
	  		// Min width of the popup, in pixels.
	  		minWidth: 50,
	
	  		// @option maxHeight: Number = null
	  		// If set, creates a scrollable container of the given height
	  		// inside a popup if its content exceeds it.
	  		maxHeight: null,
	
	  		// @option autoPan: Boolean = true
	  		// Set it to `false` if you don't want the map to do panning animation
	  		// to fit the opened popup.
	  		autoPan: true,
	
	  		// @option autoPanPaddingTopLeft: Point = null
	  		// The margin between the popup and the top left corner of the map
	  		// view after autopanning was performed.
	  		autoPanPaddingTopLeft: null,
	
	  		// @option autoPanPaddingBottomRight: Point = null
	  		// The margin between the popup and the bottom right corner of the map
	  		// view after autopanning was performed.
	  		autoPanPaddingBottomRight: null,
	
	  		// @option autoPanPadding: Point = Point(5, 5)
	  		// Equivalent of setting both top left and bottom right autopan padding to the same value.
	  		autoPanPadding: [5, 5],
	
	  		// @option keepInView: Boolean = false
	  		// Set it to `true` if you want to prevent users from panning the popup
	  		// off of the screen while it is open.
	  		keepInView: false,
	
	  		// @option closeButton: Boolean = true
	  		// Controls the presence of a close button in the popup.
	  		closeButton: true,
	
	  		// @option autoClose: Boolean = true
	  		// Set it to `false` if you want to override the default behavior of
	  		// the popup closing when another popup is opened.
	  		autoClose: true,
	
	  		// @option closeOnEscapeKey: Boolean = true
	  		// Set it to `false` if you want to override the default behavior of
	  		// the ESC key for closing of the popup.
	  		closeOnEscapeKey: true,
	
	  		// @option closeOnClick: Boolean = *
	  		// Set it if you want to override the default behavior of the popup closing when user clicks
	  		// on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
	
	  		// @option className: String = ''
	  		// A custom CSS class name to assign to the popup.
	  		className: ''
	  	},
	
	  	// @namespace Popup
	  	// @method openOn(map: Map): this
	  	// Adds the popup to the map and closes the previous one. The same as `map.openPopup(popup)`.
	  	openOn: function (map) {
	  		map.openPopup(this);
	  		return this;
	  	},
	
	  	onAdd: function (map) {
	  		DivOverlay.prototype.onAdd.call(this, map);
	
	  		// @namespace Map
	  		// @section Popup events
	  		// @event popupopen: PopupEvent
	  		// Fired when a popup is opened in the map
	  		map.fire('popupopen', {popup: this});
	
	  		if (this._source) {
	  			// @namespace Layer
	  			// @section Popup events
	  			// @event popupopen: PopupEvent
	  			// Fired when a popup bound to this layer is opened
	  			this._source.fire('popupopen', {popup: this}, true);
	  			// For non-path layers, we toggle the popup when clicking
	  			// again the layer, so prevent the map to reopen it.
	  			if (!(this._source instanceof Path)) {
	  				this._source.on('preclick', stopPropagation);
	  			}
	  		}
	  	},
	
	  	onRemove: function (map) {
	  		DivOverlay.prototype.onRemove.call(this, map);
	
	  		// @namespace Map
	  		// @section Popup events
	  		// @event popupclose: PopupEvent
	  		// Fired when a popup in the map is closed
	  		map.fire('popupclose', {popup: this});
	
	  		if (this._source) {
	  			// @namespace Layer
	  			// @section Popup events
	  			// @event popupclose: PopupEvent
	  			// Fired when a popup bound to this layer is closed
	  			this._source.fire('popupclose', {popup: this}, true);
	  			if (!(this._source instanceof Path)) {
	  				this._source.off('preclick', stopPropagation);
	  			}
	  		}
	  	},
	
	  	getEvents: function () {
	  		var events = DivOverlay.prototype.getEvents.call(this);
	
	  		if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) {
	  			events.preclick = this._close;
	  		}
	
	  		if (this.options.keepInView) {
	  			events.moveend = this._adjustPan;
	  		}
	
	  		return events;
	  	},
	
	  	_close: function () {
	  		if (this._map) {
	  			this._map.closePopup(this);
	  		}
	  	},
	
	  	_initLayout: function () {
	  		var prefix = 'leaflet-popup',
	  		    container = this._container = create$1('div',
	  			prefix + ' ' + (this.options.className || '') +
	  			' leaflet-zoom-animated');
	
	  		var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
	  		this._contentNode = create$1('div', prefix + '-content', wrapper);
	
	  		disableClickPropagation(container);
	  		disableScrollPropagation(this._contentNode);
	  		on(container, 'contextmenu', stopPropagation);
	
	  		this._tipContainer = create$1('div', prefix + '-tip-container', container);
	  		this._tip = create$1('div', prefix + '-tip', this._tipContainer);
	
	  		if (this.options.closeButton) {
	  			var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
	  			closeButton.href = '#close';
	  			closeButton.innerHTML = '&#215;';
	
	  			on(closeButton, 'click', this._onCloseButtonClick, this);
	  		}
	  	},
	
	  	_updateLayout: function () {
	  		var container = this._contentNode,
	  		    style = container.style;
	
	  		style.width = '';
	  		style.whiteSpace = 'nowrap';
	
	  		var width = container.offsetWidth;
	  		width = Math.min(width, this.options.maxWidth);
	  		width = Math.max(width, this.options.minWidth);
	
	  		style.width = (width + 1) + 'px';
	  		style.whiteSpace = '';
	
	  		style.height = '';
	
	  		var height = container.offsetHeight,
	  		    maxHeight = this.options.maxHeight,
	  		    scrolledClass = 'leaflet-popup-scrolled';
	
	  		if (maxHeight && height > maxHeight) {
	  			style.height = maxHeight + 'px';
	  			addClass(container, scrolledClass);
	  		} else {
	  			removeClass(container, scrolledClass);
	  		}
	
	  		this._containerWidth = this._container.offsetWidth;
	  	},
	
	  	_animateZoom: function (e) {
	  		var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center),
	  		    anchor = this._getAnchor();
	  		setPosition(this._container, pos.add(anchor));
	  	},
	
	  	_adjustPan: function () {
	  		if (!this.options.autoPan) { return; }
	  		if (this._map._panAnim) { this._map._panAnim.stop(); }
	
	  		var map = this._map,
	  		    marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0,
	  		    containerHeight = this._container.offsetHeight + marginBottom,
	  		    containerWidth = this._containerWidth,
	  		    layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
	
	  		layerPos._add(getPosition(this._container));
	
	  		var containerPos = map.layerPointToContainerPoint(layerPos),
	  		    padding = toPoint(this.options.autoPanPadding),
	  		    paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding),
	  		    paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding),
	  		    size = map.getSize(),
	  		    dx = 0,
	  		    dy = 0;
	
	  		if (containerPos.x + containerWidth + paddingBR.x > size.x) { // right
	  			dx = containerPos.x + containerWidth - size.x + paddingBR.x;
	  		}
	  		if (containerPos.x - dx - paddingTL.x < 0) { // left
	  			dx = containerPos.x - paddingTL.x;
	  		}
	  		if (containerPos.y + containerHeight + paddingBR.y > size.y) { // bottom
	  			dy = containerPos.y + containerHeight - size.y + paddingBR.y;
	  		}
	  		if (containerPos.y - dy - paddingTL.y < 0) { // top
	  			dy = containerPos.y - paddingTL.y;
	  		}
	
	  		// @namespace Map
	  		// @section Popup events
	  		// @event autopanstart: Event
	  		// Fired when the map starts autopanning when opening a popup.
	  		if (dx || dy) {
	  			map
	  			    .fire('autopanstart')
	  			    .panBy([dx, dy]);
	  		}
	  	},
	
	  	_onCloseButtonClick: function (e) {
	  		this._close();
	  		stop(e);
	  	},
	
	  	_getAnchor: function () {
	  		// Where should we anchor the popup on the source layer?
	  		return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
	  	}
	
	  });
	
	  // @namespace Popup
	  // @factory L.popup(options?: Popup options, source?: Layer)
	  // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
	  var popup = function (options, source) {
	  	return new Popup(options, source);
	  };
	
	
	  /* @namespace Map
	   * @section Interaction Options
	   * @option closePopupOnClick: Boolean = true
	   * Set it to `false` if you don't want popups to close when user clicks the map.
	   */
	  Map.mergeOptions({
	  	closePopupOnClick: true
	  });
	
	
	  // @namespace Map
	  // @section Methods for Layers and Controls
	  Map.include({
	  	// @method openPopup(popup: Popup): this
	  	// Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
	  	// @alternative
	  	// @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
	  	// Creates a popup with the specified content and options and opens it in the given point on a map.
	  	openPopup: function (popup, latlng, options) {
	  		if (!(popup instanceof Popup)) {
	  			popup = new Popup(options).setContent(popup);
	  		}
	
	  		if (latlng) {
	  			popup.setLatLng(latlng);
	  		}
	
	  		if (this.hasLayer(popup)) {
	  			return this;
	  		}
	
	  		if (this._popup && this._popup.options.autoClose) {
	  			this.closePopup();
	  		}
	
	  		this._popup = popup;
	  		return this.addLayer(popup);
	  	},
	
	  	// @method closePopup(popup?: Popup): this
	  	// Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
	  	closePopup: function (popup) {
	  		if (!popup || popup === this._popup) {
	  			popup = this._popup;
	  			this._popup = null;
	  		}
	  		if (popup) {
	  			this.removeLayer(popup);
	  		}
	  		return this;
	  	}
	  });
	
	  /*
	   * @namespace Layer
	   * @section Popup methods example
	   *
	   * All layers share a set of methods convenient for binding popups to it.
	   *
	   * ```js
	   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
	   * layer.openPopup();
	   * layer.closePopup();
	   * ```
	   *
	   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
	   */
	
	  // @section Popup methods
	  Layer.include({
	
	  	// @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
	  	// Binds a popup to the layer with the passed `content` and sets up the
	  	// necessary event listeners. If a `Function` is passed it will receive
	  	// the layer as the first argument and should return a `String` or `HTMLElement`.
	  	bindPopup: function (content, options) {
	
	  		if (content instanceof Popup) {
	  			setOptions(content, options);
	  			this._popup = content;
	  			content._source = this;
	  		} else {
	  			if (!this._popup || options) {
	  				this._popup = new Popup(options, this);
	  			}
	  			this._popup.setContent(content);
	  		}
	
	  		if (!this._popupHandlersAdded) {
	  			this.on({
	  				click: this._openPopup,
	  				keypress: this._onKeyPress,
	  				remove: this.closePopup,
	  				move: this._movePopup
	  			});
	  			this._popupHandlersAdded = true;
	  		}
	
	  		return this;
	  	},
	
	  	// @method unbindPopup(): this
	  	// Removes the popup previously bound with `bindPopup`.
	  	unbindPopup: function () {
	  		if (this._popup) {
	  			this.off({
	  				click: this._openPopup,
	  				keypress: this._onKeyPress,
	  				remove: this.closePopup,
	  				move: this._movePopup
	  			});
	  			this._popupHandlersAdded = false;
	  			this._popup = null;
	  		}
	  		return this;
	  	},
	
	  	// @method openPopup(latlng?: LatLng): this
	  	// Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
	  	openPopup: function (layer, latlng) {
	  		if (this._popup && this._map) {
	  			latlng = this._popup._prepareOpen(this, layer, latlng);
	
	  			// open the popup on the map
	  			this._map.openPopup(this._popup, latlng);
	  		}
	
	  		return this;
	  	},
	
	  	// @method closePopup(): this
	  	// Closes the popup bound to this layer if it is open.
	  	closePopup: function () {
	  		if (this._popup) {
	  			this._popup._close();
	  		}
	  		return this;
	  	},
	
	  	// @method togglePopup(): this
	  	// Opens or closes the popup bound to this layer depending on its current state.
	  	togglePopup: function (target) {
	  		if (this._popup) {
	  			if (this._popup._map) {
	  				this.closePopup();
	  			} else {
	  				this.openPopup(target);
	  			}
	  		}
	  		return this;
	  	},
	
	  	// @method isPopupOpen(): boolean
	  	// Returns `true` if the popup bound to this layer is currently open.
	  	isPopupOpen: function () {
	  		return (this._popup ? this._popup.isOpen() : false);
	  	},
	
	  	// @method setPopupContent(content: String|HTMLElement|Popup): this
	  	// Sets the content of the popup bound to this layer.
	  	setPopupContent: function (content) {
	  		if (this._popup) {
	  			this._popup.setContent(content);
	  		}
	  		return this;
	  	},
	
	  	// @method getPopup(): Popup
	  	// Returns the popup bound to this layer.
	  	getPopup: function () {
	  		return this._popup;
	  	},
	
	  	_openPopup: function (e) {
	  		var layer = e.layer || e.target;
	
	  		if (!this._popup) {
	  			return;
	  		}
	
	  		if (!this._map) {
	  			return;
	  		}
	
	  		// prevent map click
	  		stop(e);
	
	  		// if this inherits from Path its a vector and we can just
	  		// open the popup at the new location
	  		if (layer instanceof Path) {
	  			this.openPopup(e.layer || e.target, e.latlng);
	  			return;
	  		}
	
	  		// otherwise treat it like a marker and figure out
	  		// if we should toggle it open/closed
	  		if (this._map.hasLayer(this._popup) && this._popup._source === layer) {
	  			this.closePopup();
	  		} else {
	  			this.openPopup(layer, e.latlng);
	  		}
	  	},
	
	  	_movePopup: function (e) {
	  		this._popup.setLatLng(e.latlng);
	  	},
	
	  	_onKeyPress: function (e) {
	  		if (e.originalEvent.keyCode === 13) {
	  			this._openPopup(e);
	  		}
	  	}
	  });
	
	  /*
	   * @class Tooltip
	   * @inherits DivOverlay
	   * @aka L.Tooltip
	   * Used to display small texts on top of map layers.
	   *
	   * @example
	   *
	   * ```js
	   * marker.bindTooltip("my tooltip text").openTooltip();
	   * ```
	   * Note about tooltip offset. Leaflet takes two options in consideration
	   * for computing tooltip offsetting:
	   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
	   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
	   *   move it to the bottom. Negatives will move to the left and top.
	   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
	   *   should adapt this value if you use a custom icon.
	   */
	
	
	  // @namespace Tooltip
	  var Tooltip = DivOverlay.extend({
	
	  	// @section
	  	// @aka Tooltip options
	  	options: {
	  		// @option pane: String = 'tooltipPane'
	  		// `Map pane` where the tooltip will be added.
	  		pane: 'tooltipPane',
	
	  		// @option offset: Point = Point(0, 0)
	  		// Optional offset of the tooltip position.
	  		offset: [0, 0],
	
	  		// @option direction: String = 'auto'
	  		// Direction where to open the tooltip. Possible values are: `right`, `left`,
	  		// `top`, `bottom`, `center`, `auto`.
	  		// `auto` will dynamically switch between `right` and `left` according to the tooltip
	  		// position on the map.
	  		direction: 'auto',
	
	  		// @option permanent: Boolean = false
	  		// Whether to open the tooltip permanently or only on mouseover.
	  		permanent: false,
	
	  		// @option sticky: Boolean = false
	  		// If true, the tooltip will follow the mouse instead of being fixed at the feature center.
	  		sticky: false,
	
	  		// @option interactive: Boolean = false
	  		// If true, the tooltip will listen to the feature events.
	  		interactive: false,
	
	  		// @option opacity: Number = 0.9
	  		// Tooltip container opacity.
	  		opacity: 0.9
	  	},
	
	  	onAdd: function (map) {
	  		DivOverlay.prototype.onAdd.call(this, map);
	  		this.setOpacity(this.options.opacity);
	
	  		// @namespace Map
	  		// @section Tooltip events
	  		// @event tooltipopen: TooltipEvent
	  		// Fired when a tooltip is opened in the map.
	  		map.fire('tooltipopen', {tooltip: this});
	
	  		if (this._source) {
	  			// @namespace Layer
	  			// @section Tooltip events
	  			// @event tooltipopen: TooltipEvent
	  			// Fired when a tooltip bound to this layer is opened.
	  			this._source.fire('tooltipopen', {tooltip: this}, true);
	  		}
	  	},
	
	  	onRemove: function (map) {
	  		DivOverlay.prototype.onRemove.call(this, map);
	
	  		// @namespace Map
	  		// @section Tooltip events
	  		// @event tooltipclose: TooltipEvent
	  		// Fired when a tooltip in the map is closed.
	  		map.fire('tooltipclose', {tooltip: this});
	
	  		if (this._source) {
	  			// @namespace Layer
	  			// @section Tooltip events
	  			// @event tooltipclose: TooltipEvent
	  			// Fired when a tooltip bound to this layer is closed.
	  			this._source.fire('tooltipclose', {tooltip: this}, true);
	  		}
	  	},
	
	  	getEvents: function () {
	  		var events = DivOverlay.prototype.getEvents.call(this);
	
	  		if (touch && !this.options.permanent) {
	  			events.preclick = this._close;
	  		}
	
	  		return events;
	  	},
	
	  	_close: function () {
	  		if (this._map) {
	  			this._map.closeTooltip(this);
	  		}
	  	},
	
	  	_initLayout: function () {
	  		var prefix = 'leaflet-tooltip',
	  		    className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
	
	  		this._contentNode = this._container = create$1('div', className);
	  	},
	
	  	_updateLayout: function () {},
	
	  	_adjustPan: function () {},
	
	  	_setPosition: function (pos) {
	  		var subX, subY,
	  		    map = this._map,
	  		    container = this._container,
	  		    centerPoint = map.latLngToContainerPoint(map.getCenter()),
	  		    tooltipPoint = map.layerPointToContainerPoint(pos),
	  		    direction = this.options.direction,
	  		    tooltipWidth = container.offsetWidth,
	  		    tooltipHeight = container.offsetHeight,
	  		    offset = toPoint(this.options.offset),
	  		    anchor = this._getAnchor();
	
	  		if (direction === 'top') {
	  			subX = tooltipWidth / 2;
	  			subY = tooltipHeight;
	  		} else if (direction === 'bottom') {
	  			subX = tooltipWidth / 2;
	  			subY = 0;
	  		} else if (direction === 'center') {
	  			subX = tooltipWidth / 2;
	  			subY = tooltipHeight / 2;
	  		} else if (direction === 'right') {
	  			subX = 0;
	  			subY = tooltipHeight / 2;
	  		} else if (direction === 'left') {
	  			subX = tooltipWidth;
	  			subY = tooltipHeight / 2;
	  		} else if (tooltipPoint.x < centerPoint.x) {
	  			direction = 'right';
	  			subX = 0;
	  			subY = tooltipHeight / 2;
	  		} else {
	  			direction = 'left';
	  			subX = tooltipWidth + (offset.x + anchor.x) * 2;
	  			subY = tooltipHeight / 2;
	  		}
	
	  		pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
	
	  		removeClass(container, 'leaflet-tooltip-right');
	  		removeClass(container, 'leaflet-tooltip-left');
	  		removeClass(container, 'leaflet-tooltip-top');
	  		removeClass(container, 'leaflet-tooltip-bottom');
	  		addClass(container, 'leaflet-tooltip-' + direction);
	  		setPosition(container, pos);
	  	},
	
	  	_updatePosition: function () {
	  		var pos = this._map.latLngToLayerPoint(this._latlng);
	  		this._setPosition(pos);
	  	},
	
	  	setOpacity: function (opacity) {
	  		this.options.opacity = opacity;
	
	  		if (this._container) {
	  			setOpacity(this._container, opacity);
	  		}
	  	},
	
	  	_animateZoom: function (e) {
	  		var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
	  		this._setPosition(pos);
	  	},
	
	  	_getAnchor: function () {
	  		// Where should we anchor the tooltip on the source layer?
	  		return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
	  	}
	
	  });
	
	  // @namespace Tooltip
	  // @factory L.tooltip(options?: Tooltip options, source?: Layer)
	  // Instantiates a Tooltip object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
	  var tooltip = function (options, source) {
	  	return new Tooltip(options, source);
	  };
	
	  // @namespace Map
	  // @section Methods for Layers and Controls
	  Map.include({
	
	  	// @method openTooltip(tooltip: Tooltip): this
	  	// Opens the specified tooltip.
	  	// @alternative
	  	// @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
	  	// Creates a tooltip with the specified content and options and open it.
	  	openTooltip: function (tooltip, latlng, options) {
	  		if (!(tooltip instanceof Tooltip)) {
	  			tooltip = new Tooltip(options).setContent(tooltip);
	  		}
	
	  		if (latlng) {
	  			tooltip.setLatLng(latlng);
	  		}
	
	  		if (this.hasLayer(tooltip)) {
	  			return this;
	  		}
	
	  		return this.addLayer(tooltip);
	  	},
	
	  	// @method closeTooltip(tooltip?: Tooltip): this
	  	// Closes the tooltip given as parameter.
	  	closeTooltip: function (tooltip) {
	  		if (tooltip) {
	  			this.removeLayer(tooltip);
	  		}
	  		return this;
	  	}
	
	  });
	
	  /*
	   * @namespace Layer
	   * @section Tooltip methods example
	   *
	   * All layers share a set of methods convenient for binding tooltips to it.
	   *
	   * ```js
	   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
	   * layer.openTooltip();
	   * layer.closeTooltip();
	   * ```
	   */
	
	  // @section Tooltip methods
	  Layer.include({
	
	  	// @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
	  	// Binds a tooltip to the layer with the passed `content` and sets up the
	  	// necessary event listeners. If a `Function` is passed it will receive
	  	// the layer as the first argument and should return a `String` or `HTMLElement`.
	  	bindTooltip: function (content, options) {
	
	  		if (content instanceof Tooltip) {
	  			setOptions(content, options);
	  			this._tooltip = content;
	  			content._source = this;
	  		} else {
	  			if (!this._tooltip || options) {
	  				this._tooltip = new Tooltip(options, this);
	  			}
	  			this._tooltip.setContent(content);
	
	  		}
	
	  		this._initTooltipInteractions();
	
	  		if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) {
	  			this.openTooltip();
	  		}
	
	  		return this;
	  	},
	
	  	// @method unbindTooltip(): this
	  	// Removes the tooltip previously bound with `bindTooltip`.
	  	unbindTooltip: function () {
	  		if (this._tooltip) {
	  			this._initTooltipInteractions(true);
	  			this.closeTooltip();
	  			this._tooltip = null;
	  		}
	  		return this;
	  	},
	
	  	_initTooltipInteractions: function (remove$$1) {
	  		if (!remove$$1 && this._tooltipHandlersAdded) { return; }
	  		var onOff = remove$$1 ? 'off' : 'on',
	  		    events = {
	  			remove: this.closeTooltip,
	  			move: this._moveTooltip
	  		    };
	  		if (!this._tooltip.options.permanent) {
	  			events.mouseover = this._openTooltip;
	  			events.mouseout = this.closeTooltip;
	  			if (this._tooltip.options.sticky) {
	  				events.mousemove = this._moveTooltip;
	  			}
	  			if (touch) {
	  				events.click = this._openTooltip;
	  			}
	  		} else {
	  			events.add = this._openTooltip;
	  		}
	  		this[onOff](events);
	  		this._tooltipHandlersAdded = !remove$$1;
	  	},
	
	  	// @method openTooltip(latlng?: LatLng): this
	  	// Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
	  	openTooltip: function (layer, latlng) {
	  		if (this._tooltip && this._map) {
	  			latlng = this._tooltip._prepareOpen(this, layer, latlng);
	
	  			// open the tooltip on the map
	  			this._map.openTooltip(this._tooltip, latlng);
	
	  			// Tooltip container may not be defined if not permanent and never
	  			// opened.
	  			if (this._tooltip.options.interactive && this._tooltip._container) {
	  				addClass(this._tooltip._container, 'leaflet-clickable');
	  				this.addInteractiveTarget(this._tooltip._container);
	  			}
	  		}
	
	  		return this;
	  	},
	
	  	// @method closeTooltip(): this
	  	// Closes the tooltip bound to this layer if it is open.
	  	closeTooltip: function () {
	  		if (this._tooltip) {
	  			this._tooltip._close();
	  			if (this._tooltip.options.interactive && this._tooltip._container) {
	  				removeClass(this._tooltip._container, 'leaflet-clickable');
	  				this.removeInteractiveTarget(this._tooltip._container);
	  			}
	  		}
	  		return this;
	  	},
	
	  	// @method toggleTooltip(): this
	  	// Opens or closes the tooltip bound to this layer depending on its current state.
	  	toggleTooltip: function (target) {
	  		if (this._tooltip) {
	  			if (this._tooltip._map) {
	  				this.closeTooltip();
	  			} else {
	  				this.openTooltip(target);
	  			}
	  		}
	  		return this;
	  	},
	
	  	// @method isTooltipOpen(): boolean
	  	// Returns `true` if the tooltip bound to this layer is currently open.
	  	isTooltipOpen: function () {
	  		return this._tooltip.isOpen();
	  	},
	
	  	// @method setTooltipContent(content: String|HTMLElement|Tooltip): this
	  	// Sets the content of the tooltip bound to this layer.
	  	setTooltipContent: function (content) {
	  		if (this._tooltip) {
	  			this._tooltip.setContent(content);
	  		}
	  		return this;
	  	},
	
	  	// @method getTooltip(): Tooltip
	  	// Returns the tooltip bound to this layer.
	  	getTooltip: function () {
	  		return this._tooltip;
	  	},
	
	  	_openTooltip: function (e) {
	  		var layer = e.layer || e.target;
	
	  		if (!this._tooltip || !this._map) {
	  			return;
	  		}
	  		this.openTooltip(layer, this._tooltip.options.sticky ? e.latlng : undefined);
	  	},
	
	  	_moveTooltip: function (e) {
	  		var latlng = e.latlng, containerPoint, layerPoint;
	  		if (this._tooltip.options.sticky && e.originalEvent) {
	  			containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
	  			layerPoint = this._map.containerPointToLayerPoint(containerPoint);
	  			latlng = this._map.layerPointToLatLng(layerPoint);
	  		}
	  		this._tooltip.setLatLng(latlng);
	  	}
	  });
	
	  /*
	   * @class DivIcon
	   * @aka L.DivIcon
	   * @inherits Icon
	   *
	   * Represents a lightweight icon for markers that uses a simple `<div>`
	   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
	   *
	   * @example
	   * ```js
	   * var myIcon = L.divIcon({className: 'my-div-icon'});
	   * // you can set .my-div-icon styles in CSS
	   *
	   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
	   * ```
	   *
	   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
	   */
	
	  var DivIcon = Icon.extend({
	  	options: {
	  		// @section
	  		// @aka DivIcon options
	  		iconSize: [12, 12], // also can be set through CSS
	
	  		// iconAnchor: (Point),
	  		// popupAnchor: (Point),
	
	  		// @option html: String|HTMLElement = ''
	  		// Custom HTML code to put inside the div element, empty by default. Alternatively,
	  		// an instance of `HTMLElement`.
	  		html: false,
	
	  		// @option bgPos: Point = [0, 0]
	  		// Optional relative position of the background, in pixels
	  		bgPos: null,
	
	  		className: 'leaflet-div-icon'
	  	},
	
	  	createIcon: function (oldIcon) {
	  		var div = (oldIcon && oldIcon.tagName === 'DIV') ? oldIcon : document.createElement('div'),
	  		    options = this.options;
	
	  		if (options.html instanceof Element) {
	  			empty(div);
	  			div.appendChild(options.html);
	  		} else {
	  			div.innerHTML = options.html !== false ? options.html : '';
	  		}
	
	  		if (options.bgPos) {
	  			var bgPos = toPoint(options.bgPos);
	  			div.style.backgroundPosition = (-bgPos.x) + 'px ' + (-bgPos.y) + 'px';
	  		}
	  		this._setIconStyles(div, 'icon');
	
	  		return div;
	  	},
	
	  	createShadow: function () {
	  		return null;
	  	}
	  });
	
	  // @factory L.divIcon(options: DivIcon options)
	  // Creates a `DivIcon` instance with the given options.
	  function divIcon(options) {
	  	return new DivIcon(options);
	  }
	
	  Icon.Default = IconDefault;
	
	  /*
	   * @class GridLayer
	   * @inherits Layer
	   * @aka L.GridLayer
	   *
	   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
	   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
	   *
	   *
	   * @section Synchronous usage
	   * @example
	   *
	   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
	   *
	   * ```js
	   * var CanvasLayer = L.GridLayer.extend({
	   *     createTile: function(coords){
	   *         // create a <canvas> element for drawing
	   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
	   *
	   *         // setup tile width and height according to the options
	   *         var size = this.getTileSize();
	   *         tile.width = size.x;
	   *         tile.height = size.y;
	   *
	   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
	   *         var ctx = tile.getContext('2d');
	   *
	   *         // return the tile so it can be rendered on screen
	   *         return tile;
	   *     }
	   * });
	   * ```
	   *
	   * @section Asynchronous usage
	   * @example
	   *
	   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
	   *
	   * ```js
	   * var CanvasLayer = L.GridLayer.extend({
	   *     createTile: function(coords, done){
	   *         var error;
	   *
	   *         // create a <canvas> element for drawing
	   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
	   *
	   *         // setup tile width and height according to the options
	   *         var size = this.getTileSize();
	   *         tile.width = size.x;
	   *         tile.height = size.y;
	   *
	   *         // draw something asynchronously and pass the tile to the done() callback
	   *         setTimeout(function() {
	   *             done(error, tile);
	   *         }, 1000);
	   *
	   *         return tile;
	   *     }
	   * });
	   * ```
	   *
	   * @section
	   */
	
	
	  var GridLayer = Layer.extend({
	
	  	// @section
	  	// @aka GridLayer options
	  	options: {
	  		// @option tileSize: Number|Point = 256
	  		// Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
	  		tileSize: 256,
	
	  		// @option opacity: Number = 1.0
	  		// Opacity of the tiles. Can be used in the `createTile()` function.
	  		opacity: 1,
	
	  		// @option updateWhenIdle: Boolean = (depends)
	  		// Load new tiles only when panning ends.
	  		// `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
	  		// `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
	  		// [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
	  		updateWhenIdle: mobile,
	
	  		// @option updateWhenZooming: Boolean = true
	  		// By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
	  		updateWhenZooming: true,
	
	  		// @option updateInterval: Number = 200
	  		// Tiles will not update more than once every `updateInterval` milliseconds when panning.
	  		updateInterval: 200,
	
	  		// @option zIndex: Number = 1
	  		// The explicit zIndex of the tile layer.
	  		zIndex: 1,
	
	  		// @option bounds: LatLngBounds = undefined
	  		// If set, tiles will only be loaded inside the set `LatLngBounds`.
	  		bounds: null,
	
	  		// @option minZoom: Number = 0
	  		// The minimum zoom level down to which this layer will be displayed (inclusive).
	  		minZoom: 0,
	
	  		// @option maxZoom: Number = undefined
	  		// The maximum zoom level up to which this layer will be displayed (inclusive).
	  		maxZoom: undefined,
	
	  		// @option maxNativeZoom: Number = undefined
	  		// Maximum zoom number the tile source has available. If it is specified,
	  		// the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
	  		// from `maxNativeZoom` level and auto-scaled.
	  		maxNativeZoom: undefined,
	
	  		// @option minNativeZoom: Number = undefined
	  		// Minimum zoom number the tile source has available. If it is specified,
	  		// the tiles on all zoom levels lower than `minNativeZoom` will be loaded
	  		// from `minNativeZoom` level and auto-scaled.
	  		minNativeZoom: undefined,
	
	  		// @option noWrap: Boolean = false
	  		// Whether the layer is wrapped around the antimeridian. If `true`, the
	  		// GridLayer will only be displayed once at low zoom levels. Has no
	  		// effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
	  		// in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
	  		// tiles outside the CRS limits.
	  		noWrap: false,
	
	  		// @option pane: String = 'tilePane'
	  		// `Map pane` where the grid layer will be added.
	  		pane: 'tilePane',
	
	  		// @option className: String = ''
	  		// A custom class name to assign to the tile layer. Empty by default.
	  		className: '',
	
	  		// @option keepBuffer: Number = 2
	  		// When panning the map, keep this many rows and columns of tiles before unloading them.
	  		keepBuffer: 2
	  	},
	
	  	initialize: function (options) {
	  		setOptions(this, options);
	  	},
	
	  	onAdd: function () {
	  		this._initContainer();
	
	  		this._levels = {};
	  		this._tiles = {};
	
	  		this._resetView();
	  		this._update();
	  	},
	
	  	beforeAdd: function (map) {
	  		map._addZoomLimit(this);
	  	},
	
	  	onRemove: function (map) {
	  		this._removeAllTiles();
	  		remove(this._container);
	  		map._removeZoomLimit(this);
	  		this._container = null;
	  		this._tileZoom = undefined;
	  	},
	
	  	// @method bringToFront: this
	  	// Brings the tile layer to the top of all tile layers.
	  	bringToFront: function () {
	  		if (this._map) {
	  			toFront(this._container);
	  			this._setAutoZIndex(Math.max);
	  		}
	  		return this;
	  	},
	
	  	// @method bringToBack: this
	  	// Brings the tile layer to the bottom of all tile layers.
	  	bringToBack: function () {
	  		if (this._map) {
	  			toBack(this._container);
	  			this._setAutoZIndex(Math.min);
	  		}
	  		return this;
	  	},
	
	  	// @method getContainer: HTMLElement
	  	// Returns the HTML element that contains the tiles for this layer.
	  	getContainer: function () {
	  		return this._container;
	  	},
	
	  	// @method setOpacity(opacity: Number): this
	  	// Changes the [opacity](#gridlayer-opacity) of the grid layer.
	  	setOpacity: function (opacity) {
	  		this.options.opacity = opacity;
	  		this._updateOpacity();
	  		return this;
	  	},
	
	  	// @method setZIndex(zIndex: Number): this
	  	// Changes the [zIndex](#gridlayer-zindex) of the grid layer.
	  	setZIndex: function (zIndex) {
	  		this.options.zIndex = zIndex;
	  		this._updateZIndex();
	
	  		return this;
	  	},
	
	  	// @method isLoading: Boolean
	  	// Returns `true` if any tile in the grid layer has not finished loading.
	  	isLoading: function () {
	  		return this._loading;
	  	},
	
	  	// @method redraw: this
	  	// Causes the layer to clear all the tiles and request them again.
	  	redraw: function () {
	  		if (this._map) {
	  			this._removeAllTiles();
	  			this._update();
	  		}
	  		return this;
	  	},
	
	  	getEvents: function () {
	  		var events = {
	  			viewprereset: this._invalidateAll,
	  			viewreset: this._resetView,
	  			zoom: this._resetView,
	  			moveend: this._onMoveEnd
	  		};
	
	  		if (!this.options.updateWhenIdle) {
	  			// update tiles on move, but not more often than once per given interval
	  			if (!this._onMove) {
	  				this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
	  			}
	
	  			events.move = this._onMove;
	  		}
	
	  		if (this._zoomAnimated) {
	  			events.zoomanim = this._animateZoom;
	  		}
	
	  		return events;
	  	},
	
	  	// @section Extension methods
	  	// Layers extending `GridLayer` shall reimplement the following method.
	  	// @method createTile(coords: Object, done?: Function): HTMLElement
	  	// Called only internally, must be overridden by classes extending `GridLayer`.
	  	// Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
	  	// is specified, it must be called when the tile has finished loading and drawing.
	  	createTile: function () {
	  		return document.createElement('div');
	  	},
	
	  	// @section
	  	// @method getTileSize: Point
	  	// Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
	  	getTileSize: function () {
	  		var s = this.options.tileSize;
	  		return s instanceof Point ? s : new Point(s, s);
	  	},
	
	  	_updateZIndex: function () {
	  		if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) {
	  			this._container.style.zIndex = this.options.zIndex;
	  		}
	  	},
	
	  	_setAutoZIndex: function (compare) {
	  		// go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
	
	  		var layers = this.getPane().children,
	  		    edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
	
	  		for (var i = 0, len = layers.length, zIndex; i < len; i++) {
	
	  			zIndex = layers[i].style.zIndex;
	
	  			if (layers[i] !== this._container && zIndex) {
	  				edgeZIndex = compare(edgeZIndex, +zIndex);
	  			}
	  		}
	
	  		if (isFinite(edgeZIndex)) {
	  			this.options.zIndex = edgeZIndex + compare(-1, 1);
	  			this._updateZIndex();
	  		}
	  	},
	
	  	_updateOpacity: function () {
	  		if (!this._map) { return; }
	
	  		// IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
	  		if (ielt9) { return; }
	
	  		setOpacity(this._container, this.options.opacity);
	
	  		var now = +new Date(),
	  		    nextFrame = false,
	  		    willPrune = false;
	
	  		for (var key in this._tiles) {
	  			var tile = this._tiles[key];
	  			if (!tile.current || !tile.loaded) { continue; }
	
	  			var fade = Math.min(1, (now - tile.loaded) / 200);
	
	  			setOpacity(tile.el, fade);
	  			if (fade < 1) {
	  				nextFrame = true;
	  			} else {
	  				if (tile.active) {
	  					willPrune = true;
	  				} else {
	  					this._onOpaqueTile(tile);
	  				}
	  				tile.active = true;
	  			}
	  		}
	
	  		if (willPrune && !this._noPrune) { this._pruneTiles(); }
	
	  		if (nextFrame) {
	  			cancelAnimFrame(this._fadeFrame);
	  			this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
	  		}
	  	},
	
	  	_onOpaqueTile: falseFn,
	
	  	_initContainer: function () {
	  		if (this._container) { return; }
	
	  		this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
	  		this._updateZIndex();
	
	  		if (this.options.opacity < 1) {
	  			this._updateOpacity();
	  		}
	
	  		this.getPane().appendChild(this._container);
	  	},
	
	  	_updateLevels: function () {
	
	  		var zoom = this._tileZoom,
	  		    maxZoom = this.options.maxZoom;
	
	  		if (zoom === undefined) { return undefined; }
	
	  		for (var z in this._levels) {
	  			z = Number(z);
	  			if (this._levels[z].el.children.length || z === zoom) {
	  				this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
	  				this._onUpdateLevel(z);
	  			} else {
	  				remove(this._levels[z].el);
	  				this._removeTilesAtZoom(z);
	  				this._onRemoveLevel(z);
	  				delete this._levels[z];
	  			}
	  		}
	
	  		var level = this._levels[zoom],
	  		    map = this._map;
	
	  		if (!level) {
	  			level = this._levels[zoom] = {};
	
	  			level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
	  			level.el.style.zIndex = maxZoom;
	
	  			level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
	  			level.zoom = zoom;
	
	  			this._setZoomTransform(level, map.getCenter(), map.getZoom());
	
	  			// force the browser to consider the newly added element for transition
	  			falseFn(level.el.offsetWidth);
	
	  			this._onCreateLevel(level);
	  		}
	
	  		this._level = level;
	
	  		return level;
	  	},
	
	  	_onUpdateLevel: falseFn,
	
	  	_onRemoveLevel: falseFn,
	
	  	_onCreateLevel: falseFn,
	
	  	_pruneTiles: function () {
	  		if (!this._map) {
	  			return;
	  		}
	
	  		var key, tile;
	
	  		var zoom = this._map.getZoom();
	  		if (zoom > this.options.maxZoom ||
	  			zoom < this.options.minZoom) {
	  			this._removeAllTiles();
	  			return;
	  		}
	
	  		for (key in this._tiles) {
	  			tile = this._tiles[key];
	  			tile.retain = tile.current;
	  		}
	
	  		for (key in this._tiles) {
	  			tile = this._tiles[key];
	  			if (tile.current && !tile.active) {
	  				var coords = tile.coords;
	  				if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) {
	  					this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
	  				}
	  			}
	  		}
	
	  		for (key in this._tiles) {
	  			if (!this._tiles[key].retain) {
	  				this._removeTile(key);
	  			}
	  		}
	  	},
	
	  	_removeTilesAtZoom: function (zoom) {
	  		for (var key in this._tiles) {
	  			if (this._tiles[key].coords.z !== zoom) {
	  				continue;
	  			}
	  			this._removeTile(key);
	  		}
	  	},
	
	  	_removeAllTiles: function () {
	  		for (var key in this._tiles) {
	  			this._removeTile(key);
	  		}
	  	},
	
	  	_invalidateAll: function () {
	  		for (var z in this._levels) {
	  			remove(this._levels[z].el);
	  			this._onRemoveLevel(Number(z));
	  			delete this._levels[z];
	  		}
	  		this._removeAllTiles();
	
	  		this._tileZoom = undefined;
	  	},
	
	  	_retainParent: function (x, y, z, minZoom) {
	  		var x2 = Math.floor(x / 2),
	  		    y2 = Math.floor(y / 2),
	  		    z2 = z - 1,
	  		    coords2 = new Point(+x2, +y2);
	  		coords2.z = +z2;
	
	  		var key = this._tileCoordsToKey(coords2),
	  		    tile = this._tiles[key];
	
	  		if (tile && tile.active) {
	  			tile.retain = true;
	  			return true;
	
	  		} else if (tile && tile.loaded) {
	  			tile.retain = true;
	  		}
	
	  		if (z2 > minZoom) {
	  			return this._retainParent(x2, y2, z2, minZoom);
	  		}
	
	  		return false;
	  	},
	
	  	_retainChildren: function (x, y, z, maxZoom) {
	
	  		for (var i = 2 * x; i < 2 * x + 2; i++) {
	  			for (var j = 2 * y; j < 2 * y + 2; j++) {
	
	  				var coords = new Point(i, j);
	  				coords.z = z + 1;
	
	  				var key = this._tileCoordsToKey(coords),
	  				    tile = this._tiles[key];
	
	  				if (tile && tile.active) {
	  					tile.retain = true;
	  					continue;
	
	  				} else if (tile && tile.loaded) {
	  					tile.retain = true;
	  				}
	
	  				if (z + 1 < maxZoom) {
	  					this._retainChildren(i, j, z + 1, maxZoom);
	  				}
	  			}
	  		}
	  	},
	
	  	_resetView: function (e) {
	  		var animating = e && (e.pinch || e.flyTo);
	  		this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
	  	},
	
	  	_animateZoom: function (e) {
	  		this._setView(e.center, e.zoom, true, e.noUpdate);
	  	},
	
	  	_clampZoom: function (zoom) {
	  		var options = this.options;
	
	  		if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) {
	  			return options.minNativeZoom;
	  		}
	
	  		if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) {
	  			return options.maxNativeZoom;
	  		}
	
	  		return zoom;
	  	},
	
	  	_setView: function (center, zoom, noPrune, noUpdate) {
	  		var tileZoom = Math.round(zoom);
	  		if ((this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom) ||
	  		    (this.options.minZoom !== undefined && tileZoom < this.options.minZoom)) {
	  			tileZoom = undefined;
	  		} else {
	  			tileZoom = this._clampZoom(tileZoom);
	  		}
	
	  		var tileZoomChanged = this.options.updateWhenZooming && (tileZoom !== this._tileZoom);
	
	  		if (!noUpdate || tileZoomChanged) {
	
	  			this._tileZoom = tileZoom;
	
	  			if (this._abortLoading) {
	  				this._abortLoading();
	  			}
	
	  			this._updateLevels();
	  			this._resetGrid();
	
	  			if (tileZoom !== undefined) {
	  				this._update(center);
	  			}
	
	  			if (!noPrune) {
	  				this._pruneTiles();
	  			}
	
	  			// Flag to prevent _updateOpacity from pruning tiles during
	  			// a zoom anim or a pinch gesture
	  			this._noPrune = !!noPrune;
	  		}
	
	  		this._setZoomTransforms(center, zoom);
	  	},
	
	  	_setZoomTransforms: function (center, zoom) {
	  		for (var i in this._levels) {
	  			this._setZoomTransform(this._levels[i], center, zoom);
	  		}
	  	},
	
	  	_setZoomTransform: function (level, center, zoom) {
	  		var scale = this._map.getZoomScale(zoom, level.zoom),
	  		    translate = level.origin.multiplyBy(scale)
	  		        .subtract(this._map._getNewPixelOrigin(center, zoom)).round();
	
	  		if (any3d) {
	  			setTransform(level.el, translate, scale);
	  		} else {
	  			setPosition(level.el, translate);
	  		}
	  	},
	
	  	_resetGrid: function () {
	  		var map = this._map,
	  		    crs = map.options.crs,
	  		    tileSize = this._tileSize = this.getTileSize(),
	  		    tileZoom = this._tileZoom;
	
	  		var bounds = this._map.getPixelWorldBounds(this._tileZoom);
	  		if (bounds) {
	  			this._globalTileRange = this._pxBoundsToTileRange(bounds);
	  		}
	
	  		this._wrapX = crs.wrapLng && !this.options.noWrap && [
	  			Math.floor(map.project([0, crs.wrapLng[0]], tileZoom).x / tileSize.x),
	  			Math.ceil(map.project([0, crs.wrapLng[1]], tileZoom).x / tileSize.y)
	  		];
	  		this._wrapY = crs.wrapLat && !this.options.noWrap && [
	  			Math.floor(map.project([crs.wrapLat[0], 0], tileZoom).y / tileSize.x),
	  			Math.ceil(map.project([crs.wrapLat[1], 0], tileZoom).y / tileSize.y)
	  		];
	  	},
	
	  	_onMoveEnd: function () {
	  		if (!this._map || this._map._animatingZoom) { return; }
	
	  		this._update();
	  	},
	
	  	_getTiledPixelBounds: function (center) {
	  		var map = this._map,
	  		    mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(),
	  		    scale = map.getZoomScale(mapZoom, this._tileZoom),
	  		    pixelCenter = map.project(center, this._tileZoom).floor(),
	  		    halfSize = map.getSize().divideBy(scale * 2);
	
	  		return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
	  	},
	
	  	// Private method to load tiles in the grid's active zoom level according to map bounds
	  	_update: function (center) {
	  		var map = this._map;
	  		if (!map) { return; }
	  		var zoom = this._clampZoom(map.getZoom());
	
	  		if (center === undefined) { center = map.getCenter(); }
	  		if (this._tileZoom === undefined) { return; }	// if out of minzoom/maxzoom
	
	  		var pixelBounds = this._getTiledPixelBounds(center),
	  		    tileRange = this._pxBoundsToTileRange(pixelBounds),
	  		    tileCenter = tileRange.getCenter(),
	  		    queue = [],
	  		    margin = this.options.keepBuffer,
	  		    noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([margin, -margin]),
	  		                              tileRange.getTopRight().add([margin, -margin]));
	
	  		// Sanity check: panic if the tile range contains Infinity somewhere.
	  		if (!(isFinite(tileRange.min.x) &&
	  		      isFinite(tileRange.min.y) &&
	  		      isFinite(tileRange.max.x) &&
	  		      isFinite(tileRange.max.y))) { throw new Error('Attempted to load an infinite number of tiles'); }
	
	  		for (var key in this._tiles) {
	  			var c = this._tiles[key].coords;
	  			if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) {
	  				this._tiles[key].current = false;
	  			}
	  		}
	
	  		// _update just loads more tiles. If the tile zoom level differs too much
	  		// from the map's, let _setView reset levels and prune old tiles.
	  		if (Math.abs(zoom - this._tileZoom) > 1) { this._setView(center, zoom); return; }
	
	  		// create a queue of coordinates to load tiles from
	  		for (var j = tileRange.min.y; j <= tileRange.max.y; j++) {
	  			for (var i = tileRange.min.x; i <= tileRange.max.x; i++) {
	  				var coords = new Point(i, j);
	  				coords.z = this._tileZoom;
	
	  				if (!this._isValidTile(coords)) { continue; }
	
	  				var tile = this._tiles[this._tileCoordsToKey(coords)];
	  				if (tile) {
	  					tile.current = true;
	  				} else {
	  					queue.push(coords);
	  				}
	  			}
	  		}
	
	  		// sort tile queue to load tiles in order of their distance to center
	  		queue.sort(function (a, b) {
	  			return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
	  		});
	
	  		if (queue.length !== 0) {
	  			// if it's the first batch of tiles to load
	  			if (!this._loading) {
	  				this._loading = true;
	  				// @event loading: Event
	  				// Fired when the grid layer starts loading tiles.
	  				this.fire('loading');
	  			}
	
	  			// create DOM fragment to append tiles in one batch
	  			var fragment = document.createDocumentFragment();
	
	  			for (i = 0; i < queue.length; i++) {
	  				this._addTile(queue[i], fragment);
	  			}
	
	  			this._level.el.appendChild(fragment);
	  		}
	  	},
	
	  	_isValidTile: function (coords) {
	  		var crs = this._map.options.crs;
	
	  		if (!crs.infinite) {
	  			// don't load tile if it's out of bounds and not wrapped
	  			var bounds = this._globalTileRange;
	  			if ((!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x)) ||
	  			    (!crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y))) { return false; }
	  		}
	
	  		if (!this.options.bounds) { return true; }
	
	  		// don't load tile if it doesn't intersect the bounds in options
	  		var tileBounds = this._tileCoordsToBounds(coords);
	  		return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
	  	},
	
	  	_keyToBounds: function (key) {
	  		return this._tileCoordsToBounds(this._keyToTileCoords(key));
	  	},
	
	  	_tileCoordsToNwSe: function (coords) {
	  		var map = this._map,
	  		    tileSize = this.getTileSize(),
	  		    nwPoint = coords.scaleBy(tileSize),
	  		    sePoint = nwPoint.add(tileSize),
	  		    nw = map.unproject(nwPoint, coords.z),
	  		    se = map.unproject(sePoint, coords.z);
	  		return [nw, se];
	  	},
	
	  	// converts tile coordinates to its geographical bounds
	  	_tileCoordsToBounds: function (coords) {
	  		var bp = this._tileCoordsToNwSe(coords),
	  		    bounds = new LatLngBounds(bp[0], bp[1]);
	
	  		if (!this.options.noWrap) {
	  			bounds = this._map.wrapLatLngBounds(bounds);
	  		}
	  		return bounds;
	  	},
	  	// converts tile coordinates to key for the tile cache
	  	_tileCoordsToKey: function (coords) {
	  		return coords.x + ':' + coords.y + ':' + coords.z;
	  	},
	
	  	// converts tile cache key to coordinates
	  	_keyToTileCoords: function (key) {
	  		var k = key.split(':'),
	  		    coords = new Point(+k[0], +k[1]);
	  		coords.z = +k[2];
	  		return coords;
	  	},
	
	  	_removeTile: function (key) {
	  		var tile = this._tiles[key];
	  		if (!tile) { return; }
	
	  		remove(tile.el);
	
	  		delete this._tiles[key];
	
	  		// @event tileunload: TileEvent
	  		// Fired when a tile is removed (e.g. when a tile goes off the screen).
	  		this.fire('tileunload', {
	  			tile: tile.el,
	  			coords: this._keyToTileCoords(key)
	  		});
	  	},
	
	  	_initTile: function (tile) {
	  		addClass(tile, 'leaflet-tile');
	
	  		var tileSize = this.getTileSize();
	  		tile.style.width = tileSize.x + 'px';
	  		tile.style.height = tileSize.y + 'px';
	
	  		tile.onselectstart = falseFn;
	  		tile.onmousemove = falseFn;
	
	  		// update opacity on tiles in IE7-8 because of filter inheritance problems
	  		if (ielt9 && this.options.opacity < 1) {
	  			setOpacity(tile, this.options.opacity);
	  		}
	
	  		// without this hack, tiles disappear after zoom on Chrome for Android
	  		// https://github.com/Leaflet/Leaflet/issues/2078
	  		if (android && !android23) {
	  			tile.style.WebkitBackfaceVisibility = 'hidden';
	  		}
	  	},
	
	  	_addTile: function (coords, container) {
	  		var tilePos = this._getTilePos(coords),
	  		    key = this._tileCoordsToKey(coords);
	
	  		var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
	
	  		this._initTile(tile);
	
	  		// if createTile is defined with a second argument ("done" callback),
	  		// we know that tile is async and will be ready later; otherwise
	  		if (this.createTile.length < 2) {
	  			// mark tile as ready, but delay one frame for opacity animation to happen
	  			requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
	  		}
	
	  		setPosition(tile, tilePos);
	
	  		// save tile in cache
	  		this._tiles[key] = {
	  			el: tile,
	  			coords: coords,
	  			current: true
	  		};
	
	  		container.appendChild(tile);
	  		// @event tileloadstart: TileEvent
	  		// Fired when a tile is requested and starts loading.
	  		this.fire('tileloadstart', {
	  			tile: tile,
	  			coords: coords
	  		});
	  	},
	
	  	_tileReady: function (coords, err, tile) {
	  		if (err) {
	  			// @event tileerror: TileErrorEvent
	  			// Fired when there is an error loading a tile.
	  			this.fire('tileerror', {
	  				error: err,
	  				tile: tile,
	  				coords: coords
	  			});
	  		}
	
	  		var key = this._tileCoordsToKey(coords);
	
	  		tile = this._tiles[key];
	  		if (!tile) { return; }
	
	  		tile.loaded = +new Date();
	  		if (this._map._fadeAnimated) {
	  			setOpacity(tile.el, 0);
	  			cancelAnimFrame(this._fadeFrame);
	  			this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
	  		} else {
	  			tile.active = true;
	  			this._pruneTiles();
	  		}
	
	  		if (!err) {
	  			addClass(tile.el, 'leaflet-tile-loaded');
	
	  			// @event tileload: TileEvent
	  			// Fired when a tile loads.
	  			this.fire('tileload', {
	  				tile: tile.el,
	  				coords: coords
	  			});
	  		}
	
	  		if (this._noTilesToLoad()) {
	  			this._loading = false;
	  			// @event load: Event
	  			// Fired when the grid layer loaded all visible tiles.
	  			this.fire('load');
	
	  			if (ielt9 || !this._map._fadeAnimated) {
	  				requestAnimFrame(this._pruneTiles, this);
	  			} else {
	  				// Wait a bit more than 0.2 secs (the duration of the tile fade-in)
	  				// to trigger a pruning.
	  				setTimeout(bind(this._pruneTiles, this), 250);
	  			}
	  		}
	  	},
	
	  	_getTilePos: function (coords) {
	  		return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
	  	},
	
	  	_wrapCoords: function (coords) {
	  		var newCoords = new Point(
	  			this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x,
	  			this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
	  		newCoords.z = coords.z;
	  		return newCoords;
	  	},
	
	  	_pxBoundsToTileRange: function (bounds) {
	  		var tileSize = this.getTileSize();
	  		return new Bounds(
	  			bounds.min.unscaleBy(tileSize).floor(),
	  			bounds.max.unscaleBy(tileSize).ceil().subtract([1, 1]));
	  	},
	
	  	_noTilesToLoad: function () {
	  		for (var key in this._tiles) {
	  			if (!this._tiles[key].loaded) { return false; }
	  		}
	  		return true;
	  	}
	  });
	
	  // @factory L.gridLayer(options?: GridLayer options)
	  // Creates a new instance of GridLayer with the supplied options.
	  function gridLayer(options) {
	  	return new GridLayer(options);
	  }
	
	  /*
	   * @class TileLayer
	   * @inherits GridLayer
	   * @aka L.TileLayer
	   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
	   *
	   * @example
	   *
	   * ```js
	   * L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>'}).addTo(map);
	   * ```
	   *
	   * @section URL template
	   * @example
	   *
	   * A string of the following form:
	   *
	   * ```
	   * 'http://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
	   * ```
	   *
	   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
	   *
	   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
	   *
	   * ```
	   * L.tileLayer('http://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
	   * ```
	   */
	
	
	  var TileLayer = GridLayer.extend({
	
	  	// @section
	  	// @aka TileLayer options
	  	options: {
	  		// @option minZoom: Number = 0
	  		// The minimum zoom level down to which this layer will be displayed (inclusive).
	  		minZoom: 0,
	
	  		// @option maxZoom: Number = 18
	  		// The maximum zoom level up to which this layer will be displayed (inclusive).
	  		maxZoom: 18,
	
	  		// @option subdomains: String|String[] = 'abc'
	  		// Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
	  		subdomains: 'abc',
	
	  		// @option errorTileUrl: String = ''
	  		// URL to the tile image to show in place of the tile that failed to load.
	  		errorTileUrl: '',
	
	  		// @option zoomOffset: Number = 0
	  		// The zoom number used in tile URLs will be offset with this value.
	  		zoomOffset: 0,
	
	  		// @option tms: Boolean = false
	  		// If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
	  		tms: false,
	
	  		// @option zoomReverse: Boolean = false
	  		// If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
	  		zoomReverse: false,
	
	  		// @option detectRetina: Boolean = false
	  		// If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
	  		detectRetina: false,
	
	  		// @option crossOrigin: Boolean|String = false
	  		// Whether the crossOrigin attribute will be added to the tiles.
	  		// If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
	  		// Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
	  		crossOrigin: false
	  	},
	
	  	initialize: function (url, options) {
	
	  		this._url = url;
	
	  		options = setOptions(this, options);
	
	  		// detecting retina displays, adjusting tileSize and zoom levels
	  		if (options.detectRetina && retina && options.maxZoom > 0) {
	
	  			options.tileSize = Math.floor(options.tileSize / 2);
	
	  			if (!options.zoomReverse) {
	  				options.zoomOffset++;
	  				options.maxZoom--;
	  			} else {
	  				options.zoomOffset--;
	  				options.minZoom++;
	  			}
	
	  			options.minZoom = Math.max(0, options.minZoom);
	  		}
	
	  		if (typeof options.subdomains === 'string') {
	  			options.subdomains = options.subdomains.split('');
	  		}
	
	  		// for https://github.com/Leaflet/Leaflet/issues/137
	  		if (!android) {
	  			this.on('tileunload', this._onTileRemove);
	  		}
	  	},
	
	  	// @method setUrl(url: String, noRedraw?: Boolean): this
	  	// Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
	  	// If the URL does not change, the layer will not be redrawn unless
	  	// the noRedraw parameter is set to false.
	  	setUrl: function (url, noRedraw) {
	  		if (this._url === url && noRedraw === undefined) {
	  			noRedraw = true;
	  		}
	
	  		this._url = url;
	
	  		if (!noRedraw) {
	  			this.redraw();
	  		}
	  		return this;
	  	},
	
	  	// @method createTile(coords: Object, done?: Function): HTMLElement
	  	// Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
	  	// to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
	  	// callback is called when the tile has been loaded.
	  	createTile: function (coords, done) {
	  		var tile = document.createElement('img');
	
	  		on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
	  		on(tile, 'error', bind(this._tileOnError, this, done, tile));
	
	  		if (this.options.crossOrigin || this.options.crossOrigin === '') {
	  			tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
	  		}
	
	  		/*
	  		 Alt tag is set to empty string to keep screen readers from reading URL and for compliance reasons
	  		 http://www.w3.org/TR/WCAG20-TECHS/H67
	  		*/
	  		tile.alt = '';
	
	  		/*
	  		 Set role="presentation" to force screen readers to ignore this
	  		 https://www.w3.org/TR/wai-aria/roles#textalternativecomputation
	  		*/
	  		tile.setAttribute('role', 'presentation');
	
	  		tile.src = this.getTileUrl(coords);
	
	  		return tile;
	  	},
	
	  	// @section Extension methods
	  	// @uninheritable
	  	// Layers extending `TileLayer` might reimplement the following method.
	  	// @method getTileUrl(coords: Object): String
	  	// Called only internally, returns the URL for a tile given its coordinates.
	  	// Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
	  	getTileUrl: function (coords) {
	  		var data = {
	  			r: retina ? '@2x' : '',
	  			s: this._getSubdomain(coords),
	  			x: coords.x,
	  			y: coords.y,
	  			z: this._getZoomForUrl()
	  		};
	  		if (this._map && !this._map.options.crs.infinite) {
	  			var invertedY = this._globalTileRange.max.y - coords.y;
	  			if (this.options.tms) {
	  				data['y'] = invertedY;
	  			}
	  			data['-y'] = invertedY;
	  		}
	
	  		return template(this._url, extend(data, this.options));
	  	},
	
	  	_tileOnLoad: function (done, tile) {
	  		// For https://github.com/Leaflet/Leaflet/issues/3332
	  		if (ielt9) {
	  			setTimeout(bind(done, this, null, tile), 0);
	  		} else {
	  			done(null, tile);
	  		}
	  	},
	
	  	_tileOnError: function (done, tile, e) {
	  		var errorUrl = this.options.errorTileUrl;
	  		if (errorUrl && tile.getAttribute('src') !== errorUrl) {
	  			tile.src = errorUrl;
	  		}
	  		done(e, tile);
	  	},
	
	  	_onTileRemove: function (e) {
	  		e.tile.onload = null;
	  	},
	
	  	_getZoomForUrl: function () {
	  		var zoom = this._tileZoom,
	  		maxZoom = this.options.maxZoom,
	  		zoomReverse = this.options.zoomReverse,
	  		zoomOffset = this.options.zoomOffset;
	
	  		if (zoomReverse) {
	  			zoom = maxZoom - zoom;
	  		}
	
	  		return zoom + zoomOffset;
	  	},
	
	  	_getSubdomain: function (tilePoint) {
	  		var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
	  		return this.options.subdomains[index];
	  	},
	
	  	// stops loading all tiles in the background layer
	  	_abortLoading: function () {
	  		var i, tile;
	  		for (i in this._tiles) {
	  			if (this._tiles[i].coords.z !== this._tileZoom) {
	  				tile = this._tiles[i].el;
	
	  				tile.onload = falseFn;
	  				tile.onerror = falseFn;
	
	  				if (!tile.complete) {
	  					tile.src = emptyImageUrl;
	  					remove(tile);
	  					delete this._tiles[i];
	  				}
	  			}
	  		}
	  	},
	
	  	_removeTile: function (key) {
	  		var tile = this._tiles[key];
	  		if (!tile) { return; }
	
	  		// Cancels any pending http requests associated with the tile
	  		// unless we're on Android's stock browser,
	  		// see https://github.com/Leaflet/Leaflet/issues/137
	  		if (!androidStock) {
	  			tile.el.setAttribute('src', emptyImageUrl);
	  		}
	
	  		return GridLayer.prototype._removeTile.call(this, key);
	  	},
	
	  	_tileReady: function (coords, err, tile) {
	  		if (!this._map || (tile && tile.getAttribute('src') === emptyImageUrl)) {
	  			return;
	  		}
	
	  		return GridLayer.prototype._tileReady.call(this, coords, err, tile);
	  	}
	  });
	
	
	  // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
	  // Instantiates a tile layer object given a `URL template` and optionally an options object.
	
	  function tileLayer(url, options) {
	  	return new TileLayer(url, options);
	  }
	
	  /*
	   * @class TileLayer.WMS
	   * @inherits TileLayer
	   * @aka L.TileLayer.WMS
	   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
	   *
	   * @example
	   *
	   * ```js
	   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
	   * 	layers: 'nexrad-n0r-900913',
	   * 	format: 'image/png',
	   * 	transparent: true,
	   * 	attribution: "Weather data © 2012 IEM Nexrad"
	   * });
	   * ```
	   */
	
	  var TileLayerWMS = TileLayer.extend({
	
	  	// @section
	  	// @aka TileLayer.WMS options
	  	// If any custom options not documented here are used, they will be sent to the
	  	// WMS server as extra parameters in each request URL. This can be useful for
	  	// [non-standard vendor WMS parameters](http://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
	  	defaultWmsParams: {
	  		service: 'WMS',
	  		request: 'GetMap',
	
	  		// @option layers: String = ''
	  		// **(required)** Comma-separated list of WMS layers to show.
	  		layers: '',
	
	  		// @option styles: String = ''
	  		// Comma-separated list of WMS styles.
	  		styles: '',
	
	  		// @option format: String = 'image/jpeg'
	  		// WMS image format (use `'image/png'` for layers with transparency).
	  		format: 'image/jpeg',
	
	  		// @option transparent: Boolean = false
	  		// If `true`, the WMS service will return images with transparency.
	  		transparent: false,
	
	  		// @option version: String = '1.1.1'
	  		// Version of the WMS service to use
	  		version: '1.1.1'
	  	},
	
	  	options: {
	  		// @option crs: CRS = null
	  		// Coordinate Reference System to use for the WMS requests, defaults to
	  		// map CRS. Don't change this if you're not sure what it means.
	  		crs: null,
	
	  		// @option uppercase: Boolean = false
	  		// If `true`, WMS request parameter keys will be uppercase.
	  		uppercase: false
	  	},
	
	  	initialize: function (url, options) {
	
	  		this._url = url;
	
	  		var wmsParams = extend({}, this.defaultWmsParams);
	
	  		// all keys that are not TileLayer options go to WMS params
	  		for (var i in options) {
	  			if (!(i in this.options)) {
	  				wmsParams[i] = options[i];
	  			}
	  		}
	
	  		options = setOptions(this, options);
	
	  		var realRetina = options.detectRetina && retina ? 2 : 1;
	  		var tileSize = this.getTileSize();
	  		wmsParams.width = tileSize.x * realRetina;
	  		wmsParams.height = tileSize.y * realRetina;
	
	  		this.wmsParams = wmsParams;
	  	},
	
	  	onAdd: function (map) {
	
	  		this._crs = this.options.crs || map.options.crs;
	  		this._wmsVersion = parseFloat(this.wmsParams.version);
	
	  		var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
	  		this.wmsParams[projectionKey] = this._crs.code;
	
	  		TileLayer.prototype.onAdd.call(this, map);
	  	},
	
	  	getTileUrl: function (coords) {
	
	  		var tileBounds = this._tileCoordsToNwSe(coords),
	  		    crs = this._crs,
	  		    bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])),
	  		    min = bounds.min,
	  		    max = bounds.max,
	  		    bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ?
	  		    [min.y, min.x, max.y, max.x] :
	  		    [min.x, min.y, max.x, max.y]).join(','),
	  		    url = TileLayer.prototype.getTileUrl.call(this, coords);
	  		return url +
	  			getParamString(this.wmsParams, url, this.options.uppercase) +
	  			(this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
	  	},
	
	  	// @method setParams(params: Object, noRedraw?: Boolean): this
	  	// Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
	  	setParams: function (params, noRedraw) {
	
	  		extend(this.wmsParams, params);
	
	  		if (!noRedraw) {
	  			this.redraw();
	  		}
	
	  		return this;
	  	}
	  });
	
	
	  // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
	  // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
	  function tileLayerWMS(url, options) {
	  	return new TileLayerWMS(url, options);
	  }
	
	  TileLayer.WMS = TileLayerWMS;
	  tileLayer.wms = tileLayerWMS;
	
	  /*
	   * @class Renderer
	   * @inherits Layer
	   * @aka L.Renderer
	   *
	   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
	   * DOM container of the renderer, its bounds, and its zoom animation.
	   *
	   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
	   * itself can be added or removed to the map. All paths use a renderer, which can
	   * be implicit (the map will decide the type of renderer and use it automatically)
	   * or explicit (using the [`renderer`](#path-renderer) option of the path).
	   *
	   * Do not use this class directly, use `SVG` and `Canvas` instead.
	   *
	   * @event update: Event
	   * Fired when the renderer updates its bounds, center and zoom, for example when
	   * its map has moved
	   */
	
	  var Renderer = Layer.extend({
	
	  	// @section
	  	// @aka Renderer options
	  	options: {
	  		// @option padding: Number = 0.1
	  		// How much to extend the clip area around the map view (relative to its size)
	  		// e.g. 0.1 would be 10% of map view in each direction
	  		padding: 0.1,
	
	  		// @option tolerance: Number = 0
	  		// How much to extend click tolerance round a path/object on the map
	  		tolerance : 0
	  	},
	
	  	initialize: function (options) {
	  		setOptions(this, options);
	  		stamp(this);
	  		this._layers = this._layers || {};
	  	},
	
	  	onAdd: function () {
	  		if (!this._container) {
	  			this._initContainer(); // defined by renderer implementations
	
	  			if (this._zoomAnimated) {
	  				addClass(this._container, 'leaflet-zoom-animated');
	  			}
	  		}
	
	  		this.getPane().appendChild(this._container);
	  		this._update();
	  		this.on('update', this._updatePaths, this);
	  	},
	
	  	onRemove: function () {
	  		this.off('update', this._updatePaths, this);
	  		this._destroyContainer();
	  	},
	
	  	getEvents: function () {
	  		var events = {
	  			viewreset: this._reset,
	  			zoom: this._onZoom,
	  			moveend: this._update,
	  			zoomend: this._onZoomEnd
	  		};
	  		if (this._zoomAnimated) {
	  			events.zoomanim = this._onAnimZoom;
	  		}
	  		return events;
	  	},
	
	  	_onAnimZoom: function (ev) {
	  		this._updateTransform(ev.center, ev.zoom);
	  	},
	
	  	_onZoom: function () {
	  		this._updateTransform(this._map.getCenter(), this._map.getZoom());
	  	},
	
	  	_updateTransform: function (center, zoom) {
	  		var scale = this._map.getZoomScale(zoom, this._zoom),
	  		    position = getPosition(this._container),
	  		    viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding),
	  		    currentCenterPoint = this._map.project(this._center, zoom),
	  		    destCenterPoint = this._map.project(center, zoom),
	  		    centerOffset = destCenterPoint.subtract(currentCenterPoint),
	
	  		    topLeftOffset = viewHalf.multiplyBy(-scale).add(position).add(viewHalf).subtract(centerOffset);
	
	  		if (any3d) {
	  			setTransform(this._container, topLeftOffset, scale);
	  		} else {
	  			setPosition(this._container, topLeftOffset);
	  		}
	  	},
	
	  	_reset: function () {
	  		this._update();
	  		this._updateTransform(this._center, this._zoom);
	
	  		for (var id in this._layers) {
	  			this._layers[id]._reset();
	  		}
	  	},
	
	  	_onZoomEnd: function () {
	  		for (var id in this._layers) {
	  			this._layers[id]._project();
	  		}
	  	},
	
	  	_updatePaths: function () {
	  		for (var id in this._layers) {
	  			this._layers[id]._update();
	  		}
	  	},
	
	  	_update: function () {
	  		// Update pixel bounds of renderer container (for positioning/sizing/clipping later)
	  		// Subclasses are responsible of firing the 'update' event.
	  		var p = this.options.padding,
	  		    size = this._map.getSize(),
	  		    min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
	
	  		this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
	
	  		this._center = this._map.getCenter();
	  		this._zoom = this._map.getZoom();
	  	}
	  });
	
	  /*
	   * @class Canvas
	   * @inherits Renderer
	   * @aka L.Canvas
	   *
	   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
	   * Inherits `Renderer`.
	   *
	   * Due to [technical limitations](http://caniuse.com/#search=canvas), Canvas is not
	   * available in all web browsers, notably IE8, and overlapping geometries might
	   * not display properly in some edge cases.
	   *
	   * @example
	   *
	   * Use Canvas by default for all paths in the map:
	   *
	   * ```js
	   * var map = L.map('map', {
	   * 	renderer: L.canvas()
	   * });
	   * ```
	   *
	   * Use a Canvas renderer with extra padding for specific vector geometries:
	   *
	   * ```js
	   * var map = L.map('map');
	   * var myRenderer = L.canvas({ padding: 0.5 });
	   * var line = L.polyline( coordinates, { renderer: myRenderer } );
	   * var circle = L.circle( center, { renderer: myRenderer } );
	   * ```
	   */
	
	  var Canvas = Renderer.extend({
	  	getEvents: function () {
	  		var events = Renderer.prototype.getEvents.call(this);
	  		events.viewprereset = this._onViewPreReset;
	  		return events;
	  	},
	
	  	_onViewPreReset: function () {
	  		// Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
	  		this._postponeUpdatePaths = true;
	  	},
	
	  	onAdd: function () {
	  		Renderer.prototype.onAdd.call(this);
	
	  		// Redraw vectors since canvas is cleared upon removal,
	  		// in case of removing the renderer itself from the map.
	  		this._draw();
	  	},
	
	  	_initContainer: function () {
	  		var container = this._container = document.createElement('canvas');
	
	  		on(container, 'mousemove', this._onMouseMove, this);
	  		on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
	  		on(container, 'mouseout', this._handleMouseOut, this);
	
	  		this._ctx = container.getContext('2d');
	  	},
	
	  	_destroyContainer: function () {
	  		cancelAnimFrame(this._redrawRequest);
	  		delete this._ctx;
	  		remove(this._container);
	  		off(this._container);
	  		delete this._container;
	  	},
	
	  	_updatePaths: function () {
	  		if (this._postponeUpdatePaths) { return; }
	
	  		var layer;
	  		this._redrawBounds = null;
	  		for (var id in this._layers) {
	  			layer = this._layers[id];
	  			layer._update();
	  		}
	  		this._redraw();
	  	},
	
	  	_update: function () {
	  		if (this._map._animatingZoom && this._bounds) { return; }
	
	  		Renderer.prototype._update.call(this);
	
	  		var b = this._bounds,
	  		    container = this._container,
	  		    size = b.getSize(),
	  		    m = retina ? 2 : 1;
	
	  		setPosition(container, b.min);
	
	  		// set canvas size (also clearing it); use double size on retina
	  		container.width = m * size.x;
	  		container.height = m * size.y;
	  		container.style.width = size.x + 'px';
	  		container.style.height = size.y + 'px';
	
	  		if (retina) {
	  			this._ctx.scale(2, 2);
	  		}
	
	  		// translate so we use the same path coordinates after canvas element moves
	  		this._ctx.translate(-b.min.x, -b.min.y);
	
	  		// Tell paths to redraw themselves
	  		this.fire('update');
	  	},
	
	  	_reset: function () {
	  		Renderer.prototype._reset.call(this);
	
	  		if (this._postponeUpdatePaths) {
	  			this._postponeUpdatePaths = false;
	  			this._updatePaths();
	  		}
	  	},
	
	  	_initPath: function (layer) {
	  		this._updateDashArray(layer);
	  		this._layers[stamp(layer)] = layer;
	
	  		var order = layer._order = {
	  			layer: layer,
	  			prev: this._drawLast,
	  			next: null
	  		};
	  		if (this._drawLast) { this._drawLast.next = order; }
	  		this._drawLast = order;
	  		this._drawFirst = this._drawFirst || this._drawLast;
	  	},
	
	  	_addPath: function (layer) {
	  		this._requestRedraw(layer);
	  	},
	
	  	_removePath: function (layer) {
	  		var order = layer._order;
	  		var next = order.next;
	  		var prev = order.prev;
	
	  		if (next) {
	  			next.prev = prev;
	  		} else {
	  			this._drawLast = prev;
	  		}
	  		if (prev) {
	  			prev.next = next;
	  		} else {
	  			this._drawFirst = next;
	  		}
	
	  		delete layer._order;
	
	  		delete this._layers[stamp(layer)];
	
	  		this._requestRedraw(layer);
	  	},
	
	  	_updatePath: function (layer) {
	  		// Redraw the union of the layer's old pixel
	  		// bounds and the new pixel bounds.
	  		this._extendRedrawBounds(layer);
	  		layer._project();
	  		layer._update();
	  		// The redraw will extend the redraw bounds
	  		// with the new pixel bounds.
	  		this._requestRedraw(layer);
	  	},
	
	  	_updateStyle: function (layer) {
	  		this._updateDashArray(layer);
	  		this._requestRedraw(layer);
	  	},
	
	  	_updateDashArray: function (layer) {
	  		if (typeof layer.options.dashArray === 'string') {
	  			var parts = layer.options.dashArray.split(/[, ]+/),
	  			    dashArray = [],
	  			    dashValue,
	  			    i;
	  			for (i = 0; i < parts.length; i++) {
	  				dashValue = Number(parts[i]);
	  				// Ignore dash array containing invalid lengths
	  				if (isNaN(dashValue)) { return; }
	  				dashArray.push(dashValue);
	  			}
	  			layer.options._dashArray = dashArray;
	  		} else {
	  			layer.options._dashArray = layer.options.dashArray;
	  		}
	  	},
	
	  	_requestRedraw: function (layer) {
	  		if (!this._map) { return; }
	
	  		this._extendRedrawBounds(layer);
	  		this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
	  	},
	
	  	_extendRedrawBounds: function (layer) {
	  		if (layer._pxBounds) {
	  			var padding = (layer.options.weight || 0) + 1;
	  			this._redrawBounds = this._redrawBounds || new Bounds();
	  			this._redrawBounds.extend(layer._pxBounds.min.subtract([padding, padding]));
	  			this._redrawBounds.extend(layer._pxBounds.max.add([padding, padding]));
	  		}
	  	},
	
	  	_redraw: function () {
	  		this._redrawRequest = null;
	
	  		if (this._redrawBounds) {
	  			this._redrawBounds.min._floor();
	  			this._redrawBounds.max._ceil();
	  		}
	
	  		this._clear(); // clear layers in redraw bounds
	  		this._draw(); // draw layers
	
	  		this._redrawBounds = null;
	  	},
	
	  	_clear: function () {
	  		var bounds = this._redrawBounds;
	  		if (bounds) {
	  			var size = bounds.getSize();
	  			this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
	  		} else {
	  			this._ctx.save();
	  			this._ctx.setTransform(1, 0, 0, 1, 0, 0);
	  			this._ctx.clearRect(0, 0, this._container.width, this._container.height);
	  			this._ctx.restore();
	  		}
	  	},
	
	  	_draw: function () {
	  		var layer, bounds = this._redrawBounds;
	  		this._ctx.save();
	  		if (bounds) {
	  			var size = bounds.getSize();
	  			this._ctx.beginPath();
	  			this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
	  			this._ctx.clip();
	  		}
	
	  		this._drawing = true;
	
	  		for (var order = this._drawFirst; order; order = order.next) {
	  			layer = order.layer;
	  			if (!bounds || (layer._pxBounds && layer._pxBounds.intersects(bounds))) {
	  				layer._updatePath();
	  			}
	  		}
	
	  		this._drawing = false;
	
	  		this._ctx.restore();  // Restore state before clipping.
	  	},
	
	  	_updatePoly: function (layer, closed) {
	  		if (!this._drawing) { return; }
	
	  		var i, j, len2, p,
	  		    parts = layer._parts,
	  		    len = parts.length,
	  		    ctx = this._ctx;
	
	  		if (!len) { return; }
	
	  		ctx.beginPath();
	
	  		for (i = 0; i < len; i++) {
	  			for (j = 0, len2 = parts[i].length; j < len2; j++) {
	  				p = parts[i][j];
	  				ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
	  			}
	  			if (closed) {
	  				ctx.closePath();
	  			}
	  		}
	
	  		this._fillStroke(ctx, layer);
	
	  		// TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
	  	},
	
	  	_updateCircle: function (layer) {
	
	  		if (!this._drawing || layer._empty()) { return; }
	
	  		var p = layer._point,
	  		    ctx = this._ctx,
	  		    r = Math.max(Math.round(layer._radius), 1),
	  		    s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
	
	  		if (s !== 1) {
	  			ctx.save();
	  			ctx.scale(1, s);
	  		}
	
	  		ctx.beginPath();
	  		ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
	
	  		if (s !== 1) {
	  			ctx.restore();
	  		}
	
	  		this._fillStroke(ctx, layer);
	  	},
	
	  	_fillStroke: function (ctx, layer) {
	  		var options = layer.options;
	
	  		if (options.fill) {
	  			ctx.globalAlpha = options.fillOpacity;
	  			ctx.fillStyle = options.fillColor || options.color;
	  			ctx.fill(options.fillRule || 'evenodd');
	  		}
	
	  		if (options.stroke && options.weight !== 0) {
	  			if (ctx.setLineDash) {
	  				ctx.setLineDash(layer.options && layer.options._dashArray || []);
	  			}
	  			ctx.globalAlpha = options.opacity;
	  			ctx.lineWidth = options.weight;
	  			ctx.strokeStyle = options.color;
	  			ctx.lineCap = options.lineCap;
	  			ctx.lineJoin = options.lineJoin;
	  			ctx.stroke();
	  		}
	  	},
	
	  	// Canvas obviously doesn't have mouse events for individual drawn objects,
	  	// so we emulate that by calculating what's under the mouse on mousemove/click manually
	
	  	_onClick: function (e) {
	  		var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
	
	  		for (var order = this._drawFirst; order; order = order.next) {
	  			layer = order.layer;
	  			if (layer.options.interactive && layer._containsPoint(point)) {
	  				if (!(e.type === 'click' || e.type !== 'preclick') || !this._map._draggableMoved(layer)) {
	  					clickedLayer = layer;
	  				}
	  			}
	  		}
	  		if (clickedLayer)  {
	  			fakeStop(e);
	  			this._fireEvent([clickedLayer], e);
	  		}
	  	},
	
	  	_onMouseMove: function (e) {
	  		if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) { return; }
	
	  		var point = this._map.mouseEventToLayerPoint(e);
	  		this._handleMouseHover(e, point);
	  	},
	
	
	  	_handleMouseOut: function (e) {
	  		var layer = this._hoveredLayer;
	  		if (layer) {
	  			// if we're leaving the layer, fire mouseout
	  			removeClass(this._container, 'leaflet-interactive');
	  			this._fireEvent([layer], e, 'mouseout');
	  			this._hoveredLayer = null;
	  			this._mouseHoverThrottled = false;
	  		}
	  	},
	
	  	_handleMouseHover: function (e, point) {
	  		if (this._mouseHoverThrottled) {
	  			return;
	  		}
	
	  		var layer, candidateHoveredLayer;
	
	  		for (var order = this._drawFirst; order; order = order.next) {
	  			layer = order.layer;
	  			if (layer.options.interactive && layer._containsPoint(point)) {
	  				candidateHoveredLayer = layer;
	  			}
	  		}
	
	  		if (candidateHoveredLayer !== this._hoveredLayer) {
	  			this._handleMouseOut(e);
	
	  			if (candidateHoveredLayer) {
	  				addClass(this._container, 'leaflet-interactive'); // change cursor
	  				this._fireEvent([candidateHoveredLayer], e, 'mouseover');
	  				this._hoveredLayer = candidateHoveredLayer;
	  			}
	  		}
	
	  		if (this._hoveredLayer) {
	  			this._fireEvent([this._hoveredLayer], e);
	  		}
	
	  		this._mouseHoverThrottled = true;
	  		setTimeout(bind(function () {
	  			this._mouseHoverThrottled = false;
	  		}, this), 32);
	  	},
	
	  	_fireEvent: function (layers, e, type) {
	  		this._map._fireDOMEvent(e, type || e.type, layers);
	  	},
	
	  	_bringToFront: function (layer) {
	  		var order = layer._order;
	
	  		if (!order) { return; }
	
	  		var next = order.next;
	  		var prev = order.prev;
	
	  		if (next) {
	  			next.prev = prev;
	  		} else {
	  			// Already last
	  			return;
	  		}
	  		if (prev) {
	  			prev.next = next;
	  		} else if (next) {
	  			// Update first entry unless this is the
	  			// single entry
	  			this._drawFirst = next;
	  		}
	
	  		order.prev = this._drawLast;
	  		this._drawLast.next = order;
	
	  		order.next = null;
	  		this._drawLast = order;
	
	  		this._requestRedraw(layer);
	  	},
	
	  	_bringToBack: function (layer) {
	  		var order = layer._order;
	
	  		if (!order) { return; }
	
	  		var next = order.next;
	  		var prev = order.prev;
	
	  		if (prev) {
	  			prev.next = next;
	  		} else {
	  			// Already first
	  			return;
	  		}
	  		if (next) {
	  			next.prev = prev;
	  		} else if (prev) {
	  			// Update last entry unless this is the
	  			// single entry
	  			this._drawLast = prev;
	  		}
	
	  		order.prev = null;
	
	  		order.next = this._drawFirst;
	  		this._drawFirst.prev = order;
	  		this._drawFirst = order;
	
	  		this._requestRedraw(layer);
	  	}
	  });
	
	  // @factory L.canvas(options?: Renderer options)
	  // Creates a Canvas renderer with the given options.
	  function canvas$1(options) {
	  	return canvas ? new Canvas(options) : null;
	  }
	
	  /*
	   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
	   */
	
	
	  var vmlCreate = (function () {
	  	try {
	  		document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
	  		return function (name) {
	  			return document.createElement('<lvml:' + name + ' class="lvml">');
	  		};
	  	} catch (e) {
	  		return function (name) {
	  			return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
	  		};
	  	}
	  })();
	
	
	  /*
	   * @class SVG
	   *
	   *
	   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
	   * with old versions of Internet Explorer.
	   */
	
	  // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
	  var vmlMixin = {
	
	  	_initContainer: function () {
	  		this._container = create$1('div', 'leaflet-vml-container');
	  	},
	
	  	_update: function () {
	  		if (this._map._animatingZoom) { return; }
	  		Renderer.prototype._update.call(this);
	  		this.fire('update');
	  	},
	
	  	_initPath: function (layer) {
	  		var container = layer._container = vmlCreate('shape');
	
	  		addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
	
	  		container.coordsize = '1 1';
	
	  		layer._path = vmlCreate('path');
	  		container.appendChild(layer._path);
	
	  		this._updateStyle(layer);
	  		this._layers[stamp(layer)] = layer;
	  	},
	
	  	_addPath: function (layer) {
	  		var container = layer._container;
	  		this._container.appendChild(container);
	
	  		if (layer.options.interactive) {
	  			layer.addInteractiveTarget(container);
	  		}
	  	},
	
	  	_removePath: function (layer) {
	  		var container = layer._container;
	  		remove(container);
	  		layer.removeInteractiveTarget(container);
	  		delete this._layers[stamp(layer)];
	  	},
	
	  	_updateStyle: function (layer) {
	  		var stroke = layer._stroke,
	  		    fill = layer._fill,
	  		    options = layer.options,
	  		    container = layer._container;
	
	  		container.stroked = !!options.stroke;
	  		container.filled = !!options.fill;
	
	  		if (options.stroke) {
	  			if (!stroke) {
	  				stroke = layer._stroke = vmlCreate('stroke');
	  			}
	  			container.appendChild(stroke);
	  			stroke.weight = options.weight + 'px';
	  			stroke.color = options.color;
	  			stroke.opacity = options.opacity;
	
	  			if (options.dashArray) {
	  				stroke.dashStyle = isArray(options.dashArray) ?
	  				    options.dashArray.join(' ') :
	  				    options.dashArray.replace(/( *, *)/g, ' ');
	  			} else {
	  				stroke.dashStyle = '';
	  			}
	  			stroke.endcap = options.lineCap.replace('butt', 'flat');
	  			stroke.joinstyle = options.lineJoin;
	
	  		} else if (stroke) {
	  			container.removeChild(stroke);
	  			layer._stroke = null;
	  		}
	
	  		if (options.fill) {
	  			if (!fill) {
	  				fill = layer._fill = vmlCreate('fill');
	  			}
	  			container.appendChild(fill);
	  			fill.color = options.fillColor || options.color;
	  			fill.opacity = options.fillOpacity;
	
	  		} else if (fill) {
	  			container.removeChild(fill);
	  			layer._fill = null;
	  		}
	  	},
	
	  	_updateCircle: function (layer) {
	  		var p = layer._point.round(),
	  		    r = Math.round(layer._radius),
	  		    r2 = Math.round(layer._radiusY || r);
	
	  		this._setPath(layer, layer._empty() ? 'M0 0' :
	  			'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + (65535 * 360));
	  	},
	
	  	_setPath: function (layer, path) {
	  		layer._path.v = path;
	  	},
	
	  	_bringToFront: function (layer) {
	  		toFront(layer._container);
	  	},
	
	  	_bringToBack: function (layer) {
	  		toBack(layer._container);
	  	}
	  };
	
	  var create$2 = vml ? vmlCreate : svgCreate;
	
	  /*
	   * @class SVG
	   * @inherits Renderer
	   * @aka L.SVG
	   *
	   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
	   * Inherits `Renderer`.
	   *
	   * Due to [technical limitations](http://caniuse.com/#search=svg), SVG is not
	   * available in all web browsers, notably Android 2.x and 3.x.
	   *
	   * Although SVG is not available on IE7 and IE8, these browsers support
	   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
	   * (a now deprecated technology), and the SVG renderer will fall back to VML in
	   * this case.
	   *
	   * @example
	   *
	   * Use SVG by default for all paths in the map:
	   *
	   * ```js
	   * var map = L.map('map', {
	   * 	renderer: L.svg()
	   * });
	   * ```
	   *
	   * Use a SVG renderer with extra padding for specific vector geometries:
	   *
	   * ```js
	   * var map = L.map('map');
	   * var myRenderer = L.svg({ padding: 0.5 });
	   * var line = L.polyline( coordinates, { renderer: myRenderer } );
	   * var circle = L.circle( center, { renderer: myRenderer } );
	   * ```
	   */
	
	  var SVG = Renderer.extend({
	
	  	getEvents: function () {
	  		var events = Renderer.prototype.getEvents.call(this);
	  		events.zoomstart = this._onZoomStart;
	  		return events;
	  	},
	
	  	_initContainer: function () {
	  		this._container = create$2('svg');
	
	  		// makes it possible to click through svg root; we'll reset it back in individual paths
	  		this._container.setAttribute('pointer-events', 'none');
	
	  		this._rootGroup = create$2('g');
	  		this._container.appendChild(this._rootGroup);
	  	},
	
	  	_destroyContainer: function () {
	  		remove(this._container);
	  		off(this._container);
	  		delete this._container;
	  		delete this._rootGroup;
	  		delete this._svgSize;
	  	},
	
	  	_onZoomStart: function () {
	  		// Drag-then-pinch interactions might mess up the center and zoom.
	  		// In this case, the easiest way to prevent this is re-do the renderer
	  		//   bounds and padding when the zooming starts.
	  		this._update();
	  	},
	
	  	_update: function () {
	  		if (this._map._animatingZoom && this._bounds) { return; }
	
	  		Renderer.prototype._update.call(this);
	
	  		var b = this._bounds,
	  		    size = b.getSize(),
	  		    container = this._container;
	
	  		// set size of svg-container if changed
	  		if (!this._svgSize || !this._svgSize.equals(size)) {
	  			this._svgSize = size;
	  			container.setAttribute('width', size.x);
	  			container.setAttribute('height', size.y);
	  		}
	
	  		// movement: update container viewBox so that we don't have to change coordinates of individual layers
	  		setPosition(container, b.min);
	  		container.setAttribute('viewBox', [b.min.x, b.min.y, size.x, size.y].join(' '));
	
	  		this.fire('update');
	  	},
	
	  	// methods below are called by vector layers implementations
	
	  	_initPath: function (layer) {
	  		var path = layer._path = create$2('path');
	
	  		// @namespace Path
	  		// @option className: String = null
	  		// Custom class name set on an element. Only for SVG renderer.
	  		if (layer.options.className) {
	  			addClass(path, layer.options.className);
	  		}
	
	  		if (layer.options.interactive) {
	  			addClass(path, 'leaflet-interactive');
	  		}
	
	  		this._updateStyle(layer);
	  		this._layers[stamp(layer)] = layer;
	  	},
	
	  	_addPath: function (layer) {
	  		if (!this._rootGroup) { this._initContainer(); }
	  		this._rootGroup.appendChild(layer._path);
	  		layer.addInteractiveTarget(layer._path);
	  	},
	
	  	_removePath: function (layer) {
	  		remove(layer._path);
	  		layer.removeInteractiveTarget(layer._path);
	  		delete this._layers[stamp(layer)];
	  	},
	
	  	_updatePath: function (layer) {
	  		layer._project();
	  		layer._update();
	  	},
	
	  	_updateStyle: function (layer) {
	  		var path = layer._path,
	  		    options = layer.options;
	
	  		if (!path) { return; }
	
	  		if (options.stroke) {
	  			path.setAttribute('stroke', options.color);
	  			path.setAttribute('stroke-opacity', options.opacity);
	  			path.setAttribute('stroke-width', options.weight);
	  			path.setAttribute('stroke-linecap', options.lineCap);
	  			path.setAttribute('stroke-linejoin', options.lineJoin);
	
	  			if (options.dashArray) {
	  				path.setAttribute('stroke-dasharray', options.dashArray);
	  			} else {
	  				path.removeAttribute('stroke-dasharray');
	  			}
	
	  			if (options.dashOffset) {
	  				path.setAttribute('stroke-dashoffset', options.dashOffset);
	  			} else {
	  				path.removeAttribute('stroke-dashoffset');
	  			}
	  		} else {
	  			path.setAttribute('stroke', 'none');
	  		}
	
	  		if (options.fill) {
	  			path.setAttribute('fill', options.fillColor || options.color);
	  			path.setAttribute('fill-opacity', options.fillOpacity);
	  			path.setAttribute('fill-rule', options.fillRule || 'evenodd');
	  		} else {
	  			path.setAttribute('fill', 'none');
	  		}
	  	},
	
	  	_updatePoly: function (layer, closed) {
	  		this._setPath(layer, pointsToPath(layer._parts, closed));
	  	},
	
	  	_updateCircle: function (layer) {
	  		var p = layer._point,
	  		    r = Math.max(Math.round(layer._radius), 1),
	  		    r2 = Math.max(Math.round(layer._radiusY), 1) || r,
	  		    arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
	
	  		// drawing a circle with two half-arcs
	  		var d = layer._empty() ? 'M0 0' :
	  			'M' + (p.x - r) + ',' + p.y +
	  			arc + (r * 2) + ',0 ' +
	  			arc + (-r * 2) + ',0 ';
	
	  		this._setPath(layer, d);
	  	},
	
	  	_setPath: function (layer, path) {
	  		layer._path.setAttribute('d', path);
	  	},
	
	  	// SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
	  	_bringToFront: function (layer) {
	  		toFront(layer._path);
	  	},
	
	  	_bringToBack: function (layer) {
	  		toBack(layer._path);
	  	}
	  });
	
	  if (vml) {
	  	SVG.include(vmlMixin);
	  }
	
	  // @namespace SVG
	  // @factory L.svg(options?: Renderer options)
	  // Creates a SVG renderer with the given options.
	  function svg$1(options) {
	  	return svg || vml ? new SVG(options) : null;
	  }
	
	  Map.include({
	  	// @namespace Map; @method getRenderer(layer: Path): Renderer
	  	// Returns the instance of `Renderer` that should be used to render the given
	  	// `Path`. It will ensure that the `renderer` options of the map and paths
	  	// are respected, and that the renderers do exist on the map.
	  	getRenderer: function (layer) {
	  		// @namespace Path; @option renderer: Renderer
	  		// Use this specific instance of `Renderer` for this path. Takes
	  		// precedence over the map's [default renderer](#map-renderer).
	  		var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
	
	  		if (!renderer) {
	  			renderer = this._renderer = this._createRenderer();
	  		}
	
	  		if (!this.hasLayer(renderer)) {
	  			this.addLayer(renderer);
	  		}
	  		return renderer;
	  	},
	
	  	_getPaneRenderer: function (name) {
	  		if (name === 'overlayPane' || name === undefined) {
	  			return false;
	  		}
	
	  		var renderer = this._paneRenderers[name];
	  		if (renderer === undefined) {
	  			renderer = this._createRenderer({pane: name});
	  			this._paneRenderers[name] = renderer;
	  		}
	  		return renderer;
	  	},
	
	  	_createRenderer: function (options) {
	  		// @namespace Map; @option preferCanvas: Boolean = false
	  		// Whether `Path`s should be rendered on a `Canvas` renderer.
	  		// By default, all `Path`s are rendered in a `SVG` renderer.
	  		return (this.options.preferCanvas && canvas$1(options)) || svg$1(options);
	  	}
	  });
	
	  /*
	   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
	   */
	
	  /*
	   * @class Rectangle
	   * @aka L.Rectangle
	   * @inherits Polygon
	   *
	   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
	   *
	   * @example
	   *
	   * ```js
	   * // define rectangle geographical bounds
	   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
	   *
	   * // create an orange rectangle
	   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
	   *
	   * // zoom the map to the rectangle bounds
	   * map.fitBounds(bounds);
	   * ```
	   *
	   */
	
	
	  var Rectangle = Polygon.extend({
	  	initialize: function (latLngBounds, options) {
	  		Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
	  	},
	
	  	// @method setBounds(latLngBounds: LatLngBounds): this
	  	// Redraws the rectangle with the passed bounds.
	  	setBounds: function (latLngBounds) {
	  		return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
	  	},
	
	  	_boundsToLatLngs: function (latLngBounds) {
	  		latLngBounds = toLatLngBounds(latLngBounds);
	  		return [
	  			latLngBounds.getSouthWest(),
	  			latLngBounds.getNorthWest(),
	  			latLngBounds.getNorthEast(),
	  			latLngBounds.getSouthEast()
	  		];
	  	}
	  });
	
	
	  // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
	  function rectangle(latLngBounds, options) {
	  	return new Rectangle(latLngBounds, options);
	  }
	
	  SVG.create = create$2;
	  SVG.pointsToPath = pointsToPath;
	
	  GeoJSON.geometryToLayer = geometryToLayer;
	  GeoJSON.coordsToLatLng = coordsToLatLng;
	  GeoJSON.coordsToLatLngs = coordsToLatLngs;
	  GeoJSON.latLngToCoords = latLngToCoords;
	  GeoJSON.latLngsToCoords = latLngsToCoords;
	  GeoJSON.getFeature = getFeature;
	  GeoJSON.asFeature = asFeature;
	
	  /*
	   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
	   * (zoom to a selected bounding box), enabled by default.
	   */
	
	  // @namespace Map
	  // @section Interaction Options
	  Map.mergeOptions({
	  	// @option boxZoom: Boolean = true
	  	// Whether the map can be zoomed to a rectangular area specified by
	  	// dragging the mouse while pressing the shift key.
	  	boxZoom: true
	  });
	
	  var BoxZoom = Handler.extend({
	  	initialize: function (map) {
	  		this._map = map;
	  		this._container = map._container;
	  		this._pane = map._panes.overlayPane;
	  		this._resetStateTimeout = 0;
	  		map.on('unload', this._destroy, this);
	  	},
	
	  	addHooks: function () {
	  		on(this._container, 'mousedown', this._onMouseDown, this);
	  	},
	
	  	removeHooks: function () {
	  		off(this._container, 'mousedown', this._onMouseDown, this);
	  	},
	
	  	moved: function () {
	  		return this._moved;
	  	},
	
	  	_destroy: function () {
	  		remove(this._pane);
	  		delete this._pane;
	  	},
	
	  	_resetState: function () {
	  		this._resetStateTimeout = 0;
	  		this._moved = false;
	  	},
	
	  	_clearDeferredResetState: function () {
	  		if (this._resetStateTimeout !== 0) {
	  			clearTimeout(this._resetStateTimeout);
	  			this._resetStateTimeout = 0;
	  		}
	  	},
	
	  	_onMouseDown: function (e) {
	  		if (!e.shiftKey || ((e.which !== 1) && (e.button !== 1))) { return false; }
	
	  		// Clear the deferred resetState if it hasn't executed yet, otherwise it
	  		// will interrupt the interaction and orphan a box element in the container.
	  		this._clearDeferredResetState();
	  		this._resetState();
	
	  		disableTextSelection();
	  		disableImageDrag();
	
	  		this._startPoint = this._map.mouseEventToContainerPoint(e);
	
	  		on(document, {
	  			contextmenu: stop,
	  			mousemove: this._onMouseMove,
	  			mouseup: this._onMouseUp,
	  			keydown: this._onKeyDown
	  		}, this);
	  	},
	
	  	_onMouseMove: function (e) {
	  		if (!this._moved) {
	  			this._moved = true;
	
	  			this._box = create$1('div', 'leaflet-zoom-box', this._container);
	  			addClass(this._container, 'leaflet-crosshair');
	
	  			this._map.fire('boxzoomstart');
	  		}
	
	  		this._point = this._map.mouseEventToContainerPoint(e);
	
	  		var bounds = new Bounds(this._point, this._startPoint),
	  		    size = bounds.getSize();
	
	  		setPosition(this._box, bounds.min);
	
	  		this._box.style.width  = size.x + 'px';
	  		this._box.style.height = size.y + 'px';
	  	},
	
	  	_finish: function () {
	  		if (this._moved) {
	  			remove(this._box);
	  			removeClass(this._container, 'leaflet-crosshair');
	  		}
	
	  		enableTextSelection();
	  		enableImageDrag();
	
	  		off(document, {
	  			contextmenu: stop,
	  			mousemove: this._onMouseMove,
	  			mouseup: this._onMouseUp,
	  			keydown: this._onKeyDown
	  		}, this);
	  	},
	
	  	_onMouseUp: function (e) {
	  		if ((e.which !== 1) && (e.button !== 1)) { return; }
	
	  		this._finish();
	
	  		if (!this._moved) { return; }
	  		// Postpone to next JS tick so internal click event handling
	  		// still see it as "moved".
	  		this._clearDeferredResetState();
	  		this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
	
	  		var bounds = new LatLngBounds(
	  		        this._map.containerPointToLatLng(this._startPoint),
	  		        this._map.containerPointToLatLng(this._point));
	
	  		this._map
	  			.fitBounds(bounds)
	  			.fire('boxzoomend', {boxZoomBounds: bounds});
	  	},
	
	  	_onKeyDown: function (e) {
	  		if (e.keyCode === 27) {
	  			this._finish();
	  		}
	  	}
	  });
	
	  // @section Handlers
	  // @property boxZoom: Handler
	  // Box (shift-drag with mouse) zoom handler.
	  Map.addInitHook('addHandler', 'boxZoom', BoxZoom);
	
	  /*
	   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
	   */
	
	  // @namespace Map
	  // @section Interaction Options
	
	  Map.mergeOptions({
	  	// @option doubleClickZoom: Boolean|String = true
	  	// Whether the map can be zoomed in by double clicking on it and
	  	// zoomed out by double clicking while holding shift. If passed
	  	// `'center'`, double-click zoom will zoom to the center of the
	  	//  view regardless of where the mouse was.
	  	doubleClickZoom: true
	  });
	
	  var DoubleClickZoom = Handler.extend({
	  	addHooks: function () {
	  		this._map.on('dblclick', this._onDoubleClick, this);
	  	},
	
	  	removeHooks: function () {
	  		this._map.off('dblclick', this._onDoubleClick, this);
	  	},
	
	  	_onDoubleClick: function (e) {
	  		var map = this._map,
	  		    oldZoom = map.getZoom(),
	  		    delta = map.options.zoomDelta,
	  		    zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
	
	  		if (map.options.doubleClickZoom === 'center') {
	  			map.setZoom(zoom);
	  		} else {
	  			map.setZoomAround(e.containerPoint, zoom);
	  		}
	  	}
	  });
	
	  // @section Handlers
	  //
	  // Map properties include interaction handlers that allow you to control
	  // interaction behavior in runtime, enabling or disabling certain features such
	  // as dragging or touch zoom (see `Handler` methods). For example:
	  //
	  // ```js
	  // map.doubleClickZoom.disable();
	  // ```
	  //
	  // @property doubleClickZoom: Handler
	  // Double click zoom handler.
	  Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);
	
	  /*
	   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
	   */
	
	  // @namespace Map
	  // @section Interaction Options
	  Map.mergeOptions({
	  	// @option dragging: Boolean = true
	  	// Whether the map be draggable with mouse/touch or not.
	  	dragging: true,
	
	  	// @section Panning Inertia Options
	  	// @option inertia: Boolean = *
	  	// If enabled, panning of the map will have an inertia effect where
	  	// the map builds momentum while dragging and continues moving in
	  	// the same direction for some time. Feels especially nice on touch
	  	// devices. Enabled by default unless running on old Android devices.
	  	inertia: !android23,
	
	  	// @option inertiaDeceleration: Number = 3000
	  	// The rate with which the inertial movement slows down, in pixels/second².
	  	inertiaDeceleration: 3400, // px/s^2
	
	  	// @option inertiaMaxSpeed: Number = Infinity
	  	// Max speed of the inertial movement, in pixels/second.
	  	inertiaMaxSpeed: Infinity, // px/s
	
	  	// @option easeLinearity: Number = 0.2
	  	easeLinearity: 0.2,
	
	  	// TODO refactor, move to CRS
	  	// @option worldCopyJump: Boolean = false
	  	// With this option enabled, the map tracks when you pan to another "copy"
	  	// of the world and seamlessly jumps to the original one so that all overlays
	  	// like markers and vector layers are still visible.
	  	worldCopyJump: false,
	
	  	// @option maxBoundsViscosity: Number = 0.0
	  	// If `maxBounds` is set, this option will control how solid the bounds
	  	// are when dragging the map around. The default value of `0.0` allows the
	  	// user to drag outside the bounds at normal speed, higher values will
	  	// slow down map dragging outside bounds, and `1.0` makes the bounds fully
	  	// solid, preventing the user from dragging outside the bounds.
	  	maxBoundsViscosity: 0.0
	  });
	
	  var Drag = Handler.extend({
	  	addHooks: function () {
	  		if (!this._draggable) {
	  			var map = this._map;
	
	  			this._draggable = new Draggable(map._mapPane, map._container);
	
	  			this._draggable.on({
	  				dragstart: this._onDragStart,
	  				drag: this._onDrag,
	  				dragend: this._onDragEnd
	  			}, this);
	
	  			this._draggable.on('predrag', this._onPreDragLimit, this);
	  			if (map.options.worldCopyJump) {
	  				this._draggable.on('predrag', this._onPreDragWrap, this);
	  				map.on('zoomend', this._onZoomEnd, this);
	
	  				map.whenReady(this._onZoomEnd, this);
	  			}
	  		}
	  		addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
	  		this._draggable.enable();
	  		this._positions = [];
	  		this._times = [];
	  	},
	
	  	removeHooks: function () {
	  		removeClass(this._map._container, 'leaflet-grab');
	  		removeClass(this._map._container, 'leaflet-touch-drag');
	  		this._draggable.disable();
	  	},
	
	  	moved: function () {
	  		return this._draggable && this._draggable._moved;
	  	},
	
	  	moving: function () {
	  		return this._draggable && this._draggable._moving;
	  	},
	
	  	_onDragStart: function () {
	  		var map = this._map;
	
	  		map._stop();
	  		if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
	  			var bounds = toLatLngBounds(this._map.options.maxBounds);
	
	  			this._offsetLimit = toBounds(
	  				this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1),
	  				this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1)
	  					.add(this._map.getSize()));
	
	  			this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
	  		} else {
	  			this._offsetLimit = null;
	  		}
	
	  		map
	  		    .fire('movestart')
	  		    .fire('dragstart');
	
	  		if (map.options.inertia) {
	  			this._positions = [];
	  			this._times = [];
	  		}
	  	},
	
	  	_onDrag: function (e) {
	  		if (this._map.options.inertia) {
	  			var time = this._lastTime = +new Date(),
	  			    pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
	
	  			this._positions.push(pos);
	  			this._times.push(time);
	
	  			this._prunePositions(time);
	  		}
	
	  		this._map
	  		    .fire('move', e)
	  		    .fire('drag', e);
	  	},
	
	  	_prunePositions: function (time) {
	  		while (this._positions.length > 1 && time - this._times[0] > 50) {
	  			this._positions.shift();
	  			this._times.shift();
	  		}
	  	},
	
	  	_onZoomEnd: function () {
	  		var pxCenter = this._map.getSize().divideBy(2),
	  		    pxWorldCenter = this._map.latLngToLayerPoint([0, 0]);
	
	  		this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
	  		this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
	  	},
	
	  	_viscousLimit: function (value, threshold) {
	  		return value - (value - threshold) * this._viscosity;
	  	},
	
	  	_onPreDragLimit: function () {
	  		if (!this._viscosity || !this._offsetLimit) { return; }
	
	  		var offset = this._draggable._newPos.subtract(this._draggable._startPos);
	
	  		var limit = this._offsetLimit;
	  		if (offset.x < limit.min.x) { offset.x = this._viscousLimit(offset.x, limit.min.x); }
	  		if (offset.y < limit.min.y) { offset.y = this._viscousLimit(offset.y, limit.min.y); }
	  		if (offset.x > limit.max.x) { offset.x = this._viscousLimit(offset.x, limit.max.x); }
	  		if (offset.y > limit.max.y) { offset.y = this._viscousLimit(offset.y, limit.max.y); }
	
	  		this._draggable._newPos = this._draggable._startPos.add(offset);
	  	},
	
	  	_onPreDragWrap: function () {
	  		// TODO refactor to be able to adjust map pane position after zoom
	  		var worldWidth = this._worldWidth,
	  		    halfWidth = Math.round(worldWidth / 2),
	  		    dx = this._initialWorldOffset,
	  		    x = this._draggable._newPos.x,
	  		    newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx,
	  		    newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx,
	  		    newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
	
	  		this._draggable._absPos = this._draggable._newPos.clone();
	  		this._draggable._newPos.x = newX;
	  	},
	
	  	_onDragEnd: function (e) {
	  		var map = this._map,
	  		    options = map.options,
	
	  		    noInertia = !options.inertia || this._times.length < 2;
	
	  		map.fire('dragend', e);
	
	  		if (noInertia) {
	  			map.fire('moveend');
	
	  		} else {
	  			this._prunePositions(+new Date());
	
	  			var direction = this._lastPos.subtract(this._positions[0]),
	  			    duration = (this._lastTime - this._times[0]) / 1000,
	  			    ease = options.easeLinearity,
	
	  			    speedVector = direction.multiplyBy(ease / duration),
	  			    speed = speedVector.distanceTo([0, 0]),
	
	  			    limitedSpeed = Math.min(options.inertiaMaxSpeed, speed),
	  			    limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed),
	
	  			    decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease),
	  			    offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
	
	  			if (!offset.x && !offset.y) {
	  				map.fire('moveend');
	
	  			} else {
	  				offset = map._limitOffset(offset, map.options.maxBounds);
	
	  				requestAnimFrame(function () {
	  					map.panBy(offset, {
	  						duration: decelerationDuration,
	  						easeLinearity: ease,
	  						noMoveStart: true,
	  						animate: true
	  					});
	  				});
	  			}
	  		}
	  	}
	  });
	
	  // @section Handlers
	  // @property dragging: Handler
	  // Map dragging handler (by both mouse and touch).
	  Map.addInitHook('addHandler', 'dragging', Drag);
	
	  /*
	   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
	   */
	
	  // @namespace Map
	  // @section Keyboard Navigation Options
	  Map.mergeOptions({
	  	// @option keyboard: Boolean = true
	  	// Makes the map focusable and allows users to navigate the map with keyboard
	  	// arrows and `+`/`-` keys.
	  	keyboard: true,
	
	  	// @option keyboardPanDelta: Number = 80
	  	// Amount of pixels to pan when pressing an arrow key.
	  	keyboardPanDelta: 80
	  });
	
	  var Keyboard = Handler.extend({
	
	  	keyCodes: {
	  		left:    [37],
	  		right:   [39],
	  		down:    [40],
	  		up:      [38],
	  		zoomIn:  [187, 107, 61, 171],
	  		zoomOut: [189, 109, 54, 173]
	  	},
	
	  	initialize: function (map) {
	  		this._map = map;
	
	  		this._setPanDelta(map.options.keyboardPanDelta);
	  		this._setZoomDelta(map.options.zoomDelta);
	  	},
	
	  	addHooks: function () {
	  		var container = this._map._container;
	
	  		// make the container focusable by tabbing
	  		if (container.tabIndex <= 0) {
	  			container.tabIndex = '0';
	  		}
	
	  		on(container, {
	  			focus: this._onFocus,
	  			blur: this._onBlur,
	  			mousedown: this._onMouseDown
	  		}, this);
	
	  		this._map.on({
	  			focus: this._addHooks,
	  			blur: this._removeHooks
	  		}, this);
	  	},
	
	  	removeHooks: function () {
	  		this._removeHooks();
	
	  		off(this._map._container, {
	  			focus: this._onFocus,
	  			blur: this._onBlur,
	  			mousedown: this._onMouseDown
	  		}, this);
	
	  		this._map.off({
	  			focus: this._addHooks,
	  			blur: this._removeHooks
	  		}, this);
	  	},
	
	  	_onMouseDown: function () {
	  		if (this._focused) { return; }
	
	  		var body = document.body,
	  		    docEl = document.documentElement,
	  		    top = body.scrollTop || docEl.scrollTop,
	  		    left = body.scrollLeft || docEl.scrollLeft;
	
	  		this._map._container.focus();
	
	  		window.scrollTo(left, top);
	  	},
	
	  	_onFocus: function () {
	  		this._focused = true;
	  		this._map.fire('focus');
	  	},
	
	  	_onBlur: function () {
	  		this._focused = false;
	  		this._map.fire('blur');
	  	},
	
	  	_setPanDelta: function (panDelta) {
	  		var keys = this._panKeys = {},
	  		    codes = this.keyCodes,
	  		    i, len;
	
	  		for (i = 0, len = codes.left.length; i < len; i++) {
	  			keys[codes.left[i]] = [-1 * panDelta, 0];
	  		}
	  		for (i = 0, len = codes.right.length; i < len; i++) {
	  			keys[codes.right[i]] = [panDelta, 0];
	  		}
	  		for (i = 0, len = codes.down.length; i < len; i++) {
	  			keys[codes.down[i]] = [0, panDelta];
	  		}
	  		for (i = 0, len = codes.up.length; i < len; i++) {
	  			keys[codes.up[i]] = [0, -1 * panDelta];
	  		}
	  	},
	
	  	_setZoomDelta: function (zoomDelta) {
	  		var keys = this._zoomKeys = {},
	  		    codes = this.keyCodes,
	  		    i, len;
	
	  		for (i = 0, len = codes.zoomIn.length; i < len; i++) {
	  			keys[codes.zoomIn[i]] = zoomDelta;
	  		}
	  		for (i = 0, len = codes.zoomOut.length; i < len; i++) {
	  			keys[codes.zoomOut[i]] = -zoomDelta;
	  		}
	  	},
	
	  	_addHooks: function () {
	  		on(document, 'keydown', this._onKeyDown, this);
	  	},
	
	  	_removeHooks: function () {
	  		off(document, 'keydown', this._onKeyDown, this);
	  	},
	
	  	_onKeyDown: function (e) {
	  		if (e.altKey || e.ctrlKey || e.metaKey) { return; }
	
	  		var key = e.keyCode,
	  		    map = this._map,
	  		    offset;
	
	  		if (key in this._panKeys) {
	  			if (!map._panAnim || !map._panAnim._inProgress) {
	  				offset = this._panKeys[key];
	  				if (e.shiftKey) {
	  					offset = toPoint(offset).multiplyBy(3);
	  				}
	
	  				map.panBy(offset);
	
	  				if (map.options.maxBounds) {
	  					map.panInsideBounds(map.options.maxBounds);
	  				}
	  			}
	  		} else if (key in this._zoomKeys) {
	  			map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
	
	  		} else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) {
	  			map.closePopup();
	
	  		} else {
	  			return;
	  		}
	
	  		stop(e);
	  	}
	  });
	
	  // @section Handlers
	  // @section Handlers
	  // @property keyboard: Handler
	  // Keyboard navigation handler.
	  Map.addInitHook('addHandler', 'keyboard', Keyboard);
	
	  /*
	   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
	   */
	
	  // @namespace Map
	  // @section Interaction Options
	  Map.mergeOptions({
	  	// @section Mouse wheel options
	  	// @option scrollWheelZoom: Boolean|String = true
	  	// Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
	  	// it will zoom to the center of the view regardless of where the mouse was.
	  	scrollWheelZoom: true,
	
	  	// @option wheelDebounceTime: Number = 40
	  	// Limits the rate at which a wheel can fire (in milliseconds). By default
	  	// user can't zoom via wheel more often than once per 40 ms.
	  	wheelDebounceTime: 40,
	
	  	// @option wheelPxPerZoomLevel: Number = 60
	  	// How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
	  	// mean a change of one full zoom level. Smaller values will make wheel-zooming
	  	// faster (and vice versa).
	  	wheelPxPerZoomLevel: 60
	  });
	
	  var ScrollWheelZoom = Handler.extend({
	  	addHooks: function () {
	  		on(this._map._container, 'wheel', this._onWheelScroll, this);
	
	  		this._delta = 0;
	  	},
	
	  	removeHooks: function () {
	  		off(this._map._container, 'wheel', this._onWheelScroll, this);
	  	},
	
	  	_onWheelScroll: function (e) {
	  		var delta = getWheelDelta(e);
	
	  		var debounce = this._map.options.wheelDebounceTime;
	
	  		this._delta += delta;
	  		this._lastMousePos = this._map.mouseEventToContainerPoint(e);
	
	  		if (!this._startTime) {
	  			this._startTime = +new Date();
	  		}
	
	  		var left = Math.max(debounce - (+new Date() - this._startTime), 0);
	
	  		clearTimeout(this._timer);
	  		this._timer = setTimeout(bind(this._performZoom, this), left);
	
	  		stop(e);
	  	},
	
	  	_performZoom: function () {
	  		var map = this._map,
	  		    zoom = map.getZoom(),
	  		    snap = this._map.options.zoomSnap || 0;
	
	  		map._stop(); // stop panning and fly animations if any
	
	  		// map the delta with a sigmoid function to -4..4 range leaning on -1..1
	  		var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4),
	  		    d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2,
	  		    d4 = snap ? Math.ceil(d3 / snap) * snap : d3,
	  		    delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
	
	  		this._delta = 0;
	  		this._startTime = null;
	
	  		if (!delta) { return; }
	
	  		if (map.options.scrollWheelZoom === 'center') {
	  			map.setZoom(zoom + delta);
	  		} else {
	  			map.setZoomAround(this._lastMousePos, zoom + delta);
	  		}
	  	}
	  });
	
	  // @section Handlers
	  // @property scrollWheelZoom: Handler
	  // Scroll wheel zoom handler.
	  Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);
	
	  /*
	   * L.Map.Tap is used to enable mobile hacks like quick taps and long hold.
	   */
	
	  // @namespace Map
	  // @section Interaction Options
	  Map.mergeOptions({
	  	// @section Touch interaction options
	  	// @option tap: Boolean = true
	  	// Enables mobile hacks for supporting instant taps (fixing 200ms click
	  	// delay on iOS/Android) and touch holds (fired as `contextmenu` events).
	  	tap: true,
	
	  	// @option tapTolerance: Number = 15
	  	// The max number of pixels a user can shift his finger during touch
	  	// for it to be considered a valid tap.
	  	tapTolerance: 15
	  });
	
	  var Tap = Handler.extend({
	  	addHooks: function () {
	  		on(this._map._container, 'touchstart', this._onDown, this);
	  	},
	
	  	removeHooks: function () {
	  		off(this._map._container, 'touchstart', this._onDown, this);
	  	},
	
	  	_onDown: function (e) {
	  		if (!e.touches) { return; }
	
	  		preventDefault(e);
	
	  		this._fireClick = true;
	
	  		// don't simulate click or track longpress if more than 1 touch
	  		if (e.touches.length > 1) {
	  			this._fireClick = false;
	  			clearTimeout(this._holdTimeout);
	  			return;
	  		}
	
	  		var first = e.touches[0],
	  		    el = first.target;
	
	  		this._startPos = this._newPos = new Point(first.clientX, first.clientY);
	
	  		// if touching a link, highlight it
	  		if (el.tagName && el.tagName.toLowerCase() === 'a') {
	  			addClass(el, 'leaflet-active');
	  		}
	
	  		// simulate long hold but setting a timeout
	  		this._holdTimeout = setTimeout(bind(function () {
	  			if (this._isTapValid()) {
	  				this._fireClick = false;
	  				this._onUp();
	  				this._simulateEvent('contextmenu', first);
	  			}
	  		}, this), 1000);
	
	  		this._simulateEvent('mousedown', first);
	
	  		on(document, {
	  			touchmove: this._onMove,
	  			touchend: this._onUp
	  		}, this);
	  	},
	
	  	_onUp: function (e) {
	  		clearTimeout(this._holdTimeout);
	
	  		off(document, {
	  			touchmove: this._onMove,
	  			touchend: this._onUp
	  		}, this);
	
	  		if (this._fireClick && e && e.changedTouches) {
	
	  			var first = e.changedTouches[0],
	  			    el = first.target;
	
	  			if (el && el.tagName && el.tagName.toLowerCase() === 'a') {
	  				removeClass(el, 'leaflet-active');
	  			}
	
	  			this._simulateEvent('mouseup', first);
	
	  			// simulate click if the touch didn't move too much
	  			if (this._isTapValid()) {
	  				this._simulateEvent('click', first);
	  			}
	  		}
	  	},
	
	  	_isTapValid: function () {
	  		return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
	  	},
	
	  	_onMove: function (e) {
	  		var first = e.touches[0];
	  		this._newPos = new Point(first.clientX, first.clientY);
	  		this._simulateEvent('mousemove', first);
	  	},
	
	  	_simulateEvent: function (type, e) {
	  		var simulatedEvent = document.createEvent('MouseEvents');
	
	  		simulatedEvent._simulated = true;
	  		e.target._simulatedClick = true;
	
	  		simulatedEvent.initMouseEvent(
	  		        type, true, true, window, 1,
	  		        e.screenX, e.screenY,
	  		        e.clientX, e.clientY,
	  		        false, false, false, false, 0, null);
	
	  		e.target.dispatchEvent(simulatedEvent);
	  	}
	  });
	
	  // @section Handlers
	  // @property tap: Handler
	  // Mobile touch hacks (quick tap and touch hold) handler.
	  if (touch && (!pointer || safari)) {
	  	Map.addInitHook('addHandler', 'tap', Tap);
	  }
	
	  /*
	   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
	   */
	
	  // @namespace Map
	  // @section Interaction Options
	  Map.mergeOptions({
	  	// @section Touch interaction options
	  	// @option touchZoom: Boolean|String = *
	  	// Whether the map can be zoomed by touch-dragging with two fingers. If
	  	// passed `'center'`, it will zoom to the center of the view regardless of
	  	// where the touch events (fingers) were. Enabled for touch-capable web
	  	// browsers except for old Androids.
	  	touchZoom: touch && !android23,
	
	  	// @option bounceAtZoomLimits: Boolean = true
	  	// Set it to false if you don't want the map to zoom beyond min/max zoom
	  	// and then bounce back when pinch-zooming.
	  	bounceAtZoomLimits: true
	  });
	
	  var TouchZoom = Handler.extend({
	  	addHooks: function () {
	  		addClass(this._map._container, 'leaflet-touch-zoom');
	  		on(this._map._container, 'touchstart', this._onTouchStart, this);
	  	},
	
	  	removeHooks: function () {
	  		removeClass(this._map._container, 'leaflet-touch-zoom');
	  		off(this._map._container, 'touchstart', this._onTouchStart, this);
	  	},
	
	  	_onTouchStart: function (e) {
	  		var map = this._map;
	  		if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) { return; }
	
	  		var p1 = map.mouseEventToContainerPoint(e.touches[0]),
	  		    p2 = map.mouseEventToContainerPoint(e.touches[1]);
	
	  		this._centerPoint = map.getSize()._divideBy(2);
	  		this._startLatLng = map.containerPointToLatLng(this._centerPoint);
	  		if (map.options.touchZoom !== 'center') {
	  			this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
	  		}
	
	  		this._startDist = p1.distanceTo(p2);
	  		this._startZoom = map.getZoom();
	
	  		this._moved = false;
	  		this._zooming = true;
	
	  		map._stop();
	
	  		on(document, 'touchmove', this._onTouchMove, this);
	  		on(document, 'touchend', this._onTouchEnd, this);
	
	  		preventDefault(e);
	  	},
	
	  	_onTouchMove: function (e) {
	  		if (!e.touches || e.touches.length !== 2 || !this._zooming) { return; }
	
	  		var map = this._map,
	  		    p1 = map.mouseEventToContainerPoint(e.touches[0]),
	  		    p2 = map.mouseEventToContainerPoint(e.touches[1]),
	  		    scale = p1.distanceTo(p2) / this._startDist;
	
	  		this._zoom = map.getScaleZoom(scale, this._startZoom);
	
	  		if (!map.options.bounceAtZoomLimits && (
	  			(this._zoom < map.getMinZoom() && scale < 1) ||
	  			(this._zoom > map.getMaxZoom() && scale > 1))) {
	  			this._zoom = map._limitZoom(this._zoom);
	  		}
	
	  		if (map.options.touchZoom === 'center') {
	  			this._center = this._startLatLng;
	  			if (scale === 1) { return; }
	  		} else {
	  			// Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
	  			var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
	  			if (scale === 1 && delta.x === 0 && delta.y === 0) { return; }
	  			this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
	  		}
	
	  		if (!this._moved) {
	  			map._moveStart(true, false);
	  			this._moved = true;
	  		}
	
	  		cancelAnimFrame(this._animRequest);
	
	  		var moveFn = bind(map._move, map, this._center, this._zoom, {pinch: true, round: false});
	  		this._animRequest = requestAnimFrame(moveFn, this, true);
	
	  		preventDefault(e);
	  	},
	
	  	_onTouchEnd: function () {
	  		if (!this._moved || !this._zooming) {
	  			this._zooming = false;
	  			return;
	  		}
	
	  		this._zooming = false;
	  		cancelAnimFrame(this._animRequest);
	
	  		off(document, 'touchmove', this._onTouchMove, this);
	  		off(document, 'touchend', this._onTouchEnd, this);
	
	  		// Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
	  		if (this._map.options.zoomAnimation) {
	  			this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
	  		} else {
	  			this._map._resetView(this._center, this._map._limitZoom(this._zoom));
	  		}
	  	}
	  });
	
	  // @section Handlers
	  // @property touchZoom: Handler
	  // Touch zoom handler.
	  Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
	
	  Map.BoxZoom = BoxZoom;
	  Map.DoubleClickZoom = DoubleClickZoom;
	  Map.Drag = Drag;
	  Map.Keyboard = Keyboard;
	  Map.ScrollWheelZoom = ScrollWheelZoom;
	  Map.Tap = Tap;
	  Map.TouchZoom = TouchZoom;
	
	  exports.version = version;
	  exports.Control = Control;
	  exports.control = control;
	  exports.Browser = Browser;
	  exports.Evented = Evented;
	  exports.Mixin = Mixin;
	  exports.Util = Util;
	  exports.Class = Class;
	  exports.Handler = Handler;
	  exports.extend = extend;
	  exports.bind = bind;
	  exports.stamp = stamp;
	  exports.setOptions = setOptions;
	  exports.DomEvent = DomEvent;
	  exports.DomUtil = DomUtil;
	  exports.PosAnimation = PosAnimation;
	  exports.Draggable = Draggable;
	  exports.LineUtil = LineUtil;
	  exports.PolyUtil = PolyUtil;
	  exports.Point = Point;
	  exports.point = toPoint;
	  exports.Bounds = Bounds;
	  exports.bounds = toBounds;
	  exports.Transformation = Transformation;
	  exports.transformation = toTransformation;
	  exports.Projection = index;
	  exports.LatLng = LatLng;
	  exports.latLng = toLatLng;
	  exports.LatLngBounds = LatLngBounds;
	  exports.latLngBounds = toLatLngBounds;
	  exports.CRS = CRS;
	  exports.GeoJSON = GeoJSON;
	  exports.geoJSON = geoJSON;
	  exports.geoJson = geoJson;
	  exports.Layer = Layer;
	  exports.LayerGroup = LayerGroup;
	  exports.layerGroup = layerGroup;
	  exports.FeatureGroup = FeatureGroup;
	  exports.featureGroup = featureGroup;
	  exports.ImageOverlay = ImageOverlay;
	  exports.imageOverlay = imageOverlay;
	  exports.VideoOverlay = VideoOverlay;
	  exports.videoOverlay = videoOverlay;
	  exports.SVGOverlay = SVGOverlay;
	  exports.svgOverlay = svgOverlay;
	  exports.DivOverlay = DivOverlay;
	  exports.Popup = Popup;
	  exports.popup = popup;
	  exports.Tooltip = Tooltip;
	  exports.tooltip = tooltip;
	  exports.Icon = Icon;
	  exports.icon = icon;
	  exports.DivIcon = DivIcon;
	  exports.divIcon = divIcon;
	  exports.Marker = Marker;
	  exports.marker = marker;
	  exports.TileLayer = TileLayer;
	  exports.tileLayer = tileLayer;
	  exports.GridLayer = GridLayer;
	  exports.gridLayer = gridLayer;
	  exports.SVG = SVG;
	  exports.svg = svg$1;
	  exports.Renderer = Renderer;
	  exports.Canvas = Canvas;
	  exports.canvas = canvas$1;
	  exports.Path = Path;
	  exports.CircleMarker = CircleMarker;
	  exports.circleMarker = circleMarker;
	  exports.Circle = Circle;
	  exports.circle = circle;
	  exports.Polyline = Polyline;
	  exports.polyline = polyline;
	  exports.Polygon = Polygon;
	  exports.polygon = polygon;
	  exports.Rectangle = Rectangle;
	  exports.rectangle = rectangle;
	  exports.Map = Map;
	  exports.map = createMap;
	
	  var oldL = window.L;
	  exports.noConflict = function() {
	  	window.L = oldL;
	  	return this;
	  }
	
	  // Always export us to window global (see #2364)
	  window.L = exports;
	
	})));
	//# sourceMappingURL=leaflet-src.js.map


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	            '_'
	        ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split(
	            '_'
	        ),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	            '_'
	        ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	            '_'
	        ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort: 'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	            '_'
	        ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                '_'
	            ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	            '_'
	        ),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	            '_'
	        ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                    ? 'тан'
	                    : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	            '_'
	        ),
	        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	            '_'
	        ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split(
	            '_'
	        ),
	        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	            '_'
	        ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	            '_'
	        ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        weekdays: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysShort: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	            ' '
	        ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	            '_'
	        ),
	        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	            '_'
	        ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split(
	            '_'
	        );
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone: 'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                '_'
	            ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                '_'
	            ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split(
	            '_'
	        ),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone: 'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split(
	            '_'
	        ),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex: /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex: /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(
	        ' '
	    );
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	            '_'
	        ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                '_'
	            ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function (
	                    $0,
	                    $1,
	                    $2
	                ) {
	                    return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                });
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	            ? forms(key)[1]
	            : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                '_'
	            ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	            '_'
	        ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	            '_'
	        ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            w: 'en uke',
	            ww: '%d uker',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone: 'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                '_'
	            ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	            '_'
	        ),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                '_'
	            ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	        },
	        weekdays: {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                '_'
	            ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split(
	            '_'
	        ),
	        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	            '_'
	        ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	            '_'
	        ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	            '_'
	        ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'дан',
	            dd: translator.translate,
	            M: 'месец',
	            MM: translator.translate,
	            y: 'годину',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                        ? ':a'
	                        : b === 2
	                        ? ':a'
	                        : b === 3
	                        ? ':e'
	                        : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	            '_'
	        ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	            '_'
	        ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'waQ'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'nem'
	                : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'wen'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'ben'
	                : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	            ? format[key][0]
	            : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative: 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                    '_'
	                ),
	                accusative: 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                    '_'
	                ),
	                genitive: 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                    '_'
	                ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	            ? 'genitive'
	            : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	            '_'
	        ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort: 'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	            '_'
	        ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 481 */
/***/ (function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\"\r\n     xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\r\n     viewBox=\"0 0 512 512\"\r\n     style=\"enable-background:new 0 0 512 512\"\r\n     xml:space=\"preserve\">\r\n\r\n<style>\r\n.pin{\r\n  fill: #09397F;\r\n  opacity: 0.9\r\n}\r\n.pin-selected{\r\n  fill: #FFCE00;\r\n  opacity: 1\r\n}\r\n.circle{\r\n  fill: #FFF;\r\n  opacity: 0.9\r\n}\r\n</style>\r\n\r\n<path\r\n  id=\"icon\"\r\n  d=\"M382.6,52.4L382.6,52.4c-69.9-69.9-183.2-69.9-253.1,0l0,0c-63,63-70.1,181.6-16.6,252.8L256,512l143.2-206.8\r\n\tC452.6,234,445.5,115.4,382.6,52.4z M257.7,306.2c-71.2,0-128.9-57.7-128.9-128.9S186.5,48.3,257.7,48.3S386.7,106,386.7,177.2\r\n\tS329,306.2,257.7,306.2z\"\r\n/>\r\n<circle class=\"circle\" cx=\"256\" cy=\"176\" r=\"132\"/>\r\n<text\r\n  id=\"value\"\r\n  font-size=\"140\"\r\n  font-family=\"sans-serif\"\r\n  font-weight=\"bold\"\r\n  text-anchor=\"middle\"\r\n  alignment-baseline=\"middle\"\r\n  fill=\"#800000\"\r\n  y=\"185\"\r\n  x=\"257.5\">10</text>\r\n</svg>\r\n"

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(144);
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(344);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(218).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(485);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(145).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(107));
	util.inherits = __webpack_require__(52);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(2237);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(1708);
	var destroyImpl = __webpack_require__(484);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
	
	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(83);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var readableHwm = options.readableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(486).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(83);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(486).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    pna.nextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        pna.nextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    pna.nextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;
	
	  var state = this._readableState;
	  var paused = false;
	
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }
	
	    _this.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return this;
	};
	
	Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._readableState.highWaterMark;
	  }
	});
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    pna.nextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(82)))

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(83);
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(107));
	util.inherits = __webpack_require__(52);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return this.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);
	
	  cb(er);
	
	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}
	
	function prefinish() {
	  var _this = this;
	
	  if (typeof this._flush === 'function') {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this2 = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this2.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(144);
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      pna.nextTick(emitErrorNT, this, err);
	    }
	    return this;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      pna.nextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	
	  return this;
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(218).EventEmitter;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(145).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(1718);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	var polygon = __webpack_require__(17).polygon;
	
	/**
	 * Takes a bbox and returns an equivalent {@link Polygon|polygon}.
	 *
	 * @name bboxPolygon
	 * @param {Array<number>} bbox an Array of bounding box coordinates in the form: ```[xLow, yLow, xHigh, yHigh]```
	 * @return {Feature<Polygon>} a Polygon representation of the bounding box
	 * @example
	 * var bbox = [0, 0, 10, 10];
	 *
	 * var poly = turf.bboxPolygon(bbox);
	 *
	 * //=poly
	 */
	
	module.exports = function (bbox) {
	    var lowLeft = [bbox[0], bbox[1]];
	    var topLeft = [bbox[0], bbox[3]];
	    var topRight = [bbox[2], bbox[3]];
	    var lowRight = [bbox[2], bbox[1]];
	
	    return polygon([[
	        lowLeft,
	        lowRight,
	        topRight,
	        topLeft,
	        lowLeft
	    ]]);
	};


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	var bbox = __webpack_require__(147),
	    point = __webpack_require__(17).point;
	
	/**
	 * Takes a {@link FeatureCollection} and returns the absolute center point of all features.
	 *
	 * @name center
	 * @param {FeatureCollection} features input features
	 * @return {Feature<Point>} a Point feature at the
	 * absolute center point of all input features
	 * @example
	 * var features = {
	 *   "type": "FeatureCollection",
	 *   "features": [
	 *     {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-97.522259, 35.4691]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-97.502754, 35.463455]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-97.508269, 35.463245]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-97.516809, 35.465779]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-97.515372, 35.467072]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-97.509363, 35.463053]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-97.511123, 35.466601]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-97.518547, 35.469327]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-97.519706, 35.469659]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-97.517839, 35.466998]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-97.508678, 35.464942]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-97.514914, 35.463453]
	 *       }
	 *     }
	 *   ]
	 * };
	 *
	 * var centerPt = turf.center(features);
	 * centerPt.properties['marker-size'] = 'large';
	 * centerPt.properties['marker-color'] = '#000';
	 *
	 * var resultFeatures = features.features.concat(centerPt);
	 * var result = {
	 *   "type": "FeatureCollection",
	 *   "features": resultFeatures
	 * };
	 *
	 * //=result
	 */
	
	module.exports = function (layer) {
	    var ext = bbox(layer);
	    var x = (ext[0] + ext[2]) / 2;
	    var y = (ext[1] + ext[3]) / 2;
	    return point([x, y]);
	};


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	var featureCollection = __webpack_require__(17).featureCollection;
	var each = __webpack_require__(95).coordEach;
	var point = __webpack_require__(17).point;
	
	/**
	 * Takes a feature or set of features and returns all positions as
	 * {@link Point|points}.
	 *
	 * @name explode
	 * @param {(Feature|FeatureCollection)} geojson input features
	 * @return {FeatureCollection<point>} points representing the exploded input features
	 * @throws {Error} if it encounters an unknown geometry type
	 * @example
	 * var poly = {
	 *   "type": "Feature",
	 *   "properties": {},
	 *   "geometry": {
	 *     "type": "Polygon",
	 *     "coordinates": [[
	 *       [177.434692, -17.77517],
	 *       [177.402076, -17.779093],
	 *       [177.38079, -17.803937],
	 *       [177.40242, -17.826164],
	 *       [177.438468, -17.824857],
	 *       [177.454948, -17.796746],
	 *       [177.434692, -17.77517]
	 *     ]]
	 *   }
	 * };
	 *
	 * var points = turf.explode(poly);
	 *
	 * //=poly
	 *
	 * //=points
	 */
	module.exports = function (geojson) {
	    var points = [];
	    each(geojson, function (coord) {
	        points.push(point(coord));
	    });
	    return featureCollection(points);
	};


/***/ }),
/* 491 */
/***/ (function(module, exports) {

	/**
	 * Takes a triangular plane as a {@link Polygon}
	 * and a {@link Point} within that triangle and returns the z-value
	 * at that point. The Polygon needs to have properties `a`, `b`, and `c`
	 * that define the values at its three corners.
	 *
	 * @name planepoint
	 * @param {Feature<Point>} point the Point for which a z-value will be calculated
	 * @param {Feature<Polygon>} triangle a Polygon feature with three vertices
	 * @return {Number} the z-value for `interpolatedPoint`
	 * @example
	 * var point = {
	 *   "type": "Feature",
	 *   "properties": {},
	 *   "geometry": {
	 *     "type": "Point",
	 *     "coordinates": [-75.3221, 39.529]
	 *   }
	 * };
	 * var point = turf.point([-75.3221, 39.529]);
	 * // triangle is a polygon with "a", "b",
	 * // and "c" values representing
	 * // the values of the coordinates in order.
	 * var triangle = {
	 *   "type": "Feature",
	 *   "properties": {
	 *     "a": 11,
	 *     "b": 122,
	 *     "c": 44
	 *   },
	 *   "geometry": {
	 *     "type": "Polygon",
	 *     "coordinates": [[
	 *       [-75.1221, 39.57],
	 *       [-75.58, 39.18],
	 *       [-75.97, 39.86],
	 *       [-75.1221, 39.57]
	 *     ]]
	 *   }
	 * };
	 *
	 * var features = {
	 *   "type": "FeatureCollection",
	 *   "features": [triangle, point]
	 * };
	 *
	 * var zValue = turf.planepoint(point, triangle);
	 *
	 * //=features
	 *
	 * //=zValue
	 */
	module.exports = function (point, triangle) {
	    var x = point.geometry.coordinates[0],
	        y = point.geometry.coordinates[1],
	        x1 = triangle.geometry.coordinates[0][0][0],
	        y1 = triangle.geometry.coordinates[0][0][1],
	        z1 = triangle.properties.a,
	        x2 = triangle.geometry.coordinates[0][1][0],
	        y2 = triangle.geometry.coordinates[0][1][1],
	        z2 = triangle.properties.b,
	        x3 = triangle.geometry.coordinates[0][2][0],
	        y3 = triangle.geometry.coordinates[0][2][1],
	        z3 = triangle.properties.c;
	
	    var z = (z3 * (x - x1) * (y - y2) + z1 * (x - x2) * (y - y3) + z2 * (x - x3) * (y - y1) -
	      z2 * (x - x1) * (y - y3) - z3 * (x - x2) * (y - y1) - z1 * (x - x3) * (y - y2)) /
	      ((x - x1) * (y - y2) + (x - x2) * (y - y3) + (x - x3) * (y - y1) -
	       (x - x1) * (y - y3) - (x - x2) * (y - y1) - (x - x3) * (y - y2));
	
	    return z;
	};


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	var distance = __webpack_require__(39);
	var point = __webpack_require__(17).point;
	var bearing = __webpack_require__(148);
	var destination = __webpack_require__(149);
	
	/**
	 * Takes a {@link Point} and a {@link LineString} and calculates the closest Point on the LineString.
	 *
	 * @name pointOnLine
	 * @param {Feature<LineString>} line line to snap to
	 * @param {Feature<Point>} point point to snap from
	 * @return {Feature<Point>} closest point on the `line` to `point`
	 * @example
	 * var line = {
	 *   "type": "Feature",
	 *   "properties": {},
	 *   "geometry": {
	 *     "type": "LineString",
	 *     "coordinates": [
	 *       [-77.031669, 38.878605],
	 *       [-77.029609, 38.881946],
	 *       [-77.020339, 38.884084],
	 *       [-77.025661, 38.885821],
	 *       [-77.021884, 38.889563],
	 *       [-77.019824, 38.892368]
	 *     ]
	 *   }
	 * };
	 * var pt = {
	 *   "type": "Feature",
	 *   "properties": {},
	 *   "geometry": {
	 *     "type": "Point",
	 *     "coordinates": [-77.037076, 38.884017]
	 *   }
	 * };
	 *
	 * var snapped = turf.pointOnLine(line, pt);
	 * snapped.properties['marker-color'] = '#00f'
	 *
	 * var result = {
	 *   "type": "FeatureCollection",
	 *   "features": [line, pt, snapped]
	 * };
	 *
	 * //=result
	 */
	
	module.exports = function (line, pt) {
	    var coords;
	    if (line.type === 'Feature') {
	        coords = line.geometry.coordinates;
	    } else if (line.type === 'LineString') {
	        coords = line.coordinates;
	    } else {
	        throw new Error('input must be a LineString Feature or Geometry');
	    }
	
	    return pointOnLine(pt, coords);
	};
	
	function pointOnLine(pt, coords) {
	    var units = 'miles';
	    var closestPt = point([Infinity, Infinity], {
	        dist: Infinity
	    });
	    for (var i = 0; i < coords.length - 1; i++) {
	        var start = point(coords[i]);
	        var stop = point(coords[i + 1]);
	        //start
	        start.properties.dist = distance(pt, start, units);
	        //stop
	        stop.properties.dist = distance(pt, stop, units);
	        //perpendicular
	        var heightDistance = Math.max(start.properties.dist, stop.properties.dist);
	        var direction = bearing(start, stop);
	        var perpendicularPt1 = destination(pt, heightDistance, direction + 90, units);
	        var perpendicularPt2 = destination(pt, heightDistance, direction - 90, units);
	        var intersect = lineIntersects(
	        perpendicularPt1.geometry.coordinates[0],
	        perpendicularPt1.geometry.coordinates[1],
	        perpendicularPt2.geometry.coordinates[0],
	        perpendicularPt2.geometry.coordinates[1],
	        start.geometry.coordinates[0],
	        start.geometry.coordinates[1],
	        stop.geometry.coordinates[0],
	        stop.geometry.coordinates[1]
	        );
	        var intersectPt;
	        if (intersect) {
	            intersectPt = point(intersect);
	            intersectPt.properties.dist = distance(pt, intersectPt, units);
	        }
	
	        if (start.properties.dist < closestPt.properties.dist) {
	            closestPt = start;
	            closestPt.properties.index = i;
	        }
	        if (stop.properties.dist < closestPt.properties.dist) {
	            closestPt = stop;
	            closestPt.properties.index = i;
	        }
	        if (intersectPt && intersectPt.properties.dist < closestPt.properties.dist) {
	            closestPt = intersectPt;
	            closestPt.properties.index = i;
	        }
	    }
	
	    return closestPt;
	}
	
	// modified from http://jsfiddle.net/justin_c_rounds/Gd2S2/light/
	function lineIntersects(line1StartX, line1StartY, line1EndX, line1EndY, line2StartX, line2StartY, line2EndX, line2EndY) {
	    // if the lines intersect, the result contains the x and y of the intersection (treating the lines as infinite) and booleans for whether line segment 1 or line segment 2 contain the point
	    var denominator, a, b, numerator1, numerator2;
	    var result = {
	        x: null,
	        y: null,
	        onLine1: false,
	        onLine2: false
	    };
	    denominator = ((line2EndY - line2StartY) * (line1EndX - line1StartX)) - ((line2EndX - line2StartX) * (line1EndY - line1StartY));
	    if (denominator === 0) {
	        if (result.x !== null && result.y !== null) {
	            return result;
	        } else {
	            return false;
	        }
	    }
	    a = line1StartY - line2StartY;
	    b = line1StartX - line2StartX;
	    numerator1 = ((line2EndX - line2StartX) * a) - ((line2EndY - line2StartY) * b);
	    numerator2 = ((line1EndX - line1StartX) * a) - ((line1EndY - line1StartY) * b);
	    a = numerator1 / denominator;
	    b = numerator2 / denominator;
	
	    // if we cast these lines infinitely in both directions, they intersect here:
	    result.x = line1StartX + (a * (line1EndX - line1StartX));
	    result.y = line1StartY + (a * (line1EndY - line1StartY));
	
	    // if line1 is a segment and line2 is infinite, they intersect if:
	    if (a > 0 && a < 1) {
	        result.onLine1 = true;
	    }
	    // if line2 is a segment and line1 is infinite, they intersect if:
	    if (b > 0 && b < 1) {
	        result.onLine2 = true;
	    }
	    // if line1 and line2 are segments, they intersect if both of the above are true
	    if (result.onLine1 && result.onLine2) {
	        return [result.x, result.y];
	    } else {
	        return false;
	    }
	}


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	var distance = __webpack_require__(39);
	
	/**
	 * Takes a bounding box and calculates the minimum square bounding box that
	 * would contain the input.
	 *
	 * @name square
	 * @param {Array<number>} bbox a bounding box
	 * @return {Array<number>} a square surrounding `bbox`
	 * @example
	 * var bbox = [-20,-20,-15,0];
	 *
	 * var squared = turf.square(bbox);
	 *
	 * var features = {
	 *   "type": "FeatureCollection",
	 *   "features": [
	 *     turf.bboxPolygon(bbox),
	 *     turf.bboxPolygon(squared)
	 *   ]
	 * };
	 *
	 * //=features
	 */
	module.exports = function (bbox) {
	    var horizontalDistance = distance(bbox.slice(0, 2), [bbox[2], bbox[1]], 'miles');
	    var verticalDistance = distance(bbox.slice(0, 2), [bbox[0], bbox[3]], 'miles');
	    if (horizontalDistance >= verticalDistance) {
	        var verticalMidpoint = (bbox[1] + bbox[3]) / 2;
	        return [
	            bbox[0],
	            verticalMidpoint - ((bbox[2] - bbox[0]) / 2),
	            bbox[2],
	            verticalMidpoint + ((bbox[2] - bbox[0]) / 2)
	        ];
	    } else {
	        var horizontalMidpoint = (bbox[0] + bbox[2]) / 2;
	        return [
	            horizontalMidpoint - ((bbox[3] - bbox[1]) / 2),
	            bbox[1],
	            horizontalMidpoint + ((bbox[3] - bbox[1]) / 2),
	            bbox[3]
	        ];
	    }
	};


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	// look here for help http://svn.osgeo.org/grass/grass/branches/releasebranch_6_4/vector/v.overlay/main.c
	//must be array of polygons
	
	// depend on jsts for now https://github.com/bjornharrtell/jsts/blob/master/examples/overlay.html
	
	var jsts = __webpack_require__(143);
	
	/**
	 * Takes two {@link Polygon|polygons} and returns a combined polygon. If the input polygons are not contiguous, this function returns a {@link MultiPolygon} feature.
	 *
	 * @name union
	 * @param {Feature<Polygon>} poly1 input polygon
	 * @param {Feature<Polygon>} poly2 another input polygon
	 * @return {Feature<(Polygon|MultiPolygon)>} a combined {@link Polygon} or {@link MultiPolygon} feature
	 * @example
	 * var poly1 = {
	 *   "type": "Feature",
	 *   "properties": {
	 *     "fill": "#0f0"
	 *   },
	 *   "geometry": {
	 *     "type": "Polygon",
	 *     "coordinates": [[
	 *       [-82.574787, 35.594087],
	 *       [-82.574787, 35.615581],
	 *       [-82.545261, 35.615581],
	 *       [-82.545261, 35.594087],
	 *       [-82.574787, 35.594087]
	 *     ]]
	 *   }
	 * };
	 * var poly2 = {
	 *   "type": "Feature",
	 *   "properties": {
	 *     "fill": "#00f"
	 *   },
	 *   "geometry": {
	 *     "type": "Polygon",
	 *     "coordinates": [[
	 *       [-82.560024, 35.585153],
	 *       [-82.560024, 35.602602],
	 *       [-82.52964, 35.602602],
	 *       [-82.52964, 35.585153],
	 *       [-82.560024, 35.585153]
	 *     ]]
	 *   }
	 * };
	 * var polygons = {
	 *   "type": "FeatureCollection",
	 *   "features": [poly1, poly2]
	 * };
	 *
	 * var union = turf.union(poly1, poly2);
	 *
	 * //=polygons
	 *
	 * //=union
	 */
	module.exports = function (poly1, poly2) {
	    var reader = new jsts.io.GeoJSONReader();
	    var a = reader.read(JSON.stringify(poly1.geometry));
	    var b = reader.read(JSON.stringify(poly2.geometry));
	    var union = a.union(b);
	    var writer = new jsts.io.GeoJSONWriter();
	
	    union = writer.write(union);
	    return {
	        type: 'Feature',
	        geometry: union,
	        properties: poly1.properties
	    };
	};


/***/ }),
/* 495 */
/***/ (function(module, exports) {

	"use strict"
	
	module.exports = twoProduct
	
	var SPLITTER = +(Math.pow(2, 27) + 1.0)
	
	function twoProduct(a, b, result) {
	  var x = a * b
	
	  var c = SPLITTER * a
	  var abig = c - a
	  var ahi = c - abig
	  var alo = a - ahi
	
	  var d = SPLITTER * b
	  var bbig = d - b
	  var bhi = d - bbig
	  var blo = b - bhi
	
	  var err1 = x - (ahi * bhi)
	  var err2 = err1 - (alo * bhi)
	  var err3 = err2 - (ahi * blo)
	
	  var y = alo * blo - err3
	
	  if(result) {
	    result[0] = y
	    result[1] = x
	    return result
	  }
	
	  return [ y, x ]
	}

/***/ }),
/* 496 */
/***/ (function(module, exports) {

	"use strict";
	
	// ES3 safe
	var _undefined = void 0;
	
	module.exports = function (value) { return value !== _undefined && value !== null; };


/***/ }),
/* 497 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDI4Ni4wNTQgMjg2LjA1NCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjg2LjA1NCAyODYuMDU0OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Zz4NCgk8cGF0aCBzdHlsZT0iZmlsbDojRTI1NzRDOyIgZD0iTTE0My4wMjcsMEM2NC4wNCwwLDAsNjQuMDQsMCwxNDMuMDI3YzAsNzguOTk2LDY0LjA0LDE0My4wMjcsMTQzLjAyNywxNDMuMDI3DQoJCWM3OC45OTYsMCwxNDMuMDI3LTY0LjAyMiwxNDMuMDI3LTE0My4wMjdDMjg2LjA1NCw2NC4wNCwyMjIuMDIyLDAsMTQzLjAyNywweiBNMTQzLjAyNywyNTkuMjM2DQoJCWMtNjQuMTgzLDAtMTE2LjIwOS01Mi4wMjYtMTE2LjIwOS0xMTYuMjA5Uzc4Ljg0NCwyNi44MTgsMTQzLjAyNywyNi44MThzMTE2LjIwOSw1Mi4wMjYsMTE2LjIwOSwxMTYuMjA5DQoJCVMyMDcuMjEsMjU5LjIzNiwxNDMuMDI3LDI1OS4yMzZ6IE0xNDMuMDM2LDYyLjcyNmMtMTAuMjQ0LDAtMTcuOTk1LDUuMzQ2LTE3Ljk5NSwxMy45ODF2NzkuMjAxYzAsOC42NDQsNy43NSwxMy45NzIsMTcuOTk1LDEzLjk3Mg0KCQljOS45OTQsMCwxNy45OTUtNS41NTEsMTcuOTk1LTEzLjk3MlY3Ni43MDdDMTYxLjAzLDY4LjI3NywxNTMuMDMsNjIuNzI2LDE0My4wMzYsNjIuNzI2eiBNMTQzLjAzNiwxODcuNzIzDQoJCWMtOS44NDIsMC0xNy44NTIsOC4wMS0xNy44NTIsMTcuODZjMCw5LjgzMyw4LjAxLDE3Ljg0MywxNy44NTIsMTcuODQzczE3Ljg0My04LjAxLDE3Ljg0My0xNy44NDMNCgkJQzE2MC44NzgsMTk1LjczMiwxNTIuODc4LDE4Ny43MjMsMTQzLjAzNiwxODcuNzIzeiIvPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),
/* 498 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 499 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAyNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMS44MTc5IDkuNDI3NzJMMjAuNzQ2OSAwLjQ5NTcxNkMyMC45MDMxIDAuMzM4NjE0IDIxLjA4ODkgMC4yMTM5NDIgMjEuMjkzNCAwLjEyODg2OUMyMS40OTggMC4wNDM3OTU3IDIxLjcxNzQgMCAyMS45Mzg5IDBDMjIuMTYwNSAwIDIyLjM3OTggMC4wNDM3OTU3IDIyLjU4NDQgMC4xMjg4NjlDMjIuNzg5IDAuMjEzOTQyIDIyLjk3NDcgMC4zMzg2MTQgMjMuMTMwOSAwLjQ5NTcxNkMyMy40NDU3IDAuODEzOTc4IDIzLjYyMjMgMS4yNDM1NiAyMy42MjIzIDEuNjkxMjJDMjMuNjIyMyAyLjEzODg3IDIzLjQ0NTcgMi41Njg0NSAyMy4xMzA5IDIuODg2NzJMMTMuMDEyOSAxMy4wMDY3QzEyLjcwNTggMTMuMzEyNiAxMi4yOTI2IDEzLjQ4ODQgMTEuODU5MiAxMy40OTc2QzExLjQyNTkgMTMuNTA2NyAxMS4wMDU2IDEzLjM0ODQgMTAuNjg1OSAxMy4wNTU3TDAuNDk2OTI4IDIuODg4NzJDMC4xNzk1OTYgMi41NzI1OCAwLjAwMDg0NjkxMiAyLjE0MzMzIDMuMDAxNzNlLTA2IDEuNjk1NEMtMC4wMDA4NDA5MDkgMS4yNDc0NyAwLjE3NjI4OSAwLjgxNzU0OCAwLjQ5MjQyOCAwLjUwMDIxN0MwLjgwODU2NiAwLjE4Mjg4NSAxLjIzNzgxIDAuMDA0MTM1ODggMS42ODU3NSAwLjAwMzI5MTk2QzIuMTMzNjggMC4wMDI0NDgwNCAyLjU2MzYgMC4xNzk1NzggMi44ODA5MyAwLjQ5NTcxNkwxMS44MTc5IDkuNDI3NzJaIiBmaWxsPSIjNTU1NTU1Ii8+DQo8L3N2Zz4NCg=="

/***/ }),
/* 500 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 501 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8xNDJfNzE1NSkiPg0KPHBhdGggZD0iTTkuNDgxOTUgMi4wNjU5NUM5LjM4Mjk2IDEuODkzNTIgOS4yNDAyMiAxLjc1MDI1IDkuMDY4MTUgMS42NTA2MkM4Ljg5NjA4IDEuNTUxIDguNzAwNzggMS40OTg1NCA4LjUwMTk1IDEuNDk4NTRDOC4zMDMxMiAxLjQ5ODU0IDguMTA3ODEgMS41NTEgNy45MzU3NCAxLjY1MDYyQzcuNzYzNjcgMS43NTAyNSA3LjYyMDk0IDEuODkzNTIgNy41MjE5NSAyLjA2NTk1TDAuNjY0OTQ2IDEzLjczM0MwLjIwNzk0NiAxNC41MTEgMC43NTU5NDYgMTUuNSAxLjY0NDk1IDE1LjVIMTUuMzU3OUMxNi4yNDY5IDE1LjUgMTYuNzk1OSAxNC41MSAxNi4zMzc5IDEzLjczM0w5LjQ4MTk1IDIuMDY1OTVaTTguNDk5OTUgNS40OTk5NUM5LjAzNDk1IDUuNDk5OTUgOS40NTM5NSA1Ljk2MTk1IDkuMzk5OTUgNi40OTQ5NUw5LjA0OTk1IDEwLjAwMkM5LjAzODE5IDEwLjEzOTcgOC45NzUxNSAxMC4yNjgxIDguODczMyAxMC4zNjE2QzguNzcxNDUgMTAuNDU1MSA4LjYzODIyIDEwLjUwNyA4LjQ5OTk1IDEwLjUwN0M4LjM2MTY3IDEwLjUwNyA4LjIyODQ0IDEwLjQ1NTEgOC4xMjY1OSAxMC4zNjE2QzguMDI0NzQgMTAuMjY4MSA3Ljk2MTcxIDEwLjEzOTcgNy45NDk5NSAxMC4wMDJMNy41OTk5NSA2LjQ5NDk1QzcuNTg3MzggNi4zNjkxOSA3LjYwMTI5IDYuMjQyMTggNy42NDA3OSA2LjEyMjEyQzcuNjgwMjkgNi4wMDIwNiA3Ljc0NDUgNS44OTE2IDcuODI5MjkgNS43OTc4NkM3LjkxNDA4IDUuNzA0MTMgOC4wMTc1NiA1LjYyOTE5IDguMTMzMDcgNS41Nzc4OEM4LjI0ODU4IDUuNTI2NTcgOC4zNzM1NSA1LjUwMDAyIDguNDk5OTUgNS40OTk5NVpNOC41MDE5NSAxMS41QzguNzY3MTYgMTEuNSA5LjAyMTUyIDExLjYwNTMgOS4yMDkwNSAxMS43OTI4QzkuMzk2NTkgMTEuOTgwNCA5LjUwMTk1IDEyLjIzNDcgOS41MDE5NSAxMi41QzkuNTAxOTUgMTIuNzY1MiA5LjM5NjU5IDEzLjAxOTUgOS4yMDkwNSAxMy4yMDcxQzkuMDIxNTIgMTMuMzk0NiA4Ljc2NzE2IDEzLjUgOC41MDE5NSAxMy41QzguMjM2NzMgMTMuNSA3Ljk4MjM4IDEzLjM5NDYgNy43OTQ4NCAxMy4yMDcxQzcuNjA3MyAxMy4wMTk1IDcuNTAxOTUgMTIuNzY1MiA3LjUwMTk1IDEyLjVDNy41MDE5NSAxMi4yMzQ3IDcuNjA3MyAxMS45ODA0IDcuNzk0ODQgMTEuNzkyOEM3Ljk4MjM4IDExLjYwNTMgOC4yMzY3MyAxMS41IDguNTAxOTUgMTEuNVoiIGZpbGw9IiMyOTA2NjEiLz4NCjwvZz4NCjxkZWZzPg0KPGNsaXBQYXRoIGlkPSJjbGlwMF8xNDJfNzE1NSI+DQo8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjUgMC41KSIvPg0KPC9jbGlwUGF0aD4NCjwvZGVmcz4NCjwvc3ZnPg0K"

/***/ }),
/* 502 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xNyAxTDIxIDVMMTcgOSIgc3Ryb2tlPSIjMDAzMzk5IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjxwYXRoIGQ9Ik0zIDExVjlDMyA3LjkzOTEzIDMuNDIxNDMgNi45MjE3MiA0LjE3MTU3IDYuMTcxNTdDNC45MjE3MiA1LjQyMTQzIDUuOTM5MTMgNSA3IDVIMjEiIHN0cm9rZT0iIzAwMzM5OSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8cGF0aCBkPSJNNyAyM0wzIDE5TDcgMTUiIHN0cm9rZT0iIzAwMzM5OSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8cGF0aCBkPSJNMjEgMTNWMTVDMjEgMTYuMDYwOSAyMC41Nzg2IDE3LjA3ODMgMTkuODI4NCAxNy44Mjg0QzE5LjA3ODMgMTguNTc4NiAxOC4wNjA5IDE5IDE3IDE5SDMiIHN0cm9rZT0iIzAwMzM5OSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8L3N2Zz4NCg=="

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img-contact.0c323f3.svg";

/***/ }),
/* 504 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 505 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGlkPSJwaG9uZSI+DQo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNMjIuMDAwNCAxNy40MlYyMC40MkMyMi4wMDE2IDIwLjY5ODUgMjEuOTQ0NSAyMC45NzQyIDIxLjgzMjkgMjEuMjI5NEMyMS43MjE0IDIxLjQ4NDUgMjEuNTU3NyAyMS43MTM2IDIxLjM1MjUgMjEuOTAxOUMyMS4xNDczIDIyLjA5MDEgMjAuOTA1IDIyLjIzMzUgMjAuNjQxMiAyMi4zMjI3QzIwLjM3NzMgMjIuNDExOSAyMC4wOTc4IDIyLjQ0NTEgMTkuODIwNCAyMi40MkMxNi43NDMzIDIyLjA4NTYgMTMuNzg3NCAyMS4wMzQyIDExLjE5MDQgMTkuMzVDOC43NzQyNSAxNy44MTQ3IDYuNzI1NzYgMTUuNzY2MiA1LjE5MDQyIDEzLjM1QzMuNTAwNCAxMC43NDEyIDIuNDQ4NjYgNy43NzEgMi4xMjA0MiA0LjY4MDAxQzIuMDk1NDMgNC40MDM0NyAyLjEyODMgNC4xMjQ3NyAyLjIxNjkyIDMuODYxNjNDMi4zMDU1NSAzLjU5ODQ5IDIuNDQ3OTkgMy4zNTY2OSAyLjYzNTE5IDMuMTUxNjNDMi44MjIzOCAyLjk0NjU2IDMuMDUwMjMgMi43ODI3MSAzLjMwNDIxIDIuNjcwNTNDMy41NTgyIDIuNTU4MzQgMy44MzI3NiAyLjUwMDI3IDQuMTEwNDIgMi41MDAwMUg3LjExMDQyQzcuNTk1NzMgMi40OTUyMyA4LjA2NjIxIDIuNjY3MDggOC40MzQxOCAyLjk4MzU0QzguODAyMTUgMy4yOTk5OSA5LjA0MjUgMy43Mzk0NSA5LjExMDQyIDQuMjIwMDFDOS4yMzcwNCA1LjE4MDA3IDkuNDcxODcgNi4xMjI3MyA5LjgxMDQyIDcuMDMwMDFDOS45NDQ5NyA3LjM4NzkzIDkuOTc0MDggNy43NzY5MiA5Ljg5NDMzIDguMTUwODlDOS44MTQ1NyA4LjUyNDg1IDkuNjI5MjggOC44NjgxMiA5LjM2MDQyIDkuMTQwMDFMOC4wOTA0MiAxMC40MUM5LjUxMzk4IDEyLjkxMzYgMTEuNTg2OSAxNC45ODY1IDE0LjA5MDQgMTYuNDFMMTUuMzYwNCAxNS4xNEMxNS42MzIzIDE0Ljg3MTEgMTUuOTc1NiAxNC42ODU5IDE2LjM0OTUgMTQuNjA2MUMxNi43MjM1IDE0LjUyNjMgMTcuMTEyNSAxNC41NTU1IDE3LjQ3MDQgMTQuNjlDMTguMzc3NyAxNS4wMjg2IDE5LjMyMDQgMTUuMjYzNCAyMC4yODA0IDE1LjM5QzIwLjc2NjIgMTUuNDU4NSAyMS4yMDk4IDE1LjcwMzIgMjEuNTI3IDE2LjA3NzVDMjEuODQ0MSAxNi40NTE4IDIyLjAxMjYgMTYuOTI5NiAyMi4wMDA0IDE3LjQyWiIgc3Ryb2tlPSIjNUQzQjgxIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),
/* 506 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik05LjQ3MTk5IDYuNjU2MDVMMTAuODE2IDUuNDcyMDVDMTEuMzYgNC45OTIwNSAxMi4xOTIgNS4wNTYwNSAxMi42NzIgNS42MDAwNUMxMi43MzYgNS42NjQwNSAxMi44IDUuNzYwMDUgMTIuODMyIDUuODI0MDVMMTQuNjg4IDkuMDI0MDVDMTUuMDQgOS42NjQwNSAxNC44NDggMTAuNDY0IDE0LjIwOCAxMC44NDgxTDEzLjk4NCAxMC45NzZDMTMuNDQgMTEuMjY0MSAxMy4xODQgMTEuOTM2IDEzLjM3NiAxMi41MTJMMTQuMDQ4IDE0LjU5MkMxNC42MjQgMTYuNDggMTUuNjQ4IDE4LjIwOCAxNi45OTIgMTkuNjQ4TDE4LjMwNCAyMS4wODhDMTguNzIgMjEuNTM2IDE5LjM5MiAyMS42MzIgMTkuOTM2IDIxLjMxMkwyMC4xNiAyMS4xODRDMjAuOCAyMC44MzIgMjEuNjMyIDIxLjA1NiAyMS45ODQgMjEuNjk2TDIzLjg0IDI0Ljg2NEMyNC4yMjQgMjUuNTA0IDI0IDI2LjMzNjEgMjMuMzYgMjYuNjg4QzIzLjI2NCAyNi43NTIgMjMuMiAyNi43ODQgMjMuMTA0IDI2LjgxNkwyMS40NCAyNy4zNjAxQzE5LjQ1NiAyOC4wMzIgMTcuMzEyIDI3LjQ4OCAxNS44NzIgMjUuOTg0TDE0LjI3MiAyNC4zMkMxMS42OCAyMS41NjgxIDkuNzU5OTkgMTguMjcyIDguNjcxOTggMTQuNjU2TDcuOTAzOTggMTIuMTZDNy4yOTU5OCAxMC4xNzYgNy45MDM5OCA4LjAzMjA1IDkuNDcxOTkgNi42NTYwNVoiIGZpbGw9IiM1RDNCODEiLz4NCjwvc3ZnPg0K"

/***/ }),
/* 507 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTgiIGhlaWdodD0iNTgiIHZpZXdCb3g9IjAgMCA1OCA1OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxjaXJjbGUgY3g9IjI5IiBjeT0iMjkiIHI9IjIwLjUiIHN0cm9rZT0iIzFDMzQ1NCIgc3Ryb2tlLW9wYWNpdHk9IjAuMjYiLz4NCjxwYXRoIGQ9Ik0yNi42NzQ1IDI5TDIwLjczMTYgMjMuMDU3MUMyMC4wODk1IDIyLjQxNDkgMjAuMDg5NSAyMS4zNzM4IDIwLjczMTYgMjAuNzMxNkMyMS4zNzM4IDIwLjA4OTUgMjIuNDE0OSAyMC4wODk1IDIzLjA1NzEgMjAuNzMxNkwyOSAyNi42NzQ1TDM0Ljk0MjkgMjAuNzMxNkMzNS41ODUxIDIwLjA4OTUgMzYuNjI2MiAyMC4wODk1IDM3LjI2ODQgMjAuNzMxNkMzNy45MTA1IDIxLjM3MzggMzcuOTEwNSAyMi40MTQ5IDM3LjI2ODQgMjMuMDU3MUwzMS4zMjU1IDI5TDM3LjI2ODQgMzQuOTQyOUMzNy45MTA1IDM1LjU4NTEgMzcuOTEwNSAzNi42MjYyIDM3LjI2ODQgMzcuMjY4NEMzNi42MjYyIDM3LjkxMDUgMzUuNTg1MSAzNy45MTA1IDM0Ljk0MjkgMzcuMjY4NEwyOSAzMS4zMjU1TDIzLjA1NzEgMzcuMjY4NEMyMi40MTQ5IDM3LjkxMDUgMjEuMzczOCAzNy45MTA1IDIwLjczMTYgMzcuMjY4NEMyMC4wODk1IDM2LjYyNjIgMjAuMDg5NSAzNS41ODUxIDIwLjczMTYgMzQuOTQyOUwyNi42NzQ1IDI5WiIgZmlsbD0iIzVEM0I4MSIvPg0KPC9zdmc+DQo="

/***/ }),
/* 508 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDUiIGhlaWdodD0iNDUiIHZpZXdCb3g9IjAgMCA0NSA0NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0yMC44Njg1IDIyLjM0OTdMMTYuMzE1IDE3Ljc5NjJDMTUuODIzIDE3LjMwNDIgMTUuODIzIDE2LjUwNjQgMTYuMzE1IDE2LjAxNDRDMTYuODA3IDE1LjUyMjQgMTcuNjA0OCAxNS41MjI0IDE4LjA5NjggMTYuMDE0NEwyMi42NTAzIDIwLjU2NzlMMjcuMjAzOCAxNi4wMTQ0QzI3LjY5NTggMTUuNTIyNCAyOC40OTM2IDE1LjUyMjQgMjguOTg1NiAxNi4wMTQ0QzI5LjQ3NzYgMTYuNTA2NCAyOS40Nzc2IDE3LjMwNDIgMjguOTg1NiAxNy43OTYyTDI0LjQzMjEgMjIuMzQ5N0wyOC45ODU2IDI2LjkwMzJDMjkuNDc3NiAyNy4zOTUyIDI5LjQ3NzYgMjguMTkzIDI4Ljk4NTYgMjguNjg1QzI4LjQ5MzYgMjkuMTc3IDI3LjY5NTggMjkuMTc3IDI3LjIwMzggMjguNjg1TDIyLjY1MDMgMjQuMTMxNUwxOC4wOTY4IDI4LjY4NUMxNy42MDQ4IDI5LjE3NyAxNi44MDcgMjkuMTc3IDE2LjMxNSAyOC42ODVDMTUuODIzIDI4LjE5MyAxNS44MjMgMjcuMzk1MiAxNi4zMTUgMjYuOTAzMkwyMC44Njg1IDIyLjM0OTdaIiBmaWxsPSIjNUQzQjgxIi8+DQo8L3N2Zz4NCg=="

/***/ }),
/* 509 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik05LjI3MjgzIDYuNzgwNjlDOC44NzkxMiA2LjM0MTY0IDguOTE1ODcgNS42NjY1NSA5LjM1NDkyIDUuMjcyODNDOS43OTM5NyA0Ljg3OTEyIDEwLjQ2OTEgNC45MTU4NyAxMC44NjI4IDUuMzU0OTJDMTAuODYyOCA1LjM1NDkyIDE2LjAwMjIgMTAuOTU0MyAxNi4zNjYgMTEuMzZDMTYuNzI5OCAxMS43NjU3IDE2LjcyOTggMTIuMjM5MiAxNi4zNjYgMTIuNjQ0OEwxMC44NjI4IDE4LjY0NTFDMTAuNDY5MSAxOS4wODQxIDkuNzkzOTcgMTkuMTIwOSA5LjM1NDkyIDE4LjcyNzJDOC45MTU4NyAxOC4zMzM0IDguODc5MTIgMTcuNjU4NCA5LjI3MjgzIDE3LjIxOTNMMTQuMTM2OCAxMkw5LjI3MjgzIDYuNzgwNjlaIiBmaWxsPSJ3aGl0ZSIvPg0KPC9zdmc+DQo="

/***/ }),
/* 510 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * vee-validate v2.0.0-rc.18
	 * (c) 2017 Abdelrahman Awad
	 * @license MIT
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.VeeValidate = factory());
	}(this, (function () { 'use strict';
	
	var MILLISECONDS_IN_HOUR = 3600000;
	var MILLISECONDS_IN_MINUTE = 60000;
	var DEFAULT_ADDITIONAL_DIGITS = 2;
	
	var patterns = {
	  dateTimeDelimeter: /[T ]/,
	  plainTime: /:/,
	
	  // year tokens
	  YY: /^(\d{2})$/,
	  YYY: [
	    /^([+-]\d{2})$/, // 0 additional digits
	    /^([+-]\d{3})$/, // 1 additional digit
	    /^([+-]\d{4})$/ // 2 additional digits
	  ],
	  YYYY: /^(\d{4})/,
	  YYYYY: [
	    /^([+-]\d{4})/, // 0 additional digits
	    /^([+-]\d{5})/, // 1 additional digit
	    /^([+-]\d{6})/ // 2 additional digits
	  ],
	
	  // date tokens
	  MM: /^-(\d{2})$/,
	  DDD: /^-?(\d{3})$/,
	  MMDD: /^-?(\d{2})-?(\d{2})$/,
	  Www: /^-?W(\d{2})$/,
	  WwwD: /^-?W(\d{2})-?(\d{1})$/,
	
	  HH: /^(\d{2}([.,]\d*)?)$/,
	  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
	  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
	
	  // timezone tokens
	  timezone: /([Z+-].*)$/,
	  timezoneZ: /^(Z)$/,
	  timezoneHH: /^([+-])(\d{2})$/,
	  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
	};
	
	/**
	 * @name toDate
	 * @category Common Helpers
	 * @summary Convert the given argument to an instance of Date.
	 *
	 * @description
	 * Convert the given argument to an instance of Date.
	 *
	 * If the argument is an instance of Date, the function returns its clone.
	 *
	 * If the argument is a number, it is treated as a timestamp.
	 *
	 * If an argument is a string, the function tries to parse it.
	 * Function accepts complete ISO 8601 formats as well as partial implementations.
	 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
	 *
	 * If all above fails, the function passes the given argument to Date constructor.
	 *
	 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
	 * All *date-fns* functions will throw `RangeError` if `options.additionalDigits` is not 0, 1, 2 or undefined.
	 *
	 * @param {Date|String|Number} argument - the value to convert
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Convert string '2014-02-11T11:30:30' to date:
	 * var result = toDate('2014-02-11T11:30:30')
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert string '+02014101' to date,
	 * // if the additional number of digits in the extended year format is 1:
	 * var result = toDate('+02014101', {additionalDigits: 1})
	 * //=> Fri Apr 11 2014 00:00:00
	 */
	function toDate (argument, dirtyOptions) {
	  var options = dirtyOptions || {};
	
	  var additionalDigits = options.additionalDigits === undefined ? DEFAULT_ADDITIONAL_DIGITS : Number(options.additionalDigits);
	  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
	    throw new RangeError('additionalDigits must be 0, 1 or 2')
	  }
	
	  // Clone the date
	  if (argument instanceof Date) {
	    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
	    return new Date(argument.getTime())
	  } else if (typeof argument !== 'string') {
	    return new Date(argument)
	  }
	
	  var dateStrings = splitDateString(argument);
	
	  var parseYearResult = parseYear(dateStrings.date, additionalDigits);
	  var year = parseYearResult.year;
	  var restDateString = parseYearResult.restDateString;
	
	  var date = parseDate(restDateString, year);
	
	  if (date) {
	    var timestamp = date.getTime();
	    var time = 0;
	    var offset;
	
	    if (dateStrings.time) {
	      time = parseTime(dateStrings.time);
	    }
	
	    if (dateStrings.timezone) {
	      offset = parseTimezone(dateStrings.timezone);
	    } else {
	      // get offset accurate to hour in timezones that change offset
	      offset = new Date(timestamp + time).getTimezoneOffset();
	      offset = new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE).getTimezoneOffset();
	    }
	
	    return new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE)
	  } else {
	    return new Date(argument)
	  }
	}
	
	function splitDateString (dateString) {
	  var dateStrings = {};
	  var array = dateString.split(patterns.dateTimeDelimeter);
	  var timeString;
	
	  if (patterns.plainTime.test(array[0])) {
	    dateStrings.date = null;
	    timeString = array[0];
	  } else {
	    dateStrings.date = array[0];
	    timeString = array[1];
	  }
	
	  if (timeString) {
	    var token = patterns.timezone.exec(timeString);
	    if (token) {
	      dateStrings.time = timeString.replace(token[1], '');
	      dateStrings.timezone = token[1];
	    } else {
	      dateStrings.time = timeString;
	    }
	  }
	
	  return dateStrings
	}
	
	function parseYear (dateString, additionalDigits) {
	  var patternYYY = patterns.YYY[additionalDigits];
	  var patternYYYYY = patterns.YYYYY[additionalDigits];
	
	  var token;
	
	  // YYYY or ±YYYYY
	  token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
	  if (token) {
	    var yearString = token[1];
	    return {
	      year: parseInt(yearString, 10),
	      restDateString: dateString.slice(yearString.length)
	    }
	  }
	
	  // YY or ±YYY
	  token = patterns.YY.exec(dateString) || patternYYY.exec(dateString);
	  if (token) {
	    var centuryString = token[1];
	    return {
	      year: parseInt(centuryString, 10) * 100,
	      restDateString: dateString.slice(centuryString.length)
	    }
	  }
	
	  // Invalid ISO-formatted year
	  return {
	    year: null
	  }
	}
	
	function parseDate (dateString, year) {
	  // Invalid ISO-formatted year
	  if (year === null) {
	    return null
	  }
	
	  var token;
	  var date;
	  var month;
	  var week;
	
	  // YYYY
	  if (dateString.length === 0) {
	    date = new Date(0);
	    date.setUTCFullYear(year);
	    return date
	  }
	
	  // YYYY-MM
	  token = patterns.MM.exec(dateString);
	  if (token) {
	    date = new Date(0);
	    month = parseInt(token[1], 10) - 1;
	    date.setUTCFullYear(year, month);
	    return date
	  }
	
	  // YYYY-DDD or YYYYDDD
	  token = patterns.DDD.exec(dateString);
	  if (token) {
	    date = new Date(0);
	    var dayOfYear = parseInt(token[1], 10);
	    date.setUTCFullYear(year, 0, dayOfYear);
	    return date
	  }
	
	  // YYYY-MM-DD or YYYYMMDD
	  token = patterns.MMDD.exec(dateString);
	  if (token) {
	    date = new Date(0);
	    month = parseInt(token[1], 10) - 1;
	    var day = parseInt(token[2], 10);
	    date.setUTCFullYear(year, month, day);
	    return date
	  }
	
	  // YYYY-Www or YYYYWww
	  token = patterns.Www.exec(dateString);
	  if (token) {
	    week = parseInt(token[1], 10) - 1;
	    return dayOfISOYear(year, week)
	  }
	
	  // YYYY-Www-D or YYYYWwwD
	  token = patterns.WwwD.exec(dateString);
	  if (token) {
	    week = parseInt(token[1], 10) - 1;
	    var dayOfWeek = parseInt(token[2], 10) - 1;
	    return dayOfISOYear(year, week, dayOfWeek)
	  }
	
	  // Invalid ISO-formatted date
	  return null
	}
	
	function parseTime (timeString) {
	  var token;
	  var hours;
	  var minutes;
	
	  // hh
	  token = patterns.HH.exec(timeString);
	  if (token) {
	    hours = parseFloat(token[1].replace(',', '.'));
	    return (hours % 24) * MILLISECONDS_IN_HOUR
	  }
	
	  // hh:mm or hhmm
	  token = patterns.HHMM.exec(timeString);
	  if (token) {
	    hours = parseInt(token[1], 10);
	    minutes = parseFloat(token[2].replace(',', '.'));
	    return (hours % 24) * MILLISECONDS_IN_HOUR +
	      minutes * MILLISECONDS_IN_MINUTE
	  }
	
	  // hh:mm:ss or hhmmss
	  token = patterns.HHMMSS.exec(timeString);
	  if (token) {
	    hours = parseInt(token[1], 10);
	    minutes = parseInt(token[2], 10);
	    var seconds = parseFloat(token[3].replace(',', '.'));
	    return (hours % 24) * MILLISECONDS_IN_HOUR +
	      minutes * MILLISECONDS_IN_MINUTE +
	      seconds * 1000
	  }
	
	  // Invalid ISO-formatted time
	  return null
	}
	
	function parseTimezone (timezoneString) {
	  var token;
	  var absoluteOffset;
	
	  // Z
	  token = patterns.timezoneZ.exec(timezoneString);
	  if (token) {
	    return 0
	  }
	
	  // ±hh
	  token = patterns.timezoneHH.exec(timezoneString);
	  if (token) {
	    absoluteOffset = parseInt(token[2], 10) * 60;
	    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
	  }
	
	  // ±hh:mm or ±hhmm
	  token = patterns.timezoneHHMM.exec(timezoneString);
	  if (token) {
	    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10);
	    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
	  }
	
	  return 0
	}
	
	function dayOfISOYear (isoYear, week, day) {
	  week = week || 0;
	  day = day || 0;
	  var date = new Date(0);
	  date.setUTCFullYear(isoYear, 0, 4);
	  var fourthOfJanuaryDay = date.getUTCDay() || 7;
	  var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date
	}
	
	/**
	 * @name addMilliseconds
	 * @category Millisecond Helpers
	 * @summary Add the specified number of milliseconds to the given date.
	 *
	 * @description
	 * Add the specified number of milliseconds to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be added
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the new date with the milliseconds added
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
	 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:30.750
	 */
	function addMilliseconds (dirtyDate, dirtyAmount, dirtyOptions) {
	  var timestamp = toDate(dirtyDate, dirtyOptions).getTime();
	  var amount = Number(dirtyAmount);
	  return new Date(timestamp + amount)
	}
	
	function cloneObject (dirtyObject) {
	  dirtyObject = dirtyObject || {};
	  var object = {};
	
	  for (var property in dirtyObject) {
	    if (dirtyObject.hasOwnProperty(property)) {
	      object[property] = dirtyObject[property];
	    }
	  }
	
	  return object
	}
	
	var MILLISECONDS_IN_MINUTE$2 = 60000;
	
	/**
	 * @name addMinutes
	 * @category Minute Helpers
	 * @summary Add the specified number of minutes to the given date.
	 *
	 * @description
	 * Add the specified number of minutes to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be added
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the new date with the minutes added
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Add 30 minutes to 10 July 2014 12:00:00:
	 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 12:30:00
	 */
	function addMinutes (dirtyDate, dirtyAmount, dirtyOptions) {
	  var amount = Number(dirtyAmount);
	  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE$2, dirtyOptions)
	}
	
	/**
	 * @name isValid
	 * @category Common Helpers
	 * @summary Is the given date valid?
	 *
	 * @description
	 * Returns false if argument is Invalid Date and true otherwise.
	 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * Invalid Date is a Date, whose time value is NaN.
	 *
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Boolean} the date is valid
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // For the valid date:
	 * var result = isValid(new Date(2014, 1, 31))
	 * //=> true
	 *
	 * @example
	 * // For the value, convertable into a date:
	 * var result = isValid('2014-02-31')
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * var result = isValid(new Date(''))
	 * //=> false
	 */
	function isValid (dirtyDate, dirtyOptions) {
	  var date = toDate(dirtyDate, dirtyOptions);
	  return !isNaN(date)
	}
	
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'less than a second',
	    other: 'less than {{count}} seconds'
	  },
	
	  xSeconds: {
	    one: '1 second',
	    other: '{{count}} seconds'
	  },
	
	  halfAMinute: 'half a minute',
	
	  lessThanXMinutes: {
	    one: 'less than a minute',
	    other: 'less than {{count}} minutes'
	  },
	
	  xMinutes: {
	    one: '1 minute',
	    other: '{{count}} minutes'
	  },
	
	  aboutXHours: {
	    one: 'about 1 hour',
	    other: 'about {{count}} hours'
	  },
	
	  xHours: {
	    one: '1 hour',
	    other: '{{count}} hours'
	  },
	
	  xDays: {
	    one: '1 day',
	    other: '{{count}} days'
	  },
	
	  aboutXMonths: {
	    one: 'about 1 month',
	    other: 'about {{count}} months'
	  },
	
	  xMonths: {
	    one: '1 month',
	    other: '{{count}} months'
	  },
	
	  aboutXYears: {
	    one: 'about 1 year',
	    other: 'about {{count}} years'
	  },
	
	  xYears: {
	    one: '1 year',
	    other: '{{count}} years'
	  },
	
	  overXYears: {
	    one: 'over 1 year',
	    other: 'over {{count}} years'
	  },
	
	  almostXYears: {
	    one: 'almost 1 year',
	    other: 'almost {{count}} years'
	  }
	};
	
	function formatDistance (token, count, options) {
	  options = options || {};
	
	  var result;
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'in ' + result
	    } else {
	      return result + ' ago'
	    }
	  }
	
	  return result
	}
	
	var tokensToBeShortedPattern = /MMMM|MM|DD|dddd/g;
	
	function buildShortLongFormat (format) {
	  return format.replace(tokensToBeShortedPattern, function (token) {
	    return token.slice(1)
	  })
	}
	
	/**
	 * @name buildFormatLongFn
	 * @category Locale Helpers
	 * @summary Build `formatLong` property for locale used by `format`, `formatRelative` and `parse` functions.
	 *
	 * @description
	 * Build `formatLong` property for locale used by `format`, `formatRelative` and `parse` functions.
	 * Returns a function which takes one of the following tokens as the argument:
	 * `'LTS'`, `'LT'`, `'L'`, `'LL'`, `'LLL'`, `'l'`, `'ll'`, `'lll'`, `'llll'`
	 * and returns a long format string written as `format` token strings.
	 * See [format]{@link https://date-fns.org/docs/format}
	 *
	 * `'l'`, `'ll'`, `'lll'` and `'llll'` formats are built automatically
	 * by shortening some of the tokens from corresponding unshortened formats
	 * (e.g., if `LL` is `'MMMM DD YYYY'` then `ll` will be `MMM D YYYY`)
	 *
	 * @param {Object} obj - the object with long formats written as `format` token strings
	 * @param {String} obj.LT - time format: hours and minutes
	 * @param {String} obj.LTS - time format: hours, minutes and seconds
	 * @param {String} obj.L - short date format: numeric day, month and year
	 * @param {String} [obj.l] - short date format: numeric day, month and year (shortened)
	 * @param {String} obj.LL - long date format: day, month in words, and year
	 * @param {String} [obj.ll] - long date format: day, month in words, and year (shortened)
	 * @param {String} obj.LLL - long date and time format
	 * @param {String} [obj.lll] - long date and time format (shortened)
	 * @param {String} obj.LLLL - long date, time and weekday format
	 * @param {String} [obj.llll] - long date, time and weekday format (shortened)
	 * @returns {Function} `formatLong` property of the locale
	 *
	 * @example
	 * // For `en-US` locale:
	 * locale.formatLong = buildFormatLongFn({
	 *   LT: 'h:mm aa',
	 *   LTS: 'h:mm:ss aa',
	 *   L: 'MM/DD/YYYY',
	 *   LL: 'MMMM D YYYY',
	 *   LLL: 'MMMM D YYYY h:mm aa',
	 *   LLLL: 'dddd, MMMM D YYYY h:mm aa'
	 * })
	 */
	function buildFormatLongFn (obj) {
	  var formatLongLocale = {
	    LTS: obj.LTS,
	    LT: obj.LT,
	    L: obj.L,
	    LL: obj.LL,
	    LLL: obj.LLL,
	    LLLL: obj.LLLL,
	    l: obj.l || buildShortLongFormat(obj.L),
	    ll: obj.ll || buildShortLongFormat(obj.LL),
	    lll: obj.lll || buildShortLongFormat(obj.LLL),
	    llll: obj.llll || buildShortLongFormat(obj.LLLL)
	  };
	
	  return function (token) {
	    return formatLongLocale[token]
	  }
	}
	
	var formatLong = buildFormatLongFn({
	  LT: 'h:mm aa',
	  LTS: 'h:mm:ss aa',
	  L: 'MM/DD/YYYY',
	  LL: 'MMMM D YYYY',
	  LLL: 'MMMM D YYYY h:mm aa',
	  LLLL: 'dddd, MMMM D YYYY h:mm aa'
	});
	
	var formatRelativeLocale = {
	  lastWeek: '[last] dddd [at] LT',
	  yesterday: '[yesterday at] LT',
	  today: '[today at] LT',
	  tomorrow: '[tomorrow at] LT',
	  nextWeek: 'dddd [at] LT',
	  other: 'L'
	};
	
	function formatRelative (token, date, baseDate, options) {
	  return formatRelativeLocale[token]
	}
	
	/**
	 * @name buildLocalizeFn
	 * @category Locale Helpers
	 * @summary Build `localize.weekday`, `localize.month` and `localize.timeOfDay` properties for the locale.
	 *
	 * @description
	 * Build `localize.weekday`, `localize.month` and `localize.timeOfDay` properties for the locale
	 * used by `format` function.
	 * If no `type` is supplied to the options of the resulting function, `defaultType` will be used (see example).
	 *
	 * `localize.weekday` function takes the weekday index as argument (0 - Sunday).
	 * `localize.month` takes the month index (0 - January).
	 * `localize.timeOfDay` takes the hours. Use `indexCallback` to convert them to an array index (see example).
	 *
	 * @param {Object} values - the object with arrays of values
	 * @param {String} defaultType - the default type for the localize function
	 * @param {Function} [indexCallback] - the callback which takes the resulting function argument
	 *   and converts it into value array index
	 * @returns {Function} the resulting function
	 *
	 * @example
	 * var timeOfDayValues = {
	 *   uppercase: ['AM', 'PM'],
	 *   lowercase: ['am', 'pm'],
	 *   long: ['a.m.', 'p.m.']
	 * }
	 * locale.localize.timeOfDay = buildLocalizeFn(timeOfDayValues, 'long', function (hours) {
	 *   // 0 is a.m. array index, 1 is p.m. array index
	 *   return (hours / 12) >= 1 ? 1 : 0
	 * })
	 * locale.localize.timeOfDay(16, {type: 'uppercase'}) //=> 'PM'
	 * locale.localize.timeOfDay(5) //=> 'a.m.'
	 */
	function buildLocalizeFn (values, defaultType, indexCallback) {
	  return function (dirtyIndex, dirtyOptions) {
	    var options = dirtyOptions || {};
	    var type = options.type ? String(options.type) : defaultType;
	    var valuesArray = values[type] || values[defaultType];
	    var index = indexCallback ? indexCallback(Number(dirtyIndex)) : Number(dirtyIndex);
	    return valuesArray[index]
	  }
	}
	
	/**
	 * @name buildLocalizeArrayFn
	 * @category Locale Helpers
	 * @summary Build `localize.weekdays`, `localize.months` and `localize.timesOfDay` properties for the locale.
	 *
	 * @description
	 * Build `localize.weekdays`, `localize.months` and `localize.timesOfDay` properties for the locale.
	 * If no `type` is supplied to the options of the resulting function, `defaultType` will be used (see example).
	 *
	 * @param {Object} values - the object with arrays of values
	 * @param {String} defaultType - the default type for the localize function
	 * @returns {Function} the resulting function
	 *
	 * @example
	 * var weekdayValues = {
	 *   narrow: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	 *   short: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	 *   long: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	 * }
	 * locale.localize.weekdays = buildLocalizeArrayFn(weekdayValues, 'long')
	 * locale.localize.weekdays({type: 'narrow'}) //=> ['Su', 'Mo', ...]
	 * locale.localize.weekdays() //=> ['Sunday', 'Monday', ...]
	 */
	function buildLocalizeArrayFn (values, defaultType) {
	  return function (dirtyOptions) {
	    var options = dirtyOptions || {};
	    var type = options.type ? String(options.type) : defaultType;
	    return values[type] || values[defaultType]
	  }
	}
	
	// Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	var weekdayValues = {
	  narrow: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	  short: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	  long: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	};
	
	var monthValues = {
	  short: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	  long: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	};
	
	// `timeOfDay` is used to designate which part of the day it is, when used with 12-hour clock.
	// Use the system which is used the most commonly in the locale.
	// For example, if the country doesn't use a.m./p.m., you can use `night`/`morning`/`afternoon`/`evening`:
	//
	//   var timeOfDayValues = {
	//     any: ['in the night', 'in the morning', 'in the afternoon', 'in the evening']
	//   }
	//
	// And later:
	//
	//   var localize = {
	//     // The callback takes the hours as the argument and returns the array index
	//     timeOfDay: buildLocalizeFn(timeOfDayValues, 'any', function (hours) {
	//       if (hours >= 17) {
	//         return 3
	//       } else if (hours >= 12) {
	//         return 2
	//       } else if (hours >= 4) {
	//         return 1
	//       } else {
	//         return 0
	//       }
	//     }),
	//     timesOfDay: buildLocalizeArrayFn(timeOfDayValues, 'any')
	//   }
	var timeOfDayValues = {
	  uppercase: ['AM', 'PM'],
	  lowercase: ['am', 'pm'],
	  long: ['a.m.', 'p.m.']
	};
	
	function ordinalNumber (dirtyNumber, dirtyOptions) {
	  var number = Number(dirtyNumber);
	
	  // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'month', 'quarter', 'week', 'isoWeek', 'dayOfYear',
	  // 'dayOfMonth' or 'dayOfWeek'
	
	  var rem100 = number % 100;
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + 'st'
	      case 2:
	        return number + 'nd'
	      case 3:
	        return number + 'rd'
	    }
	  }
	  return number + 'th'
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  weekday: buildLocalizeFn(weekdayValues, 'long'),
	  weekdays: buildLocalizeArrayFn(weekdayValues, 'long'),
	  month: buildLocalizeFn(monthValues, 'long'),
	  months: buildLocalizeArrayFn(monthValues, 'long'),
	  timeOfDay: buildLocalizeFn(timeOfDayValues, 'long', function (hours) {
	    return (hours / 12) >= 1 ? 1 : 0
	  }),
	  timesOfDay: buildLocalizeArrayFn(timeOfDayValues, 'long')
	};
	
	/**
	 * @name buildMatchFn
	 * @category Locale Helpers
	 * @summary Build `match.weekdays`, `match.months` and `match.timesOfDay` properties for the locale.
	 *
	 * @description
	 * Build `match.weekdays`, `match.months` and `match.timesOfDay` properties for the locale used by `parse` function.
	 * If no `type` is supplied to the options of the resulting function, `defaultType` will be used (see example).
	 * The result of the match function will be passed into corresponding parser function
	 * (`match.weekday`, `match.month` or `match.timeOfDay` respectively. See `buildParseFn`).
	 *
	 * @param {Object} values - the object with RegExps
	 * @param {String} defaultType - the default type for the match function
	 * @returns {Function} the resulting function
	 *
	 * @example
	 * var matchWeekdaysPatterns = {
	 *   narrow: /^(su|mo|tu|we|th|fr|sa)/i,
	 *   short: /^(sun|mon|tue|wed|thu|fri|sat)/i,
	 *   long: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
	 * }
	 * locale.match.weekdays = buildMatchFn(matchWeekdaysPatterns, 'long')
	 * locale.match.weekdays('Sunday', {type: 'narrow'}) //=> ['Su', 'Su', ...]
	 * locale.match.weekdays('Sunday') //=> ['Sunday', 'Sunday', ...]
	 */
	function buildMatchFn (patterns, defaultType) {
	  return function (dirtyString, dirtyOptions) {
	    var options = dirtyOptions || {};
	    var type = options.type ? String(options.type) : defaultType;
	    var pattern = patterns[type] || patterns[defaultType];
	    var string = String(dirtyString);
	    return string.match(pattern)
	  }
	}
	
	/**
	 * @name buildParseFn
	 * @category Locale Helpers
	 * @summary Build `match.weekday`, `match.month` and `match.timeOfDay` properties for the locale.
	 *
	 * @description
	 * Build `match.weekday`, `match.month` and `match.timeOfDay` properties for the locale used by `parse` function.
	 * The argument of the resulting function is the result of the corresponding match function
	 * (`match.weekdays`, `match.months` or `match.timesOfDay` respectively. See `buildMatchFn`).
	 *
	 * @param {Object} values - the object with arrays of RegExps
	 * @param {String} defaultType - the default type for the parser function
	 * @returns {Function} the resulting function
	 *
	 * @example
	 * var parseWeekdayPatterns = {
	 *   any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	 * }
	 * locale.match.weekday = buildParseFn(matchWeekdaysPatterns, 'long')
	 * var matchResult = locale.match.weekdays('Friday')
	 * locale.match.weekday(matchResult) //=> 5
	 */
	function buildParseFn (patterns, defaultType) {
	  return function (matchResult, dirtyOptions) {
	    var options = dirtyOptions || {};
	    var type = options.type ? String(options.type) : defaultType;
	    var patternsArray = patterns[type] || patterns[defaultType];
	    var string = matchResult[1];
	
	    return patternsArray.findIndex(function (pattern) {
	      return pattern.test(string)
	    })
	  }
	}
	
	/**
	 * @name buildMatchPatternFn
	 * @category Locale Helpers
	 * @summary Build match function from a single RegExp.
	 *
	 * @description
	 * Build match function from a single RegExp.
	 * Usually used for building `match.ordinalNumbers` property of the locale.
	 *
	 * @param {Object} pattern - the RegExp
	 * @returns {Function} the resulting function
	 *
	 * @example
	 * locale.match.ordinalNumbers = buildMatchPatternFn(/^(\d+)(th|st|nd|rd)?/i)
	 * locale.match.ordinalNumbers('3rd') //=> ['3rd', '3', 'rd', ...]
	 */
	function buildMatchPatternFn (pattern) {
	  return function (dirtyString) {
	    var string = String(dirtyString);
	    return string.match(pattern)
	  }
	}
	
	/**
	 * @name parseDecimal
	 * @category Locale Helpers
	 * @summary Parses the match result into decimal number.
	 *
	 * @description
	 * Parses the match result into decimal number.
	 * Uses the string matched with the first set of parentheses of match RegExp.
	 *
	 * @param {Array} matchResult - the object returned by matching function
	 * @returns {Number} the parsed value
	 *
	 * @example
	 * locale.match = {
	 *   ordinalNumbers: (dirtyString) {
	 *     return String(dirtyString).match(/^(\d+)(th|st|nd|rd)?/i)
	 *   },
	 *   ordinalNumber: parseDecimal
	 * }
	 */
	function parseDecimal (matchResult) {
	  return parseInt(matchResult[1], 10)
	}
	
	var matchOrdinalNumbersPattern = /^(\d+)(th|st|nd|rd)?/i;
	
	var matchWeekdaysPatterns = {
	  narrow: /^(su|mo|tu|we|th|fr|sa)/i,
	  short: /^(sun|mon|tue|wed|thu|fri|sat)/i,
	  long: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
	};
	
	var parseWeekdayPatterns = {
	  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	};
	
	var matchMonthsPatterns = {
	  short: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
	  long: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
	};
	
	var parseMonthPatterns = {
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	
	// `timeOfDay` is used to designate which part of the day it is, when used with 12-hour clock.
	// Use the system which is used the most commonly in the locale.
	// For example, if the country doesn't use a.m./p.m., you can use `night`/`morning`/`afternoon`/`evening`:
	//
	//   var matchTimesOfDayPatterns = {
	//     long: /^((in the)? (night|morning|afternoon|evening?))/i
	//   }
	//
	//   var parseTimeOfDayPatterns = {
	//     any: [/(night|morning)/i, /(afternoon|evening)/i]
	//   }
	var matchTimesOfDayPatterns = {
	  short: /^(am|pm)/i,
	  long: /^([ap]\.?\s?m\.?)/i
	};
	
	var parseTimeOfDayPatterns = {
	  any: [/^a/i, /^p/i]
	};
	
	var match = {
	  ordinalNumbers: buildMatchPatternFn(matchOrdinalNumbersPattern),
	  ordinalNumber: parseDecimal,
	  weekdays: buildMatchFn(matchWeekdaysPatterns, 'long'),
	  weekday: buildParseFn(parseWeekdayPatterns, 'any'),
	  months: buildMatchFn(matchMonthsPatterns, 'long'),
	  month: buildParseFn(parseMonthPatterns, 'any'),
	  timesOfDay: buildMatchFn(matchTimesOfDayPatterns, 'long'),
	  timeOfDay: buildParseFn(parseTimeOfDayPatterns, 'any')
	};
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (United States).
	 * @language English
	 * @iso-639-2 eng
	 */
	var locale = {
	  formatDistance: formatDistance,
	  formatLong: formatLong,
	  formatRelative: formatRelative,
	  localize: localize,
	  match: match,
	  options: {
	    weekStartsOn: 0 /* Sunday */,
	    firstWeekContainsDate: 1
	  }
	};
	
	var MILLISECONDS_IN_DAY$1 = 86400000;
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCDayOfYear (dirtyDate, dirtyOptions) {
	  var date = toDate(dirtyDate, dirtyOptions);
	  var timestamp = date.getTime();
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	  var startOfYearTimestamp = date.getTime();
	  var difference = timestamp - startOfYearTimestamp;
	  return Math.floor(difference / MILLISECONDS_IN_DAY$1) + 1
	}
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCISOWeek (dirtyDate, dirtyOptions) {
	  var weekStartsOn = 1;
	
	  var date = toDate(dirtyDate, dirtyOptions);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date
	}
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCISOWeekYear (dirtyDate, dirtyOptions) {
	  var date = toDate(dirtyDate, dirtyOptions);
	  var year = date.getUTCFullYear();
	
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear, dirtyOptions);
	
	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear, dirtyOptions);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year
	  } else {
	    return year - 1
	  }
	}
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCISOWeekYear (dirtyDate, dirtyOptions) {
	  var year = getUTCISOWeekYear(dirtyDate, dirtyOptions);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setUTCFullYear(year, 0, 4);
	  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
	  var date = startOfUTCISOWeek(fourthOfJanuary, dirtyOptions);
	  return date
	}
	
	var MILLISECONDS_IN_WEEK$2 = 604800000;
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCISOWeek (dirtyDate, dirtyOptions) {
	  var date = toDate(dirtyDate, dirtyOptions);
	  var diff = startOfUTCISOWeek(date, dirtyOptions).getTime() - startOfUTCISOWeekYear(date, dirtyOptions).getTime();
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK$2) + 1
	}
	
	var formatters = {
	  // Month: 1, 2, ..., 12
	  'M': function (date) {
	    return date.getUTCMonth() + 1
	  },
	
	  // Month: 1st, 2nd, ..., 12th
	  'Mo': function (date, options) {
	    var month = date.getUTCMonth() + 1;
	    return options.locale.localize.ordinalNumber(month, {unit: 'month'})
	  },
	
	  // Month: 01, 02, ..., 12
	  'MM': function (date) {
	    return addLeadingZeros(date.getUTCMonth() + 1, 2)
	  },
	
	  // Month: Jan, Feb, ..., Dec
	  'MMM': function (date, options) {
	    return options.locale.localize.month(date.getUTCMonth(), {type: 'short'})
	  },
	
	  // Month: January, February, ..., December
	  'MMMM': function (date, options) {
	    return options.locale.localize.month(date.getUTCMonth(), {type: 'long'})
	  },
	
	  // Quarter: 1, 2, 3, 4
	  'Q': function (date) {
	    return Math.ceil((date.getUTCMonth() + 1) / 3)
	  },
	
	  // Quarter: 1st, 2nd, 3rd, 4th
	  'Qo': function (date, options) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	    return options.locale.localize.ordinalNumber(quarter, {unit: 'quarter'})
	  },
	
	  // Day of month: 1, 2, ..., 31
	  'D': function (date) {
	    return date.getUTCDate()
	  },
	
	  // Day of month: 1st, 2nd, ..., 31st
	  'Do': function (date, options) {
	    return options.locale.localize.ordinalNumber(date.getUTCDate(), {unit: 'dayOfMonth'})
	  },
	
	  // Day of month: 01, 02, ..., 31
	  'DD': function (date) {
	    return addLeadingZeros(date.getUTCDate(), 2)
	  },
	
	  // Day of year: 1, 2, ..., 366
	  'DDD': function (date) {
	    return getUTCDayOfYear(date)
	  },
	
	  // Day of year: 1st, 2nd, ..., 366th
	  'DDDo': function (date, options) {
	    return options.locale.localize.ordinalNumber(getUTCDayOfYear(date), {unit: 'dayOfYear'})
	  },
	
	  // Day of year: 001, 002, ..., 366
	  'DDDD': function (date) {
	    return addLeadingZeros(getUTCDayOfYear(date), 3)
	  },
	
	  // Day of week: Su, Mo, ..., Sa
	  'dd': function (date, options) {
	    return options.locale.localize.weekday(date.getUTCDay(), {type: 'narrow'})
	  },
	
	  // Day of week: Sun, Mon, ..., Sat
	  'ddd': function (date, options) {
	    return options.locale.localize.weekday(date.getUTCDay(), {type: 'short'})
	  },
	
	  // Day of week: Sunday, Monday, ..., Saturday
	  'dddd': function (date, options) {
	    return options.locale.localize.weekday(date.getUTCDay(), {type: 'long'})
	  },
	
	  // Day of week: 0, 1, ..., 6
	  'd': function (date) {
	    return date.getUTCDay()
	  },
	
	  // Day of week: 0th, 1st, 2nd, ..., 6th
	  'do': function (date, options) {
	    return options.locale.localize.ordinalNumber(date.getUTCDay(), {unit: 'dayOfWeek'})
	  },
	
	  // Day of ISO week: 1, 2, ..., 7
	  'E': function (date) {
	    return date.getUTCDay() || 7
	  },
	
	  // ISO week: 1, 2, ..., 53
	  'W': function (date) {
	    return getUTCISOWeek(date)
	  },
	
	  // ISO week: 1st, 2nd, ..., 53th
	  'Wo': function (date, options) {
	    return options.locale.localize.ordinalNumber(getUTCISOWeek(date), {unit: 'isoWeek'})
	  },
	
	  // ISO week: 01, 02, ..., 53
	  'WW': function (date) {
	    return addLeadingZeros(getUTCISOWeek(date), 2)
	  },
	
	  // Year: 00, 01, ..., 99
	  'YY': function (date) {
	    return addLeadingZeros(date.getUTCFullYear(), 4).substr(2)
	  },
	
	  // Year: 1900, 1901, ..., 2099
	  'YYYY': function (date) {
	    return addLeadingZeros(date.getUTCFullYear(), 4)
	  },
	
	  // ISO week-numbering year: 00, 01, ..., 99
	  'GG': function (date) {
	    return String(getUTCISOWeekYear(date)).substr(2)
	  },
	
	  // ISO week-numbering year: 1900, 1901, ..., 2099
	  'GGGG': function (date) {
	    return getUTCISOWeekYear(date)
	  },
	
	  // Hour: 0, 1, ... 23
	  'H': function (date) {
	    return date.getUTCHours()
	  },
	
	  // Hour: 00, 01, ..., 23
	  'HH': function (date) {
	    return addLeadingZeros(date.getUTCHours(), 2)
	  },
	
	  // Hour: 1, 2, ..., 12
	  'h': function (date) {
	    var hours = date.getUTCHours();
	    if (hours === 0) {
	      return 12
	    } else if (hours > 12) {
	      return hours % 12
	    } else {
	      return hours
	    }
	  },
	
	  // Hour: 01, 02, ..., 12
	  'hh': function (date) {
	    return addLeadingZeros(formatters['h'](date), 2)
	  },
	
	  // Minute: 0, 1, ..., 59
	  'm': function (date) {
	    return date.getUTCMinutes()
	  },
	
	  // Minute: 00, 01, ..., 59
	  'mm': function (date) {
	    return addLeadingZeros(date.getUTCMinutes(), 2)
	  },
	
	  // Second: 0, 1, ..., 59
	  's': function (date) {
	    return date.getUTCSeconds()
	  },
	
	  // Second: 00, 01, ..., 59
	  'ss': function (date) {
	    return addLeadingZeros(date.getUTCSeconds(), 2)
	  },
	
	  // 1/10 of second: 0, 1, ..., 9
	  'S': function (date) {
	    return Math.floor(date.getUTCMilliseconds() / 100)
	  },
	
	  // 1/100 of second: 00, 01, ..., 99
	  'SS': function (date) {
	    return addLeadingZeros(Math.floor(date.getUTCMilliseconds() / 10), 2)
	  },
	
	  // Millisecond: 000, 001, ..., 999
	  'SSS': function (date) {
	    return addLeadingZeros(date.getUTCMilliseconds(), 3)
	  },
	
	  // Timezone: -01:00, +00:00, ... +12:00
	  'Z': function (date, options) {
	    var originalDate = options._originalDate || date;
	    return formatTimezone(originalDate.getTimezoneOffset(), ':')
	  },
	
	  // Timezone: -0100, +0000, ... +1200
	  'ZZ': function (date, options) {
	    var originalDate = options._originalDate || date;
	    return formatTimezone(originalDate.getTimezoneOffset())
	  },
	
	  // Seconds timestamp: 512969520
	  'X': function (date, options) {
	    var originalDate = options._originalDate || date;
	    return Math.floor(originalDate.getTime() / 1000)
	  },
	
	  // Milliseconds timestamp: 512969520900
	  'x': function (date, options) {
	    var originalDate = options._originalDate || date;
	    return originalDate.getTime()
	  },
	
	  // AM, PM
	  'A': function (date, options) {
	    return options.locale.localize.timeOfDay(date.getUTCHours(), {type: 'uppercase'})
	  },
	
	  // am, pm
	  'a': function (date, options) {
	    return options.locale.localize.timeOfDay(date.getUTCHours(), {type: 'lowercase'})
	  },
	
	  // a.m., p.m.
	  'aa': function (date, options) {
	    return options.locale.localize.timeOfDay(date.getUTCHours(), {type: 'long'})
	  }
	};
	
	function formatTimezone (offset, delimeter) {
	  delimeter = delimeter || '';
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = Math.floor(absOffset / 60);
	  var minutes = absOffset % 60;
	  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
	}
	
	function addLeadingZeros (number, targetLength) {
	  var output = Math.abs(number).toString();
	  while (output.length < targetLength) {
	    output = '0' + output;
	  }
	  return output
	}
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function addUTCMinutes (dirtyDate, dirtyAmount, dirtyOptions) {
	  var date = toDate(dirtyDate, dirtyOptions);
	  var amount = Number(dirtyAmount);
	  date.setUTCMinutes(date.getUTCMinutes() + amount);
	  return date
	}
	
	var longFormattingTokensRegExp = /(\[[^[]*])|(\\)?(LTS|LT|LLLL|LLL|LL|L|llll|lll|ll|l)/g;
	var defaultFormattingTokensRegExp = /(\[[^[]*])|(\\)?(x|ss|s|mm|m|hh|h|do|dddd|ddd|dd|d|aa|a|ZZ|Z|YYYY|YY|X|Wo|WW|W|SSS|SS|S|Qo|Q|Mo|MMMM|MMM|MM|M|HH|H|GGGG|GG|E|Do|DDDo|DDDD|DDD|DD|D|A|.)/g;
	
	/**
	 * @name format
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format.
	 *
	 * Accepted tokens:
	 * | Unit                    | Token | Result examples                  |
	 * |-------------------------|-------|----------------------------------|
	 * | Month                   | M     | 1, 2, ..., 12                    |
	 * |                         | Mo    | 1st, 2nd, ..., 12th              |
	 * |                         | MM    | 01, 02, ..., 12                  |
	 * |                         | MMM   | Jan, Feb, ..., Dec               |
	 * |                         | MMMM  | January, February, ..., December |
	 * | Quarter                 | Q     | 1, 2, 3, 4                       |
	 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
	 * | Day of month            | D     | 1, 2, ..., 31                    |
	 * |                         | Do    | 1st, 2nd, ..., 31st              |
	 * |                         | DD    | 01, 02, ..., 31                  |
	 * | Day of year             | DDD   | 1, 2, ..., 366                   |
	 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
	 * |                         | DDDD  | 001, 002, ..., 366               |
	 * | Day of week             | d     | 0, 1, ..., 6                     |
	 * |                         | do    | 0th, 1st, ..., 6th               |
	 * |                         | dd    | Su, Mo, ..., Sa                  |
	 * |                         | ddd   | Sun, Mon, ..., Sat               |
	 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
	 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
	 * | ISO week                | W     | 1, 2, ..., 53                    |
	 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
	 * |                         | WW    | 01, 02, ..., 53                  |
	 * | Year                    | YY    | 00, 01, ..., 99                  |
	 * |                         | YYYY  | 1900, 1901, ..., 2099            |
	 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
	 * |                         | GGGG  | 1900, 1901, ..., 2099            |
	 * | AM/PM                   | A     | AM, PM                           |
	 * |                         | a     | am, pm                           |
	 * |                         | aa    | a.m., p.m.                       |
	 * | Hour                    | H     | 0, 1, ... 23                     |
	 * |                         | HH    | 00, 01, ... 23                   |
	 * |                         | h     | 1, 2, ..., 12                    |
	 * |                         | hh    | 01, 02, ..., 12                  |
	 * | Minute                  | m     | 0, 1, ..., 59                    |
	 * |                         | mm    | 00, 01, ..., 59                  |
	 * | Second                  | s     | 0, 1, ..., 59                    |
	 * |                         | ss    | 00, 01, ..., 59                  |
	 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
	 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
	 * | Millisecond             | SSS   | 000, 001, ..., 999               |
	 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
	 * |                         | ZZ    | -0100, +0000, ..., +1200         |
	 * | Seconds timestamp       | X     | 512969520                        |
	 * | Milliseconds timestamp  | x     | 512969520900                     |
	 * | Long format             | LT    | 05:30 a.m.                       |
	 * |                         | LTS   | 05:30:15 a.m.                    |
	 * |                         | L     | 07/02/1995                       |
	 * |                         | l     | 7/2/1995                         |
	 * |                         | LL    | July 2 1995                      |
	 * |                         | ll    | Jul 2 1995                       |
	 * |                         | LLL   | July 2 1995 05:30 a.m.           |
	 * |                         | lll   | Jul 2 1995 05:30 a.m.            |
	 * |                         | LLLL  | Sunday, July 2 1995 05:30 a.m.   |
	 * |                         | llll  | Sun, Jul 2 1995 05:30 a.m.       |
	 *
	 * The characters wrapped in square brackets are escaped.
	 *
	 * The result may vary by locale.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {String} format - the string of tokens
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the formatted date string
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 * @throws {RangeError} `options.locale` must contain `localize` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 *
	 * @example
	 * // Represent 11 February 2014 in middle-endian format:
	 * var result = format(
	 *   new Date(2014, 1, 11),
	 *   'MM/DD/YYYY'
	 * )
	 * //=> '02/11/2014'
	 *
	 * @example
	 * // Represent 2 July 2014 in Esperanto:
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * var result = format(
	 *   new Date(2014, 6, 2),
	 *   'Do [de] MMMM YYYY',
	 *   {locale: eoLocale}
	 * )
	 * //=> '2-a de julio 2014'
	 */
	function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
	  var formatStr = String(dirtyFormatStr);
	  var options = dirtyOptions || {};
	
	  var locale$$1 = options.locale || locale;
	
	  if (!locale$$1.localize) {
	    throw new RangeError('locale must contain localize property')
	  }
	
	  if (!locale$$1.formatLong) {
	    throw new RangeError('locale must contain formatLong property')
	  }
	
	  var localeFormatters = locale$$1.formatters || {};
	  var formattingTokensRegExp = locale$$1.formattingTokensRegExp || defaultFormattingTokensRegExp;
	  var formatLong = locale$$1.formatLong;
	
	  var originalDate = toDate(dirtyDate, options);
	
	  if (!isValid(originalDate, options)) {
	    return 'Invalid Date'
	  }
	
	  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
	  var timezoneOffset = originalDate.getTimezoneOffset();
	  var utcDate = addUTCMinutes(originalDate, -timezoneOffset, options);
	
	  var formatterOptions = cloneObject(options);
	  formatterOptions.locale = locale$$1;
	  formatterOptions.formatters = formatters;
	
	  // When UTC functions will be implemented, options._originalDate will likely be a part of public API.
	  // Right now, please don't use it in locales. If you have to use an original date,
	  // please restore it from `date`, adding a timezone offset to it.
	  formatterOptions._originalDate = originalDate;
	
	  var result = formatStr
	    .replace(longFormattingTokensRegExp, function (substring) {
	      if (substring[0] === '[') {
	        return substring
	      }
	
	      if (substring[0] === '\\') {
	        return cleanEscapedString(substring)
	      }
	
	      return formatLong(substring)
	    })
	    .replace(formattingTokensRegExp, function (substring) {
	      var formatter = localeFormatters[substring] || formatters[substring];
	
	      if (formatter) {
	        return formatter(utcDate, formatterOptions)
	      } else {
	        return cleanEscapedString(substring)
	      }
	    });
	
	  return result
	}
	
	function cleanEscapedString (input) {
	  if (input.match(/\[[\s\S]/)) {
	    return input.replace(/^\[|]$/g, '')
	  }
	  return input.replace(/\\/g, '')
	}
	
	/**
	 * @name subMinutes
	 * @category Minute Helpers
	 * @summary Subtract the specified number of minutes from the given date.
	 *
	 * @description
	 * Subtract the specified number of minutes from the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be subtracted
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the new date with the mintues subtracted
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Subtract 30 minutes from 10 July 2014 12:00:00:
	 * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 11:30:00
	 */
	function subMinutes (dirtyDate, dirtyAmount, dirtyOptions) {
	  var amount = Number(dirtyAmount);
	  return addMinutes(dirtyDate, -amount, dirtyOptions)
	}
	
	/**
	 * @name isAfter
	 * @category Common Helpers
	 * @summary Is the first date after the second one?
	 *
	 * @description
	 * Is the first date after the second one?
	 *
	 * @param {Date|String|Number} date - the date that should be after the other one to return true
	 * @param {Date|String|Number} dateToCompare - the date to compare with
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Boolean} the first date is after the second date
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Is 10 July 1989 after 11 February 1987?
	 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> true
	 */
	function isAfter (dirtyDate, dirtyDateToCompare, dirtyOptions) {
	  var date = toDate(dirtyDate, dirtyOptions);
	  var dateToCompare = toDate(dirtyDateToCompare, dirtyOptions);
	  return date.getTime() > dateToCompare.getTime()
	}
	
	/**
	 * @name isBefore
	 * @category Common Helpers
	 * @summary Is the first date before the second one?
	 *
	 * @description
	 * Is the first date before the second one?
	 *
	 * @param {Date|String|Number} date - the date that should be before the other one to return true
	 * @param {Date|String|Number} dateToCompare - the date to compare with
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Boolean} the first date is before the second date
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Is 10 July 1989 before 11 February 1987?
	 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> false
	 */
	function isBefore (dirtyDate, dirtyDateToCompare, dirtyOptions) {
	  var date = toDate(dirtyDate, dirtyOptions);
	  var dateToCompare = toDate(dirtyDateToCompare, dirtyOptions);
	  return date.getTime() < dateToCompare.getTime()
	}
	
	/**
	 * @name isEqual
	 * @category Common Helpers
	 * @summary Are the given dates equal?
	 *
	 * @description
	 * Are the given dates equal?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to compare
	 * @param {Date|String|Number} dateRight - the second date to compare
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Boolean} the dates are equal
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
	 * var result = isEqual(
	 *   new Date(2014, 6, 2, 6, 30, 45, 0)
	 *   new Date(2014, 6, 2, 6, 30, 45, 500)
	 * )
	 * //=> false
	 */
	function isEqual (dirtyLeftDate, dirtyRightDate, dirtyOptions) {
	  var dateLeft = toDate(dirtyLeftDate, dirtyOptions);
	  var dateRight = toDate(dirtyRightDate, dirtyOptions);
	  return dateLeft.getTime() === dateRight.getTime()
	}
	
	var patterns$1 = {
	  'M': /^(1[0-2]|0?\d)/, // 0 to 12
	  'D': /^(3[0-1]|[0-2]?\d)/, // 0 to 31
	  'DDD': /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/, // 0 to 366
	  'W': /^(5[0-3]|[0-4]?\d)/, // 0 to 53
	  'YYYY': /^(\d{1,4})/, // 0 to 9999
	  'H': /^(2[0-3]|[0-1]?\d)/, // 0 to 23
	  'm': /^([0-5]?\d)/, // 0 to 59
	  'Z': /^([+-])(\d{2}):(\d{2})/,
	  'ZZ': /^([+-])(\d{2})(\d{2})/,
	  singleDigit: /^(\d)/,
	  twoDigits: /^(\d{2})/,
	  threeDigits: /^(\d{3})/,
	  fourDigits: /^(\d{4})/,
	  anyDigits: /^(\d+)/
	};
	
	function parseDecimal$1 (matchResult) {
	  return parseInt(matchResult[1], 10)
	}
	
	var parsers = {
	  // Year: 00, 01, ..., 99
	  'YY': {
	    unit: 'twoDigitYear',
	    match: patterns$1.twoDigits,
	    parse: function (matchResult) {
	      return parseDecimal$1(matchResult)
	    }
	  },
	
	  // Year: 1900, 1901, ..., 2099
	  'YYYY': {
	    unit: 'year',
	    match: patterns$1.YYYY,
	    parse: parseDecimal$1
	  },
	
	  // ISO week-numbering year: 00, 01, ..., 99
	  'GG': {
	    unit: 'isoYear',
	    match: patterns$1.twoDigits,
	    parse: function (matchResult) {
	      return parseDecimal$1(matchResult) + 1900
	    }
	  },
	
	  // ISO week-numbering year: 1900, 1901, ..., 2099
	  'GGGG': {
	    unit: 'isoYear',
	    match: patterns$1.YYYY,
	    parse: parseDecimal$1
	  },
	
	  // Quarter: 1, 2, 3, 4
	  'Q': {
	    unit: 'quarter',
	    match: patterns$1.singleDigit,
	    parse: parseDecimal$1
	  },
	
	  // Ordinal quarter
	  'Qo': {
	    unit: 'quarter',
	    match: function (string, options) {
	      return options.locale.match.ordinalNumbers(string, {unit: 'quarter'})
	    },
	    parse: function (matchResult, options) {
	      return options.locale.match.ordinalNumber(matchResult, {unit: 'quarter'})
	    }
	  },
	
	  // Month: 1, 2, ..., 12
	  'M': {
	    unit: 'month',
	    match: patterns$1.M,
	    parse: function (matchResult) {
	      return parseDecimal$1(matchResult) - 1
	    }
	  },
	
	  // Ordinal month
	  'Mo': {
	    unit: 'month',
	    match: function (string, options) {
	      return options.locale.match.ordinalNumbers(string, {unit: 'month'})
	    },
	    parse: function (matchResult, options) {
	      return options.locale.match.ordinalNumber(matchResult, {unit: 'month'}) - 1
	    }
	  },
	
	  // Month: 01, 02, ..., 12
	  'MM': {
	    unit: 'month',
	    match: patterns$1.twoDigits,
	    parse: function (matchResult) {
	      return parseDecimal$1(matchResult) - 1
	    }
	  },
	
	  // Month: Jan, Feb, ..., Dec
	  'MMM': {
	    unit: 'month',
	    match: function (string, options) {
	      return options.locale.match.months(string, {type: 'short'})
	    },
	    parse: function (matchResult, options) {
	      return options.locale.match.month(matchResult, {type: 'short'})
	    }
	  },
	
	  // Month: January, February, ..., December
	  'MMMM': {
	    unit: 'month',
	    match: function (string, options) {
	      return options.locale.match.months(string, {type: 'long'}) ||
	        options.locale.match.months(string, {type: 'short'})
	    },
	    parse: function (matchResult, options) {
	      var parseResult = options.locale.match.month(matchResult, {type: 'long'});
	
	      if (parseResult == null) {
	        parseResult = options.locale.match.month(matchResult, {type: 'short'});
	      }
	
	      return parseResult
	    }
	  },
	
	  // ISO week: 1, 2, ..., 53
	  'W': {
	    unit: 'isoWeek',
	    match: patterns$1.W,
	    parse: parseDecimal$1
	  },
	
	  // Ordinal ISO week
	  'Wo': {
	    unit: 'isoWeek',
	    match: function (string, options) {
	      return options.locale.match.ordinalNumbers(string, {unit: 'isoWeek'})
	    },
	    parse: function (matchResult, options) {
	      return options.locale.match.ordinalNumber(matchResult, {unit: 'isoWeek'})
	    }
	  },
	
	  // ISO week: 01, 02, ..., 53
	  'WW': {
	    unit: 'isoWeek',
	    match: patterns$1.twoDigits,
	    parse: parseDecimal$1
	  },
	
	  // Day of week: 0, 1, ..., 6
	  'd': {
	    unit: 'dayOfWeek',
	    match: patterns$1.singleDigit,
	    parse: parseDecimal$1
	  },
	
	  // Ordinal day of week
	  'do': {
	    unit: 'dayOfWeek',
	    match: function (string, options) {
	      return options.locale.match.ordinalNumbers(string, {unit: 'dayOfWeek'})
	    },
	    parse: function (matchResult, options) {
	      return options.locale.match.ordinalNumber(matchResult, {unit: 'dayOfWeek'})
	    }
	  },
	
	  // Day of week: Su, Mo, ..., Sa
	  'dd': {
	    unit: 'dayOfWeek',
	    match: function (string, options) {
	      return options.locale.match.weekdays(string, {type: 'narrow'})
	    },
	    parse: function (matchResult, options) {
	      return options.locale.match.weekday(matchResult, {type: 'narrow'})
	    }
	  },
	
	  // Day of week: Sun, Mon, ..., Sat
	  'ddd': {
	    unit: 'dayOfWeek',
	    match: function (string, options) {
	      return options.locale.match.weekdays(string, {type: 'short'}) ||
	        options.locale.match.weekdays(string, {type: 'narrow'})
	    },
	    parse: function (matchResult, options) {
	      var parseResult = options.locale.match.weekday(matchResult, {type: 'short'});
	
	      if (parseResult == null) {
	        parseResult = options.locale.match.weekday(matchResult, {type: 'narrow'});
	      }
	
	      return parseResult
	    }
	  },
	
	  // Day of week: Sunday, Monday, ..., Saturday
	  'dddd': {
	    unit: 'dayOfWeek',
	    match: function (string, options) {
	      return options.locale.match.weekdays(string, {type: 'long'}) ||
	        options.locale.match.weekdays(string, {type: 'short'}) ||
	        options.locale.match.weekdays(string, {type: 'narrow'})
	    },
	    parse: function (matchResult, options) {
	      var parseResult = options.locale.match.weekday(matchResult, {type: 'long'});
	
	      if (parseResult == null) {
	        parseResult = options.locale.match.weekday(matchResult, {type: 'short'});
	
	        if (parseResult == null) {
	          parseResult = options.locale.match.weekday(matchResult, {type: 'narrow'});
	        }
	      }
	
	      return parseResult
	    }
	  },
	
	  // Day of ISO week: 1, 2, ..., 7
	  'E': {
	    unit: 'dayOfISOWeek',
	    match: patterns$1.singleDigit,
	    parse: function (matchResult) {
	      return parseDecimal$1(matchResult)
	    }
	  },
	
	  // Day of month: 1, 2, ..., 31
	  'D': {
	    unit: 'dayOfMonth',
	    match: patterns$1.D,
	    parse: parseDecimal$1
	  },
	
	  // Ordinal day of month
	  'Do': {
	    unit: 'dayOfMonth',
	    match: function (string, options) {
	      return options.locale.match.ordinalNumbers(string, {unit: 'dayOfMonth'})
	    },
	    parse: function (matchResult, options) {
	      return options.locale.match.ordinalNumber(matchResult, {unit: 'dayOfMonth'})
	    }
	  },
	
	  // Day of month: 01, 02, ..., 31
	  'DD': {
	    unit: 'dayOfMonth',
	    match: patterns$1.twoDigits,
	    parse: parseDecimal$1
	  },
	
	  // Day of year: 1, 2, ..., 366
	  'DDD': {
	    unit: 'dayOfYear',
	    match: patterns$1.DDD,
	    parse: parseDecimal$1
	  },
	
	  // Ordinal day of year
	  'DDDo': {
	    unit: 'dayOfYear',
	    match: function (string, options) {
	      return options.locale.match.ordinalNumbers(string, {unit: 'dayOfYear'})
	    },
	    parse: function (matchResult, options) {
	      return options.locale.match.ordinalNumber(matchResult, {unit: 'dayOfYear'})
	    }
	  },
	
	  // Day of year: 001, 002, ..., 366
	  'DDDD': {
	    unit: 'dayOfYear',
	    match: patterns$1.threeDigits,
	    parse: parseDecimal$1
	  },
	
	  // AM, PM
	  'A': {
	    unit: 'timeOfDay',
	    match: function (string, options) {
	      return options.locale.match.timesOfDay(string, {type: 'short'})
	    },
	    parse: function (matchResult, options) {
	      return options.locale.match.timeOfDay(matchResult, {type: 'short'})
	    }
	  },
	
	  // a.m., p.m.
	  'aa': {
	    unit: 'timeOfDay',
	    match: function (string, options) {
	      return options.locale.match.timesOfDay(string, {type: 'long'}) ||
	        options.locale.match.timesOfDay(string, {type: 'short'})
	    },
	    parse: function (matchResult, options) {
	      var parseResult = options.locale.match.timeOfDay(matchResult, {type: 'long'});
	
	      if (parseResult == null) {
	        parseResult = options.locale.match.timeOfDay(matchResult, {type: 'short'});
	      }
	
	      return parseResult
	    }
	  },
	
	  // Hour: 0, 1, ... 23
	  'H': {
	    unit: 'hours',
	    match: patterns$1.H,
	    parse: parseDecimal$1
	  },
	
	  // Hour: 00, 01, ..., 23
	  'HH': {
	    unit: 'hours',
	    match: patterns$1.twoDigits,
	    parse: parseDecimal$1
	  },
	
	  // Hour: 1, 2, ..., 12
	  'h': {
	    unit: 'timeOfDayHours',
	    match: patterns$1.M,
	    parse: parseDecimal$1
	  },
	
	  // Hour: 01, 02, ..., 12
	  'hh': {
	    unit: 'timeOfDayHours',
	    match: patterns$1.twoDigits,
	    parse: parseDecimal$1
	  },
	
	  // Minute: 0, 1, ..., 59
	  'm': {
	    unit: 'minutes',
	    match: patterns$1.m,
	    parse: parseDecimal$1
	  },
	
	  // Minute: 00, 01, ..., 59
	  'mm': {
	    unit: 'minutes',
	    match: patterns$1.twoDigits,
	    parse: parseDecimal$1
	  },
	
	  // Second: 0, 1, ..., 59
	  's': {
	    unit: 'seconds',
	    match: patterns$1.m,
	    parse: parseDecimal$1
	  },
	
	  // Second: 00, 01, ..., 59
	  'ss': {
	    unit: 'seconds',
	    match: patterns$1.twoDigits,
	    parse: parseDecimal$1
	  },
	
	  // 1/10 of second: 0, 1, ..., 9
	  'S': {
	    unit: 'milliseconds',
	    match: patterns$1.singleDigit,
	    parse: function (matchResult) {
	      return parseDecimal$1(matchResult) * 100
	    }
	  },
	
	  // 1/100 of second: 00, 01, ..., 99
	  'SS': {
	    unit: 'milliseconds',
	    match: patterns$1.twoDigits,
	    parse: function (matchResult) {
	      return parseDecimal$1(matchResult) * 10
	    }
	  },
	
	  // Millisecond: 000, 001, ..., 999
	  'SSS': {
	    unit: 'milliseconds',
	    match: patterns$1.threeDigits,
	    parse: parseDecimal$1
	  },
	
	  // Timezone: -01:00, +00:00, ... +12:00
	  'Z': {
	    unit: 'timezone',
	    match: patterns$1.Z,
	    parse: function (matchResult) {
	      var sign = matchResult[1];
	      var hours = parseInt(matchResult[2], 10);
	      var minutes = parseInt(matchResult[3], 10);
	      var absoluteOffset = hours * 60 + minutes;
	      return (sign === '+') ? absoluteOffset : -absoluteOffset
	    }
	  },
	
	  // Timezone: -0100, +0000, ... +1200
	  'ZZ': {
	    unit: 'timezone',
	    match: patterns$1.ZZ,
	    parse: function (matchResult) {
	      var sign = matchResult[1];
	      var hours = parseInt(matchResult[2], 10);
	      var minutes = parseInt(matchResult[3], 10);
	      var absoluteOffset = hours * 60 + minutes;
	      return (sign === '+') ? absoluteOffset : -absoluteOffset
	    }
	  },
	
	  // Seconds timestamp: 512969520
	  'X': {
	    unit: 'timestamp',
	    match: patterns$1.anyDigits,
	    parse: function (matchResult) {
	      return parseDecimal$1(matchResult) * 1000
	    }
	  },
	
	  // Milliseconds timestamp: 512969520900
	  'x': {
	    unit: 'timestamp',
	    match: patterns$1.anyDigits,
	    parse: parseDecimal$1
	  }
	};
	
	parsers['a'] = parsers['A'];
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCDay (dirtyDate, dirtyDay, dirtyOptions) {
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn === undefined ? 0 : Number(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn === undefined ? defaultWeekStartsOn : Number(options.weekStartsOn);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
	  }
	
	  var date = toDate(dirtyDate, dirtyOptions);
	  var day = Number(dirtyDay);
	
	  var currentDay = date.getUTCDay();
	
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date
	}
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCISODay (dirtyDate, dirtyDay, dirtyOptions) {
	  var day = Number(dirtyDay);
	
	  if (day % 7 === 0) {
	    day = day - 7;
	  }
	
	  var weekStartsOn = 1;
	  var date = toDate(dirtyDate, dirtyOptions);
	  var currentDay = date.getUTCDay();
	
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date
	}
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCISOWeek (dirtyDate, dirtyISOWeek, dirtyOptions) {
	  var date = toDate(dirtyDate, dirtyOptions);
	  var isoWeek = Number(dirtyISOWeek);
	  var diff = getUTCISOWeek(date, dirtyOptions) - isoWeek;
	  date.setUTCDate(date.getUTCDate() - diff * 7);
	  return date
	}
	
	var MILLISECONDS_IN_DAY$3 = 86400000;
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCISOWeekYear (dirtyDate, dirtyISOYear, dirtyOptions) {
	  var date = toDate(dirtyDate, dirtyOptions);
	  var isoYear = Number(dirtyISOYear);
	  var dateStartOfYear = startOfUTCISOWeekYear(date, dirtyOptions);
	  var diff = Math.floor((date.getTime() - dateStartOfYear.getTime()) / MILLISECONDS_IN_DAY$3);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setUTCFullYear(isoYear, 0, 4);
	  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
	  date = startOfUTCISOWeekYear(fourthOfJanuary, dirtyOptions);
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date
	}
	
	var MILLISECONDS_IN_MINUTE$7 = 60000;
	
	function setTimeOfDay (hours, timeOfDay) {
	  var isAM = timeOfDay === 0;
	
	  if (isAM) {
	    if (hours === 12) {
	      return 0
	    }
	  } else {
	    if (hours !== 12) {
	      return 12 + hours
	    }
	  }
	
	  return hours
	}
	
	var units = {
	  twoDigitYear: {
	    priority: 10,
	    set: function (dateValues, value) {
	      var century = Math.floor(dateValues.date.getUTCFullYear() / 100);
	      var year = century * 100 + value;
	      dateValues.date.setUTCFullYear(year, 0, 1);
	      dateValues.date.setUTCHours(0, 0, 0, 0);
	      return dateValues
	    }
	  },
	
	  year: {
	    priority: 10,
	    set: function (dateValues, value) {
	      dateValues.date.setUTCFullYear(value, 0, 1);
	      dateValues.date.setUTCHours(0, 0, 0, 0);
	      return dateValues
	    }
	  },
	
	  isoYear: {
	    priority: 10,
	    set: function (dateValues, value, options) {
	      dateValues.date = startOfUTCISOWeekYear(setUTCISOWeekYear(dateValues.date, value, options), options);
	      return dateValues
	    }
	  },
	
	  quarter: {
	    priority: 20,
	    set: function (dateValues, value) {
	      dateValues.date.setUTCMonth((value - 1) * 3, 1);
	      dateValues.date.setUTCHours(0, 0, 0, 0);
	      return dateValues
	    }
	  },
	
	  month: {
	    priority: 30,
	    set: function (dateValues, value) {
	      dateValues.date.setUTCMonth(value, 1);
	      dateValues.date.setUTCHours(0, 0, 0, 0);
	      return dateValues
	    }
	  },
	
	  isoWeek: {
	    priority: 40,
	    set: function (dateValues, value, options) {
	      dateValues.date = startOfUTCISOWeek(setUTCISOWeek(dateValues.date, value, options), options);
	      return dateValues
	    }
	  },
	
	  dayOfWeek: {
	    priority: 50,
	    set: function (dateValues, value, options) {
	      dateValues.date = setUTCDay(dateValues.date, value, options);
	      dateValues.date.setUTCHours(0, 0, 0, 0);
	      return dateValues
	    }
	  },
	
	  dayOfISOWeek: {
	    priority: 50,
	    set: function (dateValues, value, options) {
	      dateValues.date = setUTCISODay(dateValues.date, value, options);
	      dateValues.date.setUTCHours(0, 0, 0, 0);
	      return dateValues
	    }
	  },
	
	  dayOfMonth: {
	    priority: 50,
	    set: function (dateValues, value) {
	      dateValues.date.setUTCDate(value);
	      dateValues.date.setUTCHours(0, 0, 0, 0);
	      return dateValues
	    }
	  },
	
	  dayOfYear: {
	    priority: 50,
	    set: function (dateValues, value) {
	      dateValues.date.setUTCMonth(0, value);
	      dateValues.date.setUTCHours(0, 0, 0, 0);
	      return dateValues
	    }
	  },
	
	  timeOfDay: {
	    priority: 60,
	    set: function (dateValues, value, options) {
	      dateValues.timeOfDay = value;
	      return dateValues
	    }
	  },
	
	  hours: {
	    priority: 70,
	    set: function (dateValues, value, options) {
	      dateValues.date.setUTCHours(value, 0, 0, 0);
	      return dateValues
	    }
	  },
	
	  timeOfDayHours: {
	    priority: 70,
	    set: function (dateValues, value, options) {
	      var timeOfDay = dateValues.timeOfDay;
	      if (timeOfDay != null) {
	        value = setTimeOfDay(value, timeOfDay);
	      }
	      dateValues.date.setUTCHours(value, 0, 0, 0);
	      return dateValues
	    }
	  },
	
	  minutes: {
	    priority: 80,
	    set: function (dateValues, value) {
	      dateValues.date.setUTCMinutes(value, 0, 0);
	      return dateValues
	    }
	  },
	
	  seconds: {
	    priority: 90,
	    set: function (dateValues, value) {
	      dateValues.date.setUTCSeconds(value, 0);
	      return dateValues
	    }
	  },
	
	  milliseconds: {
	    priority: 100,
	    set: function (dateValues, value) {
	      dateValues.date.setUTCMilliseconds(value);
	      return dateValues
	    }
	  },
	
	  timezone: {
	    priority: 110,
	    set: function (dateValues, value) {
	      dateValues.date = new Date(dateValues.date.getTime() - value * MILLISECONDS_IN_MINUTE$7);
	      return dateValues
	    }
	  },
	
	  timestamp: {
	    priority: 120,
	    set: function (dateValues, value) {
	      dateValues.date = new Date(value);
	      return dateValues
	    }
	  }
	};
	
	var TIMEZONE_UNIT_PRIORITY = 110;
	var MILLISECONDS_IN_MINUTE$6 = 60000;
	
	var longFormattingTokensRegExp$1 = /(\[[^[]*])|(\\)?(LTS|LT|LLLL|LLL|LL|L|llll|lll|ll|l)/g;
	var defaultParsingTokensRegExp = /(\[[^[]*])|(\\)?(x|ss|s|mm|m|hh|h|do|dddd|ddd|dd|d|aa|a|ZZ|Z|YYYY|YY|X|Wo|WW|W|SSS|SS|S|Qo|Q|Mo|MMMM|MMM|MM|M|HH|H|GGGG|GG|E|Do|DDDo|DDDD|DDD|DD|D|A|.)/g;
	
	/**
	 * @name parse
	 * @category Common Helpers
	 * @summary Parse the date.
	 *
	 * @description
	 * Return the date parsed from string using the given format.
	 *
	 * Accepted format tokens:
	 * | Unit                    | Priority | Token | Input examples                   |
	 * |-------------------------|----------|-------|----------------------------------|
	 * | Year                    | 10       | YY    | 00, 01, ..., 99                  |
	 * |                         |          | YYYY  | 1900, 1901, ..., 2099            |
	 * | ISO week-numbering year | 10       | GG    | 00, 01, ..., 99                  |
	 * |                         |          | GGGG  | 1900, 1901, ..., 2099            |
	 * | Quarter                 | 20       | Q     | 1, 2, 3, 4                       |
	 * |                         |          | Qo    | 1st, 2nd, 3rd, 4th               |
	 * | Month                   | 30       | M     | 1, 2, ..., 12                    |
	 * |                         |          | Mo    | 1st, 2nd, ..., 12th              |
	 * |                         |          | MM    | 01, 02, ..., 12                  |
	 * |                         |          | MMM   | Jan, Feb, ..., Dec               |
	 * |                         |          | MMMM  | January, February, ..., December |
	 * | ISO week                | 40       | W     | 1, 2, ..., 53                    |
	 * |                         |          | Wo    | 1st, 2nd, ..., 53rd              |
	 * |                         |          | WW    | 01, 02, ..., 53                  |
	 * | Day of week             | 50       | d     | 0, 1, ..., 6                     |
	 * |                         |          | do    | 0th, 1st, ..., 6th               |
	 * |                         |          | dd    | Su, Mo, ..., Sa                  |
	 * |                         |          | ddd   | Sun, Mon, ..., Sat               |
	 * |                         |          | dddd  | Sunday, Monday, ..., Saturday    |
	 * | Day of ISO week         | 50       | E     | 1, 2, ..., 7                     |
	 * | Day of month            | 50       | D     | 1, 2, ..., 31                    |
	 * |                         |          | Do    | 1st, 2nd, ..., 31st              |
	 * |                         |          | DD    | 01, 02, ..., 31                  |
	 * | Day of year             | 50       | DDD   | 1, 2, ..., 366                   |
	 * |                         |          | DDDo  | 1st, 2nd, ..., 366th             |
	 * |                         |          | DDDD  | 001, 002, ..., 366               |
	 * | Time of day             | 60       | A     | AM, PM                           |
	 * |                         |          | a     | am, pm                           |
	 * |                         |          | aa    | a.m., p.m.                       |
	 * | Hour                    | 70       | H     | 0, 1, ... 23                     |
	 * |                         |          | HH    | 00, 01, ... 23                   |
	 * | Time of day hour        | 70       | h     | 1, 2, ..., 12                    |
	 * |                         |          | hh    | 01, 02, ..., 12                  |
	 * | Minute                  | 80       | m     | 0, 1, ..., 59                    |
	 * |                         |          | mm    | 00, 01, ..., 59                  |
	 * | Second                  | 90       | s     | 0, 1, ..., 59                    |
	 * |                         |          | ss    | 00, 01, ..., 59                  |
	 * | 1/10 of second          | 100      | S     | 0, 1, ..., 9                     |
	 * | 1/100 of second         | 100      | SS    | 00, 01, ..., 99                  |
	 * | Millisecond             | 100      | SSS   | 000, 001, ..., 999               |
	 * | Timezone                | 110      | Z     | -01:00, +00:00, ... +12:00       |
	 * |                         |          | ZZ    | -0100, +0000, ..., +1200         |
	 * | Seconds timestamp       | 120      | X     | 512969520                        |
	 * | Milliseconds timestamp  | 120      | x     | 512969520900                     |
	 *
	 * Values will be assigned to the date in the ascending order of its unit's priority.
	 * Units of an equal priority overwrite each other in the order of appearance.
	 *
	 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
	 * the values will be taken from 3rd argument `baseDate` which works as a context of parsing.
	 *
	 * `baseDate` must be passed for correct work of the function.
	 * If you're not sure which `baseDate` to supply, create a new instance of Date:
	 * `parse('02/11/2014', 'MM/DD/YYYY', new Date())`
	 * In this case parsing will be done in the context of the current date.
	 * If `baseDate` is `Invalid Date` or a value not convertible to valid `Date`,
	 * then `Invalid Date` will be returned.
	 *
	 * Also, `parse` unfolds long formats like those in [format]{@link https://date-fns.org/docs/format}:
	 * | Token | Input examples                 |
	 * |-------|--------------------------------|
	 * | LT    | 05:30 a.m.                     |
	 * | LTS   | 05:30:15 a.m.                  |
	 * | L     | 07/02/1995                     |
	 * | l     | 7/2/1995                       |
	 * | LL    | July 2 1995                    |
	 * | ll    | Jul 2 1995                     |
	 * | LLL   | July 2 1995 05:30 a.m.         |
	 * | lll   | Jul 2 1995 05:30 a.m.          |
	 * | LLLL  | Sunday, July 2 1995 05:30 a.m. |
	 * | llll  | Sun, Jul 2 1995 05:30 a.m.     |
	 *
	 * The characters wrapped in square brackets in the format string are escaped.
	 *
	 * The result may vary by locale.
	 *
	 * If `formatString` matches with `dateString` but does not provides tokens, `baseDate` will be returned.
	 *
	 * If parsing failed, `Invalid Date` will be returned.
	 * Invalid Date is a Date, whose time value is NaN.
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * @param {String} dateString - the string to parse
	 * @param {String} formatString - the string of tokens
	 * @param {Date|String|Number} baseDate - the date to took the missing higher priority values from
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the parsed date
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.locale` must contain `match` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 *
	 * @example
	 * // Parse 11 February 2014 from middle-endian format:
	 * var result = parse(
	 *   '02/11/2014',
	 *   'MM/DD/YYYY',
	 *   new Date()
	 * )
	 * //=> Tue Feb 11 2014 00:00:00
	 *
	 * @example
	 * // Parse 28th of February in English locale in the context of 2010 year:
	 * import eoLocale from 'date-fns/locale/eo'
	 * var result = parse(
	 *   '28-a de februaro',
	 *   'Do [de] MMMM',
	 *   new Date(2010, 0, 1)
	 *   {locale: eoLocale}
	 * )
	 * //=> Sun Feb 28 2010 00:00:00
	 */
	function parse (dirtyDateString, dirtyFormatString, dirtyBaseDate, dirtyOptions) {
	  var dateString = String(dirtyDateString);
	  var options = dirtyOptions || {};
	
	  var weekStartsOn = options.weekStartsOn === undefined ? 0 : Number(options.weekStartsOn);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
	  }
	
	  var locale$$1 = options.locale || locale;
	  var localeParsers = locale$$1.parsers || {};
	  var localeUnits = locale$$1.units || {};
	
	  if (!locale$$1.match) {
	    throw new RangeError('locale must contain match property')
	  }
	
	  if (!locale$$1.formatLong) {
	    throw new RangeError('locale must contain formatLong property')
	  }
	
	  var formatString = String(dirtyFormatString)
	    .replace(longFormattingTokensRegExp$1, function (substring) {
	      if (substring[0] === '[') {
	        return substring
	      }
	
	      if (substring[0] === '\\') {
	        return cleanEscapedString$1(substring)
	      }
	
	      return locale$$1.formatLong(substring)
	    });
	
	  if (formatString === '') {
	    if (dateString === '') {
	      return toDate(dirtyBaseDate, options)
	    } else {
	      return new Date(NaN)
	    }
	  }
	
	  var subFnOptions = cloneObject(options);
	  subFnOptions.locale = locale$$1;
	
	  var tokens = formatString.match(locale$$1.parsingTokensRegExp || defaultParsingTokensRegExp);
	  var tokensLength = tokens.length;
	
	  // If timezone isn't specified, it will be set to the system timezone
	  var setters = [{
	    priority: TIMEZONE_UNIT_PRIORITY,
	    set: dateToSystemTimezone,
	    index: 0
	  }];
	
	  var i;
	  for (i = 0; i < tokensLength; i++) {
	    var token = tokens[i];
	    var parser = localeParsers[token] || parsers[token];
	    if (parser) {
	      var matchResult;
	
	      if (parser.match instanceof RegExp) {
	        matchResult = parser.match.exec(dateString);
	      } else {
	        matchResult = parser.match(dateString, subFnOptions);
	      }
	
	      if (!matchResult) {
	        return new Date(NaN)
	      }
	
	      var unitName = parser.unit;
	      var unit = localeUnits[unitName] || units[unitName];
	
	      setters.push({
	        priority: unit.priority,
	        set: unit.set,
	        value: parser.parse(matchResult, subFnOptions),
	        index: setters.length
	      });
	
	      var substring = matchResult[0];
	      dateString = dateString.slice(substring.length);
	    } else {
	      var head = tokens[i].match(/^\[.*]$/) ? tokens[i].replace(/^\[|]$/g, '') : tokens[i];
	      if (dateString.indexOf(head) === 0) {
	        dateString = dateString.slice(head.length);
	      } else {
	        return new Date(NaN)
	      }
	    }
	  }
	
	  var uniquePrioritySetters = setters
	    .map(function (setter) {
	      return setter.priority
	    })
	    .sort(function (a, b) {
	      return a - b
	    })
	    .filter(function (priority, index, array) {
	      return array.indexOf(priority) === index
	    })
	    .map(function (priority) {
	      return setters
	        .filter(function (setter) {
	          return setter.priority === priority
	        })
	        .reverse()
	    })
	    .map(function (setterArray) {
	      return setterArray[0]
	    });
	
	  var date = toDate(dirtyBaseDate, options);
	
	  if (isNaN(date)) {
	    return new Date(NaN)
	  }
	
	  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37
	  var utcDate = subMinutes(date, date.getTimezoneOffset());
	
	  var dateValues = {date: utcDate};
	
	  var settersLength = uniquePrioritySetters.length;
	  for (i = 0; i < settersLength; i++) {
	    var setter = uniquePrioritySetters[i];
	    dateValues = setter.set(dateValues, setter.value, subFnOptions);
	  }
	
	  return dateValues.date
	}
	
	function dateToSystemTimezone (dateValues) {
	  var date = dateValues.date;
	  var time = date.getTime();
	
	  // Get the system timezone offset at (moment of time - offset)
	  var offset = date.getTimezoneOffset();
	
	  // Get the system timezone offset at the exact moment of time
	  offset = new Date(time + offset * MILLISECONDS_IN_MINUTE$6).getTimezoneOffset();
	
	  // Convert date in timezone "UTC+00:00" to the system timezone
	  dateValues.date = new Date(time + offset * MILLISECONDS_IN_MINUTE$6);
	
	  return dateValues
	}
	
	function cleanEscapedString$1 (input) {
	  if (input.match(/\[[\s\S]/)) {
	    return input.replace(/^\[|]$/g, '')
	  }
	  return input.replace(/\\/g, '')
	}
	
	// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.
	
	/**
	 * Gets the data attribute. the name must be kebab-case.
	 */
	var getDataAttribute = function (el, name) { return el.getAttribute(("data-vv-" + name)); };
	
	/**
	 * Checks if the value is either null or undefined.
	 * @param {*} value
	 */
	var isNullOrUndefined = function (value) {
	  return value === null || value === undefined;
	};
	
	/**
	 * Sets the data attribute.
	 * @param {*} el
	 * @param {String} name
	 * @param {String} value
	 */
	var setDataAttribute = function (el, name, value) { return el.setAttribute(("data-vv-" + name), value); };
	
	/**
	 * Custom parse behavior on top of date-fns parse function.
	 * @param {String} date
	 * @param {String} format
	 * @return {Date|null}
	 */
	var parseDate$1 = function (date, format$$1) {
	  var parsed = parse(date, format$$1, new Date());
	
	  // if date is not valid or the formatted output after parsing does not match
	  // the string value passed in (avoids overflows)
	  if (!isValid(parsed) || format(parsed, format$$1) !== date) {
	    return null;
	  }
	
	  return parsed;
	};
	
	var createProxy = function (target, handler) {
	  if (typeof Proxy === 'undefined') {
	    return target;
	  }
	
	  return new Proxy(target, handler);
	};
	
	var createFlags = function () { return ({
	  untouched: true,
	  touched: false,
	  dirty: false,
	  pristine: true,
	  valid: null,
	  invalid: null,
	  validated: false,
	  pending: false,
	  required: false
	}); };
	
	/**
	 * Shallow object comparison.
	 *
	 * @param {*} lhs
	 * @param {*} rhs
	 * @return {Boolean}
	 */
	var isEqual$1 = function (lhs, rhs) {
	  if (lhs instanceof RegExp && rhs instanceof RegExp) {
	    return isEqual$1(lhs.source, rhs.source) && isEqual$1(lhs.flags, rhs.flags);
	  }
	
	  if (Array.isArray(lhs) && Array.isArray(rhs)) {
	    if (lhs.length !== rhs.length) { return false; }
	
	    for (var i = 0; i < lhs.length; i++) {
	      if (!isEqual$1(lhs[i], rhs[i])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  // if both are objects, compare each key recursively.
	  if (isObject(lhs) && isObject(rhs)) {
	    return Object.keys(lhs).every(function (key) {
	      return isEqual$1(lhs[key], rhs[key]);
	    }) && Object.keys(rhs).every(function (key) {
	      return isEqual$1(lhs[key], rhs[key]);
	    });
	  }
	
	  return lhs === rhs;
	};
	
	/**
	 * Determines the input field scope.
	 */
	var getScope = function (el) {
	  var scope = getDataAttribute(el, 'scope');
	  if (isNullOrUndefined(scope) && el.form) {
	    scope = getDataAttribute(el.form, 'scope');
	  }
	
	  return !isNullOrUndefined(scope) ? scope : null;
	};
	
	/**
	 * Gets the value in an object safely.
	 * @param {String} propPath
	 * @param {Object} target
	 * @param {*} def
	 */
	var getPath = function (propPath, target, def) {
	  if ( def === void 0 ) def = undefined;
	
	  if (!propPath || !target) { return def; }
	  var value = target;
	  propPath.split('.').every(function (prop) {
	    if (! Object.prototype.hasOwnProperty.call(value, prop) && value[prop] === undefined) {
	      value = def;
	
	      return false;
	    }
	
	    value = value[prop];
	
	    return true;
	  });
	
	  return value;
	};
	
	/**
	 * Checks if path exists within an object.
	 *
	 * @param {String} path
	 * @param {Object} target
	 */
	var hasPath = function (path, target) {
	  var obj = target;
	  return path.split('.').every(function (prop) {
	    if (! Object.prototype.hasOwnProperty.call(obj, prop)) {
	      return false;
	    }
	
	    obj = obj[prop];
	
	    return true;
	  });
	};
	
	/**
	 * @param {String} rule
	 */
	var parseRule = function (rule) {
	  var params = [];
	  var name = rule.split(':')[0];
	
	  if (~rule.indexOf(':')) {
	    params = rule.split(':').slice(1).join(':').split(',');
	  }
	
	  return { name: name, params: params };
	};
	
	/**
	 * Normalizes the given rules expression.
	 *
	 * @param {Object|String} rules
	 */
	var normalizeRules = function (rules) {
	  // if falsy value return an empty object.
	  if (!rules) {
	    return {};
	  }
	
	  var validations = {};
	  if (isObject(rules)) {
	    Object.keys(rules).forEach(function (rule) {
	      var params = [];
	      if (rules[rule] === true) {
	        params = [];
	      } else if (Array.isArray(rules[rule])) {
	        params = rules[rule];
	      } else {
	        params = [rules[rule]];
	      }
	
	      if (rules[rule] !== false) {
	        validations[rule] = params;
	      }
	    });
	
	    return validations;
	  }
	
	  if (typeof rules !== 'string') {
	    warn('rules must be either a string or an object.');
	    return {};
	  }
	
	  rules.split('|').forEach(function (rule) {
	    var parsedRule = parseRule(rule);
	    if (! parsedRule.name) {
	      return;
	    }
	
	    validations[parsedRule.name] = parsedRule.params;
	  });
	
	  return validations;
	};
	
	/**
	 * Debounces a function.
	 */
	var debounce = function (fn, wait, immediate) {
	  if ( wait === void 0 ) wait = 0;
	  if ( immediate === void 0 ) immediate = false;
	
	  if (wait === 0) {
	    return fn;
	  }
	
	  var timeout;
	
	  return function () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	
	    var later = function () {
	      timeout = null;
	      if (!immediate) { fn.apply(void 0, args); }
	    };
	    /* istanbul ignore next */
	    var callNow = immediate && !timeout;
	    clearTimeout(timeout);
	    timeout = setTimeout(later, wait);
	    /* istanbul ignore next */
	    if (callNow) { fn.apply(void 0, args); }
	  };
	};
	
	/**
	 * Emits a warning to the console.
	 */
	var warn = function (message) {
	  console.warn(("[vee-validate] " + message)); // eslint-disable-line
	};
	
	/**
	 * Creates a branded error object.
	 * @param {String} message
	 */
	var createError = function (message) { return new Error(("[vee-validate] " + message)); };
	
	/**
	 * Checks if the value is an object.
	 */
	var isObject = function (object) { return object !== null && object && typeof object === 'object' && ! Array.isArray(object); };
	
	/**
	 * Checks if a function is callable.
	 */
	var isCallable = function (func) { return typeof func === 'function'; };
	
	/**
	 * Check if element has the css class on it.
	 */
	var hasClass = function (el, className) {
	  if (el.classList) {
	    return el.classList.contains(className);
	  }
	
	  return !!el.className.match(new RegExp(("(\\s|^)" + className + "(\\s|$)")));
	};
	
	/**
	 * Adds the provided css className to the element.
	 */
	var addClass = function (el, className) {
	  if (el.classList) {
	    el.classList.add(className);
	    return;
	  }
	
	  if (!hasClass(el, className)) {
	    el.className += " " + className;
	  }
	};
	
	/**
	 * Remove the provided css className from the element.
	 */
	var removeClass = function (el, className) {
	  if (el.classList) {
	    el.classList.remove(className);
	    return;
	  }
	
	  if (hasClass(el, className)) {
	    var reg = new RegExp(("(\\s|^)" + className + "(\\s|$)"));
	    el.className = el.className.replace(reg, ' ');
	  }
	};
	
	/**
	 * Adds or removes a class name on the input depending on the status flag.
	 */
	var toggleClass = function (el, className, status) {
	  if (!el || !className) { return; }
	
	  if (status) {
	    return addClass(el, className);
	  }
	
	  removeClass(el, className);
	};
	
	/**
	 * Converts an array-like object to array.
	 * Simple polyfill for Array.from
	 */
	var toArray = function (arrayLike) {
	  if (isCallable(Array.from)) {
	    return Array.from(arrayLike);
	  }
	
	  var array = [];
	  var length = arrayLike.length;
	  for (var i = 0; i < length; i++) {
	    array.push(arrayLike[i]);
	  }
	
	  return array;
	};
	
	/**
	 * Assign polyfill from the mdn.
	 * @param {Object} target
	 * @return {Object}
	 */
	var assign = function (target) {
	  var others = [], len = arguments.length - 1;
	  while ( len-- > 0 ) others[ len ] = arguments[ len + 1 ];
	
	  /* istanbul ignore else */
	  if (isCallable(Object.assign)) {
	    return Object.assign.apply(Object, [ target ].concat( others ));
	  }
	
	  /* istanbul ignore next */
	  if (target == null) {
	    throw new TypeError('Cannot convert undefined or null to object');
	  }
	
	  /* istanbul ignore next */
	  var to = Object(target);
	  /* istanbul ignore next */
	  others.forEach(function (arg) {
	    // Skip over if undefined or null
	    if (arg != null) {
	      Object.keys(arg).forEach(function (key) {
	        to[key] = arg[key];
	      });
	    }
	  });
	  /* istanbul ignore next */
	  return to;
	};
	
	/**
	 * Generates a unique id.
	 * @return {String}
	 */
	var uniqId = function () { return ("_" + (Math.random().toString(36).substr(2, 9))); };
	
	/**
	 * polyfills array.find
	 * @param {Array} array
	 * @param {Function} predicate
	 */
	var find = function (array, predicate) {
	  if (isObject(array)) {
	    array = toArray(array);
	  }
	  if (array.find) {
	    return array.find(predicate);
	  }
	  var result;
	  array.some(function (item) {
	    if (predicate(item)) {
	      result = item;
	      return true;
	    }
	
	    return false;
	  });
	
	  return result;
	};
	
	var getInputEventName = function (el) {
	  if (el && (el.tagName === 'SELECT' || ~['radio', 'checkbox', 'file'].indexOf(el.type))) {
	    return 'change';
	  }
	
	  return 'input';
	};
	
	var after = function (value, ref) {
	  var otherValue = ref[0];
	  var inclusion = ref[1];
	  var format = ref[2];
	
	  if (typeof format === 'undefined') {
	    format = inclusion;
	    inclusion = false;
	  }
	  value = parseDate$1(value, format);
	  otherValue = parseDate$1(otherValue, format);
	
	  // if either is not valid.
	  if (!value || !otherValue) {
	    return false;
	  }
	
	  return isAfter(value, otherValue) || (inclusion && isEqual(value, otherValue));
	};
	
	/**
	 * Some Alpha Regex helpers.
	 * https://github.com/chriso/validator.js/blob/master/src/lib/alpha.js
	 */
	
	var alpha$1 = {
	  en: /^[A-Z]*$/i,
	  cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,
	  da: /^[A-ZÆØÅ]*$/i,
	  de: /^[A-ZÄÖÜß]*$/i,
	  es: /^[A-ZÁÉÍÑÓÚÜ]*$/i,
	  fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,
	  lt: /^[A-ZĄČĘĖĮŠŲŪŽ]*$/i,
	  nl: /^[A-ZÉËÏÓÖÜ]*$/i,
	  hu: /^[A-ZÁÉÍÓÖŐÚÜŰ]*$/i,
	  pl: /^[A-ZĄĆĘŚŁŃÓŻŹ]*$/i,
	  pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,
	  ru: /^[А-ЯЁ]*$/i,
	  sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,
	  sr: /^[A-ZČĆŽŠĐ]*$/i,
	  tr: /^[A-ZÇĞİıÖŞÜ]*$/i,
	  uk: /^[А-ЩЬЮЯЄІЇҐ]*$/i,
	  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/
	};
	
	var alphaSpaces = {
	  en: /^[A-Z\s]*$/i,
	  cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ\s]*$/i,
	  da: /^[A-ZÆØÅ\s]*$/i,
	  de: /^[A-ZÄÖÜß\s]*$/i,
	  es: /^[A-ZÁÉÍÑÓÚÜ\s]*$/i,
	  fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ\s]*$/i,
	  lt: /^[A-ZĄČĘĖĮŠŲŪŽ\s]*$/i,
	  nl: /^[A-ZÉËÏÓÖÜ\s]*$/i,
	  hu: /^[A-ZÁÉÍÓÖŐÚÜŰ\s]*$/i,
	  pl: /^[A-ZĄĆĘŚŁŃÓŻŹ\s]*$/i,
	  pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ\s]*$/i,
	  ru: /^[А-ЯЁ\s]*$/i,
	  sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ\s]*$/i,
	  sr: /^[A-ZČĆŽŠĐ\s]*$/i,
	  tr: /^[A-ZÇĞİıÖŞÜ\s]*$/i,
	  uk: /^[А-ЩЬЮЯЄІЇҐ\s]*$/i,
	  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ\s]*$/
	};
	
	var alphanumeric = {
	  en: /^[0-9A-Z]*$/i,
	  cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,
	  da: /^[0-9A-ZÆØÅ]$/i,
	  de: /^[0-9A-ZÄÖÜß]*$/i,
	  es: /^[0-9A-ZÁÉÍÑÓÚÜ]*$/i,
	  fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,
	  lt: /^[0-9A-ZĄČĘĖĮŠŲŪŽ]*$/i,
	  hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]*$/i,
	  nl: /^[0-9A-ZÉËÏÓÖÜ]*$/i,
	  pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]*$/i,
	  pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,
	  ru: /^[0-9А-ЯЁ]*$/i,
	  sk: /^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,
	  sr: /^[0-9A-ZČĆŽŠĐ]*$/i,
	  tr: /^[0-9A-ZÇĞİıÖŞÜ]*$/i,
	  uk: /^[0-9А-ЩЬЮЯЄІЇҐ]*$/i,
	  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/
	};
	
	var alphaDash = {
	  en: /^[0-9A-Z_-]*$/i,
	  cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ_-]*$/i,
	  da: /^[0-9A-ZÆØÅ_-]*$/i,
	  de: /^[0-9A-ZÄÖÜß_-]*$/i,
	  es: /^[0-9A-ZÁÉÍÑÓÚÜ_-]*$/i,
	  fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ_-]*$/i,
	  lt: /^[0-9A-ZĄČĘĖĮŠŲŪŽ_-]*$/i,
	  nl: /^[0-9A-ZÉËÏÓÖÜ_-]*$/i,
	  hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ_-]*$/i,
	  pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ_-]*$/i,
	  pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ_-]*$/i,
	  ru: /^[0-9А-ЯЁ_-]*$/i,
	  sk: /^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ_-]*$/i,
	  sr: /^[0-9A-ZČĆŽŠĐ_-]*$/i,
	  tr: /^[0-9A-ZÇĞİıÖŞÜ_-]*$/i,
	  uk: /^[0-9А-ЩЬЮЯЄІЇҐ_-]*$/i,
	  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ_-]*$/
	};
	
	var validate = function (value, ref) {
	  if ( ref === void 0 ) ref = [null];
	  var locale = ref[0];
	
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return validate(val, [locale]); });
	  }
	
	  // Match at least one locale.
	  if (! locale) {
	    return Object.keys(alpha$1).some(function (loc) { return alpha$1[loc].test(value); });
	  }
	
	  return (alpha$1[locale] || alpha$1.en).test(value);
	};
	
	var validate$1 = function (value, ref) {
	  if ( ref === void 0 ) ref = [null];
	  var locale = ref[0];
	
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return validate$1(val, [locale]); });
	  }
	
	  // Match at least one locale.
	  if (! locale) {
	    return Object.keys(alphaDash).some(function (loc) { return alphaDash[loc].test(value); });
	  }
	
	  return (alphaDash[locale] || alphaDash.en).test(value);
	};
	
	var validate$2 = function (value, ref) {
	  if ( ref === void 0 ) ref = [null];
	  var locale = ref[0];
	
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return validate$2(val, [locale]); });
	  }
	
	  // Match at least one locale.
	  if (! locale) {
	    return Object.keys(alphanumeric).some(function (loc) { return alphanumeric[loc].test(value); });
	  }
	
	  return (alphanumeric[locale] || alphanumeric.en).test(value);
	};
	
	var validate$3 = function (value, ref) {
	  if ( ref === void 0 ) ref = [null];
	  var locale = ref[0];
	
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return validate$3(val, [locale]); });
	  }
	
	  // Match at least one locale.
	  if (! locale) {
	    return Object.keys(alphaSpaces).some(function (loc) { return alphaSpaces[loc].test(value); });
	  }
	
	  return (alphaSpaces[locale] || alphaSpaces.en).test(value);
	};
	
	var before = function (value, ref) {
	  var otherValue = ref[0];
	  var inclusion = ref[1];
	  var format = ref[2];
	
	  if (typeof format === 'undefined') {
	    format = inclusion;
	    inclusion = false;
	  }
	  value = parseDate$1(value, format);
	  otherValue = parseDate$1(otherValue, format);
	
	  // if either is not valid.
	  if (!value || !otherValue) {
	    return false;
	  }
	
	  return isBefore(value, otherValue) || (inclusion && isEqual(value, otherValue));
	};
	
	var validate$4 = function (value, ref) {
	  var min = ref[0];
	  var max = ref[1];
	
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return validate$4(val, [min, max]); });
	  }
	
	  return Number(min) <= value && Number(max) >= value;
	};
	
	var confirmed = function (value, other) { return String(value) === String(other); };
	
	function unwrapExports (x) {
		return x && x.__esModule ? x['default'] : x;
	}
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var assertString_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = assertString;
	function assertString(input) {
	  var isString = typeof input === 'string' || input instanceof String;
	
	  if (!isString) {
	    throw new TypeError('This library (validator.js) validates strings only');
	  }
	}
	module.exports = exports['default'];
	});
	
	unwrapExports(assertString_1);
	
	var isCreditCard_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isCreditCard;
	
	
	
	var _assertString2 = _interopRequireDefault(assertString_1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|62[0-9]{14})$/;
	/* eslint-enable max-len */
	
	function isCreditCard(str) {
	  (0, _assertString2.default)(str);
	  var sanitized = str.replace(/[- ]+/g, '');
	  if (!creditCard.test(sanitized)) {
	    return false;
	  }
	  var sum = 0;
	  var digit = void 0;
	  var tmpNum = void 0;
	  var shouldDouble = void 0;
	  for (var i = sanitized.length - 1; i >= 0; i--) {
	    digit = sanitized.substring(i, i + 1);
	    tmpNum = parseInt(digit, 10);
	    if (shouldDouble) {
	      tmpNum *= 2;
	      if (tmpNum >= 10) {
	        sum += tmpNum % 10 + 1;
	      } else {
	        sum += tmpNum;
	      }
	    } else {
	      sum += tmpNum;
	    }
	    shouldDouble = !shouldDouble;
	  }
	  return !!(sum % 10 === 0 ? sanitized : false);
	}
	module.exports = exports['default'];
	});
	
	var isCreditCard = unwrapExports(isCreditCard_1);
	
	var credit_card = function (value) { return isCreditCard(String(value)); };
	
	var validate$5 = function (value, params) {
	  var decimals = Array.isArray(params) ? (params[0] || '*') : '*';
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return validate$5(val, params); });
	  }
	
	  if (value === null || value === undefined || value === '') {
	    return true;
	  }
	
	  // if is 0.
	  if (Number(decimals) === 0) {
	    return /^-?\d*$/.test(value);
	  }
	
	  var regexPart = decimals === '*' ? '+' : ("{1," + decimals + "}");
	  var regex = new RegExp(("^-?\\d*(\\.\\d" + regexPart + ")?$"));
	
	  if (! regex.test(value)) {
	    return false;
	  }
	
	  var parsedValue = parseFloat(value);
	
	  // eslint-disable-next-line
	    return parsedValue === parsedValue;
	};
	
	var date_between = function (value, params) {
	  var min;
	  var max;
	  var format;
	  var inclusivity = '()';
	
	  if (params.length > 3) {
	    var assign$$1;
	    (assign$$1 = params, min = assign$$1[0], max = assign$$1[1], inclusivity = assign$$1[2], format = assign$$1[3]);
	  } else {
	    var assign$1;
	    (assign$1 = params, min = assign$1[0], max = assign$1[1], format = assign$1[2]);
	  }
	
	  var minDate = parseDate$1(min, format);
	  var maxDate = parseDate$1(max, format);
	  var dateVal = parseDate$1(value, format);
	
	  if (!minDate || !maxDate || !dateVal) {
	    return false;
	  }
	
	  if (inclusivity === '()') {
	    return isAfter(dateVal, minDate) && isBefore(dateVal, maxDate);
	  }
	
	  if (inclusivity === '(]') {
	    return isAfter(dateVal, minDate) && (isEqual(dateVal, maxDate) || isBefore(dateVal, maxDate));
	  }
	
	  if (inclusivity === '[)') {
	    return isBefore(dateVal, maxDate) && (isEqual(dateVal, minDate) || isAfter(dateVal, minDate));
	  }
	
	  return isEqual(dateVal, maxDate) || isEqual(dateVal, minDate) ||
	        (isBefore(dateVal, maxDate) && isAfter(dateVal, minDate));
	};
	
	var date_format = function (value, ref) {
	  var format = ref[0];
	
	  return !!parseDate$1(value, format);
	};
	
	var validate$6 = function (value, ref) {
	  var length = ref[0];
	
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return validate$6(val, [length]); });
	  }
	  var strVal = String(value);
	
	  return /^[0-9]*$/.test(strVal) && strVal.length === Number(length);
	};
	
	var validateImage = function (file, width, height) {
	  var URL = window.URL || window.webkitURL;
	  return new Promise(function (resolve) {
	    var image = new Image();
	    image.onerror = function () { return resolve({ valid: false }); };
	    image.onload = function () { return resolve({
	      valid: image.width === Number(width) && image.height === Number(height)
	    }); };
	
	    image.src = URL.createObjectURL(file);
	  });
	};
	
	var dimensions = function (files, ref) {
	  var width = ref[0];
	  var height = ref[1];
	
	  var list = [];
	  for (var i = 0; i < files.length; i++) {
	    // if file is not an image, reject.
	    if (! /\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(files[i].name)) {
	      return false;
	    }
	
	    list.push(files[i]);
	  }
	
	  return Promise.all(list.map(function (file) { return validateImage(file, width, height); }));
	};
	
	var merge_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = merge;
	function merge() {
	  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var defaults = arguments[1];
	
	  for (var key in defaults) {
	    if (typeof obj[key] === 'undefined') {
	      obj[key] = defaults[key];
	    }
	  }
	  return obj;
	}
	module.exports = exports['default'];
	});
	
	unwrapExports(merge_1);
	
	var isByteLength_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isByteLength;
	
	
	
	var _assertString2 = _interopRequireDefault(assertString_1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable prefer-rest-params */
	function isByteLength(str, options) {
	  (0, _assertString2.default)(str);
	  var min = void 0;
	  var max = void 0;
	  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	    min = options.min || 0;
	    max = options.max;
	  } else {
	    // backwards compatibility: isByteLength(str, min [, max])
	    min = arguments[1];
	    max = arguments[2];
	  }
	  var len = encodeURI(str).split(/%..|./).length - 1;
	  return len >= min && (typeof max === 'undefined' || len <= max);
	}
	module.exports = exports['default'];
	});
	
	unwrapExports(isByteLength_1);
	
	var isFQDN = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFDQN;
	
	
	
	var _assertString2 = _interopRequireDefault(assertString_1);
	
	
	
	var _merge2 = _interopRequireDefault(merge_1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_fqdn_options = {
	  require_tld: true,
	  allow_underscores: false,
	  allow_trailing_dot: false
	};
	
	function isFDQN(str, options) {
	  (0, _assertString2.default)(str);
	  options = (0, _merge2.default)(options, default_fqdn_options);
	
	  /* Remove the optional trailing dot before checking validity */
	  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
	    str = str.substring(0, str.length - 1);
	  }
	  var parts = str.split('.');
	  if (options.require_tld) {
	    var tld = parts.pop();
	    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
	      return false;
	    }
	    // disallow spaces
	    if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
	      return false;
	    }
	  }
	  for (var part, i = 0; i < parts.length; i++) {
	    part = parts[i];
	    if (options.allow_underscores) {
	      part = part.replace(/_/g, '');
	    }
	    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
	      return false;
	    }
	    // disallow full-width chars
	    if (/[\uff01-\uff5e]/.test(part)) {
	      return false;
	    }
	    if (part[0] === '-' || part[part.length - 1] === '-') {
	      return false;
	    }
	  }
	  return true;
	}
	module.exports = exports['default'];
	});
	
	unwrapExports(isFQDN);
	
	var isEmail_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmail;
	
	
	
	var _assertString2 = _interopRequireDefault(assertString_1);
	
	
	
	var _merge2 = _interopRequireDefault(merge_1);
	
	
	
	var _isByteLength2 = _interopRequireDefault(isByteLength_1);
	
	
	
	var _isFQDN2 = _interopRequireDefault(isFQDN);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_email_options = {
	  allow_display_name: false,
	  require_display_name: false,
	  allow_utf8_local_part: true,
	  require_tld: true
	};
	
	/* eslint-disable max-len */
	/* eslint-disable no-control-regex */
	var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\,\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
	var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
	var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
	var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
	var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
	/* eslint-enable max-len */
	/* eslint-enable no-control-regex */
	
	function isEmail(str, options) {
	  (0, _assertString2.default)(str);
	  options = (0, _merge2.default)(options, default_email_options);
	
	  if (options.require_display_name || options.allow_display_name) {
	    var display_email = str.match(displayName);
	    if (display_email) {
	      str = display_email[1];
	    } else if (options.require_display_name) {
	      return false;
	    }
	  }
	
	  var parts = str.split('@');
	  var domain = parts.pop();
	  var user = parts.join('@');
	
	  var lower_domain = domain.toLowerCase();
	  if (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com') {
	    user = user.replace(/\./g, '').toLowerCase();
	  }
	
	  if (!(0, _isByteLength2.default)(user, { max: 64 }) || !(0, _isByteLength2.default)(domain, { max: 254 })) {
	    return false;
	  }
	
	  if (!(0, _isFQDN2.default)(domain, { require_tld: options.require_tld })) {
	    return false;
	  }
	
	  if (user[0] === '"') {
	    user = user.slice(1, user.length - 1);
	    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
	  }
	
	  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
	
	  var user_parts = user.split('.');
	  for (var i = 0; i < user_parts.length; i++) {
	    if (!pattern.test(user_parts[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	module.exports = exports['default'];
	});
	
	var isEmail = unwrapExports(isEmail_1);
	
	var validate$7 = function (value) {
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return isEmail(String(val)); });
	  }
	
	  return isEmail(String(value));
	};
	
	var ext = function (files, extensions) {
	  var regex = new RegExp((".(" + (extensions.join('|')) + ")$"), 'i');
	
	  return files.every(function (file) { return regex.test(file.name); });
	};
	
	var image = function (files) { return files.every(function (file) { return /\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(file.name); }
	); };
	
	var validate$8 = function (value, options) {
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return validate$8(val, options); });
	  }
	
	  // eslint-disable-next-line
	  return !! options.filter(function (option) { return option == value; }).length;
	};
	
	var isIP_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isIP;
	
	
	
	var _assertString2 = _interopRequireDefault(assertString_1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ipv4Maybe = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
	var ipv6Block = /^[0-9A-F]{1,4}$/i;
	
	function isIP(str) {
	  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  (0, _assertString2.default)(str);
	  version = String(version);
	  if (!version) {
	    return isIP(str, 4) || isIP(str, 6);
	  } else if (version === '4') {
	    if (!ipv4Maybe.test(str)) {
	      return false;
	    }
	    var parts = str.split('.').sort(function (a, b) {
	      return a - b;
	    });
	    return parts[3] <= 255;
	  } else if (version === '6') {
	    var blocks = str.split(':');
	    var foundOmissionBlock = false; // marker to indicate ::
	
	    // At least some OS accept the last 32 bits of an IPv6 address
	    // (i.e. 2 of the blocks) in IPv4 notation, and RFC 3493 says
	    // that '::ffff:a.b.c.d' is valid for IPv4-mapped IPv6 addresses,
	    // and '::a.b.c.d' is deprecated, but also valid.
	    var foundIPv4TransitionBlock = isIP(blocks[blocks.length - 1], 4);
	    var expectedNumberOfBlocks = foundIPv4TransitionBlock ? 7 : 8;
	
	    if (blocks.length > expectedNumberOfBlocks) {
	      return false;
	    }
	    // initial or final ::
	    if (str === '::') {
	      return true;
	    } else if (str.substr(0, 2) === '::') {
	      blocks.shift();
	      blocks.shift();
	      foundOmissionBlock = true;
	    } else if (str.substr(str.length - 2) === '::') {
	      blocks.pop();
	      blocks.pop();
	      foundOmissionBlock = true;
	    }
	
	    for (var i = 0; i < blocks.length; ++i) {
	      // test for a :: which can not be at the string start/end
	      // since those cases have been handled above
	      if (blocks[i] === '' && i > 0 && i < blocks.length - 1) {
	        if (foundOmissionBlock) {
	          return false; // multiple :: in address
	        }
	        foundOmissionBlock = true;
	      } else if (foundIPv4TransitionBlock && i === blocks.length - 1) {
	        // it has been checked before that the last
	        // block is a valid IPv4 address
	      } else if (!ipv6Block.test(blocks[i])) {
	        return false;
	      }
	    }
	    if (foundOmissionBlock) {
	      return blocks.length >= 1;
	    }
	    return blocks.length === expectedNumberOfBlocks;
	  }
	  return false;
	}
	module.exports = exports['default'];
	});
	
	var isIP = unwrapExports(isIP_1);
	
	var ip = function (value, ref) {
	  if ( ref === void 0 ) ref = [4];
	  var version = ref[0];
	
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return isIP(val, [version]); });
	  }
	
	  return isIP(value, version);
	};
	
	/**
	 * @param {Array|String} value 
	 * @param {Number} length
	 * @param {Number} max 
	 */
	var compare = function (value, length, max) {
	  if (max === undefined) {
	    return value.length === length;
	  }
	
	  // cast to number.
	  max = Number(max);
	
	  return value.length >= length && value.length <= max;
	};
	
	var length = function (value, ref) {
	  var length = ref[0];
	  var max = ref[1]; if ( max === void 0 ) max = undefined;
	
	  length = Number(length);
	  if (value === undefined || value === null) {
	    return false;
	  }
	
	  if (typeof value === 'number') {
	    value = String(value);
	  }
	
	  if (!value.length) {
	    value = toArray(value);
	  }
	
	  return compare(value, length, max);
	};
	
	var integer = function (value) {
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return /^-?[0-9]+$/.test(String(val)); });
	  }
	
	  return /^-?[0-9]+$/.test(String(value));
	};
	
	var max$1 = function (value, ref) {
	  var length = ref[0];
	
	  if (value === undefined || value === null) {
	    return length >= 0;
	  }
	
	  return String(value).length <= length;
	};
	
	var max_value = function (value, ref) {
	  var max = ref[0];
	
	  if (Array.isArray(value) || value === null || value === undefined || value === '') {
	    return false;
	  }
	
	  return Number(value) <= max;
	};
	
	var mimes = function (files, mimes) {
	  var regex = new RegExp(((mimes.join('|').replace('*', '.+')) + "$"), 'i');
	
	  return files.every(function (file) { return regex.test(file.type); });
	};
	
	var min$1 = function (value, ref) {
	  var length = ref[0];
	
	  if (value === undefined || value === null) {
	    return false;
	  }
	  return String(value).length >= length;
	};
	
	var min_value = function (value, ref) {
	  var min = ref[0];
	
	  if (Array.isArray(value) || value === null || value === undefined || value === '') {
	    return false;
	  }
	
	  return Number(value) >= min;
	};
	
	var validate$9 = function (value, options) {
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return validate$9(val, options); });
	  }
	
	  // eslint-disable-next-line
	  return ! options.filter(function (option) { return option == value; }).length;
	};
	
	var numeric = function (value) {
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return /^[0-9]+$/.test(String(val)); });
	  }
	
	  return /^[0-9]+$/.test(String(value));
	};
	
	var regex = function (value, ref) {
	  var regex = ref[0];
	  var flags = ref.slice(1);
	
	  if (regex instanceof RegExp) {
	    return regex.test(value);
	  }
	
	  return new RegExp(regex, flags).test(String(value));
	};
	
	var required = function (value, params) {
	  if ( params === void 0 ) params = [false];
	
	  if (Array.isArray(value)) {
	    return !! value.length;
	  }
	
	  // incase a field considers `false` as an empty value like checkboxes.
	  var invalidateFalse = params[0];
	  if (value === false && invalidateFalse) {
	    return false;
	  }
	
	  if (value === undefined || value === null) {
	    return false;
	  }
	
	  return !! String(value).trim().length;
	};
	
	var size = function (files, ref) {
	  var size = ref[0];
	
	  if (isNaN(size)) {
	    return false;
	  }
	
	  var nSize = Number(size) * 1024;
	  for (var i = 0; i < files.length; i++) {
	    if (files[i].size > nSize) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	var isURL_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isURL;
	
	
	
	var _assertString2 = _interopRequireDefault(assertString_1);
	
	
	
	var _isFQDN2 = _interopRequireDefault(isFQDN);
	
	
	
	var _isIP2 = _interopRequireDefault(isIP_1);
	
	
	
	var _merge2 = _interopRequireDefault(merge_1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_url_options = {
	  protocols: ['http', 'https', 'ftp'],
	  require_tld: true,
	  require_protocol: false,
	  require_host: true,
	  require_valid_protocol: true,
	  allow_underscores: false,
	  allow_trailing_dot: false,
	  allow_protocol_relative_urls: false
	};
	
	var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;
	
	function isRegExp(obj) {
	  return Object.prototype.toString.call(obj) === '[object RegExp]';
	}
	
	function checkHost(host, matches) {
	  for (var i = 0; i < matches.length; i++) {
	    var match = matches[i];
	    if (host === match || isRegExp(match) && match.test(host)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	function isURL(url, options) {
	  (0, _assertString2.default)(url);
	  if (!url || url.length >= 2083 || /[\s<>]/.test(url)) {
	    return false;
	  }
	  if (url.indexOf('mailto:') === 0) {
	    return false;
	  }
	  options = (0, _merge2.default)(options, default_url_options);
	  var protocol = void 0,
	      auth = void 0,
	      host = void 0,
	      hostname = void 0,
	      port = void 0,
	      port_str = void 0,
	      split = void 0,
	      ipv6 = void 0;
	
	  split = url.split('#');
	  url = split.shift();
	
	  split = url.split('?');
	  url = split.shift();
	
	  split = url.split('://');
	  if (split.length > 1) {
	    protocol = split.shift();
	    if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
	      return false;
	    }
	  } else if (options.require_protocol) {
	    return false;
	  } else if (options.allow_protocol_relative_urls && url.substr(0, 2) === '//') {
	    split[0] = url.substr(2);
	  }
	  url = split.join('://');
	
	  if (url === '') {
	    return false;
	  }
	
	  split = url.split('/');
	  url = split.shift();
	
	  if (url === '' && !options.require_host) {
	    return true;
	  }
	
	  split = url.split('@');
	  if (split.length > 1) {
	    auth = split.shift();
	    if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
	      return false;
	    }
	  }
	  hostname = split.join('@');
	
	  port_str = null;
	  ipv6 = null;
	  var ipv6_match = hostname.match(wrapped_ipv6);
	  if (ipv6_match) {
	    host = '';
	    ipv6 = ipv6_match[1];
	    port_str = ipv6_match[2] || null;
	  } else {
	    split = hostname.split(':');
	    host = split.shift();
	    if (split.length) {
	      port_str = split.join(':');
	    }
	  }
	
	  if (port_str !== null) {
	    port = parseInt(port_str, 10);
	    if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
	      return false;
	    }
	  }
	
	  if (!(0, _isIP2.default)(host) && !(0, _isFQDN2.default)(host, options) && (!ipv6 || !(0, _isIP2.default)(ipv6, 6))) {
	    return false;
	  }
	
	  host = host || ipv6;
	
	  if (options.host_whitelist && !checkHost(host, options.host_whitelist)) {
	    return false;
	  }
	  if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
	    return false;
	  }
	
	  return true;
	}
	module.exports = exports['default'];
	});
	
	var isURL = unwrapExports(isURL_1);
	
	var url = function (value, ref) {
	  if ( ref === void 0 ) ref = [true];
	  var requireProtocol = ref[0];
	
	  var options = { require_protocol: !!requireProtocol, allow_underscores: true };
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return isURL(val, options); });
	  }
	
	  return isURL(value, options);
	};
	
	/* eslint-disable camelcase */
	var Rules = {
	  after: after,
	  alpha_dash: validate$1,
	  alpha_num: validate$2,
	  alpha_spaces: validate$3,
	  alpha: validate,
	  before: before,
	  between: validate$4,
	  confirmed: confirmed,
	  credit_card: credit_card,
	  date_between: date_between,
	  date_format: date_format,
	  decimal: validate$5,
	  digits: validate$6,
	  dimensions: dimensions,
	  email: validate$7,
	  ext: ext,
	  image: image,
	  in: validate$8,
	  integer: integer,
	  length: length,
	  ip: ip,
	  max: max$1,
	  max_value: max_value,
	  mimes: mimes,
	  min: min$1,
	  min_value: min_value,
	  not_in: validate$9,
	  numeric: numeric,
	  regex: regex,
	  required: required,
	  size: size,
	  url: url
	};
	
	var ErrorBag = function ErrorBag () {
	  this.items = [];
	};
	
	/**
	   * Adds an error to the internal array.
	   *
	   * @param {Object} error The error object.
	   */
	ErrorBag.prototype.add = function add (error) {
	  // handle old signature.
	  if (arguments.length > 1) {
	    error = {
	      field: arguments[0],
	      msg: arguments[1],
	      rule: arguments[2],
	      scope: !isNullOrUndefined(arguments[3]) ? arguments[3] : null
	    };
	  }
	
	  error.scope = !isNullOrUndefined(error.scope) ? error.scope : null;
	  this.items.push(error);
	};
	
	/**
	 * Updates a field error with the new field scope.
	 *
	 * @param {String} id
	 * @param {Object} error
	 */
	ErrorBag.prototype.update = function update (id, error) {
	  var item = find(this.items, function (i) { return i.id === id; });
	  if (!item) {
	    return;
	  }
	
	  var idx = this.items.indexOf(item);
	  this.items.splice(idx, 1);
	  item.scope = error.scope;
	  this.items.push(item);
	};
	
	/**
	   * Gets all error messages from the internal array.
	   *
	   * @param {String} scope The Scope name, optional.
	   * @return {Array} errors Array of all error messages.
	   */
	ErrorBag.prototype.all = function all (scope) {
	  if (isNullOrUndefined(scope)) {
	    return this.items.map(function (e) { return e.msg; });
	  }
	
	  return this.items.filter(function (e) { return e.scope === scope; }).map(function (e) { return e.msg; });
	};
	
	/**
	   * Checks if there are any errors in the internal array.
	   * @param {String} scope The Scope name, optional.
	   * @return {boolean} result True if there was at least one error, false otherwise.
	   */
	ErrorBag.prototype.any = function any (scope) {
	  if (isNullOrUndefined(scope)) {
	    return !! this.items.length;
	  }
	
	  return !! this.items.filter(function (e) { return e.scope === scope; }).length;
	};
	
	/**
	   * Removes all items from the internal array.
	   *
	   * @param {String} scope The Scope name, optional.
	   */
	ErrorBag.prototype.clear = function clear (scope) {
	    var this$1 = this;
	
	  if (isNullOrUndefined(scope)) {
	    scope = null;
	  }
	
	  var removeCondition = function (e) { return e.scope === scope; };
	
	  for (var i = 0; i < this.items.length; ++i) {
	    if (removeCondition(this$1.items[i])) {
	      this$1.items.splice(i, 1);
	      --i;
	    }
	  }
	};
	
	/**
	   * Collects errors into groups or for a specific field.
	   *
	   * @param{string} field The field name.
	   * @param{string} scope The scope name.
	   * @param {Boolean} map If it should map the errors to strings instead of objects.
	   * @return {Array} errors The errors for the specified field.
	   */
	ErrorBag.prototype.collect = function collect (field, scope, map) {
	    if ( map === void 0 ) map = true;
	
	  if (! field) {
	    var collection = {};
	    this.items.forEach(function (e) {
	      if (! collection[e.field]) {
	        collection[e.field] = [];
	      }
	
	      collection[e.field].push(map ? e.msg : e);
	    });
	
	    return collection;
	  }
	
	  field = !isNullOrUndefined(field) ? String(field) : field;
	  if (isNullOrUndefined(scope)) {
	    return this.items.filter(function (e) { return e.field === field; }).map(function (e) { return (map ? e.msg : e); });
	  }
	
	  return this.items.filter(function (e) { return e.field === field && e.scope === scope; })
	    .map(function (e) { return (map ? e.msg : e); });
	};
	/**
	   * Gets the internal array length.
	   *
	   * @return {Number} length The internal array length.
	   */
	ErrorBag.prototype.count = function count () {
	  return this.items.length;
	};
	
	/**
	 * Finds and fetches the first error message for the specified field id.
	 *
	 * @param {String} id
	 */
	ErrorBag.prototype.firstById = function firstById (id) {
	  var error = find(this.items, function (i) { return i.id === id; });
	
	  return error ? error.msg : null;
	};
	
	/**
	   * Gets the first error message for a specific field.
	   *
	   * @param{String} field The field name.
	   * @return {String|null} message The error message.
	   */
	ErrorBag.prototype.first = function first (field, scope) {
	    var this$1 = this;
	    if ( scope === void 0 ) scope = null;
	
	  field = !isNullOrUndefined(field) ? String(field) : field;
	  var selector = this._selector(field);
	  var scoped = this._scope(field);
	
	  if (scoped) {
	    var result = this.first(scoped.name, scoped.scope);
	    // if such result exist, return it. otherwise it could be a field.
	    // with dot in its name.
	    if (result) {
	      return result;
	    }
	  }
	
	  if (selector) {
	    return this.firstByRule(selector.name, selector.rule, scope);
	  }
	
	  for (var i = 0; i < this.items.length; ++i) {
	    if (this$1.items[i].field === field && (this$1.items[i].scope === scope)) {
	      return this$1.items[i].msg;
	    }
	  }
	
	  return null;
	};
	
	/**
	   * Returns the first error rule for the specified field
	   *
	   * @param {string} field The specified field.
	   * @return {string|null} First error rule on the specified field if one is found, otherwise null
	   */
	ErrorBag.prototype.firstRule = function firstRule (field, scope) {
	  var errors = this.collect(field, scope, false);
	
	  return (errors.length && errors[0].rule) || null;
	};
	
	/**
	   * Checks if the internal array has at least one error for the specified field.
	   *
	   * @param{string} field The specified field.
	   * @return {Boolean} result True if at least one error is found, false otherwise.
	   */
	ErrorBag.prototype.has = function has (field, scope) {
	    if ( scope === void 0 ) scope = null;
	
	  return !! this.first(field, scope);
	};
	
	/**
	   * Gets the first error message for a specific field and a rule.
	   * @param {String} name The name of the field.
	   * @param {String} rule The name of the rule.
	   * @param {String} scope The name of the scope (optional).
	   */
	ErrorBag.prototype.firstByRule = function firstByRule (name, rule, scope) {
	  var error = this.collect(name, scope, false).filter(function (e) { return e.rule === rule; })[0];
	
	  return (error && error.msg) || null;
	};
	/**
	   * Gets the first error message for a specific field that not match the rule.
	   * @param {String} name The name of the field.
	   * @param {String} rule The name of the rule.
	   * @param {String} scope The name of the scope (optional).
	   */
	ErrorBag.prototype.firstNot = function firstNot (name, rule, scope) {
	    if ( rule === void 0 ) rule = 'required';
	
	  var error = this.collect(name, scope, false).filter(function (e) { return e.rule !== rule; })[0];
	
	  return (error && error.msg) || null;
	};
	
	/**
	 * Removes errors by matching against the id.
	 * @param {String} id
	 */
	ErrorBag.prototype.removeById = function removeById (id) {
	    var this$1 = this;
	
	  for (var i = 0; i < this.items.length; ++i) {
	    if (this$1.items[i].id === id) {
	      this$1.items.splice(i, 1);
	      --i;
	    }
	  }
	};
	
	/**
	   * Removes all error messages associated with a specific field.
	   *
	   * @param{String} field The field which messages are to be removed.
	   * @param {String} scope The Scope name, optional.
	   * @param {String} id The field id, optional.
	   */
	ErrorBag.prototype.remove = function remove (field, scope, id) {
	    var this$1 = this;
	
	  field = !isNullOrUndefined(field) ? String(field) : field;
	  var removeCondition = function (e) {
	    if (e.id && id) {
	      return e.id === id;
	    }
	
	    if (!isNullOrUndefined(scope)) {
	      return e.field === field && e.scope === scope;
	    }
	
	    return e.field === field && e.scope === null;
	  };
	
	  for (var i = 0; i < this.items.length; ++i) {
	    if (removeCondition(this$1.items[i])) {
	      this$1.items.splice(i, 1);
	      --i;
	    }
	  }
	};
	
	/**
	   * Get the field attributes if there's a rule selector.
	   *
	   * @param{String} field The specified field.
	   * @return {Object|null}
	   */
	ErrorBag.prototype._selector = function _selector (field) {
	  if (field.indexOf(':') > -1) {
	    var ref = field.split(':');
	      var name = ref[0];
	      var rule = ref[1];
	
	    return { name: name, rule: rule };
	  }
	
	  return null;
	};
	
	/**
	   * Get the field scope if specified using dot notation.
	   *
	   * @param {String} field the specifie field.
	   * @return {Object|null}
	   */
	ErrorBag.prototype._scope = function _scope (field) {
	  if (field.indexOf('.') > -1) {
	    var ref = field.split('.');
	      var scope = ref[0];
	      var name = ref.slice(1);
	
	    return { name: name.join('.'), scope: scope };
	  }
	
	  return null;
	};
	
	var Dictionary = function Dictionary (dictionary) {
	  if ( dictionary === void 0 ) dictionary = {};
	
	  this.container = {};
	  this.merge(dictionary);
	};
	
	Dictionary.prototype.hasLocale = function hasLocale (locale) {
	  return !! this.container[locale];
	};
	
	Dictionary.prototype.setDateFormat = function setDateFormat (locale, format) {
	  if (!this.container[locale]) {
	    this.container[locale] = {};
	  }
	
	  this.container[locale].dateFormat = format;
	};
	
	Dictionary.prototype.getDateFormat = function getDateFormat (locale) {
	  if (!this.container[locale]) {
	    return undefined;
	  }
	
	  return this.container[locale].dateFormat;
	};
	
	Dictionary.prototype.getMessage = function getMessage (locale, key, fallback) {
	  if (! this.hasMessage(locale, key)) {
	    return fallback || this._getDefaultMessage(locale);
	  }
	
	  return this.container[locale].messages[key];
	};
	
	/**
	 * Gets a specific message for field. fallsback to the rule message.
	 *
	 * @param {String} locale
	 * @param {String} field
	 * @param {String} key
	 */
	Dictionary.prototype.getFieldMessage = function getFieldMessage (locale, field, key) {
	  if (! this.hasLocale(locale)) {
	    return this.getMessage(locale, key);
	  }
	
	  var dict = this.container[locale].custom && this.container[locale].custom[field];
	  if (! dict || ! dict[key]) {
	    return this.getMessage(locale, key);
	  }
	
	  return dict[key];
	};
	
	Dictionary.prototype._getDefaultMessage = function _getDefaultMessage (locale) {
	  if (this.hasMessage(locale, '_default')) {
	    return this.container[locale].messages._default;
	  }
	
	  return this.container.en.messages._default;
	};
	
	Dictionary.prototype.getAttribute = function getAttribute (locale, key, fallback) {
	    if ( fallback === void 0 ) fallback = '';
	
	  if (! this.hasAttribute(locale, key)) {
	    return fallback;
	  }
	
	  return this.container[locale].attributes[key];
	};
	
	Dictionary.prototype.hasMessage = function hasMessage (locale, key) {
	  return !! (
	    this.hasLocale(locale) &&
	          this.container[locale].messages &&
	          this.container[locale].messages[key]
	  );
	};
	
	Dictionary.prototype.hasAttribute = function hasAttribute (locale, key) {
	  return !! (
	    this.hasLocale(locale) &&
	          this.container[locale].attributes &&
	          this.container[locale].attributes[key]
	  );
	};
	
	Dictionary.prototype.merge = function merge (dictionary) {
	  this._merge(this.container, dictionary);
	};
	
	Dictionary.prototype.setMessage = function setMessage (locale, key, message) {
	  if (! this.hasLocale(locale)) {
	    this.container[locale] = {
	      messages: {},
	      attributes: {}
	    };
	  }
	
	  this.container[locale].messages[key] = message;
	};
	
	Dictionary.prototype.setAttribute = function setAttribute (locale, key, attribute) {
	  if (! this.hasLocale(locale)) {
	    this.container[locale] = {
	      messages: {},
	      attributes: {}
	    };
	  }
	
	  this.container[locale].attributes[key] = attribute;
	};
	
	Dictionary.prototype._merge = function _merge (target, source) {
	    var this$1 = this;
	
	  if (! (isObject(target) && isObject(source))) {
	    return target;
	  }
	
	  Object.keys(source).forEach(function (key) {
	    if (isObject(source[key])) {
	      if (! target[key]) {
	        assign(target, ( obj = {}, obj[key] = {}, obj ));
	          var obj;
	      }
	
	      this$1._merge(target[key], source[key]);
	      return;
	    }
	
	    assign(target, ( obj$1 = {}, obj$1[key] = source[key], obj$1 ));
	      var obj$1;
	  });
	
	  return target;
	};
	
	/**
	 * Formates file size.
	 *
	 * @param {Number|String} size
	 */
	var formatFileSize = function (size) {
	  var units = ['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
	  var threshold = 1024;
	  size = Number(size) * threshold;
	  var i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(threshold));
	  return (((size / Math.pow(threshold, i)).toFixed(2) * 1) + " " + (units[i]));
	};
	
	/**
	 * Checks if vee-validate is defined globally.
	 */
	var isDefinedGlobally = function () {
	  return typeof VeeValidate !== 'undefined';
	};
	
	var messages = {
	  _default: function (field) { return ("The " + field + " value is not valid."); },
	  after: function (field, ref) {
	    var target = ref[0];
	    var inclusion = ref[1];
	
	    return ("The " + field + " must be after " + (inclusion ? 'or equal to ' : '') + target + ".");
	},
	  alpha_dash: function (field) { return ("The " + field + " field may contain alpha-numeric characters as well as dashes and underscores."); },
	  alpha_num: function (field) { return ("The " + field + " field may only contain alpha-numeric characters."); },
	  alpha_spaces: function (field) { return ("The " + field + " field may only contain alphabetic characters as well as spaces."); },
	  alpha: function (field) { return ("The " + field + " field may only contain alphabetic characters."); },
	  before: function (field, ref) {
	    var target = ref[0];
	    var inclusion = ref[1];
	
	    return ("The " + field + " must be before " + (inclusion ? 'or equal to ' : '') + target + ".");
	},
	  between: function (field, ref) {
	    var min = ref[0];
	    var max = ref[1];
	
	    return ("The " + field + " field must be between " + min + " and " + max + ".");
	},
	  confirmed: function (field) { return ("The " + field + " confirmation does not match."); },
	  credit_card: function (field) { return ("The " + field + " field is invalid."); },
	  date_between: function (field, ref) {
	    var min = ref[0];
	    var max = ref[1];
	
	    return ("The " + field + " must be between " + min + " and " + max + ".");
	},
	  date_format: function (field, ref) {
	    var format = ref[0];
	
	    return ("The " + field + " must be in the format " + format + ".");
	},
	  decimal: function (field, ref) {
	    if ( ref === void 0 ) ref = ['*'];
	    var decimals = ref[0];
	
	    return ("The " + field + " field must be numeric and may contain " + (!decimals || decimals === '*' ? '' : decimals) + " decimal points.");
	},
	  digits: function (field, ref) {
	    var length = ref[0];
	
	    return ("The " + field + " field must be numeric and exactly contain " + length + " digits.");
	},
	  dimensions: function (field, ref) {
	    var width = ref[0];
	    var height = ref[1];
	
	    return ("The " + field + " field must be " + width + " pixels by " + height + " pixels.");
	},
	  email: function (field) { return ("The " + field + " field must be a valid email."); },
	  ext: function (field) { return ("The " + field + " field must be a valid file."); },
	  image: function (field) { return ("The " + field + " field must be an image."); },
	  in: function (field) { return ("The " + field + " field must be a valid value."); },
	  integer: function (field) { return ("The " + field + " field must be an integer."); },
	  ip: function (field) { return ("The " + field + " field must be a valid ip address."); },
	  length: function (field, ref) {
	    var length = ref[0];
	    var max = ref[1];
	
	    if (max) {
	      return ("The " + field + " length be between " + length + " and " + max + ".");
	    }
	
	    return ("The " + field + " length must be " + length + ".");
	  },
	  max: function (field, ref) {
	    var length = ref[0];
	
	    return ("The " + field + " field may not be greater than " + length + " characters.");
	},
	  max_value: function (field, ref) {
	    var max = ref[0];
	
	    return ("The " + field + " field must be " + max + " or less.");
	},
	  mimes: function (field) { return ("The " + field + " field must have a valid file type."); },
	  min: function (field, ref) {
	    var length = ref[0];
	
	    return ("The " + field + " field must be at least " + length + " characters.");
	},
	  min_value: function (field, ref) {
	    var min = ref[0];
	
	    return ("The " + field + " field must be " + min + " or more.");
	},
	  not_in: function (field) { return ("The " + field + " field must be a valid value."); },
	  numeric: function (field) { return ("The " + field + " field may only contain numeric characters."); },
	  regex: function (field) { return ("The " + field + " field format is invalid."); },
	  required: function (field) { return ("The " + field + " field is required."); },
	  size: function (field, ref) {
	    var size = ref[0];
	
	    return ("The " + field + " size must be less than " + (formatFileSize(size)) + ".");
	},
	  url: function (field) { return ("The " + field + " field is not a valid URL."); }
	};
	
	var locale$1 = {
	  name: 'en',
	  messages: messages,
	  attributes: {}
	};
	
	if (isDefinedGlobally()) {
	  // eslint-disable-next-line
	  VeeValidate.Validator.addLocale(locale$1);
	}
	
	/**
	 * Generates the options required to construct a field.
	 */
	var Generator = function Generator () {};
	
	Generator.generate = function generate (el, binding, vnode, options) {
	    if ( options === void 0 ) options = {};
	
	  var model = Generator.resolveModel(binding, vnode);
	
	  return {
	    name: Generator.resolveName(el, vnode),
	    el: el,
	    listen: !binding.modifiers.disable,
	    scope: Generator.resolveScope(el, binding, vnode),
	    vm: Generator.makeVM(vnode.context),
	    expression: binding.value,
	    component: vnode.child,
	    classes: options.classes,
	    classNames: options.classNames,
	    getter: Generator.resolveGetter(el, vnode, model),
	    events: Generator.resolveEvents(el, vnode) || options.events,
	    model: model,
	    delay: Generator.resolveDelay(el, vnode, options),
	    rules: Generator.resolveRules(el, binding),
	    initial: !!binding.modifiers.initial,
	    alias: Generator.resolveAlias(el, vnode),
	    validity: options.validity,
	    aria: options.aria,
	    initialValue: Generator.resolveInitialValue(vnode)
	  };
	};
	
	/**
	 *
	 * @param {*} el
	 * @param {*} binding
	 */
	Generator.resolveRules = function resolveRules (el, binding) {
	  if (!binding || !binding.expression) {
	    return getDataAttribute(el, 'rules');
	  }
	
	  if (typeof binding.value === 'string') {
	    return binding.value;
	  }
	
	  if (~['string', 'object'].indexOf(typeof binding.value.rules)) {
	    return binding.value.rules;
	  }
	
	  return binding.value;
	};
	
	/**
	 * @param {*} vnode
	 */
	Generator.resolveInitialValue = function resolveInitialValue (vnode) {
	  var model = vnode.data.model || find(vnode.data.directives, function (d) { return d.name === 'model'; });
	
	  return model && model.value;
	};
	
	/**
	 * Creates a non-circular partial VM instance from a Vue instance.
	 * @param {*} vm
	 */
	Generator.makeVM = function makeVM (vm) {
	  return {
	    get $el () {
	      return vm.$el;
	    },
	    get $refs () {
	      return vm.$refs;
	    },
	    $watch: vm.$watch ? vm.$watch.bind(vm) : function () {},
	    $validator: vm.$validator ? {
	      errors: vm.$validator.errors,
	      validate: vm.$validator.validate.bind(vm.$validator),
	      update: vm.$validator.update.bind(vm.$validator)
	    } : null
	  };
	};
	
	/**
	 * Resolves the delay value.
	 * @param {*} el
	 * @param {*} vnode
	 * @param {Object} options
	 */
	Generator.resolveDelay = function resolveDelay (el, vnode, options) {
	    if ( options === void 0 ) options = {};
	
	  return getDataAttribute(el, 'delay') || (vnode.child && vnode.child.$attrs && vnode.child.$attrs['data-vv-delay']) || options.delay;
	};
	
	/**
	 * Resolves the alias for the field.
	 * @param {*} el
	 * @param {*} vnode
	 * @return {Function} alias getter
	 */
	Generator.resolveAlias = function resolveAlias (el, vnode) {
	  return function () { return getDataAttribute(el, 'as') || (vnode.child && vnode.child.$attrs && vnode.child.$attrs['data-vv-as']) || el.title || null; };
	};
	
	/**
	 * Resolves the events to validate in response to.
	 * @param {*} el
	 * @param {*} vnode
	 */
	Generator.resolveEvents = function resolveEvents (el, vnode) {
	  if (vnode.child) {
	    return getDataAttribute(el, 'validate-on') || (vnode.child.$attrs && vnode.child.$attrs['data-vv-validate-on']);
	  }
	
	  return getDataAttribute(el, 'validate-on');
	};
	
	/**
	 * Resolves the scope for the field.
	 * @param {*} el
	 * @param {*} binding
	 */
	Generator.resolveScope = function resolveScope (el, binding, vnode) {
	    if ( vnode === void 0 ) vnode = {};
	
	  var scope = null;
	  if (isObject(binding.value)) {
	    scope = binding.value.scope;
	  }
	
	  if (vnode.child && isNullOrUndefined(scope)) {
	    scope = vnode.child.$attrs && vnode.child.$attrs['data-vv-scope'];
	  }
	
	  return !isNullOrUndefined(scope) ? scope : getScope(el);
	};
	
	/**
	 * Checks if the node directives contains a v-model or a specified arg.
	 * Args take priority over models.
	 *
	 * @return {Object}
	 */
	Generator.resolveModel = function resolveModel (binding, vnode) {
	  if (binding.arg) {
	    return binding.arg;
	  }
	
	  if (isObject(binding.value) && binding.value.arg) {
	    return binding.value.arg;
	  }
	
	  var model = vnode.data.model || find(vnode.data.directives, function (d) { return d.name === 'model'; });
	  if (!model) {
	    return null;
	  }
	
	  var watchable = /^[a-z_]+[0-9]*(\w*\.[a-z_]\w*)*$/i.test(model.expression) && hasPath(model.expression, vnode.context);
	
	  if (!watchable) {
	    return null;
	  }
	
	  return model.expression;
	};
	
	/**
	   * Resolves the field name to trigger validations.
	   * @return {String} The field name.
	   */
	Generator.resolveName = function resolveName (el, vnode) {
	  if (vnode.child) {
	    return getDataAttribute(el, 'name') || (vnode.child.$attrs && (vnode.child.$attrs['data-vv-name'] || vnode.child.$attrs['name'])) || vnode.child.name;
	  }
	
	  return getDataAttribute(el, 'name') || el.name;
	};
	
	/**
	 * Returns a value getter input type.
	 */
	Generator.resolveGetter = function resolveGetter (el, vnode, model) {
	  if (model) {
	    return function () {
	      return getPath(model, vnode.context);
	    };
	  }
	
	  if (vnode.child) {
	    return function () {
	      var path = getDataAttribute(el, 'value-path') || (vnode.child.$attrs && vnode.child.$attrs['data-vv-value-path']);
	      if (path) {
	        return getPath(path, vnode.child);
	      }
	      return vnode.child.value;
	    };
	  }
	
	  switch (el.type) {
	  case 'checkbox': return function () {
	    var els = document.querySelectorAll(("input[name=\"" + (el.name) + "\"]"));
	
	    els = toArray(els).filter(function (el) { return el.checked; });
	    if (!els.length) { return undefined; }
	
	    return els.map(function (checkbox) { return checkbox.value; });
	  };
	  case 'radio': return function () {
	    var els = document.querySelectorAll(("input[name=\"" + (el.name) + "\"]"));
	    var elm = find(els, function (el) { return el.checked; });
	
	    return elm && elm.value;
	  };
	  case 'file': return function (context) {
	    return toArray(el.files);
	  };
	  case 'select-multiple': return function () {
	    return toArray(el.options).filter(function (opt) { return opt.selected; }).map(function (opt) { return opt.value; });
	  };
	  default: return function () {
	    return el && el.value;
	  };
	  }
	};
	
	var DEFAULT_OPTIONS = {
	  targetOf: null,
	  initial: false,
	  scope: null,
	  listen: true,
	  name: null,
	  active: true,
	  required: false,
	  rules: {},
	  vm: null,
	  classes: false,
	  validity: true,
	  aria: true,
	  events: 'input|blur',
	  delay: 0,
	  classNames: {
	    touched: 'touched', // the control has been blurred
	    untouched: 'untouched', // the control hasn't been blurred
	    valid: 'valid', // model is valid
	    invalid: 'invalid', // model is invalid
	    pristine: 'pristine', // control has not been interacted with
	    dirty: 'dirty' // control has been interacted with
	  }
	};
	
	var Field = function Field (el, options) {
	  if ( options === void 0 ) options = {};
	
	  this.id = uniqId();
	  this.el = el;
	  this.updated = false;
	  this.dependencies = [];
	  this.watchers = [];
	  this.events = [];
	  this.rules = {};
	  if (!this.isHeadless && !options.targetOf) {
	    setDataAttribute(this.el, 'id', this.id); // cache field id if it is independent and has a root element.
	  }
	  options = assign({}, DEFAULT_OPTIONS, options);
	  this.validity = options.validity;
	  this.aria = options.aria;
	  this.flags = createFlags();
	  this.vm = options.vm;
	  this.component = options.component;
	  this.update(options);
	  this.updated = false;
	};
	
	var prototypeAccessors$1 = { isVue: {},validator: {},isRequired: {},isDisabled: {},isHeadless: {},displayName: {},value: {},rejectsFalse: {} };
	
	prototypeAccessors$1.isVue.get = function () {
	  return !!this.component;
	};
	
	prototypeAccessors$1.validator.get = function () {
	  if (!this.vm || !this.vm.$validator) {
	    warn('No validator instance detected.');
	    return { validate: function () {} };
	  }
	
	  return this.vm.$validator;
	};
	
	prototypeAccessors$1.isRequired.get = function () {
	  return !!this.rules.required;
	};
	
	prototypeAccessors$1.isDisabled.get = function () {
	  return (this.isVue && this.component.disabled) || (this.el && this.el.disabled);
	};
	
	prototypeAccessors$1.isHeadless.get = function () {
	  return !this.el;
	};
	
	/**
	 * Gets the display name (user-friendly name).
	 * @return {String}
	 */
	prototypeAccessors$1.displayName.get = function () {
	  return isCallable(this.alias) ? this.alias() : this.alias;
	};
	
	/**
	 * Gets the input value.
	 * @return {*}
	 */
	prototypeAccessors$1.value.get = function () {
	  if (!isCallable(this.getter)) {
	    return undefined;
	  }
	
	  return this.getter();
	};
	
	/**
	 * If the field rejects false as a valid value for the required rule.
	 */
	prototypeAccessors$1.rejectsFalse.get = function () {
	  if (this.isVue || this.isHeadless) {
	    return false;
	  }
	
	  return this.el.type === 'checkbox';
	};
	
	/**
	 * Determines if the instance matches the options provided.
	 * @param {Object} options The matching options.
	 */
	Field.prototype.matches = function matches (options) {
	  if (options.id) {
	    return this.id === options.id;
	  }
	
	  if (options.name === undefined && options.scope === undefined) {
	    return true;
	  }
	
	  if (options.scope === undefined) {
	    return this.name === options.name;
	  }
	
	  if (options.name === undefined) {
	    return this.scope === options.scope;
	  }
	
	  return options.name === this.name && options.scope === this.scope;
	};
	
	/**
	 *
	 * @param {Object} options
	 */
	Field.prototype.update = function update (options) {
	  this.targetOf = options.targetOf || null;
	  this.initial = options.initial || this.initial || false;
	
	  // update errors scope if the field scope was changed.
	  if (this.updated && !isNullOrUndefined(options.scope) && options.scope !== this.scope && isCallable(this.validator.update)) {
	    this.validator.update(this.id, { scope: options.scope });
	  }
	  this.scope = !isNullOrUndefined(options.scope) ? options.scope
	    : !isNullOrUndefined(this.scope) ? this.scope : null;
	  this.name = (!isNullOrUndefined(options.name) ? String(options.name) : options.name) || this.name || null;
	  this.rules = options.rules !== undefined ? normalizeRules(options.rules) : this.rules;
	  this.model = options.model || this.model;
	  this.listen = options.listen !== undefined ? options.listen : this.listen;
	  this.classes = options.classes || this.classes || false;
	  this.classNames = options.classNames || this.classNames || DEFAULT_OPTIONS.classNames;
	  this.alias = options.alias || this.alias;
	  this.getter = isCallable(options.getter) ? options.getter : this.getter;
	  this.delay = options.delay || this.delay || 0;
	  this.events = typeof options.events === 'string' && options.events.length ? options.events.split('|') : this.events;
	  this.updateDependencies();
	  this.addActionListeners();
	
	  // update required flag flags
	  if (options.rules !== undefined) {
	    this.flags.required = this.isRequired;
	  }
	
	  // validate if it was validated before and field was updated and there was a rules mutation.
	  if (this.flags.validated && options.rules !== undefined && this.updated) {
	    this.validator.validate(("#" + (this.id)));
	  }
	
	  this.updated = true;
	
	  // no need to continue.
	  if (this.isHeadless) {
	    return;
	  }
	
	  this.updateClasses();
	  this.addValueListeners();
	  this.updateAriaAttrs();
	};
	
	/**
	 * Resets field flags and errors.
	 */
	Field.prototype.reset = function reset () {
	    var this$1 = this;
	
	  var def = createFlags();
	  Object.keys(this.flags).forEach(function (flag) {
	    this$1.flags[flag] = def[flag];
	  });
	
	  this.addActionListeners();
	  this.updateClasses();
	  if (this.validator.errors && isCallable(this.validator.errors.removeById)) {
	    this.validator.errors.removeById(this.id);
	  }
	};
	
	/**
	 * Sets the flags and their negated counterparts, and updates the classes and re-adds action listeners.
	 * @param {Object} flags
	 */
	Field.prototype.setFlags = function setFlags (flags) {
	    var this$1 = this;
	
	  var negated = {
	    pristine: 'dirty',
	    dirty: 'pristine',
	    valid: 'invalid',
	    invalid: 'valid',
	    touched: 'untouched',
	    untouched: 'touched'
	  };
	
	  Object.keys(flags).forEach(function (flag) {
	    this$1.flags[flag] = flags[flag];
	    // if it has a negation and was not specified, set it as well.
	    if (negated[flag] && flags[negated[flag]] === undefined) {
	      this$1.flags[negated[flag]] = !flags[flag];
	    }
	  });
	
	  if (
	    flags.untouched !== undefined ||
	    flags.touched !== undefined ||
	    flags.dirty !== undefined ||
	    flags.pristine !== undefined
	  ) {
	    this.addActionListeners();
	  }
	  this.updateClasses();
	  this.updateAriaAttrs();
	  this.updateCustomValidity();
	};
	
	/**
	 * Determines if the field requires references to target fields.
	*/
	Field.prototype.updateDependencies = function updateDependencies () {
	    var this$1 = this;
	
	  // reset dependencies.
	  this.dependencies.forEach(function (d) { return d.field.destroy(); });
	  this.dependencies = [];
	
	  // we get the selectors for each field.
	  var fields = Object.keys(this.rules).reduce(function (prev, r) {
	    if (r === 'confirmed') {
	      prev.push({ selector: this$1.rules[r][0] || ((this$1.name) + "_confirmation"), name: r });
	    } else if (/after|before/.test(r)) {
	      prev.push({ selector: this$1.rules[r][0], name: r });
	    }
	
	    return prev;
	  }, []);
	
	  if (!fields.length || !this.vm || !this.vm.$el) { return; }
	
	  // must be contained within the same component, so we use the vm root element constrain our dom search.
	  fields.forEach(function (ref) {
	      var selector = ref.selector;
	      var name = ref.name;
	
	    var el = null;
	    // vue ref selector.
	    if (selector[0] === '$') {
	      el = this$1.vm.$refs[selector.slice(1)];
	    } else {
	      try {
	        // try query selector
	        el = this$1.vm.$el.querySelector(selector);
	      } catch (err) {
	        el = null;
	      }
	    }
	
	    if (!el) {
	      el = this$1.vm.$el.querySelector(("input[name=\"" + selector + "\"]"));
	    }
	
	    if (!el) {
	      return;
	    }
	
	    var options = {
	      vm: this$1.vm,
	      classes: this$1.classes,
	      classNames: this$1.classNames,
	      delay: this$1.delay,
	      scope: this$1.scope,
	      events: this$1.events.join('|'),
	      initial: this$1.initial,
	      targetOf: this$1.id
	    };
	
	    // probably a component.
	    if (isCallable(el.$watch)) {
	      options.component = el;
	      options.el = el.$el;
	      options.alias = Generator.resolveAlias(el.$el, { child: el });
	      options.getter = Generator.resolveGetter(el.$el, { child: el });
	    } else {
	      options.el = el;
	      options.alias = Generator.resolveAlias(el, {});
	      options.getter = Generator.resolveGetter(el, {});
	    }
	
	    this$1.dependencies.push({ name: name, field: new Field(options.el, options) });
	  });
	};
	
	/**
	 * Removes listeners.
	 * @param {RegExp} tag
	 */
	Field.prototype.unwatch = function unwatch (tag) {
	    if ( tag === void 0 ) tag = null;
	
	  if (!tag) {
	    this.watchers.forEach(function (w) { return w.unwatch(); });
	    this.watchers = [];
	    return;
	  }
	  this.watchers.filter(function (w) { return tag.test(w.tag); }).forEach(function (w) { return w.unwatch(); });
	  this.watchers = this.watchers.filter(function (w) { return !tag.test(w.tag); });
	};
	
	/**
	 * Updates the element classes depending on each field flag status.
	 */
	Field.prototype.updateClasses = function updateClasses () {
	  if (!this.classes) { return; }
	
	  toggleClass(this.el, this.classNames.dirty, this.flags.dirty);
	  toggleClass(this.el, this.classNames.pristine, this.flags.pristine);
	  toggleClass(this.el, this.classNames.valid, !!this.flags.valid);
	  toggleClass(this.el, this.classNames.invalid, !!this.flags.invalid);
	  toggleClass(this.el, this.classNames.touched, this.flags.touched);
	  toggleClass(this.el, this.classNames.untouched, this.flags.untouched);
	};
	
	/**
	 * Adds the listeners required for automatic classes and some flags.
	 */
	Field.prototype.addActionListeners = function addActionListeners () {
	    var this$1 = this;
	
	  // remove previous listeners.
	  this.unwatch(/class/);
	
	  var onBlur = function () {
	    this$1.flags.touched = true;
	    this$1.flags.untouched = false;
	    if (this$1.classes) {
	      toggleClass(this$1.el, this$1.classNames.touched, true);
	      toggleClass(this$1.el, this$1.classNames.untouched, false);
	    }
	
	    // only needed once.
	    this$1.unwatch(/^class_blur$/);
	  };
	
	  var inputEvent = getInputEventName(this.el);
	  var onInput = function () {
	    this$1.flags.dirty = true;
	    this$1.flags.pristine = false;
	    if (this$1.classes) {
	      toggleClass(this$1.el, this$1.classNames.pristine, false);
	      toggleClass(this$1.el, this$1.classNames.dirty, true);
	    }
	
	    // only needed once.
	    this$1.unwatch(/^class_input$/);
	  };
	
	  if (this.isVue && isCallable(this.component.$once)) {
	    this.component.$once('input', onInput);
	    this.component.$once('blur', onBlur);
	    this.watchers.push({
	      tag: 'class_input',
	      unwatch: function () {
	        this$1.component.$off('input', onInput);
	      }
	    });
	    this.watchers.push({
	      tag: 'class_blur',
	      unwatch: function () {
	        this$1.component.$off('blur', onBlur);
	      }
	    });
	    return;
	  }
	
	  if (this.isHeadless) { return; }
	
	  this.el.addEventListener(inputEvent, onInput);
	  // Checkboxes and radio buttons on Mac don't emit blur naturally, so we listen on click instead.
	  var blurEvent = ['radio', 'checkbox'].indexOf(this.el.type) === -1 ? 'blur' : 'click';
	  this.el.addEventListener(blurEvent, onBlur);
	  this.watchers.push({
	    tag: 'class_input',
	    unwatch: function () {
	      this$1.el.removeEventListener(inputEvent, onInput);
	    }
	  });
	
	  this.watchers.push({
	    tag: 'class_blur',
	    unwatch: function () {
	      this$1.el.removeEventListener(blurEvent, onBlur);
	    }
	  });
	};
	
	/**
	 * Adds the listeners required for validation.
	 */
	Field.prototype.addValueListeners = function addValueListeners () {
	    var this$1 = this;
	
	  this.unwatch(/^input_.+/);
	  if (!this.listen) { return; }
	
	  var fn = this.targetOf ? function () {
	    this$1.validator.validate(("#" + (this$1.targetOf)));
	  } : function () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	    // if its a DOM event, resolve the value, otherwise use the first parameter as the value.
	    if (args.length === 0 || (isCallable(Event) && args[0] instanceof Event) || args[0].srcElement) {
	      args[0] = this$1.value;
	    }
	    this$1.validator.validate(("#" + (this$1.id)), args[0]);
	  };
	
	  var validate = debounce(fn, this.delay);
	  var inputEvent = getInputEventName(this.el);
	  // replace input event with suitable one.
	  var events = this.events.map(function (e) {
	    return e === 'input' ? inputEvent : e;
	  });
	
	  // if there is a watchable model and an on input validation is requested.
	  if (this.model && events.indexOf(inputEvent) !== -1) {
	    var unwatch = this.vm.$watch(this.model, validate);
	    this.watchers.push({
	      tag: 'input_model',
	      unwatch: unwatch
	    });
	    // filter out input event as it is already handled by the watcher API.
	    events = events.filter(function (e) { return e !== inputEvent; });
	  }
	
	  // Add events.
	  events.forEach(function (e) {
	    if (this$1.isVue) {
	      this$1.component.$on(e, validate);
	      this$1.watchers.push({
	        tag: 'input_vue',
	        unwatch: function () {
	          this$1.component.$off(e, validate);
	        }
	      });
	      return;
	    }
	
	    if (~['radio', 'checkbox'].indexOf(this$1.el.type)) {
	      var els = document.querySelectorAll(("input[name=\"" + (this$1.el.name) + "\"]"));
	      toArray(els).forEach(function (el) {
	        el.addEventListener(e, validate);
	        this$1.watchers.push({
	          tag: 'input_native',
	          unwatch: function () {
	            el.removeEventListener(e, validate);
	          }
	        });
	      });
	
	      return;
	    }
	
	    this$1.el.addEventListener(e, validate);
	    this$1.watchers.push({
	      tag: 'input_native',
	      unwatch: function () {
	        this$1.el.removeEventListener(e, validate);
	      }
	    });
	  });
	};
	
	/**
	 * Updates aria attributes on the element.
	 */
	Field.prototype.updateAriaAttrs = function updateAriaAttrs () {
	  if (!this.aria || this.isHeadless || !isCallable(this.el.setAttribute)) { return; }
	
	  this.el.setAttribute('aria-required', this.isRequired ? 'true' : 'false');
	  this.el.setAttribute('aria-invalid', this.flags.invalid ? 'true' : 'false');
	};
	
	/**
	 * Updates the custom validity for the field.
	 */
	Field.prototype.updateCustomValidity = function updateCustomValidity () {
	  if (!this.validity || this.isHeadless || !isCallable(this.el.setCustomValidity)) { return; }
	
	  this.el.setCustomValidity(this.flags.valid ? '' : (this.validator.errors.firstById(this.id) || ''));
	};
	
	/**
	 * Removes all listeners.
	 */
	Field.prototype.destroy = function destroy () {
	  this.watchers.forEach(function (w) { return w.unwatch(); });
	  this.watchers = [];
	  this.dependencies.forEach(function (d) { return d.field.destroy(); });
	  this.dependencies = [];
	};
	
	Object.defineProperties( Field.prototype, prototypeAccessors$1 );
	
	var FieldBag = function FieldBag () {
	  this.items = [];
	};
	
	var prototypeAccessors$2 = { length: {} };
	
	/**
	 * @return {Number} The current collection length.
	 */
	prototypeAccessors$2.length.get = function () {
	  return this.items.length;
	};
	
	/**
	 * Finds the first field that matches the provided matcher object.
	 * @param {Object} matcher
	 * @return {Field|undefined} The first matching item.
	 */
	FieldBag.prototype.find = function find$1 (matcher) {
	  return find(this.items, function (item) { return item.matches(matcher); });
	};
	
	/**
	 * @param {Object|Array} matcher
	 * @return {Array} Array of matching field items.
	 */
	FieldBag.prototype.filter = function filter (matcher) {
	  // multiple matchers to be tried.
	  if (Array.isArray(matcher)) {
	    return this.items.filter(function (item) { return matcher.some(function (m) { return item.matches(m); }); });
	  }
	
	  return this.items.filter(function (item) { return item.matches(matcher); });
	};
	
	/**
	 * Maps the field items using the mapping function.
	 *
	 * @param {Function} mapper
	 */
	FieldBag.prototype.map = function map (mapper) {
	  return this.items.map(mapper);
	};
	
	/**
	 * Finds and removes the first field that matches the provided matcher object, returns the removed item.
	 * @param {Object|Field} matcher
	 * @return {Field|null}
	 */
	FieldBag.prototype.remove = function remove (matcher) {
	  var item = null;
	  if (matcher instanceof Field) {
	    item = matcher;
	  } else {
	    item = this.find(matcher);
	  }
	
	  if (!item) { return null; }
	
	  var index = this.items.indexOf(item);
	  this.items.splice(index, 1);
	
	  return item;
	};
	
	/**
	 * Adds a field item to the list.
	 *
	 * @param {Field} item
	 */
	FieldBag.prototype.push = function push (item) {
	  if (! (item instanceof Field)) {
	    throw createError('FieldBag only accepts instances of Field that has an id defined.');
	  }
	
	  if (!item.id) {
	    throw createError('Field id must be defined.');
	  }
	
	  if (this.find({ id: item.id })) {
	    throw createError(("Field with id " + (item.id) + " is already added."));
	  }
	
	  this.items.push(item);
	};
	
	Object.defineProperties( FieldBag.prototype, prototypeAccessors$2 );
	
	var RULES = {};
	var LOCALE = 'en';
	var STRICT_MODE = true;
	var DICTIONARY = new Dictionary({
	  en: {
	    messages: messages,
	    attributes: {},
	    custom: {}
	  }
	});
	
	var Validator = function Validator (validations, options) {
	  var this$1 = this;
	  if ( options === void 0 ) options = { vm: null, fastExit: true };
	
	  this.strict = STRICT_MODE;
	  this.errors = new ErrorBag();
	  this.fields = new FieldBag();
	  this.flags = {};
	  this._createFields(validations);
	  this.paused = false;
	  this.fastExit = options.fastExit || false;
	  this.ownerId = options.vm && options.vm._uid;
	  // create it statically since we don't need constant access to the vm.
	  this.reset = options.vm && isCallable(options.vm.$nextTick) ? function () {
	    options.vm.$nextTick(function () {
	      this$1.fields.items.forEach(function (i) { return i.reset(); });
	      this$1.errors.clear();
	    });
	  } : function () {
	    this$1.fields.items.forEach(function (i) { return i.reset(); });
	    this$1.errors.clear();
	  };
	  /* istanbul ignore next */
	  this.clean = function () {
	    warn('validator.clean is marked for deprecation, please use validator.reset instead.');
	    this$1.reset();
	  };
	};
	
	var prototypeAccessors = { dictionary: {},locale: {},rules: {} };
	var staticAccessors = { dictionary: {},locale: {},rules: {} };
	
	/**
	 * @return {Dictionary}
	 */
	prototypeAccessors.dictionary.get = function () {
	  return DICTIONARY;
	};
	
	/**
	 * @return {Dictionary}
	 */
	staticAccessors.dictionary.get = function () {
	  return DICTIONARY;
	};
	
	/**
	 * @return {String}
	 */
	prototypeAccessors.locale.get = function () {
	  return LOCALE;
	};
	
	/**
	 * @param {String} value
	 */
	prototypeAccessors.locale.set = function (value) {
	  Validator.locale = value;
	};
	
	/**
	* @return {String}
	*/
	staticAccessors.locale.get = function () {
	  return LOCALE;
	};
	
	/**
	 * @param {String} value
	 */
	staticAccessors.locale.set = function (value) {
	  /* istanbul ignore if */
	  if (!DICTIONARY.hasLocale(value)) {
	    // eslint-disable-next-line
	    warn('You are setting the validator locale to a locale that is not defined in the dictionary. English messages may still be generated.');
	  }
	
	  LOCALE = value;
	};
	
	/**
	 * @return {Object}
	 */
	prototypeAccessors.rules.get = function () {
	  return RULES;
	};
	
	/**
	 * @return {Object}
	 */
	staticAccessors.rules.get = function () {
	  return RULES;
	};
	
	/**
	 * Static constructor.
	 *
	 * @param{object} validations The validations object.
	 * @return {Validator} validator A validator object.
	 */
	Validator.create = function create (validations, options) {
	  return new Validator(validations, options);
	};
	
	/**
	 * Adds a custom validator to the list of validation rules.
	 *
	 * @param{string} name The name of the validator.
	 * @param{object|function} validator The validator object/function.
	 */
	Validator.extend = function extend (name, validator) {
	  Validator._guardExtend(name, validator);
	  Validator._merge(name, validator);
	};
	
	/**
	 * Removes a rule from the list of validators.
	 * @param {String} name The name of the validator/rule.
	 */
	Validator.remove = function remove (name) {
	  delete RULES[name];
	};
	
	/**
	 * Sets the default locale for all validators.
	 * @deprecated
	 * @param {String} language The locale id.
	 */
	Validator.setLocale = function setLocale (language) {
	    if ( language === void 0 ) language = 'en';
	
	  Validator.locale = language;
	};
	
	/**
	 * @deprecated
	 */
	Validator.installDateTimeValidators = function installDateTimeValidators () {
	  /* istanbul ignore next */
	  warn('Date validations are now installed by default, you no longer need to install it.');
	};
	
	/**
	 * @deprecated
	 */
	Validator.prototype.installDateTimeValidators = function installDateTimeValidators () {
	  /* istanbul ignore next */
	  warn('Date validations are now installed by default, you no longer need to install it.');
	};
	
	/**
	 * Sets the operating mode for all newly created validators.
	 * strictMode = true: Values without a rule are invalid and cause failure.
	 * strictMode = false: Values without a rule are valid and are skipped.
	 * @param {Boolean} strictMode.
	 */
	Validator.setStrictMode = function setStrictMode (strictMode) {
	    if ( strictMode === void 0 ) strictMode = true;
	
	  STRICT_MODE = strictMode;
	};
	
	/**
	 * Updates the dictionary, overwriting existing values and adding new ones.
	 * @deprecated
	 * @param{object} data The dictionary object.
	 */
	Validator.updateDictionary = function updateDictionary (data) {
	  DICTIONARY.merge(data);
	};
	
	/**
	 * Adds a locale object to the dictionary.
	 * @deprecated
	 * @param {Object} locale
	 */
	Validator.addLocale = function addLocale (locale) {
	  if (! locale.name) {
	    warn('Your locale must have a name property');
	    return;
	  }
	
	  this.updateDictionary(( obj = {}, obj[locale.name] = locale, obj ));
	    var obj;
	};
	
	/**
	 * Adds a locale object to the dictionary.
	 * @deprecated
	 * @param {Object} locale
	 */
	Validator.prototype.addLocale = function addLocale (locale) {
	  Validator.addLocale(locale);
	};
	
	/**
	 * Adds and sets the current locale for the validator.
	 *
	 * @param {String} lang
	 * @param {Object} dictionary
	 */
	Validator.prototype.localize = function localize (lang, dictionary) {
	  Validator.localize(lang, dictionary);
	};
	
	/**
	 * Adds and sets the current locale for the validator.
	 *
	 * @param {String} lang
	 * @param {Object} dictionary
	 */
	Validator.localize = function localize (lang, dictionary) {
	  // merge the dictionary.
	  if (dictionary) {
	    dictionary = assign({}, dictionary, { name: lang });
	    Validator.addLocale(dictionary);
	  }
	
	  // set the locale.
	  Validator.locale = lang;
	};
	
	/**
	 * Registers a field to be validated.
	 *
	 * @param{Field|Object} name The field name.
	 * @return {Field}
	 */
	Validator.prototype.attach = function attach (field) {
	  // deprecate: handle old signature.
	  if (arguments.length > 1) {
	    field = assign({}, {
	      name: arguments[0],
	      rules: arguments[1]
	    }, arguments[2] || { vm: { $validator: this } });
	  }
	
	  // fixes initial value detection with v-model and select elements.
	  var value = field.initialValue;
	  if (!(field instanceof Field)) {
	    field = new Field(field.el || null, field);
	  }
	
	  this.fields.push(field);
	
	  // validate the field initially
	  if (field.initial) {
	    this.validate(("#" + (field.id)), value || field.value);
	  } else {
	    this._validate(field, value || field.value, true).then(function (valid) {
	      field.flags.valid = valid;
	      field.flags.invalid = !valid;
	    });
	  }
	
	  this._addFlag(field, field.scope);
	  return field;
	};
	
	/**
	 * Sets the flags on a field.
	 *
	 * @param {String} name
	 * @param {Object} flags
	 */
	Validator.prototype.flag = function flag (name, flags) {
	  var field = this._resolveField(name);
	  if (! field || !flags) {
	    return;
	  }
	
	  field.setFlags(flags);
	};
	
	/**
	 * Removes a field from the validator.
	 *
	 * @param{String} name The name of the field.
	 * @param {String} scope The name of the field scope.
	 */
	Validator.prototype.detach = function detach (name, scope) {
	  var field = name instanceof Field ? name : this._resolveField(name, scope);
	  if (!field) { return; }
	
	  field.destroy();
	  this.errors.remove(field.name, field.scope, field.id);
	  this.fields.remove(field);
	  var flags = this.flags;
	  if (!isNullOrUndefined(field.scope) && flags[("$" + (field.scope))]) {
	    delete flags[("$" + (field.scope))][field.name];
	  } else if (isNullOrUndefined(field.scope)) {
	    delete flags[field.name];
	  }
	
	  this.flags = assign({}, flags);
	};
	
	/**
	 * Adds a custom validator to the list of validation rules.
	 *
	 * @param{string} name The name of the validator.
	 * @param{object|function} validator The validator object/function.
	 */
	Validator.prototype.extend = function extend (name, validator) {
	  Validator.extend(name, validator);
	};
	
	/**
	 * Updates a field, updating both errors and flags.
	 *
	 * @param {String} id
	 * @param {Object} diff
	 */
	Validator.prototype.update = function update (id, ref) {
	    var scope = ref.scope;
	
	  var field = this._resolveField(("#" + id));
	  this.errors.update(id, { scope: scope });
	
	  // remove old scope.
	  if (!isNullOrUndefined(field.scope) && this.flags[("$" + (field.scope))]) {
	    delete this.flags[("$" + (field.scope))][field.name];
	  } else if (isNullOrUndefined(field.scope)) {
	    delete this.flags[field.name];
	  }
	
	  this._addFlag(field, scope);
	};
	
	/**
	 * Removes a rule from the list of validators.
	 * @param {String} name The name of the validator/rule.
	 */
	Validator.prototype.remove = function remove (name) {
	  Validator.remove(name);
	};
	
	/**
	 * Sets the validator current langauge.
	 *
	 * @param {string} language locale or language id.
	 */
	Validator.prototype.setLocale = function setLocale (language) {
	  this.locale = language;
	};
	
	/**
	 * Updates the messages dictionary, overwriting existing values and adding new ones.
	 * @deprecated
	 * @param{object} data The messages object.
	 */
	Validator.prototype.updateDictionary = function updateDictionary (data) {
	  Validator.updateDictionary(data);
	};
	
	/**
	 * Validates a value against a registered field validations.
	 *
	 * @param{string} name the field name.
	 * @param{*} value The value to be validated.
	 * @param {String} scope The scope of the field.
	 * @return {Promise}
	 */
	Validator.prototype.validate = function validate (name, value, scope) {
	    if ( scope === void 0 ) scope = null;
	
	  if (this.paused) { return Promise.resolve(true); }
	
	  // overload to validate all.
	  if (arguments.length === 0) {
	    return this.validateScopes();
	  }
	
	  // overload to validate scopeless fields.
	  if (arguments.length === 1 && arguments[0] === '*') {
	    return this.validateAll();
	  }
	
	  // overload to validate a scope.
	  if (arguments.length === 1 && typeof arguments[0] === 'string' && /^(.+)\.\*$/.test(arguments[0])) {
	    var matched = arguments[0].match(/^(.+)\.\*$/)[1];
	    return this.validateAll(matched);
	  }
	
	  var field = this._resolveField(name, scope);
	  if (!field) {
	    return this._handleFieldNotFound(name, scope);
	  }
	
	  this.errors.remove(field.name, field.scope, field.id);
	  field.flags.pending = true;
	  if (arguments.length === 1) {
	    value = field.value;
	  }
	
	  var silentRun = field.isDisabled;
	
	  return this._validate(field, value, silentRun).then(function (result) {
	    field.setFlags({
	      pending: false,
	      valid: result,
	      validated: true
	    });
	
	    if (silentRun) {
	      return Promise.resolve(true);
	    }
	
	    return result;
	  });
	};
	
	/**
	 * Pauses the validator.
	 *
	 * @return {Validator}
	 */
	Validator.prototype.pause = function pause () {
	  this.paused = true;
	
	  return this;
	};
	
	/**
	 * Resumes the validator.
	 *
	 * @return {Validator}
	 */
	Validator.prototype.resume = function resume () {
	  this.paused = false;
	
	  return this;
	};
	
	/**
	 * Validates each value against the corresponding field validations.
	 * @param{Object|String} values The values to be validated.
	 * @return {Promise} Returns a promise with the validation result.
	 */
	Validator.prototype.validateAll = function validateAll (values) {
	    var arguments$1 = arguments;
	    var this$1 = this;
	
	  if (this.paused) { return Promise.resolve(true); }
	
	  var matcher = null;
	  var providedValues = false;
	
	  if (typeof values === 'string') {
	    matcher = { scope: values };
	  } else if (isObject(values)) {
	    matcher = Object.keys(values).map(function (key) {
	      return { name: key, scope: arguments$1[1] || null };
	    });
	    providedValues = true;
	  } else if (arguments.length === 0) {
	    matcher = { scope: null }; // global scope.
	  }
	
	  var promises = this.fields.filter(matcher).map(function (field) { return this$1.validate(
	    ("#" + (field.id)),
	    providedValues ? values[field.name] : field.value
	  ); });
	
	  return Promise.all(promises).then(function (results) { return results.every(function (t) { return t; }); });
	};
	
	/**
	 * Validates all scopes.
	 *
	 * @returns {Promise} All promises resulted from each scope.
	 */
	Validator.prototype.validateScopes = function validateScopes () {
	    var this$1 = this;
	
	  if (this.paused) { return Promise.resolve(true); }
	
	  var promises = this.fields.map(function (field) { return this$1.validate(
	    ("#" + (field.id)),
	    field.value
	  ); });
	
	  return Promise.all(promises).then(function (results) { return results.every(function (t) { return t; }); });
	};
	
	/**
	 * Creates the fields to be validated.
	 *
	 * @param{object} validations
	 * @return {object} Normalized object.
	 */
	Validator.prototype._createFields = function _createFields (validations) {
	    var this$1 = this;
	
	  if (!validations) { return; }
	
	  Object.keys(validations).forEach(function (field) {
	    var options = assign({}, { name: field, rules: validations[field] });
	    this$1.attach(options);
	  });
	};
	
	/**
	 * Date rules need the existance of a format, so date_format must be supplied.
	 * @param {String} name The rule name.
	 * @param {Array} validations the field validations.
	 */
	Validator.prototype._getDateFormat = function _getDateFormat (validations) {
	  var format = null;
	  if (validations.date_format && Array.isArray(validations.date_format)) {
	    format = validations.date_format[0];
	  }
	
	  return format || this.dictionary.getDateFormat(this.locale);
	};
	
	/**
	 * Checks if the passed rule is a date rule.
	 */
	Validator.prototype._isADateRule = function _isADateRule (rule) {
	  return !! ~['after', 'before', 'date_between', 'date_format'].indexOf(rule);
	};
	
	/**
	 * Formats an error message for field and a rule.
	 *
	 * @param{Field} field The field object.
	 * @param{object} rule Normalized rule object.
	 * @param {object} data Additional Information about the validation result.
	 * @return {string} Formatted error message.
	 */
	Validator.prototype._formatErrorMessage = function _formatErrorMessage (field, rule, data, targetName) {
	    if ( data === void 0 ) data = {};
	    if ( targetName === void 0 ) targetName = null;
	
	  var name = this._getFieldDisplayName(field);
	  var params = this._getLocalizedParams(rule, targetName);
	  // Defaults to english message.
	  if (!this.dictionary.hasLocale(LOCALE)) {
	    var msg$1 = this.dictionary.getFieldMessage('en', field.name, rule.name);
	
	    return isCallable(msg$1) ? msg$1(name, params, data) : msg$1;
	  }
	
	  var msg = this.dictionary.getFieldMessage(LOCALE, field.name, rule.name);
	
	  return isCallable(msg) ? msg(name, params, data) : msg;
	};
	
	/**
	 * Translates the parameters passed to the rule (mainly for target fields).
	 */
	Validator.prototype._getLocalizedParams = function _getLocalizedParams (rule, targetName) {
	    if ( targetName === void 0 ) targetName = null;
	
	  if (~['after', 'before', 'confirmed'].indexOf(rule.name) && rule.params && rule.params[0]) {
	    var localizedName = targetName || this.dictionary.getAttribute(LOCALE, rule.params[0], rule.params[0]);
	    return [localizedName].concat(rule.params.slice(1));
	  }
	
	  return rule.params;
	};
	
	/**
	 * Resolves an appropiate display name, first checking 'data-as' or the registered 'prettyName'
	 * Then the dictionary, then fallsback to field name.
	 * @param {Field} field The field object.
	 * @return {String} The name to be used in the errors.
	 */
	Validator.prototype._getFieldDisplayName = function _getFieldDisplayName (field) {
	  return field.displayName || this.dictionary.getAttribute(LOCALE, field.name, field.name);
	};
	
	/**
	 * Adds a field flags to the flags collection.
	 * @param {Field} field
	 * @param {String|null} scope
	 */
	Validator.prototype._addFlag = function _addFlag (field, scope) {
	    if ( scope === void 0 ) scope = null;
	
	  if (isNullOrUndefined(scope)) {
	    this.flags = assign({}, this.flags, ( obj = {}, obj[("" + (field.name))] = field.flags, obj ));
	      var obj;
	    return;
	  }
	
	  var scopeObj = assign({}, this.flags[("$" + scope)] || {}, ( obj$1 = {}, obj$1[("" + (field.name))] = field.flags, obj$1 ));
	    var obj$1;
	  this.flags = assign({}, this.flags, ( obj$2 = {}, obj$2[("$" + scope)] = scopeObj, obj$2 ));
	    var obj$2;
	};
	
	/**
	 * Tests a single input value against a rule.
	 *
	 * @param{Field} field The field under validation.
	 * @param{*} valuethe value of the field.
	 * @param{object} rule the rule object.
	 * @return {boolean} Whether it passes the check.
	 */
	Validator.prototype._test = function _test (field, value, rule, silent) {
	    var this$1 = this;
	
	  var validator = RULES[rule.name];
	  var params = Array.isArray(rule.params) ? toArray(rule.params) : [];
	  var targetName = null;
	  if (!validator || typeof validator !== 'function') {
	    throw createError(("No such validator '" + (rule.name) + "' exists."));
	  }
	
	  // has field depenencies
	  if (/(confirmed|after|before)/.test(rule.name)) {
	    var target = find(field.dependencies, function (d) { return d.name === rule.name; });
	    if (target) {
	      targetName = target.field.displayName;
	      params = [target.field.value].concat(params.slice(1));
	    }
	  } else if (rule.name === 'required' && field.rejectsFalse) {
	    // invalidate false if no args were specified and the field rejects false by default.
	    params = params.length ? params : [true];
	  }
	
	  if (this._isADateRule(rule.name)) {
	    var dateFormat = this._getDateFormat(field.rules);
	    if (rule.name !== 'date_format') {
	      params.push(dateFormat);
	    }
	  }
	
	  var result = validator(value, params);
	
	  // If it is a promise.
	  if (isCallable(result.then)) {
	    return result.then(function (values) {
	      var allValid = true;
	      var data = {};
	      if (Array.isArray(values)) {
	        allValid = values.every(function (t) { return (isObject(t) ? t.valid : t); });
	      } else { // Is a single object/boolean.
	        allValid = isObject(values) ? values.valid : values;
	        data = values.data;
	      }
	
	      if (!allValid && !silent) {
	        this$1.errors.add({
	          id: field.id,
	          field: field.name,
	          msg: this$1._formatErrorMessage(field, rule, data, targetName),
	          rule: rule.name,
	          scope: field.scope
	        });
	      }
	
	      return allValid;
	    });
	  }
	
	  if (!isObject(result)) {
	    result = { valid: result, data: {} };
	  }
	
	  if (!result.valid && !silent) {
	    this.errors.add({
	      id: field.id,
	      field: field.name,
	      msg: this._formatErrorMessage(field, rule, result.data, targetName),
	      rule: rule.name,
	      scope: field.scope
	    });
	  }
	
	  return result.valid;
	};
	
	/**
	 * Merges a validator object into the RULES and Messages.
	 *
	 * @param{string} name The name of the validator.
	 * @param{function|object} validator The validator object.
	 */
	Validator._merge = function _merge (name, validator) {
	  if (isCallable(validator)) {
	    RULES[name] = validator;
	    return;
	  }
	
	  RULES[name] = validator.validate;
	  if (isCallable(validator.getMessage)) {
	    DICTIONARY.setMessage(LOCALE, name, validator.getMessage);
	  }
	
	  if (validator.messages) {
	    DICTIONARY.merge(
	      Object.keys(validator.messages).reduce(function (prev, curr) {
	        var dict = prev;
	        dict[curr] = {
	          messages: ( obj = {}, obj[name] = validator.messages[curr], obj )
	        };
	          var obj;
	
	        return dict;
	      }, {})
	    );
	  }
	};
	
	/**
	 * Guards from extnsion violations.
	 *
	 * @param{string} name name of the validation rule.
	 * @param{object} validator a validation rule object.
	 */
	Validator._guardExtend = function _guardExtend (name, validator) {
	  if (isCallable(validator)) {
	    return;
	  }
	
	  if (!isCallable(validator.validate)) {
	    throw createError(
	      // eslint-disable-next-line
	      ("Extension Error: The validator '" + name + "' must be a function or have a 'validate' method.")
	    );
	  }
	
	  if (!isCallable(validator.getMessage) && !isObject(validator.messages)) {
	    throw createError(
	      // eslint-disable-next-line
	      ("Extension Error: The validator '" + name + "' must have a 'getMessage' method or have a 'messages' object.")
	    );
	  }
	};
	
	/**
	 * Tries different strategies to find a field.
	 * @param {String} name
	 * @param {String} scope
	 * @return {Field}
	 */
	Validator.prototype._resolveField = function _resolveField (name, scope) {
	  if (!isNullOrUndefined(scope)) {
	    return this.fields.find({ name: name, scope: scope });
	  }
	
	  if (name[0] === '#') {
	    return this.fields.find({ id: name.slice(1) });
	  }
	
	  if (name.indexOf('.') > -1) {
	    var ref = name.split('.');
	      var fieldScope = ref[0];
	      var fieldName = ref.slice(1);
	    var field = this.fields.find({ name: fieldName.join('.'), scope: fieldScope });
	    if (field) {
	      return field;
	    }
	  }
	
	  return this.fields.find({ name: name, scope: null });
	};
	
	/**
	 * Handles when a field is not found depending on the strict flag.
	 *
	 * @param {String} name
	 * @param {String} scope
	 */
	Validator.prototype._handleFieldNotFound = function _handleFieldNotFound (name, scope) {
	  if (!this.strict) { return Promise.resolve(true); }
	
	  var fullName = isNullOrUndefined(scope) ? name : ("" + (!isNullOrUndefined(scope) ? scope + '.' : '') + name);
	  throw createError(
	    ("Validating a non-existant field: \"" + fullName + "\". Use \"attach()\" first.")
	  );
	};
	
	/**
	 * Starts the validation process.
	 *
	 * @param {Field} field
	 * @param {Promise} value
	 * @param {Boolean} silent
	 */
	Validator.prototype._validate = function _validate (field, value, silent) {
	    var this$1 = this;
	    if ( silent === void 0 ) silent = false;
	
	  if (!field.isRequired && (isNullOrUndefined(value) || value === '')) {
	    return Promise.resolve(true);
	  }
	
	  var promises = [];
	  var isExitEarly = false;
	  // use of '.some()' is to break iteration in middle by returning true
	  Object.keys(field.rules).some(function (rule) {
	    var result = this$1._test(field, value, { name: rule, params: field.rules[rule] }, silent);
	
	    if (isCallable(result.then)) {
	      promises.push(result);
	    } else if (this$1.fastExit && !result) {
	      isExitEarly = true;
	    } else {
	      var resultAsPromise = new Promise(function (resolve) {
	        resolve(result);
	      });
	      promises.push(resultAsPromise);
	    }
	
	    return isExitEarly;
	  });
	
	  if (isExitEarly) { return Promise.resolve(false); }
	
	  return Promise.all(promises).then(function (values) { return values.every(function (t) { return t; }); });
	};
	
	Object.defineProperties( Validator.prototype, prototypeAccessors );
	Object.defineProperties( Validator, staticAccessors );
	
	var fakeFlags = createProxy({}, {
	  get: function get (target, key) {
	    // is a scope
	    if (String(key).indexOf('$') === 0) {
	      return fakeFlags;
	    }
	
	    return createFlags();
	  }
	});
	
	/**
	 * Checks if a parent validator instance was requested.
	 * @param {Object|Array} injections
	 */
	var requestsValidator = function (injections) {
	  if (! injections) {
	    return false;
	  }
	
	  /* istanbul ignore next */
	  if (Array.isArray(injections) && ~injections.indexOf('$validator')) {
	    return true;
	  }
	
	  if (isObject(injections) && injections.$validator) {
	    return true;
	  }
	
	  return false;
	};
	
	/**
	 * Creates a validator instance.
	 * @param {Vue} vm
	 * @param {Object} options
	 */
	var createValidator = function (vm, options) { return new Validator(null, { vm: vm, fastExit: options.fastExit }); };
	
	var makeMixin = function (Vue, options) {
	  if ( options === void 0 ) options = {};
	
	  var mixin = {};
	  mixin.provide = function providesValidator () {
	    if (this.$validator) {
	      return {
	        $validator: this.$validator
	      };
	    }
	
	    return {};
	  };
	
	  mixin.beforeCreate = function beforeCreate () {
	    // if its a root instance, inject anyways, or if it requested a new instance.
	    if (this.$options.$validates || !this.$parent) {
	      this.$validator = createValidator(this, options);
	    }
	
	    var requested = requestsValidator(this.$options.inject);
	
	    // if automatic injection is enabled and no instance was requested.
	    if (! this.$validator && options.inject && !requested) {
	      this.$validator = createValidator(this, options);
	    }
	
	    // don't inject errors or fieldBag as no validator was resolved.
	    if (! requested && ! this.$validator) {
	      return;
	    }
	
	    // There is a validator but it isn't injected, mark as reactive.
	    if (! requested && this.$validator) {
	      Vue.util.defineReactive(this.$validator, 'errors', this.$validator.errors);
	      Vue.util.defineReactive(this.$validator, 'flags', this.$validator.flags);
	    }
	
	    if (! this.$options.computed) {
	      this.$options.computed = {};
	    }
	
	    this.$options.computed[options.errorBagName || 'errors'] = function errorBagGetter () {
	      return this.$validator.errors;
	    };
	    this.$options.computed[options.fieldsBagName || 'fields'] = function fieldBagGetter () {
	      if (!Object.keys(this.$validator.flags).length) {
	        return fakeFlags;
	      }
	
	      return this.$validator.flags;
	    };
	  };
	
	  mixin.beforeDestroy = function beforeDestroy () {
	    // mark the validator paused to prevent delayed validation.
	    if (this.$validator && this.$validator.ownerId === this._uid && isCallable(this.$validator.pause)) {
	      this.$validator.pause();
	    }
	  };
	
	  return mixin;
	};
	
	var config = {
	  locale: 'en',
	  delay: 0,
	  errorBagName: 'errors',
	  dictionary: null,
	  strict: true,
	  fieldsBagName: 'fields',
	  classes: false,
	  classNames: undefined,
	  events: 'input|blur',
	  inject: true,
	  fastExit: true,
	  aria: true,
	  validity: false
	};
	
	/**
	 * 
	 * 
	 * Finds the requested field by id from the context object.
	 * @param {Object} context
	 * @return {Field|null}
	 */
	var findField = function (el, context) {
	  if (!context || !context.$validator) {
	    return null;
	  }
	
	  return context.$validator.fields.find({ id: getDataAttribute(el, 'id') });
	};
	
	var createDirective$1 = function (options) {
	  options = assign({}, config, options);
	
	  return {
	    bind: function bind (el, binding, vnode) {
	      var validator = vnode.context.$validator;
	      if (! validator) {
	        warn("No validator instance is present on vm, did you forget to inject '$validator'?");
	        return;
	      }
	      var fieldOptions = Generator.generate(el, binding, vnode, options);
	      validator.attach(fieldOptions);
	    },
	    inserted: function (el, binding, vnode) {
	      var field = findField(el, vnode.context);
	      var scope = Generator.resolveScope(el, binding, vnode);
	
	      // skip if scope hasn't changed.
	      if (!field || scope === field.scope) { return; }
	
	      // only update scope.
	      field.update({ scope: scope });
	
	      // allows the field to re-evaluated once more in the update hook.
	      field.updated = false;
	    },
	    update: function (el, binding, vnode) {
	      var field = findField(el, vnode.context);
	
	      // make sure we don't do uneccessary work if no important change was done.
	      if (!field || (field.updated && isEqual$1(binding.value, binding.oldValue))) { return; }
	      var scope = Generator.resolveScope(el, binding, vnode);
	      var rules = Generator.resolveRules(el, binding);
	
	      field.update({
	        scope: scope,
	        rules: rules
	      });
	    },
	    unbind: function unbind (el, binding, ref) {
	      var context = ref.context;
	
	      var field = findField(el, context);
	      if (!field) { return; }
	
	      context.$validator.detach(field);
	    }
	  };
	};
	
	var Vue;
	
	function install (_Vue, options) {
	  if ( options === void 0 ) options = {};
	
	  if (Vue) {
	    warn('already installed, Vue.use(VeeValidate) should only be called once.');
	    return;
	  }
	
	  Vue = _Vue;
	  var config$$1 = assign({}, config, options);
	  if (config$$1.dictionary) {
	    Validator.updateDictionary(config$$1.dictionary);
	  }
	
	  if (options) {
	    if (options.locale) {
	      Validator.locale = options.locale;
	    }
	
	    if (options.strict) {
	      Validator.setStrictMode(config$$1.strict);
	    }
	  }
	
	  Vue.mixin(makeMixin(Vue, config$$1));
	  Vue.directive('validate', createDirective$1(config$$1));
	}
	
	function use (plugin, options) {
	  if ( options === void 0 ) options = {};
	
	  if (!isCallable(plugin)) {
	    return warn('The plugin must be a callable function');
	  }
	
	  plugin({ Validator: Validator, ErrorBag: ErrorBag, Rules: Validator.rules }, options);
	}
	
	var normalize = function (fields) {
	  if (Array.isArray(fields)) {
	    return fields.reduce(function (prev, curr) {
	      if (~curr.indexOf('.')) {
	        prev[curr.split('.')[1]] = curr;
	      } else {
	        prev[curr] = curr;
	      }
	
	      return prev;
	    }, {});
	  }
	
	  return fields;
	};
	
	/**
	 * Maps fields to computed functions.
	 *
	 * @param {Array|Object} fields
	 */
	var mapFields = function (fields) {
	  var normalized = normalize(fields);
	  return Object.keys(normalized).reduce(function (prev, curr) {
	    var field = normalized[curr];
	    prev[curr] = function mappedField () {
	      // if field exists
	      if (this.$validator.flags[field]) {
	        return this.$validator.flags[field];
	      }
	
	      // if it has a scope defined
	      var index = field.indexOf('.');
	      if (index <= 0) {
	        return {};
	      }
	
	      var ref = field.split('.');
	      var scope = ref[0];
	      var name = ref.slice(1);
	      scope = this.$validator.flags[("$" + scope)];
	      name = name.join('.');
	
	      if (scope && scope[name]) {
	        return scope[name];
	      }
	
	      return {};
	    };
	
	    return prev;
	  }, {});
	};
	
	var minimal$1 = {
	  install: install,
	  use: use,
	  mapFields: mapFields,
	  Validator: Validator,
	  ErrorBag: ErrorBag,
	  version: '2.0.0-rc.18'
	};
	
	// rules plugin definition.
	var rulesPlugin = function (ref) {
	  var Validator = ref.Validator;
	
	  Object.keys(Rules).forEach(function (rule) {
	    Validator.extend(rule, Rules[rule]);
	  });
	};
	
	// install the rules via the plugin API.
	minimal$1.use(rulesPlugin);
	
	minimal$1.Rules = Rules;
	
	return minimal$1;
	
	})));


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1633)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(2172),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1558)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(617),
	  /* template */
	  __webpack_require__(2092),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1578)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(564),
	  /* template */
	  __webpack_require__(2113),
	  /* scopeId */
	  "data-v-442b1c98",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1669)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(639),
	  /* template */
	  __webpack_require__(2211),
	  /* scopeId */
	  "data-v-bfa35d02",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1660)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(640),
	  /* template */
	  __webpack_require__(2202),
	  /* scopeId */
	  "data-v-b415c90e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1537)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(642),
	  /* template */
	  __webpack_require__(2069),
	  /* scopeId */
	  "data-v-261fcb64",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1525)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(643),
	  /* template */
	  __webpack_require__(2057),
	  /* scopeId */
	  "data-v-1999b21f",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(646),
	  /* template */
	  __webpack_require__(2160),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1661)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(651),
	  /* template */
	  __webpack_require__(2203),
	  /* scopeId */
	  "data-v-b54d7aa6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1648)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(569),
	  /* template */
	  __webpack_require__(2188),
	  /* scopeId */
	  "data-v-85aa9308",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(655),
	  /* template */
	  __webpack_require__(2040),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1594)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(571),
	  /* template */
	  __webpack_require__(2129),
	  /* scopeId */
	  "data-v-53fdf3fd",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1655)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(572),
	  /* template */
	  __webpack_require__(2196),
	  /* scopeId */
	  "data-v-9d098318",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(676),
	  /* template */
	  __webpack_require__(2176),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1628)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(708),
	  /* template */
	  __webpack_require__(2167),
	  /* scopeId */
	  "data-v-72815a02",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1535)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(724),
	  /* template */
	  __webpack_require__(2067),
	  /* scopeId */
	  "data-v-2483f03d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1665)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(593),
	  /* template */
	  __webpack_require__(2207),
	  /* scopeId */
	  "data-v-b9f50de0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1530)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(594),
	  /* template */
	  __webpack_require__(2062),
	  /* scopeId */
	  "data-v-20bebda0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1562)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(735),
	  /* template */
	  __webpack_require__(2097),
	  /* scopeId */
	  "data-v-37c8cc00",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1619)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(737),
	  /* template */
	  __webpack_require__(2155),
	  /* scopeId */
	  "data-v-66a5027e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	  * vue-router v2.8.1
	  * (c) 2017 Evan You
	  * @license MIT
	  */
	'use strict';
	
	/*  */
	
	function assert (condition, message) {
	  if (!condition) {
	    throw new Error(("[vue-router] " + message))
	  }
	}
	
	function warn (condition, message) {
	  if (false) {
	    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
	  }
	}
	
	function isError (err) {
	  return Object.prototype.toString.call(err).indexOf('Error') > -1
	}
	
	var View = {
	  name: 'router-view',
	  functional: true,
	  props: {
	    name: {
	      type: String,
	      default: 'default'
	    }
	  },
	  render: function render (_, ref) {
	    var props = ref.props;
	    var children = ref.children;
	    var parent = ref.parent;
	    var data = ref.data;
	
	    data.routerView = true;
	
	    // directly use parent context's createElement() function
	    // so that components rendered by router-view can resolve named slots
	    var h = parent.$createElement;
	    var name = props.name;
	    var route = parent.$route;
	    var cache = parent._routerViewCache || (parent._routerViewCache = {});
	
	    // determine current view depth, also check to see if the tree
	    // has been toggled inactive but kept-alive.
	    var depth = 0;
	    var inactive = false;
	    while (parent && parent._routerRoot !== parent) {
	      if (parent.$vnode && parent.$vnode.data.routerView) {
	        depth++;
	      }
	      if (parent._inactive) {
	        inactive = true;
	      }
	      parent = parent.$parent;
	    }
	    data.routerViewDepth = depth;
	
	    // render previous view if the tree is inactive and kept-alive
	    if (inactive) {
	      return h(cache[name], data, children)
	    }
	
	    var matched = route.matched[depth];
	    // render empty node if no matched route
	    if (!matched) {
	      cache[name] = null;
	      return h()
	    }
	
	    var component = cache[name] = matched.components[name];
	
	    // attach instance registration hook
	    // this will be called in the instance's injected lifecycle hooks
	    data.registerRouteInstance = function (vm, val) {
	      // val could be undefined for unregistration
	      var current = matched.instances[name];
	      if (
	        (val && current !== vm) ||
	        (!val && current === vm)
	      ) {
	        matched.instances[name] = val;
	      }
	    }
	
	    // also register instance in prepatch hook
	    // in case the same component instance is reused across different routes
	    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
	      matched.instances[name] = vnode.componentInstance;
	    };
	
	    // resolve props
	    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
	    if (propsToPass) {
	      // clone to prevent mutation
	      propsToPass = data.props = extend({}, propsToPass);
	      // pass non-declared props as attrs
	      var attrs = data.attrs = data.attrs || {};
	      for (var key in propsToPass) {
	        if (!component.props || !(key in component.props)) {
	          attrs[key] = propsToPass[key];
	          delete propsToPass[key];
	        }
	      }
	    }
	
	    return h(component, data, children)
	  }
	};
	
	function resolveProps (route, config) {
	  switch (typeof config) {
	    case 'undefined':
	      return
	    case 'object':
	      return config
	    case 'function':
	      return config(route)
	    case 'boolean':
	      return config ? route.params : undefined
	    default:
	      if (false) {
	        warn(
	          false,
	          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
	          "expecting an object, function or boolean."
	        );
	      }
	  }
	}
	
	function extend (to, from) {
	  for (var key in from) {
	    to[key] = from[key];
	  }
	  return to
	}
	
	/*  */
	
	var encodeReserveRE = /[!'()*]/g;
	var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
	var commaRE = /%2C/g;
	
	// fixed encodeURIComponent which is more conformant to RFC3986:
	// - escapes [!'()*]
	// - preserve commas
	var encode = function (str) { return encodeURIComponent(str)
	  .replace(encodeReserveRE, encodeReserveReplacer)
	  .replace(commaRE, ','); };
	
	var decode = decodeURIComponent;
	
	function resolveQuery (
	  query,
	  extraQuery,
	  _parseQuery
	) {
	  if ( extraQuery === void 0 ) extraQuery = {};
	
	  var parse = _parseQuery || parseQuery;
	  var parsedQuery;
	  try {
	    parsedQuery = parse(query || '');
	  } catch (e) {
	    ("production") !== 'production' && warn(false, e.message);
	    parsedQuery = {};
	  }
	  for (var key in extraQuery) {
	    parsedQuery[key] = extraQuery[key];
	  }
	  return parsedQuery
	}
	
	function parseQuery (query) {
	  var res = {};
	
	  query = query.trim().replace(/^(\?|#|&)/, '');
	
	  if (!query) {
	    return res
	  }
	
	  query.split('&').forEach(function (param) {
	    var parts = param.replace(/\+/g, ' ').split('=');
	    var key = decode(parts.shift());
	    var val = parts.length > 0
	      ? decode(parts.join('='))
	      : null;
	
	    if (res[key] === undefined) {
	      res[key] = val;
	    } else if (Array.isArray(res[key])) {
	      res[key].push(val);
	    } else {
	      res[key] = [res[key], val];
	    }
	  });
	
	  return res
	}
	
	function stringifyQuery (obj) {
	  var res = obj ? Object.keys(obj).map(function (key) {
	    var val = obj[key];
	
	    if (val === undefined) {
	      return ''
	    }
	
	    if (val === null) {
	      return encode(key)
	    }
	
	    if (Array.isArray(val)) {
	      var result = [];
	      val.forEach(function (val2) {
	        if (val2 === undefined) {
	          return
	        }
	        if (val2 === null) {
	          result.push(encode(key));
	        } else {
	          result.push(encode(key) + '=' + encode(val2));
	        }
	      });
	      return result.join('&')
	    }
	
	    return encode(key) + '=' + encode(val)
	  }).filter(function (x) { return x.length > 0; }).join('&') : null;
	  return res ? ("?" + res) : ''
	}
	
	/*  */
	
	
	var trailingSlashRE = /\/?$/;
	
	function createRoute (
	  record,
	  location,
	  redirectedFrom,
	  router
	) {
	  var stringifyQuery$$1 = router && router.options.stringifyQuery;
	
	  var query = location.query || {};
	  try {
	    query = clone(query);
	  } catch (e) {}
	
	  var route = {
	    name: location.name || (record && record.name),
	    meta: (record && record.meta) || {},
	    path: location.path || '/',
	    hash: location.hash || '',
	    query: query,
	    params: location.params || {},
	    fullPath: getFullPath(location, stringifyQuery$$1),
	    matched: record ? formatMatch(record) : []
	  };
	  if (redirectedFrom) {
	    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
	  }
	  return Object.freeze(route)
	}
	
	function clone (value) {
	  if (Array.isArray(value)) {
	    return value.map(clone)
	  } else if (value && typeof value === 'object') {
	    var res = {};
	    for (var key in value) {
	      res[key] = clone(value[key]);
	    }
	    return res
	  } else {
	    return value
	  }
	}
	
	// the starting route that represents the initial state
	var START = createRoute(null, {
	  path: '/'
	});
	
	function formatMatch (record) {
	  var res = [];
	  while (record) {
	    res.unshift(record);
	    record = record.parent;
	  }
	  return res
	}
	
	function getFullPath (
	  ref,
	  _stringifyQuery
	) {
	  var path = ref.path;
	  var query = ref.query; if ( query === void 0 ) query = {};
	  var hash = ref.hash; if ( hash === void 0 ) hash = '';
	
	  var stringify = _stringifyQuery || stringifyQuery;
	  return (path || '/') + stringify(query) + hash
	}
	
	function isSameRoute (a, b) {
	  if (b === START) {
	    return a === b
	  } else if (!b) {
	    return false
	  } else if (a.path && b.path) {
	    return (
	      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
	      a.hash === b.hash &&
	      isObjectEqual(a.query, b.query)
	    )
	  } else if (a.name && b.name) {
	    return (
	      a.name === b.name &&
	      a.hash === b.hash &&
	      isObjectEqual(a.query, b.query) &&
	      isObjectEqual(a.params, b.params)
	    )
	  } else {
	    return false
	  }
	}
	
	function isObjectEqual (a, b) {
	  if ( a === void 0 ) a = {};
	  if ( b === void 0 ) b = {};
	
	  // handle null value #1566
	  if (!a || !b) { return a === b }
	  var aKeys = Object.keys(a);
	  var bKeys = Object.keys(b);
	  if (aKeys.length !== bKeys.length) {
	    return false
	  }
	  return aKeys.every(function (key) {
	    var aVal = a[key];
	    var bVal = b[key];
	    // check nested equality
	    if (typeof aVal === 'object' && typeof bVal === 'object') {
	      return isObjectEqual(aVal, bVal)
	    }
	    return String(aVal) === String(bVal)
	  })
	}
	
	function isIncludedRoute (current, target) {
	  return (
	    current.path.replace(trailingSlashRE, '/').indexOf(
	      target.path.replace(trailingSlashRE, '/')
	    ) === 0 &&
	    (!target.hash || current.hash === target.hash) &&
	    queryIncludes(current.query, target.query)
	  )
	}
	
	function queryIncludes (current, target) {
	  for (var key in target) {
	    if (!(key in current)) {
	      return false
	    }
	  }
	  return true
	}
	
	/*  */
	
	// work around weird flow bug
	var toTypes = [String, Object];
	var eventTypes = [String, Array];
	
	var Link = {
	  name: 'router-link',
	  props: {
	    to: {
	      type: toTypes,
	      required: true
	    },
	    tag: {
	      type: String,
	      default: 'a'
	    },
	    exact: Boolean,
	    append: Boolean,
	    replace: Boolean,
	    activeClass: String,
	    exactActiveClass: String,
	    event: {
	      type: eventTypes,
	      default: 'click'
	    }
	  },
	  render: function render (h) {
	    var this$1 = this;
	
	    var router = this.$router;
	    var current = this.$route;
	    var ref = router.resolve(this.to, current, this.append);
	    var location = ref.location;
	    var route = ref.route;
	    var href = ref.href;
	
	    var classes = {};
	    var globalActiveClass = router.options.linkActiveClass;
	    var globalExactActiveClass = router.options.linkExactActiveClass;
	    // Support global empty active class
	    var activeClassFallback = globalActiveClass == null
	            ? 'router-link-active'
	            : globalActiveClass;
	    var exactActiveClassFallback = globalExactActiveClass == null
	            ? 'router-link-exact-active'
	            : globalExactActiveClass;
	    var activeClass = this.activeClass == null
	            ? activeClassFallback
	            : this.activeClass;
	    var exactActiveClass = this.exactActiveClass == null
	            ? exactActiveClassFallback
	            : this.exactActiveClass;
	    var compareTarget = location.path
	      ? createRoute(null, location, null, router)
	      : route;
	
	    classes[exactActiveClass] = isSameRoute(current, compareTarget);
	    classes[activeClass] = this.exact
	      ? classes[exactActiveClass]
	      : isIncludedRoute(current, compareTarget);
	
	    var handler = function (e) {
	      if (guardEvent(e)) {
	        if (this$1.replace) {
	          router.replace(location);
	        } else {
	          router.push(location);
	        }
	      }
	    };
	
	    var on = { click: guardEvent };
	    if (Array.isArray(this.event)) {
	      this.event.forEach(function (e) { on[e] = handler; });
	    } else {
	      on[this.event] = handler;
	    }
	
	    var data = {
	      class: classes
	    };
	
	    if (this.tag === 'a') {
	      data.on = on;
	      data.attrs = { href: href };
	    } else {
	      // find the first <a> child and apply listener and href
	      var a = findAnchor(this.$slots.default);
	      if (a) {
	        // in case the <a> is a static node
	        a.isStatic = false;
	        var extend = _Vue.util.extend;
	        var aData = a.data = extend({}, a.data);
	        aData.on = on;
	        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
	        aAttrs.href = href;
	      } else {
	        // doesn't have <a> child, apply listener to self
	        data.on = on;
	      }
	    }
	
	    return h(this.tag, data, this.$slots.default)
	  }
	};
	
	function guardEvent (e) {
	  // don't redirect with control keys
	  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
	  // don't redirect when preventDefault called
	  if (e.defaultPrevented) { return }
	  // don't redirect on right click
	  if (e.button !== undefined && e.button !== 0) { return }
	  // don't redirect if `target="_blank"`
	  if (e.currentTarget && e.currentTarget.getAttribute) {
	    var target = e.currentTarget.getAttribute('target');
	    if (/\b_blank\b/i.test(target)) { return }
	  }
	  // this may be a Weex event which doesn't have this method
	  if (e.preventDefault) {
	    e.preventDefault();
	  }
	  return true
	}
	
	function findAnchor (children) {
	  if (children) {
	    var child;
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      if (child.tag === 'a') {
	        return child
	      }
	      if (child.children && (child = findAnchor(child.children))) {
	        return child
	      }
	    }
	  }
	}
	
	var _Vue;
	
	function install (Vue) {
	  if (install.installed && _Vue === Vue) { return }
	  install.installed = true;
	
	  _Vue = Vue;
	
	  var isDef = function (v) { return v !== undefined; };
	
	  var registerInstance = function (vm, callVal) {
	    var i = vm.$options._parentVnode;
	    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
	      i(vm, callVal);
	    }
	  };
	
	  Vue.mixin({
	    beforeCreate: function beforeCreate () {
	      if (isDef(this.$options.router)) {
	        this._routerRoot = this;
	        this._router = this.$options.router;
	        this._router.init(this);
	        Vue.util.defineReactive(this, '_route', this._router.history.current);
	      } else {
	        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
	      }
	      registerInstance(this, this);
	    },
	    destroyed: function destroyed () {
	      registerInstance(this);
	    }
	  });
	
	  Object.defineProperty(Vue.prototype, '$router', {
	    get: function get () { return this._routerRoot._router }
	  });
	
	  Object.defineProperty(Vue.prototype, '$route', {
	    get: function get () { return this._routerRoot._route }
	  });
	
	  Vue.component('router-view', View);
	  Vue.component('router-link', Link);
	
	  var strats = Vue.config.optionMergeStrategies;
	  // use the same hook merging strategy for route hooks
	  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
	}
	
	/*  */
	
	var inBrowser = typeof window !== 'undefined';
	
	/*  */
	
	function resolvePath (
	  relative,
	  base,
	  append
	) {
	  var firstChar = relative.charAt(0);
	  if (firstChar === '/') {
	    return relative
	  }
	
	  if (firstChar === '?' || firstChar === '#') {
	    return base + relative
	  }
	
	  var stack = base.split('/');
	
	  // remove trailing segment if:
	  // - not appending
	  // - appending to trailing slash (last segment is empty)
	  if (!append || !stack[stack.length - 1]) {
	    stack.pop();
	  }
	
	  // resolve relative path
	  var segments = relative.replace(/^\//, '').split('/');
	  for (var i = 0; i < segments.length; i++) {
	    var segment = segments[i];
	    if (segment === '..') {
	      stack.pop();
	    } else if (segment !== '.') {
	      stack.push(segment);
	    }
	  }
	
	  // ensure leading slash
	  if (stack[0] !== '') {
	    stack.unshift('');
	  }
	
	  return stack.join('/')
	}
	
	function parsePath (path) {
	  var hash = '';
	  var query = '';
	
	  var hashIndex = path.indexOf('#');
	  if (hashIndex >= 0) {
	    hash = path.slice(hashIndex);
	    path = path.slice(0, hashIndex);
	  }
	
	  var queryIndex = path.indexOf('?');
	  if (queryIndex >= 0) {
	    query = path.slice(queryIndex + 1);
	    path = path.slice(0, queryIndex);
	  }
	
	  return {
	    path: path,
	    query: query,
	    hash: hash
	  }
	}
	
	function cleanPath (path) {
	  return path.replace(/\/\//g, '/')
	}
	
	var isarray = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};
	
	/**
	 * Expose `pathToRegexp`.
	 */
	var pathToRegexp_1 = pathToRegexp;
	var parse_1 = parse;
	var compile_1 = compile;
	var tokensToFunction_1 = tokensToFunction;
	var tokensToRegExp_1 = tokensToRegExp;
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g');
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = [];
	  var key = 0;
	  var index = 0;
	  var path = '';
	  var defaultDelimiter = options && options.delimiter || '/';
	  var res;
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0];
	    var escaped = res[1];
	    var offset = res.index;
	    path += str.slice(index, offset);
	    index = offset + m.length;
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1];
	      continue
	    }
	
	    var next = str[index];
	    var prefix = res[2];
	    var name = res[3];
	    var capture = res[4];
	    var group = res[5];
	    var modifier = res[6];
	    var asterisk = res[7];
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path);
	      path = '';
	    }
	
	    var partial = prefix != null && next != null && next !== prefix;
	    var repeat = modifier === '+' || modifier === '*';
	    var optional = modifier === '?' || modifier === '*';
	    var delimiter = res[2] || defaultDelimiter;
	    var pattern = capture || group;
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    });
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index);
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path);
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length);
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
	    }
	  }
	
	  return function (obj, opts) {
	    var path = '';
	    var data = obj || {};
	    var options = opts || {};
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i];
	
	      if (typeof token === 'string') {
	        path += token;
	
	        continue
	      }
	
	      var value = data[token.name];
	      var segment;
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix;
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j]);
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment;
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value);
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment;
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys;
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g);
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      });
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = [];
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source);
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options);
	    keys = [];
	  }
	
	  options = options || {};
	
	  var strict = options.strict;
	  var end = options.end !== false;
	  var route = '';
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i];
	
	    if (typeof token === 'string') {
	      route += escapeString(token);
	    } else {
	      var prefix = escapeString(token.prefix);
	      var capture = '(?:' + token.pattern + ')';
	
	      keys.push(token);
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*';
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?';
	        } else {
	          capture = prefix + '(' + capture + ')?';
	        }
	      } else {
	        capture = prefix + '(' + capture + ')';
	      }
	
	      route += capture;
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/');
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
	  }
	
	  if (end) {
	    route += '$';
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options);
	    keys = [];
	  }
	
	  options = options || {};
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}
	
	pathToRegexp_1.parse = parse_1;
	pathToRegexp_1.compile = compile_1;
	pathToRegexp_1.tokensToFunction = tokensToFunction_1;
	pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;
	
	/*  */
	
	// $flow-disable-line
	var regexpCompileCache = Object.create(null);
	
	function fillParams (
	  path,
	  params,
	  routeMsg
	) {
	  try {
	    var filler =
	      regexpCompileCache[path] ||
	      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
	    return filler(params || {}, { pretty: true })
	  } catch (e) {
	    if (false) {
	      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
	    }
	    return ''
	  }
	}
	
	/*  */
	
	function createRouteMap (
	  routes,
	  oldPathList,
	  oldPathMap,
	  oldNameMap
	) {
	  // the path list is used to control path matching priority
	  var pathList = oldPathList || [];
	  // $flow-disable-line
	  var pathMap = oldPathMap || Object.create(null);
	  // $flow-disable-line
	  var nameMap = oldNameMap || Object.create(null);
	
	  routes.forEach(function (route) {
	    addRouteRecord(pathList, pathMap, nameMap, route);
	  });
	
	  // ensure wildcard routes are always at the end
	  for (var i = 0, l = pathList.length; i < l; i++) {
	    if (pathList[i] === '*') {
	      pathList.push(pathList.splice(i, 1)[0]);
	      l--;
	      i--;
	    }
	  }
	
	  return {
	    pathList: pathList,
	    pathMap: pathMap,
	    nameMap: nameMap
	  }
	}
	
	function addRouteRecord (
	  pathList,
	  pathMap,
	  nameMap,
	  route,
	  parent,
	  matchAs
	) {
	  var path = route.path;
	  var name = route.name;
	  if (false) {
	    assert(path != null, "\"path\" is required in a route configuration.");
	    assert(
	      typeof route.component !== 'string',
	      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
	      "string id. Use an actual component instead."
	    );
	  }
	
	  var pathToRegexpOptions = route.pathToRegexpOptions || {};
	  var normalizedPath = normalizePath(
	    path,
	    parent,
	    pathToRegexpOptions.strict
	  );
	
	  if (typeof route.caseSensitive === 'boolean') {
	    pathToRegexpOptions.sensitive = route.caseSensitive;
	  }
	
	  var record = {
	    path: normalizedPath,
	    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
	    components: route.components || { default: route.component },
	    instances: {},
	    name: name,
	    parent: parent,
	    matchAs: matchAs,
	    redirect: route.redirect,
	    beforeEnter: route.beforeEnter,
	    meta: route.meta || {},
	    props: route.props == null
	      ? {}
	      : route.components
	        ? route.props
	        : { default: route.props }
	  };
	
	  if (route.children) {
	    // Warn if route is named, does not redirect and has a default child route.
	    // If users navigate to this route by name, the default child will
	    // not be rendered (GH Issue #629)
	    if (false) {
	      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
	        warn(
	          false,
	          "Named Route '" + (route.name) + "' has a default child route. " +
	          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
	          "the default child route will not be rendered. Remove the name from " +
	          "this route and use the name of the default child route for named " +
	          "links instead."
	        );
	      }
	    }
	    route.children.forEach(function (child) {
	      var childMatchAs = matchAs
	        ? cleanPath((matchAs + "/" + (child.path)))
	        : undefined;
	      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
	    });
	  }
	
	  if (route.alias !== undefined) {
	    var aliases = Array.isArray(route.alias)
	      ? route.alias
	      : [route.alias];
	
	    aliases.forEach(function (alias) {
	      var aliasRoute = {
	        path: alias,
	        children: route.children
	      };
	      addRouteRecord(
	        pathList,
	        pathMap,
	        nameMap,
	        aliasRoute,
	        parent,
	        record.path || '/' // matchAs
	      );
	    });
	  }
	
	  if (!pathMap[record.path]) {
	    pathList.push(record.path);
	    pathMap[record.path] = record;
	  }
	
	  if (name) {
	    if (!nameMap[name]) {
	      nameMap[name] = record;
	    } else if (false) {
	      warn(
	        false,
	        "Duplicate named routes definition: " +
	        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
	      );
	    }
	  }
	}
	
	function compileRouteRegex (path, pathToRegexpOptions) {
	  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
	  if (false) {
	    var keys = Object.create(null);
	    regex.keys.forEach(function (key) {
	      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
	      keys[key.name] = true;
	    });
	  }
	  return regex
	}
	
	function normalizePath (path, parent, strict) {
	  if (!strict) { path = path.replace(/\/$/, ''); }
	  if (path[0] === '/') { return path }
	  if (parent == null) { return path }
	  return cleanPath(((parent.path) + "/" + path))
	}
	
	/*  */
	
	
	function normalizeLocation (
	  raw,
	  current,
	  append,
	  router
	) {
	  var next = typeof raw === 'string' ? { path: raw } : raw;
	  // named target
	  if (next.name || next._normalized) {
	    return next
	  }
	
	  // relative params
	  if (!next.path && next.params && current) {
	    next = assign({}, next);
	    next._normalized = true;
	    var params = assign(assign({}, current.params), next.params);
	    if (current.name) {
	      next.name = current.name;
	      next.params = params;
	    } else if (current.matched.length) {
	      var rawPath = current.matched[current.matched.length - 1].path;
	      next.path = fillParams(rawPath, params, ("path " + (current.path)));
	    } else if (false) {
	      warn(false, "relative params navigation requires a current route.");
	    }
	    return next
	  }
	
	  var parsedPath = parsePath(next.path || '');
	  var basePath = (current && current.path) || '/';
	  var path = parsedPath.path
	    ? resolvePath(parsedPath.path, basePath, append || next.append)
	    : basePath;
	
	  var query = resolveQuery(
	    parsedPath.query,
	    next.query,
	    router && router.options.parseQuery
	  );
	
	  var hash = next.hash || parsedPath.hash;
	  if (hash && hash.charAt(0) !== '#') {
	    hash = "#" + hash;
	  }
	
	  return {
	    _normalized: true,
	    path: path,
	    query: query,
	    hash: hash
	  }
	}
	
	function assign (a, b) {
	  for (var key in b) {
	    a[key] = b[key];
	  }
	  return a
	}
	
	/*  */
	
	
	function createMatcher (
	  routes,
	  router
	) {
	  var ref = createRouteMap(routes);
	  var pathList = ref.pathList;
	  var pathMap = ref.pathMap;
	  var nameMap = ref.nameMap;
	
	  function addRoutes (routes) {
	    createRouteMap(routes, pathList, pathMap, nameMap);
	  }
	
	  function match (
	    raw,
	    currentRoute,
	    redirectedFrom
	  ) {
	    var location = normalizeLocation(raw, currentRoute, false, router);
	    var name = location.name;
	
	    if (name) {
	      var record = nameMap[name];
	      if (false) {
	        warn(record, ("Route with name '" + name + "' does not exist"));
	      }
	      if (!record) { return _createRoute(null, location) }
	      var paramNames = record.regex.keys
	        .filter(function (key) { return !key.optional; })
	        .map(function (key) { return key.name; });
	
	      if (typeof location.params !== 'object') {
	        location.params = {};
	      }
	
	      if (currentRoute && typeof currentRoute.params === 'object') {
	        for (var key in currentRoute.params) {
	          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
	            location.params[key] = currentRoute.params[key];
	          }
	        }
	      }
	
	      if (record) {
	        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
	        return _createRoute(record, location, redirectedFrom)
	      }
	    } else if (location.path) {
	      location.params = {};
	      for (var i = 0; i < pathList.length; i++) {
	        var path = pathList[i];
	        var record$1 = pathMap[path];
	        if (matchRoute(record$1.regex, location.path, location.params)) {
	          return _createRoute(record$1, location, redirectedFrom)
	        }
	      }
	    }
	    // no match
	    return _createRoute(null, location)
	  }
	
	  function redirect (
	    record,
	    location
	  ) {
	    var originalRedirect = record.redirect;
	    var redirect = typeof originalRedirect === 'function'
	        ? originalRedirect(createRoute(record, location, null, router))
	        : originalRedirect;
	
	    if (typeof redirect === 'string') {
	      redirect = { path: redirect };
	    }
	
	    if (!redirect || typeof redirect !== 'object') {
	      if (false) {
	        warn(
	          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
	        );
	      }
	      return _createRoute(null, location)
	    }
	
	    var re = redirect;
	    var name = re.name;
	    var path = re.path;
	    var query = location.query;
	    var hash = location.hash;
	    var params = location.params;
	    query = re.hasOwnProperty('query') ? re.query : query;
	    hash = re.hasOwnProperty('hash') ? re.hash : hash;
	    params = re.hasOwnProperty('params') ? re.params : params;
	
	    if (name) {
	      // resolved named direct
	      var targetRecord = nameMap[name];
	      if (false) {
	        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
	      }
	      return match({
	        _normalized: true,
	        name: name,
	        query: query,
	        hash: hash,
	        params: params
	      }, undefined, location)
	    } else if (path) {
	      // 1. resolve relative redirect
	      var rawPath = resolveRecordPath(path, record);
	      // 2. resolve params
	      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
	      // 3. rematch with existing query and hash
	      return match({
	        _normalized: true,
	        path: resolvedPath,
	        query: query,
	        hash: hash
	      }, undefined, location)
	    } else {
	      if (false) {
	        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
	      }
	      return _createRoute(null, location)
	    }
	  }
	
	  function alias (
	    record,
	    location,
	    matchAs
	  ) {
	    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
	    var aliasedMatch = match({
	      _normalized: true,
	      path: aliasedPath
	    });
	    if (aliasedMatch) {
	      var matched = aliasedMatch.matched;
	      var aliasedRecord = matched[matched.length - 1];
	      location.params = aliasedMatch.params;
	      return _createRoute(aliasedRecord, location)
	    }
	    return _createRoute(null, location)
	  }
	
	  function _createRoute (
	    record,
	    location,
	    redirectedFrom
	  ) {
	    if (record && record.redirect) {
	      return redirect(record, redirectedFrom || location)
	    }
	    if (record && record.matchAs) {
	      return alias(record, location, record.matchAs)
	    }
	    return createRoute(record, location, redirectedFrom, router)
	  }
	
	  return {
	    match: match,
	    addRoutes: addRoutes
	  }
	}
	
	function matchRoute (
	  regex,
	  path,
	  params
	) {
	  var m = path.match(regex);
	
	  if (!m) {
	    return false
	  } else if (!params) {
	    return true
	  }
	
	  for (var i = 1, len = m.length; i < len; ++i) {
	    var key = regex.keys[i - 1];
	    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
	    if (key) {
	      params[key.name] = val;
	    }
	  }
	
	  return true
	}
	
	function resolveRecordPath (path, record) {
	  return resolvePath(path, record.parent ? record.parent.path : '/', true)
	}
	
	/*  */
	
	
	var positionStore = Object.create(null);
	
	function setupScroll () {
	  // Fix for #1585 for Firefox
	  window.history.replaceState({ key: getStateKey() }, '');
	  window.addEventListener('popstate', function (e) {
	    saveScrollPosition();
	    if (e.state && e.state.key) {
	      setStateKey(e.state.key);
	    }
	  });
	}
	
	function handleScroll (
	  router,
	  to,
	  from,
	  isPop
	) {
	  if (!router.app) {
	    return
	  }
	
	  var behavior = router.options.scrollBehavior;
	  if (!behavior) {
	    return
	  }
	
	  if (false) {
	    assert(typeof behavior === 'function', "scrollBehavior must be a function");
	  }
	
	  // wait until re-render finishes before scrolling
	  router.app.$nextTick(function () {
	    var position = getScrollPosition();
	    var shouldScroll = behavior(to, from, isPop ? position : null);
	
	    if (!shouldScroll) {
	      return
	    }
	
	    if (typeof shouldScroll.then === 'function') {
	      shouldScroll.then(function (shouldScroll) {
	        scrollToPosition((shouldScroll), position);
	      }).catch(function (err) {
	        if (false) {
	          assert(false, err.toString());
	        }
	      });
	    } else {
	      scrollToPosition(shouldScroll, position);
	    }
	  });
	}
	
	function saveScrollPosition () {
	  var key = getStateKey();
	  if (key) {
	    positionStore[key] = {
	      x: window.pageXOffset,
	      y: window.pageYOffset
	    };
	  }
	}
	
	function getScrollPosition () {
	  var key = getStateKey();
	  if (key) {
	    return positionStore[key]
	  }
	}
	
	function getElementPosition (el, offset) {
	  var docEl = document.documentElement;
	  var docRect = docEl.getBoundingClientRect();
	  var elRect = el.getBoundingClientRect();
	  return {
	    x: elRect.left - docRect.left - offset.x,
	    y: elRect.top - docRect.top - offset.y
	  }
	}
	
	function isValidPosition (obj) {
	  return isNumber(obj.x) || isNumber(obj.y)
	}
	
	function normalizePosition (obj) {
	  return {
	    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
	    y: isNumber(obj.y) ? obj.y : window.pageYOffset
	  }
	}
	
	function normalizeOffset (obj) {
	  return {
	    x: isNumber(obj.x) ? obj.x : 0,
	    y: isNumber(obj.y) ? obj.y : 0
	  }
	}
	
	function isNumber (v) {
	  return typeof v === 'number'
	}
	
	function scrollToPosition (shouldScroll, position) {
	  var isObject = typeof shouldScroll === 'object';
	  if (isObject && typeof shouldScroll.selector === 'string') {
	    var el = document.querySelector(shouldScroll.selector);
	    if (el) {
	      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
	      offset = normalizeOffset(offset);
	      position = getElementPosition(el, offset);
	    } else if (isValidPosition(shouldScroll)) {
	      position = normalizePosition(shouldScroll);
	    }
	  } else if (isObject && isValidPosition(shouldScroll)) {
	    position = normalizePosition(shouldScroll);
	  }
	
	  if (position) {
	    window.scrollTo(position.x, position.y);
	  }
	}
	
	/*  */
	
	var supportsPushState = inBrowser && (function () {
	  var ua = window.navigator.userAgent;
	
	  if (
	    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
	    ua.indexOf('Mobile Safari') !== -1 &&
	    ua.indexOf('Chrome') === -1 &&
	    ua.indexOf('Windows Phone') === -1
	  ) {
	    return false
	  }
	
	  return window.history && 'pushState' in window.history
	})();
	
	// use User Timing api (if present) for more accurate key precision
	var Time = inBrowser && window.performance && window.performance.now
	  ? window.performance
	  : Date;
	
	var _key = genKey();
	
	function genKey () {
	  return Time.now().toFixed(3)
	}
	
	function getStateKey () {
	  return _key
	}
	
	function setStateKey (key) {
	  _key = key;
	}
	
	function pushState (url, replace) {
	  saveScrollPosition();
	  // try...catch the pushState call to get around Safari
	  // DOM Exception 18 where it limits to 100 pushState calls
	  var history = window.history;
	  try {
	    if (replace) {
	      history.replaceState({ key: _key }, '', url);
	    } else {
	      _key = genKey();
	      history.pushState({ key: _key }, '', url);
	    }
	  } catch (e) {
	    window.location[replace ? 'replace' : 'assign'](url);
	  }
	}
	
	function replaceState (url) {
	  pushState(url, true);
	}
	
	/*  */
	
	function runQueue (queue, fn, cb) {
	  var step = function (index) {
	    if (index >= queue.length) {
	      cb();
	    } else {
	      if (queue[index]) {
	        fn(queue[index], function () {
	          step(index + 1);
	        });
	      } else {
	        step(index + 1);
	      }
	    }
	  };
	  step(0);
	}
	
	/*  */
	
	function resolveAsyncComponents (matched) {
	  return function (to, from, next) {
	    var hasAsync = false;
	    var pending = 0;
	    var error = null;
	
	    flatMapComponents(matched, function (def, _, match, key) {
	      // if it's a function and doesn't have cid attached,
	      // assume it's an async component resolve function.
	      // we are not using Vue's default async resolving mechanism because
	      // we want to halt the navigation until the incoming component has been
	      // resolved.
	      if (typeof def === 'function' && def.cid === undefined) {
	        hasAsync = true;
	        pending++;
	
	        var resolve = once(function (resolvedDef) {
	          if (isESModule(resolvedDef)) {
	            resolvedDef = resolvedDef.default;
	          }
	          // save resolved on async factory in case it's used elsewhere
	          def.resolved = typeof resolvedDef === 'function'
	            ? resolvedDef
	            : _Vue.extend(resolvedDef);
	          match.components[key] = resolvedDef;
	          pending--;
	          if (pending <= 0) {
	            next();
	          }
	        });
	
	        var reject = once(function (reason) {
	          var msg = "Failed to resolve async component " + key + ": " + reason;
	          ("production") !== 'production' && warn(false, msg);
	          if (!error) {
	            error = isError(reason)
	              ? reason
	              : new Error(msg);
	            next(error);
	          }
	        });
	
	        var res;
	        try {
	          res = def(resolve, reject);
	        } catch (e) {
	          reject(e);
	        }
	        if (res) {
	          if (typeof res.then === 'function') {
	            res.then(resolve, reject);
	          } else {
	            // new syntax in Vue 2.3
	            var comp = res.component;
	            if (comp && typeof comp.then === 'function') {
	              comp.then(resolve, reject);
	            }
	          }
	        }
	      }
	    });
	
	    if (!hasAsync) { next(); }
	  }
	}
	
	function flatMapComponents (
	  matched,
	  fn
	) {
	  return flatten(matched.map(function (m) {
	    return Object.keys(m.components).map(function (key) { return fn(
	      m.components[key],
	      m.instances[key],
	      m, key
	    ); })
	  }))
	}
	
	function flatten (arr) {
	  return Array.prototype.concat.apply([], arr)
	}
	
	var hasSymbol =
	  typeof Symbol === 'function' &&
	  typeof Symbol.toStringTag === 'symbol';
	
	function isESModule (obj) {
	  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
	}
	
	// in Webpack 2, require.ensure now also returns a Promise
	// so the resolve/reject functions may get called an extra time
	// if the user uses an arrow function shorthand that happens to
	// return that Promise.
	function once (fn) {
	  var called = false;
	  return function () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	
	    if (called) { return }
	    called = true;
	    return fn.apply(this, args)
	  }
	}
	
	/*  */
	
	var History = function History (router, base) {
	  this.router = router;
	  this.base = normalizeBase(base);
	  // start with a route object that stands for "nowhere"
	  this.current = START;
	  this.pending = null;
	  this.ready = false;
	  this.readyCbs = [];
	  this.readyErrorCbs = [];
	  this.errorCbs = [];
	};
	
	History.prototype.listen = function listen (cb) {
	  this.cb = cb;
	};
	
	History.prototype.onReady = function onReady (cb, errorCb) {
	  if (this.ready) {
	    cb();
	  } else {
	    this.readyCbs.push(cb);
	    if (errorCb) {
	      this.readyErrorCbs.push(errorCb);
	    }
	  }
	};
	
	History.prototype.onError = function onError (errorCb) {
	  this.errorCbs.push(errorCb);
	};
	
	History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
	    var this$1 = this;
	
	  var route = this.router.match(location, this.current);
	  this.confirmTransition(route, function () {
	    this$1.updateRoute(route);
	    onComplete && onComplete(route);
	    this$1.ensureURL();
	
	    // fire ready cbs once
	    if (!this$1.ready) {
	      this$1.ready = true;
	      this$1.readyCbs.forEach(function (cb) { cb(route); });
	    }
	  }, function (err) {
	    if (onAbort) {
	      onAbort(err);
	    }
	    if (err && !this$1.ready) {
	      this$1.ready = true;
	      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
	    }
	  });
	};
	
	History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
	    var this$1 = this;
	
	  var current = this.current;
	  var abort = function (err) {
	    if (isError(err)) {
	      if (this$1.errorCbs.length) {
	        this$1.errorCbs.forEach(function (cb) { cb(err); });
	      } else {
	        warn(false, 'uncaught error during route navigation:');
	        console.error(err);
	      }
	    }
	    onAbort && onAbort(err);
	  };
	  if (
	    isSameRoute(route, current) &&
	    // in the case the route map has been dynamically appended to
	    route.matched.length === current.matched.length
	  ) {
	    this.ensureURL();
	    return abort()
	  }
	
	  var ref = resolveQueue(this.current.matched, route.matched);
	    var updated = ref.updated;
	    var deactivated = ref.deactivated;
	    var activated = ref.activated;
	
	  var queue = [].concat(
	    // in-component leave guards
	    extractLeaveGuards(deactivated),
	    // global before hooks
	    this.router.beforeHooks,
	    // in-component update hooks
	    extractUpdateHooks(updated),
	    // in-config enter guards
	    activated.map(function (m) { return m.beforeEnter; }),
	    // async components
	    resolveAsyncComponents(activated)
	  );
	
	  this.pending = route;
	  var iterator = function (hook, next) {
	    if (this$1.pending !== route) {
	      return abort()
	    }
	    try {
	      hook(route, current, function (to) {
	        if (to === false || isError(to)) {
	          // next(false) -> abort navigation, ensure current URL
	          this$1.ensureURL(true);
	          abort(to);
	        } else if (
	          typeof to === 'string' ||
	          (typeof to === 'object' && (
	            typeof to.path === 'string' ||
	            typeof to.name === 'string'
	          ))
	        ) {
	          // next('/') or next({ path: '/' }) -> redirect
	          abort();
	          if (typeof to === 'object' && to.replace) {
	            this$1.replace(to);
	          } else {
	            this$1.push(to);
	          }
	        } else {
	          // confirm transition and pass on the value
	          next(to);
	        }
	      });
	    } catch (e) {
	      abort(e);
	    }
	  };
	
	  runQueue(queue, iterator, function () {
	    var postEnterCbs = [];
	    var isValid = function () { return this$1.current === route; };
	    // wait until async components are resolved before
	    // extracting in-component enter guards
	    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
	    var queue = enterGuards.concat(this$1.router.resolveHooks);
	    runQueue(queue, iterator, function () {
	      if (this$1.pending !== route) {
	        return abort()
	      }
	      this$1.pending = null;
	      onComplete(route);
	      if (this$1.router.app) {
	        this$1.router.app.$nextTick(function () {
	          postEnterCbs.forEach(function (cb) { cb(); });
	        });
	      }
	    });
	  });
	};
	
	History.prototype.updateRoute = function updateRoute (route) {
	  var prev = this.current;
	  this.current = route;
	  this.cb && this.cb(route);
	  this.router.afterHooks.forEach(function (hook) {
	    hook && hook(route, prev);
	  });
	};
	
	function normalizeBase (base) {
	  if (!base) {
	    if (inBrowser) {
	      // respect <base> tag
	      var baseEl = document.querySelector('base');
	      base = (baseEl && baseEl.getAttribute('href')) || '/';
	      // strip full URL origin
	      base = base.replace(/^https?:\/\/[^\/]+/, '');
	    } else {
	      base = '/';
	    }
	  }
	  // make sure there's the starting slash
	  if (base.charAt(0) !== '/') {
	    base = '/' + base;
	  }
	  // remove trailing slash
	  return base.replace(/\/$/, '')
	}
	
	function resolveQueue (
	  current,
	  next
	) {
	  var i;
	  var max = Math.max(current.length, next.length);
	  for (i = 0; i < max; i++) {
	    if (current[i] !== next[i]) {
	      break
	    }
	  }
	  return {
	    updated: next.slice(0, i),
	    activated: next.slice(i),
	    deactivated: current.slice(i)
	  }
	}
	
	function extractGuards (
	  records,
	  name,
	  bind,
	  reverse
	) {
	  var guards = flatMapComponents(records, function (def, instance, match, key) {
	    var guard = extractGuard(def, name);
	    if (guard) {
	      return Array.isArray(guard)
	        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
	        : bind(guard, instance, match, key)
	    }
	  });
	  return flatten(reverse ? guards.reverse() : guards)
	}
	
	function extractGuard (
	  def,
	  key
	) {
	  if (typeof def !== 'function') {
	    // extend now so that global mixins are applied.
	    def = _Vue.extend(def);
	  }
	  return def.options[key]
	}
	
	function extractLeaveGuards (deactivated) {
	  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
	}
	
	function extractUpdateHooks (updated) {
	  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
	}
	
	function bindGuard (guard, instance) {
	  if (instance) {
	    return function boundRouteGuard () {
	      return guard.apply(instance, arguments)
	    }
	  }
	}
	
	function extractEnterGuards (
	  activated,
	  cbs,
	  isValid
	) {
	  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
	    return bindEnterGuard(guard, match, key, cbs, isValid)
	  })
	}
	
	function bindEnterGuard (
	  guard,
	  match,
	  key,
	  cbs,
	  isValid
	) {
	  return function routeEnterGuard (to, from, next) {
	    return guard(to, from, function (cb) {
	      next(cb);
	      if (typeof cb === 'function') {
	        cbs.push(function () {
	          // #750
	          // if a router-view is wrapped with an out-in transition,
	          // the instance may not have been registered at this time.
	          // we will need to poll for registration until current route
	          // is no longer valid.
	          poll(cb, match.instances, key, isValid);
	        });
	      }
	    })
	  }
	}
	
	function poll (
	  cb, // somehow flow cannot infer this is a function
	  instances,
	  key,
	  isValid
	) {
	  if (instances[key]) {
	    cb(instances[key]);
	  } else if (isValid()) {
	    setTimeout(function () {
	      poll(cb, instances, key, isValid);
	    }, 16);
	  }
	}
	
	/*  */
	
	
	var HTML5History = (function (History$$1) {
	  function HTML5History (router, base) {
	    var this$1 = this;
	
	    History$$1.call(this, router, base);
	
	    var expectScroll = router.options.scrollBehavior;
	
	    if (expectScroll) {
	      setupScroll();
	    }
	
	    var initLocation = getLocation(this.base);
	    window.addEventListener('popstate', function (e) {
	      var current = this$1.current;
	
	      // Avoiding first `popstate` event dispatched in some browsers but first
	      // history route not updated since async guard at the same time.
	      var location = getLocation(this$1.base);
	      if (this$1.current === START && location === initLocation) {
	        return
	      }
	
	      this$1.transitionTo(location, function (route) {
	        if (expectScroll) {
	          handleScroll(router, route, current, true);
	        }
	      });
	    });
	  }
	
	  if ( History$$1 ) HTML5History.__proto__ = History$$1;
	  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
	  HTML5History.prototype.constructor = HTML5History;
	
	  HTML5History.prototype.go = function go (n) {
	    window.history.go(n);
	  };
	
	  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      pushState(cleanPath(this$1.base + route.fullPath));
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      replaceState(cleanPath(this$1.base + route.fullPath));
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HTML5History.prototype.ensureURL = function ensureURL (push) {
	    if (getLocation(this.base) !== this.current.fullPath) {
	      var current = cleanPath(this.base + this.current.fullPath);
	      push ? pushState(current) : replaceState(current);
	    }
	  };
	
	  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
	    return getLocation(this.base)
	  };
	
	  return HTML5History;
	}(History));
	
	function getLocation (base) {
	  var path = window.location.pathname;
	  if (base && path.indexOf(base) === 0) {
	    path = path.slice(base.length);
	  }
	  return (path || '/') + window.location.search + window.location.hash
	}
	
	/*  */
	
	
	var HashHistory = (function (History$$1) {
	  function HashHistory (router, base, fallback) {
	    History$$1.call(this, router, base);
	    // check history fallback deeplinking
	    if (fallback && checkFallback(this.base)) {
	      return
	    }
	    ensureSlash();
	  }
	
	  if ( History$$1 ) HashHistory.__proto__ = History$$1;
	  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
	  HashHistory.prototype.constructor = HashHistory;
	
	  // this is delayed until the app mounts
	  // to avoid the hashchange listener being fired too early
	  HashHistory.prototype.setupListeners = function setupListeners () {
	    var this$1 = this;
	
	    var router = this.router;
	    var expectScroll = router.options.scrollBehavior;
	    var supportsScroll = supportsPushState && expectScroll;
	
	    if (supportsScroll) {
	      setupScroll();
	    }
	
	    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
	      var current = this$1.current;
	      if (!ensureSlash()) {
	        return
	      }
	      this$1.transitionTo(getHash(), function (route) {
	        if (supportsScroll) {
	          handleScroll(this$1.router, route, current, true);
	        }
	        if (!supportsPushState) {
	          replaceHash(route.fullPath);
	        }
	      });
	    });
	  };
	
	  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      pushHash(route.fullPath);
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      replaceHash(route.fullPath);
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HashHistory.prototype.go = function go (n) {
	    window.history.go(n);
	  };
	
	  HashHistory.prototype.ensureURL = function ensureURL (push) {
	    var current = this.current.fullPath;
	    if (getHash() !== current) {
	      push ? pushHash(current) : replaceHash(current);
	    }
	  };
	
	  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
	    return getHash()
	  };
	
	  return HashHistory;
	}(History));
	
	function checkFallback (base) {
	  var location = getLocation(base);
	  if (!/^\/#/.test(location)) {
	    window.location.replace(
	      cleanPath(base + '/#' + location)
	    );
	    return true
	  }
	}
	
	function ensureSlash () {
	  var path = getHash();
	  if (path.charAt(0) === '/') {
	    return true
	  }
	  replaceHash('/' + path);
	  return false
	}
	
	function getHash () {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var index = href.indexOf('#');
	  return index === -1 ? '' : href.slice(index + 1)
	}
	
	function getUrl (path) {
	  var href = window.location.href;
	  var i = href.indexOf('#');
	  var base = i >= 0 ? href.slice(0, i) : href;
	  return (base + "#" + path)
	}
	
	function pushHash (path) {
	  if (supportsPushState) {
	    pushState(getUrl(path));
	  } else {
	    window.location.hash = path;
	  }
	}
	
	function replaceHash (path) {
	  if (supportsPushState) {
	    replaceState(getUrl(path));
	  } else {
	    window.location.replace(getUrl(path));
	  }
	}
	
	/*  */
	
	
	var AbstractHistory = (function (History$$1) {
	  function AbstractHistory (router, base) {
	    History$$1.call(this, router, base);
	    this.stack = [];
	    this.index = -1;
	  }
	
	  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
	  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
	  AbstractHistory.prototype.constructor = AbstractHistory;
	
	  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    this.transitionTo(location, function (route) {
	      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
	      this$1.index++;
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    this.transitionTo(location, function (route) {
	      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  AbstractHistory.prototype.go = function go (n) {
	    var this$1 = this;
	
	    var targetIndex = this.index + n;
	    if (targetIndex < 0 || targetIndex >= this.stack.length) {
	      return
	    }
	    var route = this.stack[targetIndex];
	    this.confirmTransition(route, function () {
	      this$1.index = targetIndex;
	      this$1.updateRoute(route);
	    });
	  };
	
	  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
	    var current = this.stack[this.stack.length - 1];
	    return current ? current.fullPath : '/'
	  };
	
	  AbstractHistory.prototype.ensureURL = function ensureURL () {
	    // noop
	  };
	
	  return AbstractHistory;
	}(History));
	
	/*  */
	
	var VueRouter = function VueRouter (options) {
	  if ( options === void 0 ) options = {};
	
	  this.app = null;
	  this.apps = [];
	  this.options = options;
	  this.beforeHooks = [];
	  this.resolveHooks = [];
	  this.afterHooks = [];
	  this.matcher = createMatcher(options.routes || [], this);
	
	  var mode = options.mode || 'hash';
	  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
	  if (this.fallback) {
	    mode = 'hash';
	  }
	  if (!inBrowser) {
	    mode = 'abstract';
	  }
	  this.mode = mode;
	
	  switch (mode) {
	    case 'history':
	      this.history = new HTML5History(this, options.base);
	      break
	    case 'hash':
	      this.history = new HashHistory(this, options.base, this.fallback);
	      break
	    case 'abstract':
	      this.history = new AbstractHistory(this, options.base);
	      break
	    default:
	      if (false) {
	        assert(false, ("invalid mode: " + mode));
	      }
	  }
	};
	
	var prototypeAccessors = { currentRoute: { configurable: true } };
	
	VueRouter.prototype.match = function match (
	  raw,
	  current,
	  redirectedFrom
	) {
	  return this.matcher.match(raw, current, redirectedFrom)
	};
	
	prototypeAccessors.currentRoute.get = function () {
	  return this.history && this.history.current
	};
	
	VueRouter.prototype.init = function init (app /* Vue component instance */) {
	    var this$1 = this;
	
	  ("production") !== 'production' && assert(
	    install.installed,
	    "not installed. Make sure to call `Vue.use(VueRouter)` " +
	    "before creating root instance."
	  );
	
	  this.apps.push(app);
	
	  // main app already initialized.
	  if (this.app) {
	    return
	  }
	
	  this.app = app;
	
	  var history = this.history;
	
	  if (history instanceof HTML5History) {
	    history.transitionTo(history.getCurrentLocation());
	  } else if (history instanceof HashHistory) {
	    var setupHashListener = function () {
	      history.setupListeners();
	    };
	    history.transitionTo(
	      history.getCurrentLocation(),
	      setupHashListener,
	      setupHashListener
	    );
	  }
	
	  history.listen(function (route) {
	    this$1.apps.forEach(function (app) {
	      app._route = route;
	    });
	  });
	};
	
	VueRouter.prototype.beforeEach = function beforeEach (fn) {
	  return registerHook(this.beforeHooks, fn)
	};
	
	VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
	  return registerHook(this.resolveHooks, fn)
	};
	
	VueRouter.prototype.afterEach = function afterEach (fn) {
	  return registerHook(this.afterHooks, fn)
	};
	
	VueRouter.prototype.onReady = function onReady (cb, errorCb) {
	  this.history.onReady(cb, errorCb);
	};
	
	VueRouter.prototype.onError = function onError (errorCb) {
	  this.history.onError(errorCb);
	};
	
	VueRouter.prototype.push = function push (location, onComplete, onAbort) {
	  this.history.push(location, onComplete, onAbort);
	};
	
	VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
	  this.history.replace(location, onComplete, onAbort);
	};
	
	VueRouter.prototype.go = function go (n) {
	  this.history.go(n);
	};
	
	VueRouter.prototype.back = function back () {
	  this.go(-1);
	};
	
	VueRouter.prototype.forward = function forward () {
	  this.go(1);
	};
	
	VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
	  var route = to
	    ? to.matched
	      ? to
	      : this.resolve(to).route
	    : this.currentRoute;
	  if (!route) {
	    return []
	  }
	  return [].concat.apply([], route.matched.map(function (m) {
	    return Object.keys(m.components).map(function (key) {
	      return m.components[key]
	    })
	  }))
	};
	
	VueRouter.prototype.resolve = function resolve (
	  to,
	  current,
	  append
	) {
	  var location = normalizeLocation(
	    to,
	    current || this.history.current,
	    append,
	    this
	  );
	  var route = this.match(location, current);
	  var fullPath = route.redirectedFrom || route.fullPath;
	  var base = this.history.base;
	  var href = createHref(base, fullPath, this.mode);
	  return {
	    location: location,
	    route: route,
	    href: href,
	    // for backwards compat
	    normalizedTo: location,
	    resolved: route
	  }
	};
	
	VueRouter.prototype.addRoutes = function addRoutes (routes) {
	  this.matcher.addRoutes(routes);
	  if (this.history.current !== START) {
	    this.history.transitionTo(this.history.getCurrentLocation());
	  }
	};
	
	Object.defineProperties( VueRouter.prototype, prototypeAccessors );
	
	function registerHook (list, fn) {
	  list.push(fn);
	  return function () {
	    var i = list.indexOf(fn);
	    if (i > -1) { list.splice(i, 1); }
	  }
	}
	
	function createHref (base, fullPath, mode) {
	  var path = mode === 'hash' ? '#' + fullPath : fullPath;
	  return base ? cleanPath(base + '/' + path) : path
	}
	
	VueRouter.install = install;
	VueRouter.version = '2.8.1';
	
	if (inBrowser && window.Vue) {
	  window.Vue.use(VueRouter);
	}
	
	module.exports = VueRouter;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global = global || self, global.DatePicker = factory());
	}(this, (function () { 'use strict';
	
	  function _typeof(obj) {
	    "@babel/helpers - typeof";
	
	    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	      _typeof = function (obj) {
	        return typeof obj;
	      };
	    } else {
	      _typeof = function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	      };
	    }
	
	    return _typeof(obj);
	  }
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _extends() {
	    _extends = Object.assign || function (target) {
	      for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];
	
	        for (var key in source) {
	          if (Object.prototype.hasOwnProperty.call(source, key)) {
	            target[key] = source[key];
	          }
	        }
	      }
	
	      return target;
	    };
	
	    return _extends.apply(this, arguments);
	  }
	
	  function ownKeys(object, enumerableOnly) {
	    var keys = Object.keys(object);
	
	    if (Object.getOwnPropertySymbols) {
	      var symbols = Object.getOwnPropertySymbols(object);
	      if (enumerableOnly) symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	      keys.push.apply(keys, symbols);
	    }
	
	    return keys;
	  }
	
	  function _objectSpread2(target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i] != null ? arguments[i] : {};
	
	      if (i % 2) {
	        ownKeys(Object(source), true).forEach(function (key) {
	          _defineProperty(target, key, source[key]);
	        });
	      } else if (Object.getOwnPropertyDescriptors) {
	        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	      } else {
	        ownKeys(Object(source)).forEach(function (key) {
	          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	        });
	      }
	    }
	
	    return target;
	  }
	
	  function _objectWithoutPropertiesLoose(source, excluded) {
	    if (source == null) return {};
	    var target = {};
	    var sourceKeys = Object.keys(source);
	    var key, i;
	
	    for (i = 0; i < sourceKeys.length; i++) {
	      key = sourceKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      target[key] = source[key];
	    }
	
	    return target;
	  }
	
	  function _objectWithoutProperties(source, excluded) {
	    if (source == null) return {};
	
	    var target = _objectWithoutPropertiesLoose(source, excluded);
	
	    var key, i;
	
	    if (Object.getOwnPropertySymbols) {
	      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	      for (i = 0; i < sourceSymbolKeys.length; i++) {
	        key = sourceSymbolKeys[i];
	        if (excluded.indexOf(key) >= 0) continue;
	        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	        target[key] = source[key];
	      }
	    }
	
	    return target;
	  }
	
	  function _slicedToArray(arr, i) {
	    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	  }
	
	  function _arrayWithHoles(arr) {
	    if (Array.isArray(arr)) return arr;
	  }
	
	  function _iterableToArrayLimit(arr, i) {
	    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"] != null) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  function _unsupportedIterableToArray(o, minLen) {
	    if (!o) return;
	    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
	    var n = Object.prototype.toString.call(o).slice(8, -1);
	    if (n === "Object" && o.constructor) n = o.constructor.name;
	    if (n === "Map" || n === "Set") return Array.from(n);
	    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	  }
	
	  function _arrayLikeToArray(arr, len) {
	    if (len == null || len > arr.length) len = arr.length;
	
	    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
	
	    return arr2;
	  }
	
	  function _nonIterableRest() {
	    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	  }
	
	  function _extends$1() {
	    return _extends$1 = Object.assign || function (a) {
	      for (var b, c = 1; c < arguments.length; c++) {
	        for (var d in b = arguments[c], b) {
	          Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
	        }
	      }
	
	      return a;
	    }, _extends$1.apply(this, arguments);
	  }
	
	  var normalMerge = ["attrs", "props", "domProps"],
	      toArrayMerge = ["class", "style", "directives"],
	      functionalMerge = ["on", "nativeOn"],
	      mergeJsxProps = function mergeJsxProps(a) {
	    return a.reduce(function (c, a) {
	      for (var b in a) {
	        if (!c[b]) c[b] = a[b];else if (-1 !== normalMerge.indexOf(b)) c[b] = _extends$1({}, c[b], a[b]);else if (-1 !== toArrayMerge.indexOf(b)) {
	          var d = c[b] instanceof Array ? c[b] : [c[b]],
	              e = a[b] instanceof Array ? a[b] : [a[b]];
	          c[b] = d.concat(e);
	        } else if (-1 !== functionalMerge.indexOf(b)) {
	          for (var f in a[b]) {
	            if (c[b][f]) {
	              var g = c[b][f] instanceof Array ? c[b][f] : [c[b][f]],
	                  h = a[b][f] instanceof Array ? a[b][f] : [a[b][f]];
	              c[b][f] = g.concat(h);
	            } else c[b][f] = a[b][f];
	          }
	        } else if ("hook" == b) for (var i in a[b]) {
	          c[b][i] = c[b][i] ? mergeFn(c[b][i], a[b][i]) : a[b][i];
	        } else c[b] = a[b];
	      }
	
	      return c;
	    }, {});
	  },
	      mergeFn = function mergeFn(a, b) {
	    return function () {
	      a && a.apply(this, arguments), b && b.apply(this, arguments);
	    };
	  };
	
	  var helper = mergeJsxProps;
	
	  function isDate(value) {
	    return value instanceof Date || Object.prototype.toString.call(value) === '[object Date]';
	  }
	  function toDate(value) {
	    if (isDate(value)) {
	      return new Date(value.getTime());
	    }
	
	    if (value == null) {
	      return new Date(NaN);
	    }
	
	    return new Date(value);
	  }
	  function isValidDate(value) {
	    return isDate(value) && !isNaN(value.getTime());
	  }
	  function startOfWeek(value) {
	    var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	    if (!(firstDayOfWeek >= 0 && firstDayOfWeek <= 6)) {
	      throw new RangeError('weekStartsOn must be between 0 and 6');
	    }
	
	    var date = toDate(value);
	    var day = date.getDay();
	    var diff = (day + 7 - firstDayOfWeek) % 7;
	    date.setDate(date.getDate() - diff);
	    date.setHours(0, 0, 0, 0);
	    return date;
	  }
	  function startOfWeekYear(value) {
	    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        _ref$firstDayOfWeek = _ref.firstDayOfWeek,
	        firstDayOfWeek = _ref$firstDayOfWeek === void 0 ? 0 : _ref$firstDayOfWeek,
	        _ref$firstWeekContain = _ref.firstWeekContainsDate,
	        firstWeekContainsDate = _ref$firstWeekContain === void 0 ? 1 : _ref$firstWeekContain;
	
	    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	      throw new RangeError('firstWeekContainsDate must be between 1 and 7');
	    }
	
	    var date = toDate(value);
	    var year = date.getFullYear();
	    var firstDateOfFirstWeek = new Date(0);
	
	    for (var i = year + 1; i >= year - 1; i--) {
	      firstDateOfFirstWeek.setFullYear(i, 0, firstWeekContainsDate);
	      firstDateOfFirstWeek.setHours(0, 0, 0, 0);
	      firstDateOfFirstWeek = startOfWeek(firstDateOfFirstWeek, firstDayOfWeek);
	
	      if (date.getTime() >= firstDateOfFirstWeek.getTime()) {
	        break;
	      }
	    }
	
	    return firstDateOfFirstWeek;
	  }
	  function getWeek(value) {
	    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        _ref2$firstDayOfWeek = _ref2.firstDayOfWeek,
	        firstDayOfWeek = _ref2$firstDayOfWeek === void 0 ? 0 : _ref2$firstDayOfWeek,
	        _ref2$firstWeekContai = _ref2.firstWeekContainsDate,
	        firstWeekContainsDate = _ref2$firstWeekContai === void 0 ? 1 : _ref2$firstWeekContai;
	
	    var date = toDate(value);
	    var firstDateOfThisWeek = startOfWeek(date, firstDayOfWeek);
	    var firstDateOfFirstWeek = startOfWeekYear(date, {
	      firstDayOfWeek: firstDayOfWeek,
	      firstWeekContainsDate: firstWeekContainsDate
	    });
	    var diff = firstDateOfThisWeek.getTime() - firstDateOfFirstWeek.getTime();
	    return Math.round(diff / (7 * 24 * 3600 * 1000)) + 1;
	  }
	
	  var locale = {
	    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	    weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	    weekdaysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	    firstDayOfWeek: 0,
	    firstWeekContainsDate: 1
	  };
	
	  var REGEX_FORMAT = /\[([^\]]+)]|YYYY|YY?|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|m{1,2}|s{1,2}|Z{1,2}|S{1,3}|w{1,2}|x|X|a|A/g;
	
	  function pad(val) {
	    var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	    var output = "".concat(Math.abs(val));
	    var sign = val < 0 ? '-' : '';
	
	    while (output.length < len) {
	      output = "0".concat(output);
	    }
	
	    return sign + output;
	  }
	
	  function getOffset(date) {
	    return Math.round(date.getTimezoneOffset() / 15) * 15;
	  }
	
	  function formatTimezone(offset) {
	    var delimeter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var sign = offset > 0 ? '-' : '+';
	    var absOffset = Math.abs(offset);
	    var hours = Math.floor(absOffset / 60);
	    var minutes = absOffset % 60;
	    return sign + pad(hours, 2) + delimeter + pad(minutes, 2);
	  }
	
	  var meridiem = function meridiem(h, _, isLowercase) {
	    var word = h < 12 ? 'AM' : 'PM';
	    return isLowercase ? word.toLocaleLowerCase() : word;
	  };
	
	  var formatFlags = {
	    Y: function Y(date) {
	      var y = date.getFullYear();
	      return y <= 9999 ? "".concat(y) : "+".concat(y);
	    },
	    // Year: 00, 01, ..., 99
	    YY: function YY(date) {
	      return pad(date.getFullYear(), 4).substr(2);
	    },
	    // Year: 1900, 1901, ..., 2099
	    YYYY: function YYYY(date) {
	      return pad(date.getFullYear(), 4);
	    },
	    // Month: 1, 2, ..., 12
	    M: function M(date) {
	      return date.getMonth() + 1;
	    },
	    // Month: 01, 02, ..., 12
	    MM: function MM(date) {
	      return pad(date.getMonth() + 1, 2);
	    },
	    MMM: function MMM(date, locale) {
	      return locale.monthsShort[date.getMonth()];
	    },
	    MMMM: function MMMM(date, locale) {
	      return locale.months[date.getMonth()];
	    },
	    // Day of month: 1, 2, ..., 31
	    D: function D(date) {
	      return date.getDate();
	    },
	    // Day of month: 01, 02, ..., 31
	    DD: function DD(date) {
	      return pad(date.getDate(), 2);
	    },
	    // Hour: 0, 1, ... 23
	    H: function H(date) {
	      return date.getHours();
	    },
	    // Hour: 00, 01, ..., 23
	    HH: function HH(date) {
	      return pad(date.getHours(), 2);
	    },
	    // Hour: 1, 2, ..., 12
	    h: function h(date) {
	      var hours = date.getHours();
	
	      if (hours === 0) {
	        return 12;
	      }
	
	      if (hours > 12) {
	        return hours % 12;
	      }
	
	      return hours;
	    },
	    // Hour: 01, 02, ..., 12
	    hh: function hh() {
	      var hours = formatFlags.h.apply(formatFlags, arguments);
	      return pad(hours, 2);
	    },
	    // Minute: 0, 1, ..., 59
	    m: function m(date) {
	      return date.getMinutes();
	    },
	    // Minute: 00, 01, ..., 59
	    mm: function mm(date) {
	      return pad(date.getMinutes(), 2);
	    },
	    // Second: 0, 1, ..., 59
	    s: function s(date) {
	      return date.getSeconds();
	    },
	    // Second: 00, 01, ..., 59
	    ss: function ss(date) {
	      return pad(date.getSeconds(), 2);
	    },
	    // 1/10 of second: 0, 1, ..., 9
	    S: function S(date) {
	      return Math.floor(date.getMilliseconds() / 100);
	    },
	    // 1/100 of second: 00, 01, ..., 99
	    SS: function SS(date) {
	      return pad(Math.floor(date.getMilliseconds() / 10), 2);
	    },
	    // Millisecond: 000, 001, ..., 999
	    SSS: function SSS(date) {
	      return pad(date.getMilliseconds(), 3);
	    },
	    // Day of week: 0, 1, ..., 6
	    d: function d(date) {
	      return date.getDay();
	    },
	    // Day of week: 'Su', 'Mo', ..., 'Sa'
	    dd: function dd(date, locale) {
	      return locale.weekdaysMin[date.getDay()];
	    },
	    // Day of week: 'Sun', 'Mon',..., 'Sat'
	    ddd: function ddd(date, locale) {
	      return locale.weekdaysShort[date.getDay()];
	    },
	    // Day of week: 'Sunday', 'Monday', ...,'Saturday'
	    dddd: function dddd(date, locale) {
	      return locale.weekdays[date.getDay()];
	    },
	    // AM, PM
	    A: function A(date, locale) {
	      var meridiemFunc = locale.meridiem || meridiem;
	      return meridiemFunc(date.getHours(), date.getMinutes(), false);
	    },
	    // am, pm
	    a: function a(date, locale) {
	      var meridiemFunc = locale.meridiem || meridiem;
	      return meridiemFunc(date.getHours(), date.getMinutes(), true);
	    },
	    // Timezone: -01:00, +00:00, ... +12:00
	    Z: function Z(date) {
	      return formatTimezone(getOffset(date), ':');
	    },
	    // Timezone: -0100, +0000, ... +1200
	    ZZ: function ZZ(date) {
	      return formatTimezone(getOffset(date));
	    },
	    // Seconds timestamp: 512969520
	    X: function X(date) {
	      return Math.floor(date.getTime() / 1000);
	    },
	    // Milliseconds timestamp: 512969520900
	    x: function x(date) {
	      return date.getTime();
	    },
	    w: function w(date, locale) {
	      return getWeek(date, {
	        firstDayOfWeek: locale.firstDayOfWeek,
	        firstWeekContainsDate: locale.firstWeekContainsDate
	      });
	    },
	    ww: function ww(date, locale) {
	      return pad(formatFlags.w(date, locale), 2);
	    }
	  };
	  function format(val, str) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var formatStr = str ? String(str) : 'YYYY-MM-DDTHH:mm:ss.SSSZ';
	    var date = toDate(val);
	
	    if (!isValidDate(date)) {
	      return 'Invalid Date';
	    }
	
	    var locale$1 = options.locale || locale;
	    return formatStr.replace(REGEX_FORMAT, function (match, p1) {
	      if (p1) {
	        return p1;
	      }
	
	      if (typeof formatFlags[match] === 'function') {
	        return "".concat(formatFlags[match](date, locale$1));
	      }
	
	      return match;
	    });
	  }
	
	  function _toConsumableArray(arr) {
	    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
	  }
	
	  function _nonIterableSpread() {
	    throw new TypeError("Invalid attempt to spread non-iterable instance");
	  }
	
	  function _iterableToArray(iter) {
	    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
	  }
	
	  function _arrayWithoutHoles(arr) {
	    if (Array.isArray(arr)) {
	      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
	        arr2[i] = arr[i];
	      }
	
	      return arr2;
	    }
	  }
	
	  function ownKeys$1(object, enumerableOnly) {
	    var keys = Object.keys(object);
	
	    if (Object.getOwnPropertySymbols) {
	      var symbols = Object.getOwnPropertySymbols(object);
	      if (enumerableOnly) symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	      keys.push.apply(keys, symbols);
	    }
	
	    return keys;
	  }
	
	  function _objectSpread(target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i] != null ? arguments[i] : {};
	
	      if (i % 2) {
	        ownKeys$1(source, true).forEach(function (key) {
	          _defineProperty$1(target, key, source[key]);
	        });
	      } else if (Object.getOwnPropertyDescriptors) {
	        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	      } else {
	        ownKeys$1(source).forEach(function (key) {
	          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	        });
	      }
	    }
	
	    return target;
	  }
	
	  function _slicedToArray$1(arr, i) {
	    return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _nonIterableRest$1();
	  }
	
	  function _nonIterableRest$1() {
	    throw new TypeError("Invalid attempt to destructure non-iterable instance");
	  }
	
	  function _iterableToArrayLimit$1(arr, i) {
	    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
	      return;
	    }
	
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"] != null) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  function _arrayWithHoles$1(arr) {
	    if (Array.isArray(arr)) return arr;
	  }
	
	  function _defineProperty$1(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	  var formattingTokens = /(\[[^\[]*\])|(MM?M?M?|Do|DD?|ddd?d?|w[o|w]?|YYYY|YY|a|A|hh?|HH?|mm?|ss?|S{1,3}|x|X|ZZ?|.)/g;
	  var match1 = /\d/; // 0 - 9
	
	  var match2 = /\d\d/; // 00 - 99
	
	  var match3 = /\d{3}/; // 000 - 999
	
	  var match4 = /\d{4}/; // 0000 - 9999
	
	  var match1to2 = /\d\d?/; // 0 - 99
	
	  var matchShortOffset = /[+-]\d\d:?\d\d/; // +00:00 -00:00 +0000 or -0000
	
	  var matchSigned = /[+-]?\d+/; // -inf - inf
	
	  var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	  // const matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i; // Word
	
	  var YEAR = 'year';
	  var MONTH = 'month';
	  var DAY = 'day';
	  var HOUR = 'hour';
	  var MINUTE = 'minute';
	  var SECOND = 'second';
	  var MILLISECOND = 'millisecond';
	  var parseFlags = {};
	
	  var addParseFlag = function addParseFlag(token, regex, callback) {
	    var tokens = Array.isArray(token) ? token : [token];
	    var func;
	
	    if (typeof callback === 'string') {
	      func = function func(input) {
	        var value = parseInt(input, 10);
	        return _defineProperty$1({}, callback, value);
	      };
	    } else {
	      func = callback;
	    }
	
	    tokens.forEach(function (key) {
	      parseFlags[key] = [regex, func];
	    });
	  };
	
	  var escapeStringRegExp = function escapeStringRegExp(str) {
	    return str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
	  };
	
	  var matchWordRegExp = function matchWordRegExp(localeKey) {
	    return function (locale) {
	      var array = locale[localeKey];
	
	      if (!Array.isArray(array)) {
	        throw new Error("Locale[".concat(localeKey, "] need an array"));
	      }
	
	      return new RegExp(array.map(escapeStringRegExp).join('|'));
	    };
	  };
	
	  var matchWordCallback = function matchWordCallback(localeKey, key) {
	    return function (input, locale) {
	      var array = locale[localeKey];
	
	      if (!Array.isArray(array)) {
	        throw new Error("Locale[".concat(localeKey, "] need an array"));
	      }
	
	      var index = array.indexOf(input);
	
	      if (index < 0) {
	        throw new Error('Invalid Word');
	      }
	
	      return _defineProperty$1({}, key, index);
	    };
	  };
	
	  addParseFlag('Y', matchSigned, YEAR);
	  addParseFlag('YY', match2, function (input) {
	    var year = new Date().getFullYear();
	    var cent = Math.floor(year / 100);
	    var value = parseInt(input, 10);
	    value = (value > 68 ? cent - 1 : cent) * 100 + value;
	    return _defineProperty$1({}, YEAR, value);
	  });
	  addParseFlag('YYYY', match4, YEAR);
	  addParseFlag('M', match1to2, function (input) {
	    return _defineProperty$1({}, MONTH, parseInt(input, 10) - 1);
	  });
	  addParseFlag('MM', match2, function (input) {
	    return _defineProperty$1({}, MONTH, parseInt(input, 10) - 1);
	  });
	  addParseFlag('MMM', matchWordRegExp('monthsShort'), matchWordCallback('monthsShort', MONTH));
	  addParseFlag('MMMM', matchWordRegExp('months'), matchWordCallback('months', MONTH));
	  addParseFlag('D', match1to2, DAY);
	  addParseFlag('DD', match2, DAY);
	  addParseFlag(['H', 'h'], match1to2, HOUR);
	  addParseFlag(['HH', 'hh'], match2, HOUR);
	  addParseFlag('m', match1to2, MINUTE);
	  addParseFlag('mm', match2, MINUTE);
	  addParseFlag('s', match1to2, SECOND);
	  addParseFlag('ss', match2, SECOND);
	  addParseFlag('S', match1, function (input) {
	    return _defineProperty$1({}, MILLISECOND, parseInt(input, 10) * 100);
	  });
	  addParseFlag('SS', match2, function (input) {
	    return _defineProperty$1({}, MILLISECOND, parseInt(input, 10) * 10);
	  });
	  addParseFlag('SSS', match3, MILLISECOND);
	
	  function matchMeridiem(locale) {
	    return locale.meridiemParse || /[ap]\.?m?\.?/i;
	  }
	
	  function defaultIsPM(input) {
	    return "".concat(input).toLowerCase().charAt(0) === 'p';
	  }
	
	  addParseFlag(['A', 'a'], matchMeridiem, function (input, locale) {
	    var isPM = typeof locale.isPM === 'function' ? locale.isPM(input) : defaultIsPM(input);
	    return {
	      isPM: isPM
	    };
	  });
	
	  function offsetFromString(str) {
	    var _ref8 = str.match(/([+-]|\d\d)/g) || ['-', '0', '0'],
	        _ref9 = _slicedToArray$1(_ref8, 3),
	        symbol = _ref9[0],
	        hour = _ref9[1],
	        minute = _ref9[2];
	
	    var minutes = parseInt(hour, 10) * 60 + parseInt(minute, 10);
	
	    if (minutes === 0) {
	      return 0;
	    }
	
	    return symbol === '+' ? -minutes : +minutes;
	  }
	
	  addParseFlag(['Z', 'ZZ'], matchShortOffset, function (input) {
	    return {
	      offset: offsetFromString(input)
	    };
	  });
	  addParseFlag('x', matchSigned, function (input) {
	    return {
	      date: new Date(parseInt(input, 10))
	    };
	  });
	  addParseFlag('X', matchTimestamp, function (input) {
	    return {
	      date: new Date(parseFloat(input) * 1000)
	    };
	  });
	  addParseFlag('d', match1, 'weekday');
	  addParseFlag('dd', matchWordRegExp('weekdaysMin'), matchWordCallback('weekdaysMin', 'weekday'));
	  addParseFlag('ddd', matchWordRegExp('weekdaysShort'), matchWordCallback('weekdaysShort', 'weekday'));
	  addParseFlag('dddd', matchWordRegExp('weekdays'), matchWordCallback('weekdays', 'weekday'));
	  addParseFlag('w', match1to2, 'week');
	  addParseFlag('ww', match2, 'week');
	
	  function to24hour(hour, isPM) {
	    if (hour !== undefined && isPM !== undefined) {
	      if (isPM) {
	        if (hour < 12) {
	          return hour + 12;
	        }
	      } else if (hour === 12) {
	        return 0;
	      }
	    }
	
	    return hour;
	  }
	
	  function getFullInputArray(input) {
	    var backupDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
	    var result = [0, 0, 1, 0, 0, 0, 0];
	    var backupArr = [backupDate.getFullYear(), backupDate.getMonth(), backupDate.getDate(), backupDate.getHours(), backupDate.getMinutes(), backupDate.getSeconds(), backupDate.getMilliseconds()];
	    var useBackup = true;
	
	    for (var i = 0; i < 7; i++) {
	      if (input[i] === undefined) {
	        result[i] = useBackup ? backupArr[i] : result[i];
	      } else {
	        result[i] = input[i];
	        useBackup = false;
	      }
	    }
	
	    return result;
	  }
	
	  function createDate(y, m, d, h, M, s, ms) {
	    var date;
	
	    if (y < 100 && y >= 0) {
	      date = new Date(y + 400, m, d, h, M, s, ms);
	
	      if (isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	      }
	    } else {
	      date = new Date(y, m, d, h, M, s, ms);
	    }
	
	    return date;
	  }
	
	  function createUTCDate() {
	    var date;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var y = args[0];
	
	    if (y < 100 && y >= 0) {
	      args[0] += 400;
	      date = new Date(Date.UTC.apply(Date, args)); // eslint-disable-next-line no-restricted-globals
	
	      if (isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	      }
	    } else {
	      date = new Date(Date.UTC.apply(Date, args));
	    }
	
	    return date;
	  }
	
	  function makeParser(dateString, format, locale) {
	    var tokens = format.match(formattingTokens);
	
	    if (!tokens) {
	      throw new Error();
	    }
	
	    var length = tokens.length;
	    var mark = {};
	
	    for (var i = 0; i < length; i += 1) {
	      var token = tokens[i];
	      var parseTo = parseFlags[token];
	
	      if (!parseTo) {
	        var word = token.replace(/^\[|\]$/g, '');
	
	        if (dateString.indexOf(word) === 0) {
	          dateString = dateString.substr(word.length);
	        } else {
	          throw new Error('not match');
	        }
	      } else {
	        var regex = typeof parseTo[0] === 'function' ? parseTo[0](locale) : parseTo[0];
	        var parser = parseTo[1];
	        var value = (regex.exec(dateString) || [])[0];
	        var obj = parser(value, locale);
	        mark = _objectSpread({}, mark, {}, obj);
	        dateString = dateString.replace(value, '');
	      }
	    }
	
	    return mark;
	  }
	
	  function parse(str, format) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    try {
	      var _options$locale = options.locale,
	          _locale = _options$locale === void 0 ? locale : _options$locale,
	          _options$backupDate = options.backupDate,
	          backupDate = _options$backupDate === void 0 ? new Date() : _options$backupDate;
	
	      var parseResult = makeParser(str, format, _locale);
	      var year = parseResult.year,
	          month = parseResult.month,
	          day = parseResult.day,
	          hour = parseResult.hour,
	          minute = parseResult.minute,
	          second = parseResult.second,
	          millisecond = parseResult.millisecond,
	          isPM = parseResult.isPM,
	          date = parseResult.date,
	          offset = parseResult.offset,
	          weekday = parseResult.weekday,
	          week = parseResult.week;
	
	      if (date) {
	        return date;
	      }
	
	      var inputArray = [year, month, day, hour, minute, second, millisecond];
	      inputArray[3] = to24hour(inputArray[3], isPM); // check week
	
	      if (week !== undefined && month === undefined && day === undefined) {
	        // new Date(year, 3) make sure in current year
	        var firstDate = startOfWeekYear(year === undefined ? backupDate : new Date(year, 3), {
	          firstDayOfWeek: _locale.firstDayOfWeek,
	          firstWeekContainsDate: _locale.firstWeekContainsDate
	        });
	        return new Date(firstDate.getTime() + (week - 1) * 7 * 24 * 3600 * 1000);
	      }
	
	      var parsedDate;
	      var result = getFullInputArray(inputArray, backupDate);
	
	      if (offset !== undefined) {
	        result[6] += offset * 60 * 1000;
	        parsedDate = createUTCDate.apply(void 0, _toConsumableArray(result));
	      } else {
	        parsedDate = createDate.apply(void 0, _toConsumableArray(result));
	      } // check weekday
	
	
	      if (weekday !== undefined && parsedDate.getDay() !== weekday) {
	        return new Date(NaN);
	      }
	
	      return parsedDate;
	    } catch (e) {
	      return new Date(NaN);
	    }
	  }
	
	  // new Date(10, 0, 1) The year from 0 to 99 will be incremented by 1900 automatically.
	  function createDate$1(y) {
	    var M = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	    var h = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	    var m = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	    var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	    var ms = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
	    var date = new Date(y, M, d, h, m, s, ms);
	
	    if (y < 100 && y >= 0) {
	      date.setFullYear(y);
	    }
	
	    return date;
	  }
	  function isValidDate$1(date) {
	    return date instanceof Date && !isNaN(date);
	  }
	  function isValidRangeDate(date) {
	    return Array.isArray(date) && date.length === 2 && date.every(isValidDate$1) && date[0] <= date[1];
	  }
	  function isValidDates(dates) {
	    return Array.isArray(dates) && dates.every(isValidDate$1);
	  }
	  function getValidDate(value) {
	    var date = new Date(value);
	
	    if (isValidDate$1(date)) {
	      return date;
	    }
	
	    for (var _len = arguments.length, backup = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      backup[_key - 1] = arguments[_key];
	    }
	
	    if (backup.length) {
	      return getValidDate.apply(void 0, backup);
	    }
	
	    return new Date();
	  }
	  function startOfYear(value) {
	    var date = new Date(value);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	    return date;
	  }
	  function startOfMonth(value) {
	    var date = new Date(value);
	    date.setDate(1);
	    date.setHours(0, 0, 0, 0);
	    return date;
	  }
	  function startOfDay(value) {
	    var date = new Date(value);
	    date.setHours(0, 0, 0, 0);
	    return date;
	  }
	  function getCalendar(_ref) {
	    var firstDayOfWeek = _ref.firstDayOfWeek,
	        year = _ref.year,
	        month = _ref.month;
	    var arr = []; // change to the last day of the last month
	
	    var calendar = createDate$1(year, month, 0);
	    var lastDayInLastMonth = calendar.getDate(); // getDay() 0 is Sunday, 1 is Monday
	
	    var firstDayInLastMonth = lastDayInLastMonth - (calendar.getDay() + 7 - firstDayOfWeek) % 7;
	
	    for (var i = firstDayInLastMonth; i <= lastDayInLastMonth; i++) {
	      arr.push(createDate$1(year, month, i - lastDayInLastMonth));
	    } // change to the last day of the current month
	
	
	    calendar.setMonth(month + 1, 0);
	    var lastDayInCurrentMonth = calendar.getDate();
	
	    for (var _i = 1; _i <= lastDayInCurrentMonth; _i++) {
	      arr.push(createDate$1(year, month, _i));
	    }
	
	    var lastMonthLength = lastDayInLastMonth - firstDayInLastMonth + 1;
	    var nextMonthLength = 6 * 7 - lastMonthLength - lastDayInCurrentMonth;
	
	    for (var _i2 = 1; _i2 <= nextMonthLength; _i2++) {
	      arr.push(createDate$1(year, month, lastDayInCurrentMonth + _i2));
	    }
	
	    return arr;
	  }
	  function setMonth(dirtyDate, dirtyMonth) {
	    var date = new Date(dirtyDate);
	    var month = typeof dirtyMonth === 'function' ? dirtyMonth(date.getMonth()) : Number(dirtyMonth);
	    var year = date.getFullYear();
	    var daysInMonth = createDate$1(year, month + 1, 0).getDate();
	    var day = date.getDate();
	    date.setMonth(month, Math.min(day, daysInMonth));
	    return date;
	  }
	  function setYear(dirtyDate, dirtyYear) {
	    var date = new Date(dirtyDate);
	    var year = typeof dirtyYear === 'function' ? dirtyYear(date.getFullYear()) : dirtyYear;
	    date.setFullYear(year);
	    return date;
	  }
	  function assignTime(target, source) {
	    var date = new Date(target);
	    var time = new Date(source);
	    date.setHours(time.getHours(), time.getMinutes(), time.getSeconds());
	    return date;
	  }
	
	  /**
	   * chunk the array
	   * @param {Array} arr
	   * @param {Number} size
	   */
	  function chunk(arr, size) {
	    if (!Array.isArray(arr)) {
	      return [];
	    }
	
	    var result = [];
	    var len = arr.length;
	    var i = 0;
	    size = size || len;
	
	    while (i < len) {
	      result.push(arr.slice(i, i += size));
	    }
	
	    return result;
	  }
	  /**
	   * isObject
	   * @param {*} obj
	   * @returns {Boolean}
	   */
	
	  function isObject(obj) {
	    return Object.prototype.toString.call(obj) === '[object Object]';
	  }
	  /**
	   * pick object
	   * @param {Object} obj
	   * @param {Array|String} props
	   */
	
	  function pick(obj, props) {
	    if (!isObject(obj)) return {};
	
	    if (!Array.isArray(props)) {
	      props = [props];
	    }
	
	    var res = {};
	    props.forEach(function (prop) {
	      if (prop in obj) {
	        res[prop] = obj[prop];
	      }
	    });
	    return res;
	  }
	  /**
	   * deep merge two object without merging array
	   * @param {object} target
	   * @param {object} source
	   */
	
	  function mergeDeep(target, source) {
	    if (!isObject(target)) {
	      return {};
	    }
	
	    var result = target;
	
	    if (isObject(source)) {
	      Object.keys(source).forEach(function (key) {
	        var value = source[key];
	
	        if (isObject(value) && isObject(target[key])) {
	          value = mergeDeep(target[key], value);
	        }
	
	        result = _objectSpread2({}, result, _defineProperty({}, key, value));
	      });
	    }
	
	    return result;
	  }
	
	  function unwrapExports (x) {
	  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	  }
	
	  function createCommonjsModule(fn, module) {
	  	return module = { exports: {} }, fn(module, module.exports), module.exports;
	  }
	
	  var en = createCommonjsModule(function (module, exports) {
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports["default"] = void 0;
	  var locale = {
	    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	    weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	    weekdaysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	    firstDayOfWeek: 0,
	    firstWeekContainsDate: 1
	  };
	  var _default = locale;
	  exports["default"] = _default;
	  module.exports = exports.default;
	  });
	
	  var en$1 = unwrapExports(en);
	
	  var lang = {
	    formatLocale: en$1,
	    yearFormat: 'YYYY',
	    monthFormat: 'MMM',
	    monthBeforeYear: true
	  };
	
	  var defaultLocale = 'en';
	  var locales = {};
	  locales[defaultLocale] = lang;
	  function locale$1(name, object, isLocal) {
	    if (typeof name !== 'string') return locales[defaultLocale];
	    var l = defaultLocale;
	
	    if (locales[name]) {
	      l = name;
	    }
	
	    if (object) {
	      locales[name] = object;
	      l = name;
	    }
	
	    if (!isLocal) {
	      defaultLocale = l;
	    }
	
	    return locales[name] || locales[defaultLocale];
	  }
	  /**
	   * get locale object
	   * @param {string} name lang
	   */
	
	  function getLocale(name) {
	    return locale$1(name, null, true);
	  }
	
	  /* istanbul ignore file */
	  function rafThrottle(fn) {
	    var isRunning = false;
	    return function fnBinfRaf() {
	      var _this = this;
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      if (isRunning) return;
	      isRunning = true;
	      requestAnimationFrame(function () {
	        isRunning = false;
	        fn.apply(_this, args);
	      });
	    };
	  }
	
	  /**
	   * get the hidden element width, height
	   * @param {HTMLElement} element dom
	   */
	  function getPopupElementSize(element) {
	    var originalDisplay = element.style.display;
	    var originalVisibility = element.style.visibility;
	    element.style.display = 'block';
	    element.style.visibility = 'hidden';
	    var styles = window.getComputedStyle(element);
	    var width = element.offsetWidth + parseInt(styles.marginLeft, 10) + parseInt(styles.marginRight, 10);
	    var height = element.offsetHeight + parseInt(styles.marginTop, 10) + parseInt(styles.marginBottom, 10);
	    element.style.display = originalDisplay;
	    element.style.visibility = originalVisibility;
	    return {
	      width: width,
	      height: height
	    };
	  }
	  /**
	   * get the popup position
	   * @param {HTMLElement} el relative element
	   * @param {Number} targetWidth target element's width
	   * @param {Number} targetHeight target element's height
	   * @param {Boolean} fixed
	   */
	
	  function getRelativePosition(el, targetWidth, targetHeight, fixed) {
	    var left = 0;
	    var top = 0;
	    var offsetX = 0;
	    var offsetY = 0;
	    var relativeRect = el.getBoundingClientRect();
	    var dw = document.documentElement.clientWidth;
	    var dh = document.documentElement.clientHeight;
	
	    if (fixed) {
	      offsetX = window.pageXOffset + relativeRect.left;
	      offsetY = window.pageYOffset + relativeRect.top;
	    }
	
	    if (dw - relativeRect.left < targetWidth && relativeRect.right < targetWidth) {
	      left = offsetX - relativeRect.left + 1;
	    } else if (relativeRect.left + relativeRect.width / 2 <= dw / 2) {
	      left = offsetX;
	    } else {
	      left = offsetX + relativeRect.width - targetWidth;
	    }
	
	    if (relativeRect.top <= targetHeight && dh - relativeRect.bottom <= targetHeight) {
	      top = offsetY + dh - relativeRect.top - targetHeight;
	    } else if (relativeRect.top + relativeRect.height / 2 <= dh / 2) {
	      top = offsetY + relativeRect.height;
	    } else {
	      top = offsetY - targetHeight;
	    }
	
	    return {
	      left: "".concat(left, "px"),
	      top: "".concat(top, "px")
	    };
	  }
	  function getScrollParent(node) {
	    var until = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;
	
	    if (!node || node === until) {
	      return null;
	    }
	
	    var style = function style(value, prop) {
	      return getComputedStyle(value, null).getPropertyValue(prop);
	    };
	
	    var regex = /(auto|scroll)/;
	    var scroll = regex.test(style(node, 'overflow') + style(node, 'overflow-y') + style(node, 'overflow-x'));
	    return scroll ? node : getScrollParent(node.parentNode, until);
	  }
	
	  //
	  var script = {
	    name: 'Popup',
	    inject: {
	      prefixClass: {
	        default: 'mx'
	      }
	    },
	    props: {
	      visible: {
	        type: Boolean,
	        default: false
	      },
	      appendToBody: {
	        type: Boolean,
	        default: true
	      }
	    },
	    data: function data() {
	      return {
	        top: '',
	        left: ''
	      };
	    },
	    watch: {
	      visible: {
	        immediate: true,
	        handler: function handler(val) {
	          var _this = this;
	
	          this.$nextTick(function () {
	            if (val) {
	              _this.displayPopup();
	            }
	          });
	        }
	      }
	    },
	    mounted: function mounted() {
	      var _this2 = this;
	
	      if (this.appendToBody) {
	        document.body.appendChild(this.$el);
	      }
	
	      this._clickoutEvent = 'ontouchend' in document ? 'touchstart' : 'mousedown';
	      document.addEventListener(this._clickoutEvent, this.handleClickOutside); // change the popup position when resize or scroll
	
	      var relativeElement = this.$parent.$el;
	      this._displayPopup = rafThrottle(function () {
	        return _this2.displayPopup();
	      });
	      this._scrollParent = getScrollParent(relativeElement) || window;
	
	      this._scrollParent.addEventListener('scroll', this._displayPopup);
	
	      window.addEventListener('resize', this._displayPopup);
	    },
	    beforeDestroy: function beforeDestroy() {
	      if (this.appendToBody && this.$el.parentNode) {
	        this.$el.parentNode.removeChild(this.$el);
	      }
	
	      document.removeEventListener(this._clickoutEvent, this.handleClickOutside);
	
	      this._scrollParent.removeEventListener('scroll', this._displayPopup);
	
	      window.removeEventListener('resize', this._displayPopup);
	    },
	    methods: {
	      handleClickOutside: function handleClickOutside(evt) {
	        if (!this.visible) return;
	        var target = evt.target;
	        var el = this.$el;
	
	        if (el && !el.contains(target)) {
	          this.$emit('clickoutside', evt);
	        }
	      },
	      displayPopup: function displayPopup() {
	        if (!this.visible) return;
	        var popup = this.$el;
	        var relativeElement = this.$parent.$el;
	        var appendToBody = this.appendToBody;
	
	        if (!this._popupRect) {
	          this._popupRect = getPopupElementSize(popup);
	        }
	
	        var _this$_popupRect = this._popupRect,
	            width = _this$_popupRect.width,
	            height = _this$_popupRect.height;
	
	        var _getRelativePosition = getRelativePosition(relativeElement, width, height, appendToBody),
	            left = _getRelativePosition.left,
	            top = _getRelativePosition.top;
	
	        this.left = left;
	        this.top = top;
	      }
	    }
	  };
	
	  function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
	  /* server only */
	  , shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
	    if (typeof shadowMode !== 'boolean') {
	      createInjectorSSR = createInjector;
	      createInjector = shadowMode;
	      shadowMode = false;
	    } // Vue.extend constructor export interop.
	
	
	    var options = typeof script === 'function' ? script.options : script; // render functions
	
	    if (template && template.render) {
	      options.render = template.render;
	      options.staticRenderFns = template.staticRenderFns;
	      options._compiled = true; // functional template
	
	      if (isFunctionalTemplate) {
	        options.functional = true;
	      }
	    } // scopedId
	
	
	    if (scopeId) {
	      options._scopeId = scopeId;
	    }
	
	    var hook;
	
	    if (moduleIdentifier) {
	      // server build
	      hook = function hook(context) {
	        // 2.3 injection
	        context = context || // cached call
	        this.$vnode && this.$vnode.ssrContext || // stateful
	        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
	        // 2.2 with runInNewContext: true
	
	        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	          context = __VUE_SSR_CONTEXT__;
	        } // inject component styles
	
	
	        if (style) {
	          style.call(this, createInjectorSSR(context));
	        } // register component module identifier for async chunk inference
	
	
	        if (context && context._registeredComponents) {
	          context._registeredComponents.add(moduleIdentifier);
	        }
	      }; // used by ssr in case component is cached and beforeCreate
	      // never gets called
	
	
	      options._ssrRegister = hook;
	    } else if (style) {
	      hook = shadowMode ? function (context) {
	        style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
	      } : function (context) {
	        style.call(this, createInjector(context));
	      };
	    }
	
	    if (hook) {
	      if (options.functional) {
	        // register for functional component in vue file
	        var originalRender = options.render;
	
	        options.render = function renderWithStyleInjection(h, context) {
	          hook.call(context);
	          return originalRender(h, context);
	        };
	      } else {
	        // inject component registration as beforeCreate hook
	        var existing = options.beforeCreate;
	        options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
	      }
	    }
	
	    return script;
	  }
	
	  /* script */
	  var __vue_script__ = script;
	  /* template */
	
	  var __vue_render__ = function __vue_render__() {
	    var _vm = this;
	
	    var _h = _vm.$createElement;
	
	    var _c = _vm._self._c || _h;
	
	    return _c('transition', {
	      attrs: {
	        "name": _vm.prefixClass + "-zoom-in-down"
	      }
	    }, [_vm.visible ? _c('div', {
	      class: _vm.prefixClass + "-datepicker-main " + _vm.prefixClass + "-datepicker-popup",
	      style: {
	        top: _vm.top,
	        left: _vm.left,
	        position: 'absolute'
	      }
	    }, [_vm._t("default")], 2) : _vm._e()]);
	  };
	
	  var __vue_staticRenderFns__ = [];
	  /* style */
	
	  var __vue_inject_styles__ = undefined;
	  /* scoped */
	
	  var __vue_scope_id__ = undefined;
	  /* module identifier */
	
	  var __vue_module_identifier__ = undefined;
	  /* functional template */
	
	  var __vue_is_functional_template__ = false;
	  /* style inject */
	
	  /* style inject SSR */
	
	  /* style inject shadow dom */
	
	  var __vue_component__ = normalizeComponent({
	    render: __vue_render__,
	    staticRenderFns: __vue_staticRenderFns__
	  }, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
	
	  /* script */
	
	  /* template */
	  var __vue_render__$1 = function __vue_render__() {
	    var _vm = this;
	
	    var _h = _vm.$createElement;
	
	    var _c = _vm._self._c || _h;
	
	    return _c('svg', {
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "viewBox": "0 0 1024 1024",
	        "width": "1em",
	        "height": "1em"
	      }
	    }, [_c('path', {
	      attrs: {
	        "d": "M940.218182 107.054545h-209.454546V46.545455h-65.163636v60.50909H363.054545V46.545455H297.890909v60.50909H83.781818c-18.618182 0-32.581818 13.963636-32.581818 32.581819v805.236363c0 18.618182 13.963636 32.581818 32.581818 32.581818h861.090909c18.618182 0 32.581818-13.963636 32.581818-32.581818V139.636364c-4.654545-18.618182-18.618182-32.581818-37.236363-32.581819zM297.890909 172.218182V232.727273h65.163636V172.218182h307.2V232.727273h65.163637V172.218182h176.872727v204.8H116.363636V172.218182h181.527273zM116.363636 912.290909V442.181818h795.927273v470.109091H116.363636z"
	      }
	    })]);
	  };
	
	  var __vue_staticRenderFns__$1 = [];
	  /* style */
	
	  var __vue_inject_styles__$1 = undefined;
	  /* scoped */
	
	  var __vue_scope_id__$1 = undefined;
	  /* module identifier */
	
	  var __vue_module_identifier__$1 = undefined;
	  /* functional template */
	
	  var __vue_is_functional_template__$1 = false;
	  /* style inject */
	
	  /* style inject SSR */
	
	  /* style inject shadow dom */
	
	  var __vue_component__$1 = normalizeComponent({
	    render: __vue_render__$1,
	    staticRenderFns: __vue_staticRenderFns__$1
	  }, __vue_inject_styles__$1, {}, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);
	
	  /* script */
	
	  /* template */
	  var __vue_render__$2 = function __vue_render__() {
	    var _vm = this;
	
	    var _h = _vm.$createElement;
	
	    var _c = _vm._self._c || _h;
	
	    return _c('svg', {
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "viewBox": "0 0 24 24",
	        "width": "1em",
	        "height": "1em"
	      }
	    }, [_c('path', {
	      attrs: {
	        "d": "M0 0h24v24H0z",
	        "fill": "none"
	      }
	    }), _vm._v(" "), _c('path', {
	      attrs: {
	        "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	      }
	    }), _vm._v(" "), _c('path', {
	      attrs: {
	        "d": "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
	      }
	    })]);
	  };
	
	  var __vue_staticRenderFns__$2 = [];
	  /* style */
	
	  var __vue_inject_styles__$2 = undefined;
	  /* scoped */
	
	  var __vue_scope_id__$2 = undefined;
	  /* module identifier */
	
	  var __vue_module_identifier__$2 = undefined;
	  /* functional template */
	
	  var __vue_is_functional_template__$2 = false;
	  /* style inject */
	
	  /* style inject SSR */
	
	  /* style inject shadow dom */
	
	  var __vue_component__$2 = normalizeComponent({
	    render: __vue_render__$2,
	    staticRenderFns: __vue_staticRenderFns__$2
	  }, __vue_inject_styles__$2, {}, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);
	
	  /* script */
	
	  /* template */
	  var __vue_render__$3 = function __vue_render__() {
	    var _vm = this;
	
	    var _h = _vm.$createElement;
	
	    var _c = _vm._self._c || _h;
	
	    return _c('svg', {
	      attrs: {
	        "xmlns": "http://www.w3.org/2000/svg",
	        "viewBox": "0 0 1024 1024",
	        "width": "1em",
	        "height": "1em"
	      }
	    }, [_c('path', {
	      attrs: {
	        "d": "M810.005333 274.005333l-237.994667 237.994667 237.994667 237.994667-60.010667 60.010667-237.994667-237.994667-237.994667 237.994667-60.010667-60.010667 237.994667-237.994667-237.994667-237.994667 60.010667-60.010667 237.994667 237.994667 237.994667-237.994667z"
	      }
	    })]);
	  };
	
	  var __vue_staticRenderFns__$3 = [];
	  /* style */
	
	  var __vue_inject_styles__$3 = undefined;
	  /* scoped */
	
	  var __vue_scope_id__$3 = undefined;
	  /* module identifier */
	
	  var __vue_module_identifier__$3 = undefined;
	  /* functional template */
	
	  var __vue_is_functional_template__$3 = false;
	  /* style inject */
	
	  /* style inject SSR */
	
	  /* style inject shadow dom */
	
	  var __vue_component__$3 = normalizeComponent({
	    render: __vue_render__$3,
	    staticRenderFns: __vue_staticRenderFns__$3
	  }, __vue_inject_styles__$3, {}, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);
	
	  //
	  //
	  //
	  //
	  //
	  //
	  //
	  //
	  //
	  //
	  var script$1 = {
	    props: {
	      type: String
	    },
	    inject: {
	      prefixClass: {
	        default: 'mx'
	      }
	    }
	  };
	
	  /* script */
	  var __vue_script__$1 = script$1;
	  /* template */
	
	  var __vue_render__$4 = function __vue_render__() {
	    var _vm = this;
	
	    var _h = _vm.$createElement;
	
	    var _c = _vm._self._c || _h;
	
	    return _c('button', _vm._g({
	      class: _vm.prefixClass + "-btn " + _vm.prefixClass + "-btn-text " + _vm.prefixClass + "-btn-icon-" + _vm.type,
	      attrs: {
	        "type": "button"
	      }
	    }, _vm.$listeners), [_c('i', {
	      class: _vm.prefixClass + "-icon-" + _vm.type
	    })]);
	  };
	
	  var __vue_staticRenderFns__$4 = [];
	  /* style */
	
	  var __vue_inject_styles__$4 = undefined;
	  /* scoped */
	
	  var __vue_scope_id__$4 = undefined;
	  /* module identifier */
	
	  var __vue_module_identifier__$4 = undefined;
	  /* functional template */
	
	  var __vue_is_functional_template__$4 = false;
	  /* style inject */
	
	  /* style inject SSR */
	
	  /* style inject shadow dom */
	
	  var __vue_component__$4 = normalizeComponent({
	    render: __vue_render__$4,
	    staticRenderFns: __vue_staticRenderFns__$4
	  }, __vue_inject_styles__$4, __vue_script__$1, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, undefined, undefined, undefined);
	
	  var script$2 = {
	    name: 'TableDate',
	    components: {
	      IconButton: __vue_component__$4
	    },
	    inject: {
	      getLocale: {
	        default: function _default() {
	          return getLocale;
	        }
	      },
	      getWeek: {
	        default: function _default() {
	          return getWeek;
	        }
	      },
	      prefixClass: {
	        default: 'mx'
	      },
	      onDateMouseEnter: {
	        default: undefined
	      },
	      onDateMouseLeave: {
	        default: undefined
	      }
	    },
	    props: {
	      calendar: {
	        type: Date,
	        default: function _default() {
	          return new Date();
	        }
	      },
	      showWeekNumber: {
	        type: Boolean,
	        default: false
	      },
	      titleFormat: {
	        type: String,
	        default: 'YYYY-MM-DD'
	      },
	      getRowClasses: {
	        type: Function,
	        default: function _default() {
	          return [];
	        }
	      },
	      getCellClasses: {
	        type: Function,
	        default: function _default() {
	          return [];
	        }
	      }
	    },
	    computed: {
	      firstDayOfWeek: function firstDayOfWeek() {
	        return this.getLocale().formatLocale.firstDayOfWeek || 0;
	      },
	      yearMonth: function yearMonth() {
	        var _this$getLocale = this.getLocale(),
	            yearFormat = _this$getLocale.yearFormat,
	            monthBeforeYear = _this$getLocale.monthBeforeYear,
	            _this$getLocale$month = _this$getLocale.monthFormat,
	            monthFormat = _this$getLocale$month === void 0 ? 'MMM' : _this$getLocale$month;
	
	        var yearLabel = {
	          panel: 'year',
	          label: this.formatDate(this.calendar, yearFormat)
	        };
	        var monthLabel = {
	          panel: 'month',
	          label: this.formatDate(this.calendar, monthFormat)
	        };
	        return monthBeforeYear ? [monthLabel, yearLabel] : [yearLabel, monthLabel];
	      },
	      days: function days() {
	        var locale = this.getLocale();
	        var days = locale.days || locale.formatLocale.weekdaysMin;
	        return days.concat(days).slice(this.firstDayOfWeek, this.firstDayOfWeek + 7);
	      },
	      dates: function dates() {
	        var year = this.calendar.getFullYear();
	        var month = this.calendar.getMonth();
	        var arr = getCalendar({
	          firstDayOfWeek: this.firstDayOfWeek,
	          year: year,
	          month: month
	        });
	        return chunk(arr, 7);
	      }
	    },
	    methods: {
	      handleIconLeftClick: function handleIconLeftClick() {
	        this.$emit('changecalendar', setMonth(this.calendar, function (v) {
	          return v - 1;
	        }), 'last-month');
	      },
	      handleIconRightClick: function handleIconRightClick() {
	        this.$emit('changecalendar', setMonth(this.calendar, function (v) {
	          return v + 1;
	        }), 'next-month');
	      },
	      handleIconDoubleLeftClick: function handleIconDoubleLeftClick() {
	        this.$emit('changecalendar', setYear(this.calendar, function (v) {
	          return v - 1;
	        }), 'last-year');
	      },
	      handleIconDoubleRightClick: function handleIconDoubleRightClick() {
	        this.$emit('changecalendar', setYear(this.calendar, function (v) {
	          return v + 1;
	        }), 'next-year');
	      },
	      handlePanelChange: function handlePanelChange(panel) {
	        this.$emit('changepanel', panel);
	      },
	      handleMouseEnter: function handleMouseEnter(cell) {
	        if (typeof this.onDateMouseEnter === 'function') {
	          this.onDateMouseEnter(cell);
	        }
	      },
	      handleMouseLeave: function handleMouseLeave(cell) {
	        if (typeof this.onDateMouseLeave === 'function') {
	          this.onDateMouseLeave(cell);
	        }
	      },
	      handleCellClick: function handleCellClick(evt) {
	        var target = evt.target;
	
	        if (target.tagName.toUpperCase() === 'DIV') {
	          target = target.parentNode;
	        }
	
	        var index = target.getAttribute('data-row-col');
	
	        if (index) {
	          var _index$split$map = index.split(',').map(function (v) {
	            return parseInt(v, 10);
	          }),
	              _index$split$map2 = _slicedToArray(_index$split$map, 2),
	              row = _index$split$map2[0],
	              col = _index$split$map2[1];
	
	          var date = this.dates[row][col];
	          this.$emit('select', new Date(date));
	        }
	      },
	      formatDate: function formatDate(date, fmt) {
	        return format(date, fmt, {
	          locale: this.getLocale().formatLocale
	        });
	      },
	      getCellTitle: function getCellTitle(date) {
	        var fmt = this.titleFormat;
	        return this.formatDate(date, fmt);
	      },
	      getWeekNumber: function getWeekNumber(date) {
	        return this.getWeek(date, this.getLocale().formatLocale);
	      }
	    }
	  };
	
	  /* script */
	  var __vue_script__$2 = script$2;
	  /* template */
	
	  var __vue_render__$5 = function __vue_render__() {
	    var _vm = this;
	
	    var _h = _vm.$createElement;
	
	    var _c = _vm._self._c || _h;
	
	    return _c('div', {
	      class: _vm.prefixClass + "-calendar " + _vm.prefixClass + "-calendar-panel-date"
	    }, [_c('div', {
	      class: _vm.prefixClass + "-calendar-header"
	    }, [_c('icon-button', {
	      attrs: {
	        "type": "double-left"
	      },
	      on: {
	        "click": _vm.handleIconDoubleLeftClick
	      }
	    }), _vm._v(" "), _c('icon-button', {
	      attrs: {
	        "type": "left"
	      },
	      on: {
	        "click": _vm.handleIconLeftClick
	      }
	    }), _vm._v(" "), _c('icon-button', {
	      attrs: {
	        "type": "double-right"
	      },
	      on: {
	        "click": _vm.handleIconDoubleRightClick
	      }
	    }), _vm._v(" "), _c('icon-button', {
	      attrs: {
	        "type": "right"
	      },
	      on: {
	        "click": _vm.handleIconRightClick
	      }
	    }), _vm._v(" "), _c('span', {
	      class: _vm.prefixClass + "-calendar-header-label"
	    }, _vm._l(_vm.yearMonth, function (item) {
	      return _c('button', {
	        key: item.panel,
	        class: _vm.prefixClass + "-btn " + _vm.prefixClass + "-btn-text " + _vm.prefixClass + "-btn-current-" + item.panel,
	        attrs: {
	          "type": "button"
	        },
	        on: {
	          "click": function click($event) {
	            return _vm.handlePanelChange(item.panel);
	          }
	        }
	      }, [_vm._v("\n        " + _vm._s(item.label) + "\n      ")]);
	    }), 0)], 1), _vm._v(" "), _c('div', {
	      class: _vm.prefixClass + "-calendar-content"
	    }, [_c('table', {
	      class: _vm.prefixClass + "-table " + _vm.prefixClass + "-table-date"
	    }, [_c('thead', [_c('tr', [_vm.showWeekNumber ? _c('th', {
	      class: _vm.prefixClass + "-week-number-header"
	    }) : _vm._e(), _vm._v(" "), _vm._l(_vm.days, function (day) {
	      return _c('th', {
	        key: day
	      }, [_vm._v(_vm._s(day))]);
	    })], 2)]), _vm._v(" "), _c('tbody', {
	      on: {
	        "click": _vm.handleCellClick
	      }
	    }, _vm._l(_vm.dates, function (row, i) {
	      return _c('tr', {
	        key: i,
	        class: [_vm.prefixClass + "-date-row", _vm.getRowClasses(row)]
	      }, [_vm.showWeekNumber ? _c('td', {
	        class: _vm.prefixClass + "-week-number",
	        attrs: {
	          "data-row-col": i + ",0"
	        }
	      }, [_vm._v("\n            " + _vm._s(_vm.getWeekNumber(row[0])) + "\n          ")]) : _vm._e(), _vm._v(" "), _vm._l(row, function (cell, j) {
	        return _c('td', {
	          key: j,
	          staticClass: "cell",
	          class: _vm.getCellClasses(cell),
	          attrs: {
	            "data-row-col": i + "," + j,
	            "title": _vm.getCellTitle(cell)
	          },
	          on: {
	            "mouseenter": function mouseenter($event) {
	              return _vm.handleMouseEnter(cell);
	            },
	            "mouseleave": function mouseleave($event) {
	              return _vm.handleMouseLeave(cell);
	            }
	          }
	        }, [_c('div', [_vm._v(_vm._s(cell.getDate()))])]);
	      })], 2);
	    }), 0)])])]);
	  };
	
	  var __vue_staticRenderFns__$5 = [];
	  /* style */
	
	  var __vue_inject_styles__$5 = undefined;
	  /* scoped */
	
	  var __vue_scope_id__$5 = undefined;
	  /* module identifier */
	
	  var __vue_module_identifier__$5 = undefined;
	  /* functional template */
	
	  var __vue_is_functional_template__$5 = false;
	  /* style inject */
	
	  /* style inject SSR */
	
	  /* style inject shadow dom */
	
	  var __vue_component__$5 = normalizeComponent({
	    render: __vue_render__$5,
	    staticRenderFns: __vue_staticRenderFns__$5
	  }, __vue_inject_styles__$5, __vue_script__$2, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);
	
	  //
	  var script$3 = {
	    name: 'TableMonth',
	    components: {
	      IconButton: __vue_component__$4
	    },
	    inject: {
	      getLocale: {
	        default: function _default() {
	          return getLocale;
	        }
	      },
	      prefixClass: {
	        default: 'mx'
	      }
	    },
	    props: {
	      calendar: {
	        type: Date,
	        default: function _default() {
	          return new Date();
	        }
	      },
	      getCellClasses: {
	        type: Function,
	        default: function _default() {
	          return [];
	        }
	      }
	    },
	    computed: {
	      calendarYear: function calendarYear() {
	        return this.calendar.getFullYear();
	      },
	      months: function months() {
	        var locale = this.getLocale();
	        var monthsLocale = locale.months || locale.formatLocale.monthsShort;
	        var months = monthsLocale.map(function (text, month) {
	          return {
	            text: text,
	            month: month
	          };
	        });
	        return chunk(months, 3);
	      }
	    },
	    methods: {
	      handleIconDoubleLeftClick: function handleIconDoubleLeftClick() {
	        this.$emit('changecalendar', setYear(this.calendar, function (v) {
	          return v - 1;
	        }), 'last-year');
	      },
	      handleIconDoubleRightClick: function handleIconDoubleRightClick() {
	        this.$emit('changecalendar', setYear(this.calendar, function (v) {
	          return v + 1;
	        }), 'next-year');
	      },
	      handlePanelChange: function handlePanelChange() {
	        this.$emit('changepanel', 'year');
	      },
	      handleClick: function handleClick(evt) {
	        var target = evt.target;
	
	        if (target.tagName.toUpperCase() === 'DIV') {
	          target = target.parentNode;
	        }
	
	        var month = target.getAttribute('data-month');
	
	        if (month) {
	          this.$emit('select', parseInt(month, 10));
	        }
	      }
	    }
	  };
	
	  /* script */
	  var __vue_script__$3 = script$3;
	  /* template */
	
	  var __vue_render__$6 = function __vue_render__() {
	    var _vm = this;
	
	    var _h = _vm.$createElement;
	
	    var _c = _vm._self._c || _h;
	
	    return _c('div', {
	      class: _vm.prefixClass + "-calendar " + _vm.prefixClass + "-calendar-panel-month"
	    }, [_c('div', {
	      class: _vm.prefixClass + "-calendar-header"
	    }, [_c('icon-button', {
	      attrs: {
	        "type": "double-left"
	      },
	      on: {
	        "click": _vm.handleIconDoubleLeftClick
	      }
	    }), _vm._v(" "), _c('icon-button', {
	      attrs: {
	        "type": "double-right"
	      },
	      on: {
	        "click": _vm.handleIconDoubleRightClick
	      }
	    }), _vm._v(" "), _c('span', {
	      class: _vm.prefixClass + "-calendar-header-label"
	    }, [_c('button', {
	      class: _vm.prefixClass + "-btn " + _vm.prefixClass + "-btn-text",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": _vm.handlePanelChange
	      }
	    }, [_vm._v("\n        " + _vm._s(_vm.calendarYear) + "\n      ")])])], 1), _vm._v(" "), _c('div', {
	      class: _vm.prefixClass + "-calendar-content"
	    }, [_c('table', {
	      class: _vm.prefixClass + "-table " + _vm.prefixClass + "-table-month",
	      on: {
	        "click": _vm.handleClick
	      }
	    }, _vm._l(_vm.months, function (row, i) {
	      return _c('tr', {
	        key: i
	      }, _vm._l(row, function (cell, j) {
	        return _c('td', {
	          key: j,
	          staticClass: "cell",
	          class: _vm.getCellClasses(cell.month),
	          attrs: {
	            "data-month": cell.month
	          }
	        }, [_c('div', [_vm._v(_vm._s(cell.text))])]);
	      }), 0);
	    }), 0)])]);
	  };
	
	  var __vue_staticRenderFns__$6 = [];
	  /* style */
	
	  var __vue_inject_styles__$6 = undefined;
	  /* scoped */
	
	  var __vue_scope_id__$6 = undefined;
	  /* module identifier */
	
	  var __vue_module_identifier__$6 = undefined;
	  /* functional template */
	
	  var __vue_is_functional_template__$6 = false;
	  /* style inject */
	
	  /* style inject SSR */
	
	  /* style inject shadow dom */
	
	  var __vue_component__$6 = normalizeComponent({
	    render: __vue_render__$6,
	    staticRenderFns: __vue_staticRenderFns__$6
	  }, __vue_inject_styles__$6, __vue_script__$3, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, undefined, undefined, undefined);
	
	  //
	  var script$4 = {
	    name: 'TableYear',
	    components: {
	      IconButton: __vue_component__$4
	    },
	    inject: {
	      prefixClass: {
	        default: 'mx'
	      }
	    },
	    props: {
	      calendar: {
	        type: Date,
	        default: function _default() {
	          return new Date();
	        }
	      },
	      getCellClasses: {
	        type: Function,
	        default: function _default() {
	          return [];
	        }
	      },
	      getYearPanel: {
	        type: Function
	      }
	    },
	    computed: {
	      years: function years() {
	        var calendar = new Date(this.calendar);
	
	        if (typeof this.getYearPanel === 'function') {
	          return this.getYearPanel(calendar);
	        }
	
	        return this.getYears(calendar);
	      },
	      firstYear: function firstYear() {
	        return this.years[0][0];
	      },
	      lastYear: function lastYear() {
	        var last = function last(arr) {
	          return arr[arr.length - 1];
	        };
	
	        return last(last(this.years));
	      }
	    },
	    methods: {
	      getYears: function getYears(calendar) {
	        var firstYear = Math.floor(calendar.getFullYear() / 10) * 10;
	        var years = [];
	
	        for (var i = 0; i < 10; i++) {
	          years.push(firstYear + i);
	        }
	
	        return chunk(years, 2);
	      },
	      handleIconDoubleLeftClick: function handleIconDoubleLeftClick() {
	        this.$emit('changecalendar', setYear(this.calendar, function (v) {
	          return v - 10;
	        }), 'last-decade');
	      },
	      handleIconDoubleRightClick: function handleIconDoubleRightClick() {
	        this.$emit('changecalendar', setYear(this.calendar, function (v) {
	          return v + 10;
	        }), 'next-decade');
	      },
	      handleClick: function handleClick(evt) {
	        var target = evt.target;
	
	        if (target.tagName.toUpperCase() === 'DIV') {
	          target = target.parentNode;
	        }
	
	        var year = target.getAttribute('data-year');
	
	        if (year) {
	          this.$emit('select', parseInt(year, 10));
	        }
	      }
	    }
	  };
	
	  /* script */
	  var __vue_script__$4 = script$4;
	  /* template */
	
	  var __vue_render__$7 = function __vue_render__() {
	    var _vm = this;
	
	    var _h = _vm.$createElement;
	
	    var _c = _vm._self._c || _h;
	
	    return _c('div', {
	      class: _vm.prefixClass + "-calendar " + _vm.prefixClass + "-calendar-panel-year"
	    }, [_c('div', {
	      class: _vm.prefixClass + "-calendar-header"
	    }, [_c('icon-button', {
	      attrs: {
	        "type": "double-left"
	      },
	      on: {
	        "click": _vm.handleIconDoubleLeftClick
	      }
	    }), _vm._v(" "), _c('icon-button', {
	      attrs: {
	        "type": "double-right"
	      },
	      on: {
	        "click": _vm.handleIconDoubleRightClick
	      }
	    }), _vm._v(" "), _c('span', {
	      class: _vm.prefixClass + "-calendar-header-label"
	    }, [_c('span', [_vm._v(_vm._s(_vm.firstYear))]), _vm._v(" "), _c('span', {
	      class: _vm.prefixClass + "-calendar-decade-separator"
	    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lastYear))])])], 1), _vm._v(" "), _c('div', {
	      class: _vm.prefixClass + "-calendar-content"
	    }, [_c('table', {
	      class: _vm.prefixClass + "-table " + _vm.prefixClass + "-table-year",
	      on: {
	        "click": _vm.handleClick
	      }
	    }, _vm._l(_vm.years, function (row, i) {
	      return _c('tr', {
	        key: i
	      }, _vm._l(row, function (cell, j) {
	        return _c('td', {
	          key: j,
	          staticClass: "cell",
	          class: _vm.getCellClasses(cell),
	          attrs: {
	            "data-year": cell
	          }
	        }, [_c('div', [_vm._v(_vm._s(cell))])]);
	      }), 0);
	    }), 0)])]);
	  };
	
	  var __vue_staticRenderFns__$7 = [];
	  /* style */
	
	  var __vue_inject_styles__$7 = undefined;
	  /* scoped */
	
	  var __vue_scope_id__$7 = undefined;
	  /* module identifier */
	
	  var __vue_module_identifier__$7 = undefined;
	  /* functional template */
	
	  var __vue_is_functional_template__$7 = false;
	  /* style inject */
	
	  /* style inject SSR */
	
	  /* style inject shadow dom */
	
	  var __vue_component__$7 = normalizeComponent({
	    render: __vue_render__$7,
	    staticRenderFns: __vue_staticRenderFns__$7
	  }, __vue_inject_styles__$7, __vue_script__$4, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, undefined, undefined, undefined);
	
	  var CalendarPanel = {
	    name: 'CalendarPanel',
	    inject: {
	      prefixClass: {
	        default: 'mx'
	      },
	      dispatchDatePicker: {
	        default: function _default() {
	          return function () {};
	        }
	      }
	    },
	    props: {
	      value: {},
	      defaultValue: {
	        default: function _default() {
	          var date = new Date();
	          date.setHours(0, 0, 0, 0);
	          return date;
	        }
	      },
	      defaultPanel: {
	        type: String
	      },
	      disabledDate: {
	        type: Function,
	        default: function _default() {
	          return false;
	        }
	      },
	      type: {
	        type: String,
	        default: 'date'
	      },
	      getClasses: {
	        type: Function,
	        default: function _default() {
	          return [];
	        }
	      },
	      showWeekNumber: {
	        type: Boolean,
	        default: undefined
	      },
	      getYearPanel: {
	        type: Function
	      },
	      titleFormat: {
	        type: String,
	        default: 'YYYY-MM-DD'
	      },
	      calendar: Date,
	      // update date when select year or month
	      partialUpdate: {
	        type: Boolean,
	        default: false
	      }
	    },
	    data: function data() {
	      var panels = ['date', 'month', 'year'];
	      var index = Math.max(panels.indexOf(this.type), panels.indexOf(this.defaultPanel));
	      var panel = index !== -1 ? panels[index] : 'date';
	      return {
	        panel: panel,
	        innerCalendar: new Date()
	      };
	    },
	    computed: {
	      innerValue: function innerValue() {
	        var value = Array.isArray(this.value) ? this.value : [this.value];
	        var map = {
	          year: startOfYear,
	          month: startOfMonth,
	          date: startOfDay
	        };
	        var start = map[this.type] || map.date;
	        return value.filter(isValidDate$1).map(function (v) {
	          return start(v);
	        });
	      },
	      calendarYear: function calendarYear() {
	        return this.innerCalendar.getFullYear();
	      },
	      calendarMonth: function calendarMonth() {
	        return this.innerCalendar.getMonth();
	      }
	    },
	    watch: {
	      value: {
	        immediate: true,
	        handler: 'initCalendar'
	      },
	      calendar: {
	        handler: 'initCalendar'
	      },
	      defaultValue: {
	        handler: 'initCalendar'
	      }
	    },
	    methods: {
	      initCalendar: function initCalendar() {
	        var calendarDate = this.calendar;
	
	        if (!isValidDate$1(calendarDate)) {
	          var length = this.innerValue.length;
	          calendarDate = getValidDate(length > 0 ? this.innerValue[length - 1] : this.defaultValue);
	        }
	
	        this.innerCalendar = startOfMonth(calendarDate);
	      },
	      isDisabled: function isDisabled(date) {
	        return this.disabledDate(new Date(date), this.innerValue);
	      },
	      emitDate: function emitDate(date, type) {
	        if (!this.isDisabled(date)) {
	          this.$emit('select', date, type, this.innerValue); // someone need get the first selected date to set range value. (#429)
	
	          this.dispatchDatePicker('pick', date, type);
	        }
	      },
	      handleCalendarChange: function handleCalendarChange(calendar, type) {
	        var oldCalendar = new Date(this.innerCalendar);
	        this.innerCalendar = calendar;
	        this.$emit('update:calendar', calendar);
	        this.dispatchDatePicker('calendar-change', calendar, oldCalendar, type);
	      },
	      handelPanelChange: function handelPanelChange(panel) {
	        var oldPanel = this.panel;
	        this.panel = panel;
	        this.dispatchDatePicker('panel-change', panel, oldPanel);
	      },
	      handleSelectYear: function handleSelectYear(year) {
	        if (this.type === 'year') {
	          var date = this.getYearCellDate(year);
	          this.emitDate(date, 'year');
	        } else {
	          this.handleCalendarChange(createDate$1(year, this.calendarMonth), 'year');
	          this.handelPanelChange('month');
	
	          if (this.partialUpdate && this.innerValue.length === 1) {
	            var _date = new Date(this.innerValue[0]);
	
	            _date.setFullYear(year);
	
	            this.emitDate(_date, 'year');
	          }
	        }
	      },
	      handleSelectMonth: function handleSelectMonth(month) {
	        if (this.type === 'month') {
	          var date = this.getMonthCellDate(month);
	          this.emitDate(date, 'month');
	        } else {
	          this.handleCalendarChange(createDate$1(this.calendarYear, month), 'month');
	          this.handelPanelChange('date');
	
	          if (this.partialUpdate && this.innerValue.length === 1) {
	            var _date2 = new Date(this.innerValue[0]);
	
	            _date2.setFullYear(this.calendarYear);
	
	            this.emitDate(setMonth(_date2, month), 'month');
	          }
	        }
	      },
	      handleSelectDate: function handleSelectDate(date) {
	        this.emitDate(date, this.type === 'week' ? 'week' : 'date');
	      },
	      getMonthCellDate: function getMonthCellDate(month) {
	        return createDate$1(this.calendarYear, month);
	      },
	      getYearCellDate: function getYearCellDate(year) {
	        return createDate$1(year, 0);
	      },
	      getDateClasses: function getDateClasses(cellDate) {
	        var notCurrentMonth = cellDate.getMonth() !== this.calendarMonth;
	        var classes = [];
	
	        if (cellDate.getTime() === new Date().setHours(0, 0, 0, 0)) {
	          classes.push('today');
	        }
	
	        if (notCurrentMonth) {
	          classes.push('not-current-month');
	        }
	
	        var state = this.getStateClass(cellDate);
	
	        if (!(state === 'active' && notCurrentMonth)) {
	          classes.push(state);
	        }
	
	        return classes.concat(this.getClasses(cellDate, this.innerValue, classes.join(' ')));
	      },
	      getMonthClasses: function getMonthClasses(month) {
	        if (this.type !== 'month') {
	          return this.calendarMonth === month ? 'active' : '';
	        }
	
	        var classes = [];
	        var cellDate = this.getMonthCellDate(month);
	        classes.push(this.getStateClass(cellDate));
	        return classes.concat(this.getClasses(cellDate, this.innerValue, classes.join(' ')));
	      },
	      getYearClasses: function getYearClasses(year) {
	        if (this.type !== 'year') {
	          return this.calendarYear === year ? 'active' : '';
	        }
	
	        var classes = [];
	        var cellDate = this.getYearCellDate(year);
	        classes.push(this.getStateClass(cellDate));
	        return classes.concat(this.getClasses(cellDate, this.innerValue, classes.join(' ')));
	      },
	      getStateClass: function getStateClass(cellDate) {
	        if (this.isDisabled(cellDate)) {
	          return 'disabled';
	        }
	
	        if (this.innerValue.some(function (v) {
	          return v.getTime() === cellDate.getTime();
	        })) {
	          return 'active';
	        }
	
	        return '';
	      },
	      getWeekState: function getWeekState(row) {
	        if (this.type !== 'week') return '';
	        var start = row[0].getTime();
	        var end = row[6].getTime();
	        var active = this.innerValue.some(function (v) {
	          var time = v.getTime();
	          return time >= start && time <= end;
	        });
	        return active ? "".concat(this.prefixClass, "-active-week") : '';
	      }
	    },
	    render: function render() {
	      var h = arguments[0];
	      var panel = this.panel,
	          innerCalendar = this.innerCalendar;
	
	      if (panel === 'year') {
	        return h(__vue_component__$7, {
	          "attrs": {
	            "calendar": innerCalendar,
	            "getCellClasses": this.getYearClasses,
	            "getYearPanel": this.getYearPanel
	          },
	          "on": {
	            "select": this.handleSelectYear,
	            "changecalendar": this.handleCalendarChange
	          }
	        });
	      }
	
	      if (panel === 'month') {
	        return h(__vue_component__$6, {
	          "attrs": {
	            "calendar": innerCalendar,
	            "getCellClasses": this.getMonthClasses
	          },
	          "on": {
	            "select": this.handleSelectMonth,
	            "changepanel": this.handelPanelChange,
	            "changecalendar": this.handleCalendarChange
	          }
	        });
	      }
	
	      return h(__vue_component__$5, {
	        "class": _defineProperty({}, "".concat(this.prefixClass, "-calendar-week-mode"), this.type === 'week'),
	        "attrs": {
	          "calendar": innerCalendar,
	          "getCellClasses": this.getDateClasses,
	          "getRowClasses": this.getWeekState,
	          "titleFormat": this.titleFormat,
	          "showWeekNumber": typeof this.showWeekNumber === 'boolean' ? this.showWeekNumber : this.type === 'week'
	        },
	        "on": {
	          "select": this.handleSelectDate,
	          "changepanel": this.handelPanelChange,
	          "changecalendar": this.handleCalendarChange
	        }
	      });
	    }
	  };
	
	  var CalendarRange = {
	    name: 'CalendarRange',
	    components: {
	      CalendarPanel: CalendarPanel
	    },
	    provide: function provide() {
	      return {
	        onDateMouseEnter: this.onDateMouseEnter,
	        onDateMouseLeave: this.onDateMouseLeave
	      };
	    },
	    inject: {
	      prefixClass: {
	        default: 'mx'
	      }
	    },
	    props: _objectSpread2({}, CalendarPanel.props),
	    data: function data() {
	      return {
	        innerValue: [],
	        calendars: [],
	        hoveredValue: null
	      };
	    },
	    computed: {
	      // Minimum difference between start and end calendars
	      calendarMinDiff: function calendarMinDiff() {
	        var map = {
	          date: 1,
	          // type:date  min 1 month
	          month: 1 * 12,
	          // type:month min 1 year
	          year: 10 * 12 // type:year  min 10 year
	
	        };
	        return map[this.type] || map.date;
	      },
	      calendarMaxDiff: function calendarMaxDiff() {
	        return Infinity;
	      },
	      defaultValues: function defaultValues() {
	        return Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue, this.defaultValue];
	      }
	    },
	    watch: {
	      value: {
	        immediate: true,
	        handler: function handler() {
	          var _this = this;
	
	          this.innerValue = isValidRangeDate(this.value) ? this.value : [new Date(NaN), new Date(NaN)];
	          var calendars = this.innerValue.map(function (v, i) {
	            return startOfMonth(getValidDate(v, _this.defaultValues[i]));
	          });
	          this.updateCalendars(calendars);
	        }
	      }
	    },
	    methods: {
	      handleSelect: function handleSelect(date, type) {
	        var _this$innerValue = _slicedToArray(this.innerValue, 2),
	            startValue = _this$innerValue[0],
	            endValue = _this$innerValue[1];
	
	        if (isValidDate$1(startValue) && !isValidDate$1(endValue)) {
	          if (startValue.getTime() > date.getTime()) {
	            this.innerValue = [date, startValue];
	          } else {
	            this.innerValue = [startValue, date];
	          }
	
	          this.emitDate(this.innerValue, type);
	        } else {
	          this.innerValue = [date, new Date(NaN)];
	        }
	      },
	      onDateMouseEnter: function onDateMouseEnter(cell) {
	        this.hoveredValue = cell;
	      },
	      onDateMouseLeave: function onDateMouseLeave() {
	        this.hoveredValue = null;
	      },
	      emitDate: function emitDate(dates, type) {
	        this.$emit('select', dates, type);
	      },
	      updateStartCalendar: function updateStartCalendar(value) {
	        this.updateCalendars([value, this.calendars[1]], 1);
	      },
	      updateEndCalendar: function updateEndCalendar(value) {
	        this.updateCalendars([this.calendars[0], value], 0);
	      },
	      updateCalendars: function updateCalendars(calendars) {
	        var adjustIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	        var gap = this.getCalendarGap(calendars);
	
	        if (gap) {
	          var calendar = new Date(calendars[adjustIndex]);
	          calendar.setMonth(calendar.getMonth() + (adjustIndex === 0 ? -gap : gap));
	          calendars[adjustIndex] = calendar;
	        }
	
	        this.calendars = calendars;
	      },
	      getCalendarGap: function getCalendarGap(calendars) {
	        var _calendars = _slicedToArray(calendars, 2),
	            calendarLeft = _calendars[0],
	            calendarRight = _calendars[1];
	
	        var yearDiff = calendarRight.getFullYear() - calendarLeft.getFullYear();
	        var monthDiff = calendarRight.getMonth() - calendarLeft.getMonth();
	        var diff = yearDiff * 12 + monthDiff;
	        var min = this.calendarMinDiff;
	        var max = this.calendarMaxDiff;
	
	        if (diff < min) {
	          return min - diff;
	        }
	
	        if (diff > max) {
	          return max - diff;
	        }
	
	        return 0;
	      },
	      getRangeClasses: function getRangeClasses(cellDate, currentDates, classnames) {
	        var classes = [].concat(this.getClasses(cellDate, currentDates, classnames));
	        if (/disabled|active/.test(classnames)) return classes;
	
	        var inRange = function inRange(data, range) {
	          var fn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (v) {
	            return v.getTime();
	          };
	          var value = fn(data);
	
	          var _range$map = range.map(fn),
	              _range$map2 = _slicedToArray(_range$map, 2),
	              min = _range$map2[0],
	              max = _range$map2[1];
	
	          if (min > max) {
	            var _ref = [max, min];
	            min = _ref[0];
	            max = _ref[1];
	          }
	
	          return value > min && value < max;
	        };
	
	        if (currentDates.length === 2 && inRange(cellDate, currentDates)) {
	          return classes.concat('in-range');
	        }
	
	        if (currentDates.length === 1 && this.hoveredValue && inRange(cellDate, [currentDates[0], this.hoveredValue])) {
	          return classes.concat('hover-in-range');
	        }
	
	        return classes;
	      }
	    },
	    render: function render() {
	      var _this2 = this;
	
	      var h = arguments[0];
	      var calendarRange = this.calendars.map(function (calendar, index) {
	        var props = _objectSpread2({}, _this2.$props, {
	          calendar: calendar,
	          value: _this2.innerValue,
	          defaultValue: _this2.defaultValues[index],
	          getClasses: _this2.getRangeClasses,
	          // don't update when range is true
	          partialUpdate: false
	        });
	
	        var on = {
	          select: _this2.handleSelect,
	          'update:calendar': index === 0 ? _this2.updateStartCalendar : _this2.updateEndCalendar
	        };
	        return h("calendar-panel", {
	          "props": _objectSpread2({}, props),
	          "on": _objectSpread2({}, on)
	        });
	      });
	      var prefixClass = this.prefixClass;
	      return h("div", {
	        "class": "".concat(prefixClass, "-range-wrapper")
	      }, [calendarRange]);
	    }
	  };
	
	  var scrollBarWidth;
	  function getScrollbarWidth () {
	    if (typeof window === 'undefined') return 0;
	    if (scrollBarWidth !== undefined) return scrollBarWidth;
	    var outer = document.createElement('div');
	    outer.style.visibility = 'hidden';
	    outer.style.overflow = 'scroll';
	    outer.style.width = '100px';
	    outer.style.position = 'absolute';
	    outer.style.top = '-9999px';
	    document.body.appendChild(outer);
	    var inner = document.createElement('div');
	    inner.style.width = '100%';
	    outer.appendChild(inner);
	    scrollBarWidth = outer.offsetWidth - inner.offsetWidth;
	    outer.parentNode.removeChild(outer);
	    return scrollBarWidth;
	  }
	
	  //
	  var script$5 = {
	    inject: {
	      prefixClass: {
	        default: 'mx'
	      }
	    },
	    data: function data() {
	      return {
	        scrollbarWidth: 0,
	        thumbTop: '',
	        thumbHeight: ''
	      };
	    },
	    created: function created() {
	      this.scrollbarWidth = getScrollbarWidth();
	      document.addEventListener('mouseup', this.handleDragend);
	    },
	    beforeDestroy: function beforeDestroy() {
	      document.addEventListener('mouseup', this.handleDragend);
	    },
	    mounted: function mounted() {
	      this.$nextTick(this.getThumbSize);
	    },
	    methods: {
	      getThumbSize: function getThumbSize() {
	        var wrap = this.$refs.wrap;
	        if (!wrap) return;
	        var heightPercentage = wrap.clientHeight * 100 / wrap.scrollHeight;
	        this.thumbHeight = heightPercentage < 100 ? "".concat(heightPercentage, "%") : '';
	      },
	      handleScroll: function handleScroll(evt) {
	        var el = evt.currentTarget;
	        var scrollHeight = el.scrollHeight,
	            scrollTop = el.scrollTop;
	        this.thumbTop = "".concat(scrollTop * 100 / scrollHeight, "%");
	      },
	      handleDragstart: function handleDragstart(evt) {
	        evt.stopImmediatePropagation();
	        this._draggable = true;
	        var offsetTop = this.$refs.thumb.offsetTop;
	        this._prevY = evt.clientY - offsetTop;
	        document.addEventListener('mousemove', this.handleDraging);
	      },
	      handleDraging: function handleDraging(evt) {
	        if (!this._draggable) return;
	        var clientY = evt.clientY;
	        var wrap = this.$refs.wrap;
	        var scrollHeight = wrap.scrollHeight,
	            clientHeight = wrap.clientHeight;
	        var offsetY = clientY - this._prevY;
	        var top = offsetY * scrollHeight / clientHeight;
	        wrap.scrollTop = top;
	      },
	      handleDragend: function handleDragend() {
	        if (this._draggable) {
	          this._draggable = false;
	          document.removeEventListener('mousemove', this.handleDraging);
	        }
	      }
	    }
	  };
	
	  /* script */
	  var __vue_script__$5 = script$5;
	  /* template */
	
	  var __vue_render__$8 = function __vue_render__() {
	    var _vm = this;
	
	    var _h = _vm.$createElement;
	
	    var _c = _vm._self._c || _h;
	
	    return _c('div', {
	      class: _vm.prefixClass + "-scrollbar",
	      style: {
	        position: 'relative',
	        overflow: 'hidden'
	      }
	    }, [_c('div', {
	      ref: "wrap",
	      class: _vm.prefixClass + "-scrollbar-wrap",
	      style: {
	        marginRight: "-" + _vm.scrollbarWidth + "px"
	      },
	      on: {
	        "scroll": _vm.handleScroll
	      }
	    }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
	      class: _vm.prefixClass + "-scrollbar-track"
	    }, [_c('div', {
	      ref: "thumb",
	      class: _vm.prefixClass + "-scrollbar-thumb",
	      style: {
	        height: _vm.thumbHeight,
	        top: _vm.thumbTop
	      },
	      on: {
	        "mousedown": _vm.handleDragstart
	      }
	    })])]);
	  };
	
	  var __vue_staticRenderFns__$8 = [];
	  /* style */
	
	  var __vue_inject_styles__$8 = undefined;
	  /* scoped */
	
	  var __vue_scope_id__$8 = undefined;
	  /* module identifier */
	
	  var __vue_module_identifier__$8 = undefined;
	  /* functional template */
	
	  var __vue_is_functional_template__$8 = false;
	  /* style inject */
	
	  /* style inject SSR */
	
	  /* style inject shadow dom */
	
	  var __vue_component__$8 = normalizeComponent({
	    render: __vue_render__$8,
	    staticRenderFns: __vue_staticRenderFns__$8
	  }, __vue_inject_styles__$8, __vue_script__$5, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, undefined, undefined, undefined);
	
	  //
	
	  var padNumber = function padNumber(value) {
	    value = parseInt(value, 10);
	    return value < 10 ? "0".concat(value) : "".concat(value);
	  };
	
	  var generateOptions = function generateOptions(length, step, options) {
	    if (Array.isArray(options)) {
	      return options.filter(function (v) {
	        return v >= 0 && v < length;
	      });
	    }
	
	    if (step <= 0) {
	      step = 1;
	    }
	
	    var arr = [];
	
	    for (var i = 0; i < length; i += step) {
	      arr.push(i);
	    }
	
	    return arr;
	  };
	
	  var scrollTo = function scrollTo(element, to) {
	    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	    // jump to target if duration zero
	    if (duration <= 0) {
	      requestAnimationFrame(function () {
	        element.scrollTop = to;
	      });
	      return;
	    }
	
	    var difference = to - element.scrollTop;
	    var tick = difference / duration * 10;
	    requestAnimationFrame(function () {
	      var scrollTop = element.scrollTop + tick;
	
	      if (scrollTop >= to) {
	        element.scrollTop = to;
	        return;
	      }
	
	      element.scrollTop = scrollTop;
	      scrollTo(element, to, duration - 10);
	    });
	  };
	
	  var script$6 = {
	    name: 'ListColumns',
	    components: {
	      ScrollbarVertical: __vue_component__$8
	    },
	    inject: {
	      prefixClass: {
	        default: 'mx'
	      }
	    },
	    props: {
	      date: Date,
	      scrollDuration: {
	        type: Number,
	        default: 100
	      },
	      getClasses: {
	        type: Function,
	        default: function _default() {
	          return [];
	        }
	      },
	      hourOptions: Array,
	      minuteOptions: Array,
	      secondOptions: Array,
	      showHour: {
	        type: Boolean,
	        default: true
	      },
	      showMinute: {
	        type: Boolean,
	        default: true
	      },
	      showSecond: {
	        type: Boolean,
	        default: true
	      },
	      hourStep: {
	        type: Number,
	        default: 1
	      },
	      minuteStep: {
	        type: Number,
	        default: 1
	      },
	      secondStep: {
	        type: Number,
	        default: 1
	      },
	      use12h: {
	        type: Boolean,
	        default: false
	      }
	    },
	    computed: {
	      columns: function columns() {
	        var cols = [];
	        if (this.showHour) cols.push({
	          type: 'hour',
	          list: this.getHoursList()
	        });
	        if (this.showMinute) cols.push({
	          type: 'minute',
	          list: this.getMinutesList()
	        });
	        if (this.showSecond) cols.push({
	          type: 'second',
	          list: this.getSecondsList()
	        });
	        if (this.use12h) cols.push({
	          type: 'ampm',
	          list: this.getAMPMList()
	        });
	        return cols.filter(function (v) {
	          return v.list.length > 0;
	        });
	      }
	    },
	    watch: {
	      date: {
	        handler: function handler() {
	          var _this = this;
	
	          this.$nextTick(function () {
	            _this.scrollToSelected(_this.scrollDuration);
	          });
	        }
	      }
	    },
	    mounted: function mounted() {
	      this.scrollToSelected(0);
	    },
	    methods: {
	      getHoursList: function getHoursList() {
	        var _this2 = this;
	
	        return generateOptions(this.use12h ? 12 : 24, this.hourStep, this.hourOptions).map(function (num) {
	          var date = new Date(_this2.date);
	          var text = padNumber(num);
	
	          if (_this2.use12h) {
	            if (num === 0) {
	              text = '12';
	            }
	
	            if (date.getHours() >= 12) {
	              num += 12;
	            }
	          }
	
	          var value = date.setHours(num);
	          return {
	            value: value,
	            text: text
	          };
	        });
	      },
	      getMinutesList: function getMinutesList() {
	        var _this3 = this;
	
	        return generateOptions(60, this.minuteStep, this.minuteOptions).map(function (num) {
	          var value = new Date(_this3.date).setMinutes(num);
	          return {
	            value: value,
	            text: padNumber(num)
	          };
	        });
	      },
	      getSecondsList: function getSecondsList() {
	        var _this4 = this;
	
	        return generateOptions(60, this.secondStep, this.secondOptions).map(function (num) {
	          var value = new Date(_this4.date).setSeconds(num);
	          return {
	            value: value,
	            text: padNumber(num)
	          };
	        });
	      },
	      getAMPMList: function getAMPMList() {
	        var _this5 = this;
	
	        return ['AM', 'PM'].map(function (text, i) {
	          var date = new Date(_this5.date);
	          var value = date.setHours(date.getHours() % 12 + i * 12);
	          return {
	            text: text,
	            value: value
	          };
	        });
	      },
	      scrollToSelected: function scrollToSelected(duration) {
	        var elements = this.$el.querySelectorAll('.active');
	
	        for (var i = 0; i < elements.length; i++) {
	          var element = elements[i];
	          var scrollElement = getScrollParent(element, this.$el);
	
	          if (scrollElement) {
	            var to = element.offsetTop;
	            scrollTo(scrollElement, to, duration);
	          }
	        }
	      },
	      handleSelect: function handleSelect(evt) {
	        var target = evt.target,
	            currentTarget = evt.currentTarget;
	        if (target.tagName.toUpperCase() !== 'LI') return;
	        var type = currentTarget.getAttribute('data-type');
	        var colIndex = parseInt(currentTarget.getAttribute('data-index'), 10);
	        var cellIndex = parseInt(target.getAttribute('data-index'), 10);
	        var value = this.columns[colIndex].list[cellIndex].value;
	        this.$emit('select', value, type);
	      }
	    }
	  };
	
	  /* script */
	  var __vue_script__$6 = script$6;
	  /* template */
	
	  var __vue_render__$9 = function __vue_render__() {
	    var _vm = this;
	
	    var _h = _vm.$createElement;
	
	    var _c = _vm._self._c || _h;
	
	    return _c('div', {
	      class: _vm.prefixClass + "-time-columns"
	    }, _vm._l(_vm.columns, function (col, i) {
	      return _c('scrollbar-vertical', {
	        key: i,
	        class: _vm.prefixClass + "-time-column"
	      }, [_c('ul', {
	        class: _vm.prefixClass + "-time-list",
	        attrs: {
	          "data-type": col.type,
	          "data-index": i
	        },
	        on: {
	          "click": _vm.handleSelect
	        }
	      }, _vm._l(col.list, function (item, j) {
	        return _c('li', {
	          key: item.value,
	          class: [_vm.prefixClass + "-time-item", _vm.getClasses(item.value, col.type)],
	          attrs: {
	            "data-index": j
	          }
	        }, [_vm._v("\n        " + _vm._s(item.text) + "\n      ")]);
	      }), 0)]);
	    }), 1);
	  };
	
	  var __vue_staticRenderFns__$9 = [];
	  /* style */
	
	  var __vue_inject_styles__$9 = undefined;
	  /* scoped */
	
	  var __vue_scope_id__$9 = undefined;
	  /* module identifier */
	
	  var __vue_module_identifier__$9 = undefined;
	  /* functional template */
	
	  var __vue_is_functional_template__$9 = false;
	  /* style inject */
	
	  /* style inject SSR */
	
	  /* style inject shadow dom */
	
	  var __vue_component__$9 = normalizeComponent({
	    render: __vue_render__$9,
	    staticRenderFns: __vue_staticRenderFns__$9
	  }, __vue_inject_styles__$9, __vue_script__$6, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, undefined, undefined, undefined);
	
	  //
	
	  function parseOption() {
	    var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var values = time.split(':');
	
	    if (values.length >= 2) {
	      var hours = parseInt(values[0], 10);
	      var minutes = parseInt(values[1], 10);
	      return {
	        hours: hours,
	        minutes: minutes
	      };
	    }
	
	    return null;
	  }
	
	  var scrollTo$1 = function scrollTo(element, to) {
	    if (element) {
	      element.scrollTop = to;
	    }
	  };
	
	  var script$7 = {
	    name: 'ListOptions',
	    components: {
	      ScrollbarVertical: __vue_component__$8
	    },
	    inject: {
	      getLocale: {
	        default: function _default() {
	          return getLocale;
	        }
	      },
	      prefixClass: {
	        default: 'mx'
	      }
	    },
	    props: {
	      date: Date,
	      options: {
	        type: [Object, Function],
	        default: function _default() {
	          return [];
	        }
	      },
	      format: {
	        type: String,
	        default: 'HH:mm:ss'
	      },
	      getClasses: {
	        type: Function,
	        default: function _default() {
	          return [];
	        }
	      }
	    },
	    computed: {
	      list: function list() {
	        var result = [];
	        var options = this.options;
	
	        if (typeof options === 'function') {
	          return options() || [];
	        }
	
	        var start = parseOption(options.start);
	        var end = parseOption(options.end);
	        var step = parseOption(options.step);
	        var fmt = options.format || this.format;
	
	        if (start && end && step) {
	          var startMinutes = start.minutes + start.hours * 60;
	          var endMinutes = end.minutes + end.hours * 60;
	          var stepMinutes = step.minutes + step.hours * 60;
	          var len = Math.floor((endMinutes - startMinutes) / stepMinutes);
	
	          for (var i = 0; i <= len; i++) {
	            var timeMinutes = startMinutes + i * stepMinutes;
	            var hours = Math.floor(timeMinutes / 60);
	            var minutes = timeMinutes % 60;
	            var value = new Date(this.date).setHours(hours, minutes, 0);
	            result.push({
	              value: value,
	              text: this.formatDate(value, fmt)
	            });
	          }
	        }
	
	        return result;
	      }
	    },
	    mounted: function mounted() {
	      this.scrollToSelected();
	    },
	    methods: {
	      formatDate: function formatDate(date, fmt) {
	        return format(date, fmt, {
	          locale: this.getLocale().formatLocale
	        });
	      },
	      scrollToSelected: function scrollToSelected() {
	        var element = this.$el.querySelector('.active');
	        if (!element) return;
	        var scrollElement = getScrollParent(element, this.$el);
	        if (!scrollElement) return;
	        var to = element.offsetTop;
	        scrollTo$1(scrollElement, to);
	      },
	      handleSelect: function handleSelect(value) {
	        this.$emit('select', value, 'time');
	      }
	    }
	  };
	
	  /* script */
	  var __vue_script__$7 = script$7;
	  /* template */
	
	  var __vue_render__$a = function __vue_render__() {
	    var _vm = this;
	
	    var _h = _vm.$createElement;
	
	    var _c = _vm._self._c || _h;
	
	    return _c('scrollbar-vertical', _vm._l(_vm.list, function (item) {
	      return _c('div', {
	        key: item.value,
	        class: [_vm.prefixClass + "-time-option", _vm.getClasses(item.value)],
	        on: {
	          "click": function click($event) {
	            return _vm.handleSelect(item.value);
	          }
	        }
	      }, [_vm._v("\n    " + _vm._s(item.text) + "\n  ")]);
	    }), 0);
	  };
	
	  var __vue_staticRenderFns__$a = [];
	  /* style */
	
	  var __vue_inject_styles__$a = undefined;
	  /* scoped */
	
	  var __vue_scope_id__$a = undefined;
	  /* module identifier */
	
	  var __vue_module_identifier__$a = undefined;
	  /* functional template */
	
	  var __vue_is_functional_template__$a = false;
	  /* style inject */
	
	  /* style inject SSR */
	
	  /* style inject shadow dom */
	
	  var __vue_component__$a = normalizeComponent({
	    render: __vue_render__$a,
	    staticRenderFns: __vue_staticRenderFns__$a
	  }, __vue_inject_styles__$a, __vue_script__$7, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, undefined, undefined, undefined);
	
	  //
	  var script$8 = {
	    name: 'TimePanel',
	    components: {
	      ListColumns: __vue_component__$9,
	      ListOptions: __vue_component__$a
	    },
	    inject: {
	      getLocale: {
	        default: function _default() {
	          return getLocale;
	        }
	      },
	      prefixClass: {
	        default: 'mx'
	      }
	    },
	    props: {
	      value: {},
	      defaultValue: {
	        default: function _default() {
	          var date = new Date();
	          date.setHours(0, 0, 0, 0);
	          return date;
	        }
	      },
	      format: {
	        default: 'HH:mm:ss'
	      },
	      timeTitleFormat: {
	        type: String,
	        default: 'YYYY-MM-DD'
	      },
	      showTimeHeader: {
	        type: Boolean,
	        default: false
	      },
	      disabledTime: {
	        type: Function,
	        default: function _default() {
	          return false;
	        }
	      },
	      timePickerOptions: {
	        type: [Object, Function],
	        default: function _default() {
	          return null;
	        }
	      },
	      hourOptions: Array,
	      minuteOptions: Array,
	      secondOptions: Array,
	      hourStep: {
	        type: Number,
	        default: 1
	      },
	      minuteStep: {
	        type: Number,
	        default: 1
	      },
	      secondStep: {
	        type: Number,
	        default: 1
	      },
	      showHour: {
	        type: Boolean,
	        default: undefined
	      },
	      showMinute: {
	        type: Boolean,
	        default: undefined
	      },
	      showSecond: {
	        type: Boolean,
	        default: undefined
	      },
	      use12h: {
	        type: Boolean,
	        default: undefined
	      },
	      scrollDuration: {
	        type: Number,
	        default: 100
	      }
	    },
	    data: function data() {
	      return {
	        innerValue: getValidDate(this.value, this.defaultValue)
	      };
	    },
	    computed: {
	      title: function title() {
	        var titleFormat = this.timeTitleFormat;
	        var date = new Date(this.innerValue);
	        return this.formatDate(date, titleFormat);
	      },
	      innerForamt: function innerForamt() {
	        return typeof this.format === 'string' ? this.format : 'HH:mm:ss';
	      },
	      ShowHourMinuteSecondAMPM: function ShowHourMinuteSecondAMPM() {
	        var _this = this;
	
	        var fmt = this.innerForamt;
	        var defaultProps = {
	          showHour: /[HhKk]/.test(fmt),
	          showMinute: /m/.test(fmt),
	          showSecond: /s/.test(fmt),
	          use12h: /a/i.test(fmt)
	        };
	        var obj = {};
	        Object.keys(defaultProps).forEach(function (key) {
	          obj[key] = typeof _this[key] === 'boolean' ? _this[key] : defaultProps[key];
	        });
	        return obj;
	      }
	    },
	    watch: {
	      value: {
	        immediate: true,
	        handler: function handler() {
	          this.innerValue = getValidDate(this.value, this.defaultValue);
	        }
	      }
	    },
	    methods: {
	      formatDate: function formatDate(date, fmt) {
	        return format(date, fmt, {
	          locale: this.getLocale().formatLocale
	        });
	      },
	      isDisabledTime: function isDisabledTime(value) {
	        return this.disabledTime(new Date(value));
	      },
	      isDisabledHour: function isDisabledHour(date) {
	        var value = new Date(date);
	        return this.isDisabledTime(value) && this.isDisabledTime(value.setMinutes(0, 0, 0)) && this.isDisabledTime(value.setMinutes(59, 59, 999));
	      },
	      isDisabledMinute: function isDisabledMinute(date) {
	        var value = new Date(date);
	        return this.isDisabledTime(value) && this.isDisabledTime(value.setSeconds(0, 0)) && this.isDisabledTime(value.setSeconds(59, 999));
	      },
	      isDisabled: function isDisabled(date, type) {
	        if (type === 'hour') {
	          return this.isDisabledHour(date);
	        }
	
	        if (type === 'minute') {
	          return this.isDisabledMinute(date);
	        }
	
	        return this.isDisabledTime(date);
	      },
	      handleSelect: function handleSelect(value, type) {
	        var date = new Date(value);
	
	        if (!this.isDisabled(value, type)) {
	          this.innerValue = date;
	
	          if (!this.isDisabledTime(date)) {
	            this.$emit('select', date, type);
	          }
	        }
	      },
	      handleClickTitle: function handleClickTitle() {
	        this.$emit('clicktitle');
	      },
	      getClasses: function getClasses(value, type) {
	        var cellDate = new Date(value);
	
	        if (this.isDisabled(value, type)) {
	          return 'disabled';
	        }
	
	        if (cellDate.getTime() === this.innerValue.getTime()) {
	          return 'active';
	        }
	
	        return '';
	      }
	    }
	  };
	
	  /* script */
	  var __vue_script__$8 = script$8;
	  /* template */
	
	  var __vue_render__$b = function __vue_render__() {
	    var _vm = this;
	
	    var _h = _vm.$createElement;
	
	    var _c = _vm._self._c || _h;
	
	    return _c('div', {
	      class: _vm.prefixClass + "-time"
	    }, [_vm.showTimeHeader ? _c('div', {
	      class: _vm.prefixClass + "-time-header"
	    }, [_c('button', {
	      class: _vm.prefixClass + "-btn " + _vm.prefixClass + "-btn-text " + _vm.prefixClass + "-time-header-title",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": _vm.handleClickTitle
	      }
	    }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
	      class: _vm.prefixClass + "-time-content"
	    }, [_vm.timePickerOptions ? _c('list-options', {
	      attrs: {
	        "date": _vm.innerValue,
	        "get-classes": _vm.getClasses,
	        "options": _vm.timePickerOptions,
	        "format": _vm.innerForamt
	      },
	      on: {
	        "select": _vm.handleSelect
	      }
	    }) : _c('list-columns', _vm._b({
	      attrs: {
	        "date": _vm.innerValue,
	        "get-classes": _vm.getClasses,
	        "hour-options": _vm.hourOptions,
	        "minute-options": _vm.minuteOptions,
	        "second-options": _vm.secondOptions,
	        "hour-step": _vm.hourStep,
	        "minute-step": _vm.minuteStep,
	        "second-step": _vm.secondStep,
	        "scroll-duration": _vm.scrollDuration
	      },
	      on: {
	        "select": _vm.handleSelect
	      }
	    }, 'list-columns', _vm.ShowHourMinuteSecondAMPM, false))], 1)]);
	  };
	
	  var __vue_staticRenderFns__$b = [];
	  /* style */
	
	  var __vue_inject_styles__$b = undefined;
	  /* scoped */
	
	  var __vue_scope_id__$b = undefined;
	  /* module identifier */
	
	  var __vue_module_identifier__$b = undefined;
	  /* functional template */
	
	  var __vue_is_functional_template__$b = false;
	  /* style inject */
	
	  /* style inject SSR */
	
	  /* style inject shadow dom */
	
	  var __vue_component__$b = normalizeComponent({
	    render: __vue_render__$b,
	    staticRenderFns: __vue_staticRenderFns__$b
	  }, __vue_inject_styles__$b, __vue_script__$8, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, undefined, undefined, undefined);
	
	  var TimeRange = {
	    name: 'TimeRange',
	    inject: {
	      prefixClass: {
	        default: 'mx'
	      }
	    },
	    props: _objectSpread2({}, __vue_component__$b.props),
	    data: function data() {
	      return {
	        startValue: new Date(NaN),
	        endValue: new Date(NaN)
	      };
	    },
	    watch: {
	      value: {
	        immediate: true,
	        handler: function handler() {
	          if (isValidRangeDate(this.value)) {
	            var _this$value = _slicedToArray(this.value, 2),
	                startValue = _this$value[0],
	                endValue = _this$value[1];
	
	            this.startValue = startValue;
	            this.endValue = endValue;
	          } else {
	            this.startValue = new Date(NaN);
	            this.endValue = new Date(NaN);
	          }
	        }
	      }
	    },
	    methods: {
	      emitChange: function emitChange(type, index) {
	        var date = [this.startValue, this.endValue];
	        this.$emit('select', date, type === 'time' ? 'time-range' : type, index);
	      },
	      handleSelectStart: function handleSelectStart(date, type) {
	        this.startValue = date; // check the NaN
	
	        if (!(this.endValue.getTime() >= date.getTime())) {
	          this.endValue = date;
	        }
	
	        this.emitChange(type, 0);
	      },
	      handleSelectEnd: function handleSelectEnd(date, type) {
	        // check the NaN
	        this.endValue = date;
	
	        if (!(this.startValue.getTime() <= date.getTime())) {
	          this.startValue = date;
	        }
	
	        this.emitChange(type, 1);
	      },
	      disabledStartTime: function disabledStartTime(date) {
	        return this.disabledTime(date, 0);
	      },
	      disabledEndTime: function disabledEndTime(date) {
	        return date.getTime() < this.startValue.getTime() || this.disabledTime(date, 1);
	      }
	    },
	    render: function render() {
	      var h = arguments[0];
	      var defaultValues = Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue, this.defaultValue];
	      var prefixClass = this.prefixClass;
	      return h("div", {
	        "class": "".concat(prefixClass, "-range-wrapper")
	      }, [h(__vue_component__$b, {
	        "props": _objectSpread2({}, _objectSpread2({}, this.$props, {
	          value: this.startValue,
	          defaultValue: defaultValues[0],
	          disabledTime: this.disabledStartTime
	        })),
	        "on": _objectSpread2({}, _objectSpread2({}, this.$listeners, {
	          select: this.handleSelectStart
	        }))
	      }), h(__vue_component__$b, {
	        "props": _objectSpread2({}, _objectSpread2({}, this.$props, {
	          value: this.endValue,
	          defaultValue: defaultValues[1],
	          disabledTime: this.disabledEndTime
	        })),
	        "on": _objectSpread2({}, _objectSpread2({}, this.$listeners, {
	          select: this.handleSelectEnd
	        }))
	      })]);
	    }
	  };
	
	  var DatetimePanel = {
	    name: 'DatetimePanel',
	    inject: {
	      prefixClass: {
	        default: 'mx'
	      }
	    },
	    emits: ['select', 'update:show-time-panel'],
	    props: _objectSpread2({}, CalendarPanel.props, {}, __vue_component__$b.props, {
	      showTimePanel: {
	        type: Boolean,
	        default: undefined
	      }
	    }),
	    data: function data() {
	      return {
	        defaultTimeVisible: false,
	        currentValue: this.value
	      };
	    },
	    computed: {
	      timeVisible: function timeVisible() {
	        return typeof this.showTimePanel === 'boolean' ? this.showTimePanel : this.defaultTimeVisible;
	      }
	    },
	    watch: {
	      value: function value(val) {
	        this.currentValue = val;
	      }
	    },
	    methods: {
	      closeTimePanel: function closeTimePanel() {
	        this.defaultTimeVisible = false;
	        this.$emit('update:show-time-panel', false);
	      },
	      openTimePanel: function openTimePanel() {
	        this.defaultTimeVisible = true;
	        this.$emit('update:show-time-panel', true);
	      },
	      emitDate: function emitDate(date, type) {
	        this.$emit('select', date, type);
	      },
	      handleSelect: function handleSelect(date, type) {
	        if (type === 'date') {
	          this.openTimePanel();
	        }
	
	        var datetime = assignTime(date, getValidDate(this.value, this.defaultValue));
	
	        if (this.disabledTime(new Date(datetime))) {
	          // set the time of defalutValue;
	          datetime = assignTime(date, this.defaultValue);
	
	          if (this.disabledTime(new Date(datetime))) {
	            // if disabled don't emit date
	            this.currentValue = datetime;
	            return;
	          }
	        }
	
	        this.emitDate(datetime, type);
	      }
	    },
	    render: function render() {
	      var h = arguments[0];
	      var calendarProps = {
	        props: _objectSpread2({}, pick(this.$props, Object.keys(CalendarPanel.props)), {
	          type: 'date',
	          value: this.currentValue
	        }),
	        on: {
	          select: this.handleSelect
	        }
	      };
	      var timeProps = {
	        props: _objectSpread2({}, pick(this.$props, Object.keys(__vue_component__$b.props)), {
	          showTimeHeader: true,
	          value: this.currentValue
	        }),
	        on: {
	          select: this.emitDate,
	          clicktitle: this.closeTimePanel
	        }
	      };
	      var prefixClass = this.prefixClass;
	      return h("div", [h(CalendarPanel, helper([{}, calendarProps])), this.timeVisible && h(__vue_component__$b, helper([{
	        "class": "".concat(prefixClass, "-calendar-time")
	      }, timeProps]))]);
	    }
	  };
	
	  var DatetimeRange = {
	    name: 'DatetimeRange',
	    inject: {
	      prefixClass: {
	        default: 'mx'
	      }
	    },
	    emits: ['select', 'update:show-time-panel'],
	    props: _objectSpread2({}, CalendarRange.props, {}, TimeRange.props, {
	      showTimePanel: {
	        type: Boolean,
	        default: undefined
	      }
	    }),
	    data: function data() {
	      return {
	        defaultTimeVisible: false,
	        currentValue: this.value
	      };
	    },
	    computed: {
	      timeVisible: function timeVisible() {
	        return typeof this.showTimePanel === 'boolean' ? this.showTimePanel : this.defaultTimeVisible;
	      }
	    },
	    watch: {
	      value: function value(val) {
	        this.currentValue = val;
	      }
	    },
	    methods: {
	      closeTimePanel: function closeTimePanel() {
	        this.defaultTimeVisible = false;
	        this.$emit('update:show-time-panel', false);
	      },
	      openTimePanel: function openTimePanel() {
	        this.defaultTimeVisible = true;
	        this.$emit('update:show-time-panel', true);
	      },
	      emitDate: function emitDate(dates, type) {
	        this.$emit('select', dates, type);
	      },
	      handleSelect: function handleSelect(dates, type) {
	        var _this = this;
	
	        if (type === 'date') {
	          this.openTimePanel();
	        }
	
	        var defaultValues = Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue, this.defaultValue];
	        var datetimes = dates.map(function (date, i) {
	          var time = isValidRangeDate(_this.value) ? _this.value[i] : defaultValues[i];
	          return assignTime(date, time);
	        });
	
	        if (datetimes[1].getTime() < datetimes[0].getTime()) {
	          datetimes = [datetimes[0], datetimes[0]];
	        }
	
	        if (datetimes.some(this.disabledTime)) {
	          datetimes = dates.map(function (date, i) {
	            return assignTime(date, defaultValues[i]);
	          });
	
	          if (datetimes.some(this.disabledTime)) {
	            this.currentValue = datetimes;
	            return;
	          }
	        }
	
	        this.emitDate(datetimes, type);
	      }
	    },
	    render: function render() {
	      var h = arguments[0];
	      var calendarProps = {
	        props: _objectSpread2({}, pick(this.$props, Object.keys(CalendarRange.props)), {
	          type: 'date',
	          value: this.currentValue
	        }),
	        on: {
	          select: this.handleSelect
	        }
	      };
	      var timeProps = {
	        props: _objectSpread2({}, pick(this.$props, Object.keys(TimeRange.props)), {
	          value: this.currentValue,
	          showTimeHeader: true
	        }),
	        on: {
	          select: this.emitDate,
	          clicktitle: this.closeTimePanel
	        }
	      };
	      var prefixClass = this.prefixClass;
	      return h("div", [h(CalendarRange, helper([{}, calendarProps])), this.timeVisible && h(TimeRange, helper([{
	        "class": "".concat(prefixClass, "-calendar-time")
	      }, timeProps]))]);
	    }
	  };
	
	  var componentMap = {
	    default: CalendarPanel,
	    time: __vue_component__$b,
	    datetime: DatetimePanel
	  };
	  var componentRangeMap = {
	    default: CalendarRange,
	    time: TimeRange,
	    datetime: DatetimeRange
	  };
	  var DatePicker = {
	    name: 'DatePicker',
	    provide: function provide() {
	      var _this = this;
	
	      return {
	        // make locale reactive
	        getLocale: function getLocale() {
	          return _this.locale;
	        },
	        getWeek: this.getWeek,
	        prefixClass: this.prefixClass,
	        dispatchDatePicker: this.$emit.bind(this)
	      };
	    },
	    props: _objectSpread2({}, DatetimePanel.props, {
	      value: {},
	      valueType: {
	        type: String,
	        default: 'date' // date, format, timestamp, or token like 'YYYY-MM-DD'
	
	      },
	      type: {
	        type: String,
	        // ['date', 'datetime', 'time', 'year', 'month', 'week']
	        default: 'date'
	      },
	      format: {
	        type: String
	      },
	      formatter: {
	        type: Object
	      },
	      range: {
	        type: Boolean,
	        default: false
	      },
	      multiple: {
	        type: Boolean,
	        default: false
	      },
	      rangeSeparator: {
	        type: String
	      },
	      lang: {
	        type: [String, Object]
	      },
	      placeholder: {
	        type: String,
	        default: ''
	      },
	      editable: {
	        type: Boolean,
	        default: true
	      },
	      disabled: {
	        type: Boolean,
	        default: false
	      },
	      clearable: {
	        type: Boolean,
	        default: true
	      },
	      prefixClass: {
	        type: String,
	        default: 'mx'
	      },
	      inputClass: {},
	      inputAttr: {
	        type: Object,
	        default: function _default() {
	          return {};
	        }
	      },
	      appendToBody: {
	        type: Boolean,
	        default: true
	      },
	      open: {
	        type: Boolean,
	        default: undefined
	      },
	      popupClass: {},
	      popupStyle: {
	        type: Object,
	        default: function _default() {
	          return {};
	        }
	      },
	      inline: {
	        type: Boolean,
	        default: false
	      },
	      confirm: {
	        type: Boolean,
	        default: false
	      },
	      confirmText: {
	        type: String,
	        default: 'OK'
	      },
	      renderInputText: {
	        type: Function
	      },
	      shortcuts: {
	        type: Array,
	        validator: function validator(value) {
	          return Array.isArray(value) && value.every(function (v) {
	            return isObject(v) && typeof v.text === 'string' && typeof v.onClick === 'function';
	          });
	        },
	        default: function _default() {
	          return [];
	        }
	      }
	    }),
	    data: function data() {
	      return {
	        // cache the innervalue, wait to confirm
	        currentValue: null,
	        userInput: null,
	        defaultOpen: false
	      };
	    },
	    computed: {
	      popupVisible: function popupVisible() {
	        return !this.disabled && (typeof this.open === 'boolean' ? this.open : this.defaultOpen);
	      },
	      innerRangeSeparator: function innerRangeSeparator() {
	        return this.rangeSeparator || (this.multiple ? ',' : ' ~ ');
	      },
	      innerFormat: function innerFormat() {
	        var map = {
	          date: 'YYYY-MM-DD',
	          datetime: 'YYYY-MM-DD HH:mm:ss',
	          year: 'YYYY',
	          month: 'YYYY-MM',
	          time: 'HH:mm:ss',
	          week: 'w'
	        };
	        return this.format || map[this.type] || map.date;
	      },
	      innerValue: function innerValue() {
	        var value = this.value;
	
	        if (this.validMultipleType) {
	          value = Array.isArray(value) ? value : [];
	          return value.map(this.value2date);
	        }
	
	        if (this.range) {
	          value = Array.isArray(value) ? value.slice(0, 2) : [null, null];
	          return value.map(this.value2date);
	        }
	
	        return this.value2date(value);
	      },
	      text: function text() {
	        var _this2 = this;
	
	        if (this.userInput !== null) {
	          return this.userInput;
	        }
	
	        if (typeof this.renderInputText === 'function') {
	          return this.renderInputText(this.innerValue);
	        }
	
	        if (!this.isValidValue(this.innerValue)) {
	          return '';
	        }
	
	        if (Array.isArray(this.innerValue)) {
	          return this.innerValue.map(function (v) {
	            return _this2.formatDate(v);
	          }).join(this.innerRangeSeparator);
	        }
	
	        return this.formatDate(this.innerValue);
	      },
	      showClearIcon: function showClearIcon() {
	        return !this.disabled && this.clearable && this.text;
	      },
	      locale: function locale() {
	        if (isObject(this.lang)) {
	          return mergeDeep(getLocale(), this.lang);
	        }
	
	        return getLocale(this.lang);
	      },
	      validMultipleType: function validMultipleType() {
	        var types = ['date', 'month', 'year'];
	        return this.multiple && !this.range && types.indexOf(this.type) !== -1;
	      }
	    },
	    watch: {
	      innerValue: {
	        immediate: true,
	        handler: function handler(val) {
	          this.currentValue = val;
	        }
	      },
	      popupVisible: {
	        handler: function handler(val) {
	          if (val) {
	            this.currentValue = this.innerValue;
	          }
	        }
	      }
	    },
	    created: function created() {
	      if (_typeof(this.format) === 'object') {
	        console.warn("[vue2-datepicker]: The prop `format` don't support Object any more. You can use the new prop `formatter` to replace it");
	      }
	    },
	    methods: {
	      handleClickOutSide: function handleClickOutSide(evt) {
	        var target = evt.target;
	
	        if (!this.$el.contains(target)) {
	          this.closePopup();
	        }
	      },
	      getFormatter: function getFormatter(key) {
	        return isObject(this.formatter) && this.formatter[key] || isObject(this.format) && this.format[key];
	      },
	      getWeek: function getWeek$1(date, options) {
	        if (typeof this.getFormatter('getWeek') === 'function') {
	          return this.getFormatter('getWeek')(date, options);
	        }
	
	        return getWeek(date, options);
	      },
	      parseDate: function parseDate(value, fmt) {
	        fmt = fmt || this.innerFormat;
	
	        if (typeof this.getFormatter('parse') === 'function') {
	          return this.getFormatter('parse')(value, fmt);
	        }
	
	        var backupDate = new Date();
	        return parse(value, fmt, {
	          locale: this.locale.formatLocale,
	          backupDate: backupDate
	        });
	      },
	      formatDate: function formatDate(date, fmt) {
	        fmt = fmt || this.innerFormat;
	
	        if (typeof this.getFormatter('stringify') === 'function') {
	          return this.getFormatter('stringify')(date, fmt);
	        }
	
	        return format(date, fmt, {
	          locale: this.locale.formatLocale
	        });
	      },
	      // transform the outer value to inner date
	      value2date: function value2date(value) {
	        switch (this.valueType) {
	          case 'date':
	            return value instanceof Date ? new Date(value.getTime()) : new Date(NaN);
	
	          case 'timestamp':
	            return typeof value === 'number' ? new Date(value) : new Date(NaN);
	
	          case 'format':
	            return typeof value === 'string' ? this.parseDate(value) : new Date(NaN);
	
	          default:
	            return typeof value === 'string' ? this.parseDate(value, this.valueType) : new Date(NaN);
	        }
	      },
	      // transform the inner date to outer value
	      date2value: function date2value(date) {
	        if (!isValidDate$1(date)) return null;
	
	        switch (this.valueType) {
	          case 'date':
	            return date;
	
	          case 'timestamp':
	            return date.getTime();
	
	          case 'format':
	            return this.formatDate(date);
	
	          default:
	            return this.formatDate(date, this.valueType);
	        }
	      },
	      emitValue: function emitValue(date, type) {
	        var close = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	        // fix IE11/10 trigger input event when input is focused. (placeholder !== '')
	        this.userInput = null;
	        var value = Array.isArray(date) ? date.map(this.date2value) : this.date2value(date);
	        this.$emit('input', value);
	        this.$emit('change', value, type);
	
	        if (close) {
	          this.closePopup();
	        }
	
	        return value;
	      },
	      isValidValue: function isValidValue(value) {
	        if (this.validMultipleType) {
	          return isValidDates(value);
	        }
	
	        if (this.range) {
	          return isValidRangeDate(value);
	        }
	
	        return isValidDate$1(value);
	      },
	      isValidValueAndNotDisabled: function isValidValueAndNotDisabled(value) {
	        if (!this.isValidValue(value)) {
	          return false;
	        }
	
	        var disabledDate = typeof this.disabledDate === 'function' ? this.disabledDate : function () {
	          return false;
	        };
	        var disabledTime = typeof this.disabledTime === 'function' ? this.disabledTime : function () {
	          return false;
	        };
	
	        if (!Array.isArray(value)) {
	          value = [value];
	        }
	
	        return value.every(function (v) {
	          return !disabledDate(v) && !disabledTime(v);
	        });
	      },
	      handleMultipleDates: function handleMultipleDates(date, dates) {
	        if (this.validMultipleType && dates) {
	          var nextDates = dates.filter(function (v) {
	            return v.getTime() !== date.getTime();
	          });
	
	          if (nextDates.length === dates.length) {
	            nextDates.push(date);
	          }
	
	          return nextDates;
	        }
	
	        return date;
	      },
	      handleSelectDate: function handleSelectDate(val, type, dates) {
	        val = this.handleMultipleDates(val, dates);
	
	        if (this.confirm) {
	          this.currentValue = val;
	        } else {
	          this.emitValue(val, type, // this.type === 'datetime', click the time should close popup
	          !this.validMultipleType && (type === this.type || type === 'time'));
	        }
	      },
	      clear: function clear() {
	        this.emitValue(this.range ? [null, null] : null);
	        this.$emit('clear');
	      },
	      handleClear: function handleClear(evt) {
	        evt.stopPropagation();
	        this.clear();
	      },
	      handleConfirmDate: function handleConfirmDate() {
	        var value = this.emitValue(this.currentValue);
	        this.$emit('confirm', value);
	      },
	      handleSelectShortcut: function handleSelectShortcut(evt) {
	        var index = evt.currentTarget.getAttribute('data-index');
	        var item = this.shortcuts[parseInt(index, 10)];
	
	        if (isObject(item) && typeof item.onClick === 'function') {
	          var date = item.onClick(this);
	
	          if (date) {
	            this.emitValue(date);
	          }
	        }
	      },
	      openPopup: function openPopup(evt) {
	        if (this.popupVisible || this.disabled) return;
	        this.defaultOpen = true;
	        this.$emit('open', evt);
	        this.$emit('update:open', true);
	      },
	      closePopup: function closePopup() {
	        if (!this.popupVisible) return;
	        this.defaultOpen = false;
	        this.$emit('close');
	        this.$emit('update:open', false);
	      },
	      blur: function blur() {
	        // when use slot input
	        if (this.$refs.input) {
	          this.$refs.input.blur();
	        }
	      },
	      focus: function focus() {
	        if (this.$refs.input) {
	          this.$refs.input.focus();
	        }
	      },
	      handleInputChange: function handleInputChange() {
	        var _this3 = this;
	
	        if (!this.editable || this.userInput === null) return;
	        var text = this.userInput.trim();
	        this.userInput = null;
	
	        if (text === '') {
	          this.clear();
	          return;
	        }
	
	        var date;
	
	        if (this.validMultipleType) {
	          date = text.split(this.innerRangeSeparator).map(function (v) {
	            return _this3.parseDate(v.trim());
	          });
	        } else if (this.range) {
	          var arr = text.split(this.innerRangeSeparator);
	
	          if (arr.length !== 2) {
	            // Maybe the separator during the day is the same as the separator for the date
	            // eg: 2019-10-09-2020-01-02
	            arr = text.split(this.innerRangeSeparator.trim());
	          }
	
	          date = arr.map(function (v) {
	            return _this3.parseDate(v.trim());
	          });
	        } else {
	          date = this.parseDate(text);
	        }
	
	        if (this.isValidValueAndNotDisabled(date)) {
	          this.emitValue(date);
	          this.blur();
	        } else {
	          this.$emit('input-error', text);
	        }
	      },
	      handleInputInput: function handleInputInput(evt) {
	        // slot input v-model
	        this.userInput = typeof evt === 'string' ? evt : evt.target.value;
	      },
	      handleInputKeydown: function handleInputKeydown(evt) {
	        var keyCode = evt.keyCode; // Tab 9 or Enter 13
	
	        if (keyCode === 9) {
	          this.closePopup();
	        } else if (keyCode === 13) {
	          this.handleInputChange();
	        }
	      },
	      handleInputBlur: function handleInputBlur(evt) {
	        // tab close
	        this.$emit('blur', evt);
	      },
	      handleInputFocus: function handleInputFocus(evt) {
	        this.openPopup(evt);
	        this.$emit('focus', evt);
	      },
	      hasSlot: function hasSlot(name) {
	        return !!(this.$slots[name] || this.$scopedSlots[name]);
	      },
	      renderSlot: function renderSlot(name, fallback, props) {
	        var slotFn = this.$scopedSlots[name];
	
	        if (slotFn) {
	          return slotFn(props) || fallback;
	        }
	
	        return this.$slots[name] || fallback;
	      },
	      renderInput: function renderInput() {
	        var h = this.$createElement;
	        var prefixClass = this.prefixClass;
	
	        var props = _objectSpread2({
	          name: 'date',
	          type: 'text',
	          autocomplete: 'off',
	          value: this.text,
	          class: this.inputClass || "".concat(this.prefixClass, "-input"),
	          readonly: !this.editable,
	          disabled: this.disabled,
	          placeholder: this.placeholder
	        }, this.inputAttr);
	
	        var value = props.value,
	            className = props.class,
	            attrs = _objectWithoutProperties(props, ["value", "class"]);
	
	        var events = {
	          keydown: this.handleInputKeydown,
	          focus: this.handleInputFocus,
	          blur: this.handleInputBlur,
	          input: this.handleInputInput,
	          change: this.handleInputChange
	        };
	        var input = this.renderSlot('input', h("input", {
	          "domProps": {
	            "value": value
	          },
	          "class": className,
	          "attrs": _objectSpread2({}, attrs),
	          "on": _objectSpread2({}, events),
	          "ref": "input"
	        }), {
	          props: props,
	          events: events
	        });
	        var calendarIcon = this.type === 'time' ? h(__vue_component__$2) : h(__vue_component__$1);
	        return h("div", {
	          "class": "".concat(prefixClass, "-input-wrapper"),
	          "on": {
	            "mousedown": this.openPopup
	          }
	        }, [input, this.showClearIcon ? h("i", {
	          "class": "".concat(prefixClass, "-icon-clear"),
	          "on": {
	            "mousedown": this.handleClear
	          }
	        }, [this.renderSlot('icon-clear', h(__vue_component__$3))]) : null, h("i", {
	          "class": "".concat(prefixClass, "-icon-calendar")
	        }, [this.renderSlot('icon-calendar', calendarIcon)])]);
	      },
	      renderContent: function renderContent() {
	        var h = this.$createElement;
	        var map = this.range ? componentRangeMap : componentMap;
	        var Component = map[this.type] || map.default;
	
	        var props = _objectSpread2({}, pick(this.$props, Object.keys(Component.props)), {
	          value: this.currentValue
	        });
	
	        var on = _objectSpread2({}, pick(this.$listeners, Component.emits || []), {
	          select: this.handleSelectDate
	        });
	
	        var content = h(Component, helper([{}, {
	          props: props,
	          on: on,
	          ref: 'picker'
	        }]));
	        return h("div", {
	          "class": "".concat(this.prefixClass, "-datepicker-body")
	        }, [this.renderSlot('content', content, {
	          value: this.currentValue,
	          emit: this.handleSelectDate
	        })]);
	      },
	      renderSidebar: function renderSidebar() {
	        var _this4 = this;
	
	        var h = this.$createElement;
	        var prefixClass = this.prefixClass;
	        return h("div", {
	          "class": "".concat(prefixClass, "-datepicker-sidebar")
	        }, [this.renderSlot('sidebar', null, {
	          value: this.currentValue,
	          emit: this.handleSelectDate
	        }), this.shortcuts.map(function (v, i) {
	          return h("button", {
	            "key": i,
	            "attrs": {
	              "data-index": i,
	              "type": "button"
	            },
	            "class": "".concat(prefixClass, "-btn ").concat(prefixClass, "-btn-text ").concat(prefixClass, "-btn-shortcut"),
	            "on": {
	              "click": _this4.handleSelectShortcut
	            }
	          }, [v.text]);
	        })]);
	      },
	      renderHeader: function renderHeader() {
	        var h = this.$createElement;
	        return h("div", {
	          "class": "".concat(this.prefixClass, "-datepicker-header")
	        }, [this.renderSlot('header', null, {
	          value: this.currentValue,
	          emit: this.handleSelectDate
	        })]);
	      },
	      renderFooter: function renderFooter() {
	        var h = this.$createElement;
	        var prefixClass = this.prefixClass;
	        return h("div", {
	          "class": "".concat(prefixClass, "-datepicker-footer")
	        }, [this.renderSlot('footer', null, {
	          value: this.currentValue,
	          emit: this.handleSelectDate
	        }), this.confirm ? h("button", {
	          "attrs": {
	            "type": "button"
	          },
	          "class": "".concat(prefixClass, "-btn ").concat(prefixClass, "-datepicker-btn-confirm"),
	          "on": {
	            "click": this.handleConfirmDate
	          }
	        }, [this.confirmText]) : null]);
	      }
	    },
	    render: function render() {
	      var _class;
	
	      var h = arguments[0];
	      var prefixClass = this.prefixClass,
	          inline = this.inline,
	          disabled = this.disabled;
	      var sidedar = this.hasSlot('sidebar') || this.shortcuts.length ? this.renderSidebar() : null;
	      var content = h("div", {
	        "class": "".concat(prefixClass, "-datepicker-content")
	      }, [this.hasSlot('header') ? this.renderHeader() : null, this.renderContent(), this.hasSlot('footer') || this.confirm ? this.renderFooter() : null]);
	      return h("div", {
	        "class": (_class = {}, _defineProperty(_class, "".concat(prefixClass, "-datepicker"), true), _defineProperty(_class, "".concat(prefixClass, "-datepicker-range"), this.range), _defineProperty(_class, "".concat(prefixClass, "-datepicker-inline"), inline), _defineProperty(_class, "disabled", disabled), _class)
	      }, [!inline ? this.renderInput() : null, !inline ? h(__vue_component__, {
	        "ref": "popup",
	        "class": this.popupClass,
	        "style": this.popupStyle,
	        "attrs": {
	          "visible": this.popupVisible,
	          "appendToBody": this.appendToBody
	        },
	        "on": {
	          "clickoutside": this.handleClickOutSide
	        }
	      }, [sidedar, content]) : h("div", {
	        "class": "".concat(prefixClass, "-datepicker-main")
	      }, [sidedar, content])]);
	    }
	  };
	
	  DatePicker.locale = locale$1;
	
	  DatePicker.install = function install(Vue) {
	    Vue.component(DatePicker.name, DatePicker);
	  };
	
	  if (typeof window !== 'undefined' && window.Vue) {
	    DatePicker.install(window.Vue);
	  }
	
	  _extends(DatePicker, {
	    CalendarPanel: CalendarPanel,
	    CalendarRange: CalendarRange,
	    TimePanel: __vue_component__$b,
	    TimeRange: TimeRange,
	    DatetimePanel: DatetimePanel,
	    DatetimeRange: DatetimeRange
	  });
	
	  return DatePicker;
	
	})));
	//# sourceMappingURL=index.js.map


/***/ }),
/* 534 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var invariant_1 = __webpack_require__(165);
	var helpers_1 = __webpack_require__(96);
	//http://en.wikipedia.org/wiki/Haversine_formula
	//http://www.movable-type.co.uk/scripts/latlong.html
	/**
	 * Calculates the distance between two {@link Point|points} in degrees, radians, miles, or kilometers.
	 * This uses the [Haversine formula](http://en.wikipedia.org/wiki/Haversine_formula) to account for global curvature.
	 *
	 * @name distance
	 * @param {Coord | Point} from origin point or coordinate
	 * @param {Coord | Point} to destination point or coordinate
	 * @param {Object} [options={}] Optional parameters
	 * @param {string} [options.units='kilometers'] can be degrees, radians, miles, or kilometers
	 * @returns {number} distance between the two points
	 * @example
	 * var from = turf.point([-75.343, 39.984]);
	 * var to = turf.point([-75.534, 39.123]);
	 * var options = {units: 'miles'};
	 *
	 * var distance = turf.distance(from, to, options);
	 *
	 * //addToMap
	 * var addToMap = [from, to];
	 * from.properties.distance = distance;
	 * to.properties.distance = distance;
	 */
	function distance(from, to, options) {
	    if (options === void 0) { options = {}; }
	    var coordinates1 = invariant_1.getCoord(from);
	    var coordinates2 = invariant_1.getCoord(to);
	    var dLat = helpers_1.degreesToRadians(coordinates2[1] - coordinates1[1]);
	    var dLon = helpers_1.degreesToRadians(coordinates2[0] - coordinates1[0]);
	    var lat1 = helpers_1.degreesToRadians(coordinates1[1]);
	    var lat2 = helpers_1.degreesToRadians(coordinates2[1]);
	    var a = Math.pow(Math.sin(dLat / 2), 2) +
	        Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);
	    return helpers_1.radiansToLength(2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)), options.units);
	}
	exports.default = distance;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var helpers = __webpack_require__(96);
	
	/**
	 * Callback for coordEach
	 *
	 * @callback coordEachCallback
	 * @param {Array<number>} currentCoord The current coordinate being processed.
	 * @param {number} coordIndex The current index of the coordinate being processed.
	 * @param {number} featureIndex The current index of the Feature being processed.
	 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
	 * @param {number} geometryIndex The current index of the Geometry being processed.
	 */
	
	/**
	 * Iterate over coordinates in any GeoJSON object, similar to Array.forEach()
	 *
	 * @name coordEach
	 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
	 * @param {Function} callback a method that takes (currentCoord, coordIndex, featureIndex, multiFeatureIndex)
	 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
	 * @returns {void}
	 * @example
	 * var features = turf.featureCollection([
	 *   turf.point([26, 37], {"foo": "bar"}),
	 *   turf.point([36, 53], {"hello": "world"})
	 * ]);
	 *
	 * turf.coordEach(features, function (currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
	 *   //=currentCoord
	 *   //=coordIndex
	 *   //=featureIndex
	 *   //=multiFeatureIndex
	 *   //=geometryIndex
	 * });
	 */
	function coordEach(geojson, callback, excludeWrapCoord) {
	  // Handles null Geometry -- Skips this GeoJSON
	  if (geojson === null) return;
	  var j,
	    k,
	    l,
	    geometry,
	    stopG,
	    coords,
	    geometryMaybeCollection,
	    wrapShrink = 0,
	    coordIndex = 0,
	    isGeometryCollection,
	    type = geojson.type,
	    isFeatureCollection = type === "FeatureCollection",
	    isFeature = type === "Feature",
	    stop = isFeatureCollection ? geojson.features.length : 1;
	
	  // This logic may look a little weird. The reason why it is that way
	  // is because it's trying to be fast. GeoJSON supports multiple kinds
	  // of objects at its root: FeatureCollection, Features, Geometries.
	  // This function has the responsibility of handling all of them, and that
	  // means that some of the `for` loops you see below actually just don't apply
	  // to certain inputs. For instance, if you give this just a
	  // Point geometry, then both loops are short-circuited and all we do
	  // is gradually rename the input until it's called 'geometry'.
	  //
	  // This also aims to allocate as few resources as possible: just a
	  // few numbers and booleans, rather than any temporary arrays as would
	  // be required with the normalization approach.
	  for (var featureIndex = 0; featureIndex < stop; featureIndex++) {
	    geometryMaybeCollection = isFeatureCollection
	      ? geojson.features[featureIndex].geometry
	      : isFeature
	      ? geojson.geometry
	      : geojson;
	    isGeometryCollection = geometryMaybeCollection
	      ? geometryMaybeCollection.type === "GeometryCollection"
	      : false;
	    stopG = isGeometryCollection
	      ? geometryMaybeCollection.geometries.length
	      : 1;
	
	    for (var geomIndex = 0; geomIndex < stopG; geomIndex++) {
	      var multiFeatureIndex = 0;
	      var geometryIndex = 0;
	      geometry = isGeometryCollection
	        ? geometryMaybeCollection.geometries[geomIndex]
	        : geometryMaybeCollection;
	
	      // Handles null Geometry -- Skips this geometry
	      if (geometry === null) continue;
	      coords = geometry.coordinates;
	      var geomType = geometry.type;
	
	      wrapShrink =
	        excludeWrapCoord &&
	        (geomType === "Polygon" || geomType === "MultiPolygon")
	          ? 1
	          : 0;
	
	      switch (geomType) {
	        case null:
	          break;
	        case "Point":
	          if (
	            callback(
	              coords,
	              coordIndex,
	              featureIndex,
	              multiFeatureIndex,
	              geometryIndex
	            ) === false
	          )
	            return false;
	          coordIndex++;
	          multiFeatureIndex++;
	          break;
	        case "LineString":
	        case "MultiPoint":
	          for (j = 0; j < coords.length; j++) {
	            if (
	              callback(
	                coords[j],
	                coordIndex,
	                featureIndex,
	                multiFeatureIndex,
	                geometryIndex
	              ) === false
	            )
	              return false;
	            coordIndex++;
	            if (geomType === "MultiPoint") multiFeatureIndex++;
	          }
	          if (geomType === "LineString") multiFeatureIndex++;
	          break;
	        case "Polygon":
	        case "MultiLineString":
	          for (j = 0; j < coords.length; j++) {
	            for (k = 0; k < coords[j].length - wrapShrink; k++) {
	              if (
	                callback(
	                  coords[j][k],
	                  coordIndex,
	                  featureIndex,
	                  multiFeatureIndex,
	                  geometryIndex
	                ) === false
	              )
	                return false;
	              coordIndex++;
	            }
	            if (geomType === "MultiLineString") multiFeatureIndex++;
	            if (geomType === "Polygon") geometryIndex++;
	          }
	          if (geomType === "Polygon") multiFeatureIndex++;
	          break;
	        case "MultiPolygon":
	          for (j = 0; j < coords.length; j++) {
	            geometryIndex = 0;
	            for (k = 0; k < coords[j].length; k++) {
	              for (l = 0; l < coords[j][k].length - wrapShrink; l++) {
	                if (
	                  callback(
	                    coords[j][k][l],
	                    coordIndex,
	                    featureIndex,
	                    multiFeatureIndex,
	                    geometryIndex
	                  ) === false
	                )
	                  return false;
	                coordIndex++;
	              }
	              geometryIndex++;
	            }
	            multiFeatureIndex++;
	          }
	          break;
	        case "GeometryCollection":
	          for (j = 0; j < geometry.geometries.length; j++)
	            if (
	              coordEach(geometry.geometries[j], callback, excludeWrapCoord) ===
	              false
	            )
	              return false;
	          break;
	        default:
	          throw new Error("Unknown Geometry Type");
	      }
	    }
	  }
	}
	
	/**
	 * Callback for coordReduce
	 *
	 * The first time the callback function is called, the values provided as arguments depend
	 * on whether the reduce method has an initialValue argument.
	 *
	 * If an initialValue is provided to the reduce method:
	 *  - The previousValue argument is initialValue.
	 *  - The currentValue argument is the value of the first element present in the array.
	 *
	 * If an initialValue is not provided:
	 *  - The previousValue argument is the value of the first element present in the array.
	 *  - The currentValue argument is the value of the second element present in the array.
	 *
	 * @callback coordReduceCallback
	 * @param {*} previousValue The accumulated value previously returned in the last invocation
	 * of the callback, or initialValue, if supplied.
	 * @param {Array<number>} currentCoord The current coordinate being processed.
	 * @param {number} coordIndex The current index of the coordinate being processed.
	 * Starts at index 0, if an initialValue is provided, and at index 1 otherwise.
	 * @param {number} featureIndex The current index of the Feature being processed.
	 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
	 * @param {number} geometryIndex The current index of the Geometry being processed.
	 */
	
	/**
	 * Reduce coordinates in any GeoJSON object, similar to Array.reduce()
	 *
	 * @name coordReduce
	 * @param {FeatureCollection|Geometry|Feature} geojson any GeoJSON object
	 * @param {Function} callback a method that takes (previousValue, currentCoord, coordIndex)
	 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
	 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
	 * @returns {*} The value that results from the reduction.
	 * @example
	 * var features = turf.featureCollection([
	 *   turf.point([26, 37], {"foo": "bar"}),
	 *   turf.point([36, 53], {"hello": "world"})
	 * ]);
	 *
	 * turf.coordReduce(features, function (previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
	 *   //=previousValue
	 *   //=currentCoord
	 *   //=coordIndex
	 *   //=featureIndex
	 *   //=multiFeatureIndex
	 *   //=geometryIndex
	 *   return currentCoord;
	 * });
	 */
	function coordReduce(geojson, callback, initialValue, excludeWrapCoord) {
	  var previousValue = initialValue;
	  coordEach(
	    geojson,
	    function (
	      currentCoord,
	      coordIndex,
	      featureIndex,
	      multiFeatureIndex,
	      geometryIndex
	    ) {
	      if (coordIndex === 0 && initialValue === undefined)
	        previousValue = currentCoord;
	      else
	        previousValue = callback(
	          previousValue,
	          currentCoord,
	          coordIndex,
	          featureIndex,
	          multiFeatureIndex,
	          geometryIndex
	        );
	    },
	    excludeWrapCoord
	  );
	  return previousValue;
	}
	
	/**
	 * Callback for propEach
	 *
	 * @callback propEachCallback
	 * @param {Object} currentProperties The current Properties being processed.
	 * @param {number} featureIndex The current index of the Feature being processed.
	 */
	
	/**
	 * Iterate over properties in any GeoJSON object, similar to Array.forEach()
	 *
	 * @name propEach
	 * @param {FeatureCollection|Feature} geojson any GeoJSON object
	 * @param {Function} callback a method that takes (currentProperties, featureIndex)
	 * @returns {void}
	 * @example
	 * var features = turf.featureCollection([
	 *     turf.point([26, 37], {foo: 'bar'}),
	 *     turf.point([36, 53], {hello: 'world'})
	 * ]);
	 *
	 * turf.propEach(features, function (currentProperties, featureIndex) {
	 *   //=currentProperties
	 *   //=featureIndex
	 * });
	 */
	function propEach(geojson, callback) {
	  var i;
	  switch (geojson.type) {
	    case "FeatureCollection":
	      for (i = 0; i < geojson.features.length; i++) {
	        if (callback(geojson.features[i].properties, i) === false) break;
	      }
	      break;
	    case "Feature":
	      callback(geojson.properties, 0);
	      break;
	  }
	}
	
	/**
	 * Callback for propReduce
	 *
	 * The first time the callback function is called, the values provided as arguments depend
	 * on whether the reduce method has an initialValue argument.
	 *
	 * If an initialValue is provided to the reduce method:
	 *  - The previousValue argument is initialValue.
	 *  - The currentValue argument is the value of the first element present in the array.
	 *
	 * If an initialValue is not provided:
	 *  - The previousValue argument is the value of the first element present in the array.
	 *  - The currentValue argument is the value of the second element present in the array.
	 *
	 * @callback propReduceCallback
	 * @param {*} previousValue The accumulated value previously returned in the last invocation
	 * of the callback, or initialValue, if supplied.
	 * @param {*} currentProperties The current Properties being processed.
	 * @param {number} featureIndex The current index of the Feature being processed.
	 */
	
	/**
	 * Reduce properties in any GeoJSON object into a single value,
	 * similar to how Array.reduce works. However, in this case we lazily run
	 * the reduction, so an array of all properties is unnecessary.
	 *
	 * @name propReduce
	 * @param {FeatureCollection|Feature} geojson any GeoJSON object
	 * @param {Function} callback a method that takes (previousValue, currentProperties, featureIndex)
	 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
	 * @returns {*} The value that results from the reduction.
	 * @example
	 * var features = turf.featureCollection([
	 *     turf.point([26, 37], {foo: 'bar'}),
	 *     turf.point([36, 53], {hello: 'world'})
	 * ]);
	 *
	 * turf.propReduce(features, function (previousValue, currentProperties, featureIndex) {
	 *   //=previousValue
	 *   //=currentProperties
	 *   //=featureIndex
	 *   return currentProperties
	 * });
	 */
	function propReduce(geojson, callback, initialValue) {
	  var previousValue = initialValue;
	  propEach(geojson, function (currentProperties, featureIndex) {
	    if (featureIndex === 0 && initialValue === undefined)
	      previousValue = currentProperties;
	    else
	      previousValue = callback(previousValue, currentProperties, featureIndex);
	  });
	  return previousValue;
	}
	
	/**
	 * Callback for featureEach
	 *
	 * @callback featureEachCallback
	 * @param {Feature<any>} currentFeature The current Feature being processed.
	 * @param {number} featureIndex The current index of the Feature being processed.
	 */
	
	/**
	 * Iterate over features in any GeoJSON object, similar to
	 * Array.forEach.
	 *
	 * @name featureEach
	 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
	 * @param {Function} callback a method that takes (currentFeature, featureIndex)
	 * @returns {void}
	 * @example
	 * var features = turf.featureCollection([
	 *   turf.point([26, 37], {foo: 'bar'}),
	 *   turf.point([36, 53], {hello: 'world'})
	 * ]);
	 *
	 * turf.featureEach(features, function (currentFeature, featureIndex) {
	 *   //=currentFeature
	 *   //=featureIndex
	 * });
	 */
	function featureEach(geojson, callback) {
	  if (geojson.type === "Feature") {
	    callback(geojson, 0);
	  } else if (geojson.type === "FeatureCollection") {
	    for (var i = 0; i < geojson.features.length; i++) {
	      if (callback(geojson.features[i], i) === false) break;
	    }
	  }
	}
	
	/**
	 * Callback for featureReduce
	 *
	 * The first time the callback function is called, the values provided as arguments depend
	 * on whether the reduce method has an initialValue argument.
	 *
	 * If an initialValue is provided to the reduce method:
	 *  - The previousValue argument is initialValue.
	 *  - The currentValue argument is the value of the first element present in the array.
	 *
	 * If an initialValue is not provided:
	 *  - The previousValue argument is the value of the first element present in the array.
	 *  - The currentValue argument is the value of the second element present in the array.
	 *
	 * @callback featureReduceCallback
	 * @param {*} previousValue The accumulated value previously returned in the last invocation
	 * of the callback, or initialValue, if supplied.
	 * @param {Feature} currentFeature The current Feature being processed.
	 * @param {number} featureIndex The current index of the Feature being processed.
	 */
	
	/**
	 * Reduce features in any GeoJSON object, similar to Array.reduce().
	 *
	 * @name featureReduce
	 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
	 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex)
	 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
	 * @returns {*} The value that results from the reduction.
	 * @example
	 * var features = turf.featureCollection([
	 *   turf.point([26, 37], {"foo": "bar"}),
	 *   turf.point([36, 53], {"hello": "world"})
	 * ]);
	 *
	 * turf.featureReduce(features, function (previousValue, currentFeature, featureIndex) {
	 *   //=previousValue
	 *   //=currentFeature
	 *   //=featureIndex
	 *   return currentFeature
	 * });
	 */
	function featureReduce(geojson, callback, initialValue) {
	  var previousValue = initialValue;
	  featureEach(geojson, function (currentFeature, featureIndex) {
	    if (featureIndex === 0 && initialValue === undefined)
	      previousValue = currentFeature;
	    else previousValue = callback(previousValue, currentFeature, featureIndex);
	  });
	  return previousValue;
	}
	
	/**
	 * Get all coordinates from any GeoJSON object.
	 *
	 * @name coordAll
	 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
	 * @returns {Array<Array<number>>} coordinate position array
	 * @example
	 * var features = turf.featureCollection([
	 *   turf.point([26, 37], {foo: 'bar'}),
	 *   turf.point([36, 53], {hello: 'world'})
	 * ]);
	 *
	 * var coords = turf.coordAll(features);
	 * //= [[26, 37], [36, 53]]
	 */
	function coordAll(geojson) {
	  var coords = [];
	  coordEach(geojson, function (coord) {
	    coords.push(coord);
	  });
	  return coords;
	}
	
	/**
	 * Callback for geomEach
	 *
	 * @callback geomEachCallback
	 * @param {Geometry} currentGeometry The current Geometry being processed.
	 * @param {number} featureIndex The current index of the Feature being processed.
	 * @param {Object} featureProperties The current Feature Properties being processed.
	 * @param {Array<number>} featureBBox The current Feature BBox being processed.
	 * @param {number|string} featureId The current Feature Id being processed.
	 */
	
	/**
	 * Iterate over each geometry in any GeoJSON object, similar to Array.forEach()
	 *
	 * @name geomEach
	 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
	 * @param {Function} callback a method that takes (currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
	 * @returns {void}
	 * @example
	 * var features = turf.featureCollection([
	 *     turf.point([26, 37], {foo: 'bar'}),
	 *     turf.point([36, 53], {hello: 'world'})
	 * ]);
	 *
	 * turf.geomEach(features, function (currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
	 *   //=currentGeometry
	 *   //=featureIndex
	 *   //=featureProperties
	 *   //=featureBBox
	 *   //=featureId
	 * });
	 */
	function geomEach(geojson, callback) {
	  var i,
	    j,
	    g,
	    geometry,
	    stopG,
	    geometryMaybeCollection,
	    isGeometryCollection,
	    featureProperties,
	    featureBBox,
	    featureId,
	    featureIndex = 0,
	    isFeatureCollection = geojson.type === "FeatureCollection",
	    isFeature = geojson.type === "Feature",
	    stop = isFeatureCollection ? geojson.features.length : 1;
	
	  // This logic may look a little weird. The reason why it is that way
	  // is because it's trying to be fast. GeoJSON supports multiple kinds
	  // of objects at its root: FeatureCollection, Features, Geometries.
	  // This function has the responsibility of handling all of them, and that
	  // means that some of the `for` loops you see below actually just don't apply
	  // to certain inputs. For instance, if you give this just a
	  // Point geometry, then both loops are short-circuited and all we do
	  // is gradually rename the input until it's called 'geometry'.
	  //
	  // This also aims to allocate as few resources as possible: just a
	  // few numbers and booleans, rather than any temporary arrays as would
	  // be required with the normalization approach.
	  for (i = 0; i < stop; i++) {
	    geometryMaybeCollection = isFeatureCollection
	      ? geojson.features[i].geometry
	      : isFeature
	      ? geojson.geometry
	      : geojson;
	    featureProperties = isFeatureCollection
	      ? geojson.features[i].properties
	      : isFeature
	      ? geojson.properties
	      : {};
	    featureBBox = isFeatureCollection
	      ? geojson.features[i].bbox
	      : isFeature
	      ? geojson.bbox
	      : undefined;
	    featureId = isFeatureCollection
	      ? geojson.features[i].id
	      : isFeature
	      ? geojson.id
	      : undefined;
	    isGeometryCollection = geometryMaybeCollection
	      ? geometryMaybeCollection.type === "GeometryCollection"
	      : false;
	    stopG = isGeometryCollection
	      ? geometryMaybeCollection.geometries.length
	      : 1;
	
	    for (g = 0; g < stopG; g++) {
	      geometry = isGeometryCollection
	        ? geometryMaybeCollection.geometries[g]
	        : geometryMaybeCollection;
	
	      // Handle null Geometry
	      if (geometry === null) {
	        if (
	          callback(
	            null,
	            featureIndex,
	            featureProperties,
	            featureBBox,
	            featureId
	          ) === false
	        )
	          return false;
	        continue;
	      }
	      switch (geometry.type) {
	        case "Point":
	        case "LineString":
	        case "MultiPoint":
	        case "Polygon":
	        case "MultiLineString":
	        case "MultiPolygon": {
	          if (
	            callback(
	              geometry,
	              featureIndex,
	              featureProperties,
	              featureBBox,
	              featureId
	            ) === false
	          )
	            return false;
	          break;
	        }
	        case "GeometryCollection": {
	          for (j = 0; j < geometry.geometries.length; j++) {
	            if (
	              callback(
	                geometry.geometries[j],
	                featureIndex,
	                featureProperties,
	                featureBBox,
	                featureId
	              ) === false
	            )
	              return false;
	          }
	          break;
	        }
	        default:
	          throw new Error("Unknown Geometry Type");
	      }
	    }
	    // Only increase `featureIndex` per each feature
	    featureIndex++;
	  }
	}
	
	/**
	 * Callback for geomReduce
	 *
	 * The first time the callback function is called, the values provided as arguments depend
	 * on whether the reduce method has an initialValue argument.
	 *
	 * If an initialValue is provided to the reduce method:
	 *  - The previousValue argument is initialValue.
	 *  - The currentValue argument is the value of the first element present in the array.
	 *
	 * If an initialValue is not provided:
	 *  - The previousValue argument is the value of the first element present in the array.
	 *  - The currentValue argument is the value of the second element present in the array.
	 *
	 * @callback geomReduceCallback
	 * @param {*} previousValue The accumulated value previously returned in the last invocation
	 * of the callback, or initialValue, if supplied.
	 * @param {Geometry} currentGeometry The current Geometry being processed.
	 * @param {number} featureIndex The current index of the Feature being processed.
	 * @param {Object} featureProperties The current Feature Properties being processed.
	 * @param {Array<number>} featureBBox The current Feature BBox being processed.
	 * @param {number|string} featureId The current Feature Id being processed.
	 */
	
	/**
	 * Reduce geometry in any GeoJSON object, similar to Array.reduce().
	 *
	 * @name geomReduce
	 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
	 * @param {Function} callback a method that takes (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
	 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
	 * @returns {*} The value that results from the reduction.
	 * @example
	 * var features = turf.featureCollection([
	 *     turf.point([26, 37], {foo: 'bar'}),
	 *     turf.point([36, 53], {hello: 'world'})
	 * ]);
	 *
	 * turf.geomReduce(features, function (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
	 *   //=previousValue
	 *   //=currentGeometry
	 *   //=featureIndex
	 *   //=featureProperties
	 *   //=featureBBox
	 *   //=featureId
	 *   return currentGeometry
	 * });
	 */
	function geomReduce(geojson, callback, initialValue) {
	  var previousValue = initialValue;
	  geomEach(
	    geojson,
	    function (
	      currentGeometry,
	      featureIndex,
	      featureProperties,
	      featureBBox,
	      featureId
	    ) {
	      if (featureIndex === 0 && initialValue === undefined)
	        previousValue = currentGeometry;
	      else
	        previousValue = callback(
	          previousValue,
	          currentGeometry,
	          featureIndex,
	          featureProperties,
	          featureBBox,
	          featureId
	        );
	    }
	  );
	  return previousValue;
	}
	
	/**
	 * Callback for flattenEach
	 *
	 * @callback flattenEachCallback
	 * @param {Feature} currentFeature The current flattened feature being processed.
	 * @param {number} featureIndex The current index of the Feature being processed.
	 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
	 */
	
	/**
	 * Iterate over flattened features in any GeoJSON object, similar to
	 * Array.forEach.
	 *
	 * @name flattenEach
	 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
	 * @param {Function} callback a method that takes (currentFeature, featureIndex, multiFeatureIndex)
	 * @example
	 * var features = turf.featureCollection([
	 *     turf.point([26, 37], {foo: 'bar'}),
	 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
	 * ]);
	 *
	 * turf.flattenEach(features, function (currentFeature, featureIndex, multiFeatureIndex) {
	 *   //=currentFeature
	 *   //=featureIndex
	 *   //=multiFeatureIndex
	 * });
	 */
	function flattenEach(geojson, callback) {
	  geomEach(geojson, function (geometry, featureIndex, properties, bbox, id) {
	    // Callback for single geometry
	    var type = geometry === null ? null : geometry.type;
	    switch (type) {
	      case null:
	      case "Point":
	      case "LineString":
	      case "Polygon":
	        if (
	          callback(
	            helpers.feature(geometry, properties, { bbox: bbox, id: id }),
	            featureIndex,
	            0
	          ) === false
	        )
	          return false;
	        return;
	    }
	
	    var geomType;
	
	    // Callback for multi-geometry
	    switch (type) {
	      case "MultiPoint":
	        geomType = "Point";
	        break;
	      case "MultiLineString":
	        geomType = "LineString";
	        break;
	      case "MultiPolygon":
	        geomType = "Polygon";
	        break;
	    }
	
	    for (
	      var multiFeatureIndex = 0;
	      multiFeatureIndex < geometry.coordinates.length;
	      multiFeatureIndex++
	    ) {
	      var coordinate = geometry.coordinates[multiFeatureIndex];
	      var geom = {
	        type: geomType,
	        coordinates: coordinate,
	      };
	      if (
	        callback(helpers.feature(geom, properties), featureIndex, multiFeatureIndex) ===
	        false
	      )
	        return false;
	    }
	  });
	}
	
	/**
	 * Callback for flattenReduce
	 *
	 * The first time the callback function is called, the values provided as arguments depend
	 * on whether the reduce method has an initialValue argument.
	 *
	 * If an initialValue is provided to the reduce method:
	 *  - The previousValue argument is initialValue.
	 *  - The currentValue argument is the value of the first element present in the array.
	 *
	 * If an initialValue is not provided:
	 *  - The previousValue argument is the value of the first element present in the array.
	 *  - The currentValue argument is the value of the second element present in the array.
	 *
	 * @callback flattenReduceCallback
	 * @param {*} previousValue The accumulated value previously returned in the last invocation
	 * of the callback, or initialValue, if supplied.
	 * @param {Feature} currentFeature The current Feature being processed.
	 * @param {number} featureIndex The current index of the Feature being processed.
	 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
	 */
	
	/**
	 * Reduce flattened features in any GeoJSON object, similar to Array.reduce().
	 *
	 * @name flattenReduce
	 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
	 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex, multiFeatureIndex)
	 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
	 * @returns {*} The value that results from the reduction.
	 * @example
	 * var features = turf.featureCollection([
	 *     turf.point([26, 37], {foo: 'bar'}),
	 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
	 * ]);
	 *
	 * turf.flattenReduce(features, function (previousValue, currentFeature, featureIndex, multiFeatureIndex) {
	 *   //=previousValue
	 *   //=currentFeature
	 *   //=featureIndex
	 *   //=multiFeatureIndex
	 *   return currentFeature
	 * });
	 */
	function flattenReduce(geojson, callback, initialValue) {
	  var previousValue = initialValue;
	  flattenEach(
	    geojson,
	    function (currentFeature, featureIndex, multiFeatureIndex) {
	      if (
	        featureIndex === 0 &&
	        multiFeatureIndex === 0 &&
	        initialValue === undefined
	      )
	        previousValue = currentFeature;
	      else
	        previousValue = callback(
	          previousValue,
	          currentFeature,
	          featureIndex,
	          multiFeatureIndex
	        );
	    }
	  );
	  return previousValue;
	}
	
	/**
	 * Callback for segmentEach
	 *
	 * @callback segmentEachCallback
	 * @param {Feature<LineString>} currentSegment The current Segment being processed.
	 * @param {number} featureIndex The current index of the Feature being processed.
	 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
	 * @param {number} geometryIndex The current index of the Geometry being processed.
	 * @param {number} segmentIndex The current index of the Segment being processed.
	 * @returns {void}
	 */
	
	/**
	 * Iterate over 2-vertex line segment in any GeoJSON object, similar to Array.forEach()
	 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
	 *
	 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
	 * @param {Function} callback a method that takes (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex)
	 * @returns {void}
	 * @example
	 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
	 *
	 * // Iterate over GeoJSON by 2-vertex segments
	 * turf.segmentEach(polygon, function (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
	 *   //=currentSegment
	 *   //=featureIndex
	 *   //=multiFeatureIndex
	 *   //=geometryIndex
	 *   //=segmentIndex
	 * });
	 *
	 * // Calculate the total number of segments
	 * var total = 0;
	 * turf.segmentEach(polygon, function () {
	 *     total++;
	 * });
	 */
	function segmentEach(geojson, callback) {
	  flattenEach(geojson, function (feature, featureIndex, multiFeatureIndex) {
	    var segmentIndex = 0;
	
	    // Exclude null Geometries
	    if (!feature.geometry) return;
	    // (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
	    var type = feature.geometry.type;
	    if (type === "Point" || type === "MultiPoint") return;
	
	    // Generate 2-vertex line segments
	    var previousCoords;
	    var previousFeatureIndex = 0;
	    var previousMultiIndex = 0;
	    var prevGeomIndex = 0;
	    if (
	      coordEach(
	        feature,
	        function (
	          currentCoord,
	          coordIndex,
	          featureIndexCoord,
	          multiPartIndexCoord,
	          geometryIndex
	        ) {
	          // Simulating a meta.coordReduce() since `reduce` operations cannot be stopped by returning `false`
	          if (
	            previousCoords === undefined ||
	            featureIndex > previousFeatureIndex ||
	            multiPartIndexCoord > previousMultiIndex ||
	            geometryIndex > prevGeomIndex
	          ) {
	            previousCoords = currentCoord;
	            previousFeatureIndex = featureIndex;
	            previousMultiIndex = multiPartIndexCoord;
	            prevGeomIndex = geometryIndex;
	            segmentIndex = 0;
	            return;
	          }
	          var currentSegment = helpers.lineString(
	            [previousCoords, currentCoord],
	            feature.properties
	          );
	          if (
	            callback(
	              currentSegment,
	              featureIndex,
	              multiFeatureIndex,
	              geometryIndex,
	              segmentIndex
	            ) === false
	          )
	            return false;
	          segmentIndex++;
	          previousCoords = currentCoord;
	        }
	      ) === false
	    )
	      return false;
	  });
	}
	
	/**
	 * Callback for segmentReduce
	 *
	 * The first time the callback function is called, the values provided as arguments depend
	 * on whether the reduce method has an initialValue argument.
	 *
	 * If an initialValue is provided to the reduce method:
	 *  - The previousValue argument is initialValue.
	 *  - The currentValue argument is the value of the first element present in the array.
	 *
	 * If an initialValue is not provided:
	 *  - The previousValue argument is the value of the first element present in the array.
	 *  - The currentValue argument is the value of the second element present in the array.
	 *
	 * @callback segmentReduceCallback
	 * @param {*} previousValue The accumulated value previously returned in the last invocation
	 * of the callback, or initialValue, if supplied.
	 * @param {Feature<LineString>} currentSegment The current Segment being processed.
	 * @param {number} featureIndex The current index of the Feature being processed.
	 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
	 * @param {number} geometryIndex The current index of the Geometry being processed.
	 * @param {number} segmentIndex The current index of the Segment being processed.
	 */
	
	/**
	 * Reduce 2-vertex line segment in any GeoJSON object, similar to Array.reduce()
	 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
	 *
	 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
	 * @param {Function} callback a method that takes (previousValue, currentSegment, currentIndex)
	 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
	 * @returns {void}
	 * @example
	 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
	 *
	 * // Iterate over GeoJSON by 2-vertex segments
	 * turf.segmentReduce(polygon, function (previousSegment, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
	 *   //= previousSegment
	 *   //= currentSegment
	 *   //= featureIndex
	 *   //= multiFeatureIndex
	 *   //= geometryIndex
	 *   //= segmentIndex
	 *   return currentSegment
	 * });
	 *
	 * // Calculate the total number of segments
	 * var initialValue = 0
	 * var total = turf.segmentReduce(polygon, function (previousValue) {
	 *     previousValue++;
	 *     return previousValue;
	 * }, initialValue);
	 */
	function segmentReduce(geojson, callback, initialValue) {
	  var previousValue = initialValue;
	  var started = false;
	  segmentEach(
	    geojson,
	    function (
	      currentSegment,
	      featureIndex,
	      multiFeatureIndex,
	      geometryIndex,
	      segmentIndex
	    ) {
	      if (started === false && initialValue === undefined)
	        previousValue = currentSegment;
	      else
	        previousValue = callback(
	          previousValue,
	          currentSegment,
	          featureIndex,
	          multiFeatureIndex,
	          geometryIndex,
	          segmentIndex
	        );
	      started = true;
	    }
	  );
	  return previousValue;
	}
	
	/**
	 * Callback for lineEach
	 *
	 * @callback lineEachCallback
	 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed
	 * @param {number} featureIndex The current index of the Feature being processed
	 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
	 * @param {number} geometryIndex The current index of the Geometry being processed
	 */
	
	/**
	 * Iterate over line or ring coordinates in LineString, Polygon, MultiLineString, MultiPolygon Features or Geometries,
	 * similar to Array.forEach.
	 *
	 * @name lineEach
	 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
	 * @param {Function} callback a method that takes (currentLine, featureIndex, multiFeatureIndex, geometryIndex)
	 * @example
	 * var multiLine = turf.multiLineString([
	 *   [[26, 37], [35, 45]],
	 *   [[36, 53], [38, 50], [41, 55]]
	 * ]);
	 *
	 * turf.lineEach(multiLine, function (currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
	 *   //=currentLine
	 *   //=featureIndex
	 *   //=multiFeatureIndex
	 *   //=geometryIndex
	 * });
	 */
	function lineEach(geojson, callback) {
	  // validation
	  if (!geojson) throw new Error("geojson is required");
	
	  flattenEach(geojson, function (feature, featureIndex, multiFeatureIndex) {
	    if (feature.geometry === null) return;
	    var type = feature.geometry.type;
	    var coords = feature.geometry.coordinates;
	    switch (type) {
	      case "LineString":
	        if (callback(feature, featureIndex, multiFeatureIndex, 0, 0) === false)
	          return false;
	        break;
	      case "Polygon":
	        for (
	          var geometryIndex = 0;
	          geometryIndex < coords.length;
	          geometryIndex++
	        ) {
	          if (
	            callback(
	              helpers.lineString(coords[geometryIndex], feature.properties),
	              featureIndex,
	              multiFeatureIndex,
	              geometryIndex
	            ) === false
	          )
	            return false;
	        }
	        break;
	    }
	  });
	}
	
	/**
	 * Callback for lineReduce
	 *
	 * The first time the callback function is called, the values provided as arguments depend
	 * on whether the reduce method has an initialValue argument.
	 *
	 * If an initialValue is provided to the reduce method:
	 *  - The previousValue argument is initialValue.
	 *  - The currentValue argument is the value of the first element present in the array.
	 *
	 * If an initialValue is not provided:
	 *  - The previousValue argument is the value of the first element present in the array.
	 *  - The currentValue argument is the value of the second element present in the array.
	 *
	 * @callback lineReduceCallback
	 * @param {*} previousValue The accumulated value previously returned in the last invocation
	 * of the callback, or initialValue, if supplied.
	 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed.
	 * @param {number} featureIndex The current index of the Feature being processed
	 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
	 * @param {number} geometryIndex The current index of the Geometry being processed
	 */
	
	/**
	 * Reduce features in any GeoJSON object, similar to Array.reduce().
	 *
	 * @name lineReduce
	 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
	 * @param {Function} callback a method that takes (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex)
	 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
	 * @returns {*} The value that results from the reduction.
	 * @example
	 * var multiPoly = turf.multiPolygon([
	 *   turf.polygon([[[12,48],[2,41],[24,38],[12,48]], [[9,44],[13,41],[13,45],[9,44]]]),
	 *   turf.polygon([[[5, 5], [0, 0], [2, 2], [4, 4], [5, 5]]])
	 * ]);
	 *
	 * turf.lineReduce(multiPoly, function (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
	 *   //=previousValue
	 *   //=currentLine
	 *   //=featureIndex
	 *   //=multiFeatureIndex
	 *   //=geometryIndex
	 *   return currentLine
	 * });
	 */
	function lineReduce(geojson, callback, initialValue) {
	  var previousValue = initialValue;
	  lineEach(
	    geojson,
	    function (currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
	      if (featureIndex === 0 && initialValue === undefined)
	        previousValue = currentLine;
	      else
	        previousValue = callback(
	          previousValue,
	          currentLine,
	          featureIndex,
	          multiFeatureIndex,
	          geometryIndex
	        );
	    }
	  );
	  return previousValue;
	}
	
	/**
	 * Finds a particular 2-vertex LineString Segment from a GeoJSON using `@turf/meta` indexes.
	 *
	 * Negative indexes are permitted.
	 * Point & MultiPoint will always return null.
	 *
	 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
	 * @param {Object} [options={}] Optional parameters
	 * @param {number} [options.featureIndex=0] Feature Index
	 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
	 * @param {number} [options.geometryIndex=0] Geometry Index
	 * @param {number} [options.segmentIndex=0] Segment Index
	 * @param {Object} [options.properties={}] Translate Properties to output LineString
	 * @param {BBox} [options.bbox={}] Translate BBox to output LineString
	 * @param {number|string} [options.id={}] Translate Id to output LineString
	 * @returns {Feature<LineString>} 2-vertex GeoJSON Feature LineString
	 * @example
	 * var multiLine = turf.multiLineString([
	 *     [[10, 10], [50, 30], [30, 40]],
	 *     [[-10, -10], [-50, -30], [-30, -40]]
	 * ]);
	 *
	 * // First Segment (defaults are 0)
	 * turf.findSegment(multiLine);
	 * // => Feature<LineString<[[10, 10], [50, 30]]>>
	 *
	 * // First Segment of 2nd Multi Feature
	 * turf.findSegment(multiLine, {multiFeatureIndex: 1});
	 * // => Feature<LineString<[[-10, -10], [-50, -30]]>>
	 *
	 * // Last Segment of Last Multi Feature
	 * turf.findSegment(multiLine, {multiFeatureIndex: -1, segmentIndex: -1});
	 * // => Feature<LineString<[[-50, -30], [-30, -40]]>>
	 */
	function findSegment(geojson, options) {
	  // Optional Parameters
	  options = options || {};
	  if (!helpers.isObject(options)) throw new Error("options is invalid");
	  var featureIndex = options.featureIndex || 0;
	  var multiFeatureIndex = options.multiFeatureIndex || 0;
	  var geometryIndex = options.geometryIndex || 0;
	  var segmentIndex = options.segmentIndex || 0;
	
	  // Find FeatureIndex
	  var properties = options.properties;
	  var geometry;
	
	  switch (geojson.type) {
	    case "FeatureCollection":
	      if (featureIndex < 0)
	        featureIndex = geojson.features.length + featureIndex;
	      properties = properties || geojson.features[featureIndex].properties;
	      geometry = geojson.features[featureIndex].geometry;
	      break;
	    case "Feature":
	      properties = properties || geojson.properties;
	      geometry = geojson.geometry;
	      break;
	    case "Point":
	    case "MultiPoint":
	      return null;
	    case "LineString":
	    case "Polygon":
	    case "MultiLineString":
	    case "MultiPolygon":
	      geometry = geojson;
	      break;
	    default:
	      throw new Error("geojson is invalid");
	  }
	
	  // Find SegmentIndex
	  if (geometry === null) return null;
	  var coords = geometry.coordinates;
	  switch (geometry.type) {
	    case "Point":
	    case "MultiPoint":
	      return null;
	    case "LineString":
	      if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
	      return helpers.lineString(
	        [coords[segmentIndex], coords[segmentIndex + 1]],
	        properties,
	        options
	      );
	    case "Polygon":
	      if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
	      if (segmentIndex < 0)
	        segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
	      return helpers.lineString(
	        [
	          coords[geometryIndex][segmentIndex],
	          coords[geometryIndex][segmentIndex + 1],
	        ],
	        properties,
	        options
	      );
	    case "MultiLineString":
	      if (multiFeatureIndex < 0)
	        multiFeatureIndex = coords.length + multiFeatureIndex;
	      if (segmentIndex < 0)
	        segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
	      return helpers.lineString(
	        [
	          coords[multiFeatureIndex][segmentIndex],
	          coords[multiFeatureIndex][segmentIndex + 1],
	        ],
	        properties,
	        options
	      );
	    case "MultiPolygon":
	      if (multiFeatureIndex < 0)
	        multiFeatureIndex = coords.length + multiFeatureIndex;
	      if (geometryIndex < 0)
	        geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
	      if (segmentIndex < 0)
	        segmentIndex =
	          coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
	      return helpers.lineString(
	        [
	          coords[multiFeatureIndex][geometryIndex][segmentIndex],
	          coords[multiFeatureIndex][geometryIndex][segmentIndex + 1],
	        ],
	        properties,
	        options
	      );
	  }
	  throw new Error("geojson is invalid");
	}
	
	/**
	 * Finds a particular Point from a GeoJSON using `@turf/meta` indexes.
	 *
	 * Negative indexes are permitted.
	 *
	 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
	 * @param {Object} [options={}] Optional parameters
	 * @param {number} [options.featureIndex=0] Feature Index
	 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
	 * @param {number} [options.geometryIndex=0] Geometry Index
	 * @param {number} [options.coordIndex=0] Coord Index
	 * @param {Object} [options.properties={}] Translate Properties to output Point
	 * @param {BBox} [options.bbox={}] Translate BBox to output Point
	 * @param {number|string} [options.id={}] Translate Id to output Point
	 * @returns {Feature<Point>} 2-vertex GeoJSON Feature Point
	 * @example
	 * var multiLine = turf.multiLineString([
	 *     [[10, 10], [50, 30], [30, 40]],
	 *     [[-10, -10], [-50, -30], [-30, -40]]
	 * ]);
	 *
	 * // First Segment (defaults are 0)
	 * turf.findPoint(multiLine);
	 * // => Feature<Point<[10, 10]>>
	 *
	 * // First Segment of the 2nd Multi-Feature
	 * turf.findPoint(multiLine, {multiFeatureIndex: 1});
	 * // => Feature<Point<[-10, -10]>>
	 *
	 * // Last Segment of last Multi-Feature
	 * turf.findPoint(multiLine, {multiFeatureIndex: -1, coordIndex: -1});
	 * // => Feature<Point<[-30, -40]>>
	 */
	function findPoint(geojson, options) {
	  // Optional Parameters
	  options = options || {};
	  if (!helpers.isObject(options)) throw new Error("options is invalid");
	  var featureIndex = options.featureIndex || 0;
	  var multiFeatureIndex = options.multiFeatureIndex || 0;
	  var geometryIndex = options.geometryIndex || 0;
	  var coordIndex = options.coordIndex || 0;
	
	  // Find FeatureIndex
	  var properties = options.properties;
	  var geometry;
	
	  switch (geojson.type) {
	    case "FeatureCollection":
	      if (featureIndex < 0)
	        featureIndex = geojson.features.length + featureIndex;
	      properties = properties || geojson.features[featureIndex].properties;
	      geometry = geojson.features[featureIndex].geometry;
	      break;
	    case "Feature":
	      properties = properties || geojson.properties;
	      geometry = geojson.geometry;
	      break;
	    case "Point":
	    case "MultiPoint":
	      return null;
	    case "LineString":
	    case "Polygon":
	    case "MultiLineString":
	    case "MultiPolygon":
	      geometry = geojson;
	      break;
	    default:
	      throw new Error("geojson is invalid");
	  }
	
	  // Find Coord Index
	  if (geometry === null) return null;
	  var coords = geometry.coordinates;
	  switch (geometry.type) {
	    case "Point":
	      return helpers.point(coords, properties, options);
	    case "MultiPoint":
	      if (multiFeatureIndex < 0)
	        multiFeatureIndex = coords.length + multiFeatureIndex;
	      return helpers.point(coords[multiFeatureIndex], properties, options);
	    case "LineString":
	      if (coordIndex < 0) coordIndex = coords.length + coordIndex;
	      return helpers.point(coords[coordIndex], properties, options);
	    case "Polygon":
	      if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
	      if (coordIndex < 0)
	        coordIndex = coords[geometryIndex].length + coordIndex;
	      return helpers.point(coords[geometryIndex][coordIndex], properties, options);
	    case "MultiLineString":
	      if (multiFeatureIndex < 0)
	        multiFeatureIndex = coords.length + multiFeatureIndex;
	      if (coordIndex < 0)
	        coordIndex = coords[multiFeatureIndex].length + coordIndex;
	      return helpers.point(coords[multiFeatureIndex][coordIndex], properties, options);
	    case "MultiPolygon":
	      if (multiFeatureIndex < 0)
	        multiFeatureIndex = coords.length + multiFeatureIndex;
	      if (geometryIndex < 0)
	        geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
	      if (coordIndex < 0)
	        coordIndex =
	          coords[multiFeatureIndex][geometryIndex].length - coordIndex;
	      return helpers.point(
	        coords[multiFeatureIndex][geometryIndex][coordIndex],
	        properties,
	        options
	      );
	  }
	  throw new Error("geojson is invalid");
	}
	
	exports.coordAll = coordAll;
	exports.coordEach = coordEach;
	exports.coordReduce = coordReduce;
	exports.featureEach = featureEach;
	exports.featureReduce = featureReduce;
	exports.findPoint = findPoint;
	exports.findSegment = findSegment;
	exports.flattenEach = flattenEach;
	exports.flattenReduce = flattenReduce;
	exports.geomEach = geomEach;
	exports.geomReduce = geomReduce;
	exports.lineEach = lineEach;
	exports.lineReduce = lineReduce;
	exports.propEach = propEach;
	exports.propReduce = propReduce;
	exports.segmentEach = segmentEach;
	exports.segmentReduce = segmentReduce;


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// https://en.wikipedia.org/wiki/Rhumb_line
	var helpers_1 = __webpack_require__(96);
	var invariant_1 = __webpack_require__(165);
	/**
	 * Calculates the distance along a rhumb line between two {@link Point|points} in degrees, radians,
	 * miles, or kilometers.
	 *
	 * @name rhumbDistance
	 * @param {Coord} from origin point
	 * @param {Coord} to destination point
	 * @param {Object} [options] Optional parameters
	 * @param {string} [options.units="kilometers"] can be degrees, radians, miles, or kilometers
	 * @returns {number} distance between the two points
	 * @example
	 * var from = turf.point([-75.343, 39.984]);
	 * var to = turf.point([-75.534, 39.123]);
	 * var options = {units: 'miles'};
	 *
	 * var distance = turf.rhumbDistance(from, to, options);
	 *
	 * //addToMap
	 * var addToMap = [from, to];
	 * from.properties.distance = distance;
	 * to.properties.distance = distance;
	 */
	function rhumbDistance(from, to, options) {
	    if (options === void 0) { options = {}; }
	    var origin = invariant_1.getCoord(from);
	    var destination = invariant_1.getCoord(to);
	    // compensate the crossing of the 180th meridian (https://macwright.org/2016/09/26/the-180th-meridian.html)
	    // solution from https://github.com/mapbox/mapbox-gl-js/issues/3250#issuecomment-294887678
	    destination[0] +=
	        destination[0] - origin[0] > 180
	            ? -360
	            : origin[0] - destination[0] > 180
	                ? 360
	                : 0;
	    var distanceInMeters = calculateRhumbDistance(origin, destination);
	    var distance = helpers_1.convertLength(distanceInMeters, "meters", options.units);
	    return distance;
	}
	/**
	 * Returns the distance travelling from ‘this’ point to destination point along a rhumb line.
	 * Adapted from Geodesy: https://github.com/chrisveness/geodesy/blob/master/latlon-spherical.js
	 *
	 * @private
	 * @param   {Array<number>} origin point.
	 * @param   {Array<number>} destination point.
	 * @param   {number} [radius=6371e3] - (Mean) radius of earth (defaults to radius in metres).
	 * @returns {number} Distance in km between this point and destination point (same units as radius).
	 *
	 * @example
	 *     var p1 = new LatLon(51.127, 1.338);
	 *     var p2 = new LatLon(50.964, 1.853);
	 *     var d = p1.distanceTo(p2); // 40.31 km
	 */
	function calculateRhumbDistance(origin, destination, radius) {
	    // φ => phi
	    // λ => lambda
	    // ψ => psi
	    // Δ => Delta
	    // δ => delta
	    // θ => theta
	    radius = radius === undefined ? helpers_1.earthRadius : Number(radius);
	    // see www.edwilliams.org/avform.htm#Rhumb
	    var R = radius;
	    var phi1 = (origin[1] * Math.PI) / 180;
	    var phi2 = (destination[1] * Math.PI) / 180;
	    var DeltaPhi = phi2 - phi1;
	    var DeltaLambda = (Math.abs(destination[0] - origin[0]) * Math.PI) / 180;
	    // if dLon over 180° take shorter rhumb line across the anti-meridian:
	    if (DeltaLambda > Math.PI) {
	        DeltaLambda -= 2 * Math.PI;
	    }
	    // on Mercator projection, longitude distances shrink by latitude; q is the 'stretch factor'
	    // q becomes ill-conditioned along E-W line (0/0); use empirical tolerance to avoid it
	    var DeltaPsi = Math.log(Math.tan(phi2 / 2 + Math.PI / 4) / Math.tan(phi1 / 2 + Math.PI / 4));
	    var q = Math.abs(DeltaPsi) > 10e-12 ? DeltaPhi / DeltaPsi : Math.cos(phi1);
	    // distance is pythagoras on 'stretched' Mercator projection
	    var delta = Math.sqrt(DeltaPhi * DeltaPhi + q * q * DeltaLambda * DeltaLambda); // angular distance in radians
	    var dist = delta * R;
	    return dist;
	}
	exports.default = rhumbDistance;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = affineHull
	
	var orient = __webpack_require__(221)
	
	function linearlyIndependent(points, d) {
	  var nhull = new Array(d+1)
	  for(var i=0; i<points.length; ++i) {
	    nhull[i] = points[i]
	  }
	  for(var i=0; i<=points.length; ++i) {
	    for(var j=points.length; j<=d; ++j) {
	      var x = new Array(d)
	      for(var k=0; k<d; ++k) {
	        x[k] = Math.pow(j+1-i, k)
	      }
	      nhull[j] = x
	    }
	    var o = orient.apply(void 0, nhull)
	    if(o) {
	      return true
	    }
	  }
	  return false
	}
	
	function affineHull(points) {
	  var n = points.length
	  if(n === 0) {
	    return []
	  }
	  if(n === 1) {
	    return [0]
	  }
	  var d = points[0].length
	  var frame = [ points[0] ]
	  var index = [ 0 ]
	  for(var i=1; i<n; ++i) {
	    frame.push(points[i])
	    if(!linearlyIndependent(frame, d)) {
	      frame.pop()
	      continue
	    }
	    index.push(i)
	    if(index.length === d+1) {
	      return index
	    }
	  }
	  return index
	}

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	var bind = __webpack_require__(233);
	var Axios = __webpack_require__(541);
	var defaults = __webpack_require__(167);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(230);
	axios.CancelToken = __webpack_require__(540);
	axios.isCancel = __webpack_require__(231);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(555);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(230);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(167);
	var utils = __webpack_require__(40);
	var InterceptorManager = __webpack_require__(542);
	var dispatchRequest = __webpack_require__(543);
	var isAbsoluteURL = __webpack_require__(551);
	var combineURLs = __webpack_require__(549);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	var transformData = __webpack_require__(546);
	var isCancel = __webpack_require__(231);
	var defaults = __webpack_require__(167);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),
/* 544 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.response = response;
	  return error;
	};


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(232);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response
	    ));
	  }
	};


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 547 */
/***/ (function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),
/* 549 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
	};


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),
/* 551 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(40);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 555 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _toConsumableArray2 = __webpack_require__(99);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _slicedToArray2 = __webpack_require__(177);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getIterator2 = __webpack_require__(69);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(70);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _set = __webpack_require__(245);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function (global, factory) {
	  ( false ? 'undefined' : (0, _typeof3.default)(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory(__webpack_require__(3)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : global.VMdDateRangePicker = factory(global.moment);
	})(undefined, function (moment) {
	  'use strict';
	
	  moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;
	
	  function clean(momentDate) {
	    return momentDate.clone().hour(0).minute(0).second(0).millisecond(0);
	  }
	
	  function range() {
	    var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var end = arguments[1];
	    var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	    var arr = [];
	    start = +start;
	    end = +end;
	
	    for (var i = start; i <= end; i += step) {
	      arr.push(i);
	    }
	
	    return arr;
	  }
	
	  var script = {
	    name: 'calendar',
	    inject: ['picker'],
	    props: ['location', 'calendarMonth', 'locale', 'start', 'end'],
	    methods: {
	      dayClass: function dayClass(date) {
	        var dt = date.clone();
	        var cleanDt = clean(dt.clone());
	        var cleanToday = clean(moment());
	        var cleanStart = clean(this.start);
	        var cleanEnd = clean(this.end);
	        var hoverStart = clean(this.picker.hoverStart_);
	        var hoverEnd = clean(this.picker.hoverEnd_);
	        return {
	          off: dt.month() !== this.month,
	
	          weekend: dt.isoWeekday() > 5,
	          today: cleanDt.isSame(cleanToday),
	
	          active: cleanDt.isSame(cleanStart) || cleanDt.isSame(cleanEnd),
	
	          'in-range': dt >= cleanStart && dt <= cleanEnd || dt >= hoverStart && dt <= hoverEnd,
	          'start-date': cleanDt.isSame(cleanStart),
	          'end-date': cleanDt.isSame(cleanEnd)
	        };
	      }
	    },
	    computed: {
	      arrowLeftClass: function arrowLeftClass() {
	        return 'arrow-left v-drp__css-icon';
	      },
	      arrowRightClass: function arrowRightClass() {
	        return 'arrow-right v-drp__css-icon';
	      },
	      month: function month() {
	        return this.calendarMonth.month();
	      },
	      monthName: function monthName() {
	        return this.locale.monthNames[this.month];
	      },
	      year: function year() {
	        return this.calendarMonth.year();
	      },
	      calendar: function calendar() {
	        var calendarMonth = this.calendarMonth;
	        var month = calendarMonth.month();
	        var year = calendarMonth.year();
	        var hour = calendarMonth.hour();
	        var minute = calendarMonth.minute();
	        var second = calendarMonth.second();
	        var daysInMonth = moment([year, month]).daysInMonth();
	        var firstDay = moment([year, month, 1]);
	        var lastDay = moment([year, month, daysInMonth]);
	        var lastMonth = moment(firstDay).subtract(1, 'month').month();
	        var lastYear = moment(firstDay).subtract(1, 'month').year();
	        var daysInLastMonth = moment([lastYear, lastMonth]).daysInMonth();
	        var dayOfWeek = firstDay.day();
	
	        var calendar = [];
	        calendar.firstDay = firstDay;
	        calendar.lastDay = lastDay;
	
	        for (var i = 0; i < 6; i++) {
	          calendar[i] = [];
	        }
	
	        var startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
	
	        if (startDay > daysInLastMonth) {
	          startDay -= 7;
	        }
	
	        if (dayOfWeek === this.locale.firstDay) {
	          startDay = daysInLastMonth - 6;
	        }
	
	        var curDate = moment([lastYear, lastMonth, startDay, 12, minute, second]);
	
	        for (var _i = 0, col = 0, row = 0; _i < 42; _i++, col++, curDate = moment(curDate).add(24, 'hour')) {
	          if (_i > 0 && col % 7 === 0) {
	            col = 0;
	            row++;
	          }
	
	          calendar[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
	          curDate.hour(12);
	        }
	
	        return calendar;
	      },
	      RangeOfYear: function RangeOfYear() {
	        if (!this.picker.showYearSelect) return [];
	
	        var picker = this.picker;
	        var maxYear = picker.maxDate && picker.maxDate.year() || picker.maxYear;
	        var minYear = picker.minDate && picker.minDate.year() || picker.minYear;
	        return range(minYear, maxYear, 1);
	      },
	
	
	      activeYear: {
	        get: function get() {
	          return this.calendarMonth.year();
	        },
	        set: function set(newYear) {
	          var calendarMonth = moment([newYear, this.month]);
	          this.$emit('clickYearSelect', {
	            location: this.location,
	            calendarMonth: calendarMonth
	          });
	        }
	      }
	    },
	    filters: {
	      dateNum: function dateNum(value) {
	        return value.date();
	      }
	    }
	  };
	
	  function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
	    if (typeof shadowMode !== 'boolean') {
	      createInjectorSSR = createInjector;
	      createInjector = shadowMode;
	      shadowMode = false;
	    }
	
	    var options = typeof script === 'function' ? script.options : script;
	
	    if (template && template.render) {
	      options.render = template.render;
	      options.staticRenderFns = template.staticRenderFns;
	      options._compiled = true;
	
	      if (isFunctionalTemplate) {
	        options.functional = true;
	      }
	    }
	
	    if (scopeId) {
	      options._scopeId = scopeId;
	    }
	
	    var hook;
	
	    if (moduleIdentifier) {
	      hook = function hook(context) {
	        context = context || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
	
	        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	          context = __VUE_SSR_CONTEXT__;
	        }
	
	        if (style) {
	          style.call(this, createInjectorSSR(context));
	        }
	
	        if (context && context._registeredComponents) {
	          context._registeredComponents.add(moduleIdentifier);
	        }
	      };
	
	      options._ssrRegister = hook;
	    } else if (style) {
	      hook = shadowMode ? function () {
	        style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
	      } : function (context) {
	        style.call(this, createInjector(context));
	      };
	    }
	
	    if (hook) {
	      if (options.functional) {
	        var originalRender = options.render;
	
	        options.render = function renderWithStyleInjection(h, context) {
	          hook.call(context);
	          return originalRender(h, context);
	        };
	      } else {
	        var existing = options.beforeCreate;
	        options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
	      }
	    }
	
	    return script;
	  }
	
	  var normalizeComponent_1 = normalizeComponent;
	
	  var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
	  function createInjector(context) {
	    return function (id, style) {
	      return addStyle(id, style);
	    };
	  }
	  var HEAD = document.head || document.getElementsByTagName('head')[0];
	  var styles = {};
	
	  function addStyle(id, css) {
	    var group = isOldIE ? css.media || 'default' : id;
	    var style = styles[group] || (styles[group] = {
	      ids: new _set2.default(),
	      styles: []
	    });
	
	    if (!style.ids.has(id)) {
	      style.ids.add(id);
	      var code = css.source;
	
	      if (css.map) {
	        code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
	
	        code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent((0, _stringify2.default)(css.map)))) + ' */';
	      }
	
	      if (!style.element) {
	        style.element = document.createElement('style');
	        style.element.type = 'text/css';
	        if (css.media) style.element.setAttribute('media', css.media);
	        HEAD.appendChild(style.element);
	      }
	
	      if ('styleSheet' in style.element) {
	        style.styles.push(code);
	        style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
	      } else {
	        var index = style.ids.size - 1;
	        var textNode = document.createTextNode(code);
	        var nodes = style.element.childNodes;
	        if (nodes[index]) style.element.removeChild(nodes[index]);
	        if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
	      }
	    }
	  }
	
	  var browser = createInjector;
	
	  var __vue_script__ = script;
	
	  var __vue_render__ = function __vue_render__() {
	    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('table', { staticClass: "calendar-table" }, [_c('thead', [_c('tr', [_c('th', { staticClass: "prev available v-drp__css-icon-wrapper", on: { "click": function click($event) {
	          return _vm.$emit('clickPrevMonth');
	        } } }, [_c('i', { class: [_vm.arrowLeftClass] })]), _vm._v(" "), _c('th', { staticClass: "month", attrs: { "colspan": "5" } }, [_vm._v("\n        " + _vm._s(_vm.monthName) + "\n        "), _vm._v(" "), _vm.picker.showYearSelect ? _c('select', { directives: [{ name: "model", rawName: "v-model", value: _vm.activeYear, expression: "activeYear" }], staticClass: "yearselect", on: { "change": function change($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
	            return o.selected;
	          }).map(function (o) {
	            var val = "_value" in o ? o._value : o.value;return val;
	          });_vm.activeYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
	        } } }, _vm._l(_vm.RangeOfYear, function (year, index) {
	      return _c('option', { key: index, domProps: { "value": year } }, [_vm._v(_vm._s(year))]);
	    }), 0) : _c('span', [_vm._v(_vm._s(_vm.activeYear))])]), _vm._v(" "), _c('th', { staticClass: "next available v-drp__css-icon-wrapper", on: { "click": function click($event) {
	          return _vm.$emit('clickNextMonth');
	        } } }, [_c('i', { class: [_vm.arrowRightClass] })])])]), _vm._v(" "), _c('tbody', [_c('tr', _vm._l(_vm.locale.daysOfWeek, function (weekDay, dayIndex) {
	      return _c('th', { key: dayIndex }, [_vm._v("\n        " + _vm._s(weekDay) + "\n      ")]);
	    }), 0), _vm._v(" "), _vm._l(_vm.calendar, function (dateRow, rowIndex) {
	      return _c('tr', { key: rowIndex }, [_vm._l(dateRow, function (date, dateIndex) {
	        return _vm._t("date-slot", [_c('td', { key: dateIndex, staticClass: "calendar-cell", class: _vm.dayClass(date), on: { "click": function click($event) {
	              return _vm.$emit('dateClick', date);
	            }, "mouseover": function mouseover($event) {
	              return _vm.$emit('hoverDate', date);
	            } } }, [_c('div', { staticClass: "calendar-cell__content" }, [_vm._v("\n            " + _vm._s(_vm._f("dateNum")(date)) + "\n          ")])])]);
	      })], 2);
	    })], 2)]);
	  };
	  var __vue_staticRenderFns__ = [];
	
	  var __vue_inject_styles__ = function __vue_inject_styles__(inject) {
	    if (!inject) return;
	    inject("data-v-89ba891e_0", { source: "table.calendar-table[data-v-89ba891e]{width:100%;margin:0;border-spacing:0;border-collapse:collapse}table.calendar-table td[data-v-89ba891e],table.calendar-table th[data-v-89ba891e],table.calendar-table tr[data-v-89ba891e]{border:none}table.calendar-table td[data-v-89ba891e],table.calendar-table th[data-v-89ba891e]{white-space:nowrap;text-align:center;vertical-align:middle;min-width:34px;width:34px;padding:17px 0;height:0;line-height:0;font-size:12px;white-space:nowrap;cursor:pointer}table.calendar-table td.calendar-cell[data-v-89ba891e]{position:relative}table.calendar-table td.calendar-cell[data-v-89ba891e]:hover{background-color:#eee;border-color:transparent;color:inherit}table.calendar-table td.calendar-cell.today[data-v-89ba891e]{font-weight:700}table.calendar-table td.calendar-cell.in-range[data-v-89ba891e]{background-color:#eef4ff;border-color:transparent;color:#000;border-radius:0}table.calendar-table td.calendar-cell.active[data-v-89ba891e],table.calendar-table td.calendar-cell.active[data-v-89ba891e]:hover{border-color:transparent;color:#fff}table.calendar-table td.calendar-cell.active.start-date[data-v-89ba891e],table.calendar-table td.calendar-cell.active:hover.start-date[data-v-89ba891e]{border-top-left-radius:34px;border-bottom-left-radius:34px}table.calendar-table td.calendar-cell.active.end-date[data-v-89ba891e],table.calendar-table td.calendar-cell.active:hover.end-date[data-v-89ba891e]{border-top-right-radius:34px;border-bottom-right-radius:34px}table.calendar-table td.calendar-cell.active .calendar-cell__content[data-v-89ba891e],table.calendar-table td.calendar-cell.active:hover .calendar-cell__content[data-v-89ba891e]{position:absolute;top:5%;left:5%;display:flex;align-items:center;justify-content:center;box-sizing:border-box;width:90%;height:90%;line-height:1;border-radius:999px;background-color:#4285f4}table.calendar-table td.calendar-cell.off[data-v-89ba891e],table.calendar-table td.calendar-cell.off.end-date[data-v-89ba891e],table.calendar-table td.calendar-cell.off.in-range[data-v-89ba891e],table.calendar-table td.calendar-cell.off.start-date[data-v-89ba891e]{background-color:#fff;border-color:transparent;color:#999}table.calendar-table td.calendar-cell.off .calendar-cell__content[data-v-89ba891e],table.calendar-table td.calendar-cell.off.end-date .calendar-cell__content[data-v-89ba891e],table.calendar-table td.calendar-cell.off.in-range .calendar-cell__content[data-v-89ba891e],table.calendar-table td.calendar-cell.off.start-date .calendar-cell__content[data-v-89ba891e]{background-color:#fff}.v-drp__css-icon-wrapper[data-v-89ba891e]{position:relative}.v-drp__css-icon-wrapper .v-drp__css-icon.arrow-left[data-v-89ba891e]:before{content:'';position:absolute;left:50%;top:8px;width:7px;height:7px;border-top:solid 2px currentColor;border-right:solid 2px currentColor;transform:rotate(-135deg)}.v-drp__css-icon-wrapper .v-drp__css-icon.arrow-right[data-v-89ba891e]:before{content:'';position:absolute;right:50%;top:8px;width:7px;height:7px;border-top:solid 2px currentColor;border-right:solid 2px currentColor;transform:rotate(45deg)}", map: undefined, media: undefined });
	  };
	
	  var __vue_scope_id__ = "data-v-89ba891e";
	
	  var __vue_module_identifier__ = undefined;
	
	  var __vue_is_functional_template__ = false;
	
	
	  var Calendar = normalizeComponent_1({ render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ }, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, browser, undefined);
	
	  var script$1 = {
	    props: ['canSelect', 'presets'],
	    inject: ['picker'],
	    computed: {
	      chosenLabel: function chosenLabel() {
	        var chosenLabel = '';
	        var customRange = true;
	        var picker = this.picker;
	        var ftm = 'YYYY-MM-DD';
	
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(this.presets), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var preset = _step.value;
	
	            var _preset$range = (0, _slicedToArray3.default)(preset.range, 2),
	                start = _preset$range[0],
	                end = _preset$range[1];
	
	            if (picker.start_.format(ftm) === start.format(ftm) && picker.end_.format(ftm) === end.format(ftm)) {
	              customRange = false;
	              chosenLabel = preset.label;
	              break;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        if (customRange) {
	          if (this.picker.showCustomRangeLabel) {
	            chosenLabel = this.picker.locale.customRangeLabel;
	          } else {
	            chosenLabel = null;
	          }
	        }
	
	        return chosenLabel;
	      },
	      presets_: function presets_() {
	        if (this.picker.showCustomRangeLabel) {
	          return [].concat((0, _toConsumableArray3.default)(this.presets), [{
	            label: this.picker.locale.customRangeLabel,
	            range: ''
	          }]);
	        }
	
	        return this.presets;
	      }
	    }
	  };
	
	  var __vue_script__$1 = script$1;
	
	  var __vue_render__$1 = function __vue_render__$1() {
	    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "ranges" }, [_c('ul', _vm._l(_vm.presets_, function (item, index) {
	      return _c('li', { key: index, class: { 'active': item.label === _vm.chosenLabel }, on: { "click": function click($event) {
	            return _vm.$emit('clickPreset', item);
	          } } }, [_vm._v("\n      " + _vm._s(item.label) + "\n    ")]);
	    }), 0), _vm._v(" "), !_vm.picker.autoApply ? _c('div', { staticClass: "action-buttons" }, [_c('button', { staticClass: "btn btn-sm btn-success", attrs: { "disabled": _vm.canSelect, "type": "button" }, on: { "click": function click($event) {
	          return _vm.$emit('clickApply');
	        } } }, [_vm._v("\n      Apply\n    ")]), _vm._v(" "), _c('button', { staticClass: "btn btn-sm btn-default", attrs: { "type": "button" }, on: { "click": function click($event) {
	          return _vm.$emit('clickCancel');
	        } } }, [_vm._v("\n      Cancel\n    ")])]) : _vm._e()]);
	  };
	  var __vue_staticRenderFns__$1 = [];
	
	  var __vue_inject_styles__$1 = function __vue_inject_styles__$1(inject) {
	    if (!inject) return;
	    inject("data-v-4e185066_0", { source: ".action-buttons[data-v-4e185066]{clear:both;padding:8px;line-height:12px;vertical-align:middle}.ranges[data-v-4e185066]{font-size:12px;float:none;margin-top:8px;text-align:left}.ranges ul[data-v-4e185066]{list-style:none;margin:0 auto;padding:0;width:100%}.ranges li[data-v-4e185066]{box-sizing:border-box;font-size:12px;padding:8px 12px;cursor:pointer}.ranges li[data-v-4e185066]:hover{background-color:#eee}.ranges li.active[data-v-4e185066]{color:#4285f4}@media (min-width:564px){.ranges ul[data-v-4e185066]{width:140px}}", map: undefined, media: undefined });
	  };
	
	  var __vue_scope_id__$1 = "data-v-4e185066";
	
	  var __vue_module_identifier__$1 = undefined;
	
	  var __vue_is_functional_template__$1 = false;
	
	
	  var CalendarRanges = normalizeComponent_1({ render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 }, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, browser, undefined);
	
	  var script$2 = {
	    inheritAttrs: false,
	    inject: ['picker'],
	    props: ['value'],
	    computed: {
	      inputClass: function inputClass() {
	        return {
	          'text-field__filled': this.value.trim().length > 0
	        };
	      }
	    }
	  };
	
	  var __vue_script__$2 = script$2;
	
	  var __vue_render__$2 = function __vue_render__$2() {
	    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "activator-wrapper" }, [_c('input', _vm._b({ staticClass: "text-field", class: _vm.inputClass, attrs: { "type": "text" }, domProps: { "value": _vm.value } }, 'input', _vm.$attrs, false)), _vm._v(" "), _vm.picker.showActivatorBar ? _c('span', { staticClass: "bar" }) : _vm._e(), _vm._v(" "), _vm.picker.showActivatorLabel ? _c('label', [_vm._v("Select Date")]) : _vm._e()]);
	  };
	  var __vue_staticRenderFns__$2 = [];
	
	  var __vue_inject_styles__$2 = function __vue_inject_styles__$2(inject) {
	    if (!inject) return;
	    inject("data-v-69b5ef5b_0", { source: ".mdrp__activator{width:100%;display:inline-block}.mdrp__activator .activator-wrapper{position:relative}.mdrp__activator .activator-wrapper .text-field{display:block;font-size:18px;padding:4px 10px 10px 5px;width:300px;border:none;border-bottom:1px solid #757575}.mdrp__activator .activator-wrapper .text-field:focus{outline:0}.mdrp__activator .activator-wrapper label{color:#999;font-size:14px;font-weight:400;position:absolute;pointer-events:none;left:5px;top:10px;transition:.2s ease all}.mdrp__activator .activator-wrapper .text-field:focus~label,.mdrp__activator .activator-wrapper .text-field__filled~label{top:-20px;font-size:14px;color:#4285f4}.mdrp__activator .activator-wrapper .bar{position:relative;display:block;width:315px}.mdrp__activator .activator-wrapper .bar:after,.mdrp__activator .activator-wrapper .bar:before{content:'';height:2px;width:0;bottom:1px;position:absolute;background:#4285f4;transition:.2s ease all}.mdrp__activator .activator-wrapper .bar:before{left:50%}.mdrp__activator .activator-wrapper .bar:after{right:50%}.mdrp__activator .activator-wrapper .text-field:focus~.bar:after,.mdrp__activator .activator-wrapper .text-field:focus~.bar:before{width:50%}", map: undefined, media: undefined });
	  };
	
	  var __vue_scope_id__$2 = undefined;
	
	  var __vue_module_identifier__$2 = undefined;
	
	  var __vue_is_functional_template__$2 = false;
	
	
	  var DefaultActivator = normalizeComponent_1({ render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 }, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, browser, undefined);
	
	  var clickoutside = {
	    bind: function bind(el, binding, vnode) {
	      function documentHandler(e) {
	        if (el.contains(e.target)) {
	          return false;
	        }
	
	        if (binding.expression) {
	          binding.value(e);
	        }
	      }
	
	      el.__vueClickOutside__ = documentHandler;
	      document.addEventListener('click', documentHandler, true);
	    },
	    update: function update() {},
	    unbind: function unbind(el, binding) {
	      document.removeEventListener('click', el.__vueClickOutside__, true);
	      delete el.__vueClickOutside__;
	    }
	  };
	
	  function getRange() {
	    var startOffset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var endOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var period = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
	
	    return [moment().subtract(startOffset, period).startOf(period), moment().subtract(endOffset, period).endOf(period)];
	  }
	
	  var defaultPresets = [{
	    label: 'Today',
	    range: getRange(0, 0)
	  }, {
	    label: 'Yesterday',
	    range: getRange(1, 1)
	  }, {
	    label: 'Last 7 Days',
	    range: getRange(6, 0)
	  }, {
	    label: 'Last 30 Days',
	    range: getRange(29, 0)
	  }, {
	    label: 'This Month',
	    range: getRange(0, 0, 'month')
	  }, {
	    label: 'Last Month',
	    range: getRange(1, 1, 'month')
	  }];
	
	  var script$3 = {
	    name: 'v-md-date-range-picker',
	    components: {
	      Calendar: Calendar,
	      CalendarRanges: CalendarRanges,
	      DefaultActivator: DefaultActivator
	    },
	    directives: {
	      clickoutside: clickoutside
	    },
	
	    provide: function provide() {
	      return {
	        'picker': this
	      };
	    },
	
	
	    props: {
	      startDate: {
	        type: String,
	        default: moment().format('YYYY-MM-DD')
	      },
	
	      endDate: {
	        type: String,
	        default: moment().format('YYYY-MM-DD')
	      },
	
	      presets: {
	        type: Array,
	
	        default: function _default() {
	          return defaultPresets;
	        }
	      },
	
	      opens: {
	        type: String,
	        default: 'left'
	      },
	
	      showCustomRangeLabel: {
	        type: Boolean,
	        default: false
	      },
	
	      showYearSelect: {
	        type: Boolean,
	        default: false
	      },
	
	      minYear: {
	        type: String,
	        default: moment().subtract(100, 'year').format('YYYY')
	      },
	
	      maxYear: {
	        type: String,
	        default: moment().add(100, 'year').format('YYYY')
	      },
	
	      autoApply: {
	        type: Boolean,
	        default: true
	      },
	
	      showActivatorLabel: {
	        type: Boolean,
	        default: true
	      },
	
	      showActivatorBar: {
	        type: Boolean,
	        default: true
	      },
	      showPresets: {
	        type: Boolean,
	        default: true
	      }
	    },
	
	    data: function data() {
	      var data = {
	        locale: {
	          direction: 'ltr',
	          format: moment.localeData().longDateFormat('L'),
	          separator: ' - ',
	          applyLabel: 'Apply',
	          cancelLabel: 'Cancel',
	          weekLabel: 'W',
	          customRangeLabel: 'Custom Range',
	          daysOfWeek: moment.weekdaysMin(),
	          monthNames: moment.monthsShort(),
	          firstDay: moment.localeData().firstDayOfWeek()
	        }
	      };
	
	      data.leftCalendarMonth_ = moment(this.startDate);
	      data.rightCalendarMonth_ = moment(this.endDate);
	      data.start_ = moment(this.startDate);
	      data.end_ = moment(this.endDate);
	      data.hoverStart_ = moment(this.startDate);
	      data.hoverEnd_ = moment(this.endDate);
	
	      data.cloneStart = moment(this.startDate);
	      data.cloneEnd = moment(this.endDate);
	      data.startText = moment(this.startDate).format(data.locale.format);
	      data.endText = moment(this.endDate).format(data.locale.format);
	      data.inRange = false;
	
	      data.pickerVisible = false;
	
	      if (data.locale.firstDay !== 0) {
	        var iterator = data.locale.firstDay;
	
	        while (iterator > 0) {
	          data.locale.daysOfWeek.push(data.locale.daysOfWeek.shift());
	          iterator--;
	        }
	      }
	
	      return data;
	    },
	
	
	    methods: {
	      clickYearSelect: function clickYearSelect(_ref) {
	        var location = _ref.location,
	            calendarMonth = _ref.calendarMonth;
	
	        this[location + 'CalendarMonth_'] = calendarMonth.clone();
	      },
	      clickNextMonth: function clickNextMonth() {
	        this.leftCalendarMonth_ = this.leftCalendarMonth_.clone().add(1, 'month');
	      },
	      clickPrevMonth: function clickPrevMonth() {
	        this.leftCalendarMonth_ = this.leftCalendarMonth_.clone().subtract(1, 'month');
	      },
	      dateClick: function dateClick(value) {
	        if (this.inRange) {
	          this.inRange = false;
	
	          if (value.isBefore(this.start_)) {
	            this.end_ = this.start_;
	            this.start_ = value.clone();
	          } else {
	            this.end_ = value.clone();
	          }
	
	          if (this.autoApply) {
	            this.clickApply();
	          }
	        } else {
	          this.inRange = true;
	          this.start_ = value.clone();
	          this.end_ = value.clone();
	        }
	      },
	      hoverDate: function hoverDate(value) {
	        if (this.inRange) {
	          if (value > this.start_) {
	            this.hoverStart_ = this.start_.clone();
	            this.hoverEnd_ = value.clone();
	          } else {
	            this.hoverEnd_ = this.start_.clone();
	            this.hoverStart_ = value.clone();
	          }
	        }
	      },
	      togglePicker: function togglePicker() {
	        var elm = this.$refs.defaultActivator && this.$refs.defaultActivator.$el;
	
	        var slotActivator = this.$slots.input && this.$slots.input.length && this.$slots.input[0].elm;
	
	        if (!elm && (slotActivator.querySelector('input') || slotActivator.querySelector('button'))) {
	          elm = slotActivator;
	        }
	
	        if (elm) {
	          this.pickerVisible = true;
	        } else {
	          this.pickerVisible = !this.pickerVisible;
	        }
	      },
	      pickerStyles: function pickerStyles() {
	        return {
	          'show-calendar': this.pickerVisible,
	          'opens-arrow-pos-right': this.opens === 'right',
	          'opens-arrow-pos-left': this.opens === 'left',
	          'opens-arrow-pos-center': this.opens === 'center'
	        };
	      },
	      clickApply: function clickApply() {
	        this.pickerVisible = false;
	
	        if (this.inRange) {
	          this.inRange = false;
	          this.start_ = this.cloneStart.clone();
	          this.end_ = this.cloneEnd.clone();
	          return;
	        }
	
	        this.updateTextField();
	        this.cloneForCancelUsage();
	        this.emitChange();
	      },
	      clickPreset: function clickPreset(preset) {
	        if (preset.label === this.locale.customRangeLabel) return;
	
	        var _preset$range2 = (0, _slicedToArray3.default)(preset.range, 2),
	            start = _preset$range2[0],
	            end = _preset$range2[1];
	
	        this.start_ = moment(start);
	        this.end_ = moment(end);
	
	        this.leftCalendarMonth_ = moment(start);
	
	        if (this.autoApply) {
	          this.clickApply();
	        }
	      },
	      updateTextField: function updateTextField() {
	        if (this.$slots.input) return;
	        this.startText = this.start_.format(this.locale.format);
	        this.endText = this.end_.format(this.locale.format);
	      },
	      cloneForCancelUsage: function cloneForCancelUsage() {
	        this.cloneStart = this.start_.clone();
	        this.cloneEnd = this.end_.clone();
	      },
	      emitChange: function emitChange() {
	        var start = this.start_.clone();
	        var end = this.end_.clone();
	        this.$emit('change', [start, end], [start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD')]);
	      },
	      clickOutside: function clickOutside() {
	        if (!this.pickerVisible) return;
	        this.clickApply();
	      }
	    },
	    watch: {
	      start_: function start_(value) {
	        this.hoverStart_ = value.clone();
	
	        if (value.month() === this.end_.month()) return;
	        this.leftCalendarMonth_ = value.clone();
	      },
	      end_: function end_(value) {
	        this.hoverEnd_ = value.clone();
	      },
	
	
	      leftCalendarMonth_: {
	        handler: function handler(leftMonth) {
	          this.rightCalendarMonth_ = leftMonth.clone().add(1, 'month');
	        },
	
	
	        immediate: true
	      },
	
	      startDate: function startDate(value) {
	        this.start_ = moment(value);
	        this.startText = moment(value).format(this.locale.format);
	        this.cloneStart = moment(value);
	      },
	      endDate: function endDate(value) {
	        this.end_ = moment(value);
	        this.endText = moment(value).format(this.locale.format);
	        this.cloneEnd = moment(value);
	      }
	    }
	  };
	
	  var __vue_script__$3 = script$3;
	
	  var __vue_render__$3 = function __vue_render__$3() {
	    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { directives: [{ name: "clickoutside", rawName: "v-clickoutside", value: _vm.clickOutside, expression: "clickOutside" }], staticClass: "mdrp-root" }, [_c('div', { staticClass: "mdrp__activator", on: { "click": _vm.togglePicker } }, [_vm._t("input", [_c('default-activator', { ref: "defaultActivator", attrs: { "value": _vm.startText + " - " + _vm.endText, "readonly": "" } })])], 2), _vm._v(" "), _c('transition', { attrs: { "name": "slide-fade", "mode": "out-in" } }, [_c('div', { directives: [{ name: "show", rawName: "v-show", value: _vm.pickerVisible, expression: "pickerVisible" }], staticClass: "mdrp__panel dropdown-menu", class: _vm.pickerStyles() }, [_vm.showPresets && _vm.presets ? _c('calendar-ranges', { attrs: { "canSelect": _vm.inRange, "presets": _vm.presets }, on: { "clickCancel": function clickCancel($event) {
	          _vm.pickerVisible = false;
	        }, "clickApply": _vm.clickApply, "clickPreset": _vm.clickPreset } }) : _vm._e(), _vm._v(" "), _c('calendar', { staticClass: "calendar left", attrs: { "location": "left", "calendar-month": _vm.leftCalendarMonth_, "locale": _vm.locale, "start": _vm.start_, "end": _vm.end_, "hover-start": _vm.hoverStart_, "hover-end": _vm.hoverEnd_ }, on: { "clickNextMonth": _vm.clickNextMonth, "clickPrevMonth": _vm.clickPrevMonth, "dateClick": _vm.dateClick, "hoverDate": _vm.hoverDate, "clickYearSelect": _vm.clickYearSelect } }), _vm._v(" "), _c('calendar', { staticClass: "calendar right", attrs: { "location": "right", "calendar-month": _vm.rightCalendarMonth_, "locale": _vm.locale, "start": _vm.start_, "end": _vm.end_, "hover-start": _vm.hoverStart_, "hover-end": _vm.hoverEnd_ }, on: { "clickNextMonth": _vm.clickNextMonth, "clickPrevMonth": _vm.clickPrevMonth, "dateClick": _vm.dateClick, "hoverDate": _vm.hoverDate, "clickYearSelect": _vm.clickYearSelect } })], 1)])], 1);
	  };
	  var __vue_staticRenderFns__$3 = [];
	
	  var __vue_inject_styles__$3 = function __vue_inject_styles__$3(inject) {
	    if (!inject) return;
	    inject("data-v-7863e830_0", { source: "@charset \"UTF-8\";*[data-v-7863e830]{box-sizing:border-box}.mdrp__panel.opens-arrow-pos-center[data-v-7863e830]::after,.mdrp__panel.opens-arrow-pos-center[data-v-7863e830]::before{left:0;right:0;width:0;margin-left:auto;margin-right:auto}.mdrp-root[data-v-7863e830]{position:relative;display:inline-block}.mdrp__panel[data-v-7863e830]{font-size:15px;line-height:1em;position:absolute;z-index:3001;top:100px;left:20px;width:278px;max-width:none;margin-top:7px;padding:0;color:inherit;border:1px solid #ddd;border-radius:4px;background-color:#fff}.mdrp__panel.show-calendar[data-v-7863e830]{display:block}.mdrp__panel[data-v-7863e830]::after,.mdrp__panel[data-v-7863e830]::before{position:absolute;display:inline-block;border-bottom-color:red;content:\"\"}.mdrp__panel[data-v-7863e830]::before{top:-7px;border-right:7px solid transparent;border-bottom:7px solid #ccc;border-left:7px solid transparent}.mdrp__panel[data-v-7863e830]::after{top:-6px;border-right:6px solid transparent;border-bottom:6px solid #fff;border-left:6px solid transparent}.mdrp__panel.opens-arrow-pos-left[data-v-7863e830]{top:40px;left:10px;right:auto}.mdrp__panel.opens-arrow-pos-left[data-v-7863e830]::before{left:9px}.mdrp__panel.opens-arrow-pos-left[data-v-7863e830]::after{left:10px}.mdrp__panel.opens-arrow-pos-right[data-v-7863e830]{top:40px;right:10px;left:auto}.mdrp__panel.opens-arrow-pos-right[data-v-7863e830]::before{right:9px}.mdrp__panel.opens-arrow-pos-right[data-v-7863e830]::after{right:10px}.mdrp__panel.opens-arrow-pos-center[data-v-7863e830]{top:40px}.mdrp__panel.dropdown-menu[data-v-7863e830]{max-width:none;z-index:9}.mdrp__panel .calendar-table[data-v-7863e830]{display:none;max-width:270px}.mdrp__panel.show-calendar .calendar-table[data-v-7863e830]{display:block}@media (min-width:564px){.mdrp__panel[data-v-7863e830]{width:auto}.mdrp__panel.show-calendar[data-v-7863e830]{display:inline-flex}.mdrp__panel .calendar-table.left[data-v-7863e830]{padding:8px 0 8px 8px}.mdrp__panel .calendar-table.right[data-v-7863e830]{padding:8px}}.slide-fade-enter-active[data-v-7863e830]{transition:all .2s ease}.slide-fade-leave-active[data-v-7863e830]{transition:all .1s cubic-bezier(1,.5,.8,1)}.slide-fade-enter[data-v-7863e830],.slide-fade-leave-to[data-v-7863e830]{transform:translateX(10px);opacity:0}", map: undefined, media: undefined });
	  };
	
	  var __vue_scope_id__$3 = "data-v-7863e830";
	
	  var __vue_module_identifier__$3 = undefined;
	
	  var __vue_is_functional_template__$3 = false;
	
	
	  var VMdDateRangePicker = normalizeComponent_1({ render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 }, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, browser, undefined);
	
	  var install = function install(Vue) {
	    Vue.component(VMdDateRangePicker.name, VMdDateRangePicker);
	  };
	
	  if (typeof window !== 'undefined' && window.Vue) {
	    install(window.Vue);
	  }
	
	  var index = {
	    install: install,
	    VMdDateRangePicker: VMdDateRangePicker
	  };
	
	  return index;
	});

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _brandMark = __webpack_require__(168);
	
	exports.default = {
	  data: function data() {
	    return {
	      markPath: _brandMark.MOVE_MAIS_MARK_PATH,
	      markViewBox: _brandMark.MOVE_MAIS_MARK_VIEWBOX
	    };
	  }
	};

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _number = __webpack_require__(24);
	
	var _financial = __webpack_require__(54);
	
	var _financial2 = _interopRequireDefault(_financial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["showTaxes"],
	  data: function data() {
	    return {
	      typeSelected: {},
	      taxas: [{
	        type: "pj",
	        values: []
	      }, {
	        type: "pf",
	        values: []
	      }]
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.getNovasTaxas();
	
	    this.showTaxes == "pf" ? this.taxas.pf = true : this.taxas.pj = true;
	
	    this.typeSelected = this.taxas.find(function (taxas) {
	      return taxas.type == _this.showTaxes;
	    });
	  },
	
	  methods: {
	    getNovasTaxas: function getNovasTaxas() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var _ref, data, arrayPjFiltro, arrayPfFiltro, _corPJ, _corPF, lastLine, cor;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _financial2.default.getNovasTaxas();
	
	              case 2:
	                _ref = _context.sent;
	                data = _ref.data;
	                arrayPjFiltro = data.consultado.filter(function (ele) {
	                  return ele[0] == "PJ";
	                });
	                arrayPfFiltro = data.consultado.filter(function (ele) {
	                  return ele[0] == "PF";
	                });
	                _corPJ = "";
	                _corPF = "";
	                lastLine = false;
	                cor = {
	                  corPJ: function corPJ() {
	                    if (_corPJ == "") {
	                      _corPJ = "red";
	                      lastLine = false;
	                      return "red";
	                    } else if (_corPJ == "red") {
	                      _corPJ = "yellow";
	                      lastLine = false;
	                      return "yellow";
	                    } else if (_corPJ == "yellow") {
	                      _corPJ = "green";
	                      lastLine = false;
	                      return "green";
	                    } else if (_corPJ == "green") {
	                      _corPJ = "blue";
	                      lastLine = false;
	                      return "blue";
	                    } else if (_corPJ == "blue") {
	                      _corPJ = "purple";
	                      lastLine = "last";
	                      return "purple";
	                    } else if (_corPJ == "purple") {
	                      _corPJ = "red";
	                      lastLine = false;
	                      return "red";
	                    }
	                  },
	                  corPF: function corPF() {
	                    if (_corPF == "") {
	                      _corPF = "red";
	                      lastLine = false;
	                      return "red";
	                    } else if (_corPF == "red") {
	                      _corPF = "yellow";
	                      lastLine = false;
	                      return "yellow";
	                    } else if (_corPF == "yellow") {
	                      _corPF = "green";
	                      lastLine = false;
	                      return "green";
	                    } else if (_corPF == "green") {
	                      _corPF = "blue";
	                      lastLine = false;
	                      return "blue";
	                    } else if (_corPF == "blue") {
	                      _corPF = "purple";
	                      lastLine = "last";
	                      return "purple";
	                    } else if (_corPF == "purple") {
	                      _corPF = "red";
	                      lastLine = false;
	                      return "red";
	                    }
	                  }
	                };
	
	
	                arrayPfFiltro.forEach(function (ele, index) {
	                  var objPf = {
	                    id: index + 1,
	                    rechargeValue: ele[4] == 99 ? ele[5] / 100 + "+" : ele[5] / 100,
	                    rechargeTax: ele[4] == 99 ? ele[6] + "%" : ele[6],
	                    additionalInformation: false,
	                    colorClass: cor.corPF(),
	                    classLastChildInLine: lastLine
	                  };
	
	                  _this2.taxas[1].values.push(objPf);
	                });
	
	                arrayPjFiltro.forEach(function (ele, index) {
	                  var ObjPj = {
	                    id: index + 1,
	                    rechargeValue: ele[4] == 99 ? ele[5] / 100 + "+" : index == 0 ? ele[5] / 100 + "*" : ele[5] / 100,
	                    rechargeTax: ele[4] == 99 ? ele[6] + "%" : ele[6],
	                    additionalInformation: index === 0 ? "*Apenas plano Estradeiro" : false,
	                    colorClass: cor.corPJ(),
	                    classLastChildInLine: lastLine
	                  };
	                  _this2.taxas[0].values.push(ObjPj);
	                });
	
	              case 12:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }))();
	    }
	  }
	};

/***/ }),
/* 559 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {},
	  data: function data() {
	    return {
	      mostrarModal: true
	    };
	  },
	  mounted: function mounted() {
	    console.log(window.innerWidth, "coprimento da tela");
	  },
	
	
	  methods: {
	    fecharModal: function fecharModal() {
	      var _this = this;
	
	      var modal = document.querySelector(".modal");
	      modal.classList.add("fade-out");
	      modal.classList.remove("fade-in");
	
	      modal.addEventListener("animationend", function () {
	        _this.$emit("fechar");
	        _this.mostrarModal = false;
	      });
	    }
	  }
	};

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _vehicles = __webpack_require__(29);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    plateToConvert: undefined
	  },
	  data: function data() {
	    return {
	      contracts: [],
	      isMobile: undefined,
	
	      mostrarModal: true
	    };
	  },
	
	
	  computed: {
	    currentUser: function currentUser() {
	      return _auth2.default.currentUser;
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.listContracts();
	    if (window.innerWidth <= 769) {
	      this.isMobile = true;
	    } else {
	      this.isMobile = false;
	    }
	
	    window.addEventListener("resize", function () {
	      return window.innerWidth <= 769 ? _this.isMobile = true : _this.isMobile = false;
	    });
	  },
	
	
	  methods: {
	    fecharModal: function fecharModal() {
	      var _this2 = this;
	
	      if (!this.isMobile) {
	        var modal = document.querySelector(".modal-main");
	        modal.classList.add("fade-out");
	        modal.classList.remove("fade-in");
	
	        modal.addEventListener("animationend", function () {
	          _this2.mostrarModal = false;
	          _this2.$emit("close");
	        });
	      } else {
	        this.mostrarModal = false;
	        this.$emit("close");
	      }
	    },
	    listContracts: function listContracts() {
	      var _this3 = this;
	
	      _vehicles2.default.getContractUserList(this.currentUser.moveMaisId).then(function (res) {
	        _this3.contracts = res;
	      });
	    }
	  }
	};

/***/ }),
/* 561 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {},
	  data: function data() {
	    return {
	      mostrarModal: true
	    };
	  },
	  mounted: function mounted() {},
	
	
	  methods: {
	    fecharModal: function fecharModal() {
	      var _this = this;
	
	      var modal = document.querySelector(".modal");
	      modal.classList.add("fade-out");
	      modal.classList.remove("fade-in");
	
	      modal.addEventListener("animationend", function () {
	        _this.$emit("fechar");
	        _this.mostrarModal = false;
	      });
	    }
	  }
	};

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vehicles = __webpack_require__(29);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    plateToConvert: undefined
	  },
	  data: function data() {
	    return {
	      mostrarModal: true,
	      newPlate: undefined,
	      oldPlate: undefined,
	      successConverted: undefined,
	      loading: false,
	      updatePlateClicked: false };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.oldPlate = this.plateToConvert;
	
	    _vehicles2.default.getVehicleMercosulPlate(this.plateToConvert).then(function (res) {
	      _this.newPlate = res;
	    });
	  },
	
	
	  methods: {
	    doUpdatePlate: function doUpdatePlate() {
	      var _this2 = this;
	
	      this.updatePlateClicked = true;
	      this.loading = true;
	      _vehicles2.default.alterToMercosulPlate(this.oldPlate).then(function (res) {
	        if (res.status.code == 0) {
	          _this2.successConverted = 1;
	          _this2.$emit("fechar");
	          _this2.$emit("success", _this2.successConverted);
	        } else {
	          _this2.successConverted = 0;
	          _this2.$emit("fechar");
	          _this2.$emit("error", _this2.successConverted);
	        }
	      }).catch(function (err) {
	        _this2.successConverted = 0;
	        _this2.$emit("fechar");
	        _this2.$emit("error", _this2.successConverted);
	      });
	    },
	    fecharModal: function fecharModal() {
	      var _this3 = this;
	
	      var modal = document.querySelector(".modal");
	      modal.classList.add("fade-out");
	      modal.classList.remove("fade-in");
	
	      modal.addEventListener("animationend", function () {
	        _this3.$emit("fechar");
	        _this3.mostrarModal = false;
	      });
	    }
	  }
	};

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _number = __webpack_require__(24);
	
	exports.default = {
	  data: function data() {
	    return {
	      transferValue: "0.00",
	      taxTransferValue: "0.00",
	      finalTransferValue: "0.00"
	    };
	  },
	  mounted: function mounted() {
	    if (window.document.webview) {
	      $('.tab-content').height('266px');
	    }
	
	    $("#modal-info").prop("checked", true);
	
	
	    var vm = this;
	    var el = $(this.$el);
	
	    el.find('.question-box > h4').click(function () {
	      el.find('.question-box .open').removeClass('open');
	      $(this).find('i').addClass('open');
	      $(this).parent().find('.answer-box').addClass('open');
	    });
	
	    el.find('.tab-pane > h4').click(function () {
	      el.find('.open').removeClass('open');
	      $(this).find('i').addClass('open');
	      $(this).parent().find('.pane-answer-box').addClass('open');
	    });
	  },
	
	  methods: {
	    doNotShow: function doNotShow() {
	      if ($('#modal-info').prop('checked') == true) {
	        if (localStorage.getItem('modal-info') == 0) {
	          localStorage.setItem('modal-info', 1);
	        }
	      } else {
	        localStorage.setItem('modal-info', 0);
	      }
	    },
	    increment: function increment() {
	      var value = parseInt(this.transferValue.replace(/[^0-9]/g, ''));
	      if (value == '' || value >= 0) {
	        value += 1000;
	      }
	
	      this.changeTransferValue(value + "");
	    },
	    decrement: function decrement() {
	      var value = parseInt(this.transferValue.replace(/[^0-9]/g, ''));
	      if (value > 1000) {
	        value -= 1000;
	      }
	
	      this.changeTransferValue(value + "");
	    },
	    changeTransferValue: function changeTransferValue(newValue) {
	      var value = parseInt(newValue.replace(/[^0-9]/g, ''));
	
	      this.transferValue = (0, _number.cents)(value);
	      var tax = value * 0.02;
	      this.taxTransferValue = (0, _number.cents)(tax);
	      this.finalTransferValue = (0, _number.cents)(value + tax);
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "ModalValidate",
	  props: {
	    show: {
	      type: Boolean,
	      default: false
	    },
	    email: {
	      type: String,
	      required: true,
	      default: ""
	    },
	    title: {
	      type: String,
	      default: "e-mail"
	    },
	    resendCooldown: {
	      type: Number,
	      default: 60 },
	    closeOnBackdrop: {
	      type: Boolean,
	      default: true
	    },
	    allowClose: {
	      type: Boolean,
	      default: true
	    },
	    initialTimer: {
	      type: Number,
	      default: null }
	  },
	  data: function data() {
	    return {
	      step: "channel-selection",
	      selectedChannel: null,
	      channelErrorMessage: "",
	      isProcessing: false,
	      channels: [],
	      loadingChannels: false,
	      code: ["", "", "", "", "", ""],
	      resendTimer: 0,
	      errorMessage: "",
	      timerInterval: null,
	      hasError: false };
	  },
	
	  computed: {
	    selectedChannelLabel: function selectedChannelLabel() {
	      var _this = this;
	
	      var channel = this.channels.find(function (c) {
	        return c.value === _this.selectedChannel;
	      });
	      return channel ? channel.label.toLowerCase() : "";
	    }
	  },
	  watch: {
	    show: function show(newVal) {
	      if (newVal) {
	        this.step = "channel-selection";
	        this.selectedChannel = null;
	        this.channelErrorMessage = "";
	        this.resetCode();
	        this.errorMessage = "";
	        this.isProcessing = false;
	
	        this.fetchNotificationChannels();
	
	        document.body.style.overflow = "hidden";
	      } else {
	        document.body.style.overflow = "auto";
	        if (this.timerInterval) {
	          clearInterval(this.timerInterval);
	          this.timerInterval = null;
	        }
	      }
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.timerInterval) {
	      clearInterval(this.timerInterval);
	    }
	    document.body.style.overflow = "auto";
	  },
	
	  methods: {
	    fetchNotificationChannels: function fetchNotificationChannels() {
	      var _this2 = this;
	
	      this.loadingChannels = true;
	      this.channelErrorMessage = "";
	
	      _auth2.default.getNotificationStatus().then(function (response) {
	        _this2.loadingChannels = false;
	
	        if (!Array.isArray(response)) {
	          _this2.channelErrorMessage = "Erro ao carregar opções de notificação.";
	          _this2.channels = [];
	          return;
	        }
	
	        var normalizeDescricao = function normalizeDescricao(desc) {
	          return desc.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "").replace(/-/g, "");
	        };
	
	        var channelMap = {
	          whatsapp: {
	            value: "WHATSAPP",
	            label: "WhatsApp",
	            icon: "icon-whatsapp"
	          },
	          sms: {
	            value: "SMS",
	            label: "SMS",
	            icon: "icon-sms"
	          },
	          email: {
	            value: "EMAIL",
	            label: "E-mail",
	            icon: "icon-envelope"
	          },
	          "e-mail": {
	            value: "EMAIL",
	            label: "E-mail",
	            icon: "icon-envelope"
	          }
	        };
	
	        _this2.channels = response.filter(function (item) {
	          return item.status === 1;
	        }).map(function (item) {
	          var normalized = normalizeDescricao(item.descricao);
	          var mapped = channelMap[normalized];
	          if (mapped) {
	            return mapped;
	          }
	
	          return {
	            value: item.descricao.toUpperCase().replace(/\s+/g, "_"),
	            label: item.descricao,
	            icon: "icon-envelope"
	          };
	        }).filter(function (item) {
	          return item !== null;
	        });
	
	        if (_this2.channels.length === 0) {
	          _this2.channelErrorMessage = "Nenhuma opção de notificação disponível no momento.";
	        }
	      }).catch(function (err) {
	        _this2.loadingChannels = false;
	        var errorMessage = "Erro ao carregar opções de notificação. Tente novamente.";
	
	        if (err.response && err.response.data && err.response.data.status) {
	          errorMessage = err.response.data.status.message || errorMessage;
	        } else if (err.message) {
	          errorMessage = err.message;
	        }
	
	        _this2.channelErrorMessage = errorMessage;
	        _this2.channels = [];
	      });
	    },
	    selectChannel: function selectChannel(channel) {
	      if (this.isProcessing) return;
	      this.selectedChannel = channel;
	      this.channelErrorMessage = "";
	    },
	    handleConfirmChannel: function handleConfirmChannel() {
	      if (!this.selectedChannel || this.isProcessing) {
	        if (!this.selectedChannel) {
	          this.channelErrorMessage = "Por favor, selecione uma opção";
	        }
	        return;
	      }
	
	      this.isProcessing = true;
	      this.channelErrorMessage = "";
	
	      this.$emit("channel-selected", this.selectedChannel);
	    },
	    proceedToCodeInput: function proceedToCodeInput() {
	      var _this3 = this;
	
	      this.step = "code-input";
	      this.isProcessing = false;
	
	      var timerValue = this.initialTimer !== null ? this.initialTimer : this.resendCooldown;
	      this.startResendTimer(timerValue);
	      this.$nextTick(function () {
	        var firstInput = _this3.$refs.codeInput1;
	        if (firstInput && firstInput[0]) {
	          firstInput[0].focus();
	        }
	      });
	    },
	    resetToChannelSelection: function resetToChannelSelection() {
	      this.step = "channel-selection";
	      this.isProcessing = false;
	      this.channelErrorMessage = "";
	    },
	    resetCode: function resetCode() {
	      this.code = ["", "", "", "", "", ""];
	      this.errorMessage = "";
	      this.hasError = false;
	    },
	    handleCodeInput: function handleCodeInput(event, index) {
	      var _this4 = this;
	
	      var value = event.target.value.replace(/[^0-9]/g, "");
	      this.code[index - 1] = value;
	
	      if (this.errorMessage) {
	        this.errorMessage = "";
	        this.hasError = false;
	      }
	
	      if (value && index < 6) {
	        this.$nextTick(function () {
	          var nextInput = _this4.$refs["codeInput" + (index + 1)];
	          if (nextInput && nextInput[0]) {
	            nextInput[0].focus();
	          }
	        });
	      }
	
	      if (this.code.every(function (digit) {
	        return digit !== "";
	      })) {
	        this.validateCode();
	      }
	    },
	    handleCodeKeydown: function handleCodeKeydown(event, index) {
	      var _this5 = this;
	
	      if (event.key === "Backspace" && !this.code[index - 1] && index > 1) {
	        this.$nextTick(function () {
	          var prevInput = _this5.$refs["codeInput" + (index - 1)];
	          if (prevInput && prevInput[0]) {
	            prevInput[0].focus();
	          }
	        });
	      }
	
	      if (event.key === "Delete") {
	        this.code[index - 1] = "";
	      }
	
	      if (event.key === "Escape") {
	        this.handleClose();
	      }
	    },
	    handleCodePaste: function handleCodePaste(event) {
	      var _this6 = this;
	
	      event.preventDefault();
	      var pastedData = event.clipboardData.getData("text").replace(/[^0-9]/g, "");
	
	      if (pastedData.length === 6) {
	        this.code = pastedData.split("");
	        this.$nextTick(function () {
	          var lastInput = _this6.$refs.codeInput6;
	          if (lastInput && lastInput[0]) {
	            lastInput[0].focus();
	          }
	          _this6.validateCode();
	        });
	      }
	    },
	    validateCode: function validateCode() {
	      var fullCode = this.code.join("");
	
	      if (fullCode.length === 6) {
	        this.$emit("validate", fullCode);
	      }
	    },
	    handleResendClick: function handleResendClick() {
	      if (this.resendTimer === 0) {
	        this.$emit("resend");
	      }
	    },
	    startResendTimer: function startResendTimer(initialValue) {
	      var _this7 = this;
	
	      this.resendTimer = initialValue !== undefined ? initialValue : this.resendCooldown;
	
	      if (this.timerInterval) {
	        clearInterval(this.timerInterval);
	      }
	
	      if (this.resendTimer <= 0) {
	        this.resendTimer = 0;
	        return;
	      }
	
	      this.timerInterval = setInterval(function () {
	        _this7.resendTimer--;
	        if (_this7.resendTimer <= 0) {
	          clearInterval(_this7.timerInterval);
	          _this7.timerInterval = null;
	        }
	      }, 1000);
	    },
	    handleClose: function handleClose() {
	      if (this.allowClose) {
	        this.$emit("close");
	        this.resetCode();
	      }
	    },
	    handleBackdropClick: function handleBackdropClick() {
	      if (this.closeOnBackdrop && this.allowClose) {
	        this.handleClose();
	      }
	    },
	    setError: function setError(message) {
	      var _this8 = this;
	
	      this.errorMessage = message;
	      this.hasError = true;
	      this.$nextTick(function () {
	        var firstInput = _this8.$refs.codeInput1;
	        if (firstInput && firstInput[0]) {
	          firstInput[0].focus();
	        }
	      });
	    },
	    setErrorState: function setErrorState(hasError) {
	      var _this9 = this;
	
	      this.hasError = hasError;
	      if (hasError) {
	        this.code = ["", "", "", "", "", ""];
	        this.$nextTick(function () {
	          var firstInput = _this9.$refs.codeInput1;
	          if (firstInput && firstInput[0]) {
	            firstInput[0].focus();
	          }
	        });
	      }
	    },
	    clearError: function clearError() {
	      this.errorMessage = "";
	      this.hasError = false;
	    }
	  }
	};

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    moveMaisIdParceiroSelecionado: undefined
	  },
	  data: function data() {
	    return {
	      isVisible: true,
	      segundaPeriodo1: undefined,
	      segundaPeriodo2: undefined,
	      tercaPeriodo1: undefined,
	      tercaPeriodo2: undefined,
	      quartaPeriodo1: undefined,
	      quartaPeriodo2: undefined,
	      quintaPeriodo1: undefined,
	      quintaPeriodo2: undefined,
	      sextaPeriodo1: undefined,
	      sextaPeriodo2: undefined,
	      sabadoPeriodo1: undefined,
	      sabadoPeriodo2: undefined,
	      domingoPeriodo1: undefined,
	      domingoPeriodo2: undefined,
	      feriadoPeriodo1: undefined,
	      feriadoPeriodo2: undefined
	    };
	  },
	  mounted: function mounted() {
	    this.getHorariosParceiros(this.moveMaisIdParceiroSelecionado);
	  },
	
	
	  methods: {
	    getHorariosParceiros: function getHorariosParceiros(moveMaisId) {
	      var _this = this;
	
	      _account2.default.getHorariosParceiros(moveMaisId).then(function (res) {
	        if (res.status.code === 0) {
	          _this.segundaPeriodo1 = res.listaHorarios.segundaPeriodo1;
	          _this.segundaPeriodo2 = res.listaHorarios.segundaPeriodo2;
	          _this.tercaPeriodo1 = res.listaHorarios.tercaPeriodo1;
	          _this.tercaPeriodo2 = res.listaHorarios.tercaPeriodo2;
	          _this.quartaPeriodo1 = res.listaHorarios.quartaPeriodo1;
	          _this.quartaPeriodo2 = res.listaHorarios.quartaPeriodo2;
	          _this.quintaPeriodo1 = res.listaHorarios.quintaPeriodo1;
	          _this.quintaPeriodo2 = res.listaHorarios.quintaPeriodo2;
	          _this.sextaPeriodo1 = res.listaHorarios.sextaPeriodo1;
	          _this.sextaPeriodo2 = res.listaHorarios.sextaPeriodo2;
	          _this.sabadoPeriodo1 = res.listaHorarios.sabadoPeriodo1;
	          _this.sabadoPeriodo2 = res.listaHorarios.sabadoPeriodo2;
	          _this.domingoPeriodo1 = res.listaHorarios.domingoPeriodo1;
	          _this.domingoPeriodo2 = res.listaHorarios.domingoPeriodo2;
	          _this.feriadoPeriodo1 = res.listaHorarios.feriadoPeriodo1;
	          _this.feriadoPeriodo2 = res.listaHorarios.feriadoPeriodo2;
	        }
	      }).catch(function (error) {
	        console.log(error, "erro do catch");
	      });
	    },
	    fecharModal: function fecharModal() {
	      this.$emit("fecharModal", 1);
	    }
	  }
	};

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _seals = __webpack_require__(750);
	
	var _seals2 = _interopRequireDefault(_seals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      selos: []
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _seals2.default.getSelos();
	
	            case 2:
	              _this.selos = _context.sent;
	
	            case 3:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  computed: {
	    payments: function payments() {
	      if (!this.$store.getters.getAllPayments) return {};
	
	      return this.$store.getters.getAllPayments;
	    },
	    showElo: function showElo() {
	      var p = this.$store.getters.getAllPayments;
	      if (p) {
	        return p["Elo"];
	      }
	      return false;
	    },
	    ios: function ios() {
	      return window.document.ios;
	    }
	  }
	};

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      isScrolling: false,
	      openMenuMobile: false,
	      isMobile: false,
	      close: false,
	      isLoginRoute: false
	    };
	  },
	  created: function created() {
	    this.close = false;
	    this.isMobile = window.innerWidth <= 769;
	    this.isLoginRoute = this.$route.name === 'login';
	  },
	
	
	  watch: {
	    '$route': function $route() {
	      this.isLoginRoute = this.$route.name === 'login';
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    window.addEventListener('scroll', function () {
	      return window.scrollY > 0 ? _this.isScrolling = true : _this.isScrolling = false;
	    });
	
	    if (window.innerWidth <= 769) {
	      this.isMobile = true;
	    } else {
	      this.isMobile = false;
	    }
	
	    window.addEventListener('resize', function () {
	      return window.innerWidth <= 769 ? _this.isMobile = true : _this.isMobile = false;
	    });
	  },
	
	  computed: {
	    home: function home() {
	      if (this.$router.name == 'inicio') return true;
	    },
	    logo: function logo() {
	      if (this.isMobile) return 'Logo_Move_Mais_Horizontal_2026.svg';else if (this.isScrolling) return 'Logo_Move_Mais_Vertical_Branco_2026.svg';else return 'Logo_Move_Mais_Vertical_2026.svg';
	    }
	  },
	  methods: {
	    open: function open(url) {
	      window.open(url);
	    },
	    zapay_inicio: function zapay_inicio() {
	      _sales2.default.gravaLogRedirecionamentoBanner(0, 1, 1).then(function (res) {
	        console.log(res, "resposta");
	      });
	
	      var url = 'https://www.zignet.com.br/parceiro/movemais-externo/';
	      window.open(url, '_blank');
	    },
	    fecharActionBar: function fecharActionBar() {
	      this.close = true;
	    }
	  }
	};

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _appHeader = __webpack_require__(1890);
	
	var _appHeader2 = _interopRequireDefault(_appHeader);
	
	var _appFooter = __webpack_require__(1889);
	
	var _appFooter2 = _interopRequireDefault(_appFooter);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _brandMark = __webpack_require__(168);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      showMenu: true,
	      isMobile: false,
	      interfaces: ["WEBSITE", "MOBILE"],
	      markPath: _brandMark.MOVE_MAIS_MARK_PATH,
	      markViewBox: _brandMark.MOVE_MAIS_MARK_VIEWBOX
	    };
	  },
	  beforeMount: function beforeMount() {
	    if (window.location.href.indexOf("hotsite") !== -1) {
	      this.showMenu = false;
	    }
	  },
	
	  watch: {
	    $route: function $route(to, from) {
	      if (to.path.indexOf("/conta/") == 0 || to.path.indexOf("/hotsite") == 0) {
	        this.showMenu = false;
	      } else {
	        this.showMenu = true;
	      }
	    }
	  },
	  computed: {
	    isLoading: function isLoading() {
	      return this.$store.getters.isLoading;
	    },
	    ios: function ios() {
	      return window.document.ios;
	    }
	  },
	  created: function created() {
	    if (this.$route.path.indexOf("/conta/") == 0) {
	      this.showMenu = false;
	    }
	
	    (function (d, l) {
	      for (var k in l) {
	        if (navigator.userAgent.match(new RegExp(l[k], "i"))) {
	          d[k] = true;
	          d.documentElement.className += " " + k;
	        }
	      }
	    })(document, {
	      ios: "(iPhone|iPod|iPad|Macintosh)",
	      android: "android",
	      mobile: "mobile",
	      webview: "((iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)|webview)"
	    });
	  },
	  mounted: function mounted() {
	    var promise = this.$store.dispatch("getPlans").catch(function (err) {
	      _messageDialog2.default.show({
	        title: "Erro",
	        message: "Houve um problema ao carregar as informações do plano, provavelmente devido a uma falha de conexão, vamos tentar recarregar a página"
	      }).then(function (r) {
	        location.reload(true);
	      });
	    });
	
	    if (this.$route.query.promotionCode) {
	      sessionStorage.setItem("promotionCode", this.$route.query.promotionCode);
	    }
	  },
	
	
	  methods: {},
	  components: {
	    AppHeader: _appHeader2.default,
	    AppFooter: _appFooter2.default,
	    MessageDialog: _messageDialog2.default
	  }
	};

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tag = __webpack_require__(55);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _eventBus = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    'vehicle': Number
	  },
	  data: function data() {
	    return {
	      serialNumber: undefined,
	      formState: 'NEW',
	      promise: undefined
	    };
	  },
	  created: function created() {
	    var vm = this;
	    _eventBus.EventBus.$on("barcode", function (barcode, vehicleId) {
	      if (vehicleId == vm.vehicle) vm.serialNumber = barcode;
	    });
	  },
	
	  methods: {
	    vincularTag: function vincularTag() {
	      var _this = this;
	
	      this.promise = this.$validator.validateAll().then(function (success) {
	        var req = {
	          serialNumber: _this.serialNumber.replace(/^[^0-9]*/g, ''),
	          vehicleId: _this.vehicle
	        };
	        return success && _tag2.default.activateTagSite(req);
	      }).then(function (response) {
	
	        if (response.status.code == 0) {
	          _this.formState = 'OLD';
	
	          return _messageDialog2.default.show({
	            headerClass: 'modal-success',
	            title: 'Ativação de TAG',
	            message: 'Seu TAG foi ativado com sucesso!',
	            type: 'OK'
	          });
	        }
	      }).catch(function (error) {
	
	        if (error.msg && error.msg.indexOf('[vee-validate]') !== -1) {
	          return false;
	        }
	
	        _this.$emit('deactivatetagLoading');
	
	        return _messageDialog2.default.show({
	          headerClass: 'modal-danger',
	          title: 'Erro',
	          message: error.data.status.message,
	          type: 'OK'
	        });
	      });
	
	      this.$emit('activetagLoading', this.promise);
	    }
	  }
	};

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _number = __webpack_require__(24);
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["contractId", "contractName", "planId", "currentBalance"],
	  data: function data() {
	    return {
	      newValue: this.contractName,
	      editing: false,
	      loading: false
	    };
	    $('[data-toggle="tooltip"]').tooltip("show");
	  },
	  mounted: function mounted() {
	    $('[data-toggle="tooltip"]').tooltip();
	  },
	
	  computed: {},
	  methods: {
	    edit: function edit() {
	      this.editing = true;
	      $('[data-toggle="tooltip"]').tooltip("hide");
	      $(".plan-name-box-edit").this().addClass("hidden");
	    },
	    cancel: function cancel() {
	      this.editing = false;
	      this.newValue = this.contractName;
	      $('[data-toggle="tooltip"]').tooltip("hide");
	      $(".plan-name-box-edit").removeClass("hidden");
	    },
	    confirm: function confirm() {
	      var _this = this;
	
	      this.loading = true;
	      $('[data-toggle="tooltip"]').tooltip("hide");
	      $(".plan-name-box-edit").removeClass("hidden");
	      _contracts2.default.updateContractName(this.contractId, this.newValue).then(function (res) {
	        _this.editing = false;
	        _this.loading = false;
	        _this.$emit("input", _this.newValue);
	      }).catch(function (err) {
	        _this.loading = false;
	        $('[data-toggle="tooltip"]').tooltip("hide");
	        $(".plan-name-box-edit").removeClass("hidden");
	        var msg = err.data && err.data.status && err.data.status.message || "Erro do servidor.";
	        messageDialog.show({
	          title: "Erro",
	          headerClass: "modal-danger",
	          message: msg
	        });
	      });
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _eventBus = __webpack_require__(25);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _number = __webpack_require__(24);
	
	var _recargaMinima = __webpack_require__(98);
	
	var _recargaMinima2 = _interopRequireDefault(_recargaMinima);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["contract"],
	  data: function data() {
	    return {
	      rechargeAlter: {},
	      recharge: undefined,
	      loading: undefined,
	
	      rechargeValue: 0,
	      qtdFix: 4,
	      rechargesData: [],
	      value: undefined,
	      tax: "-",
	      source: undefined,
	      minValue: 200000
	    };
	  },
	  mounted: function mounted() {
	    this.source = _axios2.default.CancelToken.source();
	
	    this.rechargesData = this.getFixesRecharges(this.planId, this.minValue);
	    this.rechargesData.push({
	      value: -1,
	      caption: "Outro valor (deve ser maior que " + (0, _number.cents)(this.minValue)
	    });
	
	    if (this.contract.rechargeValue) {
	      this.value = this.rechargeValue = this.contract.rechargeValue;
	      if (this.value > this.minValue) {
	        this.value = -1;
	        this.calculateRecharge();
	      }
	    }
	  },
	
	  computed: {
	    valueFormatted: function valueFormatted() {
	      this.$nextTick(function () {
	        $("#valueTotal").val($("#valueTotal").val());
	      });
	      return (0, _number.cents)(this.rechargeValue).replace("R$", "");
	    },
	
	    planId: function planId() {
	      return this.contract.plan.planId;
	    }
	  },
	  methods: {
	    hideModal: function hideModal() {
	      this.rechargeAlter = this.recharge;
	      this.$emit("closeModalRecharge", this.contract.contractId);
	    },
	    alterRechargeUnit: function alterRechargeUnit() {
	      var _this = this;
	
	      if (this.value == -1 && parseInt(this.rechargeValue) < parseInt(this.minValue)) return false;
	
	      this.loading = _contracts2.default.updateContractValueRecharge(this.contract.contractId, this.rechargeValue).then(function (response) {
	        if (response.data.status.code == 0) {
	          _this.contract.rechargeValue = _this.rechargeValue;
	        }
	        _this.$emit("closeModalRecharge", _this.contract.contractId, _this.rechargeValue);
	      });
	    },
	    changeRecharge: function changeRecharge(item) {
	      if (!item) return;
	      this.tax = item.tax;
	      this.rechargeValue = item.value;
	      this.contract._quantity = item.quantity;
	      if (item.value == -1) {
	        this.rechargeValue = 0;
	        this.tax = "-";
	      }
	    },
	
	    calculateRecharge: function calculateRecharge() {
	      var _this2 = this;
	
	      if (!_recargaMinima2.default.validate(this.rechargeValue, [this.minValue])) {
	        this.tax = "-";
	        return false;
	      }
	      this.source.cancel("cancelada");
	      this.source = _axios2.default.CancelToken.source();
	      this.waiting = true;
	      var r = this.rechargeValue;
	      this.loading = _sales2.default.calculateRechargeRate({
	        cancelToken: this.source.token,
	        value: r,
	        planId: this.planId
	      }).then(function (resp) {
	        _this2.rechargeValue = r;
	        _this2.tax = resp.taxTotal;
	        _this2.waiting = false;
	      }).catch(function (err) {
	        _this2.waiting = false;
	        _this2.tax = "-";
	      });
	    },
	    setTotal: function setTotal(newValue) {
	      this.rechargeValue = newValue.replace(/[^0-9]/g, "");
	      this.calculateRecharge();
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _eventBus = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["contract"],
	  data: function data() {
	    return {
	      rechargeAlter: {},
	      recharge: undefined,
	      loading: undefined
	    };
	  },
	  mounted: function mounted() {
	    this.calculateRecharge();
	  },
	
	  computed: {
	    multiple: function multiple() {
	      return this.getMultipleRecharge();
	    },
	    planId: function planId() {
	      return this.contract.plan.planId;
	    }
	  },
	  methods: {
	    hideModal: function hideModal() {
	      this.rechargeAlter = this.recharge;
	      this.$emit("closeModalRecharge", this.contract.contractId);
	    },
	    alterRechargeUnit: function alterRechargeUnit() {
	      var _this = this;
	
	      this.contract.rechargeValue = this.rechargeAlter.valueTotal;
	      this.loading = _contracts2.default.updateContractValueRecharge(this.contract.contractId, this.rechargeAlter.valueTotal).then(function (data) {
	        _this.$emit("closeModalRecharge", _this.contract.contractId, _this.recharge.valueTotal);
	      });
	    },
	    calculate: function calculate(qtd) {
	      var _this2 = this;
	
	      if (qtd < this.multiple) return;
	      this.loading = _sales2.default.calculateRechargeRate({
	        value: qtd,
	        planId: this.planId,
	        contractId: this.contract.contractId
	      }).then(function (result) {
	        _this2.rechargeAlter = result;
	      });
	    },
	    calculateRecharge: function calculateRecharge() {
	      var _this3 = this;
	
	      this.loading = _sales2.default.calculateRechargeRate({
	        value: this.contract.rechargeValue,
	        planId: this.planId,
	        contractId: this.contract.contractId
	      }).then(function (result) {
	        _this3.recharge = result;
	        _this3.rechargeAlter = _this3.recharge;
	      }).catch(function (err) {
	        _this3.calculate(_this3.multiple);
	      });
	    }
	  }
	};

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNan = __webpack_require__(174);
	
	var _isNan2 = _interopRequireDefault(_isNan);
	
	var _number = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['value', 'hideIncrement', 'step'],
	  data: function data() {
	    return {
	      currentValue: this.value
	    };
	  },
	
	  computed: {
	    getValue: function getValue() {
	
	      if (this.currentValue || this.currentValue == 0) return (0, _number.centss)(this.currentValue);
	
	      return "";
	    }
	  },
	  watch: {
	    value: function value(newValue) {
	      this.currentValue = newValue;
	    }
	  },
	  methods: {
	    alterValue: function alterValue(value) {
	      var newValue = this.currentValue + value;
	
	      if (newValue < 0) return false;
	
	      this.setValue('' + newValue);
	    },
	    setValue: function setValue(newValue) {
	      if (!(0, _isNan2.default)(newValue) && newValue != "") {
	        this.currentValue = parseInt(newValue.replace(/[^0-9]/g, ""));
	        this.$emit("input", this.currentValue);
	      } else {
	        this.currentValue = newValue;
	        this.$emit("input", undefined);
	      }
	    }
	  }
	};

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _eventBus = __webpack_require__(25);
	
	var _refundService = __webpack_require__(240);
	
	var _refundService2 = _interopRequireDefault(_refundService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      name: undefined,
	      companies: undefined,
	      currentUser: _auth2.default.currentUser,
	      parentUser: _auth2.default.parentUser,
	      mainMenu: true,
	      loading: undefined,
	      fixFooter: true,
	      filter: {
	        taxPayerIdNumber: _auth2.default.currentUser.taxIdNumber
	      },
	      refund: false,
	      scrolling: false,
	      is2FA: undefined,
	      showOverlay: true,
	      showOverlayMobile: true,
	      isMobile: false
	    };
	  },
	  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
	    if (to.fullPath.indexOf("meus-planos") !== -1) {
	      this.showOverlayMobile = true;
	      this.showOverlay = true;
	
	      var newLayout = document.querySelector(".new-layout");
	      if (newLayout) {
	        newLayout.style.marginTop = "51";
	      }
	    } else {
	      this.showOverlayMobile = false;
	      this.fecharActionBar();
	    }
	
	    next();
	  },
	
	
	  computed: {
	    isEmbarcador: function isEmbarcador() {
	      return this.$store.state.contract.hasPlanEmbarcador;
	    }
	  },
	
	  methods: {
	    fecharActionBar: function fecharActionBar() {
	      var _this = this;
	
	      this.showOverlay = false;
	      this.showOverlayMobile = false;
	
	      this.$nextTick(function () {
	        _this.removerMarginTop();
	      });
	    },
	    removerMarginTop: function removerMarginTop() {
	      var newLayout = document.querySelector(".new-layout");
	      if (newLayout) {
	        newLayout.style.marginTop = "0";
	      }
	    },
	    logout: function logout() {
	      var _this2 = this;
	
	      _auth2.default.logout().then(function () {
	        return _this2.$router.push("/login");
	      });
	    },
	    changeUser: function changeUser(moveMaisId) {
	      _auth2.default.changeCurrentUser(moveMaisId);
	      this.$router.push({ name: "plans", query: { moveMaisId: moveMaisId } });
	
	      setTimeout(function () {
	        window.location.reload(1);
	      }, 1000);
	    },
	    getChildAccounts: function getChildAccounts(moveMaisId) {
	      var _this3 = this;
	
	      if (this.$route.name == "adhesion") {
	        return;
	      }
	      this.loading = _account2.default.getListChildAccount(_auth2.default.parentUser.moveMaisId).then(function (res) {
	        res.unshift({
	          moveMaisId: _auth2.default.parentUser.moveMaisId,
	          taxIdNumber: _auth2.default.parentUser.taxIdNumber,
	          companyName: _auth2.default.parentUser.company.companyName,
	          companyTradeName: _auth2.default.parentUser.company.companyTradeName
	        });
	        _this3.companies = res;
	      }).catch(function (err) {});
	    },
	    handleScroll: function handleScroll() {
	      var currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
	
	      if (currentScrollPosition > 84) {
	        this.scrolling = true;
	      } else {
	        this.scrolling = false;
	      }
	    }
	  },
	
	  created: function created() {
	    var _this4 = this;
	
	    var updateUser = function updateUser(user) {
	      _this4.currentUser = user;
	    };
	
	    if (this.currentUser.flag2FA == "Y") {
	      this.is2FA = true;
	    } else {
	      this.is2FA = false;
	    }
	
	    _auth2.default.$on("userChanged", function (user) {
	      updateUser(user);
	    });
	
	    _auth2.default.$on("parentUserChanged", function (user) {
	      _this4.parentUser = user;
	      _this4.companies = undefined;
	      if (_auth2.default.parentUser) _this4.getChildAccounts(user.moveMaisId);
	    });
	
	    if (_auth2.default.parentUser) this.getChildAccounts(_auth2.default.parentUser.moveMaisId);
	
	    _eventBus.EventBus.$on("loading", function (l) {
	      _this4.loading = l;
	    });
	  },
	  mounted: function mounted() {
	    var _this5 = this;
	
	    document.addEventListener("scroll", this.handleScroll);
	
	    var vm = this;
	    setTimeout(function () {
	      vm.fixFooter = false;
	      vm.$forceUpdate();
	    }, 2000);
	    this.loading = _refundService2.default.isRefundPassage(this.filter).then(function (resp) {
	      if (resp.refund == 1) {
	        _this5.refund = true;
	      }
	    });
	
	    if (window.innerWidth <= 769) {
	      this.isMobile = true;
	    } else {
	      this.isMobile = false;
	    }
	
	    window.addEventListener("resize", function () {
	      return window.innerWidth <= 769 ? _this5.isMobile = true : _this5.isMobile = false;
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    _auth2.default.$off("userChanged");
	    _auth2.default.$off("parentUserChanged");
	  }
	};

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    unit: Number,
	    planId: [Number, String],
	    roadCardUnit: undefined
	  },
	  data: function data() {
	    return {
	      value: "Carregando...",
	      newValueRoadcard: undefined,
	      valuesRoadCard: []
	    };
	  },
	  created: function created() {
	
	    if ([_constantes2.default.PLAN_MAN_ECONOMICO, _constantes2.default.PLAN_AUT_ECONOMICO].indexOf(this.planId) !== -1) {
	      this.value = _constantes2.default.RECHARGE_UNIT_ECONOMICO * this.unit;
	    } else if (this.planId == _constantes2.default.PLAN_AUT_PJ || this.planId == _constantes2.default.PLAN_MAN_PJ || this.planId == _constantes2.default.PLAN_PRE_SEM_TAXA) {
	      this.value = _constantes2.default.RECHARGE_UNIT_PJ * this.unit;
	    } else if (this.planId == _constantes2.default.PLAN_ROADCARD_PF) {
	      this.newValueRoadcard = this.roadCardUnit * this.unit;
	      this.value = _constantes2.default.RECHARGE_UNIT_ROADCARD_PF * this.newValueRoadcard;
	      this.valuesRoadCard.push(this.value);
	      this.$emit("valoresRecebidos", this.valuesRoadCard);
	    } else if (this.planId == _constantes2.default.PLAN_ROADCARD_PJ) {
	      this.newValueRoadcard = this.roadCardUnit * this.unit;
	      this.value = _constantes2.default.RECHARGE_UNIT_ROADCARD_PJ * this.newValueRoadcard;
	      this.valuesRoadCard.push(this.value);
	      this.$emit("valoresRecebidos", this.valuesRoadCard);
	    } else {
	      this.value = _constantes2.default.RECHARGE_UNIT * this.unit;
	    }
	  },
	
	  methods: {
	    increment: function increment() {
	      if (this.value > 0) this.$emit("increment", this.value);
	    }
	  }
	};

/***/ }),
/* 576 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['order'],
	  data: function data() {
	    return {
	      expanded: false
	    };
	  },
	
	  computed: {
	    urlPayment: function urlPayment() {
	      var urlImage = this.order.paymentMethod.imagePath ? this.order.paymentMethod.imagePath.split('.')[0] : '';
	      return '/static/payment-methods/' + urlImage + '.svg';
	    }
	  },
	  methods: {
	    isDescont: function isDescont(product, value) {
	      return product.productId == 11 ? -1 * value : value;
	    }
	  }
	};

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vehicles = __webpack_require__(29);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	var _ativarTagItem = __webpack_require__(521);
	
	var _ativarTagItem2 = _interopRequireDefault(_ativarTagItem);
	
	var _tag = __webpack_require__(55);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _eventBus = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: undefined,
	      msg: undefined,
	      vehicle: undefined,
	      errorClass: ""
	    };
	  },
	
	  watch: {
	    $route: function $route() {
	      this.activate();
	    }
	  },
	  computed: {
	    plate: function plate() {
	      return this.$route.params.plate;
	    },
	    serial: function serial() {
	      return this.$route.params.serial;
	    }
	  },
	  created: function created() {},
	  mounted: function mounted() {
	
	    this.activate();
	  },
	
	  methods: {
	    activate: function activate() {
	      var _this = this;
	
	      this.msg = undefined;
	      this.loading = _vehicles2.default.getVehiclesForActivate().then(function (responseVehicles) {
	        return responseVehicles.find(function (o) {
	          return o.plate.replace('-', '') == _this.plate.replace('-', '');
	        });
	      }).then(function (v) {
	        _this.vehicle = v;
	
	        if (!v) {
	          _this.msg = "Placa não dísponivel para ativação";
	          _this.errorClass = "alert-danger";
	          return undefined;
	        }
	        var req = {
	          serialNumber: _this.serial,
	          vehicleId: v.vehicleId
	        };
	        return _tag2.default.activateTagSite(req).then(function (resp) {
	          return resp;
	        });
	      }).then(function (r) {
	
	        if (r && r.status) {
	          _this.msg = r.status.message;
	          _this.errorClass = r.status.code == 0 ? 'alert-success' : 'alert-error';
	        }
	      }).catch(function (error) {
	
	        _this.msg = error.data && error.data.status && error.data.status.message || 'Erro';
	        _this.errorClass = 'alert-danger';
	      });
	    }
	  }
	};

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _googleMaps = __webpack_require__(93);
	
	var _googleMaps2 = _interopRequireDefault(_googleMaps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["totalPoints", "initLocation", "sequence", "type"],
	  data: function data() {
	    return {
	      id: "ac" + new Date().getTime(),
	      ac: {},
	      location: this.initLocation,
	      model: undefined
	    };
	  },
	
	  computed: {
	    campos: function campos() {
	      if (this.sequence == 0) return {
	        label: "Origem",
	        placeholder: "Digite um local de origem",
	        iconClass: "pin-origin",
	        inputClass: "form-control input-origin"
	      };else if (this.sequence == this.totalPoints - 1) return {
	        label: "Destino",
	        placeholder: "Digite um local de destino",
	        iconClass: "pin-destination",
	        inputClass: "form-control input-destination"
	      };else return {
	        label: "Passagem " + this.sequence,
	        placeholder: "Digite um local de passagem",
	        iconClass: "pin-waypoint",
	        inputClass: "form-control input-origin"
	      };
	    },
	    invalid: function invalid() {
	      return this.location && this.formatAddressMM(this.location.address) != this.formatAddressMM(this.model);
	    }
	  },
	  mounted: function mounted() {
	    $('[data-toggle="tooltip"]').tooltip();
	    this.location.sequence = this.sequence + 1;
	    var vm = this;
	    var options = {
	      strictBounds: true,
	      bounds: this.restriction,
	      suppressMarkers: true
	    };
	    vm.model = this.location && this.location.address;
	    _googleMaps2.default.KEY = "AIzaSyAzAwCX1zCJ9idWkNdxs39j36N4lAToIjE";
	    _googleMaps2.default.LIBRARIES = ["places"];
	    _googleMaps2.default.load(function (google) {
	      vm.ac = new google.maps.places.Autocomplete(vm.$refs.input, options);
	      google.maps.event.addListener(vm.ac, "place_changed", function () {
	        vm.model = vm.formatAddressMM(vm.ac.getPlace().formatted_address);
	        vm.location = vm.placeToPointLocation(vm.ac.getPlace());
	      });
	    });
	  },
	
	  watch: {
	    initLocation: function initLocation(newVal) {
	      this.location = newVal;
	      this.model = this.location && this.location.address;
	    },
	    model: function model() {
	      this.$emit("placeChanged");
	    },
	    sequence: function sequence() {
	      this.location.sequence = this.sequence + 1;
	    }
	  },
	  methods: {
	    formatAddressMM: function formatAddressMM(a) {
	      if (a) return a.replace(/[0-9]{5}-000,/, "");
	    },
	    validate: function validate() {
	      var _this = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        if (_this.model && _this.location && _this.formatAddressMM(_this.location.address) == _this.formatAddressMM(_this.model)) resolve(true);
	
	        reject(false);
	      });
	    },
	    placeToPointLocation: function placeToPointLocation(place) {
	      var vm = this;
	      var p = this.location;
	      _.each(place.address_components, function (o) {
	        if (_.indexOf(o.types, "postal_code") >= 0) p.zipCode = o.short_name.replace(/[^0-9]/g, "");else if (_.indexOf(o.types, "administrative_area_level_1") >= 0) p.state = o.short_name;else if (_.indexOf(o.types, "administrative_area_level_2") >= 0) p.city = o.short_name;else if (_.indexOf(o.types, "sublocality") >= 0) p.neighborhood = o.short_name;else if (_.indexOf(o.types, "route") >= 0) p.address = o.short_name;else if (_.indexOf(o.types, "street_number") >= 0) p.number = o.short_name;else if (_.indexOf(o.types, "country") >= 0) p.country = o.short_name;
	      });
	      try {
	        p.address = this.formatAddressMM(place.formatted_address);
	        p.lat = place.geometry.location.lat();
	        p.lng = place.geometry.location.lng();
	      } catch (err) {}
	      return p;
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNan = __webpack_require__(174);
	
	var _isNan2 = _interopRequireDefault(_isNan);
	
	var _number = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["value", 'hideIncrement', 'favored', 'balance'],
	  data: function data() {
	    return {
	      currentValue: this.value
	    };
	  },
	  mounted: function mounted() {},
	
	  computed: {
	    getValue: function getValue() {
	
	      if (this.currentValue || this.currentValue == 0) return (0, _number.centss)(this.currentValue);
	
	      return "";
	    },
	    checkTransferValue: function checkTransferValue() {
	      return this.currentValue * 1.02 > this.balance;
	    }
	  },
	  watch: {
	    value: function value(newValue) {
	      this.currentValue = newValue;
	    }
	  },
	  methods: {
	    alterValue: function alterValue(value) {
	      var newValue = this.currentValue + value;
	
	      if (newValue < 0) return false;
	
	      this.setValue('' + newValue);
	    },
	    setValue: function setValue(newValue) {
	      if (!(0, _isNan2.default)(newValue) && newValue != "") {
	        this.currentValue = parseInt(newValue.replace(/[^0-9]/g, ""));
	        this.$emit("input", this.currentValue);
	      } else {
	        this.currentValue = newValue;
	        this.$emit("input", undefined);
	      }
	    }
	  }
	};

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _success = __webpack_require__(47);
	
	var _success2 = _interopRequireDefault(_success);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            valorDebitado: undefined,
	            cpm: undefined
	        };
	    },
	
	    computed: {
	        order: function order() {
	            return { contractPaymentMethod: this.cpm };
	        }
	    },
	    mounted: function mounted() {
	        this.cpm = sessionStorage.getItem("validar-cartao");
	        sessionStorage.removeItem("validar-cartao");
	
	        if (!this.cpm) {
	            this.$router.push({ name: 'plans' });
	        }
	        this.cpm = JSON.parse(this.cpm);
	    },
	
	    components: { successPage: _success2.default }
	};

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['type', 'address'],
	  data: function data() {
	    return {
	      loadingAddress: undefined,
	      errorCep: undefined
	    };
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.address.type = this.type;
	
	    if (this.address.zipCode && (this.address.address == undefined || this.address.address.length == 0)) this.queryAddress();
	
	    this.$watch('address', function () {
	      var vm = _this;
	      setTimeout(function () {
	        vm.$validator.validateAll().then(function () {
	          vm.address.validForm = true;
	        }).catch(function (err) {
	          vm.address.validForm = false;
	        });
	      }, 300);
	    }, { deep: true });
	  },
	  methods: {
	    queryAddress: function queryAddress() {
	      var _this2 = this;
	
	      this.errorCep = undefined;
	      this.loadingAddress = _account2.default.queryAddress(this.address.zipCode).then(function (resp) {
	        var addressId = _this2.address.addressId;
	        var a = resp;
	
	        _this2.address.address = a.address;
	        _this2.address.city = a.city;
	        _this2.address.neighborhood = a.neighborhood;
	        _this2.address.state = a.state;
	        _this2.address.zipCode = a.zipCode;
	
	        if (_this2.address.address.length == 0 && _this2.address.neighborhood.length == 0) _this2.address.number = '';
	      }).catch(function (err) {
	
	        _this2.errorCep = err.data.status.message;
	        _this2.$validator.validateAll();
	      });
	    },
	    queryAddressTyping: function queryAddressTyping() {
	      if (this.address.zipCode.length < 8) return;
	
	      this.queryAddress();
	    }
	  }
	};

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _financial = __webpack_require__(54);
	
	var _financial2 = _interopRequireDefault(_financial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['code', 'stepPayment', 'type', 'taxIdNumber', 'password', 'salesOrder', 'validacaoFraude', 'boletoUrl', 'msgErrorResp', 'cmpId'],
	
	  data: function data() {
	    return {
	      loading: undefined,
	      flag: 0,
	      mensagem: undefined
	    };
	  },
	
	  methods: {
	    getReprocessOrderId: function getReprocessOrderId() {
	      if (this.salesOrder && this.salesOrder.salesOrderId) {
	        return this.salesOrder.salesOrderId;
	      }
	      if (this.salesOrder && this.salesOrder.orderId) {
	        return this.salesOrder.orderId;
	      }
	      if (this.$route && this.$route.params && this.$route.params.orderId) {
	        return this.$route.params.orderId;
	      }
	      return undefined;
	    },
	    paraPlanos: function paraPlanos() {
	      this.$router.push({ name: 'plans' });
	    },
	    paraPedidos: function paraPedidos() {
	      var orderId = this.salesOrder && this.salesOrder.salesOrderId;
	      if (orderId) {
	        this.$router.push({ name: 'reprocess-order', params: { orderId: orderId } });
	      } else {
	        this.$router.push({ name: 'plans' });
	      }
	    },
	    paraPedidosReprocessamento: function paraPedidosReprocessamento() {
	      var salesOrderId = this.getReprocessOrderId();
	      if (!salesOrderId) {
	        this.$router.push({ name: 'plans' });
	        return;
	      }
	
	      this.loading = _financial2.default.reprocessPayout({ salesOrderId: salesOrderId });
	    },
	    doLogin: function doLogin() {
	      var _this = this;
	
	      var username = this.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase();
	      this.loading = _auth2.default.login(username, this.password).then(function (user) {
	        var orderId = _this.salesOrder && _this.salesOrder.salesOrderId;
	        if (user.otherSalesReference === 'REPOM') {
	          _this.$router.push({
	            name: 'repom'
	          });
	        } else if (orderId) {
	          _this.$router.push({ name: 'reprocess-order', params: { orderId: orderId } });
	        } else {
	          _this.$router.push({ name: 'plans' });
	        }
	      }).catch(function (err) {
	        _this.errorMessage = err.status && err.data.status && err.data.status.message || "Erro do servidor.";
	      });
	    }
	  }
	};

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _qrcode = __webpack_require__(1700);
	
	var _qrcode2 = _interopRequireDefault(_qrcode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["code", "boletoUrl", "type", "novoCartao", "newPix", "contractPaymentMethodId", "salesOrder", "pixCopiaCola", "usuario", "validado"],
	  data: function data() {
	    return {
	      valorDebitado: undefined,
	      isMobile: true,
	      isQRCopied: false,
	      msgErro: ""
	    };
	  },
	  created: function created() {
	    var vm = this;
	    this.isMobile = $(window).width() < 1140;
	    $(window).resize(function () {
	      vm.isMobile = $(window).width() < 1140;
	    });
	  },
	  mounted: function mounted() {
	    if (this.type !== "replaceTag" && this.boletoUrl && this.boletoUrl != "0") {
	      window.open(this.boletoUrl);
	    }
	
	    if (this.pixCopiaCola) {
	      var btnCopyQRCode = document.getElementById("qrcode");
	      btnCopyQRCode.addEventListener("click", this.copyQRCodePix(this.pixCopiaCola));
	      this.isQRCopied = false;
	    }
	  },
	
	
	  methods: {
	    copyQRCode: function copyQRCode() {
	      var _this = this;
	
	      this.isQRCopied = false;
	      navigator.clipboard.writeText(this.pixCopiaCola).then(function () {
	        _this.isQRCopied = true;
	        setTimeout(function () {
	          _this.isQRCopied = false;
	        }, 3000);
	      }).catch(function () {
	        console.log("Não foi possível copiar a string QR Code.");
	      });
	    },
	    copyQRCodePix: function copyQRCodePix(pixCopiaCola) {
	      var _this2 = this;
	
	      this.isQRCopied = false;
	      var tempInput = document.createElement("input");
	      tempInput.value = pixCopiaCola;
	      document.body.appendChild(tempInput);
	      tempInput.select();
	      document.execCommand("copy");
	      document.body.removeChild(tempInput);
	      this.isQRCopied = true;
	      setTimeout(function () {
	        _this2.isQRCopied = false;
	      }, 3000);
	    },
	    showModalSucesso: function showModalSucesso() {
	      var vm = this;
	
	      window.setTimeout(function () {
	        $("#modalSuccessAdhesion").modal();
	        $("#modalSuccessAdhesion").on("hidden.bs.modal", function (e) {
	          vm.$router.push({ name: "plans" });
	        });
	      }, 500);
	    },
	    confirmCard: function confirmCard() {
	      var _this3 = this;
	
	      var valor = this.valorDebitado.replace(/[^0-9]*/g, "");
	      if (valor == 100) {
	        return _messageDialog2.default.show({
	          title: "Info",
	          headerClass: "modal-info",
	          message: "Valor cobrado deve ser entre 1,01 e 1,99"
	        }).then(function (r) {
	          _this3.valorDebitado = null;
	          $("#valor-debitado").modal();
	        });
	      }
	      if (this.valorDebitado) {
	        _messageDialog2.default.show({
	          title: "Info",
	          headerClass: "modal-info",
	          type: "YES-NO",
	          message: "Tem certeza que o valor debitado foi " + this.valorDebitado + "?"
	        }).then(function (e) {
	          if (e == "YES") {
	            var req = {
	              chargeValue: valor,
	              contractPaymentMethodId: _this3.salesOrder.contractPaymentMethod.contractPaymentMethodId
	            };
	            _sales2.default.checkChargeValue(req).then(function (resp) {
	              var validaValor = resp.code;
	              if (validaValor == 0) {
	                _this3.showModalSucesso();
	              }
	            }).catch(function (erro) {
	              var error = erro.data.status.code;
	              var salesOrder = erro.data.salesOrder;
	              if (error == 1) {
	                if (_this3.primeiroCartao) {
	                  _this3.erroDebito = 2;
	                  $("#info-block").modal("hide");
	                } else {
	                  _this3.erroDebito = 1;
	
	                  if (salesOrder) {
	                    _this3.msgErro = "Valor informado incorreto, pedido " + salesOrder.salesOrderId + " será cancelado.";
	                  } else _this3.msgErro = "Valor informado incorreto,cartão cadastrado cancelado.";
	                }
	              } else if (error == 2) {
	                if (_this3.primeiroCartao) {
	                  _this3.erroDebito = 1;
	                  _this3.msgErro = "O prazo de validação do cartão expirou. Favor realizar um novo cadastro.";
	                  $("#info-block").modal("hide");
	                } else {
	                  _this3.erroDebito = 1;
	                  _this3.msgErro = "O prazo de validação do cartão expirou. Favor realizar um novo cadastro.";
	                }
	              } else if (error == 3) {
	                _this3.erroDebito = 1;
	                _this3.msgErro = "O prazo de validação do cartão expirou. Favor realizar um novo pedido.";
	              } else {
	                _this3.erroDebito = 1;
	                if (erro.data.status.message) {
	                  _this3.msgErro = "Ocorreu um erro na validação do valor debitado.";
	                } else _this3.msgErro = "Erro ao validar, favor entrar em contato com a CR!";
	              }
	            });
	          }
	        });
	      } else {
	        _messageDialog2.default.show({
	          title: "Info",
	          headerClass: "modal-info",
	          message: "Por favor digite um valor numerico valido"
	        }).then(function (r) {
	          _this3.valorDebitado = null;
	        });
	      }
	    }
	  },
	  components: {
	    QrcodeVue: _qrcode2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 584 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      isMobile: false
	    };
	  },
	
	  name: "YourComponentName",
	  mounted: function mounted() {
	    var _this = this;
	
	    var script = document.createElement("script");
	    script.src = "https://s3.amazonaws.com/raichu-beta/selos/bundle.js";
	    script.id = "ra-embed-reputation";
	    script.dataset.id = "ODIyNjU6bW92ZS1tYWlz";
	    script.dataset.target = "reputation-ra";
	    script.dataset.model = "2";
	    document.head.appendChild(script);
	
	    if (window.innerWidth <= 769) {
	      this.isMobile = true;
	    } else {
	      this.isMobile = false;
	    }
	
	    window.addEventListener("resize", function () {
	      return window.innerWidth <= 769 ? _this.isMobile = true : _this.isMobile = false;
	    });
	  }
	};

/***/ }),
/* 585 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      elemento: undefined
	    };
	  },
	
	
	  methods: {
	    scrollToElement: function scrollToElement(id) {
	      if (id == "footer") {
	        this.elemento = document.getElementById("footer-hotsite");
	      }
	      if (id == "planos") {
	        this.elemento = document.getElementById("plans-title");
	      }
	
	      if (id == "beneficios") {
	        this.elemento = document.getElementById("beneficios-container");
	      }
	      if (this.elemento) {
	        this.elemento.scrollIntoView({ behavior: "smooth" });
	      }
	    }
	  }
	};

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueScrollto = __webpack_require__(2228);
	
	var _vueScrollto2 = _interopRequireDefault(_vueScrollto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      roadCardPJ: config.roadCardPJ,
	      showModal: false };
	  },
	
	
	  directives: {
	    scrollTo: _vueScrollto2.default.directive
	  },
	  methods: {
	    scrollToFooter: function scrollToFooter() {
	      _vueScrollto2.default.scrollTo("#planInfoContainer", 500);
	    }
	  }
	};

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    numeroContrato: undefined,
	    idUsuario: undefined
	  },
	  data: function data() {
	    return {
	      motivo: "",
	      errorMessage: undefined,
	      errorMessageChargeback: undefined,
	      mostrarModal: true,
	      isMobile: false,
	      recarga1: undefined,
	      recarga2: undefined,
	      recarga3: undefined,
	      recarga4: undefined,
	      recarga5: undefined,
	      recarga6: undefined,
	      recarga7: undefined,
	      recarga8: undefined,
	      recarga9: undefined,
	      recarga10: undefined,
	      recarga11: undefined
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    if (window.innerWidth <= 769) {
	      this.isMobile = true;
	    } else {
	      this.isMobile = false;
	    }
	
	    window.addEventListener("resize", function () {
	      return window.innerWidth <= 769 ? _this.isMobile = true : _this.isMobile = false;
	    });
	
	    _contracts2.default.getRechargesRoadcard(70).then(function (res) {
	      _this.recarga1 = res.plano.recargas[0];
	      _this.recarga2 = res.plano.recargas[1];
	      _this.recarga3 = res.plano.recargas[2];
	      _this.recarga4 = res.plano.recargas[3];
	      _this.recarga5 = res.plano.recargas[4];
	      _this.recarga6 = res.plano.recargas[5];
	      _this.recarga7 = res.plano.recargas[6];
	      _this.recarga8 = res.plano.recargas[7];
	      _this.recarga9 = res.plano.recargas[8];
	      _this.recarga10 = res.plano.recargas[9];
	      _this.recarga11 = res.plano.recargas[10];
	    });
	  },
	
	  methods: {
	    fecharModal: function fecharModal() {
	      this.$emit("fechar-modal");
	      this.mostrarModal = false;
	    }
	  }
	};

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    numeroContrato: undefined,
	    idUsuario: undefined
	  },
	  data: function data() {
	    return {
	      motivo: "",
	      errorMessage: undefined,
	      errorMessageChargeback: undefined,
	      mostrarModal: true,
	      isMobile: false,
	      recarga1: undefined,
	      recarga2: undefined,
	      recarga3: undefined,
	      recarga4: undefined,
	      recarga5: undefined,
	      recarga6: undefined,
	      recarga7: undefined,
	      recarga8: undefined,
	      recarga9: undefined,
	      recarga10: undefined,
	      recarga11: undefined
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    window.addEventListener("scroll", function () {
	      return window.scrollY > 0 ? _this.isScrolling = true : _this.isScrolling = false;
	    });
	
	    if (window.innerWidth <= 769) {
	      this.isMobile = true;
	    } else {
	      this.isMobile = false;
	    }
	
	    window.addEventListener("resize", function () {
	      return window.innerWidth <= 769 ? _this.isMobile = true : _this.isMobile = false;
	    });
	
	    _contracts2.default.getRechargesRoadcard(71).then(function (res) {
	      _this.recarga1 = res.plano.recargas[0];
	      _this.recarga2 = res.plano.recargas[1];
	      _this.recarga3 = res.plano.recargas[2];
	      _this.recarga4 = res.plano.recargas[3];
	      _this.recarga5 = res.plano.recargas[4];
	      _this.recarga6 = res.plano.recargas[5];
	      _this.recarga7 = res.plano.recargas[6];
	      _this.recarga8 = res.plano.recargas[7];
	      _this.recarga9 = res.plano.recargas[8];
	      _this.recarga10 = res.plano.recargas[9];
	      _this.recarga11 = res.plano.recargas[10];
	    });
	  },
	
	  methods: {
	    fecharModal: function fecharModal() {
	      this.$emit("fechar-modal");
	      this.mostrarModal = false;
	    }
	  }
	};

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modalRechargesPj = __webpack_require__(1985);
	
	var _modalRechargesPj2 = _interopRequireDefault(_modalRechargesPj);
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    ModalRechargePj: _modalRechargesPj2.default
	  },
	  data: function data() {
	    return {
	      roadCardPJ: undefined,
	      showModal: false,
	      detalhe1: undefined,
	      detalhe2: undefined,
	      detalhe3: undefined,
	      detalhe4: undefined,
	      detalhe5: undefined,
	      detalhe6: undefined
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _contracts2.default.getRechargesRoadcard(71).then(function (res) {
	      _this.detalhe1 = res.plano.detalhes[0];
	      _this.detalhe2 = res.plano.detalhes[1];
	      _this.detalhe3 = res.plano.detalhes[2];
	      _this.detalhe4 = res.plano.detalhes[3];
	      _this.detalhe5 = res.plano.detalhes[4];
	      _this.detalhe6 = res.plano.detalhes[5];
	
	      console.log("detalhe4", _this.detalhe4);
	      console.log("detalhe5", _this.detalhe5);
	
	      var detalhe1 = document.getElementById("detalhe1");
	      detalhe1.innerHTML = _this.detalhe1;
	
	      var detalhe2 = document.getElementById("detalhe2");
	      detalhe2.innerHTML = _this.detalhe2;
	
	      var detalhe3 = document.getElementById("detalhe3");
	      detalhe3.innerHTML = _this.detalhe3;
	
	      var detalhe4 = document.getElementById("detalhe4");
	      detalhe4.innerHTML = _this.detalhe4;
	
	      var detalhe5 = document.getElementById("detalhe5");
	      detalhe5.innerHTML = _this.detalhe5;
	
	      var detalhe6 = document.getElementById("detalhe6");
	      detalhe6.innerHTML = _this.detalhe6;
	    });
	    this.getRoadCardUrl();
	  },
	
	  methods: {
	    getRoadCardUrl: function getRoadCardUrl() {
	      var _this2 = this;
	
	      _contracts2.default.getGeneralParameter("URL_ATHENA_PJ").then(function (res) {
	        _this2.roadCardPJ = res.value;
	      });
	    },
	    abrirModal: function abrirModal() {
	      this.showModal = true;
	      document.body.style.overflow = "hidden";
	    },
	    fecharModal: function fecharModal() {
	      this.showModal = false;
	      document.body.style.overflow = "";
	    }
	  }
	};

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _modalRecharges = __webpack_require__(1984);
	
	var _modalRecharges2 = _interopRequireDefault(_modalRecharges);
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    ModalRecharge: _modalRecharges2.default
	  },
	  data: function data() {
	    return {
	      roadCardPF: undefined,
	      showModal: false,
	      detalhe1: undefined,
	      detalhe2: undefined,
	      detalhe3: undefined,
	      detalhe4: undefined,
	      detalhe5: undefined,
	      detalhe6: undefined
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.getRoadCardUrl();
	
	    _contracts2.default.getRechargesRoadcard(70).then(function (res) {
	      _this.detalhe1 = res.plano.detalhes[0];
	      _this.detalhe2 = res.plano.detalhes[1];
	      _this.detalhe3 = res.plano.detalhes[2];
	      _this.detalhe4 = res.plano.detalhes[3];
	      _this.detalhe5 = res.plano.detalhes[4];
	      _this.detalhe6 = res.plano.detalhes[5];
	
	      console.log("detalhe4", _this.detalhe4);
	      console.log("detalhe5", _this.detalhe5);
	
	      var detalhe1 = document.getElementById("detalhe1PF");
	      detalhe1.innerHTML = _this.detalhe1;
	
	      var detalhe2 = document.getElementById("detalhe2PF");
	      detalhe2.innerHTML = _this.detalhe2;
	
	      var detalhe3 = document.getElementById("detalhe3PF");
	      detalhe3.innerHTML = _this.detalhe3;
	
	      var detalhe4 = document.getElementById("detalhe4PF");
	      detalhe4.innerHTML = _this.detalhe4;
	
	      var detalhe5 = document.getElementById("detalhe5PF");
	      detalhe5.innerHTML = _this.detalhe5;
	
	      var detalhe6 = document.getElementById("detalhe6PF");
	      detalhe6.innerHTML = _this.detalhe6;
	    });
	  },
	
	  methods: {
	    getRoadCardUrl: function getRoadCardUrl() {
	      var _this2 = this;
	
	      _contracts2.default.getGeneralParameter("URL_ATHENA_PF").then(function (res) {
	        _this2.roadCardPF = res.value;
	      });
	    },
	    abrirModal: function abrirModal() {
	      this.showModal = true;
	      document.body.style.overflow = "hidden";
	    },
	    fecharModal: function fecharModal() {
	      this.showModal = false;
	      document.body.style.overflow = "";
	    }
	  }
	};

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _planInfo = __webpack_require__(1986);
	
	var _planInfo2 = _interopRequireDefault(_planInfo);
	
	var _planInfoPF = __webpack_require__(1987);
	
	var _planInfoPF2 = _interopRequireDefault(_planInfoPF);
	
	var _footer = __webpack_require__(1981);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    PlanInfo: _planInfo2.default,
	    Footer: _footer2.default,
	    PlanInfoPf: _planInfoPF2.default
	  },
	
	  data: function data() {
	    return {
	      isMobile: undefined,
	      isAdhesionFree: undefined
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _contracts2.default.getRoadcardTax().then(function (res) {
	      _this.isAdhesionFree = res;
	    });
	
	    var screenWidth = window.innerWidth;
	    var screenHeight = window.innerHeight;
	
	    if (screenWidth <= 600) {
	      this.isMobile = true;
	    } else {
	      this.isMobile = false;
	    }
	  }
	};

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _plans = __webpack_require__(1988);
	
	var _plans2 = _interopRequireDefault(_plans);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Plans: _plans2.default
	  },
	
	  data: function data() {
	    return {
	      isHotSite: undefined
	    };
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _address = __webpack_require__(84);
	
	var _address2 = _interopRequireDefault(_address);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['valueStart', 'planId'],
	  data: function data() {
	    return {
	      bankAccount: {
	        agencyNumber: "",
	        accountNumber: "",
	        accountDigit: "",
	        paymentMethod: {
	          paymentMethodId: ""
	        }
	      },
	      itemSelected: undefined,
	      options: []
	    };
	  },
	
	  created: function created() {
	    var _this = this;
	
	    if (this.valueStart) {
	      this.bankAccount = this.valueStart;
	    }
	
	    this.$watch('bankAccount', function () {
	      _this.emitBankAccount();
	    }, { deep: true });
	
	    this.options = this.$store.getters.getBankOptionsByPlan(this.planId);
	  },
	  computed: {
	    selectOption: function selectOption() {
	      if (this.bankAccount && this.bankAccount.paymentMethodId) return this.bankAccount.paymentMethodId;
	
	      if (this.options && this.options.length) return this.options[0].paymentMethodId;
	
	      return "";
	    }
	  },
	
	  methods: {
	    onItemSelected: function onItemSelected(item) {
	
	      this.itemSelected = item;
	      this.emitBankAccount();
	    },
	    emitBankAccount: function emitBankAccount() {
	      var vm = this;
	      if ('item selecionado ', vm.itemSelected) {
	
	        vm.bankAccount.paymentMethod = {};
	        vm.bankAccount.paymentMethod.paymentMethodId = vm.itemSelected.paymentMethodId;
	        vm.bankAccount.validForm = true;
	        vm.bankAccount.imagePath = vm.itemSelected.imagePath;
	        vm.bankAccount.name = vm.itemSelected.name;
	      }
	      vm.$emit('input', vm.bankAccount);
	    }
	  },
	  components: {
	    addressComp: _address2.default
	  }
	};

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _stringify = __webpack_require__(70);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _address = __webpack_require__(84);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _objects = __webpack_require__(44);
	
	var objectsStructure = _interopRequireWildcard(_objects);
	
	var _utils = __webpack_require__(34);
	
	var Utils = _interopRequireWildcard(_utils);
	
	var _messageDialog = __webpack_require__(53);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _eventBus = __webpack_require__(25);
	
	var _financial = __webpack_require__(54);
	
	var _financial2 = _interopRequireDefault(_financial);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['showCvv', 'options', 'valueStart', 'addressStart', 'planId'],
	  data: function data() {
	    return {
	      address: objectsStructure.address(),
	      creditCard: { ownerName: "", number: "", expirationMonth: "", expirationYear: "", cvv: "", brand: "", paymentMethodId: "" },
	      months: [],
	      years: [],
	      itemSelected: undefined,
	      dateTime: undefined,
	      brand: undefined,
	      thisYear: undefined,
	      ops: undefined,
	      metodosDePagamento: []
	    };
	  },
	
	  watch: {
	    brand: function brand(newVal) {
	      var opt = _.find(this.options, function (o) {
	        return o.name == newVal;
	      });
	      this.emitCreditCard();
	      this.errorBrand();
	    }
	  },
	  created: function created() {
	
	    if (this.addressStart) {
	      this.address = JSON.parse((0, _stringify2.default)(this.addressStart));
	      this.address.addressId = undefined;
	    }
	
	    if (this.valueStart) {
	      this.itemSelected = this.creditCard = this.valueStart;
	      this.emitCreditCard();
	    }
	
	    for (var i = 1; i < 13; i++) {
	      this.months.push({ value: i, caption: i });
	    }
	    var currentYear = parseInt(new Date().getFullYear());
	    for (var _i = currentYear; _i < currentYear + 30; _i++) {
	      this.years.push({ value: _i, caption: _i });
	    }
	
	    this.ops = this.getMeiosDePagamento();
	  },
	  computed: {
	    selectOption: function selectOption() {
	      if (this.creditCard && this.creditCard.paymentMethodId) return this.creditCard.paymentMethodId;
	
	      return this.options[0].paymentMethodId;
	    },
	    showElo: function showElo() {
	      var p = this.$store.getters.getAllPayments;
	      if (p) {
	        return p["Elo"];
	      };
	      return false;
	    },
	    checkPromoSenff: function checkPromoSenff() {
	      if (sessionStorage.getItem('promoCheck') == '#SENFF2020') return true;
	    }
	  },
	
	  mounted: function mounted() {
	    this.thisYear = new Date().getFullYear();
	  },
	
	  methods: {
	    getMeiosDePagamento: function getMeiosDePagamento() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var meios, Arr;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _financial2.default.getMeiosDePagamentoAdesao(_this.planId);
	
	              case 2:
	                meios = _context.sent;
	                Arr = meios.data.list;
	
	
	                _this.metodosDePagamento = meios.data.list;
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    errorBrand: function errorBrand() {
	      if (this.brand == '' || this.brand == undefined) {
	        document.getElementById('msg-error-brand').style.display = 'block';
	      } else {
	        document.getElementById('msg-error-brand').style.display = 'none';
	      }
	    },
	    select: function select(brand) {
	      switch (brand) {
	        case "visa":
	          this.creditCard.paymentMethodId = 6;
	          this.brand = "Visa";
	          this.itemSelected = {
	            active: "1",
	            caption: "Visa",
	            imagePath: "visa.svg",
	            name: "Visa",
	            paymentMethodId: 6,
	            type: "CC",
	            value: 6
	          };
	          break;
	        case "master":
	          this.creditCard.paymentMethodId = 7;
	          this.brand = "Mastercard";
	          this.itemSelected = {
	            active: "1",
	            caption: "Mastercard",
	            imagePath: "master.svg",
	            name: "Mastercard",
	            paymentMethodId: 7,
	            type: "CC",
	            value: 7
	          };
	          break;
	        case 'amex':
	          this.creditCard.paymentMethodId = 8;
	          this.brand = "American Express";
	          this.itemSelected = {
	            active: "1",
	            caption: "American Express",
	            imagePath: "amex.svg",
	            name: "American Express",
	            paymentMethodId: 8,
	            type: "CC",
	            value: 8
	          };
	          break;
	        case 'elo':
	          this.creditCard.paymentMethodId = 10;
	          this.brand = "Elo";
	          this.itemSelected = {
	            active: "1",
	            caption: "Elo",
	            imagePath: "elo.svg",
	            name: "Elo",
	            paymentMethodId: 10,
	            type: "CC",
	            value: 10
	          };
	          break;
	        case 'Hipercard':
	          this.creditCard.paymentMethodId = 11;
	          this.brand = "HiperCard";
	          this.itemSelected = {
	            active: "1",
	            caption: "HiperCard",
	            imagePath: "Hipercard.svg",
	            name: "HiperCard",
	            paymentMethodId: 11,
	            type: "CC",
	            value: 11
	          };
	          break;
	        case 'Senff':
	          this.creditCard.paymentMethodId = 22;
	          this.brand = "Senff";
	          this.itemSelected = {
	            active: "1",
	            caption: "Senff",
	            imagePath: "senff.svg",
	            name: "Senff",
	            paymentMethodId: 22,
	            type: "CC",
	            value: 22
	          };
	          break;
	      }
	    },
	    getPayment: function getPayment() {
	      var _this2 = this;
	
	      var vm = this;
	
	      var p = this.creditCard;
	      return this.$validator.validateAll().then(function (success) {
	        return vm.$refs.addressBilling.$validator.validateAll().then(function (s) {
	          p.paymentMethod = { paymentMethodId: p.paymentMethodId };
	          p.billingAddress = _this2.address;
	          _eventBus.EventBus.$emit('setPayment', p);
	          return p;
	        });
	      });
	    },
	    onItemSelected: function onItemSelected(item) {
	      this.itemSelected = item;
	      this.emitCreditCard();
	    },
	    emitCreditCard: function emitCreditCard() {
	      var vm = this;
	      if (vm.itemSelected) {
	        vm.creditCard.paymentMethodId = vm.itemSelected.paymentMethodId;
	        vm.creditCard.imagePath = vm.itemSelected.imagePath;
	        vm.creditCard.validForm = true;
	        vm.creditCard.billingAddress = vm.address;
	        vm.creditCard.brand = vm.itemSelected.name;
	      }
	      vm.$emit('input', vm.creditCard);
	    },
	    validateAll: function validateAll() {
	      var vm = this;
	
	      if (!(0, _utils.validateCreditCard)(this.creditCard.expirationMonth, this.creditCard.expirationYear)) {
	        _messageDialog2.default.show({
	          title: 'Info',
	          message: 'Data de validade do cartão inválida.'
	        });
	
	        return false;
	      }
	
	      return this.$validator.validateAll().then(function (r) {
	        return r;
	      }).then(function (r) {
	        return vm.$refs.addressBilling.$validator.validateAll();
	      });
	    },
	    getCardBrand: function getCardBrand(value, value2, value3) {
	      this.brand = Utils.getCardBrand(value.currentTarget.value);
	    },
	    imageUrl: function imageUrl() {
	      if (this.creditCard && this.creditCard.imagePath) return '/static/payment-methods/' + this.creditCard.imagePath.split('.')[0] + '.svg';
	      return "";
	    },
	    showBandeira: function showBandeira(band) {
	      var paymentMapping = {
	        'Visa': 6,
	        'Mastercard': 7,
	        'Elo': 10,
	        'HiperCard': 11
	      };
	      var requiredPaymentMethodId = paymentMapping[band];
	
	      if (!this.metodosDePagamento || !this.metodosDePagamento.length) return false;
	
	      return this.metodosDePagamento.some(function (pm) {
	        return pm.paymentMethodId === requiredPaymentMethodId && pm.displaySite === 'Y';
	      });
	    }
	  },
	  components: {
	    addressComp: _address2.default
	  }
	};

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  mounted: function mounted() {
	    var el = $(this.$el);
	    el.find('.question-box h4').click(function () {
	      el.find('.open').removeClass('open');
	      $(this).find('i').addClass('open');
	      $(this).parent().find('.answer-box').addClass('open');
	    });
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var wideSvg = __webpack_require__(1702);
	var mobSvg = __webpack_require__(1701);
	
	exports.default = {
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	  mounted: function mounted() {
	    this.resize();
	  },
	
	
	  methods: {
	    resize: function resize() {
	      var vm = this;
	      var svgW = $(wideSvg);
	      var svgM = $(mobSvg);
	
	      if ($(window).width() < 750) svgM.appendTo(this.$el);else svgW.appendTo(this.$el);
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var wideSvg = __webpack_require__(1704);
	var mobSvg = __webpack_require__(1703);
	
	exports.default = {
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	  mounted: function mounted() {
	    this.resize();
	  },
	
	
	  methods: {
	    resize: function resize() {
	      var vm = this;
	      var svgW = $(wideSvg);
	      var svgM = $(mobSvg);
	
	      if ($(window).width() < 750) svgM.appendTo(this.$el);else svgW.appendTo(this.$el);
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    scroll: function scroll(id) {
	      $('html, body').stop().animate({
	        scrollTop: $("#" + id).offset().top - 110
	      }, 1000);
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _getIterator2 = __webpack_require__(69);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _vueCarousel = __webpack_require__(1869);
	
	var _documents = __webpack_require__(234);
	
	var _documents2 = _interopRequireDefault(_documents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      isMobile: false,
	      svgListFinal: []
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.isMobile = $(window).width() < 760;
	    $(window).resize(function () {
	      var wasMobile = _this.isMobile;
	      _this.isMobile = $(window).width() < 760;
	      if (wasMobile !== _this.isMobile) {
	        _this.fetchDocuments();
	      }
	    });
	
	    window.addEventListener("beforeunload", this.clearCache);
	  },
	  mounted: function mounted() {
	    this.fetchDocuments();
	  },
	
	
	  methods: {
	    fetchDocuments: function fetchDocuments() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var cacheName, filteredDocuments, cache, svgArray, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, doc, response, svgContent;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                cacheName = "svgCache";
	                filteredDocuments = _documents2.default.filter(function (document) {
	                  return _this2.isMobile ? document.fileCategoryId === 6 : document.fileCategoryId === 7;
	                });
	
	
	                console.log(filteredDocuments, "filteredDocuments");
	                _context.next = 5;
	                return caches.open(cacheName);
	
	              case 5:
	                cache = _context.sent;
	                svgArray = [];
	                _iteratorNormalCompletion = true;
	                _didIteratorError = false;
	                _iteratorError = undefined;
	                _context.prev = 10;
	                _iterator = (0, _getIterator3.default)(filteredDocuments);
	
	              case 12:
	                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                  _context.next = 35;
	                  break;
	                }
	
	                doc = _step.value;
	                _context.next = 16;
	                return cache.match(doc.urlDocumento);
	
	              case 16:
	                response = _context.sent;
	
	                if (response) {
	                  _context.next = 28;
	                  break;
	                }
	
	                _context.next = 20;
	                return fetch(doc.urlDocumento);
	
	              case 20:
	                response = _context.sent;
	
	                if (!response.ok) {
	                  _context.next = 26;
	                  break;
	                }
	
	                _context.next = 24;
	                return cache.put(doc.urlDocumento, response.clone());
	
	              case 24:
	                _context.next = 28;
	                break;
	
	              case 26:
	                console.error("Falha ao buscar documento: " + doc.urlDocumento);
	                return _context.abrupt("continue", 32);
	
	              case 28:
	                _context.next = 30;
	                return response.text();
	
	              case 30:
	                svgContent = _context.sent;
	
	                svgArray.push(svgContent);
	
	              case 32:
	                _iteratorNormalCompletion = true;
	                _context.next = 12;
	                break;
	
	              case 35:
	                _context.next = 41;
	                break;
	
	              case 37:
	                _context.prev = 37;
	                _context.t0 = _context["catch"](10);
	                _didIteratorError = true;
	                _iteratorError = _context.t0;
	
	              case 41:
	                _context.prev = 41;
	                _context.prev = 42;
	
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	
	              case 44:
	                _context.prev = 44;
	
	                if (!_didIteratorError) {
	                  _context.next = 47;
	                  break;
	                }
	
	                throw _iteratorError;
	
	              case 47:
	                return _context.finish(44);
	
	              case 48:
	                return _context.finish(41);
	
	              case 49:
	
	                _this2.svgListFinal = svgArray;
	
	              case 50:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2, [[10, 37, 41, 49], [42,, 44, 48]]);
	      }))();
	    },
	    clearCache: function clearCache() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var cacheNames, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, name;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return caches.keys();
	
	              case 2:
	                cacheNames = _context2.sent;
	                _iteratorNormalCompletion2 = true;
	                _didIteratorError2 = false;
	                _iteratorError2 = undefined;
	                _context2.prev = 6;
	                _iterator2 = (0, _getIterator3.default)(cacheNames);
	
	              case 8:
	                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
	                  _context2.next = 16;
	                  break;
	                }
	
	                name = _step2.value;
	
	                if (!(name === 'svgCache')) {
	                  _context2.next = 13;
	                  break;
	                }
	
	                _context2.next = 13;
	                return caches.delete(name);
	
	              case 13:
	                _iteratorNormalCompletion2 = true;
	                _context2.next = 8;
	                break;
	
	              case 16:
	                _context2.next = 22;
	                break;
	
	              case 18:
	                _context2.prev = 18;
	                _context2.t0 = _context2["catch"](6);
	                _didIteratorError2 = true;
	                _iteratorError2 = _context2.t0;
	
	              case 22:
	                _context2.prev = 22;
	                _context2.prev = 23;
	
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                  _iterator2.return();
	                }
	
	              case 25:
	                _context2.prev = 25;
	
	                if (!_didIteratorError2) {
	                  _context2.next = 28;
	                  break;
	                }
	
	                throw _iteratorError2;
	
	              case 28:
	                return _context2.finish(25);
	
	              case 29:
	                return _context2.finish(22);
	
	              case 30:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this3, [[6, 18, 22, 30], [23,, 25, 29]]);
	      }))();
	    }
	  },
	
	  components: {
	    Carousel: _vueCarousel.Carousel,
	    Slide: _vueCarousel.Slide
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      accessToken: undefined,
	      passwordSiva: undefined,
	      loading: undefined,
	      errorMessage: ''
	    };
	  },
	
	  computed: {},
	  created: function created() {
	    this.accessToken = this.$route.query.GZK;
	  },
	
	
	  methods: {
	    doLoginAtendente: function doLoginAtendente() {
	      var _this = this;
	
	      _auth2.default.loginAtendente(this.passwordSiva, this.accessToken).then(function (r) {
	
	        _this.$router.push({ name: 'plans' });
	      }).catch(function () {
	        _this.errorMessage = 'Ocorreu um erro ao autenticar a sessão.';
	      });
	    }
	  }
	};

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var win = undefined;
	exports.default = {
	  data: function data() {
	    return {};
	  },
	
	  computed: {},
	  created: function created() {
	    var _this = this;
	
	    _auth2.default.loginSSA(this.$route.query.taxIdNumber, this.$route.query.sessionId).then(function (r) {
	      _this.$router.push({ name: 'plans' });
	    });
	  }
	};

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(70);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _routes = __webpack_require__(97);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      taxIdNumber: undefined,
	      loading: undefined,
	      isShow: false,
	      typePerson: undefined,
	      errorMessage: undefined
	    };
	  },
	
	  methods: {
	    getLead: function getLead() {
	      var _this = this;
	
	      this.errorMessage = undefined;
	      this.isShow = false;
	      var _self = this;
	      this.loading = this.$validator.validateAll().then(function () {
	
	        var cpf_cnpj = _this.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase();
	        _this.typePerson = cpf_cnpj.length <= 11 ? 'PERSON' : 'COMPANY';
	        var request = { taxpayerIdNumber: cpf_cnpj };
	
	        return _account2.default.accountExists({ taxIdNumber: cpf_cnpj }).then(function (valid) {
	          if (!valid) return;
	          return _sales2.default.getLead(request).then(function (response) {
	            if (response.lead && response.status.code == 0) {
	
	              if (response.lead.campaign != 'CAMINHOSDOPARANA') {
	                _this.errorMessage = 'CPF?CNPJ não cadastrado no caminhos do Paraná!';
	                return;
	              }
	
	              response.lead.typeTaxId = _this.typePerson;
	              sessionStorage.setItem('lead', (0, _stringify2.default)(response.lead));
	              _this.isShow = true;
	              _this.$router.push({ name: 'adhesion' });
	            } else {
	              _this.errorMessage = 'CPF?CNPJ não cadastrado!';
	              return;
	            }
	          }).catch(function (error) {
	
	            _this.errorMessage = error.data && (_self.typePerson == 'PERSON' ? 'CPF' : 'CNPJ') + ' n\xE3o cadastrado no caminhos do Paran\xE1!' || error.response && error.response.data.status.message;
	          });
	        });
	      });
	    }
	  }
	};

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _eventBus = __webpack_require__(25);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      economicoManual: undefined,
	      economicoAuto: undefined,
	      filter: undefined,
	      loadPromo: true
	    };
	  },
	
	  computed: {
	    isLoadPromo: function isLoadPromo() {
	      return this.loadPromo;
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.hasPromotion();
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var el = $(this.$el);
	    el.find('.question-box .accordion-click').click(function () {
	      el.find('.open').removeClass('open');
	      $(this).find('i').addClass('open');
	      $(this).parent().find('.answer-box').addClass('open');
	    });
	    _sales2.default.getPlan().then(function (response) {
	      _this.economicoAuto = response.find(function (e) {
	        return e.name.indexOf('Automático Econômico') >= 0;
	      }).planId;
	      _this.economicoManual = response.find(function (e) {
	        return e.name.indexOf('Manual Econômico') >= 0;
	      }).planId;
	    });
	  },
	
	  methods: {
	    choose: function choose(planId) {
	      if (this.type == 'newContract') {
	        _eventBus.EventBus.$emit('chooseNewPlan', planId);
	      } else {
	        this.$router.push({ 'name': 'adhesion', 'query': { 'planId': planId } });
	      }
	    },
	    hasPromotion: function hasPromotion() {
	      var _this2 = this;
	
	      this.loadPromo = _sales2.default.hasPromotion({ promotionCode: 'PROMO25' }).then(function (response) {
	        var promo = response[0];
	
	        if (promo) {
	          var dataIniTime = new Date(promo.start_date).getTime();
	          var dataEndTime = new Date(promo.end_date).getTime();
	          var dataNowTime = new Date().getTime();
	
	          if (dataNowTime >= dataIniTime && dataNowTime < dataEndTime || promo.adhesion_count < promo.usage_limit) {
	            $('#messageDialog').modal('hide');
	            $('body').css('overflow-y', 'overlay');
	            _this2.loadPromo = false;
	          } else {
	            $('#messageDialog').modal('show');
	            $('body').css('padding-right', '0');
	            $('body').css('overflow-y', 'overlay');
	          }
	        }
	      });
	    },
	    closeModal: function closeModal() {
	      $('#messageDialog').modal('hide');
	      $('body').removeClass('modal-active');
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _b2b = __webpack_require__(119);
	
	var _b2b2 = _interopRequireDefault(_b2b);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    b2b: _b2b2.default
	  }
	};

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _b2bSodre = __webpack_require__(530);
	
	var _b2bSodre2 = _interopRequireDefault(_b2bSodre);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { b2bSodre: _b2bSodre2.default }
	};

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _b2b = __webpack_require__(119);
	
	var _b2b2 = _interopRequireDefault(_b2b);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { b2b: _b2b2.default }
	};

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _b2cSodre = __webpack_require__(531);
	
	var _b2cSodre2 = _interopRequireDefault(_b2cSodre);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { b2cSodre: _b2cSodre2.default }
	};

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _b2c = __webpack_require__(162);
	
	var _b2c2 = _interopRequireDefault(_b2c);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { b2c: _b2c2.default }
	};

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventBus = __webpack_require__(25);
	
	exports.default = {
	  props: ['type'],
	  data: function data() {
	    return {
	      loading: undefined
	    };
	  },
	
	
	  computed: {},
	
	  methods: {
	    choose: function choose(planId) {
	      if (this.type == 'newContract') {
	        _eventBus.EventBus.$emit('chooseNewPlan', planId);
	      } else {
	        this.$router.push({ 'name': 'adhesion', 'query': { 'planId': planId } });
	      }
	    }
	  }
	};

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _b2bSodre = __webpack_require__(530);
	
	var _b2bSodre2 = _interopRequireDefault(_b2bSodre);
	
	var _b2cSodre = __webpack_require__(531);
	
	var _b2cSodre2 = _interopRequireDefault(_b2cSodre);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      changePlan: 'b2cSodre'
	    };
	  },
	
	  components: { b2bSodre: _b2bSodre2.default, b2cSodre: _b2cSodre2.default }
	};

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vpo = __webpack_require__(163);
	
	var _vpo2 = _interopRequireDefault(_vpo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { vpo: _vpo2.default }
	};

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _b2b = __webpack_require__(119);
	
	var _b2b2 = _interopRequireDefault(_b2b);
	
	var _b2c = __webpack_require__(162);
	
	var _b2c2 = _interopRequireDefault(_b2c);
	
	var _vpo = __webpack_require__(163);
	
	var _vpo2 = _interopRequireDefault(_vpo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      changePlan: 'b2c'
	    };
	  },
	
	  components: { b2b: _b2b2.default, b2c: _b2c2.default, vpo: _vpo2.default }
	};

/***/ }),
/* 613 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    props: ['placeholder', 'arrayRender', 'disabled'],
	
	    data: function data() {
	        return {
	            visibleOptions: false,
	
	            placeholder: this.placeholder,
	
	            valueSelected: "",
	
	            captionSelected: "",
	
	            arrayRender: this.arrayRender,
	
	            disabled: this.disabled
	        };
	    },
	    mounted: function mounted() {
	        this.OnClickStatus();
	    },
	
	    watch: {
	        disabled: function disabled(novoValor, valorAntigo) {
	            this.visibleOptions = true;
	        },
	        arrayRender: function arrayRender(novoValor, valorAntigo) {
	            this.captionSelected = "";
	            this.valueSelected = "";
	            this.visibleOptions = true;
	        }
	    },
	    methods: {
	        OnClickStatus: function OnClickStatus() {
	            return this.visibleOptions == false ? this.visibleOptions = true : this.visibleOptions = false;
	        },
	        clickHandlerOptions: function clickHandlerOptions(caption, value) {
	            this.valueSelected = value;
	            this.captionSelected = caption;
	            this.OnClickStatus();
	            this.$emit('ClickHandler', this.captionSelected, this.valueSelected);
	            return;
	        }
	    }
	};

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _defineProperty2 = __webpack_require__(48);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _vehicles = __webpack_require__(29);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	var _cpfCnpj = __webpack_require__(86);
	
	var _formModalNewSearch = __webpack_require__(512);
	
	var _formModalNewSearch2 = _interopRequireDefault(_formModalNewSearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    "form-modal-new-search": _formModalNewSearch2.default
	  },
	  props: ["ArrayVehicles"],
	  data: function data() {
	    var _ref;
	
	    return _ref = {
	      stepForm: 0,
	
	      plate: "",
	
	      brandName: "",
	
	      modelName: "",
	
	      arrayModelsByNetrin: [],
	
	      placeHolderFixed: "",
	      axes: [],
	
	      modalConfirmVisibility: false,
	      modalNewSearch: false,
	
	      loading: false,
	
	      showAxes: false,
	      axeIdSelected: undefined,
	      axeNameSelected: undefined,
	      plateAlreadyOn: false,
	      netrimErrorBrands: []
	    }, (0, _defineProperty3.default)(_ref, "axes", undefined), (0, _defineProperty3.default)(_ref, "models", []), (0, _defineProperty3.default)(_ref, "netrinOffVisibility", false), (0, _defineProperty3.default)(_ref, "fipeId", undefined), (0, _defineProperty3.default)(_ref, "categoryId", undefined), (0, _defineProperty3.default)(_ref, "validatePlate", undefined), (0, _defineProperty3.default)(_ref, "isMoto", undefined), (0, _defineProperty3.default)(_ref, "souTransportador", false), (0, _defineProperty3.default)(_ref, "cpfCnpjTransportador", ""), (0, _defineProperty3.default)(_ref, "anttStatus", null), (0, _defineProperty3.default)(_ref, "anttLoading", false), (0, _defineProperty3.default)(_ref, "mostrarAvisoAntt", false), _ref;
	  },
	
	
	  watch: {
	    axes: function axes(novoValor, valorAntigo) {}
	  },
	
	  computed: {
	    plateCompleta: function plateCompleta() {
	      return this.plate.replace(/[^\w]/gi, "").length === 7;
	    },
	    plateValida: function plateValida() {
	      var placa = (this.plate || "").replace(/[^\w]/gi, "").toUpperCase();
	      var regexMercosul = /^[A-Z]{3}[0-9][A-J][0-9]{2}$/;
	      var regexNormal = /^[A-Z]{3}[0-9]{4}$/;
	      return regexMercosul.test(placa) || regexNormal.test(placa);
	    },
	    plateInvalida: function plateInvalida() {
	      return this.plateCompleta && !this.plateValida;
	    },
	    transportadorPendente: function transportadorPendente() {
	      return this.souTransportador && this.anttStatus !== "success";
	    },
	    cpfCnpjValido: function cpfCnpjValido() {
	      return _cpfCnpj.cpfCnpj.validate(this.cpfCnpjTransportador || "");
	    }
	  },
	
	  methods: {
	    getNetrimToken: function getNetrimToken() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var resp;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _auth2.default.checkCpfValidationPermission();
	
	              case 2:
	                resp = _context.sent;
	                return _context.abrupt("return", resp && resp.token);
	
	              case 4:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    ShowModal: function ShowModal() {
	      return this.modalConfirmVisibility = true;
	    },
	    VerificarPlaca: function VerificarPlaca() {
	      var placa = this.plate.replace(/[^\w]/gi, "").toUpperCase();
	      var regexMercosul = /^[A-Z]{3}[0-9][A-J][0-9]{2}$/;
	      var regexNormal = /^[A-Z]{3}[0-9]{4}$/;
	
	      placa = placa.replace("-", "");
	
	      if (regexMercosul.test(placa)) {
	        this.validatePlate = false;
	      } else if (regexNormal.test(placa)) {
	        this.validatePlate = false;
	      } else {
	        this.isMoto = false;
	        this.validatePlate = true;
	      }
	    },
	    CloseModalNewSearch: function CloseModalNewSearch() {
	      this.modalNewSearch = false;
	    },
	    refreshPage: function refreshPage() {
	      this.modalNewSearch = false;
	      this.stepForm = 0;
	      return this.NetrinValidation();
	    },
	    ShowNewSearch: function ShowNewSearch() {
	      return this.modalNewSearch = true;
	    },
	    RemoveModal: function RemoveModal() {
	      this.modalConfirmVisibility = false;
	      this.netrinOffVisibility = false;
	      this.resetVehicleForm();
	      this.stepForm = 0;
	      return;
	    },
	    resetVehicleForm: function resetVehicleForm() {
	      this.plate = "";
	      this.brandName = "";
	      this.modelName = "";
	      this.arrayModelsByNetrin = [];
	      this.models = [];
	      this.netrimErrorBrands = [];
	      this.axes = undefined;
	      this.showAxes = false;
	      this.axeIdSelected = undefined;
	      this.axeNameSelected = undefined;
	      this.placeHolderFixed = "";
	      this.validatePlate = false;
	      this.isMoto = false;
	      this.plateAlreadyOn = false;
	      this.souTransportador = false;
	      this.cpfCnpjTransportador = "";
	      this.anttStatus = null;
	      this.mostrarAvisoAntt = false;
	      this.emitTransportador();
	      return;
	    },
	    StepBack: function StepBack() {
	      return this.stepForm = 0;
	    },
	    NetrinValidation: function NetrinValidation() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        var placaFormatada, filter, VehicleExist, placa, netrimToken;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                if (_this2.plateValida) {
	                  _context3.next = 3;
	                  break;
	                }
	
	                _this2.VerificarPlaca();
	                return _context3.abrupt("return");
	
	              case 3:
	                if (!_this2.transportadorPendente) {
	                  _context3.next = 6;
	                  break;
	                }
	
	                _this2.mostrarAvisoAntt = true;
	                return _context3.abrupt("return");
	
	              case 6:
	                _this2.mostrarAvisoAntt = false;
	
	                _this2.VerificarPlaca();
	                _this2.loading = true;
	                _this2.plateAlreadyOn = false;
	
	                placaFormatada = _this2.plate.substring(0, 3) + "-" + _this2.plate.substring(3);
	
	
	                if (!_this2.ArrayVehicles) _this2.ArrayVehicles = [];
	                filter = _this2.ArrayVehicles.findIndex(function (element) {
	                  return element.plate == placaFormatada.toUpperCase() || element.plate === _this2.plate.toUpperCase();
	                });
	
	                if (!(filter != -1)) {
	                  _context3.next = 17;
	                  break;
	                }
	
	                _this2.plateAlreadyOn = true;
	                _this2.loading = false;
	                return _context3.abrupt("return");
	
	              case 17:
	                _context3.next = 19;
	                return _vehicles2.default.vehicleNotExists(placaFormatada);
	
	              case 19:
	                VehicleExist = _context3.sent;
	
	                if (VehicleExist) {
	                  _context3.next = 24;
	                  break;
	                }
	
	                _this2.loading = false;
	                _this2.plateAlreadyOn = true;
	                return _context3.abrupt("return");
	
	              case 24:
	                placa = _this2.plate.replaceAll("-", "");
	
	                if (!(placa.length == 0)) {
	                  _context3.next = 27;
	                  break;
	                }
	
	                return _context3.abrupt("return", _this2.loading = false);
	
	              case 27:
	                if (!(placaFormatada.length >= 7 && /^[a-zA-Z]{3}-[0-9][0-9a-jA-J][0-9]{2}$/.test(placaFormatada))) {
	                  _context3.next = 33;
	                  break;
	                }
	
	                _context3.next = 30;
	                return _this2.getNetrimToken();
	
	              case 30:
	                netrimToken = _context3.sent;
	
	                _vehicles2.default.getPlacaNetrim(placa, netrimToken).then(function (data) {
	                  if (data.isMoto > 0) {
	                    _this2.isMoto = true;
	                    _this2.loading = false;
	                    return;
	                  }
	
	                  _this2.arrayModelsByNetrin = data.modelos;
	                  _this2.arrayModelsByNetrin.forEach(function (element) {
	                    element.caption = element.name;
	                    element.value = element.fipeId + "|" + element.modelId;
	                  });
	                  _this2.brandName = data.marcas[0].name;
	                  _this2.$emit("ValueChanger", placaFormatada, data.marcas[0].name, data.marcas[0].brandId, _this2.arrayModelsByNetrin);
	                  _this2.loading = false;
	                  _this2.stepForm = 1;
	                  return;
	                }).catch(function () {
	                  var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(res) {
	                    var data;
	                    return _regenerator2.default.wrap(function _callee2$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            _this2.ShowNewSearch();
	                            _context2.next = 3;
	                            return _vehicles2.default.getVehicleBrand();
	
	                          case 3:
	                            data = _context2.sent;
	
	                            _this2.netrimErrorBrands = data;
	                            _this2.netrimErrorBrands.forEach(function (element) {
	                              element.caption = element.name;
	                              element.value = element.brandId;
	                            });
	                            _this2.stepForm = 404;
	                            _this2.loading = false;
	
	                          case 8:
	                          case "end":
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee2, _this2);
	                  }));
	
	                  return function (_x) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }());
	                return _context3.abrupt("return");
	
	              case 33:
	                _this2.loading = false;
	                return _context3.abrupt("return", _this2.showModalInvalidPlate = true);
	
	              case 35:
	              case "end":
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }))();
	    },
	    getModels: function getModels(caption, value) {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	        var models;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _this3.axes = "";
	                _context4.next = 3;
	                return _vehicles2.default.getVehicleModel(value);
	
	              case 3:
	                models = _context4.sent;
	
	                _this3.models = models;
	                _this3.categoryId = models.categoryId;
	
	                _this3.models.forEach(function (element) {
	                  element.value = element.modelId + "|" + element.categoryId;
	                  element.caption = element.name;
	                });
	                _this3.brandName = caption;
	                _this3.brandIdSelected = value;
	                return _context4.abrupt("return");
	
	              case 10:
	              case "end":
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this3);
	      }))();
	    },
	    setModels: function setModels(model, id) {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
	        var ArrayString, fipeId, categoryId, netrimToken;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                ArrayString = id.split("|");
	                fipeId = ArrayString[0];
	                categoryId = ArrayString[1];
	                _context5.next = 5;
	                return _this4.getNetrimToken();
	
	              case 5:
	                netrimToken = _context5.sent;
	
	                _vehicles2.default.listaEixosBase(categoryId, netrimToken).then(function (data) {
	                  _this4.axes = data;
	                });
	                _this4.categoryId = categoryId;
	                _this4.modelName = model;
	                _this4.modelFipeIdSelected = fipeId;
	                return _context5.abrupt("return");
	
	              case 11:
	              case "end":
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this4);
	      }))();
	    },
	    setAxes: function setAxes(name, id) {
	      this.axeNameSelected = name;
	      this.axeIdSelected = id;
	      this.$emit("AxesChanger", this.axeNameSelected, this.axeIdSelected);
	      return;
	    },
	    showModal: function showModal() {
	      if (this.plate && this.modelName && this.brandName) {
	        this.netrinOffVisibility = true;
	      }
	      return;
	    },
	    AddVehicleNetrimOff: function AddVehicleNetrimOff() {
	      var placa = this.plate.replace(/[^\w]/gi, "").toUpperCase();
	      var regexMercosul = /^[A-Z]{3}[0-9][A-J][0-9]{2}$/;
	      var regexNormal = /^[A-Z]{3}[0-9]{4}$/;
	
	      placa = placa.replace("-", "");
	
	      if (regexMercosul.test(placa)) {
	        this.validatePlate = false;
	      } else if (regexNormal.test(placa)) {
	        this.validatePlate = false;
	      } else {
	        this.validatePlate = true;
	        return;
	      }
	      this.$emit("ValueChangerNetrinOff", this.plate, this.brandName, this.brandIdSelected, this.modelName, this.modelFipeIdSelected);
	      this.modalConfirmVisibility = true;
	      return;
	    },
	    getAxes: function getAxes(model, modelTeste) {
	      var _this5 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
	        var ArrayString, fipeId, modelId, netrimToken;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _this5.axeIdSelected = "";
	                _this5.axeNameSelected = "";
	
	                ArrayString = modelTeste.split("|");
	                fipeId = ArrayString[0];
	                modelId = ArrayString[1];
	
	
	                _this5.disableAxes = false;
	                _this5.loading = true;
	                _this5.modelName = model;
	                _this5.$emit("ModelChanger", model, modelId);
	                _context6.next = 11;
	                return _this5.getNetrimToken();
	
	              case 11:
	                netrimToken = _context6.sent;
	
	                _vehicles2.default.postAxes(_this5.brandName, model, fipeId, netrimToken).then(function (data) {
	                  var response = JSON.parse(data.consultado);
	                  if (response.listCategoryArtesp.length == 1) {
	                    _this5.placeHolderFixed = response.listCategoryArtesp[0].name;
	                    _this5.axeName = response.listCategoryArtesp[0].name;
	                    _this5.axeId = response.listCategoryArtesp[0].categoryArtespId;
	                    _this5.$emit("AxesChanger", response.listCategoryArtesp[0].name, response.listCategoryArtesp[0].categoryArtespId);
	                    _this5.axeIdSelected = response.listCategoryArtesp[0].name;
	                    _this5.axeNameSelected = response.listCategoryArtesp[0].categoryArtespId;
	                    _this5.disableAxes = true;
	                    _this5.loading = false;
	                    _this5.showAxes = true;
	                    return;
	                  }
	                  _this5.selectedModel = model;
	                  _this5.fipeId = fipeId;
	                  _this5.axes = response.listCategoryArtesp;
	                  _this5.axes.forEach(function (element) {
	                    element.value = element.categoryArtespId;
	                    element.caption = element.name;
	                  });
	                  _this5.loading = false;
	                  _this5.showAxes = true;
	                  return;
	                });
	
	              case 13:
	              case "end":
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this5);
	      }))();
	    },
	    AddVehicle: function AddVehicle() {
	      this.modalConfirmVisibility = false;
	      this.plate = this.plate.substring(0, 3) + "-" + this.plate.substring(3);
	
	      this.emitTransportador();
	      this.$emit("SaveVehicle");
	    },
	    maskCpfCnpj: function maskCpfCnpj(value) {
	      var d = (value || "").replace(/\D/g, "").slice(0, 14);
	      if (d.length <= 11) {
	        return d.replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d{1,2})$/, "$1-$2");
	      }
	      return d.replace(/(\d{2})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1/$2").replace(/(\d{4})(\d{1,2})$/, "$1-$2");
	    },
	    cpfCnpjDigits: function cpfCnpjDigits() {
	      return (this.cpfCnpjTransportador || "").replace(/\D/g, "");
	    },
	    onPlateInput: function onPlateInput(event) {
	      if (event && event.target) this.plate = event.target.value;
	      this.corrigeMascara();
	
	      this.validatePlate = false;
	      this.isMoto = false;
	      this.plateAlreadyOn = false;
	
	      if (this.souTransportador || this.cpfCnpjTransportador || this.anttStatus) {
	        this.souTransportador = false;
	        this.cpfCnpjTransportador = "";
	        this.anttStatus = null;
	        this.mostrarAvisoAntt = false;
	        this.emitTransportador();
	      }
	    },
	    onTransportadorToggle: function onTransportadorToggle() {
	      if (!this.souTransportador) {
	        this.cpfCnpjTransportador = "";
	        this.anttStatus = null;
	      }
	      this.mostrarAvisoAntt = false;
	      this.emitTransportador();
	    },
	    onCpfCnpjInput: function onCpfCnpjInput() {
	      this.cpfCnpjTransportador = this.maskCpfCnpj(this.cpfCnpjTransportador);
	      this.anttStatus = null;
	      this.mostrarAvisoAntt = false;
	      this.emitTransportador();
	    },
	    consultarAntt: function consultarAntt() {
	      var _this6 = this;
	
	      var transportador = this.cpfCnpjDigits();
	      var placa = this.plate.replace(/[^\w]/gi, "").toUpperCase();
	
	      if (!transportador || !placa) {
	        this.anttStatus = "error";
	        return;
	      }
	
	      this.anttLoading = true;
	      _sales2.default.consultarRNTRC(transportador, [placa]).then(function (resp) {
	        _this6.anttStatus = _this6.anttRespostaValida(resp, placa) ? "success" : "error";
	        if (_this6.anttStatus === "success") _this6.mostrarAvisoAntt = false;
	        _this6.anttLoading = false;
	        _this6.emitTransportador();
	      }).catch(function () {
	        _this6.anttStatus = "error";
	        _this6.anttLoading = false;
	        _this6.emitTransportador();
	      });
	    },
	    anttRespostaValida: function anttRespostaValida(resp, placa) {
	      if (!resp || resp.status && resp.status.code) return false;
	      if (resp.rntrcAtivo !== true) return false;
	      if (!Array.isArray(resp.frota)) return false;
	      var norm = function norm(p) {
	        return (p || "").replace(/[^\w]/gi, "").toUpperCase();
	      };
	      return resp.frota.some(function (f) {
	        return norm(f.placaVeiculo) === placa && f.situacaoVeiculoFrotaTransportador === true;
	      });
	    },
	    emitTransportador: function emitTransportador() {
	      this.$emit("TransportadorChanger", this.souTransportador, this.cpfCnpjDigits());
	    },
	    PlateFormat: function PlateFormat(plate) {
	      var NewPlate = plate.substring(0, 3) + "-" + plate.substring(3);
	      var result = NewPlate;
	      var placa = NewPlate.replaceAll("-", "");
	      if (/^[A-Za-z]+$/.test(NewPlate[5])) result = placa;
	
	      return result;
	    },
	    verificarTecla: function verificarTecla(event) {
	      if (event.keyCode === 189) {
	        event.preventDefault();
	      }
	    },
	    corrigeMascara: function corrigeMascara() {
	      this.$nextTick(function () {
	        $("#plate").val($("#plate").val());
	      });
	    },
	    tratarTextoColado: function tratarTextoColado(event) {
	      var clipboardData = event.clipboardData || window.clipboardData;
	      var text = clipboardData.getData("text/plain");
	      text = text.replace(/-/g, "");
	      event.preventDefault();
	
	      document.execCommand("insertText", false, text);
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vehicles = __webpack_require__(29);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _lodash = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['step', 'ArrayVehicles', 'formVisibility'],
	
	  data: function data() {
	    return {
	      isClick: false,
	      vehicles: _constantes2.default.VehiclesToSaveAdhesion,
	      addVehicles: false,
	      stepForm: 0,
	      showModalInvalidPlate: false,
	      loading: false,
	      brandId: '',
	      brand: '',
	      models: [],
	      errorStatus: false,
	      msgError: "",
	      modalConfirmVisibility: false
	    };
	  },
	
	  methods: {
	    stepBackZero: function stepBackZero() {
	      return this.stepForm = 0;
	    },
	    stepNext: function stepNext() {
	      return this.stepForm += 1;
	    },
	    rmvLoading: function rmvLoading() {
	      return this.loading = false;
	    },
	    showLoading: function showLoading() {
	      return this.loading = true;
	    },
	    rmvButton: function rmvButton() {
	      return this.addVehicles = false;
	    },
	    resetForm: function resetForm() {
	      return this.addVehicles = false;
	    },
	    forceUptd: function forceUptd() {
	      return this.$forceUpdate();
	    },
	    rmvPlate: function rmvPlate() {
	      var _this = this;
	
	      var index = this.ArrayVehicles.findIndex(function (element) {
	        return element.plate.toUpperCase() == _this.plate.toUpperCase();
	      });
	      this.ArrayVehicles.splice(index, 1);
	      this.modalConfirmVisibility = false;
	      if (this.ArrayVehicles.length == 0) {
	        return this.$emit('stepBack');
	      }
	      return this.forceUptd();
	    },
	    removePlate: function removePlate(plate, modelName, brandName) {
	      this.plate = plate;
	      this.modelName = modelName;
	      this.brandName = brandName;
	      this.modalConfirmVisibility = true;
	      return;
	    },
	    RemoveModal: function RemoveModal() {
	      return this.modalConfirmVisibility = false;
	    },
	    PlateFormat: function PlateFormat(plate) {
	      var result = plate;
	      var placa = plate.replaceAll("-", "");
	
	      if (/^[A-Za-z]+$/.test(plate[5])) result = placa;
	
	      return result;
	    }
	  }
	};

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(13);
	
	exports.default = {
	  props: ['plate', 'brand', 'model', 'type'],
	  data: function data() {
	    return {
	      plate: this.plate,
	      brand: this.brand,
	      model: this.model,
	      plateExibe: this.plate
	    };
	  },
	  mounted: function mounted() {
	
	    this.verificarPlaca();
	    this.salvaPlaca();
	  },
	
	
	  methods: {
	    verificarPlaca: function verificarPlaca() {
	      if (this.plateExibe.length === 7 && isNaN(this.plateExibe.charAt(4))) {
	        this.plateExibe = this.plateExibe.substring(0, 3) + "" + this.plateExibe.substring(3);
	      } else {
	        this.plateExibe = this.plateExibe.substring(0, 3) + "-" + this.plateExibe.substring(3);
	      }
	    },
	    salvaPlaca: function salvaPlaca() {
	      this.plate = this.plate.substring(0, 3) + "-" + this.plate.substring(3);
	    }
	  }
	
	};

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['open'],
	  data: function data() {
	    return {
	      isOpen: !!this.open
	    };
	  },
	
	
	  computed: {
	    iconClass: function iconClass() {
	      return this.isOpen ? 'icon-minus-accordion' : 'icon-plus-accordion';
	    }
	  },
	
	  watch: {
	    isOpen: function isOpen(newVal) {
	      $('[data-toggle="tooltip"]').tooltip('hide');
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['request'],
	  data: function data() {
	    return {
	      resposta: [false, false, false, false, false, false, false, false, false],
	      perguntaCaptcha: '',
	      backgroundColorsA1: '#FFF',
	      backgroundColorsA2: '#FFF',
	      backgroundColorsA3: '#FFF',
	      backgroundColorsB1: '#FFF',
	      backgroundColorsB2: '#FFF',
	      backgroundColorsB3: '#FFF',
	      backgroundColorsC1: '#FFF',
	      backgroundColorsC2: '#FFF',
	      backgroundColorsC3: '#FFF',
	      borderA1: 'none',
	      borderA2: 'none',
	      borderA3: 'none',
	      borderB1: 'none',
	      borderB2: 'none',
	      borderB3: 'none',
	      borderC1: 'none',
	      borderC2: 'none',
	      borderC3: 'none',
	      tokenCaptcha: ''
	    };
	  },
	  mounted: function mounted() {
	    this.getCaptcha();
	    document.body.style.overflow = 'hidden';
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.body.style.overflow = 'auto';
	  },
	
	  computed: {
	    colorComputed: function colorComputed() {
	      return this.resposta[0] ? { 'background-color': 'red' } : { 'background-color': 'white' };
	    }
	  },
	  methods: {
	    getCaptcha: function getCaptcha() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var result;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _sales2.default.captchaAdhesion("teste");
	
	              case 2:
	                result = _context.sent;
	
	                _this.tokenCaptcha = result.token;
	                _this.perguntaCaptcha = result.perguntaCaptcha;
	                _this.resposta = [false, false, false, false, false, false, false, false, false];
	                $("#logoContainer").html($());
	                $("#LabelA1").html($());
	                $("#LabelA2").html($());
	                $("#LabelA3").html($());
	                $("#LabelB1").html($());
	                $("#LabelB2").html($());
	                $("#LabelB3").html($());
	                $("#LabelC1").html($());
	                $("#LabelC2").html($());
	                $("#LabelC3").html($());
	                _this.backgroundColorsA1 = "#fff";
	                _this.backgroundColorsA2 = "#fff";
	                _this.backgroundColorsA3 = "#fff";
	                _this.backgroundColorsB1 = "#fff";
	                _this.backgroundColorsB2 = "#fff";
	                _this.backgroundColorsB3 = "#fff";
	                _this.backgroundColorsC1 = "#fff";
	                _this.backgroundColorsC2 = "#fff";
	                _this.backgroundColorsC3 = "#fff";
	                _this.borderA1 = '1px solid #fff';
	                _this.borderA2 = '1px solid #fff';
	                _this.borderA3 = '1px solid #fff';
	                _this.borderB1 = '1px solid #fff';
	                _this.borderB2 = '1px solid #fff';
	                _this.borderB3 = '1px solid #fff';
	                _this.borderC1 = '1px solid #fff';
	                _this.borderC2 = '1px solid #fff';
	                _this.borderC3 = '1px solid #fff';
	                $("#logoContainer").append($(result.LogoMM.IMAGEM_SVG));
	                $("#LabelA1").append($(result.arrayCaptcha[0].IMAGEM_SVG));
	                $("#LabelA2").append($(result.arrayCaptcha[1].IMAGEM_SVG));
	                $("#LabelA3").append($(result.arrayCaptcha[2].IMAGEM_SVG));
	                $("#LabelB1").append($(result.arrayCaptcha[3].IMAGEM_SVG));
	                $("#LabelB2").append($(result.arrayCaptcha[4].IMAGEM_SVG));
	                $("#LabelB3").append($(result.arrayCaptcha[5].IMAGEM_SVG));
	                $("#LabelC1").append($(result.arrayCaptcha[6].IMAGEM_SVG));
	                $("#LabelC2").append($(result.arrayCaptcha[7].IMAGEM_SVG));
	                $("#LabelC3").append($(result.arrayCaptcha[8].IMAGEM_SVG));
	
	              case 44:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    captchaSelecionado: function captchaSelecionado(id, name) {
	      var checkbox = this.resposta[id] ? false : true;
	      this.resposta[id] = checkbox;
	
	      if (id === 0) {
	        this.backgroundColorsA1 = checkbox ? '#DFC1FF' : '#fff';
	        this.borderA1 = checkbox ? '1px solid #CE9FFF' : '1px solid #fff';
	      }
	      if (id === 1) {
	        this.backgroundColorsA2 = checkbox ? '#DFC1FF' : '#fff';
	        this.borderA2 = checkbox ? '1px solid #CE9FFF' : '1px solid #fff';
	      }
	      if (id === 2) {
	        this.backgroundColorsA3 = checkbox ? '#DFC1FF' : '#fff';
	        this.borderA3 = checkbox ? '1px solid #CE9FFF' : '1px solid #fff';
	      }
	      if (id === 3) {
	        this.backgroundColorsB1 = checkbox ? '#DFC1FF' : '#fff';
	        this.borderB1 = checkbox ? '1px solid #CE9FFF' : '1px solid #fff';
	      }
	      if (id === 4) {
	        this.backgroundColorsB2 = checkbox ? '#DFC1FF' : '#fff';
	        this.borderB2 = checkbox ? '1px solid #CE9FFF' : '1px solid #fff';
	      }
	      if (id === 5) {
	        this.backgroundColorsB3 = checkbox ? '#DFC1FF' : '#fff';
	        this.borderB3 = checkbox ? '1px solid #CE9FFF' : '1px solid #fff';
	      }
	      if (id === 6) {
	        this.backgroundColorsC1 = checkbox ? '#DFC1FF' : '#fff';
	        this.borderC1 = checkbox ? '1px solid #CE9FFF' : '1px solid #fff';
	      }
	      if (id === 7) {
	        this.backgroundColorsC2 = checkbox ? '#DFC1FF' : '#fff';
	        this.borderC2 = checkbox ? '1px solid #CE9FFF' : '1px solid #fff';
	      }
	      if (id === 8) {
	        this.backgroundColorsC3 = checkbox ? '#DFC1FF' : '#fff';
	        this.borderC3 = checkbox ? '1px solid #CE9FFF' : '1px solid #fff';
	      }
	      return;
	    },
	    responderCaptcha: function responderCaptcha() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var body, resposta;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (!(_this2.request === "request")) {
	                  _context2.next = 2;
	                  break;
	                }
	
	                return _context2.abrupt('return');
	
	              case 2:
	                _this2.$emit('abrirLoadingV2');
	                body = {
	                  resposta: _this2.resposta,
	                  adhesion: _this2.request,
	                  token: _this2.tokenCaptcha
	                };
	                _context2.next = 6;
	                return _sales2.default.captchaAdhesionPost(body);
	
	              case 6:
	                resposta = _context2.sent;
	
	                if (resposta) {
	                  _context2.next = 10;
	                  break;
	                }
	
	                _this2.$emit('fecharLoadingV2');
	                return _context2.abrupt('return', _this2.getCaptcha());
	
	              case 10:
	
	                _this2.$emit('continuarCaptcha', resposta);
	                _this2.$emit('fecharCaptcha');
	
	              case 12:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    }
	  }
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  props: ['value', 'options', 'fieldValue', 'fieldCaption'],
	
	  data: function data() {
	    return {
	      currentValue: this.value
	    };
	  },
	
	
	  watch: {
	    value: function value(newVal) {
	      this.currentValue = newVal;
	      this.selectItem(this.selected);
	    }
	  },
	
	  computed: {
	    selected: function selected() {
	      var _this = this;
	
	      return _.find(this.options, function (o) {
	        if (!o) return false;
	        return _this.getItemValue(o) == _this.currentValue;
	      });
	    }
	  },
	
	  mounted: function mounted() {
	    if (this.value) this.currentValue = this.value;
	
	    this.$emit('input', this.currentValue);
	    this.$emit('itemSelected', this.selected);
	  },
	
	
	  methods: {
	    selectItem: function selectItem(item) {
	      if (item && this.getItemValue(item) != this.currentValue) {
	        this.currentValue = this.getItemValue(item);
	        this.$emit('input', this.getItemValue(item));
	        this.$emit('itemSelected', item);
	      }
	    },
	    getItemValue: function getItemValue(item) {
	      if (this.fieldValue) {
	        return item[this.fieldValue];
	      }
	      return item.value;
	    },
	    getItemCaption: function getItemCaption(item) {
	      if (this.fieldCaption) {
	        return item[this.fieldCaption];
	      }
	      return item.caption;
	    }
	  }
	
	};

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dropdown = __webpack_require__(1877);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _vuejsDatepicker = __webpack_require__(2232);
	
	var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);
	
	var _titleUser = __webpack_require__(1888);
	
	var _titleUser2 = _interopRequireDefault(_titleUser);
	
	var _cardTaxes = __webpack_require__(1876);
	
	var _cardTaxes2 = _interopRequireDefault(_cardTaxes);
	
	var _vue2Datepicker = __webpack_require__(533);
	
	var _vue2Datepicker2 = _interopRequireDefault(_vue2Datepicker);
	
	var _FormVehicle = __webpack_require__(1872);
	
	var _FormVehicle2 = _interopRequireDefault(_FormVehicle);
	
	var _dropdownV = __webpack_require__(1871);
	
	var _dropdownV2 = _interopRequireDefault(_dropdownV);
	
	var _Loading = __webpack_require__(1870);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _formModal = __webpack_require__(1874);
	
	var _formModal2 = _interopRequireDefault(_formModal);
	
	var _formModalNewSearch = __webpack_require__(512);
	
	var _formModalNewSearch2 = _interopRequireDefault(_formModalNewSearch);
	
	var _formAddVehicles = __webpack_require__(1873);
	
	var _formAddVehicles2 = _interopRequireDefault(_formAddVehicles);
	
	__webpack_require__(1500);
	
	var _captcha = __webpack_require__(1875);
	
	var _captcha2 = _interopRequireDefault(_captcha);
	
	var _headerHotSite = __webpack_require__(1982);
	
	var _headerHotSite2 = _interopRequireDefault(_headerHotSite);
	
	var _mainContent = __webpack_require__(1983);
	
	var _mainContent2 = _interopRequireDefault(_mainContent);
	
	var _modalValidate = __webpack_require__(514);
	
	var _modalValidate2 = _interopRequireDefault(_modalValidate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var plugin = {};
	plugin.install = function (Vue, options) {
	  Vue.component("cardTaxes", _cardTaxes2.default);
	  Vue.component("dropdown", _dropdown2.default);
	  Vue.component("datepicker", _vuejsDatepicker2.default);
	  Vue.component("title-user", _titleUser2.default);
	  Vue.component("vue-date-picker", _vue2Datepicker2.default);
	  Vue.component("form-vehicle", _FormVehicle2.default);
	  Vue.component("dropdownV2", _dropdownV2.default);
	  Vue.component("loadingV2", _Loading2.default);
	  Vue.component("form-modal", _formModal2.default);
	  Vue.component("form-modal-new-search", _formModalNewSearch2.default);
	  Vue.component("form-add-vehicles", _formAddVehicles2.default);
	  Vue.component("CaptchaAdhesion", _captcha2.default);
	  Vue.component("HeaderHotSite", _headerHotSite2.default);
	  Vue.component("MainContentHotSite", _mainContent2.default);
	  Vue.component("modal-validate", _modalValidate2.default);
	};
	
	exports.default = plugin;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _eventBus = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["address", "user", "typePurchase"],
	  data: function data() {
	    return {
	      userAddress: [],
	      newAddress: {},
	      registerAddress: false,
	      selectedAddress: undefined,
	      loading: undefined,
	      errorCep: undefined,
	      lastAddressInsert: undefined,
	      allFieldsValid: false
	    };
	  },
	
	  watch: {
	    newAddress: {
	      handler: function handler() {
	        this.allFieldsValid = this.validateAllFields();
	      },
	      deep: true,
	      immediate: true
	    }
	  },
	  computed: {
	    currentUser: function currentUser() {
	      if (_auth2.default) return _auth2.default._currentUser;
	    }
	  },
	  created: function created() {
	    var _this = this;
	
	    this.$watch("newAddress", function () {
	      var vm = _this;
	      setTimeout(function () {
	        vm.$validator.validateAll().then(function () {
	          vm.newAddress.validForm = true;
	          $("#create-address").prop("disabled", false);
	        }).catch(function (err) {
	          vm.newAddress.validForm = false;
	        });
	      }, 300);
	    }, { deep: true });
	
	    if (this.address && !this.currentUser) {
	      this.userAddress.push(this.address);
	    } else {
	      this.getAddress();
	    }
	  },
	
	  methods: {
	    getLastInsertAddress: function getLastInsertAddress() {
	      var _this2 = this;
	
	      this.loading = _account2.default.getAddressDeliveryList(this.currentUser.moveMaisId).then(function (resp) {
	        _this2.userAddress = resp;
	        var maxValueAdress = _this2.userAddress.length - 1;
	        _this2.lastAddressInsert = _this2.userAddress[maxValueAdress];
	        _this2.$emit("deliveryAddress", _this2.lastAddressInsert);
	      });
	    },
	    changeAddress: function changeAddress() {
	      this.$emit("deliveryAddress", this.selectedAddress);
	      if (!this.currentUser) {
	        this.$emit("allAddresses", this.userAddress);
	      }
	    },
	    getAddress: function getAddress() {
	      var _this3 = this;
	
	      this.loading = _account2.default.getAddressDeliveryList(this.currentUser.moveMaisId).then(function (resp) {
	        _this3.userAddress = resp;
	      }).catch(function (err) {});
	    },
	    validateAllFields: function validateAllFields() {
	      var _this4 = this;
	
	      var requiredFields = ["zipCode", "address", "number", "neighborhood", "city", "state"];
	      return requiredFields.every(function (field) {
	        return _this4.newAddress[field] && typeof _this4.newAddress[field] === "string" && _this4.newAddress[field].trim().length > 0;
	      });
	    },
	    createAddress: function createAddress() {
	      var _this5 = this;
	
	      if (this.typePurchase != "ADHESION") {
	        this.newAddress.type = "DELIVERY";
	      }
	      if (this.typePurchase == "ADHESION") {
	        this.newAddress.type = "MAILING";
	      }
	      if (this.currentUser) {
	        this.newAddress.moveMaisId = this.currentUser.moveMaisId;
	        this.loading = _account2.default.insertAddress(this.newAddress).then(function (res) {
	          _this5.getLastInsertAddress();
	        }).catch(function (err) {});
	      } else {
	        this.userAddress.push(this.newAddress);
	        this.$emit("allAddresses", this.userAddress);
	      }
	
	      this.newAddress = {};
	      this.registerAddress = false;
	    },
	    queryAddress: function queryAddress() {
	      var _this6 = this;
	
	      this.errorCep = undefined;
	      this.loading = _account2.default.queryAddress(this.newAddress.zipCode).then(function (resp) {
	        _this6.newAddress = resp;
	
	        if (_this6.newAddress.address.length == 0 && _this6.newAddress.neighborhood.length == 0) {
	          _this6.newAddress.number = "";
	        }
	      }).catch(function (err) {
	        _this6.errorCep = err.data.status.message;
	        _this6.$validator.validateAll();
	      });
	    },
	    queryAddressTyping: function queryAddressTyping() {
	      if (this.newAddress.zipCode.length > 0 && this.newAddress.zipCode.length < 8) return;
	
	      this.queryAddress();
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PageSm = undefined;
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(28);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageSm = function () {
	  function PageSm() {
	    (0, _classCallCheck3.default)(this, PageSm);
	
	    this._size = 6;
	
	    this._offset = 0;
	
	    this._itemCount = 0;
	  }
	
	  (0, _createClass3.default)(PageSm, [{
	    key: 'build',
	    value: function build() {
	      return {
	        pageSize: this.size(),
	        pageNumber: this.page()
	      };
	    }
	  }, {
	    key: 'size',
	    value: function size(_size) {
	      if (_size === undefined) return this._size;else {
	        var x = _.clone(this);
	        x._size = _size;
	        x._offset = 0;
	        return x;
	      }
	    }
	  }, {
	    key: 'offset',
	    value: function offset(_offset) {
	      if (_offset === undefined) {
	        return this._offset;
	      } else {
	        var x = _.clone(this);
	        x._offset = _offset;
	        return x;
	      }
	    }
	  }, {
	    key: 'itemCount',
	    value: function itemCount(count) {
	      if (count === undefined) {
	        return this._itemCount;
	      } else {
	        var x = _.clone(this);
	        x._itemCount = count;
	        return x;
	      }
	    }
	  }, {
	    key: 'pages',
	    value: function pages() {
	      var start = this.page() - 5;
	      var end = this.page() + 4;
	      while (start < 1) {
	        start++;
	      }
	
	      while (end - start < 9) {
	        end++;
	      }
	
	      while (end > this.pageCount()) {
	        end--;
	      }
	
	      return _.range(start, end + 1);
	    }
	  }, {
	    key: 'firstIndexShown',
	    value: function firstIndexShown() {
	      if (this._itemCount == 0) return 0;
	
	      return this.offset() + 1;
	    }
	  }, {
	    key: 'lastIndexShown',
	    value: function lastIndexShown() {
	      return Math.min(this.offset() + this.size(), this.itemCount());
	    }
	  }, {
	    key: 'page',
	    value: function page(_page) {
	      if (_page === undefined) {
	        return Math.floor(this.offset() / this.size()) + 1;
	      } else {
	        return this.offset(this.size() * (_page - 1));
	      }
	    }
	  }, {
	    key: 'pageCount',
	    value: function pageCount(pages) {
	      if (pages === undefined) {
	        return Math.ceil(this.itemCount() / this.size());
	      } else {
	        return this.itemCount(pages * this.size());
	      }
	    }
	  }]);
	  return PageSm;
	}();
	
	exports.PageSm = PageSm;
	
	
	var template = __webpack_require__(1690);
	
	exports.default = {
	  template: template,
	
	  props: ['model'],
	
	  methods: {
	    previous: function previous() {
	      var page = this.model.page();
	      if (page > 1) {
	        this.$emit('page-change', page - 1);
	      }
	    },
	    next: function next() {
	      var page = this.model.page();
	      if (page < this.model.pageCount()) {
	        this.$emit('page-change', page + 1);
	      }
	    },
	    toPage: function toPage(p) {
	      if (p > 0 && p <= this.model.pageCount()) {
	        this.$emit('page-change', p);
	      }
	    }
	  }
	
	};

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  props: {
	    moveMaisIdParceiroSelecionado: undefined
	  },
	
	  data: function data() {
	    return {
	      mostrarModal: true,
	      segundaPeriodo1: undefined,
	      segundaPeriodo2: undefined,
	      tercaPeriodo1: undefined,
	      tercaPeriodo2: undefined,
	      quartaPeriodo1: undefined,
	      quartaPeriodo2: undefined,
	      quintaPeriodo1: undefined,
	      quintaPeriodo2: undefined,
	      sextaPeriodo1: undefined,
	      sextaPeriodo2: undefined,
	      sabadoPeriodo1: undefined,
	      sabadoPeriodo2: undefined,
	      domingoPeriodo1: undefined,
	      domingoPeriodo2: undefined,
	      feriadoPeriodo1: undefined,
	      feriadoPeriodo2: undefined
	    };
	  },
	  mounted: function mounted() {
	    this.getHorariosParceiros(this.moveMaisIdParceiroSelecionado);
	  },
	
	
	  computed: {},
	  methods: {
	    getHorariosParceiros: function getHorariosParceiros(moveMaisId) {
	      var _this = this;
	
	      _account2.default.getHorariosParceiros(moveMaisId).then(function (res) {
	        if (res.status.code === 0) {
	          _this.segundaPeriodo1 = res.listaHorarios.segundaPeriodo1;
	          _this.segundaPeriodo2 = res.listaHorarios.segundaPeriodo2;
	          _this.tercaPeriodo1 = res.listaHorarios.tercaPeriodo1;
	          _this.tercaPeriodo2 = res.listaHorarios.tercaPeriodo2;
	          _this.quartaPeriodo1 = res.listaHorarios.quartaPeriodo1;
	          _this.quartaPeriodo2 = res.listaHorarios.quartaPeriodo2;
	          _this.quintaPeriodo1 = res.listaHorarios.quintaPeriodo1;
	          _this.quintaPeriodo2 = res.listaHorarios.quintaPeriodo2;
	          _this.sextaPeriodo1 = res.listaHorarios.sextaPeriodo1;
	          _this.sextaPeriodo2 = res.listaHorarios.sextaPeriodo2;
	          _this.sabadoPeriodo1 = res.listaHorarios.sabadoPeriodo1;
	          _this.sabadoPeriodo2 = res.listaHorarios.sabadoPeriodo2;
	          _this.domingoPeriodo1 = res.listaHorarios.domingoPeriodo1;
	          _this.domingoPeriodo2 = res.listaHorarios.domingoPeriodo2;
	          _this.feriadoPeriodo1 = res.listaHorarios.feriadoPeriodo1;
	          _this.feriadoPeriodo2 = res.listaHorarios.feriadoPeriodo2;
	        }
	      }).catch(function (error) {
	        console.log(error, "erro do catch");
	      });
	    },
	    fecharModal: function fecharModal() {
	      this.$emit("fecharModal", 1);
	    }
	  }
	};

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(99);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['partner', 'userPosition'],
	  data: function data() {
	    return {
	      open: false,
	      isMobile: false,
	      aux: {
	        seg: null,
	        ter: null,
	        qua: null,
	        qui: null,
	        sex: null,
	        sab: null,
	        dom: null
	      },
	      schedulesCombination: {
	        combination1: null,
	        combination2: null
	      }
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    window.addEventListener('scroll', function () {
	      return window.scrollY > 0 ? _this.isScrolling = true : _this.isScrolling = false;
	    });
	
	    if (window.innerWidth <= 769) {
	      this.isMobile = true;
	    } else {
	      this.isMobile = false;
	    }
	    this.formatSchedules();
	  },
	
	
	  components: {},
	  computed: {
	    hourWeek: function hourWeek() {
	      if (this.partner.segunda) {
	        if (this.partner.segunda.indexOf('-') > -1) {
	          return this.partner.segunda.replace('-', ' às ');
	        }
	        return 'Fechado';
	      }
	    },
	    saturdayAndSunday: function saturdayAndSunday() {
	      var _partner = this.partner,
	          sabado = _partner.sabado,
	          domingo = _partner.domingo;
	
	
	      if (this.formatScheduleMethod(sabado) == this.formatScheduleMethod(domingo)) {
	        return 'Sab e Dom: ' + this.formatScheduleMethod(sabado);
	      } else {
	        this.aux.sab = 'Sab: ' + this.formatScheduleMethod(sabado);
	        this.aux.dom = 'Dom: ' + this.formatScheduleMethod(domingo);
	        return false;
	      }
	    },
	    tel: function tel() {
	      if (this.partner.telefone && this.partner.dddTelefone) return 'tel:' + this.partner.dddTelefone + this.partner.telefone;
	    }
	  },
	  filters: {
	    formatCep: function formatCep(cep) {
	      return cep.substring(0, 5) + '-' + cep.substring(5);
	    },
	    formatDistance: function formatDistance(distance) {
	      if (distance) return distance.toFixed(2);
	    },
	    formatSchedule: function formatSchedule(day) {
	      return this.formatScheduleMethod(day);
	    }
	  },
	  methods: {
	    showModalHorarios: function showModalHorarios() {
	      this.$emit("showModalHorarios", 1);
	    },
	    formatScheduleMethod: function formatScheduleMethod(day) {
	      if (day) return day.trim().replace('-', ' às ');else return 'Fechado';
	    },
	    checkSchedules: function checkSchedules() {
	      var _partner2 = this.partner,
	          segunda = _partner2.segunda,
	          terca = _partner2.terca,
	          quarta = _partner2.quarta,
	          quinta = _partner2.quinta,
	          sexta = _partner2.sexta,
	          sabado = _partner2.sabado,
	          domingo = _partner2.domingo;
	
	
	      if (segunda || terca || quarta || quinta || sexta || sabado || domingo) return true;else return false;
	    },
	    hideDetail: function hideDetail() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        _this2.open = false;
	      }, 10);
	    },
	    showDetail: function showDetail() {
	      this.$emit("getMoveMaisId", this.partner.moveMaisId);
	      this.open = true;
	    },
	    openMapWindow: function openMapWindow() {
	      var url = void 0;
	      url = 'https://www.google.com/maps/dir/?api=1&origin=' + this.userPosition.latitude + ',' + this.userPosition.longitude + '&destination=' + this.partner.latitude + ',' + this.partner.longitude;
	      window.open(url, '_blank', 'toolbar=yes, scrollbars=yes, resizable=yes, height=4000, width=4000');
	    },
	    formatSchedules: function formatSchedules() {
	      var _this3 = this;
	
	      var schedules = [{ id: 0, day: 'Seg', schedule: this.formatScheduleMethod(this.partner.segunda) }, { id: 1, day: 'Ter', schedule: this.formatScheduleMethod(this.partner.terca) }, { id: 2, day: 'Qua', schedule: this.formatScheduleMethod(this.partner.quarta) }, { id: 3, day: 'Qui', schedule: this.formatScheduleMethod(this.partner.quinta) }, { id: 4, day: 'Sex', schedule: this.formatScheduleMethod(this.partner.sexta) }];
	
	      var previousElement = -1;
	      var schedulesEquals = [];
	      var allSchedulesEquals = [];
	      var schedulesNotEquals = [];
	      schedules.forEach(function (element, index) {
	        if (previousElement.schedule == element.schedule) {
	          schedulesEquals.push(previousElement);
	          schedulesEquals.push(element);
	        } else if (schedulesEquals.length > 0) {
	          if (!_this3.schedulesCombination.combination1) {
	            _this3.schedulesCombination.combination1 = schedulesEquals[0].day + ' a ' + schedulesEquals[schedulesEquals.length - 1].day + ': ' + schedulesEquals[0].schedule;
	          } else {
	            _this3.schedulesCombination.combination2 = schedulesEquals[0].day + ' a ' + schedulesEquals[schedulesEquals.length - 1].day + ': ' + schedulesEquals[0].schedule;
	          }
	
	          allSchedulesEquals.push.apply(allSchedulesEquals, (0, _toConsumableArray3.default)(schedulesEquals));
	
	          schedulesEquals = [];
	        }
	
	        if (index == 4) {
	          if (schedulesEquals.length) {
	            _this3.schedulesCombination.combination2 = schedulesEquals[0].day + ' a ' + schedulesEquals[schedulesEquals.length - 1].day + ': ' + schedulesEquals[0].schedule;
	
	            allSchedulesEquals.push.apply(allSchedulesEquals, (0, _toConsumableArray3.default)(schedulesEquals));
	          }
	        }
	        previousElement = element;
	      });
	
	      schedulesNotEquals = schedules.filter(function (schedule) {
	        return !(allSchedulesEquals.indexOf(schedule) !== -1);
	      });
	
	      schedulesNotEquals.forEach(function (element) {
	        return _this3.aux[element.day.toLowerCase()] = element.day + ': ' + element.schedule;
	      });
	    }
	  }
	};

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _route = __webpack_require__(59);
	
	var _route2 = _interopRequireDefault(_route);
	
	var _pagination = __webpack_require__(33);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['routeIdSelected'],
	  data: function data() {
	    return {
	      routes: undefined,
	      page: new _pagination.Page().size(5),
	      loading: undefined,
	      search: '',
	      filterActive: true,
	      isActiveArray: [],
	      routeSelected: this.routeIdSelected ? this.routeIdSelected.routeId : undefined,
	      showAlert: true,
	      warning: false,
	      msgStrong: 'Nova forma de consulta.',
	      msgAlert: ' Para saber a relação de rotas cadastradas, faça uma pesquisa individual digitando o nome da rota ou clique na lupa com o campo vazio, para uma consulta geral.'
	    };
	  },
	  mounted: function mounted() {
	    if (this.allRoutes) {
	      this.routes = this.allRoutes;
	      this.page = this.page.itemCount(this.allRoutes.length);
	    }
	  },
	
	
	  watch: {
	    search: function search() {
	      this.page = this.page.page(1);
	    },
	    filterActive: function filterActive() {
	      this.filter();
	      this.search = '';
	      this.page = this.page.page(1);
	    },
	    routeSelected: function routeSelected(newVal) {
	      var vm = this;
	      var r = _.find(this.routes, function (o) {
	        return o.routeId == vm.routeSelected;
	      });
	
	      vm.$emit('input', r);
	    }
	  },
	
	  computed: {
	    allRoutes: function allRoutes() {
	
	      if (this.filterActive) return this.$store.getters.getRoutesActive;
	
	      return this.$store.state.route.inactives;
	    },
	    routesPaged: function routesPaged() {
	      if (this.routes && this.page) {
	        for (var i = 0; i < this.routes.length; i++) {
	          this.$set(this.routes[i], 'open', false);
	        }
	        return this.routes.slice(this.page.firstIndexShown() - 1, this.page.lastIndexShown());
	      }
	      return undefined;
	    }
	  },
	  methods: {
	    searchRoutes: function searchRoutes() {
	      var _this = this;
	
	      $('[data-toggle="tooltip"]').tooltip();
	      this.loading = this.$store.dispatch('getRoutes', this.search).then(function (resp) {
	        if (_this.allRoutes.length !== 0) {
	          _this.routes = _this.allRoutes;
	          _this.page = _this.page.itemCount(_this.allRoutes.length);
	          _this.showAlert = false;
	        } else {
	          _this.msgStrong = 'Rota não encontrada!';
	          _this.msgAlert = 'Faça uma nova busca ou cadastre uma nova rota.';
	          _this.warning = true;
	          _this.showAlert = true;
	        }
	      });
	    },
	    setCurrentPage: function setCurrentPage(p) {
	      this.page = this.page.page(p);
	    },
	    getCity: function getCity(route, type) {
	      var p = _.find(route.points, function (o) {
	        return o.type == type;
	      });
	
	      if (p) return p.city + ', ' + p.state;
	
	      return "";
	    },
	    getAddress: function getAddress(route, type) {
	      var p = _.find(route.points, function (o) {
	        return o.type == type;
	      });
	
	      if (p) return p.address;
	
	      return "";
	    },
	    imageMap: function imageMap(r) {
	      var origin = this.getAddress(r, 'origin');
	      var dest = this.getAddress(r, 'destination');
	      var url = "https://maps.googleapis.com/maps/api/staticmap?scale=1&size=260x150&maptype=roadmap&format=png&visual_refresh=true";
	      url += '&markers=icon:https://movemais.com/static/pins/pin-origin-small.png%7Cshadow:true%7C' + origin;
	      url += '&markers=icon:https://movemais.com/static/pins/pin-destination-small.png%7Cshadow:true%7C' + dest;
	
	      _.filter(r.pointList.pointLocation, function (o) {
	        return o.type == 'waypoint';
	      }).forEach(function (o) {
	        url += '&markers=icon:https://movemais.com/static/pins/pin-waypoint-small.png%7Cshadow:true%7C' + o.address;
	      });
	
	      _.forEach(r.tollFeeList.tollFee, function (o) {
	        url += '&markers=icon:https://movemais.com/static/pins/pin-toll-small.png%7Cshadow:true%7C' + o.lat + ',' + o.lng;
	      });
	
	      url += '&path=enc:' + r.description + '&key=AIzaSyAzAwCX1zCJ9idWkNdxs39j36N4lAToIjE';
	
	      return url;
	    },
	
	
	    filter: _.debounce(function () {
	      var _this2 = this;
	
	      this.search = this.search.toUpperCase();
	
	      if (!this.allRoutes) return;
	
	      if (this.search == '') {
	        this.routes = this.allRoutes;
	        this.page = this.page.itemCount(this.routes.length);
	
	        if (this.routes.length === 0) {
	          this.msgStrong = 'Rota não encontrada!';
	          this.msgAlert = 'Faça uma nova busca ou cadastre uma nova rota.';
	          this.warning = true;
	          this.showAlert = true;
	        }
	        return;
	      }
	      this.routes = this.allRoutes.filter(function (value) {
	        var a = value.name.toUpperCase().indexOf(_this2.search) >= 0 || value.flexField1 && value.flexField1.toUpperCase().indexOf(_this2.search) >= 0 || value.flexField2 && value.flexField2.toUpperCase().indexOf(_this2.search) >= 0;
	        var b = _.filter(value.points, function (o) {
	
	          return o.address && o.address.toUpperCase().indexOf(_this2.search) >= 0;
	        }).length > 0;
	
	        return a || b;
	      });
	
	      if (this.routes.length == 0) {
	        this.msgStrong = 'Rota não encontrada!';
	        this.msgAlert = 'Faça uma nova busca ou cadastre uma nova rota.';
	        this.warning = true;
	        this.showAlert = true;
	      } else {
	        this.showAlert = false;
	      }
	
	      this.page = this.page.itemCount(this.routes.length);
	    }, 400)
	
	  },
	  components: {
	    Pagination: _pagination2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(49);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(122);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _routes = __webpack_require__(97);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _index = __webpack_require__(172);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cfg = {
	  API_BASE: '/api'
	};
	
	function run() {
	  configAxios();
	}
	
	function configAxios() {
	  _axios2.default.defaults.baseURL = cfg.API_BASE;
	  _axios2.default.defaults.timeout = 10000000;
	  _axios2.default.interceptors.response.use(function (res) {
	    var mmStatus = res.data && res.data.status && res.data.status.code || undefined;
	
	    var statusOK = res.status >= 200 && res.status <= 299;
	    if (!statusOK) return _promise2.default.reject(res);
	
	    switch (mmStatus) {
	      case 9000:
	        res.status = 400;
	
	        if (res.config.url.indexOf("getListChildAccount") >= 0) return res;
	
	        _auth2.default.logout().then(function () {
	          _routes.router.push({ name: 'login', query: { sessionExpired: true } });
	        });
	        return res;
	        break;
	
	      case 0:
	      case undefined:
	        return res;
	
	      default:
	
	        res.status = 400;
	        return _promise2.default.reject(res);
	    }
	  }, function (error) {
	    if (error && error.response) {
	      var raw = error.response.data || {};
	      var normalized = raw;
	      if (typeof raw.status === 'number') {
	        var message = raw.message || 'Erro';
	        normalized = (0, _assign2.default)({}, raw, {
	          status: { code: raw.status, message: message },
	          message: message
	        });
	      }
	      return _promise2.default.reject((0, _assign2.default)({}, error.response, { data: normalized }));
	    }
	    return _promise2.default.reject(error);
	  });
	}
	
	exports.default = (0, _extends3.default)({}, cfg, {
	  run: run
	});

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(49);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _veeValidate = __webpack_require__(511);
	
	var _veeValidate2 = _interopRequireDefault(_veeValidate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var f = _veeValidate2.default.Validator.prototype.validateAll;
	_veeValidate2.default.Validator.prototype.validateAll = function validateAll(values2) {
	  var _this = this;
	
	  return f.apply(this, values2).then(function (r) {
	    if (!r) {
	      return _promise2.default.reject(_this);
	    }
	    return r;
	  });
	};
	
	exports.default = (0, _extends3.default)({}, _veeValidate2.default);

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(1501);
	
	var _brandMark = __webpack_require__(168);
	
	exports.default = {
	  inserted: function inserted(el) {
	    var overlay = $("<div class='async-overlay'><div class='spinner'>" + "<svg class='loading-draw-svg' viewBox='" + _brandMark.MOVE_MAIS_MARK_VIEWBOX + "' xmlns='http://www.w3.org/2000/svg'>" + "<path class='loading-draw-path' fill-rule='evenodd' clip-rule='evenodd' d='" + _brandMark.MOVE_MAIS_MARK_PATH + "'/>" + "</svg>" + "</div></div>");
	    $(el).append(overlay).data('overlay-div', overlay);
	  },
	  update: function update(el, binding) {
	    if (binding.value === binding.oldValue) return;
	    var $el = $(el);
	    var overlay = $el.data('overlay-div');
	
	    $el.css('position', 'relative');
	    if (binding.modifiers.opacity) overlay.addClass('opacity-loading');else overlay.removeClass('opacity-loading');
	
	    overlay.width($el.width() + 20);
	    overlay.height($el.height());
	    overlay.show();
	    binding.value.then(function () {
	      return overlay.hide();
	    }).catch(function () {
	      return overlay.hide();
	    });
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _async = __webpack_require__(628);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _mask = __webpack_require__(630);
	
	var _onlyNumbers = __webpack_require__(631);
	
	var _onlyNumbers2 = _interopRequireDefault(_onlyNumbers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  install: function install(Vue, options) {
	    Vue.directive('async', _async2.default);
	    Vue.directive('mask-tel', _mask.maskTel);
	    Vue.directive('mask-cpf-cnpj', _mask.maskCpfCnpj);
	    Vue.directive('only-numbers', _onlyNumbers2.default);
	    Vue.directive('mask-money', _mask.maskMoney);
	    Vue.directive('mask-card', _mask.maskCard);
	    Vue.directive('mask-plate', _mask.maskPlate);
	    Vue.directive('mask-birth', _mask.maskBirth);
	    Vue.directive('mask-cpf', _mask.maskCpf);
	    Vue.directive('mask-cnpj', _mask.maskCnpj);
	    Vue.directive('mask-hour', _mask.maskHour);
	    Vue.directive('mask-one-real', _mask.maskOneReal);
	    Vue.directive('mask-cep', _mask.maskCep);
	  }
	};

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.maskCep = exports.maskHour = exports.maskCnpj = exports.maskBirth = exports.maskPlate = exports.maskCard = exports.maskTel = exports.maskOneReal = exports.maskMoney = exports.maskCpf = exports.maskCpfCnpj = undefined;
	
	var _get2 = __webpack_require__(776);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _getPrototypeOf = __webpack_require__(175);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _possibleConstructorReturn2 = __webpack_require__(247);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(246);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(28);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(1694);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Mask = function () {
	  function Mask(el, binding, vnode) {
	    (0, _classCallCheck3.default)(this, Mask);
	
	    this.el = el;
	
	    $(el).mask(this.maskBehavior, this.getOptions());
	
	    $(el).on('change.mask keyup', function (e) {
	      if (e.type === 'change' && vnode.data.on && vnode.data.on.change) {
	        vnode.data.on.change(e);
	      }
	      if (vnode.data.on && vnode.data.on.input) {
	        vnode.data.on.input(e);
	      }
	      if (vnode.data.nativeOn && vnode.data.nativeOn.input) {
	        vnode.data.nativeOn.input(e);
	      }
	    });
	  }
	
	  (0, _createClass3.default)(Mask, [{
	    key: 'getOptions',
	    value: function getOptions() {
	      return {
	        onKeyPress: this.maskEventHandler.bind(this),
	        onBlur: this.maskEventHandler.bind(this)
	      };
	    }
	  }, {
	    key: 'maskBehavior',
	    value: function maskBehavior(val, e, field, options) {
	      throw "NotImplemented";
	    }
	  }, {
	    key: 'maskEventHandler',
	    value: function maskEventHandler(val, e, field, options) {
	      field.mask(this.maskBehavior(val, e, field, options), options);
	    }
	  }]);
	  return Mask;
	}();
	
	var MaskUppercaseAlphanumeric = function (_Mask) {
	  (0, _inherits3.default)(MaskUppercaseAlphanumeric, _Mask);
	
	  function MaskUppercaseAlphanumeric() {
	    (0, _classCallCheck3.default)(this, MaskUppercaseAlphanumeric);
	    return (0, _possibleConstructorReturn3.default)(this, (MaskUppercaseAlphanumeric.__proto__ || (0, _getPrototypeOf2.default)(MaskUppercaseAlphanumeric)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MaskUppercaseAlphanumeric, [{
	    key: 'maskEventHandler',
	    value: function maskEventHandler(val, e, field, options) {
	      var normalized = (val || '').toUpperCase();
	      if (normalized !== val) {
	        field.val(normalized).trigger('input');
	      }
	      field.mask(this.maskBehavior(normalized, e, field, options), options);
	    }
	  }]);
	  return MaskUppercaseAlphanumeric;
	}(Mask);
	
	var MaskCpfCnpj = function (_MaskUppercaseAlphanu) {
	  (0, _inherits3.default)(MaskCpfCnpj, _MaskUppercaseAlphanu);
	
	  function MaskCpfCnpj() {
	    (0, _classCallCheck3.default)(this, MaskCpfCnpj);
	    return (0, _possibleConstructorReturn3.default)(this, (MaskCpfCnpj.__proto__ || (0, _getPrototypeOf2.default)(MaskCpfCnpj)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MaskCpfCnpj, [{
	    key: 'maskBehavior',
	    value: function maskBehavior(val, e, field, options) {
	      var cleaned = val.replace(/[.\-\/]/g, '');
	
	      return cleaned.length <= 11 ? 'AAA.AAA.AAA-AAAAA' : 'AA.AAA.AAA/AAAA-00';
	    }
	  }]);
	  return MaskCpfCnpj;
	}(MaskUppercaseAlphanumeric);
	
	var MaskMoney = function (_Mask2) {
	  (0, _inherits3.default)(MaskMoney, _Mask2);
	
	  function MaskMoney() {
	    (0, _classCallCheck3.default)(this, MaskMoney);
	    return (0, _possibleConstructorReturn3.default)(this, (MaskMoney.__proto__ || (0, _getPrototypeOf2.default)(MaskMoney)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MaskMoney, [{
	    key: 'maskBehavior',
	    value: function maskBehavior(val, e, field, options) {
	      return '000.000.000.000.000,00';
	    }
	  }, {
	    key: 'getOptions',
	    value: function getOptions() {
	      _.extend({}, (0, _get3.default)(MaskMoney.prototype.__proto__ || (0, _getPrototypeOf2.default)(MaskMoney.prototype), 'getOptions', this).call(this), {
	        reverse: true, selectOnFocus: true
	      });
	    }
	  }]);
	  return MaskMoney;
	}(Mask);
	
	var MaskOneReal = function (_Mask3) {
	  (0, _inherits3.default)(MaskOneReal, _Mask3);
	
	  function MaskOneReal() {
	    (0, _classCallCheck3.default)(this, MaskOneReal);
	    return (0, _possibleConstructorReturn3.default)(this, (MaskOneReal.__proto__ || (0, _getPrototypeOf2.default)(MaskOneReal)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MaskOneReal, [{
	    key: 'maskBehavior',
	    value: function maskBehavior(val, e, field, options) {
	      return '0,00';
	    }
	  }, {
	    key: 'getOptions',
	    value: function getOptions() {
	      _.extend({}, (0, _get3.default)(MaskOneReal.prototype.__proto__ || (0, _getPrototypeOf2.default)(MaskOneReal.prototype), 'getOptions', this).call(this), {
	        reverse: true, selectOnFocus: true
	      });
	    }
	  }]);
	  return MaskOneReal;
	}(Mask);
	
	var MaskTel = function (_Mask4) {
	  (0, _inherits3.default)(MaskTel, _Mask4);
	
	  function MaskTel() {
	    (0, _classCallCheck3.default)(this, MaskTel);
	    return (0, _possibleConstructorReturn3.default)(this, (MaskTel.__proto__ || (0, _getPrototypeOf2.default)(MaskTel)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MaskTel, [{
	    key: 'maskBehavior',
	    value: function maskBehavior(val, e, field, options) {
	      return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
	    }
	  }]);
	  return MaskTel;
	}(Mask);
	
	var MaskCard = function (_Mask5) {
	  (0, _inherits3.default)(MaskCard, _Mask5);
	
	  function MaskCard() {
	    (0, _classCallCheck3.default)(this, MaskCard);
	    return (0, _possibleConstructorReturn3.default)(this, (MaskCard.__proto__ || (0, _getPrototypeOf2.default)(MaskCard)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MaskCard, [{
	    key: 'maskBehavior',
	    value: function maskBehavior(val, e, field, options) {
	      return '0000.0000.0000.0099';
	    }
	  }]);
	  return MaskCard;
	}(Mask);
	
	var MaskPlate = function (_Mask6) {
	  (0, _inherits3.default)(MaskPlate, _Mask6);
	
	  function MaskPlate() {
	    (0, _classCallCheck3.default)(this, MaskPlate);
	    return (0, _possibleConstructorReturn3.default)(this, (MaskPlate.__proto__ || (0, _getPrototypeOf2.default)(MaskPlate)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MaskPlate, [{
	    key: 'maskBehavior',
	    value: function maskBehavior(val, e, field, options) {
	      return 'AAA-AAAA';
	    }
	  }]);
	  return MaskPlate;
	}(Mask);
	
	var MaskBirth = function (_Mask7) {
	  (0, _inherits3.default)(MaskBirth, _Mask7);
	
	  function MaskBirth() {
	    (0, _classCallCheck3.default)(this, MaskBirth);
	    return (0, _possibleConstructorReturn3.default)(this, (MaskBirth.__proto__ || (0, _getPrototypeOf2.default)(MaskBirth)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MaskBirth, [{
	    key: 'maskBehavior',
	    value: function maskBehavior(val, e, field, options) {
	      return '00/00/0000';
	    }
	  }]);
	  return MaskBirth;
	}(Mask);
	
	var MaskCpf = function (_Mask8) {
	  (0, _inherits3.default)(MaskCpf, _Mask8);
	
	  function MaskCpf() {
	    (0, _classCallCheck3.default)(this, MaskCpf);
	    return (0, _possibleConstructorReturn3.default)(this, (MaskCpf.__proto__ || (0, _getPrototypeOf2.default)(MaskCpf)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MaskCpf, [{
	    key: 'maskBehavior',
	    value: function maskBehavior(val, e, field, options) {
	      return '000.000.000-00';
	    }
	  }]);
	  return MaskCpf;
	}(Mask);
	
	var MaskCnpj = function (_MaskUppercaseAlphanu2) {
	  (0, _inherits3.default)(MaskCnpj, _MaskUppercaseAlphanu2);
	
	  function MaskCnpj() {
	    (0, _classCallCheck3.default)(this, MaskCnpj);
	    return (0, _possibleConstructorReturn3.default)(this, (MaskCnpj.__proto__ || (0, _getPrototypeOf2.default)(MaskCnpj)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MaskCnpj, [{
	    key: 'maskBehavior',
	    value: function maskBehavior(val, e, field, options) {
	      return 'AA.AAA.AAA/AAAA-00';
	    }
	  }]);
	  return MaskCnpj;
	}(MaskUppercaseAlphanumeric);
	
	var MaskHour = function (_Mask9) {
	  (0, _inherits3.default)(MaskHour, _Mask9);
	
	  function MaskHour() {
	    (0, _classCallCheck3.default)(this, MaskHour);
	    return (0, _possibleConstructorReturn3.default)(this, (MaskHour.__proto__ || (0, _getPrototypeOf2.default)(MaskHour)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MaskHour, [{
	    key: 'maskBehavior',
	    value: function maskBehavior(val, e, field, options) {
	      return '00:00:00';
	    }
	  }]);
	  return MaskHour;
	}(Mask);
	
	var MaskCep = function (_Mask10) {
	  (0, _inherits3.default)(MaskCep, _Mask10);
	
	  function MaskCep() {
	    (0, _classCallCheck3.default)(this, MaskCep);
	    return (0, _possibleConstructorReturn3.default)(this, (MaskCep.__proto__ || (0, _getPrototypeOf2.default)(MaskCep)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MaskCep, [{
	    key: 'maskBehavior',
	    value: function maskBehavior(val, e, field, options) {
	      return '00000-000';
	    }
	  }]);
	  return MaskCep;
	}(Mask);
	
	var maskCpfCnpj = exports.maskCpfCnpj = {
	  bind: function bind(el, binding, vnode) {
	    return new MaskCpfCnpj(el, binding, vnode);
	  }
	};
	
	var maskCpf = exports.maskCpf = {
	  bind: function bind(el, binding, vnode) {
	    return new MaskCpf(el, binding, vnode);
	  }
	};
	
	var maskMoney = exports.maskMoney = {
	  bind: function bind(el, binding, vnode) {
	    return new MaskMoney(el, binding, vnode);
	  }
	};
	
	var maskOneReal = exports.maskOneReal = {
	  bind: function bind(el, binding, vnode) {
	    return new MaskOneReal(el, binding, vnode);
	  }
	};
	
	var maskTel = exports.maskTel = {
	  bind: function bind(el, binding, vnode) {
	    return new MaskTel(el, binding, vnode);
	  }
	};
	
	var maskCard = exports.maskCard = {
	  bind: function bind(el, binding, vnode) {
	    return new MaskCard(el, binding, vnode);
	  }
	};
	
	var maskPlate = exports.maskPlate = {
	  bind: function bind(el, binding, vnode) {
	    return new MaskPlate(el, binding, vnode);
	  }
	};
	
	var maskBirth = exports.maskBirth = {
	  bind: function bind(el, binding, vnode) {
	    return new MaskBirth(el, binding, vnode);
	  }
	};
	
	var maskCnpj = exports.maskCnpj = {
	  bind: function bind(el, binding, vnode) {
	    return new MaskCnpj(el, binding, vnode);
	  }
	};
	
	var maskHour = exports.maskHour = {
	  bind: function bind(el, binding, vnode) {
	    return new MaskHour(el, binding, vnode);
	  }
	};
	
	var maskCep = exports.maskCep = {
	  bind: function bind(el, binding, vnode) {
	    return new MaskCep(el, binding, vnode);
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  bind: function bind(el, binding) {
	    $(el).keypress(isNumber);
	  }
	};
	
	
	var isNumber = function isNumber(evt) {
	  evt = evt ? evt : window.event;
	  var charCode = evt.which ? evt.which : evt.keyCode;
	  if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
	    evt.preventDefault();;
	  } else {
	    return true;
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sjcl = { cipher: {}, hash: {}, keyexchange: {}, mode: {}, misc: {}, codec: {}, exception: { corrupt: function corrupt(a) {
	      this.toString = function () {
	        return "CORRUPT: " + this.message;
	      };this.message = a;
	    }, invalid: function invalid(a) {
	      this.toString = function () {
	        return "INVALID: " + this.message;
	      };this.message = a;
	    }, bug: function bug(a) {
	      this.toString = function () {
	        return "BUG: " + this.message;
	      };this.message = a;
	    }, notReady: function notReady(a) {
	      this.toString = function () {
	        return "NOT READY: " + this.message;
	      };this.message = a;
	    } } };
	sjcl.cipher.aes = function (a) {
	  this.s[0][0][0] || this.O();var b,
	      c,
	      d,
	      e,
	      f = this.s[0][4],
	      g = this.s[1];b = a.length;var h = 1;if (4 !== b && 6 !== b && 8 !== b) throw new sjcl.exception.invalid("invalid aes key size");this.b = [d = a.slice(0), e = []];for (a = b; a < 4 * b + 28; a++) {
	    c = d[a - 1];if (0 === a % b || 8 === b && 4 === a % b) c = f[c >>> 24] << 24 ^ f[c >> 16 & 255] << 16 ^ f[c >> 8 & 255] << 8 ^ f[c & 255], 0 === a % b && (c = c << 8 ^ c >>> 24 ^ h << 24, h = h << 1 ^ 283 * (h >> 7));d[a] = d[a - b] ^ c;
	  }for (b = 0; a; b++, a--) {
	    c = d[b & 3 ? a : a - 4], e[b] = 4 >= a || 4 > b ? c : g[0][f[c >>> 24]] ^ g[1][f[c >> 16 & 255]] ^ g[2][f[c >> 8 & 255]] ^ g[3][f[c & 255]];
	  }
	};
	sjcl.cipher.aes.prototype = { encrypt: function encrypt(a) {
	    return t(this, a, 0);
	  }, decrypt: function decrypt(a) {
	    return t(this, a, 1);
	  }, s: [[[], [], [], [], []], [[], [], [], [], []]], O: function O() {
	    var a = this.s[0],
	        b = this.s[1],
	        c = a[4],
	        d = b[4],
	        e,
	        f,
	        g,
	        h = [],
	        k = [],
	        l,
	        n,
	        m,
	        p;for (e = 0; 0x100 > e; e++) {
	      k[(h[e] = e << 1 ^ 283 * (e >> 7)) ^ e] = e;
	    }for (f = g = 0; !c[f]; f ^= l || 1, g = k[g] || 1) {
	      for (m = g ^ g << 1 ^ g << 2 ^ g << 3 ^ g << 4, m = m >> 8 ^ m & 255 ^ 99, c[f] = m, d[m] = f, n = h[e = h[l = h[f]]], p = 0x1010101 * n ^ 0x10001 * e ^ 0x101 * l ^ 0x1010100 * f, n = 0x101 * h[m] ^ 0x1010100 * m, e = 0; 4 > e; e++) {
	        a[e][f] = n = n << 24 ^ n >>> 8, b[e][m] = p = p << 24 ^ p >>> 8;
	      }
	    }for (e = 0; 5 > e; e++) {
	      a[e] = a[e].slice(0), b[e] = b[e].slice(0);
	    }
	  } };
	function t(a, b, c) {
	  if (4 !== b.length) throw new sjcl.exception.invalid("invalid aes block size");var d = a.b[c],
	      e = b[0] ^ d[0],
	      f = b[c ? 3 : 1] ^ d[1],
	      g = b[2] ^ d[2];b = b[c ? 1 : 3] ^ d[3];var h,
	      k,
	      l,
	      n = d.length / 4 - 2,
	      m,
	      p = 4,
	      r = [0, 0, 0, 0];h = a.s[c];a = h[0];var q = h[1],
	      v = h[2],
	      w = h[3],
	      x = h[4];for (m = 0; m < n; m++) {
	    h = a[e >>> 24] ^ q[f >> 16 & 255] ^ v[g >> 8 & 255] ^ w[b & 255] ^ d[p], k = a[f >>> 24] ^ q[g >> 16 & 255] ^ v[b >> 8 & 255] ^ w[e & 255] ^ d[p + 1], l = a[g >>> 24] ^ q[b >> 16 & 255] ^ v[e >> 8 & 255] ^ w[f & 255] ^ d[p + 2], b = a[b >>> 24] ^ q[e >> 16 & 255] ^ v[f >> 8 & 255] ^ w[g & 255] ^ d[p + 3], p += 4, e = h, f = k, g = l;
	  }for (m = 0; 4 > m; m++) {
	    r[c ? 3 & -m : m] = x[e >>> 24] << 24 ^ x[f >> 16 & 255] << 16 ^ x[g >> 8 & 255] << 8 ^ x[b & 255] ^ d[p++], h = e, e = f, f = g, g = b, b = h;
	  }return r;
	}
	sjcl.bitArray = { bitSlice: function bitSlice(a, b, c) {
	    a = sjcl.bitArray.$(a.slice(b / 32), 32 - (b & 31)).slice(1);return void 0 === c ? a : sjcl.bitArray.clamp(a, c - b);
	  }, extract: function extract(a, b, c) {
	    var d = Math.floor(-b - c & 31);return ((b + c - 1 ^ b) & -32 ? a[b / 32 | 0] << 32 - d ^ a[b / 32 + 1 | 0] >>> d : a[b / 32 | 0] >>> d) & (1 << c) - 1;
	  }, concat: function concat(a, b) {
	    if (0 === a.length || 0 === b.length) return a.concat(b);var c = a[a.length - 1],
	        d = sjcl.bitArray.getPartial(c);return 32 === d ? a.concat(b) : sjcl.bitArray.$(b, d, c | 0, a.slice(0, a.length - 1));
	  }, bitLength: function bitLength(a) {
	    var b = a.length;return 0 === b ? 0 : 32 * (b - 1) + sjcl.bitArray.getPartial(a[b - 1]);
	  }, clamp: function clamp(a, b) {
	    if (32 * a.length < b) return a;a = a.slice(0, Math.ceil(b / 32));var c = a.length;b = b & 31;0 < c && b && (a[c - 1] = sjcl.bitArray.partial(b, a[c - 1] & 2147483648 >> b - 1, 1));return a;
	  }, partial: function partial(a, b, c) {
	    return 32 === a ? b : (c ? b | 0 : b << 32 - a) + 0x10000000000 * a;
	  }, getPartial: function getPartial(a) {
	    return Math.round(a / 0x10000000000) || 32;
	  }, equal: function equal(a, b) {
	    if (sjcl.bitArray.bitLength(a) !== sjcl.bitArray.bitLength(b)) return !1;var c = 0,
	        d;for (d = 0; d < a.length; d++) {
	      c |= a[d] ^ b[d];
	    }return 0 === c;
	  }, $: function $(a, b, c, d) {
	    var e;e = 0;for (void 0 === d && (d = []); 32 <= b; b -= 32) {
	      d.push(c), c = 0;
	    }if (0 === b) return d.concat(a);for (e = 0; e < a.length; e++) {
	      d.push(c | a[e] >>> b), c = a[e] << 32 - b;
	    }e = a.length ? a[a.length - 1] : 0;a = sjcl.bitArray.getPartial(e);d.push(sjcl.bitArray.partial(b + a & 31, 32 < b + a ? c : d.pop(), 1));return d;
	  }, i: function i(a, b) {
	    return [a[0] ^ b[0], a[1] ^ b[1], a[2] ^ b[2], a[3] ^ b[3]];
	  }, byteswapM: function byteswapM(a) {
	    var b, c;for (b = 0; b < a.length; ++b) {
	      c = a[b], a[b] = c >>> 24 | c >>> 8 & 0xff00 | (c & 0xff00) << 8 | c << 24;
	    }return a;
	  } };
	sjcl.codec.utf8String = { fromBits: function fromBits(a) {
	    var b = "",
	        c = sjcl.bitArray.bitLength(a),
	        d,
	        e;for (d = 0; d < c / 8; d++) {
	      0 === (d & 3) && (e = a[d / 4]), b += String.fromCharCode(e >>> 8 >>> 8 >>> 8), e <<= 8;
	    }return decodeURIComponent(escape(b));
	  }, toBits: function toBits(a) {
	    a = unescape(encodeURIComponent(a));var b = [],
	        c,
	        d = 0;for (c = 0; c < a.length; c++) {
	      d = d << 8 | a.charCodeAt(c), 3 === (c & 3) && (b.push(d), d = 0);
	    }c & 3 && b.push(sjcl.bitArray.partial(8 * (c & 3), d));return b;
	  } };
	sjcl.codec.hex = { fromBits: function fromBits(a) {
	    var b = "",
	        c;for (c = 0; c < a.length; c++) {
	      b += ((a[c] | 0) + 0xf00000000000).toString(16).substr(4);
	    }return b.substr(0, sjcl.bitArray.bitLength(a) / 4);
	  }, toBits: function toBits(a) {
	    var b,
	        c = [],
	        d;a = a.replace(/\s|0x/g, "");d = a.length;a = a + "00000000";for (b = 0; b < a.length; b += 8) {
	      c.push(parseInt(a.substr(b, 8), 16) ^ 0);
	    }return sjcl.bitArray.clamp(c, 4 * d);
	  } };
	sjcl.codec.base32 = { B: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567", X: "0123456789ABCDEFGHIJKLMNOPQRSTUV", BITS: 32, BASE: 5, REMAINING: 27, fromBits: function fromBits(a, b, c) {
	    var d = sjcl.codec.base32.BASE,
	        e = sjcl.codec.base32.REMAINING,
	        f = "",
	        g = 0,
	        h = sjcl.codec.base32.B,
	        k = 0,
	        l = sjcl.bitArray.bitLength(a);c && (h = sjcl.codec.base32.X);for (c = 0; f.length * d < l;) {
	      f += h.charAt((k ^ a[c] >>> g) >>> e), g < d ? (k = a[c] << d - g, g += e, c++) : (k <<= d, g -= d);
	    }for (; f.length & 7 && !b;) {
	      f += "=";
	    }return f;
	  }, toBits: function toBits(a, b) {
	    a = a.replace(/\s|=/g, "").toUpperCase();var c = sjcl.codec.base32.BITS,
	        d = sjcl.codec.base32.BASE,
	        e = sjcl.codec.base32.REMAINING,
	        f = [],
	        g,
	        h = 0,
	        k = sjcl.codec.base32.B,
	        l = 0,
	        n,
	        m = "base32";b && (k = sjcl.codec.base32.X, m = "base32hex");for (g = 0; g < a.length; g++) {
	      n = k.indexOf(a.charAt(g));if (0 > n) {
	        if (!b) try {
	          return sjcl.codec.base32hex.toBits(a);
	        } catch (p) {}throw new sjcl.exception.invalid("this isn't " + m + "!");
	      }h > e ? (h -= e, f.push(l ^ n >>> h), l = n << c - h) : (h += d, l ^= n << c - h);
	    }h & 56 && f.push(sjcl.bitArray.partial(h & 56, l, 1));return f;
	  } };
	sjcl.codec.base32hex = { fromBits: function fromBits(a, b) {
	    return sjcl.codec.base32.fromBits(a, b, 1);
	  }, toBits: function toBits(a) {
	    return sjcl.codec.base32.toBits(a, 1);
	  } };
	sjcl.codec.base64 = { B: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", fromBits: function fromBits(a, b, c) {
	    var d = "",
	        e = 0,
	        f = sjcl.codec.base64.B,
	        g = 0,
	        h = sjcl.bitArray.bitLength(a);c && (f = f.substr(0, 62) + "-_");for (c = 0; 6 * d.length < h;) {
	      d += f.charAt((g ^ a[c] >>> e) >>> 26), 6 > e ? (g = a[c] << 6 - e, e += 26, c++) : (g <<= 6, e -= 6);
	    }for (; d.length & 3 && !b;) {
	      d += "=";
	    }return d;
	  }, toBits: function toBits(a, b) {
	    a = a.replace(/\s|=/g, "");var c = [],
	        d,
	        e = 0,
	        f = sjcl.codec.base64.B,
	        g = 0,
	        h;b && (f = f.substr(0, 62) + "-_");for (d = 0; d < a.length; d++) {
	      h = f.indexOf(a.charAt(d));
	      if (0 > h) throw new sjcl.exception.invalid("this isn't base64!");26 < e ? (e -= 26, c.push(g ^ h >>> e), g = h << 32 - e) : (e += 6, g ^= h << 32 - e);
	    }e & 56 && c.push(sjcl.bitArray.partial(e & 56, g, 1));return c;
	  } };sjcl.codec.base64url = { fromBits: function fromBits(a) {
	    return sjcl.codec.base64.fromBits(a, 1, 1);
	  }, toBits: function toBits(a) {
	    return sjcl.codec.base64.toBits(a, 1);
	  } };sjcl.hash.sha256 = function (a) {
	  this.b[0] || this.O();a ? (this.F = a.F.slice(0), this.A = a.A.slice(0), this.l = a.l) : this.reset();
	};sjcl.hash.sha256.hash = function (a) {
	  return new sjcl.hash.sha256().update(a).finalize();
	};
	sjcl.hash.sha256.prototype = { blockSize: 512, reset: function reset() {
	    this.F = this.Y.slice(0);this.A = [];this.l = 0;return this;
	  }, update: function update(a) {
	    "string" === typeof a && (a = sjcl.codec.utf8String.toBits(a));var b,
	        c = this.A = sjcl.bitArray.concat(this.A, a);b = this.l;a = this.l = b + sjcl.bitArray.bitLength(a);if (0x1fffffffffffff < a) throw new sjcl.exception.invalid("Cannot hash more than 2^53 - 1 bits");if ("undefined" !== typeof Uint32Array) {
	      var d = new Uint32Array(c),
	          e = 0;for (b = 512 + b - (512 + b & 0x1ff); b <= a; b += 512) {
	        u(this, d.subarray(16 * e, 16 * (e + 1))), e += 1;
	      }c.splice(0, 16 * e);
	    } else for (b = 512 + b - (512 + b & 0x1ff); b <= a; b += 512) {
	      u(this, c.splice(0, 16));
	    }return this;
	  }, finalize: function finalize() {
	    var a,
	        b = this.A,
	        c = this.F,
	        b = sjcl.bitArray.concat(b, [sjcl.bitArray.partial(1, 1)]);for (a = b.length + 2; a & 15; a++) {
	      b.push(0);
	    }b.push(Math.floor(this.l / 0x100000000));for (b.push(this.l | 0); b.length;) {
	      u(this, b.splice(0, 16));
	    }this.reset();return c;
	  }, Y: [], b: [], O: function O() {
	    function a(a) {
	      return 0x100000000 * (a - Math.floor(a)) | 0;
	    }for (var b = 0, c = 2, d, e; 64 > b; c++) {
	      e = !0;for (d = 2; d * d <= c; d++) {
	        if (0 === c % d) {
	          e = !1;break;
	        }
	      }e && (8 > b && (this.Y[b] = a(Math.pow(c, .5))), this.b[b] = a(Math.pow(c, 1 / 3)), b++);
	    }
	  } };
	function u(a, b) {
	  var c,
	      d,
	      e,
	      f = a.F,
	      g = a.b,
	      h = f[0],
	      k = f[1],
	      l = f[2],
	      n = f[3],
	      m = f[4],
	      p = f[5],
	      r = f[6],
	      q = f[7];for (c = 0; 64 > c; c++) {
	    16 > c ? d = b[c] : (d = b[c + 1 & 15], e = b[c + 14 & 15], d = b[c & 15] = (d >>> 7 ^ d >>> 18 ^ d >>> 3 ^ d << 25 ^ d << 14) + (e >>> 17 ^ e >>> 19 ^ e >>> 10 ^ e << 15 ^ e << 13) + b[c & 15] + b[c + 9 & 15] | 0), d = d + q + (m >>> 6 ^ m >>> 11 ^ m >>> 25 ^ m << 26 ^ m << 21 ^ m << 7) + (r ^ m & (p ^ r)) + g[c], q = r, r = p, p = m, m = n + d | 0, n = l, l = k, k = h, h = d + (k & l ^ n & (k ^ l)) + (k >>> 2 ^ k >>> 13 ^ k >>> 22 ^ k << 30 ^ k << 19 ^ k << 10) | 0;
	  }f[0] = f[0] + h | 0;f[1] = f[1] + k | 0;f[2] = f[2] + l | 0;f[3] = f[3] + n | 0;f[4] = f[4] + m | 0;f[5] = f[5] + p | 0;f[6] = f[6] + r | 0;f[7] = f[7] + q | 0;
	}
	sjcl.mode.ccm = { name: "ccm", G: [], listenProgress: function listenProgress(a) {
	    sjcl.mode.ccm.G.push(a);
	  }, unListenProgress: function unListenProgress(a) {
	    a = sjcl.mode.ccm.G.indexOf(a);-1 < a && sjcl.mode.ccm.G.splice(a, 1);
	  }, fa: function fa(a) {
	    var b = sjcl.mode.ccm.G.slice(),
	        c;for (c = 0; c < b.length; c += 1) {
	      b[c](a);
	    }
	  }, encrypt: function encrypt(a, b, c, d, e) {
	    var f,
	        g = b.slice(0),
	        h = sjcl.bitArray,
	        k = h.bitLength(c) / 8,
	        l = h.bitLength(g) / 8;e = e || 64;d = d || [];if (7 > k) throw new sjcl.exception.invalid("ccm: iv must be at least 7 bytes");for (f = 2; 4 > f && l >>> 8 * f; f++) {}f < 15 - k && (f = 15 - k);c = h.clamp(c, 8 * (15 - f));b = sjcl.mode.ccm.V(a, b, c, d, e, f);g = sjcl.mode.ccm.C(a, g, c, b, e, f);return h.concat(g.data, g.tag);
	  }, decrypt: function decrypt(a, b, c, d, e) {
	    e = e || 64;d = d || [];var f = sjcl.bitArray,
	        g = f.bitLength(c) / 8,
	        h = f.bitLength(b),
	        k = f.clamp(b, h - e),
	        l = f.bitSlice(b, h - e),
	        h = (h - e) / 8;if (7 > g) throw new sjcl.exception.invalid("ccm: iv must be at least 7 bytes");for (b = 2; 4 > b && h >>> 8 * b; b++) {}b < 15 - g && (b = 15 - g);c = f.clamp(c, 8 * (15 - b));k = sjcl.mode.ccm.C(a, k, c, l, e, b);a = sjcl.mode.ccm.V(a, k.data, c, d, e, b);if (!f.equal(k.tag, a)) throw new sjcl.exception.corrupt("ccm: tag doesn't match");
	    return k.data;
	  }, na: function na(a, b, c, d, e, f) {
	    var g = [],
	        h = sjcl.bitArray,
	        k = h.i;d = [h.partial(8, (b.length ? 64 : 0) | d - 2 << 2 | f - 1)];d = h.concat(d, c);d[3] |= e;d = a.encrypt(d);if (b.length) for (c = h.bitLength(b) / 8, 65279 >= c ? g = [h.partial(16, c)] : 0xffffffff >= c && (g = h.concat([h.partial(16, 65534)], [c])), g = h.concat(g, b), b = 0; b < g.length; b += 4) {
	      d = a.encrypt(k(d, g.slice(b, b + 4).concat([0, 0, 0])));
	    }return d;
	  }, V: function V(a, b, c, d, e, f) {
	    var g = sjcl.bitArray,
	        h = g.i;e /= 8;if (e % 2 || 4 > e || 16 < e) throw new sjcl.exception.invalid("ccm: invalid tag length");
	    if (0xffffffff < d.length || 0xffffffff < b.length) throw new sjcl.exception.bug("ccm: can't deal with 4GiB or more data");c = sjcl.mode.ccm.na(a, d, c, e, g.bitLength(b) / 8, f);for (d = 0; d < b.length; d += 4) {
	      c = a.encrypt(h(c, b.slice(d, d + 4).concat([0, 0, 0])));
	    }return g.clamp(c, 8 * e);
	  }, C: function C(a, b, c, d, e, f) {
	    var g,
	        h = sjcl.bitArray;g = h.i;var k = b.length,
	        l = h.bitLength(b),
	        n = k / 50,
	        m = n;c = h.concat([h.partial(8, f - 1)], c).concat([0, 0, 0]).slice(0, 4);d = h.bitSlice(g(d, a.encrypt(c)), 0, e);if (!k) return { tag: d, data: [] };for (g = 0; g < k; g += 4) {
	      g > n && (sjcl.mode.ccm.fa(g / k), n += m), c[3]++, e = a.encrypt(c), b[g] ^= e[0], b[g + 1] ^= e[1], b[g + 2] ^= e[2], b[g + 3] ^= e[3];
	    }return { tag: d, data: h.clamp(b, l) };
	  } };
	sjcl.mode.ocb2 = { name: "ocb2", encrypt: function encrypt(a, b, c, d, e, f) {
	    if (128 !== sjcl.bitArray.bitLength(c)) throw new sjcl.exception.invalid("ocb iv must be 128 bits");var g,
	        h = sjcl.mode.ocb2.S,
	        k = sjcl.bitArray,
	        l = k.i,
	        n = [0, 0, 0, 0];c = h(a.encrypt(c));var m,
	        p = [];d = d || [];e = e || 64;for (g = 0; g + 4 < b.length; g += 4) {
	      m = b.slice(g, g + 4), n = l(n, m), p = p.concat(l(c, a.encrypt(l(c, m)))), c = h(c);
	    }m = b.slice(g);b = k.bitLength(m);g = a.encrypt(l(c, [0, 0, 0, b]));m = k.clamp(l(m.concat([0, 0, 0]), g), b);n = l(n, l(m.concat([0, 0, 0]), g));n = a.encrypt(l(n, l(c, h(c))));
	    d.length && (n = l(n, f ? d : sjcl.mode.ocb2.pmac(a, d)));return p.concat(k.concat(m, k.clamp(n, e)));
	  }, decrypt: function decrypt(a, b, c, d, e, f) {
	    if (128 !== sjcl.bitArray.bitLength(c)) throw new sjcl.exception.invalid("ocb iv must be 128 bits");e = e || 64;var g = sjcl.mode.ocb2.S,
	        h = sjcl.bitArray,
	        k = h.i,
	        l = [0, 0, 0, 0],
	        n = g(a.encrypt(c)),
	        m,
	        p,
	        r = sjcl.bitArray.bitLength(b) - e,
	        q = [];d = d || [];for (c = 0; c + 4 < r / 32; c += 4) {
	      m = k(n, a.decrypt(k(n, b.slice(c, c + 4)))), l = k(l, m), q = q.concat(m), n = g(n);
	    }p = r - 32 * c;m = a.encrypt(k(n, [0, 0, 0, p]));m = k(m, h.clamp(b.slice(c), p).concat([0, 0, 0]));l = k(l, m);l = a.encrypt(k(l, k(n, g(n))));d.length && (l = k(l, f ? d : sjcl.mode.ocb2.pmac(a, d)));if (!h.equal(h.clamp(l, e), h.bitSlice(b, r))) throw new sjcl.exception.corrupt("ocb: tag doesn't match");return q.concat(h.clamp(m, p));
	  }, pmac: function pmac(a, b) {
	    var c,
	        d = sjcl.mode.ocb2.S,
	        e = sjcl.bitArray,
	        f = e.i,
	        g = [0, 0, 0, 0],
	        h = a.encrypt([0, 0, 0, 0]),
	        h = f(h, d(d(h)));for (c = 0; c + 4 < b.length; c += 4) {
	      h = d(h), g = f(g, a.encrypt(f(h, b.slice(c, c + 4))));
	    }c = b.slice(c);128 > e.bitLength(c) && (h = f(h, d(h)), c = e.concat(c, [-2147483648, 0, 0, 0]));g = f(g, c);
	    return a.encrypt(f(d(f(h, d(h))), g));
	  }, S: function S(a) {
	    return [a[0] << 1 ^ a[1] >>> 31, a[1] << 1 ^ a[2] >>> 31, a[2] << 1 ^ a[3] >>> 31, a[3] << 1 ^ 135 * (a[0] >>> 31)];
	  } };
	sjcl.mode.gcm = { name: "gcm", encrypt: function encrypt(a, b, c, d, e) {
	    var f = b.slice(0);b = sjcl.bitArray;d = d || [];a = sjcl.mode.gcm.C(!0, a, f, d, c, e || 128);return b.concat(a.data, a.tag);
	  }, decrypt: function decrypt(a, b, c, d, e) {
	    var f = b.slice(0),
	        g = sjcl.bitArray,
	        h = g.bitLength(f);e = e || 128;d = d || [];e <= h ? (b = g.bitSlice(f, h - e), f = g.bitSlice(f, 0, h - e)) : (b = f, f = []);a = sjcl.mode.gcm.C(!1, a, f, d, c, e);if (!g.equal(a.tag, b)) throw new sjcl.exception.corrupt("gcm: tag doesn't match");return a.data;
	  }, ka: function ka(a, b) {
	    var c,
	        d,
	        e,
	        f,
	        g,
	        h = sjcl.bitArray.i;e = [0, 0, 0, 0];f = b.slice(0);for (c = 0; 128 > c; c++) {
	      (d = 0 !== (a[Math.floor(c / 32)] & 1 << 31 - c % 32)) && (e = h(e, f));g = 0 !== (f[3] & 1);for (d = 3; 0 < d; d--) {
	        f[d] = f[d] >>> 1 | (f[d - 1] & 1) << 31;
	      }f[0] >>>= 1;g && (f[0] ^= -0x1f000000);
	    }return e;
	  }, j: function j(a, b, c) {
	    var d,
	        e = c.length;b = b.slice(0);for (d = 0; d < e; d += 4) {
	      b[0] ^= 0xffffffff & c[d], b[1] ^= 0xffffffff & c[d + 1], b[2] ^= 0xffffffff & c[d + 2], b[3] ^= 0xffffffff & c[d + 3], b = sjcl.mode.gcm.ka(b, a);
	    }return b;
	  }, C: function C(a, b, c, d, e, f) {
	    var g,
	        h,
	        k,
	        l,
	        n,
	        m,
	        p,
	        r,
	        q = sjcl.bitArray;m = c.length;p = q.bitLength(c);r = q.bitLength(d);h = q.bitLength(e);
	    g = b.encrypt([0, 0, 0, 0]);96 === h ? (e = e.slice(0), e = q.concat(e, [1])) : (e = sjcl.mode.gcm.j(g, [0, 0, 0, 0], e), e = sjcl.mode.gcm.j(g, e, [0, 0, Math.floor(h / 0x100000000), h & 0xffffffff]));h = sjcl.mode.gcm.j(g, [0, 0, 0, 0], d);n = e.slice(0);d = h.slice(0);a || (d = sjcl.mode.gcm.j(g, h, c));for (l = 0; l < m; l += 4) {
	      n[3]++, k = b.encrypt(n), c[l] ^= k[0], c[l + 1] ^= k[1], c[l + 2] ^= k[2], c[l + 3] ^= k[3];
	    }c = q.clamp(c, p);a && (d = sjcl.mode.gcm.j(g, h, c));a = [Math.floor(r / 0x100000000), r & 0xffffffff, Math.floor(p / 0x100000000), p & 0xffffffff];d = sjcl.mode.gcm.j(g, d, a);k = b.encrypt(e);
	    d[0] ^= k[0];d[1] ^= k[1];d[2] ^= k[2];d[3] ^= k[3];return { tag: q.bitSlice(d, 0, f), data: c };
	  } };sjcl.misc.hmac = function (a, b) {
	  this.W = b = b || sjcl.hash.sha256;var c = [[], []],
	      d,
	      e = b.prototype.blockSize / 32;this.w = [new b(), new b()];a.length > e && (a = b.hash(a));for (d = 0; d < e; d++) {
	    c[0][d] = a[d] ^ 909522486, c[1][d] = a[d] ^ 1549556828;
	  }this.w[0].update(c[0]);this.w[1].update(c[1]);this.R = new b(this.w[0]);
	};
	sjcl.misc.hmac.prototype.encrypt = sjcl.misc.hmac.prototype.mac = function (a) {
	  if (this.aa) throw new sjcl.exception.invalid("encrypt on already updated hmac called!");this.update(a);return this.digest(a);
	};sjcl.misc.hmac.prototype.reset = function () {
	  this.R = new this.W(this.w[0]);this.aa = !1;
	};sjcl.misc.hmac.prototype.update = function (a) {
	  this.aa = !0;this.R.update(a);
	};sjcl.misc.hmac.prototype.digest = function () {
	  var a = this.R.finalize(),
	      a = new this.W(this.w[1]).update(a).finalize();this.reset();return a;
	};
	sjcl.misc.pbkdf2 = function (a, b, c, d, e) {
	  c = c || 1E4;if (0 > d || 0 > c) throw new sjcl.exception.invalid("invalid params to pbkdf2");"string" === typeof a && (a = sjcl.codec.utf8String.toBits(a));"string" === typeof b && (b = sjcl.codec.utf8String.toBits(b));e = e || sjcl.misc.hmac;a = new e(a);var f,
	      g,
	      h,
	      k,
	      l = [],
	      n = sjcl.bitArray;for (k = 1; 32 * l.length < (d || 1); k++) {
	    e = f = a.encrypt(n.concat(b, [k]));for (g = 1; g < c; g++) {
	      for (f = a.encrypt(f), h = 0; h < f.length; h++) {
	        e[h] ^= f[h];
	      }
	    }l = l.concat(e);
	  }d && (l = n.clamp(l, d));return l;
	};
	sjcl.prng = function (a) {
	  this.c = [new sjcl.hash.sha256()];this.m = [0];this.P = 0;this.H = {};this.N = 0;this.U = {};this.Z = this.f = this.o = this.ha = 0;this.b = [0, 0, 0, 0, 0, 0, 0, 0];this.h = [0, 0, 0, 0];this.L = void 0;this.M = a;this.D = !1;this.K = { progress: {}, seeded: {} };this.u = this.ga = 0;this.I = 1;this.J = 2;this.ca = 0x10000;this.T = [0, 48, 64, 96, 128, 192, 0x100, 384, 512, 768, 1024];this.da = 3E4;this.ba = 80;
	};
	sjcl.prng.prototype = { randomWords: function randomWords(a, b) {
	    var c = [],
	        d;d = this.isReady(b);var e;if (d === this.u) throw new sjcl.exception.notReady("generator isn't seeded");if (d & this.J) {
	      d = !(d & this.I);e = [];var f = 0,
	          g;this.Z = e[0] = new Date().valueOf() + this.da;for (g = 0; 16 > g; g++) {
	        e.push(0x100000000 * Math.random() | 0);
	      }for (g = 0; g < this.c.length && (e = e.concat(this.c[g].finalize()), f += this.m[g], this.m[g] = 0, d || !(this.P & 1 << g)); g++) {}this.P >= 1 << this.c.length && (this.c.push(new sjcl.hash.sha256()), this.m.push(0));this.f -= f;f > this.o && (this.o = f);this.P++;this.b = sjcl.hash.sha256.hash(this.b.concat(e));this.L = new sjcl.cipher.aes(this.b);for (d = 0; 4 > d && (this.h[d] = this.h[d] + 1 | 0, !this.h[d]); d++) {}
	    }for (d = 0; d < a; d += 4) {
	      0 === (d + 1) % this.ca && y(this), e = z(this), c.push(e[0], e[1], e[2], e[3]);
	    }y(this);return c.slice(0, a);
	  }, setDefaultParanoia: function setDefaultParanoia(a, b) {
	    if (0 === a && "Setting paranoia=0 will ruin your security; use it only for testing" !== b) throw new sjcl.exception.invalid("Setting paranoia=0 will ruin your security; use it only for testing");this.M = a;
	  }, addEntropy: function addEntropy(a, b, c) {
	    c = c || "user";var d,
	        e,
	        f = new Date().valueOf(),
	        g = this.H[c],
	        h = this.isReady(),
	        k = 0;d = this.U[c];void 0 === d && (d = this.U[c] = this.ha++);void 0 === g && (g = this.H[c] = 0);this.H[c] = (this.H[c] + 1) % this.c.length;switch (typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a)) {case "number":
	        void 0 === b && (b = 1);this.c[g].update([d, this.N++, 1, b, f, 1, a | 0]);break;case "object":
	        c = Object.prototype.toString.call(a);if ("[object Uint32Array]" === c) {
	          e = [];for (c = 0; c < a.length; c++) {
	            e.push(a[c]);
	          }a = e;
	        } else for ("[object Array]" !== c && (k = 1), c = 0; c < a.length && !k; c++) {
	          "number" !== typeof a[c] && (k = 1);
	        }if (!k) {
	          if (void 0 === b) for (c = b = 0; c < a.length; c++) {
	            for (e = a[c]; 0 < e;) {
	              b++, e = e >>> 1;
	            }
	          }this.c[g].update([d, this.N++, 2, b, f, a.length].concat(a));
	        }break;case "string":
	        void 0 === b && (b = a.length);this.c[g].update([d, this.N++, 3, b, f, a.length]);this.c[g].update(a);break;default:
	        k = 1;}if (k) throw new sjcl.exception.bug("random: addEntropy only supports number, array of numbers or string");this.m[g] += b;this.f += b;h === this.u && (this.isReady() !== this.u && A("seeded", Math.max(this.o, this.f)), A("progress", this.getProgress()));
	  },
	  isReady: function isReady(a) {
	    a = this.T[void 0 !== a ? a : this.M];return this.o && this.o >= a ? this.m[0] > this.ba && new Date().valueOf() > this.Z ? this.J | this.I : this.I : this.f >= a ? this.J | this.u : this.u;
	  }, getProgress: function getProgress(a) {
	    a = this.T[a ? a : this.M];return this.o >= a ? 1 : this.f > a ? 1 : this.f / a;
	  }, startCollectors: function startCollectors() {
	    if (!this.D) {
	      this.a = { loadTimeCollector: B(this, this.ma), mouseCollector: B(this, this.oa), keyboardCollector: B(this, this.la), accelerometerCollector: B(this, this.ea), touchCollector: B(this, this.qa) };if (window.addEventListener) window.addEventListener("load", this.a.loadTimeCollector, !1), window.addEventListener("mousemove", this.a.mouseCollector, !1), window.addEventListener("keypress", this.a.keyboardCollector, !1), window.addEventListener("devicemotion", this.a.accelerometerCollector, !1), window.addEventListener("touchmove", this.a.touchCollector, !1);else if (document.attachEvent) document.attachEvent("onload", this.a.loadTimeCollector), document.attachEvent("onmousemove", this.a.mouseCollector), document.attachEvent("keypress", this.a.keyboardCollector);else throw new sjcl.exception.bug("can't attach event");
	      this.D = !0;
	    }
	  }, stopCollectors: function stopCollectors() {
	    this.D && (window.removeEventListener ? (window.removeEventListener("load", this.a.loadTimeCollector, !1), window.removeEventListener("mousemove", this.a.mouseCollector, !1), window.removeEventListener("keypress", this.a.keyboardCollector, !1), window.removeEventListener("devicemotion", this.a.accelerometerCollector, !1), window.removeEventListener("touchmove", this.a.touchCollector, !1)) : document.detachEvent && (document.detachEvent("onload", this.a.loadTimeCollector), document.detachEvent("onmousemove", this.a.mouseCollector), document.detachEvent("keypress", this.a.keyboardCollector)), this.D = !1);
	  }, addEventListener: function addEventListener(a, b) {
	    this.K[a][this.ga++] = b;
	  }, removeEventListener: function removeEventListener(a, b) {
	    var c,
	        d,
	        e = this.K[a],
	        f = [];for (d in e) {
	      e.hasOwnProperty(d) && e[d] === b && f.push(d);
	    }for (c = 0; c < f.length; c++) {
	      d = f[c], delete e[d];
	    }
	  }, la: function la() {
	    C(this, 1);
	  }, oa: function oa(a) {
	    var b, c;try {
	      b = a.x || a.clientX || a.offsetX || 0, c = a.y || a.clientY || a.offsetY || 0;
	    } catch (d) {
	      c = b = 0;
	    }0 != b && 0 != c && this.addEntropy([b, c], 2, "mouse");C(this, 0);
	  }, qa: function qa(a) {
	    a = a.touches[0] || a.changedTouches[0];this.addEntropy([a.pageX || a.clientX, a.pageY || a.clientY], 1, "touch");C(this, 0);
	  }, ma: function ma() {
	    C(this, 2);
	  }, ea: function ea(a) {
	    a = a.accelerationIncludingGravity.x || a.accelerationIncludingGravity.y || a.accelerationIncludingGravity.z;if (window.orientation) {
	      var b = window.orientation;"number" === typeof b && this.addEntropy(b, 1, "accelerometer");
	    }a && this.addEntropy(a, 2, "accelerometer");C(this, 0);
	  } };
	function A(a, b) {
	  var c,
	      d = sjcl.random.K[a],
	      e = [];for (c in d) {
	    d.hasOwnProperty(c) && e.push(d[c]);
	  }for (c = 0; c < e.length; c++) {
	    e[c](b);
	  }
	}function C(a, b) {
	  "undefined" !== typeof window && window.performance && "function" === typeof window.performance.now ? a.addEntropy(window.performance.now(), b, "loadtime") : a.addEntropy(new Date().valueOf(), b, "loadtime");
	}function y(a) {
	  a.b = z(a).concat(z(a));a.L = new sjcl.cipher.aes(a.b);
	}function z(a) {
	  for (var b = 0; 4 > b && (a.h[b] = a.h[b] + 1 | 0, !a.h[b]); b++) {}return a.L.encrypt(a.h);
	}
	function B(a, b) {
	  return function () {
	    b.apply(a, arguments);
	  };
	}sjcl.random = new sjcl.prng(6);
	a: try {
	  var D, E, F, G;if (G = "undefined" !== typeof module && module.exports) {
	    var H;try {
	      H = __webpack_require__(131);
	    } catch (a) {
	      H = null;
	    }G = E = H;
	  }if (G && E.randomBytes) D = E.randomBytes(128), D = new Uint32Array(new Uint8Array(D).buffer), sjcl.random.addEntropy(D, 1024, "crypto['randomBytes']");else if ("undefined" !== typeof window && "undefined" !== typeof Uint32Array) {
	    F = new Uint32Array(32);if (window.crypto && window.crypto.getRandomValues) window.crypto.getRandomValues(F);else if (window.msCrypto && window.msCrypto.getRandomValues) window.msCrypto.getRandomValues(F);else break a;sjcl.random.addEntropy(F, 1024, "crypto['getRandomValues']");
	  }
	} catch (a) {
	  "undefined" !== typeof window && window.console && (console.log("There was an error collecting entropy from the browser:"), console.log(a));
	}
	sjcl.json = { defaults: { v: 1, iter: 1E4, ks: 128, ts: 64, mode: "ccm", adata: "", cipher: "aes" }, ja: function ja(a, b, c, d) {
	    c = c || {};d = d || {};var e = sjcl.json,
	        f = e.g({ iv: sjcl.random.randomWords(4, 0) }, e.defaults),
	        g;e.g(f, c);c = f.adata;"string" === typeof f.salt && (f.salt = sjcl.codec.base64.toBits(f.salt));"string" === typeof f.iv && (f.iv = sjcl.codec.base64.toBits(f.iv));if (!sjcl.mode[f.mode] || !sjcl.cipher[f.cipher] || "string" === typeof a && 100 >= f.iter || 64 !== f.ts && 96 !== f.ts && 128 !== f.ts || 128 !== f.ks && 192 !== f.ks && 0x100 !== f.ks || 2 > f.iv.length || 4 < f.iv.length) throw new sjcl.exception.invalid("json encrypt: invalid parameters");"string" === typeof a ? (g = sjcl.misc.cachedPbkdf2(a, f), a = g.key.slice(0, f.ks / 32), f.salt = g.salt) : sjcl.ecc && a instanceof sjcl.ecc.elGamal.publicKey && (g = a.kem(), f.kemtag = g.tag, a = g.key.slice(0, f.ks / 32));"string" === typeof b && (b = sjcl.codec.utf8String.toBits(b));"string" === typeof c && (f.adata = c = sjcl.codec.utf8String.toBits(c));g = new sjcl.cipher[f.cipher](a);e.g(d, f);d.key = a;f.ct = "ccm" === f.mode && sjcl.arrayBuffer && sjcl.arrayBuffer.ccm && b instanceof ArrayBuffer ? sjcl.arrayBuffer.ccm.encrypt(g, b, f.iv, c, f.ts) : sjcl.mode[f.mode].encrypt(g, b, f.iv, c, f.ts);return f;
	  }, encrypt: function encrypt(a, b, c, d) {
	    var e = sjcl.json,
	        f = e.ja.apply(e, arguments);return e.encode(f);
	  }, ia: function ia(a, b, c, d) {
	    c = c || {};d = d || {};var e = sjcl.json;b = e.g(e.g(e.g({}, e.defaults), b), c, !0);var f, g;f = b.adata;"string" === typeof b.salt && (b.salt = sjcl.codec.base64.toBits(b.salt));"string" === typeof b.iv && (b.iv = sjcl.codec.base64.toBits(b.iv));if (!sjcl.mode[b.mode] || !sjcl.cipher[b.cipher] || "string" === typeof a && 100 >= b.iter || 64 !== b.ts && 96 !== b.ts && 128 !== b.ts || 128 !== b.ks && 192 !== b.ks && 0x100 !== b.ks || !b.iv || 2 > b.iv.length || 4 < b.iv.length) throw new sjcl.exception.invalid("json decrypt: invalid parameters");"string" === typeof a ? (g = sjcl.misc.cachedPbkdf2(a, b), a = g.key.slice(0, b.ks / 32), b.salt = g.salt) : sjcl.ecc && a instanceof sjcl.ecc.elGamal.secretKey && (a = a.unkem(sjcl.codec.base64.toBits(b.kemtag)).slice(0, b.ks / 32));"string" === typeof f && (f = sjcl.codec.utf8String.toBits(f));g = new sjcl.cipher[b.cipher](a);f = "ccm" === b.mode && sjcl.arrayBuffer && sjcl.arrayBuffer.ccm && b.ct instanceof ArrayBuffer ? sjcl.arrayBuffer.ccm.decrypt(g, b.ct, b.iv, b.tag, f, b.ts) : sjcl.mode[b.mode].decrypt(g, b.ct, b.iv, f, b.ts);e.g(d, b);d.key = a;return 1 === c.raw ? f : sjcl.codec.utf8String.fromBits(f);
	  }, decrypt: function decrypt(a, b, c, d) {
	    var e = sjcl.json;return e.ia(a, e.decode(b), c, d);
	  }, encode: function encode(a) {
	    var b,
	        c = "{",
	        d = "";for (b in a) {
	      if (a.hasOwnProperty(b)) {
	        if (!b.match(/^[a-z0-9]+$/i)) throw new sjcl.exception.invalid("json encode: invalid property name");c += d + '"' + b + '":';d = ",";switch ((0, _typeof3.default)(a[b])) {case "number":case "boolean":
	            c += a[b];break;case "string":
	            c += '"' + escape(a[b]) + '"';break;case "object":
	            c += '"' + sjcl.codec.base64.fromBits(a[b], 0) + '"';break;default:
	            throw new sjcl.exception.bug("json encode: unsupported type");}
	      }
	    }return c + "}";
	  }, decode: function decode(a) {
	    a = a.replace(/\s/g, "");if (!a.match(/^\{.*\}$/)) throw new sjcl.exception.invalid("json decode: this isn't json!");a = a.replace(/^\{|\}$/g, "").split(/,/);var b = {},
	        c,
	        d;for (c = 0; c < a.length; c++) {
	      if (!(d = a[c].match(/^\s*(?:(["']?)([a-z][a-z0-9]*)\1)\s*:\s*(?:(-?\d+)|"([a-z0-9+\/%*_.@=\-]*)"|(true|false))$/i))) throw new sjcl.exception.invalid("json decode: this isn't json!");
	      null != d[3] ? b[d[2]] = parseInt(d[3], 10) : null != d[4] ? b[d[2]] = d[2].match(/^(ct|adata|salt|iv)$/) ? sjcl.codec.base64.toBits(d[4]) : unescape(d[4]) : null != d[5] && (b[d[2]] = "true" === d[5]);
	    }return b;
	  }, g: function g(a, b, c) {
	    void 0 === a && (a = {});if (void 0 === b) return a;for (var d in b) {
	      if (b.hasOwnProperty(d)) {
	        if (c && void 0 !== a[d] && a[d] !== b[d]) throw new sjcl.exception.invalid("required parameter overridden");a[d] = b[d];
	      }
	    }return a;
	  }, sa: function sa(a, b) {
	    var c = {},
	        d;for (d in a) {
	      a.hasOwnProperty(d) && a[d] !== b[d] && (c[d] = a[d]);
	    }return c;
	  }, ra: function ra(a, b) {
	    var c = {},
	        d;for (d = 0; d < b.length; d++) {
	      void 0 !== a[b[d]] && (c[b[d]] = a[b[d]]);
	    }return c;
	  } };sjcl.encrypt = sjcl.json.encrypt;sjcl.decrypt = sjcl.json.decrypt;sjcl.misc.pa = {};sjcl.misc.cachedPbkdf2 = function (a, b) {
	  var c = sjcl.misc.pa,
	      d;b = b || {};d = b.iter || 1E3;c = c[a] = c[a] || {};d = c[d] = c[d] || { firstSalt: b.salt && b.salt.length ? b.salt.slice(0) : sjcl.random.randomWords(2, 0) };c = void 0 === b.salt ? d.firstSalt : b.salt;d[c] = d[c] || sjcl.misc.pbkdf2(a, c, b.iter);return { key: d[c].slice(0), salt: c.slice(0) };
	};
	"undefined" !== typeof module && module.exports && (module.exports = sjcl);"function" === "function" && !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  return sjcl;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _date = __webpack_require__(38);
	
	var _string = __webpack_require__(35);
	
	var _number = __webpack_require__(24);
	
	var plugin = {};
	
	plugin.install = function (Vue, options) {
	  Vue.filter('date', _date.date);
	  Vue.filter('dateTime', _date.dateTime);
	  Vue.filter('shortDate', _date.shortDate);
	  Vue.filter('time', _date.time);
	  Vue.filter('dateFull', _date.dateFull);
	  Vue.filter('secondsFormat', _date.secondsFormat);
	
	  Vue.filter('join', _string.join);
	  Vue.filter('cpfCnpj', _string.cpfCnpj);
	  Vue.filter('phone', _string.phone);
	  Vue.filter('firstWord', _string.firstWord);
	  Vue.filter('fromSecWord', _string.fromSecWord);
	
	  Vue.filter('money', _number.money);
	  Vue.filter('cents', _number.cents);
	  Vue.filter('percent', _number.percent);
	  Vue.filter('centsNoSymbol', _number.centsNoSymbol);
	  Vue.filter('moneyNoCents', _number.moneyNoCents);
	};
	
	exports.default = plugin;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _modernizr = __webpack_require__(1696);
	
	var _modernizr2 = _interopRequireDefault(_modernizr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (!_modernizr2.default.es6object) {
	  __webpack_require__(1490);
	}
	
	__webpack_require__(1491);

/***/ }),
/* 635 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  activateTagSite: function activateTagSite(plate, serial) {
	    window.location = "/#/conta/resumo-ativacao-tag/" + plate + "/" + serial;
	  }
	};

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _pagination = __webpack_require__(33);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _vehicles = __webpack_require__(29);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _tag = __webpack_require__(55);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _modalAggregateRegister = __webpack_require__(517);
	
	var _modalAggregateRegister2 = _interopRequireDefault(_modalAggregateRegister);
	
	var _modalBlockVehicle = __webpack_require__(518);
	
	var _modalBlockVehicle2 = _interopRequireDefault(_modalBlockVehicle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      page: new _pagination.Page().size(10),
	      loading: false,
	      plate: undefined,
	      state: 'LOADING',
	      filter: '',
	      errorMessage: undefined,
	      data: [],
	      vehicleToBlock: false,
	      reasonBlock: '',
	      showModalAggregate: false,
	      vpSelected: undefined,
	      typeAggregate: undefined
	    };
	  },
	
	  computed: {
	    contractId: function contractId() {
	      return this.$route.params.contractId;
	    },
	    contract: function contract() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _contracts2.default.getContractByContractId(_this.contractId);
	
	              case 2:
	                return _context.abrupt('return', _context.sent);
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    moveMaisId: function moveMaisId() {
	      return this.$route.params.moveMaisId;
	    }
	  },
	  mounted: function mounted() {
	    this.find();
	  },
	
	
	  methods: {
	    setCurrentPage: function setCurrentPage(p) {
	      this.page = this.page.page(p);
	      this.find();
	    },
	    setPageSize: function setPageSize(size) {
	      this.page = this.page.size(size);
	      this.find();
	    },
	    modalAggregate: function modalAggregate(value) {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return _this2.contract;
	
	              case 2:
	                _this2.contractAggregate = _context2.sent;
	
	                _this2.contractAggregate.moveMaisId = _this2.moveMaisId;
	                _this2.showModalAggregate = true;
	                _this2.$nextTick(function () {
	                  $('#modal-aggregate').modal();
	                });
	
	              case 6:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    },
	    find: function find(clearCache) {
	      var _this3 = this;
	
	      this.state = 'LOADING';
	      this.errorMessage = '';
	
	      var filter = {
	        contractIdAgr: this.contractId,
	        page: this.page.build()
	      };
	
	      if (clearCache) {
	        this.data = {};
	        filterVP.page = 1;
	        this.pageSm = filterVP.page = this.pageSm.page(1);
	      }
	
	      this.loading = _vehicles2.default.getVehiclesAggregate(filter).then(function (data) {
	        _this3.data = data.itens;
	        if (_this3.data) {
	          _this3.state = _this3.data.itens && 'LOADED' || 'NOTFOUND';
	          _this3.page = _this3.page.itemCount(data.total);
	        }
	      }).catch(function (err) {
	        _this3.state = 'NOTFOUND';
	        _this3.errorMessage = err.data && err.data.status && err.data.status.message || "Erro do servidor.";
	        _this3.data = err.data;
	      });
	    },
	    search: function search() {
	      var _this4 = this;
	
	      this.state = 'LOADING';
	      this.errorMessage = '';
	      var regex = /^[a-zA-Z0-9]{3}\-?[a-zA-Z0-9]{4}$/;
	      var promise = void 0;
	      if (this.plate == '') {
	        this.find();
	        return;
	      } else if (regex.test(this.plate)) {
	        promise = _vehicles2.default.getVehicle({ 'plate': this.plate, 'contractId': this.contractId });
	      }
	      this.loading = promise.then(function (data) {
	        if (data) {
	          _this4.data = data.itens;
	          _this4.state = _this4.data && _this4.data && 'LOADED' || 'NOTFOUND';
	        }
	      }).catch(function (err) {
	        _this4.state = 'NOTFOUND';
	        _this4.errorMessage = err.data && err.data.status && err.data.status.message || "Erro do servidor.";
	        _this4.data = err.data;
	      });
	    },
	    showBlock: function showBlock(vehicle) {
	      if (vehicle.reasonBlockId == 0) {
	        return true;
	      }
	
	      return false;
	    },
	    showUnblock: function showUnblock(vehicle) {
	      if (vehicle.reasonId == 8) return true;
	
	      return false;
	    },
	    showReplace: function showReplace(vehicle) {
	      if (vehicle.tagSerialNumber && (vehicle.requestReplaceTag == 'N' || !vehicle.requestReplaceTag)) return true;
	      return false;
	    },
	    cancelar: function cancelar() {
	      this.vehicleToBlock = false;
	      this.reasonBlock = '';
	    },
	    showBlockModal: function showBlockModal(value) {
	      this.vehicleToBlock = true;
	      this.vpSelected = value;
	      this.$nextTick(function () {
	        $('#modal-block-vehicle').modal();
	      });
	    },
	    showDeleteModal: function showDeleteModal(value) {
	      this.vehicleToBlock = true;
	      this.typeAggregate = 'delete';
	      this.vpSelected = value;
	      this.$nextTick(function () {
	        $('#modal-block-vehicle').modal();
	      });
	    },
	    close: function close(fn) {
	      $('#modal-rescue-balance').modal('hide');
	      this.vehicleToBlock = false;
	      this.vpSelected = undefined;
	      this.type = undefined;
	      this.find();
	    }
	  },
	  components: {
	    Pagination: _pagination2.default, ModalAggregate: _modalAggregateRegister2.default, ModalBlockVehicle: _modalBlockVehicle2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['address'],
	  data: function data() {
	    return {
	      loadingAddress: undefined,
	      zipCode: undefined,
	      address2: undefined,
	      number: undefined,
	      neighborhood: undefined,
	      complement: undefined,
	      city: undefined,
	      state: undefined
	    };
	  },
	  mounted: function mounted() {
	    if (this.address) {
	      this.loadingAddress = this.address.loadingAddress;
	      this.zipCode = this.address.zipCode;
	      this.address2 = this.address.address;
	      this.number = this.address.number;
	      this.neighborhood = this.address.neighborhood;
	      this.complement = this.address.complement;
	      this.city = this.address.city;
	      this.state = this.address.state;
	    }
	  },
	
	  methods: {
	    queryAddress: function queryAddress() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this.errorCep = undefined;
	                _this.loadingAddress = _account2.default.queryAddress(_this.zipCode).then(function (res) {
	                  _this.address2 = res.address;
	                  _this.city = res.city;
	                  _this.neighborhood = res.neighborhood;
	                  _this.state = res.state;
	                  _this.zipCode = res.zipCode;
	
	                  if (_this.address2.length == 0 && _this.neighborhood.length == 0) {
	                    _this.number = '';
	                  }
	                }).catch(function (err) {
	                  _this.errorCep = err.data.status.message;
	                  _this.$validator.validateAll();
	                });
	
	              case 2:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    validateAll: function validateAll() {
	      var _this2 = this;
	
	      return this.$validator.validateAll().then(function (_) {
	        _this2.address.loadingAddress = _this2.loadingAddress;
	        _this2.address.zipCode = _this2.zipCode;
	        _this2.address.address = _this2.address2;
	        _this2.address.number = _this2.number;
	        _this2.address.neighborhood = _this2.neighborhood;
	        _this2.address.complement = _this2.complement;
	        _this2.address.city = _this2.city;
	        _this2.address.state = _this2.state;
	      });
	    },
	    queryAddressTyping: function queryAddressTyping() {
	
	      if (this.zipCode.length < 8) return;
	
	      this.queryAddress();
	    }
	  }
	};

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _contact = __webpack_require__(515);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _string = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['company', 'contact'],
	  data: function data() {
	    return {
	      address: undefined,
	      taxIdNumberFormatted: undefined,
	      companyName: undefined,
	      companyTradeName: undefined,
	      cel: undefined,
	      tel: undefined,
	      email: undefined,
	      error: false
	    };
	  },
	  mounted: function mounted() {
	    if (this.company && this.contact) {
	      this.companyName = this.company.companyName;
	      this.companyTradeName = this.company.companyTradeName;
	
	      if (this.company.taxIdNumber) {
	        this.taxIdNumberFormatted = (0, _string.cpfCnpj)(this.company.taxIdNumber);
	      }
	      this.email = this.contact.email;
	      this.cel = (0, _string.phone)(this.contact.dddCellphone + ' ' + this.contact.nroCellphone);
	
	      if (this.contact.nroPhone == 0 && this.contact.dddPhone == 0) {
	        this.tel = '';
	      } else {
	        this.tel = (0, _string.phone)(this.contact.dddPhone + ' ' + this.contact.nroPhone);
	      }
	    }
	  },
	
	  methods: {
	    clearData: function clearData() {
	      this.companyName = '';
	      this.companyTradeName = '';
	      this.email = '';
	      this.cel = '';
	      this.tel = '';
	      this.address = '';
	    },
	    correctCursor2: function correctCursor2(a) {
	      if (!window.document.mobile) return;
	
	      setTimeout(function () {
	        $(a.target).val($(a.target).val());
	      }, 80);
	    },
	    companyExists: function companyExists() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var cnpj, resp;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (_this.taxIdNumberFormatted) {
	                  _context.next = 2;
	                  break;
	                }
	
	                return _context.abrupt('return');
	
	              case 2:
	                cnpj = _this.taxIdNumberFormatted.replace(/[.\-\/]/g, '').toUpperCase();
	
	                if (!(_auth2.default.currentUser.taxIdNumber == cnpj)) {
	                  _context.next = 6;
	                  break;
	                }
	
	                _this.error = true;
	                return _context.abrupt('return');
	
	              case 6:
	                _this.error = false;
	
	                _context.next = 9;
	                return _account2.default.getUserAndAddressByTaxIdNumberAggregate(cnpj);
	
	              case 9:
	                resp = _context.sent;
	
	
	                _this.companyName = resp.user.company.companyName;
	                _this.companyTradeName = resp.user.company.companyTradeName;
	                _this.email = resp.user.email2;
	                _this.cel = (0, _string.phone)(resp.user.dddCellphone + resp.user.nroCellphone);
	
	                if (resp.user.nroPhone == 0 && resp.user.dddPhone == 0) {
	                  _this.tel = '';
	                } else {
	                  _this.tel = (0, _string.phone)(resp.user.dddPhone + ' ' + resp.user.nroPhone);
	                }
	
	                _this.address = resp.address;
	
	              case 16:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    validateAll: function validateAll() {
	      var _this2 = this;
	
	      return this.$validator.validateAll().then(function (_) {
	        _this2.company.companyName = _this2.companyName;
	        _this2.company.companyTradeName = _this2.companyTradeName;
	        _this2.company.taxIdNumber = _this2.taxIdNumberFormatted.replace(/[.\-\/]/g, '').toUpperCase();
	        _this2.contact.email = _this2.email;
	
	        _this2.contact.nroCellphone = Number(_this2.cel.substring(4, _this2.cel.length).replace('-', '').trim());
	        _this2.contact.nroPhone = Number(_this2.tel.substring(4, _this2.cel.length).replace('-', '').trim());
	        _this2.contact.dddCellphone = Number(_this2.cel.substring(0, 4).replace('(', '').replace(')', ''));
	        _this2.contact.dddPhone = Number(_this2.tel.substring(0, 4).replace('(', '').replace(')', ''));
	      }).then(function (_) {
	        if (_this2.address) {
	          _this2.$emit('addressExists', _this2.address);
	        }
	      });
	    }
	  },
	  components: {
	    Contact: _contact2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _string = __webpack_require__(35);
	
	exports.default = {
	  props: ['contact'],
	  data: function data() {
	    return {};
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.$watch('contact', function () {
	      var vm = _this;
	      setTimeout(function () {
	        vm.$validator.validateAll().then(function () {
	          vm.contact.validForm = true;
	        }).catch(function (err) {
	          vm.contact.validForm = false;
	        });
	      }, 300);
	    }, { deep: true });
	  },
	  mounted: function mounted() {},
	
	  computed: {
	    tel: {
	      get: function get() {
	        return this.getTelFormated();
	      },
	      set: function set(newValue) {
	        this.setTelFormated(newValue);
	      }
	    },
	    cel: {
	      get: function get() {
	        return this.getCelFormated();
	      },
	      set: function set(newValue) {
	        this.setCelFormated(newValue);
	      }
	    }
	  },
	  methods: {
	    correctCursor2: function correctCursor2(a) {
	      if (!window.document.mobile) return;
	
	      setTimeout(function () {
	        $(a.target).val($(a.target).val());
	      }, 80);
	    },
	    getTelType: function getTelType(type) {
	      var tels = _.filter(this.contact.telephones.telephone, function (o) {
	        return o.type == type;
	      });
	      if (tels && tels.length > 0) return tels[0];
	
	      var t = { 'ddd': '', 'numberPhone': '', 'type': type };
	      this.contact.telephones.telephone.push(t);
	
	      return t;
	    },
	    getCelFormated: function getCelFormated(obj) {
	      return (0, _string.phone)(this.contact.dddCellphone + this.contact.nroCellphone);
	    },
	    setCelFormated: function setCelFormated(value) {
	      var t = value.replace(/[^0-9]/g, '');
	
	      this.contact.dddCellphone = t.substring(0, 2);
	      this.contact.nroCellphone = t.substring(2, 11);
	    },
	    getTelFormated: function getTelFormated(obj) {
	      return (0, _string.phone)(this.contact.dddPhone + this.contact.nroPhone);
	    },
	    setTelFormated: function setTelFormated(value, obj) {
	      var t = value.replace(/[^0-9]/g, '');
	      this.contact.dddPhone = t.substring(0, 2);
	      this.contact.nroPhone = t.substring(2, 11);
	    },
	    validateAll: function validateAll() {
	      var vm = this;
	      return this.$validator.validateAll().then(function (r) {
	        vm.contact.email = vm.contact.email;
	        vm.contact.celPhone = vm.contact.cel;
	      });
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tag = __webpack_require__(55);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _vehicles = __webpack_require__(29);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['vehicle', 'completeData'],
	  data: function data() {
	    return {
	      activetagLoading: undefined,
	      serialNumber: undefined,
	      promise: undefined,
	      linkedTag: false,
	      vehicles: undefined,
	      msg: undefined
	    };
	  },
	
	  methods: {
	    vincularTag: function vincularTag() {
	      var _this = this;
	
	      if (this.serialNumber.replace(/^[^0-9]*/g, '').trim().length == 0) {
	        this.msg = 'Número de TAG inválido.';
	        this.linkedTag = 'error';
	        return;
	      }
	
	      var request = {
	        serialNumber: parseInt(this.serialNumber.replace(/^[^0-9]*/g, '')),
	        vehicleId: this.vehicle.vehicleId,
	        moveMaisId: this.vehicle.moveMaisId
	      };
	
	      this.promise = this.$validator.validateAll().then(function (success) {
	        return success && _tag2.default.activateTagGeneral(request);
	      }).then(function (response) {
	        if (response.response == "OK") {
	          _this.linkedTag = 'success';
	        } else {
	          _this.linkedTag = 'error';
	          _this.msg = response.response;
	        }
	      }).catch(function (error) {
	        _this.msg = error.data.status.message;
	        if (error.msg && error.msg.indexOf('[vee-validate]') !== -1) {
	          return false;
	        }
	
	        _this.$emit('deactivatetagLoading');
	        _this.linkedTag = 'error';
	      });
	
	      this.$emit('activetagLoading', this.promise);
	    }
	  }
	};

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _string = __webpack_require__(35);
	
	var _date = __webpack_require__(38);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _contact = __webpack_require__(515);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['user', 'contact'],
	  data: function data() {
	    return {
	      address: undefined,
	      taxIdNumberFormatted: undefined,
	      fullName: undefined,
	      birthDateBR: undefined,
	      email: undefined,
	      cel: undefined,
	      tel: undefined
	    };
	  },
	  mounted: function mounted() {
	    if (this.user && this.contact) {
	      this.email = this.contact.email;
	      this.taxIdNumberFormatted = this.user.taxIdNumber;
	      this.fullName = this.user.fullName;
	      this.birthDateBR = (0, _date.AmToBr)(this.user.birthDate || '');
	      this.cel = (0, _string.phone)(this.contact.dddCellphone + ' ' + this.contact.nroCellphone);
	      this.tel = (0, _string.phone)(this.contact.dddPhone + ' ' + this.contact.nroPhone);
	    }
	  },
	
	  methods: {
	    correctCursor2: function correctCursor2(a) {
	      if (!window.document.mobile) return;
	
	      setTimeout(function () {
	        $(a.target).val($(a.target).val());
	      }, 80);
	    },
	    userExists: function userExists() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var resp;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _account2.default.getUserAndAddressByTaxIdNumberAggregate(_this.taxIdNumberFormatted.replace(/[.\-\/]/g, '').toUpperCase());
	
	              case 2:
	                resp = _context.sent;
	
	                _this.fullName = resp.user.person.name + ' ' + resp.user.person.lastName;
	                _this.birthDateBR = (0, _date.date)(resp.user.person.birthDate);
	                _this.email = resp.user.email2;
	                _this.cel = (0, _string.phone)(resp.user.dddCellphone + resp.user.nroCellphone);
	                _this.address = resp.address;
	                _this.address.addressId = resp.address.addressId;
	
	                if (resp.user.nroPhone == 0 && resp.user.dddPhone == 0) {
	                  _this.tel = '';
	                } else {
	                  _this.tel = (0, _string.phone)(resp.user.dddPhone + ' ' + resp.user.nroPhone);
	                }
	
	              case 10:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    validateAll: function validateAll() {
	      var _this2 = this;
	
	      return this.$validator.validateAll().then(function () {
	        _this2.user.fullName = _this2.fullName.trim();
	        var firstSpace = _this2.fullName.indexOf(" ") || _this2.fullName.length;
	        _this2.user.name = _this2.fullName.substring(0, firstSpace);
	        _this2.user.lastName = _this2.fullName.substring(firstSpace + 1, _this2.fullName.length);
	        _this2.user.birthDate = (0, _date.brToAm)(_this2.birthDateBR);
	        _this2.user.taxIdNumber = _this2.taxIdNumberFormatted.replace(/[.\-\/]/g, '').toUpperCase();
	        _this2.contact.email = _this2.email;
	
	        _this2.contact.nroCellphone = Number(_this2.cel.substring(4, _this2.cel.length).replace('-', '').trim());
	        _this2.contact.nroPhone = Number(_this2.tel.substring(4, _this2.cel.length).replace('-', '').trim());
	        _this2.contact.dddCellphone = Number(_this2.cel.substring(0, 4).replace('(', '').replace(')', ''));
	        _this2.contact.dddPhone = Number(_this2.tel.substring(0, 4).replace('(', '').replace(')', ''));
	      }).then(function () {
	        if (_this2.address) {
	          _this2.$emit('addressExists', _this2.address);
	        }
	      });
	    }
	  },
	  components: {
	    Contact: _contact2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _address = __webpack_require__(1894);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _company = __webpack_require__(1895);
	
	var _company2 = _interopRequireDefault(_company);
	
	var _tag = __webpack_require__(516);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _user = __webpack_require__(1896);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _vehicles = __webpack_require__(29);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _objects = __webpack_require__(44);
	
	var obj = _interopRequireWildcard(_objects);
	
	var _cpfCnpj = __webpack_require__(86);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['contractAggregate'],
	  data: function data() {
	    return {
	      loading: undefined,
	      step: 0,
	      msgError: undefined,
	      aggregateType: 'cnpj',
	      user: {},
	      company: {},
	      contact: {},
	      address: {},
	      vehicles: [],
	      vehiclesActive: [],
	      plate: '',
	      brands: undefined,
	      models: undefined,
	      brandSelected: {},
	      modelSelected: {},
	      brandId: undefined,
	      modelId: undefined,
	      axesId: 1,
	      vehiclesSaved: false,
	      plates: [],
	
	      souTransportador: false,
	      cpfCnpjTransportador: "",
	      anttStatus: null,
	      anttLoading: false,
	      mostrarAvisoAntt: false,
	      request: {
	        contract: {
	          "plan": { "planId": 45 },
	          "changeFlagEmail": "0",
	          "lcFlag": 0
	        },
	        contractIdAggregate: this.contractAggregate.contractId,
	        moveMaisId: this.contractAggregate.moveMaisId,
	        "changeFlagEmail": "0",
	        account: {},
	        address: {},
	        listVehicle: {
	          vehicle: []
	        },
	        value: undefined
	      }
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.loading = _vehicles2.default.getVehicleBrand().then(function (data) {
	      _this.brands = data;
	      _.each(data, function (obj) {
	        obj.value = obj.brandId;
	        obj.caption = obj.name;
	      });
	      if (!_this.brandId) {
	        _this.brandId = data[0].brandId;
	        _this.loadModels(_this.brandId);
	      }
	    });
	  },
	
	  computed: {
	    axes: function axes() {
	      if (!this.modelSelected || !this.modelSelected.categoryId) return [{ caption: "Selecione o modelo" }];
	
	      if (this.modelSelected.categoryId == 1) {
	        return _.filter(_constantes2.default.Axes, function (o) {
	          return o.aut;
	        });
	      } else if (this.modelSelected.categoryId == 6) {
	        return _.filter(_constantes2.default.Axes, function (o) {
	          return o.bus;
	        });
	      } else if (this.modelSelected.categoryId == 3) {
	        return _.filter(_constantes2.default.Axes, function (o) {
	          return o.truck;
	        });
	      } else {
	        return _constantes2.default.Axes;
	      }
	    },
	    plateCompleta: function plateCompleta() {
	      return (this.plate || "").replace(/[^\w]/gi, "").length === 7;
	    },
	    plateValida: function plateValida() {
	      var placa = (this.plate || "").replace(/[^\w]/gi, "").toUpperCase();
	      var regexMercosul = /^[A-Z]{3}[0-9][A-J][0-9]{2}$/;
	      var regexNormal = /^[A-Z]{3}[0-9]{4}$/;
	      return regexMercosul.test(placa) || regexNormal.test(placa);
	    },
	    transportadorPendente: function transportadorPendente() {
	      return this.souTransportador && this.anttStatus !== "success";
	    },
	    cpfCnpjValido: function cpfCnpjValido() {
	      return _cpfCnpj.cpfCnpj.validate(this.cpfCnpjTransportador || "");
	    }
	  },
	  methods: {
	    onPlateInput: function onPlateInput(event) {
	      if (event && event.target) this.plate = event.target.value;
	      this.corrigeMascara();
	
	      if (this.souTransportador || this.cpfCnpjTransportador || this.anttStatus) {
	        this.souTransportador = false;
	        this.cpfCnpjTransportador = "";
	        this.anttStatus = null;
	        this.mostrarAvisoAntt = false;
	      }
	    },
	    maskCpfCnpj: function maskCpfCnpj(value) {
	      var d = (value || "").replace(/\D/g, "").slice(0, 14);
	      if (d.length <= 11) {
	        return d.replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d{1,2})$/, "$1-$2");
	      }
	      return d.replace(/(\d{2})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1/$2").replace(/(\d{4})(\d{1,2})$/, "$1-$2");
	    },
	    cpfCnpjDigits: function cpfCnpjDigits() {
	      return (this.cpfCnpjTransportador || "").replace(/\D/g, "");
	    },
	    onTransportadorToggle: function onTransportadorToggle() {
	      if (!this.souTransportador) {
	        this.cpfCnpjTransportador = "";
	        this.anttStatus = null;
	      }
	      this.mostrarAvisoAntt = false;
	    },
	    onCpfCnpjInput: function onCpfCnpjInput() {
	      this.cpfCnpjTransportador = this.maskCpfCnpj(this.cpfCnpjTransportador);
	      this.anttStatus = null;
	      this.mostrarAvisoAntt = false;
	    },
	    consultarAntt: function consultarAntt() {
	      var _this2 = this;
	
	      var transportador = this.cpfCnpjDigits();
	      var placa = (this.plate || "").replace(/[^\w]/gi, "").toUpperCase();
	      if (!transportador || !placa) {
	        this.anttStatus = "error";
	        return;
	      }
	      this.anttLoading = true;
	      _sales2.default.consultarRNTRC(transportador, [placa]).then(function (resp) {
	        _this2.anttStatus = _this2.anttRespostaValida(resp, placa) ? "success" : "error";
	        if (_this2.anttStatus === "success") _this2.mostrarAvisoAntt = false;
	        _this2.anttLoading = false;
	      }).catch(function () {
	        _this2.anttStatus = "error";
	        _this2.anttLoading = false;
	      });
	    },
	    anttRespostaValida: function anttRespostaValida(resp, placa) {
	      if (!resp || resp.status && resp.status.code) return false;
	      if (resp.rntrcAtivo !== true) return false;
	      if (!Array.isArray(resp.frota)) return false;
	      var norm = function norm(p) {
	        return (p || "").replace(/[^\w]/gi, "").toUpperCase();
	      };
	      return resp.frota.some(function (f) {
	        return norm(f.placaVeiculo) === placa && f.situacaoVeiculoFrotaTransportador === true;
	      });
	    },
	    reset: function reset() {
	      this.user = {};
	      this.company = {};
	      this.vehicles = [];
	      this.address = {};
	      this.contact = {};
	    },
	    linkedTag: function linkedTag(fn) {
	      if (fn) this.step += 1;
	    },
	    addressExists: function addressExists(fn) {
	      this.address = fn;
	      this.address.validForm = true;
	    },
	    loadModels: function loadModels(brandId) {
	      var _this3 = this;
	
	      if (!brandId) return;
	      this.modelId = undefined;
	      this.loading = _vehicles2.default.getVehicleModel(brandId).then(function (data) {
	        if (false) {
	          _this3.models = _.filter(data, function (o) {
	            return o.categoryId == 1;
	          });
	        } else {
	          _this3.models = data;
	        }
	        _.each(_this3.models, function (obj) {
	          obj.value = obj.modelId;
	          obj.caption = obj.name;
	        });
	        if (!_this3.modelId) {
	          _this3.modelId = data[0].modelId;
	          _this3.onModelSelected(data[0]);
	        }
	      });
	    },
	    onBrandSelected: function onBrandSelected(item) {
	      if (!item) return;
	      this.brandSelected = item;
	      this.brandId = item.brandId;
	      this.loadModels(item.brandId);
	    },
	    onModelSelected: function onModelSelected(item) {
	      var _this4 = this;
	
	      this.modelSelected = item;
	      this.$nextTick(function () {
	        _this4.axesId = _this4.axes[0].value;
	      });
	    },
	    corrigeMascara: function corrigeMascara() {
	      this.$nextTick(function () {
	        $('#plate').val($('#plate').val());
	      });
	    },
	    add: function add() {
	      var _this5 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var vm, promises;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _this5.$validator.validateAll();
	
	              case 2:
	                vm = _this5;
	
	                _this5.errorMessage = undefined;
	                vm.errors.clear();
	
	                if (!vm.isAdd()) {
	                  _context.next = 8;
	                  break;
	                }
	
	                vm.errors.add('plate', 'Já cadastrado');
	                return _context.abrupt('return');
	
	              case 8:
	                if (!(_this5.plate.trim() == '' || _this5.plate.toString().replace("-", '').length != 7)) {
	                  _context.next = 10;
	                  break;
	                }
	
	                return _context.abrupt('return');
	
	              case 10:
	                if (_this5.plateValida) {
	                  _context.next = 13;
	                  break;
	                }
	
	                vm.errors.add('plate', 'Placa inválida');
	                return _context.abrupt('return');
	
	              case 13:
	                if (!_this5.transportadorPendente) {
	                  _context.next = 16;
	                  break;
	                }
	
	                _this5.mostrarAvisoAntt = true;
	                return _context.abrupt('return');
	
	              case 16:
	                _this5.mostrarAvisoAntt = false;
	
	                promises = [];
	
	                promises.push(_vehicles2.default.vehicleNotExists(_this5.plate));
	
	                _this5.loading = _promise2.default.all(promises).then(function (success) {
	                  for (var i = 0; i < success.length; i++) {
	                    if (!success[i]) {
	                      vm.$validator.validateAll();
	                      return _promise2.default.reject('Veículo já cadastrado');
	                    }
	                  }
	
	                  var v = obj.vehicle();
	
	                  v.plate = vm.plate.toUpperCase();
	                  v.model.modelId = vm.modelSelected.modelId;
	                  v.model.name = vm.modelSelected.name;
	                  v.model.brand.brandId = vm.brandSelected.brandId;
	                  v.model.brand.name = vm.brandSelected.name;
	                  v.categoryAxes.categoryAxesId = vm.axesId;
	                  v.categoryAxes.name = _.find(vm.axes, function (o) {
	                    return o.value == vm.axesId;
	                  }).caption;
	                  v.tagSerialNumber = undefined;
	                  v.isTransportador = vm.souTransportador;
	                  v.cpfCnpjTransportador = vm.souTransportador ? vm.cpfCnpjDigits() : undefined;
	
	                  vm.request.listVehicle.vehicle.push(v);
	                  vm.vehicles.push(v);
	                  _this5.plate = '';
	                  _this5.souTransportador = false;
	                  _this5.cpfCnpjTransportador = '';
	                  _this5.anttStatus = null;
	                  _this5.vehiclesSaved = true;
	                }).catch(function (error) {
	                  _this5.errorMessage = error;
	                });
	
	              case 20:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this5);
	      }))();
	    },
	    isAdd: function isAdd() {
	      for (var i = 0; i < this.request.listVehicle.vehicle.length; i++) {
	        if (this.request.listVehicle.vehicle[i].plate.toUpperCase().replace("-", "") == this.plate.toUpperCase().replace("-", "")) return true;
	      }
	      return false;
	    },
	    remove: function remove(index) {
	      this.vehicles.splice(index, 1);
	      this.request.listVehicle.vehicle.splice(index, 1);
	    },
	    handleAggregate: function handleAggregate(val) {
	      this.reset();
	      this.aggregateType = val;
	      if (this.step > 0) {
	        this.step = 0;
	      }
	    },
	    nextStep: function nextStep() {
	      var _this6 = this;
	
	      var vm = this;
	      this.msgError = undefined;
	      $('body').stop().animate({
	        scrollTop: 0
	      }, '500', 'swing');
	      switch (this.step) {
	        case 0:
	          this.loading = this.$refs.accountData.validateAll().then(function () {
	            if (_this6.company.taxIdNumber) {
	              _this6.request.account = {
	                type: "2",
	                taxIdNumber: _this6.company.taxIdNumber,
	                company: {
	                  companyName: _this6.company.companyName,
	                  companyTradeName: _this6.company.companyTradeName,
	                  taxIdNumberFormatted: _this6.company.taxIdNumberFormatted
	                },
	                accountAuthentication: {
	                  "login": _this6.contact.email,
	                  "password": 'MM' + _this6.company.taxIdNumber,
	                  "confirmPassword": 'MM' + _this6.company.taxIdNumber,
	                  "active": "Y"
	                },
	                "nroCellphone": _this6.contact.nroCellphone,
	                "dddCellphone": _this6.contact.dddCellphone,
	
	                "typePhone": "COMERCIAL",
	                "dddPhone": _this6.contact.dddPhone,
	                "nroPhone": _this6.contact.nroPhone
	              };
	            } else if (_this6.user.taxIdNumber) {
	              _this6.request.account = {
	                "type": "1",
	                "taxIdNumber": _this6.user.taxIdNumber,
	                "taxIdNumberFormatted": _this6.user.taxIdNumberFormatted,
	                "person": {
	                  "birthDate": _this6.user.birthDate,
	                  "birthDateBR": _this6.user.birthDateBR,
	                  "fullName": _this6.user.fullName,
	                  "name": _this6.user.name,
	                  "lastName": _this6.user.lastName
	                },
	                "accountAuthentication": {
	                  "login": _this6.contact.email,
	                  "password": 'MM' + _this6.user.taxIdNumber,
	                  "confirmPassword": 'MM' + _this6.user.taxIdNumber,
	                  "active": "Y"
	                },
	                "nroCellphone": _this6.contact.nroCellphone,
	                "dddCellphone": _this6.contact.dddCellphone,
	
	                "typePhone": "COMERCIAL",
	                "dddPhone": _this6.contact.dddPhone,
	                "nroPhone": _this6.contact.nroPhone
	              };
	            }
	            _this6.step += 1;
	          }).catch(function (err) {
	
	            _this6.msgError = 'Por favor verifique os campos com erro';
	          });
	          break;
	        case 1:
	          this.loading = this.$refs.addressData.validateAll().then(function (_) {
	            vm.request.address = {
	              "type": "MAILING",
	              "number": _this6.address.number,
	              "complement": _this6.address.complement,
	              "address": _this6.address.address,
	              "neighborhood": _this6.address.neighborhood,
	              "city": _this6.address.city,
	              "state": _this6.address.state,
	              "zipCode": _this6.address.zipCode
	            };
	            if (_this6.address.addressId) {
	              vm.request.address.addressId = _this6.address.addressId;
	            }
	            _this6.step += 1;
	          }).catch(function () {});
	          break;
	        case 2:
	          if (this.request.listVehicle.vehicle.length > 0) {
	            var filter = { vehicles: this.plates };
	            this.doRequestVehiclesForActivate(filter);
	          } else {
	            this.msgError = 'Adicione ao menos um veículo para continuar';
	          }
	          break;
	        case 3:
	          this.step += 1;
	          break;
	      }
	    },
	    backStep: function backStep() {
	      this.msgError = undefined;
	      $('body').stop().animate({
	        scrollTop: 0
	      }, '500', 'swing');
	      this.step -= 1;
	    },
	    doRequestVehiclesForActivate: function doRequestVehiclesForActivate(filter) {
	      var _this7 = this;
	
	      this.activetagLoading = _vehicles2.default.getVehiclesForActivateByPlate(filter).then(function (resp) {
	        _this7.vehiclesActive = resp;
	        if (_this7.vehiclesActive.length > 0) {
	          _this7.step += 1;
	        }
	      }).catch(function (error) {
	        if (error.data && error.data.status && error.data.status.code == 9990) return;
	      });
	    },
	    doRequest: function doRequest() {
	      var _this8 = this;
	
	      var vm = this;
	
	      this.request.value = this.contractAggregate.adhesionTax * this.vehicles.length;
	      this.request.contractPaymentMethod = {
	        paymentMethod: { paymentMethodId: 109 },
	        paymentMethodId: 109
	      };
	
	      this.loading = _sales2.default.adhesionAggregate(this.request).then(function (r) {
	        _this8.vehicles.forEach(function (o) {
	          vm.plates.push(o.plate);
	        });
	        _this8.vehiclesSaved = false;
	        _this8.nextStep();
	      }).catch(function (err) {
	        _this8.msgError = err.data.status.message;
	        _this8.code = err.data.status.code;
	      });
	    },
	    installTag: function installTag() {
	      this.step += 1;
	    },
	    closeModal: function closeModal() {
	      var close = {
	        modal: 'aggregate'
	      };
	      this.$emit('close', close);
	      this.step = 0;
	    }
	  },
	  components: {
	    AddressData: _address2.default, Company: _company2.default, Tag: _tag2.default, User: _user2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _tag = __webpack_require__(55);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _vehicles = __webpack_require__(29);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['type', 'vpSelected'],
	  data: function data() {
	    return {
	      loadingModal: undefined,
	      requestSuccess: false,
	      errorMessage: undefined,
	      vehicleFromPlan: undefined,
	      vehicleFromList: undefined,
	      userPlate: this.vpSelected.plate ? this.vpSelected.plate : this.vpSelected.placaVeiculo,
	      userVp: undefined,
	      contractVp: undefined,
	      serialNumber: undefined,
	      linkedTag: false,
	      msg: undefined
	    };
	  },
	
	  computed: {
	    contractCred: function contractCred() {
	      var contract = this.$store.state.contract.contracts.find(function (contract) {
	        return contract.plan.planId == 6 || contract.plan.planId == 8;
	      });
	      return contract.contractId;
	    }
	  },
	  methods: {
	    doRequestDelete: function doRequestDelete() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var payload, filter;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this.errorMessage = undefined;
	
	                if (!(_this.vpSelected.saldoVp > 0)) {
	                  _context.next = 12;
	                  break;
	                }
	
	                payload = [{
	                  index: 1,
	                  contractIdDeb: _this.vpSelected.contractIdVp,
	                  contractIdCred: _this.contractCred,
	                  transferValue: _this.vpSelected.transferValue,
	                  feeValue: _this.vpSelected.taxValue }];
	                filter = { transfer: payload };
	                _context.prev = 4;
	                _context.next = 7;
	                return _sales2.default.transferCreditAggregate(filter);
	
	              case 7:
	                _context.next = 12;
	                break;
	
	              case 9:
	                _context.prev = 9;
	                _context.t0 = _context['catch'](4);
	
	
	                _this.errorMessage = _context.t0.data.status.message;
	
	              case 12:
	
	                _this.loadingModal = _vehicles2.default.deleteAggregateVehicleAndUser({ vehicleId: _this.vpSelected.vehicleId }).then(function (res) {
	                  if (res.status.code == 0) {
	                    _this.requestSuccess = true;
	                  }
	                }).catch(function (err) {
	                  _this.errorMessage = err.data.status.message;
	                });
	
	              case 13:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this, [[4, 9]]);
	      }))();
	    },
	    doRequestBlock: function doRequestBlock() {
	      var _this2 = this;
	
	      this.errorMessage = undefined;
	      this.loadingModal = this.$validator.validateAll().then(function (success) {
	        return _tag2.default.blockTagTemp(_this2.vpSelected.tagSerialNumber, 'Agregado').then(function (res) {
	          if (res.data.status.code == 0) {
	            _this2.requestSuccess = true;
	          }
	        }).catch(function (err) {
	          _this2.errorMessage = 'Erro ao bloquear o TAG.';
	        });
	      });
	    },
	    doRequestUnblock: function doRequestUnblock() {
	      var _this3 = this;
	
	      this.loadingModal = _tag2.default.unblockTag(this.vpSelected.tagSerialNumber).then(function (res) {
	        if (res.data.status) {
	          _this3.requestSuccess = true;
	        } else {
	          _this3.errorMessage = 'Erro ao desbloquear o TAG.';
	        }
	      });
	    },
	    doReplaceTag: function doReplaceTag() {
	      var _this4 = this;
	
	      var filter = {
	        vehicleId: this.vpSelected.vehicleId,
	        serialNumber: this.serialNumber,
	        moveMaisId: this.vpSelected.moveMaisId
	      };
	      this.loadingModal = _tag2.default.replaceTagAggregate(filter).then(function (res) {
	        if (res.response === 0) {
	          _this4.linkedTag = 'success';
	          _this4.msg = 'Tag ativada.';
	          _this4.requestSuccess = true;
	        } else {
	          _this4.linkedTag = 'error';
	          _this4.msg = res.status.message;
	        }
	      }).catch(function (err) {});
	    },
	    closeModal: function closeModal(act) {
	      var close = {
	        state: act,
	        modal: 'block-vehicle'
	      };
	      this.$emit('close', close);
	
	      this.vehicleFromPlan = undefined;
	      this.vehicleFromList = undefined;
	      this.errorMessage = undefined;
	    }
	  }
	};

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toll = __webpack_require__(26);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['vpSelected'],
	  data: function data() {
	    return {
	      downloadType: undefined,
	      errorMessage: undefined
	    };
	  },
	
	  methods: {
	    download: function download(idVp) {
	      var _this = this;
	
	      if (idVp) {
	        var req = {
	          idIntern: idVp,
	          tipo: this.downloadType
	        };
	        var promise = _toll2.default.exportReceiptVp(req).then(function (data) {
	          var url = window.URL.createObjectURL(new Blob([data]));
	          var link = document.createElement('a');
	          link.href = url;
	          link.setAttribute('download', 'ComprovanteVP'.concat(_this.downloadType == 'xlsx' ? '.xlsx' : '.pdf'));
	          document.body.appendChild(link);
	          link.click();
	          link.parentNode.removeChild(link);
	        }).catch(function (err) {
	          _this.errorMessage = 'Falha ao emitir o comprovante';
	        });
	        this.$store.dispatch('loading', promise);
	      }
	    },
	    closeModal: function closeModal() {
	      var close = {
	        modal: 'print-vp'
	      };
	      this.$emit('close', close);
	      this.downloadType = undefined;
	    }
	  }
	};

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _toll = __webpack_require__(26);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	var _string = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['vpData'],
	  data: function data() {
	    return {
	      dataTransfer: undefined,
	      loading: undefined,
	      summaryVP: {},
	      origin: {},
	      destination: {}
	    };
	  },
	
	  computed: {
	    getDateTransfer: function getDateTransfer() {
	      return (0, _moment2.default)().format('[Transferência efetuada às] H:mm [em] DD/MM/YYYY [via website.]');
	    }
	  },
	
	  methods: {
	    print: function print() {
	      var prtContent = document.getElementById("comprovante");
	      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	      WinPrint.document.write(prtContent.innerHTML);
	      WinPrint.document.close();
	      WinPrint.focus();
	      WinPrint.print();
	      WinPrint.close();
	    },
	    closeModal: function closeModal() {
	      var close = {
	        modal: 'receipt-vp'
	      };
	      this.$emit('close', close);
	      this.summaryVP = {};
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    $('[data-toggle="tooltip"]').tooltip();
	
	    return this.loading = _toll2.default.getById(this.vpData.idVP).then(function (resp) {
	      _this.summaryVP = resp;
	      _this.origin.city = resp.origem.substring(0, resp.origem.indexOf(','));
	      _this.origin.state = resp.origem.substring(resp.origem.indexOf(',') + 1, resp.origem.indexOf(',') + 4);
	      _this.destination.city = resp.destino.substring(0, resp.destino.indexOf(','));
	      _this.destination.state = resp.destino.substring(resp.destino.indexOf(',') + 1, resp.destino.indexOf(',') + 4);
	      _this.summaryVP.CNPJTransportador = (0, _string.cpfCnpj)(resp.CNPJTransportador);
	    }).catch(function (err) {});
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['rescueData'],
	  data: function data() {
	    return {
	      loading: undefined,
	      feeValue: undefined,
	      smallModal: false,
	      totalValueVP: 0,
	      totalFeeValue: 0,
	      filter: {},
	      transferMsg: new Array()
	    };
	  },
	  mounted: function mounted() {
	    var vm = this;
	
	    if (this.rescueData.length > 0) {
	      this.smallModal = true;
	      this.rescueData.forEach(function (o) {
	        vm.totalValueVP += o.transferValue;
	        vm.totalFeeValue += o.feeValue;
	      });
	
	      this.feeValue = this.totalFeeValue;
	      this.filter = this.rescueData;
	    } else {
	      this.filter = [{
	        index: 1,
	        contractIdDeb: this.rescueData.contractIdVp,
	        contractIdCred: this.rescueData.contractIdCred,
	        transferValue: this.rescueData.transferValue,
	        feeValue: this.rescueData.taxValue
	      }];
	    }
	  },
	
	  methods: {
	    doRequest: function doRequest() {
	      var _this = this;
	
	      var vm = this;
	      var filter = { transfer: this.filter };
	
	      this.loading = _sales2.default.transferCreditAggregate(filter).then(function (_) {
	        _this.transferMsg = new Array();
	        _this.transferMsg.push('Transferência realizada com sucesso.');
	      }).catch(function (_) {
	        _this.transferMsg = new Array();
	        _this.transferMsg.push("Ocorreu um erro ao realizar a transferência.");
	      });
	    },
	    closeModal: function closeModal() {
	      var close = {
	        modal: 'rescue-balance'
	      };
	      this.$emit('close', close);
	      this.totalValueVP = undefined;
	      this.feeValue = undefined;
	    }
	  }
	};

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toll = __webpack_require__(26);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['vpData'],
	  data: function data() {
	    return {
	      loading: undefined,
	      summaryVP: {},
	      origin: {},
	      destination: {}
	    };
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    return this.loading = _toll2.default.getById(this.vpData.idVP).then(function (resp) {
	      _this.summaryVP = resp;
	      _this.origin.city = resp.origem.substring(0, resp.origem.indexOf(','));
	      _this.origin.state = resp.origem.substring(resp.origem.indexOf(',') + 1, resp.origem.indexOf(',') + 4);
	      _this.destination.city = resp.destino.substring(0, resp.destino.indexOf(','));
	      _this.destination.state = resp.destino.substring(resp.destino.indexOf(',') + 1, resp.destino.indexOf(',') + 4);
	    }).catch(function (err) {});
	  },
	  methods: {
	    closeModal: function closeModal() {
	      var close = {
	        modal: 'route-vp'
	      };
	      this.$emit('close', close);
	      this.summaryVP = {};
	      this.origin = {};
	      this.destination = {};
	    }
	  }
	};

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vehicleAggregate = __webpack_require__(1903);
	
	var _vehicleAggregate2 = _interopRequireDefault(_vehicleAggregate);
	
	var _dateRoute = __webpack_require__(1901);
	
	var _dateRoute2 = _interopRequireDefault(_dateRoute);
	
	var _summary = __webpack_require__(1902);
	
	var _summary2 = _interopRequireDefault(_summary);
	
	var _toll = __webpack_require__(26);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	var _date = __webpack_require__(38);
	
	var F = _interopRequireWildcard(_date);
	
	var _dateFns = __webpack_require__(208);
	
	var _transportadorRntrc = __webpack_require__(520);
	
	var _transportadorRntrc2 = _interopRequireDefault(_transportadorRntrc);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['contractShipper'],
	  data: function data() {
	    return {
	      loading: undefined,
	      step: 0,
	      msgError: undefined,
	      routeSelected: undefined,
	      filterActive: true,
	      aggregate: undefined,
	      docEmbarqueNum: undefined,
	      docEmbarqueTipo: undefined,
	      forceTransfer: false,
	      showForceTransfer: false,
	      idIntern: undefined,
	      confirmRouteSelected: false,
	      expirationVP: undefined,
	      startVP: undefined,
	      transportadorRntrc: { documento: undefined, nome: undefined },
	      showTranportadorRntrc: false
	    };
	  },
	
	  computed: {
	    contractId: function contractId() {
	      return this.$route.params.contractId;
	    }
	  },
	  watch: {
	    filterActive: function filterActive() {
	      this.filter();
	    }
	  },
	  methods: {
	    aggregateData: function aggregateData(fn) {
	      this.aggregate = fn;
	    },
	    callback: function callback(fn) {
	      this.confirmRouteSelected = fn;
	    },
	    cleanErrors: function cleanErrors() {
	      this.msgError = undefined;
	    },
	    nextStep: function nextStep() {
	      this.msgError = undefined;
	      $('body').stop().animate({
	        scrollTop: 0
	      }, '500', 'swing');
	      switch (this.step) {
	        case 0:
	          this.step += 1;
	          break;
	        case 1:
	          if (this.routeSelected !== undefined) {
	            this.step += 1;
	            this.confirmRouteSelected = false;
	            if (this.routeSelected.expirationToll) this.expirationVP = new Date(this.routeSelected.expirationToll);
	            if (this.routeSelected.startToll) this.startVP = new Date(this.routeSelected.startToll);
	            if (!this.expirationVP) {
	              this.msgError = 'Informe a data de fim da viagem.';
	              if (this.routeSelected !== undefined) this.step -= 1;
	              return;
	            }
	
	            if (!this.startVP) {
	              this.msgError = 'Informe a data de inicio da viagem.';
	              if (this.routeSelected !== undefined) this.step -= 1;
	              return;
	            }
	
	            var dateNow_30 = new Date();
	            dateNow_30.setUTCDate(dateNow_30.getUTCDate() + 30);
	
	            if ((0, _dateFns.isAfter)(this.expirationVP, dateNow_30)) {
	              this.msgError = 'Data de fim da viagem deve ser anterior a ' + (0, _dateFns.format)(dateNow_30, 'yyyy-MM-dd HH:mm:ss') + '.';
	              this.step -= 1;
	              return;
	            }
	
	            if ((0, _dateFns.isBefore)(this.expirationVP, this.startVP)) {
	              this.msgError = 'Data de fim da viagem deve ser superior a data de início da viagem.';
	              this.step -= 1;
	              return;
	            }
	          } else {
	            this.confirmRouteSelected = true;
	          }
	          break;
	        case 2:
	          this.step += 1;
	          break;
	        case 3:
	          this.step += 1;
	          break;
	      }
	    },
	    backStep: function backStep() {
	      this.msgError = undefined;
	      if (this.step === 2) this.cleanVars();
	      $('body').stop().animate({
	        scrollTop: 0
	      }, '500', 'swing');
	      this.step -= 1;
	    },
	    doRequest: function doRequest() {
	      var _this = this;
	
	      this.msgError = undefined;
	      if (this.routeSelected.totalValue == 0) {
	        this.msgError = 'Ocorreu um problema, o valor total dos pedágios não pode ser ZERO';
	        return;
	      }
	
	      var req = {
	        placaVeiculo: this.aggregate.plate,
	        routeId: this.routeSelected.routeId,
	        version: this.routeSelected.version,
	
	        expirationVP: (0, _dateFns.format)(new Date(this.routeSelected.expirationToll), 'yyyy-MM-dd HH:mm:ss'),
	        startVP: (0, _dateFns.format)(new Date(this.routeSelected.startToll), 'yyyy-MM-dd HH:mm:ss'),
	        CNPJTransportador: this.transportadorRntrc.documento,
	        transportador: this.transportadorRntrc.nome,
	        docEmbarqueTipo: '',
	        docEmbarqueNum: '',
	        CPFCNPJEmbarcador: this.aggregate.taxIdNumber,
	        categoryArtespId: this.aggregate.categoryAxesId,
	        forceTransfer: this.forceTransfer ? 1 : 0,
	        contratoOrig: this.contractShipper.contractId
	      };
	
	      this.loading = _toll2.default.insertValePedagio(req).then(function (res) {
	        _this.msgError = undefined;
	        _this.idIntern = res.idIntern;
	        _this.step += 1;
	      }).catch(function (err) {
	        _this.msgError = err.data.status.message;
	        if (err.data.status && (err.data.status.code === 9203 || err.data.status.code === 9205 || err.data.status.code === 9209 || err.data.status.code === 9210 || err.data.status.code === 9223 || err.data.status.code === 9225)) {
	          _this.showTranportadorRntrc = true;
	          _this.enableRNTRC = true;
	          _this.step -= 1;
	          return;
	        }
	        if (err.data.status && err.data.status.code == 500) {
	          _this.showForceTransfer = true;
	          return;
	        }
	      });
	    },
	    closeModal: function closeModal() {
	      var close = {
	        modal: 'toll-ticket'
	      };
	      this.$emit('close', close);
	      this.aggregateData = undefined;
	      this.routeSelected = undefined;
	
	      this.transportadorRntrc = undefined;
	      this.step = 0;
	      this.msgError = undefined;
	    },
	    cleanVars: function cleanVars() {
	      this.expirationVP = undefined;
	      this.routeSelected = undefined;
	      this.msgError = undefined;
	    }
	  },
	  components: {
	    TransportadorRntrc: _transportadorRntrc2.default, VehicleAggregate: _vehicleAggregate2.default, DateRoute: _dateRoute2.default, SummaryAggregate: _summary2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _pagination = __webpack_require__(33);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _route = __webpack_require__(59);
	
	var _route2 = _interopRequireDefault(_route);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(13);
	
	var _dateFns = __webpack_require__(208);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var workingDays = [{
	  value: '0',
	  caption: 'Validade do VP'
	}, {
	  value: '1',
	  caption: '1 dia'
	}, {
	  value: '5',
	  caption: '5 dias'
	}, {
	  value: '10',
	  caption: '10 dias'
	}, {
	  value: '15',
	  caption: '15 dias'
	}, {
	  value: '30',
	  caption: '30 dias'
	}];
	
	exports.default = {
	  components: { Pagination: _pagination2.default },
	  props: ['aggregate', 'confirmRouteSelected', 'routeIdSelected'],
	  data: function data() {
	    var currentDate = new Date();
	    var minDate = (0, _dateFns.addMinutes)(currentDate, 10);
	    var maxDate = (0, _dateFns.setMinutes)((0, _dateFns.setHours)((0, _dateFns.addDays)(currentDate, 30), 23), 59);
	    var formattedMinDate = (0, _dateFns.format)(minDate, "yyyy-MM-dd'T'HH:mm");
	    var formattedMaxDate = (0, _dateFns.format)(maxDate, "yyyy-MM-dd'T'HH:mm");
	    return {
	      minDate: formattedMinDate,
	      maxDate: formattedMaxDate,
	      dataInicioViagem: formattedMinDate,
	      dataFimViagem: '',
	      expirationDays: '0',
	      workingDays: workingDays,
	      page: new _pagination.Page().size(5),
	      routes: undefined,
	      search: '',
	      loading: undefined,
	      filterActive: true,
	      isActiveArray: [],
	      routeSelected: this.routeIdSelected ? this.routeIdSelected.routeId : undefined,
	      showAlert: true,
	      warning: false,
	      msgStrong: 'Nova forma de consulta.',
	      msgAlert: ' Para saber a relação de rotas cadastradas, faça uma pesquisa individual digitando o nome da rota ou clique na lupa com o campo vazio, para uma consulta geral.'
	    };
	  },
	  mounted: function mounted() {
	    this.$store.state.route.actives = undefined;
	    this.routeSelected = undefined;
	    this.routes = undefined;
	  },
	
	  watch: {
	    search: function search() {
	      this.page = this.page.page(1);
	    },
	    filterActive: function filterActive() {
	      this.filter();
	    },
	    routeSelected: function routeSelected(newVal) {
	      if (!newVal) return;
	
	      var vm = this;
	      var r = _.find(this.routes, function (o) {
	        return o.routeId == vm.routeSelected;
	      });
	
	      if (this.dataInicioViagem) r.startToll = this.dataInicioViagem;
	      if (this.dataFimViagem) r.expirationToll = this.dataFimViagem;
	      this.$emit('input', r);
	    },
	    dataInicioViagem: function dataInicioViagem(newValue) {
	      if (this.routeSelected && (0, _typeof3.default)(this.routeSelected) === 'object') {
	        this.routeSelected.startToll = newValue;
	      }
	
	      if (this.routeSelected) {
	        this.$emit('input', this.atualizarElementoRota(this.routeSelected));
	      } else {
	        this.$emit('input', this.routeSelected);
	      }
	      this.$emit('cleanErrors');
	    },
	    dataFimViagem: function dataFimViagem(newValue) {
	      if (this.routeSelected && (0, _typeof3.default)(this.routeSelected) === 'object') {
	        this.routeSelected.expirationToll = newValue;
	      }
	
	      if (this.routeSelected) {
	        this.$emit('input', this.atualizarElementoRota(this.routeSelected));
	      } else {
	        this.$emit('input', this.routeSelected);
	      }
	      this.$emit('cleanErrors');
	    },
	    confirmRouteSelected: function confirmRouteSelected() {
	      if (this.confirmRouteSelected) {
	        this.msgStrong = 'Campo obrigatório';
	        this.msgAlert = 'Antes de prosseguir é necessário selecionar uma rota.';
	        this.warning = true;
	        this.showAlert = true;
	        this.$emit('confirmRouteSelected', false);
	      }
	    }
	  },
	  computed: {
	    expirationDate: function expirationDate() {
	      return (0, _moment2.default)().add(parseInt(this.expirationDays), 'd');
	    },
	    allRoutes: function allRoutes() {
	      return this.$store.state.route.actives;
	    },
	    routesPaged: function routesPaged() {
	      this.filter();
	      if (this.routes && this.page) {
	        for (var i = 0; i < this.routes.length; i++) {
	          this.$set(this.routes[i], 'open', false);
	        }
	        return this.routes.slice(this.page.firstIndexShown() - 1, this.page.lastIndexShown());
	      }
	      return undefined;
	    }
	  },
	
	  methods: {
	    atualizarElementoRota: function atualizarElementoRota() {
	      var vm = this;
	      var r = _.find(this.routes, function (o) {
	        return o.routeId == vm.routeSelected;
	      });
	
	      if (this.dataInicioViagem) r.startToll = this.dataInicioViagem;
	      if (this.dataFimViagem) r.expirationToll = this.dataFimViagem;
	      return r;
	    },
	    searchRoutes: function searchRoutes() {
	      var _this = this;
	
	      this.loading = this.$store.dispatch('getRoutes', this.search).then(function (resp) {
	        if (_this.allRoutes.length !== 0) {
	          _this.routes = _this.allRoutes;
	          _this.page = _this.page.itemCount(_this.allRoutes.length);
	          _this.showAlert = false;
	        } else {
	          _this.msgStrong = 'Rota não encontrada!';
	          _this.msgAlert = 'Faça uma nova busca ou cadastre uma nova rota.';
	          _this.warning = true;
	          _this.showAlert = true;
	        }
	      });
	    },
	    setCurrentPage: function setCurrentPage(p) {
	      this.page = this.page.page(p);
	      this.find();
	    },
	    getCity: function getCity(route, type) {
	      var p = _.find(route.points, function (o) {
	        return o.type == type;
	      });
	
	      if (p) return p.city + ', ' + p.state;
	
	      return "";
	    },
	    getAddress: function getAddress(route, type) {
	      var p = _.find(route.points, function (o) {
	        return o.type == type;
	      });
	
	      if (p) return p.address;
	
	      return "";
	    },
	
	
	    filter: _.debounce(function () {
	      var _this2 = this;
	
	      this.search = this.search.toUpperCase();
	
	      if (!this.allRoutes) return;
	
	      if (this.search == '') {
	        this.routes = this.allRoutes;
	        this.page = this.page.itemCount(this.routes.length);
	        if (this.routes.length === 0) {
	          this.showAlert = true;
	        }
	        return;
	      }
	
	      this.routes = this.allRoutes.filter(function (value) {
	        var a = value.name.toUpperCase().indexOf(_this2.search) >= 0 || value.flexField1 && value.flexField1.toUpperCase().indexOf(_this2.search) >= 0 || value.flexField2 && value.flexField2.toUpperCase().indexOf(_this2.search) >= 0;
	        var b = _.filter(value.points, function (o) {
	          return o.address && o.address.toUpperCase().indexOf(_this2.search) >= 0;
	        }).length > 0;
	        return a || b;
	      });
	
	      if (this.routes.length == 0) {
	        this.msgStrong = 'Rota não encontrada!';
	        this.msgAlert = 'Faça uma nova busca ou cadastre uma nova rota.';
	        this.warning = true;
	        this.showAlert = true;
	      } else {
	        this.showAlert = false;
	      }
	
	      this.page = this.page.itemCount(this.routes.length);
	    }, 400)
	  }
	};

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _string = __webpack_require__(35);
	
	var _toll = __webpack_require__(26);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['routeSelected', 'aggregate'],
	  data: function data() {
	    return {
	      loading: undefined,
	      priceTolls: {},
	      open: true,
	      origin: {},
	      destination: {},
	      showDetails: false
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var vm = this;
	    var tolls = [];
	
	    if (this.routeSelected) {
	      this.routeSelected.points.find(function (o) {
	        if (o.type == 'origin') {
	          vm.origin = { 'city': o.city, 'state': o.state };
	        } else if (o.type == 'destination') {
	          vm.destination = { 'city': o.city, 'state': o.state };
	        }
	      });
	    }
	
	    this.routeSelected.tollFees.forEach(function (element) {
	      element.radius = element.radius == "" ? 0 : element.radius;
	      tolls.push(element);
	    });
	
	    this.loading = _toll2.default.getPriceTolls({ tolls: tolls, axes: this.aggregate.categoryAxesId }).then(function (r) {
	      _this.priceTolls = r;
	    }).catch(function (err) {});
	
	    this.showDetails = true;
	  }
	};

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toll = __webpack_require__(26);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	var _cpfCnpj = __webpack_require__(86);
	
	var _messageDialog = __webpack_require__(53);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['aggregate', 'transportadorRntrc', 'nxtStep'],
	  data: function data() {
	    return {
	      loading: undefined,
	      rntrcDocument: undefined,
	      rntrcOwnerName: undefined,
	      enableRNTRC: false,
	      msgError: undefined
	    };
	  },
	  mounted: function mounted() {
	    if (!this.aggregate.companyName) this.aggregate.companyName = this.aggregate.personName + ' ' + this.aggregate.personLastName;
	  },
	
	
	  methods: {
	    showRNTRC: function showRNTRC() {
	      this.enableRNTRC = true;
	    },
	    cancelRNTRC: function cancelRNTRC() {
	      this.enableRNTRC = false;
	      this.rntrcDocument = '';
	      this.rntrcOwnerName = '';
	      this.msgError = undefined;
	    },
	    validateDocument: function validateDocument() {
	      var _this = this;
	
	      if (!this.rntrcOwnerName) {
	        this.msgError = "Favor informar Nome/Razão Social.";
	        return;
	      }
	
	      if (!this.rntrcDocument) {
	        this.msgError = 'Favor informar CPF/CNPJ.';
	        return;
	      }
	
	      if (!_cpfCnpj.cpfCnpj.validate(this.rntrcDocument)) {
	        this.msgError = "Documento inválido!";
	        return;
	      }
	
	      this.loading = _toll2.default.getVehicleDataVp(this.aggregate.plate, this.rntrcDocument).then(function (response) {
	        _this.vehicle = response;
	        _this.enableRNTRC = false;
	        var rntrcValidado = response && response.rntrc && !(response.rntrc.indexOf("RNTRC") !== -1);
	        if (rntrcValidado) {
	          if (_this.rntrcOwnerName) {
	            _this.transportadorRntrc.nome = _this.rntrcOwnerName.toUpperCase();
	            _this.aggregate.nomeTransportador = _this.transportadorRntrc.nome;
	          } else {
	            _this.transportadorRntrc.nome = "";
	            _this.aggregate.nomeTransportador = "";
	          }
	          if (_this.rntrcDocument) {
	            _this.transportadorRntrc.documento = _this.rntrcDocument;
	            _this.aggregate.taxpayerTransportador = _this.transportadorRntrc.documento;
	          }
	        }
	
	        _this.rntrcDocument = '';
	        _this.rntrcOwnerName = '';
	        _this.msgError = undefined;
	
	        if (rntrcValidado) {
	          _messageDialog2.default.show({
	            title: 'Sucesso',
	            message: 'Documento validado com sucesso.',
	            type: 'OK'
	          });
	        } else {
	          _messageDialog2.default.show({
	            title: 'Falha validação',
	            message: response.rntrc,
	            type: 'OK'
	          });
	        }
	        _this.$emit('nxtStep');
	      }).catch(function (err) {
	        console.log(err);
	
	        _this.msgError = 'Favor entrar em contato com o suporte.';
	        if (err.data.status.code !== 9990) _this.msgError = err.data.status.message;
	      });
	    }
	  }
	};

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toll = __webpack_require__(26);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _messageDialog = __webpack_require__(53);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _transportadorRntrc = __webpack_require__(520);
	
	var _transportadorRntrc2 = _interopRequireDefault(_transportadorRntrc);
	
	var _cpfCnpj = __webpack_require__(86);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { TransportadorRntrc: _transportadorRntrc2.default },
	  props: ['aggregate', 'contract'],
	  data: function data() {
	    return {
	      loading: undefined,
	      plate: undefined,
	      axesId: 2,
	      msgError: undefined,
	      msgErrorBold: undefined,
	      vehicle: this.aggregate || undefined,
	      contractAggregate: undefined,
	      enableRNTRC: false,
	      showTranportadorRntrc: false,
	      transportadorRntrc: undefined,
	      rntrcDocument: undefined,
	      rntrcOwnerName: undefined
	    };
	  },
	
	  watch: {
	    plate: function plate(value) {
	      if (value.length < 8) return false;else this.findPlate();
	    },
	    axesId: function axesId(newVal) {
	
	      this.vehicle.categoryAxesId = newVal;
	      this.vehicle.categoryArtespId = newVal;
	      this.vehicle.category = this.category;
	    }
	  },
	  computed: {
	    axes: function axes() {
	      return _constantes2.default.Axes;
	    },
	    category: function category() {
	      var _this = this;
	
	      return _.find(_constantes2.default.Axes, function (o) {
	        return o.category_artesp_id == _this.axesId;
	      }).caption;
	    }
	  },
	  methods: {
	    findPlate: function findPlate() {
	      var _this2 = this;
	
	      this.msgError = undefined;
	      this.loading = _toll2.default.getVehicleDataVp(this.plate).then(function (r) {
	        _this2.vehicle = r;
	
	        _this2.$emit('aggregateData', _this2.vehicle);
	        _this2.msgError = undefined;
	        _this2.msgErrorBold = undefined;
	      }).catch(function (err) {
	        _this2.$emit('aggregateData', undefined);
	
	        if (err.data.status && (err.data.status.code === 9203 || err.data.status.code === 9205 || err.data.status.code === 9209 || err.data.status.code === 9210 || err.data.status.code === 9223 || err.data.status.code === 9225)) {
	          _this2.showTranportadorRntrc = true;
	          _this2.enableRNTRC = true;
	          _this2.msgError = err.data.status.message;
	          return;
	        } else {
	          if (err.data.status.code === 9883) {
	            _this2.msgErrorBold = 'Placa não encontrada!';
	            _this2.msgError = 'Faça uma nova busca ou cadastre o Agregado.';
	          } else {
	            _this2.msgError = err.data.status.message;
	          }
	          _this2.vehicle = undefined;
	        }
	      });
	    },
	    cancelRNTRC: function cancelRNTRC() {
	      this.enableRNTRC = false;
	      this.rntrcDocument = '';
	      this.rntrcOwnerName = '';
	    },
	    validateDocument: function validateDocument() {
	      var _this3 = this;
	
	      if (!this.rntrcDocument) {
	        this.msgError = 'Favor informar CPF/CNPJ.';
	        return;
	      }
	
	      if (!_cpfCnpj.cpfCnpj.validate(this.rntrcDocument)) {
	        this.msgError = "Documento inválido!";
	        return;
	      }
	
	      this.loading = _toll2.default.getVehicleDataVp(this.plate, this.rntrcDocument).then(function (response) {
	
	        _this3.vehicle = response;
	        _this3.enableRNTRC = false;
	        _this3.$emit('aggregateData', _this3.vehicle);
	        _this3.msgError = undefined;
	        _this3.msgErrorBold = undefined;
	      }).catch(function (err) {
	        _this3.msgError = err.data.status.message;
	      });
	    }
	  }
	};

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vehicles = __webpack_require__(29);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	var _param = __webpack_require__(68);
	
	var _param2 = _interopRequireDefault(_param);
	
	var _modalRescueBalance = __webpack_require__(519);
	
	var _modalRescueBalance2 = _interopRequireDefault(_modalRescueBalance);
	
	var _pagination = __webpack_require__(33);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      page: new _pagination.Page().size(10),
	      loading: false,
	      plate: undefined,
	      arrayVP: new Array(),
	      vehiclesBalance: new Array(),
	      lastDays: '31',
	      showRescue: false,
	      rescueData: new Array(),
	      feeTax: undefined,
	      searchState: undefined,
	      totalRescue: 0
	    };
	  },
	
	  computed: {
	    contractId: function contractId() {
	      return this.$route.params.contractId;
	    },
	    contractIdCred: function contractIdCred() {
	      var contract = this.$store.state.contract.contracts.find(function (contract) {
	        return contract.plan.planId == 6 || contract.plan.planId == 8;
	      });
	      return contract.contractId;
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.doFilter();
	
	    _param2.default.getGeneralParameter({ key: 'TAXA_TRANSFERENCIA' }).then(function (res) {
	      _this.feeTax = 1 + res.value / 100;
	    }).catch(function (err) {});
	  },
	
	  methods: {
	    handleChangeDate: function handleChangeDate(value) {
	      this.lastDays = value;
	      this.doFilter(true);
	    },
	    setCurrentPage: function setCurrentPage(p) {
	      this.page = this.page.page(p);
	      $('.check-item').each(function () {
	        this.checked = false;
	      });
	      this.doFilter();
	    },
	    setPageSize: function setPageSize(size) {
	      this.page = this.page.size(size);
	      this.doFilter();
	    },
	    rescueBalance: function rescueBalance(value) {
	      this.showRescue = true;
	      this.$nextTick(function () {
	        $('#modal-rescue-balance').modal();
	      });
	    },
	    close: function close(fn) {
	      var _this2 = this;
	
	      this.showRescue = false;
	      this.totalRescue = 0;
	
	      $('#modal-rescue-balance').modal('hide');
	      this.$nextTick(function () {
	        _this2.doFilter(true);
	      });
	    },
	    checkAll: function checkAll() {
	      var _this3 = this;
	
	      this.totalRescue = 0;
	      var checkAll = document.getElementById('selectAll');
	      var value = {};
	      if (checkAll.checked) {
	        $('.check-item').each(function () {
	          this.checked = true;
	        });
	        this.vehiclesBalance.forEach(function (o, index) {
	          value = {
	            index: index,
	            contractIdDeb: o.contractIdVp,
	            contractIdCred: _this3.contractIdCred,
	            transferValue: o.transferValue,
	            feeValue: o.taxValue
	          };
	          _this3.totalRescue += o.saldoVp;
	          _this3.rescueData.push(value);
	        });
	      } else {
	        $('.check-item').each(function () {
	          this.checked = false;
	        });
	        this.rescueData = new Array();
	        this.totalRescue = 0;
	      }
	    },
	    check: function check(id) {
	      var _this4 = this;
	
	      var value = {
	        index: id,
	        contractIdCred: this.contractIdCred,
	        contractIdDeb: $('#' + id).parents('tr').find('.td-plate span:last-child').text(),
	        transferValue: parseInt($('#' + id).parents('tr').find('.text-right span:nth-child(2)').text().replace(/\D+/g, '')),
	        feeValue: parseInt($('#' + id).parents('tr').find('.text-right span:last-child').text().replace(/\D+/g, ''))
	      };
	
	      if (this.rescueData.length == 0) {
	        this.rescueData.push(value);
	        this.totalRescue += parseInt($('#' + id).parents('tr').find('.text-right span:first-child').text().replace(/\D+/g, ''));
	      } else {
	        this.rescueData.filter(function (o) {
	          if (o.index === value.index) {
	            document.getElementById(id).checked = false;
	            _this4.rescueData.splice(o, 1);
	            _this4.totalRescue -= parseInt($('#' + id).parents('tr').find('.text-right span:first-child').text().replace(/\D+/g, ''));
	          } else {
	            _this4.totalRescue += parseInt($('#' + id).parents('tr').find('.text-right span:first-child').text().replace(/\D+/g, ''));
	            _this4.rescueData.push(value);
	          }
	        });
	      }
	    },
	    validate: function validate() {
	      var error = this.errors;
	
	      var filter = {
	        contractIdAgr: this.contractId,
	        page: this.page.build(),
	        "pageSize": 6
	      };
	
	      if (this.lastDays == undefined && (!this.customStart || !this.customEnd || this.customStart > this.customEnd)) {
	        this.searchState = 'ERROSEARCH';
	        this.messageError = this.customStart && this.customEnd ? 'Impossível filtrar! O período inicial é mais novo que o período final.' : 'Existem campos não preenchidos!';
	        return false;
	      }
	
	      if (this.lastDays == undefined && beforeOneYear.validate(moment(this.customStart).format("L"))) {
	        this.searchState = 'ERROSEARCH';
	        this.messageError = 'Período indisponível! Para consultas de período anteriores a um ano, favor entrar em contato com a nossa Central de Relacionamento.';
	        return false;
	      }
	
	      if (this.lastDays == undefined && this.customStart && this.customEnd && this.customEnd - this.customStart > 2678400000) {
	        this.searchState = 'ERROSEARCH';
	        this.messageError = 'Período máximo permitido, 31 dias.';
	        return false;
	      }
	
	      return filter;
	    },
	    doFilter: function doFilter(clearCache) {
	      var _this5 = this;
	
	      this.totalRescue = 0;
	      this.vehiclesBalance = [];
	      this.rescueData = [];
	
	      var filter = this.validate();
	      $('.check-item').each(function () {
	        this.checked = false;
	      });
	
	      if (clearCache) {
	        this.vehiclesBalance = new Array();
	        filter.page = 1;
	        this.page = filter.page = this.page.page(1);
	      }
	
	      if (filter) {
	        var promise = _vehicles2.default.getVehiclesAggregateWithBalance(filter).then(function (data) {
	          _this5.vehiclesBalance = data.itens;
	          _this5.page = _this5.page.itemCount(data.total);
	
	          if (data.total && _this5.vehiclesBalance.length > 0) {
	            _this5.searchState = 'FOUND';
	            _this5.$nextTick(function () {
	              $('[data-toggle="tooltip"]').tooltip();
	              $('html, body').stop().animate({
	                scrollTop: $("#table-rescue-balance").offset().top - 110
	              }, 1000);
	            });
	          } else {
	            _this5.searchState = 'NOTFOUND';
	          }
	        }).catch(function (err) {
	          _this5.searchState = 'NOTFOUND';
	        });
	        this.$store.dispatch('loading', promise);
	      }
	    }
	  },
	  components: {
	    Pagination: _pagination2.default, ModalRescueBalance: _modalRescueBalance2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _string = __webpack_require__(35);
	
	var _date = __webpack_require__(60);
	
	var _date2 = __webpack_require__(38);
	
	var F = _interopRequireWildcard(_date2);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _pagination = __webpack_require__(33);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _toll = __webpack_require__(26);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: undefined,
	      searchState: 'NEW',
	      lastDays: '31',
	      customStart: undefined,
	      customEnd: undefined,
	      dateRange: [this.customStart, this.customEnd],
	      page: new _pagination.Page(),
	      vpFilterDate: {},
	      summaryVP: {},
	      origin: {},
	      destination: {},
	      open: true,
	      totalValue: 0,
	      lang: {
	        formatLocale: {
	          months: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
	
	          monthsShort: ["Jan", "Fev", "Mar", "Abr", "Maio", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
	
	          weekdays: ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"],
	
	          weekdaysShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
	
	          weekdaysMin: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
	
	          firstDayOfWeek: 0,
	
	          firstWeekContainsDate: 1
	        }
	      },
	      momentFormat: {
	        stringify: function stringify(date) {
	          return date ? (0, _moment2.default)(date).format('L') : '';
	        }
	      }
	    };
	  },
	
	  computed: {
	    formatDate: function formatDate(date) {
	
	      return (0, _moment2.default)(date).format('L');
	    },
	    contractId: function contractId() {
	      return this.$route.params.vehicle.contractId;
	    },
	    vehicle: function vehicle() {
	      return this.$route.params.vehicle;
	    },
	    periodStart: function periodStart() {
	      var days = this.lastDays;
	      var d = this.customStart != undefined && this.customStart != null ? (0, _moment2.default)(this.customStart) : (0, _moment2.default)().subtract(parseInt(days), 'd');
	
	      return F.date(d, 'YYYY-MM-DD');
	    },
	    periodEnd: function periodEnd() {
	      var days = this.lastDays;
	      var d = this.customEnd != undefined && this.customEnd != null ? (0, _moment2.default)(this.customEnd) : (0, _moment2.default)();
	
	      return F.date(d, 'YYYY-MM-DD');
	    }
	  },
	  mounted: function mounted() {
	    this.doFilter();
	  },
	  created: function created() {},
	  methods: {
	    handleChangeDate: function handleChangeDate(value) {
	
	      if (value.length > 1) {
	        this.customStart = value[0];
	        this.customEnd = value[1];
	        this.lastDays = undefined;
	      } else {
	        this.customStart = undefined;
	        this.customEnd = undefined;
	        this.lastDays = value;
	      }
	      this.doFilter(true);
	    },
	    setCurrentPage: function setCurrentPage(p) {
	      this.page = this.page.page(p);
	      this.doFilter();
	    },
	    setPageSize: function setPageSize(size) {
	      this.page = this.page.size(size);
	      this.doFilter();
	    },
	    validate: function validate() {
	      var error = this.errors;
	
	      var filter = {
	        startDate: this.periodStart,
	        endDate: this.periodEnd,
	
	        placaVeiculo: this.vehicle.plate.replace('-', ''),
	        page: this.page.build()
	      };
	
	      if (this.lastDays == undefined && (!this.customStart || !this.customEnd || this.customStart > this.customEnd)) {
	        this.searchState = 'ERROSEARCH';
	        this.messageError = this.customStart && this.customEnd ? 'Impossível filtrar! O período inicial é mais novo que o período final.' : 'Existem campos não preenchidos!';
	        return false;
	      }
	
	      if (this.lastDays == undefined && _date.beforeOneYear.validate((0, _moment2.default)(this.customStart).format("L"))) {
	        this.searchState = 'ERROSEARCH';
	        this.messageError = 'Período indisponível! Para consultas de período anteriores a um ano, favor entrar em contato com a nossa Central de Relacionamento.';
	        return false;
	      }
	
	      if (this.lastDays == undefined && this.customStart && this.customEnd && this.customEnd - this.customStart > 2678400000) {
	        this.searchState = 'ERROSEARCH';
	        this.messageError = 'Período máximo permitido, 31 dias.';
	        return false;
	      }
	
	      return filter;
	    },
	    doFilter: function doFilter(clearCache) {
	      var _this = this;
	
	      var filter = this.validate();
	
	      if (clearCache) {
	        this.totalValue = 0;
	        this.summaryVP = {};
	        filter.page = 1;
	        this.page = filter.page = this.page.page(1);
	      }
	
	      if (filter) {
	        var promise = _toll2.default.getFilter(filter).then(function (data) {
	          _this.summaryVP = data.itens;
	
	          for (var i = 0; i < _this.summaryVP.length; i++) {
	            _this.$set(_this.summaryVP[i], 'open', false);
	            _this.totalValue += _this.summaryVP[i].valorVP;
	          }
	
	          if (data.total) {
	            _this.searchState = 'FOUND';
	            _this.page = _this.page.itemCount(data.total);
	            _this.$nextTick(function () {
	              $('[data-toggle="tooltip"]').tooltip();
	              $('html, body').stop().animate({
	                scrollTop: $("#vp-vehicle-movement").offset().top - 110
	              }, 1000);
	            });
	          } else {
	            _this.searchState = 'NOTFOUND';
	          }
	        }).catch(function (err) {
	          _this.searchState = 'NOTFOUND';
	        });
	        this.$store.dispatch('loading', promise);
	      }
	    }
	  },
	  components: {
	    Pagination: _pagination2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _b2c = __webpack_require__(162);
	
	var _b2c2 = _interopRequireDefault(_b2c);
	
	var _b2b = __webpack_require__(119);
	
	var _b2b2 = _interopRequireDefault(_b2b);
	
	var _vpo = __webpack_require__(163);
	
	var _vpo2 = _interopRequireDefault(_vpo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['type'],
	  components: { b2c: _b2c2.default, b2b: _b2b2.default, vpo: _vpo2.default }
	};

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _from = __webpack_require__(173);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _map = __webpack_require__(121);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _payment = __webpack_require__(169);
	
	var _payment2 = _interopRequireDefault(_payment);
	
	var _utils = __webpack_require__(34);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['contractId', 'payment', 'planId', 'addressMailing', 'creditCardOptions', 'bankAccountOptions', 'bankBillOption', 'value', 'showNewPayment'],
	  data: function data() {
	    return {
	      arrayDebito: undefined,
	      arrayCartao: undefined,
	      boletoCadastrato: undefined,
	      boleto: undefined,
	      index: 1,
	      contractPaymentMethodId: this.value,
	      loading: undefined,
	      paymentSelected: this.payment,
	      typesAlowed: {}
	
	    };
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.typesAlowed = this.$store.getters.getPaymentsTypesByPlan(this.planId);
	
	    this.loading = _contracts2.default.getPaymentMethod().then(function (result) {
	      var data = result;
	      _this.arrayCartao = _this.typesAlowed.creditCard ? _.filter(data, { type: 'CC' }) : undefined;
	      _this.arrayDebito = _this.typesAlowed.bankAccount ? _.filter(data, { type: 'DC' }) : undefined;
	      _this.removeDuplicity();
	    });
	
	    this.$store.commit('currentPlanId', this.planId);
	  },
	  watch: {
	    contractPaymentMethodId: function contractPaymentMethodId(newValue) {
	      this.$emit('input', newValue);
	    }
	  },
	  methods: {
	    imageUrl: function imageUrl(paymentMethod) {
	      if (!paymentMethod) return "";
	      return '/static/payment-methods/' + paymentMethod.imagePath.split('.')[0] + '.svg';
	    },
	    removeDuplicity: function removeDuplicity() {
	
	      var map = new _map2.default();
	      if (this.arrayCartao) {
	        map.clear();
	        this.arrayCartao.forEach(function (element, index) {
	          var key = '' + element.creditCard.brand + element.creditCard.ownerName + element.creditCard.expirationYear + element.creditCard.expirationMonth;
	          if (!map.has(key)) {
	            map.set(key, element);
	          }
	        });
	        this.arrayCartao = (0, _from2.default)(map, function (value) {
	          return value[1];
	        });
	      }
	
	      if (this.arrayDebito) {
	        map.clear();
	        this.arrayDebito.forEach(function (element, index) {
	          var key = '' + element.bankAccount.accountDigit + element.bankAccount.accountNumber + element.bankAccount.agencyNumber;
	          if (!map.has(key)) {
	            map.set(key, element);
	          }
	        });
	        this.arrayDebito = (0, _from2.default)(map, function (value) {
	          return value[1];
	        });
	      }
	    },
	    validateAll: function validateAll() {
	      if (!this.contractPaymentMethodId) {
	
	        return _promise2.default.reject({ customMsg: "Por favor selecione uma forma de pagamento" });
	      } else if (this.contractPaymentMethodId == 'newBankBill') {
	        delete this.payment.bankAccount;
	        delete this.payment.creditCard;
	        this.payment.bankBill = this.bankBillOption;
	        this.payment.paymentMethodId = this.bankBillOption.bankBill.paymentMethodId;
	        this.payment.imagePath = this.bankBillOption.bankBill.imagePath;
	        this.$emit('paymentSelected', this.bankBillOption);
	        return _promise2.default.resolve(true);
	      } else if (this.contractPaymentMethodId == 'newPayment') {
	
	        this.$emit('paymentSelected', this.payment);
	        return this.$refs.payment.validateAll();
	      } else {
	
	        if (this.paymentSelected.creditCard) {
	          if (!utils.validateCreditCard(this.paymentSelected.creditCard.expirationMonth, this.paymentSelected.creditCard.expirationYear)) {
	            return _promise2.default.reject({ customMsg: 'Data de validade do cart\xE3o expirou: ' + this.paymentSelected.creditCard.expirationMonth + '/' + this.paymentSelected.creditCard.expirationYear + '. Cadastre uma nova forma de pagamento, v\xE1lida!' });
	          }
	        }
	        if (this.paymentSelected.creditCard) {
	          if (!this.paymentSelected.secureCodeCreditCard || this.paymentSelected.secureCodeCreditCard.length < 3) return _promise2.default.reject({ customMsg: "Informe o código de segurança do cartão" });
	        }
	        this.$emit('paymentSelected', this.paymentSelected);
	        return _promise2.default.resolve(true);
	      }
	    },
	    getPaymentSelected: function getPaymentSelected() {
	      if (this.contractPaymentMethodId == 'newBankBill' || this.contractPaymentMethodId == 'newPayment') {
	        return this.payment;
	      } else {
	        return this.paymentSelected;
	      }
	    }
	  },
	  computed: {},
	  components: {
	    Payment: _payment2.default
	  }
	};

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(48);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _methods;
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _modalChangeAutomaticValue = __webpack_require__(524);
	
	var _modalChangeAutomaticValue2 = _interopRequireDefault(_modalChangeAutomaticValue);
	
	var _modalAutomaticValue = __webpack_require__(523);
	
	var _modalAutomaticValue2 = _interopRequireDefault(_modalAutomaticValue);
	
	var _number = __webpack_require__(24);
	
	var _util = __webpack_require__(159);
	
	var _param = __webpack_require__(68);
	
	var _param2 = _interopRequireDefault(_param);
	
	var _invoice = __webpack_require__(170);
	
	var _invoice2 = _interopRequireDefault(_invoice);
	
	var _vehicles = __webpack_require__(29);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: undefined,
	      loadingRecharge: undefined,
	      contract: undefined,
	      invoice: undefined,
	      recharge: undefined,
	      rechargeAlter: undefined,
	      showModal: undefined,
	      valueTaxRechargeAlter: undefined,
	      rechargeQtd: undefined,
	      modalRecharge: {},
	      newLimit: undefined,
	      fmtValorLimiteCredito: undefined,
	      checkVehicle: true,
	      groupers: [],
	      isModalVisible: false,
	      selectedGrouper: null,
	      isAddModalVisible: false,
	      newGrouperName: '',
	      newGrouperDescription: '',
	      isEditModalVisible: false,
	      editGrouperName: '',
	      editGrouperDescription: '',
	      isGrouper: null
	    };
	  },
	
	
	  watch: {
	    newLimit: function newLimit(newVal) {
	      this.contract.limitCredit = newVal;
	    }
	  },
	  created: function created() {
	    var isGrouper = JSON.parse(localStorage.getItem('grouper'));
	    this.isGrouper = isGrouper;
	  },
	
	
	  mounted: function mounted() {
	    this.loadContract();
	    this.loadGroupers();
	  },
	  methods: (_methods = {
	
	    setLimitValue: function setLimitValue(newValue) {
	      this.contract.limitCredit = newValue;
	      this.newLimit = newValue;
	    },
	
	    isPessoaJuridica: function isPessoaJuridica() {
	      return JSON.parse(localStorage.getItem("currentUser")).type == "PESSOA_JURIDICA";
	    },
	    hideModal: function hideModal() {
	      this.showModal = false;
	      this.rechargeAlter = this.recharge;
	    },
	    alterRechargeUnit: function alterRechargeUnit() {
	      var _this = this;
	
	      this.showModal = false;
	      this.contract.rechargeValue = this.rechargeAlter.quantity;
	      this.loading = _contracts2.default.updateContract({
	        contract: this.contract
	      }).then(function (response) {
	        if (response.data.status.code == 0) {
	          _this.recharge = _this.rechargeAlter;
	        }
	      });
	    },
	    calculate: function calculate(qtd) {
	      var _this2 = this;
	
	      this.loadingRecharge = _sales2.default.calculateRechargeRate({
	        quantity: qtd,
	        planId: this.contract.plan.planId
	      }).then(function (result) {
	        _this2.rechargeAlter = result;
	      });
	    },
	    calculateRecharge: function calculateRecharge() {
	      var _this3 = this;
	
	      if (this.planId == 31 || this.planId == 32) {
	        return;
	      }
	
	      this.loading = _sales2.default.calculateRechargeRate({
	        quantity: this.contract.rechargeValue,
	        planId: this.contract.plan.planId
	      }).then(function (result) {
	        _this3.recharge = result;
	        _this3.rechargeAlter = _this3.recharge;
	      });
	    },
	    getImage: function getImage(payment) {
	      return "/static/payment-methods/" + payment.imagePath.split(".")[0] + ".svg";
	    },
	    vencimentos: function vencimentos() {
	      var b = this.contract.billingDay;
	      if (this.contract.billingDay2) b += " - " + this.contract.billingDay2;
	      if (this.contract.billingDay3) b += " - " + this.contract.billingDay3;
	
	      return b;
	    },
	    loadContract: function loadContract() {
	      var _this4 = this;
	
	      this.loading = _contracts2.default.getContractByContractId(this.contractId).then(function (contract) {
	        _this4.contract = contract;
	        _this4.rechargeQtd = _this4.contract.rechargeValue;
	
	        if (_this4.contract.plan.planId != 6 && _this4.contract.plan.planId != 8) {
	          _vehicles2.default.checkVehicleByMoveMaisId(JSON.parse(localStorage.getItem("currentUser")).moveMaisId).then(function (res) {
	            _this4.checkVehicle = res.checkVehicle;
	          });
	        }
	
	        if (_this4.contract.plan.planId == _constantes2.default.PLAN_POS) {
	          _invoice2.default.list(_this4.contractId).then(function (resp) {
	            if (resp && resp.length > 0) _this4.invoice = resp[0];
	          });
	        }
	
	        if (_this4.planHasAutRecharge(_this4.contract.plan.planId)) {
	          _this4.calculateRecharge();
	        }
	      }).catch(function (erro) {
	        _messageDialog2.default.show({
	          title: "Erro",
	          message: erro.data.status.message,
	          type: "OK"
	        });
	      });
	    },
	    showMessageContract: function showMessageContract() {
	      _messageDialog2.default.show({
	        title: "Info",
	        headerClass: "modal-info",
	        message: "Recarga e inclusão de novo veículo somente estarão disponíveis após a ativação do contrato"
	      });
	    },
	    openModalRecharge: function openModalRecharge(contractId) {
	      this.$set(this.modalRecharge, contractId, true);
	    },
	    closeModalRecharge: function closeModalRecharge(contractId, newRecharge) {
	      this.$set(this.modalRecharge, contractId, false);
	      if (newRecharge) {
	        this.contract.rechargeValue = newRecharge;
	        this.calculateRecharge();
	      }
	    }
	  }, (0, _defineProperty3.default)(_methods, "setLimitValue", function setLimitValue(newValue) {
	    this.contract.limitCredit = newValue.replace(/[^0-9]/g, '');
	  }), (0, _defineProperty3.default)(_methods, "getUpdateAlert", function getUpdateAlert() {
	    var Flag = this.contract.lcFlag ? 1 : 0;
	    if (this.planId != 8 && this.planId != 28) {
	      if (this.contract.limitCredit < 1000) {
	        _messageDialog2.default.show({
	          title: "Erro",
	          message: "Não é possivel inserir um valor abaixo de R$ 10 reais. Tente novamente",
	          type: "OK"
	        });
	      } else if (this.contract.limitCredit == 0) {
	        _messageDialog2.default.show({
	          title: "Erro",
	          message: "Valor não permitido!",
	          type: "OK"
	        });
	      } else {
	        this.loading = _contracts2.default.getUpdateValueAlert(Flag, this.contract.limitCredit, this.contract.contractId).then(function (values) {
	          _messageDialog2.default.show({
	            title: "Sucesso",
	            message: "Alteração realizada com sucesso!",
	            type: "OK"
	          });
	        }).catch(function (erro) {
	          _messageDialog2.default.show({
	            title: "Erro",
	            message: erro.data.status.message,
	            type: "OK"
	          });
	        });
	      }
	    } else {
	      var conversion = parseInt(this.contract.limitCredit);
	
	      if (conversion < 1 || conversion > 80) {
	        _messageDialog2.default.show({
	          title: "Error",
	          message: "O percentual deve ser entre 1% a 80%",
	          type: "OK"
	        });
	      } else if (conversion == 0 || conversion == undefined || conversion == null || !conversion) {
	        _messageDialog2.default.show({
	          title: "Error",
	          message: "Valor não permitido!",
	          type: "OK"
	        });
	      } else {
	        this.loading = _contracts2.default.getUpdateValueAlert(Flag, this.contract.limitCredit, this.contract.contractId).then(function (values) {
	          _messageDialog2.default.show({
	            title: "Sucesso",
	            message: "Alteração realizada com sucesso!",
	            type: "OK"
	          });
	        }).catch(function (erro) {
	          _messageDialog2.default.show({
	            title: "Erro",
	            message: erro.data.status.message,
	            type: "OK"
	          });
	        });
	      }
	    }
	  }), (0, _defineProperty3.default)(_methods, "valueFormatted", function valueFormatted() {
	    var _this5 = this;
	
	    var chave = void 0;
	
	    if (this.contract.plan.planId == 21) {
	      chave = "LIMITE_CREDITO_PF";
	    } else {
	      if (this.contract.plan.planId == 31) {
	        chave = "LIMITE_CREDITO_PJ";
	      }
	    }
	
	    _param2.default.getGeneralParameter({
	      key: chave
	    }).then(function (res) {
	      _this5.contract.limitCredit = res.value.replace(/[^0-9]/g, '');
	    });
	
	    this.$nextTick(function () {
	      $('#limitValue').val($('#limitValue').val());
	    });
	    return (0, _number.cents)(this.contract.limitCredit);
	  }), (0, _defineProperty3.default)(_methods, "loadGroupers", function loadGroupers() {
	    var _this6 = this;
	
	    if (this.isGrouper === true) {
	      _contracts2.default.getGroupers(JSON.parse(localStorage.getItem("currentUser")).moveMaisId).then(function (res) {
	        if (res.status.code === 0) {
	          _this6.groupers = res.Agrupadores;
	        }
	      }).catch(function (err) {
	        console.error("Erro ao carregar os agrupadores", err);
	      });
	    }
	  }), (0, _defineProperty3.default)(_methods, "openAddModal", function openAddModal() {
	    this.isAddModalVisible = true;
	  }), (0, _defineProperty3.default)(_methods, "closeAddModal", function closeAddModal() {
	    this.isAddModalVisible = false;
	    this.newGrouperName = '';
	    this.newGrouperDescription = '';
	  }), (0, _defineProperty3.default)(_methods, "addGrouper", function addGrouper() {
	    var _this7 = this;
	
	    if (!this.newGrouperName || !this.newGrouperDescription) {
	      _messageDialog2.default.show({
	        title: "Erro",
	        message: "Por favor, preencha todos os campos.",
	        type: "OK"
	      });
	    }
	
	    _contracts2.default.addGrouper(this.newGrouperName, this.newGrouperDescription, JSON.parse(localStorage.getItem("currentUser")).moveMaisId).then(function (response) {
	      _this7.closeAddModal();
	      _this7.loadGroupers();
	
	      _messageDialog2.default.show({
	
	        title: "Sucesso",
	        headerClass: 'modal-success',
	        message: response.status.message,
	        type: "OK"
	      });
	    }).catch(function (error) {
	      _messageDialog2.default.show({
	        title: "Erro",
	        headerClass: "modal-danger",
	        message: error.data.status.message,
	        type: "OK"
	      });
	    });
	  }), (0, _defineProperty3.default)(_methods, "openEditModal", function openEditModal(name, description, idAgrupadorCliente) {
	    this.editGrouperName = name;
	    this.editGrouperDescription = description;
	    this.selectedGrouper = { idAgrupador: idAgrupadorCliente };
	    this.isEditModalVisible = true;
	  }), (0, _defineProperty3.default)(_methods, "closeEditModal", function closeEditModal() {
	    this.isEditModalVisible = false;
	  }), (0, _defineProperty3.default)(_methods, "submitEdit", function submitEdit() {
	    var _this8 = this;
	
	    _contracts2.default.editGrouper(this.editGrouperName, this.editGrouperDescription, this.selectedGrouper.idAgrupador).then(function (data) {
	      _messageDialog2.default.show({
	        title: "Sucesso",
	        headerClass: 'modal-success',
	        message: data.status.message,
	        type: "OK"
	      });
	      _this8.loadGroupers();
	    }).catch(function (error) {
	      _messageDialog2.default.show({
	        title: "Erro",
	        headerClass: "modal-danger",
	        message: error.data.status.message,
	        type: "OK"
	      });
	    });
	
	    this.closeEditModal();
	  }), (0, _defineProperty3.default)(_methods, "mascaraApenasLetrasEAcentos", function mascaraApenasLetrasEAcentos(value) {
	    var apenasLetrasEAcentos = value.replace(/[^a-zA-ZÀ-ÿ\s]/g, "");
	    var semEspacosDuplos = apenasLetrasEAcentos.replace(/\s+/g, " ");
	
	    return semEspacosDuplos;
	  }), _methods),
	
	  computed: {
	    contractId: function contractId() {
	      return this.$route.params.contractId;
	    },
	    planId: function planId() {
	      return this.contract.plan.planId;
	    },
	    getRechargeAut: function getRechargeAut() {
	      return this.contract.rechargeValue;
	    },
	    currentUser: function currentUser() {
	      return auth.currentUser;
	    }
	  },
	
	  components: {
	    ModalRecharge: _modalChangeAutomaticValue2.default,
	    ModalAutomatic: _modalAutomaticValue2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(48);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objects = __webpack_require__(44);
	
	var obj = _interopRequireWildcard(_objects);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _vehicles = __webpack_require__(29);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	var _vehicles3 = __webpack_require__(118);
	
	var _vehicles4 = _interopRequireDefault(_vehicles3);
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _choosePaymentNewContract = __webpack_require__(1907);
	
	var _choosePaymentNewContract2 = _interopRequireDefault(_choosePaymentNewContract);
	
	var _summaryVehicle = __webpack_require__(1963);
	
	var _summaryVehicle2 = _interopRequireDefault(_summaryVehicle);
	
	var _genericSummary = __webpack_require__(85);
	
	var _genericSummary2 = _interopRequireDefault(_genericSummary);
	
	var _success = __webpack_require__(47);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _error = __webpack_require__(67);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _address = __webpack_require__(84);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _utils = __webpack_require__(34);
	
	var Utils = _interopRequireWildcard(_utils);
	
	var _chooseNewPlan = __webpack_require__(522);
	
	var _chooseNewPlan2 = _interopRequireDefault(_chooseNewPlan);
	
	var _choosePlan = __webpack_require__(160);
	
	var _choosePlan2 = _interopRequireDefault(_choosePlan);
	
	var _chooseRecharge = __webpack_require__(161);
	
	var _chooseRecharge2 = _interopRequireDefault(_chooseRecharge);
	
	var _plans = __webpack_require__(235);
	
	var _plans2 = _interopRequireDefault(_plans);
	
	var _eventBus = __webpack_require__(25);
	
	var _financial = __webpack_require__(54);
	
	var _financial2 = _interopRequireDefault(_financial);
	
	var _b2c = __webpack_require__(162);
	
	var _b2c2 = _interopRequireDefault(_b2c);
	
	var _b2b = __webpack_require__(119);
	
	var _b2b2 = _interopRequireDefault(_b2b);
	
	var _vpo = __webpack_require__(163);
	
	var _vpo2 = _interopRequireDefault(_vpo);
	
	var _payment = __webpack_require__(237);
	
	var _payment2 = _interopRequireDefault(_payment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subs = ["Escolha o plano do novo contrato:", "", "Cadastre os veículos que irão utilizar o plano:", "Informe a forma de pagamento:", ""];
	
	exports.default = {
	  data: function data() {
	    var _ref;
	
	    return _ref = {
	      contract: obj.contract(),
	      contractProp: [],
	      creditCardOptions: [],
	      bankAccountOptions: [],
	      bankBillOption: undefined,
	      newVehicleTax: undefined,
	      vehicles: [],
	
	      planId: undefined,
	      planName: undefined,
	      step: 0,
	      subtitle: subs,
	      msgError: undefined,
	      loading: undefined,
	      success: false,
	      contractPaymentMethodId: undefined,
	      paymentSelected: obj.payment(),
	      code: undefined,
	      boletoUrl: undefined,
	      changeAddress: false,
	      newAddress: _auth2.default.currentUser.address,
	      secureCodeCreditCard: undefined,
	      qtdAllowed: _constantes2.default.qtdAllowed,
	      guaranteeTax: undefined,
	      lead: undefined,
	      newAhesionTax: undefined
	    }, (0, _defineProperty3.default)(_ref, "newVehicleTax", undefined), (0, _defineProperty3.default)(_ref, "showRecharge", true), (0, _defineProperty3.default)(_ref, "minValue", 200000), (0, _defineProperty3.default)(_ref, "total", undefined), (0, _defineProperty3.default)(_ref, "salesOrder", undefined), (0, _defineProperty3.default)(_ref, "address", undefined), (0, _defineProperty3.default)(_ref, "promotionCode", undefined), (0, _defineProperty3.default)(_ref, "shipmentType", undefined), (0, _defineProperty3.default)(_ref, "novoCartao", undefined), (0, _defineProperty3.default)(_ref, "salesResponse", undefined), (0, _defineProperty3.default)(_ref, "rodosol", undefined), (0, _defineProperty3.default)(_ref, "vehicleByContract", undefined), (0, _defineProperty3.default)(_ref, "contractNew", []), (0, _defineProperty3.default)(_ref, "cpm", { error: "Verifique o preenchimento dos campos" }), _ref;
	  },
	
	
	  watch: {
	    step: function step(newVal, oldVal) {
	
	      this.step == 2 ? this.total = this.salesOrder.price : this.total;
	      if (oldVal == 2 && newVal == 1) {
	        this.salesOrder.products.splice(1, Number.MAX_VALUE);
	      }
	    }
	  },
	
	  computed: {
	    user: function user() {
	      return _auth2.default.currentUser;
	    },
	    rodosolCheck: function rodosolCheck() {
	      return this.$route.params.rodosol;
	    },
	    request: function request() {
	      var vm = this;
	      var request = {
	        _interface: window.document.webview ? "MOBILE" : "WEBSITE",
	        account: vm.account,
	        addresses: {
	          address: [vm.address]
	        },
	        contract: vm.contract,
	        listVehicle: {
	          vehicle: vm.vehicles
	        },
	        value: this.total,
	        shipmentType: this.shipmentType
	      };
	      return request;
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    _eventBus.EventBus.$on("migrationPlan", this.choosePlan);
	    _eventBus.EventBus.$on("cleanErrors", function () {
	      _this.msgError = undefined;
	    });
	    _eventBus.EventBus.$on("setPayment", function (payment) {
	
	      _this.doRequest(payment);
	    });
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    var vm = this;
	    this.contractProp = this.$route.params.contract;
	    this.rodosol = this.rodosolCheck;
	    _vehicles2.default.getVehicleByContractIdV2(this.contractProp.contractId).then(function (response) {
	      return _this2.vehicleByContract = response.Vehicles;
	    });
	  },
	
	
	  methods: {
	    planoEscolhidoCallback: function planoEscolhidoCallback(planId) {
	
	      this.nextStep();
	      this.planId = planId;
	    },
	    getPayment: function getPayment() {
	      this.$refs.GenericSummary.getPayment();
	    },
	    choosePlan: function choosePlan(planId, planName) {
	      var _this3 = this;
	
	      this.planId = planId;
	      this.planName = planName;
	      this.contractProp.plan = {
	        planId: planId
	      };
	      this.getPlanInfo().then(function (r) {
	        _this3.$router.push({
	          name: "migration-plan",
	          query: {
	            planId: planId
	          }
	        });
	        _this3.nextStep();
	      });
	    },
	    nextStep: function nextStep() {
	      this.msgError = undefined;
	      $("body").stop().animate({
	        scrollTop: 0
	      }, "500", "swing");
	      switch (this.step) {
	
	        case 0:
	          if (this.rodosol == true) {
	
	            var value = this.vehicleByContract.length * this.newVehicleTax + this.vehicleByContract.length * this.guaranteeTax;
	
	            this.salesOrder = {
	              _interface: "WEBSITE",
	
	              planId: this.planId,
	              status: null,
	              type: "MIGRAÇÃO DE PLANO",
	              salesType: "MIGRATIONPLAN",
	              taxpayerIdSeller: null,
	              promotionCode: this.promotionCode,
	              price: value,
	              logisticsDistribution: null,
	              paymentMethod: null,
	              bankBillUrl: null,
	              transactionPassageId: null,
	              vehicleId: null,
	              contract: this.contractProp.contractId,
	              shipment: null,
	              vehicles: this.vehicleByContract,
	              products: [{
	                productId: 1,
	                productName: "ADESÃO",
	                valueUnit: this.newVehicleTax,
	                quantity: this.vehicleByContract.length,
	                valueTotal: value
	              }]
	            };
	
	            this.step += 1;
	          }
	
	          break;
	
	        case 1:
	          this.salesOrder.products.push({
	            "productId": 2,
	            "productName": "RECARGA",
	            "valueUnit": this.contract.rechargeValue,
	            "quantity": 1,
	            "valueTotal": this.contract.rechargeValue
	          });
	          this.salesOrder.products.push({
	            "productId": 3,
	            "productName": "TAXA DE RECARGA",
	            "valueUnit": this.contract.taxRecharge,
	            "quantity": 1,
	            "valueTotal": this.contract.taxRecharge
	          });
	
	          this.salesOrder.price = this.vehicleByContract.length * this.newVehicleTax + this.vehicleByContract.length * this.guaranteeTax + this.contract.rechargeValue + this.contract.taxRecharge;
	
	
	          this.step += 1;
	          break;
	      }
	    },
	    backStep: function backStep() {
	      this.msgError = undefined;
	      $("body").stop().animate({
	        scrollTop: 0
	      }, "500", "swing");
	      if (this.changeAddress) this.changeAddress = false;else this.step -= 1;
	    },
	    cancelar: function cancelar() {
	      var _this4 = this;
	
	      _messageDialog2.default.show({
	        title: "Cancelar Migração",
	        message: "Deseja cancelar o processo de migração?",
	        type: "OK-CANCEL-ADHESION"
	      }).then(function (res) {
	        if (res == "OK") {
	          _this4.$router.push({
	            name: "plans"
	          });
	        }
	      });
	    },
	    getPlanInfo: function getPlanInfo() {
	      var _this5 = this;
	
	      this.loading = _sales2.default.getPlanById(this.planId).then(function (resp) {
	
	        _this5.newAhesionTax = _this5.newVehicleTax = _.filter(resp.adhesionTax.adhesionTax, function (o) {
	          return o.taxId == _constantes2.default.NEW_VEHICLE_TAXID;
	        })[0].value;
	
	        if (_this5.planId == 33 || _this5.planId == 34) {
	          _this5.guaranteeTax = _.filter(resp.adhesionTax.adhesionTax, function (o) {
	            return o.taxId == _constantes2.default.GUARANTEE_TAXID;
	          })[0].value;
	          _this5.showRecharge = false;
	        } else {
	          _this5.guaranteeTax = 0;
	        }
	
	        _this5.planName = resp.name;
	
	        _.each(resp.paymentMethod.paymentMethod, function (o) {
	          o.value = o.paymentMethodId;
	          o.caption = o.name;
	          if (o.type == "BC") {
	            o.billNumber = o.paymentMethodId;
	            o.priority = 1;
	            _this5.bankBillOption = {
	              bankBill: o,
	              paymentMethodId: o.paymentMethodId,
	              imagePath: o.imagePath,
	              billNumber: o.paymentMethodId,
	              priority: 1
	            };
	          } else if (o.type == "DC") _this5.bankAccountOptions.push(o);else if (o.type == "CC") _this5.creditCardOptions.push(o);
	        });
	      });
	      return this.loading;
	    },
	    doRequest: function doRequest(payment) {
	      var _this6 = this;
	
	      if ((this.planId == 21 || this.planId == 22 || this.planId == 35 || this.planId == 36 || this.salesType != "MIGRATIONPLAN") && payment.contractPaymentMethodId == null) {
	        this.novoCartao = true;
	      }
	
	      if (this.promotionCode == "#SENFF_MM" && payment.paymentMethod.paymentMethodId != 21) {
	        window.setTimeout(function () {
	          _messageDialog2.default.show({
	            title: "Ops!",
	            headerClass: "modal-danger",
	            message: "Este cupom de desconto é valido somente para pagamentos utilizando cartões Senff, por favor remova o cupom para continuar, ou realize o pagamento com um cartão Senff"
	          });
	        }, 1000);
	
	        return;
	      }
	
	      var value = this.vehicleByContract.length * this.newVehicleTax + this.vehicleByContract.length * this.guaranteeTax;
	
	      var req = {
	        contractId: this.contractProp.contractId,
	        contract: this.contractProp,
	        moveMaisId: this.user.moveMaisId,
	        planId: this.contractProp.plan.planId,
	        deliveryAddressId: this.address.addressId,
	        contractPaymentMethod: payment,
	        value: this.salesOrder.price,
	        promotionCode: this.promotionCode,
	        secureCode: this.user.taxIdNumber.substring(0, 4),
	        _interface: window.document.webview ? "MOBILE" : "WEBSITE",
	        vehicles: this.vehicleByContract,
	        adhesionTax: this.newAhesionTax,
	        salesOrder: this.salesOrder,
	        rechargeValue: this.contract.rechargeValue
	
	      };
	
	      var url_atual = window.location.href;
	
	      if (url_atual != "") {
	        var regexp = new RegExp(/\S+pdv\S+/i);
	        var n = regexp.test(url_atual);
	        if (n) {
	          req["promotionCode"] = "GRAALKM29";
	          req["logisticsDistribution"] = "FOB";
	        }
	      }
	
	      if (Utils.isCaminhoParana(this.planId)) {
	        req["promotionCode"] = "CAMINHOSDOPARANA";
	        req["logisticsDistribution"] = "FOB";
	      }
	
	      this.loading = _sales2.default.migrationPlan(req).catch(function (err) {
	        var data = err && err.data || {};
	        var status = data.status || {};
	        _this6.code = status.code;
	        _this6.msgError = status.message || data.message;
	        _this6.salesResponse = undefined;
	        $("body").stop().animate({
	          scrollTop: 0
	        }, "500", "swing");
	      });
	    },
	    onPaymentSelected: function onPaymentSelected(value) {
	      this.paymentSelected = value;
	    },
	    goToStep: function goToStep(value) {
	      this.code = undefined;
	      this.step = value;
	    },
	    saveAddress: function saveAddress() {
	      var _this7 = this;
	
	      this.$refs.addressMailing.$validator.validateAll().then(function (success) {
	        _this7.loading = _account2.default.updateAddress(_this7.newAddress).then(function (r) {
	          _this7.changeAddress = false;
	          var user = _auth2.default.currentUser;
	          user.address = _this7.newAddress;
	          _auth2.default.currentUser = user;
	        }).catch(function (err) {
	          _messageDialog2.default.show({
	            title: "Erro",
	            message: err.data.status.message,
	            headerClass: "modal-danger"
	          });
	        });
	      });
	    },
	    eventChangeAddress: function eventChangeAddress(newValue) {
	      this.changeAddress = newValue;
	    },
	    setTotal: function setTotal(t) {
	      this.total = t;
	    },
	    startRequest: function startRequest() {
	      var _this8 = this;
	
	      this.$refs.GenericSummary.getInfos().then(function (r) {
	
	        _this8.address = r.address;
	        _this8.promotionCode = r.promotionCode;
	        _this8.cpm = _this8.$refs.GenericSummary.getPayment();
	
	        _this8.doRequest(_this8.cpm);
	      });
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	
	    _eventBus.EventBus.$off("setPayment");
	  },
	
	
	  components: {
	    vehicles: _vehicles4.default,
	    ChoosePaymentNewContract: _choosePaymentNewContract2.default,
	    SummaryVehicle: _summaryVehicle2.default,
	    successPage: _success2.default,
	    errorPage: _error2.default,
	    addressComp: _address2.default,
	    chooseNewPlan: _chooseNewPlan2.default,
	    choosePlan: _choosePlan2.default,
	    chooseRecharge: _chooseRecharge2.default,
	    GenericSummary: _genericSummary2.default,
	    b2c: _b2c2.default,
	    b2b: _b2b2.default,
	    vpo: _vpo2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vehicles = __webpack_require__(118);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	var _objects = __webpack_require__(44);
	
	var obj = _interopRequireWildcard(_objects);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _genericSummary = __webpack_require__(85);
	
	var _genericSummary2 = _interopRequireDefault(_genericSummary);
	
	var _success = __webpack_require__(47);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _error = __webpack_require__(67);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _address = __webpack_require__(84);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _utils = __webpack_require__(34);
	
	var Utils = _interopRequireWildcard(_utils);
	
	var _chooseNewPlan = __webpack_require__(522);
	
	var _chooseNewPlan2 = _interopRequireDefault(_chooseNewPlan);
	
	var _choosePlan = __webpack_require__(160);
	
	var _choosePlan2 = _interopRequireDefault(_choosePlan);
	
	var _chooseRecharge = __webpack_require__(161);
	
	var _chooseRecharge2 = _interopRequireDefault(_chooseRecharge);
	
	var _eventBus = __webpack_require__(25);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subs = ['Escolha o plano do novo contrato:', '', 'Cadastre os veículos que irão utilizar o plano:', 'Revise os dados e conclua a adesão:', ''];
	
	exports.default = {
	  data: function data() {
	    return {
	      contract: obj.contract(),
	      vehicles: [],
	      planId: undefined,
	      planName: undefined,
	      step: 0,
	      subtitle: subs,
	      msgError: undefined,
	      loading: undefined,
	      success: false,
	      validacaoFraude: undefined,
	      code: undefined,
	      boletoUrl: undefined,
	      changeAddress: false,
	      newAddress: _auth2.default.currentUser.address,
	      qtdAllowed: _constantes2.default.qtdAllowed,
	      guaranteeTax: undefined,
	      newAhesionTax: undefined,
	      newVehicleTax: undefined,
	      showRecharge: true,
	      minValue: 200000,
	      total: undefined,
	      salesOrder: undefined,
	      address: undefined,
	      promotionCode: undefined,
	      shipmentType: undefined,
	      salesResponse: undefined,
	      rodosol: undefined,
	      isMobile: false,
	      isRechargeSelected: false,
	      coupon: undefined
	    };
	  },
	
	
	  computed: {
	    user: function user() {
	      return _auth2.default.currentUser;
	    },
	    rodosolCheck: function rodosolCheck() {
	      return this.$route.params.rodosol;
	    },
	    contractId: function contractId() {
	      return null;
	    },
	    request: function request() {
	      var vm = this;
	      var request = {
	        "_interface": window.document.webview ? "MOBILE" : "WEBSITE",
	        account: vm.user,
	        addresses: {
	          address: [vm.address]
	        },
	        contract: vm.contract,
	        listVehicle: {
	          vehicle: vm.vehicles
	        },
	        value: this.total,
	        shipmentType: this.shipmentType
	      };
	      return request;
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    _eventBus.EventBus.$on('chooseNewPlan', this.choosePlan);
	    _eventBus.EventBus.$on('cleanErrors', function () {
	      _this.msgError = undefined;
	    });
	  },
	
	
	  mounted: function mounted() {
	    var _this2 = this;
	
	    if (window.innerWidth <= 769) {
	      this.isMobile = true;
	    } else {
	      this.isMobile = false;
	    }
	    window.addEventListener('resize', function () {
	      return window.innerWidth <= 769 ? _this2.isMobile = true : _this2.isMobile = false;
	    });
	    var vm = this;
	
	    this.rodosol = this.rodosolCheck;
	  },
	
	  methods: {
	    handleValorSelecionado: function handleValorSelecionado(valor) {
	
	      if (!valor) {
	        this.isRechargeSelected = false;
	      } else {
	        this.isRechargeSelected = true;
	      }
	    },
	    choosePlan: function choosePlan(planId, planName) {
	      var _this3 = this;
	
	      this.planId = planId;
	      this.planName = planName;
	      this.contract.plan = {
	        planId: planId
	      };
	      this.getPlanInfo().then(function (r) {
	        _this3.$router.push({
	          name: 'new-contract',
	          query: {
	            planId: planId
	          }
	        });
	        _this3.nextStep();
	      });
	    },
	    nextStep: function nextStep() {
	      var _this4 = this;
	
	      this.msgError = undefined;
	      $('body').stop().animate({
	        scrollTop: 0
	      }, '500', 'swing');
	      switch (this.step) {
	        case 0:
	          this.step += 1;
	          this.contract.plan.name = this.planName;
	          break;
	        case 1:
	          var p = void 0;
	          var refPlan = void 0;
	          if (this.planId == 31 || this.planId == 32 || this.planId == 5) {
	            refPlan = this.$refs.chooseRecharge;
	            p = refPlan.validateAll();
	          } else {
	            refPlan = this.$refs.choosePlan;
	            p = refPlan.validateAll();
	          }
	          p.then(function (r) {
	            if (refPlan && refPlan.getCoupon) {
	              var couponValue = refPlan.getCoupon();
	              if (couponValue) {
	                _this4.coupon = couponValue;
	              } else {
	                _this4.coupon = undefined;
	              }
	            }
	            _this4.step += 1;
	          }).catch(function (err) {
	            if (err === 'Cupom inválido') {
	              _this4.msgError = 'Cupom inválido. Verifique o código informado.';
	            } else if (_this4.planId == 2 || _this4.planId == 3) {
	              _this4.msgError = 'Infome um CPF ou CNPJ válido para continuar';
	            } else {
	              _this4.msgError = 'Por favor verifique o valor de recarga';
	            }
	          });
	          break;
	        case 2:
	          if (this.vehicles.length > 0) {
	            var value = this.vehicles.length * this.newVehicleTax + this.vehicles.length * this.guaranteeTax;
	
	            this.salesOrder = {
	              "_interface": "WEBSITE",
	              "planId": this.planId,
	              "status": null,
	              "type": "ADESÃO VEÍCULO ADICIONAL",
	              "salesType": "ADHESIOACONTRACTADDITIONAL",
	              "taxpayerIdSeller": null,
	              "promotionCode": this.promotionCode,
	              "price": value,
	              "logisticsDistribution": null,
	              "bankBillUrl": null,
	              "transactionPassageId": null,
	              "vehicleId": null,
	              "shipment": null,
	              "vehicles": this.vehicles,
	              "products": [{
	                "productId": 4,
	                "productName": "ADESÃO VEÍCULO ADICIONAL",
	                "valueUnit": this.newVehicleTax,
	                "quantity": this.vehicles.length,
	                "valueTotal": value
	              }]
	            };
	
	            if (true) {
	              this.salesOrder.products.push({
	                "productId": 2,
	                "productName": "RECARGA",
	                "valueUnit": this.contract.rechargeValue,
	                "quantity": 1,
	                "valueTotal": this.contract.rechargeValue
	              });
	              this.salesOrder.products.push({
	                "productId": 3,
	                "productName": "TAXA DE RECARGA",
	                "valueUnit": this.contract.tax,
	                "quantity": 1,
	                "valueTotal": this.contract.tax
	              });
	
	              this.salesOrder.price += this.contract.tax + this.contract.rechargeValue;
	            }
	
	            this.step += 1;
	          } else this.msgError = 'Adicione ao menos um veículo para continuar';
	          break;
	
	      }
	    },
	    backStep: function backStep() {
	      this.msgError = undefined;
	      $('body').stop().animate({
	        scrollTop: 0
	      }, '500', 'swing');
	      if (this.changeAddress) this.changeAddress = false;else {
	        if (this.step == 2) {
	          this.coupon = undefined;
	        }
	        this.step -= 1;
	      }
	    },
	    cancelar: function cancelar() {
	      var _this5 = this;
	
	      _messageDialog2.default.show({
	        title: 'Cancelar Novo Plano',
	        message: 'Deseja cancelar a adesão de um novo plano?',
	        type: 'OK-CANCEL-ADHESION'
	      }).then(function (res) {
	        if (res == 'OK') {
	          _this5.$router.push({
	            name: 'plans'
	          });
	        }
	      });
	    },
	    getPlanInfo: function getPlanInfo() {
	      var _this6 = this;
	
	      this.loading = _sales2.default.getPlanById(this.planId).then(function (resp) {
	        _this6.newAhesionTax = _this6.newVehicleTax = _.filter(resp.adhesionTax.adhesionTax, function (o) {
	          return o.taxId == _constantes2.default.NEW_VEHICLE_TAXID;
	        })[0].value;
	
	        if (_this6.planId == 33 || _this6.planId == 34) {
	          _this6.guaranteeTax = _.filter(resp.adhesionTax.adhesionTax, function (o) {
	            return o.taxId == _constantes2.default.GUARANTEE_TAXID;
	          })[0].value;
	          _this6.showRecharge = false;
	        } else {
	          _this6.guaranteeTax = 0;
	        }
	
	        _this6.planName = resp.name;
	      });
	      return this.loading;
	    },
	    submitContractAdditional: function submitContractAdditional() {
	      var _this7 = this;
	
	      var value = this.vehicles.length * this.newVehicleTax + this.vehicles.length * this.guaranteeTax;
	
	      var req = {
	        deliveryAddressId: this.address.addressId,
	        value: value,
	        promotionCode: this.promotionCode,
	        secureCode: this.user.taxIdNumber.substring(0, 4),
	        _interface: window.document.webview ? "MOBILE" : "WEBSITE",
	        vehicles: this.vehicles,
	        shipmentType: this.shipmentType
	      };
	
	      if (this.coupon) {
	        req.coupon = this.coupon;
	      }
	      req.contract = _.cloneDeep(this.contract);
	
	      var url_atual = window.location.href;
	      if (url_atual !== "") {
	        var regexp = new RegExp(/\S+pdv\S+/i);
	        if (regexp.test(url_atual)) {
	          req.promotionCode = "GRAALKM29";
	          req.logisticsDistribution = "FOB";
	        }
	      }
	
	      if (Utils.isCaminhoParana(this.planId)) {
	        req.promotionCode = "CAMINHOSDOPARANA";
	        req.logisticsDistribution = "FOB";
	      }
	
	      req.contract.lcFlag = req.contract.lcFlag ? 1 : 0;
	
	      if (req.shipmentType == 3) {
	        req.logisticsDistribution = "FOB";
	      }
	
	      this.loading = _sales2.default.adhesionContractAdditional(req).catch(function (err) {
	        var data = err && err.data ? err.data : {};
	        var status = data.status || {};
	        _this7.code = status.code;
	        _this7.msgError = status.message || data.message || "Não foi possível concluir a solicitação.";
	        _this7.salesResponse = undefined;
	        $("body").stop().animate({ scrollTop: 0 }, "500", "swing");
	      });
	    },
	    goToStep: function goToStep(value) {
	      this.code = undefined;
	      this.step = value;
	    },
	    saveAddress: function saveAddress() {
	      var _this8 = this;
	
	      this.$refs.addressMailing.$validator.validateAll().then(function (success) {
	        _this8.loading = _account2.default.updateAddress(_this8.newAddress).then(function (r) {
	          _this8.changeAddress = false;
	          var user = _auth2.default.currentUser;
	          user.address = _this8.newAddress;
	          _auth2.default.currentUser = user;
	        }).catch(function (err) {
	          _messageDialog2.default.show({
	            title: "Erro",
	            message: err.data.status.message,
	            headerClass: "modal-danger"
	          });
	        });
	      });
	    },
	    startRequest: function startRequest() {
	      var _this9 = this;
	
	      this.$refs.GenericSummary.getInfos().then(function (r) {
	        _this9.address = r.address;
	        _this9.promotionCode = r.promotionCode;
	        _this9.shipmentType = r.shipmentType;
	        _this9.submitContractAdditional();
	      }).catch(function () {});
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	
	    _eventBus.EventBus.$off("cleanErrors");
	  },
	
	
	  components: {
	    vehicles: _vehicles2.default,
	    successPage: _success2.default,
	    errorPage: _error2.default,
	    addressComp: _address2.default,
	    chooseNewPlan: _chooseNewPlan2.default,
	    choosePlan: _choosePlan2.default,
	    chooseRecharge: _chooseRecharge2.default,
	    GenericSummary: _genericSummary2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      dataTransfer: undefined,
	      loading: undefined,
	      summaryVP: {}
	    };
	  },
	
	  computed: {
	    getDateTransfer: function getDateTransfer() {
	      return (0, _moment2.default)().format('[Transferência efetuada às] H:mm [em] DD/MM/YYYY');
	    },
	
	    contractId: function contractId() {
	
	      return this.$route.params.contractId;
	    }
	  },
	  methods: {
	    print: function print() {
	      var prtContent = document.getElementById("comprovante");
	      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	      WinPrint.document.write(prtContent.innerHTML);
	      WinPrint.document.close();
	      WinPrint.focus();
	      WinPrint.print();
	      WinPrint.close();
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    $('[data-toggle="tooltip"]').tooltip();
	    this.loading = _sales2.default.getTransferData(this.$route.params.orderId).then(function (resp) {
	
	      _this.dataTransfer = resp.response;
	    }).catch(function (err) {});
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _transferCreditValue = __webpack_require__(1912);
	
	var _transferCreditValue2 = _interopRequireDefault(_transferCreditValue);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _param = __webpack_require__(68);
	
	var _param2 = _interopRequireDefault(_param);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _number = __webpack_require__(24);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      searchCpf: undefined,
	      searchContract: undefined,
	      status: '',
	      userReceive: undefined,
	      messageError: undefined,
	      taxIdNumber: undefined,
	      step: 1,
	      transfValue: undefined,
	      loading: undefined,
	      contract: undefined,
	      contractIdCred: undefined,
	      fee: undefined,
	      feeValue: undefined,
	      total: undefined,
	      password: undefined,
	      taxIdSender: undefined
	    };
	  },
	
	  computed: {
	    formattedValue: function formattedValue() {
	      return (0, _number.centss)(this.transfValue);
	    },
	    formattedFeeValue: function formattedFeeValue() {
	      return (0, _number.centss)(this.feeValue);
	    },
	    formattedTotal: function formattedTotal() {
	      return (0, _number.centss)(this.total);
	    },
	    checkValue: function checkValue() {
	      return !this.transfValue || this.transfValue === 0;
	    },
	    contratoOrigem: function contratoOrigem() {
	      return this.$route.params.contractId;
	    }
	  },
	  methods: {
	    nextStep: function nextStep() {
	      switch (this.step) {
	        case 1:
	          if (!this.userReceive) {
	            this.messageError = 'Informe o CPF';
	            this.status = 'ERROR';
	            return;
	          }
	          this.step += 1;
	          break;
	        case 2:
	          if (!this.transfValue || this.transfValue <= 0) {
	            this.messageError = 'Informe o valor a ser creditado';
	            this.status = 'ERROR';
	            return;
	          }
	          this.step += 1;
	          break;
	        default:
	          this.step += 1;
	      }
	    },
	    calculate: function calculate() {
	      this.fee = 2;
	      this.feeValue = this.transfValue * (this.fee / 100);
	      this.total = this.transfValue + this.feeValue;
	    },
	    filter: function filter() {
	      var _this = this;
	
	      var vm = this;
	      this.status = 'EMPTY';
	      this.transfValue = 0;
	
	      if (this.searchContract == this.$route.params.contractId) {
	        this.status = 'ERROR';
	        this.messageError = 'O contrato do favorecido não pode ser o mesmo do transferente.';
	        return;
	      }
	
	      this.$validator.validateAll().then(function (r) {
	
	        _this.loading = _account2.default.getContractByTaxPayerIdSite(_this.searchCpf.replace(/[^0-9]/g, ""), _this.searchContract.replace(/[^0-9]/g, "")).then(function (response) {
	          _this.taxIdNumber = _this.searchCpf.replace(/[^0-9]/g, "");
	          _this.contractIdCred = _this.searchContract.replace(/[^0-9]/g, "");
	          _this.userReceive = response;
	          _this.status = 'FOUND';
	        }).catch(function (error) {
	          _this.messageError = error.data.status.message;
	          _this.status = 'ERROR';
	        });
	      }).catch(function (err) {
	        _this.status = 'ERROR';
	        _this.messageError = 'Dados inválidos';
	      });
	    },
	    transfer: function transfer() {
	      var _this2 = this;
	
	      this.status = 'FOUND';
	      if (!this.password) {
	        this.messageError = "Informe sua senha para realizar a transferência!";
	        this.status = 'ERROR';
	        return;
	      }
	
	      var prom = _auth2.default.checkUserPasswordTransfer(this.taxIdSender, this.password).then(function (auth) {
	        if (auth.authorized) {
	          var transfRequest = {
	            contractIdDeb: _this2.contratoOrigem,
	            contractIdCred: _this2.userReceive.contratos[0].value,
	            transferValue: _this2.transfValue
	          };
	
	          return _sales2.default.transferCredit(transfRequest).then(function (res) {
	
	            if (res.response.statusProcess) {
	              _this2.$router.push({
	                name: 'transfer-credit-receipt',
	                params: {
	                  orderId: res.response.orderId
	                }
	              });
	            } else {
	              _this2.messageError = res.response.status;
	              _this2.status = 'ERROR';
	            }
	          }).catch(function (error) {
	
	            _this2.messageError = error.data.status.message;
	            _this2.status = 'ERROR';
	          });
	        } else {
	          _this2.messageError = "Senha inválida!";
	          _this2.status = 'ERROR';
	        }
	      }).catch(function (error) {
	
	        _this2.messageError = error.data.status.message;
	        _this2.status = 'ERROR';
	      });
	
	      this.$store.dispatch('loading', prom);
	    }
	  },
	  watch: {
	    transfValue: function transfValue(newValue) {
	      this.transfValue = newValue;
	      this.feeValue = this.transfValue * (this.fee / 100);
	      this.total = this.transfValue + this.feeValue;
	    }
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.loading = _contracts2.default.getContractByContractId(this.$route.params.contractId).then(function (response) {
	      _this3.contract = response;
	    });
	
	    _param2.default.getGeneralParameter({
	      key: "TAXA_TRANSFERENCIA"
	    }).then(function (res) {
	      _this3.fee = parseInt(res.value);
	    });
	
	    this.taxIdSender = _auth2.default.getTaxId();
	    this.taxIdSender = this.taxIdSender ? this.taxIdSender.replace(/[.\-\/]/g, "").toUpperCase() : _auth2.default.currentUser.taxIdNumber;
	  },
	
	  components: {
	    TransferCreditValue: _transferCreditValue2.default
	  }
	
	};

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _invoice = __webpack_require__(170);
	
	var _invoice2 = _interopRequireDefault(_invoice);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      state: undefined,
	      invoices: undefined,
	      loading: false,
	      messageError: undefined,
	      visibleMenuId: null,
	      nfeLinks: {},
	      nfeChecked: {},
	      nfeStatus: {},
	      toastNfeVisible: false,
	      toastNfeTimeout: null
	    };
	  },
	
	  computed: {
	    contractId: function contractId() {
	      return this.$route.params.contractId;
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.state = "LOADING";
	    this.loading = _invoice2.default.list(this.contractId).then(function (resp) {
	      _this.invoices = resp;
	      _this.state = "LOADED";
	      if (_this.invoices.length === 0) {
	        _this.messageError = "Nenhuma fatura encontrada para o contrato em questão.";
	      }
	    }).catch(function (err) {
	      _this.messageError = err.data && err.data.status && err.data.status.message || "Desculpe-nos ocorreu um problema, por favor tente novamente";
	    });
	  },
	
	  methods: {
	    toggleMenu: function toggleMenu(invoiceId) {
	      var _this2 = this;
	
	      this.visibleMenuId = this.visibleMenuId === invoiceId ? null : invoiceId;
	      if (this.visibleMenuId && this.nfeChecked[invoiceId] === undefined) {
	        this.getLinkNFe(invoiceId).then(function (data) {
	          var url = null;
	          var found = false;
	          var code = 0;
	          var message = "";
	          if (data && data.status && typeof data.status.code !== "undefined") {
	            code = data.status.code;
	            message = data.status.message;
	          }
	          if (data && data.return && Array.isArray(data.return) && data.return.length > 0) {
	            found = true;
	            url = data.return[0].url || null;
	          }
	          _this2.$set(_this2.nfeLinks, invoiceId, url);
	          _this2.$set(_this2.nfeChecked, invoiceId, found);
	          _this2.$set(_this2.nfeStatus, invoiceId, { code: code, message: message });
	        }).catch(function (err) {
	          var code = -1;
	          var message = "Erro desconhecido";
	          if (err.response && err.response.data && err.response.data.status) {
	            code = err.response.data.status.code;
	            message = err.response.data.status.message;
	          }
	          if (code === 9002) {
	            _this2.$set(_this2.nfeLinks, invoiceId, null);
	            _this2.$set(_this2.nfeChecked, invoiceId, true);
	          } else {
	            _this2.$set(_this2.nfeLinks, invoiceId, null);
	            _this2.$set(_this2.nfeChecked, invoiceId, false);
	          }
	          _this2.$set(_this2.nfeStatus, invoiceId, { code: code, message: message });
	        });
	      }
	    },
	    showNfeToast: function showNfeToast() {
	      var _this3 = this;
	
	      if (this.toastNfeTimeout) {
	        clearTimeout(this.toastNfeTimeout);
	      }
	      this.toastNfeVisible = true;
	      this.toastNfeTimeout = setTimeout(function () {
	        _this3.toastNfeVisible = false;
	        _this3.toastNfeTimeout = null;
	      }, 3000);
	    },
	    getPdf: function getPdf(id, planId) {
	      return planId !== 28 ? "/api/v2/invoice/pdf/" + id : "/api/v1/invoice/pdf/" + id;
	    },
	    getXlsx: function getXlsx(id, planId) {
	      return planId !== 28 ? "/api/v2/invoice/xlsx/" + id : "/api/v1/invoice/xlsx/" + id;
	    },
	    getTxt: function getTxt(id) {
	      return "/api/v2/invoice/txt/" + id;
	    },
	    getLinkNFe: function getLinkNFe(invoiceId) {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var res;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _axios2.default.get("/v2/invoice/linkNFe/" + invoiceId);
	
	              case 2:
	                res = _context.sent;
	                return _context.abrupt("return", res.data);
	
	              case 4:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, _this4);
	      }))();
	    },
	    buildBoletoUrl: function buildBoletoUrl(inv) {
	      return inv.boleto;
	    }
	  }
	};

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _accordion = __webpack_require__(513);
	
	var _accordion2 = _interopRequireDefault(_accordion);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      state: undefined,
	      loading: undefined,
	      notifications: undefined
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.state = 'LOADING';
	    this.loading = _account2.default.getNotification().then(function (resp) {
	      _this.notifications = resp;
	    });
	  },
	
	  components: {
	    Accordion: _accordion2.default
	  }
	
	};

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      user: _auth2.default.currentUser,
	      address: undefined,
	      errorCep: undefined,
	      loadingAddress: _promise2.default.resolve(true),
	      addressIdTemp: undefined
	    };
	  },
	
	  computed: {},
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$forceUpdate();
	    this.loadingAddress = _account2.default.getAddressMailing(this.user.moveMaisId).then(function (resp) {
	
	      _this.address = resp;
	      _this.addressIdTemp = _this.address.addressId;
	    });
	  },
	
	  methods: {
	    updateAddress: function updateAddress() {
	      var _this2 = this;
	
	      return this.$validator.validateAll().then(function (success) {
	        _this2.address.moveMaisId = _this2.user.moveMaisId;
	        if (success) return _account2.default.updateAddress(_this2.address).then(function (response) {});
	      });
	    },
	    queryAddress: function queryAddress() {
	      var _this3 = this;
	
	      this.errorCep = undefined;
	      this.loadingAddress = _account2.default.queryAddress(this.address.zipCode).then(function (resp) {
	
	        _this3.address = resp;
	        _this3.address.type = 'MAILING';
	        _this3.address.addressId = _this3.addressIdTemp;
	        _this3.$nextTick(function () {
	          this.$validator.validateAll();
	        });
	      }).catch(function (err) {
	        _this3.errorCep = err.data.status.message;
	        _this3.$validator.validateAll();
	      });
	    },
	    queryAddressTyping: function queryAddressTyping() {
	      if (this.address.zipCode.length < 8) return;
	      this.queryAddress();
	    }
	  }
	};

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _user = __webpack_require__(1921);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _address = __webpack_require__(1919);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _faInterno = __webpack_require__(526);
	
	var _faInterno2 = _interopRequireDefault(_faInterno);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _lodash = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: undefined,
	      show2fa: false
	    };
	  },
	
	
	  methods: {
	    start: function start() {
	      var vm = this;
	      this.loading = vm.$refs.userComponent.$validator.validateAll().then(function (res) {
	        return vm.$refs.addressComponent.$validator.validateAll().then(function (res2) {
	          _auth2.default.tokenGenerateResend(_auth2.default.currentUser.taxIdNumber, 'UPDATE_ACCOUNT').then(function (r) {
	            vm.show2fa = true;
	          }).catch(function (err) {
	            _messageDialog2.default.show({ title: 'Erro', message: err.data.status.message, headerClass: 'modal-danger' });
	          });
	        });
	      });
	    },
	    save: function save() {
	      var vm = this;
	      vm.show2fa = false;
	
	      var userObject = vm.$refs.userComponent.user;
	
	      delete userObject.accountAuthentication;
	
	
	      this.loading = _account2.default.updateUser(userObject).then(function (res) {
	
	        _account2.default.updateAddress(vm.$refs.addressComponent._data.address).then(function (res) {
	
	          _messageDialog2.default.show({ title: 'Sucesso', message: 'Seus dados foram salvos com sucesso.' });
	        });
	      });
	    }
	  },
	  components: {
	    userData: _user2.default, addressData: _address2.default, TwoFaInterno: _faInterno2.default
	  }
	};

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _string = __webpack_require__(35);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      user: _auth2.default._currentUser,
	      telObj: undefined,
	      celObj: undefined,
	      allowSMS: false,
	      notificationLimit: undefined,
	      loadingUser: _promise2.default.resolve(true),
	      loading: undefined,
	      semTel: undefined,
	      isCampoDesabilitado: undefined,
	      isTelDisable: false,
	      is2faValid: undefined
	    };
	  },
	
	  computed: {
	    cel: {
	      get: function get() {
	        return (0, _string.phone)(this.user.dddCellphone + this.user.nroCellphone);
	      },
	      set: function set(newValue) {
	        this.$nextTick(function () {
	          $('#telefone').val($('#telefone').val());
	        });
	        var t = newValue.replace(/[^0-9]/g, '');
	        if (t.length > 11) {
	          this.$validator.validateAll();
	          return false;
	        }
	        this.user.dddCellphone = t.substring(0, 2);
	        this.user.nroCellphone = t.substring(2, 11);
	      }
	    },
	    tel: {
	      get: function get() {
	        return (0, _string.phone)(this.user.dddPhone + this.user.nroPhone);
	      },
	      set: function set(newValue) {
	        this.$nextTick(function () {
	          $('#telefone').val($('#telefone').val());
	        });
	        var t = newValue.replace(/[^0-9]/g, '');
	        if (t.length > 11) {
	          this.$validator.validateAll();
	          return false;
	        }
	        this.user.dddPhone = t.substring(0, 2);
	        this.user.nroPhone = t.substring(2, 11);
	      }
	    }
	  },
	  created: function created() {},
	  mounted: function mounted() {
	    var _this = this;
	
	    if (this.user.flag2FA == "N") {
	      this.is2faValid = false;
	    } else {
	      this.is2faValid = true;
	    }
	
	    if (this.is2faValid) {
	      this.isCampoDesabilitado = true;
	    } else {
	      this.isCampoDesabilitado = false;
	    }
	    _account2.default.getNotification().then(function (res) {
	      _this.notificationLimit = _.find(res, function (obj) {
	        return obj.userNotificationId == 7;
	      });
	      if (_this.notificationLimit) {
	        _this.allowSMS = _this.notificationLimit.sms;
	      } else {
	        _this.allowSMS = false;
	      }
	    });
	  },
	
	
	  methods: {
	    correctCursor: function correctCursor(a) {
	      if (!window.document.mobile) return;
	
	      setTimeout(function () {
	        $(a.target).val($(a.target).val());
	      }, 80);
	    },
	    getTelFormated: function getTelFormated(obj) {
	      return (0, _string.phone)(obj.ddd + obj.numberPhone);
	    },
	    setTelFormated: function setTelFormated(value, obj) {
	      var t = value.replace(/[^0-9]/g, '');
	      if (t.length > 11) {
	        this.$validator.validateAll();
	        return false;
	      }
	      obj.ddd = t.substring(0, 2);
	      obj.numberPhone = t.substring(2, 11);
	    },
	    updateUser: function updateUser() {
	      var _this2 = this;
	
	      return this.$validator.validateAll().then(function (success) {
	        var aux = _.cloneDeep(_this2.user);
	
	        delete aux.accountAuthentication;
	        delete aux.company;
	        delete aux.person;
	        return _this2.loading = _account2.default.updateUser(aux).then(function (resp) {
	          _auth2.default.updateLocalStorage();
	        }).then(function (res) {
	          _this2.notificationLimit.sms = _this2.allowSMS;
	          var req = {
	            notifications: {
	              notification: [_this2.notificationLimit]
	            }
	          };
	
	          return _account2.default.upSertNotification(req);
	        }).catch(function (err) {
	          return _messageDialog2.default.show({ title: 'Erro', message: err.data.status.message, headerClass: 'modal-danger' });
	        });
	      });
	    },
	    changeEmail: function changeEmail() {
	      var _this3 = this;
	
	      var taxIdNumber = this.user.taxIdNumber;
	      this.loadingUser = _account2.default.requestChangeUserEmail(taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase()).then(function (success) {
	        _this3.$router.push({ name: 'user-contacts-change', params: { type: 'UPDATE_USER_EMAIL' } });
	      }).catch(function (err) {
	        return _messageDialog2.default.show({ title: 'Erro', message: err.data.status.message, headerClass: 'modal-danger' });
	      });
	    },
	    changePhone: function changePhone() {
	      var _this4 = this;
	
	      var taxIdNumber = this.user.taxIdNumber;
	      this.loadingUser = _account2.default.requestChangeUserPhone(taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase()).then(function (success) {
	        _this4.$router.push({ name: 'user-contacts-change', params: { type: 'UPDATE_USER_PHONE' } });
	      }).catch(function (err) {
	        return _messageDialog2.default.show({ title: 'Erro', message: err.data.status.message, headerClass: 'modal-danger' });
	      });
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(99);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _number = __webpack_require__(24);
	
	var _btnRechargeValue = __webpack_require__(1922);
	
	var _btnRechargeValue2 = _interopRequireDefault(_btnRechargeValue);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _valorRecargaValido = __webpack_require__(243);
	
	var _valorRecargaValido2 = _interopRequireDefault(_valorRecargaValido);
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _vehicles = __webpack_require__(29);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      user: _auth2.default.currentUser,
	      rechargeValue: undefined,
	      rate: undefined,
	      loadingRates: _promise2.default.resolve(true),
	      loading: _promise2.default.resolve(true),
	      source: undefined,
	      rechargeUnit: undefined,
	      unit: undefined,
	      numeroDeVeiculos: undefined,
	      valoresRoadCard: [],
	      menorValorDeRecarga: undefined,
	      errorMessage: ""
	
	    };
	  },
	
	  computed: {
	    contractId: function contractId() {
	      return this.$route.params.contractId;
	    },
	    planId: function planId() {
	      return this.$route.params.planId;
	    },
	    valueFormatted: function valueFormatted() {
	      this.$nextTick(function () {
	        $('#valueTotal').val($('#valueTotal').val());
	      });
	      return (0, _number.cents)(this.rechargeValue).replace('R$', '');
	    },
	    total: function total() {
	      if (this.rate) return (0, _number.cents)(this.rate.valueTotal + this.rate.taxTotal);else return (0, _number.cents)(0);
	    },
	    tax: function tax() {
	      if (this.rate) return (0, _number.cents)(this.rate.taxTotal);else return (0, _number.cents)(0);
	    }
	  },
	  created: function created() {
	    this.menorValorDeRecarga = undefined;
	    this.source = _axios2.default.CancelToken.source();
	
	    if ([_constantes2.default.PLAN_MAN_ECONOMICO, _constantes2.default.PLAN_AUT_ECONOMICO].indexOf(this.planId) !== -1) {
	      this.unit = _constantes2.default.RECHARGE_UNIT_ECONOMICO;
	    } else if (this.planId == _constantes2.default.PLAN_AUT_PJ || this.planId == _constantes2.default.PLAN_MAN_PJ || this.planId == _constantes2.default.PLAN_PRE_SEM_TAXA) {
	      this.unit = _constantes2.default.RECHARGE_UNIT_PJ;
	    } else {
	      this.unit = _constantes2.default.RECHARGE_UNIT;
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _vehicles2.default.getVehicleByContractIdContagem(this.contractId).then(function (res) {
	      _this.numeroDeVeiculos = res.length;
	    });
	  },
	
	  methods: {
	
	    incrementTotal: function incrementTotal(val) {
	      val = parseInt(val);
	      var total = parseInt(this.rechargeValue);
	      if (this.rechargeValue) this.rechargeValue = total + val;else this.rechargeValue = val;
	
	      this.calculateRecharge();
	      this.$nextTick(function () {
	        this.$validator.validateAll();
	      });
	    },
	    setTotal: function setTotal(newValue) {
	
	      this.rechargeValue = parseInt(newValue.replace(/[^0-9]/g, ''));
	
	      this.calculateRecharge();
	    },
	    getQuantity: function getQuantity() {
	      if (!this.rechargeValue) return 0;
	
	      var val = this.rechargeValue;
	      val = parseInt(val);
	      return val / this.unit;
	    },
	    calculateRecharge: function calculateRecharge() {
	      var _this2 = this;
	
	      this.errorMessage = "";
	      if (!_valorRecargaValido2.default.validate(this.rechargeValue, [this.unit])) {
	        this.rate = undefined;
	        return false;
	      }
	      this.source.cancel('cancelada');
	      this.source = _axios2.default.CancelToken.source();
	      this.waiting = true;
	
	      if (this.planId == 70 || this.planId == 71) {
	        if (this.rechargeValue >= this.menorValorDeRecarga) {
	          this.errorMessage = "";
	          var p = _sales2.default.calculateRechargeRate({ cancelToken: this.source.token, value: this.rechargeValue, planId: this.planId, contractId: this.contractId }).then(function (resp) {
	            _this2.rate = resp;
	            _this2.waiting = false;
	          }).catch(function (err) {
	            _this2.waiting = false;
	            _this2.rate = undefined;
	          });
	          this.$store.dispatch('loading', p);
	        } else {
	          this.errorMessage = "Valor informado é menor que o mínimo esperado.";
	        }
	      } else {
	        this.errorMessage = "";
	        var _p = _sales2.default.calculateRechargeRate({ cancelToken: this.source.token, value: this.rechargeValue, planId: this.planId, contractId: this.contractId }).then(function (resp) {
	          _this2.rate = resp;
	          _this2.waiting = false;
	        }).catch(function (err) {
	          _this2.waiting = false;
	          _this2.rate = undefined;
	        });
	        this.$store.dispatch('loading', _p);
	      }
	    },
	    valoresRecebidos: function valoresRecebidos(_valoresRecebidos) {
	      this.valoresRoadCard.push(_valoresRecebidos);
	
	      if (this.valoresRoadCard.length === 4) {
	        var menorValor = Math.min.apply(Math, (0, _toConsumableArray3.default)(this.valoresRoadCard));
	        this.menorValorDeRecarga = menorValor;
	      }
	    },
	    getSalesOrder: function getSalesOrder() {
	      var salesOrder = {
	        account: { moveMaisId: this.moveMaisId },
	        type: "RECHARGE",
	        salesType: "RECHARGE",
	        _interface: window.document.webview ? "MOBILE" : "WEBSITE",
	        contract: this.contractId,
	        price: this.rechargeValue + this.rate.taxTotal,
	        value: this.rechargeValue,
	        products: [{
	          productId: 2,
	          productName: "RECARGA",
	          quantity: 1,
	          valueTotal: this.rechargeValue,
	          valueUnit: this.rechargeValue
	        }, {
	          productId: 3,
	          productName: "TAXA DE RECARGA",
	          quantity: 1,
	          valueTotal: this.rate.taxTotal,
	          valueUnit: this.rate.taxTotal
	        }]
	      };
	
	      return _promise2.default.resolve(salesOrder);
	    }
	  },
	
	  components: {
	    btnRechargeValue: _btnRechargeValue2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _number = __webpack_require__(24);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _recargaMinima = __webpack_require__(98);
	
	var _recargaMinima2 = _interopRequireDefault(_recargaMinima);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      user: _auth2.default.currentUser,
	      rechargeValue: undefined,
	      rate: 'N/A',
	      loadingRates: _promise2.default.resolve(true),
	      loading: _promise2.default.resolve(true),
	      source: undefined,
	      rechargeUnit: undefined,
	      minValue: 200000,
	      qtdFix: 4,
	      rechargesData: {},
	      unit: -1,
	      msgError: undefined
	
	    };
	  },
	
	  computed: {
	    contractId: function contractId() {
	      return this.$route.params.contractId;
	    },
	    contract: function contract() {
	      return this.$store.getters.getContractById(this.contractId);
	    },
	
	    planId: function planId() {
	      return this.$route.params.planId;
	    },
	    valueFormatted: function valueFormatted() {
	      this.$nextTick(function () {
	        $('#valueTotal').val($('#valueTotal').val());
	      });
	      return (0, _number.cents)(this.rechargeValue).replace('R$', '');
	    },
	    total: function total() {
	      if (this.rate) return (0, _number.cents)(this.rate.valueTotal + this.rate.taxTotal);else return (0, _number.cents)(0);
	    },
	    tax: function tax() {
	      if (this.rate) return (0, _number.cents)(this.rate.taxTotal);else return (0, _number.cents)(0);
	    }
	  },
	  created: function created() {
	    this.source = _axios2.default.CancelToken.source();
	  },
	
	  watch: {
	    unit: function unit(newValue) {
	      this.msgError = undefined;
	      if (newValue == -1) this.$nextTick(function () {
	        $('#valueTotal').focus();
	      });
	    },
	    rechargeValue: function rechargeValue(newValue) {
	      var rechargeValueNumber = Number(newValue);
	      if (rechargeValueNumber % 50 !== 0) {
	        this.msgError = "O valor deve ser múltiplo de 50.";
	      } else {
	        this.msgError = undefined;
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.rechargesData = this.getFixesRecharges(this.planId, this.minValue, true);
	    this.unit = this.rechargesData[0].value;
	  },
	
	  methods: {
	    incrementTotal: function incrementTotal(val) {
	      val = parseInt(val);
	      var total = parseInt(this.rechargeValue);
	      if (this.rechargeValue) this.rechargeValue = total + val;else this.rechargeValue = val;
	
	      this.calculateRecharge();
	      this.$nextTick(function () {
	        this.$validator.validateAll();
	      });
	    },
	    setTotal: function setTotal(newValue) {
	      this.msgError = undefined;
	      this.rechargeValue = newValue.replace(/[^0-9]/g, '');
	      this.calculateRecharge();
	    },
	    getQuantity: function getQuantity() {
	      if (!this.rechargeValue) return 0;
	
	      var val = this.rechargeValue;
	      val = parseInt(val);
	      return val / this.unit;
	    },
	    calculateRecharge: function calculateRecharge() {
	      var _this = this;
	
	      if (!_recargaMinima2.default.validate(this.rechargeValue, [this.minValue])) {
	        this.rate = 'N/A';
	        return false;
	      }
	      this.source.cancel('cancelada');
	      this.source = _axios2.default.CancelToken.source();
	      this.waiting = true;
	      var promise = _sales2.default.calculateRechargeRate({ cancelToken: this.source.token, value: this.rechargeValue, planId: this.planId, contractId: this.contractId }).then(function (resp) {
	        _this.rate = resp.taxTotal;
	        _this.waiting = false;
	      }).catch(function (err) {
	        _this.waiting = false;
	        _this.rate = 'N/A';
	      });
	      this.$store.dispatch('loading', promise);
	    },
	    getSalesOrder: function getSalesOrder() {
	      var _this2 = this;
	
	      if (this.msgError) {
	        return false;
	      }
	      this.msgError = undefined;
	      if (this.unit == -1 && (!this.rechargeValue || parseInt(this.rechargeValue) < parseInt(this.minValue))) {
	        this.msgError = 'Valor de recarga inv\xE1lido';
	        return false;
	      }
	
	      var v = 0;
	      var r = 0;
	      if (this.unit == -1) {
	        v = this.rechargeValue;
	        r = this.rate;
	      } else {
	        v = this.unit;
	        r = _.find(this.rechargesData, function (o) {
	          return o.value == _this2.unit;
	        }).tax;
	      }
	
	      var salesOrder = {
	        account: { moveMaisId: this.moveMaisId },
	        type: "RECHARGE",
	        salesType: "RECHARGE",
	        _interface: window.document.webview ? "MOBILE" : "WEBSITE",
	        contract: this.contractId,
	        price: parseInt(v) + parseInt(this.rate),
	        value: parseInt(v),
	        products: [{
	          productId: 2,
	          productName: "RECARGA",
	          quantity: 1,
	          valueTotal: v,
	          valueUnit: v
	        }, {
	          productId: 3,
	          productName: "TAXA DE RECARGA",
	          quantity: 1,
	          valueTotal: r,
	          valueUnit: r
	        }]
	      };
	
	      return _promise2.default.resolve(salesOrder);
	    }
	  },
	
	  components: {}
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _number = __webpack_require__(24);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _recargaMinima = __webpack_require__(98);
	
	var _recargaMinima2 = _interopRequireDefault(_recargaMinima);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      user: _auth2.default.currentUser,
	      rechargeValue: undefined,
	      rate: 0,
	      credit: 0,
	      loadingRates: _promise2.default.resolve(true),
	      loading: _promise2.default.resolve(true),
	      source: undefined,
	      rechargeUnit: undefined,
	      minValue: undefined,
	      qtdFix: 4,
	      rechargesData: {},
	      unit: -1,
	      msgError: undefined
	
	    };
	  },
	
	  computed: {
	    contractId: function contractId() {
	      return this.$route.params.contractId;
	    },
	    contract: function contract() {
	      return this.$store.getters.getContractById(this.contractId);
	    },
	
	    planId: function planId() {
	      return this.$route.params.planId;
	    },
	    valueFormatted: function valueFormatted() {
	      this.$nextTick(function () {
	        $('#valueTotal').val($('#valueTotal').val());
	      });
	      return (0, _number.cents)(this.rechargeValue).replace('R$', '');
	    },
	    total: function total() {
	      if (this.rate) return (0, _number.cents)(this.rate.valueTotal + this.rate.taxTotal);else return (0, _number.cents)(0);
	    },
	    tax: function tax() {
	      if (this.rate) return (0, _number.cents)(this.rate.taxTotal);else return (0, _number.cents)(0);
	    }
	  },
	  created: function created() {
	    this.source = _axios2.default.CancelToken.source();
	    this.minValue = this.contract.rechargeValue;
	  },
	
	  watch: {
	    unit: function unit(newValue) {
	      this.msgError = undefined;
	      if (newValue == -1) this.$nextTick(function () {
	        $('#valueTotal').focus();
	      });
	    }
	  },
	  mounted: function mounted() {},
	
	  methods: {
	
	    setTotal: function setTotal(newValue) {
	      this.msgError = undefined;
	      this.rechargeValue = newValue.replace(/[^0-9]/g, '');
	      this.calculateRecharge();
	    },
	    getQuantity: function getQuantity() {
	      return 1;
	    },
	    calculateRecharge: function calculateRecharge() {
	      var _this = this;
	
	      if (!_recargaMinima2.default.validate(this.rechargeValue, [this.minValue])) {
	        this.rate = 'N/A';
	        return false;
	      }
	      this.source.cancel('cancelada');
	      this.source = _axios2.default.CancelToken.source();
	      this.waiting = true;
	      var promise = _sales2.default.calculateRechargeRate({ cancelToken: this.source.token, value: this.rechargeValue, planId: this.planId, contractId: this.contractId }).then(function (resp) {
	        _this.rate = resp.taxTotal;
	        _this.credit = resp.valueTotal;
	        _this.waiting = false;
	      }).catch(function (err) {
	        _this.waiting = false;
	        _this.rate = 'N/A';
	        _this.credit = 0;
	      });
	      this.$store.dispatch('loading', promise);
	    },
	    getSalesOrder: function getSalesOrder() {
	      this.msgError = undefined;
	      if (this.unit == -1 && (!this.rechargeValue || parseInt(this.rechargeValue) <= parseInt(this.minValue))) {
	        this.msgError = 'Valor de recarga inv\xE1lido';
	        return false;
	      }
	      var v = 0;
	      if (this.unit == -1) v = this.rechargeValue;else v = this.unit;
	
	      var salesOrder = {
	        account: { moveMaisId: this.moveMaisId },
	        type: "RECHARGE",
	        salesType: "RECHARGE",
	        _interface: window.document.webview ? "MOBILE" : "WEBSITE",
	        contract: this.contractId,
	        price: parseInt(v) + parseInt(this.rate),
	        value: parseInt(v),
	        products: [{
	          productId: 2,
	          productName: "RECARGA",
	          quantity: 1,
	          valueTotal: v,
	          valueUnit: v
	        }, {
	          productId: 3,
	          productName: "TAXA DE RECARGA",
	          quantity: 1,
	          valueTotal: this.rate,
	          valueUnit: this.rate
	        }]
	      };
	
	      return _promise2.default.resolve(salesOrder);
	    }
	  },
	
	  components: {}
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFinite = __webpack_require__(768);
	
	var _isFinite2 = _interopRequireDefault(_isFinite);
	
	var _rechargeMultiple = __webpack_require__(1923);
	
	var _rechargeMultiple2 = _interopRequireDefault(_rechargeMultiple);
	
	var _rechargeOpen = __webpack_require__(1924);
	
	var _rechargeOpen2 = _interopRequireDefault(_rechargeOpen);
	
	var _rechargeTax = __webpack_require__(1925);
	
	var _rechargeTax2 = _interopRequireDefault(_rechargeTax);
	
	var _genericSummary = __webpack_require__(85);
	
	var _genericSummary2 = _interopRequireDefault(_genericSummary);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _success = __webpack_require__(47);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _error = __webpack_require__(67);
	
	var _error2 = _interopRequireDefault(_error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      finalize: false,
	      step: 0,
	      order: undefined,
	      loading: undefined,
	      code: undefined,
	      salesResponse: undefined,
	      validacaoFraude: undefined,
	      on: true,
	      msgErrorResp: undefined
	    };
	  },
	
	  computed: {
	    contractId: function contractId() {
	      return this.$route.params.contractId;
	    },
	    planId: function planId() {
	      return this.$route.params.planId;
	    },
	    contract: function contract() {
	      return this.$store.getters.getContractById(this.contractId);
	    },
	    user: function user() {
	      return _auth2.default.currentUser;
	    }
	  },
	
	  methods: {
	    startRequest: function startRequest() {
	      var _this = this;
	
	      this.on = false;
	      var summary = this.$refs.rechargeSummary;
	      var r = summary ? summary.getInfos().then(function () {
	        return _this.duplicityCheck();
	      }) : this.duplicityCheck();
	      this.loading = r;
	      this.$store.dispatch("loading", r);
	    },
	    goToStep: function goToStep(value) {
	      this.code = undefined;
	      this.finalize = false;
	      this.step = value;
	    },
	    nextStep: function nextStep() {
	      var _this2 = this;
	
	      this.msgError = undefined;
	      $("body").stop().animate({
	        scrollTop: 0
	      }, "500", "swing");
	      switch (this.step) {
	        case 0:
	          var p = this.$refs.rec.getSalesOrder().then(function (r) {
	            if (!r) {
	              return;
	            }
	            _this2.order = r;
	            _this2.order.planId = _this2.planId;
	            if (!_this2.order.vehicles) {
	              _this2.$set(_this2.order, "vehicles", []);
	            }
	            _this2.step = 1;
	          });
	          this.$store.dispatch("loading", p);
	          break;
	      }
	    },
	    duplicityCheck: function duplicityCheck() {
	      var _this3 = this;
	
	      return _sales2.default.getProcessingOrders(this.contractId, "RECHARGE").then(function (r) {
	        if (r == 0 || _this3.planId == 6) {
	          return _this3.doRecharge();
	        } else {
	          var n = Number(r);
	          var count = (0, _isFinite2.default)(n) && n > 0 ? n : 1;
	          var body = count === 1 ? "Já existe <strong>1 pedido de recarga</strong> em processamento para este contrato. Deseja prosseguir com uma nova recarga?" : "J\xE1 existem <strong>" + count + " pedidos de recarga</strong> em processamento para este contrato. Deseja prosseguir com uma nova recarga?";
	          return _messageDialog2.default.show({
	            title: "Recarga em processamento",
	            headerClass: "modal-danger",
	            message: body,
	            type: "YES-NO"
	          }).then(function (e) {
	            return e == "YES" && _this3.doRecharge();
	          });
	        }
	      });
	    },
	    doRecharge: function doRecharge() {
	      var _this4 = this;
	
	      var request = {
	        recharge: {
	          contractId: this.contractId,
	          _interface: window.document.webview ? "MOBILE" : "WEBSITE",
	          value: this.order.value
	        }
	      };
	
	      var p = _sales2.default.recharge(request).then(function (resp) {
	        _this4.salesResponse = resp.salesOrder;
	        _this4.code = resp.status.code;
	        _this4.finalize = true;
	        $("body").stop().animate({ scrollTop: 0 }, "500", "swing");
	        _this4.showMessage(resp);
	      }).catch(function (err) {
	        _this4.finalize = true;
	        _this4.salesResponse = err.salesOrder;
	
	        _this4.validacaoFraude = false;
	
	        if (err.data) {
	          _this4.salesResponse = err.data.salesOrder;
	          _this4.code = err.data.status.code;
	          _this4.msgError = err.data.status.message;
	        } else {
	          _this4.code = 1;
	        }
	      });
	      return p;
	    },
	    showMessage: function showMessage(resp) {
	      var _this5 = this;
	
	      var code = this.code = resp.status.code;
	      if (code == 0) {
	        var title = "";
	        var msg = resp.status.message;
	        if (resp && resp.redirUrl) {
	          title = "Estamos quase lá";
	        } else {
	          title = "Recarga realizada com sucesso";
	        }
	        _messageDialog2.default.show({
	          title: title,
	          headerClass: "modal-success",
	          message: msg
	        }).then(function (res) {
	          if (resp && resp.redirUrl) {
	            window.location = resp.redirUrl;
	          } else {
	            _this5.$router.push({
	              name: "requests"
	            });
	          }
	        });
	        return;
	      }
	    }
	  },
	
	  components: {
	    RechargeMultiple: _rechargeMultiple2.default,
	    RechargeOpen: _rechargeOpen2.default,
	    RechargeTax: _rechargeTax2.default,
	    GenericSummary: _genericSummary2.default,
	    successPage: _success2.default,
	    errorPage: _error2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _refundService = __webpack_require__(240);
	
	var _refundService2 = _interopRequireDefault(_refundService);
	
	var _pagination = __webpack_require__(33);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _string = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      filter: {
	        occurrenceDate: undefined,
	        plate: undefined,
	        taxPayerIdNumber: _auth2.default.currentUser.taxIdNumber
	      },
	      occurrenceDate: undefined,
	      loading: false,
	      refunds: [],
	      refundSelected: undefined,
	      refundPassageHist: undefined,
	      page: new _pagination.Page(1),
	      name: undefined,
	      dataEstorno: undefined,
	      dataCancelaEstorno: undefined
	    };
	  },
	
	  methods: {
	    searchRefunds: function searchRefunds() {
	      var _this = this;
	
	      if (!this.filter.plate || !this.occurrenceDate) {
	        return _messageDialog2.default.show({
	          title: "Aviso",
	          headerClass: "modal-info",
	          message: "Favor fornecer uma placa e uma data para a consulta"
	        });
	      }
	      var date = new Date(this.occurrenceDate),
	          mnth = ("0" + (date.getMonth() + 1)).slice(-2),
	          day = ("0" + date.getDate()).slice(-2);
	      this.filter.occurrenceDate = [date.getFullYear(), mnth, day].join("-");
	      this.filter.plate = this.filter.plate.replace(/-/g, "");
	      this.loading = _refundService2.default.getRefundPassage(this.filter).then(function (x) {
	        var resp = x.response || x;
	        if (resp.status.code != 0) {
	          return _promise2.default.reject(resp);
	        }
	        if (resp.refundPassages.length > 0) {
	          _this.refunds = resp.refundPassages;
	        } else {
	          _this.refunds = [];
	          _messageDialog2.default.show({
	            title: "Aviso",
	            headerClass: "modal-info",
	            message: "Nenhuma contestação localizada."
	          });
	        }
	      }).catch(function (error) {
	        return console.error(error);
	      });
	    },
	    getRefundDetails: function getRefundDetails(refundPassage) {
	      var _this2 = this;
	
	      this.loading = _refundService2.default.getRefundPassageHist(refundPassage.refundPassageId).then(function (resp) {
	        _this2.refundSelected = refundPassage;
	        _this2.refundPassageHist = resp.response;
	        _this2.findUserData();
	      }).catch(function (err) {
	        _messageDialog2.default.show({
	          title: "Aviso",
	          headerClass: "modal-danger",
	          message: "Ocorreu um erro ao recuperar os detalhes da contestação."
	        });
	        console.error(err);
	      });
	
	      this.loading = _refundService2.default.getRefusedDebit(refundPassage.transactionId).then(function (resp) {
	        var debito = resp.BiAccountStatement;
	        var estorno = _.filter(debito, function (o) {
	          return o.idHistoric == 1327;
	        });
	        estorno = estorno.sort(function (a, b) {
	          return new Date(b.processingDate) - new Date(a.processingDate);
	        });
	        _this2.dataEstorno = estorno[0].processingDate;
	
	        var canc = _.filter(debito, function (o) {
	          return o.idHistoric == 2327;
	        });
	
	        canc = canc.sort(function (a, b) {
	          return new Date(b.processingDate) - new Date(a.processingDate);
	        });
	        _this2.dataCancelaEstorno = canc[0].processingDate;
	      });
	    },
	    findUserData: function findUserData() {
	      var _this3 = this;
	
	      this.loading = _account2.default.getUserAndAddressByTaxIdNumber((0, _string.removeMascara)(this.refundSelected.taxPayerIdNumber)).then(function (resp) {
	        if (resp.status.code == 0) {
	          _this3.name = resp.user.person ? resp.user.person.name + ' ' + resp.user.person.lastName : resp.user.company.companyName;
	        } else {
	          _this3.name = "";
	        }
	        $("#refundDetails").modal("show");
	      }).catch(function (err) {});
	    }
	  },
	  computed: {
	    hasComments: function hasComments() {
	      return this.refundPassageHist && this.refundPassageHist.some(function (r) {
	        return r.comments && r.userType == 2;
	      });
	    },
	    hasFiles: function hasFiles() {
	      return this.refundPassageHist && this.refundPassageHist.some(function (r) {
	        return !r.comments;
	      });
	    },
	    hasRefusedDebit: function hasRefusedDebit() {
	      return this.refundPassageHist && this.refundPassageHist.some(function (r) {
	        return r.comments && r.status == 4;
	      });
	    }
	  },
	  components: {
	    Pagination: _pagination2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _vehicles = __webpack_require__(29);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _genericSummary = __webpack_require__(85);
	
	var _genericSummary2 = _interopRequireDefault(_genericSummary);
	
	var _success = __webpack_require__(47);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _error = __webpack_require__(67);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _utils = __webpack_require__(34);
	
	var Utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      msgError: undefined,
	      loading: undefined,
	      contract: undefined,
	      replaceTax: undefined,
	      plate: undefined,
	      vehicles: [],
	      salesOrder: undefined,
	      address: _auth2.default.currentUser.address,
	      whereToDelivery: "0",
	      shipmentType: undefined,
	      salesResponse: undefined,
	      code: undefined,
	      planId: undefined,
	      planName: undefined,
	      isMobile: false,
	      tagSerialNumber: "",
	      activationSuccess: false,
	      activationError: null,
	      tagInHandActivated: false
	    };
	  },
	
	
	  computed: {
	    addressInit: function addressInit() {
	      return _auth2.default.currentUser.address;
	    },
	    contractId: function contractId() {
	      return this.$route.params.contractId;
	    },
	    user: function user() {
	      return _auth2.default.currentUser;
	    },
	    tagActivationSuccessMessage: function tagActivationSuccessMessage() {
	      return _constantes2.default.MSG_01_REPLACE_IN_HAND_SUCCESS;
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this._resizeReplaceTag = function () {
	      _this.isMobile = window.innerWidth <= 769;
	    };
	    this._resizeReplaceTag();
	    window.addEventListener("resize", this._resizeReplaceTag);
	
	    this.loading = _contracts2.default.getContractByContractId(this.contractId).then(function (r) {
	      _this.contract = r;
	      _this.planId = r.plan.planId;
	      _this.getPlanInfo();
	    });
	    _vehicles2.default.getVehicleById(this.$route.params.vehicleId).then(function (r) {
	      _this.vehicles = [r];
	      _this.plate = r.plate;
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this._resizeReplaceTag) {
	      window.removeEventListener("resize", this._resizeReplaceTag);
	    }
	  },
	
	
	  methods: {
	    startRequest: function startRequest() {
	      var _this2 = this;
	
	      this.$refs.GenericSummary.getInfos().then(function (r) {
	        if (!r || !r.address) {
	          return;
	        }
	        _this2.address = r.address;
	        _this2.whereToDelivery = r.whereToDelivery;
	        _this2.shipmentType = r.shipmentType;
	        _this2.tagSerialNumber = r.tagSerialNumber;
	        _this2.doRequest();
	      });
	    },
	    onTagActivationState: function onTagActivationState(activated) {
	      this.tagInHandActivated = activated === true;
	      if (activated) {
	        this.activationSuccess = true;
	        this.activationError = null;
	      }
	    },
	    cancelar: function cancelar() {
	      var _this3 = this;
	
	      _messageDialog2.default.show({
	        title: "Cancelar Substituição",
	        message: "Deseja cancelar o pedido de substituição?",
	        type: "OK-CANCEL"
	      }).then(function (res) {
	        if (res == "OK") {
	          _this3.$router.push({
	            name: "plans"
	          });
	        }
	      });
	    },
	    getPlanInfo: function getPlanInfo() {
	      var _this4 = this;
	
	      this.loading = _sales2.default.getPlanById(this.planId).then(function (resp) {
	        if (_this4.planId == _constantes2.default.PLAN_POS || _this4.planId == _constantes2.default.PLAN_PRE_SEM_TAXA || _this4.contract.replaceTax) {
	          _this4.replaceTax = _this4.contract.replaceTax || 0;
	        } else {
	          _this4.replaceTax = _.filter(resp.adhesionTax.adhesionTax, function (o) {
	            return o.taxId == _constantes2.default.REPLACE_TAXID;
	          })[0].value;
	        }
	
	        _this4.planName = resp.name;
	
	        _this4.salesOrder = {
	          _interface: "WEBSITE",
	          planId: _this4.planId,
	          status: null,
	          type: "SUBSTITUIÇÃO DE TAG",
	          salesType: "REPLACETAG",
	          taxpayerIdSeller: null,
	          price: _this4.replaceTax,
	          logisticsDistribution: null,
	          vehicleId: null,
	          contract: _this4.contractId,
	          shipment: null,
	          vehicles: _this4.vehicles,
	          products: [{
	            productId: 6,
	            productName: "SUBSTITUIÇÃO DE TAG",
	            valueUnit: _this4.replaceTax,
	            quantity: _this4.vehicles.length,
	            valueTotal: _this4.replaceTax
	          }]
	        };
	      });
	    },
	    doRequest: function doRequest() {
	      var _this5 = this;
	
	      if (this.shipmentType == 4) {
	        this.activationSuccess = true;
	        this.activationError = null;
	        return;
	      }
	
	      var req = {
	        moveMaisId: this.user.moveMaisId,
	        contractId: this.contractId,
	        deliveryAddressId: this.address.addressId,
	        value: this.replaceTax,
	        secureCode: this.user.taxIdNumber.substring(0, 4),
	        _interface: window.document.webview ? "MOBILE" : "WEBSITE",
	        vehicles: this.vehicles,
	        shipmentType: this.shipmentType
	      };
	
	      if (this.shipmentType == 4 && this.tagSerialNumber) {
	        this.vehicles[0].tagSerialNumber = this.tagSerialNumber;
	      } else {
	        this.vehicles[0].tagSerialNumber = this.vehicles[0].serialNumber;
	      }
	      this.vehicles[0].tag = null;
	      this.vehicles[0].installDate = new Date(this.vehicles[0].installDate);
	
	      var url_atual = window.location.href;
	
	      if (url_atual != "") {
	        var regexp = new RegExp(/\S+pdv\S+/i);
	        var n = regexp.test(url_atual);
	        if (n) {
	          req["promotionCode"] = "GRAALKM29";
	          req["logisticsDistribution"] = "FOB";
	        }
	      }
	
	      if (Utils.isCaminhoParana(this.planId)) {
	        req["promotionCode"] = "CAMINHOSDOPARANA";
	        req["logisticsDistribution"] = "FOB";
	      }
	
	      if (this.whereToDelivery != "0") {
	        req["promotionCode"] = this.whereToDelivery;
	        req["logisticsDistribution"] = "FOB";
	      }
	
	      if (req.shipmentType == 3) {
	        req.logisticsDistribution = "FOB";
	      }
	
	      var p = _sales2.default.requestTagReplacement(req).catch(function (err) {
	        var data = err && err.data ? err.data : {};
	        _this5.msgError = data.status && data.status.message || data.message || "Não foi possível concluir a substituição de TAG.";
	        _this5.code = data.status && data.status.code;
	        _this5.salesResponse = undefined;
	        $("body").stop().animate({
	          scrollTop: 0
	        }, "500", "swing");
	        return _messageDialog2.default.show({
	          headerClass: "modal-danger",
	          title: "Erro!",
	          message: _this5.msgError,
	          type: "OK"
	        });
	      });
	
	      this.$store.dispatch("loading", p);
	    },
	    finalizar: function finalizar() {
	      this.$router.push("/conta/meus-planos");
	    }
	  },
	
	  components: {
	    successPage: _success2.default,
	    errorPage: _error2.default,
	    GenericSummary: _genericSummary2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _financial = __webpack_require__(54);
	
	var _financial2 = _interopRequireDefault(_financial);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _success = __webpack_require__(47);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _error = __webpack_require__(67);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _genericSummary = __webpack_require__(85);
	
	var _genericSummary2 = _interopRequireDefault(_genericSummary);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      salesOrder: undefined,
	      loading: undefined,
	      code: undefined,
	      novoCartao: false,
	      contractId: undefined,
	      vads_action_mode: "INTERACTIVE",
	      vads_amount: "1",
	      vads_ctx_mode: undefined,
	      vads_currency: "986",
	      vads_url_return: "https://movemais.com",
	      vads_cust_country: "BR",
	      vads_cust_name: undefined,
	      vads_cust_email: undefined,
	      vads_cust_first_name: undefined,
	      vads_cust_last_name: undefined,
	      vads_cust_national_id: undefined,
	      vads_page_action: "PAYMENT",
	      vads_payment_cards: "PIX",
	      vads_payment_config: "SINGLE",
	      vads_order_id: undefined,
	      vads_site_id: undefined,
	      vads_order_info: undefined,
	      vads_trans_date: undefined,
	      vads_trans_id: undefined,
	      vads_version: "V2",
	      certificate: undefined,
	      signature: undefined,
	      newPix: false,
	      pixCopiaCola: undefined,
	      hideButton: undefined,
	      step: 0,
	      validacaoFraude: undefined,
	      cpmId: undefined,
	      usuario: undefined,
	      validado: undefined,
	      planId: undefined,
	      contract: undefined
	    };
	  },
	
	  computed: {
	    orderId: function orderId() {
	      return this.$route.params.orderId;
	    },
	    user: function user() {
	      return _auth2.default.currentUser;
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    if (this.orderId) {
	      var promise = _sales2.default.getSalesOrderId(this.orderId).then(function (result) {
	        _this.salesOrder = result.order;
	
	        _this.salesOrder.totalComDesconto = _this.salesOrder.price;
	        if (_this.salesOrder.promotionCode && _this.salesOrder.promotionCode.indexOf('SENFF') >= 0) {
	          sessionStorage.setItem('promoCheck', '#SENFF2020');
	        }
	        return _contracts2.default.getContractByContractId(result.order.contractId).then(function (r) {
	          _this.salesOrder = result.order;
	
	          _this.salesOrder.totalComDesconto = _this.salesOrder.price;
	          _this.$set(_this.salesOrder, 'contract', result.order.contractId);
	          _this.contract = r;
	          _this.salesOrder.planId = r.plan.planId;
	          _this.planId = r.plan.planId;
	        });
	      }).catch(function (error) {
	
	        if (error.data.status && error.data.status.code == 9990) {
	          return false;
	        }
	      });
	      this.$store.dispatch('loading', promise);
	    }
	  },
	
	  methods: {
	    ConvertFieldToUTF8: function ConvertFieldToUTF8() {
	      this.vads_cust_first_name = encodeURIComponent(this.vads_cust_first_name.replace(/ /g, ""));
	      this.vads_cust_last_name = encodeURIComponent(this.vads_cust_last_name.replace(/ /g, ""));
	      this.vads_cust_name = encodeURIComponent(this.vads_cust_name.replace(/ /g, ""));
	      if (!this.vads_cust_first_name) this.vads_cust_first_name = ".";
	      if (!this.vads_cust_last_name) this.vads_cust_last_name = ".";
	      if (!this.vads_cust_name) this.vads_cust_name = ".";
	    },
	    ReceberHash: function ReceberHash() {
	      this.ConvertFieldToUTF8();
	
	      var input_str = this.vads_action_mode + "+" + this.vads_amount + "+" + this.vads_ctx_mode + "+" + this.vads_currency + "+" + this.vads_cust_country + "+" + this.vads_cust_email + "+" + this.vads_cust_first_name + "+" + this.vads_cust_last_name + "+" + this.vads_cust_name + "+" + this.vads_cust_national_id + "+" + this.vads_order_id + "+" + this.vads_order_info + "+" + this.vads_page_action + "+" + this.vads_payment_cards + "+" + this.vads_payment_config + "+" + this.vads_site_id + "+" + this.vads_trans_date + "+" + this.vads_trans_id + "+" + this.vads_url_return + "+" + this.vads_version + "+" + this.certificate;
	
	      var crypto = __webpack_require__(131);
	
	      this.signature = crypto.createHmac('sha256', this.certificate).update(input_str).digest('base64');
	
	      this.$forceUpdate();
	    },
	    getPayment: function getPayment() {
	      var _this2 = this;
	
	      var cpmFromResponse = function cpmFromResponse(res) {
	        return res.salesOrder && res.salesOrder.contractPaymentMethod ? res.salesOrder.contractPaymentMethod : null;
	      };
	
	      this.loading = _financial2.default.reprocessPayout({ salesOrderId: this.orderId }).then(function (res) {
	        var cpm = cpmFromResponse(res);
	
	        if ((_this2.planId == 21 || _this2.planId == 22 || _this2.planId == 35 || _this2.planId == 36) && cpm && cpm.contractPaymentMethodId == null) {
	          _this2.novoCartao = true;
	        }
	
	        if (cpm) {
	          _this2.usuario = cpm.usuario;
	          _this2.validado = cpm.validado;
	        }
	        _this2.vads_site_id = res.info_st;
	        _this2.certificate = res.info_cc;
	
	        if (res.salesOrder && res.salesOrder.pixCopiaCola) _this2.pixCopiaCola = res.salesOrder.pixCopiaCola;
	
	        var pmId = cpm && cpm.paymentMethod ? cpm.paymentMethod.paymentMethodId : null;
	        if (pmId == 120 && _this2.pixCopiaCola != undefined) {
	          _this2.newPix = true;
	          _this2.salesResponse = res.salesOrder;
	          _this2.code = res.status.code;
	          _this2.boletoUrl = res.boletoUrl;
	        } else if (pmId == 120) {
	
	          var pedido = res.nextVal.toString();
	          if (window.location.hostname == "www.movemais.com" || window.location.hostname == "movemais.com") {
	            _this2.vads_ctx_mode = "PRODUCTION";
	          } else {
	            _this2.vads_ctx_mode = "TEST";
	          }
	
	          _this2.vads_trans_date = new Date(res.salesOrder.lastUpdateDate).toISOString().replace(/[^0-9]/g, '').substring(0, 14);
	          _this2.vads_trans_id = "M" + pedido.slice(-5);
	          _this2.vads_order_id = pedido;
	          _this2.vads_order_info = res.info_cp;
	          _this2.vads_amount = res.salesOrder.price;
	
	          if (_auth2.default.currentUser.person) {
	            var sobrenome = _auth2.default.currentUser.person.lastName.split(" ", 2);
	            _this2.vads_cust_first_name = _auth2.default.currentUser.person.name;
	            _this2.vads_cust_last_name = sobrenome[0];
	            _this2.vads_cust_name = _auth2.default.currentUser.person.name;
	          } else if (_auth2.default.currentUser.company) {
	            var nome = _auth2.default.currentUser.company.companyTradeName.split(" ", 2);
	            _this2.vads_cust_first_name = nome[0];
	            _this2.vads_cust_last_name = nome[1] ? nome[1] : nome[0];
	            _this2.vads_cust_name = nome[0];
	          }
	          _this2.vads_cust_national_id = _auth2.default.currentUser.taxIdNumber;
	          _this2.vads_cust_email = _auth2.default.currentUser.accountAuthentication.login;
	
	          _this2.ReceberHash();
	
	          _this2.newPix = true;
	          setTimeout(function () {
	            document.getElementById("formPix").submit();
	            _this2.salesResponse = res.salesOrder;
	            _this2.code = res.status.code;
	            _this2.boletoUrl = res.boletoUrl;
	          }, 200);
	        } else {
	          if (res.status) {
	            _this2.code = res.status.code;
	            _this2.hideButton = true;
	          }
	        }
	      }).catch(function (err) {
	
	        _this2.hideButton = true;
	        _this2.salesOrder = err.data.salesOrder;
	
	        var errCpm = _this2.salesOrder && _this2.salesOrder.contractPaymentMethod;
	        if (errCpm && errCpm.paymentMethod) {
	          _this2.cpmId = errCpm.paymentMethod.paymentMethodId;
	        }
	
	        _this2.code = err.data && err.data.status && err.data.status.code;
	        var contrato = err.data.salesOrder.contractId;
	        var salesOrderId = err.data.salesOrder.salesOrderId;
	        var paymentMethodId = errCpm && errCpm.contractPaymentMethodId;
	
	        if (paymentMethodId != null) {
	          _this2.loading = _sales2.default.validarFraudeContrato(contrato, salesOrderId, paymentMethodId).then(function (r) {
	            if (r.result) {
	              _this2.validacaoFraude = true;
	            } else {
	              _this2.validacaoFraude = false;
	            }
	          });
	        } else {
	          _this2.validacaoFraude = false;
	        }
	      });
	    },
	    goToStep: function goToStep(value) {
	      this.code = undefined;
	      this.step = value;
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	
	    sessionStorage.removeItem('promoCheck');
	  },
	
	
	  components: {
	    GenericSummary: _genericSummary2.default,
	    successPage: _success2.default,
	    errorPage: _error2.default
	  }
	};

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _conveniadoService = __webpack_require__(239);
	
	var _conveniadoService2 = _interopRequireDefault(_conveniadoService);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      vouchers: [],
	      loading: undefined,
	      nome: undefined,
	      sobrenome: undefined,
	      nomeCliente: undefined,
	      contractId: undefined,
	      salesOrderId: undefined
	    };
	  },
	
	
	  methods: {
	    print: function print() {
	      var prtContent = document.getElementById("comprovante");
	      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	      WinPrint.document.write(prtContent.innerHTML);
	      WinPrint.document.close();
	      WinPrint.focus();
	      WinPrint.print();
	      WinPrint.close();
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    $('[data-toggle="tooltip"]').tooltip();
	
	    this.contractId = this.$route.params.contractId;
	
	    var req = {
	      salesOrderId: this.$route.params.orderId
	    };
	
	    this.loading = _account2.default.getUserByMoveMaisId(this.$route.params.moveMaisId).then(function (resp) {
	
	      if (resp.user.person != null) {
	        _this.nome = resp.user.person.name;
	        _this.sobrenome = resp.user.person.lastName;
	        _this.nomeCliente = _this.nome + ' ' + _this.sobrenome;
	      } else {
	        _this.nomeCliente = resp.user.company.companyTradeName;
	      }
	    }).catch(function (err) {});
	
	    this.loading = _conveniadoService2.default.listaVouchersConveniadoComStatus(req).then(function (resp) {
	      _this.vouchers = resp.listaVouchersConveniado;
	    }).catch(function (err) {});
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _eventBus = __webpack_require__(25);
	
	var _routes = __webpack_require__(97);
	
	var _reprocess = __webpack_require__(525);
	
	var _reprocess2 = _interopRequireDefault(_reprocess);
	
	var _detailOrder = __webpack_require__(1931);
	
	var _detailOrder2 = _interopRequireDefault(_detailOrder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      searchState: undefined,
	      orders: undefined,
	      loading: undefined,
	      messageError: undefined,
	      showModal: false,
	      allOrderIds: [],
	      contractId: undefined
	    };
	  },
	
	  mounted: function mounted() {
	    this.loadData();
	  },
	  computed: {
	    contract: function contract() {
	      return this.$store.getters.getContractById(this.$route.params.contractId);
	    }
	  },
	  methods: {
	    showDetail: function showDetail(order) {
	      _routes.router.push({ name: 'request-detail', params: { orderId: order.orderId } });
	    },
	    loadData: function loadData() {
	      var _this = this;
	
	      this.loading = _sales2.default.listSalesOrders({ statusId: 3, type: 'COMPLETE' }).then(function (result) {
	
	        if (result && result.code == 9990) {
	          _this.messageError = result.message;
	          return false;
	        }
	        if (result.orders && result.orders.order.length > 0) {
	          _this.orders = _.filter(result.orders.order, function (o) {
	            return o.type == 'PASSAGEM' && o.status.statusId == 3;
	          });
	
	          if (_this.orders.length) {
	            _this.contractId = _this.orders[0].contract;
	          }
	
	          _this.allOrderIds = _.map(_this.orders, function (o) {
	            return o.orderId;
	          });
	        }
	      }).catch(function (error) {
	        if (error.data.status && error.data.status.code == 9990) {
	          _this.messageError = error.data.status.message;
	          return false;
	        }
	      });
	    }
	  },
	
	  components: {
	    Reprocess: _reprocess2.default,
	    DetailOrder: _detailOrder2.default
	  },
	  beforeDestroy: function beforeDestroy() {
	
	    _eventBus.EventBus.$off('setPayment');
	  }
	};

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _financial = __webpack_require__(54);
	
	var _financial2 = _interopRequireDefault(_financial);
	
	var _messageDialog = __webpack_require__(53);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['orderId', 'contractId'],
	  data: function data() {
	    return {
	      loading: undefined,
	      reprocessed: false
	    };
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.reprocessed = false;
	    if (!_auth2.default.currentUser.onlyOneContract && this.contractId) {
	      _contracts2.default.getContractByContractId(this.contractId).then(function (r) {
	        _this.$store.commit('currentPlanId', r.plan.planId);
	      });
	    }
	  },
	  methods: {
	    reprocessarPayout: function reprocessarPayout() {
	      this.reprocessed = true;
	      var request = { orderId: this.orderId };
	      this.doRequest(request);
	    },
	    doRequest: function doRequest(req) {
	      var _this2 = this;
	
	      if (Array.isArray(req.orderId)) {
	        req.allIds = req.orderId;
	        req.orderId = 0;
	      }
	      this.loading = _financial2.default.reprocessPayout(req);
	      this.loading.then(function () {
	        _messageDialog2.default.show({
	          title: 'Sucesso',
	          message: 'Pagamento realizado com sucesso!',
	          type: 'OK'
	        }).then(function () {
	          _this2.$emit('reprocessConfirmed', true);
	        });
	      }).catch(function (erro) {
	        _this2.$emit('close', '');
	        _this2.$emit('reprocessConfirmed', false);
	        _messageDialog2.default.show({
	          title: 'Erro',
	          message: erro.data.status.message,
	          type: 'OK'
	        }).then(function () {
	          _this2.reprocessed = false;
	        });
	      });
	    }
	  },
	  components: {}
	};

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _param = __webpack_require__(68);
	
	var _param2 = _interopRequireDefault(_param);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _reprocess = __webpack_require__(525);
	
	var _reprocess2 = _interopRequireDefault(_reprocess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      order: undefined,
	      address: undefined,
	      loading: undefined,
	      orderShipmentTracking: undefined,
	      showVehicle: false,
	      listVehicles: [],
	      statusPedido: {},
	      showModal: false,
	      dataCorteReprocessamento: undefined,
	      newTypePayment: undefined,
	      reprocessed: false
	    };
	  },
	
	
	  computed: {
	    notAproved: function notAproved() {
	      return this.$route.query.notAproved;
	    },
	    orderId: function orderId() {
	      return this.$route.params.orderId;
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var promise = _sales2.default.getSalesOrderId(this.orderId).then(function (r) {
	      _this.order = r;
	      if (_this.order.shipment) _this.orderShipmentTracking = _this.order.shipment.orderShipmentTrackingList.orderShipmentTracking;
	
	      _this.statusPedido['status-active'] = _this.order.status.statusId == 2 || _this.order.status.statusId == 4 || _this.order.status.statusId == 7;
	      _this.statusPedido['status-inactive'] = !_this.statusPedido['status-active'];
	
	      if (_this.order.shipment && _this.order.shipment.listVehicle) _this.listVehicles = _this.order.shipment.listVehicle.vehicle;
	
	      if (_this.order.shipment) {
	        _this.address = _this.order.shipment.address.zipCode.address + ' ' + _this.order.shipment.address.number + ', ' + _this.order.shipment.address.zipCode.neighborhood + ' - CEP ' + _this.order.shipment.address.zipCode.zipCode + ' - ' + _this.order.shipment.address.zipCode.city + ' - ' + _this.order.shipment.address.zipCode.state;
	      }
	    });
	    this.$store.dispatch('loading', promise);
	
	    _param2.default.getParm().then(function (res) {
	      _this.dataCorteReprocessamento = res.data.dataCorteReprocessamento;
	    }).catch(function (erro) {
	      _messageDialog2.default.show({
	        title: 'Erro',
	        message: 'Não foi possivel carregar a data de corte para processamento!',
	        type: 'OK'
	      });
	    });
	  },
	  methods: {
	    toogleModal: function toogleModal() {
	      this.showVehicle = !this.showVehicle;
	    },
	    canReprocess: function canReprocess() {
	      if (!this.order || this.dataCorteReprocessamento === undefined) return false;
	      var pm = this.order.paymentMethod;
	      var dateOk = parseInt(this.dataCorteReprocessamento, 10) < new Date().getTime();
	      var statusPending = this.order.status.statusId == 3 && dateOk;
	      var bcPending = pm && pm.type == 'BC' && !this.order.bankBillUrl && this.order.price > 0;
	      return statusPending || bcPending;
	    },
	    showModalReprocessPayout: function showModalReprocessPayout() {
	      this.showModal = true;
	    },
	    isDescont: function isDescont(product, value) {
	      return product.productId == 11 ? -1 * value : value;
	    },
	    showVehiclesPlates: function showVehiclesPlates(product) {
	      var productsException = [1, 4, 6];
	      return this.order.promotionCode != 'CAMINHOSDOPARANA' && productsException.indexOf(product.productId) !== -1;
	    },
	    goToOrders: function goToOrders(sucess) {
	      this.$router.push({ name: 'requests' });
	    }
	  },
	  components: {
	    Reprocess: _reprocess2.default
	  }
	
	};

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sign = __webpack_require__(766);
	
	var _sign2 = _interopRequireDefault(_sign);
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _getIterator2 = __webpack_require__(69);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _routes = __webpack_require__(97);
	
	var _pagination = __webpack_require__(33);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _invoice = __webpack_require__(170);
	
	var _invoice2 = _interopRequireDefault(_invoice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      searchState: undefined,
	      orders: undefined,
	      loading: undefined,
	      messageError: undefined,
	      page: new _pagination.Page(),
	      salesOrder: {},
	      nfeLinksMap: {}
	    };
	  },
	
	  computed: {
	    currentUser: function currentUser() {
	      return _auth2.default.currentUser;
	    },
	    contractId: function contractId() {
	      return this.$route.params.contractId;
	    }
	  },
	  mounted: function mounted() {
	    this.find();
	  },
	
	  methods: {
	    find: function find() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        var promise;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this.salesOrder = {
	                  moveMaisId: _this.currentUser.moveMaisId,
	                  planId: undefined,
	                  type: "",
	                  status: "",
	                  page: _this.page.build()
	                };
	
	                promise = _sales2.default.listSalesOrders(_this.salesOrder).then(function () {
	                  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(result) {
	                    return _regenerator2.default.wrap(function _callee2$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            if (!(result && result.status.code == 9990)) {
	                              _context2.next = 3;
	                              break;
	                            }
	
	                            _this.messageError = result.status.message;
	                            return _context2.abrupt("return", false);
	
	                          case 3:
	                            if (!(result.itens && result.itens.length > 0)) {
	                              _context2.next = 5;
	                              break;
	                            }
	
	                            return _context2.delegateYield(_regenerator2.default.mark(function _callee() {
	                              var salesOrderIds, map, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, salesOrderId, res;
	
	                              return _regenerator2.default.wrap(function _callee$(_context) {
	                                while (1) {
	                                  switch (_context.prev = _context.next) {
	                                    case 0:
	                                      _this.orders = result.itens;
	                                      _this.page = _this.page.itemCount(result.total);
	                                      salesOrderIds = _this.orders.map(function (o) {
	                                        return o.salesOrderId;
	                                      });
	                                      map = {};
	                                      _iteratorNormalCompletion = true;
	                                      _didIteratorError = false;
	                                      _iteratorError = undefined;
	                                      _context.prev = 7;
	                                      _iterator = (0, _getIterator3.default)(salesOrderIds);
	
	                                    case 9:
	                                      if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                                        _context.next = 23;
	                                        break;
	                                      }
	
	                                      salesOrderId = _step.value;
	                                      _context.prev = 11;
	                                      _context.next = 14;
	                                      return _invoice2.default.getLinkNFe(salesOrderId);
	
	                                    case 14:
	                                      res = _context.sent;
	
	                                      if (res && res.status && res.status.code === 0 && res.return && Array.isArray(res.return)) {
	                                        res.return.forEach(function (entry) {
	                                          if (entry.salesOrderId && entry.url) {
	                                            var key = String(entry.salesOrderId);
	                                            if (!map[key]) {
	                                              map[key] = [];
	                                            }
	                                            if (!(map[key].indexOf(entry.url) !== -1)) {
	                                              map[key].push(entry.url);
	                                            }
	                                          }
	                                        });
	                                      }
	                                      _context.next = 20;
	                                      break;
	
	                                    case 18:
	                                      _context.prev = 18;
	                                      _context.t0 = _context["catch"](11);
	
	                                    case 20:
	                                      _iteratorNormalCompletion = true;
	                                      _context.next = 9;
	                                      break;
	
	                                    case 23:
	                                      _context.next = 29;
	                                      break;
	
	                                    case 25:
	                                      _context.prev = 25;
	                                      _context.t1 = _context["catch"](7);
	                                      _didIteratorError = true;
	                                      _iteratorError = _context.t1;
	
	                                    case 29:
	                                      _context.prev = 29;
	                                      _context.prev = 30;
	
	                                      if (!_iteratorNormalCompletion && _iterator.return) {
	                                        _iterator.return();
	                                      }
	
	                                    case 32:
	                                      _context.prev = 32;
	
	                                      if (!_didIteratorError) {
	                                        _context.next = 35;
	                                        break;
	                                      }
	
	                                      throw _iteratorError;
	
	                                    case 35:
	                                      return _context.finish(32);
	
	                                    case 36:
	                                      return _context.finish(29);
	
	                                    case 37:
	                                      _this.nfeLinksMap = map;
	
	                                    case 38:
	                                    case "end":
	                                      return _context.stop();
	                                  }
	                                }
	                              }, _callee, _this, [[7, 25, 29, 37], [11, 18], [30,, 32, 36]]);
	                            })(), "t0", 5);
	
	                          case 5:
	                          case "end":
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee2, _this);
	                  }));
	
	                  return function (_x) {
	                    return _ref.apply(this, arguments);
	                  };
	                }()).catch(function (error) {
	                  if (error.data && error.data.status && error.data.status.code == 9990) {
	                    _this.messageError = error.data.status.message;
	                    return false;
	                  }
	                });
	
	                _this.$store.dispatch("loading", promise);
	
	              case 3:
	              case "end":
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this);
	      }))();
	    },
	    setCurrentPage: function setCurrentPage(p) {
	      this.page = this.page.page(p);
	      this.find();
	    },
	    setPageSize: function setPageSize(size) {
	      this.page = this.page.size(size);
	      this.find();
	    },
	    showDetail: function showDetail(order) {
	      _routes.router.push({
	        name: "reprocess-order",
	        params: { orderId: order.salesOrderId }
	      });
	    },
	    showQRCodePix: function showQRCodePix(order) {
	      if (order.salesOrderStatus.salesOrderStatusId == 0 && order.pixCopiaCola && order.contractPaymentMethod.paymentMethod.paymentShortName == "PX") {
	        _routes.router.push({
	          name: "view-qrcode-pix",
	          params: {
	            code: 0,
	            boletoUrl: undefined,
	            novoCartao: undefined,
	            newPix: true,
	            pixCopiaCola: order.pixCopiaCola
	          }
	        });
	      }
	    },
	    showReceipt: function showReceipt(order) {
	      _routes.router.push({
	        name: "transfer-credit-receipt",
	        params: {
	          orderId: order.salesOrderId
	        }
	      });
	    },
	    isChangeCard: function isChangeCard(order) {
	      return order.salesType == "RECARGA" && order.price == 2 || order.salesType == "RECARGA" && order.price == 100;
	    },
	    isTransfer: function isTransfer(order) {
	      return order.salesType == "TRANSFERÊNCIA ENTRE CONTAS";
	    },
	    getValueClass: function getValueClass(price) {
	      return (0, _sign2.default)(price) >= 0 ? "green" : "red";
	    },
	    exibeVoucher: function exibeVoucher(order) {
	      _routes.router.push({
	        name: "conveniado-voucher",
	        params: {
	          orderId: order.salesOrderId,
	          moveMaisId: order.moveMaisId,
	          contractId: order.contractId
	        }
	      });
	    }
	  },
	  components: {
	    Pagination: _pagination2.default
	  }
	};

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vehicleRntrc = __webpack_require__(1937);
	
	var _vehicleRntrc2 = _interopRequireDefault(_vehicleRntrc);
	
	var _vehicles = __webpack_require__(29);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: undefined,
	      vehicles: undefined,
	      vehicleStatic: undefined,
	      length: undefined,
	      rntrc: '0000',
	      editRntrc: false,
	      newRntrc: undefined
	    };
	  },
	
	  computed: {
	    user: function user() {
	      return _auth2.default.currentUser;
	    },
	    name: function name() {
	      if (this.user.company) return this.user.company.companyName;else return this.user.person.name + " " + this.user.person.lastName;
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    $('[data-toggle="tooltip"]').tooltip();
	
	    this.loading = _vehicles2.default.getVehiclesToVinculateRNTRC().then(function (responseVehicles) {
	      _this.vehicles = responseVehicles;
	      _this.vehicleStatic = _this.vehicles;
	      _this.length = _this.vehicles.length;
	    }).catch(function (error) {
	
	      if (error.data && error.data.status && error.data.status.code == 9990) return;
	
	      return MessageDialog.show({
	        headerClass: 'modal-info',
	        title: 'Erro',
	        message: 'Ocorreu um erro desconhecido.',
	        type: 'OK'
	      });
	    });
	  },
	
	  methods: {
	    startEditRntrc: function startEditRntrc() {
	      this.editRntrc = true;
	      $('[data-toggle="tooltip"]').tooltip('hide');
	    },
	    cancelEditRntrc: function cancelEditRntrc() {
	      this.editRntrc = false;
	      this.newRntrc = undefined;
	      $('[data-toggle="tooltip"]').tooltip('hide');
	    },
	    confirmEditRntrc: function confirmEditRntrc() {
	      this.editRntrc = false;
	      this.rntrc = this.newRntrc;
	      this.newRntrc = undefined;
	      $('[data-toggle="tooltip"]').tooltip('hide');
	    }
	  },
	  components: {
	    vehicleRntrc: _vehicleRntrc2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _antt = __webpack_require__(746);
	
	var _antt2 = _interopRequireDefault(_antt);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['vehicle', 'rntrc'],
	  data: function data() {
	    return {
	      serialNumber: undefined,
	      driver: {},
	      errorMsg: undefined,
	      isVinculated: false,
	      loading: undefined
	    };
	  },
	
	  computed: {
	    ownFleet: {
	      get: function get() {
	        return this.vehicle.ownFleet == 'Y';
	      },
	      set: function set(val) {
	        this.vehicle.ownFleet = val ? 'Y' : 'N';
	      }
	    }
	  },
	  created: function created() {
	    if (this.vehicle.drivers && this.vehicle.drivers.driver && this.vehicle.drivers.driver.length > 0) {
	      this.driver = this.vehicle.drivers.driver[0];
	    }
	  },
	
	  methods: {
	    vinculate: function vinculate() {
	      var _this = this;
	
	      this.errorMsg = undefined;
	      this.loading = this.$validator.validateAll().then(function (s) {
	
	        if (_this.vehicle.ownFleet == 'Y') {
	          delete _this.vehicle.drivers;
	          _this.vehicle.rntrc = _this.rntrc;
	        } else {
	          _this.vehicle.drivers = { driver: [_this.driver] };
	        }
	
	        return _antt2.default.vincularRntrc({ vehicle: _this.vehicle, taxpayerIdNumber: _auth2.default.currentUser.taxIdNumber, serialNumber: _this.serialNumber }).then(function (resp) {
	          _this.isVinculated = true;
	        });
	      }).catch(function (err) {
	
	        _this.errorMsg = err.data.status.message;
	      });
	    }
	  }
	};

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _googleMaps = __webpack_require__(93);
	
	var _googleMaps2 = _interopRequireDefault(_googleMaps);
	
	var _turf = __webpack_require__(223);
	
	var _turf2 = _interopRequireDefault(_turf);
	
	var _pointToLineDistance = __webpack_require__(166);
	
	var _pointToLineDistance2 = _interopRequireDefault(_pointToLineDistance);
	
	var _simplifyJs = __webpack_require__(146);
	
	var _simplifyJs2 = _interopRequireDefault(_simplifyJs);
	
	var _toll = __webpack_require__(26);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	var _route = __webpack_require__(59);
	
	var _route2 = _interopRequireDefault(_route);
	
	var _number = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      google: undefined,
	      map: undefined,
	      markers: [],
	      axes: 2,
	      directionsService: undefined,
	      originAc: undefined,
	      destinationAc: undefined,
	      wayPoints: [],
	      qtdWayPoints: 0,
	      msgError: undefined,
	      loading: undefined,
	      distance: undefined,
	      qtdTolls: undefined,
	      valueTolls: undefined,
	      showSummary: false,
	      coord: undefined,
	      all: undefined,
	      duration: undefined,
	      result: { start: undefined, end: undefined, wayPoints: undefined, tolls: undefined,
	        totalDistance: undefined, totalTime: undefined, totaltollFeeCost: undefined },
	      image: undefined,
	      associateId: undefined
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    var promise = _toll2.default.getTolls().then(function (r) {
	
	      _this.all = r;
	      _this.putPin(_this.all);
	    }).catch(function (err) {});
	    this.$store.dispatch('loading', promise);
	  },
	  mounted: function mounted() {
	    $('[data-toggle="tooltip"]').tooltip();
	    var vm = this;
	
	    _googleMaps2.default.KEY = 'AIzaSyAzAwCX1zCJ9idWkNdxs39j36N4lAToIjE';
	    _googleMaps2.default.LIBRARIES = ['places'];
	    _googleMaps2.default.load(function (google) {
	      vm.google = google;
	      vm.map = new google.maps.Map(document.getElementById('map'), {
	        zoom: 4,
	        center: { "lat": -21.009377008304, "lng": -48.17694799974561 }
	      });
	
	      vm.directionsDisplay = new google.maps.DirectionsRenderer({
	        draggable: true,
	        suppressMarkers: true
	      });
	      vm.directionsDisplay.setMap(vm.map);
	
	      vm.directionsService = new google.maps.DirectionsService();
	
	      vm.directionsDisplay.addListener("directions_changed", function () {
	        vm.updateNewDirections();
	      });
	
	      vm.initAutoCompletes();
	    });
	  },
	
	
	  methods: {
	    afterUpdateDirections: function afterUpdateDirections() {},
	    plotAssociate: function plotAssociate() {
	      var _this2 = this;
	
	      var t = _.filter(this.all, function (o) {
	        o.price = 0;
	        return o.associateId == _this2.associateId;
	      });
	      this.reset();
	      this.putPin(t);
	    },
	    placeToPointLocation: function placeToPointLocation(place, sequence, type) {
	      var p = {
	        type: type,
	        sequence: sequence
	      };
	      _.each(place.address_components, function (o) {
	        if (_.indexOf(o.types, 'postal_code') >= 0) p.zipCode = o.short_name;else if (_.indexOf(o.types, 'administrative_area_level_1') >= 0) p.state = o.short_name;else if (_.indexOf(o.types, 'administrative_area_level_2') >= 0) p.city = o.short_name;else if (_.indexOf(o.types, 'sublocality') >= 0) p.neighborhood = o.short_name;else if (_.indexOf(o.types, 'route') >= 0) p.address = o.short_name;else if (_.indexOf(o.types, 'street_number') >= 0) p.number = o.short_name;else if (_.indexOf(o.types, 'country') >= 0) p.country = o.short_name;
	      });
	      try {
	        p.address = place.formatted_address;
	        p.lat = place.geometry.location.lat();
	        p.lng = place.geometry.location.lng();
	      } catch (err) {}
	      return p;
	    },
	    plotar: function plotar() {
	      var pos = this.coord.trim().split(",");
	      var marker = new google.maps.Marker({
	        position: { lat: parseFloat(pos[0]), lng: parseFloat(pos[1]) },
	        map: this.map
	      });
	
	      var contentString = this.coord;
	
	      var infowindow = new google.maps.InfoWindow({
	        content: this.coord
	      });
	
	      marker.addListener('click', function () {
	        infowindow.open(this.map, marker);
	      });
	
	      this.markers.push(marker);
	    },
	    inverter: function inverter() {
	      var origin = document.getElementById('origin').value;
	      var destination = document.getElementById('destination').value;
	      document.getElementById('origin').value = destination;
	      document.getElementById('destination').value = origin;
	      this.calculate();
	    },
	    initAutoCompletes: function initAutoCompletes() {
	
	      var options = {
	        componentRestrictions: { country: 'br' }
	      };
	
	      this.originAc = new google.maps.places.Autocomplete(document.getElementById('origin'), options);
	      this.destinationAc = new google.maps.places.Autocomplete(document.getElementById('destination'), options);
	    },
	    putPin: function putPin(tolls) {
	      var _this3 = this;
	
	      _.each(tolls, function (o) {
	
	        var marker = new google.maps.Marker({
	          icon: o.id > 0 ? '/static/pins/pin-toll.png' : '/static/pins/pin-toll-inactive.png',
	          position: o,
	          map: _this3.map
	        });
	
	        var content = '<p>' + o.associateId + ' - ' + o.entryId + ' - ' + o.direction + ' - ' + o.radius + '</p>';
	        if (o.id < 0) content += '<div class="box-toll-map"><h4 class="title-toll">' + o.description + '</h4><span class="text-toll-inactive">Ped\xE1gio n\xE3o atendido pela Move Mais.</span></div>';else content += '<div class="box-toll-map"><h4 class="title-toll">' + o.description + '</h4><span class="text-toll">Valor do Ped\xE1gio: </span><span class="text-toll-value">' + (0, _number.cents)(o.price) + '</span></div>';
	
	        var infowindow = new google.maps.InfoWindow({
	          content: content
	        });
	
	        marker.addListener('click', function () {
	          infowindow.open(this.map, marker);
	        });
	
	        _this3.markers.push(marker);
	      });
	    },
	    setRouteMarkers: function setRouteMarkers(direction) {
	      var _this4 = this;
	
	      var legs = direction.routes[0].legs;
	
	      var start = legs[0].start_location;
	      var marker = new this.google.maps.Marker({
	        position: start,
	        icon: '/static/pins/pin-origin.png',
	        map: this.map
	      });
	      this.markers.push(marker);
	      this.result.start = start;
	
	      var end = legs[legs.length - 1].end_location;
	      marker = new this.google.maps.Marker({
	        position: end,
	        icon: '/static/pins/pin-destination.png',
	        map: this.map,
	        zIndex: 999,
	        optimized: false
	      });
	      this.markers.push(marker);
	      this.result.end = end;
	
	      this.result.wayPoints = [];
	
	      var _loop = function _loop() {
	
	        var wayPoint = legs[i].start_location;
	
	        _this4.result.wayPoints.push(wayPoint);
	        var marker2 = new _this4.google.maps.Marker({
	          position: wayPoint,
	          icon: '/static/pins/pin-waypoint.png',
	          map: _this4.map
	        });
	
	        var infowindow = new google.maps.InfoWindow({
	          content: '<div>' + legs[i].start_address + '</div>'
	        });
	
	        marker2.addListener('click', function () {
	          infowindow.open(this.map, marker2);
	        });
	
	        _this4.markers.push(marker2);
	      };
	
	      for (var i = 1; i < legs.length; i++) {
	        _loop();
	      }
	    },
	    updateNewDirections: function updateNewDirections() {
	      var _this5 = this;
	
	      try {
	        this.loading = new _promise2.default(function (resolve, reject) {});
	        var _vm = this;
	        this.reset();
	
	        var tolls = _vm.discoveryTolls(_vm.directionsDisplay.getDirections());
	
	        _toll2.default.getPriceTolls({ tolls: tolls.tolls, axes: this.axes }).then(function (r) {
	          tolls.tolls = r.tolls;
	          _vm.putPin(tolls.tolls);
	          _this5.result.tolls = tolls.tolls;
	          _this5.result.totaltollFeeCost = r.totalValue;
	          _this5.result.totalDistance = Math.round(tolls.totalRoute / 1000);
	          _this5.result.totalTime = tolls.totalDuration;
	          _vm.setRouteMarkers(_vm.directionsDisplay.getDirections());
	          _vm.showSummary = true;
	          _this5.afterUpdateDirections();
	        });
	      } catch (err) {}
	      this.loading = _promise2.default.reject(false);
	    },
	    cleanMarkers: function cleanMarkers() {
	      for (var i = 0; i < this.markers.length; i++) {
	        this.markers[i].setMap(null);
	      }
	      this.markers = [];
	    },
	    reset: function reset() {
	      this.cleanMarkers();
	    },
	    calculate: function calculate() {
	
	      this.msgError = undefined;
	      this.loading = new _promise2.default(function (resolve, reject) {});
	
	      var origin = document.getElementById('origin').value;
	      var destination = document.getElementById('destination').value;
	
	      var vm = this;
	      var req = {
	        origin: origin,
	        destination: destination,
	        travelMode: this.google.maps.TravelMode.DRIVING
	      };
	
	      if (this.qtdWayPoints > 0) {
	        req.waypoints = [];
	        for (var i = 0; i < this.qtdWayPoints; i++) {
	          req.waypoints.push({ location: document.getElementById('waypoint' + i).value });
	        }
	      }
	
	      vm.directionsService.route(req, function (result, status) {
	
	        if (status === this.google.maps.DirectionsStatus.OK) {
	          vm.directionsDisplay.setDirections(result);
	        } else {
	          this.msgError = "Não foi possível calcular a rota, tente especificar melhor a origem, o destino e os pontos de passagem (se existirem).";
	          this.loading = _promise2.default.reject(false);
	        }
	      });
	    },
	    showSavedRoute: function showSavedRoute(points) {
	
	      var rota = new google.maps.Polyline({
	        path: points,
	        geodesic: true,
	        strokeColor: '#FF0000',
	        strokeOpacity: 0.6,
	        strokeWeight: 2
	      });
	
	      rota.setMap(vm.map);
	    },
	    discoveryTolls: function discoveryTolls(result) {
	      var pointsLeg = [];
	      var pointsGoogle = [];
	      var legs = result.routes[0].legs;
	
	      var totalRoute = 0;
	      var totalDuration = 0;
	
	      for (var i = 0; i < legs.length; i++) {
	        pointsLeg[i] = [];
	        totalRoute += legs[i].distance.value;
	        totalDuration += legs[i].duration.value;
	        for (var j = 0; j < legs[i].steps.length; j++) {
	          for (var k = 0; k < legs[i].steps[j].path.length; k++) {
	            var p = legs[i].steps[j].path[k];
	            pointsLeg[i].push([p.lng(), p.lat()]);
	            p.y = p.lat();
	            p.x = p.lng();
	            pointsGoogle.push(p);
	          }
	        }
	      }
	
	      var tollsDirection = [];
	      var totalTolls = 0;
	
	      for (var leg = 0; leg < pointsLeg.length; leg++) {
	        var points = pointsLeg[leg];
	        var line = _turf2.default.lineString(points);
	
	        var tolls = [];
	        var all = this.all;
	        for (var i = 0; i < all.length; i++) {
	          var _p = _turf2.default.point([all[i].lng, all[i].lat]);
	          var d = (0, _pointToLineDistance2.default)(_p, line, { units: 'kilometers' });
	
	          if (d * 1000 < all[i].radius) {
	
	            all[i].dist = d;
	            tolls.push(all[i]);
	          }
	        }
	
	        for (var i = 0; i < tolls.length; i++) {
	
	          var _p2 = 0;
	          var menorDistancia = 200;
	          for (var _j = 1; _j < points.length; _j++) {
	            var auxD = _turf2.default.distance(this.toTurfPoint(tolls[i]), points[_j]);
	            if (auxD < menorDistancia) {
	              _p2 = _j;
	              menorDistancia = auxD;
	            }
	          }
	
	          var pontoAntesDoPedagio = points[_p2 - 1];
	          var direction = tolls[i].direction;
	
	          var angle = _turf2.default.bearing(pontoAntesDoPedagio, _turf2.default.pointOnLine(line, this.toTurfPoint(tolls[i])));
	
	          if (direction == "A" || direction == "N" && angle >= -90 && angle <= 90 || direction == "S" && (angle <= -90 || angle >= 90) || direction == "L" && angle >= 0 && angle <= 180 || direction == "O" && angle >= -180 && angle <= 0) {
	
	            tolls[i].angle = angle;
	            tolls[i].distanciaPedagioPontoAnterior = _turf2.default.distance(this.toTurfPoint(tolls[i]), pontoAntesDoPedagio);
	
	
	            tollsDirection.push(tolls[i]);
	          }
	        }
	      }
	
	      return { tolls: tollsDirection, totalRoute: totalRoute, totalDuration: totalDuration };
	    },
	    toTurfPoint: function toTurfPoint(obj) {
	      return [obj.lng, obj.lat];
	    },
	    addWayPoint: function addWayPoint() {
	      var options = {
	        types: ['geocode'],
	        componentRestrictions: { country: 'br' },
	        suppressMarkers: true
	      };
	
	      if (this.qtdWayPoints < 20) {
	        var i = this.qtdWayPoints++;
	
	        if (!this.wayPoints[i]) {
	
	          this.wayPoints[i] = new google.maps.places.Autocomplete(document.getElementById('waypoint' + i), options);
	        }
	      }
	    },
	    removeWayPoint: function removeWayPoint() {
	      if (this.qtdWayPoints > 0) this.qtdWayPoints--;
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _googleMaps = __webpack_require__(93);
	
	var _googleMaps2 = _interopRequireDefault(_googleMaps);
	
	var _turf = __webpack_require__(223);
	
	var _turf2 = _interopRequireDefault(_turf);
	
	var _pointToLineDistance = __webpack_require__(166);
	
	var _pointToLineDistance2 = _interopRequireDefault(_pointToLineDistance);
	
	var _simplifyJs = __webpack_require__(146);
	
	var _simplifyJs2 = _interopRequireDefault(_simplifyJs);
	
	var _toll = __webpack_require__(26);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	var _route = __webpack_require__(59);
	
	var _route2 = _interopRequireDefault(_route);
	
	var _number = __webpack_require__(24);
	
	var _routingMixin = __webpack_require__(236);
	
	var _routingMixin2 = _interopRequireDefault(_routingMixin);
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    mixins: [_routingMixin2.default],
	    data: function data() {
	        return {
	            axesOp: _constantes2.default.Axes
	        };
	    },
	    mounted: function mounted() {}
	};
	
	
	var all2 = [{
	    "i": "6gy6fdne77b3",
	    "h": "S",
	    "s": "Sorocaba , SP - Rod. Sen. José Ermirio de Moraes (SP 75) - Km 12",
	    "r": 50,
	    "p": 6.2,
	    "lat": -23.41141495960481,
	    "lng": -47.341834511607885,
	    "corrected": true
	}, {
	    "i": "6gy6gdgwrrpt",
	    "h": "L",
	    "s": "Itú , SP - Rod. Pres. Castelo Branco (SP 280) - Km 74",
	    "r": 50,
	    "p": 11,
	    "lat": -23.406328780124117,
	    "lng": -47.301602717489004,
	    "corrected": true
	}, {
	    "i": "6gyecd0t0ubp",
	    "h": "A",
	    "s": "Itupeva, SP - Rod. Dom Gabriel Paulino Bueno Couto (SP 300) - Km 76",
	    "r": 100,
	    "p": 7,
	    "lat": -23.235377011038008,
	    "lng": -47.04267231747508,
	    "corrected": true
	}, {
	    "i": "6gyvxt4pgv00",
	    "h": "A",
	    "s": "Vargem, SP - Rod. Fernão Dias (BR 381) - Km 7",
	    "r": 1000,
	    "p": 2.1,
	    "lat": -22.910656582249107,
	    "lng": -46.42533240839839,
	    "corrected": true
	}, {
	    "i": "6gvuununc480",
	    "h": "A",
	    "s": "Conchas, SP - Rod. Mal. Rondon (SP 300) - Km 192",
	    "r": 200,
	    "p": 6.5,
	    "lat": -23.03302102579438,
	    "lng": -47.982712145894766,
	    "corrected": true
	}, {
	    "i": "6gyhv7ud5vxt",
	    "h": "A",
	    "s": "Rafard, SP - Rod. Bento Antônio de Moraes (SP 101) - Km 55",
	    "r": 300,
	    "p": 4.8,
	    "lat": -23.05083578341415,
	    "lng": -47.57543010637164,
	    "corrected": true
	}, {
	    "i": "6gyjdm7e7zrc",
	    "h": "A",
	    "s": "Rio das Pedras, SP - Rod. Cornelio Pires (SP 127) - Km 58",
	    "r": 100,
	    "p": 9.4,
	    "lat": -22.910351122908658,
	    "lng": -47.70872248336673,
	    "corrected": true
	}, {
	    "i": "6gyjvzq9ukzf",
	    "h": "A",
	    "s": "Rio das Pedras, SP - Rod. do Açúcar (SP 308) - Km 147",
	    "r": 300,
	    "p": 6,
	    "lat": -22.855716922224104,
	    "lng": -47.551421988755465,
	    "corrected": true
	}, {
	    "i": "6gym62vt8hbm",
	    "h": "A",
	    "s": "Monte Mor, SP - Rod. Jorn. Francisco Aguirra Proença (SP 101) - Km 29",
	    "r": 300,
	    "p": 6.7,
	    "lat": -22.97891024332611,
	    "lng": -47.35442781820893,
	    "corrected": true
	}, {
	    "i": "6gypnevu8ezz",
	    "h": "A",
	    "s": "Iracemápolis, SP - Rod. Dep. Laércio Corte (SP 147) - Km 127",
	    "r": 100,
	    "p": 5.6,
	    "lat": -22.65437473017591,
	    "lng": -47.51881504431367,
	    "corrected": true
	}, {
	    "i": "6gysufutjh2k",
	    "h": "A",
	    "s": "Louveira, SP - Rod. Romildo Prado (SP 063) - Km 10",
	    "r": 200,
	    "p": 1.8,
	    "lat": -23.05528341698146,
	    "lng": -46.894250605255365,
	    "corrected": true
	}, {
	    "i": "6gyswngnvmr7",
	    "h": "A",
	    "s": "Jundiaí, SP - Rod. Eng. Constâncio Cintra (SP-360) - Km 77",
	    "r": 100,
	    "p": 3.4,
	    "lat": -23.077001982526102,
	    "lng": -46.84134537354112,
	    "corrected": true
	}, {
	    "i": "6gzhj0u3bkp9",
	    "h": "A",
	    "s": "Igaratá, SP - Rod. Dom Pedro I (SP 065) - Km 26",
	    "r": 200,
	    "p": 8.9,
	    "lat": -23.198517216372636,
	    "lng": -46.181280221790075,
	    "corrected": true
	}, {
	    "i": "6ung1rsubqum",
	    "h": "A",
	    "s": "Águas da Prata, SP - Rod. Dr. Gov. Adhemar Pereira de Barros (SP 342) - Km 240",
	    "r": 100,
	    "p": 4.1,
	    "lat": -21.930633298476614,
	    "lng": -46.69628446921706,
	    "corrected": true
	}, {
	    "i": "6gy40b35rcbj",
	    "h": "A",
	    "s": "Sarapuí, SP - Rod. Raposo Tavares (SP 270) - Km 135",
	    "r": 100,
	    "p": 7.8,
	    "lat": -23.552781651800345,
	    "lng": -47.77784300968051,
	    "corrected": true
	}, {
	    "i": "6gy4m8j3rx2h",
	    "h": "A",
	    "s": "Araçoiaba, SP - Rod. Raposo Tavares (SP 270) - Km 111",
	    "r": 50,
	    "p": 3.7,
	    "lat": -23.51038958230081,
	    "lng": -47.56331054493785,
	    "corrected": true
	}, {
	    "i": "6gy6k0hxedxx",
	    "h": "L",
	    "s": "Alumínio , SP - Rod. Raposo Tavares (SP 270) - Km 78",
	    "r": 50,
	    "p": 8.4,
	    "lat": -23.509428990774378,
	    "lng": -47.278765719383955,
	    "corrected": true
	}, {
	    "i": "6gy9c2pdqh00",
	    "h": "O",
	    "s": "São Roque , SP - Rod. Raposo Tavares (SP 270) - Km 46",
	    "r": 50,
	    "p": 8.8,
	    "lat": -23.598223496717193,
	    "lng": -47.043886352330446,
	    "corrected": true
	}, {
	    "i": "6gydx67qnrbh",
	    "h": "N",
	    "s": "São Paulo, SP - Rodo Anel Mário Covas (SP 021) - Km 6",
	    "r": 20,
	    "p": 2,
	    "lat": -23.453358807445202,
	    "lng": -46.78609622642398,
	    "corrected": true
	}, {
	    "i": "6gydxyww7tb5",
	    "h": "N",
	    "s": "São Paulo, SP - Rodo Anel Mário Covas (SP 021) - Km 3",
	    "r": 20,
	    "p": 2,
	    "lat": -23.427054001741965,
	    "lng": -46.7602196149528,
	    "corrected": true
	}, {
	    "i": "6gz4vxp9phxg",
	    "h": "A",
	    "s": "Guararema, SP - Rod. Ayrton Senna da Silva (SP 070) - Km 57",
	    "r": 100,
	    "p": 3.4,
	    "lat": -23.38425103317745,
	    "lng": -46.153913307935,
	    "corrected": true
	}, {
	    "i": "6gz5jz65rb0j",
	    "h": "A",
	    "s": "Guararema, SP - Rod. Pres. Dutra (BR 116) - Km 180",
	    "r": 200,
	    "p": 3.5,
	    "lat": -23.33887169928685,
	    "lng": -46.15000767633319,
	    "corrected": true
	}, {
	    "i": "6gz72tvqhgb0",
	    "h": "L",
	    "s": "Jacareí, SP - BR-116 (BR-116) - Km 167",
	    "r": 10,
	    "p": 6.3,
	    "lat": -23.30242361234012,
	    "lng": -46.025350000709295,
	    "corrected": true
	}, {
	    "i": "6gz72wj01hpf",
	    "h": "O",
	    "s": "Jacareí, SP - BR-116 (BR-116) - Km 167",
	    "r": 10,
	    "p": 6.3,
	    "lat": -23.302078613461113,
	    "lng": -46.02582575753331,
	    "corrected": true
	}, {
	    "i": "6gz73p42mnrf",
	    "h": "A",
	    "s": "Jacareí, SP - Rod. Pres. Dutra (BR 116) - Km 165",
	    "r": 200,
	    "p": 6.3,
	    "lat": -23.296459025851174,
	    "lng": -46.00747274234891,
	    "corrected": true
	}, {
	    "i": "6gz7s3m58fze",
	    "h": "A",
	    "s": "São José dos Campos, SP - Rod. Gov. Carvalho Pinto (SP 070) - Km 92",
	    "r": 50,
	    "p": 3.4,
	    "lat": -23.28353547998969,
	    "lng": -45.860801842063665,
	    "corrected": true
	}, {
	    "i": "6gznysmkzjrw",
	    "h": "A",
	    "s": "Cambuí, MG - Rod. Fernão Dias (BR-381) - Km 904",
	    "r": 300,
	    "p": 2.1,
	    "lat": -22.69575867752636,
	    "lng": -46.11295094713569,
	    "corrected": true
	}, {
	    "i": "6gzs20eg8085",
	    "h": "A",
	    "s": "Caçapava, SP - Rod. Gov. Carvalho Pinto (SP 070) - Km 114",
	    "r": 100,
	    "p": 2.6,
	    "lat": -23.155875878111043,
	    "lng": -45.697979014366865,
	    "corrected": true
	}, {
	    "i": "6gztxc9q60b6",
	    "h": "A",
	    "s": "Pindamonhangaba, SP - Rod. Pres. Dutra (BR 116) - Km 88",
	    "r": 200,
	    "p": 14.4,
	    "lat": -22.930200279701186,
	    "lng": -45.3607458807528,
	    "corrected": true
	}, {
	    "i": "6upd8rz9s48j",
	    "h": "A",
	    "s": "Careaçu, MG - Rod. Fernão Dias (BR-381) - Km 805",
	    "r": 200,
	    "p": 2.1,
	    "lat": -22.017951687209926,
	    "lng": -45.681441854685545,
	    "corrected": true
	}, {
	    "i": "6upvenswmhb1",
	    "h": "A",
	    "s": "Carmo da Cachoeira, MG - Rod. Fernão Dias (BR-381) - Km 723",
	    "r": 500,
	    "p": 2.1,
	    "lat": -21.496798243783854,
	    "lng": -45.21092874929309,
	    "corrected": true
	}, {
	    "i": "6gz7qr07zt01",
	    "h": "A",
	    "s": "Jambeiro, SP - Rod. dos Tamoios (SP-099) - Km 59",
	    "r": 200,
	    "p": 3.7,
	    "lat": -23.29578871449806,
	    "lng": -45.77930426225066,
	    "corrected": true
	}, {
	    "i": "6gydx65h8gxz",
	    "h": "S",
	    "s": "São Paulo, SP - Rodo Anel Mário Covas (SP 021) - Km 7",
	    "r": 30,
	    "p": 2,
	    "lat": -23.456101306345523,
	    "lng": -46.78540823981166,
	    "corrected": true
	}, {
	    "i": "6gydx7m10680",
	    "h": "O",
	    "s": "São Paulo, SP - Rodo Anel Mário Covas (SP 021) - Km 6",
	    "r": 30,
	    "p": 2,
	    "lat": -23.448294477176166,
	    "lng": -46.78321922197938,
	    "corrected": true
	}, {
	    "i": "6gydxvpnmvbp",
	    "h": "S",
	    "s": "São Paulo, SP - Rodo Anel Mário Covas (SP 021) - Km 3",
	    "r": 20,
	    "p": 2,
	    "lat": -23.43938576171758,
	    "lng": -46.758316587656736,
	    "corrected": true
	}, {
	    "i": "6gydz09z0nu0",
	    "h": "L",
	    "s": "São Paulo, SP - Rod. Anhangüera (SP 330) - Km 26",
	    "r": 50,
	    "p": 8.9,
	    "lat": -23.418951970591507,
	    "lng": -46.79949251934886,
	    "corrected": true
	}, {
	    "i": "6gydz0f57v81",
	    "h": "O",
	    "s": "São Paulo, SP - Rod. Anhangüera (SP 330) - Km 26",
	    "r": 50,
	    "p": 8.9,
	    "lat": -23.418343397125895,
	    "lng": -46.799059342592955,
	    "corrected": true
	}, {
	    "i": "6gyentz8ddxc",
	    "h": "S",
	    "s": "Caieiras, SP - Rod. dos Bandeirantes (SP 348) - Km 36",
	    "r": 50,
	    "p": 8.9,
	    "lat": -23.347094240007312,
	    "lng": -46.81328343227506,
	    "corrected": true
	}, {
	    "i": "6gyeqd0qkh2m",
	    "h": "N",
	    "s": "Franco da Rocha, SP - Rod. dos Bandeirantes (SP 348) - Km 39",
	    "r": 50,
	    "p": 8.9,
	    "lat": -23.322792414268974,
	    "lng": -46.82331891730428,
	    "corrected": true
	}, {
	    "i": "6gyfb3nd1ypv",
	    "h": "L",
	    "s": "São Paulo, SP - Rodo Anel Mário Covas (SP 021) - Km 0",
	    "r": 50,
	    "p": 2,
	    "lat": -23.416819214007056,
	    "lng": -46.737560983747244,
	    "corrected": true
	}, {
	    "i": "6gygk16bhcu2",
	    "h": "A",
	    "s": "Mairiporã, SP - Rod. Fernão Dias (BR 381) - Km 65",
	    "r": 50,
	    "p": 2.1,
	    "lat": -23.330405084636176,
	    "lng": -46.57772848382592,
	    "corrected": true
	}, {
	    "i": "6gyudgzcm2ry",
	    "h": "A",
	    "s": "Atibaia, SP - Rod. Dom Pedro I (SP 065) - Km 79",
	    "r": 150,
	    "p": 7,
	    "lat": -23.094403198755554,
	    "lng": -46.62611486390233,
	    "corrected": true
	}, {
	    "i": "6un7yn54mqxc",
	    "h": "A",
	    "s": "Sta. Cruz das Palmeiras, SP - SP-215 (SP-215) - Km 65",
	    "r": 100,
	    "p": 5.9,
	    "lat": -21.808027048314077,
	    "lng": -47.19329612329602,
	    "corrected": true
	}, {
	    "i": "6un8hxyggvry",
	    "h": "A",
	    "s": "Mogi Mirim, SP - SP 147 - Km 52",
	    "r": 100,
	    "p": 7.3,
	    "lat": -22.456747868925238,
	    "lng": -46.90218022093177,
	    "corrected": true
	}, {
	    "i": "6un9ftjxdr25",
	    "h": "A",
	    "s": "Mogi Guaçu, SP - Rod. Dep. Mário Beni (SP 340) - Km 192",
	    "r": 100,
	    "p": 6.9,
	    "lat": -22.163545340694256,
	    "lng": -46.991703640669584,
	    "corrected": true
	}, {
	    "i": "6un9qtpdbm80",
	    "h": "A",
	    "s": "Espírito Santo do Pinhal, SP - Rod. Dr. Gov. Adhemar Pereira de Barros (SP 342) - Km 191",
	    "r": 100,
	    "p": 8.6,
	    "lat": -22.252309683960956,
	    "lng": -46.813433300703764,
	    "corrected": true
	}, {
	    "i": "6undvbkrjjrd",
	    "h": "A",
	    "s": "São João da Boa Vista, SP - SP 344 - Km 219",
	    "r": 100,
	    "p": 4.4,
	    "lat": -22.013966354696745,
	    "lng": -46.85067242011428,
	    "corrected": true
	}, {
	    "i": "6une33f55xry",
	    "h": "A",
	    "s": "Casa Branca, SP - Rod. Prof. Boanerges Nogueira de Lima (SP 340) - Km 221",
	    "r": 200,
	    "p": 6.2,
	    "lat": -21.918597677762016,
	    "lng": -47.05175595358014,
	    "corrected": true
	}, {
	    "i": "6unenh7j9egw",
	    "h": "N",
	    "s": "São João da Boa Vista, SP - Rod. Dom Tomás Vaquero (SP 344) - Km 230",
	    "r": 100,
	    "p": 4.8,
	    "lat": -21.948300800387443,
	    "lng": -46.84152474626899,
	    "corrected": true
	}, {
	    "i": "6ur738zx70b4",
	    "h": "A",
	    "s": "Piumhi, MG - MG 050 - Km 270",
	    "r": 1000,
	    "p": 5.1,
	    "lat": -20.517079516709682,
	    "lng": -45.978392232209444,
	    "corrected": true
	}, {
	    "i": "6ure6q1c9t2r",
	    "h": "A",
	    "s": "Córrego Fundo, MG - MG 050 - Km 219",
	    "r": 1000,
	    "p": 5.1,
	    "lat": -20.48924581903651,
	    "lng": -45.60175912454724,
	    "corrected": true
	}, {
	    "i": "75cmfg5zneb5",
	    "h": "L",
	    "s": "Niterói, RJ - Ponte Pres. Costa e Silva (BR 101) - Km 322",
	    "r": 100,
	    "p": 4.1,
	    "lat": -22.877872401284193,
	    "lng": -43.11579896137118,
	    "corrected": true
	}, {
	    "i": "75cpr00x5mxu",
	    "h": "A",
	    "s": "Duque de Caxias, RJ - Rod. Washington Luiz (BR 040) - Km 104",
	    "r": 70,
	    "p": 12.4,
	    "lat": -22.630524827029106,
	    "lng": -43.28530551865697,
	    "corrected": true
	}, {
	    "i": "75cqqvcs1fxf",
	    "h": "O",
	    "s": "São Gonçalo, RJ - BR 101 - Km 299",
	    "r": 100,
	    "p": 5,
	    "lat": -22.775201181891227,
	    "lng": -42.94532446190715,
	    "corrected": true
	}, {
	    "i": "75cr1jpmqrxv",
	    "h": "A",
	    "s": "Eng. Pierre Berman, RJ - Rod. Pres. Dutra (BR 116) - Km 133",
	    "r": 100,
	    "p": 17.1,
	    "lat": -22.647266610516766,
	    "lng": -43.187958765774965,
	    "corrected": true
	}, {
	    "i": "75cr5e3d93re",
	    "h": "A",
	    "s": "Santa Guilhermina, RJ - Rod. Pres Dutra (BR 116) - Km 122",
	    "r": 100,
	    "p": 12,
	    "lat": -22.65741033923584,
	    "lng": -43.086258452385664,
	    "corrected": true
	}, {
	    "i": "75crkgbfbqg3",
	    "h": "S",
	    "s": "Santo Aleixo, RJ - Rod. Pres. Dutra (BR 116) - Km 114",
	    "r": 10,
	    "p": 8.5,
	    "lat": -22.61066923600668,
	    "lng": -43.03237086161971,
	    "corrected": true
	}, {
	    "i": "75crkgc68gf9",
	    "h": "N",
	    "s": "Santo Aleixo, RJ - Rod. Pres. Dutra (BR 116) - Km 114",
	    "r": 10,
	    "p": 12,
	    "lat": -22.610858856190994,
	    "lng": -43.0317566357553,
	    "corrected": true
	}, {
	    "i": "75cwcb9xpjpe",
	    "h": "A",
	    "s": "Itaboraí, RJ - Rod. Tanguá (RJ 116) - Km 1",
	    "r": 100,
	    "p": 5.6,
	    "lat": -22.715638986431927,
	    "lng": -42.8113722614944,
	    "corrected": true
	}, {
	    "i": "7h11svhpy7zs",
	    "h": "A",
	    "s": "Paraíba do Sul, RJ - BR 393 - Km 195",
	    "r": 300,
	    "p": 6.9,
	    "lat": -22.207561654196237,
	    "lng": -43.37920596823096,
	    "corrected": true
	}, {
	    "i": "7h134z2f9r2p",
	    "h": "A",
	    "s": "Petrópolis, RJ - Rod. Washington Luiz (BR 040) - Km 45",
	    "r": 60,
	    "p": 12.4,
	    "lat": -22.283865062857075,
	    "lng": -43.120307084172964,
	    "corrected": true
	}, {
	    "i": "7h15q244mz02",
	    "h": "A",
	    "s": "Simão Pereira, MG - BR 040 - Km 816",
	    "r": 100,
	    "p": 12.4,
	    "lat": -21.928309458063758,
	    "lng": -43.3162615634501,
	    "corrected": true
	}, {
	    "i": "7h1e0dqbfwbk",
	    "h": "A",
	    "s": "Sapucaia, RJ - BR 393 - Km 125",
	    "r": 300,
	    "p": 6.9,
	    "lat": -21.960169789369896,
	    "lng": -42.85925505682826,
	    "corrected": true
	}, {
	    "i": "7h208c00ekrg",
	    "h": "A",
	    "s": "Sto. Antônio do Amparo, MG - Rod. Fernão Dias (BR 381) - Km 648",
	    "r": 500,
	    "p": 2.1,
	    "lat": -21.000332116326007,
	    "lng": -44.96680514886975,
	    "corrected": true
	}, {
	    "i": "6gvfkrrnm08p",
	    "h": "S",
	    "s": "Itapetininga, SP - Rod. Antônio Romano Schincariol (SP 127) - Km 133",
	    "r": 200,
	    "p": 10.2,
	    "lat": -23.470479603852922,
	    "lng": -47.967579793184996,
	    "corrected": true
	}, {
	    "i": "6gvftjeykpb2",
	    "h": "N",
	    "s": "Tatuí, SP - Rod. Antônio Romano Schincariol (SP 127) - Km 128",
	    "r": 200,
	    "p": 10.2,
	    "lat": -23.43479070709944,
	    "lng": -47.93826291337609,
	    "corrected": true
	}, {
	    "i": "6gvgcb31xfrd",
	    "h": "A",
	    "s": "Quadra, SP - Rod. Pres. Castelo Branco (SP 280) - Km 158",
	    "r": 200,
	    "p": 12.5,
	    "lat": -23.245880502932163,
	    "lng": -48.085774686187506,
	    "corrected": true
	}, {
	    "i": "6gy57gg5b4hw",
	    "h": "A",
	    "s": "Boituva, SP - Rod. Pres. Castelo Branco (SP 280) - Km 111",
	    "r": 50,
	    "p": 9.1,
	    "lat": -23.31364198010932,
	    "lng": -47.64353608712554,
	    "corrected": true
	}, {
	    "i": "6gy5k514bhrg",
	    "h": "A",
	    "s": "Boituva, SP - Rod. Pres. Castelo Branco (SP-280) - Km 110",
	    "r": 10,
	    "p": 9.1,
	    "lat": -23.317960128127538,
	    "lng": -47.6353201456368,
	    "corrected": true
	}, {
	    "i": "6gy5k51p3b8r",
	    "h": "A",
	    "s": "Boituva, SP - Rod. Pres. Castelo Branco (SP-280) - Km 110",
	    "r": 10,
	    "p": 9.1,
	    "lat": -23.317260055437824,
	    "lng": -47.63522693887353,
	    "corrected": true
	}, {
	    "i": "6gy5vetcnsb2",
	    "h": "A",
	    "s": "Porto Feliz, SP - Rod. Dom Gabriel Paulino Bueno Couto (SP 300) - Km 136",
	    "r": 100,
	    "p": 7.2,
	    "lat": -23.227568138382026,
	    "lng": -47.562662456184626,
	    "corrected": true
	}, {
	    "i": "6gyk6k2yxdpc",
	    "h": "A",
	    "s": "Salto, SP - Rod. do Açúcar (SP 308) - Km 109",
	    "r": 200,
	    "p": 3.3,
	    "lat": -23.134642831569845,
	    "lng": -47.360746432095766,
	    "corrected": true
	}, {
	    "i": "6gykycqzkdu3",
	    "h": "A",
	    "s": "Indaiatuba, SP - Rod. Eng. Ermênio de Oliveira Penteado (SP 075) - Km 60",
	    "r": 100,
	    "p": 12.8,
	    "lat": -23.063135912704254,
	    "lng": -47.15480709448457,
	    "corrected": true
	}, {
	    "i": "6gykz4ufjzk5",
	    "h": "A",
	    "s": "Indaiatuba, SP - Rod. Eng. Ermênio de Oliveira Penteado (SP-075) - Km 62",
	    "r": 20,
	    "p": 12.8,
	    "lat": -23.05571121305602,
	    "lng": -47.14653415605426,
	    "corrected": true
	}, {
	    "i": "6gykz4uw8w4m",
	    "h": "A",
	    "s": "Indaiatuba, SP - Rod. Eng. Ermênio de Oliveira Penteado (SP-075) - Km 62",
	    "r": 20,
	    "p": 12.8,
	    "lat": -23.055106759210197,
	    "lng": -47.147040758281946,
	    "corrected": true
	}, {
	    "i": "6gyqyvqsr7ps",
	    "h": "A",
	    "s": "Cosmópolis, SP - Rod. Gen Milton Tavares de Souza (SP 332) - Km 135",
	    "r": 200,
	    "p": 8,
	    "lat": -22.690225179682372,
	    "lng": -47.15501328930259,
	    "corrected": true
	}, {
	    "i": "6gyqz1pwycgx",
	    "h": "N",
	    "s": "Paulínia, SP - Rod. Gen Milton Tavares de Souza (SP 332) - Km 132",
	    "r": 10,
	    "p": 11.1,
	    "lat": -22.713009606629257,
	    "lng": -47.142709996551275,
	    "corrected": true
	}, {
	    "i": "6gyryj74xzr8",
	    "h": "A",
	    "s": "Engenheiro Coelho, SP - Rod. Gen. Milton Tavares de Souza (SP 332) - Km 159",
	    "r": 200,
	    "p": 5.4,
	    "lat": -22.514571171919826,
	    "lng": -47.192810978740454,
	    "corrected": true
	}, {
	    "i": "6gysc6qut7re",
	    "h": "S",
	    "s": "Itupeva, SP - Rod. dos Bandeirantes (SP 348) - Km 77",
	    "r": 50,
	    "p": 8.8,
	    "lat": -23.05799950842299,
	    "lng": -47.04472353681922,
	    "corrected": true
	}, {
	    "i": "6gysc6rr4xpc",
	    "h": "N",
	    "s": "Itupeva, SP - Rod. dos Bandeirantes (SP 348) - Km 77",
	    "r": 50,
	    "p": 8.8,
	    "lat": -23.05758142237664,
	    "lng": -47.0442739315331,
	    "corrected": true
	}, {
	    "i": "6gyscd9s3qry",
	    "h": "A",
	    "s": "Vinhedo, SP - Miguel Melhado Campos (SP-324) - Km 81",
	    "r": 50,
	    "p": 5.5,
	    "lat": -23.056688628936598,
	    "lng": -47.04125074669719,
	    "corrected": true
	}, {
	    "i": "6gyt1fwu4p7c",
	    "h": "N",
	    "s": "Valinhos, SP - Rod. Anhangüera (SP 330) - Km 82",
	    "r": 50,
	    "p": 8.8,
	    "lat": -23.012825800819083,
	    "lng": -47.0230764336884,
	    "corrected": true
	}, {
	    "i": "6gyt413cnbzg",
	    "h": "S",
	    "s": "Valinhos, SP - Rod. Anhangüera (SP 330) - Km 82",
	    "r": 50,
	    "p": 8.8,
	    "lat": -23.02021832487281,
	    "lng": -47.01867224648595,
	    "corrected": true
	}, {
	    "i": "6gytmtmsr00h",
	    "h": "A",
	    "s": "Itatiba, SP - Rod. Dom Pedro I (SP 065) - Km 110",
	    "r": 100,
	    "p": 9.5,
	    "lat": -22.9539031058327,
	    "lng": -46.85977382585406,
	    "corrected": true
	}, {
	    "i": "6gyw3yxkgg86",
	    "h": "A",
	    "s": "Campinas, SP - Rod. Dr. Gov. Adhemar Pereira de Barros (SP 340) - Km 123",
	    "r": 100,
	    "p": 11.6,
	    "lat": -22.771081981302935,
	    "lng": -47.02198812738061,
	    "corrected": true
	}, {
	    "i": "6ujsjzcjrbpu",
	    "h": "A",
	    "s": "Araraquara , SP - Rod. Washington Luiz (SP 310) - Km 282",
	    "r": 100,
	    "p": 15.7,
	    "lat": -21.75317928473464,
	    "lng": -48.261619973927736,
	    "corrected": true
	}, {
	    "i": "6ujswpe78f6h",
	    "h": "A",
	    "s": "Araraquara, SP - ARA 080",
	    "r": 50,
	    "p": 1.5,
	    "lat": -21.667155802877936,
	    "lng": -48.24747635051608,
	    "corrected": true
	}, {
	    "i": "6ujtk5t4p9b7",
	    "h": "A",
	    "s": "Dobrada, SP - Rod. Brg. Faria Lima (SP 326) - Km 307",
	    "r": 50,
	    "p": 8.2,
	    "lat": -21.557564076891673,
	    "lng": -48.33270588889718,
	    "corrected": true
	}, {
	    "i": "6ujvkbvqr723",
	    "h": "A",
	    "s": "Guatapará, SP - Rod. Antônio Machado Sant'ana (SP 255) - Km 45",
	    "r": 300,
	    "p": 14,
	    "lat": -21.5719230290017,
	    "lng": -47.948759738355875,
	    "corrected": true
	}, {
	    "i": "6um6r98xbmp9",
	    "h": "A",
	    "s": "COLINA, SP - Rod. Brg. Faria Lima (SP 326) - Km 407",
	    "r": 100,
	    "p": 8.5,
	    "lat": -20.68863871907686,
	    "lng": -48.536860551685095,
	    "corrected": true
	}, {
	    "i": "6un0xx0vsb02",
	    "h": "A",
	    "s": "Rio Claro, SP - Rod. Wilson Finardi (SP 191) - Km 59",
	    "r": 150,
	    "p": 3.2,
	    "lat": -22.37301560293005,
	    "lng": -47.4817375279963,
	    "corrected": true
	}, {
	    "i": "6un2hccz2erv",
	    "h": "A",
	    "s": "Engenheiro Coelho, SP - Rod. Eng. João Tosello (SP 147) - Km 91",
	    "r": 100,
	    "p": 5.6,
	    "lat": -22.489086578263503,
	    "lng": -47.249772381037474,
	    "corrected": true
	}, {
	    "i": "6un2v846mzxg",
	    "h": "A",
	    "s": "Araras, SP - Rod. Wilson Finardi (SP 191) - Km 27",
	    "r": 150,
	    "p": 6,
	    "lat": -22.36825850783726,
	    "lng": -47.21588300541043,
	    "corrected": true
	}, {
	    "i": "6un33te9cszb",
	    "h": "A",
	    "s": "Leme, SP - Rod. Anhangüera (SP 330) - Km 181",
	    "r": 150,
	    "p": 7.4,
	    "lat": -22.249632039246144,
	    "lng": -47.3900374956429,
	    "corrected": true
	}, {
	    "i": "6urx7zyuk820",
	    "h": "A",
	    "s": "Luz, MG - BR-262 (BR-262) - Km 512",
	    "r": 1000,
	    "p": 4.7,
	    "lat": -19.77584362872386,
	    "lng": -45.5290206335485,
	    "corrected": true
	}, {
	    "i": "6ux0d876ucpg",
	    "h": "A",
	    "s": "Campos Altos, MG - BR-262 (BR-262) - Km 600",
	    "r": 1000,
	    "p": 5,
	    "lat": -19.597762801853033,
	    "lng": -46.29170944914222,
	    "corrected": true
	}, {
	    "i": "75bytp676021",
	    "h": "A",
	    "s": "Viúva Graça, RJ - Estr. Rio São Paulo (BR 465)",
	    "r": 100,
	    "p": 14.4,
	    "lat": -22.723271790142444,
	    "lng": -43.722396958619356,
	    "corrected": true
	}, {
	    "i": "75byv0w7gszu",
	    "h": "A",
	    "s": "Seropédica, RJ - Rod. Pres. Dutra (BR 116) - Km 207",
	    "r": 50,
	    "p": 14.4,
	    "lat": -22.716275376910655,
	    "lng": -43.716836739331484,
	    "corrected": true
	}, {
	    "i": "75cjwmzd83zt",
	    "h": "A",
	    "s": "Rio de Janeiro, RJ - Linha Amarela - Km 6",
	    "r": 70,
	    "p": 5.9,
	    "lat": -22.907326670684288,
	    "lng": -43.30887978896499,
	    "corrected": true
	}, {
	    "i": "7h021bcmtbs3",
	    "h": "A",
	    "s": "Itatiaia, RJ - Rod. Pres. Dutra (BR 116) - Km 318",
	    "r": 30,
	    "p": 14.4,
	    "lat": -22.494862429025698,
	    "lng": -44.569498244673014,
	    "corrected": true
	}, {
	    "i": "7h0b0e8b257e",
	    "h": "A",
	    "s": "Barra do Piraí, RJ - BR 393 - Km 265",
	    "r": 300,
	    "p": 6.9,
	    "lat": -22.480713299143098,
	    "lng": -43.922300320118666,
	    "corrected": true
	}, {
	    "i": "7h18qp4yb1zf",
	    "h": "A",
	    "s": "Cachoeiras de Macacu, RJ - RJ-116 (RJ 116) - Km 48",
	    "r": 30,
	    "p": 5.6,
	    "lat": -22.416474930220495,
	    "lng": -42.62327263131738,
	    "corrected": true
	}, {
	    "i": "7h1c9h4scexz",
	    "h": "A",
	    "s": "Nova Friburgo, RJ - RJ 116 - Km 90",
	    "r": 100,
	    "p": 5.6,
	    "lat": -22.213303080004028,
	    "lng": -42.49153023585677,
	    "corrected": true
	}, {
	    "i": "7h1febc17upt",
	    "h": "A",
	    "s": "Cordeiro, RJ - RJ 116 - Km 122",
	    "r": 100,
	    "p": 5.6,
	    "lat": -22.056203096600022,
	    "lng": -42.37271273508668,
	    "corrected": true
	}, {
	    "i": "7h24yuqmpzrf",
	    "h": "A",
	    "s": "Carmópolis de Minas, MG - Rod. Fernão Dias (BR-381) - Km 585",
	    "r": 500,
	    "p": 2.1,
	    "lat": -20.586133106582327,
	    "lng": -44.69442682340741,
	    "corrected": true
	}, {
	    "i": "7h2j05c5h184",
	    "h": "A",
	    "s": "São Sebastião do Oeste, MG - MG 050 - Km 140",
	    "r": 1000,
	    "p": 5.1,
	    "lat": -20.19364415614778,
	    "lng": -44.998261760920286,
	    "corrected": true
	}, {
	    "i": "7h2ktn67rvzf",
	    "h": "A",
	    "s": "Itatiaiuçu, MG - Rod. Fernão Dias (BR 381) - Km 535",
	    "r": 500,
	    "p": 2.1,
	    "lat": -20.2682658395473,
	    "lng": -44.42380266264081,
	    "corrected": true
	}, {
	    "i": "7h2mfxur1bxf",
	    "h": "A",
	    "s": "Itaúna, MG - MG 050 - Km 81",
	    "r": 1000,
	    "p": 5.1,
	    "lat": -20.039212161396907,
	    "lng": -44.53274058178067,
	    "corrected": true
	}, {
	    "i": "7h2qepx60h04",
	    "h": "A",
	    "s": "Florestal/Pará de Minas, MG - BR-262 (BR-262) - Km 389",
	    "r": 1000,
	    "p": 4.5,
	    "lat": -19.909686754245428,
	    "lng": -44.506516959518194,
	    "corrected": true
	}, {
	    "i": "7h883xqvqe0m",
	    "h": "A",
	    "s": "Capim Branco, MG - BR-040 (BR-040) - Km 487",
	    "r": 1000,
	    "p": 5.3,
	    "lat": -19.602793323297522,
	    "lng": -44.221368972212076,
	    "corrected": true
	}, {
	    "i": "6gvjcewmq900",
	    "h": "A",
	    "s": "Iaras, SP - Rod. Pres. Castelo Branco (SP 280) - Km 278",
	    "r": 200,
	    "p": 8.5,
	    "lat": -22.875083458805136,
	    "lng": -49.14450628682971,
	    "corrected": true
	}, {
	    "i": "6gvm30cj99py",
	    "h": "A",
	    "s": "Avaré, SP - Rod. João Mellão (SP 255) - Km 240",
	    "r": 100,
	    "p": 6.5,
	    "lat": -22.978784807832845,
	    "lng": -48.821182418614626,
	    "corrected": true
	}, {
	    "i": "6gvpzjrszcxu",
	    "h": "A",
	    "s": "Agudos, SP - Rod. Mal. Rondon (SP 300) - Km 314",
	    "r": 300,
	    "p": 5.6,
	    "lat": -22.513394650078936,
	    "lng": -48.9044619910419,
	    "corrected": true
	}, {
	    "i": "6gvr5dpm9fpy",
	    "h": "A",
	    "s": "Areiópolis, SP - Rod. Mal. Rondon (SP 300) - Km 285",
	    "r": 500,
	    "p": 5.7,
	    "lat": -22.663832778086267,
	    "lng": -48.70373921468854,
	    "corrected": true
	}, {
	    "i": "6gvs8n08wsxf",
	    "h": "A",
	    "s": "Itatinga, SP - Rod. Pres. Castelo Branco (SP 280) - Km 208",
	    "r": 250,
	    "p": 12.5,
	    "lat": -23.082633821525487,
	    "lng": -48.51510750129819,
	    "corrected": true
	}, {
	    "i": "6gvtmnwybe00",
	    "h": "A",
	    "s": "Anhembi, SP - Rod. Mal. Rondon (SP 300) - Km 228",
	    "r": 300,
	    "p": 7.3,
	    "lat": -22.94793387895499,
	    "lng": -48.28580779954791,
	    "corrected": true
	}, {
	    "i": "6gvw0428gfrb",
	    "h": "A",
	    "s": "Botucatu, SP - Rod. Mal Rondon (SP 300) - Km 259",
	    "r": 200,
	    "p": 5.1,
	    "lat": -22.83804354602506,
	    "lng": -48.51654516533017,
	    "corrected": true
	}, {
	    "i": "6gymgwusnbb3",
	    "h": "L",
	    "s": "Sumaré, SP - Rod. dos Bandeirantes (SP 348) - Km 115",
	    "r": 50,
	    "p": 7.8,
	    "lat": -22.85768396895499,
	    "lng": -47.3006428219378,
	    "corrected": true
	}, {
	    "i": "6gymgwuy0yxy",
	    "h": "O",
	    "s": "Sumaré, SP - Rod. dos Bandeirantes (SP 348) - Km 115",
	    "r": 50,
	    "p": 7.8,
	    "lat": -22.857414004940576,
	    "lng": -47.30057576671243,
	    "corrected": true
	}, {
	    "i": "6gyptpzw39zx",
	    "h": "A",
	    "s": "Rio Claro, SP - Rod. Cornelio Pires (SP 127) - Km 12",
	    "r": 100,
	    "p": 5.8,
	    "lat": -22.5441607575282,
	    "lng": -47.582409884780645,
	    "corrected": true
	}, {
	    "i": "6gyqmn9kz38p",
	    "h": "S",
	    "s": "Nova Odessa, SP - Rod. Anhangüera (SP 330) - Km 118",
	    "r": 50,
	    "p": 7.8,
	    "lat": -22.77100592982809,
	    "lng": -47.23907304927707,
	    "corrected": true
	}, {
	    "i": "6gyqmn9z3e8p",
	    "h": "N",
	    "s": "Nova Odessa, SP - Rod. Anhangüera (SP 330) - Km 118",
	    "r": 50,
	    "p": 7.8,
	    "lat": -22.77062045687011,
	    "lng": -47.23869754001498,
	    "corrected": true
	}, {
	    "i": "6gyr8jb55brg",
	    "h": "S",
	    "s": "Limeira, SP - Rod. dos Bandeirantes (SP 348) - Km 159",
	    "r": 50,
	    "p": 5.9,
	    "lat": -22.55580473967353,
	    "lng": -47.46066005900502,
	    "corrected": true
	}, {
	    "i": "6gyr8jb7wdb4",
	    "h": "N",
	    "s": "Limeira, SP - Rod. dos Bandeirantes (SP 348) - Km 159",
	    "r": 50,
	    "p": 5.9,
	    "lat": -22.55574220190884,
	    "lng": -47.46037406846881,
	    "corrected": true
	}, {
	    "i": "6gyrbd7yd484",
	    "h": "A",
	    "s": "Limeira, SP - Rod. Cássio de Freitas Levy (SPV-17) - Km 0",
	    "r": 50,
	    "p": 2.15,
	    "lat": -22.53043159903279,
	    "lng": -47.43371861055493,
	    "corrected": true
	}, {
	    "i": "6gyrcqnj9f20",
	    "h": "S",
	    "s": "Limeira, SP - Rod. Anhangüera (SP 330) - Km 152",
	    "r": 50,
	    "p": 5.9,
	    "lat": -22.510021674020177,
	    "lng": -47.3976563103497,
	    "corrected": true
	}, {
	    "i": "6gyrcqnx1d25",
	    "h": "N",
	    "s": "Limeira, SP - Rod. Anhangüera (SP 330) - Km 152",
	    "r": 50,
	    "p": 5.9,
	    "lat": -22.50981168761346,
	    "lng": -47.39711148664355,
	    "corrected": true
	}, {
	    "i": "6uj0308h8w20",
	    "h": "A",
	    "s": "Piratininga, SP - Rod. Eng. João Baptista Cabral Renno (SP 255) - Km 251",
	    "r": 200,
	    "p": 5.5,
	    "lat": -22.452692272369678,
	    "lng": -49.17463084682822,
	    "corrected": true
	}, {
	    "i": "6uj351p4ss0m",
	    "h": "A",
	    "s": "Jaú, SP - Rod. Eng. Paulo Nilo Romano (SP 225) - Km 199",
	    "r": 200,
	    "p": 10.6,
	    "lat": -22.31829638434183,
	    "lng": -48.72549729421735,
	    "corrected": true
	}, {
	    "i": "6uj9qhmvu2b4",
	    "h": "A",
	    "s": "Brotas, SP - Rod. Eng. Paulo Nilo Romano (SP 225) - Km 143",
	    "r": 200,
	    "p": 8.2,
	    "lat": -22.255869591017483,
	    "lng": -48.24385268613696,
	    "corrected": true
	}, {
	    "i": "6ujcmgh915bn",
	    "h": "A",
	    "s": "Brotas, SP - Rod. Eng. Paulo Nilo Romano (SP 225) - Km 106",
	    "r": 100,
	    "p": 7.1,
	    "lat": -22.263764906251577,
	    "lng": -47.9023645631969,
	    "corrected": true
	}, {
	    "i": "6ujcy6v4xs0t",
	    "h": "A",
	    "s": "Itirapina, SP - Rodovia Municipal Ayrton Senna - Km 9,5",
	    "r": 100,
	    "p": 1.5,
	    "lat": -22.176499701580802,
	    "lng": -47.88225939497352,
	    "corrected": true
	}, {
	    "i": "6ujxnrm1jzzg",
	    "h": "A",
	    "s": "Jaboticabal , SP - Rod. Atilio Balbo (SP 333) - Km 110",
	    "r": 200,
	    "p": 12.8,
	    "lat": -21.22948448763365,
	    "lng": -48.233934212476015,
	    "corrected": true
	}, {
	    "i": "6ujzhnmmcx2n",
	    "h": "A",
	    "s": "Dumont, SP - Estr. Municipal Guido Lorenzato (Estr. Municipal Guido Lorenzato) - Km 0",
	    "r": 20,
	    "p": 3,
	    "lat": -21.23435569786425,
	    "lng": -47.980824541300535,
	    "corrected": true
	}, {
	    "i": "6ujztdtu9epb",
	    "h": "A",
	    "s": "Sertãozinho , SP - Rod. Atilio Balbo (SP 322) - Km 327",
	    "r": 100,
	    "p": 6.5,
	    "lat": -21.167021513044535,
	    "lng": -47.91438790038228,
	    "corrected": true
	}, {
	    "i": "6uk8wf0hpcxf",
	    "h": "A",
	    "s": "José Bonifácio, SP - Rod. Transbrasiliana (BR 153) - Km 98",
	    "r": 200,
	    "p": 4.8,
	    "lat": -20.997475872008383,
	    "lng": -49.62785141542554,
	    "corrected": true
	}, {
	    "i": "6ukfvsqchfrv",
	    "h": "A",
	    "s": "Onda Verde , SP - Rod. Transbrasiliana (BR 153) - Km 35",
	    "r": 200,
	    "p": 4.8,
	    "lat": -20.58680934888201,
	    "lng": -49.31904835626483,
	    "corrected": true
	}, {
	    "i": "6um04semts86",
	    "h": "A",
	    "s": "Catiguá , SP - Rod. Washington Luiz (SP 310) - Km 398",
	    "r": 200,
	    "p": 14.9,
	    "lat": -21.068204731212038,
	    "lng": -49.10508284345269,
	    "corrected": true
	}, {
	    "i": "6um25t5t1s04",
	    "h": "A",
	    "s": "PIRANGI , SP - Rod. Comendador Pedro Monteleone (SP 351) - Km 184",
	    "r": 100,
	    "p": 8.9,
	    "lat": -21.065376776354263,
	    "lng": -48.708570543676615,
	    "corrected": true
	}, {
	    "i": "6umnmuhn2481",
	    "h": "A",
	    "s": "Fronteira/Frutal, MG - BR-153 (BR-153) - Km 227",
	    "r": 1000,
	    "p": 3.3,
	    "lat": -19.97210588221752,
	    "lng": -48.96072534844279,
	    "corrected": true
	}, {
	    "i": "6un0sqgtxyrt",
	    "h": "A",
	    "s": "Rio Claro, SP - Rod. Washington Luiz (SP 310) - Km 181",
	    "r": 100,
	    "p": 8.4,
	    "lat": -22.374028367641557,
	    "lng": -47.62056430801749,
	    "corrected": true
	}, {
	    "i": "6un405e8tcrv",
	    "h": "A",
	    "s": "Itirapina, SP - Rod. Washington Luiz (SP 310) - Km 217",
	    "r": 100,
	    "p": 5.1,
	    "lat": -22.12896143576567,
	    "lng": -47.80804233625531,
	    "corrected": true
	}, {
	    "i": "6un5w6cfgbrb",
	    "h": "A",
	    "s": "Descalvado, SP - Rod. Dr. Paulo Lauro (SP 215) - Km 104",
	    "r": 100,
	    "p": 6.1,
	    "lat": -21.869152948367265,
	    "lng": -47.53522815182805,
	    "corrected": true
	}, {
	    "i": "6un7049hdj86",
	    "h": "A",
	    "s": "Pirassununga, SP - Rod. Anhangüera (SP 330) - Km 215",
	    "r": 150,
	    "p": 7.4,
	    "lat": -21.958115964983776,
	    "lng": -47.45944702997804,
	    "corrected": true
	}, {
	    "i": "6unhu8u2pqxz",
	    "h": "A",
	    "s": "Santa Rita do Passa Quatro, SP - Rod. Anhangüera (SP 330) - Km 253",
	    "r": 100,
	    "p": 7.1,
	    "lat": -21.660902382682156,
	    "lng": -47.60861339047551,
	    "corrected": true
	}, {
	    "i": "6unn5ms45t0m",
	    "h": "A",
	    "s": "São Simão, SP - Rod. Anhangüera (SP 330) - Km 281",
	    "r": 100,
	    "p": 7.1,
	    "lat": -21.414609173091343,
	    "lng": -47.66417333856225,
	    "corrected": true
	}, {
	    "i": "6unsckkv2025",
	    "h": "A",
	    "s": "Casa Branca, SP - Rod. Pref. José André de Lima (SP 340) - Km 254",
	    "r": 100,
	    "p": 5.9,
	    "lat": -21.64080991037665,
	    "lng": -47.047827523201704,
	    "corrected": true
	}, {
	    "i": "6unsefsszzpg",
	    "h": "N",
	    "s": "Itobi, SP - Rod. Dep. Eduardo Vicente Nasser (SP 350) - Km 252",
	    "r": 200,
	    "p": 8.8,
	    "lat": -21.69453189265986,
	    "lng": -46.93785259500146,
	    "corrected": true
	}, {
	    "i": "6uq0u56w4tpd",
	    "h": "A",
	    "s": "Batatais, SP - Rod. Cândido Portinari (SP 334) - Km 334",
	    "r": 100,
	    "p": 9,
	    "lat": -20.94300532235622,
	    "lng": -47.633571680635214,
	    "corrected": true
	}, {
	    "i": "6uq9mm2ptbxx",
	    "h": "A",
	    "s": "Pratápolis, MG - MG 050 - Km 389",
	    "r": 1000,
	    "p": 5.1,
	    "lat": -20.84285892247249,
	    "lng": -46.87803229317069,
	    "corrected": true
	}, {
	    "i": "6ur4057j46pu",
	    "h": "A",
	    "s": "Passos, MG - MG 050 - Km 333",
	    "r": 1000,
	    "p": 5.1,
	    "lat": -20.723502556718888,
	    "lng": -46.40201831236482,
	    "corrected": true
	}, {
	    "i": "6ut1rw24g0b2",
	    "h": "A",
	    "s": "Prata, MG - BR-153 (BR-153) - Km 127",
	    "r": 1000,
	    "p": 5.6,
	    "lat": -19.432964670014265,
	    "lng": -48.88904733583331,
	    "corrected": true
	}, {
	    "i": "6ut20z3y8400",
	    "h": "A",
	    "s": "Campo Florido, MG - BR-262 (BR-262) - Km 863",
	    "r": 1000,
	    "p": 4.9,
	    "lat": -19.64652742467688,
	    "lng": -48.83180195465684,
	    "corrected": true
	}, {
	    "i": "6utepcyj7qrf",
	    "h": "A",
	    "s": "Uberlândia, MG - BR-050 (BR-050) - Km 104",
	    "r": 1000,
	    "p": 6.3,
	    "lat": -19.149620712901488,
	    "lng": -48.16671269014478,
	    "corrected": true
	}, {
	    "i": "6gevk1rd3jpv",
	    "h": "A",
	    "s": "Imbaú, PR - BR 376 - Km 377",
	    "r": 500,
	    "p": 10.5,
	    "lat": -24.38228066348777,
	    "lng": -50.79017596319318,
	    "corrected": true
	}, {
	    "i": "6gexm2wj51zg",
	    "h": "A",
	    "s": "Ortigueira, PR - BR 376 - Km 321",
	    "r": 500,
	    "p": 10.5,
	    "lat": -24.034344610201256,
	    "lng": -51.08897941187024,
	    "corrected": true
	}, {
	    "i": "6gstekb4q181",
	    "h": "A",
	    "s": "Jaguariaíva, PR - PR 151 - Km 223",
	    "r": 500,
	    "p": 7.1,
	    "lat": -24.31936515586265,
	    "lng": -49.77857245132327,
	    "corrected": true
	}, {
	    "i": "6gsyzyevss8k",
	    "h": "A",
	    "s": "Itararé, SP - Rod. Francisco Alves Negrão (SP 258) - Km 326",
	    "r": 200,
	    "p": 6.3,
	    "lat": -24.089579269788164,
	    "lng": -49.224227238446474,
	    "corrected": true
	}, {
	    "i": "6gtrydhgqxge",
	    "h": "A",
	    "s": "Buri, SP - Rod. Francisco Alves Negrão (SP 258) - Km 250",
	    "r": 200,
	    "p": 9.9,
	    "lat": -23.93827981132585,
	    "lng": -48.5770152322948,
	    "corrected": true
	}, {
	    "i": "6gv8nh4ckx2m",
	    "h": "A",
	    "s": "Capão Bonito, SP - Rod. Prof. Francisco da Silva Pontes (SP 127) - Km 192",
	    "r": 200,
	    "p": 9.2,
	    "lat": -23.8840143691575,
	    "lng": -48.24836114421487,
	    "corrected": true
	}, {
	    "i": "6gwj1zpz9bzb",
	    "h": "A",
	    "s": "Juquiá, SP - Rod. Régis Bittencourt (BR 116) - Km 426",
	    "r": 1000,
	    "p": 3,
	    "lat": -24.393820720945286,
	    "lng": -47.72494884207845,
	    "corrected": true
	}, {
	    "i": "6gybgcbk4wz3",
	    "h": "L",
	    "s": "Imigrantes - Capital - Rodo Anel Mário Covas (SP-021) - Km 70",
	    "r": 10,
	    "p": 3.3,
	    "lat": -23.764077611755127,
	    "lng": -46.592576522380114,
	    "corrected": true
	}, {
	    "i": "6gycndtu62pr",
	    "h": "L",
	    "s": "Ribeirão Pires, SP - Rodo Anel Mário Covas (SP-021) - Km 86",
	    "r": 20,
	    "p": 3.3,
	    "lat": -23.71602835082762,
	    "lng": -46.464328709989786,
	    "corrected": true
	}, {
	    "i": "6gycndty3mkk",
	    "h": "O",
	    "s": "Ribeirão Pires, SP - Rodo Anel Mário Covas (SP-021) - Km 86",
	    "r": 20,
	    "p": 2.5,
	    "lat": -23.715639564006167,
	    "lng": -46.46420868113637,
	    "corrected": true
	}, {
	    "i": "6gycnfcjxt2r",
	    "h": "O",
	    "s": "Mauá, SP - Rodo Anel Mário Covas (SP-021) - Km 3",
	    "r": 50,
	    "p": 2.5,
	    "lat": -23.714421836127713,
	    "lng": -46.45956510677934,
	    "corrected": true
	}, {
	    "i": "6gycndqw7f7r",
	    "h": "L",
	    "s": "Ribeirão Pires, SP - Rodo Anel Mário Covas (SP-021) - Km 86",
	    "r": 50,
	    "p": 3.3,
	    "lat": -23.716905047428092,
	    "lng": -46.4633178524673,
	    "corrected": true
	}, {
	    "i": "6uttq3bttfr9",
	    "h": "A",
	    "s": "Araguari, MG - BR-050 (BR-050) - Km 51",
	    "r": 1000,
	    "p": 4.4,
	    "lat": -18.754090688008855,
	    "lng": -48.24003120884299,
	    "corrected": true
	}, {
	    "i": "6utydy4qg5z8",
	    "h": "A",
	    "s": "Araguari, MG - BR-050 (BR-050) - Km 13",
	    "r": 1000,
	    "p": 5.8,
	    "lat": -18.510758541521778,
	    "lng": -48.038012590259314,
	    "corrected": true
	}, {
	    "i": "6uubw2r4pzxg",
	    "h": "A",
	    "s": "Itumbiara, GO - BR-153 (BR-153) - Km 685",
	    "r": 1000,
	    "p": 6.3,
	    "lat": -18.191568815456147,
	    "lng": -49.285576064139605,
	    "corrected": true
	}, {
	    "i": "6uy4cmrzkn8w",
	    "h": "A",
	    "s": "Campo Alegre, MG - BR-050 (BR-050) - Km 226",
	    "r": 1000,
	    "p": 7.6,
	    "lat": -17.767795485314423,
	    "lng": -47.74672502651811,
	    "corrected": true
	}, {
	    "i": "6uyjcnvu2mrz",
	    "h": "A",
	    "s": "Ipameri, MG - BR-050 (BR-050) - Km 143",
	    "r": 1000,
	    "p": 7,
	    "lat": -17.23275291211773,
	    "lng": -47.76121934875846,
	    "corrected": true
	}, {
	    "i": "6vn13suqn580",
	    "h": "A",
	    "s": "Cristalina, GO - BR-040 (BR-040) - Km 93",
	    "r": 1000,
	    "p": 5.3,
	    "lat": -16.628193440471417,
	    "lng": -47.740529123693705,
	    "corrected": true
	}, {
	    "i": "75cwzvy2bq8p",
	    "h": "A",
	    "s": "Rio Bonito, RJ - BR 101 - Km 252",
	    "r": 100,
	    "p": 5,
	    "lat": -22.686903847703096,
	    "lng": -42.54021702334285,
	    "corrected": true
	}, {
	    "i": "75cy39qbh28q",
	    "h": "A",
	    "s": "Rio Bonito, RJ - RJ 124 - Km 22",
	    "r": 50,
	    "p": 11.3,
	    "lat": -22.800933642953535,
	    "lng": -42.464501950889826,
	    "corrected": true
	}, {
	    "i": "7h0zn3nqg587",
	    "h": "A",
	    "s": "Barbacena, MG - BR-040 (BR-040) - Km 714",
	    "r": 1000,
	    "p": 5.3,
	    "lat": -21.262616296134095,
	    "lng": -43.66209486499429,
	    "corrected": true
	}, {
	    "i": "7h2cg5t1wgzy",
	    "h": "A",
	    "s": "Conselheiro Lafaiete, MG - MG-040 (MG-040) - Km 643",
	    "r": 1000,
	    "p": 5.3,
	    "lat": -20.76707445483268,
	    "lng": -43.80647214129567,
	    "corrected": true
	}, {
	    "i": "7h2sxxv75vpg",
	    "h": "A",
	    "s": "Itabirito, MG - MG-040 (MG-040) - Km 557",
	    "r": 1000,
	    "p": 5.3,
	    "lat": -20.25967752021218,
	    "lng": -43.96007118746638,
	    "corrected": true
	}, {
	    "i": "7h404hj9ptbk",
	    "h": "A",
	    "s": "Casimiro de Abreu, RJ - BR 101 - Km 192",
	    "r": 500,
	    "p": 5,
	    "lat": -22.47578245663448,
	    "lng": -42.088696639984846,
	    "corrected": true
	}, {
	    "i": "7h46e6hyxvxz",
	    "h": "A",
	    "s": "Conceição de Macabu, RJ - BR 101 - Km 123",
	    "r": 100,
	    "p": 5,
	    "lat": -22.048402799110274,
	    "lng": -41.6861748509109,
	    "corrected": true
	}, {
	    "i": "7h4t7kquvmpz",
	    "h": "A",
	    "s": "Campos de Goytacazes, RJ - BR 101 - Km 40",
	    "r": 100,
	    "p": 5,
	    "lat": -21.552647185896046,
	    "lng": -41.331874150782824,
	    "corrected": true
	}, {
	    "i": "7h4xssz27d2q",
	    "h": "A",
	    "s": "Mimoso do Sul, ES - Rod. Governador Mário Covas (BR-101) - Km 451",
	    "r": 100,
	    "p": 2.3,
	    "lat": -21.158378654412132,
	    "lng": -41.28054874017835,
	    "corrected": true
	}, {
	    "i": "7h6c5zz2jwue",
	    "h": "A",
	    "s": "Itapemirim, ES - Rod. Governador Mário Covas (BR-101) - Km 398",
	    "r": 100,
	    "p": 4.2,
	    "lat": -20.87535241353173,
	    "lng": -40.95781730487943,
	    "corrected": true
	}, {
	    "i": "7h75nc5pyts9",
	    "h": "A",
	    "s": "Guarapari, ES - Rod. Governador Mário Covas (BR-101) - Km 325",
	    "r": 100,
	    "p": 5,
	    "lat": -20.559550757058545,
	    "lng": -40.48023188486695,
	    "corrected": true
	}, {
	    "i": "7h770u6syfzb",
	    "h": "A",
	    "s": "Guarapari, ES - Rod. do Sol (ES 060) - Km 30",
	    "r": 100,
	    "p": 7.2,
	    "lat": -20.54234309977414,
	    "lng": -40.3929709084332,
	    "corrected": true
	}, {
	    "i": "7h7k7jz3emu7",
	    "h": "A",
	    "s": "Vitória, ES - Terceira Ponte (ES 060) - Km 0",
	    "r": 1,
	    "p": 0.8,
	    "lat": -20.314920777081515,
	    "lng": -40.28815219178796,
	    "corrected": true
	}, {
	    "i": "7h7q0c0p9c3n",
	    "h": "A",
	    "s": "Serra, ES - Rod. Governador Mário Covas (BR-101) - Km 242",
	    "r": 50,
	    "p": 4.8,
	    "lat": -20.03242086657831,
	    "lng": -40.39663514122367,
	    "corrected": true
	}, {
	    "i": "7h870p6tzzzz",
	    "h": "A",
	    "s": "Curvelo, MG - BR-040 (BR-040) - Km 405",
	    "r": 1000,
	    "p": 5.3,
	    "lat": -19.119266080098484,
	    "lng": -44.6446349658072,
	    "corrected": true
	}, {
	    "i": "7he2twjc523f",
	    "h": "A",
	    "s": "Aracruz, ES - Rod. Governador Mário Covas (BR-101) - Km 172",
	    "r": 100,
	    "p": 5,
	    "lat": -19.5631212836758,
	    "lng": -40.1775580085814,
	    "corrected": true
	}, {
	    "i": "7hesennrn33q",
	    "h": "A",
	    "s": "São Mateus, ES - Rod. Governador Mário Covas (BR-101) - Km 86",
	    "r": 100,
	    "p": 5.3,
	    "lat": -18.86411710471641,
	    "lng": -39.938715007156134,
	    "corrected": true
	}, {
	    "i": "7hg8e839ufrg",
	    "h": "A",
	    "s": "Pedro Canário, ES - Rod. Governador Mário Covas (BR-101) - Km 2",
	    "r": 100,
	    "p": 4,
	    "lat": -18.191721434655403,
	    "lng": -39.92184089496732,
	    "corrected": true
	}, {
	    "i": "6gzdh0c849u1",
	    "h": "A",
	    "s": "Paraibuna, SP - Rod. dos Tamoios (SP-099) - Km 59",
	    "r": 200,
	    "p": 6.5,
	    "lat": -23.550506352910535,
	    "lng": -45.52513109520078,
	    "corrected": true
	}, {
	    "i": "6feu8y90hhup",
	    "h": "A",
	    "s": "Viamão, RS - RS 040 - Km 19",
	    "r": 200,
	    "p": 5.2,
	    "lat": -30.110749750058144,
	    "lng": -50.942097287625074,
	    "corrected": true
	}, {
	    "i": "6fex1x7evumc",
	    "h": "L",
	    "s": "Portão, RS - RS-240 - Km 13",
	    "r": 20,
	    "p": 4.8,
	    "lat": -29.66656787165428,
	    "lng": -51.257163640111685,
	    "corrected": true
	}, {
	    "i": "6fex1x7vpw01",
	    "h": "L",
	    "s": "Portão, RS - RS-122 - Km 0",
	    "r": 20,
	    "p": 4.8,
	    "lat": -29.66633662404208,
	    "lng": -51.25683842226863,
	    "corrected": true
	}, {
	    "i": "6fexm9jtj2xs",
	    "h": "A",
	    "s": "Campo Bom, RS - RS-239 - Km 19",
	    "r": 50,
	    "p": 2.4,
	    "lat": -29.65684757261488,
	    "lng": -51.079050209373236,
	    "corrected": true
	}, {
	    "i": "6fg95xtnt586",
	    "h": "A",
	    "s": "Caxias do Sul, RS - BR 116 - Km 171",
	    "r": 100,
	    "p": 6,
	    "lat": -29.312985344563653,
	    "lng": -51.16733143106103,
	    "corrected": true
	}, {
	    "i": "6gfgt6112hbp",
	    "h": "A",
	    "s": "Castelo Branco, PR - BR 376 - Km 148",
	    "r": 100,
	    "p": 11.1,
	    "lat": -23.279844650173892,
	    "lng": -52.15075297281146,
	    "corrected": true
	}, {
	    "i": "6gut0k28zgxz",
	    "h": "A",
	    "s": "Jacarezinho, PR - BR 369 - Km 1",
	    "r": 400,
	    "p": 19.3,
	    "lat": -23.003971235240066,
	    "lng": -49.9098457954824,
	    "corrected": true
	}, {
	    "i": "6gutu8e4ys0h",
	    "h": "A",
	    "s": "Ourinhos, SP - Rod. Orlando Quagliato (SP 327) - Km 14",
	    "r": 200,
	    "p": 6.4,
	    "lat": -22.892288570472648,
	    "lng": -49.71971472725272,
	    "corrected": true
	}, {
	    "i": "6guyd40uq6rv",
	    "h": "A",
	    "s": "Sta. Cruz do Rio Pardo, SP - Rod. Eng João Baptista Cabral Renno (SP 255) - Km 300",
	    "r": 200,
	    "p": 5.2,
	    "lat": -22.751941138947583,
	    "lng": -49.48112217709422,
	    "corrected": true
	}, {
	    "i": "6gwzy9yntgry",
	    "h": "N",
	    "s": "São Vicente, SP - Rod. Padre Manuel da Nóbrega (SP-055) - Km 279",
	    "r": 150,
	    "p": 7,
	    "lat": -23.939403825940808,
	    "lng": -46.46366687491536,
	    "corrected": true
	}, {
	    "i": "6gyb7zxdhj8n",
	    "h": "S",
	    "s": "São Bernardo do Campo, SP - Rod. dos Imigrantes (SP 160) - Km 32",
	    "r": 150,
	    "p": 25.6,
	    "lat": -23.820748296233045,
	    "lng": -46.58272309228778,
	    "corrected": true
	}, {
	    "i": "6gybg9xknr5b",
	    "h": "L",
	    "s": "Imigrantes - Litoral - Rodo Anel Mário Covas (SP-021) - Km 70",
	    "r": 20,
	    "p": 3.3,
	    "lat": -23.765464764744273,
	    "lng": -46.59390790387988,
	    "corrected": true
	}, {
	    "i": "6gybgeyrew86",
	    "h": "S",
	    "s": "São Bernardo do Campo, SP - Rod. dos Imigrantes (SP 160) - Km 24",
	    "r": 10,
	    "p": 5.8,
	    "lat": -23.752355696015638,
	    "lng": -46.595240626484156,
	    "corrected": true
	}, {
	    "i": "6gybtmmds9ps",
	    "h": "S",
	    "s": "São Bernardo do Campo, SP - Rod. Anchieta (SP 150) - Km 31",
	    "r": 150,
	    "p": 25.6,
	    "lat": -23.789240840617452,
	    "lng": -46.51959193870425,
	    "corrected": true
	}, {
	    "i": "6gybu1bmees2",
	    "h": "O",
	    "s": "Imigrantes - Rodo Anel Mário Covas (SP-021) - Km 71",
	    "r": 10,
	    "p": 3.3,
	    "lat": -23.763861349092565,
	    "lng": -46.58136723563075,
	    "corrected": true
	}, {
	    "i": "6gybugjpfwhn",
	    "h": "N",
	    "s": "Anchieta - Rodo Anel Mário Covas (SP-021) - Km 75",
	    "r": 30,
	    "p": 3.3,
	    "lat": -23.756481927141195,
	    "lng": -46.54208494350314,
	    "corrected": true
	}, {
	    "i": "6gyc56q8d81c",
	    "h": "S",
	    "s": "Diadema, SP - Rod. dos Imigrantes (SP 160) - Km 20",
	    "r": 15,
	    "p": 3.6,
	    "lat": -23.718034713094518,
	    "lng": -46.60594532266259,
	    "corrected": true
	}, {
	    "i": "6gyc72fbpygf",
	    "h": "S",
	    "s": "Diadema, SP - Rod. dos Imigrantes (SP 160) - Km 15",
	    "r": 20,
	    "p": 1.8,
	    "lat": -23.68161529635125,
	    "lng": -46.611224580556154,
	    "corrected": true
	}, {
	    "i": "6gz04659z623",
	    "h": "N",
	    "s": "Santos, SP - Rod. Cônego Domênico Rangoni (SP 055) - Km 250",
	    "r": 150,
	    "p": 12,
	    "lat": -23.894904349056173,
	    "lng": -46.30219588056207,
	    "corrected": true
	}, {
	    "i": "6gz48b55rbpv",
	    "h": "A",
	    "s": "Itaquaquecetuba, SP - Rod. Ayrton Senna da Silva (SP 070) - Km 32",
	    "r": 65,
	    "p": 3.6,
	    "lat": -23.466246664833378,
	    "lng": -46.368621457368135,
	    "corrected": true
	}, {
	    "i": "6gz493t1xu2h",
	    "h": "L",
	    "s": "Itaquaquecetuba, SP - SP-021 (SP-021) - Km 124",
	    "r": 15,
	    "p": 2.5,
	    "lat": -23.458315144521475,
	    "lng": -46.344323325902224,
	    "corrected": true
	}, {
	    "i": "6gz49pdetmb4",
	    "h": "N",
	    "s": "Arujá, SP - SP-021 (SP-021) - Km 128",
	    "r": 10,
	    "p": 2.5,
	    "lat": -23.424974679221453,
	    "lng": -46.358684208244085,
	    "corrected": true
	}, {
	    "i": "6gz4c1bckj2h",
	    "h": "A",
	    "s": "Arujá, SP - Rod. Pres. Dutra (BR 116) - Km 204",
	    "r": 50,
	    "p": 3.5,
	    "lat": -23.413018414098076,
	    "lng": -46.36106936261058,
	    "corrected": true
	}, {
	    "i": "6uh8btbc2hbr",
	    "h": "A",
	    "s": "Marília, SP - Rod. Transbrasiliana (RB 153) - Km 268",
	    "r": 100,
	    "p": 4.8,
	    "lat": -22.336335193428393,
	    "lng": -49.89886851981282,
	    "corrected": true
	}, {
	    "i": "6uhczs3mjcrt",
	    "h": "A",
	    "s": "Avaí, SP - Rod. Mal. Rondon (SP 300) - Km 367",
	    "r": 100,
	    "p": 5.3,
	    "lat": -22.168071573141084,
	    "lng": -49.23868468031287,
	    "corrected": true
	}, {
	    "i": "6uhg4j63yn23",
	    "h": "A",
	    "s": "Pirajuí, SP - Rod. Mal. Rondon (SP 300) - Km 400",
	    "r": 200,
	    "p": 4.9,
	    "lat": -21.943696910640252,
	    "lng": -49.47922417894006,
	    "corrected": true
	}, {
	    "i": "6ujm3y1dtgzz",
	    "h": "A",
	    "s": "Itápolis , SP - Rod. Laurentino Mascari (SP 333) - Km 179",
	    "r": 100,
	    "p": 7.1,
	    "lat": -21.543626658740934,
	    "lng": -48.78799008205533,
	    "corrected": true
	}, {
	    "i": "6ujq7569wcxv",
	    "h": "A",
	    "s": "Agulha, SP - Rod. Washington Luiz (SP 310) - Km 346",
	    "r": 100,
	    "p": 10.6,
	    "lat": -21.383095591603023,
	    "lng": -48.731532264500856,
	    "corrected": true
	}, {
	    "i": "6ujrp5dh3r0n",
	    "h": "A",
	    "s": "Monte Alto, SP - Rod. Orlando Chesini Ometto (SP-323) - Km 19",
	    "r": 200,
	    "p": 5.7,
	    "lat": -21.24945572928079,
	    "lng": -48.55672365054488,
	    "corrected": true
	}, {
	    "i": "6ujxff59gp84",
	    "h": "A",
	    "s": "Taiúva, SP - Rod. Brg. Faria Lima (SP 326) - Km 357",
	    "r": 100,
	    "p": 7.5,
	    "lat": -21.12640983208578,
	    "lng": -48.38992914184928,
	    "corrected": true
	}, {
	    "i": "6um8rxqee8rb",
	    "h": "A",
	    "s": "Pitangueiras, SP - Rod. Armando Sales Oliveira (SP 322) - Km 361",
	    "r": 200,
	    "p": 8.5,
	    "lat": -21.00925431712954,
	    "lng": -48.17672135308385,
	    "corrected": true
	}, {
	    "i": "6umcqh5qz5bj",
	    "h": "A",
	    "s": "Sales Oliveira , SP - Rod. Anhanguera (SP 330) - Km 350",
	    "r": 100,
	    "p": 10.7,
	    "lat": -20.85087729475646,
	    "lng": -47.895559798926115,
	    "corrected": true
	}, {
	    "i": "6umupczhsx8p",
	    "h": "A",
	    "s": "Ituverava, SP - Rod. Anhanguera (SP 330) - Km 405",
	    "r": 100,
	    "p": 13.1,
	    "lat": -20.380353883363863,
	    "lng": -47.813561987131834,
	    "corrected": true
	}, {
	    "i": "6umyxub2q900",
	    "h": "A",
	    "s": "Delta, MG - BR-050 (BR-050) - Km 198",
	    "r": 1000,
	    "p": 4.5,
	    "lat": -19.925027199646458,
	    "lng": -47.82286053523421,
	    "corrected": true
	}, {
	    "i": "6uq4nvnsz0zx",
	    "h": "A",
	    "s": "Restinga, SP - Rod. Cândido Portinari (SP 334) - Km 374",
	    "r": 100,
	    "p": 9,
	    "lat": -20.7140013605673,
	    "lng": -47.50605275854468,
	    "corrected": true
	}, {
	    "i": "6uw0qb55h92j",
	    "h": "A",
	    "s": "Sacramento, MG - BR-262 (BR-262) - Km 736",
	    "r": 1000,
	    "p": 5.9,
	    "lat": -19.643029233953886,
	    "lng": -47.51155665144324,
	    "corrected": true
	}, {
	    "i": "6fdx0kvbyyzu",
	    "h": "A",
	    "s": "Candelária, RS - BR-287 (RSC-287) - Km 131",
	    "r": 100,
	    "p": 5.2,
	    "lat": -29.680668729628106,
	    "lng": -52.71514439955354,
	    "corrected": true
	}, {
	    "i": "6fept44z880k",
	    "h": "A",
	    "s": "Fazenda Vilanova , RS - BR 386 (BR 386) - Km 370",
	    "r": 100,
	    "p": 6,
	    "lat": -29.606908058318247,
	    "lng": -51.807714868336916,
	    "corrected": true
	}, {
	    "i": "6ffqvu9cqq2r",
	    "h": "A",
	    "s": "Sta Barbara Sul, RS - BR 285 - Km 341",
	    "r": 100,
	    "p": 0,
	    "lat": -28.319564935497045,
	    "lng": -52.83060209825635,
	    "corrected": true
	}, {
	    "i": "6ffrtcgfe102",
	    "h": "A",
	    "s": "Sarandi, RS - BR 386 - Km 164",
	    "r": 500,
	    "p": 0,
	    "lat": -28.202840031489664,
	    "lng": -52.82792491838336,
	    "corrected": true
	}, {
	    "i": "6ffsn05cq8xs",
	    "h": "A",
	    "s": "Soledade, RS - BR 386 - Km 248",
	    "r": 100,
	    "p": 0,
	    "lat": -28.8279460522496,
	    "lng": -52.46531976386905,
	    "corrected": true
	}, {
	    "i": "6ffx1m2gmx8q",
	    "h": "A",
	    "s": "Passo Fundo, RS - BR-285 (BR 285) - Km 326",
	    "r": 100,
	    "p": 0,
	    "lat": -28.271143895822807,
	    "lng": -52.67840417101979,
	    "corrected": true
	}, {
	    "i": "6ffzc9pnuzrg",
	    "h": "N",
	    "s": "Passo Fundo – Erexim, RS - RS-135 (ERS-135) - Km 18",
	    "r": 100,
	    "p": 3.6,
	    "lat": -28.16289891842132,
	    "lng": -52.30763101950288,
	    "corrected": true
	}, {
	    "i": "6fg30ev81d8m",
	    "h": "A",
	    "s": "Boa Vista do Sul, RS - RS-453 (RSC 453) - Km 18",
	    "r": 100,
	    "p": 5.2,
	    "lat": -29.33480244055255,
	    "lng": -51.65006501600146,
	    "corrected": true
	}, {
	    "i": "6fg9bf3e60b1",
	    "h": "A",
	    "s": "Farroupilha, RS - RS 122 - Km 65",
	    "r": 150,
	    "p": 0,
	    "lat": -29.210434767194688,
	    "lng": -51.293103229254484,
	    "corrected": true
	}, {
	    "i": "6fgdvhk6ybze",
	    "h": "A",
	    "s": "São Marcos, RS - Estr. P/ Caxias (BR 116) - Km 126",
	    "r": 100,
	    "p": 6,
	    "lat": -29.024202786606235,
	    "lng": -51.102221477776766,
	    "corrected": true
	}, {
	    "i": "6fge536r8zxb",
	    "h": "A",
	    "s": "Flores da Cunha, RS - RS-122 (ERS 122) - Km 100",
	    "r": 100,
	    "p": 5.2,
	    "lat": -28.995678880241446,
	    "lng": -51.182107385247946,
	    "corrected": true
	}, {
	    "i": "6gkvtwrrg020",
	    "h": "A",
	    "s": "Fazenda Rio Grande, PR - Rod. Régis Bittencourt (BR-116) - Km 134",
	    "r": 200,
	    "p": 5.6,
	    "lat": -25.714833071063357,
	    "lng": -49.31821083649993,
	    "corrected": true
	}, {
	    "i": "6gmjd0bwcyzz",
	    "h": "A",
	    "s": "São José dos Pinhais, PR - BR 376 - Km 637",
	    "r": 300,
	    "p": 2.6,
	    "lat": -25.745134353006176,
	    "lng": -49.130049515515566,
	    "corrected": true
	}, {
	    "i": "6gmnshku8v23",
	    "h": "A",
	    "s": "São José dos Pinhais, PR - Rod. Curitiba Paranaguá (BR 277) - Km 60",
	    "r": 200,
	    "p": 18.7,
	    "lat": -25.551935501555885,
	    "lng": -49.03692523017526,
	    "corrected": true
	}, {
	    "i": "6gt9fyxgjypb",
	    "h": "A",
	    "s": "Barra do Turvo, SP - Rod. Régis Bittencourt (BR-116) - Km 542",
	    "r": 500,
	    "p": 3,
	    "lat": -24.96881965060975,
	    "lng": -48.383966255933046,
	    "corrected": true
	}, {
	    "i": "6gtg3g7m4dpb",
	    "h": "A",
	    "s": "Cajati, SP - Rod. Régis Bittencourt (BR 116) - Km 485",
	    "r": 150,
	    "p": 3,
	    "lat": -24.723222379578125,
	    "lng": -48.084972370415926,
	    "corrected": true
	}, {
	    "i": "6gwqe44n612j",
	    "h": "A",
	    "s": "Miracatu, SP - Rod. Régis Bittencourt (BR-116) - Km 370",
	    "r": 500,
	    "p": 3,
	    "lat": -24.156469853657462,
	    "lng": -47.32551259920001,
	    "corrected": true
	}, {
	    "i": "6gy8u2rx08b0",
	    "h": "A",
	    "s": "São Lourenço da Serra, SP - Rod. Régis Bittencourt (BR 116) - Km 298",
	    "r": 100,
	    "p": 3,
	    "lat": -23.771914810646173,
	    "lng": -46.91221101209521,
	    "corrected": true
	}, {
	    "i": "6gy8xyu37brg",
	    "h": "N",
	    "s": "Parelheiros, SP - Rodo Anel Mário Covas (SP-021) - Km 50",
	    "r": 100,
	    "p": 3.3,
	    "lat": -23.781005105709983,
	    "lng": -46.7628981359303,
	    "corrected": true
	}, {
	    "i": "6gy9wz8pbnen",
	    "h": "S",
	    "s": "São Paulo, SP - Rodo Anel Mário Covas (SP 021) - Km 25",
	    "r": 100,
	    "p": 2,
	    "lat": -23.599960216147817,
	    "lng": -46.81277213618159,
	    "corrected": true
	}, {
	    "i": "6gy9ybcbtg00",
	    "h": "N",
	    "s": "São Paulo, SP - Rodo Anel Mário Covas (SP 021) - Km 24",
	    "r": 30,
	    "p": 2,
	    "lat": -23.594405093986243,
	    "lng": -46.81010166183114,
	    "corrected": true
	}, {
	    "i": "6gy9yc9ugk2m",
	    "h": "S",
	    "s": "São Paulo, SP - Rodo Anel Mário Covas (SP 021) - Km 24",
	    "r": 30,
	    "p": 2,
	    "lat": -23.588368236188327,
	    "lng": -46.80974727496505,
	    "corrected": true
	}, {
	    "i": "6gy9yxexy88n",
	    "h": "N",
	    "s": "Padroeira Externa, SP - Rodo Anel Mário Covas (SP 021) - Km 20",
	    "r": 30,
	    "p": 2,
	    "lat": -23.564491818888413,
	    "lng": -46.819177251309156,
	    "corrected": true
	}, {
	    "i": "6gyd5ydv0hzb",
	    "h": "O",
	    "s": "Itapevi , SP - Rod. Pres. Castelo Branco (SP 280) - Km 33",
	    "r": 250,
	    "p": 8.2,
	    "lat": -23.51805871135695,
	    "lng": -46.939280200749636,
	    "corrected": true
	}, {
	    "i": "6gydn867j8zc",
	    "h": "S",
	    "s": "São Paulo, SP - Rodo Anel Mário Covas (SP 021) - Km 19",
	    "r": 30,
	    "p": 2,
	    "lat": -23.552017979549948,
	    "lng": -46.82043956592679,
	    "corrected": true
	}, {
	    "i": "6gydnwxk4y84",
	    "h": "N",
	    "s": "São Paulo, SP - Rodo Anel Mário Covas (SP 021) - Km 15",
	    "r": 50,
	    "p": 2,
	    "lat": -23.51796917521436,
	    "lng": -46.81374343112111,
	    "corrected": true
	}, {
	    "i": "6gydppb60db4",
	    "h": "O",
	    "s": "Osasco, SP - Rod. Pres. Castelo Branco (SP 280) - Km 18",
	    "r": 100,
	    "p": 4.1,
	    "lat": -23.51191439416895,
	    "lng": -46.80140359327197,
	    "corrected": true
	}, {
	    "i": "6gydq88btxpz",
	    "h": "O",
	    "s": "São Paulo, SP - Rodo Anel Mário Covas (SP 021) - Km 14",
	    "r": 30,
	    "p": 2,
	    "lat": -23.50806281521718,
	    "lng": -46.82328002527356,
	    "corrected": true
	}, {
	    "i": "6gydq8hdtmzx",
	    "h": "L",
	    "s": "Barueri, SP - Rod. Pres. Castelo Branco (SP 280) - Km 20",
	    "r": 100,
	    "p": 4.1,
	    "lat": -23.50999439291708,
	    "lng": -46.817269530147314,
	    "corrected": true
	}, {
	    "i": "6f6duxr45f2h",
	    "h": "A",
	    "s": "Capão do Leão, RS - BR-116 - Km 541",
	    "r": 100,
	    "p": 10.7,
	    "lat": -31.8201007485315,
	    "lng": -52.52673799172044,
	    "corrected": true
	}, {
	    "i": "6f6fc393rq84",
	    "h": "A",
	    "s": "Rio Grande, RS - BR 392 - Km 52",
	    "r": 150,
	    "p": 10.7,
	    "lat": -31.85208294763411,
	    "lng": -52.326017897576094,
	    "corrected": true
	}, {
	    "i": "6f6t44u0z224",
	    "h": "A",
	    "s": "Canguçu, RS - BR 392 - Km 111",
	    "r": 150,
	    "p": 10.7,
	    "lat": -31.449661101089173,
	    "lng": -52.640713434666395,
	    "corrected": true
	}, {
	    "i": "6f6u16yfjyz9",
	    "h": "A",
	    "s": "Pelotas, RS - BR-116 - Km 510",
	    "r": 100,
	    "p": 10.7,
	    "lat": -31.62526976756592,
	    "lng": -52.31822540983558,
	    "corrected": true
	}, {
	    "i": "6f6zrxgh4x8q",
	    "h": "A",
	    "s": "Cristal, RS - BR-116 - Km 430",
	    "r": 200,
	    "p": 10.7,
	    "lat": -31.02625803750489,
	    "lng": -52.04956194385886,
	    "corrected": true
	}, {
	    "i": "6fdsnjs5jmzu",
	    "h": "A",
	    "s": "Pântano Grande, RS - BR 290 - Km 224",
	    "r": 100,
	    "p": 0,
	    "lat": -30.203537778502138,
	    "lng": -52.46497543528676,
	    "corrected": true
	}, {
	    "i": "6fdwpxws4dry",
	    "h": "A",
	    "s": "Rio Pardo, RS - BR 471 - Km 139",
	    "r": 2000,
	    "p": 6,
	    "lat": -29.84278800371179,
	    "lng": -52.395087126642466,
	    "corrected": true
	}, {
	    "i": "6fdz4rhkwvps",
	    "h": "A",
	    "s": "Venâncio Aires, RS - BR-287 (RSC-287) - Km 86",
	    "r": 100,
	    "p": 5.2,
	    "lat": -29.66770796563316,
	    "lng": -52.27777099236846,
	    "corrected": true
	}, {
	    "i": "6ffbnc8sbmxd",
	    "h": "A",
	    "s": "Cruzeiro do Sul, RS - RS-453 (RSC 453) - Km 18",
	    "r": 100,
	    "p": 5.2,
	    "lat": -29.52216260500658,
	    "lng": -52.08564838394523,
	    "corrected": true
	}, {
	    "i": "6ffcq25eh5b4",
	    "h": "A",
	    "s": "Marques de Souza, RS - BR 386 (BR 386) - Km 312",
	    "r": 200,
	    "p": 12,
	    "lat": -29.31103352469188,
	    "lng": -52.102926168590784,
	    "corrected": true
	}, {
	    "i": "6fg16uzf9n2r",
	    "h": "A",
	    "s": "Encantado , RS - RS 130 (RS 130) - Km 93",
	    "r": 400,
	    "p": 5.2,
	    "lat": -29.284960828894388,
	    "lng": -51.89970726147294,
	    "corrected": true
	}, {
	    "i": "6fgtrx9zwn02",
	    "h": "A",
	    "s": "Vacaria, RS - BR 116 - Km 48",
	    "r": 100,
	    "p": 0,
	    "lat": -28.56587673729202,
	    "lng": -50.99597180262208,
	    "corrected": true
	}, {
	    "i": "6fgwpsgyvs0h",
	    "h": "A",
	    "s": "Vacaria, RS - BR 285 - Km 130",
	    "r": 200,
	    "p": 0,
	    "lat": -28.44938750347012,
	    "lng": -50.99325506016612,
	    "corrected": true
	}, {
	    "i": "6fgye0c5u0rv",
	    "h": "A",
	    "s": "Vacaria, RS - BR 116 - Km 22",
	    "r": 200,
	    "p": 0,
	    "lat": -28.383893324967197,
	    "lng": -50.84339199587703,
	    "corrected": true
	}, {
	    "i": "6gh4w85j48r9",
	    "h": "A",
	    "s": "Correia Pinto, SC - BR 116 - Km 233",
	    "r": 200,
	    "p": 5.6,
	    "lat": -27.684684600409714,
	    "lng": -50.33503694459796,
	    "corrected": true
	}, {
	    "i": "6ghnheb7ksxb",
	    "h": "A",
	    "s": "Santa Cecília, SC - BR 116 - Km 152",
	    "r": 200,
	    "p": 5.6,
	    "lat": -27.049083235166595,
	    "lng": -50.426571015268564,
	    "corrected": true
	}, {
	    "i": "6gk2c5jb272p",
	    "h": "A",
	    "s": "Monte Castelo, SC - BR 116 - Km 81",
	    "r": 200,
	    "p": 5.6,
	    "lat": -26.570351372958893,
	    "lng": -50.22145880386233,
	    "corrected": true
	}, {
	    "i": "6gkesj9bhm8h",
	    "h": "A",
	    "s": "Rio Negro, PR - Rod. Régis Bittencourt (BR 116) - Km 204",
	    "r": 100,
	    "p": 5.6,
	    "lat": -26.073275975545563,
	    "lng": -49.74350793287158,
	    "corrected": true
	}, {
	    "i": "6gktth9wwp05",
	    "h": "A",
	    "s": "Lapa, PR - BR 476 - Km 192",
	    "r": 50,
	    "p": 12.2,
	    "lat": -25.726049443721678,
	    "lng": -49.69982514157891,
	    "corrected": true
	}, {
	    "i": "6gkx07sus9b3",
	    "h": "A",
	    "s": "Porto Amazonas, PR - BR 277 - Km 158",
	    "r": 100,
	    "p": 12.2,
	    "lat": -25.468330269771474,
	    "lng": -49.90419873967767,
	    "corrected": true
	}, {
	    "i": "6gkxcc2xvypx",
	    "h": "A",
	    "s": "Palmeira, PR - BR 376 - Km 537",
	    "r": 500,
	    "p": 11.3,
	    "lat": -25.347005469424904,
	    "lng": -49.84297966584563,
	    "corrected": true
	}, {
	    "i": "6gkxjgj4mbb4",
	    "h": "A",
	    "s": "Balsa Nova, PR - BR 277 - Km 132",
	    "r": 150,
	    "p": 7.9,
	    "lat": -25.471721028683152,
	    "lng": -49.66401932761073,
	    "corrected": true
	}, {
	    "i": "6gt0nkp2mypc",
	    "h": "A",
	    "s": "Campina Grande do Sul, PR - Rod. Régis Bittencourt (BR-116) - Km 57",
	    "r": 300,
	    "p": 3,
	    "lat": -25.290569609156883,
	    "lng": -48.93417315557599,
	    "corrected": true
	}, {
	    "i": "6g3r6gj77rrg",
	    "h": "A",
	    "s": "São Miguel do Iguaçu, PR - BR 277 - Km 704",
	    "r": 200,
	    "p": 14.8,
	    "lat": -25.427316901535647,
	    "lng": -54.36453798785806,
	    "corrected": true
	}, {
	    "i": "6g6xv99pdvzc",
	    "h": "A",
	    "s": "Laranjeiras do Sul, PR - BR 277 - Km 464",
	    "r": 100,
	    "p": 12.2,
	    "lat": -25.346941549195414,
	    "lng": -52.49127248302102,
	    "corrected": true
	}, {
	    "i": "6g7p7bj5ddb4",
	    "h": "A",
	    "s": "Candói, PR - BR 277 - Km 388",
	    "r": 100,
	    "p": 12.2,
	    "lat": -25.443702088775503,
	    "lng": -51.8594560213387,
	    "corrected": true
	}, {
	    "i": "6g7zmct232pz",
	    "h": "A",
	    "s": "Irati, PR - BR 277 - Km 249",
	    "r": 100,
	    "p": 10.7,
	    "lat": -25.43600296902082,
	    "lng": -50.71637498214841,
	    "corrected": true
	}, {
	    "i": "6gc25vfd5gxz",
	    "h": "A",
	    "s": "Mundo Novo, MS - BR-163 (BR-163) - Km 28",
	    "r": 1000,
	    "p": 4.6,
	    "lat": -23.874290833719847,
	    "lng": -54.32371510192752,
	    "corrected": true
	}, {
	    "i": "6gckneu9pfpz",
	    "h": "A",
	    "s": "Itaquiraí, MS - BR-163 (BR-163) - Km 113",
	    "r": 1000,
	    "p": 6.5,
	    "lat": -23.182341370857475,
	    "lng": -54.20014875009656,
	    "corrected": true
	}, {
	    "i": "6ge858s2fezg",
	    "h": "A",
	    "s": "Prudentópolis, PR - BR 277 - Km 302",
	    "r": 100,
	    "p": 12.2,
	    "lat": -25.309619729484435,
	    "lng": -51.16834161803126,
	    "corrected": true
	}, {
	    "i": "6gj6ktvg3hzw",
	    "h": "A",
	    "s": "Palhoça, SC - BR 101 - Km 220",
	    "r": 100,
	    "p": 2.6,
	    "lat": -27.697341022983096,
	    "lng": -48.66151923313737,
	    "corrected": true
	}, {
	    "i": "6gjmmf3kje00",
	    "h": "A",
	    "s": "Porto Belo, SC - BR 101 - Km 159",
	    "r": 200,
	    "p": 2.6,
	    "lat": -27.188978036732614,
	    "lng": -48.61243648454547,
	    "corrected": true
	}, {
	    "i": "6gm2er6jvh20",
	    "h": "A",
	    "s": "Araquari, SC - BR 101 - Km 79",
	    "r": 300,
	    "p": 2.6,
	    "lat": -26.59000960892708,
	    "lng": -48.72182099148631,
	    "corrected": true
	}, {
	    "i": "6gmhpsmcbupc",
	    "h": "A",
	    "s": "Garuva, SC - BR 101 - Km 1",
	    "r": 300,
	    "p": 2.6,
	    "lat": -25.99280557645257,
	    "lng": -48.880866933614016,
	    "corrected": true
	}, {
	    "i": "6gs0cu78dh0k",
	    "h": "A",
	    "s": "Imbituva, PR - BR 373 - Km 217",
	    "r": 100,
	    "p": 10.7,
	    "lat": -25.156968507407463,
	    "lng": -50.54177859798074,
	    "corrected": true
	}, {
	    "i": "6gs4hytpwypz",
	    "h": "A",
	    "s": "Tibagi, PR - BR 376 - Km 457",
	    "r": 500,
	    "p": 10.5,
	    "lat": -24.923842009816163,
	    "lng": -50.408978406339884,
	    "corrected": true
	}, {
	    "i": "6gs6k0zfv4xu",
	    "h": "A",
	    "s": "Carambeí, PR - PR 151 - Km 304",
	    "r": 200,
	    "p": 9.4,
	    "lat": -24.912231303595654,
	    "lng": -50.086793806403875,
	    "corrected": true
	}, {
	    "i": "6sx1j15j3yru",
	    "h": "A",
	    "s": "Porto Morrinhos, MS - BR-262 - Km 714",
	    "r": 2500,
	    "p": 8.5,
	    "lat": -19.50527712429499,
	    "lng": -57.43231588974595,
	    "corrected": true
	}, {
	    "i": "6u0bp6xu8xpb",
	    "h": "A",
	    "s": "Caarapó, MS - BR-163 (BR-163) - Km 277",
	    "r": 1000,
	    "p": 6.5,
	    "lat": -22.485469370394,
	    "lng": -54.86618148162961,
	    "corrected": true
	}, {
	    "i": "6u15x28sknb1",
	    "h": "A",
	    "s": "Rio Brilhante, MS - BR-163 (BR-163) - Km 313",
	    "r": 1000,
	    "p": 6.6,
	    "lat": -21.88125053185993,
	    "lng": -54.5243332721293,
	    "corrected": true
	}, {
	    "i": "6u31pfc6pbpz",
	    "h": "A",
	    "s": "Campo Grande, MS - BR-163 (BR-163) - Km 432",
	    "r": 1000,
	    "p": 7.4,
	    "lat": -20.902528617969224,
	    "lng": -54.50117575004697,
	    "corrected": true
	}, {
	    "i": "6u3mcegx8j84",
	    "h": "A",
	    "s": "Jaraguarí, MS - BR-163 (BR-163) - Km 533",
	    "r": 1000,
	    "p": 5.6,
	    "lat": -20.06107216749964,
	    "lng": -54.42177465185523,
	    "corrected": true
	}, {
	    "i": "6u9305wczvxs",
	    "h": "A",
	    "s": "São Gabriel do Oeste, MS - BR-163 (BR-163) - Km 603",
	    "r": 1000,
	    "p": 5.5,
	    "lat": -19.492078569708863,
	    "lng": -54.482047241181135,
	    "corrected": true
	}, {
	    "i": "6u9j2e91b42j",
	    "h": "A",
	    "s": "Rio Verde de Mato Grosso, MS - BR-163 (BR-163) - Km 703",
	    "r": 1000,
	    "p": 7.3,
	    "lat": -18.74508927940009,
	    "lng": -54.82088869437575,
	    "corrected": true
	}, {
	    "i": "6v80g896upbh",
	    "h": "A",
	    "s": "Nova Mutum, MT - BR-163 (BR-163) - Km 586",
	    "r": 100,
	    "p": 3.8,
	    "lat": -13.927382256221964,
	    "lng": -56.09441293403506,
	    "corrected": true
	}, {
	    "i": "6v81kv3wun04",
	    "h": "A",
	    "s": "Nova Mutum, MT - MT-235 - Km 103",
	    "r": 15,
	    "p": 6.1,
	    "lat": -13.81277784336842,
	    "lng": -56.03900285437703,
	    "corrected": true
	}, {
	    "i": "6trbu0cfnxbp",
	    "h": "A",
	    "s": "Jangada, MT - BR-163 (BR-163) - Km 398",
	    "r": 1000,
	    "p": 5.5,
	    "lat": -15.332386694536094,
	    "lng": -56.42303315922618,
	    "corrected": true
	}, {
	    "i": "6uc4drknxupx",
	    "h": "A",
	    "s": "Pedro Gomes, MS - BR-163 (BR-163) - Km 817",
	    "r": 1000,
	    "p": 5.4,
	    "lat": -17.800821429547142,
	    "lng": -54.73897872492671,
	    "corrected": true
	}, {
	    "i": "6ucn1btu01bj",
	    "h": "A",
	    "s": "Itiquira, MT - BR-163 (BR-163) - Km 33",
	    "r": 1000,
	    "p": 4.5,
	    "lat": -17.223123125865953,
	    "lng": -54.75889479741454,
	    "corrected": true
	}, {
	    "i": "6v0q9td1qyps",
	    "h": "A",
	    "s": "Santo Antônio de Levenger, MT - BR-163 (BR-163) - Km 302",
	    "r": 1000,
	    "p": 4.1,
	    "lat": -15.701920318436867,
	    "lng": -55.82950925454497,
	    "corrected": true
	}, {
	    "i": "6v0wj3y89sz8",
	    "h": "A",
	    "s": "Campo Verde, MT - BR-163 (BR-163) - Km 235",
	    "r": 1000,
	    "p": 4.1,
	    "lat": -15.809817394008167,
	    "lng": -55.30602587386966,
	    "corrected": true
	}, {
	    "i": "6v14dzwksy8k",
	    "h": "A",
	    "s": "Rondonópolis, MT - BR-163 (BR-163) - Km 133",
	    "r": 1000,
	    "p": 5.1,
	    "lat": -16.393689288814826,
	    "lng": -54.71415152773261,
	    "corrected": true
	}, {
	    "i": "6v14vzx4cyb5",
	    "h": "A",
	    "s": "Rondonópolis, MT - MT-130 (MT-130) - Km 9",
	    "r": 1000,
	    "p": 7.4,
	    "lat": -16.349893966689695,
	    "lng": -54.58137480542064,
	    "corrected": true
	}, {
	    "i": "6v1r66bzrqwr",
	    "h": "A",
	    "s": "Primavera do Leste, MT - MT-130 (MT-130) - Km 111",
	    "r": 1000,
	    "p": 7.4,
	    "lat": -15.58420100304414,
	    "lng": -54.39195955172181,
	    "corrected": true
	}, {
	    "i": "6v2hbr73680n",
	    "h": "A",
	    "s": "Diamantino, MT - BR-163 (BR-163) - Km 498",
	    "r": 100,
	    "p": 4.6,
	    "lat": -14.59384269868663,
	    "lng": -56.234313268214464,
	    "corrected": true
	}, {
	    "i": "6v8hmpdgpgx9",
	    "h": "A",
	    "s": "Lucas do Rio Verde, MT - BR-163 (BR-163) - Km 664",
	    "r": 1000,
	    "p": 4.9,
	    "lat": -13.273693030151938,
	    "lng": -56.02620167657733,
	    "corrected": true
	}, {
	    "i": "6v8nnppzeh06",
	    "h": "A",
	    "s": "Lucas do Rio Verde, MT - MT-449 - Km 97",
	    "r": 1000,
	    "p": 5.1,
	    "lat": -12.96841956002487,
	    "lng": -55.9754110313952,
	    "corrected": true
	}, {
	    "i": "6vb2gp4nenbj",
	    "h": "A",
	    "s": "Sorriso, MT - MT-242 - Km 66",
	    "r": 1000,
	    "p": 6.7,
	    "lat": -12.484811602065022,
	    "lng": -55.76373880729079,
	    "corrected": true
	}, {
	    "i": "6vb2jzwu8j81",
	    "h": "A",
	    "s": "Sorriso, MT - MT-242 - Km 83",
	    "r": 100,
	    "p": 7.2,
	    "lat": -12.614233332775354,
	    "lng": -55.63647670671344,
	    "corrected": true
	}, {
	    "i": "6vb3j4ygjsbn",
	    "h": "A",
	    "s": "Sorriso, MT - BR-163 (BR-163) - Km 766",
	    "r": 500,
	    "p": 7,
	    "lat": -12.464833761620154,
	    "lng": -55.66917719319463,
	    "corrected": true
	}, {
	    "i": "7jgbxnekhh8q",
	    "h": "A",
	    "s": "Rafael Jambeiro, BA - BR 116 - Km 482",
	    "r": 2500,
	    "p": 4.5,
	    "lat": -12.531863384368387,
	    "lng": -39.41498586907983,
	    "corrected": true
	}, {
	    "i": "7j6c2epm4zxf",
	    "h": "A",
	    "s": "Vitória da Conquista, BA - BR 116 - Km 873",
	    "r": 300,
	    "p": 4.5,
	    "lat": -15.231766621557627,
	    "lng": -41.100593972951174,
	    "corrected": true
	}, {
	    "i": "7j7m0hp0ssbk",
	    "h": "A",
	    "s": "Planalto, BA - BR 116 - Km 773",
	    "r": 600,
	    "p": 4.5,
	    "lat": -14.567746047812696,
	    "lng": -40.4199049808085,
	    "corrected": true
	}, {
	    "i": "7je2j1k2vfpb",
	    "h": "A",
	    "s": "Manuel Vitorino, BA - BR 116 - Km 698",
	    "r": 1000,
	    "p": 4.5,
	    "lat": -14.056128850477014,
	    "lng": -40.20423190668225,
	    "corrected": true
	}, {
	    "i": "7jetfzb7xfrv",
	    "h": "A",
	    "s": "Brejões / Nova Itarana, BA - BR 116 - Km 566",
	    "r": 500,
	    "p": 4.5,
	    "lat": -13.008817641268761,
	    "lng": -39.957216549664736,
	    "corrected": true
	}, {
	    "i": "7jswzj1gn5b5",
	    "h": "A",
	    "s": "Salvador, BA - BA-526 (BA-526) - Km 8",
	    "r": 200,
	    "p": 3.5,
	    "lat": -12.848006435424672,
	    "lng": -38.361586164683104,
	    "corrected": true
	}, {
	    "i": "7jsxmqyyucxz",
	    "h": "A",
	    "s": "Simões Filho, BA - BR 324 - Km 597",
	    "r": 500,
	    "p": 2.5,
	    "lat": -12.75119941650313,
	    "lng": -38.43152778223157,
	    "corrected": true
	}, {
	    "i": "7jsxv3xh62xz",
	    "h": "A",
	    "s": "Candeias, BA - BA-093 (BA-093) - Km 11",
	    "r": 200,
	    "p": 3.5,
	    "lat": -12.691146182390488,
	    "lng": -38.43139635398984,
	    "corrected": true
	}, {
	    "i": "7jsxwk9evmxb",
	    "h": "A",
	    "s": "Simões Filho, BA - BA-093 (BA-093) - Km 8",
	    "r": 200,
	    "p": 3.5,
	    "lat": -12.718421018919098,
	    "lng": -38.39499341323972,
	    "corrected": true
	}, {
	    "i": "7jsz19fhk0r9",
	    "h": "A",
	    "s": "Camaçari, BA - BA 099 - Km 14",
	    "r": 100,
	    "p": 5.4,
	    "lat": -12.82168705947694,
	    "lng": -38.251399006694555,
	    "corrected": true
	}, {
	    "i": "7jsz21c0huzd",
	    "h": "A",
	    "s": "Camaçari, BA - BA-535 (BA-535) - Km 8",
	    "r": 200,
	    "p": 3.5,
	    "lat": -12.778447000309823,
	    "lng": -38.31873586401343,
	    "corrected": true
	}, {
	    "i": "7ju3pjjnzfrw",
	    "h": "A",
	    "s": "Amélia Rodrigues, BA - BR 324 - Km 551",
	    "r": 500,
	    "p": 2.5,
	    "lat": -12.451584858682125,
	    "lng": -38.708444740623236,
	    "corrected": true
	}, {
	    "i": "7juc204cmhzd",
	    "h": "A",
	    "s": "Mata de São João, BA - BA-093 (BA-093) - Km 44",
	    "r": 200,
	    "p": 3.5,
	    "lat": -12.43678586080589,
	    "lng": -38.315951731055975,
	    "corrected": true
	}, {
	    "i": "7nx050c23uzs",
	    "h": "A",
	    "s": ", PE - (PE-009) - Km 49",
	    "r": 200,
	    "p": 6,
	    "lat": -8.433674465428997,
	    "lng": -35.02283474430442,
	    "corrected": true
	}, {
	    "i": "7nx06g4sqch1",
	    "h": "A",
	    "s": ", PE - (VPE-052) - Km 0",
	    "r": 200,
	    "p": 6,
	    "lat": -8.376382476130939,
	    "lng": -35.031671952456236,
	    "corrected": true
	}, {
	    "i": "7nx07mfc2yg9",
	    "h": "A",
	    "s": "Suape, PE - (PE-009) - Km 40",
	    "r": 200,
	    "p": 6,
	    "lat": -8.3617949133279,
	    "lng": -35.009691920131445,
	    "corrected": true
	}, {
	    "i": "7nx0etd0j6rv",
	    "h": "A",
	    "s": "Cabo de Santo Agostinho, PE - (PE-009) - Km 35",
	    "r": 200,
	    "p": 6,
	    "lat": -8.319336208994185,
	    "lng": -34.99945627525449,
	    "corrected": true
	}, {
	    "i": "7nx0gtdtxmbh",
	    "h": "S",
	    "s": ", PE - (PE-009) - Km 30",
	    "r": 200,
	    "p": 6,
	    "lat": -8.274472936734934,
	    "lng": -34.99870693311095,
	    "corrected": true
	}, {
	    "i": "7nx0u98y3qzc",
	    "h": "N",
	    "s": "Cabo de Santo Agostinho, PE - - (nd) - Km 0",
	    "r": 200,
	    "p": 5,
	    "lat": -8.29631862096385,
	    "lng": -34.95729798451066,
	    "corrected": true
	}, {
	    "i": "7nx1hgwmq3xf",
	    "h": "S",
	    "s": "Jaboatão dos Guararapes, PE - Km 0",
	    "r": 100,
	    "p": 5,
	    "lat": -8.24160322845596,
	    "lng": -34.93867674842477,
	    "corrected": true
	}, {
	    "i": "6fekrps6fr85",
	    "h": "A",
	    "s": "Guaíba, RS - BR 116 - Km 303",
	    "r": 100,
	    "p": 0,
	    "lat": -30.148861869355624,
	    "lng": -51.36592084541917,
	    "corrected": true
	}, {
	    "i": "6fem5b51jr23",
	    "h": "A",
	    "s": "Eldorado do Sul, RS - BR 290 - Km 129",
	    "r": 100,
	    "p": 0,
	    "lat": -30.05838758812191,
	    "lng": -51.51002520695329,
	    "corrected": true
	}, {
	    "i": "6fet0hcyxu25",
	    "h": "S",
	    "s": "Eldorado do Sul, RS - BR 116 (BR 290) - Km 110",
	    "r": 100,
	    "p": 7.1,
	    "lat": -30.031438666395072,
	    "lng": -51.32522536441684,
	    "corrected": true
	}, {
	    "i": "6fetwfb4tx01",
	    "h": "A",
	    "s": "Gravataí, RS - BR 290 - Km 77",
	    "r": 100,
	    "p": 3.5,
	    "lat": -29.954904548409772,
	    "lng": -51.0320277325809,
	    "corrected": true
	}, {
	    "i": "6fgbbcsfdz2r",
	    "h": "A",
	    "s": "Gramado, RS - RS 235 - Km 28",
	    "r": 100,
	    "p": 5.9,
	    "lat": -29.390598096248013,
	    "lng": -50.9368565864861,
	    "corrected": true
	}, {
	    "i": "6fgbhqqz6406",
	    "h": "A",
	    "s": "Três Coroas, RS - RS 115 - Km 23",
	    "r": 3500,
	    "p": 5.9,
	    "lat": -29.495650650637163,
	    "lng": -50.7804318331182,
	    "corrected": true
	}, {
	    "i": "6fgcjtc3eukk",
	    "h": "A",
	    "s": "São Francisco de Paula, RS - RS 235 - Km 55",
	    "r": 1100,
	    "p": 5.9,
	    "lat": -29.323564302605483,
	    "lng": -50.73294533416629,
	    "corrected": true
	}, {
	    "i": "6fsjup2jqj2j",
	    "h": "L",
	    "s": "Sto. Antônio da Patrulha, RS - BR 290 - Km 19",
	    "r": 100,
	    "p": 7.1,
	    "lat": -29.88612822525769,
	    "lng": -50.44885179027915,
	    "corrected": true
	}, {
	    "i": "6fsnbervrq04",
	    "h": "A",
	    "s": "Santo Antônio da Patrulha, RS - RS 474 - Km 20",
	    "r": 100,
	    "p": 5.2,
	    "lat": -29.732172774318908,
	    "lng": -50.59203715994954,
	    "corrected": true
	}, {
	    "i": "6g9c39x48h02",
	    "h": "A",
	    "s": "Céu Azul, PR - BR 277 - Km 620",
	    "r": 100,
	    "p": 11.3,
	    "lat": -25.08415708829425,
	    "lng": -53.71347030624747,
	    "corrected": true
	}, {
	    "i": "6gd1esgws2xy",
	    "h": "A",
	    "s": "Cascavel, PR - BR 277 - Km 569",
	    "r": 200,
	    "p": 12.2,
	    "lat": -25.02157774484489,
	    "lng": -53.27874222770333,
	    "corrected": true
	}, {
	    "i": "6gd55z6zm70n",
	    "h": "A",
	    "s": "Corbélia, PR - BR 369 - Km 493",
	    "r": 100,
	    "p": 12.3,
	    "lat": -24.74400940197031,
	    "lng": -53.26872585341334,
	    "corrected": true
	}, {
	    "i": "6gdwm6cyt52h",
	    "h": "A",
	    "s": "Campo Mourão , PR - BR 369 - Km 377",
	    "r": 100,
	    "p": 12.3,
	    "lat": -24.197639231359133,
	    "lng": -52.501011583954096,
	    "corrected": true
	}, {
	    "i": "6gfcw30ebfzf",
	    "h": "A",
	    "s": "Floresta , PR - PR-317 - Km 127",
	    "r": 100,
	    "p": 12.3,
	    "lat": -23.63643097391547,
	    "lng": -52.10755633190274,
	    "corrected": true
	}, {
	    "i": "6gg4q8ut7m2j",
	    "h": "A",
	    "s": "Mandaguari, PR - BR 376 - Km 200",
	    "r": 70,
	    "p": 8.2,
	    "lat": -23.505630515992387,
	    "lng": -51.739404033869505,
	    "corrected": true
	}, {
	    "i": "6gg7n7k2960j",
	    "h": "A",
	    "s": "Arapongas, PR - BR 369 - Km 178",
	    "r": 50,
	    "p": 8.2,
	    "lat": -23.360930746326236,
	    "lng": -51.39920672401786,
	    "corrected": true
	}, {
	    "i": "6ggg86hj0h2p",
	    "h": "A",
	    "s": "Jataizinho, PR - BR 369 - Km 126",
	    "r": 100,
	    "p": 21,
	    "lat": -23.279066242779052,
	    "lng": -50.959918554872274,
	    "corrected": true
	}, {
	    "i": "6ggvesk4f6b4",
	    "h": "A",
	    "s": "Sertaneja, PR - PR 323 - Km 3",
	    "r": 100,
	    "p": 18,
	    "lat": -22.915603261643593,
	    "lng": -50.817198883742094,
	    "corrected": true
	}, {
	    "i": "6gup6bhbes05",
	    "h": "A",
	    "s": "Assis, SP - Rod. Raposo Tavares (SP 270) - Km 453",
	    "r": 300,
	    "p": 7.9,
	    "lat": -22.632731015200992,
	    "lng": -50.49661187455058,
	    "corrected": true
	}, {
	    "i": "6guq6yzcrgrx",
	    "h": "A",
	    "s": "Palmital, SP - Rod. Raposo Tavares (SP 270) - Km 413",
	    "r": 300,
	    "p": 7.6,
	    "lat": -22.769649670614985,
	    "lng": -50.14518415555358,
	    "corrected": true
	}, {
	    "i": "6u558nusp800",
	    "h": "A",
	    "s": "Caiuá, SP - Rod. Raposo Tavares (SP 270) - Km 639",
	    "r": 400,
	    "p": 6.4,
	    "lat": -21.846912591898345,
	    "lng": -52.024687808007,
	    "corrected": true
	}, {
	    "i": "6u569yummj81",
	    "h": "A",
	    "s": "Presidente Bernardes, SP - Rod. Raposo Tavares (SP 270) - Km 590",
	    "r": 100,
	    "p": 8.5,
	    "lat": -22.021860708488305,
	    "lng": -51.597700249403715,
	    "corrected": true
	}, {
	    "i": "6u58r7dny4bq",
	    "h": "A",
	    "s": "Rancharia, SP - Rod. Raposo Tavares (SP 270) - Km 512",
	    "r": 300,
	    "p": 6.4,
	    "lat": -22.435341679000743,
	    "lng": -51.008136961609125,
	    "corrected": true
	}, {
	    "i": "6u591g3h7zzu",
	    "h": "A",
	    "s": "Regente Feijó, SP - Rod. Raposo Tavares (SP 270) - Km 541",
	    "r": 300,
	    "p": 6.5,
	    "lat": -22.303904161207893,
	    "lng": -51.25330226495862,
	    "corrected": true
	}, {
	    "i": "6u5xzb6usuxf",
	    "h": "A",
	    "s": "Lavínia, SP - Rod. Mal. Rondon (SP 300) - Km 590",
	    "r": 300,
	    "p": 4.5,
	    "lat": -21.136065369203987,
	    "lng": -50.98387973383069,
	    "corrected": true
	}, {
	    "i": "6u5zm74d4urx",
	    "h": "A",
	    "s": "Rubiácea, SP - Rod. Mal. Rondon (SP 300) - Km 560",
	    "r": 100,
	    "p": 5.6,
	    "lat": -21.20906663678572,
	    "lng": -50.742328371852636,
	    "corrected": true
	}, {
	    "i": "6u737zzfsbzc",
	    "h": "A",
	    "s": "Castilho, SP - Rod. Mal. Rondon (SP 300) - Km 655",
	    "r": 100,
	    "p": 3.2,
	    "lat": -20.830910191844342,
	    "lng": -51.503973472863436,
	    "corrected": true
	}, {
	    "i": "6u78d7egpyru",
	    "h": "A",
	    "s": "Guaraçaí, SP - Rod. Mal. Rondon (SP 300) - Km 621",
	    "r": 400,
	    "p": 4.3,
	    "lat": -20.985032228649942,
	    "lng": -51.22336344793439,
	    "corrected": true
	}, {
	    "i": "6uhq1v57rfru",
	    "h": "A",
	    "s": "Glicério, SP - Rod. Mal. Rondon (SP 300) - Km 497",
	    "r": 200,
	    "p": 6.6,
	    "lat": -21.417435763243294,
	    "lng": -50.191847551614046,
	    "corrected": true
	}, {
	    "i": "6uhscxf6kdbn",
	    "h": "A",
	    "s": "Promissão, SP - Rod. Mal. Rondon (SP 300) - Km 455",
	    "r": 100,
	    "p": 5.9,
	    "lat": -21.622109843653412,
	    "lng": -49.85280258581042,
	    "corrected": true
	}, {
	    "i": "6uhsd8q94grt",
	    "h": "A",
	    "s": "Lins, SP - Rod. Transbrasiliana (BR 153) - Km 183",
	    "r": 100,
	    "p": 4.8,
	    "lat": -21.711141573082273,
	    "lng": -49.808403979986906,
	    "corrected": true
	}, {
	    "i": "6uxyrs81nxzu",
	    "h": "A",
	    "s": "Felixlândia, MG - BR-040 (BR-040) - Km 328",
	    "r": 1000,
	    "p": 5.3,
	    "lat": -18.565318744907103,
	    "lng": -45.021082665771246,
	    "corrected": true
	}, {
	    "i": "6uyukc8vdh06",
	    "h": "A",
	    "s": "Lagoa Grande, MG - BR-040 (BR-040) - Km 91",
	    "r": 1000,
	    "p": 5.3,
	    "lat": -17.52497009049107,
	    "lng": -46.54795730486512,
	    "corrected": true
	}, {
	    "i": "6uywdg8k76pg",
	    "h": "A",
	    "s": "Paracatu, MG - BR-040 (BR-040) - Km 18",
	    "r": 1000,
	    "p": 5.3,
	    "lat": -17.11869883633461,
	    "lng": -46.98802599683404,
	    "corrected": true
	}, {
	    "i": "6uz3bmp9gzpb",
	    "h": "A",
	    "s": "João Pinheiro, MG - BR-040 (BR-040) - Km 172",
	    "r": 1000,
	    "p": 5.3,
	    "lat": -17.945693709092957,
	    "lng": -46.034616362303495,
	    "corrected": true
	}, {
	    "i": "6uz8yjw24h0p",
	    "h": "A",
	    "s": "São Gonçalo do Abaeté, MG - BR-040 (BR-040) - Km 254",
	    "r": 1000,
	    "p": 5.3,
	    "lat": -18.1325697139029,
	    "lng": -45.408015456050634,
	    "corrected": true
	}, {
	    "i": "6vhbp30txsb3",
	    "h": "A",
	    "s": "Piracanjuba/Prof. Jamil, GO - BR-153 (BR-153) - Km 553",
	    "r": 1000,
	    "p": 5.2,
	    "lat": -16.868533115718776,
	    "lng": -49.25068387761712,
	    "corrected": true
	}, {
	    "i": "6vj4s81wjcpg",
	    "h": "A",
	    "s": "Goianópolis, GO - BR-060 (BR-060) - Km 107",
	    "r": 1000,
	    "p": 3.6,
	    "lat": -16.438089442577958,
	    "lng": -49.01910262182355,
	    "corrected": true
	}, {
	    "i": "6vjkq7nqux81",
	    "h": "A",
	    "s": "Alexânia, GO - BR-060 (BR-060) - Km 43",
	    "r": 200,
	    "p": 4.9,
	    "lat": -16.109975270353527,
	    "lng": -48.58387095853686,
	    "corrected": true
	}];

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routingMixin = __webpack_require__(236);
	
	var _routingMixin2 = _interopRequireDefault(_routingMixin);
	
	var _route = __webpack_require__(59);
	
	var _route2 = _interopRequireDefault(_route);
	
	var _date = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_routingMixin2.default],
	  data: function data() {
	    return {
	      loading: undefined,
	      route: { version: 0, name: "Nome da Rota", routeId: undefined, flexField1: undefined },
	      editName: false,
	      newName: undefined,
	      editTime: false,
	      newTime: undefined,
	      routeStatus: true,
	      msg: undefined,
	      msgClass: undefined,
	      canSave: false
	    };
	  },
	  mounted: function mounted() {
	    var vm = this;
	  },
	
	  methods: {
	    afterInit: function afterInit() {
	      var _this = this;
	
	      if (this.$route.params.routeId > 0) {
	        if (this.$store.state.routes) {
	          this.route = this.$store.getters.getRouteById(this.$route.params.routeId, this.$route.params.version);
	          this.populateRoute();
	        } else {
	          this.$store.dispatch('getRoutes').then(function (resp) {
	            _this.route = _this.$store.getters.getRouteById(_this.$route.params.routeId, _this.$route.params.version);
	            _this.populateRoute();
	          });
	        }
	      }
	    },
	    populateRoute: function populateRoute() {
	      var _this2 = this;
	
	      this.viaPoints = [];
	      this.locationPoints = [];
	      var i = 0;
	      _.orderBy(this.route.points, ['sequence']).forEach(function (o) {
	        if (o.type == "viapoint") _this2.viaPoints.push(o);else _this2.locationPoints.push(o);
	      });
	      this.routeStatus = this.route.status.statusId == 1;
	
	      this.$nextTick(function () {
	        _this2.calculate();
	      });
	    },
	    createRoute: function createRoute(successMsg) {
	      var _this3 = this;
	
	      this.msgError = this.msg = undefined;
	
	      _.each(this.$refs.ac, function (o) {
	        o.validate();
	      });
	
	      if (!this.route.allCovered) {
	        this.msgError = 'Não é possivel salvar a rota, pois existem pedágios não atendidos pela Move Mais';
	        return;
	      }
	
	      var r = this.route;
	      r.version += 1;
	      r.totalDistance = this.result.totalDistance, r.totalTime = this.result.totalTime, r.totaltollFeeCost = this.result.totaltollFeeCost;
	      r.status = { status: this.routeStatus ? 'ATIVA' : 'INATIVA', statusId: this.routeStatus ? 1 : 2 };
	      r.points = this.locationPoints;
	      r.tollFees = [];
	      r.description = this.directionsDisplay.getDirections().routes[0].overview_polyline;
	
	      _.each(this.result.tolls, function (o) {
	
	        if (o.associateId > 0) {
	          r.tollFees.push({
	            associateId: o.associateId,
	            entryId: o.entryId,
	            tollFeeId: o.id,
	            name: o.description,
	            direction: o.direction,
	            address: o.description,
	            concession: o.associateId,
	            state: o.state,
	            pricePerAxle: o.price,
	            tollSequence: o.sequence,
	            point: {
	              lat: o.lat,
	              lng: o.lng
	            }
	          });
	        }
	      });
	
	      if (r.tollFees.length === 0) {
	        this.msgError = 'Não é possivel salvar, pois, não há nenhum pedágio para rota informada.';
	        return;
	      }
	
	      var seq = this.locationPoints.length + 1;
	      var waysReq = this.directionsDisplay.getDirections().request.waypoints || [];
	      for (var i = 0; i < waysReq.length; i++) {
	
	        if (waysReq[i].stopover === false) {
	          var latlng = {};
	          if (waysReq[i].location && waysReq[i].location.location) latlng = { lat: waysReq[i].location.location.lat(), lng: waysReq[i].location.location.lng() };else latlng = { lat: waysReq[i].location.lat(), lng: waysReq[i].location.lng() };
	
	          r.points.push({ state: 'ND', city: 'ND', address: latlng.lat + "," + latlng.lng, sequence: seq++, type: 'viapoint' });
	        }
	      }
	
	      this.loading = _route2.default.createRoute(r).then(function (res) {
	
	        if (res.status.code == 0) {
	          _this3.msgClass = 'alert-success';
	          _this3.msg = successMsg || res.status.message;
	          _this3.$set(_this3.route, 'routeId', res.routeId);
	          _this3.$set(_this3.route, 'version', res.version);
	          _this3.$router.push({ name: 'routes' });
	        } else {
	          _this3.msgClass = 'alert-danger';
	          _this3.msg = res.data.status.message;
	        }
	      }).catch(function (res) {
	        _this3.msgClass = 'alert-danger';
	        _this3.msg = res.data.status && res.data.status.message || 'Erro, favor tentar novamente';
	      });
	    },
	    ativar: function ativar() {
	      this.routeStatus = true;
	      this.createRoute('Rota ativada com sucesso');
	    },
	    desativar: function desativar() {
	      this.routeStatus = false;
	      this.createRoute('Rota desativada com sucesso');
	    },
	    startEditName: function startEditName() {
	      this.editName = true;
	      this.newName = this.route.name;
	      $('[data-toggle="tooltip"]').tooltip('hide');
	    },
	    cancelEditName: function cancelEditName() {
	      this.editName = false;
	      this.newName = undefined;
	      $('[data-toggle="tooltip"]').tooltip('hide');
	    },
	    confirmEditName: function confirmEditName() {
	      if (!this.newName) return;
	      this.editName = false;
	      this.route.name = this.newName;
	      this.newName = undefined;
	      $('[data-toggle="tooltip"]').tooltip('hide');
	    },
	    startEditTime: function startEditTime() {
	      this.editTime = true;
	      this.newTime = (0, _date.secondsFormatShort)(this.route.totalTime);
	      $('[data-toggle="tooltip"]').tooltip('hide');
	    },
	    cancelEditTime: function cancelEditTime() {
	      this.editTime = false;
	      this.newTime = undefined;
	      $('[data-toggle="tooltip"]').tooltip('hide');
	    },
	    confirmEditTime: function confirmEditTime() {
	      if (this.newTime.length != 8) {
	        return;
	      }
	      this.editTime = false;
	      var h = this.newTime.split(':');
	
	      this.route.totalTime = parseInt(h[0]) * 86400 + parseInt(h[1]) * 3600 + parseInt(h[2]) * 60;
	      this.newTime = undefined;
	      $('[data-toggle="tooltip"]').tooltip('hide');
	    },
	    afterUpdateDirections: function afterUpdateDirections() {
	      this.msgError = this.msg = undefined;
	      var r = this.route;
	      this.$set(r, 'totalDistance', this.result.totalDistance);
	      this.$set(r, 'totalTime', this.result.totalTime);
	      this.$set(r, 'totaltollFeeCost', this.result.totaltollFeeCost);
	      this.$set(r, 'tollFees', []);
	      this.$set(r, 'allCovered', this.result.allCovered);
	
	      _.each(this.result.tolls, function (o) {
	
	        if (o.associateId > 0) {
	          r.tollFees.push({
	            tollFeeId: o.id,
	            name: o.description,
	            direction: o.direction,
	            address: o.description,
	            concession: o.associateId,
	            state: o.state,
	            pricePerAxle: o.price,
	            point: {
	              lat: o.lat,
	              lng: o.lng
	            }
	          });
	        }
	      });
	
	      this.canSave = true;
	    },
	    placeChanged: function placeChanged() {
	      this.canSave = false;
	    }
	  }
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _route = __webpack_require__(59);
	
	var _route2 = _interopRequireDefault(_route);
	
	var _pagination = __webpack_require__(33);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      routes: undefined,
	      page: new _pagination.Page().size(8),
	      loading: undefined,
	      search: '',
	      filterActive: true,
	      routeStatus: true,
	      msgStrong: 'Nova forma de consulta',
	      msg: ' Para saber a relação de rotas cadastradas, faça uma pesquisa individual digitando o nome da rota ou clique na lupa com o campo vazio, para uma consulta geral.',
	      showAlert: true,
	      showAlertWarning: true,
	      warning: false,
	      dataAtual: true
	    };
	  },
	  mounted: function mounted() {
	
	    if (this.allRoutes) {
	      this.routes = this.allRoutes;
	      this.page = this.page.itemCount(this.allRoutes ? this.allRoutes.length : 0);
	    }
	  },
	
	
	  watch: {
	    filterActive: function filterActive() {
	      this.filter();
	      this.search = '';
	      this.page = this.page.page(1);
	    }
	  },
	
	  computed: {
	    allRoutes: function allRoutes() {
	
	      if (this.filterActive) return this.$store.getters.getRoutesActive;
	    },
	    routesPaged: function routesPaged() {
	      if (this.routes && this.page) {
	        for (var i = 0; i < this.routes.length; i++) {
	          this.$set(this.routes[i], 'open', false);
	        }
	
	        return this.routes.slice(this.page.firstIndexShown() - 1, this.page.lastIndexShown());
	      }
	      return undefined;
	    }
	  },
	  methods: {
	    searchRoutes: function searchRoutes() {
	      var _this = this;
	
	      $('[data-toggle="tooltip"]').tooltip();
	      this.loading = this.$store.dispatch('getRoutes', this.search).then(function (resp) {
	
	        if (_this.allRoutes.length !== 0) {
	          _this.routes = _this.allRoutes;
	          _this.page = _this.page.itemCount(_this.allRoutes ? _this.allRoutes.length : 0);
	
	          _this.msgStrong = 'Nova forma de consulta';
	          _this.msg = 'Para saber a relação de rotas cadastradas, faça uma pesquisa individual digitando o nome da rota ou clique na lupa com o campo vazio, para uma consulta geral.';
	          _this.warning = false;
	        } else {
	          _this.msgStrong = 'Rota não encontrada!';
	          _this.msg = 'Faça uma nova busca ou cadastre uma nova rota.';
	          _this.warning = true;
	        }
	        _this.showAlert = true;
	        _this.showAlertWarning = true;
	      });
	    },
	    setCurrentPage: function setCurrentPage(p) {
	      this.page = this.page.page(p);
	      this.find();
	    },
	    desativar: function desativar(route) {
	      var _this2 = this;
	
	      _messageDialog2.default.show({
	        title: 'Excluir rota',
	        message: 'Deseja excluir essa rota?',
	        type: 'YES-NO'
	      }).then(function (res) {
	        if (res == 'YES') {
	          _this2.routeStatus = false;
	          _this2.createRoute('Rota excluída com sucesso', route);
	        }
	      });
	    },
	    createRoute: function createRoute(successMsg, route) {
	      var _this3 = this;
	
	      var r = route;
	      r.version += 1;
	      r.status = { status: this.routeStatus ? 'ATIVA' : 'INATIVA', statusId: this.routeStatus ? 1 : 2 };
	
	      this.loading = _route2.default.createRoute(r).then(function (res) {
	
	        if (res.status.code == 0) {
	          _this3.$store.commit('deleteRoute', r.routeId);
	        } else {
	          _this3.$router.push({ name: 'routes' });
	        }
	      }).catch(function (res) {
	        _this3.$router.push({ name: 'routes' });
	      });
	    },
	    getCity: function getCity(route, type) {
	      var p = _.find(route.points, function (o) {
	        return o.type == type;
	      });
	
	      if (p) return p.city + ', ' + p.state;
	
	      return "";
	    },
	    getAddress: function getAddress(route, type) {
	      var p = _.find(route.points, function (o) {
	        return o.type == type;
	      });
	
	      if (p) return p.address;
	
	      return "";
	    },
	    imageMap: function imageMap(r) {
	      var origin = this.getAddress(r, 'origin');
	      var dest = this.getAddress(r, 'destination');
	      var url = "https://maps.googleapis.com/maps/api/staticmap?scale=1&size=260x150&maptype=roadmap&format=png&visual_refresh=true";
	      url += '&markers=icon:https://movemais.com/static/pins/pin-origin-small.png%7Cshadow:true%7C' + origin;
	      url += '&markers=icon:https://movemais.com/static/pins/pin-destination-small.png%7Cshadow:true%7C' + dest;
	
	      _.filter(r.points, function (o) {
	        return o.type == 'waypoint';
	      }).forEach(function (o) {
	        url += '&markers=icon:https://movemais.com/static/pins/pin-waypoint-small.png%7Cshadow:true%7C' + o.address;
	      });
	
	      _.forEach(r.tollFeesPoint, function (o) {
	        url += '&markers=icon:https://movemais.com/static/pins/pin-toll-small.png%7Cshadow:true%7C' + o.lat + ',' + o.lng;
	      });
	
	      url += '&path=enc:' + r.description + '&key=AIzaSyAzAwCX1zCJ9idWkNdxs39j36N4lAToIjE';
	
	      return url;
	    },
	
	
	    filter: _.debounce(function () {
	      var _this4 = this;
	
	      this.page = this.page.page(1);
	      this.search = this.search.toUpperCase();
	
	      if (!this.allRoutes) return;
	
	      if (this.search == '') {
	        this.routes = this.allRoutes;
	        this.page = this.page.itemCount(this.routes.length);
	
	        if (this.routes.length === 0) {
	          this.showAlert = true;
	        } else {
	          this.showAlert = false;
	        }
	
	        return;
	      }
	      this.routes = this.allRoutes.filter(function (value) {
	        var a = value.name.toUpperCase().indexOf(_this4.search) >= 0 || value.flexfield1 && value.flexfield1.toUpperCase().indexOf(_this4.search) >= 0 || value.flexfield2 && value.flexfield2.toUpperCase().indexOf(_this4.search) >= 0;
	        var b = _.filter(value.points, function (o) {
	
	          return o.address && o.address.toUpperCase().indexOf(_this4.search) >= 0;
	        }).length > 0;
	
	        return a || b;
	      });
	
	      if (this.routes.length == 0) {
	        this.msgStrong = 'Rota não encontrada!';
	        this.msgAlert = 'Faça uma nova busca ou cadastre uma nova rota.';
	        this.warning = true;
	        this.showAlert = true;
	      } else {
	        this.showAlert = false;
	      }
	
	      this.page = this.page.itemCount(this.routes.length);
	    }, 400)
	
	  },
	  components: {
	    Pagination: _pagination2.default
	  }
	};
	
	var r = [{ "routeId": 1, "name": "Rota 1", "version": 1, "totalDistance": 284, "totalTime": 12508, "totaltollFeeCost": 8860, "routeStatus": { "status": "ATIVO" }, "pointList": { "pointLocation": [{ "type": "origin", "sequence": 1, "address": "Av. João Soares e Arruda - Jardim das Flores, Araraquara - SP, Brasil", "neighborhood": "Jardim das Flores", "city": "Araraquara", "state": "SP", "country": "BR", "lat": -21.789641, "lng": -48.205943700000034 }, { "type": "waypoint", "sequence": 2, "city": "São Carlos", "state": "SP", "country": "BR", "address": "São Carlos, SP, Brasil", "lat": -22.0087082, "lng": -47.89092629999999 }, { "type": "destination", "sequence": 3, "city": "São Paulo", "state": "SP", "country": "BR", "address": "São Paulo, SP, Brasil", "lat": -23.5505199, "lng": -46.63330940000003 }] }, "tollFeeList": { "tollFee": [{ "direction": "S", "address": "Caieiras - Caieiras", "concession": 61800259, "pricePerAxle": 1760, "point": { "lat": -23.347094, "lng": -46.813283 } }, { "direction": "S", "address": "Itupeva Sul - Itupeva", "concession": 61800259, "pricePerAxle": 1740, "point": { "lat": -23.058, "lng": -47.044724 } }, { "direction": "S", "address": "Nova Odessa Sul - Nova Odessa", "concession": 61800259, "pricePerAxle": 1540, "point": { "lat": -22.771006, "lng": -47.239073 } }, { "direction": "S", "address": "Limeira A Sul - Limeira", "concession": 61800259, "pricePerAxle": 1160, "point": { "lat": -22.510022, "lng": -47.397656 } }, { "direction": "S", "address": "Itirapina - Itirapina", "concession": 61800263, "pricePerAxle": 1000, "point": { "lat": -22.128961, "lng": -47.808042 } }, { "direction": "S", "address": "Rio Claro - Rio Claro", "concession": 61800263, "pricePerAxle": 1660, "point": { "lat": -22.374028, "lng": -47.620564 } }] } }, { "routeId": 2, "name": "Rota 2", "version": 2, "totalDistance": 352, "totalTime": 15834, "totaltollFeeCost": 13900, "routeStatus": { "status": "ATIVO" }, "pointList": { "pointLocation": [{ "type": "origin", "sequence": 1, "city": "Araraquara", "state": "SP", "country": "BR", "address": "Araraquara, SP, Brasil", "lat": -21.7848272, "lng": -48.178648599999974 }, { "type": "destination", "sequence": 2, "city": "Santos", "state": "SP", "country": "BR", "address": "Santos, SP, Brasil", "lat": -23.9678823, "lng": -46.32888650000001 }] }, "tollFeeList": { "tollFee": [{ "direction": "S", "address": "Caieiras - Caieiras", "concession": 61800259, "pricePerAxle": 1760, "point": { "lat": -23.347094, "lng": -46.813283 } }, { "direction": "S", "address": "Itupeva Sul - Itupeva", "concession": 61800259, "pricePerAxle": 1740, "point": { "lat": -23.058, "lng": -47.044724 } }, { "direction": "S", "address": "Nova Odessa Sul - Nova Odessa", "concession": 61800259, "pricePerAxle": 1540, "point": { "lat": -22.771006, "lng": -47.239073 } }, { "direction": "S", "address": "Limeira A Sul - Limeira", "concession": 61800259, "pricePerAxle": 1160, "point": { "lat": -22.510022, "lng": -47.397656 } }, { "direction": "S", "address": "Itirapina - Itirapina", "concession": 61800263, "pricePerAxle": 1000, "point": { "lat": -22.128961, "lng": -47.808042 } }, { "direction": "S", "address": "Rio Claro - Rio Claro", "concession": 61800263, "pricePerAxle": 1660, "point": { "lat": -22.374028, "lng": -47.620564 } }, { "direction": "S", "address": "Piratininga - Diadema", "concession": 61800270, "pricePerAxle": 5040, "point": { "lat": -23.820748, "lng": -46.582723 } }] } }, { "routeId": 1, "name": "Rota 1", "version": 1, "totalDistance": 284, "totalTime": 12508, "totaltollFeeCost": 8860, "routeStatus": { "status": "ATIVO" }, "pointList": { "pointLocation": [{ "type": "origin", "sequence": 1, "address": "Av. João Soares e Arruda - Jardim das Flores, Araraquara - SP, Brasil", "neighborhood": "Jardim das Flores", "city": "Araraquara", "state": "SP", "country": "BR", "lat": -21.789641, "lng": -48.205943700000034 }, { "type": "waypoint", "sequence": 2, "city": "São Carlos", "state": "SP", "country": "BR", "address": "São Carlos, SP, Brasil", "lat": -22.0087082, "lng": -47.89092629999999 }, { "type": "destination", "sequence": 3, "city": "São Paulo", "state": "SP", "country": "BR", "address": "São Paulo, SP, Brasil", "lat": -23.5505199, "lng": -46.63330940000003 }] }, "tollFeeList": { "tollFee": [{ "direction": "S", "address": "Caieiras - Caieiras", "concession": 61800259, "pricePerAxle": 1760, "point": { "lat": -23.347094, "lng": -46.813283 } }, { "direction": "S", "address": "Itupeva Sul - Itupeva", "concession": 61800259, "pricePerAxle": 1740, "point": { "lat": -23.058, "lng": -47.044724 } }, { "direction": "S", "address": "Nova Odessa Sul - Nova Odessa", "concession": 61800259, "pricePerAxle": 1540, "point": { "lat": -22.771006, "lng": -47.239073 } }, { "direction": "S", "address": "Limeira A Sul - Limeira", "concession": 61800259, "pricePerAxle": 1160, "point": { "lat": -22.510022, "lng": -47.397656 } }, { "direction": "S", "address": "Itirapina - Itirapina", "concession": 61800263, "pricePerAxle": 1000, "point": { "lat": -22.128961, "lng": -47.808042 } }, { "direction": "S", "address": "Rio Claro - Rio Claro", "concession": 61800263, "pricePerAxle": 1660, "point": { "lat": -22.374028, "lng": -47.620564 } }] } }, { "routeId": 1, "name": "Rota 1", "version": 1, "totalDistance": 284, "totalTime": 12508, "totaltollFeeCost": 8860, "routeStatus": { "status": "ATIVO" }, "pointList": { "pointLocation": [{ "type": "origin", "sequence": 1, "address": "Av. João Soares e Arruda - Jardim das Flores, Araraquara - SP, Brasil", "neighborhood": "Jardim das Flores", "city": "Araraquara", "state": "SP", "country": "BR", "lat": -21.789641, "lng": -48.205943700000034 }, { "type": "waypoint", "sequence": 2, "city": "São Carlos", "state": "SP", "country": "BR", "address": "São Carlos, SP, Brasil", "lat": -22.0087082, "lng": -47.89092629999999 }, { "type": "destination", "sequence": 3, "city": "São Paulo", "state": "SP", "country": "BR", "address": "São Paulo, SP, Brasil", "lat": -23.5505199, "lng": -46.63330940000003 }] }, "tollFeeList": { "tollFee": [{ "direction": "S", "address": "Caieiras - Caieiras", "concession": 61800259, "pricePerAxle": 1760, "point": { "lat": -23.347094, "lng": -46.813283 } }, { "direction": "S", "address": "Itupeva Sul - Itupeva", "concession": 61800259, "pricePerAxle": 1740, "point": { "lat": -23.058, "lng": -47.044724 } }, { "direction": "S", "address": "Nova Odessa Sul - Nova Odessa", "concession": 61800259, "pricePerAxle": 1540, "point": { "lat": -22.771006, "lng": -47.239073 } }, { "direction": "S", "address": "Limeira A Sul - Limeira", "concession": 61800259, "pricePerAxle": 1160, "point": { "lat": -22.510022, "lng": -47.397656 } }, { "direction": "S", "address": "Itirapina - Itirapina", "concession": 61800263, "pricePerAxle": 1000, "point": { "lat": -22.128961, "lng": -47.808042 } }, { "direction": "S", "address": "Rio Claro - Rio Claro", "concession": 61800263, "pricePerAxle": 1660, "point": { "lat": -22.374028, "lng": -47.620564 } }] } }, { "routeId": 1, "name": "Rota 1", "version": 1, "totalDistance": 284, "totalTime": 12508, "totaltollFeeCost": 8860, "routeStatus": { "status": "ATIVO" }, "pointList": { "pointLocation": [{ "type": "origin", "sequence": 1, "address": "Av. João Soares e Arruda - Jardim das Flores, Araraquara - SP, Brasil", "neighborhood": "Jardim das Flores", "city": "Araraquara", "state": "SP", "country": "BR", "lat": -21.789641, "lng": -48.205943700000034 }, { "type": "waypoint", "sequence": 2, "city": "São Carlos", "state": "SP", "country": "BR", "address": "São Carlos, SP, Brasil", "lat": -22.0087082, "lng": -47.89092629999999 }, { "type": "destination", "sequence": 3, "city": "São Paulo", "state": "SP", "country": "BR", "address": "São Paulo, SP, Brasil", "lat": -23.5505199, "lng": -46.63330940000003 }] }, "tollFeeList": { "tollFee": [{ "direction": "S", "address": "Caieiras - Caieiras", "concession": 61800259, "pricePerAxle": 1760, "point": { "lat": -23.347094, "lng": -46.813283 } }, { "direction": "S", "address": "Itupeva Sul - Itupeva", "concession": 61800259, "pricePerAxle": 1740, "point": { "lat": -23.058, "lng": -47.044724 } }, { "direction": "S", "address": "Nova Odessa Sul - Nova Odessa", "concession": 61800259, "pricePerAxle": 1540, "point": { "lat": -22.771006, "lng": -47.239073 } }, { "direction": "S", "address": "Limeira A Sul - Limeira", "concession": 61800259, "pricePerAxle": 1160, "point": { "lat": -22.510022, "lng": -47.397656 } }, { "direction": "S", "address": "Itirapina - Itirapina", "concession": 61800263, "pricePerAxle": 1000, "point": { "lat": -22.128961, "lng": -47.808042 } }, { "direction": "S", "address": "Rio Claro - Rio Claro", "concession": 61800263, "pricePerAxle": 1660, "point": { "lat": -22.374028, "lng": -47.620564 } }] } }, { "routeId": 1, "name": "Rota 1", "version": 1, "totalDistance": 284, "totalTime": 12508, "totaltollFeeCost": 8860, "routeStatus": { "status": "ATIVO" }, "pointList": { "pointLocation": [{ "type": "origin", "sequence": 1, "address": "Av. João Soares e Arruda - Jardim das Flores, Araraquara - SP, Brasil", "neighborhood": "Jardim das Flores", "city": "Araraquara", "state": "SP", "country": "BR", "lat": -21.789641, "lng": -48.205943700000034 }, { "type": "waypoint", "sequence": 2, "city": "São Carlos", "state": "SP", "country": "BR", "address": "São Carlos, SP, Brasil", "lat": -22.0087082, "lng": -47.89092629999999 }, { "type": "destination", "sequence": 3, "city": "São Paulo", "state": "SP", "country": "BR", "address": "São Paulo, SP, Brasil", "lat": -23.5505199, "lng": -46.63330940000003 }] }, "tollFeeList": { "tollFee": [{ "direction": "S", "address": "Caieiras - Caieiras", "concession": 61800259, "pricePerAxle": 1760, "point": { "lat": -23.347094, "lng": -46.813283 } }, { "direction": "S", "address": "Itupeva Sul - Itupeva", "concession": 61800259, "pricePerAxle": 1740, "point": { "lat": -23.058, "lng": -47.044724 } }, { "direction": "S", "address": "Nova Odessa Sul - Nova Odessa", "concession": 61800259, "pricePerAxle": 1540, "point": { "lat": -22.771006, "lng": -47.239073 } }, { "direction": "S", "address": "Limeira A Sul - Limeira", "concession": 61800259, "pricePerAxle": 1160, "point": { "lat": -22.510022, "lng": -47.397656 } }, { "direction": "S", "address": "Itirapina - Itirapina", "concession": 61800263, "pricePerAxle": 1000, "point": { "lat": -22.128961, "lng": -47.808042 } }, { "direction": "S", "address": "Rio Claro - Rio Claro", "concession": 61800263, "pricePerAxle": 1660, "point": { "lat": -22.374028, "lng": -47.620564 } }] } }];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toll = __webpack_require__(26);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['orderData'],
	  data: function data() {
	    return {
	      dataTransfer: undefined,
	      loading: undefined,
	      summaryVP: {}
	    };
	  },
	
	  computed: {},
	  methods: {
	    print: function print() {
	      var prtContent = document.getElementById("comprovante");
	      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	      WinPrint.document.write(prtContent.innerHTML);
	      WinPrint.document.close();
	      WinPrint.focus();
	      WinPrint.print();
	      WinPrint.close();
	    },
	    closeModal: function closeModal() {
	      this.$emit('close', false);
	      this.dataTransfer = {};
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    $('[data-toggle="tooltip"]').tooltip();
	
	    this.loading = _toll2.default.getTransfer(this.orderData.orderId).then(function (resp) {
	      _this.dataTransfer = resp.transfer;
	    }).catch(function (err) {});
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      dataTransfer: undefined
	    };
	  },
	
	  computed: {
	    getDateTransfer: function getDateTransfer() {
	      return (0, _moment2.default)().format('[Transferência efetuada às] H:mm [em] DD/MM/YYYY [via website.]');
	    }
	  },
	  methods: {
	    print: function print() {
	      var prtContent = document.getElementById("comprovante");
	      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	      WinPrint.document.write(prtContent.innerHTML);
	      WinPrint.document.close();
	      WinPrint.focus();
	      WinPrint.print();
	      WinPrint.close();
	    }
	  },
	  mounted: function mounted() {
	    $('[data-toggle="tooltip"]').tooltip();
	
	    this.dataTransfer = this.$route.params.dataTransfer;
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	$(document).ready(function () {
	  $('[data-toggle="tooltip"]').tooltip();
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(48);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toll = __webpack_require__(26);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _transferShipperValue = __webpack_require__(1944);
	
	var _transferShipperValue2 = _interopRequireDefault(_transferShipperValue);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _number = __webpack_require__(24);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _modalReceiptTransfer = __webpack_require__(1943);
	
	var _modalReceiptTransfer2 = _interopRequireDefault(_modalReceiptTransfer);
	
	var _messageDialog = __webpack_require__(53);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _defineProperty3.default)({
	  components: { MessageDialog: _messageDialog2.default },
	  data: function data() {
	    return {
	      loading: undefined,
	      search: undefined,
	      status: '',
	      userReceive: undefined,
	      messageError: undefined,
	      taxIdNumber: undefined,
	      step: 1,
	      transfValue: undefined,
	      contract: undefined,
	      contracts: undefined,
	      contractCred: undefined,
	      checkBalance: false,
	      favored: {},
	      showModalReceipt: false,
	      orderData: {}
	    };
	  },
	
	  computed: {
	    fomatedValue: function fomatedValue() {
	      return (0, _number.centss)(this.transfValue);
	    },
	    checkValue: function checkValue() {
	      return !this.transfValue || this.transfValue === 0;
	    },
	    checkTransferValue: function checkTransferValue() {
	      return this.transfValue * 1.02 > this.contractData.currentBalance.currentTotalBalance;
	    },
	    contratoOrigem: function contratoOrigem() {
	      return this.$route.params.contract.contractId;
	    },
	    fomatedTax: function fomatedTax() {
	      return (0, _number.centss)(this.transfValue * 0.02);
	    },
	    fomatedTotal: function fomatedTotal() {
	      return (0, _number.centss)(this.transfValue * 1.02);
	    },
	    contractData: function contractData() {
	      return this.$route.params.contract;
	    },
	    currentUser: function currentUser() {
	      return _auth2.default.currentUser;
	    }
	  },
	  methods: {
	    nextStep: function nextStep() {
	      switch (this.step) {
	        case 1:
	          if (!this.userReceive) {
	            this.messageError = 'Informe o CNPJ';
	            this.status = 'ERROR';
	            return;
	          }
	          console.log(this.contractCred, "contractCred");
	          console.log(this.userReceive, "userReceive");
	          this.favored = {
	
	            company: this.contractCred.companyName,
	            cnpj: this.userReceive.taxIdNumber,
	            plan: this.contractCred.planName
	          };
	          this.step += 1;
	          break;
	        case 2:
	          if (!this.transfValue || this.transfValue <= 0) {
	            this.messageError = 'Informe o valor a ser creditado';
	            this.status = 'ERROR';
	            return;
	          }
	          this.step += 1;
	          break;
	        default:
	          this.step += 1;
	
	      }
	    },
	    filter: function filter() {
	      var _this = this;
	
	      var vm = this;
	      this.status = 'EMPTY';
	      this.transfValue = 0;
	
	      this.$validator.validateAll().then(function (r) {
	        var searchTaxId = _this.search.replace(/[.\-\/]/g, "").toUpperCase();
	        _this.loading = _account2.default.getUserSimple(searchTaxId).then(function (response) {
	          var vm = _this;
	          _this.userReceive = response;
	          console.log(_this.userReceive, "response user receive");
	          _this.status = 'FOUND';
	          return _contracts2.default.getContractListSimple(searchTaxId, _this.currentUser.taxIdNumber, 0).then(function (res2) {
	            vm.contracts = res2.contracts.filter(function (o) {
	              if (_this.currentUser.taxIdNumber == searchTaxId) {
	                debugger;
	                console.log(o, "o 1");
	                console.log(_this.currentUser, "current user");
	                if (o.contractId != _this.currentUser.onlyOneContract) {
	                  return o;
	                }
	              } else {
	                if (o.planId == 6 || o.planId == 8) {
	                  return o;
	                }
	              }
	            });
	            if (vm.contracts[0].currentBalance != null) {
	              _this.checkBalance = true;
	            }
	          });
	        }).catch(function (error) {
	
	          _messageDialog2.default.show({
	            title: 'Falha',
	            message: 'Não foi encontrado nenhum contrato para receber o crédito da transferência.'
	          });
	          _this.messageError = error.data.status.message;
	          _this.status = 'ERROR';
	        });
	      }).catch(function (err) {
	        _this.status = 'ERROR';
	        _this.messageError = 'CNPJ inválido';
	      });
	    },
	    transfer: function transfer() {
	      var _this2 = this;
	
	      var vm = this;
	      this.loading = _toll2.default.transferirEmbarcador({ contractIdCred: vm.contractCred.contractId, contractIdDeb: vm.contratoOrigem, transferValue: vm.transfValue }).then(function (res) {
	        _this2.orderData = {
	          cnpjCred: _this2.userReceive.taxIdNumber,
	          cnpjDeb: _this2.currentUser.taxIdNumber,
	          planCred: _this2.contractCred.planName,
	          planDeb: _this2.contractData.plan.name,
	          orderId: res.transfer.orderId
	        };
	        _this2.step += 1;
	      }).catch(function (err) {
	        console.log(err);
	        _this2.messageError = err.data.status.message;
	        _this2.status = 'ERROR';
	      });
	
	      this.$store.dispatch('loading', this.loading);
	    },
	    modalReceipt: function modalReceipt() {
	      this.$nextTick(function () {
	        $('#modal-receipt-transfer').modal();
	      });
	    },
	    close: function close(fn) {
	      $('#modal-receipt-transfer').modal('hide');
	      this.showModalReceipt = fn;
	    }
	  }
	}, 'components', {
	  TransferShipperValue: _transferShipperValue2.default, ModalReceiptTransfer: _modalReceiptTransfer2.default
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _pagination = __webpack_require__(33);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _statements = __webpack_require__(171);
	
	var _statements2 = _interopRequireDefault(_statements);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _date = __webpack_require__(38);
	
	var F = _interopRequireWildcard(_date);
	
	var _date2 = __webpack_require__(60);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lastDaysOptions = [{
	  value: '15',
	  caption: 'Últimos 15 dias'
	}, {
	  value: '30',
	  caption: 'Últimos 30 dias'
	}, {
	  value: 'custom',
	  caption: 'Período personalizado'
	}];
	
	
	var pageSizeOptions = [{
	  value: 20,
	  caption: '20'
	}, {
	  value: 40,
	  caption: '40'
	}, {
	  value: 60,
	  caption: '60'
	}, {
	  value: 80,
	  caption: '80'
	}, {
	  value: 100,
	  caption: '100'
	}];
	
	exports.default = {
	  data: function data() {
	    return {
	      lastDays: '15',
	
	      lastDaysOptions: lastDaysOptions,
	      pageSizeOptions: pageSizeOptions,
	
	      customStart: undefined,
	
	      customEnd: undefined,
	
	      loading: _promise2.default.resolve(true),
	
	      page: new _pagination.Page(),
	
	      data: {
	        statements: undefined,
	        summary: undefined
	      },
	
	      searchState: 'NEW',
	      downloadStatementUrl: undefined,
	      plate: undefined,
	      showPlate: false,
	      messageError: undefined,
	      listTransactionRefund: [],
	      rowIsOpen: {},
	      plan: this.$route.params.planId,
	      canDownloadConsolidated: false,
	      downloadingConsolidated: false
	    };
	  },
	
	
	  computed: {
	    contractId: function contractId() {
	      return this.$route.params.contractId;
	    },
	    tutorial: function tutorial() {
	      switch (parseInt(this.$route.params.planId)) {
	        case 28:
	        case 39:
	          return '/api/v2/archeion/downloadFileArcheion/move-mais-entenda-seu-extrato-pos-pago';
	        case 33:
	          return '/api/v2/archeion/downloadFileArcheion/move-mais-entenda-seu-extrato-move-pague';
	        default:
	          return '/api/v2/archeion/downloadFileArcheion/move-mais-entenda-seu-extrato-pre-pago';
	      }
	      return this.$route.params.planId;
	    },
	    periodStart: function periodStart() {
	      var days = this.lastDays;
	      var d = days == 'custom' ? (0, _moment2.default)(this.customStart) : (0, _moment2.default)().subtract(parseInt(days), 'd');
	
	      return d.startOf('day').valueOf();
	    },
	    periodEnd: function periodEnd() {
	      var days = this.lastDays;
	      var d = days == 'custom' ? (0, _moment2.default)(this.customEnd) : (0, _moment2.default)();
	
	      return d.endOf('day').valueOf();
	    }
	  },
	
	  watch: {
	    showPlate: function showPlate(newValue) {
	      if (!newValue) this.plate = undefined;
	      this.invalidateConsolidatedDownload();
	    },
	    lastDays: function lastDays() {
	      this.invalidateConsolidatedDownload();
	    },
	    customStart: function customStart() {
	      this.invalidateConsolidatedDownload();
	    },
	    customEnd: function customEnd() {
	      this.invalidateConsolidatedDownload();
	    },
	    plate: function plate() {
	      this.invalidateConsolidatedDownload();
	    }
	  },
	  mounted: function mounted() {},
	  methods: {
	    invalidateConsolidatedDownload: function invalidateConsolidatedDownload() {
	      this.canDownloadConsolidated = false;
	    },
	    setCurrentPage: function setCurrentPage(p) {
	      this.page = this.page.page(p);
	      this.doFilter();
	    },
	    setPageSize: function setPageSize(size) {
	      this.page = this.page.size(size);
	      this.doFilter();
	    },
	    validate: function validate() {
	      var error = this.errors;
	
	      var filter = {
	        contractId: this.$route.params.contractId,
	        startDate: this.periodStart,
	        endDate: this.periodEnd,
	        page: this.page.build(),
	        plate: this.plate
	      };
	      if (this.plate) {
	        this.showPlate = true;
	      }
	
	      if (this.lastDays == 'custom' && (!this.customStart || !this.customEnd || this.customStart > this.customEnd)) {
	        this.searchState = 'ERROSEARCH';
	        this.messageError = this.customStart && this.customEnd ? 'Impossível filtrar! O período inicial é mais novo que o período final.' : 'Existem campos não preenchidos!';
	        return false;
	      }
	
	      if (this.lastDays == 'custom' && this.customStart && this.customEnd && this.customEnd - this.customStart > 2678400000) {
	        this.searchState = 'ERROSEARCH';
	        this.messageError = 'Período máximo permitido, 31 dias.';
	        return false;
	      }
	
	      return filter;
	    },
	    doFilter: function doFilter(clearCache) {
	      var _this = this;
	
	      var filter = this.validate();
	      if (clearCache) {
	        this.listTransactionRefund = [];
	        filter.page = 1;
	        this.page = filter.page = this.page.page(1);
	      }
	
	      if (filter) {
	        this.canDownloadConsolidated = false;
	        _statements2.default.getSummary(filter).then(function (res) {
	
	          _this.data.summary = res;
	        });
	
	        var promise = _statements2.default.find(filter).then(function (data) {
	
	          _this.data.statements = data;
	          if (_this.data.statements.total) {
	            _this.searchState = 'FOUND';
	            _this.canDownloadConsolidated = true;
	            _this.page = _this.page.itemCount(data.total);
	            _this.$nextTick(function () {
	              $('[data-toggle="tooltip"]').tooltip();
	              $('html, body').stop().animate({
	                scrollTop: $("#resumeTable").offset().top - 110
	              }, 1000);
	            });
	          } else {
	            _this.searchState = 'NOTFOUND';
	            _this.canDownloadConsolidated = false;
	          }
	        }).catch(function (err) {
	          _this.searchState = 'NOTFOUND';
	          _this.canDownloadConsolidated = false;
	        });
	        this.$store.dispatch('loading', promise);
	      }
	    },
	    doFilterDownload: function doFilterDownload() {
	      var _this2 = this;
	
	      if (!this.canDownloadConsolidated || this.downloadingConsolidated) {
	        return;
	      }
	      var filter = this.validate();
	      if (filter) {
	        this.downloadingConsolidated = true;
	        _statements2.default.findExtratoConsolidado(filter).then(function (data) {
	          var url = window.URL.createObjectURL(new Blob([data]));
	          var link = document.createElement('a');
	          link.href = url;
	
	          link.target = '_blank';
	          link.download = 'Extrato_' + filter.contractId + '.xlsx';
	          document.body.appendChild(link);
	          link.click();
	          link.parentNode.removeChild(link);
	          _this2.downloadingConsolidated = false;
	        }).catch(function (err) {
	          _this2.downloadingConsolidated = false;
	          return _messageDialog2.default.show({
	            title: 'Falha ao emitir o relatório',
	            message: err.data.status.message,
	            type: 'OK'
	          });
	        });
	      }
	    },
	    numberClass: function numberClass(summary) {
	      return summary.type == 'C' ? 'green' : summary.type == 'S' ? 'black' : 'red';
	    },
	    downloadExtractFile: function downloadExtractFile(type) {
	      var win = window;
	      var filter = this.validate();
	      if (filter) {
	        _messageDialog2.default.show({
	          title: 'Exportar dados',
	          message: 'Selecione para qual formato deseja exportar:',
	          type: 'DOWNLOAD',
	          statement: {
	            contract: this.$route.params.contractId,
	            startDate: this.periodStart,
	            endDate: this.periodEnd,
	            filter: this.plate,
	            transactions: this.listTransactionRefund.length > 0 && type !== 'full' ? this.listTransactionRefund.toString() : null
	          }
	        });
	      }
	    },
	    download: function download(res) {
	      this.downloadStatementUrl = '/api/v1/statement/' + res + '/' + this.$route.params.contractId + '/' + this.periodStart + '/' + this.periodEnd;
	      if (this.plate) this.downloadStatementUrl += '/' + this.plate;
	      var transaction = this.listTransactionRefund.length > 0 ? this.listTransactionRefund.toString() : null;
	
	      var aTag = window.document.getElementById('mobi');
	      aTag.setAttribute('href', this.downloadStatementUrl);
	      aTag.setAttribute('download', 'teste.xls');
	
	      aTag.click();
	    },
	    b64EncodeUnicode: function b64EncodeUnicode(str) {
	      return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
	        return String.fromCharCode('0x' + p1);
	      }));
	    },
	    getValueClass: function getValueClass(t) {
	      if (parseInt(t.idHistoric) == 99) return "";
	      return t.type == 'C' ? 'green' : 'red';
	    },
	    checkPlan: function checkPlan() {
	      if (this.plan != 23 && this.plan != 24 && this.plan != 28 && this.plan != 39 && this.plan != 8) {
	        return true;
	      }
	    },
	    getClassIcon: function getClassIcon(t) {
	      switch (parseInt(t.idHistoric)) {
	        case 1:
	          return 'icon-not-allowed red';
	
	        case 2:
	          return 'icon-checkmark-outline green';
	
	        case 99:
	          return 'icon-notification yellow';
	
	        case 1001:
	          return 'icon-coin green';
	
	        case 1002:
	          return 'icon-coin green';
	
	        case 1003:
	          return 'icon-coin green';
	
	        case 1004:
	          return 'icon-coin green';
	
	        case 1005:
	          return 'icon-coin green';
	
	        case 1006:
	          return 'icon-coin green';
	
	        case 1007:
	          return 'icon-coin green';
	
	        case 1008:
	          return 'icon-coin green';
	
	        case 1010:
	          return 'icon-plans blue';
	
	        case 2010:
	          return 'icon-reply blue';
	
	        case 1012:
	          return 'icon-coin green';
	
	        case 1067:
	          return 'icon-add-vehicle blue';
	
	        case 1075:
	          return 'icon-sync blue';
	
	        case 1078:
	          return 'icon-percentage purple';
	
	        case 1101:
	          return 'icon-toll red';
	
	        case 2101:
	          return 'icon-reply blue';
	
	        case 1270:
	          return 'icon-coin green';
	
	        case 1313:
	          return 'icon-coin green';
	
	        case 1314:
	          return 'icon-coin green';
	
	        case 1332:
	          return 'icon-calendar yellow';
	
	        case 1401:
	          return 'icon-percentage purple';
	
	        case 1501:
	          return 'icon-percentage purple';
	
	        case 2332:
	          return 'icon-reply blue';
	
	        case 1668:
	          return 'icon-percentage purple';
	
	        case 1669:
	          return 'icon-percentage purple';
	
	        case 1671:
	          return 'icon-percentage purple';
	
	        case 1371:
	          return 'icon-coin green';
	      }
	      return "icon-move-plus gray";
	    },
	    toogleRow: function toogleRow(id) {
	      if (this.rowIsOpen[id]) this.rowIsOpen[id] = false;else this.$set(this.rowIsOpen, id, true);
	    },
	    exportarExtratoConsolidado: function exportarExtratoConsolidado() {
	      if (this.plate.length == 7) {
	        var placa = this.plate;
	        this.plate = placa.replace(/(\w{3})(\d{4})/g, '$1-$2');
	      }
	
	      var filter = {
	        endDate: F.date(this.periodEnd, 'YYYY-MM-DD'),
	        startDate: F.date(this.periodStart, 'YYYY-MM-DD'),
	        plate: this.plate
	      };
	
	      var promise = _statements2.default.exportarExtratoConsolidado(filter).then(function (data) {
	        var url = window.URL.createObjectURL(new Blob([data]));
	        var link = document.createElement('a');
	        link.href = url;
	        link.setAttribute('download', 'ExtratoConsolidado_' + filter.plate + '.xlsx');
	        document.body.appendChild(link);
	        link.click();
	        link.parentNode.removeChild(link);
	      }).catch(function (err) {
	        return _messageDialog2.default.show({
	          title: 'Falha ao emitir o relatório',
	          message: err.data.status.message,
	          type: 'OK'
	        });
	      });
	      this.$store.dispatch('loading', promise);
	    }
	  },
	
	  filters: {
	    plate: function plate(value) {
	      if (!value) return value;
	      return value.substring(0, 3) + " - " + value.substring(3);
	    },
	    local: function local(value) {
	      var p = /.*km[\s0-9]*/.exec(value);
	      if (p && p.length > 0) return p[0];else return value;
	    },
	    barWrap: function barWrap(value) {
	      return value.split("/").join(' / ');
	    }
	  },
	  components: {
	    Pagination: _pagination2.default
	  }
	};
	
	
	var dataUri = {
	  pdf: {
	    data: 'data:application/pdf;base64,',
	    fileName: 'extrato.pdf'
	  },
	  excel: {
	    data: 'data:application/xls;base64,',
	    fileName: 'extrato.xls'
	  },
	  json: {
	    data: 'data:application/txt;charset=utf-8,',
	    fileName: 'extrato.json'
	  }
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(177);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _vehicles = __webpack_require__(29);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	var _ativarTagItem = __webpack_require__(521);
	
	var _ativarTagItem2 = _interopRequireDefault(_ativarTagItem);
	
	var _tag = __webpack_require__(516);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      vehicles: [],
	      vehicleStatic: [],
	      loading: undefined,
	      erroMessage: undefined,
	      length: 1,
	      filter: undefined,
	      aggregateVehicles: undefined,
	      hasAggregate: false,
	      loadingVehicles: false
	    };
	  },
	
	  computed: {
	    contracts: function contracts() {
	      return this.$store.state.contract.contracts;
	    }
	  },
	  components: {
	    ativarTagItem: _ativarTagItem2.default, Tag: _tag2.default
	  },
	  watch: {
	    filter: function filter(newFilter) {
	
	      if (newFilter == undefined || newFilter.length == 0 || newFilter == '') {
	        this.vehicles = this.vehicleStatic;
	        this.length = this.vehicles.length;
	        return;
	      }
	
	      newFilter = newFilter.toUpperCase();
	      this.vehicles = _.filter(this.vehicleStatic, function (vehicle) {
	
	        return vehicle.plate.indexOf(newFilter) !== -1 || vehicle.brandName.indexOf(newFilter) !== -1 || vehicle.modelName.toUpperCase().indexOf(newFilter) !== -1;
	      });
	      this.length = this.vehicles.length;
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.contracts && this.contracts.find(function (contract) {
	      if (contract.plan.planId == 45 || contract.plan.planId == 46) {
	        _this.hasAggregate = true;
	      }
	    });
	
	    var getVehiclesForActivate = _vehicles2.default.getVehiclesForActivate();
	    var getVehiclesForActivateAgg = _vehicles2.default.getVehiclesForActivateAgg();
	
	    this.loadingVehicles = true;
	
	    this.loading = _promise2.default.all([getVehiclesForActivate, getVehiclesForActivateAgg]).then(function (response) {
	      var _response = (0, _slicedToArray3.default)(response, 2),
	          vehicles = _response[0],
	          aggregateVehicles = _response[1];
	
	      _this.vehicles = vehicles;
	      _this.vehicleStatic = _this.vehicles;
	      _this.length = _this.vehicles.length;
	
	      if (_this.hasAggregate) {
	        _this.aggregateVehicles = aggregateVehicles;
	      }
	    }).finally(function () {
	      _this.loadingVehicles = false;
	    });
	  },
	
	  methods: {
	    activatingTag: function activatingTag(promise) {
	      this.loading = promise;
	    },
	    deactivatetagLoading: function deactivatetagLoading() {
	      this.loading = _promise2.default.resolve(true);
	    }
	  }
	};

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _toll = __webpack_require__(26);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	var _date = __webpack_require__(60);
	
	var _date2 = __webpack_require__(38);
	
	var F = _interopRequireWildcard(_date2);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _pagination = __webpack_require__(33);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lastDaysOptions = [{
	  value: '15',
	  caption: 'Últimos 15 dias'
	}, {
	  value: '30',
	  caption: 'Últimos 30 dias'
	}, {
	  value: 'custom',
	  caption: 'Período personalizado'
	}];
	
	var pageSizeOptions = [{
	  value: 20,
	  caption: '20'
	}, {
	  value: 40,
	  caption: '40'
	}, {
	  value: 60,
	  caption: '60'
	}, {
	  value: 80,
	  caption: '80'
	}, {
	  value: 100,
	  caption: '100'
	}];
	
	exports.default = {
	  data: function data() {
	    return {
	      lastDays: '15',
	
	      lastDaysOptions: lastDaysOptions,
	      pageSizeOptions: pageSizeOptions,
	
	      customStart: undefined,
	
	      customEnd: undefined,
	
	      loading: _promise2.default.resolve(true),
	
	      page: new _pagination.Page(),
	
	      data: undefined,
	      listValePedagio: {},
	      searchState: 'NEW',
	      downloadStatementUrl: undefined,
	      plate: undefined,
	      toll: undefined,
	      route: undefined,
	      showPlate: false,
	      showToll: false,
	      showRoute: false,
	      lastFilter: {},
	      messageError: undefined,
	
	      parent: false,
	      rowIsOpen: {}
	    };
	  },
	
	
	  computed: {
	    contractId: function contractId() {
	      return this.$route.params.contractId;
	    },
	    periodStart: function periodStart() {
	      var days = this.lastDays;
	      var d = days == 'custom' ? (0, _moment2.default)(this.customStart) : (0, _moment2.default)().subtract(parseInt(days), 'd');
	
	      return F.date(d, 'YYYY-MM-DD');
	    },
	    periodEnd: function periodEnd() {
	      var days = this.lastDays;
	      var d = days == 'custom' ? (0, _moment2.default)(this.customEnd) : (0, _moment2.default)();
	
	      return F.date(d, 'YYYY-MM-DD');
	    },
	    hasValePedagio: function hasValePedagio() {
	      return this.listValePedagio && this.listValePedagio.length > 0;
	    }
	  },
	
	  watch: {
	    showPlate: function showPlate(newValue) {
	      if (!newValue) this.plate = undefined;
	    },
	    showToll: function showToll(newValue) {
	      if (!newValue) this.toll = undefined;
	    },
	    showRoute: function showRoute(newValue) {
	      if (!newValue) this.route = undefined;
	    }
	  },
	
	  mounted: function mounted() {
	    this.doFilter();
	  },
	  methods: {
	    hasParent: function hasParent() {
	      var _this = this;
	
	      if (this.contractId) {
	        return _contracts2.default.getMoveMaisIdParent(this.contractId).then(function (data) {
	          _this.parent = data > 0 ? true : false;
	          return _this.parent;
	        }).catch(function (err) {
	          _this.parent = false;
	          return _this.parent;
	        });
	      } else {
	        return false;
	      }
	    },
	    setCurrentPage: function setCurrentPage(p) {
	      this.page = this.page.page(p);
	      this.doFilter();
	    },
	    setPageSize: function setPageSize(size) {
	      this.page = this.page.size(size);
	      this.doFilter();
	    },
	    validate: function validate() {
	      var error = this.errors;
	
	
	      var filter = {
	        "placaVeiculo": this.plate,
	        "endDate": this.periodEnd,
	        "startDate": this.periodStart,
	        "idProtocolo": this.toll,
	        "rota": this.route,
	        "contratoOrig": this.contractId,
	        "page": this.page.build()
	      };
	
	      if (this.plate) {
	        this.showPlate = true;
	      }
	
	      if (this.route) {
	        this.showRoute = true;
	      }
	
	      if (this.lastDays == 'custom' && (!this.customStart || !this.customEnd || this.customStart > this.customEnd)) {
	        this.searchState = 'ERROSEARCH';
	        this.messageError = this.customStart && this.customEnd ? 'Impossível filtrar! O período inicial é mais novo que o período final.' : 'Existem campos não preenchidos!';
	        return false;
	      }
	
	      if (this.lastDays == 'custom' && _date.beforeOneYear.validate((0, _moment2.default)(this.customStart).format("L"))) {
	        this.searchState = 'ERROSEARCH';
	        this.messageError = 'Período indisponível! Para consultas de período anteriores a um ano, favor entrar em contato com a nossa Central de Relacionamento.';
	        return false;
	      }
	
	      if (this.lastDays == 'custom' && this.customStart && this.customEnd && this.customEnd - this.customStart > 2678400000) {
	        this.searchState = 'ERROSEARCH';
	        this.messageError = 'Período máximo permitido, 31 dias.';
	        return false;
	      }
	
	      this.lastFilter = filter;
	      return filter;
	    },
	    cancelar: function cancelar(idIntern, placaVeiculo) {
	      var vm = this;
	      _messageDialog2.default.show({
	        title: 'Cancelar vale-pedágio',
	        message: 'Deseja cancelar o vale-pedágio?',
	        type: 'OK-CANCEL-ADHESION'
	      }).then(function (res) {
	        if (res == 'OK') {
	          window.setTimeout(function () {
	            vm.doCancel(idIntern, placaVeiculo);
	          }, 500);
	        }
	      });
	    },
	    doCancel: function doCancel(idIntern, placaVeiculo) {
	      var _this2 = this;
	
	      var vm = this;
	      var promise = _toll2.default.cancelar({ idIntern: idIntern, placaVeiculo: placaVeiculo }).then(function (res) {
	        _this2.doFilter();
	      }).catch(function (err) {
	        vm.$nextTick(function () {
	
	          return _messageDialog2.default.show({
	            title: 'Falha ao cancelar',
	            message: err.data.status.message,
	            type: 'OK'
	          });
	        });
	      });
	      this.$store.dispatch('loading', promise);
	      return promise;
	    },
	    doFilter: function doFilter(clearCache) {
	      var _this3 = this;
	
	      var filter = this.validate();
	
	      this.hasParent();
	
	      if (clearCache) {
	        this.listValePedagio = [];
	        filter.page = 1;
	        this.page = filter.page = this.page.page(1);
	      }
	
	      if (filter) {
	
	        var promise = _toll2.default.getFilter(filter).then(function (data) {
	          if (data) {
	            _this3.listValePedagio = data.itens;
	            _this3.searchState = _this3.data && 'FOUND' || 'NOTFOUND';
	            _this3.page = _this3.page.itemCount(data.total);
	          }
	
	          if (_this3.listValePedagio.length > 0) {
	            _this3.searchState = 'FOUND';
	            _this3.$nextTick(function () {
	              $('[data-toggle="tooltip"]').tooltip();
	              $('html, body').stop().animate({
	                scrollTop: $("#resumeTable").offset().top - 110
	              }, 1000);
	            });
	          } else {
	            _this3.searchState = 'NOTFOUND';
	          }
	        }).catch(function (err) {
	          _this3.searchState = 'NOTFOUND';
	        });
	        this.$store.dispatch('loading', promise);
	      }
	    },
	    exportarRelatorio: function exportarRelatorio(tipo) {
	      if (this.lastFilter) {
	        var req = {
	          filter: this.lastFilter,
	          tipo: tipo
	        };
	        var promise = _toll2.default.exportarRelatorioAcompanhamento(req).then(function (data) {
	          var url = window.URL.createObjectURL(new Blob([data]));
	          var link = document.createElement('a');
	          link.href = url;
	          link.setAttribute('download', 'RelatorioAcompanhamentoVP'.concat(tipo == 'excel' ? '.xlsx' : '.pdf'));
	          document.body.appendChild(link);
	          link.click();
	          link.parentNode.removeChild(link);
	        }).catch(function (err) {
	          return _messageDialog2.default.show({
	            title: 'Falha ao emitir o relatório',
	            message: err.data.status.message,
	            type: 'OK'
	          });
	        });
	        this.$store.dispatch('loading', promise);
	      }
	    },
	    exportarRelatorioCompleto: function exportarRelatorioCompleto() {
	      var _this4 = this;
	
	      var filter = {
	        "endDate": this.periodEnd + " 00:00:00",
	        "startDate": this.periodStart + " 00:00:00",
	        "contractId": this.contractId
	      };
	
	      var promise = _toll2.default.exportarRelatorioCompleto(filter).then(function (data) {
	        var url = window.URL.createObjectURL(new Blob([data]));
	        var link = document.createElement('a');
	        link.href = url;
	        link.setAttribute('download', 'ExtratoCompletoVP_' + _this4.contractId + '.xlsx');
	        document.body.appendChild(link);
	        link.click();
	        link.parentNode.removeChild(link);
	      }).catch(function (err) {
	        return _messageDialog2.default.show({
	          title: 'Falha ao emitir o relatório',
	          message: err.data.status.message,
	          type: 'OK'
	        });
	      });
	      this.$store.dispatch('loading', promise);
	    },
	    exportarRelatorioParent: function exportarRelatorioParent() {
	      var filter = {
	        "endDate": this.periodEnd + " 00:00:00",
	        "startDate": this.periodStart + " 00:00:00",
	        "contractId": this.contractId
	      };
	      var promise = _toll2.default.exportarRelatorioParent(filter).then(function (data) {
	        var url = window.URL.createObjectURL(new Blob([data]));
	        var link = document.createElement('a');
	        link.href = url;
	        link.setAttribute('download', 'acompanhamentoParentVP.xlsx');
	        document.body.appendChild(link);
	        link.click();
	        link.parentNode.removeChild(link);
	      }).catch(function (err) {
	        return _messageDialog2.default.show({
	          title: 'Falha ao emitir o relatório',
	          message: err.data.status.message,
	          type: 'OK'
	        });
	      });
	      this.$store.dispatch('loading', promise);
	    }
	  },
	
	  filters: {
	    plate: function plate(value) {
	      if (!value) return value;
	      return value.substring(0, 3) + " - " + value.substring(3);
	    },
	    toll: function toll(value) {
	      if (!value) return value;
	      return value;
	    },
	    local: function local(value) {
	      var p = /.*km[\s0-9]*/.exec(value);
	      if (p.length > 0) return p[0];else return value;
	    },
	    barWrap: function barWrap(value) {
	      return value.split("/").join(' / ');
	    }
	  },
	  components: {
	    Pagination: _pagination2.default
	  }
	};
	
	
	var dataUri = {
	  pdf: {
	    data: 'data:application/pdf;base64,',
	    fileName: 'extrato.pdf'
	  },
	  excel: {
	    data: 'data:application/xls;base64,',
	    fileName: 'extrato.xls'
	  },
	  json: {
	    data: 'data:application/txt;charset=utf-8,',
	    fileName: 'extrato.json'
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _toll = __webpack_require__(26);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	var _date = __webpack_require__(60);
	
	var _date2 = __webpack_require__(38);
	
	var F = _interopRequireWildcard(_date2);
	
	var _pagination = __webpack_require__(33);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: _promise2.default.resolve(true),
	      page: new _pagination.Page(),
	      saldoVeiculo: undefined,
	      searchState: 'NEW',
	      plate: undefined,
	      messageError: undefined
	    };
	  },
	
	  computed: {
	    contractId: function contractId() {
	
	      return this.$route.params.contractId;
	    }
	  },
	  methods: {
	    setCurrentPage: function setCurrentPage(p) {
	      this.page = this.page.page(p);
	      this.find();
	    },
	    setPageSize: function setPageSize(size) {
	      this.page = this.page.size(size);
	      this.find();
	    },
	    find: function find() {
	      var _this = this;
	
	      var promise = _toll2.default.getSaldoVeiculo(this.plate).then(function (data) {
	        if (data) {
	          _this.saldoVeiculo = data;
	
	          _this.searchState = 'FOUND';
	        }
	
	        _this.$nextTick(function () {
	          $('[data-toggle="tooltip"]').tooltip();
	          $('html, body').stop().animate({
	            scrollTop: $("#resumeTable").offset().top - 110
	          }, 1000);
	        });
	      }).catch(function (err) {
	        _this.searchState = 'NOTFOUND';
	      });
	      this.$store.dispatch('loading', promise);
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNan = __webpack_require__(174);
	
	var _isNan2 = _interopRequireDefault(_isNan);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _string = __webpack_require__(35);
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _number = __webpack_require__(24);
	
	var _utils = __webpack_require__(34);
	
	var Utils = _interopRequireWildcard(_utils);
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _choosePayment = __webpack_require__(1961);
	
	var _choosePayment2 = _interopRequireDefault(_choosePayment);
	
	var _date = __webpack_require__(38);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["value", "hideIncrement"],
	  data: function data() {
	    return {
	      loading: undefined,
	      contract: undefined,
	      rechargeValue: undefined,
	      currentValue: "",
	      rate: 0,
	      credit: 0,
	      user: _auth2.default.currentUser,
	      step: 0,
	      contractPaymentMethodId: undefined,
	      msgError: undefined,
	      cvv: undefined,
	      expirationDate: undefined,
	      disabledButton: true
	    };
	  },
	
	  computed: {
	    getValue: function getValue() {
	      if (this.currentValue || this.currentValue == 0) return (0, _number.centss)(this.currentValue);
	
	      return "";
	    },
	
	    contractId: function contractId() {
	      return this.contract.contractId;
	    },
	    planId: function planId() {
	      return this.contract.plan.planId;
	    },
	    typesAllowed: function typesAllowed() {
	      return this.$store.getters.getPaymentsTypesByPlan(this.planId);
	    },
	    paymentMethodBankBill: function paymentMethodBankBill() {
	      return this.$store.getters.getPlanById(this.planId).paymentMethod.paymentMethod.find(function (e) {
	        return e.paymentMethodId == 106;
	      });
	    }
	  },
	  watch: {
	    value: function value(newValue) {
	      this.currentValue = newValue;
	    }
	  },
	  methods: {
	    putCvv: function putCvv(p) {
	      this.cvv = p;
	    },
	
	    calculateRecharge: _.debounce(function () {
	      var _this = this;
	
	      var promise = _sales2.default.calculateRechargeRate({
	        value: this.currentValue,
	        planId: this.contract.plan.planId,
	        contractId: this.contract.contractId
	      }).then(function (resp) {
	        _this.rate = resp.taxTotal;
	        _this.credit = resp.valueTotal;
	
	        _this.disabledButton = false;
	      }).catch(function (err) {
	        _this.rate = "N/A";
	        _this.credit = 0;
	      });
	      this.$store.dispatch("loading", promise);
	    }, 600),
	    doRecharge: function doRecharge() {
	      var _this2 = this;
	
	      this.msgError = undefined;
	      if (this.credit == 0) {
	        _messageDialog2.default.show({
	          title: "Aviso",
	          headerClass: "modal-danger",
	          message: "Valor de recarga inválido"
	        });
	        return;
	      }
	      if (this.unit == -1 && (!this.rechargeValue || parseInt(this.rechargeValue) < parseInt(this.minValue))) {
	        this.msgError = "Valor de recarga inv\xE1lido";
	
	        return false;
	      }
	      if (!this.contractPaymentMethodId) {
	        this.msgError = "Selecione a forma de pagamento";
	
	        return false;
	      }
	
	      var request = {
	        recharge: {
	          contractId: this.contractId,
	          contractPaymentMethod: this.$refs.choosePayment.getPaymentSelected(),
	          secureCode: this.user.taxIdNumber.substring(0, 4),
	          value: this.currentValue,
	          expirationDate: (0, _date.date)(this.expirationDate),
	          _interface: window.document.webview ? "MOBILE" : "WEBSITE"
	        }
	      };
	
	      var promise = _sales2.default.recharge(request).then(function (resp) {
	        _this2.showMessage(resp);
	      }).catch(function (err) {
	        _this2.showMessage(err.data);
	      });
	      this.$store.dispatch("loading", promise);
	      return promise;
	    },
	    showMessage: function showMessage(resp) {
	      var _this3 = this;
	
	      var code = resp.status.code;
	      if (code == 0) {
	        var msg = "A recarga será disponibilizada na conta Move Mais após a confirmação de pagamento.";
	        if (resp.boletoUrl) {
	          window.open(resp.boletoUrl);
	          msg += "<br><div class='text-center margin-20'><a href='" + resp.boletoUrl + "' class='btn btn-primary' target='_blank'>Imprimir Boleto</a><br></div><small>Caso n\xE3o consiga visualizar o boleto verifique seu bloqeuador de popup.</small>";
	        }
	        _messageDialog2.default.show({
	          title: "Recarga realizada com sucesso",
	          headerClass: "modal-success",
	          message: msg
	        }).then(function (res) {
	          _this3.$router.push({
	            name: "requests"
	          });
	        });
	        return;
	      } else {
	        var _msg = "Ocorreu um problema e não foi possível concluir sua recarga, por favor entre em contato com a Central de Atendimento.";
	        switch (code) {
	          case 9991:
	            _msg = "Não foi possível confirmar o pagamento da sua recarga, por favor verifique os dados do seu cartão.";
	            break;
	          case 9992:
	          case 9993:
	            _msg = resp.status.message;
	        }
	        _messageDialog2.default.show({
	          title: "Erro",
	          headerClass: "modal-danger",
	          message: _msg
	        }).then(function (res) {
	          if (code == 9993) {
	            _this3.$router.push({
	              name: "requests"
	            });
	          }
	        });
	      }
	    },
	    nextStep: function nextStep() {
	      this.msgError = undefined;
	      $("body").stop().animate({
	        scrollTop: 0
	      }, "500", "swing");
	      switch (this.step) {
	        case 0:
	          if (this.credit == 0) {
	            _messageDialog2.default.show({
	              title: "Aviso",
	              headerClass: "modal-danger",
	              message: "Valor de recarga inválido"
	            });
	            return;
	          }
	          this.step += 1;
	          break;
	        case 1:
	          this.step += 1;
	          break;
	      }
	    },
	    backStep: function backStep() {
	      if (this.step == 0) {
	        this.cancelar();
	        return;
	      }
	
	      this.msgError = undefined;
	      $("body").stop().animate({
	        scrollTop: 0
	      }, "500", "swing");
	      this.step -= 1;
	    },
	    cancelar: function cancelar() {
	      var _this4 = this;
	
	      _messageDialog2.default.show({
	        title: "Cancelar compra de créditos",
	        message: "Deseja cancelar a compra de créditos?",
	        type: "OK-CANCEL-ADHESION"
	      }).then(function (res) {
	        if (res == "OK") {
	          _this4.$router.push({
	            name: "plans"
	          });
	        }
	      });
	    },
	    doRequest: function doRequest() {
	      var _this5 = this;
	
	      _messageDialog2.default.show({
	        title: "Comprar créditos",
	        message: "Compra concluida com sucesso!",
	        type: "OK"
	      }).then(function (res) {
	        if (res == "OK") {
	          _this5.$router.push({
	            name: "plans"
	          });
	        }
	      });
	    },
	    goToStep: function goToStep(value) {
	      this.code = undefined;
	      this.step = value;
	    },
	    alterValue: function alterValue(value) {
	      this.disabledButton = true;
	
	      var newValue = this.currentValue + value;
	
	      if (newValue < 0) return false;
	
	      this.setValue("" + newValue);
	    },
	    setValue: function setValue(newValue) {
	      this.disabledButton = true;
	      if (!(0, _isNan2.default)(newValue) && newValue != "") {
	        this.currentValue = parseInt(newValue.replace(/[^0-9]/g, ""));
	        this.$emit("input", this.currentValue);
	        this.calculateRecharge();
	      } else {
	        this.currentValue = newValue;
	        this.$emit("input", undefined);
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this6 = this;
	
	    var moveMaisId = _auth2.default.currentUser.moveMaisId;
	    this.loading = _contracts2.default.findAll(moveMaisId).then(function (response) {
	      _this6.contract = _.find(response, function (o) {
	        return o.plan.planId == 6;
	      });
	    });
	  },
	
	  components: {
	    ChoosePayment: _choosePayment2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _toll = __webpack_require__(26);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	var _date = __webpack_require__(60);
	
	var _date2 = __webpack_require__(38);
	
	var F = _interopRequireWildcard(_date2);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _pagination = __webpack_require__(33);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lastDaysOptions = [{
	  value: '15',
	  caption: 'Últimos 15 dias'
	}, {
	  value: '30',
	  caption: 'Últimos 30 dias'
	}, {
	  value: 'custom',
	  caption: 'Período personalizado'
	}];
	
	var pageSizeOptions = [{
	  value: 20,
	  caption: '20'
	}, {
	  value: 40,
	  caption: '40'
	}, {
	  value: 60,
	  caption: '60'
	}, {
	  value: 80,
	  caption: '80'
	}, {
	  value: 100,
	  caption: '100'
	}];
	
	exports.default = {
	  data: function data() {
	    return {
	      lastDays: '15',
	
	      lastDaysOptions: lastDaysOptions,
	      pageSizeOptions: pageSizeOptions,
	
	      customStart: undefined,
	
	      customEnd: undefined,
	
	      loading: _promise2.default.resolve(true),
	
	      page: new _pagination.Page(),
	
	      data: undefined,
	      listValePedagio: {},
	      searchState: 'NEW',
	      downloadStatementUrl: undefined,
	      plate: undefined,
	      toll: undefined,
	      showPlate: false,
	      showToll: false,
	      messageError: undefined,
	      listTransactionRefund: [],
	      rowIsOpen: {}
	    };
	  },
	
	
	  watch: {
	    showPlate: function showPlate(newValue) {
	      if (!newValue) this.plate = undefined;
	    },
	    showToll: function showToll(newValue) {
	      if (!newValue) this.toll = undefined;
	    }
	  },
	  computed: {
	    contractId: function contractId() {
	
	      return this.$route.params.contractId;
	    },
	    periodStart: function periodStart() {
	      var days = this.lastDays;
	      var d = days == 'custom' ? (0, _moment2.default)(this.customStart) : (0, _moment2.default)().subtract(parseInt(days), 'd');
	
	      return F.date(d, 'YYYY-MM-DD');
	    },
	    periodEnd: function periodEnd() {
	      var days = this.lastDays;
	      var d = days == 'custom' ? (0, _moment2.default)(this.customEnd) : (0, _moment2.default)();
	
	      return F.date(d, 'YYYY-MM-DD');
	    }
	  },
	
	  mounted: function mounted() {
	    this.doFilter();
	  },
	  methods: {
	    setCurrentPage: function setCurrentPage(p) {
	      this.page = this.page.page(p);
	      this.doFilter();
	    },
	    setPageSize: function setPageSize(size) {
	      this.page = this.page.size(size);
	      this.doFilter();
	    },
	    validate: function validate() {
	      var error = this.errors;
	
	
	      var filter = {
	        "placaVeiculo": this.plate,
	        "endDate": this.periodEnd,
	        "startDate": this.periodStart,
	        "idProtocolo": this.toll,
	
	        "pageSize": this.page.size(),
	        "pageNumber": this.page.page(),
	        "moveMaisIdDest": _auth2.default.currentUser.moveMaisId
	      };
	
	      if (this.plate) {
	        this.showPlate = true;
	      }
	
	      if (this.lastDays == 'custom' && (!this.customStart || !this.customEnd || this.customStart > this.customEnd)) {
	        this.searchState = 'ERROSEARCH';
	        this.messageError = this.customStart && this.customEnd ? 'Impossível filtrar! O período inicial é mais novo que o período final.' : 'Existem campos não preenchidos!';
	        return false;
	      }
	
	      if (this.lastDays == 'custom' && _date.beforeOneYear.validate((0, _moment2.default)(this.customStart).format("L"))) {
	        this.searchState = 'ERROSEARCH';
	        this.messageError = 'Período indisponível! Para consultas de período anteriores a um ano, favor entrar em contato com a nossa Central de Relacionamento.';
	        return false;
	      }
	
	      if (this.lastDays == 'custom' && this.customStart && this.customEnd && this.customEnd - this.customStart > 2678400000) {
	        this.searchState = 'ERROSEARCH';
	        this.messageError = 'Período máximo permitido, 31 dias.';
	        return false;
	      }
	
	      return filter;
	    },
	    doFilter: function doFilter(clearCache) {
	      var _this = this;
	
	      var filter = this.validate();
	
	      if (clearCache) {
	        this.listTransactionRefund = [];
	        filter.page = 1;
	        this.page = filter.page = this.page.page(1);
	      }
	
	      if (filter) {
	
	        var promise = _toll2.default.getFilter(filter).then(function (data) {
	          if (data) {
	            _this.listValePedagio = data.itens;
	
	            _this.page = _this.page.itemCount(data.total);
	          }
	
	          if (_this.listValePedagio.length > 0) {
	            _this.searchState = 'FOUND';
	
	            _this.$nextTick(function () {
	              $('[data-toggle="tooltip"]').tooltip();
	              $('html, body').stop().animate({
	                scrollTop: $("#resumeTable").offset().top - 110
	              }, 1000);
	            });
	          } else {
	            _this.searchState = 'NOTFOUND';
	          }
	        }).catch(function (err) {
	          _this.searchState = 'NOTFOUND';
	        });
	        this.$store.dispatch('loading', promise);
	      }
	    }
	  },
	
	
	  filters: {
	    plate: function plate(value) {
	      if (!value) return value;
	      return value.substring(0, 3) + " - " + value.substring(3);
	    },
	    toll: function toll(value) {
	      if (!value) return value;
	      return value;
	    },
	    local: function local(value) {
	      var p = /.*km[\s0-9]*/.exec(value);
	      if (p.length > 0) return p[0];else return value;
	    },
	    barWrap: function barWrap(value) {
	      return value.split("/").join(' / ');
	    }
	  },
	  components: {
	    Pagination: _pagination2.default
	  }
	};
	
	
	var dataUri = {
	  pdf: {
	    data: 'data:application/pdf;base64,',
	    fileName: 'extrato.pdf'
	  },
	  excel: {
	    data: 'data:application/xls;base64,',
	    fileName: 'extrato.xls'
	  },
	  json: {
	    data: 'data:application/txt;charset=utf-8,',
	    fileName: 'extrato.json'
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _toll = __webpack_require__(26);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      dataTransfer: undefined,
	      loading: undefined,
	      summaryVP: {}
	    };
	  },
	
	  computed: {
	    getDateTransfer: function getDateTransfer() {
	      return (0, _moment2.default)().format('[Transferência efetuada às] H:mm [em] DD/MM/YYYY [via website.]');
	    },
	
	    contractId: function contractId() {
	
	      return this.$route.params.contractId;
	    },
	    idVP: function idVP() {
	
	      return this.$route.params.idVP;
	    }
	  },
	  methods: {
	    print: function print() {
	      var prtContent = document.getElementById("comprovante");
	      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	      WinPrint.document.write(prtContent.innerHTML);
	      WinPrint.document.close();
	      WinPrint.focus();
	      WinPrint.print();
	      WinPrint.close();
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    $('[data-toggle="tooltip"]').tooltip();
	
	    this.loading = _toll2.default.getTransfer(this.$route.params.orderId).then(function (resp) {
	      _this.dataTransfer = resp.transfer;
	    }).catch(function (err) {});
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _toll = __webpack_require__(26);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      dataTransfer: undefined,
	      loading: undefined,
	      summaryVP: {}
	    };
	  },
	
	  computed: {
	    getDateTransfer: function getDateTransfer() {
	      return (0, _moment2.default)().format('[Transferência efetuada às] H:mm [em] DD/MM/YYYY [via website.]');
	    },
	
	    contractId: function contractId() {
	
	      return this.$route.params.contractId;
	    },
	    idVP: function idVP() {
	
	      return this.$route.params.idVP;
	    }
	  },
	
	  methods: {
	    print: function print() {
	      var prtContent = document.getElementById("comprovante");
	      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
	      WinPrint.document.write(prtContent.innerHTML);
	      WinPrint.document.close();
	      WinPrint.focus();
	      WinPrint.print();
	      WinPrint.close();
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    $('[data-toggle="tooltip"]').tooltip();
	
	    this.dataTransfer = this.$route.params.dataTransfer;
	
	    return this.loading = _toll2.default.getById(this.idVP).then(function (resp) {
	      _this.summaryVP = resp;
	    }).catch(function (err) {});
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _pagination = __webpack_require__(33);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _statements = __webpack_require__(171);
	
	var _statements2 = _interopRequireDefault(_statements);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _date = __webpack_require__(38);
	
	var F = _interopRequireWildcard(_date);
	
	var _date2 = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var lastDaysOptions = [{
	  value: '15',
	  caption: 'Últimos 15 dias'
	}, {
	  value: '30',
	  caption: 'Últimos 30 dias'
	}, {
	  value: 'custom',
	  caption: 'Período personalizado'
	}];
	
	
	var pageSizeOptions = [{
	  value: 20,
	  caption: '20'
	}, {
	  value: 40,
	  caption: '40'
	}, {
	  value: 60,
	  caption: '60'
	}, {
	  value: 80,
	  caption: '80'
	}, {
	  value: 100,
	  caption: '100'
	}];
	
	exports.default = {
	  data: function data() {
	    return {
	      lastDays: '15',
	      lastDaysOptions: lastDaysOptions,
	      pageSizeOptions: pageSizeOptions,
	
	      customStart: undefined,
	
	      customEnd: undefined,
	      searchState: 'NEW',
	      plate: undefined,
	      showPlate: false,
	      vehiclesBalance: undefined,
	
	      page: new _pagination.Page(),
	      arrayPlate: new Array()
	    };
	  },
	
	  computed: {
	    contractId: function contractId() {
	      return this.$route.params.contractId;
	    },
	    currentUser: function currentUser() {
	      return _auth2.default.currentUser;
	    },
	    periodStart: function periodStart() {
	      var days = this.lastDays;
	      var d = days == 'custom' ? (0, _moment2.default)(this.customStart) : (0, _moment2.default)().subtract(parseInt(days), 'd');
	
	      return d.startOf('day').valueOf();
	    },
	    periodEnd: function periodEnd() {
	      var days = this.lastDays;
	      var d = days == 'custom' ? (0, _moment2.default)(this.customEnd) : (0, _moment2.default)();
	
	      return d.endOf('day').valueOf();
	    }
	  },
	  mounted: function mounted() {
	    this.doFilter();
	  },
	
	  methods: {
	    setCurrentPage: function setCurrentPage(p) {
	      this.page = this.page.page(p);
	      $('.check-item').each(function () {
	        this.checked = false;
	      });
	
	      this.doFilter();
	    },
	    setPageSize: function setPageSize(size) {
	      this.page = this.page.size(size);
	      this.doFilter();
	    },
	    checkAll: function checkAll() {
	      var _this = this;
	
	      var checkAll = document.getElementById('selectAll');
	      if (checkAll.checked) {
	        $('.check-item').each(function () {
	          this.checked = true;
	        });
	        _statements2.default.getSaldoVeiculosFull({ 'moveMaisId': _auth2.default.currentUser.moveMaisId }).then(function (data) {
	          data.itens.forEach(function (o) {
	            _this.arrayPlate.push(o.plate);
	          });
	        });
	      } else {
	        $('.check-item').each(function () {
	          this.checked = false;
	        });
	        this.arrayPlate = new Array();
	      }
	    },
	    check: function check(id) {
	      var value = $('#' + id).parents('tr').find('.td-plate').text();
	
	      if (this.arrayPlate.indexOf(value) !== -1) {
	        document.getElementById(id).checked = false;
	        this.arrayPlate.splice(this.arrayPlate.indexOf(value), 1);
	      } else {
	        this.arrayPlate.push(value);
	      }
	    },
	    validate: function validate() {
	      var error = this.errors;
	
	      var filter = {
	        moveMaisId: _auth2.default.currentUser.moveMaisId,
	
	        plate: this.plate,
	        page: this.page.build()
	      };
	
	      if (filter.plate == "") {
	        delete filter.plate;
	      }
	
	      if (this.lastDays == 'custom' && (!this.customStart || !this.customEnd || this.customStart > this.customEnd)) {
	        this.searchState = 'ERROSEARCH';
	        this.messageError = this.customStart && this.customEnd ? 'Impossível filtrar! O período inicial é mais novo que o período final.' : 'Existem campos não preenchidos!';
	        return false;
	      }
	
	      if (this.lastDays == 'custom' && _date2.beforeOneYear.validate((0, _moment2.default)(this.customStart).format("L"))) {
	        this.searchState = 'ERROSEARCH';
	        this.messageError = 'Período indisponível! Para consultas de período anteriores a um ano, favor entrar em contato com a nossa Central de Relacionamento.';
	        return false;
	      }
	
	      if (this.lastDays == 'custom' && this.customStart && this.customEnd && this.customEnd - this.customStart > 2678400000) {
	        this.searchState = 'ERROSEARCH';
	        this.messageError = 'Período máximo permitido, 31 dias.';
	        return false;
	      }
	
	      return filter;
	    },
	    doFilter: function doFilter(clearCache) {
	      var _this2 = this;
	
	      var filter = this.validate();
	      $('.check-item').each(function () {
	        this.checked = false;
	      });
	
	      if (clearCache) {
	        this.listTransactionRefund = [];
	        filter.page = 1;
	        this.page = filter.page = this.page.page(1);
	      }
	
	      if (filter) {
	        var promise = _statements2.default.getSaldoVeiculosFull(filter).then(function (data) {
	          _this2.vehiclesBalance = data.itens;
	          if (data.total) {
	            _this2.searchState = 'FOUND';
	            _this2.page = _this2.page.itemCount(data.total);
	            _this2.$nextTick(function () {
	              $('[data-toggle="tooltip"]').tooltip();
	              $('html, body').stop().animate({
	                scrollTop: $("#vehicleFullTable").offset().top - 110
	              }, 1000);
	            });
	          } else {
	            _this2.searchState = 'NOTFOUND';
	          }
	        }).catch(function (err) {
	          _this2.searchState = 'NOTFOUND';
	        });
	        this.$store.dispatch('loading', promise);
	      }
	    },
	    exportarExtratoConsolidado: function exportarExtratoConsolidado() {
	
	      if (this.arrayPlate.length > 0) {
	        var filter = {
	          endDate: F.date(this.periodEnd, 'YYYY-MM-DD'),
	          startDate: F.date(this.periodStart, 'YYYY-MM-DD'),
	          plate: this.arrayPlate,
	          moveMaisId: _auth2.default.currentUser.moveMaisId
	        };
	        var promise = _statements2.default.exportarExtratoConsolidadoNew(filter).then(function (data) {
	          var url = window.URL.createObjectURL(new Blob([data]));
	          var link = document.createElement('a');
	          link.href = url;
	          link.setAttribute('download', 'ExtratoConsolidado_' + filter.moveMaisId + '.xlsx');
	          document.body.appendChild(link);
	          link.target = "_blank";
	          link.click();
	          link.parentNode.removeChild(link);
	        }).catch(function (err) {
	          return _messageDialog2.default.show({
	            title: 'Falha ao emitir o relatório',
	            message: err.data.status.message,
	            type: 'OK'
	          });
	        });
	        this.$store.dispatch('loading', promise);
	      } else {
	        return _messageDialog2.default.show({
	          title: 'Falha ao emitir o relatório',
	          message: 'Selecione ao menos uma placa para extrair o relatório.',
	          type: 'OK'
	        });
	      }
	    },
	    removePlate: function removePlate(plate) {
	
	      if (this.arrayPlate.indexOf(plate) !== -1) {
	        this.arrayPlate.splice(this.arrayPlate.indexOf(plate), 1);
	        $('#vehicleFullTable').find("." + plate).parents('tr').find('.check-item').prop('checked', false);
	      }
	    }
	  },
	  filters: {
	    plate: function plate(value) {
	      if (!value) return value;
	      return value.substring(0, 3) + " - " + value.substring(3);
	    },
	    local: function local(value) {
	      var p = /.*km[\s0-9]*/.exec(value);
	      if (p && p.length > 0) return p[0];else return value;
	    },
	    barWrap: function barWrap(value) {
	      return value.split("/").join(' / ');
	    }
	  },
	  components: {
	    Pagination: _pagination2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toll = __webpack_require__(26);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: undefined,
	      summaryVP: {}
	    };
	  },
	
	  computed: {
	    contractId: function contractId() {
	
	      return this.$route.params.contractId;
	    },
	    idVP: function idVP() {
	
	      return this.$route.params.idVP;
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return this.loading = _toll2.default.getById(this.idVP).then(function (resp) {
	      _this.summaryVP = resp;
	    }).catch(function (err) {});
	  },
	  methods: {
	    cancelar: function cancelar(idIntern, placaVeiculo) {
	      var _this2 = this;
	
	      var vm = this;
	      _messageDialog2.default.show({
	        title: 'Cancelar vale-pedágio',
	        message: 'Deseja cancelar o vale-pedágio?',
	        type: 'OK-CANCEL-ADHESION'
	      }).then(function (res) {
	        if (res == 'OK') {
	          _toll2.default.cancelar({ idIntern: idIntern, placaVeiculo: placaVeiculo }).then(function (res) {
	
	            _this2.$router.push({ name: 'accompaniment' });
	          }).catch(function (err) {
	
	            window.setTimeout(function () {
	              return _messageDialog2.default.show({
	                title: 'Falha ao cancelar',
	                message: err.data.status.message,
	                type: 'OK'
	              });
	            }, 500);
	          });
	        }
	      });
	    },
	    handlePrint: function handlePrint() {
	      var conteudo = document.querySelector('.width-print').innerHTML;
	      var janela = window.open('', '_blank');
	
	      janela.document.write('\n        <html>\n          <head>\n            <title>Impress\xE3o</title>\n            <style>\n              body {\n                font-family: Arial, sans-serif;\n                margin: 20px;\n              }\n\n              .print-title {\n                text-align: center;\n\n              }\n\n              .logo-print {\n                display: block;\n                height: 60px;\n                margin-bottom: 20px;\n              }\n\n              table {\n                width: 100%;\n                border-collapse: collapse;\n              }\n\n              td, th {\n                padding: 8px;\n                border: 1px solid #ccc;\n              }\n            </style>\n          </head>\n          <body>\n            <img src="data:image/svg+xml;base64,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" alt="Logo" class="logo-print"/>\n            ' + conteudo + '\n          </body>\n        </html>\n      ');
	      janela.document.close();
	      janela.onload = function () {
	        janela.focus();
	        janela.print();
	        setTimeout(function () {
	          janela.close();
	        }, 100);
	      };
	    }
	  }
	};

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _routeResume = __webpack_require__(1887);
	
	var _routeResume2 = _interopRequireDefault(_routeResume);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _toll = __webpack_require__(26);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	var _cpfCnpj = __webpack_require__(86);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _dateFns = __webpack_require__(208);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    var currentDate = new Date();
	    var minDate = (0, _dateFns.addMinutes)(currentDate, 10);
	    var maxDate = (0, _dateFns.setMinutes)((0, _dateFns.setHours)((0, _dateFns.addDays)(currentDate, 30), 23), 59);
	    var formattedMinDate = (0, _dateFns.format)(minDate, "yyyy-MM-dd'T'HH:mm");
	    var formattedMaxDate = (0, _dateFns.format)(maxDate, "yyyy-MM-dd'T'HH:mm");
	
	    return {
	      minDate: formattedMinDate,
	      maxDate: formattedMaxDate,
	      dataInicioViagem: formattedMinDate,
	      dataFimViagem: '',
	      loading: undefined,
	      priceTolls: {},
	      listValePedagio: {},
	      docs: 'cte',
	      expirationDays: 1,
	      taxIdNumber: undefined,
	      dataViagemInicial: undefined,
	      dataViagemFim: undefined,
	      user: _auth2.default.currentUser,
	      status: '',
	      axesId: 2,
	      step: 0,
	      plate: undefined,
	      vehicle: undefined,
	      messageError: undefined,
	      routeSelected: undefined,
	      msgError: undefined,
	      docEmbarqueNum: undefined,
	      docEmbarqueTipo: undefined,
	      search: '',
	      filterActive: true,
	      forceTransfer: false,
	      showForceTransfer: false,
	      motorista: '',
	      externalId: '',
	      campo1: '',
	      campo2: '',
	      campo3: '',
	      campo4: '',
	      campo5: '',
	      enableRNTRC: false,
	      rntrcDocument: '',
	      rntrcOwnerName: '',
	      nomeTransportador: '',
	      documentoTransportador: '',
	      rntrcRejected: false,
	      rntrcExceptionCreated: false,
	      createException: false,
	      rntrcRejectedDocument: '',
	      rntrcRejectedName: '',
	      idIntern: undefined
	    };
	  },
	
	  watch: {
	    dataFimViagem: function dataFimViagem(value) {
	      this.dataViagemFim = value;
	    },
	    filterActive: function filterActive() {
	      this.filter();
	    }
	  },
	  computed: {
	    axes: function axes() {
	      return _constantes2.default.Axes;
	    },
	    contractId: function contractId() {
	      return this.$route.params.contractId;
	    },
	    emissor: function emissor() {
	      if (this.user.person) return this.user.person.name + ' ' + this.user.person.lastName;else if (this.user.company) return this.user.company.companyName;
	    },
	    transportador: function transportador() {
	      if (this.nomeTransportador) return this.nomeTransportador;
	      if (this.vehicle.companyName) return this.vehicle.companyName;else if (this.vehicle.personName) return this.vehicle.personName + ' ' + this.vehicle.personLastName;
	    },
	    category: function category() {
	      var _this = this;
	
	      return _.find(_constantes2.default.Axes, function (o) {
	        return o.category_artesp_id == _this.axesId;
	      }).caption;
	    },
	    expirationDate: function expirationDate() {
	
	      return (0, _moment2.default)().add(parseInt(this.expirationDays), 'd');
	    },
	    routeOrigin: function routeOrigin() {
	      if (this.routeSelected) {
	        var origin = this.routeSelected.points.find(function (e) {
	          return e.type == 'origin';
	        });
	        return origin ? origin.address : '';
	      }
	
	      return '';
	    },
	    routeDestination: function routeDestination() {
	      if (this.routeSelected) {
	        var destination = this.routeSelected.points.find(function (e) {
	          return e.type == 'destination';
	        });
	        return destination ? destination.address : '';
	      }
	
	      return '';
	    }
	  },
	  methods: {
	    findPlate: function findPlate() {
	      var _this2 = this;
	
	      this.msgError = undefined;
	
	      var returnCheckPlate = this.checkPlate(this.plate);
	
	      if (returnCheckPlate != 0) {
	        switch (returnCheckPlate) {
	          case 1:
	            this.msgError = 'Falha, informe uma placa.';
	            break;
	          case 2:
	            this.msgError = 'Falha, placa inválida.';
	            break;
	        }
	        return;
	      }
	
	      this.loading = _toll2.default.getVehicleDataVp(this.plate).then(function (response) {
	        if (!response) {
	          _this2.vehicle = undefined;
	          _this2.msgError = 'Não foi possível obter os dados do veículo. Tente novamente.';
	          return;
	        }
	
	        _this2.vehicle = response;
	        _this2.axesId = response.categoryArtespId;
	
	        _this2.resetRntrcException();
	
	        if (!response.rntrc) {
	          _this2.showRNTRC();
	        } else if (_this2.isRntrcRejected(response.rntrc)) {
	          _this2.handleRntrcRejection(response);
	        }
	
	        _this2.msgError = undefined;
	      }).catch(function (err) {
	
	        _this2.msgError = err && err.data && err.data.status && err.data.status.message || 'Não foi possível consultar a ANTT no momento. Tente novamente mais tarde.';
	        _this2.vehicle = undefined;
	      });
	    },
	    checkPlate: function checkPlate(plate) {
	      if (plate == '' || plate == undefined) {
	        return 1;
	      } else if (plate.toString().replace("-", '').length != 7) {
	        return 2;
	      } else {
	        return 0;
	      }
	    },
	
	    filter: _.debounce(function () {
	      var _this3 = this;
	
	      this.search = this.search.toUpperCase();
	
	      if (!this.allRoutes) return;
	
	      if (this.search == '') {
	        this.routes = this.allRoutes;
	        this.page = this.page.itemCount(this.routes.length);
	        return;
	      }
	      this.routes = this.allRoutes.filter(function (value) {
	        var a = value.name.toUpperCase().indexOf(_this3.search) >= 0 || value.flexField1.toUpperCase().indexOf(_this3.search) >= 0 || value.flexField2.toUpperCase().indexOf(_this3.search) >= 0;
	        var b = _.filter(value.points, function (o) {
	
	          return o.address && o.address.toUpperCase().indexOf(_this3.search) >= 0;
	        }).length > 0;
	
	        return a || b;
	      });
	
	      this.page = this.page.itemCount(this.routes.length);
	    }, 400),
	    nextStep: function nextStep() {
	      var _this4 = this;
	
	      this.msgError = undefined;
	      this.cancelRNTRC();
	      $('body').stop().animate({
	        scrollTop: 0
	      }, '500', 'swing');
	      switch (this.step) {
	        case 0:
	          var dateFormat = 'dd/MM/yyyy HH:mm';
	
	          if (!this.dataFimViagem) {
	            this.msgError = 'Informe a data de fim da viagem.';
	            return;
	          }
	
	          if (!this.dataInicioViagem) {
	            this.msgError = 'Informe a data de início da viagem.';
	            return;
	          }
	
	          if ((0, _dateFns.isBefore)(new Date(this.dataInicioViagem), new Date(this.minDate))) {
	            this.msgError = 'Data de início da viagem deve ser superior a ' + (0, _dateFns.format)(new Date(this.minDate), dateFormat) + '.';
	            return;
	          }
	
	          if ((0, _dateFns.isAfter)(new Date(this.dataFimViagem), new Date(this.maxDate))) {
	            this.msgError = 'Data de fim da viagem deve ser anterior a ' + (0, _dateFns.format)(new Date(this.maxDate), dateFormat) + '.';
	            return;
	          }
	
	          if ((0, _dateFns.isBefore)(new Date(this.dataFimViagem), new Date(this.dataInicioViagem))) {
	            this.msgError = 'Data de fim da viagem deve ser superior a data de início da viagem.';
	            return;
	          }
	
	          if (!this.routeSelected) {
	            this.msgError = 'Por favor escolha uma rota';
	            return;
	          }
	          this.step += 1;
	          break;
	        case 1:
	          if (!this.plate || this.plate.trim() == '' || !this.vehicle) {
	            this.msgError = 'Por favor informe a placa';
	            return;
	          }
	
	          if (this.rntrcRejected && !this.createException) {
	            this.msgError = 'Para continuar, selecione uma ação válida.';
	            return;
	          }
	
	          if (this.vehicle.partner) {
	            this.msgError = 'Não é possivel emitir Vale-pedágio para veículo ' + this.vehicle.partner;
	            return;
	          }
	
	          var tolls = [];
	
	          this.routeSelected.tollFees.forEach(function (element) {
	            element.radius = element.radius == "" ? 0 : element.radius;
	            tolls.push(element);
	          });
	
	          this.loading = _toll2.default.getPriceTolls({ tolls: tolls, axes: this.axesId }).then(function (r) {
	            _this4.priceTolls = r;
	          }).catch(function (err) {});
	          this.step += 1;
	          break;
	        case 2:
	          this.step += 1;
	          break;
	      }
	    },
	    backStep: function backStep() {
	      this.cancelRNTRC();
	
	      if (this.step == 0) {
	        this.cancelar();
	        return;
	      }
	
	      this.msgError = undefined;
	      $('body').stop().animate({
	        scrollTop: 0
	      }, '500', 'swing');
	      this.step -= 1;
	    },
	    cancelar: function cancelar() {
	      var _this5 = this;
	
	      _messageDialog2.default.show({
	        title: 'Cancelar Vale-pedágio',
	        message: 'Deseja cancelar essa emissão de vale-pedágio?',
	        type: 'OK-CANCEL-ADHESION'
	      }).then(function (res) {
	        if (res == 'OK') {
	          _this5.$router.push({ name: 'plans' });
	        }
	      });
	    },
	    doRequest: function doRequest() {
	      var _this6 = this;
	
	      this.msgError = undefined;
	      if (this.priceTolls.totalValue == 0) {
	        this.msgError = 'Ocorreu um problema, o valor total dos pedágios não pode ser ZERO';
	        return;
	      }
	
	      if (this.rntrcRejected && this.createException && !this.rntrcExceptionCreated) {
	        var promise = this.criarExcecao().then(function () {
	          return _this6.emitirValePedagio();
	        }).catch(function () {});
	        this.$store.dispatch('loading', promise);
	        return;
	      }
	
	      this.$store.dispatch('loading', this.emitirValePedagio());
	    },
	    emitirValePedagio: function emitirValePedagio() {
	      var _this7 = this;
	
	      var req = {
	        placaVeiculo: this.plate,
	        routeId: this.routeSelected.routeId,
	        version: this.routeSelected.version,
	
	        CNPJTransportador: this.documentoTransportador,
	        transportador: this.nomeTransportador,
	
	        expirationVP: (0, _dateFns.format)(new Date(this.dataFimViagem), 'yyyy-MM-dd HH:mm:ss'),
	        startVP: (0, _dateFns.format)(new Date(this.dataInicioViagem), 'yyyy-MM-dd HH:mm:ss'),
	
	        docEmbarqueTipo: '',
	        docEmbarqueNum: '',
	        CPFCNPJEmbarcador: this.user.taxIdNumber,
	        categoryArtespId: this.axesId,
	        forceTransfer: this.forceTransfer ? 1 : 0,
	        motorista: this.motorista,
	        externalId: this.externalId,
	        extraInfoVP: {
	          campo1: this.campo1,
	          campo2: this.campo2,
	          campo3: this.campo3,
	          campo4: this.campo4,
	          campo5: this.campo5
	        },
	        contratoOrig: this.contractId,
	        excecaoRntrc: this.rntrcExceptionCreated ? 1 : 0
	      };
	
	      return _toll2.default.insertValePedagio(req).then(function (res) {
	        _this7.idIntern = res.idIntern;
	        _messageDialog2.default.show({
	          title: 'Sucesso',
	          message: 'Vale-pedagio emitido com sucesso',
	          type: 'OK'
	        }).then(function (res) {
	          if (res == 'OK') {
	            _this7.$router.push({ name: 'summary-accompaniment', params: { contractId: _this7.contractId, idVP: _this7.idIntern } });
	          }
	        });
	      }).catch(function (err) {
	        if (err.data.status && (err.data.status.code === 9203 || err.data.status.code === 9205 || err.data.status.code === 9209 || err.data.status.code === 9210 || err.data.status.code === 9223 || err.data.status.code === 9225)) {
	          _this7.enableRNTRC = true;
	        }
	
	        if (err.data.status.code == 9898) {
	          document.getElementById("externalId").style.borderColor = "#FF0000";
	        }
	
	        _this7.msgError = err.data.status.message;
	
	        if (err.data.status && err.data.status.code == 500) {
	          _this7.showForceTransfer = true;
	        }
	      });
	    },
	    goToStep: function goToStep(value) {
	      this.code = undefined;
	      this.step = value;
	    },
	    cancelRNTRC: function cancelRNTRC() {
	      this.enableRNTRC = false;
	      this.rntrcDocument = '';
	      this.rntrcOwnerName = '';
	    },
	    showRNTRC: function showRNTRC() {
	      this.enableRNTRC = true;
	    },
	    validateDocument: function validateDocument() {
	      var _this8 = this;
	
	      if (!this.rntrcOwnerName) {
	        this.msgError = "Favor informar Nome/Razão Social.";
	        return;
	      }
	
	      if (!this.rntrcDocument) {
	        this.msgError = "Favor informar Documento.";
	        return;
	      }
	
	      if (!_cpfCnpj.cpfCnpj.validate(this.rntrcDocument)) {
	        this.msgError = "Documento inválido!";
	        return;
	      }
	
	      var documentoInformado = this.rntrcDocument;
	      var nomeInformado = this.rntrcOwnerName;
	
	      this.loading = _toll2.default.getVehicleDataVp(this.plate, this.rntrcDocument).then(function (response) {
	        if (!response) {
	          _this8.msgError = 'Não foi possível obter os dados do transportador. Tente novamente.';
	          return;
	        }
	
	        _this8.vehicle = response;
	        _this8.axesId = response.categoryArtespId;
	        _this8.enableRNTRC = false;
	
	        var rntrcValidado = response && response.rntrc && !_this8.isRntrcRejected(response.rntrc);
	
	        if (rntrcValidado) {
	          if (_this8.rntrcOwnerName) {
	            _this8.nomeTransportador = _this8.rntrcOwnerName.toUpperCase();
	          }
	
	          if (_this8.rntrcDocument) {
	            _this8.documentoTransportador = _this8.rntrcDocument;
	          }
	        }
	
	        _this8.rntrcDocument = '';
	        _this8.rntrcOwnerName = '';
	        _this8.msgError = undefined;
	
	        if (rntrcValidado) {
	          _this8.resetRntrcException();
	          _messageDialog2.default.show({
	            title: 'Sucesso',
	            message: 'Documento validado com sucesso.',
	            type: 'OK'
	          });
	        } else {
	          _this8.handleRntrcRejection(response, documentoInformado, nomeInformado);
	          _messageDialog2.default.show({
	            title: 'Falha validação',
	            message: 'Transportador não regularizado na ANTT (RNTRC)',
	            type: 'OK'
	          });
	        }
	      }).catch(function (err) {
	        _this8.msgError = err && err.data && err.data.status && err.data.status.message || 'Não foi possível consultar a ANTT no momento. Tente novamente mais tarde.';
	      });
	    },
	    isRntrcRejected: function isRntrcRejected(rntrc) {
	      return !!rntrc && rntrc.indexOf('RNTRC') !== -1;
	    },
	    handleRntrcRejection: function handleRntrcRejection(response, documento, nome) {
	      this.rntrcRejected = true;
	      this.rntrcExceptionCreated = false;
	      this.createException = false;
	      this.enableRNTRC = false;
	
	      this.rntrcRejectedDocument = documento || this.documentoTransportador || response && response.taxIdNumber || '';
	
	      this.rntrcRejectedName = nome || this.nomeTransportador || response && response.companyName || (response && response.personName ? (response.personName + ' ' + (response.personLastName || '')).trim() : '') || '';
	    },
	    resetRntrcException: function resetRntrcException() {
	      this.rntrcRejected = false;
	      this.rntrcExceptionCreated = false;
	      this.createException = false;
	      this.rntrcRejectedDocument = '';
	      this.rntrcRejectedName = '';
	    },
	    criarExcecao: function criarExcecao() {
	      var _this9 = this;
	
	      var cpfCnpj = this.rntrcRejectedDocument || this.documentoTransportador || this.vehicle && this.vehicle.taxIdNumber || '';
	
	      var nomeRazSocial = (this.rntrcRejectedName || this.nomeTransportador || this.vehicle && this.vehicle.companyName || (this.vehicle && this.vehicle.personName ? (this.vehicle.personName + ' ' + (this.vehicle.personLastName || '')).trim() : '') || '').toUpperCase();
	
	      if (!cpfCnpj) {
	        this.msgError = 'Não foi possível identificar o documento do transportador para criar a exceção.';
	        return _promise2.default.reject(new Error(this.msgError));
	      }
	
	      var req = {
	        plate: this.plate,
	        cpfCnpj: cpfCnpj,
	        nomeRazSocial: nomeRazSocial,
	        description: 'Exceção de RNTRC criada pelo embarcador via Site Move Mais.'
	      };
	
	      return _toll2.default.cadastrarExcecao(req).then(function (res) {
	        if (res && res.status && res.status.code !== 0) {
	          _this9.msgError = res.status.message || 'Falha ao registrar exceção.';
	          return _promise2.default.reject(new Error(_this9.msgError));
	        }
	
	        _this9.rntrcExceptionCreated = true;
	        _this9.documentoTransportador = cpfCnpj;
	        _this9.nomeTransportador = nomeRazSocial;
	        _this9.msgError = undefined;
	      }).catch(function (err) {
	        _this9.msgError = err && err.data && err.data.status && err.data.status.message || _this9.msgError || 'Falha ao registrar exceção.';
	        return _promise2.default.reject(err);
	      });
	    }
	  },
	  components: {
	    routeResume: _routeResume2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _vehicles = __webpack_require__(29);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      vehicle: undefined,
	      radioSelected: undefined,
	      brands: undefined,
	      brandSelected: undefined,
	      models: undefined,
	      otherCategories: otherCategories,
	      otherCategorySelected: undefined,
	      loading: undefined,
	      years: undefined,
	      states: states,
	      colors: colors,
	      classVehicle: {},
	      driver: {},
	      axesSelected: {},
	      updateModel: false,
	      modelSelected: undefined
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var brandPromise = _vehicles2.default.getVehicleBrand().then(function (data) {
	      _this.brands = data;
	      _.each(data, function (obj) {
	        obj.value = obj.brandId;
	        obj.caption = obj.name;
	      });
	    });
	    var vehiclePromise = _vehicles2.default.getVehicleById(this.vehicleId).then(function (resp) {
	      _this.vehicle = resp;
	      _this.brandSelected = _this.vehicle.model.brand.brandId;
	      _this.classVehicle['pull-right'] = _this.vehicle.cancelDate == undefined;
	      _this.classVehicle['pull-left'] = !_this.classVehicle['pull-right'];
	
	      _this.modelSelected = _this.vehicle.model.modelId;
	
	      _this.driver = _this.vehicle.drivers && _this.vehicle.drivers.driver ? _this.vehicle.drivers.driver[0] : { vehicleId: _this.vehicle.vehicleId };
	    });
	
	    _promise2.default.all([brandPromise, vehiclePromise]).then(function (res) {
	      _this.loadModels(false).then(function (res) {
	        _this.selectRadio();
	        _this.modelSelected = _this.vehicle.model.modelId;
	        var vm = _this;
	        _this.$nextTick(function () {
	          vm.updateModel = true;
	        });
	      });
	    });
	
	    this.years = this.loadYears();
	  },
	
	
	  computed: {
	    vehicleId: function vehicleId() {
	      return this.$route.params.vehicleId;
	    },
	    contractId: function contractId() {
	      return this.$route.params.contractId;
	    },
	    getAxesSelected: function getAxesSelected() {
	      if (this.radioSelected > 0) return this.radioSelected;
	
	      return this.otherCategorySelected;
	    },
	
	    ownFleet: {
	      get: function get() {
	        return this.vehicle.ownFleet == 'Y';
	      },
	      set: function set(val) {
	
	        this.vehicle.ownFleet = val ? 'Y' : 'N';
	      }
	    },
	    axesDescription: function axesDescription() {
	      var _this2 = this;
	
	      if (!this.getAxesSelected) return '';
	
	      return _.find(_constantes2.default.Axes, function (o) {
	        return o.value == _this2.getAxesSelected;
	      }).caption;
	    },
	    modelDescription: function modelDescription() {
	      var _this3 = this;
	
	      if (!this.modelSelected) return '';
	
	      return _.find(this.models, function (o) {
	        return o.modelId == _this3.modelSelected;
	      }).caption;
	    },
	    brandDescription: function brandDescription() {
	      var _this4 = this;
	
	      if (!this.brandSelected) return '';
	
	      return _.find(this.brands, function (o) {
	        return o.brandId == _this4.brandSelected;
	      }).caption;
	    }
	  },
	  methods: {
	    loadModels: function loadModels() {
	      var _this5 = this;
	
	      return _vehicles2.default.getVehicleModel(this.brandSelected).then(function (data) {
	        _this5.models = data;
	        _.each(data, function (obj) {
	          obj.value = obj.modelId;
	          obj.caption = obj.name;
	        });
	        if (_this5.updateModel) _this5.modelSelected = data[0].modelId;
	        return data;
	      });
	    },
	    onModelSelected: function onModelSelected(item) {
	      if (!item) return;
	      this.axesSelected = item.category.categoryId;
	    },
	    loadYears: function loadYears() {
	      var years = [];
	      var yerCurrent = new Date().getFullYear();
	      for (var i = 0; i < 30; i++) {
	        years.push({
	          value: yerCurrent - i,
	          caption: yerCurrent - i
	        });
	      }
	      return years;
	    },
	    doUpdate: function doUpdate() {
	      var _this6 = this;
	
	      this.$validator.validateAll().then(function (s) {
	        _this6.vehicle.categoryAxes.categoryAxesId = _this6.getAxesSelected;
	        _this6.vehicle.categoryAxes.name = _this6.axesDescription;
	        _this6.vehicle.model.modelId = _this6.modelSelected;
	        _this6.vehicle.model.name = _this6.modelDescription;
	        _this6.vehicle.model.brand.brandId = _this6.brandSelected;
	        _this6.vehicle.model.brand.name = _this6.brandDescription;
	
	        if (!_this6.vehicle.rntrc || _this6.vehicle.rntrc.trim() == "") {
	          _this6.vehicle.ownFleet = 'Y';
	        }
	
	        if (_this6.vehicle.ownFleet == 'N') {
	          _this6.vehicle.drivers = { driver: [_this6.driver] };
	        }
	
	        _this6.loading = _vehicles2.default.updateVehicle({
	          vehicle: _this6.vehicle
	        }).then(function (resp) {
	          _messageDialog2.default.show({
	            title: 'Sucesso',
	            message: 'Veículo atualizado com sucesso',
	            headerClass: 'modal-success'
	          });
	        }).catch(function (err) {
	          _messageDialog2.default.show({
	            title: 'Erro',
	            message: err.data.status.message,
	            headerClass: 'modal-danger'
	          });
	        });
	      }).catch(function (err) {
	
	        _messageDialog2.default.show({
	          title: 'Erro',
	          message: 'Por favor, verifique os campos em vermelho',
	          headerClass: 'modal-danger'
	        });
	      });
	    },
	    selectRadio: function selectRadio() {
	      var axesId = this.vehicle.categoryAxes.categoryAxesId;
	      this.axesSelected = this.vehicle.model.category.categoryId;
	      if (_.find(otherCategories, function (o) {
	        return o.value == axesId;
	      })) {
	        this.otherCategorySelected = this.vehicle.categoryAxes.categoryAxesId;
	        this.radioSelected = -1;
	      } else {
	        this.radioSelected = this.vehicle.categoryAxes.categoryAxesId;
	      }
	    }
	  }
	
	};
	
	var colors = [{
	  caption: "Branco",
	  value: "Branco"
	}, {
	  caption: "Preto",
	  value: "Preto"
	}, {
	  caption: "Vermelho",
	  value: "Vermelho"
	}, {
	  caption: "Prata",
	  value: "Prata"
	}, {
	  caption: "Cinza",
	  value: "Cinza"
	}, {
	  caption: "Azul",
	  value: "Azul"
	}, {
	  caption: "Marrom/Bege",
	  value: "Marrom/Bege"
	}, {
	  caption: "Verde",
	  value: "Verde"
	}, {
	  caption: "Amarelo/Dourado",
	  value: "Amarelo/Dourado"
	}, {
	  caption: "Outras",
	  value: "Outras"
	}];
	var states = [{
	  caption: "Acre - AC",
	  value: "AC"
	}, {
	  caption: "Alagoas - AL",
	  value: "AL"
	}, {
	  caption: "Amapá - AP",
	  value: "AP"
	}, {
	  caption: "Amazonas - AM",
	  value: "AM"
	}, {
	  caption: "Bahia - BA",
	  value: "BA"
	}, {
	  caption: "Ceará - CE",
	  value: "CE"
	}, {
	  caption: "Distrito Federal - DF",
	  value: "DF"
	}, {
	  caption: "Espírito Santo - ES",
	  value: "ES"
	}, {
	  caption: "Goiás - GO",
	  value: "GO"
	}, {
	  caption: "Maranhão - MA",
	  value: "MA"
	}, {
	  caption: "Mato Grosso - MT",
	  value: "MT"
	}, {
	  caption: "Mato Grosso do Sul - MS",
	  value: "MS"
	}, {
	  caption: "Minas Gerais - MG",
	  value: "MG"
	}, {
	  caption: "Paraná - PR",
	  value: "PR"
	}, {
	  caption: "Paraíba - PB",
	  value: "PB"
	}, {
	  caption: "Pará - PA",
	  value: "PA"
	}, {
	  caption: "Pernambuco - PE",
	  value: "PE"
	}, {
	  caption: "Piauí - PI",
	  value: "PI"
	}, {
	  caption: "Rio de Janeiro - RJ",
	  value: "RJ"
	}, {
	  caption: "Rio Grande do Norte - RN",
	  value: "RN"
	}, {
	  caption: "Rio Grande do Sul - RS",
	  value: "RS"
	}, {
	  caption: "Rondônia - RO",
	  value: "RO"
	}, {
	  caption: "Roraima - RR",
	  value: "RR"
	}, {
	  caption: "Santa Catarina - SC",
	  value: "SC"
	}, {
	  caption: "Sergipe - SE",
	  value: "SE"
	}, {
	  caption: "São Paulo - SP",
	  value: "SP"
	}, {
	  caption: "Tocantins - TO",
	  value: "TO"
	}];
	var otherCategories = [{
	  value: 12,
	  caption: "10 eixos, rodagem dupla"
	}, {
	  value: 13,
	  caption: "11 eixos, rodagem dupla"
	}, {
	  value: 14,
	  caption: "12 eixos, rodagem dupla"
	}, {
	  value: 15,
	  caption: "13 eixos, rodagem dupla"
	}, {
	  value: 16,
	  caption: "14 eixos, rodagem dupla"
	}, {
	  value: 17,
	  caption: "15 eixos, rodagem dupla"
	}, {
	  value: 18,
	  caption: "16 eixos, rodagem dupla"
	}, {
	  value: 19,
	  caption: "17 eixos, rodagem dupla"
	}, {
	  value: 20,
	  caption: "18 eixos, rodagem dupla"
	}, {
	  value: 21,
	  caption: "19 eixos, rodagem dupla"
	}, {
	  value: 22,
	  caption: "20 eixos, rodagem dupla"
	}, {
	  value: 23,
	  caption: "21 eixos, rodagem dupla"
	}, {
	  value: 24,
	  caption: "22 eixos, rodagem dupla"
	}, {
	  value: 25,
	  caption: "23 eixos, rodagem dupla"
	}, {
	  value: 26,
	  caption: "24 eixos, rodagem dupla"
	}, {
	  value: 27,
	  caption: "25 eixos, rodagem dupla"
	}, {
	  value: 28,
	  caption: "26 eixos, rodagem dupla"
	}, {
	  value: 29,
	  caption: "27 eixos, rodagem dupla"
	}, {
	  value: 30,
	  caption: "28 eixos, rodagem dupla"
	}, {
	  value: 31,
	  caption: "29 eixos, rodagem dupla"
	}, {
	  value: 32,
	  caption: "30 eixos, rodagem dupla"
	}, {
	  value: 33,
	  caption: "31 eixos, rodagem dupla"
	}, {
	  value: 34,
	  caption: "32 eixos, rodagem dupla"
	}, {
	  value: 35,
	  caption: "33 eixos, rodagem dupla"
	}, {
	  value: 36,
	  caption: "34 eixos, rodagem dupla"
	}, {
	  value: 37,
	  caption: "35 eixos, rodagem dupla"
	}, {
	  value: 38,
	  caption: "36 eixos, rodagem dupla"
	}, {
	  value: 39,
	  caption: "37 eixos, rodagem dupla"
	}, {
	  value: 40,
	  caption: "38 eixos, rodagem dupla"
	}, {
	  value: 41,
	  caption: "39 eixos, rodagem dupla"
	}, {
	  value: 42,
	  caption: "40 eixos, rodagem dupla"
	}, {
	  value: 43,
	  caption: "41 eixos, rodagem dupla"
	}, {
	  value: 44,
	  caption: "42 eixos, rodagem dupla"
	}, {
	  value: 45,
	  caption: "43 eixos, rodagem dupla"
	}, {
	  value: 46,
	  caption: "44 eixos, rodagem dupla"
	}, {
	  value: 47,
	  caption: "45 eixos, rodagem dupla"
	}, {
	  value: 48,
	  caption: "46 eixos, rodagem dupla"
	}, {
	  value: 49,
	  caption: "47 eixos, rodagem dupla"
	}, {
	  value: 50,
	  caption: "48 eixos, rodagem dupla"
	}];

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _keys = __webpack_require__(176);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _payment = __webpack_require__(169);
	
	var _payment2 = _interopRequireDefault(_payment);
	
	var _utils = __webpack_require__(34);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _financial = __webpack_require__(54);
	
	var _financial2 = _interopRequireDefault(_financial);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['contractId', 'payment', 'planId', 'addressMailing', 'creditCardOptions', 'bankAccountOptions', 'bankBillOption', 'value', 'showNewPayment'],
	  data: function data() {
	    return {
	      arrayDebito: undefined,
	      arrayCartao: undefined,
	      boletoCadastrato: undefined,
	      boleto: undefined,
	      index: 1,
	      contractPaymentMethodId: this.value,
	      loading: undefined,
	      paymentSelected: this.payment,
	      paymentMethodsAuthorized: {}
	
	    };
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    if (this.taxIdNumber) {
	      _financial2.default.getPaymentMethodUnauthorized(this.taxIdNumber).then(function (authResponse) {
	        var authMethods = authResponse.data.data.paymentMethods;
	
	        _this.paymentMethodsAuthorized = {};
	
	        authMethods.forEach(function (method) {
	          _this.paymentMethodsAuthorized[method.shortName] = method.authorized === 1;
	        });
	
	        if (_this.planId) {
	          _this.load();
	        }
	      }).catch(function (error) {
	        console.error('Erro ao buscar autorizações:', error);
	        if (_this.planId) {
	          _this.load();
	        }
	      });
	    } else {
	      if (this.planId) {
	        this.load();
	      }
	    }
	  },
	  watch: {
	    contractPaymentMethodId: function contractPaymentMethodId(newValue) {
	      this.$emit('input', newValue);
	    },
	    planId: function planId() {
	      this.load();
	    }
	  },
	  methods: {
	    load: function load() {
	      var _this2 = this;
	
	      this.loading = _contracts2.default.getPaymentMethod(this.contractId).then(function (result) {
	        var data = result;
	
	        if (_this2.taxIdNumber && (0, _keys2.default)(_this2.paymentMethodsAuthorized).length > 0) {
	          data = data.filter(function (item) {
	            var shortName = item.paymentMethod.paymentShortName;
	            if (shortName && _this2.paymentMethodsAuthorized.hasOwnProperty(shortName)) {
	              return _this2.paymentMethodsAuthorized[shortName];
	            }
	            return true;
	          });
	        }
	
	        if (_this2.planId == 28) {
	          _this2.paymentSelected = _.filter(data, { type: 'CR' })[0];
	
	          if (!_this2.paymentSelected) {
	            _this2.paymentSelected = data[0];
	          }
	          _this2.contractPaymentMethodId = _this2.paymentSelected.contractPaymentMethodId;
	        } else {
	          _this2.arrayCartao = _.filter(data, function (o) {
	            return o.paymentMethod.paymentShortName == 'CC';
	          });
	          _this2.arrayDebito = _.filter(data, function (o) {
	            return o.paymentMethod.paymentShortName == 'DC';
	          });
	          _this2.boletoCadastrato = _.filter(data, function (o) {
	            return o.paymentMethod.paymentShortName == 'BC';
	          });
	          if (_this2.boletoCadastrato.length > 0) {
	            _this2.boletoCadastrato = _this2.boletoCadastrato[0];
	          }
	        }
	
	        if (!_this2.contractPaymentMethodId || _this2.contractPaymentMethodId == -1) {
	
	          if (_this2.arrayCartao && _this2.arrayCartao.length > 0) {
	            _this2.contractPaymentMethodId = _this2.arrayCartao[0].contractPaymentMethodId;
	            _this2.paymentSelected = _this2.arrayCartao[0];
	          } else if (_this2.arrayDebito && _this2.arrayDebito.length > 0) {
	            _this2.contractPaymentMethodId = _this2.arrayDebito[0].contractPaymentMethodId;
	            _this2.paymentSelected = _this2.arrayDebito[0];
	          } else if (_this2.boletoCadastrato) {
	            _this2.contractPaymentMethodId = _this2.boletoCadastrato.contractPaymentMethodId;
	            _this2.paymentSelected = _this2.boletoCadastrato;
	          }
	
	          if (!_this2.boletoCadastrato || _this2.boletoCadastrato.length == 0) {
	            _this2.boletoCadastrato = { contractPaymentMethodId: -1, paymentMethod: { paymentMethodId: 12 } };
	            _this2.paymentSelected = _this2.boletoCadastrato;
	          }
	
	          _this2.validateAll();
	        }
	      });
	
	      this.$store.commit('currentPlanId', this.planId);
	    },
	    imageUrl: function imageUrl(paymentMethod) {
	      if (!paymentMethod || !paymentMethod.paymentMethod.imagePath) return "";
	      return '/static/payment-methods/' + paymentMethod.paymentMethod.imagePath.split('.')[0] + '.svg';
	    },
	    validateAll: function validateAll() {
	      if (!this.contractPaymentMethodId) {
	
	        return _promise2.default.reject({ customMsg: "Por favor selecione uma forma de pagamento" });
	      }
	      this.$emit('paymentSelected', this.paymentSelected);
	      if (this.paymentSelected.creditCard) {
	        if (!this.paymentSelected.secureCodeCreditCard || this.paymentSelected.secureCodeCreditCard.length < 3) return _promise2.default.reject({ customMsg: "Informe o código de segurança do cartão" });
	      }
	      this.$emit('cvv', this.paymentSelected.secureCodeCreditCard);
	      return _promise2.default.resolve(true);
	    },
	    getPaymentSelected: function getPaymentSelected() {
	      if (this.contractPaymentMethodId == -1) {
	        return { paymentMethod: { paymentMethodId: 12 } };
	      }
	      this.paymentSelected.cvv = this.paymentSelected.secureCodeCreditCard;
	      return this.paymentSelected;
	    },
	    isPaymentMethodAuthorized: function isPaymentMethodAuthorized(shortName) {
	      if (!this.taxIdNumber) {
	        return true;
	      }
	
	      if (!this.paymentMethodsAuthorized || (0, _keys2.default)(this.paymentMethodsAuthorized).length === 0) {
	        return true;
	      }
	
	      if (!this.paymentMethodsAuthorized.hasOwnProperty(shortName)) {
	        return true;
	      }
	
	      return this.paymentMethodsAuthorized[shortName] === true;
	    }
	  },
	  computed: {
	    typesAllowed: function typesAllowed() {
	      return this.$store.getters.getPaymentsTypesByPlan(this.planId);
	    },
	    taxIdNumber: function taxIdNumber() {
	      return _auth2.default.currentUser && _auth2.default.currentUser.taxIdNumber;
	    },
	    hasValidActivePaymentMethod: function hasValidActivePaymentMethod() {
	      var hasRegisteredCreditCards = this.arrayCartao && this.arrayCartao.length > 0 && this.isPaymentMethodAuthorized('CC');
	
	      var hasRegisteredDebits = this.arrayDebito && this.arrayDebito.length > 0 && this.isPaymentMethodAuthorized('DC');
	
	      var hasBankBill = (this.boletoCadastrato || this.bankBillOption) && this.isPaymentMethodAuthorized('BC');
	
	      var hasNewPaymentOption = this.showNewPayment && this.planId != 22 && this.planId != 32 && this.typesAllowed && (this.typesAllowed.creditCard || this.typesAllowed.bankAccount) && (this.isPaymentMethodAuthorized('CC') || this.isPaymentMethodAuthorized('DC'));
	
	      return hasRegisteredCreditCards || hasRegisteredDebits || hasBankBill || hasNewPaymentOption;
	    }
	  },
	  components: {
	    Payment: _payment2.default
	  }
	};

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__(48);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _vehicles = __webpack_require__(118);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	var _objects = __webpack_require__(44);
	
	var obj = _interopRequireWildcard(_objects);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _genericSummary = __webpack_require__(85);
	
	var _genericSummary2 = _interopRequireDefault(_genericSummary);
	
	var _success = __webpack_require__(47);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _error = __webpack_require__(67);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _address = __webpack_require__(84);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _eventBus = __webpack_require__(25);
	
	var _utils = __webpack_require__(34);
	
	var Utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subs = ['Cadastre os veículos que irão utilizar o plano:', 'Revise os dados e confirme a solicitação:'];
	
	exports.default = {
	  data: function data() {
	    var _ref;
	
	    return _ref = {
	      contract: obj.contract(),
	      newVehicleTax: undefined,
	      vehicles: [],
	      planId: undefined,
	      planName: undefined,
	      step: 0,
	      subtitle: subs,
	      msgError: undefined,
	      loading: undefined,
	      success: false,
	      code: undefined,
	      boletoUrl: undefined,
	      changeAddress: false,
	      newAddress: _auth2.default.currentUser.address,
	      qtdAllowed: _constantes2.default.LIMIT_VEHICLES,
	      guaranteeTax: undefined,
	      lead: undefined,
	      total: undefined,
	      promotionCode: undefined
	    }, (0, _defineProperty3.default)(_ref, 'contract', undefined), (0, _defineProperty3.default)(_ref, 'salesOrder', undefined), (0, _defineProperty3.default)(_ref, 'address', undefined), (0, _defineProperty3.default)(_ref, 'whereToDelivery', "0"), (0, _defineProperty3.default)(_ref, 'shipmentType', undefined), (0, _defineProperty3.default)(_ref, 'novoCartao', false), (0, _defineProperty3.default)(_ref, 'salesResponse', undefined), (0, _defineProperty3.default)(_ref, 'sales', undefined), (0, _defineProperty3.default)(_ref, 'receberAccount', undefined), (0, _defineProperty3.default)(_ref, 'validacaoFraude', undefined), (0, _defineProperty3.default)(_ref, 'isMobile', false), (0, _defineProperty3.default)(_ref, 'cpm', {}), (0, _defineProperty3.default)(_ref, 'cmpIdId', undefined), (0, _defineProperty3.default)(_ref, 'usuario', undefined), (0, _defineProperty3.default)(_ref, 'validado', undefined), (0, _defineProperty3.default)(_ref, 'tagSerialNumber', ""), (0, _defineProperty3.default)(_ref, 'tagInHandActivated', false), (0, _defineProperty3.default)(_ref, 'tagInHandVehiclesKey', 0), _ref;
	  },
	
	
	  computed: {
	    contractId: function contractId() {
	      return this.$route.params.contractId;
	    },
	    user: function user() {
	      return _auth2.default.currentUser;
	    },
	    addressInit: function addressInit() {
	      return _auth2.default.currentUser.address;
	    },
	    tagActivationSuccessMessage: function tagActivationSuccessMessage() {
	      var salesType = this.salesOrder && this.salesOrder.salesType;
	      return salesType === 'REPLACETAG' ? _constantes2.default.MSG_01_REPLACE_IN_HAND_SUCCESS : 'TAG ativada com sucesso!';
	    },
	    isReplaceTagFlow: function isReplaceTagFlow() {
	      return this.salesOrder && this.salesOrder.salesType === 'REPLACETAG';
	    },
	    request: function request() {
	      var vm = this;
	      var request = {
	        "_interface": window.document.webview ? "MOBILE" : "WEBSITE",
	        account: vm.account,
	        addresses: {
	          address: [vm.address]
	        },
	        contract: vm.contract,
	        listVehicle: {
	          vehicle: vm.vehicles
	        },
	        value: this.total,
	        shipmentType: this.shipmentType
	      };
	      return request;
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    _eventBus.EventBus.$on('cleanErrors', function () {
	      _this.msgError = undefined;
	    });
	  },
	
	
	  mounted: function mounted() {
	    var _this2 = this;
	
	    if (window.innerWidth <= 769) {
	      this.isMobile = true;
	    } else {
	      this.isMobile = false;
	    }
	    window.addEventListener('resize', function () {
	      return window.innerWidth <= 769 ? _this2.isMobile = true : _this2.isMobile = false;
	    });
	    var vm = this;
	    if (window.ga) window.ga('send', 'pageview', 'novo-veiculo/etapa1');
	    this.loading = _contracts2.default.getContractByContractId(this.contractId).then(function (r) {
	      _this2.planId = r.plan.planId;
	      _this2.contract = r;
	      _this2.getPlanInfo();
	      _this2.qtdAllowed -= r.countVehicle;
	    }).then(function (res) {
	      if (Utils.isCaminhoParana(_this2.planId)) {
	        _sales2.default.getLead({
	          taxpayerIdNumber: _auth2.default.currentUser.taxIdNumber
	        }).then(function (response) {
	
	          if (response.lead || response.status.code == 0) {
	            response.lead.typeTaxId = _auth2.default.currentUser.company ? 'COMPANY' : 'PERSON';
	            _this2.lead = response.lead;
	            _this2.lead.plates = _this2.lead.listVehicle.toUpperCase().replace(/(\w{3})(\d{4})/g, '$1-$2').split(/;/);
	          }
	        }).catch(function (error) {
	
	          _this2.errorMessage = error.data && (_self.typePerson == 'PERSON' ? 'Cpf' : 'Cnpj') + ' n\xE3o cadastrado no caminhos do Paran\xE1!' || error.response && error.response.data.status.message;
	        });
	      }
	    });
	  },
	
	  methods: {
	    startRequest: function startRequest() {
	      var _this3 = this;
	
	      this.$refs.GenericSummary.getInfos().then(function (r) {
	
	        _this3.address = r.address;
	        _this3.promotionCode = r.promotionCode;
	        _this3.whereToDelivery = r.whereToDelivery;
	        _this3.shipmentType = r.shipmentType;
	        _this3.tagSerialNumber = r.tagSerialNumber;
	        _this3.doRequest();
	      });
	    },
	    onShipmentTypeChange: function onShipmentTypeChange(shipmentType) {
	      this.shipmentType = shipmentType;
	    },
	    onTagActivationState: function onTagActivationState(activated) {
	      this.tagInHandActivated = activated === true;
	    },
	    addAnotherVehicle: function addAnotherVehicle() {
	      if (this.tagInHandActivated) {
	        this.vehicles.splice(0, this.vehicles.length);
	        this.tagSerialNumber = "";
	        this.shipmentType = undefined;
	        this.tagInHandVehiclesKey += 1;
	      }
	      this.tagInHandActivated = false;
	      this.step = 0;
	      this.msgError = undefined;
	      $('body').stop().animate({ scrollTop: 0 }, '500', 'swing');
	    },
	    finalizeTagInHandFlow: function finalizeTagInHandFlow() {
	      this.$router.push({ name: 'plans' });
	    },
	    nextStep: function nextStep() {
	      this.msgError = undefined;
	      $('body').stop().animate({
	        scrollTop: 0
	      }, '500', 'swing');
	      switch (this.step) {
	        case 0:
	          if (this.vehicles.length > 0) {
	
	            var value = this.vehicles.length * this.newVehicleTax + this.vehicles.length * this.guaranteeTax;
	            this.salesOrder = {
	              "_interface": "WEBSITE",
	              "planId": this.planId,
	              "status": null,
	              "type": "ADESÃO VEÍCULO ADICIONAL",
	              "salesType": "ADHESIONVEHICLEADDITIONAL",
	              "taxpayerIdSeller": null,
	              "promotionCode": this.promotionCode,
	              "price": value,
	              "logisticsDistribution": null,
	              "bankBillUrl": null,
	              "transactionPassageId": null,
	              "vehicleId": null,
	              "contract": this.contractId,
	              "shipment": null,
	              "vehicles": this.vehicles,
	              "products": [{
	                "productId": 4,
	                "productName": "ADESÃO VEÍCULO ADICIONAL",
	                "valueUnit": this.newVehicleTax,
	                "quantity": this.vehicles.length,
	                "valueTotal": value
	              }]
	            };
	
	            if (Utils.isCaminhoParana(this.planId)) {
	              this.salesOrder["promotionCode"] = "CAMINHOSDOPARANA";
	              this.salesOrder["logisticsDistribution"] = "FOB";
	            }
	
	            this.sendPageView();
	            this.step += 1;
	          } else this.msgError = 'Adicione ao menos um veículo para continuar';
	          break;
	      }
	    },
	    backStep: function backStep() {
	      this.msgError = undefined;
	      $('body').stop().animate({
	        scrollTop: 0
	      }, '500', 'swing');
	      if (this.changeAddress) this.changeAddress = false;else this.step -= 1;
	    },
	    sendPageView: function sendPageView() {
	      if (window.ga) window.ga('send', 'pageview', 'novo-veiculo/etapa' + (this.step + 2));
	    },
	    cancelar: function cancelar() {
	      var _this4 = this;
	
	      _messageDialog2.default.show({
	        title: 'Cancelar Novo Veículo',
	        message: 'Deseja cancelar a adesão de novo veiculo?',
	        type: 'OK-CANCEL-ADHESION'
	      }).then(function (res) {
	        if (res == 'OK') {
	          if (window.ga) window.ga('send', 'pageview', 'novo-veiculo/cancelou');
	          _this4.$router.push({
	            name: 'plans'
	          });
	        }
	      });
	    },
	    getPlanInfo: function getPlanInfo() {
	      var _this5 = this;
	
	      this.loading = _sales2.default.getPlanById(this.planId).then(function (resp) {
	
	        if (_this5.planId == _constantes2.default.PLAN_POS || _this5.contract.adhesionTax) {
	          _this5.newVehicleTax = _this5.contract.deadlineExemptionAdhesion > 0 ? 0 : _this5.contract.adhesionTax;
	        } else {
	          _this5.newVehicleTax = _.filter(resp.adhesionTax.adhesionTax, function (o) {
	
	            return o.taxId == _constantes2.default.NEW_VEHICLE_TAXID;
	          })[0].value;
	        }
	
	        if (_this5.planId == 33 || _this5.planId == 34) {
	          _this5.guaranteeTax = _.filter(resp.adhesionTax.adhesionTax, function (o) {
	            return o.taxId == _constantes2.default.GUARANTEE_TAXID;
	          })[0].value;
	        } else {
	          _this5.guaranteeTax = 0;
	        }
	
	        _this5.planName = resp.name;
	      });
	    },
	    doRequest: function doRequest() {
	      var _this6 = this;
	
	      var value = this.vehicles.length * this.newVehicleTax + this.vehicles.length * this.guaranteeTax;
	
	      var req = {
	        "contractId": this.contractId,
	        "deliveryAddressId": this.address.addressId,
	        "value": value,
	        "promotionCode": this.promotionCode,
	        "secureCode": this.user.taxIdNumber.substring(0, 4),
	        "_interface": window.document.webview ? "MOBILE" : "WEBSITE",
	        "vehicles": this.vehicles,
	        "shipmentType": this.shipmentType
	      };
	
	      var url_atual = window.location.href;
	
	      if (url_atual != "") {
	        var regexp = new RegExp(/\S+pdv\S+/i);
	        var n = regexp.test(url_atual);
	        if (n) {
	          req["promotionCode"] = "GRAALKM29";
	          req["logisticsDistribution"] = "FOB";
	        }
	      }
	
	      if (Utils.isCaminhoParana(this.planId)) {
	        req["promotionCode"] = "CAMINHOSDOPARANA";
	        req["logisticsDistribution"] = "FOB";
	      }
	
	      if (this.whereToDelivery != "0") {
	        req["promotionCode"] = this.getwhereToDelivrey;
	        req["logisticsDistribution"] = "FOB";
	      }
	
	      if (this.promotionCode) {
	        req.promotionCode = this.promotionCode;
	      }
	
	      if (req.shipmentType == 3) {
	        req.logisticsDistribution = "FOB";
	      }
	      if (req.shipmentType == 4) {
	        req.logisticsDistribution = null;
	        req.value = 0;
	        req.sales_type = "SOL_TAG";
	      }
	
	      if (req.shipmentType == 4 && this.tagSerialNumber && this.vehicles && this.vehicles.length) {
	        this.vehicles[0].tagSerialNumber = this.tagSerialNumber;
	      }
	
	      var p = _sales2.default.adhesionVehicleAddition(req).then(function (r) {
	        if (r && r.status === 0 && r.salesToken) {
	          window.location.href = r.salesToken;
	          return new _promise2.default(function () {});
	        }
	        if (r && r.status === 0 && (r.price === 0 || r.approved === true)) {
	          if (window.ga) window.ga('send', 'pageview', 'novo-veiculo/sucesso');
	          _this6.code = 0;
	          $('body').stop().animate({ scrollTop: 0 }, '500', 'swing');
	          return;
	        }
	        _this6.usuario = r.salesOrder.contractPaymentMethod.usuario;
	        _this6.validado = r.salesOrder.contractPaymentMethod.validado;
	        var pedido = r.salesOrder.salesOrderId.toString();
	
	        if (r.salesOrder && r.salesOrder.pixCopiaCola) _this6.pixCopiaCola = r.salesOrder.pixCopiaCola;
	
	        if (_this6.cpm.paymentMethod.paymentMethodId == 120 && _this6.pixCopiaCola != undefined) {
	          _this6.newPix = true;
	          _this6.salesResponse = r.salesOrder;
	          _this6.code = r.status.code;
	          _this6.boletoUrl = r.boletoUrl;
	          _this6.cmpId = _this6.cpm.paymentMethod.paymentMethodId;
	        } else if (_this6.cpm.paymentMethod.paymentMethodId == 120) {
	          _this6.cmpId = _this6.cpm.paymentMethod.paymentMethodId;
	          if (window.location.hostname == "www.movemais.com" || window.location.hostname == "movemais.com" || r.status.info_cc == "8910024294252017") {
	            _this6.vads_ctx_mode = "PRODUCTION";
	          } else {
	            _this6.vads_ctx_mode = "TEST";
	          }
	
	          _this6.vads_trans_date = new Date(r.salesOrder.salesDate).toISOString().replace(/[^0-9]/g, '').substring(0, 14);
	          _this6.vads_trans_id = "M" + pedido.slice(-5);
	          _this6.vads_order_id = r.salesOrder.salesOrderId;
	          _this6.vads_amount = r.salesOrder.price;
	          _this6.vads_site_id = r.status.info_st;
	          _this6.certificate = r.status.info_cc;
	          _this6.vads_order_info = r.status.info_cp;
	
	          if (_this6.user.person) {
	            var sobrenome = _this6.user.person.lastName.split(" ", 2);
	            _this6.vads_cust_first_name = _this6.user.person.name;
	            _this6.vads_cust_last_name = sobrenome[0];
	            _this6.vads_cust_name = _this6.user.person.name;
	          } else if (_this6.user.company) {
	            var nome = _this6.user.company.companyTradeName.split(" ", 2);
	            _this6.vads_cust_first_name = nome[0];
	            _this6.vads_cust_last_name = nome[1] ? nome[1] : nome[0];
	            _this6.vads_cust_name = nome[0];
	          }
	          _this6.vads_cust_national_id = _this6.user.taxIdNumber;
	          _this6.vads_cust_email = _this6.user.accountAuthentication.login;
	
	          _this6.ReceberHash();
	
	          _this6.newPix = true;
	          setTimeout(function () {
	            document.getElementById("formPix").submit();
	            _this6.salesResponse = r.salesOrder;
	            _this6.code = r.status.code;
	            _this6.boletoUrl = r.boletoUrl;
	          }, 200);
	        } else {
	          _this6.salesResponse = r.salesOrder;
	          _this6.code = r.status.code;
	          _this6.boletoUrl = r.boletoUrl;
	          if (r.redirUrl || r.bankBillUrl) {
	            return _messageDialog2.default.show({
	              title: "Estamos quase lá...",
	              headerClass: 'modal-success',
	              message: r.status.message
	            }).then(function (res) {
	              if (r.redirUrl) {
	                window.location = r.redirUrl;
	              }
	            });
	          }
	
	          if (window.ga) window.ga('send', 'pageview', 'novo-veiculo/sucesso');
	          $('body').stop().animate({
	            scrollTop: 0
	          }, '500', 'swing');
	        }
	      }).catch(function (err) {
	        _this6.cmpId = _this6.cpm.paymentMethod.paymentMethodId;
	        if (window.ga) window.ga('send', 'pageview', 'novo-veiculo/erro');
	        var data = err && err.data || {};
	        var status = data.status || {};
	        _this6.code = status.code;
	        _this6.msgError = status.message || data.message;
	        _this6.salesResponse = undefined;
	        _this6.usuario = undefined;
	        _this6.validado = undefined;
	        _this6.cmpId = undefined;
	        $('body').stop().animate({
	          scrollTop: 0
	        }, '500', 'swing');
	      });
	
	      this.$store.dispatch('loading', p);
	    },
	    goToStep: function goToStep(value) {
	      this.code = undefined;
	      this.step = value;
	    },
	    saveAddress: function saveAddress() {
	      var _this7 = this;
	
	      this.$refs.addressMailing.$validator.validateAll().then(function (success) {
	        _this7.loading = _account2.default.updateAddress(_this7.newAddress).then(function (r) {
	          _this7.changeAddress = false;
	          var user = _auth2.default.currentUser;
	          user.address = _this7.newAddress;
	          _auth2.default.currentUser = user;
	        }).catch(function (err) {
	          _messageDialog2.default.show({
	            title: 'Erro',
	            message: err.data.status.message,
	            headerClass: 'modal-danger'
	          });
	        });
	      });
	    },
	    eventChangeAddress: function eventChangeAddress(newValue) {
	      this.changeAddress = newValue;
	    },
	    setTotal: function setTotal(t) {
	      this.total = t;
	    },
	    changePromotionCode: function changePromotionCode(newValue) {
	      this.promotionCode = newValue;
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	
	    _eventBus.EventBus.$off('cleanErrors');
	  },
	
	
	  components: {
	    vehicles: _vehicles2.default,
	    successPage: _success2.default,
	    errorPage: _error2.default,
	    addressComp: _address2.default,
	    GenericSummary: _genericSummary2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(48);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _toll = __webpack_require__(26);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	var _string = __webpack_require__(35);
	
	var _utils = __webpack_require__(34);
	
	var Utils = _interopRequireWildcard(_utils);
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['vehicles', 'address', 'user', 'payment', 'type', 'planId', 'showRecharge', 'minValue', 'contract', 'newVehicleTax', 'replaceTax'],
	  data: function data() {
	    var _ref;
	
	    return _ref = {
	      rechargeValueTotal: 0,
	      rechargeTaxTotal: 0,
	      total: 0,
	      terms: false,
	      cupom: "",
	      descontoCupom: 0,
	      erroCupom: undefined,
	      loading: undefined,
	      totalSemDesconto: 0
	    }, (0, _defineProperty3.default)(_ref, 'loading', undefined), (0, _defineProperty3.default)(_ref, 'cupomApplied', false), (0, _defineProperty3.default)(_ref, 'whereToDelivrey', 0), (0, _defineProperty3.default)(_ref, 'entries', []), (0, _defineProperty3.default)(_ref, 'showEntries', false), _ref;
	  },
	
	
	  computed: {
	    cel: function cel() {
	      var t = this.user.telephones.telephone[1];
	      if (t) return (0, _string.phone)(t.ddd + t.numberPhone);
	      return "";
	    },
	    tel: function tel() {
	      var t = this.user.telephones.telephone[0];
	      if (t) return (0, _string.phone)(t.ddd + t.numberPhone);
	      return "";
	    },
	    isPF: function isPF() {
	      return this.user.type == 'PESSOA_FISICA';
	    },
	    image: function image() {
	      if (!this.payment) return "";
	      return '/static/payment-methods/' + this.payment.imagePath.split('.')[0] + '.svg';
	    },
	    isCaminhoParana: function isCaminhoParana() {
	      return Utils.isCaminhoParana(this.planId);
	    },
	    plan: function plan() {
	      return this.$store.getters.getPlanById(this.planId);
	    },
	    newAdhesionTax: function newAdhesionTax() {
	      return this.$store.getters.getNewAdhesionTax(this.planId);
	    },
	    guaranteeTax: function guaranteeTax() {
	      return this.$store.getters.getGuaranteeTax(this.planId);
	    },
	    linkRntrcTax: function linkRntrcTax() {
	      return this.$store.getters.getLinkRntrcTax(this.planId);
	    },
	    monthlyTax: function monthlyTax() {
	      return this.$store.getters.getMonthlyTax(this.planId);
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var vm = this;
	    if (this.showRecharge) {
	      var recRecharge = {
	        planId: this.planId,
	        value: this.contract.rechargeValue
	      };
	
	      this.loading = _sales2.default.calculateRechargeRate(recRecharge).then(function (r) {
	        _this.rechargeValueTotal = r.valueTotal;
	        _this.rechargeTaxTotal = r.taxTotal;
	        _this.calculateTotal();
	      });
	    } else {
	      this.calculateTotal();
	    }
	    this.$store.dispatch('actWhereToDelivrey', 0);
	  },
	
	
	  watch: {
	    whereToDelivrey: function whereToDelivrey(newQuestion, oldQuestion) {
	      this.$store.dispatch('actWhereToDelivrey', newQuestion);
	    }
	  },
	
	  methods: {
	    calculateTotal: function calculateTotal() {
	      if (this.type == 'replaceTag') {
	        this.totalSemDesconto = this.total = this.replaceTax;
	      } else {
	        this.totalSemDesconto = this.vehicles.length * this.newVehicleTax + this.vehicles.length * this.guaranteeTax + this.rechargeValueTotal + this.rechargeTaxTotal;
	        if (this.monthlyTax) {
	          this.totalSemDesconto += this.vehicles.length * this.monthlyTax;
	        }
	
	        if (this.planId == 2 || this.planId == 3) {
	          this.totalSemDesconto += this.vehicles.length * this.linkRntrcTax;
	        }
	        this.total = this.totalSemDesconto;
	      }
	      if (this.isCaminhoParana) {
	        this.total -= this.vehicles.length * this.newVehicleTax;
	      } else if (this.descontoCupom) {
	        this.total -= this.descontoCupom;
	      }
	
	      this.$emit('setTotal', this.totalSemDesconto);
	    },
	    validateAll: function validateAll() {
	      return this.$validator.validateAll().then(function (r) {
	        return !changeAddress;
	      });
	    },
	    calculateDiscount: function calculateDiscount() {
	      var _this2 = this;
	
	      this.erroCupom = undefined;
	      var req = {
	        planId: this.planId,
	        promotionCode: this.cupom,
	        salesType: 'ADHESIONVEHICLEADDITIONAL'
	      };
	      _sales2.default.calculateDiscount(req).then(function (res) {
	
	        if (res.productId == _constantes2.default.SALES_TYPE.ADHESIONVEHICLEADDITIONAL || res.productId == _constantes2.default.SALES_TYPE.GUARANTEE) {
	          var qtd = res.discountLimit == 0 ? _this2.vehicles.length : Math.min(_this2.vehicles.length, res.discountLimit);
	          _this2.descontoCupom = qtd * res.valueUnitDiscount;
	        } else {
	          _this2.descontoCupom = res.valueUnitDiscount;
	        }
	        _this2.cupomApplied = true;
	        _this2.$emit('changePromotionCode', _this2.cupom);
	        _this2.calculateTotal();
	      }).catch(function (res) {
	
	        _this2.cupomApplied = false;
	        _this2.$emit('changePromotionCode', undefined);
	        _this2.erroCupom = res.data.status.message;
	      });
	    },
	    removeDiscount: function removeDiscount() {
	      this.descontoCupom = 0;
	      this.cupomApplied = false;
	      this.$emit('changePromotionCode', undefined);
	      this.calculateTotal();
	    },
	    getTolls: function getTolls(state, associateId) {
	      var _this3 = this;
	
	      this.loading = _toll2.default.getTollsByState(state).then(function (res) {
	        _this3.entries = _.filter(res, function (o) {
	          return o.associateId == associateId;
	        });
	        _this3.showEntries = true;
	      }).catch(function (err) {});
	    }
	  }
	};

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(70);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _map = __webpack_require__(121);
	
	var _map2 = _interopRequireDefault(_map);
	
	__webpack_require__(343);
	
	var _leaflet = __webpack_require__(345);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _number = __webpack_require__(24);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CLASS_PIN_REGULAR = "pin";
	var CLASS_PIN_SELECTED = "pin-selected";
	
	var counterPinCache = new _map2.default();
	
	var counterPinTemplate = __webpack_require__(481);
	
	function createCounterPin(val, clazz) {
	  var key = (0, _stringify2.default)(arguments);
	
	  var pin = counterPinCache.get(key);
	  if (pin) return pin;
	
	  var pinSvg = $(counterPinTemplate);
	  pinSvg.find('#icon').addClass(clazz);
	
	  pinSvg.find('#value').addClass(clazz).text(val);
	
	  var _html = $('<div>').append($(pinSvg).clone()).html();
	  pin = "data:image/svg+xml;base64," + btoa(_html);
	  counterPinCache.set(key, pin);
	  return pin;
	}
	
	
	function markerFromPlace(p) {
	  var size = 50;
	  var marker = _leaflet2.default.marker([p.pointLat, p.pointLng], {
	    icon: _leaflet2.default.icon({
	      iconUrl: createCounterPin(p.qtd, CLASS_PIN_REGULAR),
	      iconSize: [size, size]
	    })
	  });
	
	  marker.passageCount = p.qtd;
	
	  return marker;
	}
	
	exports.default = {
	  props: ['summary', 'selection'],
	
	  data: function data() {
	    return {
	      markers: [],
	      map: undefined,
	      group: _leaflet2.default.featureGroup()
	    };
	  },
	
	
	  watch: {
	    summary: function summary(val) {
	      var _this = this;
	
	      this.group.clearLayers();
	
	      if (!val) return false;
	
	      _.each(val, function (obj) {
	        if (obj.pointLat && obj.pointLng) {
	          var marker = markerFromPlace(obj);
	          marker.bindPopup('<b>' + obj.description + '</b><br>Quantidade de passagens: ' + obj.qtd + '<br>Total das passagens: ' + (0, _number.cents)(obj.total));
	          _this.markers[obj.maplinkId] = marker;
	          _this.group.addLayer(marker);
	        }
	      });
	      this.map.addLayer(this.group);
	      this.map.fitBounds(this.group.getBounds(), {
	        padding: [50, 50]
	      });
	    },
	    selection: function selection(newId, oldId) {
	      var _this2 = this;
	
	      if (newId == oldId) return;
	
	      var changeIcon = function changeIcon(id, color) {
	        var marker = _this2.markers[id];
	        if (marker) {
	          var options = _.clone(marker.options.icon.options);
	          options.iconUrl = createCounterPin(marker.passageCount, color);
	          marker.setIcon(_leaflet2.default.icon(options));
	        }
	      };
	
	      if (newId !== undefined) changeIcon(newId, CLASS_PIN_SELECTED);
	      if (oldId !== undefined) changeIcon(oldId, CLASS_PIN_REGULAR);
	    }
	  },
	
	  mounted: function mounted() {
	    this.map = _leaflet2.default.map(this.$el).setView([-23.533773, -46.625290], 13);
	    _leaflet2.default.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
	      maxZoom: 19,
	      attribution: '&copy;<a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
	    }).addTo(this.map);
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vehicleMap = __webpack_require__(1964);
	
	var _vehicleMap2 = _interopRequireDefault(_vehicleMap);
	
	var _pagination = __webpack_require__(33);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _vehicles = __webpack_require__(29);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	var _statements = __webpack_require__(171);
	
	var _statements2 = _interopRequireDefault(_statements);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pageSize = 10;
	
	var tenDaysAgo = new Date();
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: undefined,
	      selection: undefined,
	      passages: undefined,
	      summary: undefined,
	      page: new _pagination.Page(),
	      customStart: tenDaysAgo,
	      customEnd: new Date(),
	      vehicle: undefined,
	      totalValue: 0,
	      totalPassages: 0,
	      searchState: 'NOERROR',
	      messageErro: undefined
	    };
	  },
	
	
	  computed: {
	    vehicleId: function vehicleId() {
	      return this.$route.params.vehicleId;
	    },
	    contractId: function contractId() {
	      return this.$route.params.contractId;
	    },
	    startDate: function startDate() {
	      return (0, _moment2.default)(this.customStart).startOf('day').valueOf();
	    },
	    endDate: function endDate() {
	      return (0, _moment2.default)(this.customEnd).endOf('day').valueOf();
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.find(true);
	    _vehicles2.default.getVehicleById(this.vehicleId).then(function (r) {
	      _this.vehicle = r;
	    });
	  },
	
	
	  methods: {
	    setCurrentPage: function setCurrentPage(p) {
	      this.page = this.page.page(p);
	      this.find(false);
	    },
	    find: function find(updateSummary) {
	      var _this2 = this;
	
	      if (updateSummary) this.page = new _pagination.Page();
	
	      var filter = {
	        contractId: this.contractId,
	        vehicleId: this.vehicleId,
	        startDate: this.startDate,
	        endDate: this.endDate,
	        page: this.page.build(),
	        historicId: 1101
	      };
	
	      this.searchState = 'NOERROR';
	      if (this.customEnd >= this.customStart) {
	        this.loading = _statements2.default.find(filter).then(function (data) {
	
	          _this2.passages = data.itens;
	
	          _this2.page = _this2.page.itemCount(data.total);
	          return _vehicles2.default.listPassage(filter).then(function (sum) {
	
	            if (updateSummary) {
	
	              _this2.totalPassages = _this2.totalValue = 0;
	              _this2.summary = sum.passageSummaryList;
	              _.each(_this2.summary, function (obj) {
	                _this2.totalValue += obj.total;
	                _this2.totalPassages += obj.qtd;
	              });
	            }
	          });
	        }).catch(function (error) {
	          _this2.passages = undefined;
	          _this2.summary = undefined;
	          _this2.totalPassages = 0;
	          _this2.totalValue = 0;
	        });
	      } else {
	        this.searchState = 'ERROSEARCH';
	        this.messageErro = this.customEnd < this.customStart ? 'Data final deve ser maior que a data inicial' : 'Outros';
	      };
	    }
	  },
	
	  components: {
	    VehicleMap: _vehicleMap2.default,
	    Pagination: _pagination2.default
	  }
	};

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(69);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _vehicles = __webpack_require__(29);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	var _tag = __webpack_require__(55);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _pagination = __webpack_require__(33);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pageSize = 10;
	
	exports.default = {
	  data: function data() {
	    return {
	      data: undefined,
	      page: new _pagination.Page(),
	      state: 'LOADING',
	      filter: '',
	      loading: false,
	      vehiclesChecked: []
	    };
	  },
	  mounted: function mounted() {
	    this.find();
	  },
	
	
	  computed: {
	    contractId: function contractId() {
	      return this.$route.params.contractId;
	    }
	  },
	
	  methods: {
	    setCurrentPage: function setCurrentPage(p) {
	      this.page = this.page.page(p);
	      this.find();
	    },
	    setPageSize: function setPageSize(size) {
	      this.page = this.page.size(size);
	      this.find();
	    },
	    find: function find() {
	      var _this = this;
	
	      this.state = 'LOADING';
	      var filter = {
	        contractId: this.contractId,
	        page: {
	          pageSize: this.page.size(),
	          pageNumber: this.page.page()
	        }
	      };
	
	      this.loading = _vehicles2.default.getVehicle(filter).then(function (data) {
	        if (data) {
	          _this.data = data;
	          _this.state = _this.data.itens && 'LOADED' || 'NOTFOUND';
	          _this.page = _this.page.itemCount(data.total);
	
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = (0, _getIterator3.default)(_this.data.itens), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var v = _step.value;
	
	              if (v.enabledPap == 'Y') _this.vehiclesChecked.push(v.vehicleId);
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	        }
	      }).catch(function (err) {
	        _this.state = 'NOTFOUND';
	        var msg = err.data && err.data.status && err.data.status.message || "Erro do servidor.";
	      });
	    },
	    tooglePtoP: function tooglePtoP(itens) {
	      var _this2 = this;
	
	      itens.requestReplaceTag = 'N';
	
	      var enabledPap = void 0;
	
	      if (itens.enabledPap) {
	        enabledPap = itens.enabledPap;
	      } else {
	        enabledPap = 'N';
	      }
	
	      if (enabledPap == 'Y') {
	        enabledPap = 'N';
	      } else if (enabledPap == 'N') {
	        enabledPap = 'Y';
	      }
	      var options = {
	        placement: 'top',
	        html: true,
	        delay: { "show": 500, "hide": 300 },
	
	        content: enabledPap == 'Y' ? 'Veículo incluído com sucesso!' : 'Veículo excluído com sucesso!',
	        animation: true,
	        template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	      };
	
	      var vehicleId = itens.vehicleId;
	
	      this.loading = _vehicles2.default.updateVehicle(enabledPap, vehicleId).then(function () {
	
	        $('#' + itens.vehicleId).popover(options);
	        $('#' + itens.vehicleId).popover('show');
	
	        setTimeout(function () {
	          $('#' + itens.vehicleId).popover('destroy');
	        }, 2000);
	
	        _this2.find();
	      }).catch(function () {
	        options.content = 'Erro ao processar requisição';
	        $('#' + itens.vehicleId).popover(options);
	        $('#' + itens.vehicleId).popover('show');
	
	        setTimeout(function () {
	          $('#' + itens.vehicleId).popover('destroy');
	        }, 2000);
	      });
	    }
	  },
	  components: {
	    Pagination: _pagination2.default
	  }
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _vehicles = __webpack_require__(29);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _tag = __webpack_require__(55);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _pagination = __webpack_require__(33);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _modalSwitchPlate = __webpack_require__(1882);
	
	var _modalSwitchPlate2 = _interopRequireDefault(_modalSwitchPlate);
	
	var _modalSucessMerc = __webpack_require__(1881);
	
	var _modalSucessMerc2 = _interopRequireDefault(_modalSucessMerc);
	
	var _modalErrorMerc = __webpack_require__(1879);
	
	var _modalErrorMerc2 = _interopRequireDefault(_modalErrorMerc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pageSize = 10;
	
	exports.default = {
	  data: function data() {
	    return {
	      data: undefined,
	      page: new _pagination.Page(),
	      state: 'LOADING',
	      filter: '',
	      loading: false,
	      vehicleToBlock: undefined,
	      reasonBlock: '',
	      errorMessage: undefined,
	      exportError: undefined,
	      exportingVehicles: false,
	      plateOrObuid: '',
	      loadingModal: undefined,
	      contractActive: false,
	      showMercModal: false,
	      plateToConvert: undefined,
	      showSuccessConvertModal: undefined,
	      showModalErrorConvert: undefined,
	      isMobile: undefined,
	      groupers: [],
	      groupersOp: [],
	      selectedOptions: {},
	      isGrouper: null
	    };
	  },
	  created: function created() {
	    var isGrouper = JSON.parse(localStorage.getItem('grouper'));
	    this.isGrouper = isGrouper;
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      var _ref, contractStatusId;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _contracts2.default.getContractByContractId(_this.contractId);
	
	            case 2:
	              _ref = _context.sent;
	              contractStatusId = _ref.status.contractStatusId;
	
	
	              if (contractStatusId != 0 && contractStatusId != 2 && contractStatusId != 3 && contractStatusId != 4 && contractStatusId != 7 && contractStatusId != 8) {
	                _this.contractActive = true;
	              } else {
	                _this.contractActive = false;
	              }
	
	              _this.find();
	              _this.loadGroupers();
	
	              if (window.innerWidth <= 769) {
	                _this.isMobile = true;
	              } else {
	                _this.isMobile = false;
	              }
	
	              window.addEventListener('resize', function () {
	                return window.innerWidth <= 769 ? _this.isMobile = true : _this.isMobile = false;
	              });
	
	            case 9:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	
	  computed: {
	    shouldShowButton: function shouldShowButton() {
	      return (/^[A-Za-z]$/.test(this.vehicle.plate.charAt(4))
	      );
	    },
	    contractId: function contractId() {
	      return this.$route.params.contractId;
	    },
	    hasVehicles: function hasVehicles() {
	      return !!(this.data && Array.isArray(this.data.itens) && this.data.itens.length);
	    }
	  },
	
	  methods: {
	    exportVehicles: function exportVehicles() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var url, link, report, httpStatus;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (!(_this2.exportingVehicles || !_this2.hasVehicles)) {
	                  _context2.next = 2;
	                  break;
	                }
	
	                return _context2.abrupt('return');
	
	              case 2:
	
	                _this2.exportingVehicles = true;
	                _this2.exportError = undefined;
	                url = void 0;
	                link = void 0;
	                _context2.prev = 6;
	                report = void 0;
	                _context2.prev = 8;
	                _context2.next = 11;
	                return _vehicles2.default.exportVehicles(_this2.contractId);
	
	              case 11:
	                report = _context2.sent;
	                _context2.next = 19;
	                break;
	
	              case 14:
	                _context2.prev = 14;
	                _context2.t0 = _context2['catch'](8);
	                httpStatus = _context2.t0 && (_context2.t0.response && _context2.t0.response.status || _context2.t0.status);
	
	                if (_context2.t0 && _context2.t0.exportStatusCode == 9000 || httpStatus == 401) {
	                  _this2.exportError = 'Sua sessão expirou, por favor faça o login novamente.';
	                } else if (_context2.t0 && _context2.t0.exportStatusCode == 404 || httpStatus == 404) {
	                  _this2.exportError = 'Não existem veículos disponíveis para exportação.';
	                } else {
	                  _this2.exportError = 'Não foi possível gerar o arquivo no momento. Tente novamente mais tarde.';
	                }
	                return _context2.abrupt('return');
	
	              case 19:
	
	                url = window.URL.createObjectURL(report);
	                link = document.createElement('a');
	                link.href = url;
	                link.download = 'relatorio_veiculos.xls';
	                document.body.appendChild(link);
	                link.click();
	                _context2.next = 30;
	                break;
	
	              case 27:
	                _context2.prev = 27;
	                _context2.t1 = _context2['catch'](6);
	
	                _this2.exportError = 'Não foi possível baixar o arquivo. Atualize a página e tente novamente.';
	
	              case 30:
	                _context2.prev = 30;
	
	                if (link && link.parentNode) link.parentNode.removeChild(link);
	                if (url) {
	                  setTimeout(function () {
	                    return window.URL.revokeObjectURL(url);
	                  }, 1000);
	                }
	                _this2.exportingVehicles = false;
	                return _context2.finish(30);
	
	              case 35:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2, [[6, 27, 30, 35], [8, 14]]);
	      }))();
	    },
	    showSwitchPlate: function showSwitchPlate(selectedPlate) {
	      this.showMercModal = true;
	      this.plateToConvert = selectedPlate;
	    },
	    showSuccessModal: function showSuccessModal(success) {
	      this.showSuccessConvertModal = true;
	    },
	    showErrorModal: function showErrorModal(e) {
	      this.showModalErrorConvert = true;
	    },
	    fecharModal: function fecharModal() {
	      this.showMercModal = false;
	      this.find();
	    },
	    concluirSucesso: function concluirSucesso() {
	      this.showSuccessConvertModal = false;
	    },
	    concluirErro: function concluirErro() {
	      this.showModalErrorConvert = false;
	    },
	    showMessageContract: function showMessageContract() {
	      _messageDialog2.default.show({
	        title: 'Info',
	        headerClass: 'modal-info',
	        message: 'Operação disponivel somente para contratos ativos'
	      });
	    },
	    setCurrentPage: function setCurrentPage(p) {
	      this.page = this.page.page(p);
	      this.find();
	    },
	    setPageSize: function setPageSize(size) {
	      this.page = this.page.size(size);
	      this.find();
	    },
	    find: function find() {
	      var _this3 = this;
	
	      this.state = 'LOADING';
	      this.errorMessage = '';
	      var filter = {
	        contractId: this.contractId,
	        page: {
	          pageSize: this.page.size(),
	          pageNumber: this.page.page()
	        }
	      };
	      this.loading = _vehicles2.default.getVehicle(filter).then(function (data) {
	        if (data) {
	          _this3.data = data;
	          _this3.state = _this3.data.itens && 'LOADED' || 'NOTFOUND';
	          _this3.page = _this3.page.itemCount(data.total);
	        }
	      }).catch(function (err) {
	        console.error(err);
	        _this3.state = 'NOTFOUND';
	        _this3.errorMessage = err.data && err.data.status && err.data.status.message || "Erro do servidor.";
	        _this3.data = err.data;
	      });
	    },
	    search: function search() {
	      var _this4 = this;
	
	      this.state = 'LOADING';
	      this.errorMessage = '';
	      var regex = /^[a-zA-Z0-9]{3}\-?[a-zA-Z0-9]{4}$/;
	      var promise = void 0;
	      if (this.plateOrObuid == '') {
	        this.find();
	        return;
	      } else if (regex.test(this.plateOrObuid)) {
	        promise = _vehicles2.default.getVehicle({ 'plate': this.plateOrObuid, 'contractId': this.contractId });
	      } else {
	        if (/[^0-9]/.test(this.plateOrObuid)) {
	          this.errorMessage = 'Valor pesquisado inválido';
	          this.data.itens = undefined;
	          this.state = 'NOTFOUND';
	          return;
	        }
	        promise = _vehicles2.default.getVehicle({ 'tag': this.plateOrObuid });
	      }
	      this.loading = promise.then(function (data) {
	        if (data) {
	          _this4.data = data;
	          _this4.state = _this4.data.itens && _this4.data.itens && 'LOADED' || 'NOTFOUND';
	        }
	      }).catch(function (err) {
	        console.error(err);
	        _this4.state = 'NOTFOUND';
	        _this4.errorMessage = err.data && err.data.status && err.data.status.message || "Erro do servidor.";
	        _this4.data = err.data;
	      });
	    },
	    showBlock: function showBlock(vehicle) {
	      if (vehicle.reasonBlockId == 0) {
	        return true;
	      }
	
	      return false;
	    },
	    showUnblock: function showUnblock(vehicle) {
	      if (vehicle.reasonId == 8) return true;
	
	      return false;
	    },
	    showEditar: function showEditar(vehicle) {
	      if (vehicle.tagSerialNumber && (vehicle.tagStatusId == 2 || vehicle.tagStatusId == 3)) return false;
	
	      return true;
	    },
	    showReplace: function showReplace(vehicle) {
	      if (vehicle.tagSerialNumber && (vehicle.requestReplaceTag == 'N' || !vehicle.requestReplaceTag)) return true;
	      return false;
	    },
	    blockTag: function blockTag() {
	      var _this5 = this;
	
	      this.errorMessage = undefined;
	      this.loadingModal = this.$validator.validateAll().then(function (success) {
	        return _tag2.default.blockTagTemp(_this5.vehicleToBlock.tagSerialNumber, _this5.reasonBlock).then(function (res) {
	          if (res.data.status.code == 0) {
	            _this5.vehicleToBlock = undefined;
	            _this5.reasonBlock = '';
	            _this5.find();
	          }
	        }).catch(function (err) {
	          _this5.errorMessage = 'Erro ao bloquear a tag!';
	        });
	      });
	    },
	    unblockTag: function unblockTag(vehicle) {
	      var _this6 = this;
	
	      _messageDialog2.default.show({
	        title: 'Desbloquear Tag.',
	        message: '<p>Após a solicitação do desbloqueio da TAG, você precisa aguardar até 6 horas para que aconteça o desbloqueio em todas as praças de pedágios.</p><p>Confirma o desbloqueio?</p>',
	        type: 'YES-NO'
	      }).then(function (res) {
	        if (res === 'YES') {
	
	          _this6.loading = _tag2.default.unblockTag(vehicle.tagSerialNumber).then(function (res) {
	            if (res.data.status) {
	              _this6.find();
	            } else {
	              _messageDialog2.default.show({
	                title: 'Erro',
	                message: res.data.state.message,
	                type: 'YES-NO'
	              });
	            }
	          });
	        }
	      });
	    },
	    getStatus: function getStatus(vehicle) {
	
	      if (vehicle.reasonDescription) {
	        if (vehicle.reasonBlockDescription.toUpperCase() == "DESBLOQUEADO") {
	          return 'Ativo';
	        } else {
	          return 'Bloqueado';
	        }
	      } else {
	        return 'Ainda não possui TAG';
	      }
	    },
	    getStatusClass: function getStatusClass(vehicle) {
	
	      if (vehicle.reasonDescription) {
	        if (vehicle.reasonBlockDescription.toUpperCase() == "DESBLOQUEADO") {
	          return 'status-active';
	        } else {
	          return 'status-inactive';
	        }
	      } else {
	        return 'status-warning';
	      }
	    },
	    cancelar: function cancelar() {
	
	      this.vehicleToBlock = undefined;
	      this.reasonBlock = '';
	    },
	    loadGroupers: function loadGroupers() {
	      var _this7 = this;
	
	      _contracts2.default.getGroupers(JSON.parse(localStorage.getItem("currentUser")).moveMaisId).then(function (res) {
	        if (res.status.code === 0) {
	          _this7.groupers = res.Agrupadores;
	          _this7.groupersOp = _this7.groupers.map(function (grouper) {
	            return {
	              caption: grouper.nome,
	              value: grouper.idAgrupadorCliente
	            };
	          });
	        }
	      }).catch(function (err) {
	        console.error("Erro ao carregar os agrupadores", err);
	      });
	    },
	    handleOptionChange: function handleOptionChange(vehicle, idAgrupadorCliente) {
	      var _this8 = this;
	
	      _vehicles2.default.createVehicleGrouper(vehicle.vehicleId, idAgrupadorCliente).then(function (res) {
	        _messageDialog2.default.show({
	          title: "Sucesso",
	          headerClass: 'modal-success',
	          message: res.status.message,
	          type: "OK"
	        });
	        _this8.find();
	      }).catch(function (error) {
	        _messageDialog2.default.show({
	          title: "Erro",
	          headerClass: "modal-danger",
	          message: error.data.status.message || "Ocorreu um erro desconhecido",
	          type: "OK"
	        });
	      });
	    }
	  },
	  components: {
	    Pagination: _pagination2.default,
	    modalSwitchPlate: _modalSwitchPlate2.default,
	    modalSucessMerc: _modalSucessMerc2.default,
	    modalErrorMerc: _modalErrorMerc2.default
	  }
	
	};

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _lodash = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  props: ['origin'],
	
	  data: function data() {
	    return {
	      taxIdNumber: undefined,
	      formState: 'NEW',
	      loading: false,
	      TFACode: undefined,
	      errorMessage: undefined,
	      enabledButton: false,
	      TFACodeInput: null,
	      tokenInput: ''
	    };
	  },
	
	
	  computed: {
	    type: function type() {
	      return this.origin || this.$route.params.type;
	    }
	  },
	
	  created: function created() {
	    this.taxIdNumber = _auth2.default.getTaxIdNumber();
	  },
	
	
	  methods: {
	    requestAgain: function requestAgain() {
	      var _this = this;
	
	      var hash = _auth2.default.getHash();
	      var isAccountUnlock = hash.indexOf('escolher-canal/desbloqueioConta') !== -1;
	      var isResetPassword = hash.indexOf('escolher-canal/reset') !== -1;
	
	      var redirectPage = isResetPassword || isAccountUnlock ? 'password-set' : 'login';
	      var redirectParams = isResetPassword || isAccountUnlock ? 'desbloqueioConta' : 'reset';
	
	      var origin = isResetPassword ? 'RESET_PASSWORD' : "LOGIN";
	
	      this.formState = 'NEW';
	      this.$validator.validateAll().then(function (success) {
	        _auth2.default.tokenGenerateResend(_this.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), origin);
	        console.log('codigo reenviado');
	      });
	    },
	    doRequest: function doRequest() {
	      var _this2 = this;
	
	      this.taxIdNumber = _auth2.default.getTaxIdNumber();
	      var originTelas = this.origin || this.$route.params.type;
	      console.log('taxId ', this.taxIdNumber, originTelas);
	      if (originTelas == 'UPDATE_USER_EMAIL') {
	        this.$validator.validateAll().then(function (success) {
	          _this2.loading = _auth2.default.twoFactorAuthentication(_this2.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), _this2.tokenInput, originTelas).then(function (data) {
	            console.log(_auth2.default.currentUser.moveMaisId);
	            _auth2.default.changeCurrentUser(_auth2.default.currentUser.moveMaisId);
	            _this2.$router.push({ name: 'user-contacts-change', params: { type: originTelas } });
	          }).catch(function (err) {
	            console.error(err);
	            _this2.errorMessage = err.data.status.message;
	          });
	        });
	      };
	
	      if (originTelas == 'UPDATE_NEW_USER_EMAIL') {
	        this.$validator.validateAll().then(function (success) {
	          _this2.loading = _auth2.default.twoFactorAuthentication(_this2.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), _this2.tokenInput, originTelas).then(function (data) {
	            return _auth2.default.updateNewUserEmail(_this2.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), _auth2.default.getNewEmail()).then(function () {
	              _messageDialog2.default.show({
	                headerClass: 'modal-success',
	                title: 'Alteração cadastral',
	                message: 'Novo e-mail cadastrado com sucesso!',
	                type: 'OK'
	              });
	              _auth2.default.changeCurrentUser(_auth2.default.currentUser.moveMaisId);
	              _auth2.default.changeCurrentUser(_auth2.default.currentUser.moveMaisId);
	              _this2.$router.push({ name: 'plans' });
	            });
	          }).catch(function (err) {
	            console.error(err);
	            _this2.errorMessage = err.data.status.message;
	          });
	        });
	      };
	
	      if (originTelas == 'UPDATE_PASSWORD') {
	        this.$validator.validateAll().then(function (success) {
	          _this2.loading = _auth2.default.twoFactorAuthentication(_this2.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), _this2.tokenInput, originTelas).then(function (data) {
	            _this2.$router.push({ name: 'password-change' });
	          }).catch(function (err) {
	            console.error(err);
	            _this2.errorMessage = err.data.status.message;
	          });
	        });
	      };
	
	      if (originTelas == 'UPDATE_USER_PHONE') {
	        this.$validator.validateAll().then(function (success) {
	          _this2.loading = _auth2.default.twoFactorAuthentication(_this2.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), _this2.tokenInput, originTelas).then(function (data) {
	            _auth2.default.changeCurrentUser(_auth2.default.currentUser.moveMaisId);
	            _this2.$router.push({ name: 'user-contacts-change', params: { type: originTelas } });
	          }).catch(function (err) {
	            console.error(err);
	            _this2.errorMessage = err.data.status.message;
	          });
	        });
	      };
	
	      if (originTelas == 'UPDATE_NEW_USER_PHONE') {
	        this.$validator.validateAll().then(function (success) {
	          _this2.loading = _auth2.default.twoFactorAuthentication(_this2.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), _this2.tokenInput, originTelas).then(function (data) {
	            _auth2.default.updateNewUserPhone(_this2.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), _auth2.default.getNewPhone()).then(function () {
	              _messageDialog2.default.show({
	                headerClass: 'modal-success',
	                title: 'Alteração cadastral',
	                message: 'Novo celular cadastrado com sucesso!',
	                type: 'OK'
	              });
	              _auth2.default.changeCurrentUser(_auth2.default.currentUser.moveMaisId);
	              _this2.$router.push({ name: 'plans' });
	            });
	          }).catch(function (err) {
	            console.error(err);
	            _this2.errorMessage = err.data.status.message;
	          });
	        });
	      };
	
	      if (originTelas == 'SMS' || originTelas == 'EMAIL') {
	        this.$validator.validateAll().then(function (success) {
	          _this2.loading = _auth2.default.twoFactorAuthentication(_this2.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), _this2.tokenInput, 'LOGIN').then(function (data) {
	            _auth2.default.changeCurrentUser(_auth2.default.getMoveMaisId()).then(function (r) {
	              _this2.$router.push({ name: 'plans', query: { showPromotionalModal: true } });
	            });
	          }).catch(function (err) {
	            console.error(err);
	            _this2.errorMessage = err.data.status.message;
	          });
	        });
	      }
	
	      if (originTelas == 'UPDATE_ACCOUNT') {
	        this.$validator.validateAll().then(function (success) {
	          _this2.loading = _auth2.default.twoFactorAuthentication(_this2.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), _this2.tokenInput, originTelas).then(function (data) {
	            _this2.$emit("sucess2fa");
	          }).catch(function (err) {
	            console.error(err);
	            _this2.errorMessage = err.data.status.message;
	          });
	        });
	      }
	
	      if (originTelas == 'RESET_PASSWORD') {
	        this.$validator.validateAll().then(function (success) {
	          _this2.loading = _auth2.default.twoFactorAuthentication(_this2.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), _this2.tokenInput, originTelas).then(function (data) {
	            _this2.$router.push({ name: 'password-set', params: { type: 'reset' } });
	          }).catch(function (err) {
	            console.error(err);
	            _this2.errorMessage = err.data.status.message;
	          });
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      taxIdNumber: undefined,
	
	      formState: 'NEW',
	      loading: false,
	      TFACode: undefined,
	      origemTelas: undefined,
	      origin: undefined
	    };
	  },
	
	
	  computed: {
	    type: function type() {
	      return this.$route.params.type;
	    }
	  },
	
	  created: function created() {
	    this.taxIdNumber = this.$route.query.taxIdNumber;
	  },
	
	
	  methods: {
	    requestAgain: function requestAgain() {
	      if (this.$route.params.type == 'desbloqueioConta' || this.$route.params.type == 'reset') {
	        origin = 'RESET_PASSWORD';
	      } else {
	        if (this.$route.params.type == 'login') {
	          origin = 'LOGIN';
	        };
	      };
	
	      var hash = _auth2.default.getHash();
	      var isAccountUnlock = hash.indexOf('escolher-canal/desbloqueioConta') !== -1;
	      var isResetPassword = hash.indexOf('escolher-canal/reset') !== -1;
	
	      var redirectPage = isResetPassword || isAccountUnlock ? 'password-set' : 'login';
	      var redirectParams = isResetPassword || isAccountUnlock ? 'desbloqueioConta' : 'reset';
	
	      this.formState = 'NEW';
	      this.$validator.validateAll().then(function (success) {
	        var taxIdNumber = _auth2.default.getTaxIdNumber();
	        _auth2.default.tokenGenerateResend(taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), origin);
	        console.log('ok');
	      });
	    },
	    doRequest: function doRequest() {
	      var _this = this;
	
	      if (this.$route.params.type == 'desbloqueioConta' || this.$route.params.type == 'reset') {
	        origin = 'RESET_PASSWORD';
	      } else {
	        if (this.$route.params.type == 'login') {
	          origin = 'LOGIN';
	        };
	      };
	
	      var hash = _auth2.default.getHash();
	      var isAccountUnlock = hash.indexOf('escolher-canal/desbloqueioConta') !== -1;
	      var isResetPassword = hash.indexOf('escolher-canal/reset') !== -1;
	
	      var redirectPage = isResetPassword || isAccountUnlock ? 'password-set' : 'login';
	      var redirectParams = isResetPassword || isAccountUnlock ? 'desbloqueioConta' : 'reset';
	
	      this.formState = 'NEW';
	      this.$validator.validateAll().then(function (success) {
	        var taxIdNumber = _auth2.default.getTaxIdNumber();
	        _auth2.default.twoFactorAuthentication(taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), _this.TFACode, origin).then(function (data) {
	          if (data.status.code === 0) {
	            _auth2.default.saveToken(_this.TFACode);
	            _auth2.default.saveMoveMaisId(data.movemaisId);
	            _this.$router.push({ name: redirectPage, params: { type: redirectParams } });
	          }
	        }).catch(function (err) {
	          _this.formState = 'ERROR';
	          _this.errorMessage = err.data.status.message;
	        });
	      });
	    }
	  }
	};

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      taxIdNumber: undefined,
	
	      formState: 'NEW',
	      loading: false,
	      validTaxIdNumber: false
	    };
	  },
	
	
	  computed: {
	    type: function type() {
	      return this.$route.params.type;
	    }
	  },
	
	  created: function created() {
	    this.taxIdNumber = this.$route.query.taxIdNumber;
	  },
	
	
	  methods: {
	    doRequest: function doRequest() {
	      var _this = this;
	
	      var hash = window.location.hash;
	      _auth2.default.saveHash(hash);
	
	      this.formState = 'NEW';
	      this.$validator.validateAll().then(function (success) {
	        console.log(_this.taxIdNumber);
	        _auth2.default.saveTaxIdNumber(_this.taxIdNumber);
	        _this.$router.push({
	          name: 'auth-email-tel-req'
	        });
	      });
	    }
	  }
	};

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      formState: 'NEW',
	      loading: undefined,
	      phone: undefined,
	      errorMessage: undefined,
	      successMessage: undefined
	    };
	  },
	
	
	  computed: {},
	
	  created: function created() {},
	
	
	  methods: {
	    doRequest: function doRequest() {
	      var _this = this;
	
	      _auth2.default.saveHash(window.location.hash);
	      this.formState = 'NEW';
	      this.$validator.validateAll().then(function (success) {
	        var taxIdNumber = _auth2.default.getTaxIdNumber();
	        _auth2.default.retrieveEmail(taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), _this.phone).then(function (data) {
	          if (data.status.code === 0) {
	            _this.formState = 'SUCCESS';
	            _this.successMessage = data.status.message;
	          }
	        }).catch(function (err) {
	          _this.formState = 'ERROR';
	          _this.errorMessage = err.data.status.message;
	        });
	      });
	    }
	  }
	};

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      taxIdNumber: undefined,
	      loading: false,
	      chooseEmail: false,
	      chooseCellphone: false,
	      email: undefined,
	      cellphone: undefined,
	      channelSelected: undefined,
	      origemTelas: undefined,
	      errorMessage: undefined
	    };
	  },
	
	
	  watch: {
	    channelSelectedForm: function channelSelectedForm(newValue) {
	      if (this.channelSelected == 'EMAIL') {
	        this.chooseEmail = true;
	      } else if (this.channelSelected == 'SMS') {
	        this.chooseCellphone = true;
	      }
	    }
	  },
	
	  computed: {
	    type: function type() {
	      return this.$route.params.type;
	    }
	  },
	
	  created: function created() {},
	
	
	  methods: {
	    validate: function validate() {
	      if (this.chooseEmail) {
	        this.showCellphoneForm = false;
	        this.showEmailForm = true;
	      }
	      if (this.chooseCellphone) {
	        this.showCellphoneForm = true;
	        this.showEmailForm = false;
	      }
	    },
	    doRequest: function doRequest() {
	      var _this = this;
	
	      this.errorMessage = undefined;
	
	      _auth2.default.tokenGenerateResend(_auth2.default.getTaxIdNumber().replace(/[.\-\/]/g, '').toUpperCase(), 'LOGIN', this.channelSelected).then(function (res) {
	        _this.$router.push({ name: '2fa-login', params: { type: _this.channelSelected } });
	      }).catch(function (err) {
	        _this.errorMessage = err.data.status.message;
	      });
	    }
	  }
	};

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      taxIdNumber: undefined,
	
	      formState: 'NEW',
	      loading: false,
	      chooseEmail: false,
	      chooseCellphone: false,
	      email: undefined,
	      cellphone: undefined,
	      channelSelected: undefined,
	      origemTelas: undefined
	    };
	  },
	
	
	  watch: {
	    channelSelectedForm: function channelSelectedForm(newValue) {
	      if (this.channelSelected == 'email') {
	        this.chooseEmail = true;
	      } else if (this.channelSelected == 'cellphone') {
	        this.chooseCellphone = true;
	      }
	    }
	  },
	
	  computed: {
	    type: function type() {
	      return this.$route.params.type;
	    }
	  },
	
	  created: function created() {
	    this.taxIdNumber = this.$route.query.taxIdNumber;
	    this.origemTelas = this.$route.params.type;
	  },
	
	
	  methods: {
	    validate: function validate() {
	      if (this.chooseEmail) {
	        this.showCellphoneForm = false;
	        this.showEmailForm = true;
	      }
	      if (this.chooseCellphone) {
	        this.showCellphoneForm = true;
	        this.showEmailForm = false;
	      }
	    },
	    doRequest: function doRequest() {
	      var _this = this;
	
	      _auth2.default.saveHash(window.location.hash);
	      this.formState = 'NEW';
	      this.$validator.validateAll().then(function (success) {
	        var taxIdNumber = _auth2.default.getTaxIdNumber();
	        _auth2.default.validUserResetPassword(taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), _this.cellphone, _this.email).then(function (data) {
	          if (data.status.code === 0) {
	            _this.$router.push({
	              name: '2fa',
	              params: { type: _this.origemTelas }
	            });
	          }
	        }).catch(function (err) {
	          _this.formState = 'ERROR';
	          _this.errorMessage = err.data.status.message;
	        });
	      });
	    }
	  }
	};

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      taxIdNumber: undefined,
	      password: undefined,
	      errorMessage: undefined,
	      email: null,
	      loading: _promise2.default.resolve(true),
	      saveTaxId: false
	    };
	  },
	  created: function created() {
	    if (_auth2.default.getTaxId()) {
	      this.taxIdNumber = _auth2.default.getTaxId();
	      this.saveTaxId = true;
	    }
	    if (_auth2.default.getPass()) {
	      this.password = _auth2.default.getPass();
	      this.saveTaxId = true;
	    }
	    this.password = '';
	  },
	
	  mounted: function mounted() {
	    if (this.$route.query.sessionExpired) {
	      $('body').removeClass('modal-open').css('padding-right', '0');
	      $('.modal-backdrop').hide();
	      this.errorMessage = 'Sua sessão expirou, por favor faça o login novamente';
	    }
	  },
	  methods: {
	    doLogin: function doLogin() {
	      var _this = this;
	
	      this.errorMessage = undefined;
	      this.$validator.validateAll().then(function (success) {
	        var username = _this.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase();
	        _this.loading = _auth2.default.login(username, _this.password, _this.email).then(function (user) {
	          console.log("retorno login user ", user);
	          _auth2.default.isGrouper(user.moveMaisId).then(function (isGrouper) {
	            _auth2.default.saveIsGrouper(isGrouper.Agrupador);
	          });
	          _auth2.default.saveTaxIdNumber(_this.taxIdNumber);
	          _auth2.default.saveMoveMaisId(user.moveMaisId);
	          if (user.otherSalesReference === 'REPOM') {
	            _this.$router.push({
	              name: 'repom'
	            });
	          } else {
	            if (_this.saveTaxId) {
	              _auth2.default.saveTaxId(_this.taxIdNumber, _this.password);
	            } else {
	              _auth2.default.deleteTaxId();
	            }
	
	            if (_auth2.default.getLoginTFA() == 'Y') {
	              _this.$router.push({
	                name: 'choose-channel-interno',
	                params: { type: 'login' }
	              });
	            } else {
	              _this.$router.push({
	                name: 'plans',
	                query: { showPromotionalModal: true }
	              });
	            }
	          }
	        }).catch(function (err) {
	
	          _this.errorMessage = err.status && err.data.status && err.data.status.message || "Erro do servidor.";
	        });
	      });
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(48);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    var _ref;
	
	    return _ref = {
	      password: undefined,
	      oldPassword: undefined,
	      passwordRepeat: undefined,
	      errorMessage: undefined,
	      loading: undefined
	
	    }, (0, _defineProperty3.default)(_ref, 'password', null), (0, _defineProperty3.default)(_ref, 'passwordLength', 0), (0, _defineProperty3.default)(_ref, 'containsEightCharacters', false), (0, _defineProperty3.default)(_ref, 'containsNumber', false), (0, _defineProperty3.default)(_ref, 'containsUppercase', false), (0, _defineProperty3.default)(_ref, 'containsSpecialCharacter', false), (0, _defineProperty3.default)(_ref, 'validPassword', false), _ref;
	  },
	
	  methods: {
	    doRequest: function doRequest() {
	      var _this = this;
	
	      this.loading = _auth2.default.requestChangePassword(_auth2.default.getTaxIdNumber().replace(/[.\-\/]/g, '').toUpperCase()).then(function (resp) {
	        if (resp) _this.$router.push({ name: '2fa-interno',
	          params: { type: 'UPDATE_PASSWORD' } });
	      }).catch(function (err) {
	        _this.formState = 'ERROR';
	        console.log('erro: ', err.data.status.message);
	        _this.errorMessage = err.data.status.message;
	      });
	    },
	    doChange: function doChange() {
	      var _this2 = this;
	
	      this.$validator.validateAll().then(function (success) {
	        _this2.loading = _auth2.default.changePassword(_this2.oldPassword, _this2.password).then(function (value) {
	          if (value) return _messageDialog2.default.show({
	            headerClass: 'modal-success',
	            title: 'Definição de senha',
	            message: 'Sua senha foi alterada com sucesso!',
	            type: 'OK'
	          }).then(function () {
	            _this2.$router.push({ name: 'plans'
	            });
	          });
	        }).catch(function (error) {
	          _this2.errorMessage = error.data && error.data.status && error.data.status.message || "Erro do servidor.";
	        });
	      });
	    }
	  }
	};

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      password: undefined,
	      oldPassword: undefined,
	      passwordRepeat: undefined,
	      errorMessage: undefined,
	      loading: undefined
	    };
	  },
	
	  methods: {
	    doChange: function doChange() {
	      var _this = this;
	
	      this.$validator.validateAll().then(function (success) {
	        _this.loading = _auth2.default.changePassword(_this.oldPassword, _this.password).then(function (value) {
	          if (value) return _messageDialog2.default.show({
	            headerClass: 'modal-success',
	            title: 'Definição de senha',
	            message: 'Sua senha foi alterada com sucesso!',
	            type: 'OK'
	          }).then(function () {
	            _this.$router.push({ name: 'plans' });
	          });
	        }).catch(function (error) {
	          _this.errorMessage = error.data && error.data.status && error.data.status.message || "Erro do servidor.";
	        });
	      });
	    }
	  }
	};

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _stringify = __webpack_require__(70);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(49);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _locale = __webpack_require__(332);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _authHelper = __webpack_require__(747);
	
	var _authHelper2 = _interopRequireDefault(_authHelper);
	
	var _modalValidate = __webpack_require__(514);
	
	var _modalValidate2 = _interopRequireDefault(_modalValidate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    ModalValidate: _modalValidate2.default
	  },
	
	  data: function data() {
	    return {
	      taxIdNumber: undefined,
	      formState: "NEW",
	      loading: false,
	      validTaxIdNumber: false,
	      origemTelas: undefined,
	      errorMessage: undefined,
	      initProcess: false,
	      showValidationModal: false,
	      userEmail: "",
	      userResponse: null,
	      initialTimerValue: 60,
	      isProcessing: false,
	      requestTimeout: 30000,
	      pendingMoveMaisId: null,
	      selectedChannel: null
	    };
	  },
	
	
	  computed: {
	    type: function type() {
	      return this.$route.params.type;
	    }
	  },
	
	  created: function created() {
	    this.taxIdNumber = this.$route.query.taxIdNumber;
	    this.origemTelas = this.$route.params.type;
	  },
	  mounted: function mounted() {
	    this.restorePasswordResetSession();
	  },
	
	
	  methods: {
	    getMoveMaisIdFromResponse: function getMoveMaisIdFromResponse(response) {
	      if (!response) {
	        return null;
	      }
	
	      if (response.moveMaisId !== undefined) {
	        return response.moveMaisId;
	      }
	
	      if (response.user && response.user.moveMaisId !== undefined) {
	        return response.user.moveMaisId;
	      }
	      return null;
	    },
	    validateTaxIdNumber: function validateTaxIdNumber(taxIdNumber) {
	      if (!taxIdNumber || typeof taxIdNumber !== "string") {
	        return false;
	      }
	      var cleaned = taxIdNumber.replace(/[.\-\/]/g, "").toUpperCase();
	      return cleaned.length === 11 || cleaned.length === 14;
	    },
	    sanitizeInput: function sanitizeInput(input) {
	      if (typeof input !== "string") {
	        return "";
	      }
	      return input.trim().replace(/[<>]/g, "");
	    },
	    doRequest: function doRequest() {
	      var _this = this;
	
	      if (this.isProcessing) {
	        return;
	      }
	
	      if (!this.taxIdNumber || this.taxIdNumber === "") {
	        this.formState = "ERROR";
	        this.errorMessage = "CPF/CNPJ Não informado";
	        this.initProcess = false;
	        return;
	      }
	
	      var sanitizedTaxId = this.sanitizeInput(this.taxIdNumber);
	      var cpfSemMascara = sanitizedTaxId.replace(/[.\-\/]/g, "").toUpperCase();
	
	      if (!this.validateTaxIdNumber(sanitizedTaxId)) {
	        this.formState = "ERROR";
	        this.errorMessage = "CPF/CNPJ inválido";
	        this.initProcess = false;
	        return;
	      }
	
	      if (cpfSemMascara.length < 11 || cpfSemMascara.length > 14) {
	        this.formState = "ERROR";
	        this.errorMessage = "CPF/CNPJ deve ter 11 ou 14 dígitos";
	        this.initProcess = false;
	        return;
	      }
	
	      this.$validator.validateAll().then(function (success) {
	        if (success) {
	          _this.fetchUserDataAndSendCode();
	        } else {
	          _this.initProcess = false;
	        }
	      });
	    },
	    fetchUserDataAndSendCode: function fetchUserDataAndSendCode() {
	      var _this2 = this;
	
	      if (this.isProcessing) {
	        return;
	      }
	
	      this.isProcessing = true;
	      var cpfSemMascara = this.taxIdNumber.replace(/[.\-\/]/g, "").toUpperCase();
	
	      if (!cpfSemMascara || cpfSemMascara.length < 11) {
	        this.formState = "ERROR";
	        this.errorMessage = "CPF/CNPJ inválido";
	        this.initProcess = false;
	        this.isProcessing = false;
	        return;
	      }
	
	      var timeoutPromise = new _promise2.default(function (_, reject) {
	        setTimeout(function () {
	          reject(new Error("Tempo de requisição excedido. Verifique sua conexão."));
	        }, _this2.requestTimeout);
	      });
	
	      _promise2.default.race([_authHelper2.default.getUserAndAddressByTaxIdNumberNoSession(cpfSemMascara), timeoutPromise]).then(function (response) {
	        if (!response || (typeof response === "undefined" ? "undefined" : (0, _typeof3.default)(response)) !== "object") {
	          throw new Error("Resposta inválida do servidor");
	        }
	
	        var moveMaisId = null;
	        if (response.moveMaisId !== undefined) {
	          moveMaisId = response.moveMaisId;
	
	          _this2.userResponse = (0, _extends3.default)({}, response, {
	            user: (0, _extends3.default)({
	              moveMaisId: response.moveMaisId,
	              taxIdNumber: response.taxIdNumber,
	              flag2FA: response.user && response.user.flag2FA || "N" }, response.user || {})
	          });
	        } else if (response.user && response.user.moveMaisId !== undefined) {
	          moveMaisId = response.user.moveMaisId;
	
	          if (!response.user.flag2FA) {
	            response.user.flag2FA = "N";
	          }
	          _this2.userResponse = response;
	        } else {
	          throw new Error("Dados do usuário não encontrados na resposta");
	        }
	
	        if (!moveMaisId || typeof moveMaisId !== "number" && typeof moveMaisId !== "string") {
	          _this2.formState = "ERROR";
	          _this2.errorMessage = "Erro ao processar dados do usuário.";
	          _this2.initProcess = false;
	          _this2.isProcessing = false;
	          return;
	        }
	
	        var moveMaisIdNum = Number(moveMaisId);
	        if (isNaN(moveMaisIdNum) || moveMaisIdNum <= 0) {
	          _this2.formState = "ERROR";
	          _this2.errorMessage = "ID do usuário inválido.";
	          _this2.initProcess = false;
	          _this2.isProcessing = false;
	          return;
	        }
	
	        _this2.pendingMoveMaisId = moveMaisIdNum;
	
	        _this2.savePasswordResetSession();
	
	        _this2.showValidationModal = true;
	        _this2.initProcess = false;
	        _this2.isProcessing = false;
	      }).catch(function (err) {
	        _this2.isProcessing = false;
	
	        if (err.message && err.message.indexOf("Tempo de requisição") !== -1) {
	          _this2.formState = "ERROR";
	          _this2.errorMessage = "Tempo de requisição excedido. Verifique sua conexão e tente novamente.";
	          _this2.initProcess = false;
	          return;
	        }
	
	        if (err.code === "ECONNABORTED" || err.message === "Network Error") {
	          _this2.formState = "ERROR";
	          _this2.errorMessage = "Erro de conexão. Verifique sua internet e tente novamente.";
	          _this2.initProcess = false;
	          return;
	        }
	
	        var errorCode = err.response && err.response.data && err.response.data.status && err.response.data.status.code;
	
	        if (errorCode === 9990) {
	          var remainingTime = _this2.getRemainingTimer();
	          _this2.initialTimerValue = remainingTime > 0 ? remainingTime : 0;
	
	          if (_this2.userResponse) {
	            var moveMaisId = _this2.getMoveMaisIdFromResponse(_this2.userResponse);
	            if (moveMaisId) {
	              var moveMaisIdNum = Number(moveMaisId);
	              if (!isNaN(moveMaisIdNum) && moveMaisIdNum > 0) {
	                _this2.pendingMoveMaisId = moveMaisIdNum;
	              }
	            }
	          }
	
	          _this2.showValidationModal = true;
	          _this2.initProcess = false;
	        } else {
	          _this2.formState = "ERROR";
	          _this2.errorMessage = err.response && err.response.data && err.response.data.status && err.response.data.status.message || "Erro ao enviar código. Tente novamente.";
	          _this2.initProcess = false;
	        }
	      });
	    },
	    saveTokenTimestamp: function saveTokenTimestamp() {
	      try {
	        var timestamp = Date.now();
	        if (isNaN(timestamp) || timestamp <= 0) {
	          return;
	        }
	        localStorage.setItem("passwordResetTokenTimestamp", timestamp.toString());
	      } catch (err) {
	        return;
	      }
	    },
	    savePasswordResetSession: function savePasswordResetSession() {
	      try {
	        var sessionData = {
	          taxIdNumber: this.taxIdNumber,
	          pendingMoveMaisId: this.pendingMoveMaisId,
	          selectedChannel: this.selectedChannel,
	          userResponse: this.userResponse
	        };
	        localStorage.setItem("passwordResetSession", (0, _stringify2.default)(sessionData));
	      } catch (err) {
	        console.error("Erro ao salvar sessão de reset de senha:", err);
	      }
	    },
	    getPasswordResetSession: function getPasswordResetSession() {
	      try {
	        var sessionData = localStorage.getItem("passwordResetSession");
	        if (!sessionData) {
	          return null;
	        }
	        return JSON.parse(sessionData);
	      } catch (err) {
	        console.error("Erro ao recuperar sessão de reset de senha:", err);
	        return null;
	      }
	    },
	    clearPasswordResetSession: function clearPasswordResetSession() {
	      try {
	        localStorage.removeItem("passwordResetSession");
	        localStorage.removeItem("passwordResetTokenTimestamp");
	      } catch (err) {
	        console.error("Erro ao limpar sessão de reset de senha:", err);
	      }
	    },
	    restorePasswordResetSession: function restorePasswordResetSession() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var sessionData, remainingTime;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                sessionData = _this3.getPasswordResetSession();
	
	                if (!(!sessionData || !sessionData.pendingMoveMaisId)) {
	                  _context.next = 4;
	                  break;
	                }
	
	                _this3.clearPasswordResetSession();
	                return _context.abrupt("return");
	
	              case 4:
	                _this3.taxIdNumber = sessionData.taxIdNumber || _this3.taxIdNumber;
	                _this3.pendingMoveMaisId = sessionData.pendingMoveMaisId;
	                _this3.selectedChannel = sessionData.selectedChannel;
	                _this3.userResponse = sessionData.userResponse;
	
	                remainingTime = _this3.getRemainingTimer();
	
	                if (!(remainingTime <= 0)) {
	                  _context.next = 12;
	                  break;
	                }
	
	                _this3.clearPasswordResetSession();
	                return _context.abrupt("return");
	
	              case 12:
	                _this3.initialTimerValue = remainingTime;
	                _this3.showValidationModal = true;
	
	                setTimeout(function () {
	                  if (_this3.$refs.modalValidate) {
	                    if (_this3.selectedChannel) {
	                      _this3.$refs.modalValidate.selectedChannel = _this3.selectedChannel;
	                    }
	
	                    _this3.$refs.modalValidate.proceedToCodeInput();
	                  }
	                }, 100);
	
	              case 15:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, _this3);
	      }))();
	    },
	    getRemainingTimer: function getRemainingTimer() {
	      try {
	        var savedTimestamp = localStorage.getItem("passwordResetTokenTimestamp");
	
	        if (!savedTimestamp) {
	          return 0;
	        }
	
	        var timestamp = parseInt(savedTimestamp, 10);
	        if (isNaN(timestamp) || timestamp <= 0) {
	          localStorage.removeItem("passwordResetTokenTimestamp");
	          return 0;
	        }
	
	        var now = Date.now();
	        if (isNaN(now) || now < timestamp) {
	          localStorage.removeItem("passwordResetTokenTimestamp");
	          return 0;
	        }
	
	        var elapsed = Math.floor((now - timestamp) / 1000);
	        if (elapsed < 0) {
	          return 0;
	        }
	
	        var remaining = 60 - elapsed;
	        return remaining > 0 ? remaining : 0;
	      } catch (err) {
	        localStorage.removeItem("passwordResetTokenTimestamp");
	        return 0;
	      }
	    },
	    validateCode: function validateCode(code) {
	      if (!code || typeof code !== "string") {
	        return false;
	      }
	      var cleaned = code.replace(/\D/g, "");
	      return cleaned.length === 6 && /^\d{6}$/.test(cleaned);
	    },
	    onCodeValidate: function onCodeValidate(code) {
	      var _this4 = this;
	
	      if (this.isProcessing) {
	        return;
	      }
	
	      if (!code || !this.validateCode(code)) {
	        if (this.$refs.modalValidate) {
	          this.$refs.modalValidate.setError("Código inválido. Digite 6 dígitos numéricos.");
	          this.$refs.modalValidate.setErrorState(true);
	        }
	        return;
	      }
	
	      var moveMaisId = this.getMoveMaisIdFromResponse(this.userResponse);
	      if (!moveMaisId) {
	        if (this.$refs.modalValidate) {
	          this.$refs.modalValidate.setError("Erro: dados do usuário não encontrados.");
	        }
	        return;
	      }
	      var moveMaisIdNum = Number(moveMaisId);
	
	      if (isNaN(moveMaisIdNum) || moveMaisIdNum <= 0) {
	        if (this.$refs.modalValidate) {
	          this.$refs.modalValidate.setError("Erro: ID do usuário inválido.");
	        }
	        return;
	      }
	
	      var sanitizedCode = String(code).replace(/\D/g, "").substring(0, 6);
	
	      this.isProcessing = true;
	
	      var timeoutPromise = new _promise2.default(function (_, reject) {
	        setTimeout(function () {
	          reject(new Error("Tempo de validação excedido. Tente novamente."));
	        }, _this4.requestTimeout);
	      });
	
	      _promise2.default.race([_auth2.default.validarTokenPorMoveMaisId(moveMaisIdNum, sanitizedCode), timeoutPromise]).then(function (response) {
	        _this4.isProcessing = false;
	
	        if (!response || (typeof response === "undefined" ? "undefined" : (0, _typeof3.default)(response)) !== "object") {
	          throw new Error("Resposta inválida do servidor");
	        }
	
	        var statusCode = response && response.status && response.status.code;
	
	        if (statusCode === 0 || statusCode === undefined || statusCode === null) {
	          _this4.processPasswordResetSuccess(moveMaisIdNum);
	        } else {
	          if (_this4.$refs.modalValidate) {
	            var errorMsg = response.status && response.status.message ? String(response.status.message).substring(0, 200) : "Código inválido. Tente novamente.";
	            _this4.$refs.modalValidate.setError(errorMsg);
	            _this4.$refs.modalValidate.setErrorState(true);
	          }
	        }
	      }).catch(function (err) {
	        _this4.isProcessing = false;
	
	        var errorMessage = "Código inválido. Tente novamente.";
	
	        if (err.message && err.message.indexOf("Tempo de validação") !== -1) {
	          errorMessage = "Tempo de validação excedido. Tente novamente.";
	        } else if (err.code === "ECONNABORTED" || err.message === "Network Error") {
	          errorMessage = "Erro de conexão. Verifique sua internet e tente novamente.";
	        } else if (err.response && err.response.data && err.response.data.status && err.response.data.status.message) {
	          errorMessage = String(err.response.data.status.message).substring(0, 200);
	        }
	
	        if (_this4.$refs.modalValidate) {
	          _this4.$refs.modalValidate.setError(errorMessage);
	          _this4.$refs.modalValidate.setErrorState(true);
	        }
	      });
	    },
	    processPasswordResetSuccess: function processPasswordResetSuccess(moveMaisId) {
	      var _this5 = this;
	
	      if (this.isProcessing) {
	        return;
	      }
	
	      this.isProcessing = true;
	      this.showValidationModal = false;
	
	      try {
	        this.clearPasswordResetSession();
	      } catch (err) {}
	
	      var cpfSemMascara = this.taxIdNumber.replace(/[.\-\/]/g, "").toUpperCase();
	
	      if (!cpfSemMascara || cpfSemMascara.length < 11) {
	        this.formState = "ERROR";
	        this.errorMessage = "CPF/CNPJ inválido";
	        this.initProcess = false;
	        this.isProcessing = false;
	        return;
	      }
	
	      if (!moveMaisId || isNaN(Number(moveMaisId)) || Number(moveMaisId) <= 0) {
	        this.formState = "ERROR";
	        this.errorMessage = "ID do usuário inválido";
	        this.initProcess = false;
	        this.isProcessing = false;
	        return;
	      }
	
	      if (this.userResponse && this.userResponse.user && this.userResponse.user.flag2FA === "Y") {
	        var hash = window.location.hash;
	        _auth2.default.saveHash(hash);
	        this.formState = "NEW";
	        this.errorMessage = undefined;
	        this.$validator.validateAll().then(function (success) {
	          var taxId = _this5.taxIdNumber.replace(/[.\-\/]/g, "").toUpperCase();
	          _auth2.default.saveTaxIdNumber(taxId);
	          return _auth2.default.validUserResetPassword(taxId).then(function (res) {
	            _auth2.default.saveMoveMaisId(res.moveMaisId);
	            _this5.$router.push({
	              name: "2fa-login",
	              params: { type: "RESET_PASSWORD" }
	            });
	          }).catch(function (err) {
	            console.error(err);
	            _this5.errorMessage = err.data && err.data.status ? err.data.status.message : "Erro ao processar.";
	            _this5.isProcessing = false;
	          });
	        });
	        return;
	      }
	
	      var timeoutPromise = new _promise2.default(function (_, reject) {
	        setTimeout(function () {
	          reject(new Error("Tempo de requisição excedido"));
	        }, _this5.requestTimeout);
	      });
	
	      _promise2.default.race([_auth2.default.newRequestPasswordReset(cpfSemMascara, Number(moveMaisId)), timeoutPromise]).then(function () {
	        _this5.isProcessing = false;
	        _this5.formState = "SUCCESS";
	        _this5.errorMessage = undefined;
	        _this5.initProcess = false;
	      }).catch(function (err) {
	        _this5.isProcessing = false;
	        _this5.formState = "ERROR";
	
	        if (err.message && err.message.indexOf("Tempo de requisição") !== -1) {
	          _this5.errorMessage = "Tempo de requisição excedido. Tente novamente.";
	        } else if (err.code === "ECONNABORTED" || err.message === "Network Error") {
	          _this5.errorMessage = "Erro de conexão. Verifique sua internet e tente novamente.";
	        } else {
	          _this5.errorMessage = err.response && err.response.data && err.response.data.status && err.response.data.status.message || "Erro ao processar. Tente novamente.";
	        }
	        _this5.initProcess = false;
	      });
	    },
	    onResendCode: function onResendCode() {
	      if (this.isProcessing) {
	        return;
	      }
	
	      this.selectedChannel = null;
	
	      try {
	        localStorage.removeItem("passwordResetTokenTimestamp");
	      } catch (err) {}
	
	      this.savePasswordResetSession();
	
	      if (this.$refs.modalValidate) {
	        this.$refs.modalValidate.resetToChannelSelection();
	      }
	    },
	    onChannelSelected: function onChannelSelected(channel) {
	      var _this6 = this;
	
	      if (this.isProcessing) {
	        return;
	      }
	
	      if (!this.pendingMoveMaisId) {
	        if (this.$refs.modalValidate) {
	          this.$refs.modalValidate.resetToChannelSelection();
	          this.$refs.modalValidate.channelErrorMessage = "Erro: dados do usuário não encontrados.";
	        }
	        return;
	      }
	
	      this.selectedChannel = channel;
	
	      this.savePasswordResetSession();
	
	      this.isProcessing = true;
	
	      var timeoutPromise = new _promise2.default(function (_, reject) {
	        setTimeout(function () {
	          reject(new Error("Tempo de requisição excedido"));
	        }, _this6.requestTimeout);
	      });
	
	      _promise2.default.race([_auth2.default.generateTokenSite(this.pendingMoveMaisId, channel), timeoutPromise]).then(function (tokenResponse) {
	        _this6.isProcessing = false;
	
	        if (!tokenResponse || (typeof tokenResponse === "undefined" ? "undefined" : (0, _typeof3.default)(tokenResponse)) !== "object") {
	          throw new Error("Resposta inválida ao gerar token");
	        }
	
	        var statusCode = tokenResponse && tokenResponse.status && tokenResponse.status.code;
	
	        if (statusCode === 9990) {
	          var remainingTime = _this6.getRemainingTimer();
	          _this6.initialTimerValue = remainingTime > 0 ? remainingTime : 0;
	
	          if (_this6.$refs.modalValidate) {
	            _this6.$refs.modalValidate.proceedToCodeInput();
	          }
	        } else if (statusCode === 0 || statusCode === undefined || statusCode === null) {
	          _this6.saveTokenTimestamp();
	          _this6.initialTimerValue = 60;
	
	          if (_this6.$refs.modalValidate) {
	            _this6.$refs.modalValidate.proceedToCodeInput();
	          }
	        } else {
	          throw new Error(tokenResponse.status && tokenResponse.status.message ? tokenResponse.status.message : "Erro ao gerar token");
	        }
	      }).catch(function (err) {
	        _this6.isProcessing = false;
	
	        var errorCode = err.response && err.response.data && err.response.data.status && err.response.data.status.code;
	
	        if (errorCode === 9990) {
	          var remainingTime = _this6.getRemainingTimer();
	          _this6.initialTimerValue = remainingTime > 0 ? remainingTime : 0;
	
	          if (_this6.$refs.modalValidate) {
	            _this6.$refs.modalValidate.proceedToCodeInput();
	          }
	        } else {
	          var errorMessage = "Erro ao enviar código. Tente novamente.";
	
	          if (err.message && err.message.indexOf("Tempo de requisição") !== -1) {
	            errorMessage = "Tempo de requisição excedido. Tente novamente.";
	          } else if (err.code === "ECONNABORTED" || err.message === "Network Error") {
	            errorMessage = "Erro de conexão. Verifique sua internet e tente novamente.";
	          } else if (err.response && err.response.data && err.response.data.status && err.response.data.status.message) {
	            errorMessage = err.response.data.status.message;
	          }
	
	          if (_this6.$refs.modalValidate) {
	            _this6.$refs.modalValidate.resetToChannelSelection();
	            _this6.$refs.modalValidate.channelErrorMessage = errorMessage;
	          }
	        }
	      });
	    },
	    closeValidationModal: function closeValidationModal() {
	      this.showValidationModal = false;
	      this.initProcess = false;
	    }
	  }
	};

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(48);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _locale = __webpack_require__(332);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    var _ref;
	
	    return _ref = {
	      password: undefined,
	      passwordRepeat: undefined,
	      errorMessage: undefined,
	      loading: false
	    }, (0, _defineProperty3.default)(_ref, 'password', null), (0, _defineProperty3.default)(_ref, 'passwordLength', 0), (0, _defineProperty3.default)(_ref, 'containsEightCharacters', false), (0, _defineProperty3.default)(_ref, 'containsNumber', false), (0, _defineProperty3.default)(_ref, 'containsUppercase', false), (0, _defineProperty3.default)(_ref, 'containsSpecialCharacter', false), (0, _defineProperty3.default)(_ref, 'validPassword', false), (0, _defineProperty3.default)(_ref, 'token', undefined), (0, _defineProperty3.default)(_ref, 'moveMaisId', undefined), (0, _defineProperty3.default)(_ref, 'validPasswordRepeat', false), (0, _defineProperty3.default)(_ref, 'passwordRepeatLength', 0), (0, _defineProperty3.default)(_ref, 'is2FA', false), (0, _defineProperty3.default)(_ref, 'taxId', ""), _ref;
	  },
	
	
	  computed: {
	    type: function type() {
	      console.log(this.$route.params.type, "this.$route.params.type");
	      return this.$route.params.type;
	    }
	  },
	
	  mounted: function mounted() {},
	
	  methods: {
	    doReset: function doReset() {
	      var _this = this;
	
	      if (this.is2FA == true) {
	        this.formState = 'NEW';
	        console.log("movemaisId: ", _auth2.default.getMoveMaisId());
	        this.$validator.validateAll().then(function (success) {
	          _this.loading = _auth2.default.resetPassword(_this.password, _auth2.default.getMoveMaisId()).then(function (data) {
	            if (data) return _messageDialog2.default.show({
	              headerClass: 'modal-success',
	              title: 'Definição de senha',
	              message: 'Sua senha foi definida com sucesso!',
	              type: 'OK'
	            }).then(function () {
	              _this.$router.push({ name: "login" });
	            });
	          }).catch(function (err) {
	            console.error(err);
	            if (err.data.status.code == 9990) _this.errorMessage = "Prazo para redefinição de senha encerrado!";else _this.errorMessage = err.data && err.data.status && err.data.status.message || "Ocorreu um problema, tente novamente";
	          });
	        });
	      } else {
	
	        this.formState = 'NEW';
	        this.$validator.validateAll().then(function (success) {
	          var token = _this.$route.query.token;
	
	          console.log(_this.password, token, "Dados para redefinição de senha");
	          _this.loading = _auth2.default.validToken(_this.password, token).then(function (data) {
	            console.log(data, "data valid token");
	            if (data) {
	              return _messageDialog2.default.show({
	                headerClass: 'modal-success',
	                title: 'Definição de senha',
	                message: 'Sua senha foi definida com sucesso!',
	                type: 'OK'
	              }).then(function () {
	                _this.$router.push({ name: "login" });
	              });
	            }
	          }).catch(function (err) {
	            console.error(err);
	            if (err.data.status.code == 9990) _this.errorMessage = "Prazo para redefinição de senha encerrado !";else _this.errorMessage = err.data && err.data.status && err.data.status.message || "Ocorreu um problema, tente novamente";
	          });
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(48);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _string = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    var _ref;
	
	    return _ref = {
	      password: undefined,
	      oldPassword: undefined,
	      passwordRepeat: undefined,
	      errorMessage: undefined,
	      loading: undefined
	
	    }, (0, _defineProperty3.default)(_ref, 'password', null), (0, _defineProperty3.default)(_ref, 'passwordLength', 0), (0, _defineProperty3.default)(_ref, 'containsEightCharacters', false), (0, _defineProperty3.default)(_ref, 'containsNumber', false), (0, _defineProperty3.default)(_ref, 'containsUppercase', false), (0, _defineProperty3.default)(_ref, 'containsSpecialCharacter', false), (0, _defineProperty3.default)(_ref, 'validPassword', false), (0, _defineProperty3.default)(_ref, 'email', undefined), (0, _defineProperty3.default)(_ref, 'newEmail', undefined), (0, _defineProperty3.default)(_ref, 'newPhone', undefined), (0, _defineProperty3.default)(_ref, 'dddCellphone', undefined), (0, _defineProperty3.default)(_ref, 'nroCellphone', undefined), (0, _defineProperty3.default)(_ref, 'oldDddCellphone', undefined), (0, _defineProperty3.default)(_ref, 'oldNroCellphone', undefined), _ref;
	  },
	
	
	  computed: {
	    type: function type() {
	      return this.$route.params.type;
	    },
	
	    newCellPhone: {
	      get: function get() {
	        return this.getCelFormated();
	      },
	      set: function set(newValue) {
	        this.setCelFormated(newValue);
	      }
	    },
	    oldCellPhone: {
	      get: function get() {
	        return this.getOldCelFormated();
	      },
	      set: function set(newValue) {
	        this.setOldCelFormated(newValue);
	      }
	    }
	
	  },
	
	  created: function created() {},
	
	
	  methods: {
	    getCelFormated: function getCelFormated(obj) {
	      return (0, _string.phone)(this.dddCellphone + this.nroCellphone);
	    },
	    setCelFormated: function setCelFormated(value) {
	      var t = value.replace(/[^0-9]/g, '');
	      this.dddCellphone = t.substring(0, 2);
	      this.nroCellphone = t.substring(2, 11);
	    },
	    getOldCelFormated: function getOldCelFormated(obj) {
	      return (0, _string.phone)(this.oldDddCellphone + this.oldNroCellphone);
	    },
	    setOldCelFormated: function setOldCelFormated(value) {
	      var t = value.replace(/[^0-9]/g, '');
	      this.oldDddCellphone = t.substring(0, 2);
	      this.oldNroCellphone = t.substring(2, 11);
	    },
	    doChange: function doChange() {
	      var _this = this;
	
	      origin = this.$route.params.type;
	      this.$validator.validateAll().then(function (success) {
	        if (origin == 'UPDATE_PASSWORD') {
	          _this.loading = _auth2.default.changePassword(_this.oldPassword, _this.password).then(function (value) {
	            if (value) return _messageDialog2.default.show({
	              headerClass: 'modal-success',
	              title: 'Definição de senha',
	              message: 'Sua senha foi alterada com sucesso!',
	              type: 'OK'
	            }).then(function () {
	              _this.$router.push({ name: 'plans' });
	            });
	          });
	        } else {
	          if (origin == 'UPDATE_USER_EMAIL') {
	            _auth2.default.saveNewEmail(_this.newEmail);
	            _this.errorMessage = undefined;
	            _this.loading = _auth2.default.sendTokenNewUserData(_auth2.default.getTaxIdNumber().replace(/[.\-\/]/g, '').toUpperCase(), '', _this.newEmail).then(function (value) {
	              _this.$router.push({ name: '2fa-interno', params: { type: 'UPDATE_NEW_USER_EMAIL' } });
	            }).catch(function (err) {
	              _this.errorMessage = err.status && err.data.status && err.data.status.message;
	            });
	          } else {
	            if (origin == 'UPDATE_USER_PHONE') {
	              _auth2.default.saveNewPhone(_this.newCellPhone.replace(/[^\d]+/g, ''));
	              _this.loading = _auth2.default.sendTokenNewUserData(_auth2.default.getTaxIdNumber().replace(/[.\-\/]/g, '').toUpperCase(), _this.newCellPhone.replace(/[^\d]+/g, ''), '').then(function (value) {
	                _this.$router.push({ name: '2fa-interno', params: { type: 'UPDATE_NEW_USER_PHONE' } });
	              }).catch(function (err) {
	                _this.errorMessage = err.status && err.data.status && err.data.status.message;
	              });
	            }
	          }
	        }
	      }).catch(function (error) {
	        _this.errorMessage = error.data && error.data.status && error.data.status.message || "Erro do servidor.";
	      });
	    },
	    checkPassword: function checkPassword() {
	      this.passwordLength = this.password.length;
	      var format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
	
	      if (this.passwordLength > 8) {
	        this.containsEightCharacters = true;
	      } else {
	        this.containsEightCharacters = false;
	      }
	
	      this.containsNumber = /\d/.test(this.password);
	      this.containsUppercase = /[A-Z]/.test(this.password);
	      this.containsSpecialCharacter = format.test(this.password);
	
	      if (this.containsEightCharacters === true && this.containsSpecialCharacter === true && this.containsUppercase === true && this.containsNumber === true) {
	        this.validPassword = true;
	      } else {
	        this.validPassword = false;
	      }
	    }
	  }
	};

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(49);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _eventBus = __webpack_require__(25);
	
	var _param = __webpack_require__(68);
	
	var _param2 = _interopRequireDefault(_param);
	
	var _number = __webpack_require__(24);
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _vuex = __webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["contract", "newSalesType"],
	  data: function data() {
	    return {
	      loading: undefined,
	      taxRecharge: undefined,
	      rechargeValue: 0,
	      recharge: 1,
	
	      taxRechargeMan: undefined,
	      rechargeValueMan: 0,
	      rechargeMan: 1,
	
	      taxRechargeAut: undefined,
	      rechargeValueAut: 0,
	      rechargeAut: 1,
	
	      taxIdNumber: undefined,
	      detalhePlano: undefined,
	      recVp: undefined,
	      couponValue: '',
	      couponError: ''
	    };
	  },
	  created: function created() {
	    this.mostrarAlerta(this.planId);
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.contract.plan.planId = this.$route.query.planId;
	    if (this.contract.rechargeValue) {
	      this.recharge = this.rechargeMan = this.rechargeAut = this.contract.rechargeValue / this.multiple;
	    } else {
	      this.contract.rechargeValue = this.multiple;
	      this.recharge = 1;
	    }
	
	    if (this.planHasRecharge(this.planId) && !this.promoId) {
	      var promise = _sales2.default.calculateRechargeRate({
	        value: this.recharge * this.multiple,
	        planId: this.contract.plan.planId || 21,
	        contractId: 0
	      }).then(function (response) {
	        _this.taxRecharge = response.taxTotal;
	        _this.rechargeValue = response.valueTotal;
	
	        _this.taxRechargeAut = response.taxTotal;
	        _this.rechargeValueAut = response.valueTotal;
	
	        _this.taxRechargeMan = response.taxTotal;
	        _this.rechargeValueMan = response.valueTotal;
	
	        _this.contract.taxRecharge = _this.taxRecharge;
	      });
	      this.$store.dispatch("loading", promise);
	    } else {
	      this.firstValueRecharge(1);
	    }
	
	    this.contract.lcFlag = false;
	
	    var chave;
	
	    if (this.contract.plan.planId == 21) {
	      this.chave = "LIMITE_CREDITO_PF";
	    } else {
	      if (this.contract.plan.planId == 31) {
	        this.chave = "LIMITE_CREDITO_PJ";
	      }
	    }
	
	    _param2.default.getGeneralParameter({
	      key: this.chave
	    }).then(function (res) {
	      _this.contract.limitCredit = res.value.replace(/[^0-9]/g, "");
	    });
	  },
	
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(["getPromotionCurrent"]), {
	    sameTax: function sameTax() {
	      return this.newAdhesionTax == this.newVehicleTax;
	    },
	    planId: function planId() {
	      return this.$route.query.planId || this.contract.plan.planId;
	    },
	    CO: function CO() {
	      return _constantes2.default;
	    },
	    isCaminhoParana: function isCaminhoParana() {
	      return !!this.$parent.lead;
	    },
	    multiple: function multiple() {
	      return this.getMultipleRecharge(this.planId);
	    },
	    plan: function plan() {
	      return this.$store.getters.getPlanById(this.planId);
	    },
	    newAdhesionTax: function newAdhesionTax() {
	      return this.$store.getters.getNewAdhesionTax(this.planId);
	    },
	    newVehicleTax: function newVehicleTax() {
	      return this.$store.getters.getNewVehicleTax(this.planId);
	    },
	    guaranteeTax: function guaranteeTax() {
	      return this.$store.getters.getGuaranteeTax(this.planId);
	    },
	    linkRntrcTax: function linkRntrcTax() {
	      return this.$store.getters.getLinkRntrcTax(this.planId);
	    },
	    bankAccountOptions: function bankAccountOptions() {
	      return this.$store.getters.getBankAccountOptions(this.planId);
	    },
	    creditCardOptions: function creditCardOptions() {
	      return this.$store.getters.getCreditCardOptions(this.planId);
	    },
	    bankBillOption: function bankBillOption() {
	      return this.$store.getters.getBankBillOption(this.planId);
	    },
	    qtdGratis: function qtdGratis() {
	      return Math.floor(this.rechargeValue / 20000);
	    },
	    checkPromoSenff: function checkPromoSenff() {
	      if (sessionStorage.getItem("promoCheck") == "#FR01") return true;
	    },
	    promoId: function promoId() {
	      return this.$route.query.promoId;
	    },
	
	    coupon: {
	      get: function get() {
	        return this.couponValue;
	      },
	      set: function set(value) {
	        this.couponError = '';
	        this.couponValue = value ? value.replace(/[^a-zA-Z0-9]/g, '') : '';
	      }
	    }
	  }),
	
	  methods: {
	    firstValueRecharge: function firstValueRecharge(unit) {
	      var _this2 = this;
	
	      if (unit < 1) return;
	
	      var req = {
	        planId: this.planId,
	        promoId: this.promoId
	      };
	
	      this.loading = _sales2.default.firstValueRecharge(req).then(function (response) {
	        var multiple = response.firstTaxe.rechargeValue;
	        _this2.loading = _sales2.default.calculateRechargeRate({
	          value: unit * multiple,
	          planId: _this2.contract.plan.planId || 21,
	          contractId: 0
	        }).then(function (response) {
	          _this2.recharge = unit;
	          _this2.taxRecharge = response.taxTotal;
	          _this2.rechargeValue = response.valueTotal;
	
	          if (_this2.planId == 22) {
	            _this2.rechargeValueAut = 5000;
	            _this2.rechargeValueMan = 5000;
	            _this2.taxRechargeAut = 750;
	            _this2.taxRechargeMan = 750;
	          }
	          if (_this2.planId == 32) {
	            _this2.rechargeValueAut = 25000;
	            _this2.rechargeValueMan = 25000;
	            _this2.taxRechargeAut = 2500;
	            _this2.taxRechargeMan = 2500;
	          }
	
	          _this2.contract.taxRecharge = _this2.taxRecharge;
	          _this2.contract.rechargeValue = _this2.rechargeValue;
	        });
	      }).catch(function (err) {
	        return false;
	      });
	    },
	    mostrarAlerta: function mostrarAlerta(newVal) {
	      var _this3 = this;
	
	      try {
	        _contracts2.default.getDetailPlanVp(newVal).then(function (resp) {
	          console.log(resp, "Detalhe do plano 2");
	          _this3.recVp = resp.plan.recVp;
	          console.log(_this3.recVp, "recVp");
	        });
	      } catch (error) {
	        console.error('Erro na requisição: ', error);
	        alert('Erro na requisição: ' + error.message);
	      }
	    },
	    calculate: function calculate(unit) {
	      var _this4 = this;
	
	      if (unit < 1) return;
	
	      var promise = _sales2.default.calculateRechargeRate({
	        value: unit * this.multiple,
	        planId: this.planId || 21,
	        contractId: 0
	      }).then(function (r) {
	        _this4.recharge = unit;
	        _this4.taxRecharge = r.taxTotal;
	        _this4.contract.taxRecharge = _this4.taxRecharge;
	        _this4.contract.rechargeValue = _this4.rechargeValue = r.valueTotal;
	      });
	
	      this.$store.dispatch("loading", promise);
	    },
	    calculateManParanaWay: function calculateManParanaWay(unit) {
	      var _this5 = this;
	
	      if (unit < 1) return;
	
	      var promise = _sales2.default.calculateRechargeRate({
	        value: unit * this.multiple,
	        planId: this.$parent.lead.typeTaxId == "COMPANY" ? 37 : 35,
	        contractId: 0
	      }).then(function (r) {
	        _this5.rechargeMan = unit;
	        _this5.taxRechargeMan = r.taxTotal;
	        _this5.contract.rechargeValue = _this5.rechargeValueMan = r.valueTotal;
	      });
	
	      this.$store.dispatch("loading", promise);
	    },
	    calculateAutParanaWay: function calculateAutParanaWay(unit) {
	      var _this6 = this;
	
	      if (unit < 1) return;
	
	      var promise = _sales2.default.calculateRechargeRate({
	        value: unit * this.multiple,
	        planId: this.$parent.lead.typeTaxId == "COMPANY" ? 38 : 36,
	        contractId: 0
	      }).then(function (r) {
	        _this6.rechargeAut = unit;
	        _this6.taxRechargeAut = r.taxTotal;
	        _this6.contract.rechargeValue = _this6.rechargeValueAut = r.valueTotal;
	      });
	
	      this.$store.dispatch("loading", promise);
	    },
	    nextParana: function nextParana(plan) {
	      this.taxRecharge = plan == "man" ? this.taxRechargeMan : this.taxRechargeAut;
	      this.rechargeValue = plan == "man" ? this.rechargeValueMan : this.rechargeValueAut;
	      this.contract.rechargeValue = this.rechargeValue;
	
	      this.$parent.nextParana(plan);
	    },
	    validateAll: function validateAll() {
	      var _this7 = this;
	
	      this.contract.tax = this.taxRecharge;
	      var vm = this;
	      var promise = this.$validator.validateAll().then(function (r) {
	        if (_this7.planId == 2) {
	          var taxId = _this7.taxIdNumber.replace(/[.\-\/]/g, "").toUpperCase();
	          if (taxId.length == 14) {
	            _this7.contract.plan.planId = 3;
	            _this7.$router.replace({
	              name: "adhesion",
	              query: { planId: 3, taxIdNumber: taxId }
	            });
	          } else {
	            _this7.$router.replace({
	              name: "adhesion",
	              query: { planId: 2, taxIdNumber: taxId }
	            });
	          }
	        }
	      }).then(function () {
	        var coupon = vm.getCoupon();
	        if (coupon) {
	          return _sales2.default.validateCoupon(coupon).then(function (res) {
	            if (!res.valid) {
	              vm.couponError = 'Cupom inválido';
	              return _promise2.default.reject('Cupom inválido');
	            }
	          }).catch(function (err) {
	            vm.couponError = 'Cupom inválido';
	            return _promise2.default.reject('Cupom inválido');
	          });
	        }
	      });
	
	      return promise;
	    },
	    getCoupon: function getCoupon() {
	      return this.couponValue || null;
	    },
	    cleanErrors: function cleanErrors() {
	      _eventBus.EventBus.$emit("cleanErrors");
	    },
	
	
	    limiteFormatado: function limiteFormatado() {
	      return (0, _number.cents)(this.contract.limitCredit);
	    }
	  }
	};

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _number = __webpack_require__(24);
	
	var _recargaMinima = __webpack_require__(98);
	
	var _recargaMinima2 = _interopRequireDefault(_recargaMinima);
	
	var _isMultiple = __webpack_require__(242);
	
	var _isMultiple2 = _interopRequireDefault(_isMultiple);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _eventBus = __webpack_require__(25);
	
	var _param = __webpack_require__(68);
	
	var _param2 = _interopRequireDefault(_param);
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['contract', 'planId'],
	  data: function data() {
	    return {
	      loading: undefined,
	      taxRecharge: undefined,
	      rechargeValue: 0,
	      recharge: 1,
	
	      qtdFix: 4,
	      rechargesData: [],
	      value: undefined,
	      tax: '-',
	      source: undefined,
	
	      changeFlagEmail: "0",
	      selectedValue: undefined,
	      recVp: "",
	      couponValue: '',
	      couponError: ''
	    };
	  },
	  created: function created() {
	    this.source = _axios2.default.CancelToken.source();
	    if (this.contract.rechargeValue) {
	      this.value = this.rechargeValue = this.contract.rechargeValue;
	      if (this.value > this.minValue) {
	        this.value = -1;
	        this.calculateRecharge();
	      }
	    }
	    this.contract.plan.planId = this.$route.query.planId;
	    this.mostrarAlerta(this.contract.plan.planId);
	  },
	
	
	  watch: {
	    changeFlagEmail: function changeFlagEmail(newValue) {
	      this.contract.changeFlagEmail = newValue;
	    },
	    value: function value() {
	      this.contract.taxRecharge = this.tax;
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.value = "";
	    this.rechargesData = this.getFixesRecharges(this.planId, this.minValue, false);
	
	    if (!this.value) {
	      this.contract.rechargeValue = this.value = this.rechargesData[0].value;
	      this.contract.taxRecharge = this.tax;
	    }
	
	    if (this.value > -1 && this.value <= this.minValue) {
	
	      var a = this.rechargesData.find(function (o) {
	        if (!o) return false;
	        return o.value == _this.contract.rechargeValue;
	      });
	
	      this.changeRecharge(a);
	    }
	
	    this.contract.lcFlag = false;
	
	    var chave;
	
	    if (this.contract.plan.planId == 21) {
	      this.chave = "LIMITE_CREDITO_PF";
	    } else {
	      if (this.contract.plan.planId == 31) {
	        this.chave = "LIMITE_CREDITO_PJ";
	      }
	    }
	
	    _param2.default.getGeneralParameter({
	      key: this.chave
	    }).then(function (res) {
	      _this.contract.limitCredit = res.value.replace(/[^0-9]/g, '');
	    });
	  },
	
	
	  computed: {
	    sameTax: function sameTax() {
	      return this.newAdhesionTax == this.newVehicleTax;
	    },
	    planId: function planId() {
	      return this.$route.query.planId;
	    },
	    CO: function CO() {
	
	      return _constantes2.default;
	    },
	    isCaminhoParana: function isCaminhoParana() {
	      return !!this.$parent.lead;
	    },
	
	    valueFormatted: function valueFormatted() {
	      this.$nextTick(function () {
	        $('#valueTotal').val($('#valueTotal').val());
	      });
	      return (0, _number.cents)(this.rechargeValue).replace('R$', '');
	    },
	    minValue: function minValue() {
	      return this.getMinOpenValue(this.planId);
	    },
	    plan: function plan() {
	      return this.$store.getters.getPlanById(this.planId);
	    },
	    newAdhesionTax: function newAdhesionTax() {
	      return this.$store.getters.getNewAdhesionTax(this.planId);
	    },
	    newVehicleTax: function newVehicleTax() {
	      return this.$store.getters.getNewVehicleTax(this.planId);
	    },
	    guaranteeTax: function guaranteeTax() {
	      return this.$store.getters.getGuaranteeTax(this.planId);
	    },
	    monthlyTax: function monthlyTax() {
	      return this.$store.getters.getMonthlyTax(this.planId);
	    },
	    bankAccountOptions: function bankAccountOptions() {
	      return this.$store.getters.getBankAccountOptions(this.planId);
	    },
	    creditCardOptions: function creditCardOptions() {
	      return this.$store.getters.getCreditCardOptions(this.planId);
	    },
	    bankBillOption: function bankBillOption() {
	      return this.$store.getters.getBankBillOption(this.planId);
	    },
	    qtdGratis: function qtdGratis() {
	      return Math.floor((this.value == -1 ? this.rechargeValue : this.value) / 50000);
	    },
	    promoId: function promoId() {
	      return this.$route.query.promoId;
	    },
	
	    coupon: {
	      get: function get() {
	        return this.couponValue;
	      },
	      set: function set(value) {
	        this.couponError = '';
	        this.couponValue = value ? value.replace(/[^a-zA-Z0-9]/g, '') : '';
	      }
	    }
	
	  },
	
	  methods: {
	    calculate: function calculate(value) {
	      var _this2 = this;
	
	      if (value < 1) return;
	      var resp = [];
	      var promise = _sales2.default.calculateRechargeRate({
	        value: value,
	        planId: this.planId,
	        contractId: 0
	      }).then(function (r) {
	        _this2.tax = r.tax;
	        _this2.contract.rechargeValue = r.value;
	      });
	      this.$store.dispatch("loading", promise);
	      return resp[0];
	    },
	    changeRecharge: function changeRecharge(item) {
	
	      this.$emit('valorSelecionado', item);
	      if (!item) return;
	      this.calculate(item.value);
	
	      if (item.value == -1) {
	        this.rechargeValue = 0;
	      }
	      _eventBus.EventBus.$emit('cleanErrors');
	    },
	
	    calculateRecharge: function calculateRecharge() {
	      var _this3 = this;
	
	      if (!_recargaMinima2.default.validate(this.rechargeValue, [this.minValue]) || !_isMultiple2.default.validate(this.rechargeValue, 5000)) {
	        this.tax = "-";
	        return false;
	      }
	
	      this.source.cancel('cancelada');
	      this.source = _axios2.default.CancelToken.source();
	      this.waiting = true;
	      this.loading = _sales2.default.calculateRechargeRate({ cancelToken: this.source.token, value: this.rechargeValue, planId: this.planId, contractId: 0 }).then(function (resp) {
	        _this3.tax = resp.taxTotal;
	        _this3.contract.rechargeValue = resp.valueTotal;
	        _this3.waiting = false;
	        _eventBus.EventBus.$emit('cleanErrors');
	      }).catch(function (err) {
	        _this3.waiting = false;
	        _this3.tax = '-';
	      });
	    },
	    setTotal: function setTotal(newValue) {
	      this.rechargeValue = newValue.replace(/[^0-9]/g, '');
	      this.calculateRecharge();
	    },
	
	    validateAll: function validateAll() {
	      this.contract.tax = this.tax;
	      var vm = this;
	      return this.$validator.validateAll().then(function () {
	        var coupon = vm.getCoupon();
	        if (coupon) {
	          return _sales2.default.validateCoupon(coupon).then(function (res) {
	            if (!res.valid) {
	              vm.couponError = 'Cupom inválido';
	              return _promise2.default.reject('Cupom inválido');
	            }
	          }).catch(function (err) {
	            vm.couponError = 'Cupom inválido';
	            return _promise2.default.reject('Cupom inválido');
	          });
	        }
	      });
	    },
	    getCoupon: function getCoupon() {
	      return this.couponValue || null;
	    },
	    limiteFormatado: function limiteFormatado() {
	
	      return (0, _number.cents)(this.contract.limitCredit);
	    },
	    mostrarAlerta: function mostrarAlerta(newVal) {
	      var _this4 = this;
	
	      try {
	        _contracts2.default.getDetailPlanVp(newVal).then(function (resp) {
	          console.log(resp, "Detalhe do plano 2");
	          _this4.recVp = resp.plan.recVp;
	          console.log(_this4.recVp, "recVp");
	        });
	      } catch (error) {
	        console.error('Erro na requisição: ', error);
	        alert('Erro na requisição: ' + error.message);
	      }
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _address = __webpack_require__(84);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _string = __webpack_require__(35);
	
	var _date = __webpack_require__(38);
	
	var _objects = __webpack_require__(44);
	
	var obj = _interopRequireWildcard(_objects);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['account', 'address', 'blockTaxIdNumber'],
	  data: function data() {
	    return {
	      step: 0,
	      businessActivity: undefined,
	      optanteNacional: false
	    };
	  },
	  mounted: function mounted() {},
	
	
	  computed: {
	    tel1: {
	      get: function get() {
	        return this.getCelFormated();
	      },
	      set: function set(newValue) {
	        this.$nextTick(function () {
	          $('#telephone1').val($('#telephone1').val());
	        });
	        this.setCelFormated(newValue);
	      }
	    },
	    tel2: {
	      get: function get() {
	        return this.getTel1Formated();
	      },
	      set: function set(newValue) {
	        this.$nextTick(function () {
	          $('#telephone2').val($('#telephone2').val());
	        });
	        this.setTel1Formated(newValue);
	      }
	    },
	    tel3: {
	      get: function get() {
	        return this.getTel2Formated();
	      },
	      set: function set(newValue) {
	        this.setTel2Formated(newValue);
	      }
	    },
	    businessActivities: function businessActivities() {
	      return obj.businessActivity();
	    },
	    states: function states() {
	      return obj.states();
	    }
	  },
	
	  methods: {
	    correctCursor: function correctCursor(a) {
	      if (!window.document.mobile) return;
	
	      setTimeout(function () {
	        $(a.target).val($(a.target).val());
	      }, 80);
	    },
	    getTelType: function getTelType(type) {
	      var tels = _.filter(this.account.telephones.telephone, function (o) {
	        return o.type == type;
	      });
	      if (tels && tels.length > 0) return tels[0];
	
	      var t = { 'ddd': '', 'numberPhone': '', 'type': type };
	      this.account.telephones.telephone.push(t);
	
	      return t;
	    },
	    getCelFormated: function getCelFormated(obj) {
	      return (0, _string.phone)(this.account.dddCellphone + this.account.nroCellphone);
	    },
	    setCelFormated: function setCelFormated(value, obj) {
	      var t = value.replace(/[^0-9]/g, '');
	      this.account.dddCellphone = t.substring(0, 2);
	      this.account.nroCellphone = t.substring(2, 11);
	    },
	    getTel1Formated: function getTel1Formated(obj) {
	      return (0, _string.phone)(this.account.dddPhone + this.account.nroPhone);
	    },
	    setTel1Formated: function setTel1Formated(value, obj) {
	      var t = value.replace(/[^0-9]/g, '');
	      this.account.dddPhone = t.substring(0, 2);
	      this.account.nroPhone = t.substring(2, 11);
	    },
	    getTel2Formated: function getTel2Formated(obj) {
	      return (0, _string.phone)(this.account.dddPhone2 + this.account.nroPhone2);
	    },
	    setTel2Formated: function setTel2Formated(value, obj) {
	      var t = value.replace(/[^0-9]/g, '');
	      this.account.dddPhone2 = t.substring(0, 2);
	      this.account.nroPhone2 = t.substring(2, 11);
	    },
	    validateAll: function validateAll() {
	      var _this = this;
	
	      var vm = this;
	      return this.$validator.validateAll().then(function (r) {
	        var firstSpace = vm.account.company.contractManagerFullName.indexOf(" ") || vm.account.company.contractManagerFullName.length;
	        vm.account.company.contractManagerName = vm.account.company.contractManagerFullName.substring(0, firstSpace);
	        vm.account.company.contractManagerLastName = vm.account.company.contractManagerFullName.substring(firstSpace + 1, vm.account.company.contractManagerFullName.length);
	        vm.account.taxIdNumber = vm.account.taxIdNumberFormatted.replace(/[.\-\/]/g, '').toUpperCase();
	        vm.account.company.optanteNacional = _this.getFlagOptanteNacionalFromFront();
	        return _account2.default.accountExists({ taxIdNumber: vm.account.taxIdNumber }).then(function (r) {
	          if (!r) return _promise2.default.reject('Erro');
	        });
	      }).then(function (r) {
	        return vm.$refs.addressMailing.$validator.validateAll();
	      });
	    },
	    getFlagOptanteNacionalFromFront: function getFlagOptanteNacionalFromFront() {
	      if (this.optanteNacional == true) {
	        return "Y";
	      } else {
	        return "N";
	      }
	    }
	  },
	
	  components: { addressComp: _address2.default }
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _string = __webpack_require__(35);
	
	var _utils = __webpack_require__(34);
	
	var Utils = _interopRequireWildcard(_utils);
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _toll = __webpack_require__(26);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['request', 'minValue'],
	  data: function data() {
	    return {
	      rechargeValueTotal: 0,
	      rechargeTaxTotal: 0,
	      total: 0,
	      cupom: undefined,
	      totalComDesconto: 0,
	      descontoCupom: 0,
	      erroCupom: 0,
	      loading: undefined,
	      entries: undefined,
	      showEntries: false
	    };
	  },
	
	
	  computed: {
	    vehicles: function vehicles() {
	      return this.request.listVehicle.vehicle;
	    },
	    account: function account() {
	      return this.request.account;
	    },
	    address: function address() {
	      return this.request.addresses.address[0];
	    },
	    typeTel1: function typeTel1() {
	      var t = this.request.account.telephones.telephone[0];
	      if (t) return t.type;
	      return "";
	    },
	    typeTel2: function typeTel2() {
	      var t = this.request.account.telephones.telephone[1];
	      if (t) return t.type;
	      return "";
	    },
	    typeTel3: function typeTel3() {
	      var t = this.request.account.telephones.telephone[2];
	      if (t) return t.type;
	      return "";
	    },
	    tel1: function tel1() {
	      var t = this.request.account.telephones.telephone[0];
	      if (t) return (0, _string.phone)(t.ddd + t.numberPhone);
	      return "";
	    },
	    tel2: function tel2() {
	      var t = this.request.account.telephones.telephone[1];
	      if (t) return (0, _string.phone)(t.ddd + t.numberPhone);
	      return "";
	    },
	    tel3: function tel3() {
	      var t = this.request.account.telephones.telephone[2];
	      if (t) return (0, _string.phone)(t.ddd + t.numberPhone);
	      return "";
	    },
	    isPF: function isPF() {
	      return this.request.account.type == 'PESSOA_FISICA';
	    },
	    payment: function payment() {
	      return this.request.contract.paymentMethods.paymentMethod[0];
	    },
	    image: function image() {
	      if (this.payment.bankBill) return '/static/payment-methods/' + this.payment.bankBill.imagePath.split('.')[0] + '.svg';else if (this.payment.creditCard) return '/static/payment-methods/' + this.payment.creditCard.imagePath.split('.')[0] + '.svg';else if (this.payment.bankAccount) return '/static/payment-methods/' + this.payment.bankAccount.imagePath.split('.')[0] + '.svg';
	    },
	    isCaminhoParana: function isCaminhoParana() {
	      return Utils.isCaminhoParana(this.request.contract.plan.planId);
	    },
	    planId: function planId() {
	      return this.request.contract.plan.planId;
	    },
	    taxIdType: function taxIdType() {
	      return this.request.account.type == 'PESSOA_FISICA' ? 'CPF' : 'CNPJ';
	    },
	    plan: function plan() {
	      return this.$store.getters.getPlanById(this.planId);
	    },
	    newAdhesionTax: function newAdhesionTax() {
	      return this.$store.getters.getNewAdhesionTax(this.planId);
	    },
	    newVehicleTax: function newVehicleTax() {
	      if ([52, 51].indexOf(this.planId) !== -1) return 0;
	
	      return this.newAdhesionTax;
	    },
	    guaranteeTax: function guaranteeTax() {
	      return this.$store.getters.getGuaranteeTax(this.planId);
	    },
	    linkRntrcTax: function linkRntrcTax() {
	      return this.$store.getters.getLinkRntrcTax(this.planId);
	    },
	    monthlyTax: function monthlyTax() {
	      return this.$store.getters.getMonthlyTax(this.planId);
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var vm = this;
	    if (this.planHasRecharge(this.planId)) {
	      var recRecharge = {
	        planId: this.planId,
	        value: this.request.contract.rechargeValue
	      };
	
	      var promise = _sales2.default.calculateRechargeRate(recRecharge).then(function (r) {
	        _this.rechargeValueTotal = r.valueTotal;
	        _this.rechargeTaxTotal = r.taxTotal;
	        _this.calculateTotal();
	
	        if (_this.request.promotionCode && _this.request.promotionCode != 'CAMINHOSDOPARANA') {
	          _this.cupom = _this.request.promotionCode;
	
	          _this.calculateDiscount();
	        }
	      });
	
	      this.$store.dispatch('loading', promise);
	    } else {
	      this.rechargeValueTotal = this.rechargeTaxTotal = 0;
	      this.calculateTotal();
	    }
	    $('[data-toggle="tooltip"]').tooltip();
	  },
	
	
	  methods: {
	    calculateTotal: function calculateTotal() {
	      this.total = this.rechargeValueTotal + this.rechargeTaxTotal + this.newAdhesionTax + this.guaranteeTax * this.vehicles.length;
	      this.total += (this.vehicles.length - 1) * this.newVehicleTax;
	
	      if (this.monthlyTax) {
	        this.total += this.vehicles.length * this.monthlyTax;
	      }
	
	      if (this.planId == 2 || this.planId == 3) {
	        this.total += this.vehicles.length * this.linkRntrcTax;
	      }
	
	      this.totalComDesconto = this.total;
	
	      if (this.isCaminhoParana) {
	        this.totalComDesconto = this.total - this.vehicles.length * this.newVehicleTax;
	      } else if (this.descontoCupom) {
	        this.totalComDesconto = this.total - this.descontoCupom;
	      }
	
	      this.request.value = this.total;
	    },
	    adhesion: function adhesion() {
	      _sales2.default.adhesion(this.request);
	    },
	    validateAll: function validateAll() {
	      return this.$validator.validateAll();
	    },
	    calculateDiscount: function calculateDiscount() {
	      var _this2 = this;
	
	      this.erroCupom = '';
	      var resolveTemp = undefined;
	
	      var promotionCode = this.cupom;
	      var planId = this.request.contract.plan.planId;
	      var request = {
	        promotionCode: promotionCode,
	        planId: planId
	      };
	      request.salesType = 'ADHESION';
	
	      var discountRecharge = undefined;
	      var discountAdhesion = undefined;
	      var countDiscount = 0;
	
	      var promise = _sales2.default.calculateDiscount(request).then(function (response) {
	        discountAdhesion = response;
	
	        if (discountAdhesion && [51, 52].indexOf(_this2.planId) !== -1) {
	          _this2.descontoCupom = _this2.rechargeTaxTotal;
	        } else if (discountAdhesion) {
	          if (discountAdhesion.productId == _constantes2.default.SALES_TYPE.ADHESION || discountAdhesion.productId == _constantes2.default.SALES_TYPE.GUARANTEE) {
	            var qtd = discountAdhesion.discountLimit == 0 ? _this2.vehicles.length : Math.min(_this2.vehicles.length, discountAdhesion.discountLimit);
	            _this2.descontoCupom = qtd * discountAdhesion.valueUnitDiscount;
	          } else {
	            _this2.descontoCupom = discountAdhesion.valueUnitDiscount;
	          }
	        }
	        _this2.setPromotion(_this2.cupom);
	        _this2.calculateTotal();
	      }).catch(function () {
	        _this2.erroCupom = 'Desconto não existe.';
	        _this2.setPromotion(undefined);
	      });
	
	      this.$store.dispatch('loading', promise);
	    },
	    removeDiscount: function removeDiscount() {
	      this.descontoCupom = 0;
	      this.setPromotion(undefined);
	      this.calculateTotal();
	      this.cupom = '';
	      this.erroCupom = '';
	    },
	    setPromotion: function setPromotion(code) {
	
	      if (this.request["promotionCode"] != 'CAMINHOSDOPARANA') {
	        this.request["promotionCode"] = code;
	        if (!code) {
	          delete this.request["promotionCode"];
	        }
	      }
	    },
	    getTolls: function getTolls(state, associateId) {
	      var _this3 = this;
	
	      this.loading = _toll2.default.getTollsByState(state).then(function (res) {
	        _this3.entries = _.filter(res, function (o) {
	          return o.associateId == associateId;
	        });
	        _this3.showEntries = true;
	      }).catch(function (err) {});
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _slicedToArray2 = __webpack_require__(177);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _address = __webpack_require__(84);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _string = __webpack_require__(35);
	
	var _date = __webpack_require__(38);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _objects = __webpack_require__(44);
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["user", "address", "blockTaxIdNumber"],
	  data: function data() {
	    return {
	      token: null,
	      step: 0,
	      validacao: undefined,
	      lastNetrimQuery: null
	    };
	  },
	  mounted: function mounted() {
	    this.checkCpfValidationPermission();
	    this.sincronizarCamposMascarados();
	  },
	
	
	  computed: {
	    tel: {
	      get: function get() {
	        return this.getTelFormated();
	      },
	      set: function set(newValue) {
	        this.setTelFormated(newValue);
	      }
	    },
	    cel: {
	      get: function get() {
	        return this.getCelFormated();
	      },
	      set: function set(newValue) {
	        this.setCelFormated(newValue);
	      }
	    }
	  },
	  methods: {
	    sincronizarCamposMascarados: function sincronizarCamposMascarados() {
	      var _this = this;
	
	      var campos = [[this.$refs.taxIdNumber, function () {
	        return _this.user;
	      }, "taxIdNumberFormatted"], [this.$refs.birthDate, function () {
	        return _this.user && _this.user.person;
	      }, "birthDateBR"]];
	
	      campos.forEach(function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 3),
	            el = _ref2[0],
	            obterAlvo = _ref2[1],
	            propriedade = _ref2[2];
	
	        if (!el) return;
	
	        var sincronizar = function sincronizar() {
	          var alvo = obterAlvo();
	          if (alvo && alvo[propriedade] !== el.value) {
	            _this.$set(alvo, propriedade, el.value);
	          }
	        };
	
	        var aoEditar = function aoEditar() {
	          sincronizar();
	          setTimeout(sincronizar, 0);
	        };
	
	        el.addEventListener("input", aoEditar);
	        el.addEventListener("keyup", aoEditar);
	      });
	    },
	    checkCpfValidationPermission: function checkCpfValidationPermission() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var resp;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _auth2.default.checkCpfValidationPermission();
	
	              case 2:
	                resp = _context.sent;
	
	                _this2.token = resp.token;
	
	              case 4:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }))();
	    },
	
	    ValidacaoNetrim: _.debounce((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	      var _this3 = this;
	
	      var cpf, dataNascimento, dataCompleta, queryKey;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              cpf = this.user.taxIdNumberFormatted.replaceAll(/[^0-9]/g, "");
	              dataNascimento = this.user.person.birthDateBR ? this.user.person.birthDateBR.replaceAll("/", "-") : null;
	              dataCompleta = !!dataNascimento && dataNascimento.length === 10;
	
	              if (!(cpf.length >= 11 && dataCompleta && this.user.person.fullName)) {
	                _context2.next = 16;
	                break;
	              }
	
	              queryKey = cpf + "_" + dataNascimento;
	
	              if (!(this.lastNetrimQuery === queryKey)) {
	                _context2.next = 7;
	                break;
	              }
	
	              return _context2.abrupt("return");
	
	            case 7:
	              this.lastNetrimQuery = queryKey;
	
	              _context2.prev = 8;
	              _context2.next = 11;
	              return this.checkCpfValidationPermission();
	
	            case 11:
	              _context2.next = 15;
	              break;
	
	            case 13:
	              _context2.prev = 13;
	              _context2.t0 = _context2["catch"](8);
	
	            case 15:
	              _contracts2.default.ConsultaNetrimLog(cpf, dataNascimento, this.token).then(function (resp) {
	                if (resp.consulta.length == 0) {
	                  _this3.validacao = true;
	                } else if (resp.consulta[0].exception == 0) {
	                    _this3.validacao = true;
	                  } else if (resp.consulta[0].exception == 2) {
	                    _this3.validacao = false;
	                    _this3.user.taxIdNumberFormatted = "";
	                    _this3.user.person.birthDateBR = "";
	                    _this3.user.person.fullName = "";
	                    _messageDialog2.default.show({
	                      title: "Oops! Alguma coisa deu errada!",
	                      message: "Não foi possível validar seu CPF no momento. Por favor, entre em contato com nossa Central de Relacionamento, através dos números 4000 2901 (Capitais e regiões metropolitanas) e 0800 777 1022 (Demais localidades).",
	                      headerClass: "modal-danger"
	                    });
	                  } else {
	                    _this3.validacao = false;
	                    _this3.user.taxIdNumberFormatted = "";
	                    _this3.user.person.birthDateBR = "";
	                    _this3.user.person.fullName = "";
	
	                    _messageDialog2.default.show({
	                      title: "Oops! Alguma coisa deu errada!",
	                      message: "Não podemos prosseguir com o seu cadastro. Para maiores informações, consulte seu CPF na página da Secretaria da Receita Federal, ",
	                      headerClass: "modal-danger",
	                      type: "BLANK",
	                      txtBlank: "clicando aqui!",
	                      urlBlank: "https://servicos.receita.fazenda.gov.br/servicos/cpf/consultasituacao/consultapublica.asp",
	                      colorTxtBlank: "#0000FF"
	                    });
	                  }
	              }).catch(function (err) {
	                console.warn("Falha ao validar CPF na Netrin:", err);
	              });
	
	            case 16:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, this, [[8, 13]]);
	    })), 500),
	    correctCursor2: function correctCursor2(a) {
	      if (!window.document.mobile) return;
	
	      setTimeout(function () {
	        $(a.target).val($(a.target).val());
	      }, 80);
	    },
	    getTelType: function getTelType(type) {
	      var tels = _.filter(this.user.telephones.telephone, function (o) {
	        return o.type == type;
	      });
	      if (tels && tels.length > 0) return tels[0];
	
	      var t = { ddd: "", numberPhone: "", type: type };
	      this.user.telephones.telephone.push(t);
	
	      return t;
	    },
	    getCelFormated: function getCelFormated(obj) {
	      return (0, _string.phone)(this.user.dddCellphone + this.user.nroCellphone);
	    },
	    setCelFormated: function setCelFormated(value) {
	      var t = value.replace(/[^0-9]/g, "");
	      this.user.dddCellphone = t.substring(0, 2);
	      this.user.nroCellphone = t.substring(2, 11);
	    },
	    getTelFormated: function getTelFormated(obj) {
	      return (0, _string.phone)(this.user.dddPhone + this.user.nroPhone);
	    },
	    setTelFormated: function setTelFormated(value, obj) {
	      var t = value.replace(/[^0-9]/g, "");
	      this.user.dddPhone = t.substring(0, 2);
	      this.user.nroPhone = t.substring(2, 11);
	    },
	    validateAll: function validateAll() {
	      var vm = this;
	      return this.$validator.validateAll().then(function (r) {
	        vm.user.person.fullName = vm.user.person.fullName.trim();
	        var firstSpace = vm.user.person.fullName.indexOf(" ") || vm.user.person.fullName.length;
	        vm.user.person.name = vm.user.person.fullName.substring(0, firstSpace);
	        vm.user.person.lastName = vm.user.person.fullName.substring(firstSpace + 1, vm.user.person.fullName.length);
	        vm.user.person.birthDate = (0, _date.brToAm)(vm.user.person.birthDateBR);
	        vm.user.taxIdNumber = vm.user.taxIdNumberFormatted.replace(/[^0-9]/g, "");
	        vm.user.email2 = vm.user.accountAuthentication.login;
	
	        return _account2.default.accountExists({
	          taxIdNumber: vm.user.taxIdNumber
	        }).then(function (r) {
	          if (!r) return _promise2.default.reject("Erro");
	        });
	      }).then(function (r) {
	        return vm.$refs.addressMailing.$validator.validateAll();
	      });
	    }
	  },
	
	  components: { addressComp: _address2.default }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(49);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(48);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _vehicles = __webpack_require__(29);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	var _messageDialog = __webpack_require__(53);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _objects = __webpack_require__(44);
	
	var obj = _interopRequireWildcard(_objects);
	
	var _utils = __webpack_require__(34);
	
	var _eventBus = __webpack_require__(25);
	
	var _vuex = __webpack_require__(120);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  props: ['vehicles', 'type', 'allowVehicles', 'planId'],
	
	  data: function data() {
	    var _ref;
	
	    return _ref = {
	      plate: '',
	
	      models: [],
	      modelSelected: {},
	      modelId: undefined,
	
	      brands: undefined,
	      brandSelected: {},
	      brandId: undefined,
	
	      axesName: "",
	      axesId: 1,
	      errorMessage: undefined,
	      loading: undefined,
	
	      formStep: 0,
	
	      isTransportador: false,
	      cpfCnpjTransportador: undefined,
	
	      showModalInvalidPlate: false
	
	    }, (0, _defineProperty3.default)(_ref, 'loading', false), (0, _defineProperty3.default)(_ref, 'formVisibility', false), _ref;
	  },
	
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getPromotionCurrent']), {
	    isAdhesionAditional: function isAdhesionAditional() {
	      return this.$route.path.indexOf('/veiculos/novo') >= 0;
	    },
	    lead: function lead() {
	      return this.$parent.lead;
	    }
	  }),
	
	  mounted: function mounted() {
	    if (this.vehicles && this.vehicles.length) {
	      this.formStep = 1;
	    }
	  },
	
	
	  methods: {
	    ChangeByPropsStepOne: function ChangeByPropsStepOne(plateSelected, brandNameSelected, brandIdSelected, arrayModelsByNetrin) {
	      this.plate = plateSelected;
	      this.brandSelected.brandId = brandIdSelected;
	      this.brandSelected.name = brandNameSelected;
	      this.models = arrayModelsByNetrin;
	      return;
	    },
	    ChangeByPropsStepOneNetrinOff: function ChangeByPropsStepOneNetrinOff(plateSelected, brandNameSelected, brandIdSelected, modelSelected, modelSelectedId) {
	      this.plate = plateSelected;
	      this.brandSelected.brandId = brandIdSelected;
	      this.brandSelected.name = brandNameSelected;
	      this.modelSelected.name = modelSelected;
	      this.modelSelected.modelId = modelSelectedId;
	      return;
	    },
	    ChangeModelInfo: function ChangeModelInfo(modelName, modelId) {
	      this.modelSelected.name = modelName;
	      this.modelSelected.modelId = modelId;
	      return;
	    },
	    ChangeAxesInfo: function ChangeAxesInfo(axesName, axesId) {
	      this.axesId = axesId;
	      this.axesName = axesName;
	      return;
	    },
	    ChangeTransportadorInfo: function ChangeTransportadorInfo(isTransportador, cpfCnpjTransportador) {
	      this.isTransportador = !!isTransportador;
	      this.cpfCnpjTransportador = cpfCnpjTransportador || undefined;
	      return;
	    },
	    ChangeLoadingStatusToOn: function ChangeLoadingStatusToOn() {
	      return this.loading = true;
	    },
	    ChangeLoadingStatusToOff: function ChangeLoadingStatusToOff() {
	      return this.loading = false;
	    },
	    OpenForm: function OpenForm() {
	      this.formVisibility = true;
	      return;
	    },
	    stepBackZero: function stepBackZero() {
	      return this.formStep = 0;
	    },
	    unphenize: function unphenize(plates) {
	      var response = [];
	      plates.forEach(function (plate) {
	        response.push(plate.replace("-", ""));
	      });
	      return response;
	    },
	    add: function add() {
	      var _this = this;
	
	      this.loading = true;
	      var vm = this;
	      this.errorMessage = undefined;
	      vm.errors.clear();
	
	      if (!(0, _utils.isCaminhoParana)(this.planId) && this.allowVehicles >= 0 && vm.vehicles.length >= this.allowVehicles) {
	        _messageDialog2.default.show({
	          title: 'Limite atingido',
	          message: 'Este plano permite adicionar apenas ' + _constantes2.default.LIMIT_VEHICLES + ' ve\xEDculos',
	          type: 'OK'
	        });
	        return this.loading = false;
	      }
	
	      if ((this.planId == 21 || this.planId == 22 || this.planId == 28) && vm.vehicles.length >= 10) {
	        _messageDialog2.default.show({
	          title: 'Limite atingido',
	          message: 'Este plano permite adicionar apenas 10 ve\xEDculos',
	          type: 'OK'
	        });
	        return this.loading = false;
	      }
	
	      var promises = [];
	      promises.push(_vehicles2.default.vehicleNotExists(this.plate));
	
	      if (this.lead && this.lead.plates.length > 0) {
	        var promiseLead = new _promise2.default(function (resolve, reject) {
	
	          _this.lead.plates = _this.unphenize(_this.lead.plates);
	
	          if (_this.lead.plates.indexOf(_this.plate.replace("-", "").toUpperCase()) >= 0) resolve(true);else reject('Veiculo não esta cadastrado no plano Caminhos do Paraná!');
	        });
	
	        promises.push(promiseLead);
	      }
	
	      var v = obj.vehicle();
	
	      v.plate = vm.plate.toUpperCase();
	      v.model.modelId = vm.modelSelected.modelId;
	      v.model.name = vm.modelSelected.name;
	      v.model.brand.brandId = vm.brandSelected.brandId;
	      v.model.brand.name = vm.brandSelected.name;
	      v.categoryAxes.categoryAxesId = vm.axesId;
	      v.categoryAxes.name = vm.axesName;
	      v.isTransportador = vm.isTransportador;
	      v.cpfCnpjTransportador = vm.isTransportador ? vm.cpfCnpjTransportador : undefined;
	
	      vm.vehicles.push(v);
	      vm.plate = '';
	      vm.isTransportador = false;
	      vm.cpfCnpjTransportador = undefined;
	      vm.formStep = 1;
	      vm.formVisibility = false;
	      vm.loading = false;
	      vm.$forceUpdate();
	      _eventBus.EventBus.$emit('cleanErrors');
	    }
	  }
	
	};

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _trunc = __webpack_require__(767);
	
	var _trunc2 = _interopRequireDefault(_trunc);
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _assign = __webpack_require__(122);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _getIterator2 = __webpack_require__(69);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _keys = __webpack_require__(176);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _payment = __webpack_require__(1991);
	
	var _payment2 = _interopRequireDefault(_payment);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _toll = __webpack_require__(26);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _number = __webpack_require__(24);
	
	var _modalAddress = __webpack_require__(1878);
	
	var _modalAddress2 = _interopRequireDefault(_modalAddress);
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _tag = __webpack_require__(55);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _financial = __webpack_require__(54);
	
	var _financial2 = _interopRequireDefault(_financial);
	
	var _utils = __webpack_require__(34);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _objects = __webpack_require__(44);
	
	var obj = _interopRequireWildcard(_objects);
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _conveniadoService = __webpack_require__(239);
	
	var _conveniadoService2 = _interopRequireDefault(_conveniadoService);
	
	var _param = __webpack_require__(68);
	
	var _param2 = _interopRequireDefault(_param);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["account", "order", "showAddress", "addressInit", "reprocess", "contract", "currentBalance", "rodosol", "disablePayment", "skipBillingSection"],
	  data: function data() {
	    return {
	      blackFriday: ['FR01', 'FR02', 'FR03', 'FR04', 'FR05', 'FR06', 'FR07', 'FR08', 'FR09', 'FR10'],
	      disableBf: false,
	      address: this.address,
	      loading: undefined,
	      orderShipmentTracking: undefined,
	      urlPayment: undefined,
	      showVehicle: false,
	      listVehicles: [],
	      statusPedido: {},
	      showModal: false,
	      secureCodeCreditCard: undefined,
	      dataCorteReprocessamento: undefined,
	      newTypePayment: undefined,
	      reprocessed: false,
	      orderResult: undefined,
	      paymentSelected: obj.payment(),
	      showEntries: false,
	      whereToDelivery: "0",
	      cupom: this.order.promotionCode,
	      promotionCode: this.order.promotionCode,
	      totalComDesconto: this.order.price,
	      descontoCupom: 0,
	      erroCupom: 0,
	      nameDelivery: {
	        61800016: "MSVIA",
	        61801283: "RodoNorte"
	      },
	      shipmentType: undefined,
	      frete: undefined,
	      promoBF: false,
	      onoffswitch: undefined,
	      limitValue: undefined,
	      limitPercent: undefined,
	      emailBlured: false,
	      valid: true,
	      conveniados: [],
	      resultBalance: undefined,
	      percentValid: undefined,
	      toggle: false,
	      cpm: {
	        contractPaymentMethodId: undefined,
	        error: this.disablePayment || this.skipBillingSection ? undefined : "Verifique o preenchimento dos campos"
	      },
	      resolveConfirm: undefined,
	      selectedAddress: {},
	      addresses: [],
	      prazoEntrega: "",
	      paymentMethodsAuthorized: {},
	      termsAccepted: false,
	      termsAdhesionShowError: false,
	      tagInHandStates: [],
	      tagReservaDisponivel: false,
	      saldoDisponivel: 0
	    };
	  },
	
	  computed: {
	    requiresAdhesionTermsAcceptance: function requiresAdhesionTermsAcceptance() {
	      if (!this.orderResult || this.cpm.error) {
	        return false;
	      }
	      if (this.orderResult.salesOrderId) {
	        return false;
	      }
	      if (this.orderResult.salesType === "RECHARGE") {
	        return false;
	      }
	      if (this.orderResult.salesType !== "ADHESION") {
	        return false;
	      }
	      return this.skipPaymentFlow || this.cpm.paymentMethod != null;
	    },
	    skipPaymentFlow: function skipPaymentFlow() {
	      return this.disablePayment === true || this.skipBillingSection === true;
	    },
	    addressOrderDelivery: function addressOrderDelivery() {
	      return this.orderResult.salesOrderShipment.deliveryAddress;
	    },
	    currentUser: function currentUser() {
	      return _auth2.default.currentUser;
	    },
	    possuiTagReserva: function possuiTagReserva() {
	      return !!(_auth2.default.currentUser && _auth2.default.currentUser.possuiTagReserva);
	    },
	    mostrarValores: function mostrarValores() {
	      return this.orderResult.salesType == "RECHARGE" || this.shipmentType || this.reprocess;
	    },
	    mostrarPagamento: function mostrarPagamento() {
	      return this.orderResult.salesType == "RECHARGE" || this.shipmentType;
	    },
	    email: function email() {
	      if (this.currentUser) {
	        return this.currentUser.email2;
	      } else if (this.account.email2) {
	        return this.account.email2;
	      } else if (this.account.company) {
	        return this.account.accountAuthentication.login;
	      }
	    },
	    nomePfPj: function nomePfPj() {
	      if (this.account && this.account.person) {
	        return this.account.person.name + " " + this.account.person.lastName;
	      } else if (this.account && this.account.company) {
	        return this.account.company.companyName;
	      } else if (this.currentUser.company) {
	        return this.currentUser.company.companyName;
	      } else {
	        return this.currentUser.person.name + " " + this.currentUser.person.lastName;
	      }
	    },
	    notAproved: function notAproved() {
	      return this.$route.query.notAproved;
	    },
	    hasAnyPaymentMethodAvailable: function hasAnyPaymentMethodAvailable() {
	      var _this = this;
	
	      if (!this.account || !this.account.taxIdNumber) {
	        return this.hasAnyPaymentMethodInPlan();
	      }
	
	      var planId = this.orderResult && this.orderResult.planId;
	      if (!planId) {
	        return true;
	      }
	
	      var typesAllowed = this.$store.getters.getPaymentsTypesByPlan(planId);
	
	      if (!this.paymentMethodsAuthorized || (0, _keys2.default)(this.paymentMethodsAuthorized).length === 0) {
	        if (!typesAllowed) {
	          return true;
	        }
	        return this.hasAnyPaymentMethodInPlan();
	      }
	
	      if (!typesAllowed) {
	        return true;
	      }
	
	      var isAuthorized = function isAuthorized(method) {
	        if (!_this.paymentMethodsAuthorized.hasOwnProperty(method)) {
	          return true;
	        }
	        return _this.paymentMethodsAuthorized[method] === true;
	      };
	
	      var hasDC = isAuthorized('DC') && typesAllowed.bankAccount;
	      var hasCC = isAuthorized('CC') && typesAllowed.creditCard;
	      var hasBC = isAuthorized('BC') && typesAllowed.bankBill;
	      var hasDO = isAuthorized('DO') && typesAllowed.doc;
	      var hasTE = isAuthorized('TE') && typesAllowed.ted;
	      var hasPX = isAuthorized('PX');
	      var hasCR = isAuthorized('CR');
	
	      return hasDC || hasCC || hasBC || hasDO || hasTE || hasPX || hasCR;
	    },
	    hasAnyPaymentMethodInPlan: function hasAnyPaymentMethodInPlan() {
	      var planId = this.orderResult && this.orderResult.planId;
	      if (!planId) {
	        return true;
	      }
	
	      var typesAllowed = this.$store.getters.getPaymentsTypesByPlan(planId);
	      if (!typesAllowed) {
	        return true;
	      }
	
	      return typesAllowed.bankAccount || typesAllowed.creditCard || typesAllowed.bankBill || typesAllowed.doc || typesAllowed.ted;
	    },
	    contractId: function contractId() {
	      return this.orderResult && this.orderResult.contract;
	    },
	    isCaminhoParana: function isCaminhoParana() {
	      if (this.orderResult) {
	        return utils.isCaminhoParana(this.orderResult.planId);
	      }
	      return;
	    },
	    bankBillOption: function bankBillOption() {
	      var options = this.$store.getters.getPaymentsTypesByPlan(this.orderResult.planId);
	      return options.bankBill;
	    },
	    isPlanPrePF: function isPlanPrePF() {
	      var _this2 = this;
	
	      var plans = [21, 22];
	      return plans.find(function (p) {
	        return p == _this2.order.planId;
	      });
	    },
	    isPlanPrePJ: function isPlanPrePJ() {
	      var _this3 = this;
	
	      var plans = [31, 32, 45, 55];
	      return plans.find(function (p) {
	        return p == _this3.order.planId;
	      });
	    },
	    showFreteExpresso: function showFreteExpresso() {
	      return sessionStorage.getItem('promoCheck') != '#SENFF2020' && !this.reprocess && this.orderResult.planId != null;
	    },
	    showRetiradaEmMaos: function showRetiradaEmMaos() {
	      return sessionStorage.getItem("promoCheck") != "#SENFF2020" && !this.reprocess && this.orderResult.planId != null;
	    },
	    isAnyTagActivating: function isAnyTagActivating() {
	      return this.tagInHandStates.some(function (s) {
	        return s && (s.loading || s.success);
	      });
	    },
	    anyTagActivationSuccess: function anyTagActivationSuccess() {
	      return this.tagInHandStates.some(function (s) {
	        return s && s.success;
	      });
	    },
	    cellPhone: function cellPhone() {
	
	      if (this.currentUser) {
	        if (!this.currentUser.nroCellphone && !this.currentUser.dddCellphone && !this.orderResult.salesType != "ADHESION" || this.currentUser.dddCellphone == "null" && this.currentUser.nroCellphone == "null" && this.orderResult.salesType != "ADHESION") {
	          this.currentUser.dddCellphone = "";
	          this.currentUser.nroCellphone = "";
	          return;
	        } else {
	          return "(" + this.currentUser.dddCellphone + ") " + this.currentUser.nroCellphone;
	        }
	      }
	      return "(" + this.account.dddCellphone + ") " + this.account.nroCellphone;
	    },
	    devePreencherEndereco: function devePreencherEndereco() {
	      return this.showAddress && !this.shipmentType && (this.orderResult.planId == 21 || this.orderResult.planId == 22);
	    }
	  },
	
	  watch: {
	    address: function address() {
	      this.getPrazoEntrega();
	    },
	    cupom: function cupom() {
	      var cupomExiste = this.blackFriday.indexOf(this.cupom);
	      cupomExiste != -1 ? this.disableBf = true : this.disableBf = false;
	    },
	    cpm: function cpm() {
	      this.$emit("input", this.cpm);
	    },
	    'account.taxIdNumber': function accountTaxIdNumber(newVal) {
	      if (this.skipPaymentFlow) {
	        this.paymentMethodsAuthorized = {};
	        return;
	      }
	      if (newVal) {
	        this.loadPaymentMethodAuthorizations(newVal);
	      } else {
	        this.paymentMethodsAuthorized = {};
	      }
	    },
	
	    orderResult: {
	      handler: function handler(newVal) {
	        this.checkTagReservaDisponivel();
	        if (this.skipPaymentFlow) {
	          return;
	        }
	        if (newVal && this.account && this.account.taxIdNumber) {
	          this.loadPaymentMethodAuthorizations(this.account.taxIdNumber);
	        }
	      },
	
	      deep: true
	    },
	    anyTagActivationSuccess: function anyTagActivationSuccess(newVal) {
	      this.$emit("tag-activation-state", newVal);
	    },
	    listVehicles: function listVehicles(newVal) {
	      var prev = this.tagInHandStates || [];
	      this.tagInHandStates = (newVal || []).map(function (_v, i) {
	        var keep = prev[i];
	        return keep ? keep : { serialNumber: "", error: "", loading: false, success: false };
	      });
	    },
	
	    'contract.currentBalance.currentBalance': function contractCurrentBalanceCurrentBalance(val, oldVal) {
	      this.calculatePercentValid();
	    },
	    termsAccepted: function termsAccepted(val) {
	      if (val) {
	        this.termsAdhesionShowError = false;
	      }
	    },
	    shipmentType: function shipmentType(newVal) {
	      var _this4 = this;
	
	      this.$emit("shipment-type-change", newVal);
	      _.remove(this.order.products, function (o) {
	        return o.productId == 31;
	      });
	
	      if (this.shipmentType == 3) {
	        $('#ModalConveniados').modal('show');
	
	        this.loading = _conveniadoService2.default.listaConveniados().then(function (resp) {
	          _this4.conveniados = resp.listaConveniados;
	        }).catch(function (err) {});
	      }
	
	      if (this.shipmentType == 2) {
	        this.order.products.push({
	          productId: 31,
	          productName: "FRETE",
	          valueUnit: this.frete.cobrancaExp,
	          quantity: 1,
	          valueTotal: this.frete.cobrancaExp
	        });
	      }
	      if (this.shipmentType != 4) {
	        this.tagInHandStates = (this.listVehicles || []).map(function () {
	          return {
	            serialNumber: "",
	            error: "",
	            loading: false,
	            success: false
	          };
	        });
	      }
	      this.calculateTotal();
	    }
	  },
	  created: function created() {
	    if (this.addressInit) {
	      this.address = this.addressInit;
	      this.selectedAddress = this.addressInit;
	    } else {
	      this.address = _auth2.default.currentUser && _auth2.default.currentUser.address;
	      this.selectedAddress = this.address;
	    }
	
	    if (this.account && this.account.taxIdNumber && !this.skipPaymentFlow) {
	      this.loadPaymentMethodAuthorizations(this.account.taxIdNumber);
	    }
	
	    this.$store.dispatch('getPlans').catch(function (err) {
	      console.error('Erro ao carregar planos:', err);
	    });
	  },
	
	
	  mounted: function () {
	    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      var larguraTela, recargaProduto, adesaoProduto, taxaRecargaProduto, adesaoVeiculoAdicional, hasPlanId22, contracts, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, contract, res, uf, _res;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              larguraTela = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	
	
	              this.calculatePercentValid();
	
	              if (!(this.$route.query.promoId == 'FERIAS_2022')) {
	                _context.next = 5;
	                break;
	              }
	
	              _context.next = 5;
	              return this.blackFridayCheck();
	
	            case 5:
	
	              this.orderResult = this.order;
	              this.listVehicles = this.order.vehicles;
	              this.tagInHandStates = (this.listVehicles || []).map(function () {
	                return {
	                  serialNumber: "",
	                  error: "",
	                  loading: false,
	                  success: false
	                };
	              });
	              this.checkTagReservaDisponivel();
	
	              if (this.showAddress && this.orderResult && !this.order.salesOrderId && this.orderResult.salesType !== "RECHARGE" && this.orderResult.salesType !== "MIGRATIONPLAN" && !utils.isCaminhoParana(this.orderResult.planId) && this.order.promotionCode !== "CAMINHOSDOPARANA" && (this.shipmentType === undefined || this.shipmentType === null || this.shipmentType === "")) {
	                this.shipmentType = "1";
	              }
	
	              if (!(this.orderResult.salesType != "RECHARGE" && this.salesType == 'MIGRATIONPLAN')) {
	                _context.next = 14;
	                break;
	              }
	
	              if (!(!this.reprocess && sessionStorage.getItem('promoCheck') != '#SENFF2020')) {
	                _context.next = 14;
	                break;
	              }
	
	              _context.next = 14;
	              return this.checkCovid();
	
	            case 14:
	              recargaProduto = this.orderResult.products.filter(function (product) {
	                return product.productId === 2;
	              });
	              adesaoProduto = this.orderResult.products.filter(function (product) {
	                return product.productId === 1;
	              });
	              taxaRecargaProduto = this.orderResult.products.filter(function (product) {
	                return product.productId === 3;
	              });
	              adesaoVeiculoAdicional = this.orderResult.products.filter(function (product) {
	                return product.productId === 4;
	              });
	
	              if (!((this.orderResult.salesType === "ADHESION" || this.orderResult.salesType === "ADHESIOACONTRACTADDITIONAL") && recargaProduto[0].valueTotal >= 20000 && this.orderResult.planId === 22)) {
	                _context.next = 64;
	                break;
	              }
	
	              hasPlanId22 = false;
	
	              if (!(this.orderResult.salesType === "ADHESIOACONTRACTADDITIONAL")) {
	                _context.next = 53;
	                break;
	              }
	
	              _context.next = 23;
	              return _contracts2.default.findAll(this.currentUser.moveMaisId);
	
	            case 23:
	              contracts = _context.sent;
	              _iteratorNormalCompletion = true;
	              _didIteratorError = false;
	              _iteratorError = undefined;
	              _context.prev = 27;
	              _iterator = (0, _getIterator3.default)(contracts);
	
	            case 29:
	              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                _context.next = 37;
	                break;
	              }
	
	              contract = _step.value;
	
	              if (!(contract.plan && contract.plan.planId === 22)) {
	                _context.next = 34;
	                break;
	              }
	
	              hasPlanId22 = true;
	              return _context.abrupt("break", 37);
	
	            case 34:
	              _iteratorNormalCompletion = true;
	              _context.next = 29;
	              break;
	
	            case 37:
	              _context.next = 43;
	              break;
	
	            case 39:
	              _context.prev = 39;
	              _context.t0 = _context["catch"](27);
	              _didIteratorError = true;
	              _iteratorError = _context.t0;
	
	            case 43:
	              _context.prev = 43;
	              _context.prev = 44;
	
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	
	            case 46:
	              _context.prev = 46;
	
	              if (!_didIteratorError) {
	                _context.next = 49;
	                break;
	              }
	
	              throw _iteratorError;
	
	            case 49:
	              return _context.finish(46);
	
	            case 50:
	              return _context.finish(43);
	
	            case 51:
	              if (!hasPlanId22) {
	                _context.next = 53;
	                break;
	              }
	
	              return _context.abrupt("return");
	
	            case 53:
	              if (hasPlanId22) {
	                _context.next = 64;
	                break;
	              }
	
	              _context.prev = 54;
	              _context.next = 57;
	              return _param2.default.getGeneralParameter({ key: 'TOTAL_ADHESION' });
	
	            case 57:
	              res = _context.sent;
	
	              if (res.status.code === 0 && res.value != "") {
	                this.descontoCupom = 2;
	                this.cupom = res.value;
	                this.order.promotionCode = res.value;
	
	                if (this.orderResult.salesType === "ADHESION") {
	                  adesaoProduto[0].valueUnit = 0;
	                  adesaoProduto[0].valueTotal = 0;
	                } else {
	                  adesaoVeiculoAdicional[0].valueUnit = 0;
	                  adesaoVeiculoAdicional[0].valueTotal = 0;
	                }
	
	                taxaRecargaProduto[0].valueUnit = 0;
	                taxaRecargaProduto[0].valueTotal = 0;
	              }
	              _context.next = 64;
	              break;
	
	            case 61:
	              _context.prev = 61;
	              _context.t1 = _context["catch"](54);
	
	              console.error("Falha ao consultar promocao total ativa");
	
	            case 64:
	
	              if (this.promotionCode) {
	                this.calculateDiscount();
	              }
	
	              if (!this.showAddress) {
	                _context.next = 71;
	                break;
	              }
	
	              uf = { uf: this.address.state };
	              _context.next = 69;
	              return _sales2.default.findByUf(uf);
	
	            case 69:
	              _res = _context.sent;
	
	              this.frete = _res.frete;
	
	            case 71:
	
	              this.calculateTotal();
	              this.getPrazoEntrega();
	
	            case 73:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, this, [[27, 39, 43, 51], [44,, 46, 50], [54, 61]]);
	    }));
	
	    function mounted() {
	      return _ref.apply(this, arguments);
	    }
	
	    return mounted;
	  }(),
	  methods: {
	    checkTagReservaDisponivel: function checkTagReservaDisponivel() {
	      var _this5 = this;
	
	      var possui = !!(_auth2.default.currentUser && _auth2.default.currentUser.possuiTagReserva);
	      if (!possui) {
	        this.saldoDisponivel = 0;
	        this.tagReservaDisponivel = false;
	        return;
	      }
	      var moveMaisId = _auth2.default.currentUser.moveMaisId;
	      var cnpj = _auth2.default.currentUser.taxIdNumber;
	      if (!moveMaisId || !cnpj) {
	        this.saldoDisponivel = 0;
	        this.tagReservaDisponivel = false;
	        return;
	      }
	      _tag2.default.getSaldoTagReservaByMoveMaisId(moveMaisId).then(function (saldos) {
	        var entrada = (saldos || []).find(function (s) {
	          return s && s.cnpj === cnpj;
	        });
	        var saldoLiq = entrada && entrada.saldoDisponivelLiquido != null ? entrada.saldoDisponivelLiquido : 0;
	        _this5.saldoDisponivel = Math.max(0, saldoLiq);
	        _this5.tagReservaDisponivel = _this5.saldoDisponivel > 0;
	      }).catch(function () {
	        _this5.saldoDisponivel = 0;
	        _this5.tagReservaDisponivel = false;
	      });
	    },
	    canActivateTagInHand: function canActivateTagInHand(index) {
	      var s = this.tagInHandStates[index];
	      if (!s || this.shipmentType != 4) return false;
	      if (s.loading || s.success) return false;
	      if (!s.serialNumber || s.serialNumber.length === 0) return false;
	      if (this.isAnyTagActivating && !s.loading) return false;
	      return true;
	    },
	    handleTagSerialNumberInput: function handleTagSerialNumberInput(index) {
	      var s = this.tagInHandStates[index];
	      if (!s) return;
	      s.serialNumber = (s.serialNumber || "").replace(/\D/g, "");
	      s.error = "";
	      s.success = false;
	    },
	    validateTagInHand: function validateTagInHand(vehicle, index) {
	      var s = this.tagInHandStates[index];
	      if (!s) return;
	
	      s.error = "";
	      s.success = false;
	
	      var onlyNumbers = (s.serialNumber || "").replace(/\D/g, "");
	      s.serialNumber = onlyNumbers;
	
	      if (!onlyNumbers) {
	        s.error = "Digite o número da TAG.";
	        return;
	      }
	
	      if (onlyNumbers.length < 8) {
	        s.error = _constantes2.default.MSG_02_TAG_NOT_FOUND;
	        return;
	      }
	
	      if (!vehicle || !vehicle.plate) {
	        s.error = "Veículo não disponível para ativação.";
	        return;
	      }
	
	      var moveMaisId = _auth2.default.currentUser && _auth2.default.currentUser.moveMaisId;
	      if (!moveMaisId) {
	        s.error = "Não foi possível identificar o usuário. Tente novamente.";
	        return;
	      }
	
	      s.loading = true;
	
	      var isReplaceTag = this.orderResult && this.orderResult.salesType === "REPLACETAG";
	
	      var handleSuccess = function handleSuccess(resp) {
	        var ok = resp && resp.status === 0 || resp && resp.code === 0 || resp && resp.status && resp.status.code === 0 || resp && resp.salesOrder;
	        if (ok) {
	          s.success = true;
	        } else {
	          s.error = _constantes2.default.MSG_02_TAG_NOT_FOUND;
	        }
	      };
	
	      var handleError = function handleError() {
	        s.error = _constantes2.default.MSG_02_TAG_NOT_FOUND;
	      };
	
	      var done = function done() {
	        s.loading = false;
	      };
	
	      if (isReplaceTag) {
	        var vehicleForReq = (0, _assign2.default)({}, vehicle, {
	          tagSerialNumber: onlyNumbers,
	          tag: null
	        });
	        var _payload = {
	          moveMaisId: moveMaisId,
	          contractId: this.contractId,
	          deliveryAddressId: this.address && this.address.addressId,
	
	          contractPaymentMethod: this.skipPaymentFlow ? undefined : this.cpm,
	          value: this.totalComDesconto,
	          _interface: "WEBSITE",
	          vehicles: [vehicleForReq],
	          shipmentType: 4,
	          logisticsDistribution: null,
	          salesTypeExt: "SOL_TAG"
	        };
	        return _sales2.default.requestTagReplacement(_payload, { skipCheckout: true }).then(handleSuccess).catch(handleError).then(done);
	      }
	
	      var payload = {
	        plate: vehicle.plate,
	        modelId: vehicle.model && vehicle.model.modelId,
	        categoryArtespId: vehicle.categoryAxes && vehicle.categoryAxes.categoryAxesId,
	        tagSerialNumber: onlyNumbers,
	        moveMaisId: moveMaisId,
	        contractId: this.contractId
	      };
	      if (this.shipmentType == 4) {
	        payload.sales_type = "SOL_TAG";
	      }
	
	      return _tag2.default.activateTagSite(payload).then(handleSuccess).catch(handleError).then(done);
	    },
	    loadPaymentMethodAuthorizations: function loadPaymentMethodAuthorizations(taxIdNumber) {
	      var _this6 = this;
	
	      if (this.skipPaymentFlow) {
	        this.paymentMethodsAuthorized = {};
	        return;
	      }
	      if (!taxIdNumber) {
	        this.paymentMethodsAuthorized = {};
	        return;
	      }
	
	      _financial2.default.getPaymentMethodUnauthorized(taxIdNumber).then(function (authResponse) {
	        var authMethods = authResponse.data.data.paymentMethods;
	
	        _this6.paymentMethodsAuthorized = {};
	
	        authMethods.forEach(function (method) {
	          _this6.paymentMethodsAuthorized[method.shortName] = method.authorized === 1;
	        });
	
	        _this6.$nextTick(function () {
	          _this6.$forceUpdate();
	        });
	      }).catch(function (error) {
	        console.error('Erro ao buscar autorizações:', error);
	        _this6.paymentMethodsAuthorized = {};
	        _this6.$nextTick(function () {
	          _this6.$forceUpdate();
	        });
	      });
	    },
	    getPrazoEntrega: function getPrazoEntrega() {
	      var _this7 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return _axios2.default.get("/v2/prazo-entrega/" + _this7.address.zipCode).then(function (res) {
	                  _this7.prazoEntrega = res.data.prazoEntrega;
	                });
	
	              case 2:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this7);
	      }))();
	    },
	    addNewAddress: function addNewAddress() {
	      this.showModal = true;
	      $("#modal-address").modal("show");
	    },
	    deliveryAddress: function deliveryAddress(fn) {
	
	      this.address = fn;
	    },
	    allAddresses: function allAddresses(addresses) {
	
	      this.addresses = addresses;
	    },
	    showConfirmModal: function showConfirmModal() {
	      var _this8 = this;
	
	      if (this.skipPaymentFlow) {
	        return _promise2.default.resolve("YES");
	      }
	
	      var vm = this;
	      if (this.cpm.paymentMethod.paymentMethodId != 120) {
	        $("#modalPurchase").modal();
	        $("#modalPurchase").on("hidden.bs.modal", function (e) {
	          vm.resolveConfirm("NO");
	        });
	      } else {
	        $("#modalPurchase").modal();
	        $("#modalPurchase").modal("hide");
	        $("#modalPurchase").on("hidden.bs.modal", function (e) {
	          vm.resolveConfirm("YES");
	        });
	      }
	
	      return new _promise2.default(function (resolve, reject) {
	        _this8.resolveConfirm = resolve;
	      });
	    },
	    endModal: function endModal(option) {
	      $("#modalPurchase").on("hidden.bs.modal", function (e) {});
	      $("#modalPurchase").modal("hide");
	      this.resolveConfirm(option);
	    },
	    formatAddress: function formatAddress() {
	      return this.address.address + " " + this.address.number + ", " + this.address.city;
	    },
	    getCurrentBalance: function getCurrentBalance() {
	      return (0, _number.cents)(this.contract.currentBalance.currentBalance);
	    },
	    getPayment: function getPayment() {
	      if (this.skipPaymentFlow) {
	        return undefined;
	      }
	      return this.cpm;
	    },
	    getInfos: function getInfos() {
	      var _this9 = this;
	
	      this.address.whereToDelivery = this.whereToDelivery;
	
	      if (this.shipmentType == 4 && !this.anyTagActivationSuccess) {
	        _messageDialog2.default.show({
	          title: "Ativação da TAG",
	          message: "Informe e valide o número da TAG para continuar."
	        });
	        return _promise2.default.reject("");
	      }
	
	      if (this.cupom && this.order.promotionCode != this.cupom) {
	
	        _messageDialog2.default.show({
	          title: 'Cupom inválido',
	          message: 'Por favor coloque um cupom válido ou remova o cupom inválido'
	        });
	
	        return _promise2.default.reject('');
	      }
	
	      if (this.requiresAdhesionTermsAcceptance && !this.termsAccepted) {
	        this.termsAdhesionShowError = true;
	        _messageDialog2.default.show({
	          title: "Termos de contratação",
	          message: "É necessário ler e concordar com os termos para realizar a adesão"
	        });
	        this.$nextTick(function () {
	          var el = document.getElementById("terms");
	          if (el && el.scrollIntoView) {
	            el.scrollIntoView({ behavior: "smooth", block: "center" });
	          }
	        });
	        return _promise2.default.reject("");
	      }
	      this.termsAdhesionShowError = false;
	
	      if (!this.showAddress) {
	        return _promise2.default.resolve({
	          promotionCode: this.cupom,
	          whereToDelivery: this.whereToDelivery,
	          shipmentType: this.shipmentType
	        });
	      }
	      if (this.showAddress && !this.shipmentType && !this.orderResult.salesType == 'MIGRATIONPLAN' && (this.orderResult.planId == 21 || this.orderResult.planId == 22)) {
	        _messageDialog2.default.show({
	          title: "Forma de envio",
	          message: "Favor selecionar a forma de envio"
	        });
	        return _promise2.default.reject("");
	      }
	      var message = "";
	      if (this.isCaminhoParana) {
	        message = ' Confirma a retirada da(s) tag(s) na Base de apoio operacional da Concessionária Caminhos do Paraná. \nRodovia 277, Km 249, 700\nIrati - PR?\nAtendimento: Segunda a Sexta, das 8 às 17 h. <br><br> <div class="info-block-box"><div class="inline"><img src="static/exclamation-mark.png" alt="" width="40px"></div><p class="inline">Para utilizar nossos serviços e fazer novas recargas, você deve primeiro ativar sua(s) TAG(s) que está a caminho.</p></div>';
	      } else if (this.whereToDelivery != "0") {
	        message = 'Confirma retirada das TAGs no(a) ' + this.nameDelivery[this.whereToDelivery] + '?<br><br> <div class="info-block-box"><div class="inline"><img src="static/exclamation-mark.png" alt="" width="40px"></div><p class="inline">Para utilizar nossos serviços e fazer novas recargas, você deve primeiro ativar sua(s) TAG(s) que está a caminho.</p></div>';
	      } else if (this.shipmentType != null && this.shipmentType == 3) {
	        message = 'Confirma a retirada da TAG em mãos em um Parceiro Move Mais?';
	      } else if (this.orderResult.salesType == 'MIGRATIONPLAN') {
	        message = 'Deseja prosseguir com a migração?';
	      } else if (this.skipPaymentFlow) {
	        message = 'Confirma a entrega da(s) TAG(s) no endereço: ' + this.formatAddress() + '?';
	      } else {
	        message = 'Após a aprovação do seu pagamento, você receberá seu(s) TAG(s) no endereço: ' + this.formatAddress();
	      }
	
	      return this.showConfirmModal().then(function (e) {
	        if (e == "YES" && _this9.shipmentType != null && _this9.shipmentType == 3) {
	          return {
	            address: _this9.address,
	            allAddresses: _this9.addresses,
	            promotionCode: _this9.cupom,
	            whereToDelivery: _this9.whereToDelivery,
	            shipmentType: _this9.shipmentType,
	            tagSerialNumber: (_this9.tagInHandStates.find(function (s) {
	              return s && s.success;
	            }) || {}).serialNumber || ""
	          };
	        } else if (e == "YES") {
	          return {
	            address: _this9.address,
	            allAddresses: _this9.addresses,
	            promotionCode: _this9.cupom,
	            whereToDelivery: _this9.whereToDelivery,
	            shipmentType: _this9.shipmentType,
	            tagSerialNumber: (_this9.tagInHandStates.find(function (s) {
	              return s && s.success;
	            }) || {}).serialNumber || ""
	          };
	        } else return _promise2.default.reject("");
	      }).catch(function () {});
	    },
	    toogleModal: function toogleModal() {
	      this.showVehicle = !this.showVehicle;
	    },
	    canReprocess: function canReprocess() {
	      return !this.expiredCardDate && this.orderResult.status.statusId == 3 && parseInt(this.dataCorteReprocessamento) < new Date().getTime() || this.orderResult.paymentMethod.type == "BC" && !this.orderResult.bankBillUrl && this.orderResult.price > 0;
	    },
	    showModalReprocessPayout: function showModalReprocessPayout() {
	      this.showModal = true;
	    },
	    isDescont: function isDescont(product, value) {
	      return product.productId == 11 ? -1 * value : value;
	    },
	    showVehiclesPlates: function showVehiclesPlates(product) {
	      var productsException = [1, 4, 6];
	      return this.orderResult.promotionCode != "CAMINHOSDOPARANA" && productsException.indexOf(product.productId) !== -1;
	    },
	    goToOrders: function goToOrders(sucess) {
	      this.$router.push({
	        name: "requests"
	      });
	    },
	    getTolls: function getTolls(state, associateId) {
	      var _this10 = this;
	
	      this.loading = _toll2.default.getTollsByState(state).then(function (res) {
	        _this10.entries = _.filter(res, function (o) {
	          return o.associateId == associateId;
	        });
	        _this10.showEntries = true;
	      }).catch(function (err) {});
	    },
	    calculateDiscount: function calculateDiscount() {
	      var _this11 = this;
	
	      var findRecharge = this.order.products.find(function (product) {
	        return product.productId == 2;
	      });
	      var valueByPlan = this.order.planId == 22 ? 9999 : this.order.planId == 32 ? 24999 : 0;
	      var checkBfParams = this.disableBf && findRecharge.valueTotal < valueByPlan ? true : false;
	      if (!checkBfParams) {
	        this.erroCupom = "";
	        var resolveTemp = undefined;
	
	        var promotionCode = this.cupom;
	        this.setPromotion(this.cupom);
	        var planId = this.orderResult.planId;
	        var request = {
	          promotionCode: promotionCode,
	          planId: planId
	        };
	        request.salesType = this.order.salesType;
	
	        var discountRecharge = undefined;
	        var discountAdhesion = undefined;
	        var countDiscount = 0;
	
	        var promise = _sales2.default.calculateDiscount(request).then(function (response) {
	          discountAdhesion = response;
	          if (discountAdhesion && [51, 52].indexOf(_this11.planId) !== -1) {
	            _this11.descontoCupom = _this11.rechargeTaxTotal;
	          } else if (discountAdhesion) {
	            if (discountAdhesion.productId == _constantes2.default.SALES_TYPE.ADHESION || discountAdhesion.productId == _constantes2.default.SALES_TYPE.GUARANTEE || discountAdhesion.productId == _constantes2.default.SALES_TYPE.ADHESIONVEHICLEADDITIONAL) {
	              var qtd = discountAdhesion.discountLimit == 0 ? _this11.order.vehicles.length : Math.min(_this11.order.vehicles.length, discountAdhesion.discountLimit);
	              _this11.descontoCupom = qtd * discountAdhesion.valueUnitDiscount;
	            } else {
	              _this11.descontoCupom = discountAdhesion.valueUnitDiscount;
	            }
	          }
	          if (_this11.descontoCupom > 0) {
	            var d = _this11.order.products.find(function (o) {
	              return o.productId == 11;
	            });
	            if (d) {
	              d.valueTotal = -1 * _this11.descontoCupom;
	              d.valueUnit = -1 * _this11.descontoCupom;
	            } else {
	              _this11.order.products.push({
	                productId: 11,
	                productName: "DESCONTO",
	                quantity: 1,
	                valueTotal: -1 * _this11.descontoCupom,
	                valueUnit: -1 * _this11.descontoCupom
	              });
	            }
	          }
	
	          _this11.setPromotion(_this11.cupom);
	          _this11.calculateTotal();
	        }).catch(function (e) {
	
	          _this11.erroCupom = "Desconto não existe.";
	          _this11.setPromotion(undefined);
	        });
	
	        this.$store.dispatch("loading", promise);
	      } else {
	        this.erroCupom = 'Valor da recarga não atende os requisitos para esse cupom.';
	      }
	    },
	    handleInputChange: function handleInputChange() {
	      this.erroCupom = "";
	    },
	    removeDiscount: function removeDiscount() {
	      this.descontoCupom = 0;
	      this.setPromotion(undefined);
	
	      var i = this.order.products.findIndex(function (o) {
	        return o.productId == 11;
	      });
	      if (i > 0) {
	        this.order.products.splice(i, 1);
	      }
	
	      this.calculateTotal();
	      this.cupom = "";
	      this.erroCupom = "";
	    },
	    setPromotion: function setPromotion(code) {
	      if (this.order.promotionCode != "CAMINHOSDOPARANA") {
	        this.order.promotionCode = code;
	        if (!code) {
	          this.order.promotionCode = undefined;
	        }
	      }
	    },
	    calculateTotal: function calculateTotal() {
	      var t = 0;
	      this.order.products.forEach(function (o) {
	        t += parseFloat(o.valueTotal);
	      });
	      this.totalComDesconto = t;
	      this.order.totalComDesconto = t;
	    },
	    checkValueMinForBF: function checkValueMinForBF() {
	      var findRecharge = this.order.products.find(function (product) {
	        return product.productId == 2;
	      });
	      if (findRecharge) {
	        var promoCode = 'FR0';
	        var valueByPlan = this.order.planId == 22 ? 9999 : this.order.planId == 32 ? 24999 : 0;
	        if (findRecharge.valueTotal > valueByPlan) {
	          var qtdPromo = (0, _trunc2.default)(findRecharge.valueTotal / valueByPlan);
	          var promoCodeFull = qtdPromo > 9 ? promoCode = 'FR' + qtdPromo : promoCode + qtdPromo;
	
	          return promoCodeFull;
	        }
	      }
	    },
	    blackFridayCheck: function blackFridayCheck() {
	      var _this12 = this;
	
	      var promoCodeFull = this.checkValueMinForBF();
	      if (promoCodeFull) {
	        var reqD = {
	          promotionCode: promoCodeFull,
	          planId: this.order.planId,
	          salesType: this.order.salesType
	        };
	        _sales2.default.calculateDiscount(reqD).then(function (response) {
	          _this12.promoBF = true;
	          if (response.valid == 1) {
	            _this12.cupom = promoCodeFull;
	            _this12.setPromotion(promoCodeFull);
	            _this12.calculateDiscount();
	          }
	        });
	      }
	    },
	    calculatePercentValid: function calculatePercentValid() {
	      if (this.contract) {
	        var percentRechargeValue = void 0;
	        if (this.contract.plan.newPlanId == 22) {
	          percentRechargeValue = 0.4;
	        } else if (this.contract.plan.newPlanId == 32) {
	          percentRechargeValue = 0.3;
	        }
	        this.percentValid = this.resultBalance < this.contract.rechargeValue * percentRechargeValue;
	        return this.percentValid;
	      }
	    }
	  },
	  components: {
	    Payment: _payment2.default,
	    modalAddress: _modalAddress2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _creditCard = __webpack_require__(529);
	
	var _creditCard2 = _interopRequireDefault(_creditCard);
	
	var _bankAccount = __webpack_require__(528);
	
	var _bankAccount2 = _interopRequireDefault(_bankAccount);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _eventBus = __webpack_require__(25);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var typeOptions = [{ caption: "Débito em conta", value: "DC" }, { caption: "Cartão de crédito", value: "AD" }];
	
	exports.default = {
	  props: ['planId', 'arrayCartao', 'addressMailing'],
	  data: function data() {
	    return {
	      address: undefined,
	      loading: undefined,
	      creditCard: undefined,
	      bankAccount: undefined,
	      itemSelected: undefined,
	      valueCard: undefined,
	      valueBank: undefined,
	      type: undefined,
	      typeOptions: typeOptions,
	      creditAddress: undefined,
	      addressStart: undefined,
	
	      typesAllowed: { bankAccount: true, creditCard: true }
	    };
	  },
	
	
	  computed: {
	    colClassPayment: function colClassPayment() {
	      return 'col-md-6';
	    }
	  },
	
	  methods: {
	    getPayment: function getPayment() {
	      if (this.type == 'CC') {
	        this.$refs.creditCard.getPayment();
	      } else if (this.type == 'DC') {
	        _eventBus.EventBus.$emit('setPayment', this.bankAccount);
	      }
	    },
	    limiteCredito: function limiteCredito() {
	      if (this.type == 'CC') {
	
	        if (this.planId == 21 || this.planId == 31) {
	          if (!this.arrayCartao) return true;
	          if (this.arrayCartao.length < 3) {
	            return true;
	          } else {
	            _messageDialog2.default.show({
	              title: "Atenção",
	              message: "O limite maximo de (3) cartões cadastrados foi atingido, para excluir alguma forma de pagamento, por favor, entre em contato com nossa central de relacionamento."
	            });
	            return false;
	          }
	        } else return true;
	      }
	    }
	  },
	  watch: {
	    type: function type() {}
	  },
	
	
	  components: { CreditCard: _creditCard2.default, BankAccount: _bankAccount2.default }
	};

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _string = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['user'],
	  data: function data() {
	    return {
	      emailConfirmed: undefined,
	      cellConfirmed: undefined,
	      tokenCellphone: undefined,
	      tokenEmail: undefined,
	      cellphoneSent: false,
	      emailSent: undefined,
	      errorCell: undefined,
	      errorEmail: undefined,
	      resentCell: undefined,
	      resentEmail: undefined
	    };
	  },
	
	
	  computed: {
	    confirmCellphone: function confirmCellphone() {
	      return this.$store.getters.getConfirmCellphone();
	    },
	    confirmEmail: function confirmEmail() {
	      return this.$store.getters.getConfirmEmail();
	    },
	    showCellphone: function showCellphone() {
	      return this.confirmCellphone && !this.isCellConfirmed;
	    },
	    showEmail: function showEmail() {
	      return this.confirmEmail && !this.isEmailConfirmed && (this.isCellConfirmed || !this.confirmCellphone);
	    },
	    cellUser: function cellUser() {
	      return this.user && this.user.dddCellphone + this.user.nroCellphone;
	    },
	    emailUser: function emailUser() {
	      return this.user && this.user.accountAuthentication && this.user.accountAuthentication.login;
	    },
	    isEmailConfirmed: function isEmailConfirmed() {
	      return !!this.emailConfirmed && this.emailConfirmed == this.emailUser;
	    },
	    isCellConfirmed: function isCellConfirmed() {
	      return !!this.cellConfirmed && this.cellConfirmed == this.cellUser;
	    },
	    celFormated: function celFormated() {
	      return (0, _string.phone)(this.user.dddCellphone + this.user.nroCellphone);
	    }
	  },
	
	  watch: {},
	
	  methods: {
	    isOK: function isOK() {
	      if (this.confirmEmail && !this.isEmailConfirmed || this.isCellConfirmed && !this.confirmCellphone) {
	        this.tokenCellphone = undefined;
	        this.tokenEmail = undefined;
	        $('#modal-2fa').modal({ backdrop: 'static', keyboard: false });
	        if (this.confirmCellphone) {
	          this.sendCellphone();
	        } else if (this.confirmEmail) {
	          this.sendEmail();
	        }
	        return false;
	      }
	
	      return true;
	    },
	    sendCellphone: function sendCellphone() {
	      var _this = this;
	
	      if (this.cellphoneSent == false) {
	        this.errorCell = undefined;
	        this.resentCell = undefined;
	        this.tokenCellphone = undefined;
	        _auth2.default.tokenGenerateResendNew(this.user.taxIdNumber, 'ADHESION_NEW_PHONE', this.cellUser).then(function (resp) {
	          _this.cellphoneSent = true;
	          _this.resentCell = true;
	        }).catch(function (err) {
	          return _this.errorCell = err.data && err.data.status && err.data.status.message;
	        });
	      } else this.sendEmail();
	    },
	    confirmCellphoneOTP: function confirmCellphoneOTP() {
	      var _this2 = this;
	
	      this.errorCell = undefined;
	      this.resentCell = undefined;
	      _auth2.default.twoFactorAuthenticationNew(this.user.taxIdNumber, this.tokenCellphone, 'ADHESION_NEW_PHONE', this.cellUser).then(function (resp) {
	        console.log('celular: ' + _this2.cellUser + ' confirmado!');
	        _this2.cellConfirmed = _this2.cellUser;
	        if (_this2.confirmEmail && !_this2.isEmailConfirmed) {
	          _this2.sendEmail();
	        } else {
	          $('#modal-2fa').modal('hide');
	          _this2.$emit('nextStep');
	          return true;
	        }
	      }).catch(function (err) {
	        return _this2.errorCell = err.data && err.data.status && err.data.status.message;
	      });
	    },
	    sendEmail: function sendEmail() {
	      var _this3 = this;
	
	      this.errorEmail = undefined;
	      this.resentEmail = undefined;
	      this.tokenEmail = undefined;
	      _auth2.default.tokenGenerateResendNew(this.user.taxIdNumber, 'ADHESION_NEW_EMAIL', this.emailUser).then(function (resp) {
	        console.log(resp);
	        _this3.emailphoneSent = true;
	        _this3.resentEmail = true;
	      }).catch(function (err) {
	        return _this3.errorEmail = err.data && err.data.status && err.data.status.message;
	      });;
	    },
	    confirmEmailOTP: function confirmEmailOTP() {
	      var _this4 = this;
	
	      this.errorEmail = undefined;
	      this.resentEmail = undefined;
	      _auth2.default.twoFactorAuthenticationNew(this.user.taxIdNumber, this.tokenEmail, 'ADHESION_NEW_EMAIL', this.emailUser).then(function (resp) {
	        console.log(resp);
	        console.log('e-mail: ' + _this4.emailUser + ' confirmado!');
	        _this4.emailConfirmed = _this4.emailUser;
	        _this4.$emit('nextStep');
	        $('#modal-2fa').modal('hide');
	        return true;
	      }).catch(function (err) {
	        return _this4.errorEmail = err.data && err.data.status && err.data.status.message;
	      });;;
	    },
	    resetSentCellPhone: function resetSentCellPhone() {
	      this.cellphoneSent = false;
	      this.tokenCellphone = undefined;
	    }
	  },
	  components: {}
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _choosePlan = __webpack_require__(160);
	
	var _choosePlan2 = _interopRequireDefault(_choosePlan);
	
	var _chooseRecharge = __webpack_require__(161);
	
	var _chooseRecharge2 = _interopRequireDefault(_chooseRecharge);
	
	var _userData = __webpack_require__(527);
	
	var _userData2 = _interopRequireDefault(_userData);
	
	var _companyData = __webpack_require__(228);
	
	var _companyData2 = _interopRequireDefault(_companyData);
	
	var _vehicles = __webpack_require__(118);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	var _payment = __webpack_require__(1979);
	
	var _payment2 = _interopRequireDefault(_payment);
	
	var _summary = __webpack_require__(1980);
	
	var _summary2 = _interopRequireDefault(_summary);
	
	var _objects = __webpack_require__(44);
	
	var obj = _interopRequireWildcard(_objects);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _success = __webpack_require__(47);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _error = __webpack_require__(67);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _messageDialog = __webpack_require__(53);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _utils = __webpack_require__(34);
	
	var Utils = _interopRequireWildcard(_utils);
	
	var _eventBus = __webpack_require__(25);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subs = ['', 'Queremos saber mais sobre a empresa, por gentileza, informe os dados abaixo:', 'Informe a forma de pagamento:', ''];
	
	exports.default = {
	  props: ['type'],
	  data: function data() {
	    return {
	      account: undefined,
	      address: obj.address(),
	      contract: obj.contract(),
	
	      vehicles: [],
	      step: 0,
	      subtitle: subs,
	      msgError: undefined,
	      loading: undefined,
	      success: false,
	      code: undefined,
	      boletoUrl: undefined,
	      showRecharge: true,
	      planId: 6,
	      lead: undefined,
	      minValue: 200000
	    };
	  },
	
	
	  computed: {
	    payment: function payment() {
	      return this.contract.paymentMethods.paymentMethod[0];
	    },
	    qtdAllowed: function qtdAllowed() {
	      return _constantes2.default.LIMIT_VEHICLES;
	    },
	    request: function request() {
	      var vm = this;
	      var request = {
	        "_interface": window.document.webview ? "MOBILE" : "WEBSITE",
	        account: vm.account,
	        addresses: {
	          address: [vm.address]
	        },
	        contract: vm.contract,
	        listVehicle: {
	          vehicle: vm.vehicles
	        },
	        value: undefined
	      };
	      return request;
	    },
	    isPJ: function isPJ() {
	      if (this.lead) return this.lead.typeTaxId == 'COMPANY';
	
	      return _constantes2.default.isPJ(this.planId);
	    },
	    isCaminhoParana: function isCaminhoParana() {
	      return !!this.lead;
	    },
	    plan: function plan() {
	      return this.$store.getters.getPlanById(this.planId);
	    },
	    planName: function planName() {
	      return this.plan && this.plan.name;
	    },
	    newAdhesionTax: function newAdhesionTax() {
	      return this.$store.getters.getNewAdhesionTax(this.planId);
	    },
	    newVehicleTax: function newVehicleTax() {
	      return this.$store.getters.getNewVehicleTax(this.planId);
	    },
	    guaranteeTax: function guaranteeTax() {
	      return this.$store.getters.getGuaranteeTax(this.planId);
	    },
	    bankAccountOptions: function bankAccountOptions() {
	      return this.$store.getters.getBankAccountOptions(this.planId);
	    },
	    creditCardOptions: function creditCardOptions() {
	      return this.$store.getters.getCreditCardOptions(this.planId);
	    },
	    bankBillOption: function bankBillOption() {
	      return this.$store.getters.getBankBillOption(this.planId);
	    },
	    tedOption: function tedOption() {
	      return this.$store.getters.getTedOption(this.planId);
	    },
	    docOption: function docOption() {
	      return this.$store.getters.getDocOption(this.planId);
	    }
	  },
	
	  watch: {
	    $route: function $route() {
	
	      this.planId = this.$route.query.planId;
	      this.account = this.isPJ ? obj.companyAccount() : obj.account();
	      this.account.taxIdNumber = this.$route.query.taxIdNumber;
	      this.account.taxIdNumberFormatted = this.formatTaxId(this.$route.query.taxIdNumber);
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.contract.plan.planId = this.planId;
	    this.$store.commit('resetLoading');
	
	    if (window.ga) window.ga('send', 'pageview', 'adesao/etapa-embarcador');
	
	    sessionStorage.removeItem('lead');
	
	    this.$store.commit('currentPlanId', this.planId);
	
	    if (!this.account) {
	
	      this.account = this.isPJ ? obj.companyAccount() : obj.account();
	
	      if (this.lead) {
	        this.address = obj.address();
	        this.account.taxIdNumber = this.lead.taxpayerIdNumber;
	        this.account.accountAuthentication.login = this.lead.contactEmail;
	        this.address.zipCode.zipCode = this.lead.zipCode;
	        var leadTels = this.lead.phone ? this.lead.phone.split(';') : [];
	
	        if (leadTels.length && leadTels[0].length > 2) {
	          leadTels[0] = leadTels[0].replace(/[^0-9]/g, '').replace(/^0/, '');
	          this.account.telephones.telephone[1].ddd = leadTels[0].substring(0, 2);
	          this.account.telephones.telephone[1].numberPhone = leadTels[0].substring(2);
	        }
	
	        if (this.isPJ) {
	          this.account.company.companyName = this.lead.companyName;
	          this.account.company.companyTradeName = this.lead.companyName;
	          this.account.taxIdNumberFormatted = this.lead.taxpayerIdNumber.replace(/(\w{2})(\w{3})(\w{3})(\w{4})(\w{2})/, '$1.$2.$3/$4-$5');
	        } else {
	          this.account.person.fullName = this.lead.companyName;
	          this.account.taxIdNumberFormatted = this.lead.taxpayerIdNumber.replace(/(\w{3})(\w{3})(\w{3})(\w{2})/, '$1.$2.$3-$4');
	        }
	      }
	    }
	
	    this.getPlanInfo();
	    this.$on('goToStep', function (value) {
	      _this.step = value;
	    });
	
	    _eventBus.EventBus.$on('cleanErrors', function () {
	      _this.msgError = undefined;
	    });
	  },
	  mounted: function mounted() {
	    var vm = this;
	  },
	
	
	  methods: {
	    nextStep: function nextStep() {
	      var _this2 = this;
	
	      this.msgError = undefined;
	      $('body').stop().animate({
	        scrollTop: 0
	      }, '500', 'swing');
	      switch (this.step) {
	        case 0:
	          var p = void 0;
	          if (this.planId == 31 || this.planId == 32 || this.planId == 5) {
	            p = this.$refs.chooseRecharge.validateAll();
	          } else {
	            p = this.$refs.choosePlan.validateAll();
	          }
	          p.then(function (r) {
	            _this2.step += 1;
	          }).catch(function (err) {
	
	            if (_this2.planId == 2 || _this2.planId == 3) _this2.msgError = 'Infome um CPF ou CNPJ válido para continuar';else _this2.msgError = 'Por favor verifique o valor de recarga';
	          });
	          break;
	        case 1:
	          this.$refs.userData.validateAll().then(function (r) {
	            _this2.step += 1;
	          }).catch(function (err) {
	            _this2.msgError = 'Por favor verifique os campos com erro';
	          });
	          break;
	        case 2:
	          this.$refs.payment.validateAll().then(function (r) {
	            _this2.step += 1;
	          }).catch(function (err) {
	            _this2.msgError = 'Por favor verifique os campos com erro';
	          });
	          break;
	        case 3:
	
	          break;
	      }
	
	      if (window.ga && !this.msgError) window.ga('send', 'pageview', 'adesao/etapa' + (this.step + 1));
	    },
	    backStep: function backStep() {
	      if (this.step == 0) {
	        this.cancelar();
	        return;
	      }
	
	      this.msgError = undefined;
	      $('body').stop().animate({
	        scrollTop: 0
	      }, '500', 'swing');
	      this.step -= 1;
	    },
	    cancelar: function cancelar() {
	      var _this3 = this;
	
	      _messageDialog2.default.show({
	        title: 'Cancelar Adesão',
	        message: 'Deseja cancelar a adesão?',
	        type: 'OK-CANCEL-ADHESION'
	      }).then(function (res) {
	        if (res == 'OK') {
	          sessionStorage.removeItem("lead");
	          if (_this3.planId && _this3.getKindPlan(_this3.planId) == 'RNTRC') _this3.$router.push({ name: 'home' });else if (_this3.isPJ) _this3.$router.push({ name: 'services-b2b' });else _this3.$router.push({ name: 'services-b2c' });
	        }
	      });
	    },
	    getPlanInfo: function getPlanInfo() {},
	    doRequest: function doRequest() {
	      var _this4 = this;
	
	      this.$refs.summary.validateAll().then(function (r) {
	        var promise = _sales2.default.adhesion(_this4.request).then(function (r) {
	          _this4.code = r.status.code;
	          _this4.boletoUrl = r.boletoUrl;
	          $('body').stop().animate({
	            scrollTop: 0
	          }, '500', 'swing');
	        }).catch(function (err) {
	          _this4.msgError = err.data.status.message;
	          _this4.code = err.data.status.code;
	          $('body').stop().animate({
	            scrollTop: 0
	          }, '500', 'swing');
	        });
	
	        _this4.$store.dispatch('loading', promise);
	      });
	    },
	    goToStep: function goToStep(value) {
	      this.code = undefined;
	      this.step = value;
	    },
	    nextParana: function nextParana(plan) {
	      if (plan == 'man') {
	        this.contract.plan.planId = this.planId = this.lead.typeTaxId == 'COMPANY' ? 37 : 35;
	      } else {
	        this.contract.plan.planId = this.planId = this.lead.typeTaxId == 'COMPANY' ? 38 : 36;
	      }
	      this.$store.commit('currentPlanId', this.contract.plan.planId);
	
	      this.nextStep();
	    }
	  },
	  components: {
	    choosePlan: _choosePlan2.default,
	    chooseRecharge: _chooseRecharge2.default,
	    userData: _userData2.default,
	    vehicles: _vehicles2.default,
	    payment: _payment2.default,
	    summaryComp: _summary2.default,
	    successPage: _success2.default,
	    errorPage: _error2.default,
	    companyData: _companyData2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _choosePlan = __webpack_require__(160);
	
	var _choosePlan2 = _interopRequireDefault(_choosePlan);
	
	var _chooseRecharge = __webpack_require__(161);
	
	var _chooseRecharge2 = _interopRequireDefault(_chooseRecharge);
	
	var _userData = __webpack_require__(527);
	
	var _userData2 = _interopRequireDefault(_userData);
	
	var _companyData = __webpack_require__(228);
	
	var _companyData2 = _interopRequireDefault(_companyData);
	
	var _vehicles = __webpack_require__(118);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	var _genericSummary = __webpack_require__(85);
	
	var _genericSummary2 = _interopRequireDefault(_genericSummary);
	
	var _objects = __webpack_require__(44);
	
	var obj = _interopRequireWildcard(_objects);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _success = __webpack_require__(47);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _error = __webpack_require__(67);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _messageDialog = __webpack_require__(53);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _utils = __webpack_require__(34);
	
	var Utils = _interopRequireWildcard(_utils);
	
	var _eventBus = __webpack_require__(25);
	
	var _adhesionConfirm2fa = __webpack_require__(1992);
	
	var _adhesionConfirm2fa2 = _interopRequireDefault(_adhesionConfirm2fa);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subs = ['', 'Queremos saber mais sobre você, por gentileza, informe os seus dados abaixo:', 'Cadastre os veículos que irão utilizar o plano:', 'Confira e confirme os dados do seu pedido:', ''];
	
	exports.default = {
	  props: ['type'],
	  data: function data() {
	    return {
	      checkPlanArray: [31, 32, 5, 64],
	      step: 0,
	      subtitle: subs,
	      msgError: undefined,
	      loading: undefined,
	      success: false,
	      code: undefined,
	      planId: undefined,
	      lead: undefined,
	      minValue: 200000,
	      promotionCode: undefined,
	      salesOrder: undefined,
	      request: {
	        "_interface": window.document.webview ? "MOBILE" : "WEBSITE",
	        account: obj.account(),
	        address: obj.address(),
	        contract: obj.contract(),
	        changeFlagEmail: obj.contract().changeFlagEmail,
	        listVehicle: {
	          vehicle: []
	        },
	        value: undefined,
	        whereToDelivrey: "0",
	        promotionCode: undefined,
	        shipmentType: undefined
	      },
	      salesResponse: undefined,
	      validacaoFraude: undefined,
	      isMobile: false,
	      isRechargeSelected: false
	    };
	  },
	
	
	  computed: {
	    vehicles: function vehicles() {
	      return this.request.listVehicle.vehicle;
	    },
	    checkPlan: function checkPlan() {
	      return this.checkPlanArray.indexOf(this.planId) !== -1;
	    },
	    qtdAllowed: function qtdAllowed() {
	      return _constantes2.default.LIMIT_VEHICLES;
	    },
	    isPJ: function isPJ() {
	      if (this.lead) return this.lead.typeTaxId == 'COMPANY';
	
	      return _constantes2.default.isPJ(this.planId);
	    },
	    isCaminhoParana: function isCaminhoParana() {
	      return !!this.lead;
	    },
	    plan: function plan() {
	      return this.$store.getters.getPlanById(this.planId);
	    },
	    planName: function planName() {
	      return this.plan && this.plan.name;
	    },
	    newAdhesionTax: function newAdhesionTax() {
	      return this.$store.getters.getNewAdhesionTax(this.planId);
	    },
	    newVehicleTax: function newVehicleTax() {
	      return this.$store.getters.getNewVehicleTax(this.planId);
	    },
	    guaranteeTax: function guaranteeTax() {
	      return this.$store.getters.getGuaranteeTax(this.planId);
	    },
	    account: function account() {
	      return this.request.account;
	    },
	    address: function address() {
	      return this.request.address;
	    },
	    contract: function contract() {
	      return this.request.contract;
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.$store.commit('resetLoading');
	
	    if (window.ga) window.ga('send', 'pageview', 'adesao/etapa1');
	
	    this.lead = sessionStorage.getItem('lead') ? JSON.parse(sessionStorage.getItem('lead')) : undefined;
	    if (this.lead) this.lead.plates = this.lead.listVehicle.toUpperCase().replace(/(\w{3})(\d{4})/g, '$1-$2').split(/;/);
	
	    sessionStorage.removeItem('lead');
	    sessionStorage.removeItem("showed-reprocess");
	
	    if (!this.$route.query.planId && !this.lead) {
	      this.$router.push({
	        name: 'home'
	      });
	      return;
	    }
	
	    this.planId = parseInt(this.$route.query.planId || 36);
	    this.$store.commit('currentPlanId', this.planId);
	
	    if (!this.account || !this.account.taxIdNumber) {
	      this.request.account = this.isPJ ? obj.companyAccount() : obj.account();
	
	      if (this.lead) {
	        this.request.account.taxIdNumber = this.lead.taxpayerIdNumber;
	        this.request.account.accountAuthentication.login = this.lead.contactEmail;
	        this.address.zipCode = this.lead.zipCode;
	        var leadTels = this.lead.phone ? this.lead.phone.split(';') : [];
	
	        if (leadTels.length && leadTels[0].length > 2) {
	          leadTels[0] = leadTels[0].replace(/[^0-9]/g, '').replace(/^0/, '');
	          this.request.account.dddCellphone = leadTels[0].substring(0, 2);
	          this.request.account.nroCellphone = leadTels[0].substring(2);
	        }
	
	        if (this.isPJ) {
	          this.request.account.company.companyName = this.lead.companyName;
	          this.request.account.company.companyTradeName = this.lead.companyName;
	          this.request.account.taxIdNumberFormatted = this.lead.taxpayerIdNumber.replace(/(\w{2})(\w{3})(\w{3})(\w{4})(\w{2})/, '$1.$2.$3/$4-$5');
	        } else {
	          this.request.account.person.fullName = this.lead.companyName;
	          this.request.account.taxIdNumberFormatted = this.lead.taxpayerIdNumber.replace(/(\w{3})(\w{3})(\w{3})(\w{2})/, '$1.$2.$3-$4');
	        }
	      }
	    }
	
	    _eventBus.EventBus.$on('cleanErrors', function () {
	      _this.msgError = undefined;
	    });
	  },
	
	
	  mounted: function mounted() {
	    var _this2 = this;
	
	    if (window.innerWidth <= 769) {
	      this.isMobile = true;
	    } else {
	      this.isMobile = false;
	    }
	    window.addEventListener('resize', function () {
	      return window.innerWidth <= 769 ? _this2.isMobile = true : _this2.isMobile = false;
	    });
	
	    var vm = this;
	    var el = $(this.$el);
	    el.find('.question-box h4').click(function () {
	      el.find('.open').removeClass('open');
	      $(this).find('i').addClass('open');
	      $(this).parent().find('.answer-box').addClass('open');
	    });
	  },
	
	  methods: {
	    handleValorSelecionado: function handleValorSelecionado(valor) {
	      if (!valor) {
	        this.isRechargeSelected = false;
	      } else {
	        this.isRechargeSelected = true;
	      }
	    },
	    checkTypePlan: function checkTypePlan() {
	      if (this.planId >= 35 && this.planId <= 38) {
	        return;
	      }
	
	      this.request.account = this.isPJ ? obj.companyAccount() : obj.account();
	      this.request.account.taxIdNumber = this.$route.query.taxIdNumber;
	      this.request.account.taxIdNumberFormatted = this.formatTaxId(this.$route.query.taxIdNumber);
	    },
	    nextStep: function nextStep() {
	      var _this3 = this;
	
	      this.msgError = undefined;
	      $('body').stop().animate({
	        scrollTop: 0
	      }, '500', 'swing');
	      switch (this.step) {
	        case 0:
	          var p = void 0;
	          var refPlan = void 0;
	          if (this.planId == 31 || this.planId == 32 || this.planId == 5 || this.planId == 64) {
	            refPlan = this.$refs.chooseRecharge;
	            this.loading = p = refPlan.validateAll();
	          } else {
	            refPlan = this.$refs.choosePlan;
	            this.loading = p = refPlan.validateAll();
	          }
	          p.then(function (r) {
	            _this3.sendPageView();
	            _this3.checkTypePlan();
	            if (refPlan && refPlan.getCoupon) {
	              var couponValue = refPlan.getCoupon();
	              if (couponValue) {
	                _this3.request.coupon = couponValue;
	              } else {
	                delete _this3.request.coupon;
	              }
	            }
	            _this3.step += 1;
	          }).catch(function (err) {
	            if (err === 'Cupom inválido') {
	              _this3.msgError = 'Cupom inválido. Verifique o código informado.';
	            } else if (_this3.planId == 2 || _this3.planId == 3) {
	              _this3.msgError = 'Infome um CPF ou CNPJ válido para continuar';
	            } else {
	              _this3.msgError = 'Por favor verifique o valor de recarga';
	            }
	          });
	          break;
	        case 1:
	          this.loading = this.$refs.userData.validateAll().then(function (r) {
	            if (_this3.$refs.confirm2fa.isOK()) {
	              _this3.sendPageView();
	              _this3.contract.plan.name = _this3.plan.name;
	              _this3.step += 1;
	            }
	          }).catch(function (err) {
	            _this3.msgError = "Por favor verifique os campos com erro";
	          });
	          break;
	        case 2:
	          this.sendPageView();
	          if (this.vehicles.length > 0 || this.planId == 6 || this.planId == 8) {
	            this.generateSalesOrder();
	            this.step += 1;
	          } else {
	            this.msgError = 'Adicione ao menos um veículo para continuar';
	          }
	          break;
	        case 3:
	          this.sendPageView();
	          break;
	      }
	    },
	    sendPageView: function sendPageView() {
	      if (window.ga) window.ga('send', 'pageview', 'adesao/etapa' + (this.step + 2));
	    },
	    backStep: function backStep() {
	      if (this.step == 0) {
	        this.cancelar();
	        return;
	      }
	
	      if (this.step == 1) {
	        delete this.request.coupon;
	      }
	
	      this.msgError = undefined;
	      $('body').stop().animate({
	        scrollTop: 0
	      }, '500', 'swing');
	      this.step -= 1;
	    },
	    cancelar: function cancelar() {
	      var _this4 = this;
	
	      _messageDialog2.default.show({
	        title: 'Cancelar Adesão',
	        message: 'Deseja cancelar a adesão?',
	        type: 'OK-CANCEL-ADHESION'
	      }).then(function (res) {
	        if (res == 'OK') {
	          sessionStorage.removeItem("lead");
	          if (window.ga) window.ga('send', 'pageview', 'adesao/cancelou');
	          if (_this4.planId && _this4.getKindPlan(_this4.planId) == 'RNTRC') _this4.$router.push({
	            name: 'home'
	          });else if (_this4.isPJ) _this4.$router.push({
	            name: 'services-b2b'
	          });else _this4.$router.push({
	            name: 'services-b2c'
	          });
	        }
	      });
	    },
	    doRequest: function doRequest() {
	      var _this5 = this;
	
	      delete this.request.contractPaymentMethod;
	      delete this.request.contract.paymentMethods;
	
	      var url_atual = window.location.href;
	
	      if (url_atual != "") {
	        var regexp = new RegExp(/\S+pdv\S+/i);
	        var n = regexp.test(url_atual);
	        if (n) {
	          this.request["promotionCode"] = "GRAALKM29";
	          this.request["logisticsDistribution"] = "FOB";
	        }
	      }
	
	      if (Utils.isCaminhoParana(this.planId)) {
	        this.request["promotionCode"] = "CAMINHOSDOPARANA";
	        this.request["logisticsDistribution"] = "FOB";
	      } else if (this.promotionCode) {
	        this.request["promotionCode"] = this.promotionCode;
	      }
	
	      if (this.request["whereToDelivrey"] != "0") {
	        this.request["promotionCode"] = this.request["whereToDelivrey"];
	        this.request["logisticsDistribution"] = "FOB";
	      }
	
	      if (this.request["shipmentType"] == 3) {
	        this.request["logisticsDistribution"] = "FOB";
	      };
	
	      this.request.contract.lcFlag = this.request.contract.lcFlag ? 1 : 0;
	
	      this.loading = _sales2.default.adhesion(this.request).catch(function (err) {
	        var data = err && err.data || {};
	        var status = data.status || {};
	        _this5.code = status.code;
	        _this5.msgError = status.message || data.message || 'Não foi possível concluir a adesão.';
	        _this5.salesResponse = undefined;
	        if (window.ga) window.ga("send", "pageview", "adesao/erro");
	        $("body").stop().animate({ scrollTop: 0 }, "500", "swing");
	      });
	      this.$store.dispatch('loading', this.loading);
	    },
	    nextParana: function nextParana(plan) {
	      if (plan == 'man') {
	        this.contract.plan.planId = this.planId = this.lead.typeTaxId == 'COMPANY' ? 37 : 35;
	      } else {
	        this.contract.plan.planId = this.planId = this.lead.typeTaxId == 'COMPANY' ? 38 : 36;
	      }
	
	      this.$store.commit('currentPlanId', this.contract.plan.planId);
	
	      this.nextStep();
	    },
	    startRequest: function startRequest() {
	      var _this6 = this;
	
	      this.$refs.GenericSummary.getInfos().then(function (r) {
	        _this6.request.address = r.address;
	        _this6.promotionCode = r.promotionCode;
	        _this6.request.shipmentType = r.shipmentType;
	        _this6.doRequest();
	      });
	    },
	    generateSalesOrder: function generateSalesOrder() {
	
	      var value = this.vehicles.length * this.newAdhesionTax + this.vehicles.length * this.guaranteeTax;
	
	      this.salesOrder = {
	        "_interface": "WEBSITE",
	        "planId": this.planId,
	        "status": null,
	        "type": "ADHESION",
	        "salesType": "ADHESION",
	        "taxpayerIdSeller": null,
	        "promotionCode": null,
	        "price": value,
	        "logisticsDistribution": null,
	        "bankBillUrl": null,
	        "transactionPassageId": null,
	        "vehicleId": null,
	        "shipment": null,
	        "vehicles": this.vehicles,
	        "shipmentType": this.request.shipmentType,
	        "products": [{
	          "productId": 1,
	          "productName": "ADESÃO",
	          "valueUnit": this.newAdhesionTax,
	          "quantity": this.vehicles.length,
	          "valueTotal": value
	        }]
	      };
	
	      if (this.isCaminhoParana) {
	        this.salesOrder["promotionCode"] = "CAMINHOSDOPARANA";
	        this.salesOrder["logisticsDistribution"] = "FOB";
	      } else if (sessionStorage.getItem('promotionCode')) {
	        this.promotionCode = sessionStorage.getItem('promotionCode');
	        this.salesOrder["promotionCode"] = this.promotionCode;
	      }
	
	      if (true) {
	        if (this.planId != 6) {
	          this.salesOrder.products.push({
	            "productId": 2,
	            "productName": "RECARGA",
	            "valueUnit": this.contract.rechargeValue,
	            "quantity": 1,
	            "valueTotal": this.contract.rechargeValue
	          });
	          this.salesOrder.products.push({
	            "productId": 3,
	            "productName": "TAXA DE RECARGA",
	            "valueUnit": this.contract.tax,
	            "quantity": 1,
	            "valueTotal": this.contract.tax
	          });
	
	          this.salesOrder.price += this.contract.tax + this.contract.rechargeValue;
	        }
	      }
	    }
	  },
	  components: {
	    choosePlan: _choosePlan2.default,
	    chooseRecharge: _chooseRecharge2.default,
	    userData: _userData2.default,
	    vehicles: _vehicles2.default,
	    successPage: _success2.default,
	    errorPage: _error2.default,
	    companyData: _companyData2.default,
	    GenericSummary: _genericSummary2.default,
	    adhesionConfirm2fa: _adhesionConfirm2fa2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _support = __webpack_require__(241);
	
	var _support2 = _interopRequireDefault(_support);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _mapaParceiros = __webpack_require__(2004);
	
	var _mapaParceiros2 = _interopRequireDefault(_mapaParceiros);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subject = [{
	  value: '1',
	  valueId: '8',
	  caption: 'Auto Peças'
	}, {
	  value: '2',
	  valueId: '8',
	  caption: 'Centro Automotivo'
	}, {
	  value: '3',
	  valueId: '8',
	  caption: 'Comércio de Pneus'
	}, {
	  value: '4',
	  valueId: '8',
	  caption: 'Concessionária de Veículos'
	}, {
	  value: '5',
	  valueId: '8',
	  caption: 'Corretora de Seguros'
	}, {
	  value: '6',
	  valueId: '8',
	  caption: 'Pátio de Veículos'
	}, {
	  value: '7',
	  valueId: '8',
	  caption: 'Reparo de Parabrisas'
	}, {
	  value: '8',
	  valueId: '8',
	  caption: 'Revenda de Veículos'
	}, {
	  value: '9',
	  valueId: '8',
	  caption: 'Vistoria Veícular'
	}, {
	  value: '10',
	  valueId: '8',
	  caption: 'Outros'
	}];
	
	exports.default = {
	  data: function data() {
	    return {
	      faleConosco: {},
	      formState: 'NEW',
	      errorMessage: '',
	      subject: subject,
	      subjects: '1',
	      loading: undefined,
	      cep: undefined,
	      listaConveniados: [],
	      listaMapa: [],
	      endereco: undefined,
	      conveniado: undefined
	    };
	  },
	
	  computed: {},
	  created: function created() {},
	  mounted: function mounted() {},
	
	  watch: {
	    cep: function cep() {
	      if (this.cep == null || this.cep == "") {
	        this.endereco = null;
	        this.listaConveniados = [];
	        this.listaMapa = [];
	      }
	    }
	  },
	  methods: {
	    doRequest: function doRequest() {
	      var _this = this;
	
	      this.formState = 'NEW';
	      this.$validator.validateAll().then(function (success) {
	        _this.faleConosco.assunto = subject.find(function (s) {
	          return s.value == _this.faleConosco.assuntoId;
	        }).caption;
	        _this.faleConosco.assuntoId = subject.find(function (s) {
	          return s.value == _this.faleConosco.assuntoId;
	        }).valueId;
	        _this.loading = _support2.default.faleConosco(_this.faleConosco).then(function (data) {
	          if (data) _this.formState = 'SUCCESS';
	        }).catch(function (err) {
	          _this.formState = 'ERROR';
	          _this.errorMessage = err.data && err.data.status && err.data.status.message || "Ocorreu um erro, por favor tente novamente";
	        });
	      });
	    },
	    buscaParceiros: function buscaParceiros() {
	      if (this.cep && this.cep != "") {
	        this.endereco = this.cep;
	      } else {
	        _messageDialog2.default.show({
	          title: 'Aviso',
	          message: 'Por favor digite um número de CEP válido!',
	          headerClass: 'modal-info'
	        });
	      }
	    },
	    addMapa: function addMapa(conveniado) {
	      if (conveniado.latitude && conveniado.longitude) {
	        var end = _.find(this.listaMapa, function (l) {
	          return l.nomeFantasia == conveniado.nomeFantasia;
	        });
	        if (!end) {
	          this.conveniado = conveniado;
	        }
	      } else {
	        _messageDialog2.default.show({
	          title: 'Aviso',
	          message: 'Parceiro não possui as coordenadas cadastradas',
	          headerClass: 'modal-info'
	        });
	      }
	    },
	    listaProximos: function listaProximos(lat, lng) {
	      var _this2 = this;
	
	      var req = {
	        lat: lat,
	        lng: lng
	      };
	      _account2.default.buscaConveniadosProximos(req).then(function (res) {
	        var lista = res.lista;
	        _this2.listaConveniados = [];
	        _this2.listaMapa = [];
	        if (lista.length > 0) {
	          _.each(lista, function (obj) {
	            if (obj.distancia < 1) obj.distancia = String(obj.distancia).substr(0, 4);else obj.distancia = Math.round(obj.distancia);
	            _this2.listaConveniados.push(obj);
	          });
	        } else {
	          _messageDialog2.default.show({
	            title: 'Aviso',
	            message: 'Não existem parceiros próximos no raio de 100km!',
	            headerClass: 'modal-info'
	          });
	        }
	      });
	    },
	    mapeados: function mapeados(mapa) {
	      this.listaMapa = _.filter(this.listaMapa, function (l) {
	        return l.marcador != mapa.marcador;
	      });
	      this.listaMapa.push(mapa);
	    }
	  },
	  components: {
	    MapaParceiros: _mapaParceiros2.default
	  }
	};

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _support = __webpack_require__(241);
	
	var _support2 = _interopRequireDefault(_support);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subject = [{
	  value: '1',
	  valueId: '1',
	  caption: 'Vale Pedágio'
	}, {
	  value: '2',
	  valueId: '3',
	  caption: 'Adesão a Planos'
	}, {
	  value: '3',
	  valueId: '3',
	  caption: 'Compra de Tag'
	}, {
	  value: '4',
	  valueId: '3',
	  caption: 'Problema com Cobrança'
	}, {
	  value: '5',
	  valueId: '4',
	  caption: 'Problema com Tag'
	}, {
	  value: '6',
	  valueId: '5',
	  caption: 'Dúvida'
	}, {
	  value: '7',
	  valueId: '6',
	  caption: 'Elogio'
	}, {
	  value: '8',
	  valueId: '7',
	  caption: 'Marketing'
	}];
	
	exports.default = {
	  data: function data() {
	    return {
	      faleConosco: {},
	      formState: 'NEW',
	      errorMessage: '',
	      subject: subject,
	      subjects: '1',
	      loading: undefined
	    };
	  },
	
	  computed: {},
	  created: function created() {},
	  mounted: function mounted() {},
	
	  methods: {
	    doRequest: function doRequest() {
	      var _this = this;
	
	      this.formState = 'NEW';
	      this.$validator.validateAll().then(function (success) {
	        _this.faleConosco.assunto = subject.find(function (s) {
	          return s.value == _this.faleConosco.assuntoId;
	        }).caption;
	        _this.faleConosco.assuntoId = subject.find(function (s) {
	          return s.value == _this.faleConosco.assuntoId;
	        }).valueId;
	        _this.loading = _support2.default.faleConosco(_this.faleConosco).then(function (data) {
	          if (data) _this.formState = 'SUCCESS';
	        }).catch(function (err) {
	          _this.formState = 'ERROR';
	          _this.errorMessage = err.data && err.data.status && err.data.status.message || "Ocorreu um erro, por favor tente novamente";
	        });
	      });
	    }
	  },
	  components: {}
	};

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _stringify = __webpack_require__(70);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _map = __webpack_require__(121);
	
	var _map2 = _interopRequireDefault(_map);
	
	__webpack_require__(343);
	
	var _leaflet = __webpack_require__(345);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _address = __webpack_require__(238);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _googleMaps = __webpack_require__(93);
	
	var _googleMaps2 = _interopRequireDefault(_googleMaps);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CLASS_PIN_REGULAR = "pin";
	var CLASS_PIN_SELECTED = "pin-selected";
	
	var counterPinCache = new _map2.default();
	
	var counterPinTemplate = __webpack_require__(481);
	
	function createCounterPin(val, clazz) {
	  var key = (0, _stringify2.default)(arguments);
	
	  var pin = counterPinCache.get(key);
	  if (pin) return pin;
	
	  var pinSvg = $(counterPinTemplate);
	  pinSvg.find('#icon').addClass(clazz);
	
	  pinSvg.find('#value').addClass(clazz).text(val);
	
	  var _html = $('<div>').append($(pinSvg).clone()).html();
	  pin = "data:image/svg+xml;base64," + btoa(_html);
	  counterPinCache.set(key, pin);
	  return pin;
	}
	
	exports.default = {
	  props: ['endereco', 'conveniado'],
	
	  data: function data() {
	    return {
	      end: {
	        inicio: undefined,
	        end1: undefined,
	        linha1: undefined,
	        end2: undefined,
	        linha2: undefined,
	        end3: undefined,
	        linha3: undefined
	      },
	      count: 1,
	      map: undefined,
	      google: undefined,
	      geocoder: undefined
	    };
	  },
	
	
	  watch: {
	    conveniado: function conveniado() {
	      if (this.conveniado) {
	        var point = new _leaflet2.default.LatLng(this.conveniado.latitude, this.conveniado.longitude);
	
	        var pointList = [this.end.inicio.getLatLng(), point];
	        if (this.count == 1) {
	          if (this.end.end1) {
	            this.map.removeLayer(this.end.end1);
	            this.map.removeLayer(this.end.linha1);
	          }
	
	          var polyline = new _leaflet2.default.Polyline(pointList, {
	            color: 'blue',
	            weight: 4,
	            opacity: 0.5,
	            smoothFactor: 1
	          }).addTo(this.map);
	
	          var size = 50;
	          var marker = _leaflet2.default.marker([point.lat, point.lng], {
	            icon: _leaflet2.default.icon({
	              iconUrl: createCounterPin('P2', CLASS_PIN_SELECTED),
	              iconSize: [size, size]
	            })
	          }).addTo(this.map);
	
	          if (this.conveniado.domingo) {
	            var popup = "<b>Dias de funcionamento</b>" + "<br>Domingo: " + this.conveniado.domingo + "<br>Segunda: " + this.conveniado.segunda + "<br>Terca: " + this.conveniado.terca + "<br>Quarta: " + this.conveniado.quarta + "<br>Quinta: " + this.conveniado.quinta + "<br>Sexta: " + this.conveniado.sexta + "<br>Sabado: " + this.conveniado.sabado;
	
	            if (this.conveniado.infoAdd) {
	              popup = popup + "<br><br><b>Informações Adicionais</b><br>" + this.conveniado.infoAdd;
	            }
	            marker.bindPopup(popup).openPopup();
	          } else {
	            marker.bindPopup("<b>Dias de funcionamento</b><br>Não informado.").openPopup();
	          }
	
	          this.end.end1 = marker;
	          this.end.linha1 = polyline;
	          this.count = 2;
	
	          var mapa = {
	            marcador: 'P2',
	            nomeFantasia: this.conveniado.nomeFantasia,
	            numero: this.conveniado.numero
	          };
	          this.$emit('mapeados', mapa);
	        } else if (this.count == 2) {
	          if (this.end.end2) {
	            this.map.removeLayer(this.end.end2);
	            this.map.removeLayer(this.end.linha2);
	          }
	
	          var _polyline = new _leaflet2.default.Polyline(pointList, {
	            color: 'red',
	            weight: 4,
	            opacity: 0.5,
	            smoothFactor: 1
	          }).addTo(this.map);
	
	          var _size = 50;
	          var _marker = _leaflet2.default.marker([point.lat, point.lng], {
	            icon: _leaflet2.default.icon({
	              iconUrl: createCounterPin('P3', CLASS_PIN_SELECTED),
	              iconSize: [_size, _size]
	            })
	          }).addTo(this.map);
	
	          if (this.conveniado.domingo) {
	            var _popup = "<b>Dias de funcionamento</b>" + "<br>Domingo: " + this.conveniado.domingo + "<br>Segunda: " + this.conveniado.segunda + "<br>Terca: " + this.conveniado.terca + "<br>Quarta: " + this.conveniado.quarta + "<br>Quinta: " + this.conveniado.quinta + "<br>Sexta: " + this.conveniado.sexta + "<br>Sabado: " + this.conveniado.sabado;
	
	            if (this.conveniado.infoAdd) {
	              _popup = _popup + "<br><br><b>Informações Adicionais</b><br>" + this.conveniado.infoAdd;
	            }
	            _marker.bindPopup(_popup).openPopup();
	          } else {
	            _marker.bindPopup("<b>Dias de funcionamento</b><br>Não informado.").openPopup();
	          }
	
	          this.end.end2 = _marker;
	          this.end.linha2 = _polyline;
	          this.count = 3;
	
	          var _mapa = {
	            marcador: 'P3',
	            nomeFantasia: this.conveniado.nomeFantasia,
	            numero: this.conveniado.numero
	          };
	          this.$emit('mapeados', _mapa);
	        } else if (this.count == 3) {
	          if (this.end.end3) {
	            this.map.removeLayer(this.end.end3);
	            this.map.removeLayer(this.end.linha3);
	          }
	
	          var _polyline2 = new _leaflet2.default.Polyline(pointList, {
	            color: 'green',
	            weight: 4,
	            opacity: 0.5,
	            smoothFactor: 1
	          }).addTo(this.map);
	
	          var _size2 = 50;
	          var _marker2 = _leaflet2.default.marker([point.lat, point.lng], {
	            icon: _leaflet2.default.icon({
	              iconUrl: createCounterPin('P4', CLASS_PIN_SELECTED),
	              iconSize: [_size2, _size2]
	            })
	          }).addTo(this.map);
	
	          if (this.conveniado.domingo) {
	            var _popup2 = "<b>Dias de funcionamento</b>" + "<br>Domingo: " + this.conveniado.domingo + "<br>Segunda: " + this.conveniado.segunda + "<br>Terca: " + this.conveniado.terca + "<br>Quarta: " + this.conveniado.quarta + "<br>Quinta: " + this.conveniado.quinta + "<br>Sexta: " + this.conveniado.sexta + "<br>Sabado: " + this.conveniado.sabado;
	
	            if (this.conveniado.infoAdd) {
	              _popup2 = _popup2 + "<br><br><b>Informações Adicionais</b><br>" + this.conveniado.infoAdd;
	            }
	            _marker2.bindPopup(_popup2).openPopup();
	          } else {
	            _marker2.bindPopup("<b>Dias de funcionamento</b><br>Não informado.").openPopup();
	          }
	
	          this.end.end3 = _marker2;
	          this.end.linha3 = _polyline2;
	          this.count = 1;
	
	          var _mapa2 = {
	            marcador: 'P4',
	            nomeFantasia: this.conveniado.nomeFantasia,
	            numero: this.conveniado.numero
	          };
	          this.$emit('mapeados', _mapa2);
	        }
	      }
	    },
	    endereco: function endereco() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var _ref, _ref$data, logradouro, localidade;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (_this.end.inicio) _this.map.removeLayer(_this.end.inicio);
	                if (_this.end.end1) {
	                  _this.map.removeLayer(_this.end.end1);
	                  _this.map.removeLayer(_this.end.linha1);
	                }
	                if (_this.end.end2) {
	                  _this.map.removeLayer(_this.end.end2);
	                  _this.map.removeLayer(_this.end.linha2);
	                }
	                if (_this.end.end3) {
	                  _this.map.removeLayer(_this.end.end3);
	                  _this.map.removeLayer(_this.end.linha3);
	                }
	
	                _context.prev = 4;
	
	                if (_this.endereco) {
	                  _context.next = 7;
	                  break;
	                }
	
	                return _context.abrupt('return');
	
	              case 7:
	                _context.next = 9;
	                return _axios2.default.get('https://viacep.com.br/ws/' + _this.endereco.replaceAll('-', '') + '/json');
	
	              case 9:
	                _ref = _context.sent;
	                _ref$data = _ref.data;
	                logradouro = _ref$data.logradouro;
	                localidade = _ref$data.localidade;
	
	                if (!(!logradouro || !localidade)) {
	                  _context.next = 15;
	                  break;
	                }
	
	                throw new Error();
	
	              case 15:
	                _context.next = 17;
	                return _this.findAddressByGoogle(logradouro + ',' + localidade);
	
	              case 17:
	                _context.next = 25;
	                break;
	
	              case 19:
	                _context.prev = 19;
	                _context.t0 = _context['catch'](4);
	
	                if (_this.endereco) {
	                  _context.next = 23;
	                  break;
	                }
	
	                return _context.abrupt('return');
	
	              case 23:
	                _context.next = 25;
	                return _this.findAddressByGoogle(_this.endereco.replaceAll('-', ''));
	
	              case 25:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this, [[4, 19]]);
	      }))();
	    }
	  },
	  mounted: function mounted() {
	    this.map = _leaflet2.default.map(this.$el).setView([-23.533773, -46.625290], 15);
	
	    _leaflet2.default.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
	      maxZoom: 19,
	      attribution: '&copy;<a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
	    }).addTo(this.map);
	
	    var vm = this;
	    _googleMaps2.default.KEY = 'AIzaSyAzAwCX1zCJ9idWkNdxs39j36N4lAToIjE';
	    _googleMaps2.default.LIBRARIES = ['places'];
	    _googleMaps2.default.load(function (google) {
	      vm.google = google;
	      vm.geocoder = new google.maps.Geocoder();
	      vm.geocoder.geocode({ 'address': '14801525' }, function (results, status) {});
	    });
	  },
	
	
	  methods: {
	    findAddressByGoogle: function findAddressByGoogle(address) {
	      var vm = this;
	      vm.geocoder.geocode({ address: address }, function () {
	        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(results) {
	          var lat, lng, point, size, marker;
	          return _regenerator2.default.wrap(function _callee2$(_context2) {
	            while (1) {
	              switch (_context2.prev = _context2.next) {
	                case 0:
	                  try {
	                    lat = results[0].geometry.location.lat();
	                    lng = results[0].geometry.location.lng();
	                    point = new _leaflet2.default.LatLng(lat, lng);
	                    size = 50;
	                    marker = _leaflet2.default.marker([point.lat, point.lng], {
	                      icon: _leaflet2.default.icon({
	                        iconUrl: createCounterPin('P1', CLASS_PIN_REGULAR),
	                        iconSize: [size, size]
	                      })
	                    }).addTo(vm.map);
	
	
	                    vm.end.inicio = marker;
	                    vm.map.panTo(point);
	                    vm.$emit('listaProximos', lat, lng);
	                  } catch (e) {
	                    _messageDialog2.default.show({
	                      title: 'Aviso',
	                      message: 'CEP invalido!',
	                      headerClass: 'modal-info'
	                    });
	                  }
	
	                case 1:
	                case 'end':
	                  return _context2.stop();
	              }
	            }
	          }, _callee2, this);
	        }));
	
	        return function (_x) {
	          return _ref2.apply(this, arguments);
	        };
	      }());
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      taxpayerIdNumber: '',
	      contactName: '',
	      contactEmail: '',
	      contactJobTitle: '',
	      companyName: '',
	      sizeOfFleetVehicle: '',
	      formState: 'NEW',
	      errorMessage: '',
	      loading: undefined,
	      leadClient: false
	    };
	  },
	
	  computed: {},
	  created: function created() {
	    var promo = this.$route.query.oferta;
	
	    if (promo) {
	      window.sessionStorage.setItem('promo', promo);
	    }
	  },
	  mounted: function mounted() {},
	
	
	  methods: {
	    doRequest: function doRequest() {
	      var _this = this;
	
	      var vm = this;
	      vm.formState = 'NEW';
	      try {
	
	        vm.loading = vm.$validator.validateAll().then(function (success) {
	          var request = {
	            lead: {
	              taxpayerIdNumber: vm.taxpayerIdNumber.replace(/[.\-\/]/g, '').toUpperCase(),
	              contactName: vm.contactName,
	              contactEmail: vm.contactEmail,
	              phone: vm.contactJobTitle.replace(/[^\d]+/g, ''),
	              companyName: vm.companyName,
	              sizeOfFleetVehicle: vm.sizeOfFleetVehicle,
	              "source": window.document.webview ? "MOBILE" : "WEBSITE"
	            }
	          };
	
	          var promo = window.sessionStorage.getItem('promo');
	          if (promo) request.lead.campaign = promo;
	
	          if (_this.$route.query.plano) request.lead.plan = _this.$route.query.plano;
	
	          var taxpayerIdNumber = vm.taxpayerIdNumber.replace(/[.\-\/]/g, '').toUpperCase();
	          var proposal = '';
	          var promises = [];
	          promises.push(_sales2.default.getLead({ taxpayerIdNumber: taxpayerIdNumber, proposal: proposal }));
	          promises.push(_account2.default.accountExists({ taxIdNumber: vm.taxpayerIdNumber.replace(/[.\-\/]/g, '').toUpperCase() }));
	
	          return _promise2.default.all(promises).then(function (response) {
	
	            var statusProposal = ['TRIAGEM', 'PROSPECÇÃO'];
	
	            if (response[0].proposal && statusProposal.indexOf(response[0].proposal.listProposalStatus[0].status) !== -1) {
	              vm.formState = 'LEAD-INFO';
	              _this.leadClient = !response[1];
	              return _promise2.default.resolve(true);
	            }
	
	            if (response[0].lead && response[0].proposal && response[0].proposal.listProposalStatus[0].status == 'LEAD DESCARTADO') {
	              request.lead.leadId = response[0].lead.leadId;
	
	              var promise = [];
	              request.createProcess = "";
	              promise.push(_sales2.default.updateLead(request));
	              var leadId = request.lead.leadId;
	              promise.push(_sales2.default.createANewProposal({ leadId: leadId }));
	
	              return _promise2.default.all(promise).then(function (response) {
	
	                vm.formState = 'SUCCESS';
	              });
	            }
	
	            return _sales2.default.createLead(request).then(function (data) {
	              if (data) vm.formState = 'SUCCESS';
	            }).catch(function (err) {
	              vm.formState = 'ERROR';
	              vm.errorMessage = err.data && err.data.status && err.data.status.message || "Ocorreu um erro, por favor tente novamente";
	            });
	          }).catch(function (err) {});
	        }).catch(function (err) {
	
	          vm.formState = 'ERROR';
	          vm.errorMessage = 'Campos obrigatórios não foram preenchidos!';
	        });
	      } catch (e) {}
	    }
	  },
	
	  components: {}
	};

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _eventBus = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['type'],
	  data: function data() {
	    return {
	      loading: undefined
	    };
	  },
	
	
	  computed: {
	    getNewAdhesionTax: function getNewAdhesionTax() {
	      return this.$store.getters.getNewAdhesionTax(_constantes2.default.PLAN_PRE_AUT_MEN_SODRE_PF);
	    },
	    getReplaceTax: function getReplaceTax() {
	      return this.$store.getters.getReplaceTax(_constantes2.default.PLAN_PRE_AUT_MEN_SODRE_PF);
	    },
	    getNewVehicleTax: function getNewVehicleTax() {
	      return this.$store.getters.getNewVehicleTax(_constantes2.default.PLAN_PRE_AUT_MEN_SODRE_PF);
	    },
	    getMonthlyTax: function getMonthlyTax() {
	      return this.$store.getters.getMonthlyTax(_constantes2.default.PLAN_PRE_AUT_MEN_SODRE_PF);
	    }
	  },
	
	  methods: {
	    choose: function choose(planId) {
	      if (this.type == 'newContract') {
	        _eventBus.EventBus.$emit('chooseNewPlan', planId);
	      } else {
	        this.$router.push({ 'name': 'adhesion', 'query': { 'planId': planId } });
	      }
	    }
	  }
	};

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _eventBus = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['type', 'rodosol'],
	  data: function data() {
	    return {
	      loading: undefined
	    };
	  },
	
	
	  computed: {
	    sameTax: function sameTax() {
	      return this.newAhesionTaxMan == this.newVehicleTaxMan && this.newAhesionTaxAut == this.newVehicleTaxAut;
	    },
	    newAhesionTaxMan: function newAhesionTaxMan() {
	      return this.$store.getters.getNewAdhesionTax(_constantes2.default.PLAN_MAN_PJ);
	    },
	    newVehicleTaxMan: function newVehicleTaxMan() {
	      return this.$store.getters.getNewVehicleTax(_constantes2.default.PLAN_MAN_PJ);
	    },
	    newAhesionTaxAut: function newAhesionTaxAut() {
	      return this.$store.getters.getNewAdhesionTax(_constantes2.default.PLAN_AUT_PJ);
	    },
	    newVehicleTaxAut: function newVehicleTaxAut() {
	      return this.$store.getters.getNewVehicleTax(_constantes2.default.PLAN_AUT_PJ);
	    },
	    newVehicleTaxPos: function newVehicleTaxPos() {
	      return this.$store.getters.getNewVehicleTax(_constantes2.default.PLAN_POS);
	    },
	    newAhesionTaxPos: function newAhesionTaxPos() {
	      return this.$store.getters.getNewAdhesionTax(_constantes2.default.PLAN_POS);
	    },
	    newAhesionTaxPreMen: function newAhesionTaxPreMen() {
	      return this.$store.getters.getNewAdhesionTax(_constantes2.default.PLAN_PREMEN_PJ);
	    },
	    newVehicleTaxPreMen: function newVehicleTaxPreMen() {
	      return this.$store.getters.getNewVehicleTax(_constantes2.default.PLAN_PREMEN_PJ);
	    }
	  },
	
	  methods: {
	    choose: function choose(planId) {
	      if (this.type == 'newContract') {
	        _eventBus.EventBus.$emit('chooseNewPlan', planId);
	      } else if (this.type == 'migration') {
	        _eventBus.EventBus.$emit('migrationPlan', planId);
	      } else {
	        this.$router.push({ 'name': 'adhesion', 'query': { 'planId': planId } });
	      }
	    }
	  }
	};

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _eventBus = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['type'],
	  data: function data() {
	    return {
	      loading: undefined
	    };
	  },
	
	
	  computed: {
	    getNewAdhesionTax: function getNewAdhesionTax() {
	      return this.$store.getters.getNewAdhesionTax(_constantes2.default.PLAN_PRE_AUT_MEN_SODRE_PF);
	    },
	    getReplaceTax: function getReplaceTax() {
	      return this.$store.getters.getReplaceTax(_constantes2.default.PLAN_PRE_AUT_MEN_SODRE_PF);
	    },
	    getNewVehicleTax: function getNewVehicleTax() {
	      return this.$store.getters.getNewVehicleTax(_constantes2.default.PLAN_PRE_AUT_MEN_SODRE_PF);
	    },
	    getMonthlyTax: function getMonthlyTax() {
	      return this.$store.getters.getMonthlyTax(_constantes2.default.PLAN_PRE_AUT_MEN_SODRE_PF);
	    }
	  },
	
	  methods: {
	    choose: function choose(planId) {
	      if (this.type == 'newContract') {
	        _eventBus.EventBus.$emit('chooseNewPlan', planId);
	      } else {
	        this.$router.push({ 'name': 'adhesion', 'query': { 'planId': planId } });
	      }
	    }
	  }
	};

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _eventBus = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['type', 'rodosol'],
	  data: function data() {
	    return {
	      loading: undefined
	    };
	  },
	
	
	  computed: {
	    sameTax: function sameTax() {
	      return this.newAhesionTaxMan == this.newVehicleTaxMan && this.newAhesionTaxAut == this.newVehicleTaxAut;
	    },
	    newAhesionTaxCont: function newAhesionTaxCont() {
	      return this.$store.getters.getNewAdhesionTax(_constantes2.default.PLAN_MAN);
	    },
	    newVehicleTaxCont: function newVehicleTaxCont() {
	      return this.$store.getters.getNewVehicleTax(_constantes2.default.PLAN_MAN);
	    },
	    newAhesionTaxConf: function newAhesionTaxConf() {
	      return this.$store.getters.getNewAdhesionTax(_constantes2.default.PLAN_AUT);
	    },
	    newVehicleTaxConf: function newVehicleTaxConf() {
	      return this.$store.getters.getNewVehicleTax(_constantes2.default.PLAN_AUT);
	    },
	    newAhesionTaxSemC: function newAhesionTaxSemC() {
	      return 0;
	    },
	    newVehicleTaxSemC: function newVehicleTaxSemC() {
	      return 0;
	    },
	    guaranteeTaxSemC: function guaranteeTaxSemC() {
	      return 0;
	    },
	    newAhesionTaxPreMen: function newAhesionTaxPreMen() {
	      return this.$store.getters.getNewAdhesionTax(_constantes2.default.PLAN_PREMEN_PF);
	    },
	    newVehicleTaxPreMen: function newVehicleTaxPreMen() {
	      return this.$store.getters.getNewVehicleTax(_constantes2.default.PLAN_PREMEN_PF);
	    },
	    checkPromoSenff: function checkPromoSenff() {
	      if (sessionStorage.getItem('promoCheck') == '#SENFF2020') return true;
	    }
	  },
	
	  methods: {
	    choose: function choose(planId) {
	      if (this.type == 'newContract') {
	        _eventBus.EventBus.$emit('chooseNewPlan', planId);
	      } else if (this.type == 'migration') {
	        _eventBus.EventBus.$emit('migrationPlan', planId);
	      } else {
	        this.$router.push({ 'name': 'adhesion', 'query': { 'planId': planId } });
	      }
	    }
	  }
	};

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _contracts = __webpack_require__(22);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	var _eventBus = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['type', 'rodosol'],
	  data: function data() {
	    return {
	      loading: undefined,
	      urlMoveCargo: undefined
	    };
	  },
	  mounted: function mounted() {
	    this.geturlMoveCargo();
	  },
	
	
	  computed: {
	    sameTax: function sameTax() {
	      return this.newAhesionTaxMan == this.newVehicleTaxMan && this.newAhesionTaxAut == this.newVehicleTaxAut;
	    },
	    newAhesionTaxCont: function newAhesionTaxCont() {
	      return this.$store.getters.getNewAdhesionTax(_constantes2.default.PLAN_MAN);
	    }
	  },
	
	  methods: {
	    geturlMoveCargo: function geturlMoveCargo() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                try {
	                  _contracts2.default.getUrlMoveCargo().then(function (resp) {
	                    console.log(resp, "Resposta da url");
	                    _this.urlMoveCargo = resp.url;
	                  });
	                } catch (error) {
	                  console.error('Erro na requisição: ', error);
	                  alert('Erro na requisição: ' + error.message);
	                }
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    }
	  }
	
	};

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery, $) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      taxpayerIdNumber: '',
	      contactName: '',
	      contactEmail: '',
	      contactJobTitle: '',
	      companyName: '',
	      sizeOfFleetVehicle: '',
	      formState: 'NEW',
	      errorMessage: '',
	      loading: undefined,
	      leadClient: false
	    };
	  },
	
	  computed: {},
	  created: function created() {
	    var promo = this.$route.query.oferta;
	
	    if (promo) {
	      window.sessionStorage.setItem('promo', promo);
	    }
	  },
	  mounted: function mounted() {
	    (function ($) {
	      $.fn.countTo = function (options) {
	        options = options || {};
	
	        return $(this).each(function () {
	          var settings = $.extend({}, $.fn.countTo.defaults, {
	            from: $(this).data('from'),
	            to: $(this).data('to'),
	            speed: $(this).data('speed'),
	            refreshInterval: $(this).data('refresh-interval'),
	            decimals: $(this).data('decimals')
	          }, options);
	
	          var loops = Math.ceil(settings.speed / settings.refreshInterval),
	              increment = (settings.to - settings.from) / loops;
	
	          var self = this,
	              $self = $(this),
	              loopCount = 0,
	              value = settings.from,
	              data = $self.data('countTo') || {};
	
	          $self.data('countTo', data);
	
	          if (data.interval) {
	            clearInterval(data.interval);
	          }
	          data.interval = setInterval(updateTimer, settings.refreshInterval);
	
	          render(value);
	
	          function updateTimer() {
	            value += increment;
	            loopCount++;
	
	            render(value);
	
	            if (typeof settings.onUpdate == 'function') {
	              settings.onUpdate.call(self, value);
	            }
	
	            if (loopCount >= loops) {
	              $self.removeData('countTo');
	              clearInterval(data.interval);
	              value = settings.to;
	
	              if (typeof settings.onComplete == 'function') {
	                settings.onComplete.call(self, value);
	              }
	            }
	          }
	
	          function render(value) {
	            var formattedValue = settings.formatter.call(self, value, settings);
	            $self.html(formattedValue);
	          }
	        });
	      };
	
	      $.fn.countTo.defaults = {
	        from: 0,
	        to: 0,
	        speed: 1000,
	        refreshInterval: 100,
	        decimals: 0,
	        formatter: formatter,
	        onUpdate: null,
	        onComplete: null };
	
	      function formatter(value, settings) {
	        return value.toFixed(settings.decimals);
	      }
	    })(jQuery);
	
	    jQuery(function ($) {
	      $('.count-number').data('countToOptions', {
	        formatter: function formatter(value, options) {
	          return value.toFixed(options.decimals).replace(/\B(?=(?:\d{3})+(?!\d))/g, '.');
	        }
	      });
	
	      $('.timer').each(count);
	
	      function count(options) {
	        var $this = $(this);
	        options = $.extend({}, options || {}, $this.data('countToOptions') || {});
	        $this.countTo(options);
	      }
	    });
	  },
	
	
	  methods: {
	    scroll: function scroll() {
	      $('html, body').stop().animate({
	        scrollTop: $("#form").offset().top - 180
	      }, 1000);
	    },
	    doRequest: function doRequest() {
	      var _this = this;
	
	      var vm = this;
	      vm.formState = 'NEW';
	      try {
	
	        vm.loading = vm.$validator.validateAll().then(function (success) {
	          var request = {
	            lead: {
	              taxpayerIdNumber: vm.taxpayerIdNumber.replace(/[.\-\/]/g, '').toUpperCase(),
	              contactName: vm.contactName,
	              contactEmail: vm.contactEmail,
	              phone: vm.contactJobTitle.replace(/[^\d]+/g, ''),
	              companyName: vm.companyName,
	              sizeOfFleetVehicle: vm.sizeOfFleetVehicle,
	              "source": window.document.webview ? "MOBILE" : "WEBSITE"
	            }
	          };
	
	          var promo = window.sessionStorage.getItem('promo');
	          if (promo) request.lead.campaign = promo;
	
	          if (_this.$route.query.plano) request.lead.plan = _this.$route.query.plano;
	
	          var taxpayerIdNumber = vm.taxpayerIdNumber.replace(/[.\-\/]/g, '').toUpperCase();
	          var proposal = '';
	          var promises = [];
	          promises.push(_sales2.default.getLead({
	            taxpayerIdNumber: taxpayerIdNumber,
	            proposal: proposal
	          }));
	          promises.push(_account2.default.accountExists({
	            taxIdNumber: vm.taxpayerIdNumber.replace(/[.\-\/]/g, '').toUpperCase()
	          }));
	
	          return _promise2.default.all(promises).then(function (response) {
	
	            var statusProposal = ['TRIAGEM', 'PROSPECÇÃO'];
	
	            if (response[0].proposal && statusProposal.indexOf(response[0].proposal.listProposalStatus[0].status) !== -1) {
	              vm.formState = 'LEAD-INFO';
	              _this.leadClient = !response[1];
	              return _promise2.default.resolve(true);
	            }
	
	            if (response[0].lead && response[0].proposal && response[0].proposal.listProposalStatus[0].status == 'LEAD DESCARTADO') {
	              request.lead.leadId = response[0].lead.leadId;
	
	              var promise = [];
	              request.createProcess = "";
	              promise.push(_sales2.default.updateLead(request));
	              var leadId = request.lead.leadId;
	              promise.push(_sales2.default.createANewProposal({
	                leadId: leadId
	              }));
	
	              return _promise2.default.all(promise).then(function (response) {
	
	                vm.formState = 'SUCCESS';
	              });
	            }
	
	            return _sales2.default.createLead(request).then(function (data) {
	              if (data) vm.formState = 'SUCCESS';
	            }).catch(function (err) {
	              vm.formState = 'ERROR';
	              vm.errorMessage = err.data && err.data.status && err.data.status.message || "Ocorreu um erro, por favor tente novamente";
	            });
	          }).catch(function (err) {});
	        }).catch(function (err) {
	
	          vm.formState = 'ERROR';
	          vm.errorMessage = 'Campos obrigatórios não foram preenchidos!';
	        });
	      } catch (e) {}
	    }
	  },
	
	  components: {}
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5), __webpack_require__(5)))

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _messageDialog = __webpack_require__(14);
	
	var _messageDialog2 = _interopRequireDefault(_messageDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      taxpayerIdNumber: '',
	      contactName: '',
	      contactEmail: '',
	      contactJobTitle: '',
	      companyName: '',
	      sizeOfFleetVehicle: '',
	      formState: 'NEW',
	      errorMessage: '',
	      loading: '',
	      leadClient: false
	    };
	  },
	
	  computed: {},
	  created: function created() {
	    var promo = this.$route.query.oferta;
	
	    if (promo) {
	      window.sessionStorage.setItem('promo', promo);
	    }
	  },
	  mounted: function mounted() {},
	
	
	  methods: {
	    doRequest: function doRequest() {
	      var _this = this;
	
	      var vm = this;
	      vm.formState = 'NEW';
	      try {
	
	        vm.loading = vm.$validator.validateAll().then(function (success) {
	          var request = {
	            lead: {
	              taxpayerIdNumber: vm.taxpayerIdNumber.replace(/[.\-\/]/g, '').toUpperCase(),
	              contactName: vm.contactName,
	              contactEmail: vm.contactEmail,
	              phone: vm.contactJobTitle.replace(/[^\d]+/g, ''),
	              companyName: vm.companyName,
	              sizeOfFleetVehicle: vm.sizeOfFleetVehicle,
	              "source": window.document.webview ? "MOBILE" : "WEBSITE"
	            }
	          };
	
	          var promo = window.sessionStorage.getItem('promo');
	          if (promo) request.lead.campaign = promo;
	
	          if (_this.$route.query.plano) request.lead.plan = _this.$route.query.plano;
	
	          var taxpayerIdNumber = vm.taxpayerIdNumber.replace(/[.\-\/]/g, '').toUpperCase();
	          var proposal = '';
	          var promises = [];
	          promises.push(_sales2.default.getLead({ taxpayerIdNumber: taxpayerIdNumber, proposal: proposal }));
	          promises.push(_account2.default.accountExists({ taxIdNumber: vm.taxpayerIdNumber.replace(/[.\-\/]/g, '').toUpperCase() }));
	
	          return _promise2.default.all(promises).then(function (response) {
	
	            var statusProposal = ['TRIAGEM', 'PROSPECÇÃO'];
	
	            if (response[0].proposal && statusProposal.indexOf(response[0].proposal.listProposalStatus[0].status) !== -1) {
	              vm.formState = 'LEAD-INFO';
	              _this.leadClient = !response[1];
	              return _promise2.default.resolve(true);
	            }
	
	            if (response[0].lead && response[0].proposal && response[0].proposal.listProposalStatus[0].status == 'LEAD DESCARTADO') {
	              request.lead.leadId = response[0].lead.leadId;
	
	              var promise = [];
	              request.createProcess = "";
	              promise.push(_sales2.default.updateLead(request));
	              var leadId = request.lead.leadId;
	              promise.push(_sales2.default.createANewProposal({ leadId: leadId }));
	
	              return _promise2.default.all(promise).then(function (response) {
	                vm.formState = 'SUCCESS';
	              });
	            }
	
	            return _sales2.default.createLead(request).then(function (data) {
	              if (data) vm.formState = 'SUCCESS';
	            }).catch(function (err) {
	              vm.formState = 'ERROR';
	              vm.errorMessage = err.data && err.data.status && err.data.status.message || "Ocorreu um erro, por favor tente novamente";
	            });
	          }).catch(function (err) {});
	        }).catch(function (err) {
	
	          vm.formState = 'ERROR';
	          vm.errorMessage = 'Campos obrigatórios não foram preenchidos!';
	        });
	      } catch (e) {}
	    }
	  },
	
	  components: {}
	};

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var baseSvg = __webpack_require__(1705);
	
	exports.default = {
	  data: function data() {
	    return {
	      svg: undefined
	    };
	  },
	  mounted: function mounted() {
	    var vm = this;
	    this.svg = $(baseSvg);
	    this.svg.appendTo(this.$el);
	
	    this.svg.find("g[id]").on("click", function (e) {
	      vm.onClickState(this);
	    });
	  },
	
	
	  methods: {
	    onClickState: function onClickState(state) {
	      var self = $(state);
	
	      if (!self.find('.estado-active').length) return;
	
	      this.svg.find('.estado-active').removeClass('selected');
	      this.svg.find('.label-active').removeClass('selected');
	
	      self.find('.estado-active').addClass('selected');
	      self.find('.label-active').addClass('selected');
	
	      var uf = self.attr('id');
	      this.$emit('selected', uf);
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _rangeMap = __webpack_require__(2016);
	
	var _rangeMap2 = _interopRequireDefault(_rangeMap);
	
	var _toll = __webpack_require__(26);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  data: function data() {
	    return {
	      selected: undefined,
	      entries: undefined,
	      loading: undefined,
	      mapState: undefined,
	      bkEntries: undefined,
	      search: '',
	      pedagios: undefined
	    };
	  },
	
	
	  watch: {
	    selected: function selected(val) {
	      this.getTolls();
	    }
	  },
	
	  created: function created() {},
	
	  computed: {
	    entriesKey: function entriesKey() {
	      if (this.entries) return _.keys(this.entries);
	
	      return undefined;
	    }
	  },
	
	  mounted: function mounted() {
	    this.getListTolls();
	  },
	
	
	  methods: {
	    getListTolls: function getListTolls() {
	      var _this = this;
	
	      this.loading = _toll2.default.getListTolls().then(function (res) {
	
	        _this.pedagios = {};
	        for (var i = 0; i < res.length; i++) {
	          if (!_this.pedagios[res[i].state]) {
	            _this.pedagios[res[i].state] = {};
	          }
	          if (!_this.pedagios[res[i].state][res[i].associateFinancialId]) {
	            _this.pedagios[res[i].state][res[i].associateFinancialId] = [];
	          }
	          _this.pedagios[res[i].state][res[i].associateFinancialId].push(res[i]);
	        }
	
	        _this.entries = _.groupBy(res, 'associateFinancialId');
	        _this.mapState = _.groupBy(res, 'state');
	        _this.entriesKey = '';
	        _this.search = '';
	      }).catch(function (err) {});
	    },
	    getTolls: function getTolls() {
	      var _this2 = this;
	
	      this.loading = _toll2.default.getTollsByState(this.selected).then(function (res) {
	        _this2.bkEntries = res;
	        _this2.entries = _.groupBy(res, 'associateFinancialId');
	        _this2.search = '';
	        _this2.pedagios = '';
	      }).catch(function (err) {});
	    },
	    getImg: function getImg(id) {
	      return 'static/highway_managers/' + id + '.png';
	    },
	
	    filter: _.debounce(function () {
	      if (this.search == '') {
	        this.entries = _.groupBy(this.bkEntries, 'state');
	
	        return;
	      }
	
	      var s = this.search.toUpperCase();
	      this.entries = _.chain(this.bkEntries).filter(function (o) {
	        return o.associate.toUpperCase().indexOf(s) >= 0 || o.city.toUpperCase().indexOf(s) >= 0 || o.tipo.toUpperCase().indexOf(s) >= 0 || o.roadCode.toUpperCase().indexOf(s) >= 0 || o.km.toUpperCase().indexOf(s) >= 0;
	      }).groupBy('state').value();
	    }, 400)
	  },
	
	  components: {
	    RangeMap: _rangeMap2.default
	  }
	};

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	
	            status: undefined
	        };
	    },
	    mounted: function mounted() {
	        this.updateOrderStatus();
	    },
	
	    computed: {
	        order: function order() {
	            return this.$route.query.id;
	        }
	    },
	    methods: {
	        updateOrderStatus: function updateOrderStatus() {
	            var _this = this;
	
	            _sales2.default.updateSenffOrder(this.order).then(function (res) {
	                _this.status = res;
	                _this.goToRequests();
	            });
	        },
	        goToRequests: function goToRequests() {
	            this.$router.push({ name: 'requests' });
	        }
	    }
	};

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(49);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _partnerInformation = __webpack_require__(1886);
	
	var _partnerInformation2 = _interopRequireDefault(_partnerInformation);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _googleMaps = __webpack_require__(93);
	
	var _googleMaps2 = _interopRequireDefault(_googleMaps);
	
	var _address = __webpack_require__(238);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _partnerInformationModal = __webpack_require__(1885);
	
	var _partnerInformationModal2 = _interopRequireDefault(_partnerInformationModal);
	
	var _partnerInformationModalMobile = __webpack_require__(1884);
	
	var _partnerInformationModalMobile2 = _interopRequireDefault(_partnerInformationModalMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    PartnerInformation: _partnerInformation2.default,
	    partnerInformationModal: _partnerInformationModal2.default,
	    partnerInformationModalMobile: _partnerInformationModalMobile2.default
	  },
	  data: function data() {
	    return {
	      openMenu: false,
	      showInputCep: false,
	      showInputCity: false,
	      showGetCurrentLocalization: false,
	      showMsgEror: false,
	      showMsgErorFilter: false,
	      showHorarios: false,
	      msgError: '',
	      cep: '',
	      isMobile: false,
	      city: '',
	      range: 50,
	      moveMaisIdParceiroSelecionado: undefined,
	      maxRange: 150,
	      partners: [],
	      showHorariosMobile: false,
	      partnersFiltered: [],
	      userPosition: {
	        latitude: '',
	        longitude: ''
	      },
	      loading: false,
	      faqs: [{
	        ask: 'O que preciso apresentar para retirar o meu TAG?',
	        reply: 'Basta levar consigo um documento de identificação com foto (RG. CNH, CTPS ou Passaporte), documento do veículo (original, digital ou foto do documento); e o(s) voucher(s) impresso(s) ou gerado(s) digitalmente.'
	      }, {
	        ask: 'Posso pedir para outra pessoa retirar meu TAG?',
	        reply: 'Sim, você pode! Basta pedir à pessoa que leve um documento dela de identificação com foto, documento do veículo (original, digital ou foto do documento) e o(s) voucher(s) impresso(s) ou gerado(s) digitalmente.'
	      }, {
	        ask: 'Aonde posso pegar o meu TAG Move Mais?',
	        reply: 'Você pode retirar seu TAG em qualquer estabelecimento parceiro, basta ir ao de sua preferência com o(s) voucher(s) e documentos necessários.'
	      }, {
	        ask: 'Posso comprar o meu TAG no ponto de retirada?',
	        reply: 'Não! Nos pontos de retirada só é feito a entrega dos TAGs ao cliente, sendo necessária a apresentação do voucher de retirada, que é gerado somente após a realização da compra pelo nosso site. O processo de compra fica sob responsabilidade do usuário, responsabilizando o estabelecimento parceiro somente do ato de entrega do TAG.'
	      }]
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    window.addEventListener('scroll', function () {
	      return window.scrollY > 0 ? _this.isScrolling = true : _this.isScrolling = false;
	    });
	
	    if (window.innerWidth <= 769) {
	      this.isMobile = true;
	    } else {
	      this.isMobile = false;
	    }
	
	    var el = $(this.$el);
	    el.find('.question-box h4').click(function () {
	      el.find('.open').removeClass('open');
	      $(this).find('i').addClass('open');
	      $(this).parent().find('.answer-box').addClass('open');
	    });
	
	    _googleMaps2.default.KEY = 'AIzaSyAzAwCX1zCJ9idWkNdxs39j36N4lAToIjE';
	    _googleMaps2.default.LIBRARIES = ['places'];
	
	    _googleMaps2.default.load(function (google) {
	      var city = document.getElementById('city');
	      var cep = document.getElementById('cep');
	
	      var optionsCep = {
	        componentRestrictions: { country: ['BR'] },
	        types: ['(regions)'],
	        strictBounds: true
	      };
	
	      var optionsCity = (0, _extends3.default)({}, optionsCep, { types: ['(cities)'] });
	
	      var autocompleteCity = new google.maps.places.Autocomplete(city, optionsCity);
	      var autocompleteCep = new google.maps.places.Autocomplete(cep, optionsCep);
	
	      google.maps.event.addListener(autocompleteCity, 'place_changed', function () {
	        if (autocompleteCity.getPlace().formatted_address) {
	          _this.city = autocompleteCity.getPlace().formatted_address;
	        }
	        _this.searchByCity();
	      });
	
	      google.maps.event.addListener(autocompleteCep, 'place_changed', function () {
	        if (autocompleteCep.getPlace().name.length == 9) {
	          _this.cep = autocompleteCep.getPlace().name;
	          _this.searchByCep();
	        }
	      });
	    });
	  },
	
	
	  watch: {
	    range: function range() {
	      var _this2 = this;
	
	      if (this.partners.length > 0) {
	        this.partnersFiltered = this.partners.filter(function (p) {
	          return p.distancia <= _this2.range;
	        });
	
	        if (this.partnersFiltered.length == 0) {
	          this.msgError = 'Nenhum ponto de retirada encontrado nesta distância. Tente aumentar a distância da busca.';
	          this.showMsgErorFilter = true;
	          return;
	        }
	        this.showMsgErorFilter = false;
	        return;
	      }
	    }
	  },
	  methods: {
	    showInputCepFunc: function showInputCepFunc() {
	      if (this.showInputCep) {
	        this.showInputCep = false;
	      } else {
	        this.showInputCep = true;
	        setTimeout(function () {
	          return document.getElementById('cep').focus();
	        }, 1);
	      }
	      this.showInputCity = false;
	      this.showGetCurrentLocalization = false;
	      this.showMsgEror = false;
	      this.showMsgErorFilter = false;
	      this.partnersFiltered = [];
	    },
	    showInputCityFunc: function showInputCityFunc() {
	      if (this.showInputCity) {
	        this.showInputCity = false;
	      } else {
	        this.showInputCity = true;
	        setTimeout(function () {
	          return document.getElementById('city').focus();
	        }, 1);
	      }
	      this.showInputCep = false;
	      this.showGetCurrentLocalization = false;
	      this.showMsgEror = false;
	      this.showMsgErorFilter = false;
	      this.partnersFiltered = [];
	    },
	    showGetCurrentLocalizationFunc: function showGetCurrentLocalizationFunc() {
	      this.showGetCurrentLocalization = true;
	      this.showInputCep = false;
	      this.showInputCity = false;
	      this.showMsgEror = false;
	      this.showMsgErorFilter = false;
	      this.partnersFiltered = [];
	    },
	    preencheMoveMaisId: function preencheMoveMaisId(moveMaisId) {
	      this.moveMaisIdParceiroSelecionado = moveMaisId;
	    },
	    showModalHorarios: function showModalHorarios(value) {
	      if (value === 1 && !this.isMobile) {
	        this.showHorarios = true;
	        this.showHorariosMobile = false;
	      } else if (value === 1 && this.isMobile) {
	        this.showHorariosMobile = true;
	        this.showHorarios = false;
	      } else {
	        this.showHorarios = false;
	        this.showHorariosMobile = false;
	      }
	    },
	    fecharModalHorarios: function fecharModalHorarios(value) {
	      if (value == 1) {
	        this.showHorarios = false;
	        this.showHorariosMobile = false;
	      } else {
	        this.showHorarios = true;
	      }
	    },
	    hideMsgError: function hideMsgError() {
	      this.showMsgEror = false;
	      this.msgError = '';
	    },
	    searchByCep: function searchByCep() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var _ref, latitude, longitude;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	
	                _this3.hideMsgError();
	                _this3.partnersFiltered = [];
	                _this3.loading = true;
	
	                _context.prev = 3;
	                _context.next = 6;
	                return _this3.getLatLngGoogle(_this3.cep.replaceAll('-', ''));
	
	              case 6:
	                _ref = _context.sent;
	                latitude = _ref.latitude;
	                longitude = _ref.longitude;
	
	                _this3.userPosition = { latitude: latitude, longitude: longitude };
	                _context.next = 12;
	                return _this3.getPartnersByPosition(_this3.userPosition);
	
	              case 12:
	                if (!(_this3.partners.length == 0)) {
	                  _context.next = 14;
	                  break;
	                }
	
	                throw new Error(1);
	
	              case 14:
	                _context.next = 21;
	                break;
	
	              case 16:
	                _context.prev = 16;
	                _context.t0 = _context['catch'](3);
	
	                if (_context.t0.message == 1) {
	                  if (_this3.range < 150) {
	                    _this3.msgError = 'Nenhum ponto de retirada próximo encontrado. Tente aumentar a distância de busca para encontrar o ponto de retirada mais próximo de seu CEP.';
	                  } else {
	                    _this3.msgError = 'Nenhum ponto de retirada próximo encontrado pelo Cep informado.';
	                  }
	                } else {
	
	                  _this3.msgError = 'CEP não encontrado. Por favor verifique se o número está correto ou use outra forma para encontrar o ponto de retirada mais próximo.';
	                }
	                _this3.showMsgEror = true;
	                return _context.abrupt('return');
	
	              case 21:
	                _context.prev = 21;
	
	                _this3.loading = false;
	                return _context.finish(21);
	
	              case 24:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this3, [[3, 16, 21, 24]]);
	      }))();
	    },
	    searchByCity: function searchByCity() {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var _ref2, latitude, longitude;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this4.hideMsgError();
	                _this4.partnersFiltered = [];
	                _this4.loading = true;
	
	                _context2.prev = 3;
	                _context2.next = 6;
	                return _this4.getLatLngGoogle(_this4.city);
	
	              case 6:
	                _ref2 = _context2.sent;
	                latitude = _ref2.latitude;
	                longitude = _ref2.longitude;
	
	                _this4.userPosition = { latitude: latitude, longitude: longitude };
	                _context2.next = 12;
	                return _this4.getPartnersByPosition({ latitude: latitude, longitude: longitude, range: _this4.range });
	
	              case 12:
	                if (!(_this4.partners.length == 0)) {
	                  _context2.next = 14;
	                  break;
	                }
	
	                throw new Error();
	
	              case 14:
	                _context2.next = 21;
	                break;
	
	              case 16:
	                _context2.prev = 16;
	                _context2.t0 = _context2['catch'](3);
	
	
	                _this4.msgError = 'Cidade não encontrada. Por favor verifique se o nome está correto ou use outra forma para encontrar o ponto de retirada mais próximo.';
	                _this4.showMsgEror = true;
	                return _context2.abrupt('return');
	
	              case 21:
	                _context2.prev = 21;
	
	                _this4.loading = false;
	                return _context2.finish(21);
	
	              case 24:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this4, [[3, 16, 21, 24]]);
	      }))();
	    },
	    searchByCurrentLocalization: function searchByCurrentLocalization() {
	      var _this5 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this5.hideMsgError();
	                _this5.partnersFiltered = [];
	                _this5.loading = true;
	
	                _this5.showGetCurrentLocalizationFunc();
	
	                _context3.prev = 4;
	                _context3.next = 7;
	                return _this5.getCurrentLocalization();
	
	              case 7:
	                _this5.userPosition = _context3.sent;
	                _context3.next = 10;
	                return _this5.getPartnersByPosition(_this5.userPosition);
	
	              case 10:
	                if (!(_this5.partners.length == 0)) {
	                  _context3.next = 12;
	                  break;
	                }
	
	                throw new Error(1);
	
	              case 12:
	                _context3.next = 19;
	                break;
	
	              case 14:
	                _context3.prev = 14;
	                _context3.t0 = _context3['catch'](4);
	
	                if (_context3.t0.message == 1) {
	                  if (_this5.range < 150) {
	                    _this5.msgError = 'Nenhum ponto de retirada próximo a sua localização foi encontrado. Tente aumentar a distância de busca ou tente outra maneira de encontrar um ponto de retirada.';
	                  } else {
	                    _this5.msgError = 'Nenhum ponto de retirada próximo encontrado para sua localização atual.';
	                  }
	                } else {
	                  _this5.msgError = 'Não foi possível encontrar sua localização atual. Por favor verifique se sua localização está ativada, ou tente outra maneira de encontrar o ponto de retirada mais próximo.';
	                }
	                _this5.showMsgEror = true;
	                return _context3.abrupt('return');
	
	              case 19:
	                _context3.prev = 19;
	
	                _this5.loading = false;
	                return _context3.finish(19);
	
	              case 22:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this5, [[4, 14, 19, 22]]);
	      }))();
	    },
	    getCurrentLocalization: function getCurrentLocalization() {
	      return new _promise2.default(function (resolve, reject) {
	        navigator.geolocation.getCurrentPosition(function (response) {
	          resolve({
	            latitude: response.coords.latitude,
	            longitude: response.coords.longitude
	          });
	        }, function (error) {
	          reject(error);
	        });
	      });
	    },
	    getLatLngGoogle: function getLatLngGoogle(address) {
	      var _this6 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        try {
	          new google.maps.Geocoder().geocode({ address: address }, function () {
	            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(response) {
	              var res;
	              return _regenerator2.default.wrap(function _callee4$(_context4) {
	                while (1) {
	                  switch (_context4.prev = _context4.next) {
	                    case 0:
	                      if (!(response.length > 0)) {
	                        _context4.next = 4;
	                        break;
	                      }
	
	                      return _context4.abrupt('return', resolve({
	                        latitude: response[0].geometry.location.lat(),
	                        longitude: response[0].geometry.location.lng()
	                      }));
	
	                    case 4:
	                      _context4.next = 6;
	                      return _address2.default.getLatLng(cep);
	
	                    case 6:
	                      res = _context4.sent;
	                      return _context4.abrupt('return', resolve({
	                        latitude: res.latitude,
	                        longitude: res.longitude
	                      }));
	
	                    case 8:
	                    case 'end':
	                      return _context4.stop();
	                  }
	                }
	              }, _callee4, _this6);
	            }));
	
	            return function (_x) {
	              return _ref3.apply(this, arguments);
	            };
	          }());
	        } catch (e) {
	
	          reject(e);
	        }
	      });
	    },
	    getPartnersByPosition: function getPartnersByPosition(position) {
	      var _this7 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
	        var request;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                request = {
	                  latitude: position.latitude,
	                  longitude: position.longitude,
	                  range: _this7.range
	                };
	                _context5.next = 3;
	                return _account2.default.getPartnersByPosition(request);
	
	              case 3:
	                _this7.partners = _context5.sent;
	
	                _this7.partnersFiltered = _this7.partners;
	
	              case 5:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this7);
	      }))();
	    },
	    getPartnersByCity: function getPartnersByCity(address, position) {
	      var _this8 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
	        var city, state;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                city = address.city, state = address.state;
	                _context6.next = 3;
	                return _account2.default.getPartnersByCity(city.split('-')[0].trim(), state.length == 2 ? state : '', position);
	
	              case 3:
	                _this8.partners = _context6.sent;
	
	                _this8.partnersFiltered = _this8.partners;
	
	              case 5:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this8);
	      }))();
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(28);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnttService = function () {
	  function AnttService() {
	    (0, _classCallCheck3.default)(this, AnttService);
	  }
	
	  (0, _createClass3.default)(AnttService, [{
	    key: 'vincularRntrc',
	    value: function vincularRntrc(request) {
	      return _axios2.default.post('/v1/vincularRntrc', request);
	    }
	  }]);
	  return AnttService;
	}();
	
	var instance = new AnttService();
	exports.default = instance;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(28);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthHelper = function () {
	  function AuthHelper() {
	    (0, _classCallCheck3.default)(this, AuthHelper);
	  }
	
	  (0, _createClass3.default)(AuthHelper, [{
	    key: 'getUserAndAddressByTaxIdNumberNoSession',
	    value: function getUserAndAddressByTaxIdNumberNoSession(taxIdNumber) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return _auth2.default.getUserAndAddressByTaxIdNumberNoSession(taxIdNumber, options);
	    }
	  }, {
	    key: 'generateCpfJwt',
	    value: function generateCpfJwt(taxIdNumber) {
	      return _auth2.default.generateCpfJwt(taxIdNumber);
	    }
	  }]);
	  return AuthHelper;
	}();
	
	var instance = new AuthHelper();
	exports.default = instance;

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(28);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(13);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DocumentsEnum = function () {
	  function DocumentsEnum() {
	    (0, _classCallCheck3.default)(this, DocumentsEnum);
	  }
	
	  (0, _createClass3.default)(DocumentsEnum, [{
	    key: 'getDocumentsByInterface',
	    value: function getDocumentsByInterface(interfaces) {
	      return _axios2.default.post('/v2/documentos/listaDocs', { interfaces: interfaces }).then(function (res) {
	        return res.data;
	      });
	    }
	  }]);
	  return DocumentsEnum;
	}();
	
	var instance = new DocumentsEnum();
	exports.default = instance;

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Message = undefined;
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(28);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Message = exports.Message = function () {
	  function Message() {
	    (0, _classCallCheck3.default)(this, Message);
	  }
	
	  (0, _createClass3.default)(Message, [{
	    key: "getMessage",
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(type) {
	        var response;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return _axios2.default.get("/v2/getMessageByInterface/" + type + "/WEBSITE");
	
	              case 3:
	                response = _context.sent;
	
	                if (!response.data.status.code) {
	                  _context.next = 6;
	                  break;
	                }
	
	                throw response.data;
	
	              case 6:
	                return _context.abrupt("return", response.data.Mensagem);
	
	              case 9:
	                _context.prev = 9;
	                _context.t0 = _context["catch"](0);
	
	                console.error(_context.t0);
	
	                return _context.abrupt("return", {
	                  name: 'ERROR',
	                  message: 'Não foi possível carregar a mensagem.'
	                });
	
	              case 13:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[0, 9]]);
	      }));
	
	      function getMessage(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return getMessage;
	    }()
	  }]);
	  return Message;
	}();
	
	Message.type = {
	  BLOQUEADO_PARCIALMENTE: "BLOQUEADO_PARCIALMENTE"
	};
	
	
	var instance = new Message();
	
	exports.default = instance;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(28);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SealService = function () {
	  function SealService() {
	    (0, _classCallCheck3.default)(this, SealService);
	  }
	
	  (0, _createClass3.default)(SealService, [{
	    key: 'getSelos',
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var _ref2, data, mapped;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _axios2.default.get('/v2/selos/website');
	
	              case 2:
	                _ref2 = _context.sent;
	                data = _ref2.data;
	                mapped = [];
	
	
	                if (data && Array.isArray(data.seal)) {
	                  data.seal.forEach(function (selo) {
	                    mapped[selo.position] = selo;
	                  });
	                }
	
	                return _context.abrupt('return', mapped);
	
	              case 7:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function getSelos() {
	        return _ref.apply(this, arguments);
	      }
	
	      return getSelos;
	    }()
	  }]);
	  return SealService;
	}();
	
	var instance = new SealService();
	exports.default = instance;

/***/ }),
/* 751 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var contractStore = {
	  state: {
	    hasPlanEmbarcador: false,
	    contracts: undefined,
	    contractSelected: undefined
	  },
	  mutations: {
	    hasPlanEmbarcador: function hasPlanEmbarcador(state, hasPlan) {
	      state.hasPlanEmbarcador = hasPlan;
	    },
	    setContracts: function setContracts(state, c) {
	      state.contracts = c;
	    },
	    setContractSelected: function setContractSelected(state, c) {
	      state.contractSelected = c;
	    }
	  },
	  getters: {
	    getContractById: function getContractById(state, getters) {
	      return function (id) {
	        if (state.contracts === undefined) {
	          return undefined;
	        }
	        return state.contracts.find(function (p) {
	          return p.contractId == id;
	        });
	      };
	    }
	
	  }
	};
	
	exports.default = contractStore;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loadingStore = {
	  state: {
	    count: 0
	  },
	  mutations: {
	    incrementLoading: function incrementLoading(state) {
	      state.count += 1;
	    },
	    decrementLoading: function decrementLoading(state) {
	      state.count -= 1;
	    },
	    resetLoading: function resetLoading(state) {
	      state.count = 0;
	    }
	  },
	  getters: {
	    isLoading: function isLoading(state) {
	      return state.count > 0;
	    }
	  },
	  actions: {
	    loading: function loading(context, promise) {
	      context.commit('incrementLoading');
	      promise.then(function (r) {
	        context.commit('decrementLoading');
	      }).catch(function (e) {
	        context.commit('decrementLoading');
	      });
	    }
	  }
	};
	
	exports.default = loadingStore;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _route = __webpack_require__(59);
	
	var _route2 = _interopRequireDefault(_route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routeStore = {
	  state: {
	    actives: undefined,
	    inactives: undefined
	  },
	  mutations: {
	    setActives: function setActives(state, routes) {
	      state.actives = routes;
	    },
	    setInactives: function setInactives(state, routes) {
	      state.inactives = routes;
	    },
	    deleteRoute: function deleteRoute(state, id) {
	
	      var idx = state.actives.findIndex(function (r) {
	        return r.routeId == id;
	      });
	
	      state.actives.splice(idx, 1);
	    }
	  },
	  getters: {
	    getRouteById: function getRouteById(state, getters) {
	      return function (routeId, version) {
	        if (state.actives) {
	          var r = state.actives.find(function (r) {
	            return r.routeId == routeId && r.version == version;
	          });
	          if (r) return r;
	        }
	        if (state.inactives) {
	          var _r = state.inactives.find(function (r) {
	            return r.routeId == routeId && r.version == version;
	          });
	          if (_r) return _r;
	        }
	
	        return undefined;
	      };
	    },
	
	    getRoutesActive: function getRoutesActive(state) {
	      return state.actives;
	    }
	  },
	  actions: {
	    getRoutes: function getRoutes(context, payload) {
	      var a = _route2.default.getRoute(true, payload).then(function (r) {
	        context.commit('setActives', r);
	        return r;
	      }).catch(function (err) {
	        context.commit('setActives', []);
	      });
	
	      return _promise2.default.all([a]);
	    },
	    deleteRoute: function deleteRoute(context, id) {
	
	      var idx = context.state.actives.findIndex(function (r) {
	        return r.routeId == id;
	      });
	      context.state.actives.slice(idx, 1);
	      context.commit('setActives', context.state.actives);
	    }
	  }
	
	};
	
	exports.default = routeStore;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sales = __webpack_require__(12);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paymentStore = {
	  state: {
	    currentPlanId: undefined,
	    plans: undefined,
	    promotionCurrent: undefined,
	    whereToDelivrey: undefined,
	    confirmCellphone: undefined,
	    confirmEmail: undefined
	  },
	  mutations: {
	    currentPlanId: function currentPlanId(state, planId) {
	      state.currentPlanId = planId;
	    },
	    setPlans: function setPlans(state, plans) {
	      state.plans = plans;
	    },
	    setPromotion: function setPromotion(state, promotion) {
	      state.promotionCurrent = promotion;
	    },
	    setwhereToDelivrey: function setwhereToDelivrey(state, code) {
	      state.whereToDelivrey = code;
	    },
	    setConfirmCellphone: function setConfirmCellphone(state, value) {
	      state.confirmCellphone = value;
	    },
	    setConfirmEmail: function setConfirmEmail(state, value) {
	      state.confirmEmail = value;
	    }
	  },
	  getters: {
	    getReplaceTax: function getReplaceTax(state, getters) {
	      return function (planId) {
	        if (!state.plans) return "";
	
	        var tax = _.filter(getters.getPlanById(planId).adhesionTax.adhesionTax, function (o) {
	          return o.taxId == _constantes2.default.REPLACE_TAXID;
	        });
	
	        if (tax && tax.length > 0) {
	          return tax[0].value;
	        }
	
	        return undefined;
	      };
	    },
	    getwhereToDelivrey: function getwhereToDelivrey(state, getters) {
	      return state.whereToDelivrey;
	    },
	    getPlanById: function getPlanById(state, getters) {
	      return function (planId) {
	        if (state.plans === undefined) {
	          return undefined;
	        }
	        return state.plans.find(function (p) {
	          return p.planId == planId;
	        });
	      };
	    },
	    getPromotionCurrent: function getPromotionCurrent(state, getters) {
	      return state.promotionCurrent;
	    },
	    getNewAdhesionTax: function getNewAdhesionTax(state, getters) {
	      return function (planId) {
	        if (!state.plans) return "";
	
	        var tax = _.filter(getters.getPlanById(planId).adhesionTax.adhesionTax, function (o) {
	          return o.taxId == _constantes2.default.NEW_ADHESION_TAXID;
	        });
	
	        if (tax && tax.length > 0) {
	          return tax[0].value;
	        }
	
	        return undefined;
	      };
	    },
	    getNewVehicleTax: function getNewVehicleTax(state, getters) {
	      return function (planId) {
	        if (!state.plans) return "";
	
	        var tax = _.filter(getters.getPlanById(planId).adhesionTax.adhesionTax, function (o) {
	          return o.taxId == _constantes2.default.NEW_VEHICLE_TAXID;
	        });
	
	        if (tax && tax.length > 0) {
	          return tax[0].value;
	        }
	
	        return undefined;
	      };
	    },
	    getGuaranteeTax: function getGuaranteeTax(state, getters) {
	      return function (planId) {
	        if (!state.plans) return "";
	
	        if (planId == 33) {
	          return _.filter(getters.getPlanById(planId).adhesionTax.adhesionTax, function (o) {
	            return o.taxId == _constantes2.default.GUARANTEE_TAXID;
	          })[0].value;
	        } else {
	          return 0;
	        }
	      };
	    },
	    getLinkRntrcTax: function getLinkRntrcTax(state, getters) {
	      return function (planId) {
	        if (!state.plans) return "";
	
	        var tax = _.filter(getters.getPlanById(planId).adhesionTax.adhesionTax, function (o) {
	          return o.taxId == _constantes2.default.LINK_RNTRC;
	        });
	
	        if (tax && tax.length > 0) {
	          return tax[0].value;
	        }
	
	        return undefined;
	      };
	    },
	    getMonthlyTax: function getMonthlyTax(state, getters) {
	      return function (planId) {
	        if (!state.plans) return "";
	
	        var tax = _.filter(getters.getPlanById(planId).adhesionTax.adhesionTax, function (o) {
	          return o.taxId == _constantes2.default.MONTHLY_TAX;
	        });
	
	        if (tax && tax.length > 0) {
	          return tax[0].value;
	        }
	
	        return undefined;
	      };
	    },
	    getBankAccountOptions: function getBankAccountOptions(state, getters) {
	      return function (planId) {
	        var op = [];
	        _.each(getters.getPlanById(planId).paymentMethod.paymentMethod, function (o) {
	          if (o.type == 'DC') {
	            o.caption = o.name;
	            o.value = o.paymentMethodId;
	            op.push(o);
	          }
	        });
	
	        return op;
	      };
	    },
	
	    getCreditCardOptions: function getCreditCardOptions(state, getters) {
	      return function (planId) {
	        var op = [];
	        _.each(getters.getPlanById(planId).paymentMethod.paymentMethod, function (o) {
	          if (o.type == 'CC') {
	            o.caption = o.name;
	            o.value = o.paymentMethodId;
	            op.push(o);
	          }
	        });
	
	        return op;
	      };
	    },
	
	    getBankBillOption: function getBankBillOption(state, getters) {
	      return function (planId) {
	        var op = undefined;
	        _.each(getters.getPlanById(planId).paymentMethod.paymentMethod, function (o) {
	          if (o.type == 'BC') {
	            op = {
	              bankBill: {
	                billNumber: o.paymentMethodId
	              },
	              paymentMethodId: o.paymentMethodId,
	              imagePath: o.imagePath,
	              billNumber: o.paymentMethodId
	            };
	          }
	        });
	
	        return op;
	      };
	    },
	    getDocOption: function getDocOption(state, getters) {
	      return function (planId) {
	        var op = undefined;
	        _.each(getters.getPlanById(planId).paymentMethod.paymentMethod, function (o) {
	          if (o.type == 'DO') {
	            op = {
	              bankBill: {
	                billNumber: o.paymentMethodId
	              },
	              paymentMethodId: o.paymentMethodId,
	              imagePath: o.imagePath,
	              billNumber: o.paymentMethodId
	            };
	          }
	        });
	
	        return op;
	      };
	    },
	    getTedOption: function getTedOption(state, getters) {
	      return function (planId) {
	        var op = undefined;
	        _.each(getters.getPlanById(planId).paymentMethod.paymentMethod, function (o) {
	          if (o.type == 'TE') {
	            op = {
	              bankBill: {
	                billNumber: o.paymentMethodId
	              },
	              paymentMethodId: o.paymentMethodId,
	              imagePath: o.imagePath,
	              billNumber: o.paymentMethodId
	            };
	          }
	        });
	
	        return op;
	      };
	    },
	
	    getPaymentsMethodsByPlan: function getPaymentsMethodsByPlan(state, getters) {
	      return function (planId) {
	
	        if (state.plans === undefined) return undefined;
	
	        if (state.plans.find(function (p) {
	          return p.planId == planId;
	        }) && state.plans.find(function (p) {
	          return p.planId == planId;
	        }).paymentMethod && state.plans.find(function (p) {
	          return p.planId == planId;
	        }).paymentMethod.paymentMethod) {
	
	          return state.plans.find(function (p) {
	            return p.planId == planId;
	          }).paymentMethod.paymentMethod;
	        } else {
	          return undefined;
	        }
	      };
	    },
	    getAllPayments: function getAllPayments(state) {
	      if (state.plans === undefined) return undefined;
	
	      var payments = {};
	      state.plans.forEach(function (o) {
	        o.paymentMethod.paymentMethod.forEach(function (p) {
	          payments[p.name] = p;
	        });
	      });
	      return payments;
	    },
	
	    getPaymentsTypesByPlan: function getPaymentsTypesByPlan(state, getters) {
	      return function (planId) {
	        var obj = {};
	        obj.bankBill = !!_.find(getters.getPaymentsMethodsByPlan(planId), function (o) {
	          return o.type == "BC";
	        });
	        obj.bankAccount = !!_.find(getters.getPaymentsMethodsByPlan(planId), function (o) {
	          return o.type == "DC";
	        });
	        obj.creditCard = !!_.find(getters.getPaymentsMethodsByPlan(planId), function (o) {
	          return o.type == "CC";
	        });
	        obj.ted = !!_.find(getters.getPaymentsMethodsByPlan(planId), function (o) {
	          return o.type == "TE";
	        });
	        obj.doc = !!_.find(getters.getPaymentsMethodsByPlan(planId), function (o) {
	          return o.type == "DO";
	        });
	        obj.senff = !!_.find(getters.getPaymentsMethodsByPlan(planId), function (o) {
	          return o.type == "SF";
	        });
	
	        var i = 0;
	        _.forIn(obj, function (v) {
	
	          if (v) i++;
	        });
	        obj.qtd = i;
	
	        return obj;
	      };
	    },
	    getBankOptionsByPlan: function getBankOptionsByPlan(state, getters) {
	      return function (planId) {
	        return _.filter(getters.getPaymentsMethodsByPlan(planId), function (o) {
	          return o.type == "DC";
	        });
	      };
	    },
	    getConfirmCellphone: function getConfirmCellphone(state, getters) {
	      return function () {
	        return state.confirmCellphone;
	      };
	    },
	    getConfirmEmail: function getConfirmEmail(state, getters) {
	      return function () {
	        return state.confirmEmail;
	      };
	    }
	  },
	  actions: {
	    actWhereToDelivrey: function actWhereToDelivrey(context, code) {
	      context.commit('setwhereToDelivrey', code);
	    },
	    getPlans: function getPlans(context) {
	      return _sales2.default.getPlan().then(function (r) {
	        context.commit('setPlans', r.plans);
	        context.commit('setConfirmCellphone', r.confirmCellphone);
	        context.commit('setConfirmEmail', r.confirmEmail);
	      }).catch(function (err) {
	        return console.log(err);
	      });
	    },
	    getPromotionCode: function getPromotionCode(context, code) {
	      return _sales2.default.hasPromotion({ promotionCode: code }).then(function (r) {
	        context.commit('setPromotion', r[0]);
	        return r[0];
	      });
	    }
	  }
	};
	
	exports.default = paymentStore;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.moveMaisCPF = exports.cep = exports.older = exports.completeName = exports.accountExists = undefined;
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _account = __webpack_require__(21);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validaAccount(val, args) {
	
	  var type = args[0];
	  var url = undefined;
	  var obj = {};
	
	  if (!val) return true;
	
	  if (type == 'email') obj.email = val;
	
	  if (type == 'cpf' || type == 'cnpj') obj.taxIdNumber = val;
	
	  return _account2.default.accountExists(obj).then(function (r) {
	    return {
	      valid: r
	    };
	  });
	}
	
	function completeNameVal(value) {
	  if (!value) return true;
	
	  value = value.trim();
	
	  if (value.indexOf(' ') > 0 && value.indexOf(' ') < value.length) return true;
	
	  return false;
	}
	
	function olderVal(value) {
	
	  if (!value || value.length != 10) return true;
	
	  if (!(0, _moment2.default)(value, "DD-MM-YYYY").isValid()) return _promise2.default.resolve({ valid: false, data: true });
	
	  return _promise2.default.resolve({ valid: (0, _moment2.default)(value, "DD-MM-YYYY").add(18, 'y').isSameOrBefore((0, _moment2.default)()) });
	}
	
	function cepValid(value) {
	  if (!value) return true;
	
	  return value.replace(/[^0-9]/g, '').length == 8;
	}
	
	function passwordValid(value) {
	  if (value.length >= 8) {
	    var format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
	
	    var containsNumber = /\d/.test(value);
	    var containsUppercase = /[A-Z]/.test(value);
	    var containsSpecialCharacter = format.test(value);
	
	    if (containsSpecialCharacter === true && containsUppercase === true && containsNumber === true) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	var accountExists = exports.accountExists = {
	  messages: {
	    en: function en(field, args) {
	      if (args[0] == 'email') return "Email já cadastrado!";
	      return "CPF/CNPJ já cadastrado!";
	    },
	    'pt-BR': function ptBR(field, args) {
	      if (args[0] == 'email') return "Email já cadastrado!";
	      return "CPF/CNPJ já cadastrado!";
	    }
	  },
	  validate: function validate(value, args) {
	    return validaAccount(value, args);
	  }
	};
	
	var completeName = exports.completeName = {
	  messages: {
	    en: function en(field, args) {
	      return "Digite seu nome completo";
	    },
	    'pt-BR': function ptBR(field, args) {
	      return "Digite seu nome completo";
	    }
	  },
	  validate: function validate(value, args) {
	    return completeNameVal(value, args);
	  }
	};
	
	var older = exports.older = {
	  messages: {
	    en: function en(field, args, dateError) {
	      return dateError === true ? 'Data inválida!' : "Somente para maiores de idade";
	    },
	    'pt-BR': function ptBR(field, args, dateError) {
	      return dateError === true ? 'Data inválida!' : "Somente para maiores de idade";
	    }
	  },
	  validate: function validate(value, args) {
	    return olderVal(value, args);
	  }
	};
	
	var cep = exports.cep = {
	  messages: {
	    en: function en(field, args) {
	      return "CEP inválido (somente números)";
	    },
	    'pt-BR': function ptBR(field, args) {
	      return "CEP inválido (somente números)";
	    }
	  },
	  validate: function validate(value, args) {
	    return cepValid(value, args);
	  }
	};
	
	var moveMaisCPF = exports.moveMaisCPF = {
	  messages: {
	    en: function en(field, args) {
	      return "Senha inválida";
	    },
	    'pt-BR': function ptBR(field, args) {
	      return "Senha inválida";
	    }
	  },
	  validate: function validate(value, args) {
	    return passwordValid(value, args);
	  }
	};

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.brand = exports.card = undefined;
	
	var _utils = __webpack_require__(34);
	
	var Utils = _interopRequireWildcard(_utils);
	
	var _index = __webpack_require__(172);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function validaCard(cardNumber) {
	  cardNumber = cardNumber.replace(/[^0-9]/g, '');
	
	  if (cardNumber.length > 12) {
	    var digit1 = cardNumber.substring(0, 1);
	    var digit2 = cardNumber.substring(0, 2);
	    var digit3 = cardNumber.substring(0, 3);
	    var digit4 = cardNumber.substring(0, 4);
	
	    if (digit1 == 4) {
	      if (cardNumber.length == 13 || cardNumber.length == 16) return true;
	    } else if (digit2 >= 51 && digit2 <= 55 || digit2 == 59) {
	        if (cardNumber.length == 16) return true;
	      } else if (digit2 == 34 || digit2 == 37) {
	          if (cardNumber.length >= 15) return true;
	        } else if (digit2 == 36 || digit2 == 38 || digit3 >= 300 && digit3 <= 305) {
	            if (cardNumber.length >= 15) return true;
	          }
	  }
	  return false;
	}
	
	function isBrandValid(cardNumber) {
	  var brand = Utils.getCardBrand(cardNumber);
	
	  return !!_index2.default.getters.getPaymentsMethodsByPlan(_index2.default.state.sales.currentPlanId).find(function (o) {
	    return o.name == brand;
	  });
	}
	
	var card = exports.card = {
	  messages: {
	    en: function en(field, args) {
	      return "Cartão de crédito inválido!";
	    },
	    'pt-BR': function ptBR(field, args) {
	      return "Cartão de crédito inválido!";
	    }
	  },
	  validate: function validate(value) {
	    return validaCard(value);
	  }
	};
	
	var brand = exports.brand = {
	  messages: {
	    en: function en(field, args) {
	      return "Bandeira não aceita!";
	    },
	    'pt-BR': function ptBR(field, args) {
	      return "Bandeira não aceita!";
	    }
	  },
	  validate: function validate(value) {
	    return isBrandValid(value);
	  }
	};

/***/ }),
/* 757 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function validaCel(val) {
	  var celular = val.replace(/\s/g, '');
	  var digito = celular.substr(4, 1);
	
	  if (!val) return true;
	
	  var len = val.toString().replace(/[^0-9]/g, '').length;
	
	  if (len == 11 && digito == "9") {
	    return true;
	  } else if (len == 10 && (digito == "6" || digito == "7" || digito == "8" || digito == "9")) {
	    return true;
	  }
	  return false;
	}
	
	exports.default = {
	  messages: {
	    en: function en(field, args) {
	      return "Celular inválido";
	    },
	    'pt-BR': function ptBR(field, args) {
	      return "Celular inválido";
	    }
	  },
	  validate: function validate(value) {
	    return validaCel(value);
	  }
	};

/***/ }),
/* 758 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function formatPhoneNumber(phoneNumber) {
	  var cleanedNumber = phoneNumber.replace(/\D/g, '');
	
	  if (cleanedNumber.length === 11 && cleanedNumber[2] === '9') {
	    return cleanedNumber.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
	  } else if (cleanedNumber.length === 10 && (cleanedNumber[2] === '9' || cleanedNumber[2] === '6' || cleanedNumber[2] === '7' || cleanedNumber[2] === '8')) {
	    return cleanedNumber.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
	  } else if (cleanedNumber.length === 10) {
	    return cleanedNumber.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
	  } else {
	    return false;
	  }
	}
	
	exports.default = {
	  messages: {
	    en: function en(field, args) {
	      return "Telefone inválido";
	    },
	    'pt-BR': function ptBR(field, args) {
	      return "Telefone inválido";
	    }
	  },
	  validate: function validate(value) {
	    return formatPhoneNumber(value);
	  }
	};

/***/ }),
/* 759 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function valida(params, obj) {
	
	  return false;
	}
	
	exports.default = {
	  messages: {
	    en: function en(field, args) {
	      return "Por favor selecione um item da lista";
	    },
	    'pt-BR': function ptBR(field, args) {
	      return "Por favor selecione um item da lista";
	    }
	  },
	  validate: function validate(params, obj) {
	    return valida(params, obj);
	  }
	};

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _veeValidate = __webpack_require__(511);
	
	var _cpfCnpj = __webpack_require__(86);
	
	var _card = __webpack_require__(756);
	
	var _valorRecargaValido = __webpack_require__(243);
	
	var _valorRecargaValido2 = _interopRequireDefault(_valorRecargaValido);
	
	var _valorRecargaValidoOpen = __webpack_require__(763);
	
	var _valorRecargaValidoOpen2 = _interopRequireDefault(_valorRecargaValidoOpen);
	
	var _phone = __webpack_require__(761);
	
	var _phone2 = _interopRequireDefault(_phone);
	
	var _cell = __webpack_require__(757);
	
	var _cell2 = _interopRequireDefault(_cell);
	
	var _generalMask = __webpack_require__(758);
	
	var _generalMask2 = _interopRequireDefault(_generalMask);
	
	var _plate = __webpack_require__(762);
	
	var _account = __webpack_require__(755);
	
	var _date = __webpack_require__(60);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _recargaMinima = __webpack_require__(98);
	
	var _recargaMinima2 = _interopRequireDefault(_recargaMinima);
	
	var _googleAutocomplete = __webpack_require__(759);
	
	var _googleAutocomplete2 = _interopRequireDefault(_googleAutocomplete);
	
	var _isMultiple = __webpack_require__(242);
	
	var _isMultiple2 = _interopRequireDefault(_isMultiple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dictionary = {
	  'pt-BR': {
	    messages: {
	      required: function required() {
	        return 'Campo é obrigatório.';
	      },
	      min: function min(field, arg) {
	        return 'M\xEDnimo ' + arg + ' caracteres.';
	      },
	      max: function max(field, arg) {
	        return 'M\xE1ximo ' + arg + ' caracteres.';
	      },
	      after: function after(field) {
	        return 'Campo deve ser ap\xF3s ' + field;
	      },
	      confirmed: function confirmed(field) {
	        return 'Campos n\xE3o conferem';
	      },
	      email: function email(field) {
	        return 'O formato do e-mail é inválido.';
	      },
	      decimal: function decimal(field) {
	        return 'Campo deve ser numérico';
	      },
	      numeric: function numeric(field) {
	        return 'Campo deve ser numérico';
	      },
	      moveMaisCPF: function moveMaisCPF(field) {
	        return 'Senha inválida';
	      }
	    }
	  }
	};
	
	var plugin = {};
	
	plugin.install = function (Vue, options) {
	  _veeValidate.Validator.installDateTimeValidators(_moment2.default);
	  _veeValidate.Validator.updateDictionary(dictionary);
	  _veeValidate.Validator.setLocale('pt-BR');
	  _veeValidate.Validator.extend('cpf', _cpfCnpj.cpf);
	  _veeValidate.Validator.extend('cnpj', _cpfCnpj.cnpj);
	  _veeValidate.Validator.extend('cpfCnpj', _cpfCnpj.cpfCnpj);
	  _veeValidate.Validator.extend('valorRecarga', _valorRecargaValido2.default);
	  _veeValidate.Validator.extend('valorRecargaOpen', _valorRecargaValidoOpen2.default);
	  _veeValidate.Validator.extend('phone', _phone2.default);
	  _veeValidate.Validator.extend('cell', _cell2.default);
	  _veeValidate.Validator.extend('generalMask', _generalMask2.default);
	  _veeValidate.Validator.extend('plateExist', _plate.plateExist);
	  _veeValidate.Validator.extend('plateValid', _plate.plateValid);
	  _veeValidate.Validator.extend('accountExists', _account.accountExists);
	  _veeValidate.Validator.extend('card', _card.card);
	  _veeValidate.Validator.extend('complete-name', _account.completeName);
	  _veeValidate.Validator.extend('older', _account.older);
	  _veeValidate.Validator.extend('beforeOneYear', _date.beforeOneYear);
	  _veeValidate.Validator.extend('cep', _account.cep);
	  _veeValidate.Validator.extend('brand', _card.brand);
	  _veeValidate.Validator.extend('recargaMinima', _recargaMinima2.default);
	  _veeValidate.Validator.extend('isMultiple', _isMultiple2.default);
	  _veeValidate.Validator.extend('googleAutocomplete', _googleAutocomplete2.default);
	  _veeValidate.Validator.extend('moveMaisCPF', _account.moveMaisCPF);
	};
	
	exports.default = plugin;

/***/ }),
/* 761 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function validaTel(val) {
	  if (!val) return true;
	
	  var len = val.toString().replace(/[^0-9]/g, '').length;
	  if (len == 10) return true;
	
	  return false;
	}
	
	exports.default = {
	  messages: {
	    en: function en(field, args) {
	      return "Telefone inválido";
	    },
	    'pt-BR': function ptBR(field, args) {
	      return "Telefone inválido";
	    }
	  },
	  validate: function validate(value) {
	    return validaTel(value);
	  }
	};

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.plateValid = exports.plateExist = undefined;
	
	var _vehicles = __webpack_require__(29);
	
	var _vehicles2 = _interopRequireDefault(_vehicles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function valida(val, args) {
	  if (!val) return true;
	
	  var len = val.toString().replace("-", '').length;
	
	  if (len != 7) return true;
	
	  return _vehicles2.default.vehicleNotExists(val).then(function (r) {
	    return { valid: r };
	  });
	}
	
	function validaFormato(val, args) {
	  if (!val) return false;
	
	  var len = val.toString().replace("-", '').length;
	
	  if (len != 7) return false;
	
	  return true;
	}
	
	var plateExist = exports.plateExist = {
	  messages: {
	    en: function en(field, args) {
	      return "Veículo já cadastrado";
	    },
	    'pt-BR': function ptBR(field, args) {
	      return "Veículo já cadastrado";
	    }
	  },
	  validate: function validate(value, args) {
	    return valida(value, args);
	  }
	};
	
	var plateValid = exports.plateValid = {
	  messages: {
	    en: function en(field, args) {
	      return "Placa inválida";
	    },
	    'pt-BR': function ptBR(field, args) {
	      return "Placa inválida";
	    }
	  },
	  validate: function validate(value, args) {
	    return validaFormato(value, args);
	  }
	};

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constantes = __webpack_require__(16);
	
	var _constantes2 = _interopRequireDefault(_constantes);
	
	var _auth = __webpack_require__(11);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _number = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function recargaValida(val, args) {
	  var mult = parseInt(args[0]);
	  var min = parseInt(args[1]);
	  if (!val) return false;
	
	  val = parseInt(val.toString().replace(/[^0-9]/g, ''));
	
	  if (val > min) return true;
	
	  if (val / mult > 0 && val % mult == 0) return true;
	
	  return false;
	}
	
	exports.default = {
	  messages: {
	    en: function en(field, args) {
	      var mult = args[0];
	      return 'Valor de recarga inv\xE1lido';
	    },
	    'pt-BR': function ptBR(field, args) {
	      var mult = args[0];
	      return 'Valor de recarga inv\xE1lido';
	    }
	  },
	  validate: function validate(value, args) {
	    return recargaValida(value, args);
	  }
	};

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(20);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(19);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _axios = __webpack_require__(18);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _number = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var recharge = [21, 22, 31, 32, 35, 36, 37, 38, 4, 5, 51, 52, 45, 55, 62, 64];
	var rechargeAut = [22, 32, 36, 38, 4, 5, 45, 55, 62, 64];
	exports.default = {
	  computed: {
	    window: function (_window) {
	      function window() {
	        return _window.apply(this, arguments);
	      }
	
	      window.toString = function () {
	        return _window.toString();
	      };
	
	      return window;
	    }(function () {
	      return window;
	    })
	  },
	  methods: {
	    getRechargeRates: function getRechargeRates(planId) {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _axios2.default.get('/v2/getRechargeRates/' + _this.planId);
	
	              case 2:
	                return _context.abrupt('return', _context.sent);
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    planHasRecharge: function planHasRecharge(planId) {
	      return recharge.indexOf(parseInt(planId)) >= 0;
	    },
	    planHasAutRecharge: function planHasAutRecharge(planId) {
	      return rechargeAut.indexOf(parseInt(planId)) >= 0;
	    },
	    getKindPlan: function getKindPlan(planId) {
	      switch (parseInt(planId)) {
	
	        case 28:
	          return 'POS_PAGO';
	
	        case 21:
	        case 31:
	        case 35:
	        case 37:
	        case 51:
	        case 70:
	        case 71:
	          return 'PRE_MAN';
	        case 22:
	        case 32:
	        case 36:
	        case 38:
	        case 52:
	        case 4:
	        case 5:
	        case 62:
	        case 64:
	          return 'PRE_AUTO';
	
	        case 33:
	          return 'MOVE_PAGUE';
	
	        case 2:
	        case 3:
	          return 'RNTRC';
	
	        case 6:
	          return 'EMBARCADOR-PRE';
	        case 8:
	          return 'EMBARCADOR-POS';
	        case 23:
	        case 7:
	          return 'VALE';
	        case 45:
	        case 46:
	          return 'AGREGADO';
	      }
	    },
	    getPercentRechargeAut: function getPercentRechargeAut(planId) {
	      if (planId == 31 || planId == 32 || planId == 64) return 30;
	
	      return 40;
	    },
	    getMultipleRecharge: function getMultipleRecharge(planId) {
	      if (planId == 31 || planId == 32 || planId == 64) return 50000;else if (planId == 51 || planId == 52) return 2500;else return 5000;
	    },
	    getMinOpenValue: function getMinOpenValue(planId) {
	
	      if (planId == 31 || planId == 32 || planId == 5 || planId == 64) return 200000;else if (planId == 51 || planId == 52) return 2500;else return 5000;
	    },
	    calculate: function calculate(planId, value) {
	      var promise = Sales.calculateRechargeRate({
	        value: value,
	        planId: planId,
	        contractId: 0
	      }).then(function (r) {});
	
	      this.$store.dispatch("loading", promise);
	    },
	    getFixesRecharges: function getFixesRecharges(planId, minValue, icFull) {
	
	      var arrayRetorno = [];
	
	      this.getRechargeRates(planId).then(function (e) {
	        e.data.response.forEach(function (element) {
	          var elm = { value: element[3], tax: element[4], caption: (0, _number.cents)(element[3]) };
	          arrayRetorno.push(elm);
	        });
	        if (!icFull) {
	          arrayRetorno.push({ value: -1, tax: 999, caption: "Valor maior que " + (0, _number.cents)(minValue) });
	        }
	      });
	
	      return arrayRetorno;
	    },
	    formatTaxId: function formatTaxId(tax) {
	      if (!tax) return undefined;
	
	      tax = tax.replace();
	      if (tax.length == 14) return tax.replace(/(\w{2})(\w{3})(\w{3})(\w{4})(\w{2})/, '$1.$2.$3/$4-$5');else return tax.replace(/(\w{3})(\w{3})(\w{3})(\w{2})/, '$1.$2.$3-$4');
	    }
	  }
	};

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(789), __esModule: true };

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(792), __esModule: true };

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(793), __esModule: true };

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(794), __esModule: true };

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(797), __esModule: true };

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(799), __esModule: true };

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(800), __esModule: true };

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(803), __esModule: true };

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(804), __esModule: true };

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(807), __esModule: true };

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(808), __esModule: true };

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getPrototypeOf = __webpack_require__(175);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _getOwnPropertyDescriptor = __webpack_require__(771);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);
	
	  if (desc === undefined) {
	    var parent = (0, _getPrototypeOf2.default)(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};

/***/ }),
/* 777 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 778 */
/***/ (function(module, exports) {

	/**
	 * Bit twiddling hacks for JavaScript.
	 *
	 * Author: Mikola Lysenko
	 *
	 * Ported from Stanford bit twiddling hack library:
	 *    http://graphics.stanford.edu/~seander/bithacks.html
	 */
	
	"use strict"; "use restrict";
	
	//Number of bits in an integer
	var INT_BITS = 32;
	
	//Constants
	exports.INT_BITS  = INT_BITS;
	exports.INT_MAX   =  0x7fffffff;
	exports.INT_MIN   = -1<<(INT_BITS-1);
	
	//Returns -1, 0, +1 depending on sign of x
	exports.sign = function(v) {
	  return (v > 0) - (v < 0);
	}
	
	//Computes absolute value of integer
	exports.abs = function(v) {
	  var mask = v >> (INT_BITS-1);
	  return (v ^ mask) - mask;
	}
	
	//Computes minimum of integers x and y
	exports.min = function(x, y) {
	  return y ^ ((x ^ y) & -(x < y));
	}
	
	//Computes maximum of integers x and y
	exports.max = function(x, y) {
	  return x ^ ((x ^ y) & -(x < y));
	}
	
	//Checks if a number is a power of two
	exports.isPow2 = function(v) {
	  return !(v & (v-1)) && (!!v);
	}
	
	//Computes log base 2 of v
	exports.log2 = function(v) {
	  var r, shift;
	  r =     (v > 0xFFFF) << 4; v >>>= r;
	  shift = (v > 0xFF  ) << 3; v >>>= shift; r |= shift;
	  shift = (v > 0xF   ) << 2; v >>>= shift; r |= shift;
	  shift = (v > 0x3   ) << 1; v >>>= shift; r |= shift;
	  return r | (v >> 1);
	}
	
	//Computes log base 10 of v
	exports.log10 = function(v) {
	  return  (v >= 1000000000) ? 9 : (v >= 100000000) ? 8 : (v >= 10000000) ? 7 :
	          (v >= 1000000) ? 6 : (v >= 100000) ? 5 : (v >= 10000) ? 4 :
	          (v >= 1000) ? 3 : (v >= 100) ? 2 : (v >= 10) ? 1 : 0;
	}
	
	//Counts number of bits
	exports.popCount = function(v) {
	  v = v - ((v >>> 1) & 0x55555555);
	  v = (v & 0x33333333) + ((v >>> 2) & 0x33333333);
	  return ((v + (v >>> 4) & 0xF0F0F0F) * 0x1010101) >>> 24;
	}
	
	//Counts number of trailing zeros
	function countTrailingZeros(v) {
	  var c = 32;
	  v &= -v;
	  if (v) c--;
	  if (v & 0x0000FFFF) c -= 16;
	  if (v & 0x00FF00FF) c -= 8;
	  if (v & 0x0F0F0F0F) c -= 4;
	  if (v & 0x33333333) c -= 2;
	  if (v & 0x55555555) c -= 1;
	  return c;
	}
	exports.countTrailingZeros = countTrailingZeros;
	
	//Rounds to next power of 2
	exports.nextPow2 = function(v) {
	  v += v === 0;
	  --v;
	  v |= v >>> 1;
	  v |= v >>> 2;
	  v |= v >>> 4;
	  v |= v >>> 8;
	  v |= v >>> 16;
	  return v + 1;
	}
	
	//Rounds down to previous power of 2
	exports.prevPow2 = function(v) {
	  v |= v >>> 1;
	  v |= v >>> 2;
	  v |= v >>> 4;
	  v |= v >>> 8;
	  v |= v >>> 16;
	  return v - (v>>>1);
	}
	
	//Computes parity of word
	exports.parity = function(v) {
	  v ^= v >>> 16;
	  v ^= v >>> 8;
	  v ^= v >>> 4;
	  v &= 0xf;
	  return (0x6996 >>> v) & 1;
	}
	
	var REVERSE_TABLE = new Array(256);
	
	(function(tab) {
	  for(var i=0; i<256; ++i) {
	    var v = i, r = i, s = 7;
	    for (v >>>= 1; v; v >>>= 1) {
	      r <<= 1;
	      r |= v & 1;
	      --s;
	    }
	    tab[i] = (r << s) & 0xff;
	  }
	})(REVERSE_TABLE);
	
	//Reverse bits in a 32 bit word
	exports.reverse = function(v) {
	  return  (REVERSE_TABLE[ v         & 0xff] << 24) |
	          (REVERSE_TABLE[(v >>> 8)  & 0xff] << 16) |
	          (REVERSE_TABLE[(v >>> 16) & 0xff] << 8)  |
	           REVERSE_TABLE[(v >>> 24) & 0xff];
	}
	
	//Interleave bits of 2 coordinates with 16 bits.  Useful for fast quadtree codes
	exports.interleave2 = function(x, y) {
	  x &= 0xFFFF;
	  x = (x | (x << 8)) & 0x00FF00FF;
	  x = (x | (x << 4)) & 0x0F0F0F0F;
	  x = (x | (x << 2)) & 0x33333333;
	  x = (x | (x << 1)) & 0x55555555;
	
	  y &= 0xFFFF;
	  y = (y | (y << 8)) & 0x00FF00FF;
	  y = (y | (y << 4)) & 0x0F0F0F0F;
	  y = (y | (y << 2)) & 0x33333333;
	  y = (y | (y << 1)) & 0x55555555;
	
	  return x | (y << 1);
	}
	
	//Extracts the nth interleaved component
	exports.deinterleave2 = function(v, n) {
	  v = (v >>> n) & 0x55555555;
	  v = (v | (v >>> 1))  & 0x33333333;
	  v = (v | (v >>> 2))  & 0x0F0F0F0F;
	  v = (v | (v >>> 4))  & 0x00FF00FF;
	  v = (v | (v >>> 16)) & 0x000FFFF;
	  return (v << 16) >> 16;
	}
	
	
	//Interleave bits of 3 coordinates, each with 10 bits.  Useful for fast octree codes
	exports.interleave3 = function(x, y, z) {
	  x &= 0x3FF;
	  x  = (x | (x<<16)) & 4278190335;
	  x  = (x | (x<<8))  & 251719695;
	  x  = (x | (x<<4))  & 3272356035;
	  x  = (x | (x<<2))  & 1227133513;
	
	  y &= 0x3FF;
	  y  = (y | (y<<16)) & 4278190335;
	  y  = (y | (y<<8))  & 251719695;
	  y  = (y | (y<<4))  & 3272356035;
	  y  = (y | (y<<2))  & 1227133513;
	  x |= (y << 1);
	  
	  z &= 0x3FF;
	  z  = (z | (z<<16)) & 4278190335;
	  z  = (z | (z<<8))  & 251719695;
	  z  = (z | (z<<4))  & 3272356035;
	  z  = (z | (z<<2))  & 1227133513;
	  
	  return x | (z << 2);
	}
	
	//Extracts nth interleaved component of a 3-tuple
	exports.deinterleave3 = function(v, n) {
	  v = (v >>> n)       & 1227133513;
	  v = (v | (v>>>2))   & 3272356035;
	  v = (v | (v>>>4))   & 251719695;
	  v = (v | (v>>>8))   & 4278190335;
	  v = (v | (v>>>16))  & 0x3FF;
	  return (v<<22)>>22;
	}
	
	//Computes next combination in colexicographic order (this is mistakenly called nextPermutation on the bit twiddling hacks page)
	exports.nextCombination = function(v) {
	  var t = v | (v - 1);
	  return (t + 1) | (((~t & -~t) - 1) >>> (countTrailingZeros(v) + 1));
	}
	


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
	 * Bootstrap v3.3.7 (http://getbootstrap.com)
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under the MIT license
	 */
	
	if (typeof jQuery === 'undefined') {
	  throw new Error('Bootstrap\'s JavaScript requires jQuery')
	}
	
	+function ($) {
	  'use strict';
	  var version = $.fn.jquery.split(' ')[0].split('.')
	  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] > 3)) {
	    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4')
	  }
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: transition.js v3.3.7
	 * http://getbootstrap.com/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap')
	
	    var transEndEventNames = {
	      WebkitTransition : 'webkitTransitionEnd',
	      MozTransition    : 'transitionend',
	      OTransition      : 'oTransitionEnd otransitionend',
	      transition       : 'transitionend'
	    }
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] }
	      }
	    }
	
	    return false // explicit for ie8 (  ._.)
	  }
	
	  // http://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false
	    var $el = this
	    $(this).one('bsTransitionEnd', function () { called = true })
	    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
	    setTimeout(callback, duration)
	    return this
	  }
	
	  $(function () {
	    $.support.transition = transitionEnd()
	
	    if (!$.support.transition) return
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function (e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
	      }
	    }
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: alert.js v3.3.7
	 * http://getbootstrap.com/javascript/#alerts
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // ALERT CLASS DEFINITION
	  // ======================
	
	  var dismiss = '[data-dismiss="alert"]'
	  var Alert   = function (el) {
	    $(el).on('click', dismiss, this.close)
	  }
	
	  Alert.VERSION = '3.3.7'
	
	  Alert.TRANSITION_DURATION = 150
	
	  Alert.prototype.close = function (e) {
	    var $this    = $(this)
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = $(selector === '#' ? [] : selector)
	
	    if (e) e.preventDefault()
	
	    if (!$parent.length) {
	      $parent = $this.closest('.alert')
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'))
	
	    if (e.isDefaultPrevented()) return
	
	    $parent.removeClass('in')
	
	    function removeElement() {
	      // detach from parent, fire event then clean up data
	      $parent.detach().trigger('closed.bs.alert').remove()
	    }
	
	    $.support.transition && $parent.hasClass('fade') ?
	      $parent
	        .one('bsTransitionEnd', removeElement)
	        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
	      removeElement()
	  }
	
	
	  // ALERT PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.alert')
	
	      if (!data) $this.data('bs.alert', (data = new Alert(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.alert
	
	  $.fn.alert             = Plugin
	  $.fn.alert.Constructor = Alert
	
	
	  // ALERT NO CONFLICT
	  // =================
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old
	    return this
	  }
	
	
	  // ALERT DATA-API
	  // ==============
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: button.js v3.3.7
	 * http://getbootstrap.com/javascript/#buttons
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // BUTTON PUBLIC CLASS DEFINITION
	  // ==============================
	
	  var Button = function (element, options) {
	    this.$element  = $(element)
	    this.options   = $.extend({}, Button.DEFAULTS, options)
	    this.isLoading = false
	  }
	
	  Button.VERSION  = '3.3.7'
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  }
	
	  Button.prototype.setState = function (state) {
	    var d    = 'disabled'
	    var $el  = this.$element
	    var val  = $el.is('input') ? 'val' : 'html'
	    var data = $el.data()
	
	    state += 'Text'
	
	    if (data.resetText == null) $el.data('resetText', $el[val]())
	
	    // push to event loop to allow forms to submit
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state])
	
	      if (state == 'loadingText') {
	        this.isLoading = true
	        $el.addClass(d).attr(d, d).prop(d, true)
	      } else if (this.isLoading) {
	        this.isLoading = false
	        $el.removeClass(d).removeAttr(d).prop(d, false)
	      }
	    }, this), 0)
	  }
	
	  Button.prototype.toggle = function () {
	    var changed = true
	    var $parent = this.$element.closest('[data-toggle="buttons"]')
	
	    if ($parent.length) {
	      var $input = this.$element.find('input')
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked')) changed = false
	        $parent.find('.active').removeClass('active')
	        this.$element.addClass('active')
	      } else if ($input.prop('type') == 'checkbox') {
	        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
	        this.$element.toggleClass('active')
	      }
	      $input.prop('checked', this.$element.hasClass('active'))
	      if (changed) $input.trigger('change')
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
	      this.$element.toggleClass('active')
	    }
	  }
	
	
	  // BUTTON PLUGIN DEFINITION
	  // ========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.button')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.button', (data = new Button(this, options)))
	
	      if (option == 'toggle') data.toggle()
	      else if (option) data.setState(option)
	    })
	  }
	
	  var old = $.fn.button
	
	  $.fn.button             = Plugin
	  $.fn.button.Constructor = Button
	
	
	  // BUTTON NO CONFLICT
	  // ==================
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old
	    return this
	  }
	
	
	  // BUTTON DATA-API
	  // ===============
	
	  $(document)
	    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      var $btn = $(e.target).closest('.btn')
	      Plugin.call($btn, 'toggle')
	      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
	        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
	        e.preventDefault()
	        // The target component still receive the focus
	        if ($btn.is('input,button')) $btn.trigger('focus')
	        else $btn.find('input:visible,button:visible').first().trigger('focus')
	      }
	    })
	    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
	    })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: carousel.js v3.3.7
	 * http://getbootstrap.com/javascript/#carousel
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CAROUSEL CLASS DEFINITION
	  // =========================
	
	  var Carousel = function (element, options) {
	    this.$element    = $(element)
	    this.$indicators = this.$element.find('.carousel-indicators')
	    this.options     = options
	    this.paused      = null
	    this.sliding     = null
	    this.interval    = null
	    this.$active     = null
	    this.$items      = null
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
	      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
	      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
	  }
	
	  Carousel.VERSION  = '3.3.7'
	
	  Carousel.TRANSITION_DURATION = 600
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  }
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return
	    switch (e.which) {
	      case 37: this.prev(); break
	      case 39: this.next(); break
	      default: return
	    }
	
	    e.preventDefault()
	  }
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false)
	
	    this.interval && clearInterval(this.interval)
	
	    this.options.interval
	      && !this.paused
	      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))
	
	    return this
	  }
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item')
	    return this.$items.index(item || this.$active)
	  }
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active)
	    var willWrap = (direction == 'prev' && activeIndex === 0)
	                || (direction == 'next' && activeIndex == (this.$items.length - 1))
	    if (willWrap && !this.options.wrap) return active
	    var delta = direction == 'prev' ? -1 : 1
	    var itemIndex = (activeIndex + delta) % this.$items.length
	    return this.$items.eq(itemIndex)
	  }
	
	  Carousel.prototype.to = function (pos) {
	    var that        = this
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))
	
	    if (pos > (this.$items.length - 1) || pos < 0) return
	
	    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
	    if (activeIndex == pos) return this.pause().cycle()
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
	  }
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true)
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end)
	      this.cycle(true)
	    }
	
	    this.interval = clearInterval(this.interval)
	
	    return this
	  }
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return
	    return this.slide('next')
	  }
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return
	    return this.slide('prev')
	  }
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active   = this.$element.find('.item.active')
	    var $next     = next || this.getItemForDirection(type, $active)
	    var isCycling = this.interval
	    var direction = type == 'next' ? 'left' : 'right'
	    var that      = this
	
	    if ($next.hasClass('active')) return (this.sliding = false)
	
	    var relatedTarget = $next[0]
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    })
	    this.$element.trigger(slideEvent)
	    if (slideEvent.isDefaultPrevented()) return
	
	    this.sliding = true
	
	    isCycling && this.pause()
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active')
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
	      $nextIndicator && $nextIndicator.addClass('active')
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type)
	      $next[0].offsetWidth // force reflow
	      $active.addClass(direction)
	      $next.addClass(direction)
	      $active
	        .one('bsTransitionEnd', function () {
	          $next.removeClass([type, direction].join(' ')).addClass('active')
	          $active.removeClass(['active', direction].join(' '))
	          that.sliding = false
	          setTimeout(function () {
	            that.$element.trigger(slidEvent)
	          }, 0)
	        })
	        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
	    } else {
	      $active.removeClass('active')
	      $next.addClass('active')
	      this.sliding = false
	      this.$element.trigger(slidEvent)
	    }
	
	    isCycling && this.cycle()
	
	    return this
	  }
	
	
	  // CAROUSEL PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.carousel')
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
	      var action  = typeof option == 'string' ? option : options.slide
	
	      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
	      if (typeof option == 'number') data.to(option)
	      else if (action) data[action]()
	      else if (options.interval) data.pause().cycle()
	    })
	  }
	
	  var old = $.fn.carousel
	
	  $.fn.carousel             = Plugin
	  $.fn.carousel.Constructor = Carousel
	
	
	  // CAROUSEL NO CONFLICT
	  // ====================
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old
	    return this
	  }
	
	
	  // CAROUSEL DATA-API
	  // =================
	
	  var clickHandler = function (e) {
	    var href
	    var $this   = $(this)
	    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
	    if (!$target.hasClass('carousel')) return
	    var options = $.extend({}, $target.data(), $this.data())
	    var slideIndex = $this.attr('data-slide-to')
	    if (slideIndex) options.interval = false
	
	    Plugin.call($target, options)
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex)
	    }
	
	    e.preventDefault()
	  }
	
	  $(document)
	    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
	    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this)
	      Plugin.call($carousel, $carousel.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: collapse.js v3.3.7
	 * http://getbootstrap.com/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	/* jshint latedef: false */
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function (element, options) {
	    this.$element      = $(element)
	    this.options       = $.extend({}, Collapse.DEFAULTS, options)
	    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
	                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
	    this.transitioning = null
	
	    if (this.options.parent) {
	      this.$parent = this.getParent()
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
	    }
	
	    if (this.options.toggle) this.toggle()
	  }
	
	  Collapse.VERSION  = '3.3.7'
	
	  Collapse.TRANSITION_DURATION = 350
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  }
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width')
	    return hasWidth ? 'width' : 'height'
	  }
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return
	
	    var activesData
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse')
	      if (activesData && activesData.transitioning) return
	    }
	
	    var startEvent = $.Event('show.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide')
	      activesData || actives.data('bs.collapse', null)
	    }
	
	    var dimension = this.dimension()
	
	    this.$element
	      .removeClass('collapse')
	      .addClass('collapsing')[dimension](0)
	      .attr('aria-expanded', true)
	
	    this.$trigger
	      .removeClass('collapsed')
	      .attr('aria-expanded', true)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse in')[dimension]('')
	      this.transitioning = 0
	      this.$element
	        .trigger('shown.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'))
	
	    this.$element
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
	  }
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return
	
	    var startEvent = $.Event('hide.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    var dimension = this.dimension()
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight
	
	    this.$element
	      .addClass('collapsing')
	      .removeClass('collapse in')
	      .attr('aria-expanded', false)
	
	    this.$trigger
	      .addClass('collapsed')
	      .attr('aria-expanded', false)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.transitioning = 0
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse')
	        .trigger('hidden.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    this.$element
	      [dimension](0)
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
	  }
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']()
	  }
	
	  Collapse.prototype.getParent = function () {
	    return $(this.options.parent)
	      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
	      .each($.proxy(function (i, element) {
	        var $element = $(element)
	        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
	      }, this))
	      .end()
	  }
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in')
	
	    $element.attr('aria-expanded', isOpen)
	    $trigger
	      .toggleClass('collapsed', !isOpen)
	      .attr('aria-expanded', isOpen)
	  }
	
	  function getTargetFromTrigger($trigger) {
	    var href
	    var target = $trigger.attr('data-target')
	      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	
	    return $(target)
	  }
	
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.collapse')
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
	      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.collapse
	
	  $.fn.collapse             = Plugin
	  $.fn.collapse.Constructor = Collapse
	
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old
	    return this
	  }
	
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this   = $(this)
	
	    if (!$this.attr('data-target')) e.preventDefault()
	
	    var $target = getTargetFromTrigger($this)
	    var data    = $target.data('bs.collapse')
	    var option  = data ? 'toggle' : $this.data()
	
	    Plugin.call($target, option)
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: dropdown.js v3.3.7
	 * http://getbootstrap.com/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop'
	  var toggle   = '[data-toggle="dropdown"]'
	  var Dropdown = function (element) {
	    $(element).on('click.bs.dropdown', this.toggle)
	  }
	
	  Dropdown.VERSION = '3.3.7'
	
	  function getParent($this) {
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = selector && $(selector)
	
	    return $parent && $parent.length ? $parent : $this.parent()
	  }
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return
	    $(backdrop).remove()
	    $(toggle).each(function () {
	      var $this         = $(this)
	      var $parent       = getParent($this)
	      var relatedTarget = { relatedTarget: this }
	
	      if (!$parent.hasClass('open')) return
	
	      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this.attr('aria-expanded', 'false')
	      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
	    })
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this)
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    clearMenus()
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $(document.createElement('div'))
	          .addClass('dropdown-backdrop')
	          .insertAfter($(this))
	          .on('click', clearMenus)
	      }
	
	      var relatedTarget = { relatedTarget: this }
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this
	        .trigger('focus')
	        .attr('aria-expanded', 'true')
	
	      $parent
	        .toggleClass('open')
	        .trigger($.Event('shown.bs.dropdown', relatedTarget))
	    }
	
	    return false
	  }
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return
	
	    var $this = $(this)
	
	    e.preventDefault()
	    e.stopPropagation()
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus')
	      return $this.trigger('click')
	    }
	
	    var desc = ' li:not(.disabled):visible a'
	    var $items = $parent.find('.dropdown-menu' + desc)
	
	    if (!$items.length) return
	
	    var index = $items.index(e.target)
	
	    if (e.which == 38 && index > 0)                 index--         // up
	    if (e.which == 40 && index < $items.length - 1) index++         // down
	    if (!~index)                                    index = 0
	
	    $items.eq(index).trigger('focus')
	  }
	
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.dropdown')
	
	      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.dropdown
	
	  $.fn.dropdown             = Plugin
	  $.fn.dropdown.Constructor = Dropdown
	
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old
	    return this
	  }
	
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document)
	    .on('click.bs.dropdown.data-api', clearMenus)
	    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
	    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
	    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
	    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: modal.js v3.3.7
	 * http://getbootstrap.com/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // MODAL CLASS DEFINITION
	  // ======================
	
	  var Modal = function (element, options) {
	    this.options             = options
	    this.$body               = $(document.body)
	    this.$element            = $(element)
	    this.$dialog             = this.$element.find('.modal-dialog')
	    this.$backdrop           = null
	    this.isShown             = null
	    this.originalBodyPad     = null
	    this.scrollbarWidth      = 0
	    this.ignoreBackdropClick = false
	
	    if (this.options.remote) {
	      this.$element
	        .find('.modal-content')
	        .load(this.options.remote, $.proxy(function () {
	          this.$element.trigger('loaded.bs.modal')
	        }, this))
	    }
	  }
	
	  Modal.VERSION  = '3.3.7'
	
	  Modal.TRANSITION_DURATION = 300
	  Modal.BACKDROP_TRANSITION_DURATION = 150
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  }
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget)
	  }
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this
	    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })
	
	    this.$element.trigger(e)
	
	    if (this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = true
	
	    this.checkScrollbar()
	    this.setScrollbar()
	    this.$body.addClass('modal-open')
	
	    this.escape()
	    this.resize()
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
	      })
	    })
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade')
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body) // don't move modals dom position
	      }
	
	      that.$element
	        .show()
	        .scrollTop(0)
	
	      that.adjustDialog()
	
	      if (transition) {
	        that.$element[0].offsetWidth // force reflow
	      }
	
	      that.$element.addClass('in')
	
	      that.enforceFocus()
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })
	
	      transition ?
	        that.$dialog // wait for modal to slide in
	          .one('bsTransitionEnd', function () {
	            that.$element.trigger('focus').trigger(e)
	          })
	          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	        that.$element.trigger('focus').trigger(e)
	    })
	  }
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault()
	
	    e = $.Event('hide.bs.modal')
	
	    this.$element.trigger(e)
	
	    if (!this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = false
	
	    this.escape()
	    this.resize()
	
	    $(document).off('focusin.bs.modal')
	
	    this.$element
	      .removeClass('in')
	      .off('click.dismiss.bs.modal')
	      .off('mouseup.dismiss.bs.modal')
	
	    this.$dialog.off('mousedown.dismiss.bs.modal')
	
	    $.support.transition && this.$element.hasClass('fade') ?
	      this.$element
	        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
	        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	      this.hideModal()
	  }
	
	  Modal.prototype.enforceFocus = function () {
	    $(document)
	      .off('focusin.bs.modal') // guard against infinite focus loop
	      .on('focusin.bs.modal', $.proxy(function (e) {
	        if (document !== e.target &&
	            this.$element[0] !== e.target &&
	            !this.$element.has(e.target).length) {
	          this.$element.trigger('focus')
	        }
	      }, this))
	  }
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide()
	      }, this))
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal')
	    }
	  }
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
	    } else {
	      $(window).off('resize.bs.modal')
	    }
	  }
	
	  Modal.prototype.hideModal = function () {
	    var that = this
	    this.$element.hide()
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open')
	      that.resetAdjustments()
	      that.resetScrollbar()
	      that.$element.trigger('hidden.bs.modal')
	    })
	  }
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove()
	    this.$backdrop = null
	  }
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this
	    var animate = this.$element.hasClass('fade') ? 'fade' : ''
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate
	
	      this.$backdrop = $(document.createElement('div'))
	        .addClass('modal-backdrop ' + animate)
	        .appendTo(this.$body)
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false
	          return
	        }
	        if (e.target !== e.currentTarget) return
	        this.options.backdrop == 'static'
	          ? this.$element[0].focus()
	          : this.hide()
	      }, this))
	
	      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow
	
	      this.$backdrop.addClass('in')
	
	      if (!callback) return
	
	      doAnimate ?
	        this.$backdrop
	          .one('bsTransitionEnd', callback)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callback()
	
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in')
	
	      var callbackRemove = function () {
	        that.removeBackdrop()
	        callback && callback()
	      }
	      $.support.transition && this.$element.hasClass('fade') ?
	        this.$backdrop
	          .one('bsTransitionEnd', callbackRemove)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callbackRemove()
	
	    } else if (callback) {
	      callback()
	    }
	  }
	
	  // these following methods are used to handle overflowing modals
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog()
	  }
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight
	
	    this.$element.css({
	      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    })
	  }
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    })
	  }
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth
	    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
	      var documentElementRect = document.documentElement.getBoundingClientRect()
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
	    this.scrollbarWidth = this.measureScrollbar()
	  }
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
	    this.originalBodyPad = document.body.style.paddingRight || ''
	    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
	  }
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad)
	  }
	
	  Modal.prototype.measureScrollbar = function () { // thx walsh
	    var scrollDiv = document.createElement('div')
	    scrollDiv.className = 'modal-scrollbar-measure'
	    this.$body.append(scrollDiv)
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
	    this.$body[0].removeChild(scrollDiv)
	    return scrollbarWidth
	  }
	
	
	  // MODAL PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.modal')
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
	      if (typeof option == 'string') data[option](_relatedTarget)
	      else if (options.show) data.show(_relatedTarget)
	    })
	  }
	
	  var old = $.fn.modal
	
	  $.fn.modal             = Plugin
	  $.fn.modal.Constructor = Modal
	
	
	  // MODAL NO CONFLICT
	  // =================
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old
	    return this
	  }
	
	
	  // MODAL DATA-API
	  // ==============
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this   = $(this)
	    var href    = $this.attr('href')
	    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
	    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())
	
	    if ($this.is('a')) e.preventDefault()
	
	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus')
	      })
	    })
	    Plugin.call($target, option, this)
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tooltip.js v3.3.7
	 * http://getbootstrap.com/javascript/#tooltip
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TOOLTIP PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Tooltip = function (element, options) {
	    this.type       = null
	    this.options    = null
	    this.enabled    = null
	    this.timeout    = null
	    this.hoverState = null
	    this.$element   = null
	    this.inState    = null
	
	    this.init('tooltip', element, options)
	  }
	
	  Tooltip.VERSION  = '3.3.7'
	
	  Tooltip.TRANSITION_DURATION = 150
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false,
	    viewport: {
	      selector: 'body',
	      padding: 0
	    }
	  }
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled   = true
	    this.type      = type
	    this.$element  = $(element)
	    this.options   = this.getOptions(options)
	    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
	    this.inState   = { click: false, hover: false, focus: false }
	
	    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
	      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
	    }
	
	    var triggers = this.options.trigger.split(' ')
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i]
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
	      } else if (trigger != 'manual') {
	        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'
	
	        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
	      }
	    }
	
	    this.options.selector ?
	      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
	      this.fixTitle()
	  }
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS
	  }
	
	  Tooltip.prototype.getOptions = function (options) {
	    options = $.extend({}, this.getDefaults(), this.$element.data(), options)
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      }
	    }
	
	    return options
	  }
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options  = {}
	    var defaults = this.getDefaults()
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value
	    })
	
	    return options
	  }
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
	    }
	
	    if (self.tip().hasClass('in') || self.hoverState == 'in') {
	      self.hoverState = 'in'
	      return
	    }
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'in'
	
	    if (!self.options.delay || !self.options.delay.show) return self.show()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show()
	    }, self.options.delay.show)
	  }
	
	  Tooltip.prototype.isInStateTrue = function () {
	    for (var key in this.inState) {
	      if (this.inState[key]) return true
	    }
	
	    return false
	  }
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
	    }
	
	    if (self.isInStateTrue()) return
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'out'
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide()
	    }, self.options.delay.hide)
	  }
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type)
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e)
	
	      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
	      if (e.isDefaultPrevented() || !inDom) return
	      var that = this
	
	      var $tip = this.tip()
	
	      var tipId = this.getUID(this.type)
	
	      this.setContent()
	      $tip.attr('id', tipId)
	      this.$element.attr('aria-describedby', tipId)
	
	      if (this.options.animation) $tip.addClass('fade')
	
	      var placement = typeof this.options.placement == 'function' ?
	        this.options.placement.call(this, $tip[0], this.$element[0]) :
	        this.options.placement
	
	      var autoToken = /\s?auto?\s?/i
	      var autoPlace = autoToken.test(placement)
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'
	
	      $tip
	        .detach()
	        .css({ top: 0, left: 0, display: 'block' })
	        .addClass(placement)
	        .data('bs.' + this.type, this)
	
	      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
	      this.$element.trigger('inserted.bs.' + this.type)
	
	      var pos          = this.getPosition()
	      var actualWidth  = $tip[0].offsetWidth
	      var actualHeight = $tip[0].offsetHeight
	
	      if (autoPlace) {
	        var orgPlacement = placement
	        var viewportDim = this.getPosition(this.$viewport)
	
	        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
	                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
	                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
	                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
	                    placement
	
	        $tip
	          .removeClass(orgPlacement)
	          .addClass(placement)
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)
	
	      this.applyPlacement(calculatedOffset, placement)
	
	      var complete = function () {
	        var prevHoverState = that.hoverState
	        that.$element.trigger('shown.bs.' + that.type)
	        that.hoverState = null
	
	        if (prevHoverState == 'out') that.leave(that)
	      }
	
	      $.support.transition && this.$tip.hasClass('fade') ?
	        $tip
	          .one('bsTransitionEnd', complete)
	          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	        complete()
	    }
	  }
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var $tip   = this.tip()
	    var width  = $tip[0].offsetWidth
	    var height = $tip[0].offsetHeight
	
	    // manually read margins because getBoundingClientRect includes difference
	    var marginTop = parseInt($tip.css('margin-top'), 10)
	    var marginLeft = parseInt($tip.css('margin-left'), 10)
	
	    // we must check for NaN for ie 8/9
	    if (isNaN(marginTop))  marginTop  = 0
	    if (isNaN(marginLeft)) marginLeft = 0
	
	    offset.top  += marginTop
	    offset.left += marginLeft
	
	    // $.fn.offset doesn't round pixel values
	    // so we use setOffset directly with our own function B-0
	    $.offset.setOffset($tip[0], $.extend({
	      using: function (props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        })
	      }
	    }, offset), 0)
	
	    $tip.addClass('in')
	
	    // check to see if placing tip in new offset caused the tip to resize itself
	    var actualWidth  = $tip[0].offsetWidth
	    var actualHeight = $tip[0].offsetHeight
	
	    if (placement == 'top' && actualHeight != height) {
	      offset.top = offset.top + height - actualHeight
	    }
	
	    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)
	
	    if (delta.left) offset.left += delta.left
	    else offset.top += delta.top
	
	    var isVertical          = /top|bottom/.test(placement)
	    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
	    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'
	
	    $tip.offset(offset)
	    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
	  }
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
	    this.arrow()
	      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
	      .css(isVertical ? 'top' : 'left', '')
	  }
	
	  Tooltip.prototype.setContent = function () {
	    var $tip  = this.tip()
	    var title = this.getTitle()
	
	    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
	    $tip.removeClass('fade in top bottom left right')
	  }
	
	  Tooltip.prototype.hide = function (callback) {
	    var that = this
	    var $tip = $(this.$tip)
	    var e    = $.Event('hide.bs.' + this.type)
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach()
	      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
	        that.$element
	          .removeAttr('aria-describedby')
	          .trigger('hidden.bs.' + that.type)
	      }
	      callback && callback()
	    }
	
	    this.$element.trigger(e)
	
	    if (e.isDefaultPrevented()) return
	
	    $tip.removeClass('in')
	
	    $.support.transition && $tip.hasClass('fade') ?
	      $tip
	        .one('bsTransitionEnd', complete)
	        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	      complete()
	
	    this.hoverState = null
	
	    return this
	  }
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
	    }
	  }
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle()
	  }
	
	  Tooltip.prototype.getPosition = function ($element) {
	    $element   = $element || this.$element
	
	    var el     = $element[0]
	    var isBody = el.tagName == 'BODY'
	
	    var elRect    = el.getBoundingClientRect()
	    if (elRect.width == null) {
	      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
	      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
	    }
	    var isSvg = window.SVGElement && el instanceof window.SVGElement
	    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
	    // See https://github.com/twbs/bootstrap/issues/20280
	    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
	    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
	    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null
	
	    return $.extend({}, elRect, scroll, outerDims, elOffset)
	  }
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
	        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }
	
	  }
	
	  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
	    var delta = { top: 0, left: 0 }
	    if (!this.$viewport) return delta
	
	    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
	    var viewportDimensions = this.getPosition(this.$viewport)
	
	    if (/right|left/.test(placement)) {
	      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
	      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
	      if (topEdgeOffset < viewportDimensions.top) { // top overflow
	        delta.top = viewportDimensions.top - topEdgeOffset
	      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
	        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
	      }
	    } else {
	      var leftEdgeOffset  = pos.left - viewportPadding
	      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
	      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
	        delta.left = viewportDimensions.left - leftEdgeOffset
	      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
	        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
	      }
	    }
	
	    return delta
	  }
	
	  Tooltip.prototype.getTitle = function () {
	    var title
	    var $e = this.$element
	    var o  = this.options
	
	    title = $e.attr('data-original-title')
	      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)
	
	    return title
	  }
	
	  Tooltip.prototype.getUID = function (prefix) {
	    do prefix += ~~(Math.random() * 1000000)
	    while (document.getElementById(prefix))
	    return prefix
	  }
	
	  Tooltip.prototype.tip = function () {
	    if (!this.$tip) {
	      this.$tip = $(this.options.template)
	      if (this.$tip.length != 1) {
	        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
	      }
	    }
	    return this.$tip
	  }
	
	  Tooltip.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
	  }
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true
	  }
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false
	  }
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled
	  }
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = this
	    if (e) {
	      self = $(e.currentTarget).data('bs.' + this.type)
	      if (!self) {
	        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
	        $(e.currentTarget).data('bs.' + this.type, self)
	      }
	    }
	
	    if (e) {
	      self.inState.click = !self.inState.click
	      if (self.isInStateTrue()) self.enter(self)
	      else self.leave(self)
	    } else {
	      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
	    }
	  }
	
	  Tooltip.prototype.destroy = function () {
	    var that = this
	    clearTimeout(this.timeout)
	    this.hide(function () {
	      that.$element.off('.' + that.type).removeData('bs.' + that.type)
	      if (that.$tip) {
	        that.$tip.detach()
	      }
	      that.$tip = null
	      that.$arrow = null
	      that.$viewport = null
	      that.$element = null
	    })
	  }
	
	
	  // TOOLTIP PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.tooltip')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tooltip
	
	  $.fn.tooltip             = Plugin
	  $.fn.tooltip.Constructor = Tooltip
	
	
	  // TOOLTIP NO CONFLICT
	  // ===================
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: popover.js v3.3.7
	 * http://getbootstrap.com/javascript/#popovers
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // POPOVER PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Popover = function (element, options) {
	    this.init('popover', element, options)
	  }
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')
	
	  Popover.VERSION  = '3.3.7'
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  })
	
	
	  // NOTE: POPOVER EXTENDS tooltip.js
	  // ================================
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)
	
	  Popover.prototype.constructor = Popover
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS
	  }
	
	  Popover.prototype.setContent = function () {
	    var $tip    = this.tip()
	    var title   = this.getTitle()
	    var content = this.getContent()
	
	    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
	    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
	      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
	    ](content)
	
	    $tip.removeClass('fade top bottom left right in')
	
	    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
	    // this manually by checking the contents.
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
	  }
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent()
	  }
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element
	    var o  = this.options
	
	    return $e.attr('data-content')
	      || (typeof o.content == 'function' ?
	            o.content.call($e[0]) :
	            o.content)
	  }
	
	  Popover.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
	  }
	
	
	  // POPOVER PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.popover')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.popover
	
	  $.fn.popover             = Plugin
	  $.fn.popover.Constructor = Popover
	
	
	  // POPOVER NO CONFLICT
	  // ===================
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: scrollspy.js v3.3.7
	 * http://getbootstrap.com/javascript/#scrollspy
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // SCROLLSPY CLASS DEFINITION
	  // ==========================
	
	  function ScrollSpy(element, options) {
	    this.$body          = $(document.body)
	    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
	    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
	    this.selector       = (this.options.target || '') + ' .nav li > a'
	    this.offsets        = []
	    this.targets        = []
	    this.activeTarget   = null
	    this.scrollHeight   = 0
	
	    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
	    this.refresh()
	    this.process()
	  }
	
	  ScrollSpy.VERSION  = '3.3.7'
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  }
	
	  ScrollSpy.prototype.getScrollHeight = function () {
	    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
	  }
	
	  ScrollSpy.prototype.refresh = function () {
	    var that          = this
	    var offsetMethod  = 'offset'
	    var offsetBase    = 0
	
	    this.offsets      = []
	    this.targets      = []
	    this.scrollHeight = this.getScrollHeight()
	
	    if (!$.isWindow(this.$scrollElement[0])) {
	      offsetMethod = 'position'
	      offsetBase   = this.$scrollElement.scrollTop()
	    }
	
	    this.$body
	      .find(this.selector)
	      .map(function () {
	        var $el   = $(this)
	        var href  = $el.data('target') || $el.attr('href')
	        var $href = /^#./.test(href) && $(href)
	
	        return ($href
	          && $href.length
	          && $href.is(':visible')
	          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
	      })
	      .sort(function (a, b) { return a[0] - b[0] })
	      .each(function () {
	        that.offsets.push(this[0])
	        that.targets.push(this[1])
	      })
	  }
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
	    var scrollHeight = this.getScrollHeight()
	    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
	    var offsets      = this.offsets
	    var targets      = this.targets
	    var activeTarget = this.activeTarget
	    var i
	
	    if (this.scrollHeight != scrollHeight) {
	      this.refresh()
	    }
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
	    }
	
	    if (activeTarget && scrollTop < offsets[0]) {
	      this.activeTarget = null
	      return this.clear()
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i]
	        && scrollTop >= offsets[i]
	        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
	        && this.activate(targets[i])
	    }
	  }
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target
	
	    this.clear()
	
	    var selector = this.selector +
	      '[data-target="' + target + '"],' +
	      this.selector + '[href="' + target + '"]'
	
	    var active = $(selector)
	      .parents('li')
	      .addClass('active')
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active
	        .closest('li.dropdown')
	        .addClass('active')
	    }
	
	    active.trigger('activate.bs.scrollspy')
	  }
	
	  ScrollSpy.prototype.clear = function () {
	    $(this.selector)
	      .parentsUntil(this.options.target, '.active')
	      .removeClass('active')
	  }
	
	
	  // SCROLLSPY PLUGIN DEFINITION
	  // ===========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.scrollspy')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.scrollspy
	
	  $.fn.scrollspy             = Plugin
	  $.fn.scrollspy.Constructor = ScrollSpy
	
	
	  // SCROLLSPY NO CONFLICT
	  // =====================
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old
	    return this
	  }
	
	
	  // SCROLLSPY DATA-API
	  // ==================
	
	  $(window).on('load.bs.scrollspy.data-api', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this)
	      Plugin.call($spy, $spy.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tab.js v3.3.7
	 * http://getbootstrap.com/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function (element) {
	    // jscs:disable requireDollarBeforejQueryAssignment
	    this.element = $(element)
	    // jscs:enable requireDollarBeforejQueryAssignment
	  }
	
	  Tab.VERSION = '3.3.7'
	
	  Tab.TRANSITION_DURATION = 150
	
	  Tab.prototype.show = function () {
	    var $this    = this.element
	    var $ul      = $this.closest('ul:not(.dropdown-menu)')
	    var selector = $this.data('target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return
	
	    var $previous = $ul.find('.active:last a')
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    })
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    })
	
	    $previous.trigger(hideEvent)
	    $this.trigger(showEvent)
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return
	
	    var $target = $(selector)
	
	    this.activate($this.closest('li'), $ul)
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      })
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      })
	    })
	  }
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active    = container.find('> .active')
	    var transition = callback
	      && $.support.transition
	      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)
	
	    function next() {
	      $active
	        .removeClass('active')
	        .find('> .dropdown-menu > .active')
	          .removeClass('active')
	        .end()
	        .find('[data-toggle="tab"]')
	          .attr('aria-expanded', false)
	
	      element
	        .addClass('active')
	        .find('[data-toggle="tab"]')
	          .attr('aria-expanded', true)
	
	      if (transition) {
	        element[0].offsetWidth // reflow for transition
	        element.addClass('in')
	      } else {
	        element.removeClass('fade')
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element
	          .closest('li.dropdown')
	            .addClass('active')
	          .end()
	          .find('[data-toggle="tab"]')
	            .attr('aria-expanded', true)
	      }
	
	      callback && callback()
	    }
	
	    $active.length && transition ?
	      $active
	        .one('bsTransitionEnd', next)
	        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
	      next()
	
	    $active.removeClass('in')
	  }
	
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.tab')
	
	      if (!data) $this.data('bs.tab', (data = new Tab(this)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tab
	
	  $.fn.tab             = Plugin
	  $.fn.tab.Constructor = Tab
	
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old
	    return this
	  }
	
	
	  // TAB DATA-API
	  // ============
	
	  var clickHandler = function (e) {
	    e.preventDefault()
	    Plugin.call($(this), 'show')
	  }
	
	  $(document)
	    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
	    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: affix.js v3.3.7
	 * http://getbootstrap.com/javascript/#affix
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // AFFIX CLASS DEFINITION
	  // ======================
	
	  var Affix = function (element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options)
	
	    this.$target = $(this.options.target)
	      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
	      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))
	
	    this.$element     = $(element)
	    this.affixed      = null
	    this.unpin        = null
	    this.pinnedOffset = null
	
	    this.checkPosition()
	  }
	
	  Affix.VERSION  = '3.3.7'
	
	  Affix.RESET    = 'affix affix-top affix-bottom'
	
	  Affix.DEFAULTS = {
	    offset: 0,
	    target: window
	  }
	
	  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
	    var scrollTop    = this.$target.scrollTop()
	    var position     = this.$element.offset()
	    var targetHeight = this.$target.height()
	
	    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false
	
	    if (this.affixed == 'bottom') {
	      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
	      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
	    }
	
	    var initializing   = this.affixed == null
	    var colliderTop    = initializing ? scrollTop : position.top
	    var colliderHeight = initializing ? targetHeight : height
	
	    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
	    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'
	
	    return false
	  }
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset
	    this.$element.removeClass(Affix.RESET).addClass('affix')
	    var scrollTop = this.$target.scrollTop()
	    var position  = this.$element.offset()
	    return (this.pinnedOffset = position.top - scrollTop)
	  }
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1)
	  }
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return
	
	    var height       = this.$element.height()
	    var offset       = this.options.offset
	    var offsetTop    = offset.top
	    var offsetBottom = offset.bottom
	    var scrollHeight = Math.max($(document).height(), $(document.body).height())
	
	    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
	    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)
	
	    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)
	
	    if (this.affixed != affix) {
	      if (this.unpin != null) this.$element.css('top', '')
	
	      var affixType = 'affix' + (affix ? '-' + affix : '')
	      var e         = $.Event(affixType + '.bs.affix')
	
	      this.$element.trigger(e)
	
	      if (e.isDefaultPrevented()) return
	
	      this.affixed = affix
	      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null
	
	      this.$element
	        .removeClass(Affix.RESET)
	        .addClass(affixType)
	        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
	    }
	
	    if (affix == 'bottom') {
	      this.$element.offset({
	        top: scrollHeight - height - offsetBottom
	      })
	    }
	  }
	
	
	  // AFFIX PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.affix')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.affix
	
	  $.fn.affix             = Plugin
	  $.fn.affix.Constructor = Affix
	
	
	  // AFFIX NO CONFLICT
	  // =================
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old
	    return this
	  }
	
	
	  // AFFIX DATA-API
	  // ==============
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this)
	      var data = $spy.data()
	
	      data.offset = data.offset || {}
	
	      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
	      if (data.offsetTop    != null) data.offset.top    = data.offsetTop
	
	      Plugin.call($spy, data)
	    })
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(178);
	var Transform = __webpack_require__(179);
	var inherits = __webpack_require__(52);
	var modes = __webpack_require__(180);
	var StreamCipher = __webpack_require__(254);
	var ebtk = __webpack_require__(248);
	
	inherits(Decipher, Transform);
	function Decipher(mode, key, iv) {
	  if (!(this instanceof Decipher)) {
	    return new Decipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._last = void 0;
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Decipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.decrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Decipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  if (!chunk) {
	    return next;
	  }
	
	  this.push(unpad(this._mode.decrypt(this, chunk)));
	
	  next();
	};
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 16) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  if (this.cache.length) {
	    return this.cache;
	  }
	};
	function unpad(last) {
	  var padded = last[15];
	  if (padded === 16) {
	    return;
	  }
	  return last.slice(0, 16 - padded);
	}
	
	var modelist = {
	  ECB: __webpack_require__(252),
	  CBC: __webpack_require__(249),
	  CFB: __webpack_require__(250),
	  OFB: __webpack_require__(253),
	  CTR: __webpack_require__(251)
	};
	
	module.exports = function (crypto) {
	  function createDecipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv, true);
	    }
	    return new Decipher(modelist[config.mode], password, iv);
	  }
	
	  function createDecipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createDecipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createDecipher: createDecipher,
	    createDecipheriv: createDecipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32).Buffer))

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(178);
	var Transform = __webpack_require__(179);
	var inherits = __webpack_require__(52);
	var modes = __webpack_require__(180);
	var ebtk = __webpack_require__(248);
	var StreamCipher = __webpack_require__(254);
	inherits(Cipher, Transform);
	function Cipher(mode, key, iv) {
	  if (!(this instanceof Cipher)) {
	    return new Cipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Cipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.encrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Cipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  this.push(this._mode.encrypt(this, chunk));
	  this._cipher.scrub();
	  next();
	};
	
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 15) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  var len = 16 - this.cache.length;
	  var padBuff = new Buffer(len);
	
	  var i = -1;
	  while (++i < len) {
	    padBuff.writeUInt8(len, i);
	  }
	  var out = Buffer.concat([this.cache, padBuff]);
	  return out;
	};
	var modelist = {
	  ECB: __webpack_require__(252),
	  CBC: __webpack_require__(249),
	  CFB: __webpack_require__(250),
	  OFB: __webpack_require__(253),
	  CTR: __webpack_require__(251)
	};
	module.exports = function (crypto) {
	  function createCipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv);
	    }
	    return new Cipher(modelist[config.mode], password, iv);
	  }
	  function createCipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createCipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createCipher: createCipher,
	    createCipheriv: createCipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32).Buffer))

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function (crypto, exports) {
	  exports = exports || {};
	  var ciphers = __webpack_require__(781)(crypto);
	  exports.createCipher = ciphers.createCipher;
	  exports.createCipheriv = ciphers.createCipheriv;
	  var deciphers = __webpack_require__(780)(crypto);
	  exports.createDecipher = deciphers.createDecipher;
	  exports.createDecipheriv = deciphers.createDecipheriv;
	  var modes = __webpack_require__(180);
	  function listCiphers () {
	    return Object.keys(modes);
	  }
	  exports.listCiphers = listCiphers;
	};
	


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	var convexHull1d = __webpack_require__(784)
	var convexHull2d = __webpack_require__(785)
	var convexHullnd = __webpack_require__(786)
	
	module.exports = convexHull
	
	function convexHull(points) {
	  var n = points.length
	  if(n === 0) {
	    return []
	  } else if(n === 1) {
	    return [[0]]
	  }
	  var d = points[0].length
	  if(d === 0) {
	    return []
	  } else if(d === 1) {
	    return convexHull1d(points)
	  } else if(d === 2) {
	    return convexHull2d(points)
	  }
	  return convexHullnd(points, d)
	}

/***/ }),
/* 784 */
/***/ (function(module, exports) {

	"use strict"
	
	module.exports = convexHull1d
	
	function convexHull1d(points) {
	  var lo = 0
	  var hi = 0
	  for(var i=1; i<points.length; ++i) {
	    if(points[i][0] < points[lo][0]) {
	      lo = i
	    }
	    if(points[i][0] > points[hi][0]) {
	      hi = i
	    }
	  }
	  if(lo < hi) {
	    return [[lo], [hi]]
	  } else if(lo > hi) {
	    return [[hi], [lo]]
	  } else {
	    return [[lo]]
	  }
	}

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = convexHull2D
	
	var monotoneHull = __webpack_require__(1698)
	
	function convexHull2D(points) {
	  var hull = monotoneHull(points)
	  var h = hull.length
	  if(h <= 2) {
	    return []
	  }
	  var edges = new Array(h)
	  var a = hull[h-1]
	  for(var i=0; i<h; ++i) {
	    var b = hull[i]
	    edges[i] = [a,b]
	    a = b
	  }
	  return edges
	}


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = convexHullnD
	
	var ich = __webpack_require__(1693)
	var aff = __webpack_require__(538)
	
	function permute(points, front) {
	  var n = points.length
	  var npoints = new Array(n)
	  for(var i=0; i<front.length; ++i) {
	    npoints[i] = points[front[i]]
	  }
	  var ptr = front.length
	  for(var i=0; i<n; ++i) {
	    if(front.indexOf(i) < 0) {
	      npoints[ptr++] = points[i]
	    }
	  }
	  return npoints
	}
	
	function invPermute(cells, front) {
	  var nc = cells.length
	  var nf = front.length
	  for(var i=0; i<nc; ++i) {
	    var c = cells[i]
	    for(var j=0; j<c.length; ++j) {
	      var x = c[j]
	      if(x < nf) {
	        c[j] = front[x]
	      } else {
	        x = x - nf
	        for(var k=0; k<nf; ++k) {
	          if(x >= front[k]) {
	            x += 1
	          }
	        }
	        c[j] = x
	      }
	    }
	  }
	  return cells
	}
	
	function convexHullnD(points, d) {
	  try {
	    return ich(points, true)
	  } catch(e) {
	    //If point set is degenerate, try to find a basis and rerun it
	    var ah = aff(points)
	    if(ah.length <= d) {
	      //No basis, no try
	      return []
	    }
	    var npoints = permute(points, ah)
	    var nhull   = ich(npoints, true)
	    return invPermute(nhull, ah)
	  }
	}

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(74);
	__webpack_require__(831);
	module.exports = __webpack_require__(23).Array.from;


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(89);
	__webpack_require__(74);
	module.exports = __webpack_require__(829);


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(89);
	__webpack_require__(74);
	module.exports = __webpack_require__(830);


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(23);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(130);
	__webpack_require__(74);
	__webpack_require__(89);
	__webpack_require__(833);
	__webpack_require__(851);
	__webpack_require__(850);
	__webpack_require__(849);
	module.exports = __webpack_require__(23).Map;


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(834);
	module.exports = __webpack_require__(23).Math.sign;


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(835);
	module.exports = __webpack_require__(23).Math.trunc;


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(836);
	module.exports = __webpack_require__(23).Number.isFinite;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(837);
	module.exports = __webpack_require__(23).Number.isNaN;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(838);
	module.exports = __webpack_require__(23).Object.assign;


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(839);
	var $Object = __webpack_require__(23).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(840);
	var $Object = __webpack_require__(23).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(841);
	module.exports = __webpack_require__(23).Object.freeze;


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(842);
	var $Object = __webpack_require__(23).Object;
	module.exports = function getOwnPropertyDescriptor(it, key) {
	  return $Object.getOwnPropertyDescriptor(it, key);
	};


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(843);
	module.exports = __webpack_require__(23).Object.getPrototypeOf;


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(844);
	module.exports = __webpack_require__(23).Object.keys;


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(845);
	module.exports = __webpack_require__(23).Object.setPrototypeOf;


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(852);
	module.exports = __webpack_require__(23).Object.values;


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(130);
	__webpack_require__(74);
	__webpack_require__(89);
	__webpack_require__(846);
	__webpack_require__(853);
	__webpack_require__(854);
	module.exports = __webpack_require__(23).Promise;


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(130);
	__webpack_require__(74);
	__webpack_require__(89);
	__webpack_require__(847);
	__webpack_require__(857);
	__webpack_require__(856);
	__webpack_require__(855);
	module.exports = __webpack_require__(23).Set;


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(848);
	__webpack_require__(130);
	__webpack_require__(858);
	__webpack_require__(859);
	module.exports = __webpack_require__(23).Symbol;


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(74);
	__webpack_require__(89);
	module.exports = __webpack_require__(197).f('iterator');


/***/ }),
/* 809 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(102);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(63);
	var toLength = __webpack_require__(128);
	var toAbsoluteIndex = __webpack_require__(827);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(56);
	var IObject = __webpack_require__(185);
	var toObject = __webpack_require__(73);
	var toLength = __webpack_require__(128);
	var asc = __webpack_require__(814);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(42);
	var isArray = __webpack_require__(261);
	var SPECIES = __webpack_require__(37)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(813);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(45);
	var createDesc = __webpack_require__(105);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(88);
	var gOPS = __webpack_require__(189);
	var pIE = __webpack_require__(104);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 817 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(126);
	var descriptor = __webpack_require__(105);
	var setToStringTag = __webpack_require__(106);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(62)(IteratorPrototype, __webpack_require__(37)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 819 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(36);
	var macrotask = __webpack_require__(275).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(101)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(41);
	var getKeys = __webpack_require__(88);
	var gOPS = __webpack_require__(189);
	var pIE = __webpack_require__(104);
	var toObject = __webpack_require__(73);
	var IObject = __webpack_require__(185);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(71)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(45);
	var anObject = __webpack_require__(50);
	var getKeys = __webpack_require__(88);
	
	module.exports = __webpack_require__(41) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(63);
	var gOPN = __webpack_require__(265).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(41);
	var getKeys = __webpack_require__(88);
	var toIObject = __webpack_require__(63);
	var isEnum = __webpack_require__(104).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(42);
	var anObject = __webpack_require__(50);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(56)(Function.call, __webpack_require__(188).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(193);
	var defined = __webpack_require__(182);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(193);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(36);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(50);
	var get = __webpack_require__(198);
	module.exports = __webpack_require__(23).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(124);
	var ITERATOR = __webpack_require__(37)('iterator');
	var Iterators = __webpack_require__(87);
	module.exports = __webpack_require__(23).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(56);
	var $export = __webpack_require__(31);
	var toObject = __webpack_require__(73);
	var call = __webpack_require__(262);
	var isArrayIter = __webpack_require__(260);
	var toLength = __webpack_require__(128);
	var createProperty = __webpack_require__(815);
	var getIterFn = __webpack_require__(198);
	
	$export($export.S + $export.F * !__webpack_require__(263)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(809);
	var step = __webpack_require__(264);
	var Iterators = __webpack_require__(87);
	var toIObject = __webpack_require__(63);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(186)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(255);
	var validate = __webpack_require__(195);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(257)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(31);
	
	$export($export.S, 'Math', { sign: __webpack_require__(819) });


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(31);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(31);
	var _isFinite = __webpack_require__(36).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(31);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(31);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(821) });


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(31);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(126) });


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(31);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(41), 'Object', { defineProperty: __webpack_require__(45).f });


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(42);
	var meta = __webpack_require__(125).onFreeze;
	
	__webpack_require__(127)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(63);
	var $getOwnPropertyDescriptor = __webpack_require__(188).f;
	
	__webpack_require__(127)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(73);
	var $getPrototypeOf = __webpack_require__(266);
	
	__webpack_require__(127)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(73);
	var $keys = __webpack_require__(88);
	
	__webpack_require__(127)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(31);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(825).set });


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(103);
	var global = __webpack_require__(36);
	var ctx = __webpack_require__(56);
	var classof = __webpack_require__(124);
	var $export = __webpack_require__(31);
	var isObject = __webpack_require__(42);
	var aFunction = __webpack_require__(100);
	var anInstance = __webpack_require__(181);
	var forOf = __webpack_require__(102);
	var speciesConstructor = __webpack_require__(274);
	var task = __webpack_require__(275).set;
	var microtask = __webpack_require__(820)();
	var newPromiseCapabilityModule = __webpack_require__(187);
	var perform = __webpack_require__(268);
	var userAgent = __webpack_require__(828);
	var promiseResolve = __webpack_require__(269);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(37)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(190)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(106)($Promise, PROMISE);
	__webpack_require__(273)(PROMISE);
	Wrapper = __webpack_require__(23)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(263)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(255);
	var validate = __webpack_require__(195);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(257)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(36);
	var has = __webpack_require__(72);
	var DESCRIPTORS = __webpack_require__(41);
	var $export = __webpack_require__(31);
	var redefine = __webpack_require__(270);
	var META = __webpack_require__(125).KEY;
	var $fails = __webpack_require__(71);
	var shared = __webpack_require__(192);
	var setToStringTag = __webpack_require__(106);
	var uid = __webpack_require__(129);
	var wks = __webpack_require__(37);
	var wksExt = __webpack_require__(197);
	var wksDefine = __webpack_require__(196);
	var enumKeys = __webpack_require__(816);
	var isArray = __webpack_require__(261);
	var anObject = __webpack_require__(50);
	var isObject = __webpack_require__(42);
	var toObject = __webpack_require__(73);
	var toIObject = __webpack_require__(63);
	var toPrimitive = __webpack_require__(194);
	var createDesc = __webpack_require__(105);
	var _create = __webpack_require__(126);
	var gOPNExt = __webpack_require__(823);
	var $GOPD = __webpack_require__(188);
	var $GOPS = __webpack_require__(189);
	var $DP = __webpack_require__(45);
	var $keys = __webpack_require__(88);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(265).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(104).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(103)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(62)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(271)('Map');


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(272)('Map');


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(31);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(256)('Map') });


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(31);
	var $values = __webpack_require__(824)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(31);
	var core = __webpack_require__(23);
	var global = __webpack_require__(36);
	var speciesConstructor = __webpack_require__(274);
	var promiseResolve = __webpack_require__(269);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(31);
	var newPromiseCapability = __webpack_require__(187);
	var perform = __webpack_require__(268);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(271)('Set');


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(272)('Set');


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(31);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(256)('Set') });


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(196)('asyncIterator');


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(196)('observable');


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(276)
	
	var zeroBuffer = new Buffer(128)
	zeroBuffer.fill(0)
	
	module.exports = Hmac
	
	function Hmac (alg, key) {
	  if(!(this instanceof Hmac)) return new Hmac(alg, key)
	  this._opad = opad
	  this._alg = alg
	
	  var blocksize = (alg === 'sha512') ? 128 : 64
	
	  key = this._key = !Buffer.isBuffer(key) ? new Buffer(key) : key
	
	  if(key.length > blocksize) {
	    key = createHash(alg).update(key).digest()
	  } else if(key.length < blocksize) {
	    key = Buffer.concat([key, zeroBuffer], blocksize)
	  }
	
	  var ipad = this._ipad = new Buffer(blocksize)
	  var opad = this._opad = new Buffer(blocksize)
	
	  for(var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36
	    opad[i] = key[i] ^ 0x5C
	  }
	
	  this._hash = createHash(alg).update(ipad)
	}
	
	Hmac.prototype.update = function (data, enc) {
	  this._hash.update(data, enc)
	  return this
	}
	
	Hmac.prototype.digest = function (enc) {
	  var h = this._hash.digest()
	  return createHash(this._alg).update(this._opad).update(h).digest(enc)
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32).Buffer))

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var intSize = 4;
	var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
	var chrsz = 8;
	
	function toArray(buf, bigEndian) {
	  if ((buf.length % intSize) !== 0) {
	    var len = buf.length + (intSize - (buf.length % intSize));
	    buf = Buffer.concat([buf, zeroBuffer], len);
	  }
	
	  var arr = [];
	  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
	  for (var i = 0; i < buf.length; i += intSize) {
	    arr.push(fn.call(buf, i));
	  }
	  return arr;
	}
	
	function toBuffer(arr, size, bigEndian) {
	  var buf = new Buffer(size);
	  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
	  for (var i = 0; i < arr.length; i++) {
	    fn.call(buf, arr[i], i * 4, true);
	  }
	  return buf;
	}
	
	function hash(buf, fn, hashSize, bigEndian) {
	  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
	  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
	  return toBuffer(arr, hashSize, bigEndian);
	}
	
	module.exports = { hash: hash };
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32).Buffer))

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	var helpers = __webpack_require__(861);
	
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length
	 */
	function core_md5(x, len)
	{
	  /* append padding */
	  x[len >> 5] |= 0x80 << ((len) % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;
	
	  var a =  1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d =  271733878;
	
	  for(var i = 0; i < x.length; i += 16)
	  {
	    var olda = a;
	    var oldb = b;
	    var oldc = c;
	    var oldd = d;
	
	    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
	    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
	    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
	    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
	    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
	    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
	    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
	    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
	    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
	    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
	    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
	    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
	    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
	    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
	    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
	    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);
	
	    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
	    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
	    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
	    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
	    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
	    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
	    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
	    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
	    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
	    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
	    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
	    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
	    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
	    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
	    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
	    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);
	
	    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
	    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
	    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
	    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
	    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
	    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
	    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
	    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
	    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
	    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
	    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
	    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
	    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
	    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
	    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
	    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);
	
	    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
	    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
	    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
	    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
	    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
	    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
	    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
	    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
	    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
	    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
	    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
	    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
	    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
	    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
	    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
	    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);
	
	    a = safe_add(a, olda);
	    b = safe_add(b, oldb);
	    c = safe_add(c, oldc);
	    d = safe_add(d, oldd);
	  }
	  return Array(a, b, c, d);
	
	}
	
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	function md5_cmn(q, a, b, x, s, t)
	{
	  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
	}
	function md5_ff(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}
	function md5_gg(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}
	function md5_hh(a, b, c, d, x, s, t)
	{
	  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5_ii(a, b, c, d, x, s, t)
	{
	  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
	}
	
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	function safe_add(x, y)
	{
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xFFFF);
	}
	
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	function bit_rol(num, cnt)
	{
	  return (num << cnt) | (num >>> (32 - cnt));
	}
	
	module.exports = function md5(buf) {
	  return helpers.hash(buf, core_md5, 16);
	};


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	var pbkdf2Export = __webpack_require__(1699)
	
	module.exports = function (crypto, exports) {
	  exports = exports || {}
	
	  var exported = pbkdf2Export(crypto)
	
	  exports.pbkdf2 = exported.pbkdf2
	  exports.pbkdf2Sync = exported.pbkdf2Sync
	
	  return exports
	}


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer) {(function() {
	  var g = ('undefined' === typeof window ? global : window) || {}
	  _crypto = (
	    g.crypto || g.msCrypto || __webpack_require__(2236)
	  )
	  module.exports = function(size) {
	    // Modern Browsers
	    if(_crypto.getRandomValues) {
	      var bytes = new Buffer(size); //in browserify, this is an extended Uint8Array
	      /* This will not work in older browsers.
	       * See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
	       */
	    
	      _crypto.getRandomValues(bytes);
	      return bytes;
	    }
	    else if (_crypto.randomBytes) {
	      return _crypto.randomBytes(size)
	    }
	    else
	      throw new Error(
	        'secure random number generation not supported by this browser\n'+
	        'use chrome, FireFox or Internet Explorer 11'
	      )
	  }
	}())
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(32).Buffer))

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(279));
	
	var _index2 = _interopRequireDefault(__webpack_require__(866));
	
	var _index3 = _interopRequireDefault(__webpack_require__(282));
	
	var _index4 = _interopRequireDefault(__webpack_require__(281));
	
	var _index5 = _interopRequireDefault(__webpack_require__(283));
	
	var _index6 = _interopRequireDefault(__webpack_require__(199));
	
	var _index7 = _interopRequireDefault(__webpack_require__(90));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dayPeriodEnum = {
	  am: 'am',
	  pm: 'pm',
	  midnight: 'midnight',
	  noon: 'noon',
	  morning: 'morning',
	  afternoon: 'afternoon',
	  evening: 'evening',
	  night: 'night'
	};
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
	 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
	 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
	 * |  d  | Day of month                   |  D  | Day of year                    |
	 * |  e  | Local day of week              |  E  | Day of week                    |
	 * |  f  |                                |  F* | Day of week in month           |
	 * |  g* | Modified Julian day            |  G  | Era                            |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  i! | ISO day of week                |  I! | ISO week of year               |
	 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
	 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
	 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  n  |                                |  N  |                                |
	 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
	 * |  p! | Long localized time            |  P! | Long localized date            |
	 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
	 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
	 * |  u  | Extended year                  |  U* | Cyclic year                    |
	 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
	 * |  w  | Local week of year             |  W* | Week of month                  |
	 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
	 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
	 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 *
	 * Letters marked by ! are non-standard, but implemented by date-fns:
	 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
	 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
	 *   i.e. 7 for Sunday, 1 for Monday, etc.
	 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
	 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
	 *   `R` is supposed to be used in conjunction with `I` and `i`
	 *   for universal ISO week-numbering date, whereas
	 *   `Y` is supposed to be used in conjunction with `w` and `e`
	 *   for week-numbering date specific to the locale.
	 * - `P` is long localized date format
	 * - `p` is long localized time format
	 */
	
	var formatters = {
	  // Era
	  G: function (date, token, localize) {
	    var era = date.getUTCFullYear() > 0 ? 1 : 0;
	
	    switch (token) {
	      // AD, BC
	      case 'G':
	      case 'GG':
	      case 'GGG':
	        return localize.era(era, {
	          width: 'abbreviated'
	        });
	      // A, B
	
	      case 'GGGGG':
	        return localize.era(era, {
	          width: 'narrow'
	        });
	      // Anno Domini, Before Christ
	
	      case 'GGGG':
	      default:
	        return localize.era(era, {
	          width: 'wide'
	        });
	    }
	  },
	  // Year
	  y: function (date, token, localize) {
	    // Ordinal number
	    if (token === 'yo') {
	      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
	
	      var year = signedYear > 0 ? signedYear : 1 - signedYear;
	      return localize.ordinalNumber(year, {
	        unit: 'year'
	      });
	    }
	
	    return _index.default.y(date, token);
	  },
	  // Local week-numbering year
	  Y: function (date, token, localize, options) {
	    var signedWeekYear = (0, _index6.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
	
	    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
	
	    if (token === 'YY') {
	      var twoDigitYear = weekYear % 100;
	      return (0, _index7.default)(twoDigitYear, 2);
	    } // Ordinal number
	
	
	    if (token === 'Yo') {
	      return localize.ordinalNumber(weekYear, {
	        unit: 'year'
	      });
	    } // Padding
	
	
	    return (0, _index7.default)(weekYear, token.length);
	  },
	  // ISO week-numbering year
	  R: function (date, token) {
	    var isoWeekYear = (0, _index4.default)(date); // Padding
	
	    return (0, _index7.default)(isoWeekYear, token.length);
	  },
	  // Extended year. This is a single number designating the year of this calendar system.
	  // The main difference between `y` and `u` localizers are B.C. years:
	  // | Year | `y` | `u` |
	  // |------|-----|-----|
	  // | AC 1 |   1 |   1 |
	  // | BC 1 |   1 |   0 |
	  // | BC 2 |   2 |  -1 |
	  // Also `yy` always returns the last two digits of a year,
	  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
	  u: function (date, token) {
	    var year = date.getUTCFullYear();
	    return (0, _index7.default)(year, token.length);
	  },
	  // Quarter
	  Q: function (date, token, localize) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	
	    switch (token) {
	      // 1, 2, 3, 4
	      case 'Q':
	        return String(quarter);
	      // 01, 02, 03, 04
	
	      case 'QQ':
	        return (0, _index7.default)(quarter, 2);
	      // 1st, 2nd, 3rd, 4th
	
	      case 'Qo':
	        return localize.ordinalNumber(quarter, {
	          unit: 'quarter'
	        });
	      // Q1, Q2, Q3, Q4
	
	      case 'QQQ':
	        return localize.quarter(quarter, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	      case 'QQQQQ':
	        return localize.quarter(quarter, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // 1st quarter, 2nd quarter, ...
	
	      case 'QQQQ':
	      default:
	        return localize.quarter(quarter, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone quarter
	  q: function (date, token, localize) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	
	    switch (token) {
	      // 1, 2, 3, 4
	      case 'q':
	        return String(quarter);
	      // 01, 02, 03, 04
	
	      case 'qq':
	        return (0, _index7.default)(quarter, 2);
	      // 1st, 2nd, 3rd, 4th
	
	      case 'qo':
	        return localize.ordinalNumber(quarter, {
	          unit: 'quarter'
	        });
	      // Q1, Q2, Q3, Q4
	
	      case 'qqq':
	        return localize.quarter(quarter, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	      case 'qqqqq':
	        return localize.quarter(quarter, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // 1st quarter, 2nd quarter, ...
	
	      case 'qqqq':
	      default:
	        return localize.quarter(quarter, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // Month
	  M: function (date, token, localize) {
	    var month = date.getUTCMonth();
	
	    switch (token) {
	      case 'M':
	      case 'MM':
	        return _index.default.M(date, token);
	      // 1st, 2nd, ..., 12th
	
	      case 'Mo':
	        return localize.ordinalNumber(month + 1, {
	          unit: 'month'
	        });
	      // Jan, Feb, ..., Dec
	
	      case 'MMM':
	        return localize.month(month, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // J, F, ..., D
	
	      case 'MMMMM':
	        return localize.month(month, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // January, February, ..., December
	
	      case 'MMMM':
	      default:
	        return localize.month(month, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone month
	  L: function (date, token, localize) {
	    var month = date.getUTCMonth();
	
	    switch (token) {
	      // 1, 2, ..., 12
	      case 'L':
	        return String(month + 1);
	      // 01, 02, ..., 12
	
	      case 'LL':
	        return (0, _index7.default)(month + 1, 2);
	      // 1st, 2nd, ..., 12th
	
	      case 'Lo':
	        return localize.ordinalNumber(month + 1, {
	          unit: 'month'
	        });
	      // Jan, Feb, ..., Dec
	
	      case 'LLL':
	        return localize.month(month, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // J, F, ..., D
	
	      case 'LLLLL':
	        return localize.month(month, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // January, February, ..., December
	
	      case 'LLLL':
	      default:
	        return localize.month(month, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // Local week of year
	  w: function (date, token, localize, options) {
	    var week = (0, _index5.default)(date, options);
	
	    if (token === 'wo') {
	      return localize.ordinalNumber(week, {
	        unit: 'week'
	      });
	    }
	
	    return (0, _index7.default)(week, token.length);
	  },
	  // ISO week of year
	  I: function (date, token, localize) {
	    var isoWeek = (0, _index3.default)(date);
	
	    if (token === 'Io') {
	      return localize.ordinalNumber(isoWeek, {
	        unit: 'week'
	      });
	    }
	
	    return (0, _index7.default)(isoWeek, token.length);
	  },
	  // Day of the month
	  d: function (date, token, localize) {
	    if (token === 'do') {
	      return localize.ordinalNumber(date.getUTCDate(), {
	        unit: 'date'
	      });
	    }
	
	    return _index.default.d(date, token);
	  },
	  // Day of year
	  D: function (date, token, localize) {
	    var dayOfYear = (0, _index2.default)(date);
	
	    if (token === 'Do') {
	      return localize.ordinalNumber(dayOfYear, {
	        unit: 'dayOfYear'
	      });
	    }
	
	    return (0, _index7.default)(dayOfYear, token.length);
	  },
	  // Day of week
	  E: function (date, token, localize) {
	    var dayOfWeek = date.getUTCDay();
	
	    switch (token) {
	      // Tue
	      case 'E':
	      case 'EE':
	      case 'EEE':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	
	      case 'EEEEE':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	
	      case 'EEEEEE':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	
	      case 'EEEE':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Local day of week
	  e: function (date, token, localize, options) {
	    var dayOfWeek = date.getUTCDay();
	    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
	
	    switch (token) {
	      // Numerical value (Nth day of week with current locale or weekStartsOn)
	      case 'e':
	        return String(localDayOfWeek);
	      // Padded numerical value
	
	      case 'ee':
	        return (0, _index7.default)(localDayOfWeek, 2);
	      // 1st, 2nd, ..., 7th
	
	      case 'eo':
	        return localize.ordinalNumber(localDayOfWeek, {
	          unit: 'day'
	        });
	
	      case 'eee':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	
	      case 'eeeee':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	
	      case 'eeeeee':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	
	      case 'eeee':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone local day of week
	  c: function (date, token, localize, options) {
	    var dayOfWeek = date.getUTCDay();
	    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
	
	    switch (token) {
	      // Numerical value (same as in `e`)
	      case 'c':
	        return String(localDayOfWeek);
	      // Padded numerical value
	
	      case 'cc':
	        return (0, _index7.default)(localDayOfWeek, token.length);
	      // 1st, 2nd, ..., 7th
	
	      case 'co':
	        return localize.ordinalNumber(localDayOfWeek, {
	          unit: 'day'
	        });
	
	      case 'ccc':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // T
	
	      case 'ccccc':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // Tu
	
	      case 'cccccc':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'standalone'
	        });
	      // Tuesday
	
	      case 'cccc':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // ISO day of week
	  i: function (date, token, localize) {
	    var dayOfWeek = date.getUTCDay();
	    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
	
	    switch (token) {
	      // 2
	      case 'i':
	        return String(isoDayOfWeek);
	      // 02
	
	      case 'ii':
	        return (0, _index7.default)(isoDayOfWeek, token.length);
	      // 2nd
	
	      case 'io':
	        return localize.ordinalNumber(isoDayOfWeek, {
	          unit: 'day'
	        });
	      // Tue
	
	      case 'iii':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	
	      case 'iiiii':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	
	      case 'iiiiii':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	
	      case 'iiii':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // AM or PM
	  a: function (date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
	
	    switch (token) {
	      case 'a':
	      case 'aa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	
	      case 'aaa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        }).toLowerCase();
	
	      case 'aaaaa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	
	      case 'aaaa':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // AM, PM, midnight, noon
	  b: function (date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue;
	
	    if (hours === 12) {
	      dayPeriodEnumValue = dayPeriodEnum.noon;
	    } else if (hours === 0) {
	      dayPeriodEnumValue = dayPeriodEnum.midnight;
	    } else {
	      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
	    }
	
	    switch (token) {
	      case 'b':
	      case 'bb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	
	      case 'bbb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        }).toLowerCase();
	
	      case 'bbbbb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	
	      case 'bbbb':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // in the morning, in the afternoon, in the evening, at night
	  B: function (date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue;
	
	    if (hours >= 17) {
	      dayPeriodEnumValue = dayPeriodEnum.evening;
	    } else if (hours >= 12) {
	      dayPeriodEnumValue = dayPeriodEnum.afternoon;
	    } else if (hours >= 4) {
	      dayPeriodEnumValue = dayPeriodEnum.morning;
	    } else {
	      dayPeriodEnumValue = dayPeriodEnum.night;
	    }
	
	    switch (token) {
	      case 'B':
	      case 'BB':
	      case 'BBB':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	
	      case 'BBBBB':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	
	      case 'BBBB':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Hour [1-12]
	  h: function (date, token, localize) {
	    if (token === 'ho') {
	      var hours = date.getUTCHours() % 12;
	      if (hours === 0) hours = 12;
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	
	    return _index.default.h(date, token);
	  },
	  // Hour [0-23]
	  H: function (date, token, localize) {
	    if (token === 'Ho') {
	      return localize.ordinalNumber(date.getUTCHours(), {
	        unit: 'hour'
	      });
	    }
	
	    return _index.default.H(date, token);
	  },
	  // Hour [0-11]
	  K: function (date, token, localize) {
	    var hours = date.getUTCHours() % 12;
	
	    if (token === 'Ko') {
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	
	    return (0, _index7.default)(hours, token.length);
	  },
	  // Hour [1-24]
	  k: function (date, token, localize) {
	    var hours = date.getUTCHours();
	    if (hours === 0) hours = 24;
	
	    if (token === 'ko') {
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	
	    return (0, _index7.default)(hours, token.length);
	  },
	  // Minute
	  m: function (date, token, localize) {
	    if (token === 'mo') {
	      return localize.ordinalNumber(date.getUTCMinutes(), {
	        unit: 'minute'
	      });
	    }
	
	    return _index.default.m(date, token);
	  },
	  // Second
	  s: function (date, token, localize) {
	    if (token === 'so') {
	      return localize.ordinalNumber(date.getUTCSeconds(), {
	        unit: 'second'
	      });
	    }
	
	    return _index.default.s(date, token);
	  },
	  // Fraction of second
	  S: function (date, token) {
	    return _index.default.S(date, token);
	  },
	  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
	  X: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	
	    if (timezoneOffset === 0) {
	      return 'Z';
	    }
	
	    switch (token) {
	      // Hours and optional minutes
	      case 'X':
	        return formatTimezoneWithOptionalMinutes(timezoneOffset);
	      // Hours, minutes and optional seconds without `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `XX`
	
	      case 'XXXX':
	      case 'XX':
	        // Hours and minutes without `:` delimiter
	        return formatTimezone(timezoneOffset);
	      // Hours, minutes and optional seconds with `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `XXX`
	
	      case 'XXXXX':
	      case 'XXX': // Hours and minutes with `:` delimiter
	
	      default:
	        return formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
	  x: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	
	    switch (token) {
	      // Hours and optional minutes
	      case 'x':
	        return formatTimezoneWithOptionalMinutes(timezoneOffset);
	      // Hours, minutes and optional seconds without `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `xx`
	
	      case 'xxxx':
	      case 'xx':
	        // Hours and minutes without `:` delimiter
	        return formatTimezone(timezoneOffset);
	      // Hours, minutes and optional seconds with `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `xxx`
	
	      case 'xxxxx':
	      case 'xxx': // Hours and minutes with `:` delimiter
	
	      default:
	        return formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (GMT)
	  O: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	
	    switch (token) {
	      // Short
	      case 'O':
	      case 'OO':
	      case 'OOO':
	        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
	      // Long
	
	      case 'OOOO':
	      default:
	        return 'GMT' + formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (specific non-location)
	  z: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	
	    switch (token) {
	      // Short
	      case 'z':
	      case 'zz':
	      case 'zzz':
	        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
	      // Long
	
	      case 'zzzz':
	      default:
	        return 'GMT' + formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Seconds timestamp
	  t: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timestamp = Math.floor(originalDate.getTime() / 1000);
	    return (0, _index7.default)(timestamp, token.length);
	  },
	  // Milliseconds timestamp
	  T: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timestamp = originalDate.getTime();
	    return (0, _index7.default)(timestamp, token.length);
	  }
	};
	
	function formatTimezoneShort(offset, dirtyDelimiter) {
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = Math.floor(absOffset / 60);
	  var minutes = absOffset % 60;
	
	  if (minutes === 0) {
	    return sign + String(hours);
	  }
	
	  var delimiter = dirtyDelimiter || '';
	  return sign + String(hours) + delimiter + (0, _index7.default)(minutes, 2);
	}
	
	function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
	  if (offset % 60 === 0) {
	    var sign = offset > 0 ? '-' : '+';
	    return sign + (0, _index7.default)(Math.abs(offset) / 60, 2);
	  }
	
	  return formatTimezone(offset, dirtyDelimiter);
	}
	
	function formatTimezone(offset, dirtyDelimiter) {
	  var delimiter = dirtyDelimiter || '';
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = (0, _index7.default)(Math.floor(absOffset / 60), 2);
	  var minutes = (0, _index7.default)(absOffset % 60, 2);
	  return sign + hours + delimiter + minutes;
	}
	
	var _default = formatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCDayOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	
	function getUTCDayOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var timestamp = date.getTime();
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	  var startOfYearTimestamp = date.getTime();
	  var difference = timestamp - startOfYearTimestamp;
	  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
	}
	
	module.exports = exports.default;

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCDay;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
	  (0, _index3.default)(2, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index2.default)(dirtyDate);
	  var day = (0, _index.default)(dirtyDay);
	  var currentDay = date.getUTCDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCISODay;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCISODay(dirtyDate, dirtyDay) {
	  (0, _index3.default)(2, arguments);
	  var day = (0, _index.default)(dirtyDay);
	
	  if (day % 7 === 0) {
	    day = day - 7;
	  }
	
	  var weekStartsOn = 1;
	  var date = (0, _index2.default)(dirtyDate);
	  var currentDay = date.getUTCDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(282));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var isoWeek = (0, _index.default)(dirtyISOWeek);
	  var diff = (0, _index3.default)(date) - isoWeek;
	  date.setUTCDate(date.getUTCDate() - diff * 7);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(283));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCWeek(dirtyDate, dirtyWeek, options) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var week = (0, _index.default)(dirtyWeek);
	  var diff = (0, _index3.default)(date, options) - week;
	  date.setUTCDate(date.getUTCDate() - diff * 7);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(281));
	
	var _index2 = _interopRequireDefault(__webpack_require__(133));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setUTCFullYear(year, 0, 4);
	  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(199));
	
	var _index3 = _interopRequireDefault(__webpack_require__(109));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
	  (0, _index4.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index.default)(options.firstWeekContainsDate);
	  var year = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var firstWeek = new Date(0);
	  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
	  firstWeek.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index3.default)(firstWeek, dirtyOptions);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = add;
	
	var _index = _interopRequireDefault(__webpack_require__(58));
	
	var _index2 = _interopRequireDefault(__webpack_require__(111));
	
	var _index3 = _interopRequireDefault(__webpack_require__(4));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	var _index5 = _interopRequireDefault(__webpack_require__(10));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name add
	 * @category Common Helpers
	 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
	 *
	 * @description
	 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 *
	 * | Key            | Description                        |
	 * |----------------|------------------------------------|
	 * | years          | Amount of years to be added        |
	 * | months         | Amount of months to be added       |
	 * | weeks          | Amount of weeks to be added        |
	 * | days           | Amount of days to be added         |
	 * | hours          | Amount of hours to be added        |
	 * | minutes        | Amount of minutes to be added      |
	 * | seconds        | Amount of seconds to be added      |
	 *
	 * All values default to 0
	 *
	 * @returns {Date} the new date with the seconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add the following duration to 1 September 2014, 10:19:50
	 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
	 *   years: 2,
	 *   months: 9,
	 *   weeks: 1,
	 *   days: 7,
	 *   hours: 5,
	 *   minutes: 9,
	 *   seconds: 30,
	 * })
	 * //=> Thu Jun 15 2017 15:29:20
	 */
	function add(dirtyDate, duration) {
	  (0, _index4.default)(2, arguments);
	  if (!duration || typeof duration !== 'object') return new Date(NaN);
	  var years = duration.years ? (0, _index5.default)(duration.years) : 0;
	  var months = duration.months ? (0, _index5.default)(duration.months) : 0;
	  var weeks = duration.weeks ? (0, _index5.default)(duration.weeks) : 0;
	  var days = duration.days ? (0, _index5.default)(duration.days) : 0;
	  var hours = duration.hours ? (0, _index5.default)(duration.hours) : 0;
	  var minutes = duration.minutes ? (0, _index5.default)(duration.minutes) : 0;
	  var seconds = duration.seconds ? (0, _index5.default)(duration.seconds) : 0; // Add years and months
	
	  var date = (0, _index3.default)(dirtyDate);
	  var dateWithMonths = months || years ? (0, _index2.default)(date, months + years * 12) : date; // Add weeks and days
	
	  var dateWithDays = days || weeks ? (0, _index.default)(dateWithMonths, days + weeks * 7) : dateWithMonths; // Add days, hours, minutes and seconds
	
	  var minutesToAdd = minutes + hours * 60;
	  var secondsToAdd = seconds + minutesToAdd * 60;
	  var msToAdd = secondsToAdd * 1000;
	  var finalDate = new Date(dateWithDays.getTime() + msToAdd);
	  return finalDate;
	}
	
	module.exports = exports.default;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = areIntervalsOverlapping;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name areIntervalsOverlapping
	 * @category Interval Helpers
	 * @summary Is the given time interval overlapping with another time interval?
	 *
	 * @description
	 * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `areRangesOverlapping` to `areIntervalsOverlapping`.
	 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
	 *
	 *   ```
	 *   2.1.3
	 *   time interval
	 *   part of the time axis limited by two instants
	 *   ```
	 *
	 *   Also, this function now accepts an object with `start` and `end` properties
	 *   instead of two arguments as an interval.
	 *   This function now throws `RangeError` if the start of the interval is after its end
	 *   or if any date in the interval is `Invalid Date`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   areRangesOverlapping(
	 *     new Date(2014, 0, 10), new Date(2014, 0, 20),
	 *     new Date(2014, 0, 17), new Date(2014, 0, 21)
	 *   )
	 *
	 *   // v2.0.0 onward
	 *
	 *   areIntervalsOverlapping(
	 *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *     { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
	 *   )
	 *   ```
	 *
	 * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Object} [options] - the object with options
	 * @param {Boolean} [options.inclusive=false] - whether the comparison is inclusive or not
	 * @returns {Boolean} whether the time intervals are overlapping
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For overlapping time intervals:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
	 * )
	 * //=> true
	 *
	 * @example
	 * // For non-overlapping time intervals:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
	 * )
	 * //=> false
	 *
	 * @example
	 * // For adjacent time intervals:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
	 * )
	 * //=> false
	 *
	 * @example
	 * // Using the inclusive option:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
	 * )
	 * //=> false
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
	 *   { inclusive: true }
	 * )
	 * //=> true
	 */
	function areIntervalsOverlapping(dirtyIntervalLeft, dirtyIntervalRight) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	    inclusive: false
	  };
	  (0, _index2.default)(2, arguments);
	  var intervalLeft = dirtyIntervalLeft || {};
	  var intervalRight = dirtyIntervalRight || {};
	  var leftStartTime = (0, _index.default)(intervalLeft.start).getTime();
	  var leftEndTime = (0, _index.default)(intervalLeft.end).getTime();
	  var rightStartTime = (0, _index.default)(intervalRight.start).getTime();
	  var rightEndTime = (0, _index.default)(intervalRight.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  if (options.inclusive) {
	    return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
	  }
	
	  return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
	}
	
	module.exports = exports.default;

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = clamp;
	
	var _index = _interopRequireDefault(__webpack_require__(333));
	
	var _index2 = _interopRequireDefault(__webpack_require__(334));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name clamp
	 * @category Interval Helpers
	 * @summary Return a date bounded by the start and the end of the given interval
	 *
	 * @description
	 * Clamps a date to the lower bound with the start of the interval and the upper
	 * bound with the end of the interval.
	 *
	 * - When the date is less than the start of the interval, the start is returned.
	 * - When the date is greater than the end of the interval, the end is returned.
	 * - Otherwise the date is returned.
	 *
	 * @example
	 * // What is Mar, 21, 2021 bounded to an interval starting at Mar, 22, 2021 and ending at Apr, 01, 2021
	 * const result = clamp(new Date(2021, 2, 21), {
	 *   start: new Date(2021, 2, 22),
	 *   end: new Date(2021, 3, 1),
	 * })
	 * //=> Mon Mar 22 2021 00:00:00
	 *
	 * @param {Date | Number} date - the date to be bounded
	 * @param {Interval} interval - the interval to bound to
	 * @returns {Date} the date bounded by the start and the end of the interval
	 * @throws {TypeError} 2 arguments required
	 */
	function clamp(date, _ref) {
	  var start = _ref.start,
	      end = _ref.end;
	  (0, _index3.default)(2, arguments);
	  return (0, _index2.default)([(0, _index.default)([date, start]), end]);
	}
	
	module.exports = exports.default;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = closestIndexTo;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name closestIndexTo
	 * @category Common Helpers
	 * @summary Return an index of the closest date from the array comparing to the given date.
	 *
	 * @description
	 * Return an index of the closest date from the array comparing to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - Now, `closestIndexTo` doesn't throw an exception
	 *   when the second argument is not an array, and returns Invalid Date instead.
	 *
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @param {Date[]|Number[]} datesArray - the array to search
	 * @returns {Number} an index of the date closest to the given date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Which date is closer to 6 September 2015?
	 * var dateToCompare = new Date(2015, 8, 6)
	 * var datesArray = [
	 *   new Date(2015, 0, 1),
	 *   new Date(2016, 0, 1),
	 *   new Date(2017, 0, 1)
	 * ]
	 * var result = closestIndexTo(dateToCompare, datesArray)
	 * //=> 1
	 */
	function closestIndexTo(dirtyDateToCompare, dirtyDatesArray) {
	  (0, _index2.default)(2, arguments);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	
	  if (isNaN(dateToCompare)) {
	    return NaN;
	  }
	
	  var timeToCompare = dateToCompare.getTime();
	  var datesArray; // `dirtyDatesArray` is undefined or null
	
	  if (dirtyDatesArray == null) {
	    datesArray = []; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  } else if (typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
	  } else {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  }
	
	  var result;
	  var minDistance;
	  datesArray.forEach(function (dirtyDate, index) {
	    var currentDate = (0, _index.default)(dirtyDate);
	
	    if (isNaN(currentDate)) {
	      result = NaN;
	      minDistance = NaN;
	      return;
	    }
	
	    var distance = Math.abs(timeToCompare - currentDate.getTime());
	
	    if (result == null || distance < minDistance) {
	      result = index;
	      minDistance = distance;
	    }
	  });
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = closestTo;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name closestTo
	 * @category Common Helpers
	 * @summary Return a date from the array closest to the given date.
	 *
	 * @description
	 * Return a date from the array closest to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - Now, `closestTo` doesn't throw an exception
	 *   when the second argument is not an array, and returns Invalid Date instead.
	 *
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @param {Date[]|Number[]} datesArray - the array to search
	 * @returns {Date} the date from the array closest to the given date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
	 * var dateToCompare = new Date(2015, 8, 6)
	 * var result = closestTo(dateToCompare, [
	 *   new Date(2000, 0, 1),
	 *   new Date(2030, 0, 1)
	 * ])
	 * //=> Tue Jan 01 2030 00:00:00
	 */
	function closestTo(dirtyDateToCompare, dirtyDatesArray) {
	  (0, _index2.default)(2, arguments);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	
	  if (isNaN(dateToCompare)) {
	    return new Date(NaN);
	  }
	
	  var timeToCompare = dateToCompare.getTime();
	  var datesArray; // `dirtyDatesArray` is undefined or null
	
	  if (dirtyDatesArray == null) {
	    datesArray = []; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  } else if (typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
	  } else {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  }
	
	  var result;
	  var minDistance;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	
	    if (isNaN(currentDate)) {
	      result = new Date(NaN);
	      minDistance = NaN;
	      return;
	    }
	
	    var distance = Math.abs(timeToCompare - currentDate.getTime());
	
	    if (result == null || distance < minDistance) {
	      result = currentDate;
	      minDistance = distance;
	    }
	  });
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = compareDesc;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name compareDesc
	 * @category Common Helpers
	 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
	 *
	 * @description
	 * Compare the two dates and return -1 if the first date is after the second,
	 * 1 if the first date is before the second or 0 if dates are equal.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to compare
	 * @param {Date|Number} dateRight - the second date to compare
	 * @returns {Number} the result of the comparison
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
	 * const result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
	 * //=> 1
	 *
	 * @example
	 * // Sort the array of dates in reverse chronological order:
	 * const result = [
	 *   new Date(1995, 6, 2),
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * ].sort(compareDesc)
	 * //=> [
	 * //   Sun Jul 02 1995 00:00:00,
	 * //   Mon Jul 10 1989 00:00:00,
	 * //   Wed Feb 11 1987 00:00:00
	 * // ]
	 */
	function compareDesc(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var diff = dateLeft.getTime() - dateRight.getTime();
	
	  if (diff > 0) {
	    return -1;
	  } else if (diff < 0) {
	    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
	  } else {
	    return diff;
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = daysToWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name daysToWeeks
	 * @category Conversion Helpers
	 * @summary Convert days to weeks.
	 *
	 * @description
	 * Convert a number of days to a full number of weeks.
	 *
	 * @param {number} days - number of days to be converted
	 *
	 * @returns {number} the number of days converted in weeks
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 14 days to weeks:
	 * const result = daysToWeeks(14)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = daysToWeeks(13)
	 * //=> 1
	 */
	function daysToWeeks(days) {
	  (0, _index.default)(1, arguments);
	  var weeks = days / _index2.daysInWeek;
	  return Math.floor(weeks);
	}
	
	module.exports = exports.default;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInBusinessDays;
	
	var _index = _interopRequireDefault(__webpack_require__(51));
	
	var _index2 = _interopRequireDefault(__webpack_require__(138));
	
	var _index3 = _interopRequireDefault(__webpack_require__(4));
	
	var _index4 = _interopRequireDefault(__webpack_require__(76));
	
	var _index5 = _interopRequireDefault(__webpack_require__(58));
	
	var _index6 = _interopRequireDefault(__webpack_require__(112));
	
	var _index7 = _interopRequireDefault(__webpack_require__(10));
	
	var _index8 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInBusinessDays
	 * @category Day Helpers
	 * @summary Get the number of business days between the given dates.
	 *
	 * @description
	 * Get the number of business day periods between the given dates.
	 * Business days being days that arent in the weekend.
	 * Like `differenceInCalendarDays`, the function removes the times from
	 * the dates before calculating the difference.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of business days
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many business days are between
	 * // 10 January 2014 and 20 July 2014?
	 * var result = differenceInBusinessDays(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 0, 10)
	 * )
	 * //=> 136
	 */
	function differenceInBusinessDays(dirtyDateLeft, dirtyDateRight) {
	  (0, _index8.default)(2, arguments);
	  var dateLeft = (0, _index3.default)(dirtyDateLeft);
	  var dateRight = (0, _index3.default)(dirtyDateRight);
	  if (!(0, _index.default)(dateLeft) || !(0, _index.default)(dateRight)) return NaN;
	  var calendarDifference = (0, _index4.default)(dateLeft, dateRight);
	  var sign = calendarDifference < 0 ? -1 : 1;
	  var weeks = (0, _index7.default)(calendarDifference / 7);
	  var result = weeks * 5;
	  dateRight = (0, _index5.default)(dateRight, weeks * 7); // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
	
	  while (!(0, _index6.default)(dateLeft, dateRight)) {
	    // sign is used to account for both negative and positive differences
	    result += (0, _index2.default)(dateRight) ? 0 : sign;
	    dateRight = (0, _index5.default)(dateRight, sign);
	  }
	
	  return result === 0 ? 0 : result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarISOWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(57));
	
	var _index2 = _interopRequireDefault(__webpack_require__(81));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name differenceInCalendarISOWeeks
	 * @category ISO Week Helpers
	 * @summary Get the number of calendar ISO weeks between the given dates.
	 *
	 * @description
	 * Get the number of calendar ISO weeks between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar ISO weeks
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
	 * const result = differenceInCalendarISOWeeks(
	 *   new Date(2014, 6, 21),
	 *   new Date(2014, 6, 6)
	 * )
	 * //=> 3
	 */
	
	function differenceInCalendarISOWeeks(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var startOfISOWeekLeft = (0, _index2.default)(dirtyDateLeft);
	  var startOfISOWeekRight = (0, _index2.default)(dirtyDateRight);
	  var timestampLeft = startOfISOWeekLeft.getTime() - (0, _index.default)(startOfISOWeekLeft);
	  var timestampRight = startOfISOWeekRight.getTime() - (0, _index.default)(startOfISOWeekRight); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
	}
	
	module.exports = exports.default;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(306));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInCalendarQuarters
	 * @category Quarter Helpers
	 * @summary Get the number of calendar quarters between the given dates.
	 *
	 * @description
	 * Get the number of calendar quarters between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar quarters
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
	 * var result = differenceInCalendarQuarters(
	 *   new Date(2014, 6, 2),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 3
	 */
	function differenceInCalendarQuarters(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var dateLeft = (0, _index2.default)(dirtyDateLeft);
	  var dateRight = (0, _index2.default)(dirtyDateRight);
	  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
	  var quarterDiff = (0, _index.default)(dateLeft) - (0, _index.default)(dateRight);
	  return yearDiff * 4 + quarterDiff;
	}
	
	module.exports = exports.default;

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInISOWeekYears;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(289));
	
	var _index3 = _interopRequireDefault(__webpack_require__(75));
	
	var _index4 = _interopRequireDefault(__webpack_require__(339));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of full ISO week-numbering years between the given dates.
	 *
	 * @description
	 * Get the number of full ISO week-numbering years between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `differenceInISOYears` to `differenceInISOWeekYears`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full ISO week-numbering years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
	 * var result = differenceInISOWeekYears(
	 *   new Date(2012, 0, 1),
	 *   new Date(2010, 0, 1)
	 * )
	 * //=> 1
	 */
	function differenceInISOWeekYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index5.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = (0, _index3.default)(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  dateLeft = (0, _index4.default)(dateLeft, sign * difference); // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
	  // if last calendar ISO year is not full
	  // If so, result must be decreased by 1 in absolute value
	
	  var isLastISOWeekYearNotFull = Number((0, _index3.default)(dateLeft, dateRight) === -sign);
	  var result = sign * (difference - isLastISOWeekYearNotFull); // Prevent negative zero
	
	  return result === 0 ? 0 : result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(136));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	var _index3 = __webpack_require__(108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInQuarters
	 * @category Quarter Helpers
	 * @summary Get the number of quarters between the given dates.
	 *
	 * @description
	 * Get the number of quarters between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Number} the number of full quarters
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full quarters are between 31 December 2013 and 2 July 2014?
	 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
	 * //=> 2
	 */
	function differenceInQuarters(dateLeft, dateRight, options) {
	  (0, _index2.default)(2, arguments);
	  var diff = (0, _index.default)(dateLeft, dateRight) / 3;
	  return (0, _index3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
	}
	
	module.exports = exports.default;

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(203));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	var _index3 = __webpack_require__(108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInWeeks
	 * @category Week Helpers
	 * @summary Get the number of full weeks between the given dates.
	 *
	 * @description
	 * Get the number of full weeks between two dates. Fractional weeks are
	 * truncated towards zero by default.
	 *
	 * One "full week" is the distance between a local time in one day to the same
	 * local time 7 days earlier or later. A full week can sometimes be less than
	 * or more than 7*24 hours if a daylight savings change happens between two dates.
	 *
	 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
	 * `Math.floor(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
	 *
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Number} the number of full weeks
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full weeks are between 5 July 2014 and 20 July 2014?
	 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
	 * //=> 2
	 *
	 * // How many full weeks are between
	 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
	 * // Note: because local time is used, the
	 * // result will always be 8 weeks (54 days),
	 * // even if DST starts and the period has
	 * // only 54*24-1 hours.
	 * const result = differenceInWeeks(
	 *   new Date(2020, 5, 1),
	 *   new Date(2020, 2, 6)
	 * )
	 * //=> 8
	 */
	function differenceInWeeks(dateLeft, dateRight, options) {
	  (0, _index2.default)(2, arguments);
	  var diff = (0, _index.default)(dateLeft, dateRight) / 7;
	  return (0, _index3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
	}
	
	module.exports = exports.default;

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachHourOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(200));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachHourOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of hours within the specified time interval.
	 *
	 * @description
	 * Return the array of hours within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
	 * @returns {Date[]} the array with starts of hours from the hour of the interval start to the hour of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.step` must be a number greater than 1
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each hour between 6 October 2014, 12:00 and 6 October 2014, 15:00
	 * var result = eachHourOfInterval({
	 *   start: new Date(2014, 9, 6, 12),
	 *   end: new Date(2014, 9, 6, 15)
	 * })
	 * //=> [
	 * //   Mon Oct 06 2014 12:00:00,
	 * //   Mon Oct 06 2014 13:00:00,
	 * //   Mon Oct 06 2014 14:00:00,
	 * //   Mon Oct 06 2014 15:00:00
	 * // ]
	 */
	function eachHourOfInterval(dirtyInterval, options) {
	  (0, _index3.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index2.default)(interval.start);
	  var endDate = (0, _index2.default)(interval.end);
	  var startTime = startDate.getTime();
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startTime <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var dates = [];
	  var currentDate = startDate;
	  currentDate.setMinutes(0, 0, 0);
	  var step = options && 'step' in options ? Number(options.step) : 1;
	  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index2.default)(currentDate));
	    currentDate = (0, _index.default)(currentDate, step);
	  }
	
	  return dates;
	}
	
	module.exports = exports.default;

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachMinuteOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(201));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(213));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachMinuteOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of minutes within the specified time interval.
	 *
	 * @description
	 * Returns the array of minutes within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.step=1] - the step to increment by. The starts of minutes from the hour of the interval start to the hour of the interval end
	 * @throws {TypeError} 1 argument requie value should be more than 1.
	 * @returns {Date[]} the array withred
	 * @throws {RangeError} `options.step` must be a number equal or greater than 1
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each minute between 14 October 2020, 13:00 and 14 October 2020, 13:03
	 * const result = eachMinuteOfInterval({
	 *   start: new Date(2014, 9, 14, 13),
	 *   end: new Date(2014, 9, 14, 13, 3)
	 * })
	 * //=> [
	 * //   Wed Oct 14 2014 13:00:00,
	 * //   Wed Oct 14 2014 13:01:00,
	 * //   Wed Oct 14 2014 13:02:00,
	 * //   Wed Oct 14 2014 13:03:00
	 * // ]
	 */
	function eachMinuteOfInterval(interval, options) {
	  (0, _index4.default)(1, arguments);
	  var startDate = (0, _index3.default)((0, _index2.default)(interval.start));
	  var endDate = (0, _index3.default)((0, _index2.default)(interval.end));
	  var startTime = startDate.getTime();
	  var endTime = endDate.getTime();
	
	  if (startTime >= endTime) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var dates = [];
	  var currentDate = startDate;
	  var step = options && 'step' in options ? Number(options.step) : 1;
	  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number equal or greater than 1');
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index2.default)(currentDate));
	    currentDate = (0, _index.default)(currentDate, step);
	  }
	
	  return dates;
	}
	
	module.exports = exports.default;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachMonthOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachMonthOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of months within the specified time interval.
	 *
	 * @description
	 * Return the array of months within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @returns {Date[]} the array with starts of months from the month of the interval start to the month of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each month between 6 February 2014 and 10 August 2014:
	 * var result = eachMonthOfInterval({
	 *   start: new Date(2014, 1, 6),
	 *   end: new Date(2014, 7, 10)
	 * })
	 * //=> [
	 * //   Sat Feb 01 2014 00:00:00,
	 * //   Sat Mar 01 2014 00:00:00,
	 * //   Tue Apr 01 2014 00:00:00,
	 * //   Thu May 01 2014 00:00:00,
	 * //   Sun Jun 01 2014 00:00:00,
	 * //   Tue Jul 01 2014 00:00:00,
	 * //   Fri Aug 01 2014 00:00:00
	 * // ]
	 */
	function eachMonthOfInterval(dirtyInterval) {
	  (0, _index2.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index.default)(interval.start);
	  var endDate = (0, _index.default)(interval.end);
	  var endTime = endDate.getTime();
	  var dates = []; // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var currentDate = startDate;
	  currentDate.setHours(0, 0, 0, 0);
	  currentDate.setDate(1);
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index.default)(currentDate));
	    currentDate.setMonth(currentDate.getMonth() + 1);
	  }
	
	  return dates;
	}
	
	module.exports = exports.default;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachQuarterOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(202));
	
	var _index2 = _interopRequireDefault(__webpack_require__(214));
	
	var _index3 = _interopRequireDefault(__webpack_require__(4));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachQuarterOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of quarters within the specified time interval.
	 *
	 * @description
	 * Return the array of quarters within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @returns {Date[]} the array with starts of quarters from the quarter of the interval start to the quarter of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each quarter within interval 6 February 2014 - 10 August 2014:
	 * var result = eachQuarterOfInterval({
	 *   start: new Date(2014, 1, 6),
	 *   end: new Date(2014, 7, 10)
	 * })
	 * //=> [
	 * //   Wed Jan 01 2014 00:00:00,
	 * //   Tue Apr 01 2014 00:00:00,
	 * //   Tue Jul 01 2014 00:00:00,
	 * // ]
	 */
	function eachQuarterOfInterval(dirtyInterval) {
	  (0, _index4.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index3.default)(interval.start);
	  var endDate = (0, _index3.default)(interval.end);
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var startDateQuarter = (0, _index2.default)(startDate);
	  var endDateQuarter = (0, _index2.default)(endDate);
	  endTime = endDateQuarter.getTime();
	  var quarters = [];
	  var currentQuarter = startDateQuarter;
	
	  while (currentQuarter.getTime() <= endTime) {
	    quarters.push((0, _index3.default)(currentQuarter));
	    currentQuarter = (0, _index.default)(currentQuarter, 1);
	  }
	
	  return quarters;
	}
	
	module.exports = exports.default;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachWeekOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(134));
	
	var _index2 = _interopRequireDefault(__webpack_require__(66));
	
	var _index3 = _interopRequireDefault(__webpack_require__(4));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachWeekOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of weeks within the specified time interval.
	 *
	 * @description
	 * Return the array of weeks within the specified time interval.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date[]} the array with starts of weeks from the week of the interval start to the week of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be 0, 1, ..., 6
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each week within interval 6 October 2014 - 23 November 2014:
	 * var result = eachWeekOfInterval({
	 *   start: new Date(2014, 9, 6),
	 *   end: new Date(2014, 10, 23)
	 * })
	 * //=> [
	 * //   Sun Oct 05 2014 00:00:00,
	 * //   Sun Oct 12 2014 00:00:00,
	 * //   Sun Oct 19 2014 00:00:00,
	 * //   Sun Oct 26 2014 00:00:00,
	 * //   Sun Nov 02 2014 00:00:00,
	 * //   Sun Nov 09 2014 00:00:00,
	 * //   Sun Nov 16 2014 00:00:00,
	 * //   Sun Nov 23 2014 00:00:00
	 * // ]
	 */
	function eachWeekOfInterval(dirtyInterval, options) {
	  (0, _index4.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index3.default)(interval.start);
	  var endDate = (0, _index3.default)(interval.end);
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var startDateWeek = (0, _index2.default)(startDate, options);
	  var endDateWeek = (0, _index2.default)(endDate, options); // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
	
	  startDateWeek.setHours(15);
	  endDateWeek.setHours(15);
	  endTime = endDateWeek.getTime();
	  var weeks = [];
	  var currentWeek = startDateWeek;
	
	  while (currentWeek.getTime() <= endTime) {
	    currentWeek.setHours(0);
	    weeks.push((0, _index3.default)(currentWeek));
	    currentWeek = (0, _index.default)(currentWeek, 1);
	    currentWeek.setHours(15);
	  }
	
	  return weeks;
	}
	
	module.exports = exports.default;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachWeekendOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(205));
	
	var _index2 = _interopRequireDefault(__webpack_require__(140));
	
	var _index3 = _interopRequireDefault(__webpack_require__(207));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachWeekendOfMonth
	 * @category Month Helpers
	 * @summary List all the Saturdays and Sundays in the given month.
	 *
	 * @description
	 * Get all the Saturdays and Sundays in the given month.
	 *
	 * @param {Date|Number} date - the given month
	 * @returns {Date[]} an array containing all the Saturdays and Sundays
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The passed date is invalid
	 *
	 * @example
	 * // Lists all Saturdays and Sundays in the given month
	 * const result = eachWeekendOfMonth(new Date(2022, 1, 1))
	 * //=> [
	 * //   Sat Feb 05 2022 00:00:00,
	 * //   Sun Feb 06 2022 00:00:00,
	 * //   Sat Feb 12 2022 00:00:00,
	 * //   Sun Feb 13 2022 00:00:00,
	 * //   Sat Feb 19 2022 00:00:00,
	 * //   Sun Feb 20 2022 00:00:00,
	 * //   Sat Feb 26 2022 00:00:00,
	 * //   Sun Feb 27 2022 00:00:00
	 * // ]
	 */
	function eachWeekendOfMonth(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var startDate = (0, _index2.default)(dirtyDate);
	  if (isNaN(startDate.getTime())) throw new RangeError('The passed date is invalid');
	  var endDate = (0, _index3.default)(dirtyDate);
	  return (0, _index.default)({
	    start: startDate,
	    end: endDate
	  });
	}
	
	module.exports = exports.default;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachWeekendOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(205));
	
	var _index2 = _interopRequireDefault(__webpack_require__(216));
	
	var _index3 = _interopRequireDefault(__webpack_require__(298));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachWeekendOfYear
	 * @category Year Helpers
	 * @summary List all the Saturdays and Sundays in the year.
	 *
	 * @description
	 * Get all the Saturdays and Sundays in the year.
	 *
	 * @param {Date|Number} date - the given year
	 * @returns {Date[]} an array containing all the Saturdays and Sundays
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The passed date is invalid
	 *
	 * @example
	 * // Lists all Saturdays and Sundays in the year
	 * var result = eachWeekendOfYear(new Date(2020, 1, 1))
	 * //=> [
	 * //   Sat Jan 03 2020 00:00:00,
	 * //   Sun Jan 04 2020 00:00:00,
	 * //   ...
	 * //   Sun Dec 27 2020 00:00:00
	 * // ]
	 * ]
	 */
	function eachWeekendOfYear(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var startDate = (0, _index2.default)(dirtyDate);
	  if (isNaN(startDate)) throw new RangeError('The passed date is invalid');
	  var endDate = (0, _index3.default)(dirtyDate);
	  return (0, _index.default)({
	    start: startDate,
	    end: endDate
	  });
	}
	
	module.exports = exports.default;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachYearOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachYearOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of yearly timestamps within the specified time interval.
	 *
	 * @description
	 * Return the array of yearly timestamps within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @returns {Date[]} the array with starts of yearly timestamps from the month of the interval start to the month of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each year between 6 February 2014 and 10 August 2017:
	 * const result = eachYearOfInterval({
	 *   start: new Date(2014, 1, 6),
	 *   end: new Date(2017, 7, 10)
	 * })
	 * //=> [
	 * //   Wed Jan 01 2014 00:00:00,
	 * //   Thu Jan 01 2015 00:00:00,
	 * //   Fri Jan 01 2016 00:00:00,
	 * //   Sun Jan 01 2017 00:00:00
	 * // ]
	 */
	function eachYearOfInterval(dirtyInterval) {
	  (0, _index2.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index.default)(interval.start);
	  var endDate = (0, _index.default)(interval.end);
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var dates = [];
	  var currentDate = startDate;
	  currentDate.setHours(0, 0, 0, 0);
	  currentDate.setMonth(0, 1);
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index.default)(currentDate));
	    currentDate.setFullYear(currentDate.getFullYear() + 1);
	  }
	
	  return dates;
	}
	
	module.exports = exports.default;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfDecade;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfDecade
	 * @category Decade Helpers
	 * @summary Return the end of a decade for the given date.
	 *
	 * @description
	 * Return the end of a decade for the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a decade
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // The end of a decade for 12 May 1984 00:00:00:
	 * const result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
	 * //=> Dec 31 1989 23:59:59.999
	 */
	function endOfDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = 9 + Math.floor(year / 10) * 10;
	  date.setFullYear(decade, 11, 31);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfHour;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfHour
	 * @category Hour Helpers
	 * @summary Return the end of an hour for the given date.
	 *
	 * @description
	 * Return the end of an hour for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an hour
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of an hour for 2 September 2014 11:55:00:
	 * const result = endOfHour(new Date(2014, 8, 2, 11, 55))
	 * //=> Tue Sep 02 2014 11:59:59.999
	 */
	function endOfHour(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMinutes(59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(91));
	
	var _index2 = _interopRequireDefault(__webpack_require__(81));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the end of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the end of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `endOfISOYear` to `endOfISOWeekYear`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of an ISO week-numbering year for 2 July 2005:
	 * const result = endOfISOWeekYear(new Date(2005, 6, 2))
	 * //=> Sun Jan 01 2006 23:59:59.999
	 */
	function endOfISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuaryOfNextYear);
	  date.setMilliseconds(date.getMilliseconds() - 1);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(297));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfISOWeek
	 * @category ISO Week Helpers
	 * @summary Return the end of an ISO week for the given date.
	 *
	 * @description
	 * Return the end of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of an ISO week for 2 September 2014 11:55:00:
	 * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Sep 07 2014 23:59:59.999
	 */
	function endOfISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, {
	    weekStartsOn: 1
	  });
	}
	
	module.exports = exports.default;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfMinute;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfMinute
	 * @category Minute Helpers
	 * @summary Return the end of a minute for the given date.
	 *
	 * @description
	 * Return the end of a minute for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a minute
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a minute for 1 December 2014 22:15:45.400:
	 * const result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:59.999
	 */
	function endOfMinute(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setSeconds(59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfQuarter
	 * @category Quarter Helpers
	 * @summary Return the end of a year quarter for the given date.
	 *
	 * @description
	 * Return the end of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a quarter for 2 September 2014 11:55:00:
	 * const result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 23:59:59.999
	 */
	function endOfQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var currentMonth = date.getMonth();
	  var month = currentMonth - currentMonth % 3 + 3;
	  date.setMonth(month, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfSecond;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfSecond
	 * @category Second Helpers
	 * @summary Return the end of a second for the given date.
	 *
	 * @description
	 * Return the end of a second for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a second
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a second for 1 December 2014 22:15:45.400:
	 * const result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:45.999
	 */
	function endOfSecond(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMilliseconds(999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfToday;
	
	var _index = _interopRequireDefault(__webpack_require__(206));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfToday
	 * @category Day Helpers
	 * @summary Return the end of today.
	 * @pure false
	 *
	 * @description
	 * Return the end of today.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the end of today
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = endOfToday()
	 * //=> Mon Oct 6 2014 23:59:59.999
	 */
	function endOfToday() {
	  return (0, _index.default)(Date.now());
	}
	
	module.exports = exports.default;

/***/ }),
/* 902 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfTomorrow;
	
	/**
	 * @name endOfTomorrow
	 * @category Day Helpers
	 * @summary Return the end of tomorrow.
	 * @pure false
	 *
	 * @description
	 * Return the end of tomorrow.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the end of tomorrow
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * const result = endOfTomorrow()
	 * //=> Tue Oct 7 2014 23:59:59.999
	 */
	function endOfTomorrow() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day + 1);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 903 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfYesterday;
	
	/**
	 * @name endOfYesterday
	 * @category Day Helpers
	 * @summary Return the end of yesterday.
	 * @pure false
	 *
	 * @description
	 * Return the end of yesterday.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the end of yesterday
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * const result = endOfYesterday()
	 * //=> Sun Oct 5 2014 23:59:59.999
	 */
	function endOfYesterday() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day - 1);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistanceToNowStrict;
	
	var _index = _interopRequireDefault(__webpack_require__(299));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatDistanceToNowStrict
	 * @category Common Helpers
	 * @summary Return the distance between the given date and now in words.
	 * @pure false
	 *
	 * @description
	 * Return the distance between the given dates in words, using strict units.
	 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
	 * 'less than' and the like.
	 *
	 * | Distance between dates | Result              |
	 * |------------------------|---------------------|
	 * | 0 ... 59 secs          | [0..59] seconds     |
	 * | 1 ... 59 mins          | [1..59] minutes     |
	 * | 1 ... 23 hrs           | [1..23] hours       |
	 * | 1 ... 29 days          | [1..29] days        |
	 * | 1 ... 11 months        | [1..11] months      |
	 * | 1 ... N years          | [1..N]  years       |
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
	 * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
	 * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // If today is 1 January 2015, what is the distance to 2 July 2014?
	 * var result = formatDistanceToNowStrict(
	 *   new Date(2014, 6, 2)
	 * )
	 * //=> '6 months'
	 *
	 * @example
	 * // If now is 1 January 2015 00:00:00,
	 * // what is the distance to 1 January 2015 00:00:15, including seconds?
	 * var result = formatDistanceToNowStrict(
	 *   new Date(2015, 0, 1, 0, 0, 15)
	 * )
	 * //=> '20 seconds'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 January 2016, with a suffix?
	 * var result = formatDistanceToNowStrict(
	 *   new Date(2016, 0, 1),
	 *   {addSuffix: true}
	 * )
	 * //=> 'in 1 year'
	 *
	 * @example
	 * // If today is 28 January 2015,
	 * // what is the distance to 1 January 2015, in months, rounded up??
	 * var result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
	 *   unit: 'month',
	 *   roundingMethod: 'ceil'
	 * })
	 * //=> '1 month'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 August 2016 in Esperanto?
	 * var eoLocale = require('date-fns/locale/eo')
	 * var result = formatDistanceToNowStrict(
	 *   new Date(2016, 7, 1),
	 *   {locale: eoLocale}
	 * )
	 * //=> '1 jaro'
	 */
	function formatDistanceToNowStrict(dirtyDate, dirtyOptions) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now(), dirtyOptions);
	}
	
	module.exports = exports.default;

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistanceToNow;
	
	var _index = _interopRequireDefault(__webpack_require__(300));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatDistanceToNow
	 * @category Common Helpers
	 * @summary Return the distance between the given date and now in words.
	 * @pure false
	 *
	 * @description
	 * Return the distance between the given date and now in words.
	 *
	 * | Distance to now                                                   | Result              |
	 * |-------------------------------------------------------------------|---------------------|
	 * | 0 ... 30 secs                                                     | less than a minute  |
	 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
	 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
	 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
	 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
	 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
	 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
	 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
	 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
	 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
	 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
	 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
	 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
	 * | N yrs ... N yrs 3 months                                          | about N years       |
	 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
	 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
	 *
	 * With `options.includeSeconds == true`:
	 * | Distance to now     | Result               |
	 * |---------------------|----------------------|
	 * | 0 secs ... 5 secs   | less than 5 seconds  |
	 * | 5 secs ... 10 secs  | less than 10 seconds |
	 * | 10 secs ... 20 secs | less than 20 seconds |
	 * | 20 secs ... 40 secs | half a minute        |
	 * | 40 secs ... 60 secs | less than a minute   |
	 * | 60 secs ... 90 secs | 1 minute             |
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `distanceInWordsToNow ` to `formatDistanceToNow`
	 *   to make its name consistent with `format` and `formatRelative`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   distanceInWordsToNow(new Date(2014, 6, 2), { addSuffix: true })
	 *   //=> 'in 6 months'
	 *
	 *   // v2.0.0 onward
	 *
	 *   formatDistanceToNow(new Date(2014, 6, 2), { addSuffix: true })
	 *   //=> 'in 6 months'
	 *   ```
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - the object with options
	 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
	 * @param {Boolean} [options.addSuffix=false] - result specifies if now is earlier or later than the passed date
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // If today is 1 January 2015, what is the distance to 2 July 2014?
	 * var result = formatDistanceToNow(
	 *   new Date(2014, 6, 2)
	 * )
	 * //=> '6 months'
	 *
	 * @example
	 * // If now is 1 January 2015 00:00:00,
	 * // what is the distance to 1 January 2015 00:00:15, including seconds?
	 * var result = formatDistanceToNow(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   {includeSeconds: true}
	 * )
	 * //=> 'less than 20 seconds'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 January 2016, with a suffix?
	 * var result = formatDistanceToNow(
	 *   new Date(2016, 0, 1),
	 *   {addSuffix: true}
	 * )
	 * //=> 'in about 1 year'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 August 2016 in Esperanto?
	 * var eoLocale = require('date-fns/locale/eo')
	 * var result = formatDistanceToNow(
	 *   new Date(2016, 7, 1),
	 *   {locale: eoLocale}
	 * )
	 * //=> 'pli ol 1 jaro'
	 */
	function formatDistanceToNow(dirtyDate, dirtyOptions) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now(), dirtyOptions);
	}
	
	module.exports = exports.default;

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDuration;
	
	var _index = _interopRequireDefault(__webpack_require__(80));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultFormat = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds'];
	/**
	 * @name formatDuration
	 * @category Common Helpers
	 * @summary Formats a duration in human-readable format
	 *
	 * @description
	 * Return human-readable duration string i.e. "9 months 2 days"
	 *
	 * @param {Duration} duration - the duration to format
	 * @param {Object} [options] - an object with options.
	
	 * @param {string[]} [options.format=['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds']] - the array of units to format
	 * @param {boolean} [options.zero=false] - should be zeros be included in the output?
	 * @param {string} [options.delimiter=' '] - delimiter string
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {string} the formatted date string
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Format full duration
	 * formatDuration({
	 *   years: 2,
	 *   months: 9,
	 *   weeks: 1,
	 *   days: 7,
	 *   hours: 5,
	 *   minutes: 9,
	 *   seconds: 30
	 * })
	 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds
	 *
	 * @example
	 * // Format partial duration
	 * formatDuration({ months: 9, days: 2 })
	 * //=> '9 months 2 days'
	 *
	 * @example
	 * // Customize the format
	 * formatDuration(
	 *   {
	 *     years: 2,
	 *     months: 9,
	 *     weeks: 1,
	 *     days: 7,
	 *     hours: 5,
	 *     minutes: 9,
	 *     seconds: 30
	 *   },
	 *   { format: ['months', 'weeks'] }
	 * ) === '9 months 1 week'
	 *
	 * @example
	 * // Customize the zeros presence
	 * formatDuration({ years: 0, months: 9 })
	 * //=> '9 months'
	 * formatDuration({ years: 0, months: 9 }, { zero: true })
	 * //=> '0 years 9 months'
	 *
	 * @example
	 * // Customize the delimiter
	 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
	 * //=> '2 years, 9 months, 3 weeks'
	 */
	
	function formatDuration(duration, options) {
	  if (arguments.length < 1) {
	    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
	  }
	
	  var format = (options === null || options === void 0 ? void 0 : options.format) || defaultFormat;
	  var locale = (options === null || options === void 0 ? void 0 : options.locale) || _index.default;
	  var zero = (options === null || options === void 0 ? void 0 : options.zero) || false;
	  var delimiter = (options === null || options === void 0 ? void 0 : options.delimiter) || ' ';
	  var result = format.reduce(function (acc, unit) {
	    var token = "x".concat(unit.replace(/(^.)/, function (m) {
	      return m.toUpperCase();
	    }));
	    var addChunk = typeof duration[unit] === 'number' && (zero || duration[unit]);
	    return addChunk ? acc.concat(locale.formatDistance(token, duration[unit])) : acc;
	  }, []).join(delimiter);
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatISO9075;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(51));
	
	var _index3 = _interopRequireDefault(__webpack_require__(90));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatISO9075
	 * @category Common Helpers
	 * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
	 *
	 * @description
	 * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
	 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time, or both.
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
	 * @throws {RangeError} `options.represenation` must be 'date', 'time' or 'complete'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075 format:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> '2019-09-18 19:00:52'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075, short format:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
	 * //=> '20190918 190052'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075 format, date only:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
	 * //=> '2019-09-18'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075 format, time only:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
	 * //=> '19:00:52'
	 */
	function formatISO9075(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
	  }
	
	  var originalDate = (0, _index.default)(dirtyDate);
	
	  if (!(0, _index2.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var options = dirtyOptions || {};
	  var format = options.format == null ? 'extended' : String(options.format);
	  var representation = options.representation == null ? 'complete' : String(options.representation);
	
	  if (format !== 'extended' && format !== 'basic') {
	    throw new RangeError("format must be 'extended' or 'basic'");
	  }
	
	  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
	    throw new RangeError("representation must be 'date', 'time', or 'complete'");
	  }
	
	  var result = '';
	  var dateDelimiter = format === 'extended' ? '-' : '';
	  var timeDelimiter = format === 'extended' ? ':' : ''; // Representation is either 'date' or 'complete'
	
	  if (representation !== 'time') {
	    var day = (0, _index3.default)(originalDate.getDate(), 2);
	    var month = (0, _index3.default)(originalDate.getMonth() + 1, 2);
	    var year = (0, _index3.default)(originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.
	
	    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
	  } // Representation is either 'time' or 'complete'
	
	
	  if (representation !== 'date') {
	    var hour = (0, _index3.default)(originalDate.getHours(), 2);
	    var minute = (0, _index3.default)(originalDate.getMinutes(), 2);
	    var second = (0, _index3.default)(originalDate.getSeconds(), 2); // If there's also date, separate it with time with a space
	
	    var separator = result === '' ? '' : ' '; // HHmmss or HH:mm:ss.
	
	    result = "".concat(result).concat(separator).concat(hour).concat(timeDelimiter).concat(minute).concat(timeDelimiter).concat(second);
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatISODuration;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatISODuration
	 * @category Common Helpers
	 * @summary Format a duration object according as ISO 8601 duration string
	 *
	 * @description
	 * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs/90001437-13/reference/r_iso_8601_duration_format.htm)
	 *
	 * @param {Duration} duration - the duration to format
	 *
	 * @returns {String} The ISO 8601 duration string
	 * @throws {TypeError} Requires 1 argument
	 * @throws {Error} Argument must be an object
	 *
	 * @example
	 * // Format the given duration as ISO 8601 string
	 * const result = formatISODuration({
	 *   years: 39,
	 *   months: 2,
	 *   days: 20,
	 *   hours: 7,
	 *   minutes: 5,
	 *   seconds: 0
	 * })
	 * //=> 'P39Y2M20DT0H0M0S'
	 */
	function formatISODuration(duration) {
	  (0, _index.default)(1, arguments);
	  if (typeof duration !== 'object') throw new Error('Duration must be an object');
	  var _duration$years = duration.years,
	      years = _duration$years === void 0 ? 0 : _duration$years,
	      _duration$months = duration.months,
	      months = _duration$months === void 0 ? 0 : _duration$months,
	      _duration$days = duration.days,
	      days = _duration$days === void 0 ? 0 : _duration$days,
	      _duration$hours = duration.hours,
	      hours = _duration$hours === void 0 ? 0 : _duration$hours,
	      _duration$minutes = duration.minutes,
	      minutes = _duration$minutes === void 0 ? 0 : _duration$minutes,
	      _duration$seconds = duration.seconds,
	      seconds = _duration$seconds === void 0 ? 0 : _duration$seconds;
	  return "P".concat(years, "Y").concat(months, "M").concat(days, "DT").concat(hours, "H").concat(minutes, "M").concat(seconds, "S");
	}
	
	module.exports = exports.default;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatISO;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(51));
	
	var _index3 = _interopRequireDefault(__webpack_require__(90));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatISO
	 * @category Common Helpers
	 * @summary Format the date according to the ISO 8601 standard (http://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
	 *
	 * @description
	 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
	 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time with time zone, or both.
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
	 * @throws {RangeError} `options.represenation` must be 'date', 'time' or 'complete'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601 format (UTC):
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> '2019-09-18T19:00:52Z'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601, short format (UTC):
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
	 * //=> '20190918T190052'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601 format, date only:
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
	 * //=> '2019-09-18'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601 format, time only (UTC):
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
	 * //=> '19:00:52Z'
	 */
	function formatISO(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
	  }
	
	  var originalDate = (0, _index.default)(dirtyDate);
	
	  if (!(0, _index2.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var options = dirtyOptions || {};
	  var format = options.format == null ? 'extended' : String(options.format);
	  var representation = options.representation == null ? 'complete' : String(options.representation);
	
	  if (format !== 'extended' && format !== 'basic') {
	    throw new RangeError("format must be 'extended' or 'basic'");
	  }
	
	  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
	    throw new RangeError("representation must be 'date', 'time', or 'complete'");
	  }
	
	  var result = '';
	  var tzOffset = '';
	  var dateDelimiter = format === 'extended' ? '-' : '';
	  var timeDelimiter = format === 'extended' ? ':' : ''; // Representation is either 'date' or 'complete'
	
	  if (representation !== 'time') {
	    var day = (0, _index3.default)(originalDate.getDate(), 2);
	    var month = (0, _index3.default)(originalDate.getMonth() + 1, 2);
	    var year = (0, _index3.default)(originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.
	
	    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
	  } // Representation is either 'time' or 'complete'
	
	
	  if (representation !== 'date') {
	    // Add the timezone.
	    var offset = originalDate.getTimezoneOffset();
	
	    if (offset !== 0) {
	      var absoluteOffset = Math.abs(offset);
	      var hourOffset = (0, _index3.default)(Math.floor(absoluteOffset / 60), 2);
	      var minuteOffset = (0, _index3.default)(absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.
	
	      var sign = offset < 0 ? '+' : '-';
	      tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
	    } else {
	      tzOffset = 'Z';
	    }
	
	    var hour = (0, _index3.default)(originalDate.getHours(), 2);
	    var minute = (0, _index3.default)(originalDate.getMinutes(), 2);
	    var second = (0, _index3.default)(originalDate.getSeconds(), 2); // If there's also date, separate it with time with 'T'
	
	    var separator = result === '' ? '' : 'T'; // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
	
	    var time = [hour, minute, second].join(timeDelimiter); // HHmmss or HH:mm:ss.
	
	    result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRFC3339;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(51));
	
	var _index3 = _interopRequireDefault(__webpack_require__(90));
	
	var _index4 = _interopRequireDefault(__webpack_require__(10));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatRFC3339
	 * @category Common Helpers
	 * @summary Format the date according to the RFC 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
	 *
	 * @description
	 * Return the formatted date string in RFC 3339 format. Options may be passed to control the parts and notations of the date.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2|3} [options.fractionDigits=0] - number of digits after the decimal point after seconds
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.fractionDigits` must be between 0 and 3
	 *
	 * @example
	 * // Represent 18 September 2019 in RFC 3339 format:
	 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> '2019-09-18T19:00:52Z'
	 *
	 * @example
	 * // Represent 18 September 2019 in RFC 3339 format, 2 digits of second fraction:
	 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), { fractionDigits: 2 })
	 * //=> '2019-09-18T19:00:52.23Z'
	 *
	 * @example
	 * // Represent 18 September 2019 in RFC 3339 format, 3 digits of second fraction
	 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), { fractionDigits: 3 })
	 * //=> '2019-09-18T19:00:52.234Z'
	 */
	function formatRFC3339(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
	  }
	
	  var originalDate = (0, _index.default)(dirtyDate);
	
	  if (!(0, _index2.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var _ref = dirtyOptions || {},
	      _ref$fractionDigits = _ref.fractionDigits,
	      fractionDigits = _ref$fractionDigits === void 0 ? 0 : _ref$fractionDigits; // Test if fractionDigits is between 0 and 3 _and_ is not NaN
	
	
	  if (!(fractionDigits >= 0 && fractionDigits <= 3)) {
	    throw new RangeError('fractionDigits must be between 0 and 3 inclusively');
	  }
	
	  var day = (0, _index3.default)(originalDate.getDate(), 2);
	  var month = (0, _index3.default)(originalDate.getMonth() + 1, 2);
	  var year = originalDate.getFullYear();
	  var hour = (0, _index3.default)(originalDate.getHours(), 2);
	  var minute = (0, _index3.default)(originalDate.getMinutes(), 2);
	  var second = (0, _index3.default)(originalDate.getSeconds(), 2);
	  var fractionalSecond = '';
	
	  if (fractionDigits > 0) {
	    var milliseconds = originalDate.getMilliseconds();
	    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, fractionDigits - 3));
	    fractionalSecond = '.' + (0, _index3.default)(fractionalSeconds, fractionDigits);
	  }
	
	  var offset = '';
	  var tzOffset = originalDate.getTimezoneOffset();
	
	  if (tzOffset !== 0) {
	    var absoluteOffset = Math.abs(tzOffset);
	    var hourOffset = (0, _index3.default)((0, _index4.default)(absoluteOffset / 60), 2);
	    var minuteOffset = (0, _index3.default)(absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.
	
	    var sign = tzOffset < 0 ? '+' : '-';
	    offset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
	  } else {
	    offset = 'Z';
	  }
	
	  return "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hour, ":").concat(minute, ":").concat(second).concat(fractionalSecond).concat(offset);
	}
	
	module.exports = exports.default;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRFC7231;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(51));
	
	var _index3 = _interopRequireDefault(__webpack_require__(90));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	/**
	 * @name formatRFC7231
	 * @category Common Helpers
	 * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
	 *
	 * @description
	 * Return the formatted date string in RFC 7231 format.
	 * The result will always be in UTC timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 *
	 * @example
	 * // Represent 18 September 2019 in RFC 7231 format:
	 * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
	 */
	
	function formatRFC7231(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
	  }
	
	  var originalDate = (0, _index.default)(dirtyDate);
	
	  if (!(0, _index2.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var dayName = days[originalDate.getUTCDay()];
	  var dayOfMonth = (0, _index3.default)(originalDate.getUTCDate(), 2);
	  var monthName = months[originalDate.getUTCMonth()];
	  var year = originalDate.getUTCFullYear();
	  var hour = (0, _index3.default)(originalDate.getUTCHours(), 2);
	  var minute = (0, _index3.default)(originalDate.getUTCMinutes(), 2);
	  var second = (0, _index3.default)(originalDate.getUTCSeconds(), 2); // Result variables.
	
	  return "".concat(dayName, ", ").concat(dayOfMonth, " ").concat(monthName, " ").concat(year, " ").concat(hour, ":").concat(minute, ":").concat(second, " GMT");
	}
	
	module.exports = exports.default;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	
	var _index = _interopRequireDefault(__webpack_require__(76));
	
	var _index2 = _interopRequireDefault(__webpack_require__(301));
	
	var _index3 = _interopRequireDefault(__webpack_require__(80));
	
	var _index4 = _interopRequireDefault(__webpack_require__(114));
	
	var _index5 = _interopRequireDefault(__webpack_require__(4));
	
	var _index6 = _interopRequireDefault(__webpack_require__(57));
	
	var _index7 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatRelative
	 * @category Common Helpers
	 * @summary Represent the date in words relative to the given base date.
	 *
	 * @description
	 * Represent the date in words relative to the given base date.
	 *
	 * | Distance to the base date | Result                    |
	 * |---------------------------|---------------------------|
	 * | Previous 6 days           | last Sunday at 04:30 AM   |
	 * | Last day                  | yesterday at 04:30 AM     |
	 * | Same day                  | today at 04:30 AM         |
	 * | Next day                  | tomorrow at 04:30 AM      |
	 * | Next 6 days               | Sunday at 04:30 AM        |
	 * | Other                     | 12/31/2017                |
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to format
	 * @param {Date|Number} baseDate - the date to compare with
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {String} the date in words
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `baseDate` must not be Invalid Date
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.locale` must contain `localize` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 * @throws {RangeError} `options.locale` must contain `formatRelative` property
	 *
	 * @example
	 * // Represent the date of 6 days ago in words relative to the given base date. In this example, today is Wednesday
	 * const result = formatRelative(addDays(new Date(), -6), new Date())
	 * //=> "last Thursday at 12:45 AM"
	 */
	function formatRelative(dirtyDate, dirtyBaseDate, dirtyOptions) {
	  (0, _index7.default)(2, arguments);
	  var date = (0, _index5.default)(dirtyDate);
	  var baseDate = (0, _index5.default)(dirtyBaseDate);
	
	  var _ref = dirtyOptions || {},
	      _ref$locale = _ref.locale,
	      locale = _ref$locale === void 0 ? _index3.default : _ref$locale,
	      _ref$weekStartsOn = _ref.weekStartsOn,
	      weekStartsOn = _ref$weekStartsOn === void 0 ? 0 : _ref$weekStartsOn;
	
	  if (!locale.localize) {
	    throw new RangeError('locale must contain localize property');
	  }
	
	  if (!locale.formatLong) {
	    throw new RangeError('locale must contain formatLong property');
	  }
	
	  if (!locale.formatRelative) {
	    throw new RangeError('locale must contain formatRelative property');
	  }
	
	  var diff = (0, _index.default)(date, baseDate);
	
	  if (isNaN(diff)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var token;
	
	  if (diff < -6) {
	    token = 'other';
	  } else if (diff < -1) {
	    token = 'lastWeek';
	  } else if (diff < 0) {
	    token = 'yesterday';
	  } else if (diff < 1) {
	    token = 'today';
	  } else if (diff < 2) {
	    token = 'tomorrow';
	  } else if (diff < 7) {
	    token = 'nextWeek';
	  } else {
	    token = 'other';
	  }
	
	  var utcDate = (0, _index4.default)(date, (0, _index6.default)(date));
	  var utcBaseDate = (0, _index4.default)(baseDate, (0, _index6.default)(baseDate));
	  var formatStr = locale.formatRelative(token, utcDate, utcBaseDate, {
	    locale: locale,
	    weekStartsOn: weekStartsOn
	  });
	  return (0, _index2.default)(date, formatStr, {
	    locale: locale,
	    weekStartsOn: weekStartsOn
	  });
	}
	
	module.exports = exports.default;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = fromUnixTime;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(10));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name fromUnixTime
	 * @category Timestamp Helpers
	 * @summary Create a date from a Unix timestamp.
	 *
	 * @description
	 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Number} unixTime - the given Unix timestamp (in seconds)
	 * @returns {Date} the date
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Create the date 29 February 2012 11:45:05:
	 * const result = fromUnixTime(1330515905)
	 * //=> Wed Feb 29 2012 11:45:05
	 */
	function fromUnixTime(dirtyUnixTime) {
	  (0, _index3.default)(1, arguments);
	  var unixTime = (0, _index2.default)(dirtyUnixTime);
	  return (0, _index.default)(unixTime * 1000);
	}
	
	module.exports = exports.default;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDayOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(216));
	
	var _index3 = _interopRequireDefault(__webpack_require__(76));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDayOfYear
	 * @category Day Helpers
	 * @summary Get the day of the year of the given date.
	 *
	 * @description
	 * Get the day of the year of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the year is 2 July 2014?
	 * const result = getDayOfYear(new Date(2014, 6, 2))
	 * //=> 183
	 */
	function getDayOfYear(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index3.default)(date, (0, _index2.default)(date));
	  var dayOfYear = diff + 1;
	  return dayOfYear;
	}
	
	module.exports = exports.default;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDaysInYear;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(312));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDaysInYear
	 * @category Year Helpers
	 * @summary Get the number of days in a year of the given date.
	 *
	 * @description
	 * Get the number of days in a year of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the number of days in a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // How many days are in 2012?
	 * const result = getDaysInYear(new Date(2012, 0, 1))
	 * //=> 366
	 */
	function getDaysInYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	
	  if (String(new Date(date)) === 'Invalid Date') {
	    return NaN;
	  }
	
	  return (0, _index2.default)(date) ? 366 : 365;
	}
	
	module.exports = exports.default;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDecade;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDecade
	 * @category Decade Helpers
	 * @summary Get the decade of the given date.
	 *
	 * @description
	 * Get the decade of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the year of decade
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which decade belongs 27 November 1942?
	 * const result = getDecade(new Date(1942, 10, 27))
	 * //=> 1940
	 */
	function getDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = Math.floor(year / 10) * 10;
	  return decade;
	}
	
	module.exports = exports.default;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getHours;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getHours
	 * @category Hour Helpers
	 * @summary Get the hours of the given date.
	 *
	 * @description
	 * Get the hours of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the hours of 29 February 2012 11:45:00:
	 * const result = getHours(new Date(2012, 1, 29, 11, 45))
	 * //=> 11
	 */
	function getHours(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var hours = date.getHours();
	  return hours;
	}
	
	module.exports = exports.default;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISOWeeksInYear;
	
	var _index = _interopRequireDefault(__webpack_require__(113));
	
	var _index2 = _interopRequireDefault(__webpack_require__(134));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name getISOWeeksInYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
	 *
	 * @description
	 * Get the number of weeks in an ISO week-numbering year of the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the number of ISO weeks in a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // How many weeks are in ISO week-numbering year 2015?
	 * const result = getISOWeeksInYear(new Date(2015, 1, 11))
	 * //=> 53
	 */
	
	function getISOWeeksInYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var thisYear = (0, _index.default)(dirtyDate);
	  var nextYear = (0, _index.default)((0, _index2.default)(thisYear, 60));
	  var diff = nextYear.valueOf() - thisYear.valueOf(); // Round the number of weeks to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK);
	}
	
	module.exports = exports.default;

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getMilliseconds
	 * @category Millisecond Helpers
	 * @summary Get the milliseconds of the given date.
	 *
	 * @description
	 * Get the milliseconds of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the milliseconds of 29 February 2012 11:45:05.123:
	 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 123
	 */
	function getMilliseconds(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var milliseconds = date.getMilliseconds();
	  return milliseconds;
	}
	
	module.exports = exports.default;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getMinutes
	 * @category Minute Helpers
	 * @summary Get the minutes of the given date.
	 *
	 * @description
	 * Get the minutes of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the minutes of 29 February 2012 11:45:05:
	 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
	 * //=> 45
	 */
	function getMinutes(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var minutes = date.getMinutes();
	  return minutes;
	}
	
	module.exports = exports.default;

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getMonth
	 * @category Month Helpers
	 * @summary Get the month of the given date.
	 *
	 * @description
	 * Get the month of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which month is 29 February 2012?
	 * const result = getMonth(new Date(2012, 1, 29))
	 * //=> 1
	 */
	function getMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  return month;
	}
	
	module.exports = exports.default;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getOverlappingDaysInIntervals;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;
	/**
	 * @name getOverlappingDaysInIntervals
	 * @category Interval Helpers
	 * @summary Get the number of days that overlap in two time intervals
	 *
	 * @description
	 * Get the number of days that overlap in two time intervals
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `getOverlappingDaysInRanges` to `getOverlappingDaysInIntervals`.
	 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
	 *
	 *   ```
	 *   2.1.3
	 *   time interval
	 *   part of the time axis limited by two instants
	 *   ```
	 *
	 *   Also, this function now accepts an object with `start` and `end` properties
	 *   instead of two arguments as an interval.
	 *   This function now throws `RangeError` if the start of the interval is after its end
	 *   or if any date in the interval is `Invalid Date`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   getOverlappingDaysInRanges(
	 *     new Date(2014, 0, 10), new Date(2014, 0, 20),
	 *     new Date(2014, 0, 17), new Date(2014, 0, 21)
	 *   )
	 *
	 *   // v2.0.0 onward
	 *
	 *   getOverlappingDaysInIntervals(
	 *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *     { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
	 *   )
	 *   ```
	 *
	 * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link docs/Interval}
	 * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link docs/Interval}
	 * @returns {Number} the number of days that overlap in two time intervals
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For overlapping time intervals adds 1 for each started overlapping day:
	 * getOverlappingDaysInIntervals(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
	 * )
	 * //=> 3
	 *
	 * @example
	 * // For non-overlapping time intervals returns 0:
	 * getOverlappingDaysInIntervals(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
	 * )
	 * //=> 0
	 */
	
	function getOverlappingDaysInIntervals(dirtyIntervalLeft, dirtyIntervalRight) {
	  (0, _index2.default)(2, arguments);
	  var intervalLeft = dirtyIntervalLeft || {};
	  var intervalRight = dirtyIntervalRight || {};
	  var leftStartTime = (0, _index.default)(intervalLeft.start).getTime();
	  var leftEndTime = (0, _index.default)(intervalLeft.end).getTime();
	  var rightStartTime = (0, _index.default)(intervalRight.start).getTime();
	  var rightEndTime = (0, _index.default)(intervalRight.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var isOverlapping = leftStartTime < rightEndTime && rightStartTime < leftEndTime;
	
	  if (!isOverlapping) {
	    return 0;
	  }
	
	  var overlapStartDate = rightStartTime < leftStartTime ? leftStartTime : rightStartTime;
	  var overlapEndDate = rightEndTime > leftEndTime ? leftEndTime : rightEndTime;
	  var differenceInMs = overlapEndDate - overlapStartDate;
	  return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY);
	}
	
	module.exports = exports.default;

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getSeconds
	 * @category Second Helpers
	 * @summary Get the seconds of the given date.
	 *
	 * @description
	 * Get the seconds of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the seconds of 29 February 2012 11:45:05.123:
	 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 5
	 */
	function getSeconds(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var seconds = date.getSeconds();
	  return seconds;
	}
	
	module.exports = exports.default;

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUnixTime;
	
	var _index = _interopRequireDefault(__webpack_require__(307));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getUnixTime
	 * @category Timestamp Helpers
	 * @summary Get the seconds timestamp of the given date.
	 *
	 * @description
	 * Get the seconds timestamp of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the timestamp
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the timestamp of 29 February 2012 11:45:05 CET:
	 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
	 * //=> 1330512305
	 */
	function getUnixTime(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return Math.floor((0, _index.default)(dirtyDate) / 1000);
	}
	
	module.exports = exports.default;

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeekOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(302));
	
	var _index2 = _interopRequireDefault(__webpack_require__(137));
	
	var _index3 = _interopRequireDefault(__webpack_require__(140));
	
	var _index4 = _interopRequireDefault(__webpack_require__(10));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getWeekOfMonth
	 * @category Week Helpers
	 * @summary Get the week of the month of the given date.
	 *
	 * @description
	 * Get the week of the month of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the week of month
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // Which week of the month is 9 November 2017?
	 * var result = getWeekOfMonth(new Date(2017, 10, 9))
	 * //=> 2
	 */
	function getWeekOfMonth(date, dirtyOptions) {
	  (0, _index5.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index4.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index4.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var currentDayOfMonth = (0, _index.default)(date);
	
	  if (isNaN(currentDayOfMonth)) {
	    return currentDayOfMonth;
	  }
	
	  var startWeekDay = (0, _index2.default)((0, _index3.default)(date));
	  var lastDayOfFirstWeek = 0;
	
	  if (startWeekDay >= weekStartsOn) {
	    lastDayOfFirstWeek = weekStartsOn + 7 - startWeekDay;
	  } else {
	    lastDayOfFirstWeek = weekStartsOn - startWeekDay;
	  }
	
	  var weekNumber = 1;
	
	  if (currentDayOfMonth > lastDayOfFirstWeek) {
	    var remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
	    weekNumber = weekNumber + Math.ceil(remainingDaysAfterFirstWeek / 7);
	  }
	
	  return weekNumber;
	}
	
	module.exports = exports.default;

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeeksInMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(291));
	
	var _index2 = _interopRequireDefault(__webpack_require__(321));
	
	var _index3 = _interopRequireDefault(__webpack_require__(140));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getWeeksInMonth
	 * @category Week Helpers
	 * @summary Get the number of calendar weeks a month spans.
	 *
	 * @description
	 * Get the number of calendar weeks the month in the given date spans.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the number of calendar weeks
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // How many calendar weeks does February 2015 span?
	 * const result = getWeeksInMonth(new Date(2015, 1, 8))
	 * //=> 4
	 *
	 * @example
	 * // If the week starts on Monday,
	 * // how many calendar weeks does July 2017 span?
	 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
	 * //=> 6
	 */
	function getWeeksInMonth(date, options) {
	  (0, _index4.default)(1, arguments);
	  return (0, _index.default)((0, _index2.default)(date), (0, _index3.default)(date), options) + 1;
	}
	
	module.exports = exports.default;

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getYear;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getYear
	 * @category Year Helpers
	 * @summary Get the year of the given date.
	 *
	 * @description
	 * Get the year of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which year is 2 July 2014?
	 * const result = getYear(new Date(2014, 6, 2))
	 * //=> 2014
	 */
	function getYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  return year;
	}
	
	module.exports = exports.default;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hoursToMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name hoursToMilliseconds
	 * @category  Conversion Helpers
	 * @summary Convert hours to milliseconds.
	 *
	 * @description
	 * Convert a number of hours to a full number of milliseconds.
	 *
	 * @param {number} hours - number of hours to be converted
	 *
	 * @returns {number} the number of hours converted to milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 hours to milliseconds:
	 * const result = hoursToMilliseconds(2)
	 * //=> 7200000
	 */
	function hoursToMilliseconds(hours) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(hours * _index2.millisecondsInHour);
	}
	
	module.exports = exports.default;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hoursToMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name hoursToMinutes
	 * @category Conversion Helpers
	 * @summary Convert hours to minutes.
	 *
	 * @description
	 * Convert a number of hours to a full number of minutes.
	 *
	 * @param {number} hours - number of hours to be converted
	 *
	 * @returns {number} the number of hours converted in minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 hours to minutes:
	 * const result = hoursToMinutes(2)
	 * //=> 120
	 */
	function hoursToMinutes(hours) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(hours * _index2.minutesInHour);
	}
	
	module.exports = exports.default;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hoursToSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name hoursToSeconds
	 * @category Conversion Helpers
	 * @summary Convert hours to seconds.
	 *
	 * @description
	 * Convert a number of hours to a full number of seconds.
	 *
	 * @param {number} hours - number of hours to be converted
	 *
	 * @returns {number} the number of hours converted in seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 hours to seconds:
	 * const result = hoursToSeconds(2)
	 * //=> 7200
	 */
	function hoursToSeconds(hours) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(hours * _index2.secondsInHour);
	}
	
	module.exports = exports.default;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = intervalToDuration;
	
	var _index = _interopRequireDefault(__webpack_require__(75));
	
	var _index2 = _interopRequireDefault(__webpack_require__(295));
	
	var _index3 = _interopRequireDefault(__webpack_require__(136));
	
	var _index4 = _interopRequireDefault(__webpack_require__(203));
	
	var _index5 = _interopRequireDefault(__webpack_require__(293));
	
	var _index6 = _interopRequireDefault(__webpack_require__(294));
	
	var _index7 = _interopRequireDefault(__webpack_require__(204));
	
	var _index8 = _interopRequireDefault(__webpack_require__(51));
	
	var _index9 = _interopRequireDefault(__webpack_require__(1));
	
	var _index10 = _interopRequireDefault(__webpack_require__(4));
	
	var _index11 = _interopRequireDefault(__webpack_require__(341));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name intervalToDuration
	 * @category Common Helpers
	 * @summary Convert interval to duration
	 *
	 * @description
	 * Convert a interval object to a duration object.
	 *
	 * @param {Interval} interval - the interval to convert to duration
	 *
	 * @returns {Duration} The duration Object
	 * @throws {TypeError} Requires 2 arguments
	 * @throws {RangeError} `start` must not be Invalid Date
	 * @throws {RangeError} `end` must not be Invalid Date
	 *
	 * @example
	 * // Get the duration between January 15, 1929 and April 4, 1968.
	 * intervalToDuration({
	 *   start: new Date(1929, 0, 15, 12, 0, 0),
	 *   end: new Date(1968, 3, 4, 19, 5, 0)
	 * })
	 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
	 */
	function intervalToDuration(_ref) {
	  var start = _ref.start,
	      end = _ref.end;
	  (0, _index9.default)(1, arguments);
	  var dateLeft = (0, _index10.default)(start);
	  var dateRight = (0, _index10.default)(end);
	
	  if (!(0, _index8.default)(dateLeft)) {
	    throw new RangeError('Start Date is invalid');
	  }
	
	  if (!(0, _index8.default)(dateRight)) {
	    throw new RangeError('End Date is invalid');
	  }
	
	  var duration = {
	    years: 0,
	    months: 0,
	    days: 0,
	    hours: 0,
	    minutes: 0,
	    seconds: 0
	  };
	  var sign = (0, _index.default)(dateLeft, dateRight);
	  duration.years = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  var remainingMonths = (0, _index11.default)(dateLeft, {
	    years: sign * duration.years
	  });
	  duration.months = Math.abs((0, _index3.default)(remainingMonths, dateRight));
	  var remainingDays = (0, _index11.default)(remainingMonths, {
	    months: sign * duration.months
	  });
	  duration.days = Math.abs((0, _index4.default)(remainingDays, dateRight));
	  var remainingHours = (0, _index11.default)(remainingDays, {
	    days: sign * duration.days
	  });
	  duration.hours = Math.abs((0, _index5.default)(remainingHours, dateRight));
	  var remainingMinutes = (0, _index11.default)(remainingHours, {
	    hours: sign * duration.hours
	  });
	  duration.minutes = Math.abs((0, _index6.default)(remainingMinutes, dateRight));
	  var remainingSeconds = (0, _index11.default)(remainingMinutes, {
	    minutes: sign * duration.minutes
	  });
	  duration.seconds = Math.abs((0, _index7.default)(remainingSeconds, dateRight));
	  return duration;
	}
	
	module.exports = exports.default;

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = intlFormat;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name intlFormat
	 * @category Common Helpers
	 * @summary  Format the date with Intl.DateTimeFormat (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat).
	 *
	 * @description
	 * Return the formatted date string in the given format.
	 * The method uses [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) inside.
	 * formatOptions are the same as [`Intl.DateTimeFormat` options](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options)
	 *
	 * > ⚠️ Please note that before Node version 13.0.0, only the locale data for en-US is available by default.
	 *
	 * @param {Date|Number} argument - the original date.
	 * @param {Object} [formatOptions] - an object with options.
	 * @param {'lookup'|'best fit'} [formatOptions.localeMatcher='best fit'] - locale selection algorithm.
	 * @param {'narrow'|'short'|'long'} [formatOptions.weekday] - representation the days of the week.
	 * @param {'narrow'|'short'|'long'} [formatOptions.era] - representation of eras.
	 * @param {'numeric'|'2-digit'} [formatOptions.year] - representation of years.
	 * @param {'numeric'|'2-digit'|'narrow'|'short'|'long'} [formatOptions.month='numeric'] - representation of month.
	 * @param {'numeric'|'2-digit'} [formatOptions.day='numeric'] - representation of day.
	 * @param {'numeric'|'2-digit'} [formatOptions.hour='numeric'] - representation of hours.
	 * @param {'numeric'|'2-digit'} [formatOptions.minute] - representation of minutes.
	 * @param {'numeric'|'2-digit'} [formatOptions.second] - representation of seconds.
	 * @param {'short'|'long'} [formatOptions.timeZoneName] - representation of names of time zones.
	 * @param {'basic'|'best fit'} [formatOptions.formatMatcher='best fit'] - format selection algorithm.
	 * @param {Boolean} [formatOptions.hour12] - determines whether to use 12-hour time format.
	 * @param {String} [formatOptions.timeZone] - the time zone to use.
	 * @param {Object} [localeOptions] - an object with locale.
	 * @param {String|String[]} [localeOptions.locale] - the locale code
	 * @returns {String} the formatted date string.
	 * @throws {TypeError} 1 argument required.
	 * @throws {RangeError} `date` must not be Invalid Date
	 *
	 * @example
	 * // Represent 10 October 2019 in German.
	 * // Convert the date with format's options and locale's options.
	 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
	 *      weekday: 'long',
	 *      year: 'numeric',
	 *      month: 'long',
	 *      day: 'numeric',
	 *    }, {
	 *      locale: 'de-DE',
	 *  })
	 * //=> Freitag, 4. Oktober 2019
	 *
	 * @example
	 * // Represent 10 October 2019.
	 * // Convert the date with format's options.
	 * const result = intlFormat.default(new Date(2019, 9, 4, 12, 30, 13, 456), {
	 *      year: 'numeric',
	 *      month: 'numeric',
	 *      day: 'numeric',
	 *      hour: 'numeric',
	 *  })
	 * //=> 10/4/2019, 12 PM
	 *
	 * @example
	 * // Represent 10 October 2019 in Korean.
	 * // Convert the date with locale's options.
	 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
	 *      locale: 'ko-KR',
	 *  })
	 * //=> 2019. 10. 4.
	 *
	 * @example
	 * // Represent 10 October 2019 in middle-endian format:
	 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456))
	 * //=> 10/4/2019
	 */
	function intlFormat(date, formatOrLocale, localeOptions) {
	  var _localeOptions;
	
	  (0, _index.default)(1, arguments);
	  var formatOptions;
	
	  if (isFormatOptions(formatOrLocale)) {
	    formatOptions = formatOrLocale;
	  } else {
	    localeOptions = formatOrLocale;
	  }
	
	  return new Intl.DateTimeFormat((_localeOptions = localeOptions) === null || _localeOptions === void 0 ? void 0 : _localeOptions.locale, formatOptions).format(date);
	}
	
	function isFormatOptions(opts) {
	  return opts !== undefined && !('locale' in opts);
	}
	
	module.exports = exports.default;

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAfter;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isAfter
	 * @category Common Helpers
	 * @summary Is the first date after the second one?
	 *
	 * @description
	 * Is the first date after the second one?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date that should be after the other one to return true
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is after the second date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Is 10 July 1989 after 11 February 1987?
	 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> true
	 */
	function isAfter(dirtyDate, dirtyDateToCompare) {
	  (0, _index2.default)(2, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  return date.getTime() > dateToCompare.getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBefore;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isBefore
	 * @category Common Helpers
	 * @summary Is the first date before the second one?
	 *
	 * @description
	 * Is the first date before the second one?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date that should be before the other one to return true
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is before the second date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Is 10 July 1989 before 11 February 1987?
	 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> false
	 */
	function isBefore(dirtyDate, dirtyDateToCompare) {
	  (0, _index2.default)(2, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  return date.getTime() < dateToCompare.getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEqual;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isEqual
	 * @category Common Helpers
	 * @summary Are the given dates equal?
	 *
	 * @description
	 * Are the given dates equal?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to compare
	 * @param {Date|Number} dateRight - the second date to compare
	 * @returns {Boolean} the dates are equal
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
	 * var result = isEqual(
	 *   new Date(2014, 6, 2, 6, 30, 45, 0),
	 *   new Date(2014, 6, 2, 6, 30, 45, 500)
	 * )
	 * //=> false
	 */
	function isEqual(dirtyLeftDate, dirtyRightDate) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyLeftDate);
	  var dateRight = (0, _index.default)(dirtyRightDate);
	  return dateLeft.getTime() === dateRight.getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 936 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isExists;
	
	/**
	 * @name isExists
	 * @category Common Helpers
	 * @summary Is the given date exists?
	 *
	 * @description
	 * Checks if the given arguments convert to an existing date.
	 *
	 * @param {Number} year of the date to check
	 * @param {Number} month of the date to check
	 * @param {Number} day of the date to check
	 * @returns {Boolean} the date exists
	 * @throws {TypeError} 3 arguments required
	 *
	 * @example
	 * // For the valid date:
	 * var result = isExists(2018, 0, 31)
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * var result = isExists(2018, 1, 31)
	 * //=> false
	 */
	function isExists(year, month, day) {
	  if (arguments.length < 3) {
	    throw new TypeError('3 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = new Date(year, month, day);
	  return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
	}
	
	module.exports = exports.default;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFirstDayOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isFirstDayOfMonth
	 * @category Month Helpers
	 * @summary Is the given date the first day of a month?
	 *
	 * @description
	 * Is the given date the first day of a month?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is the first day of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 1 September 2014 the first day of a month?
	 * var result = isFirstDayOfMonth(new Date(2014, 8, 1))
	 * //=> true
	 */
	function isFirstDayOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDate() === 1;
	}
	
	module.exports = exports.default;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFriday;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isFriday
	 * @category Weekday Helpers
	 * @summary Is the given date Friday?
	 *
	 * @description
	 * Is the given date Friday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Friday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 26 September 2014 Friday?
	 * var result = isFriday(new Date(2014, 8, 26))
	 * //=> true
	 */
	function isFriday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 5;
	}
	
	module.exports = exports.default;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFuture;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isFuture
	 * @category Common Helpers
	 * @summary Is the given date in the future?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the future?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in the future
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 31 December 2014 in the future?
	 * var result = isFuture(new Date(2014, 11, 31))
	 * //=> true
	 */
	function isFuture(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getTime() > Date.now();
	}
	
	module.exports = exports.default;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMatch;
	
	var _index = _interopRequireDefault(__webpack_require__(335));
	
	var _index2 = _interopRequireDefault(__webpack_require__(51));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isMatch
	 * @category Common Helpers
	 * @summary validates the date string against given formats
	 *
	 * @description
	 * Return the true if given date is string correct against the given format else
	 * will return false.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://git.io/fxCyr
	 *
	 * The characters in the format string wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 *
	 * Format of the format string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 5 below the table).
	 *
	 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
	 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
	 *
	 * ```javascript
	 * isMatch('23 AM', 'HH a')
	 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
	 * ```
	 *
	 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
	 *
	 * Accepted format string patterns:
	 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
	 * |---------------------------------|-----|---------|-----------------------------------|-------|
	 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
	 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 |     | GGGGG   | A, B                              |       |
	 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
	 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
	 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
	 * |                                 |     | yyyyy   | ...                               | 2,4   |
	 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
	 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
	 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
	 * |                                 |     | YYYYY   | ...                               | 2,4   |
	 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
	 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
	 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
	 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
	 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
	 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
	 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
	 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
	 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
	 * |                                 |     | uuuuu   | ...                               | 2,4   |
	 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
	 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
	 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
	 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
	 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
	 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
	 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
	 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
	 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
	 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
	 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
	 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
	 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
	 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
	 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 |     | DDDD    | ...                               | 2     |
	 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
	 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
	 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
	 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
	 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
	 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
	 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
	 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
	 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
	 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
	 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 |     | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
	 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
	 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
	 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
	 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
	 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
	 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
	 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
	 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
	 * |                                 |     | tt      | ...                               | 2     |
	 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
	 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
	 * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
	 * |                                 |     | SSSS    | ...                               | 2     |
	 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
	 * |                                 |     | TT      | ...                               | 2     |
	 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
	 * |                                 |     | XX      | -0800, +0530, Z                   |       |
	 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
	 * |                                 |     | xx      | -0800, +0530, +0000               |       |
	 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
	 * |                                 |     | PP      | May 29, 1453                      |       |
	 * |                                 |     | PPP     | May 29th, 1453                    |       |
	 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
	 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
	 * |                                 |     | pp      | 12:00:00 AM                       |       |
	 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
	 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
	 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
	 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular.
	 *    In `format` function, they will produce different result:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 *    `isMatch` will try to match both formatting and stand-alone units interchangably.
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table:
	 *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
	 *      as wide as the sequence
	 *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
	 *      These variations are marked with "2" in the last column of the table.
	 *
	 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 4. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
	 *
	 *    `isMatch('50', 'yy') //=> true`
	 *
	 *    `isMatch('75', 'yy') //=> true`
	 *
	 *    while `uu` will use the year as is:
	 *
	 *    `isMatch('50', 'uu') //=> true`
	 *
	 *    `isMatch('75', 'uu') //=> true`
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
	 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
	 *
	 * 5. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
	 *    on the given locale.
	 *
	 *    using `en-US` locale: `P` => `MM/dd/yyyy`
	 *    using `en-US` locale: `p` => `hh:mm a`
	 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
	 *    using `pt-BR` locale: `p` => `HH:mm`
	 *
	 * Values will be checked in the descending order of its unit's priority.
	 * Units of an equal priority overwrite each other in the order of appearance.
	 *
	 * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
	 * the values will be taken from today's using `new Date()` date which works as a context of parsing.
	 *
	 * The result may vary by locale.
	 *
	 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
	 *
	 *
	 *
	 * @param {String} dateString - the date string to verify
	 * @param {String} formatString - the string of tokens
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://git.io/fxCyr
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://git.io/fxCyr
	 * @returns {Boolean}
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} `options.locale` must contain `match` property
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Match 11 February 2014 from middle-endian format:
	 * var result = isMatch('02/11/2014', 'MM/dd/yyyy')
	 * //=> true
	 *
	 * @example
	 * // Match 28th of February in Esperanto locale in the context of 2010 year:
	 * import eo from 'date-fns/locale/eo'
	 * var result = isMatch('28-a de februaro', "do 'de' MMMM", {
	 *   locale: eo
	 * })
	 * //=> true
	 */
	function isMatch(dateString, formatString, options) {
	  (0, _index3.default)(2, arguments);
	  return (0, _index2.default)((0, _index.default)(dateString, formatString, new Date(), options));
	}
	
	module.exports = exports.default;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMonday;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isMonday
	 * @category Weekday Helpers
	 * @summary Is the given date Monday?
	 *
	 * @description
	 * Is the given date Monday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Monday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 22 September 2014 Monday?
	 * var result = isMonday(new Date(2014, 8, 22))
	 * //=> true
	 */
	function isMonday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date).getDay() === 1;
	}
	
	module.exports = exports.default;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPast;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isPast
	 * @category Common Helpers
	 * @summary Is the given date in the past?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the past?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in the past
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 2 July 2014 in the past?
	 * var result = isPast(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isPast(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getTime() < Date.now();
	}
	
	module.exports = exports.default;

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(113));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Are the given dates in the same ISO week-numbering year?
	 *
	 * @description
	 * Are the given dates in the same ISO week-numbering year?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `isSameISOYear` to `isSameISOWeekYear`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same ISO week-numbering year
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
	 * var result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
	 * //=> true
	 */
	function isSameISOWeekYear(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfYear = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfYear = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisHour;
	
	var _index = _interopRequireDefault(__webpack_require__(313));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisHour
	 * @category Hour Helpers
	 * @summary Is the given date in the same hour as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same hour as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this hour
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:00:00 in this hour?
	 * var result = isThisHour(new Date(2014, 8, 25, 18))
	 * //=> true
	 */
	function isThisHour(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	
	module.exports = exports.default;

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(314));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisISOWeek
	 * @category ISO Week Helpers
	 * @summary Is the given date in the same ISO week as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same ISO week as the current date?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
	 * var result = isThisISOWeek(new Date(2014, 8, 22))
	 * //=> true
	 */
	function isThisISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now());
	}
	
	module.exports = exports.default;

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisMinute;
	
	var _index = _interopRequireDefault(__webpack_require__(315));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisMinute
	 * @category Minute Helpers
	 * @summary Is the given date in the same minute as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same minute as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this minute
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:30:00 in this minute?
	 * var result = isThisMinute(new Date(2014, 8, 25, 18, 30))
	 * //=> true
	 */
	function isThisMinute(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	
	module.exports = exports.default;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(316));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisMonth
	 * @category Month Helpers
	 * @summary Is the given date in the same month as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same month as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 15 September 2014 in this month?
	 * var result = isThisMonth(new Date(2014, 8, 15))
	 * //=> true
	 */
	function isThisMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	
	module.exports = exports.default;

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(317));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisQuarter
	 * @category Quarter Helpers
	 * @summary Is the given date in the same quarter as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same quarter as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
	 * var result = isThisQuarter(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isThisQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	
	module.exports = exports.default;

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisSecond;
	
	var _index = _interopRequireDefault(__webpack_require__(318));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisSecond
	 * @category Second Helpers
	 * @summary Is the given date in the same second as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same second as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this second
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:30:15.000 in this second?
	 * var result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
	 * //=> true
	 */
	function isThisSecond(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	
	module.exports = exports.default;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(209));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisWeek
	 * @category Week Helpers
	 * @summary Is the given date in the same week as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same week as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @param {Object} [options] - the object with options
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Boolean} the date is in this week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // If today is 25 September 2014, is 21 September 2014 in this week?
	 * var result = isThisWeek(new Date(2014, 8, 21))
	 * //=> true
	 *
	 * @example
	 * // If today is 25 September 2014 and week starts with Monday
	 * // is 21 September 2014 in this week?
	 * var result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
	 * //=> false
	 */
	function isThisWeek(dirtyDate, options) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now(), options);
	}
	
	module.exports = exports.default;

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisYear;
	
	var _index = _interopRequireDefault(__webpack_require__(319));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisYear
	 * @category Year Helpers
	 * @summary Is the given date in the same year as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same year as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 2 July 2014 in this year?
	 * var result = isThisYear(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isThisYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now());
	}
	
	module.exports = exports.default;

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThursday;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThursday
	 * @category Weekday Helpers
	 * @summary Is the given date Thursday?
	 *
	 * @description
	 * Is the given date Thursday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Thursday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 25 September 2014 Thursday?
	 * var result = isThursday(new Date(2014, 8, 25))
	 * //=> true
	 */
	function isThursday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 4;
	}
	
	module.exports = exports.default;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isToday;
	
	var _index = _interopRequireDefault(__webpack_require__(112));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isToday
	 * @category Day Helpers
	 * @summary Is the given date today?
	 * @pure false
	 *
	 * @description
	 * Is the given date today?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is today
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 6 October 14:00:00 today?
	 * var result = isToday(new Date(2014, 9, 6, 14, 0))
	 * //=> true
	 */
	function isToday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now());
	}
	
	module.exports = exports.default;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isTomorrow;
	
	var _index = _interopRequireDefault(__webpack_require__(58));
	
	var _index2 = _interopRequireDefault(__webpack_require__(112));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isTomorrow
	 * @category Day Helpers
	 * @summary Is the given date tomorrow?
	 * @pure false
	 *
	 * @description
	 * Is the given date tomorrow?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is tomorrow
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
	 * var result = isTomorrow(new Date(2014, 9, 7, 14, 0))
	 * //=> true
	 */
	function isTomorrow(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  return (0, _index2.default)(dirtyDate, (0, _index.default)(Date.now(), 1));
	}
	
	module.exports = exports.default;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isTuesday;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isTuesday
	 * @category Weekday Helpers
	 * @summary Is the given date Tuesday?
	 *
	 * @description
	 * Is the given date Tuesday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Tuesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 23 September 2014 Tuesday?
	 * var result = isTuesday(new Date(2014, 8, 23))
	 * //=> true
	 */
	function isTuesday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 2;
	}
	
	module.exports = exports.default;

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWednesday;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isWednesday
	 * @category Weekday Helpers
	 * @summary Is the given date Wednesday?
	 *
	 * @description
	 * Is the given date Wednesday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Wednesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 24 September 2014 Wednesday?
	 * const result = isWednesday(new Date(2014, 8, 24))
	 * //=> true
	 */
	function isWednesday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 3;
	}
	
	module.exports = exports.default;

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWithinInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isWithinInterval
	 * @category Interval Helpers
	 * @summary Is the given date within the interval?
	 *
	 * @description
	 * Is the given date within the interval? (Including start and end.)
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `isWithinRange` to `isWithinInterval`.
	 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
	 *
	 *   ```
	 *   2.1.3
	 *   time interval
	 *   part of the time axis limited by two instants
	 *   ```
	 *
	 *   Also, this function now accepts an object with `start` and `end` properties
	 *   instead of two arguments as an interval.
	 *   This function now throws `RangeError` if the start of the interval is after its end
	 *   or if any date in the interval is `Invalid Date`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   isWithinRange(
	 *     new Date(2014, 0, 3),
	 *     new Date(2014, 0, 1), new Date(2014, 0, 7)
	 *   )
	 *
	 *   // v2.0.0 onward
	 *
	 *   isWithinInterval(
	 *     new Date(2014, 0, 3),
	 *     { start: new Date(2014, 0, 1), end: new Date(2014, 0, 7) }
	 *   )
	 *   ```
	 *
	 * @param {Date|Number} date - the date to check
	 * @param {Interval} interval - the interval to check
	 * @returns {Boolean} the date is within the interval
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For the date within the interval:
	 * isWithinInterval(new Date(2014, 0, 3), {
	 *   start: new Date(2014, 0, 1),
	 *   end: new Date(2014, 0, 7)
	 * })
	 * //=> true
	 *
	 * @example
	 * // For the date outside of the interval:
	 * isWithinInterval(new Date(2014, 0, 10), {
	 *   start: new Date(2014, 0, 1),
	 *   end: new Date(2014, 0, 7)
	 * })
	 * //=> false
	 *
	 * @example
	 * // For date equal to interval start:
	 * isWithinInterval(date, { start, end: date }) // => true
	 *
	 * @example
	 * // For date equal to interval end:
	 * isWithinInterval(date, { start: date, end }) // => true
	 */
	function isWithinInterval(dirtyDate, interval) {
	  (0, _index2.default)(2, arguments);
	  var time = (0, _index.default)(dirtyDate).getTime();
	  var startTime = (0, _index.default)(interval.start).getTime();
	  var endTime = (0, _index.default)(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startTime <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  return time >= startTime && time <= endTime;
	}
	
	module.exports = exports.default;

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isYesterday;
	
	var _index = _interopRequireDefault(__webpack_require__(112));
	
	var _index2 = _interopRequireDefault(__webpack_require__(141));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isYesterday
	 * @category Day Helpers
	 * @summary Is the given date yesterday?
	 * @pure false
	 *
	 * @description
	 * Is the given date yesterday?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is yesterday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
	 * var result = isYesterday(new Date(2014, 9, 5, 14, 0))
	 * //=> true
	 */
	function isYesterday(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, (0, _index2.default)(Date.now(), 1));
	}
	
	module.exports = exports.default;

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfDecade;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfDecade
	 * @category Decade Helpers
	 * @summary Return the last day of a decade for the given date.
	 *
	 * @description
	 * Return the last day of a decade for the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of a decade
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of a decade for 21 December 2012 21:12:00:
	 * var result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
	 * //=> Wed Dec 31 2019 00:00:00
	 */
	function lastDayOfDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = 9 + Math.floor(year / 10) * 10;
	  date.setFullYear(decade + 1, 0, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(91));
	
	var _index2 = _interopRequireDefault(__webpack_require__(81));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the last day of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the last day of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `lastDayOfISOYear` to `lastDayOfISOWeekYear`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of an ISO week-numbering year for 2 July 2005:
	 * var result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
	 * //=> Sun Jan 01 2006 00:00:00
	 */
	function lastDayOfISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setFullYear(year + 1, 0, 4);
	  fourthOfJanuary.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  date.setDate(date.getDate() - 1);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(322));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfISOWeek
	 * @category ISO Week Helpers
	 * @summary Return the last day of an ISO week for the given date.
	 *
	 * @description
	 * Return the last day of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of an ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of an ISO week for 2 September 2014 11:55:00:
	 * var result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function lastDayOfISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, {
	    weekStartsOn: 1
	  });
	}
	
	module.exports = exports.default;

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfQuarter
	 * @category Quarter Helpers
	 * @summary Return the last day of a year quarter for the given date.
	 *
	 * @description
	 * Return the last day of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the last day of a quarter
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // The last day of a quarter for 2 September 2014 11:55:00:
	 * var result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function lastDayOfQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var currentMonth = date.getMonth();
	  var month = currentMonth - currentMonth % 3 + 3;
	  date.setMonth(month, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfYear
	 * @category Year Helpers
	 * @summary Return the last day of a year for the given date.
	 *
	 * @description
	 * Return the last day of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of a year for 2 September 2014 11:55:00:
	 * var result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Dec 31 2014 00:00:00
	 */
	function lastDayOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  date.setFullYear(year + 1, 0, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lightFormat;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(279));
	
	var _index3 = _interopRequireDefault(__webpack_require__(57));
	
	var _index4 = _interopRequireDefault(__webpack_require__(51));
	
	var _index5 = _interopRequireDefault(__webpack_require__(114));
	
	var _index6 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This RegExp consists of three parts separated by `|`:
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	var formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	/**
	 * @name lightFormat
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format. Unlike `format`,
	 * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
	 *
	 * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
	 * > See: https://git.io/fxCyr
	 *
	 * The characters wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 *
	 * Format of the string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 *
	 * Accepted patterns:
	 * | Unit                            | Pattern | Result examples                   |
	 * |---------------------------------|---------|-----------------------------------|
	 * | AM, PM                          | a..aaa  | AM, PM                            |
	 * |                                 | aaaa    | a.m., p.m.                        |
	 * |                                 | aaaaa   | a, p                              |
	 * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
	 * |                                 | yy      | 44, 01, 00, 17                    |
	 * |                                 | yyy     | 044, 001, 000, 017                |
	 * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
	 * | Month (formatting)              | M       | 1, 2, ..., 12                     |
	 * |                                 | MM      | 01, 02, ..., 12                   |
	 * | Day of month                    | d       | 1, 2, ..., 31                     |
	 * |                                 | dd      | 01, 02, ..., 31                   |
	 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
	 * |                                 | hh      | 01, 02, ..., 11, 12               |
	 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
	 * |                                 | HH      | 00, 01, 02, ..., 23               |
	 * | Minute                          | m       | 0, 1, ..., 59                     |
	 * |                                 | mm      | 00, 01, ..., 59                   |
	 * | Second                          | s       | 0, 1, ..., 59                     |
	 * |                                 | ss      | 00, 01, ..., 59                   |
	 * | Fraction of second              | S       | 0, 1, ..., 9                      |
	 * |                                 | SS      | 00, 01, ..., 99                   |
	 * |                                 | SSS     | 000, 0001, ..., 999               |
	 * |                                 | SSSS    | ...                               |
	 *
	 * @param {Date|Number} date - the original date
	 * @param {String} format - the string of tokens
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * const result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
	 * //=> '2014-02-11'
	 */
	
	function lightFormat(dirtyDate, formatStr) {
	  (0, _index6.default)(2, arguments);
	  var originalDate = (0, _index.default)(dirtyDate);
	
	  if (!(0, _index4.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
	
	
	  var timezoneOffset = (0, _index3.default)(originalDate);
	  var utcDate = (0, _index5.default)(originalDate, timezoneOffset);
	  var tokens = formatStr.match(formattingTokensRegExp); // The only case when formattingTokensRegExp doesn't match the string is when it's empty
	
	  if (!tokens) return '';
	  var result = tokens.map(function (substring) {
	    // Replace two single quote characters with one single quote character
	    if (substring === "''") {
	      return "'";
	    }
	
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === "'") {
	      return cleanEscapedString(substring);
	    }
	
	    var formatter = _index2.default[firstCharacter];
	
	    if (formatter) {
	      return formatter(utcDate, substring);
	    }
	
	    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	    }
	
	    return substring;
	  }).join('');
	  return result;
	}
	
	function cleanEscapedString(input) {
	  var matches = input.match(escapedStringRegExp);
	
	  if (!matches) {
	    return input;
	  }
	
	  return matches[1].replace(doubleQuoteRegExp, "'");
	}
	
	module.exports = exports.default;

/***/ }),
/* 965 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: "minder as 'n sekonde",
	    other: 'minder as {{count}} sekondes'
	  },
	  xSeconds: {
	    one: '1 sekonde',
	    other: '{{count}} sekondes'
	  },
	  halfAMinute: "'n halwe minuut",
	  lessThanXMinutes: {
	    one: "minder as 'n minuut",
	    other: 'minder as {{count}} minute'
	  },
	  xMinutes: {
	    one: "'n minuut",
	    other: '{{count}} minute'
	  },
	  aboutXHours: {
	    one: 'ongeveer 1 uur',
	    other: 'ongeveer {{count}} ure'
	  },
	  xHours: {
	    one: '1 uur',
	    other: '{{count}} ure'
	  },
	  xDays: {
	    one: '1 dag',
	    other: '{{count}} dae'
	  },
	  aboutXWeeks: {
	    one: 'ongeveer 1 week',
	    other: 'ongeveer {{count}} weke'
	  },
	  xWeeks: {
	    one: '1 week',
	    other: '{{count}} weke'
	  },
	  aboutXMonths: {
	    one: 'ongeveer 1 maand',
	    other: 'ongeveer {{count}} maande'
	  },
	  xMonths: {
	    one: '1 maand',
	    other: '{{count}} maande'
	  },
	  aboutXYears: {
	    one: 'ongeveer 1 jaar',
	    other: 'ongeveer {{count}} jaar'
	  },
	  xYears: {
	    one: '1 jaar',
	    other: '{{count}} jaar'
	  },
	  overXYears: {
	    one: 'meer as 1 jaar',
	    other: 'meer as {{count}} jaar'
	  },
	  almostXYears: {
	    one: 'byna 1 jaar',
	    other: 'byna {{count}} jaar'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'oor ' + result;
	    } else {
	      return result + ' gelede';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d MMMM yyyy',
	  long: 'd MMMM yyyy',
	  medium: 'd MMM yyyy',
	  short: 'yyyy/MM/dd'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'om' {{time}}",
	  long: "{{date}} 'om' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 967 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'verlede' eeee 'om' p",
	  yesterday: "'gister om' p",
	  today: "'vandag om' p",
	  tomorrow: "'môre om' p",
	  nextWeek: "eeee 'om' p",
	  other: 'P'
	};
	
	function formatRelative(token) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['vC', 'nC'],
	  abbreviated: ['vC', 'nC'],
	  wide: ['voor Christus', 'na Christus']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['K1', 'K2', 'K3', 'K4'],
	  wide: ['1ste kwartaal', '2de kwartaal', '3de kwartaal', '4de kwartaal']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Des'],
	  wide: ['Januarie', 'Februarie', 'Maart', 'April', 'Mei', 'Junie', 'Julie', 'Augustus', 'September', 'Oktober', 'November', 'Desember']
	};
	var dayValues = {
	  narrow: ['S', 'M', 'D', 'W', 'D', 'V', 'S'],
	  short: ['So', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Sa'],
	  abbreviated: ['Son', 'Maa', 'Din', 'Woe', 'Don', 'Vry', 'Sat'],
	  wide: ['Sondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrydag', 'Saterdag']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'vm',
	    pm: 'nm',
	    midnight: 'middernag',
	    noon: 'middaguur',
	    morning: 'oggend',
	    afternoon: 'middag',
	    evening: 'laat middag',
	    night: 'aand'
	  },
	  abbreviated: {
	    am: 'vm',
	    pm: 'nm',
	    midnight: 'middernag',
	    noon: 'middaguur',
	    morning: 'oggend',
	    afternoon: 'middag',
	    evening: 'laat middag',
	    night: 'aand'
	  },
	  wide: {
	    am: 'vm',
	    pm: 'nm',
	    midnight: 'middernag',
	    noon: 'middaguur',
	    morning: 'oggend',
	    afternoon: 'middag',
	    evening: 'laat middag',
	    night: 'aand'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'vm',
	    pm: 'nm',
	    midnight: 'middernag',
	    noon: 'uur die middag',
	    morning: 'uur die oggend',
	    afternoon: 'uur die middag',
	    evening: 'uur die aand',
	    night: 'uur die aand'
	  },
	  abbreviated: {
	    am: 'vm',
	    pm: 'nm',
	    midnight: 'middernag',
	    noon: 'uur die middag',
	    morning: 'uur die oggend',
	    afternoon: 'uur die middag',
	    evening: 'uur die aand',
	    night: 'uur die aand'
	  },
	  wide: {
	    am: 'vm',
	    pm: 'nm',
	    midnight: 'middernag',
	    noon: 'uur die middag',
	    morning: 'uur die oggend',
	    afternoon: 'uur die middag',
	    evening: 'uur die aand',
	    night: 'uur die aand'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  var rem100 = number % 100;
	
	  if (rem100 < 20) {
	    switch (rem100) {
	      case 1:
	      case 8:
	        return number + 'ste';
	
	      default:
	        return number + 'de';
	    }
	  }
	
	  return number + 'ste';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(ste|de)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^([vn]\.? ?C\.?)/,
	  abbreviated: /^([vn]\. ?C\.?)/,
	  wide: /^((voor|na) Christus)/
	};
	var parseEraPatterns = {
	  any: [/^v/, /^n/]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^K[1234]/i,
	  wide: /^[1234](st|d)e kwartaal/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(Jan|Feb|Mrt|Apr|Mei|Jun|Jul|Aug|Sep|Okt|Nov|Dec)\.?/i,
	  wide: /^(Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^J/i, /^F/i, /^M/i, /^A/i, /^M/i, /^J/i, /^J/i, /^A/i, /^S/i, /^O/i, /^N/i, /^D/i],
	  any: [/^Jan/i, /^Feb/i, /^Mrt/i, /^Apr/i, /^Mei/i, /^Jun/i, /^Jul/i, /^Aug/i, /^Sep/i, /^Okt/i, /^Nov/i, /^Dec/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smdwv]/i,
	  short: /^(So|Ma|Di|Wo|Do|Vr|Sa)/i,
	  abbreviated: /^(Son|Maa|Din|Woe|Don|Vry|Sat)/i,
	  wide: /^(Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag)/i
	};
	var parseDayPatterns = {
	  narrow: [/^S/i, /^M/i, /^D/i, /^W/i, /^D/i, /^V/i, /^S/i],
	  any: [/^So/i, /^Ma/i, /^Di/i, /^Wo/i, /^Do/i, /^Vr/i, /^Sa/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(vm|nm|middernag|(?:uur )?die (oggend|middag|aand))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^vm/i,
	    pm: /^nm/i,
	    midnight: /^middernag/i,
	    noon: /^middaguur/i,
	    morning: /oggend/i,
	    afternoon: /middag/i,
	    evening: /laat middag/i,
	    night: /aand/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(965));
	
	var _index2 = _interopRequireDefault(__webpack_require__(966));
	
	var _index3 = _interopRequireDefault(__webpack_require__(967));
	
	var _index4 = _interopRequireDefault(__webpack_require__(968));
	
	var _index5 = _interopRequireDefault(__webpack_require__(969));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Afrikaans locale.
	 * @language Afrikaans
	 * @iso-639-2 afr
	 * @author Marnus Weststrate [@marnusw]{@link https://github.com/marnusw}
	 */
	var locale = {
	  code: 'af',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 971 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'أقل من ثانية واحدة',
	    two: 'أقل من ثانتين',
	    threeToTen: 'أقل من {{count}} ثواني',
	    other: 'أقل من {{count}} ثانية'
	  },
	  xSeconds: {
	    one: 'ثانية واحدة',
	    two: 'ثانتين',
	    threeToTen: '{{count}} ثواني',
	    other: '{{count}} ثانية'
	  },
	  halfAMinute: 'نصف دقيقة',
	  lessThanXMinutes: {
	    one: 'أقل من دقيقة',
	    two: 'أقل من دقيقتين',
	    threeToTen: 'أقل من {{count}} دقائق',
	    other: 'أقل من {{count}} دقيقة'
	  },
	  xMinutes: {
	    one: 'دقيقة واحدة',
	    two: 'دقيقتين',
	    threeToTen: '{{count}} دقائق',
	    other: '{{count}} دقيقة'
	  },
	  aboutXHours: {
	    one: 'ساعة واحدة تقريباً',
	    two: 'ساعتين تقريباً',
	    threeToTen: '{{count}} ساعات تقريباً',
	    other: '{{count}} ساعة تقريباً'
	  },
	  xHours: {
	    one: 'ساعة واحدة',
	    two: 'ساعتين',
	    threeToTen: '{{count}} ساعات',
	    other: '{{count}} ساعة'
	  },
	  xDays: {
	    one: 'يوم واحد',
	    two: 'يومين',
	    threeToTen: '{{count}} أيام',
	    other: '{{count}} يوم'
	  },
	  aboutXWeeks: {
	    one: 'أسبوع واحد تقريباً',
	    two: 'أسبوعين تقريباً',
	    threeToTen: '{{count}} أسابيع تقريباً',
	    other: '{{count}} أسبوع تقريباً'
	  },
	  xWeeks: {
	    one: 'أسبوع واحد',
	    two: 'أسبوعين',
	    threeToTen: '{{count}} أسابيع',
	    other: '{{count}} أسبوع'
	  },
	  aboutXMonths: {
	    one: 'شهر واحد تقريباً',
	    two: 'شهرين تقريباً',
	    threeToTen: '{{count}} أشهر تقريباً',
	    other: '{{count}} شهر تقريباً'
	  },
	  xMonths: {
	    one: 'شهر واحد',
	    two: 'شهرين',
	    threeToTen: '{{count}} أشهر',
	    other: '{{count}} شهر'
	  },
	  aboutXYears: {
	    one: 'عام واحد تقريباً',
	    two: 'عامين تقريباً',
	    threeToTen: '{{count}} أعوام تقريباً',
	    other: '{{count}} عام تقريباً'
	  },
	  xYears: {
	    one: 'عام واحد',
	    two: 'عامين',
	    threeToTen: '{{count}} أعوام',
	    other: '{{count}} عام'
	  },
	  overXYears: {
	    one: 'أكثر من عام',
	    two: 'أكثر من عامين',
	    threeToTen: 'أكثر من {{count}} أعوام',
	    other: 'أكثر من {{count}} عام'
	  },
	  almostXYears: {
	    one: 'عام واحد تقريباً',
	    two: 'عامين تقريباً',
	    threeToTen: '{{count}} أعوام تقريباً',
	    other: '{{count}} عام تقريباً'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else if (count === 2) {
	    result = formatDistanceLocale[token].two;
	  } else if (count <= 10) {
	    result = formatDistanceLocale[token].threeToTen.replace('{{count}}', count);
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'في خلال ' + result;
	    } else {
	      return 'منذ ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, MMMM do, y',
	  long: 'MMMM do, y',
	  medium: 'MMM d, y',
	  short: 'MM/dd/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'عند' {{time}}",
	  long: "{{date}} 'عند' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 973 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'أخر' eeee 'عند' p",
	  yesterday: "'أمس عند' p",
	  today: "'اليوم عند' p",
	  tomorrow: "'غداً عند' p",
	  nextWeek: "eeee 'عند' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['ق', 'ب'],
	  abbreviated: ['ق.م.', 'ب.م.'],
	  wide: ['قبل الميلاد', 'بعد الميلاد']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['ر1', 'ر2', 'ر3', 'ر4'],
	  wide: ['الربع الأول', 'الربع الثاني', 'الربع الثالث', 'الربع الرابع']
	};
	var monthValues = {
	  narrow: ['ج', 'ف', 'م', 'أ', 'م', 'ج', 'ج', 'أ', 'س', 'أ', 'ن', 'د'],
	  abbreviated: ['جانـ', 'فيفـ', 'مارس', 'أفريل', 'مايـ', 'جوانـ', 'جويـ', 'أوت', 'سبتـ', 'أكتـ', 'نوفـ', 'ديسـ'],
	  wide: ['جانفي', 'فيفري', 'مارس', 'أفريل', 'ماي', 'جوان', 'جويلية', 'أوت', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']
	};
	var dayValues = {
	  narrow: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
	  short: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
	  abbreviated: ['أحد', 'اثنـ', 'ثلا', 'أربـ', 'خميـ', 'جمعة', 'سبت'],
	  wide: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'ن',
	    noon: 'ظ',
	    morning: 'صباحاً',
	    afternoon: 'بعد الظهر',
	    evening: 'مساءاً',
	    night: 'ليلاً'
	  },
	  abbreviated: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهر',
	    morning: 'صباحاً',
	    afternoon: 'بعد الظهر',
	    evening: 'مساءاً',
	    night: 'ليلاً'
	  },
	  wide: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهر',
	    morning: 'صباحاً',
	    afternoon: 'بعد الظهر',
	    evening: 'مساءاً',
	    night: 'ليلاً'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'ن',
	    noon: 'ظ',
	    morning: 'في الصباح',
	    afternoon: 'بعد الظـهر',
	    evening: 'في المساء',
	    night: 'في الليل'
	  },
	  abbreviated: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهر',
	    morning: 'في الصباح',
	    evening: 'في المساء',
	    night: 'في الليل'
	  },
	  wide: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهر',
	    afternoon: 'بعد الظـهر',
	    evening: 'في المساء',
	    night: 'في الليل'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  return String(dirtyNumber);
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ق|ب)/i,
	  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
	  wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
	};
	var parseEraPatterns = {
	  any: [/^قبل/i, /^بعد/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^ر[1234]/i,
	  wide: /^الربع [1234]/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[جفمأسند]/i,
	  abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
	  wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^ج/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ج/i, /^ج/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
	  any: [/^جان/i, /^فيف/i, /^مار/i, /^أفر/i, /^ماي/i, /^جوا/i, /^جوي/i, /^أوت/i, /^سبت/i, /^أكت/i, /^نوف/i, /^ديس/i]
	};
	var matchDayPatterns = {
	  narrow: /^[حنثرخجس]/i,
	  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
	  abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
	  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
	};
	var parseDayPatterns = {
	  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
	  wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
	  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
	  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mi/i,
	    noon: /^no/i,
	    morning: /morning/i,
	    afternoon: /afternoon/i,
	    evening: /evening/i,
	    night: /night/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(971));
	
	var _index2 = _interopRequireDefault(__webpack_require__(972));
	
	var _index3 = _interopRequireDefault(__webpack_require__(973));
	
	var _index4 = _interopRequireDefault(__webpack_require__(974));
	
	var _index5 = _interopRequireDefault(__webpack_require__(975));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Arabic locale (Algerian Arabic).
	 * @language Algerian Arabic
	 * @iso-639-2 ara
	 * @author Badreddine Boumaza [@badre429]{@link https://github.com/badre429}
	 * @author Ahmed ElShahat [@elshahat]{@link https://github.com/elshahat}
	 */
	var locale = {
	  code: 'ar-DZ',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 977 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'أقل من ثانية واحدة',
	    two: 'أقل من ثانتين',
	    threeToTen: 'أقل من {{count}} ثواني',
	    other: 'أقل من {{count}} ثانية'
	  },
	  xSeconds: {
	    one: 'ثانية واحدة',
	    two: 'ثانتين',
	    threeToTen: '{{count}} ثواني',
	    other: '{{count}} ثانية'
	  },
	  halfAMinute: 'نصف دقيقة',
	  lessThanXMinutes: {
	    one: 'أقل من دقيقة',
	    two: 'أقل من دقيقتين',
	    threeToTen: 'أقل من {{count}} دقائق',
	    other: 'أقل من {{count}} دقيقة'
	  },
	  xMinutes: {
	    one: 'دقيقة واحدة',
	    two: 'دقيقتين',
	    threeToTen: '{{count}} دقائق',
	    other: '{{count}} دقيقة'
	  },
	  aboutXHours: {
	    one: 'ساعة واحدة تقريباً',
	    two: 'ساعتين تقريباً',
	    threeToTen: '{{count}} ساعات تقريباً',
	    other: '{{count}} ساعة تقريباً'
	  },
	  xHours: {
	    one: 'ساعة واحدة',
	    two: 'ساعتين',
	    threeToTen: '{{count}} ساعات',
	    other: '{{count}} ساعة'
	  },
	  xDays: {
	    one: 'يوم واحد',
	    two: 'يومين',
	    threeToTen: '{{count}} أيام',
	    other: '{{count}} يوم'
	  },
	  aboutXWeeks: {
	    one: 'أسبوع واحد تقريباً',
	    two: 'أسبوعين تقريباً',
	    threeToTen: '{{count}} أسابيع تقريباً',
	    other: '{{count}} أسبوع تقريباً'
	  },
	  xWeeks: {
	    one: 'أسبوع واحد',
	    two: 'أسبوعين',
	    threeToTen: '{{count}} أسابيع',
	    other: '{{count}} أسبوع'
	  },
	  aboutXMonths: {
	    one: 'شهر واحد تقريباً',
	    two: 'شهرين تقريباً',
	    threeToTen: '{{count}} أشهر تقريباً',
	    other: '{{count}} شهر تقريباً'
	  },
	  xMonths: {
	    one: 'شهر واحد',
	    two: 'شهرين',
	    threeToTen: '{{count}} أشهر',
	    other: '{{count}} شهر'
	  },
	  aboutXYears: {
	    one: 'عام واحد تقريباً',
	    two: 'عامين تقريباً',
	    threeToTen: '{{count}} أعوام تقريباً',
	    other: '{{count}} عام تقريباً'
	  },
	  xYears: {
	    one: 'عام واحد',
	    two: 'عامين',
	    threeToTen: '{{count}} أعوام',
	    other: '{{count}} عام'
	  },
	  overXYears: {
	    one: 'أكثر من عام',
	    two: 'أكثر من عامين',
	    threeToTen: 'أكثر من {{count}} أعوام',
	    other: 'أكثر من {{count}} عام'
	  },
	  almostXYears: {
	    one: 'عام واحد تقريباً',
	    two: 'عامين تقريباً',
	    threeToTen: '{{count}} أعوام تقريباً',
	    other: '{{count}} عام تقريباً'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else if (count === 2) {
	    result = formatDistanceLocale[token].two;
	  } else if (count <= 10) {
	    result = formatDistanceLocale[token].threeToTen.replace('{{count}}', count);
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'في خلال ' + result;
	    } else {
	      return 'منذ ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, MMMM do, y',
	  long: 'MMMM do, y',
	  medium: 'MMM d, y',
	  short: 'MM/dd/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'عند' {{time}}",
	  long: "{{date}} 'عند' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 979 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'أخر' eeee 'عند' p",
	  yesterday: "'أمس عند' p",
	  today: "'اليوم عند' p",
	  tomorrow: "'غداً عند' p",
	  nextWeek: "eeee 'عند' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['ق', 'ب'],
	  abbreviated: ['ق.م.', 'ب.م.'],
	  wide: ['قبل الميلاد', 'بعد الميلاد']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['ر1', 'ر2', 'ر3', 'ر4'],
	  wide: ['الربع الأول', 'الربع الثاني', 'الربع الثالث', 'الربع الرابع']
	};
	var monthValues = {
	  narrow: ['ي', 'ف', 'م', 'أ', 'م', 'ي', 'ي', 'غ', 'ش', 'أ', 'ن', 'د'],
	  abbreviated: ['ينا', 'فبر', 'مارس', 'أبريل', 'ماي', 'يونـ', 'يولـ', 'غشت', 'شتنـ', 'أكتـ', 'نونـ', 'دجنـ'],
	  wide: ['يناير', 'فبراير', 'مارس', 'أبريل', 'ماي', 'يونيو', 'يوليوز', 'غشت', 'شتنبر', 'أكتوبر', 'نونبر', 'دجنبر']
	};
	var dayValues = {
	  narrow: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
	  short: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
	  abbreviated: ['أحد', 'اثنـ', 'ثلا', 'أربـ', 'خميـ', 'جمعة', 'سبت'],
	  wide: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'ن',
	    noon: 'ظ',
	    morning: 'صباحاً',
	    afternoon: 'بعد الظهر',
	    evening: 'مساءاً',
	    night: 'ليلاً'
	  },
	  abbreviated: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهر',
	    morning: 'صباحاً',
	    afternoon: 'بعد الظهر',
	    evening: 'مساءاً',
	    night: 'ليلاً'
	  },
	  wide: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهر',
	    morning: 'صباحاً',
	    afternoon: 'بعد الظهر',
	    evening: 'مساءاً',
	    night: 'ليلاً'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'ن',
	    noon: 'ظ',
	    morning: 'في الصباح',
	    afternoon: 'بعد الظـهر',
	    evening: 'في المساء',
	    night: 'في الليل'
	  },
	  abbreviated: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهر',
	    morning: 'في الصباح',
	    evening: 'في المساء',
	    night: 'في الليل'
	  },
	  wide: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهر',
	    afternoon: 'بعد الظـهر',
	    evening: 'في المساء',
	    night: 'في الليل'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  return String(dirtyNumber);
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ق|ب)/i,
	  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
	  wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
	};
	var parseEraPatterns = {
	  any: [/^قبل/i, /^بعد/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^ر[1234]/i,
	  wide: /^الربع [1234]/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[يفمأمسند]/i,
	  abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i,
	  wide: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^ي/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ي/i, /^ي/i, /^غ/i, /^ش/i, /^أ/i, /^ن/i, /^د/i],
	  any: [/^ين/i, /^فب/i, /^مار/i, /^أب/i, /^ماي/i, /^يون/i, /^يول/i, /^غشت/i, /^ش/i, /^أك/i, /^ن/i, /^د/i]
	};
	var matchDayPatterns = {
	  narrow: /^[حنثرخجس]/i,
	  short: /^(أحد|إثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
	  abbreviated: /^(أحد|إثن|ثلا|أرب|خمي|جمعة|سبت)/i,
	  wide: /^(الأحد|الإثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
	};
	var parseDayPatterns = {
	  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
	  wide: [/^الأحد/i, /^الإثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
	  any: [/^أح/i, /^إث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
	  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mi/i,
	    noon: /^no/i,
	    morning: /morning/i,
	    afternoon: /afternoon/i,
	    evening: /evening/i,
	    night: /night/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(977));
	
	var _index2 = _interopRequireDefault(__webpack_require__(978));
	
	var _index3 = _interopRequireDefault(__webpack_require__(979));
	
	var _index4 = _interopRequireDefault(__webpack_require__(980));
	
	var _index5 = _interopRequireDefault(__webpack_require__(981));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Arabic locale (Moroccan Arabic).
	 * @language Moroccan Arabic
	 * @iso-639-2 ara
	 * @author Achraf Rrami [@rramiachraf]{@link https://github.com/rramiachraf}
	 */
	var locale = {
	  code: 'ar-MA',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    // Monday is 1
	    weekStartsOn: 1,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 983 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'أقل من ثانية واحدة',
	    two: 'أقل من ثانتين',
	    threeToTen: 'أقل من {{count}} ثواني',
	    other: 'أقل من {{count}} ثانية'
	  },
	  xSeconds: {
	    one: 'ثانية واحدة',
	    two: 'ثانتين',
	    threeToTen: '{{count}} ثواني',
	    other: '{{count}} ثانية'
	  },
	  halfAMinute: 'نصف دقيقة',
	  lessThanXMinutes: {
	    one: 'أقل من دقيقة',
	    two: 'أقل من دقيقتين',
	    threeToTen: 'أقل من {{count}} دقائق',
	    other: 'أقل من {{count}} دقيقة'
	  },
	  xMinutes: {
	    one: 'دقيقة واحدة',
	    two: 'دقيقتين',
	    threeToTen: '{{count}} دقائق',
	    other: '{{count}} دقيقة'
	  },
	  aboutXHours: {
	    one: 'ساعة واحدة تقريباً',
	    two: 'ساعتين تقريباً',
	    threeToTen: '{{count}} ساعات تقريباً',
	    other: '{{count}} ساعة تقريباً'
	  },
	  xHours: {
	    one: 'ساعة واحدة',
	    two: 'ساعتين',
	    threeToTen: '{{count}} ساعات',
	    other: '{{count}} ساعة'
	  },
	  xDays: {
	    one: 'يوم واحد',
	    two: 'يومين',
	    threeToTen: '{{count}} أيام',
	    other: '{{count}} يوم'
	  },
	  aboutXWeeks: {
	    one: 'أسبوع واحد تقريباً',
	    two: 'أسبوعين تقريباً',
	    threeToTen: '{{count}} أسابيع تقريباً',
	    other: '{{count}} أسبوع تقريباً'
	  },
	  xWeeks: {
	    one: 'أسبوع واحد',
	    two: 'أسبوعين',
	    threeToTen: '{{count}} أسابيع',
	    other: '{{count}} أسبوع'
	  },
	  aboutXMonths: {
	    one: 'شهر واحد تقريباً',
	    two: 'شهرين تقريباً',
	    threeToTen: '{{count}} أشهر تقريباً',
	    other: '{{count}} شهر تقريباً'
	  },
	  xMonths: {
	    one: 'شهر واحد',
	    two: 'شهرين',
	    threeToTen: '{{count}} أشهر',
	    other: '{{count}} شهر'
	  },
	  aboutXYears: {
	    one: 'عام واحد تقريباً',
	    two: 'عامين تقريباً',
	    threeToTen: '{{count}} أعوام تقريباً',
	    other: '{{count}} عام تقريباً'
	  },
	  xYears: {
	    one: 'عام واحد',
	    two: 'عامين',
	    threeToTen: '{{count}} أعوام',
	    other: '{{count}} عام'
	  },
	  overXYears: {
	    one: 'أكثر من عام',
	    two: 'أكثر من عامين',
	    threeToTen: 'أكثر من {{count}} أعوام',
	    other: 'أكثر من {{count}} عام'
	  },
	  almostXYears: {
	    one: 'عام واحد تقريباً',
	    two: 'عامين تقريباً',
	    threeToTen: '{{count}} أعوام تقريباً',
	    other: '{{count}} عام تقريباً'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else if (count === 2) {
	    result = formatDistanceLocale[token].two;
	  } else if (count <= 10) {
	    result = formatDistanceLocale[token].threeToTen.replace('{{count}}', count);
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'في خلال ' + result;
	    } else {
	      return 'منذ ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, MMMM do, y',
	  long: 'MMMM do, y',
	  medium: 'MMM d, y',
	  short: 'MM/dd/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'عند' {{time}}",
	  long: "{{date}} 'عند' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 985 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'أخر' eeee 'عند' p",
	  yesterday: "'أمس عند' p",
	  today: "'اليوم عند' p",
	  tomorrow: "'غداً عند' p",
	  nextWeek: "eeee 'عند' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['ق', 'ب'],
	  abbreviated: ['ق.م.', 'ب.م.'],
	  wide: ['قبل الميلاد', 'بعد الميلاد']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['ر1', 'ر2', 'ر3', 'ر4'],
	  wide: ['الربع الأول', 'الربع الثاني', 'الربع الثالث', 'الربع الرابع']
	};
	var monthValues = {
	  narrow: ['ي', 'ف', 'م', 'أ', 'م', 'ي', 'ي', 'أ', 'س', 'أ', 'ن', 'د'],
	  abbreviated: ['ينا', 'فبر', 'مارس', 'أبريل', 'مايو', 'يونـ', 'يولـ', 'أغسـ', 'سبتـ', 'أكتـ', 'نوفـ', 'ديسـ'],
	  wide: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']
	};
	var dayValues = {
	  narrow: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
	  short: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
	  abbreviated: ['أحد', 'اثنـ', 'ثلا', 'أربـ', 'خميـ', 'جمعة', 'سبت'],
	  wide: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'ن',
	    noon: 'ظ',
	    morning: 'صباحاً',
	    afternoon: 'بعد الظهر',
	    evening: 'مساءاً',
	    night: 'ليلاً'
	  },
	  abbreviated: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهر',
	    morning: 'صباحاً',
	    afternoon: 'بعد الظهر',
	    evening: 'مساءاً',
	    night: 'ليلاً'
	  },
	  wide: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهر',
	    morning: 'صباحاً',
	    afternoon: 'بعد الظهر',
	    evening: 'مساءاً',
	    night: 'ليلاً'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'ن',
	    noon: 'ظ',
	    morning: 'في الصباح',
	    afternoon: 'بعد الظـهر',
	    evening: 'في المساء',
	    night: 'في الليل'
	  },
	  abbreviated: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهر',
	    morning: 'في الصباح',
	    evening: 'في المساء',
	    night: 'في الليل'
	  },
	  wide: {
	    am: 'ص',
	    pm: 'م',
	    midnight: 'نصف الليل',
	    noon: 'ظهر',
	    afternoon: 'بعد الظـهر',
	    evening: 'في المساء',
	    night: 'في الليل'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  return String(dirtyNumber);
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ق|ب)/i,
	  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
	  wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
	};
	var parseEraPatterns = {
	  any: [/^قبل/i, /^بعد/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^ر[1234]/i,
	  wide: /^الربع [1234]/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[يفمأمسند]/i,
	  abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i,
	  wide: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^ي/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ي/i, /^ي/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
	  any: [/^ين/i, /^ف/i, /^مار/i, /^أب/i, /^ماي/i, /^يون/i, /^يول/i, /^أغ/i, /^س/i, /^أك/i, /^ن/i, /^د/i]
	};
	var matchDayPatterns = {
	  narrow: /^[حنثرخجس]/i,
	  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
	  abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
	  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
	};
	var parseDayPatterns = {
	  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
	  wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
	  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
	  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mi/i,
	    noon: /^no/i,
	    morning: /morning/i,
	    afternoon: /afternoon/i,
	    evening: /evening/i,
	    night: /night/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(983));
	
	var _index2 = _interopRequireDefault(__webpack_require__(984));
	
	var _index3 = _interopRequireDefault(__webpack_require__(985));
	
	var _index4 = _interopRequireDefault(__webpack_require__(986));
	
	var _index5 = _interopRequireDefault(__webpack_require__(987));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Arabic locale (Sauid Arabic).
	 * @language Arabic
	 * @iso-639-2 ara
	 * @author Dhaifallah Alwadani [@dalwadani]{@link https://github.com/dalwadani}
	 */
	var locale = {
	  code: 'ar-SA',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 989 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'أقل من ثانية',
	    two: 'أقل من زوز ثواني',
	    threeToTen: 'أقل من {{count}} ثواني',
	    other: 'أقل من {{count}} ثانية'
	  },
	  xSeconds: {
	    one: 'ثانية',
	    two: 'زوز ثواني',
	    threeToTen: '{{count}} ثواني',
	    other: '{{count}} ثانية'
	  },
	  halfAMinute: 'نص دقيقة',
	  lessThanXMinutes: {
	    one: 'أقل من دقيقة',
	    two: 'أقل من دقيقتين',
	    threeToTen: 'أقل من {{count}} دقايق',
	    other: 'أقل من {{count}} دقيقة'
	  },
	  xMinutes: {
	    one: 'دقيقة',
	    two: 'دقيقتين',
	    threeToTen: '{{count}} دقايق',
	    other: '{{count}} دقيقة'
	  },
	  aboutXHours: {
	    one: 'ساعة تقريب',
	    two: 'ساعتين تقريب',
	    threeToTen: '{{count}} سوايع تقريب',
	    other: '{{count}} ساعة تقريب'
	  },
	  xHours: {
	    one: 'ساعة',
	    two: 'ساعتين',
	    threeToTen: '{{count}} سوايع',
	    other: '{{count}} ساعة'
	  },
	  xDays: {
	    one: 'نهار',
	    two: 'نهارين',
	    threeToTen: '{{count}} أيام',
	    other: '{{count}} يوم'
	  },
	  aboutXWeeks: {
	    one: 'جمعة تقريب',
	    two: 'جمعتين تقريب',
	    threeToTen: '{{count}} جماع تقريب',
	    other: '{{count}} جمعة تقريب'
	  },
	  xWeeks: {
	    one: 'جمعة',
	    two: 'جمعتين',
	    threeToTen: '{{count}} جماع',
	    other: '{{count}} جمعة'
	  },
	  aboutXMonths: {
	    one: 'شهر تقريب',
	    two: 'شهرين تقريب',
	    threeToTen: '{{count}} أشهرة تقريب',
	    other: '{{count}} شهر تقريب'
	  },
	  xMonths: {
	    one: 'شهر',
	    two: 'شهرين',
	    threeToTen: '{{count}} أشهرة',
	    other: '{{count}} شهر'
	  },
	  aboutXYears: {
	    one: 'عام تقريب',
	    two: 'عامين تقريب',
	    threeToTen: '{{count}} أعوام تقريب',
	    other: '{{count}} عام تقريب'
	  },
	  xYears: {
	    one: 'عام',
	    two: 'عامين',
	    threeToTen: '{{count}} أعوام',
	    other: '{{count}} عام'
	  },
	  overXYears: {
	    one: 'أكثر من عام',
	    two: 'أكثر من عامين',
	    threeToTen: 'أكثر من {{count}} أعوام',
	    other: 'أكثر من {{count}} عام'
	  },
	  almostXYears: {
	    one: 'عام تقريب',
	    two: 'عامين تقريب',
	    threeToTen: '{{count}} أعوام تقريب',
	    other: '{{count}} عام تقريب'
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  var usageGroup = formatDistanceLocale[token];
	  var result;
	
	  if (typeof usageGroup === 'string') {
	    result = usageGroup;
	  } else if (count === 1) {
	    result = usageGroup.one;
	  } else if (count === 2) {
	    result = usageGroup.two;
	  } else if (count <= 10) {
	    result = usageGroup.threeToTen.replace('{{count}}', String(count));
	  } else {
	    result = usageGroup.other.replace('{{count}}', String(count));
	  }
	
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'في ' + result;
	    } else {
	      return 'عندو ' + result;
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE، do MMMM y',
	  long: 'do MMMM y',
	  medium: 'd MMM y',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'HH:mm:ss',
	  long: 'HH:mm:ss',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'مع' {{time}}",
	  long: "{{date}} 'مع' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 991 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'إلي فات مع' p",
	  yesterday: "'البارح مع' p",
	  today: "'اليوم مع' p",
	  tomorrow: "'غدوة مع' p",
	  nextWeek: "eeee 'الجمعة الجاية مع' p 'نهار'",
	  other: 'P'
	};
	
	var formatRelative = function (token) {
	  return formatRelativeLocale[token];
	};
	
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['ق', 'ب'],
	  abbreviated: ['ق.م.', 'ب.م.'],
	  wide: ['قبل الميلاد', 'بعد الميلاد']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['ر1', 'ر2', 'ر3', 'ر4'],
	  wide: ['الربع الأول', 'الربع الثاني', 'الربع الثالث', 'الربع الرابع']
	};
	var monthValues = {
	  narrow: ['د', 'ن', 'أ', 'س', 'أ', 'ج', 'ج', 'م', 'أ', 'م', 'ف', 'ج'],
	  abbreviated: ['جانفي', 'فيفري', 'مارس', 'أفريل', 'ماي', 'جوان', 'جويلية', 'أوت', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
	  wide: ['جانفي', 'فيفري', 'مارس', 'أفريل', 'ماي', 'جوان', 'جويلية', 'أوت', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']
	};
	var dayValues = {
	  narrow: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
	  short: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
	  abbreviated: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
	  wide: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ص',
	    pm: 'ع',
	    morning: 'الصباح',
	    noon: 'القايلة',
	    afternoon: 'بعد القايلة',
	    evening: 'العشية',
	    night: 'الليل',
	    midnight: 'نص الليل'
	  },
	  abbreviated: {
	    am: 'ص',
	    pm: 'ع',
	    morning: 'الصباح',
	    noon: 'القايلة',
	    afternoon: 'بعد القايلة',
	    evening: 'العشية',
	    night: 'الليل',
	    midnight: 'نص الليل'
	  },
	  wide: {
	    am: 'ص',
	    pm: 'ع',
	    morning: 'الصباح',
	    noon: 'القايلة',
	    afternoon: 'بعد القايلة',
	    evening: 'العشية',
	    night: 'الليل',
	    midnight: 'نص الليل'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ص',
	    pm: 'ع',
	    morning: 'في الصباح',
	    noon: 'في القايلة',
	    afternoon: 'بعد القايلة',
	    evening: 'في العشية',
	    night: 'في الليل',
	    midnight: 'نص الليل'
	  },
	  abbreviated: {
	    am: 'ص',
	    pm: 'ع',
	    morning: 'في الصباح',
	    noon: 'في القايلة',
	    afternoon: 'بعد القايلة',
	    evening: 'في العشية',
	    night: 'في الليل',
	    midnight: 'نص الليل'
	  },
	  wide: {
	    am: 'ص',
	    pm: 'ع',
	    morning: 'في الصباح',
	    noon: 'في القايلة',
	    afternoon: 'بعد القايلة',
	    evening: 'في العشية',
	    night: 'في الليل',
	    midnight: 'نص الليل'
	  }
	};
	
	var ordinalNumber = function (num) {
	  return String(num);
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /[قب]/,
	  abbreviated: /[قب]\.م\./,
	  wide: /(قبل|بعد) الميلاد/
	};
	var parseEraPatterns = {
	  any: [/قبل/, /بعد/]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /ر[1234]/,
	  wide: /الربع (الأول|الثاني|الثالث|الرابع)/
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[جفمأسند]/,
	  abbreviated: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
	  wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
	};
	var parseMonthPatterns = {
	  narrow: [/^ج/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ج/i, /^ج/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
	  any: [/^جانفي/i, /^فيفري/i, /^مارس/i, /^أفريل/i, /^ماي/i, /^جوان/i, /^جويلية/i, /^أوت/i, /^سبتمبر/i, /^أكتوبر/i, /^نوفمبر/i, /^ديسمبر/i]
	};
	var matchDayPatterns = {
	  narrow: /^[حنثرخجس]/i,
	  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
	  abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
	  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
	};
	var parseDayPatterns = {
	  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
	  wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
	  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(ص|ع|ن ل|ل|(في|مع) (صباح|قايلة|عشية|ليل))/,
	  any: /^([صع]|نص الليل|قايلة|(في|مع) (صباح|قايلة|عشية|ليل))/
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^ص/,
	    pm: /^ع/,
	    midnight: /نص الليل/,
	    noon: /قايلة/,
	    afternoon: /بعد القايلة/,
	    morning: /صباح/,
	    evening: /عشية/,
	    night: /ليل/
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(989));
	
	var _index2 = _interopRequireDefault(__webpack_require__(990));
	
	var _index3 = _interopRequireDefault(__webpack_require__(991));
	
	var _index4 = _interopRequireDefault(__webpack_require__(992));
	
	var _index5 = _interopRequireDefault(__webpack_require__(993));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Arabic locale (Tunisian Arabic).
	 * @language Arabic
	 * @iso-639-2 ara
	 * @author Koussay Haj Kacem [@essana3]{@link https://github.com/essana3}
	 */
	var locale = {
	  code: 'ar-TN',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 995 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'bir saniyədən az',
	    other: '{{count}} bir saniyədən az'
	  },
	  xSeconds: {
	    one: '1 saniyə',
	    other: '{{count}} saniyə'
	  },
	  halfAMinute: 'yarım dəqiqə',
	  lessThanXMinutes: {
	    one: 'bir dəqiqədən az',
	    other: '{{count}} bir dəqiqədən az'
	  },
	  xMinutes: {
	    one: 'bir dəqiqə',
	    other: '{{count}} dəqiqə'
	  },
	  aboutXHours: {
	    one: 'təxminən 1 saat',
	    other: 'təxminən {{count}} saat'
	  },
	  xHours: {
	    one: '1 saat',
	    other: '{{count}} saat'
	  },
	  xDays: {
	    one: '1 gün',
	    other: '{{count}} gün'
	  },
	  aboutXWeeks: {
	    one: 'təxminən 1 həftə',
	    other: 'təxminən {{count}} həftə'
	  },
	  xWeeks: {
	    one: '1 həftə',
	    other: '{{count}} həftə'
	  },
	  aboutXMonths: {
	    one: 'təxminən 1 ay',
	    other: 'təxminən {{count}} ay'
	  },
	  xMonths: {
	    one: '1 ay',
	    other: '{{count}} ay'
	  },
	  aboutXYears: {
	    one: 'təxminən 1 il',
	    other: 'təxminən {{count}} il'
	  },
	  xYears: {
	    one: '1 il',
	    other: '{{count}} il'
	  },
	  overXYears: {
	    one: '1 ildən çox',
	    other: '{{count}} ildən çox'
	  },
	  almostXYears: {
	    one: 'demək olar ki 1 il',
	    other: 'demək olar ki {{count}} il'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result + ' əvvəl';
	    } else {
	      return result + ' sonra';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, do MMMM y 'il'",
	  long: "do MMMM y 'il'",
	  medium: "d MMM y 'il'",
	  short: 'dd.MM.yyyy'
	};
	var timeFormats = {
	  full: 'H:mm:ss zzzz',
	  long: 'H:mm:ss z',
	  medium: 'H:mm:ss',
	  short: 'H:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} {{time}} - 'də'",
	  long: "{{date}} {{time}} - 'də'",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 997 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'sonuncu' eeee p -'də'",
	  yesterday: "'dünən' p -'də'",
	  today: "'bugün' p -'də'",
	  tomorrow: "'sabah' p -'də'",
	  nextWeek: "eeee p -'də'",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['B', 'A'],
	  abbreviated: ['BC', 'AD'],
	  wide: ["Hz. İsa'dan öncə", 'Anno Domini']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['K1', 'K2', 'K3', 'K4'],
	  wide: ['1ci kvartal', '2ci kvartal', '3cü kvartal', '4cü kvartal'] // Note: in English, the names of days of the week and months are capitalized.
	  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
	  // Generally, formatted dates should look like they are in the middle of a sentence,
	  // e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	};
	var monthValues = {
	  narrow: ['Y', 'F', 'M', 'A', 'M', 'I', 'I', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Yan', 'Fev', 'Mar', 'Apr', 'May', 'İyun', 'İyul', 'Avq', 'Sen', 'Okt', 'Noy', 'Dek'],
	  wide: ['Yanvar', 'Fevral', 'Mart', 'Aprel', 'May', 'İyun', 'İyul', 'Avqust', 'Sentyabr', 'Oktyabr', 'Noyabr', 'Dekabr']
	};
	var dayValues = {
	  narrow: ['B.', 'B.e', 'Ç.a', 'Ç.', 'C.a', 'C.', 'Ş.'],
	  short: ['B.', 'B.e', 'Ç.a', 'Ç.', 'C.a', 'C.', 'Ş.'],
	  abbreviated: ['Baz', 'Baz.e', 'Çər.a', 'Çər', 'Cüm.a', 'Cüm', 'Şə'],
	  wide: ['Bazar', 'Bazar ertəsi', 'Çərşənbə axşamı', 'Çərşənbə', 'Cümə axşamı', 'Cümə', 'Şənbə']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'gecəyarı',
	    noon: 'gün',
	    morning: 'səhər',
	    afternoon: 'gündüz',
	    evening: 'axşam',
	    night: 'gecə'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'gecəyarı',
	    noon: 'gün',
	    morning: 'səhər',
	    afternoon: 'gündüz',
	    evening: 'axşam',
	    night: 'gecə'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'gecəyarı',
	    noon: 'gün',
	    morning: 'səhər',
	    afternoon: 'gündüz',
	    evening: 'axşam',
	    night: 'gecə'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'gecəyarı',
	    noon: 'gün',
	    morning: 'səhər',
	    afternoon: 'gündüz',
	    evening: 'axşam',
	    night: 'gecə'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'gecəyarı',
	    noon: 'gün',
	    morning: 'səhər',
	    afternoon: 'gündüz',
	    evening: 'axşam',
	    night: 'gecə'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'gecəyarı',
	    noon: 'gün',
	    morning: 'səhər',
	    afternoon: 'gündüz',
	    evening: 'axşam',
	    night: 'gecə'
	  }
	};
	var suffixes = {
	  1: '-inci',
	  5: '-inci',
	  8: '-inci',
	  70: '-inci',
	  80: '-inci',
	  2: '-nci',
	  7: '-nci',
	  20: '-nci',
	  50: '-nci',
	  3: '-üncü',
	  4: '-üncü',
	  100: '-üncü',
	  6: '-ncı',
	  9: '-uncu',
	  10: '-uncu',
	  30: '-uncu',
	  60: '-ıncı',
	  90: '-ıncı'
	};
	
	function getSuffix(number) {
	  if (number === 0) {
	    // special case for zero
	    return number + '-ıncı';
	  }
	
	  var a = number % 10,
	      b = number % 100 - a,
	      c = number >= 100 ? 100 : null;
	  return suffixes[a] || suffixes[b] || suffixes[c];
	}
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber);
	  var suffix = getSuffix(number);
	  return number + suffix;
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(-?(ci|inci|nci|uncu|üncü|ncı))?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(b|a)$/i,
	  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)$/i,
	  wide: /^(Hz. İsa'dan öncə|ümumi eradan əvvəl|anno domini|ümumi dövr)$/i
	};
	var parseEraPatterns = {
	  any: [/^b$/i, /^(a|c)$/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]$/i,
	  abbreviated: /^K[1234]$/i,
	  wide: /^[1234](ci)? kvartal$/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[(?-i)yfmaisond]$/i,
	  abbreviated: /^(Yan|Fev|Mar|Apr|May|İyun|İyul|Avq|Sen|Okt|Noy|Dek)$/i,
	  wide: /^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avgust|Sentyabr|Oktyabr|Noyabr|Dekabr)$/i
	};
	var parseMonthPatterns = {
	  narrow: [/^[(?-i)y]$/i, /^[(?-i)f]$/i, /^[(?-i)m]$/i, /^[(?-i)a]$/i, /^[(?-i)m]$/i, /^[(?-i)i]$/i, /^[(?-i)i]$/i, /^[(?-i)a]$/i, /^[(?-i)s]$/i, /^[(?-i)o]$/i, /^[(?-i)n]$/i, /^[(?-i)d]$/i],
	  abbreviated: [/^Yan$/i, /^Fev$/i, /^Mar$/i, /^Apr$/i, /^May$/i, /^İyun$/i, /^İyul$/i, /^Avg$/i, /^Sen$/i, /^Okt$/i, /^Noy$/i, /^Dek$/i],
	  wide: [/^Yanvar$/i, /^Fevral$/i, /^Mart$/i, /^Aprel$/i, /^May$/i, /^İyun$/i, /^İyul$/i, /^Avgust$/i, /^Sentyabr$/i, /^Oktyabr$/i, /^Noyabr$/i, /^Dekabr$/i]
	};
	var matchDayPatterns = {
	  narrow: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
	  short: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
	  abbreviated: /^(Baz\.e|Çər|Çər\.a|Cüm|Cüm\.a|Şə)$/i,
	  wide: /^(Bazar|Bazar ertəsi|Çərşənbə axşamı|Çərşənbə|Cümə axşamı|Cümə|Şənbə)$/i
	};
	var parseDayPatterns = {
	  narrow: [/^B\.$/i, /^B\.e$/i, /^Ç\.a$/i, /^Ç\.$/i, /^C\.a$/i, /^C\.$/i, /^Ş\.$/i],
	  abbreviated: [/^Baz\.e$/i, /^Çər$/i, /^Çər\.a$/i, /^Cüm$/i, /^Cüm\.a$/i, /^Şə$/i],
	  wide: [/^Bazar$/i, /^Bazar ertəsi$/i, /^Çərşənbə axşamı$/i, /^Çərşənbə$/i, /^Cümə axşamı$/i, /^Cümə$/i, /^Şənbə$/i],
	  any: [/^B\.$/i, /^B\.e$/i, /^Ç\.a$/i, /^Ç\.$/i, /^C\.a$/i, /^C\.$/i, /^Ş\.$/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i,
	  any: /^(am|pm|a\.m\.|p\.m\.|AM|PM|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a$/i,
	    pm: /^p$/i,
	    midnight: /^gecəyarı$/i,
	    noon: /^gün$/i,
	    morning: /səhər$/i,
	    afternoon: /gündüz$/i,
	    evening: /axşam$/i,
	    night: /gecə$/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(995));
	
	var _index2 = _interopRequireDefault(__webpack_require__(996));
	
	var _index3 = _interopRequireDefault(__webpack_require__(997));
	
	var _index4 = _interopRequireDefault(__webpack_require__(998));
	
	var _index5 = _interopRequireDefault(__webpack_require__(999));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Azerbaijani locale.
	 * @language Azerbaijani
	 * @iso-639-2 aze
	 */
	var locale = {
	  code: 'az',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	
	function declension(scheme, count) {
	  // scheme for count=1 exists
	  if (scheme.one !== undefined && count === 1) {
	    return scheme.one;
	  }
	
	  var rem10 = count % 10;
	  var rem100 = count % 100; // 1, 21, 31, ...
	
	  if (rem10 === 1 && rem100 !== 11) {
	    return scheme.singularNominative.replace('{{count}}', count); // 2, 3, 4, 22, 23, 24, 32 ...
	  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
	    return scheme.singularGenitive.replace('{{count}}', count); // 5, 6, 7, 8, 9, 10, 11, ...
	  } else {
	    return scheme.pluralGenitive.replace('{{count}}', count);
	  }
	}
	
	function buildLocalizeTokenFn(scheme) {
	  return function (count, options) {
	    if (options.addSuffix) {
	      if (options.comparison > 0) {
	        if (scheme.future) {
	          return declension(scheme.future, count);
	        } else {
	          return 'праз ' + declension(scheme.regular, count);
	        }
	      } else {
	        if (scheme.past) {
	          return declension(scheme.past, count);
	        } else {
	          return declension(scheme.regular, count) + ' таму';
	        }
	      }
	    } else {
	      return declension(scheme.regular, count);
	    }
	  };
	}
	
	var formatDistanceLocale = {
	  lessThanXSeconds: buildLocalizeTokenFn({
	    regular: {
	      one: 'менш за секунду',
	      singularNominative: 'менш за {{count}} секунду',
	      singularGenitive: 'менш за {{count}} секунды',
	      pluralGenitive: 'менш за {{count}} секунд'
	    },
	    future: {
	      one: 'менш, чым праз секунду',
	      singularNominative: 'менш, чым праз {{count}} секунду',
	      singularGenitive: 'менш, чым праз {{count}} секунды',
	      pluralGenitive: 'менш, чым праз {{count}} секунд'
	    }
	  }),
	  xSeconds: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} секунда',
	      singularGenitive: '{{count}} секунды',
	      pluralGenitive: '{{count}} секунд'
	    },
	    past: {
	      singularNominative: '{{count}} секунду таму',
	      singularGenitive: '{{count}} секунды таму',
	      pluralGenitive: '{{count}} секунд таму'
	    },
	    future: {
	      singularNominative: 'праз {{count}} секунду',
	      singularGenitive: 'праз {{count}} секунды',
	      pluralGenitive: 'праз {{count}} секунд'
	    }
	  }),
	  halfAMinute: function (_, options) {
	    if (options.addSuffix) {
	      if (options.comparison > 0) {
	        return 'праз паўхвіліны';
	      } else {
	        return 'паўхвіліны таму';
	      }
	    }
	
	    return 'паўхвіліны';
	  },
	  lessThanXMinutes: buildLocalizeTokenFn({
	    regular: {
	      one: 'менш за хвіліну',
	      singularNominative: 'менш за {{count}} хвіліну',
	      singularGenitive: 'менш за {{count}} хвіліны',
	      pluralGenitive: 'менш за {{count}} хвілін'
	    },
	    future: {
	      one: 'менш, чым праз хвіліну',
	      singularNominative: 'менш, чым праз {{count}} хвіліну',
	      singularGenitive: 'менш, чым праз {{count}} хвіліны',
	      pluralGenitive: 'менш, чым праз {{count}} хвілін'
	    }
	  }),
	  xMinutes: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} хвіліна',
	      singularGenitive: '{{count}} хвіліны',
	      pluralGenitive: '{{count}} хвілін'
	    },
	    past: {
	      singularNominative: '{{count}} хвіліну таму',
	      singularGenitive: '{{count}} хвіліны таму',
	      pluralGenitive: '{{count}} хвілін таму'
	    },
	    future: {
	      singularNominative: 'праз {{count}} хвіліну',
	      singularGenitive: 'праз {{count}} хвіліны',
	      pluralGenitive: 'праз {{count}} хвілін'
	    }
	  }),
	  aboutXHours: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'каля {{count}} гадзіны',
	      singularGenitive: 'каля {{count}} гадзін',
	      pluralGenitive: 'каля {{count}} гадзін'
	    },
	    future: {
	      singularNominative: 'прыблізна праз {{count}} гадзіну',
	      singularGenitive: 'прыблізна праз {{count}} гадзіны',
	      pluralGenitive: 'прыблізна праз {{count}} гадзін'
	    }
	  }),
	  xHours: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} гадзіна',
	      singularGenitive: '{{count}} гадзіны',
	      pluralGenitive: '{{count}} гадзін'
	    },
	    past: {
	      singularNominative: '{{count}} гадзіну таму',
	      singularGenitive: '{{count}} гадзіны таму',
	      pluralGenitive: '{{count}} гадзін таму'
	    },
	    future: {
	      singularNominative: 'праз {{count}} гадзіну',
	      singularGenitive: 'праз {{count}} гадзіны',
	      pluralGenitive: 'праз {{count}} гадзін'
	    }
	  }),
	  xDays: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} дзень',
	      singularGenitive: '{{count}} дні',
	      pluralGenitive: '{{count}} дзён'
	    }
	  }),
	  aboutXWeeks: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'каля {{count}} месяца',
	      // TODO
	      singularGenitive: 'каля {{count}} месяцаў',
	      // TODO
	      pluralGenitive: 'каля {{count}} месяцаў' // TODO
	
	    },
	    future: {
	      singularNominative: 'прыблізна праз {{count}} месяц',
	      // TODO
	      singularGenitive: 'прыблізна праз {{count}} месяцы',
	      // TODO
	      pluralGenitive: 'прыблізна праз {{count}} месяцаў' // TODO
	
	    }
	  }),
	  xWeeks: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} месяц',
	      singularGenitive: '{{count}} месяцы',
	      pluralGenitive: '{{count}} месяцаў'
	    }
	  }),
	  aboutXMonths: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'каля {{count}} месяца',
	      singularGenitive: 'каля {{count}} месяцаў',
	      pluralGenitive: 'каля {{count}} месяцаў'
	    },
	    future: {
	      singularNominative: 'прыблізна праз {{count}} месяц',
	      singularGenitive: 'прыблізна праз {{count}} месяцы',
	      pluralGenitive: 'прыблізна праз {{count}} месяцаў'
	    }
	  }),
	  xMonths: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} месяц',
	      singularGenitive: '{{count}} месяцы',
	      pluralGenitive: '{{count}} месяцаў'
	    }
	  }),
	  aboutXYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'каля {{count}} года',
	      singularGenitive: 'каля {{count}} гадоў',
	      pluralGenitive: 'каля {{count}} гадоў'
	    },
	    future: {
	      singularNominative: 'прыблізна праз {{count}} год',
	      singularGenitive: 'прыблізна праз {{count}} гады',
	      pluralGenitive: 'прыблізна праз {{count}} гадоў'
	    }
	  }),
	  xYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} год',
	      singularGenitive: '{{count}} гады',
	      pluralGenitive: '{{count}} гадоў'
	    }
	  }),
	  overXYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'больш за {{count}} год',
	      singularGenitive: 'больш за {{count}} гады',
	      pluralGenitive: 'больш за {{count}} гадоў'
	    },
	    future: {
	      singularNominative: 'больш, чым праз {{count}} год',
	      singularGenitive: 'больш, чым праз {{count}} гады',
	      pluralGenitive: 'больш, чым праз {{count}} гадоў'
	    }
	  }),
	  almostXYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'амаль {{count}} год',
	      singularGenitive: 'амаль {{count}} гады',
	      pluralGenitive: 'амаль {{count}} гадоў'
	    },
	    future: {
	      singularNominative: 'амаль праз {{count}} год',
	      singularGenitive: 'амаль праз {{count}} гады',
	      pluralGenitive: 'амаль праз {{count}} гадоў'
	    }
	  })
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  return formatDistanceLocale[token](count, options);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, d MMMM y 'г.'",
	  long: "d MMMM y 'г.'",
	  medium: "d MMM y 'г.'",
	  short: 'dd.MM.y'
	};
	var timeFormats = {
	  full: 'H:mm:ss zzzz',
	  long: 'H:mm:ss z',
	  medium: 'H:mm:ss',
	  short: 'H:mm'
	};
	var dateTimeFormats = {
	  any: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'any'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	
	var _index = _interopRequireDefault(__webpack_require__(46));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accusativeWeekdays = ['нядзелю', 'панядзелак', 'аўторак', 'сераду', 'чацвер', 'пятніцу', 'суботу'];
	
	function lastWeek(day) {
	  var weekday = accusativeWeekdays[day];
	
	  switch (day) {
	    case 0:
	    case 3:
	    case 5:
	    case 6:
	      return "'у мінулую " + weekday + " а' p";
	
	    case 1:
	    case 2:
	    case 4:
	      return "'у мінулы " + weekday + " а' p";
	  }
	}
	
	function thisWeek(day) {
	  var weekday = accusativeWeekdays[day];
	  return "'у " + weekday + " а' p";
	}
	
	function nextWeek(day) {
	  var weekday = accusativeWeekdays[day];
	
	  switch (day) {
	    case 0:
	    case 3:
	    case 5:
	    case 6:
	      return "'у наступную " + weekday + " а' p";
	
	    case 1:
	    case 2:
	    case 4:
	      return "'у наступны " + weekday + " а' p";
	  }
	}
	
	var formatRelativeLocale = {
	  lastWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return lastWeek(day);
	    }
	  },
	  yesterday: "'учора а' p",
	  today: "'сёння а' p",
	  tomorrow: "'заўтра а' p",
	  nextWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return nextWeek(day);
	    }
	  },
	  other: 'P'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date, baseDate, options);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['да н.э.', 'н.э.'],
	  abbreviated: ['да н. э.', 'н. э.'],
	  wide: ['да нашай эры', 'нашай эры']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1-ы кв.', '2-і кв.', '3-і кв.', '4-ы кв.'],
	  wide: ['1-ы квартал', '2-і квартал', '3-і квартал', '4-ы квартал']
	};
	var monthValues = {
	  narrow: ['С', 'Л', 'С', 'К', 'М', 'Ч', 'Л', 'Ж', 'В', 'К', 'Л', 'С'],
	  abbreviated: ['студз.', 'лют.', 'сак.', 'крас.', 'май', 'чэрв.', 'ліп.', 'жн.', 'вер.', 'кастр.', 'ліст.', 'снеж.'],
	  wide: ['студзень', 'люты', 'сакавік', 'красавік', 'май', 'чэрвень', 'ліпень', 'жнівень', 'верасень', 'кастрычнік', 'лістапад', 'снежань']
	};
	var formattingMonthValues = {
	  narrow: ['С', 'Л', 'С', 'К', 'М', 'Ч', 'Л', 'Ж', 'В', 'К', 'Л', 'С'],
	  abbreviated: ['студз.', 'лют.', 'сак.', 'крас.', 'мая', 'чэрв.', 'ліп.', 'жн.', 'вер.', 'кастр.', 'ліст.', 'снеж.'],
	  wide: ['студзеня', 'лютага', 'сакавіка', 'красавіка', 'мая', 'чэрвеня', 'ліпеня', 'жніўня', 'верасня', 'кастрычніка', 'лістапада', 'снежня']
	};
	var dayValues = {
	  narrow: ['Н', 'П', 'А', 'С', 'Ч', 'П', 'С'],
	  short: ['нд', 'пн', 'аў', 'ср', 'чц', 'пт', 'сб'],
	  abbreviated: ['нядз', 'пан', 'аўт', 'сер', 'чац', 'пят', 'суб'],
	  wide: ['нядзеля', 'панядзелак', 'аўторак', 'серада', 'чацвер', 'пятніца', 'субота']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'поўн.',
	    noon: 'поўд.',
	    morning: 'ран.',
	    afternoon: 'дзень',
	    evening: 'веч.',
	    night: 'ноч'
	  },
	  abbreviated: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'поўн.',
	    noon: 'поўд.',
	    morning: 'ран.',
	    afternoon: 'дзень',
	    evening: 'веч.',
	    night: 'ноч'
	  },
	  wide: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'поўнач',
	    noon: 'поўдзень',
	    morning: 'раніца',
	    afternoon: 'дзень',
	    evening: 'вечар',
	    night: 'ноч'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'поўн.',
	    noon: 'поўд.',
	    morning: 'ран.',
	    afternoon: 'дня',
	    evening: 'веч.',
	    night: 'ночы'
	  },
	  abbreviated: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'поўн.',
	    noon: 'поўд.',
	    morning: 'ран.',
	    afternoon: 'дня',
	    evening: 'веч.',
	    night: 'ночы'
	  },
	  wide: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'поўнач',
	    noon: 'поўдзень',
	    morning: 'раніцы',
	    afternoon: 'дня',
	    evening: 'вечара',
	    night: 'ночы'
	  }
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	  var number = Number(dirtyNumber);
	  var suffix;
	  /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
	   *  For date-month combinations should be used `d` formatter.
	   *  Correct:   `d MMMM` (4 верасня)
	   *  Incorrect: `do MMMM` (4-га верасня)
	   *
	   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
	   *  So for phrase "5th day of month" (`do дзень месяца`)
	   *  library will produce:            `5-га дзень месяца`
	   *  but correct spelling should be:  `5-ы дзень месяца`
	   *
	   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
	   */
	
	  if (unit === 'date') {
	    suffix = '-га';
	  } else if (unit === 'hour' || unit === 'minute' || unit === 'second') {
	    suffix = '-я';
	  } else {
	    suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? '-і' : '-ы';
	  }
	
	  return number + suffix;
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'any',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^((да )?н\.?\s?э\.?)/i,
	  abbreviated: /^((да )?н\.?\s?э\.?)/i,
	  wide: /^(да нашай эры|нашай эры|наша эра)/i
	};
	var parseEraPatterns = {
	  any: [/^д/i, /^н/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
	  wide: /^[1234](-?[ыі]?)? квартал/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[слкмчжв]/i,
	  abbreviated: /^(студз|лют|сак|крас|ма[йя]|чэрв|ліп|жн|вер|кастр|ліст|снеж)\.?/i,
	  wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|ма[йя]|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|снеж(ань|ня))/i
	};
	var parseMonthPatterns = {
	  narrow: [/^с/i, /^л/i, /^с/i, /^к/i, /^м/i, /^ч/i, /^л/i, /^ж/i, /^в/i, /^к/i, /^л/i, /^с/i],
	  any: [/^ст/i, /^лю/i, /^са/i, /^кр/i, /^ма/i, /^ч/i, /^ліп/i, /^ж/i, /^в/i, /^ка/i, /^ліс/i, /^сн/i]
	};
	var matchDayPatterns = {
	  narrow: /^[нпасч]/i,
	  short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
	  abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцв|чац|птн|пят|суб).?/i,
	  wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацв(ер|ярга)|пятніц[аы]|субот[аы])/i
	};
	var parseDayPatterns = {
	  narrow: [/^н/i, /^п/i, /^а/i, /^с/i, /^ч/i, /^п/i, /^с/i],
	  any: [/^н/i, /^п[ан]/i, /^а/i, /^с[ер]/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
	  abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
	  wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^дп/i,
	    pm: /^пп/i,
	    midnight: /^поўн/i,
	    noon: /^поўд/i,
	    morning: /^р/i,
	    afternoon: /^д[зн]/i,
	    evening: /^в/i,
	    night: /^н/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1001));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1002));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1003));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1004));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1005));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Belarusian locale.
	 * @language Belarusian
	 * @iso-639-2 bel
	 * @author Kiryl Anokhin [@alyrik]{@link https://github.com/alyrik}
	 * @author Martin Wind [@arvigeus]{@link https://github.com/mawi12345}
	 */
	var locale = {
	  code: 'be',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'по-малко от секунда',
	    other: 'по-малко от {{count}} секунди'
	  },
	  xSeconds: {
	    one: '1 секунда',
	    other: '{{count}} секунди'
	  },
	  halfAMinute: 'половин минута',
	  lessThanXMinutes: {
	    one: 'по-малко от минута',
	    other: 'по-малко от {{count}} минути'
	  },
	  xMinutes: {
	    one: '1 минута',
	    other: '{{count}} минути'
	  },
	  aboutXHours: {
	    one: 'около час',
	    other: 'около {{count}} часа'
	  },
	  xHours: {
	    one: '1 час',
	    other: '{{count}} часа'
	  },
	  xDays: {
	    one: '1 ден',
	    other: '{{count}} дни'
	  },
	  aboutXWeeks: {
	    one: 'около седмица',
	    other: 'около {{count}} седмици'
	  },
	  xWeeks: {
	    one: '1 седмица',
	    other: '{{count}} седмици'
	  },
	  aboutXMonths: {
	    one: 'около месец',
	    other: 'около {{count}} месеца'
	  },
	  xMonths: {
	    one: '1 месец',
	    other: '{{count}} месеца'
	  },
	  aboutXYears: {
	    one: 'около година',
	    other: 'около {{count}} години'
	  },
	  xYears: {
	    one: '1 година',
	    other: '{{count}} години'
	  },
	  overXYears: {
	    one: 'над година',
	    other: 'над {{count}} години'
	  },
	  almostXYears: {
	    one: 'почти година',
	    other: 'почти {{count}} години'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'след ' + result;
	    } else {
	      return 'преди ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, dd MMMM yyyy',
	  long: 'dd MMMM yyyy',
	  medium: 'dd MMM yyyy',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'H:mm'
	};
	var dateTimeFormats = {
	  any: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'any'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	
	var _index = _interopRequireDefault(__webpack_require__(46));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Adapted from the `ru` translation
	var weekdays = ['неделя', 'понеделник', 'вторник', 'сряда', 'четвъртък', 'петък', 'събота'];
	
	function lastWeek(day) {
	  var weekday = weekdays[day];
	
	  switch (day) {
	    case 0:
	    case 3:
	    case 6:
	      return "'миналата " + weekday + " в' p";
	
	    case 1:
	    case 2:
	    case 4:
	    case 5:
	      return "'миналия " + weekday + " в' p";
	  }
	}
	
	function thisWeek(day) {
	  var weekday = weekdays[day];
	
	  if (day === 2
	  /* Tue */
	  ) {
	      return "'във " + weekday + " в' p";
	    } else {
	    return "'в " + weekday + " в' p";
	  }
	}
	
	function nextWeek(day) {
	  var weekday = weekdays[day];
	
	  switch (day) {
	    case 0:
	    case 3:
	    case 6:
	      return "'следващата " + weekday + " в' p";
	
	    case 1:
	    case 2:
	    case 4:
	    case 5:
	      return "'следващия " + weekday + " в' p";
	  }
	}
	
	var formatRelativeLocale = {
	  lastWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return lastWeek(day);
	    }
	  },
	  yesterday: "'вчера в' p",
	  today: "'днес в' p",
	  tomorrow: "'утре в' p",
	  nextWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return nextWeek(day);
	    }
	  },
	  other: 'P'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date, baseDate, options);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['пр.н.е.', 'н.е.'],
	  abbreviated: ['преди н. е.', 'н. е.'],
	  wide: ['преди новата ера', 'новата ера']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1-во тримес.', '2-ро тримес.', '3-то тримес.', '4-то тримес.'],
	  wide: ['1-во тримесечие', '2-ро тримесечие', '3-то тримесечие', '4-то тримесечие']
	};
	var monthValues = {
	  abbreviated: ['яну', 'фев', 'мар', 'апр', 'май', 'юни', 'юли', 'авг', 'сеп', 'окт', 'ное', 'дек'],
	  wide: ['януари', 'февруари', 'март', 'април', 'май', 'юни', 'юли', 'август', 'септември', 'октомври', 'ноември', 'декември']
	};
	var dayValues = {
	  narrow: ['Н', 'П', 'В', 'С', 'Ч', 'П', 'С'],
	  short: ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
	  abbreviated: ['нед', 'пон', 'вто', 'сря', 'чет', 'пет', 'съб'],
	  wide: ['неделя', 'понеделник', 'вторник', 'сряда', 'четвъртък', 'петък', 'събота']
	};
	var dayPeriodValues = {
	  wide: {
	    am: 'преди обяд',
	    pm: 'след обяд',
	    midnight: 'в полунощ',
	    noon: 'на обяд',
	    morning: 'сутринта',
	    afternoon: 'следобед',
	    evening: 'вечерта',
	    night: 'през нощта'
	  }
	};
	
	function isFeminine(unit) {
	  return unit === 'year' || unit === 'week' || unit === 'minute' || unit === 'second';
	}
	
	function isNeuter(unit) {
	  return unit === 'quarter';
	}
	
	function numberWithSuffix(number, unit, masculine, feminine, neuter) {
	  var suffix = isNeuter(unit) ? neuter : isFeminine(unit) ? feminine : masculine;
	  return number + '-' + suffix;
	}
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	  var number = Number(dirtyNumber);
	
	  if (number === 0) {
	    return numberWithSuffix(0, unit, 'ев', 'ева', 'ево');
	  } else if (number % 1000 === 0) {
	    return numberWithSuffix(number, unit, 'ен', 'на', 'но');
	  } else if (number % 100 === 0) {
	    return numberWithSuffix(number, unit, 'тен', 'тна', 'тно');
	  }
	
	  var rem100 = number % 100;
	
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return numberWithSuffix(number, unit, 'ви', 'ва', 'во');
	
	      case 2:
	        return numberWithSuffix(number, unit, 'ри', 'ра', 'ро');
	
	      case 7:
	      case 8:
	        return numberWithSuffix(number, unit, 'ми', 'ма', 'мо');
	    }
	  }
	
	  return numberWithSuffix(number, unit, 'ти', 'та', 'то');
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(8));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^((пр)?н\.?\s?е\.?)/i,
	  abbreviated: /^((пр)?н\.?\s?е\.?)/i,
	  wide: /^(преди новата ера|новата ера|нова ера)/i
	};
	var parseEraPatterns = {
	  any: [/^п/i, /^н/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
	  wide: /^[1234](-?[врт]?о?)? тримесечие/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchDayPatterns = {
	  narrow: /^[нпвсч]/i,
	  short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
	  abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
	  wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
	};
	var parseDayPatterns = {
	  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
	  any: [/^н[ед]/i, /^п[он]/i, /^вт/i, /^ср/i, /^ч[ет]/i, /^п[ет]/i, /^с[ъб]/i]
	};
	var matchMonthPatterns = {
	  abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
	  wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
	};
	var parseMonthPatterns = {
	  any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^май/i, /^юн/i, /^юл/i, /^ав/i, /^се/i, /^окт/i, /^но/i, /^де/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^преди о/i,
	    pm: /^след о/i,
	    midnight: /^в пол/i,
	    noon: /^на об/i,
	    morning: /^сут/i,
	    afternoon: /^следо/i,
	    evening: /^веч/i,
	    night: /^през н/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1007));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1008));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1009));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1010));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1011));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Bulgarian locale.
	 * @language Bulgarian
	 * @iso-639-2 bul
	 * @author Nikolay Stoynov [@arvigeus]{@link https://github.com/arvigeus}
	 * @author Tsvetan Ovedenski [@fintara]{@link https://github.com/fintara}
	 */
	var locale = {
	  code: 'bg',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	
	var _index = _interopRequireDefault(__webpack_require__(323));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'প্রায় ১ সেকেন্ড',
	    other: 'প্রায় {{count}} সেকেন্ড'
	  },
	  xSeconds: {
	    one: '১ সেকেন্ড',
	    other: '{{count}} সেকেন্ড'
	  },
	  halfAMinute: 'আধ মিনিট',
	  lessThanXMinutes: {
	    one: 'প্রায় ১ মিনিট',
	    other: 'প্রায় {{count}} মিনিট'
	  },
	  xMinutes: {
	    one: '১ মিনিট',
	    other: '{{count}} মিনিট'
	  },
	  aboutXHours: {
	    one: 'প্রায় ১ ঘন্টা',
	    other: 'প্রায় {{count}} ঘন্টা'
	  },
	  xHours: {
	    one: '১ ঘন্টা',
	    other: '{{count}} ঘন্টা'
	  },
	  xDays: {
	    one: '১ দিন',
	    other: '{{count}} দিন'
	  },
	  aboutXWeeks: {
	    one: 'প্রায় ১ সপ্তাহ',
	    other: 'প্রায় {{count}} সপ্তাহ'
	  },
	  xWeeks: {
	    one: '১ সপ্তাহ',
	    other: '{{count}} সপ্তাহ'
	  },
	  aboutXMonths: {
	    one: 'প্রায় ১ মাস',
	    other: 'প্রায় {{count}} মাস'
	  },
	  xMonths: {
	    one: '১ মাস',
	    other: '{{count}} মাস'
	  },
	  aboutXYears: {
	    one: 'প্রায় ১ বছর',
	    other: 'প্রায় {{count}} বছর'
	  },
	  xYears: {
	    one: '১ বছর',
	    other: '{{count}} বছর'
	  },
	  overXYears: {
	    one: '১ বছরের বেশি',
	    other: '{{count}} বছরের বেশি'
	  },
	  almostXYears: {
	    one: 'প্রায় ১ বছর',
	    other: 'প্রায় {{count}} বছর'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', _index.default.numberToLocale(count));
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result + ' এর মধ্যে';
	    } else {
	      return result + ' আগে';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, MMMM do, y',
	  long: 'MMMM do, y',
	  medium: 'MMM d, y',
	  short: 'MM/dd/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} {{time}} 'সময়'",
	  long: "{{date}} {{time}} 'সময়'",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'গত' eeee 'সময়' p",
	  yesterday: "'গতকাল' 'সময়' p",
	  today: "'আজ' 'সময়' p",
	  tomorrow: "'আগামীকাল' 'সময়' p",
	  nextWeek: "eeee 'সময়' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(ম|য়|র্থ|ষ্ঠ|শে|ই|তম)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(খ্রিঃপূঃ|খ্রিঃ)/i,
	  abbreviated: /^(খ্রিঃপূর্ব|খ্রিঃ)/i,
	  wide: /^(খ্রিস্টপূর্ব|খ্রিস্টাব্দ)/i
	};
	var parseEraPatterns = {
	  narrow: [/^খ্রিঃপূঃ/i, /^খ্রিঃ/i],
	  abbreviated: [/^খ্রিঃপূর্ব/i, /^খ্রিঃ/i],
	  wide: [/^খ্রিস্টপূর্ব/i, /^খ্রিস্টাব্দ/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[১২৩৪]/i,
	  abbreviated: /^[১২৩৪]ত্রৈ/i,
	  wide: /^[১২৩৪](ম|য়|র্থ)? ত্রৈমাসিক/i
	};
	var parseQuarterPatterns = {
	  any: [/১/i, /২/i, /৩/i, /৪/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
	  abbreviated: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
	  wide: /^(জানুয়ারি|ফেব্রুয়ারি|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর)/i
	};
	var parseMonthPatterns = {
	  any: [/^জানু/i, /^ফেব্রু/i, /^মার্চ/i, /^এপ্রিল/i, /^মে/i, /^জুন/i, /^জুলাই/i, /^আগস্ট/i, /^সেপ্ট/i, /^অক্টো/i, /^নভে/i, /^ডিসে/i]
	};
	var matchDayPatterns = {
	  narrow: /^(র|সো|ম|বু|বৃ|শু|শ)+/i,
	  short: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
	  abbreviated: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
	  wide: /^(রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার |শুক্রবার|শনিবার)+/i
	};
	var parseDayPatterns = {
	  narrow: [/^র/i, /^সো/i, /^ম/i, /^বু/i, /^বৃ/i, /^শু/i, /^শ/i],
	  short: [/^রবি/i, /^সোম/i, /^মঙ্গল/i, /^বুধ/i, /^বৃহ/i, /^শুক্র/i, /^শনি/i],
	  abbreviated: [/^রবি/i, /^সোম/i, /^মঙ্গল/i, /^বুধ/i, /^বৃহ/i, /^শুক্র/i, /^শনি/i],
	  wide: [/^রবিবার/i, /^সোমবার/i, /^মঙ্গলবার/i, /^বুধবার/i, /^বৃহস্পতিবার /i, /^শুক্রবার/i, /^শনিবার/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(পূ|অপ|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
	  abbreviated: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
	  wide: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^পূ/i,
	    pm: /^অপ/i,
	    midnight: /^মধ্যরাত/i,
	    noon: /^মধ্যাহ্ন/i,
	    morning: /সকাল/i,
	    afternoon: /বিকাল/i,
	    evening: /সন্ধ্যা/i,
	    night: /রাত/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1013));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1014));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1015));
	
	var _index4 = _interopRequireDefault(__webpack_require__(323));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1016));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Bengali locale.
	 * @language Bengali
	 * @iso-639-2 ben
	 * @author Touhidur Rahman [@touhidrahman]{@link https://github.com/touhidrahman}
	 * @author Farhad Yasir [@nutboltu]{@link https://github.com/nutboltu}
	 */
	var locale = {
	  code: 'bn',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: {
	      standalone: 'manje od 1 sekunde',
	      withPrepositionAgo: 'manje od 1 sekunde',
	      withPrepositionIn: 'manje od 1 sekundu'
	    },
	    dual: 'manje od {{count}} sekunde',
	    other: 'manje od {{count}} sekundi'
	  },
	  xSeconds: {
	    one: {
	      standalone: '1 sekunda',
	      withPrepositionAgo: '1 sekunde',
	      withPrepositionIn: '1 sekundu'
	    },
	    dual: '{{count}} sekunde',
	    other: '{{count}} sekundi'
	  },
	  halfAMinute: 'pola minute',
	  lessThanXMinutes: {
	    one: {
	      standalone: 'manje od 1 minute',
	      withPrepositionAgo: 'manje od 1 minute',
	      withPrepositionIn: 'manje od 1 minutu'
	    },
	    dual: 'manje od {{count}} minute',
	    other: 'manje od {{count}} minuta'
	  },
	  xMinutes: {
	    one: {
	      standalone: '1 minuta',
	      withPrepositionAgo: '1 minute',
	      withPrepositionIn: '1 minutu'
	    },
	    dual: '{{count}} minute',
	    other: '{{count}} minuta'
	  },
	  aboutXHours: {
	    one: {
	      standalone: 'oko 1 sat',
	      withPrepositionAgo: 'oko 1 sat',
	      withPrepositionIn: 'oko 1 sat'
	    },
	    dual: 'oko {{count}} sata',
	    other: 'oko {{count}} sati'
	  },
	  xHours: {
	    one: {
	      standalone: '1 sat',
	      withPrepositionAgo: '1 sat',
	      withPrepositionIn: '1 sat'
	    },
	    dual: '{{count}} sata',
	    other: '{{count}} sati'
	  },
	  xDays: {
	    one: {
	      standalone: '1 dan',
	      withPrepositionAgo: '1 dan',
	      withPrepositionIn: '1 dan'
	    },
	    dual: '{{count}} dana',
	    other: '{{count}} dana'
	  },
	  aboutXWeeks: {
	    one: {
	      standalone: 'oko 1 sedmicu',
	      withPrepositionAgo: 'oko 1 sedmicu',
	      withPrepositionIn: 'oko 1 sedmicu'
	    },
	    dual: 'oko {{count}} sedmice',
	    other: 'oko {{count}} sedmice'
	  },
	  xWeeks: {
	    one: {
	      standalone: '1 sedmicu',
	      withPrepositionAgo: '1 sedmicu',
	      withPrepositionIn: '1 sedmicu'
	    },
	    dual: '{{count}} sedmice',
	    other: '{{count}} sedmice'
	  },
	  aboutXMonths: {
	    one: {
	      standalone: 'oko 1 mjesec',
	      withPrepositionAgo: 'oko 1 mjesec',
	      withPrepositionIn: 'oko 1 mjesec'
	    },
	    dual: 'oko {{count}} mjeseca',
	    other: 'oko {{count}} mjeseci'
	  },
	  xMonths: {
	    one: {
	      standalone: '1 mjesec',
	      withPrepositionAgo: '1 mjesec',
	      withPrepositionIn: '1 mjesec'
	    },
	    dual: '{{count}} mjeseca',
	    other: '{{count}} mjeseci'
	  },
	  aboutXYears: {
	    one: {
	      standalone: 'oko 1 godinu',
	      withPrepositionAgo: 'oko 1 godinu',
	      withPrepositionIn: 'oko 1 godinu'
	    },
	    dual: 'oko {{count}} godine',
	    other: 'oko {{count}} godina'
	  },
	  xYears: {
	    one: {
	      standalone: '1 godina',
	      withPrepositionAgo: '1 godine',
	      withPrepositionIn: '1 godinu'
	    },
	    dual: '{{count}} godine',
	    other: '{{count}} godina'
	  },
	  overXYears: {
	    one: {
	      standalone: 'preko 1 godinu',
	      withPrepositionAgo: 'preko 1 godinu',
	      withPrepositionIn: 'preko 1 godinu'
	    },
	    dual: 'preko {{count}} godine',
	    other: 'preko {{count}} godina'
	  },
	  almostXYears: {
	    one: {
	      standalone: 'gotovo 1 godinu',
	      withPrepositionAgo: 'gotovo 1 godinu',
	      withPrepositionIn: 'gotovo 1 godinu'
	    },
	    dual: 'gotovo {{count}} godine',
	    other: 'gotovo {{count}} godina'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    if (options.addSuffix) {
	      if (options.comparison > 0) {
	        result = formatDistanceLocale[token].one.withPrepositionIn;
	      } else {
	        result = formatDistanceLocale[token].one.withPrepositionAgo;
	      }
	    } else {
	      result = formatDistanceLocale[token].one.standalone;
	    }
	  } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
	  String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
	  ) {
	      result = formatDistanceLocale[token].dual.replace('{{count}}', count);
	    } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'za ' + result;
	    } else {
	      return 'prije ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d. MMMM yyyy.',
	  long: 'd. MMMM yyyy.',
	  medium: 'd. MMM yy.',
	  short: 'dd. MM. yy.'
	};
	var timeFormats = {
	  full: 'HH:mm:ss (zzzz)',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'u' {{time}}",
	  long: "{{date}} 'u' {{time}}",
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: function (date) {
	    var day = date.getUTCDay();
	
	    switch (day) {
	      case 0:
	        return "'prošle nedjelje u' p";
	
	      case 3:
	        return "'prošle srijede u' p";
	
	      case 6:
	        return "'prošle subote u' p";
	
	      default:
	        return "'prošli' EEEE 'u' p";
	    }
	  },
	  yesterday: "'juče u' p",
	  today: "'danas u' p",
	  tomorrow: "'sutra u' p",
	  nextWeek: function (date) {
	    var day = date.getUTCDay();
	
	    switch (day) {
	      case 0:
	        return "'sljedeće nedjelje u' p";
	
	      case 3:
	        return "'sljedeću srijedu u' p";
	
	      case 6:
	        return "'sljedeću subotu u' p";
	
	      default:
	        return "'sljedeći' EEEE 'u' p";
	    }
	  },
	  other: 'P'
	};
	
	function formatRelative(token, date, _baseDate, _options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return String(number).concat('.');
	}
	
	var eraValues = {
	  narrow: ['pr.n.e.', 'AD'],
	  abbreviated: ['pr. Hr.', 'po. Hr.'],
	  wide: ['Prije Hrista', 'Poslije Hrista']
	};
	var monthValues = {
	  narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
	  abbreviated: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'avg', 'sep', 'okt', 'nov', 'dec'],
	  wide: ['januar', 'februar', 'mart', 'april', 'maj', 'juni', 'juli', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar']
	};
	var formattingMonthValues = {
	  narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
	  abbreviated: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'avg', 'sep', 'okt', 'nov', 'dec'],
	  wide: ['januar', 'februar', 'mart', 'april', 'maj', 'juni', 'juli', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar']
	};
	var quarterValues = {
	  narrow: ['1.', '2.', '3.', '4.'],
	  abbreviated: ['1. kv.', '2. kv.', '3. kv.', '4. kv.'],
	  wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
	};
	var dayValues = {
	  narrow: ['N', 'P', 'U', 'S', 'Č', 'P', 'S'],
	  short: ['ned', 'pon', 'uto', 'sre', 'čet', 'pet', 'sub'],
	  abbreviated: ['ned', 'pon', 'uto', 'sre', 'čet', 'pet', 'sub'],
	  wide: ['nedjelja', 'ponedjeljak', 'utorak', 'srijeda', 'četvrtak', 'petak', 'subota']
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutru',
	    afternoon: 'popodne',
	    evening: 'uveče',
	    night: 'noću'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutru',
	    afternoon: 'popodne',
	    evening: 'uveče',
	    night: 'noću'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutru',
	    afternoon: 'poslije podne',
	    evening: 'uveče',
	    night: 'noću'
	  }
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutru',
	    afternoon: 'popodne',
	    evening: 'uveče',
	    night: 'noću'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutru',
	    afternoon: 'popodne',
	    evening: 'uveče',
	    night: 'noću'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutru',
	    afternoon: 'poslije podne',
	    evening: 'uveče',
	    night: 'noću'
	  }
	};
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(8));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)\./i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(pr\.n\.e\.|AD)/i,
	  abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
	  wide: /^(Prije Hrista|prije nove ere|Poslije Hrista|nova era)/i
	};
	var parseEraPatterns = {
	  any: [/^pr/i, /^(po|nova)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234]\.\s?kv\.?/i,
	  wide: /^[1234]\. kvartal/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(10|11|12|[123456789])\./i,
	  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
	  wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(juni|juna)|(juli|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
	};
	var parseMonthPatterns = {
	  narrow: [/(10|11|12|[123456789])/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^avg/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[npusčc]/i,
	  short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
	  abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
	  wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
	  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|poslije podne|ujutru)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^pono/i,
	    noon: /^pod/i,
	    morning: /jutro/i,
	    afternoon: /(poslije\s|po)+podne/i,
	    evening: /(uvece|uveče)/i,
	    night: /(nocu|noću)/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1018));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1019));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1020));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1021));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1022));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Bosnian locale.
	 * @language Bosnian
	 * @iso-639-2 bos
	 * @author Branislav Lazić [@branislavlazic]{@link https://github.com/branislavlazic}
	 */
	var locale = {
	  code: 'bs',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	
	/**
	 * Davant de les xifres que es diuen amb vocal inicial, 1 i 11, s'apostrofen els articles el i la i la preposició de igual que si estiguessin escrits amb lletres.
	 *    l'1 de juliol ('l'u')
	 *    l'11 de novembre ('l'onze')
	 *    l'11a clàusula del contracte ('l'onzena')
	 *    la contractació d'11 jugadors ('d'onze')
	 *    l'aval d'11.000 socis ('d'onze mil')
	 *
	 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=apostrofaci%25F3+davant+xifres&action=Principal&method=detall_completa&numPagina=1&idHit=11236&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=11236&titol=apostrofaci%F3%20davant%20de%20xifres%20%2F%20apostrofaci%F3%20davant%20de%201%20i%2011&numeroResultat=1&clickLink=detall&tipusCerca=cerca.normes
	 */
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: "menys d'un segon",
	    eleven: "menys d'onze segons",
	    other: 'menys de {{count}} segons'
	  },
	  xSeconds: {
	    one: '1 segon',
	    other: '{{count}} segons'
	  },
	  halfAMinute: 'mig minut',
	  lessThanXMinutes: {
	    one: "menys d'un minut",
	    eleven: "menys d'onze minuts",
	    other: 'menys de {{count}} minuts'
	  },
	  xMinutes: {
	    one: '1 minut',
	    other: '{{count}} minuts'
	  },
	  aboutXHours: {
	    one: 'aproximadament una hora',
	    other: 'aproximadament {{count}} hores'
	  },
	  xHours: {
	    one: '1 hora',
	    other: '{{count}} hores'
	  },
	  xDays: {
	    one: '1 dia',
	    other: '{{count}} dies'
	  },
	  aboutXWeeks: {
	    one: 'aproximadament una setmana',
	    other: 'aproximadament {{count}} setmanes'
	  },
	  xWeeks: {
	    one: '1 setmana',
	    other: '{{count}} setmanes'
	  },
	  aboutXMonths: {
	    one: 'aproximadament un mes',
	    other: 'aproximadament {{count}} mesos'
	  },
	  xMonths: {
	    one: '1 mes',
	    other: '{{count}} mesos'
	  },
	  aboutXYears: {
	    one: 'aproximadament un any',
	    other: 'aproximadament {{count}} anys'
	  },
	  xYears: {
	    one: '1 any',
	    other: '{{count}} anys'
	  },
	  overXYears: {
	    one: "més d'un any",
	    eleven: "més d'onze anys",
	    other: 'més de {{count}} anys'
	  },
	  almostXYears: {
	    one: 'gairebé un any',
	    other: 'gairebé {{count}} anys'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else if (count === 11 && formatDistanceLocale[token].eleven) {
	    result = formatDistanceLocale[token].eleven;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'en ' + result;
	    } else {
	      return 'fa ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, d 'de' MMMM y",
	  long: "d 'de' MMMM y",
	  medium: 'd MMM y',
	  short: 'dd/MM/y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'a les' {{time}}",
	  long: "{{date}} 'a les' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'el' eeee 'passat a la' LT",
	  yesterday: "'ahir a la' p",
	  today: "'avui a la' p",
	  tomorrow: "'demà a la' p",
	  nextWeek: "eeee 'a la' p",
	  other: 'P'
	};
	var formatRelativeLocalePlural = {
	  lastWeek: "'el' eeee 'passat a les' p",
	  yesterday: "'ahir a les' p",
	  today: "'avui a les' p",
	  tomorrow: "'demà a les' p",
	  nextWeek: "eeee 'a les' p",
	  other: 'P'
	};
	
	function formatRelative(token, date, _baseDate, _options) {
	  if (date.getUTCHours() !== 1) {
	    return formatRelativeLocalePlural[token];
	  }
	
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * General information
	 * Reference: https://aplicacions.llengua.gencat.cat
	 * Reference: https://www.uoc.edu/portal/ca/servei-linguistic/convencions/abreviacions/simbols/simbols-habituals.html
	 */
	
	/**
	 * Abans de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abans+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6876&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6876&titol=abans%20de%20Crist%20(abreviatura)%20/%20abans%20de%20Crist%20(sigla)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
	 * Desprest de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=despr%E9s+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6879&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6879&titol=despr%E9s%20de%20Crist%20(sigla)%20/%20despr%E9s%20de%20Crist%20(abreviatura)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
	 */
	var eraValues = {
	  narrow: ['aC', 'dC'],
	  abbreviated: ['a. de C.', 'd. de C.'],
	  wide: ['abans de Crist', 'després de Crist']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['T1', 'T2', 'T3', 'T4'],
	  wide: ['1r trimestre', '2n trimestre', '3r trimestre', '4t trimestre']
	};
	/**
	 * Dins d'un text convé fer servir la forma sencera dels mesos, ja que sempre és més clar el mot sencer que l'abreviatura, encara que aquesta sigui força coneguda.
	 * Cal reservar, doncs, les abreviatures per a les llistes o classificacions, els gràfics, les taules o quadres estadístics, els textos publicitaris, etc.
	 *
	 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviacions+mesos&action=Principal&method=detall_completa&numPagina=1&idHit=8402&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8402&titol=abreviatures%20dels%20mesos%20de%20l%27any&numeroResultat=5&clickLink=detall&tipusCerca=cerca.fitxes
	 */
	
	var monthValues = {
	  narrow: ['GN', 'FB', 'MÇ', 'AB', 'MG', 'JN', 'JL', 'AG', 'ST', 'OC', 'NV', 'DS'],
	
	  /**
	   * Les abreviatures dels mesos de l'any es formen seguint una de les normes generals de formació d'abreviatures.
	   * S'escriu la primera síl·laba i les consonants de la síl·laba següent anteriors a la primera vocal.
	   * Els mesos de març, maig i juny no s'abreugen perquè són paraules d'una sola síl·laba.
	   */
	  abbreviated: ['gen.', 'febr.', 'març', 'abr.', 'maig', 'juny', 'jul.', 'ag.', 'set.', 'oct.', 'nov.', 'des.'],
	  wide: ['gener', 'febrer', 'març', 'abril', 'maig', 'juny', 'juliol', 'agost', 'setembre', 'octubre', 'novembre', 'desembre']
	};
	/**
	 * Les abreviatures dels dies de la setmana comencen totes amb la lletra d.
	 * Tot seguit porten la consonant següent a la i, excepte en el cas de dimarts, dimecres i diumenge, en què aquesta consonant és la m i, per tant, hi podria haver confusió.
	 * Per evitar-ho, s'ha substituït la m per una t (en el cas de dimarts), una c (en el cas de dimecres) i una g (en el cas de diumenge), respectivament.
	 *
	 * Seguint la norma general d'ús de les abreviatures, les dels dies de la setmana sempre porten punt final.
	 * Igualment, van amb la primera lletra en majúscula quan la paraula sencera també hi aniria.
	 * En canvi, van amb la primera lletra en minúscula quan la inicial de la paraula sencera també hi aniria.
	 *
	 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviatures+dies&action=Principal&method=detall_completa&numPagina=1&idHit=8387&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8387&titol=abreviatures%20dels%20dies%20de%20la%20setmana&numeroResultat=1&clickLink=detall&tipusCerca=cerca.tot
	 */
	
	var dayValues = {
	  narrow: ['dg.', 'dl.', 'dt.', 'dm.', 'dj.', 'dv.', 'ds.'],
	  short: ['dg.', 'dl.', 'dt.', 'dm.', 'dj.', 'dv.', 'ds.'],
	  abbreviated: ['dg.', 'dl.', 'dt.', 'dm.', 'dj.', 'dv.', 'ds.'],
	  wide: ['diumenge', 'dilluns', 'dimarts', 'dimecres', 'dijous', 'divendres', 'dissabte']
	};
	/**
	 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?action=Principal&method=detall&input_cercar=parts+del+dia&numPagina=1&database=FITXES_PUB&idFont=12801&idHit=12801&tipusFont=Fitxes+de+l%27Optimot&numeroResultat=1&databases_avansada=&categories_avansada=&clickLink=detall&titol=Nom+de+les+parts+del+dia&tematica=&tipusCerca=cerca.fitxes
	 */
	
	var dayPeriodValues = {
	  narrow: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'mitjanit',
	    noon: 'migdia',
	    morning: 'matí',
	    afternoon: 'tarda',
	    evening: 'vespre',
	    night: 'nit'
	  },
	  abbreviated: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'mitjanit',
	    noon: 'migdia',
	    morning: 'matí',
	    afternoon: 'tarda',
	    evening: 'vespre',
	    night: 'nit'
	  },
	  wide: {
	    am: 'ante meridiem',
	    pm: 'post meridiem',
	    midnight: 'mitjanit',
	    noon: 'migdia',
	    morning: 'matí',
	    afternoon: 'tarda',
	    evening: 'vespre',
	    night: 'nit'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'de la mitjanit',
	    noon: 'del migdia',
	    morning: 'del matí',
	    afternoon: 'de la tarda',
	    evening: 'del vespre',
	    night: 'de la nit'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'de la mitjanit',
	    noon: 'del migdia',
	    morning: 'del matí',
	    afternoon: 'de la tarda',
	    evening: 'del vespre',
	    night: 'de la nit'
	  },
	  wide: {
	    am: 'ante meridiem',
	    pm: 'post meridiem',
	    midnight: 'de la mitjanit',
	    noon: 'del migdia',
	    morning: 'del matí',
	    afternoon: 'de la tarda',
	    evening: 'del vespre',
	    night: 'de la nit'
	  }
	};
	/**
	 * Quan van en singular, els nombres ordinals es representen, en forma d’abreviatura, amb la xifra seguida de l’última lletra del mot desplegat.
	 * És optatiu posar punt després de la lletra.
	 *
	 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/pdf/abrevia.pdf#page=18
	 *
	 * @param {Number} dirtyNumber
	 * @param {Object} [_dirtyOptions]
	 */
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber);
	  var rem100 = number % 100;
	
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + 'r';
	
	      case 2:
	        return number + 'n';
	
	      case 3:
	        return number + 'r';
	
	      case 4:
	        return number + 't';
	    }
	  }
	
	  return number + 'è';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(8));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(è|r|n|r|t)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(aC|dC)/i,
	  abbreviated: /^(a. de C.|d. de C.)/i,
	  wide: /^(abans de Crist|despr[eé]s de Crist)/i
	};
	var parseEraPatterns = {
	  narrow: [/^aC/i, /^dC/i],
	  abbreviated: [/^(a. de C.)/i, /^(d. de C.)/i],
	  wide: [/^(abans de Crist)/i, /^(despr[eé]s de Crist)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^T[1234]/i,
	  wide: /^[1234](è|r|n|r|t)? trimestre/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS)/i,
	  abbreviated: /^(gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.)/i,
	  wide: /^(gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^GN/i, /^FB/i, /^MÇ/i, /^AB/i, /^MG/i, /^JN/i, /^JL/i, /^AG/i, /^ST/i, /^OC/i, /^NV/i, /^DS/i],
	  abbreviated: [/^gen./i, /^febr./i, /^març/i, /^abr./i, /^maig/i, /^juny/i, /^jul./i, /^ag./i, /^set./i, /^oct./i, /^nov./i, /^des./i],
	  wide: [/^gener/i, /^febrer/i, /^març/i, /^abril/i, /^maig/i, /^juny/i, /^juliol/i, /^agost/i, /^setembre/i, /^octubre/i, /^novembre/i, /^desembre/i]
	};
	var matchDayPatterns = {
	  narrow: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
	  short: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
	  abbreviated: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
	  wide: /^(diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte)/i
	};
	var parseDayPatterns = {
	  narrow: [/^dg./i, /^dl./i, /^dt./i, /^dm./i, /^dj./i, /^dv./i, /^ds./i],
	  abbreviated: [/^dg./i, /^dl./i, /^dt./i, /^dm./i, /^dj./i, /^dv./i, /^ds./i],
	  wide: [/^diumenge/i, /^dilluns/i, /^dimarts/i, /^dimecres/i, /^dijous/i, /^divendres/i, /^disssabte/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mn|md|(del|de la) (matí|tarda|vespre|nit))/i,
	  abbreviated: /^([ap]\.?\s?m\.?|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i,
	  wide: /^(ante meridiem|post meridiem|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mitjanit/i,
	    noon: /^migdia/i,
	    morning: /matí/i,
	    afternoon: /tarda/i,
	    evening: /vespre/i,
	    night: /nit/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1024));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1025));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1026));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1027));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1028));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Catalan locale.
	 * @language Catalan
	 * @iso-639-2 cat
	 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
	 * @author Alex Vizcaino [@avizcaino]{@link https://github.com/avizcaino}
	 */
	var locale = {
	  code: 'ca',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale; // throw new Error('ca locale is currently unavailable. Please check the progress of converting this locale to v2.0.0 in this issue on Github: TBA')
	
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: {
	      regular: 'méně než sekunda',
	      past: 'před méně než sekundou',
	      future: 'za méně než sekundu'
	    },
	    few: {
	      regular: 'méně než {{count}} sekundy',
	      past: 'před méně než {{count}} sekundami',
	      future: 'za méně než {{count}} sekundy'
	    },
	    many: {
	      regular: 'méně než {{count}} sekund',
	      past: 'před méně než {{count}} sekundami',
	      future: 'za méně než {{count}} sekund'
	    }
	  },
	  xSeconds: {
	    one: {
	      regular: 'sekunda',
	      past: 'před sekundou',
	      future: 'za sekundu'
	    },
	    few: {
	      regular: '{{count}} sekundy',
	      past: 'před {{count}} sekundami',
	      future: 'za {{count}} sekundy'
	    },
	    many: {
	      regular: '{{count}} sekund',
	      past: 'před {{count}} sekundami',
	      future: 'za {{count}} sekund'
	    }
	  },
	  halfAMinute: {
	    other: {
	      regular: 'půl minuty',
	      past: 'před půl minutou',
	      future: 'za půl minuty'
	    }
	  },
	  lessThanXMinutes: {
	    one: {
	      regular: 'méně než minuta',
	      past: 'před méně než minutou',
	      future: 'za méně než minutu'
	    },
	    few: {
	      regular: 'méně než {{count}} minuty',
	      past: 'před méně než {{count}} minutami',
	      future: 'za méně než {{count}} minuty'
	    },
	    many: {
	      regular: 'méně než {{count}} minut',
	      past: 'před méně než {{count}} minutami',
	      future: 'za méně než {{count}} minut'
	    }
	  },
	  xMinutes: {
	    one: {
	      regular: 'minuta',
	      past: 'před minutou',
	      future: 'za minutu'
	    },
	    few: {
	      regular: '{{count}} minuty',
	      past: 'před {{count}} minutami',
	      future: 'za {{count}} minuty'
	    },
	    many: {
	      regular: '{{count}} minut',
	      past: 'před {{count}} minutami',
	      future: 'za {{count}} minut'
	    }
	  },
	  aboutXHours: {
	    one: {
	      regular: 'přibližně hodina',
	      past: 'přibližně před hodinou',
	      future: 'přibližně za hodinu'
	    },
	    few: {
	      regular: 'přibližně {{count}} hodiny',
	      past: 'přibližně před {{count}} hodinami',
	      future: 'přibližně za {{count}} hodiny'
	    },
	    many: {
	      regular: 'přibližně {{count}} hodin',
	      past: 'přibližně před {{count}} hodinami',
	      future: 'přibližně za {{count}} hodin'
	    }
	  },
	  xHours: {
	    one: {
	      regular: 'hodina',
	      past: 'před hodinou',
	      future: 'za hodinu'
	    },
	    few: {
	      regular: '{{count}} hodiny',
	      past: 'před {{count}} hodinami',
	      future: 'za {{count}} hodiny'
	    },
	    many: {
	      regular: '{{count}} hodin',
	      past: 'před {{count}} hodinami',
	      future: 'za {{count}} hodin'
	    }
	  },
	  xDays: {
	    one: {
	      regular: 'den',
	      past: 'před dnem',
	      future: 'za den'
	    },
	    few: {
	      regular: '{{count}} dny',
	      past: 'před {{count}} dny',
	      future: 'za {{count}} dny'
	    },
	    many: {
	      regular: '{{count}} dní',
	      past: 'před {{count}} dny',
	      future: 'za {{count}} dní'
	    }
	  },
	  aboutXWeeks: {
	    one: {
	      regular: 'přibližně týden',
	      past: 'přibližně před týdnem',
	      future: 'přibližně za týden'
	    },
	    few: {
	      regular: 'přibližně {{count}} týdny',
	      past: 'přibližně před {{count}} týdny',
	      future: 'přibližně za {{count}} týdny'
	    },
	    many: {
	      regular: 'přibližně {{count}} týdnů',
	      past: 'přibližně před {{count}} týdny',
	      future: 'přibližně za {{count}} týdnů'
	    }
	  },
	  xWeeks: {
	    one: {
	      regular: 'týden',
	      past: 'před týdnem',
	      future: 'za týden'
	    },
	    few: {
	      regular: '{{count}} týdny',
	      past: 'před {{count}} týdny',
	      future: 'za {{count}} týdny'
	    },
	    many: {
	      regular: '{{count}} týdnů',
	      past: 'před {{count}} týdny',
	      future: 'za {{count}} týdnů'
	    }
	  },
	  aboutXMonths: {
	    one: {
	      regular: 'přibližně měsíc',
	      past: 'přibližně před měsícem',
	      future: 'přibližně za měsíc'
	    },
	    few: {
	      regular: 'přibližně {{count}} měsíce',
	      past: 'přibližně před {{count}} měsíci',
	      future: 'přibližně za {{count}} měsíce'
	    },
	    many: {
	      regular: 'přibližně {{count}} měsíců',
	      past: 'přibližně před {{count}} měsíci',
	      future: 'přibližně za {{count}} měsíců'
	    }
	  },
	  xMonths: {
	    one: {
	      regular: 'měsíc',
	      past: 'před měsícem',
	      future: 'za měsíc'
	    },
	    few: {
	      regular: '{{count}} měsíce',
	      past: 'před {{count}} měsíci',
	      future: 'za {{count}} měsíce'
	    },
	    many: {
	      regular: '{{count}} měsíců',
	      past: 'před {{count}} měsíci',
	      future: 'za {{count}} měsíců'
	    }
	  },
	  aboutXYears: {
	    one: {
	      regular: 'přibližně rok',
	      past: 'přibližně před rokem',
	      future: 'přibližně za rok'
	    },
	    few: {
	      regular: 'přibližně {{count}} roky',
	      past: 'přibližně před {{count}} roky',
	      future: 'přibližně za {{count}} roky'
	    },
	    many: {
	      regular: 'přibližně {{count}} roků',
	      past: 'přibližně před {{count}} roky',
	      future: 'přibližně za {{count}} roků'
	    }
	  },
	  xYears: {
	    one: {
	      regular: 'rok',
	      past: 'před rokem',
	      future: 'za rok'
	    },
	    few: {
	      regular: '{{count}} roky',
	      past: 'před {{count}} roky',
	      future: 'za {{count}} roky'
	    },
	    many: {
	      regular: '{{count}} roků',
	      past: 'před {{count}} roky',
	      future: 'za {{count}} roků'
	    }
	  },
	  overXYears: {
	    one: {
	      regular: 'více než rok',
	      past: 'před více než rokem',
	      future: 'za více než rok'
	    },
	    few: {
	      regular: 'více než {{count}} roky',
	      past: 'před více než {{count}} roky',
	      future: 'za více než {{count}} roky'
	    },
	    many: {
	      regular: 'více než {{count}} roků',
	      past: 'před více než {{count}} roky',
	      future: 'za více než {{count}} roků'
	    }
	  },
	  almostXYears: {
	    one: {
	      regular: 'skoro rok',
	      past: 'skoro před rokem',
	      future: 'skoro za rok'
	    },
	    few: {
	      regular: 'skoro {{count}} roky',
	      past: 'skoro před {{count}} roky',
	      future: 'skoro za {{count}} roky'
	    },
	    many: {
	      regular: 'skoro {{count}} roků',
	      past: 'skoro před {{count}} roky',
	      future: 'skoro za {{count}} roků'
	    }
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var scheme = formatDistanceLocale[token]; // cs pluralization
	
	  var pluralToken;
	
	  if (typeof scheme.other === 'object') {
	    pluralToken = 'other';
	  } else if (count === 1) {
	    pluralToken = 'one';
	  } else if (count > 1 && count < 5 || count === 0) {
	    pluralToken = 'few';
	  } else {
	    pluralToken = 'many';
	  } // times
	
	
	  var suffixExist = options.addSuffix === true;
	  var comparison = options.comparison;
	  var timeToken;
	
	  if (suffixExist && comparison === -1) {
	    timeToken = 'past';
	  } else if (suffixExist && comparison === 1) {
	    timeToken = 'future';
	  } else {
	    timeToken = 'regular';
	  }
	
	  return scheme[pluralToken][timeToken].replace('{{count}}', count);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d. MMMM yyyy',
	  long: 'd. MMMM yyyy',
	  medium: 'd. M. yyyy',
	  short: 'dd.MM.yyyy'
	};
	var timeFormats = {
	  full: 'H:mm:ss zzzz',
	  long: 'H:mm:ss z',
	  medium: 'H:mm:ss',
	  short: 'H:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'v' {{time}}",
	  long: "{{date}} 'v' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var accusativeWeekdays = ['neděli', 'pondělí', 'úterý', 'středu', 'čtvrtek', 'pátek', 'sobotu'];
	var formatRelativeLocale = {
	  lastWeek: "'poslední' eeee 've' p",
	  yesterday: "'včera v' p",
	  today: "'dnes v' p",
	  tomorrow: "'zítra v' p",
	  nextWeek: function (date, _baseDate, _options) {
	    var day = date.getUTCDay();
	    return "'v " + accusativeWeekdays[day] + " o' p";
	  },
	  other: 'P'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date, baseDate, options);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['př. n. l.', 'n. l.'],
	  abbreviated: ['př. n. l.', 'n. l.'],
	  wide: ['před naším letopočtem', 'našeho letopočtu']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1. čtvrtletí', '2. čtvrtletí', '3. čtvrtletí', '4. čtvrtletí'],
	  wide: ['1. čtvrtletí', '2. čtvrtletí', '3. čtvrtletí', '4. čtvrtletí']
	};
	var monthValues = {
	  narrow: ['L', 'Ú', 'B', 'D', 'K', 'Č', 'Č', 'S', 'Z', 'Ř', 'L', 'P'],
	  abbreviated: ['led', 'úno', 'bře', 'dub', 'kvě', 'čvn', 'čvc', 'srp', 'zář', 'říj', 'lis', 'pro'],
	  wide: ['leden', 'únor', 'březen', 'duben', 'květen', 'červen', 'červenec', 'srpen', 'září', 'říjen', 'listopad', 'prosinec']
	};
	var formattingMonthValues = {
	  narrow: ['L', 'Ú', 'B', 'D', 'K', 'Č', 'Č', 'S', 'Z', 'Ř', 'L', 'P'],
	  abbreviated: ['led', 'úno', 'bře', 'dub', 'kvě', 'čvn', 'čvc', 'srp', 'zář', 'říj', 'lis', 'pro'],
	  wide: ['ledna', 'února', 'března', 'dubna', 'května', 'června', 'července', 'srpna', 'září', 'října', 'listopadu', 'prosince']
	};
	var dayValues = {
	  narrow: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
	  short: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
	  abbreviated: ['ned', 'pon', 'úte', 'stř', 'čtv', 'pát', 'sob'],
	  wide: ['neděle', 'pondělí', 'úterý', 'středa', 'čtvrtek', 'pátek', 'sobota']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'dop.',
	    pm: 'odp.',
	    midnight: 'půlnoc',
	    noon: 'poledne',
	    morning: 'ráno',
	    afternoon: 'odpoledne',
	    evening: 'večer',
	    night: 'noc'
	  },
	  abbreviated: {
	    am: 'dop.',
	    pm: 'odp.',
	    midnight: 'půlnoc',
	    noon: 'poledne',
	    morning: 'ráno',
	    afternoon: 'odpoledne',
	    evening: 'večer',
	    night: 'noc'
	  },
	  wide: {
	    am: 'dopoledne',
	    pm: 'odpoledne',
	    midnight: 'půlnoc',
	    noon: 'poledne',
	    morning: 'ráno',
	    afternoon: 'odpoledne',
	    evening: 'večer',
	    night: 'noc'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'dop.',
	    pm: 'odp.',
	    midnight: 'půlnoc',
	    noon: 'poledne',
	    morning: 'ráno',
	    afternoon: 'odpoledne',
	    evening: 'večer',
	    night: 'noc'
	  },
	  abbreviated: {
	    am: 'dop.',
	    pm: 'odp.',
	    midnight: 'půlnoc',
	    noon: 'poledne',
	    morning: 'ráno',
	    afternoon: 'odpoledne',
	    evening: 'večer',
	    night: 'noc'
	  },
	  wide: {
	    am: 'dopoledne',
	    pm: 'odpoledne',
	    midnight: 'půlnoc',
	    noon: 'poledne',
	    morning: 'ráno',
	    afternoon: 'odpoledne',
	    evening: 'večer',
	    night: 'noc'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(8));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)\.?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(p[řr]ed Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
	  abbreviated: /^(pe[řr]ed Kr\.|pe[řr]ed n\. l\.|po Kr\.|n\. l\.)/i,
	  wide: /^(p[řr]ed Kristem|pred na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
	};
	var parseEraPatterns = {
	  any: [/^p[řr]/i, /^(po|n)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
	  wide: /^[1234]\. [čc]tvrtlet[íi]/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[lúubdkčcszřrlp]/i,
	  abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
	  wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^l/i, /^[úu]/i, /^b/i, /^d/i, /^k/i, /^[čc]/i, /^[čc]/i, /^s/i, /^z/i, /^[řr]/i, /^l/i, /^p/i],
	  any: [/^led/i, /^[úu]n/i, /^b[řr]e/i, /^dub/i, /^kv[ěe]/i, /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i, /^[čc]vc|[čc]erven(ec|ce)/i, /^srp/i, /^z[áa][řr]/i, /^[řr][íi]j/i, /^lis/i, /^pro/i]
	};
	var matchDayPatterns = {
	  narrow: /^[npuúsčps]/i,
	  short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
	  abbreviated: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
	  wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
	};
	var parseDayPatterns = {
	  narrow: [/^n/i, /^p/i, /^[úu]/i, /^s/i, /^[čc]/i, /^p/i, /^s/i],
	  any: [/^ne/i, /^po/i, /^ut/i, /^st/i, /^[čc]t/i, /^p/i, /^so/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^dopoledne|dop\.?|odpoledne|odp\.?|půlnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^dop/i,
	    pm: /^odp/i,
	    midnight: /^p[ůu]lnoc/i,
	    noon: /^poledne/i,
	    morning: /r[áa]no/i,
	    afternoon: /odpoledne/i,
	    evening: /ve[čc]er/i,
	    night: /noc/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1030));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1031));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1032));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1033));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1034));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Czech locale.
	 * @language Czech
	 * @iso-639-2 ces
	 * @author David Rus [@davidrus]{@link https://github.com/davidrus}
	 * @author Pavel Hrách [@SilenY]{@link https://github.com/SilenY}
	 * @author Jozef Bíroš [@JozefBiros]{@link https://github.com/JozefBiros}
	 */
	var locale = {
	  code: 'cs',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'llai na eiliad',
	    other: 'llai na {{count}} eiliad'
	  },
	  xSeconds: {
	    one: '1 eiliad',
	    other: '{{count}} eiliad'
	  },
	  halfAMinute: 'hanner munud',
	  lessThanXMinutes: {
	    one: 'llai na munud',
	    two: 'llai na 2 funud',
	    other: 'llai na {{count}} munud'
	  },
	  xMinutes: {
	    one: '1 munud',
	    two: '2 funud',
	    other: '{{count}} munud'
	  },
	  aboutXHours: {
	    one: 'tua 1 awr',
	    other: 'tua {{count}} awr'
	  },
	  xHours: {
	    one: '1 awr',
	    other: '{{count}} awr'
	  },
	  xDays: {
	    one: '1 diwrnod',
	    two: '2 ddiwrnod',
	    other: '{{count}} diwrnod'
	  },
	  aboutXWeeks: {
	    one: 'tua 1 wythnos',
	    two: 'tua pythefnos',
	    other: 'tua {{count}} wythnos'
	  },
	  xWeeks: {
	    one: '1 wythnos',
	    two: 'pythefnos',
	    other: '{{count}} wythnos'
	  },
	  aboutXMonths: {
	    one: 'tua 1 mis',
	    two: 'tua 2 fis',
	    other: 'tua {{count}} mis'
	  },
	  xMonths: {
	    one: '1 mis',
	    two: '2 fis',
	    other: '{{count}} mis'
	  },
	  aboutXYears: {
	    one: 'tua 1 flwyddyn',
	    two: 'tua 2 flynedd',
	    other: 'tua {{count}} mlynedd'
	  },
	  xYears: {
	    one: '1 flwyddyn',
	    two: '2 flynedd',
	    other: '{{count}} mlynedd'
	  },
	  overXYears: {
	    one: 'dros 1 flwyddyn',
	    two: 'dros 2 flynedd',
	    other: 'dros {{count}} mlynedd'
	  },
	  almostXYears: {
	    one: 'bron 1 flwyddyn',
	    two: 'bron 2 flynedd',
	    other: 'bron {{count}} mlynedd'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else if (count === 2 && !!formatDistanceLocale[token].two) {
	    result = formatDistanceLocale[token].two;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'mewn ' + result;
	    } else {
	      return result + ' yn ôl';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d MMMM yyyy',
	  long: 'd MMMM yyyy',
	  medium: 'd MMM yyyy',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'am' {{time}}",
	  long: "{{date}} 'am' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'diwethaf am' p",
	  yesterday: "'ddoe am' p",
	  today: "'heddiw am' p",
	  tomorrow: "'yfory am' p",
	  nextWeek: "eeee 'am' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['C', 'O'],
	  abbreviated: ['CC', 'OC'],
	  wide: ['Cyn Crist', 'Ar ôl Crist']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Ch1', 'Ch2', 'Ch3', 'Ch4'],
	  wide: ['Chwarter 1af', '2ail chwarter', '3ydd chwarter', '4ydd chwarter']
	}; // Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['I', 'Ch', 'Ma', 'E', 'Mi', 'Me', 'G', 'A', 'Md', 'H', 'T', 'Rh'],
	  abbreviated: ['Ion', 'Chwe', 'Maw', 'Ebr', 'Mai', 'Meh', 'Gor', 'Aws', 'Med', 'Hyd', 'Tach', 'Rhag'],
	  wide: ['Ionawr', 'Chwefror', 'Mawrth', 'Ebrill', 'Mai', 'Mehefin', 'Gorffennaf', 'Awst', 'Medi', 'Hydref', 'Tachwedd', 'Rhagfyr']
	};
	var dayValues = {
	  narrow: ['S', 'Ll', 'M', 'M', 'I', 'G', 'S'],
	  short: ['Su', 'Ll', 'Ma', 'Me', 'Ia', 'Gw', 'Sa'],
	  abbreviated: ['Sul', 'Llun', 'Maw', 'Mer', 'Iau', 'Gwe', 'Sad'],
	  wide: ['dydd Sul', 'dydd Llun', 'dydd Mawrth', 'dydd Mercher', 'dydd Iau', 'dydd Gwener', 'dydd Sadwrn']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'b',
	    pm: 'h',
	    midnight: 'hn',
	    noon: 'hd',
	    morning: 'bore',
	    afternoon: 'prynhawn',
	    evening: "gyda'r nos",
	    night: 'nos'
	  },
	  abbreviated: {
	    am: 'yb',
	    pm: 'yh',
	    midnight: 'hanner nos',
	    noon: 'hanner dydd',
	    morning: 'bore',
	    afternoon: 'prynhawn',
	    evening: "gyda'r nos",
	    night: 'nos'
	  },
	  wide: {
	    am: 'y.b.',
	    pm: 'y.h.',
	    midnight: 'hanner nos',
	    noon: 'hanner dydd',
	    morning: 'bore',
	    afternoon: 'prynhawn',
	    evening: "gyda'r nos",
	    night: 'nos'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'b',
	    pm: 'h',
	    midnight: 'hn',
	    noon: 'hd',
	    morning: 'yn y bore',
	    afternoon: 'yn y prynhawn',
	    evening: "gyda'r nos",
	    night: 'yn y nos'
	  },
	  abbreviated: {
	    am: 'yb',
	    pm: 'yh',
	    midnight: 'hanner nos',
	    noon: 'hanner dydd',
	    morning: 'yn y bore',
	    afternoon: 'yn y prynhawn',
	    evening: "gyda'r nos",
	    night: 'yn y nos'
	  },
	  wide: {
	    am: 'y.b.',
	    pm: 'y.h.',
	    midnight: 'hanner nos',
	    noon: 'hanner dydd',
	    morning: 'yn y bore',
	    afternoon: 'yn y prynhawn',
	    evening: "gyda'r nos",
	    night: 'yn y nos'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber);
	
	  if (number < 20) {
	    switch (number) {
	      case 0:
	        return number + 'fed';
	
	      case 1:
	        return number + 'af';
	
	      case 2:
	        return number + 'ail';
	
	      case 3:
	      case 4:
	        return number + 'ydd';
	
	      case 5:
	      case 6:
	        return number + 'ed';
	
	      case 7:
	      case 8:
	      case 9:
	      case 10:
	      case 12:
	      case 15:
	      case 18:
	        return number + 'fed';
	
	      case 11:
	      case 13:
	      case 14:
	      case 16:
	      case 17:
	      case 19:
	        return number + 'eg';
	    }
	  } else if (number >= 50 && number <= 60 || number === 80 || number >= 100) {
	    return number + 'fed';
	  }
	
	  return number + 'ain';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(af|ail|ydd|ed|fed|eg|ain)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(c|o)/i,
	  abbreviated: /^(c\.?\s?c\.?|o\.?\s?c\.?)/i,
	  wide: /^(cyn christ|ar ôl crist|ar ol crist)/i
	};
	var parseEraPatterns = {
	  wide: [/^c/i, /^(ar ôl crist|ar ol crist)/i],
	  any: [/^c/i, /^o/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^ch[1234]/i,
	  wide: /^(chwarter 1af)|([234](ail|ydd)? chwarter)/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(i|ch|m|e|g|a|h|t|rh)/i,
	  abbreviated: /^(ion|chwe|maw|ebr|mai|meh|gor|aws|med|hyd|tach|rhag)/i,
	  wide: /^(ionawr|chwefror|mawrth|ebrill|mai|mehefin|gorffennaf|awst|medi|hydref|tachwedd|rhagfyr)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^i/i, /^ch/i, /^m/i, /^e/i, /^m/i, /^m/i, /^g/i, /^a/i, /^m/i, /^h/i, /^t/i, /^rh/i],
	  any: [/^io/i, /^ch/i, /^maw/i, /^e/i, /^mai/i, /^meh/i, /^g/i, /^a/i, /^med/i, /^h/i, /^t/i, /^rh/i]
	};
	var matchDayPatterns = {
	  narrow: /^(s|ll|m|i|g)/i,
	  short: /^(su|ll|ma|me|ia|gw|sa)/i,
	  abbreviated: /^(sul|llun|maw|mer|iau|gwe|sad)/i,
	  wide: /^dydd (sul|llun|mawrth|mercher|iau|gwener|sadwrn)/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^ll/i, /^m/i, /^m/i, /^i/i, /^g/i, /^s/i],
	  wide: [/^dydd su/i, /^dydd ll/i, /^dydd ma/i, /^dydd me/i, /^dydd i/i, /^dydd g/i, /^dydd sa/i],
	  any: [/^su/i, /^ll/i, /^ma/i, /^me/i, /^i/i, /^g/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(b|h|hn|hd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i,
	  any: /^(y\.?\s?[bh]\.?|hanner nos|hanner dydd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^b|(y\.?\s?b\.?)/i,
	    pm: /^h|(y\.?\s?h\.?)|(yr hwyr)/i,
	    midnight: /^hn|hanner nos/i,
	    noon: /^hd|hanner dydd/i,
	    morning: /bore/i,
	    afternoon: /prynhawn/i,
	    evening: /^gyda'r nos$/i,
	    night: /blah/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1036));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1037));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1038));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1039));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1040));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Welsh locale.
	 * @language Welsh
	 * @iso-639-2 cym
	 * @author Elwyn Malethan [@elmomalmo]{@link https://github.com/elmomalmo}
	 */
	var locale = {
	  code: 'cy',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'mindre end ét sekund',
	    other: 'mindre end {{count}} sekunder'
	  },
	  xSeconds: {
	    one: '1 sekund',
	    other: '{{count}} sekunder'
	  },
	  halfAMinute: 'ét halvt minut',
	  lessThanXMinutes: {
	    one: 'mindre end ét minut',
	    other: 'mindre end {{count}} minutter'
	  },
	  xMinutes: {
	    one: '1 minut',
	    other: '{{count}} minutter'
	  },
	  aboutXHours: {
	    one: 'cirka 1 time',
	    other: 'cirka {{count}} timer'
	  },
	  xHours: {
	    one: '1 time',
	    other: '{{count}} timer'
	  },
	  xDays: {
	    one: '1 dag',
	    other: '{{count}} dage'
	  },
	  aboutXWeeks: {
	    one: 'cirka 1 uge',
	    other: 'cirka {{count}} uger'
	  },
	  xWeeks: {
	    one: '1 uge',
	    other: '{{count}} uger'
	  },
	  aboutXMonths: {
	    one: 'cirka 1 måned',
	    other: 'cirka {{count}} måneder'
	  },
	  xMonths: {
	    one: '1 måned',
	    other: '{{count}} måneder'
	  },
	  aboutXYears: {
	    one: 'cirka 1 år',
	    other: 'cirka {{count}} år'
	  },
	  xYears: {
	    one: '1 år',
	    other: '{{count}} år'
	  },
	  overXYears: {
	    one: 'over 1 år',
	    other: 'over {{count}} år'
	  },
	  almostXYears: {
	    one: 'næsten 1 år',
	    other: 'næsten {{count}} år'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'om ' + result;
	    } else {
	      return result + ' siden';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE 'den' d. MMMM y",
	  long: 'd. MMMM y',
	  medium: 'd. MMM y',
	  short: 'dd/MM/y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'kl'. {{time}}",
	  long: "{{date}} 'kl'. {{time}}",
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'sidste' eeee 'kl.' p",
	  yesterday: "'i går kl.' p",
	  today: "'i dag kl.' p",
	  tomorrow: "'i morgen kl.' p",
	  nextWeek: "'på' eeee 'kl.' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['fvt', 'vt'],
	  abbreviated: ['f.v.t.', 'v.t.'],
	  wide: ['før vesterlandsk tidsregning', 'vesterlandsk tidsregning']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1. kvt.', '2. kvt.', '3. kvt.', '4. kvt.'],
	  wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
	  wide: ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december']
	}; // Note that 'Days - abbreviated - Formatting' has periods at the end.
	// https://www.unicode.org/cldr/charts/32/summary/da.html#1760
	// This makes grammatical sense in danish, as most abbreviations have periods.
	
	var dayValues = {
	  narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
	  short: ['sø', 'ma', 'ti', 'on', 'to', 'fr', 'lø'],
	  abbreviated: ['søn.', 'man.', 'tir.', 'ons.', 'tor.', 'fre.', 'lør.'],
	  wide: ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'midnat',
	    noon: 'middag',
	    morning: 'morgen',
	    afternoon: 'eftermiddag',
	    evening: 'aften',
	    night: 'nat'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnat',
	    noon: 'middag',
	    morning: 'morgen',
	    afternoon: 'eftermiddag',
	    evening: 'aften',
	    night: 'nat'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnat',
	    noon: 'middag',
	    morning: 'morgen',
	    afternoon: 'eftermiddag',
	    evening: 'aften',
	    night: 'nat'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'midnat',
	    noon: 'middag',
	    morning: 'om morgenen',
	    afternoon: 'om eftermiddagen',
	    evening: 'om aftenen',
	    night: 'om natten'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnat',
	    noon: 'middag',
	    morning: 'om morgenen',
	    afternoon: 'om eftermiddagen',
	    evening: 'om aftenen',
	    night: 'om natten'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnat',
	    noon: 'middag',
	    morning: 'om morgenen',
	    afternoon: 'om eftermiddagen',
	    evening: 'om aftenen',
	    night: 'om natten'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(8));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(fKr|fvt|eKr|vt)/i,
	  abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
	  wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
	};
	var parseEraPatterns = {
	  any: [/^f/i, /^(v|e)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234]. kvt\./i,
	  wide: /^[1234]\.? kvartal/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
	  wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smtofl]/i,
	  short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
	  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
	  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
	  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
	  any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /midnat/i,
	    noon: /middag/i,
	    morning: /morgen/i,
	    afternoon: /eftermiddag/i,
	    evening: /aften/i,
	    night: /nat/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1042));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1043));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1044));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1045));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1046));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Danish locale.
	 * @language Danish
	 * @iso-639-2 dan
	 * @author Mathias Wøbbe [@MathiasKandelborg]{@link https://github.com/MathiasKandelborg}
	 * @author Anders B. Hansen [@Andersbiha]{@link https://github.com/Andersbiha}
	 * @author [@kgram]{@link https://github.com/kgram}
	 * @author [@stefanbugge]{@link https://github.com/stefanbugge}
	 */
	var locale = {
	  code: 'da',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['v.Chr.', 'n.Chr.'],
	  abbreviated: ['v.Chr.', 'n.Chr.'],
	  wide: ['vor Christus', 'nach Christus']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1. Quartal', '2. Quartal', '3. Quartal', '4. Quartal']
	}; // Note: in German, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jän', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
	  wide: ['Jänner', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
	}; // https://st.unicode.org/cldr-apps/v#/de_AT/Gregorian/
	
	var formattingMonthValues = {
	  narrow: monthValues.narrow,
	  abbreviated: ['Jän.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'],
	  wide: monthValues.wide
	};
	var dayValues = {
	  narrow: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
	  short: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
	  abbreviated: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
	  wide: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']
	}; // https://www.unicode.org/cldr/charts/32/summary/de.html#1881
	
	var dayPeriodValues = {
	  narrow: {
	    am: 'vm.',
	    pm: 'nm.',
	    midnight: 'Mitternacht',
	    noon: 'Mittag',
	    morning: 'Morgen',
	    afternoon: 'Nachm.',
	    evening: 'Abend',
	    night: 'Nacht'
	  },
	  abbreviated: {
	    am: 'vorm.',
	    pm: 'nachm.',
	    midnight: 'Mitternacht',
	    noon: 'Mittag',
	    morning: 'Morgen',
	    afternoon: 'Nachmittag',
	    evening: 'Abend',
	    night: 'Nacht'
	  },
	  wide: {
	    am: 'vormittags',
	    pm: 'nachmittags',
	    midnight: 'Mitternacht',
	    noon: 'Mittag',
	    morning: 'Morgen',
	    afternoon: 'Nachmittag',
	    evening: 'Abend',
	    night: 'Nacht'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'vm.',
	    pm: 'nm.',
	    midnight: 'Mitternacht',
	    noon: 'Mittag',
	    morning: 'morgens',
	    afternoon: 'nachm.',
	    evening: 'abends',
	    night: 'nachts'
	  },
	  abbreviated: {
	    am: 'vorm.',
	    pm: 'nachm.',
	    midnight: 'Mitternacht',
	    noon: 'Mittag',
	    morning: 'morgens',
	    afternoon: 'nachmittags',
	    evening: 'abends',
	    night: 'nachts'
	  },
	  wide: {
	    am: 'vormittags',
	    pm: 'nachmittags',
	    midnight: 'Mitternacht',
	    noon: 'Mittag',
	    morning: 'morgens',
	    afternoon: 'nachmittags',
	    evening: 'abends',
	    night: 'nachts'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    formattingValues: formattingMonthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(324));
	
	var _index2 = _interopRequireDefault(__webpack_require__(325));
	
	var _index3 = _interopRequireDefault(__webpack_require__(326));
	
	var _index4 = _interopRequireDefault(__webpack_require__(327));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1048));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// difference to 'de' locale
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary German locale (Austria).
	 * @language German
	 * @iso-639-2 deu
	 * @author Christoph Tobias Stenglein [@cstenglein]{@link https://github.com/cstenglein}
	 */
	var locale = {
	  code: 'de-AT',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index5.default,
	  match: _index4.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['v.Chr.', 'n.Chr.'],
	  abbreviated: ['v.Chr.', 'n.Chr.'],
	  wide: ['vor Christus', 'nach Christus']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1. Quartal', '2. Quartal', '3. Quartal', '4. Quartal']
	}; // Note: in German, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
	  wide: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
	}; // https://st.unicode.org/cldr-apps/v#/de/Gregorian/
	
	var formattingMonthValues = {
	  narrow: monthValues.narrow,
	  abbreviated: ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'],
	  wide: monthValues.wide
	};
	var dayValues = {
	  narrow: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
	  short: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
	  abbreviated: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
	  wide: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']
	}; // https://www.unicode.org/cldr/charts/32/summary/de.html#1881
	
	var dayPeriodValues = {
	  narrow: {
	    am: 'vm.',
	    pm: 'nm.',
	    midnight: 'Mitternacht',
	    noon: 'Mittag',
	    morning: 'Morgen',
	    afternoon: 'Nachm.',
	    evening: 'Abend',
	    night: 'Nacht'
	  },
	  abbreviated: {
	    am: 'vorm.',
	    pm: 'nachm.',
	    midnight: 'Mitternacht',
	    noon: 'Mittag',
	    morning: 'Morgen',
	    afternoon: 'Nachmittag',
	    evening: 'Abend',
	    night: 'Nacht'
	  },
	  wide: {
	    am: 'vormittags',
	    pm: 'nachmittags',
	    midnight: 'Mitternacht',
	    noon: 'Mittag',
	    morning: 'Morgen',
	    afternoon: 'Nachmittag',
	    evening: 'Abend',
	    night: 'Nacht'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'vm.',
	    pm: 'nm.',
	    midnight: 'Mitternacht',
	    noon: 'Mittag',
	    morning: 'morgens',
	    afternoon: 'nachm.',
	    evening: 'abends',
	    night: 'nachts'
	  },
	  abbreviated: {
	    am: 'vorm.',
	    pm: 'nachm.',
	    midnight: 'Mitternacht',
	    noon: 'Mittag',
	    morning: 'morgens',
	    afternoon: 'nachmittags',
	    evening: 'abends',
	    night: 'nachts'
	  },
	  wide: {
	    am: 'vormittags',
	    pm: 'nachmittags',
	    midnight: 'Mitternacht',
	    noon: 'Mittag',
	    morning: 'morgens',
	    afternoon: 'nachmittags',
	    evening: 'abends',
	    night: 'nachts'
	  }
	};
	
	var ordinalNumber = function (dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	};
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    formattingValues: formattingMonthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(324));
	
	var _index2 = _interopRequireDefault(__webpack_require__(325));
	
	var _index3 = _interopRequireDefault(__webpack_require__(326));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1050));
	
	var _index5 = _interopRequireDefault(__webpack_require__(327));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary German locale.
	 * @language German
	 * @iso-639-2 deu
	 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
	 * @author Asia [@asia-t]{@link https://github.com/asia-t}
	 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
	 * @author RomanErnst [@pex]{@link https://github.com/pex}
	 * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
	 */
	var locale = {
	  code: 'de',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'λιγότερο από ένα δευτερόλεπτο',
	    other: 'λιγότερο από {{count}} δευτερόλεπτα'
	  },
	  xSeconds: {
	    one: '1 δευτερόλεπτο',
	    other: '{{count}} δευτερόλεπτα'
	  },
	  halfAMinute: 'μισό λεπτό',
	  lessThanXMinutes: {
	    one: 'λιγότερο από ένα λεπτό',
	    other: 'λιγότερο από {{count}} λεπτά'
	  },
	  xMinutes: {
	    one: '1 λεπτό',
	    other: '{{count}} λεπτά'
	  },
	  aboutXHours: {
	    one: 'περίπου 1 ώρα',
	    other: 'περίπου {{count}} ώρες'
	  },
	  xHours: {
	    one: '1 ώρα',
	    other: '{{count}} ώρες'
	  },
	  xDays: {
	    one: '1 ημέρα',
	    other: '{{count}} ημέρες'
	  },
	  aboutXWeeks: {
	    one: 'περίπου 1 εβδομάδα',
	    other: 'περίπου {{count}} εβδομάδες'
	  },
	  xWeeks: {
	    one: '1 εβδομάδα',
	    other: '{{count}} εβδομάδες'
	  },
	  aboutXMonths: {
	    one: 'περίπου 1 μήνας',
	    other: 'περίπου {{count}} μήνες'
	  },
	  xMonths: {
	    one: '1 μήνας',
	    other: '{{count}} μήνες'
	  },
	  aboutXYears: {
	    one: 'περίπου 1 χρόνο',
	    other: 'περίπου {{count}} χρόνια'
	  },
	  xYears: {
	    one: '1 χρόνο',
	    other: '{{count}} χρόνια'
	  },
	  overXYears: {
	    one: 'πάνω από 1 χρόνο',
	    other: 'πάνω από {{count}} χρόνια'
	  },
	  almostXYears: {
	    one: 'περίπου 1 χρόνο',
	    other: 'περίπου {{count}} χρόνια'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'σε ' + result;
	    } else {
	      return result + ' πριν';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d MMMM y',
	  long: 'd MMMM y',
	  medium: 'd MMM y',
	  short: 'd/M/yy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: '{{date}} - {{time}}',
	  long: '{{date}} - {{time}}',
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: function (date) {
	    switch (date.getUTCDay()) {
	      case 6:
	        //Σάββατο
	        return "'το προηγούμενο' eeee 'στις' p";
	
	      default:
	        return "'την προηγούμενη' eeee 'στις' p";
	    }
	  },
	  yesterday: "'χθες στις' p",
	  today: "'σήμερα στις' p",
	  tomorrow: "'αύριο στις' p",
	  nextWeek: "eeee 'στις' p",
	  other: 'P'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	  if (typeof format === 'function') return format(date, baseDate, options);
	  return format;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['πΧ', 'μΧ'],
	  abbreviated: ['π.Χ.', 'μ.Χ.'],
	  wide: ['προ Χριστού', 'μετά Χριστόν']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Τ1', 'Τ2', 'Τ3', 'Τ4'],
	  wide: ['1ο τρίμηνο', '2ο τρίμηνο', '3ο τρίμηνο', '4ο τρίμηνο']
	};
	var monthValues = {
	  narrow: ['Ι', 'Φ', 'Μ', 'Α', 'Μ', 'Ι', 'Ι', 'Α', 'Σ', 'Ο', 'Ν', 'Δ'],
	  abbreviated: ['Ιαν', 'Φεβ', 'Μάρ', 'Απρ', 'Μάι', 'Ιούν', 'Ιούλ', 'Αύγ', 'Σεπ', 'Οκτ', 'Νοέ', 'Δεκ'],
	  wide: ['Ιανουάριος', 'Φεβρουάριος', 'Μάρτιος', 'Απρίλιος', 'Μάιος', 'Ιούνιος', 'Ιούλιος', 'Αύγουστος', 'Σεπτέμβριος', 'Οκτώβριος', 'Νοέμβριος', 'Δεκέμβριος']
	};
	var formattingMonthValues = {
	  narrow: ['Ι', 'Φ', 'Μ', 'Α', 'Μ', 'Ι', 'Ι', 'Α', 'Σ', 'Ο', 'Ν', 'Δ'],
	  abbreviated: ['Ιαν', 'Φεβ', 'Μαρ', 'Απρ', 'Μαΐ', 'Ιουν', 'Ιουλ', 'Αυγ', 'Σεπ', 'Οκτ', 'Νοε', 'Δεκ'],
	  wide: ['Ιανουαρίου', 'Φεβρουαρίου', 'Μαρτίου', 'Απριλίου', 'Μαΐου', 'Ιουνίου', 'Ιουλίου', 'Αυγούστου', 'Σεπτεμβρίου', 'Οκτωβρίου', 'Νοεμβρίου', 'Δεκεμβρίου']
	};
	var dayValues = {
	  narrow: ['Κ', 'Δ', 'T', 'Τ', 'Π', 'Π', 'Σ'],
	  short: ['Κυ', 'Δε', 'Τρ', 'Τε', 'Πέ', 'Πα', 'Σά'],
	  abbreviated: ['Κυρ', 'Δευ', 'Τρί', 'Τετ', 'Πέμ', 'Παρ', 'Σάβ'],
	  wide: ['Κυριακή', 'Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'πμ',
	    pm: 'μμ',
	    midnight: 'μεσάνυχτα',
	    noon: 'μεσημέρι',
	    morning: 'πρωί',
	    afternoon: 'απόγευμα',
	    evening: 'βράδυ',
	    night: 'νύχτα'
	  },
	  abbreviated: {
	    am: 'π.μ.',
	    pm: 'μ.μ.',
	    midnight: 'μεσάνυχτα',
	    noon: 'μεσημέρι',
	    morning: 'πρωί',
	    afternoon: 'απόγευμα',
	    evening: 'βράδυ',
	    night: 'νύχτα'
	  },
	  wide: {
	    am: 'π.μ.',
	    pm: 'μ.μ.',
	    midnight: 'μεσάνυχτα',
	    noon: 'μεσημέρι',
	    morning: 'πρωί',
	    afternoon: 'απόγευμα',
	    evening: 'βράδυ',
	    night: 'νύχτα'
	  }
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	  var suffix;
	
	  if (unit === 'year' || unit === 'month') {
	    suffix = 'ος';
	  } else if (unit === 'week' || unit === 'dayOfYear' || unit === 'day' || unit === 'hour' || unit === 'date') {
	    suffix = 'η';
	  } else {
	    suffix = 'ο';
	  }
	
	  return dirtyNumber + suffix;
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(ος|η|ο)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(πΧ|μΧ)/i,
	  abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
	  wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
	};
	var parseEraPatterns = {
	  any: [/^π/i, /^(μ|κ)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^τ[1234]/i,
	  wide: /^[1234]ο? τρ(ί|ι)μηνο/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[ιφμαμιιασονδ]/i,
	  abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
	  wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^ι/i, /^φ/i, /^μ/i, /^α/i, /^μ/i, /^ι/i, /^ι/i, /^α/i, /^σ/i, /^ο/i, /^ν/i, /^δ/i],
	  any: [/^ια/i, /^φ/i, /^μ[άα]ρ/i, /^απ/i, /^μ[άα][ιΐ]/i, /^ιο[ύυ]ν/i, /^ιο[ύυ]λ/i, /^α[ύυ]/i, /^σ/i, /^ο/i, /^ν/i, /^δ/i]
	};
	var matchDayPatterns = {
	  narrow: /^[κδτπσ]/i,
	  short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
	  abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
	  wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
	};
	var parseDayPatterns = {
	  narrow: [/^κ/i, /^δ/i, /^τ/i, /^τ/i, /^π/i, /^π/i, /^σ/i],
	  any: [/^κ/i, /^δ/i, /^τρ/i, /^τε/i, /^π[εέ]/i, /^π[αά]/i, /^σ/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
	  any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^πμ|π\.\s?μ\./i,
	    pm: /^μμ|μ\.\s?μ\./i,
	    midnight: /^μεσάν/i,
	    noon: /^μεσημ(έ|ε)/i,
	    morning: /πρω(ί|ι)/i,
	    afternoon: /απ(ό|ο)γευμα/i,
	    evening: /βρ(ά|α)δυ/i,
	    night: /ν(ύ|υ)χτα/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1052));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1053));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1054));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1055));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1056));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Greek locale.
	 * @language Greek
	 * @iso-639-2 ell
	 * @author Fanis Katsimpas [@fanixk]{@link https://github.com/fanixk}
	 * @author Theodoros Orfanidis [@teoulas]{@link https://github.com/teoulas}
	 */
	var locale = {
	  code: 'el',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d MMMM yyyy',
	  long: 'd MMMM yyyy',
	  medium: 'd MMM yyyy',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'at' {{time}}",
	  long: "{{date}} 'at' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(92));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1058));
	
	var _index3 = _interopRequireDefault(__webpack_require__(77));
	
	var _index4 = _interopRequireDefault(__webpack_require__(78));
	
	var _index5 = _interopRequireDefault(__webpack_require__(79));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (Australia).
	 * @language English
	 * @iso-639-2 eng
	 * @author Julien Malige [@JulienMalige]{@link https://github.com/JulienMalige}
	 */
	var locale = {
	  code: 'en-AU',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'less than a second',
	    other: 'less than {{count}} seconds'
	  },
	  xSeconds: {
	    one: 'a second',
	    other: '{{count}} seconds'
	  },
	  halfAMinute: 'half a minute',
	  lessThanXMinutes: {
	    one: 'less than a minute',
	    other: 'less than {{count}} minutes'
	  },
	  xMinutes: {
	    one: 'a minute',
	    other: '{{count}} minutes'
	  },
	  aboutXHours: {
	    one: 'about an hour',
	    other: 'about {{count}} hours'
	  },
	  xHours: {
	    one: 'an hour',
	    other: '{{count}} hours'
	  },
	  xDays: {
	    one: 'a day',
	    other: '{{count}} days'
	  },
	  aboutXWeeks: {
	    one: 'about a week',
	    other: 'about {{count}} weeks'
	  },
	  xWeeks: {
	    one: 'a week',
	    other: '{{count}} weeks'
	  },
	  aboutXMonths: {
	    one: 'about a month',
	    other: 'about {{count}} months'
	  },
	  xMonths: {
	    one: 'a month',
	    other: '{{count}} months'
	  },
	  aboutXYears: {
	    one: 'about a year',
	    other: 'about {{count}} years'
	  },
	  xYears: {
	    one: 'a year',
	    other: '{{count}} years'
	  },
	  overXYears: {
	    one: 'over a year',
	    other: 'over {{count}} years'
	  },
	  almostXYears: {
	    one: 'almost a year',
	    other: 'almost {{count}} years'
	  }
	};
	
	var formatDistance = function (token, count, options) {
	  var result;
	  var tokenValue = formatDistanceLocale[token];
	
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    result = tokenValue.one;
	  } else {
	    result = tokenValue.other.replace('{{count}}', count.toString());
	  }
	
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'in ' + result;
	    } else {
	      return result + ' ago';
	    }
	  }
	
	  return result;
	};
	
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, MMMM do, yyyy',
	  long: 'MMMM do, yyyy',
	  medium: 'MMM d, yyyy',
	  short: 'yyyy-MM-dd'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'at' {{time}}",
	  long: "{{date}} 'at' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(77));
	
	var _index2 = _interopRequireDefault(__webpack_require__(78));
	
	var _index3 = _interopRequireDefault(__webpack_require__(79));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1060));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1061));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (Canada).
	 * @language English
	 * @iso-639-2 eng
	 * @author Mark Owsiak [@markowsiak]{@link https://github.com/markowsiak}
	 * @author Marco Imperatore [@mimperatore]{@link https://github.com/mimperatore}
	 */
	var locale = {
	  code: 'en-CA',
	  formatDistance: _index4.default,
	  formatLong: _index5.default,
	  formatRelative: _index.default,
	  localize: _index2.default,
	  match: _index3.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d MMMM yyyy',
	  long: 'd MMMM yyyy',
	  medium: 'd MMM yyyy',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'at' {{time}}",
	  long: "{{date}} 'at' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(92));
	
	var _index2 = _interopRequireDefault(__webpack_require__(77));
	
	var _index3 = _interopRequireDefault(__webpack_require__(78));
	
	var _index4 = _interopRequireDefault(__webpack_require__(79));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1063));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (United Kingdom).
	 * @language English
	 * @iso-639-2 eng
	 * @author Alex [@glintik]{@link https://github.com/glintik}
	 */
	var locale = {
	  code: 'en-GB',
	  formatDistance: _index.default,
	  formatLong: _index5.default,
	  formatRelative: _index2.default,
	  localize: _index3.default,
	  match: _index4.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d MMMM yyyy',
	  long: 'd MMMM, yyyy',
	  medium: 'd MMM, yyyy',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'at' {{time}}",
	  long: "{{date}} 'at' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(92));
	
	var _index2 = _interopRequireDefault(__webpack_require__(77));
	
	var _index3 = _interopRequireDefault(__webpack_require__(78));
	
	var _index4 = _interopRequireDefault(__webpack_require__(79));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1065));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (India).
	 * @language English
	 * @iso-639-2 eng
	 * @author Galeel Bhasha Satthar [@gbhasha]{@link https://github.com/gbhasha}
	 */
	var locale = {
	  code: 'en-IN',
	  formatDistance: _index.default,
	  formatLong: _index5.default,
	  formatRelative: _index2.default,
	  localize: _index3.default,
	  match: _index4.default,
	  options: {
	    weekStartsOn: 1,
	    // Monday is the first day of the week.
	    firstWeekContainsDate: 4 // The week that contains Jan 4th is the first week of the year.
	
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d MMMM yyyy',
	  long: 'd MMMM yyyy',
	  medium: 'd MMM yyyy',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'at' {{time}}",
	  long: "{{date}} 'at' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(92));
	
	var _index2 = _interopRequireDefault(__webpack_require__(77));
	
	var _index3 = _interopRequireDefault(__webpack_require__(78));
	
	var _index4 = _interopRequireDefault(__webpack_require__(79));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1067));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (New Zealand).
	 * @language English
	 * @iso-639-2 eng
	 * @author Murray Lucas [@muntact]{@link https://github.com/muntact}
	 */
	var locale = {
	  code: 'en-NZ',
	  formatDistance: _index.default,
	  formatLong: _index5.default,
	  formatRelative: _index2.default,
	  localize: _index3.default,
	  match: _index4.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, MMMM do, y',
	  long: 'MMMM do, y',
	  medium: 'MMM d, y',
	  short: 'MM/dd/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'at' {{time}}",
	  long: "{{date}} 'at' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d MMMM yyyy',
	  long: 'd MMMM yyyy',
	  medium: 'd MMM yyyy',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'at' {{time}}",
	  long: "{{date}} 'at' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(92));
	
	var _index2 = _interopRequireDefault(__webpack_require__(77));
	
	var _index3 = _interopRequireDefault(__webpack_require__(78));
	
	var _index4 = _interopRequireDefault(__webpack_require__(79));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1070));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (South Africa).
	 * @language English
	 * @iso-639-2 eng
	 * @author Shaila Kavrakova [@shaykav]{@link https://github.com/shaykav}
	 */
	var locale = {
	  code: 'en-ZA',
	  formatDistance: _index.default,
	  formatLong: _index5.default,
	  formatRelative: _index2.default,
	  localize: _index3.default,
	  match: _index4.default,
	  options: {
	    weekStartsOn: 0,
	    // Sunday is the first day of the week.
	    firstWeekContainsDate: 1 // The week that contains Jan 1st is the first week of the year.
	
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'malpli ol sekundo',
	    other: 'malpli ol {{count}} sekundoj'
	  },
	  xSeconds: {
	    one: '1 sekundo',
	    other: '{{count}} sekundoj'
	  },
	  halfAMinute: 'duonminuto',
	  lessThanXMinutes: {
	    one: 'malpli ol minuto',
	    other: 'malpli ol {{count}} minutoj'
	  },
	  xMinutes: {
	    one: '1 minuto',
	    other: '{{count}} minutoj'
	  },
	  aboutXHours: {
	    one: 'proksimume 1 horo',
	    other: 'proksimume {{count}} horoj'
	  },
	  xHours: {
	    one: '1 horo',
	    other: '{{count}} horoj'
	  },
	  xDays: {
	    one: '1 tago',
	    other: '{{count}} tagoj'
	  },
	  aboutXMonths: {
	    one: 'proksimume 1 monato',
	    other: 'proksimume {{count}} monatoj'
	  },
	  xWeeks: {
	    one: '1 semajno',
	    other: '{{count}} semajnoj'
	  },
	  aboutXWeeks: {
	    one: 'proksimume 1 semajno',
	    other: 'proksimume {{count}} semajnoj'
	  },
	  xMonths: {
	    one: '1 monato',
	    other: '{{count}} monatoj'
	  },
	  aboutXYears: {
	    one: 'proksimume 1 jaro',
	    other: 'proksimume {{count}} jaroj'
	  },
	  xYears: {
	    one: '1 jaro',
	    other: '{{count}} jaroj'
	  },
	  overXYears: {
	    one: 'pli ol 1 jaro',
	    other: 'pli ol {{count}} jaroj'
	  },
	  almostXYears: {
	    one: 'preskaŭ 1 jaro',
	    other: 'preskaŭ {{count}} jaroj'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'post ' + result;
	    } else {
	      return 'antaŭ ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, do 'de' MMMM y",
	  long: 'y-MMMM-dd',
	  medium: 'y-MMM-dd',
	  short: 'yyyy-MM-dd'
	};
	var timeFormats = {
	  full: "Ho 'horo kaj' m:ss zzzz",
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  any: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'any'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'pasinta' eeee 'je' p",
	  yesterday: "'hieraŭ je' p",
	  today: "'hodiaŭ je' p",
	  tomorrow: "'morgaŭ je' p",
	  nextWeek: "eeee 'je' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['aK', 'pK'],
	  abbreviated: ['a.K.E.', 'p.K.E.'],
	  wide: ['antaŭ Komuna Erao', 'Komuna Erao']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['K1', 'K2', 'K3', 'K4'],
	  wide: ['1-a kvaronjaro', '2-a kvaronjaro', '3-a kvaronjaro', '4-a kvaronjaro']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aŭg', 'sep', 'okt', 'nov', 'dec'],
	  wide: ['januaro', 'februaro', 'marto', 'aprilo', 'majo', 'junio', 'julio', 'aŭgusto', 'septembro', 'oktobro', 'novembro', 'decembro']
	};
	var dayValues = {
	  narrow: ['D', 'L', 'M', 'M', 'Ĵ', 'V', 'S'],
	  short: ['di', 'lu', 'ma', 'me', 'ĵa', 've', 'sa'],
	  abbreviated: ['dim', 'lun', 'mar', 'mer', 'ĵaŭ', 'ven', 'sab'],
	  wide: ['dimanĉo', 'lundo', 'mardo', 'merkredo', 'ĵaŭdo', 'vendredo', 'sabato']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'noktomezo',
	    noon: 'tagmezo',
	    morning: 'matene',
	    afternoon: 'posttagmeze',
	    evening: 'vespere',
	    night: 'nokte'
	  },
	  abbreviated: {
	    am: 'a.t.m.',
	    pm: 'p.t.m.',
	    midnight: 'noktomezo',
	    noon: 'tagmezo',
	    morning: 'matene',
	    afternoon: 'posttagmeze',
	    evening: 'vespere',
	    night: 'nokte'
	  },
	  wide: {
	    am: 'antaŭtagmeze',
	    pm: 'posttagmeze',
	    midnight: 'noktomezo',
	    noon: 'tagmezo',
	    morning: 'matene',
	    afternoon: 'posttagmeze',
	    evening: 'vespere',
	    night: 'nokte'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + '-a';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(-?a)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^([ap]k)/i,
	  abbreviated: /^([ap]\.?\s?k\.?\s?e\.?)/i,
	  wide: /^((antaǔ |post )?komuna erao)/i
	};
	var parseEraPatterns = {
	  any: [/^a/i, /^[kp]/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^k[1234]/i,
	  wide: /^[1234](-?a)? kvaronjaro/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|a(ŭ|ux|uh|u)g|sep|okt|nov|dec)/i,
	  wide: /^(januaro|februaro|marto|aprilo|majo|junio|julio|a(ŭ|ux|uh|u)gusto|septembro|oktobro|novembro|decembro)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^a(u|ŭ)/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[dlmĵjvs]/i,
	  short: /^(di|lu|ma|me|(ĵ|jx|jh|j)a|ve|sa)/i,
	  abbreviated: /^(dim|lun|mar|mer|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)|ven|sab)/i,
	  wide: /^(diman(ĉ|cx|ch|c)o|lundo|mardo|merkredo|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)do|vendredo|sabato)/i
	};
	var parseDayPatterns = {
	  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^(j|ĵ)/i, /^v/i, /^s/i],
	  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^(j|ĵ)/i, /^v/i, /^s/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^([ap]|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
	  abbreviated: /^([ap][.\s]?t[.\s]?m[.\s]?|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
	  wide: /^(anta(ŭ|ux)tagmez|posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo]/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^noktom/i,
	    noon: /^t/i,
	    morning: /^m/i,
	    afternoon: /^posttagmeze/i,
	    evening: /^v/i,
	    night: /^n/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1072));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1073));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1074));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1075));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1076));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Esperanto locale.
	 * @language Esperanto
	 * @iso-639-2 epo
	 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
	 */
	var locale = {
	  code: 'eo',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'menos de un segundo',
	    other: 'menos de {{count}} segundos'
	  },
	  xSeconds: {
	    one: '1 segundo',
	    other: '{{count}} segundos'
	  },
	  halfAMinute: 'medio minuto',
	  lessThanXMinutes: {
	    one: 'menos de un minuto',
	    other: 'menos de {{count}} minutos'
	  },
	  xMinutes: {
	    one: '1 minuto',
	    other: '{{count}} minutos'
	  },
	  aboutXHours: {
	    one: 'alrededor de 1 hora',
	    other: 'alrededor de {{count}} horas'
	  },
	  xHours: {
	    one: '1 hora',
	    other: '{{count}} horas'
	  },
	  xDays: {
	    one: '1 día',
	    other: '{{count}} días'
	  },
	  aboutXWeeks: {
	    one: 'alrededor de 1 semana',
	    other: 'alrededor de {{count}} semanas'
	  },
	  xWeeks: {
	    one: '1 semana',
	    other: '{{count}} semanas'
	  },
	  aboutXMonths: {
	    one: 'alrededor de 1 mes',
	    other: 'alrededor de {{count}} meses'
	  },
	  xMonths: {
	    one: '1 mes',
	    other: '{{count}} meses'
	  },
	  aboutXYears: {
	    one: 'alrededor de 1 año',
	    other: 'alrededor de {{count}} años'
	  },
	  xYears: {
	    one: '1 año',
	    other: '{{count}} años'
	  },
	  overXYears: {
	    one: 'más de 1 año',
	    other: 'más de {{count}} años'
	  },
	  almostXYears: {
	    one: 'casi 1 año',
	    other: 'casi {{count}} años'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'en ' + result;
	    } else {
	      return 'hace ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, d 'de' MMMM 'de' y",
	  long: "d 'de' MMMM 'de' y",
	  medium: 'd MMM y',
	  short: 'dd/MM/y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'a las' {{time}}",
	  long: "{{date}} 'a las' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'el' eeee 'pasado a la' LT",
	  yesterday: "'ayer a la' p",
	  today: "'hoy a la' p",
	  tomorrow: "'mañana a la' p",
	  nextWeek: "eeee 'a la' p",
	  other: 'P'
	};
	var formatRelativeLocalePlural = {
	  lastWeek: "'el' eeee 'pasado a las' p",
	  yesterday: "'ayer a las' p",
	  today: "'hoy a las' p",
	  tomorrow: "'mañana a las' p",
	  nextWeek: "eeee 'a las' p",
	  other: 'P'
	};
	
	function formatRelative(token, date, _baseDate, _options) {
	  if (date.getUTCHours() !== 1) {
	    return formatRelativeLocalePlural[token];
	  }
	
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['AC', 'DC'],
	  abbreviated: ['AC', 'DC'],
	  wide: ['antes de cristo', 'después de cristo']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['T1', 'T2', 'T3', 'T4'],
	  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
	};
	var monthValues = {
	  narrow: ['e', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
	  abbreviated: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
	  wide: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
	};
	var dayValues = {
	  narrow: ['d', 'l', 'm', 'm', 'j', 'v', 's'],
	  short: ['do', 'lu', 'ma', 'mi', 'ju', 'vi', 'sa'],
	  abbreviated: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
	  wide: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mn',
	    noon: 'md',
	    morning: 'mañana',
	    afternoon: 'tarde',
	    evening: 'tarde',
	    night: 'noche'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'medianoche',
	    noon: 'mediodia',
	    morning: 'mañana',
	    afternoon: 'tarde',
	    evening: 'tarde',
	    night: 'noche'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'medianoche',
	    noon: 'mediodia',
	    morning: 'mañana',
	    afternoon: 'tarde',
	    evening: 'tarde',
	    night: 'noche'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mn',
	    noon: 'md',
	    morning: 'de la mañana',
	    afternoon: 'de la tarde',
	    evening: 'de la tarde',
	    night: 'de la noche'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'medianoche',
	    noon: 'mediodia',
	    morning: 'de la mañana',
	    afternoon: 'de la tarde',
	    evening: 'de la tarde',
	    night: 'de la noche'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'medianoche',
	    noon: 'mediodia',
	    morning: 'de la mañana',
	    afternoon: 'de la tarde',
	    evening: 'de la tarde',
	    night: 'de la noche'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + 'º';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ac|dc|a|d)/i,
	  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
	  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
	};
	var parseEraPatterns = {
	  any: [/^ac/i, /^dc/i],
	  wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^T[1234]/i,
	  wide: /^[1234](º)? trimestre/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[efmajsond]/i,
	  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
	  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
	};
	var matchDayPatterns = {
	  narrow: /^[dlmjvs]/i,
	  short: /^(do|lu|ma|mi|ju|vi|sa)/i,
	  abbreviated: /^(dom|lun|mar|mie|jue|vie|sab)/i,
	  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
	};
	var parseDayPatterns = {
	  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
	  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
	  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mn/i,
	    noon: /^md/i,
	    morning: /mañana/i,
	    afternoon: /tarde/i,
	    evening: /tarde/i,
	    night: /noche/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1078));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1079));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1080));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1081));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1082));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Spanish locale.
	 * @language Spanish
	 * @iso-639-2 spa
	 * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
	 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
	 * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
	 * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
	 * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
	 */
	var locale = {
	  code: 'es',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    standalone: {
	      one: 'vähem kui üks sekund',
	      other: 'vähem kui {{count}} sekundit'
	    },
	    withPreposition: {
	      one: 'vähem kui ühe sekundi',
	      other: 'vähem kui {{count}} sekundi'
	    }
	  },
	  xSeconds: {
	    standalone: {
	      one: 'üks sekund',
	      other: '{{count}} sekundit'
	    },
	    withPreposition: {
	      one: 'ühe sekundi',
	      other: '{{count}} sekundi'
	    }
	  },
	  halfAMinute: {
	    standalone: 'pool minutit',
	    withPreposition: 'poole minuti'
	  },
	  lessThanXMinutes: {
	    standalone: {
	      one: 'vähem kui üks minut',
	      other: 'vähem kui {{count}} minutit'
	    },
	    withPreposition: {
	      one: 'vähem kui ühe minuti',
	      other: 'vähem kui {{count}} minuti'
	    }
	  },
	  xMinutes: {
	    standalone: {
	      one: 'üks minut',
	      other: '{{count}} minutit'
	    },
	    withPreposition: {
	      one: 'ühe minuti',
	      other: '{{count}} minuti'
	    }
	  },
	  aboutXHours: {
	    standalone: {
	      one: 'umbes üks tund',
	      other: 'umbes {{count}} tundi'
	    },
	    withPreposition: {
	      one: 'umbes ühe tunni',
	      other: 'umbes {{count}} tunni'
	    }
	  },
	  xHours: {
	    standalone: {
	      one: 'üks tund',
	      other: '{{count}} tundi'
	    },
	    withPreposition: {
	      one: 'ühe tunni',
	      other: '{{count}} tunni'
	    }
	  },
	  xDays: {
	    standalone: {
	      one: 'üks päev',
	      other: '{{count}} päeva'
	    },
	    withPreposition: {
	      one: 'ühe päeva',
	      other: '{{count}} päeva'
	    }
	  },
	  aboutXWeeks: {
	    standalone: {
	      one: 'umbes üks nädal',
	      other: 'umbes {{count}} nädalat'
	    },
	    withPreposition: {
	      one: 'umbes ühe nädala',
	      other: 'umbes {{count}} nädala'
	    }
	  },
	  xWeeks: {
	    standalone: {
	      one: 'üks nädal',
	      other: '{{count}} nädalat'
	    },
	    withPreposition: {
	      one: 'ühe nädala',
	      other: '{{count}} nädala'
	    }
	  },
	  aboutXMonths: {
	    standalone: {
	      one: 'umbes üks kuu',
	      other: 'umbes {{count}} kuud'
	    },
	    withPreposition: {
	      one: 'umbes ühe kuu',
	      other: 'umbes {{count}} kuu'
	    }
	  },
	  xMonths: {
	    standalone: {
	      one: 'üks kuu',
	      other: '{{count}} kuud'
	    },
	    withPreposition: {
	      one: 'ühe kuu',
	      other: '{{count}} kuu'
	    }
	  },
	  aboutXYears: {
	    standalone: {
	      one: 'umbes üks aasta',
	      other: 'umbes {{count}} aastat'
	    },
	    withPreposition: {
	      one: 'umbes ühe aasta',
	      other: 'umbes {{count}} aasta'
	    }
	  },
	  xYears: {
	    standalone: {
	      one: 'üks aasta',
	      other: '{{count}} aastat'
	    },
	    withPreposition: {
	      one: 'ühe aasta',
	      other: '{{count}} aasta'
	    }
	  },
	  overXYears: {
	    standalone: {
	      one: 'rohkem kui üks aasta',
	      other: 'rohkem kui {{count}} aastat'
	    },
	    withPreposition: {
	      one: 'rohkem kui ühe aasta',
	      other: 'rohkem kui {{count}} aasta'
	    }
	  },
	  almostXYears: {
	    standalone: {
	      one: 'peaaegu üks aasta',
	      other: 'peaaegu {{count}} aastat'
	    },
	    withPreposition: {
	      one: 'peaaegu ühe aasta',
	      other: 'peaaegu {{count}} aasta'
	    }
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var usageGroup = options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
	  var result;
	
	  if (typeof usageGroup === 'string') {
	    result = usageGroup;
	  } else if (count === 1) {
	    result = usageGroup.one;
	  } else {
	    result = usageGroup.other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result + ' pärast';
	    } else {
	      return result + ' eest';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'eeee, d. MMMM y',
	  long: 'd. MMMM y',
	  medium: 'd. MMM y',
	  short: 'dd.MM.y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'kell' {{time}}",
	  long: "{{date}} 'kell' {{time}}",
	  medium: '{{date}}. {{time}}',
	  short: '{{date}}. {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'eelmine' eeee 'kell' p",
	  yesterday: "'eile kell' p",
	  today: "'täna kell' p",
	  tomorrow: "'homme kell' p",
	  nextWeek: "'järgmine' eeee 'kell' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['e.m.a', 'm.a.j'],
	  abbreviated: ['e.m.a', 'm.a.j'],
	  wide: ['enne meie ajaarvamist', 'meie ajaarvamise järgi']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['K1', 'K2', 'K3', 'K4'],
	  wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
	};
	var monthValues = {
	  narrow: ['J', 'V', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['jaan', 'veebr', 'märts', 'apr', 'mai', 'juuni', 'juuli', 'aug', 'sept', 'okt', 'nov', 'dets'],
	  wide: ['jaanuar', 'veebruar', 'märts', 'aprill', 'mai', 'juuni', 'juuli', 'august', 'september', 'oktoober', 'november', 'detsember']
	};
	var dayValues = {
	  narrow: ['P', 'E', 'T', 'K', 'N', 'R', 'L'],
	  short: ['P', 'E', 'T', 'K', 'N', 'R', 'L'],
	  abbreviated: ['pühap.', 'esmasp.', 'teisip.', 'kolmap.', 'neljap.', 'reede.', 'laup.'],
	  wide: ['pühapäev', 'esmaspäev', 'teisipäev', 'kolmapäev', 'neljapäev', 'reede', 'laupäev']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'kesköö',
	    noon: 'keskpäev',
	    morning: 'hommik',
	    afternoon: 'pärastlõuna',
	    evening: 'õhtu',
	    night: 'öö'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'kesköö',
	    noon: 'keskpäev',
	    morning: 'hommik',
	    afternoon: 'pärastlõuna',
	    evening: 'õhtu',
	    night: 'öö'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'kesköö',
	    noon: 'keskpäev',
	    morning: 'hommik',
	    afternoon: 'pärastlõuna',
	    evening: 'õhtu',
	    night: 'öö'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'keskööl',
	    noon: 'keskpäeval',
	    morning: 'hommikul',
	    afternoon: 'pärastlõunal',
	    evening: 'õhtul',
	    night: 'öösel'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'keskööl',
	    noon: 'keskpäeval',
	    morning: 'hommikul',
	    afternoon: 'pärastlõunal',
	    evening: 'õhtul',
	    night: 'öösel'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'keskööl',
	    noon: 'keskpäeval',
	    morning: 'hommikul',
	    afternoon: 'pärastlõunal',
	    evening: 'õhtul',
	    night: 'öösel'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    formattingValues: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    formattingValues: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    formattingValues: formattingDayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^\d+\./i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
	  abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
	  wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
	};
	var parseEraPatterns = {
	  any: [/^e/i, /^(m|p)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^K[1234]/i,
	  wide: /^[1234](\.)? kvartal/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jvmasond]/i,
	  abbreviated: /^('jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets')/i,
	  wide: /^('jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember')/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^v/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^v/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[petknrl]/i,
	  short: /^[petknrl]/i,
	  abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
	  wide: /^('pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev')/i
	};
	var parseDayPatterns = {
	  any: [/^p/i, /^e/i, /^t/i, /^k/i, /^n/i, /^r/i, /^l/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(am|pm|kesköö|keskpäev|hommik|pärastlõuna|õhtu|öö)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^keskö/i,
	    noon: /^keskp/i,
	    morning: /hommik/i,
	    afternoon: /pärastlõuna/i,
	    evening: /õhtu/i,
	    night: /öö/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1084));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1085));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1086));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1087));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1088));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Estonian locale.
	 * @language Estonian
	 * @iso-639-2 est
	 * @author Priit Hansen [@HansenPriit]{@link https://github.com/priithansen}
	 */
	var locale = {
	  code: 'et',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'segundo bat baino gutxiago',
	    other: '{{count}} segundo baino gutxiago'
	  },
	  xSeconds: {
	    one: '1 segundo',
	    other: '{{count}} segundo'
	  },
	  halfAMinute: 'minutu erdi',
	  lessThanXMinutes: {
	    one: 'minutu bat baino gutxiago',
	    other: '{{count}} minutu baino gutxiago'
	  },
	  xMinutes: {
	    one: '1 minutu',
	    other: '{{count}} minutu'
	  },
	  aboutXHours: {
	    one: '1 ordu gutxi gorabehera',
	    other: '{{count}} ordu gutxi gorabehera'
	  },
	  xHours: {
	    one: '1 ordu',
	    other: '{{count}} ordu'
	  },
	  xDays: {
	    one: '1 egun',
	    other: '{{count}} egun'
	  },
	  aboutXWeeks: {
	    one: 'aste 1 inguru',
	    other: '{{count}} aste inguru'
	  },
	  xWeeks: {
	    one: '1 aste',
	    other: '{{count}} astean'
	  },
	  aboutXMonths: {
	    one: '1 hilabete gutxi gorabehera',
	    other: '{{count}} hilabete gutxi gorabehera'
	  },
	  xMonths: {
	    one: '1 hilabete',
	    other: '{{count}} hilabete'
	  },
	  aboutXYears: {
	    one: '1 urte gutxi gorabehera',
	    other: '{{count}} urte gutxi gorabehera'
	  },
	  xYears: {
	    one: '1 urte',
	    other: '{{count}} urte'
	  },
	  overXYears: {
	    one: '1 urte baino gehiago',
	    other: '{{count}} urte baino gehiago'
	  },
	  almostXYears: {
	    one: 'ia 1 urte',
	    other: 'ia {{count}} urte'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'en ' + result;
	    } else {
	      return 'duela ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, y'ko' MMMM'ren' d'a' y'ren'",
	  long: "y'ko' MMMM'ren' d'a'",
	  medium: 'y MMM d',
	  short: 'yy/MM/dd'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'tan' {{time}}",
	  long: "{{date}} 'tan' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'joan den' eeee, LT",
	  yesterday: "'atzo,' p",
	  today: "'gaur,' p",
	  tomorrow: "'bihar,' p",
	  nextWeek: 'eeee, p',
	  other: 'P'
	};
	var formatRelativeLocalePlural = {
	  lastWeek: "'joan den' eeee, p",
	  yesterday: "'atzo,' p",
	  today: "'gaur,' p",
	  tomorrow: "'bihar,' p",
	  nextWeek: 'eeee, p',
	  other: 'P'
	};
	
	function formatRelative(token, date, _baseDate, _options) {
	  if (date.getUTCHours() !== 1) {
	    return formatRelativeLocalePlural[token];
	  }
	
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['k.a.', 'k.o.'],
	  abbreviated: ['k.a.', 'k.o.'],
	  wide: ['kristo aurretik', 'kristo ondoren']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1H', '2H', '3H', '4H'],
	  wide: ['1. hiruhilekoa', '2. hiruhilekoa', '3. hiruhilekoa', '4. hiruhilekoa']
	};
	var monthValues = {
	  narrow: ['u', 'o', 'm', 'a', 'm', 'e', 'u', 'a', 'i', 'u', 'a', 'a'],
	  abbreviated: ['urt', 'ots', 'mar', 'api', 'mai', 'eka', 'uzt', 'abu', 'ira', 'urr', 'aza', 'abe'],
	  wide: ['urtarrila', 'otsaila', 'martxoa', 'apirila', 'maiatza', 'ekaina', 'uztaila', 'abuztua', 'iraila', 'urria', 'azaroa', 'abendua']
	};
	var dayValues = {
	  narrow: ['i', 'a', 'a', 'a', 'o', 'o', 'l'],
	  short: ['ig', 'al', 'as', 'az', 'og', 'or', 'lr'],
	  abbreviated: ['iga', 'ast', 'ast', 'ast', 'ost', 'ost', 'lar'],
	  wide: ['igandea', 'astelehena', 'asteartea', 'asteazkena', 'osteguna', 'ostirala', 'larunbata']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'ge',
	    noon: 'eg',
	    morning: 'goiza',
	    afternoon: 'arratsaldea',
	    evening: 'arratsaldea',
	    night: 'gaua'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'gauerdia',
	    noon: 'eguerdia',
	    morning: 'goiza',
	    afternoon: 'arratsaldea',
	    evening: 'arratsaldea',
	    night: 'gaua'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'gauerdia',
	    noon: 'eguerdia',
	    morning: 'goiza',
	    afternoon: 'arratsaldea',
	    evening: 'arratsaldea',
	    night: 'gaua'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'ge',
	    noon: 'eg',
	    morning: 'goizean',
	    afternoon: 'arratsaldean',
	    evening: 'arratsaldean',
	    night: 'gauean'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'gauerdia',
	    noon: 'eguerdia',
	    morning: 'goizean',
	    afternoon: 'arratsaldean',
	    evening: 'arratsaldean',
	    night: 'gauean'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'gauerdia',
	    noon: 'eguerdia',
	    morning: 'goizean',
	    afternoon: 'arratsaldean',
	    evening: 'arratsaldean',
	    night: 'gauean'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(.)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(k.a.|k.o.)/i,
	  abbreviated: /^(k.a.|k.o.)/i,
	  wide: /^(kristo aurretik|kristo ondoren)/i
	};
	var parseEraPatterns = {
	  narrow: [/^k.a./i, /^k.o./i],
	  abbreviated: [/^(k.a.)/i, /^(k.o.)/i],
	  wide: [/^(kristo aurretik)/i, /^(kristo ondoren)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234]H/i,
	  wide: /^[1234](.)? hiruhilekoa/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[uomaei]/i,
	  abbreviated: /^(urt|ots|mar|api|mai|eka|uzt|abu|ira|urr|aza|abe)/i,
	  wide: /^(urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^u/i, /^o/i, /^m/i, /^a/i, /^m/i, /^e/i, /^u/i, /^a/i, /^i/i, /^u/i, /^a/i, /^a/i],
	  any: [/^urt/i, /^ots/i, /^mar/i, /^api/i, /^mai/i, /^eka/i, /^uzt/i, /^abu/i, /^ira/i, /^urr/i, /^aza/i, /^abe/i]
	};
	var matchDayPatterns = {
	  narrow: /^[iaol]/i,
	  short: /^(ig|al|as|az|og|or|lr)/i,
	  abbreviated: /^(iga|ast|ast|ast|ost|ost|lar)/i,
	  wide: /^(igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata)/i
	};
	var parseDayPatterns = {
	  narrow: [/^i/i, /^a/i, /^a/i, /^a/i, /^o/i, /^o/i, /^l/i],
	  short: [/^ig/i, /^al/i, /^as/i, /^az/i, /^og/i, /^or/i, /^lr/i],
	  abbreviated: [/^iga/i, /^ast/i, /^ast/i, /^ast/i, /^ost/i, /^ost/i, /^lar/i],
	  wide: [/^igandea/i, /^astelehena/i, /^asteartea/i, /^asteazkena/i, /^osteguna/i, /^ostirala/i, /^larunbata/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|ge|eg|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i,
	  any: /^([ap]\.?\s?m\.?|gauerdia|eguerdia|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i
	};
	var parseDayPeriodPatterns = {
	  narrow: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^ge/i,
	    noon: /^eg/i,
	    morning: /goiz/i,
	    afternoon: /arratsaldea/i,
	    evening: /arratsaldea/i,
	    night: /gau/i
	  },
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^gauerdia/i,
	    noon: /^eguerdia/i,
	    morning: /goiz/i,
	    afternoon: /arratsaldea/i,
	    evening: /arratsaldea/i,
	    night: /gau/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1090));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1091));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1092));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1093));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1094));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Basque locale.
	 * @language Basque
	 * @iso-639-2 eus
	 * @author Jacob Söderblom [@JacobSoderblom]{@link https://github.com/JacobSoderblom}
	 */
	var locale = {
	  code: 'eu',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'کمتر از یک ثانیه',
	    other: 'کمتر از {{count}} ثانیه'
	  },
	  xSeconds: {
	    one: '1 ثانیه',
	    other: '{{count}} ثانیه'
	  },
	  halfAMinute: 'نیم دقیقه',
	  lessThanXMinutes: {
	    one: 'کمتر از یک دقیقه',
	    other: 'کمتر از {{count}} دقیقه'
	  },
	  xMinutes: {
	    one: '1 دقیقه',
	    other: '{{count}} دقیقه'
	  },
	  aboutXHours: {
	    one: 'حدود 1 ساعت',
	    other: 'حدود {{count}} ساعت'
	  },
	  xHours: {
	    one: '1 ساعت',
	    other: '{{count}} ساعت'
	  },
	  xDays: {
	    one: '1 روز',
	    other: '{{count}} روز'
	  },
	  aboutXWeeks: {
	    one: 'حدود 1 هفته',
	    other: 'حدود {{count}} هفته'
	  },
	  xWeeks: {
	    one: '1 هفته',
	    other: '{{count}} هفته'
	  },
	  aboutXMonths: {
	    one: 'حدود 1 ماه',
	    other: 'حدود {{count}} ماه'
	  },
	  xMonths: {
	    one: '1 ماه',
	    other: '{{count}} ماه'
	  },
	  aboutXYears: {
	    one: 'حدود 1 سال',
	    other: 'حدود {{count}} سال'
	  },
	  xYears: {
	    one: '1 سال',
	    other: '{{count}} سال'
	  },
	  overXYears: {
	    one: 'بیشتر از 1 سال',
	    other: 'بیشتر از {{count}} سال'
	  },
	  almostXYears: {
	    one: 'نزدیک 1 سال',
	    other: 'نزدیک {{count}} سال'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'در ' + result;
	    } else {
	      return result + ' قبل';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE do MMMM y',
	  long: 'do MMMM y',
	  medium: 'd MMM y',
	  short: 'yyyy/MM/dd'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'در' {{time}}",
	  long: "{{date}} 'در' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'گذشته در' p",
	  yesterday: "'دیروز در' p",
	  today: "'امروز در' p",
	  tomorrow: "'فردا در' p",
	  nextWeek: "eeee 'در' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['ق', 'ب'],
	  abbreviated: ['ق.م.', 'ب.م.'],
	  wide: ['قبل از میلاد', 'بعد از میلاد']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['س‌م1', 'س‌م2', 'س‌م3', 'س‌م4'],
	  wide: ['سه‌ماهه 1', 'سه‌ماهه 2', 'سه‌ماهه 3', 'سه‌ماهه 4']
	}; // Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['ژ', 'ف', 'م', 'آ', 'م', 'ج', 'ج', 'آ', 'س', 'ا', 'ن', 'د'],
	  abbreviated: ['ژانـ', 'فور', 'مارس', 'آپر', 'می', 'جون', 'جولـ', 'آگو', 'سپتـ', 'اکتـ', 'نوامـ', 'دسامـ'],
	  wide: ['ژانویه', 'فوریه', 'مارس', 'آپریل', 'می', 'جون', 'جولای', 'آگوست', 'سپتامبر', 'اکتبر', 'نوامبر', 'دسامبر']
	};
	var dayValues = {
	  narrow: ['ی', 'د', 'س', 'چ', 'پ', 'ج', 'ش'],
	  short: ['1ش', '2ش', '3ش', '4ش', '5ش', 'ج', 'ش'],
	  abbreviated: ['یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه', 'شنبه'],
	  wide: ['یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه', 'شنبه']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ق',
	    pm: 'ب',
	    midnight: 'ن',
	    noon: 'ظ',
	    morning: 'ص',
	    afternoon: 'ب.ظ.',
	    evening: 'ع',
	    night: 'ش'
	  },
	  abbreviated: {
	    am: 'ق.ظ.',
	    pm: 'ب.ظ.',
	    midnight: 'نیمه‌شب',
	    noon: 'ظهر',
	    morning: 'صبح',
	    afternoon: 'بعدازظهر',
	    evening: 'عصر',
	    night: 'شب'
	  },
	  wide: {
	    am: 'قبل‌ازظهر',
	    pm: 'بعدازظهر',
	    midnight: 'نیمه‌شب',
	    noon: 'ظهر',
	    morning: 'صبح',
	    afternoon: 'بعدازظهر',
	    evening: 'عصر',
	    night: 'شب'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ق',
	    pm: 'ب',
	    midnight: 'ن',
	    noon: 'ظ',
	    morning: 'ص',
	    afternoon: 'ب.ظ.',
	    evening: 'ع',
	    night: 'ش'
	  },
	  abbreviated: {
	    am: 'ق.ظ.',
	    pm: 'ب.ظ.',
	    midnight: 'نیمه‌شب',
	    noon: 'ظهر',
	    morning: 'صبح',
	    afternoon: 'بعدازظهر',
	    evening: 'عصر',
	    night: 'شب'
	  },
	  wide: {
	    am: 'قبل‌ازظهر',
	    pm: 'بعدازظهر',
	    midnight: 'نیمه‌شب',
	    noon: 'ظهر',
	    morning: 'صبح',
	    afternoon: 'بعدازظهر',
	    evening: 'عصر',
	    night: 'شب'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  return String(dirtyNumber);
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ق|ب)/i,
	  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?د\.?\s?م\.?|م\.?\s?|د\.?\s?م\.?)/i,
	  wide: /^(قبل از میلاد|قبل از دوران مشترک|میلادی|دوران مشترک|بعد از میلاد)/i
	};
	var parseEraPatterns = {
	  any: [/^قبل/i, /^بعد/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^س‌م[1234]/i,
	  wide: /^سه‌ماهه [1234]/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[جژفمآاماسند]/i,
	  abbreviated: /^(جنو|ژانـ|ژانویه|فوریه|فور|مارس|آوریل|آپر|مه|می|ژوئن|جون|جول|جولـ|ژوئیه|اوت|آگو|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نوامـ|دسامبر|دسامـ|دسم)/i,
	  wide: /^(ژانویه|جنوری|فبروری|فوریه|مارچ|مارس|آپریل|اپریل|ایپریل|آوریل|مه|می|ژوئن|جون|جولای|ژوئیه|آگست|اگست|آگوست|اوت|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نومبر|دسامبر|دسمبر)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^(ژ|ج)/i, /^ف/i, /^م/i, /^(آ|ا)/i, /^م/i, /^(ژ|ج)/i, /^(ج|ژ)/i, /^(آ|ا)/i, /^س/i, /^ا/i, /^ن/i, /^د/i],
	  any: [/^ژا/i, /^ف/i, /^ما/i, /^آپ/i, /^(می|مه)/i, /^(ژوئن|جون)/i, /^(ژوئی|جول)/i, /^(اوت|آگ)/i, /^س/i, /^(اوک|اک)/i, /^ن/i, /^د/i]
	};
	var matchDayPatterns = {
	  narrow: /^[شیدسچپج]/i,
	  short: /^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
	  abbreviated: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
	  wide: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i
	};
	var parseDayPatterns = {
	  narrow: [/^ی/i, /^دو/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i],
	  any: [/^(ی|1ش|یکشنبه)/i, /^(د|2ش|دوشنبه)/i, /^(س|3ش|سه‌شنبه)/i, /^(چ|4ش|چهارشنبه)/i, /^(پ|5ش|پنجشنبه)/i, /^(ج|جمعه)/i, /^(ش|شنبه)/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
	  abbreviated: /^(ق.ظ.|ب.ظ.|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i,
	  wide: /^(قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^(ق|ق.ظ.|قبل‌ازظهر)/i,
	    pm: /^(ب|ب.ظ.|بعدازظهر)/i,
	    midnight: /^(‌نیمه‌شب|ن)/i,
	    noon: /^(ظ|ظهر)/i,
	    morning: /(ص|صبح)/i,
	    afternoon: /(ب|ب.ظ.|بعدازظهر)/i,
	    evening: /(ع|عصر)/i,
	    night: /(ش|شب)/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1096));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1097));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1098));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1099));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1100));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Persian/Farsi locale (Iran).
	 * @language Persian
	 * @iso-639-2 ira
	 * @author Morteza Ziyae [@mort3za]{@link https://github.com/mort3za}
	 */
	var locale = {
	  code: 'fa-IR',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 6
	    /* Saturday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	
	function futureSeconds(text) {
	  return text.replace(/sekuntia?/, 'sekunnin');
	}
	
	function futureMinutes(text) {
	  return text.replace(/minuuttia?/, 'minuutin');
	}
	
	function futureHours(text) {
	  return text.replace(/tuntia?/, 'tunnin');
	}
	
	function futureDays(text) {
	  return text.replace(/päivää?/, 'päivän');
	}
	
	function futureWeeks(text) {
	  return text.replace(/(viikko|viikkoa)/, 'viikon');
	}
	
	function futureMonths(text) {
	  return text.replace(/(kuukausi|kuukautta)/, 'kuukauden');
	}
	
	function futureYears(text) {
	  return text.replace(/(vuosi|vuotta)/, 'vuoden');
	}
	
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'alle sekunti',
	    other: 'alle {{count}} sekuntia',
	    futureTense: futureSeconds
	  },
	  xSeconds: {
	    one: 'sekunti',
	    other: '{{count}} sekuntia',
	    futureTense: futureSeconds
	  },
	  halfAMinute: {
	    one: 'puoli minuuttia',
	    other: 'puoli minuuttia',
	    futureTense: function (_text) {
	      return 'puolen minuutin';
	    }
	  },
	  lessThanXMinutes: {
	    one: 'alle minuutti',
	    other: 'alle {{count}} minuuttia',
	    futureTense: futureMinutes
	  },
	  xMinutes: {
	    one: 'minuutti',
	    other: '{{count}} minuuttia',
	    futureTense: futureMinutes
	  },
	  aboutXHours: {
	    one: 'noin tunti',
	    other: 'noin {{count}} tuntia',
	    futureTense: futureHours
	  },
	  xHours: {
	    one: 'tunti',
	    other: '{{count}} tuntia',
	    futureTense: futureHours
	  },
	  xDays: {
	    one: 'päivä',
	    other: '{{count}} päivää',
	    futureTense: futureDays
	  },
	  aboutXWeeks: {
	    one: 'noin viikko',
	    other: 'noin {{count}} viikkoa',
	    futureTense: futureWeeks
	  },
	  xWeeks: {
	    one: 'viikko',
	    other: '{{count}} viikkoa',
	    futureTense: futureWeeks
	  },
	  aboutXMonths: {
	    one: 'noin kuukausi',
	    other: 'noin {{count}} kuukautta',
	    futureTense: futureMonths
	  },
	  xMonths: {
	    one: 'kuukausi',
	    other: '{{count}} kuukautta',
	    futureTense: futureMonths
	  },
	  aboutXYears: {
	    one: 'noin vuosi',
	    other: 'noin {{count}} vuotta',
	    futureTense: futureYears
	  },
	  xYears: {
	    one: 'vuosi',
	    other: '{{count}} vuotta',
	    futureTense: futureYears
	  },
	  overXYears: {
	    one: 'yli vuosi',
	    other: 'yli {{count}} vuotta',
	    futureTense: futureYears
	  },
	  almostXYears: {
	    one: 'lähes vuosi',
	    other: 'lähes {{count}} vuotta',
	    futureTense: futureYears
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var distance = formatDistanceLocale[token];
	  var result = count === 1 ? distance.one : distance.other.replace('{{count}}', count);
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return distance.futureTense(result) + ' kuluttua';
	    } else {
	      return result + ' sitten';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'eeee d. MMMM y',
	  long: 'd. MMMM y',
	  medium: 'd. MMM y',
	  short: 'd.M.y'
	};
	var timeFormats = {
	  full: 'HH.mm.ss zzzz',
	  long: 'HH.mm.ss z',
	  medium: 'HH.mm.ss',
	  short: 'HH.mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'klo' {{time}}",
	  long: "{{date}} 'klo' {{time}}",
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'viime' eeee 'klo' p",
	  yesterday: "'eilen klo' p",
	  today: "'tänään klo' p",
	  tomorrow: "'huomenna klo' p",
	  nextWeek: "'ensi' eeee 'klo' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['eaa.', 'jaa.'],
	  abbreviated: ['eaa.', 'jaa.'],
	  wide: ['ennen ajanlaskun alkua', 'jälkeen ajanlaskun alun']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1. kvartaali', '2. kvartaali', '3. kvartaali', '4. kvartaali']
	};
	var monthValues = {
	  narrow: ['T', 'H', 'M', 'H', 'T', 'K', 'H', 'E', 'S', 'L', 'M', 'J'],
	  abbreviated: ['tammi', 'helmi', 'maalis', 'huhti', 'touko', 'kesä', 'heinä', 'elo', 'syys', 'loka', 'marras', 'joulu'],
	  wide: ['tammikuu', 'helmikuu', 'maaliskuu', 'huhtikuu', 'toukokuu', 'kesäkuu', 'heinäkuu', 'elokuu', 'syyskuu', 'lokakuu', 'marraskuu', 'joulukuu']
	};
	var formattingMonthValues = {
	  narrow: monthValues.narrow,
	  abbreviated: monthValues.abbreviated,
	  wide: monthValues.wide.map(function (name) {
	    return name + 'ta';
	  })
	};
	var dayValues = {
	  narrow: ['S', 'M', 'T', 'K', 'T', 'P', 'L'],
	  short: ['su', 'ma', 'ti', 'ke', 'to', 'pe', 'la'],
	  abbreviated: ['sunn.', 'maan.', 'tiis.', 'kesk.', 'torst.', 'perj.', 'la'],
	  wide: ['sunnuntai', 'maanantai', 'tiistai', 'keskiviikko', 'torstai', 'perjantai', 'lauantai']
	};
	var formattingDayValues = {
	  narrow: dayValues.narrow,
	  short: dayValues.short,
	  abbreviated: dayValues.abbreviated,
	  wide: dayValues.wide.map(function (name) {
	    return name + 'na';
	  })
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ap',
	    pm: 'ip',
	    midnight: 'keskiyö',
	    noon: 'keskipäivä',
	    morning: 'ap',
	    afternoon: 'ip',
	    evening: 'illalla',
	    night: 'yöllä'
	  },
	  abbreviated: {
	    am: 'ap',
	    pm: 'ip',
	    midnight: 'keskiyö',
	    noon: 'keskipäivä',
	    morning: 'ap',
	    afternoon: 'ip',
	    evening: 'illalla',
	    night: 'yöllä'
	  },
	  wide: {
	    am: 'ap',
	    pm: 'ip',
	    midnight: 'keskiyöllä',
	    noon: 'keskipäivällä',
	    morning: 'aamupäivällä',
	    afternoon: 'iltapäivällä',
	    evening: 'illalla',
	    night: 'yöllä'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    formattingValues: formattingMonthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    formattingValues: formattingDayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(\.)/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(e|j)/i,
	  abbreviated: /^(eaa.|jaa.)/i,
	  wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
	};
	var parseEraPatterns = {
	  any: [/^e/i, /^j/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234]\.? kvartaali/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[thmkeslj]/i,
	  abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
	  wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
	};
	var parseMonthPatterns = {
	  narrow: [/^t/i, /^h/i, /^m/i, /^h/i, /^t/i, /^k/i, /^h/i, /^e/i, /^s/i, /^l/i, /^m/i, /^j/i],
	  any: [/^ta/i, /^hel/i, /^maa/i, /^hu/i, /^to/i, /^k/i, /^hei/i, /^e/i, /^s/i, /^l/i, /^mar/i, /^j/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smtkpl]/i,
	  short: /^(su|ma|ti|ke|to|pe|la)/i,
	  abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
	  wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^m/i, /^t/i, /^k/i, /^t/i, /^p/i, /^l/i],
	  any: [/^s/i, /^m/i, /^ti/i, /^k/i, /^to/i, /^p/i, /^l/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
	  any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^ap/i,
	    pm: /^ip/i,
	    midnight: /^keskiyö/i,
	    noon: /^keskipäivä/i,
	    morning: /aamupäivällä/i,
	    afternoon: /iltapäivällä/i,
	    evening: /illalla/i,
	    night: /yöllä/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1102));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1103));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1104));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1105));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1106));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Finnish locale.
	 * @language Finnish
	 * @iso-639-2 fin
	 * @author Pyry-Samuli Lahti [@Pyppe]{@link https://github.com/Pyppe}
	 * @author Edo Rivai [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
	 * @author Samu Juvonen [@sjuvonen]{@link https://github.com/sjuvonen}
	 */
	var locale = {
	  code: 'fi',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE d MMMM y',
	  long: 'd MMMM y',
	  medium: 'd MMM y',
	  short: 'yy-MM-dd'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'à' {{time}}",
	  long: "{{date}} 'à' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(328));
	
	var _index2 = _interopRequireDefault(__webpack_require__(329));
	
	var _index3 = _interopRequireDefault(__webpack_require__(330));
	
	var _index4 = _interopRequireDefault(__webpack_require__(331));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1108));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Same as fr
	// Unique for fr-CA
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary French locale (Canada).
	 * @language French
	 * @iso-639-2 fra
	 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
	 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
	 * @author Gabriele Petrioli [@gpetrioli]{@link https://github.com/gpetrioli}
	 */
	var locale = {
	  code: 'fr-CA',
	  formatDistance: _index.default,
	  formatLong: _index5.default,
	  formatRelative: _index2.default,
	  localize: _index3.default,
	  match: _index4.default,
	  // Unique for fr-CA
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'moins d’une seconde',
	    other: 'moins de {{count}} secondes'
	  },
	  xSeconds: {
	    one: '1 seconde',
	    other: '{{count}} secondes'
	  },
	  halfAMinute: '30 secondes',
	  lessThanXMinutes: {
	    one: 'moins d’une minute',
	    other: 'moins de {{count}} minutes'
	  },
	  xMinutes: {
	    one: '1 minute',
	    other: '{{count}} minutes'
	  },
	  aboutXHours: {
	    one: 'environ 1 heure',
	    other: 'environ {{count}} heures'
	  },
	  xHours: {
	    one: '1 heure',
	    other: '{{count}} heures'
	  },
	  xDays: {
	    one: '1 jour',
	    other: '{{count}} jours'
	  },
	  aboutXWeeks: {
	    one: 'environ 1 semaine',
	    other: 'environ {{count}} semaines'
	  },
	  xWeeks: {
	    one: '1 semaine',
	    other: '{{count}} semaines'
	  },
	  aboutXMonths: {
	    one: 'environ 1 mois',
	    other: 'environ {{count}} mois'
	  },
	  xMonths: {
	    one: '1 mois',
	    other: '{{count}} mois'
	  },
	  aboutXYears: {
	    one: 'environ 1 an',
	    other: 'environ {{count}} ans'
	  },
	  xYears: {
	    one: '1 an',
	    other: '{{count}} ans'
	  },
	  overXYears: {
	    one: 'plus d’un an',
	    other: 'plus de {{count}} ans'
	  },
	  almostXYears: {
	    one: 'presqu’un an',
	    other: 'presque {{count}} ans'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'dans ' + result;
	    } else {
	      return 'il y a ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE d MMMM y',
	  long: 'd MMMM y',
	  medium: 'd MMM y',
	  short: 'dd.MM.y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'à' {{time}}",
	  long: "{{date}} 'à' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'la semaine dernière à' p",
	  yesterday: "'hier à' p",
	  today: "'aujourd’hui à' p",
	  tomorrow: "'demain à' p'",
	  nextWeek: "eeee 'la semaine prochaine à' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['av. J.-C', 'ap. J.-C'],
	  abbreviated: ['av. J.-C', 'ap. J.-C'],
	  wide: ['avant Jésus-Christ', 'après Jésus-Christ']
	};
	var quarterValues = {
	  narrow: ['T1', 'T2', 'T3', 'T4'],
	  abbreviated: ['1er trim.', '2ème trim.', '3ème trim.', '4ème trim.'],
	  wide: ['1er trimestre', '2ème trimestre', '3ème trimestre', '4ème trimestre']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
	  wide: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']
	};
	var dayValues = {
	  narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
	  short: ['di', 'lu', 'ma', 'me', 'je', 've', 'sa'],
	  abbreviated: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
	  wide: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'minuit',
	    noon: 'midi',
	    morning: 'mat.',
	    afternoon: 'ap.m.',
	    evening: 'soir',
	    night: 'mat.'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'minuit',
	    noon: 'midi',
	    morning: 'matin',
	    afternoon: 'après-midi',
	    evening: 'soir',
	    night: 'matin'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'minuit',
	    noon: 'midi',
	    morning: 'du matin',
	    afternoon: 'de l’après-midi',
	    evening: 'du soir',
	    night: 'du matin'
	  }
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var number = Number(dirtyNumber);
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	  var suffix;
	
	  if (number === 0) {
	    return number;
	  }
	
	  if (unit === 'year' || unit === 'hour' || unit === 'week') {
	    if (number === 1) {
	      suffix = 'ère';
	    } else {
	      suffix = 'ème';
	    }
	  } else {
	    if (number === 1) {
	      suffix = 'er';
	    } else {
	      suffix = 'ème';
	    }
	  }
	
	  return number + suffix;
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
	  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
	  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
	};
	var parseEraPatterns = {
	  any: [/^av/i, /^ap/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^t[1234]/i,
	  wide: /^[1234](er|ème|e)? trimestre/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
	  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[lmjvsd]/i,
	  short: /^(di|lu|ma|me|je|ve|sa)/i,
	  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
	  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
	};
	var parseDayPatterns = {
	  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
	  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
	  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^min/i,
	    noon: /^mid/i,
	    morning: /mat/i,
	    afternoon: /ap/i,
	    evening: /soir/i,
	    night: /nuit/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1110));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1111));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1112));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1113));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1114));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary French locale.
	 * @language French
	 * @iso-639-2 fra
	 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
	 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
	 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
	 * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
	 */
	var locale = {
	  code: 'fr-CH',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE d MMMM y',
	  long: 'd MMMM y',
	  medium: 'd MMM y',
	  short: 'dd/MM/y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'à' {{time}}",
	  long: "{{date}} 'à' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(328));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1116));
	
	var _index3 = _interopRequireDefault(__webpack_require__(329));
	
	var _index4 = _interopRequireDefault(__webpack_require__(330));
	
	var _index5 = _interopRequireDefault(__webpack_require__(331));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary French locale.
	 * @language French
	 * @iso-639-2 fra
	 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
	 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
	 */
	var locale = {
	  code: 'fr',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'nas lugha na diog',
	    other: 'nas lugha na {{count}} diogan'
	  },
	  xSeconds: {
	    one: '1 diog',
	    two: '2 dhiog',
	    twenty: '20 diog',
	    other: '{{count}} diogan'
	  },
	  halfAMinute: 'leth mhionaid',
	  lessThanXMinutes: {
	    one: 'nas lugha na mionaid',
	    other: 'nas lugha na {{count}} mionaidean'
	  },
	  xMinutes: {
	    one: '1 mionaid',
	    two: '2 mhionaid',
	    twenty: '20 mionaid',
	    other: '{{count}} mionaidean'
	  },
	  aboutXHours: {
	    one: 'mu uair de thìde',
	    other: 'mu {{count}} uairean de thìde'
	  },
	  xHours: {
	    one: '1 uair de thìde',
	    two: '2 uair de thìde',
	    twenty: '20 uair de thìde',
	    other: '{{count}} uairean de thìde'
	  },
	  xDays: {
	    one: '1 là',
	    other: '{{count}} là'
	  },
	  aboutXWeeks: {
	    one: 'mu 1 seachdain',
	    other: 'mu {{count}} seachdainean'
	  },
	  xWeeks: {
	    one: '1 seachdain',
	    other: '{{count}} seachdainean'
	  },
	  aboutXMonths: {
	    one: 'mu mhìos',
	    other: 'mu {{count}} mìosan'
	  },
	  xMonths: {
	    one: '1 mìos',
	    other: '{{count}} mìosan'
	  },
	  aboutXYears: {
	    one: 'mu bhliadhna',
	    other: 'mu {{count}} bliadhnaichean'
	  },
	  xYears: {
	    one: '1 bhliadhna',
	    other: '{{count}} bliadhna'
	  },
	  overXYears: {
	    one: 'còrr is bliadhna',
	    other: 'còrr is {{count}} bliadhnaichean'
	  },
	  almostXYears: {
	    one: 'cha mhòr bliadhna',
	    other: 'cha mhòr {{count}} bliadhnaichean'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else if (count === 2 && !!formatDistanceLocale[token].two) {
	    result = formatDistanceLocale[token].two;
	  } else if (count === 9 && !!formatDistanceLocale[token].nine) {
	    result = formatDistanceLocale[token].nine;
	  } else if (count === 20 && !!formatDistanceLocale[token].twenty) {
	    result = formatDistanceLocale[token].twenty;
	  } else if (count === 30 && !!formatDistanceLocale[token].thirty) {
	    result = formatDistanceLocale[token].thirty;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'ann an ' + result;
	    } else {
	      return 'o chionn ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, MMMM do, y',
	  long: 'MMMM do, y',
	  medium: 'MMM d, y',
	  short: 'MM/dd/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'aig' {{time}}",
	  long: "{{date}} 'aig' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'mu dheireadh' eeee 'aig' p",
	  //FIX
	  yesterday: "'an-dè aig' p",
	  today: "'an-diugh aig' p",
	  tomorrow: "'a-màireach aig' p",
	  nextWeek: "eeee 'aig' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['R', 'A'],
	  abbreviated: ['RC', 'AD'],
	  wide: ['ro Chrìosta', 'anno domini']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['C1', 'C2', 'C3', 'C4'],
	  wide: ["a' chiad chairteal", 'an dàrna cairteal', 'an treas cairteal', 'an ceathramh cairteal']
	}; // Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['F', 'G', 'M', 'G', 'C', 'Ò', 'I', 'L', 'S', 'D', 'S', 'D'],
	  abbreviated: ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'],
	  wide: ['Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd']
	};
	var dayValues = {
	  narrow: ['D', 'L', 'M', 'C', 'A', 'H', 'S'],
	  short: ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'],
	  abbreviated: ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	  wide: ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'm',
	    pm: 'f',
	    midnight: 'm.o.',
	    noon: 'm.l.',
	    morning: 'madainn',
	    afternoon: 'feasgar',
	    evening: 'feasgar',
	    night: 'oidhche'
	  },
	  abbreviated: {
	    am: 'M.',
	    pm: 'F.',
	    midnight: 'meadhan oidhche',
	    noon: 'meadhan là',
	    morning: 'madainn',
	    afternoon: 'feasgar',
	    evening: 'feasgar',
	    night: 'oidhche'
	  },
	  wide: {
	    am: 'm.',
	    pm: 'f.',
	    midnight: 'meadhan oidhche',
	    noon: 'meadhan là',
	    morning: 'madainn',
	    afternoon: 'feasgar',
	    evening: 'feasgar',
	    night: 'oidhche'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'm',
	    pm: 'f',
	    midnight: 'm.o.',
	    noon: 'm.l.',
	    morning: 'sa mhadainn',
	    afternoon: 'feasgar',
	    evening: 'feasgar',
	    night: 'air an oidhche'
	  },
	  abbreviated: {
	    am: 'M.',
	    pm: 'F.',
	    midnight: 'meadhan oidhche',
	    noon: 'meadhan là',
	    morning: 'sa mhadainn',
	    afternoon: 'feasgar',
	    evening: 'feasgar',
	    night: 'air an oidhche'
	  },
	  wide: {
	    am: 'm.',
	    pm: 'f.',
	    midnight: 'meadhan oidhche',
	    noon: 'meadhan là',
	    morning: 'sa mhadainn',
	    afternoon: 'feasgar',
	    evening: 'feasgar',
	    night: 'air an oidhche'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	
	  var rem100 = number % 100;
	
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + 'd';
	
	      case 2:
	        return number + 'na';
	    }
	  }
	
	  if (rem100 === 12) {
	    return number + 'na';
	  }
	
	  return number + 'mh';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(d|na|tr|mh)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(r|a)/i,
	  abbreviated: /^(r\.?\s?c\.?|r\.?\s?a\.?\s?c\.?|a\.?\s?d\.?|a\.?\s?c\.?)/i,
	  wide: /^(ro Chrìosta|ron aois choitchinn|anno domini|aois choitcheann)/i
	};
	var parseEraPatterns = {
	  any: [/^b/i, /^(a|c)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^c[1234]/i,
	  wide: /^[1234](cd|na|tr|mh)? cairteal/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[fgmcòilsd]/i,
	  abbreviated: /^(faoi|gear|màrt|gibl|cèit|ògmh|iuch|lùn|sult|dàmh|samh|dùbh)/i,
	  wide: /^(am faoilleach|an gearran|am màrt|an giblean|an cèitean|an t-Ògmhios|an t-Iuchar|an lùnastal|an t-Sultain|an dàmhair|an t-Samhain|an dùbhlachd)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^f/i, /^g/i, /^m/i, /^g/i, /^c/i, /^ò/i, /^i/i, /^l/i, /^s/i, /^d/i, /^s/i, /^d/i],
	  any: [/^fa/i, /^ge/i, /^mà/i, /^gi/i, /^c/i, /^ò/i, /^i/i, /^l/i, /^su/i, /^d/i, /^sa/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[dlmcahs]/i,
	  short: /^(dò|lu|mà|ci|ar|ha|sa)/i,
	  abbreviated: /^(did|dil|dim|dic|dia|dih|dis)/i,
	  wide: /^(didòmhnaich|diluain|dimàirt|diciadain|diardaoin|dihaoine|disathairne)/i
	};
	var parseDayPatterns = {
	  narrow: [/^d/i, /^l/i, /^m/i, /^c/i, /^a/i, /^h/i, /^s/i],
	  any: [/^d/i, /^l/i, /^m/i, /^c/i, /^a/i, /^h/i, /^s/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mi|n|(san|aig) (madainn|feasgar|feasgar|oidhche))/i,
	  any: /^([ap]\.?\s?m\.?|meadhan oidhche|meadhan là|(san|aig) (madainn|feasgar|feasgar|oidhche))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^m/i,
	    pm: /^f/i,
	    midnight: /^meadhan oidhche/i,
	    noon: /^meadhan là/i,
	    morning: /sa mhadainn/i,
	    afternoon: /feasgar/i,
	    evening: /feasgar/i,
	    night: /air an oidhche/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1118));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1119));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1120));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1121));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1122));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Scottish Gaelic.
	 * @language Scottish Gaelic
	 * @iso-639-2 gla
	 * @author Lee Driscoll [@leedriscoll]{@link https://github.com/leedriscoll}
	 */
	var locale = {
	  code: 'gd',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1124 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'menos dun segundo',
	    other: 'menos de {{count}} segundos'
	  },
	  xSeconds: {
	    one: '1 segundo',
	    other: '{{count}} segundos'
	  },
	  halfAMinute: 'medio minuto',
	  lessThanXMinutes: {
	    one: 'menos dun minuto',
	    other: 'menos de {{count}} minutos'
	  },
	  xMinutes: {
	    one: '1 minuto',
	    other: '{{count}} minutos'
	  },
	  aboutXHours: {
	    one: 'arredor dunha hora',
	    other: 'arredor de {{count}} horas'
	  },
	  xHours: {
	    one: '1 hora',
	    other: '{{count}} horas'
	  },
	  xDays: {
	    one: '1 día',
	    other: '{{count}} días'
	  },
	  aboutXWeeks: {
	    one: 'arredor dunha semana',
	    other: 'arredor de {{count}} semanas'
	  },
	  xWeeks: {
	    one: '1 semana',
	    other: '{{count}} semanas'
	  },
	  aboutXMonths: {
	    one: 'arredor de 1 mes',
	    other: 'arredor de {{count}} meses'
	  },
	  xMonths: {
	    one: '1 mes',
	    other: '{{count}} meses'
	  },
	  aboutXYears: {
	    one: 'arredor dun ano',
	    other: 'arredor de {{count}} anos'
	  },
	  xYears: {
	    one: '1 ano',
	    other: '{{count}} anos'
	  },
	  overXYears: {
	    one: 'máis dun ano',
	    other: 'máis de {{count}} anos'
	  },
	  almostXYears: {
	    one: 'case un ano',
	    other: 'case {{count}} anos'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'en ' + result;
	    } else {
	      return 'hai ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, d 'de' MMMM y",
	  long: "d 'de' MMMM y",
	  medium: 'd MMM y',
	  short: 'dd/MM/y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'ás' {{time}}",
	  long: "{{date}} 'ás' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'o' eeee 'pasado á' LT",
	  yesterday: "'onte á' p",
	  today: "'hoxe á' p",
	  tomorrow: "'mañá á' p",
	  nextWeek: "eeee 'á' p",
	  other: 'P'
	};
	var formatRelativeLocalePlural = {
	  lastWeek: "'o' eeee 'pasado ás' p",
	  yesterday: "'onte ás' p",
	  today: "'hoxe ás' p",
	  tomorrow: "'mañá ás' p",
	  nextWeek: "eeee 'ás' p",
	  other: 'P'
	};
	
	function formatRelative(token, date, _baseDate, _options) {
	  if (date.getUTCHours() !== 1) {
	    return formatRelativeLocalePlural[token];
	  }
	
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['AC', 'DC'],
	  abbreviated: ['AC', 'DC'],
	  wide: ['antes de cristo', 'despois de cristo']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['T1', 'T2', 'T3', 'T4'],
	  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
	};
	var monthValues = {
	  narrow: ['e', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
	  abbreviated: ['xan', 'feb', 'mar', 'abr', 'mai', 'xun', 'xul', 'ago', 'set', 'out', 'nov', 'dec'],
	  wide: ['xaneiro', 'febreiro', 'marzo', 'abril', 'maio', 'xuño', 'xullo', 'agosto', 'setembro', 'outubro', 'novembro', 'decembro']
	};
	var dayValues = {
	  narrow: ['d', 'l', 'm', 'm', 'j', 'v', 's'],
	  short: ['do', 'lu', 'ma', 'me', 'xo', 've', 'sa'],
	  abbreviated: ['dom', 'lun', 'mar', 'mer', 'xov', 'ven', 'sab'],
	  wide: ['domingo', 'luns', 'martes', 'mércores', 'xoves', 'venres', 'sábado']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mn',
	    noon: 'md',
	    morning: 'mañá',
	    afternoon: 'tarde',
	    evening: 'tarde',
	    night: 'noite'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'medianoite',
	    noon: 'mediodía',
	    morning: 'mañá',
	    afternoon: 'tarde',
	    evening: 'tardiña',
	    night: 'noite'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'medianoite',
	    noon: 'mediodía',
	    morning: 'mañá',
	    afternoon: 'tarde',
	    evening: 'tardiña',
	    night: 'noite'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mn',
	    noon: 'md',
	    morning: 'da mañá',
	    afternoon: 'da tarde',
	    evening: 'da tardiña',
	    night: 'da noite'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'medianoite',
	    noon: 'mediodía',
	    morning: 'da mañá',
	    afternoon: 'da tarde',
	    evening: 'da tardiña',
	    night: 'da noite'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'medianoite',
	    noon: 'mediodía',
	    morning: 'da mañá',
	    afternoon: 'da tarde',
	    evening: 'da tardiña',
	    night: 'da noite'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + 'º';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ac|dc|a|d)/i,
	  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
	  wide: /^(antes de cristo|antes da era com[uú]n|despois de cristo|era com[uú]n)/i
	};
	var parseEraPatterns = {
	  any: [/^ac/i, /^dc/i],
	  wide: [/^(antes de cristo|antes da era com[uú]n)/i, /^(despois de cristo|era com[uú]n)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^T[1234]/i,
	  wide: /^[1234](º)? trimestre/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[xfmasond]/i,
	  abbreviated: /^(xan|feb|mar|abr|mai|xun|xul|ago|set|out|nov|dec)/i,
	  wide: /^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^x/i, /^f/i, /^m/i, /^a/i, /^m/i, /^x/i, /^x/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^xan/i, /^feb/i, /^mar/i, /^abr/i, /^mai/i, /^xun/i, /^xul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dec/i]
	};
	var matchDayPatterns = {
	  narrow: /^[dlmxvs]/i,
	  short: /^(do|lu|ma|me|xo|ve|sa)/i,
	  abbreviated: /^(dom|lun|mar|mer|xov|ven|sab)/i,
	  wide: /^(domingo|luns|martes|m[eé]rcores|xoves|venres|s[áa]bado)/i
	};
	var parseDayPatterns = {
	  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^x/i, /^v/i, /^s/i],
	  any: [/^do/i, /^lu/i, /^ma/i, /^me/i, /^xo/i, /^ve/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mn|md|(da|[aá]s) (mañ[aá]|tarde|noite))/i,
	  any: /^([ap]\.?\s?m\.?|medianoite|mediod[ií]a|(da|[aá]s) (mañ[aá]|tarde|noite))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mn/i,
	    noon: /^md/i,
	    morning: /mañ[aá]/i,
	    afternoon: /tarde/i,
	    evening: /tardiña/i,
	    night: /noite/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1124));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1125));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1126));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1127));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1128));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Galician locale.
	 * @language Galician
	 * @iso-639-2 glg
	 * @author Alberto Doval - Cocodin Technology[@cocodinTech]{@link https://github.com/cocodinTech}
	 * @author Fidel Pita [@fidelpita]{@link https://github.com/fidelpita}
	 */
	var locale = {
	  code: 'gl',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1130 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'હમણાં',
	    // CLDR #1461
	    other: '​આશરે {{count}} સેકંડ'
	  },
	  xSeconds: {
	    one: '1 સેકંડ',
	    other: '{{count}} સેકંડ'
	  },
	  halfAMinute: 'અડધી મિનિટ',
	  lessThanXMinutes: {
	    one: 'આ મિનિટ',
	    // CLDR #1448
	    other: '​આશરે {{count}} મિનિટ'
	  },
	  xMinutes: {
	    one: '1 મિનિટ',
	    other: '{{count}} મિનિટ'
	  },
	  aboutXHours: {
	    one: '​આશરે 1 કલાક',
	    other: '​આશરે {{count}} કલાક'
	  },
	  xHours: {
	    one: '1 કલાક',
	    other: '{{count}} કલાક'
	  },
	  xDays: {
	    one: '1 દિવસ',
	    other: '{{count}} દિવસ'
	  },
	  aboutXWeeks: {
	    one: 'આશરે 1 અઠવાડિયું',
	    other: 'આશરે {{count}} અઠવાડિયા'
	  },
	  xWeeks: {
	    one: '1 અઠવાડિયું',
	    other: '{{count}} અઠવાડિયા'
	  },
	  aboutXMonths: {
	    one: 'આશરે 1 મહિનો',
	    other: 'આશરે {{count}} મહિના'
	  },
	  xMonths: {
	    one: '1 મહિનો',
	    other: '{{count}} મહિના'
	  },
	  aboutXYears: {
	    one: 'આશરે 1 વર્ષ',
	    other: 'આશરે {{count}} વર્ષ'
	  },
	  xYears: {
	    one: '1 વર્ષ',
	    other: '{{count}} વર્ષ'
	  },
	  overXYears: {
	    one: '1 વર્ષથી વધુ',
	    other: '{{count}} વર્ષથી વધુ'
	  },
	  almostXYears: {
	    one: 'લગભગ 1 વર્ષ',
	    other: 'લગભગ {{count}} વર્ષ'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result + 'માં';
	    } else {
	      return result + ' પહેલાં';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
	var dateFormats = {
	  full: 'EEEE, d MMMM, y',
	  // CLDR #1825
	  long: 'd MMMM, y',
	  // CLDR #1826
	  medium: 'd MMM, y',
	  // CLDR #1827
	  short: 'd/M/yy' // CLDR #1828
	
	};
	var timeFormats = {
	  full: 'hh:mm:ss a zzzz',
	  // CLDR #1829
	  long: 'hh:mm:ss a z',
	  // CLDR #1830
	  medium: 'hh:mm:ss a',
	  // CLDR #1831
	  short: 'hh:mm a' // CLDR #1832
	
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  // CLDR #1833
	  long: '{{date}} {{time}}',
	  // CLDR #1834
	  medium: '{{date}} {{time}}',
	  // CLDR #1835
	  short: '{{date}} {{time}}' // CLDR #1836
	
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1132 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
	var formatRelativeLocale = {
	  lastWeek: "'પાછલા' eeee p",
	  // CLDR #1384
	  yesterday: "'ગઈકાલે' p",
	  // CLDR #1409
	  today: "'આજે' p",
	  // CLDR #1410
	  tomorrow: "'આવતીકાલે' p",
	  // CLDR #1411
	  nextWeek: 'eeee p',
	  // CLDR #1386
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// https://www.unicode.org/cldr/charts/32/summary/gu.html
	// #1621 - #1630
	var eraValues = {
	  narrow: ['ઈસપૂ', 'ઈસ'],
	  abbreviated: ['ઈ.સ.પૂર્વે', 'ઈ.સ.'],
	  wide: ['ઈસવીસન પૂર્વે', 'ઈસવીસન']
	}; // https://www.unicode.org/cldr/charts/32/summary/gu.html
	// #1631 - #1654
	
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1લો ત્રિમાસ', '2જો ત્રિમાસ', '3જો ત્રિમાસ', '4થો ત્રિમાસ']
	}; // Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	// https://www.unicode.org/cldr/charts/32/summary/gu.html
	// #1655 - #1726
	
	var monthValues = {
	  narrow: ['જા', 'ફે', 'મા', 'એ', 'મે', 'જૂ', 'જુ', 'ઓ', 'સ', 'ઓ', 'ન', 'ડિ'],
	  abbreviated: ['જાન્યુ', 'ફેબ્રુ', 'માર્ચ', 'એપ્રિલ', 'મે', 'જૂન', 'જુલાઈ', 'ઑગસ્ટ', 'સપ્ટે', 'ઓક્ટો', 'નવે', 'ડિસે'],
	  wide: ['જાન્યુઆરી', 'ફેબ્રુઆરી', 'માર્ચ', 'એપ્રિલ', 'મે', 'જૂન', 'જુલાઇ', 'ઓગસ્ટ', 'સપ્ટેમ્બર', 'ઓક્ટોબર', 'નવેમ્બર', 'ડિસેમ્બર']
	}; // https://www.unicode.org/cldr/charts/32/summary/gu.html
	// #1727 - #1768
	
	var dayValues = {
	  narrow: ['ર', 'સો', 'મં', 'બુ', 'ગુ', 'શુ', 'શ'],
	  short: ['ર', 'સો', 'મં', 'બુ', 'ગુ', 'શુ', 'શ'],
	  abbreviated: ['રવિ', 'સોમ', 'મંગળ', 'બુધ', 'ગુરુ', 'શુક્ર', 'શનિ'],
	  wide: ['રવિવાર'
	  /* Sunday */
	  , 'સોમવાર'
	  /* Monday */
	  , 'મંગળવાર'
	  /* Tuesday */
	  , 'બુધવાર'
	  /* Wednesday */
	  , 'ગુરુવાર'
	  /* Thursday */
	  , 'શુક્રવાર'
	  /* Friday */
	  , 'શનિવાર'
	  /* Saturday */
	  ]
	}; // https://www.unicode.org/cldr/charts/32/summary/gu.html
	// #1783 - #1824
	
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'મ.રાત્રિ',
	    noon: 'બ.',
	    morning: 'સવારે',
	    afternoon: 'બપોરે',
	    evening: 'સાંજે',
	    night: 'રાત્રે'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: '​મધ્યરાત્રિ',
	    noon: 'બપોરે',
	    morning: 'સવારે',
	    afternoon: 'બપોરે',
	    evening: 'સાંજે',
	    night: 'રાત્રે'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: '​મધ્યરાત્રિ',
	    noon: 'બપોરે',
	    morning: 'સવારે',
	    afternoon: 'બપોરે',
	    evening: 'સાંજે',
	    night: 'રાત્રે'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'મ.રાત્રિ',
	    noon: 'બપોરે',
	    morning: 'સવારે',
	    afternoon: 'બપોરે',
	    evening: 'સાંજે',
	    night: 'રાત્રે'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'મધ્યરાત્રિ',
	    noon: 'બપોરે',
	    morning: 'સવારે',
	    afternoon: 'બપોરે',
	    evening: 'સાંજે',
	    night: 'રાત્રે'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: '​મધ્યરાત્રિ',
	    noon: 'બપોરે',
	    morning: 'સવારે',
	    afternoon: 'બપોરે',
	    evening: 'સાંજે',
	    night: 'રાત્રે'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber);
	  return number;
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(લ|જ|થ|ઠ્ઠ|મ)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ઈસપૂ|ઈસ)/i,
	  abbreviated: /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i,
	  wide: /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i
	};
	var parseEraPatterns = {
	  any: [/^(ઈસપૂ|ઈસ)/i, /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i, /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](લો|જો|થો)? ત્રિમાસ/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  // eslint-disable-next-line no-misleading-character-class
	  narrow: /^[જાફેમાએમેજૂજુઓસઓનડિ]/i,
	  abbreviated: /^(જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઓક્ટો|નવે|ડિસે)/i,
	  wide: /^(જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઇ|ઓગસ્ટ|સપ્ટેમ્બર|ઓક્ટોબર|નવેમ્બર|ડિસેમ્બર)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^જા/i, /^ફે/i, /^મા/i, /^એ/i, /^મે/i, /^જૂ/i, /^જુ/i, /^ઑગ/i, /^સ/i, /^ઓક્ટો/i, /^ન/i, /^ડિ/i],
	  any: [/^જા/i, /^ફે/i, /^મા/i, /^એ/i, /^મે/i, /^જૂ/i, /^જુ/i, /^ઑગ/i, /^સ/i, /^ઓક્ટો/i, /^ન/i, /^ડિ/i]
	};
	var matchDayPatterns = {
	  narrow: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
	  short: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
	  abbreviated: /^(રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ)/i,
	  wide: /^(રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર)/i
	};
	var parseDayPatterns = {
	  narrow: [/^ર/i, /^સો/i, /^મં/i, /^બુ/i, /^ગુ/i, /^શુ/i, /^શ/i],
	  any: [/^ર/i, /^સો/i, /^મં/i, /^બુ/i, /^ગુ/i, /^શુ/i, /^શ/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|મ\.?|સ|બ|સાં|રા)/i,
	  any: /^(a|p|મ\.?|સ|બ|સાં|રા)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^મ\.?/i,
	    noon: /^બ/i,
	    morning: /સ/i,
	    afternoon: /બ/i,
	    evening: /સાં/i,
	    night: /રા/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1130));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1131));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1132));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1133));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1134));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Gujarati locale (India).
	 * @language Gujarati
	 * @iso-639-2 guj
	 * @author Manaday Mavani [@ManadayM]{@link https://github.com/manadaym}
	 */
	var locale = {
	  code: 'gu',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'פחות משנייה',
	    two: 'פחות משתי שניות',
	    other: 'פחות מ־{{count}} שניות'
	  },
	  xSeconds: {
	    one: 'שנייה',
	    two: 'שתי שניות',
	    other: '{{count}} שניות'
	  },
	  halfAMinute: 'חצי דקה',
	  lessThanXMinutes: {
	    one: 'פחות מדקה',
	    two: 'פחות משתי דקות',
	    other: 'פחות מ־{{count}} דקות'
	  },
	  xMinutes: {
	    one: 'דקה',
	    two: 'שתי דקות',
	    other: '{{count}} דקות'
	  },
	  aboutXHours: {
	    one: 'כשעה',
	    two: 'כשעתיים',
	    other: 'כ־{{count}} שעות'
	  },
	  xHours: {
	    one: 'שעה',
	    two: 'שעתיים',
	    other: '{{count}} שעות'
	  },
	  xDays: {
	    one: 'יום',
	    two: 'יומיים',
	    other: '{{count}} ימים'
	  },
	  aboutXWeeks: {
	    one: 'כשבוע',
	    two: 'כשבועיים',
	    other: 'כ־{{count}} שבועות'
	  },
	  xWeeks: {
	    one: 'שבוע',
	    two: 'שבועיים',
	    other: '{{count}} שבועות'
	  },
	  aboutXMonths: {
	    one: 'כחודש',
	    two: 'כחודשיים',
	    other: 'כ־{{count}} חודשים'
	  },
	  xMonths: {
	    one: 'חודש',
	    two: 'חודשיים',
	    other: '{{count}} חודשים'
	  },
	  aboutXYears: {
	    one: 'כשנה',
	    two: 'כשנתיים',
	    other: 'כ־{{count}} שנים'
	  },
	  xYears: {
	    one: 'שנה',
	    two: 'שנתיים',
	    other: '{{count}} שנים'
	  },
	  overXYears: {
	    one: 'יותר משנה',
	    two: 'יותר משנתיים',
	    other: 'יותר מ־{{count}} שנים'
	  },
	  almostXYears: {
	    one: 'כמעט שנה',
	    two: 'כמעט שנתיים',
	    other: 'כמעט {{count}} שנים'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {}; // Return word instead of `in one day` or `one day ago`
	
	  if (token === 'xDays' && options.addSuffix && count <= 2) {
	    var past = {
	      1: 'אתמול',
	      2: 'שלשום'
	    };
	    var future = {
	      1: 'מחר',
	      2: 'מחרתיים'
	    };
	    return options.comparison > 0 ? future[count] : past[count];
	  }
	
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else if (count === 2) {
	    result = formatDistanceLocale[token].two;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'בעוד ' + result;
	    } else {
	      return 'לפני ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d בMMMM y',
	  long: 'd בMMMM y',
	  medium: 'd בMMM y',
	  short: 'd.M.y'
	};
	var timeFormats = {
	  full: 'H:mm:ss zzzz',
	  long: 'H:mm:ss z',
	  medium: 'H:mm:ss',
	  short: 'H:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'בשעה' {{time}}",
	  long: "{{date}} 'בשעה' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1138 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'שעבר בשעה' p",
	  yesterday: "'אתמול בשעה' p",
	  today: "'היום בשעה' p",
	  tomorrow: "'מחר בשעה' p",
	  nextWeek: "eeee 'בשעה' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['לפנה״ס', 'לספירה'],
	  abbreviated: ['לפנה״ס', 'לספירה'],
	  wide: ['לפני הספירה', 'לספירה']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['רבעון 1', 'רבעון 2', 'רבעון 3', 'רבעון 4']
	};
	var monthValues = {
	  narrow: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
	  abbreviated: ['ינו׳', 'פבר׳', 'מרץ', 'אפר׳', 'מאי', 'יוני', 'יולי', 'אוג׳', 'ספט׳', 'אוק׳', 'נוב׳', 'דצמ׳'],
	  wide: ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר']
	};
	var dayValues = {
	  narrow: ['א׳', 'ב׳', 'ג׳', 'ד׳', 'ה׳', 'ו׳', 'ש׳'],
	  short: ['א׳', 'ב׳', 'ג׳', 'ד׳', 'ה׳', 'ו׳', 'ש׳'],
	  abbreviated: ['יום א׳', 'יום ב׳', 'יום ג׳', 'יום ד׳', 'יום ה׳', 'יום ו׳', 'שבת'],
	  wide: ['יום ראשון', 'יום שני', 'יום שלישי', 'יום רביעי', 'יום חמישי', 'יום שישי', 'יום שבת']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'לפנה״צ',
	    pm: 'אחה״צ',
	    midnight: 'חצות',
	    noon: 'צהריים',
	    morning: 'בוקר',
	    afternoon: 'אחר הצהריים',
	    evening: 'ערב',
	    night: 'לילה'
	  },
	  abbreviated: {
	    am: 'לפנה״צ',
	    pm: 'אחה״צ',
	    midnight: 'חצות',
	    noon: 'צהריים',
	    morning: 'בוקר',
	    afternoon: 'אחר הצהריים',
	    evening: 'ערב',
	    night: 'לילה'
	  },
	  wide: {
	    am: 'לפנה״צ',
	    pm: 'אחה״צ',
	    midnight: 'חצות',
	    noon: 'צהריים',
	    morning: 'בוקר',
	    afternoon: 'אחר הצהריים',
	    evening: 'ערב',
	    night: 'לילה'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'לפנה״צ',
	    pm: 'אחה״צ',
	    midnight: 'חצות',
	    noon: 'צהריים',
	    morning: 'בבוקר',
	    afternoon: 'בצהריים',
	    evening: 'בערב',
	    night: 'בלילה'
	  },
	  abbreviated: {
	    am: 'לפנה״צ',
	    pm: 'אחה״צ',
	    midnight: 'חצות',
	    noon: 'צהריים',
	    morning: 'בבוקר',
	    afternoon: 'אחר הצהריים',
	    evening: 'בערב',
	    night: 'בלילה'
	  },
	  wide: {
	    am: 'לפנה״צ',
	    pm: 'אחה״צ',
	    midnight: 'חצות',
	    noon: 'צהריים',
	    morning: 'בבוקר',
	    afternoon: 'אחר הצהריים',
	    evening: 'בערב',
	    night: 'בלילה'
	  }
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var number = Number(dirtyNumber); // We only show words till 10
	
	  if (number <= 0 || number > 10) return number;
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	  var isFemale = ['year', 'hour', 'minute', 'second'].indexOf(unit) >= 0;
	  var male = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שביעי', 'שמיני', 'תשיעי', 'עשירי'];
	  var female = ['ראשונה', 'שנייה', 'שלישית', 'רביעית', 'חמישית', 'שישית', 'שביעית', 'שמינית', 'תשיעית', 'עשירית'];
	  var index = number - 1;
	  return isFemale ? female[index] : male[index];
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+|(ראשון|שני|שלישי|רביעי|חמישי|שישי|שביעי|שמיני|תשיעי|עשירי|ראשונה|שנייה|שלישית|רביעית|חמישית|שישית|שביעית|שמינית|תשיעית|עשירית))/i;
	var parseOrdinalNumberPattern = /^(\d+|רא|שנ|של|רב|ח|שי|שב|שמ|ת|ע)/i;
	var matchEraPatterns = {
	  narrow: /^ל(ספירה|פנה״ס)/i,
	  abbreviated: /^ל(ספירה|פנה״ס)/i,
	  wide: /^ל(פני ה)?ספירה/i
	};
	var parseEraPatterns = {
	  any: [/^לפ/i, /^לס/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^רבעון [1234]/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^\d+/i,
	  abbreviated: /^(ינו|פבר|מרץ|אפר|מאי|יוני|יולי|אוג|ספט|אוק|נוב|דצמ)׳?/i,
	  wide: /^(ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^1$/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^7/i, /^8/i, /^9/i, /^10/i, /^11/i, /^12/i],
	  any: [/^ינ/i, /^פ/i, /^מר/i, /^אפ/i, /^מא/i, /^יונ/i, /^יול/i, /^אוג/i, /^ס/i, /^אוק/i, /^נ/i, /^ד/i]
	};
	var matchDayPatterns = {
	  narrow: /^[אבגדהוש]׳/i,
	  short: /^[אבגדהוש]׳/i,
	  abbreviated: /^(שבת|יום (א|ב|ג|ד|ה|ו)׳)/i,
	  wide: /^יום (ראשון|שני|שלישי|רביעי|חמישי|שישי|שבת)/i
	};
	var parseDayPatterns = {
	  abbreviated: [/א׳$/i, /ב׳$/i, /ג׳$/i, /ד׳$/i, /ה׳$/i, /ו׳$/i, /^ש/i],
	  wide: [/ן$/i, /ני$/i, /לישי$/i, /עי$/i, /מישי$/i, /שישי$/i, /ת$/i],
	  any: [/^א/i, /^ב/i, /^ג/i, /^ד/i, /^ה/i, /^ו/i, /^ש/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(אחר ה|ב)?(חצות|צהריים|בוקר|ערב|לילה|אחה״צ|לפנה״צ)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^לפ/i,
	    pm: /^אחה/i,
	    midnight: /^ח/i,
	    noon: /^צ/i,
	    morning: /בוקר/i,
	    afternoon: /בצ|אחר/i,
	    evening: /ערב/i,
	    night: /לילה/i
	  }
	};
	var ordinalName = ['רא', 'שנ', 'של', 'רב', 'ח', 'שי', 'שב', 'שמ', 'ת', 'ע'];
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      var number = parseInt(value, 10);
	      return isNaN(number) ? ordinalName.indexOf(value) + 1 : number;
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1136));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1137));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1138));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1139));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1140));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Hebrew locale.
	 * @language Hebrew
	 * @iso-639-2 heb
	 * @author Nir Lahad [@nirlah]{@link https://github.com/nirlah}
	 */
	var locale = {
	  code: 'he',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	
	var _index = _interopRequireDefault(__webpack_require__(211));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Source: https://www.unicode.org/cldr/charts/32/summary/hi.html
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: '१ सेकंड से कम',
	    // CLDR #1310
	    other: '{{count}} सेकंड से कम'
	  },
	  xSeconds: {
	    one: '१ सेकंड',
	    other: '{{count}} सेकंड'
	  },
	  halfAMinute: 'आधा मिनट',
	  lessThanXMinutes: {
	    one: '१ मिनट से कम',
	    other: '{{count}} मिनट से कम'
	  },
	  xMinutes: {
	    one: '१ मिनट',
	    // CLDR #1307
	    other: '{{count}} मिनट'
	  },
	  aboutXHours: {
	    one: 'लगभग १ घंटा',
	    other: 'लगभग {{count}} घंटे'
	  },
	  xHours: {
	    one: '१ घंटा',
	    // CLDR #1304
	    other: '{{count}} घंटे' // CLDR #4467
	
	  },
	  xDays: {
	    one: '१ दिन',
	    // CLDR #1286
	    other: '{{count}} दिन'
	  },
	  aboutXWeeks: {
	    one: 'लगभग १ सप्ताह',
	    other: 'लगभग {{count}} सप्ताह'
	  },
	  xWeeks: {
	    one: '१ सप्ताह',
	    other: '{{count}} सप्ताह'
	  },
	  aboutXMonths: {
	    one: 'लगभग १ महीना',
	    other: 'लगभग {{count}} महीने'
	  },
	  xMonths: {
	    one: '१ महीना',
	    other: '{{count}} महीने'
	  },
	  aboutXYears: {
	    one: 'लगभग १ वर्ष',
	    other: 'लगभग {{count}} वर्ष' // CLDR #4823
	
	  },
	  xYears: {
	    one: '१ वर्ष',
	    other: '{{count}} वर्ष'
	  },
	  overXYears: {
	    one: '१ वर्ष से अधिक',
	    other: '{{count}} वर्ष से अधिक'
	  },
	  almostXYears: {
	    one: 'लगभग १ वर्ष',
	    other: 'लगभग {{count}} वर्ष'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', _index.default.numberToLocale(count));
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result + 'मे ';
	    } else {
	      return result + ' पहले';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, do MMMM, y',
	  // CLDR #1787
	  long: 'do MMMM, y',
	  // CLDR #1788
	  medium: 'd MMM, y',
	  // CLDR #1789
	  short: 'dd/MM/yyyy' // CLDR #1790
	
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  // CLDR #1791
	  long: 'h:mm:ss a z',
	  // CLDR #1792
	  medium: 'h:mm:ss a',
	  // CLDR #1793
	  short: 'h:mm a' // CLDR #1794
	
	};
	var dateTimeFormats = {
	  full: "{{date}} 'को' {{time}}",
	  // CLDR #1795
	  long: "{{date}} 'को' {{time}}",
	  // CLDR #1796
	  medium: '{{date}}, {{time}}',
	  // CLDR #1797
	  short: '{{date}}, {{time}}' // CLDR #1798
	
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'पिछले' eeee p",
	  yesterday: "'कल' p",
	  today: "'आज' p",
	  tomorrow: "'कल' p",
	  nextWeek: "eeee 'को' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	var _index3 = _interopRequireDefault(__webpack_require__(211));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
	var parseOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
	var matchEraPatterns = {
	  narrow: /^(ईसा-पूर्व|ईस्वी)/i,
	  abbreviated: /^(ईसा\.?\s?पूर्व\.?|ईसा\.?)/i,
	  wide: /^(ईसा-पूर्व|ईसवी पूर्व|ईसवी सन|ईसवी)/i
	};
	var parseEraPatterns = {
	  any: [/^b/i, /^(a|c)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^ति[1234]/i,
	  wide: /^[1234](पहली|दूसरी|तीसरी|चौथी)? तिमाही/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  // eslint-disable-next-line no-misleading-character-class
	  narrow: /^[जफ़माअप्मईजूनजुअगसिअक्तनदि]/i,
	  abbreviated: /^(जन|फ़र|मार्च|अप्|मई|जून|जुल|अग|सित|अक्तू|नव|दिस)/i,
	  wide: /^(जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^ज/i, /^फ़/i, /^मा/i, /^अप्/i, /^मई/i, /^जू/i, /^जु/i, /^अग/i, /^सि/i, /^अक्तू/i, /^न/i, /^दि/i],
	  any: [/^जन/i, /^फ़/i, /^मा/i, /^अप्/i, /^मई/i, /^जू/i, /^जु/i, /^अग/i, /^सि/i, /^अक्तू/i, /^नव/i, /^दिस/i]
	};
	var matchDayPatterns = {
	  // eslint-disable-next-line no-misleading-character-class
	  narrow: /^[रविसोममंगलबुधगुरुशुक्रशनि]/i,
	  short: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
	  abbreviated: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
	  wide: /^(रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार)/i
	};
	var parseDayPatterns = {
	  narrow: [/^रवि/i, /^सोम/i, /^मंगल/i, /^बुध/i, /^गुरु/i, /^शुक्र/i, /^शनि/i],
	  any: [/^रवि/i, /^सोम/i, /^मंगल/i, /^बुध/i, /^गुरु/i, /^शुक्र/i, /^शनि/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(पू|अ|म|द.\?|सु|दो|शा|रा)/i,
	  any: /^(पूर्वाह्न|अपराह्न|म|द.\?|सु|दो|शा|रा)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^पूर्वाह्न/i,
	    pm: /^अपराह्न/i,
	    midnight: /^मध्य/i,
	    noon: /^दो/i,
	    morning: /सु/i,
	    afternoon: /दो/i,
	    evening: /शा/i,
	    night: /रा/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: _index3.default.localeToNumber
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1142));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1143));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1144));
	
	var _index4 = _interopRequireDefault(__webpack_require__(211));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1145));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Hindi locale (India).
	 * @language Hindi
	 * @iso-639-2 hin
	 * @author Mukesh Mandiwal [@mukeshmandiwal]{@link https://github.com/mukeshmandiwal}
	 */
	var locale = {
	  code: 'hi',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: {
	      standalone: 'manje od 1 sekunde',
	      withPrepositionAgo: 'manje od 1 sekunde',
	      withPrepositionIn: 'manje od 1 sekundu'
	    },
	    dual: 'manje od {{count}} sekunde',
	    other: 'manje od {{count}} sekundi'
	  },
	  xSeconds: {
	    one: {
	      standalone: '1 sekunda',
	      withPrepositionAgo: '1 sekunde',
	      withPrepositionIn: '1 sekundu'
	    },
	    dual: '{{count}} sekunde',
	    other: '{{count}} sekundi'
	  },
	  halfAMinute: 'pola minute',
	  lessThanXMinutes: {
	    one: {
	      standalone: 'manje od 1 minute',
	      withPrepositionAgo: 'manje od 1 minute',
	      withPrepositionIn: 'manje od 1 minutu'
	    },
	    dual: 'manje od {{count}} minute',
	    other: 'manje od {{count}} minuta'
	  },
	  xMinutes: {
	    one: {
	      standalone: '1 minuta',
	      withPrepositionAgo: '1 minute',
	      withPrepositionIn: '1 minutu'
	    },
	    dual: '{{count}} minute',
	    other: '{{count}} minuta'
	  },
	  aboutXHours: {
	    one: {
	      standalone: 'oko 1 sat',
	      withPrepositionAgo: 'oko 1 sat',
	      withPrepositionIn: 'oko 1 sat'
	    },
	    dual: 'oko {{count}} sata',
	    other: 'oko {{count}} sati'
	  },
	  xHours: {
	    one: {
	      standalone: '1 sat',
	      withPrepositionAgo: '1 sat',
	      withPrepositionIn: '1 sat'
	    },
	    dual: '{{count}} sata',
	    other: '{{count}} sati'
	  },
	  xDays: {
	    one: {
	      standalone: '1 dan',
	      withPrepositionAgo: '1 dan',
	      withPrepositionIn: '1 dan'
	    },
	    dual: '{{count}} dana',
	    other: '{{count}} dana'
	  },
	  aboutXWeeks: {
	    one: {
	      standalone: 'oko 1 tjedan',
	      withPrepositionAgo: 'oko 1 tjedan',
	      withPrepositionIn: 'oko 1 tjedan'
	    },
	    dual: 'oko {{count}} tjedna',
	    other: 'oko {{count}} tjedana'
	  },
	  xWeeks: {
	    one: {
	      standalone: '1 tjedan',
	      withPrepositionAgo: '1 tjedan',
	      withPrepositionIn: '1 tjedan'
	    },
	    dual: '{{count}} tjedna',
	    other: '{{count}} tjedana'
	  },
	  aboutXMonths: {
	    one: {
	      standalone: 'oko 1 mjesec',
	      withPrepositionAgo: 'oko 1 mjesec',
	      withPrepositionIn: 'oko 1 mjesec'
	    },
	    dual: 'oko {{count}} mjeseca',
	    other: 'oko {{count}} mjeseci'
	  },
	  xMonths: {
	    one: {
	      standalone: '1 mjesec',
	      withPrepositionAgo: '1 mjesec',
	      withPrepositionIn: '1 mjesec'
	    },
	    dual: '{{count}} mjeseca',
	    other: '{{count}} mjeseci'
	  },
	  aboutXYears: {
	    one: {
	      standalone: 'oko 1 godinu',
	      withPrepositionAgo: 'oko 1 godinu',
	      withPrepositionIn: 'oko 1 godinu'
	    },
	    dual: 'oko {{count}} godine',
	    other: 'oko {{count}} godina'
	  },
	  xYears: {
	    one: {
	      standalone: '1 godina',
	      withPrepositionAgo: '1 godine',
	      withPrepositionIn: '1 godinu'
	    },
	    dual: '{{count}} godine',
	    other: '{{count}} godina'
	  },
	  overXYears: {
	    one: {
	      standalone: 'preko 1 godinu',
	      withPrepositionAgo: 'preko 1 godinu',
	      withPrepositionIn: 'preko 1 godinu'
	    },
	    dual: 'preko {{count}} godine',
	    other: 'preko {{count}} godina'
	  },
	  almostXYears: {
	    one: {
	      standalone: 'gotovo 1 godinu',
	      withPrepositionAgo: 'gotovo 1 godinu',
	      withPrepositionIn: 'gotovo 1 godinu'
	    },
	    dual: 'gotovo {{count}} godine',
	    other: 'gotovo {{count}} godina'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    if (options.addSuffix) {
	      if (options.comparison > 0) {
	        result = formatDistanceLocale[token].one.withPrepositionIn;
	      } else {
	        result = formatDistanceLocale[token].one.withPrepositionAgo;
	      }
	    } else {
	      result = formatDistanceLocale[token].one.standalone;
	    }
	  } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
	  String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
	  ) {
	      result = formatDistanceLocale[token].dual.replace('{{count}}', count);
	    } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'za ' + result;
	    } else {
	      return 'prije ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d. MMMM y.',
	  long: 'd. MMMM y.',
	  medium: 'd. MMM y.',
	  short: 'dd. MM. y.'
	};
	var timeFormats = {
	  full: 'HH:mm:ss (zzzz)',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'u' {{time}}",
	  long: "{{date}} 'u' {{time}}",
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: function (date) {
	    var day = date.getUTCDay();
	
	    switch (day) {
	      case 0:
	        return "'prošlu nedjelju u' p";
	
	      case 3:
	        return "'prošlu srijedu u' p";
	
	      case 6:
	        return "'prošlu subotu u' p";
	
	      default:
	        return "'prošli' EEEE 'u' p";
	    }
	  },
	  yesterday: "'jučer u' p",
	  today: "'danas u' p",
	  tomorrow: "'sutra u' p",
	  nextWeek: function (date) {
	    var day = date.getUTCDay();
	
	    switch (day) {
	      case 0:
	        return "'iduću nedjelju u' p";
	
	      case 3:
	        return "'iduću srijedu u' p";
	
	      case 6:
	        return "'iduću subotu u' p";
	
	      default:
	        return "'prošli' EEEE 'u' p";
	    }
	  },
	  other: 'P'
	};
	
	function formatRelative(token, date, _baseDate, _options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return String(number).concat('.');
	}
	
	var eraValues = {
	  narrow: ['pr.n.e.', 'AD'],
	  abbreviated: ['pr. Kr.', 'po. Kr.'],
	  wide: ['Prije Krista', 'Poslije Krista']
	};
	var monthValues = {
	  narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
	  abbreviated: ['sij', 'velj', 'ožu', 'tra', 'svi', 'lip', 'srp', 'kol', 'ruj', 'lis', 'stu', 'pro'],
	  wide: ['siječanj', 'veljača', 'ožujak', 'travanj', 'svibanj', 'lipanj', 'srpanj', 'kolovoz', 'rujan', 'listopad', 'studeni', 'prosinac']
	};
	var formattingMonthValues = {
	  narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
	  abbreviated: ['sij', 'velj', 'ožu', 'tra', 'svi', 'lip', 'srp', 'kol', 'ruj', 'lis', 'stu', 'pro'],
	  wide: ['siječnja', 'veljače', 'ožujka', 'travnja', 'svibnja', 'lipnja', 'srpnja', 'kolovoza', 'rujna', 'listopada', 'studenog', 'prosinca']
	};
	var quarterValues = {
	  narrow: ['1.', '2.', '3.', '4.'],
	  abbreviated: ['1. kv.', '2. kv.', '3. kv.', '4. kv.'],
	  wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
	};
	var dayValues = {
	  narrow: ['N', 'P', 'U', 'S', 'Č', 'P', 'S'],
	  short: ['ned', 'pon', 'uto', 'sri', 'čet', 'pet', 'sub'],
	  abbreviated: ['ned', 'pon', 'uto', 'sri', 'čet', 'pet', 'sub'],
	  wide: ['nedjelja', 'ponedjeljak', 'utorak', 'srijeda', 'četvrtak', 'petak', 'subota']
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutro',
	    afternoon: 'popodne',
	    evening: 'navečer',
	    night: 'noću'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutro',
	    afternoon: 'popodne',
	    evening: 'navečer',
	    night: 'noću'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutro',
	    afternoon: 'poslije podne',
	    evening: 'navečer',
	    night: 'noću'
	  }
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutro',
	    afternoon: 'popodne',
	    evening: 'navečer',
	    night: 'noću'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutro',
	    afternoon: 'popodne',
	    evening: 'navečer',
	    night: 'noću'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutro',
	    afternoon: 'poslije podne',
	    evening: 'navečer',
	    night: 'noću'
	  }
	};
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(8));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)\./i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(pr\.n\.e\.|AD)/i,
	  abbreviated: /^(pr\.\s?Kr\.|po\.\s?Kr\.)/i,
	  wide: /^(Prije Krista|prije nove ere|Poslije Krista|nova era)/i
	};
	var parseEraPatterns = {
	  any: [/^pr/i, /^(po|nova)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234]\.\s?kv\.?/i,
	  wide: /^[1234]\. kvartal/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(10|11|12|[123456789])\./i,
	  abbreviated: /^(sij|velj|(ožu|ozu)|tra|svi|lip|srp|kol|ruj|lis|stu|pro)/i,
	  wide: /^((siječanj|siječnja|sijecanj|sijecnja)|(veljača|veljače|veljaca|veljace)|(ožujak|ožujka|ozujak|ozujka)|(travanj|travnja)|(svibanj|svibnja)|(lipanj|lipnja)|(srpanj|srpnja)|(kolovoz|kolovoza)|(rujan|rujna)|(listopad|listopada)|(studeni|studenog)|(prosinac|prosinca))/i
	};
	var parseMonthPatterns = {
	  narrow: [/(10|11|12|[123456789])/i],
	  abbreviated: [/^sij/i, /^velj/i, /^(ožu|ozu)/i, /^tra/i, /^svi/i, /^lip/i, /^srp/i, /^kol/i, /^ruj/i, /^lis/i, /^stu/i, /^pro/i],
	  wide: [/^sij/i, /^velj/i, /^(ožu|ozu)/i, /^tra/i, /^svi/i, /^lip/i, /^srp/i, /^kol/i, /^ruj/i, /^lis/i, /^stu/i, /^pro/i]
	};
	var matchDayPatterns = {
	  narrow: /^[npusčc]/i,
	  short: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
	  abbreviated: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
	  wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
	  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(am|pm|ponoc|ponoć|(po)?podne|navecer|navečer|noću|poslije podne|ujutro)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^pono/i,
	    noon: /^pod/i,
	    morning: /jutro/i,
	    afternoon: /(poslije\s|po)+podne/i,
	    evening: /(navece|naveče)/i,
	    night: /(nocu|noću)/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1147));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1148));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1149));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1150));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1151));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Croatian locale.
	 * @language Croatian
	 * @iso-639-2 hrv
	 * @author Matija Marohnić [@silvenon]{@link https://github.com/silvenon}
	 * @author Manico [@manico]{@link https://github.com/manico}
	 * @author Ivan Jeržabek [@jerzabek]{@link https://github.com/jerzabek}
	 */
	var locale = {
	  code: 'hr',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'mwens pase yon segond',
	    other: 'mwens pase {{count}} segond'
	  },
	  xSeconds: {
	    one: '1 segond',
	    other: '{{count}} segond'
	  },
	  halfAMinute: '30 segond',
	  lessThanXMinutes: {
	    one: 'mwens pase yon minit',
	    other: 'mwens pase {{count}} minit'
	  },
	  xMinutes: {
	    one: '1 minit',
	    other: '{{count}} minit'
	  },
	  aboutXHours: {
	    one: 'anviwon inè',
	    other: 'anviwon {{count}} è'
	  },
	  xHours: {
	    one: '1 lè',
	    other: '{{count}} lè'
	  },
	  xDays: {
	    one: '1 jou',
	    other: '{{count}} jou'
	  },
	  aboutXWeeks: {
	    one: 'anviwon 1 semèn',
	    other: 'anviwon {{count}} semèn'
	  },
	  xWeeks: {
	    one: '1 semèn',
	    other: '{{count}} semèn'
	  },
	  aboutXMonths: {
	    one: 'anviwon 1 mwa',
	    other: 'anviwon {{count}} mwa'
	  },
	  xMonths: {
	    one: '1 mwa',
	    other: '{{count}} mwa'
	  },
	  aboutXYears: {
	    one: 'anviwon 1 an',
	    other: 'anviwon {{count}} an'
	  },
	  xYears: {
	    one: '1 an',
	    other: '{{count}} an'
	  },
	  overXYears: {
	    one: 'plis pase 1 an',
	    other: 'plis pase {{count}} an'
	  },
	  almostXYears: {
	    one: 'prèske 1 an',
	    other: 'prèske {{count}} an'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'nan ' + result;
	    } else {
	      return 'sa fè ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE d MMMM y',
	  long: 'd MMMM y',
	  medium: 'd MMM y',
	  short: 'dd/MM/y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'nan lè' {{time}}",
	  long: "{{date}} 'nan lè' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'pase nan lè' p",
	  yesterday: "'yè nan lè' p",
	  today: "'jodi a' p",
	  tomorrow: "'demen nan lè' p'",
	  nextWeek: "eeee 'pwochen nan lè' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['av. J.-K', 'ap. J.-K'],
	  abbreviated: ['av. J.-K', 'ap. J.-K'],
	  wide: ['anvan Jezi Kris', 'apre Jezi Kris']
	};
	var quarterValues = {
	  narrow: ['T1', 'T2', 'T3', 'T4'],
	  abbreviated: ['1ye trim.', '2yèm trim.', '3yèm trim.', '4yèm trim.'],
	  wide: ['1ye trimès', '2yèm trimès', '3yèm trimès', '4yèm trimès']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'O', 'S', 'O', 'N', 'D'],
	  abbreviated: ['janv.', 'fevr.', 'mas', 'avr.', 'me', 'jen', 'jiyè', 'out', 'sept.', 'okt.', 'nov.', 'des.'],
	  wide: ['janvye', 'fevrye', 'mas', 'avril', 'me', 'jen', 'jiyè', 'out', 'septanm', 'oktòb', 'novanm', 'desanm']
	};
	var dayValues = {
	  narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
	  short: ['di', 'le', 'ma', 'mè', 'je', 'va', 'sa'],
	  abbreviated: ['dim.', 'len.', 'mad.', 'mèk.', 'jed.', 'van.', 'sam.'],
	  wide: ['dimanch', 'lendi', 'madi', 'mèkredi', 'jedi', 'vandredi', 'samdi']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'minwit',
	    noon: 'midi',
	    morning: 'mat.',
	    afternoon: 'ap.m.',
	    evening: 'swa',
	    night: 'mat.'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'minwit',
	    noon: 'midi',
	    morning: 'maten',
	    afternoon: 'aprèmidi',
	    evening: 'swa',
	    night: 'maten'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'minwit',
	    noon: 'midi',
	    morning: 'nan maten',
	    afternoon: 'nan aprèmidi',
	    evening: 'nan aswè',
	    night: 'nan maten'
	  }
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var number = Number(dirtyNumber);
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	  var suffix;
	
	  if (number === 0) {
	    return number;
	  }
	
	  if (unit === 'year' || unit === 'hour' || unit === 'week') {
	    if (number === 1) {
	      suffix = 'ye';
	    } else {
	      suffix = 'yèm';
	    }
	  } else {
	    if (number === 1) {
	      suffix = 'ye';
	    } else {
	      suffix = 'yèm';
	    }
	  }
	
	  return number + suffix;
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(ye|yèm)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(av\.J\.K|ap\.J\.K|ap\.J\.-K)/i,
	  abbreviated: /^(av\.J\.-K|av\.J-K|apr\.J\.-K|apr\.J-K|ap\.J-K)/i,
	  wide: /^(avan Jezi Kris|apre Jezi Kris)/i
	};
	var parseEraPatterns = {
	  any: [/^av/i, /^ap/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^t[1234]/i,
	  wide: /^[1234](ye|yèm)? trimès/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(janv|fevr|mas|avr|me|jen|jiyè|out|sept|okt|nov|des)\.?/i,
	  wide: /^(janvye|fevrye|mas|avril|me|jen|jiyè|out|septanm|oktòb|novanm|desanm)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^o/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^ma/i, /^av/i, /^me/i, /^je/i, /^ji/i, /^ou/i, /^s/i, /^ok/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[lmjvsd]/i,
	  short: /^(di|le|ma|me|je|va|sa)/i,
	  abbreviated: /^(dim|len|mad|mèk|jed|van|sam)\.?/i,
	  wide: /^(dimanch|lendi|madi|mèkredi|jedi|vandredi|samdi)/i
	};
	var parseDayPatterns = {
	  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
	  any: [/^di/i, /^le/i, /^ma/i, /^mè/i, /^je/i, /^va/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|minwit|midi|mat\.?|ap\.?m\.?|swa)/i,
	  any: /^([ap]\.?\s?m\.?|nan maten|nan aprèmidi|nan aswè)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^min/i,
	    noon: /^mid/i,
	    morning: /mat/i,
	    afternoon: /ap/i,
	    evening: /sw/i,
	    night: /nwit/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1153));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1154));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1155));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1156));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1157));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Haitian Creole locale.
	 * @language Haitian Creole
	 * @iso-639-2 hat
	 * @author Rubens Mariuzzo [@rmariuzzo]{@link https://github.com/rmariuzzo}
	 * @author Watson Marcelain [@watsongm24]{@link https://github.com/watsongm24}
	 */
	var locale = {
	  code: 'ht',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1159 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var translations = {
	  about: 'körülbelül',
	  over: 'több mint',
	  almost: 'majdnem',
	  lessthan: 'kevesebb mint'
	};
	var withoutSuffixes = {
	  xseconds: ' másodperc',
	  halfaminute: 'fél perc',
	  xminutes: ' perc',
	  xhours: ' óra',
	  xdays: ' nap',
	  xweeks: ' hét',
	  xmonths: ' hónap',
	  xyears: ' év'
	};
	var withSuffixes = {
	  xseconds: {
	    '-1': ' másodperccel ezelőtt',
	    '1': ' másodperc múlva',
	    '0': ' másodperce'
	  },
	  halfaminute: {
	    '-1': 'fél perccel ezelőtt',
	    '1': 'fél perc múlva',
	    '0': 'fél perce'
	  },
	  xminutes: {
	    '-1': ' perccel ezelőtt',
	    '1': ' perc múlva',
	    '0': ' perce'
	  },
	  xhours: {
	    '-1': ' órával ezelőtt',
	    '1': ' óra múlva',
	    '0': ' órája'
	  },
	  xdays: {
	    '-1': ' nappal ezelőtt',
	    '1': ' nap múlva',
	    '0': ' napja'
	  },
	  xweeks: {
	    '-1': ' héttel ezelőtt',
	    '1': ' hét múlva',
	    '0': ' hete'
	  },
	  xmonths: {
	    '-1': ' hónappal ezelőtt',
	    '1': ' hónap múlva',
	    '0': ' hónapja'
	  },
	  xyears: {
	    '-1': ' évvel ezelőtt',
	    '1': ' év múlva',
	    '0': ' éve'
	  }
	};
	
	function translate(number, addSuffix, key, comparison) {
	  var translated = addSuffix ? withSuffixes[key][comparison] : withoutSuffixes[key];
	
	  if (key === 'halfaminute') {
	    return translated;
	  }
	
	  return number + translated;
	}
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var adverb = token.match(/about|over|almost|lessthan/i);
	  var unit = token.replace(adverb, '');
	  var result;
	  result = translate(count, options.addSuffix, unit.toLowerCase(), options.comparison);
	
	  if (adverb) {
	    result = translations[adverb[0].toLowerCase()] + ' ' + result;
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'y. MMMM d., EEEE',
	  long: 'y. MMMM d.',
	  medium: 'y. MMM d.',
	  short: 'y. MM. dd.'
	};
	var timeFormats = {
	  full: 'H:mm:ss zzzz',
	  long: 'H:mm:ss z',
	  medium: 'H:mm:ss',
	  short: 'H:mm'
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  long: '{{date}} {{time}}',
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1161 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var accusativeWeekdays = ['vasárnap', 'hétfőn', 'kedden', 'szerdán', 'csütörtökön', 'pénteken', 'szombaton'];
	
	function week(isFuture) {
	  return function (date, _baseDate, _options) {
	    var day = date.getUTCDay();
	    return (isFuture ? '' : "'múlt' ") + "'" + accusativeWeekdays[day] + "'" + " p'-kor'";
	  };
	}
	
	var formatRelativeLocale = {
	  lastWeek: week(false),
	  yesterday: "'tegnap' p'-kor'",
	  today: "'ma' p'-kor'",
	  tomorrow: "'holnap' p'-kor'",
	  nextWeek: week(true),
	  other: 'P'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date, baseDate, options);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['ie.', 'isz.'],
	  abbreviated: ['i. e.', 'i. sz.'],
	  wide: ['Krisztus előtt', 'időszámításunk szerint']
	};
	var quarterValues = {
	  narrow: ['1.', '2.', '3.', '4.'],
	  abbreviated: ['1. n.év', '2. n.év', '3. n.év', '4. n.év'],
	  wide: ['1. negyedév', '2. negyedév', '3. negyedév', '4. negyedév']
	};
	var formattingQuarterValues = {
	  narrow: ['I.', 'II.', 'III.', 'IV.'],
	  abbreviated: ['I. n.év', 'II. n.év', 'III. n.év', 'IV. n.év'],
	  wide: ['I. negyedév', 'II. negyedév', 'III. negyedév', 'IV. negyedév']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'Á', 'M', 'J', 'J', 'A', 'Sz', 'O', 'N', 'D'],
	  abbreviated: ['jan.', 'febr.', 'márc.', 'ápr.', 'máj.', 'jún.', 'júl.', 'aug.', 'szept.', 'okt.', 'nov.', 'dec.'],
	  wide: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember', 'október', 'november', 'december']
	};
	var dayValues = {
	  narrow: ['V', 'H', 'K', 'Sz', 'Cs', 'P', 'Sz'],
	  short: ['V', 'H', 'K', 'Sze', 'Cs', 'P', 'Szo'],
	  abbreviated: ['V', 'H', 'K', 'Sze', 'Cs', 'P', 'Szo'],
	  wide: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'de.',
	    pm: 'du.',
	    midnight: 'éjfél',
	    noon: 'dél',
	    morning: 'reggel',
	    afternoon: 'du.',
	    evening: 'este',
	    night: 'éjjel'
	  },
	  abbreviated: {
	    am: 'de.',
	    pm: 'du.',
	    midnight: 'éjfél',
	    noon: 'dél',
	    morning: 'reggel',
	    afternoon: 'du.',
	    evening: 'este',
	    night: 'éjjel'
	  },
	  wide: {
	    am: 'de.',
	    pm: 'du.',
	    midnight: 'éjfél',
	    noon: 'dél',
	    morning: 'reggel',
	    afternoon: 'délután',
	    evening: 'este',
	    night: 'éjjel'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingQuarterValues,
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)\.?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ie\.|isz\.)/i,
	  abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
	  wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
	};
	var parseEraPatterns = {
	  narrow: [/ie/i, /isz/i],
	  abbreviated: [/^(i\.?\s?e\.?|b\s?ce)/i, /^(i\.?\s?sz\.?|c\s?e)/i],
	  any: [/előtt/i, /(szerint|i. sz.)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]\.?/i,
	  abbreviated: /^[1234]?\.?\s?n\.év/i,
	  wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
	};
	var parseQuarterPatterns = {
	  any: [/1|I$/i, /2|II$/i, /3|III/i, /4|IV/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmaásond]|sz/i,
	  abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
	  wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a|á/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s|sz/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^már/i, /^áp/i, /^máj/i, /^jún/i, /^júl/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^([vhkpc]|sz|cs|sz)/i,
	  short: /^([vhkp]|sze|cs|szo)/i,
	  abbreviated: /^([vhkp]|sze|cs|szo)/i,
	  wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
	};
	var parseDayPatterns = {
	  narrow: [/^v/i, /^h/i, /^k/i, /^sz/i, /^c/i, /^p/i, /^sz/i],
	  any: [/^v/i, /^h/i, /^k/i, /^sze/i, /^c/i, /^p/i, /^szo/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^de\.?/i,
	    pm: /^du\.?/i,
	    midnight: /^éjf/i,
	    noon: /^dé/i,
	    morning: /reg/i,
	    afternoon: /^délu\.?/i,
	    evening: /es/i,
	    night: /éjj/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1159));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1160));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1161));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1162));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1163));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 *
	 * @summary Hungarian locale.
	 * @language Hungarian
	 *
	 * @iso-639-2 hun
	 *
	 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
	 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
	 * @author Zoltan Szepesi [@twodcube]{@link https://github.com/twodcube}
	 */
	var locale = {
	  code: 'hu',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1165 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'ավելի քիչ քան 1 վայրկյան',
	    other: 'ավելի քիչ քան {{count}} վայրկյան'
	  },
	  xSeconds: {
	    one: '1 վայրկյան',
	    other: '{{count}} վայրկյան'
	  },
	  halfAMinute: 'կես րոպե',
	  lessThanXMinutes: {
	    one: 'ավելի քիչ քան 1 րոպե',
	    other: 'ավելի քիչ քան {{count}} րոպե'
	  },
	  xMinutes: {
	    one: '1 րոպե',
	    other: '{{count}} րոպե'
	  },
	  aboutXHours: {
	    one: 'մոտ 1 ժամ',
	    other: 'մոտ {{count}} ժամ'
	  },
	  xHours: {
	    one: '1 ժամ',
	    other: '{{count}} ժամ'
	  },
	  xDays: {
	    one: '1 օր',
	    other: '{{count}} օր'
	  },
	  aboutXWeeks: {
	    one: 'մոտ 1 շաբաթ',
	    other: 'մոտ {{count}} շաբաթ'
	  },
	  xWeeks: {
	    one: '1 շաբաթ',
	    other: '{{count}} շաբաթ'
	  },
	  aboutXMonths: {
	    one: 'մոտ 1 ամիս',
	    other: 'մոտ {{count}} ամիս'
	  },
	  xMonths: {
	    one: '1 ամիս',
	    other: '{{count}} ամիս'
	  },
	  aboutXYears: {
	    one: 'մոտ 1 տարի',
	    other: 'մոտ {{count}} տարի'
	  },
	  xYears: {
	    one: '1 տարի',
	    other: '{{count}} տարի'
	  },
	  overXYears: {
	    one: 'ավելի քան 1 տարի',
	    other: 'ավելի քան {{count}} տարի'
	  },
	  almostXYears: {
	    one: 'համարյա 1 տարի',
	    other: 'համարյա {{count}} տարի'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result + ' հետո';
	    } else {
	      return result + ' առաջ';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'd MMMM, y, EEEE',
	  long: 'd MMMM, y',
	  medium: 'd MMM, y',
	  short: 'dd.MM.yyyy'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'ժ․'{{time}}",
	  long: "{{date}} 'ժ․'{{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1167 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'նախորդ' eeee p'֊ին'",
	  yesterday: "'երեկ' p'֊ին'",
	  today: "'այսօր' p'֊ին'",
	  tomorrow: "'վաղը' p'֊ին'",
	  nextWeek: "'հաջորդ' eeee p'֊ին'",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['Ք', 'Մ'],
	  abbreviated: ['ՔԱ', 'ՄԹ'],
	  wide: ['Քրիստոսից առաջ', 'Մեր թվարկության']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Ք1', 'Ք2', 'Ք3', 'Ք4'],
	  wide: ['1֊ին քառորդ', '2֊րդ քառորդ', '3֊րդ քառորդ', '4֊րդ քառորդ']
	};
	var monthValues = {
	  narrow: ['Հ', 'Փ', 'Մ', 'Ա', 'Մ', 'Հ', 'Հ', 'Օ', 'Ս', 'Հ', 'Ն', 'Դ'],
	  abbreviated: ['հուն', 'փետ', 'մար', 'ապր', 'մայ', 'հուն', 'հուլ', 'օգս', 'սեպ', 'հոկ', 'նոյ', 'դեկ'],
	  wide: ['հունվար', 'փետրվար', 'մարտ', 'ապրիլ', 'մայիս', 'հունիս', 'հուլիս', 'օգոստոս', 'սեպտեմբեր', 'հոկտեմբեր', 'նոյեմբեր', 'դեկտեմբեր']
	};
	var dayValues = {
	  narrow: ['Կ', 'Ե', 'Ե', 'Չ', 'Հ', 'Ո', 'Շ'],
	  short: ['կր', 'եր', 'եք', 'չք', 'հգ', 'ուր', 'շբ'],
	  abbreviated: ['կիր', 'երկ', 'երք', 'չոր', 'հնգ', 'ուրբ', 'շաբ'],
	  wide: ['կիրակի', 'երկուշաբթի', 'երեքշաբթի', 'չորեքշաբթի', 'հինգշաբթի', 'ուրբաթ', 'շաբաթ']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'կեսգշ',
	    noon: 'կեսօր',
	    morning: 'առավոտ',
	    afternoon: 'ցերեկ',
	    evening: 'երեկո',
	    night: 'գիշեր'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'կեսգիշեր',
	    noon: 'կեսօր',
	    morning: 'առավոտ',
	    afternoon: 'ցերեկ',
	    evening: 'երեկո',
	    night: 'գիշեր'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'կեսգիշեր',
	    noon: 'կեսօր',
	    morning: 'առավոտ',
	    afternoon: 'ցերեկ',
	    evening: 'երեկո',
	    night: 'գիշեր'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'կեսգշ',
	    noon: 'կեսօր',
	    morning: 'առավոտը',
	    afternoon: 'ցերեկը',
	    evening: 'երեկոյան',
	    night: 'գիշերը'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'կեսգիշերին',
	    noon: 'կեսօրին',
	    morning: 'առավոտը',
	    afternoon: 'ցերեկը',
	    evening: 'երեկոյան',
	    night: 'գիշերը'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'կեսգիշերին',
	    noon: 'կեսօրին',
	    morning: 'առավոտը',
	    afternoon: 'ցերեկը',
	    evening: 'երեկոյան',
	    night: 'գիշերը'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	
	  var rem100 = number % 100;
	
	  if (rem100 < 10) {
	    if (rem100 % 10 === 1) {
	      return number + '֊ին';
	    }
	  }
	
	  return number + '֊րդ';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)((-|֊)?(ին|րդ))?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(Ք|Մ)/i,
	  abbreviated: /^(Ք\.?\s?Ա\.?|Մ\.?\s?Թ\.?\s?Ա\.?|Մ\.?\s?Թ\.?|Ք\.?\s?Հ\.?)/i,
	  wide: /^(քրիստոսից առաջ|մեր թվարկությունից առաջ|մեր թվարկության|քրիստոսից հետո)/i
	};
	var parseEraPatterns = {
	  any: [/^(ք|մ)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^ք[1234]/i,
	  wide: /^[1234]((-|֊)?(ին|րդ)) քառորդ/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[հփմաօսնդ]/i,
	  abbreviated: /^(հուն|փետ|մար|ապր|մայ|հուն|հուլ|օգս|սեպ|հոկ|նոյ|դեկ)/i,
	  wide: /^(հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^հ/i, /^փ/i, /^մ/i, /^ա/i, /^մ/i, /^հ/i, /^հ/i, /^օ/i, /^ս/i, /^հ/i, /^ն/i, /^դ/i],
	  any: [/^հու/i, /^փ/i, /^մար/i, /^ա/i, /^մայ/i, /^հուն/i, /^հուլ/i, /^օ/i, /^ս/i, /^հոկ/i, /^ն/i, /^դ/i]
	};
	var matchDayPatterns = {
	  narrow: /^[եչհոշկ]/i,
	  short: /^(կր|եր|եք|չք|հգ|ուր|շբ)/i,
	  abbreviated: /^(կիր|երկ|երք|չոր|հնգ|ուրբ|շաբ)/i,
	  wide: /^(կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ)/i
	};
	var parseDayPatterns = {
	  narrow: [/^կ/i, /^ե/i, /^ե/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
	  short: [/^կ/i, /^եր/i, /^եք/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
	  abbreviated: [/^կ/i, /^երկ/i, /^երք/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
	  wide: [/^կ/i, /^երկ/i, /^երե/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^([ap]|կեսգշ|կեսօր|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i,
	  any: /^([ap]\.?\s?m\.?|կեսգիշեր(ին)?|կեսօր(ին)?|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /կեսգիշեր/i,
	    noon: /կեսօր/i,
	    morning: /առավոտ/i,
	    afternoon: /ցերեկ/i,
	    evening: /երեկո/i,
	    night: /գիշեր/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1165));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1166));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1167));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1168));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1169));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Armenian locale
	 * @language Armenian
	 * @iso-639-2 arm
	 * @author Alex Igityan [@alexigityan]{@link https://github.com/alexigityan}
	 */
	var locale = {
	  code: 'hy',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1171 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'kurang dari 1 detik',
	    other: 'kurang dari {{count}} detik'
	  },
	  xSeconds: {
	    one: '1 detik',
	    other: '{{count}} detik'
	  },
	  halfAMinute: 'setengah menit',
	  lessThanXMinutes: {
	    one: 'kurang dari 1 menit',
	    other: 'kurang dari {{count}} menit'
	  },
	  xMinutes: {
	    one: '1 menit',
	    other: '{{count}} menit'
	  },
	  aboutXHours: {
	    one: 'sekitar 1 jam',
	    other: 'sekitar {{count}} jam'
	  },
	  xHours: {
	    one: '1 jam',
	    other: '{{count}} jam'
	  },
	  xDays: {
	    one: '1 hari',
	    other: '{{count}} hari'
	  },
	  aboutXWeeks: {
	    one: 'sekitar 1 minggu',
	    other: 'sekitar {{count}} minggu'
	  },
	  xWeeks: {
	    one: '1 minggu',
	    other: '{{count}} minggu'
	  },
	  aboutXMonths: {
	    one: 'sekitar 1 bulan',
	    other: 'sekitar {{count}} bulan'
	  },
	  xMonths: {
	    one: '1 bulan',
	    other: '{{count}} bulan'
	  },
	  aboutXYears: {
	    one: 'sekitar 1 tahun',
	    other: 'sekitar {{count}} tahun'
	  },
	  xYears: {
	    one: '1 tahun',
	    other: '{{count}} tahun'
	  },
	  overXYears: {
	    one: 'lebih dari 1 tahun',
	    other: 'lebih dari {{count}} tahun'
	  },
	  almostXYears: {
	    one: 'hampir 1 tahun',
	    other: 'hampir {{count}} tahun'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'dalam waktu ' + result;
	    } else {
	      return result + ' yang lalu';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d MMMM yyyy',
	  long: 'd MMMM yyyy',
	  medium: 'd MMM yyyy',
	  short: 'd/M/yyyy'
	};
	var timeFormats = {
	  full: 'HH.mm.ss',
	  long: 'HH.mm.ss',
	  medium: 'HH.mm',
	  short: 'HH.mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'pukul' {{time}}",
	  long: "{{date}} 'pukul' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1173 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'lalu pukul' p",
	  yesterday: "'Kemarin pukul' p",
	  today: "'Hari ini pukul' p",
	  tomorrow: "'Besok pukul' p",
	  nextWeek: "eeee 'pukul' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// All data for localization are taken from this page
	// https://www.unicode.org/cldr/charts/32/summary/id.html
	var eraValues = {
	  narrow: ['SM', 'M'],
	  abbreviated: ['SM', 'M'],
	  wide: ['Sebelum Masehi', 'Masehi']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['K1', 'K2', 'K3', 'K4'],
	  wide: ['Kuartal ke-1', 'Kuartal ke-2', 'Kuartal ke-3', 'Kuartal ke-4']
	}; // Note: in Indonesian, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Ags', 'Sep', 'Okt', 'Nov', 'Des'],
	  wide: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
	};
	var dayValues = {
	  narrow: ['M', 'S', 'S', 'R', 'K', 'J', 'S'],
	  short: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
	  abbreviated: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
	  wide: ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'tengah malam',
	    noon: 'tengah hari',
	    morning: 'pagi',
	    afternoon: 'siang',
	    evening: 'sore',
	    night: 'malam'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'tengah malam',
	    noon: 'tengah hari',
	    morning: 'pagi',
	    afternoon: 'siang',
	    evening: 'sore',
	    night: 'malam'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'tengah malam',
	    noon: 'tengah hari',
	    morning: 'pagi',
	    afternoon: 'siang',
	    evening: 'sore',
	    night: 'malam'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'tengah malam',
	    noon: 'tengah hari',
	    morning: 'pagi',
	    afternoon: 'siang',
	    evening: 'sore',
	    night: 'malam'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'tengah malam',
	    noon: 'tengah hari',
	    morning: 'pagi',
	    afternoon: 'siang',
	    evening: 'sore',
	    night: 'malam'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'tengah malam',
	    noon: 'tengah hari',
	    morning: 'pagi',
	    afternoon: 'siang',
	    evening: 'sore',
	    night: 'malam'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber); // Can't use "pertama", "kedua" because can't be parsed
	
	  switch (number) {
	    default:
	      return 'ke-' + number;
	  }
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(8));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^ke-(\d+)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(sm|m)/i,
	  abbreviated: /^(s\.?\s?m\.?|s\.?\s?e\.?\s?u\.?|m\.?|e\.?\s?u\.?)/i,
	  wide: /^(sebelum masehi|sebelum era umum|masehi|era umum)/i
	};
	var parseEraPatterns = {
	  any: [/^s/i, /^(m|e)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^K-?\s[1234]/i,
	  wide: /^Kuartal ke-?\s?[1234]/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mar|apr|mei|jun|jul|agt|sep|okt|nov|des)/i,
	  wide: /^(januari|februari|maret|april|mei|juni|juli|agustus|september|oktober|november|desember)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^ma/i, /^ap/i, /^me/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[srkjm]/i,
	  short: /^(min|sen|sel|rab|kam|jum|sab)/i,
	  abbreviated: /^(min|sen|sel|rab|kam|jum|sab)/i,
	  wide: /^(minggu|senin|selasa|rabu|kamis|jumat|sabtu)/i
	};
	var parseDayPatterns = {
	  narrow: [/^m/i, /^s/i, /^s/i, /^r/i, /^k/i, /^j/i, /^s/i],
	  any: [/^m/i, /^sen/i, /^sel/i, /^r/i, /^k/i, /^j/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|tengah m|tengah h|(di(\swaktu)?) (pagi|siang|sore|malam))/i,
	  any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|(di(\swaktu)?) (pagi|siang|sore|malam))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^pm/i,
	    midnight: /^tengah m/i,
	    noon: /^tengah h/i,
	    morning: /pagi/i,
	    afternoon: /siang/i,
	    evening: /sore/i,
	    night: /malam/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1171));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1172));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1173));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1174));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1175));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Indonesian locale.
	 * @language Indonesian
	 * @iso-639-2 ind
	 * @author Rahmat Budiharso [@rbudiharso]{@link https://github.com/rbudiharso}
	 * @author Benget Nata [@bentinata]{@link https://github.com/bentinata}
	 * @author Budi Irawan [@deerawan]{@link https://github.com/deerawan}
	 * @author Try Ajitiono [@imballinst]{@link https://github.com/imballinst}
	 */
	var locale = {
	  code: 'id',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1177 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'minna en 1 sekúnda',
	    other: 'minna en {{count}} sekúndur'
	  },
	  xSeconds: {
	    one: '1 sekúnda',
	    other: '{{count}} sekúndur'
	  },
	  halfAMinute: 'hálf mínúta',
	  lessThanXMinutes: {
	    one: 'minna en 1 mínúta',
	    other: 'minna en {{count}} mínútur'
	  },
	  xMinutes: {
	    one: '1 mínúta',
	    other: '{{count}} mínútur'
	  },
	  aboutXHours: {
	    one: 'u.þ.b. 1 klukkustund',
	    other: 'u.þ.b. {{count}} klukkustundir'
	  },
	  xHours: {
	    one: '1 klukkustund',
	    other: '{{count}} klukkustundir'
	  },
	  xDays: {
	    one: '1 dagur',
	    other: '{{count}} dagar'
	  },
	  aboutXWeeks: {
	    one: 'um viku',
	    other: 'um {{count}} vikur'
	  },
	  xWeeks: {
	    one: '1 viku',
	    other: '{{count}} vikur'
	  },
	  aboutXMonths: {
	    one: 'u.þ.b. 1 mánuður',
	    other: 'u.þ.b. {{count}} mánuðir'
	  },
	  xMonths: {
	    one: '1 mánuður',
	    other: '{{count}} mánuðir'
	  },
	  aboutXYears: {
	    one: 'u.þ.b. 1 ár',
	    other: 'u.þ.b. {{count}} ár'
	  },
	  xYears: {
	    one: '1 ár',
	    other: '{{count}} ár'
	  },
	  overXYears: {
	    one: 'meira en 1 ár',
	    other: 'meira en {{count}} ár'
	  },
	  almostXYears: {
	    one: 'næstum 1 ár',
	    other: 'næstum {{count}} ár'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'í ' + result;
	    } else {
	      return result + ' síðan';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, do MMMM y',
	  long: 'do MMMM y',
	  medium: 'do MMM y',
	  short: 'd.MM.y'
	};
	var timeFormats = {
	  full: "'kl'. HH:mm:ss zzzz",
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'kl.' {{time}}",
	  long: "{{date}} 'kl.' {{time}}",
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'síðasta' dddd 'kl.' p",
	  yesterday: "'í gær kl.' p",
	  today: "'í dag kl.' p",
	  tomorrow: "'á morgun kl.' p",
	  nextWeek: "dddd 'kl.' p",
	  other: 'L'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['f.Kr.', 'e.Kr.'],
	  abbreviated: ['f.Kr.', 'e.Kr.'],
	  wide: ['fyrir Krist', 'eftir Krist']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1F', '2F', '3F', '4F'],
	  wide: ['1. fjórðungur', '2. fjórðungur', '3. fjórðungur', '4. fjórðungur']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'Á', 'S', 'Ó', 'N', 'D'],
	  abbreviated: ['jan.', 'feb.', 'mars', 'apríl', 'maí', 'júní', 'júlí', 'ágúst', 'sept.', 'okt.', 'nóv.', 'des.'],
	  wide: ['janúar', 'febrúar', 'mars', 'apríl', 'maí', 'júní', 'júlí', 'ágúst', 'september', 'október', 'nóvember', 'desember']
	};
	var dayValues = {
	  narrow: ['S', 'M', 'Þ', 'M', 'F', 'F', 'L'],
	  short: ['Su', 'Má', 'Þr', 'Mi', 'Fi', 'Fö', 'La'],
	  abbreviated: ['sun.', 'mán.', 'þri.', 'mið.', 'fim.', 'fös.', 'lau'],
	  wide: ['sunnudagur', 'mánudagur', 'þriðjudagur', 'miðvikudagur', 'fimmtudagur', 'föstudagur', 'laugardagur']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'f',
	    pm: 'e',
	    midnight: 'miðnætti',
	    noon: 'hádegi',
	    morning: 'morgunn',
	    afternoon: 'síðdegi',
	    evening: 'kvöld',
	    night: 'nótt'
	  },
	  abbreviated: {
	    am: 'f.h.',
	    pm: 'e.h.',
	    midnight: 'miðnætti',
	    noon: 'hádegi',
	    morning: 'morgunn',
	    afternoon: 'síðdegi',
	    evening: 'kvöld',
	    night: 'nótt'
	  },
	  wide: {
	    am: 'fyrir hádegi',
	    pm: 'eftir hádegi',
	    midnight: 'miðnætti',
	    noon: 'hádegi',
	    morning: 'morgunn',
	    afternoon: 'síðdegi',
	    evening: 'kvöld',
	    night: 'nótt'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'f',
	    pm: 'e',
	    midnight: 'á miðnætti',
	    noon: 'á hádegi',
	    morning: 'að morgni',
	    afternoon: 'síðdegis',
	    evening: 'um kvöld',
	    night: 'um nótt'
	  },
	  abbreviated: {
	    am: 'f.h.',
	    pm: 'e.h.',
	    midnight: 'á miðnætti',
	    noon: 'á hádegi',
	    morning: 'að morgni',
	    afternoon: 'síðdegis',
	    evening: 'um kvöld',
	    night: 'um nótt'
	  },
	  wide: {
	    am: 'fyrir hádegi',
	    pm: 'eftir hádegi',
	    midnight: 'á miðnætti',
	    noon: 'á hádegi',
	    morning: 'að morgni',
	    afternoon: 'síðdegis',
	    evening: 'um kvöld',
	    night: 'um nótt'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(f\.Kr\.|e\.Kr\.)/i,
	  abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
	  wide: /^(fyrir Krist|eftir Krist)/i
	};
	var parseEraPatterns = {
	  any: [/^(f\.Kr\.|e\.Kr\.)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234] fjórðungur/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmásónd]/i,
	  abbreviated: /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
	  wide: /^(januar|februar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^á/i, /^s/i, /^ó/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maí/i, /^jún/i, /^júl/i, /^áu/i, /^s/i, /^ó/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smtwf]/i,
	  short: /^(su|má|þr|mi|fi|fö|la)/i,
	  abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
	  wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^m/i, /^þ/i, /^m/i, /^f/i, /^f/i, /^l/i],
	  any: [/^su/i, /^má/i, /^þr/i, /^mi/i, /^fi/i, /^fö/i, /^la/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
	  any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^f/i,
	    pm: /^e/i,
	    midnight: /^mi/i,
	    noon: /^há/i,
	    morning: /morgunn/i,
	    afternoon: /síðdegi/i,
	    evening: /kvöld/i,
	    night: /nótt/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1177));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1178));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1179));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1180));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1181));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Icelandic locale.
	 * @language Icelandic
	 * @iso-639-2 isl
	 * @author Derek Blank [@derekblank]{@link https://github.com/derekblank}
	 * @author Arnór Ýmir [@lamayg]{@link https://github.com/lamayg}
	 */
	var locale = {
	  code: 'is',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'meno di un secondo',
	    other: 'meno di {{count}} secondi'
	  },
	  xSeconds: {
	    one: 'un secondo',
	    other: '{{count}} secondi'
	  },
	  halfAMinute: 'alcuni secondi',
	  lessThanXMinutes: {
	    one: 'meno di un minuto',
	    other: 'meno di {{count}} minuti'
	  },
	  xMinutes: {
	    one: 'un minuto',
	    other: '{{count}} minuti'
	  },
	  aboutXHours: {
	    one: "circa un'ora",
	    other: 'circa {{count}} ore'
	  },
	  xHours: {
	    one: "un'ora",
	    other: '{{count}} ore'
	  },
	  xDays: {
	    one: 'un giorno',
	    other: '{{count}} giorni'
	  },
	  aboutXWeeks: {
	    one: 'circa una settimana',
	    other: 'circa {{count}} settimane'
	  },
	  xWeeks: {
	    one: 'una settimana',
	    other: '{{count}} settimane'
	  },
	  aboutXMonths: {
	    one: 'circa un mese',
	    other: 'circa {{count}} mesi'
	  },
	  xMonths: {
	    one: 'un mese',
	    other: '{{count}} mesi'
	  },
	  aboutXYears: {
	    one: 'circa un anno',
	    other: 'circa {{count}} anni'
	  },
	  xYears: {
	    one: 'un anno',
	    other: '{{count}} anni'
	  },
	  overXYears: {
	    one: 'più di un anno',
	    other: 'più di {{count}} anni'
	  },
	  almostXYears: {
	    one: 'quasi un anno',
	    other: 'quasi {{count}} anni'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'tra ' + result;
	    } else {
	      return result + ' fa';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE d MMMM y',
	  long: 'd MMMM y',
	  medium: 'd MMM y',
	  short: 'dd/MM/y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  long: '{{date}} {{time}}',
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	
	var _index = _interopRequireDefault(__webpack_require__(46));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var weekdays = ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'];
	
	function lastWeek(day) {
	  switch (day) {
	    case 0:
	      return "'domenica scorsa alle' p";
	
	    default:
	      return "'" + weekdays[day] + " scorso alle' p";
	  }
	}
	
	function thisWeek(day) {
	  return "'" + weekdays[day] + " alle' p";
	}
	
	function nextWeek(day) {
	  switch (day) {
	    case 0:
	      return "'domenica prossima alle' p";
	
	    default:
	      return "'" + weekdays[day] + " prossimo alle' p";
	  }
	}
	
	var formatRelativeLocale = {
	  lastWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return lastWeek(day);
	    }
	  },
	  yesterday: "'ieri alle' p",
	  today: "'oggi alle' p",
	  tomorrow: "'domani alle' p",
	  nextWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return nextWeek(day);
	    }
	  },
	  other: 'P'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date, baseDate, options);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['aC', 'dC'],
	  abbreviated: ['a.C.', 'd.C.'],
	  wide: ['avanti Cristo', 'dopo Cristo']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['T1', 'T2', 'T3', 'T4'],
	  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
	};
	var monthValues = {
	  narrow: ['G', 'F', 'M', 'A', 'M', 'G', 'L', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'],
	  wide: ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre']
	};
	var dayValues = {
	  narrow: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
	  short: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
	  abbreviated: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
	  wide: ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'm.',
	    pm: 'p.',
	    midnight: 'mezzanotte',
	    noon: 'mezzogiorno',
	    morning: 'mattina',
	    afternoon: 'pomeriggio',
	    evening: 'sera',
	    night: 'notte'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'mezzanotte',
	    noon: 'mezzogiorno',
	    morning: 'mattina',
	    afternoon: 'pomeriggio',
	    evening: 'sera',
	    night: 'notte'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'mezzanotte',
	    noon: 'mezzogiorno',
	    morning: 'mattina',
	    afternoon: 'pomeriggio',
	    evening: 'sera',
	    night: 'notte'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'm.',
	    pm: 'p.',
	    midnight: 'mezzanotte',
	    noon: 'mezzogiorno',
	    morning: 'di mattina',
	    afternoon: 'del pomeriggio',
	    evening: 'di sera',
	    night: 'di notte'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'mezzanotte',
	    noon: 'mezzogiorno',
	    morning: 'di mattina',
	    afternoon: 'del pomeriggio',
	    evening: 'di sera',
	    night: 'di notte'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'mezzanotte',
	    noon: 'mezzogiorno',
	    morning: 'di mattina',
	    afternoon: 'del pomeriggio',
	    evening: 'di sera',
	    night: 'di notte'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + 'º';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(aC|dC)/i,
	  abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
	  wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
	};
	var parseEraPatterns = {
	  any: [/^a/i, /^(d|e)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^t[1234]/i,
	  wide: /^[1234](º)? trimestre/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[gfmalsond]/i,
	  abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
	  wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[dlmgvs]/i,
	  short: /^(do|lu|ma|me|gi|ve|sa)/i,
	  abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
	  wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
	};
	var parseDayPatterns = {
	  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
	  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
	  any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mezza/i,
	    noon: /^mezzo/i,
	    morning: /mattina/i,
	    afternoon: /pomeriggio/i,
	    evening: /sera/i,
	    night: /notte/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1183));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1184));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1185));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1186));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1187));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Italian locale.
	 * @language Italian
	 * @iso-639-2 ita
	 * @author Alberto Restifo [@albertorestifo]{@link https://github.com/albertorestifo}
	 * @author Giovanni Polimeni [@giofilo]{@link https://github.com/giofilo}
	 * @author Vincenzo Carrese [@vin-car]{@link https://github.com/vin-car}
	 */
	var locale = {
	  code: 'it',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: '1びょうみまん',
	    other: '{{count}}びょうみまん',
	    oneWithSuffix: 'やく1びょう',
	    otherWithSuffix: 'やく{{count}}びょう'
	  },
	  xSeconds: {
	    one: '1びょう',
	    other: '{{count}}びょう'
	  },
	  halfAMinute: '30びょう',
	  lessThanXMinutes: {
	    one: '1ぷんみまん',
	    other: '{{count}}ふんみまん',
	    oneWithSuffix: 'やく1ぷん',
	    otherWithSuffix: 'やく{{count}}ふん'
	  },
	  xMinutes: {
	    one: '1ぷん',
	    other: '{{count}}ふん'
	  },
	  aboutXHours: {
	    one: 'やく1じかん',
	    other: 'やく{{count}}じかん'
	  },
	  xHours: {
	    one: '1じかん',
	    other: '{{count}}じかん'
	  },
	  xDays: {
	    one: '1にち',
	    other: '{{count}}にち'
	  },
	  aboutXWeeks: {
	    one: 'やく1しゅうかん',
	    other: 'やく{{count}}しゅうかん'
	  },
	  xWeeks: {
	    one: '1しゅうかん',
	    other: '{{count}}しゅうかん'
	  },
	  aboutXMonths: {
	    one: 'やく1かげつ',
	    other: 'やく{{count}}かげつ'
	  },
	  xMonths: {
	    one: '1かげつ',
	    other: '{{count}}かげつ'
	  },
	  aboutXYears: {
	    one: 'やく1ねん',
	    other: 'やく{{count}}ねん'
	  },
	  xYears: {
	    one: '1ねん',
	    other: '{{count}}ねん'
	  },
	  overXYears: {
	    one: '1ねんいじょう',
	    other: '{{count}}ねんいじょう'
	  },
	  almostXYears: {
	    one: '1ねんちかく',
	    other: '{{count}}ねんちかく'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    if (options.addSuffix && formatDistanceLocale[token].oneWithSuffix) {
	      result = formatDistanceLocale[token].oneWithSuffix;
	    } else {
	      result = formatDistanceLocale[token].one;
	    }
	  } else {
	    if (options.addSuffix && formatDistanceLocale[token].otherWithSuffix) {
	      result = formatDistanceLocale[token].otherWithSuffix.replace('{{count}}', count);
	    } else {
	      result = formatDistanceLocale[token].other.replace('{{count}}', count);
	    }
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result + 'あと';
	    } else {
	      return result + 'まえ';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'yねんMがつdにちEEEE',
	  long: 'yねんMがつdにち',
	  medium: 'y/MM/dd',
	  short: 'y/MM/dd'
	};
	var timeFormats = {
	  full: 'Hじmmふんssびょう zzzz',
	  long: 'H:mm:ss z',
	  medium: 'H:mm:ss',
	  short: 'H:mm'
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  long: '{{date}} {{time}}',
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1191 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: 'せんしゅうのeeeeのp',
	  yesterday: 'きのうのp',
	  today: 'きょうのp',
	  tomorrow: 'あしたのp',
	  nextWeek: 'よくしゅうのeeeeのp',
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['BC', 'AC'],
	  abbreviated: ['きげんぜん', 'せいれき'],
	  wide: ['きげんぜん', 'せいれき']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['だい1しはんき', 'だい2しはんき', 'だい3しはんき', 'だい4しはんき']
	};
	var monthValues = {
	  narrow: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
	  abbreviated: ['1がつ', '2がつ', '3がつ', '4がつ', '5がつ', '6がつ', '7がつ', '8がつ', '9がつ', '10がつ', '11がつ', '12がつ'],
	  wide: ['1がつ', '2がつ', '3がつ', '4がつ', '5がつ', '6がつ', '7がつ', '8がつ', '9がつ', '10がつ', '11がつ', '12がつ']
	};
	var dayValues = {
	  narrow: ['にち', 'げつ', 'か', 'すい', 'もく', 'きん', 'ど'],
	  short: ['にち', 'げつ', 'か', 'すい', 'もく', 'きん', 'ど'],
	  abbreviated: ['にち', 'げつ', 'か', 'すい', 'もく', 'きん', 'ど'],
	  wide: ['にちようび', 'げつようび', 'かようび', 'すいようび', 'もくようび', 'きんようび', 'どようび']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ごぜん',
	    pm: 'ごご',
	    midnight: 'しんや',
	    noon: 'しょうご',
	    morning: 'あさ',
	    afternoon: 'ごご',
	    evening: 'よる',
	    night: 'しんや'
	  },
	  abbreviated: {
	    am: 'ごぜん',
	    pm: 'ごご',
	    midnight: 'しんや',
	    noon: 'しょうご',
	    morning: 'あさ',
	    afternoon: 'ごご',
	    evening: 'よる',
	    night: 'しんや'
	  },
	  wide: {
	    am: 'ごぜん',
	    pm: 'ごご',
	    midnight: 'しんや',
	    noon: 'しょうご',
	    morning: 'あさ',
	    afternoon: 'ごご',
	    evening: 'よる',
	    night: 'しんや'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ごぜん',
	    pm: 'ごご',
	    midnight: 'しんや',
	    noon: 'しょうご',
	    morning: 'あさ',
	    afternoon: 'ごご',
	    evening: 'よる',
	    night: 'しんや'
	  },
	  abbreviated: {
	    am: 'ごぜん',
	    pm: 'ごご',
	    midnight: 'しんや',
	    noon: 'しょうご',
	    morning: 'あさ',
	    afternoon: 'ごご',
	    evening: 'よる',
	    night: 'しんや'
	  },
	  wide: {
	    am: 'ごぜん',
	    pm: 'ごご',
	    midnight: 'しんや',
	    noon: 'しょうご',
	    morning: 'あさ',
	    afternoon: 'ごご',
	    evening: 'よる',
	    night: 'しんや'
	  }
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	
	  switch (unit) {
	    case 'year':
	      return "".concat(number, "\u306D\u3093");
	
	    case 'quarter':
	      return "\u3060\u3044".concat(number, "\u3057\u306F\u3093\u304D");
	
	    case 'month':
	      return "".concat(number, "\u304C\u3064");
	
	    case 'week':
	      return "\u3060\u3044".concat(number, "\u3057\u3085\u3046");
	
	    case 'date':
	      return "".concat(number, "\u306B\u3061");
	
	    case 'hour':
	      return "".concat(number, "\u3058");
	
	    case 'minute':
	      return "".concat(number, "\u3075\u3093");
	
	    case 'second':
	      return "".concat(number, "\u3073\u3087\u3046");
	
	    default:
	      return "".concat(number);
	  }
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^だ?い?\d+(ねん|しはんき|がつ|しゅう|にち|じ|ふん|びょう)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(B\.?C\.?|A\.?D\.?)/i,
	  abbreviated: /^(きげん[前後]|せいれき)/i,
	  wide: /^(きげん[前後]|せいれき)/i
	};
	var parseEraPatterns = {
	  narrow: [/^B/i, /^A/i],
	  any: [/^(きげんぜん)/i, /^(せいれき|きげんご)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^Q[1234]/i,
	  wide: /^だい[1234一二三四１２３４]しはんき/i
	};
	var parseQuarterPatterns = {
	  any: [/(1|一|１)/i, /(2|二|２)/i, /(3|三|３)/i, /(4|四|４)/i]
	};
	var matchMonthPatterns = {
	  narrow: /^([123456789]|1[012])/,
	  abbreviated: /^([123456789]|1[012])がつ/i,
	  wide: /^([123456789]|1[012])がつ/i
	};
	var parseMonthPatterns = {
	  any: [/^1\D/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
	};
	var matchDayPatterns = {
	  narrow: /^(にち|げつ|か|すい|もく|きん|ど)/,
	  short: /^(にち|げつ|か|すい|もく|きん|ど)/,
	  abbreviated: /^(にち|げつ|か|すい|もく|きん|ど)/,
	  wide: /^(にち|げつ|か|すい|もく|きん|ど)ようび/
	};
	var parseDayPatterns = {
	  any: [/^にち/, /^げつ/, /^か/, /^すい/, /^もく/, /^きん/, /^ど/]
	};
	var matchDayPeriodPatterns = {
	  any: /^(AM|PM|ごぜん|ごご|しょうご|しんや|まよなか|よる|あさ)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^(A|ごぜん)/i,
	    pm: /^(P|ごご)/i,
	    midnight: /^しんや|まよなか/i,
	    noon: /^しょうご/i,
	    morning: /^あさ/i,
	    afternoon: /^ごご/i,
	    evening: /^よる/i,
	    night: /^しんや/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1189));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1190));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1191));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1192));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1193));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Japanese (Hiragana) locale.
	 * @language Japanese (Hiragana)
	 * @iso-639-2 jpn
	 * @author Eri Hiramatsu [@Eritutteo]{@link https://github.com/Eritutteo}
	 */
	var locale = {
	  code: 'ja-Hira',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1195 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: '1秒未満',
	    other: '{{count}}秒未満',
	    oneWithSuffix: '約1秒',
	    otherWithSuffix: '約{{count}}秒'
	  },
	  xSeconds: {
	    one: '1秒',
	    other: '{{count}}秒'
	  },
	  halfAMinute: '30秒',
	  lessThanXMinutes: {
	    one: '1分未満',
	    other: '{{count}}分未満',
	    oneWithSuffix: '約1分',
	    otherWithSuffix: '約{{count}}分'
	  },
	  xMinutes: {
	    one: '1分',
	    other: '{{count}}分'
	  },
	  aboutXHours: {
	    one: '約1時間',
	    other: '約{{count}}時間'
	  },
	  xHours: {
	    one: '1時間',
	    other: '{{count}}時間'
	  },
	  xDays: {
	    one: '1日',
	    other: '{{count}}日'
	  },
	  aboutXWeeks: {
	    one: '約1週間',
	    other: '約{{count}}週間'
	  },
	  xWeeks: {
	    one: '1週間',
	    other: '{{count}}週間'
	  },
	  aboutXMonths: {
	    one: '約1か月',
	    other: '約{{count}}か月'
	  },
	  xMonths: {
	    one: '1か月',
	    other: '{{count}}か月'
	  },
	  aboutXYears: {
	    one: '約1年',
	    other: '約{{count}}年'
	  },
	  xYears: {
	    one: '1年',
	    other: '{{count}}年'
	  },
	  overXYears: {
	    one: '1年以上',
	    other: '{{count}}年以上'
	  },
	  almostXYears: {
	    one: '1年近く',
	    other: '{{count}}年近く'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    if (options.addSuffix && formatDistanceLocale[token].oneWithSuffix) {
	      result = formatDistanceLocale[token].oneWithSuffix;
	    } else {
	      result = formatDistanceLocale[token].one;
	    }
	  } else {
	    if (options.addSuffix && formatDistanceLocale[token].otherWithSuffix) {
	      result = formatDistanceLocale[token].otherWithSuffix.replace('{{count}}', count);
	    } else {
	      result = formatDistanceLocale[token].other.replace('{{count}}', count);
	    }
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result + '後';
	    } else {
	      return result + '前';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'y年M月d日EEEE',
	  long: 'y年M月d日',
	  medium: 'y/MM/dd',
	  short: 'y/MM/dd'
	};
	var timeFormats = {
	  full: 'H時mm分ss秒 zzzz',
	  long: 'H:mm:ss z',
	  medium: 'H:mm:ss',
	  short: 'H:mm'
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  long: '{{date}} {{time}}',
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: '先週のeeeeのp',
	  yesterday: '昨日のp',
	  today: '今日のp',
	  tomorrow: '明日のp',
	  nextWeek: '翌週のeeeeのp',
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['BC', 'AC'],
	  abbreviated: ['紀元前', '西暦'],
	  wide: ['紀元前', '西暦']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['第1四半期', '第2四半期', '第3四半期', '第4四半期']
	};
	var monthValues = {
	  narrow: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
	  abbreviated: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
	  wide: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
	};
	var dayValues = {
	  narrow: ['日', '月', '火', '水', '木', '金', '土'],
	  short: ['日', '月', '火', '水', '木', '金', '土'],
	  abbreviated: ['日', '月', '火', '水', '木', '金', '土'],
	  wide: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: '午前',
	    pm: '午後',
	    midnight: '深夜',
	    noon: '正午',
	    morning: '朝',
	    afternoon: '午後',
	    evening: '夜',
	    night: '深夜'
	  },
	  abbreviated: {
	    am: '午前',
	    pm: '午後',
	    midnight: '深夜',
	    noon: '正午',
	    morning: '朝',
	    afternoon: '午後',
	    evening: '夜',
	    night: '深夜'
	  },
	  wide: {
	    am: '午前',
	    pm: '午後',
	    midnight: '深夜',
	    noon: '正午',
	    morning: '朝',
	    afternoon: '午後',
	    evening: '夜',
	    night: '深夜'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: '午前',
	    pm: '午後',
	    midnight: '深夜',
	    noon: '正午',
	    morning: '朝',
	    afternoon: '午後',
	    evening: '夜',
	    night: '深夜'
	  },
	  abbreviated: {
	    am: '午前',
	    pm: '午後',
	    midnight: '深夜',
	    noon: '正午',
	    morning: '朝',
	    afternoon: '午後',
	    evening: '夜',
	    night: '深夜'
	  },
	  wide: {
	    am: '午前',
	    pm: '午後',
	    midnight: '深夜',
	    noon: '正午',
	    morning: '朝',
	    afternoon: '午後',
	    evening: '夜',
	    night: '深夜'
	  }
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	
	  switch (unit) {
	    case 'year':
	      return "".concat(number, "\u5E74");
	
	    case 'quarter':
	      return "\u7B2C".concat(number, "\u56DB\u534A\u671F");
	
	    case 'month':
	      return "".concat(number, "\u6708");
	
	    case 'week':
	      return "\u7B2C".concat(number, "\u9031");
	
	    case 'date':
	      return "".concat(number, "\u65E5");
	
	    case 'hour':
	      return "".concat(number, "\u6642");
	
	    case 'minute':
	      return "".concat(number, "\u5206");
	
	    case 'second':
	      return "".concat(number, "\u79D2");
	
	    default:
	      return "".concat(number);
	  }
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(B\.?C\.?|A\.?D\.?)/i,
	  abbreviated: /^(紀元[前後]|西暦)/i,
	  wide: /^(紀元[前後]|西暦)/i
	};
	var parseEraPatterns = {
	  narrow: [/^B/i, /^A/i],
	  any: [/^(紀元前)/i, /^(西暦|紀元後)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^Q[1234]/i,
	  wide: /^第[1234一二三四１２３４]四半期/i
	};
	var parseQuarterPatterns = {
	  any: [/(1|一|１)/i, /(2|二|２)/i, /(3|三|３)/i, /(4|四|４)/i]
	};
	var matchMonthPatterns = {
	  narrow: /^([123456789]|1[012])/,
	  abbreviated: /^([123456789]|1[012])月/i,
	  wide: /^([123456789]|1[012])月/i
	};
	var parseMonthPatterns = {
	  any: [/^1\D/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
	};
	var matchDayPatterns = {
	  narrow: /^[日月火水木金土]/,
	  short: /^[日月火水木金土]/,
	  abbreviated: /^[日月火水木金土]/,
	  wide: /^[日月火水木金土]曜日/
	};
	var parseDayPatterns = {
	  any: [/^日/, /^月/, /^火/, /^水/, /^木/, /^金/, /^土/]
	};
	var matchDayPeriodPatterns = {
	  any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^(A|午前)/i,
	    pm: /^(P|午後)/i,
	    midnight: /^深夜|真夜中/i,
	    noon: /^正午/i,
	    morning: /^朝/i,
	    afternoon: /^午後/i,
	    evening: /^夜/i,
	    night: /^深夜/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1195));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1196));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1197));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1198));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1199));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Japanese locale.
	 * @language Japanese
	 * @iso-639-2 jpn
	 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
	 * @author Yamagishi Kazutoshi [@ykzts]{@link https://github.com/ykzts}
	 * @author Luca Ban [@mesqueeb]{@link https://github.com/mesqueeb}
	 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
	 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
	 */
	var locale = {
	  code: 'ja',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    past: '{{count}} წამზე ნაკლები ხნის წინ',
	    present: '{{count}} წამზე ნაკლები',
	    future: '{{count}} წამზე ნაკლებში'
	  },
	  xSeconds: {
	    past: '{{count}} წამის წინ',
	    present: '{{count}} წამი',
	    future: '{{count}} წამში'
	  },
	  halfAMinute: {
	    past: 'ნახევარი წუთის წინ',
	    present: 'ნახევარი წუთი',
	    future: 'ნახევარი წუთში'
	  },
	  lessThanXMinutes: {
	    past: '{{count}} წუთზე ნაკლები ხნის წინ',
	    present: '{{count}} წუთზე ნაკლები',
	    future: '{{count}} წუთზე ნაკლებში'
	  },
	  xMinutes: {
	    past: '{{count}} წუთის წინ',
	    present: '{{count}} წუთი',
	    future: '{{count}} წუთში'
	  },
	  aboutXHours: {
	    past: 'დაახლოებით {{count}} საათის წინ',
	    present: 'დაახლოებით {{count}} საათი',
	    future: 'დაახლოებით {{count}} საათში'
	  },
	  xHours: {
	    past: '{{count}} საათის წინ',
	    present: '{{count}} საათი',
	    future: '{{count}} საათში'
	  },
	  xDays: {
	    past: '{{count}} დღის წინ',
	    present: '{{count}} დღე',
	    future: '{{count}} დღეში'
	  },
	  aboutXWeeks: {
	    past: 'დაახლოებით {{count}} კვირას წინ',
	    present: 'დაახლოებით {{count}} კვირა',
	    future: 'დაახლოებით {{count}} კვირაში'
	  },
	  xWeeks: {
	    past: '{{count}} კვირას კვირა',
	    present: '{{count}} კვირა',
	    future: '{{count}} კვირაში'
	  },
	  aboutXMonths: {
	    past: 'დაახლოებით {{count}} თვის წინ',
	    present: 'დაახლოებით {{count}} თვე',
	    future: 'დაახლოებით {{count}} თვეში'
	  },
	  xMonths: {
	    past: '{{count}} თვის წინ',
	    present: '{{count}} თვე',
	    future: '{{count}} თვეში'
	  },
	  aboutXYears: {
	    past: 'დაახლოებით {{count}} წლის წინ',
	    present: 'დაახლოებით {{count}} წელი',
	    future: 'დაახლოებით {{count}} წელში'
	  },
	  xYears: {
	    past: '{{count}} წლის წინ',
	    present: '{{count}} წელი',
	    future: '{{count}} წელში'
	  },
	  overXYears: {
	    past: '{{count}} წელზე მეტი ხნის წინ',
	    present: '{{count}} წელზე მეტი',
	    future: '{{count}} წელზე მეტი ხნის შემდეგ'
	  },
	  almostXYears: {
	    past: 'თითქმის {{count}} წლის წინ',
	    present: 'თითქმის {{count}} წელი',
	    future: 'თითქმის {{count}} წელში'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (options.addSuffix && options.comparison > 0) {
	    result = formatDistanceLocale[token].future.replace('{{count}}', count);
	  } else if (options.addSuffix && options.comparison <= 0) {
	    result = formatDistanceLocale[token].past.replace('{{count}}', count);
	  } else {
	    result = formatDistanceLocale[token].present.replace('{{count}}', count);
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, do MMMM, y',
	  long: 'do, MMMM, y',
	  medium: 'd, MMM, y',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} {{time}}'-ზე'",
	  long: "{{date}} {{time}}'-ზე'",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1203 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'წინა' eeee LT'-ზე'",
	  yesterday: "'გუშინ' LT'-ზე'",
	  today: "'დღეს' LT'-ზე'",
	  tomorrow: "'ხვალ' LT'-ზე'",
	  nextWeek: "'შემდეგი' eeee LT'-ზე'",
	  other: 'L'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['ჩ.წ-მდე', 'ჩ.წ'],
	  abbreviated: ['ჩვ.წ-მდე', 'ჩვ.წ'],
	  wide: ['ჩვენს წელთაღრიცხვამდე', 'ჩვენი წელთაღრიცხვით']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1-ლი კვ', '2-ე კვ', '3-ე კვ', '4-ე კვ'],
	  wide: ['1-ლი კვარტალი', '2-ე კვარტალი', '3-ე კვარტალი', '4-ე კვარტალი']
	}; // Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['ია', 'თე', 'მა', 'აპ', 'მს', 'ვნ', 'ვლ', 'აგ', 'სე', 'ოქ', 'ნო', 'დე'],
	  abbreviated: ['იან', 'თებ', 'მარ', 'აპრ', 'მაი', 'ივნ', 'ივლ', 'აგვ', 'სექ', 'ოქტ', 'ნოე', 'დეკ'],
	  wide: ['იანვარი', 'თებერვალი', 'მარტი', 'აპრილი', 'მაისი', 'ივნისი', 'ივლისი', 'აგვისტო', 'სექტემბერი', 'ოქტომბერი', 'ნოემბერი', 'დეკემბერი']
	};
	var dayValues = {
	  narrow: ['კვ', 'ორ', 'სა', 'ოთ', 'ხუ', 'პა', 'შა'],
	  short: ['კვი', 'ორშ', 'სამ', 'ოთხ', 'ხუთ', 'პარ', 'შაბ'],
	  abbreviated: ['კვი', 'ორშ', 'სამ', 'ოთხ', 'ხუთ', 'პარ', 'შაბ'],
	  wide: ['კვირა', 'ორშაბათი', 'სამშაბათი', 'ოთხშაბათი', 'ხუთშაბათი', 'პარასკევი', 'შაბათი']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'შუაღამე',
	    noon: 'შუადღე',
	    morning: 'დილა',
	    afternoon: 'საღამო',
	    evening: 'საღამო',
	    night: 'ღამე'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'შუაღამე',
	    noon: 'შუადღე',
	    morning: 'დილა',
	    afternoon: 'საღამო',
	    evening: 'საღამო',
	    night: 'ღამე'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'შუაღამე',
	    noon: 'შუადღე',
	    morning: 'დილა',
	    afternoon: 'საღამო',
	    evening: 'საღამო',
	    night: 'ღამე'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'შუაღამით',
	    noon: 'შუადღისას',
	    morning: 'დილით',
	    afternoon: 'ნაშუადღევს',
	    evening: 'საღამოს',
	    night: 'ღამით'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'შუაღამით',
	    noon: 'შუადღისას',
	    morning: 'დილით',
	    afternoon: 'ნაშუადღევს',
	    evening: 'საღამოს',
	    night: 'ღამით'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'შუაღამით',
	    noon: 'შუადღისას',
	    morning: 'დილით',
	    afternoon: 'ნაშუადღევს',
	    evening: 'საღამოს',
	    night: 'ღამით'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	
	  if (number === 1) {
	    return number + '-ლი';
	  }
	
	  return number + '-ე';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(-ლი|-ე)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ჩვ?\.წ)/i,
	  abbreviated: /^(ჩვ?\.წ)/i,
	  wide: /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე|ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
	};
	var parseEraPatterns = {
	  any: [/^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე)/i, /^(ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234]-(ლი|ე)? კვ/i,
	  wide: /^[1234]-(ლი|ე)? კვარტალი/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  any: /^(ია|თე|მა|აპ|მს|ვნ|ვლ|აგ|სე|ოქ|ნო|დე)/i
	};
	var parseMonthPatterns = {
	  any: [/^ია/i, /^თ/i, /^მარ/i, /^აპ/i, /^მაი/i, /^ი?ვნ/i, /^ი?ვლ/i, /^აგ/i, /^ს/i, /^ო/i, /^ნ/i, /^დ/i]
	};
	var matchDayPatterns = {
	  narrow: /^(კვ|ორ|სა|ოთ|ხუ|პა|შა)/i,
	  short: /^(კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ)/i,
	  long: /^(კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი)/i
	};
	var parseDayPatterns = {
	  any: [/^კვ/i, /^ორ/i, /^სა/i, /^ოთ/i, /^ხუ/i, /^პა/i, /^შა/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^([ap]\.?\s?m\.?|შუაღ|დილ)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^შუაღ/i,
	    noon: /^შუადღ/i,
	    morning: /^დილ/i,
	    afternoon: /ნაშუადღევს/i,
	    evening: /საღამო/i,
	    night: /ღამ/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1201));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1202));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1203));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1204));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1205));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Georgian locale.
	 * @language Georgian
	 * @iso-639-2 geo
	 * @author Lado Lomidze [@Landish]{@link https://github.com/Landish}
	 * @author Nick Shvelidze [@shvelo]{@link https://github.com/shvelo}
	 */
	var locale = {
	  code: 'ka',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1207 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	
	function declension(scheme, count) {
	  // scheme for count=1 exists
	  if (scheme.one !== undefined && count === 1) {
	    return scheme.one;
	  }
	
	  var rem10 = count % 10;
	  var rem100 = count % 100; // 1, 21, 31, ...
	
	  if (rem10 === 1 && rem100 !== 11) {
	    return scheme.singularNominative.replace('{{count}}', count); // 2, 3, 4, 22, 23, 24, 32 ...
	  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
	    return scheme.singularGenitive.replace('{{count}}', count); // 5, 6, 7, 8, 9, 10, 11, ...
	  } else {
	    return scheme.pluralGenitive.replace('{{count}}', count);
	  }
	}
	
	function buildLocalizeTokenFn(scheme) {
	  return function (count, options) {
	    if (options.addSuffix) {
	      if (options.comparison > 0) {
	        if (scheme.future) {
	          return declension(scheme.future, count);
	        } else {
	          return declension(scheme.regular, count) + ' кейін';
	        }
	      } else {
	        if (scheme.past) {
	          return declension(scheme.past, count);
	        } else {
	          return declension(scheme.regular, count) + ' бұрын';
	        }
	      }
	    } else {
	      return declension(scheme.regular, count);
	    }
	  };
	}
	
	var formatDistanceLocale = {
	  lessThanXSeconds: buildLocalizeTokenFn({
	    regular: {
	      one: '1 секундтан аз',
	      singularNominative: '{{count}} секундтан аз',
	      singularGenitive: '{{count}} секундтан аз',
	      pluralGenitive: '{{count}} секундтан аз'
	    },
	    future: {
	      one: 'бір секундтан кейін',
	      singularNominative: '{{count}} секундтан кейін',
	      singularGenitive: '{{count}} секундтан кейін',
	      pluralGenitive: '{{count}} секундтан кейін'
	    }
	  }),
	  xSeconds: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} секунд',
	      singularGenitive: '{{count}} секунд',
	      pluralGenitive: '{{count}} секунд'
	    },
	    past: {
	      singularNominative: '{{count}} секунд бұрын',
	      singularGenitive: '{{count}} секунд бұрын',
	      pluralGenitive: '{{count}} секунд бұрын'
	    },
	    future: {
	      singularNominative: '{{count}} секундтан кейін',
	      singularGenitive: '{{count}} секундтан кейін',
	      pluralGenitive: '{{count}} секундтан кейін'
	    }
	  }),
	  halfAMinute: function (_, options) {
	    if (options.addSuffix) {
	      if (options.comparison > 0) {
	        return 'жарты минут ішінде';
	      } else {
	        return 'жарты минут бұрын';
	      }
	    }
	
	    return 'жарты минут';
	  },
	  lessThanXMinutes: buildLocalizeTokenFn({
	    regular: {
	      one: '1 минуттан аз',
	      singularNominative: '{{count}} минуттан аз',
	      singularGenitive: '{{count}} минуттан аз',
	      pluralGenitive: '{{count}} минуттан аз'
	    },
	    future: {
	      one: 'минуттан кем ',
	      singularNominative: '{{count}} минуттан кем',
	      singularGenitive: '{{count}} минуттан кем',
	      pluralGenitive: '{{count}} минуттан кем'
	    }
	  }),
	  xMinutes: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} минут',
	      singularGenitive: '{{count}} минут',
	      pluralGenitive: '{{count}} минут'
	    },
	    past: {
	      singularNominative: '{{count}} минут бұрын',
	      singularGenitive: '{{count}} минут бұрын',
	      pluralGenitive: '{{count}} минут бұрын'
	    },
	    future: {
	      singularNominative: '{{count}} минуттан кейін',
	      singularGenitive: '{{count}} минуттан кейін',
	      pluralGenitive: '{{count}} минуттан кейін'
	    }
	  }),
	  aboutXHours: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'шамамен {{count}} сағат',
	      singularGenitive: 'шамамен {{count}} сағат',
	      pluralGenitive: 'шамамен {{count}} сағат'
	    },
	    future: {
	      singularNominative: 'шамамен {{count}} сағаттан кейін',
	      singularGenitive: 'шамамен {{count}} сағаттан кейін',
	      pluralGenitive: 'шамамен {{count}} сағаттан кейін'
	    }
	  }),
	  xHours: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} сағат',
	      singularGenitive: '{{count}} сағат',
	      pluralGenitive: '{{count}} сағат'
	    }
	  }),
	  xDays: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} күн',
	      singularGenitive: '{{count}} күн',
	      pluralGenitive: '{{count}} күн'
	    },
	    future: {
	      singularNominative: '{{count}} күннен кейін',
	      singularGenitive: '{{count}} күннен кейін',
	      pluralGenitive: '{{count}} күннен кейін'
	    }
	  }),
	  aboutXWeeks: {
	    one: 'шамамен 1 апта',
	    other: 'шамамен {{count}} апта'
	  },
	  xWeeks: {
	    one: '1 апта',
	    other: '{{count}} апта'
	  },
	  aboutXMonths: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'шамамен {{count}} ай',
	      singularGenitive: 'шамамен {{count}} ай',
	      pluralGenitive: 'шамамен {{count}} ай'
	    },
	    future: {
	      singularNominative: 'шамамен {{count}} айдан кейін',
	      singularGenitive: 'шамамен {{count}} айдан кейін',
	      pluralGenitive: 'шамамен {{count}} айдан кейін'
	    }
	  }),
	  xMonths: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} ай',
	      singularGenitive: '{{count}} ай',
	      pluralGenitive: '{{count}} ай'
	    }
	  }),
	  aboutXYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'шамамен {{count}} жыл',
	      singularGenitive: 'шамамен {{count}} жыл',
	      pluralGenitive: 'шамамен {{count}} жыл'
	    },
	    future: {
	      singularNominative: 'шамамен {{count}} жылдан кейін',
	      singularGenitive: 'шамамен {{count}} жылдан кейін',
	      pluralGenitive: 'шамамен {{count}} жылдан кейін'
	    }
	  }),
	  xYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} жыл',
	      singularGenitive: '{{count}} жыл',
	      pluralGenitive: '{{count}} жыл'
	    },
	    future: {
	      singularNominative: '{{count}} жылдан кейін',
	      singularGenitive: '{{count}} жылдан кейін',
	      pluralGenitive: '{{count}} жылдан кейін'
	    }
	  }),
	  overXYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} жылдан астам',
	      singularGenitive: '{{count}} жылдан астам',
	      pluralGenitive: '{{count}} жылдан астам'
	    },
	    future: {
	      singularNominative: '{{count}} жылдан астам',
	      singularGenitive: '{{count}} жылдан астам',
	      pluralGenitive: '{{count}} жылдан астам'
	    }
	  }),
	  almostXYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} жылға жақын',
	      singularGenitive: '{{count}} жылға жақын',
	      pluralGenitive: '{{count}} жылға жақын'
	    },
	    future: {
	      singularNominative: '{{count}} жылдан кейін',
	      singularGenitive: '{{count}} жылдан кейін',
	      pluralGenitive: '{{count}} жылдан кейін'
	    }
	  })
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  return formatDistanceLocale[token](count, options);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, do MMMM y 'ж.'",
	  long: "do MMMM y 'ж.'",
	  medium: "d MMM y 'ж.'",
	  short: 'dd.MM.yyyy'
	};
	var timeFormats = {
	  full: 'H:mm:ss zzzz',
	  long: 'H:mm:ss z',
	  medium: 'H:mm:ss',
	  short: 'H:mm'
	};
	var dateTimeFormats = {
	  any: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'any'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	
	var _index = _interopRequireDefault(__webpack_require__(46));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accusativeWeekdays = ['жексенбіде', 'дүйсенбіде', 'сейсенбіде', 'сәрсенбіде', 'бейсенбіде', 'жұмада', 'сенбіде'];
	
	function lastWeek(day) {
	  var weekday = accusativeWeekdays[day];
	  return "'өткен " + weekday + " сағат' p'-де'";
	}
	
	function thisWeek(day) {
	  var weekday = accusativeWeekdays[day];
	  return "'" + weekday + " сағат' p'-де'";
	}
	
	function nextWeek(day) {
	  var weekday = accusativeWeekdays[day];
	  return "'келесі " + weekday + " сағат' p'-де'";
	}
	
	var formatRelativeLocale = {
	  lastWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return lastWeek(day);
	    }
	  },
	  yesterday: "'кеше сағат' p'-де'",
	  today: "'бүгін сағат' p'-де'",
	  tomorrow: "'ертең сағат' p'-де'",
	  nextWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return nextWeek(day);
	    }
	  },
	  other: 'P'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date, baseDate, options);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['б.з.д.', 'б.з.'],
	  abbreviated: ['б.з.д.', 'б.з.'],
	  wide: ['біздің заманымызға дейін', 'біздің заманымыз']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1-ші тоқ.', '2-ші тоқ.', '3-ші тоқ.', '4-ші тоқ.'],
	  wide: ['1-ші тоқсан', '2-ші тоқсан', '3-ші тоқсан', '4-ші тоқсан']
	};
	var monthValues = {
	  narrow: ['Қ', 'А', 'Н', 'С', 'М', 'М', 'Ш', 'Т', 'Қ', 'Қ', 'Қ', 'Ж'],
	  abbreviated: ['қаң', 'ақп', 'нау', 'сәу', 'мам', 'мау', 'шіл', 'там', 'қыр', 'қаз', 'қар', 'жел'],
	  wide: ['қаңтар', 'ақпан', 'наурыз', 'сәуір', 'мамыр', 'маусым', 'шілде', 'тамыз', 'қыркүйек', 'қазан', 'қараша', 'желтоқсан']
	};
	var formattingMonthValues = {
	  narrow: ['Қ', 'А', 'Н', 'С', 'М', 'М', 'Ш', 'Т', 'Қ', 'Қ', 'Қ', 'Ж'],
	  abbreviated: ['қаң', 'ақп', 'нау', 'сәу', 'мам', 'мау', 'шіл', 'там', 'қыр', 'қаз', 'қар', 'жел'],
	  wide: ['қаңтар', 'ақпан', 'наурыз', 'сәуір', 'мамыр', 'маусым', 'шілде', 'тамыз', 'қыркүйек', 'қазан', 'қараша', 'желтоқсан']
	};
	var dayValues = {
	  narrow: ['Ж', 'Д', 'С', 'С', 'Б', 'Ж', 'С'],
	  short: ['жс', 'дс', 'сс', 'ср', 'бс', 'жм', 'сб'],
	  abbreviated: ['жс', 'дс', 'сс', 'ср', 'бс', 'жм', 'сб'],
	  wide: ['жексенбі', 'дүйсенбі', 'сейсенбі', 'сәрсенбі', 'бейсенбі', 'жұма', 'сенбі']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ТД',
	    pm: 'ТК',
	    midnight: 'түн ортасы',
	    noon: 'түс',
	    morning: 'таң',
	    afternoon: 'күндіз',
	    evening: 'кеш',
	    night: 'түн'
	  },
	  wide: {
	    am: 'ТД',
	    pm: 'ТК',
	    midnight: 'түн ортасы',
	    noon: 'түс',
	    morning: 'таң',
	    afternoon: 'күндіз',
	    evening: 'кеш',
	    night: 'түн'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ТД',
	    pm: 'ТК',
	    midnight: 'түн ортасында',
	    noon: 'түс',
	    morning: 'таң',
	    afternoon: 'күн',
	    evening: 'кеш',
	    night: 'түн'
	  },
	  wide: {
	    am: 'ТД',
	    pm: 'ТК',
	    midnight: 'түн ортасында',
	    noon: 'түсте',
	    morning: 'таңертең',
	    afternoon: 'күндіз',
	    evening: 'кеште',
	    night: 'түнде'
	  }
	};
	var suffixes = {
	  0: '-ші',
	  1: '-ші',
	  2: '-ші',
	  3: '-ші',
	  4: '-ші',
	  5: '-ші',
	  6: '-шы',
	  7: '-ші',
	  8: '-ші',
	  9: '-шы',
	  10: '-шы',
	  20: '-шы',
	  30: '-шы',
	  40: '-шы',
	  50: '-ші',
	  60: '-шы',
	  70: '-ші',
	  80: '-ші',
	  90: '-шы',
	  100: '-ші'
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  var a = number % 10;
	  var b = number >= 100 ? 100 : null;
	  return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'any',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(-?(ші|шы))?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^((б )?з\.?\s?д\.?)/i,
	  abbreviated: /^((б )?з\.?\s?д\.?)/i,
	  wide: /^(біздің заманымызға дейін|біздің заманымыз|біздің заманымыздан)/i
	};
	var parseEraPatterns = {
	  any: [/^б/i, /^з/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234](-?ші)? тоқ.?/i,
	  wide: /^[1234](-?ші)? тоқсан/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(қ|а|н|с|м|мау|ш|т|қыр|қаз|қар|ж)/i,
	  abbreviated: /^(қаң|ақп|нау|сәу|мам|мау|шіл|там|қыр|қаз|қар|жел)/i,
	  wide: /^(қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^қ/i, /^а/i, /^н/i, /^с/i, /^м/i, /^м/i, /^ш/i, /^т/i, /^қ/i, /^қ/i, /^қ/i, /^ж/i],
	  abbreviated: [/^қаң/i, /^ақп/i, /^нау/i, /^сәу/i, /^мам/i, /^мау/i, /^шіл/i, /^там/i, /^қыр/i, /^қаз/i, /^қар/i, /^жел/i],
	  any: [/^қ/i, /^а/i, /^н/i, /^с/i, /^м/i, /^м/i, /^ш/i, /^т/i, /^қ/i, /^қ/i, /^қ/i, /^ж/i]
	};
	var matchDayPatterns = {
	  narrow: /^(ж|д|с|с|б|ж|с)/i,
	  short: /^(жс|дс|сс|ср|бс|жм|сб)/i,
	  wide: /^(жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі)/i
	};
	var parseDayPatterns = {
	  narrow: [/^ж/i, /^д/i, /^с/i, /^с/i, /^б/i, /^ж/i, /^с/i],
	  short: [/^жс/i, /^дс/i, /^сс/i, /^ср/i, /^бс/i, /^жм/i, /^сб/i],
	  any: [/^ж[ек]/i, /^д[үй]/i, /^сe[й]/i, /^сә[р]/i, /^б[ей]/i, /^ж[ұм]/i, /^се[н]/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
	  wide: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
	  any: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^ТД/i,
	    pm: /^ТК/i,
	    midnight: /^түн орта/i,
	    noon: /^күндіз/i,
	    morning: /таң/i,
	    afternoon: /түс/i,
	    evening: /кеш/i,
	    night: /түн/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1207));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1208));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1209));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1210));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1211));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Kazakh locale.
	 * @language Kazakh
	 * @iso-639-2 kaz
	 * @author Nikita Bayev [@drugoi]{@link https://github.com/drugoi}
	 */
	var locale = {
	  code: 'kk',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1213 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: {
	      default: '1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ',
	      future: '1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ',
	      past: '1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ'
	    },
	    other: {
	      default: '{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ',
	      future: '{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ',
	      past: '{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ'
	    }
	  },
	  xSeconds: {
	    one: {
	      default: '1 ಸೆಕೆಂಡ್',
	      future: '1 ಸೆಕೆಂಡ್‌ನಲ್ಲಿ',
	      past: '1 ಸೆಕೆಂಡ್ ಹಿಂದೆ'
	    },
	    other: {
	      default: '{{count}} ಸೆಕೆಂಡುಗಳು',
	      future: '{{count}} ಸೆಕೆಂಡ್‌ಗಳಲ್ಲಿ',
	      past: '{{count}} ಸೆಕೆಂಡ್ ಹಿಂದೆ'
	    }
	  },
	  halfAMinute: {
	    other: {
	      default: 'ಅರ್ಧ ನಿಮಿಷ',
	      future: 'ಅರ್ಧ ನಿಮಿಷದಲ್ಲಿ',
	      past: 'ಅರ್ಧ ನಿಮಿಷದ ಹಿಂದೆ'
	    }
	  },
	  lessThanXMinutes: {
	    one: {
	      default: '1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ',
	      future: '1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ',
	      past: '1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ'
	    },
	    other: {
	      default: '{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ',
	      future: '{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ',
	      past: '{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ'
	    }
	  },
	  xMinutes: {
	    one: {
	      default: '1 ನಿಮಿಷ',
	      future: '1 ನಿಮಿಷದಲ್ಲಿ',
	      past: '1 ನಿಮಿಷದ ಹಿಂದೆ'
	    },
	    other: {
	      default: '{{count}} ನಿಮಿಷಗಳು',
	      future: '{{count}} ನಿಮಿಷಗಳಲ್ಲಿ',
	      past: '{{count}} ನಿಮಿಷಗಳ ಹಿಂದೆ'
	    }
	  },
	  aboutXHours: {
	    one: {
	      default: 'ಸುಮಾರು 1 ಗಂಟೆ',
	      future: 'ಸುಮಾರು 1 ಗಂಟೆಯಲ್ಲಿ',
	      past: 'ಸುಮಾರು 1 ಗಂಟೆ ಹಿಂದೆ'
	    },
	    other: {
	      default: 'ಸುಮಾರು {{count}} ಗಂಟೆಗಳು',
	      future: 'ಸುಮಾರು {{count}} ಗಂಟೆಗಳಲ್ಲಿ',
	      past: 'ಸುಮಾರು {{count}} ಗಂಟೆಗಳ ಹಿಂದೆ'
	    }
	  },
	  xHours: {
	    one: {
	      default: '1 ಗಂಟೆ',
	      future: '1 ಗಂಟೆಯಲ್ಲಿ',
	      past: '1 ಗಂಟೆ ಹಿಂದೆ'
	    },
	    other: {
	      default: '{{count}} ಗಂಟೆಗಳು',
	      future: '{{count}} ಗಂಟೆಗಳಲ್ಲಿ',
	      past: '{{count}} ಗಂಟೆಗಳ ಹಿಂದೆ'
	    }
	  },
	  xDays: {
	    one: {
	      default: '1 ದಿನ',
	      future: '1 ದಿನದಲ್ಲಿ',
	      past: '1 ದಿನದ ಹಿಂದೆ'
	    },
	    other: {
	      default: '{{count}} ದಿನಗಳು',
	      future: '{{count}} ದಿನಗಳಲ್ಲಿ',
	      past: '{{count}} ದಿನಗಳ ಹಿಂದೆ'
	    }
	  },
	  aboutXMonths: {
	    one: {
	      default: 'ಸುಮಾರು 1 ತಿಂಗಳು',
	      future: 'ಸುಮಾರು 1 ತಿಂಗಳಲ್ಲಿ',
	      past: 'ಸುಮಾರು 1 ತಿಂಗಳ ಹಿಂದೆ'
	    },
	    other: {
	      default: 'ಸುಮಾರು {{count}} ತಿಂಗಳು',
	      future: 'ಸುಮಾರು {{count}} ತಿಂಗಳುಗಳಲ್ಲಿ',
	      past: 'ಸುಮಾರು {{count}} ತಿಂಗಳುಗಳ ಹಿಂದೆ'
	    }
	  },
	  xMonths: {
	    one: {
	      default: '1 ತಿಂಗಳು',
	      future: '1 ತಿಂಗಳಲ್ಲಿ',
	      past: '1 ತಿಂಗಳ ಹಿಂದೆ'
	    },
	    other: {
	      default: '{{count}} ತಿಂಗಳು',
	      future: '{{count}} ತಿಂಗಳುಗಳಲ್ಲಿ',
	      past: '{{count}} ತಿಂಗಳುಗಳ ಹಿಂದೆ'
	    }
	  },
	  aboutXYears: {
	    one: {
	      default: 'ಸುಮಾರು 1 ವರ್ಷ',
	      future: 'ಸುಮಾರು 1 ವರ್ಷದಲ್ಲಿ',
	      past: 'ಸುಮಾರು 1 ವರ್ಷದ ಹಿಂದೆ'
	    },
	    other: {
	      default: 'ಸುಮಾರು {{count}} ವರ್ಷಗಳು',
	      future: 'ಸುಮಾರು {{count}} ವರ್ಷಗಳಲ್ಲಿ',
	      past: 'ಸುಮಾರು {{count}} ವರ್ಷಗಳ ಹಿಂದೆ'
	    }
	  },
	  xYears: {
	    one: {
	      default: '1 ವರ್ಷ',
	      future: '1 ವರ್ಷದಲ್ಲಿ',
	      past: '1 ವರ್ಷದ ಹಿಂದೆ'
	    },
	    other: {
	      default: '{{count}} ವರ್ಷಗಳು',
	      future: '{{count}} ವರ್ಷಗಳಲ್ಲಿ',
	      past: '{{count}} ವರ್ಷಗಳ ಹಿಂದೆ'
	    }
	  },
	  overXYears: {
	    one: {
	      default: '1 ವರ್ಷದ ಮೇಲೆ',
	      future: '1 ವರ್ಷದ ಮೇಲೆ',
	      past: '1 ವರ್ಷದ ಮೇಲೆ'
	    },
	    other: {
	      default: '{{count}} ವರ್ಷಗಳ ಮೇಲೆ',
	      future: '{{count}} ವರ್ಷಗಳ ಮೇಲೆ',
	      past: '{{count}} ವರ್ಷಗಳ ಮೇಲೆ'
	    }
	  },
	  almostXYears: {
	    one: {
	      default: 'ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ',
	      future: 'ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ',
	      past: 'ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ'
	    },
	    other: {
	      default: 'ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ',
	      future: 'ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ',
	      past: 'ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ'
	    }
	  }
	};
	
	function getResultByTense(parentToken, options) {
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return parentToken.future;
	    } else {
	      return parentToken.past;
	    }
	  }
	
	  return parentToken.default;
	}
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = getResultByTense(formatDistanceLocale[token].one, options);
	  } else {
	    result = getResultByTense(formatDistanceLocale[token].other, options);
	  }
	
	  return result.replace('{{count}}', count);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Reference: https://www.unicode.org/cldr/charts/32/summary/kn.html
	var dateFormats = {
	  full: 'EEEE, MMMM d, y',
	  // CLDR 1816
	  long: 'MMMM d, y',
	  // CLDR 1817
	  medium: 'MMM d, y',
	  // CLDR 1818
	  short: 'd/M/yy' // CLDR 1819
	
	};
	var timeFormats = {
	  full: 'hh:mm:ss a zzzz',
	  // CLDR 1820
	  long: 'hh:mm:ss a z',
	  // CLDR 1821
	  medium: 'hh:mm:ss a',
	  // CLDR 1822
	  short: 'hh:mm a' // CLDR 1823
	
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  // CLDR 1824
	  long: '{{date}} {{time}}',
	  // CLDR 1825
	  medium: '{{date}} {{time}}',
	  // CLDR 1826
	  short: '{{date}} {{time}}' // CLDR 1827
	
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'ಕಳೆದ' eeee p 'ಕ್ಕೆ'",
	  yesterday: "'ನಿನ್ನೆ' p 'ಕ್ಕೆ'",
	  today: "'ಇಂದು' p 'ಕ್ಕೆ'",
	  tomorrow: "'ನಾಳೆ' p 'ಕ್ಕೆ'",
	  nextWeek: "eeee p 'ಕ್ಕೆ'",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Reference: https://www.unicode.org/cldr/charts/32/summary/kn.html
	var eraValues = {
	  narrow: ['ಕ್ರಿ.ಪೂ', 'ಕ್ರಿ.ಶ'],
	  abbreviated: ['ಕ್ರಿ.ಪೂ', 'ಕ್ರಿ.ಶ'],
	  // CLDR #1618, #1620
	  wide: ['ಕ್ರಿಸ್ತ ಪೂರ್ವ', 'ಕ್ರಿಸ್ತ ಶಕ'] // CLDR #1614, #1616
	
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['ತ್ರೈ 1', 'ತ್ರೈ 2', 'ತ್ರೈ 3', 'ತ್ರೈ 4'],
	  // CLDR #1630 - #1638
	  wide: ['1ನೇ ತ್ರೈಮಾಸಿಕ', '2ನೇ ತ್ರೈಮಾಸಿಕ', '3ನೇ ತ್ರೈಮಾಸಿಕ', '4ನೇ ತ್ರೈಮಾಸಿಕ'] // CLDR #1622 - #1629
	
	}; // CLDR #1646 - #1717
	
	var monthValues = {
	  narrow: ['ಜ', 'ಫೆ', 'ಮಾ', 'ಏ', 'ಮೇ', 'ಜೂ', 'ಜು', 'ಆ', 'ಸೆ', 'ಅ', 'ನ', 'ಡಿ'],
	  abbreviated: ['ಜನ', 'ಫೆಬ್ರ', 'ಮಾರ್ಚ್', 'ಏಪ್ರಿ', 'ಮೇ', 'ಜೂನ್', 'ಜುಲೈ', 'ಆಗ', 'ಸೆಪ್ಟೆಂ', 'ಅಕ್ಟೋ', 'ನವೆಂ', 'ಡಿಸೆಂ'],
	  wide: ['ಜನವರಿ', 'ಫೆಬ್ರವರಿ', 'ಮಾರ್ಚ್', 'ಏಪ್ರಿಲ್', 'ಮೇ', 'ಜೂನ್', 'ಜುಲೈ', 'ಆಗಸ್ಟ್', 'ಸೆಪ್ಟೆಂಬರ್', 'ಅಕ್ಟೋಬರ್', 'ನವೆಂಬರ್', 'ಡಿಸೆಂಬರ್']
	}; // CLDR #1718 - #1773
	
	var dayValues = {
	  narrow: ['ಭಾ', 'ಸೋ', 'ಮಂ', 'ಬು', 'ಗು', 'ಶು', 'ಶ'],
	  short: ['ಭಾನು', 'ಸೋಮ', 'ಮಂಗಳ', 'ಬುಧ', 'ಗುರು', 'ಶುಕ್ರ', 'ಶನಿ'],
	  abbreviated: ['ಭಾನು', 'ಸೋಮ', 'ಮಂಗಳ', 'ಬುಧ', 'ಗುರು', 'ಶುಕ್ರ', 'ಶನಿ'],
	  wide: ['ಭಾನುವಾರ', 'ಸೋಮವಾರ', 'ಮಂಗಳವಾರ', 'ಬುಧವಾರ', 'ಗುರುವಾರ', 'ಶುಕ್ರವಾರ', 'ಶನಿವಾರ']
	}; // CLDR #1774 - #1815
	
	var dayPeriodValues = {
	  narrow: {
	    am: 'ಪೂರ್ವಾಹ್ನ',
	    pm: 'ಅಪರಾಹ್ನ',
	    midnight: 'ಮಧ್ಯರಾತ್ರಿ',
	    noon: 'ಮಧ್ಯಾಹ್ನ',
	    morning: 'ಬೆಳಗ್ಗೆ',
	    afternoon: 'ಮಧ್ಯಾಹ್ನ',
	    evening: 'ಸಂಜೆ',
	    night: 'ರಾತ್ರಿ'
	  },
	  abbreviated: {
	    am: 'ಪೂರ್ವಾಹ್ನ',
	    pm: 'ಅಪರಾಹ್ನ',
	    midnight: 'ಮಧ್ಯರಾತ್ರಿ',
	    noon: 'ಮಧ್ಯಾನ್ಹ',
	    morning: 'ಬೆಳಗ್ಗೆ',
	    afternoon: 'ಮಧ್ಯಾನ್ಹ',
	    evening: 'ಸಂಜೆ',
	    night: 'ರಾತ್ರಿ'
	  },
	  wide: {
	    am: 'ಪೂರ್ವಾಹ್ನ',
	    pm: 'ಅಪರಾಹ್ನ',
	    midnight: 'ಮಧ್ಯರಾತ್ರಿ',
	    noon: 'ಮಧ್ಯಾನ್ಹ',
	    morning: 'ಬೆಳಗ್ಗೆ',
	    afternoon: 'ಮಧ್ಯಾನ್ಹ',
	    evening: 'ಸಂಜೆ',
	    night: 'ರಾತ್ರಿ'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ಪೂ',
	    pm: 'ಅ',
	    midnight: 'ಮಧ್ಯರಾತ್ರಿ',
	    noon: 'ಮಧ್ಯಾನ್ಹ',
	    morning: 'ಬೆಳಗ್ಗೆ',
	    afternoon: 'ಮಧ್ಯಾನ್ಹ',
	    evening: 'ಸಂಜೆ',
	    night: 'ರಾತ್ರಿ'
	  },
	  abbreviated: {
	    am: 'ಪೂರ್ವಾಹ್ನ',
	    pm: 'ಅಪರಾಹ್ನ',
	    midnight: 'ಮಧ್ಯ ರಾತ್ರಿ',
	    noon: 'ಮಧ್ಯಾನ್ಹ',
	    morning: 'ಬೆಳಗ್ಗೆ',
	    afternoon: 'ಮಧ್ಯಾನ್ಹ',
	    evening: 'ಸಂಜೆ',
	    night: 'ರಾತ್ರಿ'
	  },
	  wide: {
	    am: 'ಪೂರ್ವಾಹ್ನ',
	    pm: 'ಅಪರಾಹ್ನ',
	    midnight: 'ಮಧ್ಯ ರಾತ್ರಿ',
	    noon: 'ಮಧ್ಯಾನ್ಹ',
	    morning: 'ಬೆಳಗ್ಗೆ',
	    afternoon: 'ಮಧ್ಯಾನ್ಹ',
	    evening: 'ಸಂಜೆ',
	    night: 'ರಾತ್ರಿ'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber);
	  return number + 'ನೇ';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(ನೇ|ನೆ)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ)/i,
	  abbreviated: /^(ಕ್ರಿ\.?\s?ಪೂ\.?|ಕ್ರಿ\.?\s?ಶ\.?|ಪ್ರ\.?\s?ಶ\.?)/i,
	  wide: /^(ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಪ್ರಸಕ್ತ ಶಕ)/i
	};
	var parseEraPatterns = {
	  any: [/^ಪೂ/i, /^(ಶ|ಪ್ರ)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^ತ್ರೈ[1234]|ತ್ರೈ [1234]| [1234]ತ್ರೈ/i,
	  wide: /^[1234](ನೇ)? ತ್ರೈಮಾಸಿಕ/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(ಜೂ|ಜು|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಆ|ಸೆ|ಅ|ನ|ಡಿ)/i,
	  abbreviated: /^(ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ)/i,
	  wide: /^(ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^ಜ$/i, /^ಫೆ/i, /^ಮಾ/i, /^ಏ/i, /^ಮೇ/i, /^ಜೂ/i, /^ಜು$/i, /^ಆ/i, /^ಸೆ/i, /^ಅ/i, /^ನ/i, /^ಡಿ/i],
	  any: [/^ಜನ/i, /^ಫೆ/i, /^ಮಾ/i, /^ಏ/i, /^ಮೇ/i, /^ಜೂನ್/i, /^ಜುಲೈ/i, /^ಆ/i, /^ಸೆ/i, /^ಅ/i, /^ನ/i, /^ಡಿ/i]
	};
	var matchDayPatterns = {
	  narrow: /^(ಭಾ|ಸೋ|ಮ|ಬು|ಗು|ಶು|ಶ)/i,
	  short: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
	  abbreviated: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
	  wide: /^(ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ)/i
	};
	var parseDayPatterns = {
	  narrow: [/^ಭಾ/i, /^ಸೋ/i, /^ಮ/i, /^ಬು/i, /^ಗು/i, /^ಶು/i, /^ಶ/i],
	  any: [/^ಭಾ/i, /^ಸೋ/i, /^ಮ/i, /^ಬು/i, /^ಗು/i, /^ಶು/i, /^ಶ/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(ಪೂ|ಅ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i,
	  any: /^(ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^ಪೂ/i,
	    pm: /^ಅ/i,
	    midnight: /ಮಧ್ಯರಾತ್ರಿ/i,
	    noon: /ಮಧ್ಯಾನ್ಹ/i,
	    morning: /ಬೆಳಗ್ಗೆ/i,
	    afternoon: /ಮಧ್ಯಾನ್ಹ/i,
	    evening: /ಸಂಜೆ/i,
	    night: /ರಾತ್ರಿ/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1213));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1214));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1215));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1216));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1217));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Kannada locale (India).
	 * @language Kannada
	 * @iso-639-2 kan
	 * @author Manjunatha Gouli [@developergouli]{@link https://github.com/developergouli}
	 */
	var locale = {
	  code: 'kn',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: '1초 미만',
	    other: '{{count}}초 미만'
	  },
	  xSeconds: {
	    one: '1초',
	    other: '{{count}}초'
	  },
	  halfAMinute: '30초',
	  lessThanXMinutes: {
	    one: '1분 미만',
	    other: '{{count}}분 미만'
	  },
	  xMinutes: {
	    one: '1분',
	    other: '{{count}}분'
	  },
	  aboutXHours: {
	    one: '약 1시간',
	    other: '약 {{count}}시간'
	  },
	  xHours: {
	    one: '1시간',
	    other: '{{count}}시간'
	  },
	  xDays: {
	    one: '1일',
	    other: '{{count}}일'
	  },
	  aboutXWeeks: {
	    one: '약 1주',
	    other: '약 {{count}}주'
	  },
	  xWeeks: {
	    one: '1주',
	    other: '{{count}}주'
	  },
	  aboutXMonths: {
	    one: '약 1개월',
	    other: '약 {{count}}개월'
	  },
	  xMonths: {
	    one: '1개월',
	    other: '{{count}}개월'
	  },
	  aboutXYears: {
	    one: '약 1년',
	    other: '약 {{count}}년'
	  },
	  xYears: {
	    one: '1년',
	    other: '{{count}}년'
	  },
	  overXYears: {
	    one: '1년 이상',
	    other: '{{count}}년 이상'
	  },
	  almostXYears: {
	    one: '거의 1년',
	    other: '거의 {{count}}년'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result + ' 후';
	    } else {
	      return result + ' 전';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'y년 M월 d일 EEEE',
	  long: 'y년 M월 d일',
	  medium: 'y.MM.dd',
	  short: 'y.MM.dd'
	};
	var timeFormats = {
	  full: 'a H시 mm분 ss초 zzzz',
	  long: 'a H:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  long: '{{date}} {{time}}',
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'지난' eeee p",
	  yesterday: "'어제' p",
	  today: "'오늘' p",
	  tomorrow: "'내일' p",
	  nextWeek: "'다음' eeee p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['BC', 'AD'],
	  abbreviated: ['BC', 'AD'],
	  wide: ['기원전', '서기']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1분기', '2분기', '3분기', '4분기']
	};
	var monthValues = {
	  narrow: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
	  abbreviated: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
	  wide: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월']
	};
	var dayValues = {
	  narrow: ['일', '월', '화', '수', '목', '금', '토'],
	  short: ['일', '월', '화', '수', '목', '금', '토'],
	  abbreviated: ['일', '월', '화', '수', '목', '금', '토'],
	  wide: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: '오전',
	    pm: '오후',
	    midnight: '자정',
	    noon: '정오',
	    morning: '아침',
	    afternoon: '오후',
	    evening: '저녁',
	    night: '밤'
	  },
	  abbreviated: {
	    am: '오전',
	    pm: '오후',
	    midnight: '자정',
	    noon: '정오',
	    morning: '아침',
	    afternoon: '오후',
	    evening: '저녁',
	    night: '밤'
	  },
	  wide: {
	    am: '오전',
	    pm: '오후',
	    midnight: '자정',
	    noon: '정오',
	    morning: '아침',
	    afternoon: '오후',
	    evening: '저녁',
	    night: '밤'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: '오전',
	    pm: '오후',
	    midnight: '자정',
	    noon: '정오',
	    morning: '아침',
	    afternoon: '오후',
	    evening: '저녁',
	    night: '밤'
	  },
	  abbreviated: {
	    am: '오전',
	    pm: '오후',
	    midnight: '자정',
	    noon: '정오',
	    morning: '아침',
	    afternoon: '오후',
	    evening: '저녁',
	    night: '밤'
	  },
	  wide: {
	    am: '오전',
	    pm: '오후',
	    midnight: '자정',
	    noon: '정오',
	    morning: '아침',
	    afternoon: '오후',
	    evening: '저녁',
	    night: '밤'
	  }
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var number = Number(dirtyNumber);
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	
	  switch (unit) {
	    case 'minute':
	    case 'second':
	      return number;
	
	    case 'date':
	      return number + '일';
	
	    default:
	      return number + '번째';
	  }
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(일|번째)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
	  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
	  wide: /^(기원전|서기)/i
	};
	var parseEraPatterns = {
	  any: [/^(bc|기원전)/i, /^(ad|서기)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234]사?분기/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(1[012]|[123456789])/,
	  abbreviated: /^(1[012]|[123456789])월/i,
	  wide: /^(1[012]|[123456789])월/i
	};
	var parseMonthPatterns = {
	  any: [/^1월?$/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
	};
	var matchDayPatterns = {
	  narrow: /^[일월화수목금토]/,
	  short: /^[일월화수목금토]/,
	  abbreviated: /^[일월화수목금토]/,
	  wide: /^[일월화수목금토]요일/
	};
	var parseDayPatterns = {
	  any: [/^일/, /^월/, /^화/, /^수/, /^목/, /^금/, /^토/]
	};
	var matchDayPeriodPatterns = {
	  any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^(am|오전)/i,
	    pm: /^(pm|오후)/i,
	    midnight: /^자정/i,
	    noon: /^정오/i,
	    morning: /^아침/i,
	    afternoon: /^오후/i,
	    evening: /^저녁/i,
	    night: /^밤/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1219));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1220));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1221));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1222));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1223));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Korean locale.
	 * @language Korean
	 * @iso-639-2 kor
	 * @author Hong Chulju [@angdev]{@link https://github.com/angdev}
	 * @author Lee Seoyoen [@iamssen]{@link https://github.com/iamssen}
	 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
	 */
	var locale = {
	  code: 'ko',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1225 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    standalone: {
	      one: 'manner wéi eng Sekonn',
	      other: 'manner wéi {{count}} Sekonnen'
	    },
	    withPreposition: {
	      one: 'manner wéi enger Sekonn',
	      other: 'manner wéi {{count}} Sekonnen'
	    }
	  },
	  xSeconds: {
	    standalone: {
	      one: 'eng Sekonn',
	      other: '{{count}} Sekonnen'
	    },
	    withPreposition: {
	      one: 'enger Sekonn',
	      other: '{{count}} Sekonnen'
	    }
	  },
	  halfAMinute: {
	    standalone: 'eng hallef Minutt',
	    withPreposition: 'enger hallwer Minutt'
	  },
	  lessThanXMinutes: {
	    standalone: {
	      one: 'manner wéi eng Minutt',
	      other: 'manner wéi {{count}} Minutten'
	    },
	    withPreposition: {
	      one: 'manner wéi enger Minutt',
	      other: 'manner wéi {{count}} Minutten'
	    }
	  },
	  xMinutes: {
	    standalone: {
	      one: 'eng Minutt',
	      other: '{{count}} Minutten'
	    },
	    withPreposition: {
	      one: 'enger Minutt',
	      other: '{{count}} Minutten'
	    }
	  },
	  aboutXHours: {
	    standalone: {
	      one: 'ongeféier eng Stonn',
	      other: 'ongeféier {{count}} Stonnen'
	    },
	    withPreposition: {
	      one: 'ongeféier enger Stonn',
	      other: 'ongeféier {{count}} Stonnen'
	    }
	  },
	  xHours: {
	    standalone: {
	      one: 'eng Stonn',
	      other: '{{count}} Stonnen'
	    },
	    withPreposition: {
	      one: 'enger Stonn',
	      other: '{{count}} Stonnen'
	    }
	  },
	  xDays: {
	    standalone: {
	      one: 'een Dag',
	      other: '{{count}} Deeg'
	    },
	    withPreposition: {
	      one: 'engem Dag',
	      other: '{{count}} Deeg'
	    }
	  },
	  aboutXWeeks: {
	    standalone: {
	      one: 'ongeféier eng Woch',
	      other: 'ongeféier {{count}} Wochen'
	    },
	    withPreposition: {
	      one: 'ongeféier enger Woche',
	      other: 'ongeféier {{count}} Wochen'
	    }
	  },
	  xWeeks: {
	    standalone: {
	      one: 'eng Woch',
	      other: '{{count}} Wochen'
	    },
	    withPreposition: {
	      one: 'enger Woch',
	      other: '{{count}} Wochen'
	    }
	  },
	  aboutXMonths: {
	    standalone: {
	      one: 'ongeféier ee Mount',
	      other: 'ongeféier {{count}} Méint'
	    },
	    withPreposition: {
	      one: 'ongeféier engem Mount',
	      other: 'ongeféier {{count}} Méint'
	    }
	  },
	  xMonths: {
	    standalone: {
	      one: 'ee Mount',
	      other: '{{count}} Méint'
	    },
	    withPreposition: {
	      one: 'engem Mount',
	      other: '{{count}} Méint'
	    }
	  },
	  aboutXYears: {
	    standalone: {
	      one: 'ongeféier ee Joer',
	      other: 'ongeféier {{count}} Joer'
	    },
	    withPreposition: {
	      one: 'ongeféier engem Joer',
	      other: 'ongeféier {{count}} Joer'
	    }
	  },
	  xYears: {
	    standalone: {
	      one: 'ee Joer',
	      other: '{{count}} Joer'
	    },
	    withPreposition: {
	      one: 'engem Joer',
	      other: '{{count}} Joer'
	    }
	  },
	  overXYears: {
	    standalone: {
	      one: 'méi wéi ee Joer',
	      other: 'méi wéi {{count}} Joer'
	    },
	    withPreposition: {
	      one: 'méi wéi engem Joer',
	      other: 'méi wéi {{count}} Joer'
	    }
	  },
	  almostXYears: {
	    standalone: {
	      one: 'bal ee Joer',
	      other: 'bal {{count}} Joer'
	    },
	    withPreposition: {
	      one: 'bal engem Joer',
	      other: 'bal {{count}} Joer'
	    }
	  }
	};
	var EXCEPTION_CONSONANTS = ['d', 'h', 'n', 't', 'z'];
	var VOWELS = ['a,', 'e', 'i', 'o', 'u'];
	var DIGITS_SPOKEN_N_NEEDED = [0, 1, 2, 3, 8, 9];
	var FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED = [40, 50, 60, 70]; // Eifeler Regel
	
	function isFinalNNeeded(nextWords) {
	  var firstLetter = nextWords.charAt(0).toLowerCase();
	
	  if (VOWELS.indexOf(firstLetter) != -1 || EXCEPTION_CONSONANTS.indexOf(firstLetter) != -1) {
	    return true;
	  } // Numbers would need to converted into words for checking.
	  // Therefore, I have listed the digits that require a preceeding n with a few exceptions.
	
	
	  var firstWord = nextWords.split(' ')[0];
	  var number = parseInt(firstWord);
	
	  if (!isNaN(number) && DIGITS_SPOKEN_N_NEEDED.indexOf(number % 10) != -1 && FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED.indexOf(parseInt(firstWord.substring(0, 2))) == -1) {
	    return true;
	  } // Omit other checks as they are not expected here.
	
	
	  return false;
	}
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var usageGroup = options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
	  var result;
	
	  if (typeof usageGroup === 'string') {
	    result = usageGroup;
	  } else if (count === 1) {
	    result = usageGroup.one;
	  } else {
	    result = usageGroup.other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'a' + (isFinalNNeeded(result) ? 'n' : '') + ' ' + result;
	    } else {
	      return 'viru' + (isFinalNNeeded(result) ? 'n' : '') + ' ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
	var dateFormats = {
	  full: 'EEEE, do MMMM y',
	  // Méindeg, 7. Januar 2018
	  long: 'do MMMM y',
	  // 7. Januar 2018
	  medium: 'do MMM y',
	  // 7. Jan 2018
	  short: 'dd.MM.yy' // 07.01.18
	
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'um' {{time}}",
	  long: "{{date}} 'um' {{time}}",
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: function (date) {
	    var day = date.getUTCDay();
	    var result = "'läschte";
	
	    if (day === 2 || day === 4) {
	      // Eifeler Regel: Add an n before the consonant d; Here "Dënschdeg" "and Donneschde".
	      result += 'n';
	    }
	
	    result += "' eeee 'um' p";
	    return result;
	  },
	  yesterday: "'gëschter um' p",
	  today: "'haut um' p",
	  tomorrow: "'moien um' p",
	  nextWeek: "eeee 'um' p",
	  other: 'P'
	};
	
	function formatRelative(token, date, _baseDate, _options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['v.Chr.', 'n.Chr.'],
	  abbreviated: ['v.Chr.', 'n.Chr.'],
	  wide: ['viru Christus', 'no Christus']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1. Quartal', '2. Quartal', '3. Quartal', '4. Quartal']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jan', 'Feb', 'Mäe', 'Abr', 'Mee', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
	  wide: ['Januar', 'Februar', 'Mäerz', 'Abrëll', 'Mee', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
	};
	var dayValues = {
	  narrow: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
	  short: ['So', 'Mé', 'Dë', 'Më', 'Do', 'Fr', 'Sa'],
	  abbreviated: ['So.', 'Mé.', 'Dë.', 'Më.', 'Do.', 'Fr.', 'Sa.'],
	  wide: ['Sonndeg', 'Méindeg', 'Dënschdeg', 'Mëttwoch', 'Donneschdeg', 'Freideg', 'Samschdeg']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'mo.',
	    pm: 'nomë.',
	    midnight: 'Mëtternuecht',
	    noon: 'Mëtteg',
	    morning: 'Moien',
	    afternoon: 'Nomëtteg',
	    evening: 'Owend',
	    night: 'Nuecht'
	  },
	  abbreviated: {
	    am: 'moies',
	    pm: 'nomëttes',
	    midnight: 'Mëtternuecht',
	    noon: 'Mëtteg',
	    morning: 'Moien',
	    afternoon: 'Nomëtteg',
	    evening: 'Owend',
	    night: 'Nuecht'
	  },
	  wide: {
	    am: 'moies',
	    pm: 'nomëttes',
	    midnight: 'Mëtternuecht',
	    noon: 'Mëtteg',
	    morning: 'Moien',
	    afternoon: 'Nomëtteg',
	    evening: 'Owend',
	    night: 'Nuecht'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'mo.',
	    pm: 'nom.',
	    midnight: 'Mëtternuecht',
	    noon: 'mëttes',
	    morning: 'moies',
	    afternoon: 'nomëttes',
	    evening: 'owes',
	    night: 'nuets'
	  },
	  abbreviated: {
	    am: 'moies',
	    pm: 'nomëttes',
	    midnight: 'Mëtternuecht',
	    noon: 'mëttes',
	    morning: 'moies',
	    afternoon: 'nomëttes',
	    evening: 'owes',
	    night: 'nuets'
	  },
	  wide: {
	    am: 'moies',
	    pm: 'nomëttes',
	    midnight: 'Mëtternuecht',
	    noon: 'mëttes',
	    morning: 'moies',
	    afternoon: 'nomëttes',
	    evening: 'owes',
	    night: 'nuets'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
	  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
	  wide: /^(viru Christus|virun eiser Zäitrechnung|no Christus|eiser Zäitrechnung)/i
	};
	var parseEraPatterns = {
	  any: [/^v/i, /^n/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](\.)? Quartal/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mäe|abr|mee|jun|jul|aug|sep|okt|nov|dez)/i,
	  wide: /^(januar|februar|mäerz|abrëll|mee|juni|juli|august|september|oktober|november|dezember)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mä/i, /^ab/i, /^me/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smdf]/i,
	  short: /^(so|mé|dë|më|do|fr|sa)/i,
	  abbreviated: /^(son?|méi?|dën?|mët?|don?|fre?|sam?)\.?/i,
	  wide: /^(sonndeg|méindeg|dënschdeg|mëttwoch|donneschdeg|freideg|samschdeg)/i
	};
	var parseDayPatterns = {
	  any: [/^so/i, /^mé/i, /^dë/i, /^më/i, /^do/i, /^f/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(mo\.?|nomë\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
	  abbreviated: /^(moi\.?|nomët\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
	  wide: /^(moies|nomëttes|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^m/i,
	    pm: /^n/i,
	    midnight: /^Mëtter/i,
	    noon: /^mëttes/i,
	    morning: /moies/i,
	    afternoon: /nomëttes/i,
	    // will never be matched. Afternoon is matched by `pm`
	    evening: /owes/i,
	    night: /nuets/i // will never be matched. Night is matched by `pm`
	
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1225));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1226));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1227));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1228));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1229));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Luxembourgish locale.
	 * @language Luxembourgish
	 * @iso-639-2 ltz
	 * @author Daniel Waxweiler [@dwaxweiler]{@link https://github.com/dwaxweiler}
	 */
	var locale = {
	  code: 'lb',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1231 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: translateSeconds,
	    other: translate
	  },
	  xSeconds: {
	    one: translateSeconds,
	    other: translate
	  },
	  halfAMinute: 'pusė minutės',
	  lessThanXMinutes: {
	    one: translateSingular,
	    other: translate
	  },
	  xMinutes: {
	    one: translateSingular,
	    other: translate
	  },
	  aboutXHours: {
	    one: translateSingular,
	    other: translate
	  },
	  xHours: {
	    one: translateSingular,
	    other: translate
	  },
	  xDays: {
	    one: translateSingular,
	    other: translate
	  },
	  aboutWeeks: {
	    one: translateSingular,
	    other: translate
	  },
	  xWeeks: {
	    one: translateSingular,
	    other: translate
	  },
	  aboutXMonths: {
	    one: translateSingular,
	    other: translate
	  },
	  xMonths: {
	    one: translateSingular,
	    other: translate
	  },
	  aboutXYears: {
	    one: translateSingular,
	    other: translate
	  },
	  xYears: {
	    one: translateSingular,
	    other: translate
	  },
	  overXYears: {
	    one: translateSingular,
	    other: translate
	  },
	  almostXYears: {
	    one: translateSingular,
	    other: translate
	  }
	};
	var translations = {
	  xseconds_other: 'sekundė_sekundžių_sekundes',
	  xminutes_one: 'minutė_minutės_minutę',
	  xminutes_other: 'minutės_minučių_minutes',
	  xhours_one: 'valanda_valandos_valandą',
	  xhours_other: 'valandos_valandų_valandas',
	  xdays_one: 'diena_dienos_dieną',
	  xdays_other: 'dienos_dienų_dienas',
	  xweeks_one: 'savaitė_savaitės_savaitę',
	  xweeks_other: 'savaitės_savaičių_savaites',
	  xmonths_one: 'mėnuo_mėnesio_mėnesį',
	  xmonths_other: 'mėnesiai_mėnesių_mėnesius',
	  xyears_one: 'metai_metų_metus',
	  xyears_other: 'metai_metų_metus',
	  about: 'apie',
	  over: 'daugiau nei',
	  almost: 'beveik',
	  lessthan: 'mažiau nei'
	};
	
	function translateSeconds(number, addSuffix, key, isFuture) {
	  if (!addSuffix) {
	    return 'kelios sekundės';
	  } else {
	    return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	  }
	}
	
	function translateSingular(number, addSuffix, key, isFuture) {
	  return !addSuffix ? forms(key)[0] : isFuture ? forms(key)[1] : forms(key)[2];
	}
	
	function special(number) {
	  return number % 10 === 0 || number > 10 && number < 20;
	}
	
	function forms(key) {
	  return translations[key].split('_');
	}
	
	function translate(number, addSuffix, key, isFuture) {
	  var result = number + ' ';
	
	  if (number === 1) {
	    return result + translateSingular(number, addSuffix, key[0], isFuture);
	  } else if (!addSuffix) {
	    return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	  } else {
	    if (isFuture) {
	      return result + forms(key)[1];
	    } else {
	      return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	    }
	  }
	}
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var adverb = token.match(/about|over|almost|lessthan/i);
	  var unit = token.replace(adverb, '');
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one(count, options.addSuffix, unit.toLowerCase() + '_one');
	  } else {
	    result = formatDistanceLocale[token].other(count, options.addSuffix, unit.toLowerCase() + '_other');
	  }
	
	  if (adverb) {
	    result = translations[adverb[0].toLowerCase()] + ' ' + result;
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'po ' + result;
	    } else {
	      return 'prieš ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "y 'm'. MMMM d 'd'., EEEE",
	  long: "y 'm'. MMMM d 'd'.",
	  medium: 'y-MM-dd',
	  short: 'y-MM-dd'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  long: '{{date}} {{time}}',
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1233 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'Praėjusį' eeee p",
	  yesterday: "'Vakar' p",
	  today: "'Šiandien' p",
	  tomorrow: "'Rytoj' p",
	  nextWeek: 'eeee p',
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['pr. Kr.', 'po Kr.'],
	  abbreviated: ['pr. Kr.', 'po Kr.'],
	  wide: ['prieš Kristų', 'po Kristaus']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['I ketv.', 'II ketv.', 'III ketv.', 'IV ketv.'],
	  wide: ['I ketvirtis', 'II ketvirtis', 'III ketvirtis', 'IV ketvirtis']
	};
	var formattingQuarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['I k.', 'II k.', 'III k.', 'IV k.'],
	  wide: ['I ketvirtis', 'II ketvirtis', 'III ketvirtis', 'IV ketvirtis']
	};
	var monthValues = {
	  narrow: ['S', 'V', 'K', 'B', 'G', 'B', 'L', 'R', 'R', 'S', 'L', 'G'],
	  abbreviated: ['saus.', 'vas.', 'kov.', 'bal.', 'geg.', 'birž.', 'liep.', 'rugp.', 'rugs.', 'spal.', 'lapkr.', 'gruod.'],
	  wide: ['sausis', 'vasaris', 'kovas', 'balandis', 'gegužė', 'birželis', 'liepa', 'rugpjūtis', 'rugsėjis', 'spalis', 'lapkritis', 'gruodis']
	};
	var formattingMonthValues = {
	  narrow: ['S', 'V', 'K', 'B', 'G', 'B', 'L', 'R', 'R', 'S', 'L', 'G'],
	  abbreviated: ['saus.', 'vas.', 'kov.', 'bal.', 'geg.', 'birž.', 'liep.', 'rugp.', 'rugs.', 'spal.', 'lapkr.', 'gruod.'],
	  wide: ['sausio', 'vasario', 'kovo', 'balandžio', 'gegužės', 'birželio', 'liepos', 'rugpjūčio', 'rugsėjo', 'spalio', 'lapkričio', 'gruodžio']
	};
	var dayValues = {
	  narrow: ['S', 'P', 'A', 'T', 'K', 'P', 'Š'],
	  short: ['Sk', 'Pr', 'An', 'Tr', 'Kt', 'Pn', 'Št'],
	  abbreviated: ['sk', 'pr', 'an', 'tr', 'kt', 'pn', 'št'],
	  wide: ['sekmadienis', 'pirmadienis', 'antradienis', 'trečiadienis', 'ketvirtadienis', 'penktadienis', 'šeštadienis']
	};
	var formattingDayValues = {
	  narrow: ['S', 'P', 'A', 'T', 'K', 'P', 'Š'],
	  short: ['Sk', 'Pr', 'An', 'Tr', 'Kt', 'Pn', 'Št'],
	  abbreviated: ['sk', 'pr', 'an', 'tr', 'kt', 'pn', 'št'],
	  wide: ['sekmadienį', 'pirmadienį', 'antradienį', 'trečiadienį', 'ketvirtadienį', 'penktadienį', 'šeštadienį']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'pr. p.',
	    pm: 'pop.',
	    midnight: 'vidurnaktis',
	    noon: 'vidurdienis',
	    morning: 'rytas',
	    afternoon: 'diena',
	    evening: 'vakaras',
	    night: 'naktis'
	  },
	  abbreviated: {
	    am: 'priešpiet',
	    pm: 'popiet',
	    midnight: 'vidurnaktis',
	    noon: 'vidurdienis',
	    morning: 'rytas',
	    afternoon: 'diena',
	    evening: 'vakaras',
	    night: 'naktis'
	  },
	  wide: {
	    am: 'priešpiet',
	    pm: 'popiet',
	    midnight: 'vidurnaktis',
	    noon: 'vidurdienis',
	    morning: 'rytas',
	    afternoon: 'diena',
	    evening: 'vakaras',
	    night: 'naktis'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'pr. p.',
	    pm: 'pop.',
	    midnight: 'vidurnaktis',
	    noon: 'perpiet',
	    morning: 'rytas',
	    afternoon: 'popietė',
	    evening: 'vakaras',
	    night: 'naktis'
	  },
	  abbreviated: {
	    am: 'priešpiet',
	    pm: 'popiet',
	    midnight: 'vidurnaktis',
	    noon: 'perpiet',
	    morning: 'rytas',
	    afternoon: 'popietė',
	    evening: 'vakaras',
	    night: 'naktis'
	  },
	  wide: {
	    am: 'priešpiet',
	    pm: 'popiet',
	    midnight: 'vidurnaktis',
	    noon: 'perpiet',
	    morning: 'rytas',
	    afternoon: 'popietė',
	    evening: 'vakaras',
	    night: 'naktis'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber);
	  return number + '-oji';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingQuarterValues,
	    defaultFormattingWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(-oji)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^p(r|o)\.?\s?(kr\.?|me)/i,
	  abbreviated: /^(pr\.\s?(kr\.|m\.\s?e\.)|po\s?kr\.|mūsų eroje)/i,
	  wide: /^(prieš Kristų|prieš mūsų erą|po Kristaus|mūsų eroje)/i
	};
	var parseEraPatterns = {
	  wide: [/prieš/i, /(po|mūsų)/i],
	  any: [/^pr/i, /^(po|m)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^([1234])/i,
	  abbreviated: /^(I|II|III|IV)\s?ketv?\.?/i,
	  wide: /^(I|II|III|IV)\s?ketvirtis/i
	};
	var parseQuarterPatterns = {
	  narrow: [/1/i, /2/i, /3/i, /4/i],
	  any: [/I$/i, /II$/i, /III/i, /IV/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[svkbglr]/i,
	  abbreviated: /^(saus\.|vas\.|kov\.|bal\.|geg\.|birž\.|liep\.|rugp\.|rugs\.|spal\.|lapkr\.|gruod\.)/i,
	  wide: /^(sausi(s|o)|vasari(s|o)|kov(a|o)s|balandž?i(s|o)|gegužės?|birželi(s|o)|liep(a|os)|rugpjū(t|č)i(s|o)|rugsėj(is|o)|spali(s|o)|lapkri(t|č)i(s|o)|gruodž?i(s|o))/i
	};
	var parseMonthPatterns = {
	  narrow: [/^s/i, /^v/i, /^k/i, /^b/i, /^g/i, /^b/i, /^l/i, /^r/i, /^r/i, /^s/i, /^l/i, /^g/i],
	  any: [/^saus/i, /^vas/i, /^kov/i, /^bal/i, /^geg/i, /^birž/i, /^liep/i, /^rugp/i, /^rugs/i, /^spal/i, /^lapkr/i, /^gruod/i]
	};
	var matchDayPatterns = {
	  narrow: /^[spatkš]/i,
	  short: /^(sk|pr|an|tr|kt|pn|št)/i,
	  abbreviated: /^(sk|pr|an|tr|kt|pn|št)/i,
	  wide: /^(sekmadien(is|į)|pirmadien(is|į)|antradien(is|į)|trečiadien(is|į)|ketvirtadien(is|į)|penktadien(is|į)|šeštadien(is|į))/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^p/i, /^a/i, /^t/i, /^k/i, /^p/i, /^š/i],
	  wide: [/^se/i, /^pi/i, /^an/i, /^tr/i, /^ke/i, /^pe/i, /^še/i],
	  any: [/^sk/i, /^pr/i, /^an/i, /^tr/i, /^kt/i, /^pn/i, /^št/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(pr.\s?p.|pop.|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i,
	  any: /^(priešpiet|popiet$|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i
	};
	var parseDayPeriodPatterns = {
	  narrow: {
	    am: /^pr/i,
	    pm: /^pop./i,
	    midnight: /^vidurnaktis/i,
	    noon: /^(vidurdienis|perp)/i,
	    morning: /rytas/i,
	    afternoon: /(die|popietė)/i,
	    evening: /vakaras/i,
	    night: /naktis/i
	  },
	  any: {
	    am: /^pr/i,
	    pm: /^popiet$/i,
	    midnight: /^vidurnaktis/i,
	    noon: /^(vidurdienis|perp)/i,
	    morning: /rytas/i,
	    afternoon: /(die|popietė)/i,
	    evening: /vakaras/i,
	    night: /naktis/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1231));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1232));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1233));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1234));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1235));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 *
	 * @summary Lithuanian locale.
	 * @language Lithuanian
	 *
	 * @iso-639-2 lit
	 *
	 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
	 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
	 */
	var locale = {
	  code: 'lt',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1237 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	
	function buildLocalizeTokenFn(schema) {
	  return function (count, options) {
	    if (count === 1) {
	      if (options.addSuffix) {
	        return schema.one[0].replace('{{time}}', schema.one[2]);
	      } else {
	        return schema.one[0].replace('{{time}}', schema.one[1]);
	      }
	    } else {
	      var rem = count % 10 === 1 && count % 100 !== 11;
	
	      if (options.addSuffix) {
	        return schema.other[0].replace('{{time}}', rem ? schema.other[3] : schema.other[4]).replace('{{count}}', count);
	      } else {
	        return schema.other[0].replace('{{time}}', rem ? schema.other[1] : schema.other[2]).replace('{{count}}', count);
	      }
	    }
	  };
	}
	
	var formatDistanceLocale = {
	  lessThanXSeconds: buildLocalizeTokenFn({
	    one: ['mazāk par {{time}}', 'sekundi', 'sekundi'],
	    other: ['mazāk nekā {{count}} {{time}}', 'sekunde', 'sekundes', 'sekundes', 'sekundēm']
	  }),
	  xSeconds: buildLocalizeTokenFn({
	    one: ['1 {{time}}', 'sekunde', 'sekundes'],
	    other: ['{{count}} {{time}}', 'sekunde', 'sekundes', 'sekundes', 'sekundēm']
	  }),
	  halfAMinute: function (count, options) {
	    if (options.addSuffix) {
	      return 'pusminūtes';
	    } else {
	      return 'pusminūte';
	    }
	  },
	  lessThanXMinutes: buildLocalizeTokenFn({
	    one: ['mazāk par {{time}}', 'minūti', 'minūti'],
	    other: ['mazāk nekā {{count}} {{time}}', 'minūte', 'minūtes', 'minūtes', 'minūtēm']
	  }),
	  xMinutes: buildLocalizeTokenFn({
	    one: ['1 {{time}}', 'minūte', 'minūtes'],
	    other: ['{{count}} {{time}}', 'minūte', 'minūtes', 'minūtes', 'minūtēm']
	  }),
	  aboutXHours: buildLocalizeTokenFn({
	    one: ['apmēram 1 {{time}}', 'stunda', 'stundas'],
	    other: ['apmēram {{count}} {{time}}', 'stunda', 'stundas', 'stundas', 'stundām']
	  }),
	  xHours: buildLocalizeTokenFn({
	    one: ['1 {{time}}', 'stunda', 'stundas'],
	    other: ['{{count}} {{time}}', 'stunda', 'stundas', 'stundas', 'stundām']
	  }),
	  xDays: buildLocalizeTokenFn({
	    one: ['1 {{time}}', 'diena', 'dienas'],
	    other: ['{{count}} {{time}}', 'diena', 'dienas', 'dienas', 'dienām']
	  }),
	  aboutXWeeks: buildLocalizeTokenFn({
	    one: ['apmēram 1 {{time}}', 'nedēļa', 'nedēļas'],
	    other: ['apmēram {{count}} {{time}}', 'nedēļa', 'nedēļu', 'nedēļas', 'nedēļām']
	  }),
	  xWeeks: buildLocalizeTokenFn({
	    one: ['1 {{time}}', 'nedēļa', 'nedēļas'],
	    other: ['{{count}} {{time}}', // TODO
	    'nedēļa', 'nedēļu', 'nedēļas', 'nedēļām']
	  }),
	  aboutXMonths: buildLocalizeTokenFn({
	    one: ['apmēram 1 {{time}}', 'mēnesis', 'mēneša'],
	    other: ['apmēram {{count}} {{time}}', 'mēnesis', 'mēneši', 'mēneša', 'mēnešiem']
	  }),
	  xMonths: buildLocalizeTokenFn({
	    one: ['1 {{time}}', 'mēnesis', 'mēneša'],
	    other: ['{{count}} {{time}}', 'mēnesis', 'mēneši', 'mēneša', 'mēnešiem']
	  }),
	  aboutXYears: buildLocalizeTokenFn({
	    one: ['apmēram 1 {{time}}', 'gads', 'gada'],
	    other: ['apmēram {{count}} {{time}}', 'gads', 'gadi', 'gada', 'gadiem']
	  }),
	  xYears: buildLocalizeTokenFn({
	    one: ['1 {{time}}', 'gads', 'gada'],
	    other: ['{{count}} {{time}}', 'gads', 'gadi', 'gada', 'gadiem']
	  }),
	  overXYears: buildLocalizeTokenFn({
	    one: ['ilgāk par 1 {{time}}', 'gadu', 'gadu'],
	    other: ['vairāk nekā {{count}} {{time}}', 'gads', 'gadi', 'gada', 'gadiem']
	  }),
	  almostXYears: buildLocalizeTokenFn({
	    one: ['gandrīz 1 {{time}}', 'gads', 'gada'],
	    other: ['vairāk nekā {{count}} {{time}}', 'gads', 'gadi', 'gada', 'gadiem']
	  })
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result = formatDistanceLocale[token](count, options);
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'pēc ' + result;
	    } else {
	      return 'pirms ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, y. 'gada' d. MMMM",
	  long: "y. 'gada' d. MMMM",
	  medium: 'dd.MM.y.',
	  short: 'dd.MM.y.'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'plkst.' {{time}}",
	  long: "{{date}} 'plkst.' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	
	var _index = _interopRequireDefault(__webpack_require__(46));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var weekdays = ['svētdienā', 'pirmdienā', 'otrdienā', 'trešdienā', 'ceturtdienā', 'piektdienā', 'sestdienā'];
	var formatRelativeLocale = {
	  lastWeek: function (date, baseDate, options) {
	    if ((0, _index.default)(date, baseDate, options)) {
	      return "eeee 'plkst.' p";
	    }
	
	    var weekday = weekdays[date.getUTCDay()];
	    return "'Pagājušā " + weekday + " plkst.' p";
	  },
	  yesterday: "'Vakar plkst.' p",
	  today: "'Šodien plkst.' p",
	  tomorrow: "'Rīt plkst.' p",
	  nextWeek: function (date, baseDate, options) {
	    if ((0, _index.default)(date, baseDate, options)) {
	      return "eeee 'plkst.' p";
	    }
	
	    var weekday = weekdays[date.getUTCDay()];
	    return "'Nākamajā " + weekday + " plkst.' p";
	  },
	  other: 'P'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date, baseDate, options);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['p.m.ē', 'm.ē'],
	  abbreviated: ['p. m. ē.', 'm. ē.'],
	  wide: ['pirms mūsu ēras', 'mūsu ērā']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1. cet.', '2. cet.', '3. cet.', '4. cet.'],
	  wide: ['pirmais ceturksnis', 'otrais ceturksnis', 'trešais ceturksnis', 'ceturtais ceturksnis']
	};
	var formattingQuarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1. cet.', '2. cet.', '3. cet.', '4. cet.'],
	  wide: ['pirmajā ceturksnī', 'otrajā ceturksnī', 'trešajā ceturksnī', 'ceturtajā ceturksnī']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['janv.', 'febr.', 'marts', 'apr.', 'maijs', 'jūn.', 'jūl.', 'aug.', 'sept.', 'okt.', 'nov.', 'dec.'],
	  wide: ['janvāris', 'februāris', 'marts', 'aprīlis', 'maijs', 'jūnijs', 'jūlijs', 'augusts', 'septembris', 'oktobris', 'novembris', 'decembris']
	};
	var formattingMonthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['janv.', 'febr.', 'martā', 'apr.', 'maijs', 'jūn.', 'jūl.', 'aug.', 'sept.', 'okt.', 'nov.', 'dec.'],
	  wide: ['janvārī', 'februārī', 'martā', 'aprīlī', 'maijā', 'jūnijā', 'jūlijā', 'augustā', 'septembrī', 'oktobrī', 'novembrī', 'decembrī']
	};
	var dayValues = {
	  narrow: ['S', 'P', 'O', 'T', 'C', 'P', 'S'],
	  short: ['Sv', 'P', 'O', 'T', 'C', 'Pk', 'S'],
	  abbreviated: ['svētd.', 'pirmd.', 'otrd.', 'trešd.', 'ceturtd.', 'piektd.', 'sestd.'],
	  wide: ['svētdiena', 'pirmdiena', 'otrdiena', 'trešdiena', 'ceturtdiena', 'piektdiena', 'sestdiena']
	};
	var formattingDayValues = {
	  narrow: ['S', 'P', 'O', 'T', 'C', 'P', 'S'],
	  short: ['Sv', 'P', 'O', 'T', 'C', 'Pk', 'S'],
	  abbreviated: ['svētd.', 'pirmd.', 'otrd.', 'trešd.', 'ceturtd.', 'piektd.', 'sestd.'],
	  wide: ['svētdienā', 'pirmdienā', 'otrdienā', 'trešdienā', 'ceturtdienā', 'piektdienā', 'sestdienā']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'pusn.',
	    noon: 'pusd.',
	    morning: 'rīts',
	    afternoon: 'diena',
	    evening: 'vakars',
	    night: 'nakts'
	  },
	  abbreviated: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'pusn.',
	    noon: 'pusd.',
	    morning: 'rīts',
	    afternoon: 'pēcpusd.',
	    evening: 'vakars',
	    night: 'nakts'
	  },
	  wide: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'pusnakts',
	    noon: 'pusdienlaiks',
	    morning: 'rīts',
	    afternoon: 'pēcpusdiena',
	    evening: 'vakars',
	    night: 'nakts'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'pusn.',
	    noon: 'pusd.',
	    morning: 'rītā',
	    afternoon: 'dienā',
	    evening: 'vakarā',
	    night: 'naktī'
	  },
	  abbreviated: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'pusn.',
	    noon: 'pusd.',
	    morning: 'rītā',
	    afternoon: 'pēcpusd.',
	    evening: 'vakarā',
	    night: 'naktī'
	  },
	  wide: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'pusnaktī',
	    noon: 'pusdienlaikā',
	    morning: 'rītā',
	    afternoon: 'pēcpusdienā',
	    evening: 'vakarā',
	    night: 'naktī'
	  }
	};
	
	function ordinalNumber(number, _options) {
	  return number + '.';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingQuarterValues,
	    defaultFormattingWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)\./i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(p\.m\.ē|m\.ē)/i,
	  abbreviated: /^(p\. m\. ē\.|m\. ē\.)/i,
	  wide: /^(pirms mūsu ēras|mūsu ērā)/i
	};
	var parseEraPatterns = {
	  any: [/^p/i, /^m/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234](\. cet\.)/i,
	  wide: /^(pirma(is|jā)|otra(is|jā)|treša(is|jā)|ceturta(is|jā)) ceturksn(is|ī)/i
	};
	var parseQuarterPatterns = {
	  narrow: [/^1/i, /^2/i, /^3/i, /^4/i],
	  abbreviated: [/^1/i, /^2/i, /^3/i, /^4/i],
	  wide: [/^p/i, /^o/i, /^t/i, /^c/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(janv\.|febr\.|marts|apr\.|maijs|jūn\.|jūl\.|aug\.|sept\.|okt\.|nov\.|dec\.)/i,
	  wide: /^(janvār(is|ī)|februār(is|ī)|mart[sā]|aprīl(is|ī)|maij[sā]|jūnij[sā]|jūlij[sā]|august[sā]|septembr(is|ī)|oktobr(is|ī)|novembr(is|ī)|decembr(is|ī))/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jūn/i, /^jūl/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[spotc]/i,
	  short: /^(sv|pi|o|t|c|pk|s)/i,
	  abbreviated: /^(svētd\.|pirmd\.|otrd.\|trešd\.|ceturtd\.|piektd\.|sestd\.)/i,
	  wide: /^(svētdien(a|ā)|pirmdien(a|ā)|otrdien(a|ā)|trešdien(a|ā)|ceturtdien(a|ā)|piektdien(a|ā)|sestdien(a|ā))/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^p/i, /^o/i, /^t/i, /^c/i, /^p/i, /^s/i],
	  any: [/^sv/i, /^pi/i, /^o/i, /^t/i, /^c/i, /^p/i, /^se/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|dien(a|ā)|vakar(s|ā)|nakt(s|ī))/,
	  abbreviated: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|pēcpusd\.|vakar(s|ā)|nakt(s|ī))/,
	  wide: /^(am|pm|pusnakt(s|ī)|pusdienlaik(s|ā)|rīt(s|ā)|pēcpusdien(a|ā)|vakar(s|ā)|nakt(s|ī))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^am/i,
	    pm: /^pm/i,
	    midnight: /^pusn/i,
	    noon: /^pusd/i,
	    morning: /^r/i,
	    afternoon: /^(d|pēc)/i,
	    evening: /^v/i,
	    night: /^n/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1237));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1238));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1239));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1240));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1241));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Latvian locale (Latvia).
	 * @language Latvian
	 * @iso-639-2 lav
	 * @author Rūdolfs Puķītis [@prudolfs]{@link https://github.com/prudolfs}
	 */
	var locale = {
	  code: 'lv',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1243 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'помалку од секунда',
	    other: 'помалку од {{count}} секунди'
	  },
	  xSeconds: {
	    one: '1 секунда',
	    other: '{{count}} секунди'
	  },
	  halfAMinute: 'половина минута',
	  lessThanXMinutes: {
	    one: 'помалку од минута',
	    other: 'помалку од {{count}} минути'
	  },
	  xMinutes: {
	    one: '1 минута',
	    other: '{{count}} минути'
	  },
	  aboutXHours: {
	    one: 'околу 1 час',
	    other: 'околу {{count}} часа'
	  },
	  xHours: {
	    one: '1 час',
	    other: '{{count}} часа'
	  },
	  xDays: {
	    one: '1 ден',
	    other: '{{count}} дена'
	  },
	  aboutXWeeks: {
	    one: 'околу 1 недела',
	    other: 'околу {{count}} месеци'
	  },
	  xWeeks: {
	    one: '1 недела',
	    other: '{{count}} недели'
	  },
	  aboutXMonths: {
	    one: 'околу 1 месец',
	    other: 'околу {{count}} недели'
	  },
	  xMonths: {
	    one: '1 месец',
	    other: '{{count}} месеци'
	  },
	  aboutXYears: {
	    one: 'околу 1 година',
	    other: 'околу {{count}} години'
	  },
	  xYears: {
	    one: '1 година',
	    other: '{{count}} години'
	  },
	  overXYears: {
	    one: 'повеќе од 1 година',
	    other: 'повеќе од {{count}} години'
	  },
	  almostXYears: {
	    one: 'безмалку 1 година',
	    other: 'безмалку {{count}} години'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'за ' + result;
	    } else {
	      return 'пред ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, dd MMMM yyyy',
	  long: 'dd MMMM yyyy',
	  medium: 'dd MMM yyyy',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'H:mm'
	};
	var dateTimeFormats = {
	  any: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'any'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	
	var _index = _interopRequireDefault(__webpack_require__(46));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var weekdays = ['недела', 'понеделник', 'вторник', 'среда', 'четврток', 'петок', 'сабота'];
	
	function lastWeek(day) {
	  var weekday = weekdays[day];
	
	  switch (day) {
	    case 0:
	    case 3:
	    case 6:
	      return "'минатата " + weekday + " во' p";
	
	    case 1:
	    case 2:
	    case 4:
	    case 5:
	      return "'минатиот " + weekday + " во' p";
	  }
	}
	
	function thisWeek(day) {
	  var weekday = weekdays[day];
	
	  switch (day) {
	    case 0:
	    case 3:
	    case 6:
	      return "'ова " + weekday + " вo' p";
	
	    case 1:
	    case 2:
	    case 4:
	    case 5:
	      return "'овој " + weekday + " вo' p";
	  }
	}
	
	function nextWeek(day) {
	  var weekday = weekdays[day];
	
	  switch (day) {
	    case 0:
	    case 3:
	    case 6:
	      return "'следната " + weekday + " вo' p";
	
	    case 1:
	    case 2:
	    case 4:
	    case 5:
	      return "'следниот " + weekday + " вo' p";
	  }
	}
	
	var formatRelativeLocale = {
	  lastWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return lastWeek(day);
	    }
	  },
	  yesterday: "'вчера во' p",
	  today: "'денес во' p",
	  tomorrow: "'утре во' p",
	  nextWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return nextWeek(day);
	    }
	  },
	  other: 'P'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date, baseDate, options);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['пр.н.е.', 'н.е.'],
	  abbreviated: ['пред н. е.', 'н. е.'],
	  wide: ['пред нашата ера', 'нашата ера']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1-ви кв.', '2-ри кв.', '3-ти кв.', '4-ти кв.'],
	  wide: ['1-ви квартал', '2-ри квартал', '3-ти квартал', '4-ти квартал']
	};
	var monthValues = {
	  abbreviated: ['јан', 'фев', 'мар', 'апр', 'мај', 'јун', 'јул', 'авг', 'септ', 'окт', 'ноем', 'дек'],
	  wide: ['јануари', 'февруари', 'март', 'април', 'мај', 'јуни', 'јули', 'август', 'септември', 'октомври', 'ноември', 'декември']
	};
	var dayValues = {
	  narrow: ['Н', 'П', 'В', 'С', 'Ч', 'П', 'С'],
	  short: ['не', 'по', 'вт', 'ср', 'че', 'пе', 'са'],
	  abbreviated: ['нед', 'пон', 'вто', 'сре', 'чет', 'пет', 'саб'],
	  wide: ['недела', 'понеделник', 'вторник', 'среда', 'четврток', 'петок', 'сабота']
	};
	var dayPeriodValues = {
	  wide: {
	    am: 'претпладне',
	    pm: 'попладне',
	    midnight: 'полноќ',
	    noon: 'напладне',
	    morning: 'наутро',
	    afternoon: 'попладне',
	    evening: 'навечер',
	    night: 'ноќе'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  var rem100 = number % 100;
	
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + '-ви';
	
	      case 2:
	        return number + '-ри';
	
	      case 7:
	      case 8:
	        return number + '-ми';
	    }
	  }
	
	  return number + '-ти';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(8));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(-?[врмт][и])?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^((пр)?н\.?\s?е\.?)/i,
	  abbreviated: /^((пр)?н\.?\s?е\.?)/i,
	  wide: /^(пред нашата ера|нашата ера)/i
	};
	var parseEraPatterns = {
	  any: [/^п/i, /^н/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234](-?[врт]?и?)? кв.?/i,
	  wide: /^[1234](-?[врт]?и?)? квартал/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchDayPatterns = {
	  narrow: /^[нпвсч]/i,
	  short: /^(не|по|вт|ср|че|пе|са)/i,
	  abbreviated: /^(нед|пон|вто|сре|чет|пет|саб)/i,
	  wide: /^(недела|понеделник|вторник|среда|четврток|петок|сабота)/i
	};
	var parseDayPatterns = {
	  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
	  any: [/^н[ед]/i, /^п[он]/i, /^вт/i, /^ср/i, /^ч[ет]/i, /^п[ет]/i, /^с[аб]/i]
	};
	var matchMonthPatterns = {
	  abbreviated: /^(јан|фев|мар|апр|мај|јун|јул|авг|сеп|окт|ноем|дек)/i,
	  wide: /^(јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември)/i
	};
	var parseMonthPatterns = {
	  any: [/^ја/i, /^Ф/i, /^мар/i, /^ап/i, /^мај/i, /^јун/i, /^јул/i, /^ав/i, /^се/i, /^окт/i, /^но/i, /^де/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(претп|попл|полноќ|утро|пладне|вечер|ноќ)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /претпладне/i,
	    pm: /попладне/i,
	    midnight: /полноќ/i,
	    noon: /напладне/i,
	    morning: /наутро/i,
	    afternoon: /попладне/i,
	    evening: /навечер/i,
	    night: /ноќе/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1243));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1244));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1245));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1246));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1247));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Macedonian locale.
	 * @language Macedonian
	 * @iso-639-2 mkd
	 * @author Petar Vlahu [@vlahupetar]{@link https://github.com/vlahupetar}
	 * @author Altrim Beqiri [@altrim]{@link https://github.com/altrim}
	 */
	var locale = {
	  code: 'mk',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1249 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'секунд хүрэхгүй',
	    other: '{{count}} секунд хүрэхгүй'
	  },
	  xSeconds: {
	    one: '1 секунд',
	    other: '{{count}} секунд'
	  },
	  halfAMinute: 'хагас минут',
	  lessThanXMinutes: {
	    one: 'минут хүрэхгүй',
	    other: '{{count}} минут хүрэхгүй'
	  },
	  xMinutes: {
	    one: '1 минут',
	    other: '{{count}} минут'
	  },
	  aboutXHours: {
	    one: 'ойролцоогоор 1 цаг',
	    other: 'ойролцоогоор {{count}} цаг'
	  },
	  xHours: {
	    one: '1 цаг',
	    other: '{{count}} цаг'
	  },
	  xDays: {
	    one: '1 өдөр',
	    other: '{{count}} өдөр'
	  },
	  aboutXWeeks: {
	    one: 'ойролцоогоор 1 долоо хоног',
	    other: 'ойролцоогоор {{count}} долоо хоног'
	  },
	  xWeeks: {
	    one: '1 долоо хоног',
	    other: '{{count}} долоо хоног'
	  },
	  aboutXMonths: {
	    one: 'ойролцоогоор 1 сар',
	    other: 'ойролцоогоор {{count}} сар'
	  },
	  xMonths: {
	    one: '1 сар',
	    other: '{{count}} сар'
	  },
	  aboutXYears: {
	    one: 'ойролцоогоор 1 жил',
	    other: 'ойролцоогоор {{count}} жил'
	  },
	  xYears: {
	    one: '1 жил',
	    other: '{{count}} жил'
	  },
	  overXYears: {
	    one: '1 жил гаран',
	    other: '{{count}} жил гаран'
	  },
	  almostXYears: {
	    one: 'бараг 1 жил',
	    other: 'бараг {{count}} жил'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    /**
	     * Append genitive case
	     */
	    var words = result.split(' ');
	    var lastword = words.pop();
	    result = words.join(' ');
	
	    switch (lastword) {
	      case 'секунд':
	        result += ' секундийн';
	        break;
	
	      case 'минут':
	        result += ' минутын';
	        break;
	
	      case 'цаг':
	        result += ' цагийн';
	        break;
	
	      case 'өдөр':
	        result += ' өдрийн';
	        break;
	
	      case 'сар':
	        result += ' сарын';
	        break;
	
	      case 'жил':
	        result += ' жилийн';
	        break;
	
	      case 'хоног':
	        result += ' хоногийн';
	        break;
	
	      case 'гаран':
	        result += ' гараны';
	        break;
	
	      case 'хүрэхгүй':
	        result += ' хүрэхгүй хугацааны';
	        break;
	
	      default:
	        result += lastword + '-н';
	    }
	
	    if (options.comparison > 0) {
	      return result + ' дараа';
	    } else {
	      return result + ' өмнө';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "y 'оны' MMMM'ын' d, EEEE 'гараг'",
	  long: "y 'оны' MMMM'ын' d",
	  medium: "y 'оны' MMM'ын' d",
	  short: 'y.MM.dd'
	};
	var timeFormats = {
	  full: 'H:mm:ss zzzz',
	  long: 'H:mm:ss z',
	  medium: 'H:mm:ss',
	  short: 'H:mm'
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  long: '{{date}} {{time}}',
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1251 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'өнгөрсөн' eeee 'гарагийн' p 'цагт'",
	  yesterday: "'өчигдөр' p 'цагт'",
	  today: "'өнөөдөр' p 'цагт'",
	  tomorrow: "'маргааш' p 'цагт'",
	  nextWeek: "'ирэх' eeee 'гарагийн' p 'цагт'",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['НТӨ', 'НТ'],
	  abbreviated: ['НТӨ', 'НТ'],
	  wide: ['нийтийн тооллын өмнөх', 'нийтийн тооллын']
	};
	var quarterValues = {
	  narrow: ['I', 'II', 'III', 'IV'],
	  abbreviated: ['I улирал', 'II улирал', 'III улирал', 'IV улирал'],
	  wide: ['1-р улирал', '2-р улирал', '3-р улирал', '4-р улирал']
	}; // Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'],
	  abbreviated: ['1-р сар', '2-р сар', '3-р сар', '4-р сар', '5-р сар', '6-р сар', '7-р сар', '8-р сар', '9-р сар', '10-р сар', '11-р сар', '12-р сар'],
	  wide: ['Нэгдүгээр сар', 'Хоёрдугаар сар', 'Гуравдугаар сар', 'Дөрөвдүгээр сар', 'Тавдугаар сар', 'Зургаадугаар сар', 'Долоодугаар сар', 'Наймдугаар сар', 'Есдүгээр сар', 'Аравдугаар сар', 'Арваннэгдүгээр сар', 'Арван хоёрдугаар сар']
	};
	var formattingMonthValues = {
	  narrow: ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'],
	  abbreviated: ['1-р сар', '2-р сар', '3-р сар', '4-р сар', '5-р сар', '6-р сар', '7-р сар', '8-р сар', '9-р сар', '10-р сар', '11-р сар', '12-р сар'],
	  wide: ['нэгдүгээр сар', 'хоёрдугаар сар', 'гуравдугаар сар', 'дөрөвдүгээр сар', 'тавдугаар сар', 'зургаадугаар сар', 'долоодугаар сар', 'наймдугаар сар', 'есдүгээр сар', 'аравдугаар сар', 'арваннэгдүгээр сар', 'арван хоёрдугаар сар']
	};
	var dayValues = {
	  narrow: ['Н', 'Д', 'М', 'Л', 'П', 'Б', 'Б'],
	  short: ['Ня', 'Да', 'Мя', 'Лх', 'Пү', 'Ба', 'Бя'],
	  abbreviated: ['Ням', 'Дав', 'Мяг', 'Лха', 'Пүр', 'Баа', 'Бям'],
	  wide: ['Ням', 'Даваа', 'Мягмар', 'Лхагва', 'Пүрэв', 'Баасан', 'Бямба']
	};
	var formattingDayValues = {
	  narrow: ['Н', 'Д', 'М', 'Л', 'П', 'Б', 'Б'],
	  short: ['Ня', 'Да', 'Мя', 'Лх', 'Пү', 'Ба', 'Бя'],
	  abbreviated: ['Ням', 'Дав', 'Мяг', 'Лха', 'Пүр', 'Баа', 'Бям'],
	  wide: ['ням', 'даваа', 'мягмар', 'лхагва', 'пүрэв', 'баасан', 'бямба']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ү.ө.',
	    pm: 'ү.х.',
	    midnight: 'шөнө дунд',
	    noon: 'үд дунд',
	    morning: 'өглөө',
	    afternoon: 'өдөр',
	    evening: 'орой',
	    night: 'шөнө'
	  },
	  abbreviated: {
	    am: 'ү.ө.',
	    pm: 'ү.х.',
	    midnight: 'шөнө дунд',
	    noon: 'үд дунд',
	    morning: 'өглөө',
	    afternoon: 'өдөр',
	    evening: 'орой',
	    night: 'шөнө'
	  },
	  wide: {
	    am: 'ү.ө.',
	    pm: 'ү.х.',
	    midnight: 'шөнө дунд',
	    noon: 'үд дунд',
	    morning: 'өглөө',
	    afternoon: 'өдөр',
	    evening: 'орой',
	    night: 'шөнө'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	
	  return number;
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /\d+/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(нтө|нт)/i,
	  abbreviated: /^(нтө|нт)/i,
	  wide: /^(нийтийн тооллын өмнө|нийтийн тооллын)/i
	};
	var parseEraPatterns = {
	  any: [/^(нтө|нийтийн тооллын өмнө)/i, /^(нт|нийтийн тооллын)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^(iv|iii|ii|i)/i,
	  abbreviated: /^(iv|iii|ii|i) улирал/i,
	  wide: /^[1-4]-р улирал/i
	};
	var parseQuarterPatterns = {
	  any: [/^(i(\s|$)|1)/i, /^(ii(\s|$)|2)/i, /^(iii(\s|$)|3)/i, /^(iv(\s|$)|4)/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(xii|xi|x|ix|viii|vii|vi|v|iv|iii|ii|i)/i,
	  abbreviated: /^(1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар)/i,
	  wide: /^(нэгдүгээр сар|хоёрдугаар сар|гуравдугаар сар|дөрөвдүгээр сар|тавдугаар сар|зургаадугаар сар|долоодугаар сар|наймдугаар сар|есдүгээр сар|аравдугаар сар|арван нэгдүгээр сар|арван хоёрдугаар сар)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^i$/i, /^ii$/i, /^iii$/i, /^iv$/i, /^v$/i, /^vi$/i, /^vii$/i, /^viii$/i, /^ix$/i, /^x$/i, /^xi$/i, /^xii$/i],
	  any: [/^(1|нэгдүгээр)/i, /^(2|хоёрдугаар)/i, /^(3|гуравдугаар)/i, /^(4|дөрөвдүгээр)/i, /^(5|тавдугаар)/i, /^(6|зургаадугаар)/i, /^(7|долоодугаар)/i, /^(8|наймдугаар)/i, /^(9|есдүгээр)/i, /^(10|аравдугаар)/i, /^(11|арван нэгдүгээр)/i, /^(12|арван хоёрдугаар)/i]
	};
	var matchDayPatterns = {
	  narrow: /^[ндмлпбб]/i,
	  short: /^(ня|да|мя|лх|пү|ба|бя)/i,
	  abbreviated: /^(ням|дав|мяг|лха|пүр|баа|бям)/i,
	  wide: /^(ням|даваа|мягмар|лхагва|пүрэв|баасан|бямба)/i
	};
	var parseDayPatterns = {
	  narrow: [/^н/i, /^д/i, /^м/i, /^л/i, /^п/i, /^б/i, /^б/i],
	  any: [/^ня/i, /^да/i, /^мя/i, /^лх/i, /^пү/i, /^ба/i, /^бя/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i,
	  any: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^ү\.ө\./i,
	    pm: /^ү\.х\./i,
	    midnight: /^шөнө дунд/i,
	    noon: /^үд дунд/i,
	    morning: /өглөө/i,
	    afternoon: /өдөр/i,
	    evening: /орой/i,
	    night: /шөнө/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1249));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1250));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1251));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1252));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1253));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Mongolian locale.
	 * @language Mongolian
	 * @iso-639-2 mon
	 * @author Bilguun Ochirbat [@bilguun0203]{@link https://github.com/bilguun0203}
	 */
	var locale = {
	  code: 'mn',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1255 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'kurang dari 1 saat',
	    other: 'kurang dari {{count}} saat'
	  },
	  xSeconds: {
	    one: '1 saat',
	    other: '{{count}} saat'
	  },
	  halfAMinute: 'setengah minit',
	  lessThanXMinutes: {
	    one: 'kurang dari 1 minit',
	    other: 'kurang dari {{count}} minit'
	  },
	  xMinutes: {
	    one: '1 minit',
	    other: '{{count}} minit'
	  },
	  aboutXHours: {
	    one: 'sekitar 1 jam',
	    other: 'sekitar {{count}} jam'
	  },
	  xHours: {
	    one: '1 jam',
	    other: '{{count}} jam'
	  },
	  xDays: {
	    one: '1 hari',
	    other: '{{count}} hari'
	  },
	  aboutXWeeks: {
	    one: 'sekitar 1 minggu',
	    other: 'sekitar {{count}} minggu'
	  },
	  xWeeks: {
	    one: '1 minggu',
	    other: '{{count}} minggu'
	  },
	  aboutXMonths: {
	    one: 'sekitar 1 bulan',
	    other: 'sekitar {{count}} bulan'
	  },
	  xMonths: {
	    one: '1 bulan',
	    other: '{{count}} bulan'
	  },
	  aboutXYears: {
	    one: 'sekitar 1 tahun',
	    other: 'sekitar {{count}} tahun'
	  },
	  xYears: {
	    one: '1 tahun',
	    other: '{{count}} tahun'
	  },
	  overXYears: {
	    one: 'lebih dari 1 tahun',
	    other: 'lebih dari {{count}} tahun'
	  },
	  almostXYears: {
	    one: 'hampir 1 tahun',
	    other: 'hampir {{count}} tahun'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'dalam masa ' + result;
	    } else {
	      return result + ' yang lalu';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d MMMM yyyy',
	  long: 'd MMMM yyyy',
	  medium: 'd MMM yyyy',
	  short: 'd/M/yyyy'
	};
	var timeFormats = {
	  full: 'HH.mm.ss',
	  long: 'HH.mm.ss',
	  medium: 'HH.mm',
	  short: 'HH.mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'pukul' {{time}}",
	  long: "{{date}} 'pukul' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1257 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'lepas pada jam' p",
	  yesterday: "'Semalam pada jam' p",
	  today: "'Hari ini pada jam' p",
	  tomorrow: "'Esok pada jam' p",
	  nextWeek: "eeee 'pada jam' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Most data for localization are taken from this page
	// https://www.unicode.org/cldr/charts/32/summary/ms.html
	var eraValues = {
	  narrow: ['SM', 'M'],
	  abbreviated: ['SM', 'M'],
	  wide: ['Sebelum Masihi', 'Masihi']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['S1', 'S2', 'S3', 'S4'],
	  wide: ['Suku pertama', 'Suku kedua', 'Suku ketiga', 'Suku keempat']
	}; // Note: in Malay, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'O', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jan', 'Feb', 'Mac', 'Apr', 'Mei', 'Jun', 'Jul', 'Ogo', 'Sep', 'Okt', 'Nov', 'Dis'],
	  wide: ['Januari', 'Februari', 'Mac', 'April', 'Mei', 'Jun', 'Julai', 'Ogos', 'September', 'Oktober', 'November', 'Disember']
	};
	var dayValues = {
	  narrow: ['A', 'I', 'S', 'R', 'K', 'J', 'S'],
	  short: ['Ahd', 'Isn', 'Sel', 'Rab', 'Kha', 'Jum', 'Sab'],
	  abbreviated: ['Ahd', 'Isn', 'Sel', 'Rab', 'Kha', 'Jum', 'Sab'],
	  wide: ['Ahad', 'Isnin', 'Selasa', 'Rabu', 'Khamis', 'Jumaat', 'Sabtu']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'tgh malam',
	    noon: 'tgh hari',
	    morning: 'pagi',
	    afternoon: 'tengah hari',
	    evening: 'petang',
	    night: 'malam'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'tengah malam',
	    noon: 'tengah hari',
	    morning: 'pagi',
	    afternoon: 'tengah hari',
	    evening: 'petang',
	    night: 'malam'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'tengah malam',
	    noon: 'tengah hari',
	    morning: 'pagi',
	    afternoon: 'tengah hari',
	    evening: 'petang',
	    night: 'malam'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'tengah malam',
	    noon: 'tengah hari',
	    morning: 'pagi',
	    afternoon: 'tengah hari',
	    evening: 'petang',
	    night: 'malam'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'tengah malam',
	    noon: 'tengah hari',
	    morning: 'pagi',
	    afternoon: 'tengah hari',
	    evening: 'petang',
	    night: 'malam'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'tengah malam',
	    noon: 'tengah hari',
	    morning: 'pagi',
	    afternoon: 'tengah hari',
	    evening: 'petang',
	    night: 'malam'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber); // Can't use "pertama", "kedua" because can't be parsed
	
	  switch (number) {
	    default:
	      return 'ke-' + number;
	  }
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(8));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^ke-(\d+)?/i;
	var parseOrdinalNumberPattern = /petama|\d+/i;
	var matchEraPatterns = {
	  narrow: /^(sm|m)/i,
	  abbreviated: /^(s\.?\s?m\.?|m\.?)/i,
	  wide: /^(sebelum masihi|masihi)/i
	};
	var parseEraPatterns = {
	  any: [/^s/i, /^(m)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^S[1234]/i,
	  wide: /Suku (pertama|kedua|ketiga|keempat)/i
	};
	var parseQuarterPatterns = {
	  any: [/pertama|1/i, /kedua|2/i, /ketiga|3/i, /keempat|4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mac|apr|mei|jun|jul|ogo|sep|okt|nov|dis)/i,
	  wide: /^(januari|februari|mac|april|mei|jun|julai|ogos|september|oktober|november|disember)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^o/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^ma/i, /^ap/i, /^me/i, /^jun/i, /^jul/i, /^og/i, /^s/i, /^ok/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[aisrkj]/i,
	  short: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
	  abbreviated: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
	  wide: /^(ahad|isnin|selasa|rabu|khamis|jumaat|sabtu)/i
	};
	var parseDayPatterns = {
	  narrow: [/^a/i, /^i/i, /^s/i, /^r/i, /^k/i, /^j/i, /^s/i],
	  any: [/^a/i, /^i/i, /^se/i, /^r/i, /^k/i, /^j/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(am|pm|tengah malam|tengah hari|pagi|petang|malam)/i,
	  any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|pagi|petang|malam)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^pm/i,
	    midnight: /^tengah m/i,
	    noon: /^tengah h/i,
	    morning: /pa/i,
	    afternoon: /tengah h/i,
	    evening: /pe/i,
	    night: /m/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1255));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1256));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1257));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1258));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1259));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Malay locale.
	 * @language Malay
	 * @iso-639-2 msa
	 * @author Ruban Selvarajah [@Zyten]{@link https://github.com/Zyten}
	 */
	var locale = {
	  code: 'ms',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1261 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'inqas minn sekonda',
	    other: 'inqas minn {{count}} sekondi'
	  },
	  xSeconds: {
	    one: 'sekonda',
	    other: '{{count}} sekondi'
	  },
	  halfAMinute: 'nofs minuta',
	  lessThanXMinutes: {
	    one: 'inqas minn minuta',
	    other: 'inqas minn {{count}} minuti'
	  },
	  xMinutes: {
	    one: 'minuta',
	    other: '{{count}} minuti'
	  },
	  aboutXHours: {
	    one: 'madwar siegħa',
	    other: 'madwar {{count}} siegħat'
	  },
	  xHours: {
	    one: 'siegħa',
	    other: '{{count}} siegħat'
	  },
	  xDays: {
	    one: 'ġurnata',
	    other: '{{count}} ġranet'
	  },
	  aboutXWeeks: {
	    one: 'madwar ġimgħa',
	    other: 'madwar {{count}} ġimgħat'
	  },
	  xWeeks: {
	    one: 'ġimgħa',
	    other: '{{count}} ġimgħat'
	  },
	  aboutXMonths: {
	    one: 'madwar xahar',
	    other: 'madwar {{count}} xhur'
	  },
	  xMonths: {
	    one: 'xahar',
	    other: '{{count}} xhur'
	  },
	  aboutXYears: {
	    one: 'madwar sena',
	    two: 'madwar sentejn',
	    other: 'madwar {{count}} snin'
	  },
	  xYears: {
	    one: 'sena',
	    two: 'sentejn',
	    other: '{{count}} snin'
	  },
	  overXYears: {
	    one: 'aktar minn sena',
	    two: 'aktar minn sentejn',
	    other: 'aktar minn {{count}} snin'
	  },
	  almostXYears: {
	    one: 'kważi sena',
	    two: 'kważi sentejn',
	    other: 'kważi {{count}} snin'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var adverb = token.match(/years/i);
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else if (count === 2 && adverb) {
	    result = formatDistanceLocale[token].two;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return "f'" + result;
	    } else {
	      return result + ' ilu';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d MMMM yyyy',
	  long: 'd MMMM yyyy',
	  medium: 'd MMM yyyy',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  long: '{{date}} {{time}}',
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1263 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'li għadda' 'fil-'p",
	  yesterday: "'Il-bieraħ fil-'p",
	  today: "'Illum fil-'p",
	  tomorrow: "'Għada fil-'p",
	  nextWeek: "eeee 'fil-'p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['Q', 'W'],
	  abbreviated: ['QK', 'WK'],
	  wide: ['qabel Kristu', 'wara Kristu']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['K1', 'K2', 'K3', 'K4'],
	  wide: ['1. kwart', '2. kwart', '3. kwart', '4. kwart']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'Ġ', 'L', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jan', 'Fra', 'Mar', 'Apr', 'Mej', 'Ġun', 'Lul', 'Aww', 'Set', 'Ott', 'Nov', 'Diċ'],
	  wide: ['Jannar', 'Frar', 'Marzu', 'April', 'Mejju', 'Ġunju', 'Lulju', 'Awwissu', 'Settembru', 'Ottubru', 'Novembru', 'Diċembru']
	};
	var dayValues = {
	  narrow: ['Ħ', 'T', 'T', 'E', 'Ħ', 'Ġ', 'S'],
	  short: ['Ħa', 'Tn', 'Tl', 'Er', 'Ħa', 'Ġi', 'Si'],
	  abbreviated: ['Ħad', 'Tne', 'Tli', 'Erb', 'Ħam', 'Ġim', 'Sib'],
	  wide: ['Il-Ħadd', 'It-Tnejn', 'It-Tlieta', 'L-Erbgħa', 'Il-Ħamis', 'Il-Ġimgħa', 'Is-Sibt']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'nofsillejl',
	    noon: 'nofsinhar',
	    morning: 'għodwa',
	    afternoon: 'wara nofsinhar',
	    evening: 'filgħaxija',
	    night: 'lejl'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'nofsillejl',
	    noon: 'nofsinhar',
	    morning: 'għodwa',
	    afternoon: 'wara nofsinhar',
	    evening: 'filgħaxija',
	    night: 'lejl'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'nofsillejl',
	    noon: 'nofsinhar',
	    morning: 'għodwa',
	    afternoon: 'wara nofsinhar',
	    evening: 'filgħaxija',
	    night: 'lejl'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: "f'nofsillejl",
	    noon: "f'nofsinhar",
	    morning: 'filgħodu',
	    afternoon: 'wara nofsinhar',
	    evening: 'filgħaxija',
	    night: 'billejl'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: "f'nofsillejl",
	    noon: "f'nofsinhar",
	    morning: 'filgħodu',
	    afternoon: 'wara nofsinhar',
	    evening: 'filgħaxija',
	    night: 'billejl'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: "f'nofsillejl",
	    noon: "f'nofsinhar",
	    morning: 'filgħodu',
	    afternoon: 'wara nofsinhar',
	    evening: 'filgħaxija',
	    night: 'billejl'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + 'º';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(q|w)/i,
	  abbreviated: /^(q\.?\s?k\.?|b\.?\s?c\.?\s?e\.?|w\.?\s?k\.?)/i,
	  wide: /^(qabel kristu|before common era|wara kristu|common era)/i
	};
	var parseEraPatterns = {
	  any: [/^(q|b)/i, /^(w|c)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^k[1234]/i,
	  wide: /^[1234](\.)? kwart/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmaglsond]/i,
	  abbreviated: /^(jan|fra|mar|apr|mej|ġun|lul|aww|set|ott|nov|diċ)/i,
	  wide: /^(jannar|frar|marzu|april|mejju|ġunju|lulju|awwissu|settembru|ottubru|novembru|diċembru)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^ġ/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mej/i, /^ġ/i, /^l/i, /^aw/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[ħteġs]/i,
	  short: /^(ħa|tn|tl|er|ħa|ġi|si)/i,
	  abbreviated: /^(ħad|tne|tli|erb|ħam|ġim|sib)/i,
	  wide: /^(il-ħadd|it-tnejn|it-tlieta|l-erbgħa|il-ħamis|il-ġimgħa|is-sibt)/i
	};
	var parseDayPatterns = {
	  narrow: [/^ħ/i, /^t/i, /^t/i, /^e/i, /^ħ/i, /^ġ/i, /^s/i],
	  any: [/^(il-)?ħad/i, /^(it-)?tn/i, /^(it-)?tl/i, /^(l-)?er/i, /^(il-)?ham/i, /^(il-)?ġi/i, /^(is-)?si/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i,
	  any: /^([ap]\.?\s?m\.?|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^f'nofsillejl/i,
	    noon: /^f'nofsinhar/i,
	    morning: /għodwa/i,
	    afternoon: /wara(\s.*)nofsinhar/i,
	    evening: /filgħaxija/i,
	    night: /lejl/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1261));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1262));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1263));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1264));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1265));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Maltese locale.
	 * @language Maltese
	 * @iso-639-2 mlt
	 * @author Andras Matzon [@amatzon](@link https://github.com/amatzon)
	 * @author Bryan Borg [@bryanMt](@link https://github.com/bryanMt)
	 */
	var locale = {
	  code: 'mt',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1267 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    singular: 'mindre enn ett sekund',
	    plural: 'mindre enn {{count}} sekunder'
	  },
	  xSeconds: {
	    singular: 'ett sekund',
	    plural: '{{count}} sekunder'
	  },
	  halfAMinute: 'et halvt minutt',
	  lessThanXMinutes: {
	    singular: 'mindre enn ett minutt',
	    plural: 'mindre enn {{count}} minutter'
	  },
	  xMinutes: {
	    singular: 'ett minutt',
	    plural: '{{count}} minutter'
	  },
	  aboutXHours: {
	    singular: 'omtrent en time',
	    plural: 'omtrent {{count}} timer'
	  },
	  xHours: {
	    singular: 'en time',
	    plural: '{{count}} timer'
	  },
	  xDays: {
	    singular: 'en dag',
	    plural: '{{count}} dager'
	  },
	  aboutXWeeks: {
	    singular: 'omtrent en uke',
	    plural: 'omtrent {{count}} uker'
	  },
	  xWeeks: {
	    singular: 'en uke',
	    plural: '{{count}} uker'
	  },
	  aboutXMonths: {
	    singular: 'omtrent en måned',
	    plural: 'omtrent {{count}} måneder'
	  },
	  xMonths: {
	    singular: 'en måned',
	    plural: '{{count}} måneder'
	  },
	  aboutXYears: {
	    singular: 'omtrent ett år',
	    plural: 'omtrent {{count}} år'
	  },
	  xYears: {
	    singular: 'ett år',
	    plural: '{{count}} år'
	  },
	  overXYears: {
	    singular: 'over ett år',
	    plural: 'over {{count}} år'
	  },
	  almostXYears: {
	    singular: 'nesten ett år',
	    plural: 'nesten {{count}} år'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var translation = formatDistanceLocale[token];
	  var result;
	
	  if (typeof translation === 'string') {
	    result = translation;
	  } else if (count === 0 || count > 1) {
	    result = translation.plural.replace('{{count}}', count);
	  } else {
	    result = translation.singular;
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'om ' + result;
	    } else {
	      return result + ' siden';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE d. MMMM y',
	  long: 'd. MMMM y',
	  medium: 'd. MMM y',
	  short: 'dd.MM.y'
	};
	var timeFormats = {
	  full: "'kl'. HH:mm:ss zzzz",
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'kl.' {{time}}",
	  long: "{{date}} 'kl.' {{time}}",
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1269 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'forrige' eeee 'kl.' p",
	  yesterday: "'i går kl.' p",
	  today: "'i dag kl.' p",
	  tomorrow: "'i morgen kl.' p",
	  nextWeek: "EEEE 'kl.' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['f.Kr.', 'e.Kr.'],
	  abbreviated: ['f.Kr.', 'e.Kr.'],
	  wide: ['før Kristus', 'etter Kristus']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['jan.', 'feb.', 'mars', 'apr.', 'mai', 'juni', 'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'des.'],
	  wide: ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember']
	};
	var dayValues = {
	  narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
	  short: ['sø', 'ma', 'ti', 'on', 'to', 'fr', 'lø'],
	  abbreviated: ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'],
	  wide: ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'midnatt',
	    noon: 'middag',
	    morning: 'på morg.',
	    afternoon: 'på etterm.',
	    evening: 'på kvelden',
	    night: 'på natten'
	  },
	  abbreviated: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnatt',
	    noon: 'middag',
	    morning: 'på morg.',
	    afternoon: 'på etterm.',
	    evening: 'på kvelden',
	    night: 'på natten'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnatt',
	    noon: 'middag',
	    morning: 'på morgenen',
	    afternoon: 'på ettermiddagen',
	    evening: 'på kvelden',
	    night: 'på natten'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)\.?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
	  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
	  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
	};
	var parseEraPatterns = {
	  any: [/^f/i, /^e/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](\.)? kvartal/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
	  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smtofl]/i,
	  short: /^(sø|ma|ti|on|to|fr|lø)/i,
	  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
	  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
	};
	var parseDayPatterns = {
	  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
	  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a(\.?\s?m\.?)?$/i,
	    pm: /^p(\.?\s?m\.?)?$/i,
	    midnight: /^midn/i,
	    noon: /^midd/i,
	    morning: /morgen/i,
	    afternoon: /ettermiddag/i,
	    evening: /kveld/i,
	    night: /natt/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1267));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1268));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1269));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1270));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1271));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Norwegian Bokmål locale.
	 * @language Norwegian Bokmål
	 * @iso-639-2 nob
	 * @author Hans-Kristian Koren [@Hanse]{@link https://github.com/Hanse}
	 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
	 * @author Dag Stuan [@dagstuan]{@link https://github.com/dagstuan}
	 */
	var locale = {
	  code: 'nb',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1273 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'minder dan een seconde',
	    other: 'minder dan {{count}} seconden'
	  },
	  xSeconds: {
	    one: '1 seconde',
	    other: '{{count}} seconden'
	  },
	  halfAMinute: 'een halve minuut',
	  lessThanXMinutes: {
	    one: 'minder dan een minuut',
	    other: 'minder dan {{count}} minuten'
	  },
	  xMinutes: {
	    one: 'een minuut',
	    other: '{{count}} minuten'
	  },
	  aboutXHours: {
	    one: 'ongeveer 1 uur',
	    other: 'ongeveer {{count}} uur'
	  },
	  xHours: {
	    one: '1 uur',
	    other: '{{count}} uur'
	  },
	  xDays: {
	    one: '1 dag',
	    other: '{{count}} dagen'
	  },
	  aboutXWeeks: {
	    one: 'ongeveer 1 week',
	    other: 'ongeveer {{count}} weken'
	  },
	  xWeeks: {
	    one: '1 week',
	    other: '{{count}} weken'
	  },
	  aboutXMonths: {
	    one: 'ongeveer 1 maand',
	    other: 'ongeveer {{count}} maanden'
	  },
	  xMonths: {
	    one: '1 maand',
	    other: '{{count}} maanden'
	  },
	  aboutXYears: {
	    one: 'ongeveer 1 jaar',
	    other: 'ongeveer {{count}} jaar'
	  },
	  xYears: {
	    one: '1 jaar',
	    other: '{{count}} jaar'
	  },
	  overXYears: {
	    one: 'meer dan 1 jaar',
	    other: 'meer dan {{count}} jaar'
	  },
	  almostXYears: {
	    one: 'bijna 1 jaar',
	    other: 'bijna {{count}} jaar'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'over ' + result;
	    } else {
	      return result + ' geleden';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE d MMMM y',
	  long: 'd MMMM y',
	  medium: 'd MMM y',
	  short: 'dd.MM.y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'om' {{time}}",
	  long: "{{date}} 'om' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1275 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'vorige' eeee 'om' p",
	  yesterday: "'gisteren om' p",
	  today: "'vandaag om' p",
	  tomorrow: "'morgen om' p",
	  nextWeek: "eeee 'om' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['v.C.', 'n.C.'],
	  abbreviated: ['v.Chr.', 'n.Chr.'],
	  wide: ['voor Christus', 'na Christus']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['K1', 'K2', 'K3', 'K4'],
	  wide: ['1e kwartaal', '2e kwartaal', '3e kwartaal', '4e kwartaal']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['jan.', 'feb.', 'mrt.', 'apr.', 'mei', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
	  wide: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december']
	};
	var dayValues = {
	  narrow: ['Z', 'M', 'D', 'W', 'D', 'V', 'Z'],
	  short: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
	  abbreviated: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
	  wide: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'middernacht',
	    noon: 'het middag',
	    morning: "'s ochtends",
	    afternoon: "'s namiddags",
	    evening: "'s avonds",
	    night: "'s nachts"
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'middernacht',
	    noon: 'het middag',
	    morning: "'s ochtends",
	    afternoon: "'s namiddags",
	    evening: "'s avonds",
	    night: "'s nachts"
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'middernacht',
	    noon: 'het middag',
	    morning: "'s ochtends",
	    afternoon: "'s namiddags",
	    evening: "'s avonds",
	    night: "'s nachts"
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + 'e';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)e?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^([vn]\.? ?C\.?)/,
	  abbreviated: /^([vn]\. ?Chr\.?)/,
	  wide: /^((voor|na) Christus)/
	};
	var parseEraPatterns = {
	  any: [/^v/, /^n/]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^K[1234]/i,
	  wide: /^[1234]e kwartaal/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
	  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
	};
	var matchDayPatterns = {
	  narrow: /^[zmdwv]/i,
	  short: /^(zo|ma|di|wo|do|vr|za)/i,
	  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
	  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
	};
	var parseDayPatterns = {
	  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
	  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^am/i,
	    pm: /^pm/i,
	    midnight: /^middernacht/i,
	    noon: /^het middaguur/i,
	    morning: /ochtend/i,
	    afternoon: /middag/i,
	    evening: /avond/i,
	    night: /nacht/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1273));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1274));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1275));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1276));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1277));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Dutch locale.
	 * @language Dutch
	 * @iso-639-2 nld
	 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
	 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
	 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
	 * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
	 */
	var locale = {
	  code: 'nl-BE',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1279 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'minder dan een seconde',
	    other: 'minder dan {{count}} seconden'
	  },
	  xSeconds: {
	    one: '1 seconde',
	    other: '{{count}} seconden'
	  },
	  halfAMinute: 'een halve minuut',
	  lessThanXMinutes: {
	    one: 'minder dan een minuut',
	    other: 'minder dan {{count}} minuten'
	  },
	  xMinutes: {
	    one: 'een minuut',
	    other: '{{count}} minuten'
	  },
	  aboutXHours: {
	    one: 'ongeveer 1 uur',
	    other: 'ongeveer {{count}} uur'
	  },
	  xHours: {
	    one: '1 uur',
	    other: '{{count}} uur'
	  },
	  xDays: {
	    one: '1 dag',
	    other: '{{count}} dagen'
	  },
	  aboutXWeeks: {
	    one: 'ongeveer 1 week',
	    other: 'ongeveer {{count}} weken'
	  },
	  xWeeks: {
	    one: '1 week',
	    other: '{{count}} weken'
	  },
	  aboutXMonths: {
	    one: 'ongeveer 1 maand',
	    other: 'ongeveer {{count}} maanden'
	  },
	  xMonths: {
	    one: '1 maand',
	    other: '{{count}} maanden'
	  },
	  aboutXYears: {
	    one: 'ongeveer 1 jaar',
	    other: 'ongeveer {{count}} jaar'
	  },
	  xYears: {
	    one: '1 jaar',
	    other: '{{count}} jaar'
	  },
	  overXYears: {
	    one: 'meer dan 1 jaar',
	    other: 'meer dan {{count}} jaar'
	  },
	  almostXYears: {
	    one: 'bijna 1 jaar',
	    other: 'bijna {{count}} jaar'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'over ' + result;
	    } else {
	      return result + ' geleden';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE d MMMM y',
	  long: 'd MMMM y',
	  medium: 'd MMM y',
	  short: 'dd-MM-y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'om' {{time}}",
	  long: "{{date}} 'om' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1281 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'afgelopen' eeee 'om' p",
	  yesterday: "'gisteren om' p",
	  today: "'vandaag om' p",
	  tomorrow: "'morgen om' p",
	  nextWeek: "eeee 'om' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['v.C.', 'n.C.'],
	  abbreviated: ['v.Chr.', 'n.Chr.'],
	  wide: ['voor Christus', 'na Christus']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['K1', 'K2', 'K3', 'K4'],
	  wide: ['1e kwartaal', '2e kwartaal', '3e kwartaal', '4e kwartaal']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['jan.', 'feb.', 'mrt.', 'apr.', 'mei', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
	  wide: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december']
	};
	var dayValues = {
	  narrow: ['Z', 'M', 'D', 'W', 'D', 'V', 'Z'],
	  short: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
	  abbreviated: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
	  wide: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'middernacht',
	    noon: 'het middaguur',
	    morning: "'s ochtends",
	    afternoon: "'s middags",
	    evening: "'s avonds",
	    night: "'s nachts"
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'middernacht',
	    noon: 'het middaguur',
	    morning: "'s ochtends",
	    afternoon: "'s middags",
	    evening: "'s avonds",
	    night: "'s nachts"
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'middernacht',
	    noon: 'het middaguur',
	    morning: "'s ochtends",
	    afternoon: "'s middags",
	    evening: "'s avonds",
	    night: "'s nachts"
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + 'e';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)e?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^([vn]\.? ?C\.?)/,
	  abbreviated: /^([vn]\. ?Chr\.?)/,
	  wide: /^((voor|na) Christus)/
	};
	var parseEraPatterns = {
	  any: [/^v/, /^n/]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^K[1234]/i,
	  wide: /^[1234]e kwartaal/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
	  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
	};
	var matchDayPatterns = {
	  narrow: /^[zmdwv]/i,
	  short: /^(zo|ma|di|wo|do|vr|za)/i,
	  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
	  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
	};
	var parseDayPatterns = {
	  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
	  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^am/i,
	    pm: /^pm/i,
	    midnight: /^middernacht/i,
	    noon: /^het middaguur/i,
	    morning: /ochtend/i,
	    afternoon: /middag/i,
	    evening: /avond/i,
	    night: /nacht/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1279));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1280));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1281));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1282));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1283));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Dutch locale.
	 * @language Dutch
	 * @iso-639-2 nld
	 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
	 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
	 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
	 * @author Edo Rivai [@edorivai]{@link https://github.com/edorivai}
	 * @author Niels Keurentjes [@curry684]{@link https://github.com/curry684}
	 * @author Stefan Vermaas [@stefanvermaas]{@link https://github.com/stefanvermaas}
	 */
	var locale = {
	  code: 'nl',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1285 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    singular: 'mindre enn eitt sekund',
	    plural: 'mindre enn {{count}} sekund'
	  },
	  xSeconds: {
	    singular: 'eitt sekund',
	    plural: '{{count}} sekund'
	  },
	  halfAMinute: 'eit halvt minutt',
	  lessThanXMinutes: {
	    singular: 'mindre enn eitt minutt',
	    plural: 'mindre enn {{count}} minutt'
	  },
	  xMinutes: {
	    singular: 'eitt minutt',
	    plural: '{{count}} minutt'
	  },
	  aboutXHours: {
	    singular: 'omtrent ein time',
	    plural: 'omtrent {{count}} timar'
	  },
	  xHours: {
	    singular: 'ein time',
	    plural: '{{count}} timar'
	  },
	  xDays: {
	    singular: 'ein dag',
	    plural: '{{count}} dagar'
	  },
	  aboutXWeeks: {
	    singular: 'omtrent ei veke',
	    plural: 'omtrent {{count}} veker'
	  },
	  xWeeks: {
	    singular: 'ei veke',
	    plural: '{{count}} veker'
	  },
	  aboutXMonths: {
	    singular: 'omtrent ein månad',
	    plural: 'omtrent {{count}} månader'
	  },
	  xMonths: {
	    singular: 'ein månad',
	    plural: '{{count}} månader'
	  },
	  aboutXYears: {
	    singular: 'omtrent eitt år',
	    plural: 'omtrent {{count}} år'
	  },
	  xYears: {
	    singular: 'eitt år',
	    plural: '{{count}} år'
	  },
	  overXYears: {
	    singular: 'over eitt år',
	    plural: 'over {{count}} år'
	  },
	  almostXYears: {
	    singular: 'nesten eitt år',
	    plural: 'nesten {{count}} år'
	  }
	};
	var wordMapping = ['null', 'ein', 'to', 'tre', 'fire', 'fem', 'seks', 'sju', 'åtte', 'ni', 'ti', 'elleve', 'tolv'];
	
	function formatDistance(token, count, options) {
	  options = options || {
	    onlyNumeric: false
	  };
	  var translation = formatDistanceLocale[token];
	  var result;
	
	  if (typeof translation === 'string') {
	    result = translation;
	  } else if (count === 0 || count > 1) {
	    if (options.onlyNumeric) {
	      result = translation.plural.replace('{{count}}', count);
	    } else {
	      result = translation.plural.replace('{{count}}', count < 13 ? wordMapping[count] : count);
	    }
	  } else {
	    result = translation.singular;
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'om ' + result;
	    } else {
	      return result + ' sidan';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE d. MMMM y',
	  long: 'd. MMMM y',
	  medium: 'd. MMM y',
	  short: 'dd.MM.y'
	};
	var timeFormats = {
	  full: "'kl'. HH:mm:ss zzzz",
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'kl.' {{time}}",
	  long: "{{date}} 'kl.' {{time}}",
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1287 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'førre' eeee 'kl.' p",
	  yesterday: "'i går kl.' p",
	  today: "'i dag kl.' p",
	  tomorrow: "'i morgon kl.' p",
	  nextWeek: "EEEE 'kl.' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['f.Kr.', 'e.Kr.'],
	  abbreviated: ['f.Kr.', 'e.Kr.'],
	  wide: ['før Kristus', 'etter Kristus']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['jan.', 'feb.', 'mars', 'apr.', 'mai', 'juni', 'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'des.'],
	  wide: ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember']
	};
	var dayValues = {
	  narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
	  short: ['su', 'må', 'ty', 'on', 'to', 'fr', 'lau'],
	  abbreviated: ['sun', 'mån', 'tys', 'ons', 'tor', 'fre', 'laur'],
	  wide: ['sundag', 'måndag', 'tysdag', 'onsdag', 'torsdag', 'fredag', 'laurdag']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'midnatt',
	    noon: 'middag',
	    morning: 'på morg.',
	    afternoon: 'på etterm.',
	    evening: 'på kvelden',
	    night: 'på natta'
	  },
	  abbreviated: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnatt',
	    noon: 'middag',
	    morning: 'på morg.',
	    afternoon: 'på etterm.',
	    evening: 'på kvelden',
	    night: 'på natta'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnatt',
	    noon: 'middag',
	    morning: 'på morgonen',
	    afternoon: 'på ettermiddagen',
	    evening: 'på kvelden',
	    night: 'på natta'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)\.?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
	  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
	  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
	};
	var parseEraPatterns = {
	  any: [/^f/i, /^e/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](\.)? kvartal/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
	  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smtofl]/i,
	  short: /^(su|må|ty|on|to|fr|la)/i,
	  abbreviated: /^(sun|mån|tys|ons|tor|fre|laur)/i,
	  wide: /^(sundag|måndag|tysdag|onsdag|torsdag|fredag|laurdag)/i
	};
	var parseDayPatterns = {
	  any: [/^s/i, /^m/i, /^ty/i, /^o/i, /^to/i, /^f/i, /^l/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta)|[ap])/i,
	  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a(\.?\s?m\.?)?$/i,
	    pm: /^p(\.?\s?m\.?)?$/i,
	    midnight: /^midn/i,
	    noon: /^midd/i,
	    morning: /morgon/i,
	    afternoon: /ettermiddag/i,
	    evening: /kveld/i,
	    night: /natt/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1285));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1286));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1287));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1288));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1289));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Norwegian Nynorsk locale.
	 * @language Norwegian Nynorsk
	 * @iso-639-2 nno
	 * @author Mats Byrkjeland [@draperunner]{@link https://github.com/draperunner}
	 */
	var locale = {
	  code: 'nn',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1291 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	
	function declensionGroup(scheme, count) {
	  if (count === 1) {
	    return scheme.one;
	  }
	
	  var rem100 = count % 100; // ends with 11-20
	
	  if (rem100 <= 20 && rem100 > 10) {
	    return scheme.other;
	  }
	
	  var rem10 = rem100 % 10; // ends with 2, 3, 4
	
	  if (rem10 >= 2 && rem10 <= 4) {
	    return scheme.twoFour;
	  }
	
	  return scheme.other;
	}
	
	function declension(scheme, count, time) {
	  time = time || 'regular';
	  var group = declensionGroup(scheme, count);
	  var finalText = group[time] || group;
	  return finalText.replace('{{count}}', count);
	}
	
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: {
	      regular: 'mniej niż sekunda',
	      past: 'mniej niż sekundę',
	      future: 'mniej niż sekundę'
	    },
	    twoFour: 'mniej niż {{count}} sekundy',
	    other: 'mniej niż {{count}} sekund'
	  },
	  xSeconds: {
	    one: {
	      regular: 'sekunda',
	      past: 'sekundę',
	      future: 'sekundę'
	    },
	    twoFour: '{{count}} sekundy',
	    other: '{{count}} sekund'
	  },
	  halfAMinute: {
	    one: 'pół minuty',
	    twoFour: 'pół minuty',
	    other: 'pół minuty'
	  },
	  lessThanXMinutes: {
	    one: {
	      regular: 'mniej niż minuta',
	      past: 'mniej niż minutę',
	      future: 'mniej niż minutę'
	    },
	    twoFour: 'mniej niż {{count}} minuty',
	    other: 'mniej niż {{count}} minut'
	  },
	  xMinutes: {
	    one: {
	      regular: 'minuta',
	      past: 'minutę',
	      future: 'minutę'
	    },
	    twoFour: '{{count}} minuty',
	    other: '{{count}} minut'
	  },
	  aboutXHours: {
	    one: {
	      regular: 'około godziny',
	      past: 'około godziny',
	      future: 'około godzinę'
	    },
	    twoFour: 'około {{count}} godziny',
	    other: 'około {{count}} godzin'
	  },
	  xHours: {
	    one: {
	      regular: 'godzina',
	      past: 'godzinę',
	      future: 'godzinę'
	    },
	    twoFour: '{{count}} godziny',
	    other: '{{count}} godzin'
	  },
	  xDays: {
	    one: {
	      regular: 'dzień',
	      past: 'dzień',
	      future: '1 dzień'
	    },
	    twoFour: '{{count}} dni',
	    other: '{{count}} dni'
	  },
	  aboutXWeeks: {
	    one: 'około tygodnia',
	    twoFour: 'około {{count}} tygodni',
	    other: 'około {{count}} tygodni'
	  },
	  xWeeks: {
	    one: 'tydzień',
	    twoFour: '{{count}} tygodnie',
	    other: '{{count}} tygodni'
	  },
	  aboutXMonths: {
	    one: 'około miesiąc',
	    twoFour: 'około {{count}} miesiące',
	    other: 'około {{count}} miesięcy'
	  },
	  xMonths: {
	    one: 'miesiąc',
	    twoFour: '{{count}} miesiące',
	    other: '{{count}} miesięcy'
	  },
	  aboutXYears: {
	    one: 'około rok',
	    twoFour: 'około {{count}} lata',
	    other: 'około {{count}} lat'
	  },
	  xYears: {
	    one: 'rok',
	    twoFour: '{{count}} lata',
	    other: '{{count}} lat'
	  },
	  overXYears: {
	    one: 'ponad rok',
	    twoFour: 'ponad {{count}} lata',
	    other: 'ponad {{count}} lat'
	  },
	  almostXYears: {
	    one: 'prawie rok',
	    twoFour: 'prawie {{count}} lata',
	    other: 'prawie {{count}} lat'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var scheme = formatDistanceLocale[token];
	
	  if (!options.addSuffix) {
	    return declension(scheme, count);
	  }
	
	  if (options.comparison > 0) {
	    return 'za ' + declension(scheme, count, 'future');
	  } else {
	    return declension(scheme, count, 'past') + ' temu';
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, do MMMM y',
	  long: 'do MMMM y',
	  medium: 'do MMM y',
	  short: 'dd.MM.y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  long: '{{date}} {{time}}',
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	
	var _index = _interopRequireDefault(__webpack_require__(46));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adjectivesLastWeek = {
	  masculine: 'ostatni',
	  feminine: 'ostatnia'
	};
	var adjectivesThisWeek = {
	  masculine: 'ten',
	  feminine: 'ta'
	};
	var adjectivesNextWeek = {
	  masculine: 'następny',
	  feminine: 'następna'
	};
	var dayGrammaticalGender = {
	  0: 'feminine',
	  1: 'masculine',
	  2: 'masculine',
	  3: 'feminine',
	  4: 'masculine',
	  5: 'masculine',
	  6: 'feminine'
	};
	
	function getAdjectives(token, date, baseDate, options) {
	  if ((0, _index.default)(date, baseDate, options)) {
	    return adjectivesThisWeek;
	  } else if (token === 'lastWeek') {
	    return adjectivesLastWeek;
	  } else if (token === 'nextWeek') {
	    return adjectivesNextWeek;
	  } else {
	    throw new Error("Cannot determine adjectives for token ".concat(token));
	  }
	}
	
	function getAdjective(token, date, baseDate, options) {
	  var day = date.getUTCDay();
	  var adjectives = getAdjectives(token, date, baseDate, options);
	  var grammaticalGender = dayGrammaticalGender[day];
	  return adjectives[grammaticalGender];
	}
	
	function dayAndTimeWithAdjective(token, date, baseDate, options) {
	  var adjective = getAdjective(token, date, baseDate, options);
	  return "'".concat(adjective, "' eeee 'o' p");
	}
	
	var formatRelativeLocale = {
	  lastWeek: dayAndTimeWithAdjective,
	  yesterday: "'wczoraj o' p",
	  today: "'dzisiaj o' p",
	  tomorrow: "'jutro o' p",
	  nextWeek: dayAndTimeWithAdjective,
	  other: 'P'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(token, date, baseDate, options);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return String(number);
	}
	
	var eraValues = {
	  narrow: ['p.n.e.', 'n.e.'],
	  abbreviated: ['p.n.e.', 'n.e.'],
	  wide: ['przed naszą erą', 'naszej ery']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['I kw.', 'II kw.', 'III kw.', 'IV kw.'],
	  wide: ['I kwartał', 'II kwartał', 'III kwartał', 'IV kwartał']
	};
	var monthValues = {
	  narrow: ['S', 'L', 'M', 'K', 'M', 'C', 'L', 'S', 'W', 'P', 'L', 'G'],
	  abbreviated: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
	  wide: ['styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec', 'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień']
	};
	var monthFormattingValues = {
	  narrow: ['s', 'l', 'm', 'k', 'm', 'c', 'l', 's', 'w', 'p', 'l', 'g'],
	  abbreviated: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
	  wide: ['stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca', 'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia']
	};
	var dayValues = {
	  narrow: ['N', 'P', 'W', 'Ś', 'C', 'P', 'S'],
	  short: ['nie', 'pon', 'wto', 'śro', 'czw', 'pią', 'sob'],
	  abbreviated: ['niedz.', 'pon.', 'wt.', 'śr.', 'czw.', 'pt.', 'sob.'],
	  wide: ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota']
	};
	var dayFormattingValues = {
	  narrow: ['n', 'p', 'w', 'ś', 'c', 'p', 's'],
	  short: ['nie', 'pon', 'wto', 'śro', 'czw', 'pią', 'sob'],
	  abbreviated: ['niedz.', 'pon.', 'wt.', 'śr.', 'czw.', 'pt.', 'sob.'],
	  wide: ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'półn.',
	    noon: 'poł',
	    morning: 'rano',
	    afternoon: 'popoł.',
	    evening: 'wiecz.',
	    night: 'noc'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'północ',
	    noon: 'południe',
	    morning: 'rano',
	    afternoon: 'popołudnie',
	    evening: 'wieczór',
	    night: 'noc'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'północ',
	    noon: 'południe',
	    morning: 'rano',
	    afternoon: 'popołudnie',
	    evening: 'wieczór',
	    night: 'noc'
	  }
	};
	var dayPeriodFormattingValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'o półn.',
	    noon: 'w poł.',
	    morning: 'rano',
	    afternoon: 'po poł.',
	    evening: 'wiecz.',
	    night: 'w nocy'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'o północy',
	    noon: 'w południe',
	    morning: 'rano',
	    afternoon: 'po południu',
	    evening: 'wieczorem',
	    night: 'w nocy'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'o północy',
	    noon: 'w południe',
	    morning: 'rano',
	    afternoon: 'po południu',
	    evening: 'wieczorem',
	    night: 'w nocy'
	  }
	};
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: monthFormattingValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide',
	    formattingValues: dayFormattingValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: dayPeriodFormattingValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
	  abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
	  wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
	};
	var parseEraPatterns = {
	  any: [/^p/i, /^n/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
	  wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
	};
	var parseQuarterPatterns = {
	  narrow: [/1/i, /2/i, /3/i, /4/i],
	  any: [/^I kw/i, /^II kw/i, /^III kw/i, /^IV kw/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[slmkcwpg]/i,
	  abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
	  wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
	};
	var parseMonthPatterns = {
	  narrow: [/^s/i, /^l/i, /^m/i, /^k/i, /^m/i, /^c/i, /^l/i, /^s/i, /^w/i, /^p/i, /^l/i, /^g/i],
	  any: [/^st/i, /^lu/i, /^mar/i, /^k/i, /^maj/i, /^c/i, /^lip/i, /^si/i, /^w/i, /^p/i, /^lis/i, /^g/i]
	};
	var matchDayPatterns = {
	  narrow: /^[npwścs]/i,
	  short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
	  abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
	  wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
	};
	var parseDayPatterns = {
	  narrow: [/^n/i, /^p/i, /^w/i, /^ś/i, /^c/i, /^p/i, /^s/i],
	  abbreviated: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pt/i, /^so/i],
	  any: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pi/i, /^so/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
	  any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
	};
	var parseDayPeriodPatterns = {
	  narrow: {
	    am: /^a$/i,
	    pm: /^p$/i,
	    midnight: /pó(ł|l)n/i,
	    noon: /po(ł|l)/i,
	    morning: /rano/i,
	    afternoon: /po\s*po(ł|l)/i,
	    evening: /wiecz/i,
	    night: /noc/i
	  },
	  any: {
	    am: /^am/i,
	    pm: /^pm/i,
	    midnight: /pó(ł|l)n/i,
	    noon: /po(ł|l)/i,
	    morning: /rano/i,
	    afternoon: /po\s*po(ł|l)/i,
	    evening: /wiecz/i,
	    night: /noc/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1291));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1292));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1293));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1294));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1295));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Polish locale.
	 * @language Polish
	 * @iso-639-2 pol
	 * @author Mateusz Derks [@ertrzyiks]{@link https://github.com/ertrzyiks}
	 * @author Just RAG [@justrag]{@link https://github.com/justrag}
	 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
	 * @author Mateusz Tokarski [@mutisz]{@link https://github.com/mutisz}
	 */
	var locale = {
	  code: 'pl',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1297 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'menos de um segundo',
	    other: 'menos de {{count}} segundos'
	  },
	  xSeconds: {
	    one: '1 segundo',
	    other: '{{count}} segundos'
	  },
	  halfAMinute: 'meio minuto',
	  lessThanXMinutes: {
	    one: 'menos de um minuto',
	    other: 'menos de {{count}} minutos'
	  },
	  xMinutes: {
	    one: '1 minuto',
	    other: '{{count}} minutos'
	  },
	  aboutXHours: {
	    one: 'cerca de 1 hora',
	    other: 'cerca de {{count}} horas'
	  },
	  xHours: {
	    one: '1 hora',
	    other: '{{count}} horas'
	  },
	  xDays: {
	    one: '1 dia',
	    other: '{{count}} dias'
	  },
	  aboutXWeeks: {
	    one: 'cerca de 1 semana',
	    other: 'cerca de {{count}} semanas'
	  },
	  xWeeks: {
	    one: '1 semana',
	    other: '{{count}} semanas'
	  },
	  aboutXMonths: {
	    one: 'cerca de 1 mês',
	    other: 'cerca de {{count}} meses'
	  },
	  xMonths: {
	    one: '1 mês',
	    other: '{{count}} meses'
	  },
	  aboutXYears: {
	    one: 'cerca de 1 ano',
	    other: 'cerca de {{count}} anos'
	  },
	  xYears: {
	    one: '1 ano',
	    other: '{{count}} anos'
	  },
	  overXYears: {
	    one: 'mais de 1 ano',
	    other: 'mais de {{count}} anos'
	  },
	  almostXYears: {
	    one: 'quase 1 ano',
	    other: 'quase {{count}} anos'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'em ' + result;
	    } else {
	      return 'há ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, d 'de' MMMM 'de' y",
	  long: "d 'de' MMMM 'de' y",
	  medium: 'd MMM y',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'às' {{time}}",
	  long: "{{date}} 'às' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1299 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: function (date, _baseDate, _options) {
	    var weekday = date.getUTCDay();
	    var last = weekday === 0 || weekday === 6 ? 'último' : 'última';
	    return "'" + last + "' eeee 'às' p";
	  },
	  yesterday: "'ontem às' p",
	  today: "'hoje às' p",
	  tomorrow: "'amanhã às' p",
	  nextWeek: "eeee 'às' p",
	  other: 'P'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date, baseDate, options);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['AC', 'DC'],
	  abbreviated: ['AC', 'DC'],
	  wide: ['antes de cristo', 'depois de cristo']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['T1', 'T2', 'T3', 'T4'],
	  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
	};
	var monthValues = {
	  narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
	  abbreviated: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
	  wide: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro']
	};
	var dayValues = {
	  narrow: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
	  short: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'],
	  abbreviated: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
	  wide: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mn',
	    noon: 'md',
	    morning: 'manhã',
	    afternoon: 'tarde',
	    evening: 'tarde',
	    night: 'noite'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'meia-noite',
	    noon: 'meio-dia',
	    morning: 'manhã',
	    afternoon: 'tarde',
	    evening: 'tarde',
	    night: 'noite'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'meia-noite',
	    noon: 'meio-dia',
	    morning: 'manhã',
	    afternoon: 'tarde',
	    evening: 'tarde',
	    night: 'noite'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mn',
	    noon: 'md',
	    morning: 'da manhã',
	    afternoon: 'da tarde',
	    evening: 'da tarde',
	    night: 'da noite'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'meia-noite',
	    noon: 'meio-dia',
	    morning: 'da manhã',
	    afternoon: 'da tarde',
	    evening: 'da tarde',
	    night: 'da noite'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'meia-noite',
	    noon: 'meio-dia',
	    morning: 'da manhã',
	    afternoon: 'da tarde',
	    evening: 'da tarde',
	    night: 'da noite'
	  }
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var number = Number(dirtyNumber);
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	
	  if (unit === 'week' || unit === 'isoWeek') {
	    return number + 'ª';
	  }
	
	  return number + 'º';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(8));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)[ºªo]?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ac|dc|a|d)/i,
	  abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
	  wide: /^(antes de cristo|depois de cristo)/i
	};
	var parseEraPatterns = {
	  any: [/^ac/i, /^dc/i],
	  wide: [/^antes de cristo/i, /^depois de cristo/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^T[1234]/i,
	  wide: /^[1234](º)? trimestre/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmajsond]/i,
	  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
	  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^fev/i, /^mar/i, /^abr/i, /^mai/i, /^jun/i, /^jul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dez/i]
	};
	var matchDayPatterns = {
	  narrow: /^(dom|[23456]ª?|s[aá]b)/i,
	  short: /^(dom|[23456]ª?|s[aá]b)/i,
	  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
	  wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
	};
	var parseDayPatterns = {
	  short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
	  narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
	  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
	  any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mn|^meia[-\s]noite/i,
	    noon: /^md|^meio[-\s]dia/i,
	    morning: /manhã/i,
	    afternoon: /tarde/i,
	    evening: /tarde/i,
	    night: /noite/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1297));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1298));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1299));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1300));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1301));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Portuguese locale (Brazil).
	 * @language Portuguese
	 * @iso-639-2 por
	 * @author Lucas Duailibe [@duailibe]{@link https://github.com/duailibe}
	 * @author Yago Carballo [@yagocarballo]{@link https://github.com/YagoCarballo}
	 */
	var locale = {
	  code: 'pt-BR',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1303 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'menos de um segundo',
	    other: 'menos de {{count}} segundos'
	  },
	  xSeconds: {
	    one: '1 segundo',
	    other: '{{count}} segundos'
	  },
	  halfAMinute: 'meio minuto',
	  lessThanXMinutes: {
	    one: 'menos de um minuto',
	    other: 'menos de {{count}} minutos'
	  },
	  xMinutes: {
	    one: '1 minuto',
	    other: '{{count}} minutos'
	  },
	  aboutXHours: {
	    one: 'aproximadamente 1 hora',
	    other: 'aproximadamente {{count}} horas'
	  },
	  xHours: {
	    one: '1 hora',
	    other: '{{count}} horas'
	  },
	  xDays: {
	    one: '1 dia',
	    other: '{{count}} dias'
	  },
	  aboutXWeeks: {
	    one: 'aproximadamente 1 semana',
	    other: 'aproximadamente {{count}} semanas'
	  },
	  xWeeks: {
	    one: '1 semana',
	    other: '{{count}} semanas'
	  },
	  aboutXMonths: {
	    one: 'aproximadamente 1 mês',
	    other: 'aproximadamente {{count}} meses'
	  },
	  xMonths: {
	    one: '1 mês',
	    other: '{{count}} meses'
	  },
	  aboutXYears: {
	    one: 'aproximadamente 1 ano',
	    other: 'aproximadamente {{count}} anos'
	  },
	  xYears: {
	    one: '1 ano',
	    other: '{{count}} anos'
	  },
	  overXYears: {
	    one: 'mais de 1 ano',
	    other: 'mais de {{count}} anos'
	  },
	  almostXYears: {
	    one: 'quase 1 ano',
	    other: 'quase {{count}} anos'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'daqui a ' + result;
	    } else {
	      return 'há ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, d 'de' MMMM 'de' y",
	  long: "d 'de' MMMM 'de' y",
	  medium: "d 'de' MMM 'de' y",
	  short: 'dd/MM/y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'às' {{time}}",
	  long: "{{date}} 'às' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1305 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'na última' eeee 'às' p",
	  yesterday: "'ontem às' p",
	  today: "'hoje às' p",
	  tomorrow: "'amanhã às' p",
	  nextWeek: "eeee 'às' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number + 'º';
	}
	
	var eraValues = {
	  narrow: ['aC', 'dC'],
	  abbreviated: ['a.C.', 'd.C.'],
	  wide: ['antes de Cristo', 'depois de Cristo']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['T1', 'T2', 'T3', 'T4'],
	  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
	};
	var monthValues = {
	  narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
	  abbreviated: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
	  wide: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro']
	};
	var dayValues = {
	  narrow: ['d', 's', 't', 'q', 'q', 's', 's'],
	  short: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
	  abbreviated: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
	  wide: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'meia-noite',
	    noon: 'meio-dia',
	    morning: 'manhã',
	    afternoon: 'tarde',
	    evening: 'noite',
	    night: 'madrugada'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'meia-noite',
	    noon: 'meio-dia',
	    morning: 'manhã',
	    afternoon: 'tarde',
	    evening: 'noite',
	    night: 'madrugada'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'meia-noite',
	    noon: 'meio-dia',
	    morning: 'manhã',
	    afternoon: 'tarde',
	    evening: 'noite',
	    night: 'madrugada'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'meia-noite',
	    noon: 'meio-dia',
	    morning: 'da manhã',
	    afternoon: 'da tarde',
	    evening: 'da noite',
	    night: 'da madrugada'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'meia-noite',
	    noon: 'meio-dia',
	    morning: 'da manhã',
	    afternoon: 'da tarde',
	    evening: 'da noite',
	    night: 'da madrugada'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'meia-noite',
	    noon: 'meio-dia',
	    morning: 'da manhã',
	    afternoon: 'da tarde',
	    evening: 'da noite',
	    night: 'da madrugada'
	  }
	};
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(º|ª)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ac|dc|a|d)/i,
	  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
	  wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
	};
	var parseEraPatterns = {
	  any: [/^ac/i, /^dc/i],
	  wide: [/^(antes de cristo|antes da era comum)/i, /^(depois de cristo|era comum)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^T[1234]/i,
	  wide: /^[1234](º|ª)? trimestre/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
	  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ab/i, /^mai/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[dstq]/i,
	  short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
	  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
	  wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
	};
	var parseDayPatterns = {
	  narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
	  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
	  any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^meia/i,
	    noon: /^meio/i,
	    morning: /manh[ãa]/i,
	    afternoon: /tarde/i,
	    evening: /noite/i,
	    night: /madrugada/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1303));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1304));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1305));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1306));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1307));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Portuguese locale.
	 * @language Portuguese
	 * @iso-639-2 por
	 * @author Dário Freire [@dfreire]{@link https://github.com/dfreire}
	 * @author Adrián de la Rosa [@adrm]{@link https://github.com/adrm}
	 */
	var locale = {
	  code: 'pt',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'mai puțin de o secundă',
	    other: 'mai puțin de {{count}} secunde'
	  },
	  xSeconds: {
	    one: '1 secundă',
	    other: '{{count}} secunde'
	  },
	  halfAMinute: 'jumătate de minut',
	  lessThanXMinutes: {
	    one: 'mai puțin de un minut',
	    other: 'mai puțin de {{count}} minute'
	  },
	  xMinutes: {
	    one: '1 minut',
	    other: '{{count}} minute'
	  },
	  aboutXHours: {
	    one: 'circa 1 oră',
	    other: 'circa {{count}} ore'
	  },
	  xHours: {
	    one: '1 oră',
	    other: '{{count}} ore'
	  },
	  xDays: {
	    one: '1 zi',
	    other: '{{count}} zile'
	  },
	  aboutXWeeks: {
	    one: 'circa o săptămână',
	    other: 'circa {{count}} săptămâni'
	  },
	  xWeeks: {
	    one: '1 săptămână',
	    other: '{{count}} săptămâni'
	  },
	  aboutXMonths: {
	    one: 'circa 1 lună',
	    other: 'circa {{count}} luni'
	  },
	  xMonths: {
	    one: '1 lună',
	    other: '{{count}} luni'
	  },
	  aboutXYears: {
	    one: 'circa 1 an',
	    other: 'circa {{count}} ani'
	  },
	  xYears: {
	    one: '1 an',
	    other: '{{count}} ani'
	  },
	  overXYears: {
	    one: 'peste 1 an',
	    other: 'peste {{count}} ani'
	  },
	  almostXYears: {
	    one: 'aproape 1 an',
	    other: 'aproape {{count}} ani'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'în ' + result;
	    } else {
	      return result + ' în urmă';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d MMMM yyyy',
	  long: 'd MMMM yyyy',
	  medium: 'd MMM yyyy',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'la' {{time}}",
	  long: "{{date}} 'la' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1311 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'trecută la' p",
	  yesterday: "'ieri la' p",
	  today: "'astăzi la' p",
	  tomorrow: "'mâine la' p",
	  nextWeek: "eeee 'viitoare la' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['Î', 'D'],
	  abbreviated: ['Î.d.C.', 'D.C.'],
	  wide: ['Înainte de Cristos', 'După Cristos']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['T1', 'T2', 'T3', 'T4'],
	  wide: ['primul trimestru', 'al doilea trimestru', 'al treilea trimestru', 'al patrulea trimestru']
	};
	var monthValues = {
	  narrow: ['I', 'F', 'M', 'A', 'M', 'I', 'I', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['ian', 'feb', 'mar', 'apr', 'mai', 'iun', 'iul', 'aug', 'sep', 'oct', 'noi', 'dec'],
	  wide: ['ianuarie', 'februarie', 'martie', 'aprilie', 'mai', 'iunie', 'iulie', 'august', 'septembrie', 'octombrie', 'noiembrie', 'decembrie']
	};
	var dayValues = {
	  narrow: ['d', 'l', 'm', 'm', 'j', 'v', 's'],
	  short: ['du', 'lu', 'ma', 'mi', 'jo', 'vi', 'sâ'],
	  abbreviated: ['dum', 'lun', 'mar', 'mie', 'joi', 'vin', 'sâm'],
	  wide: ['duminică', 'luni', 'marți', 'miercuri', 'joi', 'vineri', 'sâmbătă']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mn',
	    noon: 'ami',
	    morning: 'dim',
	    afternoon: 'da',
	    evening: 's',
	    night: 'n'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'miezul nopții',
	    noon: 'amiază',
	    morning: 'dimineață',
	    afternoon: 'după-amiază',
	    evening: 'seară',
	    night: 'noapte'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'miezul nopții',
	    noon: 'amiază',
	    morning: 'dimineață',
	    afternoon: 'după-amiază',
	    evening: 'seară',
	    night: 'noapte'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mn',
	    noon: 'amiază',
	    morning: 'dimineață',
	    afternoon: 'după-amiază',
	    evening: 'seară',
	    night: 'noapte'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'miezul nopții',
	    noon: 'amiază',
	    morning: 'dimineață',
	    afternoon: 'după-amiază',
	    evening: 'seară',
	    night: 'noapte'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'miezul nopții',
	    noon: 'amiază',
	    morning: 'dimineață',
	    afternoon: 'după-amiază',
	    evening: 'seară',
	    night: 'noapte'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return String(number);
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(Î|D)/i,
	  abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
	  wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
	};
	var parseEraPatterns = {
	  any: [/^ÎC/i, /^DC/i],
	  wide: [/^(Înainte de Cristos|Înaintea erei noastre)/i, /^(După Cristos|Era noastră)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^T[1234]/i,
	  wide: /^trimestrul [1234]/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[ifmaasond]/i,
	  abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
	  wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^i/i, /^f/i, /^m/i, /^a/i, /^m/i, /^i/i, /^i/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ia/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^iun/i, /^iul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[dlmjvs]/i,
	  short: /^(d|l|ma|mi|j|v|s)/i,
	  abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
	  wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
	};
	var parseDayPatterns = {
	  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
	  any: [/^d/i, /^l/i, /^ma/i, /^mi/i, /^j/i, /^v/i, /^s/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
	  any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mn/i,
	    noon: /amiaza/i,
	    morning: /dimineaţa/i,
	    afternoon: /după-amiaza/i,
	    evening: /seara/i,
	    night: /noaptea/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1309));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1310));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1311));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1312));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1313));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Romanian locale.
	 * @language Romanian
	 * @iso-639-2 ron
	 * @author Sergiu Munteanu [@jsergiu]{@link https://github.com/jsergiu}
	 * @author Adrian Ocneanu [@aocneanu]{@link https://github.com/aocneanu}
	 * @author Mihai Ocneanu [@gandesc]{@link https://github.com/gandesc}
	 */
	var locale = {
	  code: 'ro',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1315 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	
	function declension(scheme, count) {
	  // scheme for count=1 exists
	  if (scheme.one !== undefined && count === 1) {
	    return scheme.one;
	  }
	
	  var rem10 = count % 10;
	  var rem100 = count % 100; // 1, 21, 31, ...
	
	  if (rem10 === 1 && rem100 !== 11) {
	    return scheme.singularNominative.replace('{{count}}', count); // 2, 3, 4, 22, 23, 24, 32 ...
	  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
	    return scheme.singularGenitive.replace('{{count}}', count); // 5, 6, 7, 8, 9, 10, 11, ...
	  } else {
	    return scheme.pluralGenitive.replace('{{count}}', count);
	  }
	}
	
	function buildLocalizeTokenFn(scheme) {
	  return function (count, options) {
	    if (options.addSuffix) {
	      if (options.comparison > 0) {
	        if (scheme.future) {
	          return declension(scheme.future, count);
	        } else {
	          return 'через ' + declension(scheme.regular, count);
	        }
	      } else {
	        if (scheme.past) {
	          return declension(scheme.past, count);
	        } else {
	          return declension(scheme.regular, count) + ' назад';
	        }
	      }
	    } else {
	      return declension(scheme.regular, count);
	    }
	  };
	}
	
	var formatDistanceLocale = {
	  lessThanXSeconds: buildLocalizeTokenFn({
	    regular: {
	      one: 'меньше секунды',
	      singularNominative: 'меньше {{count}} секунды',
	      singularGenitive: 'меньше {{count}} секунд',
	      pluralGenitive: 'меньше {{count}} секунд'
	    },
	    future: {
	      one: 'меньше, чем через секунду',
	      singularNominative: 'меньше, чем через {{count}} секунду',
	      singularGenitive: 'меньше, чем через {{count}} секунды',
	      pluralGenitive: 'меньше, чем через {{count}} секунд'
	    }
	  }),
	  xSeconds: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} секунда',
	      singularGenitive: '{{count}} секунды',
	      pluralGenitive: '{{count}} секунд'
	    },
	    past: {
	      singularNominative: '{{count}} секунду назад',
	      singularGenitive: '{{count}} секунды назад',
	      pluralGenitive: '{{count}} секунд назад'
	    },
	    future: {
	      singularNominative: 'через {{count}} секунду',
	      singularGenitive: 'через {{count}} секунды',
	      pluralGenitive: 'через {{count}} секунд'
	    }
	  }),
	  halfAMinute: function (_, options) {
	    if (options.addSuffix) {
	      if (options.comparison > 0) {
	        return 'через полминуты';
	      } else {
	        return 'полминуты назад';
	      }
	    }
	
	    return 'полминуты';
	  },
	  lessThanXMinutes: buildLocalizeTokenFn({
	    regular: {
	      one: 'меньше минуты',
	      singularNominative: 'меньше {{count}} минуты',
	      singularGenitive: 'меньше {{count}} минут',
	      pluralGenitive: 'меньше {{count}} минут'
	    },
	    future: {
	      one: 'меньше, чем через минуту',
	      singularNominative: 'меньше, чем через {{count}} минуту',
	      singularGenitive: 'меньше, чем через {{count}} минуты',
	      pluralGenitive: 'меньше, чем через {{count}} минут'
	    }
	  }),
	  xMinutes: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} минута',
	      singularGenitive: '{{count}} минуты',
	      pluralGenitive: '{{count}} минут'
	    },
	    past: {
	      singularNominative: '{{count}} минуту назад',
	      singularGenitive: '{{count}} минуты назад',
	      pluralGenitive: '{{count}} минут назад'
	    },
	    future: {
	      singularNominative: 'через {{count}} минуту',
	      singularGenitive: 'через {{count}} минуты',
	      pluralGenitive: 'через {{count}} минут'
	    }
	  }),
	  aboutXHours: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'около {{count}} часа',
	      singularGenitive: 'около {{count}} часов',
	      pluralGenitive: 'около {{count}} часов'
	    },
	    future: {
	      singularNominative: 'приблизительно через {{count}} час',
	      singularGenitive: 'приблизительно через {{count}} часа',
	      pluralGenitive: 'приблизительно через {{count}} часов'
	    }
	  }),
	  xHours: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} час',
	      singularGenitive: '{{count}} часа',
	      pluralGenitive: '{{count}} часов'
	    }
	  }),
	  xDays: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} день',
	      singularGenitive: '{{count}} дня',
	      pluralGenitive: '{{count}} дней'
	    }
	  }),
	  aboutXWeeks: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'около {{count}} недели',
	      singularGenitive: 'около {{count}} недель',
	      pluralGenitive: 'около {{count}} недель'
	    },
	    future: {
	      singularNominative: 'приблизительно через {{count}} неделю',
	      singularGenitive: 'приблизительно через {{count}} недели',
	      pluralGenitive: 'приблизительно через {{count}} недель'
	    }
	  }),
	  xWeeks: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} неделя',
	      singularGenitive: '{{count}} недели',
	      pluralGenitive: '{{count}} недель'
	    }
	  }),
	  aboutXMonths: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'около {{count}} месяца',
	      singularGenitive: 'около {{count}} месяцев',
	      pluralGenitive: 'около {{count}} месяцев'
	    },
	    future: {
	      singularNominative: 'приблизительно через {{count}} месяц',
	      singularGenitive: 'приблизительно через {{count}} месяца',
	      pluralGenitive: 'приблизительно через {{count}} месяцев'
	    }
	  }),
	  xMonths: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} месяц',
	      singularGenitive: '{{count}} месяца',
	      pluralGenitive: '{{count}} месяцев'
	    }
	  }),
	  aboutXYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'около {{count}} года',
	      singularGenitive: 'около {{count}} лет',
	      pluralGenitive: 'около {{count}} лет'
	    },
	    future: {
	      singularNominative: 'приблизительно через {{count}} год',
	      singularGenitive: 'приблизительно через {{count}} года',
	      pluralGenitive: 'приблизительно через {{count}} лет'
	    }
	  }),
	  xYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} год',
	      singularGenitive: '{{count}} года',
	      pluralGenitive: '{{count}} лет'
	    }
	  }),
	  overXYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'больше {{count}} года',
	      singularGenitive: 'больше {{count}} лет',
	      pluralGenitive: 'больше {{count}} лет'
	    },
	    future: {
	      singularNominative: 'больше, чем через {{count}} год',
	      singularGenitive: 'больше, чем через {{count}} года',
	      pluralGenitive: 'больше, чем через {{count}} лет'
	    }
	  }),
	  almostXYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'почти {{count}} год',
	      singularGenitive: 'почти {{count}} года',
	      pluralGenitive: 'почти {{count}} лет'
	    },
	    future: {
	      singularNominative: 'почти через {{count}} год',
	      singularGenitive: 'почти через {{count}} года',
	      pluralGenitive: 'почти через {{count}} лет'
	    }
	  })
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  return formatDistanceLocale[token](count, options);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, d MMMM y 'г.'",
	  long: "d MMMM y 'г.'",
	  medium: "d MMM y 'г.'",
	  short: 'dd.MM.y'
	};
	var timeFormats = {
	  full: 'H:mm:ss zzzz',
	  long: 'H:mm:ss z',
	  medium: 'H:mm:ss',
	  short: 'H:mm'
	};
	var dateTimeFormats = {
	  any: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'any'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	
	var _index = _interopRequireDefault(__webpack_require__(46));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accusativeWeekdays = ['воскресенье', 'понедельник', 'вторник', 'среду', 'четверг', 'пятницу', 'субботу'];
	
	function lastWeek(day) {
	  var weekday = accusativeWeekdays[day];
	
	  switch (day) {
	    case 0:
	      return "'в прошлое " + weekday + " в' p";
	
	    case 1:
	    case 2:
	    case 4:
	      return "'в прошлый " + weekday + " в' p";
	
	    case 3:
	    case 5:
	    case 6:
	      return "'в прошлую " + weekday + " в' p";
	  }
	}
	
	function thisWeek(day) {
	  var weekday = accusativeWeekdays[day];
	
	  if (day === 2
	  /* Tue */
	  ) {
	      return "'во " + weekday + " в' p";
	    } else {
	    return "'в " + weekday + " в' p";
	  }
	}
	
	function nextWeek(day) {
	  var weekday = accusativeWeekdays[day];
	
	  switch (day) {
	    case 0:
	      return "'в следующее " + weekday + " в' p";
	
	    case 1:
	    case 2:
	    case 4:
	      return "'в следующий " + weekday + " в' p";
	
	    case 3:
	    case 5:
	    case 6:
	      return "'в следующую " + weekday + " в' p";
	  }
	}
	
	var formatRelativeLocale = {
	  lastWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return lastWeek(day);
	    }
	  },
	  yesterday: "'вчера в' p",
	  today: "'сегодня в' p",
	  tomorrow: "'завтра в' p",
	  nextWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return nextWeek(day);
	    }
	  },
	  other: 'P'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date, baseDate, options);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['до н.э.', 'н.э.'],
	  abbreviated: ['до н. э.', 'н. э.'],
	  wide: ['до нашей эры', 'нашей эры']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1-й кв.', '2-й кв.', '3-й кв.', '4-й кв.'],
	  wide: ['1-й квартал', '2-й квартал', '3-й квартал', '4-й квартал']
	};
	var monthValues = {
	  narrow: ['Я', 'Ф', 'М', 'А', 'М', 'И', 'И', 'А', 'С', 'О', 'Н', 'Д'],
	  abbreviated: ['янв.', 'фев.', 'март', 'апр.', 'май', 'июнь', 'июль', 'авг.', 'сент.', 'окт.', 'нояб.', 'дек.'],
	  wide: ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь']
	};
	var formattingMonthValues = {
	  narrow: ['Я', 'Ф', 'М', 'А', 'М', 'И', 'И', 'А', 'С', 'О', 'Н', 'Д'],
	  abbreviated: ['янв.', 'фев.', 'мар.', 'апр.', 'мая', 'июн.', 'июл.', 'авг.', 'сент.', 'окт.', 'нояб.', 'дек.'],
	  wide: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря']
	};
	var dayValues = {
	  narrow: ['В', 'П', 'В', 'С', 'Ч', 'П', 'С'],
	  short: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
	  abbreviated: ['вск', 'пнд', 'втр', 'срд', 'чтв', 'птн', 'суб'],
	  wide: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'полн.',
	    noon: 'полд.',
	    morning: 'утро',
	    afternoon: 'день',
	    evening: 'веч.',
	    night: 'ночь'
	  },
	  abbreviated: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'полн.',
	    noon: 'полд.',
	    morning: 'утро',
	    afternoon: 'день',
	    evening: 'веч.',
	    night: 'ночь'
	  },
	  wide: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'полночь',
	    noon: 'полдень',
	    morning: 'утро',
	    afternoon: 'день',
	    evening: 'вечер',
	    night: 'ночь'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'полн.',
	    noon: 'полд.',
	    morning: 'утра',
	    afternoon: 'дня',
	    evening: 'веч.',
	    night: 'ночи'
	  },
	  abbreviated: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'полн.',
	    noon: 'полд.',
	    morning: 'утра',
	    afternoon: 'дня',
	    evening: 'веч.',
	    night: 'ночи'
	  },
	  wide: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'полночь',
	    noon: 'полдень',
	    morning: 'утра',
	    afternoon: 'дня',
	    evening: 'вечера',
	    night: 'ночи'
	  }
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	  var suffix;
	
	  if (unit === 'date') {
	    suffix = '-е';
	  } else if (unit === 'week' || unit === 'minute' || unit === 'second') {
	    suffix = '-я';
	  } else {
	    suffix = '-й';
	  }
	
	  return dirtyNumber + suffix;
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'any',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^((до )?н\.?\s?э\.?)/i,
	  abbreviated: /^((до )?н\.?\s?э\.?)/i,
	  wide: /^(до нашей эры|нашей эры|наша эра)/i
	};
	var parseEraPatterns = {
	  any: [/^д/i, /^н/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
	  wide: /^[1234](-?[ыои]?й?)? квартал/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[яфмаисонд]/i,
	  abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
	  wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
	};
	var parseMonthPatterns = {
	  narrow: [/^я/i, /^ф/i, /^м/i, /^а/i, /^м/i, /^и/i, /^и/i, /^а/i, /^с/i, /^о/i, /^н/i, /^я/i],
	  any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^ав/i, /^с/i, /^о/i, /^н/i, /^д/i]
	};
	var matchDayPatterns = {
	  narrow: /^[впсч]/i,
	  short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
	  abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
	  wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
	};
	var parseDayPatterns = {
	  narrow: [/^в/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
	  any: [/^в[ос]/i, /^п[он]/i, /^в/i, /^ср/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
	  abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
	  wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^дп/i,
	    pm: /^пп/i,
	    midnight: /^полн/i,
	    noon: /^полд/i,
	    morning: /^у/i,
	    afternoon: /^д[ен]/i,
	    evening: /^в/i,
	    night: /^н/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1315));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1316));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1317));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1318));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1319));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Russian locale.
	 * @language Russian
	 * @iso-639-2 rus
	 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
	 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
	 */
	var locale = {
	  code: 'ru',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1321 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	
	// NOTE: should prolly be improved
	// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1308
	function declensionGroup(scheme, count) {
	  if (count === 1) {
	    return scheme.one;
	  }
	
	  if (count >= 2 && count <= 4) {
	    return scheme.twoFour;
	  } // if count === null || count === 0 || count >= 5
	
	
	  return scheme.other;
	}
	
	function declension(scheme, count, time) {
	  var group = declensionGroup(scheme, count);
	  var finalText = group[time] || group;
	  return finalText.replace('{{count}}', count);
	}
	
	function extractPreposition(token) {
	  var result = ['lessThan', 'about', 'over', 'almost'].filter(function (preposition) {
	    return !!token.match(new RegExp('^' + preposition));
	  });
	  return result[0];
	}
	
	function prefixPreposition(preposition) {
	  var translation = '';
	
	  if (preposition === 'almost') {
	    translation = 'takmer';
	  }
	
	  if (preposition === 'about') {
	    translation = 'približne';
	  }
	
	  return translation.length > 0 ? translation + ' ' : '';
	}
	
	function suffixPreposition(preposition) {
	  var translation = '';
	
	  if (preposition === 'lessThan') {
	    translation = 'menej než';
	  }
	
	  if (preposition === 'over') {
	    translation = 'viac než';
	  }
	
	  return translation.length > 0 ? translation + ' ' : '';
	}
	
	function lowercaseFirstLetter(string) {
	  return string.charAt(0).toLowerCase() + string.slice(1);
	}
	
	var formatDistanceLocale = {
	  xSeconds: {
	    one: {
	      regular: 'sekunda',
	      past: 'sekundou',
	      future: 'sekundu'
	    },
	    twoFour: {
	      regular: '{{count}} sekundy',
	      past: '{{count}} sekundami',
	      future: '{{count}} sekundy'
	    },
	    other: {
	      regular: '{{count}} sekúnd',
	      past: '{{count}} sekundami',
	      future: '{{count}} sekúnd'
	    }
	  },
	  halfAMinute: {
	    other: {
	      regular: 'pol minúty',
	      past: 'pol minútou',
	      future: 'pol minúty'
	    }
	  },
	  xMinutes: {
	    one: {
	      regular: 'minúta',
	      past: 'minútou',
	      future: 'minútu'
	    },
	    twoFour: {
	      regular: '{{count}} minúty',
	      past: '{{count}} minútami',
	      future: '{{count}} minúty'
	    },
	    other: {
	      regular: '{{count}} minút',
	      past: '{{count}} minútami',
	      future: '{{count}} minút'
	    }
	  },
	  xHours: {
	    one: {
	      regular: 'hodina',
	      past: 'hodinou',
	      future: 'hodinu'
	    },
	    twoFour: {
	      regular: '{{count}} hodiny',
	      past: '{{count}} hodinami',
	      future: '{{count}} hodiny'
	    },
	    other: {
	      regular: '{{count}} hodín',
	      past: '{{count}} hodinami',
	      future: '{{count}} hodín'
	    }
	  },
	  xDays: {
	    one: {
	      regular: 'deň',
	      past: 'dňom',
	      future: 'deň'
	    },
	    twoFour: {
	      regular: '{{count}} dni',
	      past: '{{count}} dňami',
	      future: '{{count}} dni'
	    },
	    other: {
	      regular: '{{count}} dní',
	      past: '{{count}} dňami',
	      future: '{{count}} dní'
	    }
	  },
	  xWeeks: {
	    one: {
	      regular: 'mesiac',
	      // TODO
	      past: 'mesiacom',
	      // TODO
	      future: 'mesiac' // TODO
	
	    },
	    twoFour: {
	      regular: '{{count}} mesiace',
	      // TODO
	      past: '{{count}} mesiacmi',
	      // TODO
	      future: '{{count}} mesiace' // TODO
	
	    },
	    other: {
	      regular: '{{count}} mesiacov',
	      // TODO
	      past: '{{count}} mesiacmi',
	      // TODO
	      future: '{{count}} mesiacov' // TODO
	
	    }
	  },
	  xMonths: {
	    one: {
	      regular: 'mesiac',
	      past: 'mesiacom',
	      future: 'mesiac'
	    },
	    twoFour: {
	      regular: '{{count}} mesiace',
	      past: '{{count}} mesiacmi',
	      future: '{{count}} mesiace'
	    },
	    other: {
	      regular: '{{count}} mesiacov',
	      past: '{{count}} mesiacmi',
	      future: '{{count}} mesiacov'
	    }
	  },
	  xYears: {
	    one: {
	      regular: 'rok',
	      past: 'rokom',
	      future: 'rok'
	    },
	    twoFour: {
	      regular: '{{count}} roky',
	      past: '{{count}} rokmi',
	      future: '{{count}} roky'
	    },
	    other: {
	      regular: '{{count}} rokov',
	      past: '{{count}} rokmi',
	      future: '{{count}} rokov'
	    }
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var preposition = extractPreposition(token) || '';
	  var key = lowercaseFirstLetter(token.substring(preposition.length));
	  var scheme = formatDistanceLocale[key];
	
	  if (!options.addSuffix) {
	    return prefixPreposition(preposition) + suffixPreposition(preposition) + declension(scheme, count, 'regular');
	  }
	
	  if (options.comparison > 0) {
	    return prefixPreposition(preposition) + 'o ' + suffixPreposition(preposition) + declension(scheme, count, 'future');
	  } else {
	    return prefixPreposition(preposition) + 'pred ' + suffixPreposition(preposition) + declension(scheme, count, 'past');
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1986
	var dateFormats = {
	  full: 'EEEE d. MMMM y',
	  long: 'd. MMMM y',
	  medium: 'd. M. y',
	  short: 'd. M. y'
	}; // https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#2149
	
	var timeFormats = {
	  full: 'H:mm:ss zzzz',
	  long: 'H:mm:ss z',
	  medium: 'H:mm:ss',
	  short: 'H:mm'
	}; // https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1994
	
	var dateTimeFormats = {
	  full: '{{date}}, {{time}}',
	  long: '{{date}}, {{time}}',
	  medium: '{{date}}, {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	
	var _index = _interopRequireDefault(__webpack_require__(46));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1308
	var accusativeWeekdays = ['nedeľu', 'pondelok', 'utorok', 'stredu', 'štvrtok', 'piatok', 'sobotu'];
	
	function lastWeek(day) {
	  var weekday = accusativeWeekdays[day];
	
	  switch (day) {
	    case 0:
	    /* Sun */
	
	    case 3:
	    /* Wed */
	
	    case 6
	    /* Sat */
	    :
	      return "'minulú " + weekday + " o' p";
	
	    default:
	      return "'minulý' eeee 'o' p";
	  }
	}
	
	function thisWeek(day) {
	  var weekday = accusativeWeekdays[day];
	
	  if (day === 4
	  /* Thu */
	  ) {
	      return "'vo' eeee 'o' p";
	    } else {
	    return "'v " + weekday + " o' p";
	  }
	}
	
	function nextWeek(day) {
	  var weekday = accusativeWeekdays[day];
	
	  switch (day) {
	    case 0:
	    /* Sun */
	
	    case 4:
	    /* Wed */
	
	    case 6
	    /* Sat */
	    :
	      return "'budúcu " + weekday + " o' p";
	
	    default:
	      return "'budúci' eeee 'o' p";
	  }
	}
	
	var formatRelativeLocale = {
	  lastWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return lastWeek(day);
	    }
	  },
	  yesterday: "'včera o' p",
	  today: "'dnes o' p",
	  tomorrow: "'zajtra o' p",
	  nextWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return nextWeek(day);
	    }
	  },
	  other: 'P'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date, baseDate, options);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// https://www.unicode.org/cldr/charts/32/summary/sk.html#1772
	var eraValues = {
	  narrow: ['pred Kr.', 'po Kr.'],
	  abbreviated: ['pred Kr.', 'po Kr.'],
	  wide: ['pred Kristom', 'po Kristovi']
	}; // https://www.unicode.org/cldr/charts/32/summary/sk.html#1780
	
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1. štvrťrok', '2. štvrťrok', '3. štvrťrok', '4. štvrťrok']
	}; // https://www.unicode.org/cldr/charts/32/summary/sk.html#1804
	
	var monthValues = {
	  narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
	  abbreviated: ['jan', 'feb', 'mar', 'apr', 'máj', 'jún', 'júl', 'aug', 'sep', 'okt', 'nov', 'dec'],
	  wide: ['január', 'február', 'marec', 'apríl', 'máj', 'jún', 'júl', 'august', 'september', 'október', 'november', 'december']
	};
	var formattingMonthValues = {
	  narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
	  abbreviated: ['jan', 'feb', 'mar', 'apr', 'máj', 'jún', 'júl', 'aug', 'sep', 'okt', 'nov', 'dec'],
	  wide: ['januára', 'februára', 'marca', 'apríla', 'mája', 'júna', 'júla', 'augusta', 'septembra', 'októbra', 'novembra', 'decembra']
	}; // https://www.unicode.org/cldr/charts/32/summary/sk.html#1876
	
	var dayValues = {
	  narrow: ['n', 'p', 'u', 's', 'š', 'p', 's'],
	  short: ['ne', 'po', 'ut', 'st', 'št', 'pi', 'so'],
	  abbreviated: ['ne', 'po', 'ut', 'st', 'št', 'pi', 'so'],
	  wide: ['nedeľa', 'pondelok', 'utorok', 'streda', 'štvrtok', 'piatok', 'sobota']
	}; // https://www.unicode.org/cldr/charts/32/summary/sk.html#1932
	
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'poln.',
	    noon: 'pol.',
	    morning: 'ráno',
	    afternoon: 'pop.',
	    evening: 'več.',
	    night: 'noc'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'poln.',
	    noon: 'pol.',
	    morning: 'ráno',
	    afternoon: 'popol.',
	    evening: 'večer',
	    night: 'noc'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'polnoc',
	    noon: 'poludnie',
	    morning: 'ráno',
	    afternoon: 'popoludnie',
	    evening: 'večer',
	    night: 'noc'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'o poln.',
	    noon: 'nap.',
	    morning: 'ráno',
	    afternoon: 'pop.',
	    evening: 'več.',
	    night: 'v n.'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'o poln.',
	    noon: 'napol.',
	    morning: 'ráno',
	    afternoon: 'popol.',
	    evening: 'večer',
	    night: 'v noci'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'o polnoci',
	    noon: 'napoludnie',
	    morning: 'ráno',
	    afternoon: 'popoludní',
	    evening: 'večer',
	    night: 'v noci'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues // defaultWidth: 'wide'
	
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)\.?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
	  abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
	  wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
	};
	var parseEraPatterns = {
	  any: [/^pr/i, /^(po|n)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234]\. [šs]tvr[ťt]rok/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
	  wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^m[áa]j/i, /^j[úu]n/i, /^j[úu]l/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[npusšp]/i,
	  short: /^(ne|po|ut|st|št|pi|so)/i,
	  abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
	  wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
	};
	var parseDayPatterns = {
	  narrow: [/^n/i, /^p/i, /^u/i, /^s/i, /^š/i, /^p/i, /^s/i],
	  any: [/^n/i, /^po/i, /^u/i, /^st/i, /^(št|stv)/i, /^pi/i, /^so/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
	  abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
	  any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^am/i,
	    pm: /^pm/i,
	    midnight: /poln/i,
	    noon: /^(nap|(na)?pol(\.|u))/i,
	    morning: /^r[áa]no/i,
	    afternoon: /^pop/i,
	    evening: /^ve[čc]/i,
	    night: /^(noc|v n\.)/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1321));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1322));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1323));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1324));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1325));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Slovak locale.
	 * @language Slovak
	 * @iso-639-2 slk
	 * @author Marek Suscak [@mareksuscak]{@link https://github.com/mareksuscak}
	 */
	var locale = {
	  code: 'sk',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1327 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var distanceInWordsLocale = {
	  lessThanXSeconds: {
	    one: 'manj kot {{count}} sekunda',
	    two: 'manj kot {{count}} sekundi',
	    few: 'manj kot {{count}} sekunde',
	    other: 'manj kot {{count}} sekund'
	  },
	  xSeconds: {
	    one: '{{count}} sekunda',
	    two: '{{count}} sekundi',
	    few: '{{count}} sekunde',
	    other: '{{count}} sekund'
	  },
	  halfAMinute: 'pol minute',
	  lessThanXMinutes: {
	    one: 'manj kot {{count}} minuta',
	    two: 'manj kot {{count}} minuti',
	    few: 'manj kot {{count}} minute',
	    other: 'manj kot {{count}} minut'
	  },
	  xMinutes: {
	    one: '{{count}} minuta',
	    two: '{{count}} minuti',
	    few: '{{count}} minute',
	    other: '{{count}} minut'
	  },
	  aboutXHours: {
	    one: 'približno {{count}} ura',
	    two: 'približno {{count}} uri',
	    few: 'približno {{count}} ure',
	    other: 'približno {{count}} ur'
	  },
	  xHours: {
	    one: '{{count}} ura',
	    two: '{{count}} uri',
	    few: '{{count}} ure',
	    other: '{{count}} ur'
	  },
	  xDays: {
	    one: '{{count}} dan',
	    two: '{{count}} dni',
	    few: '{{count}} dni',
	    other: '{{count}} dni'
	  },
	  aboutXWeeks: {
	    one: 'približno {{count}} teden',
	    two: 'približno {{count}} tedna',
	    few: 'približno {{count}} tedne',
	    other: 'približno {{count}} tednov'
	  },
	  xWeeks: {
	    one: '{{count}} teden',
	    two: '{{count}} tedna',
	    few: '{{count}} tedne',
	    other: '{{count}} tednov'
	  },
	  aboutXMonths: {
	    one: 'približno {{count}} mesec',
	    two: 'približno {{count}} meseca',
	    few: 'približno {{count}} mesece',
	    other: 'približno {{count}} mesecev'
	  },
	  xMonths: {
	    one: '{{count}} mesec',
	    two: '{{count}} meseca',
	    few: '{{count}} meseci',
	    other: '{{count}} mesecev'
	  },
	  aboutXYears: {
	    one: 'približno {{count}} leto',
	    two: 'približno {{count}} leti',
	    few: 'približno {{count}} leta',
	    other: 'približno {{count}} let'
	  },
	  xYears: {
	    one: '{{count}} leto',
	    two: '{{count}} leti',
	    few: '{{count}} leta',
	    other: '{{count}} let'
	  },
	  overXYears: {
	    one: 'več kot {{count}} leto',
	    two: 'več kot {{count}} leti',
	    few: 'več kot {{count}} leta',
	    other: 'več kot {{count}} let'
	  },
	  almostXYears: {
	    one: 'skoraj {{count}} leto',
	    two: 'skoraj {{count}} leti',
	    few: 'skoraj {{count}} leta',
	    other: 'skoraj {{count}} let'
	  }
	};
	var distanceInWordsLocalePast = {
	  lessThanXSeconds: {
	    one: 'manj kot {{count}} sekundo',
	    two: 'manj kot {{count}} sekundama',
	    few: 'manj kot {{count}} sekundami',
	    other: 'manj kot {{count}} sekundami'
	  },
	  xSeconds: {
	    one: '{{count}} sekundo',
	    two: '{{count}} sekundama',
	    few: '{{count}} sekundami',
	    other: '{{count}} sekundami'
	  },
	  halfAMinute: 'pol minute',
	  lessThanXMinutes: {
	    one: 'manj kot {{count}} minuto',
	    two: 'manj kot {{count}} minutama',
	    few: 'manj kot {{count}} minutami',
	    other: 'manj kot {{count}} minutami'
	  },
	  xMinutes: {
	    one: '{{count}} minuto',
	    two: '{{count}} minutama',
	    few: '{{count}} minutami',
	    other: '{{count}} minutami'
	  },
	  aboutXHours: {
	    one: 'približno {{count}} uro',
	    two: 'približno {{count}} urama',
	    few: 'približno {{count}} urami',
	    other: 'približno {{count}} urami'
	  },
	  xHours: {
	    one: '{{count}} uro',
	    two: '{{count}} urama',
	    few: '{{count}} urami',
	    other: '{{count}} urami'
	  },
	  xDays: {
	    one: '{{count}} dnem',
	    two: '{{count}} dnevoma',
	    few: '{{count}} dnevi',
	    other: '{{count}} dnevi'
	  },
	  aboutXMonths: {
	    one: 'približno {{count}} mesecem',
	    two: 'približno {{count}} mesecema',
	    few: 'približno {{count}} meseci',
	    other: 'približno {{count}} meseci'
	  },
	  xMonths: {
	    one: '{{count}} mesecem',
	    two: '{{count}} mesecema',
	    few: '{{count}} meseci',
	    other: '{{count}} meseci'
	  },
	  aboutXYears: {
	    one: 'približno {{count}} letom',
	    two: 'približno {{count}} letoma',
	    few: 'približno {{count}} leti',
	    other: 'približno {{count}} leti'
	  },
	  xYears: {
	    one: '{{count}} letom',
	    two: '{{count}} letoma',
	    few: '{{count}} leti',
	    other: '{{count}} leti'
	  },
	  overXYears: {
	    one: 'več kot {{count}} letom',
	    two: 'več kot {{count}} letoma',
	    few: 'več kot {{count}} leti',
	    other: 'več kot {{count}} leti'
	  },
	  almostXYears: {
	    one: 'skoraj {{count}} letom',
	    two: 'skoraj {{count}} letoma',
	    few: 'skoraj {{count}} leti',
	    other: 'skoraj {{count}} leti'
	  }
	};
	var distanceInWordsLocaleFuture = {
	  lessThanXSeconds: {
	    one: 'manj kot {{count}} sekundo',
	    two: 'manj kot {{count}} sekundi',
	    few: 'manj kot {{count}} sekunde',
	    other: 'manj kot {{count}} sekund'
	  },
	  xSeconds: {
	    one: '{{count}} sekundo',
	    two: '{{count}} sekundi',
	    few: '{{count}} sekunde',
	    other: '{{count}} sekund'
	  },
	  halfAMinute: 'pol minute',
	  lessThanXMinutes: {
	    one: 'manj kot {{count}} minuto',
	    two: 'manj kot {{count}} minuti',
	    few: 'manj kot {{count}} minute',
	    other: 'manj kot {{count}} minut'
	  },
	  xMinutes: {
	    one: '{{count}} minuto',
	    two: '{{count}} minuti',
	    few: '{{count}} minute',
	    other: '{{count}} minut'
	  },
	  aboutXHours: {
	    one: 'približno {{count}} uro',
	    two: 'približno {{count}} uri',
	    few: 'približno {{count}} ure',
	    other: 'približno {{count}} ur'
	  },
	  xHours: {
	    one: '{{count}} uro',
	    two: '{{count}} uri',
	    few: '{{count}} ure',
	    other: '{{count}} ur'
	  },
	  xDays: {
	    one: '{{count}} dan',
	    two: '{{count}} dni',
	    few: '{{count}} dni',
	    other: '{{count}} dni'
	  },
	  aboutXMonths: {
	    one: 'približno {{count}} mesec',
	    two: 'približno {{count}} meseca',
	    few: 'približno {{count}} mesece',
	    other: 'približno {{count}} mesecev'
	  },
	  xMonths: {
	    one: '{{count}} mesec',
	    two: '{{count}} meseca',
	    few: '{{count}} mesece',
	    other: '{{count}} mesecev'
	  },
	  aboutXYears: {
	    one: 'približno {{count}} leto',
	    two: 'približno {{count}} leti',
	    few: 'približno {{count}} leta',
	    other: 'približno {{count}} let'
	  },
	  xYears: {
	    one: '{{count}} leto',
	    two: '{{count}} leti',
	    few: '{{count}} leta',
	    other: '{{count}} let'
	  },
	  overXYears: {
	    one: 'več kot {{count}} leto',
	    two: 'več kot {{count}} leti',
	    few: 'več kot {{count}} leta',
	    other: 'več kot {{count}} let'
	  },
	  almostXYears: {
	    one: 'skoraj {{count}} leto',
	    two: 'skoraj {{count}} leti',
	    few: 'skoraj {{count}} leta',
	    other: 'skoraj {{count}} let'
	  }
	};
	
	function getFormFromCount(count) {
	  switch (count % 100) {
	    case 1:
	      return 'one';
	
	    case 2:
	      return 'two';
	
	    case 3:
	    case 4:
	      return 'few';
	
	    default:
	      return 'other';
	  }
	}
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var localeObject = distanceInWordsLocale;
	  var result = '';
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      localeObject = distanceInWordsLocaleFuture;
	      result += 'čez ';
	    } else {
	      localeObject = distanceInWordsLocalePast;
	      result += 'pred ';
	    }
	  }
	
	  if (typeof localeObject[token] === 'string') {
	    result += localeObject[token];
	  } else {
	    var form = getFormFromCount(count);
	    result += localeObject[token][form].replace('{{count}}', count);
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, dd. MMMM y',
	  long: 'dd. MMMM y',
	  medium: 'd. MMM y',
	  short: 'd. MM. yy'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  long: '{{date}} {{time}}',
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1329 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: function (date) {
	    var day = date.getUTCDay();
	
	    switch (day) {
	      case 0:
	        return "'prejšnjo nedeljo ob' p";
	
	      case 3:
	        return "'prejšnjo sredo ob' p";
	
	      case 6:
	        return "'prejšnjo soboto ob' p";
	
	      default:
	        return "'prejšnji' EEEE 'ob' p";
	    }
	  },
	  yesterday: "'včeraj ob' p",
	  today: "'danes ob' p",
	  tomorrow: "'jutri ob' p",
	  nextWeek: function (date) {
	    var day = date.getUTCDay();
	
	    switch (day) {
	      case 0:
	        return "'naslednjo nedeljo ob' p";
	
	      case 3:
	        return "'naslednjo sredo ob' p";
	
	      case 6:
	        return "'naslednjo soboto ob' p";
	
	      default:
	        return "'naslednji' EEEE 'ob' p";
	    }
	  },
	  other: 'P'
	};
	
	function formatRelative(token, date, _baseDate, _options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return String(number).concat('.');
	}
	
	var eraValues = {
	  narrow: ['pr. n. št.', 'po n. št.'],
	  abbreviated: ['pr. n. št.', 'po n. št.'],
	  wide: ['pred našim štetjem', 'po našem štetju']
	};
	var monthValues = {
	  narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
	  abbreviated: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'avg.', 'sep.', 'okt.', 'nov.', 'dec.'],
	  wide: ['januar', 'februar', 'marec', 'april', 'maj', 'junij', 'julij', 'avgust', 'september', 'oktober', 'november', 'december']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1. čet.', '2. čet.', '3. čet.', '4. čet.'],
	  wide: ['1. četrtletje', '2. četrtletje', '3. četrtletje', '4. četrtletje']
	};
	var dayValues = {
	  narrow: ['n', 'p', 't', 's', 'č', 'p', 's'],
	  short: ['ned.', 'pon.', 'tor.', 'sre.', 'čet.', 'pet.', 'sob.'],
	  abbreviated: ['ned.', 'pon.', 'tor.', 'sre.', 'čet.', 'pet.', 'sob.'],
	  wide: ['nedelja', 'ponedeljek', 'torek', 'sreda', 'četrtek', 'petek', 'sobota']
	};
	var dayPeriodValuesStandalone = {
	  narrow: {
	    am: 'd',
	    pm: 'p',
	    midnight: '24.00',
	    noon: '12.00',
	    morning: 'j',
	    afternoon: 'p',
	    evening: 'v',
	    night: 'n'
	  },
	  abbreviated: {
	    am: 'dop.',
	    pm: 'pop.',
	    midnight: 'poln.',
	    noon: 'pold.',
	    morning: 'jut.',
	    afternoon: 'pop.',
	    evening: 'več.',
	    night: 'noč'
	  },
	  wide: {
	    am: 'dop.',
	    pm: 'pop.',
	    midnight: 'polnoč',
	    noon: 'poldne',
	    morning: 'jutro',
	    afternoon: 'popoldne',
	    evening: 'večer',
	    night: 'noč'
	  }
	};
	var dayPeriodValuesFormatting = {
	  narrow: {
	    am: 'd',
	    pm: 'p',
	    midnight: '24.00',
	    noon: '12.00',
	    morning: 'zj',
	    afternoon: 'p',
	    evening: 'zv',
	    night: 'po'
	  },
	  abbreviated: {
	    am: 'dop.',
	    pm: 'pop.',
	    midnight: 'opoln.',
	    noon: 'opold.',
	    morning: 'zjut.',
	    afternoon: 'pop.',
	    evening: 'zveč.',
	    night: 'ponoči'
	  },
	  wide: {
	    am: 'dop.',
	    pm: 'pop.',
	    midnight: 'opolnoči',
	    noon: 'opoldne',
	    morning: 'zjutraj',
	    afternoon: 'popoldan',
	    evening: 'zvečer',
	    night: 'ponoči'
	  }
	};
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValuesStandalone,
	    defaultWidth: 'wide',
	    formattingValues: dayPeriodValuesFormatting,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(8));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)\./i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  abbreviated: /^(pr\. n\. št\.|po n\. št\.)/i,
	  wide: /^(pred Kristusom|pred na[sš]im [sš]tetjem|po Kristusu|po na[sš]em [sš]tetju|na[sš]ega [sš]tetja)/i
	};
	var parseEraPatterns = {
	  any: [/^pr/i, /^(po|na[sš]em)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234]\.\s?[čc]et\.?/i,
	  wide: /^[1234]\. [čc]etrtletje/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan\.|feb\.|mar\.|apr\.|maj|jun\.|jul\.|avg\.|sep\.|okt\.|nov\.|dec\.)/i,
	  wide: /^(januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  abbreviated: [/^ja/i, /^fe/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^av/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  wide: [/^ja/i, /^fe/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^av/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[nptsčc]/i,
	  short: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
	  abbreviated: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
	  wide: /^(nedelja|ponedeljek|torek|sreda|[cč]etrtek|petek|sobota)/i
	};
	var parseDayPatterns = {
	  narrow: [/^n/i, /^p/i, /^t/i, /^s/i, /^[cč]/i, /^p/i, /^s/i],
	  any: [/^n/i, /^po/i, /^t/i, /^sr/i, /^[cč]/i, /^pe/i, /^so/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(d|po?|z?v|n|z?j|24\.00|12\.00)/i,
	  any: /^(dop\.|pop\.|o?poln(\.|o[cč]i?)|o?pold(\.|ne)|z?ve[cč](\.|er)|(po)?no[cč]i?|popold(ne|an)|jut(\.|ro)|zjut(\.|raj))/i
	};
	var parseDayPeriodPatterns = {
	  narrow: {
	    am: /^d/i,
	    pm: /^p/i,
	    midnight: /^24/i,
	    noon: /^12/i,
	    morning: /^(z?j)/i,
	    afternoon: /^p/i,
	    evening: /^(z?v)/i,
	    night: /^(n|po)/i
	  },
	  any: {
	    am: /^dop\./i,
	    pm: /^pop\./i,
	    midnight: /^o?poln/i,
	    noon: /^o?pold/i,
	    morning: /j/i,
	    afternoon: /^pop\./i,
	    evening: /^z?ve/i,
	    night: /(po)?no/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1327));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1328));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1329));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1330));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1331));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Slovenian locale.
	 * @language Slovenian
	 * @iso-639-2 slv
	 * @author Adam Stradovnik [@Neoglyph]{@link https://github.com/Neoglyph}
	 * @author Mato Žgajner [@mzgajner]{@link https://github.com/mzgajner}
	 */
	var locale = {
	  code: 'sl',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1333 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'më pak se një sekondë',
	    other: 'më pak se {{count}} sekonda'
	  },
	  xSeconds: {
	    one: '1 sekondë',
	    other: '{{count}} sekonda'
	  },
	  halfAMinute: 'gjysëm minuti',
	  lessThanXMinutes: {
	    one: 'më pak se një minute',
	    other: 'më pak se {{count}} minuta'
	  },
	  xMinutes: {
	    one: '1 minutë',
	    other: '{{count}} minuta'
	  },
	  aboutXHours: {
	    one: 'rreth 1 orë',
	    other: 'rreth {{count}} orë'
	  },
	  xHours: {
	    one: '1 orë',
	    other: '{{count}} orë'
	  },
	  xDays: {
	    one: '1 ditë',
	    other: '{{count}} ditë'
	  },
	  aboutXWeeks: {
	    one: 'rreth 1 javë',
	    other: 'rreth {{count}} javë'
	  },
	  xWeeks: {
	    one: '1 javë',
	    other: '{{count}} javë'
	  },
	  aboutXMonths: {
	    one: 'rreth 1 muaj',
	    other: 'rreth {{count}} muaj'
	  },
	  xMonths: {
	    one: '1 muaj',
	    other: '{{count}} muaj'
	  },
	  aboutXYears: {
	    one: 'rreth 1 vit',
	    other: 'rreth {{count}} vite'
	  },
	  xYears: {
	    one: '1 vit',
	    other: '{{count}} vite'
	  },
	  overXYears: {
	    one: 'mbi 1 vit',
	    other: 'mbi {{count}} vite'
	  },
	  almostXYears: {
	    one: 'pothuajse 1 vit',
	    other: 'pothuajse {{count}} vite'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'në ' + result;
	    } else {
	      return result + ' më parë';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, MMMM do, y',
	  long: 'MMMM do, y',
	  medium: 'MMM d, y',
	  short: 'MM/dd/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'në' {{time}}",
	  long: "{{date}} 'në' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1335 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'të' eeee 'e shkuar në' p",
	  yesterday: "'dje në' p",
	  today: "'sot në' p",
	  tomorrow: "'nesër në' p",
	  nextWeek: "eeee 'at' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['P', 'M'],
	  abbreviated: ['PK', 'MK'],
	  wide: ['Para Krishtit', 'Mbas Krishtit']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['4-mujori I', '4-mujori II', '4-mujori III', '4-mujori IV']
	}; // Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['J', 'S', 'M', 'P', 'M', 'Q', 'K', 'G', 'S', 'T', 'N', 'D'],
	  abbreviated: ['Jan', 'Shk', 'Mar', 'Pri', 'Maj', 'Qer', 'Kor', 'Gus', 'Sht', 'Tet', 'Nën', 'Dhj'],
	  wide: ['Janar', 'Shkurt', 'Mars', 'Prill', 'Maj', 'Qershor', 'Korrik', 'Gusht', 'Shtator', 'Tetor', 'Nëntor', 'Dhjetor']
	};
	var dayValues = {
	  narrow: ['D', 'H', 'M', 'M', 'E', 'P', 'S'],
	  short: ['Di', 'Hë', 'Ma', 'Më', 'En', 'Pr', 'Sh'],
	  abbreviated: ['Die', 'Hën', 'Mar', 'Mër', 'Enj', 'Pre', 'Sht'],
	  wide: ['Dielë', 'Hënë', 'Martë', 'Mërkurë', 'Enjte', 'Premte', 'Shtunë']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'p',
	    pm: 'm',
	    midnight: 'm',
	    noon: 'd',
	    morning: 'mëngjes',
	    afternoon: 'dite',
	    evening: 'mbrëmje',
	    night: 'natë'
	  },
	  abbreviated: {
	    am: 'PD',
	    pm: 'MD',
	    midnight: 'mesnëtë',
	    noon: 'drek',
	    morning: 'mëngjes',
	    afternoon: 'mbasdite',
	    evening: 'mbrëmje',
	    night: 'natë'
	  },
	  wide: {
	    am: 'p.d.',
	    pm: 'm.d.',
	    midnight: 'mesnëtë',
	    noon: 'drek',
	    morning: 'mëngjes',
	    afternoon: 'mbasdite',
	    evening: 'mbrëmje',
	    night: 'natë'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'p',
	    pm: 'm',
	    midnight: 'm',
	    noon: 'd',
	    morning: 'në mëngjes',
	    afternoon: 'në mbasdite',
	    evening: 'në mbrëmje',
	    night: 'në mesnatë'
	  },
	  abbreviated: {
	    am: 'PD',
	    pm: 'MD',
	    midnight: 'mesnatë',
	    noon: 'drek',
	    morning: 'në mëngjes',
	    afternoon: 'në mbasdite',
	    evening: 'në mbrëmje',
	    night: 'në mesnatë'
	  },
	  wide: {
	    am: 'p.d.',
	    pm: 'm.d.',
	    midnight: 'mesnatë',
	    noon: 'drek',
	    morning: 'në mëngjes',
	    afternoon: 'në mbasdite',
	    evening: 'në mbrëmje',
	    night: 'në mesnatë'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	
	  var options = _dirtyOptions || {};
	  var unit = String(options.unit);
	  if (unit === 'hour') return number;
	  if (number === 1) return number + '-rë';
	  if (number === 4) return number + 't';
	  return number + '-të';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(-rë|-të|t|)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(p|m)/i,
	  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
	  wide: /^(para krishtit|mbas krishtit)/i
	};
	var parseEraPatterns = {
	  any: [/^b/i, /^(p|m)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234]-mujori (i{1,3}|iv)/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jsmpqkftnd]/i,
	  abbreviated: /^(jan|shk|mar|pri|maj|qer|kor|gus|sht|tet|nën|dhj)/i,
	  wide: /^(janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^s/i, /^m/i, /^p/i, /^m/i, /^q/i, /^k/i, /^g/i, /^s/i, /^t/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^shk/i, /^mar/i, /^pri/i, /^maj/i, /^qer/i, /^kor/i, /^gu/i, /^sht/i, /^tet/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[dhmeps]/i,
	  short: /^(di|hë|ma|më|en|pr|sh)/i,
	  abbreviated: /^(die|hën|mar|mër|enj|pre|sht)/i,
	  wide: /^(dielë|hënë|martë|mërkurë|enjte|premte|shtunë)/i
	};
	var parseDayPatterns = {
	  narrow: [/^d/i, /^h/i, /^m/i, /^m/i, /^e/i, /^p/i, /^s/i],
	  any: [/^d/i, /^h/i, /^ma/i, /^më/i, /^e/i, /^p/i, /^s/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(p|m|me|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i,
	  any: /^([pm]\.?\s?d\.?|drek|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^p/i,
	    pm: /^m/i,
	    midnight: /^me/i,
	    noon: /^dr/i,
	    morning: /mëngjes/i,
	    afternoon: /mbasdite/i,
	    evening: /mbrëmje/i,
	    night: /natë/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1333));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1334));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1335));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1336));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1337));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Albanian locale.
	 * @language Shqip
	 * @iso-639-2 sqi
	 * @author Ardit Dine [@arditdine]{@link https://github.com/arditdine}
	 */
	var locale = {
	  code: 'sq',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1339 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: {
	      standalone: 'manje od 1 sekunde',
	      withPrepositionAgo: 'manje od 1 sekunde',
	      withPrepositionIn: 'manje od 1 sekundu'
	    },
	    dual: 'manje od {{count}} sekunde',
	    other: 'manje od {{count}} sekundi'
	  },
	  xSeconds: {
	    one: {
	      standalone: '1 sekunda',
	      withPrepositionAgo: '1 sekunde',
	      withPrepositionIn: '1 sekundu'
	    },
	    dual: '{{count}} sekunde',
	    other: '{{count}} sekundi'
	  },
	  halfAMinute: 'pola minute',
	  lessThanXMinutes: {
	    one: {
	      standalone: 'manje od 1 minute',
	      withPrepositionAgo: 'manje od 1 minute',
	      withPrepositionIn: 'manje od 1 minutu'
	    },
	    dual: 'manje od {{count}} minute',
	    other: 'manje od {{count}} minuta'
	  },
	  xMinutes: {
	    one: {
	      standalone: '1 minuta',
	      withPrepositionAgo: '1 minute',
	      withPrepositionIn: '1 minutu'
	    },
	    dual: '{{count}} minute',
	    other: '{{count}} minuta'
	  },
	  aboutXHours: {
	    one: {
	      standalone: 'oko 1 sat',
	      withPrepositionAgo: 'oko 1 sat',
	      withPrepositionIn: 'oko 1 sat'
	    },
	    dual: 'oko {{count}} sata',
	    other: 'oko {{count}} sati'
	  },
	  xHours: {
	    one: {
	      standalone: '1 sat',
	      withPrepositionAgo: '1 sat',
	      withPrepositionIn: '1 sat'
	    },
	    dual: '{{count}} sata',
	    other: '{{count}} sati'
	  },
	  xDays: {
	    one: {
	      standalone: '1 dan',
	      withPrepositionAgo: '1 dan',
	      withPrepositionIn: '1 dan'
	    },
	    dual: '{{count}} dana',
	    other: '{{count}} dana'
	  },
	  aboutXWeeks: {
	    one: {
	      standalone: 'oko 1 nedelju',
	      withPrepositionAgo: 'oko 1 nedelju',
	      withPrepositionIn: 'oko 1 nedelju'
	    },
	    dual: 'oko {{count}} nedelje',
	    other: 'oko {{count}} nedelje'
	  },
	  xWeeks: {
	    one: {
	      standalone: '1 nedelju',
	      withPrepositionAgo: '1 nedelju',
	      withPrepositionIn: '1 nedelju'
	    },
	    dual: '{{count}} nedelje',
	    other: '{{count}} nedelje'
	  },
	  aboutXMonths: {
	    one: {
	      standalone: 'oko 1 mesec',
	      withPrepositionAgo: 'oko 1 mesec',
	      withPrepositionIn: 'oko 1 mesec'
	    },
	    dual: 'oko {{count}} meseca',
	    other: 'oko {{count}} meseci'
	  },
	  xMonths: {
	    one: {
	      standalone: '1 mesec',
	      withPrepositionAgo: '1 mesec',
	      withPrepositionIn: '1 mesec'
	    },
	    dual: '{{count}} meseca',
	    other: '{{count}} meseci'
	  },
	  aboutXYears: {
	    one: {
	      standalone: 'oko 1 godinu',
	      withPrepositionAgo: 'oko 1 godinu',
	      withPrepositionIn: 'oko 1 godinu'
	    },
	    dual: 'oko {{count}} godine',
	    other: 'oko {{count}} godina'
	  },
	  xYears: {
	    one: {
	      standalone: '1 godina',
	      withPrepositionAgo: '1 godine',
	      withPrepositionIn: '1 godinu'
	    },
	    dual: '{{count}} godine',
	    other: '{{count}} godina'
	  },
	  overXYears: {
	    one: {
	      standalone: 'preko 1 godinu',
	      withPrepositionAgo: 'preko 1 godinu',
	      withPrepositionIn: 'preko 1 godinu'
	    },
	    dual: 'preko {{count}} godine',
	    other: 'preko {{count}} godina'
	  },
	  almostXYears: {
	    one: {
	      standalone: 'gotovo 1 godinu',
	      withPrepositionAgo: 'gotovo 1 godinu',
	      withPrepositionIn: 'gotovo 1 godinu'
	    },
	    dual: 'gotovo {{count}} godine',
	    other: 'gotovo {{count}} godina'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    if (options.addSuffix) {
	      if (options.comparison > 0) {
	        result = formatDistanceLocale[token].one.withPrepositionIn;
	      } else {
	        result = formatDistanceLocale[token].one.withPrepositionAgo;
	      }
	    } else {
	      result = formatDistanceLocale[token].one.standalone;
	    }
	  } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
	  String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
	  ) {
	      result = formatDistanceLocale[token].dual.replace('{{count}}', count);
	    } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'za ' + result;
	    } else {
	      return 'pre ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d. MMMM yyyy.',
	  long: 'd. MMMM yyyy.',
	  medium: 'd. MMM yy.',
	  short: 'dd. MM. yy.'
	};
	var timeFormats = {
	  full: 'HH:mm:ss (zzzz)',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'u' {{time}}",
	  long: "{{date}} 'u' {{time}}",
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1341 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: function (date) {
	    var day = date.getUTCDay();
	
	    switch (day) {
	      case 0:
	        return "'prošle nedelje u' p";
	
	      case 3:
	        return "'prošle srede u' p";
	
	      case 6:
	        return "'prošle subote u' p";
	
	      default:
	        return "'prošli' EEEE 'u' p";
	    }
	  },
	  yesterday: "'juče u' p",
	  today: "'danas u' p",
	  tomorrow: "'sutra u' p",
	  nextWeek: function (date) {
	    var day = date.getUTCDay();
	
	    switch (day) {
	      case 0:
	        return "'sledeće nedelje u' p";
	
	      case 3:
	        return "'sledeću sredu u' p";
	
	      case 6:
	        return "'sledeću subotu u' p";
	
	      default:
	        return "'sledeći' EEEE 'u' p";
	    }
	  },
	  other: 'P'
	};
	
	function formatRelative(token, date, _baseDate, _options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return String(number).concat('.');
	}
	
	var eraValues = {
	  narrow: ['pr.n.e.', 'AD'],
	  abbreviated: ['pr. Hr.', 'po. Hr.'],
	  wide: ['Pre Hrista', 'Posle Hrista']
	};
	var monthValues = {
	  narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
	  abbreviated: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'avg', 'sep', 'okt', 'nov', 'dec'],
	  wide: ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar']
	};
	var formattingMonthValues = {
	  narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
	  abbreviated: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'avg', 'sep', 'okt', 'nov', 'dec'],
	  wide: ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar']
	};
	var quarterValues = {
	  narrow: ['1.', '2.', '3.', '4.'],
	  abbreviated: ['1. kv.', '2. kv.', '3. kv.', '4. kv.'],
	  wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
	};
	var dayValues = {
	  narrow: ['N', 'P', 'U', 'S', 'Č', 'P', 'S'],
	  short: ['ned', 'pon', 'uto', 'sre', 'čet', 'pet', 'sub'],
	  abbreviated: ['ned', 'pon', 'uto', 'sre', 'čet', 'pet', 'sub'],
	  wide: ['nedelja', 'ponedeljak', 'utorak', 'sreda', 'četvrtak', 'petak', 'subota']
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutru',
	    afternoon: 'popodne',
	    evening: 'uveče',
	    night: 'noću'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutru',
	    afternoon: 'popodne',
	    evening: 'uveče',
	    night: 'noću'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutru',
	    afternoon: 'posle podne',
	    evening: 'uveče',
	    night: 'noću'
	  }
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutru',
	    afternoon: 'popodne',
	    evening: 'uveče',
	    night: 'noću'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutru',
	    afternoon: 'popodne',
	    evening: 'uveče',
	    night: 'noću'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'ponoć',
	    noon: 'podne',
	    morning: 'ujutru',
	    afternoon: 'posle podne',
	    evening: 'uveče',
	    night: 'noću'
	  }
	};
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(8));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)\./i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(pr\.n\.e\.|AD)/i,
	  abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
	  wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
	};
	var parseEraPatterns = {
	  any: [/^pr/i, /^(po|nova)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234]\.\s?kv\.?/i,
	  wide: /^[1234]\. kvartal/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(10|11|12|[123456789])\./i,
	  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
	  wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
	};
	var parseMonthPatterns = {
	  narrow: [/(10|11|12|[123456789])/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^avg/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[npusčc]/i,
	  short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
	  abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
	  wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
	  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^pono/i,
	    noon: /^pod/i,
	    morning: /jutro/i,
	    afternoon: /(posle\s|po)+podne/i,
	    evening: /(uvece|uveče)/i,
	    night: /(nocu|noću)/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1339));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1340));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1341));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1342));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1343));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Serbian latin locale.
	 * @language Serbian
	 * @iso-639-2 srp
	 * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
	 */
	var locale = {
	  code: 'sr-Latn',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1345 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: {
	      standalone: 'мање од 1 секунде',
	      withPrepositionAgo: 'мање од 1 секунде',
	      withPrepositionIn: 'мање од 1 секунду'
	    },
	    dual: 'мање од {{count}} секунде',
	    other: 'мање од {{count}} секунди'
	  },
	  xSeconds: {
	    one: {
	      standalone: '1 секунда',
	      withPrepositionAgo: '1 секунде',
	      withPrepositionIn: '1 секунду'
	    },
	    dual: '{{count}} секунде',
	    other: '{{count}} секунди'
	  },
	  halfAMinute: 'пола минуте',
	  lessThanXMinutes: {
	    one: {
	      standalone: 'мање од 1 минуте',
	      withPrepositionAgo: 'мање од 1 минуте',
	      withPrepositionIn: 'мање од 1 минуту'
	    },
	    dual: 'мање од {{count}} минуте',
	    other: 'мање од {{count}} минута'
	  },
	  xMinutes: {
	    one: {
	      standalone: '1 минута',
	      withPrepositionAgo: '1 минуте',
	      withPrepositionIn: '1 минуту'
	    },
	    dual: '{{count}} минуте',
	    other: '{{count}} минута'
	  },
	  aboutXHours: {
	    one: {
	      standalone: 'око 1 сат',
	      withPrepositionAgo: 'око 1 сат',
	      withPrepositionIn: 'око 1 сат'
	    },
	    dual: 'око {{count}} сата',
	    other: 'око {{count}} сати'
	  },
	  xHours: {
	    one: {
	      standalone: '1 сат',
	      withPrepositionAgo: '1 сат',
	      withPrepositionIn: '1 сат'
	    },
	    dual: '{{count}} сата',
	    other: '{{count}} сати'
	  },
	  xDays: {
	    one: {
	      standalone: '1 дан',
	      withPrepositionAgo: '1 дан',
	      withPrepositionIn: '1 дан'
	    },
	    dual: '{{count}} дана',
	    other: '{{count}} дана'
	  },
	  aboutXWeeks: {
	    one: {
	      standalone: 'око 1 недељу',
	      withPrepositionAgo: 'око 1 недељу',
	      withPrepositionIn: 'око 1 недељу'
	    },
	    dual: 'око {{count}} недеље',
	    other: 'око {{count}} недеље'
	  },
	  xWeeks: {
	    one: {
	      standalone: '1 недељу',
	      withPrepositionAgo: '1 недељу',
	      withPrepositionIn: '1 недељу'
	    },
	    dual: '{{count}} недеље',
	    other: '{{count}} недеље'
	  },
	  aboutXMonths: {
	    one: {
	      standalone: 'око 1 месец',
	      withPrepositionAgo: 'око 1 месец',
	      withPrepositionIn: 'око 1 месец'
	    },
	    dual: 'око {{count}} месеца',
	    other: 'око {{count}} месеци'
	  },
	  xMonths: {
	    one: {
	      standalone: '1 месец',
	      withPrepositionAgo: '1 месец',
	      withPrepositionIn: '1 месец'
	    },
	    dual: '{{count}} месеца',
	    other: '{{count}} месеци'
	  },
	  aboutXYears: {
	    one: {
	      standalone: 'око 1 годину',
	      withPrepositionAgo: 'око 1 годину',
	      withPrepositionIn: 'око 1 годину'
	    },
	    dual: 'око {{count}} године',
	    other: 'око {{count}} година'
	  },
	  xYears: {
	    one: {
	      standalone: '1 година',
	      withPrepositionAgo: '1 године',
	      withPrepositionIn: '1 годину'
	    },
	    dual: '{{count}} године',
	    other: '{{count}} година'
	  },
	  overXYears: {
	    one: {
	      standalone: 'преко 1 годину',
	      withPrepositionAgo: 'преко 1 годину',
	      withPrepositionIn: 'преко 1 годину'
	    },
	    dual: 'преко {{count}} године',
	    other: 'преко {{count}} година'
	  },
	  almostXYears: {
	    one: {
	      standalone: 'готово 1 годину',
	      withPrepositionAgo: 'готово 1 годину',
	      withPrepositionIn: 'готово 1 годину'
	    },
	    dual: 'готово {{count}} године',
	    other: 'готово {{count}} година'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    if (options.addSuffix) {
	      if (options.comparison > 0) {
	        result = formatDistanceLocale[token].one.withPrepositionIn;
	      } else {
	        result = formatDistanceLocale[token].one.withPrepositionAgo;
	      }
	    } else {
	      result = formatDistanceLocale[token].one.standalone;
	    }
	  } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
	  String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
	  ) {
	      result = formatDistanceLocale[token].dual.replace('{{count}}', count);
	    } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'за ' + result;
	    } else {
	      return 'пре ' + result;
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, d. MMMM yyyy.',
	  long: 'd. MMMM yyyy.',
	  medium: 'd. MMM yy.',
	  short: 'dd. MM. yy.'
	};
	var timeFormats = {
	  full: 'HH:mm:ss (zzzz)',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'у' {{time}}",
	  long: "{{date}} 'у' {{time}}",
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1347 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: function (date) {
	    var day = date.getUTCDay();
	
	    switch (day) {
	      case 0:
	        return "'прошле недеље у' p";
	
	      case 3:
	        return "'прошле среде у' p";
	
	      case 6:
	        return "'прошле суботе у' p";
	
	      default:
	        return "'прошли' EEEE 'у' p";
	    }
	  },
	  yesterday: "'јуче у' p",
	  today: "'данас у' p",
	  tomorrow: "'сутра у' p",
	  nextWeek: function (date) {
	    var day = date.getUTCDay();
	
	    switch (day) {
	      case 0:
	        return "'следеће недеље у' p";
	
	      case 3:
	        return "'следећу среду у' p";
	
	      case 6:
	        return "'следећу суботу у' p";
	
	      default:
	        return "'следећи' EEEE 'у' p";
	    }
	  },
	  other: 'P'
	};
	
	function formatRelative(token, date, _baseDate, _options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return String(number).concat('.');
	}
	
	var eraValues = {
	  narrow: ['пр.н.е.', 'АД'],
	  abbreviated: ['пр. Хр.', 'по. Хр.'],
	  wide: ['Пре Христа', 'После Христа']
	};
	var monthValues = {
	  narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
	  abbreviated: ['јан', 'феб', 'мар', 'апр', 'мај', 'јун', 'јул', 'авг', 'сеп', 'окт', 'нов', 'дец'],
	  wide: ['јануар', 'фебруар', 'март', 'април', 'мај', 'јун', 'јул', 'август', 'септембар', 'октобар', 'новембар', 'децембар']
	};
	var formattingMonthValues = {
	  narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
	  abbreviated: ['јан', 'феб', 'мар', 'апр', 'мај', 'јун', 'јул', 'авг', 'сеп', 'окт', 'нов', 'дец'],
	  wide: ['јануар', 'фебруар', 'март', 'април', 'мај', 'јун', 'јул', 'август', 'септембар', 'октобар', 'новембар', 'децембар']
	};
	var quarterValues = {
	  narrow: ['1.', '2.', '3.', '4.'],
	  abbreviated: ['1. кв.', '2. кв.', '3. кв.', '4. кв.'],
	  wide: ['1. квартал', '2. квартал', '3. квартал', '4. квартал']
	};
	var dayValues = {
	  narrow: ['Н', 'П', 'У', 'С', 'Ч', 'П', 'С'],
	  short: ['нед', 'пон', 'уто', 'сре', 'чет', 'пет', 'суб'],
	  abbreviated: ['нед', 'пон', 'уто', 'сре', 'чет', 'пет', 'суб'],
	  wide: ['недеља', 'понедељак', 'уторак', 'среда', 'четвртак', 'петак', 'субота']
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'АМ',
	    pm: 'ПМ',
	    midnight: 'поноћ',
	    noon: 'подне',
	    morning: 'ујутру',
	    afternoon: 'поподне',
	    evening: 'увече',
	    night: 'ноћу'
	  },
	  abbreviated: {
	    am: 'АМ',
	    pm: 'ПМ',
	    midnight: 'поноћ',
	    noon: 'подне',
	    morning: 'ујутру',
	    afternoon: 'поподне',
	    evening: 'увече',
	    night: 'ноћу'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'поноћ',
	    noon: 'подне',
	    morning: 'ујутру',
	    afternoon: 'после подне',
	    evening: 'увече',
	    night: 'ноћу'
	  }
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'поноћ',
	    noon: 'подне',
	    morning: 'ујутру',
	    afternoon: 'поподне',
	    evening: 'увече',
	    night: 'ноћу'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'поноћ',
	    noon: 'подне',
	    morning: 'ујутру',
	    afternoon: 'поподне',
	    evening: 'увече',
	    night: 'ноћу'
	  },
	  wide: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'поноћ',
	    noon: 'подне',
	    morning: 'ујутру',
	    afternoon: 'после подне',
	    evening: 'увече',
	    night: 'ноћу'
	  }
	};
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(8));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)\./i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(пр\.н\.е\.|АД)/i,
	  abbreviated: /^(пр\.\s?Хр\.|по\.\s?Хр\.)/i,
	  wide: /^(Пре Христа|пре нове ере|После Христа|нова ера)/i
	};
	var parseEraPatterns = {
	  any: [/^пр/i, /^(по|нова)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234]\.\s?кв\.?/i,
	  wide: /^[1234]\. квартал/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(10|11|12|[123456789])\./i,
	  abbreviated: /^(јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец)/i,
	  wide: /^((јануар|јануара)|(фебруар|фебруара)|(март|марта)|(април|априла)|(мја|маја)|(јун|јуна)|(јул|јула)|(август|августа)|(септембар|септембра)|(октобар|октобра)|(новембар|новембра)|(децембар|децембра))/i
	};
	var parseMonthPatterns = {
	  narrow: [/(10|11|12|[123456789])/i],
	  any: [/^ја/i, /^ф/i, /^мар/i, /^ап/i, /^мај/i, /^јун/i, /^јул/i, /^авг/i, /^с/i, /^о/i, /^н/i, /^д/i]
	};
	var matchDayPatterns = {
	  narrow: /^[пусчн]/i,
	  short: /^(нед|пон|уто|сре|чет|пет|суб)/i,
	  abbreviated: /^(нед|пон|уто|сре|чет|пет|суб)/i,
	  wide: /^(недеља|понедељак|уторак|среда|четвртак|петак|субота)/i
	};
	var parseDayPatterns = {
	  narrow: [/^п/i, /^у/i, /^с/i, /^ч/i, /^н/i],
	  any: [/^нед/i, /^пон/i, /^уто/i, /^сре/i, /^чет/i, /^пет/i, /^суб/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(ам|пм|поноћ|(по)?подне|увече|ноћу|после подне|ујутру)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^поно/i,
	    noon: /^под/i,
	    morning: /ујутру/i,
	    afternoon: /(после\s|по)+подне/i,
	    evening: /(увече)/i,
	    night: /(ноћу)/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1345));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1346));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1347));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1348));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1349));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Serbian cyrillic locale.
	 * @language Serbian
	 * @iso-639-2 srp
	 * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
	 */
	var locale = {
	  code: 'sr',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    singular: 'mindre än en sekund',
	    plural: 'mindre än {{count}} sekunder'
	  },
	  xSeconds: {
	    singular: 'en sekund',
	    plural: '{{count}} sekunder'
	  },
	  halfAMinute: 'en halv minut',
	  lessThanXMinutes: {
	    singular: 'mindre än en minut',
	    plural: 'mindre än {{count}} minuter'
	  },
	  xMinutes: {
	    singular: 'en minut',
	    plural: '{{count}} minuter'
	  },
	  aboutXHours: {
	    singular: 'ungefär en timme',
	    plural: 'ungefär {{count}} timmar'
	  },
	  xHours: {
	    singular: 'en timme',
	    plural: '{{count}} timmar'
	  },
	  xDays: {
	    singular: 'en dag',
	    plural: '{{count}} dagar'
	  },
	  aboutXWeeks: {
	    singular: 'ungefär en vecka',
	    plural: 'ungefär {{count}} vecka'
	  },
	  xWeeks: {
	    singular: 'en vecka',
	    plural: '{{count}} vecka'
	  },
	  aboutXMonths: {
	    singular: 'ungefär en månad',
	    plural: 'ungefär {{count}} månader'
	  },
	  xMonths: {
	    singular: 'en månad',
	    plural: '{{count}} månader'
	  },
	  aboutXYears: {
	    singular: 'ungefär ett år',
	    plural: 'ungefär {{count}} år'
	  },
	  xYears: {
	    singular: 'ett år',
	    plural: '{{count}} år'
	  },
	  overXYears: {
	    singular: 'över ett år',
	    plural: 'över {{count}} år'
	  },
	  almostXYears: {
	    singular: 'nästan ett år',
	    plural: 'nästan {{count}} år'
	  }
	};
	var wordMapping = ['noll', 'en', 'två', 'tre', 'fyra', 'fem', 'sex', 'sju', 'åtta', 'nio', 'tio', 'elva', 'tolv'];
	
	function formatDistance(token, count, options) {
	  options = options || {
	    onlyNumeric: false
	  };
	  var translation = formatDistanceLocale[token];
	  var result;
	
	  if (typeof translation === 'string') {
	    result = translation;
	  } else if (count === 0 || count > 1) {
	    if (options.onlyNumeric) {
	      result = translation.plural.replace('{{count}}', count);
	    } else {
	      result = translation.plural.replace('{{count}}', count < 13 ? wordMapping[count] : count);
	    }
	  } else {
	    result = translation.singular;
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'om ' + result;
	    } else {
	      return result + ' sedan';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE d MMMM y',
	  long: 'd MMMM y',
	  medium: 'd MMM y',
	  short: 'y-MM-dd'
	};
	var timeFormats = {
	  full: "'kl'. HH:mm:ss zzzz",
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'kl.' {{time}}",
	  long: "{{date}} 'kl.' {{time}}",
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'i' EEEE's kl.' p",
	  yesterday: "'igår kl.' p",
	  today: "'idag kl.' p",
	  tomorrow: "'imorgon kl.' p",
	  nextWeek: "EEEE 'kl.' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['f.Kr.', 'e.Kr.'],
	  abbreviated: ['f.Kr.', 'e.Kr.'],
	  wide: ['före Kristus', 'efter Kristus']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1:a kvartalet', '2:a kvartalet', '3:e kvartalet', '4:e kvartalet']
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['jan.', 'feb.', 'mars', 'apr.', 'maj', 'juni', 'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
	  wide: ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december']
	};
	var dayValues = {
	  narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
	  short: ['sö', 'må', 'ti', 'on', 'to', 'fr', 'lö'],
	  abbreviated: ['sön', 'mån', 'tis', 'ons', 'tors', 'fre', 'lör'],
	  wide: ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag']
	}; // https://www.unicode.org/cldr/charts/32/summary/sv.html#1888
	
	var dayPeriodValues = {
	  narrow: {
	    am: 'fm',
	    pm: 'em',
	    midnight: 'midnatt',
	    noon: 'middag',
	    morning: 'morg.',
	    afternoon: 'efterm.',
	    evening: 'kväll',
	    night: 'natt'
	  },
	  abbreviated: {
	    am: 'f.m.',
	    pm: 'e.m.',
	    midnight: 'midnatt',
	    noon: 'middag',
	    morning: 'morgon',
	    afternoon: 'efterm.',
	    evening: 'kväll',
	    night: 'natt'
	  },
	  wide: {
	    am: 'förmiddag',
	    pm: 'eftermiddag',
	    midnight: 'midnatt',
	    noon: 'middag',
	    morning: 'morgon',
	    afternoon: 'eftermiddag',
	    evening: 'kväll',
	    night: 'natt'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'fm',
	    pm: 'em',
	    midnight: 'midnatt',
	    noon: 'middag',
	    morning: 'på morg.',
	    afternoon: 'på efterm.',
	    evening: 'på kvällen',
	    night: 'på natten'
	  },
	  abbreviated: {
	    am: 'fm',
	    pm: 'em',
	    midnight: 'midnatt',
	    noon: 'middag',
	    morning: 'på morg.',
	    afternoon: 'på efterm.',
	    evening: 'på kvällen',
	    night: 'på natten'
	  },
	  wide: {
	    am: 'fm',
	    pm: 'em',
	    midnight: 'midnatt',
	    noon: 'middag',
	    morning: 'på morgonen',
	    afternoon: 'på eftermiddagen',
	    evening: 'på kvällen',
	    night: 'på natten'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  var rem100 = number % 100;
	
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	      case 2:
	        return number + ':a';
	    }
	  }
	
	  return number + ':e';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(:a|:e)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
	  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
	  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
	};
	var parseEraPatterns = {
	  any: [/^f/i, /^[ev]/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](:a|:e)? kvartalet/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|aug|sep|okt|nov|dec)\.?/i,
	  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smtofl]/i,
	  short: /^(sö|må|ti|on|to|fr|lö)/i,
	  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
	  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
	};
	var parseDayPatterns = {
	  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^f/i,
	    pm: /^e/i,
	    midnight: /^midn/i,
	    noon: /^midd/i,
	    morning: /morgon/i,
	    afternoon: /eftermiddag/i,
	    evening: /kväll/i,
	    night: /natt/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1351));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1352));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1353));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1354));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1355));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Swedish locale.
	 * @language Swedish
	 * @iso-639-2 swe
	 * @author Johannes Ulén [@ejulen]{@link https://github.com/ejulen}
	 * @author Alexander Nanberg [@alexandernanberg]{@link https://github.com/alexandernanberg}
	 * @author Henrik Andersson [@limelights]{@link https://github.com/limelights}
	 */
	var locale = {
	  code: 'sv',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: {
	      default: 'ஒரு வினாடிக்கு குறைவாக',
	      in: 'ஒரு வினாடிக்குள்',
	      ago: 'ஒரு வினாடிக்கு முன்பு'
	    },
	    other: {
	      default: '{{count}} வினாடிகளுக்கு குறைவாக',
	      in: '{{count}} வினாடிகளுக்குள்',
	      ago: '{{count}} வினாடிகளுக்கு முன்பு'
	    }
	  },
	  xSeconds: {
	    one: {
	      default: '1 வினாடி',
	      in: '1 வினாடியில்',
	      ago: '1 வினாடி முன்பு'
	    },
	    other: {
	      default: '{{count}} விநாடிகள்',
	      in: '{{count}} வினாடிகளில்',
	      ago: '{{count}} விநாடிகளுக்கு முன்பு'
	    }
	  },
	  halfAMinute: {
	    default: 'அரை நிமிடம்',
	    in: 'அரை நிமிடத்தில்',
	    ago: 'அரை நிமிடம் முன்பு'
	  },
	  lessThanXMinutes: {
	    one: {
	      default: 'ஒரு நிமிடத்திற்கும் குறைவாக',
	      in: 'ஒரு நிமிடத்திற்குள்',
	      ago: 'ஒரு நிமிடத்திற்கு முன்பு'
	    },
	    other: {
	      default: '{{count}} நிமிடங்களுக்கும் குறைவாக',
	      in: '{{count}} நிமிடங்களுக்குள்',
	      ago: '{{count}} நிமிடங்களுக்கு முன்பு'
	    }
	  },
	  xMinutes: {
	    one: {
	      default: '1 நிமிடம்',
	      in: '1 நிமிடத்தில்',
	      ago: '1 நிமிடம் முன்பு'
	    },
	    other: {
	      default: '{{count}} நிமிடங்கள்',
	      in: '{{count}} நிமிடங்களில்',
	      ago: '{{count}} நிமிடங்களுக்கு முன்பு'
	    }
	  },
	  aboutXHours: {
	    one: {
	      default: 'சுமார் 1 மணி நேரம்',
	      in: 'சுமார் 1 மணி நேரத்தில்',
	      ago: 'சுமார் 1 மணி நேரத்திற்கு முன்பு'
	    },
	    other: {
	      default: 'சுமார் {{count}} மணி நேரம்',
	      in: 'சுமார் {{count}} மணி நேரத்திற்கு முன்பு',
	      ago: 'சுமார் {{count}} மணி நேரத்தில்'
	    }
	  },
	  xHours: {
	    one: {
	      default: '1 மணி நேரம்',
	      in: '1 மணி நேரத்தில்',
	      ago: '1 மணி நேரத்திற்கு முன்பு'
	    },
	    other: {
	      default: '{{count}} மணி நேரம்',
	      in: '{{count}} மணி நேரத்தில்',
	      ago: '{{count}} மணி நேரத்திற்கு முன்பு'
	    }
	  },
	  xDays: {
	    one: {
	      default: '1 நாள்',
	      in: '1 நாளில்',
	      ago: '1 நாள் முன்பு'
	    },
	    other: {
	      default: '{{count}} நாட்கள்',
	      in: '{{count}} நாட்களில்',
	      ago: '{{count}} நாட்களுக்கு முன்பு'
	    }
	  },
	  aboutXWeeks: {
	    one: {
	      default: 'சுமார் 1 வாரம்',
	      in: 'சுமார் 1 வாரத்தில்',
	      ago: 'சுமார் 1 வாரம் முன்பு'
	    },
	    other: {
	      default: 'சுமார் {{count}} வாரங்கள்',
	      in: 'சுமார் {{count}} வாரங்களில்',
	      ago: 'சுமார் {{count}} வாரங்களுக்கு முன்பு'
	    }
	  },
	  xWeeks: {
	    one: {
	      default: '1 வாரம்',
	      in: '1 வாரத்தில்',
	      ago: '1 வாரம் முன்பு'
	    },
	    other: {
	      default: '{{count}} வாரங்கள்',
	      in: '{{count}} வாரங்களில்',
	      ago: '{{count}} வாரங்களுக்கு முன்பு'
	    }
	  },
	  aboutXMonths: {
	    one: {
	      default: 'சுமார் 1 மாதம்',
	      in: 'சுமார் 1 மாதத்தில்',
	      ago: 'சுமார் 1 மாதத்திற்கு முன்பு'
	    },
	    other: {
	      default: 'சுமார் {{count}} மாதங்கள்',
	      in: 'சுமார் {{count}} மாதங்களில்',
	      ago: 'சுமார் {{count}} மாதங்களுக்கு முன்பு'
	    }
	  },
	  xMonths: {
	    one: {
	      default: '1 மாதம்',
	      in: '1 மாதத்தில்',
	      ago: '1 மாதம் முன்பு'
	    },
	    other: {
	      default: '{{count}} மாதங்கள்',
	      in: '{{count}} மாதங்களில்',
	      ago: '{{count}} மாதங்களுக்கு முன்பு'
	    }
	  },
	  aboutXYears: {
	    one: {
	      default: 'சுமார் 1 வருடம்',
	      in: 'சுமார் 1 ஆண்டில்',
	      ago: 'சுமார் 1 வருடம் முன்பு'
	    },
	    other: {
	      default: 'சுமார் {{count}} ஆண்டுகள்',
	      in: 'சுமார் {{count}} ஆண்டுகளில்',
	      ago: 'சுமார் {{count}} ஆண்டுகளுக்கு முன்பு'
	    }
	  },
	  xYears: {
	    one: {
	      default: '1 வருடம்',
	      in: '1 ஆண்டில்',
	      ago: '1 வருடம் முன்பு'
	    },
	    other: {
	      default: '{{count}} ஆண்டுகள்',
	      in: '{{count}} ஆண்டுகளில்',
	      ago: '{{count}} ஆண்டுகளுக்கு முன்பு'
	    }
	  },
	  overXYears: {
	    one: {
	      default: '1 வருடத்திற்கு மேல்',
	      in: '1 வருடத்திற்கும் மேலாக',
	      ago: '1 வருடம் முன்பு'
	    },
	    other: {
	      default: '{{count}} ஆண்டுகளுக்கும் மேலாக',
	      in: '{{count}} ஆண்டுகளில்',
	      ago: '{{count}} ஆண்டுகளுக்கு முன்பு'
	    }
	  },
	  almostXYears: {
	    one: {
	      default: 'கிட்டத்தட்ட 1 வருடம்',
	      in: 'கிட்டத்தட்ட 1 ஆண்டில்',
	      ago: 'கிட்டத்தட்ட 1 வருடம் முன்பு'
	    },
	    other: {
	      default: 'கிட்டத்தட்ட {{count}} ஆண்டுகள்',
	      in: 'கிட்டத்தட்ட {{count}} ஆண்டுகளில்',
	      ago: 'கிட்டத்தட்ட {{count}} ஆண்டுகளுக்கு முன்பு'
	    }
	  }
	};
	
	function getFormatDistanceLocaleWithSuffix(resultObj, options) {
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return resultObj.in;
	    } else {
	      return resultObj.ago;
	    }
	  }
	
	  return resultObj.default;
	}
	
	function formatDistance(token, count) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var result;
	
	  if (formatDistanceLocale[token].default) {
	    result = getFormatDistanceLocaleWithSuffix(formatDistanceLocale[token], options);
	  } else if (count === 1) {
	    result = getFormatDistanceLocaleWithSuffix(formatDistanceLocale[token].one, options);
	  } else {
	    result = getFormatDistanceLocaleWithSuffix(formatDistanceLocale[token].other, options);
	  }
	
	  return result.replace('{{count}}', count);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Ref: https://www.unicode.org/cldr/charts/32/summary/ta.html
	// CLDR #1846 - #1849
	var dateFormats = {
	  full: 'EEEE, d MMMM, y',
	  long: 'd MMMM, y',
	  medium: 'd MMM, y',
	  short: 'd/M/yy'
	}; // CLDR #1850 - #1853
	
	var timeFormats = {
	  full: 'a h:mm:ss zzzz',
	  long: 'a h:mm:ss z',
	  medium: 'a h:mm:ss',
	  short: 'a h:mm'
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  long: '{{date}} {{time}}',
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'கடந்த' eeee p 'மணிக்கு'",
	  yesterday: "'நேற்று ' p 'மணிக்கு'",
	  today: "'இன்று ' p 'மணிக்கு'",
	  tomorrow: "'நாளை ' p 'மணிக்கு'",
	  nextWeek: "eeee p 'மணிக்கு'",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Ref: https://www.unicode.org/cldr/charts/32/summary/ta.html
	var eraValues = {
	  narrow: ['கி.மு.', 'கி.பி.'],
	  abbreviated: ['கி.மு.', 'கி.பி.'],
	  // CLDR #1624, #1626
	  wide: ['கிறிஸ்துவுக்கு முன்', 'அன்னோ டோமினி'] // CLDR #1620, #1622
	
	};
	var quarterValues = {
	  // CLDR #1644 - #1647
	  narrow: ['1', '2', '3', '4'],
	  // CLDR #1636 - #1639
	  abbreviated: ['காலா.1', 'காலா.2', 'காலா.3', 'காலா.4'],
	  // CLDR #1628 - #1631
	  wide: ['ஒன்றாம் காலாண்டு', 'இரண்டாம் காலாண்டு', 'மூன்றாம் காலாண்டு', 'நான்காம் காலாண்டு']
	};
	var monthValues = {
	  // CLDR #700 - #711
	  narrow: ['ஜ', 'பி', 'மா', 'ஏ', 'மே', 'ஜூ', 'ஜூ', 'ஆ', 'செ', 'அ', 'ந', 'டி'],
	  // CLDR #1676 - #1687
	  abbreviated: ['ஜன.', 'பிப்.', 'மார்.', 'ஏப்.', 'மே', 'ஜூன்', 'ஜூலை', 'ஆக.', 'செப்.', 'அக்.', 'நவ.', 'டிச.'],
	  // CLDR #1652 - #1663
	  wide: ['ஜனவரி', // January
	  'பிப்ரவரி', // February
	  'மார்ச்', // March
	  'ஏப்ரல்', // April
	  'மே', // May
	  'ஜூன்', // June
	  'ஜூலை', // July
	  'ஆகஸ்ட்', // August
	  'செப்டம்பர்', // September
	  'அக்டோபர்', // October
	  'நவம்பர்', // November
	  'டிசம்பர்' // December
	  ]
	};
	var dayValues = {
	  // CLDR #1766 - #1772
	  narrow: ['ஞா', 'தி', 'செ', 'பு', 'வி', 'வெ', 'ச'],
	  // CLDR #1752 - #1758
	  short: ['ஞா', 'தி', 'செ', 'பு', 'வி', 'வெ', 'ச'],
	  // CLDR #1738 - #1744
	  abbreviated: ['ஞாயி.', 'திங்.', 'செவ்.', 'புத.', 'வியா.', 'வெள்.', 'சனி'],
	  // CLDR #1724 - #1730
	  wide: ['ஞாயிறு', // Sunday
	  'திங்கள்', // Monday
	  'செவ்வாய்', // Tuesday
	  'புதன்', // Wednesday
	  'வியாழன்', // Thursday
	  'வெள்ளி', // Friday
	  'சனி' // Saturday
	  ]
	}; // CLDR #1780 - #1845
	
	var dayPeriodValues = {
	  narrow: {
	    am: 'மு.ப',
	    pm: 'பி.ப',
	    midnight: 'நள்.',
	    noon: 'நண்.',
	    morning: 'கா.',
	    afternoon: 'மதி.',
	    evening: 'மா.',
	    night: 'இர.'
	  },
	  abbreviated: {
	    am: 'முற்பகல்',
	    pm: 'பிற்பகல்',
	    midnight: 'நள்ளிரவு',
	    noon: 'நண்பகல்',
	    morning: 'காலை',
	    afternoon: 'மதியம்',
	    evening: 'மாலை',
	    night: 'இரவு'
	  },
	  wide: {
	    am: 'முற்பகல்',
	    pm: 'பிற்பகல்',
	    midnight: 'நள்ளிரவு',
	    noon: 'நண்பகல்',
	    morning: 'காலை',
	    afternoon: 'மதியம்',
	    evening: 'மாலை',
	    night: 'இரவு'
	  }
	}; // CLDR #1780 - #1845
	
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'மு.ப',
	    pm: 'பி.ப',
	    midnight: 'நள்.',
	    noon: 'நண்.',
	    morning: 'கா.',
	    afternoon: 'மதி.',
	    evening: 'மா.',
	    night: 'இர.'
	  },
	  abbreviated: {
	    am: 'முற்பகல்',
	    pm: 'பிற்பகல்',
	    midnight: 'நள்ளிரவு',
	    noon: 'நண்பகல்',
	    morning: 'காலை',
	    afternoon: 'மதியம்',
	    evening: 'மாலை',
	    night: 'இரவு'
	  },
	  wide: {
	    am: 'முற்பகல்',
	    pm: 'பிற்பகல்',
	    midnight: 'நள்ளிரவு',
	    noon: 'நண்பகல்',
	    morning: 'காலை',
	    afternoon: 'மதியம்',
	    evening: 'மாலை',
	    night: 'இரவு'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	  // var rem100 = number % 100
	  // if (rem100 > 20 || rem100 < 10) {
	  //   switch (rem100 % 10) {
	  //     case 1:
	  //       return number + 'st'
	  //     case 2:
	  //       return number + 'nd'
	  //     case 3:
	  //       return number + 'rd'
	  //   }
	  // }
	  // return number + 'th'
	
	  return number;
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(வது)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(கி.மு.|கி.பி.)/i,
	  abbreviated: /^(கி\.?\s?மு\.?|கி\.?\s?பி\.?)/,
	  wide: /^(கிறிஸ்துவுக்கு\sமுன்|அன்னோ\sடோமினி)/i
	};
	var parseEraPatterns = {
	  any: [/கி\.?\s?மு\.?/, /கி\.?\s?பி\.?/]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^காலா.[1234]/i,
	  wide: /^(ஒன்றாம்|இரண்டாம்|மூன்றாம்|நான்காம்) காலாண்டு/i
	};
	var parseQuarterPatterns = {
	  narrow: [/1/i, /2/i, /3/i, /4/i],
	  any: [/(1|காலா.1|ஒன்றாம்)/i, /(2|காலா.2|இரண்டாம்)/i, /(3|காலா.3|மூன்றாம்)/i, /(4|காலா.4|நான்காம்)/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(ஜ|பி|மா|ஏ|மே|ஜூ|ஆ|செ|அ|ந|டி)$/i,
	  abbreviated: /^(ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.)/i,
	  wide: /^(ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^ஜ$/i, /^பி/i, /^மா/i, /^ஏ/i, /^மே/i, /^ஜூ/i, /^ஜூ/i, /^ஆ/i, /^செ/i, /^அ/i, /^ந/i, /^டி/i],
	  any: [/^ஜன/i, /^பி/i, /^மா/i, /^ஏ/i, /^மே/i, /^ஜூன்/i, /^ஜூலை/i, /^ஆ/i, /^செ/i, /^அ/i, /^ந/i, /^டி/i]
	};
	var matchDayPatterns = {
	  narrow: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
	  short: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
	  abbreviated: /^(ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி)/i,
	  wide: /^(ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி)/i
	};
	var parseDayPatterns = {
	  narrow: [/^ஞா/i, /^தி/i, /^செ/i, /^பு/i, /^வி/i, /^வெ/i, /^ச/i],
	  any: [/^ஞா/i, /^தி/i, /^செ/i, /^பு/i, /^வி/i, /^வெ/i, /^ச/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(மு.ப|பி.ப|நள்|நண்|காலை|மதியம்|மாலை|இரவு)/i,
	  any: /^(மு.ப|பி.ப|முற்பகல்|பிற்பகல்|நள்ளிரவு|நண்பகல்|காலை|மதியம்|மாலை|இரவு)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^மு/i,
	    pm: /^பி/i,
	    midnight: /^நள்/i,
	    noon: /^நண்/i,
	    morning: /காலை/i,
	    afternoon: /மதியம்/i,
	    evening: /மாலை/i,
	    night: /இரவு/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1357));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1358));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1359));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1360));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1361));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Tamil locale (India).
	 * @language Tamil
	 * @iso-639-2 tam
	 * @author Sibiraj [@sibiraj-s]{@link https://github.com/sibiraj-s}
	 */
	var locale = {
	  code: 'ta',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    standalone: {
	      one: 'సెకను కన్నా తక్కువ',
	      other: '{{count}} సెకన్ల కన్నా తక్కువ'
	    },
	    withPreposition: {
	      one: 'సెకను',
	      other: '{{count}} సెకన్ల'
	    }
	  },
	  xSeconds: {
	    standalone: {
	      one: 'ఒక సెకను',
	      // CLDR #1314
	      other: '{{count}} సెకన్ల'
	    },
	    withPreposition: {
	      one: 'ఒక సెకను',
	      other: '{{count}} సెకన్ల'
	    }
	  },
	  halfAMinute: {
	    standalone: 'అర నిమిషం',
	    withPreposition: 'అర నిమిషం'
	  },
	  lessThanXMinutes: {
	    standalone: {
	      one: 'ఒక నిమిషం కన్నా తక్కువ',
	      other: '{{count}} నిమిషాల కన్నా తక్కువ'
	    },
	    withPreposition: {
	      one: 'ఒక నిమిషం',
	      other: '{{count}} నిమిషాల'
	    }
	  },
	  xMinutes: {
	    standalone: {
	      one: 'ఒక నిమిషం',
	      // CLDR #1311
	      other: '{{count}} నిమిషాలు'
	    },
	    withPreposition: {
	      one: 'ఒక నిమిషం',
	      // CLDR #1311
	      other: '{{count}} నిమిషాల'
	    }
	  },
	  aboutXHours: {
	    standalone: {
	      one: 'సుమారు ఒక గంట',
	      other: 'సుమారు {{count}} గంటలు'
	    },
	    withPreposition: {
	      one: 'సుమారు ఒక గంట',
	      other: 'సుమారు {{count}} గంటల'
	    }
	  },
	  xHours: {
	    standalone: {
	      one: 'ఒక గంట',
	      // CLDR #1308
	      other: '{{count}} గంటలు'
	    },
	    withPreposition: {
	      one: 'ఒక గంట',
	      other: '{{count}} గంటల'
	    }
	  },
	  xDays: {
	    standalone: {
	      one: 'ఒక రోజు',
	      // CLDR #1292
	      other: '{{count}} రోజులు'
	    },
	    withPreposition: {
	      one: 'ఒక రోజు',
	      other: '{{count}} రోజుల'
	    }
	  },
	  aboutXWeeks: {
	    standalone: {
	      one: 'సుమారు ఒక వారం',
	      other: 'సుమారు {{count}} వారాలు'
	    },
	    withPreposition: {
	      one: 'సుమారు ఒక వారం',
	      other: 'సుమారు {{count}} వారాలల'
	    }
	  },
	  xWeeks: {
	    standalone: {
	      one: 'ఒక వారం',
	      other: '{{count}} వారాలు'
	    },
	    withPreposition: {
	      one: 'ఒక వారం',
	      other: '{{count}} వారాలల'
	    }
	  },
	  aboutXMonths: {
	    standalone: {
	      one: 'సుమారు ఒక నెల',
	      other: 'సుమారు {{count}} నెలలు'
	    },
	    withPreposition: {
	      one: 'సుమారు ఒక నెల',
	      other: 'సుమారు {{count}} నెలల'
	    }
	  },
	  xMonths: {
	    standalone: {
	      one: 'ఒక నెల',
	      // CLDR #1281
	      other: '{{count}} నెలలు'
	    },
	    withPreposition: {
	      one: 'ఒక నెల',
	      other: '{{count}} నెలల'
	    }
	  },
	  aboutXYears: {
	    standalone: {
	      one: 'సుమారు ఒక సంవత్సరం',
	      other: 'సుమారు {{count}} సంవత్సరాలు'
	    },
	    withPreposition: {
	      one: 'సుమారు ఒక సంవత్సరం',
	      other: 'సుమారు {{count}} సంవత్సరాల'
	    }
	  },
	  xYears: {
	    standalone: {
	      one: 'ఒక సంవత్సరం',
	      // CLDR #1275
	      other: '{{count}} సంవత్సరాలు'
	    },
	    withPreposition: {
	      one: 'ఒక సంవత్సరం',
	      other: '{{count}} సంవత్సరాల'
	    }
	  },
	  overXYears: {
	    standalone: {
	      one: 'ఒక సంవత్సరం పైగా',
	      other: '{{count}} సంవత్సరాలకు పైగా'
	    },
	    withPreposition: {
	      one: 'ఒక సంవత్సరం',
	      other: '{{count}} సంవత్సరాల'
	    }
	  },
	  almostXYears: {
	    standalone: {
	      one: 'దాదాపు ఒక సంవత్సరం',
	      other: 'దాదాపు {{count}} సంవత్సరాలు'
	    },
	    withPreposition: {
	      one: 'దాదాపు ఒక సంవత్సరం',
	      other: 'దాదాపు {{count}} సంవత్సరాల'
	    }
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var usageGroup = options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
	  var result;
	
	  if (typeof usageGroup === 'string') {
	    result = usageGroup;
	  } else if (count === 1) {
	    result = usageGroup.one;
	  } else {
	    result = usageGroup.other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result + 'లో';
	    } else {
	      return result + ' క్రితం';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
	// CLDR #1807 - #1811
	var dateFormats = {
	  full: 'd, MMMM y, EEEE',
	  long: 'd MMMM, y',
	  medium: 'd MMM, y',
	  short: 'dd-MM-yy'
	}; // CLDR #1807 - #1811
	
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	}; // CLDR #1815 - #1818
	
	var dateTimeFormats = {
	  full: "{{date}} {{time}}'కి'",
	  long: "{{date}} {{time}}'కి'",
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
	var formatRelativeLocale = {
	  lastWeek: "'గత' eeee p",
	  // CLDR #1384
	  yesterday: "'నిన్న' p",
	  // CLDR #1393
	  today: "'ఈ రోజు' p",
	  // CLDR #1394
	  tomorrow: "'రేపు' p",
	  // CLDR #1395
	  nextWeek: "'తదుపరి' eeee p",
	  // CLDR #1386
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
	// Source: https://dsal.uchicago.edu/dictionaries/brown/
	// CLDR #1605 - #1608
	var eraValues = {
	  narrow: ['క్రీ.పూ.', 'క్రీ.శ.'],
	  abbreviated: ['క్రీ.పూ.', 'క్రీ.శ.'],
	  wide: ['క్రీస్తు పూర్వం', 'క్రీస్తుశకం']
	}; // CLDR #1613 - #1628
	
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['త్రై1', 'త్రై2', 'త్రై3', 'త్రై4'],
	  wide: ['1వ త్రైమాసికం', '2వ త్రైమాసికం', '3వ త్రైమాసికం', '4వ త్రైమాసికం']
	}; // CLDR #1637 - #1708
	
	var monthValues = {
	  narrow: ['జ', 'ఫి', 'మా', 'ఏ', 'మే', 'జూ', 'జు', 'ఆ', 'సె', 'అ', 'న', 'డి'],
	  abbreviated: ['జన', 'ఫిబ్ర', 'మార్చి', 'ఏప్రి', 'మే', 'జూన్', 'జులై', 'ఆగ', 'సెప్టెం', 'అక్టో', 'నవం', 'డిసెం'],
	  wide: ['జనవరి', 'ఫిబ్రవరి', 'మార్చి', 'ఏప్రిల్', 'మే', 'జూన్', 'జులై', 'ఆగస్టు', 'సెప్టెంబర్', 'అక్టోబర్', 'నవంబర్', 'డిసెంబర్']
	}; // CLDR #1709 - #1764
	
	var dayValues = {
	  narrow: ['ఆ', 'సో', 'మ', 'బు', 'గు', 'శు', 'శ'],
	  short: ['ఆది', 'సోమ', 'మంగళ', 'బుధ', 'గురు', 'శుక్ర', 'శని'],
	  abbreviated: ['ఆది', 'సోమ', 'మంగళ', 'బుధ', 'గురు', 'శుక్ర', 'శని'],
	  wide: ['ఆదివారం', 'సోమవారం', 'మంగళవారం', 'బుధవారం', 'గురువారం', 'శుక్రవారం', 'శనివారం']
	}; // CLDR #1767 - #1806
	
	var dayPeriodValues = {
	  narrow: {
	    am: 'పూర్వాహ్నం',
	    pm: 'అపరాహ్నం',
	    midnight: 'అర్ధరాత్రి',
	    noon: 'మిట్టమధ్యాహ్నం',
	    morning: 'ఉదయం',
	    afternoon: 'మధ్యాహ్నం',
	    evening: 'సాయంత్రం',
	    night: 'రాత్రి'
	  },
	  abbreviated: {
	    am: 'పూర్వాహ్నం',
	    pm: 'అపరాహ్నం',
	    midnight: 'అర్ధరాత్రి',
	    noon: 'మిట్టమధ్యాహ్నం',
	    morning: 'ఉదయం',
	    afternoon: 'మధ్యాహ్నం',
	    evening: 'సాయంత్రం',
	    night: 'రాత్రి'
	  },
	  wide: {
	    am: 'పూర్వాహ్నం',
	    pm: 'అపరాహ్నం',
	    midnight: 'అర్ధరాత్రి',
	    noon: 'మిట్టమధ్యాహ్నం',
	    morning: 'ఉదయం',
	    afternoon: 'మధ్యాహ్నం',
	    evening: 'సాయంత్రం',
	    night: 'రాత్రి'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'పూర్వాహ్నం',
	    pm: 'అపరాహ్నం',
	    midnight: 'అర్ధరాత్రి',
	    noon: 'మిట్టమధ్యాహ్నం',
	    morning: 'ఉదయం',
	    afternoon: 'మధ్యాహ్నం',
	    evening: 'సాయంత్రం',
	    night: 'రాత్రి'
	  },
	  abbreviated: {
	    am: 'పూర్వాహ్నం',
	    pm: 'అపరాహ్నం',
	    midnight: 'అర్ధరాత్రి',
	    noon: 'మిట్టమధ్యాహ్నం',
	    morning: 'ఉదయం',
	    afternoon: 'మధ్యాహ్నం',
	    evening: 'సాయంత్రం',
	    night: 'రాత్రి'
	  },
	  wide: {
	    am: 'పూర్వాహ్నం',
	    pm: 'అపరాహ్నం',
	    midnight: 'అర్ధరాత్రి',
	    noon: 'మిట్టమధ్యాహ్నం',
	    morning: 'ఉదయం',
	    afternoon: 'మధ్యాహ్నం',
	    evening: 'సాయంత్రం',
	    night: 'రాత్రి'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber);
	  return number + 'వ';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(వ)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(క్రీ\.పూ\.|క్రీ\.శ\.)/i,
	  abbreviated: /^(క్రీ\.?\s?పూ\.?|ప్ర\.?\s?శ\.?\s?పూ\.?|క్రీ\.?\s?శ\.?|సా\.?\s?శ\.?)/i,
	  wide: /^(క్రీస్తు పూర్వం|ప్రస్తుత శకానికి పూర్వం|క్రీస్తు శకం|ప్రస్తుత శకం)/i
	};
	var parseEraPatterns = {
	  any: [/^(పూ|శ)/i, /^సా/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^త్రై[1234]/i,
	  wide: /^[1234](వ)? త్రైమాసికం/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(జూ|జు|జ|ఫి|మా|ఏ|మే|ఆ|సె|అ|న|డి)/i,
	  abbreviated: /^(జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్|అక్టో|నవ|డిసె)/i,
	  wide: /^(జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^జ/i, /^ఫి/i, /^మా/i, /^ఏ/i, /^మే/i, /^జూ/i, /^జు/i, /^ఆ/i, /^సె/i, /^అ/i, /^న/i, /^డి/i],
	  any: [/^జన/i, /^ఫి/i, /^మా/i, /^ఏ/i, /^మే/i, /^జూన్/i, /^జులై/i, /^ఆగ/i, /^సె/i, /^అ/i, /^న/i, /^డి/i]
	};
	var matchDayPatterns = {
	  narrow: /^(ఆ|సో|మ|బు|గు|శు|శ)/i,
	  short: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
	  abbreviated: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
	  wide: /^(ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం)/i
	};
	var parseDayPatterns = {
	  narrow: [/^ఆ/i, /^సో/i, /^మ/i, /^బు/i, /^గు/i, /^శు/i, /^శ/i],
	  any: [/^ఆది/i, /^సోమ/i, /^మం/i, /^బుధ/i, /^గురు/i, /^శుక్ర/i, /^శని/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i,
	  any: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^పూర్వాహ్నం/i,
	    pm: /^అపరాహ్నం/i,
	    midnight: /^అర్ధ/i,
	    noon: /^మిట్ట/i,
	    morning: /ఉదయం/i,
	    afternoon: /మధ్యాహ్నం/i,
	    evening: /సాయంత్రం/i,
	    night: /రాత్రి/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1363));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1364));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1365));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1366));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1367));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Telugu locale
	 * @language Telugu
	 * @iso-639-2 tel
	 * @author Kranthi Lakum [@kranthilakum]{@link https://github.com/kranthilakum}
	 */
	var locale = {
	  code: 'te',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'น้อยกว่า 1 วินาที',
	    other: 'น้อยกว่า {{count}} วินาที'
	  },
	  xSeconds: {
	    one: '1 วินาที',
	    other: '{{count}} วินาที'
	  },
	  halfAMinute: 'ครึ่งนาที',
	  lessThanXMinutes: {
	    one: 'น้อยกว่า 1 นาที',
	    other: 'น้อยกว่า {{count}} นาที'
	  },
	  xMinutes: {
	    one: '1 นาที',
	    other: '{{count}} นาที'
	  },
	  aboutXHours: {
	    one: 'ประมาณ 1 ชั่วโมง',
	    other: 'ประมาณ {{count}} ชั่วโมง'
	  },
	  xHours: {
	    one: '1 ชั่วโมง',
	    other: '{{count}} ชั่วโมง'
	  },
	  xDays: {
	    one: '1 วัน',
	    other: '{{count}} วัน'
	  },
	  aboutXWeeks: {
	    one: 'ประมาณ 1 สัปดาห์',
	    other: 'ประมาณ {{count}} สัปดาห์'
	  },
	  xWeeks: {
	    one: '1 สัปดาห์',
	    other: '{{count}} สัปดาห์'
	  },
	  aboutXMonths: {
	    one: 'ประมาณ 1 เดือน',
	    other: 'ประมาณ {{count}} เดือน'
	  },
	  xMonths: {
	    one: '1 เดือน',
	    other: '{{count}} เดือน'
	  },
	  aboutXYears: {
	    one: 'ประมาณ 1 ปี',
	    other: 'ประมาณ {{count}} ปี'
	  },
	  xYears: {
	    one: '1 ปี',
	    other: '{{count}} ปี'
	  },
	  overXYears: {
	    one: 'มากกว่า 1 ปี',
	    other: 'มากกว่า {{count}} ปี'
	  },
	  almostXYears: {
	    one: 'เกือบ 1 ปี',
	    other: 'เกือบ {{count}} ปี'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      if (token === 'halfAMinute') {
	        return 'ใน' + result;
	      } else {
	        return 'ใน ' + result;
	      }
	    } else {
	      return result + 'ที่ผ่านมา';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'วันEEEEที่ do MMMM y',
	  long: 'do MMMM y',
	  medium: 'd MMM y',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'H:mm:ss น. zzzz',
	  long: 'H:mm:ss น. z',
	  medium: 'H:mm:ss น.',
	  short: 'H:mm น.'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'เวลา' {{time}}",
	  long: "{{date}} 'เวลา' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'medium'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "eeee'ที่แล้วเวลา' p",
	  yesterday: "'เมื่อวานนี้เวลา' p",
	  today: "'วันนี้เวลา' p",
	  tomorrow: "'พรุ่งนี้เวลา' p",
	  nextWeek: "eeee 'เวลา' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['B', 'คศ'],
	  abbreviated: ['BC', 'ค.ศ.'],
	  wide: ['ปีก่อนคริสตกาล', 'คริสต์ศักราช']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['ไตรมาสแรก', 'ไตรมาสที่สอง', 'ไตรมาสที่สาม', 'ไตรมาสที่สี่']
	};
	var dayValues = {
	  narrow: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
	  short: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
	  abbreviated: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
	  wide: ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์']
	};
	var monthValues = {
	  narrow: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
	  abbreviated: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
	  wide: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ก่อนเที่ยง',
	    pm: 'หลังเที่ยง',
	    midnight: 'เที่ยงคืน',
	    noon: 'เที่ยง',
	    morning: 'เช้า',
	    afternoon: 'บ่าย',
	    evening: 'เย็น',
	    night: 'กลางคืน'
	  },
	  abbreviated: {
	    am: 'ก่อนเที่ยง',
	    pm: 'หลังเที่ยง',
	    midnight: 'เที่ยงคืน',
	    noon: 'เที่ยง',
	    morning: 'เช้า',
	    afternoon: 'บ่าย',
	    evening: 'เย็น',
	    night: 'กลางคืน'
	  },
	  wide: {
	    am: 'ก่อนเที่ยง',
	    pm: 'หลังเที่ยง',
	    midnight: 'เที่ยงคืน',
	    noon: 'เที่ยง',
	    morning: 'เช้า',
	    afternoon: 'บ่าย',
	    evening: 'เย็น',
	    night: 'กลางคืน'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ก่อนเที่ยง',
	    pm: 'หลังเที่ยง',
	    midnight: 'เที่ยงคืน',
	    noon: 'เที่ยง',
	    morning: 'ตอนเช้า',
	    afternoon: 'ตอนกลางวัน',
	    evening: 'ตอนเย็น',
	    night: 'ตอนกลางคืน'
	  },
	  abbreviated: {
	    am: 'ก่อนเที่ยง',
	    pm: 'หลังเที่ยง',
	    midnight: 'เที่ยงคืน',
	    noon: 'เที่ยง',
	    morning: 'ตอนเช้า',
	    afternoon: 'ตอนกลางวัน',
	    evening: 'ตอนเย็น',
	    night: 'ตอนกลางคืน'
	  },
	  wide: {
	    am: 'ก่อนเที่ยง',
	    pm: 'หลังเที่ยง',
	    midnight: 'เที่ยงคืน',
	    noon: 'เที่ยง',
	    morning: 'ตอนเช้า',
	    afternoon: 'ตอนกลางวัน',
	    evening: 'ตอนเย็น',
	    night: 'ตอนกลางคืน'
	  }
	};
	
	function ordinalNumber(dirtyNumber) {
	  var number = Number(dirtyNumber);
	  return number;
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^\d+/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^([bB]|[aA]|คศ)/i,
	  abbreviated: /^([bB]\.?\s?[cC]\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?|ค\.?ศ\.?)/i,
	  wide: /^(ก่อนคริสตกาล|คริสต์ศักราช|คริสตกาล)/i
	};
	var parseEraPatterns = {
	  any: [/^[bB]/i, /^(^[aA]|ค\.?ศ\.?|คริสตกาล|คริสต์ศักราช|)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^ไตรมาส(ที่)? ?[1234]/i
	};
	var parseQuarterPatterns = {
	  any: [/(1|แรก|หนึ่ง)/i, /(2|สอง)/i, /(3|สาม)/i, /(4|สี่)/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?)/i,
	  abbreviated: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?')/i,
	  wide: /^(มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)/i
	};
	var parseMonthPatterns = {
	  wide: [/^มก/i, /^กุม/i, /^มี/i, /^เม/i, /^พฤษ/i, /^มิ/i, /^กรก/i, /^ส/i, /^กัน/i, /^ต/i, /^พฤศ/i, /^ธ/i],
	  any: [/^ม\.?ค\.?/i, /^ก\.?พ\.?/i, /^มี\.?ค\.?/i, /^เม\.?ย\.?/i, /^พ\.?ค\.?/i, /^มิ\.?ย\.?/i, /^ก\.?ค\.?/i, /^ส\.?ค\.?/i, /^ก\.?ย\.?/i, /^ต\.?ค\.?/i, /^พ\.?ย\.?/i, /^ธ\.?ค\.?/i]
	};
	var matchDayPatterns = {
	  narrow: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
	  short: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
	  abbreviated: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
	  wide: /^(อาทิตย์|จันทร์|อังคาร|พุธ|พฤหัสบดี|ศุกร์|เสาร์)/i
	};
	var parseDayPatterns = {
	  wide: [/^อา/i, /^จั/i, /^อั/i, /^พุธ/i, /^พฤ/i, /^ศ/i, /^เส/i],
	  any: [/^อา/i, /^จ/i, /^อ/i, /^พ(?!ฤ)/i, /^พฤ/i, /^ศ/i, /^ส/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(ก่อนเที่ยง|หลังเที่ยง|เที่ยงคืน|เที่ยง|(ตอน.*?)?.*(เที่ยง|เช้า|บ่าย|เย็น|กลางคืน))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^ก่อนเที่ยง/i,
	    pm: /^หลังเที่ยง/i,
	    midnight: /^เที่ยงคืน/i,
	    noon: /^เที่ยง/i,
	    morning: /เช้า/i,
	    afternoon: /บ่าย/i,
	    evening: /เย็น/i,
	    night: /กลางคืน/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1369));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1370));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1371));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1372));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1373));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Thai locale.
	 * @language Thai
	 * @iso-639-2 tha
	 * @author Athiwat Hirunworawongkun [@athivvat]{@link https://github.com/athivvat}
	 * @author [@hawkup]{@link https://github.com/hawkup}
	 * @author  Jirawat I. [@nodtem66]{@link https://github.com/nodtem66}
	 */
	var locale = {
	  code: 'th',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'bir saniyeden az',
	    other: '{{count}} saniyeden az'
	  },
	  xSeconds: {
	    one: '1 saniye',
	    other: '{{count}} saniye'
	  },
	  halfAMinute: 'yarım dakika',
	  lessThanXMinutes: {
	    one: 'bir dakikadan az',
	    other: '{{count}} dakikadan az'
	  },
	  xMinutes: {
	    one: '1 dakika',
	    other: '{{count}} dakika'
	  },
	  aboutXHours: {
	    one: 'yaklaşık 1 saat',
	    other: 'yaklaşık {{count}} saat'
	  },
	  xHours: {
	    one: '1 saat',
	    other: '{{count}} saat'
	  },
	  xDays: {
	    one: '1 gün',
	    other: '{{count}} gün'
	  },
	  aboutXWeeks: {
	    one: 'yaklaşık 1 hafta',
	    other: 'yaklaşık {{count}} hafta'
	  },
	  xWeeks: {
	    one: '1 hafta',
	    other: '{{count}} hafta'
	  },
	  aboutXMonths: {
	    one: 'yaklaşık 1 ay',
	    other: 'yaklaşık {{count}} ay'
	  },
	  xMonths: {
	    one: '1 ay',
	    other: '{{count}} ay'
	  },
	  aboutXYears: {
	    one: 'yaklaşık 1 yıl',
	    other: 'yaklaşık {{count}} yıl'
	  },
	  xYears: {
	    one: '1 yıl',
	    other: '{{count}} yıl'
	  },
	  overXYears: {
	    one: '1 yıldan fazla',
	    other: '{{count}} yıldan fazla'
	  },
	  almostXYears: {
	    one: 'neredeyse 1 yıl',
	    other: 'neredeyse {{count}} yıl'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result + ' sonra';
	    } else {
	      return result + ' önce';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'd MMMM y EEEE',
	  long: 'd MMMM y',
	  medium: 'd MMM y',
	  short: 'dd.MM.yyyy'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'saat' {{time}}",
	  long: "{{date}} 'saat' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'geçen hafta' eeee 'saat' p",
	  yesterday: "'dün saat' p",
	  today: "'bugün saat' p",
	  tomorrow: "'yarın saat' p",
	  nextWeek: "eeee 'saat' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  abbreviated: ['MÖ', 'MS'],
	  narrow: ['MÖ', 'MS'],
	  wide: ['Milattan Önce', 'Milattan Sonra']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1Ç', '2Ç', '3Ç', '4Ç'],
	  wide: ['İlk çeyrek', 'İkinci Çeyrek', 'Üçüncü çeyrek', 'Son çeyrek']
	};
	var monthValues = {
	  narrow: ['O', 'Ş', 'M', 'N', 'M', 'H', 'T', 'A', 'E', 'E', 'K', 'A'],
	  abbreviated: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
	  wide: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık']
	};
	var dayValues = {
	  narrow: ['P', 'P', 'S', 'Ç', 'P', 'C', 'C'],
	  short: ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct'],
	  abbreviated: ['Paz', 'Pts', 'Sal', 'Çar', 'Per', 'Cum', 'Cts'],
	  wide: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'öö',
	    pm: 'ös',
	    midnight: 'gy',
	    noon: 'ö',
	    morning: 'sa',
	    afternoon: 'ös',
	    evening: 'ak',
	    night: 'ge'
	  },
	  abbreviated: {
	    am: 'ÖÖ',
	    pm: 'ÖS',
	    midnight: 'gece yarısı',
	    noon: 'öğle',
	    morning: 'sabah',
	    afternoon: 'öğleden sonra',
	    evening: 'akşam',
	    night: 'gece'
	  },
	  wide: {
	    am: 'Ö.Ö.',
	    pm: 'Ö.S.',
	    midnight: 'gece yarısı',
	    noon: 'öğle',
	    morning: 'sabah',
	    afternoon: 'öğleden sonra',
	    evening: 'akşam',
	    night: 'gece'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'öö',
	    pm: 'ös',
	    midnight: 'gy',
	    noon: 'ö',
	    morning: 'sa',
	    afternoon: 'ös',
	    evening: 'ak',
	    night: 'ge'
	  },
	  abbreviated: {
	    am: 'ÖÖ',
	    pm: 'ÖS',
	    midnight: 'gece yarısı',
	    noon: 'öğlen',
	    morning: 'sabahleyin',
	    afternoon: 'öğleden sonra',
	    evening: 'akşamleyin',
	    night: 'geceleyin'
	  },
	  wide: {
	    am: 'ö.ö.',
	    pm: 'ö.s.',
	    midnight: 'gece yarısı',
	    noon: 'öğlen',
	    morning: 'sabahleyin',
	    afternoon: 'öğleden sonra',
	    evening: 'akşamleyin',
	    night: 'geceleyin'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber);
	  return number + '.';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaulFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(mö|ms)/i,
	  abbreviated: /^(mö|ms)/i,
	  wide: /^(milattan önce|milattan sonra)/i
	};
	var parseEraPatterns = {
	  any: [/(^mö|^milattan önce)/i, /(^ms|^milattan sonra)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234]ç/i,
	  wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i],
	  abbreviated: [/1ç/i, /2ç/i, /3ç/i, /4ç/i],
	  wide: [/^(i|İ)lk çeyrek/i, /(i|İ)kinci çeyrek/i, /üçüncü çeyrek/i, /son çeyrek/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[oşmnhtaek]/i,
	  abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
	  wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^o/i, /^ş/i, /^m/i, /^n/i, /^m/i, /^h/i, /^t/i, /^a/i, /^e/i, /^e/i, /^k/i, /^a/i],
	  any: [/^o/i, /^ş/i, /^mar/i, /^n/i, /^may/i, /^h/i, /^t/i, /^ağ/i, /^ey/i, /^ek/i, /^k/i, /^ar/i]
	};
	var matchDayPatterns = {
	  narrow: /^[psçc]/i,
	  short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
	  abbreviated: /^(paz|pts|sal|çar|per|cum|cts)/i,
	  wide: /^(pazar|pazartesi|salı|çarşamba|perşembe|cuma|cumartesi)/i
	};
	var parseDayPatterns = {
	  narrow: [/^p/i, /^p/i, /^s/i, /^ç/i, /^p/i, /^c/i, /^c/i],
	  any: [/^pz/i, /^pt/i, /^sa/i, /^ça/i, /^pe/i, /^cu/i, /^ct/i],
	  wide: [/^pazar/i, /^pazartesi/i, /^salı/i, /^çarşamba/i, /^perşembe/i, /^cuma/i, /cumartesi/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
	  any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^ö\.?ö\.?/i,
	    pm: /^ö\.?s\.?/i,
	    midnight: /^(gy|gece yarısı)/i,
	    noon: /^öğ/i,
	    morning: /^sa/i,
	    afternoon: /^öğleden sonra/i,
	    evening: /^ak/i,
	    night: /^ge/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1375));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1376));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1377));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1378));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1379));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Turkish locale.
	 * @language Turkish
	 * @iso-639-2 tur
	 * @author Alpcan Aydın [@alpcanaydin]{@link https://github.com/alpcanaydin}
	 * @author Berkay Sargın [@berkaey]{@link https://github.com/berkaey}
	 * @author Ismail Demirbilek [@dbtek]{@link https://github.com/dbtek}
	 * @author İsmail Kayar [@ikayar]{@link https://github.com/ikayar}
	 *
	 *
	 */
	var locale = {
	  code: 'tr',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'بىر سىكۇنت ئىچىدە',
	    other: 'سىكۇنت ئىچىدە {{count}}'
	  },
	  xSeconds: {
	    one: 'بىر سىكۇنت',
	    other: 'سىكۇنت {{count}}'
	  },
	  halfAMinute: 'يىرىم مىنۇت',
	  lessThanXMinutes: {
	    one: 'بىر مىنۇت ئىچىدە',
	    other: 'مىنۇت ئىچىدە {{count}}'
	  },
	  xMinutes: {
	    one: 'بىر مىنۇت',
	    other: 'مىنۇت {{count}}'
	  },
	  aboutXHours: {
	    one: 'تەخمىنەن بىر سائەت',
	    other: 'سائەت {{count}} تەخمىنەن'
	  },
	  xHours: {
	    one: 'بىر سائەت',
	    other: 'سائەت {{count}}'
	  },
	  xDays: {
	    one: 'بىر كۈن',
	    other: 'كۈن {{count}}'
	  },
	  aboutXWeeks: {
	    one: 'تەخمىنەن بىرھەپتە',
	    other: 'ھەپتە {{count}} تەخمىنەن'
	  },
	  xWeeks: {
	    one: 'بىرھەپتە',
	    other: 'ھەپتە {{count}}'
	  },
	  aboutXMonths: {
	    one: 'تەخمىنەن بىر ئاي',
	    other: 'ئاي {{count}} تەخمىنەن'
	  },
	  xMonths: {
	    one: 'بىر ئاي',
	    other: 'ئاي {{count}}'
	  },
	  aboutXYears: {
	    one: 'تەخمىنەن بىر يىل',
	    other: 'يىل {{count}} تەخمىنەن'
	  },
	  xYears: {
	    one: 'بىر يىل',
	    other: 'يىل {{count}}'
	  },
	  overXYears: {
	    one: 'بىر يىلدىن ئارتۇق',
	    other: 'يىلدىن ئارتۇق {{count}}'
	  },
	  almostXYears: {
	    one: 'ئاساسەن بىر يىل',
	    other: 'يىل {{count}} ئاساسەن'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result;
	    } else {
	      return result + ' بولدى';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, MMMM do, y',
	  long: 'MMMM do, y',
	  medium: 'MMM d, y',
	  short: 'MM/dd/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'دە' {{time}}",
	  long: "{{date}} 'دە' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'ئ‍ۆتكەن' eeee 'دە' p",
	  yesterday: "'تۈنۈگۈن دە' p",
	  today: "'بۈگۈن دە' p",
	  tomorrow: "'ئەتە دە' p",
	  nextWeek: "eeee 'دە' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['ب', 'ك'],
	  abbreviated: ['ب', 'ك'],
	  wide: ['مىيلادىدىن بۇرۇن', 'مىيلادىدىن كىيىن']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1', '2', '3', '4'],
	  wide: ['بىرىنجى چارەك', 'ئىككىنجى چارەك', 'ئۈچىنجى چارەك', 'تۆتىنجى چارەك']
	}; // Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['ي', 'ف', 'م', 'ا', 'م', 'ى', 'ى', 'ا', 'س', 'ۆ', 'ن', 'د'],
	  abbreviated: ['يانۋار', 'فېۋىرال', 'مارت', 'ئاپرىل', 'ماي', 'ئىيۇن', 'ئىيول', 'ئاۋغۇست', 'سىنتەبىر', 'ئۆكتەبىر', 'نويابىر', 'دىكابىر'],
	  wide: ['يانۋار', 'فېۋىرال', 'مارت', 'ئاپرىل', 'ماي', 'ئىيۇن', 'ئىيول', 'ئاۋغۇست', 'سىنتەبىر', 'ئۆكتەبىر', 'نويابىر', 'دىكابىر']
	};
	var dayValues = {
	  narrow: ['ي', 'د', 'س', 'چ', 'پ', 'ج', 'ش'],
	  short: ['ي', 'د', 'س', 'چ', 'پ', 'ج', 'ش'],
	  abbreviated: ['يەكشەنبە', 'دۈشەنبە', 'سەيشەنبە', 'چارشەنبە', 'پەيشەنبە', 'جۈمە', 'شەنبە'],
	  wide: ['يەكشەنبە', 'دۈشەنبە', 'سەيشەنبە', 'چارشەنبە', 'پەيشەنبە', 'جۈمە', 'شەنبە']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ئە',
	    pm: 'چ',
	    midnight: 'ك',
	    noon: 'چ',
	    morning: 'ئەتىگەن',
	    afternoon: 'چۈشتىن كىيىن',
	    evening: 'ئاخشىم',
	    night: 'كىچە'
	  },
	  abbreviated: {
	    am: 'ئە',
	    pm: 'چ',
	    midnight: 'ك',
	    noon: 'چ',
	    morning: 'ئەتىگەن',
	    afternoon: 'چۈشتىن كىيىن',
	    evening: 'ئاخشىم',
	    night: 'كىچە'
	  },
	  wide: {
	    am: 'ئە',
	    pm: 'چ',
	    midnight: 'ك',
	    noon: 'چ',
	    morning: 'ئەتىگەن',
	    afternoon: 'چۈشتىن كىيىن',
	    evening: 'ئاخشىم',
	    night: 'كىچە'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ئە',
	    pm: 'چ',
	    midnight: 'ك',
	    noon: 'چ',
	    morning: 'ئەتىگەندە',
	    afternoon: 'چۈشتىن كىيىن',
	    evening: 'ئاخشامدا',
	    night: 'كىچىدە'
	  },
	  abbreviated: {
	    am: 'ئە',
	    pm: 'چ',
	    midnight: 'ك',
	    noon: 'چ',
	    morning: 'ئەتىگەندە',
	    afternoon: 'چۈشتىن كىيىن',
	    evening: 'ئاخشامدا',
	    night: 'كىچىدە'
	  },
	  wide: {
	    am: 'ئە',
	    pm: 'چ',
	    midnight: 'ك',
	    noon: 'چ',
	    morning: 'ئەتىگەندە',
	    afternoon: 'چۈشتىن كىيىن',
	    evening: 'ئاخشامدا',
	    night: 'كىچىدە'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  return String(dirtyNumber);
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(ب|ك)/i,
	  wide: /^(مىيلادىدىن بۇرۇن|مىيلادىدىن كىيىن)/i
	};
	var parseEraPatterns = {
	  any: [/^بۇرۇن/i, /^كىيىن/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^چ[1234]/i,
	  wide: /^چارەك [1234]/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  // eslint-disable-next-line no-misleading-character-class
	  narrow: /^[يفمئامئ‍ئاسۆند]/i,
	  abbreviated: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i,
	  wide: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^ي/i, /^ف/i, /^م/i, /^ا/i, /^م/i, /^ى‍/i, /^ى‍/i, /^ا‍/i, /^س/i, /^ۆ/i, /^ن/i, /^د/i],
	  any: [/^يان/i, /^فېۋ/i, /^مار/i, /^ئاپ/i, /^ماي/i, /^ئىيۇن/i, /^ئىيول/i, /^ئاۋ/i, /^سىن/i, /^ئۆك/i, /^نوي/i, /^دىك/i]
	};
	var matchDayPatterns = {
	  narrow: /^[دسچپجشي]/i,
	  short: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
	  abbreviated: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
	  wide: /^(يەكشەنبە|دۈشەنبە|سەيشەنبە|چارشەنبە|پەيشەنبە|جۈمە|شەنبە)/i
	};
	var parseDayPatterns = {
	  narrow: [/^ي/i, /^د/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i],
	  any: [/^ي/i, /^د/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i,
	  any: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^ئە/i,
	    pm: /^چ/i,
	    midnight: /^ك/i,
	    noon: /^چ/i,
	    morning: /ئەتىگەن/i,
	    afternoon: /چۈشتىن كىيىن/i,
	    evening: /ئاخشىم/i,
	    night: /كىچە/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1381));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1382));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1383));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1384));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1385));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Uighur locale
	 * @language Uighur
	 * @iso-639-2 uig
	 * @author Abduwaly M. [@abduwaly]{@link https://github.com/abduwaly}
	 */
	var locale = {
	  code: 'ug',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1387 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	
	function declension(scheme, count) {
	  // scheme for count=1 exists
	  if (scheme.one !== undefined && count === 1) {
	    return scheme.one;
	  }
	
	  var rem10 = count % 10;
	  var rem100 = count % 100; // 1, 21, 31, ...
	
	  if (rem10 === 1 && rem100 !== 11) {
	    return scheme.singularNominative.replace('{{count}}', count); // 2, 3, 4, 22, 23, 24, 32 ...
	  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
	    return scheme.singularGenitive.replace('{{count}}', count); // 5, 6, 7, 8, 9, 10, 11, ...
	  } else {
	    return scheme.pluralGenitive.replace('{{count}}', count);
	  }
	}
	
	function buildLocalizeTokenFn(scheme) {
	  return function (count, options) {
	    if (options.addSuffix) {
	      if (options.comparison > 0) {
	        if (scheme.future) {
	          return declension(scheme.future, count);
	        } else {
	          return 'за ' + declension(scheme.regular, count);
	        }
	      } else {
	        if (scheme.past) {
	          return declension(scheme.past, count);
	        } else {
	          return declension(scheme.regular, count) + ' тому';
	        }
	      }
	    } else {
	      return declension(scheme.regular, count);
	    }
	  };
	}
	
	var formatDistanceLocale = {
	  lessThanXSeconds: buildLocalizeTokenFn({
	    regular: {
	      one: 'менше секунди',
	      singularNominative: 'менше {{count}} секунди',
	      singularGenitive: 'менше {{count}} секунд',
	      pluralGenitive: 'менше {{count}} секунд'
	    },
	    future: {
	      one: 'менше, ніж за секунду',
	      singularNominative: 'менше, ніж за {{count}} секунду',
	      singularGenitive: 'менше, ніж за {{count}} секунди',
	      pluralGenitive: 'менше, ніж за {{count}} секунд'
	    }
	  }),
	  xSeconds: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} секунда',
	      singularGenitive: '{{count}} секунди',
	      pluralGenitive: '{{count}} секунд'
	    },
	    past: {
	      singularNominative: '{{count}} секунду тому',
	      singularGenitive: '{{count}} секунди тому',
	      pluralGenitive: '{{count}} секунд тому'
	    },
	    future: {
	      singularNominative: 'за {{count}} секунду',
	      singularGenitive: 'за {{count}} секунди',
	      pluralGenitive: 'за {{count}} секунд'
	    }
	  }),
	  halfAMinute: function (_, options) {
	    if (options.addSuffix) {
	      if (options.comparison > 0) {
	        return 'за півхвилини';
	      } else {
	        return 'півхвилини тому';
	      }
	    }
	
	    return 'півхвилини';
	  },
	  lessThanXMinutes: buildLocalizeTokenFn({
	    regular: {
	      one: 'менше хвилини',
	      singularNominative: 'менше {{count}} хвилини',
	      singularGenitive: 'менше {{count}} хвилин',
	      pluralGenitive: 'менше {{count}} хвилин'
	    },
	    future: {
	      one: 'менше, ніж за хвилину',
	      singularNominative: 'менше, ніж за {{count}} хвилину',
	      singularGenitive: 'менше, ніж за {{count}} хвилини',
	      pluralGenitive: 'менше, ніж за {{count}} хвилин'
	    }
	  }),
	  xMinutes: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} хвилина',
	      singularGenitive: '{{count}} хвилини',
	      pluralGenitive: '{{count}} хвилин'
	    },
	    past: {
	      singularNominative: '{{count}} хвилину тому',
	      singularGenitive: '{{count}} хвилини тому',
	      pluralGenitive: '{{count}} хвилин тому'
	    },
	    future: {
	      singularNominative: 'за {{count}} хвилину',
	      singularGenitive: 'за {{count}} хвилини',
	      pluralGenitive: 'за {{count}} хвилин'
	    }
	  }),
	  aboutXHours: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'близько {{count}} години',
	      singularGenitive: 'близько {{count}} годин',
	      pluralGenitive: 'близько {{count}} годин'
	    },
	    future: {
	      singularNominative: 'приблизно за {{count}} годину',
	      singularGenitive: 'приблизно за {{count}} години',
	      pluralGenitive: 'приблизно за {{count}} годин'
	    }
	  }),
	  xHours: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} годину',
	      singularGenitive: '{{count}} години',
	      pluralGenitive: '{{count}} годин'
	    }
	  }),
	  xDays: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} день',
	      singularGenitive: '{{count}} дня',
	      pluralGenitive: '{{count}} днів'
	    }
	  }),
	  aboutXWeeks: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'близько {{count}} тижня',
	      singularGenitive: 'близько {{count}} тижнів',
	      pluralGenitive: 'близько {{count}} тижнів'
	    },
	    future: {
	      singularNominative: 'приблизно за {{count}} тиждень',
	      singularGenitive: 'приблизно за {{count}} тижні',
	      pluralGenitive: 'приблизно за {{count}} тижні'
	    }
	  }),
	  xWeeks: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} тиждень',
	      singularGenitive: '{{count}} тижня',
	      pluralGenitive: '{{count}} тижні'
	    }
	  }),
	  aboutXMonths: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'близько {{count}} місяця',
	      singularGenitive: 'близько {{count}} місяців',
	      pluralGenitive: 'близько {{count}} місяців'
	    },
	    future: {
	      singularNominative: 'приблизно за {{count}} місяць',
	      singularGenitive: 'приблизно за {{count}} місяця',
	      pluralGenitive: 'приблизно за {{count}} місяців'
	    }
	  }),
	  xMonths: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} місяць',
	      singularGenitive: '{{count}} місяця',
	      pluralGenitive: '{{count}} місяців'
	    }
	  }),
	  aboutXYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'близько {{count}} року',
	      singularGenitive: 'близько {{count}} років',
	      pluralGenitive: 'близько {{count}} років'
	    },
	    future: {
	      singularNominative: 'приблизно за {{count}} рік',
	      singularGenitive: 'приблизно за {{count}} роки',
	      pluralGenitive: 'приблизно за {{count}} років'
	    }
	  }),
	  xYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: '{{count}} рік',
	      singularGenitive: '{{count}} роки',
	      pluralGenitive: '{{count}} років'
	    }
	  }),
	  overXYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'більше {{count}} року',
	      singularGenitive: 'більше {{count}} років',
	      pluralGenitive: 'більше {{count}} років'
	    },
	    future: {
	      singularNominative: 'більше, ніж за {{count}} рік',
	      singularGenitive: 'більше, ніж за {{count}} роки',
	      pluralGenitive: 'більше, ніж за {{count}} років'
	    }
	  }),
	  almostXYears: buildLocalizeTokenFn({
	    regular: {
	      singularNominative: 'майже {{count}} рік',
	      singularGenitive: 'майже {{count}} роки',
	      pluralGenitive: 'майже {{count}} років'
	    },
	    future: {
	      singularNominative: 'майже за {{count}} рік',
	      singularGenitive: 'майже за {{count}} роки',
	      pluralGenitive: 'майже за {{count}} років'
	    }
	  })
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  return formatDistanceLocale[token](count, options);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "EEEE, do MMMM y 'р.'",
	  long: "do MMMM y 'р.'",
	  medium: "d MMM y 'р.'",
	  short: 'dd.MM.y'
	};
	var timeFormats = {
	  full: 'H:mm:ss zzzz',
	  long: 'H:mm:ss z',
	  medium: 'H:mm:ss',
	  short: 'H:mm'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'о' {{time}}",
	  long: "{{date}} 'о' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	
	var _index = _interopRequireDefault(__webpack_require__(46));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accusativeWeekdays = ['неділю', 'понеділок', 'вівторок', 'середу', 'четвер', 'п’ятницю', 'суботу'];
	
	function lastWeek(day) {
	  var weekday = accusativeWeekdays[day];
	
	  switch (day) {
	    case 0:
	    case 3:
	    case 5:
	    case 6:
	      return "'у минулу " + weekday + " о' p";
	
	    case 1:
	    case 2:
	    case 4:
	      return "'у минулий " + weekday + " о' p";
	  }
	}
	
	function thisWeek(day) {
	  var weekday = accusativeWeekdays[day];
	  return "'у " + weekday + " о' p";
	}
	
	function nextWeek(day) {
	  var weekday = accusativeWeekdays[day];
	
	  switch (day) {
	    case 0:
	    case 3:
	    case 5:
	    case 6:
	      return "'у наступну " + weekday + " о' p";
	
	    case 1:
	    case 2:
	    case 4:
	      return "'у наступний " + weekday + " о' p";
	  }
	}
	
	var formatRelativeLocale = {
	  lastWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return lastWeek(day);
	    }
	  },
	  yesterday: "'вчора о' p",
	  today: "'сьогодні о' p",
	  tomorrow: "'завтра о' p",
	  nextWeek: function (date, baseDate, options) {
	    var day = date.getUTCDay();
	
	    if ((0, _index.default)(date, baseDate, options)) {
	      return thisWeek(day);
	    } else {
	      return nextWeek(day);
	    }
	  },
	  other: 'P'
	};
	
	function formatRelative(token, date, baseDate, options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(date, baseDate, options);
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['до н.е.', 'н.е.'],
	  abbreviated: ['до н. е.', 'н. е.'],
	  wide: ['до нашої ери', 'нашої ери']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['1-й кв.', '2-й кв.', '3-й кв.', '4-й кв.'],
	  wide: ['1-й квартал', '2-й квартал', '3-й квартал', '4-й квартал']
	};
	var monthValues = {
	  // ДСТУ 3582:2013
	  narrow: ['С', 'Л', 'Б', 'К', 'Т', 'Ч', 'Л', 'С', 'В', 'Ж', 'Л', 'Г'],
	  abbreviated: ['січ.', 'лют.', 'берез.', 'квіт.', 'трав.', 'черв.', 'лип.', 'серп.', 'верес.', 'жовт.', 'листоп.', 'груд.'],
	  wide: ['січень', 'лютий', 'березень', 'квітень', 'травень', 'червень', 'липень', 'серпень', 'вересень', 'жовтень', 'листопад', 'грудень']
	};
	var formattingMonthValues = {
	  narrow: ['С', 'Л', 'Б', 'К', 'Т', 'Ч', 'Л', 'С', 'В', 'Ж', 'Л', 'Г'],
	  abbreviated: ['січ.', 'лют.', 'берез.', 'квіт.', 'трав.', 'черв.', 'лип.', 'серп.', 'верес.', 'жовт.', 'листоп.', 'груд.'],
	  wide: ['січня', 'лютого', 'березня', 'квітня', 'травня', 'червня', 'липня', 'серпня', 'вересня', 'жовтня', 'листопада', 'грудня']
	};
	var dayValues = {
	  narrow: ['Н', 'П', 'В', 'С', 'Ч', 'П', 'С'],
	  short: ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
	  abbreviated: ['нед', 'пон', 'вів', 'сер', 'чтв', 'птн', 'суб'],
	  wide: ['неділя', 'понеділок', 'вівторок', 'середа', 'четвер', 'п’ятниця', 'субота']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'півн.',
	    noon: 'пол.',
	    morning: 'ранок',
	    afternoon: 'день',
	    evening: 'веч.',
	    night: 'ніч'
	  },
	  abbreviated: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'півн.',
	    noon: 'пол.',
	    morning: 'ранок',
	    afternoon: 'день',
	    evening: 'веч.',
	    night: 'ніч'
	  },
	  wide: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'північ',
	    noon: 'полудень',
	    morning: 'ранок',
	    afternoon: 'день',
	    evening: 'вечір',
	    night: 'ніч'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'півн.',
	    noon: 'пол.',
	    morning: 'ранку',
	    afternoon: 'дня',
	    evening: 'веч.',
	    night: 'ночі'
	  },
	  abbreviated: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'півн.',
	    noon: 'пол.',
	    morning: 'ранку',
	    afternoon: 'дня',
	    evening: 'веч.',
	    night: 'ночі'
	  },
	  wide: {
	    am: 'ДП',
	    pm: 'ПП',
	    midnight: 'північ',
	    noon: 'полудень',
	    morning: 'ранку',
	    afternoon: 'дня',
	    evening: 'веч.',
	    night: 'ночі'
	  }
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	  var suffix;
	
	  if (unit === 'date') {
	    if (dirtyNumber === 3 || dirtyNumber === 23) {
	      suffix = '-є';
	    } else {
	      suffix = '-е';
	    }
	  } else if (unit === 'minute' || unit === 'second' || unit === 'hour') {
	    suffix = '-а';
	  } else {
	    suffix = '-й';
	  }
	
	  return dirtyNumber + suffix;
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'any',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(-?(е|й|є|а|я))?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^((до )?н\.?\s?е\.?)/i,
	  abbreviated: /^((до )?н\.?\s?е\.?)/i,
	  wide: /^(до нашої ери|нашої ери|наша ера)/i
	};
	var parseEraPatterns = {
	  any: [/^д/i, /^н/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
	  wide: /^[1234](-?[иі]?й?)? квартал/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[слбктчвжг]/i,
	  abbreviated: /^(січ|лют|бер|берез|кві|трав?|чер|лип|сер|вер|жов|лис(топ)?|груд)\.?/i,
	  wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопада?|грудень|грудня)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^с/i, /^л/i, /^б/i, /^к/i, /^т/i, /^ч/i, /^л/i, /^с/i, /^в/i, /^ж/i, /^л/i, /^г/i],
	  any: [/^сі/i, /^лю/i, /^б/i, /^к/i, /^т/i, /^ч/i, /^лип/i, /^се/i, /^в/i, /^ж/i, /^лис/i, /^г/i]
	};
	var matchDayPatterns = {
	  narrow: /^[нпвсч]/i,
	  short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
	  abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
	  wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
	};
	var parseDayPatterns = {
	  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
	  any: [/^н/i, /^п[он]/i, /^в/i, /^с[ер]/i, /^ч/i, /^п\W*?[ят]/i, /^с[уб]/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
	  abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
	  wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^дп/i,
	    pm: /^пп/i,
	    midnight: /^півн/i,
	    noon: /^пол/i,
	    morning: /^р/i,
	    afternoon: /^д[ен]/i,
	    evening: /^в/i,
	    night: /^н/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1387));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1388));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1389));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1390));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1391));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Ukrainian locale.
	 * @language Ukrainian
	 * @iso-639-2 ukr
	 * @author Andrii Korzh [@korzhyk]{@link https://github.com/korzhyk}
	 * @author Andriy Shcherbyak [@shcherbyakdev]{@link https://github.com/shcherbyakdev}
	 */
	var locale = {
	  code: 'uk',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'sekunddan kam',
	    other: '{{count}} sekunddan kam'
	  },
	  xSeconds: {
	    one: '1 sekund',
	    other: '{{count}} sekund'
	  },
	  halfAMinute: 'yarim minut',
	  lessThanXMinutes: {
	    one: 'bir minutdan kam',
	    other: '{{count}} minutdan kam'
	  },
	  xMinutes: {
	    one: '1 minut',
	    other: '{{count}} minut'
	  },
	  aboutXHours: {
	    one: 'tahminan 1 soat',
	    other: 'tahminan {{count}} soat'
	  },
	  xHours: {
	    one: '1 soat',
	    other: '{{count}} soat'
	  },
	  xDays: {
	    one: '1 kun',
	    other: '{{count}} kun'
	  },
	  aboutXWeeks: {
	    one: 'tahminan 1 hafta',
	    other: 'tahminan {{count}} hafta'
	  },
	  xWeeks: {
	    one: '1 hafta',
	    other: '{{count}} hafta'
	  },
	  aboutXMonths: {
	    one: 'tahminan 1 oy',
	    other: 'tahminan {{count}} oy'
	  },
	  xMonths: {
	    one: '1 oy',
	    other: '{{count}} oy'
	  },
	  aboutXYears: {
	    one: 'tahminan 1 yil',
	    other: 'tahminan {{count}} yil'
	  },
	  xYears: {
	    one: '1 yil',
	    other: '{{count}} yil'
	  },
	  overXYears: {
	    one: "1 yildan ko'p",
	    other: "{{count}} yildan ko'p"
	  },
	  almostXYears: {
	    one: 'deyarli 1 yil',
	    other: 'deyarli {{count}} yil'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result + ' dan keyin';
	    } else {
	      return result + ' oldin';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, do MMMM, y',
	  long: 'do MMMM, y',
	  medium: 'd MMM, y',
	  short: 'dd/MM/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss zzzz',
	  long: 'h:mm:ss z',
	  medium: 'h:mm:ss',
	  short: 'h:mm'
	};
	var dateTimeFormats = {
	  any: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'any'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1395 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'oldingi' eeee p 'da'",
	  yesterday: "'kecha' p 'da'",
	  today: "'bugun' p 'da'",
	  tomorrow: "'ertaga' p 'da'",
	  nextWeek: "eeee p 'da'",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['M.A', 'M.'],
	  abbreviated: ['M.A', 'M.'],
	  wide: ['Miloddan Avvalgi', 'Milodiy']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['CH.1', 'CH.2', 'CH.3', 'CH.4'],
	  wide: ['1-chi chorak', '2-chi chorak', '3-chi chorak', '4-chi chorak']
	}; // Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['Y', 'F', 'M', 'A', 'M', 'I', 'I', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Yan', 'Fev', 'Mar', 'Apr', 'May', 'Iyun', 'Iyul', 'Avg', 'Sen', 'Okt', 'Noy', 'Dek'],
	  wide: ['Yanvar', 'Fevral', 'Mart', 'Aprel', 'May', 'Iyun', 'Iyul', 'Avgust', 'Sentabr', 'Oktabr', 'Noyabr', 'Dekabr']
	};
	var dayValues = {
	  narrow: ['Y', 'D', 'S', 'CH', 'P', 'J', 'SH'],
	  short: ['Ya', 'Du', 'Se', 'Cho', 'Pa', 'Ju', 'Sha'],
	  abbreviated: ['Yak', 'Dush', 'Sesh', 'Chor', 'Pay', 'Jum', 'Shan'],
	  wide: ['Yakshanba', 'Dushanba', 'Seshanba', 'Chorshanba', 'Payshanba', 'Juma', 'Shanba']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'y.t',
	    noon: 'p.',
	    morning: 'ertalab',
	    afternoon: 'tushdan keyin',
	    evening: 'kechqurun',
	    night: 'tun'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'yarim tun',
	    noon: 'peshin',
	    morning: 'ertalab',
	    afternoon: 'tushdan keyin',
	    evening: 'kechqurun',
	    night: 'tun'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'yarim tun',
	    noon: 'peshin',
	    morning: 'ertalab',
	    afternoon: 'tushdan keyin',
	    evening: 'kechqurun',
	    night: 'tun'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'y.t',
	    noon: 'p.',
	    morning: 'ertalab',
	    afternoon: 'tushdan keyin',
	    evening: 'kechqurun',
	    night: 'tun'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'yarim tun',
	    noon: 'peshin',
	    morning: 'ertalab',
	    afternoon: 'tushdan keyin',
	    evening: 'kechqurun',
	    night: 'tun'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'yarim tun',
	    noon: 'peshin',
	    morning: 'ertalab',
	    afternoon: 'tushdan keyin',
	    evening: 'kechqurun',
	    night: 'tun'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	
	  return number;
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(chi)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(m\.a|m\.)/i,
	  abbreviated: /^(m\.a\.?\s?m\.?)/i,
	  wide: /^(miloddan avval|miloddan keyin)/i
	};
	var parseEraPatterns = {
	  any: [/^b/i, /^(a|c)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](chi)? chorak/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[yfmasond]/i,
	  abbreviated: /^(yan|fev|mar|apr|may|iyun|iyul|avg|sen|okt|noy|dek)/i,
	  wide: /^(yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^y/i, /^f/i, /^m/i, /^a/i, /^m/i, /^i/i, /^i/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ya/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^iyun/i, /^iyul/i, /^av/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[ydschj]/i,
	  short: /^(ya|du|se|cho|pa|ju|sha)/i,
	  abbreviated: /^(yak|dush|sesh|chor|pay|jum|shan)/i,
	  wide: /^(yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba)/i
	};
	var parseDayPatterns = {
	  narrow: [/^y/i, /^d/i, /^s/i, /^ch/i, /^p/i, /^j/i, /^sh/i],
	  any: [/^ya/i, /^d/i, /^se/i, /^ch/i, /^p/i, /^j/i, /^sh/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|y\.t|p| (ertalab|tushdan keyin|kechqurun|tun))/i,
	  any: /^([ap]\.?\s?m\.?|yarim tun|peshin| (ertalab|tushdan keyin|kechqurun|tun))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^y\.t/i,
	    noon: /^pe/i,
	    morning: /ertalab/i,
	    afternoon: /tushdan keyin/i,
	    evening: /kechqurun/i,
	    night: /tun/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1393));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1394));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1395));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1396));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1397));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Uzbek locale.
	 * @language Uzbek
	 * @iso-639-2 uzb
	 * @author Mukhammadali [@mukhammadali]{@link https://github.com/Mukhammadali}
	 */
	var locale = {
	  code: 'uz',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'dưới 1 giây',
	    other: 'dưới {{count}} giây'
	  },
	  xSeconds: {
	    one: '1 giây',
	    other: '{{count}} giây'
	  },
	  halfAMinute: 'nửa phút',
	  lessThanXMinutes: {
	    one: 'dưới 1 phút',
	    other: 'dưới {{count}} phút'
	  },
	  xMinutes: {
	    one: '1 phút',
	    other: '{{count}} phút'
	  },
	  aboutXHours: {
	    one: 'khoảng 1 giờ',
	    other: 'khoảng {{count}} giờ'
	  },
	  xHours: {
	    one: '1 giờ',
	    other: '{{count}} giờ'
	  },
	  xDays: {
	    one: '1 ngày',
	    other: '{{count}} ngày'
	  },
	  aboutXWeeks: {
	    one: 'khoảng 1 tuần',
	    other: 'khoảng {{count}} tuần'
	  },
	  xWeeks: {
	    one: '1 tuần',
	    other: '{{count}} tuần'
	  },
	  aboutXMonths: {
	    one: 'khoảng 1 tháng',
	    other: 'khoảng {{count}} tháng'
	  },
	  xMonths: {
	    one: '1 tháng',
	    other: '{{count}} tháng'
	  },
	  aboutXYears: {
	    one: 'khoảng 1 năm',
	    other: 'khoảng {{count}} năm'
	  },
	  xYears: {
	    one: '1 năm',
	    other: '{{count}} năm'
	  },
	  overXYears: {
	    one: 'hơn 1 năm',
	    other: 'hơn {{count}} năm'
	  },
	  almostXYears: {
	    one: 'gần 1 năm',
	    other: 'gần {{count}} năm'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result + ' nữa';
	    } else {
	      return result + ' trước';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  // thứ Sáu, ngày 25 tháng 08 năm 2017
	  full: "EEEE, 'ngày' d MMMM 'năm' y",
	  // ngày 25 tháng 08 năm 2017
	  long: "'ngày' d MMMM 'năm' y",
	  // 25 thg 08 năm 2017
	  medium: "d MMM 'năm' y",
	  // 25/08/2017
	  short: 'dd/MM/y'
	};
	var timeFormats = {
	  full: 'HH:mm:ss zzzz',
	  long: 'HH:mm:ss z',
	  medium: 'HH:mm:ss',
	  short: 'HH:mm'
	};
	var dateTimeFormats = {
	  // thứ Sáu, ngày 25 tháng 08 năm 2017 23:25:59
	  full: '{{date}} {{time}}',
	  // ngày 25 tháng 08 năm 2017 23:25
	  long: '{{date}} {{time}}',
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "eeee 'tuần trước vào lúc' p",
	  yesterday: "'hôm qua vào lúc' p",
	  today: "'hôm nay vào lúc' p",
	  tomorrow: "'ngày mai vào lúc' p",
	  nextWeek: "eeee 'tới vào lúc' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Vietnamese locale reference: http://www.localeplanet.com/icu/vi-VN/index.html
	// Capitalization reference: http://hcmup.edu.vn/index.php?option=com_content&view=article&id=4106%3Avit-hoa-trong-vn-bn-hanh-chinh&catid=2345%3Atham-kho&Itemid=4103&lang=vi&site=134
	var eraValues = {
	  narrow: ['TCN', 'SCN'],
	  abbreviated: ['trước CN', 'sau CN'],
	  wide: ['trước Công Nguyên', 'sau Công Nguyên']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['Quý 1', 'Quý 2', 'Quý 3', 'Quý 4']
	};
	var formattingQuarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  // I notice many news outlet use this "quý II/2018"
	  wide: ['quý I', 'quý II', 'quý III', 'quý IV']
	}; // Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	var monthValues = {
	  narrow: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
	  abbreviated: ['Thg 1', 'Thg 2', 'Thg 3', 'Thg 4', 'Thg 5', 'Thg 6', 'Thg 7', 'Thg 8', 'Thg 9', 'Thg 10', 'Thg 11', 'Thg 12'],
	  wide: ['Tháng Một', 'Tháng Hai', 'Tháng Ba', 'Tháng Tư', 'Tháng Năm', 'Tháng Sáu', 'Tháng Bảy', 'Tháng Tám', 'Tháng Chín', 'Tháng Mười', 'Tháng Mười Một', 'Tháng Mười Hai']
	}; // In Vietnamese date formatting, month number less than 10 expected to have leading zero
	
	var formattingMonthValues = {
	  narrow: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
	  abbreviated: ['thg 1', 'thg 2', 'thg 3', 'thg 4', 'thg 5', 'thg 6', 'thg 7', 'thg 8', 'thg 9', 'thg 10', 'thg 11', 'thg 12'],
	  wide: ['tháng 01', 'tháng 02', 'tháng 03', 'tháng 04', 'tháng 05', 'tháng 06', 'tháng 07', 'tháng 08', 'tháng 09', 'tháng 10', 'tháng 11', 'tháng 12']
	};
	var dayValues = {
	  narrow: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
	  short: ['CN', 'Th 2', 'Th 3', 'Th 4', 'Th 5', 'Th 6', 'Th 7'],
	  abbreviated: ['CN', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7'],
	  wide: ['Chủ Nhật', 'Thứ Hai', 'Thứ Ba', 'Thứ Tư', 'Thứ Năm', 'Thứ Sáu', 'Thứ Bảy']
	}; // Vietnamese are used to AM/PM borrowing from English, hence `narrow` and
	// `abbreviated` are just like English but I'm leaving the `wide`
	// format being localized with abbreviations found in some systems (SÁng / CHiều);
	// however, personally, I don't think `Chiều` sounds appropriate for `PM`
	
	var dayPeriodValues = {
	  // narrow date period is extremely rare in Vietnamese
	  // I used abbreviated form for noon, morning and afternoon
	  // which are regconizable by Vietnamese, others cannot be any shorter
	  narrow: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'nửa đêm',
	    noon: 'tr',
	    morning: 'sg',
	    afternoon: 'ch',
	    evening: 'tối',
	    night: 'đêm'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'nửa đêm',
	    noon: 'trưa',
	    morning: 'sáng',
	    afternoon: 'chiều',
	    evening: 'tối',
	    night: 'đêm'
	  },
	  wide: {
	    am: 'SA',
	    pm: 'CH',
	    midnight: 'nửa đêm',
	    noon: 'trưa',
	    morning: 'sáng',
	    afternoon: 'chiều',
	    evening: 'tối',
	    night: 'đêm'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'am',
	    pm: 'pm',
	    midnight: 'nửa đêm',
	    noon: 'tr',
	    morning: 'sg',
	    afternoon: 'ch',
	    evening: 'tối',
	    night: 'đêm'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'nửa đêm',
	    noon: 'trưa',
	    morning: 'sáng',
	    afternoon: 'chiều',
	    evening: 'tối',
	    night: 'đêm'
	  },
	  wide: {
	    am: 'SA',
	    pm: 'CH',
	    midnight: 'nửa đêm',
	    noon: 'giữa trưa',
	    morning: 'vào buổi sáng',
	    afternoon: 'vào buổi chiều',
	    evening: 'vào buổi tối',
	    night: 'vào ban đêm'
	  }
	}; // If ordinal numbers depend on context, for example,
	// if they are different for different grammatical genders,
	// use `options.unit`:
	//
	//   var options = dirtyOptions || {}
	//   var unit = String(options.unit)
	//
	// where `unit` can be 'month', 'quarter', 'week', 'isoWeek', 'dayOfYear',
	// 'dayOfMonth' or 'dayOfWeek'
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	  var number = parseInt(dirtyNumber, 10);
	
	  if (unit === 'quarter') {
	    // many news outlets use "quý I"...
	    switch (number) {
	      case 1:
	        return 'I';
	
	      case 2:
	        return 'II';
	
	      case 3:
	        return 'III';
	
	      case 4:
	        return 'IV';
	    }
	  } else if (unit === 'day') {
	    // day of week in Vietnamese has ordinal number meaning,
	    // so we should use them, else it'll sound weird
	    switch (number) {
	      case 1:
	        return 'thứ 2';
	      // meaning 2nd day but it's the first day of the week :D
	
	      case 2:
	        return 'thứ 3';
	      // meaning 3rd day
	
	      case 3:
	        return 'thứ 4';
	      // meaning 4th day and so on
	
	      case 4:
	        return 'thứ 5';
	
	      case 5:
	        return 'thứ 6';
	
	      case 6:
	        return 'thứ 7';
	
	      case 7:
	        return 'chủ nhật';
	      // meaning Sunday, there's no 8th day :D
	    }
	  } else if (unit === 'week') {
	    if (number === 1) {
	      return 'thứ nhất';
	    } else {
	      return 'thứ ' + number;
	    }
	  } else if (unit === 'dayOfYear') {
	    if (number === 1) {
	      return 'đầu tiên';
	    } else {
	      return 'thứ ' + number;
	    }
	  } // there are no different forms of ordinal numbers in Vietnamese
	
	
	  return number;
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingQuarterValues,
	    defaultFormattingWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingMonthValues,
	    defaultFormattingWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(tcn|scn)/i,
	  abbreviated: /^(trước CN|sau CN)/i,
	  wide: /^(trước Công Nguyên|sau Công Nguyên)/i
	};
	var parseEraPatterns = {
	  any: [/^t/i, /^s/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^([1234]|i{1,3}v?)/i,
	  abbreviated: /^q([1234]|i{1,3}v?)/i,
	  wide: /^quý ([1234]|i{1,3}v?)/i
	};
	var parseQuarterPatterns = {
	  any: [/(1|i)$/i, /(2|ii)$/i, /(3|iii)$/i, /(4|iv)$/i]
	};
	var matchMonthPatterns = {
	  // month number may contain leading 0, 'thg' prefix may have space, underscore or empty before number
	  // note the order of '1' since it is a sub-string of '10', so must be lower priority
	  narrow: /^(0?[2-9]|10|11|12|0?1)/i,
	  // note the order of 'thg 1' since it is sub-string of 'thg 10', so must be lower priority
	  abbreviated: /^thg[ _]?(0?[1-9](?!\d)|10|11|12)/i,
	  // note the order of 'Mười' since it is sub-string of Mười Một, so must be lower priority
	  wide: /^tháng ?(Một|Hai|Ba|Tư|Năm|Sáu|Bảy|Tám|Chín|Mười|Mười ?Một|Mười ?Hai|0?[1-9](?!\d)|10|11|12)/i
	};
	var parseMonthPatterns = {
	  narrow: [/0?1$/i, /0?2/i, /3/, /4/, /5/, /6/, /7/, /8/, /9/, /10/, /11/, /12/],
	  abbreviated: [/^thg[ _]?0?1(?!\d)/i, /^thg[ _]?0?2/i, /^thg[ _]?0?3/i, /^thg[ _]?0?4/i, /^thg[ _]?0?5/i, /^thg[ _]?0?6/i, /^thg[ _]?0?7/i, /^thg[ _]?0?8/i, /^thg[ _]?0?9/i, /^thg[ _]?10/i, /^thg[ _]?11/i, /^thg[ _]?12/i],
	  wide: [/^tháng ?(Một|0?1(?!\d))/i, /^tháng ?(Hai|0?2)/i, /^tháng ?(Ba|0?3)/i, /^tháng ?(Tư|0?4)/i, /^tháng ?(Năm|0?5)/i, /^tháng ?(Sáu|0?6)/i, /^tháng ?(Bảy|0?7)/i, /^tháng ?(Tám|0?8)/i, /^tháng ?(Chín|0?9)/i, /^tháng ?(Mười|10)/i, /^tháng ?(Mười ?Một|11)/i, /^tháng ?(Mười ?Hai|12)/i]
	};
	var matchDayPatterns = {
	  narrow: /^(CN|T2|T3|T4|T5|T6|T7)/i,
	  short: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
	  abbreviated: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
	  wide: /^(Chủ ?Nhật|Chúa ?Nhật|thứ ?Hai|thứ ?Ba|thứ ?Tư|thứ ?Năm|thứ ?Sáu|thứ ?Bảy)/i
	};
	var parseDayPatterns = {
	  narrow: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
	  short: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
	  abbreviated: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
	  wide: [/(Chủ|Chúa) ?Nhật/i, /Hai/i, /Ba/i, /Tư/i, /Năm/i, /Sáu/i, /Bảy/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
	  abbreviated: /^(am|pm|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
	  wide: /^(ch[^i]*|sa|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^(a|sa)/i,
	    pm: /^(p|ch[^i]*)/i,
	    midnight: /nửa đêm/i,
	    noon: /trưa/i,
	    morning: /sáng/i,
	    afternoon: /chiều/i,
	    evening: /tối/i,
	    night: /^đêm/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1399));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1400));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1401));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1402));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1403));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Vietnamese locale (Vietnam).
	 * @language Vietnamese
	 * @iso-639-2 vie
	 * @author Thanh Tran [@trongthanh]{@link https://github.com/trongthanh}
	 * @author Leroy Hopson [@lihop]{@link https://github.com/lihop}
	 */
	var locale = {
	  code: 'vi',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 1
	    /* First week of new year contains Jan 1st  */
	
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: '不到 1 秒',
	    other: '不到 {{count}} 秒'
	  },
	  xSeconds: {
	    one: '1 秒',
	    other: '{{count}} 秒'
	  },
	  halfAMinute: '半分钟',
	  lessThanXMinutes: {
	    one: '不到 1 分钟',
	    other: '不到 {{count}} 分钟'
	  },
	  xMinutes: {
	    one: '1 分钟',
	    other: '{{count}} 分钟'
	  },
	  xHours: {
	    one: '1 小时',
	    other: '{{count}} 小时'
	  },
	  aboutXHours: {
	    one: '大约 1 小时',
	    other: '大约 {{count}} 小时'
	  },
	  xDays: {
	    one: '1 天',
	    other: '{{count}} 天'
	  },
	  aboutXWeeks: {
	    one: '大约 1 个星期',
	    other: '大约 {{count}} 个星期'
	  },
	  xWeeks: {
	    one: '1 个星期',
	    other: '{{count}} 个星期'
	  },
	  aboutXMonths: {
	    one: '大约 1 个月',
	    other: '大约 {{count}} 个月'
	  },
	  xMonths: {
	    one: '1 个月',
	    other: '{{count}} 个月'
	  },
	  aboutXYears: {
	    one: '大约 1 年',
	    other: '大约 {{count}} 年'
	  },
	  xYears: {
	    one: '1 年',
	    other: '{{count}} 年'
	  },
	  overXYears: {
	    one: '超过 1 年',
	    other: '超过 {{count}} 年'
	  },
	  almostXYears: {
	    one: '将近 1 年',
	    other: '将近 {{count}} 年'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result + '内';
	    } else {
	      return result + '前';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "y'年'M'月'd'日' EEEE",
	  long: "y'年'M'月'd'日'",
	  medium: 'yyyy-MM-dd',
	  short: 'yy-MM-dd'
	};
	var timeFormats = {
	  full: 'zzzz a h:mm:ss',
	  long: 'z a h:mm:ss',
	  medium: 'a h:mm:ss',
	  short: 'a h:mm'
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  long: '{{date}} {{time}}',
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	
	var _index = _interopRequireDefault(__webpack_require__(46));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function checkWeek(_date, _baseDate, _options, baseFormat) {
	  if ((0, _index.default)(_date, _baseDate, _options)) {
	    return baseFormat; // in same week
	  } else if (_date.getTime() > _baseDate.getTime()) {
	    return "'下个'" + baseFormat; // in next week
	  }
	
	  return "'上个'" + baseFormat; // in last week
	}
	
	var formatRelativeLocale = {
	  lastWeek: checkWeek,
	  // days before yesterday, maybe in this week or last week
	  yesterday: "'昨天' p",
	  today: "'今天' p",
	  tomorrow: "'明天' p",
	  nextWeek: checkWeek,
	  // days after tomorrow, maybe in this week or next week
	  other: 'PP p'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  var format = formatRelativeLocale[token];
	
	  if (typeof format === 'function') {
	    return format(_date, _baseDate, _options, 'eeee p');
	  }
	
	  return format;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['前', '公元'],
	  abbreviated: ['前', '公元'],
	  wide: ['公元前', '公元']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['第一刻', '第二刻', '第三刻', '第四刻'],
	  wide: ['第一刻钟', '第二刻钟', '第三刻钟', '第四刻钟']
	};
	var monthValues = {
	  narrow: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
	  abbreviated: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
	  wide: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
	};
	var dayValues = {
	  narrow: ['日', '一', '二', '三', '四', '五', '六'],
	  short: ['日', '一', '二', '三', '四', '五', '六'],
	  abbreviated: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
	  wide: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: '上',
	    pm: '下',
	    midnight: '凌晨',
	    noon: '午',
	    morning: '早',
	    afternoon: '下午',
	    evening: '晚',
	    night: '夜'
	  },
	  abbreviated: {
	    am: '上午',
	    pm: '下午',
	    midnight: '凌晨',
	    noon: '中午',
	    morning: '早晨',
	    afternoon: '中午',
	    evening: '晚上',
	    night: '夜间'
	  },
	  wide: {
	    am: '上午',
	    pm: '下午',
	    midnight: '凌晨',
	    noon: '中午',
	    morning: '早晨',
	    afternoon: '中午',
	    evening: '晚上',
	    night: '夜间'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: '上',
	    pm: '下',
	    midnight: '凌晨',
	    noon: '午',
	    morning: '早',
	    afternoon: '下午',
	    evening: '晚',
	    night: '夜'
	  },
	  abbreviated: {
	    am: '上午',
	    pm: '下午',
	    midnight: '凌晨',
	    noon: '中午',
	    morning: '早晨',
	    afternoon: '中午',
	    evening: '晚上',
	    night: '夜间'
	  },
	  wide: {
	    am: '上午',
	    pm: '下午',
	    midnight: '凌晨',
	    noon: '中午',
	    morning: '早晨',
	    afternoon: '中午',
	    evening: '晚上',
	    night: '夜间'
	  }
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	  var number = Number(dirtyNumber);
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	
	  switch (unit) {
	    case 'date':
	      return number.toString() + '日';
	
	    case 'hour':
	      return number.toString() + '时';
	
	    case 'minute':
	      return number.toString() + '分';
	
	    case 'second':
	      return number.toString() + '秒';
	
	    default:
	      return '第 ' + number.toString();
	  }
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(第\s*)?\d+(日|时|分|秒)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(前)/i,
	  abbreviated: /^(前)/i,
	  wide: /^(公元前|公元)/i
	};
	var parseEraPatterns = {
	  any: [/^(前)/i, /^(公元)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^第[一二三四]刻/i,
	  wide: /^第[一二三四]刻钟/i
	};
	var parseQuarterPatterns = {
	  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
	  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
	  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
	};
	var parseMonthPatterns = {
	  narrow: [/^一/i, /^二/i, /^三/i, /^四/i, /^五/i, /^六/i, /^七/i, /^八/i, /^九/i, /^十(?!(一|二))/i, /^十一/i, /^十二/i],
	  any: [/^一|1/i, /^二|2/i, /^三|3/i, /^四|4/i, /^五|5/i, /^六|6/i, /^七|7/i, /^八|8/i, /^九|9/i, /^十(?!(一|二))|10/i, /^十一|11/i, /^十二|12/i]
	};
	var matchDayPatterns = {
	  narrow: /^[一二三四五六日]/i,
	  short: /^[一二三四五六日]/i,
	  abbreviated: /^周[一二三四五六日]/i,
	  wide: /^星期[一二三四五六日]/i
	};
	var parseDayPatterns = {
	  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^上午?/i,
	    pm: /^下午?/i,
	    midnight: /^午夜/i,
	    noon: /^[中正]午/i,
	    morning: /^早上/i,
	    afternoon: /^下午/i,
	    evening: /^晚上?/i,
	    night: /^凌晨/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1405));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1406));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1407));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1408));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1409));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Chinese Simplified locale.
	 * @language Chinese Simplified
	 * @iso-639-2 zho
	 * @author Changyu Geng [@KingMario]{@link https://github.com/KingMario}
	 * @author Song Shuoyun [@fnlctrl]{@link https://github.com/fnlctrl}
	 * @author sabrinaM [@sabrinamiao]{@link https://github.com/sabrinamiao}
	 * @author Carney Wu [@cubicwork]{@link https://github.com/cubicwork}
	 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
	 */
	var locale = {
	  code: 'zh-CN',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: '少於 1 秒',
	    other: '少於 {{count}} 秒'
	  },
	  xSeconds: {
	    one: '1 秒',
	    other: '{{count}} 秒'
	  },
	  halfAMinute: '半分鐘',
	  lessThanXMinutes: {
	    one: '少於 1 分鐘',
	    other: '少於 {{count}} 分鐘'
	  },
	  xMinutes: {
	    one: '1 分鐘',
	    other: '{{count}} 分鐘'
	  },
	  xHours: {
	    one: '1 小時',
	    other: '{{count}} 小時'
	  },
	  aboutXHours: {
	    one: '大約 1 小時',
	    other: '大約 {{count}} 小時'
	  },
	  xDays: {
	    one: '1 天',
	    other: '{{count}} 天'
	  },
	  aboutXWeeks: {
	    one: '大約 1 個星期',
	    other: '大約 {{count}} 個星期'
	  },
	  xWeeks: {
	    one: '1 個星期',
	    other: '{{count}} 個星期'
	  },
	  aboutXMonths: {
	    one: '大約 1 個月',
	    other: '大約 {{count}} 個月'
	  },
	  xMonths: {
	    one: '1 個月',
	    other: '{{count}} 個月'
	  },
	  aboutXYears: {
	    one: '大約 1 年',
	    other: '大約 {{count}} 年'
	  },
	  xYears: {
	    one: '1 年',
	    other: '{{count}} 年'
	  },
	  overXYears: {
	    one: '超過 1 年',
	    other: '超過 {{count}} 年'
	  },
	  almostXYears: {
	    one: '將近 1 年',
	    other: '將近 {{count}} 年'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return result + '內';
	    } else {
	      return result + '前';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: "y'年'M'月'd'日' EEEE",
	  long: "y'年'M'月'd'日'",
	  medium: 'yyyy-MM-dd',
	  short: 'yy-MM-dd'
	};
	var timeFormats = {
	  full: 'zzzz a h:mm:ss',
	  long: 'z a h:mm:ss',
	  medium: 'a h:mm:ss',
	  short: 'a h:mm'
	};
	var dateTimeFormats = {
	  full: '{{date}} {{time}}',
	  long: '{{date}} {{time}}',
	  medium: '{{date}} {{time}}',
	  short: '{{date}} {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1413 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'上個'eeee p",
	  yesterday: "'昨天' p",
	  today: "'今天' p",
	  tomorrow: "'明天' p",
	  nextWeek: "'下個'eeee p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['前', '公元'],
	  abbreviated: ['前', '公元'],
	  wide: ['公元前', '公元']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['第一刻', '第二刻', '第三刻', '第四刻'],
	  wide: ['第一刻鐘', '第二刻鐘', '第三刻鐘', '第四刻鐘']
	};
	var monthValues = {
	  narrow: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
	  abbreviated: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
	  wide: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
	};
	var dayValues = {
	  narrow: ['日', '一', '二', '三', '四', '五', '六'],
	  short: ['日', '一', '二', '三', '四', '五', '六'],
	  abbreviated: ['週日', '週一', '週二', '週三', '週四', '週五', '週六'],
	  wide: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: '上',
	    pm: '下',
	    midnight: '凌晨',
	    noon: '午',
	    morning: '早',
	    afternoon: '下午',
	    evening: '晚',
	    night: '夜'
	  },
	  abbreviated: {
	    am: '上午',
	    pm: '下午',
	    midnight: '凌晨',
	    noon: '中午',
	    morning: '早晨',
	    afternoon: '中午',
	    evening: '晚上',
	    night: '夜間'
	  },
	  wide: {
	    am: '上午',
	    pm: '下午',
	    midnight: '凌晨',
	    noon: '中午',
	    morning: '早晨',
	    afternoon: '中午',
	    evening: '晚上',
	    night: '夜間'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: '上',
	    pm: '下',
	    midnight: '凌晨',
	    noon: '午',
	    morning: '早',
	    afternoon: '下午',
	    evening: '晚',
	    night: '夜'
	  },
	  abbreviated: {
	    am: '上午',
	    pm: '下午',
	    midnight: '凌晨',
	    noon: '中午',
	    morning: '早晨',
	    afternoon: '中午',
	    evening: '晚上',
	    night: '夜間'
	  },
	  wide: {
	    am: '上午',
	    pm: '下午',
	    midnight: '凌晨',
	    noon: '中午',
	    morning: '早晨',
	    afternoon: '中午',
	    evening: '晚上',
	    night: '夜間'
	  }
	};
	
	function ordinalNumber(dirtyNumber, dirtyOptions) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	
	  var options = dirtyOptions || {};
	  var unit = String(options.unit);
	
	  switch (unit) {
	    case 'date':
	      return number.toString() + '日';
	
	    case 'hour':
	      return number.toString() + '時';
	
	    case 'minute':
	      return number.toString() + '分';
	
	    case 'second':
	      return number.toString() + '秒';
	
	    default:
	      return '第 ' + number.toString();
	  }
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(前)/i,
	  abbreviated: /^(前)/i,
	  wide: /^(公元前|公元)/i
	};
	var parseEraPatterns = {
	  any: [/^(前)/i, /^(公元)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^第[一二三四]刻/i,
	  wide: /^第[一二三四]刻鐘/i
	};
	var parseQuarterPatterns = {
	  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
	};
	var matchMonthPatterns = {
	  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
	  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
	  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
	};
	var parseMonthPatterns = {
	  narrow: [/^一/i, /^二/i, /^三/i, /^四/i, /^五/i, /^六/i, /^七/i, /^八/i, /^九/i, /^十(?!(一|二))/i, /^十一/i, /^十二/i],
	  any: [/^一|1/i, /^二|2/i, /^三|3/i, /^四|4/i, /^五|5/i, /^六|6/i, /^七|7/i, /^八|8/i, /^九|9/i, /^十(?!(一|二))|10/i, /^十一|11/i, /^十二|12/i]
	};
	var matchDayPatterns = {
	  narrow: /^[一二三四五六日]/i,
	  short: /^[一二三四五六日]/i,
	  abbreviated: /^週[一二三四五六日]/i,
	  wide: /^星期[一二三四五六日]/i
	};
	var parseDayPatterns = {
	  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
	};
	var matchDayPeriodPatterns = {
	  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^上午?/i,
	    pm: /^下午?/i,
	    midnight: /^午夜/i,
	    noon: /^[中正]午/i,
	    morning: /^早上/i,
	    afternoon: /^下午/i,
	    evening: /^晚上?/i,
	    night: /^凌晨/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1411));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1412));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1413));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1414));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1415));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary Chinese Traditional locale.
	 * @language Chinese Traditional
	 * @iso-639-2 zho
	 * @author tonypai [@tpai]{@link https://github.com/tpai}
	 * @author Jack Hsu [@jackhsu978]{@link https://github.com/jackhsu978}
	 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
	 */
	var locale = {
	  code: 'zh-TW',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 1
	    /* Monday */
	    ,
	    firstWeekContainsDate: 4
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = millisecondsToHours;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name millisecondsToHours
	 * @category Conversion Helpers
	 * @summary Convert milliseconds to hours.
	 *
	 * @description
	 * Convert a number of milliseconds to a full number of hours.
	 *
	 * @param {number} milliseconds - number of milliseconds to be converted
	 *
	 * @returns {number} the number of milliseconds converted in hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 7200000 milliseconds to hours:
	 * const result = millisecondsToHours(7200000)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = millisecondsToHours(7199999)
	 * //=> 1
	 */
	function millisecondsToHours(milliseconds) {
	  (0, _index.default)(1, arguments);
	  var hours = milliseconds / _index2.millisecondsInHour;
	  return Math.floor(hours);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = millisecondsToMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name millisecondsToMinutes
	 * @category Conversion Helpers
	 * @summary Convert milliseconds to minutes.
	 *
	 * @description
	 * Convert a number of milliseconds to a full number of minutes.
	 *
	 * @param {number} milliseconds - number of milliseconds to be converted.
	 *
	 * @returns {number} the number of milliseconds converted in minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 60000 milliseconds to minutes:
	 * const result = millisecondsToMinutes(60000)
	 * //=> 1
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = millisecondsToMinutes(119999)
	 * //=> 1
	 */
	function millisecondsToMinutes(milliseconds) {
	  (0, _index.default)(1, arguments);
	  var minutes = milliseconds / _index2.millisecondsInMinute;
	  return Math.floor(minutes);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = millisecondsToSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name millisecondsToSeconds
	 * @category Conversion Helpers
	 * @summary Convert milliseconds to seconds.
	 *
	 * @description
	 * Convert a number of milliseconds to a full number of seconds.
	 *
	 * @param {number} milliseconds - number of milliseconds to be converted
	 *
	 * @returns {number} the number of milliseconds converted in seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 1000 miliseconds to seconds:
	 * const result = millisecondsToSeconds(1000)
	 * //=> 1
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = millisecondsToSeconds(1999)
	 * //=> 1
	 */
	function millisecondsToSeconds(milliseconds) {
	  (0, _index.default)(1, arguments);
	  var seconds = milliseconds / _index2.millisecondsInSecond;
	  return Math.floor(seconds);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = milliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
	// 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
	var daysInYear = 365.2425;
	/**
	 * @name milliseconds
	 * @category Millisecond Helpers
	 * @summary
	 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
	 *
	 * @description
	 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
	 *
	 * One years equals 365.2425 days according to the formula:
	 *
	 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
	 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
	 *
	 * One month is a year divided by 12.
	 *
	 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {number} the milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // 1 year in milliseconds
	 * milliseconds({ years: 1 })
	 * //=> 31556952000
	 *
	 * // 3 months in milliseconds
	 * milliseconds({ months: 3 })
	 * //=> 7889238000
	 */
	
	function milliseconds(_ref) {
	  var years = _ref.years,
	      months = _ref.months,
	      weeks = _ref.weeks,
	      days = _ref.days,
	      hours = _ref.hours,
	      minutes = _ref.minutes,
	      seconds = _ref.seconds;
	  (0, _index.default)(1, arguments);
	  var totalDays = 0;
	  if (years) totalDays += years * daysInYear;
	  if (months) totalDays += months * (daysInYear / 12);
	  if (weeks) totalDays += weeks * 7;
	  if (days) totalDays += days;
	  var totalSeconds = totalDays * 24 * 60 * 60;
	  if (hours) totalSeconds += hours * 60 * 60;
	  if (minutes) totalSeconds += minutes * 60;
	  if (seconds) totalSeconds += seconds;
	  return Math.round(totalSeconds * 1000);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = minutesToHours;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name minutesToHours
	 * @category Conversion Helpers
	 * @summary Convert minutes to hours.
	 *
	 * @description
	 * Convert a number of minutes to a full number of hours.
	 *
	 * @param {number} minutes - number of minutes to be converted
	 *
	 * @returns {number} the number of minutes converted in hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 140 minutes to hours:
	 * const result = minutesToHours(120)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = minutesToHours(179)
	 * //=> 2
	 */
	function minutesToHours(minutes) {
	  (0, _index.default)(1, arguments);
	  var hours = minutes / _index2.minutesInHour;
	  return Math.floor(hours);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = minutesToMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name minutesToMilliseconds
	 * @category Conversion Helpers
	 * @summary Convert minutes to milliseconds.
	 *
	 * @description
	 * Convert a number of minutes to a full number of milliseconds.
	 *
	 * @param {number} minutes - number of minutes to be converted
	 *
	 * @returns {number} the number of minutes converted in milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 minutes to milliseconds
	 * const result = minutesToMilliseconds(2)
	 * //=> 120000
	 */
	function minutesToMilliseconds(minutes) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(minutes * _index2.millisecondsInMinute);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = minutesToSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name minutesToSeconds
	 * @category Conversion Helpers
	 * @summary Convert minutes to seconds.
	 *
	 * @description
	 * Convert a number of minutes to a full number of seconds.
	 *
	 * @param { number } minutes - number of minutes to be converted
	 *
	 * @returns {number} the number of minutes converted in seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 minutes to seconds
	 * const result = minutesToSeconds(2)
	 * //=> 120
	 */
	function minutesToSeconds(minutes) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(minutes * _index2.secondsInMinute);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = monthsToQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name monthsToQuarters
	 * @category Conversion Helpers
	 * @summary Convert number of months to quarters.
	 *
	 * @description
	 * Convert a number of months to a full number of quarters.
	 *
	 * @param {number} months - number of months to be converted.
	 *
	 * @returns {number} the number of months converted in quarters
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 6 months to quarters:
	 * const result = monthsToQuarters(6)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = monthsToQuarters(7)
	 * //=> 2
	 */
	function monthsToQuarters(months) {
	  (0, _index.default)(1, arguments);
	  var quarters = months / _index2.monthsInQuarter;
	  return Math.floor(quarters);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = monthsToYears;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name monthsToYears
	 * @category Conversion Helpers
	 * @summary Convert number of months to years.
	 *
	 * @description
	 * Convert a number of months to a full number of years.
	 *
	 * @param {number} months - number of months to be converted
	 *
	 * @returns {number} the number of months converted in years
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 36 months to years:
	 * const result = monthsToYears(36)
	 * //=> 3
	 *
	 * // It uses floor rounding:
	 * const result = monthsToYears(40)
	 * //=> 3
	 */
	function monthsToYears(months) {
	  (0, _index.default)(1, arguments);
	  var years = months / _index2.monthsInYear;
	  return Math.floor(years);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextFriday;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = _interopRequireDefault(__webpack_require__(64));
	
	var _index3 = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name nextFriday
	 * @category Weekday Helpers
	 * @summary When is the next Friday?
	 *
	 * @description
	 * When is the next Friday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Friday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Friday after Mar, 22, 2020?
	 * const result = nextFriday(new Date(2020, 2, 22))
	 * //=> Fri Mar 27 2020 00:00:00
	 */
	function nextFriday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)((0, _index3.default)(date), 5);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextMonday;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = _interopRequireDefault(__webpack_require__(64));
	
	var _index3 = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name nextMonday
	 * @category Weekday Helpers
	 * @summary When is the next Monday?
	 *
	 * @description
	 * When is the next Monday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Monday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Monday after Mar, 22, 2020?
	 * const result = nextMonday(new Date(2020, 2, 22))
	 * //=> Mon Mar 23 2020 00:00:00
	 */
	function nextMonday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)((0, _index3.default)(date), 1);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextSaturday;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = _interopRequireDefault(__webpack_require__(64));
	
	var _index3 = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name nextSaturday
	 * @category Weekday Helpers
	 * @summary When is the next Saturday?
	 *
	 * @description
	 * When is the next Saturday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Saturday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Saturday after Mar, 22, 2020?
	 * const result = nextSaturday(new Date(2020, 2, 22))
	 * //=> Sat Mar 28 2020 00:00:00
	 */
	function nextSaturday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)((0, _index3.default)(date), 6);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextSunday;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = _interopRequireDefault(__webpack_require__(64));
	
	var _index3 = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name nextSunday
	 * @category Weekday Helpers
	 * @summary When is the next Sunday?
	 *
	 * @description
	 * When is the next Sunday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Sunday after Mar, 22, 2020?
	 * const result = nextSunday(new Date(2020, 2, 22))
	 * //=> Sun Mar 29 2020 00:00:00
	 */
	function nextSunday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)((0, _index3.default)(date), 0);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextThursday;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = _interopRequireDefault(__webpack_require__(64));
	
	var _index3 = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name nextThursday
	 * @category Weekday Helpers
	 * @summary When is the next Thursday?
	 *
	 * @description
	 * When is the next Thursday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Thursday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Thursday after Mar, 22, 2020?
	 * const result = nextThursday(new Date(2020, 2, 22))
	 * //=> Thur Mar 26 2020 00:00:00
	 */
	function nextThursday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)((0, _index3.default)(date), 4);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextTuesday;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = _interopRequireDefault(__webpack_require__(64));
	
	var _index3 = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name nextTuesday
	 * @category Weekday Helpers
	 * @summary When is the next Tuesday?
	 *
	 * @description
	 * When is the next Tuesday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Tuesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Tuesday after Mar, 22, 2020?
	 * const result = nextTuesday(new Date(2020, 2, 22))
	 * //=> Tue Mar 24 2020 00:00:00
	 */
	function nextTuesday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)((0, _index3.default)(date), 2);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextWednesday;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = _interopRequireDefault(__webpack_require__(64));
	
	var _index3 = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name nextWednesday
	 * @category Weekday Helpers
	 * @summary When is the next Wednesday?
	 *
	 * @description
	 * When is the next Wednesday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Wednesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Wednesday after Mar, 22, 2020?
	 * const result = nextWednesday(new Date(2020, 2, 22))
	 * //=> Wed Mar 25 2020 00:00:00
	 */
	function nextWednesday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)((0, _index3.default)(date), 3);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseISO;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_HOUR = 3600000;
	var MILLISECONDS_IN_MINUTE = 60000;
	var DEFAULT_ADDITIONAL_DIGITS = 2;
	var patterns = {
	  dateTimeDelimiter: /[T ]/,
	  timeZoneDelimiter: /[Z ]/i,
	  timezone: /([Z+-].*)$/
	};
	var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
	var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
	var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
	/**
	 * @name parseISO
	 * @category Common Helpers
	 * @summary Parse ISO string
	 *
	 * @description
	 * Parse the given string in ISO 8601 format and return an instance of Date.
	 *
	 * Function accepts complete ISO 8601 formats as well as partial implementations.
	 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
	 *
	 * If the argument isn't a string, the function cannot parse the string or
	 * the values are invalid, it returns Invalid Date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The previous `parse` implementation was renamed to `parseISO`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   parse('2016-01-01')
	 *
	 *   // v2.0.0 onward
	 *   parseISO('2016-01-01')
	 *   ```
	 *
	 * - `parseISO` now validates separate date and time values in ISO-8601 strings
	 *   and returns `Invalid Date` if the date is invalid.
	 *
	 *   ```javascript
	 *   parseISO('2018-13-32')
	 *   //=> Invalid Date
	 *   ```
	 *
	 * - `parseISO` now doesn't fall back to `new Date` constructor
	 *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
	 *
	 * @param {String} argument - the value to convert
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Convert string '2014-02-11T11:30:30' to date:
	 * var result = parseISO('2014-02-11T11:30:30')
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert string '+02014101' to date,
	 * // if the additional number of digits in the extended year format is 1:
	 * var result = parseISO('+02014101', { additionalDigits: 1 })
	 * //=> Fri Apr 11 2014 00:00:00
	 */
	
	function parseISO(argument, dirtyOptions) {
	  (0, _index2.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : (0, _index.default)(options.additionalDigits);
	
	  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
	    throw new RangeError('additionalDigits must be 0, 1 or 2');
	  }
	
	  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
	    return new Date(NaN);
	  }
	
	  var dateStrings = splitDateString(argument);
	  var date;
	
	  if (dateStrings.date) {
	    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
	    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
	  }
	
	  if (isNaN(date) || !date) {
	    return new Date(NaN);
	  }
	
	  var timestamp = date.getTime();
	  var time = 0;
	  var offset;
	
	  if (dateStrings.time) {
	    time = parseTime(dateStrings.time);
	
	    if (isNaN(time) || time === null) {
	      return new Date(NaN);
	    }
	  }
	
	  if (dateStrings.timezone) {
	    offset = parseTimezone(dateStrings.timezone);
	
	    if (isNaN(offset)) {
	      return new Date(NaN);
	    }
	  } else {
	    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
	    // but we need it to be parsed in our timezone
	    // so we use utc values to build date in our timezone.
	    // Year values from 0 to 99 map to the years 1900 to 1999
	    // so set year explicitly with setFullYear.
	
	    var result = new Date(0);
	    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
	    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
	    return result;
	  }
	
	  return new Date(timestamp + time + offset);
	}
	
	function splitDateString(dateString) {
	  var dateStrings = {};
	  var array = dateString.split(patterns.dateTimeDelimiter);
	  var timeString; // The regex match should only return at maximum two array elements.
	  // [date], [time], or [date, time].
	
	  if (array.length > 2) {
	    return dateStrings;
	  }
	
	  if (/:/.test(array[0])) {
	    dateStrings.date = null;
	    timeString = array[0];
	  } else {
	    dateStrings.date = array[0];
	    timeString = array[1];
	
	    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
	      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
	      timeString = dateString.substr(dateStrings.date.length, dateString.length);
	    }
	  }
	
	  if (timeString) {
	    var token = patterns.timezone.exec(timeString);
	
	    if (token) {
	      dateStrings.time = timeString.replace(token[1], '');
	      dateStrings.timezone = token[1];
	    } else {
	      dateStrings.time = timeString;
	    }
	  }
	
	  return dateStrings;
	}
	
	function parseYear(dateString, additionalDigits) {
	  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
	  var captures = dateString.match(regex); // Invalid ISO-formatted year
	
	  if (!captures) return {
	    year: null
	  };
	  var year = captures[1] && parseInt(captures[1]);
	  var century = captures[2] && parseInt(captures[2]);
	  return {
	    year: century == null ? year : century * 100,
	    restDateString: dateString.slice((captures[1] || captures[2]).length)
	  };
	}
	
	function parseDate(dateString, year) {
	  // Invalid ISO-formatted year
	  if (year === null) return null;
	  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string
	
	  if (!captures) return null;
	  var isWeekDate = !!captures[4];
	  var dayOfYear = parseDateUnit(captures[1]);
	  var month = parseDateUnit(captures[2]) - 1;
	  var day = parseDateUnit(captures[3]);
	  var week = parseDateUnit(captures[4]);
	  var dayOfWeek = parseDateUnit(captures[5]) - 1;
	
	  if (isWeekDate) {
	    if (!validateWeekDate(year, week, dayOfWeek)) {
	      return new Date(NaN);
	    }
	
	    return dayOfISOWeekYear(year, week, dayOfWeek);
	  } else {
	    var date = new Date(0);
	
	    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
	      return new Date(NaN);
	    }
	
	    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
	    return date;
	  }
	}
	
	function parseDateUnit(value) {
	  return value ? parseInt(value) : 1;
	}
	
	function parseTime(timeString) {
	  var captures = timeString.match(timeRegex);
	  if (!captures) return null; // Invalid ISO-formatted time
	
	  var hours = parseTimeUnit(captures[1]);
	  var minutes = parseTimeUnit(captures[2]);
	  var seconds = parseTimeUnit(captures[3]);
	
	  if (!validateTime(hours, minutes, seconds)) {
	    return NaN;
	  }
	
	  return hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
	}
	
	function parseTimeUnit(value) {
	  return value && parseFloat(value.replace(',', '.')) || 0;
	}
	
	function parseTimezone(timezoneString) {
	  if (timezoneString === 'Z') return 0;
	  var captures = timezoneString.match(timezoneRegex);
	  if (!captures) return 0;
	  var sign = captures[1] === '+' ? -1 : 1;
	  var hours = parseInt(captures[2]);
	  var minutes = captures[3] && parseInt(captures[3]) || 0;
	
	  if (!validateTimezone(hours, minutes)) {
	    return NaN;
	  }
	
	  return sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE);
	}
	
	function dayOfISOWeekYear(isoWeekYear, week, day) {
	  var date = new Date(0);
	  date.setUTCFullYear(isoWeekYear, 0, 4);
	  var fourthOfJanuaryDay = date.getUTCDay() || 7;
	  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	} // Validation functions
	// February is null to handle the leap year (using ||)
	
	
	var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	function isLeapYearIndex(year) {
	  return year % 400 === 0 || year % 4 === 0 && year % 100;
	}
	
	function validateDate(year, month, date) {
	  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
	}
	
	function validateDayOfYearDate(year, dayOfYear) {
	  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
	}
	
	function validateWeekDate(_year, week, day) {
	  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
	}
	
	function validateTime(hours, minutes, seconds) {
	  if (hours === 24) {
	    return minutes === 0 && seconds === 0;
	  }
	
	  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
	}
	
	function validateTimezone(_hours, minutes) {
	  return minutes >= 0 && minutes <= 59;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseJSON;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name parseJSON
	 * @category Common Helpers
	 * @summary Parse a JSON date string
	 *
	 * @description
	 * Converts a complete ISO date string in UTC time, the typical format for transmitting
	 * a date in JSON, to a JavaScript `Date` instance.
	 *
	 * This is a minimal implementation for converting dates retrieved from a JSON API to
	 * a `Date` instance which can be used with other functions in the `date-fns` library.
	 * The following formats are supported:
	 *
	 * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
	 * - `2000-03-15T05:20:10Z`: Without milliseconds
	 * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
	 * - `2000-03-15T05:20:10+05:45`: With a positive or negative offset, the default JSON encoded format in some other languages
	 * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
	 * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
	 * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
	 * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
	 *
	 * For convenience and ease of use these other input types are also supported
	 * via [toDate]{@link https://date-fns.org/docs/toDate}:
	 *
	 * - A `Date` instance will be cloned
	 * - A `number` will be treated as a timestamp
	 *
	 * Any other input type or invalid date strings will return an `Invalid Date`.
	 *
	 * @param {String|Number|Date} argument A fully formed ISO8601 date string to convert
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 */
	function parseJSON(argument) {
	  (0, _index2.default)(1, arguments);
	
	  if (typeof argument === 'string') {
	    var parts = argument.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
	
	    if (parts) {
	      // Group 8 matches the sign
	      return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == '-' ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == '-' ? -1 : 1), +parts[6], +((parts[7] || '0') + '00').substring(0, 3)));
	    }
	
	    return new Date(NaN);
	  }
	
	  return (0, _index.default)(argument);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(199));
	
	var _index2 = _interopRequireDefault(__webpack_require__(867));
	
	var _index3 = _interopRequireDefault(__webpack_require__(868));
	
	var _index4 = _interopRequireDefault(__webpack_require__(869));
	
	var _index5 = _interopRequireDefault(__webpack_require__(870));
	
	var _index6 = _interopRequireDefault(__webpack_require__(133));
	
	var _index7 = _interopRequireDefault(__webpack_require__(109));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_HOUR = 3600000;
	var MILLISECONDS_IN_MINUTE = 60000;
	var MILLISECONDS_IN_SECOND = 1000;
	var numericPatterns = {
	  month: /^(1[0-2]|0?\d)/,
	  // 0 to 12
	  date: /^(3[0-1]|[0-2]?\d)/,
	  // 0 to 31
	  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
	  // 0 to 366
	  week: /^(5[0-3]|[0-4]?\d)/,
	  // 0 to 53
	  hour23h: /^(2[0-3]|[0-1]?\d)/,
	  // 0 to 23
	  hour24h: /^(2[0-4]|[0-1]?\d)/,
	  // 0 to 24
	  hour11h: /^(1[0-1]|0?\d)/,
	  // 0 to 11
	  hour12h: /^(1[0-2]|0?\d)/,
	  // 0 to 12
	  minute: /^[0-5]?\d/,
	  // 0 to 59
	  second: /^[0-5]?\d/,
	  // 0 to 59
	  singleDigit: /^\d/,
	  // 0 to 9
	  twoDigits: /^\d{1,2}/,
	  // 0 to 99
	  threeDigits: /^\d{1,3}/,
	  // 0 to 999
	  fourDigits: /^\d{1,4}/,
	  // 0 to 9999
	  anyDigitsSigned: /^-?\d+/,
	  singleDigitSigned: /^-?\d/,
	  // 0 to 9, -0 to -9
	  twoDigitsSigned: /^-?\d{1,2}/,
	  // 0 to 99, -0 to -99
	  threeDigitsSigned: /^-?\d{1,3}/,
	  // 0 to 999, -0 to -999
	  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
	
	};
	var timezonePatterns = {
	  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
	  basic: /^([+-])(\d{2})(\d{2})|Z/,
	  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
	  extended: /^([+-])(\d{2}):(\d{2})|Z/,
	  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
	};
	
	function parseNumericPattern(pattern, string, valueCallback) {
	  var matchResult = string.match(pattern);
	
	  if (!matchResult) {
	    return null;
	  }
	
	  var value = parseInt(matchResult[0], 10);
	  return {
	    value: valueCallback ? valueCallback(value) : value,
	    rest: string.slice(matchResult[0].length)
	  };
	}
	
	function parseTimezonePattern(pattern, string) {
	  var matchResult = string.match(pattern);
	
	  if (!matchResult) {
	    return null;
	  } // Input is 'Z'
	
	
	  if (matchResult[0] === 'Z') {
	    return {
	      value: 0,
	      rest: string.slice(1)
	    };
	  }
	
	  var sign = matchResult[1] === '+' ? 1 : -1;
	  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
	  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
	  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
	  return {
	    value: sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * MILLISECONDS_IN_SECOND),
	    rest: string.slice(matchResult[0].length)
	  };
	}
	
	function parseAnyDigitsSigned(string, valueCallback) {
	  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
	}
	
	function parseNDigits(n, string, valueCallback) {
	  switch (n) {
	    case 1:
	      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);
	
	    case 2:
	      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);
	
	    case 3:
	      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);
	
	    case 4:
	      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);
	
	    default:
	      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
	  }
	}
	
	function parseNDigitsSigned(n, string, valueCallback) {
	  switch (n) {
	    case 1:
	      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);
	
	    case 2:
	      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);
	
	    case 3:
	      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);
	
	    case 4:
	      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);
	
	    default:
	      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
	  }
	}
	
	function dayPeriodEnumToHours(enumValue) {
	  switch (enumValue) {
	    case 'morning':
	      return 4;
	
	    case 'evening':
	      return 17;
	
	    case 'pm':
	    case 'noon':
	    case 'afternoon':
	      return 12;
	
	    case 'am':
	    case 'midnight':
	    case 'night':
	    default:
	      return 0;
	  }
	}
	
	function normalizeTwoDigitYear(twoDigitYear, currentYear) {
	  var isCommonEra = currentYear > 0; // Absolute number of the current year:
	  // 1 -> 1 AC
	  // 0 -> 1 BC
	  // -1 -> 2 BC
	
	  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
	  var result;
	
	  if (absCurrentYear <= 50) {
	    result = twoDigitYear || 100;
	  } else {
	    var rangeEnd = absCurrentYear + 50;
	    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
	    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
	    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
	  }
	
	  return isCommonEra ? result : 1 - result;
	}
	
	var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation
	
	function isLeapYearIndex(year) {
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
	}
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
	 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
	 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
	 * |  d  | Day of month                   |  D  | Day of year                    |
	 * |  e  | Local day of week              |  E  | Day of week                    |
	 * |  f  |                                |  F* | Day of week in month           |
	 * |  g* | Modified Julian day            |  G  | Era                            |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  i! | ISO day of week                |  I! | ISO week of year               |
	 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
	 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
	 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  n  |                                |  N  |                                |
	 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
	 * |  p  |                                |  P  |                                |
	 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
	 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
	 * |  u  | Extended year                  |  U* | Cyclic year                    |
	 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
	 * |  w  | Local week of year             |  W* | Week of month                  |
	 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
	 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
	 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 *
	 * Letters marked by ! are non-standard, but implemented by date-fns:
	 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
	 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
	 *   i.e. 7 for Sunday, 1 for Monday, etc.
	 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
	 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
	 *   `R` is supposed to be used in conjunction with `I` and `i`
	 *   for universal ISO week-numbering date, whereas
	 *   `Y` is supposed to be used in conjunction with `w` and `e`
	 *   for week-numbering date specific to the locale.
	 */
	
	
	var parsers = {
	  // Era
	  G: {
	    priority: 140,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // AD, BC
	        case 'G':
	        case 'GG':
	        case 'GGG':
	          return match.era(string, {
	            width: 'abbreviated'
	          }) || match.era(string, {
	            width: 'narrow'
	          });
	        // A, B
	
	        case 'GGGGG':
	          return match.era(string, {
	            width: 'narrow'
	          });
	        // Anno Domini, Before Christ
	
	        case 'GGGG':
	        default:
	          return match.era(string, {
	            width: 'wide'
	          }) || match.era(string, {
	            width: 'abbreviated'
	          }) || match.era(string, {
	            width: 'narrow'
	          });
	      }
	    },
	    set: function (date, flags, value, _options) {
	      flags.era = value;
	      date.setUTCFullYear(value, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['R', 'u', 't', 'T']
	  },
	  // Year
	  y: {
	    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
	    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
	    // |----------|-------|----|-------|-------|-------|
	    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
	    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
	    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
	    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
	    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
	    priority: 130,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (year) {
	        return {
	          year: year,
	          isTwoDigitYear: token === 'yy'
	        };
	      };
	
	      switch (token) {
	        case 'y':
	          return parseNDigits(4, string, valueCallback);
	
	        case 'yo':
	          return match.ordinalNumber(string, {
	            unit: 'year',
	            valueCallback: valueCallback
	          });
	
	        default:
	          return parseNDigits(token.length, string, valueCallback);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value.isTwoDigitYear || value.year > 0;
	    },
	    set: function (date, flags, value, _options) {
	      var currentYear = date.getUTCFullYear();
	
	      if (value.isTwoDigitYear) {
	        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
	        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
	        date.setUTCHours(0, 0, 0, 0);
	        return date;
	      }
	
	      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
	      date.setUTCFullYear(year, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']
	  },
	  // Local week-numbering year
	  Y: {
	    priority: 130,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (year) {
	        return {
	          year: year,
	          isTwoDigitYear: token === 'YY'
	        };
	      };
	
	      switch (token) {
	        case 'Y':
	          return parseNDigits(4, string, valueCallback);
	
	        case 'Yo':
	          return match.ordinalNumber(string, {
	            unit: 'year',
	            valueCallback: valueCallback
	          });
	
	        default:
	          return parseNDigits(token.length, string, valueCallback);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value.isTwoDigitYear || value.year > 0;
	    },
	    set: function (date, flags, value, options) {
	      var currentYear = (0, _index.default)(date, options);
	
	      if (value.isTwoDigitYear) {
	        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
	        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
	        date.setUTCHours(0, 0, 0, 0);
	        return (0, _index7.default)(date, options);
	      }
	
	      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
	      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
	      date.setUTCHours(0, 0, 0, 0);
	      return (0, _index7.default)(date, options);
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
	  },
	  // ISO week-numbering year
	  R: {
	    priority: 130,
	    parse: function (string, token, _match, _options) {
	      if (token === 'R') {
	        return parseNDigitsSigned(4, string);
	      }
	
	      return parseNDigitsSigned(token.length, string);
	    },
	    set: function (_date, _flags, value, _options) {
	      var firstWeekOfYear = new Date(0);
	      firstWeekOfYear.setUTCFullYear(value, 0, 4);
	      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
	      return (0, _index6.default)(firstWeekOfYear);
	    },
	    incompatibleTokens: ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
	  },
	  // Extended year
	  u: {
	    priority: 130,
	    parse: function (string, token, _match, _options) {
	      if (token === 'u') {
	        return parseNDigitsSigned(4, string);
	      }
	
	      return parseNDigitsSigned(token.length, string);
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCFullYear(value, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']
	  },
	  // Quarter
	  Q: {
	    priority: 120,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // 1, 2, 3, 4
	        case 'Q':
	        case 'QQ':
	          // 01, 02, 03, 04
	          return parseNDigits(token.length, string);
	        // 1st, 2nd, 3rd, 4th
	
	        case 'Qo':
	          return match.ordinalNumber(string, {
	            unit: 'quarter'
	          });
	        // Q1, Q2, Q3, Q4
	
	        case 'QQQ':
	          return match.quarter(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	        case 'QQQQQ':
	          return match.quarter(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // 1st quarter, 2nd quarter, ...
	
	        case 'QQQQ':
	        default:
	          return match.quarter(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.quarter(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 4;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth((value - 1) * 3, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Stand-alone quarter
	  q: {
	    priority: 120,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // 1, 2, 3, 4
	        case 'q':
	        case 'qq':
	          // 01, 02, 03, 04
	          return parseNDigits(token.length, string);
	        // 1st, 2nd, 3rd, 4th
	
	        case 'qo':
	          return match.ordinalNumber(string, {
	            unit: 'quarter'
	          });
	        // Q1, Q2, Q3, Q4
	
	        case 'qqq':
	          return match.quarter(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	        case 'qqqqq':
	          return match.quarter(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // 1st quarter, 2nd quarter, ...
	
	        case 'qqqq':
	        default:
	          return match.quarter(string, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.quarter(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 4;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth((value - 1) * 3, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Month
	  M: {
	    priority: 110,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (value) {
	        return value - 1;
	      };
	
	      switch (token) {
	        // 1, 2, ..., 12
	        case 'M':
	          return parseNumericPattern(numericPatterns.month, string, valueCallback);
	        // 01, 02, ..., 12
	
	        case 'MM':
	          return parseNDigits(2, string, valueCallback);
	        // 1st, 2nd, ..., 12th
	
	        case 'Mo':
	          return match.ordinalNumber(string, {
	            unit: 'month',
	            valueCallback: valueCallback
	          });
	        // Jan, Feb, ..., Dec
	
	        case 'MMM':
	          return match.month(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // J, F, ..., D
	
	        case 'MMMMM':
	          return match.month(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // January, February, ..., December
	
	        case 'MMMM':
	        default:
	          return match.month(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.month(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 11;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth(value, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Stand-alone month
	  L: {
	    priority: 110,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (value) {
	        return value - 1;
	      };
	
	      switch (token) {
	        // 1, 2, ..., 12
	        case 'L':
	          return parseNumericPattern(numericPatterns.month, string, valueCallback);
	        // 01, 02, ..., 12
	
	        case 'LL':
	          return parseNDigits(2, string, valueCallback);
	        // 1st, 2nd, ..., 12th
	
	        case 'Lo':
	          return match.ordinalNumber(string, {
	            unit: 'month',
	            valueCallback: valueCallback
	          });
	        // Jan, Feb, ..., Dec
	
	        case 'LLL':
	          return match.month(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // J, F, ..., D
	
	        case 'LLLLL':
	          return match.month(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // January, February, ..., December
	
	        case 'LLLL':
	        default:
	          return match.month(string, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.month(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 11;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth(value, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Local week of year
	  w: {
	    priority: 100,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'w':
	          return parseNumericPattern(numericPatterns.week, string);
	
	        case 'wo':
	          return match.ordinalNumber(string, {
	            unit: 'week'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 53;
	    },
	    set: function (date, _flags, value, options) {
	      return (0, _index7.default)((0, _index5.default)(date, value, options), options);
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
	  },
	  // ISO week of year
	  I: {
	    priority: 100,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'I':
	          return parseNumericPattern(numericPatterns.week, string);
	
	        case 'Io':
	          return match.ordinalNumber(string, {
	            unit: 'week'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 53;
	    },
	    set: function (date, _flags, value, options) {
	      return (0, _index6.default)((0, _index4.default)(date, value, options), options);
	    },
	    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
	  },
	  // Day of the month
	  d: {
	    priority: 90,
	    subPriority: 1,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'd':
	          return parseNumericPattern(numericPatterns.date, string);
	
	        case 'do':
	          return match.ordinalNumber(string, {
	            unit: 'date'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (date, value, _options) {
	      var year = date.getUTCFullYear();
	      var isLeapYear = isLeapYearIndex(year);
	      var month = date.getUTCMonth();
	
	      if (isLeapYear) {
	        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
	      } else {
	        return value >= 1 && value <= DAYS_IN_MONTH[month];
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCDate(value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Day of year
	  D: {
	    priority: 90,
	    subPriority: 1,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'D':
	        case 'DD':
	          return parseNumericPattern(numericPatterns.dayOfYear, string);
	
	        case 'Do':
	          return match.ordinalNumber(string, {
	            unit: 'date'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (date, value, _options) {
	      var year = date.getUTCFullYear();
	      var isLeapYear = isLeapYearIndex(year);
	
	      if (isLeapYear) {
	        return value >= 1 && value <= 366;
	      } else {
	        return value >= 1 && value <= 365;
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth(0, value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']
	  },
	  // Day of week
	  E: {
	    priority: 90,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // Tue
	        case 'E':
	        case 'EE':
	        case 'EEE':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // T
	
	        case 'EEEEE':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tu
	
	        case 'EEEEEE':
	          return match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tuesday
	
	        case 'EEEE':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 6;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index2.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Local day of week
	  e: {
	    priority: 90,
	    parse: function (string, token, match, options) {
	      var valueCallback = function (value) {
	        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
	        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
	      };
	
	      switch (token) {
	        // 3
	        case 'e':
	        case 'ee':
	          // 03
	          return parseNDigits(token.length, string, valueCallback);
	        // 3rd
	
	        case 'eo':
	          return match.ordinalNumber(string, {
	            unit: 'day',
	            valueCallback: valueCallback
	          });
	        // Tue
	
	        case 'eee':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // T
	
	        case 'eeeee':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tu
	
	        case 'eeeeee':
	          return match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tuesday
	
	        case 'eeee':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 6;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index2.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']
	  },
	  // Stand-alone local day of week
	  c: {
	    priority: 90,
	    parse: function (string, token, match, options) {
	      var valueCallback = function (value) {
	        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
	        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
	      };
	
	      switch (token) {
	        // 3
	        case 'c':
	        case 'cc':
	          // 03
	          return parseNDigits(token.length, string, valueCallback);
	        // 3rd
	
	        case 'co':
	          return match.ordinalNumber(string, {
	            unit: 'day',
	            valueCallback: valueCallback
	          });
	        // Tue
	
	        case 'ccc':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // T
	
	        case 'ccccc':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // Tu
	
	        case 'cccccc':
	          return match.day(string, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // Tuesday
	
	        case 'cccc':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 6;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index2.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']
	  },
	  // ISO day of week
	  i: {
	    priority: 90,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (value) {
	        if (value === 0) {
	          return 7;
	        }
	
	        return value;
	      };
	
	      switch (token) {
	        // 2
	        case 'i':
	        case 'ii':
	          // 02
	          return parseNDigits(token.length, string);
	        // 2nd
	
	        case 'io':
	          return match.ordinalNumber(string, {
	            unit: 'day'
	          });
	        // Tue
	
	        case 'iii':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	        // T
	
	        case 'iiiii':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	        // Tu
	
	        case 'iiiiii':
	          return match.day(string, {
	            width: 'short',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	        // Tuesday
	
	        case 'iiii':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 7;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index3.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']
	  },
	  // AM or PM
	  a: {
	    priority: 80,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'a':
	        case 'aa':
	        case 'aaa':
	          return match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'aaaaa':
	          return match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'aaaa':
	        default:
	          return match.dayPeriod(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['b', 'B', 'H', 'K', 'k', 't', 'T']
	  },
	  // AM, PM, midnight
	  b: {
	    priority: 80,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'b':
	        case 'bb':
	        case 'bbb':
	          return match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'bbbbb':
	          return match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'bbbb':
	        default:
	          return match.dayPeriod(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'B', 'H', 'K', 'k', 't', 'T']
	  },
	  // in the morning, in the afternoon, in the evening, at night
	  B: {
	    priority: 80,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'B':
	        case 'BB':
	        case 'BBB':
	          return match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'BBBBB':
	          return match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'BBBB':
	        default:
	          return match.dayPeriod(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 't', 'T']
	  },
	  // Hour [1-12]
	  h: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'h':
	          return parseNumericPattern(numericPatterns.hour12h, string);
	
	        case 'ho':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 12;
	    },
	    set: function (date, _flags, value, _options) {
	      var isPM = date.getUTCHours() >= 12;
	
	      if (isPM && value < 12) {
	        date.setUTCHours(value + 12, 0, 0, 0);
	      } else if (!isPM && value === 12) {
	        date.setUTCHours(0, 0, 0, 0);
	      } else {
	        date.setUTCHours(value, 0, 0, 0);
	      }
	
	      return date;
	    },
	    incompatibleTokens: ['H', 'K', 'k', 't', 'T']
	  },
	  // Hour [0-23]
	  H: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'H':
	          return parseNumericPattern(numericPatterns.hour23h, string);
	
	        case 'Ho':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 23;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(value, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T']
	  },
	  // Hour [0-11]
	  K: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'K':
	          return parseNumericPattern(numericPatterns.hour11h, string);
	
	        case 'Ko':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 11;
	    },
	    set: function (date, _flags, value, _options) {
	      var isPM = date.getUTCHours() >= 12;
	
	      if (isPM && value < 12) {
	        date.setUTCHours(value + 12, 0, 0, 0);
	      } else {
	        date.setUTCHours(value, 0, 0, 0);
	      }
	
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 'h', 'H', 'k', 't', 'T']
	  },
	  // Hour [1-24]
	  k: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'k':
	          return parseNumericPattern(numericPatterns.hour24h, string);
	
	        case 'ko':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 24;
	    },
	    set: function (date, _flags, value, _options) {
	      var hours = value <= 24 ? value % 24 : value;
	      date.setUTCHours(hours, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T']
	  },
	  // Minute
	  m: {
	    priority: 60,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'm':
	          return parseNumericPattern(numericPatterns.minute, string);
	
	        case 'mo':
	          return match.ordinalNumber(string, {
	            unit: 'minute'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 59;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMinutes(value, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['t', 'T']
	  },
	  // Second
	  s: {
	    priority: 50,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 's':
	          return parseNumericPattern(numericPatterns.second, string);
	
	        case 'so':
	          return match.ordinalNumber(string, {
	            unit: 'second'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 59;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCSeconds(value, 0);
	      return date;
	    },
	    incompatibleTokens: ['t', 'T']
	  },
	  // Fraction of second
	  S: {
	    priority: 30,
	    parse: function (string, token, _match, _options) {
	      var valueCallback = function (value) {
	        return Math.floor(value * Math.pow(10, -token.length + 3));
	      };
	
	      return parseNDigits(token.length, string, valueCallback);
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMilliseconds(value);
	      return date;
	    },
	    incompatibleTokens: ['t', 'T']
	  },
	  // Timezone (ISO-8601. +00:00 is `'Z'`)
	  X: {
	    priority: 10,
	    parse: function (string, token, _match, _options) {
	      switch (token) {
	        case 'X':
	          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);
	
	        case 'XX':
	          return parseTimezonePattern(timezonePatterns.basic, string);
	
	        case 'XXXX':
	          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);
	
	        case 'XXXXX':
	          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);
	
	        case 'XXX':
	        default:
	          return parseTimezonePattern(timezonePatterns.extended, string);
	      }
	    },
	    set: function (date, flags, value, _options) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	
	      return new Date(date.getTime() - value);
	    },
	    incompatibleTokens: ['t', 'T', 'x']
	  },
	  // Timezone (ISO-8601)
	  x: {
	    priority: 10,
	    parse: function (string, token, _match, _options) {
	      switch (token) {
	        case 'x':
	          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);
	
	        case 'xx':
	          return parseTimezonePattern(timezonePatterns.basic, string);
	
	        case 'xxxx':
	          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);
	
	        case 'xxxxx':
	          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);
	
	        case 'xxx':
	        default:
	          return parseTimezonePattern(timezonePatterns.extended, string);
	      }
	    },
	    set: function (date, flags, value, _options) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	
	      return new Date(date.getTime() - value);
	    },
	    incompatibleTokens: ['t', 'T', 'X']
	  },
	  // Seconds timestamp
	  t: {
	    priority: 40,
	    parse: function (string, _token, _match, _options) {
	      return parseAnyDigitsSigned(string);
	    },
	    set: function (_date, _flags, value, _options) {
	      return [new Date(value * 1000), {
	        timestampIsSet: true
	      }];
	    },
	    incompatibleTokens: '*'
	  },
	  // Milliseconds timestamp
	  T: {
	    priority: 20,
	    parse: function (string, _token, _match, _options) {
	      return parseAnyDigitsSigned(string);
	    },
	    set: function (_date, _flags, value, _options) {
	      return [new Date(value), {
	        timestampIsSet: true
	      }];
	    },
	    incompatibleTokens: '*'
	  }
	};
	var _default = parsers;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousFriday;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = _interopRequireDefault(__webpack_require__(65));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name previousFriday
	 * @category Weekday Helpers
	 * @summary When is the previous Friday?
	 *
	 * @description
	 * When is the previous Friday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Friday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Friday before Jun, 19, 2021?
	 * const result = previousFriday(new Date(2021, 5, 19))
	 * //=> Fri June 18 2021 00:00:00
	 */
	function previousFriday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 5);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousMonday;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = _interopRequireDefault(__webpack_require__(65));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name previousMonday
	 * @category Weekday Helpers
	 * @summary When is the previous Monday?
	 *
	 * @description
	 * When is the previous Monday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Monday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Monday before Jun, 18, 2021?
	 * const result = previousMonday(new Date(2021, 5, 18))
	 * //=> Mon June 14 2021 00:00:00
	 */
	function previousMonday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 1);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousSaturday;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = _interopRequireDefault(__webpack_require__(65));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name previousSaturday
	 * @category Weekday Helpers
	 * @summary When is the previous Saturday?
	 *
	 * @description
	 * When is the previous Saturday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Saturday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Saturday before Jun, 20, 2021?
	 * const result = previousSaturday(new Date(2021, 5, 20))
	 * //=> Sat June 19 2021 00:00:00
	 */
	function previousSaturday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 6);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousSunday;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = _interopRequireDefault(__webpack_require__(65));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name previousSunday
	 * @category Weekday Helpers
	 * @summary When is the previous Sunday?
	 *
	 * @description
	 * When is the previous Sunday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Sunday before Jun, 21, 2021?
	 * const result = previousSunday(new Date(2021, 5, 21))
	 * //=> Sun June 20 2021 00:00:00
	 */
	function previousSunday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 0);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousThursday;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = _interopRequireDefault(__webpack_require__(65));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name previousThursday
	 * @category Weekday Helpers
	 * @summary When is the previous Thursday?
	 *
	 * @description
	 * When is the previous Thursday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Thursday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Thursday before Jun, 18, 2021?
	 * const result = previousThursday(new Date(2021, 5, 18))
	 * //=> Thu June 17 2021 00:00:00
	 */
	function previousThursday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 4);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousTuesday;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = _interopRequireDefault(__webpack_require__(65));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name previousTuesday
	 * @category Weekday Helpers
	 * @summary When is the previous Tuesday?
	 *
	 * @description
	 * When is the previous Tuesday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Tuesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Tuesday before Jun, 18, 2021?
	 * const result = previousTuesday(new Date(2021, 5, 18))
	 * //=> Tue June 15 2021 00:00:00
	 */
	function previousTuesday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 2);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousWednesday;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = _interopRequireDefault(__webpack_require__(65));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name previousWednesday
	 * @category Weekday Helpers
	 * @summary When is the previous Wednesday?
	 *
	 * @description
	 * When is the previous Wednesday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Wednesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Wednesday before Jun, 18, 2021?
	 * const result = previousWednesday(new Date(2021, 5, 18))
	 * //=> Wed June 16 2021 00:00:00
	 */
	function previousWednesday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 3);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = quartersToMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name quartersToMonths
	 * @category Conversion Helpers
	 * @summary Convert number of quarters to months.
	 *
	 * @description
	 * Convert a number of quarters to a full number of months.
	 *
	 * @param {number} quarters - number of quarters to be converted
	 *
	 * @returns {number} the number of quarters converted in months
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 quarters to months
	 * const result = quartersToMonths(2)
	 * //=> 6
	 */
	function quartersToMonths(quarters) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(quarters * _index2.monthsInQuarter);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = quartersToYears;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name quartersToYears
	 * @category Conversion Helpers
	 * @summary Convert number of quarters to years.
	 *
	 * @description
	 * Convert a number of quarters to a full number of years.
	 *
	 * @param {number} quarters - number of quarters to be converted
	 *
	 * @returns {number} the number of quarters converted in years
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 8 quarters to years
	 * const result = quartersToYears(8)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = quartersToYears(11)
	 * //=> 2
	 */
	function quartersToYears(quarters) {
	  (0, _index.default)(1, arguments);
	  var years = quarters / _index2.quartersInYear;
	  return Math.floor(years);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = roundToNearestMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(10));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name roundToNearestMinutes
	 * @category Minute Helpers
	 * @summary Rounds the given date to the nearest minute
	 *
	 * @description
	 * Rounds the given date to the nearest minute (or number of minutes).
	 * Rounds up when the given date is exactly between the nearest round minutes.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to round
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.nearestTo=1] - nearest number of minutes to round to. E.g. `15` to round to quarter hours.
	 * @returns {Date} the new date rounded to the closest minute
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.nearestTo` must be between 1 and 30
	 *
	 * @example
	 * // Round 10 July 2014 12:12:34 to nearest minute:
	 * var result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
	 * //=> Thu Jul 10 2014 12:13:00
	 *
	 * @example
	 * // Round 10 July 2014 12:07:30 to nearest quarter hour:
	 * var result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
	 * // rounds up because given date is exactly between 12:00:00 and 12:15:00
	 * //=> Thu Jul 10 2014 12:15:00
	 */
	function roundToNearestMinutes(dirtyDate, options) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only none provided present');
	  }
	
	  var nearestTo = options && 'nearestTo' in options ? (0, _index2.default)(options.nearestTo) : 1;
	
	  if (nearestTo < 1 || nearestTo > 30) {
	    throw new RangeError('`options.nearestTo` must be between 1 and 30');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var seconds = date.getSeconds(); // relevant if nearestTo is 1, which is the default case
	
	  var minutes = date.getMinutes() + seconds / 60;
	  var roundedMinutes = Math.floor(minutes / nearestTo) * nearestTo;
	  var remainderMinutes = minutes % nearestTo;
	  var addedMinutes = Math.round(remainderMinutes / nearestTo) * nearestTo;
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), roundedMinutes + addedMinutes);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = secondsToHours;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name secondsToHours
	 * @category Conversion Helpers
	 * @summary Convert seconds to hours.
	 *
	 * @description
	 * Convert a number of seconds to a full number of hours.
	 *
	 * @param {number} seconds - number of seconds to be converted
	 *
	 * @returns {number} the number of seconds converted in hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 7200 seconds into hours
	 * const result = secondsToHours(7200)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = secondsToHours(7199)
	 * //=> 1
	 */
	function secondsToHours(seconds) {
	  (0, _index.default)(1, arguments);
	  var hours = seconds / _index2.secondsInHour;
	  return Math.floor(hours);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = secondsToMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name secondsToMilliseconds
	 * @category Conversion Helpers
	 * @summary Convert seconds to milliseconds.
	 *
	 * @description
	 * Convert a number of seconds to a full number of milliseconds.
	 *
	 * @param {number} seconds - number of seconds to be converted
	 *
	 * @returns {number} the number of seconds converted in milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 seconds into milliseconds
	 * const result = secondsToMilliseconds(2)
	 * //=> 2000
	 */
	function secondsToMilliseconds(seconds) {
	  (0, _index.default)(1, arguments);
	  return seconds * _index2.millisecondsInSecond;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = secondsToMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name secondsToMinutes
	 * @category Conversion Helpers
	 * @summary Convert seconds to minutes.
	 *
	 * @description
	 * Convert a number of seconds to a full number of minutes.
	 *
	 * @param {number} seconds - number of seconds to be converted
	 *
	 * @returns {number} the number of seconds converted in minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 120 seconds into minutes
	 * const result = secondsToMinutes(120)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = secondsToMinutes(119)
	 * //=> 1
	 */
	function secondsToMinutes(seconds) {
	  (0, _index.default)(1, arguments);
	  var minutes = seconds / _index2.secondsInMinute;
	  return Math.floor(minutes);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setDate;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setDate
	 * @category Day Helpers
	 * @summary Set the day of the month to the given date.
	 *
	 * @description
	 * Set the day of the month to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} dayOfMonth - the day of the month of the new date
	 * @returns {Date} the new date with the day of the month set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 30th day of the month to 1 September 2014:
	 * var result = setDate(new Date(2014, 8, 1), 30)
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function setDate(dirtyDate, dirtyDayOfMonth) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var dayOfMonth = (0, _index.default)(dirtyDayOfMonth);
	  date.setDate(dayOfMonth);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setDayOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setDayOfYear
	 * @category Day Helpers
	 * @summary Set the day of the year to the given date.
	 *
	 * @description
	 * Set the day of the year to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} dayOfYear - the day of the year of the new date
	 * @returns {Date} the new date with the day of the year set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 2nd day of the year to 2 July 2014:
	 * var result = setDayOfYear(new Date(2014, 6, 2), 2)
	 * //=> Thu Jan 02 2014 00:00:00
	 */
	function setDayOfYear(dirtyDate, dirtyDayOfYear) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var dayOfYear = (0, _index.default)(dirtyDayOfYear);
	  date.setMonth(0);
	  date.setDate(dayOfYear);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setDay;
	
	var _index = _interopRequireDefault(__webpack_require__(58));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(10));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setDay
	 * @category Weekday Helpers
	 * @summary Set the day of the week to the given date.
	 *
	 * @description
	 * Set the day of the week to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} day - the day of the week of the new date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the new date with the day of the week set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
	 * var result = setDay(new Date(2014, 8, 1), 0)
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // Set week day to Sunday, with a weekStartsOn of Monday:
	 * var result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function setDay(dirtyDate, dirtyDay, dirtyOptions) {
	  (0, _index4.default)(2, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index3.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index3.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index2.default)(dirtyDate);
	  var day = (0, _index3.default)(dirtyDay);
	  var currentDay = date.getDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var delta = 7 - weekStartsOn;
	  var diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
	  return (0, _index.default)(date, diff);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setHours;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setHours
	 * @category Hour Helpers
	 * @summary Set the hours to the given date.
	 *
	 * @description
	 * Set the hours to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} hours - the hours of the new date
	 * @returns {Date} the new date with the hours set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 4 hours to 1 September 2014 11:30:00:
	 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
	 * //=> Mon Sep 01 2014 04:30:00
	 */
	function setHours(dirtyDate, dirtyHours) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var hours = (0, _index.default)(dirtyHours);
	  date.setHours(hours);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setISODay;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(58));
	
	var _index4 = _interopRequireDefault(__webpack_require__(304));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setISODay
	 * @category Weekday Helpers
	 * @summary Set the day of the ISO week to the given date.
	 *
	 * @description
	 * Set the day of the ISO week to the given date.
	 * ISO week starts with Monday.
	 * 7 is the index of Sunday, 1 is the index of Monday etc.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} day - the day of the ISO week of the new date
	 * @returns {Date} the new date with the day of the ISO week set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set Sunday to 1 September 2014:
	 * const result = setISODay(new Date(2014, 8, 1), 7)
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function setISODay(dirtyDate, dirtyDay) {
	  (0, _index5.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var day = (0, _index.default)(dirtyDay);
	  var currentDay = (0, _index4.default)(date);
	  var diff = day - currentDay;
	  return (0, _index3.default)(date, diff);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(305));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setISOWeek
	 * @category ISO Week Helpers
	 * @summary Set the ISO week to the given date.
	 *
	 * @description
	 * Set the ISO week to the given date, saving the weekday number.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} isoWeek - the ISO week of the new date
	 * @returns {Date} the new date with the ISO week set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 53rd ISO week to 7 August 2004:
	 * const result = setISOWeek(new Date(2004, 7, 7), 53)
	 * //=> Sat Jan 01 2005 00:00:00
	 */
	function setISOWeek(dirtyDate, dirtyISOWeek) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var isoWeek = (0, _index.default)(dirtyISOWeek);
	  var diff = (0, _index3.default)(date) - isoWeek;
	  date.setDate(date.getDate() - diff * 7);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setMilliseconds
	 * @category Millisecond Helpers
	 * @summary Set the milliseconds to the given date.
	 *
	 * @description
	 * Set the milliseconds to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} milliseconds - the milliseconds of the new date
	 * @returns {Date} the new date with the milliseconds set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
	 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
	 * //=> Mon Sep 01 2014 11:30:40.300
	 */
	function setMilliseconds(dirtyDate, dirtyMilliseconds) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var milliseconds = (0, _index.default)(dirtyMilliseconds);
	  date.setMilliseconds(milliseconds);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setMinutes
	 * @category Minute Helpers
	 * @summary Set the minutes to the given date.
	 *
	 * @description
	 * Set the minutes to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} minutes - the minutes of the new date
	 * @returns {Date} the new date with the minutes set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 45 minutes to 1 September 2014 11:30:40:
	 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:45:40
	 */
	function setMinutes(dirtyDate, dirtyMinutes) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var minutes = (0, _index.default)(dirtyMinutes);
	  date.setMinutes(minutes);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(212));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setQuarter
	 * @category Quarter Helpers
	 * @summary Set the year quarter to the given date.
	 *
	 * @description
	 * Set the year quarter to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} quarter - the quarter of the new date
	 * @returns {Date} the new date with the quarter set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 2nd quarter to 2 July 2014:
	 * const result = setQuarter(new Date(2014, 6, 2), 2)
	 * //=> Wed Apr 02 2014 00:00:00
	 */
	function setQuarter(dirtyDate, dirtyQuarter) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var quarter = (0, _index.default)(dirtyQuarter);
	  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
	  var diff = quarter - oldQuarter;
	  return (0, _index3.default)(date, date.getMonth() + diff * 3);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setSeconds
	 * @category Second Helpers
	 * @summary Set the seconds to the given date.
	 *
	 * @description
	 * Set the seconds to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} seconds - the seconds of the new date
	 * @returns {Date} the new date with the seconds set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 45 seconds to 1 September 2014 11:30:40:
	 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:30:45
	 */
	function setSeconds(dirtyDate, dirtySeconds) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var seconds = (0, _index.default)(dirtySeconds);
	  date.setSeconds(seconds);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(76));
	
	var _index2 = _interopRequireDefault(__webpack_require__(215));
	
	var _index3 = _interopRequireDefault(__webpack_require__(4));
	
	var _index4 = _interopRequireDefault(__webpack_require__(10));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setWeekYear
	 * @category Week-Numbering Year Helpers
	 * @summary Set the local week-numbering year to the given date.
	 *
	 * @description
	 * Set the local week-numbering year to the given date,
	 * saving the week number and the weekday number.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} weekYear - the local week-numbering year of the new date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Date} the new date with the local week-numbering year set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
	 * var result = setWeekYear(new Date(2010, 0, 2), 2004)
	 * //=> Sat Jan 03 2004 00:00:00
	 *
	 * @example
	 * // Set the local week-numbering year 2004 to 2 January 2010,
	 * // if Monday is the first day of week
	 * // and 4 January is always in the first week of the year:
	 * var result = setWeekYear(new Date(2010, 0, 2), 2004, {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> Sat Jan 01 2005 00:00:00
	 */
	function setWeekYear(dirtyDate, dirtyWeekYear) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  (0, _index5.default)(2, arguments);
	  var locale = options.locale;
	  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index4.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index4.default)(options.firstWeekContainsDate);
	  var date = (0, _index3.default)(dirtyDate);
	  var weekYear = (0, _index4.default)(dirtyWeekYear);
	  var diff = (0, _index.default)(date, (0, _index2.default)(date, options));
	  var firstWeek = new Date(0);
	  firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
	  firstWeek.setHours(0, 0, 0, 0);
	  date = (0, _index2.default)(firstWeek, options);
	  date.setDate(date.getDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(309));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(10));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setWeek
	 * @category Week Helpers
	 * @summary Set the local week to the given date.
	 *
	 * @description
	 * Set the local week to the given date, saving the weekday number.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} week - the week of the new date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Date} the new date with the local week set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Set the 1st week to 2 January 2005 with default options:
	 * var result = setWeek(new Date(2005, 0, 2), 1)
	 * //=> Sun Dec 26 2004 00:00:00
	 *
	 * @example
	 * // Set the 1st week to 2 January 2005,
	 * // if Monday is the first day of the week,
	 * // and the first week of the year always contains 4 January:
	 * var result = setWeek(new Date(2005, 0, 2), 1, {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> Sun Jan 4 2004 00:00:00
	 */
	function setWeek(dirtyDate, dirtyWeek, options) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var week = (0, _index3.default)(dirtyWeek);
	  var diff = (0, _index.default)(date, options) - week;
	  date.setDate(date.getDate() - diff * 7);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setYear;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setYear
	 * @category Year Helpers
	 * @summary Set the year to the given date.
	 *
	 * @description
	 * Set the year to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} year - the year of the new date
	 * @returns {Date} the new date with the year set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set year 2013 to 1 September 2014:
	 * const result = setYear(new Date(2014, 8, 1), 2013)
	 * //=> Sun Sep 01 2013 00:00:00
	 */
	function setYear(dirtyDate, dirtyYear) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var year = (0, _index.default)(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
	
	  if (isNaN(date.getTime())) {
	    return new Date(NaN);
	  }
	
	  date.setFullYear(year);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = set;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(212));
	
	var _index3 = _interopRequireDefault(__webpack_require__(10));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name set
	 * @category Common Helpers
	 * @summary Set date values to a given date.
	 *
	 * @description
	 * Set date values to a given date.
	 *
	 * Sets time values to date from object `values`.
	 * A value is not set if it is undefined or null or doesn't exist in `values`.
	 *
	 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
	 * to use native `Date#setX` methods. If you use this function, you may not want to include the
	 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Object} values - an object with options
	 * @param {Number} [values.year] - the number of years to be set
	 * @param {Number} [values.month] - the number of months to be set
	 * @param {Number} [values.date] - the number of days to be set
	 * @param {Number} [values.hours] - the number of hours to be set
	 * @param {Number} [values.minutes] - the number of minutes to be set
	 * @param {Number} [values.seconds] - the number of seconds to be set
	 * @param {Number} [values.milliseconds] - the number of milliseconds to be set
	 * @returns {Date} the new date with options set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `values` must be an object
	 *
	 * @example
	 * // Transform 1 September 2014 into 20 October 2015 in a single line:
	 * var result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
	 * //=> Tue Oct 20 2015 00:00:00
	 *
	 * @example
	 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
	 * var result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
	 * //=> Mon Sep 01 2014 12:23:45
	 */
	function set(dirtyDate, values) {
	  (0, _index4.default)(2, arguments);
	
	  if (typeof values !== 'object' || values === null) {
	    throw new RangeError('values parameter must be an object');
	  }
	
	  var date = (0, _index.default)(dirtyDate); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
	
	  if (isNaN(date.getTime())) {
	    return new Date(NaN);
	  }
	
	  if (values.year != null) {
	    date.setFullYear(values.year);
	  }
	
	  if (values.month != null) {
	    date = (0, _index2.default)(date, values.month);
	  }
	
	  if (values.date != null) {
	    date.setDate((0, _index3.default)(values.date));
	  }
	
	  if (values.hours != null) {
	    date.setHours((0, _index3.default)(values.hours));
	  }
	
	  if (values.minutes != null) {
	    date.setMinutes((0, _index3.default)(values.minutes));
	  }
	
	  if (values.seconds != null) {
	    date.setSeconds((0, _index3.default)(values.seconds));
	  }
	
	  if (values.milliseconds != null) {
	    date.setMilliseconds((0, _index3.default)(values.milliseconds));
	  }
	
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfDecade;
	
	var _index = _interopRequireDefault(__webpack_require__(4));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfDecade
	 * @category Decade Helpers
	 * @summary Return the start of a decade for the given date.
	 *
	 * @description
	 * Return the start of a decade for the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a decade
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a decade for 21 October 2015 00:00:00:
	 * const result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
	 * //=> Jan 01 2010 00:00:00
	 */
	function startOfDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = Math.floor(year / 10) * 10;
	  date.setFullYear(decade, 0, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfToday;
	
	var _index = _interopRequireDefault(__webpack_require__(139));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfToday
	 * @category Day Helpers
	 * @summary Return the start of today.
	 * @pure false
	 *
	 * @description
	 * Return the start of today.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the start of today
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = startOfToday()
	 * //=> Mon Oct 6 2014 00:00:00
	 */
	function startOfToday() {
	  return (0, _index.default)(Date.now());
	}
	
	module.exports = exports.default;

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfTomorrow;
	
	/**
	 * @name startOfTomorrow
	 * @category Day Helpers
	 * @summary Return the start of tomorrow.
	 * @pure false
	 *
	 * @description
	 * Return the start of tomorrow.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the start of tomorrow
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * const result = startOfTomorrow()
	 * //=> Tue Oct 7 2014 00:00:00
	 */
	function startOfTomorrow() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day + 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1466 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfYesterday;
	
	/**
	 * @name startOfYesterday
	 * @category Day Helpers
	 * @summary Return the start of yesterday.
	 * @pure false
	 *
	 * @description
	 * Return the start of yesterday.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the start of yesterday
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * const result = startOfYesterday()
	 * //=> Sun Oct 5 2014 00:00:00
	 */
	function startOfYesterday() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day - 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subBusinessDays;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(285));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subBusinessDays
	 * @category Day Helpers
	 * @summary Substract the specified number of business days (mon - fri) to the given date.
	 *
	 * @description
	 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of business days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the business days subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Substract 10 business days from 1 September 2014:
	 * var result = subBusinessDays(new Date(2014, 8, 1), 10)
	 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
	 */
	function subBusinessDays(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subHours;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(200));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subHours
	 * @category Hour Helpers
	 * @summary Subtract the specified number of hours from the given date.
	 *
	 * @description
	 * Subtract the specified number of hours from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the hours subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 2 hours from 11 July 2014 01:00:00:
	 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
	 * //=> Thu Jul 10 2014 23:00:00
	 */
	function subHours(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(201));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subMinutes
	 * @category Minute Helpers
	 * @summary Subtract the specified number of minutes from the given date.
	 *
	 * @description
	 * Subtract the specified number of minutes from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the minutes subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 30 minutes from 10 July 2014 12:00:00:
	 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 11:30:00
	 */
	function subMinutes(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(202));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subQuarters
	 * @category Quarter Helpers
	 * @summary Subtract the specified number of year quarters from the given date.
	 *
	 * @description
	 * Subtract the specified number of year quarters from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of quarters to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the quarters subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 3 quarters from 1 September 2014:
	 * const result = subQuarters(new Date(2014, 8, 1), 3)
	 * //=> Sun Dec 01 2013 00:00:00
	 */
	function subQuarters(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(287));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subSeconds
	 * @category Second Helpers
	 * @summary Subtract the specified number of seconds from the given date.
	 *
	 * @description
	 * Subtract the specified number of seconds from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of seconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the seconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 30 seconds from 10 July 2014 12:45:00:
	 * const result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
	 * //=> Thu Jul 10 2014 12:44:30
	 */
	function subSeconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(134));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subWeeks
	 * @category Week Helpers
	 * @summary Subtract the specified number of weeks from the given date.
	 *
	 * @description
	 * Subtract the specified number of weeks from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the weeks subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 4 weeks from 1 September 2014:
	 * const result = subWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Aug 04 2014 00:00:00
	 */
	function subWeeks(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subYears;
	
	var _index = _interopRequireDefault(__webpack_require__(10));
	
	var _index2 = _interopRequireDefault(__webpack_require__(288));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subYears
	 * @category Year Helpers
	 * @summary Subtract the specified number of years from the given date.
	 *
	 * @description
	 * Subtract the specified number of years from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the years subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 years from 1 September 2014:
	 * const result = subYears(new Date(2014, 8, 1), 5)
	 * //=> Tue Sep 01 2009 00:00:00
	 */
	function subYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = weeksToDays;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name weeksToDays
	 * @category Conversion Helpers
	 * @summary Convert weeks to days.
	 *
	 * @description
	 * Convert a number of weeks to a full number of days.
	 *
	 * @param {number} weeks - number of weeks to be converted
	 *
	 * @returns {number} the number of weeks converted in days
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 weeks into days
	 * const result = weeksToDays(2)
	 * //=> 14
	 */
	function weeksToDays(weeks) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(weeks * _index2.daysInWeek);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = yearsToMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name yearsToMonths
	 * @category Conversion Helpers
	 * @summary Convert years to months.
	 *
	 * @description
	 * Convert a number of years to a full number of months.
	 *
	 * @param {number} years - number of years to be converted
	 *
	 * @returns {number} the number of years converted in months
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 years into months
	 * const result = yearsToMonths(2)
	 * //=> 24
	 */
	function yearsToMonths(years) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(years * _index2.monthsInYear);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = yearsToQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(1));
	
	var _index2 = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name yearsToQuarters
	 * @category Conversion Helpers
	 * @summary Convert years to quarters.
	 *
	 * @description
	 * Convert a number of years to a full number of quarters.
	 *
	 * @param {number} years - number of years to be converted
	 *
	 * @returns {number} the number of years converted in quarters
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 years to quarters
	 * const result = yearsToQuarters(2)
	 * //=> 8
	 */
	function yearsToQuarters(years) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(years * _index2.quartersInYear);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1477 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = earcut;
	module.exports.default = earcut;
	
	function earcut(data, holeIndices, dim) {
	
	    dim = dim || 2;
	
	    var hasHoles = holeIndices && holeIndices.length,
	        outerLen = hasHoles ? holeIndices[0] * dim : data.length,
	        outerNode = linkedList(data, 0, outerLen, dim, true),
	        triangles = [];
	
	    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
	
	    var minX, minY, maxX, maxY, x, y, invSize;
	
	    if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);
	
	    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
	    if (data.length > 80 * dim) {
	        minX = maxX = data[0];
	        minY = maxY = data[1];
	
	        for (var i = dim; i < outerLen; i += dim) {
	            x = data[i];
	            y = data[i + 1];
	            if (x < minX) minX = x;
	            if (y < minY) minY = y;
	            if (x > maxX) maxX = x;
	            if (y > maxY) maxY = y;
	        }
	
	        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
	        invSize = Math.max(maxX - minX, maxY - minY);
	        invSize = invSize !== 0 ? 1 / invSize : 0;
	    }
	
	    earcutLinked(outerNode, triangles, dim, minX, minY, invSize);
	
	    return triangles;
	}
	
	// create a circular doubly linked list from polygon points in the specified winding order
	function linkedList(data, start, end, dim, clockwise) {
	    var i, last;
	
	    if (clockwise === (signedArea(data, start, end, dim) > 0)) {
	        for (i = start; i < end; i += dim) last = insertNode(i, data[i], data[i + 1], last);
	    } else {
	        for (i = end - dim; i >= start; i -= dim) last = insertNode(i, data[i], data[i + 1], last);
	    }
	
	    if (last && equals(last, last.next)) {
	        removeNode(last);
	        last = last.next;
	    }
	
	    return last;
	}
	
	// eliminate colinear or duplicate points
	function filterPoints(start, end) {
	    if (!start) return start;
	    if (!end) end = start;
	
	    var p = start,
	        again;
	    do {
	        again = false;
	
	        if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
	            removeNode(p);
	            p = end = p.prev;
	            if (p === p.next) break;
	            again = true;
	
	        } else {
	            p = p.next;
	        }
	    } while (again || p !== end);
	
	    return end;
	}
	
	// main ear slicing loop which triangulates a polygon (given as a linked list)
	function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
	    if (!ear) return;
	
	    // interlink polygon nodes in z-order
	    if (!pass && invSize) indexCurve(ear, minX, minY, invSize);
	
	    var stop = ear,
	        prev, next;
	
	    // iterate through ears, slicing them one by one
	    while (ear.prev !== ear.next) {
	        prev = ear.prev;
	        next = ear.next;
	
	        if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
	            // cut off the triangle
	            triangles.push(prev.i / dim);
	            triangles.push(ear.i / dim);
	            triangles.push(next.i / dim);
	
	            removeNode(ear);
	
	            // skipping the next vertex leads to less sliver triangles
	            ear = next.next;
	            stop = next.next;
	
	            continue;
	        }
	
	        ear = next;
	
	        // if we looped through the whole remaining polygon and can't find any more ears
	        if (ear === stop) {
	            // try filtering points and slicing again
	            if (!pass) {
	                earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
	
	            // if this didn't work, try curing all small self-intersections locally
	            } else if (pass === 1) {
	                ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
	                earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
	
	            // as a last resort, try splitting the remaining polygon into two
	            } else if (pass === 2) {
	                splitEarcut(ear, triangles, dim, minX, minY, invSize);
	            }
	
	            break;
	        }
	    }
	}
	
	// check whether a polygon node forms a valid ear with adjacent nodes
	function isEar(ear) {
	    var a = ear.prev,
	        b = ear,
	        c = ear.next;
	
	    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
	
	    // now make sure we don't have other points inside the potential ear
	    var p = ear.next.next;
	
	    while (p !== ear.prev) {
	        if (pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) return false;
	        p = p.next;
	    }
	
	    return true;
	}
	
	function isEarHashed(ear, minX, minY, invSize) {
	    var a = ear.prev,
	        b = ear,
	        c = ear.next;
	
	    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
	
	    // triangle bbox; min & max are calculated like this for speed
	    var minTX = a.x < b.x ? (a.x < c.x ? a.x : c.x) : (b.x < c.x ? b.x : c.x),
	        minTY = a.y < b.y ? (a.y < c.y ? a.y : c.y) : (b.y < c.y ? b.y : c.y),
	        maxTX = a.x > b.x ? (a.x > c.x ? a.x : c.x) : (b.x > c.x ? b.x : c.x),
	        maxTY = a.y > b.y ? (a.y > c.y ? a.y : c.y) : (b.y > c.y ? b.y : c.y);
	
	    // z-order range for the current triangle bbox;
	    var minZ = zOrder(minTX, minTY, minX, minY, invSize),
	        maxZ = zOrder(maxTX, maxTY, minX, minY, invSize);
	
	    var p = ear.prevZ,
	        n = ear.nextZ;
	
	    // look for points inside the triangle in both directions
	    while (p && p.z >= minZ && n && n.z <= maxZ) {
	        if (p !== ear.prev && p !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) return false;
	        p = p.prevZ;
	
	        if (n !== ear.prev && n !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) &&
	            area(n.prev, n, n.next) >= 0) return false;
	        n = n.nextZ;
	    }
	
	    // look for remaining points in decreasing z-order
	    while (p && p.z >= minZ) {
	        if (p !== ear.prev && p !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) return false;
	        p = p.prevZ;
	    }
	
	    // look for remaining points in increasing z-order
	    while (n && n.z <= maxZ) {
	        if (n !== ear.prev && n !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) &&
	            area(n.prev, n, n.next) >= 0) return false;
	        n = n.nextZ;
	    }
	
	    return true;
	}
	
	// go through all polygon nodes and cure small local self-intersections
	function cureLocalIntersections(start, triangles, dim) {
	    var p = start;
	    do {
	        var a = p.prev,
	            b = p.next.next;
	
	        if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {
	
	            triangles.push(a.i / dim);
	            triangles.push(p.i / dim);
	            triangles.push(b.i / dim);
	
	            // remove two nodes involved
	            removeNode(p);
	            removeNode(p.next);
	
	            p = start = b;
	        }
	        p = p.next;
	    } while (p !== start);
	
	    return filterPoints(p);
	}
	
	// try splitting polygon into two and triangulate them independently
	function splitEarcut(start, triangles, dim, minX, minY, invSize) {
	    // look for a valid diagonal that divides the polygon into two
	    var a = start;
	    do {
	        var b = a.next.next;
	        while (b !== a.prev) {
	            if (a.i !== b.i && isValidDiagonal(a, b)) {
	                // split the polygon in two by the diagonal
	                var c = splitPolygon(a, b);
	
	                // filter colinear points around the cuts
	                a = filterPoints(a, a.next);
	                c = filterPoints(c, c.next);
	
	                // run earcut on each half
	                earcutLinked(a, triangles, dim, minX, minY, invSize);
	                earcutLinked(c, triangles, dim, minX, minY, invSize);
	                return;
	            }
	            b = b.next;
	        }
	        a = a.next;
	    } while (a !== start);
	}
	
	// link every hole into the outer loop, producing a single-ring polygon without holes
	function eliminateHoles(data, holeIndices, outerNode, dim) {
	    var queue = [],
	        i, len, start, end, list;
	
	    for (i = 0, len = holeIndices.length; i < len; i++) {
	        start = holeIndices[i] * dim;
	        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
	        list = linkedList(data, start, end, dim, false);
	        if (list === list.next) list.steiner = true;
	        queue.push(getLeftmost(list));
	    }
	
	    queue.sort(compareX);
	
	    // process holes from left to right
	    for (i = 0; i < queue.length; i++) {
	        outerNode = eliminateHole(queue[i], outerNode);
	        outerNode = filterPoints(outerNode, outerNode.next);
	    }
	
	    return outerNode;
	}
	
	function compareX(a, b) {
	    return a.x - b.x;
	}
	
	// find a bridge between vertices that connects hole with an outer ring and and link it
	function eliminateHole(hole, outerNode) {
	    var bridge = findHoleBridge(hole, outerNode);
	    if (!bridge) {
	        return outerNode;
	    }
	
	    var bridgeReverse = splitPolygon(bridge, hole);
	
	    // filter collinear points around the cuts
	    var filteredBridge = filterPoints(bridge, bridge.next);
	    filterPoints(bridgeReverse, bridgeReverse.next);
	
	    // Check if input node was removed by the filtering
	    return outerNode === bridge ? filteredBridge : outerNode;
	}
	
	// David Eberly's algorithm for finding a bridge between hole and outer polygon
	function findHoleBridge(hole, outerNode) {
	    var p = outerNode,
	        hx = hole.x,
	        hy = hole.y,
	        qx = -Infinity,
	        m;
	
	    // find a segment intersected by a ray from the hole's leftmost point to the left;
	    // segment's endpoint with lesser x will be potential connection point
	    do {
	        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
	            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
	            if (x <= hx && x > qx) {
	                qx = x;
	                if (x === hx) {
	                    if (hy === p.y) return p;
	                    if (hy === p.next.y) return p.next;
	                }
	                m = p.x < p.next.x ? p : p.next;
	            }
	        }
	        p = p.next;
	    } while (p !== outerNode);
	
	    if (!m) return null;
	
	    if (hx === qx) return m; // hole touches outer segment; pick leftmost endpoint
	
	    // look for points inside the triangle of hole point, segment intersection and endpoint;
	    // if there are no points found, we have a valid connection;
	    // otherwise choose the point of the minimum angle with the ray as connection point
	
	    var stop = m,
	        mx = m.x,
	        my = m.y,
	        tanMin = Infinity,
	        tan;
	
	    p = m;
	
	    do {
	        if (hx >= p.x && p.x >= mx && hx !== p.x &&
	                pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
	
	            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
	
	            if (locallyInside(p, hole) &&
	                (tan < tanMin || (tan === tanMin && (p.x > m.x || (p.x === m.x && sectorContainsSector(m, p)))))) {
	                m = p;
	                tanMin = tan;
	            }
	        }
	
	        p = p.next;
	    } while (p !== stop);
	
	    return m;
	}
	
	// whether sector in vertex m contains sector in vertex p in the same coordinates
	function sectorContainsSector(m, p) {
	    return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
	}
	
	// interlink polygon nodes in z-order
	function indexCurve(start, minX, minY, invSize) {
	    var p = start;
	    do {
	        if (p.z === null) p.z = zOrder(p.x, p.y, minX, minY, invSize);
	        p.prevZ = p.prev;
	        p.nextZ = p.next;
	        p = p.next;
	    } while (p !== start);
	
	    p.prevZ.nextZ = null;
	    p.prevZ = null;
	
	    sortLinked(p);
	}
	
	// Simon Tatham's linked list merge sort algorithm
	// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
	function sortLinked(list) {
	    var i, p, q, e, tail, numMerges, pSize, qSize,
	        inSize = 1;
	
	    do {
	        p = list;
	        list = null;
	        tail = null;
	        numMerges = 0;
	
	        while (p) {
	            numMerges++;
	            q = p;
	            pSize = 0;
	            for (i = 0; i < inSize; i++) {
	                pSize++;
	                q = q.nextZ;
	                if (!q) break;
	            }
	            qSize = inSize;
	
	            while (pSize > 0 || (qSize > 0 && q)) {
	
	                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
	                    e = p;
	                    p = p.nextZ;
	                    pSize--;
	                } else {
	                    e = q;
	                    q = q.nextZ;
	                    qSize--;
	                }
	
	                if (tail) tail.nextZ = e;
	                else list = e;
	
	                e.prevZ = tail;
	                tail = e;
	            }
	
	            p = q;
	        }
	
	        tail.nextZ = null;
	        inSize *= 2;
	
	    } while (numMerges > 1);
	
	    return list;
	}
	
	// z-order of a point given coords and inverse of the longer side of data bbox
	function zOrder(x, y, minX, minY, invSize) {
	    // coords are transformed into non-negative 15-bit integer range
	    x = 32767 * (x - minX) * invSize;
	    y = 32767 * (y - minY) * invSize;
	
	    x = (x | (x << 8)) & 0x00FF00FF;
	    x = (x | (x << 4)) & 0x0F0F0F0F;
	    x = (x | (x << 2)) & 0x33333333;
	    x = (x | (x << 1)) & 0x55555555;
	
	    y = (y | (y << 8)) & 0x00FF00FF;
	    y = (y | (y << 4)) & 0x0F0F0F0F;
	    y = (y | (y << 2)) & 0x33333333;
	    y = (y | (y << 1)) & 0x55555555;
	
	    return x | (y << 1);
	}
	
	// find the leftmost node of a polygon ring
	function getLeftmost(start) {
	    var p = start,
	        leftmost = start;
	    do {
	        if (p.x < leftmost.x || (p.x === leftmost.x && p.y < leftmost.y)) leftmost = p;
	        p = p.next;
	    } while (p !== start);
	
	    return leftmost;
	}
	
	// check if a point lies within a convex triangle
	function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
	    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 &&
	           (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 &&
	           (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
	}
	
	// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
	function isValidDiagonal(a, b) {
	    return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && // dones't intersect other edges
	           (locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && // locally visible
	            (area(a.prev, a, b.prev) || area(a, b.prev, b)) || // does not create opposite-facing sectors
	            equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0); // special zero-length case
	}
	
	// signed area of a triangle
	function area(p, q, r) {
	    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
	}
	
	// check if two points are equal
	function equals(p1, p2) {
	    return p1.x === p2.x && p1.y === p2.y;
	}
	
	// check if two segments intersect
	function intersects(p1, q1, p2, q2) {
	    var o1 = sign(area(p1, q1, p2));
	    var o2 = sign(area(p1, q1, q2));
	    var o3 = sign(area(p2, q2, p1));
	    var o4 = sign(area(p2, q2, q1));
	
	    if (o1 !== o2 && o3 !== o4) return true; // general case
	
	    if (o1 === 0 && onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
	    if (o2 === 0 && onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
	    if (o3 === 0 && onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
	    if (o4 === 0 && onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
	
	    return false;
	}
	
	// for collinear points p, q, r, check if point q lies on segment pr
	function onSegment(p, q, r) {
	    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
	}
	
	function sign(num) {
	    return num > 0 ? 1 : num < 0 ? -1 : 0;
	}
	
	// check if a polygon diagonal intersects any polygon segments
	function intersectsPolygon(a, b) {
	    var p = a;
	    do {
	        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i &&
	                intersects(p, p.next, a, b)) return true;
	        p = p.next;
	    } while (p !== a);
	
	    return false;
	}
	
	// check if a polygon diagonal is locally inside the polygon
	function locallyInside(a, b) {
	    return area(a.prev, a, a.next) < 0 ?
	        area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 :
	        area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
	}
	
	// check if the middle point of a polygon diagonal is inside the polygon
	function middleInside(a, b) {
	    var p = a,
	        inside = false,
	        px = (a.x + b.x) / 2,
	        py = (a.y + b.y) / 2;
	    do {
	        if (((p.y > py) !== (p.next.y > py)) && p.next.y !== p.y &&
	                (px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x))
	            inside = !inside;
	        p = p.next;
	    } while (p !== a);
	
	    return inside;
	}
	
	// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
	// if one belongs to the outer ring and another to a hole, it merges it into a single ring
	function splitPolygon(a, b) {
	    var a2 = new Node(a.i, a.x, a.y),
	        b2 = new Node(b.i, b.x, b.y),
	        an = a.next,
	        bp = b.prev;
	
	    a.next = b;
	    b.prev = a;
	
	    a2.next = an;
	    an.prev = a2;
	
	    b2.next = a2;
	    a2.prev = b2;
	
	    bp.next = b2;
	    b2.prev = bp;
	
	    return b2;
	}
	
	// create a node and optionally link it with previous one (in a circular doubly linked list)
	function insertNode(i, x, y, last) {
	    var p = new Node(i, x, y);
	
	    if (!last) {
	        p.prev = p;
	        p.next = p;
	
	    } else {
	        p.next = last.next;
	        p.prev = last;
	        last.next.prev = p;
	        last.next = p;
	    }
	    return p;
	}
	
	function removeNode(p) {
	    p.next.prev = p.prev;
	    p.prev.next = p.next;
	
	    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
	    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
	}
	
	function Node(i, x, y) {
	    // vertex index in coordinates array
	    this.i = i;
	
	    // vertex coordinates
	    this.x = x;
	    this.y = y;
	
	    // previous and next vertex nodes in a polygon ring
	    this.prev = null;
	    this.next = null;
	
	    // z-order curve value
	    this.z = null;
	
	    // previous and next nodes in z-order
	    this.prevZ = null;
	    this.nextZ = null;
	
	    // indicates whether this is a steiner point
	    this.steiner = false;
	}
	
	// return a percentage difference between the polygon area and its triangulation area;
	// used to verify correctness of triangulation
	earcut.deviation = function (data, holeIndices, dim, triangles) {
	    var hasHoles = holeIndices && holeIndices.length;
	    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
	
	    var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
	    if (hasHoles) {
	        for (var i = 0, len = holeIndices.length; i < len; i++) {
	            var start = holeIndices[i] * dim;
	            var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
	            polygonArea -= Math.abs(signedArea(data, start, end, dim));
	        }
	    }
	
	    var trianglesArea = 0;
	    for (i = 0; i < triangles.length; i += 3) {
	        var a = triangles[i] * dim;
	        var b = triangles[i + 1] * dim;
	        var c = triangles[i + 2] * dim;
	        trianglesArea += Math.abs(
	            (data[a] - data[c]) * (data[b + 1] - data[a + 1]) -
	            (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
	    }
	
	    return polygonArea === 0 && trianglesArea === 0 ? 0 :
	        Math.abs((trianglesArea - polygonArea) / polygonArea);
	};
	
	function signedArea(data, start, end, dim) {
	    var sum = 0;
	    for (var i = start, j = end - dim; i < end; i += dim) {
	        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
	        j = i;
	    }
	    return sum;
	}
	
	// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
	earcut.flatten = function (data) {
	    var dim = data[0][0].length,
	        result = {vertices: [], holes: [], dimensions: dim},
	        holeIndex = 0;
	
	    for (var i = 0; i < data.length; i++) {
	        for (var j = 0; j < data[i].length; j++) {
	            for (var d = 0; d < dim; d++) result.vertices.push(data[i][j][d]);
	        }
	        if (i > 0) {
	            holeIndex += data[i - 1].length;
	            result.holes.push(holeIndex);
	        }
	    }
	    return result;
	};


/***/ }),
/* 1478 */
/***/ (function(module, exports) {

	"use strict";
	
	// eslint-disable-next-line no-empty-function
	module.exports = function () {};


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = __webpack_require__(1480)() ? Object.assign : __webpack_require__(1481);


/***/ }),
/* 1480 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function () {
		var assign = Object.assign, obj;
		if (typeof assign !== "function") return false;
		obj = { foo: "raz" };
		assign(obj, { bar: "dwa" }, { trzy: "trzy" });
		return obj.foo + obj.bar + obj.trzy === "razdwatrzy";
	};


/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var keys  = __webpack_require__(1482)
	  , value = __webpack_require__(1486)
	  , max   = Math.max;
	
	module.exports = function (dest, src/*, …srcn*/) {
		var error, i, length = max(arguments.length, 2), assign;
		dest = Object(value(dest));
		assign = function (key) {
			try {
				dest[key] = src[key];
			} catch (e) {
				if (!error) error = e;
			}
		};
		for (i = 1; i < length; ++i) {
			src = arguments[i];
			keys(src).forEach(assign);
		}
		if (error !== undefined) throw error;
		return dest;
	};


/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = __webpack_require__(1483)() ? Object.keys : __webpack_require__(1484);


/***/ }),
/* 1483 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function () {
		try {
			Object.keys("primitive");
			return true;
		} catch (e) {
			return false;
		}
	};


/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var isValue = __webpack_require__(217);
	
	var keys = Object.keys;
	
	module.exports = function (object) { return keys(isValue(object) ? Object(object) : object); };


/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var isValue = __webpack_require__(217);
	
	var forEach = Array.prototype.forEach, create = Object.create;
	
	var process = function (src, obj) {
		var key;
		for (key in src) obj[key] = src[key];
	};
	
	// eslint-disable-next-line no-unused-vars
	module.exports = function (opts1/*, …options*/) {
		var result = create(null);
		forEach.call(arguments, function (options) {
			if (!isValue(options)) return;
			process(Object(options), result);
		});
		return result;
	};


/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var isValue = __webpack_require__(217);
	
	module.exports = function (value) {
		if (!isValue(value)) throw new TypeError("Cannot use null or undefined");
		return value;
	};


/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = __webpack_require__(1488)() ? String.prototype.contains : __webpack_require__(1489);


/***/ }),
/* 1488 */
/***/ (function(module, exports) {

	"use strict";
	
	var str = "razdwatrzy";
	
	module.exports = function () {
		if (typeof str.contains !== "function") return false;
		return str.contains("dwa") === true && str.contains("foo") === false;
	};


/***/ }),
/* 1489 */
/***/ (function(module, exports) {

	"use strict";
	
	var indexOf = String.prototype.indexOf;
	
	module.exports = function (searchString/*, position*/) {
		return indexOf.call(this, searchString, arguments[1]) > -1;
	};


/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, process) {/*!
	 * https://github.com/paulmillr/es6-shim
	 * @license es6-shim Copyright 2013-2016 by Paul Miller (http://paulmillr.com)
	 *   and contributors,  MIT License
	 * es6-shim: v0.35.4
	 * see https://github.com/paulmillr/es6-shim/blob/0.35.3/LICENSE
	 * Details and documentation:
	 * https://github.com/paulmillr/es6-shim/
	 */
	
	// UMD (Universal Module Definition)
	// see https://github.com/umdjs/umd/blob/master/returnExports.js
	(function (root, factory) {
	  /*global define */
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    // Browser globals (root is window)
	    root.returnExports = factory();
	  }
	}(this, function () {
	  'use strict';
	
	  var _apply = Function.call.bind(Function.apply);
	  var _call = Function.call.bind(Function.call);
	  var isArray = Array.isArray;
	  var keys = Object.keys;
	
	  var not = function notThunker(func) {
	    return function notThunk() {
	      return !_apply(func, this, arguments);
	    };
	  };
	  var throwsError = function (func) {
	    try {
	      func();
	      return false;
	    } catch (e) {
	      return true;
	    }
	  };
	  var valueOrFalseIfThrows = function valueOrFalseIfThrows(func) {
	    try {
	      return func();
	    } catch (e) {
	      return false;
	    }
	  };
	
	  var isCallableWithoutNew = not(throwsError);
	  var arePropertyDescriptorsSupported = function () {
	    // if Object.defineProperty exists but throws, it's IE 8
	    return !throwsError(function () {
	      return Object.defineProperty({}, 'x', { get: function () { } }); // eslint-disable-line getter-return
	    });
	  };
	  var supportsDescriptors = !!Object.defineProperty && arePropertyDescriptorsSupported();
	  var functionsHaveNames = (function foo() {}).name === 'foo'; // eslint-disable-line no-extra-parens
	
	  var _forEach = Function.call.bind(Array.prototype.forEach);
	  var _reduce = Function.call.bind(Array.prototype.reduce);
	  var _filter = Function.call.bind(Array.prototype.filter);
	  var _some = Function.call.bind(Array.prototype.some);
	
	  var defineProperty = function (object, name, value, force) {
	    if (!force && name in object) { return; }
	    if (supportsDescriptors) {
	      Object.defineProperty(object, name, {
	        configurable: true,
	        enumerable: false,
	        writable: true,
	        value: value
	      });
	    } else {
	      object[name] = value;
	    }
	  };
	
	  // Define configurable, writable and non-enumerable props
	  // if they don’t exist.
	  var defineProperties = function (object, map, forceOverride) {
	    _forEach(keys(map), function (name) {
	      var method = map[name];
	      defineProperty(object, name, method, !!forceOverride);
	    });
	  };
	
	  var _toString = Function.call.bind(Object.prototype.toString);
	  var isCallable =  false ? function IsCallableSlow(x) {
	    // Some old browsers (IE, FF) say that typeof /abc/ === 'function'
	    return typeof x === 'function' && _toString(x) === '[object Function]';
	  } : function IsCallableFast(x) { return typeof x === 'function'; };
	
	  var Value = {
	    getter: function (object, name, getter) {
	      if (!supportsDescriptors) {
	        throw new TypeError('getters require true ES5 support');
	      }
	      Object.defineProperty(object, name, {
	        configurable: true,
	        enumerable: false,
	        get: getter
	      });
	    },
	    proxy: function (originalObject, key, targetObject) {
	      if (!supportsDescriptors) {
	        throw new TypeError('getters require true ES5 support');
	      }
	      var originalDescriptor = Object.getOwnPropertyDescriptor(originalObject, key);
	      Object.defineProperty(targetObject, key, {
	        configurable: originalDescriptor.configurable,
	        enumerable: originalDescriptor.enumerable,
	        get: function getKey() { return originalObject[key]; },
	        set: function setKey(value) { originalObject[key] = value; }
	      });
	    },
	    redefine: function (object, property, newValue) {
	      if (supportsDescriptors) {
	        var descriptor = Object.getOwnPropertyDescriptor(object, property);
	        descriptor.value = newValue;
	        Object.defineProperty(object, property, descriptor);
	      } else {
	        object[property] = newValue;
	      }
	    },
	    defineByDescriptor: function (object, property, descriptor) {
	      if (supportsDescriptors) {
	        Object.defineProperty(object, property, descriptor);
	      } else if ('value' in descriptor) {
	        object[property] = descriptor.value;
	      }
	    },
	    preserveToString: function (target, source) {
	      if (source && isCallable(source.toString)) {
	        defineProperty(target, 'toString', source.toString.bind(source), true);
	      }
	    }
	  };
	
	  // Simple shim for Object.create on ES3 browsers
	  // (unlike real shim, no attempt to support `prototype === null`)
	  var create = Object.create || function (prototype, properties) {
	    var Prototype = function Prototype() {};
	    Prototype.prototype = prototype;
	    var object = new Prototype();
	    if (typeof properties !== 'undefined') {
	      keys(properties).forEach(function (key) {
	        Value.defineByDescriptor(object, key, properties[key]);
	      });
	    }
	    return object;
	  };
	
	  var supportsSubclassing = function (C, f) {
	    if (!Object.setPrototypeOf) { return false; /* skip test on IE < 11 */ }
	    return valueOrFalseIfThrows(function () {
	      var Sub = function Subclass(arg) {
	        var o = new C(arg);
	        Object.setPrototypeOf(o, Subclass.prototype);
	        return o;
	      };
	      Object.setPrototypeOf(Sub, C);
	      Sub.prototype = create(C.prototype, {
	        constructor: { value: Sub }
	      });
	      return f(Sub);
	    });
	  };
	
	  var getGlobal = function () {
	    /* global self, window */
	    // the only reliable means to get the global object is
	    // `Function('return this')()`
	    // However, this causes CSP violations in Chrome apps.
	    if (typeof self !== 'undefined') { return self; }
	    if (typeof window !== 'undefined') { return window; }
	    if (typeof global !== 'undefined') { return global; }
	    throw new Error('unable to locate global object');
	  };
	
	  var globals = getGlobal();
	  var globalIsFinite = globals.isFinite;
	  var _indexOf = Function.call.bind(String.prototype.indexOf);
	  var _arrayIndexOfApply = Function.apply.bind(Array.prototype.indexOf);
	  var _concat = Function.call.bind(Array.prototype.concat);
	  // var _sort = Function.call.bind(Array.prototype.sort);
	  var _strSlice = Function.call.bind(String.prototype.slice);
	  var _push = Function.call.bind(Array.prototype.push);
	  var _pushApply = Function.apply.bind(Array.prototype.push);
	  var _join = Function.call.bind(Array.prototype.join);
	  var _shift = Function.call.bind(Array.prototype.shift);
	  var _max = Math.max;
	  var _min = Math.min;
	  var _floor = Math.floor;
	  var _abs = Math.abs;
	  var _exp = Math.exp;
	  var _log = Math.log;
	  var _sqrt = Math.sqrt;
	  var _hasOwnProperty = Function.call.bind(Object.prototype.hasOwnProperty);
	  var ArrayIterator; // make our implementation private
	  var noop = function () {};
	
	  var OrigMap = globals.Map;
	  var origMapDelete = OrigMap && OrigMap.prototype['delete'];
	  var origMapGet = OrigMap && OrigMap.prototype.get;
	  var origMapHas = OrigMap && OrigMap.prototype.has;
	  var origMapSet = OrigMap && OrigMap.prototype.set;
	
	  var Symbol = globals.Symbol || {};
	  var symbolSpecies = Symbol.species || '@@species';
	
	  var numberIsNaN = Number.isNaN || function isNaN(value) {
	    // NaN !== NaN, but they are identical.
	    // NaNs are the only non-reflexive value, i.e., if x !== x,
	    // then x is NaN.
	    // isNaN is broken: it converts its argument to number, so
	    // isNaN('foo') => true
	    return value !== value;
	  };
	  var numberIsFinite = Number.isFinite || function isFinite(value) {
	    return typeof value === 'number' && globalIsFinite(value);
	  };
	  var _sign = isCallable(Math.sign) ? Math.sign : function sign(value) {
	    var number = Number(value);
	    if (number === 0) { return number; }
	    if (numberIsNaN(number)) { return number; }
	    return number < 0 ? -1 : 1;
	  };
	  var _log1p = function log1p(value) {
	    var x = Number(value);
	    if (x < -1 || numberIsNaN(x)) { return NaN; }
	    if (x === 0 || x === Infinity) { return x; }
	    if (x === -1) { return -Infinity; }
	
	    return (1 + x) - 1 === 0 ? x : x * (_log(1 + x) / ((1 + x) - 1));
	  };
	
	  // taken directly from https://github.com/ljharb/is-arguments/blob/master/index.js
	  // can be replaced with require('is-arguments') if we ever use a build process instead
	  var isStandardArguments = function isArguments(value) {
	    return _toString(value) === '[object Arguments]';
	  };
	  var isLegacyArguments = function isArguments(value) {
	    return value !== null &&
	      typeof value === 'object' &&
	      typeof value.length === 'number' &&
	      value.length >= 0 &&
	      _toString(value) !== '[object Array]' &&
	      _toString(value.callee) === '[object Function]';
	  };
	  var isArguments = isStandardArguments(arguments) ? isStandardArguments : isLegacyArguments;
	
	  var Type = {
	    primitive: function (x) { return x === null || (typeof x !== 'function' && typeof x !== 'object'); },
	    string: function (x) { return _toString(x) === '[object String]'; },
	    regex: function (x) { return _toString(x) === '[object RegExp]'; },
	    symbol: function (x) {
	      return typeof globals.Symbol === 'function' && typeof x === 'symbol';
	    }
	  };
	
	  var overrideNative = function overrideNative(object, property, replacement) {
	    var original = object[property];
	    defineProperty(object, property, replacement, true);
	    Value.preserveToString(object[property], original);
	  };
	
	  // eslint-disable-next-line no-restricted-properties
	  var hasSymbols = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' && Type.symbol(Symbol());
	
	  // This is a private name in the es6 spec, equal to '[Symbol.iterator]'
	  // we're going to use an arbitrary _-prefixed name to make our shims
	  // work properly with each other, even though we don't have full Iterator
	  // support.  That is, `Array.from(map.keys())` will work, but we don't
	  // pretend to export a "real" Iterator interface.
	  var $iterator$ = Type.symbol(Symbol.iterator) ? Symbol.iterator : '_es6-shim iterator_';
	  // Firefox ships a partial implementation using the name @@iterator.
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=907077#c14
	  // So use that name if we detect it.
	  if (globals.Set && typeof new globals.Set()['@@iterator'] === 'function') {
	    $iterator$ = '@@iterator';
	  }
	
	  // Reflect
	  if (!globals.Reflect) {
	    defineProperty(globals, 'Reflect', {}, true);
	  }
	  var Reflect = globals.Reflect;
	
	  var $String = String;
	
	  /* global document */
	  var domAll = (typeof document === 'undefined' || !document) ? null : document.all;
	  var isNullOrUndefined = domAll == null ? function isNullOrUndefined(x) {
	    return x == null;
	  } : function isNullOrUndefinedAndNotDocumentAll(x) {
	    return x == null && x !== domAll;
	  };
	
	  var ES = {
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-call
	    Call: function Call(F, V) {
	      var args = arguments.length > 2 ? arguments[2] : [];
	      if (!ES.IsCallable(F)) {
	        throw new TypeError(F + ' is not a function');
	      }
	      return _apply(F, V, args);
	    },
	
	    RequireObjectCoercible: function (x, optMessage) {
	      if (isNullOrUndefined(x)) {
	        throw new TypeError(optMessage || 'Cannot call method on ' + x);
	      }
	      return x;
	    },
	
	    // This might miss the "(non-standard exotic and does not implement
	    // [[Call]])" case from
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-typeof-operator-runtime-semantics-evaluation
	    // but we can't find any evidence these objects exist in practice.
	    // If we find some in the future, you could test `Object(x) === x`,
	    // which is reliable according to
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toobject
	    // but is not well optimized by runtimes and creates an object
	    // whenever it returns false, and thus is very slow.
	    TypeIsObject: function (x) {
	      if (x === void 0 || x === null || x === true || x === false) {
	        return false;
	      }
	      return typeof x === 'function' || typeof x === 'object' || x === domAll;
	    },
	
	    ToObject: function (o, optMessage) {
	      return Object(ES.RequireObjectCoercible(o, optMessage));
	    },
	
	    IsCallable: isCallable,
	
	    IsConstructor: function (x) {
	      // We can't tell callables from constructors in ES5
	      return ES.IsCallable(x);
	    },
	
	    ToInt32: function (x) {
	      return ES.ToNumber(x) >> 0;
	    },
	
	    ToUint32: function (x) {
	      return ES.ToNumber(x) >>> 0;
	    },
	
	    ToNumber: function (value) {
	      if (hasSymbols && _toString(value) === '[object Symbol]') {
	        throw new TypeError('Cannot convert a Symbol value to a number');
	      }
	      return +value;
	    },
	
	    ToInteger: function (value) {
	      var number = ES.ToNumber(value);
	      if (numberIsNaN(number)) { return 0; }
	      if (number === 0 || !numberIsFinite(number)) { return number; }
	      return (number > 0 ? 1 : -1) * _floor(_abs(number));
	    },
	
	    ToLength: function (value) {
	      var len = ES.ToInteger(value);
	      if (len <= 0) { return 0; } // includes converting -0 to +0
	      if (len > Number.MAX_SAFE_INTEGER) { return Number.MAX_SAFE_INTEGER; }
	      return len;
	    },
	
	    SameValue: function (a, b) {
	      if (a === b) {
	        // 0 === -0, but they are not identical.
	        if (a === 0) { return 1 / a === 1 / b; }
	        return true;
	      }
	      return numberIsNaN(a) && numberIsNaN(b);
	    },
	
	    SameValueZero: function (a, b) {
	      // same as SameValue except for SameValueZero(+0, -0) == true
	      return (a === b) || (numberIsNaN(a) && numberIsNaN(b));
	    },
	
	    IsIterable: function (o) {
	      return ES.TypeIsObject(o) && (typeof o[$iterator$] !== 'undefined' || isArguments(o));
	    },
	
	    GetIterator: function (o) {
	      if (isArguments(o)) {
	        // special case support for `arguments`
	        return new ArrayIterator(o, 'value');
	      }
	      var itFn = ES.GetMethod(o, $iterator$);
	      if (!ES.IsCallable(itFn)) {
	        // Better diagnostics if itFn is null or undefined
	        throw new TypeError('value is not an iterable');
	      }
	      var it = ES.Call(itFn, o);
	      if (!ES.TypeIsObject(it)) {
	        throw new TypeError('bad iterator');
	      }
	      return it;
	    },
	
	    GetMethod: function (o, p) {
	      var func = ES.ToObject(o)[p];
	      if (isNullOrUndefined(func)) {
	        return void 0;
	      }
	      if (!ES.IsCallable(func)) {
	        throw new TypeError('Method not callable: ' + p);
	      }
	      return func;
	    },
	
	    IteratorComplete: function (iterResult) {
	      return !!iterResult.done;
	    },
	
	    IteratorClose: function (iterator, completionIsThrow) {
	      var returnMethod = ES.GetMethod(iterator, 'return');
	      if (returnMethod === void 0) {
	        return;
	      }
	      var innerResult, innerException;
	      try {
	        innerResult = ES.Call(returnMethod, iterator);
	      } catch (e) {
	        innerException = e;
	      }
	      if (completionIsThrow) {
	        return;
	      }
	      if (innerException) {
	        throw innerException;
	      }
	      if (!ES.TypeIsObject(innerResult)) {
	        throw new TypeError("Iterator's return method returned a non-object.");
	      }
	    },
	
	    IteratorNext: function (it) {
	      var result = arguments.length > 1 ? it.next(arguments[1]) : it.next();
	      if (!ES.TypeIsObject(result)) {
	        throw new TypeError('bad iterator');
	      }
	      return result;
	    },
	
	    IteratorStep: function (it) {
	      var result = ES.IteratorNext(it);
	      var done = ES.IteratorComplete(result);
	      return done ? false : result;
	    },
	
	    Construct: function (C, args, newTarget, isES6internal) {
	      var target = typeof newTarget === 'undefined' ? C : newTarget;
	
	      if (!isES6internal && Reflect.construct) {
	        // Try to use Reflect.construct if available
	        return Reflect.construct(C, args, target);
	      }
	      // OK, we have to fake it.  This will only work if the
	      // C.[[ConstructorKind]] == "base" -- but that's the only
	      // kind we can make in ES5 code anyway.
	
	      // OrdinaryCreateFromConstructor(target, "%ObjectPrototype%")
	      var proto = target.prototype;
	      if (!ES.TypeIsObject(proto)) {
	        proto = Object.prototype;
	      }
	      var obj = create(proto);
	      // Call the constructor.
	      var result = ES.Call(C, obj, args);
	      return ES.TypeIsObject(result) ? result : obj;
	    },
	
	    SpeciesConstructor: function (O, defaultConstructor) {
	      var C = O.constructor;
	      if (C === void 0) {
	        return defaultConstructor;
	      }
	      if (!ES.TypeIsObject(C)) {
	        throw new TypeError('Bad constructor');
	      }
	      var S = C[symbolSpecies];
	      if (isNullOrUndefined(S)) {
	        return defaultConstructor;
	      }
	      if (!ES.IsConstructor(S)) {
	        throw new TypeError('Bad @@species');
	      }
	      return S;
	    },
	
	    CreateHTML: function (string, tag, attribute, value) {
	      var S = ES.ToString(string);
	      var p1 = '<' + tag;
	      if (attribute !== '') {
	        var V = ES.ToString(value);
	        var escapedV = V.replace(/"/g, '&quot;');
	        p1 += ' ' + attribute + '="' + escapedV + '"';
	      }
	      var p2 = p1 + '>';
	      var p3 = p2 + S;
	      return p3 + '</' + tag + '>';
	    },
	
	    IsRegExp: function IsRegExp(argument) {
	      if (!ES.TypeIsObject(argument)) {
	        return false;
	      }
	      var isRegExp = argument[Symbol.match];
	      if (typeof isRegExp !== 'undefined') {
	        return !!isRegExp;
	      }
	      return Type.regex(argument);
	    },
	
	    ToString: function ToString(string) {
	      if (hasSymbols && _toString(string) === '[object Symbol]') {
	        throw new TypeError('Cannot convert a Symbol value to a number');
	      }
	      return $String(string);
	    }
	  };
	
	  // Well-known Symbol shims
	  if (supportsDescriptors && hasSymbols) {
	    var defineWellKnownSymbol = function defineWellKnownSymbol(name) {
	      if (Type.symbol(Symbol[name])) {
	        return Symbol[name];
	      }
	      // eslint-disable-next-line no-restricted-properties
	      var sym = Symbol['for']('Symbol.' + name);
	      Object.defineProperty(Symbol, name, {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: sym
	      });
	      return sym;
	    };
	    if (!Type.symbol(Symbol.search)) {
	      var symbolSearch = defineWellKnownSymbol('search');
	      var originalSearch = String.prototype.search;
	      defineProperty(RegExp.prototype, symbolSearch, function search(string) {
	        return ES.Call(originalSearch, string, [this]);
	      });
	      var searchShim = function search(regexp) {
	        var O = ES.RequireObjectCoercible(this);
	        if (!isNullOrUndefined(regexp)) {
	          var searcher = ES.GetMethod(regexp, symbolSearch);
	          if (typeof searcher !== 'undefined') {
	            return ES.Call(searcher, regexp, [O]);
	          }
	        }
	        return ES.Call(originalSearch, O, [ES.ToString(regexp)]);
	      };
	      overrideNative(String.prototype, 'search', searchShim);
	    }
	    if (!Type.symbol(Symbol.replace)) {
	      var symbolReplace = defineWellKnownSymbol('replace');
	      var originalReplace = String.prototype.replace;
	      defineProperty(RegExp.prototype, symbolReplace, function replace(string, replaceValue) {
	        return ES.Call(originalReplace, string, [this, replaceValue]);
	      });
	      var replaceShim = function replace(searchValue, replaceValue) {
	        var O = ES.RequireObjectCoercible(this);
	        if (!isNullOrUndefined(searchValue)) {
	          var replacer = ES.GetMethod(searchValue, symbolReplace);
	          if (typeof replacer !== 'undefined') {
	            return ES.Call(replacer, searchValue, [O, replaceValue]);
	          }
	        }
	        return ES.Call(originalReplace, O, [ES.ToString(searchValue), replaceValue]);
	      };
	      overrideNative(String.prototype, 'replace', replaceShim);
	    }
	    if (!Type.symbol(Symbol.split)) {
	      var symbolSplit = defineWellKnownSymbol('split');
	      var originalSplit = String.prototype.split;
	      defineProperty(RegExp.prototype, symbolSplit, function split(string, limit) {
	        return ES.Call(originalSplit, string, [this, limit]);
	      });
	      var splitShim = function split(separator, limit) {
	        var O = ES.RequireObjectCoercible(this);
	        if (!isNullOrUndefined(separator)) {
	          var splitter = ES.GetMethod(separator, symbolSplit);
	          if (typeof splitter !== 'undefined') {
	            return ES.Call(splitter, separator, [O, limit]);
	          }
	        }
	        return ES.Call(originalSplit, O, [ES.ToString(separator), limit]);
	      };
	      overrideNative(String.prototype, 'split', splitShim);
	    }
	    var symbolMatchExists = Type.symbol(Symbol.match);
	    var stringMatchIgnoresSymbolMatch = symbolMatchExists && (function () {
	      // Firefox 41, through Nightly 45 has Symbol.match, but String#match ignores it.
	      // Firefox 40 and below have Symbol.match but String#match works fine.
	      var o = {};
	      o[Symbol.match] = function () { return 42; };
	      return 'a'.match(o) !== 42;
	    }());
	    if (!symbolMatchExists || stringMatchIgnoresSymbolMatch) {
	      var symbolMatch = defineWellKnownSymbol('match');
	
	      var originalMatch = String.prototype.match;
	      defineProperty(RegExp.prototype, symbolMatch, function match(string) {
	        return ES.Call(originalMatch, string, [this]);
	      });
	
	      var matchShim = function match(regexp) {
	        var O = ES.RequireObjectCoercible(this);
	        if (!isNullOrUndefined(regexp)) {
	          var matcher = ES.GetMethod(regexp, symbolMatch);
	          if (typeof matcher !== 'undefined') {
	            return ES.Call(matcher, regexp, [O]);
	          }
	        }
	        return ES.Call(originalMatch, O, [ES.ToString(regexp)]);
	      };
	      overrideNative(String.prototype, 'match', matchShim);
	    }
	  }
	
	  var wrapConstructor = function wrapConstructor(original, replacement, keysToSkip) {
	    Value.preserveToString(replacement, original);
	    if (Object.setPrototypeOf) {
	      // sets up proper prototype chain where possible
	      Object.setPrototypeOf(original, replacement);
	    }
	    if (supportsDescriptors) {
	      _forEach(Object.getOwnPropertyNames(original), function (key) {
	        if (key in noop || keysToSkip[key]) { return; }
	        Value.proxy(original, key, replacement);
	      });
	    } else {
	      _forEach(Object.keys(original), function (key) {
	        if (key in noop || keysToSkip[key]) { return; }
	        replacement[key] = original[key];
	      });
	    }
	    replacement.prototype = original.prototype;
	    Value.redefine(original.prototype, 'constructor', replacement);
	  };
	
	  var defaultSpeciesGetter = function () { return this; };
	  var addDefaultSpecies = function (C) {
	    if (supportsDescriptors && !_hasOwnProperty(C, symbolSpecies)) {
	      Value.getter(C, symbolSpecies, defaultSpeciesGetter);
	    }
	  };
	
	  var addIterator = function (prototype, impl) {
	    var implementation = impl || function iterator() { return this; };
	    defineProperty(prototype, $iterator$, implementation);
	    if (!prototype[$iterator$] && Type.symbol($iterator$)) {
	      // implementations are buggy when $iterator$ is a Symbol
	      prototype[$iterator$] = implementation;
	    }
	  };
	
	  var createDataProperty = function createDataProperty(object, name, value) {
	    if (supportsDescriptors) {
	      Object.defineProperty(object, name, {
	        configurable: true,
	        enumerable: true,
	        writable: true,
	        value: value
	      });
	    } else {
	      object[name] = value;
	    }
	  };
	  var createDataPropertyOrThrow = function createDataPropertyOrThrow(object, name, value) {
	    createDataProperty(object, name, value);
	    if (!ES.SameValue(object[name], value)) {
	      throw new TypeError('property is nonconfigurable');
	    }
	  };
	
	  var emulateES6construct = function (o, defaultNewTarget, defaultProto, slots) {
	    // This is an es5 approximation to es6 construct semantics.  in es6,
	    // 'new Foo' invokes Foo.[[Construct]] which (for almost all objects)
	    // just sets the internal variable NewTarget (in es6 syntax `new.target`)
	    // to Foo and then returns Foo().
	
	    // Many ES6 object then have constructors of the form:
	    // 1. If NewTarget is undefined, throw a TypeError exception
	    // 2. Let xxx by OrdinaryCreateFromConstructor(NewTarget, yyy, zzz)
	
	    // So we're going to emulate those first two steps.
	    if (!ES.TypeIsObject(o)) {
	      throw new TypeError('Constructor requires `new`: ' + defaultNewTarget.name);
	    }
	    var proto = defaultNewTarget.prototype;
	    if (!ES.TypeIsObject(proto)) {
	      proto = defaultProto;
	    }
	    var obj = create(proto);
	    for (var name in slots) {
	      if (_hasOwnProperty(slots, name)) {
	        var value = slots[name];
	        defineProperty(obj, name, value, true);
	      }
	    }
	    return obj;
	  };
	
	  // Firefox 31 reports this function's length as 0
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=1062484
	  if (String.fromCodePoint && String.fromCodePoint.length !== 1) {
	    var originalFromCodePoint = String.fromCodePoint;
	    overrideNative(String, 'fromCodePoint', function fromCodePoint(codePoints) {
	      return ES.Call(originalFromCodePoint, this, arguments);
	    });
	  }
	
	  var StringShims = {
	    fromCodePoint: function fromCodePoint(codePoints) {
	      var result = [];
	      var next;
	      for (var i = 0, length = arguments.length; i < length; i++) {
	        next = Number(arguments[i]);
	        if (!ES.SameValue(next, ES.ToInteger(next)) || next < 0 || next > 0x10FFFF) {
	          throw new RangeError('Invalid code point ' + next);
	        }
	
	        if (next < 0x10000) {
	          _push(result, String.fromCharCode(next));
	        } else {
	          next -= 0x10000;
	          _push(result, String.fromCharCode((next >> 10) + 0xD800));
	          _push(result, String.fromCharCode((next % 0x400) + 0xDC00));
	        }
	      }
	      return _join(result, '');
	    },
	
	    raw: function raw(template) {
	      var numberOfSubstitutions = arguments.length - 1;
	      var cooked = ES.ToObject(template, 'bad template');
	      var raw = ES.ToObject(cooked.raw, 'bad raw value');
	      var len = raw.length;
	      var literalSegments = ES.ToLength(len);
	      if (literalSegments <= 0) {
	        return '';
	      }
	
	      var stringElements = [];
	      var nextIndex = 0;
	      var nextKey, next, nextSeg, nextSub;
	      while (nextIndex < literalSegments) {
	        nextKey = ES.ToString(nextIndex);
	        nextSeg = ES.ToString(raw[nextKey]);
	        _push(stringElements, nextSeg);
	        if (nextIndex + 1 >= literalSegments) {
	          break;
	        }
	        next = nextIndex + 1 < arguments.length ? arguments[nextIndex + 1] : '';
	        nextSub = ES.ToString(next);
	        _push(stringElements, nextSub);
	        nextIndex += 1;
	      }
	      return _join(stringElements, '');
	    }
	  };
	  if (String.raw && String.raw({ raw: { 0: 'x', 1: 'y', length: 2 } }) !== 'xy') {
	    // IE 11 TP has a broken String.raw implementation
	    overrideNative(String, 'raw', StringShims.raw);
	  }
	  defineProperties(String, StringShims);
	
	  // Fast repeat, uses the `Exponentiation by squaring` algorithm.
	  // Perf: http://jsperf.com/string-repeat2/2
	  var stringRepeat = function repeat(s, times) {
	    if (times < 1) { return ''; }
	    if (times % 2) { return repeat(s, times - 1) + s; }
	    var half = repeat(s, times / 2);
	    return half + half;
	  };
	  var stringMaxLength = Infinity;
	
	  var StringPrototypeShims = {
	    repeat: function repeat(times) {
	      var thisStr = ES.ToString(ES.RequireObjectCoercible(this));
	      var numTimes = ES.ToInteger(times);
	      if (numTimes < 0 || numTimes >= stringMaxLength) {
	        throw new RangeError('repeat count must be less than infinity and not overflow maximum string size');
	      }
	      return stringRepeat(thisStr, numTimes);
	    },
	
	    startsWith: function startsWith(searchString) {
	      var S = ES.ToString(ES.RequireObjectCoercible(this));
	      if (ES.IsRegExp(searchString)) {
	        throw new TypeError('Cannot call method "startsWith" with a regex');
	      }
	      var searchStr = ES.ToString(searchString);
	      var position;
	      if (arguments.length > 1) {
	        position = arguments[1];
	      }
	      var start = _max(ES.ToInteger(position), 0);
	      return _strSlice(S, start, start + searchStr.length) === searchStr;
	    },
	
	    endsWith: function endsWith(searchString) {
	      var S = ES.ToString(ES.RequireObjectCoercible(this));
	      if (ES.IsRegExp(searchString)) {
	        throw new TypeError('Cannot call method "endsWith" with a regex');
	      }
	      var searchStr = ES.ToString(searchString);
	      var len = S.length;
	      var endPosition;
	      if (arguments.length > 1) {
	        endPosition = arguments[1];
	      }
	      var pos = typeof endPosition === 'undefined' ? len : ES.ToInteger(endPosition);
	      var end = _min(_max(pos, 0), len);
	      return _strSlice(S, end - searchStr.length, end) === searchStr;
	    },
	
	    includes: function includes(searchString) {
	      if (ES.IsRegExp(searchString)) {
	        throw new TypeError('"includes" does not accept a RegExp');
	      }
	      var searchStr = ES.ToString(searchString);
	      var position;
	      if (arguments.length > 1) {
	        position = arguments[1];
	      }
	      // Somehow this trick makes method 100% compat with the spec.
	      return _indexOf(this, searchStr, position) !== -1;
	    },
	
	    codePointAt: function codePointAt(pos) {
	      var thisStr = ES.ToString(ES.RequireObjectCoercible(this));
	      var position = ES.ToInteger(pos);
	      var length = thisStr.length;
	      if (position >= 0 && position < length) {
	        var first = thisStr.charCodeAt(position);
	        var isEnd = position + 1 === length;
	        if (first < 0xD800 || first > 0xDBFF || isEnd) { return first; }
	        var second = thisStr.charCodeAt(position + 1);
	        if (second < 0xDC00 || second > 0xDFFF) { return first; }
	        return ((first - 0xD800) * 1024) + (second - 0xDC00) + 0x10000;
	      }
	    }
	  };
	  if (String.prototype.includes && 'a'.includes('a', Infinity) !== false) {
	    overrideNative(String.prototype, 'includes', StringPrototypeShims.includes);
	  }
	
	  if (String.prototype.startsWith && String.prototype.endsWith) {
	    var startsWithRejectsRegex = throwsError(function () {
	      /* throws if spec-compliant */
	      return '/a/'.startsWith(/a/);
	    });
	    var startsWithHandlesInfinity = valueOrFalseIfThrows(function () {
	      return 'abc'.startsWith('a', Infinity) === false;
	    });
	    if (!startsWithRejectsRegex || !startsWithHandlesInfinity) {
	      // Firefox (< 37?) and IE 11 TP have a noncompliant startsWith implementation
	      overrideNative(String.prototype, 'startsWith', StringPrototypeShims.startsWith);
	      overrideNative(String.prototype, 'endsWith', StringPrototypeShims.endsWith);
	    }
	  }
	  if (hasSymbols) {
	    var startsWithSupportsSymbolMatch = valueOrFalseIfThrows(function () {
	      var re = /a/;
	      re[Symbol.match] = false;
	      return '/a/'.startsWith(re);
	    });
	    if (!startsWithSupportsSymbolMatch) {
	      overrideNative(String.prototype, 'startsWith', StringPrototypeShims.startsWith);
	    }
	    var endsWithSupportsSymbolMatch = valueOrFalseIfThrows(function () {
	      var re = /a/;
	      re[Symbol.match] = false;
	      return '/a/'.endsWith(re);
	    });
	    if (!endsWithSupportsSymbolMatch) {
	      overrideNative(String.prototype, 'endsWith', StringPrototypeShims.endsWith);
	    }
	    var includesSupportsSymbolMatch = valueOrFalseIfThrows(function () {
	      var re = /a/;
	      re[Symbol.match] = false;
	      return '/a/'.includes(re);
	    });
	    if (!includesSupportsSymbolMatch) {
	      overrideNative(String.prototype, 'includes', StringPrototypeShims.includes);
	    }
	  }
	
	  defineProperties(String.prototype, StringPrototypeShims);
	
	  // whitespace from: http://es5.github.io/#x15.5.4.20
	  // implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
	  var ws = [
	    '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
	    '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
	    '\u2029\uFEFF'
	  ].join('');
	  var trimRegexp = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
	  var trimShim = function trim() {
	    return ES.ToString(ES.RequireObjectCoercible(this)).replace(trimRegexp, '');
	  };
	  var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
	  var nonWSregex = new RegExp('[' + nonWS + ']', 'g');
	  var isBadHexRegex = /^[-+]0x[0-9a-f]+$/i;
	  var hasStringTrimBug = nonWS.trim().length !== nonWS.length;
	  defineProperty(String.prototype, 'trim', trimShim, hasStringTrimBug);
	
	  // Given an argument x, it will return an IteratorResult object,
	  // with value set to x and done to false.
	  // Given no arguments, it will return an iterator completion object.
	  var iteratorResult = function (x) {
	    return { value: x, done: arguments.length === 0 };
	  };
	
	  // see http://www.ecma-international.org/ecma-262/6.0/#sec-string.prototype-@@iterator
	  var StringIterator = function (s) {
	    ES.RequireObjectCoercible(s);
	    this._s = ES.ToString(s);
	    this._i = 0;
	  };
	  StringIterator.prototype.next = function () {
	    var s = this._s;
	    var i = this._i;
	    if (typeof s === 'undefined' || i >= s.length) {
	      this._s = void 0;
	      return iteratorResult();
	    }
	    var first = s.charCodeAt(i);
	    var second, len;
	    if (first < 0xD800 || first > 0xDBFF || (i + 1) === s.length) {
	      len = 1;
	    } else {
	      second = s.charCodeAt(i + 1);
	      len = (second < 0xDC00 || second > 0xDFFF) ? 1 : 2;
	    }
	    this._i = i + len;
	    return iteratorResult(s.substr(i, len));
	  };
	  addIterator(StringIterator.prototype);
	  addIterator(String.prototype, function () {
	    return new StringIterator(this);
	  });
	
	  var ArrayShims = {
	    from: function from(items) {
	      var C = this;
	      var mapFn;
	      if (arguments.length > 1) {
	        mapFn = arguments[1];
	      }
	      var mapping, T;
	      if (typeof mapFn === 'undefined') {
	        mapping = false;
	      } else {
	        if (!ES.IsCallable(mapFn)) {
	          throw new TypeError('Array.from: when provided, the second argument must be a function');
	        }
	        if (arguments.length > 2) {
	          T = arguments[2];
	        }
	        mapping = true;
	      }
	
	      // Note that that Arrays will use ArrayIterator:
	      // https://bugs.ecmascript.org/show_bug.cgi?id=2416
	      var usingIterator = typeof (isArguments(items) || ES.GetMethod(items, $iterator$)) !== 'undefined';
	
	      var length, result, i;
	      if (usingIterator) {
	        result = ES.IsConstructor(C) ? Object(new C()) : [];
	        var iterator = ES.GetIterator(items);
	        var next, nextValue;
	
	        i = 0;
	        while (true) {
	          next = ES.IteratorStep(iterator);
	          if (next === false) {
	            break;
	          }
	          nextValue = next.value;
	          try {
	            if (mapping) {
	              nextValue = typeof T === 'undefined' ? mapFn(nextValue, i) : _call(mapFn, T, nextValue, i);
	            }
	            result[i] = nextValue;
	          } catch (e) {
	            ES.IteratorClose(iterator, true);
	            throw e;
	          }
	          i += 1;
	        }
	        length = i;
	      } else {
	        var arrayLike = ES.ToObject(items);
	        length = ES.ToLength(arrayLike.length);
	        result = ES.IsConstructor(C) ? Object(new C(length)) : new Array(length);
	        var value;
	        for (i = 0; i < length; ++i) {
	          value = arrayLike[i];
	          if (mapping) {
	            value = typeof T === 'undefined' ? mapFn(value, i) : _call(mapFn, T, value, i);
	          }
	          createDataPropertyOrThrow(result, i, value);
	        }
	      }
	
	      result.length = length;
	      return result;
	    },
	
	    of: function of() {
	      var len = arguments.length;
	      var C = this;
	      var A = isArray(C) || !ES.IsCallable(C) ? new Array(len) : ES.Construct(C, [len]);
	      for (var k = 0; k < len; ++k) {
	        createDataPropertyOrThrow(A, k, arguments[k]);
	      }
	      A.length = len;
	      return A;
	    }
	  };
	  defineProperties(Array, ArrayShims);
	  addDefaultSpecies(Array);
	
	  // Our ArrayIterator is private; see
	  // https://github.com/paulmillr/es6-shim/issues/252
	  ArrayIterator = function (array, kind) {
	    this.i = 0;
	    this.array = array;
	    this.kind = kind;
	  };
	
	  defineProperties(ArrayIterator.prototype, {
	    next: function () {
	      var i = this.i;
	      var array = this.array;
	      if (!(this instanceof ArrayIterator)) {
	        throw new TypeError('Not an ArrayIterator');
	      }
	      if (typeof array !== 'undefined') {
	        var len = ES.ToLength(array.length);
	        if (i < len) {
	        //for (; i < len; i++) {
	          var kind = this.kind;
	          var retval;
	          if (kind === 'key') {
	            retval = i;
	          } else if (kind === 'value') {
	            retval = array[i];
	          } else if (kind === 'entry') {
	            retval = [i, array[i]];
	          }
	          this.i = i + 1;
	          return iteratorResult(retval);
	        }
	      }
	      this.array = void 0;
	      return iteratorResult();
	    }
	  });
	  addIterator(ArrayIterator.prototype);
	
	  /*
	  var orderKeys = function orderKeys(a, b) {
	    var aNumeric = String(ES.ToInteger(a)) === a;
	    var bNumeric = String(ES.ToInteger(b)) === b;
	    if (aNumeric && bNumeric) {
	      return b - a;
	    } else if (aNumeric && !bNumeric) {
	      return -1;
	    } else if (!aNumeric && bNumeric) {
	      return 1;
	    } else {
	      return a.localeCompare(b);
	    }
	  };
	
	  var getAllKeys = function getAllKeys(object) {
	    var ownKeys = [];
	    var keys = [];
	
	    for (var key in object) {
	      _push(_hasOwnProperty(object, key) ? ownKeys : keys, key);
	    }
	    _sort(ownKeys, orderKeys);
	    _sort(keys, orderKeys);
	
	    return _concat(ownKeys, keys);
	  };
	  */
	
	  // note: this is positioned here because it depends on ArrayIterator
	  var arrayOfSupportsSubclassing = Array.of === ArrayShims.of || (function () {
	    // Detects a bug in Webkit nightly r181886
	    var Foo = function Foo(len) { this.length = len; };
	    Foo.prototype = [];
	    var fooArr = Array.of.apply(Foo, [1, 2]);
	    return fooArr instanceof Foo && fooArr.length === 2;
	  }());
	  if (!arrayOfSupportsSubclassing) {
	    overrideNative(Array, 'of', ArrayShims.of);
	  }
	
	  var ArrayPrototypeShims = {
	    copyWithin: function copyWithin(target, start) {
	      var o = ES.ToObject(this);
	      var len = ES.ToLength(o.length);
	      var relativeTarget = ES.ToInteger(target);
	      var relativeStart = ES.ToInteger(start);
	      var to = relativeTarget < 0 ? _max(len + relativeTarget, 0) : _min(relativeTarget, len);
	      var from = relativeStart < 0 ? _max(len + relativeStart, 0) : _min(relativeStart, len);
	      var end;
	      if (arguments.length > 2) {
	        end = arguments[2];
	      }
	      var relativeEnd = typeof end === 'undefined' ? len : ES.ToInteger(end);
	      var finalItem = relativeEnd < 0 ? _max(len + relativeEnd, 0) : _min(relativeEnd, len);
	      var count = _min(finalItem - from, len - to);
	      var direction = 1;
	      if (from < to && to < (from + count)) {
	        direction = -1;
	        from += count - 1;
	        to += count - 1;
	      }
	      while (count > 0) {
	        if (from in o) {
	          o[to] = o[from];
	        } else {
	          delete o[to];
	        }
	        from += direction;
	        to += direction;
	        count -= 1;
	      }
	      return o;
	    },
	
	    fill: function fill(value) {
	      var start;
	      if (arguments.length > 1) {
	        start = arguments[1];
	      }
	      var end;
	      if (arguments.length > 2) {
	        end = arguments[2];
	      }
	      var O = ES.ToObject(this);
	      var len = ES.ToLength(O.length);
	      start = ES.ToInteger(typeof start === 'undefined' ? 0 : start);
	      end = ES.ToInteger(typeof end === 'undefined' ? len : end);
	
	      var relativeStart = start < 0 ? _max(len + start, 0) : _min(start, len);
	      var relativeEnd = end < 0 ? len + end : end;
	
	      for (var i = relativeStart; i < len && i < relativeEnd; ++i) {
	        O[i] = value;
	      }
	      return O;
	    },
	
	    find: function find(predicate) {
	      var list = ES.ToObject(this);
	      var length = ES.ToLength(list.length);
	      if (!ES.IsCallable(predicate)) {
	        throw new TypeError('Array#find: predicate must be a function');
	      }
	      var thisArg = arguments.length > 1 ? arguments[1] : null;
	      for (var i = 0, value; i < length; i++) {
	        value = list[i];
	        if (thisArg) {
	          if (_call(predicate, thisArg, value, i, list)) {
	            return value;
	          }
	        } else if (predicate(value, i, list)) {
	          return value;
	        }
	      }
	    },
	
	    findIndex: function findIndex(predicate) {
	      var list = ES.ToObject(this);
	      var length = ES.ToLength(list.length);
	      if (!ES.IsCallable(predicate)) {
	        throw new TypeError('Array#findIndex: predicate must be a function');
	      }
	      var thisArg = arguments.length > 1 ? arguments[1] : null;
	      for (var i = 0; i < length; i++) {
	        if (thisArg) {
	          if (_call(predicate, thisArg, list[i], i, list)) {
	            return i;
	          }
	        } else if (predicate(list[i], i, list)) {
	          return i;
	        }
	      }
	      return -1;
	    },
	
	    keys: function keys() {
	      return new ArrayIterator(this, 'key');
	    },
	
	    values: function values() {
	      return new ArrayIterator(this, 'value');
	    },
	
	    entries: function entries() {
	      return new ArrayIterator(this, 'entry');
	    }
	  };
	  // Safari 7.1 defines Array#keys and Array#entries natively,
	  // but the resulting ArrayIterator objects don't have a "next" method.
	  if (Array.prototype.keys && !ES.IsCallable([1].keys().next)) {
	    delete Array.prototype.keys;
	  }
	  if (Array.prototype.entries && !ES.IsCallable([1].entries().next)) {
	    delete Array.prototype.entries;
	  }
	
	  // Chrome 38 defines Array#keys and Array#entries, and Array#@@iterator, but not Array#values
	  if (Array.prototype.keys && Array.prototype.entries && !Array.prototype.values && Array.prototype[$iterator$]) {
	    defineProperties(Array.prototype, {
	      values: Array.prototype[$iterator$]
	    });
	    if (Type.symbol(Symbol.unscopables)) {
	      Array.prototype[Symbol.unscopables].values = true;
	    }
	  }
	  // Chrome 40 defines Array#values with the incorrect name, although Array#{keys,entries} have the correct name
	  if (functionsHaveNames && Array.prototype.values && Array.prototype.values.name !== 'values') {
	    var originalArrayPrototypeValues = Array.prototype.values;
	    overrideNative(Array.prototype, 'values', function values() { return ES.Call(originalArrayPrototypeValues, this, arguments); });
	    defineProperty(Array.prototype, $iterator$, Array.prototype.values, true);
	  }
	  defineProperties(Array.prototype, ArrayPrototypeShims);
	
	  if (1 / [true].indexOf(true, -0) < 0) {
	    // indexOf when given a position arg of -0 should return +0.
	    // https://github.com/tc39/ecma262/pull/316
	    defineProperty(Array.prototype, 'indexOf', function indexOf(searchElement) {
	      var value = _arrayIndexOfApply(this, arguments);
	      if (value === 0 && (1 / value) < 0) {
	        return 0;
	      }
	      return value;
	    }, true);
	  }
	
	  addIterator(Array.prototype, function () { return this.values(); });
	  // Chrome defines keys/values/entries on Array, but doesn't give us
	  // any way to identify its iterator.  So add our own shimmed field.
	  if (Object.getPrototypeOf) {
	    addIterator(Object.getPrototypeOf([].values()));
	  }
	
	  // note: this is positioned here because it relies on Array#entries
	  var arrayFromSwallowsNegativeLengths = (function () {
	    // Detects a Firefox bug in v32
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=1063993
	    return valueOrFalseIfThrows(function () {
	      return Array.from({ length: -1 }).length === 0;
	    });
	  }());
	  var arrayFromHandlesIterables = (function () {
	    // Detects a bug in Webkit nightly r181886
	    var arr = Array.from([0].entries());
	    return arr.length === 1 && isArray(arr[0]) && arr[0][0] === 0 && arr[0][1] === 0;
	  }());
	  if (!arrayFromSwallowsNegativeLengths || !arrayFromHandlesIterables) {
	    overrideNative(Array, 'from', ArrayShims.from);
	  }
	  var arrayFromHandlesUndefinedMapFunction = (function () {
	    // Microsoft Edge v0.11 throws if the mapFn argument is *provided* but undefined,
	    // but the spec doesn't care if it's provided or not - undefined doesn't throw.
	    return valueOrFalseIfThrows(function () {
	      return Array.from([0], void 0);
	    });
	  }());
	  if (!arrayFromHandlesUndefinedMapFunction) {
	    var origArrayFrom = Array.from;
	    overrideNative(Array, 'from', function from(items) {
	      if (arguments.length > 1 && typeof arguments[1] !== 'undefined') {
	        return ES.Call(origArrayFrom, this, arguments);
	      } else {
	        return _call(origArrayFrom, this, items);
	      }
	    });
	  }
	
	  var int32sAsOne = -(Math.pow(2, 32) - 1);
	  var toLengthsCorrectly = function (method, reversed) {
	    var obj = { length: int32sAsOne };
	    obj[reversed ? (obj.length >>> 0) - 1 : 0] = true;
	    return valueOrFalseIfThrows(function () {
	      _call(method, obj, function () {
	        // note: in nonconforming browsers, this will be called
	        // -1 >>> 0 times, which is 4294967295, so the throw matters.
	        throw new RangeError('should not reach here');
	      }, []);
	      return true;
	    });
	  };
	  if (!toLengthsCorrectly(Array.prototype.forEach)) {
	    var originalForEach = Array.prototype.forEach;
	    overrideNative(Array.prototype, 'forEach', function forEach(callbackFn) {
	      return ES.Call(originalForEach, this.length >= 0 ? this : [], arguments);
	    });
	  }
	  if (!toLengthsCorrectly(Array.prototype.map)) {
	    var originalMap = Array.prototype.map;
	    overrideNative(Array.prototype, 'map', function map(callbackFn) {
	      return ES.Call(originalMap, this.length >= 0 ? this : [], arguments);
	    });
	  }
	  if (!toLengthsCorrectly(Array.prototype.filter)) {
	    var originalFilter = Array.prototype.filter;
	    overrideNative(Array.prototype, 'filter', function filter(callbackFn) {
	      return ES.Call(originalFilter, this.length >= 0 ? this : [], arguments);
	    });
	  }
	  if (!toLengthsCorrectly(Array.prototype.some)) {
	    var originalSome = Array.prototype.some;
	    overrideNative(Array.prototype, 'some', function some(callbackFn) {
	      return ES.Call(originalSome, this.length >= 0 ? this : [], arguments);
	    });
	  }
	  if (!toLengthsCorrectly(Array.prototype.every)) {
	    var originalEvery = Array.prototype.every;
	    overrideNative(Array.prototype, 'every', function every(callbackFn) {
	      return ES.Call(originalEvery, this.length >= 0 ? this : [], arguments);
	    });
	  }
	  if (!toLengthsCorrectly(Array.prototype.reduce)) {
	    var originalReduce = Array.prototype.reduce;
	    overrideNative(Array.prototype, 'reduce', function reduce(callbackFn) {
	      return ES.Call(originalReduce, this.length >= 0 ? this : [], arguments);
	    });
	  }
	  if (!toLengthsCorrectly(Array.prototype.reduceRight, true)) {
	    var originalReduceRight = Array.prototype.reduceRight;
	    overrideNative(Array.prototype, 'reduceRight', function reduceRight(callbackFn) {
	      return ES.Call(originalReduceRight, this.length >= 0 ? this : [], arguments);
	    });
	  }
	
	  var lacksOctalSupport = Number('0o10') !== 8;
	  var lacksBinarySupport = Number('0b10') !== 2;
	  var trimsNonWhitespace = _some(nonWS, function (c) {
	    return Number(c + 0 + c) === 0;
	  });
	  if (lacksOctalSupport || lacksBinarySupport || trimsNonWhitespace) {
	    var OrigNumber = Number;
	    var binaryRegex = /^0b[01]+$/i;
	    var octalRegex = /^0o[0-7]+$/i;
	    // Note that in IE 8, RegExp.prototype.test doesn't seem to exist: ie, "test" is an own property of regexes. wtf.
	    var isBinary = binaryRegex.test.bind(binaryRegex);
	    var isOctal = octalRegex.test.bind(octalRegex);
	    var toPrimitive = function (O, hint) { // need to replace this with `es-to-primitive/es6`
	      var result;
	      if (typeof O.valueOf === 'function') {
	        result = O.valueOf();
	        if (Type.primitive(result)) {
	          return result;
	        }
	      }
	      if (typeof O.toString === 'function') {
	        result = O.toString();
	        if (Type.primitive(result)) {
	          return result;
	        }
	      }
	      throw new TypeError('No default value');
	    };
	    var hasNonWS = nonWSregex.test.bind(nonWSregex);
	    var isBadHex = isBadHexRegex.test.bind(isBadHexRegex);
	    var NumberShim = (function () {
	      // this is wrapped in an IIFE because of IE 6-8's wacky scoping issues with named function expressions.
	      var NumberShim = function Number(value) {
	        var primValue;
	        if (arguments.length > 0) {
	          primValue = Type.primitive(value) ? value : toPrimitive(value, 'number');
	        } else {
	          primValue = 0;
	        }
	        if (typeof primValue === 'string') {
	          primValue = ES.Call(trimShim, primValue);
	          if (isBinary(primValue)) {
	            primValue = parseInt(_strSlice(primValue, 2), 2);
	          } else if (isOctal(primValue)) {
	            primValue = parseInt(_strSlice(primValue, 2), 8);
	          } else if (hasNonWS(primValue) || isBadHex(primValue)) {
	            primValue = NaN;
	          }
	        }
	        var receiver = this;
	        var valueOfSucceeds = valueOrFalseIfThrows(function () {
	          OrigNumber.prototype.valueOf.call(receiver);
	          return true;
	        });
	        if (receiver instanceof NumberShim && !valueOfSucceeds) {
	          return new OrigNumber(primValue);
	        }
	        return OrigNumber(primValue);
	      };
	      return NumberShim;
	    }());
	    wrapConstructor(OrigNumber, NumberShim, {});
	    // this is necessary for ES3 browsers, where these properties are non-enumerable.
	    defineProperties(NumberShim, {
	      NaN: OrigNumber.NaN,
	      MAX_VALUE: OrigNumber.MAX_VALUE,
	      MIN_VALUE: OrigNumber.MIN_VALUE,
	      NEGATIVE_INFINITY: OrigNumber.NEGATIVE_INFINITY,
	      POSITIVE_INFINITY: OrigNumber.POSITIVE_INFINITY
	    });
	    /* eslint-disable no-undef, no-global-assign */
	    Number = NumberShim;
	    Value.redefine(globals, 'Number', NumberShim);
	    /* eslint-enable no-undef, no-global-assign */
	  }
	
	  var maxSafeInteger = Math.pow(2, 53) - 1;
	  defineProperties(Number, {
	    MAX_SAFE_INTEGER: maxSafeInteger,
	    MIN_SAFE_INTEGER: -maxSafeInteger,
	    EPSILON: 2.220446049250313e-16,
	
	    parseInt: globals.parseInt,
	    parseFloat: globals.parseFloat,
	
	    isFinite: numberIsFinite,
	
	    isInteger: function isInteger(value) {
	      return numberIsFinite(value) && ES.ToInteger(value) === value;
	    },
	
	    isSafeInteger: function isSafeInteger(value) {
	      return Number.isInteger(value) && _abs(value) <= Number.MAX_SAFE_INTEGER;
	    },
	
	    isNaN: numberIsNaN
	  });
	  // Firefox 37 has a conforming Number.parseInt, but it's not === to the global parseInt (fixed in v40)
	  defineProperty(Number, 'parseInt', globals.parseInt, Number.parseInt !== globals.parseInt);
	
	  // Work around bugs in Array#find and Array#findIndex -- early
	  // implementations skipped holes in sparse arrays. (Note that the
	  // implementations of find/findIndex indirectly use shimmed
	  // methods of Number, so this test has to happen down here.)
	  /* eslint-disable no-sparse-arrays */
	  if ([, 1].find(function () { return true; }) === 1) {
	    overrideNative(Array.prototype, 'find', ArrayPrototypeShims.find);
	  }
	  if ([, 1].findIndex(function () { return true; }) !== 0) {
	    overrideNative(Array.prototype, 'findIndex', ArrayPrototypeShims.findIndex);
	  }
	  /* eslint-enable no-sparse-arrays */
	
	  var isEnumerableOn = Function.bind.call(Function.bind, Object.prototype.propertyIsEnumerable);
	  var ensureEnumerable = function ensureEnumerable(obj, prop) {
	    if (supportsDescriptors && isEnumerableOn(obj, prop)) {
	      Object.defineProperty(obj, prop, { enumerable: false });
	    }
	  };
	  var sliceArgs = function sliceArgs() {
	    // per https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	    // and https://gist.github.com/WebReflection/4327762cb87a8c634a29
	    var initial = Number(this);
	    var len = arguments.length;
	    var desiredArgCount = len - initial;
	    var args = new Array(desiredArgCount < 0 ? 0 : desiredArgCount);
	    for (var i = initial; i < len; ++i) {
	      args[i - initial] = arguments[i];
	    }
	    return args;
	  };
	  var assignTo = function assignTo(source) {
	    return function assignToSource(target, key) {
	      target[key] = source[key];
	      return target;
	    };
	  };
	  var assignReducer = function (target, source) {
	    var sourceKeys = keys(Object(source));
	    var symbols;
	    if (ES.IsCallable(Object.getOwnPropertySymbols)) {
	      symbols = _filter(Object.getOwnPropertySymbols(Object(source)), isEnumerableOn(source));
	    }
	    return _reduce(_concat(sourceKeys, symbols || []), assignTo(source), target);
	  };
	
	  var ObjectShims = {
	    // 19.1.3.1
	    assign: function (target, source) {
	      var to = ES.ToObject(target, 'Cannot convert undefined or null to object');
	      return _reduce(ES.Call(sliceArgs, 1, arguments), assignReducer, to);
	    },
	
	    // Added in WebKit in https://bugs.webkit.org/show_bug.cgi?id=143865
	    is: function is(a, b) {
	      return ES.SameValue(a, b);
	    }
	  };
	  var assignHasPendingExceptions = Object.assign && Object.preventExtensions && (function () {
	    // Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	    // which is 72% slower than our shim, and Firefox 40's native implementation.
	    var thrower = Object.preventExtensions({ 1: 2 });
	    try {
	      Object.assign(thrower, 'xy');
	    } catch (e) {
	      return thrower[1] === 'y';
	    }
	  }());
	  if (assignHasPendingExceptions) {
	    overrideNative(Object, 'assign', ObjectShims.assign);
	  }
	  defineProperties(Object, ObjectShims);
	
	  if (supportsDescriptors) {
	    var ES5ObjectShims = {
	      // 19.1.3.9
	      // shim from https://gist.github.com/WebReflection/5593554
	      setPrototypeOf: (function (Object, magic) {
	        var set;
	
	        var checkArgs = function (O, proto) {
	          if (!ES.TypeIsObject(O)) {
	            throw new TypeError('cannot set prototype on a non-object');
	          }
	          if (!(proto === null || ES.TypeIsObject(proto))) {
	            throw new TypeError('can only set prototype to an object or null' + proto);
	          }
	        };
	
	        var setPrototypeOf = function (O, proto) {
	          checkArgs(O, proto);
	          _call(set, O, proto);
	          return O;
	        };
	
	        try {
	          // this works already in Firefox and Safari
	          set = Object.getOwnPropertyDescriptor(Object.prototype, magic).set;
	          _call(set, {}, null);
	        } catch (e) {
	          if (Object.prototype !== {}[magic]) {
	            // IE < 11 cannot be shimmed
	            return;
	          }
	          // probably Chrome or some old Mobile stock browser
	          set = function (proto) {
	            this[magic] = proto;
	          };
	          // please note that this will **not** work
	          // in those browsers that do not inherit
	          // __proto__ by mistake from Object.prototype
	          // in these cases we should probably throw an error
	          // or at least be informed about the issue
	          setPrototypeOf.polyfill = setPrototypeOf(
	            setPrototypeOf({}, null),
	            Object.prototype
	          ) instanceof Object;
	          // setPrototypeOf.polyfill === true means it works as meant
	          // setPrototypeOf.polyfill === false means it's not 100% reliable
	          // setPrototypeOf.polyfill === undefined
	          // or
	          // setPrototypeOf.polyfill ==  null means it's not a polyfill
	          // which means it works as expected
	          // we can even delete Object.prototype.__proto__;
	        }
	        return setPrototypeOf;
	      }(Object, '__proto__'))
	    };
	
	    defineProperties(Object, ES5ObjectShims);
	  }
	
	  // Workaround bug in Opera 12 where setPrototypeOf(x, null) doesn't work,
	  // but Object.create(null) does.
	  if (Object.setPrototypeOf && Object.getPrototypeOf &&
	      Object.getPrototypeOf(Object.setPrototypeOf({}, null)) !== null &&
	      Object.getPrototypeOf(Object.create(null)) === null) {
	    (function () {
	      var FAKENULL = Object.create(null);
	      var gpo = Object.getPrototypeOf;
	      var spo = Object.setPrototypeOf;
	      Object.getPrototypeOf = function (o) {
	        var result = gpo(o);
	        return result === FAKENULL ? null : result;
	      };
	      Object.setPrototypeOf = function (o, p) {
	        var proto = p === null ? FAKENULL : p;
	        return spo(o, proto);
	      };
	      Object.setPrototypeOf.polyfill = false;
	    }());
	  }
	
	  var objectKeysAcceptsPrimitives = !throwsError(function () { return Object.keys('foo'); });
	  if (!objectKeysAcceptsPrimitives) {
	    var originalObjectKeys = Object.keys;
	    overrideNative(Object, 'keys', function keys(value) {
	      return originalObjectKeys(ES.ToObject(value));
	    });
	    keys = Object.keys;
	  }
	  var objectKeysRejectsRegex = throwsError(function () { return Object.keys(/a/g); });
	  if (objectKeysRejectsRegex) {
	    var regexRejectingObjectKeys = Object.keys;
	    overrideNative(Object, 'keys', function keys(value) {
	      if (Type.regex(value)) {
	        var regexKeys = [];
	        for (var k in value) {
	          if (_hasOwnProperty(value, k)) {
	            _push(regexKeys, k);
	          }
	        }
	        return regexKeys;
	      }
	      return regexRejectingObjectKeys(value);
	    });
	    keys = Object.keys;
	  }
	
	  if (Object.getOwnPropertyNames) {
	    var objectGOPNAcceptsPrimitives = !throwsError(function () { return Object.getOwnPropertyNames('foo'); });
	    if (!objectGOPNAcceptsPrimitives) {
	      var cachedWindowNames = typeof window === 'object' ? Object.getOwnPropertyNames(window) : [];
	      var originalObjectGetOwnPropertyNames = Object.getOwnPropertyNames;
	      overrideNative(Object, 'getOwnPropertyNames', function getOwnPropertyNames(value) {
	        var val = ES.ToObject(value);
	        if (_toString(val) === '[object Window]') {
	          try {
	            return originalObjectGetOwnPropertyNames(val);
	          } catch (e) {
	            // IE bug where layout engine calls userland gOPN for cross-domain `window` objects
	            return _concat([], cachedWindowNames);
	          }
	        }
	        return originalObjectGetOwnPropertyNames(val);
	      });
	    }
	  }
	  if (Object.getOwnPropertyDescriptor) {
	    var objectGOPDAcceptsPrimitives = !throwsError(function () { return Object.getOwnPropertyDescriptor('foo', 'bar'); });
	    if (!objectGOPDAcceptsPrimitives) {
	      var originalObjectGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	      overrideNative(Object, 'getOwnPropertyDescriptor', function getOwnPropertyDescriptor(value, property) {
	        return originalObjectGetOwnPropertyDescriptor(ES.ToObject(value), property);
	      });
	    }
	  }
	  if (Object.seal) {
	    var objectSealAcceptsPrimitives = !throwsError(function () { return Object.seal('foo'); });
	    if (!objectSealAcceptsPrimitives) {
	      var originalObjectSeal = Object.seal;
	      overrideNative(Object, 'seal', function seal(value) {
	        if (!ES.TypeIsObject(value)) { return value; }
	        return originalObjectSeal(value);
	      });
	    }
	  }
	  if (Object.isSealed) {
	    var objectIsSealedAcceptsPrimitives = !throwsError(function () { return Object.isSealed('foo'); });
	    if (!objectIsSealedAcceptsPrimitives) {
	      var originalObjectIsSealed = Object.isSealed;
	      overrideNative(Object, 'isSealed', function isSealed(value) {
	        if (!ES.TypeIsObject(value)) { return true; }
	        return originalObjectIsSealed(value);
	      });
	    }
	  }
	  if (Object.freeze) {
	    var objectFreezeAcceptsPrimitives = !throwsError(function () { return Object.freeze('foo'); });
	    if (!objectFreezeAcceptsPrimitives) {
	      var originalObjectFreeze = Object.freeze;
	      overrideNative(Object, 'freeze', function freeze(value) {
	        if (!ES.TypeIsObject(value)) { return value; }
	        return originalObjectFreeze(value);
	      });
	    }
	  }
	  if (Object.isFrozen) {
	    var objectIsFrozenAcceptsPrimitives = !throwsError(function () { return Object.isFrozen('foo'); });
	    if (!objectIsFrozenAcceptsPrimitives) {
	      var originalObjectIsFrozen = Object.isFrozen;
	      overrideNative(Object, 'isFrozen', function isFrozen(value) {
	        if (!ES.TypeIsObject(value)) { return true; }
	        return originalObjectIsFrozen(value);
	      });
	    }
	  }
	  if (Object.preventExtensions) {
	    var objectPreventExtensionsAcceptsPrimitives = !throwsError(function () { return Object.preventExtensions('foo'); });
	    if (!objectPreventExtensionsAcceptsPrimitives) {
	      var originalObjectPreventExtensions = Object.preventExtensions;
	      overrideNative(Object, 'preventExtensions', function preventExtensions(value) {
	        if (!ES.TypeIsObject(value)) { return value; }
	        return originalObjectPreventExtensions(value);
	      });
	    }
	  }
	  if (Object.isExtensible) {
	    var objectIsExtensibleAcceptsPrimitives = !throwsError(function () { return Object.isExtensible('foo'); });
	    if (!objectIsExtensibleAcceptsPrimitives) {
	      var originalObjectIsExtensible = Object.isExtensible;
	      overrideNative(Object, 'isExtensible', function isExtensible(value) {
	        if (!ES.TypeIsObject(value)) { return false; }
	        return originalObjectIsExtensible(value);
	      });
	    }
	  }
	  if (Object.getPrototypeOf) {
	    var objectGetProtoAcceptsPrimitives = !throwsError(function () { return Object.getPrototypeOf('foo'); });
	    if (!objectGetProtoAcceptsPrimitives) {
	      var originalGetProto = Object.getPrototypeOf;
	      overrideNative(Object, 'getPrototypeOf', function getPrototypeOf(value) {
	        return originalGetProto(ES.ToObject(value));
	      });
	    }
	  }
	
	  var hasFlags = supportsDescriptors && (function () {
	    var desc = Object.getOwnPropertyDescriptor(RegExp.prototype, 'flags');
	    return desc && ES.IsCallable(desc.get);
	  }());
	  if (supportsDescriptors && !hasFlags) {
	    var regExpFlagsGetter = function flags() {
	      if (!ES.TypeIsObject(this)) {
	        throw new TypeError('Method called on incompatible type: must be an object.');
	      }
	      var result = '';
	      if (this.global) {
	        result += 'g';
	      }
	      if (this.ignoreCase) {
	        result += 'i';
	      }
	      if (this.multiline) {
	        result += 'm';
	      }
	      if (this.unicode) {
	        result += 'u';
	      }
	      if (this.sticky) {
	        result += 'y';
	      }
	      return result;
	    };
	
	    Value.getter(RegExp.prototype, 'flags', regExpFlagsGetter);
	  }
	
	  var regExpSupportsFlagsWithRegex = supportsDescriptors && valueOrFalseIfThrows(function () {
	    return String(new RegExp(/a/g, 'i')) === '/a/i';
	  });
	  var regExpNeedsToSupportSymbolMatch = hasSymbols && supportsDescriptors && (function () {
	    // Edge 0.12 supports flags fully, but does not support Symbol.match
	    var regex = /./;
	    regex[Symbol.match] = false;
	    return RegExp(regex) === regex;
	  }());
	
	  var regexToStringIsGeneric = valueOrFalseIfThrows(function () {
	    return RegExp.prototype.toString.call({ source: 'abc' }) === '/abc/';
	  });
	  var regexToStringSupportsGenericFlags = regexToStringIsGeneric && valueOrFalseIfThrows(function () {
	    return RegExp.prototype.toString.call({ source: 'a', flags: 'b' }) === '/a/b';
	  });
	  if (!regexToStringIsGeneric || !regexToStringSupportsGenericFlags) {
	    var origRegExpToString = RegExp.prototype.toString;
	    defineProperty(RegExp.prototype, 'toString', function toString() {
	      var R = ES.RequireObjectCoercible(this);
	      if (Type.regex(R)) {
	        return _call(origRegExpToString, R);
	      }
	      var pattern = $String(R.source);
	      var flags = $String(R.flags);
	      return '/' + pattern + '/' + flags;
	    }, true);
	    Value.preserveToString(RegExp.prototype.toString, origRegExpToString);
	  }
	
	  if (supportsDescriptors && (!regExpSupportsFlagsWithRegex || regExpNeedsToSupportSymbolMatch)) {
	    var flagsGetter = Object.getOwnPropertyDescriptor(RegExp.prototype, 'flags').get;
	    var sourceDesc = Object.getOwnPropertyDescriptor(RegExp.prototype, 'source') || {};
	    var legacySourceGetter = function () {
	      // prior to it being a getter, it's own + nonconfigurable
	      return this.source;
	    };
	    var sourceGetter = ES.IsCallable(sourceDesc.get) ? sourceDesc.get : legacySourceGetter;
	
	    var OrigRegExp = RegExp;
	    var RegExpShim = (function () {
	      return function RegExp(pattern, flags) {
	        var patternIsRegExp = ES.IsRegExp(pattern);
	        var calledWithNew = this instanceof RegExp;
	        if (!calledWithNew && patternIsRegExp && typeof flags === 'undefined' && pattern.constructor === RegExp) {
	          return pattern;
	        }
	
	        var P = pattern;
	        var F = flags;
	        if (Type.regex(pattern)) {
	          P = ES.Call(sourceGetter, pattern);
	          F = typeof flags === 'undefined' ? ES.Call(flagsGetter, pattern) : flags;
	          return new RegExp(P, F);
	        } else if (patternIsRegExp) {
	          P = pattern.source;
	          F = typeof flags === 'undefined' ? pattern.flags : flags;
	        }
	        return new OrigRegExp(pattern, flags);
	      };
	    }());
	    wrapConstructor(OrigRegExp, RegExpShim, {
	      $input: true // Chrome < v39 & Opera < 26 have a nonstandard "$input" property
	    });
	    /* eslint-disable no-undef, no-global-assign */
	    RegExp = RegExpShim;
	    Value.redefine(globals, 'RegExp', RegExpShim);
	    /* eslint-enable no-undef, no-global-assign */
	  }
	
	  if (supportsDescriptors) {
	    var regexGlobals = {
	      input: '$_',
	      lastMatch: '$&',
	      lastParen: '$+',
	      leftContext: '$`',
	      rightContext: '$\''
	    };
	    _forEach(keys(regexGlobals), function (prop) {
	      if (prop in RegExp && !(regexGlobals[prop] in RegExp)) {
	        Value.getter(RegExp, regexGlobals[prop], function get() {
	          return RegExp[prop];
	        });
	      }
	    });
	  }
	  addDefaultSpecies(RegExp);
	
	  var inverseEpsilon = 1 / Number.EPSILON;
	  var roundTiesToEven = function roundTiesToEven(n) {
	    // Even though this reduces down to `return n`, it takes advantage of built-in rounding.
	    return (n + inverseEpsilon) - inverseEpsilon;
	  };
	  var BINARY_32_EPSILON = Math.pow(2, -23);
	  var BINARY_32_MAX_VALUE = Math.pow(2, 127) * (2 - BINARY_32_EPSILON);
	  var BINARY_32_MIN_VALUE = Math.pow(2, -126);
	  var E = Math.E;
	  var LOG2E = Math.LOG2E;
	  var LOG10E = Math.LOG10E;
	  var numberCLZ = Number.prototype.clz;
	  delete Number.prototype.clz; // Safari 8 has Number#clz
	
	  var MathShims = {
	    acosh: function acosh(value) {
	      var x = Number(value);
	      if (numberIsNaN(x) || value < 1) { return NaN; }
	      if (x === 1) { return 0; }
	      if (x === Infinity) { return x; }
	
	      var xInvSquared = 1 / (x * x);
	      if (x < 2) {
	        return _log1p(x - 1 + (_sqrt(1 - xInvSquared) * x));
	      }
	      var halfX = x / 2;
	      return _log1p(halfX + (_sqrt(1 - xInvSquared) * halfX) - 1) + (1 / LOG2E);
	    },
	
	    asinh: function asinh(value) {
	      var x = Number(value);
	      if (x === 0 || !globalIsFinite(x)) {
	        return x;
	      }
	
	      var a = _abs(x);
	      var aSquared = a * a;
	      var s = _sign(x);
	      if (a < 1) {
	        return s * _log1p(a + (aSquared / (_sqrt(aSquared + 1) + 1)));
	      }
	      return s * (_log1p((a / 2) + (_sqrt(1 + (1 / aSquared)) * a / 2) - 1) + (1 / LOG2E));
	    },
	
	    atanh: function atanh(value) {
	      var x = Number(value);
	
	      if (x === 0) { return x; }
	      if (x === -1) { return -Infinity; }
	      if (x === 1) { return Infinity; }
	      if (numberIsNaN(x) || x < -1 || x > 1) {
	        return NaN;
	      }
	
	      var a = _abs(x);
	      return _sign(x) * _log1p(2 * a / (1 - a)) / 2;
	    },
	
	    cbrt: function cbrt(value) {
	      var x = Number(value);
	      if (x === 0) { return x; }
	      var negate = x < 0;
	      var result;
	      if (negate) { x = -x; }
	      if (x === Infinity) {
	        result = Infinity;
	      } else {
	        result = _exp(_log(x) / 3);
	        // from http://en.wikipedia.org/wiki/Cube_root#Numerical_methods
	        result = ((x / (result * result)) + (2 * result)) / 3;
	      }
	      return negate ? -result : result;
	    },
	
	    clz32: function clz32(value) {
	      // See https://bugs.ecmascript.org/show_bug.cgi?id=2465
	      var x = Number(value);
	      var number = ES.ToUint32(x);
	      if (number === 0) {
	        return 32;
	      }
	      return numberCLZ ? ES.Call(numberCLZ, number) : 31 - _floor(_log(number + 0.5) * LOG2E);
	    },
	
	    cosh: function cosh(value) {
	      var x = Number(value);
	      if (x === 0) { return 1; } // +0 or -0
	      if (numberIsNaN(x)) { return NaN; }
	      if (!globalIsFinite(x)) { return Infinity; }
	
	      var t = _exp(_abs(x) - 1);
	      return (t + (1 / (t * E * E))) * (E / 2);
	    },
	
	    expm1: function expm1(value) {
	      var x = Number(value);
	      if (x === -Infinity) { return -1; }
	      if (!globalIsFinite(x) || x === 0) { return x; }
	      if (_abs(x) > 0.5) {
	        return _exp(x) - 1;
	      }
	      // A more precise approximation using Taylor series expansion
	      // from https://github.com/paulmillr/es6-shim/issues/314#issuecomment-70293986
	      var t = x;
	      var sum = 0;
	      var n = 1;
	      while (sum + t !== sum) {
	        sum += t;
	        n += 1;
	        t *= x / n;
	      }
	      return sum;
	    },
	
	    hypot: function hypot(x, y) {
	      var result = 0;
	      var largest = 0;
	      for (var i = 0; i < arguments.length; ++i) {
	        var value = _abs(Number(arguments[i]));
	        if (largest < value) {
	          result *= (largest / value) * (largest / value);
	          result += 1;
	          largest = value;
	        } else {
	          result += value > 0 ? (value / largest) * (value / largest) : value;
	        }
	      }
	      return largest === Infinity ? Infinity : largest * _sqrt(result);
	    },
	
	    log2: function log2(value) {
	      return _log(value) * LOG2E;
	    },
	
	    log10: function log10(value) {
	      return _log(value) * LOG10E;
	    },
	
	    log1p: _log1p,
	
	    sign: _sign,
	
	    sinh: function sinh(value) {
	      var x = Number(value);
	      if (!globalIsFinite(x) || x === 0) { return x; }
	
	      var a = _abs(x);
	      if (a < 1) {
	        var u = Math.expm1(a);
	        return _sign(x) * u * (1 + (1 / (u + 1))) / 2;
	      }
	      var t = _exp(a - 1);
	      return _sign(x) * (t - (1 / (t * E * E))) * (E / 2);
	    },
	
	    tanh: function tanh(value) {
	      var x = Number(value);
	      if (numberIsNaN(x) || x === 0) { return x; }
	      // can exit early at +-20 as JS loses precision for true value at this integer
	      if (x >= 20) { return 1; }
	      if (x <= -20) { return -1; }
	
	      return (Math.expm1(x) - Math.expm1(-x)) / (_exp(x) + _exp(-x));
	    },
	
	    trunc: function trunc(value) {
	      var x = Number(value);
	      return x < 0 ? -_floor(-x) : _floor(x);
	    },
	
	    imul: function imul(x, y) {
	      // taken from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/imul
	      var a = ES.ToUint32(x);
	      var b = ES.ToUint32(y);
	      var ah = (a >>> 16) & 0xffff;
	      var al = a & 0xffff;
	      var bh = (b >>> 16) & 0xffff;
	      var bl = b & 0xffff;
	      // the shift by 0 fixes the sign on the high part
	      // the final |0 converts the unsigned value into a signed value
	      return (al * bl) + ((((ah * bl) + (al * bh)) << 16) >>> 0) | 0;
	    },
	
	    fround: function fround(x) {
	      var v = Number(x);
	      if (v === 0 || v === Infinity || v === -Infinity || numberIsNaN(v)) {
	        return v;
	      }
	      var sign = _sign(v);
	      var abs = _abs(v);
	      if (abs < BINARY_32_MIN_VALUE) {
	        return sign * roundTiesToEven(abs / BINARY_32_MIN_VALUE / BINARY_32_EPSILON) * BINARY_32_MIN_VALUE * BINARY_32_EPSILON;
	      }
	      // Veltkamp's splitting (?)
	      var a = (1 + (BINARY_32_EPSILON / Number.EPSILON)) * abs;
	      var result = a - (a - abs);
	      if (result > BINARY_32_MAX_VALUE || numberIsNaN(result)) {
	        return sign * Infinity;
	      }
	      return sign * result;
	    }
	  };
	
	  var withinULPDistance = function withinULPDistance(result, expected, distance) {
	    return _abs(1 - (result / expected)) / Number.EPSILON < (distance || 8);
	  };
	
	  defineProperties(Math, MathShims);
	  // Chrome < 40 sinh returns ∞ for large numbers
	  defineProperty(Math, 'sinh', MathShims.sinh, Math.sinh(710) === Infinity);
	  // Chrome < 40 cosh returns ∞ for large numbers
	  defineProperty(Math, 'cosh', MathShims.cosh, Math.cosh(710) === Infinity);
	  // IE 11 TP has an imprecise log1p: reports Math.log1p(-1e-17) as 0
	  defineProperty(Math, 'log1p', MathShims.log1p, Math.log1p(-1e-17) !== -1e-17);
	  // IE 11 TP has an imprecise asinh: reports Math.asinh(-1e7) as not exactly equal to -Math.asinh(1e7)
	  defineProperty(Math, 'asinh', MathShims.asinh, Math.asinh(-1e7) !== -Math.asinh(1e7));
	  // Chrome < 54 asinh returns ∞ for large numbers and should not
	  defineProperty(Math, 'asinh', MathShims.asinh, Math.asinh(1e+300) === Infinity);
	  // Chrome < 54 atanh incorrectly returns 0 for large numbers
	  defineProperty(Math, 'atanh', MathShims.atanh, Math.atanh(1e-300) === 0);
	  // Chrome 40 has an imprecise Math.tanh with very small numbers
	  defineProperty(Math, 'tanh', MathShims.tanh, Math.tanh(-2e-17) !== -2e-17);
	  // Chrome 40 loses Math.acosh precision with high numbers
	  defineProperty(Math, 'acosh', MathShims.acosh, Math.acosh(Number.MAX_VALUE) === Infinity);
	  // Chrome < 54 has an inaccurate acosh for EPSILON deltas
	  defineProperty(Math, 'acosh', MathShims.acosh, !withinULPDistance(Math.acosh(1 + Number.EPSILON), Math.sqrt(2 * Number.EPSILON)));
	  // Firefox 38 on Windows
	  defineProperty(Math, 'cbrt', MathShims.cbrt, !withinULPDistance(Math.cbrt(1e-300), 1e-100));
	  // node 0.11 has an imprecise Math.sinh with very small numbers
	  defineProperty(Math, 'sinh', MathShims.sinh, Math.sinh(-2e-17) !== -2e-17);
	  // FF 35 on Linux reports 22025.465794806725 for Math.expm1(10)
	  var expm1OfTen = Math.expm1(10);
	  defineProperty(Math, 'expm1', MathShims.expm1, expm1OfTen > 22025.465794806719 || expm1OfTen < 22025.4657948067165168);
	  // node v12.11 - v12.15 report NaN
	  defineProperty(Math, 'hypot', MathShims.hypot, Math.hypot(Infinity, NaN) !== Infinity);
	
	  var origMathRound = Math.round;
	  // breaks in e.g. Safari 8, Internet Explorer 11, Opera 12
	  var roundHandlesBoundaryConditions = Math.round(0.5 - (Number.EPSILON / 4)) === 0 &&
	    Math.round(-0.5 + (Number.EPSILON / 3.99)) === 1;
	
	  // When engines use Math.floor(x + 0.5) internally, Math.round can be buggy for large integers.
	  // This behavior should be governed by "round to nearest, ties to even mode"
	  // see http://www.ecma-international.org/ecma-262/6.0/#sec-terms-and-definitions-number-type
	  // These are the boundary cases where it breaks.
	  var smallestPositiveNumberWhereRoundBreaks = inverseEpsilon + 1;
	  var largestPositiveNumberWhereRoundBreaks = (2 * inverseEpsilon) - 1;
	  var roundDoesNotIncreaseIntegers = [
	    smallestPositiveNumberWhereRoundBreaks,
	    largestPositiveNumberWhereRoundBreaks
	  ].every(function (num) {
	    return Math.round(num) === num;
	  });
	  defineProperty(Math, 'round', function round(x) {
	    var floor = _floor(x);
	    var ceil = floor === -1 ? -0 : floor + 1;
	    return x - floor < 0.5 ? floor : ceil;
	  }, !roundHandlesBoundaryConditions || !roundDoesNotIncreaseIntegers);
	  Value.preserveToString(Math.round, origMathRound);
	
	  var origImul = Math.imul;
	  if (Math.imul(0xffffffff, 5) !== -5) {
	    // Safari 6.1, at least, reports "0" for this value
	    Math.imul = MathShims.imul;
	    Value.preserveToString(Math.imul, origImul);
	  }
	  if (Math.imul.length !== 2) {
	    // Safari 8.0.4 has a length of 1
	    // fixed in https://bugs.webkit.org/show_bug.cgi?id=143658
	    overrideNative(Math, 'imul', function imul(x, y) {
	      return ES.Call(origImul, Math, arguments);
	    });
	  }
	
	  // Promises
	  // Simplest possible implementation; use a 3rd-party library if you
	  // want the best possible speed and/or long stack traces.
	  var PromiseShim = (function () {
	    var setTimeout = globals.setTimeout;
	    // some environments don't have setTimeout - no way to shim here.
	    if (typeof setTimeout !== 'function' && typeof setTimeout !== 'object') { return; }
	
	    ES.IsPromise = function (promise) {
	      if (!ES.TypeIsObject(promise)) {
	        return false;
	      }
	      if (typeof promise._promise === 'undefined') {
	        return false; // uninitialized, or missing our hidden field.
	      }
	      return true;
	    };
	
	    // "PromiseCapability" in the spec is what most promise implementations
	    // call a "deferred".
	    var PromiseCapability = function (C) {
	      if (!ES.IsConstructor(C)) {
	        throw new TypeError('Bad promise constructor');
	      }
	      var capability = this;
	      var resolver = function (resolve, reject) {
	        if (capability.resolve !== void 0 || capability.reject !== void 0) {
	          throw new TypeError('Bad Promise implementation!');
	        }
	        capability.resolve = resolve;
	        capability.reject = reject;
	      };
	      // Initialize fields to inform optimizers about the object shape.
	      capability.resolve = void 0;
	      capability.reject = void 0;
	      capability.promise = new C(resolver);
	      if (!(ES.IsCallable(capability.resolve) && ES.IsCallable(capability.reject))) {
	        throw new TypeError('Bad promise constructor');
	      }
	    };
	
	    // find an appropriate setImmediate-alike
	    var makeZeroTimeout;
	    if (typeof window !== 'undefined' && ES.IsCallable(window.postMessage)) {
	      makeZeroTimeout = function () {
	        // from http://dbaron.org/log/20100309-faster-timeouts
	        var timeouts = [];
	        var messageName = 'zero-timeout-message';
	        var setZeroTimeout = function (fn) {
	          _push(timeouts, fn);
	          window.postMessage(messageName, '*');
	        };
	        var handleMessage = function (event) {
	          if (event.source === window && event.data === messageName) {
	            event.stopPropagation();
	            if (timeouts.length === 0) { return; }
	            var fn = _shift(timeouts);
	            fn();
	          }
	        };
	        window.addEventListener('message', handleMessage, true);
	        return setZeroTimeout;
	      };
	    }
	    var makePromiseAsap = function () {
	      // An efficient task-scheduler based on a pre-existing Promise
	      // implementation, which we can use even if we override the
	      // global Promise below (in order to workaround bugs)
	      // https://github.com/Raynos/observ-hash/issues/2#issuecomment-35857671
	      var P = globals.Promise;
	      var pr = P && P.resolve && P.resolve();
	      return pr && function (task) {
	        return pr.then(task);
	      };
	    };
	    var enqueue = ES.IsCallable(globals.setImmediate) ?
	      globals.setImmediate :
	      typeof process === 'object' && process.nextTick ? process.nextTick : makePromiseAsap() ||
	      (ES.IsCallable(makeZeroTimeout) ? makeZeroTimeout() : function (task) { setTimeout(task, 0); }); // fallback
	
	    // Constants for Promise implementation
	    var PROMISE_IDENTITY = function (x) { return x; };
	    var PROMISE_THROWER = function (e) { throw e; };
	    var PROMISE_PENDING = 0;
	    var PROMISE_FULFILLED = 1;
	    var PROMISE_REJECTED = 2;
	    // We store fulfill/reject handlers and capabilities in a single array.
	    var PROMISE_FULFILL_OFFSET = 0;
	    var PROMISE_REJECT_OFFSET = 1;
	    var PROMISE_CAPABILITY_OFFSET = 2;
	    // This is used in an optimization for chaining promises via then.
	    var PROMISE_FAKE_CAPABILITY = {};
	
	    var enqueuePromiseReactionJob = function (handler, capability, argument) {
	      enqueue(function () {
	        promiseReactionJob(handler, capability, argument);
	      });
	    };
	
	    var promiseReactionJob = function (handler, promiseCapability, argument) {
	      var handlerResult, f;
	      if (promiseCapability === PROMISE_FAKE_CAPABILITY) {
	        // Fast case, when we don't actually need to chain through to a
	        // (real) promiseCapability.
	        return handler(argument);
	      }
	      try {
	        handlerResult = handler(argument);
	        f = promiseCapability.resolve;
	      } catch (e) {
	        handlerResult = e;
	        f = promiseCapability.reject;
	      }
	      f(handlerResult);
	    };
	
	    var fulfillPromise = function (promise, value) {
	      var _promise = promise._promise;
	      var length = _promise.reactionLength;
	      if (length > 0) {
	        enqueuePromiseReactionJob(
	          _promise.fulfillReactionHandler0,
	          _promise.reactionCapability0,
	          value
	        );
	        _promise.fulfillReactionHandler0 = void 0;
	        _promise.rejectReactions0 = void 0;
	        _promise.reactionCapability0 = void 0;
	        if (length > 1) {
	          for (var i = 1, idx = 0; i < length; i++, idx += 3) {
	            enqueuePromiseReactionJob(
	              _promise[idx + PROMISE_FULFILL_OFFSET],
	              _promise[idx + PROMISE_CAPABILITY_OFFSET],
	              value
	            );
	            promise[idx + PROMISE_FULFILL_OFFSET] = void 0;
	            promise[idx + PROMISE_REJECT_OFFSET] = void 0;
	            promise[idx + PROMISE_CAPABILITY_OFFSET] = void 0;
	          }
	        }
	      }
	      _promise.result = value;
	      _promise.state = PROMISE_FULFILLED;
	      _promise.reactionLength = 0;
	    };
	
	    var rejectPromise = function (promise, reason) {
	      var _promise = promise._promise;
	      var length = _promise.reactionLength;
	      if (length > 0) {
	        enqueuePromiseReactionJob(
	          _promise.rejectReactionHandler0,
	          _promise.reactionCapability0,
	          reason
	        );
	        _promise.fulfillReactionHandler0 = void 0;
	        _promise.rejectReactions0 = void 0;
	        _promise.reactionCapability0 = void 0;
	        if (length > 1) {
	          for (var i = 1, idx = 0; i < length; i++, idx += 3) {
	            enqueuePromiseReactionJob(
	              _promise[idx + PROMISE_REJECT_OFFSET],
	              _promise[idx + PROMISE_CAPABILITY_OFFSET],
	              reason
	            );
	            promise[idx + PROMISE_FULFILL_OFFSET] = void 0;
	            promise[idx + PROMISE_REJECT_OFFSET] = void 0;
	            promise[idx + PROMISE_CAPABILITY_OFFSET] = void 0;
	          }
	        }
	      }
	      _promise.result = reason;
	      _promise.state = PROMISE_REJECTED;
	      _promise.reactionLength = 0;
	    };
	
	    var createResolvingFunctions = function (promise) {
	      var alreadyResolved = false;
	      var resolve = function (resolution) {
	        var then;
	        if (alreadyResolved) { return; }
	        alreadyResolved = true;
	        if (resolution === promise) {
	          return rejectPromise(promise, new TypeError('Self resolution'));
	        }
	        if (!ES.TypeIsObject(resolution)) {
	          return fulfillPromise(promise, resolution);
	        }
	        try {
	          then = resolution.then;
	        } catch (e) {
	          return rejectPromise(promise, e);
	        }
	        if (!ES.IsCallable(then)) {
	          return fulfillPromise(promise, resolution);
	        }
	        enqueue(function () {
	          promiseResolveThenableJob(promise, resolution, then);
	        });
	      };
	      var reject = function (reason) {
	        if (alreadyResolved) { return; }
	        alreadyResolved = true;
	        return rejectPromise(promise, reason);
	      };
	      return { resolve: resolve, reject: reject };
	    };
	
	    var optimizedThen = function (then, thenable, resolve, reject) {
	      // Optimization: since we discard the result, we can pass our
	      // own then implementation a special hint to let it know it
	      // doesn't have to create it.  (The PROMISE_FAKE_CAPABILITY
	      // object is local to this implementation and unforgeable outside.)
	      if (then === Promise$prototype$then) {
	        _call(then, thenable, resolve, reject, PROMISE_FAKE_CAPABILITY);
	      } else {
	        _call(then, thenable, resolve, reject);
	      }
	    };
	    var promiseResolveThenableJob = function (promise, thenable, then) {
	      var resolvingFunctions = createResolvingFunctions(promise);
	      var resolve = resolvingFunctions.resolve;
	      var reject = resolvingFunctions.reject;
	      try {
	        optimizedThen(then, thenable, resolve, reject);
	      } catch (e) {
	        reject(e);
	      }
	    };
	
	    var Promise$prototype, Promise$prototype$then;
	    var Promise = (function () {
	      var PromiseShim = function Promise(resolver) {
	        if (!(this instanceof PromiseShim)) {
	          throw new TypeError('Constructor Promise requires "new"');
	        }
	        if (this && this._promise) {
	          throw new TypeError('Bad construction');
	        }
	        // see https://bugs.ecmascript.org/show_bug.cgi?id=2482
	        if (!ES.IsCallable(resolver)) {
	          throw new TypeError('not a valid resolver');
	        }
	        var promise = emulateES6construct(this, PromiseShim, Promise$prototype, {
	          _promise: {
	            result: void 0,
	            state: PROMISE_PENDING,
	            // The first member of the "reactions" array is inlined here,
	            // since most promises only have one reaction.
	            // We've also exploded the 'reaction' object to inline the
	            // "handler" and "capability" fields, since both fulfill and
	            // reject reactions share the same capability.
	            reactionLength: 0,
	            fulfillReactionHandler0: void 0,
	            rejectReactionHandler0: void 0,
	            reactionCapability0: void 0
	          }
	        });
	        var resolvingFunctions = createResolvingFunctions(promise);
	        var reject = resolvingFunctions.reject;
	        try {
	          resolver(resolvingFunctions.resolve, reject);
	        } catch (e) {
	          reject(e);
	        }
	        return promise;
	      };
	      return PromiseShim;
	    }());
	    Promise$prototype = Promise.prototype;
	
	    var _promiseAllResolver = function (index, values, capability, remaining) {
	      var alreadyCalled = false;
	      return function (x) {
	        if (alreadyCalled) { return; }
	        alreadyCalled = true;
	        values[index] = x;
	        if ((--remaining.count) === 0) {
	          var resolve = capability.resolve;
	          resolve(values); // call w/ this===undefined
	        }
	      };
	    };
	
	    var performPromiseAll = function (iteratorRecord, C, resultCapability) {
	      var it = iteratorRecord.iterator;
	      var values = [];
	      var remaining = { count: 1 };
	      var next, nextValue;
	      var index = 0;
	      while (true) {
	        try {
	          next = ES.IteratorStep(it);
	          if (next === false) {
	            iteratorRecord.done = true;
	            break;
	          }
	          nextValue = next.value;
	        } catch (e) {
	          iteratorRecord.done = true;
	          throw e;
	        }
	        values[index] = void 0;
	        var nextPromise = C.resolve(nextValue);
	        var resolveElement = _promiseAllResolver(
	          index,
	          values,
	          resultCapability,
	          remaining
	        );
	        remaining.count += 1;
	        optimizedThen(nextPromise.then, nextPromise, resolveElement, resultCapability.reject);
	        index += 1;
	      }
	      if ((--remaining.count) === 0) {
	        var resolve = resultCapability.resolve;
	        resolve(values); // call w/ this===undefined
	      }
	      return resultCapability.promise;
	    };
	
	    var performPromiseRace = function (iteratorRecord, C, resultCapability) {
	      var it = iteratorRecord.iterator;
	      var next, nextValue, nextPromise;
	      while (true) {
	        try {
	          next = ES.IteratorStep(it);
	          if (next === false) {
	            // NOTE: If iterable has no items, resulting promise will never
	            // resolve; see:
	            // https://github.com/domenic/promises-unwrapping/issues/75
	            // https://bugs.ecmascript.org/show_bug.cgi?id=2515
	            iteratorRecord.done = true;
	            break;
	          }
	          nextValue = next.value;
	        } catch (e) {
	          iteratorRecord.done = true;
	          throw e;
	        }
	        nextPromise = C.resolve(nextValue);
	        optimizedThen(nextPromise.then, nextPromise, resultCapability.resolve, resultCapability.reject);
	      }
	      return resultCapability.promise;
	    };
	
	    defineProperties(Promise, {
	      all: function all(iterable) {
	        var C = this;
	        if (!ES.TypeIsObject(C)) {
	          throw new TypeError('Promise is not object');
	        }
	        var capability = new PromiseCapability(C);
	        var iterator, iteratorRecord;
	        try {
	          iterator = ES.GetIterator(iterable);
	          iteratorRecord = { iterator: iterator, done: false };
	          return performPromiseAll(iteratorRecord, C, capability);
	        } catch (e) {
	          var exception = e;
	          if (iteratorRecord && !iteratorRecord.done) {
	            try {
	              ES.IteratorClose(iterator, true);
	            } catch (ee) {
	              exception = ee;
	            }
	          }
	          var reject = capability.reject;
	          reject(exception);
	          return capability.promise;
	        }
	      },
	
	      race: function race(iterable) {
	        var C = this;
	        if (!ES.TypeIsObject(C)) {
	          throw new TypeError('Promise is not object');
	        }
	        var capability = new PromiseCapability(C);
	        var iterator, iteratorRecord;
	        try {
	          iterator = ES.GetIterator(iterable);
	          iteratorRecord = { iterator: iterator, done: false };
	          return performPromiseRace(iteratorRecord, C, capability);
	        } catch (e) {
	          var exception = e;
	          if (iteratorRecord && !iteratorRecord.done) {
	            try {
	              ES.IteratorClose(iterator, true);
	            } catch (ee) {
	              exception = ee;
	            }
	          }
	          var reject = capability.reject;
	          reject(exception);
	          return capability.promise;
	        }
	      },
	
	      reject: function reject(reason) {
	        var C = this;
	        if (!ES.TypeIsObject(C)) {
	          throw new TypeError('Bad promise constructor');
	        }
	        var capability = new PromiseCapability(C);
	        var rejectFunc = capability.reject;
	        rejectFunc(reason); // call with this===undefined
	        return capability.promise;
	      },
	
	      resolve: function resolve(v) {
	        // See https://esdiscuss.org/topic/fixing-promise-resolve for spec
	        var C = this;
	        if (!ES.TypeIsObject(C)) {
	          throw new TypeError('Bad promise constructor');
	        }
	        if (ES.IsPromise(v)) {
	          var constructor = v.constructor;
	          if (constructor === C) {
	            return v;
	          }
	        }
	        var capability = new PromiseCapability(C);
	        var resolveFunc = capability.resolve;
	        resolveFunc(v); // call with this===undefined
	        return capability.promise;
	      }
	    });
	
	    defineProperties(Promise$prototype, {
	      'catch': function (onRejected) {
	        return this.then(null, onRejected);
	      },
	
	      then: function then(onFulfilled, onRejected) {
	        var promise = this;
	        if (!ES.IsPromise(promise)) { throw new TypeError('not a promise'); }
	        var C = ES.SpeciesConstructor(promise, Promise);
	        var resultCapability;
	        var returnValueIsIgnored = arguments.length > 2 && arguments[2] === PROMISE_FAKE_CAPABILITY;
	        if (returnValueIsIgnored && C === Promise) {
	          resultCapability = PROMISE_FAKE_CAPABILITY;
	        } else {
	          resultCapability = new PromiseCapability(C);
	        }
	        // PerformPromiseThen(promise, onFulfilled, onRejected, resultCapability)
	        // Note that we've split the 'reaction' object into its two
	        // components, "capabilities" and "handler"
	        // "capabilities" is always equal to `resultCapability`
	        var fulfillReactionHandler = ES.IsCallable(onFulfilled) ? onFulfilled : PROMISE_IDENTITY;
	        var rejectReactionHandler = ES.IsCallable(onRejected) ? onRejected : PROMISE_THROWER;
	        var _promise = promise._promise;
	        var value;
	        if (_promise.state === PROMISE_PENDING) {
	          if (_promise.reactionLength === 0) {
	            _promise.fulfillReactionHandler0 = fulfillReactionHandler;
	            _promise.rejectReactionHandler0 = rejectReactionHandler;
	            _promise.reactionCapability0 = resultCapability;
	          } else {
	            var idx = 3 * (_promise.reactionLength - 1);
	            _promise[idx + PROMISE_FULFILL_OFFSET] = fulfillReactionHandler;
	            _promise[idx + PROMISE_REJECT_OFFSET] = rejectReactionHandler;
	            _promise[idx + PROMISE_CAPABILITY_OFFSET] = resultCapability;
	          }
	          _promise.reactionLength += 1;
	        } else if (_promise.state === PROMISE_FULFILLED) {
	          value = _promise.result;
	          enqueuePromiseReactionJob(
	            fulfillReactionHandler,
	            resultCapability,
	            value
	          );
	        } else if (_promise.state === PROMISE_REJECTED) {
	          value = _promise.result;
	          enqueuePromiseReactionJob(
	            rejectReactionHandler,
	            resultCapability,
	            value
	          );
	        } else {
	          throw new TypeError('unexpected Promise state');
	        }
	        return resultCapability.promise;
	      }
	    });
	    // This helps the optimizer by ensuring that methods which take
	    // capabilities aren't polymorphic.
	    PROMISE_FAKE_CAPABILITY = new PromiseCapability(Promise);
	    Promise$prototype$then = Promise$prototype.then;
	
	    return Promise;
	  }());
	
	  // Chrome's native Promise has extra methods that it shouldn't have. Let's remove them.
	  if (globals.Promise) {
	    delete globals.Promise.accept;
	    delete globals.Promise.defer;
	    delete globals.Promise.prototype.chain;
	  }
	
	  if (typeof PromiseShim === 'function') {
	    // export the Promise constructor.
	    defineProperties(globals, { Promise: PromiseShim });
	    // In Chrome 33 (and thereabouts) Promise is defined, but the
	    // implementation is buggy in a number of ways.  Let's check subclassing
	    // support to see if we have a buggy implementation.
	    var promiseSupportsSubclassing = supportsSubclassing(globals.Promise, function (S) {
	      return S.resolve(42).then(function () {}) instanceof S;
	    });
	    var promiseIgnoresNonFunctionThenCallbacks = !throwsError(function () {
	      return globals.Promise.reject(42).then(null, 5).then(null, noop);
	    });
	    var promiseRequiresObjectContext = throwsError(function () { return globals.Promise.call(3, noop); });
	    // Promise.resolve() was errata'ed late in the ES6 process.
	    // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1170742
	    //      https://code.google.com/p/v8/issues/detail?id=4161
	    // It serves as a proxy for a number of other bugs in early Promise
	    // implementations.
	    var promiseResolveBroken = (function (Promise) {
	      var p = Promise.resolve(5);
	      p.constructor = {};
	      var p2 = Promise.resolve(p);
	      try {
	        p2.then(null, noop).then(null, noop); // avoid "uncaught rejection" warnings in console
	      } catch (e) {
	        return true; // v8 native Promises break here https://code.google.com/p/chromium/issues/detail?id=575314
	      }
	      return p === p2; // This *should* be false!
	    }(globals.Promise));
	
	    // Chrome 46 (probably older too) does not retrieve a thenable's .then synchronously
	    var getsThenSynchronously = supportsDescriptors && (function () {
	      var count = 0;
	      // eslint-disable-next-line getter-return
	      var thenable = Object.defineProperty({}, 'then', { get: function () { count += 1; } });
	      Promise.resolve(thenable);
	      return count === 1;
	    }());
	
	    var BadResolverPromise = function BadResolverPromise(executor) {
	      var p = new Promise(executor);
	      executor(3, function () {});
	      this.then = p.then;
	      this.constructor = BadResolverPromise;
	    };
	    BadResolverPromise.prototype = Promise.prototype;
	    BadResolverPromise.all = Promise.all;
	    // Chrome Canary 49 (probably older too) has some implementation bugs
	    var hasBadResolverPromise = valueOrFalseIfThrows(function () {
	      return !!BadResolverPromise.all([1, 2]);
	    });
	
	    if (!promiseSupportsSubclassing || !promiseIgnoresNonFunctionThenCallbacks ||
	        !promiseRequiresObjectContext || promiseResolveBroken ||
	        !getsThenSynchronously || hasBadResolverPromise) {
	      /* globals Promise: true */
	      /* eslint-disable no-undef, no-global-assign */
	      Promise = PromiseShim;
	      /* eslint-enable no-undef, no-global-assign */
	      overrideNative(globals, 'Promise', PromiseShim);
	    }
	    if (Promise.all.length !== 1) {
	      var origAll = Promise.all;
	      overrideNative(Promise, 'all', function all(iterable) {
	        return ES.Call(origAll, this, arguments);
	      });
	    }
	    if (Promise.race.length !== 1) {
	      var origRace = Promise.race;
	      overrideNative(Promise, 'race', function race(iterable) {
	        return ES.Call(origRace, this, arguments);
	      });
	    }
	    if (Promise.resolve.length !== 1) {
	      var origResolve = Promise.resolve;
	      overrideNative(Promise, 'resolve', function resolve(x) {
	        return ES.Call(origResolve, this, arguments);
	      });
	    }
	    if (Promise.reject.length !== 1) {
	      var origReject = Promise.reject;
	      overrideNative(Promise, 'reject', function reject(r) {
	        return ES.Call(origReject, this, arguments);
	      });
	    }
	    ensureEnumerable(Promise, 'all');
	    ensureEnumerable(Promise, 'race');
	    ensureEnumerable(Promise, 'resolve');
	    ensureEnumerable(Promise, 'reject');
	    addDefaultSpecies(Promise);
	  }
	
	  // Map and Set require a true ES5 environment
	  // Their fast path also requires that the environment preserve
	  // property insertion order, which is not guaranteed by the spec.
	  var testOrder = function (a) {
	    var b = keys(_reduce(a, function (o, k) {
	      o[k] = true;
	      return o;
	    }, {}));
	    return a.join(':') === b.join(':');
	  };
	  var preservesInsertionOrder = testOrder(['z', 'a', 'bb']);
	  // some engines (eg, Chrome) only preserve insertion order for string keys
	  var preservesNumericInsertionOrder = testOrder(['z', 1, 'a', '3', 2]);
	
	  if (supportsDescriptors) {
	
	    var fastkey = function fastkey(key, skipInsertionOrderCheck) {
	      if (!skipInsertionOrderCheck && !preservesInsertionOrder) {
	        return null;
	      }
	      if (isNullOrUndefined(key)) {
	        return '^' + ES.ToString(key);
	      } else if (typeof key === 'string') {
	        return '$' + key;
	      } else if (typeof key === 'number') {
	        // note that -0 will get coerced to "0" when used as a property key
	        if (!preservesNumericInsertionOrder) {
	          return 'n' + key;
	        }
	        return key;
	      } else if (typeof key === 'boolean') {
	        return 'b' + key;
	      }
	      return null;
	    };
	
	    var emptyObject = function emptyObject() {
	      // accomodate some older not-quite-ES5 browsers
	      return Object.create ? Object.create(null) : {};
	    };
	
	    var addIterableToMap = function addIterableToMap(MapConstructor, map, iterable) {
	      if (isArray(iterable) || Type.string(iterable)) {
	        _forEach(iterable, function (entry) {
	          if (!ES.TypeIsObject(entry)) {
	            throw new TypeError('Iterator value ' + entry + ' is not an entry object');
	          }
	          map.set(entry[0], entry[1]);
	        });
	      } else if (iterable instanceof MapConstructor) {
	        _call(MapConstructor.prototype.forEach, iterable, function (value, key) {
	          map.set(key, value);
	        });
	      } else {
	        var iter, adder;
	        if (!isNullOrUndefined(iterable)) {
	          adder = map.set;
	          if (!ES.IsCallable(adder)) { throw new TypeError('bad map'); }
	          iter = ES.GetIterator(iterable);
	        }
	        if (typeof iter !== 'undefined') {
	          while (true) {
	            var next = ES.IteratorStep(iter);
	            if (next === false) { break; }
	            var nextItem = next.value;
	            try {
	              if (!ES.TypeIsObject(nextItem)) {
	                throw new TypeError('Iterator value ' + nextItem + ' is not an entry object');
	              }
	              _call(adder, map, nextItem[0], nextItem[1]);
	            } catch (e) {
	              ES.IteratorClose(iter, true);
	              throw e;
	            }
	          }
	        }
	      }
	    };
	    var addIterableToSet = function addIterableToSet(SetConstructor, set, iterable) {
	      if (isArray(iterable) || Type.string(iterable)) {
	        _forEach(iterable, function (value) {
	          set.add(value);
	        });
	      } else if (iterable instanceof SetConstructor) {
	        _call(SetConstructor.prototype.forEach, iterable, function (value) {
	          set.add(value);
	        });
	      } else {
	        var iter, adder;
	        if (!isNullOrUndefined(iterable)) {
	          adder = set.add;
	          if (!ES.IsCallable(adder)) { throw new TypeError('bad set'); }
	          iter = ES.GetIterator(iterable);
	        }
	        if (typeof iter !== 'undefined') {
	          while (true) {
	            var next = ES.IteratorStep(iter);
	            if (next === false) { break; }
	            var nextValue = next.value;
	            try {
	              _call(adder, set, nextValue);
	            } catch (e) {
	              ES.IteratorClose(iter, true);
	              throw e;
	            }
	          }
	        }
	      }
	    };
	
	    var collectionShims = {
	      Map: (function () {
	
	        var empty = {};
	
	        var MapEntry = function MapEntry(key, value) {
	          this.key = key;
	          this.value = value;
	          this.next = null;
	          this.prev = null;
	        };
	
	        MapEntry.prototype.isRemoved = function isRemoved() {
	          return this.key === empty;
	        };
	
	        var isMap = function isMap(map) {
	          return !!map._es6map;
	        };
	
	        var requireMapSlot = function requireMapSlot(map, method) {
	          if (!ES.TypeIsObject(map) || !isMap(map)) {
	            throw new TypeError('Method Map.prototype.' + method + ' called on incompatible receiver ' + ES.ToString(map));
	          }
	        };
	
	        var MapIterator = function MapIterator(map, kind) {
	          requireMapSlot(map, '[[MapIterator]]');
	          this.head = map._head;
	          this.i = this.head;
	          this.kind = kind;
	        };
	
	        MapIterator.prototype = {
	          isMapIterator: true,
	          next: function next() {
	            if (!this.isMapIterator) {
	              throw new TypeError('Not a MapIterator');
	            }
	            var i = this.i;
	            var kind = this.kind;
	            var head = this.head;
	            if (typeof this.i === 'undefined') {
	              return iteratorResult();
	            }
	            while (i.isRemoved() && i !== head) {
	              // back up off of removed entries
	              i = i.prev;
	            }
	            // advance to next unreturned element.
	            var result;
	            while (i.next !== head) {
	              i = i.next;
	              if (!i.isRemoved()) {
	                if (kind === 'key') {
	                  result = i.key;
	                } else if (kind === 'value') {
	                  result = i.value;
	                } else {
	                  result = [i.key, i.value];
	                }
	                this.i = i;
	                return iteratorResult(result);
	              }
	            }
	            // once the iterator is done, it is done forever.
	            this.i = void 0;
	            return iteratorResult();
	          }
	        };
	        addIterator(MapIterator.prototype);
	
	        var Map$prototype;
	        var MapShim = function Map() {
	          if (!(this instanceof Map)) {
	            throw new TypeError('Constructor Map requires "new"');
	          }
	          if (this && this._es6map) {
	            throw new TypeError('Bad construction');
	          }
	          var map = emulateES6construct(this, Map, Map$prototype, {
	            _es6map: true,
	            _head: null,
	            _map: OrigMap ? new OrigMap() : null,
	            _size: 0,
	            _storage: emptyObject()
	          });
	
	          var head = new MapEntry(null, null);
	          // circular doubly-linked list.
	          /* eslint no-multi-assign: 1 */
	          head.next = head.prev = head;
	          map._head = head;
	
	          // Optionally initialize map from iterable
	          if (arguments.length > 0) {
	            addIterableToMap(Map, map, arguments[0]);
	          }
	          return map;
	        };
	        Map$prototype = MapShim.prototype;
	
	        Value.getter(Map$prototype, 'size', function () {
	          if (typeof this._size === 'undefined') {
	            throw new TypeError('size method called on incompatible Map');
	          }
	          return this._size;
	        });
	
	        defineProperties(Map$prototype, {
	          get: function get(key) {
	            requireMapSlot(this, 'get');
	            var entry;
	            var fkey = fastkey(key, true);
	            if (fkey !== null) {
	              // fast O(1) path
	              entry = this._storage[fkey];
	              if (entry) {
	                return entry.value;
	              } else {
	                return;
	              }
	            }
	            if (this._map) {
	              // fast object key path
	              entry = origMapGet.call(this._map, key);
	              if (entry) {
	                return entry.value;
	              } else {
	                return;
	              }
	            }
	            var head = this._head;
	            var i = head;
	            while ((i = i.next) !== head) {
	              if (ES.SameValueZero(i.key, key)) {
	                return i.value;
	              }
	            }
	          },
	
	          has: function has(key) {
	            requireMapSlot(this, 'has');
	            var fkey = fastkey(key, true);
	            if (fkey !== null) {
	              // fast O(1) path
	              return typeof this._storage[fkey] !== 'undefined';
	            }
	            if (this._map) {
	              // fast object key path
	              return origMapHas.call(this._map, key);
	            }
	            var head = this._head;
	            var i = head;
	            while ((i = i.next) !== head) {
	              if (ES.SameValueZero(i.key, key)) {
	                return true;
	              }
	            }
	            return false;
	          },
	
	          set: function set(key, value) {
	            requireMapSlot(this, 'set');
	            var head = this._head;
	            var i = head;
	            var entry;
	            var fkey = fastkey(key, true);
	            if (fkey !== null) {
	              // fast O(1) path
	              if (typeof this._storage[fkey] !== 'undefined') {
	                this._storage[fkey].value = value;
	                return this;
	              } else {
	                entry = this._storage[fkey] = new MapEntry(key, value); /* eslint no-multi-assign: 1 */
	                i = head.prev;
	                // fall through
	              }
	            } else if (this._map) {
	              // fast object key path
	              if (origMapHas.call(this._map, key)) {
	                origMapGet.call(this._map, key).value = value;
	              } else {
	                entry = new MapEntry(key, value);
	                origMapSet.call(this._map, key, entry);
	                i = head.prev;
	                // fall through
	              }
	            }
	            while ((i = i.next) !== head) {
	              if (ES.SameValueZero(i.key, key)) {
	                i.value = value;
	                return this;
	              }
	            }
	            entry = entry || new MapEntry(key, value);
	            if (ES.SameValue(-0, key)) {
	              entry.key = +0; // coerce -0 to +0 in entry
	            }
	            entry.next = this._head;
	            entry.prev = this._head.prev;
	            entry.prev.next = entry;
	            entry.next.prev = entry;
	            this._size += 1;
	            return this;
	          },
	
	          'delete': function (key) {
	            requireMapSlot(this, 'delete');
	            var head = this._head;
	            var i = head;
	            var fkey = fastkey(key, true);
	            if (fkey !== null) {
	              // fast O(1) path
	              if (typeof this._storage[fkey] === 'undefined') {
	                return false;
	              }
	              i = this._storage[fkey].prev;
	              delete this._storage[fkey];
	              // fall through
	            } else if (this._map) {
	              // fast object key path
	              if (!origMapHas.call(this._map, key)) {
	                return false;
	              }
	              i = origMapGet.call(this._map, key).prev;
	              origMapDelete.call(this._map, key);
	              // fall through
	            }
	            while ((i = i.next) !== head) {
	              if (ES.SameValueZero(i.key, key)) {
	                i.key = empty;
	                i.value = empty;
	                i.prev.next = i.next;
	                i.next.prev = i.prev;
	                this._size -= 1;
	                return true;
	              }
	            }
	            return false;
	          },
	
	          clear: function clear() {
	            /* eslint no-multi-assign: 1 */
	            requireMapSlot(this, 'clear');
	            this._map = OrigMap ? new OrigMap() : null;
	            this._size = 0;
	            this._storage = emptyObject();
	            var head = this._head;
	            var i = head;
	            var p = i.next;
	            while ((i = p) !== head) {
	              i.key = empty;
	              i.value = empty;
	              p = i.next;
	              i.next = i.prev = head;
	            }
	            head.next = head.prev = head;
	          },
	
	          keys: function keys() {
	            requireMapSlot(this, 'keys');
	            return new MapIterator(this, 'key');
	          },
	
	          values: function values() {
	            requireMapSlot(this, 'values');
	            return new MapIterator(this, 'value');
	          },
	
	          entries: function entries() {
	            requireMapSlot(this, 'entries');
	            return new MapIterator(this, 'key+value');
	          },
	
	          forEach: function forEach(callback) {
	            requireMapSlot(this, 'forEach');
	            var context = arguments.length > 1 ? arguments[1] : null;
	            var it = this.entries();
	            for (var entry = it.next(); !entry.done; entry = it.next()) {
	              if (context) {
	                _call(callback, context, entry.value[1], entry.value[0], this);
	              } else {
	                callback(entry.value[1], entry.value[0], this);
	              }
	            }
	          }
	        });
	        addIterator(Map$prototype, Map$prototype.entries);
	
	        return MapShim;
	      }()),
	
	      Set: (function () {
	        var isSet = function isSet(set) {
	          return set._es6set && typeof set._storage !== 'undefined';
	        };
	        var requireSetSlot = function requireSetSlot(set, method) {
	          if (!ES.TypeIsObject(set) || !isSet(set)) {
	            // https://github.com/paulmillr/es6-shim/issues/176
	            throw new TypeError('Set.prototype.' + method + ' called on incompatible receiver ' + ES.ToString(set));
	          }
	        };
	
	        // Creating a Map is expensive.  To speed up the common case of
	        // Sets containing only string or numeric keys, we use an object
	        // as backing storage and lazily create a full Map only when
	        // required.
	        var Set$prototype;
	        var SetShim = function Set() {
	          if (!(this instanceof Set)) {
	            throw new TypeError('Constructor Set requires "new"');
	          }
	          if (this && this._es6set) {
	            throw new TypeError('Bad construction');
	          }
	          var set = emulateES6construct(this, Set, Set$prototype, {
	            _es6set: true,
	            '[[SetData]]': null,
	            _storage: emptyObject()
	          });
	          if (!set._es6set) {
	            throw new TypeError('bad set');
	          }
	
	          // Optionally initialize Set from iterable
	          if (arguments.length > 0) {
	            addIterableToSet(Set, set, arguments[0]);
	          }
	          return set;
	        };
	        Set$prototype = SetShim.prototype;
	
	        var decodeKey = function (key) {
	          var k = key;
	          if (k === '^null') {
	            return null;
	          } else if (k === '^undefined') {
	            return void 0;
	          } else {
	            var first = k.charAt(0);
	            if (first === '$') {
	              return _strSlice(k, 1);
	            } else if (first === 'n') {
	              return +_strSlice(k, 1);
	            } else if (first === 'b') {
	              return k === 'btrue';
	            }
	          }
	          return +k;
	        };
	        // Switch from the object backing storage to a full Map.
	        var ensureMap = function ensureMap(set) {
	          if (!set['[[SetData]]']) {
	            var m = new collectionShims.Map();
	            set['[[SetData]]'] = m;
	            _forEach(keys(set._storage), function (key) {
	              var k = decodeKey(key);
	              m.set(k, k);
	            });
	            set['[[SetData]]'] = m;
	          }
	          set._storage = null; // free old backing storage
	        };
	
	        Value.getter(SetShim.prototype, 'size', function () {
	          requireSetSlot(this, 'size');
	          if (this._storage) {
	            return keys(this._storage).length;
	          }
	          ensureMap(this);
	          return this['[[SetData]]'].size;
	        });
	
	        defineProperties(SetShim.prototype, {
	          has: function has(key) {
	            requireSetSlot(this, 'has');
	            var fkey;
	            if (this._storage && (fkey = fastkey(key)) !== null) {
	              return !!this._storage[fkey];
	            }
	            ensureMap(this);
	            return this['[[SetData]]'].has(key);
	          },
	
	          add: function add(key) {
	            requireSetSlot(this, 'add');
	            var fkey;
	            if (this._storage && (fkey = fastkey(key)) !== null) {
	              this._storage[fkey] = true;
	              return this;
	            }
	            ensureMap(this);
	            this['[[SetData]]'].set(key, key);
	            return this;
	          },
	
	          'delete': function (key) {
	            requireSetSlot(this, 'delete');
	            var fkey;
	            if (this._storage && (fkey = fastkey(key)) !== null) {
	              var hasFKey = _hasOwnProperty(this._storage, fkey);
	              return (delete this._storage[fkey]) && hasFKey;
	            }
	            ensureMap(this);
	            return this['[[SetData]]']['delete'](key);
	          },
	
	          clear: function clear() {
	            requireSetSlot(this, 'clear');
	            if (this._storage) {
	              this._storage = emptyObject();
	            }
	            if (this['[[SetData]]']) {
	              this['[[SetData]]'].clear();
	            }
	          },
	
	          values: function values() {
	            requireSetSlot(this, 'values');
	            ensureMap(this);
	            return new SetIterator(this['[[SetData]]'].values());
	          },
	
	          entries: function entries() {
	            requireSetSlot(this, 'entries');
	            ensureMap(this);
	            return new SetIterator(this['[[SetData]]'].entries());
	          },
	
	          forEach: function forEach(callback) {
	            requireSetSlot(this, 'forEach');
	            var context = arguments.length > 1 ? arguments[1] : null;
	            var entireSet = this;
	            ensureMap(entireSet);
	            this['[[SetData]]'].forEach(function (value, key) {
	              if (context) {
	                _call(callback, context, key, key, entireSet);
	              } else {
	                callback(key, key, entireSet);
	              }
	            });
	          }
	        });
	        defineProperty(SetShim.prototype, 'keys', SetShim.prototype.values, true);
	        addIterator(SetShim.prototype, SetShim.prototype.values);
	
	        var SetIterator = function SetIterator(it) {
	          this.it = it;
	        };
	        SetIterator.prototype = {
	          isSetIterator: true,
	          next: function next() {
	            if (!this.isSetIterator) {
	              throw new TypeError('Not a SetIterator');
	            }
	            return this.it.next();
	          }
	        };
	        addIterator(SetIterator.prototype);
	
	        return SetShim;
	      }())
	    };
	
	    var isGoogleTranslate = globals.Set && !Set.prototype['delete'] && Set.prototype.remove && Set.prototype.items && Set.prototype.map && Array.isArray(new Set().keys);
	    if (isGoogleTranslate) {
	      // special-case force removal of wildly invalid Set implementation in Google Translate iframes
	      // see https://github.com/paulmillr/es6-shim/issues/438 / https://twitter.com/ljharb/status/849335573114363904
	      globals.Set = collectionShims.Set;
	    }
	    if (globals.Map || globals.Set) {
	      // Safari 8, for example, doesn't accept an iterable.
	      var mapAcceptsArguments = valueOrFalseIfThrows(function () { return new Map([[1, 2]]).get(1) === 2; });
	      if (!mapAcceptsArguments) {
	        globals.Map = function Map() {
	          if (!(this instanceof Map)) {
	            throw new TypeError('Constructor Map requires "new"');
	          }
	          var m = new OrigMap();
	          if (arguments.length > 0) {
	            addIterableToMap(Map, m, arguments[0]);
	          }
	          delete m.constructor;
	          Object.setPrototypeOf(m, globals.Map.prototype);
	          return m;
	        };
	        globals.Map.prototype = create(OrigMap.prototype);
	        defineProperty(globals.Map.prototype, 'constructor', globals.Map, true);
	        Value.preserveToString(globals.Map, OrigMap);
	      }
	      var testMap = new Map();
	      var mapUsesSameValueZero = (function () {
	        // Chrome 38-42, node 0.11/0.12, iojs 1/2 also have a bug when the Map has a size > 4
	        var m = new Map([[1, 0], [2, 0], [3, 0], [4, 0]]);
	        m.set(-0, m);
	        return m.get(0) === m && m.get(-0) === m && m.has(0) && m.has(-0);
	      }());
	      var mapSupportsChaining = testMap.set(1, 2) === testMap;
	      if (!mapUsesSameValueZero || !mapSupportsChaining) {
	        overrideNative(Map.prototype, 'set', function set(k, v) {
	          _call(origMapSet, this, k === 0 ? 0 : k, v);
	          return this;
	        });
	      }
	      if (!mapUsesSameValueZero) {
	        defineProperties(Map.prototype, {
	          get: function get(k) {
	            return _call(origMapGet, this, k === 0 ? 0 : k);
	          },
	          has: function has(k) {
	            return _call(origMapHas, this, k === 0 ? 0 : k);
	          }
	        }, true);
	        Value.preserveToString(Map.prototype.get, origMapGet);
	        Value.preserveToString(Map.prototype.has, origMapHas);
	      }
	      var testSet = new Set();
	      var setUsesSameValueZero = Set.prototype['delete'] && Set.prototype.add && Set.prototype.has && (function (s) {
	        s['delete'](0);
	        s.add(-0);
	        return !s.has(0);
	      }(testSet));
	      var setSupportsChaining = testSet.add(1) === testSet;
	      if (!setUsesSameValueZero || !setSupportsChaining) {
	        var origSetAdd = Set.prototype.add;
	        Set.prototype.add = function add(v) {
	          _call(origSetAdd, this, v === 0 ? 0 : v);
	          return this;
	        };
	        Value.preserveToString(Set.prototype.add, origSetAdd);
	      }
	      if (!setUsesSameValueZero) {
	        var origSetHas = Set.prototype.has;
	        Set.prototype.has = function has(v) {
	          return _call(origSetHas, this, v === 0 ? 0 : v);
	        };
	        Value.preserveToString(Set.prototype.has, origSetHas);
	        var origSetDel = Set.prototype['delete'];
	        Set.prototype['delete'] = function SetDelete(v) {
	          return _call(origSetDel, this, v === 0 ? 0 : v);
	        };
	        Value.preserveToString(Set.prototype['delete'], origSetDel);
	      }
	      var mapSupportsSubclassing = supportsSubclassing(globals.Map, function (M) {
	        var m = new M([]);
	        // Firefox 32 is ok with the instantiating the subclass but will
	        // throw when the map is used.
	        m.set(42, 42);
	        return m instanceof M;
	      });
	      // without Object.setPrototypeOf, subclassing is not possible
	      var mapFailsToSupportSubclassing = Object.setPrototypeOf && !mapSupportsSubclassing;
	      var mapRequiresNew = (function () {
	        try {
	          return !(globals.Map() instanceof globals.Map);
	        } catch (e) {
	          return e instanceof TypeError;
	        }
	      }());
	      if (globals.Map.length !== 0 || mapFailsToSupportSubclassing || !mapRequiresNew) {
	        globals.Map = function Map() {
	          if (!(this instanceof Map)) {
	            throw new TypeError('Constructor Map requires "new"');
	          }
	          var m = new OrigMap();
	          if (arguments.length > 0) {
	            addIterableToMap(Map, m, arguments[0]);
	          }
	          delete m.constructor;
	          Object.setPrototypeOf(m, Map.prototype);
	          return m;
	        };
	        globals.Map.prototype = OrigMap.prototype;
	        defineProperty(globals.Map.prototype, 'constructor', globals.Map, true);
	        Value.preserveToString(globals.Map, OrigMap);
	      }
	      var setSupportsSubclassing = supportsSubclassing(globals.Set, function (S) {
	        var s = new S([]);
	        s.add(42, 42);
	        return s instanceof S;
	      });
	      // without Object.setPrototypeOf, subclassing is not possible
	      var setFailsToSupportSubclassing = Object.setPrototypeOf && !setSupportsSubclassing;
	      var setRequiresNew = (function () {
	        try {
	          return !(globals.Set() instanceof globals.Set);
	        } catch (e) {
	          return e instanceof TypeError;
	        }
	      }());
	      if (globals.Set.length !== 0 || setFailsToSupportSubclassing || !setRequiresNew) {
	        var OrigSet = globals.Set;
	        globals.Set = function Set() {
	          if (!(this instanceof Set)) {
	            throw new TypeError('Constructor Set requires "new"');
	          }
	          var s = new OrigSet();
	          if (arguments.length > 0) {
	            addIterableToSet(Set, s, arguments[0]);
	          }
	          delete s.constructor;
	          Object.setPrototypeOf(s, Set.prototype);
	          return s;
	        };
	        globals.Set.prototype = OrigSet.prototype;
	        defineProperty(globals.Set.prototype, 'constructor', globals.Set, true);
	        Value.preserveToString(globals.Set, OrigSet);
	      }
	      var newMap = new globals.Map();
	      var mapIterationThrowsStopIterator = !valueOrFalseIfThrows(function () {
	        return newMap.keys().next().done;
	      });
	      /*
	        - In Firefox < 23, Map#size is a function.
	        - In all current Firefox, Set#entries/keys/values & Map#clear do not exist
	        - https://bugzilla.mozilla.org/show_bug.cgi?id=869996
	        - In Firefox 24, Map and Set do not implement forEach
	        - In Firefox 25 at least, Map and Set are callable without "new"
	      */
	      if (
	        typeof globals.Map.prototype.clear !== 'function' ||
	        new globals.Set().size !== 0 ||
	        newMap.size !== 0 ||
	        typeof globals.Map.prototype.keys !== 'function' ||
	        typeof globals.Set.prototype.keys !== 'function' ||
	        typeof globals.Map.prototype.forEach !== 'function' ||
	        typeof globals.Set.prototype.forEach !== 'function' ||
	        isCallableWithoutNew(globals.Map) ||
	        isCallableWithoutNew(globals.Set) ||
	        typeof newMap.keys().next !== 'function' || // Safari 8
	        mapIterationThrowsStopIterator || // Firefox 25
	        !mapSupportsSubclassing
	      ) {
	        defineProperties(globals, {
	          Map: collectionShims.Map,
	          Set: collectionShims.Set
	        }, true);
	      }
	
	      if (globals.Set.prototype.keys !== globals.Set.prototype.values) {
	        // Fixed in WebKit with https://bugs.webkit.org/show_bug.cgi?id=144190
	        defineProperty(globals.Set.prototype, 'keys', globals.Set.prototype.values, true);
	      }
	
	      // Shim incomplete iterator implementations.
	      addIterator(Object.getPrototypeOf((new globals.Map()).keys()));
	      addIterator(Object.getPrototypeOf((new globals.Set()).keys()));
	
	      if (functionsHaveNames && globals.Set.prototype.has.name !== 'has') {
	        // Microsoft Edge v0.11.10074.0 is missing a name on Set#has
	        var anonymousSetHas = globals.Set.prototype.has;
	        overrideNative(globals.Set.prototype, 'has', function has(key) {
	          return _call(anonymousSetHas, this, key);
	        });
	      }
	    }
	    defineProperties(globals, collectionShims);
	    addDefaultSpecies(globals.Map);
	    addDefaultSpecies(globals.Set);
	  }
	
	  var throwUnlessTargetIsObject = function throwUnlessTargetIsObject(target) {
	    if (!ES.TypeIsObject(target)) {
	      throw new TypeError('target must be an object');
	    }
	  };
	
	  // Some Reflect methods are basically the same as
	  // those on the Object global, except that a TypeError is thrown if
	  // target isn't an object. As well as returning a boolean indicating
	  // the success of the operation.
	  var ReflectShims = {
	    // Apply method in a functional form.
	    apply: function apply() {
	      return ES.Call(ES.Call, null, arguments);
	    },
	
	    // New operator in a functional form.
	    construct: function construct(constructor, args) {
	      if (!ES.IsConstructor(constructor)) {
	        throw new TypeError('First argument must be a constructor.');
	      }
	      var newTarget = arguments.length > 2 ? arguments[2] : constructor;
	      if (!ES.IsConstructor(newTarget)) {
	        throw new TypeError('new.target must be a constructor.');
	      }
	      return ES.Construct(constructor, args, newTarget, 'internal');
	    },
	
	    // When deleting a non-existent or configurable property,
	    // true is returned.
	    // When attempting to delete a non-configurable property,
	    // it will return false.
	    deleteProperty: function deleteProperty(target, key) {
	      throwUnlessTargetIsObject(target);
	      if (supportsDescriptors) {
	        var desc = Object.getOwnPropertyDescriptor(target, key);
	
	        if (desc && !desc.configurable) {
	          return false;
	        }
	      }
	
	      // Will return true.
	      return delete target[key];
	    },
	
	    has: function has(target, key) {
	      throwUnlessTargetIsObject(target);
	      return key in target;
	    }
	  };
	
	  if (Object.getOwnPropertyNames) {
	    Object.assign(ReflectShims, {
	      // Basically the result of calling the internal [[OwnPropertyKeys]].
	      // Concatenating propertyNames and propertySymbols should do the trick.
	      // This should continue to work together with a Symbol shim
	      // which overrides Object.getOwnPropertyNames and implements
	      // Object.getOwnPropertySymbols.
	      ownKeys: function ownKeys(target) {
	        throwUnlessTargetIsObject(target);
	        var keys = Object.getOwnPropertyNames(target);
	
	        if (ES.IsCallable(Object.getOwnPropertySymbols)) {
	          _pushApply(keys, Object.getOwnPropertySymbols(target));
	        }
	
	        return keys;
	      }
	    });
	  }
	
	  var callAndCatchException = function ConvertExceptionToBoolean(func) {
	    return !throwsError(func);
	  };
	
	  if (Object.preventExtensions) {
	    Object.assign(ReflectShims, {
	      isExtensible: function isExtensible(target) {
	        throwUnlessTargetIsObject(target);
	        return Object.isExtensible(target);
	      },
	      preventExtensions: function preventExtensions(target) {
	        throwUnlessTargetIsObject(target);
	        return callAndCatchException(function () {
	          return Object.preventExtensions(target);
	        });
	      }
	    });
	  }
	
	  if (supportsDescriptors) {
	    var internalGet = function get(target, key, receiver) {
	      var desc = Object.getOwnPropertyDescriptor(target, key);
	
	      if (!desc) {
	        var parent = Object.getPrototypeOf(target);
	
	        if (parent === null) {
	          return void 0;
	        }
	
	        return internalGet(parent, key, receiver);
	      }
	
	      if ('value' in desc) {
	        return desc.value;
	      }
	
	      if (desc.get) {
	        return ES.Call(desc.get, receiver);
	      }
	
	      return void 0;
	    };
	
	    var internalSet = function set(target, key, value, receiver) {
	      var desc = Object.getOwnPropertyDescriptor(target, key);
	
	      if (!desc) {
	        var parent = Object.getPrototypeOf(target);
	
	        if (parent !== null) {
	          return internalSet(parent, key, value, receiver);
	        }
	
	        desc = {
	          value: void 0,
	          writable: true,
	          enumerable: true,
	          configurable: true
	        };
	      }
	
	      if ('value' in desc) {
	        if (!desc.writable) {
	          return false;
	        }
	
	        if (!ES.TypeIsObject(receiver)) {
	          return false;
	        }
	
	        var existingDesc = Object.getOwnPropertyDescriptor(receiver, key);
	
	        if (existingDesc) {
	          return Reflect.defineProperty(receiver, key, {
	            value: value
	          });
	        } else {
	          return Reflect.defineProperty(receiver, key, {
	            value: value,
	            writable: true,
	            enumerable: true,
	            configurable: true
	          });
	        }
	      }
	
	      if (desc.set) {
	        _call(desc.set, receiver, value);
	        return true;
	      }
	
	      return false;
	    };
	
	    Object.assign(ReflectShims, {
	      defineProperty: function defineProperty(target, propertyKey, attributes) {
	        throwUnlessTargetIsObject(target);
	        return callAndCatchException(function () {
	          return Object.defineProperty(target, propertyKey, attributes);
	        });
	      },
	
	      getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	        throwUnlessTargetIsObject(target);
	        return Object.getOwnPropertyDescriptor(target, propertyKey);
	      },
	
	      // Syntax in a functional form.
	      get: function get(target, key) {
	        throwUnlessTargetIsObject(target);
	        var receiver = arguments.length > 2 ? arguments[2] : target;
	
	        return internalGet(target, key, receiver);
	      },
	
	      set: function set(target, key, value) {
	        throwUnlessTargetIsObject(target);
	        var receiver = arguments.length > 3 ? arguments[3] : target;
	
	        return internalSet(target, key, value, receiver);
	      }
	    });
	  }
	
	  if (Object.getPrototypeOf) {
	    var objectDotGetPrototypeOf = Object.getPrototypeOf;
	    ReflectShims.getPrototypeOf = function getPrototypeOf(target) {
	      throwUnlessTargetIsObject(target);
	      return objectDotGetPrototypeOf(target);
	    };
	  }
	
	  if (Object.setPrototypeOf && ReflectShims.getPrototypeOf) {
	    var willCreateCircularPrototype = function (object, lastProto) {
	      var proto = lastProto;
	      while (proto) {
	        if (object === proto) {
	          return true;
	        }
	        proto = ReflectShims.getPrototypeOf(proto);
	      }
	      return false;
	    };
	
	    Object.assign(ReflectShims, {
	      // Sets the prototype of the given object.
	      // Returns true on success, otherwise false.
	      setPrototypeOf: function setPrototypeOf(object, proto) {
	        throwUnlessTargetIsObject(object);
	        if (proto !== null && !ES.TypeIsObject(proto)) {
	          throw new TypeError('proto must be an object or null');
	        }
	
	        // If they already are the same, we're done.
	        if (proto === Reflect.getPrototypeOf(object)) {
	          return true;
	        }
	
	        // Cannot alter prototype if object not extensible.
	        if (Reflect.isExtensible && !Reflect.isExtensible(object)) {
	          return false;
	        }
	
	        // Ensure that we do not create a circular prototype chain.
	        if (willCreateCircularPrototype(object, proto)) {
	          return false;
	        }
	
	        Object.setPrototypeOf(object, proto);
	
	        return true;
	      }
	    });
	  }
	  var defineOrOverrideReflectProperty = function (key, shim) {
	    if (!ES.IsCallable(globals.Reflect[key])) {
	      defineProperty(globals.Reflect, key, shim);
	    } else {
	      var acceptsPrimitives = valueOrFalseIfThrows(function () {
	        globals.Reflect[key](1);
	        globals.Reflect[key](NaN);
	        globals.Reflect[key](true);
	        return true;
	      });
	      if (acceptsPrimitives) {
	        overrideNative(globals.Reflect, key, shim);
	      }
	    }
	  };
	  Object.keys(ReflectShims).forEach(function (key) {
	    defineOrOverrideReflectProperty(key, ReflectShims[key]);
	  });
	  var originalReflectGetProto = globals.Reflect.getPrototypeOf;
	  if (functionsHaveNames && originalReflectGetProto && originalReflectGetProto.name !== 'getPrototypeOf') {
	    overrideNative(globals.Reflect, 'getPrototypeOf', function getPrototypeOf(target) {
	      return _call(originalReflectGetProto, globals.Reflect, target);
	    });
	  }
	  if (globals.Reflect.setPrototypeOf) {
	    if (valueOrFalseIfThrows(function () {
	      globals.Reflect.setPrototypeOf(1, {});
	      return true;
	    })) {
	      overrideNative(globals.Reflect, 'setPrototypeOf', ReflectShims.setPrototypeOf);
	    }
	  }
	  if (globals.Reflect.defineProperty) {
	    if (!valueOrFalseIfThrows(function () {
	      var basic = !globals.Reflect.defineProperty(1, 'test', { value: 1 });
	      // "extensible" fails on Edge 0.12
	      var extensible = typeof Object.preventExtensions !== 'function' || !globals.Reflect.defineProperty(Object.preventExtensions({}), 'test', {});
	      return basic && extensible;
	    })) {
	      overrideNative(globals.Reflect, 'defineProperty', ReflectShims.defineProperty);
	    }
	  }
	  if (globals.Reflect.construct) {
	    if (!valueOrFalseIfThrows(function () {
	      var F = function F() {};
	      return globals.Reflect.construct(function () {}, [], F) instanceof F;
	    })) {
	      overrideNative(globals.Reflect, 'construct', ReflectShims.construct);
	    }
	  }
	
	  if (String(new Date(NaN)) !== 'Invalid Date') {
	    var dateToString = Date.prototype.toString;
	    var shimmedDateToString = function toString() {
	      var valueOf = +this;
	      if (valueOf !== valueOf) {
	        return 'Invalid Date';
	      }
	      return ES.Call(dateToString, this);
	    };
	    overrideNative(Date.prototype, 'toString', shimmedDateToString);
	  }
	
	  // Annex B HTML methods
	  // http://www.ecma-international.org/ecma-262/6.0/#sec-additional-properties-of-the-string.prototype-object
	  var stringHTMLshims = {
	    anchor: function anchor(name) { return ES.CreateHTML(this, 'a', 'name', name); },
	    big: function big() { return ES.CreateHTML(this, 'big', '', ''); },
	    blink: function blink() { return ES.CreateHTML(this, 'blink', '', ''); },
	    bold: function bold() { return ES.CreateHTML(this, 'b', '', ''); },
	    fixed: function fixed() { return ES.CreateHTML(this, 'tt', '', ''); },
	    fontcolor: function fontcolor(color) { return ES.CreateHTML(this, 'font', 'color', color); },
	    fontsize: function fontsize(size) { return ES.CreateHTML(this, 'font', 'size', size); },
	    italics: function italics() { return ES.CreateHTML(this, 'i', '', ''); },
	    link: function link(url) { return ES.CreateHTML(this, 'a', 'href', url); },
	    small: function small() { return ES.CreateHTML(this, 'small', '', ''); },
	    strike: function strike() { return ES.CreateHTML(this, 'strike', '', ''); },
	    sub: function sub() { return ES.CreateHTML(this, 'sub', '', ''); },
	    sup: function sub() { return ES.CreateHTML(this, 'sup', '', ''); }
	  };
	  _forEach(Object.keys(stringHTMLshims), function (key) {
	    var method = String.prototype[key];
	    var shouldOverwrite = false;
	    if (ES.IsCallable(method)) {
	      var output = _call(method, '', ' " ');
	      var quotesCount = _concat([], output.match(/"/g)).length;
	      shouldOverwrite = output !== output.toLowerCase() || quotesCount > 2;
	    } else {
	      shouldOverwrite = true;
	    }
	    if (shouldOverwrite) {
	      overrideNative(String.prototype, key, stringHTMLshims[key]);
	    }
	  });
	
	  var JSONstringifiesSymbols = (function () {
	    // Microsoft Edge v0.12 stringifies Symbols incorrectly
	    if (!hasSymbols) { return false; } // Symbols are not supported
	    var stringify = typeof JSON === 'object' && typeof JSON.stringify === 'function' ? JSON.stringify : null;
	    if (!stringify) { return false; } // JSON.stringify is not supported
	    if (typeof stringify(Symbol()) !== 'undefined') { return true; } // Symbols should become `undefined`
	    if (stringify([Symbol()]) !== '[null]') { return true; } // Symbols in arrays should become `null`
	    var obj = { a: Symbol() };
	    obj[Symbol()] = true;
	    if (stringify(obj) !== '{}') { return true; } // Symbol-valued keys *and* Symbol-valued properties should be omitted
	    return false;
	  }());
	  var JSONstringifyAcceptsObjectSymbol = valueOrFalseIfThrows(function () {
	    // Chrome 45 throws on stringifying object symbols
	    if (!hasSymbols) { return true; } // Symbols are not supported
	    return JSON.stringify(Object(Symbol())) === '{}' && JSON.stringify([Object(Symbol())]) === '[{}]';
	  });
	  if (JSONstringifiesSymbols || !JSONstringifyAcceptsObjectSymbol) {
	    var origStringify = JSON.stringify;
	    overrideNative(JSON, 'stringify', function stringify(value) {
	      if (typeof value === 'symbol') { return; }
	      var replacer;
	      if (arguments.length > 1) {
	        replacer = arguments[1];
	      }
	      var args = [value];
	      if (!isArray(replacer)) {
	        var replaceFn = ES.IsCallable(replacer) ? replacer : null;
	        var wrappedReplacer = function (key, val) {
	          var parsedValue = replaceFn ? _call(replaceFn, this, key, val) : val;
	          if (typeof parsedValue !== 'symbol') {
	            if (Type.symbol(parsedValue)) {
	              return assignTo({})(parsedValue);
	            } else {
	              return parsedValue;
	            }
	          }
	        };
	        args.push(wrappedReplacer);
	      } else {
	        // create wrapped replacer that handles an array replacer?
	        args.push(replacer);
	      }
	      if (arguments.length > 2) {
	        args.push(arguments[2]);
	      }
	      return origStringify.apply(this, args);
	    });
	  }
	
	  return globals;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(82)))

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	if (!__webpack_require__(1492)()) {
		Object.defineProperty(__webpack_require__(142), "Symbol", {
			value: __webpack_require__(1497),
			configurable: true,
			enumerable: false,
			writable: true
		});
	}


/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var global     = __webpack_require__(142)
	  , validTypes = { object: true, symbol: true };
	
	module.exports = function () {
		var Symbol = global.Symbol;
		var symbol;
		if (typeof Symbol !== "function") return false;
		symbol = Symbol("test symbol");
		try { String(symbol); }
		catch (e) { return false; }
	
		// Return 'true' also for polyfills
		if (!validTypes[typeof Symbol.iterator]) return false;
		if (!validTypes[typeof Symbol.toPrimitive]) return false;
		if (!validTypes[typeof Symbol.toStringTag]) return false;
	
		return true;
	};


/***/ }),
/* 1493 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (value) {
		if (!value) return false;
		if (typeof value === "symbol") return true;
		if (!value.constructor) return false;
		if (value.constructor.name !== "Symbol") return false;
		return value[value.constructor.toStringTag] === "Symbol";
	};


/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var d = __webpack_require__(132);
	
	var create = Object.create, defineProperty = Object.defineProperty, objPrototype = Object.prototype;
	
	var created = create(null);
	module.exports = function (desc) {
		var postfix = 0, name, ie11BugWorkaround;
		while (created[desc + (postfix || "")]) ++postfix;
		desc += postfix || "";
		created[desc] = true;
		name = "@@" + desc;
		defineProperty(
			objPrototype,
			name,
			d.gs(null, function (value) {
				// For IE11 issue see:
				// https://connect.microsoft.com/IE/feedbackdetail/view/1928508/
				//    ie11-broken-getters-on-dom-objects
				// https://github.com/medikoo/es6-symbol/issues/12
				if (ie11BugWorkaround) return;
				ie11BugWorkaround = true;
				defineProperty(this, name, d(value));
				ie11BugWorkaround = false;
			})
		);
		return name;
	};


/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var d            = __webpack_require__(132)
	  , NativeSymbol = __webpack_require__(142).Symbol;
	
	module.exports = function (SymbolPolyfill) {
		return Object.defineProperties(SymbolPolyfill, {
			// To ensure proper interoperability with other native functions (e.g. Array.from)
			// fallback to eventual native implementation of given symbol
			hasInstance: d(
				"", (NativeSymbol && NativeSymbol.hasInstance) || SymbolPolyfill("hasInstance")
			),
			isConcatSpreadable: d(
				"",
				(NativeSymbol && NativeSymbol.isConcatSpreadable) ||
					SymbolPolyfill("isConcatSpreadable")
			),
			iterator: d("", (NativeSymbol && NativeSymbol.iterator) || SymbolPolyfill("iterator")),
			match: d("", (NativeSymbol && NativeSymbol.match) || SymbolPolyfill("match")),
			replace: d("", (NativeSymbol && NativeSymbol.replace) || SymbolPolyfill("replace")),
			search: d("", (NativeSymbol && NativeSymbol.search) || SymbolPolyfill("search")),
			species: d("", (NativeSymbol && NativeSymbol.species) || SymbolPolyfill("species")),
			split: d("", (NativeSymbol && NativeSymbol.split) || SymbolPolyfill("split")),
			toPrimitive: d(
				"", (NativeSymbol && NativeSymbol.toPrimitive) || SymbolPolyfill("toPrimitive")
			),
			toStringTag: d(
				"", (NativeSymbol && NativeSymbol.toStringTag) || SymbolPolyfill("toStringTag")
			),
			unscopables: d(
				"", (NativeSymbol && NativeSymbol.unscopables) || SymbolPolyfill("unscopables")
			)
		});
	};


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var d              = __webpack_require__(132)
	  , validateSymbol = __webpack_require__(342);
	
	var registry = Object.create(null);
	
	module.exports = function (SymbolPolyfill) {
		return Object.defineProperties(SymbolPolyfill, {
			for: d(function (key) {
				if (registry[key]) return registry[key];
				return (registry[key] = SymbolPolyfill(String(key)));
			}),
			keyFor: d(function (symbol) {
				var key;
				validateSymbol(symbol);
				for (key in registry) {
					if (registry[key] === symbol) return key;
				}
				return undefined;
			})
		});
	};


/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	// ES2015 Symbol polyfill for environments that do not (or partially) support it
	
	"use strict";
	
	var d                    = __webpack_require__(132)
	  , validateSymbol       = __webpack_require__(342)
	  , NativeSymbol         = __webpack_require__(142).Symbol
	  , generateName         = __webpack_require__(1494)
	  , setupStandardSymbols = __webpack_require__(1495)
	  , setupSymbolRegistry  = __webpack_require__(1496);
	
	var create = Object.create
	  , defineProperties = Object.defineProperties
	  , defineProperty = Object.defineProperty;
	
	var SymbolPolyfill, HiddenSymbol, isNativeSafe;
	
	if (typeof NativeSymbol === "function") {
		try {
			String(NativeSymbol());
			isNativeSafe = true;
		} catch (ignore) {}
	} else {
		NativeSymbol = null;
	}
	
	// Internal constructor (not one exposed) for creating Symbol instances.
	// This one is used to ensure that `someSymbol instanceof Symbol` always return false
	HiddenSymbol = function Symbol(description) {
		if (this instanceof HiddenSymbol) throw new TypeError("Symbol is not a constructor");
		return SymbolPolyfill(description);
	};
	
	// Exposed `Symbol` constructor
	// (returns instances of HiddenSymbol)
	module.exports = SymbolPolyfill = function Symbol(description) {
		var symbol;
		if (this instanceof Symbol) throw new TypeError("Symbol is not a constructor");
		if (isNativeSafe) return NativeSymbol(description);
		symbol = create(HiddenSymbol.prototype);
		description = description === undefined ? "" : String(description);
		return defineProperties(symbol, {
			__description__: d("", description),
			__name__: d("", generateName(description))
		});
	};
	
	setupStandardSymbols(SymbolPolyfill);
	setupSymbolRegistry(SymbolPolyfill);
	
	// Internal tweaks for real symbol producer
	defineProperties(HiddenSymbol.prototype, {
		constructor: d(SymbolPolyfill),
		toString: d("", function () { return this.__name__; })
	});
	
	// Proper implementation of methods exposed on Symbol.prototype
	// They won't be accessible on produced symbol instances as they derive from HiddenSymbol.prototype
	defineProperties(SymbolPolyfill.prototype, {
		toString: d(function () { return "Symbol (" + validateSymbol(this).__description__ + ")"; }),
		valueOf: d(function () { return validateSymbol(this); })
	});
	defineProperty(
		SymbolPolyfill.prototype,
		SymbolPolyfill.toPrimitive,
		d("", function () {
			var symbol = validateSymbol(this);
			if (typeof symbol === "symbol") return symbol;
			return symbol.toString();
		})
	);
	defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toStringTag, d("c", "Symbol"));
	
	// Proper implementaton of toPrimitive and toStringTag for returned symbol instances
	defineProperty(
		HiddenSymbol.prototype, SymbolPolyfill.toStringTag,
		d("c", SymbolPolyfill.prototype[SymbolPolyfill.toStringTag])
	);
	
	// Note: It's important to define `toPrimitive` as last one, as some implementations
	// implement `toPrimitive` natively without implementing `toStringTag` (or other specified symbols)
	// And that may invoke error in definition flow:
	// See: https://github.com/medikoo/es6-symbol/issues/13#issuecomment-164146149
	defineProperty(
		HiddenSymbol.prototype, SymbolPolyfill.toPrimitive,
		d("c", SymbolPolyfill.prototype[SymbolPolyfill.toPrimitive])
	);


/***/ }),
/* 1498 */
/***/ (function(module, exports) {

	var naiveFallback = function () {
		if (typeof self === "object" && self) return self;
		if (typeof window === "object" && window) return window;
		throw new Error("Unable to resolve global `this`");
	};
	
	module.exports = (function () {
		if (this) return this;
	
		// Unexpected strict mode (may happen if e.g. bundled into ESM module)
	
		// Thanks @mathiasbynens -> https://mathiasbynens.be/notes/globalthis
		// In all ES5+ engines global object inherits from Object.prototype
		// (if you approached one that doesn't please report)
		try {
			Object.defineProperty(Object.prototype, "__global__", {
				get: function () { return this; },
				configurable: true
			});
		} catch (error) {
			// Unfortunate case of Object.prototype being sealed (via preventExtensions, seal or freeze)
			return naiveFallback();
		}
		try {
			// Safari case (window.__global__ is resolved with global context, but __global__ does not)
			if (!__global__) return naiveFallback();
			return __global__;
		} finally {
			delete Object.prototype.__global__;
		}
	})();


/***/ }),
/* 1499 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function () {
		if (typeof globalThis !== "object") return false;
		if (!globalThis) return false;
		return globalThis.Array === Array;
	};


/***/ }),
/* 1500 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1501 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1502 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1503 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1504 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1505 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1507 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1508 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1509 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1511 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1512 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1513 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1514 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1515 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1516 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1517 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1518 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1519 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1521 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1522 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1523 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1524 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1525 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1526 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1527 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1529 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1530 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1531 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1532 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1534 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1535 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1536 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1537 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1538 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1539 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1540 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1541 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1542 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1543 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1544 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1546 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1547 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1549 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1550 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1551 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1552 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1553 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1554 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1555 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1558 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1559 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1560 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1561 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1562 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1564 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1566 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1567 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1568 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1569 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1570 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1571 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1572 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1573 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1574 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1575 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1576 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1577 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1578 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1580 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1581 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1582 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1583 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1584 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1585 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1586 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1587 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1588 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1589 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1590 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1591 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1592 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1593 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1594 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1595 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1596 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1597 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1598 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1599 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1600 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1601 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1602 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1603 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1604 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1605 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1606 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1607 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1608 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1609 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1610 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1611 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1612 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1613 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1614 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1615 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1616 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1617 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1618 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1619 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1620 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1621 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1622 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1623 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1624 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1625 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1626 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1627 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1628 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1629 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1630 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1631 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1632 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1633 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1634 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1635 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1636 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1637 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1638 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1639 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1640 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1641 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1642 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1643 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1644 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1645 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1646 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1647 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1648 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1649 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1650 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1651 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1652 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1653 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1654 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1655 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1656 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1657 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1658 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1659 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1660 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1661 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1662 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1663 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1664 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1665 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1666 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1667 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1668 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1669 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1670 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1671 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1672 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1673 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1674 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1675 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1676 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1677 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1678 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1679 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1680 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1681 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1682 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1683 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1684 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1685 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1686 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

	var wgs84 = __webpack_require__(2235);
	
	module.exports.geometry = geometry;
	module.exports.ring = ringArea;
	
	function geometry(_) {
	    var area = 0, i;
	    switch (_.type) {
	        case 'Polygon':
	            return polygonArea(_.coordinates);
	        case 'MultiPolygon':
	            for (i = 0; i < _.coordinates.length; i++) {
	                area += polygonArea(_.coordinates[i]);
	            }
	            return area;
	        case 'Point':
	        case 'MultiPoint':
	        case 'LineString':
	        case 'MultiLineString':
	            return 0;
	        case 'GeometryCollection':
	            for (i = 0; i < _.geometries.length; i++) {
	                area += geometry(_.geometries[i]);
	            }
	            return area;
	    }
	}
	
	function polygonArea(coords) {
	    var area = 0;
	    if (coords && coords.length > 0) {
	        area += Math.abs(ringArea(coords[0]));
	        for (var i = 1; i < coords.length; i++) {
	            area -= Math.abs(ringArea(coords[i]));
	        }
	    }
	    return area;
	}
	
	/**
	 * Calculate the approximate area of the polygon were it projected onto
	 *     the earth.  Note that this area will be positive if ring is oriented
	 *     clockwise, otherwise it will be negative.
	 *
	 * Reference:
	 * Robert. G. Chamberlain and William H. Duquette, "Some Algorithms for
	 *     Polygons on a Sphere", JPL Publication 07-03, Jet Propulsion
	 *     Laboratory, Pasadena, CA, June 2007 http://trs-new.jpl.nasa.gov/dspace/handle/2014/40409
	 *
	 * Returns:
	 * {float} The approximate signed geodesic area of the polygon in square
	 *     meters.
	 */
	
	function ringArea(coords) {
	    var p1, p2, p3, lowerIndex, middleIndex, upperIndex,
	    area = 0,
	    coordsLength = coords.length;
	
	    if (coordsLength > 2) {
	        for (i = 0; i < coordsLength; i++) {
	            if (i === coordsLength - 2) {// i = N-2
	                lowerIndex = coordsLength - 2;
	                middleIndex = coordsLength -1;
	                upperIndex = 0;
	            } else if (i === coordsLength - 1) {// i = N-1
	                lowerIndex = coordsLength - 1;
	                middleIndex = 0;
	                upperIndex = 1;
	            } else { // i = 0 to N-3
	                lowerIndex = i;
	                middleIndex = i+1;
	                upperIndex = i+2;
	            }
	            p1 = coords[lowerIndex];
	            p2 = coords[middleIndex];
	            p3 = coords[upperIndex];
	            area += ( rad(p3[0]) - rad(p1[0]) ) * Math.sin( rad(p2[1]));
	        }
	
	        area = area * wgs84.RADIUS * wgs84.RADIUS / 2;
	    }
	
	    return area;
	}
	
	function rad(_) {
	    return _ * Math.PI / 180;
	}

/***/ }),
/* 1688 */
/***/ (function(module, exports) {

	module.exports = normalize;
	
	var types = {
	    Point: 'geometry',
	    MultiPoint: 'geometry',
	    LineString: 'geometry',
	    MultiLineString: 'geometry',
	    Polygon: 'geometry',
	    MultiPolygon: 'geometry',
	    GeometryCollection: 'geometry',
	    Feature: 'feature',
	    FeatureCollection: 'featurecollection'
	};
	
	/**
	 * Normalize a GeoJSON feature into a FeatureCollection.
	 *
	 * @param {object} gj geojson data
	 * @returns {object} normalized geojson data
	 */
	function normalize(gj) {
	    if (!gj || !gj.type) return null;
	    var type = types[gj.type];
	    if (!type) return null;
	
	    if (type === 'geometry') {
	        return {
	            type: 'FeatureCollection',
	            features: [{
	                type: 'Feature',
	                properties: {},
	                geometry: gj
	            }]
	        };
	    } else if (type === 'feature') {
	        return {
	            type: 'FeatureCollection',
	            features: [gj]
	        };
	    } else if (type === 'featurecollection') {
	        return gj;
	    }
	}


/***/ }),
/* 1689 */
/***/ (function(module, exports) {

	module.exports = function() {
	    throw new Error('call .point() or .polygon() instead');
	};
	
	function position(bbox) {
	    if (bbox) return coordInBBBOX(bbox);
	    else return [lon(), lat()];
	}
	
	module.exports.position = position;
	
	module.exports.point = function(count, bbox) {
	    var features = [];
	    for (i = 0; i < count; i++) {
	        features.push(feature(bbox ? point(position(bbox)) : point()));
	    }
	    return collection(features);
	};
	
	module.exports.polygon = function(count, num_vertices, max_radial_length, bbox) {
	    if (typeof num_vertices !== 'number') num_vertices = 10;
	    if (typeof max_radial_length !== 'number') max_radial_length = 10;
	    var features = [];
	    for (i = 0; i < count; i++) {
	        var vertices = [],
	            circle_offsets = Array.apply(null,
	                new Array(num_vertices + 1)).map(Math.random);
	
	        circle_offsets.forEach(sumOffsets);
	        circle_offsets.forEach(scaleOffsets);
	        vertices[vertices.length - 1] = vertices[0]; // close the ring
	
	        // center the polygon around something
	        vertices = vertices.map(vertexToCoordinate(position(bbox)));
	        features.push(feature(polygon([vertices])));
	    }
	
	    function sumOffsets(cur, index, arr) {
	        arr[index] = (index > 0) ? cur + arr[index - 1] : cur;
	    }
	
	    function scaleOffsets(cur, index) {
	        cur = cur * 2 * Math.PI / circle_offsets[circle_offsets.length - 1];
	        var radial_scaler = Math.random();
	        vertices.push([
	            radial_scaler * max_radial_length * Math.sin(cur),
	            radial_scaler * max_radial_length * Math.cos(cur)
	        ]);
	    }
	
	    return collection(features);
	};
	
	
	function vertexToCoordinate(hub) {
	    return function(cur, index) { return [cur[0] + hub[0], cur[1] + hub[1]]; };
	}
	
	function rnd() { return Math.random() - 0.5; }
	function lon() { return rnd() * 360; }
	function lat() { return rnd() * 180; }
	
	function point(coordinates) {
	    return {
	        type: 'Point',
	        coordinates: coordinates || [lon(), lat()]
	    };
	}
	
	function coordInBBBOX(bbox) {
	    return [
	        (Math.random() * (bbox[2] - bbox[0])) + bbox[0],
	        (Math.random() * (bbox[3] - bbox[1])) + bbox[1]];
	}
	
	function pointInBBBOX() {
	    return {
	        type: 'Point',
	        coordinates: [lon(), lat()]
	    };
	}
	
	function polygon(coordinates) {
	    return {
	        type: 'Polygon',
	        coordinates: coordinates
	    };
	}
	
	function feature(geom) {
	    return {
	        type: 'Feature',
	        geometry: geom,
	        properties: {}
	    };
	}
	
	function collection(f) {
	    return {
	        type: 'FeatureCollection',
	        features: f
	    };
	}


/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<ul class=\"pagination no-margin\"> <li class=btn-page :class=\"{'disabled': model.page() == 1}\"> <a href=javascript:; @click=previous()><img src=" + __webpack_require__(1857) + " alt=\"\"></a></li> <li class=btn-page :class=\"{'disabled': model.page() == model.pageCount()}\"> <a href=javascript:; @click=next()><img src=" + __webpack_require__(1858) + " alt=\"\"></a> </li> </ul> ";

/***/ }),
/* 1691 */
/***/ (function(module, exports) {

	module.exports = "<ul class=\"pagination margin-10\"> <li class=\"paginate_button previous\" :class=\"{'disabled': model.page() == 1}\"> <a href=javascript:; @click=previous()>Anterior</a></li> <li class=paginate_button v-for=\"p in model.pages()\" :class=\"{'active': model.page() == p}\"> <a href=javascript:; @click=toPage(p)>{{ p }}</a> </li> <li class=\"paginate_button next\" :class=\"{'disabled': model.page() == model.pageCount()}\"> <a href=javascript:; @click=next()>Próxima</a> </li> </ul> ";

/***/ }),
/* 1692 */
/***/ (function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	//High level idea:
	// 1. Use Clarkson's incremental construction to find convex hull
	// 2. Point location in triangulation by jump and walk
	
	module.exports = incrementalConvexHull
	
	var orient = __webpack_require__(221)
	var compareCell = __webpack_require__(1724).compareCells
	
	function compareInt(a, b) {
	  return a - b
	}
	
	function Simplex(vertices, adjacent, boundary) {
	  this.vertices = vertices
	  this.adjacent = adjacent
	  this.boundary = boundary
	  this.lastVisited = -1
	}
	
	Simplex.prototype.flip = function() {
	  var t = this.vertices[0]
	  this.vertices[0] = this.vertices[1]
	  this.vertices[1] = t
	  var u = this.adjacent[0]
	  this.adjacent[0] = this.adjacent[1]
	  this.adjacent[1] = u
	}
	
	function GlueFacet(vertices, cell, index) {
	  this.vertices = vertices
	  this.cell = cell
	  this.index = index
	}
	
	function compareGlue(a, b) {
	  return compareCell(a.vertices, b.vertices)
	}
	
	function bakeOrient(d) {
	  var code = ["function orient(){var tuple=this.tuple;return test("]
	  for(var i=0; i<=d; ++i) {
	    if(i > 0) {
	      code.push(",")
	    }
	    code.push("tuple[", i, "]")
	  }
	  code.push(")}return orient")
	  var proc = new Function("test", code.join(""))
	  var test = orient[d+1]
	  if(!test) {
	    test = orient
	  }
	  return proc(test)
	}
	
	var BAKED = []
	
	function Triangulation(dimension, vertices, simplices) {
	  this.dimension = dimension
	  this.vertices = vertices
	  this.simplices = simplices
	  this.interior = simplices.filter(function(c) {
	    return !c.boundary
	  })
	
	  this.tuple = new Array(dimension+1)
	  for(var i=0; i<=dimension; ++i) {
	    this.tuple[i] = this.vertices[i]
	  }
	
	  var o = BAKED[dimension]
	  if(!o) {
	    o = BAKED[dimension] = bakeOrient(dimension)
	  }
	  this.orient = o
	}
	
	var proto = Triangulation.prototype
	
	//Degenerate situation where we are on boundary, but coplanar to face
	proto.handleBoundaryDegeneracy = function(cell, point) {
	  var d = this.dimension
	  var n = this.vertices.length - 1
	  var tuple = this.tuple
	  var verts = this.vertices
	
	  //Dumb solution: Just do dfs from boundary cell until we find any peak, or terminate
	  var toVisit = [ cell ]
	  cell.lastVisited = -n
	  while(toVisit.length > 0) {
	    cell = toVisit.pop()
	    var cellVerts = cell.vertices
	    var cellAdj = cell.adjacent
	    for(var i=0; i<=d; ++i) {
	      var neighbor = cellAdj[i]
	      if(!neighbor.boundary || neighbor.lastVisited <= -n) {
	        continue
	      }
	      var nv = neighbor.vertices
	      for(var j=0; j<=d; ++j) {
	        var vv = nv[j]
	        if(vv < 0) {
	          tuple[j] = point
	        } else {
	          tuple[j] = verts[vv]
	        }
	      }
	      var o = this.orient()
	      if(o > 0) {
	        return neighbor
	      }
	      neighbor.lastVisited = -n
	      if(o === 0) {
	        toVisit.push(neighbor)
	      }
	    }
	  }
	  return null
	}
	
	proto.walk = function(point, random) {
	  //Alias local properties
	  var n = this.vertices.length - 1
	  var d = this.dimension
	  var verts = this.vertices
	  var tuple = this.tuple
	
	  //Compute initial jump cell
	  var initIndex = random ? (this.interior.length * Math.random())|0 : (this.interior.length-1)
	  var cell = this.interior[ initIndex ]
	
	  //Start walking
	outerLoop:
	  while(!cell.boundary) {
	    var cellVerts = cell.vertices
	    var cellAdj = cell.adjacent
	
	    for(var i=0; i<=d; ++i) {
	      tuple[i] = verts[cellVerts[i]]
	    }
	    cell.lastVisited = n
	
	    //Find farthest adjacent cell
	    for(var i=0; i<=d; ++i) {
	      var neighbor = cellAdj[i]
	      if(neighbor.lastVisited >= n) {
	        continue
	      }
	      var prev = tuple[i]
	      tuple[i] = point
	      var o = this.orient()
	      tuple[i] = prev
	      if(o < 0) {
	        cell = neighbor
	        continue outerLoop
	      } else {
	        if(!neighbor.boundary) {
	          neighbor.lastVisited = n
	        } else {
	          neighbor.lastVisited = -n
	        }
	      }
	    }
	    return
	  }
	
	  return cell
	}
	
	proto.addPeaks = function(point, cell) {
	  var n = this.vertices.length - 1
	  var d = this.dimension
	  var verts = this.vertices
	  var tuple = this.tuple
	  var interior = this.interior
	  var simplices = this.simplices
	
	  //Walking finished at boundary, time to add peaks
	  var tovisit = [ cell ]
	
	  //Stretch initial boundary cell into a peak
	  cell.lastVisited = n
	  cell.vertices[cell.vertices.indexOf(-1)] = n
	  cell.boundary = false
	  interior.push(cell)
	
	  //Record a list of all new boundaries created by added peaks so we can glue them together when we are all done
	  var glueFacets = []
	
	  //Do a traversal of the boundary walking outward from starting peak
	  while(tovisit.length > 0) {
	    //Pop off peak and walk over adjacent cells
	    var cell = tovisit.pop()
	    var cellVerts = cell.vertices
	    var cellAdj = cell.adjacent
	    var indexOfN = cellVerts.indexOf(n)
	    if(indexOfN < 0) {
	      continue
	    }
	
	    for(var i=0; i<=d; ++i) {
	      if(i === indexOfN) {
	        continue
	      }
	
	      //For each boundary neighbor of the cell
	      var neighbor = cellAdj[i]
	      if(!neighbor.boundary || neighbor.lastVisited >= n) {
	        continue
	      }
	
	      var nv = neighbor.vertices
	
	      //Test if neighbor is a peak
	      if(neighbor.lastVisited !== -n) {      
	        //Compute orientation of p relative to each boundary peak
	        var indexOfNeg1 = 0
	        for(var j=0; j<=d; ++j) {
	          if(nv[j] < 0) {
	            indexOfNeg1 = j
	            tuple[j] = point
	          } else {
	            tuple[j] = verts[nv[j]]
	          }
	        }
	        var o = this.orient()
	
	        //Test if neighbor cell is also a peak
	        if(o > 0) {
	          nv[indexOfNeg1] = n
	          neighbor.boundary = false
	          interior.push(neighbor)
	          tovisit.push(neighbor)
	          neighbor.lastVisited = n
	          continue
	        } else {
	          neighbor.lastVisited = -n
	        }
	      }
	
	      var na = neighbor.adjacent
	
	      //Otherwise, replace neighbor with new face
	      var vverts = cellVerts.slice()
	      var vadj = cellAdj.slice()
	      var ncell = new Simplex(vverts, vadj, true)
	      simplices.push(ncell)
	
	      //Connect to neighbor
	      var opposite = na.indexOf(cell)
	      if(opposite < 0) {
	        continue
	      }
	      na[opposite] = ncell
	      vadj[indexOfN] = neighbor
	
	      //Connect to cell
	      vverts[i] = -1
	      vadj[i] = cell
	      cellAdj[i] = ncell
	
	      //Flip facet
	      ncell.flip()
	
	      //Add to glue list
	      for(var j=0; j<=d; ++j) {
	        var uu = vverts[j]
	        if(uu < 0 || uu === n) {
	          continue
	        }
	        var nface = new Array(d-1)
	        var nptr = 0
	        for(var k=0; k<=d; ++k) {
	          var vv = vverts[k]
	          if(vv < 0 || k === j) {
	            continue
	          }
	          nface[nptr++] = vv
	        }
	        glueFacets.push(new GlueFacet(nface, ncell, j))
	      }
	    }
	  }
	
	  //Glue boundary facets together
	  glueFacets.sort(compareGlue)
	
	  for(var i=0; i+1<glueFacets.length; i+=2) {
	    var a = glueFacets[i]
	    var b = glueFacets[i+1]
	    var ai = a.index
	    var bi = b.index
	    if(ai < 0 || bi < 0) {
	      continue
	    }
	    a.cell.adjacent[a.index] = b.cell
	    b.cell.adjacent[b.index] = a.cell
	  }
	}
	
	proto.insert = function(point, random) {
	  //Add point
	  var verts = this.vertices
	  verts.push(point)
	
	  var cell = this.walk(point, random)
	  if(!cell) {
	    return
	  }
	
	  //Alias local properties
	  var d = this.dimension
	  var tuple = this.tuple
	
	  //Degenerate case: If point is coplanar to cell, then walk until we find a non-degenerate boundary
	  for(var i=0; i<=d; ++i) {
	    var vv = cell.vertices[i]
	    if(vv < 0) {
	      tuple[i] = point
	    } else {
	      tuple[i] = verts[vv]
	    }
	  }
	  var o = this.orient(tuple)
	  if(o < 0) {
	    return
	  } else if(o === 0) {
	    cell = this.handleBoundaryDegeneracy(cell, point)
	    if(!cell) {
	      return
	    }
	  }
	
	  //Add peaks
	  this.addPeaks(point, cell)
	}
	
	//Extract all boundary cells
	proto.boundary = function() {
	  var d = this.dimension
	  var boundary = []
	  var cells = this.simplices
	  var nc = cells.length
	  for(var i=0; i<nc; ++i) {
	    var c = cells[i]
	    if(c.boundary) {
	      var bcell = new Array(d)
	      var cv = c.vertices
	      var ptr = 0
	      var parity = 0
	      for(var j=0; j<=d; ++j) {
	        if(cv[j] >= 0) {
	          bcell[ptr++] = cv[j]
	        } else {
	          parity = j&1
	        }
	      }
	      if(parity === (d&1)) {
	        var t = bcell[0]
	        bcell[0] = bcell[1]
	        bcell[1] = t
	      }
	      boundary.push(bcell)
	    }
	  }
	  return boundary
	}
	
	function incrementalConvexHull(points, randomSearch) {
	  var n = points.length
	  if(n === 0) {
	    throw new Error("Must have at least d+1 points")
	  }
	  var d = points[0].length
	  if(n <= d) {
	    throw new Error("Must input at least d+1 points")
	  }
	
	  //FIXME: This could be degenerate, but need to select d+1 non-coplanar points to bootstrap process
	  var initialSimplex = points.slice(0, d+1)
	
	  //Make sure initial simplex is positively oriented
	  var o = orient.apply(void 0, initialSimplex)
	  if(o === 0) {
	    throw new Error("Input not in general position")
	  }
	  var initialCoords = new Array(d+1)
	  for(var i=0; i<=d; ++i) {
	    initialCoords[i] = i
	  }
	  if(o < 0) {
	    initialCoords[0] = 1
	    initialCoords[1] = 0
	  }
	
	  //Create initial topological index, glue pointers together (kind of messy)
	  var initialCell = new Simplex(initialCoords, new Array(d+1), false)
	  var boundary = initialCell.adjacent
	  var list = new Array(d+2)
	  for(var i=0; i<=d; ++i) {
	    var verts = initialCoords.slice()
	    for(var j=0; j<=d; ++j) {
	      if(j === i) {
	        verts[j] = -1
	      }
	    }
	    var t = verts[0]
	    verts[0] = verts[1]
	    verts[1] = t
	    var cell = new Simplex(verts, new Array(d+1), true)
	    boundary[i] = cell
	    list[i] = cell
	  }
	  list[d+1] = initialCell
	  for(var i=0; i<=d; ++i) {
	    var verts = boundary[i].vertices
	    var adj = boundary[i].adjacent
	    for(var j=0; j<=d; ++j) {
	      var v = verts[j]
	      if(v < 0) {
	        adj[j] = initialCell
	        continue
	      }
	      for(var k=0; k<=d; ++k) {
	        if(boundary[k].vertices.indexOf(v) < 0) {
	          adj[j] = boundary[k]
	        }
	      }
	    }
	  }
	
	  //Initialize triangles
	  var triangles = new Triangulation(d, initialSimplex, list)
	
	  //Insert remaining points
	  var useRandom = !!randomSearch
	  for(var i=d+1; i<n; ++i) {
	    triangles.insert(points[i], useRandom)
	  }
	  
	  //Extract boundary cells
	  return triangles.boundary()
	}

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * jquery.mask.js
	 * @version: v1.14.16
	 * @author: Igor Escobar
	 *
	 * Created by Igor Escobar on 2012-03-10. Please report any bug at github.com/igorescobar/jQuery-Mask-Plugin
	 *
	 * Copyright (c) 2012 Igor Escobar http://igorescobar.com
	 *
	 * The MIT License (http://www.opensource.org/licenses/mit-license.php)
	 *
	 * Permission is hereby granted, free of charge, to any person
	 * obtaining a copy of this software and associated documentation
	 * files (the "Software"), to deal in the Software without
	 * restriction, including without limitation the rights to use,
	 * copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the
	 * Software is furnished to do so, subject to the following
	 * conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
	 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
	 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
	 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
	 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
	 * OTHER DEALINGS IN THE SOFTWARE.
	 */
	
	/* jshint laxbreak: true */
	/* jshint maxcomplexity:17 */
	/* global define */
	
	// UMD (Universal Module Definition) patterns for JavaScript modules that work everywhere.
	// https://github.com/umdjs/umd/blob/master/templates/jqueryPlugin.js
	(function (factory, jQuery, Zepto) {
	
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object' && typeof Meteor === 'undefined') {
	        module.exports = factory(require('jquery'));
	    } else {
	        factory(jQuery || Zepto);
	    }
	
	}(function ($) {
	    'use strict';
	
	    var Mask = function (el, mask, options) {
	
	        var p = {
	            invalid: [],
	            getCaret: function () {
	                try {
	                    var sel,
	                        pos = 0,
	                        ctrl = el.get(0),
	                        dSel = document.selection,
	                        cSelStart = ctrl.selectionStart;
	
	                    // IE Support
	                    if (dSel && navigator.appVersion.indexOf('MSIE 10') === -1) {
	                        sel = dSel.createRange();
	                        sel.moveStart('character', -p.val().length);
	                        pos = sel.text.length;
	                    }
	                    // Firefox support
	                    else if (cSelStart || cSelStart === '0') {
	                        pos = cSelStart;
	                    }
	
	                    return pos;
	                } catch (e) {}
	            },
	            setCaret: function(pos) {
	                try {
	                    if (el.is(':focus')) {
	                        var range, ctrl = el.get(0);
	
	                        // Firefox, WebKit, etc..
	                        if (ctrl.setSelectionRange) {
	                            ctrl.setSelectionRange(pos, pos);
	                        } else { // IE
	                            range = ctrl.createTextRange();
	                            range.collapse(true);
	                            range.moveEnd('character', pos);
	                            range.moveStart('character', pos);
	                            range.select();
	                        }
	                    }
	                } catch (e) {}
	            },
	            events: function() {
	                el
	                .on('keydown.mask', function(e) {
	                    el.data('mask-keycode', e.keyCode || e.which);
	                    el.data('mask-previus-value', el.val());
	                    el.data('mask-previus-caret-pos', p.getCaret());
	                    p.maskDigitPosMapOld = p.maskDigitPosMap;
	                })
	                .on($.jMaskGlobals.useInput ? 'input.mask' : 'keyup.mask', p.behaviour)
	                .on('paste.mask drop.mask', function() {
	                    setTimeout(function() {
	                        el.keydown().keyup();
	                    }, 100);
	                })
	                .on('change.mask', function(){
	                    el.data('changed', true);
	                })
	                .on('blur.mask', function(){
	                    if (oldValue !== p.val() && !el.data('changed')) {
	                        el.trigger('change');
	                    }
	                    el.data('changed', false);
	                })
	                // it's very important that this callback remains in this position
	                // otherwhise oldValue it's going to work buggy
	                .on('blur.mask', function() {
	                    oldValue = p.val();
	                })
	                // select all text on focus
	                .on('focus.mask', function (e) {
	                    if (options.selectOnFocus === true) {
	                        $(e.target).select();
	                    }
	                })
	                // clear the value if it not complete the mask
	                .on('focusout.mask', function() {
	                    if (options.clearIfNotMatch && !regexMask.test(p.val())) {
	                       p.val('');
	                   }
	                });
	            },
	            getRegexMask: function() {
	                var maskChunks = [], translation, pattern, optional, recursive, oRecursive, r;
	
	                for (var i = 0; i < mask.length; i++) {
	                    translation = jMask.translation[mask.charAt(i)];
	
	                    if (translation) {
	
	                        pattern = translation.pattern.toString().replace(/.{1}$|^.{1}/g, '');
	                        optional = translation.optional;
	                        recursive = translation.recursive;
	
	                        if (recursive) {
	                            maskChunks.push(mask.charAt(i));
	                            oRecursive = {digit: mask.charAt(i), pattern: pattern};
	                        } else {
	                            maskChunks.push(!optional && !recursive ? pattern : (pattern + '?'));
	                        }
	
	                    } else {
	                        maskChunks.push(mask.charAt(i).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
	                    }
	                }
	
	                r = maskChunks.join('');
	
	                if (oRecursive) {
	                    r = r.replace(new RegExp('(' + oRecursive.digit + '(.*' + oRecursive.digit + ')?)'), '($1)?')
	                         .replace(new RegExp(oRecursive.digit, 'g'), oRecursive.pattern);
	                }
	
	                return new RegExp(r);
	            },
	            destroyEvents: function() {
	                el.off(['input', 'keydown', 'keyup', 'paste', 'drop', 'blur', 'focusout', ''].join('.mask '));
	            },
	            val: function(v) {
	                var isInput = el.is('input'),
	                    method = isInput ? 'val' : 'text',
	                    r;
	
	                if (arguments.length > 0) {
	                    if (el[method]() !== v) {
	                        el[method](v);
	                    }
	                    r = el;
	                } else {
	                    r = el[method]();
	                }
	
	                return r;
	            },
	            calculateCaretPosition: function(oldVal) {
	                var newVal = p.getMasked(),
	                    caretPosNew = p.getCaret();
	                if (oldVal !== newVal) {
	                    var caretPosOld = el.data('mask-previus-caret-pos') || 0,
	                        newValL = newVal.length,
	                        oldValL = oldVal.length,
	                        maskDigitsBeforeCaret = 0,
	                        maskDigitsAfterCaret = 0,
	                        maskDigitsBeforeCaretAll = 0,
	                        maskDigitsBeforeCaretAllOld = 0,
	                        i = 0;
	
	                    for (i = caretPosNew; i < newValL; i++) {
	                        if (!p.maskDigitPosMap[i]) {
	                            break;
	                        }
	                        maskDigitsAfterCaret++;
	                    }
	
	                    for (i = caretPosNew - 1; i >= 0; i--) {
	                        if (!p.maskDigitPosMap[i]) {
	                            break;
	                        }
	                        maskDigitsBeforeCaret++;
	                    }
	
	                    for (i = caretPosNew - 1; i >= 0; i--) {
	                        if (p.maskDigitPosMap[i]) {
	                            maskDigitsBeforeCaretAll++;
	                        }
	                    }
	
	                    for (i = caretPosOld - 1; i >= 0; i--) {
	                        if (p.maskDigitPosMapOld[i]) {
	                            maskDigitsBeforeCaretAllOld++;
	                        }
	                    }
	
	                    // if the cursor is at the end keep it there
	                    if (caretPosNew > oldValL) {
	                      caretPosNew = newValL * 10;
	                    } else if (caretPosOld >= caretPosNew && caretPosOld !== oldValL) {
	                        if (!p.maskDigitPosMapOld[caretPosNew])  {
	                          var caretPos = caretPosNew;
	                          caretPosNew -= maskDigitsBeforeCaretAllOld - maskDigitsBeforeCaretAll;
	                          caretPosNew -= maskDigitsBeforeCaret;
	                          if (p.maskDigitPosMap[caretPosNew])  {
	                            caretPosNew = caretPos;
	                          }
	                        }
	                    }
	                    else if (caretPosNew > caretPosOld) {
	                        caretPosNew += maskDigitsBeforeCaretAll - maskDigitsBeforeCaretAllOld;
	                        caretPosNew += maskDigitsAfterCaret;
	                    }
	                }
	                return caretPosNew;
	            },
	            behaviour: function(e) {
	                e = e || window.event;
	                p.invalid = [];
	
	                var keyCode = el.data('mask-keycode');
	
	                if ($.inArray(keyCode, jMask.byPassKeys) === -1) {
	                    var newVal = p.getMasked(),
	                        caretPos = p.getCaret(),
	                        oldVal = el.data('mask-previus-value') || '';
	
	                    // this is a compensation to devices/browsers that don't compensate
	                    // caret positioning the right way
	                    setTimeout(function() {
	                      p.setCaret(p.calculateCaretPosition(oldVal));
	                    }, $.jMaskGlobals.keyStrokeCompensation);
	
	                    p.val(newVal);
	                    p.setCaret(caretPos);
	                    return p.callbacks(e);
	                }
	            },
	            getMasked: function(skipMaskChars, val) {
	                var buf = [],
	                    value = val === undefined ? p.val() : val + '',
	                    m = 0, maskLen = mask.length,
	                    v = 0, valLen = value.length,
	                    offset = 1, addMethod = 'push',
	                    resetPos = -1,
	                    maskDigitCount = 0,
	                    maskDigitPosArr = [],
	                    lastMaskChar,
	                    check;
	
	                if (options.reverse) {
	                    addMethod = 'unshift';
	                    offset = -1;
	                    lastMaskChar = 0;
	                    m = maskLen - 1;
	                    v = valLen - 1;
	                    check = function () {
	                        return m > -1 && v > -1;
	                    };
	                } else {
	                    lastMaskChar = maskLen - 1;
	                    check = function () {
	                        return m < maskLen && v < valLen;
	                    };
	                }
	
	                var lastUntranslatedMaskChar;
	                while (check()) {
	                    var maskDigit = mask.charAt(m),
	                        valDigit = value.charAt(v),
	                        translation = jMask.translation[maskDigit];
	
	                    if (translation) {
	                        if (valDigit.match(translation.pattern)) {
	                            buf[addMethod](valDigit);
	                             if (translation.recursive) {
	                                if (resetPos === -1) {
	                                    resetPos = m;
	                                } else if (m === lastMaskChar && m !== resetPos) {
	                                    m = resetPos - offset;
	                                }
	
	                                if (lastMaskChar === resetPos) {
	                                    m -= offset;
	                                }
	                            }
	                            m += offset;
	                        } else if (valDigit === lastUntranslatedMaskChar) {
	                            // matched the last untranslated (raw) mask character that we encountered
	                            // likely an insert offset the mask character from the last entry; fall
	                            // through and only increment v
	                            maskDigitCount--;
	                            lastUntranslatedMaskChar = undefined;
	                        } else if (translation.optional) {
	                            m += offset;
	                            v -= offset;
	                        } else if (translation.fallback) {
	                            buf[addMethod](translation.fallback);
	                            m += offset;
	                            v -= offset;
	                        } else {
	                          p.invalid.push({p: v, v: valDigit, e: translation.pattern});
	                        }
	                        v += offset;
	                    } else {
	                        if (!skipMaskChars) {
	                            buf[addMethod](maskDigit);
	                        }
	
	                        if (valDigit === maskDigit) {
	                            maskDigitPosArr.push(v);
	                            v += offset;
	                        } else {
	                            lastUntranslatedMaskChar = maskDigit;
	                            maskDigitPosArr.push(v + maskDigitCount);
	                            maskDigitCount++;
	                        }
	
	                        m += offset;
	                    }
	                }
	
	                var lastMaskCharDigit = mask.charAt(lastMaskChar);
	                if (maskLen === valLen + 1 && !jMask.translation[lastMaskCharDigit]) {
	                    buf.push(lastMaskCharDigit);
	                }
	
	                var newVal = buf.join('');
	                p.mapMaskdigitPositions(newVal, maskDigitPosArr, valLen);
	                return newVal;
	            },
	            mapMaskdigitPositions: function(newVal, maskDigitPosArr, valLen) {
	              var maskDiff = options.reverse ? newVal.length - valLen : 0;
	              p.maskDigitPosMap = {};
	              for (var i = 0; i < maskDigitPosArr.length; i++) {
	                p.maskDigitPosMap[maskDigitPosArr[i] + maskDiff] = 1;
	              }
	            },
	            callbacks: function (e) {
	                var val = p.val(),
	                    changed = val !== oldValue,
	                    defaultArgs = [val, e, el, options],
	                    callback = function(name, criteria, args) {
	                        if (typeof options[name] === 'function' && criteria) {
	                            options[name].apply(this, args);
	                        }
	                    };
	
	                callback('onChange', changed === true, defaultArgs);
	                callback('onKeyPress', changed === true, defaultArgs);
	                callback('onComplete', val.length === mask.length, defaultArgs);
	                callback('onInvalid', p.invalid.length > 0, [val, e, el, p.invalid, options]);
	            }
	        };
	
	        el = $(el);
	        var jMask = this, oldValue = p.val(), regexMask;
	
	        mask = typeof mask === 'function' ? mask(p.val(), undefined, el,  options) : mask;
	
	        // public methods
	        jMask.mask = mask;
	        jMask.options = options;
	        jMask.remove = function() {
	            var caret = p.getCaret();
	            if (jMask.options.placeholder) {
	                el.removeAttr('placeholder');
	            }
	            if (el.data('mask-maxlength')) {
	                el.removeAttr('maxlength');
	            }
	            p.destroyEvents();
	            p.val(jMask.getCleanVal());
	            p.setCaret(caret);
	            return el;
	        };
	
	        // get value without mask
	        jMask.getCleanVal = function() {
	           return p.getMasked(true);
	        };
	
	        // get masked value without the value being in the input or element
	        jMask.getMaskedVal = function(val) {
	           return p.getMasked(false, val);
	        };
	
	       jMask.init = function(onlyMask) {
	            onlyMask = onlyMask || false;
	            options = options || {};
	
	            jMask.clearIfNotMatch  = $.jMaskGlobals.clearIfNotMatch;
	            jMask.byPassKeys       = $.jMaskGlobals.byPassKeys;
	            jMask.translation      = $.extend({}, $.jMaskGlobals.translation, options.translation);
	
	            jMask = $.extend(true, {}, jMask, options);
	
	            regexMask = p.getRegexMask();
	
	            if (onlyMask) {
	                p.events();
	                p.val(p.getMasked());
	            } else {
	                if (options.placeholder) {
	                    el.attr('placeholder' , options.placeholder);
	                }
	
	                // this is necessary, otherwise if the user submit the form
	                // and then press the "back" button, the autocomplete will erase
	                // the data. Works fine on IE9+, FF, Opera, Safari.
	                if (el.data('mask')) {
	                  el.attr('autocomplete', 'off');
	                }
	
	                // detect if is necessary let the user type freely.
	                // for is a lot faster than forEach.
	                for (var i = 0, maxlength = true; i < mask.length; i++) {
	                    var translation = jMask.translation[mask.charAt(i)];
	                    if (translation && translation.recursive) {
	                        maxlength = false;
	                        break;
	                    }
	                }
	
	                if (maxlength) {
	                    el.attr('maxlength', mask.length).data('mask-maxlength', true);
	                }
	
	                p.destroyEvents();
	                p.events();
	
	                var caret = p.getCaret();
	                p.val(p.getMasked());
	                p.setCaret(caret);
	            }
	        };
	
	        jMask.init(!el.is('input'));
	    };
	
	    $.maskWatchers = {};
	    var HTMLAttributes = function () {
	        var input = $(this),
	            options = {},
	            prefix = 'data-mask-',
	            mask = input.attr('data-mask');
	
	        if (input.attr(prefix + 'reverse')) {
	            options.reverse = true;
	        }
	
	        if (input.attr(prefix + 'clearifnotmatch')) {
	            options.clearIfNotMatch = true;
	        }
	
	        if (input.attr(prefix + 'selectonfocus') === 'true') {
	           options.selectOnFocus = true;
	        }
	
	        if (notSameMaskObject(input, mask, options)) {
	            return input.data('mask', new Mask(this, mask, options));
	        }
	    },
	    notSameMaskObject = function(field, mask, options) {
	        options = options || {};
	        var maskObject = $(field).data('mask'),
	            stringify = JSON.stringify,
	            value = $(field).val() || $(field).text();
	        try {
	            if (typeof mask === 'function') {
	                mask = mask(value);
	            }
	            return typeof maskObject !== 'object' || stringify(maskObject.options) !== stringify(options) || maskObject.mask !== mask;
	        } catch (e) {}
	    },
	    eventSupported = function(eventName) {
	        var el = document.createElement('div'), isSupported;
	
	        eventName = 'on' + eventName;
	        isSupported = (eventName in el);
	
	        if ( !isSupported ) {
	            el.setAttribute(eventName, 'return;');
	            isSupported = typeof el[eventName] === 'function';
	        }
	        el = null;
	
	        return isSupported;
	    };
	
	    $.fn.mask = function(mask, options) {
	        options = options || {};
	        var selector = this.selector,
	            globals = $.jMaskGlobals,
	            interval = globals.watchInterval,
	            watchInputs = options.watchInputs || globals.watchInputs,
	            maskFunction = function() {
	                if (notSameMaskObject(this, mask, options)) {
	                    return $(this).data('mask', new Mask(this, mask, options));
	                }
	            };
	
	        $(this).each(maskFunction);
	
	        if (selector && selector !== '' && watchInputs) {
	            clearInterval($.maskWatchers[selector]);
	            $.maskWatchers[selector] = setInterval(function(){
	                $(document).find(selector).each(maskFunction);
	            }, interval);
	        }
	        return this;
	    };
	
	    $.fn.masked = function(val) {
	        return this.data('mask').getMaskedVal(val);
	    };
	
	    $.fn.unmask = function() {
	        clearInterval($.maskWatchers[this.selector]);
	        delete $.maskWatchers[this.selector];
	        return this.each(function() {
	            var dataMask = $(this).data('mask');
	            if (dataMask) {
	                dataMask.remove().removeData('mask');
	            }
	        });
	    };
	
	    $.fn.cleanVal = function() {
	        return this.data('mask').getCleanVal();
	    };
	
	    $.applyDataMask = function(selector) {
	        selector = selector || $.jMaskGlobals.maskElements;
	        var $selector = (selector instanceof $) ? selector : $(selector);
	        $selector.filter($.jMaskGlobals.dataMaskAttr).each(HTMLAttributes);
	    };
	
	    var globals = {
	        maskElements: 'input,td,span,div',
	        dataMaskAttr: '*[data-mask]',
	        dataMask: true,
	        watchInterval: 300,
	        watchInputs: true,
	        keyStrokeCompensation: 10,
	        // old versions of chrome dont work great with input event
	        useInput: !/Chrome\/[2-4][0-9]|SamsungBrowser/.test(window.navigator.userAgent) && eventSupported('input'),
	        watchDataMask: false,
	        byPassKeys: [9, 16, 17, 18, 36, 37, 38, 39, 40, 91],
	        translation: {
	            '0': {pattern: /\d/},
	            '9': {pattern: /\d/, optional: true},
	            '#': {pattern: /\d/, recursive: true},
	            'A': {pattern: /[a-zA-Z0-9]/},
	            'S': {pattern: /[a-zA-Z]/}
	        }
	    };
	
	    $.jMaskGlobals = $.jMaskGlobals || {};
	    globals = $.jMaskGlobals = $.extend(true, {}, globals, $.jMaskGlobals);
	
	    // looking for inputs with data-mask attribute
	    if (globals.dataMask) {
	        $.applyDataMask();
	    }
	
	    setInterval(function() {
	        if ($.jMaskGlobals.watchDataMask) {
	            $.applyDataMask();
	        }
	    }, globals.watchInterval);
	}, window.jQuery, window.Zepto));


/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.1
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function decode (s) {
			return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
		}
	
		function init (converter) {
			function api() {}
	
			function set (key, value, attributes) {
				if (typeof document === 'undefined') {
					return;
				}
	
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);
	
				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}
	
				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}
	
				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
	
				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);
	
				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
	
					// Considers RFC 6265 section 5.2:
					// ...
					// 3.  If the remaining unparsed-attributes contains a %x3B (";")
					//     character:
					// Consume the characters of the unparsed-attributes up to,
					// not including, the first %x3B (";") character.
					// ...
					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}
	
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}
	
			function get (key, json) {
				if (typeof document === 'undefined') {
					return;
				}
	
				var jar = {};
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all.
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = decode(parts[0]);
						cookie = (converter.read || converter)(cookie, name) ||
							decode(cookie);
	
						if (json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						jar[name] = cookie;
	
						if (key === name) {
							break;
						}
					} catch (e) {}
				}
	
				return key ? jar[key] : jar;
			}
	
			api.set = set;
			api.get = function (key) {
				return get(key, false /* read as raw */);
			};
			api.getJSON = function (key) {
				return get(key, true /* read as json */);
			};
			api.remove = function (key, attributes) {
				set(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.defaults = {};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),
/* 1696 */
/***/ (function(module, exports) {

	;(function(window){
	var hadGlobal = 'Modernizr' in window;
	var oldGlobal = window.Modernizr;
	/*! modernizr 3.11.8 (Custom Build) | MIT *
	 * https://modernizr.com/download/?-es5object-es6object-setclasses !*/
	!function(e,n,t,s){function o(e,n){return typeof e===n}var a=[],i={_version:"3.11.8",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){a.push({name:e,fn:n,options:t})},addAsyncTest:function(e){a.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=i,Modernizr=new Modernizr;var c=[],r=t.documentElement,f="svg"===r.nodeName.toLowerCase();Modernizr.addTest("es6object",!!(Object.assign&&Object.is&&Object.setPrototypeOf)),Modernizr.addTest("es5object",function(){return!!(Object.keys&&Object.create&&Object.getPrototypeOf&&Object.getOwnPropertyNames&&Object.isSealed&&Object.isFrozen&&Object.isExtensible&&Object.getOwnPropertyDescriptor&&Object.defineProperty&&Object.defineProperties&&Object.seal&&Object.freeze&&Object.preventExtensions)}),function(){var e,n,t,s,i,r,f;for(var l in a)if(a.hasOwnProperty(l)){if(e=[],n=a[l],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(s=o(n.fn,"function")?n.fn():n.fn,i=0;i<e.length;i++)r=e[i],f=r.split("."),1===f.length?Modernizr[f[0]]=s:(Modernizr[f[0]]&&(!Modernizr[f[0]]||Modernizr[f[0]]instanceof Boolean)||(Modernizr[f[0]]=new Boolean(Modernizr[f[0]])),Modernizr[f[0]][f[1]]=s),c.push((s?"":"no-")+f.join("-"))}}(),function(e){var n=r.className,t=Modernizr._config.classPrefix||"";if(f&&(n=n.baseVal),Modernizr._config.enableJSClass){var s=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(s,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(e.length>0&&(n+=" "+t+e.join(" "+t)),f?r.className.baseVal=n:r.className=n)}(c),delete i.addTest,delete i.addAsyncTest;for(var l=0;l<Modernizr._q.length;l++)Modernizr._q[l]();e.Modernizr=Modernizr}(window,window,document);
	module.exports = window.Modernizr;
	if (hadGlobal) { window.Modernizr = oldGlobal; }
	else { delete window.Modernizr; }
	})(window);

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 346,
		"./af.js": 346,
		"./ar": 353,
		"./ar-dz": 347,
		"./ar-dz.js": 347,
		"./ar-kw": 348,
		"./ar-kw.js": 348,
		"./ar-ly": 349,
		"./ar-ly.js": 349,
		"./ar-ma": 350,
		"./ar-ma.js": 350,
		"./ar-sa": 351,
		"./ar-sa.js": 351,
		"./ar-tn": 352,
		"./ar-tn.js": 352,
		"./ar.js": 353,
		"./az": 354,
		"./az.js": 354,
		"./be": 355,
		"./be.js": 355,
		"./bg": 356,
		"./bg.js": 356,
		"./bm": 357,
		"./bm.js": 357,
		"./bn": 359,
		"./bn-bd": 358,
		"./bn-bd.js": 358,
		"./bn.js": 359,
		"./bo": 360,
		"./bo.js": 360,
		"./br": 361,
		"./br.js": 361,
		"./bs": 362,
		"./bs.js": 362,
		"./ca": 363,
		"./ca.js": 363,
		"./cs": 364,
		"./cs.js": 364,
		"./cv": 365,
		"./cv.js": 365,
		"./cy": 366,
		"./cy.js": 366,
		"./da": 367,
		"./da.js": 367,
		"./de": 370,
		"./de-at": 368,
		"./de-at.js": 368,
		"./de-ch": 369,
		"./de-ch.js": 369,
		"./de.js": 370,
		"./dv": 371,
		"./dv.js": 371,
		"./el": 372,
		"./el.js": 372,
		"./en-au": 373,
		"./en-au.js": 373,
		"./en-ca": 374,
		"./en-ca.js": 374,
		"./en-gb": 375,
		"./en-gb.js": 375,
		"./en-ie": 376,
		"./en-ie.js": 376,
		"./en-il": 377,
		"./en-il.js": 377,
		"./en-in": 378,
		"./en-in.js": 378,
		"./en-nz": 379,
		"./en-nz.js": 379,
		"./en-sg": 380,
		"./en-sg.js": 380,
		"./eo": 381,
		"./eo.js": 381,
		"./es": 385,
		"./es-do": 382,
		"./es-do.js": 382,
		"./es-mx": 383,
		"./es-mx.js": 383,
		"./es-us": 384,
		"./es-us.js": 384,
		"./es.js": 385,
		"./et": 386,
		"./et.js": 386,
		"./eu": 387,
		"./eu.js": 387,
		"./fa": 388,
		"./fa.js": 388,
		"./fi": 389,
		"./fi.js": 389,
		"./fil": 390,
		"./fil.js": 390,
		"./fo": 391,
		"./fo.js": 391,
		"./fr": 394,
		"./fr-ca": 392,
		"./fr-ca.js": 392,
		"./fr-ch": 393,
		"./fr-ch.js": 393,
		"./fr.js": 394,
		"./fy": 395,
		"./fy.js": 395,
		"./ga": 396,
		"./ga.js": 396,
		"./gd": 397,
		"./gd.js": 397,
		"./gl": 398,
		"./gl.js": 398,
		"./gom-deva": 399,
		"./gom-deva.js": 399,
		"./gom-latn": 400,
		"./gom-latn.js": 400,
		"./gu": 401,
		"./gu.js": 401,
		"./he": 402,
		"./he.js": 402,
		"./hi": 403,
		"./hi.js": 403,
		"./hr": 404,
		"./hr.js": 404,
		"./hu": 405,
		"./hu.js": 405,
		"./hy-am": 406,
		"./hy-am.js": 406,
		"./id": 407,
		"./id.js": 407,
		"./is": 408,
		"./is.js": 408,
		"./it": 410,
		"./it-ch": 409,
		"./it-ch.js": 409,
		"./it.js": 410,
		"./ja": 411,
		"./ja.js": 411,
		"./jv": 412,
		"./jv.js": 412,
		"./ka": 413,
		"./ka.js": 413,
		"./kk": 414,
		"./kk.js": 414,
		"./km": 415,
		"./km.js": 415,
		"./kn": 416,
		"./kn.js": 416,
		"./ko": 417,
		"./ko.js": 417,
		"./ku": 418,
		"./ku.js": 418,
		"./ky": 419,
		"./ky.js": 419,
		"./lb": 420,
		"./lb.js": 420,
		"./lo": 421,
		"./lo.js": 421,
		"./lt": 422,
		"./lt.js": 422,
		"./lv": 423,
		"./lv.js": 423,
		"./me": 424,
		"./me.js": 424,
		"./mi": 425,
		"./mi.js": 425,
		"./mk": 426,
		"./mk.js": 426,
		"./ml": 427,
		"./ml.js": 427,
		"./mn": 428,
		"./mn.js": 428,
		"./mr": 429,
		"./mr.js": 429,
		"./ms": 431,
		"./ms-my": 430,
		"./ms-my.js": 430,
		"./ms.js": 431,
		"./mt": 432,
		"./mt.js": 432,
		"./my": 433,
		"./my.js": 433,
		"./nb": 434,
		"./nb.js": 434,
		"./ne": 435,
		"./ne.js": 435,
		"./nl": 437,
		"./nl-be": 436,
		"./nl-be.js": 436,
		"./nl.js": 437,
		"./nn": 438,
		"./nn.js": 438,
		"./oc-lnc": 439,
		"./oc-lnc.js": 439,
		"./pa-in": 440,
		"./pa-in.js": 440,
		"./pl": 441,
		"./pl.js": 441,
		"./pt": 443,
		"./pt-br": 442,
		"./pt-br.js": 442,
		"./pt.js": 443,
		"./ro": 444,
		"./ro.js": 444,
		"./ru": 445,
		"./ru.js": 445,
		"./sd": 446,
		"./sd.js": 446,
		"./se": 447,
		"./se.js": 447,
		"./si": 448,
		"./si.js": 448,
		"./sk": 449,
		"./sk.js": 449,
		"./sl": 450,
		"./sl.js": 450,
		"./sq": 451,
		"./sq.js": 451,
		"./sr": 453,
		"./sr-cyrl": 452,
		"./sr-cyrl.js": 452,
		"./sr.js": 453,
		"./ss": 454,
		"./ss.js": 454,
		"./sv": 455,
		"./sv.js": 455,
		"./sw": 456,
		"./sw.js": 456,
		"./ta": 457,
		"./ta.js": 457,
		"./te": 458,
		"./te.js": 458,
		"./tet": 459,
		"./tet.js": 459,
		"./tg": 460,
		"./tg.js": 460,
		"./th": 461,
		"./th.js": 461,
		"./tk": 462,
		"./tk.js": 462,
		"./tl-ph": 463,
		"./tl-ph.js": 463,
		"./tlh": 464,
		"./tlh.js": 464,
		"./tr": 465,
		"./tr.js": 465,
		"./tzl": 466,
		"./tzl.js": 466,
		"./tzm": 468,
		"./tzm-latn": 467,
		"./tzm-latn.js": 467,
		"./tzm.js": 468,
		"./ug-cn": 469,
		"./ug-cn.js": 469,
		"./uk": 470,
		"./uk.js": 470,
		"./ur": 471,
		"./ur.js": 471,
		"./uz": 473,
		"./uz-latn": 472,
		"./uz-latn.js": 472,
		"./uz.js": 473,
		"./vi": 474,
		"./vi.js": 474,
		"./x-pseudo": 475,
		"./x-pseudo.js": 475,
		"./yo": 476,
		"./yo.js": 476,
		"./zh-cn": 477,
		"./zh-cn.js": 477,
		"./zh-hk": 478,
		"./zh-hk.js": 478,
		"./zh-mo": 479,
		"./zh-mo.js": 479,
		"./zh-tw": 480,
		"./zh-tw.js": 480
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1697;


/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = monotoneConvexHull2D
	
	var orient = __webpack_require__(221)[3]
	
	function monotoneConvexHull2D(points) {
	  var n = points.length
	
	  if(n < 3) {
	    var result = new Array(n)
	    for(var i=0; i<n; ++i) {
	      result[i] = i
	    }
	
	    if(n === 2 &&
	       points[0][0] === points[1][0] &&
	       points[0][1] === points[1][1]) {
	      return [0]
	    }
	
	    return result
	  }
	
	  //Sort point indices along x-axis
	  var sorted = new Array(n)
	  for(var i=0; i<n; ++i) {
	    sorted[i] = i
	  }
	  sorted.sort(function(a,b) {
	    var d = points[a][0]-points[b][0]
	    if(d) {
	      return d
	    }
	    return points[a][1] - points[b][1]
	  })
	
	  //Construct upper and lower hulls
	  var lower = [sorted[0], sorted[1]]
	  var upper = [sorted[0], sorted[1]]
	
	  for(var i=2; i<n; ++i) {
	    var idx = sorted[i]
	    var p   = points[idx]
	
	    //Insert into lower list
	    var m = lower.length
	    while(m > 1 && orient(
	        points[lower[m-2]], 
	        points[lower[m-1]], 
	        p) <= 0) {
	      m -= 1
	      lower.pop()
	    }
	    lower.push(idx)
	
	    //Insert into upper list
	    m = upper.length
	    while(m > 1 && orient(
	        points[upper[m-2]], 
	        points[upper[m-1]], 
	        p) >= 0) {
	      m -= 1
	      upper.pop()
	    }
	    upper.push(idx)
	  }
	
	  //Merge lists together
	  var result = new Array(upper.length + lower.length - 2)
	  var ptr    = 0
	  for(var i=0, nl=lower.length; i<nl; ++i) {
	    result[ptr++] = lower[i]
	  }
	  for(var j=upper.length-2; j>0; --j) {
	    result[ptr++] = upper[j]
	  }
	
	  //Return result
	  return result
	}

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function(crypto) {
	  function pbkdf2(password, salt, iterations, keylen, digest, callback) {
	    if ('function' === typeof digest) {
	      callback = digest
	      digest = undefined
	    }
	
	    if ('function' !== typeof callback)
	      throw new Error('No callback provided to pbkdf2')
	
	    setTimeout(function() {
	      var result
	
	      try {
	        result = pbkdf2Sync(password, salt, iterations, keylen, digest)
	      } catch (e) {
	        return callback(e)
	      }
	
	      callback(undefined, result)
	    })
	  }
	
	  function pbkdf2Sync(password, salt, iterations, keylen, digest) {
	    if ('number' !== typeof iterations)
	      throw new TypeError('Iterations not a number')
	
	    if (iterations < 0)
	      throw new TypeError('Bad iterations')
	
	    if ('number' !== typeof keylen)
	      throw new TypeError('Key length not a number')
	
	    if (keylen < 0)
	      throw new TypeError('Bad key length')
	
	    digest = digest || 'sha1'
	
	    if (!Buffer.isBuffer(password)) password = new Buffer(password)
	    if (!Buffer.isBuffer(salt)) salt = new Buffer(salt)
	
	    var hLen, l = 1, r, T
	    var DK = new Buffer(keylen)
	    var block1 = new Buffer(salt.length + 4)
	    salt.copy(block1, 0, 0, salt.length)
	
	    for (var i = 1; i <= l; i++) {
	      block1.writeUInt32BE(i, salt.length)
	
	      var U = crypto.createHmac(digest, password).update(block1).digest()
	
	      if (!hLen) {
	        hLen = U.length
	        T = new Buffer(hLen)
	        l = Math.ceil(keylen / hLen)
	        r = keylen - (l - 1) * hLen
	
	        if (keylen > (Math.pow(2, 32) - 1) * hLen)
	          throw new TypeError('keylen exceeds maximum length')
	      }
	
	      U.copy(T, 0, 0, hLen)
	
	      for (var j = 1; j < iterations; j++) {
	        U = crypto.createHmac(digest, password).update(U).digest()
	
	        for (var k = 0; k < hLen; k++) {
	          T[k] ^= U[k]
	        }
	      }
	
	      var destPos = (i - 1) * hLen
	      var len = (i == l ? r : hLen)
	      T.copy(DK, destPos, 0, len)
	    }
	
	    return DK
	  }
	
	  return {
	    pbkdf2: pbkdf2,
	    pbkdf2Sync: pbkdf2Sync
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32).Buffer))

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * qrcode.vue v1.7.0
	 * A Vue component to generate QRCode.
	 * © 2017-2019 @scopewu(https://github.com/scopewu)
	 * MIT License.
	 */
	(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global = global || self, global.QrcodeVue = factory());
	}(this, function () { 'use strict';
	
	var mode = {
	  MODE_NUMBER: 1 << 0,
	  MODE_ALPHA_NUM: 1 << 1,
	  MODE_8BIT_BYTE: 1 << 2,
	  MODE_KANJI: 1 << 3
	};
	
	function QR8bitByte(data) {
	  this.mode = mode.MODE_8BIT_BYTE;
	  this.data = data;
	}
	
	QR8bitByte.prototype = {
	  getLength: function (buffer) {
	    return this.data.length;
	  },
	  write: function (buffer) {
	    for (var i = 0; i < this.data.length; i++) {
	      // not JIS ...
	      buffer.put(this.data.charCodeAt(i), 8);
	    }
	  }
	};
	var _8BitByte = QR8bitByte;
	
	var ErrorCorrectLevel = {
	  L: 1,
	  M: 0,
	  Q: 3,
	  H: 2
	};
	
	function QRRSBlock(totalCount, dataCount) {
	  this.totalCount = totalCount;
	  this.dataCount = dataCount;
	}
	
	QRRSBlock.RS_BLOCK_TABLE = [// L
	// M
	// Q
	// H
	// 1
	[1, 26, 19], [1, 26, 16], [1, 26, 13], [1, 26, 9], // 2
	[1, 44, 34], [1, 44, 28], [1, 44, 22], [1, 44, 16], // 3
	[1, 70, 55], [1, 70, 44], [2, 35, 17], [2, 35, 13], // 4		
	[1, 100, 80], [2, 50, 32], [2, 50, 24], [4, 25, 9], // 5
	[1, 134, 108], [2, 67, 43], [2, 33, 15, 2, 34, 16], [2, 33, 11, 2, 34, 12], // 6
	[2, 86, 68], [4, 43, 27], [4, 43, 19], [4, 43, 15], // 7		
	[2, 98, 78], [4, 49, 31], [2, 32, 14, 4, 33, 15], [4, 39, 13, 1, 40, 14], // 8
	[2, 121, 97], [2, 60, 38, 2, 61, 39], [4, 40, 18, 2, 41, 19], [4, 40, 14, 2, 41, 15], // 9
	[2, 146, 116], [3, 58, 36, 2, 59, 37], [4, 36, 16, 4, 37, 17], [4, 36, 12, 4, 37, 13], // 10		
	[2, 86, 68, 2, 87, 69], [4, 69, 43, 1, 70, 44], [6, 43, 19, 2, 44, 20], [6, 43, 15, 2, 44, 16], // 11
	[4, 101, 81], [1, 80, 50, 4, 81, 51], [4, 50, 22, 4, 51, 23], [3, 36, 12, 8, 37, 13], // 12
	[2, 116, 92, 2, 117, 93], [6, 58, 36, 2, 59, 37], [4, 46, 20, 6, 47, 21], [7, 42, 14, 4, 43, 15], // 13
	[4, 133, 107], [8, 59, 37, 1, 60, 38], [8, 44, 20, 4, 45, 21], [12, 33, 11, 4, 34, 12], // 14
	[3, 145, 115, 1, 146, 116], [4, 64, 40, 5, 65, 41], [11, 36, 16, 5, 37, 17], [11, 36, 12, 5, 37, 13], // 15
	[5, 109, 87, 1, 110, 88], [5, 65, 41, 5, 66, 42], [5, 54, 24, 7, 55, 25], [11, 36, 12], // 16
	[5, 122, 98, 1, 123, 99], [7, 73, 45, 3, 74, 46], [15, 43, 19, 2, 44, 20], [3, 45, 15, 13, 46, 16], // 17
	[1, 135, 107, 5, 136, 108], [10, 74, 46, 1, 75, 47], [1, 50, 22, 15, 51, 23], [2, 42, 14, 17, 43, 15], // 18
	[5, 150, 120, 1, 151, 121], [9, 69, 43, 4, 70, 44], [17, 50, 22, 1, 51, 23], [2, 42, 14, 19, 43, 15], // 19
	[3, 141, 113, 4, 142, 114], [3, 70, 44, 11, 71, 45], [17, 47, 21, 4, 48, 22], [9, 39, 13, 16, 40, 14], // 20
	[3, 135, 107, 5, 136, 108], [3, 67, 41, 13, 68, 42], [15, 54, 24, 5, 55, 25], [15, 43, 15, 10, 44, 16], // 21
	[4, 144, 116, 4, 145, 117], [17, 68, 42], [17, 50, 22, 6, 51, 23], [19, 46, 16, 6, 47, 17], // 22
	[2, 139, 111, 7, 140, 112], [17, 74, 46], [7, 54, 24, 16, 55, 25], [34, 37, 13], // 23
	[4, 151, 121, 5, 152, 122], [4, 75, 47, 14, 76, 48], [11, 54, 24, 14, 55, 25], [16, 45, 15, 14, 46, 16], // 24
	[6, 147, 117, 4, 148, 118], [6, 73, 45, 14, 74, 46], [11, 54, 24, 16, 55, 25], [30, 46, 16, 2, 47, 17], // 25
	[8, 132, 106, 4, 133, 107], [8, 75, 47, 13, 76, 48], [7, 54, 24, 22, 55, 25], [22, 45, 15, 13, 46, 16], // 26
	[10, 142, 114, 2, 143, 115], [19, 74, 46, 4, 75, 47], [28, 50, 22, 6, 51, 23], [33, 46, 16, 4, 47, 17], // 27
	[8, 152, 122, 4, 153, 123], [22, 73, 45, 3, 74, 46], [8, 53, 23, 26, 54, 24], [12, 45, 15, 28, 46, 16], // 28
	[3, 147, 117, 10, 148, 118], [3, 73, 45, 23, 74, 46], [4, 54, 24, 31, 55, 25], [11, 45, 15, 31, 46, 16], // 29
	[7, 146, 116, 7, 147, 117], [21, 73, 45, 7, 74, 46], [1, 53, 23, 37, 54, 24], [19, 45, 15, 26, 46, 16], // 30
	[5, 145, 115, 10, 146, 116], [19, 75, 47, 10, 76, 48], [15, 54, 24, 25, 55, 25], [23, 45, 15, 25, 46, 16], // 31
	[13, 145, 115, 3, 146, 116], [2, 74, 46, 29, 75, 47], [42, 54, 24, 1, 55, 25], [23, 45, 15, 28, 46, 16], // 32
	[17, 145, 115], [10, 74, 46, 23, 75, 47], [10, 54, 24, 35, 55, 25], [19, 45, 15, 35, 46, 16], // 33
	[17, 145, 115, 1, 146, 116], [14, 74, 46, 21, 75, 47], [29, 54, 24, 19, 55, 25], [11, 45, 15, 46, 46, 16], // 34
	[13, 145, 115, 6, 146, 116], [14, 74, 46, 23, 75, 47], [44, 54, 24, 7, 55, 25], [59, 46, 16, 1, 47, 17], // 35
	[12, 151, 121, 7, 152, 122], [12, 75, 47, 26, 76, 48], [39, 54, 24, 14, 55, 25], [22, 45, 15, 41, 46, 16], // 36
	[6, 151, 121, 14, 152, 122], [6, 75, 47, 34, 76, 48], [46, 54, 24, 10, 55, 25], [2, 45, 15, 64, 46, 16], // 37
	[17, 152, 122, 4, 153, 123], [29, 74, 46, 14, 75, 47], [49, 54, 24, 10, 55, 25], [24, 45, 15, 46, 46, 16], // 38
	[4, 152, 122, 18, 153, 123], [13, 74, 46, 32, 75, 47], [48, 54, 24, 14, 55, 25], [42, 45, 15, 32, 46, 16], // 39
	[20, 147, 117, 4, 148, 118], [40, 75, 47, 7, 76, 48], [43, 54, 24, 22, 55, 25], [10, 45, 15, 67, 46, 16], // 40
	[19, 148, 118, 6, 149, 119], [18, 75, 47, 31, 76, 48], [34, 54, 24, 34, 55, 25], [20, 45, 15, 61, 46, 16]];
	
	QRRSBlock.getRSBlocks = function (typeNumber, errorCorrectLevel) {
	  var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
	
	  if (rsBlock == undefined) {
	    throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
	  }
	
	  var length = rsBlock.length / 3;
	  var list = new Array();
	
	  for (var i = 0; i < length; i++) {
	    var count = rsBlock[i * 3 + 0];
	    var totalCount = rsBlock[i * 3 + 1];
	    var dataCount = rsBlock[i * 3 + 2];
	
	    for (var j = 0; j < count; j++) {
	      list.push(new QRRSBlock(totalCount, dataCount));
	    }
	  }
	
	  return list;
	};
	
	QRRSBlock.getRsBlockTable = function (typeNumber, errorCorrectLevel) {
	  switch (errorCorrectLevel) {
	    case ErrorCorrectLevel.L:
	      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
	
	    case ErrorCorrectLevel.M:
	      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
	
	    case ErrorCorrectLevel.Q:
	      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
	
	    case ErrorCorrectLevel.H:
	      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
	
	    default:
	      return undefined;
	  }
	};
	
	var RSBlock = QRRSBlock;
	
	function QRBitBuffer() {
	  this.buffer = new Array();
	  this.length = 0;
	}
	
	QRBitBuffer.prototype = {
	  get: function (index) {
	    var bufIndex = Math.floor(index / 8);
	    return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) == 1;
	  },
	  put: function (num, length) {
	    for (var i = 0; i < length; i++) {
	      this.putBit((num >>> length - i - 1 & 1) == 1);
	    }
	  },
	  getLengthInBits: function () {
	    return this.length;
	  },
	  putBit: function (bit) {
	    var bufIndex = Math.floor(this.length / 8);
	
	    if (this.buffer.length <= bufIndex) {
	      this.buffer.push(0);
	    }
	
	    if (bit) {
	      this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
	    }
	
	    this.length++;
	  }
	};
	var BitBuffer = QRBitBuffer;
	
	var QRMath = {
	  glog: function (n) {
	    if (n < 1) {
	      throw new Error("glog(" + n + ")");
	    }
	
	    return QRMath.LOG_TABLE[n];
	  },
	  gexp: function (n) {
	    while (n < 0) {
	      n += 255;
	    }
	
	    while (n >= 256) {
	      n -= 255;
	    }
	
	    return QRMath.EXP_TABLE[n];
	  },
	  EXP_TABLE: new Array(256),
	  LOG_TABLE: new Array(256)
	};
	
	for (var i = 0; i < 8; i++) {
	  QRMath.EXP_TABLE[i] = 1 << i;
	}
	
	for (var i = 8; i < 256; i++) {
	  QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4] ^ QRMath.EXP_TABLE[i - 5] ^ QRMath.EXP_TABLE[i - 6] ^ QRMath.EXP_TABLE[i - 8];
	}
	
	for (var i = 0; i < 255; i++) {
	  QRMath.LOG_TABLE[QRMath.EXP_TABLE[i]] = i;
	}
	
	var math = QRMath;
	
	function QRPolynomial(num, shift) {
	  if (num.length == undefined) {
	    throw new Error(num.length + "/" + shift);
	  }
	
	  var offset = 0;
	
	  while (offset < num.length && num[offset] == 0) {
	    offset++;
	  }
	
	  this.num = new Array(num.length - offset + shift);
	
	  for (var i = 0; i < num.length - offset; i++) {
	    this.num[i] = num[i + offset];
	  }
	}
	
	QRPolynomial.prototype = {
	  get: function (index) {
	    return this.num[index];
	  },
	  getLength: function () {
	    return this.num.length;
	  },
	  multiply: function (e) {
	    var num = new Array(this.getLength() + e.getLength() - 1);
	
	    for (var i = 0; i < this.getLength(); i++) {
	      for (var j = 0; j < e.getLength(); j++) {
	        num[i + j] ^= math.gexp(math.glog(this.get(i)) + math.glog(e.get(j)));
	      }
	    }
	
	    return new QRPolynomial(num, 0);
	  },
	  mod: function (e) {
	    if (this.getLength() - e.getLength() < 0) {
	      return this;
	    }
	
	    var ratio = math.glog(this.get(0)) - math.glog(e.get(0));
	    var num = new Array(this.getLength());
	
	    for (var i = 0; i < this.getLength(); i++) {
	      num[i] = this.get(i);
	    }
	
	    for (var i = 0; i < e.getLength(); i++) {
	      num[i] ^= math.gexp(math.glog(e.get(i)) + ratio);
	    } // recursive call
	
	
	    return new QRPolynomial(num, 0).mod(e);
	  }
	};
	var Polynomial = QRPolynomial;
	
	var QRMaskPattern = {
	  PATTERN000: 0,
	  PATTERN001: 1,
	  PATTERN010: 2,
	  PATTERN011: 3,
	  PATTERN100: 4,
	  PATTERN101: 5,
	  PATTERN110: 6,
	  PATTERN111: 7
	};
	var QRUtil = {
	  PATTERN_POSITION_TABLE: [[], [6, 18], [6, 22], [6, 26], [6, 30], [6, 34], [6, 22, 38], [6, 24, 42], [6, 26, 46], [6, 28, 50], [6, 30, 54], [6, 32, 58], [6, 34, 62], [6, 26, 46, 66], [6, 26, 48, 70], [6, 26, 50, 74], [6, 30, 54, 78], [6, 30, 56, 82], [6, 30, 58, 86], [6, 34, 62, 90], [6, 28, 50, 72, 94], [6, 26, 50, 74, 98], [6, 30, 54, 78, 102], [6, 28, 54, 80, 106], [6, 32, 58, 84, 110], [6, 30, 58, 86, 114], [6, 34, 62, 90, 118], [6, 26, 50, 74, 98, 122], [6, 30, 54, 78, 102, 126], [6, 26, 52, 78, 104, 130], [6, 30, 56, 82, 108, 134], [6, 34, 60, 86, 112, 138], [6, 30, 58, 86, 114, 142], [6, 34, 62, 90, 118, 146], [6, 30, 54, 78, 102, 126, 150], [6, 24, 50, 76, 102, 128, 154], [6, 28, 54, 80, 106, 132, 158], [6, 32, 58, 84, 110, 136, 162], [6, 26, 54, 82, 110, 138, 166], [6, 30, 58, 86, 114, 142, 170]],
	  G15: 1 << 10 | 1 << 8 | 1 << 5 | 1 << 4 | 1 << 2 | 1 << 1 | 1 << 0,
	  G18: 1 << 12 | 1 << 11 | 1 << 10 | 1 << 9 | 1 << 8 | 1 << 5 | 1 << 2 | 1 << 0,
	  G15_MASK: 1 << 14 | 1 << 12 | 1 << 10 | 1 << 4 | 1 << 1,
	  getBCHTypeInfo: function (data) {
	    var d = data << 10;
	
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
	      d ^= QRUtil.G15 << QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15);
	    }
	
	    return (data << 10 | d) ^ QRUtil.G15_MASK;
	  },
	  getBCHTypeNumber: function (data) {
	    var d = data << 12;
	
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
	      d ^= QRUtil.G18 << QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18);
	    }
	
	    return data << 12 | d;
	  },
	  getBCHDigit: function (data) {
	    var digit = 0;
	
	    while (data != 0) {
	      digit++;
	      data >>>= 1;
	    }
	
	    return digit;
	  },
	  getPatternPosition: function (typeNumber) {
	    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
	  },
	  getMask: function (maskPattern, i, j) {
	    switch (maskPattern) {
	      case QRMaskPattern.PATTERN000:
	        return (i + j) % 2 == 0;
	
	      case QRMaskPattern.PATTERN001:
	        return i % 2 == 0;
	
	      case QRMaskPattern.PATTERN010:
	        return j % 3 == 0;
	
	      case QRMaskPattern.PATTERN011:
	        return (i + j) % 3 == 0;
	
	      case QRMaskPattern.PATTERN100:
	        return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;
	
	      case QRMaskPattern.PATTERN101:
	        return i * j % 2 + i * j % 3 == 0;
	
	      case QRMaskPattern.PATTERN110:
	        return (i * j % 2 + i * j % 3) % 2 == 0;
	
	      case QRMaskPattern.PATTERN111:
	        return (i * j % 3 + (i + j) % 2) % 2 == 0;
	
	      default:
	        throw new Error("bad maskPattern:" + maskPattern);
	    }
	  },
	  getErrorCorrectPolynomial: function (errorCorrectLength) {
	    var a = new Polynomial([1], 0);
	
	    for (var i = 0; i < errorCorrectLength; i++) {
	      a = a.multiply(new Polynomial([1, math.gexp(i)], 0));
	    }
	
	    return a;
	  },
	  getLengthInBits: function (mode$1, type) {
	    if (1 <= type && type < 10) {
	      // 1 - 9
	      switch (mode$1) {
	        case mode.MODE_NUMBER:
	          return 10;
	
	        case mode.MODE_ALPHA_NUM:
	          return 9;
	
	        case mode.MODE_8BIT_BYTE:
	          return 8;
	
	        case mode.MODE_KANJI:
	          return 8;
	
	        default:
	          throw new Error("mode:" + mode$1);
	      }
	    } else if (type < 27) {
	      // 10 - 26
	      switch (mode$1) {
	        case mode.MODE_NUMBER:
	          return 12;
	
	        case mode.MODE_ALPHA_NUM:
	          return 11;
	
	        case mode.MODE_8BIT_BYTE:
	          return 16;
	
	        case mode.MODE_KANJI:
	          return 10;
	
	        default:
	          throw new Error("mode:" + mode$1);
	      }
	    } else if (type < 41) {
	      // 27 - 40
	      switch (mode$1) {
	        case mode.MODE_NUMBER:
	          return 14;
	
	        case mode.MODE_ALPHA_NUM:
	          return 13;
	
	        case mode.MODE_8BIT_BYTE:
	          return 16;
	
	        case mode.MODE_KANJI:
	          return 12;
	
	        default:
	          throw new Error("mode:" + mode$1);
	      }
	    } else {
	      throw new Error("type:" + type);
	    }
	  },
	  getLostPoint: function (qrCode) {
	    var moduleCount = qrCode.getModuleCount();
	    var lostPoint = 0; // LEVEL1
	
	    for (var row = 0; row < moduleCount; row++) {
	      for (var col = 0; col < moduleCount; col++) {
	        var sameCount = 0;
	        var dark = qrCode.isDark(row, col);
	
	        for (var r = -1; r <= 1; r++) {
	          if (row + r < 0 || moduleCount <= row + r) {
	            continue;
	          }
	
	          for (var c = -1; c <= 1; c++) {
	            if (col + c < 0 || moduleCount <= col + c) {
	              continue;
	            }
	
	            if (r == 0 && c == 0) {
	              continue;
	            }
	
	            if (dark == qrCode.isDark(row + r, col + c)) {
	              sameCount++;
	            }
	          }
	        }
	
	        if (sameCount > 5) {
	          lostPoint += 3 + sameCount - 5;
	        }
	      }
	    } // LEVEL2
	
	
	    for (var row = 0; row < moduleCount - 1; row++) {
	      for (var col = 0; col < moduleCount - 1; col++) {
	        var count = 0;
	        if (qrCode.isDark(row, col)) count++;
	        if (qrCode.isDark(row + 1, col)) count++;
	        if (qrCode.isDark(row, col + 1)) count++;
	        if (qrCode.isDark(row + 1, col + 1)) count++;
	
	        if (count == 0 || count == 4) {
	          lostPoint += 3;
	        }
	      }
	    } // LEVEL3
	
	
	    for (var row = 0; row < moduleCount; row++) {
	      for (var col = 0; col < moduleCount - 6; col++) {
	        if (qrCode.isDark(row, col) && !qrCode.isDark(row, col + 1) && qrCode.isDark(row, col + 2) && qrCode.isDark(row, col + 3) && qrCode.isDark(row, col + 4) && !qrCode.isDark(row, col + 5) && qrCode.isDark(row, col + 6)) {
	          lostPoint += 40;
	        }
	      }
	    }
	
	    for (var col = 0; col < moduleCount; col++) {
	      for (var row = 0; row < moduleCount - 6; row++) {
	        if (qrCode.isDark(row, col) && !qrCode.isDark(row + 1, col) && qrCode.isDark(row + 2, col) && qrCode.isDark(row + 3, col) && qrCode.isDark(row + 4, col) && !qrCode.isDark(row + 5, col) && qrCode.isDark(row + 6, col)) {
	          lostPoint += 40;
	        }
	      }
	    } // LEVEL4
	
	
	    var darkCount = 0;
	
	    for (var col = 0; col < moduleCount; col++) {
	      for (var row = 0; row < moduleCount; row++) {
	        if (qrCode.isDark(row, col)) {
	          darkCount++;
	        }
	      }
	    }
	
	    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
	    lostPoint += ratio * 10;
	    return lostPoint;
	  }
	};
	var util = QRUtil;
	
	function QRCode(typeNumber, errorCorrectLevel) {
	  this.typeNumber = typeNumber;
	  this.errorCorrectLevel = errorCorrectLevel;
	  this.modules = null;
	  this.moduleCount = 0;
	  this.dataCache = null;
	  this.dataList = [];
	} // for client side minification
	
	
	var proto = QRCode.prototype;
	
	proto.addData = function (data) {
	  var newData = new _8BitByte(data);
	  this.dataList.push(newData);
	  this.dataCache = null;
	};
	
	proto.isDark = function (row, col) {
	  if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
	    throw new Error(row + "," + col);
	  }
	
	  return this.modules[row][col];
	};
	
	proto.getModuleCount = function () {
	  return this.moduleCount;
	};
	
	proto.make = function () {
	  // Calculate automatically typeNumber if provided is < 1
	  if (this.typeNumber < 1) {
	    var typeNumber = 1;
	
	    for (typeNumber = 1; typeNumber < 40; typeNumber++) {
	      var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);
	      var buffer = new BitBuffer();
	      var totalDataCount = 0;
	
	      for (var i = 0; i < rsBlocks.length; i++) {
	        totalDataCount += rsBlocks[i].dataCount;
	      }
	
	      for (var i = 0; i < this.dataList.length; i++) {
	        var data = this.dataList[i];
	        buffer.put(data.mode, 4);
	        buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber));
	        data.write(buffer);
	      }
	
	      if (buffer.getLengthInBits() <= totalDataCount * 8) break;
	    }
	
	    this.typeNumber = typeNumber;
	  }
	
	  this.makeImpl(false, this.getBestMaskPattern());
	};
	
	proto.makeImpl = function (test, maskPattern) {
	  this.moduleCount = this.typeNumber * 4 + 17;
	  this.modules = new Array(this.moduleCount);
	
	  for (var row = 0; row < this.moduleCount; row++) {
	    this.modules[row] = new Array(this.moduleCount);
	
	    for (var col = 0; col < this.moduleCount; col++) {
	      this.modules[row][col] = null; //(col + row) % 3;
	    }
	  }
	
	  this.setupPositionProbePattern(0, 0);
	  this.setupPositionProbePattern(this.moduleCount - 7, 0);
	  this.setupPositionProbePattern(0, this.moduleCount - 7);
	  this.setupPositionAdjustPattern();
	  this.setupTimingPattern();
	  this.setupTypeInfo(test, maskPattern);
	
	  if (this.typeNumber >= 7) {
	    this.setupTypeNumber(test);
	  }
	
	  if (this.dataCache == null) {
	    this.dataCache = QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
	  }
	
	  this.mapData(this.dataCache, maskPattern);
	};
	
	proto.setupPositionProbePattern = function (row, col) {
	  for (var r = -1; r <= 7; r++) {
	    if (row + r <= -1 || this.moduleCount <= row + r) continue;
	
	    for (var c = -1; c <= 7; c++) {
	      if (col + c <= -1 || this.moduleCount <= col + c) continue;
	
	      if (0 <= r && r <= 6 && (c == 0 || c == 6) || 0 <= c && c <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= c && c <= 4) {
	        this.modules[row + r][col + c] = true;
	      } else {
	        this.modules[row + r][col + c] = false;
	      }
	    }
	  }
	};
	
	proto.getBestMaskPattern = function () {
	  var minLostPoint = 0;
	  var pattern = 0;
	
	  for (var i = 0; i < 8; i++) {
	    this.makeImpl(true, i);
	    var lostPoint = util.getLostPoint(this);
	
	    if (i == 0 || minLostPoint > lostPoint) {
	      minLostPoint = lostPoint;
	      pattern = i;
	    }
	  }
	
	  return pattern;
	};
	
	proto.createMovieClip = function (target_mc, instance_name, depth) {
	  var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
	  var cs = 1;
	  this.make();
	
	  for (var row = 0; row < this.modules.length; row++) {
	    var y = row * cs;
	
	    for (var col = 0; col < this.modules[row].length; col++) {
	      var x = col * cs;
	      var dark = this.modules[row][col];
	
	      if (dark) {
	        qr_mc.beginFill(0, 100);
	        qr_mc.moveTo(x, y);
	        qr_mc.lineTo(x + cs, y);
	        qr_mc.lineTo(x + cs, y + cs);
	        qr_mc.lineTo(x, y + cs);
	        qr_mc.endFill();
	      }
	    }
	  }
	
	  return qr_mc;
	};
	
	proto.setupTimingPattern = function () {
	  for (var r = 8; r < this.moduleCount - 8; r++) {
	    if (this.modules[r][6] != null) {
	      continue;
	    }
	
	    this.modules[r][6] = r % 2 == 0;
	  }
	
	  for (var c = 8; c < this.moduleCount - 8; c++) {
	    if (this.modules[6][c] != null) {
	      continue;
	    }
	
	    this.modules[6][c] = c % 2 == 0;
	  }
	};
	
	proto.setupPositionAdjustPattern = function () {
	  var pos = util.getPatternPosition(this.typeNumber);
	
	  for (var i = 0; i < pos.length; i++) {
	    for (var j = 0; j < pos.length; j++) {
	      var row = pos[i];
	      var col = pos[j];
	
	      if (this.modules[row][col] != null) {
	        continue;
	      }
	
	      for (var r = -2; r <= 2; r++) {
	        for (var c = -2; c <= 2; c++) {
	          if (r == -2 || r == 2 || c == -2 || c == 2 || r == 0 && c == 0) {
	            this.modules[row + r][col + c] = true;
	          } else {
	            this.modules[row + r][col + c] = false;
	          }
	        }
	      }
	    }
	  }
	};
	
	proto.setupTypeNumber = function (test) {
	  var bits = util.getBCHTypeNumber(this.typeNumber);
	
	  for (var i = 0; i < 18; i++) {
	    var mod = !test && (bits >> i & 1) == 1;
	    this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
	  }
	
	  for (var i = 0; i < 18; i++) {
	    var mod = !test && (bits >> i & 1) == 1;
	    this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
	  }
	};
	
	proto.setupTypeInfo = function (test, maskPattern) {
	  var data = this.errorCorrectLevel << 3 | maskPattern;
	  var bits = util.getBCHTypeInfo(data); // vertical		
	
	  for (var i = 0; i < 15; i++) {
	    var mod = !test && (bits >> i & 1) == 1;
	
	    if (i < 6) {
	      this.modules[i][8] = mod;
	    } else if (i < 8) {
	      this.modules[i + 1][8] = mod;
	    } else {
	      this.modules[this.moduleCount - 15 + i][8] = mod;
	    }
	  } // horizontal
	
	
	  for (var i = 0; i < 15; i++) {
	    var mod = !test && (bits >> i & 1) == 1;
	
	    if (i < 8) {
	      this.modules[8][this.moduleCount - i - 1] = mod;
	    } else if (i < 9) {
	      this.modules[8][15 - i - 1 + 1] = mod;
	    } else {
	      this.modules[8][15 - i - 1] = mod;
	    }
	  } // fixed module
	
	
	  this.modules[this.moduleCount - 8][8] = !test;
	};
	
	proto.mapData = function (data, maskPattern) {
	  var inc = -1;
	  var row = this.moduleCount - 1;
	  var bitIndex = 7;
	  var byteIndex = 0;
	
	  for (var col = this.moduleCount - 1; col > 0; col -= 2) {
	    if (col == 6) col--;
	
	    while (true) {
	      for (var c = 0; c < 2; c++) {
	        if (this.modules[row][col - c] == null) {
	          var dark = false;
	
	          if (byteIndex < data.length) {
	            dark = (data[byteIndex] >>> bitIndex & 1) == 1;
	          }
	
	          var mask = util.getMask(maskPattern, row, col - c);
	
	          if (mask) {
	            dark = !dark;
	          }
	
	          this.modules[row][col - c] = dark;
	          bitIndex--;
	
	          if (bitIndex == -1) {
	            byteIndex++;
	            bitIndex = 7;
	          }
	        }
	      }
	
	      row += inc;
	
	      if (row < 0 || this.moduleCount <= row) {
	        row -= inc;
	        inc = -inc;
	        break;
	      }
	    }
	  }
	};
	
	QRCode.PAD0 = 0xEC;
	QRCode.PAD1 = 0x11;
	
	QRCode.createData = function (typeNumber, errorCorrectLevel, dataList) {
	  var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
	  var buffer = new BitBuffer();
	
	  for (var i = 0; i < dataList.length; i++) {
	    var data = dataList[i];
	    buffer.put(data.mode, 4);
	    buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber));
	    data.write(buffer);
	  } // calc num max data.
	
	
	  var totalDataCount = 0;
	
	  for (var i = 0; i < rsBlocks.length; i++) {
	    totalDataCount += rsBlocks[i].dataCount;
	  }
	
	  if (buffer.getLengthInBits() > totalDataCount * 8) {
	    throw new Error("code length overflow. (" + buffer.getLengthInBits() + ">" + totalDataCount * 8 + ")");
	  } // end code
	
	
	  if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
	    buffer.put(0, 4);
	  } // padding
	
	
	  while (buffer.getLengthInBits() % 8 != 0) {
	    buffer.putBit(false);
	  } // padding
	
	
	  while (true) {
	    if (buffer.getLengthInBits() >= totalDataCount * 8) {
	      break;
	    }
	
	    buffer.put(QRCode.PAD0, 8);
	
	    if (buffer.getLengthInBits() >= totalDataCount * 8) {
	      break;
	    }
	
	    buffer.put(QRCode.PAD1, 8);
	  }
	
	  return QRCode.createBytes(buffer, rsBlocks);
	};
	
	QRCode.createBytes = function (buffer, rsBlocks) {
	  var offset = 0;
	  var maxDcCount = 0;
	  var maxEcCount = 0;
	  var dcdata = new Array(rsBlocks.length);
	  var ecdata = new Array(rsBlocks.length);
	
	  for (var r = 0; r < rsBlocks.length; r++) {
	    var dcCount = rsBlocks[r].dataCount;
	    var ecCount = rsBlocks[r].totalCount - dcCount;
	    maxDcCount = Math.max(maxDcCount, dcCount);
	    maxEcCount = Math.max(maxEcCount, ecCount);
	    dcdata[r] = new Array(dcCount);
	
	    for (var i = 0; i < dcdata[r].length; i++) {
	      dcdata[r][i] = 0xff & buffer.buffer[i + offset];
	    }
	
	    offset += dcCount;
	    var rsPoly = util.getErrorCorrectPolynomial(ecCount);
	    var rawPoly = new Polynomial(dcdata[r], rsPoly.getLength() - 1);
	    var modPoly = rawPoly.mod(rsPoly);
	    ecdata[r] = new Array(rsPoly.getLength() - 1);
	
	    for (var i = 0; i < ecdata[r].length; i++) {
	      var modIndex = i + modPoly.getLength() - ecdata[r].length;
	      ecdata[r][i] = modIndex >= 0 ? modPoly.get(modIndex) : 0;
	    }
	  }
	
	  var totalCodeCount = 0;
	
	  for (var i = 0; i < rsBlocks.length; i++) {
	    totalCodeCount += rsBlocks[i].totalCount;
	  }
	
	  var data = new Array(totalCodeCount);
	  var index = 0;
	
	  for (var i = 0; i < maxDcCount; i++) {
	    for (var r = 0; r < rsBlocks.length; r++) {
	      if (i < dcdata[r].length) {
	        data[index++] = dcdata[r][i];
	      }
	    }
	  }
	
	  for (var i = 0; i < maxEcCount; i++) {
	    for (var r = 0; r < rsBlocks.length; r++) {
	      if (i < ecdata[r].length) {
	        data[index++] = ecdata[r][i];
	      }
	    }
	  }
	
	  return data;
	};
	
	var QRCode_1 = QRCode;
	
	/**
	 * Encode UTF16 to UTF8.
	 * See: http://jonisalonen.com/2012/from-utf-16-to-utf-8-in-javascript/
	 * @param str {string}
	 * @returns {string}
	 */
	
	function toUTF8String(str) {
	  var utf8Str = '';
	
	  for (var i = 0; i < str.length; i++) {
	    var charCode = str.charCodeAt(i);
	
	    if (charCode < 0x0080) {
	      utf8Str += String.fromCharCode(charCode);
	    } else if (charCode < 0x0800) {
	      utf8Str += String.fromCharCode(0xc0 | charCode >> 6);
	      utf8Str += String.fromCharCode(0x80 | charCode & 0x3f);
	    } else if (charCode < 0xd800 || charCode >= 0xe000) {
	      utf8Str += String.fromCharCode(0xe0 | charCode >> 12);
	      utf8Str += String.fromCharCode(0x80 | charCode >> 6 & 0x3f);
	      utf8Str += String.fromCharCode(0x80 | charCode & 0x3f);
	    } else {
	      // surrogate pair
	      i++; // UTF-16 encodes 0x10000-0x10FFFF by
	      // subtracting 0x10000 and splitting the
	      // 20 bits of 0x0-0xFFFFF into two halves
	
	      charCode = 0x10000 + ((charCode & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
	      utf8Str += String.fromCharCode(0xf0 | charCode >> 18);
	      utf8Str += String.fromCharCode(0x80 | charCode >> 12 & 0x3f);
	      utf8Str += String.fromCharCode(0x80 | charCode >> 6 & 0x3f);
	      utf8Str += String.fromCharCode(0x80 | charCode & 0x3f);
	    }
	  }
	
	  return utf8Str;
	}
	
	function generatePath(modules) {
	  var margin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var ops = [];
	  modules.forEach(function (row, y) {
	    var start = null;
	    row.forEach(function (cell, x) {
	      if (!cell && start !== null) {
	        // M0 0h7v1H0z injects the space with the move and drops the comma,
	        // saving a char per operation
	        ops.push("M".concat(start + margin, " ").concat(y + margin, "h").concat(x - start, "v1H").concat(start + margin, "z"));
	        start = null;
	        return;
	      } // end of row, clean up or skip
	
	
	      if (x === row.length - 1) {
	        if (!cell) {
	          // We would have closed the op above already so this can only mean
	          // 2+ light modules in a row.
	          return;
	        }
	
	        if (start === null) {
	          // Just a single dark module.
	          ops.push("M".concat(x + margin, ",").concat(y + margin, " h1v1H").concat(x + margin, "z"));
	        } else {
	          // Otherwise finish the current line.
	          ops.push("M".concat(start + margin, ",").concat(y + margin, " h").concat(x + 1 - start, "v1H").concat(start + margin, "z"));
	        }
	
	        return;
	      }
	
	      if (cell && start === null) {
	        start = x;
	      }
	    });
	  });
	  return ops.join('');
	} // @vue/component
	
	
	var QrcodeVue = {
	  props: {
	    value: {
	      type: String,
	      required: true,
	      default: ''
	    },
	    className: {
	      type: String,
	      default: ''
	    },
	    size: {
	      type: [Number, String],
	      default: 100,
	      validator: function validator(s) {
	        return isNaN(Number(s)) !== true;
	      }
	    },
	    level: {
	      type: String,
	      default: 'L',
	      validator: function validator(l) {
	        return ['L', 'Q', 'M', 'H'].indexOf(l) > -1;
	      }
	    },
	    background: {
	      type: String,
	      default: '#fff'
	    },
	    foreground: {
	      type: String,
	      default: '#000'
	    },
	    renderAs: {
	      type: String,
	      required: false,
	      default: 'canvas',
	      validator: function validator(as) {
	        return ['canvas', 'svg'].indexOf(as) > -1;
	      }
	    }
	  },
	  data: function data() {
	    return {
	      numCells: 0,
	      fgPath: ''
	    };
	  },
	  updated: function updated() {
	    this.render();
	  },
	  mounted: function mounted() {
	    this.render();
	  },
	  methods: {
	    render: function render() {
	      var value = this.value,
	          size = this.size,
	          level = this.level,
	          background = this.background,
	          foreground = this.foreground,
	          renderAs = this.renderAs;
	
	      var _size = size >>> 0; // size to number
	      // We'll use type===-1 to force QRCode to automatically pick the best type
	
	
	      var qrCode = new QRCode_1(-1, ErrorCorrectLevel[level]);
	      qrCode.addData(toUTF8String(value));
	      qrCode.make();
	      var cells = qrCode.modules;
	      var tileW = _size / cells.length;
	      var tileH = _size / cells.length;
	      var scale = window.devicePixelRatio || 1;
	
	      if (renderAs === 'svg') {
	        this.numCells = cells.length; // Drawing strategy: instead of a rect per module, we're going to create a
	        // single path for the dark modules and layer that on top of a light rect,
	        // for a total of 2 DOM nodes. We pay a bit more in string concat but that's
	        // way faster than DOM ops.
	        // For level 1, 441 nodes -> 2
	        // For level 40, 31329 -> 2
	
	        this.fgPath = generatePath(cells);
	      } else {
	        var canvas = this.$refs['qrcode-vue'];
	        var ctx = canvas.getContext('2d');
	        canvas.height = canvas.width = _size * scale;
	        ctx.scale(scale, scale);
	        cells.forEach(function (row, rdx) {
	          row.forEach(function (cell, cdx) {
	            ctx.fillStyle = cell ? foreground : background;
	            var w = Math.ceil((cdx + 1) * tileW) - Math.floor(cdx * tileW);
	            var h = Math.ceil((rdx + 1) * tileH) - Math.floor(rdx * tileH);
	            ctx.fillRect(Math.round(cdx * tileW), Math.round(rdx * tileH), w, h);
	          });
	        });
	      }
	    }
	  },
	  render: function render(createElement) {
	    var className = this.className,
	        value = this.value,
	        level = this.level,
	        background = this.background,
	        foreground = this.foreground,
	        size = this.size,
	        renderAs = this.renderAs,
	        numCells = this.numCells,
	        fgPath = this.fgPath;
	    return createElement('div', {
	      class: this.class || className,
	      attrs: {
	        value: value,
	        level: level,
	        background: background,
	        foreground: foreground
	      }
	    }, [renderAs === 'svg' ? createElement('svg', {
	      attrs: {
	        height: size,
	        width: size,
	        shapeRendering: 'crispEdges',
	        viewBox: "0 0 ".concat(numCells, " ").concat(numCells)
	      },
	      style: {
	        width: size + 'px',
	        height: size + 'px'
	      }
	    }, [createElement('path', {
	      attrs: {
	        fill: background,
	        d: "M0,0 h".concat(numCells, "v").concat(numCells, "H0z")
	      }
	    }), createElement('path', {
	      attrs: {
	        fill: foreground,
	        d: fgPath
	      }
	    })]) : createElement('canvas', {
	      attrs: {
	        height: size,
	        width: size
	      },
	      style: {
	        width: size + 'px',
	        height: size + 'px'
	      },
	      ref: 'qrcode-vue'
	    }, [])]);
	  }
	};
	
	return QrcodeVue;
	
	}));


/***/ }),
/* 1701 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 735 1399\">\r\n  <defs>\r\n    <style>\r\n      .hbmb-cls-1 {\r\n        clip-path: url(#clip-banner_mais_para_empresas_mobile_1);\r\n      }\r\n\r\n      .hbmb-cls-2, .hbmb-cls-5 {\r\n        fill: #5d3b81;\r\n      }\r\n\r\n      .hbmb-cls-3 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .hbmb-cls-4 {\r\n        fill: #58595b;\r\n      }\r\n\r\n      .hbmb-cls-5 {\r\n        font-size: 132px;\r\n        font-family: NexaLight, Nexa Light;\r\n      }\r\n\r\n      .hbmb-cls-6 {\r\n        fill: #4b4e5c;\r\n      }\r\n\r\n      .hbmb-cls-7 {\r\n        filter: url(#BGButton-para-empresas-mobile);\r\n      }\r\n    </style>\r\n    <filter id=\"BGButton-para-empresas-mobile\" x=\"-30\" y=\"966\" width=\"795\" height=\"378\" filterUnits=\"userSpaceOnUse\">\r\n      <feOffset dy=\"57\" input=\"SourceAlpha\"/>\r\n      <feGaussianBlur stdDeviation=\"45\" result=\"blur\"/>\r\n      <feFlood flood-color=\"#020202\" flood-opacity=\"0.141\"/>\r\n      <feComposite operator=\"in\" in2=\"blur\"/>\r\n      <feComposite in=\"SourceGraphic\"/>\r\n    </filter>\r\n    <clipPath id=\"clip-banner_mais_para_empresas_mobile_1\">\r\n      <rect width=\"735\" height=\"1399\"/>\r\n    </clipPath>\r\n  </defs>\r\n  <g id=\"banner_mais_para_empresas_mobile_1\" data-name=\"banner_mais_para_empresas_mobile – 1\" class=\"hbmb-cls-1\">\r\n    <rect class=\"hbmb-cls-3\" width=\"735\" height=\"1399\"/>\r\n    <g id=\"Button-para-empresas\" transform=\"translate(104.51 1044.276)\">\r\n      <g class=\"hbmb-cls-7\" transform=\"matrix(1, 0, 0, 1, -104.51, -1044.28)\">\r\n        <rect id=\"BGButton-para-empresas-mobile-2\" data-name=\"BGButton-para-empresas-mobile\" class=\"hbmb-cls-2\" width=\"525\" height=\"108\" rx=\"54\" transform=\"translate(105 1044)\"/>\r\n      </g>\r\n      <path id=\"quero-agora-empresas\" class=\"hbmb-cls-3\" d=\"M-100.823-15.39A18.6,18.6,0,0,1-103.2-5.585a11.827,11.827,0,0,1-6.7,5.291l7.307,7.6h-5.186L-113.757.378l-1.155.042q-6.782,0-10.467-4.147t-3.685-11.705q0-7.5,3.7-11.621t10.5-4.126q6.614,0,10.33,4.2T-100.823-15.39Zm-24.46,0q0,6.236,2.656,9.459t7.716,3.223q5.1,0,7.706-3.212t2.6-9.469q0-6.194-2.593-9.4t-7.674-3.2q-5.1,0-7.758,3.223T-125.284-15.39Zm34.056-7.622V-8.083a6.006,6.006,0,0,0,1.281,4.2A5.218,5.218,0,0,0-85.937-2.5q3.611,0,5.281-1.974t1.669-6.446V-23.012H-75.5V0h-2.876l-.5-3.086h-.189a6.947,6.947,0,0,1-2.971,2.6,9.986,9.986,0,0,1-4.336.9q-4.2,0-6.288-1.995t-2.089-6.383V-23.012ZM-58.39.42a10.573,10.573,0,0,1-8.052-3.107q-2.95-3.107-2.95-8.629,0-5.564,2.74-8.839a9.1,9.1,0,0,1,7.359-3.275,8.678,8.678,0,0,1,6.845,2.845,10.9,10.9,0,0,1,2.52,7.506v2.2H-65.781a9.122,9.122,0,0,0,2.047,6.152,7.08,7.08,0,0,0,5.469,2.1,18.535,18.535,0,0,0,7.349-1.554v3.107a18.444,18.444,0,0,1-3.5,1.144A19.646,19.646,0,0,1-58.39.42Zm-.945-20.933a5.692,5.692,0,0,0-4.42,1.806,8.323,8.323,0,0,0-1.942,5h12.031a7.663,7.663,0,0,0-1.47-5.05A5.173,5.173,0,0,0-59.335-20.513Zm25.846-2.918a13.638,13.638,0,0,1,2.75.252l-.483,3.233a11.872,11.872,0,0,0-2.52-.315,6.133,6.133,0,0,0-4.777,2.268A8.268,8.268,0,0,0-40.5-12.346V0h-3.485V-23.012h2.876l.4,4.262h.168a10.116,10.116,0,0,1,3.086-3.464A6.948,6.948,0,0,1-33.489-23.432Zm26.056,11.9q0,5.627-2.834,8.787A9.983,9.983,0,0,1-18.1.42a10.373,10.373,0,0,1-5.48-1.449,9.562,9.562,0,0,1-3.7-4.157,14.488,14.488,0,0,1-1.3-6.341q0-5.627,2.813-8.766a9.95,9.95,0,0,1,7.811-3.139,9.735,9.735,0,0,1,7.674,3.212Q-7.433-17.007-7.433-11.527Zm-17.532,0q0,4.409,1.764,6.719A6.122,6.122,0,0,0-18.015-2.5a6.163,6.163,0,0,0,5.2-2.3q1.774-2.3,1.774-6.729,0-4.388-1.774-6.666a6.234,6.234,0,0,0-5.239-2.278,6.135,6.135,0,0,0-5.165,2.247Q-24.964-15.978-24.964-11.527ZM24,0l-.693-3.275h-.168A9.683,9.683,0,0,1,19.7-.346,10.464,10.464,0,0,1,15.432.42a7.686,7.686,0,0,1-5.365-1.764A6.433,6.433,0,0,1,8.125-6.362q0-6.971,11.149-7.307l3.905-.126v-1.428a5.834,5.834,0,0,0-1.165-4,4.793,4.793,0,0,0-3.727-1.291,15.185,15.185,0,0,0-6.509,1.764l-1.071-2.667a16.378,16.378,0,0,1,3.727-1.449A16.141,16.141,0,0,1,18.5-23.39q4.115,0,6.1,1.827t1.984,5.858V0ZM16.125-2.457a7.074,7.074,0,0,0,5.113-1.785,6.6,6.6,0,0,0,1.858-5v-2.079l-3.485.147q-4.157.147-5.994,1.291A3.894,3.894,0,0,0,11.779-6.32a3.591,3.591,0,0,0,1.144,2.876A4.75,4.75,0,0,0,16.125-2.457ZM52.6-23.012v2.2l-4.262.5a7.327,7.327,0,0,1,1.05,1.921,7.33,7.33,0,0,1,.462,2.677,6.8,6.8,0,0,1-2.31,5.4,9.317,9.317,0,0,1-6.341,2.016,10.559,10.559,0,0,1-1.932-.168Q37.037-7.286,37.037-5.5a1.5,1.5,0,0,0,.777,1.4,5.675,5.675,0,0,0,2.667.451h4.073A9.121,9.121,0,0,1,50.3-2.079,5.471,5.471,0,0,1,52.3,2.5a6.534,6.534,0,0,1-3.065,5.826Q46.17,10.33,40.292,10.33a12.22,12.22,0,0,1-6.96-1.68,5.423,5.423,0,0,1-2.446-4.745A5.329,5.329,0,0,1,32.229.273a6.842,6.842,0,0,1,3.779-2.079,3.646,3.646,0,0,1-1.48-1.239A3.278,3.278,0,0,1,33.93-5,3.706,3.706,0,0,1,34.6-7.2a7.064,7.064,0,0,1,2.121-1.827,6.216,6.216,0,0,1-2.908-2.5,7.342,7.342,0,0,1-1.123-4.031,7.446,7.446,0,0,1,2.268-5.826,9.258,9.258,0,0,1,6.425-2.047,11.683,11.683,0,0,1,3.254.42ZM34.245,3.863A3.123,3.123,0,0,0,35.819,6.7a8.691,8.691,0,0,0,4.514.966q4.388,0,6.5-1.312a4.018,4.018,0,0,0,2.11-3.559A2.816,2.816,0,0,0,47.787.2a8.969,8.969,0,0,0-4.346-.724H39.263a5.5,5.5,0,0,0-3.7,1.134A4.051,4.051,0,0,0,34.245,3.863Zm1.89-19.505A4.685,4.685,0,0,0,37.5-11.989a5.449,5.449,0,0,0,3.8,1.239q5.1,0,5.1-4.955,0-5.186-5.165-5.186a5.114,5.114,0,0,0-3.779,1.323A5.327,5.327,0,0,0,36.134-15.642Zm41.047,4.115q0,5.627-2.834,8.787A9.983,9.983,0,0,1,66.516.42a10.373,10.373,0,0,1-5.48-1.449,9.562,9.562,0,0,1-3.7-4.157,14.488,14.488,0,0,1-1.3-6.341q0-5.627,2.813-8.766a9.95,9.95,0,0,1,7.811-3.139,9.735,9.735,0,0,1,7.674,3.212Q77.182-17.007,77.182-11.527Zm-17.532,0q0,4.409,1.764,6.719A6.122,6.122,0,0,0,66.6-2.5a6.163,6.163,0,0,0,5.2-2.3q1.774-2.3,1.774-6.729,0-4.388-1.774-6.666a6.234,6.234,0,0,0-5.239-2.278,6.135,6.135,0,0,0-5.165,2.247Q59.65-15.978,59.65-11.527Zm34.14-11.9a13.638,13.638,0,0,1,2.75.252l-.483,3.233a11.872,11.872,0,0,0-2.52-.315,6.133,6.133,0,0,0-4.777,2.268,8.268,8.268,0,0,0-1.984,5.648V0H83.292V-23.012h2.876l.4,4.262h.168a10.116,10.116,0,0,1,3.086-3.464A6.948,6.948,0,0,1,93.79-23.432ZM114.135,0l-.693-3.275h-.168a9.683,9.683,0,0,1-3.433,2.929,10.464,10.464,0,0,1-4.273.766A7.686,7.686,0,0,1,100.2-1.344a6.433,6.433,0,0,1-1.942-5.018q0-6.971,11.149-7.307l3.905-.126v-1.428a5.834,5.834,0,0,0-1.165-4,4.793,4.793,0,0,0-3.727-1.291,15.185,15.185,0,0,0-6.509,1.764l-1.071-2.667a16.378,16.378,0,0,1,3.727-1.449,16.141,16.141,0,0,1,4.063-.525q4.115,0,6.1,1.827t1.984,5.858V0Zm-7.874-2.457a7.074,7.074,0,0,0,5.113-1.785,6.6,6.6,0,0,0,1.858-5v-2.079l-3.485.147q-4.157.147-5.994,1.291a3.894,3.894,0,0,0-1.837,3.559,3.591,3.591,0,0,0,1.144,2.876A4.75,4.75,0,0,0,106.261-2.457Zm20.786-6h-2.2L123.772-30.7h4.346Zm-3.653,6.236q0-2.855,2.52-2.855a2.4,2.4,0,0,1,1.879.735,3.068,3.068,0,0,1,.661,2.121,3.01,3.01,0,0,1-.672,2.089,2.387,2.387,0,0,1-1.869.745,2.553,2.553,0,0,1-1.806-.661A2.849,2.849,0,0,1,123.394-2.226Z\" transform=\"translate(256.49 63.904)\"/>\r\n      <g id=\"Icon-arrow-para-empresas-mobile\" transform=\"translate(446.014 73.788) rotate(-90)\">\r\n        <path id=\"Caminho_24\" data-name=\"Caminho 24\" class=\"hbmb-cls-3\" d=\"M.542.55a1.866,1.866,0,0,0,0,2.629l9.217,9.188a1.857,1.857,0,0,0,2.562.058L21.4,3.372A1.856,1.856,0,1,0,18.782.743l-7.8,7.685L3.171.541A1.857,1.857,0,0,0,.542.55Z\" transform=\"translate(9.05 15.119)\"/>\r\n        <path id=\"Caminho_25\" data-name=\"Caminho 25\" class=\"hbmb-cls-3\" d=\"M0,20.032A20.032,20.032,0,1,0,20.032,0,20.029,20.029,0,0,0,0,20.032ZM32.013,8.051A16.943,16.943,0,1,1,8.051,32.013,16.943,16.943,0,1,1,32.013,8.051Z\"/>\r\n      </g>\r\n    </g>\r\n    <g id=\"Texto-para-empresas\" transform=\"translate(32.937 399.949)\">\r\n      <path id=\"paragrafo-empresas\" class=\"hbmb-cls-4\" d=\"M38.28,28.865,36.8,27.38a9.4,9.4,0,0,1-3.218,2.112,10,10,0,0,1-3.712.726,11.1,11.1,0,0,1-4.224-.743,8.4,8.4,0,0,1-3.036-2.062,8.676,8.676,0,0,1-1.831-3.069,11.44,11.44,0,0,1-.611-3.8,11.325,11.325,0,0,1,.611-3.7A9.129,9.129,0,0,1,22.605,13.7a8.985,8.985,0,0,1,3.036-2.194,10.119,10.119,0,0,1,4.224-.825,9.53,9.53,0,0,1,6.765,2.772l1.419-1.419a9.084,9.084,0,0,0-3.7-2.623,12.351,12.351,0,0,0-4.488-.841,13.025,13.025,0,0,0-5.264.99,10.825,10.825,0,0,0-3.762,2.656A10.989,10.989,0,0,0,18.6,16.045a13.869,13.869,0,0,0-.743,4.538,13.551,13.551,0,0,0,.759,4.554,10.549,10.549,0,0,0,2.26,3.746,10.749,10.749,0,0,0,3.746,2.541,13.5,13.5,0,0,0,5.247.94,11.974,11.974,0,0,0,4.488-.858A11.665,11.665,0,0,0,38.28,28.865Zm10.758-13.4a9.073,9.073,0,0,0-3.382.61,7.6,7.6,0,0,0-2.64,1.733,8.03,8.03,0,0,0-1.732,2.69,9.2,9.2,0,0,0-.627,3.448A8.872,8.872,0,0,0,41.3,27.38a7.964,7.964,0,0,0,1.765,2.656,7.694,7.694,0,0,0,2.657,1.7,9.108,9.108,0,0,0,3.317.594,9.2,9.2,0,0,0,3.349-.594,7.607,7.607,0,0,0,4.406-4.356,9.633,9.633,0,0,0-.017-6.881,8.109,8.109,0,0,0-1.765-2.69,7.774,7.774,0,0,0-2.657-1.733A8.89,8.89,0,0,0,49.038,15.467Zm0,2.013a6.366,6.366,0,0,1,2.491.479A5.643,5.643,0,0,1,53.477,19.3a6.247,6.247,0,0,1,1.27,2.046,7.134,7.134,0,0,1,.462,2.607,7.235,7.235,0,0,1-.445,2.59,5.593,5.593,0,0,1-1.271,2,5.688,5.688,0,0,1-1.947,1.271,7.236,7.236,0,0,1-5,0A5.486,5.486,0,0,1,44.6,28.535a5.911,5.911,0,0,1-1.271-2,7,7,0,0,1-.462-2.59,7.37,7.37,0,0,1,.445-2.607A5.9,5.9,0,0,1,44.583,19.3a5.816,5.816,0,0,1,1.964-1.337A6.366,6.366,0,0,1,49.038,17.48ZM74.382,32h2.244V22.826a8.714,8.714,0,0,0-.545-3.2,6.587,6.587,0,0,0-1.5-2.326,6.036,6.036,0,0,0-2.293-1.4,9.046,9.046,0,0,0-2.97-.462,7.147,7.147,0,0,0-3.118.709,6.146,6.146,0,0,0-2.508,2.294L63.624,15.7H61.512V32h2.211V23.123a5.942,5.942,0,0,1,.4-2.194,5.668,5.668,0,0,1,1.089-1.766,5.059,5.059,0,0,1,1.683-1.2,5.246,5.246,0,0,1,2.178-.445,5.411,5.411,0,0,1,3.894,1.353,5.264,5.264,0,0,1,1.419,3.993Zm10.89-21.12-2.211.231V15.83H79.728v1.881h3.333v9.108A6.314,6.314,0,0,0,84.2,30.812a4.441,4.441,0,0,0,3.778,1.419,5.854,5.854,0,0,0,1.568-.215,10.453,10.453,0,0,0,1.567-.577l-.693-1.848a9.934,9.934,0,0,1-1.2.445,4.108,4.108,0,0,1-1.172.182,2.38,2.38,0,0,1-2.211-.924,4.74,4.74,0,0,1-.561-2.475V17.711h5.28V15.83h-5.28ZM96.162,15.7H94.083V32h2.211V22.727a5.262,5.262,0,0,1,.4-2.062,5.009,5.009,0,0,1,4.653-3.086,4.855,4.855,0,0,1,2.805.858l1.023-1.848a6.341,6.341,0,0,0-1.733-.891,6.576,6.576,0,0,0-1.963-.264,7.724,7.724,0,0,0-1.485.149,5.664,5.664,0,0,0-1.452.495,5.073,5.073,0,0,0-1.271.908,4.809,4.809,0,0,0-.973,1.386Zm18.447-.231a9.073,9.073,0,0,0-3.382.61,7.6,7.6,0,0,0-2.64,1.733,8.03,8.03,0,0,0-1.733,2.69,9.2,9.2,0,0,0-.627,3.448,8.873,8.873,0,0,0,.644,3.432,7.964,7.964,0,0,0,1.766,2.656,7.694,7.694,0,0,0,2.657,1.7,9.108,9.108,0,0,0,3.316.594,9.2,9.2,0,0,0,3.349-.594,7.607,7.607,0,0,0,4.406-4.356,9.633,9.633,0,0,0-.017-6.881,8.109,8.109,0,0,0-1.765-2.69,7.774,7.774,0,0,0-2.657-1.733A8.89,8.89,0,0,0,114.609,15.467Zm0,2.013a6.366,6.366,0,0,1,2.492.479,5.643,5.643,0,0,1,1.947,1.337,6.247,6.247,0,0,1,1.271,2.046,7.134,7.134,0,0,1,.462,2.607,7.235,7.235,0,0,1-.445,2.59,5.593,5.593,0,0,1-1.271,2,5.688,5.688,0,0,1-1.947,1.271,7.236,7.236,0,0,1-5,0,5.486,5.486,0,0,1-1.947-1.271,5.91,5.91,0,0,1-1.271-2,7,7,0,0,1-.462-2.59,7.37,7.37,0,0,1,.446-2.607,5.9,5.9,0,0,1,1.271-2.046,5.816,5.816,0,0,1,1.964-1.337A6.366,6.366,0,0,1,114.609,17.48ZM129.525,8.9h-2.211V32h2.211Zm20.79,15.906a10.491,10.491,0,0,0-.33-4.174,7.272,7.272,0,0,0-1.683-2.92,6.946,6.946,0,0,0-2.706-1.716,9.579,9.579,0,0,0-3.4-.528,8.362,8.362,0,0,0-3.35.594,7.8,7.8,0,0,0-2.64,1.749,8.068,8.068,0,0,0-1.732,2.673,8.9,8.9,0,0,0-.627,3.366,9.177,9.177,0,0,0,.643,3.515,7.926,7.926,0,0,0,1.766,2.673,7.661,7.661,0,0,0,2.673,1.7,9.334,9.334,0,0,0,3.366.594,10.4,10.4,0,0,0,3.861-.759,7.476,7.476,0,0,0,3.135-2.277l-1.485-1.32a4.158,4.158,0,0,1-1.073.974,7.415,7.415,0,0,1-1.386.693,9.055,9.055,0,0,1-1.535.429,8.24,8.24,0,0,1-1.518.149A7.107,7.107,0,0,1,140,29.855a5.819,5.819,0,0,1-1.9-1.056,5.57,5.57,0,0,1-1.353-1.7,5.85,5.85,0,0,1-.627-2.294Zm-14.19-1.881a5.8,5.8,0,0,1,6.1-5.511,7.257,7.257,0,0,1,2.31.363,5.6,5.6,0,0,1,1.9,1.056,5,5,0,0,1,1.287,1.732,5.948,5.948,0,0,1,.512,2.36ZM166.354,10.88l-2.211.231V15.83h-3.333v1.881h3.333v9.108a6.314,6.314,0,0,0,1.138,3.993,4.441,4.441,0,0,0,3.779,1.419,5.854,5.854,0,0,0,1.568-.215,10.453,10.453,0,0,0,1.567-.577l-.693-1.848a9.933,9.933,0,0,1-1.2.445,4.108,4.108,0,0,1-1.172.182,2.38,2.38,0,0,1-2.211-.924,4.74,4.74,0,0,1-.561-2.475V17.711h5.28V15.83h-5.28Zm16,4.587a9.073,9.073,0,0,0-3.382.61,7.6,7.6,0,0,0-2.64,1.733A8.03,8.03,0,0,0,174.6,20.5a9.2,9.2,0,0,0-.627,3.448,8.872,8.872,0,0,0,.643,3.432,7.964,7.964,0,0,0,1.766,2.656,7.694,7.694,0,0,0,2.656,1.7,9.108,9.108,0,0,0,3.316.594,9.2,9.2,0,0,0,3.35-.594,7.607,7.607,0,0,0,4.406-4.356A9.633,9.633,0,0,0,190.1,20.5a8.109,8.109,0,0,0-1.766-2.69,7.774,7.774,0,0,0-2.656-1.733A8.89,8.89,0,0,0,182.358,15.467Zm0,2.013a6.366,6.366,0,0,1,2.492.479A5.643,5.643,0,0,1,186.8,19.3a6.247,6.247,0,0,1,1.27,2.046,7.134,7.134,0,0,1,.462,2.607,7.235,7.235,0,0,1-.445,2.59,5.593,5.593,0,0,1-1.271,2,5.688,5.688,0,0,1-1.947,1.271,7.236,7.236,0,0,1-5,0,5.486,5.486,0,0,1-1.947-1.271,5.91,5.91,0,0,1-1.271-2,7,7,0,0,1-.462-2.59,7.37,7.37,0,0,1,.445-2.607A5.9,5.9,0,0,1,177.9,19.3a5.816,5.816,0,0,1,1.963-1.337A6.366,6.366,0,0,1,182.358,17.48Zm16.17-6.6-2.211.231V15.83h-3.333v1.881h3.333v9.108a6.314,6.314,0,0,0,1.138,3.993,4.441,4.441,0,0,0,3.779,1.419,5.854,5.854,0,0,0,1.568-.215,10.453,10.453,0,0,0,1.567-.577l-.693-1.848a9.933,9.933,0,0,1-1.2.445,4.108,4.108,0,0,1-1.172.182,2.38,2.38,0,0,1-2.211-.924,4.74,4.74,0,0,1-.561-2.475V17.711h5.28V15.83h-5.28Zm22.506,8.052a5.838,5.838,0,0,0-1.171-1.518,6.812,6.812,0,0,0-1.551-1.089,7.6,7.6,0,0,0-1.8-.644,8.583,8.583,0,0,0-1.881-.214,8.886,8.886,0,0,0-3.267.594,7.854,7.854,0,0,0-2.64,1.683,7.986,7.986,0,0,0-1.782,2.64,8.766,8.766,0,0,0-.66,3.465,9.177,9.177,0,0,0,.643,3.515,7.8,7.8,0,0,0,1.782,2.673,7.945,7.945,0,0,0,2.64,1.7,8.757,8.757,0,0,0,3.251.594,8.149,8.149,0,0,0,1.848-.215,7.273,7.273,0,0,0,1.765-.66,7.7,7.7,0,0,0,1.584-1.122,6.784,6.784,0,0,0,1.271-1.567V32h2.046V15.7h-2.079ZM214.7,17.48a6.176,6.176,0,0,1,3.514.941,5.974,5.974,0,0,1,2.1,2.359,7.215,7.215,0,0,1,0,6.171,5.974,5.974,0,0,1-2.1,2.359,6.176,6.176,0,0,1-3.514.941,6.388,6.388,0,0,1-2.425-.462,5.91,5.91,0,0,1-1.98-1.3,6.039,6.039,0,0,1-1.32-2.013,7.386,7.386,0,0,1,0-5.23,5.825,5.825,0,0,1,1.32-2.013,6.039,6.039,0,0,1,1.98-1.287A6.388,6.388,0,0,1,214.7,17.48ZM230.7,8.9h-2.211V32H230.7Zm8.217,21.945a1.336,1.336,0,0,0-.495-1.155,1.777,1.777,0,0,0-1.073-.363,1.727,1.727,0,0,0-1.072.38,1.308,1.308,0,0,0-.5,1.105,1.266,1.266,0,0,0,.281.875,1.537,1.537,0,0,0,.71.445L235.852,35h1.65q.528-1.518.974-2.524A4.3,4.3,0,0,0,238.921,30.845Zm27.159-11.913a5.838,5.838,0,0,0-1.172-1.518,6.811,6.811,0,0,0-1.551-1.089,7.6,7.6,0,0,0-1.8-.644,8.583,8.583,0,0,0-1.881-.214,8.886,8.886,0,0,0-3.267.594,7.854,7.854,0,0,0-2.64,1.683,7.986,7.986,0,0,0-1.782,2.64,8.766,8.766,0,0,0-.66,3.465,9.177,9.177,0,0,0,.643,3.515,7.8,7.8,0,0,0,1.782,2.673,7.945,7.945,0,0,0,2.64,1.7,8.757,8.757,0,0,0,3.251.594,8.149,8.149,0,0,0,1.848-.215,7.273,7.273,0,0,0,1.766-.66,7.7,7.7,0,0,0,1.584-1.122,6.784,6.784,0,0,0,1.271-1.567V32h2.046V15.7h-2.079Zm-6.336-1.452a6.176,6.176,0,0,1,3.514.941,5.974,5.974,0,0,1,2.1,2.359,7.215,7.215,0,0,1,0,6.171,5.974,5.974,0,0,1-2.1,2.359,6.176,6.176,0,0,1-3.514.941,6.388,6.388,0,0,1-2.426-.462,5.91,5.91,0,0,1-1.98-1.3,6.039,6.039,0,0,1-1.32-2.013,7.386,7.386,0,0,1,0-5.23,5.825,5.825,0,0,1,1.32-2.013,6.039,6.039,0,0,1,1.98-1.287A6.388,6.388,0,0,1,259.743,17.48Zm16-8.58h-2.211V32h2.211Zm9.5,1.98-2.211.231V15.83h-3.333v1.881h3.333v9.108a6.314,6.314,0,0,0,1.138,3.993,4.441,4.441,0,0,0,3.779,1.419,5.854,5.854,0,0,0,1.568-.215,10.454,10.454,0,0,0,1.568-.577l-.693-1.848a9.934,9.934,0,0,1-1.2.445,4.108,4.108,0,0,1-1.171.182,2.38,2.38,0,0,1-2.211-.924,4.74,4.74,0,0,1-.561-2.475V17.711h5.28V15.83h-5.28Zm22.506,8.052a5.838,5.838,0,0,0-1.172-1.518,6.811,6.811,0,0,0-1.551-1.089,7.6,7.6,0,0,0-1.8-.644,8.583,8.583,0,0,0-1.881-.214,8.886,8.886,0,0,0-3.267.594,7.854,7.854,0,0,0-2.64,1.683,7.986,7.986,0,0,0-1.782,2.64,8.765,8.765,0,0,0-.66,3.465,9.178,9.178,0,0,0,.643,3.515,7.8,7.8,0,0,0,1.782,2.673,7.945,7.945,0,0,0,2.64,1.7,8.757,8.757,0,0,0,3.251.594,8.149,8.149,0,0,0,1.848-.215,7.273,7.273,0,0,0,1.766-.66,7.7,7.7,0,0,0,1.584-1.122,6.784,6.784,0,0,0,1.271-1.567V32h2.046V15.7h-2.079Zm-6.336-1.452a6.176,6.176,0,0,1,3.514.941,5.974,5.974,0,0,1,2.1,2.359,7.215,7.215,0,0,1,0,6.171,5.974,5.974,0,0,1-2.1,2.359,6.176,6.176,0,0,1-3.514.941A6.388,6.388,0,0,1,299,29.789a5.91,5.91,0,0,1-1.98-1.3,6.039,6.039,0,0,1-1.32-2.013,7.386,7.386,0,0,1,0-5.23,5.825,5.825,0,0,1,1.32-2.013A6.039,6.039,0,0,1,299,17.942,6.388,6.388,0,0,1,301.423,17.48Zm25.674-6.6-2.211.231V15.83h-3.333v1.881h3.333v9.108a6.314,6.314,0,0,0,1.138,3.993,4.441,4.441,0,0,0,3.779,1.419,5.854,5.854,0,0,0,1.568-.215,10.454,10.454,0,0,0,1.568-.577l-.693-1.848a9.934,9.934,0,0,1-1.2.445,4.108,4.108,0,0,1-1.171.182,2.38,2.38,0,0,1-2.211-.924,4.74,4.74,0,0,1-.561-2.475V17.711h5.28V15.83H327.1Zm24.222,13.926a10.491,10.491,0,0,0-.33-4.174,7.272,7.272,0,0,0-1.683-2.92,6.946,6.946,0,0,0-2.706-1.716,9.579,9.579,0,0,0-3.4-.528,8.362,8.362,0,0,0-3.35.594,7.8,7.8,0,0,0-2.64,1.749,8.069,8.069,0,0,0-1.733,2.673,8.9,8.9,0,0,0-.627,3.366,9.178,9.178,0,0,0,.643,3.515,7.926,7.926,0,0,0,1.766,2.673,7.661,7.661,0,0,0,2.673,1.7,9.334,9.334,0,0,0,3.366.594,10.4,10.4,0,0,0,3.861-.759,7.476,7.476,0,0,0,3.135-2.277l-1.485-1.32a4.158,4.158,0,0,1-1.072.974,7.416,7.416,0,0,1-1.386.693,9.055,9.055,0,0,1-1.534.429,8.24,8.24,0,0,1-1.518.149,7.107,7.107,0,0,1-2.294-.363,5.82,5.82,0,0,1-1.9-1.056,5.571,5.571,0,0,1-1.353-1.7,5.849,5.849,0,0,1-.627-2.294Zm-14.19-1.881a5.8,5.8,0,0,1,6.1-5.511,7.257,7.257,0,0,1,2.31.363,5.6,5.6,0,0,1,1.9,1.056,5,5,0,0,1,1.287,1.732,5.948,5.948,0,0,1,.512,2.36Zm31.548,6.93-1.518-1.485a6.112,6.112,0,0,1-2.1,1.386,6.554,6.554,0,0,1-2.426.462,6.927,6.927,0,0,1-2.409-.413,5.877,5.877,0,0,1-1.98-1.2,5.559,5.559,0,0,1-1.353-1.98,7.075,7.075,0,0,1-.495-2.739,6.859,6.859,0,0,1,.495-2.689,5.878,5.878,0,0,1,1.336-1.98,5.716,5.716,0,0,1,2-1.238,6.956,6.956,0,0,1,2.442-.429,6.032,6.032,0,0,1,4.29,1.749l1.452-1.419a8.078,8.078,0,0,0-2.689-1.831,8.189,8.189,0,0,0-3.086-.577,9.586,9.586,0,0,0-3.316.561,7.587,7.587,0,0,0-2.673,1.65,7.862,7.862,0,0,0-1.8,2.64,9.033,9.033,0,0,0-.66,3.564,8.991,8.991,0,0,0,.676,3.564,7.984,7.984,0,0,0,1.815,2.673,7.588,7.588,0,0,0,2.673,1.65,9.488,9.488,0,0,0,3.284.561,8.451,8.451,0,0,0,6.039-2.475ZM385.143,32h2.244V22.826a8.714,8.714,0,0,0-.544-3.2,6.587,6.587,0,0,0-1.5-2.326,6.036,6.036,0,0,0-2.293-1.4,9.046,9.046,0,0,0-2.97-.462,7.147,7.147,0,0,0-3.118.709,6.145,6.145,0,0,0-2.508,2.294l-.066-2.739h-2.112V32h2.211V23.123a5.942,5.942,0,0,1,.4-2.194,5.669,5.669,0,0,1,1.089-1.766,5.059,5.059,0,0,1,1.683-1.2,5.246,5.246,0,0,1,2.178-.445,5.411,5.411,0,0,1,3.894,1.353,5.264,5.264,0,0,1,1.419,3.993Zm14.52-16.533a9.073,9.073,0,0,0-3.383.61,7.6,7.6,0,0,0-2.64,1.733,8.03,8.03,0,0,0-1.733,2.69,9.2,9.2,0,0,0-.627,3.448,8.873,8.873,0,0,0,.643,3.432,7.964,7.964,0,0,0,1.766,2.656,7.694,7.694,0,0,0,2.656,1.7,9.108,9.108,0,0,0,3.316.594,9.2,9.2,0,0,0,3.35-.594,7.607,7.607,0,0,0,4.405-4.356A9.633,9.633,0,0,0,407.4,20.5a8.108,8.108,0,0,0-1.766-2.69,7.773,7.773,0,0,0-2.656-1.733A8.89,8.89,0,0,0,399.663,15.467Zm0,2.013a6.366,6.366,0,0,1,2.492.479A5.643,5.643,0,0,1,404.1,19.3a6.247,6.247,0,0,1,1.271,2.046,7.134,7.134,0,0,1,.462,2.607,7.235,7.235,0,0,1-.445,2.59,5.593,5.593,0,0,1-1.27,2,5.688,5.688,0,0,1-1.947,1.271,7.236,7.236,0,0,1-5,0,5.486,5.486,0,0,1-1.947-1.271,5.91,5.91,0,0,1-1.27-2,7,7,0,0,1-.462-2.59,7.37,7.37,0,0,1,.445-2.607,5.9,5.9,0,0,1,1.271-2.046,5.816,5.816,0,0,1,1.964-1.337A6.366,6.366,0,0,1,399.663,17.48ZM414.579,8.9h-2.211V32h2.211Zm12.7,6.567a9.073,9.073,0,0,0-3.383.61,7.6,7.6,0,0,0-2.64,1.733,8.03,8.03,0,0,0-1.733,2.69,9.2,9.2,0,0,0-.627,3.448,8.873,8.873,0,0,0,.643,3.432,7.964,7.964,0,0,0,1.766,2.656,7.694,7.694,0,0,0,2.656,1.7,9.108,9.108,0,0,0,3.316.594,9.2,9.2,0,0,0,3.35-.594,7.607,7.607,0,0,0,4.405-4.356,9.633,9.633,0,0,0-.017-6.881,8.108,8.108,0,0,0-1.766-2.69,7.773,7.773,0,0,0-2.656-1.733A8.89,8.89,0,0,0,427.284,15.467Zm0,2.013a6.366,6.366,0,0,1,2.492.479,5.643,5.643,0,0,1,1.947,1.337,6.247,6.247,0,0,1,1.271,2.046,7.134,7.134,0,0,1,.462,2.607,7.235,7.235,0,0,1-.446,2.59,5.593,5.593,0,0,1-1.27,2,5.688,5.688,0,0,1-1.947,1.271,7.236,7.236,0,0,1-5,0,5.486,5.486,0,0,1-1.947-1.271,5.91,5.91,0,0,1-1.27-2,7,7,0,0,1-.462-2.59,7.37,7.37,0,0,1,.445-2.607,5.9,5.9,0,0,1,1.271-2.046,5.816,5.816,0,0,1,1.964-1.337A6.366,6.366,0,0,1,427.284,17.48Zm26.532-2.772L452.1,16.754a5.347,5.347,0,0,0-1.056-.577,9.069,9.069,0,0,0-1.237-.413,8.785,8.785,0,0,0-1.287-.231,12.139,12.139,0,0,0-1.238-.066,9.844,9.844,0,0,0-3.069.495,8.324,8.324,0,0,0-2.739,1.5,7.709,7.709,0,0,0-1.98,2.508,7.618,7.618,0,0,0-.759,3.481,8.672,8.672,0,0,0,.627,3.4,6.959,6.959,0,0,0,1.766,2.508,7.848,7.848,0,0,0,2.706,1.567,10.449,10.449,0,0,0,3.448.545,10.166,10.166,0,0,1,2.228.247,6.865,6.865,0,0,1,1.98.759,4.278,4.278,0,0,1,1.4,1.287,3.233,3.233,0,0,1,.528,1.865,3.162,3.162,0,0,1-.544,1.864,4.166,4.166,0,0,1-1.4,1.254,6.906,6.906,0,0,1-1.964.709,10.862,10.862,0,0,1-2.228.231,9.155,9.155,0,0,1-2.26-.28,6.027,6.027,0,0,1-1.947-.858,4.38,4.38,0,0,1-1.337-1.435,3.958,3.958,0,0,1-.495-2.013h-2.211a6.122,6.122,0,0,0,2.359,4.966,7.649,7.649,0,0,0,2.624,1.32,11.553,11.553,0,0,0,3.267.445,12.369,12.369,0,0,0,3.135-.4,8.687,8.687,0,0,0,2.673-1.172,6.239,6.239,0,0,0,1.865-1.931,5.066,5.066,0,0,0,.71-2.706,4.748,4.748,0,0,0-1.254-3.382,7.425,7.425,0,0,0-3.564-1.964,6.505,6.505,0,0,0,2.178-1.073,6.738,6.738,0,0,0,1.535-1.634,7.019,7.019,0,0,0,.908-1.98,7.886,7.886,0,0,0,.3-2.145,6.936,6.936,0,0,0-.627-3.168,10.466,10.466,0,0,0-1.551-2.244l1.749-2.079Zm-6.534,2.805a7.614,7.614,0,0,1,2.327.363,5.942,5.942,0,0,1,2.013,1.089,5.283,5.283,0,0,1,1.4,1.848,6.145,6.145,0,0,1,.528,2.64,6.041,6.041,0,0,1-.446,2.31,5.59,5.59,0,0,1-1.27,1.9,6.163,6.163,0,0,1-1.98,1.287,6.665,6.665,0,0,1-2.574.479,8.211,8.211,0,0,1-2.475-.363,5.44,5.44,0,0,1-2-1.105,5.294,5.294,0,0,1-1.336-1.865,6.5,6.5,0,0,1-.495-2.64,5.836,5.836,0,0,1,.561-2.64,5.617,5.617,0,0,1,1.469-1.865,5.946,5.946,0,0,1,2.03-1.089A7.569,7.569,0,0,1,447.282,17.513Zm14.85-1.881h-2.211V32h2.211Zm-2.64-5.049a1.382,1.382,0,0,0,.5,1.171,1.705,1.705,0,0,0,1.056.38,1.75,1.75,0,0,0,1.089-.38,1.383,1.383,0,0,0,.495-1.171,1.392,1.392,0,0,0-.495-1.155,1.7,1.7,0,0,0-1.089-.4,1.662,1.662,0,0,0-1.056.4A1.391,1.391,0,0,0,459.492,10.583Zm21.483,8.349a5.838,5.838,0,0,0-1.172-1.518,6.811,6.811,0,0,0-1.551-1.089,7.6,7.6,0,0,0-1.8-.644,8.583,8.583,0,0,0-1.881-.214,8.886,8.886,0,0,0-3.267.594,7.854,7.854,0,0,0-2.64,1.683,7.986,7.986,0,0,0-1.782,2.64,8.765,8.765,0,0,0-.66,3.465,9.178,9.178,0,0,0,.643,3.515,7.8,7.8,0,0,0,1.782,2.673,7.945,7.945,0,0,0,2.64,1.7,8.757,8.757,0,0,0,3.251.594,8.149,8.149,0,0,0,1.848-.215,7.273,7.273,0,0,0,1.766-.66,7.7,7.7,0,0,0,1.584-1.122,6.784,6.784,0,0,0,1.271-1.567V32h2.046V15.7h-2.079Zm-6.336-1.452a6.176,6.176,0,0,1,3.514.941,5.974,5.974,0,0,1,2.1,2.359,7.215,7.215,0,0,1,0,6.171,5.974,5.974,0,0,1-2.1,2.359,6.176,6.176,0,0,1-3.514.941,6.388,6.388,0,0,1-2.426-.462,5.91,5.91,0,0,1-1.98-1.3,6.039,6.039,0,0,1-1.32-2.013,7.386,7.386,0,0,1,0-5.23,5.825,5.825,0,0,1,1.32-2.013,6.039,6.039,0,0,1,1.98-1.287A6.388,6.388,0,0,1,474.639,17.48Zm16.4,13.365a1.336,1.336,0,0,0-.495-1.155,1.777,1.777,0,0,0-1.072-.363,1.727,1.727,0,0,0-1.073.38,1.308,1.308,0,0,0-.495,1.105,1.266,1.266,0,0,0,.28.875,1.537,1.537,0,0,0,.71.445L487.971,35h1.65q.528-1.518.973-2.524A4.3,4.3,0,0,0,491.04,30.845ZM515.13,19.1l1.287-1.452a7.9,7.9,0,0,0-2.772-1.683,10.193,10.193,0,0,0-3.366-.528,10.923,10.923,0,0,0-2.376.264,6.688,6.688,0,0,0-2.112.842,4.787,4.787,0,0,0-1.5,1.468,3.737,3.737,0,0,0-.577,2.079,3.463,3.463,0,0,0,.577,2.063,4.363,4.363,0,0,0,1.485,1.3,8.048,8.048,0,0,0,2.046.759q1.139.264,2.327.429.99.132,1.848.3a6.021,6.021,0,0,1,1.5.479,2.6,2.6,0,0,1,1.006.825,2.2,2.2,0,0,1,.363,1.3,2.077,2.077,0,0,1-.429,1.353,3.049,3.049,0,0,1-1.106.841,5.285,5.285,0,0,1-1.452.429,9.987,9.987,0,0,1-1.469.116,9.839,9.839,0,0,1-3.2-.627,5.743,5.743,0,0,1-2.673-2.013l-1.386,1.518a7.063,7.063,0,0,0,3.184,2.425,11.164,11.164,0,0,0,4.043.743,11.3,11.3,0,0,0,2.425-.264,7.139,7.139,0,0,0,2.145-.825,4.511,4.511,0,0,0,1.518-1.469,4.211,4.211,0,0,0,.61-2.194,3.974,3.974,0,0,0-.643-2.376,4.426,4.426,0,0,0-1.633-1.386,8.452,8.452,0,0,0-2.178-.726q-1.188-.231-2.277-.4-.759-.1-1.551-.264a6.658,6.658,0,0,1-1.436-.462,3.176,3.176,0,0,1-1.056-.759,1.717,1.717,0,0,1-.413-1.188,1.691,1.691,0,0,1,.33-1.122,2.88,2.88,0,0,1,.973-.825,4.787,4.787,0,0,1,1.419-.479,9.4,9.4,0,0,1,1.7-.149,10.108,10.108,0,0,1,2.491.3A5.51,5.51,0,0,1,515.13,19.1Zm19.536-.165a5.837,5.837,0,0,0-1.172-1.518,6.811,6.811,0,0,0-1.551-1.089,7.6,7.6,0,0,0-1.8-.644,8.583,8.583,0,0,0-1.881-.214,8.886,8.886,0,0,0-3.267.594,7.854,7.854,0,0,0-2.64,1.683,7.985,7.985,0,0,0-1.782,2.64,8.765,8.765,0,0,0-.66,3.465,9.177,9.177,0,0,0,.643,3.515,7.805,7.805,0,0,0,1.782,2.673,7.945,7.945,0,0,0,2.64,1.7,8.757,8.757,0,0,0,3.25.594,8.149,8.149,0,0,0,1.848-.215,7.274,7.274,0,0,0,1.766-.66,7.7,7.7,0,0,0,1.584-1.122,6.784,6.784,0,0,0,1.271-1.567V32h2.046V15.7h-2.079ZM528.33,17.48a6.176,6.176,0,0,1,3.515.941,5.974,5.974,0,0,1,2.1,2.359,7.215,7.215,0,0,1,0,6.171,5.974,5.974,0,0,1-2.1,2.359,6.176,6.176,0,0,1-3.515.941,6.388,6.388,0,0,1-2.425-.462,5.909,5.909,0,0,1-1.98-1.3,6.038,6.038,0,0,1-1.32-2.013,7.386,7.386,0,0,1,0-5.23,5.824,5.824,0,0,1,1.32-2.013,6.038,6.038,0,0,1,1.98-1.287A6.388,6.388,0,0,1,528.33,17.48ZM544.336,8.9h-2.211V32h2.211Zm12.705,8.646a6.388,6.388,0,0,1,2.425.462A5.855,5.855,0,0,1,561.43,19.3a5.985,5.985,0,0,1,1.3,2,6.7,6.7,0,0,1,.478,2.557,6.79,6.79,0,0,1-.478,2.59,6.173,6.173,0,0,1-1.3,2.013,5.771,5.771,0,0,1-1.947,1.3,6.351,6.351,0,0,1-2.442.462,6.79,6.79,0,0,1-2.393-.413,5.611,5.611,0,0,1-1.947-1.221,5.686,5.686,0,0,1-1.32-1.98,7.163,7.163,0,0,1-.478-2.722,7.291,7.291,0,0,1,.478-2.739,5.489,5.489,0,0,1,1.32-1.98,5.735,5.735,0,0,1,1.947-1.2A6.79,6.79,0,0,1,557.041,17.546Zm8.481-8.613H563.31V18.965a5.8,5.8,0,0,0-2.706-2.673,8.093,8.093,0,0,0-3.7-.825,8.607,8.607,0,0,0-3.234.528,7.636,7.636,0,0,0-2.607,1.634,7.392,7.392,0,0,0-1.749,2.64,9.678,9.678,0,0,0-.627,3.614,9.678,9.678,0,0,0,.627,3.614,7.392,7.392,0,0,0,1.749,2.64,7.635,7.635,0,0,0,2.607,1.633,9.079,9.079,0,0,0,3.234.561,7.934,7.934,0,0,0,3.68-.891,6.44,6.44,0,0,0,2.722-2.673L563.377,32h2.145ZM578,15.467a9.073,9.073,0,0,0-3.383.61,7.6,7.6,0,0,0-2.64,1.733,8.03,8.03,0,0,0-1.732,2.69,9.2,9.2,0,0,0-.627,3.448,8.872,8.872,0,0,0,.643,3.432,7.965,7.965,0,0,0,1.766,2.656,7.694,7.694,0,0,0,2.656,1.7A9.108,9.108,0,0,0,578,32.33a9.2,9.2,0,0,0,3.349-.594,7.607,7.607,0,0,0,4.406-4.356,9.634,9.634,0,0,0-.017-6.881,8.109,8.109,0,0,0-1.766-2.69,7.773,7.773,0,0,0-2.656-1.733A8.89,8.89,0,0,0,578,15.467Zm0,2.013a6.366,6.366,0,0,1,2.491.479,5.643,5.643,0,0,1,1.947,1.337,6.247,6.247,0,0,1,1.271,2.046,7.134,7.134,0,0,1,.462,2.607,7.235,7.235,0,0,1-.445,2.59,5.592,5.592,0,0,1-1.271,2,5.688,5.688,0,0,1-1.947,1.271,7.236,7.236,0,0,1-5,0,5.486,5.486,0,0,1-1.947-1.271,5.911,5.911,0,0,1-1.271-2,7,7,0,0,1-.462-2.59,7.37,7.37,0,0,1,.445-2.607,5.9,5.9,0,0,1,1.271-2.046,5.816,5.816,0,0,1,1.964-1.337A6.366,6.366,0,0,1,578,17.48ZM39.139,69.855,37.621,68.37a6.112,6.112,0,0,1-2.1,1.386,6.554,6.554,0,0,1-2.425.462,6.927,6.927,0,0,1-2.409-.413,5.878,5.878,0,0,1-1.98-1.2,5.559,5.559,0,0,1-1.353-1.98,7.074,7.074,0,0,1-.495-2.739,6.859,6.859,0,0,1,.495-2.689,5.878,5.878,0,0,1,1.337-1.98,5.716,5.716,0,0,1,2-1.238,6.956,6.956,0,0,1,2.442-.429,6.032,6.032,0,0,1,4.29,1.749l1.452-1.419a8.078,8.078,0,0,0-2.69-1.831,8.189,8.189,0,0,0-3.085-.577,9.586,9.586,0,0,0-3.316.561,7.588,7.588,0,0,0-2.673,1.65,7.862,7.862,0,0,0-1.8,2.64,9.838,9.838,0,0,0,.017,7.128,7.984,7.984,0,0,0,1.815,2.673,7.588,7.588,0,0,0,2.673,1.65,9.488,9.488,0,0,0,3.284.561,8.451,8.451,0,0,0,6.039-2.475ZM49.666,55.467a9.073,9.073,0,0,0-3.382.61,7.6,7.6,0,0,0-2.64,1.732,8.03,8.03,0,0,0-1.732,2.69,9.2,9.2,0,0,0-.627,3.448,8.872,8.872,0,0,0,.643,3.432,7.964,7.964,0,0,0,1.765,2.657,7.694,7.694,0,0,0,2.657,1.7,9.108,9.108,0,0,0,3.317.594,9.2,9.2,0,0,0,3.349-.594,7.607,7.607,0,0,0,4.406-4.356A9.633,9.633,0,0,0,57.4,60.5a8.109,8.109,0,0,0-1.765-2.69,7.774,7.774,0,0,0-2.657-1.732A8.89,8.89,0,0,0,49.666,55.467Zm0,2.013a6.366,6.366,0,0,1,2.491.479A5.643,5.643,0,0,1,54.1,59.295a6.247,6.247,0,0,1,1.27,2.046,7.134,7.134,0,0,1,.462,2.607,7.235,7.235,0,0,1-.445,2.59,5.593,5.593,0,0,1-1.271,2,5.688,5.688,0,0,1-1.947,1.27,7.236,7.236,0,0,1-5,0,5.486,5.486,0,0,1-1.947-1.27,5.911,5.911,0,0,1-1.271-2,7,7,0,0,1-.462-2.59,7.37,7.37,0,0,1,.445-2.607,5.9,5.9,0,0,1,1.271-2.046,5.816,5.816,0,0,1,1.964-1.336A6.366,6.366,0,0,1,49.666,57.48ZM73.921,72h2.211V62.562a5.689,5.689,0,0,1,.346-2.013,4.674,4.674,0,0,1,.99-1.6,4.811,4.811,0,0,1,1.518-1.073,4.708,4.708,0,0,1,1.964-.4,4.767,4.767,0,0,1,1.947.38A4.4,4.4,0,0,1,84.365,58.9a4.558,4.558,0,0,1,.94,1.584,5.945,5.945,0,0,1,.33,2.013V72h2.211V62.5a8.174,8.174,0,0,0-.495-2.921,6.476,6.476,0,0,0-1.386-2.228,5.793,5.793,0,0,0-2.161-1.4,7.951,7.951,0,0,0-2.822-.478,7.109,7.109,0,0,0-3.432.874,5.507,5.507,0,0,0-2.442,2.822,5.591,5.591,0,0,0-.974-1.749,5.173,5.173,0,0,0-1.386-1.172,5.25,5.25,0,0,0-1.633-.611,9.241,9.241,0,0,0-1.749-.165,7.05,7.05,0,0,0-2.871.61,4.464,4.464,0,0,0-2.178,2.161l-.1-2.607H62.14V72h2.211V62.562a5.689,5.689,0,0,1,.347-2.013,4.81,4.81,0,0,1,.974-1.6,4.621,4.621,0,0,1,1.5-1.073,5.066,5.066,0,0,1,3.927,0,4.622,4.622,0,0,1,1.5,1.073,4.809,4.809,0,0,1,.973,1.6,5.689,5.689,0,0,1,.347,2.013Zm27.357-1.815a6.16,6.16,0,0,1-2.442-.479,5.8,5.8,0,0,1-1.93-1.32,6.135,6.135,0,0,1-1.271-2,6.691,6.691,0,0,1-.462-2.508,6.911,6.911,0,0,1,.446-2.508,5.919,5.919,0,0,1,1.254-2,5.8,5.8,0,0,1,1.931-1.32,6.245,6.245,0,0,1,2.475-.479,7.025,7.025,0,0,1,2.442.413,5.531,5.531,0,0,1,1.947,1.2,5.447,5.447,0,0,1,1.287,1.964,7.292,7.292,0,0,1,.462,2.689,7.163,7.163,0,0,1-.479,2.723,5.8,5.8,0,0,1-1.3,1.98,5.415,5.415,0,0,1-1.947,1.221A6.927,6.927,0,0,1,101.278,70.185Zm-8.481,9.6h2.178V68.7a6.311,6.311,0,0,0,2.756,2.739,8,8,0,0,0,3.646.891,9.206,9.206,0,0,0,3.3-.577,7.312,7.312,0,0,0,2.607-1.667A7.765,7.765,0,0,0,109,67.413a9.614,9.614,0,0,0,.627-3.564,9.26,9.26,0,0,0-.61-3.448,7.793,7.793,0,0,0-1.683-2.624,7.435,7.435,0,0,0-2.541-1.683,8.875,8.875,0,0,0-3.184-.627,7.523,7.523,0,0,0-3.894.957,6.9,6.9,0,0,0-2.706,2.739L94.942,55.7H92.8Zm34.65-20.856a5.838,5.838,0,0,0-1.171-1.518,6.812,6.812,0,0,0-1.551-1.089,7.6,7.6,0,0,0-1.8-.644,8.583,8.583,0,0,0-1.881-.214,8.886,8.886,0,0,0-3.267.594,7.854,7.854,0,0,0-2.64,1.683,7.986,7.986,0,0,0-1.782,2.64,8.765,8.765,0,0,0-.66,3.465,9.177,9.177,0,0,0,.644,3.515,7.8,7.8,0,0,0,1.782,2.673,7.945,7.945,0,0,0,2.64,1.7,8.757,8.757,0,0,0,3.25.594,8.149,8.149,0,0,0,1.848-.215,7.273,7.273,0,0,0,1.766-.66,7.7,7.7,0,0,0,1.584-1.122,6.784,6.784,0,0,0,1.271-1.567V72h2.046V55.7h-2.079Zm-6.336-1.452a6.176,6.176,0,0,1,3.515.941,5.974,5.974,0,0,1,2.1,2.359,7.215,7.215,0,0,1,0,6.171,5.974,5.974,0,0,1-2.1,2.359,6.176,6.176,0,0,1-3.515.94,6.388,6.388,0,0,1-2.425-.462,5.91,5.91,0,0,1-1.98-1.3,6.039,6.039,0,0,1-1.32-2.013,7.386,7.386,0,0,1,0-5.231,5.825,5.825,0,0,1,1.32-2.013,6.038,6.038,0,0,1,1.98-1.287A6.388,6.388,0,0,1,121.111,57.48ZM136.753,55.7h-2.079V72h2.211V62.727a5.262,5.262,0,0,1,.4-2.062,5.009,5.009,0,0,1,4.653-3.086,4.855,4.855,0,0,1,2.805.858l1.023-1.848a6.342,6.342,0,0,0-1.732-.891,6.576,6.576,0,0,0-1.964-.264,7.724,7.724,0,0,0-1.485.149,5.664,5.664,0,0,0-1.452.495,5.073,5.073,0,0,0-1.271.908,4.809,4.809,0,0,0-.973,1.386Zm15.84-4.818-2.211.231V55.83h-3.333v1.881h3.333v9.108a6.314,6.314,0,0,0,1.138,3.993,4.441,4.441,0,0,0,3.779,1.419,5.855,5.855,0,0,0,1.568-.215,10.454,10.454,0,0,0,1.567-.577l-.693-1.848a9.935,9.935,0,0,1-1.2.445,4.108,4.108,0,0,1-1.172.182,2.38,2.38,0,0,1-2.211-.924,4.74,4.74,0,0,1-.561-2.475V57.711h5.28V55.83h-5.28Zm11.022,4.752H161.4V72h2.211Zm-2.64-5.049a1.382,1.382,0,0,0,.495,1.172,1.705,1.705,0,0,0,1.056.38,1.75,1.75,0,0,0,1.089-.38,1.614,1.614,0,0,0,0-2.326,1.7,1.7,0,0,0-1.089-.4,1.662,1.662,0,0,0-1.056.4A1.391,1.391,0,0,0,160.975,50.583ZM171.2,48.9h-2.211V72H171.2Zm7.557,0h-2.178V72h2.211V63.222a6.072,6.072,0,0,1,.4-2.211,5.667,5.667,0,0,1,1.105-1.8,4.933,4.933,0,0,1,1.7-1.2,5.42,5.42,0,0,1,2.178-.429,4.536,4.536,0,0,1,3.663,1.4,5.815,5.815,0,0,1,1.188,3.878V72h2.211V62.859a9.9,9.9,0,0,0-.429-3,6.523,6.523,0,0,0-1.27-2.326,5.722,5.722,0,0,0-2.112-1.518,7.539,7.539,0,0,0-2.987-.544,7.983,7.983,0,0,0-3.151.709,5.741,5.741,0,0,0-2.525,2.36Zm31.119,10.032a5.838,5.838,0,0,0-1.171-1.518,6.812,6.812,0,0,0-1.551-1.089,7.6,7.6,0,0,0-1.8-.644,8.583,8.583,0,0,0-1.881-.214,8.886,8.886,0,0,0-3.267.594,7.854,7.854,0,0,0-2.64,1.683,7.986,7.986,0,0,0-1.782,2.64,8.766,8.766,0,0,0-.66,3.465,9.177,9.177,0,0,0,.643,3.515,7.8,7.8,0,0,0,1.782,2.673,7.945,7.945,0,0,0,2.64,1.7,8.757,8.757,0,0,0,3.251.594,8.149,8.149,0,0,0,1.848-.215,7.273,7.273,0,0,0,1.765-.66,7.7,7.7,0,0,0,1.584-1.122,6.784,6.784,0,0,0,1.271-1.567V72h2.046V55.7h-2.079Zm-6.336-1.452a6.176,6.176,0,0,1,3.514.941,5.974,5.974,0,0,1,2.1,2.359,7.215,7.215,0,0,1,0,6.171,5.974,5.974,0,0,1-2.1,2.359,6.176,6.176,0,0,1-3.514.94,6.388,6.388,0,0,1-2.425-.462,5.91,5.91,0,0,1-1.98-1.3,6.039,6.039,0,0,1-1.32-2.013,7.386,7.386,0,0,1,0-5.231,5.825,5.825,0,0,1,1.32-2.013,6.039,6.039,0,0,1,1.98-1.287A6.388,6.388,0,0,1,203.545,57.48Zm20.889.066a6.388,6.388,0,0,1,2.426.462,5.855,5.855,0,0,1,1.964,1.287,5.986,5.986,0,0,1,1.3,2,6.7,6.7,0,0,1,.479,2.557,6.79,6.79,0,0,1-.479,2.59,6.172,6.172,0,0,1-1.3,2.013,5.771,5.771,0,0,1-1.947,1.3,6.351,6.351,0,0,1-2.442.462,6.79,6.79,0,0,1-2.392-.413,5.61,5.61,0,0,1-1.947-1.221,5.685,5.685,0,0,1-1.32-1.98,7.163,7.163,0,0,1-.479-2.722,7.29,7.29,0,0,1,.479-2.739,5.489,5.489,0,0,1,1.32-1.98,5.735,5.735,0,0,1,1.947-1.2A6.79,6.79,0,0,1,224.434,57.546Zm8.481-8.613H230.7V58.965A5.8,5.8,0,0,0,228,56.292a8.094,8.094,0,0,0-3.7-.825,8.607,8.607,0,0,0-3.234.528,7.636,7.636,0,0,0-2.607,1.634,7.391,7.391,0,0,0-1.749,2.64,10.726,10.726,0,0,0,0,7.227,7.391,7.391,0,0,0,1.749,2.64,7.636,7.636,0,0,0,2.607,1.633,9.079,9.079,0,0,0,3.234.561,7.934,7.934,0,0,0,3.679-.891,6.44,6.44,0,0,0,2.723-2.673L230.77,72h2.145Zm12.474,6.534a9.073,9.073,0,0,0-3.382.61,7.6,7.6,0,0,0-2.64,1.732,8.03,8.03,0,0,0-1.732,2.69,9.2,9.2,0,0,0-.627,3.448,8.872,8.872,0,0,0,.643,3.432,7.964,7.964,0,0,0,1.766,2.657,7.694,7.694,0,0,0,2.656,1.7,9.108,9.108,0,0,0,3.316.594,9.2,9.2,0,0,0,3.35-.594,7.607,7.607,0,0,0,4.406-4.356,9.633,9.633,0,0,0-.016-6.88,8.109,8.109,0,0,0-1.766-2.69,7.774,7.774,0,0,0-2.656-1.732A8.89,8.89,0,0,0,245.389,55.467Zm0,2.013a6.366,6.366,0,0,1,2.492.479,5.643,5.643,0,0,1,1.947,1.336,6.247,6.247,0,0,1,1.27,2.046,7.134,7.134,0,0,1,.462,2.607,7.235,7.235,0,0,1-.445,2.59,5.593,5.593,0,0,1-1.271,2,5.688,5.688,0,0,1-1.947,1.27,7.236,7.236,0,0,1-5,0,5.486,5.486,0,0,1-1.947-1.27,5.91,5.91,0,0,1-1.271-2,7,7,0,0,1-.462-2.59,7.37,7.37,0,0,1,.445-2.607,5.9,5.9,0,0,1,1.271-2.046,5.816,5.816,0,0,1,1.963-1.336A6.366,6.366,0,0,1,245.389,57.48Zm36.5,7.326a10.491,10.491,0,0,0-.33-4.174,7.272,7.272,0,0,0-1.683-2.921,6.946,6.946,0,0,0-2.706-1.716,9.579,9.579,0,0,0-3.4-.528,8.362,8.362,0,0,0-3.35.594,7.8,7.8,0,0,0-2.64,1.749,8.069,8.069,0,0,0-1.733,2.673,8.9,8.9,0,0,0-.627,3.366,9.178,9.178,0,0,0,.643,3.515,7.926,7.926,0,0,0,1.766,2.673,7.661,7.661,0,0,0,2.673,1.7,9.334,9.334,0,0,0,3.366.594,10.4,10.4,0,0,0,3.861-.759,7.476,7.476,0,0,0,3.135-2.277l-1.485-1.32a4.158,4.158,0,0,1-1.072.974,7.416,7.416,0,0,1-1.386.693,9.056,9.056,0,0,1-1.534.429,8.24,8.24,0,0,1-1.518.148,7.108,7.108,0,0,1-2.294-.363,5.82,5.82,0,0,1-1.9-1.056,5.57,5.57,0,0,1-1.353-1.7,5.849,5.849,0,0,1-.627-2.294ZM267.7,62.925a5.8,5.8,0,0,1,6.1-5.511,7.257,7.257,0,0,1,2.31.363,5.6,5.6,0,0,1,1.9,1.056,5,5,0,0,1,1.287,1.732,5.948,5.948,0,0,1,.512,2.36ZM306.208,72h2.211V62.562a5.688,5.688,0,0,1,.346-2.013,4.674,4.674,0,0,1,.99-1.6,4.812,4.812,0,0,1,1.518-1.073,4.708,4.708,0,0,1,1.964-.4,4.767,4.767,0,0,1,1.947.38,4.4,4.4,0,0,1,1.469,1.039,4.558,4.558,0,0,1,.94,1.584,5.945,5.945,0,0,1,.33,2.013V72h2.211V62.5a8.174,8.174,0,0,0-.495-2.921,6.476,6.476,0,0,0-1.386-2.228,5.792,5.792,0,0,0-2.161-1.4,7.951,7.951,0,0,0-2.822-.478,7.109,7.109,0,0,0-3.432.874,5.507,5.507,0,0,0-2.442,2.822,5.59,5.59,0,0,0-.974-1.749,5.173,5.173,0,0,0-1.386-1.172,5.25,5.25,0,0,0-1.634-.611,9.24,9.24,0,0,0-1.749-.165,7.05,7.05,0,0,0-2.871.61,4.464,4.464,0,0,0-2.178,2.161l-.1-2.607h-2.079V72h2.211V62.562a5.689,5.689,0,0,1,.346-2.013,4.809,4.809,0,0,1,.974-1.6,4.621,4.621,0,0,1,1.5-1.073,5.066,5.066,0,0,1,3.927,0,4.622,4.622,0,0,1,1.5,1.073,4.809,4.809,0,0,1,.974,1.6,5.689,5.689,0,0,1,.346,2.013Zm32.571-13.068a5.838,5.838,0,0,0-1.172-1.518,6.811,6.811,0,0,0-1.551-1.089,7.6,7.6,0,0,0-1.8-.644,8.583,8.583,0,0,0-1.881-.214,8.886,8.886,0,0,0-3.267.594,7.854,7.854,0,0,0-2.64,1.683,7.986,7.986,0,0,0-1.782,2.64,8.765,8.765,0,0,0-.66,3.465,9.178,9.178,0,0,0,.643,3.515,7.8,7.8,0,0,0,1.782,2.673,7.945,7.945,0,0,0,2.64,1.7,8.757,8.757,0,0,0,3.251.594,8.149,8.149,0,0,0,1.848-.215,7.273,7.273,0,0,0,1.766-.66,7.7,7.7,0,0,0,1.584-1.122,6.784,6.784,0,0,0,1.271-1.567V72h2.046V55.7h-2.079Zm-6.336-1.452a6.176,6.176,0,0,1,3.514.941,5.974,5.974,0,0,1,2.1,2.359,7.215,7.215,0,0,1,0,6.171,5.974,5.974,0,0,1-2.1,2.359,6.176,6.176,0,0,1-3.514.94,6.388,6.388,0,0,1-2.426-.462,5.91,5.91,0,0,1-1.98-1.3,6.039,6.039,0,0,1-1.32-2.013,7.386,7.386,0,0,1,0-5.231,5.825,5.825,0,0,1,1.32-2.013,6.039,6.039,0,0,1,1.98-1.287A6.388,6.388,0,0,1,332.443,57.48Zm15.774-1.848h-2.211V72h2.211Zm-2.64-5.049a1.382,1.382,0,0,0,.5,1.172,1.705,1.705,0,0,0,1.056.38,1.75,1.75,0,0,0,1.089-.38,1.614,1.614,0,0,0,0-2.326,1.7,1.7,0,0,0-1.089-.4,1.662,1.662,0,0,0-1.056.4A1.391,1.391,0,0,0,345.577,50.583ZM363.991,59.1l1.287-1.452a7.9,7.9,0,0,0-2.772-1.683,10.193,10.193,0,0,0-3.366-.528,10.923,10.923,0,0,0-2.376.264,6.688,6.688,0,0,0-2.112.842,4.787,4.787,0,0,0-1.5,1.468,3.737,3.737,0,0,0-.577,2.079,3.463,3.463,0,0,0,.577,2.063,4.363,4.363,0,0,0,1.485,1.3,8.048,8.048,0,0,0,2.046.759q1.139.264,2.327.429.99.132,1.848.3a6.02,6.02,0,0,1,1.5.479,2.6,2.6,0,0,1,1.007.825,2.2,2.2,0,0,1,.363,1.3A2.077,2.077,0,0,1,363.3,68.9a3.049,3.049,0,0,1-1.105.841,5.286,5.286,0,0,1-1.452.429,9.988,9.988,0,0,1-1.469.115,9.839,9.839,0,0,1-3.2-.627,5.742,5.742,0,0,1-2.673-2.013l-1.386,1.518a7.063,7.063,0,0,0,3.184,2.425,11.164,11.164,0,0,0,4.043.743,11.3,11.3,0,0,0,2.426-.264,7.139,7.139,0,0,0,2.145-.825,4.511,4.511,0,0,0,1.518-1.468,4.212,4.212,0,0,0,.611-2.194,3.974,3.974,0,0,0-.643-2.376,4.427,4.427,0,0,0-1.634-1.386,8.453,8.453,0,0,0-2.178-.726q-1.188-.231-2.277-.4-.759-.1-1.551-.264a6.658,6.658,0,0,1-1.436-.462,3.176,3.176,0,0,1-1.056-.759,1.717,1.717,0,0,1-.413-1.188,1.691,1.691,0,0,1,.33-1.122,2.88,2.88,0,0,1,.973-.825,4.787,4.787,0,0,1,1.419-.479,9.4,9.4,0,0,1,1.7-.149,10.108,10.108,0,0,1,2.492.3A5.509,5.509,0,0,1,363.991,59.1Zm27.885,10.758-1.518-1.485a6.112,6.112,0,0,1-2.1,1.386,6.554,6.554,0,0,1-2.426.462,6.927,6.927,0,0,1-2.409-.413,5.877,5.877,0,0,1-1.98-1.2,5.559,5.559,0,0,1-1.353-1.98,7.075,7.075,0,0,1-.495-2.739,6.859,6.859,0,0,1,.495-2.689,5.878,5.878,0,0,1,1.336-1.98,5.716,5.716,0,0,1,2-1.238,6.956,6.956,0,0,1,2.442-.429,6.032,6.032,0,0,1,4.29,1.749l1.452-1.419a8.078,8.078,0,0,0-2.689-1.831,8.189,8.189,0,0,0-3.086-.577,9.586,9.586,0,0,0-3.316.561,7.587,7.587,0,0,0-2.673,1.65,7.862,7.862,0,0,0-1.8,2.64,9.838,9.838,0,0,0,.016,7.128,7.984,7.984,0,0,0,1.815,2.673,7.588,7.588,0,0,0,2.673,1.65,9.488,9.488,0,0,0,3.284.561,8.451,8.451,0,0,0,6.039-2.475ZM402.4,55.467a9.073,9.073,0,0,0-3.383.61,7.6,7.6,0,0,0-2.64,1.732,8.03,8.03,0,0,0-1.733,2.69,9.2,9.2,0,0,0-.627,3.448,8.873,8.873,0,0,0,.643,3.432,7.964,7.964,0,0,0,1.766,2.657,7.694,7.694,0,0,0,2.656,1.7,9.108,9.108,0,0,0,3.316.594,9.2,9.2,0,0,0,3.35-.594,7.607,7.607,0,0,0,4.405-4.356,9.633,9.633,0,0,0-.017-6.88,8.108,8.108,0,0,0-1.766-2.69,7.773,7.773,0,0,0-2.656-1.732A8.89,8.89,0,0,0,402.4,55.467Zm0,2.013a6.366,6.366,0,0,1,2.492.479,5.643,5.643,0,0,1,1.947,1.336,6.247,6.247,0,0,1,1.271,2.046,7.134,7.134,0,0,1,.462,2.607,7.235,7.235,0,0,1-.445,2.59,5.593,5.593,0,0,1-1.27,2,5.688,5.688,0,0,1-1.947,1.27,7.236,7.236,0,0,1-5,0,5.486,5.486,0,0,1-1.947-1.27,5.91,5.91,0,0,1-1.27-2,7,7,0,0,1-.462-2.59,7.37,7.37,0,0,1,.445-2.607,5.9,5.9,0,0,1,1.271-2.046,5.816,5.816,0,0,1,1.964-1.336A6.366,6.366,0,0,1,402.4,57.48ZM426.658,72h2.211V62.562a5.688,5.688,0,0,1,.346-2.013,4.674,4.674,0,0,1,.99-1.6,4.812,4.812,0,0,1,1.518-1.073,4.708,4.708,0,0,1,1.964-.4,4.767,4.767,0,0,1,1.947.38A4.4,4.4,0,0,1,437.1,58.9a4.558,4.558,0,0,1,.94,1.584,5.945,5.945,0,0,1,.33,2.013V72h2.211V62.5a8.174,8.174,0,0,0-.495-2.921,6.476,6.476,0,0,0-1.386-2.228,5.792,5.792,0,0,0-2.161-1.4,7.951,7.951,0,0,0-2.822-.478,7.109,7.109,0,0,0-3.432.874,5.507,5.507,0,0,0-2.442,2.822,5.59,5.59,0,0,0-.974-1.749,5.173,5.173,0,0,0-1.386-1.172,5.25,5.25,0,0,0-1.634-.611,9.24,9.24,0,0,0-1.749-.165,7.05,7.05,0,0,0-2.871.61,4.464,4.464,0,0,0-2.178,2.161l-.1-2.607h-2.079V72h2.211V62.562a5.689,5.689,0,0,1,.346-2.013,4.809,4.809,0,0,1,.974-1.6,4.621,4.621,0,0,1,1.5-1.073,5.066,5.066,0,0,1,3.927,0,4.622,4.622,0,0,1,1.5,1.073,4.809,4.809,0,0,1,.974,1.6,5.689,5.689,0,0,1,.346,2.013Zm26.2-16.533a9.073,9.073,0,0,0-3.383.61,7.6,7.6,0,0,0-2.64,1.732A8.03,8.03,0,0,0,445.1,60.5a9.2,9.2,0,0,0-.627,3.448,8.873,8.873,0,0,0,.643,3.432,7.964,7.964,0,0,0,1.766,2.657,7.694,7.694,0,0,0,2.656,1.7,9.108,9.108,0,0,0,3.316.594,9.2,9.2,0,0,0,3.35-.594,7.607,7.607,0,0,0,4.405-4.356,9.633,9.633,0,0,0-.017-6.88,8.108,8.108,0,0,0-1.766-2.69,7.773,7.773,0,0,0-2.656-1.732A8.89,8.89,0,0,0,452.859,55.467Zm0,2.013a6.366,6.366,0,0,1,2.492.479,5.643,5.643,0,0,1,1.947,1.336,6.247,6.247,0,0,1,1.271,2.046,7.134,7.134,0,0,1,.462,2.607,7.235,7.235,0,0,1-.446,2.59,5.593,5.593,0,0,1-1.27,2,5.688,5.688,0,0,1-1.947,1.27,7.236,7.236,0,0,1-5,0,5.486,5.486,0,0,1-1.947-1.27,5.91,5.91,0,0,1-1.27-2,7,7,0,0,1-.462-2.59,7.37,7.37,0,0,1,.445-2.607,5.9,5.9,0,0,1,1.271-2.046,5.816,5.816,0,0,1,1.964-1.336A6.366,6.366,0,0,1,452.859,57.48Zm19.8.066a6.388,6.388,0,0,1,2.426.462,5.855,5.855,0,0,1,1.964,1.287,5.986,5.986,0,0,1,1.3,2,6.7,6.7,0,0,1,.478,2.557,6.79,6.79,0,0,1-.478,2.59,6.173,6.173,0,0,1-1.3,2.013,5.771,5.771,0,0,1-1.947,1.3,6.352,6.352,0,0,1-2.442.462,6.79,6.79,0,0,1-2.392-.413,5.61,5.61,0,0,1-1.947-1.221A5.685,5.685,0,0,1,467,66.6a7.163,7.163,0,0,1-.479-2.722A7.29,7.29,0,0,1,467,61.143a5.489,5.489,0,0,1,1.32-1.98,5.735,5.735,0,0,1,1.947-1.2A6.79,6.79,0,0,1,472.66,57.546Zm8.481-8.613H478.93V58.965a5.8,5.8,0,0,0-2.706-2.673,8.093,8.093,0,0,0-3.7-.825,8.607,8.607,0,0,0-3.234.528,7.635,7.635,0,0,0-2.607,1.634,7.391,7.391,0,0,0-1.749,2.64,10.726,10.726,0,0,0,0,7.227,7.391,7.391,0,0,0,1.749,2.64,7.635,7.635,0,0,0,2.607,1.633,9.079,9.079,0,0,0,3.234.561,7.934,7.934,0,0,0,3.68-.891,6.44,6.44,0,0,0,2.723-2.673L479,72h2.145Zm7.359,6.7h-2.211V72H488.5Zm-2.64-5.049a1.382,1.382,0,0,0,.5,1.172,1.705,1.705,0,0,0,1.056.38,1.75,1.75,0,0,0,1.089-.38,1.614,1.614,0,0,0,0-2.326,1.7,1.7,0,0,0-1.089-.4,1.662,1.662,0,0,0-1.056.4A1.391,1.391,0,0,0,485.859,50.583Zm15.114,6.963a6.388,6.388,0,0,1,2.426.462,5.855,5.855,0,0,1,1.964,1.287,5.986,5.986,0,0,1,1.3,2,6.7,6.7,0,0,1,.479,2.557,6.79,6.79,0,0,1-.479,2.59,6.173,6.173,0,0,1-1.3,2.013,5.771,5.771,0,0,1-1.947,1.3,6.352,6.352,0,0,1-2.442.462,6.79,6.79,0,0,1-2.392-.413,5.61,5.61,0,0,1-1.947-1.221,5.685,5.685,0,0,1-1.32-1.98,7.163,7.163,0,0,1-.479-2.722,7.29,7.29,0,0,1,.479-2.739,5.489,5.489,0,0,1,1.32-1.98,5.735,5.735,0,0,1,1.947-1.2A6.79,6.79,0,0,1,500.974,57.546Zm8.481-8.613h-2.211V58.965a5.8,5.8,0,0,0-2.706-2.673,8.093,8.093,0,0,0-3.7-.825,8.607,8.607,0,0,0-3.234.528A7.635,7.635,0,0,0,495,57.629a7.391,7.391,0,0,0-1.749,2.64,10.726,10.726,0,0,0,0,7.227A7.391,7.391,0,0,0,495,70.135a7.635,7.635,0,0,0,2.607,1.633,9.079,9.079,0,0,0,3.234.561,7.934,7.934,0,0,0,3.68-.891,6.44,6.44,0,0,0,2.723-2.673L507.31,72h2.145Zm18.843,10a5.837,5.837,0,0,0-1.172-1.518,6.811,6.811,0,0,0-1.551-1.089,7.6,7.6,0,0,0-1.8-.644,8.583,8.583,0,0,0-1.881-.214,8.886,8.886,0,0,0-3.267.594,7.854,7.854,0,0,0-2.64,1.683,7.985,7.985,0,0,0-1.782,2.64,8.765,8.765,0,0,0-.66,3.465,9.177,9.177,0,0,0,.643,3.515,7.805,7.805,0,0,0,1.782,2.673,7.945,7.945,0,0,0,2.64,1.7,8.757,8.757,0,0,0,3.25.594,8.149,8.149,0,0,0,1.848-.215,7.274,7.274,0,0,0,1.766-.66,7.7,7.7,0,0,0,1.584-1.122,6.784,6.784,0,0,0,1.271-1.567V72h2.046V55.7H528.3Zm-6.336-1.452a6.176,6.176,0,0,1,3.515.941,5.975,5.975,0,0,1,2.1,2.359,7.215,7.215,0,0,1,0,6.171,5.975,5.975,0,0,1-2.1,2.359,6.176,6.176,0,0,1-3.515.94,6.388,6.388,0,0,1-2.425-.462,5.909,5.909,0,0,1-1.98-1.3,6.038,6.038,0,0,1-1.32-2.013,7.386,7.386,0,0,1,0-5.231,5.824,5.824,0,0,1,1.32-2.013,6.038,6.038,0,0,1,1.98-1.287A6.388,6.388,0,0,1,521.961,57.48Zm20.889.066a6.388,6.388,0,0,1,2.425.462,5.855,5.855,0,0,1,1.964,1.287,5.986,5.986,0,0,1,1.3,2,6.7,6.7,0,0,1,.478,2.557,6.79,6.79,0,0,1-.478,2.59,6.173,6.173,0,0,1-1.3,2.013,5.771,5.771,0,0,1-1.947,1.3,6.351,6.351,0,0,1-2.442.462,6.79,6.79,0,0,1-2.393-.413,5.611,5.611,0,0,1-1.947-1.221,5.686,5.686,0,0,1-1.32-1.98,7.163,7.163,0,0,1-.478-2.722,7.291,7.291,0,0,1,.478-2.739,5.489,5.489,0,0,1,1.32-1.98,5.735,5.735,0,0,1,1.947-1.2A6.79,6.79,0,0,1,542.851,57.546Zm8.481-8.613H549.12V58.965a5.8,5.8,0,0,0-2.706-2.673,8.093,8.093,0,0,0-3.7-.825,8.607,8.607,0,0,0-3.234.528,7.635,7.635,0,0,0-2.607,1.634,7.392,7.392,0,0,0-1.749,2.64,10.727,10.727,0,0,0,0,7.227,7.392,7.392,0,0,0,1.749,2.64,7.635,7.635,0,0,0,2.607,1.633,9.079,9.079,0,0,0,3.234.561,7.934,7.934,0,0,0,3.68-.891,6.44,6.44,0,0,0,2.722-2.673L549.187,72h2.145Zm20.559,15.873a10.492,10.492,0,0,0-.33-4.174,7.273,7.273,0,0,0-1.683-2.921,6.946,6.946,0,0,0-2.706-1.716,9.579,9.579,0,0,0-3.4-.528,8.362,8.362,0,0,0-3.349.594,7.8,7.8,0,0,0-2.64,1.749,8.068,8.068,0,0,0-1.732,2.673,8.9,8.9,0,0,0-.627,3.366,9.177,9.177,0,0,0,.643,3.515,7.926,7.926,0,0,0,1.766,2.673,7.661,7.661,0,0,0,2.673,1.7,9.334,9.334,0,0,0,3.366.594,10.4,10.4,0,0,0,3.861-.759,7.476,7.476,0,0,0,3.135-2.277l-1.485-1.32a4.158,4.158,0,0,1-1.073.974,7.414,7.414,0,0,1-1.386.693,9.055,9.055,0,0,1-1.534.429,8.24,8.24,0,0,1-1.518.148,7.107,7.107,0,0,1-2.294-.363,5.819,5.819,0,0,1-1.9-1.056,5.569,5.569,0,0,1-1.353-1.7,5.85,5.85,0,0,1-.627-2.294ZM557.7,62.925a5.8,5.8,0,0,1,6.105-5.511,7.258,7.258,0,0,1,2.31.363,5.6,5.6,0,0,1,1.9,1.056,5,5,0,0,1,1.287,1.732,5.949,5.949,0,0,1,.511,2.36Zm17.787,7.821a1.382,1.382,0,0,0,.495,1.172,1.705,1.705,0,0,0,2.145,0,1.634,1.634,0,0,0,0-2.343,1.705,1.705,0,0,0-2.145,0A1.382,1.382,0,0,0,575.488,70.746Z\" transform=\"translate(24.063 492.051)\"/>\r\n      <text id=\"empresas\" class=\"hbmb-cls-5\" transform=\"translate(334.563 420.051)\"><tspan x=\"-310.662\" y=\"0\">empresas</tspan></text>\r\n      <path id=\"para-empresas\" class=\"hbmb-cls-6\" d=\"M62.453.133C39.066.133,21.06-17.873,21.06-42.916S38.652-85.964,62.453-85.964c23.18,0,41.806,14.073,41.806,42.841S85.632.133,62.453.133Zm-42.22,50.5V-15.6C28.925,1.374,45.068,9.86,62.453,9.86,91.22,9.86,114.4-8.767,114.4-43.122c0-32.907-21.938-51.534-49.671-52.569-19.868,0-36.218,10.141-44.29,25.663V-94.242H10.505V50.632ZM227.4-94.242V-71.89c-8.485-15.936-25.249-23.594-41.806-23.594-28.561,0-51.948,21.11-51.948,52.362S157.035,9.653,185.6,9.653c16.557,0,31.872-7.451,41.806-23.387V8h10.141V-94.242ZM185.6-85.757c56.915,0,56.915,85.476,0,85.476-23.18,0-41.806-17.178-41.806-42.841S162.416-85.757,185.6-85.757Zm79.474-8.485V8H275.21V-51.608a33.96,33.96,0,0,1,33.735-34.149A32.878,32.878,0,0,1,326.33-81l4.553-8.279a39.917,39.917,0,0,0-21.938-6c-13.039,0-27.526,5.381-33.942,19.248l-.414-18.213Zm169.3,0V-71.89c-8.485-15.936-25.249-23.594-41.806-23.594-28.561,0-51.948,21.11-51.948,52.362S364,9.653,392.558,9.653c16.557,0,31.872-7.451,41.806-23.387V8h10.141V-94.242Zm-41.806,8.485c56.915,0,56.915,85.476,0,85.476-23.18,0-41.806-17.178-41.806-42.841S369.378-85.757,392.558-85.757Z\" transform=\"translate(178.724 270.209)\"/>\r\n      <path id=\"mais-empresas\" class=\"hbmb-cls-2\" d=\"M9.555-61.108v12.224H54.121V-3.81H66.09V-48.885h44.566V-61.108H66.09v-43.8H54.121v43.8Z\" transform=\"translate(37.619 296.319)\"/>\r\n    </g>\r\n    <image id=\"img-business-mob\" width=\"742\" height=\"501\" transform=\"translate(-7 57)\" xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAuYAAAH1CAYAAAC6Mzv7AAAABHNCSVQICAgIfAhkiAAAIABJREFUeF7svQm8ZVdV7jvPPrvfp2+qr1RVKh2tKCKIyEUQEQHl2guIynvXd316nz+v96coKI1yhWuHLdIJGEAkEJpohJiYKAmhCYihC+mq709Tp9379O/7jzHn3rtOqpJKpZqTylqVlb3P2quZa6y51vrGN78xRkfIpswCmQUyC2QWyCyQWSCzQGaBzAKZBS64BToueAuyBmQWyCyQWSCzQGaBzAKZBTILZBbILBAyYP7o7wQPdQ1XHv2nmJ1BZoHMApkFMgtkFsgskFng4rfAQ4G6i98Ca/8Mz/U1yoD72u8DWQszC2QWyCyQWSCzQGaBx4AFzjXoewyY8Kyf4smuyekue7DGnAyAnwqUZ2D9rF/WbIeZBTILZBbILJBZILNAZoEHt0AGzC98D3ko0N3++6m+n+5ZtAPu0/me9psB9dO1cLZeZoHMApkFMgtkFsgskFngDC2QAfMzNNwj3Gy13U8GuNOy5ucv//IvPDGf73xiqdD5+PmVlSc3FlYGF1dCbWk5V+vIdVRXQkctLHfUljs6JheXVsY6VpbH9H1sZXl5rKOjY3RlZeXY0tLSXQtzc1/92NVX361zSID7VJ+c5mpQnoH0R3jxs80f2gJ/9+n/rIWZ6dpcfrG2OLtcC7nO6krHcqmjszC+OLcy9j9+5lkHH3ov2RqZBTILZBbILJBZ4NFlgQyYn9/rdVoAXE3qeOnLXvakSr78zGKx8+mlYseTK+WOJ+VzuZDTHnKdHaGzo8MQ83RjOSwsrwT9F1Y0L2pZriMXFvRlhXVY2DbRAOZl/dMOvphbWf5G6Fi5c2Vl8StX/817bo1A/EwA+/m1ZHa0i8IC7/nYzdsXFpeemOvsfII67JPVxR+vHvoU9WJ1T/1TT1xaUm+lg6vnWj/Xt8XFJTr8bMjlR5fleOZyHYdzudxXBvq6vjZYq935wmdfdedFYaDsJDILZBbILJBZ4DFlgQyYn5/LfSpAnnBy+J4X/NgVXdXizxQLxe/Nda48Nd+ZqxUK+ZAXuC4UOkOhczlUy/nQqc+80DkgXSx4WFpZDrNzS2F+SaBF57K0wqfmJYGajk4BmRVBHIC45mX9EsG6gIxh8E6tCwBieS63PJVfXr6pq5j71MLk1D/9xbs+cCSaByz0cFj182PV7CiPKgu85d3v7u5cqDyjUqk8I1+pPlNd9xkaAeoToLb+F+RQtvxInMrUZwHpfNf/td6y+jgO54K8z/n5BTmqedu+Q/upVoqhv7uiuRyG+7u+2tNdubNaKnyxXC1+sq9S2fWoMljW2MwCmQUyC2QWeMxZIAPm5+6Sn0yu0gTi0H9Pf97zBmrVoZ/Md3b+/HJH+A7BEwHvXMjnc2LEYccFnMWOF4v5UNKyfF66lXJnKBa0TOuBrQHbC0LdM41FfTqjCDgXnyjw0mmg25lG2EcH4EwJAPFnp47DZL/oe1HH6tYxyvncl5eXl26YbSxc+2d/9s6vrALpq4G67fbcmTPb86PRAu/66E3bOnMd/9fiwsKPHDx0+Mm9XVU5kYtheHh9GwgHbwPMAdzeP5MDGXul9c4l68PujIYVQPyK2PQljQ4tBUm3Qme+M5QKxdBVK4WBnkoY6qsKoFdDT60cKqVC0H12t+6tfyp0dnyqUCjc8Gi0Z9bmzAKZBTILZBa4uC2QAfNzc30foA+PuNeA+XNf/JMvKBQL/484vhctwVZrIaAD9hp2G4ACyBCgMfANOC+LNS8Vc6Fc7BTICKFaEosuRh2+e3FxOcwJnMyIOW/YCL+D8xUBdXa+yPd0nvELOMhAu+P2ZkJ7jg+bns+thJL+KKodtG9+Yf7zS/NLf/62t737IxGAJxY9A+jnpg89avf67k/c2p1bafxsbqXj5Rq2eSb9ebZRD2NjYwLMtTA2MR02bdpkDLdLVOizGtnR3wbMo/Po4DyZoUMAfFn3AqNACLHo3+6Y4nTqOOqji/Z7RTfIgAD5YL9msee9XWUx6SXdO4BznN9OjjWrI92ke+vDOs77H7XGzhqeWSCzQGaBzAIXlQUyYH52L+eDA/If/qkf6cznf1NA4KnCvYaJjfVzNa1AOUAccC7IDigxgCwgEQF6sZQPNc1lsdnVck4AHfZcAF5HnV9YCnUBE2QtdYFzhvuXDJjz6VIWw/wAGoBM25VPOnTDQxGoWxu0FY5BXiy6tOj2vWOlY9/K8tLbJo8ffeff//11k9qCXZ9M6mJ46+yaN9vbWrbAuz/8iSvVBX9bbPQrc7mC9WHD3TDd6jvHjo2pPy/assHBIQHzvPXI9pEcA9m6AwDp1l+b4LxDrLj6YE7AXGBcBLlty3fD5Uhb0J1rWV4OKyz5oBjzdX1doU/seXdVwFyseTEveRijTRavgXzLjnFIG/6V5r8hSHot2zhrW2aBzAKZBTILXNwWyID52bm+7XZMcpXm5/f+0I++TGDlN8SNPy4dzkGBD8f7EL4z53w31pq/DAkDzAHHDlSKYs0Zlq+IOe+uAdCLoQDzqH9zQkWN+cUwN7ccFBMqwJ+LoNz15wl3J615agvLDRAZjd6Su/hJrejYJiQQo+8heTgK4urrUrxcPTs78dZ3vesf7mMXtrJP7UA9/X12LJ3tZc1Z4G1/f/23L9Ybv7O4vPBSMeAdpVJJozkldSV3Bw2gC41P1RvqlA0kJaG3f0AAmnVSgCegmtGhTvVZ+qDfG4lFp2tGcr05IsT6BIYaMLdAUQVByxmFiS/JgR3uq0nOUgsDvdXQK6BeLQuYFwqK15BUDNa8BcyTTev6Anv+VrX5G2vO0FmDMgtkFsgskFngordABswf2SV+CED+Yy/JF4pvEkC5MgEUAyIebmm4G8gLQGBSIJwAt4B2saShd+liBVzyMOICEZ365PdOBXQWhIhhyhXUJpAuvbmQ88oKOlsFgS4sSDawEBbFoE8vzIX63GKoz4tFb8xJ0uLgZfUkaCMm3APsgDgO4J0xB1SRAaZD2xlzDouu303/ruXyExa13tVj4xO/d/XV1xzQTxlAf2R96lGz9Zvf8fFnqm//9tLiwouWlhbU9xqSlzir3amATORZy+qT6MA7OwuSWi2qf6+EDYN9cjCLodbVayDaep31y8SA+/hRWo68JYFydy/Fnus45i6SsYUVLTAUYO53V1GsOUGgQ/1dAudizbsqoUuseaUsp4H7CXAOa+6M+clsfqMWvkm/3fKouSDnuaG6ZlUdkrkSPyWyk88u/yrOfOdCpk+8r/aZJFL8zae8tjAb57rszt/ZlFkgs0BmgcecBTJgfuaX/GSyFV5CHd/7gpc+pVCpvFXfv9uG8eMxYP/KYhNr1WooCyDUqpVQqlQkTymL4SsYUGjpa112wpSAu5HoMYOFa88F0NHUFsVgC5w7wJDmHHCC9pa/SKVofHfOdOhzAu5zc3MC7w2bG3MNgXZ9h83U+zSpXBDY0Bb+GUturLmz57xHUZ4D1AsAdwM5K3M62LskV3jzBz5w7VGtlAH0M+9ba3rLD11/086lxdwfq5f9SGLFafCS+hdd2DG2s+RLCvQEfNcVnHxgdDaMjh4NV10ypD64EDZt2aLV6HNRPxXP2p1Xz8ICqEcWwypgb3Tk5jrqvyXpWZgXxcyXxYav7+8WO14LPdKUoyfHgYUdLxE8rRkZC6DcHVxAOex6cpD94KtBuhzem9TGV2v5HWv6opyDxkXg3a1dM3dp7tEMEK9pLp+DQ67eJUB9Js5T+mzOuh5z5+H42SEyC2QWyCxw3i2QAfMzM3k7KG9KVp7zgy/dXKp1v1nv/J9aEZPX39cbenp6Qm9vjzHgkrOc9GjzAGYBZFK/AZrn5ubD3Lx/ArANXJP+UAAk6dFZTiBbUQAElr2mVIpVZWxhCN9YSMFitLZFse95rVPS50q+aPIBwBAAvoWcnaHk+LP1ejg+Oal5KkxOT9t6nCAMOV4HLDmAHDa9U2ipoIUFwI0+kbgoi0tDTfubw4cPvuWaa64fA1/ZTnzKJC5n1t/WxFbX3vj5wUZj5o2Cr78olAwL6hlSNDWzqLSobdOVp+XC12H/kYmw+8ChcNW2/lCfaYQtl1yiIOdi27lF8dQJozoeuOwyFV8VKVbK4GLfcTxjLn8H8y7HAoAX8gUFf1aUOrHqzLlY9Fq1aIx6STPg3AC6YX0/vn1vY9HjKNN1WgZAvyglLjpHwPd6zRs092kGiPOgONkEWAY0I/1JLDefePftLHiTHZfdNICiNFG+z3ZWPf2dWPfVLDx/n2ziOBOaRzQf03xIx5g/xbrZ4swCmQUyCzxqLJAB84d3qU7Jkr/4J3/+BUNDA1f3dnf19vR1K/isZmycB6Yp1/hsI8zU58LM7GyoC/zCUM/M8lk3xk8ZLFaxdY5lLT+z/pmcRH9baBysuUA5n6b/1nEKkg4AksnaItUA3LdBb4PcxrL7EsWGhiUF3ZXLYuvF3hfLpJIrismvaJmcB7GKTBwHmcDk1HQ4PjUZJiamwnR9Wu0kEDSEEix5h+vO8x3IFwDtaHf1uwWcLk8oSPTPDt61/8+u+fSnYboSKG8H6cn6WZDow+uH533tv//Hf/tf6sevUycEsFlfpH/AiOejw4kD2ZZGxXpfmsDPk9Pz4e7dh8NQj6Qm6q+DwwOhVO5u9vvVqTyb28ZAzyTD4pNAUO4t+poFOiOZ0Sd9nXgJZltHLa0oDmO9QPnwQE268y4LDIVRJxi0IPDONjiVCZC3gqFP+nj8oNr1OrX13vN+Ec7iAduAOGB8neZ2AAygxisnuHs1Uw0AP6+T2kqfS8x9+yfLXfPkE+2l9gLz4YxVP6+XKTtYZoHMAmfJAhkwP31DPoAlv/HGG3t37ty59ROfuum1c/PzP4akA/i8uDBvbDOgdkrzzKzeFwKv09NzYr4lyhYQdxaQgzsjaKDb/k5/ub47TSlLhVNYrkuHkcwlrSzLABhis/NC6GXNYOwO/Y1jYLS+ZXjp1PFVGTTmOie7heU41+98ErTX01UL3V1dCi7tUk7oqlUSpSmwkscnJsLE5EQYP348rOg8pTE3qYtUA+YYcDad/ME5ApQ6lsVorfzRvZ//xl9/8rbbYNQygH76fe6Cr/mBf/xMv67hh3Rlf8AbQ3pOyVPaWOUUxGyANrLdgHT6Z8q4Aos9PTsf7jswHgrLU2Hzuj7r3z39ys5i/TzJuJL72er7TsK3qtg2Abot82OYrAXXU8Gfcgptpl30WWPNu0thw0B3WDfQpUBQseZKn4hDSqyGA/MH1Zuvvg4A17/T/Hq1fe8Fv0in0YDIVm/Uqps0b9acgDjWTcwz7POIzom/1/ykc6KT9GseivOgPpHbpOm4vhD3clDzMZ1XRgCs+auaNTCzQGaBDJifXh8wO7397W/Pv+QlL9lYq9U26WW+5fDho1s+ffO//8r45MTOkbFRgfAZge8Zk6M0DatXAcCjUiOoczFMT4opnxGIaAPE7QGZ7XJbz8/iODaB9KZ3gLYbN4DMEgBhPiNgt6wpVAsVnS5praWHIzjU9+N5yq1Qi/4ApKeCRIAZ2EdrvKVa9PcYmvgeAfV+SXKYyarBVBf7D1CfkvRlZnrSgHlRdLppziO+AhjBppcKK4ektnnzZ7/42XffcMOdDDmfCqBnL8/T65PnfK0PXX/rM3TtrlVH2Gj5wuNMXn2mJFNpZ7Lth+h1InNJ/RZGu6Hgz91HJkN9ejxcuW3YdOb9A8PN1Ijm4uFw6iZoZ8/j2JHvOt5PnibRC2e5nMW3TcvZhgDReVXfQmvucpausF7AnKDQmiqEEu+Rcpt7+kQfjXoYE/34nZrfqPYSV7GmJtmxVw0CjAPEkaikibYCVhMQ95Q4F8Gkc0YvOBxnnJCBeFoL+iQtJud9IAsuvQgudnYKmQUuUgtkwPyhL2zHzMzMRr2wd2reqhd/HpBx07/fuuHTN978miOjYz0NyVQgY2CvDTjwko8AwlCuJB+5DuVP1iujIPS6tLwgAD+vkuLO+BmDHsFMYgc9vs0BSjtQobkub3H8bFwjjDbHBlg4lamgTK8cWpC0pSrdeWcuCnQNLHlb2c6LD/EZxKLTlpg1xuhOfnM9L2ArOQp9PQqyk36euargVaAMNhmVc0Jw31Jj1o6dp+3RWeCYZQWpdpdze5aXF//gd974N+/RZu3gPAHy1Z8PfYWyNc6qBWAiP/Kp216ty/9GdYd8u7TDugJ9xOaUHd+XMbV+i3A69l86OLn2D47Ww7GRY+GKrX3q/4uhT2kTkVk1AbFJU+hyKStLdAC078WYpzytyxG4F8DlMOYmXIl/05zEnPM7waEDPdWwcbAnrBtEagYoF2NuVXUp5hWDQdtGqR6GUdFa/6XmN+v4xFVcsEn2R6t9qeYdmgHmTARKwhwzo8UGpD4mJtmDTDE4Jsw4KSnQB7nL/Zr3yh7o1bMps0BmgcwCa8ICGTA/xWXQA71/YWFhhwI2LxXoLOt7rtFo7Dl06NDB1/7+H3zP3NLSO2Q8PeQdfBoe9tJAUWbCGHsEz6ZfpYw4adqQn3iwJOze7OyiAIprYS29XJSVtGt1aWK7rCX9nS6e1+aMoNzIcx1EiyxQ03I2q3KowHlBhYmQnQCSBY71G1qXlDvao7YA6IB19LkOkPwcbNBYf3OGEYLZMWEdB/r6wvDgoFhJkx9bIOvRsWNh9NioMnUgeyAdo5wFHa5b2pda2YJGvzXXmP+9j7z5ndcomi4D6GvicRDCzTffXB6ZL12j5rzYmegH9j2WnTjKg2OZUnGeCNDT9qYLV0agI2MzYd+R4+GyjVXr/31y7ghINsY7gnvbv3mm7riac5ruqyhf8TZ4/2SUxyuA+rqM0ixasDT3k/qjgprLkq2Qz3xIRYc2DvUag14TWC8BzgHmpFBs05mf4eVA4/ynmv9I7UCjfV6mKFPZpoMByNGMM6EFB3juV1uyoknRKLIVIweAdGyVIo936ftu2Qk2PZsyC2QWyCxwQS2QAfM288dh0J1adLnAuLFN0tOOjY+P75aMZffrX//6pZ/6uZ/9HdHTr6E8+NKyVK3GLCdlOFpsq61pe4VQNEANk62gSCYbMge+a3idFIds2WjMh4bKdVKpE1DBkLzJABIoaQMs7b2FYEtjDdHWmkvgYNwxjQeN8on0hMVlaUmKAudkcwmStrDMqooaIEGz7sefk7xFp2eOgp1HlBYY+LLj+cSniwh8Ijf1xnXrwnqB9IIAO8snp6bC0ZGRcGx0xIokWYBqfkWBpwSNsoPl/1xamn/DH/3R3/6TGSOTuLRf4vP6/bqb7xhqzC98St3gqenA7WC5vTEtIH4iW06PaP+ttR/9olGVCWVjuW//WBjuyYUe5RWvKkg6r6EkZ8h9dKhVAIs+Ge8pxUa02rIKxBs7nvqq74P+a/pz9THSh3LP9SqNYn+3KoL2ViyXOtlZjDU3YK770iRYrSDQ0zG+3Rt2M5zwKAUI/x/Nf6H7Cjb9nEw6NiAcgAkoR1+GJGW35l06LoxwNj2IBWS/Lfp5e7QfazKyQLG0e86nY5VdpMwCmQUyC7RbIAPmsoYe0AQNXcEDWoCctCSz0onvPnjw4L2XX345zFPH4x//+NJ3P+t7/lZv+J9AtoHkY1H08gLMsuUNj2aNDDMvedZLMNZf3h5gZsDcALGAgEBBPr9sxYHqs6RLJCWiMktY+jevinjClGhC2h33noBxSvfG+in3uaWDEzNuTDlZXCzFIgCZ5QBzKnl6cCfgBJRBs5G1zAvVcH4JdDgwj9Q552BtAVt7LmhPwMi+lqVJ7w7rh4eVCWNAx1HAqZjzY8eOhSOaCY4t6LhFSVscjuEnrHxJedV/4z1/855b46mdDKRzaqstkt3RZ8ECSoV4hRzNf9FVvcSMvKrjrdaTt3pfq4/6Ng7MV++DZWRxIQXofQcnwvLcZNi2qV9SK7TeikNsAlvPf56Ol7Tjyd21rCukRLTYhVbl3MS4u1NA7ISnV/S4Cbv5LDvLkED5OmVnGeoluNkzEpXIeW7SLu4J15qvHqE6lYmTE3GK9Q9ruzdpfod+Pyup/HR+PJ8A4zyvIA84u3ZZxkWjFz8L3fq0diGbwpzviHZNmnT06HdrRo+ePXNOy5LZSpkFMgucDQs8ZoG5HsZgQh7GvODSw3hUcpVvVioVMi0kzJjbtGlT/rk/+IMfUVa4Fxq7p3fhotLELQmYG0AHdEgHYgDdaDoFXgp08rIGkLKoyQLqsB0CpRgejTeBm3mlT+kUfSyeWgWAFCSnYiyNBjkmHHLD/kGHLQNebP9IQzw+s31KkhYD7OYg+ArGnHuZ0WYWFzK2oHfPqS2Wzxk9OqDE2HNgPKkVxeYbuPGMLb4vZ8lNf84sEM55msTFgHtkEG1tB/0b168PmzQje2EiYPTI0aNKwTjhzoFpfjgvy6Jxy9zs1Gs+9J73U9BlNThvf0FmL8sTL/8Z/3Xtv3zuWQLl1+ny9bUHP7YDbBuBMWlJAt2eP9wy/tBfbDlg2HFhC9h7f2IiteKCZCX3H5oII2Mj4Qnbh61f9fWqAqj1Oe+jDq6jhMUYaf/N5FTNdfjaHqjp2nTuQdYhbgMH05xb68OM0hRCX09ZAaDKzqJCRL0KAq1oWYnsLCb5QutO5qLVqUtPbdp03ukcT7Emz5PXy37vOdOLpOOQW5xnFc8swDmGht39ZsbunqlVH7id7EyWlydq3ho7G8TMPcyyc1bU6OyZOttTZoHMAqewwGMOmOvBC8Z9guarNKdAoH36fpcevBSqSDbhrW/zy1/1qvcVcp0/mROzbUx3ZIUtJZxwwIIA7EIsbOJAQC93Lc8p8DIv4A0obygDhb/EPdOKMdoAbq3DBJtNY/Jis3M5MfJC4zNKL0dzySyRCgsZzF4mk4r2omC45jA6+4bxZqIN8SyM64kgJx2H35CVdHgZTwWHFoxFzylAtCwGH5BCUBxSndn5xTC7SHrFFgvKVswWQcZ5GnDyjC+wlDTDRC+RvbRgU50fOvStmzaJuSybFahCuv/gQWPRLeWiaYnjcZaWr6/XG797zfve91U/ykllLrEF2f19phb46I23PW1pYeUWjWqcqpCL988Iyk/OhrdY8jSgkfTp3h2dxTbgLnB+QIWG9hweC9vXVywGYmhoSP0j3gcngP/kh0YG3Qpj+TJvVPKdW8sSOPcSWMhnPAMS4JwRoW7JWcjMsq6vpmJDVcvOAmNO2kQPAHXmPGWeOVO7nmI7GNjXaf6H02VhZTsyjDxFM7nGmWDe79J8dwYUz/LVadud7E5108dpvkxzKrS0S9//U3anwFI2ZRbILJBZ4JxY4DEDzPWg5Vx5yD5ZM+WkeW8THPX1yDglvImhm6D8x1/5yr9QlcD/mywnyEDIfgLQ9NqZfCrbRATlBJwRPGnD5+KzYMRh33jJO4MH9ezabWPL474oa28gQhuTA7yg9SnUw8q2jb7WxaTX9UpeNs2M8e12DElArB1GpBPUGX+1CwtoNqDjwMpZbz+2tR6mm8BMK1Ou3OepjLnarDTPPsQvoD47vxSmxODP69hRytsc6neQ5CxlUqDDnnOOztr7KEL7UH+/GNItAuh93Souoy3rChbds29/mFBudNrDZEBQDdZ/1zYmp373mg98gIIubhSfEliPf0ZEn/7KPh/SAh/51K1PUH+WdCgnNjax1Gb9JgNuho4M9gN3CEOegj65Zv63g3gXebdnVwGsI2MaOT4bdh06Hoa6V5QdpWjVcYvFygmMvO/D28J2LmFRb7Hqsi3dmMdwRH261iY7i4/caH1zDjss+NPcR4H/inTl6/prNg/01EKXdO7GmjNqlVhzDvMwWPOHNHSyIefhqUbv1Pw7avsnT7WtzoFCOt+hGR00E4V+vqn5Pm2XDHA6h87WeQQWiDIXRiqu1JzeGzhYXz1b8qRH0Lxs08wCmQUuQgs8JoC5Hq4MS8I6UXyClxogjwcrBW+Ykh0c8frfnT/1cz/3WpX1fg1aagIoAc021K1fLcgSlpic4FEPXhcAIDdzp0pvAkxh0m2Hlhs5BcWBV2IKxMjQlcjSIlDDcLtlUgEUQIAjb2G27QXMlV5uiiwui+5DWCYX0sRZGjln5g2Ea38rpg13uYsdPQJo5C4YwKA0uCWeLIfoEHBB816VFjcviUuZ4is6PhKAhtjtuvCNORAmL3DwbFU+Dbg1acymRS341dZLPHjrDmLbLgX+bd+82bK6ME0pB/yefXvD9IwSWpjzEtdXEvaV5eUPHh8df+Mnr7kGWUAG0FumPKNvH73xi5d2rCzerouzzhGwZzBpAWJ228J/vtwBd8sZS4duv/4O5G2y0SN2ShB1K03nlAJA79o9ohGiRti+iRgEOYXlWtOJtMsbNecOygGzMTA09tn0t/1mUpp4SPtwUA9+x5Fd1E2woHsEhxRmfFD5zCk0NCzWHGBeU38vwpqblMWDTXGmU5zGGRl41UZmE2VC0g3V7qR+Qau9Rse7sWnJlRXA37dpJgidO4BMLzyrdp+NdmT7ODMLxJHWy7U1o61cI7w9JZQyKVGm6z8zs2ZbZRbILHASC1zUwFwPU4I6v1MzleGYEiBvLyt9UlD+Ey97xS+UK6W/tkAwbWiZBQHkerECzJ2oi6A5AhuQ5Gx9LtSlEXfAIKYc0B7BSZK+WCxRKuTDvgHEAsbAD8AAzDyss7Hb+p6XBpxUhxCDi3q5TylIdGpKGveoQbdAUWMKwUKw7KAUl5cYIDCJiE/8TY5106dHJhugbYFv0T9hVIA0cnmCRRUWVRCYgVGfE6NvrHzcmbcwTlGCkIAdIA4buea8uZatnLZLLHqPAPq2LVtUvMjTLo9Le75n375Qr/tlQlCbHAhpmN9+7OjI7//ztddSJCX5GHZq7c1Z9T21MvuUBT5xw5c3LXXMfU5XZqtXhk3qbh/1aDlZLXPFbtRc0L7O6u/uIEbnLTqCHqjpy5F13bN3TJmIJsJV0pkrFWno6da19w7TchCM8eY+c+DtzL0RdL9YAAAgAElEQVQz8tSyNcfPRp3agHnLJ3BHQuvNE6ShT1KAUnirT/nM1wucD4s171EAKI4o6RQB5padpVls6PS15qfTsVLe95Po0Ql4frVmUiwin+BRwPc7da67Tmff2TrnxwInAeiQOzhOsOjZlFkgs0BmgUdsgYsSmOvhSZQhw8BkL+BVjWSFl1w7IMd47aA8seW5H//pH39qravnFm1ZIDAzSPPNy1Rcl2EHk4cgAQFE63cY9SYI1ZcFIYaZmTnL2pKG4wkQdYY6sogw7WpAKghkgDwShbDzyL8JErWsKiaj0bISx3MZCgz2yHhdrLwynjSzwrjsBWC0IJ2LVfE0ijux5PwhIBPbkYC46eI5XvQXYNVzOq/kJDBSUFTOZ68E6p5KE+hHIxq3avuNEoQ0omCwHBiVSNAIyyPAsj1qXZYC0C8RQO+TtAGDHlaA6N79B8T+L0Rw71nUtU1d+vq3j+7f/5brr7+egi4ZQD/NR8H1199TahRGvij7Psmy6qya2kG2SUHabhJz8NpY8LTpaj150qO357IwaBzvNgoL7Tl4PBzU9X3CpcMC2MuhS1l80u8+xsP6ni3IUohaf/HlTWmN3UAaKdInGZAY8fFtrLfFzEbcqz6ypFSQlru/SznMNygzC0GgfQoArapvGzBXn0fzbtmSbDTL++YjmVbLuB5iX1/R7+/V/I+a79exH3iBHkljsm3PmgVOAtAZ2fiyrhlFnLIps0BmgcwCZ2yBR/bWOePDnrsN9cAkqBMdObGUFIz4YtSQn+yg/gb32XTlz3zuD214wlXbby+WwkYySJhUVj8To2l5U4x1azFpNuxtzLkzw8Y+i1UHLMAMNpQeDm2sFw9ynbeBUUBRHDZvHly/mPac36mcaekUXT4DJC2UyODiy/h9SUzgyEQjzCgHeoS+5gjQFj45/iIAHXo8ZlExDGtMooNr2PM0+TLOIw7jw6Kjq0crj3NQ9mJFOAlp3Xbk4CXROX6np4qM5c2RE+R0zPintZ0Jpt9lOq1MLjgDvdKe77jkEuWZ9iI0Bw8dtCBRCzK1/OuxfSsrU9Lg//m+Q4feest1103EU0qnxiFOaN6563WPnj1/9F9u/4Ba+zJanDp+dLfsJE5gv+PTwT5wuqIDZ2ATB5D+HvXftr+0ju/J+pFN0ZFL++a6Hzw6Ge7bdyhctqlbWYFUdErAnKwoCVT7AR1km3TKRn3o175P+pePBnkuf+65hOxZx0aRYlpFADvKLjIezRs7L425pCybhnqU01wBoJExLyntko1WRYlZyvH/SK7uwwTmqc9+VF9eq3P+1iM5drbtubdABOi8c56kmZEO0ix+SdeO51E2ZRbILJBZ4GFb4KIB5lG28kxZAB05zPgdejiSbeVUUzsoN2y8fv36wvf9wAv/VUGP31VQlpJKWQBUb/T5OQe+FTFryAnn55CqIPNA1gJjt2S6cKVLMRTi0NvggmVUQd/KCxpQr+yJzbzK7ZlTvDqms4Q5HQNmj6Fvdqvqowb+KUiE5IWATPTnJHwEGE1Nz4UJac+XpT1fMkmKg6QFtctzretTx3aNsDPaKXzMguoMaMVWJ8fBE5O7zjsWXrFgVqqHCkjBLJq+3rCRp8vzjDQ6OmCbvwFnxrL6JXASPWakSRKK2ANNShNBmI1IaNWh/v6wY+tWadxL0u7Phb1794Wx4+Pah2fH8fbxuTImgP4n37j//r/80o03cu3TBUjAPAPoMsrHb/zcL8sQf5lu+pNJVtpvltWAvV1KkrZN65xM2pKY86bDFxn3ZfXFyem6dOZHQ3d5WYGYqsKp0RJiM1K6Rtu2LR9ou1OQwHmSzFhQM0x5ZMwTW+73Ik4x94k7x6haCnJsCfzcPNyjSqCuM6/CmOt+ptiQZ2XhM+b2f9iP1bOyAQ+T92smSJS4imxawxaIo7TfriYySsuEbJIMLlmKxTV83bKmZRZYixZ41ANzPRBhxtGRpwcimQt4ID5YQE467xZZLYz30p9+xR8q1/avkC4QiXhJ4LcgqnxFrLMBbIX7AIqFkwV4l0wbzsucRAsGAeJeHZICD6X3hr0TGDc5RxyKn1MKwjlV8Em5wa3gUGQVHQeT/xtWWuy86V2dIVcgqmlgJZM15twqFeo7kLquyMzjAugiyQ0IU0CIfTXI5iJHgnSOLKc9fBpYjsCnxerxg5Y72G3SzWk4n+bbMSOT38pSEyUOBqgF0sHlJp+J2VjibpMQxVvGb24zZhMptMsGIpoHqG3ZsMGyuLD91NR02L1/b5idnTWnBPv4vqzpR1aWlt70d29/5zs4O/uhNdsViTdhO1Bfi/flWW/TJ//lc8+Qe4iWWfHFfr0eanow0G3GpI+s2k/73+3HSU5oksLMzc+Hr993RE7uVLhi64AXGipXDZj7PnyUp11KQjVcl814ZhZzdi3wmftBjqzSKZIRid87zbHFCfZqtgRiA9JNbq6JHOZb1vXKKZCcRSkU0ZkT5FykroDuvfa0iY9UzvJQdn6I3wkyfLfmN6odsLHZtIYtoD5JoMzTNFOVVU9+058TJJpNmQUyC2QWOC0LPKqBuR6CBHX+F81EyZOD/HY9BEkr9lBTO1tuEpYX/PAPP7Pa3fuvsNMFod2SQDDAHNYMkA5IpljQjJhpXvhkd3AwrhRsYtKLsViPZxJxYAHwJhc4shYfXod3F7BWMOeCpT+U1IRHt4CSgV6Aqq0BOHd9remv41XieJ7STQ4DAMKySHjecBjkOcvaMi82csGqfTKuCnhm2H9idi4o62HMVOEyEs+wop0TRGcMZQTSnp7DzqMddyWAYplpGPInraPsgL3srE1yEIE5Z6F9oH9vao4BXdisDfwnCZDZwKzm+7G/k4Ogvwsq7LRj6xarJso6x46NhH0H9wvYzcXiSb6+j1cs75Pd33Trp2563+7du0Fuj2mAft3NdwwpaPYbss9wk+l+EECdbh4DwQbiHewyefrNVhCmfce8bTg/OXrtRana10PahM58twoN7T98JDx555DdW+QzT8WK/Nr7fcOEk3fCcQHmWr4ob9nuGruBBMabvYibh+q7um+NMfd6AylotFIphK3r+sJGyVnQmXcpnzlpE4t2/7vOvCVTWzOPyT/RKf+B2jXyUA+47PcLawH1VdJcEudE2ksCef8jG/m4sNckO3pmgUeLBdbMG+fhGEwPPdpNSrHHawZ48dA73aj4B4ByAYLic37oxV/Sfi8nXWGnQHZJwLYs8FsqOfj1ADPJRQRyG2K8F8Vjwc4x9A2TDVCHcdN/JvNIIAL4AAjn01PGOeg22YZY5YbY7IYQM9klLNgyMsgpiM2G02HHDc2mOeZSZ32OL1zsYNkB97QSnk/XYRedo+Z4kDezOtYMbTeA7kwiswEfsLBV8nSZSwtsYS7YyRRU51eKVMq0GXYRAFMsofF1+GYQ277IDpoJfOUoyHHSGfAlpYGk7aZVNsY9sudJUsMZcO6kntTvtWolXLptu8BUlzlLBw4dkgb9kLb3AF2zU8wIo1bfuzC/+HsffNfffqjNeM0mxGWczkPTxw+ng66xdT/xr194ry7Hz3kGFh8tORljzjWwIMroFCX2OsUdpNNaLVt5ANh3n67ZHxLD7Wx2SrfYEfYdOR7u2380XL6xwhBL2Lhho8mi2hlq8x9imwH0XtnT9820pM48L5BvTq+kMB2Ac2PJueNcf26ZkbRMg17uaMb7ZotA+Wax5kN9XaFH+c0rJmchbWLMzMI91eYgr5HLCsh7q+Y/lJ0IOMymNWqB+J4i/zn6c+W3MvKImCfp8bIps0BmgcwCJ7fAow6Y62FHRbb/opnSyTBHt+pBd7qV2NL58mlMuebOn37VK39TIOR1KRsEKJWUiJSqLxngLlrFQgOxJk8ROBcYmJ8DMAqcm5xF4FQvddjzsnTYXv0yFUNxUO6pE5ddjqJ9d5BjWYBzWukPKSDE8Ysw3ZZDWX8KTHiBIgelsOKAcMALIIVsFmjgXVLjTLpDkRULdJuagS2EeYRR1P4FzOYFzOtyBOZhEpfEKFqqRYB5ZD4T5wxQt+F/mEjtMoEa60eO3h17c1zPlkE7LIWkfoiFHA0smx5cM1pf2ujZI2NoYHSTEih3ttxOIWaPcQ48hxTH8L5zooMDA+HSS1x/vqhrse/A/nBs5GjoZD2a60MQOr4xrV9TkZk3fOhd76GgS7uHkwD56s+L5nlx3c1ffI6u1c0e8Bt1HPHs3HmkSwNclXzTh4bi9Y2W4qONXW+CcOsQvq5fM/52WRFT2sSP4cc1oM+/eMyR8elw176job+yqPSFvaGiqlblCgVI/Tb1YyVnosWY2/IUSK3vBHQCzlc6VK1WP5njaQCc0RukaO69W2yeOX+M9uQs+HPrMHKWrtBbk87csrOUjDFnNOrBGPMLLG/hZAB3f6j5z9SW1dmmLpr+ezGciPoroJyEBBQqonPfrxkyKdXRuBhOMzuHzAKZBc6SBR5VwFwPOIpuoCcntTUPtoer3VvNlnf+xMt/4tKh4YEviyksma46KpOpqAkoQLtK7mNSqXkmCAcM/INBh4XusOwiaM8FuCW5YJi8pgwqyDRAtInlI0MKyUoAy1T71Kr2lCa7yvhUQxUKtbZ+L8oRYF/w3QDzjhwg2IEs2nJYcvYLjlpa0nLkMmYUL0hkgahqH0Gfs8qpPq+UipbNJC7HSYD1Rzc/r3F+dOeLaN6Bbgm2ukLcpACAa6/omIAbvc+RsykOxL4bUDEpDrnXXZLD+gBjSz9HWsnEPjJiQJAd+1e7bJTCemIsVsTZafctKQQyGx9tsLX0xV2BZenPN4atWzabTWYpULRnt4JhIRWjrIZvdtVNVvPF2fr86z/63vdS0GU1QE/gPJ7cWbrDLuBurr/nntLigbFv6vR3mLzErWd9t31iebK1nXzs457JJwHt1jbtkhK/HvGeMDAc10ui8nigdnBvGXs0TUzNhrv3jcrpmlE+8/WKhZgLfX34276bVvBwS1KVWH2kLw6Oc3JA62F8fDxUewcEwDstzsIdT4I9dc9F2dg8UhbdKA1ty8hXWcNbA5KxDHRXTcZSkbOMJC0vB5tMLSXdoF2VstJ3ilFXhdIhrTc00BuzIq2ZRyf5/P+35rfJHnqCZNNatYDuARITPFXzJs3cBF/XjMQsK1C0Vi9a1q7MAhfAAmvm7fJg5x6HBL9b6+zgfa75M3qYPdx0VOlcLWmJZtBt52te+6vXLSwuP3cxpV8DuESgy6PTAakXMEFyASb2IfXI6KHtbswbOEUxUojZHaoKGq1IBkOaRdhIHcMZbh0U0Ak4NoZcTDcBZzDXE8pUMTGjQE1lgQHIFg0ouFTFgbmDHqQtDLEbeLfMLFQ1VHsi8DCmD/23Fi7IeWhof2kYX66F7QPATbaYuXk+BeKldXe2USMCSS5AW1ObLVC0LWgwAi/D47DStl+Hy2BezwMdmX6AtDHrzkKmwkzo3y1IlewzUcpjwEvGNr8IuY8xvZ7JxRhfY851PQyouwOC3n7H5kvCMPpzLRufGFUGl72yY8PAf5JmcO7zAL7lcNvUzNxrPnb11bfbDk7OovuJPIqn6/7t86/XGbzuZLKV9tNqz0OOrU5gyJO83K63M98Rqvv3tgBiW9AGzHUV42G4p9yhYkqBmw0FgN6zZzRMTI6FJ12xQZl35kO/Cg2lNvCZErPYd/LzR9mKOQf6e/T4bLjjrq+Few/eF2Z0H8wK3M80ZsNcvR6WF3Rfqv+vIJVqts0dSBvSEkMvuj50DNbCitIn5vS5rq8c+lV0qKb7uEs3Xm++FHoLpVCRRGawoxy2FQfCuvKwwP1CGFOF2oWlgu7lQuiulsOA2P6+Sl8Y7KqFDX29yvZSDhWBfO7F88Cw79cpvlHze3QsIleyaY1aQH2XwNDv0pwyiH1F12zXGm1u1qzMApkFzrMF1jww10OMwM7v0zygmYcXAZ5nApgSW54kLLnf/F+/9LxaT9c/LsCggfnQKRvYgA3mBe4wBMBrZee13PIcGxDVy17LAbwwgABI4+/I6CDGuCBJSk3MeaUY83drWyocOtvuIAXQjx6W1IeAcEDHmNi/yal5sehaJw6pG0BHIgJAp2mm0vCsLNQ/KgDCI+ixtth+/RyMcVfDAOLkNV+W3IC3tuV41jo4JJzHnE4ErfuidOksX9DfhlhNiuDmNiVPGxNqul4D5q3l7ij4CALyhgSMLRe7MecpHR2jBgB4gDrFmyKINwAVHSK+oksHTEdZQwI46NYZRzDcGEF6tVwOO7fvCD0qUESbjx45FA4cOBCDbj3Alu2Ai1xpMaqfnpqcfc3HP/jBr9qFvogA+vW33bFzeXH53nT9jDHnQvlFNJnP6pvoBFDOau1rrPrbr/0qZ43143opDLcJ8lf1HZYvqHDUnkOTCuI9HJ54mQoNqS/21LrMgXPZksc8pLY7k0/60jmx4FS+DeHtH/5w+NbM/WGxUw4dzi4Jy/mB7ww/wc5bJ/UYCPufRUyrfwo0h35JZ9b3icPsD53resLOwe4w3FUNg0rfOFgqhx5JW6rKGDOgjDFbunrClT3rw5WFbarHvhjuW9gf9k6rUNLMlEaf5PZp1Kk3J3Y93xWWxV0fPDYRpsYXwqbKQHj85k3KPrNOkpmi+QRp8tv2rD6Gd2uHr9e1eV/rKNm3tWgB9evL1S5ipSiIR6E0UvyiQ8+mzAKZBR7DFjirb4SzbUc9uAa1T0A5Gj2KNpxpwY12trypLf+t1/zqvwtIPBUwAThkck03kg1ngZ1ed8xmgBOgAOAUwAUUom1FDgLrDPhsyS38ddulIfGuqnTjlgaOvOJixMVUmxwD9tgYSo4s4KQ3NuB8VLKWeiOVNXcNN+A8TyVQw0JRe25AF1BOMSIkLB44RyYYy1seLwgAJ56eJCvOnltO9SgTNnAuoAU4t7SQ+i6li4CTA+7EcDZBHq2NAZaO/1tSAwfqSGfcZsbem12ifS2rDEGjAuYErcqJIb+NrRvZcdrLNpxny0YO+tgNzpFr+JdNm29sqGFNL8TU29Mbtm69xNLvYe+DB/aFI8r+QRYZX9XlO+C3BTVU2To+Pju78Lti0AkgvigA+nX/+vn3yRSvTB2fk2qOZ9hFaxsOiB1ldaXP1H+SDCbJXR4gbzkBtKcsLq2nQTtbDMOe+hEjT4dHp8O9+46ETYPF0KsAzC4VlcrndbvbjWY3n90f1q/lrdr9AzAXqJ9RkPOfXP1XYawkFCyHbwENCzUD6NgGzNWnCGa1kZ7UHl19Oc26cZTLSceRPCWsV4a7zQLnG/rCBunOL+ntCoMKMh6Qo9dTVGXQQjF0i0HvLynwuGcwXNm9KfR01sLo4vFwpDEdRubqYU7HWVcQS54TA69OOjY3Haqd5TAu9n5K7RqbnA2Tk/OhslwMw9WesF4FldZ36Tg6Rl/Ns8JYn0/37CMH7MgkyIH+sdaVyL6tNQvoXkCWSXAoRYq4RfdoRqZ5unFTa+2UsvZkFsgs8AgtsGaBeWQT0JND8N7yCJkEp/baAj5/6Zde9fzu3tonGGKX7lg4AKZbDJoAW1mFhfICjMZIQ64ZJeyWJhsJUpccLLboalKwweChNafsNyt6DmTQioNagkMBHaWyeGGBBYrlJMZxtXSAYwA1Ryf0sldwKRlJOsX2FYRiAbAAbAOY2r3JRSD+LLe4OxX8rrqjApzCJTgMEfBau4ws9OqlOBkUHyIgFZKR38lkwXf05w106JoB56aLt9EEJAktntXZcxwOdApNzcMJXTI5IG47NU6b0G4y13RKO99se5TJmKTI0vRBauq8TU/v8gcAPc4P0h+0wFWQPfIFgTE7JwIYORMD8B1heGhD2LAR/Xleec/rkrfsCccnJpoMPy0mSDQGCi5Pzy1+aHR88o2fuuaaXWaQpN1ogfV0bi0jPMIb8Fxs/o+f+eKlCty9h8t9MhkLy5qMN85cRK1IfWxEJjaKv5NTlq5j+4mfIHkxOtvvsiSNsVGhKDlxp4p+26KLuV7jE7Phnv3jAtBT4fJLhs3sXWKmGXFJbWwCeSuURdB1IyzMy3nVffTn739HOJ6bDR3SiFMfYFkpSOm0dKEcVXrlaObcw9Sh1VflyC5buwT0lb9cw1ohDCuj3SYNyG3qC1Vladmh3ObrxJgPSF/eJRlLVSkUu1UKuLdYDhtq3WF796DY9G6NvmiES8B7QiNhfWLKi7miHL5l9cf50CVQXuushlm1l5DXjeXusHt6LIzPz4a67qvjDY2MNRZCXrgsN9cRqvPFsKNrIFy1cVhpHHtdvpa8/EfWSb6kzaki+qlHtpts63NpAfXxLu2f9Ipb43OHehzkQM/05+fS8Nm+MwusQQusSWCuhxSAnDRTxzUDyh8Je5BAeQLmpi3/1V/9pX+TVvupxsTpZTo9VVcqQcBD2Sps5gT4epSpoVJRZhZxGsZGA3qNek7A0bM3mI5bL1mAwTxacoGPKmkWI0OLhAXEQpYX9gfXnjSyCQYhQUlVDwHjYN1padfrCt4E71AVEZbZCfNYkp7l+q7dGnBneUEAGYAO6GE7tO0IShwgJVYZPXkE4ujSAfGsbYy1b8t20w3lWkeHLgAP3nGABHZyeYszqFDXMOMJ0Xkbk5SGPm/VOVlq/xGgCij3gE/ha886o0YA2C33u44Jm0pVVdelp2OvKAsLIwcUfxJol8NTkxMlmb7lhLdUf+4+GHO+oGtICzdsuiQMDm+w7xMC5nv37NH1qpsTYkCTfNdxKzHoC/W5pfeNjYz//vXXXktBF/B7kzxu+86WaxKg/+PNn7taUqdXtAPk1QA9SaqaaNqQs9PTOF9uF5dMmXDLukdku9Np26jSA6cHMOptq6AusTGLOCI1Jzb5rn3jYXRsJHznVZsVxDkWNm/eYn253Wm1/qbruyRt9xzAfEHOcH0mvOfj/xD2Tx8WMM9bxqFl7a9DkqwVxVXkVHQrp5u6A5kJh1V/EboORTHk9QPHw6K05MvdAueDwkQGzCVn2dgXtg70hA2SswxUVJFUcpaaJC8A9L5yRax5OWzvGQqbq31KbdoZpqVjL66oMq060/jirIB3PWwp9giU1yxOApvhNHZ1Wmx5mF5shHlVHFM/0/c5selzZmMIfoqBLczKmZjLheFyLWzRyM+6qjsI/V0Ve37gmJ7h9Dlt92uyKZ/ZtEYtoH6+Tk2jQJGGcAJZW+7UNbtnjTY3a1ZmgcwC58ACZ/yUPwdtsV3qwfRMfezQfEAzQZ6PlDF4AFv+yl945Q/09nR93BjkCJ6pIDg5MycwCkTVC1zAsCTEV1P0ZslmvRRJiUiqQ/KK2wvSwSSAmVzlaGbJBDFHJR9NgMoiUhNtw/5T3vNyGUDP5s58WzET/YkOHBlKKgm+iKREoH5Ob+0lpTZk5QTKXcrh7DBjoQBzy9iil3xJunYTapDaEW27seJ+LJcloLd2ID4PC6kxCZjzVIHUZS/kH5dNKFhUV/YZBYlybmjULb2e5aRuQ6aGfJzdDoo9cwfCGfKmHoG9RrmNf3qVU9OaK8VkDnlMxPdp/wmIJJBmGWcs0ws4iyJQKghD7ngLO+B4gMgVafslU1DXQT+/uCyvIl8JGzZsCT3K3AH4Hxk5ohzo+y3VountcUgiV7y4SAaXZaWYX3nn2KGRN3/yk58kLeejAqDDluuC60WukMc2xhXr0LfMl3ITrpJTeX5xB9reR9L0AFAff/BIC+9T3ht8Wg3M099N2VZsBFvNa6TpPunMDx0bC0/Y1hfGRkfCpZdut9GS1ftbijKWOYHfhYWG+u18+PStt4TP3vtlMeFyrnQP5gmeljxmRSlI8bzoynmrAqprTIrPgVKobR0KU7vGrG+sKEXi0sbesLJFwFxzTnrz/PqesN2Aecm05V3qS10w5gLmPQLoWxWguq17OGyoKIOM+sq0glh3NY4ZKM+tdIahQp9nftG/vnxNwaMVuwfrupd7xLrPW9Exj68YkwzGrpMMD7u+GAPLKRa2JLa/KPA/JQd5eUqse2d3eML64XDl1mFzSNP1TZ8t+VibiL3tusSvN+jz1drmPx74U7ZkrVhA15IMZE/RTIwViQ7If35krbQva0dmgcwC584CawaY60FEW56tmYppu/QQ+uxZOO10fklXbu/p//7//uInlEf8eQ4q9LKOelbAIPnJZ+fID24QwyQXeQoOCQSmbCgGgE3T7Xm502vQ8oZopypq4yAH1o8Dxiqdy2LK7IWs9apRU2rBn2Rt0HoAY5ji+aRBR5qiH5CRLAgYW1ybjdEjlYFR9rL3tJU90FbkNSW1F3IQ7TmjAQB8ywpjSN6taowk4B5pjX6ztIl2zp7phVED1nHmfD4cV8XTGYEok7ZEcJ4AegLNCfSJ5/agTICQE+UREEamXwtoq7fD9UUFC5j1gNgUMJoAncvN06X0QkTgZAsm1VcAOiCnZPnjo7OjH3BScKJIN0kWHHLRl6vdYeOWS5WSsiK7LEp7vj+MCqTjwFjsoOxjEhcrwMSIQ8e09MN/df/++//olutu4QXZZsUTvnuHucDTJ2+6/WpZ4BXGZUcQnj6bIxfNZrpNm7x3vICROI+nc2KWlnR6qSqoX4m2CfPHEZXVUpdWP0kxCc7O7zkyFfYdnQgbe+UI6xpWBYhrCuBNRbbS/tCXLzaIv5hWX523YO2v3f3N8JFb/1n4GGS7EBbEhCtowHLwWx9X02wkRvcA92ZusByqG/vD1P2j5sDldKMsaWRs4fJ1AuciKTcKoItR39irDC01BYGKNe8lANR05gSDlsO6SlfYqSDQq7q32H731I+GfbNjNrrUIWDOPCdmvyyWvCdflR694jG36o/z6oPdchK5d7E78Rx1OY6MDrHOAsAc51nfeQ5Uc4VQp3KvpDvEgCzN6RwaiqOQVGazJD/o1Iclxxmy6qXyUBcF9PNl9fkWcD9Fl0R7jsTl4aacvcA9/LFzePV7mI4nan4c3VgzmXe+rCSTzCYAACAASURBVGt2OtWtHzuGys40s8BFZoE1Acz1AAKbfZ/mDZrJ63q22BzOzzGvz50veMELNm/fufNu8Brg09BLG5gAQVpgJCgN4EsAWQxeNLZaWxB8iG4ZQJ3XMthvgjCpgmk1Woz1ItcivLXjOEtvaBS9FxsCJMHCk70F9tpkKsZos61SMFrBIQewAFbYRYJG+d1i20CQ7M7QtWdXoX1IbcpikdFgA3Y72BZGWL8DAlxCIACLpCSmJecc2XdDwnR05xzfAjTtuJ4RZVZSnVHJAqaNOcdJ8Mqh7sC0wBjfHdjhfkRdewQhCVwnthy3wsC1beTg3AJF2V9Ty+7I3qqXmmQGcM9Bo2QFMxBEiozHgmQdnKegUZZ5J1AKSnMGPIi3t384DG3YquuGNrkRjhzcK/25WFSYVUOalvfcr4VyxYvxPK60k3+661u7/vyWW25BWpUAegLj7aD8ggD0626+Y0gi64Nqm0pgcgbJZXTpSItZtSvW9rc390Tm1a9pk+W2a9zKxGJwvnmWCdo72EwpNmOYRbN/eE9ppUuMlz2MHK+Hb+4dFZu8FB63bTiMSc4ytG69gUurCGuB00icFpWatB7qsxMWCIqcZXx6IrzjYx9QxqFGWJmeDwsjymEPKI/9x4C53ce6d9RP8sNdoaSCQtP7pZKT/KlTAaDco4tXrA/LO4YsABRgPtBXUyBqxTK09AuYA8i7xZz3yKHb2jUUHte9OWzq6gvHlYP9+MJsOC62fBx5lDoPgLooQD0nhrxLILzQIUmcQHpBsSKcT514CV2dolIwdgnwz+lvnGdzIOK9RK/lPqOagRUT04ksxNzsxq7XdT+rui/HQlJT0IjagI5xWV932LluIGxeP+D3zINPHI6quAD0XQ+1cvb7hbGA+j5Vt75d83ZuH80EqSNxQSOZTZkFMgtcZBa44MBcDx3GrJ+nWW/F8IWzqKdL58bbyd7PmvM//Yqf/+1KtfLbBBAio0Cu4tjWi48woWVtsn6RbiQgUepVMXEABcAfFUELMfMa+bgB0bDqkq/oj7Jm2GykKGxr8BCGzrTqnjkF+URRB69IKuPFhmJqQB1/XmCQlzy68KqCRmknchhYQ5O8NHOpO3DlfwzNm1Zd/0oCERVtk887uPLiSJ5phvU9P7unMAS08HfDypu7Lh1ZvGV8idp6tp0ROB8XKzmrZOAUcLEAUgC6iWkTM+4g0PUSDom9eS0G04G5OyfGajKjKWcUAjAPWw9zHdvoV0WgnSGKeI34ao6DPAMcBPZlTgz7YBRDv3OdCrom7g+5EoWAXpfzqElaqX94s0CgSsFr+9nZyXDkwG59UqAowXnsEQSe0LFTnCYcnV1Y+cMvfeOut3/rttvQgK4ZgH7djZ/5n2rMH6eO31KAp9iE6EDFqwLgs1+if9oE2+lv+3T0bdc0MtAAdL/C9Ol0dZpf4rpxG+txsUWRxE/PULZH7jExPRe+eq/q5KwshGc8cWs4duxYWLde14T7QZtyfd3Zc3BeV3rC2ZkJgfHZ0JDO/H3XfywcGz8WViT5WBydtaws3Kex4e5Q6I+cArA7e8qhIF15/cCkZ2/hB91fS9skS7lUfs1mfSptYr6vGqpionvlgNckZ6moA3Sqn6+r9ocnrLskzKmP3ja1OxxT9pUGzwbJvfLLuo+XJXmT3KVb+c/7CmXtuhjWlbpCv+7HTdVepVzsFZsuByMJp2QTnhuAdvrunPVTHFN3unluMPIDcGea07137KicgJEZc/DxNatyLirdRUudmreKqJ2S3JTDeunTNyr7izHqnIuCXT1D0gMe+wTYv1fz6/UbEsJsWoMWUP8nSxnxV7wrKSZ1p+a7dc0uCBGwBk2UNSmzwEVhgQsKzCMof74sSY7y2/SA2X0WrerIqsWY4wB0/tjLX/WNQrFjKyxTWeJkUhlbOXsjl5xNtVDINsDBCxIgDXu6oCFqmHCqc/J+K1DREtCprQD7sPCw4OjLqxXXURugAN3RmPhSTJUNCVCE0UPHCog2gI10RavP1hUYphcpqRKpPNiBtl37Ii0czC7gmHZaUZ7IEC4bmBf41HE7dY4VgQ6YaAddznJaTnE5ECvGfKMH96F+ZDKwcnNizinEMyewAR5A/+3cOUy+0tQJpExQmEisvhclcvBlxWYi+HKNuMEhO7ZlqYkaCctaI6fIUkjGtbAB4JnlgG6vEupsvwF0M57r9o2Jt+NJmoIDZMDLHaxC1OsjHyLriwF2Rjdsc4A5oCeCH2sreeQLYdOWbWLR6YZBuadHwtGjeyzQkGOadEfrkkJySkzl5HyHwFjHAcl//vdt//yN9+zffzsX91QA/by9ND9+w79+S1fqinZ23O8nT2G4mhFffa+1pCfxVGLf9ZEcv36psFNyXJvIHAO0g/j4ty2LFrBrZl0kmcRBIn33rj0jYf/R8fDMJ20X8J4JQ8NDxpiTLcnkW/gP2swyBymWAylLg1SEkyPhozd9Knz1nm+EFfXXpeNizonxYJum5WMvUzVehrc6pStfnPBq6DjJy13SmW9QysStBIDqUxrz0FsJuUX1oaNTYXFE7Lq23XHptvDd2x6n0ZPF8C97vxrGO+omK7Oc6HCXkpAEYkFYpmJDoVP3NNlZtHy95C+9YrQ357vDZmVoOT6j42u1/p5a6JEMpSYnH6LAwTgsgkZ/tF8AuY/55EJdDPmuu0d1X7JM94myX5f0AJOrYc+Mid0HwlX9ciQu3xamu4phWQ8180+kg88vCKyrGNIVA4PhKgW6DveR1tEf/21AXUKZ8HbNv6dlxFVk0xq0gO6pbWoWGVxg0ic1k14RmUs2ZRbILHARWOCCAfMoX/l+2ZAcaf92Dh4s7aDcMrE8/0U/+v3dfb2fAGZqFNn143r5dwlkA4oLFqjJZh6EyWSAUpO92mGuBFrRhfM3TJeFDMIkmgQjZkiBARMAcJDuGUiawDhKY0yWYVs7YAaslggkNXCOfAR2XCy2QAbylJKCO2tVBToKcLL+gpYbgAcUw5SjodW+TF4CWLcMcTCNsOdsxzGa3kaTqbZhcraxbV3qQmYZqwaq/TakazXpjezkAacUHxI4FXWsxBc2lI5EZpnCRGp3rLZu7H37FHGdH5eLEVMfgg3sQmEDPgEcYBu7DslRcWY3AU62cbYd5wOZi18DwL0BfMNGrpX3dVPQafxuAJEsH24vJmxc6+4Ol1yyTUwp77uOMHr0QBgbOWiFb5A7WMYa/UJp91EF442Ls1pcyt1fn1/6/Y995jMfDPfe67R8a05dp/3zBLucrT8+/ul/fbrs87km+LbW+u29Gqi3AHgLTKd2NH+z9Jc+2V4SOI/78/XivZGGmuJv7ig5o2566VUnGUNG057tAONKD/qVew6Ezeu6VfNHYFasdqXSHeMuWjuwbENNr5nRkoXw2f/4Qrjm5k+ExWkFhE6Ji1bfXFa/tBtB/djOgU7AvUObrb/TKfRV99WynNcwUHNA3q9POpVGhyyggieHtt26YWN49lVPCfOyyw133xEmlgTKVZ/AZmnU9YPWI92qdV5txBAY+dj1WVBudgWADhYJBFUe86JAulj1FY2KkQoVZxpnuSKHgSJZNWWYqer5UVF7cfJnlV2mIAdl797JMD8lR1qH2Li5Fi7ZPBDGx+ph9IDYcznKt3/k/eFxqmC6cce2sPX536Mc7TUbIWrWNCCHPPEoC0olqvZs7e4JW5SzvVfPvx4x6jxj4jQjG/+F7qG3qD+RGSub1pgF4vsT7Tk50LlwZJCi1sfDrYi9xs4sa05mgcwCFwSY66HCcZ+rGU35rXqY7DnLlyKBcqea/MHV+aKffMW7xNL+NOXuDRgD5NCd6iVY1gsQuQiBk2RhyYslXhYzBwhwDbSbCrhiUhLD7SmYETbRGT1ODbbWMoZoPwxPA4gNm9sWEXBy7BSUlqQVWgZLllcVw8RIAnIA6KYdRzdOoSEymOhfKiREZgtLXcgwdmqfvrTS5REESU5wTiMyp/H8aZMx+gbKPfDMAiAB56Y9F3NuWWFce21Boejd9ceMpVMEwHvBohRAafIDLbfiRPE4CZib3Q3hO2NuhKPZLspLANYGuF2+YJU/I2tutT4N2LvdaTe2xnkiZSJsuQWKJkBun62h+zSCnzqFOTFcU5279wWAUGcYXjcYtopBLwhEkfnj6KG9YUJSCUs5qWPbecr+U8ozL4JWunsqp3bcMze3+MaP/917PoxJV81m5tjHT/RYzlLHv/ZTN71D5/Xf0u4SGE/9KOm0bRSieU0isF7FdNvARpvUor2JSf6SgHlixFMudP42PXdbSOhqJp3e6/EHXojKhDE66BfvvN9yk3/b43aEKen9N29RDICAbRRgNa8TUjMf0vLc9fO6T9/6/r8KBydGJSlR1VwBdDRHxppDnNPBdD/a9YuzUfdcFMC67lOlX4J+9stkUd2a+VPbbhheF5771GeouuhKuGHffyqHq0B5NwNwWhdgrkBu8/TFTCv1i7YTUEebpuJEQYGaoUNMupjzXmVoKa2I4daxu5YLYXOp15oZw0ms7+Inco1qygBDCzuR5+hwBUbp7NqpjntPIVz5+HWhU4z+3V8/Is29Rt208cjdXwlf+vB7w2/++q+FoSc/Lhwf6FVNBi/WxL3L/qyCsc2MzOkMdG9vVmrGAbWvKlXhJmnUt65TZhpiMxzk/bHmP9V39F3ZtMYsoGtJ1VD055fGpt2rz//U9WL0I5syC2QWeBRa4EIB82fLVhRSoATxmVbzfDBztwNzA+Wa8z/yMz+3T6+i3qi4dTBtDKsz5YCystBrmfzYeuECZA24AzN4IwLkLM2gXqaw1WLPl9GC6wVXsKDDCHLBDUgoYMG0L5O4UDBEjTDQA0utfVilSmPdYyAdpJv+AtQb/2xsvUs5WL9IGwWwcSRg6yHmCPqcF3U9L3E4MbQAXQ/ydM257QEgRpClaa4BxG46fqMNnBtgiuwvVtGT3xgdME27yEAkLlbdlLLnSXuOnl26c8lqrPIpNrGMLQ50GYLHoWA/3g7vas3hc2zO+eK48GsEi6aqFQOOVXxcws+B7ZwtRZ5i1L1NZMyxKqIAc0YnAHwWDBqNHbeN7lDsMxyvtcRGGqImGXtUBNBqyje/YcMm6c83GNCfk5b5yMHdqt44bcG3tAfFBOz5jBjISb0Gp8Sga5Thy0qX+YZPvu9vKehy3gD6h6775wlZsscBazSPddUEvn1p+w3f9BDiNqmyp1nGfmQH8RSs36b98sWdx5a/oa9x5MXkLrHf8SVpvE0KE48VL4RfX+QaytO/Z+/B8PV7doenf9e3hWOHj4Vt2zaLNReLjZQsHgv5ld8/PmJkMjJd7OOKD/iYWPO7du8K87O6GMok5G3X/UlRIb5bBlE/Jxspouf5kIsBd3tKWGJ9QLlmMdeDGwbD85/2rLCi+/uGb34+jEtTrhtRMwBcn9J266Fh61opNMlMrKqogkSlPfNZoDd0KBOLGHMAea+kLZt0XktiufWUCaUOmHaPZbDHjD7p4zb6o76Vo76C7qVSLLhFMHhJo2fTxzU6IGLfnX85lcuNsPvW68Kxe+8KL/+NXwu5bduUHlT6eD3ILCZEO8d5Jag5jWZwv/I44Lg1taNHmvhutWpjTUx6Wdlx5GD0dlVHquXCm9XnAenZtAYtoPuKvOfkPycPOsKqr2n+pq5Z8zZfg83OmpRZILPASSxw3oG5HiApT/nX9dD4yjm6KgmYN9ny7/uhH3nS4LqBz1mGEpBVHGw3ss5oVpdAwEx7ysFOjQQXBNLEVGsmgYuVnjdwE4M3tS9SmE1Kr0olwbJe0LDkADmkJrzsjInlPY/O2Q+DottZXZhfe6kCUl1T7bPLbEg6yDHtxWlA3XWnnjHFdmDtgZ0GmPvovTPO1gbyjqP7Nirfz7MgNp79cUwvOkSdUQdMgGnISAueFAgArLJPz3XuUpm6hNZLaFZpt3AJrFvDivsAyr1Yk4Nzl8IAXi1Qld8MsDlbaoWDdEw/dzXIKD3PI2IjDFjHhyB8uaWUtBO280mad/BUqs6KFCk5QMa6x32zGxwHA5Ycy1QarfcVoxCMEMwTWIssR+2tKWVft8B5t5jUdcre0ts3ZO2ePD4a9u9XgGhDoEi7WJQzRADsvALuxqeVUlJACnym/X1hrjH3Wx+7+upb48FOBtJPbMgZ3gx//f6PPkNGvt10NCbNQd5Ef4lOVwuBN8/bbnyuUwSvznSbsMrtbPtKyhy/XbimyC7abefQF9sCkv0nAnlXT3YfCPSaU2UxHKQidfdrSYV26A/zygd+87/fHi674jI5xj267zpCX79whlhzG3lhhEnnRdrRDnPSKMrlIx0mfVK/OXRkd7j98/8WvnnvrtDQ+gu6+Nzudu3pjLHBfq5Imrg/rNPhgXtnQoveWwh9ylf+gqd9b+hQu//lrjvC6Cxac3U4wDugnPV7BboVVKohN+9c3G90AAVf6oS1DMAvUlNBoSHfFa6sDYT1SqHYlauYYzuv9UuqGGqqGd1Q3N+bpEc/IAewjowMoD8jW9l9rVSSlraxJL9ADrrO+9jkjN2nVlRMh+3MqTDa0FTYdulOZbBZCX3SklcZCVCzLIMLtkJuY88ivyfTMyNlI7KAUj19titQdVtvdzg2Mml6+23rBg9uGur5fR3mXdo2ywhyhvfrudxM9xXphtGfq5xtYJSD9IoipLIps0BmgUeLBc4rMNdDgyG3x2u+Tw+Lc1WBLp2TYTzeVcwv+vGf/pVStfRm42HtpRwnA6d8h9KOAFA/ItkATHcLbPeIFaOITQV2FrZachBeYuyH9/C00qQdn1D+c+X6Rp5BHuZy2UvHA9w5GIFdgG8DTbDppFpEU27vSAeoAA/WMHZb+4UBtpaZ/ITtnRnz2YExAZekjgM4E5xIICZBc0XQKPpSvfEpWmKAC8Cv7dzJcOukbC2zGjKfVjGhRQPLGjUQsKiUfKSAyp/oyt1mSeKC3Tz3OKiH7XjBAxJoG8cDIzbUrllJPmDpAO4OHuPx4yWw7Cl8N+Dssh9Xu7rcCNAFkLPgQWufa/8T+45dkCEhkXVNf5QGW/BnZNCxE0Aa2Y2+J3Y4aaC7KnJ4dDyKuTTQKKsNBAf3ipns61IgryovDq3fHkoa9seBOXrkYDhw8KAVjWkIjCP7mVNWjrrOdd5kAq7vF3i8aXpq+jUfvfpDpABdDc7b2awzZrZ++bf+5LfVF99kAbzkqzcHy+MkDHDHkRP6CQGzXABjjFnOxTDpiV8v2wesNDIR+2R0wQG/rUsP4FqnO8jYZ5ruQYopEDoBP48NiBl4CMyFCeYa4aiKnUUDzT2Ac9Tdq4qc6sQTkrFs3Lg1NJQWccPmSyR90nraNo7/mMTMNSoAc3di6VkEhRalF8+pwFV9djQcVdrFg6NHw+Gx8XB0ZDyMHZ+0jChe9ZaTpetys1uH8qcFgFt9oVuA9Aef8WypUcrhhq/dHo7VpeoAiFMggI4Gow5rznZo1HsEvmlMlLgZKIc1R+IiPTeylmFJV55Y6g9P79uoIM2NBsiPi9m/X+06Um/YvTKlgO+yJD5FOcYz3NOkRZwkLzvB0YBzMg9xd7gzjwad54jVPuAZIltU1F8Hh6vmAldFLvR20TZvGk0E/DMB9K2wmD0MnChw58pjNfDLKjrWkHTvfdLEF7RuWQ5BKZff1VUpvmH78ODVugcf6IXF+zr7uHAWUL/mPUsOdB6tSnlkBYqyeIELd0myI2cWOG0LnDdgrgfFpWrVd2vepwfEv592Cx/+ipxTmpsylh/68Z/4B2mGX4iuldzeBgIjQCQNH8A2pShTzURjc1kOgC6Tv1jFO3q6kg49bg8riX5TAEd8tZilGZUUZxkse2fo69XLzDKiRF2v0XYgcc9ZnCp8duaUag0mK6ZHA4iSIs3YddpigDp6Gfa3gz7Pyy2Zxdy8XugURiK3s/aNQyHda1HAAeBhGlYOHXXDebXJZbRkYwEwE/C5FKakzSXYFNnKCm9wlOzorgWaAOa8gXnZA345lcb8nDkBGuU3QO2JV9hOCuzkhOjcZ7XtjCqqoqcFEFlzLNOJY9E0SlDgRE0O4cWTTGeOuQB0rGj7dyzk2wAWsQXVQyUZUkMqVFXVb8h+8gJoTDa4IMfIgnZxIizdpF9DnBkj63WMLjlTEKKUV58WU4kdSmTX0fkPD5XklCkLjBjP/iGRUjpeQxsfOrg3HD4mna+wIlKWRTGL+GKWA50E6xGLCyxf15ia+51/eP/7v9lceCJQTz39YQP0Sm3wJlnjueb0xbSQvus4YTSzdbR3/Na8+e1L0p77Nk0dunWctK8HPi4c06XbLV3PtMwubssRPuHM4Ksj2I7AsFOFeKq1fu8XOGDce9JaV7oHtLwndNX6ZP9a6FYmkxoFdcRoizzWMZSPXEwx15ltbOSEgGAbiiHFYF3Xqq6YgKlw/+7d4Z49+8MRQLrJO7yN3rH0nbgQOWMvfNZzdJyucNPXvhAOT4+51MVK7EbGHFbd9FMAb20rAGzMOcGmCoQ2kyj3uTPnStPY3ReePbA5vGDDFeGlO54adnRtMEB9XJll9k2Nhb0T4+GA2sS9OC152MRsPczqnpyeWVCF2umQU7YXBRnbPUsKRtKmdtjoGVVNOW/FxogZt1SRyFrkXFQ1c1pkndqo3O2LaiLPJXdo/Wbi/qIdSdJm95b+8fwx+ZDuU+Qvdk3Ur2vq05f194RhBeiOT0zdNTO59LvPfcqVH8kkE63bba180zUjSuLbNF8R23S/Psng4imJsimzQGaBNWmB8wLM9YAg7yppEcc133COWZaEEhxZxgHql/zMyw5Kn1rj/eK6cpg112Tz8iGgEtDYymbSkpWgP6f0e03gvLuKxAXduOFrvdwJMuPFqKF4BQpOKg3a+IRLQGDXe5W2DL0y2VR46ZmWm5dqBANWhj4ScCmDC8P6AGdenrTPmVd/19vfhg+SnMUztPAyH5tQXmdYNoHEml6c5EdnZuOFmOWF8uS0AzxhzJn2l4IrKQM+KwbPh7c9EA2WeVosHsGe2IwNaA96fHCJMdICvYb9jDV1BpPJMqcAFvU72V0mZwgaRQMfg0Xt4ABYTtVRG6CaP02Z0JzdOXEM6IDOsIXhKR0fEAeQZzSAEQvJCqpySuwauVDH5TIRf+FE2Plxve3TRxpgihkBYB8ch9EOriMaXuIO+uSYkWSD9bt614eegU06F+nLZ2fDgf17xMhOKRDU853DQcf07tEZM7AphcvyRyanp373k++/Zpdd4Cisid/boevpAvRSuVKbUH8qtTs6D9Ryt54/5tTEA57sqdS+n4f6PQH41eul0QzrxW3A3n2E5FCdqDlvraf+JVDrIy+thprT5x3N71315UpFIF0VMLsEoruUVad/cDAMDPaFXgIfBbCtcBf9VECdFIv1uXqYmVdBoKmJcODIEbHpY+HQ+IRiJeadkddz4Pnf871h3eBw+OL9Xwt3H97joByGnGMDwnU/NzsogByQzn2G1rwJ9LnB9LdAeShW5cdVwnes3xp+dPMTww9u/fZwae864fzOcHhmMozUp60iKH1xgaAOXZ0ZFb3C8ePe3nVwVM+UhjIB4VwoVaoNwumZEEfZViT5yemGtmgVy8Io+1G8TO2iYjFMumWbwvnX96LailSviERPn4UYp2HrQEjY/RsFTdjabhy7+dwF07KKjDosp2lIOvTOlZWvKCvMa7/nip3/dLL+ki27sBbQfaVAjfBUzZs008G+rplCftlox4W9NNnRMwuc1ALnHJjroaBx3PDi+ED4Jz0MKIxwLqd2YA5lmX/Jf33Jd3b1Dd5Cdcs5KNI4mSQkZoZwsA6D7C8nf7+6eUzHavplsVWAAb2Ae7sF1MXOgqumBcbn0ZQT6IjeG6ZLQ9BUx2SbLqVTY32LK9PfBs4FgvUqjiAU7ThA27OvoDU1yQm4OWERkww4IEnp5izoS29JAhDntb+6GPO6AMaiGLtZtQemq6z8yGAGA4pWOAgvwkF9RQFrpGajEfyGwwAA59xNrGB2oPKl2PRZSqE7U08bzF76DQehKtCS66Rckme5AfDn9Mw3YK//mVxHL300s8dnFKgqjboHh7okyEf/HaSZ3TXbhTM2LxY5MmzgDoABBMAlEgn709uV2HS0y2WcksKKUmEysuCA2zKHNNljHA8/V5hBl7Qgd1F7bd+uaUZ37kAQ3CWJDyBMv5vcQ8Fy3YNbQr46qOw0kgJPT4U9+3aFcQGo+gKRBBZN4PZcxVhr+3dPjE286bprrqGgS7tw283fmh4UoJfL5ed25PI3PRgQPxl4PuHGj/384dyUJzteOxhnXw/WppMdK2UR4vrmNUpVhg4/iV7daw3E7Ehcu/i3BTdrG1hkMuqs33BJ2HHlVWHj1vUG0ity2AhwnlfF0KUFStzrOilXfUMRlN/at0fzvvDkKx4frtixI+w6ciB89lsKgQGIW/UwfXJD8jffuamS1hxJC3IWc3QBwHGgjiBQMkAVYc0VhNnTH37+kieF791wZXjC4CWhv9wT7h45FA5Mj5tDXNN6VAPFUZ4hhkGfA6Wq2sro1KKc7KKKKs2FsZnZcGR8UhI6yX40alVUaklGgayCqID5guRUXNKKnjtkLSKPv8fR0DwkW371WWZpGuU/DCiWoqzn2SL3N3ULeEZoNbo7z0VnMPQswFNltE7fOWZBpEafJF87e7oVB1u4Q3UOfu0p27YRV5FNa8wCuh/Xq0nfpRmgPqsZ9nz3Gmtm1pzMAo95C5xTYK4HAW+oF2omMfSn9BCgGMK5nNL5JLbc8N2r/tvLX1Eslt8GSIQFndeMTCFCPWPU0FU6k+csrsPDCOT0zTXdHrCG/rMkkNYltqxH7Dm4arYuJk5VMfXedHmE5Qd3cG+6cw1zo1WHVGO/FBwCBPOddQDmzDDrEFZWKCey0RYoacH17jQgw7DsKfoT/TCfAA4cDwCj6O3TAgAAIABJREFUZU8hB7kawnuUthbFoOWNuVblTukujH0EVGv4u2T0vEs8HAcB+JHEcN4q8KKFddHwyGXqcjgib9Y8N4a9awI95EpHmw8oLhcBuGKPlTFmVjNpKAFO0zrv49NykKTLtrSDOAQxL7yx1zFQFdBvWWsE22k/shaugUkcvIkGec0OcRTBwAfXSnOyZVVtQaJSNQmwb28BhKwXh/J9lN4DEp3l1zWz64822tl9bExVV2PfI6M+TyEmmPZcNdSGLlFP6zGbHBs5Gu7bvc8kPJybyWYMa7udWcfOdWVFhR6X3n10dPQPbrn2WnSgDxugl8vV39H+3ngy9H4q5rvJmEcmO217cpb79G5Xtj0VED8Vq756z01gznXQCFWlQspAb137PlppQLFrcnz8HvBbVr0HuRUjP1qlKkZ9/aYtYeull4Wt20nB6IWsFoVicY+XdJFnFIBaVCfp7+0P9+y9P9xwx22mOjOm3EB5GzCnUxhLDvAGtNI5QMI8CzQBzBMoJziF9IlizXNqx3MGtoTnizX/jqHtCqzcoEq6M+GescO6L+ctKBP9+Lz6TVXVg3AW83Ky55RTfd+x4/bM6lUVUvo794SNNAnzr+heJV6AmJZDx6bCAUnqCCrl6dtBhidYcYLSY4pIcqe7bM/vse/aPBieqKJDXXo4WQExOSsL9pyRlIu0r/R7+qyMS4amKd3DkyIA6N/1GT3HVHCMFJCP29AfhiUxkilu1CPwt67atOmO0+s92VrnywK6j+g1l2t+smaEYNJpWcXt0fPVhuw4mQUyCzy4Bc41MH+uDk+u8ht14wM8zvXkb+oW6WrA/Nd//RffoCHbX4P85MVjwFwvsjkxS4Alk3Lw8o8AwEaTbXKWKQ7qOktr4Nw1mAUFeBUFSAe6xUwhcVBJ8ZmZOaXUWzDNsacANBjp1UDFrCEtQWpBJmxAKQw2YB82j3c/qc0IFOXFCzhOeuqkNbeszwBZ5BdqsGVLseFn5XAhewoBfuZguM55XinZ0NLSXvYJcEaqQlDojBh2Z5rFNOrlbay69oE9ymIcIdMZ3oblZ58NQPWMKi4qb7cVEDIJj8uB1Fq92DkPP0d0vpxnQaz11OS8NLPuDACIVNJe6e28kip2h62HHbTymdqt40W+eEYbGDuAOcPv2ChVsTTHJDLRNtzO0H50qOgEsPmAlZI26pEEiTowDNtD0xMISR9gfQtAtMJNvm8+OW/ju41NNhRt++faA8xxfMj2wcjERF0Mp2ySU7n2PgEuACV23LX/YNh38JAz8tbT6EwONNmvl1k392K2Y3H5bQf37/0/n73hBgK0Thugl8u1D2pXP5PA9WoQ/FBs+WpAnwB2+6ddDevLp/e4eCim/FQgPklckn2KkkowYtI+rd63t8lnnDqTJ8UgWBxKLmaHdNWdmnNinPsGNoYnPulpoV/5uqti0ZelTydlYlXa9asu3xmmlTT8XTd8NOzavct3y/GbwFzfAep0SgPmkUk2Jj0CdGsK61FYSDIWk8FQolPchID5k7oHww9ueUJ4xtDl4fKhzRa7cdfo4TA2O6XD6C5Sny+INZ9uNJRGXVI4bVfTc2ZU2Ve+tf+oYh5gwT1rFOsMqijSSt5HjmoC81sUQHtwbCocHp9Sv9SogGwxs6KYD937lsPc5GNkZuFGctvibm6Qg/6MHZvCZdrf+PSM5Fl13TfKANMlSZy2JYUom5KeFYeaU4RYmJWzPjo1o/tgMQxo3f6qrpnuc0YRX/sbr7vu6U9/2qtf/9v/3zdOuIjZHxfcArqPoIgoTnSlPZpC2KMZBn3mgjcua0Bmgce4BU7vTXsGRtKNz02PV041wvvOYBdnskl6SyfG3BKgve41v/qBQin/YsDUnNggGClkH3P6XBCgIh85w98pkwUvMNglLxqIrCG+bMF+5AFvaqg9MIrc4qY/F3ueFxCd0/Dy0WOStwicA/KMbQcA27ub70smI/EiRi7pYL0uAQVKc5eMOYeQc9bcJBpNmthBN5gDqQw1KQH3xoBpHS+i4gCTDS24Uy9TQOiiMjsYCBdYsKwbBkIVlCkW3ACPjgvrbtkdtJ4x7QSVRbabVciacVzZWxoK5vQhAU8PCcAtqgHdGtLvqsLEo9WWo6ECJ1QznZUUZkJMOQWJMOcMDgMAXyDBihqRthGAruPywjdWOk7OnjtYJqjT9ectoMiaCTPiL/jk7LdVdxU2gvWztlXE7glQWZpItYXiSZZikFELMaBJw58qusb4waa8h0wYBNBx3SfFZM7KDmPTy2FU+vkpSXQaSwr6HVgXLqE4jo5JWsX79uyT/vy4M/1G6YK8vY95qKtjQP02oS7558cO7Hnr7Z/+9JSv3Jzjxk2z2JmWKtUvyz7ffrrA/JQ3fGS8V7PmpwPG24H2qUB3+/JTgXwD5uas+AXNC9CaRvwkbfNVWmfTcjBigC8Zk5oZZrSypUHEOVaBH+nShzdtDzt3Xql0glVh5mL49sc/TgBXhRXu/3oYWZgUCL4/7Ln/fufrzTvUJ5IV8wz5HmUt6dO8UyhqOmoE7JbBBY25ZgWBdtS6w4s2XxF2KiPLtw3uCE8e3i5pXDHceXhvODar9IhiBADj9uzBadTcr7Z2aZ1+ZUa5+8ARHaIQjh6fltRFbqzugS2b+sOSRqcm5gTkLQZEgFnPg6UpOeNI9SD16e+0W7acUgdrWH0COfC4nnom4J5yLxR1L2/uqgnc18J6xcYUtc2MRgIdiPtzDie5os8unVNRzweeJTi7BMpbEDmjdLq32f9b/ugt4T9u+/zKz//Cz374pb/wstde1ruO4jfZtIYsoHuuS80hvSJ1RVAV3qX5q7q3TGGYTZkFMgucfwucE2Cum31Yp0KwJxlYPnMeT6sdmKeMLIXffc3/+LyCM68k8BEYhAYcmYcKwYg1J92d5Cd6mVioooHEqOK2d5m/iE16wImQYztmKQAYmB5cLy2TuIjFqpANQcPL6MhHxma1f1BrTElmAJbQLAHPCHgLetlbDI6NS1PcRrIQsVPox42cQxstZyAN6Sc5hBUd0hZIVSxPeGJfHWOaR9BUUEQW2SUurGuw1dhfhsFNd5uqexo4Aswjj/Wc7jgIDP/zosc+s7IZWnHL3pKOh2nQ+OrlTgabgR6Xs9AWk6LoHFQZUwGgGgI3QI52nX3JtTBHIxU6ctbTnIvmWIXxobZ/2ELYc89R7rjVWO/EbGMT8qVH0Ma1spzrmstyhGqyb5e0tBRrZFvyfVMgCbuwH0YOCjK8cflqu2Wa4dzargAFoNCsm/Zew/jHlcHlqMr7jAuk15fytly6bwPnG9evNxtMiFUkIwhAxybrVwl3e0rBxP4KtI8sLyz+8V33fPOvvnXbbWRQOCVAV/BjXdspsWVrsstvval1HM9g47d7C8+2elVL9hKb13a+J9WTx8MlO7vv2nqcpGO3y2naGfFTPROWGK6KJ5CTDIT+5yMoLbP5OaRzOfERZncFGX8Yk1oNznXPdQiE5+UsrsgBHlR2nR07Hhe+/1lPCwPKNPKNffeFw7NjYbEkJrhzIXzxy3eEyRGN9HMsDgPHaMy4ZvVj87y39Ppyk7R4GkKTspC9BYAOW46cRex/UG72rmpf+NmdTwpblJXliYNbLQj03mMHw0EFgU5KZ27yNpx56VAYAUPSQtGf9QLo6Mv3Kqf4UE9P2HV41IoGoZjZum1I2V1mzJmdUKA2z4QwpZzluhdrOl8rRKb+vKh7GFNyD102OKSg04acymmzL/EfBGijBkJ6RX/fqOfQ867aJu15pzI2TYdRMenTGgrMa4cl7ZtYDBzesm6mvi7SM7okz4odafnnv/KF8L9+7X+G5zzzeeHVb3j1UrFY+jt5Ca/fOTCw91TXP1t+YSyge5PCRN+puV8zz5yvnEdC7cKcdHbUzAJr1AJnHZjHIbIf1vmCY6/Tzd2Ktjz3RkjAnDckHFd+y5ae0i++6ueOCnd2wkKV9JIEpABEKYwD80suat6HItMNlBsQ4P0YWVleRJbROTKdPkLu2UBWYLeRWvBa4hNWF4BuadxginnZ8t0BOYDU1QyeAxwgSDozZg4MM0y+dPYJELZ9wxKLdWYbADMT+wHMmQTEhu8dQRr/avpzRzfxUEZucz4AeIA5M0AddhwA7uWDCKhz21jua0YOtLQk1g9Qa2xyxJMzKgYzKX1pQ6MNpl2N2CWNDvQCfFSkpVyMWVHiaAFgidEK0ieivwYUAwq8sE8sE85oACYz4Ozo2IlI1w1bMK7250Ua+T0GdnLG5pB4oaOE8GC5Yc4thk+fNbH5yG7KGt1Ad48jAiDCZq5Y8ZR7ABqOy7C/M9wUW3KGEYfMALeYyzFJWcb1Kjsu1lzZ7RDAeJ5sfZaVXeSybdsF/ATg9PexkZGwe/9ejdaceFs4MHfHJ4FqXatDchje/IX/+MK7j9x5J0HTqwH6ZqUTdJAT7+TVN7RhynjRmsAZe9nyyOHHa2d2tH1FR8ekR75vc0zs99a19p7o94uPvvDFnVt3HB1kmpNoqzojbj2N/yLg9nP2Y3v/dNa8U/0OltZ7Qjx7GHS6usUc+DXg9+QTODB3iZSPHiG7Sv1LawowdhJwgPxM2qZnPPWZ4VlPe7by18+G+4/ulxepbSq6z+RUjs9Ph89/5rawoFEPt7H2nYZkorTJk7ADwvU7xqI/EghKMAnLlQddN5BmHbParYwx68J/v+KpOsdi+O7tj1du8+4wWZ8Nu8ePqe8omFPyFBvl0n1RFjtO3xxW7vxuyVx6K9Xwn7sOmuNRFfNvFX4Z0lE/VsJxG2kbAZhLXrIoqVin7AA4R7KTt2rGCkBXe48oeJTYCK4Ez7YBtbFf/RTGHtZ7XCNok6QW0m575Vjodglb+7rC9oEuCxafnK5r9KthtoXBT7UMeJ4y+oesDme8ovP+98/eGOYbx8PLf+YXVGtADpFuIe34nYuF5Tde1r3hfMgb/dpl02lZQNd0p1YkxSJJG5S83/Tn2XU6LetlK2UWODsWOBfA/PvUtI2aP60b+nwHlHA+QAlmD/x8xX/deenll3yFNwIvDXIBe2YRNL6UoRc9IBbIq1t6WfmUMjENuQNoTOesPYJBjeEFtFrgH+wSB3OQY1pwmFcx4WibAb7kGTdwA5Dg/W4A0EGLlZOXs4DGHLBo6Qf1g7HDticHGlZEheFoTU1GGdBhbSGtn4N0z8CgZZQr1z+OA+B1ANUCUewHEM6MuVJhH17ckPcMh6PFByQxQk9GEqtGGsHwikY6AdijqnZZF8hmN8Yz69McCQCBwMM6gfNaibZw4hFX6gNpzYyK+eAEkHIQSYk7GD46YXGxtDoCu4Q83QKe/tAUA3wm8GnnBNzgWI4Jzd52Xfyaw+jBMpJJpirmvBvJjbHJLo1xcZBfS3Kfk08dsGd5ntXmSbHjByakm1+QQ6XAAkEnBcJJr08RJgXqMRqzFHPV+2gCDVHmCrGcl+3YptzSZXNC9kt7vv/QIbs+fpUjSvXTbrYnat73/P/svQeAp+dV3num9162d21Rb5Ytd8uywd0YGd/kXhzRwSQkN3ATQnCoCca+JGEJNsXYBOJAgOACLmDHBowtF0mWLWml1Wq1ve/Ozk7vM3l+z3m/mZWRCQTbK5P5r/6amX/5vvd7y/c+55znPGdxfuFn/ui33/UeX3x5ft8Pfded7W1tf1pPhEV9bUUSIgry1mNsmQ6EgSfwZC+mPgNlC28+gDeTitH1zyWDYWlwbiMyE/6syFE6M+NIhsFPam0C6/LuMkhnHMkjgCqUUoAUBpqRDOCMAZyMYf2cI2lZBbpmnDwtuc+Jcf0+GWPS9T4nOcML54ZjYkyvCRxjWNsQ5SeGYzFGc22y3MsY2jDLHl2e83CjHYbRZ+iHLkn9bV8f3/ziF+tzbfHooXPR2dMczZ2N8qqrrQLoc1LzOXD4YBz83JdCg6yEAqRRPag56apJaIqL+gkRfNYoTWERquAUeveyTgVzhHMk6djV1xsvv/mZsVkVTQc7++I5W/fYQbDv7DGdYkbgmD7LdcDdAqOyXeO3VgouDfr9xNCIgPGMqCRNpuW1aT7BMQ/lUHDqIWhmIzPRIGnPOSglWp9tkjRkfTcKvHeqUNZ59XMj9xyBcUhtJJ5SICuVVtLQb9XxnfTMuLE+dWPcIK/49t7O2CiQTuG1cY3ThRFVHtXcb9Hca1K/ci0USSJChIIL86xnQIaFjCF46sjOYkBoHYrVtvjLM42tP39tVxcJiKuPp0kPaM0wgylOdLWe/C6LNe7X/YBKoquP1R5Y7YGvcQ98VYG5FjSFDG7T80taxA9/jdv+5YevruVJwPyf/MAbn7lh/cDHoYs4yRNOtcA51SgBSOmBxlObwBalAeT8QIYVsDK4AlizUQK2gSECbRU6sVdXCLHSAzf9REelMA9e2gTFgFMBCHnR8PImnzb3bw4Ov7lFXulOeduSs62NlLCwDkS72PAmhQ3QRgcw2kIwcCqQCABkj/OCj4UyCmASgD4LCDIo57xuja/XBkKhwABuksubnls431Z5AZjDLyXxEnoNEQHkEW2gKOSvaMMFkjsVOl8QMK08mJXiQ5M25gFVRewUt5ukVmM8X3gaQFZtAUCov1GSsKFRvJI2QNwmoz31U0YVsrqkXkc/3b26AmrzOt2lZfxWpgn9zjWSFIqXr1W0FpynbQJULriUypHL7bOnXG2F8gOtgLGf0Nx57Myi9KdVYEjKMnDkLf8MpNeJXayozMTKMKgUdHhj3UB/bN200cbYrHIRDh0/IS/6RUbE88SzoVxz1Zc5g9ywA3Mzcz/zwfe8+w/46zf/4IPfK4D1dow/w2L/V3m1fSXuiL9C+/B0LSC7amx+srJ/VtpRTp4GUvarbUUvjgLSi+t7ZT7lR218FjBfjcLldJbEyelpr54G8nqN+bcgwDg7My6AKZA3LV61tMdHR4djVBU9Lwi0HztyQvrx5zRPOQ0JuRlOqqrjovN9+bEx2tx25kBna7zm214brWs74xOP3h+N8wMx2DEQnYPtArX6XjPgfz4Of/GR2P+Fh2PxEupyzDmfoJj+BZC7CiiJDHr2ahLJGLViy6hONl2Cd1QCFc+8q7U9rrlqd6zpHYgtazbEC3ZdGzvXrI/7jhyMo7qu6ZJ57qiM6W5osctolwnYKVCLITM2itQj6k+iq0ClE32us0fAWO06PzQV4wu6UcjoJJemRs1G4Rxg3qD2zQrEc7vycsrJJgc/ik1EIoiKZDQNqh9GgWsdOLJFYjlRQl2iqoAOyNDYoKJF6/UkH2ZahtOEADmOD7q5WSCc+xj3rVkZZvMkspsaJ3qNDIUOceZJYJV8o5INF/9Db0392wYHB1eBX7VQngY/tXZQU6Na91aWs54H9HxQ65zSu6uP1R5Y7YGvUQ981YC5FjGxevTKz2nhfuxr1N6/7rBcS/Ws+OX1//Qfv/H569cMfMiUB6NrQwbrU48p3Dsm9YAlAXFAlb1ueNu0c6EygCeoCrc7cZOIdfEiZgIl2uUFxANS7JmWFrA2Jx4AA7jnbFzmc5cQfSPeTW262iILMClwSp9vJeSMuppO5iRHQLr+R1geys2FS9p4pSfuqp06B2XjOQfXZGcd5wHU6/utrRU/nMaIVy8PN8orfNGKIBXo1dvzJH3qrQaFn/kJfxtvOt7zTLZMzXSOb44pyasGhNBZ5uPc6JSKtRB5yCqdy7KDaidJoZ3SSe5tw7BIpRk+xEYPcELlBYBOMquTVHnbqhGCJ1w/P3WN8MELQPW4uGx4WhrLYNGJpAVBVpQJ21UFgMKLpd8A4lQKzf4W91xAhmQ3Gw/uLoyv/FxWZcUIUh9rLM8pkfUzB5TsOdviiEsaSTQhk3BXzIQnT9eqDQCuzRs26ElgSfhN3N2Dh49oLk4kjC0efP9a2r3Ct6fPFr80Nzf9069+xbfubqxvfosjFDY6MvkvvdwrP9OwXAHJlo287Nj+bHZSXvtlQLv6u4ooLAP0PMLyZy//XHXVK6QcHdNznzm70juXg+YnA2hkP/OJobkgwxIDc0Ee90WMzMUZjQ/qQzMxOT4U93/+c/GF+/bJ0y6lHSsdQcnQPENPv/SFp4k90dmCF77ohbFx55b4wqUn4mTjWHQ390bXSL9K2fdEs6q81ogecuQv7o/HPnt/zK+X7PNZ5eIyxoWuwtouCw7kW+gseg1wDoXFExdDstw4xBWvEZWjTeovvd19sW3rNv0cjBddc0O8/Ppb4vOPPxYHz5yV4ScFFZ2IglaXxiZ9T+qSTjmVNgc7u+KCPNET8pgP4cFXW9rkqcZQJcGzs7NF4Fjeb9UUmBQYZl0itxhKazDzhmiY7i28REEjomum7tEjGntGv1ngP/MtJNOotqSxhfQp9yDWg5KfqYimRdqmz0LV29zTEbskt9jbKe+9NOEn5flHqWVc49Eqr3wzCjU6+IzaxM0ExwKGF3SXDgF8Imv6HTL/W9sG1/6nTTU1JRHjyetn9a8r0wNam306M/xzCgXC68Lx9viVac3qWVd74O9/D3w1gTl65RQugFeOe+nr/XhKYP4jP/QdLx0Y6P1DvHCAaR4oCLAR4Ulm85pUiBpgSJGgeegbRO/0vsO6RTHF4XJ4x6BW7fJwNrNSZ/KCkSlk56qR25XNH5oMigemA+iJVjhShWyCpoRog2qSl43fUTBgg8wy9HBrkUSWJBqqLPa2A2LVRipR6tjjtFdeZjsASdQCxOPxJpIO/1oHAZpZspB2CjhwLKg1oPJpXSvHFKFAPyl4lBxurn1exghbNJ6tJkkfAmO5NFfWBLiiSoPHUZsydIlalUIHcpFEe3FsRlJtUqOZT9cz57CiCpu5Ptsu0NIpxRbv0zji6DeUcXQAKC2cm+/g+Jyzt7WiUSTyBoAse/oMC9NbbtCHkWF0CEUpoyFppxV6Q/H2Gsz7HTj+ODapjlp5z+nHTCxNcJrfpx8B8a7KbgfoYpwanonPHBKvfDo50NnjK6D2yyf/MsC+DPRSQGfb5k0x0NfjeXL2wpASRI/J04m0JIctRoIPvPy/FSOjofHUjs3Xru9U4ZqOdnkhrSENNx5AWnnKs/8dZeGQBXybtlMMsye1jTHzuTMqUp11pTfyGvMybI1c9sjXq+NW/bHiJU+ufgXoKwPAPHB7yvNgBuRFj39RUn/87qJcTAwZmIB0IlCmyAgILlHRc2woHtv3UHzyzz4Vl0Yndc31jsIAAH2tWNVeulIy2bQhnve858aR0yfj/nMHo+2WtdGxpSfqD7dET31fdAy2xaUnDsfDf/JxgXzhEPHRteBj0UooVNxMr3taoIRailFjsK6/mVh+vYB0e8tZ1C2KHLWoQmlXbNm4Jbp7+uJWKcO85rbnxMGTp+KJc2eVtzGVfahDk1ztfAcd97ZtGxRNa1IegxJAz4/E2ZEp009atL4Z806oIrqfLCgKtFiM32m9DwVlkYq7yHmqnXPUJ5DBTmEljxP9zRpJk7AA8EJ5U3fbAcD9Qf+qpPhF5ZU0ScKmXmuNmg7cm/raWkxbQfFoU39HrOmSCo2OOzwyHsMaD8cLSZrW4ud1J2VDt+I+SBTRkUjWWcOZ1vqGfxfr1//6tV/7YnRfvkxX//5rekBrZ6vexoOOJ52aJMgrQnNZfaz2wGoPfBV74KsCzLVg96hNlPy9Twv1sa9i+/42h6qAeUVlsVTiv/x/v+vV/f3d7zEkLV67rOSZFSzRPgYIIQM4hUKLeM9Tes4I+FqGEGhpAJOAIx2LbPSAU5I2Uy4Mr+6CQWbxQBl+ZBJiahykbB9e2Qo0NcuD1iquJmpqeKznFPa1JLKOOy/Q0SRwYT1zXRHeqxGFi2dFn6BIEk8SFg1f4QnrH1Rh2mbADMDnqV9IJkXykA2wRRsn4JPKo6iHoIaCpxegzGbJ9c8KuENnYdPk841waPU5OOe0xXri0EH0E8Bn+C4ARNh6WJ68s5ekvOKCmfQLWCbpHi0CKm2i6rSSqEbCGrAA7125HieAwjH3k1ZV2uIcA+CWVBYDfoNWRlWMcIPt5MjiMV9E0QLDCIDO591HCZ1tKGG4mI2Qxpo5rwLeXKuNLRkf1XmYMzaY6AuBHivg6bNz6rt9x2fisSGqrGIepNGX2PJytJrg/ssfnkNu76IKT7XHVVu3CFy3uc0nz5yJYyfEP3fsoIB9A2ra5YsoMMpmR1w8dyGGzw/Hd37f94jL22EKVSanFlDu+cr45nKvgHjlTa7+5j1mqtcKUYry2cTgeX6PWgHQf+WiDNQro2Yl2nQ5fcUJmf7c5RzwjJxUiZ+Z/EjuAVKg4qEDLjF27SVnzODA0yRHD8xdN0Bf1LwbuRC//RvvjlOnzmiNi04BcNRc91mdBFwfr3kNgb2IP/ron4p20hTtL9gcm5+1PqZPyIt8rMt0rX3v/+OYlbb4EsYxa7avS3xt5YrYMix9kTcDR8ZywbmTS4ipGJWAc7UD67hWGeEtGuOent7Yvn1HdPb2xjWbd8Rzd13nZOD9MhRGVDWW36su5h7FPaZfiZ83bFzr9fzQ0bNK0JyTRzqLKFPd11Vpmcf67IyA+frejhiW59p9LYB/8eKU73cYNw3i0VPtlLaSQMqIZ2J4Kig5KVyX6Z9lnjLwvnSmoI63KKBfR2VjHdPfZ1ykxlSr6BNrqltGxMaOtuiX8TnQjSd/UlG1MfHPZ9VG3ff0utesVa0yh4YoHMuINaG2HmttbPzpmzdt+i21YVW6768utivyitYpE/saPa/Vkz32jJ73aoy+1sUDr8j1rp50tQeuRA/8nYG5FirZ26/Vc0SL8yNX4iLKOZ8SmP/rH/7e1/f2db7Lb2ojcgEd467cdAjv8reTELXxI0GG5xwP+pg2Yvir5jprE7qcg1txsqEloMKCpBj7sj19VHzEu8dmXRxr1S9NUFusC855vQFJQq3JvG3oEyTFsck2CQTydTzR5pnq4FBZLimMjRIK1UVeXX76AAAgAElEQVQp412K0ieg0jFNtyiALOkX2QzAeQsazjpPkxRemgU25gRonDRqsAVVB/BKCBuQTQpkdmmrwDSa63grMykzqRMUQiHJlXNYbUNAioIjF8ZEudFz3godK0CQMDjgF+95q3ix8LzRhQd0AwImlViZ0okJAgrzJz208Mp5Ld2ey+DIfmpwUWIGPwAjVRIp7bIufeHQgqUYMzj40FLqCoccMOaqqyU/YJn7bG88CjDJsYeH3oyRIyfquPr/3kPzcXpCgEcexGxv8nRpowGvm5sRiXxcBtQv/1W/rxH/fJv45wCXOc2DIydOxJlz5/MrnkgcrOQJlOOav+5zapxEd7jx6uujv6/PABQahCMpfuY42bfvZM+Vcam8504BKA1d9nqXdtvILD1c0VqWr6YMh4elSDI+mUueI5PFoHL4lsdKf0yIM33y+JnYsmODXz9+9JwTWU/p+idE85kYR9Jd/a7Exa7ePgHbdq8XS2YyXj4gk4bCAQtx9uSxeNevvkNc7FEB80x4RR+ftf+sZ9wm/fLt8ZnPfE4FoI5FraIMzTesjS0v2xFLGNb3LcbZzz0SY2dOZlSH45N4rTUKxc3tZ+1WlUDhl2vtKxtTfkRkETMap5CPFq+efMfJwModUTuaG3UNUlnZtm2H6h50xKaNW+M5e66Njf398aDkNM8Oj5rfzSU5v0Nrv0Hj2Nkkb7uM+I1S9xmTzOGwLN/TF3V9dhAQ4cuObdHniTLs2tivRNBpAfBMJF9Se5ArvaTCQXUUVsKBr/vMFNEJzpUWVxn/9NJnonzO4ere50AW61DXht4WIJ3zQ3+pVV/UtyV9yPcH3dtadM1tuk/0CKhv6GuzqgvrHdlQ6IKsewq14aTI+1Uak6x3ziND44AW908+a+vW31NbqmlTLabVn1eoB7S+0R3De769NAFqC/zzImF0hRq2etrVHvh70ANfDWD+YvUDZNkPalEir3SlHpcD82WO+Y//yPd/e3dP29sv9wpW3jk3lE3LTIj0buOFtuqDNhW8dWPSK54QFx0POhp+mXOZXkUAj3EIHExtnq3yGMElx5uLdw8/nYHUMnlCm1ANFBD4zVT2zO73/7Up2hMNXUSvNMk12yl6QiquEAjOQj7jkjq7KINhTJ7tBak+uCCQFSC0Ueq4QC7AmPngtNPtSc85QLhdChHtAtpt8ljbM6wju63mRlf0BvUFHnySvZwIqsInpZAI8IzLQesYL6T1O3RSrjsvA6rMXJwalYdfihDpd03vJtJtGDFWeTEIRkUGz7s48QK7bNJT2vBn5Y2bQZawILjiW03AjYe0YHP81ObOut3F62qpvASepjuY/QCwL2DQ3mOBiVqpUlD7xeolpZWAAq5JnwWoCMdkaXM03dXWdrWTI0MxIOEA1Ylzqmh6UtpDJOMlhoHORKQACkAaXqlMku1LSUQ6OxFOpYyTqjr5+vbNG2LHtk02xsbEM37o4cdj6Py5pOfYswx9KKlSwjgGp/4uXk8dZ/vuHfH8O54fAwMDGa2oOPL+mREgR20KCKoWrGe1jm+js7z4pHVTvcaUZ+mUn1z35aAbD3UartU4VIA8R5LcjZHhCQHw4wLPl2JSNJRH99+nBMarRI9oiXvu+ZBVkkjYzlnm0bRdUiugt33nNXHbc54fGzavE3BDcabStM9wS42A6cF9D8e73vkryZe2dVobg+vWxp0vuiPOyJv+8U/8mdd+rQB3/fbeWCtg3rOhPU5+5Gic/9OH0mjGaGe9M55a2wuioSySP8IEcfhLP5FFBIyLHrKcAIrn1xeq94EpJGqA8rHqGptlQLXHpsG1sWfzVnmOO+KmTTvjth0740uiz5xVISq0wpPawz0mjeV26aDjzW6W9521TJRpXBE0eqfYg75P8NkuaZdfK2BOBdBT8sD7flDWNnSTkRnRZRz9wUmghFCda7o4LKq5kFER1n4mg3M9GO687vsW6wruunT8PZ8cOZAB26H7miNSOYOoCEwDpxVJYyy7ZAhtX9sTW/o6DdKZyxOSiByVUgyRvyYlluJFZz5R72BUi5B7qxKxH2yqrfk3r7pt5x9VbVz9eeV7QPOhW61A8AEddJJCH9Jz/6oRdeXHZrUF37g98HcC5oVz9tyyEO+/wt3wVMC84c0/+v3/qKuj45cSA684XEx5qDYdNjc2QjYXwujsO4VKwWYyK6BxcWRSAB3gkwjPIMv8yxLuTUzjTQrJOjzTBQ+k+guUCHiVeCyJdmtTtAQioKa8l8Bo0aF0l5MXJ7vZmzw621JboYqg0Aka4mcvqJKmvGZ4sL3tAo4BQ1BSdKXon1u9xAmNuTED1pvx7muD72tHkQQuOAleiP6lAWBPM1hC10KhEqgtlgwU6q8TnxyvMucCROPNX9KmOS9N5hm47vqezRABqllt2HDOSewUmUAlwdmg2XCT8jGvXRz6Dp4xOOwzykgDsGFozOr6KDxUizKOWjM3r5B9kcirBZQKeNlDB97RJ3BO0nBTcoxPBWzKNdSn1WWAVQvapk8MGBU+F+KelyRejT2hJekUqKPvUzUG/nw9ERAdrd7AOpN9MWK4CowUpORq4NkDTkAm9CHheGcqJI2J79Sr8JDlAxWV1ymTo4xRo78TtIsvrd/1btSpnc3yMO5RNcr1KlJEh587dyoefWhfTEpOEDCDKWFPqK+7op1kYR07FtWWXTc+I26/8xXmMgMuATiWQjRYTw1wuiKlBsGblSc9V7KBMJO1POxUteGSS83npm8vW1deG+7DYpRe5uNML3p9vP/3PhiHD30p2joa4yUvuT26lAQ5JUnRP/nQR+Nzn/+MLdXZQtPgj0WSBpHwKddKNKC1qzde/MpviRtvudUAE2p3Fv5KDvqswN573vmrsW/fF9WXLTY0X/3a14jf3REf+PCHY2zokudFjWggdQMd0X/n1rj6xVfF8c8diid+895YVOQHoxars6ZFq1YSgYuioswPlfQZW6N6HzUWva9MSGXYoFVefuciVIRLeqoJ0MuMQZmlVu1Zq/bvXL8p1kjX/Np1W+P5e66Lw6dOKWlShXwEpsfk2WYt2muu6+poalOkC7lBZDqlCCRvM/cl7jdQ0kjmtC2gudSldu4c7LZs576TFxzxA8wzX/gu+Rue0+iNy7CAOtMuMD+hKI210THWi4Fm49KrrIBt5kxZ6wvS719QlMuzgb7k3icjBZUYg3MDep1b7aiVwc16HZfCztDUJWu0b1mn6+9ojR6du7etOdp0z2ScpuUQQVEG1gSmxri+O6QIHFK2OuZ9ja0NP/7dz9350Su836ye/rIe0NqmcigVRKkkirrOFzQfjq920moPrPbA374H/reBuRYitROrQkJ/pEX49Swk9FRX+uXA3BzzH/+X33d3d2fH3oyC4vGpvKsJpDOZMNGDSR16H3hkdCAQ2SDvstUg9OFpec1HpD4yptLyFMYxP9uYLnnWgExAGy8BHPFGtWrjb5JnLb2heI3Ti52JqGxWAmLmNKcnkRw1NmI+R9Imn6sTjQTQCYBVbJv/icM9H+dV1WZMmz/e6znFptmIF/whMIw2bR1nQaiV5ErC+IBUJOCm4ew6Vi6vJLrJld60w9oCq772WQP+evO6FXIuPY4/OrmmtD0lGk0L8uVpE3diHq6T9FwmgAXtY/DQ4ezsCYRNQdBrAPByAL++qKkErOX9WlNR5FXXscE4BnycV//qBHicegroKGNg3jaAHtBaRrWiegCuubRUpklDiSRdPHTpCcRrncm8hickyml8DDQxdOyVTu8hV4ABYiJJASUrJFw+pmOXtrkP/clCxQHqYCh46pV4AMDen8fbnp5Jjtsh/fPrbrhB9I1MED186FA8tv9Re9qzncvdmYaRXOhEV6rvA8R3Szf7luffGe1KEgWgc90ANdNdMLQ8JAD2lWuxF7QYmsuLLW1SA7XqUdFb8lKyx1c46Pk5A3LPj5r4yB/+Wfzxh/9LdIp3/PIXPTde/rK74hf2/rLmpHTMZXQcV/VNDA+iVfPKWagphhUHQLKSFhABqJFnddvua+P13/69ooS0Jg2peGkdUdA83/+lB+Ldv7ZX67A5brrphti1a3fse/TRePTYERcNWpRnusbcbwHeawaj/yWbo6OvPQ794idj8tiwjEkBcnnKSf6c17wwjUoKKa4mxbkwNvGYC4gamENnQSqRn4B6gUkUUSipY285Nwu1O5paY6CtM67etCX6e/vjqoGN8XxFAYjUHVUC6ImLI6KpIYmYCZrMq5aGVuWcNOr0TdHf1SFKm6oKC1BPFdocSeEpB5k5Jus6O2JEilNjcN70wHghGkg/kYA5o/5xtIl5qtehwDTrXjen+8qiXpsUSK/T9fmuaeNrBXxzPOaabhGxJIUoNOX5DAYAkox10lT3T4w6bm0C7zgEiO4QbWpUXw1Nn4sHH30keroG4qqNO5R7osRbjcOGrvYYkFe9RZ/nvjtFNVQS8nUvHpeRf15RuBmpaGnpfUo0pX/xgy/d+dnlybj6yxXvgZJvdoMawkYlHp7558NXvGGrDVjtgW+gHvi7AHPkk3br+cmniWX8lMD8Fa+96+6O5sa91kY2KMdFCCUBAinUiJToo4Inkny4nFFJAbjxHmoBUEyatNHi4QWTQDMRg0F8TXlxtPmRqAZqnpfuMioQqIIASpPKkNxve5nYpwDDeEgdJgf0XQ6soGYAzjgeOx8ATcDb4BWArePpuGzgVkjAiwh6MjEbxxwGQnqa7Q200zIrLeJFRJebv72xQp1YNioSJOMb4/h4qaB3pBQhjU5yiCeLwVkaIoAmYCAJtD4f7/s7yeM2kJH72Ns6Hk2bF5mgmV9JI8lvGpgWkKpz15qfnjScij7kVniU8xxJpSntIsyu71THsJfc7+pqsAugr2C4VMdjbPFpoy8PME1MiV9Qn8XQADmXFwv4XqGp0G4+jIRc0lX83bKaDMAr8M50Q5/OyZgJYOi99JjL00u/uzPAeol804bMCISboTfXrF8fO3fvFnhq9Dw8/MTjcfiwHFI+J578pKmkNZLHt+HDB/Bkam7vuObGuPoZz4pWSfahqgOP2CDdCcZ5TZUGeF4PbUiawvLD7Xdar19KEykflyeF5u9ZlClBm2g/Zy7F237230qp42T0dHfG3p/5yfjAH90Xf3H/R0QVkw725ETxeOc6AJznOkT6sF72oUnNWpNU7xX43LI5/uH3/DPRI7qs7w8X220qqi3zAre/9PM/q4TK4Xj9t94Vo2Oj8f73f0AJik3RLKrH1KkhyS9qrKW5XS9JxL5v3h4N3U0x8vHHY+Re8c9RV+kRfYVoDhQW+lR/w6sWss1kTzjmRJ5EDQlFAKJbT0A6AF7RppC+v3N4vY74vIC5DIUmgfONMpS2iWN+zYYt8byd18rx3qiE4mOqCzBhr/GIoyO6fl13J9U/G9tFaWkWxa1V6izij9u7jFJMRt08EIBfomsYXRpbIlusNwxMf4AxL5x0y5Uy5Vivmp+sNT5LRA2gb8pYWS+OOAmok5/AdED7fBb5VYA5eaSMMYcnkACdxSpG+jwTWK+3y8CB9jIlRwKAv0lc9In5yfjQR3/X95umlu7Yveum2DKwXh70NtHGpNsup0a3DJ+1AuvcN9FSpyjZtM43qmNdmiRiU/vhhprFf/X9L70aCsXq42nQA4V/DjinrgmPJ/T8ou4DsmhXH6s9sNoD/6se+N8C5lp4hKvwlg9psUna4GnxeEpgvnn9+rvFIxYwBycUb6SAF5U6wUvLIWa4v3gaAbD2tiZVZUleKnYWAC+JgoDpWjbq3G2jDpk/yw7mZwpSMhjFm8iGWPCvX0sQkwA1PcZsXMnjBOi6mQKZHAkgbV95ATlQHpJZkEgygXR1xDwzdJWqsEriPJ/doACAuqJmUmgPvOs9O9uSYetqo+U85XRuUJHQq5BY4l5/Hy6swWWJGCzXszdqYMfO42PsVL7s5L0mH978cXC3AXepxmmAqdewJRwah3qT1JAsMlQurfLopR8vG1x+uLf8eY5dSB9wyo2F0xtuR6svOj/r3/msz1GB6OqQFVDlgLQnedDZFFsfOc50ikE779DB5eIKiEfOz5QZt7OchzlpIyhhr5/0TVomBlVbN2+Oraogigb1lOgOjx94XEVlLhhBrRg5NCaPVT1ce1XnprDRrquvid3XXR/Nra32pGJEAdYqYJ4c9EJ5oe88Tk99q/AZ6LIyD90P9N2y99zdYOD4hc8+FL/yy2+VHTkb69b2x6++7Zfj7e96Zxw9uV95CVNxXuoyI5fGdK5UlDHOBHDSs/CMSxtoCYbGbS94drzom1+vqrkqclNyNir5Uhcb0lr+7F9+Ms4c3S8VlG3xqU9/Oo4dO+5k4HpxnBsH2mPi0IX0mnerL67rjcEXbo9xecuHfutz2acDnbEoyphHmPsC1yVeOoaQQ1jI9ADO8axLClSZnUlt6dJ9g7wU0d/sMTfCZQ6QcSy1mJY2VcXtiqvWajwH1sVLr7nZ9JZ9J47GmeExReeURzI1YQ82VTSJumwYGBQFpDG62ttF9ZqVbaAInR0Ojpt4vkA7A8BSGChHTsnc5mnjGRfolrcc0M29pnFe1VSlrz6nuegLBHSXZFEMnVl720utAMaCLvBcUVKnvOt0xewUjoYcK9vkgHzUjQS8OfuigHRLO1FDJZCrz2bk8cZxQTJ5gyINZ0ZPxpf236/o35AKR43E2sGtccs1t4uDvy4NC/XDooyUVlFftg5KylJgneRooiejqjjME/Es0V7+sKGm7s3f/eLtV0oVbHmtrf6SPaBBQT4Z/vlaPZlM+/R8RGt75ca02lmrPbDaA3+lB/53gfkdOtJ6PT/8NApTfQVgvuZu8TL3UsXOiXfaLPCa8rcxkekY7Dq5AZki4e2IlypQlIAOEOx/YCT/nRsRG3ZVOKXQKr0JGW4BcvBUF++rQbZ7nU0+QRwbmze98no9BTjs3Qbo0YbqK1mi2/SZdG/ZS5rSdgXwFgxnjy1fBMkb9GdSX7YpecKFHZpo2L7m9FBXh69AMIgt9/40JnxY+qbINELHKU5vezjt6TcOqZLOitfUoNymhidixUpfAaYJoG2+2EhIkO6B5ZhOMLUVoDfwEgMwKs8w40X7M3HMyWgFcNNWV/EswI7xLUKYBXxnFxhcuA8yulIBduaLwWLVFtrIHCjjYqPChhJtKR3o39N4sMcYuO3kOY2FPKNLAkhTZ4+qpLr4zy6sJE8w46Nrq5dXNQ2ENMRIJMXYYjuj59C/375jR6xft8afu3RpOA4cOGQFkypPgsa7z3xN9H969TMEQZX4hth5zTWx8+o98t7KYwxAhxKEkkspzGPOcAHmX84151DVsX1cL6YKSD8ZqEOxwKj849/7ULz3/b/lz910055487/6adXtuWTDYFbAfN8X7o33/fffkxLNUKG+ZAczE1KLPY0iogZ7rt8Tt7/oZdE3uE25F0rgtGFB8asC6K2FLtqDZPoe/9Jn49zZTPgEWAPa8ZL3PueqGDtyLmbOKfFQwLztxjXR+cz10abfT777MzH2xFDUi6u9qARwR4D03fQiazwpMEYxIXvN4ZULiHcKnMujbmoL3HNmMLqh8MDQQIdTxvzF468E0K6O7tjQvzauFtf6lSoydNWajfHFw4dMZZmCaqM5Piqv+fDYmADtVAz2qDKpvMnb+7v1s1la5hOKEogaot8PXZj03GWWkjjbVOopEBkhGZsEZtounXCP1cOf/Hh0TZ6Lm5/3ohhuG4zZYgxVBlh6wFPO0MBf3wFQewqpj4lO9CoqAM0EPjj8bx4ZZSs1D6DNKJpQJyqfpWX1nTkZCVBgfM+StOL5sYvx0U9/QNc7qjEnQkIUpzmu33N7XLfrRkcISCY+de5MPPbQw7G+f1D0u/m48dqbY+uWjc4toFdnFMVQsii1h/+rktzffPfzdxzLFq0+rnQPaM2BFeCfU4SQJA30z49c6Xatnn+1B56uPfC3BuZaZAO6mG/S84gW16efRhf2lMB898aNd9e3tuwFDNWTPJlbS6JPexnxJRZPGJDRgDZhqtMJ7RHVX1BHzGgGkhPWTiCQIA8+tF6tNTvb0N6GAKcysGG/gYaiz5lW4S8l+NSbLr5BiFnn9cbmX0AkWd3TgIeXOVYFvHk5nYnFQ76M91foB7lHFk90eoYNd3mttI3zVM7QpFiQ06bNGO+6QIeT6djyDbzopwQXeW1VI/L1WnvGRZEQf3ZuQcoPLospIElfaIN3eFzfIflx0cAxDZwCxd0OGyj0u4BYdc0AVPcidIY6+L4KiQ+dUrGWNieyTUoWr6lRHk8BlAYBrgXzrDNCYHBaHOmGyaX/OJExtK2eDM/nRfEj+98wJHGsvdYJDAv/nL9pj6MceQ08MQCS4sJ1pOmTBgIHEh0KxYkaypUroXj/PbFm025zhUkYnp9VFVqUa6RFXqu/rXhDGwAfRDyqSA4tlFXQruvfddUOJXd22mg8efZcHDp0RAm7ujgwowFVMQrlqXW0pMy7jAiJ3iOVkF17dhrokxgIKHeSKN5TRto/04PuRzFg0oBaue6q8yotciuhuN/Se14nr+w7fuEd8bn7P26O8xvfeFfcfvs3x1LxdFMsaHpiJM6ceCweuP/eeOSR/crnmHQBKh5OqBYgH1jTG7uvvy627rguuno2qp+k4mFJxLIebUyXAlP6uWGwJ+75xJ/Ge/7Lb4kqQ/GefJ9oQs+zdkbTnp648OEDsSjudl2vFIuevTma1rbH9BdPxtDH9kfjGolOAK5ZBcxDr0mAOYV8KOgDjQVAriBivxyEg8IeWyVQoWTGUEVMZUCTQS3kqOe4nuK1i7ejY/JT0TldV2dDW+xZs11e81tjbEYV6hWlm1HyKwXQRiahsyjh+9JI9Mqj3i6j7XXPvFHtIYdFdBIlRo+o6NDnj56PKd1YnOitvvbaMlVJ6w7aGnQ33y+Yx7XxP37nN6L2wsnYraTTnc97cUy09fo8KxGjnPu+H3ptpCPBtyeOq3nR294sZSNJe2r+4o2fFOgGvPtWof9hLDXKW06QANoUxiBe+BpxxOdkqKB5TqbS44qYQB87dlTqQ5cuSrHngoISohDpzZuvfl5cvX2PDNhW54M88eiDceDRL0WvAPqF8fF49s3Piht3Xy1J11bTdjByRfObUx+8u7a55qff+Iytp3Pirj6uZA9o7TCLduoJxQWpRYX5XPdEmlarj9UeWO2By3ugQJG/eadogVGdQztOvO9pxhmroBWIADzj5M+dnd13y12zt6a7Pzql7wzFwlQI7zrplSZvNT2m6RFKbi4bWwJyUxoM4hJIVvmLlXeo7FvpSfN3k6/psuBQNfSKqQRscvZeVjDGqFrV+PgAbVCrUF4Qn3ReFQdJfsqG8F28qUi/Fa8s3lQdbcGAPz3u1XHxsK7A3eKt9hXzavLeAcbG/+X4XFuB4DYAKuTtY+O494ab308PPlQgvP0qTT8qUKCqlSTkdfWujZaBtd7Q52fHY0nyji1KzsMTm7ggd3t7tA12EijwqAMwEWa357h43el7ZE64dnt9RSOaHovTB/bFGhVpGZU3sUngjChDXZ3AuYqaMMbmz+vzKEJUba6MpOyc5CN7Abh4ER+nnwsSsVyjzolHtFxvDkYWMkrwnwZEqqxAA4DqVDC4O40eh69OQiwJmRh0FHVhfGbj/AOfisGdO2Ncnu62tm4r6NQsSQ1GFJMaGTi0FwoCYD2BP32SBk0aMRl/GFDxm6u2b5FcZ6uTfw8dPyUN8DMGYyTMAtCR/8zoDbkIaV4uGyWMlebb6KWhmBq/lOCsGCvuH8/pjHTke/xX/pXJn3ShysAF0AscliiVDVj9feDxgzF08Uy0iSO9V5SWz91zME4cPSjadaPpCTwpRW99+QasKmZkJnx6ttc3R2NLpyjanQLp7eLKCwhDLYMfjUe9GK40GZDZJXA8qL754HvfG7/+K3t1HoHlssad/yH1kt67bo5L9x2L+fOiiwxKeWWNSshfOxi1l6Zi9COPRoOMnkVJ/VXzwsYq81MecSIwcwLHS+huwinvVXvWCciv031GaiO1u7bE4rFTSkaRiiyRJCUyhip2SiCcimJIqORx8aQz15h/eP4F4BtOjOi2pT5Z1xtNUj9pnqmJnjVro39wfbzohqtjw7r1OowKkmkyIIM6JfrKI6cvSd2IImKKyGCbOdyS9x0SPzH1OC0vHJJazWd+99fjrte9JrY849kx3DzgWg4sUvrOI8w9jHVfPOWVlUrkB2CO15zxQgGKgkGTui7n1+i0roPA/EUeFYUqUVeQe7QXXseeHM0oRI24+UvciMoN9vTQyfjEJ98nyUgZZVo3zTJi+5oH4/nPf7UiBoNuy8FDj2jufCgWtdRn56ZjsHu9JEavj9tueG6s6elejrTJmJ2WcfIrnQ2NP/fqZ6wHCK4+rnAPCD+QFHq9nuSncXM+qicKLleiWvgV7o3V06/2wFP3wN8KmGtRYfE+U899WkhffJp16lMD85aWu+fqG/d2b94WTaq0x/aUFIzi+mObMl0gqQkAq4RsCUgMrQzkBBJIZiohW1eZNDjyHlY8TQk2q+8kOE4QU73uc/AqeA9grI1mQYoUk0OE78X77OiNNoW3adDcjEpZS98XT3AC2wRTBtimNiRYqhLtDEzcmKTb5Hmr68hLMofcLrC8Vn+eXbyaCQAcfwUQVvjxfkHfAzSX47kVagMVSkcuXYiJU4eFo+qiq39ddGzbKvChkLWA1fzEWDQo/F4vbiw9Sx+6ywwYSnKsN2WOzw9kCzEaEpi7qBHnKmCBdNOF8YsxfHB/9F+1M0algz164UI0y3vcIypAvVRMaskL4LuA0sonjzGSV5avuJvSMHIQATqRP88bqNOkh9CsGQ9WmRfVLOMa8L5ytOyw7FPmhcG7AHgxaGrMI0jDZ0EJjrNT4wLzs3Hx5BOxbsfVcqBOSr5vSNSHEHwAACAASURBVJzb9mjr7I+6NpIZ5VV3kl6OKSAHCTunC3tSCWSpryiLbmNPPzdsWBvbtuJFlrqGvLKPy3t+XgaTv1IqgVJD0fOZBFtbETl/8yGAJ6/14YMPqkjPEb9e6Z5XwDs532X8fNnFy1qO8OV/V0euU7SKIkyz8hwPrF0T733v78SP/rOfjfvu/0R6se2azfmYVWfR2G4UiO+IdRs2xlU7d8Vm8cS7+/qdLMgabpZX1QOE8VuMu8uNgx2b1poK9IH3fjDe9Y63CZjjqCsGVzGi2569w8mbkw+eFjAX0lujxNib1kXt5EyMf+ChqFFV1iWBdFOU3CG6XtNXJDEqgwIayzyJ3ALnC136vsrRx0YFFfGcr1+jLEUVRJQ2ubgl+r767pjGY0Sec+gv9qTL+IaLbsUfTyqkSyIOqKCiPOFCvlEzNRO18jQvitteIxoLhb2a65qlU78m+tdsiI1rB+K6zVtdGOz0xKIMNCWJykhDTtHGnTqBqIziIaad2DAX3eWTv/trkilsjdtf+20x3dyVNB3uSY4kVrZIOgL4PFMlpRdzzltfHOqV+qNJlBkoQi6GBAdfn0X6cEZgn6Jt3K86RfdxvQIdY3oCrXYCbBoP2DXcz+he/Tx28Xh86CO/o+/O2Ji47frnKPKxQ6Bbxbe0tgH0v/++d8bQ+FGtEbUFmhH8+YYeqdFsi+uvuimeddstzp8o95Xx+sb6vVL+edu3375ztUJltSiv4M+Sp0a18I2lGQ/r58Nav2WHvYKNWz31ag9c4R5Y3pL/Ju3QYnqdPocn+v1aQJWC3t/kq1+Pz1SQ6Uke8+vWb757Zmlhb5uSiVq6ehwmTpACqgBvJk2DfTdBc8EpxdOUKCR51f6M/zQUys9a1SPBk6FZYjgfBbBnJ695DXofjrRL7CVI43wAndnpkbgglY1FbZ49a7ZEl/SNZ+QJssdqelz0jFZtXs0GrcmNT2BZyAXZjuROpFkAGikhe7ek2mTZUMsFGswvA6FlXOlN2yASvGNSCRsmXl8SXvNaoQHwtwvbyEN7/tD+mLxwSsZDY3QKHHdv3RrzAhxzUtpATaFVUmg18lY6dgAAJ9xeOsvJjXk5+V5pb7qeEylwPpQwppUMNz+nhLjJizGlsvW9W7er7yZj5NTJaO8diNbeDQLmAkby3FOpMzu/uk5+5VoA0+ixcNwcn9IVK5EU+q7ipZfxdN5BWgornmHTlXJuVEDfwLDMnVRW14JR++f5rJLYFmRsjZw7EjNKdhvctiuaOwckeXkhzh/cJ+OiQ2XaN8hL2+8kzaQdkRwrOgIgX+evxhwDBUNDRVxzvnn+4qFsiM0C55s2iour+TemxMHHDh0T3YGkygRZRCYq4wx0ZD1+Y/QsSsUUHRNv/ciBB2LorCpgVoZczrzlR/V6Dt1ffyupF4ielpLGoqJAe67dreI/745vf8N3xIlT+5fpJZeD6jwmY5hRFOZGe3tnbNu2M1511xuiQzKDFu13zsHK+atjdHe2x2BvV1wYHo4nDh6N//8nfkSGgSRDMXCLcWEFkk390XTLxpiQCgtGY/0mAdRN3VEvgD2rQkOowcxdAJiXVQ2ApBqojJ8lngLYNdLhXpDxvNQpapXkFkNe7oACM6An38M4QkGpTQhUVU7jlIA6yancD0RXiYuir9B/JFvaK6DvHJWD94RU5pi+hV+31NUqlq7Av70HGAf6sP7mmhtF52lTHzcoetSy2CQ5xt4Y6Fpr8N4hrXTGmUJbrFv61LUVRIMhitMivjt9WQHzvNTLxpM5Vjgtjrr4fuc7nEE/bYcGVRlXrTJaoLu0i+KDNOusvksCKsXFehUtmZDRSC4ARoKjDnUWKM9+ZSx1bfc+/Kn4wsOflRrOtIRueuKld/yDWK9o3GJmesY9n/tYPPL4Xzrw1aZ+n9YxqZpcNyODbkpe9v7NsUH3h5fe8dLolnFVDLfhhw888Atf+IsP/+If//qvr3poL1vLV+pXjaWs10DhjUJFlOOCf46Ky+pjtQf+j+2BvzEw1wLapl56jp4PaeE8+DTssacE5tcImCu8urdNiXIt7fJkkfzkuz8AtADqkmDpawKQJSpYBmx4hjNxkCegND2lfBb19hqFYhPApje7ApoJ3gFDCZ7q2BDZ1Pz9fNG64pPDceHgo1Y4adPmA7BdmBGVRRsXsouNorYsqt1IoC3g6fRZ0htkeFZCzQkbMzk0YcSKhzxbX3SvL9t0cwIkd9YgzWCWrklvtsFsfsIgA0lGa5f7ePK+URxo4mwMnzgiI0KhdXmuSW5DdtFeTUnZdfUKGNDvAg+uCGh6T4LOir9efM95Tr1qiUifR2eSxw0gMTM1FmNnj8fkyPlYs1ZVE2VsTalq5NlDj0a9wEVn76ZolUe1Rjx0wu2mxBRaj68f8Opj2wft3+0ZZyr4mpPeTxEoGx+mtiQYxo3D+PHBecBJ4v2MGvBiec2YqRhijoZYplLAHOMCvrQoI7OTlxRJmIiB7Ver2ExbTIycjfOPPSAJuQ5FTAQKmzqdAJoqOFLRwOaiLdX882ioZ5C7Y4zdTyTC5rzC6GsVHWbnzh0x2N/j106duaAE0ScEkJx5p2udjwY1J1U5GVOAW5khvF9yC6aUnHnm/HHRbSjqW4AT12o0nC0CyK0k264YKp7iBdBiXE4RRdHfz3n+s+Of/+MfjTe96XvkTIYCXM1WLzy3p5p3Oe1ytlX88D6pmLzxu38g1m/ZUWg++ZllA0K/71BVUDy7+2WUYGm84y0/E4ePPyYve7M9u571+lytNLMbn70tlk6MxpxAc/06gWupqjRu7I6lYxdj7owMwTNjaZBj2BYPLdGMGs1zKC14tRfammJBAHGhT4YhwFyA38CccTxzVotEmINMxUkB82HRWaRD7smEFvpZ9S3vUWqWsBEnG1KNlsfP6P5SxhXDfo2oMvB88LADzCl00C0KTfEM5w2LROy8v+HNrtPkaZqri/72/ujr2xSDosJ0QgdSNKJZiZUNah+eZRJ04aPTh9RoyITy8ihGsg07c9gLbKf59AH96LmaVD6DdT04LtQW2pHVixVQEDAfE+WlTX02LSqO5x+3Hu5crFk9p+UpPzd8Nv70L35fxoOiBWY11YmysjV6mgZiy6ZtcUH8+Ece/ETU98ppIR8RuSbcIxYVjVhCohJt9u7eePbzXxV3vvBOV1qGSkNbhseHzo2fPfOWi0ub3vFTb7gWzZzVxxXuAc0hha7iJj3hm6F7Dv/83BVu1urpV3vgivTA3waYv1IthFv+h09Db3nu6PlkV1jmmG8Vx7ypq2tvS5+AuTxHNSTB6W1UNAA0KG4k37mAdPa0ZZm53OzxIipfyYdPDjkUggRyCSPz4cQwQIqReSI3J4UWGGvYY95zeictTyDQgDdz9Pij0ahy5A3QVuRVnJOUHt74Fm2oLQLrNQK2lAgnic7JogblxSAARNobTGJagsTkgWQ7ii8/Pf0VknJHcfEAqfSkJ5eefiDcnRrrPPhpiTlC2gXYUm1TwWuBOVUgFGibEje0RuBrcXpCVJMx4Y4Jtb0j2sQLbe8eiAVAOcmFtEY/0zZKDjg8bfdt4b27WVwbhgCAU+CkQd6wGRFk56XeUCNw27n5KhkrLTEnYHfu4GPRpA2/qU00EAFSEizt7ffYJdh2X2lzn4cb7v5iI89rgwNuLXF+13jUk0Dmf3hr0T+H/w9wlfoEmz/eR7VpjgiGNeSB9ZhKin7AXTYfAHqC2uuENDShBd/loWRsFxZm7eFfe/UtGu8u8bqHY+LIgTh15HEDrloZFvXwzZ3smWAiM2FpazpaUR9bZIysE05/6Tz6f6rJyJPpnluKXkns3XjjTSou1GG+8KEDB+LA/v1ZcIpv+bKh7ti3XxAXY5PSn/zjOPWiajSLnlHXquiH5z3zrZpfRs9l+a2AcWhIULBQ1Th7ciTOnlEegsb6ta99eTz39pfH7/73d6hNU25LVYArk0epBisalL6HbOAc0RcZfTNKGLThoT5t6+iM7/iBfxZbr7q6nDqBO23qaFNlzYGeuDQ6HqfOZm7ZJ/7og6os+jtSoGla9pg7+oPj+bZtHvf54wLIvc1RP6BEQlXxbFSXTD98KuZVUKgG0MxaAIDCjZanvFZUlhoKDJH8Kb76TKdAYnebALQA+SY5Adb0ROtAf0yeEi0FQO7iX+onJbXac66Ikly9yTlH1eWSXseDTkVRXW+N6Cx1qgK6RPKmDIClDeKu0+ck93IcwLyKH/m1nL05OQDtXufl7lQZ2AB5GUeKJ1lHvV0J0+0tXbG2e10MDG7WXFljsE6BLsZgBZyrbw2wNbcEtm0k2r3OqUtl4YLW04ueORF5jDI3SlOoXLq89vULc5L7GgmqUFQ4x6Soffc9/BklMj+g9aF+VVRsQf3EeCyNqH8Uzmtp7YyuNX0xXTcbw5dOpjOCOXNhQiowMpSUXMv97pl3vCJe+bLXZ5VT9WGDcx/q4tTJM/HZT37sxAue+9yf3dX9gnffcccVL5BXxvD/3B9av0yc6/S8Wk9+P64n/HMqia4+Vnvg/5geqO7of+0Fa8Egd3SHno9pkdz3NO2dgkSfDMxvveHWuxs6u/cSSl8Q1QIai2kU9toSFjVCFBAuqiX2/qSnVsFZbUi5WcDnLTDYFALoAJkrCL1D4AOYW+2Leg8vJ5ujk+68h+UGBXAGEFtuUN8F6NVIKm7i3Elt9K3RvXa9OMijcVLKAx36u0mV8eqlxlCHhB6bIuBbm4xVzAHKgJjiNSdBE+jCJgdYhBNe/bS3kZ0UbyEYL/dVXau8ueJJWGnGKh65z+Pp9fbPsQr/1T9Ex8CbbgUHnR+d5doFyc1pY94ioFknT9jsxGgcfvBeUU4mBHwoly4Aw6arjof/RNERe8ahKbgvMoGPCp+AZLyS9sLRn5baE/jndRH8F2VJ9a3fFoPyNs8rqaxJAOb04Yfi5JEnpP5CKXDGmItg3AD8yZm3cWIAy5gAnPEsEm1I7j6hD4k5aDdQgprHjG+teM3BSpUCC55z+o7jGM+bl5/AMJnEGXXhEACP7Nek/bglcM41hlt2XSuDokOVZM/HyYNPqLz5jPXEoU80QA0w4KJtsMcKN96KQHlNQPFiT/i8bgOfhPbCsNmDmoho27btsfvaawxMZ8RtfmTfvjhx5IjHm2gQV8RPElgrLXCDb88TXWehQdVLfaR9w/qolyHEo+At/25gXM6ZFB8dy9zjxXj8wSdi6Px5J4F+/w98l6BhbzzwxKc9j9OwcTdmxMb9lYYZxYLcAvUjuu2njkgt5eywDZ7tu/fED/7Ij3ulXk6D2bphjT2kB4+eFO86q/YeO3Awfv0Xf7bQJVg3JclY7zXt2RDzSB2eHBctRRGKdiWgrunwnF147EzMj8pEg++NQca6qvoVAKz5Xqsk0/r2lphV3yyaZy5++TrR5tb3Rbv435x/UhKQ4m4kGOdYY3rCL2c9yviIVo2xJBEN2hk8cPdRGTInpLOOXSYDYB7uOosQykuGcAToBcxLQbFc0XrgQdd16EZA1qcsaP3NfCf5tNB43NksMH6SoKn51jgrqklLX6wZ2CoKzAbJOfYIzDaLsw5dJuU08Wi7GBXzTzc5G4U6BjkB/AFFBc45IBuVlJz3KxFCvoejoypolLfi2pgSF79NlCDugRhqzOF9j38pzpw8FBdHLsalCyfsga8l6kLhJj1ufM7LJKP4RJwdPuQ1uzgsSpD6cZ7+GZ/zfebWl9wVz7zledEuh0e/EnmbdJ3v/9MPxwN/8QEbIc+8+QXx7Gfe/oQ4+T911523/I7mUU7G1ccV6wGtL24uyCtuYZrpiTY9kfqnG332ivXR6on/fvfA3xSYv0TdID5CvFeL4+laveupgfnz7ry7qaVzbyIyAcMkfXvDoNx7akPDfTWSMcjFG1wrMEh5eWub2wOqnwAye5PYGPRdbTiSzvVPUyRQ3+B9jk8IGsDj7ydYa8ADnLXrl8PybKrQCuprm2KDynLP6Dwt8k5OnD8WJ+TZTN6lNllzpoFfpSoner/GtiiBlGEEMJu6keAPj685xbS7eLi8o9okKQxyslkrFRd7PXlk+wy6vHPmxpo+1fTIO3ELag5GCjxyecW7BULqkERTBGD84lBcVFImmy6h7UyH9KmLdz77nxA0hYMM1I1mAZOc1GTbrGLq/uI6AY/ycKo/dt5wm9RL4C2PxBMPPiiP6pTOk2AWb7N97hwSugx9AN7zEUHY6elLQ6lcmZNdk2Ljazd1hI8kCAGs2hgphZL8w+OZPOhyWB8z4y8JpPFop58359dykqPaev2d3xJ1koybU9j+wU8pCVLXihoLfF28oRU1g2tObR+n/2Zf+bP84E24w1xaUmz8q9uQoJrZyuuA/Z179sT2XTttCI2MjMS+L4pHLsBs48Rjk3MmxyEpK8u0HrzZNmqksCG1k7ZNm0Qhkge9ADVPlWXvrU9u6T48348+8EiMjYyKptMUP/ajPxz7Hj4cF6ZP2Xisvudojbu98n5zyem5dZSCeaBoyYknjsSpo6J5aExe8fo3xJ3f9DpHdHi0tTTHBnlSR6V0c1Le8up7YxeH4z/9/E/ICLpkEFrxzPlOnYoN1e8ZjAUBc/qrbi3UMV25gGLd2bGYPK8Kl1JGqZFhhZG4JHoF0RCA7RJ65niuBdBDtJjoFl9bhXBUwlJPRehEZxns74uzVGnFaz4pcIyXHA88QJn5TZKm1ElqlCC6NDTh/mQOdx46HdOHzqqtMhrlnZ8R0PcDwM2TewLFjDBklsE5g61OxDvOOqA/e2UsnBSv3dVL9bc/68WWnyWJFTCfDBSrxNTosw3KDSH5tu2ibI3mNbF293WxngTcLtF8MDJtudOM6ospkZhecdYcHnGamvdC7rHmqNvozbnCb3OqmPwn7/wP8S2vell07ro1RgW/mAezcgJMTI3ERz/4X1V8SEYKhl7eTJejnPRNXXNd9G3eGmfOHIl5eRwW1TdQWmpkODQ3dck4kjrO/FT84Jt+TNGU1njrv/8xRSfOeb21ikr2ph/4/2RANklIp3Wf7h8/8W0vvvW9pSdWf1zBHtB6Z8IjNiFumPnnUGgf17ypNqor2LrVU6/2wNeuB/6XwFyLg0Xxcj0PaUF85mvXlL/zkZ8SmK/vo/Jn3d6UMsRhRIl23bzt5QSIAL5zv8qy9GASNi4ASoIh+0e98eOZA4omsHfip/6lFGImAsJfTgRYdi0DxBIGxseJB9geyqQnGPQAHAUE+lRopLOvV972+TgmabmZkaECZtno8JInKM/kK51Heymnyr8L8jQag7KCtkkFLi/n3ybvOsEvcIxry00yAR3PAu3sHczrqkAeIMAcbUcaqIZKUmjqkGzdc210Dg6Icz4Rj9x7j8FD6irnUTOZzx1cePDl+tV2CjK5bL05trQ/+8eFkZYBdLYV1Yk9L3ipzqqy3kqcfORTf2YKgPmuBq4cKz15pigZOGfkIj3nFQBMB2JVIZOmGWJwGsao4A08b8vvATY8vjpP0ZtkfvhctJ3QfAGWVZQiDaS8bnrWoF4exj0veoVARXOMSULw2Of/UgBFfFqOI0PFZgzeyWyxHy4M5dFJY4++wlOYV5mVPt3SyrhxGXgiOgnr018vLCeqx/U33hzrNiKIsCiv5EkB9IdiXIosvJ+qHHnWAqHcKel8Lx5t/U472kR/aNuySdeBEkf2w4r3Gu9qnXIopuOxLz5qjzdA72d+6t/EJ/7inhibF+KrlksxBPzdyqvra86okPuuRHTmpO29/4F9Mamy9F09PfHDP/EWHVdgUZ/ZqIqiraKVHDp22t7yipc+rXO/a+/b4uiRx5xYW3HffVHyGDfdqoTl00qQ1eDW9ctDjP52t6JsStScG1F+w8XkSKf7GmMWYKrkSWY/FjJeaTTNOwXOAcKDum1uFM98bV/UbFkXS6dEl1V7DY6pKY8nGw86D0VK+H5dp/jvI5NRI8DerPtE84HTUavvmOqjU0yISrSAEWBPOImi+p1Ko/bEc08q9xz6EqANfx2DgYbjTXYfMwFzbfla7NXW71ByUIphtvEa7TN/XpQeaaTXHJeRI034um3rYk1zfwzWb4j1AsNdAwNOHm1TLkmDqShlDuhE/M36R5XF/e0IX4LzXIs5uxa0dt/55h+MZ996S9zwwldFvYB0Gng5B4eGT8cD930qzoruNSsDfIFrhzKm47eIusbfDUqcnmyYjJklpC3135gqhkozfknec9NvdH1rNu6Jb3/jm+Ltv/ivo5G1xjl0rVs374h/+Mbvk8wkBa19t79fS/vN3/qSW/8kB2j1cSV7QHNnq85/s5540kl2uV/zY1Wf/koOyuq5v6Y98DcB5iR8btPzj7UYns5SU4n+Elstc8wH2jvvls7uXiBNghr8l5nQZ++NASkbWtJDkg6Q3tMMxy9D0gTjBnXatPB+et/AW5meVzjSiSkMk/x+JtYlbcYUAb1rqgMYju8Y6OBJnY8te26Kvq2SPVOi2P77PhlTklkzsAWsCKw5ubTsrXZ4sbHonEmNwfDIDS99kMXTX0BcAuMVT3j5SHrMfCElGRLApQ0eL3cC1jRg+J9pDWVzr/indq56bxfQfMbt0S7v4PTkaDx6z18qpCxONe0z2MzvV7ruHJKkSZ8ZrrmpEtn7vLZgoye9evZj6/vowvNeW3NH7HzWCyVTVx/Tw+fiwP2fsVeRYzhEjlZ9+oDd7nS6ZzJr1VduN+8zDvQr4+lzJRCuxeAw1SVBegVMbZDgITblAyWLHGci+UvWIXQMwedPMyApOQAS2pFTVKBLiZ6Dm3f6GuZnxmNE6idTUkKhk+o81qmUYoCCgeJ+SgPLhynzx03jqOjcOzeAuVAKH9l7X8aNuZ/WwTIg6hX/+cZbbo2ubgQRauLQ4wfi0YcesoebL9rAKZ3oaWKDlDHB6sm+4vx8pHnNQDRvVMKl+L3uEHvRGft6ecoFpL/4iD2j/QJyb33Lz8Xvvf8DMb2g4jv0kNdUzsNcUjqTrR8M5CLZ6abzNz9UEfOcxv2hAx7r7/yhH47d10geT15iaCzjAuEnlOxagXJTYtT5f/CbvxGf/+zHTedZBuYcVuduvG6zFD80dgJ0tV0tUd8jFSTRIhZEO1kYV4GfE1Jm4bptVOs7RSrQFy/PNFx1iuW46meXfqHY0BYBc2QTNynYOCpgfFpKK5WOOXQLAWzkD5dGRWEBFEM/MQ1DfGol6bYePK32TC/fWyZ65MlXgmm6oVMKUUTxBNmA+4o2xevcATEUGEsnHesnxgPUGYN2kkj1O557jieKUTRnpMaTGW11bmZUhD0zHPUAc9aoigotTlBISMbj9v5o3NAbrbUt0SnMtKF/e+zafm0Mbthkm6BaT9ZTZ2X4nlnmsKOMOcfozz/41bdEl4orvfz/uVtJs7vKnSHvPoePPhH33/MxKQWdldKTjBv1G95ujtUkYO54nNbRgu7L043zjsJRwKkGyouAt6Nuurb2wbXxzGe/Mu758/cpIVZ9TkKq2tHR1hbf8d3/JDo618mDftncWIrPLtYt/Ys33PGMT+UqW31cqR7QWDNdrtETDjqzG2BOgujTGZNcqe5aPe83eA+Ubf2pr0KLgWIAr9fzvBbA/3iaX6sxCPf6snBdYKhPOuYCUHtpu7XHC2AzDAPEAHQFZFxcx0AU3q6AQgEWKZMGHSGBq/nnxXvnMDzZo7pNVMmgBk14rAsw588KvKRqRvrSrfyRMCQ9sPrO1t03RNemzfacHrz3L+URVNETA4EcpgSNPkMCN/2rpMuS35weL7PD7SFOL2eB6dk9/FEAWgLyTJR0Gwu3PkG4UWF+3BQOX1gWqDFA00+8Y/o1lVQaYu2O7dFEhT7pcp8+KO8Wm6KBYukEHzg37KTb+OhFFzm9bUm5EbiWV5PoBps6iX4kEc7IWzatRLAWeUfxzONJnxQ9YvTiWXsV7a3lejgOT2/eovSAE0u/NwISlr38YCqBa33Xajd0m42XDM9bvxmvNG1KGyHBBBrbFIIS95biOBMqclTsqwQJ9p4DsEtRJagJ2vAZHa4Jjnezkj437tolMD4iZ+dUDF84r+TfknyJp9EDx9853p6rcOjdl5o9YGN5ak01NlDWdwBRpfoVSkFuL21JVO35QPKiQTcGjA5Cot66TRtjqxRcWqVYMi/Ad+zI8Th1Wvse6wB6MoYl/WEjMeeJDVkr92QyX7WeJmanRJ8esSHGNCHhd/j8iED0o+7nNevXxn/8hX8f73zPf1bhS3mHCyhP/F/mnC1axo/Ovuw1Wza5ZlC32Xf/g0qcnYpv+pbXxUte/m0xIHnE7q6OOClQPi4vPeu5oqwwHp/++CfifSqq04QXeXn+cUSNj2gnSwLkdRcF2ORdre8X4BO1hMTdmhFV1zxF8maJBtD5JBGyXgC0mguqjuQ5C99cfBofq16KKYt437d0qytmY0GG14ISUgMgDrCGW854AKrxUkOFATALjNfq79Zzl2Lp5JCri86uVw0GADMPPgvA5rvQngDgPKDXFOpXSB/cwBpAnnyS7F++59ChnubC6UlCDN53klg5pq1gvgNg10cujEbt4+AgRkm9pc/Nq1ppXLNZbS5biNcL9lpNtM03xsaeLYpebI81gxsVQOiMDtFfzEMv4+dbLfOj3E9PHN0fX/jIf4+X3fWPonXdtlxzeoyrjsPRo4fjs//j99NBgVoQEQR02aUsUwfFR3UBbNzr+EhAzrZo3kIRpLoqxoAiECTrNrWzXuHkQ1PUU6eot+1RF9/1Hd+rRNKu2LFR1+QFV+aZm7n00ZrF+n/1+pfe9EC+ufq4Uj2gdYxqC97zbaUNypiPB3Ufgeqy+ljtgb8XPVDuqk99LVoEVUGhezTxDz/Nr9iQRc8nAfPOhtq762vq9xqYASDKnmRagIF5qS1ogM6z0BZ4j83bexGAMY/uRLly0waMNOoDJIbytiqmGQAAIABJREFUWagC1kkGMHMeZ0tm+Na+eHsw02PEbd8eRwNdJMYkaSZvE1XwlqTaceHoIQHcmSxdbz309CYXfFy8qQVj2+tUAUFOXDxR6eBLULZ83hVfrmBZgmSdGxCJNjPgi8St/JKAH+BWoeZUzsBoAbhmWL/4RG081CBHplLyjaJmzIjHOykeLSHqRh17Tu+r4Lk9tmi5+x8eeY4tlRK3kSsDj+kzV992Z7RIh9oee48HvFGFpcXtHVeSGMC3pbNH59R3BNTPKImxXTKDJMc2CizXyjNIWw3M4KV6HFFkQAEGQFoUZ8o4Mj4n9n9JAFtAqAJsgAwMrxINQe4Qug1j1ySe6tYde8Rd1SYuTrhTAEwPSGPIvp3KW60jLpD8JiC2tDgjerH6Rc8G6Uw3Kqm3QeB2RpVMZ4eUGEklS3mYOWCTuMOMy7IfH5oKVAG3UP93aEZzDkDkhVnoMumc9DzxfMZIZO4k1k1YVOY90SBruTD2OtcWFSjasH69qcvTU9PyVB4XjUCVQGmFPmu1GfRe7LkvwN8oPxce5/M60PwYnRiOMcmA0spzx8/G0ccP+1q27dgSP/0TPxO/9p53yrMpcFSAufsLw6p4VwGVcJMxIMrlPQks1QhYHdq3Py6IR777huvje/7pvxaoWucLfPyoqm16CNLYtiHNGMvg+E9v+THTxjLJdMWDWyfOfP3mflUAlRdfbWiQNGEtvG+oS1L6mJjQT5Ofif7YKspCQwBzKQ4hiwgwr5EHt6Gt3YWJGnt6o13H7e5W0qH46kKTyvscjQuiLk2Nq8qq5D+lI5KUEwHKBNV6TsBDh+6iBMbhyVgalFdduRt+vwLMAHtbkOp0yyXmnPNPwD00FCxSG0h8jxuNQDk8d0B6Wd/+Ph51X4t+d+hHn8WbjmXEsQVsax9VnxZDv13VTae3DiofRoaEEqbtleBzcNU5RjGsUICpV2J5W3tXdNR3xqauDXHVlutjy46rXIiIyEflOLBppzFtVD/mJSblZXT0YnzsI38Q40Nn9J4SiQHkavOMADuyqOu2XB1HDkqPQJ/nu6yzWRm+tTJWHGFTRADqIjkIdfKaN0DN0bmdZA4dhluM3n/dK18Vu29+rjzmMiA8BxOYL68ZunFp6f3q8B9/w0tueSQn5erjSvWA1jRhPvjnSuawpsBDeu5f5Z9fqRFZPe9Xswf+V8D8ZTqZYrHxB5rw6bp7+j6+IjBXUZ69yaVIHrD3MP70zbcAbYMYXi8gBrBRvMGVrjJeTCd7ejfJ0tIGcgb5qe9boRQ8twskbRmgFVpLBQT0Ct4d6CkwtPkOnpxt190adciuyVN+/vATLjc9p9B2PTKJAs3kaVLiukbKI0kP4XU95a2zagKeXI6rTdKSZQYPJTnR+wzgB9pAgmB7QA3suB4AHNcAwNT1WJMvERee/XSyC+xal7sAOj6qv+dQvlDyaltnl6qUtsS81FjOH3si2roHhQH0nlRmUMWhmqVLmnsTFgdUoPqwuPSA31RBYThq4sYXKqUBoMDrGDH6OS9QWyNAMaFS3Ui9NQ+sNR6YFriZvHBWxXladf2qLok2sxrbpCJDLm+uazB1SId2RkAxYuwNBrDpOS5d9JMP3q8EUoEgjS9SfVw376O/bJBbIDKGGcoi3T2qsnn9rSrrLl4qZdkFqDP3wNAVM8l/Q7GhzwCGqNSw6Y+ODUtzHWWTDgNeKr/OKp9gZmw0utZudPIabWhSpID+MFDA82fDsZBlwFPgMnca/bTSSot6uMw5Hswc68TPSY9hRJOvng/Ah6MKmhvwr3ds2Rhr+qmSWxMjo2PxhCqITpOwyNz3YaFuVJGcEm0pYKyKrHDOeR305Omj8dij+5S8N2yAfMszbojv+c4fjN9+729hbuVa8rCv/LTRZmOY81WtTKC98jlpsx88IjWe49HZ0xU/90vvVHXIQYFeAd/hleh2BcoZ11mB3bf++D+PCenIU4jJEa9yTDzdTdduiZlTwwLYMjJ721WsStKKatfE4wKl7T0xLU3zGnlp8fzbaPL6Aphr7KHHCKDXtEgXXZVuZSlGrSoNd6lEfK+AeWd7e/RJyQa6DBR15gNrY1zJjROSAB0fO685PhmT83qK6z+tfjcwxuON5xrg60lZ1qVBOKBc50+uVD4B9q4yWuYFP0C6xUmwhDQjoH7588ViMzDPeeYJYe65nlBsWA8HVEBMiat1uv8MdLfGhdt3xWyNgPgZRQAwKrSeJYqe5+aeY+O+gH7aiVdf7eQe2jxVH5ta18fW7deoqut20fJbo6uz28CbcwOiM+nejY+HHrxHipIzysUYivMnjsa6rbs19o/oPjmiPIJZ1UkYUJ+NRl+vlHA0AYcU7eHscyhIef3mva2mkZ80RRERvY+hySoFmF+1eVv89M/+XOw7eEYKLqk49CS6k+1QG6jyLyz9t8XGhje/4YU3Hi4dvfrjCvWAxmiTTo2CCwkCyCoir3j8CjVn9bSrPfBV6YGvCMw14dEsf42eBzTR7/2qnO1re5CnBObr+9bcLe7pXnvCHYoHSBcwaqCWjbKXWOAKmgKgtlYeJzTD+d6sNjJ+AnrrVYFTvMOkRujGjszXxVNHDVySwwyVQaBcv8+jXGBQlKov3Nj5Dw/lWvGLTceQWsCUwGajqA2dg7rHCLzOLkzHyOkT2sy1ueNM0+ZcQxluPHGc13teuYaiClIBFs4C3Ed3PZVXsk0Jp5KnXRURysBy0krs6TX6LlzzMlb5rQTmRUDRKA5YxgZ66cxJh4ZRZWlVxUrxBAy4h09IvlDgeFwKLQBTeMz1CvHbO0t79J0ZgZLD+x7Vr5mo6v6RsXITwLy0NYsc6VwyUlCCmNDxOnrFZZa3OWkA0zEtD+SsqoJ2DPTpWDqKuMyt3UroF8CqES3GHncd2kWiAGL8TtIvmuLi8k6MXoizB/fLcz1uY8pyjvrcLBxg90ghHRH5KHOkW5Unt13/LCWVSZVEig4YQM4LpKfBTzY24JWjXy6grT6YVyQB7+TEyIXo33GtKBMq9w5KwwDTHJgavWTqB8oWhOmb5Gm05jtkFR3UuRA2oGxBpiFg7z9n1cmNrqtlUAxPc8GLIVaOkfo46S1e/rwNyORK816HwOXObUpGFqDk6s+K031UnmjPaU+JAqSZXcaLGLisk5w49HuuM1Vs1Xw4sP/hePzA/rjxpmvjrm/5B/HHf/aBnHuXAXLnAZQiNx5/QJX59sUscrI0r6VBOXz6XBx8eL8Nir2/8Zuxcf3WOHT8jLBs0UWnmcUYTppaxH99+9vjSw9+WsYdhYZSm9xGrvq8WdSMeemL0z8kCzavUf/LQB0/dEae1rYYOSMpQxt2WDncLwCgWm2AY43XkuZBrQB6I3Sujg5VGpanuK8v2hRh6dBa7sV45B7hfjEkLPeDVDBZLwODqM64qsMekSrTwSceVnGnQwKlwhtwv530qPmCLQ+4pmiX+NFuC95wzXt73xkD5o1AdMXhzmEhckD0hqTtBKY2TtUPPG2oIOFY+irVW2zBRw0Gy+lh5YLWR78qo87culN1kZT8KhWZJNjDV0fqEYBfDAgAOgYF8xKAz7Py0E+IzoODYf3m6JidiLZRJe6Ko777qpslI3qNQLrmD8f0vJSg9akj8cC9fx7njh22EU/FX94nIrZ1982SUzwd27btiee/6OXx3j98d1w4ctBrm4cpcRq/OVHsuHejTtTie0NS87hfom/+m7/yznjo2Pnokka6v5eWwfIj/8zXNK8URFv6z0t1jT/1hjtv0k1w9XGlekBjwRTZo+f1ekK/pTDRvbpv6Ia7+ljtgW+8HvjrgDlWKEL/H9EEl3zC0/7xlMD8OXe+WnKJzXvNF07oZ7BqFIXXkI27wEJQhW+7hbZiHGf1ggrWZpKnO43PaGOYFy3hhDTHx0flETS9ID/vm3ryYDKcnndzdyJQecOuG6NbVRknLp52UlxLx9ro2bjFYfEF/T02LCUEbSzNVBQUn3ZRIeFmeYTs0QaYuHH8mnSHyhNsrMVr9pDlmD0JqlV7DYaKW1Vdf7no6pUKMJWDpFGR12ewo98ol33hxAkV/ZmMNdt2i/stEIfXWoAXXXbUM+goCsR0qyJnYwd6yKBXJCbFtRYwf0xyfe4aF8oBcDXEDXcoUGPns14rSZmL89MxqfD/jML8fVt2CwBRYVRXpoJG0wK0c/Kc1wmoNDd2KHl2Ilr7JVVX+mrZy+sQfnoPGZ85AIlA8bQ82KdVeXVaHm0MBlNPqn4xvz69w0i1mV+tZ4+8dFtveo4MOCUJ2mtJVVM80ki6AVIZbjznekIFEiCfn5Hqh0A/QL2hO4shAbQWNd70IXQdCiXRB3NKYIQaBLDBmLEcoMezjLX/5iQJsvlJmzMKzxy5zNjy/E3zLP+fx/FM5nIA+cxZv88jYwycrr+3O7bLg56FeebjuAqznDh9NvMwORRf5HRVPM3ym8mNhz5UV+YMp53SfDh1+njs3nN93PvAX0avEiO99viMKSsJ1K1pj5Y1wAlPJ8ZH4RzbmHDholqN20Tsu/dLlj/8qbe+VTSZ6+LYqfPLYNxXWdZcUpuUzfeJP4/3/f5vCEend7Y6B81v3b3ZntVFKaPUie/d1NVupZS5c/LMCrCPjXCMAjoLzxxDHqPZVBMZojUyrOsEwBugtAiMd3b1yHneJq95bwxKQQbjni5DQYgIzziRCN9/apQn2illEPjvqCrOiQmyIJA+FedUvGto6GgMj5yO0RloYqLAcK+qaCdcIxQVRjCzLuU/1DwqxXySMpKA3d1RALkrBht847RAg1zrD0++5iMcbgzXRXPhVZTonM555mJ06Do7d4vyoyjAsLzqE/DT0dmv0XoU11s8tjwJk8cgvXjOeY220U+EbaSiIikVfVaGkADzgiIdzPUG8f+bFX3rX+hThc/dsWHHzuiWnnqHDJ1zUmf57J9/UIm/Mr50T6zWaJ3WC5VM63W8//s7flg5G7Px397+bz3XF+U1J/qEk2J+QRQySdF2KKpRJ+OB+5JnufoAOt6bvvN7Y2Db1aoVJQeIlwk5Jumw+DKMvjyv9PqMzvJrdQtN/+5bv/nG1UqV5e5yJX5oLStMGjfqeVU5/yH9fGCVf34lRmP1nH+XHvjrgDlJn1Oa1B/6u5zg6/jdrwDMX3t3c1urVFlyV8oLxmuezhtjC/4u73n/Z+8F4AKwnEi47M9N3jjOMgAjXlCBqVP7vhDjl4a0fxE6BTgAmBOUVx7ECiRw+AaBuG3S4W4WkJ1WOfYJVffrXbNZ0nNKQIOLLXA4JWWTeVEb6lVEBwDcIO40HlSA+DK9wZSUpBLYqPDugUccb1MCsGzFkx9+rTJCaCPtNTKrPk0HVJ713P5KL/lAmCcubMTGrY1vSjSMdtFW6rThEdqHNz56UaoYAhVN8vQ1iddJZBxJszSLSEiTsoM28UfuuzcBo/s6DY0b73xFAnMDCAZJnmeBhSXxWan62NDRa+oAlJF5AZv5SSUbwjEVGIJ3OqGQd5uAc+o4l0GGa04VzjLOcFhdPAnPvYD8sELkI0oinccIgm5ggyDbUFEuGtS2ennaGgUC+uXp61XUo64ZAAQfXMmqGvPkYVc9xnDIW67xg6uPxw5u67z6rKatR8cS857qoABThernoQkJnLQoMjIvbmwT3lD4y5WRsDyZygStDADGqphZxexcGXAAMqNnsI4zM9eB53UZ1TRcMqJgnK33nUPqNeAhi43r1sWmTWscDYI+cFjFe4aGLuXnyvjl4sLjClhN4wTAY8Cvg7lPObb6/ItfvE8RlkYZcwJnAMcqsZE2CdDRX2mEJmjN9YmWPBMjgTlj/tCn74/t27fHN7/yFbH7pudJv1yVMi9DUZd7zPn9xBNH41f+w0/64tLLX37qvK1b14vC0ikFlgtK3GyTRntzNEsJheTI4SPihU9rbTKRbYkAZrMYlOe8gLar82q85uWNbxeQ7F2zNnZIM37Pts2xprsr+qEm6XxZpp76QosxDg2MaYg8ojja0Czg1lOufkrzcFLG+ZSAMZe0IGAJbh/Tujl26vE4evJAnB09r3kl7zOSiUgeam65eigUNUWo4LwTASRyk/cIBtqLy7SVOue/5H2R/oC/7eii+zupJ7VK/pxX1GBevO429Vvn9WsjlCR7SZrtF7kH9YlFMMUcTmMnVMnW9JYSfbETpBpfGS3RDDsSkC5jok2g/sjZQp3Ryy06BuowT+CY0DhftSGaFP5rH62J7ZuvU8XfbfHIAx+Tga6EVF0Xa4n5U69+w4D91rt/RNS0yfjkn/y26h0sxJRogazbkRFF7jRvmnUvWqvzb73uqnj4MVHFnf+RfPMbrr4h/sE/+m4ZbZ3+bM67vH9W99DL55bvhWWuyXBUuGDpl1RQ662vu+PmVU/tl+05X88/NSaEPG7TUxPVqV/79HzkG4CO+/XsptVzPY174CmBuSa2sqjixXqiF7r/adz+y5v21MD8m157d2Nzx17rVxRudUEqCXKRT6QqnranFDUsgNR3YjanwlC2F2gZyiRYZPOBuyqP67EDD0vOa8ThcYNc+JSXweLMY0zpwI6O/th43bV2Ji1oQ4Ve0qjS2C2dnfZs4VGdFTCfEaBrEqWA/Q2+boM2fCg3lnL0yCWdpaoQaVjNhgpeZ9/V35UOQrE32H4LiCsJqQVYpfoMB8hIQgIXzswmXnVtgrk8Mpee1UdnAZzozKhtXA+esmltnKSW4smqk3ExJ6DZ2K6EOh8Bag8V/ADmn0+ajzW7cZw2xfUqo11L/5pzgo2A/rs22fFRn7lR9JF6wBCyaXWSSJsYNwZvFvBfoGKmVC6adS68sJkfkK02EDf/O5M0Ld+m1xbmJ0SFmRLIHxMgnhClZU6h8nFt/lNqtxLJ5NlsFsBplcRho3IAUJ5pkRevobPPXk8oA3hNly06d1HZ0V2QBi+8SstLVQZqwYiqGNbIu9c+sE7AQsAd76S86YsCXgsyZrr6VaipoTOaxbtdcC6CepeuWDamctCq8U4/eOZOAMATCKeiTKpeJODmMyT80gcwb+vxIjMJS96EE0Uz0cJAepkEJYCzoNca5PHctnlzrBUFi/dGx8alF37MhqVTUDwnmS/Qb2gMHHGOU5KM6fuqNoBeH9d4Ts7KAzyHbGK22eozUEtsECUwqkA4tJYsGJTAnHM8/sCjcfttz4jBtWvjqlteIKMJ0YZ8LIMmjuXnotRvhuMdb/tJnXs48zzK3DBVTaounfKaT5xSlU7NndaBLlNaGPOLjxyNiTmZgkjwuZ1lHRaP+YLmI3kUzJN2cct7163XOA7Gho3rVWtIdBYZkoPim+OVBoTn4CVNbkJrA7BOYak25UgYqOt/U8wL5j4UHq5bX4FelbKDcpIrGfqCIm7nLpyKoUvHVexyUsmSKNKMiPUiTzwKJAW41gqQYsw6MVRthjpTp+M7udl9XWgdet2RRaJaGBA6T+NF5UacVhIwc2inFJEEnusePRFD6p9heOWKKixR/Oiw+m2GmxrTgGRWtNbzXmguPMnNAHMbEpKjXqPfh/T7YTmaHW3UgwRSJCBPCNwzr6QFjxZ5XBxLA1iVVakGXK8EC5SRLILrtZDSnL39m2Ny9JzXm+eT+pek7XklsM7q3tQhZZYzBw7FN736VfHQE/tk6IjSpGRRAHqvDKd/8s9/TFEwFVWivzyJchcoM9vzO6fMytZ5OViX8aliAEv/fqmu7T++4Y5rV0vJL6/Gr/8vGpcNOiuRf4C6DCd7z498/VuyesbVHvjb9cBXAuZYm7v0fL8msuL73xCPrwDMXydg3iyPed5lrTFtkA34SOhhtsqyJzGvteJ/rhBgeDVpA74xg7QBl7pRL8iTu6RNbkbVBi+ePSXgNWR+dZNC000GPvlVvDr1TXBPOwSyke2St0ybBZ7SeikK4H1ND4085gKG2PpOajQ61Xe1aWfyZobD/dMtqh6XeQEvb2sZ5eqaisJjeqgrxL7sZVyRYbwcxLvv/NlC91Gb5mWYzIwMi2Iyomqlqp6ojZMQc4O4tmyMM+J9i3Cua5cagoBsu8Ay0pSAOKgFCwKjj3z2s2VkcPKxzdbHdS9+uU0Om0R45tW2aSV6AWyRSoM+0i7FC4DnrMLnE2dPC8g2CkitsR54e5eKnkilhYRZl+p22xOEV/PAphigEcBLsRgkEwHGGEq6LrzbsowSBMobjhRhrca0geRS1DcErGsa8dBLz9lUljKHfDVJCPHEIjIgz+iCklfnAEwTSu4T17zZlVK3a+yJOkh7Wcl/dSqO4qklr2xTR58+I1ACSDWHuFBq7EHOQcurwchwCaNq1hqiVwubzy7zjPkuQExoC0+3KTfqgDRL00tqMON/HE7HrjyqPm9eY6sMox3bt0Q3yjl67cLQUBw9dsqJyl4fgCR7XTOxOVnZ2aLUA3H2Yzpu1T9D5w7FpfEL0Wg99QJ5CkjnL+gi5CGwftJjniAOAH9JhXueceMtcebs2bj1jldGXx9OsmKgFo/4CkAX2JWx9Ru/+NY4cfxxgTIlchZAaMqMxnXgxt0xLvDOy819HVEvUI7U5diR0zEVjTE1xP4Oz38FmNcJIDZAX1G/kPjZoEhYh/ItulQsbEAGwyYZMv2dHdGDUgtJ3FZYEijXuLsCqwxJvOREI9pVubRKhJ7U+wD0yuuvJHbRr7j2HCPuAamjvxTtqn45JGrPnL4zIa732eHjqnx6PI4c2xeXRiW5iIa5ja7sYL7bqPtNg5K15eV1DkTShHiS5M3CSHWpBhU5qj8m0E1bNskD/7zrov2TX4yLjS0xBZBWP5JoOS/jFnWamNaXmAokRhPxwRhw6AVVG31G69iecZ7n1Z/irisRwcaQufRQXobGo0aKNPldLAJdcQdSlHoyOCoeVOPcH/HD4dJrFjfUahxcPMoTQF8loqHXdYypIXnM6WMdauzs+XiFIiz3PvZQgvtihLRobN70Q/8ixuYaYtfmjZ5H1Vzy3OV+4Tm1/I7n9+WfW55rWhYanJ9vm+/55Ve8YueqlN9yL319f9F4cONBXe4GPaG6qJiA9c81oVcfqz3w9OyBrwTM71Jzp7+BaCz07lcA5njM2+QxT8hQfSw9zoAHHFcJZbJyYnm9ANv8XgXo7JfRK0XNweCCBE+BKw6Ndwsvrl4zXxqOp71R6YUmRJ+etgSK8DsmRYFZUAJorarOtYoOUiuAOSfP17SURgAgzfI2O3TfMRiNbfLgIZlnfWwAVaovuM1l88pdNzfgiuBQ7IJikBQ7gSS2ypPsryef0teLwVJ5zr0ZYbmUMxnN6+xcqzbjSXnrUERo7RSHvEtAUq9DX5gYPqPukJKKwC7qMw0KH7d2iyMPYPPmJkqHkr723XNPAZoA8+RTXweVhfEowIDTzyjpc0LSadCHmiSV2NY3EFMC1IvSEF8UIFhSn80JUE9eGo/eTduECegrwAi8Iw9ZSeYq1B06qFxW5VVflDFhz6TAMkA9E+Lg5wIOMSgShANklPTlRF08j5YjLNeFtxieuaGXsQ0gVACLSILUVyYEkqbUXmQKaxabokWc2slJXYPa3q1rwmghEbhBhgWeejzaLh7kQazMsBVzLGlWnCfBSw5TaY/BOw+kNFdWQOURr2goFVUrv58rIOFGAkBeSixSzssU0L8eeYB3bN0koC6vo/rtpPjnpwSUXd2xtJXIB+nIGJvW5EeFhvms1+dtLC3E8NEDcezh+wQS26J560bNI9RomP46KwAYKoZAmKktvpzSGh1vUFGFHhmFn7/33njRa/+v2LZdaTGXvZ8fz8/b+6zz/f67fy2+eP+nDMwv95izXl/x7XfFZz71OSsNNcu7Cp0F7jNgvU76+WePnM9+oI9J/CRJV4Cc+VGriBbgHG55q+Zol4pt9fT3xzqpxQwqsbOvQ950POJqD7SeiioyNi3DjMiN2tctUF9V9p1VW6uqmYwE3vZJGT++B3kMkiGCZHmzEivHpoo3v7pe/ZzTMUclW3n27LE4M3wqLqoU/bBUaZCznFSkyQmwzGmUncT/btBxUIHiPkU7uZ9Bd2m+II+12tDUJ+PoWXuiRrrm4+cVFdO5Z6HpSId/WH02Qn9R/ZT7BPQWFoGOaaGWrqaY1f2M7y7pmuWlUMElAXIZq8iempNeAXF5y0PcfihO7im1qVaykZigBuZV9dSq6irfZbrIgG2kxgARDF1Dvc7NvJlTbgoymQtSlsFDvqZXhdD+J3vvAWDnVV0L7+m9j2bUu2TJvdsYjDEuYGxTEiDkwcOQ8kgCaeTRHgZMACcPh8dT8uj1J0CoptjGYDA2xsbdsmzJ6n00Gml6nzv1rbX2PvdeySJ/khcJK5lrX80t3/2+075z1t5n7bURCEqDpIwceczFbOM/f9vbbf/glD3vzLP8dovxI+PIFw2NmcTS8dsiDCWOMU0riVaoOYfanR/ubSj8/FvOPz9Svfp5Zx8nrgXQZ+QEEpzT4cju24MnPei0tGcfsy3wnGqBZwFzDGBIa9hL8NyIQbvhOVXaf74wvwaYv+oGLJbrUgZPeco5lwbgEHUktol9SnV/ZNJt4cLCdc51m5Ovkn8JLjhJOy2Dnl2CLXETufBq7c6eRWcUPAiAJOCG3wz3dYn2UQYlgKqWBTaDhZ6e5EnoWlPsYGq0F57icQBRcNDJm+Y2tM4RkmgCYXibbA61UbxhwGtwiT0FSXBcCMIjS2T2cL3w1d7XdS7+pD4EOIu2SWhWbYZ6jwEsjyLwtRBgldzjUnrLcewYNMFrQQ2gF20cmshN4NCXIiAtQT4FRk4M28YHHxD4S9KURfBOn3Hltd5+4us7gGZA2hioJjMI1hzq7baa5oXKzNl/YLfkJSvB6S0trsQuRZ2VwztPWoFrYhNU42Tc/o+FVQGlfJ2ArP7yOtz94ALtSUxkgHE7X01DgA9POf8SyHAxF4Dxfk4P34NxYomMG50D3j0GfwJ8M6AMvJ74AAAgAElEQVRuAnUYR6BpBUAl6THDyGjYd3AvVHnmw9OPoNAS7JwAoHBr3rcpUl97H/k4coDgXe9wmmM8AeiUJdblP72+pKf4OCRdy4dJNmOsvgvTFeUuwnu2gKc+9Qu6xg/euh6jjiGYmo+sn0sWLkSz0As8AfWWDjvU3eUeePzHvmRLeKA1d6ho2AYlAO3Ss3uz7d/ypBu2eC665GqbKEYbMQGRjDUAKoL9GKOiWURfnn/GmTACh+zb3/6Ovfz1b7Jzz3tBXl+k8eytkjzPv/jJT+zO7/1/kihNHnOnmZn95bv+UsG8fbj/Tjv9dKkJjYB6cduPfmaPb9gCdZohN8JpqJHXDA9tKf+KYx47KjQwIB1aB+WeGoDzecg42YRdsnm4HyrhYSYVhQ+2fRk8yn1QFhpHO7D/6sALJ02L5aERkZGhSO8vwCWOmQgaixu4NGYLrBZKKSO4x0g38rkqNyGwzgTYySAmEB3HGORODZNBHTq0x3bv2Ww7D+6ANCYSIBHl8+fkn8OIKEIbFaLMmgXw+VRjua3ArsMoaGNdvYNWT7nSeXNtLlSkBtFXbWzEldi16APgbgNFZRmVmmDEboZwSQPoW0NDVoNrHxzmmPa9Ggjeg5eO3TUquPDJXUZ4xO1gj+ZI3cPwipcvbEV7oJ40xKUew69QKO0GxMTFBuB9g6D56hYEjVYV2NKJCms7cBj5FEBpgVwk5+oy3F8eDjRjVei3KQWCmr3q+t+y1lWnY5djPvqKDtYY/hq78QjDJzvQ4pjU6j5lcd3wERtjbDc+/2BB/4Vffe1rmTp69vGbaAHcDwx0Ir2FWyLsh814EuvM9slvokNmr3nMFjgWMD8bR0LL7aRRY0kVOyYwv/hqUlkqpMriqCKgtwCVv3Z44wFRiX+cAsPoTdVrebicz6jAUW0x++/kaQ9pL8myiVCet8VJUBMtnQBF4E0FajF4MQN1l2nQVRgQOgEKCJUHqrH9TTXEQqgUVMIbzeDKJCenAE9c3YFzdvkISJ62XBMwiSYSSMs2g8ARQb5rFhAD+va81h1xhumt1dKihS9/sLiUGf4H2CRgHodHm0FWTPzT1wmgebhdQYx12NIvQRBjMQD7NMELs0jKWCCVBRxzeMxJrfBysZ0gl3jlNaKg8Pwu5+YBapRBHKcaA6QFq7FwFqKMQ937retAu6hB9c1zASagPw1VBXmaJb0HkOlSJXpOB386P+hP1w7KhgA8RwHHggLAhHTwW/e+S3JT9BIOgsRRDkV79bn3iu+q+PjQjgtTnwOQEBgxWG0cnk8qdzCNfAZUoAwMnEpQV4qh0T7DLJIK8mV/BNhK55Q8Zu4y6oZ4L265ujpAuNqUBoWDKh8m/kIORgJ79TXpPtwZSNKLbrz6wPIB4ztK9LzzeHq9Y0yLfkRsVGRLFy6weXObdZ5hBAru2r0X+txDWUCT1YXhuJHUnWelPLxjox3c8jTew9jFR8teeL1iLkam+qBaAgUYtDWVcjwOAgCV3nO8osf7yhe+0J5+4im780d32qXXXIsg0N9JRfZyq/3ygfm07dy8wz6/7iYF8srbmYAWjr/+Fdfaf/mvb7QnH30c6jGrrRl0lGJcZz1kGX/xi1/YJgQq7m1HmQjkqVtOeUsay6RE4FmMe5R0p/Ia3yFivEATgrqb4VWm6ko9g11lJNHYcKOfdaMMJXnmdRwT5FLH/JFhYiocQ2A+yjEk/OllpvFVBiBbj+RFPUOgXalrXLEp6YB7F2YhpfpeO2McvmkHIvp4ACC7txsedQSkH4KkZw/oVd3Y4elHDE0GnPUZZPwsXQn9cYDcQyjLEOpZBjrKBO7zVQf2Wg92eDqwA1RSPWGZTk5cAM+gnxQwKBXe9EbsbpVwNwqvuzNIPMbYHhaEsobI4CtPOKhD6lzWlRlHkQVVvQ41lcoFLc7Pp5EOY4ZB2p7kCe1BlC0DnIORGVgrrHEJKMZNRfb6c663i+avsq2IA7p/468wXsAtxxidCBpQHe45SityaK9dtdbe8mdvt86uIWuGkZ//yB9HR3yhJo42zhtPbn85QM/u2sxMb8H99v7fuerC72BsHtkxR5909v1xawH0RwtOzgRF7GRsz9iT6I9dx+2CsyeebYF/RQscC5i/kvMgBumt/4rzPBcOPSYwvwDAvArAnIsTIcQkF8UAopoV5REnZHAQxkA1gg4FvwlgOyUEBAWBGqelcHV0wCUoQwBAIKd9zCAPaPHTKhqgPDW1g2VN2ToUv8GiN8kgQ3A2iwjMsfB0b9sADWkk3QDQnQYwKMV3ytApeoafwM0Kl0vkecSmJrAmHAsPj0NDX7CTVjnB/JS8ooK7UT8/p6gGXLT1G7YB68AyO3jPBVPGmsLigwIyxa1oro3Yzp8AP34I4LwaabiLWW4slMUI6pTnVJ4+b5dJBP5teuAhlUCNwfrhv7OuvM5jUPGR2NPJW4WFmN6+GSzsVTg3azaMrfmRvh7EuSFAE2CIgVv0XHIfmp7yafHwPUmPe2nRZtoJ0JIZuycsT/RJ9KPGgrgopCUR4Ee2ULY56StRD0+AgysQqOt4H0VKOqX+EYdGkolUq1GqcdI4YNAUg4NbgvMwUco4jA0GrCaVF1exkJ/ZASYNQwJoguwENMNgTPsyPpxy44tnEKAu8sRAtPIEFjQmnass8B9IP5mo3hJ+O4mKorYjvncDzfvRjQ9HwfBq8/7Cd+UApiuWLAbNBf2A/7q7e20PMoiOwaCio93jG0iRCHoYNPsPbdtkHQDntFlYtxWXvgIUH8hegnpQyF2GyU7rRFBjBuoobbsP2jCCRlm8VStX2pVXXG4P/vIBW//YY8jceK694Q/engXmSqKUAkmjzei9HIFyyy03/jkAPgN7cwGgrPWZZ51hN37wA7bxiSdt8bIl1gJQzcQ35NB//jOftYYVp9qPfvZzjRxRWWhsAhyS3iTZPnLNmWQIKkrlAHYN8JZXAaDPA6VlLqQnCczZTsXw6pK+4sXCDhMMNYLzGgYW00stDjvGBjjjokvhuDHmM+BvUeZR7KJxLmis5L0FD/8IaMwynpkAC/Oczu3A/9c90jWcOuP9p56X4cXdC+zyYPxP4Dkw1mf79m4HDabdDm7fYrvgYGTAtIHCVtRcbys791gf+q8LSi2VSDEw2I7dsWp4p5e0ikteAC977fotOM+oVcEAG58ssrFi8sU5jADCCcwpHUlwzZgN7ooMY8wcgsAJjWt4wEtwHY1oZvfE/TTOOtMpQmBO2UbWVVrpSNiGebQFNKvyZfU23jZon/4jyCfi+y2ju+xdn7rFaoZw7v4MlJoKrII7HrzP0L5lCB7+0he+Yo9s3G5L5lIDIQyZaMS0A3H0wnkEaI92TDs0ccupL3Scrx9PYu6+8XdfetHJonr26wfSSfwN+mMFik9nJKPGEewg/vms7OVJ3Kf/EYp+xPyCQcro5evxPFmSCuX3wbGB+RWvuKGqsnqdFpwAIIQE9La6QgSBteCLXivoMLaE5dklkJdqhQOwtKEuoB+AnDO+stXhFORcCrQLybiHWkBIYI3vHeTyEwWd8vrkMTP9NgBlMTxOowDpg+27lMqa3l9qI9Mzx5TzorHgSQCrNNMCSg6SeC6uTyIcBFCKlVYgVIt0eHTc/881T65T/VaDITSw9RlXMufkBCBneT0rZgIUXl0s4OSqAjAXA1RQr3p8sN8qsTgWMVU5ATcVNfI8dOKmAsBv+tV9Ab4FAwWUzrniOtBUtCJGj/EaNHwgOUiAC1BXCaoAkd4guOyjAwg+ha55aWU1FtZKm4AnlMGavmtBQ4Dgi+DUwTP7wX3cjlpSGKU+wXEaFdpZST3u4FgLqxz5bA8qj3C8uAebIJA7DxBU9LOm6wkvoL8BMAlGZWqQXw+gSvlLgtUMgOYk6C2loLUUU35RajIeSyAHt9RNwniQ4aULqB6JoiUsoIU/djZwYv/Mxx0TyvAUGtsaBtHfGt+k5DhQ9/2CMMxQO7VbGElZKpDAeHhm2Rrp/pFNgPOBg1XXUGvkn1fA08nDDx7uFLglp1nBqIzFUCDjpB3Y/IR17tgmA2wSXvQVl74S46YWBqnratcjT8ihvbus5exT7c4f/AjKIzQCp+3SF15qixctstt+eDvyCPRb09xWe+t7blYQoHP+c2AzHzjR6/qZW262/fu2KFgwn86yEF7/D34UwaE7d0GrvtGWwsgoAzAfhIf2/e+60c689DL76q23aw+cGWDpJScwT7KJZeg/3gOl8CKXgWte1wBFFoDyZjxb4DVvQLIhapXzvmMZOWc4AIeXGVSwKoD6ahi3BNvFMExGQL2oxJwwBqN0lHEKaN9SjO0JUq3QrnORhbMHGuvsD/YcAx6ZYEljNOsUSPerBo6PefYfN1M4W8jQ8qUgCzyjL9WOPC6MsVJ47qfQR/uRp6Dt8H7rLpqw3Z09UGdBUjQkkZpsBb++pdQGDoAGU4w+OWstjFA4HpCNtWD90whMRc4GJvaaKLAR7BDCAnP1lk7E4okwjyfaGpW1AnLMqSrD8YhxVN7a5LQatht029leEzhWI5Yec06o3AVBn5bBYz53JYKrcYnuwjFb98q/skUIuJ4un7Z3fP9/IeHVLlFaSkYnrQrBqlUA6OXw4NNg+su3/RXiV0psMQJ3E5hOzg/Nez6RZg1k3eF+YLYNs8doTvGYgtwjfu8Tx2Mwuv/yv7z88vvzDph9eQJbAP1DH8bp8eSV2/CkIt2sqs4J7IfZS+XNz/mNgQHKwAgqsvwCg5KD82R6HBOYXwxgXlZZuS4HZxyCui/Tveie0TI0njmR0oHLY3z+DB6xM2zjI/8b3nE5QHxKdjDp+E/gSr+QV97PxQQz8jrqCvyJe9qnIC9WTI8bgOwIlEYGOtqghQxVF/BVp8lnxoJTTM8kqQNKuEI5QdcZdiqDAyQH+6k8BCdugKTyOdXBYbxzjt1j6K/jc54jOC8JzHIJd06zvtSRXmUHs0pjz6yZ4MiPgatKD3Al5NGopMGsimw9p5Tw4Q00OdZvGx8Ax5webJ2WIABUFgBzb02nYKgt2bRMxgNgzsC8GqRIn4IneAQa6syYyXYqRRBgIZU2KNEo4ONZUNOuQqJ5JLjvMNT72XnXqU7uGU71I2gREIs+dQAbdJYoNxvevbMAGaTQBI/d5QJZbnrJ4fFkW+FahdyGZ4IhvB8HhWAGgKUEYK6QwE5A1z1/7BWVm/2s/wjSA7DrvRuXqe95Phlr/En8mG2rXRB6XvV5GHKUxkPFXKYw4Yow9nhkMk5YRxXCQYaPa6J1ii56WWQOxC6Bhk4Ef85rbbHFkAxkEB7jBPYiM2dHB4QRmCWUSiAAyW3PPGRdu3d52+Fky59/PYBYgzKcUnu+prBb2XWvedMbrGfjE7a5f9J+fOdP7GUveSmcrGN2B2gspMSUoO//+H1/Az43YjFQTgYxJupYPmgiiLrr1u/bvT/9tnjmybPJY2ugnHLzx25B3MeYMu6uWrXSGiDRNw7gd9P7b7aFK5fa93/2AIAy4gYIbkO/nL8lnaWUkqa4h0tB36rE/fvSKy6zx7bvQ4wF6CyIKWjCudYumodATGaZjRmIBhPjTRCUyDHUgHgJZqekCsskAHgt6B3jaIduZsvEo5z0JyapQhtXw2gYgd636skywHtMb7nfag6+JYOp//x+dUPKd67CjNN5kwKMT0y+K5Jv4PCeIvXKgb+Ph6pKBnaXWj/aq6MX2WH7d9mu4XZ74Ol2lL/LGs8/E9KUyOwJql7m8Q0Y4xjzfZDI7AdPnTtb+C34MNC9BIuA8ymSOhm46/KYdwKYKykY6lAGxZoFcxSDQ2rMDHYMptEenHdGqegC5SOVm9QWAnMoBi1YuULfVZxaZ9e3vsCuPPVC0aW66nvtv33og4ph4TzK+7oY7V9B5s3QjL38qlfa6lPPRiZSBLPjlMlw8+bL7Vilzx14877U0bmYpTjWk1uFsybOoXNpso5+KCy4G0nk3v37v/uKx7z1Zx8nugXQj0haYOfguUQdabYVz6dwD3iK4NnHbAucoBaIKdivhoHJyCkOym9gMJ5swRDHBOYXAJhXVoLKQggj72EAzPCoiSsreJaDa1y85EUXYPOFjA8tb0QogU05IbtOOD6QKgq9KFwgmPEweZbd25yuIi+8FsqghiipDwEKpcSoiFCMbe1RGwLHvAoeN8qZ0TtLjxwThbhcokNM9+CyPO4hc4PAYbkvnHrpoE7ldq+6wygHfclE8c/9IaAmvnnsD6j+LHdcl8AyLfXuQnLuJznCACqjvV1K/FGBzJXi8TKNfTJS+Mvwzk6M9tnGh34F1QdP5kFQMoXjzrnq+jACvO04RfLKBCkEYJNIxlNWWQ/O+iQW+C7w24ehH12D9d13F6apxJAWPCZYZx9rY4Bc9YDnjjuj/qn/WQd2bhgD0Y5RfV/45SH30VIogIy2j7HiIEds7XQVvGIbMlAW2/ekJcjCoCEGjjkACZt0gqosqFMJdd4pm0lvvIqZvP48q48hdWjsuvDHImEJkxFkRHAmh6MP07yxp872nYKokDNvHJxxPOr+SOOdXHa6c/mIJEXZJFAx6vlbjmcp4fG+CmBOvCEFFnwhigs8oYsWzLf581vVLqPgn+/ZtR8KIciWi3Zp2/QoUqhv0+4Bky2tpMccRpZiHmbGrbrgkPVD7eWq33+jTYPSUlxD9ZoiUSlu+8Ft9sD9MO4IOFHp3/7Dt9npp57n/c+xTH382BVKoIrAfPOGjfbVz34U9xtpSsm77DSQD37kQ9aITLW9hw/bylWrQGdpkn74t779QyT2OWCPPLPTegfAnaexQ2UegkVSp0hnYQZK9Ku07uG1rahrRMZe8MybG621qclqoVpSDa94CvCMQajpgx5xgmNym8sALhmzwV6sALe7HOXaD8m/TCReYlxLA0Bthjr4mEMI5PmZPLcywtxgCydudGUC5RwvTmHK2Z8OOLOGTJoLWC/2c/zV8dG2vFAVaCp0cvP7PvDc57SgrOWF1t43atugcT8E3L0HfbZ33y7reuZxA45X0HA7soiOUnMeVDe4/wHW4TEfACAnjYXZRvnsG4YBi1245hpkYIXUJPuJzDC0B/nuRd3IGwGDNsPMuQwW5URBrzsziCI+Z+maU3CaKSjFTNvFC9fYWy59lWpVVFFgf33Hp209xoAMFY57tDv7oBZ92FRYY+euuMBeeRVkW2Ns8HdHc8yPBdLTbqmODcDOfqBBIM34kKUUkI9zJtAe1KPb8M17//TNb3g6umD2zwluAfQDRPnFPwcpyyh1+RSe23Fv5BbJE1ym2cv952qBo4H5ySiTmHrsmMBcHvMKqLLQmySvL7XHE9B2/qCDWgeigt/6LHGEhd70ufshHZImdcIsvBUu5z8EdVwUCdg4+ToHPHnb3ePoUCgtmgoyZApygA0C8wx0iEcRhFUJL3ARngL60j9OHsCgVugcDrEFvAMsp0DXgHHePrHVHY7wbD28VgDUWqh1ijgXaxx0CNWe64zDd3nXw7jgD/ipQDMNFSyMw1C0IH+2Ct5H7gIopTwaTNoiMmq8jccyvbb1QcglxjavMhQSmINjLvCrRTOAJ346LWA+AwoMvGDwxk/D1UVgPgGgx6DZUihFSCkjaCx+ndS3VK2gfzfJQrqXOO1cuPeQfedK21kPKz/LQ+Z+TuetU/GG44D0EH84LcCDfxOI9oV/Gjsi9JgXcXEmmMZr6OsrSDUDGkYBqC6sUwE8rp6enn1M41AuT9+fcMvLdxdYRHrl5QXnNXz8eR3gow8PN1+LniWwxrL5ORxy+7j0U3PshpqMih4mnIY/fw/gQv687hH5yT19Pd4VyYiTFYtrCOJHRlBSe/z8LFslPNpLliyyZsgs8lp9SMi1e9sO2/7Efda5d4e3OcbNihcAQIGjzfu1AMGC1fSYI8D36j94o5V2HbDJpkXWiPT2LUjgQ8D3w+/fZvf8/D7o5o/ZRQgcfsl1r3UjVnV2YHkElQXgqKuj0z710fcpTXsydBMo/f23/KG98EUvsh2bNtmaU9daK7zdHKLbYEx851vftp2HekDlgGIIQT/qVEIKGlV0SDdDLAV3B4pgJDLZEJV3pNACUN4Mrvn8pgZQrosBtsv9fg4AXV1aBFyKDLSQESwD2K8CxaMExng5VFKYIbQS52yorbQtbT0yJij3XcPfZJzmxLqSe57hPBITS6qPv09zHscsDXzGmPiozddyV1/F77183EHxeYc7MRphMSXyrLxmVYXPcYMjE4gtQJKf+mIbAlDu7QZVBDkHfABMo2wZZOBss42bHrO7n34csoTI2As6lyqzb6+MmqmuHnjR4UknMEeCNT5KwFsHFIdXG5fG/T8FUD4Jr3kROOgFoMgQ2I6MMMcBLXgUjrrmkK1chiRunNcOQyGqZflC+8jVv6/xxce24T324S//b1zGsVai/VDLnIHMtejHt1z1Zps/d6EnQNPM546XmL31OwVza7qgUcTG5Jzs16ChpL/sE971NHR5j3ENYOKxuLdonLIPOD+Ehjyn828VTBfd+J63vxU3xuzjN9ECGBPLcF3yzyknhiAIewT3AXSMZx+zLXB8WyAhCk5M2EO0V+C5FYPvZNxOEybBk/CDyIYKgcX0mFdUVAKYh69Uk6i7E5X+hF49/MxVJuRj9NMIACXQLjTp8Yn8GyBd/HPB1zCk+TOAFxeko2fIgYuf0wGTEJS89nwZE762tDlpU4UNiyu2fYe6DgLYknMMegO5rKSwcKEUYPMFUwuqAJWDTIF/ndM56FneMA9RQVxmzg0TLydLH5osWnzI/VZLEWTxdwG83bPG80cLaZGO2skT5Lt95NsO90DrGWUrJ7higBePxCmVDzIAIF+Oj/bb5gd/GWQM77RC8INPg1yir3buMdfOBMEtaSBMbY8Askp4yAnMx6hoMjQImcE6AHMMYXotudDrDBEYy34iWM32hXu02WYJsjik9TZSIHCs8VmArfM5jHVjC+1GapHc+RwbAQDZXryWvI/4SuOMNB8yfcCb5QJOBRhSEZgFEQ9yzCF0buUA5pSnozKNvNEcpxH4J5+2quU7OfLMqazcHfDPs371AOkCEyqDj9+A7TIoNBaphuMtnR3HMrqy0b8Oytkz05BLSR55XY8gHS5u7uYUE2wQAHPMRItSbZstLhsJxwrYi8qJmEAEQEr/HB5lxgtseugee+iuH2Pcgy9MYP7CVyoD7FDPIYCVCZs3p9SGOg7btf/t96xupssGDYGU8+dZLag/e/bu0lgbgfzknT/+me072GWvedPbAK7gyVaWXAb+et8mDyf/jkAt5lO3fNB6Qb+gMZwPZi+8+EJ7x/94jz39yCO2dPkygDOo/QBgDgEg/81ffwSSnE123+NPuiEEz3aRgDkMwtA1J8BUvAOMavLMa+sboUtfbbUA6a31kEUF6KYUH73mvKFYRnK3SZ05jNTx1QD0NaB8zAXt5eylLfbLTfsEcCtBWznUP6xxWw2JxCq8pxpLMekbHAE4D7nnMRvFeM4BbX7P+SvtyKgbef3skf7C5wjcPaLN+XvNPzK8/OikgV+Ca1cjU+fgIFSl8H1FVaE11hVDlQf66QOTiDFA8Dd+QulHZritYl4GvB+A6ko31F7WP/Ok/fix+2xoP6hMlJ4EKB+FwpO44gTm9CxjEIHJYiUaxjQ6Ub5K3CcsO73mSNCUwThhsrbEU2dMziLQkMrQD0OUbK2csb+4/A020+vgmHSyPYNt9syeTaACIXUUHAgVaOMaUMnqoAjUUN6ENq5xL7eMHW8bgeu4Z5L3mxWXRr7oKmHocO1QAG5QW/hezziXdrj4HcqN8+s+pNOI3/M9vkdW0qmB4dGvNMxZcNM//v0H9x3VTbNvT0ALoM94c1Gl7lQ8iSmoS0/+OYH67GO2BY5LC2TnZAzA5bjC8/C8D4Nu/3G52vE9qWOmYwBzAMR13D4lIHF0xnuNoCL5v/mZ/9x9hvKrCrFwUZEShuZjX+gVKEXPCRcGLEzaPtbEmnByeh9epgRmhZLoOUlgHgkwAmDJm8rFD+cbx0IximyK1OYuwLY49awJMpiSXEXX9VkD917qIcPBU7AXMy07gJAAdnzueDggWIBjLb5oEzZJokmoAcX7iPag11+o3D3jHicjZJgui5fu8XG9ZABz8L65uHArv7gIW9X8pevseQepPWYsM9KDzJ8PKN28vkMdCfQY/DnJ67ILYoRKOpsLKtppGlSfMnjHp3HO0ZEBy0CGrQp8XhoxM/CWlaAMXLwLEVxGj1ax2gKv8a88uFJY8cWQF1Afh5ebfFPuIAh+Z3cuHb57a7umj++wZFvBx4JwsHuno0b4wL1jPOUU6UosBek4qEc5EkbNgKqRgbZzAYE5tOzpgWUbkCsr04nAxK0iBflmPfsqO4vlhpWkLwOQ+zj2hxMWiLU9nsLVZNJuDdso7RlwK59jmUOGXkDyE+IkjkX0OzfH6I0OepbOG7VV/xeh76jxTw6+jy/vRByP4Dopy5BLjnrNaUFw5YJ5AN37rPvgftu1eZPt3L7Vll54nSQHh/sPg8qQsdGhXquCwfXyP36T6juFJE6rly0TLWD/fnhag7cjry3GwqhRLhNtKclJ7uJ4K4g+gPoLRKH9v4AMoPuR3IigOh+Y14FK8rmvfMnWIyttI+QOV69eAe55Hagm0/ahmz5sp194kX3x699B2CrqBhDOliC4525RATNdoqxV8JJTZrGMsokYmxVQEapDUpt6vK5HoqFayipSajEruYk8O1AlIYisBUWlEkbbQqiQXLRirt35xG4lAKJ3egTcat7jTVXwGmOgpYRDDPokVSppc6d65tN00jhSMDbHU8x3aVcjfa8xlu557Qq5U0BTD8eUYimCFoMPmXlzAm3DPi4tB+8dSjHYxMKO2LjVwctfCjDeC1oKb7FyHEuJxwEEd3I6Ghobtq9843O2Z8N69QnpXOSyguAAACAASURBVGPIupvBPVNcg3gbBEXTo16MsVQmGl/s5MBjTkO1gLEAAwDeVGuixzkCQDmXzF+0wGqgqkNOfB9GxTWnXGo//8I3QXuBAUhniDzVVJ7xuV4FDACtuVU3kXvA3YjxOvpo9jksu4BmP/G7T9+km1D3gO9uxqTjN1T6Xsen2dHvJd27aPdi7jgUFI2j2p+bLi7766FDO2cVQ2JaOpF/MN7pYSL/nDiJ3bUdzw0Yj9D6nH3MtsC/bwvkA/OLcWpKB337JB1sxwTmpLIgo+A694JG4hSCMc1/TpWQx1zuYQ/G4oJBz1+ibExS4YJgJDvRBtAIj3o4kXIzrRYPTsLIggmA4z6smGwFogj/yUH311wkmbWSLIpybNNOAJiP9EDXGtu8RQj80ha5FkdXAnHJPwdXOnMspILdYR2oVgH6taiEX9rLSoqALxLSMI/1IjWgn5vOAX5HgyAYzlENt0OEQr081BmPRYve/JGuDlwC2/XwjBYxQyb5yoKZ4dON84yOdMNj/isZEtqh4MKLbfzTX3SNRrnKzbqxj/AbwA5pF09mkFCougkJQxD4Ba8bF9oK7i4AzBTjelK8QKvS8evWkgPqKHXCiQ4+VO4AsqoPy5kWZfm6A5A4W5yN5VrsTmWJkaCllV55r6PvZDh9iZ1EYyyUa1LSJAYJwzvIuo3DY14IYF4CoE4wJ1oSvKlp2XdxHJbVjQg2H/EHbR1tq9PTxut5VTSGfWz5B85XT2XTgFH/ed6l2EXBQUXsR6B7Amg3LnI0Cdad4yCbTInAPR3Da6Ev+DsfFCwEKUj0uoJ2kXU3+ldsn2koagg44/o10yPW1AQaD+6BYWSB7Jkss+4eADmcaxrZYccGDtlqcL3Pu+IFNt7ZYRWQsVu+ZBk00gfsEDLkaieGfR73J++3zMQMEk+WYcyAMpLKpBHAorln89avfNmeePQeKbOkhzzsAMAf/QfQHAaGxQ1es3Y1vN11Crj85Cc/b8tPO80+9YWv2RipVQxu5m/wlwBf8RQA55SNpH4/PedUEBKdpaHRCPobkVG0Gl5z6rAzO6X48Cj/KIB5H7JxZhBvsBRe+kWNtTavtsrW7+9SW5HOpmRD6Lh5oHe09wyJv89uoHFC+hjHhcO8vEcC0ZonEh0u4U6nY8l08S2yNFVlaUApmRHvoeQx14jS+Y74CYetVVe5x3wSuyGk3dRUw8gCgJ7ge1yDtJwhZO5UKfH7rTs3261f+xyy4kI2FG1c09JqIwjorm9qQZuMKvnWJIB3cRWypnLnBRSeIgD+DMc3KSDYYZzAk6pQ2eh3zKN1oDs141zayUCZnr/0PLv3S1+1g7t3anz6XRBjQqMtZ9CqaGFQ+jH+vb+Kf7OWeUygQV3JnTfvCqld09yZd20vgZ/bDYFc/7lh7oYR7lXwdQo+MZ4Z/hscCM7P7ONEtwD6hpqd5J8jwtwIyhkLQJbBUTfdiS7Z7PX+I7VAmg04GVAmEWtMwe0naQVZFz6fRWWRKotUMlhDwdfwe/qEOBnIWl5ZNUIiLQimCwhzDg59gCyQ9WlUP/DjCGjVou5Vd6aJo2dJ4MWES/AsUBfztugNSgEPXyQW93F4hDPIblmGtOxl4KIyLbVzUZPH1IG5h0yGR5X4M3jmuqAK4p4tIjYHcDlPmDdVWmxiTtFi5WojovEEnzg3HnwxS8tN8rKLUkHuJtsIlRoGMC+G15eScfQKCmhyEedv08KE8w/DY77lYQR/olxJBpIe9tMvvyra2q/MqxahjeShZPZDpLavQPAnDaYJJOaZgJexDB7JIiQKodyZgDnqED5xccBFZ/CuiOXXh36WHx6KLJ5Eh9djg8a2NYExWzC0zN2QcaDPI+jx126Mzp0WaXq8AqRrUMGsYLKYAOb01jF9O9U4RpEivQTAvRTAnGnRpeoi44t0EafhiB7D88cYllHBJmedPPpSID+Vwp1zDjS0M8Kxg3MJcKtubpSSH06wkwW27CocpIBSNT4NyIirkNfUr1EIw8011d3YEi3KNxpEC2Mad1qcDhxpNHDMQ3e++xAAK/T5Mc4LwJuSsxIBfqUwCJbObwANAllbsRvSi8DQ9Y9vtEGkeh/r3G1rL36+nfvi51v5wS1Wuup8ZdPsRID0MHYbeE0l3ooOZgAlg0hF7UBdMtMVqA9AXYzRhHseue+X9sNvfc6BuRo2wCb+/slf/KmdecZZ1tG231afssrmQKFjHHX4wQ9/okygdz+4wfZ3dCimgVx75RiQprlzzSvQt8W4d0vhIa9ELoKmBcjqi+MaauExB9iuJQeddBbt7Lhi0QRkA3sHBqwf1KzTly+x0xcvsDYok4wAcJJrPgyJQRo6ZWi3Ghh1XUi+Q085Pem8zwl8J2JXgOdN8TOeKdjBexr9R8BpAXcNAb/fOGUIdPsz6ZyzHxOtJYdDYglJ4xLnqK4CtWUIqjXRnpVIgJRhYCv43LxOBYA5efO6VtyRT+/cag/+/HbbtmmD7rWGuQtsGNxw8veHkKyMakwlMHLGkSWZc2XdwhXWf2gvxhGMMLTNBMA6jZJpSEySDlIIYF4G46cRuSAI0C+av9xWLFprd37zm/b4vXfrzj0WlEroyu+o1CC5WJsjAHTc8emzLLVPc6cbO96evx6z5fj/0Y66m2KO5XnitzQWferUejSIhvw45GY/hk9mKRU+bE/oA/2yGBdkBlEquVBWkfSWk03J7oS22ezF/uUt4Guv8xNeh+ceDK4H/uU/f04dmTDjs4B5RXnlOufTOhdYG43yKPpC4RuVBGkEGD4xCgwRaHOSTNrecknykZ1y0Xg8HpMmt+0JsLUIOkhScpu4Bk/EXwumOEbUAuKeTlwHniLqFhMojiD4cxqAkx7UMmzpSyM5ueXj/G5/uH+WxVddVLY0rWsZjYWPn3OBZeBRgCuVgV5eZ8S7ckwiPqTfkuvIa+R7hnnVIL9EG6oNCDhxzkmcZwQcc0o7loOvWQCvIIGdvHLh6eeCyFYbGeqyHY8gwRCBAL3lLEFxhZ3x4qs9sFGl9n5j28m7i0WZuwvlUO2gP3scig8T2N6vwgJcADDEwE8G0RJkTIvb7ImUuGMQPZPdaVB7KCoyFk7xOLxNPPNp8pyHNrkjci2O0uLmW1U72jA8k2mEODhm+YOCw4CvSPxCjjk5+BwDo/SYo27FMGQKoNMMUgSuER7pAFVu2HhEQPLtcQcoO5b1KjzkGhlulKlXZaTQe83Cs07uy8+CeWUG9b73cet/WVeCvRlwfRkvUQwaAo0ejRuN+VTT5HX363Io+I6TNxepL5OQAC2CAsfEcB8MKBhslLUEGCdvXYF+DICGcUIFkhUrl0GGDxlQ0R8H29pt61NP2lxw0s++5GyrHdpv5UvOsab6emsDjYVa1qSqqC40hlFu0peYVZPglLxfguZptOcoPPGZaXrHHfC07ztgn/m792PMpKmD49Db7bpXXGf/9U1vts1PrgcwXw1lFmhgY1z96uEn7Ee332blLYvs3oceEaeZiYWKqJ0PWgu95fRsU/aUWUCLwTMvx85XGQB6DQBiLbzoDVAMIY+ceuYM8CRHPMGyrn6QLuA5rwXHfBl2BqTChDqsbKmxp/Z3o6xl1lJbjnqDV48n60xdc9Ix6DFnvQWydW+6vZFoJ84Z94yjCTTr3hYAd6NEM4XGmrcFP2LfJ6+5juH5YyZMv/GR5n1QAUL4MIJYdTb8U4pxM07lFU1PGA04r+I0yRWnYYmPx9CP//hPX7CtTz4sPjo1/YtwPzNx2SRjMPBQvyIOIWtho86UhxTvG/cWg3/VXjBaSmH8UJ6zETry3DNpBSXpfe/9gP2fT3zK7v7m15zWFHX4dX+83XwH1XcPY4bNB9qaH73eMmLjkWbho899LJCu0/m2VraNvFU4h/l109Pv/qBmzcz0gIrz0cnx0b/Hoa6lOfs4YS0Q/PM1uCA10DmxkGb0KPoKWbFmH7Mt8G9vAc00GGCUB3opnkxLu+nffrrf6C/T6vosYF6JzJ8ESfTYFRGshTeSwItTnCddIUiIxSlm7OQTTR5zd08GRUFX43sCNG26+yqo5YkJhyBhhlfhRAwDIHwrBA8BGN0bCi1reISKpXKBRQy8yykENZJvWcoFnh49LrL63tGgL51CiXiqFmr8NMmLF6kFNgEplcqhm8rJuhMAOkD3j5xS4nJ6Xk8pj+gIB1vBVPZrxe+kqY7F1JMdFVg/AldLELzH4DfuAPiiT/oMm4ueVV90+ge7bPfjD7kqCw4S+CuttlNf+GJ3+Ac1Q54tPEmNII+UXmZ64xE2ZRO9h7BYZ0T7KYDHnCCJSic8Xi0iTzmumfWYB/iQ5ymZHN51WRAjd1cs3FI+ccPCbQ+nDsQutwCKejzRfaJ9fajkGT5QZVG2S3HxnSJSiAA+qrSMwgtIg6MMwZ/kLEMMXp7yfHUderZnCl0BIsg2sXR7W8rYCcCUGw3eH8k4EGjhuzAgaBCqFwlG47csM3GOgjjx/TCyqpK/Lyjms4WPPe1MuE1D4KsG0niJI3S4CDAab5NIOsWgXXq2S8C75uk5miX0KcMU1Aa2GY1bXH8O5AWXLV0IUAdqDz4bhvpOy9I5Nnao3VaceQGoIJW2a/cO1cVBI64TGt4s9xSBPkEogWAAS47PDMb40Fgx9qBLsTM1YR//wDsAhAcFQvMf551/rr3zvTfa9o1P2Tx4uxcvWoj7sNSe3rLTbrn5Zrvw6mvt1h/9BG0Hj7U46qg4ZfqotgJgXkbZRHhsCS5BpbMaBIxWwlteAypLPQJB60DzqoLRXU7NfZSb2T6ZyIhGJ6kso2OIioC3eCV4+ORqL5tTbfu6hq0byidL5jQgcDIDKo2PJ/6Wuupsi0lqc6MiJeBlu7EeWuYB7tjIZOBozATQ1GuODe3i+X2fQDn/ageJnv3wwvttFZOkD78YG2n2izGiW2/G5jaUW0fPiK6xqLkKMuUZJBoK7fVUDpzva7fCm33fT3CfoC6oV8Oi5TbYB8MbtJYixNpM4j6ZAtiWUyVUoHxEkiKD+opn7rs/FTBsJqHeVA/60CT6mYHGH/2ft9gP7/6Fff1jf8uAj2x3Cyyn3cZ80H3EiEhzrV8x137RDnGf6ZvsP0GN+TXnTOA9fe1n1aR0xMONHnVSzPv+NWlWKtXMTAfa4GbQeT6Dt7Oc5yOb77i/Q/tDRsjOwnNlXGwX/q7HOKXU4uxjtgX+1S3gS62npSXH/F4MpgP/6rM8N36QkOqzqSz0mHMKKwJ9QIu2L8K+lemKESlVOz2HxVhkpVYQQIReZgWP6jfconfgl1xSPq9zQhWccW4mAQ/Pw8N0FZ9cHSe6h1VtL7UKfMuFlYsiTk2gOQLPGXmp5KGSuElAQ8eeMK0AVgKVIlM4QFJgnHdGKo+7dR3huoHhi5CkHFUHh3HJS+akF9aT4IuvCQZ5DgJ251En37wWSNaDgVTi7ZDuU2hjPVC6oMQjgQkMC51b1+apPAslAdMQvN07H33IMV08KsrrbPVll6s+gdflOeWP6S2aQYAbvc5lVQ0A5uM2Du88F+tyqF/MAOiUANSyfjpWfFrvY75Il0nBuryAADvrJqQdbaeP0uLLvo5dieR1x/fuaXeQnIwgN1viHHGsb5m7h5aqFK7cgFZinZj1kJ7O4X5wzBH4BnoOVT5Ee0I9fHw6v17FU2W8H/iBukjd49Qmh2Hhu1RAJD4hAHZ+avb3AlWxw6E+pLGEkymTLK5Ak00jdGbChg91WE1jK+6RYNsnI4fHAEhKNx6XYpwAi0sjV1x0tbmDP94zPlJYd+rKI/280D8TMeFHApigPjBIlu3kCF334IL54FovXght7zJbAKDehfK0gn9NusoBSOz5vReKRbjeJJNQpUBkjl4cwJ0ocnO0Y4DyKN083ncNzthXPvt5BJw+JTpL8mayzIsh6/i+D3/IeqEGUwEFkEUA5pXY4ejuH7J3vf2ddt7lL7bb77kfQYfoSxgpVch0uvaCc6wZIJ75B4rRLnyWwJNOkF6BsUkAXYUndcwrGARJiUWUnQGgwmMoF2krO9sO2Y4Dh6wR9/8LVi8Ezxz3EY47DEDb3j9mC5rqbfdhaN+jftwVoAEypl0H7haw3Wgj+HjWnCPPt3tdpzw6NDvQE2WFvZNe81oEuuneSaBc48aHoIPj7D2Su3+zs10euNR9oZNNw6iohKzimPWBg57dxcJ39PZ/9Ztfsc1PPQzO+JgSB5EWVAdKyxiMQ0LQMdCgpqhsxGvTmMM94x58D/BlW4wz6RCNXLR3DXYmKNeq8uKfl7zkJbZ07Rn29U/8HfIaYeyi3RmszDolnj+D70kbceqh10u7eRpjMevKix67DjGm3OSNdmET+ZQVy4Tf/94/HOs0fj33A40QBoJzB20cdZtAsDP58hPYQaAiEZOpjaJO4zDOGKhK497vrdj5VXemPp3ZhyH01xMTY1/mXZXfK7Ovj38LoI/hcbDz8ZyLJ2XKIJRvmzFGfbGffcy2wL+wBTR7Y0BxMJ2C5/cxiIb/hb99rh2meZHzKJ5HyCWCa7guHKeaKbVdzS1C4RtfwDjx57yeQWeICQ8b4QI9jsWCBEBwxraLiwomx+JTADUQAbQAQ/K9ivLiv5Z3M6EtAXNcn6os9PDhhxkEfxq8RKVQ6SjGtmwRFn6pdOj8/tSkr8k/ByqzHlp51Pnwf11pxrfLc/iTFXC6gQcxOuAWGCSg5V+xWEJZQ7/NIsS4rp+dHk9yevkQzgI3tADty2DMQvF3vewqgTMpdN4BqG7sfuwRb9FY88tKG+yUyy6LkuNjcZPTjgYXY5yAIBbeZQaDZnqYzCgDDxkCZQF6lCKdbYOy0kjIeeqdysM2C5Mo6sz6RmOqxaIf5WklfiWxJJRP0mLIhkmLdnRJ8kK7v9LHiQNrr6s8wzC+uB2vs3Ecom8JLpggiVSWMgA/cpYZUCjV99QJBPYaewTY7mn0nQ9K2CVVHQfkibPKsqsLw4DgH3Lh6YlXn0WDJ+qKdn1wkOqq4FYGq07ZcOcBKFss0r3B8gjI4OQC8vKwehu7nr4LSWqsy3jF5wQ57DP2o6rEMhMzeGKcrEQpgDLbhuBcQas4jes6E1gX2/MuXGvnnHd2FhBlQPdoa9+nHiPv2ncDfOufgJ6GSGovSpBmaVqqPhsfbYi237F1h33+M1+0QdCh0oPtS1D3kb/7KGg8k5DkHLRTEABaDx3yYQQtvued77XW5cvtoae22iDiG4oBAi9++dW2eOVaxTi4tCm851RdQf1L0Z8EgnxWwVBlgHc5ykQKCq9FI3YyZPQGhzJ275PPyHBhW77motNt5dwG1alrCEHhCGqdLigFMGdwrPO1h1F2Ggje/5rP5YV3cO2APM0HGv9BE3MGUEDKmANEd0HbUMs7+xucmeA8yTLS2HHeeTgwYszHVBq3k/+aHVkKw0hcelywHFa5JDQBukepwc55QdSWGbv1rh/Ywe52BHSP2LYnwDXHdRh3UQU6yiAM8FHsxJFrniQLWVlPDAQ6D3af2B7jkMGcAm2G15q/eBHockOg1MHbDmBL4+it73iX9XX22OrFy9DGbvyJ8sUx6zdV9v5wA97fp7lUdkC0qdrOJ5ssCE9HZ8dSthWiNWKXKndeP3syctJrp6FxvuN9MoE1Ydg6Du62bvDtuzva7SBoXEzS1d8HAw1g3bXRXbYRZ9uO2nxganz8G1H47NiefXH8WwB9Nx9XOQ9PbjUST9F7vvf4X3n2Cv9RWkCzJwbSFfjTjMHzzZO4Ygm1HgXMr7+hrKxyHTfNi5lMgqCCCW/k8QkvkSZB90CSk5ycDfTsuhc8Iaw0T9OD4nCXYGYGBzrOds+0e4c9oNFpMs5bd+CbFjV3WvI3UsWGN5VZClm2YWaChBe1vBIqHQSblEvE1rSXLaQcHVqlJTHWjSR86B6dLLoVRHHQmUKL/LdiBGdpGWl1SXxSh/cB4vQ6aZRo9c/RQ0Q/CJ4xjhqDt5/gS9v4DGaUDraTQKKJVL7B/oOgsrhkvrASCllR3Worn3exMGnWmCDQwjG6Bj1OaKtSUALANkeg6SGoeQDUQte8UDQCyKhx8cT1pC1O3y/7Wiwd9yY6yOUFEsD2RVBQQ9SVZKa41917XzBXfauxwn9JR4qe1dKtMZUDvcmDTe40wUyiawARqr5F8MQC/QL4DQlwV1D3Pe2QEITLEHDwzeZP5hP7yXd03Jvv3n0fv27hhFHAuvITjjmBaa+797wDe4151cU7QT53erwpvQ6lmJHDeyFb14jFP6NU79MTI1KQ4bgpxK4FROzUjiXMVqqt9tBtJtBTJljQRkBhIcWjAueRh107FWFk8Xqun4lz06NOUM5+8kyJMsTwevGCWjvnonOhad6CgGjuwoCSAgWTHiSzogEhiU88JulFxX80FAkyCWzEjWeNY4dDja/x5P2eGem1O779fXtk024ELUK6MsDie256vy2av8gOtyMAdPVKKMc0YxwX2te/9m1kkN9tW9u7kRBozJaetdYuvOol8s7SSFAwJw0SPAlwlSgIsQMVMFLL0b8VBOkE5vSYB36VsYU234VzbgGvfgK7QFOoy8vOWGkXrl6EYEl4VVFs0mAe2nbI+mBHsH3ode+Hjrd2ZOiFFfBzjzk1xjUPEaATGCeAHn9dgtVpWhw2BN4JmMtLHkj7CH557J4lwy6wfR7493FKz/AYjBqWowryj7wEDeMpjKMajPvmmnLb2w3ZQg5tXIf3x+2P3I/MqvvVZzs3PG2d+9swh1Ra64pTrHvPTsii9kLuH+MQMQ9pvtGIx28J/DXHwpgbR7IhnnPOvLnKQEwja3RoRNlof/f3fs+6kUH1eedc5HM7xx3HQYwJnU+TT3I4JwPDyxm3V5Y+FXecf+c/9j+6y9I/aZ52AJ414uOa6draV4rv6fXn62ksEpJ0RL3Iw59A3cdZf7Tj1OQIlGx67FBHmx1A+2zeuBX+HCZc8nsZRsvTqNv7pqbGf+CFm32cqBZA33EIrMbzTDyx7W1deDJBUe+JKsPsdU7eFkjA/DWowiAGzY9P3qpoLtT8j2fOY3759UgwVLFOW+zTmNShew0sBLUEqB6JGwvKBYFleEoE4ghQNKv6Yu8ccp/sBM5iDiZYlMdZi4uDJ/ciuZSdU0CcZpD1zuuwAM1cFJLfHYsYvTyENqNjkEwDn7IS6hUMIvNtVMoXOo82PeSsceSl66qI6UvHavEpP3QPl9eAx/kBvhfg64nLg7G8qoXqJu++zpM9c5zYz6ZFRZ4nLiRehswQYl8AqEoR6MZAOIE9AnMByfDs4MQj3QdsF4LrfHX2QlTVzLMVF2HRjGurXgQdLDORC0EdDi+sRnAgypjp6Yak3pgDcwQXsg1Z8JxkIH4vkBH0IV7fYbkeibKiruIHblupP73fhOjVsB4gyTq7mRMtoLZT/CCOkTQmL+ko0MEusxUqQyD58Q6kRbFg5k94AIcBMDkGK5hMCt7UAnHM3evOxVrtRu4w6pG/P+2MU5cllDEol5/rzKcQURbOY1ujn2PrPYhZPhai7G5Y+FjwRCeTNti+W6oiUh0BCCTwmehHcC90pAuqmnVW/qaInm7VDYlywPX1HQPI10GnnVv2vdjZmEI/UVlj7kqIGcj4cYoNjTbRobj5S1qZvIS4DnjpHFdMcb98bq2tPu8Ma4IsZgsUWQhcCHjZm/0wBPv6+nwMsgvDa15CAxznKaKGH08tHjmNau97aVlzI4DtCqCz64mH7P6HN9u29g54IvvtNb/zWrvqmmsAenbb8uVLbR4oNIWgpazfsMW++c1/sq6RSevD+S96zauQ7bJF96jUZlAvNwZcerEMxiK95wz2pNeciYLoLSdwZh3Y3iwSs1Bu2d9pe0DXGefuCtr6easW2gvWLhMwr4RXeGnLHLvzse02zcBq3aegb9C7jtcZeIq7+0cErhe21kmxpSTPax6ILUY++9kdCPkPT2IWtyP/ajfE9wZTYGzcOd6meT+PYaTPOb6HoVXeUg9ZQ5SLRgSTKE2gnXk3UwqyvQ80Dt7PcZJHdmy3hzc/rfiAFvDyH77/fhvqHbS6eQttqH2v9XQcQAbVudZzcC97WXMP25d88XRtGjvDvRwLM6AUMclThTU0+vgdwedXXvdSGwDA3f3IDij6jNgYdjyYOZiBohxLHDtzFi6yP/ijP0YSM6fhicrCtoq/fgt5QKzmCp85su2Z36bJQcJ7JBntubwXPgu5eg6v7eNAzoMoC5VsONYJzJlEaRzrxDiME+ZG8NmBtCzQXmAwZ4Z77Ec/+I7teGZn1lANT/ojuPiNk5OZnx7R2bNvjnsLoM/pmSI4J0hn9+7Bkx50KP3PPmZb4NgtAIygwIVX47kTg+Whk7ih0npyBDC/+PKX3YDEMwr+nJkaw9b8QXC4kYEO29JIvagARSEqLQ7wtGWBangYs0hWyEzHcH1PUmQObeklcw4tQVQW6AQEFpFEAM+D9+SR9BndL40ZmWDGM/JBlQVb5xOZISwMCP6Ed1BUEAUg0vPrhkECbQnUOrb1BSJ5h/0NF5UEJOkdJziOBUULgswLAVGCKueeU9lEVRUfXGBJbxOc9av7J0SjlGkjBYEiFUiQhPKTM1+GAE16sMXJx+GeCIYLKssFQNXbZnsAzGUE6XrQOK6daysvRLgD60jMry/oNXXqARctLp7FCOaiV2+MgA+czFJoQxeVMviT8owO+vjTFMjqPnIsZspYyS/YODTIEr1IaDTXhjygyIM0vdZs4ETZ4LlyiETwGMGijE2gKo3jPva5l11eMIJFbEk7H5+eMPBgARwmwKcdGwWYAogtww4JaSwlABFTBBwEdhwvNDRUtpRJNneXOrCmseCfudFFI5QGlVpB4yUZkRon4ablTxzGczw441flFO+WJ5i0/rZdCFisgbQjs5QGjYXty7oxq6v6VLXFzpFzfgsoixddSpoUdy4oa1kIYLb3RsbvrAAAIABJREFU6Yetbs5Ca5i3DKdjoK5QjjyApCi5BChBFLS7yxqgZ92OzI5Ddt4FZ9qa88+xOWizxpZ5tm/fHgGvRiidsM8J8HtgpPX3I8077ye8LwFQpue5rAIBpATgNJdIYaEBoREc6jrReCQZde/dYhseWG9DuPd6+wfsrX/+dntm/RO2bNliW7J0CYynSnDTR+ymGz9gLStX247OLlv1ossBmsEDR30UCEvQBoBYC+UVcqX5eQUMbALzUlBP6EEmMC9lkKhSwPsOFwM3yb/OMKlSpKNf1txg5y6dj3T2HscxB+P8EOguo5MYa3gvL3kAOVZjNOMyheJQB+BNf50e4beaRuhRwFwgVN/7Uf5zH3v5+uW6Gzgejzp/TGc6N7+fgDHBJLxM9uNGGMc95jkZJKgvFHLSjMLfrIe++P1PPQE5yTr8dtrmN8y3L3/241bfSmC+W/dKeW2TDWEOn57CeKFBEoZECqquwJjoP3RYxl0JqGI1Da5s1TRvHih2Q1Y9v8UGce3eh59B/EBH3FfhYKDBzMRfCLp//R/+la1YsRT9xV0Q7oD4M8fXZ/vl1Gry2zO169FGD3cRNP9H++R7zlPfyHHBuY59q/KAew76UldXj+3dtw8echod01Atqram1hZoxEMJiPc3d+EYOJwZsNu/+3Xb9hTpzTQmfMeQ3+Ow+3HvvwPysifzOh+j9+T6g/6tQYkpr7gwSk79800YI7OxACdXV56Q0hKYJ0UWZrHi3XyyPn4NML/+hqLy8nUEIIQnDEzUdjsWumLqKQOYC0o5ohEQdMJG8iTnvMwewhZeDf3KlyIBb3lYhe3kvZIPhIGVAtHpkbyb7lF1YOACAQQm5O8SvIwh0cYklFkqIAFIagPpLZxgBWzl9XPqQaI2+OKWSuPllsc0PNhOZMFRjqECuWt1UCnSbgErIE8n9bpjlyCXyD7nIT9SQtEX4Qy29HkEPYXjAFI0fsqgjMB05TIquEwIIRKgEskVWF/XXmvb8JSXiWXDi+rGhbby3PODC50bimpPSq7Re8RFF8lGaKQwmREBfDk85rBi3EPPNpLmeHi8g5qihVFgIy7mLanPXAM8AD3pIWGMsJwCutG3YfXEKAgoErE9nhGW7edg1HGLUzOUhCmAOa0LUi5KALIm4b0bRzr5QgCWMnimPcsrsxo6b5pBou61ZP9xy9/7jSfX+b1Ds8agE50I4pzG4OPVx6eOI5AJA0Qa6RqnbsDkXodxhjthEvEC/XueUUxEMZPlYEyWok/HIdtHlZJplLWUhpzoViwiy+Le+yJ8XoTf0WPONh6C5/lQ1254citswZLlNgl6RwkD4DJ9NjPWaX2HDtpQPwLewKEubV5iZa1LbQLc4vLxfjvn8kts1elrbCEkBCuwE7Nz53ZvH/xHikkddOxZ3wzAW2dnJzJkQgWEhhK8jGW4jjeZez4TdSC9zu0UsL1A34G+/qO332n1K8+0cy640NrbOmAA1NnyFSsUADqDur/zv78buuqX2T0bnrEzX3KNQHcR71+BN+eXl6FBmuuqkOUSOwj4jGDceebQ2AZAL5VUIoK6CZ5QwBHwoPk7jg1mACUAawK4P33hHARHomQAjQ1IOMYxPpiBRxr32CgALINZszNM8grkAevcXeSv8uvP9wlAitai9wku56D20SAznTMLzo+6CK8xODIOgwUgnLsHODcBJukXhcVMBObzpKg3MV7uePBua4N+fVVVk9piUd1i0IY+7fKKUOUZRxZQNI0CJmk0crdJk37cCLxmJag+Az1IOsb5CL+rb2rU2Kuf02xNMOIyBRPW2YikR0912t4tWwOYhyHBoFNo1JdDqvHa1/+xnXraWZCtLNecxsyu4slr9zIH0PNpPvmA/GiVn/x2T+0vqorfvm68x5PTFPt+fBwZS/sHkYH2XtvyzHprA8VJzhcczzFSCi38Sy+/1taedorGnccbQQsfPP0vrLsF8wqkJdVAKC/G2zSMNi11VaV3zpQXvmu8rZfgcPZxAlsAfdyCyzFBEQNFKXFJJbxdJ7AIs5c6CVqAwHwRyvlCPB/CANl5EpT51xXxmMD8vMteCo55xTol8MDEOwpgXgTvVhUWWHBFBIa5Aa4JVo7ZnMShA+AEvgKwhyuZS7i8kPRqBPh2TxTfuGcqgThm9xOBFLMiue3iBWf9VtzCJ1DLaPJnsNxIf68VINinHJzcYoBNBjGyfAwsU0wgXouXHufw7dIA3ypD8ovFAivA7Z/LYx4GhpeWdXQvTfKrO2WDYCpqpPPn+7bCCx/UAXqnqBogGgnbD16bcSzKRQj+LKcOO6gZ/h0XoJCsxHV7kCCkDXJ0On00XV3rMltyzlme10Zt5Qs3W5TApJDAHt54coUYCDba34N2K7HqWvCXkb6awHYGvBLnlqd2AMedW788n9Y19kcYNzomjB2C6oRxdJyD4ayajZst/rnazf3N+X522R701jLja6JAsS3p2cQWNBVkCK4J4kqYVhzAfBTSmEwiVYIdhlKqyhCYgxJB/XWZW2FgeYyB96NGZRqzKif+Bxinh5qe3yJqnGtc+kKurlREKH7rGxDu/dN5eIhTl2RQiJvtDcHPi9DO3C5nnIYIGvQ6k7uNb5koZoZ81+inCYzlmaFegW8meJmEbMwUIpqBC1BXgO6JYSSEgiECUEr6AO+9QfDECzD+xxFYyUc1NMLpBa+as0RgrHq03RbMW25nXX+VLVu4WP29B5xab0cH25QsbGluAU8fnn3Ug/Sgru5uGx0dAAimXrzHQPBJQyE2cdSfyYDxe9L7dnpq2J657x7rHS6xC192lRWjHM3zllgzslEy0dA/rPukLTptjd23abudesXVoquwXUr4F9eokRRiCby+0KZncCfG7RC0vXmPlyMYklzzUoJyZgzF78jfZ9ZLpqufQNsOAJiPo32q4fU9dW4TuOQl8KKDloNjm2tYRwL4GTvQBxpGeK8d8OXoSHFXHWGMxADK/lGbxGzkr72d/PH/BsxJtyhGD9dCGpLysT1DKD8MH3p7SfoSUI9phR7dXz3zhG1t22H9GZ9fuve3W8fufQiOHrSxXqgvMXA6sgzz/iE4n2bQPNoxgh7lIR8GmB3u7ZUBU9tQL7nJxrkt1gzpxCULWu38qy60b3ziG7bn6c2e9EtzM0pEiggmHtIHr3z1Dbbm1LMhawm9eexwULWH1CBXbHGjl898YJ7/uVov2jEB8fy2V3mjeQXQ88C5U7EK7M4f/dj27dpsr3v1y2zLjj323W9+w4ZguEieFmXl7ytrGuyVr3+LLUYwMsundQkOgEce/Knd9d3vqp11g9Pjj93XSQRNFzBzagXy8RbM3JrpHXsvrNmtR4+L2ffHtwXQ55RWpMQith2NvHPyz8lDn33MtgCdZzNUY6Eqy88xMA6exG1yTGB+5sWX31BVVrKO25DyPGv73DmnCn3MukIJehiI6WoTvqXuRzmXL8HukO3jN1oQ/RjBdOEe905yos1KkbmAt4MaHJ0mYhfMcG8qlVio2lEEjjG37sfBry3Dti28/VJlERgXf5qv80Gy3J1cBtI6HPM9wZuL36WHr9u+DIuIorIHPxmfiShBYJmttZ/SAyV1aPyI13RbQF4eej3h8WWxeM6x/m540KEUXV6FbWR4+LAgFCHoLz14fXr5utp32sFnIJuft4A1zl9ti884TfVxyOttSk87dcsFFNknAlgAfQiSJSgtKQJYAdjJ4LMKeBmzqePVLJQ+c0qJwHTKZslq0F4IQJPyCSlwlLsJ+MCNHwfk8qqLBsLr83xBMdEizSaRCeVtrC5KjYYWxbb+JPqYgJGe5hIYhhXQXR+HB3ECVBYaG4UoP0Ej9a8RsCyAnqB4tvmjR9WHAYbVL1GP5FFTV2lohCkRRkmyVVK7inkhIyOP2iEPN40UUnR4Jgbd4iNSQGQkxfVoCCiAEPV2SQtvH4IOvsN5aHC4igvPIeSPcntgYyG0rGfwetND92G8g87DMgKoLrsAsei4yHQJkwyBb1zRb7Uwps+Gh3r5slVoygnbD6lEJU1iv8T44eiowpib09IiIMXPuwD6h6jUIVlDv4el5CH6iI90lVXt47QmNwa56wHlly0b7OnHt9sF118LfnsV6GV1oNIsQAbQH8FrPWpb+4Zt1WUvBsim8Rkec5yHAJxUmnrQaJrxOwLrMRgtGQQql8JwJBedgZtUbCkhJUu0D5fuIzDrxy4KcxuwXIvra21ZS4MNwUNO3nZzTYXNra3G8SW2qaNXNJfcPZTGXQ4YZm+8eHFsj3l+W/r8ksCndnziffa32ZvZ57SjPeqsA2MUZkDRqq8EQIYXek8XAzAnMe5prIArrdgL9YgM1jYoAD2zf6Pt7c2gnRiUO27PPPo46IfY5UQA8QTuEfk4SNuQjjkNVwat+i4Dr1lbVysP/aF97WqTKhgxvKeqAdDrMC8shvzmpz7+UXv9n/yZbXvkKSjAgHbHuQEgX554vK6Ebv9l174Oia7WWkNdNYw9GJlM/BVZVpXNlvOxduZo4IZxE2A9227RRlnnDkdXeMVVa807eesB24wgHX9HYaS+9x1/Bi9/nb3vfe+0//m3twCk79DuGntDuxu4fjHmjJe++s226rQzs7QbOoH6B7rti+tutoHunmz3M35Fu27MOVGONRAG4sRQZrq0ofprYwUFH7C9h3YfPVZm3x+/FkBfc4E+A8+1MRHtx98nMF6YSXT28Z+4BQjMz0b9iYTuwIA4mTNWHROYX0yPeWUVOObhF2K68cgCmgCq+5kcyMjjEOAjQUNhDQGzoIj4+q5f8ZgULuVbkwA5Pl/Ht3FkeKEF9AgQMal6ICA9jr4oKGAMi9UEvCETo4MIlENAI40ILvSYgKXJK3CRLUCcPIHzdC0vV875G15fh1T+e19NvSwBgAXSCc/VVnw42JI/WR84aMkCIXJ5mXkR31B9QyAMx49iURgDgKgWhxoxLgAQ1UgqI09sco/jVB37t9vBrZs8iCq03eevOMtaVi33Mgr/EyAhoBSc2xm0C73wDrpQTnLb4U3jIm/T2GqGAUBeaxkoInKJqp7e71LoSyjX4ZfXMRCvdtTjQ5ek5xu3PhzkRptnf+RtkowRb1Z+qXDNAHik3ysvLGg4CNDCjg2/HafiDoKPJfnIz0fBiwavOAOufG3zQhtAqvlq8EdLCM45bgJ4qyAcL2nEiS+dQFOqilNTvC5pFOYNGTYrPpeOujzm4SlXiXFmetpJbA+spwQ9sl54bR8rojnJ+MC72MEhMHftZ9+VobqN2l1dEEKhYcgVMqCNoJqc8qlR2/7YAzYI8CVTEjSRFc97icwvEa3QcfMqkECqfNrOe/HltnTpClBNRu3gwQPSVi+EBiMVZzRWpLrkBnE1kvk0g+Li91qxgk8HBtHOgbvlMddYDmAe90TaPXIDhEBpEkGHu23j/U/YonMusAWL52E3pNg6EWR5x0/utorlq6zp7PPhBaesKcBSUFnoWS0l3Qd9tKgJXlyAanqHySnn7gETJ/G1v2eKehjl8sSC8gEjlwocoxgvDPirg3F+9uL5AmMd/dhJA6BajHMa4sp6kO2SdBaCXP3HvvfbOmecxl3vhmkMeA2mnFHCT3XHqL98rPtQ95MlYB6nOnoGehYw57X6BkdhzJTAqMI50AeHB3FvcgelAIZniQc7Js36CsRz9OC+6OrZab/a1WEHekZxb0zZ3m277NAWyEdCqYoOABlX+h/zOHYxeB2lqw/AS934xcuX2PanQL8iXxxGLufOEiZwwnMRgPlN736n3fTJddaz9aDt2YzjaCSihsXk/9fW27wlq2zJqjNs7tz5GEP1UJHBzp+AOWlmSefcDcJnP71sHseRMxqzrR5gXLNpgHC+zso2BtVv/caN9umPfcRaW1rt3Te+0977F3+B3R8Y8OTy4NzUyC8D0F5z5tl2zvOvsYbmVhl/TqHBDiza5rtf/5xthhxtts8I5BHQSnpXIbKzFlRxxw67ezAcsfhMQCnpi1CB+eDI5r0ns4MuW9+T5QXGAQPdzsFziRYQsy14Po2xxXD42cd/whYgML8E9V6G57cxEE7mrGE+E/r6kqfK8rIbysqr1qXFRj7kPBzrXlm5G4W0fEFzj3kRFn7BKn3mkl6+ZDk33D2nAXYVJBi/x+LjWRuFRLKLlvjk5J1rW510aagSQFFiCrzyUgSi0jvO4MvJYWxPY7ufKb2nCNDLQLlBJs0SvGc0VSKm/LPjleBJfGeXBPNS8p73BTmVm8AmKZAE9yHAMz5XxJzXWaom8d7VV7gwgsIA4D2G8tbUN0lRhGBqbLAHEoBI9DE5hvke3sDBMZuzeLnACE8mfIlCte/ZYl07tkWApi9OC6DYMW/FkuijnIeJni3KdqgdsL1MI4Vb/TPQAC+YhDcNNIlieMsyOK62qVXec5kXpCpxQVd3CZVmy6AuTAul+k/RAgKr7hnnIy2pMbwI2HiKxOX10+k45ZHQNoh71wVoSA0huQR9Tb1ytufESD9ShjeD61lnMwDjU2MDorTMAKQWAuBNwZNcDeWRAvS72j5ZAKqFb03zMuKzs1dVhthdiJ5WqcRzjxGbhrjGbjJMWBcHzQLoGr/4F+PXg2KJnAgyYkdII8evo2tqd4gv/BoyYLM7ED7uUnxB2qVI3ncaLPR6FoAis/VXP1VQG39QBA/y0ouugydeiB/HjNviOujU49znXH2FzUcg4Cg81YcPH8p2TXZ3JPpSoJqoDx7OeiT7mQNww4MnERzX3dWFXQuMGXle/b7Of6p9wzBVF7JPMX5Gh3rsyV/80qpBr1l73plWiPcdoJEcHAc4XrAcYBk0KnpSCZqoZQ4AR/DEVuS4J7+coJJc9DLcE+SWV4Iy4XKKVI9x6VaC81GMawJzZTwFV5q/PaV1DjzPFdaN+4pZPpfDg87EYiwrk/P0ISMoKS1HPnxnyaUF01j2+S03tlPfxZhlS8XQTzt+uk3yfpF/DbV13hyXvuNnh3uH4N0vsmUNzC9QZju7oJ4EMf0yqCdx7pvA+JHEvcAok+2M2qMbf257+qYQ4Er6FHYOegZt6333IGssDHxS2cLg5o4LZUidgsV68lZ3hZvFSETVtnM3KC1QO0LbNc5pwi7LlED6HHDN15x+inXNjFrfpg7bcN99osSx7zSgcC7GeFRht7Jl3mJbsGCJzZsHihRAPbOpelv4nC5DTL/xtnXueY6HnoKs2Y6u7OKJizyJEeMLeK/5HJ39q/actLvuudfu+sE3bCGoW3/13//Ebv3Gl60dakEZ0JmYdK4B4gWLVsGjP28l4j6asUsIBRoYFonbzh2Axx68x+74py8fMSSKQMuhp1x7gfCaF8AZRBEExrTQqCkqLUQnlXxqsLz8Zrv38VlqxVF31PF8i3uG8X7knyMwwpg1dAOeOzDWjr6xj2cxZs/9HGgBAvMrUY4WdP7XnwPl+X8pQiCno4D5FdffUIXMn+7N1lKmlFwJMLtKiaCiJisP2IxAOHwqfWQyUfCfnK6iOfhCRzgjKgo+d5aimM36KyCSAjUJYOQtpsoJqTJOyZjEYkPVC6791dger6jDYouDRgDKp+Ah0oVBdSB3uqgEiTagx8sU4A62EnCMl1lQwlN4ubwcDiwVmR/lTlroqQ75dz3pG0kZg4DSj9EpPDFQyJtRWYSyXQaQlEF5K7CQMREMqQ0jAFkzomcggI3nKCyzukYkQ4PXiTrPrCNpQAd2bLTOvbtUAfe0ImR99fk2d8li8fZVbnzO8kwDcI+Dd0/pvAy8g6UAKWPY3sbqK9UFrvCQAwNY9GyB09QzFwgl/zR8g+w7KqKEh9XBs/cjX2SxC17k2iS1dXiUvVSxc+HGnI+XoHIERPadFHzNa2M7n/zYCYAsbCEoIVI/9IbLS6qQVp1ZPzMADQ1WjgBGqti4TnsTzuu8ZS3+7Eqdz9vJd3ccgMq7r2J6wVOm1MRPJ1gW6I3fCfDmAaoENzSskkEiwy68847CfVzpwhwXTsw6AuIJ0Abdh1/EMaL9sI0IwninCPuSvsCdjgnbev+dNgy6CfujCLsryy+9DuchOxknmR6zhbWgRaFdnvfSq2wBDJYuSCN2xxa9wDDHjpsLuseSrB8NPWaKrIIh1wyPYhWCRlnCUXjcu7q7tEPh9JYcONc4UKABx417/RUzonE/Zpsf+iUUMjKg1bwIFBvIQA5DMnEYMoV1C6wHvPpEMWC5SpnsijVh4KA84x78WUEuMBq9GvScBMwTgCYtgx7zEQYiUqUFQeAMDl0Jes5CZBcl5eUw2qq1tspqYaiTi8wg0nZ48Bkg6vpJfDjg012UDQ71OUMKTDFWHIy68ecUCTdW0kNGS/bds1/8/wHz+fWltqK5QomR9vZOWGUJaCXY9RpFPejlB7OHg84O9/Tb3KppAOpf2M/2Z6xzCDz7nj7EHUzZ9ofvF5CfZn8xYRlLGt5zSnDyPb3mpIhRM7+xEbtz+PTg3gMyDBshMcmg4Nr6OqiY1Ihet+j802wflFl2rd8AOgvocNFmTi/x+Ygn0R8Baowl9IXfYGHQ5TdHrAfZyVLt6nupubaMq6hNc3O4g3IP8Oe4IWCfwm/7INl5/vkX2fNecJHdfcdt8ujXIkC8ZQGywS5ahhgVOFopEQt1pDIY9KTaJO150n26DrXZp/72Rqf9qFa8JWEU1FbKSEV0MoA5VkQoDU0jZsFvWZSZkq215UOTLTXrpudWfdT+4c6Bf2YIzH7179wCGHvLcEoyGSiFxbYn/xyeiNnHf5YWIDC/njMjOv5kT0KQZrojPeZXvOIGeDsAzMlDhsZy8Ph8xnSQSxm9XEp2TpL8zidgZ5cnbyo/4wTKhS0AGoG2gHds3ccCxwOUO4+ghBkVyTvXoo9P5SFCSPY4ADgC/4DYkHwF2f0w0fJaBKAF4JmX0HuKhaeAmfNK66ALTu40M2lyzo/FIzvrx4IhjcEEtTw4bjoiGnn9IvKGUTJO1cVaoLEIKBg1wB1JBLyGQBnLnRIhhdERmSeT4gUXTPKAIcEFr+Kg6jkw0GnVCGSspFY8ecbcdq1pxl83UAju+V/bjvXWu7tNr92vPGOL116ItOZInAbvVBEXbvWFy+kxdX0GW/eT1HRumANe6Tg87k8riVEl9I1J/ajAdYvLanAtHwY0vKiLLAMruCrJschTyyDA+WkoCNzRg8w+jNHkyzR/6x5F/ZZvA4iLUqM+8DrJ6+mjR8crQybKyfEywUAzqD5MAmDQyqmBYgTl0Ho6oEuNoKxaeIOLoFhRCj3zaYAtx4xsGVeYEeTK9rujBjcHqOyYxmQuSDmLr9JY9ZpkVXj4O7GsCZpFS4FHEuNbGws6r19Duu0aVwTdUXdyXKOd1HL6nPKORHkBaISScV68l+yjX91PTgMJVIVpAO/t9/3YhpjYh5Ju8DyvuPRajk48MUrRPi21CAAF6Lr0+musqbEZNJZ2eL1dBlhGUaKFBZDyz3kZp1rRU8r7jYGhLeKflwucDgwMQGIR6d6Df+6OqQSlOA8Q6IcnlVKbMS8c3rXRfnnnr+yyN/yuNVWAI46T90BCMVPZaIdLa62/iOd3OUTKJ1KrXOorAE5MLsQn26wKANHlEt0IIACXAgnOR1WSMXjORzFeuDO0HF7/ZaBV1EKVZVcnsgJjLpsD/nMZ7i2+7h7O2ACCS5N0ogPqiEOI8ZkPuINsFQDdwXzu+zQH5gBofssceax+mn2kc7A+nfCYz20osSUNFQLh+wDMKwDMC4powGDniApL2vopEDBfO7fCutoes/9z28P22HrEI6K95q5cY3see9ClISkrSvUbGi94zcDyMeR7UMwA2w6fMwEPjZ8WyCLuRGAux28VtO85DhvnIJgex1TifetZa2zbAw8bIk3twDaPfUygXPdyzOMawpJ7xKfjIwC55Lm7hz7bDmGQCtD7XZodRz5kfGdKm7J+If3Nv8fiVsOnfkcXY7eM2vWv++1XWx8Cpu+69Xu5Nsb1m1sW2jWveq0tRPIlypsy6N09804X5HMSO5af/thNaNO9OWMC93ERlGsm4ZUnCC+sIDCv0k6uxj5/j+DQGVBeppsQpDunus+WNN9iBdX/22767Kz29pHD/bi9C/75qbgAacachBA0YY/j/po1ko5bqz93Tkxg/lsoTgYdfsdzp1j/ppIcG5gjwRBSMq8T5tJk6HDE8ZUDLueaOpjw6TKmzACFPmH7hFcIt1+whnMALry9/JlAvM5FsEKQhwh4Jo8ngMNFSjABUjWDYJgKIzPwKk9B1oq65Qz449ZiHyLvCUIrwEEuBjgvYQZNgFx6xsjVlMdTZU4gIrcQeMY6p7voGNeccQOEi0wsEqpwLBbRGN46nJu1KDkQpcoHQa2fxRcZ1zxnK7rs5DTAEykt01i4SrBYHt65WbSc2uZ5WDwr4eUCUFHQbfCleR4s3Pu2Pm69bQfcS6eSmi098xJrbG2NXgg4wAUN4Jrb15Pw0pM7quQ8MGh6D+7VFmx1QyuuDUAOegBWaK+vPFYwQuiJlQHmVBOptSRUqqFGGkfIK8qr7uNA4DyNGu2skPtAkMqvnYTtMFyjw9Ggfsp2830J1QDbytR5GyfwVHsx1TyBYgW286dsCKnGCd5KQG0pxY4A24oerLQzIqoRW4jZZjVGfcyKksI+jWs6l8QXfSei+KB3M01d5w+/EdTPtOH0PRd13hcB6FxSMWACxizHgcaLTun3SC7AlrQT97BTx58YXrtCpAWQAiVtfL+wwAmNPuVbwn0BYL7jgbsQoDmI+wEGFMbK8ufDYw6A4PJ6Y/AWF1gZLnzJy6+x1qY5tgd6ziMA5kou40X3v7w3Re9xzrF75RmETB3zGO/4tgb88yYouBSijVlDeib7oe4jtSQ1Bj93cOP3vYMlbYDhPcs0NnDQnrjrHpt7+kV2yprlMKwGrW+UlQNIgnd+33SpjUENhgBdyivyoLvHvJxHp65VAAAgAElEQVReSjwq4JlUJlB8LyoLd0dEy0AuAxhvpLNkmHEV7dQMMLmqtdnmAYx3gKLROTAEmk6lNcFYr8ZOFIMl20CtcXWPXJu40RjzUTQUm0v0pbz5I/836qdo0+SBjdNkP08GTO4U+XMR6SnQ3gYffg6oLEubGOTM8k2gDdDxAOakCdJbPhXAvBPA/LT5ldbftc/e8eGPW/sAPOEAjOe96MXIAvq4HYBu/RSMFRov9dgR6zywT/fVFHbsuPNCNRwGzmdAU2KgZsvcZtsHfjqNeM4PjDthv7M+NQCm885cYzs2PWPlQ9O2Azr1CcymHYC4o50rzo1LzG2NTTXW0ATdfBpcuhGiDXXP+P0lo5aNGSBcLwMoe6vrRlB/+/wcKw7GGKk7nOPYib09Q9jZydifve2ttnHXFnv4Fz+HQY/6MgMs7xP8VwG99Ste9ho755IXBh3Q73QFhXMOQvv8/K7v2f133JoF5hrdMFStIpRsIGdZgPfjg66IVEijkRmJkSdiugEeeYLzZVD4m1N52HZ0/A1ujU/Bg06axezjBLQAxghVW8g/Xx5DZRv+PoXxdzLTjk9Ay53clyAw/21UYQQdfefJXRXNcb7m5HPML0Pmz6qKdYISAQCzTg1BFxcelOcwO226Bzd5I9UunIhdaiULftwz6ODRdaLDsyIJC4KQHMD17zX14ena4QRpdOVNYTufwYHMHkluMzNnjg4NwNPTgEkUiwkWb3pElH2RHo0swOIEnK7JCjp4cs5J3uKs4rCMurTXIa92XgNfJATkwkqZDlpPktLzJYSF9D/uAaK0HAAz+eagtDAhUt/hdmwXV8JLXisPKDNZyqPFq/jKpTbfv+kJ6z7QFiCBHxfYKRdfYdXgihMIpoBMUjWYmpoBhUpPDU8bAc4EgPkAdMxLyOGlvjYWcoJ/BaJmt/F9WAiuCsxSCjDQLI0lgrHoGtFGqCnPD+QhTkMq6CN66+0tmJ8FOslo80HmGvCxWDP4k0YF5RrxepKSb+T8MjANcp2TUP4Y6u3Rbg4TDBWjvaYBJLTfIlDrzZ0MqtiXcY8eDT8pnfBTR2MJuMdgc6AQHZsAegJr/JL0krQ7IAOJYxrYwD3gxKocEDyG7efjPPkFC8A3ojRl8s6SdBR5XjWaRJcJZ7t2FlhvbMGQhuD5iwAykPRrO6TdhpVKHBQleLWXXXyN9NYPbX0U46bcLrnkdOlSX/aKayF5N8cOwGPeCzm8YsZbiALgBoPGFYE57xEaQfhsQpzcPCClkQ/vNIByLahDjfDASzIVPONe9MMgPfcyeBwyJYqJ4zA3dyZhiPKaQDO24d57bbysyc699CIrxq4Hd3GGx2cg09eMVMrFtt+qbKIcBjYNL/HKocYCACl+MtqGdBaqsxD7k8KQJPfoLR0C1Y1qI/SY12OsrILk32LILw7jOru6+lTPZgCoBVBtoZGyl2AOxkzKE8AxwLr6HOVzgM9AERsQn6Xv05hRf+aB+PTbZzsD/Jz+efq1TyL8rAuKNfPqim1Zc5WNIMhwb09GQZ9FiBPhDiPTEjiVBfnKewZsDTzmA4d32Ls+8vfWDmnFuWvW2tVXvgxG04BtePJx6+vtBi0JGUP375OK1STmyTHsOJL6xesVgeaSlFXmL5pnHaCyZEBbopRmGdqJbVuDOWkG/bcMcQJ7kXm4aajYnvrlfWF8eVmSQUaPMm+rKfQDQW4pAGwlKHTU0a+EQcS5rig0zqWYpfaMaTgaROuO5rtwZoRDhV9Lw92/0fzuLcd7DsbC1h2o25jd+D/eY49s32T7d+7wwE/06CgC3nsPd+OeIYe+3N78p++2+cgLQOpYynqra+Ie2Ld3h/3j339EPHo3vnAt7t40MPkV2g3xDoWoy/R0OeoJaiCrjHt6BjszM9Dgt2YA84WgPC/Fsw2qfkMjbeASfsjaC75o9947G5yYP+yP42v0J4NKLsBzDp4E5dSg34r+TMDiOF599tQnugUIzF+Diw6gg39yoi/+73y9hKKOBObymFeu44RGYEvPa7g8g9nggW2xdIUHkkiW/2Oi03cJ/PjMm70T0iQcE7JjF0dSAmeiHcQ2PsGDLANf8Pk/g7UIjLCySCpRScBQ+hEEhNILXYZFqBhg0/WmGTREHd3kkU8wK86X15i+OFDXguUnqHRQ5YCKi67z3f3h4ENUDgI91SWMBymlkA7jv0/HZxF81ivJFRY61KDfFGN7fgD60fSUl0DNoAhAUxKPPA+vFjwJAfPNT1rPgf1auNwzV2BrLrkamfewc8Bj02XDnUcQTWoDFy6mh+f7oe6DaBNQZQBcitBWkjCjFJ5oLA6wxCWXw5ugjX+9b2Sb6DoOarPYQo3j1kcwM/w4lTGAOftWn3I8+edqS33mbZ2MOcUhiPLjo4l9SwMDOzkKSmOwLNU7irVDQo+5/JlCx+mM4jlHH8jg04V8HLF/UmyENI4DcMu41DjmTk+A9qikgNezABuaJAukcXp533P9rh0InY+ef44rvIlESG6IsDzsS287b+zU8TTkfKyxjA5wXT1i18N3Q3e6W79hwq9lF4LKguNGBg6hbmW2dlUtQEPGLkM69QZw7zug4DIIGkrqI+dMh93MEodIOcsxDq8zdah1m/H63CVQHfxeJGibg2DhGsZv4JhxeKq7uiD3SfnSGAPaUWMPsz9ww9JrSWlDVm8SMSC71j8Oek2/nXEpeOc1ZcAuoHUBiJaDz1yOax8azFhP/UJQBKqg7gEqC4E5xwv6tAaGCLXLqUleBpBHaVTe7xmApmEAQrYVZRPZrkvmtNjqlnoA+AJ5zQ8PDMtjvho656xbH/jY3cNQ+Qlx8AT7Ugp43edeczemjkTTzwLwHGHJY370sXHnBCDPmxv87Jp/OnuHoUhTBmOiAplKp203uPnAe8gSDKAMbhOL6cC8wDoBzFc2l1rX/g128ye+Yr2FNXbdb70OQBoB0rhXOg/32sYdW+2yiy+1rTs2217MG23bnrbe9v3S9NZ8wX9EE4SSDzzmI6QqwYChh7sCHnPS4BgIOgljrWXBPMu0VNqc0VJ76LbbPVYj7gdNF9ydxItJUImYUVPBxF5UtSDnD56XmuclAOxNzc04tye58mb19tUclsZ9dsRqMLrX3M/q85R2pXh/mG3ftBW7qJP2sb+7xW679y473N4u0J1APjniPQc7ANB77NyLLrPffuMfie6TVJoE0OHAGBzotc//rw/C+O/KloPXgESi4l5kWCOfQmHVPLQdxh4Mx0J8NjmNesOrXtQKGtBCJGaaA1462s+wC4KtHLYzcp7M3GRL7v263ZRm0qjM7J/j1gLo/8U4OT3oTAbAQDTKK7YdtwvOnvg30gIE5q/FlfvQuXf9Rkrw73dRXxGO9pgDmFdWVK4TqGOQDeY+n2JJqwhPBidGTFZZTyL1qMklF3ZzH6VPngG24kLyqMfilrIp+goRXFyeEyiAGNDzfHJhdFqAb3cSHNFlSe4xswMKRkOhAkANS3cpgBo1wD2Rjct08fwegCoITZjHC3rNo27OinXgobUmPPjKBhnt7d5YB3YyWgJIalESSPVaZx3sOoJqM6p0eIZ86ecWbAE85hNjQ8oKOYC06KRk0MMk7zWT5siT6YXkmeErtf0bn7D+DsjexcLFtjnl4qusEoFt6pl8e0DFdG+zgjnBuyd/fQQJo6QZDVWCwlIYAgTm8KSqfWREBeszgcRoteTicwweHm62n7yvAYIDn/tuAz34PrwETqMdsgA5jT79hnX1AFffvWASE7qIXa0naS6TIzsBt+E4gTlTISKTH71wTB7j48rpT5QiTHrkaex6r6Gq8Z0kHlUV7sYA9kWdtDPD+vBvlEvAngcn207D2svMlhDBg5fP6pk72BWdSVx230Hwf9DWAIrywur+4Da7e8sdqocxxL+MT+DxBOYsJ7fuMW52PnYPkgx1a1egDBKbi86/Rudmk82A6rJqHj3sZfbCl11q9Ui61YFjyUlPu1WsOSUTdSuhDEXaenIQzgDlcgAPH80xFth4GhtebiLscujKz2lGIh8G1KEawyPkn3cK5GqHhfeI2hIGBbzSBMfZa6Jlug5st0d/+rCdduXVoNswqR/UiaA5XYaYhwqAZ4LEAcSJjDUieRKMVlIyOIiqKOMHcEdjkdrmSv8O0M+dFWX/RCNMwqgbRT1aEBy+BiCc2ujDmC/2AnSSX76ipQm89WIFWJJnPooxlTT2veQJ/rlZ+euAOZslgcicx9yNKR9d2dkjRl8OhOa+85uGfdEJj/nS5nJorkPGFO93d4+BV09jk/r8iEuhnY2BRsdxD4D5ijmlNtCx0T70yX+0aWR+feNrbrBmGEyMXdwM+tIG5Dx4BZI57QQY/db3vmPt259EHgM4MTCG6HH2XAraq0GQZyV2Q2rhed6t+ayctDEYXTWNDaK3NELf/Lo3vtoef+gpe+S2n7g+eDJUmaSMoByxPqSguafaH2mHIL1XzIyGUJEtXLbUWsFtd0nHZPj4blr2kQI48FlSo1GMhO5fb1/eF9ue3qJ59Ytf+qJ95mtfwprQ78HSMYYZF8GEeVSfKcEOxDs/BN+TckW4Co9UbmjUwbj7+mc/ZvthzPjy5dcoRf2n6Rln8csAyKtaMU6wq0CHCu4BzqkVdXVW29hk1U1N1gAVoMmCEduxZyOcIBWIShyDUYLYiszoM30Tk+/r/ofvgS8z+zgRLYDxxJl7DZ6n48lo6MN4MkA0RTGfiGLMXuM4tgCB+etw/i506s+O43VOxKmPCczPIzAvL1+XcERaXugbTtSVXAgd5z2CIE2POiJ5MLJADt8Iz8QER/5y1ncd65Yc45pA4xpx0SxNWYDZQYoyWeI/cmGJJ7iIDiNBD+UAywA2iyEzNi3uKQN8eHH3Pns6GAIgB+gyMhTkmRZReisdevCj5C0ksBBgisU2tYdLI3LRdMAg7/b/Ze89wDS9rjLBUznnqq6uqq7OOSu0siXLtmRbxhhmDJhgYDzM7LNDWNh9vLAwYJgBbDMYMMaAscFmnG2MbeQk2QpWbKkVW2qpW52rc3V35Zx633DvXyUPTPC6eRa5fqm6qv76/u+799xz733Pue85hwBOXc3GSeKvF/Zpf5p5cekxn6N3CZvDBIB5KRb48mrk/gUVQUZAAaDx9s5jfRJUloHTMPaT3HgqsPnmNyprAv+eN8GCx4myIqDD5ysZ6IUNc7jvHLyQOFJGwGSJKn+yiJRT7alSJscTu56NGQ+bKcPJ4025EcypjabPlHDTFPq22pqlZO50BqT0/BdK2+O6TFUqMPy1FxuaEizPohR4CYCT9mhWLMSNSMGZYnAfMvAwTaCMC5wEKB84n8dL2S4ad76ds//gHvLPC2jrB1NGyJ/XmPsay8CbccZW/JvZKe6//fypn7yWMsKbAub576kKa4HrrjSiBrQSiP5PQa9SH9JI7C13qkX+4HHn9fSAitaCcZiF3hx6/B4YWH0a1+qG5lh25W0yOujxoyYsqRlWHvxX3fG6aET2n5PwHo4jjeg83nFjCwG+6jNROrnBkDtlmmSg/qMN0gf8V1qITDVIqQMlqgk0FI4N/z6IUvADoLjQSBCVhWMAjyvTgCpQjmPBeYu/T04PxCOfuzOaN18RO6/cBi/lRdwT8QJQqgbccwbxJEOg7JR2ro6xuraYxpxmAGgNjFjRs6jHPBVLFCumSqTuEKQPgjtN7/qq1mYAXdAQ8H4veOasFtrRAO4zwNI487jDqBtF6fVpnnZQ3GmupSE2MJehmY1r68dC8LjQO661Jp2ApCVPemezMIPPgsLlx+h+pLIQmHc1VMYYXOPH4DFvquUpHgwltJ9edHrMJ3G6wBSWq1rK4JXti3d94ENR0rIi3vbmt0Yr+jbBwkroU8/ZM7Gyoyu+9eRz8aVPfsDziNU64T1m4CdjcoZRIVQVR+H53bp9Qzz16FOikJWBDki9qwJXn7pXB7m/+ad+Ou6+/xsxdfQ8+OgH9D495ZwPswDlon8oo4lnSJbLy2WV9QKpMHl6sXUjgtCRjccBCZJRYSFJ97D56xVcGZT8f36KDIcDe1/U7PvEpz4Z7/3zP0ZGGugCPeYaV3+RAtnXewGnjmfjR37m52Pzldf7Pgn0E5gzK9Gdn/9Y7H3k/sLY8AfGABUjcFkxRDDqSqoaY6akAesPcr5jHS3j+o0T2+rGVsQKLVWayTpUcD1ybF8sa+mOras647ar1mnOHkOQ76FzF57snej7j3/99rd/42UPWvzlskkA4wwvjqqHsoooXzjFiGegp4sxAJdN6v88NyYw/wk86iwG895/nkdetqfkFZAr4oI85uCYV6HAUN5IBGC9NGZwk0GIgayX0czcyJ62QmGgtDsJ1ODnnNtc7FMBHt4gLbYEWCJKy68ooGRGmHZM7ejKPAIgwzzWLDBEwD4KKovSrdGzJo62i6h4Y/B3+/68+Jsynjz+zKGujZbNSOAzA2u5v9054ylzZg2r+J49bQZx3ryF7+RRT7lGCjXrfX/2jUfH9HwiNQu8pyUxDvBRjkp/pUyPyJR/pJb4UreanjJ5zJ+IQRzHZj4zOZJbXvV6eNpB5yCgzptX2rl4D9JAeA9yOgncxvp7telWMBMLPI/MIc288LqGwJSSSn0ykEuIU5ti/jWPC+GGM7jkYeKAOaBwgTwE2vGli4TYCuMgYJ7GWdx8Po8cc4JVjDW9yvR2EQWyUNIkKxqibDwLoJC2xPRl2tRlCDD+IZuI1h9x4jmI0lUL1fpMnfIpkABwMtioHDT8lBWF7bKquD/p54QIJC+pBz3nBOPC1tABcfL5oZTdpmDE+fl6JtNgUnbixvPI3QagFI56RONSNDKjWJ7eXJpDBVAA84MI/hyHR5ke8/L6hlh+5e1Kl0kgVYH7tDWNojR9Y9z0xlujAXEXJ0FjmGDhquSx99TiP0mXZYQ5noBZWVhYxgYLddweVYJfBmF7/vA0il5Lv893GwFIGpErmmNBz2UfKoiOISBb4wGPNIGgRMweJcWeAlAiWDz4+KOgZszFlbe/OmrxvBFyz2Eg1IEfj4kOnUVgNzyRo1XwoNcvQQajBoHCarRT1UMlS2ZtQgYiVs/Ez+dgHFRjPViKAMYVrY3iB/OQpRfZYNpRIKYBwHyKjDLIpBJ6NYjAQeU1x/+ZyuLJnEF5Xk+85qVlKsnRI+e+5Z/SG9QPyZsy9ilCgYZRuMQCOd8/BhZEWSxrrIhJjPexi8g8hFIMM8AT9pg7XeIwKnzSMbGurQJ8+tn45Le+HdPITrRr8/ZYghSRY+OoAQD3Opt/7FxvvO8D741ZOC8Yt8EZQllwvViyciMCz/dpDaXhtRn5yg+9eBDpEMeUWaWaAY3UAsgXBemje9vmONV/LjoQB/AMYgXkmMBDZhHoyQlAT7nTZKbpxF7pVGZeFhaPZVmBE8INAOY8KZxXDMuHXnB+jLENWaaqXMwiaWg/C6OR+06V5vgfP3RUhuBHPv7x+IP3/wHm73wsjIA3HRTo//joBLLKHIr1W66IH/93v6L+ifKicXL8z+6HvxV3ffaj0oX8bKadLKlFAD31H6ePRThtnKuEfoIWWMa4B554Yg2vqm+OWgQzN7a2xRJkkTrWsz+qkJJ2w9q18cPXbYoGnHANzZTE6QGcWqC9dZWlu+vryt9524bOh+altPjT5ZQAxplHdKzejpzEKJAdgXLa8SLG2gvc4utfnAQIzH8SrT6FQcTK9C/6ZdRq6PkyYK6sLN/xcvoqfyQtY+m4P+Et/Im+EzK1CTgYCGmYwo9wIc7Uhgz1/J44mQxSlKPax+VeyU1p8cuAWF5q/DSbqCwEB/Qljw8zsAt5j3G8Tk+qveX2fPvZ815IJGPD45IHM6NePkJg1DtIBpZGcTZMCPwEfgWsDDzZWpfiIdi0EIU/jQnTK6GQJGz+URs/eZjIVnEJ7R5FnulKePeKceReBo/5bAKEuefcDdjnY3sfQ8VH1rBIcsNnt9/yRmVXsLfPDzHoJJ5jeyFROffxB/JwsUGXwztWjjLfl0Cj4abrVInuf95EzavXzQreYN/X6RGT6zmJKK9nqa/Cueaccnxz0CdzvovekjzXPiNJn6F3lR44XU+gC14mPJoCQcrOgnuCYsE0k6zyWsJKkPCYsyS9AwAdDCZ108h4MAigeD/h0GTtyIxIfaNwCGpT6ZNkYGbv6PwJSrqd5DFvhPppos7o3pZXMVA9nbFKCVow3OilV7ku91+AJ2k8Pq/jfAISyoTUAOkiveQcBzHtFQA7A/C5/6G7EPCMoEtcUdPYFp07X03yj2gzxQAfS5tGogkA9vrbb4l6ZCfqAa2BfGEdw9sCtbc86TbBjwMgoWeI3WBmI7FbCsNJQGnvt3SSYFWTk/K1svMbwXcLssA0AAzzb1MwPi9cIL99UCk6ZfhpYFywhSBLdDOM+9nDz8XB54/E9lvh5UdKulkg0DEYCQQ7FRjjcRrf4NOXIg/1HIpNTdS2Adg5RoI0Ar5Y9XMK7ade5SwtHTAWliMziMrPY371I5sNU5q2sbgWBl7AHJ/neDHnuUFaMtSTPqkQTmE+88000axiC17JSNf78171l68H80A9rZz6PO94AcCcwZ+dDTz3KErAnEa6gTkztZCcMTCE0zYYNVs7qkDfmYmjyN7C9Ioc0yZQLoZpZDiRkcbnqw/dF3d94RMGzgSzNPhYZp7ZbRCzQPTMdaCjoxkxA9NxrueMdLO2qUnzrRJZWaaQ1acJec1nl9bHJpzC3Pv3XwE1BAaCwLhTwHo2WHacV15D7K1OC6fBruYr7o8xWLdpvU5o/CoC5Qo6A+rNNHnZuK4KcTf0PrOSKMe1DNZVLQwGVnntOX4M+tWv4GhWPWUffvcP/zj+66c+omghK5vnGY0SAvspUJdOHz6C+9bFL/w/vy8aSvboZ0rLiZ5D8Td/9NumpqWxpAFYhgw/7C895sXwks9VtuLEE4CcwBzrdzmodVXIm16NGIwGBEkvR5GrmBuNU8eOxubNO+P2nWuUsnMS40lgzttXlWPMakhdunQ3VPHX7tjS9fRCjVr8+fJJAOPehbtfiS8uWEy6/zT08vjle+LinS+XBDIwP40BvO9yPeSf6b7eWf8bYH7Hz1RV1sFjzkUtbUDafVJmFG2s3FyS51NZTrgI56udcNDZTwxqM1PbINZUFt1dvGICGmGF9EpcbjYuPz4BAN5P2ZrJY6T3Jx2vM/hTgUXIZctMA6UEEQLtaaNM1BD2Kafks097HlC6t/PecKEYvmnMqk1Bjn38bF+4vcakUOivBFcJm+V2W3z5797ERUvhRggQMSdgXgKQReCCtjObDDZLc3C84/usgvKejaNPPQoqSr8TDgppEpi/ATxHAGwaN0mChc2Q7eaGiT+oDDtAB4MGyxhMB2DOY9jiYh4js2EeT2+i7Cc9tG5FpvHIOKEnKwlCn9MunL9M1bBikd4iJIjb5nR8bqD1gh/lpok3zB/RKYnzo1OeQBaKdKMXix5j5iqGxxz5mKcmUd2VmWWq4PUHGFSGBwmXmuh84dqQ8Z33EtD3O/rX3G43O/nO9bv506k7Mo6SAqTx969p3HknfoY4m0wg4W0bnwouTUNop3Qy6iQOft4nItQtZqCxCNKz1UoDF+ucPfA8nSliHmsEWe5/+OvIR43TFvS2AV7l9h236tie1KFiyK2jYQze6/a47rabAMwbAMyPxzhoHnZYs+82VvPYMVsLgTkBNz2RFdDDwoTE5Qx6K0vgN2l+gXogrzm95Hw2243b8kSmFQCdPHQKdHiwH+Xm+wCeODr2qFJOpKPYqCLwnUPGoNPx1Lceiu5rr49VyztRlXYAgBnjC0OBwYgTLMQF7a9En6iL08z139SluJJMWRgDVWMCc4snQRdhELSD99sEQF+LlHZV6CcpVCNjY9EJ0DlClzmuK4F+1uPvQ+OI+8gBg5pMnoMKXEyL1j/mEZ/nl/v6pOSSb17WMr1s/oJ02QIAz+DPpQDm3Y2V8pgfB8e8Fb9fugSDFICaBZEo535UBr6ENXDrsmqMFzKSXGQaTTosYHxUV8YQgDk95hdw0tDW1BhHkJHkz973GzLqSCvSxOa6IEcHv82AS96GfoJCVFMex/YfUdtrwC+fxnxrhOd3BKd61dCB6k0roqxvNI4/+RRoMADFMhqTl3x+EyiA3YX91alMAuXUltalbdG9akVBlyZgZBx56agCirWs8OSTqTPx1YiMQJ1d8EQ31kAmDUidWgG6FvK4D6DC7LP74thBBMXj+T/3H34pHkQFT8Uopf5J36XHkBP6f+b4cQH/f/vLvxVtnSvUVuqx1k3IZRyFkf70P78T+oeA6eypgA5UIpvPNHWLRiZ0bq6qFUY9KC5cR3FSS8cQUzI2Ll0WK1etjtUImG2qL4977r0n1q7bFq+7YkOsQDByMYzLUwNM7YkTLhga7aAu0eiSQTg396Xx4qLf+KEtHS98p64s/v69lwDGnJN2Pb6244tBB/R8kX+OlDqLr38pEvg+AObMylIJj3k6d+YCJ2CRoWuCN1BnepkIdAnEeURKDc8Z85zdw+DGzkmDIh2lCnpwMbdHcr7CZkIr2t8SINXOaJDCF72C3JS4sWTesqgs4GpX4niaAJ3BYPZGJmCePLzyOmKTi2Jylg3UBEQJhBNWE5Eht13eWzVb3vLcl5z3mZv8peSpdVZx3jGBe4FXNT5tXBKC7iWgiaPoIlITIFtW/qyqRuAqg5FY5jkh/OzJEY4EYDj81CM41u8zIJRMSmPra94oOkcygwTCCycalCHALeXLoFL+ZRQl1suxqRUjBzy9zgw0FbUipTrLQJUbKDmX8nop+Q0fmlLLJfdhwXCinHSEbeqDZKlGG2DyozTH5sFJ8khLVtYB94ef5e94n+XEuZly41eGFpZqR0VEclknhrQxlgKY0+OqYFnqhuRmwJ/TYibooaf4PMaGn5qZvMfsHeaW7wkAACAASURBVD/C56mbCZLbTcrN2jooPdAAFpRFOiwONu8nPUnDzJ9FpqaOZGAOCoi81J5b1B9TtmwgeGbxWSxaZJCg1uASjSkNUoCGF+gxB6WH7WeF2I5tN7lJBNfIWLSkYSSa65fGNa+9IeoBFE6dOx1jDNbD3UppJM1bwWp0OdzjBHz0aE+TygJDTzojDzfayrF1HLXnVdLrXEJddrtShVoGni9FoELUIZc1AB/BOwyoYeg585+TA85bZGNAtHUZIwDbs6PxxJfvjOpl62PD9k3RXDyFcvPwygLA1JDCAkrOFDy1leDWlzLjCznpDR34WoozaaQUJMVBmk4AOwydKY1mBJQuYUpRPJc5zEcgiyXgYk9BpwiIyjEPGlkgBh8kN5s6Rw58WnKkV5lj7gFKw6Sx8pip2wuBabpmIb/6ZZ8r/OLP07Bg8GdHAwoMNVciWDWiB17VtnqcqE1jTcAkRMiFvKz9yFozhzmxHXnM+eD956ZgUNArPIt02pVx9sIIvP8T8bd/9xlw1JvjNALGL554QUbbGIwP6hVz4suxQVAKvWoBQJ2CocRsf4dePIz1CQAUvGrOrzoA0nFUTy1H/5rXrULgLjIAgqfdj++i5xT44UkuC4yNl8lLBqGfybFevXEd9Bf0J80tpPs8cyHOnTwjebOKK2mP7GAx4oe4rjP4++Ybroubr98O6ghqMYD/Tkpbz6lTyMby5wDUM/HDb/upeH7/U4W+LTy5yO3s7TmB7DTn4kfe8YuxGpQW6XmmsygIdCY++dE/jWPP7kkK7bEtr0chMzaV1UDhACqqaY3pYpx00jkAKksD6FYsfNe4pDM6ly2PpYhvWNZWH0/tfRJrdF1sX70ibti8EvQyzEkUahpBewnMO5GFh3n1k4OeO8ncu//43Z8513PkPx64+86jC2W4+PPlkQB0kpsIwTlBOhdoyp3888UiUZdH5N/Tu34fAXMuRj5G18aRNxoVPzHI44te51nmRtYFWFyETFwN0dlDDHO80SdPobwTCUhp6TUA8hG3/6XXc1YZPxKwFSAi8MMV2EAI1ujpgg8xppC39xK4flUJmDMgMIOHXNmtkKfbrdGXeOAJUBJZqYAMW5P6IqOB/F9eyaIxAAKm1JhqQBMDzOdEbQCQzL1IXnL2jEf2PjHIfcQjCZZB1UBJGIAU/Iv2l4KWwaqEQEn2yqYNX9lx1CZ4xp54GHx0G/ICCqSyvO5N8tpnx848mHfgE7mWxHcs1kKYNzLQi5zmiIEB/5ZpE0mlcVGbZAiR11FC3ghkY4tKL2U7IciUo5UoMAGSrBgJU/J6xw4QcppTy/YLEhvBqa3GpuwbvekGqbxWgJ6oSLxyer24YVFWTH3J4E8UlwIwZznxMhxH06NmgEh5uL0ylmhUwEAjyBL4p+4kcC6DTjJl490X6Z1wQDI8dZ+0L/NnfcaA06cBlouNRnLSnUeIlTxFyxLStZj0ZOqzn6preFrEZzuA2eNpiXgeMH95kbJbaCLp7+LXojDP/ocQgAeKgYB5W1e0b75BnyWYKb40Ba/rCNLRdcUNrwEwR4Bfz2l4zOFFtXFLI0g+en1GuqkTBwZ2MrObgTlbY2DOzvMSEtUU1Zr02U1b6EHW+OX5mmgM/L0Gutba3iGdYP8GkIpuECA96wJ1jdeJs4+mMF/14SfvjxM9w7Hr9tujAbm8J9GOUfDqa5tQvAV3YYrRhvalNqKoJwxuBkAfRVCecsDj+nFWAwVlrBzArgMAsEIVRXk6MAvAW6O5PopASfatHoC2FicyY/Co0pMpAzV5zclAojx4ElcOr/sUi17JEkprRdaZJI8CNUKi8wTJp4ZJa/RNf0l6xM9cQMGjdgDxbqZLBAo/BWDejODP6UswoAGqJ8mJXwDMN7dXKdvNgfMG5qTxPHb4cPz9l74cqwG0D730VIz0npETo4RVVGGQj49PYf1h+j5TTzj57BgBVQMgd9WK1njhuZfiEjzKTAWo3OP4LNtXhq8l69ci9eLRqB8jte4ZjZtog9/xWqgXC08L8vsEtpuu2K6TGH++KI4fORlDOBFkwSNl12Gwa+Ka83SQzgUaE+/5rXfGrmuuQF59BFsivubEufPxtrf9mxiE8bBhyw4YcdZtrR/4T4HLyZimUTx0/nycOXQ4bn/Lj8fVr0ZGo/SizlA3aLjsfuibcQ/oP5kzz/Yt6VyKjCwlMG4mcLoJ+lMRUkqWox4E2tsI+ko50rnS4VEJcN61ci045o2xeimyIiGu58CBI7F61dq4ZevaWLusPXpHp2MA1lc5DJ/mWjgZVGXbCkF5vecDfxjP3HcX4p/HPjYzOvDb4xeRRH7xddklANkj32VchS/SXDhJeHKxD3qbJsxlb8LiA74LCXyfAHPmMc9bSuIzE36IY03uML/PoxY7UA24BMp0VE+Q4I1nPivBPFfTPrPkiUpAz6DcexUBPj9fWMi1h3iT48LJlGhKk4a2TMELR+9vGY4SWdHO/PIE1vQt+5P53WDZ7s0UYISn2s/G5ydvJd0WBIvpxJ99Ul9E+eCOS+BqD6w97gDmeJ+nCARbfiXfq/BoQrDZO4Mj0SKAc/pMJ3DkTmBehiN7VuEU7URwzi/1GxvVoSce0LW6q8BAaWy59fXIGJCO8vkpk3jVR4FD/gqQW4RNlr+MARSRE1nEQFNksCE3WwYK25Wr5/B7MoI0luJqENwSmGfPLjcQykMHsGmg0+DJQ0yxWycEXgsGXQYk7DmBGkCDhJwMNz6DmyPBgr7Ta850nDxMADCnxxRpJhlwxUw2DMrSwDAdn8bE5pF0TvQdNoS35/0B1KWP1mkZDvlIRM3UQBlwJdnrp/QZgvNskxSGOIFuf8xGpLzvDC6GHGns2XAgDGQueQIFjwtbqhSCWX5ZTwRULW8rgGkKReDyTo2OxAEEf05CDrxNHUqNt29CdglNGs7RGQQQDkdDY0fc+JqbkBmiAcGfx+AxZ55xPnAeIroSKr3Z6cQI7ZyER7UKdAjTDqy2LFZFcGYusk8+REkoqDTH11POMki6m66bAo2GHNyWphbkP2/UtQxevHjxAtIsjmh+0pNPNRTE05jPxMDZ4/HoNx6KHXf8QHQ0Aqwy5zi8maQLlMJjOgIaQ1VNM+ZNNug5/KUxWI2MLqC5MAPLGJ5NDn0LgmSrQLGh/KtQQr2aAdDQnXFSO/BiBpcazIkKXDuI4FMaBzZKOH6m4xE81eG500BQ7Pokvy9YowxSrd+mRfjneV1JSsVvVqvCHOezLgKYL4XHvLvZwPwECgy11NEQYPpU8KNpr+KrDx5zOiY2toPnjM8d7WOV3KLYd7wnHnjqsXjukW8rK8kcTg9Y+bd9+Vp4oo9EPTy+UwDcM/ib1sgUsUxPu6oWwxBcs3Z5HEdKQRbroV5WI1iRxdAqAIBpmLevWhmnpwajfgAVaHc/YmM6GZW5d/8Y3ec7/9aMVJvd69ZKZzKd6djB4zHUj3gbrGd8EZyTwkMjSKeYTA6A//7N294aazdsgKHB+g3FcQangB/+0F/EBMa6c/nKqEQAbN/5iwD5FyEDBhE3AlR3aC3nHjMBvvyxvc/FDuQzf9OPvaMwBvmZXH9OQl5/+yf/WXUg8ig1gv705re8IXrPnUPhpiqccEAG/VjBYPBV4HSIlCtyz8lbX9oNPjnScq4GXWdiZjwef3xPdCxfExtBx7nlik0Yr+LoA5+e9RiqsDbXIn7G6fQ9J/8LMsvs/tKnsach0eLQwCSCcT+EAfq9kXOI5l18XXYJYAza8RAWKGKgKCpJyXt+5LI/ePEB35UEXvnA/JY7fqayulbAfH5L8VZrkzF5QgtMa75nAkQOGFz4SQY6y2ec3uQG520tYWchCvOjWeDHx+zMZmEvJnevAkAXW8S7E3PwqmgOQOcoqSD0vCD4hhUDVexCHlh76IsA2ARURfgVHDK2TgApBz26Jfakyn+s/9PPyeflMuxso73UxFw6elX+deatMKhLbA8rWRZI/q60XMwhTEpOEaqWIr8y2i4qC9tP8MMWZA8wf0OfD+15ANk4BhPA4vPKY1uisgi801AgiCQn2fBAwJSglHKhsTMOKgyBOVMlgrypI+I5AW+DMKf4s/c88+PnPecGmJLfAs5GLigz31UDtZTAUP3QETA9xSJjO4uGNmXpjf+me6tIEygbBD3KucesLMioQW8lgZQ45sh3DZ5mETxUprIwj3nSTRlQ9gDqZCRzKwiuCHTZBimV9Yq9kTHpg4k05hZGpkOZ7sT30jVJT6Qt8pomBEbd5r3YH3XF3nX1VV5yfJfTmYJm1UpTwMTnV6uSXolzTRzMi2lkyI2s3xn4yuDPWYArGrcty1ZG89pr7NmjcQPw3t06DvpBZ1x/y/UIlEPlRxSVGQV9Qz2XkrPzSc/pqWY8BgE6/jYBj6qycYi6lQwNUnWEywni7T0lr9w0AXVOgqGxqEq7yQhVnwiykWGFvFy+SgGIWaCoCrxvPmMS/biAAkicx2yTM/SYxsCmjo9eiOfuuz+quzcga8hWFE4agcdyHIAFGTBQUXJqZBiey2IAJdYPMfWHsptGdqOLFU0ovOMKlgQ/zGs+DqBG7zivofdVaVahVzWYD5RNA7zK9JjTc+7TFvYszWncpxEAKtN8JqCjpMJYl71eOM2o37Na+Gf9XhDVvOGX/8Y5xHSJncjKsqIJVBbkiuhBVpaGGgJSBISDejIF+bP6Zx9AM2lNrPzJMTkCYE6ay8Gzp+OrD3wrXtr9KChJAO8A5gzmbUD6vgllgUIubWaBgsxY8EmFx0APmYSR1Nq6JHpPHI0OeHPpBDh5pEf9qAWYH2fqSQT0MlNOYzMqWna3R2nfYLx0772mFS54vYw6kgD7y4C6jJeSWLl2VdS3tOqTCgDG6+TRE3Ee3u9qjA8/w2BNgnKeFGlVQh8bEdy6bfs2xSsohSj+Q46Z2Pf8XrV3aWdX9EPXLyBVpNONcu5CP0Af6V67WvnZuZ68tGcPrl0Z7/iVdwkQe8g83pxng1iTP/IHv6n11jqAEyXoyU/+5NtiEAZhHTL7DI6Mx7nZmjh85jwoLKAiQodYWZTpZ1s7ukFnWRErULipqGQuHn5sN2hdS6MFwchvuu5K5Y3vxykW28/c+rWsHKr1VwtZ/MmHPxAPfPEzseqKa+MQOPNebi+N4dufjk+OvzcGkDFg8XXZJQCdYmpFplhk6iAeV5N/Th764uv/RxJ45QNz5DGvQFYWbx0558g8bDCw5YLo7wV/KT0aBBMJ4CW/ZQHMGPAlb512KN8/QUB9l7fM65LvpU/Qh+3NTV50cczJAwQwxwJIHvQkqCD0lJeAysJAIab68j0S0hLgJ5GAd+JG4hBQUVXyxqmVTwjRDWBxobSTyisMzzKPObnxuokEVAYkBI3ejFMfeb1W2QUdWqDEApzyxEzr2wSC3HgMyiPRIhS/IGqwiAwJeFduJgcfexCbKvjVxgD4e5mBOfrsVGxqghZ49UJeO2ZgYEAejl4hu4kBeMwJaBMwZ7YBFxdy9/UZSSYF4QogWY7KC8w2JfDh6/LD3F7jYsommzS+hrnlLVqDdj4zGy+8uwMyrRMEBgRqrh7I42Xm+oEeANRNYtOdnRpFZhkYMamwh05EZFzw3lnzCmcj1ro0VvNVQC3DfMyeMFgyFlzUysNnoJWpLNZ6g3oZH/ogesh+J1Hk/vOz+R76HI0DqJ+clZKPOfyi8Vj0upf35qSHnDf0vvPUAHo/NTYQLz74LYAueHXx7NbutdGw9iqNP42LEtB+2pvGYknbsth183VRg5OYUwTmAFcyhPiVjMoiZI+5hCOEUnics/incEzPTBhZn9mSWXS0jAGifEaiHeTKs7nTGnuBLk3cgv7xoTPwQDNXteGNjZlq8L6bwcktQ9Ac3xsbGY1BBBPCLyyZyBBhg8mdnh2Jw7sfiv7pith+3a5AIosYZVYazJVaAJ0Z8O5ZeKoKINLFvig+D8g45m1fWUNM17QgVV2Nsne0AmQyawvlV4WTNhblqcR3vlhNtBoAbBieZXKuOQr5jIF9L8fkI50lLxcTTEtYWM++E5h7ffCMyquGHpOXuTTWpu9cHMS41ZXEihZwjjEuDP5Ewg7JiHNgioYA5vLgKLKuAHBv60TKR1YI7UcaQel4xLef3hOf/fjHkDFlXAbRHGM1AISrcFoxifSV5GlPAJhz4cljxjWwoaUDvOsjCK6si5Wru+OJh5+QDtQgIws97PSc09tegbV1+c3XR1/PsTi9+4kYhVd64esfozZxPSYlhsYZnQKMA+he2a1Tr+wt5z3OgF9+7uRptVFFhMT3xlqAPtJQYzapDfCyD4DSdBa8cqWdlWFA6hfS5YKit3L1qugF3e9sH6rAgvqGm3Hx0zXVANMbV3RF0dRIHHzicdHPfvE334dTN54ccp6nJAZ45jhOpD7+wfdEb8/R1D07et70htvRbvDuAawvwalxarw09rwAuaGSKY3FIhh6HNQ6GJ/dq9bFyvYWzMHyeOiJPZi7k9HR2R1vuvHa6ELV0zFwk5j6t4zjw0wvjI1Ka/in7/pKfOljH4mtt94Rj//9x3zqiT8y9/z4KApfXCp639jUyB/H+fM4clp8XU4JYB6Qu8viRJukSLCZ8cUMLouyv5yC/1+49ysfmMNjjjLf70/Q1hsLPcHYnAVnBaqyH5DA2a5Gh7F5I7Jnzh4Oc4gNMnSEn67RPQQSEqBLQHa+1DIzVuiPOq5VoJKC23is6RLtApWMosc6VQZaRik8fSrRnYC52sL9yoTmgpnh8fZGWcBshOhyC7KJyUxIXjtnJZnfTLNhMqviQ9509Zz033x+lKxZ6e8JzBmYkzzDghwEGUMqN68iLeJMmyajtnHDIFaFd/3A7vtjBgCLjXT6uuLYfMvrsVHQwwlKCAQqZoaYKFn+uBabcDGAETe5CWZlgbeZmVx0uqCqn2xfzjFP7z8BXKI3JDHZKEqGF8ey0NcEINkqGSQcV7eP7XdwGO4/R892MsRkAGUDj/jJoEKeZNE3eKLgnMhKRZj44qXYaCcBwlj2m95zuL9glLgsu9Ml2jDKZmP2/Bs4WdeyYZDPTgg2FXiYAJTAtKzC9KEEJNWqJAvpLI0P3c2nBzaE/A8rexYy4upiAngDxWRy6U11l/SNbATombiOBwX8hvcVVA2QptgNekABzPchz/IlAkvctxVBks2rt6fTJcYBTCOAcDiWtq+IHddfWfCYjyETCbvlgD/3kV80gGi0KXgXbZyBV7UKclWGGWUoscyYuYX9K1AXKAvdA2+rvemePB1JFJwM0lhBkp7yJD4DeOo1nl3f2BxNSC1HXeSzmMFlCGXRRZuTOH1fpgs89sLuOLr/dGy55bXgiIPuAT7yFE7NqhtbpCcTmEcMvuNJmrO0sOV2LowDMPWVIasGaC5NAPAE8sMw8poB0peA5lKdQCL1vobefTSWgaB57ZIU0LeyBM7ZRdIQmKbQftZ5Iy/9mmSXFCPpuC/MV6RpwLdwwwsA5m3glK9sqRZt5VDvGAAbDAEATlI6OG500A+CAjENL/fWDoBDfPbQBbQTMuLYHkZA5j/c/TXIcDCO7H9BXvNKxGLQsJzG3GlDwSFW/x1DxhEuQ7mKMLM+sTZEJXj2V193RTx078Mq3FMBYFsGY4VAmR5z9n/dtbvixNkTMXfsVJw8wAqZ7lAeb40X1jE6GvjZKnipeeQyhVMI6lQlvMMd3V26p8Go14peeJ5PHT2uegX8kscc92bqTOpDM+IEVgN4P/nEEwomznrGD5dhzK+9Zle88Y2vjQ3rV8ZTx3vjt//okzFDA54vtJ0WXe1EX6xdtTzOHnkJVZTPxs/8wq9HO2gn+WVgTH77dPz9J/8yXnr68QX7V1Hs2L4jVq3qwryqxqlUQxw4NRR7jp6JGpzGVEGXixGMTAcC19hVazdFNzzmraDWPPzss3ERBnJr+7K4cefOuHL9CnnqZzCupPIxDSSN3yzD+55+Mj6LYkmtqzfFM1/7jAwsxhLVNbRgjlxU8Gl5ddUFJD14z9vf/mt/9oFfumOxSM78tLosP0HPmWaK6RWX44vTfj++nsOYvfzY6LI8ffGm/z0JfF8Ac/BB36+jdjqsCCblV3Y4H9+XBxFSyhxyLqo6RC5gmQRusj9a6zY9YIKUqh4oVorwmI/qyePM0FfvJWzEgDQCnRICBwIJgQV4SlgwhFQWbB5jwyhpz2I52ABKsAEbmAs5GDRpteXDEjJOEE1ASXSJbFRoe+HKzN5oY9VfkhfOoMoy8JW5zb6HvGLibSZPt25l4K4rEzJRH+jJAnqjx4vpEnFKgT4AYKPt8iJx2pN/zEbgZ/JADzx2b8xlrjDvieu2II85QY8kmzZ8+5k1cBo70ieYe1enC+CYl5YhNSN4xDzWnlNxIfKzCWEYzMrUd66wqvI3bEMC+ZKHbo5PEICxTwm4iabu1B7m5iZAa1kQfCZjTn9KwaZJHgbCCY2KS03Dhc9nACg9xpQV8tRjsyeNYXZyRMWYWGBIgb56Bk9F+GyDfsk7G1aFsTK4zOwWGVX4haCXRo3GSTqaU2JaX9U8vU8urv2nDjr0zahvNIzUV3HzDdbsvaW+WE6i7osLz19MsxKgSjNMwJnGD40bsbHIUXcgIzP5kL4wNTYYBx75JqgK09Li1u710QhgTs8bYy5KcU1n02C0LlkdV1yzFVlZmuLEGRQYAjDPyNgxCmwuDUD0CZ6/XJWVWVloJFpQnodEEAoA5HsEU5QKsZTGNM0Fyk+nSfYQawalMZ8G95fzs5BPng2h/mjMKb/SaEW6vnrkgPYUmo1+6OkIsqpkMM/nTcNomB6/EI995Z5Yf/Progt83UugtgyNTKEcOoI7MQ8GL5yLalQNJdDnvQmwSlPMCfsyjBOBsu5tMVvdEKOgRdFT3tbYCE85sjoB7HDcSvG5ehiu41hbGOiZzC4Zq2UYvzK13XQefofTXC8DVOuLf9e/lhN1Ud/93sIFIas/gTniPmNtazWCXYvi6IXxaET6wnODGBNM8VJQ3bgeE5hPAZhvAzDnZ186D1oc2kIOPKk6e/a/FJ3w4H75G3fGoReeB11oMpYu68apyQgqhY6BnoGTCXxnszVfRPnimoT74NdtV2yOw/sOokhUv/LPN4C+Mol5p9MhdKB9WVeM1iIrSt9EPP/gfXpPFCfciakyuX7RkCC4rgH1xHUkcDKIk5NGZMNpaV+i9nKtLhh6+Htf30Acf+mwYgJ4IiaPeaaz4OcWnLAQ7PccOYT1EvEljHuQvGk4lsSaVevj5ptvjFfjpIi5z//Vr/1hnAE9SEKHXmOziOKLx6OrexlC9mdQaOhAvOZNPxrXYA21sZjGixLBevvAPXfGA3d+3oPJJ+Ga5d3L45pdO6BrZaCmNMXzAOXPnsOahLWptWOZ2lNKSgv6sGrd5uhALvOlzY2x58X9cabncDQjY8u67hVxKyrdkr7CkxK2j0GwzCBk1SmKvadPxVe++e1o71oan/jrD2quci2i7s1gPEvISweVi+1cs3HX6bYVy37v7i/+xYfjySdZMGfxdRklgLlMDhb55+B1BQ2iZ6EbBy/jIxdv/T+QwCsfmN96B6gs1aCy2Hq358r+xeyJ9NLhJUReKQUs2zelUuva9R2wow063YFMb9NZuMHbE2zPulBC2ugZmMcbJ4DM22FTZpo5bfr4fRYp4eix5IbLhXt0qA8LJap+AmwKmC/gvwr8J4DgWxJIzHsuxXlXk7Vjqh+6QhfrV3s2dZ+cYSV7o9PVio1MdISCAqUPCpcZypl4zHtDDgBQpBLMTtLThw2QBSrAT1R5Qsoo8zyMXRT09hI8pVyU1SxuJPhvMzaVYu7aqfl54xdIIMjhd+aP5iYAWU32nUfWA/BxwZUtg6zosXXmnAQ09SF9EH9AmxdyZhOoEJ9Z7bPXNwMR6YPeXghEDDwldr6fPmu9oIzsepABRu0wElSOa2VSwF9F48B/5ANP4Vh9BuC0HJ68UuStx25mWXDjYjEeepoTCEpEG2tqQX9MSxFP2sprsKTvNHbUJFGm5tPAJVClIU2nAgJclq8DIj3E0ul0P3cvnRiwlzNCs7qAWVdyzEYJaVY6oTDMdUGmBBRopBCYk2tLw2roYhx49B7lweem3g4w0rRyZwKF7NNsLK0ZQPDZ6rjy+qtUSOXkSWZlmcAdU1aVNGAKhsX19lZbX1j5sxLeY4FR/J4PuXgyoXgFzsXk4fRJlGVTMD5TfESWKXvCe5JilmaU5xTGgNzhXGyGpx6kozUBUNYg3oKvKdAxLvZdUKEiKtY0vhOAsWjLs/fcjYJD3bER3t3JflRBBQ4vxfypQmq/SRjqs6C51EBHVPERbVTmIbYW82gGmW3GUU59qm1VFIF+0AngyRMYyoHtoUHBDC6krIyn4EO2h+9nKgv7R2oYvdSTjtrTKwPw7/y5cMF3XMP3fSpmKks9qCtr25CfHIJ+6exwLEHQK4EqQfcFEM+pDgTmzJ6zDekSOUUOISsLQR1jBagTLDDEfgwjpeZnvvoVZMHpiw4EW/Ze6Itj+/bA+wrshi+fWpompfSzmnOz0bWiEwbQZJwCz5yGb/OSNnnYafgwVSW9xWUbu6MWhsP+h74tqks9jRtww2kwcmyZ29upVpn1BlQWrFE1yKJCo4+yUwrKNG+8PiNDDuhMh194Sfru6rPOfsN1i9lZaHhOTYCigjE0MHdhIgPzUvDf22Ln9q1xy003xMoV3fGrH/5cHDh62usYH8qKwUNnUSioBSdKLXFy7xOxftOO+KGf/gXF2qSlS99ZJ+PggX3x6b94b8Hhwee0AIy/7jYU9IIcliKw89TFoXj0aF+cL6mNttUbZHSzb2Voc2fn8li5vBtUqdo41nsuTp1BW6CoO9ZtiJu3ro9WGC0yYrkWoW8VbEOamwNY5+967Om4fvuWePs7/w+0HfGHnJJMHYt7V0HWNFIUYjsyNAAAIABJREFUT4VXRVN7DJw8cCxOHvqdiVMnPo63FrOILJx0l+FnjNsq3HYnvpC3NBiMsAfjd+4yPGrxlv8DCbzygbmCP11gyEAJC6NP4bk1Ja+PQbI8Lb7KXj8FlTGdIBdCggB6lIxF7Hk0qBGgy8f/BYFn7yL/LmST8b1+N54RepP3mBsIPagMAh1CVpZqpKkqSx5zg3zf+OWLv9vhV/ZkG2Rn716G7fMe3JzBg/3IZwcGk/SgCbRTAnog2+kThfngSO4JyRihHLgHkoaTkucxuww9/tXMGYw83ZcYzIgN1t53e3IpYWZM2PcIgDk2ZPkoJcaS2IQCQ+Rv6pmUmbqWjte5SZCbihZW4N6zAOhTQ70qxMQsLeRl0hMqAyydEHDA9GwB3IVjouE2YNPj7Sm1DUaTLYHyQvCfx1hUBMqKRohuamAq2aUxzRl45LnX83GUjI1RWJFgkFkjeOSN9k5iYwZZVpzlYhRl4kkAs50Y/vveTmXJ8fLJg3+2vrI9WRdtbtqAlE6m6/h3liAvGBn8hIA3r6HX3CkeJQcOkx3xmiuWP/9h/zw/BD6TfJitRSdOpLuo1dTzeUqULRgDV51JCJRTZ/gzuK8A5ocfuQeeXMRYQDZtqzZG4yp4zHkkTo85OOZdzSPIQrEydl57JTbwujgNYE4qC9vFPhV44BwrBtaSFoTnlKKTUzjJoa5IjqQSaSoz8C3RXZLyEZDmgF7JVtNKN2djzcnn2OOtaaS4pPfUOu15bYPYRhIbVqa0nQaKBG8NAFmKucDFY2PDyOByMSZR+p2FgwhA52bH4tT+p+Pw/rOx647XIzLLwJ0Fd+qWLAHlZzgmQEWpRBaYHDye5wbHaQbFvUaRAaQYNIbi5hWgJbSBwoKsGmw/2sRUrAwYZesYDMqOsKmVAOv8IhZn8KfSWHpZSsaR9eIfe2XP+ULwvvA6ZmVpqCiK1W0oOAPhHruASqDNNQoO5PN7h6dZIRLAHGkgAdw2Il0iZX74IgJ2WTQMOjUNrsvIuCk4HOfnUFzqK3ffpeDWoy88gXiWQVFWOH80z3KgeEqfSJBdB15585LmOPLiIelFNX7naQ0pKRM4sauBA6QC+bjjzMWoxmnfKKupci3BGNOLbWqagTfphtRL7xN57fXczOt8BqMTMAYOAZgTiFfRqCK/PHnNCcxF5xCnnNlikCoV91aRKjyLz69Gtp5VK1fENVfuiPUI9PzQNx+Lpw/0aN5ogACmi3HScAnUvyUoYNX3xLeiEZ/52V9+F+g+CL6nziZVplFAStWf/e474TxhwSMboDWIv3jrj7wl+sGt7+pojzGoxkOnJ+Ng+ZJYgvSd1QwiJkUQ17fAgNmM0wVmAZqAnI8ie8wIqIhdLS2xA8+/clUn5hqdS16fKnINCzSVa9NLyBXfhMJK//7dvxeDmMM80VBJV4yVjCPoJ0/SaKwuXbEWpxrDcfqpB+NS34X96O+7xvvO090/bzX+06q5+JfvUgLQC3rStuBrM774M9NaPonxRCDH4uufSwLfB8AcwZ/VTpdIECLIJeDlTTP5OTXfDZ+51xpEGtIZSHJpEUDXWmxgo+sImvNqkUC7S91788lH/wmaezMncCRIIEgj2Af4IGhgcQYemY4jKwu5kCqIsYBjbk9wAo+FbSAFavK2DCwDd8C5qdm/7A01yGI+aqbg88pGMGlgbkMjYWNlETHQtMzYAwNVvQg2EmjWz+K+soojrsFGOonsCVPIv8tsAczNzawsBCgJlhnw4/PTSK0objGPZJMMCcy33gqPuVIGenF3ircErvEslT4njxpgiwFjU0MXxEnnF4GuskiooI3HTR5fuX7xf06NSOODmxbpFOqDS8jn8wP3mw2wDlg2DrTN/H5VhVSqSQI3XpB+lmhJ6/DdBFIV1GVPkgn25GGijxjvCfBkccTg/Mr0mKu4Er1G9pbbCDJtSiA4UaRkQDFoIZ0GmIqSwWXSTyIvbvJJ59kLjT3vJUDpYE2+qZz8iYoxn5VGpoUhCJ+jIImkE8lIyfQwA2/e21UveU/Nl/Q8V8xloyVWBb8RlIzDCD28+14AEhaoimhfszHqVmyXN53836LZ8ehsHEF2jTWx4+or4DGvhce8B9lWeKRPMeXnJp0Xx9yZRvRE3LcyBWS6LfbWi8rCPOk0GtlwyNYVYwlmrPMcA3KG6ayz8eNnMF0iqUei5uAjPllLKSB9biKQpVMR3ZM5nVEsB9zvJvDH6c2kLjD/ObnTlJLagJOG/p6D8fwTe2P9dbfAm9kAqgZOVBCPUVWPU2Z8n8DcqgDNhR5ntUmUOItibg7gvA/xHQA/RXXNUbtsC7KUIIBU3GfSVkqjDidLTIvIiqB8ZCX1jX0wElevfTL43eOfDNgJzGuRg3t1GwppzRSpbDs55gwM5N3HceJCN+jw2LToKWtaSbdBvvPBGdAi6PEv0d+4JvKlOY3GfhOBjj1HD8aLTz+GAFukliXwBbBt7+qKEwcBhNO4cF4ThJaCF7581bI4+PxLAsakp5SjDTSUSCGsZJXl5W0KMF0Bk+jk8WNpnfYa5HE3+F5YfMh/856QZTxPZXEWliOgsrAqJz3CHHNTWcj5xncW2EoURmZZ4RgwuxVf9JiXwFHTAQ79lTu2RDfoKl/d1xNPH0Eed00uPBceeVg0uLgs6pZ1xvjzD0YlHAA/+8u/jZOaJRrXfFCpU03oz4f+6HfiwgmA4gTMaQD85I+/NS4iVqejvV2B98+O18YjI+VRjSDidnxVAJxzztSiTTvBZ6duMOPWPtBTegHoty5fHqtAb7l2w3JlAcqns6KzMJbDqiWj40DvhXjne34vxi8gSyKVAIYFDd8qeNu555HKSRny/pUokjV8+ljMINWjc9eXP4MYkt8cu3DuK15YFl+XSwLQD2ZtIf98lRUucPQTezE2GLDF1+WWwCsfmJPKUlX3fqUsk1fXnFJBc6Fce8izOzv5c7kNGARrBNLmn37Oixo5poWrkucs3bLwWXnzErSjR87p5LyhuuQ5viujALxsLCqChYqlu+kFLldAIyt7ZljMTcD5sbXYebtwGxO4cjhi2lZ5rYD4/CabDQqnWmT3edwIr4W85c4cwaud54U4hsAiecwX9l+gk38iwGI/AJaBYVQwBxkmfDTLrCwuzmROoRdotn4WRUGee+hubYwGJvRIISsLgXk60hUoF45PQBPX6T0CaXgDZ+ExmhzuB0giMEfmA3rixA1N2TRS7nJDU1d0leQEPGjAmGZh3r3pG8J6em6WY5YEG5mMFXnRTVuQwaZbGuByc3XadjacXklstNpwWZ01jYNcSjy2hYcMNARyzMtxQlKcjQuA9nwczvZxXNRObaaJb25Cg+RjV3z+nv+uwVK/XZHW/faF6RuBeEaFMmDmdSkrMAOc7blPH0uDmKk88oIz44845m5HOh8pPFMGgFzVNhpFOQBIYKDmGApEHX70AVOh8KQOlPquXLZReuXCXFPIgz0BTvGq2LZzhzyBZ071gE89YsMn6Y76yaImMPRo5Mgjz7bgGTIQ0xzgKsCsMAR9BnAErfw051YyQgQAqQy4DsA8FxbTjMM9J+GtL68iMGccgASrE5Cc7o7vEKjxs3muZqGTatWAKp91AGJ5QtCTOYo5rzkIWY2NnI299z4UrWu2x2oE/o2B6jQHEFvJfOdoNysDV6Z0dhp76i9Fr1MBGPbIPFcCKpkyF1U0Rt2qHcpFzRgMes35fUJFh8w/N8hPKoTv2WPuNn/3rwFQWZYiK0sNCiqNzJREH6grlSiKUMlTIchtAkeXnD30iI/D2NnShSBWLEUHe8cVtMmCPNO5+FFqhoI28fMf/dWH4+iLe3BqBmCKsa5Gdo+f+Nmfj4+BqkFHAT3inEOz0Ac+azkysxx58aDWKp5QVAIoc81ikGIljTQE3w5Xl0TT+fGYHpjPzFIA5tQJnZjktdjrp9Zf6bxPX/VOWkM5LucQADo+jHSoPBEjh5+gHDo5S2BO+g3Gi6cv1XUNWiNmUrsJzDmmLfBGr1+/JlauWRP3HzkfLx4Ds4DrBxdbeOQFzPkzqDfFJ/dFxeRg/Pj/9qvRuWK1KDcLgTlPNr/xD5+KJ++/29hehkXE62+/Dek5y6MOucu5JvXM1MY3zuECGJLtoP004MSH06kEc/bKFSsUjFyD9KAvnOiJs8gYs25pV3Q11cUbr9okamIN9i0a3tzPWAgui4zSGcYA/+v/61diuhfAnI1LXnMaAcxyM4u/81S0fGYUlXGRVhN6MYi0l1zrNa/Y16J4AqfMvzJx/vxD3712Ln7yf0YC2HsRKCP+eRu+OAjP4esAdGceVPzP3Gjxmv8lCXwfAHN4zKuq3k/OheGJmeXZF5zBYmG95d+0ABuMyhlKj7AQjIGZ78ONmy5og0VBP26M8jhz0TPNwNzlwicWPN14Sp5ELJiigxCQYnEexUZdiYDGMpaahwejAIq44NObYPeaFlYCQc2Q5M3PoFJFh/ToFOSq8o3JXalNhhuJjRLBEYImbSj8m4/8eQNDT8rMRWLUf+1Jvp8kykbQA4e+TgKYz44imwSAQBGDf4rJzeTOZZqM4QC+YIA89+Dd8CSyyqQZA7x2+2t/IGWGM9hQ19IP9rTS88PThXJs4tMxAo9jJYAYgTmQENZ6B1Bx0VfxG8kMvZK3mX+bv682VUpAOJzeZgPHhCgt44JnOdE9OF4yMgjGPIb0EIsmI3CfjD+jdRs9PMlglgjVqMaXuMjwCGLTUrrESRydp2DZIp4WMCOLDAYDRUks4wE9j+02BaUQ6JnaL4OTw0GZ09jjPZyE3KcVVmjd37L1jwlf2giizkrmQhz6WcYkP86THo5+Kpar6rGzrO7K+ULfsTMBSTeT4erUknyTVBwbROJGAyRN9J9F2swMzCOWbNgZdZ3rxYnlg0oAVFY1D6GozLrYtGF91DeBB3sawHw0BVKmxtPwI8AmMK+ALtDjnoNQWaIeE8vzjeNJww5BAPaCO4uGpF1AEPOGuHjOBRBDQUHH4amsQMq4HN8hnZKx5rlDsTFlXM6Nnk9s+L7TVjolaV1TMwJEUaCIrUO7B/rPA2ehkA7uMTc7GsdQGXdkpia23Xid5hTT8hXD+18B7/AUMlkUVdTBQIBB6hmV7DOPA9OQ8lS6ApmdRuGZr16+I6q71mpeMkiPjTSlBWENBDsLXiYieQy/85XnYn6/MDcXXOv3imIYNIc18JbXwkt+EZTi3kEEzWKM6EUld3wS84JeYQJzBkGvBeWFsjkEKgsNGtI9pEdy57s9LLJ018O744uf+zDWQfbVukrQu+WKm+O5px4Anx7zDXLk+wS/vGQZeOY9h3sEagmAawEEebpXCcBcxSDZMrR3aWM0nByMsXOnDVpTbA+lKwNLw+/Th9xvTRX93WtLnldqF76Ghkajv/eiOPM5M8sMAbhoLMzQNCMPPvPgTytzk0/xCMyZRYb51ld2dyMd48rYfW4sevrAKEiOmRhFHxFrocnLtXb4TJSNnIsf/qn/PdZvu0oGSGEExW+fjeeffTy+/F//0s9JMt2+dUvsvHKL0lE2oHjRieFL8fUBFAJificUIapDKtByGkRYs69EYaMWnMjUIt3kUVQcPYGvNvy+vr013nzVRoz5SLSDe88c9aT8VIP2kk8cci2P30R2loe+9jUrLOc5+t2A1I+kDfEEoQipHcumSCeyMT924XxMj7oyME+bDM6pF7P3Ij3qr45dOPPEf6Ooi298TyUA2S/HDelBZyaXIXw9hXFdrN76PZXy/M1e+cBc6RJrEfzplwCNwCcntykCBdtPPySwljcn+eUIvBLzXF6peVDq+9prYoSsX72xcbvXz/meXsT1d4I2reN5ccImhEWMR5mTA0PKzV0Kz4OCeAQoC2s+fpr3zpicQx6kwRub4aNpP8ek+OTNZHvoqZcXlF5o9iOxq9MNBEn493RE7pvYUyj5CQHkTZsP5SO4yHtznGCWEfBhqxHwJn4587HT95lcN/ZU41/QUJ5/8BvyxHDB5ZF/MQLctr/mTVrICTjVJF7Lh+Rnko+PzblUKddwtI9A2RKAjQr8Lq8sn8k+ceHOes5MIJKfhZTztaeh8r09KBoro1f3UcAgCd96YpqS+cbp7IX0GQJyfFR95d0sdm0s9A7Tg8Rze2aC4HE2jQR6nqbIlYbXnMGypSwyxLFmJhuCbmEB+eISxYBj53v7L9a1rHd82ykQk/FJOeBNcZ2pB7yf2u3PZHXNu7cKCykdqI0sGWoKrUAfuElqM+enCE6ci9knHbyxP0eJCMTkXOU0kHBPgyiKw8Bc5ASM40j/qTi6+2FRm8iAbt+4K6rbu/FMAhPkd8d4di8ZimVdm2PTto3wdIJjfgZUFlQ7ZCkWJw90W3liohR4MNRkACRKDcEfn6jc/RwL0l1YXZOyYG8yONeA8T2+az0pgYd3LuWVVKYlXDOJZ1eCm2ukz44k80mClZAlc+qgqDBpYs7id8ZY6Hp8lhlWauEFb0aAqE5M8D4zq/RdPK8TJdhuMdZ7MB68c3fc+OM/FnUw8gaHx0SLagD/9xKCIVkdsgYAXy/FL3CcDWjmpseRI3sAXldwh5Hv/xKM/bnG5dG1YZvSKpJTTo53ni+i3VBSWrwWeoc9DyUXTZOC5rzsZ6uj1zr+PwKjc107gsAht1F4/M+CojLKLDIqAAWDAICU69soikCRT7++vSJGp4riyHkaJxST26BWpQVozwsH4mMf/QBOmkaM63QKA50DqFu5bmv09p6KWRglBWDO4ELoQseyjugDQB5FznCC9ToA8yl4d2nYsDpqKcZ5tLUu6saKo2fP48onzhmWg8JNmfKJlV4cS/aWWZ4owwTieT1TH1IXM4AfQnYWBYymzCwFYK6UkTzRQVEozH8WUfKaQsPMwatcD/j3YlCSRpbCYGU1ZU0ktAGeeAFzvkDXKRrvi7L+4/HaH/ixuBppZwXMJT/St5yp5hROmz7xgd9XgKu7UYTMMg3xYz/6w9F7/hyoM0uj59xAPFWxOo6PIxUk/tYIEE5dHsJ4boCurmhB/AIyqPTiZPTF06dV9fY2FMu6bdsqyG0Sha+QxlMUR+RaR2VZZRFKewiN8c88tTc+/Ie/H8UYwxLoeRmSH9TBO16MPtAYmausjyKkUeXJI43tCYzZRD9SnTNonsBcJ6pcc8lHR0reudmvQFS/PnruJL25i6/LJAHMew4kc5+Tg85FlVVbWaDIVasWX98zCXwfAPM3I/iz4v0KUNO+4kXNgCtvI4magA2VVSMJ4Ax6MoLJHm97kviyp9E84hT/l0CdN+aXA1o/x7uaA6wEcehV0CN4rA/4Qi8JNoSZQVSyg1eLpenpddAxeQJ92XM6f6yaD/S5ECb0LAqLjYeCUZA8qkpXxwXPvcAXFzlTabzfMhE1S8abepLBpe+cUWDafLMaEnwStNGrAqAwDU8ZctKmVI+OzBdFJjVPAAIL8t4HvuEy7d55xRvfASqLvK/adP2BTDsRZOYGIyoLjz2RAQbBX6XIkEAwJoNF8sJ4EugvmCY6WSBQEr0lwcvkiVMDBDiy/NIzk4fXhk0aQ8pJQNB3F9ZPctJZyYL7yPvOnILkldI7JnBDQIZNXx40xBSg2t4sCoSwwl55FU4ZeNyt1HiZEOKH8OmsxkpwSLmIaSE5ZQPPGmb9VGetv9QbCc7CyOAqexr9rj3iOmRR/wof9cfEa9fWqv6KmgTjVN5yGSUGLOStizAkALrg5AhruHPBk/bCz6IPfA6A4VBvTxx58mEd6fM+3Zuuj8qly5QN48QTX4+1u14f3S3DsWzNptiyZRMAMSt/9qAoybBMFgF8dRWnAwDek/A8M9BuJgE2zgFmR/Gcp44zpzzmHYsQqUfUGYqbAW4UFMGMszKpv/LaUe7O5sQgykkAyTLoXJ5Lok5omEwFEzhjLnqeHyTjyiM472kV3xjp7srhAefzq0HRaUT+c853PnsIFK0RVGucpu6Mn4+nv/mt6L7iVdHa1hzTY0PwHIeKvhThHqMMtsZnPVSJM29FFFAavXghasE5ngNlamxsKkZnkZqzZVlsu/oGVBQFZUIGBL34HksajZmul8RrIadfdE0yyvxm0qIFgJ3LAT3m3c2QE+Q+A30ZnWHAbTLkFwD/8QmkcYSXdC0qf45MoMDQBcbcpHlFqYkCcilOXxyID/zNB5Gt45DkpGI9PBmBgjN4sAZFhW686dXx9S98QmsQOdxuKwpXwaPLn3t7Tmo+Ktga9y3BHKTuMdf7VFNNNNe1xfGHcVKBIm9ptqRJnvU8rUmpr1prFMztU1jrog0K0al4wpSMNGZmMb/cHnO2Q6eTLPIExwJjZmg0ar3E+zoFxA1b4aXuGcXPCCDGcUNW+IgBeM9h6Giek8sN+kfZhUOxc9dNccePvqNgXHvyeg0agIHGQkND0Ik8hqw38VM/8SNK6bkE1JUBFHw6WLM29gxCTtiDGnFCU86KynhMI4yYrZ2dChqdgc48ffQo9HQIoHxn7FqzLGqrkekFf+OM4HpVAzlzfPL+x3Sdv/aRD8WBL30KhZFoiDAdI6gxtahFgXlK6tIYqtuWYk0kDYZjNwNnz+jFPsmZfa3A6QKNWjl0QPVULAEmNU4dPj81fek3hk4eRpTv4utySQBy52bL7C05Yf5h/PwMxnIx9/z3SOivfGCuyp+VCP4s7B4Jddii1zGkfFWGNYKeWnuTR1nwPXmJsIM6r3T6u7fuwgZvQJM8FNrg+QbfJWghoEwFUfLT+Ls2LRxREzjQ48fFGZXsShA8yUVRBSvkhfOG4G82KviLfHxc/2UPELTxbX4Gm1I2LAw/tMjJs5nazc9yAYWzKP1NDdYNDSIMZha+bF5IIrlJ2kxyHCJTws3AC1wBkFnMvL7imOPZ9Jzy1too8Wksys8RmCcMqV7CY7zz1W/AdfRI25By8CfBdNqpCcwZuQ9P1yT4lZMAL5V4FtPXkU7A56mFPFrObfcQFDyk6mMC1PLlZENKKNQexMwr9ugaeArG6V4Eltm4MaAnF5t6JApRBmHSLXqrGORlY0/wDoChGMCNVRmn4CFlZpZSUVk43sjPTm8bx05Goltgb6s/by31wOesQHqmByz7+9NpjYF0ulz3SyjVb2p4PcbWfQurYEiyGWmQ/El6oq2Pel4SpDnmHDCmgaOG2ONcTMXkQGo4FMbq/zgfoDdD545Hz9OPCqhwjnRtvjEqljh/8twIUmFWN0V7bV+s3ARgvhXAHN60MyhsMgZqR/Yuqu00DPB8HrdXADTTq0yvNVPnUa55UxcgJu+cKRUT/UoZdaQ3SbuTzNWLlFYxzzV2ZQrcXnPMPQcFwChkcn9lGNpw4/MV+ExQP+e4Aakehwn/8JSgnFUaRY2wd7AO1JY65D/3uKNoEDzeI0jtNz3Zj9L0u+MS5LH5ip1IM3kedAFSIOoA4EpjDF7F0ipw0LlmLADIlDhpVKyQW4kc8HMzk8iahAwvRdVx9FRvrNt5bazccpWBquYNx03WRNIVr32qBpyUpBArYQ162St703nNyAiysDTBAMW9ZiCr0RlW9LVBq1Ow9BoGECxCLMGSepwgAa+e6sOphjz5yfhFm144fDQ+/em/QY73AZyWjIgbTrDOUzNW77zhtltj7fI1SGHYFX/1QfDMQambgoeXwY0c1wrIpaO7M1569nmA+Dqk28SpHquAQl+mseY2MTVtU21Ut3RF33N748yx40kb8PEEoD1DpGyFthuAOz2oZYc/mwcoufEm+g0/M7iR3/k80mnyCZSrfVr2np9MXTkrzjdX4pbOruhBMGbAU03KSqENOFkVx5wvPRMZic4fQKDoivjZX/wNx6VwTdTjHXQ6AZl8+iN/EqcRPJtffOZb3vwDeBa83S3ImQ8D4snhqtg9jcqfWJc6EM9A2p1mB4y77V3dKI7UjCqgrfHNveC1X5oAnaUFgaEro6u1Jupg5JAiRGCumAZuMJzP3J/Qht/52w/F81/4tAA7veRVMKqotzwZGAOtaXAM6/v0MNKMomIsQPkcxmh8gB5zU5PKEL9EwVJuXC91wor9hI4NBGXPjvb3f3yurPhdE7TgF1+XTQIYjwbc/Bp8LcEXo5b34etFjEfhsPqyPfwVfuPvA2DOPOY1yspiEJEXVbkHvWCkUMfsc3SgnYPrlOdZOI7X0uuplVf3EmTS7RKQTJA14b68jOvzyhGReN38CI+LBcYF3BBTgRuVwHMxhaIjMzgiLEcgoDZZHZEmIMRHFdrMRdyLfj46zvuFwblhVDYcMiIwxzXluCWMFHjKXUobi6SSQQQpKkYTBfgmZJFnBt4HUM5FZibh+ZoF97EcEfVFrF5KgGy3Yfq8jYc59HMfg5D4GMoY/SxFusCtr77NsjZGSh4vPsvjx1zRkhs2jylsStPYqKtwDFzCI15uwgJFLDBjME8xsKKkbkaPs0dN98qjmLFqoUorRzq1S7QVbpgJcHv83ZpSUn5wc3qx1dxEbclVMT3w9rSqxCG9uLiOpyKuqAfqD/jKl1D5MwewCiAK5M5ztS0kNtlC4b/k6tvD6b4J9MuYST182ZF7yjGiowLqczLNOA7UIQvCOqNr0llS+jVZaGqCUiZSj405ClStDEr4ceZwF3BPukUtFR6Doom6xCbzOwDPyNnDcfSpR12YBK8VW26KyrZlMhhpwJQxXWLdYKzdsi3Wb12HDb8BwLwHnl+UsE8anrWDzuYZpBQkMPcBDjNjIKMJPI9z8Cw7yJueahfTcQi4U+DNgyIbZlkBVWyJTdfSQfMRKTqRZaOsClkzMI+y91itl/xJYTCti8GfBlz8E993x+UNRgdnsJeVM0A6gYukRPKgNoJLXwtPJT87DTrGIPKfj470xennn4iz4BpvveVmFdWZBbgvJe+8rg6nR0PoFznoOHlh3zi+bAEbDzmw8BcUDSAL3mzkAJ+rbIyDx0+hzaWx/qq7w/PdAAAgAElEQVQbY82WnTZY5FSYB4kZLLIxViGP1T/1Eh4VMB+NpY3M+kKZA0PCkBD1iHMzrQa8xyjAWDHAXR1Kw7Py6LkhVwXNYJXXPPniC/GFT/81HMTsM2UIjzKoIaPIzlMPjvOb/tWPxsXe87FsaWd8HF515TCH3HLb+cRNyLW9d8+z8rLS4CqvxAkls96APlENgFjTjADEjtVRfPpknDyICqCauzSkPXfnRD3xeqsTwiQGGZmeHRKJUmYmI1kXcRDY3pTXW8CcYDzxvPUczcskc+lmqGItp8XazVtQoAcAHAWJUmS5n4WT1Xlg7jWipP8QcseXxS/++nsUTJ7jJgjM+RwC2y997qPxwp5HXjZ81+26JtraG6IBFKf2pUtj9/HB2F3WFZNYp9pQEZSFgBqx5k7DoGmHfnUifWkjdO4w8plXTI/FcpzkjGMtfMNVm+MMAjs3r1imvPgKrmXlWsqP8wNf9z7/THzqA+9GmkucrkKm1bWgcaU5OAF41z+MTErw/pdjTCZBuSF1cXJoWPRHvpi+kfuFgbmruNLQUVE7gPxhcNIhiyno8kcqW5p+59zevaRcLL4ukwQwpl24NfnniGgPlvIm/3zRKPr/IO9XPjBXHvMaUVnSTu71VOBK0MKeIm5lCTh5feVCxx+YqDsBmQR2MkHEOVYMleRz19roI3At0Pxbei8Du7zluzn0ymPTIj+ZCzO8vjOw/AnMKwk2mZItAUMtyDmlm9pmZMS/Z++Tns0dX6lIuUoTxM5vggYWeI72FAMnt9VBYNl7LQNCGGbeK75QxwTa1bnk/VYec7aF6f9GcPSO4DjSMuhtRECnJEyQJLG43XPI4fz8t1FURS0ieMBxblVDbLr5tebJWoTuR9ogNYbcHLEQMyUeaTMsFFIJvqM95qaxKKdMAptqqoYSz+EGmXOws+e8NeVgS8YjSSHkQeLlMmR8+uFMOskzlmQjmRGIpeDb7Cm2PvF6jjFBAjttPiy9YQRjLAuvtH8Yc1bXK1UZdQZSUi0JzJ11xcGrBOv8GWPKYFIaA4m2IP0VOEjZhtSTeZBAXOYsi0kXkgWXDxTm5O1Puqq85Hy+0JX7m4FYBg4JeMkXl3SIYqcWCIzzeea7qN0OkibNw6cJSrFJHcTX0LmDcezJ3fJ+ss3Ltl4PWsYyBeIy+K/80nh01I7E6m0A5mtXIeVga5xF5c8xeE3n/a72UFJkDGBjKkN57tF2pqVj6k4G2Un7EjiwN92gmTzheTDu8U0KLr7wJXBgLwWpD14zmP6OBWZ8v6QuHBupEb2UNFi8rlgOkm4aEcqX3HhcT8NDnGFnDbLeZcMArAUAoWZ4SQk4OLqTAOL9CBDtO70/9t73RGy9/XYFVo7Dgw9/LOSGzB44raLeVSFLiQwCPknGml8Tw+CvIxNTJahmgwBVxeV1cRSZQ4aGx5GyrjE2g97SDQ669dynEPbeeyoWQHq63z/1jbIYHBqJ5loAYNHsgZRwakAniF9eB3jTCbjJL81OIAgTUwHDdHEEXn41m0avHhof/Nhfx4kDzzqehTKGE2MJMvUcO/Ri/OC//lGcrLTEsyiwsw5pA7/y+Y9r3FX0B08QPQSfW48MNy8dOBKXQIGrRsrJacR2CHCzKaBAtTbWRsPOXTFz9AhOLftkUJCnLfXHP46l8DhnXSo4QJLKaFzT9TwJnQNdi3p6+vhZ0WMIQKmjeibHWtc7yNXi4DOoaKjVkOh5G3bdGE8d6UM6n7oFwBzXDmIOZI95WreKR88gM8tQ/Nwv/xYoMIzV8Fqt01JRf6bjofvvim8vqADKx65F1petMHyZ233p0vZ48exg3F+8IlCTWB7tFjiJtqGI0UtnziKh5KVYBmC+DLSXPlDKhqGTWzub43kUkPrpW6+PQzjRunr1Kq1v1O0mVHudmkbQrS02UFaK4lf/0/8d5w69pCxkyiuviYj4DaTVHBnHiRb6QG2ZogEDZZiGXk8xriTJibSXfFKRufz0uFfBsCAwJ4jnOgCDdRzxIB+sryh/975HH4UQF1+XQwLQZaryenxtxxcXxwv4Iv+8/3I875V+z+8DYM6sLBXvN5Y095q0AJVj1nvpaFCobX4TypDVh+/khdOTZH6vMI6WVOa/9h5jUJzoCjlC335yH2VmAKPL/VnTEPBhenfoxYNngUFQUwDmVQCbLFMsWgoXV67kBJ4EafTMuhG+UzpS53vmOXvTc5o8g5YCBSJdy/eKwaUtEHnSJsEbOoUgZZRPBNzM/Ly043tToUwScCbvcxJp7OZw/EgaTgm8c8pjjitJT8nAg8BhBoFp++//pr3WvBGeWYGj9g03vTptfOmBfHDyppqXS9oMN2ZyzBEoi6ws5eA0knOubCmkzqTAXtdHQM/T5i6ZMJ84NgzmMM+pIYVBNSoJzEo4uc+5HelImhJGW0krmQXYNGfdAE/yQRtFZ0kbYi5FMjfl0z0GJc7Bk8fcw9xQpnA0zPLapPGUk1PKMdYJA0eS6fjyqYfvrRHl5kSx+JG+r5o531bphfTDVwgOJSDk99lp3gvfckIJ6bGBhcC6vruv5h6z/QZKwpqaQqT1OC2bjRSDDN47iQQX2hDh6QzHUhiC98O9+k4DmD/1mK4hOF+54+aobO4UR5wevipQHDrqRmLlti2xYT2yTFe3wmN+EmAUVBYJIM0haixyZrPCYxnzIQuYwSOK+9QwjznAcPb2ap6SG885x/SamitUVaZG5NBZjmwf56QNRf7BgGkKbr1y5AO3tNjXRO/Rb7yRfM6KsaCY6QGXYZYMVLWF3FnoIHNEW5jzY+k+cW3hMT1AtvjnyH+O36kBo+D0jvYdj/s/+3fRefVN0dHZhuw+PPKfi/o25q8GTxcgsJI509NpjsKSKVPEj0wzaBTe1koE6U0O9mOMK+PM0Fic60XKRgijrrEZHvSbomvtJgfyiguVFhuJ3Drlk6SkVkkP8zfKeAgVPStgOHCsWWyG3s085wped4hlAqBtANlLKjAvKaUJ5DKXUUsZysopjt//o/dG/5ljylZSg/at2rAlVi1fhUJNvQpu3bJxffRBLnd966txet8zceEC0qhqbL0+0VPcjsqWg6B/jKDvbV0rYJicVEpJrrEMwm6rrYy2q6+L4eM9yHByUTEgAoLSlxQUnfqeDbyFhkqei9IeGn7yqtvQmoBn/sj+g1gfWfXV/fN8tBdZTiL9nl64WTlTzkL+zSs3xolR7FOouDk/4XHBQmDuBR+5PFEDY+R0vOXH3hHbrrlJe4fbirYo9eR0HDy0Pz77l+/zRE8vgvEbbtilk4YuFBEaQrDulwZqo6+oUoHOdfDCN6E9l0CFmhodjKWtXbFu5UoZSn3nT8e2rqYYnKuMLcvaYwhOl1bMwRVLGPdQrLz1duJwvnn9+psvfjYeu+drMYjxq0a/vDQhFSjEM875NQ3nFNZ05rdXZVdyzxFEm/n8dGKpT5xxGawzHSgzFoGuw9gjxh1VNTYhlWZNNNZXD0/NlvzxVHX5+w59/esMIFh8XQYJYIwJygnOCdI5JY7iix70FKV8GR76CrzlKx+Yk2NegeBP8aa5SRAkehFcyFH1Viz/Sgo65IbASpVEHwwQ4sbke9hjbs84F1Sxj9Nm7veN6lR4xOglXZ3hvIEJX7xSwYD4vZQlouE9nQXoKEdWExZZWOg10tqVvW8ZkCiYkxtARpK8xp7sXL3Tadz4PsGovXfaAhMtw3xub7HqnzA0rzGYzMDF+s+FMG0i+ryPlXkR7z2JgjmXwDMvg5evmN7ylNoqe77sKqJnczReADAvBGnis+W1SLt14y1pPqs5BkTc3DhuGBuVskYbygH4mYFjAkFepC4UQ3YCTgycVCWlBCA5Qtm7rE2S4MqbRAbPAoq4PANd9dcPz10W+CzJwbQ6UbBsVMmUHkFhcd+b/lVmIpAXWxuwZSTQrkqpoB/QYMFmPwGv3QyOdKuw6RUpEBBAgcBcFp8BUVK9gqHl/dz9cyupa5bRgiarPwSIjj/wmPPUQndl9zXKVB3Kg1kmrAHWXf8kCfAhjjZNz0uGSHq25hI9iwB9TOHoIE9fI69+tslSnICe4OiwuHjmYBx/5nHRDjjPlm+/KaqaOsxHxY1LIKvVTSOxHMf569dvAFipRW7oE8j4geBPzaE8RviONhKYl8Prp5SUHFPInZQAnSSh06LMJIBgvUU7U2XazA0nyYQpK8nxJu1BVAY+KXGHmc2DvG6fpBjg2zBLAJtGDY0VXE+vvZ1JEpKbyyqwvDseUwb6RsGQYZpMQxS9mGnEafpMgapBBpd65EDX9Xh74PypeO6+f4j+sbLY+qqbkLmiF8+sBM2mFl/lAN0AJ5hTDNwzzCUgpFxoGOO06RwqXQLwz4LPO46g0MnS6jhw6KTXHHzVIdhw49WvivaVa5MeJTMvAXJ3mmqYxiC1W12EjAcBzGvRDlb6LHiEc+c0vu7tALz1Iwio5ZTlnGCeb77P4aXhtO/E6fgIMomUQg6V8Ije9ro3x1Xbd8S+I4fjms1b9ax6pIVsgqHx23/xJ9FcNh3fvPNu5Sqn59ypCVFICOCS8QakvNQ1LY3RgXOQKcAvxmkap29N8LBWIyVn0TTae+GEM+sI2FJmNvKdj99jtJDSk73fej//LYHyXCRtDB7foyw4xBOOBaDYgdFMHVkcTaCE1LfXK9f9C3tAp2EGnmVr4/QkDDhkkkmLovWIwZ8pv7fFyoV1PMoHj8bV198ad/zIT2vcU2NlFLOQ1yBA65+/+9cRDDwfq0cKyxvf8LoYxbzqAJWlFCcud54vi6NzTnvbAW99FdcsyGISwLwctMPtMI6qMA9eAF/9xpVtUd+8VPOpo6UmhlCFdsealdJ57kMVCDRgH0sVCBrxyIvPxWc++7fRe+QlxI04cJ8KMMwsl+Smo/5DDUD2CFIHk6LFpWMM92TeemXAEeWKy6T3Ye0ReJ9zn0vVCAomlWGsK5CGsRbgvKW5HqkrkYaxvaOv98iRPzj/7JN/io8jiefi63JIAPpNZb0KX6S5cLV/AV/7oAOOlF98/Xcl8H0AzMExr6h8f2KTJq9ZAunc+rXxLUBlWlQNVriAOCGFAbigC1YIATgBRV9ML4DXP3uH7LnkWwmR6E/kcufjSqIjXMPjdgKnxP8rLcFmCr7xHOggldhci3Bcm2kURkkEOZn84XEV+FI6QJsEfKrgSvJa+gq+/DnRXrhY0q/Lo1rCNW0gWU8S2EsbkcNiM1hIwNad8+bAo2BsHuo3FskpcH9pXLDAUAn6U4TNRgQagR8DQBaQmITX7sUH7pJHh/iInrHqupZYC2CeemDqSc7kwY2cwJjPwvvMpjCGzC7YSVT1k0ZN9ox7EzWsFFY2xCt4alW0h3LHf2qbjAqPqfuU+puPgTl2BKXptIJ9V2CjHaiFU5P5wFrrTkK0Cv5Umkp8cawZ4Ms0X2Xgb46jIAgDlyoAIkoAjMjHN1D0xqOWCgu83CCUvZKam4dO11OtjFE1HvybKUTWAAmbn6MM/KMoJgpAFKMpgcj03eDa3vLsBbcHlQ1gsCP5/DQ+aYRSP0mlysYbP5xOfLgeU4bJUDGIADA/fTiOPbNbc4FzceUOcMwBmpTQguMDYL6ifiTWINfymg3rAAjq49xZcMyVx5yGD/tiQEwdmoBe6eRB+ogWQV/Kq2hYm5KTA9BIe8kBzg6QsyGueSN5mdpWzuw/BPmaJxQivPLw6JWCn2yyCtqZqt7mTEmiUPDZ/NL4WcezLLOMCRqZ21pjnOa2bY1k+AjYG3jYGPZpRENjK7zaoK3AQ86sK8eefTieeOTp2AlqSxksP86/YgCXagSSziCDyxyKWZHuJfCiuUCTA12BJ5JpFIsZQIrPDYPHO1tWG4dPnMU9nP6Tr8a2ztgI72tz54qCB90iovfTDoG85nhmGZgPjEwgSweBOWeZX3kl0TVsBwTT249c/qQtYa0g84N/m0Z7ZNzi/t9+9pn44sf/KpavXB1XXXtjbFu/ETSK1riI9taCMvfovv3RDW/4ND54tu9kDCJu4Qsf/YwKtFGepLKQIsj+NCBosQ90jDqcJtBbWw/gJolgLGqxppTi70u37oq+px6JSoV75JYbWNrpkdb3BLzVL+m19Uce+ryGcO6kn1XHAJ+fRhwE+0uqB9O8sjIpX6Q1ta9cgbS55chpPxC7v3GPCu60Qu69E5AVqEYzWFNnFX+CdpFjDmBeDtDMzFQT5GGTRth/JFasWhVv/w+/moKa0xwWNx/6ASP4r/7kd6P/VE8aFXjnsde89a0/FH19vbEEpy6sRPrUVFM8POIsMO1NDfCaI24IfRkbPA/qz0zsuuZmVZLd13MkruloitXIt96LMV+9tDVOnDkTN2yEQZdOLaooW/SXXHVq4TgoLM8fP4xA3f8CSuKoxpky6xuFHDFW1QDyzO0+iuBn/R1vj0Aml2BMGJi7kJzV0DJ3nBKMK1Bv+s+elfOD6TBrYXx2dHXEAApzVWCP6WOsxuN7zs5NTP4+tPBDuMViNcuCJnxvf4Dut+OOLFDEQFHkBlb2lqPf26e88u72igfmV6HyZ1VF9fu9lDJLAjndC4BoAlwGE97Pzb0ukDy8oRBgECrI+5g95rwlt16CDv8sDyV5wARSogrwvthAM1ji+8YR4iwL0CbPKjdT5rKdgxeV+ZqLFCy00PvrPsxvFl6f7clk5hf+md64efBuHjIXZD9UHGrRDfy5Ql7rwpaZN096Ol5u3HqjThvVAveyOMPoB9s1CY8L+1CO3OLMN8tsDvIypQ0uUZfBKx2BxxzBnwChyu2MmxOYr7sJwDxvaraAtGD7c3iO+KK4HQDNOLx+yK8G7yBBLY42yWlUFpvUt4wsOK4ZsRJM4M8pNXWBJiNIymdITDbDCmjCbwlgJawuRckecsG2BOhkrqG84xwAKnVGpw50k8vryp+hfwTmzMaBvk9AXkUAVzphwKY7R2NMqfYosnm/vfydiTJBHJwo7QkGeVzMMGdTDSKSMidjjJQUKYi9lwlE+B2/9HPhH76RTxgsPw8/LqDXKwnQklJr/S/iGmTgUJbCG7KM/FcFjtJAEewVj7gfqe+OP/uYPJo0bNZc+eoorkeQG08i8OkKlJnvrBuOtdu3xZq1awG666L3XA8ylUBuUhvTy/iLgDkCjytrkJaOwIeGCW5SCk+p2oAvbuAqysTNnO9pfpq/ryIx8k7zyS5P5KIw9jLb54zxAyghn1XqRVnSWEynJuxmBuWkUljWFjJgA57JipR+QxlFeNIj4VPxfLogUXHeUM5clwRmZKlIh2h4lqNP9ZATY1HYuYHzx+PBL381WtZvitYljVhD4JXFddXI8HIJgXQ8kKiAF5QCKRjwGgsE1iGAmmmJy4BEx+BlnympiSMnemE0Ingy6Qb72YwKj5uvvRVAvcMODgHzRK2SHD3uAkoY5EG4PwnMK1IlX88Ar068L39merzzBOYYF17H9JCcV14CvKacQ0aOO7/2d3IO//zP/pzuXwmgx7k4DuPkI5/7uzjZdyZuf9MPRndTZRw6sDe++pnPAdzixEDjBIcBDDZSo1ra2+Li2V5xv+dg2DfAwJExh9MJFiYiL3nla94SJ+77GipecvySLZvWYVEgNTXSjpLmEhuc31OdgrTHGK/7WlOn4J2H0XPk4FGAYXCiMX4EmQwUrsbPdTgV6epEulAA8ocfuRfc7Gnk8O9GYGY70COMB8RYnJytiBcxPgLm0KF20HgqQBc503MCVUtRNRrAvBVg/d/9n7+FMa/znNNYe7zZvju/+Il47uH78uhKRm9+0xtwu8loakZRIfC+T8w2xJeHcPoEPWpA1prlLU0xiXaN9J2PwfNn41W3/mC01uGU5UxPrEDl0DZcU4tTlgasx8fPnonXbtmAzDJVWvoqEehOGRuY+zWMmIl3vfe3ov/cKe0RPA3tH8OYI8C3Bp54rvHcS2ZSMTEC8zmcbHBQxPdX/IeNwmwYkf5Zi7YPnUc6SDq+ML8alyyJruXLkfJ9DFV1J6K0tSkO33cf7gucWBQ926++5j/tXbHsY/H5zy96cwsa8b39AeOzDnfcgS8ej5Drvwc6Rx764usfkcArHpjvQvAn8p6i8qdLCxGYe83nDsKf7C1ztg1ewVcGOd6wHVhnEJuQT/qsN8kC142fSxu4NhXtsIJCGer53sYoeo/H8TnfLVYtZJVADt/JUfD6CMxTVgfRIrTjp03dm5/bZsoMu2M2O8EUF+D5a/mXgsEhNykNguy9d2+9VVouygiSlk9z1uc1Z+GxtYAs5SreN7FFMbi/4JiDmsECSaSyMM0WP2PYJljBHQrcwZF4/oFvKbOIvb/wkCDl1vrrbjaI92qbmmQDxsVE9HFkHCgHcMBJJIIAxcUUoCWwwXhIDPaQe8gMFJy20SPuaoIer0IXM5jlJ1IT+EOmHRn/ibikv4uDTznqYCRHExB1Wi9EgaCsU+AnT/ToIST/uQz8e+71TF+GaigI9EXwJ8E63hetiEZA0p+C9NVUDbpEY667QamPF+z5d79sgBQ8mPxZ6p7Ak7SPH01y4CwQCuF9fa+CTqTfyL32f/NDpIqqvA+NIvwAXG5OdT5KoAiSV9XVdzmsyVgEqLhw8mCcePZJAVbyeNdc+Zooqm1W+8nHL0VQYGv1QGy66opYDW9iFdIFymOO421jfiNi6Ri+JjB/KuHFs+o4Nzd5xAJK0h2eFLH99tBJ1ClYWHQcvpcnOeVLGgjjEiiYBMIYvCeaieajRW9Pu+d7LixEUOn5Yt33M1POc9InAHIIzjwEGYDzu2UmD63AugG6s3+4r0xJOQ1uNlP/1aPAUCn0fxaG6t4H74k+ZDnpXrMSnkYEyyGYjjnOi2EoToCHXoF1JVdUlL6kE5/J4QvidjO2ZWIYGVtK6uL46YsxDCDjrs0bdEuWr4414KCT6qJUk0n2BRmgO6zQOwTCMKksGZh7/lsa/BIwB0A+P+CA1YX0DtV6IJBN9KEhGLAvID31dduvEHec/Sc9og8Fl979/j+Mfnj+X/u2n0KfAcYGT8feRx+MkycA+CQrFq6ZEle5BZ72gYugRyBjDOd1HTzB45iDVQCVZRibanjZW696VVzcvy+qYRTyOdaTNBvQL6binMUczrE1Gt2kS1RweW/Tmqn5Rx3h3+WcKIoTR07idAInGRIGc7TDKNWEthEvdSAtA84GOmdal3TEGXi3WRSI9ylD5pjJ9rWInMbJaisoJKC4EHD3wUs8i5iB8oGjUYs58I5f+nVQY2BEqXkca5440iCejmee3h1f/9RH097l8dh11VU4lQCNDNd0dbTHuany+MIw4hCKeKoTsXVFlwof9fX3xcXjh+LaW98cnY31ALxIS4l52ojMOrXtSDc5MBJ1GPe1APKbVjE7CyhIoMOUI+iTBpX2DHyNIoj6d+G5v3DyqPSXp2+nL6CmA+5Xhb2QAf5joN0wyJOUsHHETUzAILfhi/nH3OrS4aQ71EP8rQKBzVPYF6ZhnPKaupaWWLZqjU5tz0CH2jZvjiOPPBTjAO/06G/D2lLf3HzwUknpu779pS99Rsvd4ut7LgGMO49ftuFrI5dDfPHIhvxzZnJZfC2QwCsfmGeOeQFoeDPWzEtgXN4xerLpSdOslFs8iUlIRT8b8HKhFTTx9q2dzVkVvKlnwFfYp/VkwRkuHPhGjeTCJI6sNiBnjGAKPRbauMSUbyrQw3YkeMVFXZujmyWvlNrqTCuCYPpGj3IC4uoG/8qiL+wZq9lxMXNhJEMQoht6fw0+fCemo3JuXYmJbZYnOT08XZWEqEIxkg0umkQOdlYtlMdcPGoiYWd3sFfD7Z+aGEQe83tSVThvRJXwmG+4/lWpXUmOiQNQpAI0PpYmFaUSAHYcXvdZcMzLmL8WAAcLqwCNbRgOMoFmOp4QeKan3CDf/xlMFrzLpHPw6XaKOZUkDS+7KhM4MRgX9icw4/Fw8gIRJGepCvcr8I7AHGNCNSKNhW5iAk5UOWV2AnrM6c5kBg4Fy9LzTyoL1jDnFGcb5r2uGrOsmul9m2MGnFm5lZuf3efYcgiSDielTcCd4DfJhPJK/RZg8031LOmX9M9ceaYQVA0AVTu10SiDh88nu0WqSs65g60lBYFLaxxlxlMlAoDzPQfi5L6noUPmmK+79vYoQnYeG5OgocyNR1vdaGzasS1WLW2J6qbOOE1gjgDpQupGqSXGBAbB+BiOwcEznUUmFT6LHGUeoav/+F8ZcdKYs7tsK73nRsNUmQSmk9FFcKAqjJ4JkhFBWSlTjfipkr0DshOA4ynQ/8vee4ZZel1VwrtyzqlDdVV1dVIndbdSK1jJiracZMuCYTzY5sOY8MDwfcDAMPAwPEMaDDzYYBwwNhiDsQWyjY1lI1s5S61udc7dlXNVV85V31pr73OrNfNnBsSM3e7buqqqe9/3vCfsc87a+6y9N9riss9CHY6ma0Ky1X6G0EvKowAuHSAlK2yPnza5pGrV0NwQxQaKAcP8MWoMZa2srALW1GpiGxvpOGXHXjtqq0D9mUWioiXMgTI4VufAej0L7m0BwgvKmTHibztahtLITKHDI1ZZUw9+OqzKeeWwfI7YCBwzdQ4Vi08C6XXNG20TnE+LQbFQdkeuSQTCrCNqKioLAGJhOhXgnPKp5courqUFlsBc00XrMnnI6i2BdqfKqPv0eJ1qaE7Axo9n5gGc/8U//L09+9i3rXrLFVZV22B1JTl2+JlnbbAPnHuOL2SAwJy+AfUAnBOgfNA5lgpyCR0PqbSrexetqgx+Hg1NcBgusnmczNASLcMJKjCJtPD9XT02hntTKEXlVADolGLBuYEH8nnqI63fie5DzM3oTB52kQrAFE81CFLlBJwn52bmgZiGAkUHSDrEsh+qMR7DoGHMcG0lx7qyzhbX73HnTyhnK8sy6jkDusZYp8r7dx/6eVsHB14XXcqux/BfxH7T0VqCQLIAACAASURBVHXevvhnoJEEz5xTaA2yft5x5602Mjyk38eg1H1nqdF6Zn3dX1tXZ9WgcI1CKe448qrtuOUt1gqloQIgfAr0kN6OM3b9nqvtXP+w1VWVgSZ1we5/03Xqi0L0I6lKdPDliyfIf/ilh+zos9+CMs+wlpBwGCa6BxCNBfQr9jujEZFjzroz7OIETkCmUabmCec1oxVBhkURkox4PclZX8SaOjM+ITkvwanIKvhJlCCL6dmDr9qq7Tts4MwpG4aPQktrizU0roOPEk7ZKlebrd58aCEn99ef++3/+LUQ1cs/3uAegMyDV6fwik14c/CO430I4+pA6PKL6+Pyv0c/dKNTHv8+7w/BErw587l6UzvLvRZUFoBEWMzDVsPFnwuxz2TfLPGbO2wSuHJX0A4RsazFxhRCSaBN1mqhFpZBoOcoxq0jbmHxjd4tmzou13Wx8es2/kELJ77BQqkraEUjFxKLM5MlMEqEN8fryV1GGMLXnwALeqpbRMJEnBQPRZdwboZfrDYRPPiGAVcg1Un1e50Fnd9nUFpGLJK13AGIA3qBuIjKQhAxTZ4jjkPJ7csD+FTYNYILVp8wRmfgy6AcXLAjz7nIeSpwWMwBzDffeKvq6XZZb32ypulp2NS44XHBnUOkg0UeQ0OJkRJA3iFBsvoKIF1REXwc1AWh2AgYqfv9c+9f0izSIbtcgB0Q61t2V4y5EAIt91Q2GOEnKW60zPErr7l3j5AeNuM5XO8p7GU1RoSWbPRNLiJWzMJat7wAOg6TZgCUMwpIFixUfOrrYqiHPDowd1AT4ufP02feFt3LT5PCEG30pEgud6IxZaznfr3K8eFZ+ZlKk9x4f8lKLrHCxaRjCZTxJztZKgFHWl8rhLYCH/EEg1oAn43+w885/Bw6f9S6EEVDY4HrN113LzjPoGKwj7HhwvaFrIzDtueaq239+nWwosFi3t8GIMBQdxSQ6AfWBgMwBUtoMbipAssE9rDEyQE51FgCozTsHnNcNfO20eFTU8MnGMUnj6CLVCT9LcSsvxme0+Gnt5P/cyWIcdH5F4grklNa63V3lBvrA/sbllfyYFkJnlKQzpD6gSXzbz9tSM6Hac4z2yXC7nEu6HudAclAwOREpQDKSzMjdnr/QStFKvrp0SHMdIAicM0LqpAuHWBnOQeZZnmqpfH2tYnO1fAItEnEOC+ElZ2ZQucWs21gdN56e3HqTEVUTfV1LvXTGoC/Dbuuh2JdoZFnc6mATsEiWghKAhUUjhJPz9gnMbWlkDCMXv+FSbXA1zb8xCW0sk8CnCrevOTRv/e5yl88azKNF1977Lv2+Le/hoge4DfvvhIROErt1X/+jrLH8lKWIYs5/i6vqRSAHmUcd9Cn6HDJcH2klzG1fAVSw+cg6kstHC5HTh6S5XcGALobDqijg0NuJc8AQc5zzm+XXe0PSqjma25mfQm54d/8LgdGhGJELZnF6Y5O0Chf+G7vtdcgcU8F6C0IfQkKyNPPvWTdnT0C5lM4hRwHlWMeJ5Iw89vShmvg/ElgnrAMJxqcykFjgRqifn7nD/8/th3hL5PF32WfFv95cMmRAfTPfh9g1yMIskcZKvGHf+jd4GKPWHVVlU6Yn89qssOYaqwfY4TvWlNvI/i+4+CLUISutau27oBjaKm19XXDSDJkGwDep3KKlDztNMIhfvjt97oDMMYzH8osk0FReeEy8PTxg/bpP/ptzTEOOk+ARpBcKG/qAtrgvhBh/pLyMwXqDoE5FRxmRS2BjE5ewDhKcaJ4+l7Oa+lfMEE6C/4uQFSZ2sYmqwMAP3/0NSsBLYiJj0ojwRfzX+TVrbO5hiuQ3A2+SrjnwtljL5382ud/bWFy9FEVfvn1hvcA5gPD9jBBURXejNryGub25aytnI8/GMCcmT8dsAhEu/ky4W9fUJWC3gGFRyiJDVph1nzzF3DhInDR37KqhjUuJahxK2HcIeDA3x0QCAxwwUmYEB8uwLrnjnMAm3D+XASPjiHSeFyuu9NmpmPjAEehUARGj80/EFVMoYugZKAtLIAE8GqbO0QKEyc7VoBz3/d8s0kAXB+pLf58BxD4W2HeCWIdoE3TqsO43HTIBCiiRU+tjz6T/Y+GHVhFDj/3XWQFTEf22Bgqam3L3psjzbqDPneOpWMgn+lOVVyGmWZ9ARxFhmbMZUQTPIcb/1JY7sL85sA4dIhkeWYL5PTKf5SD6C/9RmWKPzJGGKcKSR5c//K/WCh5G5Ibl4lk21QElFDKXKlgMhGPVc9NhYAgF5tXLo5ryclf4gbBNjAKD5OfaFAI2NC/AYLpzO6iRwiW+OKUVcqut0AOy5Qx9lmAYoHmcPhckWlJgOQ/bdoxqPrcFUr/PlmBOdxqH6PRKGC4W/L9IvpNAEjiIkWpoXBTkdFNHlNeIJaV0tTjCQIjRBCYH7auE4cEdljXDTfcB+sVgTXrgCPw5VmryBm2XTdcY83NTbCiwfmzrxNOYYjUwPIj4kcCdVM4QaHzF/uYdShAn+agnx2Xsw601oedm9XkkTj+JsWNLVwiJ4tzMSzgzjF3YK4jc55M0GLuZt241tcWZRcFWiR1gmPHnxot0d1cmU2Kj9YDfEv5T87I6nqWw7HjShQWV+e9cx6RAuA0Ca0i+t0t9zGr9TuBSRWsqsQ7/WdP2FJuObi2iA892qe5V1SF9PQAejMzSKwDGsTK6sbnoz6gJcwA8GSBJpMH2Z1EBs9JxCBva8f9lG2FPfSh5y9qPbq4pnWb1W3cKae9ytICgVwmUCJunQKveopOj+jDIoZSjTV2Fn07MAzl9CI6Eh276TDqkVpi7mWUgZis7HnKGJ7+iS981oY6z0Bh60dIxEpECsm3M6falXSGYE2W6ojMwmQ25bCcdrV1BKBDRBdYVOewjtAhvRagPgfRXWrRllEkGSpA3588esKmQaGQk6/62pVx+gCUVpYhbjasuqoLxZ0g8/VKs/wnon2UAa6LJegDnhZwDgjsQz7WrF5tO7dtUZZSxsk/cOCwdXZ24jSkyu596+32pS9/VT4AMP3a0ibgGViQFfhdlUKd5uH4Od4Ra/Sy3XL3O+zWe+4PSXOFnkoALebjoHr83Z//sfV3nM8oEOyr99z/DiTvGkeioTJl93x6ssL2zcCZmvMH/boT4RCZtbnt8Ms2U9pgt2C9bkQfDEPZW0KIw2LQqZ7t7LY3IVnVQQDvn7jnTtvYuEoKVCHmEuksaR0ehQHqF3/150R9ZN/NwV+AwLxwBnObjv0cXY0/uf95mPMTkEsoR1S4IIN1LZvsQj8UAmZRZd9LifN7KsEjH+rudoUCCmgZIs3UNbbYcPsZrC84zQK9ZR2iYNGIlIVQtVkbr7PZfIZt9HVrDnSu177wp0h0tPgM9uFfGhvug4f65de/RQ+gv1tR7m684dBgEGrxz/v+LZ71/VLmJQ/M5fxZWCTnT8GRsL7EXxdtab4hu917ZaPzv2lv8mRCgVsCygYQTmAtg/B8o86ks+eGnKA6QYybawPgERwxo5lbEuZgtVmEhaaYsblTqEGChDD8Jr4uf3oU8uR15pUTGHcjm57vQMCpEE7ZiNaF1cmBuaCzZDaFdlMv0BoUpwvEVOT5qWfSrsxCE9Bi79CZERZzngAw1TgtwLIgRVkOPNh2UA5w9HnsuSe1QTNjMxWWYoCJTXvf5EASL8IhB5oBJPE8ZnsjkCnA5jaNzWURikxBAU4XsOgLDAGowMgnwOLg9KL26lcvS++wFKrdAXCTnKhXQhFZge4+rWW9EyDx8XeCgceY5z+BU31GWgKtxHTIZRhOWknpCArnT2wGBB0E5sh4AgsQw2OiDXyrmwn8nCaiqqZ/2vS9Rn5A4mOiT9Vt3nfpdEDjmJrsXe/3Ckik+1ILXYlMvHsVlKgYkhMKlXrAq0hreYRDk4U75E+OWRq3AE8x7jq0knZK5cydevvPHLLu44dkTadIbrjpndoodQKEzwqQYKh8uc/23HKzNTWtgwUW4RL72rBJgz+tyEkUTFJVqBiCbgDOcREyEy7jeJz1JI3CI0M4uBbIZn04dJw7qGpyYKRcuai6FZz1FU1BFjlXKAmyKJ6MxOSYgfPP55nbz1kgKBbyrXBQoW6UcpiAhvchLa1KLU+FgX2q57qCq/CVvEcy6IqCz9GwDlJBy4SkZL1dziULkhvGwS6UI99oN/prJsuqEC1jsOucO2eXgZeOWxhulJZuWaZjnRKSBiCfxanWMvxEChDScRJc3xmcQLd19sKyuXK6Evg6I1PZ6K+1G7fbpt3Xo9Gg5qEsJr1lFkjJJd5FAJ3FytGQBbA+h0yP8BVJgomSclGxIozbOGhJktNYu5ID7lMHDtoVzevh9z1pzzz/nJ0++LxVVVXahQuIXY66NiECx/59yPAJK+0cQNw8I3kQlIIuxfGsx/fd7V3isPOzUjgwLiKXwDws7oUEkADmDbv22tipkzZw7rQNIsKIrORx6uqyxPFHPSFrpMXoJeUhjZXLuvwCNDFjzQdwz8PaReWBjq6zTK6k65ZhRS+y66+7ysMHoh6nTp+xLljMi0ELfO8Pv8cefexJO3H4IEIZVljBNXfaeP8QvF8R8pDgHMo9EKvlXQDwjNO+bWjDe97/kxpOn76sBznmfO6cPfyFP7czh1/NAHNectddb7YSOE8TRNciOsvBqUJ7crpcpzOoGGKTV1sZ5l3X8ddsZHbJrrrxLmvBKQRWXastWITydt4mENmnAP0wgFjw92zeaDfu3qF+KWK4SijJ9Pvgi+3/2Oc+bocPvCxlb2IK9J1J0HzmRqGLupO0rzSYhziBnYRSMgOqlRQdygmjL7HPxUPyF5UwFl8NYD7cPyiqTj6cassbVllB3So4lk5Cieuwsk2brAqnJBXIapUL36aF5qtsHqdImXLw/AOfR/qT0WE3Ai0sPoL4/788Nzd5KHPR5V/esB6A/NPCsB3vbXjz9y6892H+87zmB+51yQNzUlkKCgKYC1BxY6N12sGBFlgB1jT23CDTFhjgWXfwM+6Ubh11GCL9Or69SHYS6CUwC1BycTQCXkkwJ4dJWvCYM1EWWCScgfUgi5kFRc9wy5uiFOCeFAXBqxuLkegX5JDzw1AGoi2OMxx+pZc48o473JDquC4A/EVcWR0/p800qSssJVlSo0RZIf06blSMOcskFoV5oGZgcafV33so6qCNFo4/cDY7/dzT4gW7sRLWp4p623jdTZkeZR+lPU23a2/zdN106pHjpBxNocSQBiLKjPNc5QiqaiWgScukz3iJgL5ZGXaBVY2X8+x5CQG2ovCwfUG38evUWPXsCiByeRAFgScmwlh+MkP6DcdYfG5FRSCnFIAR9Zyhsyw2gcJkMeeAkMMtoO9P409XwpLx25VHP/Xwa9Q2RSr0VjnQC+s/7tT9kv9Uf0eemgEB+tzyHqOuYkJyBDhYNgeA1ydghhqBLKoIJyFrPArKjLVqQQtizBbeJ2Mj+gJojQBh6BSsgiePSIYpJS03vQN0FVi8Mc7iUi9NWflSr111+222HrSMvKJK6+9pB98XTmCqUyhJmicA5krOhfuDHlACBVeTkMoRf0jRXKGbSTrjlEUSn8BxTBImCUrOedIpyGlFWQx3GYhRHSpKg2g9btkmDc3pGQHy1T98+bwVkBeVJXxE8IF/Q2BP5drv1ziK08/vXAHQ6kNZj/Uro2uGDEtxDAlnHxWXQ1GBI+gF8HdXtbbi+H/Q+pGkqagU8c4hd7MTI5YD8Ed6gGa6GuryvDA9AlCNo34AmJlx0AhySu185yBAFAAhTwtZq6i75DVO9JhXoLZ5u1W0AJTRMZvlcU7iGtJbalGn1BGUpkFEZkngPYfAHGvHBJxY0wxNtBne0zEyYn/8CVgzC7NtrAsWZUzqQoSGLIYlvK+7S6d2POmg38Y8k5AxGyoAeDr92bJjC6zgJ20KRgQKZAnANf0QlmDB5mllCfql+Za7rA8g+PyBfXIkVObYoAVK2YZME5QXIinRSM+Qlx2UncCdal4C3d5YKnQ82WM0lgL5CDgw9+s4ZjsRyaSuHomhMOZnzrVbdzdS3uP08b63vtVeenW/HUc6+3wA8+pb32l9oHYs9CL9PME5LL+SnrE2Zc0k1aluTZP9xC/+ps9xF59QFLAGYU169JGH7SUk+bn4tRMZdjdtarZi9F05Ypt3LhXZNycq4VSN9mMuNQPwVsJvoO/MMWTg7YEh5Q5rqW+wSshHNizmR08dtdKatcj2yahcuGVsyH7kvruR9RV8BfQXLeZOXXRF9mlka/3cpz+mZEAXRqdtbArAfHZEybB8ncXKwEgwQzjBifU01Zf7I/2LaKzRpXiTkkR5LIMVfx6nIBOI6COLOSKzFMAxtQjj3IcES1XwR8gen7RVUELK1zXbeO1WhNukEs455iaGE4980cZPHoYRyP1MIEs4eJl7eHFu6b8gTuWJ13Xc5T/ekB7APGCYKVrP10tEzE7hfRBj8gMV0vLSB+aMylJUJCqLg5YUESmx1zj8XFR9ajtxgUDGSeoCxAIjnm4ngfGwmWgx0NEzraSxIXrYOgKFdITtlAFeRyDAJ9OKJIuAIj5Qy/frZ7CBLsGKRIs5SNoBzryuSzwm12Yf4En7pysLGQdB1TGBRl/wE4ARqCJoE8oKRC7AFm3nkSpxQdrWff3MvBJQjBVenyf+twAvCpoGxSCbqcaxmRAsy+yX6DzxHHbo5NignXruKUU9IMeP+3kp4ldvQOY9AShCBKWH9153uMPwaoCYKLIYZY+BysJkRgUFBOZMzENFJrJlwnkyC5qPA5qwupGGoRMLdhn57t40pw7oMilKy0ous7Ix6CviN10bkIc/1I9OrcmW9RZJj5iURgLjvFqPhEAaC4+QhcwFzAuxEQlIKlGOcyaz4fy5ROsvOeaUh1BYOG50lpIVVWDcx1zJmdQ9qowAm+gi0ZbkgJmJnKKYk8muzdtWrOySRWmRIRehgKpPopMC8/sOKAyWtnwvU6LIrJfsqzjikRVW1i9yrd3iK9oK/vFIvf/kQevCZk7lh/i4+eb7Aarg1EXKD/oyb3ncyuZ77bo777A1NRXglcLa2d0ORzg6fzqn27vblQfSLkpAoVhUQOxlhOtj/G5WmACIVmbnrvLlEW14L2X0IkoS64xx4LUEUQRlriBSsSD1AIo05M17KhT7kB3xsFGXXKASxTMPeXNjQFpLSAdhhBYoHqFAOsYOgeQ6EmE/taaQGuPC6cBcJ2GuCKw832UxxVLXeMjiSKqOz6Gi/Hnr6xiyhk1XAHjl2mDveczDaTAjquTzQWUjB/2lKKksX4+EkoGoQVNMKgPwOzc6iFjn5dbeORAW7aTlev9LmWP/hd0gH5lNy5t3WNm67aKbcVYUgXNcV0Fg7u1g2wdHp0Rz4XpFkFwMq/oEkh6lVwLVbMdLyKD5pS98wrJRzgId/Jg5F5bw6lWrZfUe7u/N3DcHIwdpRzMA14ywwxOTVVDwxpEB9AISDVEm86FElJSCzoBnjwPIlcAyvPm2e20UzownX3oZFnFYaUmF8Znu2jF+VACk7n3LLfbsPz1mkwM4XVC3pfXBDRCaOvGTv9OKz37mqQHXg1kAXvdd8CpXgkJy5a5tqnM7eO2dcDblSdo9d99l+w8ettPHDsN6XGq1d7zXesCTX+xCW3kKBKdQDcDMkOXPINoI2sVQmj//ax+B0kWGgPS9kH/S6RbtMEDxV/7qE75OadyybH1zi1133S4oMgtWU1tj4wid+Q+jFTidwM3goNdWlloVQh8ujPTZOVj0G7bsRubZJmtFYqST509YLpLjTUORK0Mc9EpQhEZPH7L/9IEfsWWcghVhzSNnX1sC5z/qOIe59Luf/CNkAO6yrm5GBgJjZnoQLEGnLdLizcRCFCfOSSo2PAFRe+QACmdd7s3BM+c4sTP5eXl5sfXiZISxzSsbVgOYr1Gyq9GOs5YLelAtPqsAVa6mpdVGqzbhRCh8PGLMug88Zz1PfRO8eD81m4dyx5MVPHAJe83fzC/P/wY27HMZYbv8yxvWA5BH8s7JPycPnQvBQbxPQkZjprxhj/qeLOjSB+bJYs61VJuhkwIUIYIrBF486tNv2qj9ewceCZDxE+eUJm71ymjSCkTA45u0g9xYkAPkKP8QQaaMhw6OBFJUF+e9KsscFppp8BwZg5hpkN0RMDZ+LmUJDHKRwsbPhT1ZL7MJRFXvAG7imLihV8+ihVdWGZlyVX1XJJLt3a3yabPM7BTR0IstVtpM+ewAZp5VUYhBIa0ULxuLMLNzqs9lKWNBbrGl5XUKDmknXwCVJYAJHV8rkOa5ZQ+cmrwlDoL1HI+cQasvQRE/J3d4DEpADixFudiAyO1khjo9I/HMdYbrFkueS6jZGpMEqQDXqLh41bTAJwuXA3G3mIsyzUvY7iAsqB8zaJ4p56NtbB/p4XSCxFhzjOhkq6DdAk5oA8xHuQAsVEqYRY+0izyckGA3kTMaVUK3Ynu94n9uP4ix48dO1eG4hYNyph18lG+25DknIJrZgFO9NdoXnadEWx1IUCmkIhEnDlT2+LnoQhqWi8aUkVqcd+zKSyh3mZMGV/4IRF3mca+49vPWDWDef+q4nG0py5tveQBce4Jh76t8APOK5RG79vYbrXFNA06Sqq23q0PUCkYw0ckXxycydU6PzyI5CpyOqQBBLsvBk2ZlRRdxpCkLtINATzDlnGkWEpFWlJ2QwAHPx6YuJUFy4j4CtL5ng5/qQM2t007v8vFheWk+B1oL+ZEQ+dTiyQ5uz4s1yNU4V0gpo+pHWs0lrrSOcx1wWoQ7dTt1St/58uOionXCr5WDsr7nYLlRYBGGp/HzZ62yebc1rKmB9XzEhgYHFOFimQB8akYOpBw6ZYlFWTpV4HeYs0WV9bAgD6H/ENpuaBKWbka+4IBT3hiD3OeBkr2orb7OMhxoedOVVrx6i9VUlcIhEKFBo3zWfRgKAmOas6KkCZXg+ylYgpOfZQKOnK9/+NlPwkEVcdZB31gE95uRoMjbLiorQ8ZMcr4HcS/WUQI7ZlVGqXNQ4gmKOX5F4Jkzsc8onSlhIedqU4b7KBtjAOz0N9h07U1QlvORa+FxG+3pdgpaelFuQJlZDWfkYkS44Snn2X1HLpquPhJ8ZUB59AWBJakshQDmlFE6PPKdXuy/q6/epe+7evqsB29mBb7+5pts//7XEGrxFCgccGa8E8AcDrlLfXDKpTVfnGy8FqYsf7obxhEfix/7uV+z+sZmV+Q4FlqDXLns6+uxP/+D33BgH696gPE777gZCu6k1TfU21JRlT00WGDDc5gbzKqJPmyuRtp7APNuzNvyNRtwCnOF7QA96GXQW8oQYrJ/YMDqa5A9FHvAXP95e/9b77aNSAo1irjhrXAeJYWKdWMYRZ4G7we96m+/8Dk7ffysnIELYTHPImUM9RqHwy3BNvfDIigtTBQ1iTHSnMOb1vC09zht0PfTbFCl6vCsztPnNLNKEVK0rGm9r+FQLqdhLW/adY2VI1N8w6aN1pvVYCC9ZNYdTufxnnY79fDnYBxwI80clB/6T1FGuYagfiB12WcX53N+E14UPSsCcvm3N6oHILNNKIsRXKjJkzPG8IqkuVzSrwTMu9DYJ77PW6ptEW9uZStRWRTHHBZzWc04wRzwRP7OAGpcsAKYat9MG2785GKGzwl9tYRldkG54cUxfgJ7aZf0jZobPzc40UYCJ6oCmUUSv9MZkBsowA3pGcuwmNOTnHxI7feyQK0ASlnHVc+0PJG2QXMcragEP7S6JutZ1JdtyAAyB+pSTmIPSRuf24TC+vU/CYRf7LZrhyT6jd7+rCepLGPw3cBxQDbiAufQakjnPPZ61DdgDED1gJ1FrOHkSc82MU1267WwmOP65FSbsTpFn/FZCkkGwDQFYL5IKguOM2mNY5w1HgH7cTy5vyEJ7CcCMTZWVmNacUNBy/ShA8qknLlmEBIlyfJTCNbfyQdRuEASJCakL1mhBfFEFcG1AKDeTysOoHkAdmzHJEEFLcPY9JZBmyD1B+YYceUTqFOfB9B2eXB5TSoYm+A6ktcqmM5uAadYRFMcdgb9RWjWQZyu4J+sayiZTu+KcXaCtMusjpH8ZInCk+PozTuKoJSonUomLk9Osw7O2H63EnuYRZQNue8++ipClx33WuG+Tbe8V+Mobi4Uq4LlMStZGrQb73gTgOQ6YIMqhKw7BwsuIlIo2otLlE551J+gskDJEYcdG3Q50nozEo4DXlwDBzPRTmS9d+BJpVDxqqnIEZTrtAPgHfcxzjgpN+k5cvAkOI7Mg6TcJOqIqCUoizLtkUjiJ8pW2i+Nh88tPRfyIOdoDZ7PH1m843c/8fD6yDlS85V0K3YuAXqcjHFyabziOk1Tb5NTfaicumIqaz9qM9F/zmYXSm3rNQhntzANsIMQgrA2LyFiGedwPlLCwzVVio8r0+wBUC+Q9TGrqByZQheQs2DGRmdzrLMHdAo905213aLvsuUp03Uopu/z4NS+dut1Vk+KizrC59bIxKxAGV+0mJcykyVoHnMMxRrym8brAqgpjzz1hL2671kpeJMI71eEcV6Cf04p+OFMGz+Kz8gv5/pBKzlpEAKDsHgScJfCyXN8dFLWV64hBObzuH+WkZ5wzZrWzXblrbfbU1/8axs4f050tLQWcXzLa2ERBrd6Avz42nUNdmrfYdB+EH3Jp0dGttTqGF9vGxI5AZgXKOkVFAfSWdhuFwFdu3PbZvDeS2wA9I3unn70U47dcOONtv/AflCQuqTk1NBi3gn/OIVMREALhRvlOgca5GS7gDlB6tse/KBdSb8dSXDUJYA5w0d+/Pd/3SZHmOfFK10CCsq7778PSbx6rQHRSwoQ4edbYxV2bhLfk9MNwLsGVvPliSHrP7jPCuqbrWrTdtvV2Gjn4ZRdDlk619WO+PrlsLgD7A6129Wr6+2et9xnpxC+S0cWswAAIABJREFUcu+WDQqbSKWNTebp4QJk81Nf+mv7zqOPi05UNIdwlBiTWShdNPRwrpVBYSDVaQ4+EbxGJ5FoB3KUyPiR9hE62ft6k2s18KnoRyx79jEBfPX6DaCrwKiDKFijOC1Zj9PZbRvX4iSo3M5PldrMEpRw3sv9h30EIH7oK39hWf09+ozAnDLGuV0Jn4YR7D9S2JazZgoLSz5hm3b8zvi+Jy4nzXFRfkNfmBfknzMGOlcSHom9gvWDjqKX5OvSt5jfeu/784uLP6rtTosfF6CIzBAbjmP5dJyX4G6CYQ5EV0CSW+jclMU4zc6hFlQRDkoALv3mVmtuLypZccZj5aYlj0XR4hGxbwnMs7FgEqgRfDogD7Cj3/lnlBWtuWjd90sDIDjg8k3ZW0PKCAFKOn4OgJCsn7EDJnCpPouqZnYOf7x2n+hJDxemz2EBhiWTjaJjDqMryLwapw0JA9KSPAaO+dnnn1HnJEWjrGKVrd97g1ePG7rMsnyW40LHVQQWgAxQWmZh9aDzZz76KovOphGhQ6MgMBN9RbzE404uunFgEIcj4Wfqi7FCV7KffEAdmBJchPbi4CTkiCCUNAUdkWRuuKi7Uux2bpAMi4Z7w2LMiCEE5ryPzncIFIY9j1FZYOlllkQBLpeleKLLjsCl93XqD1dC/CoCNo+ywmfjGvEl/cQgmuP4TWCNpbmC5pLM5/mJik4N4oYENFyh9UFQaD594YA99Y+DrwRMWI5TOcjb90gzvBy/43aCXgLznmP7beDscbWHl7Tc+kBY+QkkYZnEsXzh0jCiS7wZwLwRwBw8YliyyDHX86Lrk5hOIalNkTJ/onzICiNucD6Ic85+pRPbijbq7RH45fznJewv/4yDloc5SJkTiNSez98jO2Wa0+w3WcC9F1mvXGURZUQa9pcPgC8/Pm/oSE1AQUXS4+p7D2tmckwCbKseGjQf9HSQwtz1KcHRoiN9lasTFDUhFIyYdC4LuEJOsVT8EBJu8LT1nx+0K2+5W9SSaaw7Y6ACTSOXwtzEGKzocKqGZTmNu+ddwEkEOOmLSh4GejMiZUxnFdj5DgZRiDokUWHdpagxJGo8nwoKPigorbQ1V+y1mqbNkpMLGLcZKE18OTCHQoTnTcPBMIpz+dFTDPHVu+zTf/UpREWpRVSf4+J70wGS6eyLse4QgI+DQz4DEL8AgJ6HSBwKb0oLOupFmgaj0kxj/k0jokgpwkjOMbkbOMozsLbXwllw99veY/u++mUoj0dcbvR8Zu/MsfqmeslGf0evtVx5hXWeOGMTg8igmgwASSA1bCvr4+uAOU/UIOOksyQ/HZa/ubUZzouVNjQ8CnpHn8Dr1dddbwdfOwCFY0DJ1KrvfND6zsFwiEy3OA7AQ1y+Ob55AOY55F3jvfv6W+0t7/nRzPxzBdst5pTXv/nsn1jb0YOZOnJd/aEH34NTlD6rBGe/qLTCjmSvsuf6UT6zzNIpFOERc8BjH0KSoqWKOlu7c6+11lTbOOox0d9pIyMDSsJUj7CTJcuTVjk3aR/68Q/bKNpbSufg2moPdYm5NofxIPnkkwLm37VCOAwvjfZCARy1eRgtuFbSuFOA0xAqzvM4+XBbiMsKT0qZIXTlhS+piEEBqoDiNIrTkxmcAlGZqVy9xpaheBShzNHebtuwd69dtedKhbw9N1aMfPFYNzhP0lqLQgfOHLCubz2saGx0muaaxTGsQsSaW2+/3kZmJuzJR55RwrjC1p0TA2VrP2qzS79vL/5NeARfVLXLv/6regDziIsR+ecboiDGPyf//JKLf37JA/OrYTFH2uOPetQNX1j9tbKZOeghWInNgwtXAjOxEchKyDJicfbtxQHMyn38I1nOvUyBHe6HGfju1k5ZN0Us5a+eYIGW0nkA8yVsjEXM0AfrhNNN8E9H3kGbSfBPmy/LcetDsnKy7MBVDsyEbL0+Dj4CiAbA8muDWZ7icqtsV1Z4f8IyaWZlwEaAHrcaYqEVMMf1OMYktYSxmL26BDteFT52fKzfzr0Ii5fb5xVir6xqtW2QxdyVnIwTGkEbb8Vn84zdjI2VWfEmGMsa1iKGS6QVSol5WBYBkTodb2FHFEBLehydehtSnyQAG4BVX4XlWTIQ/YLfGBLQo7zwC4AqKGVM7+5/01pIqoBqgDJCCeLvjJgAmfI45twUAcxzYdVFR8yS+4qyyJNfZiIWOf2RWuGypOLx1rMVOtEpCvwwE2YvyS3JPlSYZJnVQEc/eIuT7Gb+0jM0KWIzIoDm38HbxteqMr9Vs71tKVpC4rrzb09Ag2uY9VMyzZv9SVISOPgoTJkv/QJtup2HXrahcyf0US6uabrtvQpl6XGMwZNdhIPbeJvd+fa3IBTeGoRCrLDe7g5QLkBlCcqJ6sVnQ+6mYHktLoPliynXMd5lOP7OocNtqB5KRsJrRXOKcROVxZVehsBTnSU48BeAXM0HfzVZuUXvyABxn3f+eAoqIrIkK7coXA6QXZGibFJ0XB4J/BV7n2A1FAM9O+7LKAhSEjgsaaViGcpjrHulUOK9EndfsZrceCAenY+xHh5OsDyhY/PnphEd6aVnrWXHzbZl+zaBU+Lj6elJONwhPCLiOucDzCSrvmQFiskCnJYXMH4FmOczY8M2R6fQDkTBIMeXvjBsd+Z0wH0BFFI11jMeoHD8CstrrH7LdbZYvhoA1S0EAubgIvM1DgdQP8HzcUkKyCye86d/+SmotADpx4/aTiS2YQjCzp5eG+k+q1T35ItPg5Ixxyg09OlghCjUA9E1kIioGnSoaSjGBO/IVAkFbgGgnOv1FCL70Bq+9U13W/trL9vpl1+UlVbrAt507F3dukbt6zndYeu2btRJZ8/Jdu/rGGdVl13P+cnux/UEdflQdvKRQEchQ8mzhsXcFUnNamtpXIOIKDXInDplXeCQL0CWd1x1jR3avw/1BY0DNL4qAPOB03genTIBfHUzX/iZO9kJ+gWVjAVrRGKd9/3UL2pdSX3odBY6oS/aU48/Ao78w36rRCbL7gWfnazAEjhRl8Ka3J5VY9/oRvk47WDUKCq+9Ujs1LXvKVvIKba1u260Glj4q9CH3e0nbWykH+EYp62xdpWtApYfPnPEfvJDP2Orm5qtHycZW0B7ISjnFJiG0nQG8cb/8A9/y86d74VzJvoHSZKmoYCQnqO5Bg2QVL9ZUJuYiEzreVJ2WI6UR+9nndBE6FVmdeVYM2Y9rymuqbWcqhp5As0PDVnj5i047VhrjU2r7dRIriHYY7gP8KTH10Q4e9rZR/7Gps+e1MmnlGPONSgEpeUVip1POlQRfKrym7fZUCWZF1nQ0OwjCBL/x7bv61M+MJdfb1QPYJwrUdYNeFfjDa1U0Vva3qjyvxfKufSBucIlFsP5MwGxsGwTwHCf0pIZYDq40om16wPkcCbglv8dnE3+TstXCnemRZgbUCxzDtq9bI/vTB4tuatRrDhxvAaLjeJ9A9hik1icn0L2QoQww+LtdSPG8p8OJlbAQKoff/pa5cDJP+c6kja1BJSEwqKG3noH9A6ovK2Z21c2RL8l80qLvDLZJWCIKk7hGDwHG45CWdFrno4zKFAWQC9e74mRXjv30nPaMLzO4AGCY77pqusEofwyV6YEerhQ0tJKizk7Fn3DWNbZ4JgzhF4WM38GEGGf02HOo2SwoGg76UIccTd9R33COqxx9e7l/wSy4vkJDKj6tGYmc7ueAcSEZyT4Ln8FjrOITwSH+AALOi0uCpNJixqtdgwJiL9nsdGKysJwiUxLreyl6UQkuPkBcP2gJSxFBLkC8L6BuCGdlCIHwAksJjCtUVVfZhqe4c+nTyk3LN2TTek374+4VzQMh4KSVVceCAhp1eRmT/42aSje534SQmXGe4fXLyEMn7pBz1mw9leftf72c6HAZlvr7aCyQGCWcuYRo37eqvNJnzhnd7ztHjie1eJIexWoLMj8iTj4BHZSoSRfHIslWEDhzIjkLLRGUwGqLC3HM0kl8lZmLJOK+uJUESoE7tTrirTCL7KucmIuBPeZirOIKT7euJ7Ac4HWc1wvGMzuFTD3doOUhDnN/guzvgbKn5EwJnuBdK9kLNDtQQXyUw8/vdAxfTIsaO3heNNqD8lJf6uHY+2JuSa+t6hdTnGhxVu+IeTAJ/HXuohxOPSszS+X2tW33yX5loIJ6+X4QKf8XgpATUiSo5kpVA9+NwBpQUmpTSPNfTYc6s60DwBgw4or8BJnPkDh6j8ZDFwClb9A/eNyWVBWa3ngoOdWrsGagWyNAOa8f2LSwVkGVIYCxfXkCURMGRruR/KfTrv5plttG6gKv/mR37UxhNOEwz/W0ELwyEcA0JENE0CdSgOjtcxB6ahtqAOVZQIgfBxrLlLAA4QyyyvB+SRO4njS0rB5B8LrTdnRpx8D9p3OWJVz4Tjb0LxKdeo51WHV61ZZDWJ1H39mX8ay7nM4VucAkWw4FT0C80JmlBUdA2sA6kWrONcKjlPjqgarhWPpBGg1veCQM1HShiu22oljRwU0uWaW3/GgjRCYU9GE1dZXTAmh5UwBmCNRFLg5UDDq7AM/+6tWiDFKhhbPDeF0kJMnDttDn/mYaC96oYhrr7rKNm1ZrwgnZQDmk7mV9rddkPci0MJ4TIL36pJ8u3D8VShwswg9uMtqkOxn67pGO4goS7mz4zjVAhUG8fKbQPnp2P+kfeiDP2Vbd+6ydlBItjc3KgESlVvyzgfQ/7/40z9mI5NLiEjTYIVZ8zZ4CqcUoI5ImeI+gvHhGDAJVJoTrK4UPsxRrS+aC7ESox9K4EtQiLWg+1wbllXQhwCkS3HqxnV5EXH6i+DMXAIr+patLXasf8kGsxAWUkqUz1GWyb9zYEQa+u7f2zKs9dz7i3E6Q0pWCfq2oKrBejowDj3tVtR0hQ0AmHv0NozHwlS/vfb474Jr9QkU5R6rl19vWA9ADjaiMKTAhXMAUjbg/SJk/JI4qbjkgTnDJSIO7EdFJaGlQJDAJ7ADGIJfD1cowkdYELXdCqgQHIZlXBsckR4nboruwL89kkuKypLs47JwKtSZT3Yd+Yt3HOAXnyvZNzZZWRyZYAgWHCZcyENsYabrVqxlXqPN1oGaJ3bJrKNSLpxv7OX7l671C4gEIHCoG0t4BpymtNfcFPzSFUu5/56xVmnxC5Sox+sB2mD8xJ1RWRCdAFXIo3Mjo8ooEYuXocVTZOxlmxjutTP7ns/wbvllee06ZO67xq3lCeiwTgHkOFK00mnxBTCnEkBuZSE45rRgkKMvBUbA3Dd89gPpJqTPuOnWQYXXRZfqO21rARJ0j3rV+1EGaBUVchDIStZ0lkFZ4EZMEJogOusYPEgCRP7O0mgZo6UqF5FHaNUmMOcGmY+Fnnxm1VXOn241T9a2aEyMO2WGMrQSW99lKuRAIWFdAXXOb6yFvE19QDqGc9gTGPee8k1NcFfCwDda7ijaf1eDHZgKSABc5UIRkdhJRl02FS2GJdKZlW0nyJSx3LnOdOJj/PbO1wjM2/AZHaBzbONt92MzRBi8jtM2NthuV15/g412nbB73n2fbW0otbnSJkRlOQ9AhZMGcVnwIDxM4FXAHBGNYNFboIMmnlkKQMYY63RIZu3meTSeTrUwsMg6rvCWCj8YIF9ZY2kRR4ULcUSNIGk+NzBexOXMV8SWCOhLgNg2L9f9GADMdVJEcOsAjWuBXpKTNMcw7xlTjmUFkOMlUjIIyCNMYlIu5dugU1u2m0qBAidK/kipS0q8D0PMObYlnEbZVQpVyfsJlmVBD9nA37Oj7fbqY6/YTe96j9XiqJ4xyAuKEZEDyVaG0OeF5eCdSymhUzPXF2rK88osmgdqysI4opzAct45hCyVDEVIWcabzpyqj9opN3oZNOjonCzooc1ZTnm9FbfssfL6tVLqGZZR/ZdOEcJQQQrQMOg25bDmf+PJJ+zWa661V0+dt4c+/3GwBRmvPB+JhAAk8dQxgHPOuVlYNjWAkJMaAPMJ1JEhExcR2YnX02pOy/ckPmMSolwAt7WIl37wO9+yaZSRlLqisiJrAK+cQL/nTKeVwDJ75W177eBTL0FWiQ9ifC+eS5ItZv2ktRyZP2HBZ504zqRz8CRQ+xPea+B0WVODSDmg43TD+ZMW881bt9uxo4flxMpyct/0LptFTHlSmrCI+DyQhKOvpvutACdNywD0RQDk7/upX7FqAF4ZR7gMSuJ8HRpEBJu/+tPf08ldeq1GMp773naX9SNhUwX6YbmgzB4eLrPRLBhblGcBCaDwo2Co08ZBCclB1sySpo120xVX2MtH9tvqohw7fvKYlWLu7GxpsvHuY7b3quvtJihP/Qiny89YlTyM/9jUNJIKTdt//pWfs+7eUWtt3YT6zVjXAZxSMAu2FDyGRYSCDKpVoqLRr0i0OK4o6DOeRCxgL1A0I84lKdUFthoReM4cOa4ySHMqXLVWJwFwUpHi0njVtZgKs9a3UGxdWdUe/YrPlMHI10KudXngzs+dOmQLJ/ZbHeYGDUSlcCwvhcwMDPQiqky3NTS2WNnaZvRXhZ2YwVqE+mYfftyWpyY6UcR/W5qa+CyKvORoFxnB+b/wS9BbCM4TveUwxv+1/wtVeUMfeek7fwKYI0a0nD8dUiZoGlbyhN9iuRJwJ2YgpJGVKhwbw/KtZS0BbJkpndIiEKd18SIUFEBayS3i2UG2cGdBAk5xbsmj8411AcB8Fs4pJchwyKgsblHmI+O53O8DcPJRrjg4YNKTVXcqAU578egcKXW3W9VlfYu66xg9YXeVIIgab153sbyl73iZWxAXScOh1QabL9s2Nsp0ytngfXMBR2gsuOCrbzJA2R8xNdxjp/e9gEWRae35DDjq1TfZht3XZrqQdaWl3I8Y/OMFpkNnXwCYTyOiBL33yYXNDYu5mLpqO6tIkM5ujUYEEPXllv3IB6hzRUnhVa7c8B3Km6NXQSAH3w6LZDlH5QTgeW+0L4F4uRkLP2MLpIWcnGppGCiHmynDI+IZC6BksHncaEjHcTBHK6qDMy/Px0VSpl9ZJ//hVmsCMzomq/VxIhC2bdU35PQii5K7gPoc8FGNslmeuP1+v+JPC5S7tdkDl+A+GY7xmWI6BrErUX0kjnywV9IlODj/fl7v/YaxbHv1aevvJDBnCvpc23LbAwLLitCBeVBbhPThHUftHQ++E1ZOUFlgWe1GtkJSLYRpMXd4LC4LN8qdAGdYFnPcT6tcGfp1AZEiqIiwjUgU4voFa60hDsVT64DUYw+7yfJoYYWjIBVPnfrwS2Y8Fahlm9L8pwINriz6yhP1UFlBrxOUCgnR0u7Lht/nEkiFIQ+NcJqbV8odT1cAfeLmS4JjzrIwypPkBO1XZHY5DLuM+mi6AYEAIyM9GmieHqC/yCMQZYk+L95mUisW58fswKPftsY9N1jr5k2KKQ+TpEBdTwfC4eVRCQ6lg0/m2sZkRIhxzpjSywAws+Bujy/kWwf413x+NjQZ6svsPz/4c3nJ47hFVBpfQ33t4s+CmjVWufFaW8jHiQf6XEqz6A9ByZDiwf7imMLijLb8+h/8rs2P9OD5iMDC2On4rhQxyft7ETCDvGOOA9YLzqsKcMp52jcyMATAN61ya5F5cxJ8c1rM6QTJaE8bd11tB7/7bRvpAp87rMqVq6oBdCtBk5mxvjYAU/THdW+/04YRjeTo4y/qVGzllYxBrC/6QlSW1wPzedR/7n8A5uXgcZOn3Q3LMx97x1132j8/+h0BaBlirnwzhB2KBh1H5y5mS6CvZobh4AhFAsCe0Wce/LH/aI0AvFKCfOlAP7siwKRMn//4f7exIVBHNDTLOIEstPe970HQgjrBM69EXxbY0wur7fQcT/SwrqsfEMd9FlShng5f5xE28ZYdV9r+cyetCcySUyeOgP4zb5uqyqx5Xa0tjE0ie+k7bBT8/T0bNsnwzoRDdPDtRCKgz3z+E/bKi69Zc1MLlIJ77XMf+a+IvQ9nZChZpLKQR+4RkeJ8CfOkCMYr5oMYQzZQrv/Jj4QO1SnRUMum9XYamVtdsca+BIfUXJym4HzVsgDON73pzXb68Cs2XVJjg4tkRsRe4RMu+oRrFtaTw09ZLtZrFlYJ5awC4RhnQP0ibWcO7agAp34Q0YIYOSareZctNDRb1uEn4DNGXrzW2zPzRev+q40c/Vt14OXXG9YDkOU6FIasZlaONzJv2dOQd2qs35evS95injJ/6jgd84xHU6IE6HiduyXHLRPfwkGZrOE+MS86kMTvtDLGMW5YKJzPG1sKgVJYWj1WuG8cXA21sSvkmW//dCWScyNf2Cxk/cO1swDm5LWVFCJVNi3OwdH2chKICCVDdAG3svjj3HovEKT/O3jTaqwGBUSixUt/kRPtVAN/rQDxi63k3mFOw3EQx3J9A1XEC1r3/G6FsWNdaDFnhBGlJ0+bryrpdZkY7LZTr76ovhCYwb/S2kZr3XOtP0OgM2oli2sATUZp4O6Osidhnc8nUAe/j0eVy7DAaMvXHh6nG15Zry+xiIY36sEyVR2PcKHTDIHweLYwp1Z0B2z8ne0hsJSe5PfLbslnqg8IOSO5jLY/gBfyU9mDiu5Bb39YyBFnlxbZGVAycnhigvFmUha3oLpykUCKA3J5/3vfqHMSvYHXxmkHS0dFhJWj75JS4R6BDn4y/4tQiP4Z25/ZteMSPicsty4CSaAC+LE89gkBusuii5GDU2+BK4FBEpGVS5ZH7e2Ldn7/U+AEdwog8tRjy83vATAP4AeebP4sjvLHumAxf6vV169GKMQaRKNAdkFGs0FXab7hWYwHzrk9MTkPGgQURjwjB4CwDNEYpPwKsHKq+VjwPlFQMk6J7BbPMkB5JcglMGIG20VazEPx4hDqEIijTloO20n5wDPmuXnz6F2KoSNRz5YbSon3TqwqfD6t/Yx8EvLIK+VjQAWQY05Zp5JGPMJTPY9IRHnlUNHBlG2jVGWyhl6U0MmjtgQlRjJOGfQELO6c6rVxy6PPG+pS8wi5d/aV5+AMV2ZX3Xw9/F3K0a4C+XIM9+C0Ao6aBQCulKdsKi3sQ3TM/PQF1BegJ3sRlmg4hWaX2Nm2XokW1zfF+pdRwK34jMxB5clpbr5iyUFaS53P1/zqJito3I2Y5dxvfa1wxZvfu5PzPDrjqX0H7eEvfdbycaIwhcg8ml+oWxEdw1H2OCNo0B8mOMpFiBpVWVluXYhzLSs0HRPBk+ZaSoWMdWF4vurWLXbh9AlrR7Ih90/IstYdGwEEkalyZBSnPUwJv2g7Ec6zEomBnv/qt+E4O52Zfj7iviarzgHMmdlUz6JTIQAnwblTWZZtLagsVAxYSEcXQjXi9o1XbLPTp04gzB8SuHH6bLrR41kyfF+kr9cNFIyFCaS17xVljtbed/37DyNgyFUaX77cH8RpNDNQcD//iT9EfPvzPi+oSGNMHrgfIHpiFOCzHONfbK/M1diBWShpkAPuVzrlhRK3iDXYhvHevNv2wKrfh4RCE4M9CGMJvwP4HqwvK7SbbrnV9j35qL33hz6orMyziIazBw6zNVA+GDLxICg5L736nH3tK1+Dw2il/eIv/Yr9xi98yBZg5GHEHJ2WyMET9SY4x/jnw4Iu9ZMhhplQiuE+ubag+fTNWsRpAV9N65tsoLdP/gbiqlfW2CL2C6rDRbi4Cf3S0XnG5nBi2TeH0NkXzQuXSfYpfiBjaOHRJywXivAC5KAMz3/gXW+FE2iFnWprt0e+9V2rram3CShJFxB9ZqkGlJbWXWZHkasDuSq0f2AAFvLrbbl43VHIw69bz+NO7r/8ekN6ALLLxZbxljfhTQF4GX1+7g0p/P9wIZc8MPfMn4jKIuAkKC4App9cKDMgJo7vuYly3dJs9E2Usz1DxeBngSsSYHNbZvBBCZJ0YwI63GRX0rSLAhCDLFCojHLkmjpfeAaLTBYtdQgDRYt5OlLzzcit88QOHjfZgZYv+2IOBvJkW1Ys5m45Z1scIIi+wE1V7fRWqlscxes/bumxXWfAYNo+/eLM/0TTYF+ySlOMMYv65YGHmQ3HMYGH4JK6NVoPslFwV88eeMX7lxgGP8vq1tp6WMzTkDi1AOXSSS7amTiyWVhkmfiD4dKYcjkXlhxxet1rR/0mfrc6K5oYwFHgKyyYMcz+HFzP2/0UwgGQi4m3XOCTY8ZaE/Tw95AVp/z4saorfawDqQ9+dK5Y71II4DiHjVyJMXAt45jnAnTn4oSE0RacUkGroLfD+zqeH39GpVbqwrq9bnDc/ihgF5+7c2Bgb4FFlpskMQlCKCWZ5zig1YmMujGy1WoIvXIJEOokIYZXIsQHS1RXlD3+rcgxFHn+gX5phwPZICxzmgMYww03vUv+FhogfJ83C2vn1KDd+Y67bRWAeTGcBbu7CA4RlUXOkD6Q5CWTbz0+DipLKUAPFLg8APMSbKCuuMpG7U52VBwAZ8W0ZlcILOqX6Dc1TGE/meJdYRQ53rxEFnOATMmHO23rPlquCTQJrNnXyVmb10luVtYe7x8f3mwAc8mYxjDIRPwi9WGqI30rBGDdiEAwmEeOfSjNboqmAzlpZUkxdIDvim8MfpyeJZ+VZPmXnEjkPFQlQjQju+Mh6wKw3vWmmwA6Vlt2ITKFFiB6y8Qwsoj2wPLo4DHNaSpmCzOg4pHqhL6fAX97PrfczrUBqGEsE/VIbeeJE6gwdJTl2peh3/gC5bLl+plWttzqZstr3GU54DlTSsdnUT/QS9bU1lpb/7B98hMfgYV4WjSjWVhlixE2cQ4cbbY9H5bZeeSGoBMos0gm8LkWjn/tbXAkBgedjWBMeYXaRB3mYQEtBY2jZvM2m0Ca+TP7XxHYY7/tvuUa9MGUjcFpcaADFno8Zy1CHNa3NNqZVw+B3hER81j55OAfA85kQeS5E5inpDikV8kBVH4RS7ZuzRocqEEhxO/94GTz9IeUml7OOpmGAAAgAElEQVTEU6dFn8vtUityr2TBgk2lgk6JPhn9J/jl+RMd2EfgzIrn3/vu99nOvbdIfjJnKVyb+DzsNV+Ctfr0oX1aZ7RUopjbb7kZ/GyElWQUE6yvZ5aq7EmEFFxmxluMXS5OLJdGEUaQSXc6cZqwdoO1bkU0O8hfT+dZKwDPfG6ox+oxR9754I/at775kN355vvQjib75iNftw/80L+zjXACZYKhl46dhPF/0j7yB39g1+3YY+9+1zvt4x/7HRs8eVSZWCnipIzkYc2kwkfKCoMjkOpJY8cElK4CZvuNoPec66Tp8FW3ukG+In3tnZq3+ZVVkEkH5sUw5NQ2rLMyhFWsWltvJydwSoGHUdHjPSyDoRb5+wxCJi6+9C34RoB6hLHiHLnp2uts9+4rQKmasIf+/mu2tn6N3XHv7faXf/nXNltcZ0sbAMyPP2c54/C/CCrWIqhei2XEjZyPS/swUX7dOh97xAfu8uuN6AHM30aUA80VByPwDceb3POYJG/EE/7ty7j0qSyIylLIOOba+twy60xc7cexEPmmxQVAuFEw10FLAtk60g+glizU/D4TGYFLniyuyc7J3YebpZfLbJBetoMWWUu4Bwkc8ZjVrdwzDFOGxSYPm2A2Fj9uslIgYrPSvSgvILrPb5UjgoWsb27B5rNp+YnFWqjCIbxqoTL5dzRa64T/qZbKoc8Rgvosfc7f020BslN57NVpbHLklObhCJXgmRa/tCGoJgRJuO/CYIedxWYn5SBAaBks5i2wmLu1fIVioWgqgQCcTiETHJy36GiKyBCgsuh4XZZO9GOEaEzAWo+lcVJNdVCagKzjCheEBEtXTh78W33Oe5Mip4JiHATGPemON88t2XzxmF8ZPylvjBTA6CCykCHaCDYZWozp7JsDYJ4Hi3kO6TgCdLCi6tE+7iqN1r4AZulzfpwUCD1esuCtiNujTT6K/nKVixeoTwm4Yzwd42pA/EOGzkB57j+BWwlK8V2C8yqSFCYWkx4q2Y6+pPLnvRJC6uUqihDLx8Z3ft/TyEDZIeBKf4RNAOY8LlciJ8b5nutCBIVhe8sDdyOu8mpwf2uQdr3dxieQDVBUEVKEPHY4gfkUjvfp9MfyCcyL2c+0CIevBwGnzoqoCKg7IrQkLc3kynPuhDxS1kgvIh9epyrsRckfn+vzKKOQkSLBKzIRSeiMDOivqRa9z7ZrzGL+8QeVEPU3y43vMhE03GosgwKfmyYe64nUJrn0q9B3Ec5RwJpjRZWaSocr68kBlXWmlZ8vnWS52hSy5tZ4DyvqEYT498Rwhx188lmMy622dm0LHOp4soMoLej3XkTgyMtHpI5QeijvBMKLsNgyggbDmE7CUpkNMN3WDYoIQhfSaumymqznftohGrqAo/epDw0/9BNGrSFUwOpaLXfNlXYImUe/+dR3rBifd5w/7WFa8WKmSIZKLAKFRYqAxg5JhUDPYBhEOnfKMo152AqaQzscA8eRaMjHHZFI4NjHrJsTSHfPkHg1W3YgdUyHtZ04KooCwewqRE0hyJ9FxJcJWIupAFTU1drqzesVd7v9AAyi0YaYdJkfpFkwaVUhKFJcE6QEYPyorPPN+pbDSq0kQJB/1RXtrweNawRc/nHy5QmoW3FqT6WOXGmlpI+1Xc/FacT4ectFNChazW+993674Y63xTrs/H6dmXJNwfr03W//oz37ra9qHU5K7I7t2625GdkyUdeyslLrWiyyx+brbZZZiQHO87A35U4OIBkeqEvw98jCqUpt0yZrQTQbKs6TA6C4XOizVZh+V11/KzjnB625cYPddvud9rf/+GV71+332o5NG1T+adCEuE/83mc+ZevgBP+2d7zLHvq7z9gJON0uMqMp5kkx4s4XQtmaHpuSw3Fzywaczl6w4eFhrXYE7ckfJznVsg9L0JeMsNN27IROn2nwyoLvgHINYAwLYT3fesNNVrGm1jqmyrR+U9YYNpL9TOs4X+0HX7ILT/8TFG9S030dpwJ126032Bzm1Fe+8k9WDaPBT334A/bZL37Bzgxi7DZdDWD+jGVfQOx/NIJzbgm0sIWyzRg7KDhcB2SEyHrBJnt+CRQXxA++/HojegCygOMdYwB/UlzI9XoK6wcpLt8Xr0vfYq4EQyUelQUv314TLUDbZMaSyL8iwp5fTmsTAbSs356gwrGob0CxFTvICODoVwSQCWAlIy4+ljWVwIb36w5aSOhYTyqLZ62cZjgsgIcipF3msadb3hwsedKO2LgCvDqm5IYmYgp3N238Dg4DWBJViXuRNj0hJ91FS66ATYBJ76aLAKnAm5eVQKz/9DbJyh4WSYb+mhoZFoeS7yXWPyyIDm4DgOAWHom3HT7gBsuwJpXBiagV2dgEX2Jj04bp1dVrCZuXnOIAYifAj8wGqM0HUNAmTEsm702xwIMCo6gxDF+o/nEutluCfTvLgNYAlH4YoY6VtdN9DdjosBzzGJ42F2adTHxSdjGO6D3MH8XFnYYYt16xePFoATz2NyPKQXGhBM1CERO9CeAljxkvyfXV2PjRrZz13CyvXpdLqsBGWFf1BU9KooMobGnoL+rbaGiMoQ+e+krW46T4eXs8djY7w9Wh9AhJWpCt1UZKulA5/2B7w3rsU0BKp6hWgrHsFz/RUSAbcZsX7cxLT2D/7lIdyBHZcPO70X4ATnmK4tOJdrsAS+F73/9OW4Nj45K6Jljk2pDZEZQpKlscAzxO4QvxyyQcyYqx2RJw5MG/oRQbsSsi3i+LoHIIKCdlj5asGNq0sXMDlwKCa8hVJodZmyrlgPdBcVDKIPWz86eVkRZty6WyoPjlaAPLjomSIXtpLN3Kr2lF8K41weVMfS5tJimEDkpltQ8qiOSC1nzxxLmusCOiiUpV6+uETtEItNm1GgGaWknLofS6eSKFU9UKItnzvuFcFj+dnPzcGdv/yDescsNOa9m4EdboagCaMoUg7G474QoA7vVzjlBg4HsyhQyLBeV1oC4MInxqmXUPTtoogKuUIbVQo6725UrZ4UmDKwr6nP2t+eenMVpH+RPysVTTYh//9vM2iPB7SwDjpJUkYLkATi8z69I/wMd8AYmmSgR0p2aYIAaJ3HDi0gQL9zBC6Y30I5NpWJ3pGMh+pVNoMSL61G7eClrGmA0P9doMs2my1gTMfFPRYjQVWmfJcxc1EUAbysgCeOrp5SeR/mKfFkBJKCIwDws5gbkS7cA6y6gjVNALIHe0SnNoKwFIN8LSnFuUZeehSJw+120LLfTFQfvotCmKXDwjFsochkxchLUZisi1iFN/x9seVF9yjnreAc5FX4+OHD1gD336Yz72nHP4tnHdOrsSdBOuNXSEncwpsW/PN9jEMp6JutFxt2gep7uwdE8AKOcga3H16ma7prXFZofbrDpv2mpKs239+lYYTirs5UOHrO10G/jjD9iB00etBuFhdyDSzCYoOe0DfYiyNGcj6Mfv/OM37MMf+KB9/DN/YoegMJCnzrblYj+pXFWPU5hpnFZMgHZUjkzAa+3EiWOyoPPUlPXXWMQCyDnJSDurW9bZOfLMecrEvkckFmYwXYBhh/Og9dobbe3GRmufhkLEtYqgHTJAmo0yhWMQTj75DZs/AgN3BpgvYp0ptLffexdCRpp9/ZvftnLs2R/40f9gjz7zuL1ydtCWN+0F2f4ZJChCUiiUWQOq0/DwmM0Xb8CEZCJLvijcmDlzkN8Lxx7F+vvLiJm8PyMwl3/5F/cAZJmizKREO0IoXvh+obb8YABzxDF32scKQUNbH1e9ZNkIMKPljSCL+yA3jgBF+lx4MblVrWAhJ8ZkbGgol0ksmCCDURew3Qi0eAErfkEe+UPUDB5TK0weVDsCNWy6yFaK+eqZIN2C5CtusiZpW4tFOMVFV52D36vNn5ETBIhd4fCDel/A1Rv4TNt/KAzimoZB3bshHhB9kmZIgugqkTQNgRWik2VkkRsS6KSXPOu/RMOdAAqtfwEq8bwhxBpuP3zILWVqHqkszbZh11XhGOsOs3oWj8FDKWIIL/UVNi+mCOfmwuQ8WtzQVx5xA/dlTNj+t/pGBfrmoz5QB7iy4j4AvCj4wInm4ejTN2TeTiwkmlCAPXK/+a38B1zClqEEkFLgoAxjCwsLgRJ5z4u0rNJ6jnCJPMqnpS8X3xXgaFaOVSQws5/k9UoTaoDZOImR5VbW+ovGTZ8J88b/9Iv625UM/ZkB0K4fXTy6vNY/c2s8+8b7Xkok+4zlELTz2SwsrJHsR+cO8zmu/DEev8P96Gf2LedOSB4VE1l58f2Zlx+3MTjnLSMyQhaSLm0CMOf97rQMPvTQCSQt6bX3/PiDoC2Ae1u9CqHY4PyJ42tXUlP/sP6wOiKuMzPm8oylADJQBEdQNl5MD9SftAHSqxboDIhKu29HgMTUL7Imc14yURYsZxwvKgucvwD2BeCdM2yibGlsG/uHznssL4C5xlBOnwHc1XZX8AWaQ56djy5h9A4SFcUBt06/cA/pHpQdHA/5uApfU2lwfwfOP1re5Ygba1Ri+Cu6D3VW/0ox9bNAMXMeu1C9n0Dx1Id8b/yk34mz04J+RUt6Dizkh5+z9o4p23P3nVaGaC0FONVjqMQLA0j4BNpKIXm+aqf3NftoenIIoRCrFGpuBuvaxHyudbT3wGAYzvWaMxIugUama1fSpbCQc3xlwZQ8+1oRK6EUn2cAgJ453WODfQDoWovwXAE1zC86AYblmbSHcnDGp1APUk9oVa+EopeLz3tBc0iJhxiZZRngeAYOfeR9163fhEQ1dUjmcxzRacDvpqLC5nEup7MjzQsf0ywAbibDGT5yDNZkAGMBO+8VpziBTsFwiVBqnOLmMjmP8WTUESrxhQCZiiKC9rF+e3bvRtKhVgDl7eBMr7UP/fTPW08JwB055nB2lqaf1itpLui/6QHQSeAAivXyymtvsrc+8EE/zdHpBGdeAHOM0QhCB/7p7/yqQHCqa01Njd0C/wJm2K1AlsssnOj980ydDWRhPiHaCutWmw9lAtbgSfDUqzBXm8GNf9c9t9iu9XU2PDptz+/bb90YlxFaucG97jl90t7xQ++3NS3N9ipC5W7dstmuAf2lH1zywZExZOHcaF/+50ft/ltvtY9+9lN24OtfykSuoYhW1MOJFIrVJE4zSnAikg9gPApDEIF5LizvVKKTD4lOoKkso61rwDPvgULDEw4qPSWrEfEHCvs8xhOewrZu2x6rW7PaRkoblX05KShpBeOYHP3q5ywXyZMoi/NQoLR+YOxuB82rtKrUvv3dJ0CNKbIH3v0ee+HwPnv1DID5ZtCNzrxgWb1t2gNbr9hkbWfbbC4PTIsC8NnToqz5jnk5fET+GVhzv1aYY786MTGBo5fLr39tD0CmV6GMW/CmtQuWBMU9X9GW/7UP+De4/9IH5sExz6zotIATlAbSFv86AyHYw4HQ1dmOdnzjjM8FOpJzqH+uoi5CtBk4GyDPQYtbxFiMDJLcI7Ew8/idQE0AHP+m4XBDhyqmGqYVXYCXC36A8wwwjzo5GEubewCMgOBu6SVAYDX92VIrBCq9Ts4jdwUlQ9HR5u5Nzjw3eRRGv6XrZTHmpoRFn85yM7Bg0VJFCwc55osEKgQo7GUVql3bBjvOWvexQ+qHlByFUVlaAcwZQtKt8S7xvCYBGTpvCfBgw5oDbYYAuACAgBnpvJ+o4Hgb1T71dbIEqSO8cQLQXh+PLBIyESAttS9sxl6LAPECTNz/vPYBRkJhiwg50if4KFlS6STHZCJhaUM/5WBjJvCcx8aaB4CeS+dPHvMLKPp5igM1FhQnOQKreB6BEp/smJQDqba6ThXAOcZdfRIy7XLpbU2rUgI56hK+qNAIca5YmR28xVmQbk8ozwGUqhq3iVCVkXcNXPCxw6rPPsSvdKgkleX0S48hLCIcBHmsDyvnxhveLqvUFObBEqJr2EQvLN/Ldt8Db4HFaY1VwcGqv4scc/KCXSlSY4gxASTn5xg6jT3BZC5Z2MAB0FB/bowEU3MMowaL8UKKTZ6ZX+zkiAsf7eG8zEVqeMUuXyblxC3uzNqqcY0TGKltBFn4p8Q6BNtUsMIuLUuu5I3z1OXIo6WgDAJQ9jbHT+Pq81FRZPg8Si8Vn5CrEFlZaKn8UgjYLgF86saSy6TUcc5RSaRixHqhHVQypLS6IuAusCH/Oinw9ZBNJiVtAe0lnU7gHR9e6D9r55B+fsMtt1l9dZ0VFleCRlBic+CW93e0iW4gSQkZ4pMWZuB4iVDDXMvmkJgIUcPFO+ffEt8QvWyMF+c5e47P9r5kv1Bf5ec0APiclaTH91Pggz95rNMeO9yGKBmwZMKowdFxfwL+9PW1DEoE+d0jw0iEBBBcDKWNiYY62gDMQbMhp7gCGSwp0tOIr813cUWVbb35zXb8cURmgRWd/cA5SgUsUepSltgl8NgXQO0oQyr7C+fOyXLu1C0H7moL6kFAyXCJVCS4/hPkce2cY4xyGRrgsCpnWV87166FU/z6FlsPC/+2bVfYxz75F3ZkqQa8R1iTcULkzpi+pvs+hw5bnLCCSYRThPPkFTuvtfv/w4cF2OmLoUM1roNcS+i0i/v/5Hd+DZFZPNQjX8VQbN7+9nttoL/PqgHSc2BIeDkbFup5rLU0IKBuq4vxcwBhNMcQs7w0z2687S6rblhrLyBDafuRAzaCk61CJAQrQPZQhiocwJp/893vAJ3lDvv7r/2dXb1rl+0Fp3wIxqizcKK9AWs/cwYMgLr25a/8ne3/5sMxfpwFiHHeuFZJk4YHscfoNBknH7DW6wQb40pr+MXAnP3Nvxua1toIEgqN9fb7aQSip+RXIfQn5zBOTuqQfXYGe+1ozUZbZEbm2CtplKBMZIFOM/nEQ1aMsJRUbOaxB3HMyM/fsfUKW4dxefKZFzTH7r77bjty+rgd7kK40I3wQzwHP6q+8xr/SmSbnQadama51paLGnzRin1dYzdyDImhPMIOXQB+5MH3fWnbzu3/5Zd+6WfPZQbm8i//oh6AjIBzZ2/GmzFU6QTyBOTjeza2/KXPMScwRxxzB88ECdoxAp8IQTjFRPCNs8N3ef7f7eD8S/YlB3Gy8HiUaw9E5puhik9oJ0RHFBGVHNFPtOl6WXykjqC5gWCBcPBKyiCidGDiF2BBU5xfxSH2umvlZYEqZ6UZOnwMC6hsIQmQZ8A2Sw7+oFCUDrG1gDs0X+kPGZW1iUSb0rb5ujYGcqGCEsd94i3i9wlYXwppvUBK7WU5toX1y83zjm+xUQ0iTnXX8cPq8wS6q1ZvtNadV7IFAs0+UrQG+6YmqyGtg1R40F9Mpc19muGv6DjotBNmS/UFL234aiettLI6x8u1JQfnfjyiungc+5CEtG6yFgJTDqwcm7oyI+YAreW8RqCLlmyOk0NkgSZGwtAm6IB0EVFZ8hgtAr9TEWNc6AJwNHnKwjFn5lLJnDjPXqYrGAkTh5wSqAewk39DRoZTG71NSaxT9A/5IHA8vMUrChA3dFhl47Alwj26pKnfNOwZ6O+WOSkAbLPLeYpq4KOXLMOw5sqyTdHzo2HJPqyP7QeegcWVkS0AABHbvfmau6WQZiHE4QycDOfGkRocwPy2d91rdbVrrKYOwLynTdF/pGKzXznW7CPMIyZrYWQUtoz5ucoQaUNOwNJaPHQlHS4JzOmo6Vlw1cWSVb1Jp2C/ACxRweTmnJxcaT3PhwLBUzEpajGfqWSz+3idwLVOuoiAXKacZqHZpX/uBO6f61lxn685AeApn6iX5lbMSR9jWFlhfc7L89OZRLOLIxqnKnCOXDS3Msoo+1nW2KScpTXKre4uL6ib+onKDGpEy21EVlpg6ML5UTv7/GMAfLtsubYFTpJrZLHkiUU/IlwwQoYrTHHKxJGaR3IYlElL9iwsldNZcCiE5VzzRXMv5leAFYJHJiFiuFWKKi3pBOeis7AXMxM5M6FtHNbURw+22XzDdjuw/yVEMKHTnSeeor8LLfqM0jI2NIiDA2TjRXlNSHZz/nwH6sT073AIBJ+adBL2EeOec5y23XmfnX32KWvvAxddm0C8NX4+L2Qt5xixfzllESllEQoAwzNKTrRoYNxxmkOLeSYqC75jCFjyy2ehHLDPZWigZZsndXiXgxPdgtjf9cgGuh1W16996zu2fxb4gsAcQI/z6HXAnCc+OOHIHwGeQyjI1i077Yd//OdVljK+ps1DVBqqMMv2xb/8hJ2EM37imPMk6cEH7ree3i5Er4HyBdDbVdQMB1AmjoOShQatmb9glQvoEyTgYbnF9S2WW1oDHvqSjR4/YOOIvJULPnoJEg0VgQ4zBDrQ1u177Oq9N9vTzz9q69c12dXbdyMiVb6dR9jJKzftsFV1FdaFqCZffviL9sxXvhjKA9dBcLph+c6DnHXjhINjxQysMzBsUM7pu8CT2gy1Ukdk/qpATPh58MkH4aTKtSUHdKV8KPgc23wA/XKcxHVDoR/JgbLDkLXa/NMY43c4FeccfdyK0WbORVLb5jDOVPyawDPffMVGexGnA9TT33LvW+zlg6/aqSGMzQaE1+44aFndp9UOJiZiNJnRMcyrkibtv68T5PGzljcHznysp7fd9Ga7456bFxpXr/qrrx4//hsP/fZvw8v28utf2gOQDbLtbsZ7Dd7MGPoY9nNaeL7nXj8gFnPnmAs3BUoJ7Ka/6YnNhUb8Xc3KQJAJtHJN5QabATncPp3HGZBlZWAFhlPCIX7sZSZgw21Ydj5t6gRqzlXMBVjwBCmwmGPTzwfnmNq9Nm4tMqE8xI60QmlJj3ZrKp+ntshC5qCOdArnEjvA9bJYfz/OT/f5nugAO1FBLj6G1Z6kDYjPdC0kWQp53zzaQisRk8rkgV4i65J20jiuTlVFPfvhONYJhyrxsAkUcX/F6lZbj1i4HpPaqSzeg8naT6Mdo1OAz4r3OKKycLPJQwSDrAwwT86ysTDLAsiXA4WkfIVqIuCb2eMFyomuCCCjhQJH6YQlgC6/d3Tuwx80lrTICogJg+HLoCqJZsF7eGyN7wqZYChrzoE5FuJ88BOpXLA9AlUCYw6S9BCBHFcR+bfHfg/p47hLtklFyHSyg/bApLog5DVdIknQmLMP0CNSPLgJ+k/JTlJOgqbi3ejgXJZUgUCWhHvEf5AE4lERt50yt0xwi42M40wqB2lOKIeAeWEWcZmZBh79QOssQn8gAhyt3rnYdAcR777b9raW2vpb70FWQGRYrF1tAz1nQa1FAhXVgw5yeqgoJ6QfpLjmNFqXVwLASBlQKi9RBbLggKWEQLEvSuZ9cVB/J9BHvy8mfSJlwRUS2GwBuPLJYddJCJse81hWax8UBz/sQwfYyqKpfkizhoDL15kcJThLI0lZSz4GCbD6GKYxk3jKygqnZ0bGCDlN1mMxXpy87nPbUa+vemwigAj71gOmcuxCuaI1OsaTa4croryBckEePOeT+8S4pXvBug98F15VFdayY7dVVK+GogAKG/qrv/0EDh+gnOOdMRSgYkuLdMxEqEWcBs4glN4sIlS0dw8pyoXkSawizhlSPtBfBKbsI64nnOdoVw6TSVGJEWj1eqbTQO9FOKwCZH1z/2l7/iSi/UhBASiSoQPgnHzpvm4ofRP6vGVTi7WdQSZZ8I1pMCD1aQHAnO2YB3hnvzXvud5GEU7w5FkAwpXVIk00n0RpouAGrmn0TVoEhWEZFusMMKcFHHUQMOeJmYwaHi6RsjtD51gBc8aOj9MDgmlcv6oB6e0baq1x7SrbD5rMAQLzaYB+WP6ZZM2BeSwKpPWBC1EweNqQ1MaaW7fa+37yF6QsMkRliITq5XK8ZI9/9xF78uv/4O3QNMiyt957D8ZmGrHgkWMB9R0EcP0OQgpSUS0fgyV9cdoqQeMYbjslZaZy4x7LQ/ZmZgIePvw8cjTAQRvFlVY3WPmqRvgX9IHrX2Ybr9yLmO/nrIgJiLbtsKamJjuAyCyNoDJu27AOVJE5+4dvPGxf/+yfqV1LkFnWuR5x5qvhZNuPZD5jOL0oQYjDC1CyRMFEm5ltOp1IrSQMw6kZlHNmdu08cUr0JoZTXCiplAN+CSZXKU5FJuDE3LFYQeHWmp3hnHJssUblHHvCikj1wj9Fa2HUFvR7LazvW7dtsdeQlXURpzV33PFme+XgfmufhFGK4RK7wUZpPy75ppJfiygxfd046S1F0kqGxs1oSXgOEkPlTLaLysU6rG9qtR//8ffjxKLaDg0Nz/7Tywc/jeH6rTNf+euVo40VKbz82/9iD2C92I1Lt+PNRfBxyEzf/+Kt/8cuu/Qt5orKQou5Uxu44GlD1TbjC1nGOUcbmH+vY98EPvWpb9wZ5vNFG7nGl86F3Mi0PjqESou1WxL9T49q4TstrfF0TKK1LQ+WBQIVxbUmj5VhwWh1Eyh3gJY2X9WZTcEuLSqKLL9ufWPBwhcOtdQ+2cQC2DkwJ9CIRTyJmjYX5zRHVWMzXwFnYUf0hVuV4LrJ//kmymyLc+ALMpIFuZZKWiIrrNMZ+MrFT0A0cDaPWi84hypLAAZOTrSYb9+ZsZRnACmRiY4lGN7LLSU8SWDoMFqb87GRMcSeJ7xhW51rriQajrP1GaGZZ1/1PUz9BAsgnTgFJzPycZGKlkB49KMswVJ6+CPsl7KK+oYs8MdxptU1eLakaTjRgVQWUlpgdQWIycbv05NoA64tADAnT95DyrG5Ts2JWnof85kaJ1aXiZkAVDIKhF/qVKW4K+rpAxnWPW0RQeeSkpXKYwNxbyTQ0akFjgOUpVTgkYWHWhv9R/lTNBSKDfseGgfb4tQNVIxNgTayNI8EP7iWXNDlpTkrrFwtxY9AfhFAl5xggoslHBnPI6nQUGe35DoXMjQ/2WdbN62zLeDZNtVXKwlVP/wTxhmFQ3OA/e3AiErbLKKVkHotiyPmcDUiMvCEgtG+Kb9Kyw5AMAeQSEdNKU7Jp4YAACAASURBVEKSQcqyK0Qpsy6P+QnQFL4aD6JCuIA6FiJkILO5Jiu2elS8JQc0jEWvOPpSjPihh3WLofGuxGNpBZZiGBZxWco4PkoWtDL0AlJaMthg911gdBGCJVeMo/4q163xacHRPFcBHomGlnBSfJL/gZ8OaWHCcNEQwLY4z1z6lpKHAfREmWx3SjBEx+uR869ZP0Iqtt74ZqssrYJeBasg3gNIRjSPPsmTAso6uJxRYZuDElZQVmkzUKyXkLDofO8QGBlweow1jte60uQRYghWabGnzwBpX65AeOZIOcZy/FFPqRrsJ3YTWjUwPmWPHDpvB9vAcwedohzJcpi+vf/sCYEqyvba9esQbm8CykSnIq2QwiHuPu5n9tJ8WLirAZCKAKgPHoKjIYWaz1Nz0tyJtTTmEuvGSDNLSKKmON8XfU6/G0ZlSRbzRGXhycQMqDNsKyOMJAdknhIw/GQ1aBANtXVWB2B6/MwZO5mDYBME5qS/iGrl67A6hhSn4nzLBzBfxqnBWmTl/ODP/ueIJe8nED7qfuJJOT586FX7ewBh8bJjrbjmqqvhBLpKsl4K3vzATJ49PQZZvjAIPjUUDIShLEUiuXFYwhcLyq103WZEyaFcL9jImcM4hRjW6VV1QyMSRq3CaTAyw9IZ9fb7EFe8386Di30LTiN2bdtprx47hjErtD3gnXMQv/LIV+yxL/6l1gZGlqEcFwJcr9+4AVF4zovnXY8Mpd3t7VDkZ2XEykG/cv2TUsmTRzlMM1xmvlXVVyEyyyl3MMaYzsE/YgmGkHIMJx3Ey5o32qFhap3k/se4xj4Nrc3yjj8N35L/GZhXIurL5k0b7TTqND05Y9dcfa0dh3z1LGI9b4bPYf8ps/NHtM4ScNMRtacd2VyLAczhMJtRpiTDiG4zclxUPO4dpaBe/fL/9wtWUYvsolASv/T084zgM1XYvPZPqtbt/L0n/t8Pfk9ae32D+t5+QUZaUMObopZPQr6gxX/vvH4gLOaFQWXRHqkFzI9vZWjTQu4bu29mAagZahBgzsGXL8KCYZnrY0PTFuC7qFufL1qwWRZxovZTbsDJXu9P4gLA7URggRxp3MxkCVw88pEAg9q9J8rxjdR3tgDouEZAU4CXb6cORMl+HeustTpZxQN4xwIeJcamKZSgvkmZHjPP0/Vpqw/hjQ1QaSu5kJM/igV8fmQQ+wLqzgRDjNRA0EEQxkgqtCqqvoh1e/aIdQOYC8hEn9es3mxNO7erFf6mlZFAxWkF3HNoXSoA8FlE3zgwx98Kl0grLMEqQSHGVxwk3sM+YNuYjCWdGPgYpWyd+isB1NCDCE4UkUdWO3fU5T3+lxM1nAbhYPx1QCjt1xoXyJEyfzoBihQKJusroPMXIzGA45iFY2c60pG7SasWN5MlnLp5yMpUtve7D4UrAg7VXOlKlkmCMEZOWVEc3Mbufekyr0+STKQ+IYecZTsh2SNPAFBnwzrMzzSGGD/GXCd/x5VANptAgJu9RwXy4HaJloB2U9mEc5h+TowgrXut5ZfAGRCV4YafQ2c6RbhwK9QcojwwoyvD1RXXN1re0jj4tasQ/7jerl2HtO8ViOfcfS5DZdHeyY0YP+epGKJzCWpJDcuF1lIFILNAqyWtYBwN0cZgMWPUFlldvX8dIMeaQHCOv6k0M3mVkprEqQCtvgUC5h5lRs6JvJY8ZgJr6UV8NvsjrRyh6GmonM7GvmK4QxcelsMxdyupFNlYazSemppBgwlNjHG2C4qgzJMzzn+su8bVqTGKE67n8zuPlUIDgp6vGI5so4MYfaVljzUngHd5kZ2BISthNHAHX3eapULDoll1jvbsRLft/87Ttuu++5GQpsaKGLUDoGKo55zWsyKAcEa2Yr1EEceNc0hEkwcr9sLcJJSxLOscmQIQdipHRpeIWeUKC8eUHGkALer68pH2aC6y4PP0JWh1yeiQfvbBEfHp9nF7rR0UFtR/ZqQPz3FlqaFxlegtJ147AhreKCzrxaAcICY2KnkBofhIfSgqr0IEl/V29OBhG4Xi584jmlTeGP7ig5R5y3gAQLcEmpYujXnGUzHFMQd9g9dzTaTfA+WHVBauSaSNUH55ksY1lFklS0GxqYBltwJJkXoR27yjZB1A+f8AzH1GQivA2lJcYHlDZy1rdAAAdp19+Bd+U/1Eeff5z87lPHc6S1dnu33uT/474r1PZ4D5WkQvufW2N4F6cUEhEwfQjydGQfmYoUygHbAA56G/pqGQzcIgUz4+BCfKRssGLW/o3BHQ0IbRtwWgB1VZTkUt5n6xjfact11770AisFE788ozdtNd99hu0FnGoKxRxFevWmNtyHbKUJxPf+MhZfKdR+hNVpeK6OrGRhsDFWoCJxyMrz6GcJWkOJaD1z8B/yZGtuGIUKGm8qrTVQDxGpw2nD9+CicY7ig6jz1jHmNbjHWgFP3VtGevvXge1ndkmvU5mTY4/JwYtPyTLwCYO3mVc04JoTBuBOZr1zVaD7K+jmPN2ookS+cQvnO4oB7ZjbaBzXzO7Oxrwh1cH6pgMR8bGLG5ghaME0ONxjqqZWDWskeOYH65jHEu/PRP/BQ47GuQlKjI/vbJ5xC/f8YKEXO9pGnzaF1l3R+Nzmb/0RM/8yBC81x+/e/2AOYkif63aRkzew7rxfn/3TL+ra6/9IE5LOYIpfRRWcYo72E590XbrYe+6fFPfsbNyjV0AaA0SWMt02JKgC2UL3ive3R75v9Bn+Amo1kuPT6+9U90/Ip7OQfJVytgSmH8TmpDHixsuVjQPA4vN3seja+UnizncRj9+udyn8W1DM3ntte0g7jCQcDp2QP58s1eltCLAL4DP1ck/ELfGPVH0lui5JStTmAVC9U0N1yk8c5RSC1Y4Aj4UlkBIhkdpeMMLG3nz2Uc81h+1ZqN1rR9R6bGgsLoFD+eZC2wIGLzVbpzbDKziD9MP+sCKQEED849V8vjFIGFKSIInVO90dHW4PzyOo27bln5qfF2ZYxWVA+b6RcpYorEKRQN3ifgQourf64x1z7NEhiJhZ+5o948w3ahj2g9nKfFnFQWAXNyQ2kN9PjUAt6iE/gwJKtpRsHk+NFRVGPnlfca+yCl+PDeqhg/1TX5G0R7AmT5Ja58LsExFfmyFSllgeEhGa2AwIj9GwBSpwAERlSu4tSAXSmqFgFqnK7zlGNhmgmB0DzEKSYdJIsWZ9Eb+BOAMZwnCULGh/uwGc9ZWU0zFJVx29C6xprXVCDz5yqrg3NZL/wTJnGyJGWEZXATw1+LKGcGG7MiT6AOuRC0moYaOfolAEVgTlDGl5J3xQmRd3A4Q2vuE8SD+w/ZYl9SceCHTFAjqoE4/d6nHr7SlTSOl3ArQtk5SKdC5tZ6vagQ8Qf6hpbrRCPzk45QuEL5XnFQ98/pR+BTgZEh5hWjXe3X5xR0fhcWfz2KpVKeWHf2E5VjOE/TeVEOxrwXtRGn3k8/pAgHwBQNh0CcKdHJx4+/ddSu8n1NpQPH8sKknX3hUStq2GZbkIuAMbbJL54AZWV0cEAUEikLagfnD+YCnELBhBb1YW5qxobncgA6h1SXLCgPHiqWz3GlUlFNKGuoZwGVfvgeuIOkr3kEaD7fLlqJpai7ktE3uWD/+OJRO3yuV6duVJ4qaips3cZmO/TcPhvuG7Qa0CXmoEjyhinE5+ZcLSb4amm1ob4BOzvE8IQ8puJbE9wt1nzxZ7K2UhFBJJJsJFLLfI9LBMzRn4y1z3svzvw5B047542yJrPdMU9ZB4LLAiiJjHE+jHVvrBFR4KYxRwHUVizmvAlvxu6HYScHYQuzQQWrrVtlP/OffkvO5a/LKUFZYnQhyPYIKCGf+djvYu4xLrjLdRESSD34wDttBJG2kAsECT4nrX2u0DqHMZdx4pcPK/oiaCqMKjV79EXLh9Fh1ZbdVrRmvXV2t9lC50krBzWIbSlejYhbV2y2468h2zNCBW4EZfG5bz1s11x3I+LCNyPeeAWaMg3lA9lTX3jS+s6ehB8Awl6K1oE1Hs/fu3er7dpxhWrHuT40NGJ/9akvwRl0BDx2KE9N9bZ910bkXJpG+MVpBKyZQSjHKVjqAWYBvs+fOIfQrENYa0FXQrjGWY7F/8/emwf4fZb1os/s+z5ZJkmz723TlW6UllIWKQUKeOAiIoh6PVzPUY/I8VzXc0BFlCtWBRVFRDiILNaytKW0tJC2adqmS5pmzySTySSZyUxm37f7Wd73NxP0/HMvIqfwS6fzm9/y/b77+3k+7+d5HpAPtRj/G668LvaeGYqxEshZ8lzVpoNGggSn/OiTkB/6JIWRtTgv6DNRj7CNtYj2QwNiAtF+Nm/ZFkeOIYJP/RrEnAT739+JkIlPa43gpapg4MzAOJgsgcy5spmdnNqbTY51YugIyAgYaFxTMMbueMOb4oqrLosqGGRf3v1U9CCBX8Wypqhauylam9pAUMz3nj114sMzs91/dvTP/uwH1plxoZI/WM+wXjA8zq34gTUbu7DGtf8glPBFL2W56uYfQ+bPijtzchQe0XLh5qaRATLnoTajtFlZqmDJgrdBPvXfBGla9jPDqvfSa3rdzom+piFSAdQmkEggqHunhZz6V2oPeaw5iePTMnru0wFIWk7uZIuAub7r66dtGL/N56aXvEnrkZCR6dUCa8PnmenNZTMu4V9pWzM1qw3d65Pfu+CRGB8ZOwQ1lBIMEJgjogyODxUqEnWQnpsMEq+jLIoA5oefjt4ObByGM2rq1lVb4iLEtmV9BYTwOh02jXYNg+QoK7oMjj84UqVemQ5B3PAUrUUAxaHYCERcV7cV8YB6P9eHG3mqkE4VcuXY5Gy61Cb59vq0jvzxjhqcoF4fSgAlEasqKC/iz8iRjncWq0c5C4AuohwQnE4CmBMoUo5DBzUdQ+fQebkvUvULhiKvmd5z6MRkXGSApvJlQyGJqnITFsaGx6ZaJHetGsB1mQczPI1QaYO9PVHX1AJDsRoOqzAe1LbpxImfI5tJ4J4AkYcaWU+YIykEHmO4e3+llAVlBaikDltzDn9Tfy7NJuUI0JcOnutR5sWqhqUAB/Oxac2SaFvZiARDy6IVkVm6TwGYg4mVkZzGhDdManWdlIUbOjXJLcuaof2c0GscG9zQOVZoEMhJtBDlw13Ixsj/SJTzuF4nUxyjuB7DtVUAsLDveE/Z+/iiGfPEVMuQNtDNTKmnk7jsBMZ5tO1xKudnTzO8a6MyZ+Z0H2UCwP3FLmL7VMJ4t4GfiQKO/dz+fiojnsw4gbAKamkI1zpL7lxmG/6sTFpJdBs6f05jbYLsKuEHa8/5/Uw6sP7pRGBmOHrbD0T/MFLUv+xW6KghMUNkmjEwxyOIZc7Y4l53XWfecgaRd9gnZJEnhgZjcKY0unoRxo6nPgTnzrpkpjfhJOrdOWbZfmTQGU5SUqNkjBeGuFrLK7Cz4Pp7J84Nxt1PHgJLP44MktA5X3MZHB8PRPv+g2B8L4pBRCchEJ2EtIXyhBoAr9aVqxX+cG8n5BiFhSJ1DQc3xq2OwuhUygdPQOkPA3+IIp7YpAfHHg2dGvjF8KHILPiZxJxgVBb2F9czhmXMfascFzSK2UYM9Uhjdhtyp2QpiybsokJhrpIxLx48HSU9HdEEHfR//vU/kMZZxlper1wCGXbjmOuf/PMPRzci63jh4vgsjTve+HoA5hGcJCDjKyRh7QNICnZ+FHYXiKOV62MKdantRoKnrqMC/Uu2XxfNO26EPOlkzB/YBWkLyAe0Wx3A+o6rr40OMOlDAJebtu6I5wDSVyHiy5oNm2D8QGaEOkyj3/uRmOiZbz+gUzuTMnMAtHXxxjfeFFfuYEhqSzjbT5yMv7rzbxCH/jyCJdRAS16NfquI177uVumyWZ6ly5aovadBBtz1xa/FA1++z0mucKIzifCGRRh/FZDXrYAO/1x5XfROMS/N4gfadeBsVLTvATB3+/HUk6fcZORFVnDNxr1amlvimquvir5hhPA8iWRWIBYQCgYB+p6QMcfxTiafrTtZCka9ClH8FgNzbiqMPz/Rk9aEWVzv+rjllTejHkvjnn37ov3MuShrqonKdRti2ZK1MTgwA2OjM8rPHT990brtv3f3PYf/OvZ84n+rLJff1eDf9z8xzxix5VX4Yec/hT5mSMV/18eLnjEXMK+suHMGC08ZFqxJLJxzsKKrsFhxggoka3PjAu7FzcsSFwQyPJYwcN2zpCF9prD6myX1y+m4WX8k8MxNg2wgcRpelo5SQNR6af6mRz4ZZh5vM4taOcqlzJlc8FmGHKqOTDfBvn67oBmsZWCuYiXg6aN2rmvcmFi+XEeDMYEF4bACatOLWXebQUAeodJM61g5sX6y6s26sV7UbU5CXlLGGN3UUDM0l8SyuFKKe51CLUfnQTBUJzuNXdNRdRuch5auW5PqZPc01VEslMG7kr2AueD9xqFRJcNMTbsYc4UaTMYTrklpQGoMRxoRm2kEpP5IN0h2S+pE1y+PBRVBtycwY1lcXmWvFFIo3MJlpRRIHWCWj31gn0hs0gTmDOHGGNTK/AldKcNjkiXD0WoRJQMUHovvVcvkpjfeosGSNcXqzjQO0ictWMhGm79qwj33b27QVOZ0fY8BG6wE+dwgZ2cQIqz/HGKIn4L0pBEazTbJEQhW2RwcrYDZYvt1omAU6HIa4eqa7MUytAk54wrqdykNAbiX/JPvs2/pGEpQDf32OMLpDff0AAxMRT0YofKaIqTuboq2i1oQsaEVjPmK6Oo8pgQxBuaJ9cUdCVhmAB6kDYchSGDeCnZpFs6l1qE7RCkBnWQ0ik7iCC6FU7PC32T+CRjNmLupUGeAjOoaZAjE99luef5R9pKdPTk2c/4Bz1M1cGoTAw0x1HJ2zKCYhj+BPD/OC3PtSaceurlP9Ty2sLEDNFalbIfuX4LTPCZsMLCF6YOhZ5wPnAOUptDgT0yyr8n1AdfgYNFt+D+OQYBGfF7zS0aGLlVYH2zM8kXqlHmSAkke5vvgqYNx/PDxuOyVb0RynGaBzNGxYY11zVfKo1Rmr0/s/2lEDymDoTE5eD7GkLSvoxtsOuYJ6yQ7gGFqkzxNEg+1E7XnZM6pq08QXJ91m5N1lMnA5tS6a0dSTmIaJwdP9cJJ9ESsBNg7+NyBON2ObJkoG8tSAWKBY2ZoZAwa5IpoXbs5irCHPNsBfTDHbDZgWL4l9ar3VC8cSplAiffH+qe27UFWW5wi6jnLgHowq2QN5z8eXD+5JhCYM3IIw8EqT4OXKX2nsrpa86UVEYm6Tp6wkbmdwJxRWRheb/F6heeQ4uCoB1IaaLy7DkVNTX2873f+SBIOSQdloOQx7xMXgsz/+bcfi8N7Ed4vmexst1fccgsIeDiSorx0Qt1/ajA6hkE0UCvftg7AFie8kHqMwNG1rBbrxI6bo3rFeviA9MX0gceQ5Ghcda1ZvjKWrtqI+o7Gmc6T8q+pgME/dPJorL/kUmRqbYg5MMmUDTXgVOC+u/9Byercbpb+/ex/fCuM9HWSVjHE4wlEWfn4Rz+BZHUAsiA3auopaURGmasujoP7jsYK6OPf/LY7tJ+y7x+4/+G4+++/jGGOeQFd+SROKedhtFeBhKivb47SdduifdB7yEKbouHPd0XliWflCK7EgnTghyHGWPjct23sFENrviXe8qY3gLXfFr/4V/8Qp4ZwLbRNwEDh5ONlleeAp73FiABDOZI35vTAvSZBbI2SsOLYmMM1t8br33AbnN5boYHvRYz0QzipQPIshNBsa1oRq2EMrF9WG/0IOTs6WR67Htl5Ympq6n88GxOfiS9+MR3lLLrFj57+qy2AecgJSXAOLdO/Pzj/IWDMb3sXNrA7p6FdnUV4qSnouMju1SKEE52aCDYMSrQEcDqk/4vj1OKeX9MeIsCVPq3FjQiDIbnAoGmC5gWPzxP7tejqeRoKUsjxhiwhWCkwKGRSpxAusRQMVTk0iF7ICc61sxjAFhYNvmwIKaCZim9iK2+YfN8h9y6Y/2mzyrpq4YYCOk3soNg0LuJpg+BlpdpxGxVAPeuQwCqP9sYAzCvBlNEZRxpaoxdvBJllw8bSefBpxLnFMV8qN8uyatvVsQQhtBYtU4mYtvOkLkRmknp1/DUJhk3ObmCbpWdHP8wJYFhLOYvQJayDo7ygkCq7e9nuiQkIJcRhYGpmjlFPXNXUxgkQiX0U5W7WmKnLHfpuAQRTomKHPjdaEaON8NoERozCwwRSZGKpuwZjLtYPuuWiEjCg8gj0CYz713XI/acTdDVphtJpALio0g2r7Knc/F4+dVDtdWEjrIUTktS26if2J65NvTc2LYarK2Wbo3yOL+9MpEyoMzcPJhoEYREcNkGDO6oKS8bEQArjRwkPGWwmmgHzWIWNG2m7i8FWaVjgOgK0vCY26mkwi2MjAwhO0B3DCANX3bQMDl8RV21eEXWIN70C4eKawJifRTzkUXxOBpKMQ8fY4fgjmONvxtIvR12WLm9EPRC6jhIWGhaoG5nAGWzGZTDm8tjMrWhQ7ARJ3PwrofeVaa42h94X6wiTmygMHvuFgFWSHE4CGypio9Gn2Rk4h89U0iS1Oz9KI5f5OC3FYDmyI2d2btQcI/uuCZqmCnVg3L8hz6HGlt/hlwX1GfyYwEvGmceoVbH8iNcB1p8HM5nvtlTMTpRCwVoH7BDIPymjYEIlXkYO1bqszArdwysMzS70N1lBgX4qLHrj2Qcejktf+YZYsWIN/h5F3yKSDhIc0bguBzBKg9HtiPKNQ8JUBSA/NYQ442X1AM7nIWfwaZwYc51EeJ5ZFuN5Ucb3qT0XCZAd21mvXHfdQaCtECs+4S+22Rn4Tz546Gzs3Pm0dN51jTzdZiwe6KlxglmBG67YcjEygI7GC6fOwY+BfV+wUjyfNLnxQ9kUgTvD7rEPGLKx+2TuBY09Mri1MFLz2GXad8oZKU9i1BrPflVSXVcNtpifWbJ0WQLmKNlW+K0hCkjAUPR8TuXhmotr0wOaIUdLO/ZCxlEZv/rfPwLDGOtkards6Gnck7XHHPzG1++KR+692+MlPa688opYvhz6cADjSshj9kGH3TGK1sR6WwN5Eu2cCrDiA6fao3rZmqhfuTZacepAY2vs7DH8Qp4GlK1uSRuMnupYDqlQL5y3z53tjhUbL4893/pKXHLl1YhzXoG+no02ONpWYz0/0b4vnnnkYdWLMio6n77p7bfF5Vs26QSHBvbREx3xNx/7FJLVIUgJ2qC+uVFhei+/5lLovYcQvak3XvaKW2ITnMfpLPrYI7vjq3//Ja0VMsCQ1I1GUfX0GEA3HES3XQENPWVuybpL63f0d0XF8efQBvABQvuJAGB/oa9JoHn84rQAzrnXXXNtXHblZfHZZw/DiAF5AOOoCAYK/YyED3h3gvtSAPNa7HWLGXN29zT2/6FjkgdxXVsKGdLb3/429H1rnMM97/rOLvh0wBcCp3aXX3ZNbNy2Lfqh1z+y/wWsr/XSoA+c7oJD7plDGy7Z8dv3fOyjX1wYHBd07Y/++K4WwHzEpBU4b8QPs4Qe+/dqpB8KxryyourO86c7sVZB2weNF2NIK+61Fj5s1kKWXuwXUqzbiVDBDQkcEpSzpjctgqnXCO4N4tKxtJ560/IRsZGzjoHpgJOANFk7QQrcnuwd/5qEow01hpVk0JOUxWxWgtzajBzXWtfzEp4eNBBYo6RrFcuVjgP5OYJjbqz6zToITgrkeYHwJu/Yvzp0179FN1BdsmHCmyrkF6+CZuEmyjTcVVj0iplyPkWnUOMklkuZTvFn5/6n4jzCXvmswjVYsfXqaEUqaLdYfh2ca6qnnNvIODNSAdcwhjhDGzFTHkNPidXT5rwYzJDZJlsIlkyvU9LAqvoO7guHk0w7fuo7NZhKIizENjNETht+imwixOYQbtbSU2eK9rPAHNenfjoxu9q77RBJFlIJb7BwE6BRt0wd91wx1gZ3dbq9jYWFRx57CbznPVkg3iVURA1BpcSAp/blezRQVLR0SpFD/FnKReBDgxFlZvQYaG0rEd6MJ0siCWXgefCyviYOCcZ0LqDEWDQKuLWV4cksXp8lgEfYtCE4R1ELWw7gVY0YwhCv4zLsE04vzAI5VE0B+PZH77Ej0CqvjnFoaUtLpuIVN+xAuLWlsX0ZnD9b18WZE0eQbZCZPz002besBwETq0FNeRkM2wq8trStHhsoNlGUg8YbjQSOk+xwneUmGSRKgkJHVtRzBtIEOpwZiLJDENsazG8N1hABcY60tLFyo/ZJk4FEIb09yiOjktf1hBFLr+yvGrOeejrdSQadupubOMccG1lji0CfL/uUAayYwr1pfkr24RFifX8CdniuGOhavXhN16minCPFg4yXl6xERj8L4jEix2NchlGE5JiudSHJ0vI6wtf4GZaB9+XaI6dXjhUnYOp89oGoXLojtkN3PoVTkH6wj4wDP4G5y7Eg+U8a4AQiM4hdXwzJ1Dz059PTxXGsbzLGQKgYnBswifHVOuR1x6c2OJHBbxq5DkWZ5k+aFxk8FcN5VhKmtKRKSoR/ZTBA98IQ+NTd34khZCelAVEKOcsAwPgswPJKMJcl6LODCO84jvF0wSMt8QJfWfNNYM7yglktOomIIzxqYn8QmOOnBiy8lyH3CR1A+ZuMeX7I8MA1KGvkGngBY771hgVg7s1FfYTGBTAH+Ye2KK0HuQPtdwU6+VfAmFfXNbivk0Gj4SjDlj+zsfe5PfH5T/ypV4u0x21GlJQNG9ZIE085y5FTfXEQchY62zNLahUckCvKoMfvBcmC+je1XRS1GzbDubI4zh85EMthxNbXVAI0twB8V8a2jVsRGx1RVWAsH2vvi8PP7471Gzcpvj1XsDYk+6F9s3b9RfGXf/x7iJlPKRXWeBBXP/Ped8YahIssR6QfAvO9+/fHVyFP6US4S57sNEK+UoGEYtffeDV8/qlpYwAAIABJREFUTShDGkYf1scmxD/vxinc0QNH46lvPS4/kRIY3IjxCTUQ5gP8VTAlYunWy+LQOAwm+IfokQyeot6TUd75goA5xyENf853+gRwHWc/8/UaEA5r166NDZs2x96p0jhwGsB8HOTR/kdlqOh0TsQGZkZZc8zXrfPk52D0xow2RGSeocMwZriWzSkk5Hve/bNIhFUPB9Ca+PjnvxwjWEvnYOg2Lr0oGtZsgX2Gup7ByU/b6mhEvPtOtMv09Ag06C3R3d/z7FRZyW91Pfjg1y4ctD/6619rgQTOfwzvUd6yE/2a2MPvb3u9+IH5dTe/q7q27k6H7fPupQUxsUM8Ls6uWQYn7gCmBRfppK3PLKEtaU5Y7ZAAFYzVbB2ptgKCcYE5b9D8mBmr9D7fyQBKiyE3UkbtAIuV4iVPgHEuL4Oel4w5J7zWW9/XDHoqIOcy4VdakB1TnWApMf45FrXuRwaM3zf4zpuys/wZvBcr3GMuqe9hfk84rACC+EfhCFv7gYFzOTaCCeokwRDRsChlTOMkFZgl5sW/dBKt+3Uc2BP9p8+g/En7iWus2n5ttKxqS3d1P+R2zRuFGE9KkLBJjsOxjFIDhY0j8CHwIvwGjhCeyZmfWEeddKQQg2zOdMgnELHoFITtrLZi5ArZKXgBFSBgzSVivwjQpJcUnaVw1G+DxgOFoAhAXPoPNpaT4EgDDcNlBnTz1DDDS+JYGGwSo7LQebWIrLn08WkcJfY7Rw/yiEpjQmXIyGBRr3G8pBKkzpTxIcmGADjvQXDID3Ic+UTBQBBjBgbEDByjxhGpgmnXCYDkAEojlAwq6ivgzzHM0HM6MaKimMwk54619dQoM9X3NDbJ2Rkk6uDYBtvD0ypZkWoqtBHmgLIfgmGbm0N/Ni0FSMOGOXYO2fVWxnIcSy8HY9iCjb/j6AFE8EC68TxSUGZHr2Cnkr12Ep1KJOBZgjBp3EgZRUHGhAwJhz2kM51PclgUz11FDoIMhtcm+LZMypsnp9gkpANk7yRJYvsmxtzMtUG5QZ9/a6lw16cH5yNWDgzAYhgnSlKqecS2QH8kyZfupwlpY15RidJnWc4pAL5yalt1Xfe/ncSTAa9xbbOba5ngMoeywiVapqL24MyUPtvl4v30LwEzyuwo61BdM7snsO/2shO81x6Wn74DLLvyECRd7XD3oeg/Nxc7bnkNCjAZfQBmZRjv0zD8SiEnKIK0w/YegSi+B6DktRZyNXzm9CDiYg+D1ubYY3U59mQE4DcdV1VROFBzjPIETUYGy+cmV1ZUPud6zLVIYN5kipl4Esxm4JkZ81HIIP5x54E4PzYVYwBxDGO4dMXKqAGTfvx0b5wfIStuMscXTvOdrzF8IcY7Gs1jnIYgmOMinu4RFMMY47pYA/bZfjA0XiFpQ3/yt09ivMbmRzkMMObaWIYoKZ3Hj1nORmAOIiSgOU8DyBWEMYENhA0RZQ0Y3y/silIYcb/0m38QjcjU6hODC6+vUzxcs/dcd3z0A/+Ng8RlwL8VqPcVV14KYIyMmahT98B47O0eV7QmGgyVAOblWK+mh8/BIRdVblsSe69eHUXw7ZgD6fDG0bpoHpyE8/ZFClW5fuWa2HvsAKKp9MWTO5+NEUhhKtBOLUtprBfBn2WpYs6/6hW3xm9/8L8iSdM5+SrVQp7z4Q//jvTdxXQqxjw8dOR4PIBkS51HmHBsBPHI65EsqDFuedWNcMLcoD461zsAww7ZZnFacxpGxcNf/xbIrxGsYQDUAOYTaNdSGNsVWKdWbb0kjs3WxdgM/XwKzR9FiLledupAwS9AMhYx5pBfMQtwGvMMgdsAJ9QViBzTU7cMshisR5OIuvXCo0o85dMvLpgQyZU2xnw9yih91qIH9oTiQQDzOea/4Qlcabz7ne/B+GtB2zTFJ+7+OogJZLhFu5RVwyF+8+Uxh74e7ToWKxArvg1Otc8+dG80IHY7Q3+OoV7DuOdo1+mnSsan/kv/yfZHLrzhj/767hZIshYsVsFjPSYhgqPA9/fxogfm191C589qZf5Usg1z1IWFx5u7OSXhMAEX65M537xhc8NyhjR+lZudwt+R6gYKLCbY4hULwNzLmpEuv58RnLY+bUIM6mRQ7QQT5YxjjqP/SSwgpVg0SrEImtlIG+0ixlxXZxnxO3FHqoOKlzZFMbupvNaapJ2Jx+ncILSfuC0cUpDl8gYnx0HddqHche0nL1jpBWU8xCfJYk2B8SRYroLGnFnYlEmQ16PWnNcX8+z7tu/bHUPd3d7b1BvzsfbSG6Jp+TL3kMqZIEcCCQKBZHy5wKGMowC1bCsycAI0jLYh9oybLeUWqW4CyM6+Wqp+Q5HcXO4MHxQU9leVkW1kUlRvaMykLnW4wPSWgF0yyGQUGdimi+M3U8+n13krjBUeS5dgY5vHUfMUEp0wbi2dP8lCyWBMGmAfi6TrF8Bdgf/MhdPvFOVQn7+gbCo5y+RxtPhhoy8f/Rv1SV9O0EKQQaCYwhjmtN/sAxlAZIwZVQZsojWWABlwSJxEMg5KRBQZCACFRm0JGC46SNE3QONMDsA8qYK2FmnMmQGV844OlONgmGob1gKsATyDVR3p74jNiJpx6Q2XRysiQCzHiUpXx1EllyLDTkZeZwdkwXF/KSoA0CklqS4HywhgTmdTxP+VcciQikxlz821ig63mi82XPXQFLDfyAyAkvSpMjDdrlMAQkxWIgCfGlqzWFIZz1cb0GkTTmMhjx/fwpZhMU5H8hzVCZtAsY1vS6aS0SqDyacCcrTEtVl+xsP26MzT2zIWOQMToBJ4a0xmltRsXyniMedxkr/rMIXsH4fDtAFHh9ops4KL6uS1RfBuMX5R+0jKI2PfK6tWIUz+qeGzMdQzGBt2XAfDvSQGuzqiCIBzgk6O+AwZU37BMxVPIS9g9IpyrIOjOLrvRwzt071Mv+41jvfKiYb8nKDekW5o12YHUc2WNPQVFYhMMg1pAHr5AjCqEP4mwKdRwfbjfOTjoeeOxme/vS9OdfUgBnpDrEIipeOHj8bpMbQRwbcLkxcw/00pC+aEQhZKO4MywRlwvuuE3lf4PkpZBMz9FTLlkwR7+K2AAHkopvFFYM56LGtbFSfbkcyHe9EWSFmQSEmZPwvrNG5GfbkqigACjVhjXng8SgFif+HXPghwB3CcxkqB5NHAtxFFlvnDv/U+kLwMj+3ea0Ls91tuvQllRVZUaN0HESpxz8mBmIZRSUKEWUp5AlMELXkxDO9z6xvj1C3bo3a8OMabSqJtaCJ+fBA+GaPTYMY3g2Uuig5Ilh79yj9H/1nsFcjKOYU9Y+X6DRpniKAmkuKya14an/7ER2KO4YPRL8xH8D8++GtiykfBVFfgs0cRe/7uf7oHkWQG4jyi+VSAzGpa2hK3vPYVkIDA6RN9urx1aTz2+GNxycVbEe3l2dgDKUhn+0lUDXMa2vtxrFUlYJ8rEQGmbcOWOAH/hrF5yoy9FmjpBDCvADCvTg67U8y3QNkRTkfkL6ExzzEIMgB91dSyJAaWrIteEAw4YoPG/JEopnMw90HOaYz52dL6mKtPSYYKmw/vh7VwGIbAVH9ax4vix151e1x97WWQ0NXF3U88Gc8+/RxkQqdk5C3Zdk1UYVwMHHo6qmEYXHLDTbH70W9ELcYOT67L6nDqgzVvGNlUZ9BGdS0t3xroOf1rY729TxUG2o+e/IsWwPpFR1CCc2qVHsB8gbPA9+/xQwDMb4PzZyUyf3ojIburTUZA1ouqNyEvksZfGSqyI/i5rMjkV330WQDiadVXyLL0Pc8zL+76hfd8/LqwhssZTTd0OmZ64hM0zODotAKLOrOTEWTmkGQ50kthw0+bomqSQEUqvpn6ApPvhddrzALDZVuBlU0baAamqZTeE9hW+kgBZ7pSxFVmF7PkhRscM+VNwHmLWT95AkCjRaHVBNxwocTGsr2P7t0Fx0KwISqFb3LRxddH8wp4qvsWvg/eyvHaxeT57F2Os9QZV6DduDgqEyCArY/y3dcKoyeMnPqz0EDuFzHeest1UROwKGl8qOW46acIK4VEMGmMJBjl77CavlLaJvECy8qRwljdakTHWibIKmXILizwjGPORCklYA4ZX5vSHFtNBDeFEeU2SRhAxU4AXE2a24vAWtDGD7NuZg5zGyTtQmoRjq/ElKcvlVDKwDKLRbdRqWrwKDb1jGJSs10ENHB6QXmOCmjZjuUaBH/O0ip5A+UqlD1h45nDJjhPhhCg79hzz4BNR1g5AiVo7NcgK2AFMgDOATxPDvZFP8KUrVm1NK659UakBm+JNoCL03D+HIOuUlFcwO45ggWDYtgBk0fVZFNrsKS28AiYG6GArZNgUcZGI1KSK/WQWWIbQZ5zMuRQl0rMQ4LcLA+ZovZdGnM3mJ0q2UZsA2u1HTIxDYh8zTQuPNZxHzphEvCKs7ZTuZcmA2n+k1O1ALNLmftUdQUwoP6dbexRh/+nsIcalwmMWgsuKkHXYJtRtqHTNo4L9qFCXlr8xHp4MfSYmaOkA6TBhcDcF1e/CvjTsLFB4rC0vL5b1c61GhzoJ0RgQZ6DipZ10Cc3xrkT+6MUjrQMvUeDgXIu+1V4tDKs5gzSoROYTuD0ZGi6LE52jyRpm9tRc5WAusAEk6gmyE4ECscp+0TtThkL09LzO16TuT6ZRWfyIodilG3M8YjvMIrSVx9/Ib6082C0btgWXe3Ho30eRgSieRSAeWbP2WiQaAgss28p5sdrpWBsixBJaA7roxhzMsAMI5jmFtf/CbzHcZudkC9gzMm+4zvL21YCmCNpEL53x399Xzz40N443wl9dVpXZYHguupYnIpU1eFUDhk4y3Dtn/2lX49V6+DfkYalIvNojfAYUDQj/PvEn/1hnNi/zwsIHjwtedOb7lBkHYZqpKz9YM9Y9IxgjmGfYvKeKvpzlExDYtEVJ6+Bw/arrorpI4MxjfvPLi2Ja75+PGaOnUECOWi9gXNGEbu+/dFvqW20ZsO3hOEoG2D8VGA8MIJXHZy8n4L6Yg6GDsc/47jf/ubXIo55W0xiXFA3/8gTT0c7WHPOUUV5Qn9N4POTCL05CaNuy8WbYwcce5/ctVsGfH9vH96Dgy36dOD8kNjycaw5xbwewrkuvWhtjNa1RtcE2jDNAY2xnvYLgLkkd2hTM+bom7wB87PplHh89VVg5KEjh/9N0cHHIMnByQbnAhN0sa0RMnK2HuEU6efi6eH/8Vrjp+EA2uXTOPy9bfMl8eNvvUNRmB4/eiy+s/uZGITTLPeA5h03Qaq+MUb2Pwb51yhixN8UhxhDHiFKKUBrwX5K3fkQHGmHu86IyOIpDi77Naw8vz7afer5Qmf/6MkFLYC2J2NOWQthyn2YkzzK+748XvTOn9fdQmBeBcbcm43UDdoAvfyTociLoDYZvu6dRJNEQEub1gI6tYGcuR1ezpv0YkAvPJ42ePNLvA6BcYZNdi9iem0ClhJM0CkcO00hCkAlFzoCgrTxZERGRsv7vTXmgvrazRPwSkaH40zn2Z7vt1hvnkrEuidNdmF1SGiU9/E3eX20g1jlxAIuWkd0rEomWoAIwJxSnMSYK8wX25MbHgGCPuv2OvbMozHSx5jFZrv4WAnrv2UVUjqrqfNZxiIWTZgPBcHiR0A2NYQsqWBJKJ0RAJBUyQBB9zW+XNDpsseFKPFDo4J/525l9VI52IzatgrNywVXeFPAKZs5+hQ/ky6Zh01qOINxSDR07J1qxDjs/JsnIsx6OQVgXoGNiA6sjDYwl8CVB6HrUXgUxk42sLCVCkCnDuGTjMg0dglcXL4Fh2WXn/9PRI/bKg0Ts7lkyl35NF18ksRv5Ubl3q9xyBjvLKrfowyHcd4X4VIBOJ8+0BGWnzNDNwtZw/GndiLcGZKw4H4V0FOuu/Y2ZY8kaBmHE+B5xAC+ZOPyuORlNyC5CqKyILrDaYAcnjRMCog7VCEjH1FKpTkun5CiqEU0idbmOt1L2n4C8xRlhFkey6GbZfx1GtUpsqYWCOukWT5ItDAPGf+Z44WAbnxsFFpdsF3JkMvAhtdnYcw8k41lLPo0iHIjptM6AneCAzL36l2uE5kpzQa8+sTGBMvNaCoCVdqsScqCNYRxl0aJ7mUNdrpnGusaDlrvDMQcl5zXdrhEPhayn9qgZd1tjeGrdNTkWsQLc8DoP64vDk3q0UnDxGNNwJbjQgOKY0wCNn3f5gClXTgpmiqPWjjLne86KMfiSrCXk5CwVFQjeyiBM8cIIxnh9xQjakFfOz0+ECOIdd5+FklweE+2syaf65BZYBaTbCmdQr0UEIh7nRE7TiCPujtChsE4m45gnn/LyE/MOq9VhhMGhpu8f+/p+Py3j8YT58mKA2j5om4rLRp4TikLDE0x5hw3nEM83eg+HrNInMVrM4Z8LU5daBDQ+CMwHwegpPQrS4jUi2nu62QEa+mKlRfF8WPIlozX3/fJv44m6Kn/+4f+MsZhrGiNKcf9COLdEdA849TpwBNRDGPh3e99X6zfcqnqmdsq7RruQYHzmbjrnz4Xu795bzK48FmsTbfffjsuPwn2vB7LGZJBDc/HC13nxW6TUBJZBbb8PFLPD7zu0mi49ZpYFw1Ri/lzpHYqRr74aDQ9cQxsck3Ut62NstamOPKt+6Sn5yiZgsPtxu0XS9JXjagsJKVWbro0vv6Pn0TCOkTeSqekZRjv9BFjO9dC316L60xTIoJ/jA3PsnB/GIXD7ugIYtHjeRWM6HHsEzNg2R2aEs2EeV9VW4OkQAMxCpliMUiHckgwm5a1RTHyJLSPMCNnClzAfug5BmB+MDHmzEOBfRrAnI66eeFkXxGkK3QvfvqXIeM7km0RmMehx8GYjyvTaAkMXQHzEujk67ZgjCzWs3suIX12lA4iSymjsWFdaATA/4X3vhdRZ6rjCIyLb+x6JgaQgGkJHOJjOdqtcUmMd+7FqcRgbN52Wcxg3Wt/9kmsibOxfPWa6Eb42XFIfcb7zjvEYwH/xPwb3vH2Lz5++PnfOPaVbxzVQPjR44IWwLzg8clr8UPN2L3o5xQP9d+2oX4oGHOk0L6TTml5ARL4LgDatKZyqU+bobcbszECMNqjEsrTM22DBm/pUQD1ZKASoE4clxGuNrTEW3LhLADDlAKZumkszJNIVFDJGLFwNNECq83WZXGZ+MtoS8CKwEI8cd40ucmnz4h9S4xp2jvE0KXNvVB2bbQLQEAoRXEBzXupPvx+akPLTBzyLad0lkMdGOBJ6r6VYIjhEpFiXoVMm7o7QAvt0acfhcN6n1okYYfYfM0rorKpXiDOdgDrqS+57/ijOHt0ycVJAxbcYmxE1LM7ZjqcFAv95tvqIQkNr8UIKgzdR6bXQCHvqf7LfeT/u2Q2sPgSL+LQekompHbHQ56hPg0pxnPbRrZqzMLib3nk83MGkWbMcTwNYD4J0EHNbwk2HQJAZ9jkpsAv0pjhhdMAUrvzrQS4NdYyLhAc4ocL7WYDzic5edgkvFXokty8GQRoSOWmY7/rCzQryewanKutNCat01W+JZ5OqLJsZoMkhZdM8gD2uWQVkmLgu9RZYtM6svtbcAzFKSG+V1XREKuv/zEAc4RVBLgeR6bQ84gfvH3dsth2w3WxBMC8edXqONNxOEaQ/U/X1JAi0CeLzORCYDnRrnzUYQ41N4HdZukFnCmfNSCehlFA1o3JnMwS25nXxid/uIkz34E1wVoHUBfGmmb4Os6xfDKjVPcC/gSABq0C6bxqGv86h0gbItuPBgKP49XaBJXUF3MsJd8WDiQZOoqpKOvSw1kDDRpzHufjaN3hOdN6puMnj0XdX/XwFMhrnsae8KJPZCRxxYeUtCv1jZRGCVhTFqS1CA9HaML/klO6poImKlvHQN+RkbxY6FdizDM7bGw/B2lCSxx5DnHDkaJ8pB/Oe9OVUYfIE8wWWYbTI+qIs7+Dos3gdAzUOVjniZjAPY+emUAfeoXlvRQGUdX3b0a1IDhnL9CgslGjqpolZ4k5NuU7YcZd5Rcwd6Qcy17cz2Rkq5F+fh7i9k9Dg/759rPR341IM8OTYHxxWjiJ084JlJOOoSBX1NkEyfwNgFTZfzpmzp7RfCFJQc00r88TXI7bcUi6CMzz4wLGHECPeu7lkCwcRfIaMusX3fjyeMs73hJbN62ND3zob6LzEBIZMZuo/AfcRzUVAIBHkXUSwPwn3vOfYuuOK+2UnMZHXhOyAyhPX3Y9+nD802c+qTVKQw3Xuf76lyKHQBPIeBiyKEtH72Q828VEPdUeg2jUWTjrDpw8FMW37ojP/eYHYiNzEMA4OY/TsVf9yQej9O7dYHBLonnN5lhx8aWx6wufQh95vE9BarNu68UKP8g9oxkAualtDQ5c5+LBL30OYRMh68C/cujnFUEG/V7T1CB/JCZeyqFQGSGF7DnblSdKZzq6oMtGGEblR5hWptJJSNFkaKPMI0hiNoq+Y5SVEuTEYKKg5o3b4vk+Tu508sAR3w3GHAZkNdqXI53ZRenjMYvycs7Q54mDS9lasbZwbR8AYEboN/lUCJijHXgKSCOAwHy+CH4DDWDMEWEmbW9eCzjv8J0SZgBNjAvXn/f+/C8gw+jSOIsyP7x3P4zVfpwWl0bDslVgxVfjK8iQCj17G4y3VavWxgv70e/owGoYtKe7uqLj4EGFVyWx0I+IOOOIJc81iKv69htfNnv46ac+MzY08DsTp0+fLAzCHz3x8jI/34Zft+CnF2P9/u9Hs/xQAHOEabrTGM/gTEDLWE8T1AkyDN4c6SSx22nRF8BK4DQnHvI1MmDWts3tER/jskvAwI04sbdpQxZjmG+ra/MHId40uZlCmJkgR+RkwwXQjnnpHiq/mUjbCNz4fDWBNV3O9ZP8gEuZEJaBtfBwqrOxQtrMWdcEJjMcFThVfb3z2sErlRdfTsR8gVUjC8cFn7pXyg8oZSljUhJG8+AeoR0xGzK836yA+TCAOcP6SQ+OOm14yS1R04wMgancBhxC1YV+YpSIYmhUmWBlBqwpj1KLmTgDbISTprDMqV1SQRlzPHd4ZhwLun++I3DhjxjIqLENtPQ0NZ7eS7u7etsfNXjPmVbTi7qGw85Rn60whNyjJWUhC4djZibxGQPbxZjAkCUYmGPxVh/z6jwhIahkv9OB1KAnqU8KJwIuXiory6ySuf9tXOaHKyijKmntJVdRWfF/gA4zlTmCSGLdVT/f3w+CSY5Gamj5Hd6OzH1yJlWLGAxZMsEZhTGi9gDIYZMwvCIA9LFd34zh3vMyAOkUuumlb7CkB0UiQ9pz9Im4fjuyBl5xcbQtQfhEJNXoQubPsWE6k4Jx47Ul52AADKbbdgpz9m9dZRHYJm7mlBRw0lATj1CKcNiahFFQCe27HDt1CkAnZo8byy8IttEOlEXQKZc9j89OYWOrBGs3j5MQJbpiaxSAeZKyJKPF1+IY9tog/wi1PzX6KAcZcw1tfsYsvzFtmvMYA9KJp/7y9PZKMwkGjhKPPFTUF/SI1LselLqe2p4g3WNCCbrS/PDHPLez5ITlKbQD18qU0EsRdAje8WFFQdHa4PXGI55GCevCk4K8GrI4bN+k82YzezZFFXwIqpqWRA800wM4NWqorxQJTYlLEcaGQlsCnEsHTkOHxinkBkxAQ7A8gTTtx/vh0zKtBvNJAsuR2o71NTPOkx0aN2hfAm70Z36PbUO5vXTpkvMkCQsZc31/gUW3Hh0ZRwEE66rLYrR4Jj7ffTa+ehYRMlAmRmxRrgT4tQx2DsWpPV0xV47xhiRAE0MIgYjEayUIAzqHyDRkzOn8SWNCmT/hxDkO+Qv7Jj8WA3M5h4OdbkY0o65TiGgCQNiKTJUrtm6KP/61X4mHntobH/j9v8CignHOQkvuh7LOQUIDFpua97f/9C/ExVdcI0PT/bWw1nnNQ79gTB46dCD+5s4POzoM1wZcbsO6jXHt9VfrM7VwKjzU2Rf7e5GdEjIQgl2t/aMD8BtAkqENy+Mrn/p0rG9o1djj2H3zH30g+h94MmYhMalFPoSLLrsunvjnz8QqhMY93dGuuO6N0GVzMrCudXDKbF65Lm67/Q1x15c+HY/d81WAd8SWZ3hQlIKsbwUY70akt6eR5Tns09BqnESwjpMwRroOHo62TRtk/BCYV+I91mFiGFI6PBufmIkR9JfEWwPnYMhXxNKNW2JvH0ifkjp3BdsGpx2VXdCYw9GV84+gnz8E5rwX70uQyxNigvRSavHbLmOcS/QF2vHw7ihGFCn1DfZIrQbFAOaUspQ6nr3uk/YMGnJFA/ujYp7A3ye7b33L2+MqxGefhDFPt/clrXWxDIx5fV0jTpngjI71467jz8QzCM35y1feFiME3ujD55E0qx/ysXK08dDIOJxuEQUMBuDZE8ejt7ML43MiyhFDvhaGcv/prmmQFn9d31T3ux179pwpDMYfPWE/bEczXIGfI+hvZIz6t328+IH5zbe9q7y6+k5lpyRLlBZvNqt14Qnp5nmhGWKWMWt8FQ0jgRxfwJuBjvwlPzJ404aonwyGzSz6YbacR6j8Fq18HtMKVPA5YyuDzZuGhzgdnih18OKZ2Entnt6wpUolQNOmmOQlOb62K5gWqkWQzGu1QALLTaNBwc+0OQtBpbbhk2RQCMykNSNdSr/4GtlbfcnSBGo06cg3hXCPlWBWSgF+GCmFlJTStbOkCTRyMzr89E5Y7QOGcMlIWHfly+Gcwo053UPbuNtOW3oCulyIyeSNI+a7GBsy5mg/hXMTEEnXZBKg3He8SurDQh1cqsRCGzCoeulz6kk3ewIiZs0lOeeJRzI2ZKwJlbBPEjCSAcgx50RSdPqx5JwnJM48O0Vgjg2HyUlozIi+40bDugJMGgfnvmRkICbEssOujUf3A5/4CNyF9evZPmEbJsMztYsryf94Hw0AjSdvbqy068I/xHJTasXRsjCUE7gjEHeb3lw7AAAgAElEQVQjWSmRjDle29So2sMXNYBnaciyzgB8zcEQPfb4/TDQ4ByH+zCW+4ab3oRrOyHIOJKUnD/8RNx2/cZYumULkoJdBB+EVdKYj0AyRedMDjH5EqCdp6hTBrvLccjmqK8GMIcD3ByT37DdcVWyjcwRQKdVHTvjXtT9e9baqJETZDKkOKbo5Ka6oZITMAarG7DhKvwdAZzPz+QEzfGgk5gkq2B9CWJlHCWDKRlKlKYwdrJCJMow9QYsWZeMHJ9/GLizD2xQqZlRnwlIByqUuj2tPLLWLJ3IoTs1H1Kf5hM33tcglH2rKmj+Z2PdfhSeK6obs9QmFtzsvZ0rlRcgtYnOELmesBEVjcZtJbkP28OsSJpbbgmO+TkY740AmwNnO2P/7sdi4xVXA4BBngbnv3o4g/ZD+lGHSCL6hjoIbc5oGOjfMoCk8eHBODdWgugplESk9TrNQ36BYJqGDdtMunIOwIJ0hUYPcx+YJSfRzIzrBPPz0GZJf457ik1H1CBmY7beH8wtwo+Qma2qKI6++cn4PBLcPIjoH4z8Q0JiamwuzjzdHdWrMGsqoOknUzs4Gkc/tTNmzyDEK/qA7DOdcDnuJ8CCUhvtyD6pnQr7hrNFlsFwbwZ4Pdt9WiB1xfU3RTFY981b18V/fPc7452/+Nsx1gfLhqw5naDZr0NIJX+uA0l0puKtP/XzcQW/k04UFodM1NjQ2joXXV0n4+N/9LsY5wj1lx51kG696U2vBxidiMamxjhx+lycHC+LvhHmObCD/wyMplEkGZqDcbjyHXBWvPVVcUPt8vjiQHsc/+svRCUypjJrbjMiy6xFZtB9ux+MaRgr43CO5D7I69RCYy65EaO0QI9++x1vj5PInPqZP/9IDJ45q/mqiEpsZ6z7VSgL56bGOYwKDrMGxDK/5JLNceRoR5xBkqurXn5DHD1+Et9B7ghotNsQ3ekk3mNug0mcbihHE40qOBjXoz9aV7TFsanaGJ5LGUA5lnvo/LkfwNyZdgXMye5zXMG4nmAseYxAAXP0dTl08v1tO2B9QqJMbfmRJ6MYiYbYzszvwfV/Duv7bAOcP8tyPH9dwv/jnB1uj/IpxEDnXMM8uvGGl8dtt90apTCMhnGNjetWxYqlS6IOxgalo0MgGj5/8L74NqROb9uBzKfTtfHs8/uQeTViy8aNyHaLPoPGfODc+RhlmGGQIqeOHInzp87K0GmC7w4jXc2hXdAG4z2dJz+GGfWhoVOIIfqjh1oAfY+sXrEGP0+iL6Ep+7d7vOg15i+BxhwJb+D8qV3SOw4f2pgsLzBgtQOWFym/L8DhtCr+irvHW6zwkpmVrAvUhpTnlzaExFzztQR8CLr4o+08LYbWsgIgMNwgGFSyp2LMtcEZ+Ds7ZgJeaTxoc2V5eKlcPqPP9NkMNRdKnzC7NneFqUsbQKHcug6dwBxl4oJH+rLBgkEbN24+CMynsLlMIVpGBY7PmCRJLJw2RLcLNaE6nSAwf/I7YJJSLOp0rQ0A5vVgARba03fPseUFXTK4xuY2Cocw6svFmidgTt5R9deKlkARwbHYStGIBYaXTwRrZDh48zfgXuhHt7lBewY3cuhNLDw3Fe0I+CH7n9OTE33OS7iMEpEJo4OgKyOWTAk1wJ5QP1sOlrccoJTAXM5D6jZnpXXn5zHGv10eGzs2nPg/kWSClf5bdVGhF/hLRY9RGWyc5REtE0sAje1lI01XEoNM/TV15DYotHGKmPX7joeeHBjZBnwvOfxqpCejzddKYSP5dYwbOnEdffT+GMUGzXarqKiN9S97o7T2jFo0NXgu+g/tjttu2BKtW7ch4dAKbNirkGTlCDaRgeSA6Xrw+1MA+sxSSKDD4tfXFEdTPRhzlIsbtwA0NuJygHcmM5JvAtGXdO95aSAwWDB0+H4pWS1F7sC1oV2trkccc2ag5SmNnD6dddTJdWyIFFOjqq4QlPa4Vd+52WmsKWyhh6QIfZIHYqPNYxcePuXhqwZPii6DtiMw9zDkawSdClapvrM9xLFk41TGBr+PscjQgDlqigGafVekG8dlCuuiut8SHpkbHBppXeMXFPKRJdVQ8OccFDWB4GTMWd+uUml8MGKOlCcYDnT2q4SGdmqwO574+pdjLVKQ8wqIzhcjswC/5fhsJeRtYhBsDAF5goEE6wlQNAVd+uBsOcL4wdBTcdnG1rVzvuYUS1ynlfRTtLhZfwF3/GaGWBkrBOdSORiAl+JHDqGlANcc58owanadY6ESAL0KP6UIy9kBDe/H93XEU8g8O43IJUMH+6NhUy3kGdQ6M252eZz62nMxuf8MfGsGlGCI/U8ZFdl/Mrz/mr6cg4CsLBnzxqbm6AP7OQYN9cZXvyYatq6MxlUNUbeqGcboRHztjx9GgwJQgplmHYvPI7074sbP4yTpjv/jXXH9y1+T+lJD1MMzPVHmC6xL5+Ek+LGPfBBp3hcixJVjrbrjjtvFTjdCajiKsp4vbUC726eH6+88HHvnEHlnHJKjQbxf/sqb47abXxn/+O37o+r+J8CojwvE1je3RlnLqhhCvovTzz2hcV6Vkus1trZo/LG+LQir+NKbXxvNSxrj43/y+9EJJ3HJ4ph9U4EFYDAndlzhTTH/aHBvv+zi+Im3vSUOHjoUf/8Xn46f+4X/HEcRSvDxXXtEeG25dCvimeOUBn2gxGMYLyMM1Qpg3oA2qwfY70WM8Z7pRcAcxk1F576UaZf5Fph8DXITlIFOy2nRVduW4RSruqEpepaCYKXhDQlMIFxmMU8gRFbw9JPrPE5MawHMy6GZz5gjz3juF+Nn4AB6Kp1ORWxHKMd3vONtICfq4zjIgVZEn9mydiVilTdFI1jzcczFX3n0s3EYzrC3XnpFvLJlW6yH9pwS3kG0ffuZM9Fx+mwMwNgdH4M/AEIVM0HSqcOH0dcgRtAT9TjNGO7tjta25cimeoZrzTD65qMTMzP/z/mjR79vjo+Llr4fqKeYnxzwjNTCDGSM1NL9b1XAFz0wt/NnzZ0Cr9ygEzDPMWSdKMWM2QIXmZrbCKkw8Rb+8G5q6a838cVHj2nJ03vejtLmKADto1SxhwKM0HlJnoHFDUBtDkfl9HbnQq4NQt81+NGE5v102yQrUNl9l7T1J7CZ9jDVzPVYSBDj42avydan+7lRg54XML0QRQKLCViwvmzL5MgnCx9fokPdDEIYMuFPMRYeOWOynRKwEJjnJQCqDzz+kGQ70tcSDOB/Gy6/ORqQ3dG4Tw1UsKN4IYe1MwCYA/M5yQQSWAipLSQ7r0g0bCsAlAKIT13J40yfjmRwmnamBDB1Tz7nSqZmwHUS9SxMKeBLAML3+Z7LRyOGTKZaTycNZlB9EfczWUprjFEqsc94jf0NB75JpKCnc10pdPlK7AT0QGbcDZcafgFD63XZAoqhT1Bkbe8C8DNQSh2m+1Jkk84RBKDUEjIuXE6PnSxD4fdZP8+XQk0E/jzCVD9WX0f+/MO6cRs5bEjrohNpngwzS6J0csWvUPc5MxmHdt6PpFQA2ahPeUUdGPM3iqEloz0NUNO7f2fccNn22PjSKzCuWmIZGPNTHQcRLhFxoVFpk4xsWx4nMwRiSYyOWi4AtQCcP5lhkYy0Q5pOC7xDNsFQZ4mBE7DMBjvBI9lcGnX4BsFTcSlYd2qzQanSObsKjDmBviQh7FOOS7yvyC0cz2JWAZJZOLaLJFYJ/Kv+GL8MW8j7a7IZpdK4kp2gVs6giQ2d+kHzTB0jw4Jx2G1Ap+HGdheAZ/9aF2/2n22UjMQ0dz082W8E5WnuqLfNsts0cKIpsaL5e7yVbpjXvGwYmWUm6PYk1we1hpna4JqJ3/h4OcY46z2T5mRNXTPIxUZE0jgfj8Dhr+3iK6IZEXjO9Q3BeW1VzAKElzIzLilttZHlhpMAgQw7OjsxjHjNZXF2APHq0YiKZq9Ksx3tF8K/SsCE2wHUREJOrETATkkLpSUG3SZfDM79ehlek95coJ7gkUmkAEopySE4B3jndZ8/1R+/d/dz8c3nOhEKEM65JTjFQTjB8qaKGDlwOqYPnonR7nNgzBHKDlYAM9KOATiRBV4MzNUTmd3G70ok92EYQfpGDEFzvfEd74ypxtroQeKclWtr4qd//OXxkd/9cvSegqaZwJxG8nkk1YO2naEdb3vz2+OmV73e0o+0Zy2+h/V88yjLSPzlnX8YnUcPaTTwQSPkFa+4BYx9gxwOaxDH//gQopI0LNFY5dRh++C4FIYXQDnq1XbRRoTDBPPc1x2nj+yPQWTiHEPIxHmECJ2mVA3lO733aZ0eVCOSDE+ymgDMGTWEoXZbYYDX4PrXQN/+jW/cFXvu+1q0YN41NDfFWQQNgNhJjqksG4E6x2dtQ21ceeN1sXXz+rh4/br43D98IY7CF+B1b3x9PLVnd5xGhtBtAOZnTp2GcY+TBzD4nHNjGK/02aiDU3IDkiGNVS+JE9P0+UtjCO1YfmKvkixxrmfGXCcchX2S/cXTFMR3b4QBRedP6ssRkQWB8DWFnTeA+xdOd3GiPF2zAZOBkhnvKXqIIcB1ES7RGUD98nKA5p9/78/rRKADMr52GE5bEEZ2G+q5Ag7xlHPe2/50XA69eSOc6CuQxLKsuAInDl3Rc64vjnWejBOIfz4KfKE5hJKMwZicA+boOHQYa/AIovg0aAzQMOL6wmhXHIIIH3oeUp0/LG1s/tNTu3YxPucP7QNzlCF7Xpca4KtYI9DJ3/vHi1/KAmCOBc1xzLnIJGBrrpSMDxZHLi/a/7zhLDjIEWik6CsEQ9o0OY+8OfJaGbok3hhvaqnyfE0gTrlq9J204dJ5UAwZtGzc0MUqQmMOOm8Wzp+My81oI9pYtMclMK4N3wxcAQgJVRCIpvBkaYz4SJoRZ/iCGST+ULqQj5plUKRg3aq5gCg/v3By4BbxRqVLGDGk66WIGLwOdq0pHDFPA5hT88YFk+BAG0RioPh9wVZsRgd3P6zjUpfF7bLu8psAzOFprnuxQxYAk8lb67R57UkmtQFjXoy2YnQKMXnU7pLV4+YjsOXFUgmBBJLwH9td0gXusm4P3Ur1ch+5klxA8wafJBtse5K+6gB+nCCM+CONGY0RX0xNxfsw6oLQow0COVXxNjC85sBkzSJuN3WVZQClbCsCGznmqXyp9clU87saDP6+RqLY7VT+1CMGQHzf2WpVELHauUkpX0pyG42rJOPgZwSU+DAsK0i9Fo3d3DUCf/wQBreNJZc1tZwBXwGQ8bO+jwwkedwS9M3FoYfvjhEem+OlcjCja298Q0D2GR277om1l1wbPfu/E7ffsiOatlyhcInN2IS62g/FABK28BoZzPIC1JhXVpXA925SUYJqAIhaWmu0z3Eu8LNMQlRVDUYen5VzMli8rONUr6Gu1FIzWgbbV7YljEx+hrKXaWyy1YhOwU1LbnSSvPAUBG1AwMlaE/wliZsGkQYJx5rnktYYfJ8MXj4905bNcZJ03Oa9Deg95fg3s8ZySwUAxcZZgygXXEOyf4G1tu5BGQeqD41hrhueS5T8UA7gQez3CRTs2EmjkJpbl1HOvtS509DF9xSxhLKgQoD/ZDjbGtO4VBnSGCymHwPjdvMUgBOSvhJcc3kqpAIZ1PN5Ywsy/mIejA/1xJHvfBESkNaoXbERLYD+AgMpg4TNQ/kO1wt5iKP26A9G0JhjTgCQl92jiJ8N7TBHm/3EU+x8dhWHK41JSlW0LliIyHqJEccHyjBmCuBdTQmJFb5DwF7BNAla0niK4uRG/F2GzJdVOPWifJs+DqzWrkNn43f+8al46AVIdSl74riCVKAGzvETANZ0xKPzHh0ZR2HsUV+ebcPFJI9Yf9yfUUQoDyzBd86BzSx6/dtUrnWIvIJ4NbF1w0XRCQ377u/sx+uIOY5+GDh5HEQPyA+Ar1ff/uPxytvfXPCL0HhKNzRo9LpIBvjTn/x47N2NpDgaSR57V7/k6li7ZkUsWYLISEgGdB5tPVLTjKZ3mvp5MP8D/Yj+MXBe4H/5irVIGrRc7Xb80HMAz5g7dM7mVdEcg5DB7AdYnhyFM2by1WgF6K5FX5dBmlEM8E72et1mRB0B6Pzi334MSTEn4xUvfxn2iNr4x6/ep7lcxkg0XKsoUcN8Wrfj4ti0fWO0AqQvaWyMBx7aGd1nB+JVr7k1vnHvPbFu/VoB6wPPH4YUEsnMMN4nNX4QwQUOmuXQdVe2tsX+cSQAYqY6PgbPRMWxZy7UmAPIF+SDqZ24BnIvKsMJUN8KAHPOg+4jEWeOoQ/AsHMuov6KVkYJHRlzOLznUzVdRn3ChWokSgYPIXGf11eGRv3VX3k/ZCat0Y8++oevfA3jriQa6xtj6aoNuEx9lDaXx5Zt65HxuCQGeofivq9+I/o6jkVLPU5VoCGfhtxlI6RPSwDuD7V3xBE4kdJ/hsTQ0X1g9tE7MxgrPH3g2kGHY65XPNHla6XVzd01JTO/B7H6X+3fv//7Ep0kNe0P1C/0xzIU6JX4OYu58eC/ReF+OIA5GHMtMHmhwW+zKgag2oPF+pEtMoNsItUwQ/PF00xQI7+aQaX3OH9OC15iyozsuCabjRTAFhvlj3tT9ebHBY4ON9OwaKkn5GLkY3FvqtmiLkhPsoWtqZNBkWtotojskAlgHQO7dBfURLVJb7kNuDldyL3rfYJ52QML7cHnueyqIxbjCbCQU2CxqgEYyFrzqN8b9YUPso0HH39Ymf90xQTMyZjX4+hShWKz6E1BXPP6Rlg6OVBoRsYAh+6vjE582jHNmDu5CvvV4NGbkCN4KDiKXl/oV5bfRokq634iLs51zEBVTF1qBslkCMwJNNnILKsZUl+FxgGNLsfQVi0oZ0nloBZxFhrHOWY/hLSiFJuRGhnUHcMNzpNxFRjjN802Z+berClahHUW6HdZ1D/qRwNMO+8aZPPhjYTtZ4fAAjhTnfz5HEfbhgFA1Iz7jzIkXsfRNTyWBbylXCDgc+Na6sBPOvJBGj4C5iVASgr4w1eVDXUqDjzwVbM4ZMyrmmLDDW8EYAG4Bls+DSa0f/8j8d63XRbjNduiFYxaFZw/Tx0/FEPUQ5IFF/hyWaawOVcDPY1g06QMoQHS8OYlDQIbrDsNJEhDlQ59GtrWIsrFOJ4EaJPRmxrLCm+OKZQb40vzFvWcgfFZ0whnK8ZKFxPu2O00MoqxUcogxjXgArZouhHiprmj66PQYqItmVCL5L4hFBUYV2sXxhtPYtjVyjaMa08jvndV0r5rBGipyKaQv83Bz/nANmJ7aCwxjnJ2Zk1FoiHCe9HgpeEkVk/jwxkhMzjM0aY8vtL6qIUsrRkEvbwnjZjExLPEKpXYX76HfgZrSqBuAsTXKof0rRYSB352uO9kTPUciK/+8yNxx8+8O+ZwOjLDyCQMmQg2uBzOt2ovrdUoKU5KGFOaYHdkqC+6Z2txagLSIzkr2/B2ZZVCCNE+7AvAdgGgTtpyGidy86Ax5qmj8rDe1MQTcJK0t9yFnwNgx3wl+CzHRShtKYf0xgcXDIM4HQ/vOxv/7XPPxXMd0AsjFngZQn0WYc4zIg9zMDC6B6UF/ysZi7oRZW1EdJFZGGW1kJKcam+PTTe/TAC8CKdOLHcZ1pAySvpQsCGw0wM956PvXD+ALwhOANiXv+p18fr/8JMq+OITTO+BmQNwmR/45j1xzxc+m2a418OtW7fGtu2bYwnS3rcCnFcj3ftpRBahocQkXBw1U5yzOAEkuGuEjKIFAJfGSifqXMuQmDAu+lEurpc82RiBnIKAsa4KIBhjkhIR6r4n8HPkMOLGz4/F+isui/YTZ2LP449E75nTsX3zltiO1w4eP4Zwh92IzlKv0y8mGWK0pFKw2hsu3g4AviouQpSf1chc+q1v74xn9h6Ma16C2OJ0OgcBtvOhxxGKnicVWOOwX03CqqvCXH7Z5ZfEebTZ148iXj7Gqcbn0LmoPLZH4RI50ikbomH/3Scc7Cs6mJYCmPe3AZhL6obZefL5KO456UZW2FMOMADzOgJz7HcylLUJaa3Vb7D3xf0HAucLfg2Pn/6pn4nrbrwmZmHA/uln/y7O0XkTcpRqnCw0rlqHumNd2FSNaDxlcd2yS+K+L34RY20cYWab4yK0GyOZXbxtQ9Rh/jz7wv7oBoPecfgEEj+tj84TJ6Ifsd1ZN44PngRR6sMxxeWxhM7/SIpEO6iyaOrk8Y6zHxg+vfnTEQ8vhBIqlPTF/wR9DyeCuBQ/e7C20Kr5nj5+KIC54piLdQTA44ZSYAbt/CgAJ5RittFQh8AhMWBs8sSSp5lT6IS84HMC88haMoUCSDeU15aUEXACmuK3GaYNf7M8CuFGFhgxcEuwwdCKLVjSYovSppc2FIM2ViaDwVT+NK8NsLnomkUzOLXXf2bd8wZ8oabbMWXIdrnMPgvI4E6YWSDM9xYoIWihZz42x2loPstx9M9j+iI68ZExT2ftbhaCmOl4YdeDiFAAh6dF5dlw+cugc6POcBETl9Yq349JXxwdgpnyJsGYczHOaZEpZxFTmNa5dLyxqPDW1grcCyQskgHh8gKmYtdZKCJ4b+bUGfNrBBvWu/tHiWcMO7Tmelxxl2OzmaHXF5ma3qNLR7cMJEHnNTpDzWCTpj+B0sNnREBwlxlXlSv1gFhCgi2X23CUt2FZE9hetDy4yQiKcu8ZFHsI5jZI7CPLxugSCeQivK818xy/QjY0Wt3tjgZkiYxkBRrgHoceheLT/ZynGLyG9MHJIGIdyBDi2HvfA1/BBmkDraK2OdZfjzjmTLqBF8aHzsR5JM5406uvisq1W6OhFow5kqx0Hj+szJ85hn7iaJXWvAYh7UYRfYBJdBoAkpqW1oshY2EoKZpABIz62gppeqXJTk1TmMc0LMhokTVi8iRsSGS4ipDpkJ08gygG1QDm89SM0jBTP5MNJ2OOz+vkIQFzWSsEu1xnOAc5p9zujGFPpz61lYdZYcw5/4H/tk48v2cAzH4hGOHRus5+eH1+hKcteWTkUxIZbE6iI+04okQwZ0J+sExKNqOONZHAzJLFrC9AjDXtnAo+MeBDvi0EpmxTNayB/FyKEU7HcjlKYt74n6w33YPERwXjoqeTJ45l+ksoKVB5A0BGi6LtjA10xVBfVxx59Nux6tpboiHVtQzp2rHIyFiSsytKQGDK+TYD9hzQRGCrd6Y6+hC+kFl2dUqYKpwJkhKGBkJ5aDZQnkLJABloGx88HeB667mj8yvWlwBFoMU6c8teGEObwBx/A7FXwqgUIYoPKxwdNOcD/dNx37Hx+PCu/jh6199Fad9pgfIK9D8dByfp+FnYM7xWL/SPnzcDEI9Bi74S6d6PIHLKMkgYKnDyw65jJlU7Mc9GE1hnvs6xdeZ0bxzdsw/270xcf9Mr4QD6c+7n73qo69mP6GvGMj/AyCwf/VAK32ja56JVa+Il114ZzWBmlyI7c0Nzc1S0rY4+GKhyDqZBh1jnI9Bq83qrm5eiH0pifRucKU+cjPu/8UCch1/ICH5k3GMPYPIoylAYzrAEBg7b2FFOaD+iLjBGGhEMgBlJh6GNHu4fgrEOIwxtWlXeGKs2roWh3oB8BmDAn90XWy/dAkMBJjF8VLj/NPP0FQbwtg2borvnbNx337fjNa9+bbQ0Vsa3vrUL7cUxjJNLGDeM+EJpR3f7MchdLom7D3ZCt03VAtoFYVsrj+zGCRX8gtBG44i7rqg1eUxpb3W7VsJ4LMEYHlh5iccn51zX/ijuPhFFNKQxb51dHCfkdZvMmMsJ3PPIizOfY/0ZOBgVsyQt+PJsbN92Rbz/196neXbP00/EIYBrOqEWwYCoa1uj743Ap2Ap2nzj2o3xNDT8cyhrBUiftVu3ixTZBvkLJVSHj3VE38nO6IQmnTBky8bV8egzT8txvpnRr2or4zzCKhKkyx8H4xznE9incNITo3H2HIJU1Gw8suryW3/niU+///N5l/oXg+tF/ALm7KtRPQSrV/IhBNz/3j1e/MAcUVkqq2ruLJDGqe1o4WujEnjhwp2ZXUMdAS9+VkBFMyO9zoXTwNGRDQw48ufSAbLuYomGr2Vg5smrY0OBTxub3NRzmvA5WLjFYIH5t2GUv+PMn7y3r6sNVEylN/u0s7vcYkFyffI7NhJyuQR+CyArr9f8btoY9CYdJg3uEqw0yON33TTYu92GBBBTOAqchiyhkkf0YMDmYHXzmNNH/v4eP8yMjwcfh1c+NhqVUvUqwjHkDYhlvMQtlkCuNckL31cqeG56ZJpwr2qGHVPYu6S/J/gBE6lbSS9OIJvah3txqorMJZ5UuAe49aq+ubVcBkNfnaqomD6udycSDLvefrAOKSY966Nbpr7X0aDvwqNr9j2TXMzyhAFggpEcGIXHTIroCZUnM96U/thotBdEjsaz2IHT1XA9ck9LS+qSFWrpkrLvCcIWjQdeWR8m04/3pW2QmMIl516B6wms6+SAYJRltSxgoWF4fQNzPZNRQBbZOvs8H8QwYxw89+BXFbuf71XUtcTG6yHfA3AkozoG57XBI0/Eu990eYw3bkUYtSWxBMD81IlDMYiNeiGKBXX7AKsACbXVpTE8DMYcG31d+Xy0tIDdRvuzLwjSJvGZutpybEAIrchwdWKL3UYyZPmPccsp3eCYZVhIsFs8WmdTTGCjqwNLx4gyeS7wm5SylNAJjbGM0VZMMOToR2wvz90sG9L8p/MojVeNbfaF3JbTPFGB3FMsgl5OY1D9jKHNBEk8VUt9K2mQgGXys9C4pXXFH8szrInlnDZQVnnY3xyvYrtpRBG8uw8JBmhAZadpOYGaRl7obs1TG+8EDGWKC09gmk98XA/HdvfapIQ5Mia8jmXpCMdTdeMyzAVkxZ2Cbry/G9UaB67Zgwgu9bEa0SUIYsuqEb2Dhh37BXpkjluDy5mon0F0EACqWaxFfZNFcXaMOm6y8wvjW32sfjUb7bjlYPTpnnsAACAASURBVL7xN3/kA4S/C3ayjCkuOzYsCWwYraUMEUgIyvmcDCPHE/XzpQDuGlb8EsbcEKQq8NfUNL7nmY74i49/Ls50I4U82mEURMx368vzSawaNT2aAYRHsDcsBwPccewIdMxIxIQCMtRjFdbAvjMIxahwoeWxavPaaMY6OgwDtR2AlRqfl9z4coRMfK9H+iJwLlJFRhxBoWOE90GO8nv/9y8rU6nGJcZIA+73+je8Tk7g62AUtLS2iu3edPkOlGsSDqHjyl46jLCJ/UMjsfPB3YpT3tWNjJPw+Xjta66BBAYJgWAk7zvQjjLXxSBAOsfxOHTtU5CpcLBXwbDuASCsgk66EcZIHSK1lNTWg7Q+pXoyXwCN4/YXIPNA5JSl0JPXtoAB3r0H4SC3AxibFKqFJn8YMpl6EDejcAbfuHZDnGg/GQf3PB/XXHczQnSOIuzqiRhERKhZGAi1qN8p/H32+BEw49UxUw8HyKbVSqgEAXZUHHkc0rjE6qMfnBAsbwZeX/kgMC9FkqSBJet1WlqCPb50uAdRX/oURWoO/hI0OgimzZjDj1BZvjGvsKYk3Z1/DyF++uQ5zzn0UwWkTB/+8EeiETHlj/SejZ179kgbPwsM0Lp6E/bCqhjr7YxSrC2r12+I0909MYhQtIxI04oTjvMwmgSwQQr0dp6J1auQsAqGyImjR2LDmrUxD/kss4T2IRHRui2b4nxfD6SWkyJO6DdAlr+uphZhJedjCJGQmmtWRt36K6JnsuR5LJq/9dSn3n/34jH7Yn+OucNYl7fjh1ba1zCvzHx+Dx4/HM6f0JgLGCcAyMVIG1CSB2Tm1JtkYoHynPNSJjBiptDsqJAKP0vWlZthBrR4iyyipRGG4jlmdoFR1TzmZu4jdr0Oq3keixYZVIaCIqtlnaiBUdp5DN7SFl94LwHeAvbVwEggPm3AZmBZZwNNlUCX9ecW6STStxNcTRc1+86N1LuyAR/Z7wTuUFYmimDYLIawUhpv/FiOY3bN3yGBTGD+ABYV6Hy1ibtd1+24HlKWpfpQZpCyAeQWc1g6dgAZi0kaAdDB0VmIYErONQr34OsR/OX4xqq3wqmoQ3w1gXSznYXSsU0SZr3QWPNlC6aSysi2I/BJ3xdgJXvivw3OyQ5xY3c/09mLf5Uzjjk0f1NkzGGEVdKRL0kh9F1F9UhWhOrjPnXSlQSMZEhYOqEhog5NwExA2P1qoCxXPgM0/sY/R/TJfSnO09finfhESg67j6pehaFoo8HmAjcZg3kjHRugYlTV1Lwf+4b38f2yXngWoGvv/V/BmEFCFrxfVdsaa69/jZJT8dujfZ3Rf/TxeNebb4iJhouivmEZgHlbnAQwGQJjLnM3GRfs9ikAEwLzIWzITMpRD1a0pRWRMQgC6WyKtuNn6sEGTYAxVxQVgvDUtqmRk1FLwEJwyTGUjC/0Ccd4PYC59eAcY9byzzLyBtk+1p7X1VizpCP7Ey+cXgBCMlwjTsbolqv1JSU5sg7Cc2/hNI7Gt097shE+h4Q20teyyZMBSWNKc4xj0hofA3XOr2TMK/Qlyse24LB1OEOX2VPDY4yOnDRoVH8y7pxb7G9eR9Ifjo3s6OwVyfVnXXzdfFpi0EyfEy6YALM4atecYPupmAT8eQai36A3p15/tP8sDCiE04MRPHnmMBjg7lh18dVymi6uqhWY5nVKmZxL8wtAFXvkPLMr4qaYYXFuoiiODXmue15q4iaD0XgoS3UUoUV1TCA8gfcMlGWnKZSiwThBDplyg3FrzekUKmdSMsCSxJBhnYBPBAAltm92ywzKfO/DT8envvAg2OTTysb6v5Ky+KST8cPrgK+nJUvo7T4TJXDUYxxtAudqhE0c6UcCptQfNBCZdI37yCRAJIH5tS+7RcBcpuciYO4xzzqxWTxHptF+H/qt90ffWTiOJilTGfann37Xu2MEiW02bdoUK1eugB68PjZvvwQAHVFhGKkE5ZtAeMA7P/m5aF2+EWtaxLWXXxwf/IOPxute+2qwtcs1pu6//5vx3BNgkTF+zyCO/ZbtW+Lgc/vEnK/ZsC5qkcvi0PMHkKl0O5L+1MbKdWvhxN0Epn5p7H5qT3Qj7N/S1sZ47N7744rLr40J+AV0nOyQRKMJJ66UrC1BWMbnd+2OlTDmewdGEPnGjo6zODFavfEi9ENpXHn9lXH29OnYv/8IpHOeD3MIwRtg0Ad7EF1s+8uiB4w6nKGi4tBjAuaTdEpXaMt/icE4vCrpeAnH3hnUjYYdM5LSaZwnGAzX2HXsOKKRIcADpTu1G/AFsPpMMkTgS3kf1xVFesHFxhCZZaTDfgGUQOLnnW9/T7z+LcCCCFv09OkOrHWjiIE/hXZCvXGasLqWkYyqohPRe3bDWBnHqTLHQwMcZzkeWuDAWwG53ygcSM9DVnQYcc7HYDjWoS8HYSxuuuolceZsF7T9G+MYnEJLYUwwayr3+VXQsncjtGktyrps7fp44cBhJJ5aF8UIDTlD35j5eBJF/I2n/u5Xv5nX0hf7b8zN5ajjrfg5hnn1+Peqvj8UwLw8acyz9e/1mZEXsLHwuFI7MwGN2SLtEtoazZ4Y6HFjdIKQzHyLXxVjRPxj1iEDHocy5DftiOhjaaMe3Y5gQXpj/KU8wWCYFZUFR09kTxkSSjuadrUkszDg1GUEeGxEaIPNiy02afNXKnHej/H9xFilUgn8FT7lz19whGr8p3JnAJ8um95Q5V0Zbq74NY4jr1mkBS7FAsAEOjz+Z5QRgruECywdwoYixhwLHFtN0VTwb91lL40GpOnmhi2HXNYP15bDrgwYNwf/R2DDrJnMBseoLGQ1FUVEzFwCxzS8WDjiKngUZuPKR/Euu/XaCXEK+Kbu50alNrIhlA0St7r71W1DUSqdPN2aPqhw4wlE63hyAUDyqJiAhfp7OuPMAHjo6BXgQnpwMv+8gi7k0xAnSEojMvW1S7xgFLrgNhs8bn2SoQbT9/2NZFep/POQl1DP7kZNhmcaV0q7wfKobVh+juw8Fwz2CfQ5ecTRU+pAgJjA4RxBji5LsA9mUzSsmUsxsMz8CQDw/DfvglMXIgDgvep6aEKvf21UwShliMbh/lPSmL/1DS+NuZbV0dy8DJvzCqQlPwiN+YBAPq9nW4yJWqaR/AWsD7Ix8tSkAXtqcysiKeDWDElKKQt1rDU10PZO0glxgdV3rHF3oGpKwyY7sIr9NsieRFnrmsGYazBayqVDJBqBZInFKnuNUBfgb7aTHELZPgSjeJeyr0ps4G7S7NDr/sozU0ywPs/543HnscfwyHB0ZUxBTSzL5YgEdDqUul6X5pjgpqnhyjkEsI2xR+dYkwrJuEwO07w6Xzfo5UkP10im6LFh66ArXh/5f0tZPO4FRPFJRrRRRBEWjcDfw1ftyusxlGoaMgUQr8/I0iO4rYia1pXyIRjq6dB3KlHmqbGzcfjxnbEGGYKLAKRmATgYmnUObVkBx2EbDIy7jvTsc2hfgNaeybI40Atwqgb6brbYDLibzidNjFcuUxLl4eXMqptBZxH1t15L4JzAnGMdQLwCGnOOKWvVaXwzvB9vOxNDAIeTyDI5i/k2CwaT44fSxS/f+3h84jP3RXcvnJm/67FY3sJTBo6FajCWY1g/GdVplvGzcQIkooQGF8Z8ZR0kGbiXMtwyWgkrAWD+2jv+A37eqhOcwlaRhpRGpIYRySJnsf3rv/qz2P/kLu1R6jvU/7U/9rpYDrZ2+bKlsXYtwDI03JRrbN2BZDqoK+t0Cizrn//lp+Pal96CBDhtcQbyk8NdSMIEAmJ2rD8u3gLt94qmONfdDT12bZw/h/jkDF9KQxn3aIHhwdPDdsjVptBOqxE2sQ3ZLdkZ05i/YzA0zoHl5vw/3dkRT3zz24jpvS1KG8vBgHdCgoG43pClTGAtYIbLwZ5zCj/chDmLy0kGuWzFcjC/VZDWjMell26PNoQHPHjiVOx+8rkYOtWBdcs5J8ZGSxBdZZNY6bIDO6MGAJvSIzqaZlno4i5j+5EoKgIYn00nMQwlOTwAphr9tWLdGoDoMURPPKETODLm85VQQhCUU85CQM55w9/8mR6K0vNw5sVYklQI9d+0cWv8/oc+FEuWt2CO1MYQ2P4hnCBMgm0fhRRnitmksTcOQj/PdfDRR3bqdK6xtjGmIE0bQJblKtRd7dC2VFFkjiNCTQX6j5m4B870xZJ1a2HYLInjHe3Re+iEtPiT6D+egvFkoRoSQYa9PHQc2ntmpIVsp2IlkiUJUzGj8+QjR5+99/1Dex/9ngHVfzE5foBeQL9fieJsw8/3LITii1/KwjjmSWPOlVUh/gRg0jEuNzl1cuKfkw6bwEiQTBuwEaGfWqySmYwMwDPD5at4HzCMMegUSymgY1mLmEr+cNtmpi8KE+Gkw2M1RmWhl0UGhQajLALjSWNxF2bDnbSwJrCUmez0ZyFbZwKSBmg2FVxX7jrp+97BU10L1TUoU3USGF30Ge+6tPD9Ppk/JouYQYKkCmYkxLEbNboJqeZ9UZ+fhmPLYWjM6fyY4z6zJTZchTjmiMuqfkqgwSyh21SGFIuChYpOSlM4HzYwp9bSR+fZYZYyH/cXLXm0Ob5DLa4AdN6Z1CsGvOqvBHoX1VjvmfRnoVLHqu6ES3Qio0GA58SuGhcGQyK2hckJaNKxJ/6WrALfrGAiEjDGk2BoKP0pRaIJyiCKuUjrRtzRPW5SR6kr8iu2F7OZ4B5aqIO7TYw+o6ZoxOL9jO0IHFxa/agefK5rOt61xzz+w2AT06k3OXfSRQTYSak7OokcYbNRk7S6/I6STOl+bKDEsrM/eB1oR19AKDTqpVma6qalsfra12AjYuSNWeglu+PcC9+J97z5+hiuWR7rAcorlq+O9mOHkCQDx+AEwxzJDINH/AHGqK6uBKHZvMk3VeKHwJxsOe5JVntmcg6fqcAGj5CK2EBlJBDPoS2zqEUnMvi8ks0kQ0KnyeifKcgDaqF7LViJdCxV2wEIMQwcddWSRdiMUfC+gtMD25cXgtQUda7Bcbv9UVKM/e/qU45DO7byazTSeEFKweCzoERJlnFkSZMxekKOhbGMJ6aFPQrwH9lejV/NZ8s4BNwpZUk+I7o3PywpC+cW+wyjUvVK6wINHhksvDFkFHQq5VMeJiSHUv1No4RjAtfkiVGFTkTS6yyuBgjanGFjxap7LDBS0QSyv07D0VfhHykNKJ6Mzie/HbNL18dK+A9MQa5SBU3vNAkNxERXYFDcCzQHnPmQ6GcIoVn74eib+kM3dg3SGuq1RTY9/zEEH95n/8kplIYnGPtCZKnC9wxWrS8ntuJvGDw4pbE8BpIXGEpk0csqeOVpsM3wwZlm/3Et88kEu38Mut5/uHtnfOKz94NZBwDK/YXfHKOMI07ZHo2HKhgi8wBD4yA1SMEzo6X6FuWvAxtaCcfmvs7uAtDld7iO/9Kv/VasR4QTT2qvD4qQlA27tLYrOgzG1z33fSXu+9Ln8d3kv4BvbFi3IW5/w20y7tavWwu2dLmCFOx86pl4z8+8S4RMZy+AHx1CATT/+O//OS7ZciVkD/1xxebm2PfCvrj/3u/EL/+X/1PzvQaSkV4wuzpFpIHL+mI9rQWwnsI+2NPfh1Li75r6WA7d8yAizPAkjL4kfchgeaanC3kghuMrf/t5aMdfh4Q93ELnYIw3a69gn44iDOC+Z/YhGc8yMO+rwTBD6oR+mEQscEaKueTSq2Pjxk0w+hviKw88GA9//esxPzEeyzZui+ce+k4s2XpttMNXoRTAvBp9OsH4+emE47slQVwrqJHnCegcfa4AkCk3olyH71XV1koTnnMgTNduQl+SMcdaT/056mUNFNdG9CvCLRb3PKM4+xq1ypVQEr/4f70/3vHOt0QNcjSAxYgBAOdpEg/4GCVFXB/4jbM9Z+JRRtdB307hFHEZkic98+RTmvO9OBFYvW1HLEH4WTqFHodfQV8XTigRSrKxuimGQcwQwA8znj1JFIw1OryvQGbUWkQCmkY7dPWBOV+zI87sfxS+QW+Jec1r+nXgpOrYE3Hysa/diwX3N/DiM553L84H+pZL2xvxw42bIRQzN/r/ucIvfmCeNOZeXtIA1/JkNlVMmV7O7xmq+JHAujY0s1biUBOws8Y881v5Cv7tj5g5c3IbIbZ0XW54GMACn9zdMKGxkM0AqMwDrPLYsAgOPf68WR5fE/cmC5wsaL1buKYvbV10YopZ2nzLfJ0MzqQ1MJObs/3xJsZgBvAGBCw3y8udO39ZbxvI86hTsgdMfrAZjKTBjZfAPOtMXQeXj8f6c2DWD+3+FiQMjrgkYICW2nTdKxEjlyHg6HzqL+ReKURoEYXOxY7JmADMmagD7cWN2yywj9Bn2WZoV9kWurmdeTl3FtrH97CDrBqvcILi+y4AGDWMjDluqLyHUbqTt7irMkbibwE5tg+P7GWMmY0Ss4oPlzHzJ45MKf3xCUm12S2xuGbNVX9JGNwS6hEPxQWjLI0N3Tt9xyXnhzJSdm2yvMLXpQTDUgiBT4Fzyzo8pjn+ZG0YdONzcjJM0ga9z79ZZLUvx0Fmmmlc2JlLbai40NkE8BjjYl8EUPvs/V/SyQnnQx0YtlVXvQZj30bx6MDZmDr2SPzhf7ouHj23Ipa2LIvqFWviGJJiDEMHq/5ia1FygHtQf1yP1O6DA+MYt3PRAmDe0AwDkQ6o1PajLyhhaayvkSNdcUoYo9MJnZyxzZJsREZXknwwVrKAKeQd0ATXYuNP1jUtLfXbLHwtGKZT4fjErvqEwYadHWdt4HickIWrApDkuMz9lqCz+0Rx13k9G5t5notB5/Ey1goawGwDT1G8LgPDjH3WcHss8gMYUwQrXIsk3/HJhU4wZECzH5O8KY02Ooo6QZQ191pZeKJjC9ZGgMaIRx+zaNIB3uwtxwANNscRF3jUHAOAT8Dcp06cS7wux31aTwnSMADqWtep7UZ7T0lTbh8L3g7OoT1HIWnqijVXXxczAO6V9csChLUAdRGO8qF0jxpc5OTwTBzpG0nryKIJkudLWmc0XgWoLX9jWzC2eSkLLadWl9PWNuvCCeF5TvkKfLkd4QVjyuEUM2sOcM73FHkPJzZYtyZxWqOlE+NRwYnSnB4ZnYzP3fVIfOafdsZwitSi8KoymGCMYb7wORllEhM2kJiZFuAd8bd1YoOLDSFhDEEUxyLn5hrojd/3m78rosQ9lfY+taX3r8J6wyhSGNPPPLM7PvWxP7G8gu/jA1XIZPmTP/kTYI1HYsPatdG2cqV8fGhkdiPz6eVXvyTqlrfFOYQy7YLchLkx9x06BUnEobjikk1g82ti/4FD8dJrdmg8NSBh0okOSDs4/7UO0daYjaVgY+cATKvrkUFzqDdaoWXfuHoDNNIA1TDAGH1nDMCwD8w5I6ycQVjIh+/6Rrz0ppdHcROMApSJGYCVPwJ1PrS/PVobG3C/JoWbnMb8YeSn8wCdtfUI+cgwrStXYT5WxP7D++O5XY8hAENdPLP72ShHEry5TVfG8KkjUXz2uPa7hR1fLeO1X/9Tp8oJnCeg9EeRlap2Zh4EsOSol07d4Rc1Vb8FAwMJhkjK8fSMYJwDig/qnlC3onN7cfID4kL7jgFyPQzROz/653EjcjuwzBMkMXAqMoG2G8EJ7DgMAa53FRh050H8DEEjXoI9awj781nUmWOHkXTO9gGcr16L2O11CLV5Os4CmI9D4vLszl3RgtPJikZo7VGmMo352ehoPx3rYcgsXVoTZw49H+cmW6Nh5VVx9vDOaILUsHrlJjnH0gl5pBfhGO//O5xmTWBZLL3ruutu+PVHH31oITj+hVPxf/u/MI9wrBM342cf1urn/v9W6MUPzJVgqPpOgmCrrLUdeLLonzdKL02JRZIqgJvKAgDSYkYQlsCRdIl4zmPqZONqwvK5jvh5NX1m4WH4IgyrBdEJc/gDtgWTk9q+WRxLEajlmFxaMMnSS4dtVYYmqcrmrV+l19sLW7yPQRfkMy5QApLeV71IE5Qk3TJfUCto4/UCXpBmpPYx4+f3xfZRYy5wWiw94+wkwDIYkzJkS9QpgPbkVC58ntH36PR4ePdDiMriswoDh9LYdtNr5Bimskn3nfrIyLTQV2IhsJgzXGIVFrQSnjAk8CJNOcEL+0tl83O2lM2NtDUlQOt6+n7qrVQ33k/Qu9BQBFhpE03XI5vjqhE05M3aimzdTww9f+wcqPMRhsviZop6EpAyZKSYT4AVaQmlB2C5CXxzf3IUkV1b3NcAmpSIGKk4pwuxgolpGwsC0v6uexN14pgsnITkE5Q0zgt1TdFA0rhgfXLmWksqeA2CRV4/Q+4EsGiCyEhil1jGRadAlpFSECXEUZFxb2wQz33jS9h/qNmEjnbpqlhz+Ssl4yrDdYf6O2P00BPxUz/x8ugtQvppxONtW3lRnES4xIGBYR2bso0ZJ7sERiY3kRo4dg4PULOOY/G60qivAyrimGD7oy8Yjq2+HkfdkKQUS2uj6pg9JTPMtuKUoLHMDKSM3yuJigHyFJ0/ER85d808w63BKLBDl8JxqO0ppzDbjmpqRNjA5uX5XYZrrMTxsjX+lAG5l9hWORoOy8AxYc16KirbG99hdIpKaFbzrJATpwzT/EG/RQOVbSk5i8Ygy0tpkd/3OmfDS/NALaAeNwD3h7RG5AhLrnsW9Hmc0W4HMQyywTkD6LyeZTs05pgvQmYx+p/xl/V9xUT3uCkcRqlcjrxUikywdAadw7o4wQyWiRxhmeikOdqPzf/ZZ6Lt0mujng50AOStkEcwbCsz6RLrdw7PR3vvqMdvWrslAUuhFDUv8vqkMes9QECcoBvvl5EF53tpnVMLa9y7X7MDaCVDJ3IIcB7yu8lQq6yAxKSKJzse9zMAUfLDxXOxxSQQ1DaselH0D47H337hofif//RtsOnUkcPxDyeD48g6y0+SlZUTfCp36nH3fzJW87iohvPjz/3i++L/Je89oOy+rvPeA2AGmBkMZtB7JUGCJNgpFrGKoiyJUuT25FiOHLnIibNkx1muiWM7UbxiRYkVZ0mxn0tcY0eRi2TJ6pWUREnsvYAAQRC9d2AqBnjf7/vOuTOiacX2e+tZpi84nDv3/v/nf8o+e397n10uvvTK4EbWsfK+sI7sTfM5+mDr9YRcSZ4r73vXOx1kH8UrCtqdb3iTLNrTy3JZyxfIlWWRQHO/nsHJ2Qc+9FH5US8ob7jz9eX6664qgwMDCsA8UbYroHKfityc0snAUAXhsGbqXTzz1GOqOzDswNbwkullhay4c2RdXqJ4I7KDEJO0cKEyhei0YOv2F7wn5srn/sChAwpUPVoOSynY/MSjcnN6pGy46uoyLsXerFz/CFYc1nwv6J8j6/ByP4ehDko57xV4P6TgyD7xlXG5Os4VcP/i5z9f1q5d5Uwk9376LhWD2lvmLlyukwzFtJDjG36uf606bqvO3OaRNL4uNIQ7jZ8VZmwlge0PH0TRUmGhM4N4P9BXEYZOz6wE8QPxAMxxZzm2ufSo8FZOvXB/V1YXvV9z3kXld379N5T+cHU5KD/yJYuWeV/t1gnEV1Eunn3BgZtHxeeOqAgVxjIs4Pv37CqXXrRepx2LbF0fk0EBgweZmB7TicZJ8dUhKSPPfOW+sv6Ky5WalHSYSoUsvndgn05DyJwlH/0DW5+Sn+DVZUhJScaHjpSDj95VzrvhO8s4xYlcGfVoefpjv1nOKeAU8tmw/qKz1117+fsvu+iif/fTv/AL28LNXl4vre3tGtEy/WA1V7j33/71DwKY9yj4E7AMZDJkqELQOXfNEAE5CJgqqLEidACo4YyZerOl19PWDjOLQAvfb/mmq6tn9pNlQoARrzBEAHlyhtEvjkGpnHlWFj1bwhDGXAeTt8tA7o4/dhOi9aEWnmHsAWC5oln4I275nu/oUPy3myCuXgtmZPm8qhOcECCo2pzZuoIgb2OJ35t7xtEd0fXKZdsnnz4XnqD6Z0d4VMuCxj0iprflq0qX6FzQQQTTlBP3sttfa0ubgxQtL2KNtuyg/wBc9akbJUYMcFw+dT0yVU3Hn13H6GGCzFksvzk9aHpHxFdGwBjiykTj/mWpmMWaXKc8PH66WTuen/kC7GHpS7sxhgLO+RJfXzFVLH/0xJlYeLiEMqnB+If1hCw2Yo68xw+SOQuozYA7hYDcZqUH+sCTfHoT95HmXhKwFfcSgAfezWebG0UdV1M22yhz6sYEsD4ROpknQDWZL0JvtHbW3wc4duqA2iofq7ABFUJIz7TN2G2DRtKtFkaatVXbAuSPf/pDmocU6xhYtrYsv+p2K6ks5bDA2OnnHipvfNNt5YyOV+co2wGVP5/b9JSOqFVciiwouo4cu+SPJgcvwPzEMfneqt+LB7tk0UOmiUbUE1xZxhQ02S+hPKKj3RkKGuPltWWczAFuC7reBYR01E3qPVf/rCdV41KcSRUXH3OtgaxaKFrjpD+05TluH8QQBPBImNrqOQlk2T+jo6cli3GJYerNOAzOw2dQwvD1JecxGRviG5vUhXElGZeA7sFKGgZW95A3Ut3XoVe+dpVL1s8Ai/SPZHNp+ysKhwNcq/KYkxaN2VZqdzAYUP9rJ3/hFSgJoQkaJN0gwIUsET4tQ5nxuPMvmzHP5z1gnfZT4bLyB7sa1s/03L65KlJDxcvhozqOJ+CXW+IaQ563CVWbfEHW3e75q8uK1avLgPhm10yduil+AwPBZonHnYfxMc84suBYHzsmDbP3sIKcItjoAl6i//qS4kPEMcSoH6MIKSGZXejdFnKAuIB5j1Mp0v9qvUdpVJsUaZkpzcWean4gt7OT6RexCvA3AXb9iZsLQZgU8Hz4hZHy0LNHy2NPPFG+9KmPut/nKfXd2vUXKpuJrKOcUooXIjvw0/Zv/UB7S6TE3nT7a8qFG1Skh9SclRfkFLTuc/P0kq7EiwAAIABJREFUUF1cmzhZmij7FPj5y7/4b+1bbC2i8taNGy8vl2+80CkvFyszy1yViF9RLef42T/y5NPlIbmOnDg1VtatPq8sXybLq4wnWJGJBaJ+Q78Atnm1Jomc5U4rWQNXG8BllnzyRFc1l+TUPqQ9v+m558slys6zds0qK0/s6VMCjSeltNzzpbvKpocfK9fcfGs5f/35TqnLycEwVX61h/sFwE03+k+l5q1wwzOw2J+SAoS7zGkBydMAXQWZP/boE+XzX32qzDi6Q5mYFjmQGEXK6XVwPyV5g4wBrlNS9+w5yb8ZSgPb1Tvg50d+ZBt5PzLH3XPKxOxV2jCyllcDlIE560IaV/pY17CcUtXRIZ0YNaxC3Af7WNcsVrrKH/+XP1be/J1vlG//nrJZfvL9M/sV6DnXmX5GNCZOuEbFw45KVlKU7eDhQ/aTH8carz4DouFzgPPTo6fKC1ufVz7zo2WP3AVPKD5g9YUXyBChkz31+4hyxfdJwSEN5TmlRe6av7HsG56twOP95eS2RzRHK8vAmkuVDhhDlOLIPvvbZUTBooxxQMHKb3jN7WXV6hVnzjt/ze/uOH7wne/6uXep+tbL5yXalbQp36qfo6LvT/+/GdnLP/hTriyyNrzX7tUi7hzTVwBlrZq9U90SLGACxoAW3kj1/zDsM6SOqubIDnjTG6wqtXmDSIMACy6jkTA9Mz+aj+DlQoSYSsxYWcAKgMXvnBgJfntVCrgHFmpmUhF0fkhlrK0f7msFkX4izKKiSR+jmymkT7knR2wBBnxegV9tu5WjjzWcOckALKfdPl1IlhE+w5qCBVtn9FIsZPUGlDvyiWnH4lplkW4cEQPY/FVZzLEe197M6OorlwuYN+tme2Cz3hsyVsvNOeZKvnpnnMccpk8wWUpk427QALkBTnwILJRbgG4WwgPxq1kt7XmN0PeYmc+slRmr20VIRKjThgGEQUtmtIGX3AvjzjMcwe8lp8gNYwaYyxorcEZaty6CV6Vc2Ee3WkYMCaxY0DYBXlhg8xDjm3Q9wN+WMtabT2JxzxAryPHq5wg2wLxRDbQX94WOoA7VxvXCy569kdOEqScwbV6ZijzbWEXzFC9dph0lpgIAdB7/844LMJLweeyzH3J2CeZm7tLzy+orb4qCogbHlZXj+Ob7lKbtNWVM1jWA+VKBgGeffKoc0zG2j+oJupP5lEOmMVV87JmtrCwnJZAEbhbNnSb/fdwKUNoCgEaGzyqbhNKKKaUiQMmqOvMl2smJBBZlBdYpUgwXKQS/S2jznZ5DqrY585Vr3/OLtTMFQ3AtScrOZB9xVh0UGcAqAZfRTCqGniYL1EkBhcRTNMCYQMQEZbJe7C36wtx2qZ0cAGkixTew5BOb0AJg+djzm0XzHMeckMI40IQzoQAiGasvqYvsNascCpoxzbtjng8HCBuk6l/1T6+Mw9cG52Hl9qYwjutU92wxC/AvvqdOiecplvpkyorrCNZ89xlFhtMj01C3XFrWeiSnDr+g9rUejEn3KWLAyvGMaePlyPMPCgzKD/rCixWMKfcRndgx7ueGe8oLByiJTifp2KSCxHwwuR3fdveFjzqqhE83p0nRxUUmJ3uNB2TL5CSE9UkmFsfxiU4I2GtVgKFT3GLI1Q5Ax+/ce8MjzD5pp2HtpNO8QtZMQPrI+PRy/7Yz5e3//CddXfmmO+4sb3nbD8kSrIJ0uD+YV1QDgrsYvoORw8YM9hrtCYRhGOA78w8US61Xc3lpawldnDx5tPzue3+prFymKpYCZHv2yNdYr1lSku58/Z3ac9qvypgyR9k+FkhRXbt2tcEurjoDcwZk9T9YPviRj5Wdu4+4kmeXlKRe+ZSTGWS2wF2TTSPqv9mkntltH31+yEVOJhOUXOY0yi4KyCHt+4ceeKTc+Mqb5YaxUnuAitkBnvtl3f78J/+izJw2q9z++m+TJbzffIYTlNRNSEG/piSzf5DBzN0JFcbbK/eb9Rdc6P03JCPTacWj3LtXLnJ7Ngmc68TmwtvKyek1tzlEDnhWtdV6/GH+Uk7tKN3Du8v0vkVldKYKRDoZgSYO4M3+5pR4OiddwRdhh5WXVuyRz8OvyvD+Mu3kC4nZUp54eA77wxhCdIVBZ8Xq9eV7f/AHyptee5tchR4uf/qRT2sdWFspiuKbzKmD5KWcDcmt5az63ZQw9iI+6QcPHC7XXn1NGRWgPqrKtNte2Fo2P/aILfNUOjZNqTuzFDjPqfY8uQYVnY5sPtlX9uzaJr68vuzb9OWy9IJbFJQtWaU29z7yF2Xs0J4yqmrg50R7V19+eblSuebXrlpZVq5aPjIwMOc3Dhw78Es//MM/dahuhb/3v0THHIMQDHqv5njr33ZA/wCA+Z1v07HS+8Ku2jEUFo0ws0CWCpbZQZa4cRmxd139OyIu/rRnDNzrnqrsNaAowMNCrwKmJu8MXusqBehOWgkczaljKKw8RNA7mBHhWds0++dmrC8IPguPFr7HHq6+z5U5t8qf7lHj/h3wVgWwOxY3CzoGHLNQsHCtFvWOcI5A6swFnzt9O2aeQD7mhSwpE+PKhmCLv0ADwYzNYlb7wVE2ATTP3PsF+RhHebCAUwaXK+54Q0B0Y0zuc9xEjJnq5wRo4dc4JisJR7xkgOEanpWMEVOasCStf1cQADNGoHbWyVkx6gCrddC27vpQW8VdQtUTVeehWhWZPBfPadbr5P1tc+OUcmrH1kpAD8fXOjYlpSTuDBP6mSkf0W75mJ/1OXh8eEOZAIesjUkzf9ZlqP136lSUltAczNgr7HWMwhXFq06gP86E5LPm4AVdCYAIQDqVqC33AoaAsvYyPdQfcra7EcBV1sg9tmJTUz3Sd9ZE7eSTACrn9paQBMw++Zk/9xExvokLVIJ9yWU3Ko2ak9aVM8f3lSOb73eqtXOyDi+Yu1DXLC+bn3yiHMXH3BIda/m0Mn9uryxU8qtUVccTJ1B3VRZcwJzvqMrY/JNHRiYEiPtkaRxVpg+yJ2Rw2ZOyWGK5JpsQLjIShgh9AtIM7DkVkoWyX6XCDSZ1HzmBXYRDli4ywVgxYZ+6+E2AX/YnVzdCBCwMS1YP5hPPK9eE2didwIIQsEWmD6zmibto+efHFZ/QK3eNjkJm1yL83RlHeF2IBrKNew2ZaVyGnsw5xm5xq8KSaj9z7hGdT+AdTIEhQHmOZDqMBD/qs/hhW1ELTQX353Qt6TV5BopJ+kKGHk8zf5NW0hbzapmORlEVGM21y6PXHPHQtb6fpeC/nv5FAqXKbKKc0DPg29FP/KJ7eE9PmzhSnv/SR8u6G79TmOl06dex+65zA2XHfgXsAfZZC7eZpQmnhhZ5X8fkoTaAXnl2TZvoIdRhwOnZYi6k5GUmzzRgkvlOKkXjeJRH3d8D0MQHXrwEl4PENwASY3jxSQSsZAo9RE9MmjyUhxf2HC6//BsfLc/snig/8lM/J0uwjBM1+Lgjf/QGJQ75BqBttG3eMSkMvu6959DkRqYk9qWydxw/Un7vfe8ut9x6q/fmMQViPrvp2bJLRWn65R5y3TVXlfnz5giEz5GLRF9Zu3pVWaJUhdzPmOcPznd6Q+47fvKETklHy0G5jeyX//uY+0zWn9QWwFqOdRk3F/5mTNBAtkDO5ojJ4QcL7+69u+SScahcd921lpNzBHo5lTolH/SHH36g7Nmxy2B1/YUXOlMNKVLbnvJJdbVS95Lz3Eqi8LL6t19ZXJYsXGwLMq/TUvSfPj697N21r8w4sqXM0qnM6f41pl2/cDuR20cIKLyojB4qXcc3xyq+QMG2nHjhkiLXFudPRJFywFQHDaStKWsTombx1e6IAmCPy+q84CLzsGnKbd49csj7nntY016B86VLl5Yrr7mmfNd3/KNy0QXrypj22WH17asPPKqxz9DcjjmfO9byMyRp0F7iFAI5inJ3UEG78+bMV3rZBT7R3iv3l81ybZmlYoGLlXqSE6dk1CLbkOZH7xcpGH+7FN+uxZfanXTv4x/XieaV5ez8ZZoSZSLadr9OkIijGSt7n7pH/T5dbrnhFTphWaITj9XlwvPP08nGutPHjh9979adW3/5B37gx5Xz8+//S/L+TRoFVdw+rPX5y3k1/xpD/AfhyiKt8r1xKsCCV+VDtXY29twskHH1wKIXANSKtHjvdCY0gjZAhC9ysFt3GJ92rjScD8+ttsdcz98u1Q6xI1lsdZNmX7MtxGJen2nhlU2IpyYYMdLMYsVgKEWPEOSx7EbmYDGNT3FcHyLEeHGyS1Q+lqoIVQRtHTTP6jwdYT45JHeVpzakDHhAcEgQjSjSHYs5ZZFnCJinYiLCmTYiyOkDx/jPfEXAnHvppoWhIuRve72zknQs9J7fMCBnEPAAAEgCbWIowzpmJeUcAKqBD7Px1mgVRlHAqr+1BTJ9aYKqgdasYdYrgGZyAerEtXngEk9EsyzywOoG4nmun6vrxNdidfWn6gcW85yQyBqrzAP8ON0j7ji4KzhdW7NoxlrdmPbkvEwGFLub7g9dzp3xfM24PMMeDoXcs25xneAHxayqmJ39kGuhI6fNqwLDqgwA3wSUyArTSJUvtcehUwcBxqc4S5Gxu61Ku/jVnpkYKk984iPO587Hc1deVJZcep0FsK3Txw6W4a1ftSvLHCkyCxYsk7BbU555/DFZzI9ZgeD4Hx/I3h7tHwmaRQt6ZD3DZ31aWTxXLkIVmJMakjUdkcVqjvwmh4flOy73F88be6Cm2gOcAKoBC7hCUDIdQQ2wI2hxSMrgPFnMoUECA8koQ55g55Q2ElNWBgAWYJ6xY+mGDmwIqFxGX4w7+FMp/jw/k7uN+UOoOf6E/eHAU4Bz9c/n5AQrn6xnM6XMJa0j0xoFt5NVZwp9B+xxf0rRp+gTA+ciXBzqnvF60U8AO5fA5xIDwymIn2Oa11yHm5ipOXjbym3dNPosFRyhCvZvBYgoadU9p1XU7CZw1n3P5grdhk/ZzGFrOoGga62gnDoikEK2CnUGa7JjDMyvpGZoPZZMl2vD3mfKkCpDzpR1d2L+0rLjyEg5Lmv6iKyIwWQB6fwE/3nzmP15KqxI5PQhVXMnTwXCIbK/vNzqnAsTiQYZf6sYmiDgXNkqhM7SWNE5Z8nn3NVGq8tLZdZ+th3Z6hp5Pu1Oln0LTTIrm7buL3vObVAGFLnyNO2EXtVTVWfAURszSblbX1NBOR+9GKjnMuReYmNOKwPKr//XXyzf9d3fW2bLNQL3mB3bt5T3/97vOePKCqUYXLdmpXy1+xWzMWA/842XbjCoZ+1nK/hxkbKA4CpCHAaGCAI3h+Veceed/8gAnqxKAOpxWVcB/x4L/ImFqOAZmiNY8flt28sOZQw5LmvusPr29GYVWeoelL/0hrJgnuKMtE9Oyxq8dfcL5Y/+4I9l9FH5eeU4v/KKDZpXAX+BcwgY4E+buFrNJHsYcwVF6LlDAvbDpyfKZZdeZAV9lvjytsND5X988G7xFhWz04nNxMWvKyfP1XklXaUyw3iDe2+zH3QCevgJpxidWPaKgHBSWsp9J5G+uSwviC1xWI3HdxasrkcZVRrNw5tLWXqNMQJAvfuo6vnUTF+csq6Q280rVOjp1htfWW67/bayQhZpeBbzuVX53XX+YFon3STj5+QBFz3PtQK8uY6d+oX77ytztW+uuvzCckwuPZ++567ygd//43LNpdeUy6+5Qp8pkFQyHn9z6GHZYu2tUz3lxCCnDNPKgac/V/pVc6dn4802Bh3f/aTk36zSt2BhGdr9eNn1wOfKhavWlI2XnK98/APlgvPOK9dKmZghPrxr9y4Vdz357osv+45fuf32dZrYv78v7VX5KZVb9fOY5l0Vvv7mr5c/MJcri6osvjcZBLIHzJSqLLKloEKY5iAQgBZGVVllsJr+bEEy3lsGvwFD+FU2hj+57QKAJm3oAScBiggWNrM2haySALIzsjZPV2Q1aacMcDpAhmcBHqpVsgL1CLIqZOlFE/z+tMIyS2uEPFb3cAQLX9oH7DKINi91TL6lIr4Ie6OXOnkZHZ83K7CP0yUISF94jvLGiorHZ9zZHKq1LP2JYBmV5vy0gDlCx97IfkZXueTW18eNx8AwHsk82lVSLZxiyWfxAOakbJqp9GAzdGyd9GwI8rrOBgX0O+Ag8xT46DbqkPzJi4bXAG4WPdZFAwbrFsxjhb8mj9Qmtfy2YK/zVNu1Wa8dH2u8AHNKWMNQx3UsPS4fWXLJTkO5sMtF62OItNFtSK0qTh4FYKdlmmHcDSPj8x83gFAmneJeJjL0aIZs14SqjDE7nbaBBrZ5BmxxswEXD6hKYLUuMk+2llZacHsCwAlCTCClAYznixZSfh2h5ywpovfHP/1h/VZshS5YtOaSsmTjtXZlYf3PnDhYxrbfW173hluUeWBuGVCO4yXKnrDpiafKYVni8APHGj9Tnejr7ZLAHi2LBuQiJLrAQEX56C7l+sZiTkowlijAfKaOdAUWJBDcM6xmkAR0bCsyFnNcE7DQCZjbqsb+k08q1QQXzPN82sfVcRIULqI0NnNBCkaaTLEhT5+BI+1jTYwihO9un4I/mzU6rjb1emUdYSsDXpx+DUubmU+szLiA4dvarUG2vWqgWQt11S2djeqzA6zWYAcstHKlUAehF7ML9zmuJY03mkOwYLbS4wKAYsCeDE01XdHKsinF0QwJaq97y5bI7DTndPZ1dQ+7kiqUYVCbk0GnCrWln3VKu/S5izmhzz39SouoQNAzw6oIutvf0xcrUqatjGlQzyUrxZzpI8pJ/WQZWf/qclonKWfOjihd4YTAhc4DlLLQ5MxcGohmt+SEIn1OPv68h0bMorCc81RbuaWYMS74P0ptdV3xZ/A8Pq/jjg+6fuTC0kN1UOmdM/WeQ4UG2qswqTKm8ijfz4OjKHNNDCLp13MHppWvPS+6V350XlEKcOlLnAoWc8cm5Gu/OqeAdZxu3usS2RAFAN/jsfLrv/Ifyx13vK6sueBizZkCN+Wq+MH//Qfl+c3POpPHxRddILeUPlnN+8tsGUjmKOvKqhXL7NJCFcqFixcLEMfPu0fAnb4cUprDhQuWl6sF9OJbrr0jizKnXVi2GRsVfJGNtr7rH6C90z/6WH3SH9HJ2V1fvK9csuHicttN16kfSo2qa++594vlw3/yJ8rrXcqbvuO7ymu+5dZ6whI54j1k5TbB1VjLmXgs9Tv37i2bt2wvN8saD384qv3+i7/2+2XH8zvLnNNyU1myvhw5tyj71u4s+JFXi7lnUPzikJJyoGgsvFzEI1nOdfKxNrDWqXKTrdHEcnrk15Q16SyYfNaLMrOUJfKOkPVafihl+pEnSvcYFeBFdzJirFQg7mUXX1guv/yyctPNN5aLpKwQ6Mk49ylAdvjUiNJSHiuLZFBAliKDPMf1tIK5OCGDw/5Dh8tnv/xlVUweKN/+xteUEaXz/c//9T3l4I4D5a3/5J+qxoiyUcE7zIqmqziW/NGPj5bnR/vloz9RTm5/sEwc2FfW3vH2ck75208dUsad46fLgjXr1e3jZc/Dnyyndz5frrlsY1kqF6l5Uvgu0anGuvXrxI9PKZj3sLKyLdu+et3qn37tHa/600mq/fv3TvT6evVai17+XOuQ9HN/g9fLH5grK8tM5TGHmiqs9QZoKQHt/iBCY/NncwSlNftpmGCz4uh4sH7nfalv7Hvq99XKwqaHcCsU6VgqpjBHt25tFSDQcuRy5KZMEWIOM3GYtRUqgjBYCoZfrVM8sGPGbgw1fXfwqTkskifDiS/hVOvuJIXk+9o5hkIbHjGft+siBjvz0GSD2w0zh7WM6ciSymoUHZA/QvxM3ddJ5s91w4rU33Tv3bbMuKg4wllA7uJbXusgpcxZVsDBSNWa24JCARfkuT2jam7dVP2TD2OCE3lOnXnQkSVShE4DSa3loMm6ulzqOcv4G8RtVOCvgkdyTQUBXBqvDS9QhGcLpjR18B3EFYuKhQ04UJfjT0kg4ci4rP6yzGKN5dSCnwClepLRFAz3Kx3AXSABn81OHSXr6xl7Xa9Mf74zbRjy5M9Go8xOXVPn7/b+yD2ZO65Unyo9EQSauWigO6kFM9+A/gDIqAfMHVcnnsAgEWUJX2HlC35YBYaci1n3LV6zsSy8+Gq7JiFAx44dKGd2PFxufM0tymLQI4G+WFY4fMzlyqIgJgAqFjcCu2YrNSLuKXNJlygL6fyeM2XjcpXjljlzyEAwrl8A8wFlaxkSSOvWPR6owZVVCBfVseuI2p4l95lhrVGX/FjjoqMAU+VAnqugt1TA1L1SpHH+ID+xXVlYFbu+YBWFKvENz/G+rZ+2iUrp0HHyLKWfM6kbrIe2POecsBgwJpMNvsJ2OzFQi+Ucn81uKXReXJFXK5YUg4M+dKrQKGC5jyHFYo5LBc86K7elSQuxSwjFjYR10hqzTpRVzykLdBultGMZrxTUeJHpJpvIIBuwOslHQxOmJIQ71KHvu6GFdjqYbZR6A9Z082OXOP3uoyKoaGNU2XpcLr5zEhPlnatn4+YmhW2x5nbfvq3lyHRZzfuX5VRARH5GwOYkwYLCOxT7yekGezc8bOqplIN6NY9jbNoKiHmGfen1wg+aNJpWTuHNlf967dl35kFRaLCg41nSLUsm4JzYB2dzcbXQumbZPtlzzLPnMgGpHUBtfA5tpA8U4bnv+Rnl2f3qC/MkmgPs06It5lVBaMx8KjCfCshDgJUMDd7Olt/+9V8pV1y0sVxxwy12IRmV+9WzT8mH+fd/x37LS5QbfN3aFeJfqjYpIN6nLEHkXF+7Rin4lGObz/rlbz6OxVgvKt2yT+59+PHyEz/yo2WH3CfYmQuVQ5zsIKOq4wFYB5DHaAWmTYrMdrpsLqivqF6P5feAiuL80rveXeapavC/+pf/oqxaudB9f/8Hfr/cf/eXlUZycfnu7/mecvXVl7kAHny3yeTEGDCfcES565xQ8KNK1T/5zJNlSAHDb3nLt5uff+DuB8pHP/L50j+0rfRoTU8vvUo8RYGbZJiRlT5CsBlNxD9kMZ+uWh1nBs7XoDkVQ8PUWlguEmSNywtYTQ/ndJDfzVIYbp3PLDv0jP1KA77oMlkawHl6jR8rMw48aI7GWPpF6xdvWF8uVqDmtddeW669/royX7UWoM9RAuyf2qSc/4sSO4NCovtQguAH0MNzck966plN5aGv3Vv6FB82T26BV1xxXdm48ZLymS9/Vn77ny2vuOyGcvkNUlZEU+6W2rjrS19UNqTZZfEFl5fHd58uh+WL/8JXP1rOv/4tZeZKBSefkCvirp1l5SVSKgi8P7KjbLr7j1WRebqs8hsVMzRbaSznqaLoMisLx2TYO6zA/W/91v9Lmuv0r5weGXnH973526SV/P17aV6lvRUFzZVntUYP/k1H8LIH5tfe9vrv6+ntey9sjg3SXDomJwpRQU5xf1tdXSQ4OSKuWAiW7SAgX2Fe6VdKnHP3pCU2uc2Dg3ythVFnq+U9gs4MOOneIjTiygIwd15uS88mnLJRnX4ujUbgVUBtZss+pn8Gm+1Mtj25MvsK5g0sw/YDsCwN0mfzCIODWKvrIDoGc3/AdxauySaQQYmx6ihwQv2fJVcWLMII1GR8AHyHd3HXKQXabJZVg/si5PzQsvHWOwWCxKgsBDu//ACAGho+7QACKdU9oZ+ZYkqUcHefDQDTVmfeW9XLKVb/Bhb8Ea07Y0MVjh6zJ7P9arzbgKUB9wCMpjw0TBX6SNabKF62AnIyi3Ubpmj3kFi1OOadGFN6SVl2ZyivrZl2PYY2TLAFD4Uj620B7XYCIvg8q17jA6zApHR6OpLj9rbOwc3Vmt4B+hEEVjLqUoZ2yYDDfgjoj9W3XgFYywgNUJu11UBJYMcgUZd2LKjOZS1gaT/oOtcoKvJzfOQzH/ZRNxbXJeddUZZcKCauXMO0O3p0bxnf9XB5/bfeUY6PdgmYLy0L8TF/Wmm9jh6xcIGhd4vRz5Z1a0yCsq9/lrIEDNm9ZPWKfgkoxTtQDU8bHDk8PCSL+UC3lEPl8lVxDnenglksaAgrBBoAncAp4iEIWGvK3agyYcyTJTDKk2Zax+zMBCDBJwMG8Pqh4i0AHau6fM+mzWCvs6ewYOo6Bf12i3Y9UdWy6n3LGkAvdnMjFWRogjgHqzrV/Qs6molQb4pkpZssNoPKWvlkRH9iscW679SL3nOhrbh0mPNVK3oyTwDyeOGu06y0+KZ3Xo1YTDxROpw5wowtykC818IISe1qdxyNC0sx99gd0Lwv7gThWwkcy2lhwHQLTZ2J1XzeUs21qv4qY08onNSJeS40Ss5l3G7mak/tOnywHDigojQrV/tZUQiyJ8blRnVCyhn+tzO7pNx5uOGGBHHacuzTNoFFxcIAaIjbs3UdGq90D6nP0MlC/LrDZ00D9K0aORpQx+8cl5eZom/cr3rkZtU9k/SHGmE9FbEyZSWjyaLMFdMafBuXIvMt+ICzCKni5vFp5Z4tMlhMAMy1f8CCFNCyzMhcxjjTVnDqvp1c1/SfvXK2/NkH/rAMCqjdfue3x/cb3/Njh8of/c6vlr0vvOATpQ0q3T5/3oAVjj7xfSpd8iLV4QKdLFEldEjpEGfpmKCvP9lYjsk6u3L52rJizfKyd+eucoEs3qQ0ZJ5xsWCu7Ttf5UA70SatItb3zc9tLR//2MecyhEF8qTkCfnPF4g/vPa1ryvXXHFZ2a/iZL/3G7+qFH9Hyoq1F5d/ovzrS5YoZ7nmg+xBHo/mj3lk7tlrDz36ePnUJz7uNLbImptuurlcduVlchk6Vj76uQdL1+mdZcemJ8pZ5ew+1KW01eqP0xpOfaGEH326zBiXLOxbWc7NlNubBZ3mBcLHpUX52cth+Y7bkgQ9ie6l0GgCo3FYJOp/mhMD832ywONjPhusF6ovRzeVrhPbTcusLwG3S5csURGodWXjZZcppeH4XdULAAAgAElEQVS6MqD5Zg6ffG5Lueriy6QDoAHWE1/o2yk3z5Xf/MAflLsVMIqyj3vKG9/wujJXAb3E0uGycvT44XL33feWN7/5rfLdX+o53LZnZ/nAH/5PZZE7U1auWFe+5Y5Xqa0z5f6HvlKU7rwsu/5Nkm/Hym6lbjzvylvUZ1JBjpSj2x8r2x/8nOJ/5paL1q+REjDgIF7o7bDclI6dGsJqXvrnzxWWODsuPvcfju7c8u4//dM//Vv5an/94vz/+5fm/tV64lL9fER0Lw3ur/96+Qd/Oo85FvMA22jiQZxhUmZx5L2wQLG1iL0C6KxcLIVZuC/Hsb7Upp3kaQ60b61mo4S50mS1ZoZrT66M3hqswQhpl8AyWSSmk56NTVrTJTqqmyssTNlUNFH7XgG5YZTbjqWzCUiD5yoomxU6nQ80z6syBwO86mbDfe58nad2Xb2n42ZSGZtHLtRz+vRxWXMFeGQZmEH1RgNz5r0yfo9VwFyplrZ+9W6DMYLJmNNpOvK79PY7Pdbwqwg4+pApb2PU35ob3GEoUKQc9fFLdxaHCBtPvAMmaaPOewW3k1a9fJdTjzbW8MNYNTM/OfrMPBg3UEmT+augmLFZEasAr8JiAxFPX/WbdAgkYNTBhPLrFWjD1/6sLP/krZ/GmmPxAtTZ+h8rv/uY2MUKjqsvbyS/++h1i5qYflU6rtNW1znT0ujUoySA2MG1oeMoFDVLC1ebhhlcrM18BEgSVKlxC+kThWWwPrpLADJ3iuuJiUiGFqyJjT5TKE2gWn6MT3xeKeBwzQCYX3CVKu7p+NcFo2SZUlaW0e0PlO9+y+vKviMC5rL6EPz57FNPlVPHj8oaJJcP9ovmp08BtEOyhA4o48rRI6TsVAnspQLmi/DDxiVCGSxEL8fF+LlmSEevALCO4xBkIqudTzSqpbe3d459yrt7416F+9CYctjNW4QrC2sVSx5p0yaUa9sZjzRmK5sG0znFsUW70l+oSuslUDET2tW84AbnvNk8Q8QkfGKggCvRDJ084cPsemB1PxPTgWWxxxZz9mpS8plDRScyDRjkcZakz0jZjiKDT7djAKwkVSt25TUoYcm3n/5C1OyqpFmMQhwQzf0hK56VuJZxu+8QO+BgcPvso6RAE2yOVFl1hhq7fQQgEHjaTrO8F2kQevA+iAuNU1D6OcImzWp+bL8wi9wC6j5plM04oblBAaDtKvd+4uCpclYgkJ6iazBPHovnBpcJWfK07rggdQmgj5MJRYpUKD9pTs9oTH2iARSxERUHGtMC4d4Td6YooIBru7QwbCvirIEZgMdqn28I1esDEBcwF3Duk3JIrLx91NUO6+pZrbzXtKL3zAVg8tSQ9sUI+5ZwHuILugRuFADYl9Ojrz1Xyp4TcWGZibahDvHcxIxMGnOikHlxwrymyAMvra799Gc+UU4o0PLb3vI2zwE+yiM65dqz87ny2+99j/ftHPmXX3rxBvefbD89AueAdHg/RWyc51zXzJYryxKBdAxOjGNo5Gy549WvcuYV3F2GpfWMAcpr8GdcaiJzHWau+fvxn/nX5ehu8QROp/TN2hXLy/e97R+rCJEyHPWpqqZTlzJuKd66hv19z1e+VJ54bEvZcNm15Yd+8K02GrhwGJb5akFLPEQpP/vOfyfgvcXGkz6d0L39bW9V4KOAKF/qvnGB8P/1J/9LBY0OlRNzzpe8s7CYMneZt2nHt5QZQ/vKRLfqHcxS5iWfDom/K+ahSNlXwvQA86oI2vcc/yYyt9AnFhd5hg87BLbzoVL6pQgM6qfJNwD73vtKl1whoWl8ygcG5pYVyk/OicVqpZOcqzSH9H1IMTwz5Ps9b74KLHH6VvEJ9EDg5wOP318+8ccKwtd8Y1Bbr1Scs+WexPUeoOb+8cefVHXV7ywLlqLcTCuHFRz8R7/7W6r0TVrSWQoGvkZuhsvKLlUb3fzc3rLhjh+UcfNM2aq2L7qWbGsspehYfTm6/eHyzD0fK0sH55Ubrr6irFmjHOwyfpwSr6Wi7QnR+KAUO1d29hSfe2Dnnm1v/ewHP7glXOfvx0s0zAQqo0XZrnW452/S65c/MK/pEpv/JpPTjj0DXGIdaFZkgwfPYHVF4G+Yv3FJBT4m1wBv7rNA+frt6Raqfb1auduy5EnjCHSEL3DKwFQbX8fmZPGg4IytlQZCWILTGh90XGNqcwGt7OXYnCKomtUFdxg2eu1NBUdhyNUS1gCmf6NEtGP3Ok/1Wlugad4Poyvx02sp+ZiEEbmoAETZZDMEtC14bS0PWkhqN1138nDZfP89UV4Qbs480VsueZWqPtbxuDjPS1CyI+oB5rJkUmSIFFzTOF7TZ06/xhhqI4YYSEqODq3UxHodyy+4YdI65Tny+CZPPwAwASUdpwyvetLaxSoYeqn044OKRhdRCEhtRVCaiwyR9YCCNALl5K0fweovZawHoU86LOesrqciBtfJkNIMK26Z/OhWWCLIsyjNpgSCr8jAI6lEWU8SbG2vPa6LWGcY/96IwIAsL7DbnqhtR2HlWRClBqp0JtYL9FPL8vg7u0D4shzzA82TtacqqlWpwV1jTOD68bs/pmwaXHG2LL3w2rJg3UY1f6bseuKRskSFMEa23SuL+avLDJXFXrVyZTmzcJUs5k8LfB8OAEIYa6C9SkNHgavZ8h8/rQJDM3W8vnzpHFm3sRphBWXtldtXVpkB+cIePKFjbfmf2xWNQRgIhD6dOlHrRnYhXFlmK+vEhJ7DWpyRb/rgIvmGa6xdStN5lgqM5NNG4TLo86IYmJj29YPS71L2KGYAZv1Ne6qvYJrgFMOAwcobNOlVN89BYXerxIiA0LPZbdGfIdrvVCGu/eaK0EtiNGgVesWVAmDhLCK2kNemAPVYsiuvIXMLQGgm1n/fP2l0sBUdbO5TIPYWvIUbmS+yrSQwlZcD2rlcv4J/kpiTb53vHHoQj3BlU/cmABHyYmzhdbH2Zl/DSzQOnSz1zl8hJUogUQWGnNu9jodzl17mTPxgzoy+sumQQNxpufwoe4R5UBi7+YPHXwEpdI/xsHN6CX/mNMZlzgHGmck2Z94C3udpEAwFKGWeW7rEqK88IuObkGIS3pGYgVEBUQDiTIHH2X0KluyPiwVZfpLeEFAS5d70osaGhpTG8LR+hMkA4eY9um6WTk56BMJ7+5Kucev+8fL0Qb2XgsuzUMagr2TyitLVAeaVDtqvyVNYgfwH7ivPPvC18pYf/BdaN9LqTTh7CkaRL372Y+VuWZehcSpzrlO5e7J1AMpnif8DjnkPIGf9Oc2iPsc46yY3jlPD4+X7v/8HdGolv3CNw0GJ5o2ZZ88s/BPDB/tSPPw//fK7ylP3yyvAcyLwLPq/8cabVOhoQdkty/tVV19ttzHmjOsJGn36mafLwT175Ja2sPyTt31/WbFyueUWLkppKO54KNh/8D9/p3ztC3fVz6ZJ4bhU6QLXlGUC52RKO6YsJ/sOHygP33t/Ode7sBw4s9h8eEqHWaky/eS2Uk7KbMzKU2jM/Fd7bJas53MFrpX5RWb+QAw6y1EI5WFVVMltEZjZgDnK3F55cwjkl/lyjQkB5+cM/udPlK4hZSrSM2ZLGV0sQLtaGXJWKwB0mXLIz5avOYrxkcMn9dglkcnmNQoG9RydKY9verT8+R/9Sa1KrSxIagcFq1drx5qQQeuk+rt2zUXlulde764dOHqwfO5TOl2QoQP3oPkK8OwTmD8tHjw63lUueu3by4SMWM8+dHe55Lo3Si9JMgCbDwTOTx7YWvZvfVS1Kg7oZHNJWb1SBaQoTuS88/LcUQVZpscYQ2M9NXyifOGTH/+xYwcP/vcXkew39Z+SpRwXrNbPX2gcf+2iQy97V5YbGjCveyAMOfshjDIfOINu9mml/Y7oMiNrgU6G1WLAsOpaP68CzHZ9Nk47jmxWrljRK95h+0JwtEJqtJp1AZCGBRAG1sHZFRSaYRrk5jmTAD3AIiC3igreG0SxFcLA2ytqAR/p/zaWTgr7uEpkAgK4872f0JqxCaxOJld7zmIJH5ePuYG5fA3JymI/ydZfC+/M8emTR8qz933JR9ABiBQF6SuX3PY621fjjZxr8+q8yfPU9zMKnKQwjVMzSjDZtYBnVP/KjKrNTYBK/maMzGN8F9tUBIxWNw+uFfjMuCvwbuAW8F3BaZ4xRWBX1xYDs2p5dBYTLCKmueSfJusHIIfCFhOjysWuMcyQn3xMevrx+knZwNrGfNhSGpXBVs06Z15iX1vPbAw+2hiqdczzZWjgvobqAW+0FSUgekbGaUWwboJUDWUdYsG3Vd30INr3/uGDmsovM2nFxIOtFmBb1Jui1FEiAHZny7CsLpvu/rgFAgJ15UXXl8XrVKBC158+sEOWtv5y7Nl7yuveeLuAx0xbzLsWrVW6ROUxlyuLLV64BukHn90hcfTBOb0qjHHKJbdXrBoUaBB9+CQi6tPxwyoesmSunn20hoOyn3E3STBY/Lp11K3+9fWrrLaCv/rkaz7GPpWldFwW0/kLVaiEdSLFoEC5Uz/KQuc0gPXlk48aGRvwCFTLvmReJyTAejhqhk40XbisMLOMyeq6TzIQ53HrMaWZBnlFoe/W8XjLqBIXlequwCVe91Bnc6VowByloQWKR1DXDDu5zWCUJ6ZwSp5meKlrw8+4MP32qrt/qdaZVHRRuBP0i1IKCYnmdZ1dWeIX6P3GnEW5CN25XgS54/1RFPtGtWGBAqDzlruk+cjxvTpKV47yDn87WxTyZgHf3T27PLNna9n0wsly6SuurH2s4/L+4cfkY7pvaSftF8+RhWdCsQP2QDOTM22cQSHVN879rZ/ubirDaj+Q5cPxMbjFxK3Fa617EnZMcKEyfwhcn9HE4SLEZzPJbY7f+SxZzlVR09fVfPOOSUA59vPxF1apc+XhP6EAVk5Z2kleS0Eav/MYDJR0qGw+JKVYisBMxUiETkI/PtXxCWNbu6zj1Bf9fnrL5vLFj32wfN8P/ysHGbrcOr7msuSeOHG4vP9//KqCIrd63ZfYjWK1XchQigPSuxUEKuVRzyI42nTneZgoLyhn+MaLrir9Ss+H6xh9w3pL3wiCn3S/wQiA//lo+cIXP1s2PfBA5I1+sHSvlJvShg0XipeeVqYPFb5pQtYkqlNcxSHt2raNFSsXX3VTuehS0ky3eAv8/pOxBDedu+7+THlIwY/WJDSHBEuul6sOedptOlB7+w8fKbuf36b5PVcOzVyvluyXVelFfR2X69SJzWWaAtvha872BOeGDggqn7u+dOkEh+qvRqAG2CIy4gEEbL1GLXsLFabQtA4+o89lcV+4IZpu3RG+VjET5dCTstLvNN3hQrRMp4oXnH++1kTpZfE1l1Kxe8+BslBrBJ2SQtJzgHuf5NGu/TvKH/zW76gpin9xojFRLt+woXzbd39b+b9/5w/kGnjCiskS8d+rrrlBYL+/HNfp+Bc+/2kFeB6RS8r6svvQQYH3IQfuz12oVIi3f28Z17Juuu/TAubfqrjV7HO2fn26KgUr5eKsM+VbrlfaxAsWlg997jNl23PJIjN3nlLJ2l0QRT3rPyQ3qqXzF324a6Dr+//zv/nPSlfzzf/SukujKm/Uz/Ois6/9dXv8DwiYi01amIRZGlRUUGKXFaxAdVM3UBrOVSVcndF2H/6yDdg1wckl+ayCWbZtFV6msNZGBT6u9KY7EsGvDSHrHJuSNE4B1vDjMFv/h2Wo0w4Cd8oyVzxkcB45UoWf3hhMxnoZsR9+YNDI194s9QampQncyIn0o/N5Fap+CFIt1jNaNTDXZwDzaTqCTzaLPKO51dDc8AkBMlnMuxB2+poNO7NnsFx866tzrR9bLfpTh1ivpw1OF2TWUtYNuc3AyAEBMK2cnXsMARDpv417Hs8kRPdTAK2erzauPDBzwBxXVaWOI71rQle/DTJogDEG9MaizTWJU2CaDGSwiDpdHNbUbgk45X3XcTzBsvYxxwfRvr31GRakAZTtXe1d+gBIxwe3BoNG6ZoE37ZAelzpT9wD+MydzV6I2aZaM0JrXs1K9ymMw83AC/oXVc8ODQCpOuaWsjPThoLUGHBW054NNdjO/RSdDyu486kvfTKBiqKh5RuvKwvXbrTFk4otI0d3lVNbHyivfZ2yskz0yWK+SG6Wq8qzTz+hAM+j1d8XZQJgPt2+rIPKynL0sI5XZUFcd96A85u7JLzmGyPZCVmOFiybpzLSCr6UFYdTi2kSUGP4/2M1VT9SOOucDFizbTGfpeqyZwXAz8hqT9GX+YsEzDk+xrLObDknu2jRztMZv+lOtIglFSWcUyFSDDqAUj9jcgmYRVnSqsAZIOh7n2mIYLBO8uoGzBicNjelBGxBa92cslRiba4h2Tn8P/RsuO89pmcqhsUuExXsR5lPu+Er2Sx2HeAzgIUBJiuO4hsXFD9Dl1iJq9eePTeqsUoJgs41JgBu20MxUqA48B0+5iif/J06By4u5H3rI6eccLn7+IVHjGc6oyB0zeovs+bK8ilf8xEFgpr/usvnZDGXQkXMiVJJ7tm/S0rannJmxZU2dsTA305uaJGGc0oC6GLtWUMCMh0/ojXvlnuLTzEEyJPyUlZjghRx/8V9S/2TG7astxQOQuGOsadlwGJIxDYH0GMtFtineBXzquvwNsGLgXuhWZ7dlIDwXOYs2O3kKbmAjAOmUHAaZ4jSHrBqu4iAf06zcLnZeVwVpaeTvhYFj72MrMnDm+U8E/GXXzt275Yl9bfL29/x4zacQMfx/5bbiYwih/bvLh9SkOWOLc+Z1y+WRfY8gfNZUjLwKacQDUYHaBtAz9+2Vus9GUAGtYYrVJgIIG7gqs8dMA0/r9TluA+tA8D+i1++SxbYh0zzBvAaR7+ywyyXFZziOaY7f07BMdWJUHt79+9zGkSuW7VuQ7nuppt8Io0lmBd9g9JGtR/vfeAr5aEvflH56EmzijsdypL2mPoEOEwVUZ3KyVI/qjk+0HWeFqGdplZlTi4sXarWiRoOn63VHnK6B78eXFtmKDASRfWsAG/oXV/COwDmrA0Xw6zwYYc4lEPdVnXlC/f3VT7YkOR9o++O7dL1yrd+5qQy5MxyVdZ5Wo9eKWWueiq3vBWr1yRgGWWc/c2j9JjTOgH5sz9+v1wLR8oiucIwfyuXrSyv0Fzdc9895cjuAwqevbrcessN5f7HntIpoTLoaO899fRj5aQUlQV61lZVHV12yatkGe8p/cq60zVnkRTs0fLEV/6ibLz2O8pMxf607ER2XdUoZsvd8JrzlpTrN64q569ZqHklg5ZOw7VhqCzbjJl2a/IEJohYaVJ3zJhx9rsGBxfe/1fR7jfT5+q/gI19zT8kuv1rpYJ8+QPzjo95hFWAa0NsEUxxm2jWqACPJuCa1cNCpoEViwdtMvPQgJpIIX5yd+yoMMAAofhRVsFTFQMXm9FPqsrJqiBLBK4PXVMqf8ZAnbYNpnlvzl/fVwpsFvPa9QhIHwtWZFqFaQRwmP9Ulw8bcDxE2mf4utOFRCbtUbmgPTBvYwUPMB1WEA6f4WPOER5WwE76wjoz9HNI1pYtYoL2X9UPgrm7Z0DBn3fUtahr5b6neV4AINIy8owRBeEBHPDHZ74CzPO8dghgMFq7G9CaAQSCtE8yP7bs+VlTgW0FK/6Veau/OkfUmAA8JW48gCngPxb/VGlLkCy/HazI8aYY8biEwVlZzLtVKGamQBbuOEnFCK1UBpzm6isWbc9FZmZyRDwTIa7fAWMoHYYzphtb8K2EhG6zrgFggV11rtujGAs04HtwT+FqQ3MLGM+xpw5wXueGP5H91vTSn5bmDReXFD/KkT977owsII/f/SmvK64+Ky5RyjOlTOyR4EQ/GT6ktHi77i//+M03lmcPDqpi3MLSu3Cls7IcP6ZqchCGBBjAfIYKC42rIMjsgRnKdSz/ba3LBeeTYjHl551PXFcek8V80ZJBKXYEdyZQbUwpzEYk+Ag+Y6Faak6C1XCZ6pEgRoke0fE7czJPFnNmD39ZB2nK6kSa0BlawywLe68WGWJ+rdREwWnucGMU4tK6c1LHOGbJLYb3oRzd7yIs7I24xARIIUnTBwZFbAXKAScftoqbdmoXGHMF2ykihMBLaXIHu1VLvQMrDc5b1+NX7Zz6LhYTy3dAa2iSa63AWCmr9i+NkfzzDijDjxzhD537Doaud8YcSRcKJcf9A2WPK8Kr7CKn5zJmZo3Ujjk/yz4LPxQAX7DOVtyRYzt9NI7rDHEW/bq6X3M5LsPA3iN7ysT++8uHn1xQXv+d3+ICSw5q91xijfZAK2hij04qpN1S5Gb2yKJNakMFFgPSKSARn3dAZIJCAb/wbvb0LIGgZERhbjwk8ahpcj8Zlw8168yaBOhj3eTkADrvERh3kTE+Y98Q6MszOu4W5PLWiZB8yk+NYlFnEyZeivmt3kNuH2UhsQXseebkbNkzNKscGydAvgaDem2ikCVguVFNZ/N7rg8dPV7+8Dd+pfyzH/lJGUBm1xODZEzh9IUCNYdV2fH9v60gy90ChmprUGkBL7/sEgHhHgNcfMi7BcCYd8AyL9xZDp84pjmZXjZsvDTyjnEwMOiaSrtVafP1du+ZKPfe95Xy2Ne+1uFb9BHrLbElWNvBrGtXLS/X3XKjsow8X7Y884wDhXslI+YMDpa5Knp0vYw/cxct6sgU3H14DWufAzQf/OLdDuQexa1UDX7Pd725PL51S3n6UbmMcCLCGOXLPSZ6OzDj/Bh0PH9VDo4cKF0nt9sJEVI4Az+Bh1sBF00LmPcq+9Q00e7QQRVJY8DsGTqvYk1JmaQXijlgHMB+5HmhZxmIl11V5YIaNNOuJ6ystqpraqJFrKquuub8cvOli8qbX7m8/MJ7fqsc2XeodOuU6cy8ZWpX/ENxYJwyOhUqAbSyRo87Pkxu7ALZPQL2KMfGLRQKUmraufMXOX/9hHgIA8LSTpzMwnkKElVQ57lzs0v/2utcJI99zdhxM3zsqx8pG654Q5k9VztTY8RQ2V1P6HpFG5etWlyu27iinLdyfpmnwm+9ohUs9gbmVSnP/CLb4E1VTp07NyqDyz+d0zfnmz6tovaXSsCW1+jnr52h5eUPzG97oyp/9rwvbB2BFsuCmWfHSsTfaK6x4Fo4iPkgBJpAmCK5vG/YZgi7WA/BB0kzF7Ycn0QzRyxrDcRUIDSV0ADmsaIpPZyOtkgVNkPEaYZpJjUJ0ILMYabhBc11xc1XoD35O0oIUscy1wpJ9ryzpFQAACCK8GxAjcYTgOTpaSA9s1f/lxlg8K4cyojV+OhpMQeOackfrQjwafKrbCg5OYMjSE4JkG17KAy2jWFW72C55JZXd9amYr4Ajdpx3AtSpEbFQk7rCFtfkmt2mgJ1kv2F/iXtm/tnABk3pQZmYk1vYFr94R4W0fy1zlmmqU5Whux+aN58VM8aZCb9PoV3ahtcBqCFAqyQYWXKe8YPMCcdH24OZ2StPaPsHJyQdMtibkDuAkO8CNJhDBX/NuTkvgi0OWiO59J5XCqyJk7Gp2uBdbmFRar9bVoFfeRqUHS9D6sy9O+KuJUWOlbwejrkWWtgPzdWUI5Qyvx3TiVsOcxRPODLrjQNmKarZUwpD5+455MSyPGbX3XpK8uc1Rc6lz0AZUjAfMaBh8vVyo4wJieFNbKY9y8ij3mAeWIWdPyKwUlSZVjAfN68WQLmSqMpCXDh+nkSyAEF7UTl6METZeGyQRXDGpU/uizWWJJPnnQhIdaG42dcVACHvQLmKE9Ul8WCPayj5ekK+luwiKAqgQdKnisICzDqIipyn2GKTCIoIAAz1kJ/J/gzIJiXEg5I0JHtJWXCSRHprEMSxDzbPuaar2qD9322eFbwSNaXFLEBWFV3FAB0VdDcg5CqwQSkYGWAYkm0VQOfkZT2g2b/QLW49LD+dB4LlU9wsqO6ANpWXELr2TR5RnzMyagU9cL+9ibAuhc8bH0jsIkyQYVe3FicBb0aGgBfLu4EMHfTANgEh8KRDFngifzumVP6sJpr/0wckz8vtKCrBnT9TNpQ+8d1Mjd+5IHyH//wSHnbT/1zPT48bjKNISsyKQcCUMX3fdpTFVo9DEt2n6x56nyNJcAVxDtc/az5oL2qKBXqq/KKW8EnRsUKDDEIWBnzt08J9X2XsrLgVkDF0F4KYYl+AP6uyVAtJeaZPs2Rn63iG07KlWWiutM4OBIl0IKGNcje93qY77OOMUTtG5KiMkTe+5xStJ/J05JJGeKh6J7TslL/2n/5xfLDP/ITZVb/YPoOD6spDVuxmmPK2vGlz368PHTP3VbmcGFZLLeJlfLNXiIL7MAg+yV1Bfg9JiB4UmlHtz6/r1x7440G5swPFvO5ch87qX3citNF2YyV/plnnypf/tSnPB/0u0/BklhXqQdh5VZ89PWvv7OsveTSsnvXrvKI3CXnzDqnKqYj5Vte+1rpMt1lYP6SMlrTJELzzmAjmiGodfuObeVLn/6kC+gwDpSKPgVr8mwXxpq3uozYQq6A1bMCkCUnRGHSUerL+HFV/nxO6RKTramyOvME08SiC8vAahUwkhJ//KACQHFpiTCPxdy5M2EiWM0TmF+OS+k5sreU5cpY5YJEuh6eCRCvLklKU6X3FGbTyevsBaV31XllnVJEbj6uuaPPw3JvHhQwN1OCqKeVJcv6y/7dktlSHAHsPsYhBaSV65ptBvAi5SZHNDEHGR9wvRQmpdYqXfJ1//YrLizbd+60kYC6Eg6u1vWPf+XPy/qNr5EVfZ5pDr4+s8bNEJR80bKF5fpLlpXzV8vtZnC2rOacTpJxKuvSaNHcw7Re5zTv2fU/M9Df/55c+M37Uk/Ja04wKFZzTeg3fr38gz9tMZ/93jYN9t20lhtI3XysXWa6BrRVnJYNZ7HALWFw0Cn7OlH9VfDocx+hAQINxrgt12MNNzi20LTEzrsZFV0AACAASURBVPMRNWie9rmM8CEF4AwsSmJgnP2z/xwAZGZboWAV9iHYBpRoLcfkjWnVB+V+g/Zq6awE7p5Xsyd7rllAY59ibFWLR/xYAWmbsjJ+mCMAlA3CNeI8Q8qywfxwfHlOTBCQwXPdooW0BqTrjh3ZV1545D4PgU9pv7tPxQZuvr1uvGo5QxAYYDTLUEAmN407VZU2sAoMwZwizHgYvW/H/lm/qEnMDUKyA6nNAPynwS/3heFnZVm3et6AKYFqJxmMBd7k3NMfbLHN5uyFqZRBXmwsEwActe5AGhZVViSK3sgvclRgqUuKRbeKJE2rvpamHdozqM38mnRsjc+sEdDjbEHQsRc3dkWD7SoQbJ/GQufRZP2cwcM0EFWMl32IoV/Wkia9PwBXYYRR4kLTsZvnvriyVCZM3wQMcGFobdsdIJdmf3Cf/4vgGTl6oDz5JdJ0AbvOlfMuu0kC5QJbXjntGT28vUzsfbJseOXNZaGsbUtUlAKL+SaVij4pYO6XLcvZQyNSbBcImB89clIWzFIu2jBXfuoEf+KzDFCaVo4eVBDUsrmuQjhAFgSeo6NuMpaM288ccEhNgbPKctAvZVl55ufIAis5RKEO6GzBfOUm5qQEAKfrldbLgA3f2pzIhdYT9MyaYT/T7ypoBAdsgUfGnhNYo3pnt2jAKrKVJaxVTJT6jfXQQCT+1ih5KFEItxbISfVOABd51V3Aqa2pJzvAl/UHEDm3NUGUig0wWGBazGtIHYllEhBcFRn4HXvAe4SMDVAOBBKaySFA3deyoKFQpfgLQ40bm8sFeduEj5xzsC7fkZ897jGhDAWj6WoHhjqNW04IXFUU/mm0adJ3YCq8tHfheXqQXDWO7HKxKu4hRzKZnriUOgenxl8oP/kf7ik/8h9+qioo1RDh7sdinZStNTC68SlGyhpXzMT+xsJtMlLr+ISTrbLx1sw6fIfZkwVyRIYW+/BmfjwOQTlwGLQUfBEXr24ZMWbrlKi3B3BeC6wxwzZ6REbZfUT3HTw2ZtqkI1ZouKaeIrYT0Obb37EuQte67ODpmWXXMD7fNc8+CpvHyzZocqJuWHUQx4H/9q5/X37oX/yoAvvm2fed8aYwEFbzuKXYeqp9sG3rpvKJD76/HN63x3KIAke9Kjw0IGv1Qlli585faBcR6JvxvLB9V7njtcrEBS8EaGo+rli/WhbqXepPLKZNccApZP+h/eUTH/oz837ydM+Qdfi4KlFOY89qngDm6y/eWFatPc+nbscO7yvL5Xb2zDNbyytl9BklglbzcBrf7jpe+sgzsLiflBV/23NPO/h4nvzV+6WQ3y0L+sK5C8oZuUZtH58n5V+bNijbu2zyd3YdKQFnHN4kl5Ihjyc/4b6OGFp+RZm9dI2Mb/163sly9rj4WJhrgDk+5VaKkTkViZw+pJSJW0tZqeqftYquCCxZXpJ7VNYuAXN4QBeZX+TWvGB1Kavkk85861llSBZ3FejK9XrplOYmAeKvPHdA/n0VeFsb1jNrVVBfZ5xUx1rd68IACL6guJJ+qwjSz772kvI5VQ6dDr5XM6RnZd8++ZUPlpXrbynz5PcOvdptVesNS0EGnq/1uf7iFeWCNYtkfe8r/WAHTQgBpY49qK+4amU++dX+dm2QsxO/Pn/u4Ds6F38TvlF/V6lbt+rnKdHbo/+nLr78gbnymCvK+L0pzNGILBvBW6bKFS94hRyGCRVEB6aypSatNj5q9r2ViTWoAnBBh/OsGwpWUJ2WA3KQH7wPSIvlPQKUioW8yOUdgUUvYznvZDaBUQNU+b7z/NpfnkK/zXS4x9zfrXSkWgVVMXzq6Tm3DvTKg2LxRRiyw1oTrRkuYWPwN2PV/TP0g/wZkYWKo3d8csMAOPqLYE7Fx9xz4tBeA/PWf37Pmj2vXHzTq5rEcq9jjK8d8JylOAJBt8MUdpCQx23mHNkHLDGjxNjqGz+jgFb3Nb8DEupaJIKxWtKyzl4pg4CqiJipZo28Vp7bzGeCU6JgGbTSlh8bK7rbJquJBLSpgvXmJMZHkAp2siuLgoWU6ms6GSrEiOL3TfsIjArI6xjqU/M8MB+M29/lON6VOt0PvmyFYgAxoXNnI0JB0B0GXF5L+okAbAsdB6NY6xP0SaBaHgUoiyWRVmIZreRlABFXm9ZPguI8BQab2UP+r9LX6WN7Ffz5OTN5LGbrlO+2f+UFtmJxy6n921Tl7rmy4epbyvr5smArh/WMhSvKlqefkY/5EbUdQI+Fh1zmBNMuHOwphw6rAIeecfml82X1popunUcJ4WMHjpf5S5SffGhMmTDIq0zRIID5iGkZVwtod0xWu4F5s2VZJ9NLr4MAh07KFURIbnBBf8AcgYI6bmYKAeYIeWbFftFefsD7FDr0PtM9ApPnCIbDRQKLqBqYKfeLkGgshKYhQaOIsNAdVnoAPVeQ9sw+3w6oA0QS4FqVQy1QMk8BPOEX3CtgroDTWbb8shI50TOpoABiDQdgZUb9vOQmZx8nVsIWccC2eQYKZ1V6cbvQOPArJl2iDRh2e2HxMxeNvqwkkX3IFvOaucY8NmtkNxcUWZMV7kC0kzmI8sitmaNZvfNL14DcEuQONnJsn/nigHgBGXAgoDHVCDh0YEv50V/8YvmZ9/ycLLbiq42h0Q7zyB7gYaJVnuL3nOz4TVPQp/CRfJxv9AyyqjA26M8ZT81/GC/8XaDVVS0TeN0lfoqlfVw+6viZDylmASsqtATtzMH9Q0HMXFMf4nmwi55onBz8I3JpOaHTnrCcBlw53TVj63D6AJewCu9C/Qd97x/qKftHxG+q4tSqvnrYU+SJn6u/f/ld7yxvf/s/K/2DFO6hjSihTrXnvOPQf+iNHyzPO7c/V7YLpA8f3qU88nsVqI3BRuO0r7nGwMmwxjxPwZWXXH6V9oH4tw0q5zQHqiIpOm1ZjUwj1biEAvDkow8rNkk5yxeRBWSuxsE+IDc5/vmK21FFaMaBtZtidwPz5pZd27cr8FG8w/7knMKQMUbrJdoGAEIXVhI5PVI/esgupJkckj/5MgV+EsA6MH9p+c1PPFq+8CVVWLdF2YKjyom2Xvwthfv41tI1LDBtppxtwK+JmYPl3FK5scxTtpT+OYprUWzLgYMSnBhQtX7iRyIoywYzXOKoICbl3C+7niplxStM135pnNYMKVoEvePqwr4kVqlHwHzeCuUCUaAr7kN8prS8SidlRdbPkmJ5yfpF5ekX9PxTAth2m6qKgEF3G2MjIha/yjqez2majZz6PXaqvP3m88qm5zYpzkyxJuoOwJxRb3roE2Xx0svLAgXpspamdXiSviX3/6p5/QLmK8vF5y0qi+fN8R6AtxBQzJ5odPmNgHk9OfrVefMG/2Um55vzpTG8ST3rEX3+H91vXvauLNfddufbenp739c0byuhQAoRc9xP4oZiaApvq6DLW62DtKo1HOt21bTzfQV5kLqxXCwjfoIZZwNrWDeN/8L8DZJC+LG42LZp1wZe+OK5Gwbs2UcWU5URW9CZ8CdfjfkamJoZ8L8mdfi7Csr0rsKntGuVxJ3KIy12LJ1rK0FiVciGCbl/DNLomY8mlG3lqI+7fWRpi3miqtP3MG/uNTB/+H6DBYM2jrd6sZi/qmrFadJZLCxAO6PpVM4ck8XzjHJH98n3EX/tJmhgqFYAmFHm12Y9oHXAYRBqHadBcHX18TCYrzo3fBeCqIoIDArGXQt8oLgAzGjL8xdwbL9bisiYtSPjOequc6TPJihIQYCZuBdA6ayY2kz5Gk8T8/R8eV3pR5OyEGwFdB0FoM5/JzAzQMJfV+kc6qiTl6WsbDf3hr2nlHo7HQhU466A7ManA/TbGFrL9TRBn9vvlmN0QDfrTMsMQe+TJA+wEgCKgOYf/odDx/eXZ+76jBUuWl975a2lb8V5yRyg604ceL50HX2uXHK98h0LrKxYurgMqgDGZuUxPypg7tWzcJCw1QNHJKzmD8hSdmxY3Z0oV12mgCJZu6MAo8zK//zQKaVXG5DFfFg5mPs9b8Mnj+u0FoBBH6OcjSlIb44Kp4xQ8ELgHn/fU6dH7Us8twJzY06ANa4s8BDHG8TCaSwEDVkZyt71DAKwTRdZm6RqpaaS+umbmMrMNWsUsBT3BrdX81yT9aLDD1jP+r2VfvOdShA+0Qi9k02j17wlylN4VCyveQwZQxhL/J9t9RQYPyuAA60AYnjZMMG9dd14lAsy4YNarXy2LlMsKBMRYI7CTMpGXLkMXsnUAKknLSgdAiChfHBbgsVQdiaNI5wgzdL1oyi4gKhF6z2W8UNbPTeDVtKTq3lUbi4Httxffux9D5effve/lQsvsQJZK+a/0WjjLx1AXtemqi5eJ7OuurfSBgpP3SKmc/pLQC4AXTxQAMsHYD4ZZZfFp90+/jYISFESzZHPe8K+4DJOCIgQAIcbVvpSDQHmLQr8FFA7cTJ57lvK3wRwJpjU62lqYX2qgk/6Uh5XfzjN2ndqVtk3Mrsqe5P+5k0WuQWu1wT9t//yS+Vtb31b6Z+30HgUWZlCXMkDbuu5D6HDswzQdeGSBQPlgtWLbQU9LJe0Z7c8W/bt2C4XRFWifOYJFcwcKReuW6fAzZXOwY0Cib83IJuTGXJj9+CzzwmP93lkJv7fPQLKgPXlcpeZruuYa+ga+sSfHEDXJdCKm1D81XH1it86r/BIE3898ck+Y4ktDS03WPTwpWTTKuWdv/+R8r7f/Iu4kXiCqvHGjN9XBryOHS3Tj29TkSF8ryNszsnwMrHgfAl3lbUfXFD6pDAAzCfEh84dBMTrXnzMKdAEYTraV3iA94qfKcr9XZYLmKPUci3uJSzIbJ3esS9VGyTuLbKYK17LbisrLkzedJ0sEIdRZuvZaI9QqyzmK9cvLrt26dmnauUs+u4x1LGZ5q2NZVw8z/u5jhV3F3jDmeHyrRsXaU0PlOMyfADK4cdM4dYnPi+f/PPKorXn21ruTEYOQEfRVxYZVYi9fsOKcpmCQJcsnOPYBK5z3n+v/eSrgfNYzulGXKumVIl9z4L5c3/66276JvpD/VWVqKJjj/Jl0duOb9S1lz0wv0GuLDNn9cpijsDK1jMgzjtvwCaUsi294vky3+o+JHCAVkgizI+LXmxlqFs7MBghXEFgE1A+pUIowGwIZtTvGRxF6/eYLOb0ZZY2D0GOPLApFHlcgKH7FcT7dS9f4n2V7xso5qKAmAjoBt5yVJYiKLESx+nBo4xsCMOq7XUmoIIFAx4EpO44o3uHZDEnt3OPUv9hfXBgVwUBDTkytUcP7i7bH33AwjnuDSqQMbCwbLjh1ipwKots60TXPLYIBaT5uHzMsbL2yDo/Tc/sZGXp+ENPTk1WkWFhUTeSzroaMIS5TrqN8EfmvtFKJg3mFOHTpj5gq9KBlb06aXaJwr2HFmJRtdUaAY1QB5jj8iGgNCJgTqEYskhkQuzdWkFdQLPXMqveAQNZo6o5eQQRIi2Qz4E7njfuZIyByJWia7rE5BpvSmSjn/jpU6mzjqe2kZHSH6yaoRErmnLydkAoT+mc1vA5AKgBeNYvyoZpSoLn9JGdZZPKOgfgnS1rr7pN8mSdU24hkIb3P1+mKfDp8htu001nyqrlC+1jvkXA/JgCknjeuI+nA8yHdBy9YE53Oao85ihl11wh1xcCPPVMgz2dQpxQ8aG5S5RvV8HDcxXEhR88Lljjcg9oMRDM3ciwAgnn99kXvV9+r6S5HBpSgKfGPk8+5jw7wZhYi2PhTSAm7/I5aClKAUsVABTeEzcNp12tlf5QxsnY42nt7PuAAis4VBH1OLJnXS2yWpMN/O0Y3UB5XWU1FneX0DKZYGSkqPwN4A1RTgpJrsIKyjL5BIrg6urz6uIjNYMFqS1x7XA6P9NlUuD1KmgM/3CPz88N70ga1liSiScAmENaPQL98FZoMAoi1wLMCToNTWHdxL0GNd1H4Yxd7VKVkHWdNbBUgYlzy/gJuU+o0mC/0rSigNH/Ye2tXY/dXX72d2U1f+dPKN2b0t7Bcyu+CPjF3z5gvdF0co9nZJk71iDr2k5S7aZc9zXXWXU2oAhdtBz23Ma9gM1Z+JELuDONgPMmA8jygnsKWAxXj16dpOAGZjpwcaCsFXN7SoD21LAzr3t/Oli08VH3unPuV/lY+ELzz42bmgDTsf5ydCyZR5JKscmyAP2An+nlV9/3nvLmb//2MrBwmUA5J5E1paddCLLutpibZuNOCM0tGOw3OMdvGCtov1wOewQ6ewS2qu2qbN+9R5UmF8u4wqlW5dGeR2+nv+JVlcKXkn8VsL34xo78YkW9P8PJXuoV5TzGC89BpQv2xa9/+K7y8+/+QwdmT4LT0EkHGdjgJrCqtIllTHEw7GmyBA0sVpuyiGutdVRQZgqYW4lF2dkr/3H8mwYGRdCcJqk9fJ5O6lQYHKCMP2WbEpAsE6YzMNdN9IF7XLRIrirK8y1NT4Bb72XoKYPL5c++RnnTF8bvnDYlJ8tsPcPrrboQG5aVnXsUgKqTGB8JerwViNexT37WgHmbP6zqBEQDzkfLK1f2ldWDcmfattfKdsB1KS9s+krp7VYKx/MvjIIEMCfo2XQyrcwXbVx34TK5MC0tSxcOyJun15lZmPueGizc1unFwLwp2VOAOa5VP7t08cJ3fyMK+rv6Tv1HK/pO/ezTnr7rG/XjHwQwd+VPtg6bn01XN54BkL8Ik2/g1/KqMtqW7zfCNEe3vDrb2sKnTnETqoZ9IeAA6K9nmP6ognJy5k53ZLiOBuXPit8jJdrt0mwUk6f5vQh5qvtMKzzTul6hW0e4N4aU/kXYhN1abTADri6Q/j6fArZ9UQSDrwsz77zanzSMtZC7xGTIysKRYjeVLLGY25esKT4R0oCRo/t3lu2PPRw3CAtsBfLMXVIuuO5GM6ukSZqiCDHvgBhr8gGDzBVZBygSc7amSwxHr0f7PBfBWZ9hIaxvbbxmKpmNul7V7sVpduf6Nme+2Pdm5jINsY52Kv/4uYAzgFcF0aY1wDiMPtayZLAhsC3HlWcEHEj72NNLkSQsmfGVt2pkF4UoEbFchwZyQJGiKk3G+PFMTX3TaNPWNMZcTd++w2uJMA/w8a0ZYtaiWto69OuPk93B/SLQEIClawlgm8B9pbo1GA5yolDb5HNTm4koa9dOh4j2P3VIwPyeuww6eMK6a+4o/cvlf2n/Usma/dvL2MFnyzW33WY6W75skU5jV5bnnn5SFvPj6ouK+xhoya1Bzz0li/niubPKoWMEaU6Ua65SFpceAVopiRNy0D2rRk8pMHTB4sFy+oRSK6octKK0RLfHJdMCNHiBcYd0vDt3/uxy4ji+6Ar+VP+HFSTF8evcxXJliUpia5KBud7aah0IWpWiBH477sQm4ghEr6Puc0Yofusfpcw5qm97OZZ35ju57LslVFEiCVAFACWDB+A+pynutIXhJD/i8wRQBQSOSBF03n/TFYGcKShF5+1CAvgDiOhagCSnGuZF6oN3cgVDHYu57wWkiJaxZBIbY9twUxpCWxCt3QvUN4+RoE//Hau//VFNW8Ti6L19zNkrmhfPmdz8DKKjMLiKrLeGaEtGgJ55q7S+iteQr3m//LW7tb8myHqhdd3zyCfLz/3hjvLPf/5HFTy8zOtjnk4TdS/xnICw7K3q36PnBXT6Xxhhhw9ancdax20+9QjDbCkIs9woplljKxv2U09g/5w+Kn5iyQ1/oOhOravk1Il2e0ERqRVBx8dJ6YfSIwOO3KCowmmO5GPb1j+Tb+eVaWqqeFx1rJPAi2Q8eOJQfxk+Gx/l5k7ZMQTVVn7rN/97eYMCJxcsXWmsOJkJJgq9/c6hG9Oez3jMA+bLErpk/mBZMHe29k+PUvjNtGUbYI7vMM85oWxI9HGefNBj1AjXqREtXz+Yl/ir0eNUC+pL3dS+f+nvGqer35r+AamBBfmRpV5r+Md3PVDe8bO/5uJWSelpjmiePikfTckZC1/jaqKUiwbQBHtSzVP+9jPJjS6+QftnVfTs3DG5oqA0zxFP0kmwBZWMB9YiZwvPbVNM1pIrA8xtvdYPwBwLuFx6bDGX4l1mCpTjUz5H2fnmr5SvuQA6QaJogwRr4uJS+7bg/IXlsIwYBuY6yfCxC2OrvvgdDdZg3Ys/ZZxoFNVirgD4lbPHy52ymj/61PMd9zDA+a5tD5buiR4Z7y/rKOsA76QVnV4GRBekTLxK4Hy5+PJgP9l8dEpmYE59kibNQrfZdjGmTQXmDbSPKTn76dPDb1y/dpXy8H7zvdTPW9Qr/M0/qLH9lUGg/2CA+SRInWptZqEDoDjEqVyhc7zVYRIAE6wCIgxnXqmAh7u5L4C3eW1W2tWXDs6pjP0sflNc67YiAJ2GDsHrlGGcCJ3QL3KoCqT51G3SigG7aHlokcMvtpjDgAOcmmiv13iIlip5diVqCxvn6q3PmdK3fBLmkjbr1Hg8zf4cAe6MFPoaSEJ+csaC5eyc0pXZFxRhmlaqIDxXDh/YXXY+9mBH4CGoZiuV04XX3hDw3RibhWizMAbgNAsieaixAHdRmAefQABhM8V4ABJqWHeMOANiI2IZV2WcTCR8FfcVP7bNt5Gw/w6kCXD00XwFmPE5D7gygDZgRRpXYU5ucQKKpXj5Xvedk4XqY6sln1BmAkUyyQVQZeMV/EkmCQe8VMt8GD9grapMXoj0sWWQMV3AN7FQep0C5purigsJZfa9iAbedR29yrmpqWodq7bX2f6MjI35yq+kRoyA7wKQGSzxHdlmmLIw1VhEwFf6H32jk3ze1kF0ePzA9rLla1922kv+rbn+tWVAwHtaDeAb3vucMrc8VV79qtvkD6o57F9d5q9eruNRLObHnN8YP3ueR0DgaQmm+YPdKn4i4SdL3nXXLLYbJsfkPnpH1gm0z9eRKUCot08AEZcCuZCN2mIe6ML1Yu4K8pxTjhw5pSBQnWjoOSclvEgZtkD3h8TYyxFapnNrLHpjt2zmDMsPQog+JtjRwBArOnKdpcZHXfcRrGZBzUzoO1ucEV5oi2ocEEvfyEyE5xD+3NZeqjKWdYkPuCke0K++Jbc6pcpVplx58/vIemCe15QEMubglpWqnRT3MWjGmi3B2w2gqAC+7a8UR4MJ8ZXGrw6NK/iyz8A8pykJFNUFau8MgZ7QttodE+joovgYvAWfU1uXAckQD7cwnyivOXE6R7EgUU2SRwL+5F7jXYECqOI+8MuFa30Kde7wttKLEqB86pw4jiv489l7P1be+Sf7yo/+/DvK2rUKQLOijJ6Xkwh+G6wGsXpdvUb1XaPZSRdBxh3XEl9ZeXn2S/Zp+skezZ7Lq/KualxJJpwAcHMZAfRWmMiAnOvI0FLTW44JFZOuM+6ANdd8tTIEu4RLmf37+Z59v9oJqsfUmLnWbVwZhh450C8ZlkwtUUhy2pFLz7ka5qtuuKEsWaWiOFYyIrucelLX+Dckyg2mUZQNpRQUGF+s/QMwH5QL0WxZgnFNwT2B4D/mfkxuTUPaZwtV+j3AvM1eFThfN3uT42kf/+2BeTiiR+D/2rpljfJ5FNwAPvbFufLxB58ub/uxX5aBGGW0rq3nCpAaeqhMkuMz04mBMxU9GZzc76RVyZKtQmmDA9537B+ymAyRbnJUQBfrt/ey2iJDCikT+7UHDcyVx5xaAVjLYRIAcxcmUrIP5SKX5UDPkzxUca0yIFeWufpRsLxdWXCRwQ9dBdpyrDO9rF43v+xQXQczcWSRTjfKMVn6W/CnJ4BN2H6a1Zz+ZZ/Gaj5aBlTU8oduOb989WEVQ7KimvXav+txFSg9V9ZcfJVPFJuPecNRfVKkr1q3uFwj6/1KFX6bK1qBTtiXnKS8GJg3AG66ngLQrfyqv5ygqvroqS07tr/izptvfnYKCX1TvFX/pSmV2/XziMb29F/VqZc/MJ9S+dNAxBsqFoavP+Kq1nNAN5sxF3iDZJs0gWdblucT/9BOtpG0Wq29sVO0TC3hhWFkZgEGyIiaMAZnKdDHoxIkwHvS59mK6X7muSZ0KwVsqmpRnqJN/tUL7AdWQcOtee9ZMOCiD4AAgF2YUud5bjRW1QYA6mR0QD4ZI6LUyCKnqHb7mFNxA0BQ/cctegzog1uO7dtetj/+SFrWf/SpXxHjF1x/o6+b+uoAcw2b3MFYZhD5Y0OytgDMsQ6Ql9kCpaUazIQBQgHmCVp0FwMmGHYVBAbXyVPi+UgfK1upSlUrSpI1ZK6qFaopQVmcjiAMdTCf5OcO6Jyhtse4mwweBB3pkWPyLzyjI8++3gEBkJoi00CKDnJ//OOt+HX6XmnMtFPhN+Cg0qsBQVUX3YYD9wLCOpTcJLZpgDWIlTd2vygaHSWm0kCABT6v3DyZ+z+5yiuM4T1rEOLNETspM5kHZ7gIYDd41Fqe2LutbLnvy14Q9sWaG16vtFrLkp9b15za81wZOPx4ueLmW8rygVNlqOeC0r/svPIcPuYKKHPeCFwvNEayHw0rqGze/C65ssjHXIDh+qt1ZKxjYIAGpcQBFaMnJ+Qj3qPUcwr+lCUKQUGhp3EBH3x9rUbKin5a1RXnL+iTxfy0gr+owiqwLl/MXvkP83m4CMA7tQjYO93OmNCO9Rl/voe+PCW2bMa/Psf+FCYSaBb9cmxLXmy7kDNfnJwQkFiBq9fFCpnmWuPA9SWKfwwN04lrcB58O8eFYaitLp/GxUUGn+teWfDsulT3fgoGqXWnfkTYKbBQ7ZEZhxzQPQLmVB8tM2puH4BZhyZoB6WEEwlZzK1c8K3uQCuzpkajoh3NBcrTqH3M8ffFrzhFlUxRmo9OylnuATzY7YUCS8yJE4GKLgQj1WedlfjEBrrqVhDo9H75QJ88VHrlzoKSy/1nlL712a9+vPy7P9tTfuzn/1W54IJViQmgP/D4yrcm3TzCeYK56nVm/kxY+5XNY7U87LvyllCE2UxwnZWLDuNtb1ze9AAAIABJREFUvN6p5CY3YOLAPUCzWNYUNyXnb+c0St+RXpV5HBqWVb2C8QCU9Le9JqVVZdd1H/uyKXvef2ZI5dhoV3n6cFU0kQFWxpsEOFf+5E//d7lSlTVXrb/Y1UYzV+DQjN9/e+h0vvoE6z1W8oUK7Fsol5bBOXJlkUzo1Q/+387KoWehLJ9QVpVFsh5PArDMw4tfrUfu+4su+JtazFuwaluHqdMYusACPhWYC/CJbu5/dkd54w/9oqr2EnOhuzCiDGDhxh+8+njXEyjPLnsABVqBnkXjFIPKpKvwz3T7Uoum5aM9T3vyiAqmje9R2k/c+Lw4aKtql4ACuXeUnQ8KZCuYE5dHADn7jN9YwgfkOz6K5VsgG3cVgDkW87n6WSALeZ/6iIKt+iFlybrsS9HX6hUDZedJ+bhjtwVgK9i9HMIlBuAP7fJTDTPex2YQWRrzIZiV/taenj52qPzM6y8rd93/aN0FXHO2HN23uQwJ/K+79FoNDbepBH8mS5cOCeTatVGxCNdetKysWTpP2XBmO5c5wJzfU09wXsqVha40P3NoEZdDApKf37tv29btR6/+ge+4vabv+ss09Xf1icaBO4sKXE/76F/Vh5d/VhanS+yRK0vyPiczCwwIBoOgbIgtWjPBT/HyhQG0a6oLhD5L+eMAjLDiMCd/Xv8OEw/hBYdMAmPzHIAUPzAAbQAHOOlZYwLmXZRQJqexZWsEeZULNk12Ku+9BIN6yUWWr0qImy2EmS7AKptLPa7Hce6tOX2dH2PZAFD32UKmWZQj1HIkGkALAB5R6qdZpDkiD7sDxWL1q6fSHXZ/SCWAdz0hYF5BBU/on7+sXPCKV/qZHUFYBxTRDf+LNY9Lzsg6AO9wMSNHWTHRAapZ6TpEI0QUrQzBoFC/w5SjqDVf8Sgm1cGpMX8DUawDmZ/J9JWhj1iwYp6KsEu7BqwGAFi5ApBtpcPCpLlxsKLWe0LR8jN75RohhupSyQZzWL4AW1YX1FZOJWK7j6tOe44nw4thQvPIk2Ixa+ajdIOL0KFzq9dThJb1pdFNLPH8FSCfe2DMaXvqdR3EYQbLc5giJlb2TdO2+sLa659zRdcgWruycK2Y+tHdW8oLDz6g9xF057/yDWXOgqUGiYDa07u2lAvKM6X/4leXiwdPKpvBeWVEvpNbnwSYH7Xi4zW04kNyA2VrGFSAp4KmSEN43SuUtYMiogL6IyPjzggxOqTKnYt75L4in+i+FOgZFS2N6Qg3MiduSkPHlDJtUW85flyZTHqpmijgL1eWWco1PV8uLqYJgIx9bqM84cri3cM+IfsNQBlyrQWXUrJeYFyCHLB7VgoAPuYA1FkCtRN6z8qdUYYYqp8yB85uAn8xaNJTKjCeJUsTANfLpef7PeRT6cMESeVK5UtuAbK4QDhjkvd6c7/IXsCyDuZzSk/9Q4iOy/1ntmiTQcSgkD1v1xw+s+U4R/qjyi7UJ9/WDjfFGq67NNq6H/hbPI60ioByXDREK1jRncJTrhV4VaQuQixudqkx3ZE6tGa74eRRH52h6qauQiEjaPKsCg5N01F9lwoOTVOlS9ZmdOiYsv58uPz7j+wvP/YLP6H0maujJPAPgF6ZxGThknzgz5mLaqiALrKFIhsCBK0uT4JjX5u9z4exXNeGvI/qn563WNSbjAnQDCA1r7btpWYa4fSo485CysRkQUk/6Vj4IXuKleNk1/KCtjqD6Wxdt02ZeKfVNdMqZcexWWXHSVVG9U05+Wtz87GPf6SsXDC/XHTF1baYc0PzMzducz90vQ0C4b+8+nVqukDAfJGA1jxlNaIaJZZQV9WsFnPaOaFUpQHmuS+nDhX8TXb7L717sbU8Q60L+qKrJz+P3Pv665rBYvKmqQCwveekavOew+Wmt/5rKXwEWYqxDMqFBD9oOk+WFMC3TnLDSOqA0Lwcp6FnkxlFFUgVDen7HR8gXrBAaRlPnDxVhre/oIXnKFX8sE0IY8LFZY8y7C1QMCegW0YGPwPXFNpXxhwHg1JkiMxJGKtmKwMLFvPFovlZemav7juhDCyL11WjmU7p+rUnFYNz+qj6jqVIfK4cldXdrjosrhl1CBdaq/E8dRIrMEd5GCvTRo+Wd9xxUXno8Zq1xtjpXDl5aJsMMPvLeZff6BND3NaIr2Lvwttm6WfD8vnlFRuWl3Ur5ot/98kQQrzNOfGTbwzM29q8GJgz8ztVWfaRx5//xD/77jvf+A3I6O/kK/X7cj34Mv18SnQsbekvv172wPxapUvsU7rEzkaB3TdLpwXoJOBgelqasTCJKZu2MrscfMbCYSZVwVoKu8TdAi5p4VwZH0yEYCVy9Jpp1x8zfgucuEiQaQQfVqLTc6rI/+JrGtQfq3CzWaWPYfBTWEFn3/Cm+VJbkNi6GcbU/LgD5txSZ0xTZIjFT+e7KeDMe9WCqYIyCeiRE8cd3DRDOZmpysd98XOeFGI0cWTvC2Xnk49V4ZUxDKoy2fnX3RCGELgxOcduqfqnZgBKNSjwheWQkskS8LhyTJb25taMdyqANCCs69RAekeIVppIX/M8V65pFmUq6mXC9VOFmmkCa2j6G92lgp5cBszy4hjE4yrgaooztc76RsG+E6oY2SXlAh9iLMVhgzVotgIAg3yvOt/WPLRtkTxNmRP3nfnO4EwVLc1mAxNZ7Viom5PO5Hw3y121zPqpoWvfA4hqyonpvNJfnWdDdO8nLE7J+xymjoUs6fWgGQMTfbx/xzNl+4P3RTnS+q2//k4lDlhiUArTPqzv5516rqy9/jaNekLW8BVl0UrSJcrHXFXzDMytfMQVaVgp6GSgK6eU1hD3mOteMc9yCxA4Pk4BE9GoKn4ukMX7pNJ6zZ7NKQUuD0MCjMqiLSWWvpBX+vTxMVX4VLET5Y2eJQBPvwHmlLieP18059nLahmgAJ5bjuDOuuFelUqPDv4EQBIMJsHXFLyzygUsT2qD/zPkp2b2yNyD0NY9AFMDZ/XJtIqOKDoCYLswGWvU1kTTHTeEpG20bzqlyumlnjtqq3aEHXia9bFRgWDJmrFiHFCgNgn0HBfYmI21zX0Ij6Edc0UUMCisZsWhRHevgpjtiqbFoL3QS/aMYbQawX0BQwRCOm4sAXuOXajbKwaEAGNiVhhjzgGSW9/fqTMYQ2iL0PkJFRuarhzOM47tTnval+Onj5THPv/h8ksfO1h+/N//pIA5rp2TFnNTdaXjGAbDL4Lvwtsaj/fc88/8qX7vvVT/CnPIN74vaD5vG9/Ntcy/QRmxGcwR+6jeXafLPJ+Un9BJ8o5n3FYiqhtO65/bNG+L4ckKQhuP2240kr1csfwkb9ZmfGSPaH28VtyEPszbSvn0Zz5VBnE30GnmGLUSOPGp9M5zcmpg1byuY7hJH/tE1R4NzFXREaCOxRz/4WYxp//kIV84T64sdV4yP41/ZZ5f6vViF4eXuualLelNsZq848VPeClgTmD2XvljX/m9/0YKn+5QWkdbw+u+cT8hStxPTsjqDFCnYYwtWMw5uSI4UxllPLHEEaAAybq7UMD8lE5PT7+wTd9pnwOyJ0krwP7gJlm01whkK3iTdngWBg2MUVjMuQdXFU4tAO/9AHNZy5fqHlvMBe6xmC/U3w7ihsBkpFBNhyP71F8rEHooOd5dAZnxsLi8tyDL85rF3Gy+gnWdsqlKm1ImrimbtmyxgSGEryJV2o+HpXCcf8XN4usB5hQNS4aWgPTzF8+VxVzyf+VC5YyHVmRM0L3/J4v51HVKCk/Sd+r0VLJjt1wdH35sswLAJ370Hd/zxl97SSL6O/pQ/ca36dv087To+JGXpG9d9FZ9sUcX3PV31M//rx7beBv8HdUd6uu6QekSZ/X2vc/CBBBlK1s050nNfBLMeJM69Vtl0EYl7ai/glA+MTibBOgWkd5MEe4twNLgxbssDga2KVQmyvNdgEYbBTomoJEgLBfqAGCZecONkbitncrFeVIDypWPdcAXt7gneSV1GsP6f8h7D6jLz6u89535eq/Te1MZFavbcpdtMKaDsQIJJblOTLgUQ2g3rEBIIQEDBkxJ6JhlAtghYMrFuMrIAhXLkjXSjMpoZiTNaPp8M1+vM/f5PXu/55yR5dxkrcTOko905jvnf/7lLfvd+9n73SXZZ3Jm3zatL26WgXtlsAnqkuVWIeOe+B9z5IaQYPHOXrjgbSrAMgyitq8qKHWiTx97uhzbv6/5u/o2pKCUHbe8PCxmbi7jGLm4rZzoYrap6Bff5uVTh5XUVVJlFl2FFQ6hUR+Smkq4GsW8BORmzoIGAtDE3ITuE8JfxrscQCxLuG/EHQL6YiXVmbgZMAR2SaDNfImdmHiW/rP/ZQR32T0KGqCqobamYUpLcsdZkbWhQ+PVpsh5LP+mP1uVuSdCMCz4tppzKF0Pwibus2MngLtbkIfiVhXO1t67mSgIFcjlaHhHIekgBGRsWSeM1riGxd59zxvaSmZgEbQQrlD64s2LaB0td/YOzuMIFlYdjzTNK+X0of3lyGcfdNuxtl/x8q9VGjFKP4flefLE42V48lBZf9MdUm9WyoZ1G8ompVdz8OcZ+WsmSCTQkymald/4YN8q+Ycre4qefcvNqjYn14dOgQSK6ywvSvmVJX1ouNvBnb3kOFfbl7UNzDqkwBC9RimY0e9YxidlMe8UoKAI0PzMioBqWxnW9dU9CsgYKQKhk8iu5K5CsS4chuwMC2TQNAqaXDRyJ4lsRhJPcgOlnL0cNHDjzJSIAeAwnyLHRee6mbOKaJx7FPTMXHhl5PizMKsbVuUdKPnO/aR7kqu9u5vqjwy//LN1zyyCaN9fQDVrjJXQrjW1qDzOvRLquJkAoBF8NWAtiqKlj70avSBLbi9B31ytNjolouYbNx/vtIEDxNvmBcw7Ae34jmfAKr2IXRf6GuCy3huLePhrQ2Pijck7I+ZDQh4/bf1dlFWwfWBDaZtTJgy1e0n3mbtwqjz0oQ+U93xksXz/T31/uXL3JtN57JKBOxIwJ9gmrSm7TXYXtgEnV1kss8QaoSB7PimoBbD22qscN8A2t7DSAv0nfVSaqXEaZF6J4kZ1EcPrggeZjpIPNdzuzAviedWAUbmNj1kRCr4Qe0mVNwSPiyOxVk2mLfKA/OifPt4X/Cb5LVfcffcny0VVjbz9tW8sS+YRoUjZhSU/88jlKmNyzLCOjwmQr1Fu6grMewkAtcW8KmQqaqmqu+NYzLlrZS7V0BEjE2OfrW85FMPW6PPlv7RaxVsVmJDPOaEt9269+nJgHnONMjShrEyvf+fPliMnZRmX8cmNjn/q0MZn1hBWbdYxlmiCLyugrQ/SvLOGcNcaF1ifk9I8+fTTIVytHDfnyx/PPyUALuu30grjOuL7ea3q1adj5BMHmCOPcHfBYj6UAaAAdyzmBIiO4HOeucz1qCFV/7xwSlZy+gEtVjcZnkn7g9CjPWjzocGal9sXnUBVGZe0jVDe/qot5eDhw9qB1DGvCRWRmz5dTqho05Xi4eSRJyMLwNlB3IB0vbetGSy3KPhzz5Yx0YJSJpLdSdf3SPGp2Z1MA9BWvl/4vebWh3+xRs6qNsWnH35Kuf8XVIe3/aZ3/MOvUCL4/3Ne6sdXqzViXav+7MVa9SXjY9609EFkgbSaRS8qQIshaq7bANthGQtQVq8mZRi0HKA7QZ4ZXiJCHQWEB8gJIdJkLgn6EXSAePwo9SPpEl3Rj21sS90E5m5sbXM8sYGQ8mMQrH8wkKzbr7WNBm0JphNNXWbpdU/M5JJBJnO00G+YWVoYGuOS/ppui86fVWQ5gSxkfriI/xwWgQoecmFxr1PPPFmOP3WgsjSP46CCVHbd/HID4RipmAirEsn7SI8YOJp0dvIj1jM7xSDJ/82uQ/QrpJlT0VmQeAJbh8v3NHisaW00B95S9zPhjSn88tkByM3SfX9/tuIW9yFok+EK61eOM+ektSGqzQZdWbmgCApzL6v/sgBjl5gmWVmwmPOKMOHI4hA4L5U+++rGHFsPSKUimDiME6tkAPOGr7i7H+1veuAHRTepmTmulsu6LqDlUCZoUZMGQumIe8ZvBHsFIw7XCx9Nl4McLY/Xqsip5nPJygIwf1bA3EsGYP7qb1DaTNxPsFCLqZ96tqycerzsvPX1AnIrZf1aRe4rs8ahA/vLmdNyZbGr0EIGgFKFUHmse5VvXGXL23TT226MbA/tAgnLyuO7oKAtDEsA6xmlQeyRjznNWVbQKAByWRZ3j67odl6ZCoaxrAuYt3ehoCl9owTz8GC3UnqRzjHUDiBYZNwApMVWfjjyxO4ByopdXKDNkPAGylhBcc1yulFd1y2r2QoCWcoDSoixoS6xNVuXtZNSzsSBBV6pHAWwbbMnKFa/r2CBts+S2gOQznkHmMfcUNhG/EV05oRCuL/o3is+F2EpYK7zFu2aRkCairXo/EEBc9oCiLC1ny7QLitpAcy594LAcH8vLj7k6pfiQZ71VPZcKVkNor1sUUMvrFdbgm1xQMltKrUGtrgIqZ9R7CVcDA3oHVzNNoh+u4SyIir0LdTKNVeWdhjf5CnvUC7NTZT7/uoPy89/ZKH82E//UNmt4E/4gqm/BXRHlpbgYf4J0s+0jzGhscvq7vjSBO26B2sqLNXp3sh9Y3EGb8DI06CJZGS5Fq14Rdx/xAskiQTbiWc0LcPw5lz3QQlBDilbGizTj6iyoHleU6aZUSXvij24YPWryrHJjnL4vHY7ESBep6vK/Q/cVyaOP1fe8OavkuIKM7dUy8ch2wLoRm71UHb4TgaWUQHztXJnGVH1XdIl9kqZpJhPF7SarlnnZF1eI4t5zWbjFrtBvOvYxdeK22uveE6tWOpetwDuKqnqiFfZ2HpevV8Viy+0sIdMbQLzabnD/bN3v7d86MEjWgPsataWNOe1MeLV0kzDmWTo0l1KQQB3x3KtNTWudUPl0XMHBb5ZLDAp5gAXTQ+sQPfkYfmNK24Qi7kBs467WqpeBF3TGYI/DcxlHe+Te8vA2rCQ9wu445KmqqRlQIAdRYGX1mG/dgWnz+k4L7K/TErpoGN+hj5G0Eu8/TlNX0w2wJy2AcyXFPz56q3l0LPPqp6J7pf9nNcaPH7gM+Wqm99kvo7hjjzm0DuWc7wINinX/Y17NpQrt4yXtaoRgdsT/ekWDdVA5NY5f+E8VVcWDCSRPldePeLp933mcQWCOi5j35rO2RvvvPNOOvB/xEt9UIqdco3ef6k1Lo3q8teXBjDv6fklrwkzvhS+8UVHbYoOwkvmXBeqhyqZbNjMuUcsQheM4Gp8eHNMq1tJGlhN4A3GAK3riMGRGXYs0AhcY+sZy51SAOJ9iuXJ1kddb9ACQ8y7GQRHkxsg2s9vWj2jOcHU00buFttiGp3y3xD+FW7SnmR+jb3VFFaN6wIoNxkai1V3AXhIY59XmXQKn7TLrzV8XsOiZPsX/fXAqPrcERWbOPhEk9GqI0Nrt5WdN94awsiCrrJ/Xav71MVXlYdFVf50yW780AzMA2CsGJznqJMZpeVrTJzvHgvepABIBPCG+AxAG3C0zn1taPQ7rcYWmk2/0gggjQEMexkWQEuquJ95W/gXr1JWCiDdyuKkAtoFzFUEAh/zVbKu0DqCrHg2llQLH1psYRUAGNqowK1SI4+m7eGqE0qkASLzm2OJG0C1qodHavQz6LWp+AVQZn0EZUe/gxYMxw2iYryCzipF6an4Veuoy7pDtmmVi3EJQGDVQfc+8eQj5dhj2snL++95zdfL73HQ4JFDs8pjvnBif9l++5cVMVYB5a1yZdmoPOaymKu6Jxk2BKftp4ngQwHqVK7oOQHzDvn233rrkMmTQMklFftAfswpPeXIeJ9itZa0wyza0TUELgI6iXmiLwRdzsk6PiKXlckLSr3oAERZ0QXS167pV7AuGYdQzLGGhjtN8JUAxHWXK0dHtBm/cXNbnEW3ne3KBiMcbkVUx/v6CbYM4bfEVjCg3uAlUi52KOi0okasQ33yO/XKzViUWC05X2nJRJlvk5B2lnC1c0VjQDYXrFVY6jtx99Cv8J9V3rWTyw+7DxgL9PwVWf16lSXC+x6aV4Re0BI0RhwAyq1mgHlQ6k+s68yDlzrg27xR99FcONBNz8Kyuto1DpTXWy5djqXwoEtgG9zpnuxG6SZLGtdePQe1B+szW//QhSvRUv9XzwGsA4SdZlVb/e3dqq44cdSqzfzkifLIh/6k/NTHZsq///kfL1u1Ve4Vn3w3EHisV3u16xmhsNb1Sv+Yn+BHthCzpCtorvwDeocfxFZirCrTe7o2+pk5bskbYhcwjChRqjx+t+KQ97UcqnyQdazGVes5uwt1vk17yfKSc2U//cevRiwMfbc4iQsqb4rlvKo8eEK5+wlwcmtKefChh8pzsnh+zdffqfnn2nCzC3oLV5ZQohAFOU56BnJgVBk2xhVQOCr/sn6tGcA5gL2TAkCOv5BlU3FJ61QB1DwrBUvIreShQeV+ZRebnXrBp/8ZYN7kX6FQ1Nfns8hyfHp+sfzZ3z5U/uXvf7hckEtcKBDQTUtDqnA0oUQf7CbCXzOEBOjwdYC5/o5lsOO5Q4ciCwtWaxgJqU25n5TeMnE4wLaqh5ooDMzTog2AB/zjPkN7yMzSMyZrF8GfspBjUQeck19d68MpHDkPg4oKsBUFwptlDEixFl9tDAjM0wpF9sOfE9tyyHy3AvPp8h2v2FyeP3msTJKCMahOu3ST5di++8rVt36ZPAE6vVtiQA5/0LtT/dwod6frd60ru2UxXzc2YGAOT4CGXmgxN80mhqt/m8A85Cv0OCPedd+DBxQwveTUotOz0z/wo//sm3/x8xLPF/gHtR1m9Ga9PytalGP+5a8vAWD+lm/vpPInhGiQUsFKtSO2rngs31Wpqoyigpm6/liIsI3KDMNamni5wUByyeqHCqZEpmk1g8FE5U/oPLaUueNiurK04btmRpUQvwr7FublB+UWcZOp0LQmcA7bZTJRsJ7zAyejqyDLLKOG7STrozNOcxdCyY/C8pOf+dkMndvB1bTAXHpariyAZFxZ7LOaVpFgXk3hcVyW0hOHnmxYcLnf2BZF/l91re8b9uqwxFRlx1YpcX83TccZK8Y2slMAErDQg7vD8gtoiHanwIvUDgaKtnoxB4yrFYE8J59rUnELQtA2srT4WoQp1lB1zxX7aAZnAtDC7SQULlxeeEqmTwS8AI70JhUdIHpJfnkrso50yfopROGxM0ix0M3sHtGLoKPk7a0+mGGdzfGt1scKzBo0GvegN+kYY6Af9l0GI35pfTk7A9Yi94QmhdUw3FnyXAYXH0qAXIISwKrHR9fgR+jrqy+t2w+AYaKWy/P7H4ydE605AiB3v/YbZcUesHtQm8Db9PEnVBXvyXL1q7+srO9R9oC+rWXdxg3lyX37XfmTNIQEHwMkAzxFYBx+0O36fPONsvZqDrCMLyoV2bwE67wyq4xtEDA/DzCX5ZtUjZoD1r1iR01vgKXZWXzRlXpxQhZ5tqO1HibPL5QNG3sdqOnzYhVEn+z3a5ScVANhhDIS/wO6QsEEwHV2ko8a2uD7ahXo69UawmovQSJ/eFtTUTgRnuIRnbKqkR7QuXv17leVQPpZsUFk46kQM4GAvlOwxmlGsbRL4OPWE3MQ4NlB6gBDXFX0zGXly4YmGANos1vzoTqM9kdfELAPTIayEElQKXtOm5ak9fSr4qDBty3mZBJhKWSudNaZnsOmBKkZyU9OoLjzX9egQcZL4+Eqlrr3omikW5Z7iWd9lsVcz2yXxRxXWOWBCD/VVemqw7j2jZW2wc3l4uyEdqMmlYrvZPn0B99X3nNXKT/1Kz+uyrFjOVvVBzbcr1i7sbsGs0h+b+GvY/BsdgpC58kVAx/ImffHZCjmJ8FbLgPIqXzVZRqcKfluArkKlDnHq85YKM4MGkohk9SFYmPw2kCV0V4/l/+DdTVYb6TopTvB46PQUPJTVrV+wyA+Ob+6PHZGSp93a9vKPinBjz90X/mmb/42KW3cEr4eO7zc3OkmddygnBFM5Yp0mQR9jsuVZVS7TINK+Qc4x2WKPO3srMInJmQxHxum0FcaFFqBrflXk7fFT3X0mvPxQteU5i8pdnxdGChe7NzWO/73gPmU+Mcff+Kh8uPv+4jSfmOZjZmuu9mtzw1CSWuzgTnf83yugV4FzFlDI8SU6b+zcgNRBHtYwqE7gj7ZCda6K2cPhhtLu5RfN5gJSzr2tovuhPsMLxl+DOIH1ymXufzM+5ROkZSK3BNrOvKGwURGyyCgKndxPeOEtcAFlHIyq3bov2mpN45hEVKYCH93HZcry9teNq4g1jPizbK6m/bEC5ZmlBr5U2XvrW82LugWL+3FnYkKuVIo9KeMKx3tNdvXlJ0KAl0rYE6aRJqD29PnA+at8wj/iXS4EcPlmipSWu598DFZzBX0Lx4/NTs9deCJA1f83s/+5InPmacv0gH14Zv06Gnx+g+9sAkveWDu4M+ePlnMYUKtfsXQdgDVeLVwMn5KUFgHLGBNAMbqrhLghu9cHhZ1/jqgqkroQLGxLn11PseMMrRRrMvOwSlXFnzMyWoSvDgFg4U6a+cF4Mn3iqYHoTb7EhaB9A02KDWENOtu7XMIkMxFUvvMIae3a5LLZXdP4WE5ltZm8jG7wJCEbScWfwcsVctqHdto57FDj5Uzh8VoEBS0ST+Pbb1SlciuMWAMBwFz0YYVJbZLcTmJ+pWLqvxJAzuVA9zllrkKcMIcJ1oJyxjdoy8x8k37S2SSsb9zzjcM1nNkQBWy0ILak1GvDNAfBX7S55N4Aw9vKi8W2gGBHciGQmECIHewslJQfp22yndzRX6/neSuzeqldv+pLjaGfjnBrULKcxtKU8gGJiKsL2F5StrJS4MqTCQaihr/kFapFHwBuA2rdG64aaRDRpB3gxTybtkG3zkHy9hB7a98OwAX7SFeZOL5AAAgAElEQVQvdayLCAgEPC8rAPjecprtWx1HWdn1+reWdrl0XDh6QIGxYdFeM7m/bJHvuVZHGV2zsYyvFzB/7IAqeE4ETcsKZEhqgKDv6BNk/pAQuUnAfEl02T8oYK6/U+Q3p8bGut5yQSC7X9YiXGooPoRwWfBWLbmlZVkXgB8a7VIgKdYr0EabfdfX69p2Wf3CNzhHJgGUV1kWlfF02cWnZfDcb3bLVLG2q81tMplrvnsFXihrT4AqxY4YVLa67YuuPnbjJoI8V79ws+gf6A83mBgFW8H5QnVIuyowY2pLZ5ss5uRR132X9bwuAXNzBrXDbkfwKvzFuV5ADCEGPTGnAOweWe0o+ET+9nkCrsUX6C6Za9rkUkIueZTNJblkDVNVUH0EpK/WGEFDKwpuhQ7cIt2TlJTsQHRovjsIVDMAjIic2K+KfPjaULClqwvfegSufu3SDciJrjBZr3PTl6zuBp32a9d4rdsrd1vtgEwdV5KM0+XeP/398mufKOVnfusnVfJb4ASqtvuFNfbcFMtjnqoKqZmYJt1XLBQyAJJNwwqnsQ4TILee5zWaM2Rc4+tiRft7GkfMlevxlA+tINK/01zju+SJDX4ffN7LG0NBBllXWRO3jYfDW3EDChc7DidYRbdutK+UJye6y/n54N8Hnni8fOaeT5Rv/Sfv0I6Snk3V1pjNHPegJRtXdRSAbvrQtcMC5msUpzEqVxaKdAHMoT/nMk9gfv7CZBlVFczPBeaV4bihsYji/xd9vRBwV/ndaqjKIf4ccJ4iIOeF9tc5is/1PaMYlt/60L3l3/zBRyWLQpq4sw0MkU2rrMHjrPVYU+Dyc2wFG/wSG4VyOYhlWIfOPvNMueiiQmkcJAe661ro+7nDUcGzU+C8Anxb5GkGa19vfM+5OSkTewHjcmWhAuiw3Fd6tTa5H4sLecM13Bv3Sa6rwSYwcbYOgwDjWSFkzBcaFnOey6RLfvmY6nG85WrN4/KFcvo0xd+CoJYvzpejD/9t2XvbV2hHTTQg0D0glybcmkiV2CUtfESxPjsVhLpdwHxcAcPEz3Bxl3jO/xQwT1cW1iKK/N8LmFN7ApoUMEdu/NFv/8JPfsvnIaEv+GGN0cv10N16U2wo/YlySvUjwZ/H9MNdX/CW/a99YK4U0zgszMGfAPOent7MytJYMSZgL/J0yK6Ls3WLqy7kJkMIRsb3WF/BJIMRJdeoN+KvldBkJQn2vJQAUCx4Arl0DzILwOjxMUdIVn9SMyuYJ88wNsy7NZ5VQVgDgvu+LqnOMyqO9xpJcOh7cD9LhmAqCGIDqFhMBqRcWxlO9im+hhBpMEIYsS3J0lInJxw05hSGBGMCMisYS+bKojl28BFl5Dgsq2YwFazYo5tkMb9aBRRieN3eEIHRRxe20DMAKozhsoA5fswdetZqCXkDGIBsWmtzmN0ZnmkAbpBTVZTY9XCXEOy2dsezuVOoMTFEDcHg9iSE8I5AY6BSVIX12OPB/dK66bP4jOAiVZ4z1uDbPC3AJPcC+f/h3mIgB7DN/ORBKzlN/hiKVSgKMG/m7rKGur9Y09wEPyVvYvIMWo1prL/GOCR0ipHnXP0T1sw6Jo2b+Vpb3FBI9KcC8aiFE3EFDmCzuxCuCgRnYu8N5djrRkz98L6/K2efloLG+AikXfGGf6D5lAVUlh9brZ9/onz7toPlqd4vl5VHAmzNJqU63OA85ufPk5VFDyLYh0JD6hiKW1RrFCDV026Sj/mCLOWDSsG1IEsUmVho6+BIj7Ou9MhibkAvVxauWRRAd4l4mWQXlE5xaFSZKuTKYpcNHZ+T3zkWcwNNLPRWcpiDVOTobmO4sZ7rOisqscaYTxfk0YtNMeRh5NRWgS3lel5RIBV0vjjPdchQqmKiqJFznUI/IRvxTR8cVKYH01rMVfizhz9sUEhQCtlVfJJ+U7lq+/gihK2g2fKJzzc50wG6WKZTKKNICch3y2rXgYVb9DkzPyXgh+YTPKumtsPFBWA+oEIqQIx5WdE67I4UwNyuelj3vTZjR6JdlrsOAkStBGiXzTxOmWB0fg9tUT9nLy2WfgfOIeABhSgDYeF3akcVTWK3jPW2mp0TBnYtuZ6VE/7ckXJBlWXv//M/KL9696ryi7/zU7bGmfcyNljW1JCwO3tmgtCdfSl3ocwHIrA4uH3yfM85fEV/DGqrkYXbVAFQ+UeuWOaFa3IH1dd7Ryqs1Zwd1Y3zPNMFNE270ujjdc/X4JAVfEfLgj9EC8ONLGiRtiVH9TPhp/FjYqdqvkl+oVShost9p8Oq+pQCEu/5yF+Vt//zd2pumKPqkhUuS35rMl4IzHnGkPJvj8tNYUyFa8hrjitLLTKEKwNW9fMK/hxRLvAKwNyDy4AuvWiOaQxAfK+yNWRwi0xqYVVhSKsHcpwuu11TKYrhqudcDso5Pqf18NDB58u3/ux/KWfwo269T8szPZBuNtqK1pOzoOSrgmkpyljMkVsDTiPYVs4dVUzNBVmbG8CceiAAc93n/DNhPe+Si0oQSdzfwoUx0XmZUckpE3sA5pkyUTVCFLwjQB7KvSwVAdC5DpnD/fBlx58KYrePnf56+4N3nYO00Pv5wVPsH4hf9/JsuWPXgDxj5srxY+eyebiuLZbnHr6r7L7hTeJZfWWDgju3yI9841ifPGe6Sp8qMw8IrI8pG8uYFbhu6QoYCHBdY8cQXhszHe5YuT5e8Bm5SlXkajGfF6+7+96HFTOjnWn1Ta4s5cn9+8s119506794+9cpKfwX/yWa0nZGeb3e96uPslA1X18SFnOAuRe7mVy1QiYfxmqR0jSKKzDxgJ5mMFIFl/EjNBnMzsBR9wVgBoALQGdGa1Dt26TlNVarmYjBLEI0tqUJvMLqtKxyveQTbifFWWVORj6sITJVJIAyFqjMusmALXJsFUm/zco5vK6Sofkv7avMraL37Fx4ZARus1Ww3j8ua7wsZABYAQMoS74wPWFrSJuiwl08JKWDl1VeTN+PPvVwOfPMYQtqA0KNxRjAfK/Se1bkyJjmeMWcBDAPS662reRjzny1i9nji+3sFUyxnxWW75yevCVjUoVU9D+CYas3o0OkvfgD5CS80Xg5WI5T2fLXX9Qpnu1sG6aTcD2gIJDshZ4lC17az/h4n5hiQwSxAcyZX2pCTCl/s9wLegQYcG9xvmIml+sBHjlV9KYBhqs8qGKYR8W82+80JFtOsQnRMxj0EhY8061BXYXdYckOURd+o86FThv03b7pST6tQpNLnOfc3DxduszomQJy+1clIujJWTA0hoAuGP6hz95Tzh45aMsrtHDVHd9cVsu/EEsx159+4t5y69DJ0r3zywUold5QxTKwmj+1/4CAuSzmjKnGm2wqBP0BKrsM/vBAXik3v2xA2b+Uj3xYoFKgfFruKTxnWIB7bmpGLi69YuQEXJIXWPOBsFQ7MSTNyu9yGB9z5TNfpUlnvudnlKllrEeWHII5WecMVIVC0FfMjZeW5475CD6SumusJz0ET48VUjiaBsPH3MGnKOhKm0ghmdWyKEWK1RX5tUcWCCvz6uuwwEwEoIdgbWTaoPcGn1403rmindDukizJXQayyHsKCskNRaexy2UlWnPpooLs4pEdRQKtS1Y2qut2S5k8r4I9VKgUpFK/Mw+zboBfOqkVRwaH/ewF5Wvu1jXQEukXAf7hb4sCFgp7F8BdfA83Jtze8GTHtr6g3YF++KHOBaT3UcWTMdG7R20GHHaobXIwshsLO2gptnWOLOyjO8qyQMnqqZPlwtmny10f+O3yO3d3lF9478/IequMNGkljl2BVL9Zv8EKPB68wibcCggIqnXPg6sCSnwiPBz6N1HHWjCPaNJFGDy4Y8xldSPxfKJUoAT7eC3gk8GvKPMG1tG2ykZj3YWBoHKDymBr8HkY8JFPkXyAm4QffdBjxXbmmea53jPzNXw9fKGjnJ7tLIeOHCkf/fMPlO9654+4zqpvyz11AytHyLJUnLiPN1ygO51D9c9RKcVrFAA6oM8Dvd1ON9qp3RR8zPE1BpgPyy2rFYDFznD0vc5GfshBSEBa+VzKyloJsnlunat6n5zZ/Fp5WSvg41i9T6u1nGPz4g+f3Heo/KN3/RfTYUOzaX2gP+dkeZC1oFxsj8N1IvWZ7FwG5grATCXl3PPHyso5fLxTUcSAQwYVBvjCc3G8W1ZwE0QLOK876X6e7s113fiVy50Fi/mQrmE3C0s5Lz5X95pg+3FPGBhDj4sK96k+5lWZqBZzkx2Tr7cMS1YI9PfL9vSVzWtWlccOPB/KGrxAGa9OHri3fP1Xf0t5w617ys5NQw4KJvNKp2pC2NccHMA7M7b49vBzdhThosyz3rhNtc6JRxreBt0RmyMFYUFKBd04duFc+djf3FPWbtiiDQB8zGdkMd9f9l5306d+8O1f95rPmbIvwgG1m9H+Zr2fVf8+1dqElzwwv03pEmX1CR/zgCR6VaaWAJTph3FWiVoZbOsiy8UWlqggiJV0C2j6Bwawg2htATBg4iucNMFbg5iiIiTEzVYxQvaigDkMitzDXBiV2dPKmcDT96zNr+C9gkj/gKAIeV2rDtqFgL54CALtuRe2aOfn7Ku/+xnV8hIWhWqV4OzoE8dYvAh9PVWLmcqf+Hy3kzMVn++0QvvWVQDouuee+Gw5e+yIn+MteI372KY9ZfPeaxugxq1K4Rc8LQSGIYeQ3dKMqqQiKBWRHhUEo83MLQIonHgYRnMdX99IYRmdbAhiD2fIprwmhor228CJ8DT15IkewACTRtsObIvzDNDNM9OlxpYvrG7hD+1UmmKctHBJQT3LlDLXNuMlrCG5vWt5RCXHuKnvbdCHkHYbQIU8Nxm9g0WDviNLRDKzhmCLvtCOqGgbyoQhbFrQ4ln4DTcFYtB6nGsZz6VuS6wBK4opHIMu0obF8PgdiheFdExutFA/oNwg6A4/+Ily7tnndJ76Liv11a/7ZqeOxJJL9c0Tj36q7Og5Xzbc8uYy3jFZVg9tLyNyZTm4Xxbzs2dinWl8sZSg+8zL4tx9GTDvFsi9pLgnAfELs2VSxYW6FEQ5LLAwoS30IQFzFOKL2o61nzReKyhfag7pFAdHO4p0TSFXBFW77qXc5iNdTmfq3Ommodhr8EwZk5lIQ6e1MsX4BR0irBgnntmpTC849QYgEzDXtj/+5RjLluTKYsAuRa3TFy8JmAtUxlP0u9xshqTMaXcgQBU7QriFhLCMvC+ZmQfAJdpCqJEzvzNzrdO+ZeZFVX0IwKK4FdBsvuYwNvhadKBet3zHewTQz50/a4UJq3knYN7uU2RCUA54jeHI0BrT2IKC2DtVaZD5B6SjrOOLbucT3FdE572kB3WKUygsFANiEea0W9KvZ3WrvXPqQ3e6qsyrnz2y2hNoisJnxZh87VaOUfbCOtdO5gqBkVVKmzh9/OHyl+//nfK+e4bKf/qD/yiQKBeyHENSbHpp65mBO2L91F3DmLsY21UAb3Zici0G//RCDD5o6yHB7nKr8hSzMpJjmL86AqVlR8PEYeXfXDYezcoyPUAmVIHFWm6+h5jw8/K5yRegNfJCuw1ezckn8zzzQdxb2K1hxyEBdbbcN7U4SN5Rx4CDpE98RL7mzz13tPz5H/9++f4f/ldyIwJgNvOYg8vsW64G8yxoNoysseNAEB95qcfknjAs63m/wDn5zQHmEfzXJsA0K5Cm3RMykXk+go80X7Xn2X/PS/3cPOY+JUiLz81+NeqW5Ag2q3/XOW6C8Xqf1vvV+84LKN735LHyjf/udyJDTbajpbE5keaSXhu2mNf6BuYNwR+805fAvA+ZL2vAxIkTZUWFcew7zhBQ8ZVsTCjgk6oKittIr4oGVa2qAnjvYpipRlNYYwR59uPKogBQrUv7mXfLYg5ZEgjqVKWVqJIACe7gPvjP08iI6NV901eettMfLoRwzKwA5hg2FstXXNlX9m7pLp964JDd4LBaz0+fK5PPPFFe/9XfWjatGynrh3rKmHYHR+W+MsxbtSQGlSq2T+4r3QLqBHwSIEpRLdwQ2cUMF0uGM1LT4m7HriFZuHgO9RnmhZ1mFNg/rbz4c3LF+cMP/XnZM6iiRddcJxf6ZVvMH1e8xPUvu5XNgbf8yD/9us/x6758Hr8w30RbBID2qY//rfWJL3lg/gq5ssgP+ZdgtCa/ujASPDSpM35rbosFAK1VEpMF+E9dj8G4bVNsMBWYE7QflnHAYrLzXAQWBiKusOiGXyzbvmRrsMUcH3O2vmC4ds8IJl4ZaICf/J4z6S3NFAD20bYiFpboJvDGCsu9wq2gCpewsCJ8AjS1ssTKINN23BBCtaCOwb4Ys/PTSDjPTimPufrSRfqmDP6MAkPNF+4Mz+z/TLlw7Fm3DcECsx/ZuKts1yKypcfNC2Bud4rKibUQLxKIp9fC9KQt3JQBx8/Uo+4HhZXSSo8HBQYSojGsST7DQpYGVGHW5FEhGBqFptz+umlc+xFzYLBrBkcQHkeiDZFBhdsD0rHGMSdiIjnfq/Cd07FFubJQNa1LFnNbD2sFU8Cc6Yz7xE5JuENEu9PmncC9WunoKy4sIRRWx7aN78DHCqo5Vl14QpSHcAorVYCJGiAdn+vOET2iz3UnIcaiNV+625zp1CCommmCJzoY2GvPI+5nHn7grjJx9LmYK9HNNXe8zcW1cIdibTz7yCfL8MrZ8rI3fGX5qisulccm15buNZu1JbmvTOPK4rGIYB+sJVhGejWGAErG95Ybe+UedtEW8+mZuXL6rNwkepVfeaxTPubz2tlVhTlZqS8KPDI+iwsQB9kAFHgq6/jQYGeZmsbKbiccyZ+LzoFO5peLrqjLWDSBOdlcbEqHiMO93rLSrmqrFLjpBPmsedGtCgpdFPgh3SOFjQakLJAOFD6wqChUzmFt4spCZVRcWTxFuvWyNIgBCbiqZNvXHGDruQXYhfD30raGIF9wgX7815mH6t0SefjZISCNmcZNz5+l8qeud5VS7UZQr7N/YFCZ1HrLyZOy2lmpxBWF8uqRVYX86BdFx6Mja+0nPy+Fs1PgGoVgWSna2uRyQmAujSKHP65nuKi06a8LrBHs6xzwF4UJNC+dvaVTbZmW9bxHz1hSe4DUF1frGsAOvJGsMOZxgEXNgXmq+tcp8LFmjy14U8/8ffmL9/1G+YOHRstvCpiP9Adf8o5omJRznSZAzhUXazl2HS6ytnMHLA4EPw9+HDtRjXO96GE7zdUbtB5z4SfCZ9MSEGwtVnQYCgKks1sCNgN42AHOyyYZY7TYvCUMpcG5rPM1XvCKsNozXDVAMzKBBV+BX0aqxXA3jG3SFrrRLZ6Z7CyPHj5V3v/7v11+8Ed/QuMPn81dxVzKBuMVmBs4RVt5A8wB5eNyZcHfPFImdgprUmANVxYpgspKBa31oJBXUN6QGcErQiY3Zis/eAJy/PgYfKwJzkN+e7QuG7sE44xcvSbvGOfV85v9qBZ0dtSePnG+3PGjvyLwl9bpHP/m2EebA5jDDwjkrLKJ+U/wzF/cVvVbr8aBbDXnTp0qK6qS2diN4TpnUNG5kzqu6rqlX94PNeizFZh7Yl8AzGsucwPzTJnImBAI6vn2IAQNwQyIxOSFK4snEsKCgNLnnQN2dct+8Hws5jxXBqbX7eopO9euLvseOWx+g7V8fupsuXDiWNl2y1vkpigrOX1Vv3tUtKpb7365sowp1mfz2GDZvnawbFwzIJeWHru5TCoX+fMnzyr9rQC3fO8vqDrqhFIyT01O6d7zVu6IEZrScVzpMJxQYGhahQ4ff/yz5Wve/I1l9/U3GKgDzA+oYvTLbrgN/vjpH377193aumK+WJ9Fczfq2Xv1/jPRIwnl/XrJA/Oo/Nn7S7Hm6mJtscY2Vm+wyGZu81jV8XN8rqyRbyZVhIo/B5irC70y4arpVaBeb2LG6EUUgJgFyhb1iojN2Q6o8sf9cosqlg6LJ5+RbL4BeeFRwVPNDAzVrEWnH3JtfNjN3UfvEPBfgshW+FyHxH8NEGgnz69kE88x5nVgo0Q4FnMVMOhS4IktigBNdg3quNS2AbiUjWPi2DH/5uKQ+jswvqXsvOmWy/pBNxE4YXWVKCGLhTRpFJYFLVB8gdup/CnBXxlMY74SiVZrVC1fHTbgmNMawFVtMrUwSPSy+lczuCmEE/SmPNC4kEUFX2POD1/5BsPDYu6sGakc+a/GSYyELDzQzYKKJJEpo1t5zNnWXE2BIQvKeGYMeDD4ykObBZjiuTXItIooy3x2KrDMV1cVnu17oayEj3dQe9KMqSsAfiyTDBCzUMx14TEJIemsMUk3gQ3SncdKUQg8n8v2pA44FgBlB1qw8ORnWczv+1iZeP6427VaQv/KN71Vxh65imiOAQ1HH/5w2S2L+e7bv6as65su8z27ZDHfWJ54bJ9qZVwIhUOAL3InrzgCf6CHYkKy9Or6W27uk7VEvuJyE5kVcz91SrnLBcxHRtrFvGWZtfsIFnO5H+keToHr7VTl5FfZ7YHBDrnAqDJnyljcPIaHBEhFbrjP8EPsjIUQD1cWvuhYzQoUmm8dfY9LZIoRWCXmVOCTLGb9SisXFiFZgKRMUOgFSxlBlpzfL1AZ1tzIE94nCyQWZubMU0E+c1tE2QVB+eZ6zTuAXdfge0lfaQ3VF8kA5NbqmVguSTuI+jGjXM0cByyZT+g2QxLk/QoCPfb8M7EFLsDdpe/4jtPfBQlFtpLXjCnriZ4xpxzCnQJfgG1chdo0t0UKiPGfU+V1lMGu4eS10BSpE6G5dmVTuCCLubK7EIwrBaujo19d0/2hycx6g/FC4b2hd2ON1BjbOKABbReovzS+0zELZ5/+ZPmz3/+V8mefXVN+8w9/zta5MIgQk1DBEkqW4W+opcHqYx79gXnlc4yXX8kwXGSusX2Z6ys4tefctN4Cwi0/4Jn1+mDYaTCIVRnZUyQLAOcy7XGq/7VVPtZ8LL0mM27spGV7zZExdOo8JIBpAjdghihjHHDLaVQxrVq7bskOmA01OndRz7zrwFT5g9/6tfJD/89POHNUSq0YBjAbfTT4D7mz7KJqMU6u/im/4TG5sgDMcWUh6A9gjiIIMKcSLJbRIbmzeC3FCIf8q3zq8wDzkMfJk/KyVqt5HGrOS711lef1e6srSwxhtL8V6PN5UTR+/PxceeX3vqtMzaVs9fxHe+Nv4x/Plxd5dTWJm8ZJMJv0Me/X334FnZw6faosHRM/ZGA9D3qTmYUBnjkVBYQGt8TvTG71Ra/35zyTqtYEaRUJ/hzEao4ri4A5FnMEbj/AnPvnGqguLDI4iLFp4tOXPLSslneC9HoMFxZby3X+8lzZMd5WtvdKIZZLzrIUddI/L8qAdu7MCaVCVh5zeAaujHoMO+VWziTD+Q9j/RaB85cpbeKereNyiRkqTx09WP70g38T/Ev3u6T1sCTeXgOM2SmdVqzZLPFmZLfLnQlilE6ePla+/i3fVPbceJNzmc8oixvA/DpZzJFLCt59w4++/as/0aSJL84n0ZW2+Modev+d5Obh2oqXPDB35c/e3vcEEPPKqEs4WGhdTylAXTOtAppkDI2TALO+JGwOcacgLMtGA4+4vRk91i4YO2ewFs3kq2Yf1nJDL/w9AeYSaAgtLKeR0SHbZ14ZC9WFKHJtN35PRmK5bUAfwjx5bBNYc6lvGTAscGSAqNrVBp/xs+O4BSoXtsimRi/TVENqtUUBcxcwkTVtFZa1BOWtW5O47DzzyAOq6qhtO93fZcX1d3h8a9kuYE67zUoZq7pN63GMlEgUJqHFC9NKzajjHUr9BPjgGYacfMZKre8rZu7JYHO2HJRYKSDHDYtSbaPPR2ihNFj5qIy99jhhVmPsYpoagNc0EADVG7zejg6rOdUjAS6XNEbEJczKIkDGjR4Cc6heyra86SPcHwKUM/b6x/MeHvYWvLbWxuQEBeb5l5FHljnn2aZRo4TsK3l4c159LGiZZxrGw/f1PUCJrwoqd/+qxVBfQwv0PQ1OQ9NK0MX1MH8K/uQ6QZGhzRrzQ/d+tJw/ATDXd9HLlW98q0C5yrp7p+hSOf6Zj5Q7rzlbJtZ/nbY9taWpdIkj69Yp+HO/LObyxbTCGKCcsZ4VA+7vU7aTecE2radbbxmwlbinR/m6dezUmTmvtYF+uYMoLWB3H6nIFpzJhF4ukw9OzW9XeclZBX8OCITPTWGBDt9zMjEM9hMomWvG/cxFFdQX64nxtuKNdVFjYBAcxXns24wriLKyOBDUucFVyVPbu4w4VvP5WUcxBGiW0L4oID6orC20jXlZlnAakFXJUCgV7EiXGLQSymzMGnPDdq99PjUWtJ1gzlUU+aCpOs4OAdZtdhwIljVdeU4B7JLtQ/ILVa79p48pUHcVBYpCIcadxWlS2W7W09aNjznV45yyt2AdswWf9YxrEm43DnxWfIWA+qj8XanRR3/aeQ4p3vSsRSmrPV2qQMnO3oryN7erSJT+0r6LbNHDM8kMAthnt47AVY9zOLC1yyd9eWhDWa2t/POHP1n+/L3/ufzJw2Pl997/LgHDsNDHumHsQvlxX+uhOm6x+kKZZCQ5vwJYr5VgwrGyPPOevxpOaoUp7xXncEXudRmdp+W5Mlg/gxkNmWF5wA6K124CrsYdGde0Ynp5xr1CQeVz8OxQ0mIODPTzM7epoJxzYxc213awiJBl+vDwsfny8z/3i+WHBcwvSemJPkfPAh+G+4pdpfzMOEZfugU2R7WzQ6YNqn8GMMdiLlcWV4EMvs5u1uhwFAOr6RxbZUblLQ0h5acnvXse4nv9e3l17zyc58WueIDpBgAPaZj4oOV49sPzgguF3mdUmOx1/+IXy4lzyp7iCp/sBOmFtu4tQvhdvj0YaTGvTWTNs/CIj3E2FoI/BcylrJySe97ic8eCNr3Y9cZiDo3OysVl6rRA9vYYZASMaSCfGR2KtrA72Q9bBiwAACAASURBVCWZQvCnXVkSmFOtFBDfL9Dund4mMB8Z6igb1/aVQ+rX3GkZbq0R5s5SMK74zudqsa/AnHHQGlUW2tLXPl3axYfblY3lknYi5xWXcuHEEVmuX1/apGQQ7MpON9gIYO6kDeoCPGWNlLcbdq4tV25fWzYJmH/q4b8v7/vdP3BbnKvcgf7iV9qRJyc619lSrl2XBWGn6ekpB3UPDQ2WU+dOl3/w9d9Wrrz5VhkbiC+aKfsffbRcd92t4iMOdP/wD7/9q3Aj+aK+RFuErdyp99Oi8/tqY176wPyOr/wO5YlWVpZkrkm7AUSg62CZwX7hWNB8Fby+Kk+MxWycwrqKPy3sIK4Ly1kL+PNFzXPD1zCshqR1g+1iQYXolkVguLFQNS/axcKpoCnBmoF0NKsBJrOJtmynySf5dfapnpCyxYyZ1RCMPIR4drXew+CoyaRquex6KtzfvCG3z2j7RW0XtbGFDfDEAsZWk4E3aysUFBbYkX33q5rccYOYwHHKyrJhZ9l23Y0B2hgboElusxpkM1JkXkimOicfcwR6h4u9kCEiLbJVbDAXnlWELlwmjAy0pQpMPsFsGy8rA7m1y9JlLOrk1eHx31CQ8D1dsatSKBieU7vm4LYR1klbzfPhjBX+cW0STGwRLpOLXRaVrm4FP5HLllR0HqUIMQsLc4h4W9Gdti/GHQAg+0GCEnpSx7nSTNBCpdGw3FUah6aidDiNxvWmxkMY0iXYawpHZoPdoXq3YKZeCvb1DeBq/cGpK1NxrQJKv6NOMdL8NTASvR+6/+Pl3HHtnOgrAPSqN75NtKP0fAnmT3zmw+W7XjtTDra/WVubYsr920Qn68vTmZXFCm9u57r8swBrb3ebLM4aU43/rbKYs666tV1KqreTpwT09KzuXqx1qrYpCxFbrgRB4vrjAj+MpHL1zU3LSj1IwGeCI/2ElXxAKRxtqTZd55qkDQ0FN8ajZom39dxKNn7q+qv5XiWA2dEt+pYrC4DGbaKaKBZv0o7OAaIiHoFqeYp0lFtopBBzeLG2ZgeGRS/V+gmAZ8wS6Dgm1FOF73isPJfJTptDl3bkUBaskGjSerrx95USIle6efm3Wwd3xDPZY/DJHy6jymf+lCr2OgBS7WeXB1/hRfmYLsknlT6OjcnHXO2fFV2T/YXzZKdPRS5VQxQIgecxVTDEs4ciRIxdr6yx9HdawLyfLEUYFgDkspgvGpgD3DUWGj+yGmkPJjL/iP5QwAEz/HU1xZ7RcnFgXZmXj/kHfv0/lA/uW1d+7wPvllUSK3GsdwM0cLlBbFjQvUagcZ0TlBAKsHk+7/q7CT0MBAGczREaO1UhRII2KiQPhZYhTdCFAsWE8Fy3IdrklWYgEjUP4li0wbso5qTROrsswQ/MZ4IXE/MQYLkJygOkVx/w2MELgBrPddv4D9ZR13HyybMzS+WdP/Zz5V/8yI9J2YnsKfSpqQSkX7luhE98KzAnD/WIFMjx4QH/JeNGj4A5AaAAc6ynGFfOq/4Fuy2hIDTlWhAxPa3Od3xuTEROSsq2ZOJNt5WUkw3mHh+i3yGnX8yVpYL1em6r1ZxdpwlV/73jh3+5PHuG7Ck5lwBVdzwXnl1XIK6ULQ1/bkuEoKVMo0gX+zEWaL2c0TgsqnJmAG8zU207SBkC+M6dUwCo/MyHd8X11apOBhYsxfy1+6jetpgr0LNvtKwaHi+bNo6Xmc6BMrGg31Ak7GMe8QLmKWItN25XwLQU9BNikc8+L6OHFHQTHTyGQka83C60MH03OGcbhqwsfJ8t4306/5m7yuzEYtl61csUGhPAfPrUM2XXda8pbTKisUviQmHqt7Ou+HPEKo1pV/BlOwTMt60pm9ePlHse/rvya7/wy2X+wpR3Vkj56viFNATNCmz3iAetWbtG8kEZXWRAwLDZrTGbUB2Da3fdVK657RVKmShXGCVaeOgzj5Yrr72tDEoB2LZxpOxcP3b9Ldfv2vcCEvmCfxWNfaUeqiFY9Rf14RWYv2TTJb7CwLzHwNzIrFph66JPxsRC8BJnwdb8w/E1AWL1s2pq29zCIURmwoDMy5lBWLBjqCvIqRkT2K6EkbJNw5avKw/KlaWLjBREYrstySwN0AMMXeYaEss8AGBlNHFhMFq6rHcAmGRvNcWfgWsIywDzMCvH7UdbEUiMVfIWW1jSkhkiC+aM8AiwTNvJwUqO5w5tWTllX45jHQcUAPysDz9yfzl/6nhmG6SPWpTrAeY3hCUnhUMIiSbj9Q5DgvQ5PcsVxMTQsMgxOBGUiDtI9LrOJ96yKYHcx1ZferswAMhjkhrCIYJ4uQ3uGNF3zvMce9AJ/kTixTVVgcLH2mkSAW3O7hPaPmNA9goslLj6oJJdlHKhEREw709LIiAFYMz9QwBWf9WYy6BRB1z60Vi9QxBbYXF2iAo4QvB4V4SrTCQVLMR3/6ZzYnsfcmP0IrVX+JkHrcfY0aRQEBw0ykhbSCe9VaHqVHe5lqj+6ufiyhLKqO+T4Ofpe1VBTzsnzBZ5sq+845scGEsgIgrN6Yc+Xt7xiqXyRN/ry7rh2bLSvasMr1MecwV/Tk/Ix9x+whVoCZgLIPZhHZcVpVOWqhtvkIWG7A/agcJF5PhxSkULtynwkl2pTirV2J8k3GEMknVCu+Z1ZkaWrEGljpsizkG91djyc1+frrEveaqzkIa3khEYAccD1rFzI7ACXfJQxgqLNb/rn95eQDigH/94ZWboZdwB3QtKNyiFz6B5ldxONOYr8slkF9pKI01WVhaAOoohlCQya1fglHOkQyMGZdEKtnfJKrNEoQ1tU+O+36kx7hJAImCKZ/bI353whjkVl8EtxeSeVX66BdpHVTJ9SFU9nzx00FvPuHBRFItiRUvKX7ygKoht2ukYGxcgxqVt/oLzn9uy7S131jjuNBpA0qnq+QMCCmTQWdL4dFtBl6uOWnN+8UIZEmgP5U3CuH1A06O5buu1rzopJW0V133aGUiU/0CXysqjMcONTm3pHNtZplU19v2/8m/Khx8fL7/7J7+k56FQRYrIyD0etJkkHJRpHoOyGsHXuEolkZvU2J7vEujBUu/CYwlgvQoSd8VaYq4if79dHbm7jycug18Dwr0mAiiamuEdAGvNf1TUhPZi4diNpX72ufUf7hTrOIyaAcz5z5ksknZ9by6xwh6uJ+6C58ccPflO8t3sz3f/+C+X/+sd3106euV+xJoOdmH6rBZzrx+m2v7m0Q8Ch6PIUFrMDcyVwxpXFgoNJTA/J7dEdlsaO6wxI8GzzAWbUxDi9IVHkguZDmItXn5OvSbGuXH7lC/xhOjz/x8wP69sTV/+L3+1HDyuqPCci2hSCq06OLY24+KRYJ1HmE8w4MGna37zfhQYgcmzCoSdJX1sBcCcp6DvsJgLmJ8VaB9S/AQVdkc2R1VPKnxyDoWDyMEKdmCRi5+St3ydajG8/2s2lLuPL5Q/PrhY9u9/UvMkJdd8Poi3u/NiWS//7iNn8RfXAZRb6oQYhLMO01LuNQkIJ3UTf7PAEH7mqvy7cVzxII/9ZTn/1JNlx+tkZBHBzyt6fvrkEQPzzj65pYGTsFh7zUcmFo5hRR+Ve97LdqwpV8iVZcuGkXL/I/eVX/yZny+ziicaVoGqMKytdjatNWvGy/4nnii7Nm9RbQlln9HxJcC7mtw/NFaeO3O87NlyTbnhla+W29FCuaDEFAcPHi1XXXuLdmcGZFXvF0Dv/sWvfMUVP9AgiC/SB9HczXr0VXp/QGvAVaK+RCzmCcyDfzdAbGOBelUCfgHZaSWxVh1nVNBrxp33MDuvIA9BFqj5svPNPkxMgYKCHbKeQyMOH+cA5suAAwJhKGmfwZ+eoGDpAToTnNcFVa0DaYM00I0m2zadjI0HAgzytwRrwZHVpuRhZk7ZN4MMA62UOtw3gX/lyhYwttCEFY9gjOW5yMDQToEhgrMoUuQx4W3HCIP5I5+9t0ycOhkKg9u1qoxv2lW2XXN9suHKWHP8E2zQPDauEVYzcgPplNZvJQAQYYtViBtAqjNMM/Z+rgc9BG1+9vQ1J8gPclvTrO55SwtS2qwb7N7QlDk3UM1Z4l6ObwwhZyxsoRo0xda8GT/WTTFQb43KZ5AWd2nrnp2GldhiCxpK4RMW9KaYqbsyPga48MkZxpn0V6et7hnUO3rOKPDicUoayfvwhCad5+BUYePupAKHwuHO5dwYeMYY0G0AHmPgkLkcnxCX7DIYCQVAEXM/cp+ysqQrC8U2rn7jNzmoEJ9nBMLRRz5R1vReKjtufHl521Xz5eGZbUo0sNmuLJNKh8Xgh9tSgJBZuasM9QlcKhFztwI2r79G8Q4EC6NwiBaPHZMvolqgTZZIVSYw22YALD9yZkhBmKZnzcOcUisODLQr+DPAjO2bAsT9cilpCHAPvsBXWhFjTmLugi5COYoJzc/6ikDq7qLgD0AqXA+wWmNNXZJlf54gVN0DH+MOBWStUCRJ/tHtXk+4sii96BrlPXdwIMCdNuAyI99J3TOej+oHCBeQEjBfUUApPuaMQ5fcaLBmzojfQJt98st3RhRZ4gmArfoYE0pasxFVbxyQFfrQM08FfYvQe/o1fu19asuM2itf8K7+slbgCv/OBeU7d7pE6FlziUIAkZAvvk3b0LijDSmdm1OcMi6sY7mysG6n588rQ8Owpl+7GABtpV69uKgqr3JpifJDmg+nYtVOGfEvKP8Ie/s2A8y7yxJ510d3lvmJZ8t7f/5Hyj0HN5bf/K8/Z7cc7zxVi7jXKeCYcQV0IAJIGTkn0IgVEv/1qIhqmpfP+6EH/q7suPl2F3GJmgnB94Oze8pT8TdzCQXJrDba2bB+V26SPLsC6SCVqGDI2ODO4nwweZ4t49wFnpI+K6Z+5BZNTF5tcG6wD43FLqB/N5oPa7q/m+ehVOaSrktbx1NlKe//i0+oxsQrlNhjbShbQc4pCkSn6VduH3b4rNtB0TCqf2p3pMVijisLb2RcTZV3XsF84yoyVGOqqjtLsJUKm2N4W19eYzn2TUt5TsILz20wrFhbvrVlGGPxwvvGgaa1PHYZ2F2dlIL75h/71fLEUbmW1AtDyMfkx51NVzngYZ02yEXJy98AttCX5rlL8mB4eLBMSVGePXQ4wHxVGEmTygtXlvNyZVl/S7inaPdCwk8uKwLluBiRCe2yt5gcVbFlhd4y2lZuEN964yad3zlX3vlnT8vNhCKGTLra7MrGEFa1jFeLeALy+pswyir5eq+ScrxqRTUhtFu2WvnLVwuUr9GO32ZlrPr0f/tP5aLGaNcb/pEs8NpxVNHB6ZOHlR0FYC45J5rAsAS/wnLOXLMMOUZw9g0715Urt64pW9YPl4efeKj82nt+zcGo7Lig9DsDl/jP+vXryv4nnyhXbNtqlyAYTJ/ys2/YuKls2rKtvP+Df1K2r9ternvFq8qssMnkhfPl/MRc2X3VdVaaly2Ly6md/VMb77zzzmp1/Vwi+wIcEZ3t1GPEVMpHJC8UTMC0RIGh53XgE1+ANvzvfETFL+AEDFfMVvutdyj4s5OsLC2Pbq7NZKIs/tBiWQ8WTC3APBZc3L7p7xZHYF4BnWJR+nuCWjPhBMLVch6nxaKNVGm6j3MKC5hLcFGuOKpmRhuMgbgHlkjDh3g12mGmH80LoZm/x+zG/YHOCKBU1MMbJs4027M1nG/5BH+uI5JdS3OPwVuCOFudqo85AWAqkIQFG3/h6spixql3tTYjdA49fG+5cFpR5nq6fcy1QMc37xHzv8bMMNqVjDHH0j6kMAg13kVYBMzxV6VKqn3yDU7VF3euQsWUHigEuG64rU0FKSBM8xXiNZ7vuU2mEVU+414BtFLLqdNusBqgyfmt3QHOiV0RXqYLW8HkniDwQPq4BfnkAz7IY+4Uilj/ALNY/T1vCORQOJokVhWMcKYK5YJnVYBQCaKpTkTxdARx8J/og/cvko7qGPD8HPw6CnS7JV0i1wUwr+shFJ+QkewixKpwoR7oyTTMogr/+IaNXUz+6b//sHZOxIewwsv9ae8b3mYmi8BGgXl+36eUjWOl3Paa28qbdkyVA7O7y4Ytm8ojDz2q4M3zBjA1iJpnzpM1pZfgSeoRrZRrrsbNKVxLcAk5cWJWDFluEypWZGEgpOYS8AJcVfBGvncJFPzVZcWekjXYXQUEqhudutapCFnCzLm14UQ1Vurpai7IywAgwDnWGmPUQz5w/SVn+bKu7+oKML2yLKVAwZ+0w7vVNsFLIdBOgIWZvuMLPzpOppO4H+DN1TMBv4Ai0RkBUhBdp66Lc5ReTAYuKo52yOrdobSR8xKg0HW3rJi27mt94MrilIjQqdrbJ2E5PDJW1ohGHz/ylJWXdo1bh5QaCmMtyZ98Tj6cHQo227BmTKBWri3yLbVFFFDO2sciq74B0LHUA1RGVMGQXOqMFC5pZPwgQHhK1vYB5SGHNxIAiiXw0sI50ceQrdiryLgjsM7A4DPtfpvPhY+zXcLwaR/eqnGcKL/zU+8snz6xrfzGH74rCpolBzWbMTil8BFzG+O1Sj7zp47t127/Zhki5Q6ADzvtQ0nQ7sC+u/6m7LrldqW3HJcSkO4A8IdAecmz428ouslNAAL1mBX1AM2xzgPWm/dVQF2t5T5U/ceTJwaosPIbv7EO4nMrALdN3sYBgHmkTOQR8GLGrr5qs52+0bQbPCyOXypHjp4sh6dlZRyX774D7Gp745k1GA/uYgxn8RZBxcMC5nZlkeV8ULQEKO+xxTwyAaG8G5iPjiRfSiNXMKrKhRrz1rSI53iZNUY7XvxFT0K59ivQvN9Vhtbgz/i5eZ8X5jNn92FWiu+XC5g/dkTyq2FJzrFsMEJuVAejFfPlCbkzZ8u2c4Zrd2GgL5SwY0ezwE8CewNnjbnSf6q4gkC5MBxMuvqIVzcWCnFhNe9SGlXqYlDpU+5npU8AXuN/zcah8k+uH1cg/GL5zt+9R3ShLTgAOUat5NmOQtd6aNO7Q/KpU+8OZVXqkLtKl4B4r1zK+uSe0tmmGB51pUs8FvaCutyje5w9e7x8/MP/r9bfYNn5pm8Tj9GO2uwF7YoelmvLK0uXCpBFzvKIPeJvfA6X1kFl7XnZ9nVlr/zMAeaPPfVY+Y3//BtlQTvLHXoWQH5KY7Bt8+ayRe8+VZPdvXNXGR8blyQTrxEfVXbc8tSRZ8on7/pQuWLzleXaV9yuYVOq3CkB87PTZcfuKzLRDIH2JGO4+NX/+v++868+D/F8QQ6L5ihJjDvLA6LJJ036L3lgTlaWnr5wZamAAmbXAGgBzmLJVABUgUddyzCsAF+xbANsBRiszDeu55ea27ku8XAXEAHnAQeYViaMtUIL1FuXsmDhe4c1L/AfzD4AF58jnVQI3wbDz26FbwONCgFh9mNQy+EIsjLsDNTY6IvP8Mkwe4BZ3LzJtpM2fX00p46lGRfHYfYC5ktK/0e6u9XS3BFmWPCaFvOw+mDtPiRXlqmTCvoDHGF10g9rt11dNu1R1b7m49xOD5nHqsleYZ4Ac7bp2wgyS1eWKCseFkjPFUPn68IFxoGCOV52xfAg0u8YV//m4asZNlIwIFD1X6hGYWmyAPNxnlGt0AHcK2BDaaliwGOu8XIxHDFRQNiiLeaApz7TANbFxshbiNMYwVnLFgBTFTIxn06H2ZipAOcxBumSlMpmytqY90CZPq+Z3zcmt9J/g06z8ZWKGgC0TlLSY6v4tO8yY1Wf41qQKUtMlxHwfEnA/Im7P1SmyEeuF5bUq1+PK0v4fwsmlhOf/RTpzcsrX3NL2Tq8WBY7tymt5qbytIJ4ZiYnBSSxCkeqSiZ9Vlur472rFIG/LJ/llbJnN4ATw5SsdxJuJ0/KYq5zuwQq2yVZ2D4lILdNbbFF3NbIcElbmgdEks4tQJHXsC3Y0XnHLdiNIrlBLDgTkIU7TWpRBEPZjwWEMOrs1E6JAO7irLKa6L49PeG+s7ioHNIkRqEtlQ4lKPGdX00WIlxC9PuadYBJFHroNXzVq2uR86ED1NShHgW42iovwLmk9vTKbQVg3qY1ujg75/ngHEkoPVdjvBjZWBBanDc4RJGYUW21D5Wnn31aO2NK76lUZqxt/MwXpIzPq8Edcu/YtFbAXHOwKGBOykuAV1in4H0rdp3pkdUMV5hRZWXBKm0/ekqIZ9rDyYUzZbh3vdMveuUCNuYB5uRtZydFlrp2ZW1R2xzQSvpHdsjskiRakPUQN5OO/vVKt3au/Pa7/2154uzG8iu/9x8aFTbDmslUMHlMCm4H+sMY6Zqn9/+djATKpqY29Sj+w26Kuubk4X3lox//RLn2thvLtXtv95q9hL87Vl2vzVDQYl0lo6lrpX73Gqh8I+Y4QHycCK9yswyy42/9HM2u4LsJsn0LfMi5mvNNO+kSw/e0mHPcWVQMzKHFuEeDdIN6/V9wxuCjAK9PHphUvZpNWpuRMjGaG7zO7Ut6daVS+oENRXRO9c9RpUukqMyQwDmZWnqpdSFQ2CFQiGHmgoD5mIB5a/VP393DGPerz8sPjVFtZlHLAbxsvD/flzre0UMrM3XGcnz8zJyUujNMXykydMf3/HTZ//gzcYXbiHxmZ46Ox9r3q+YA92Ay0MlQPRGZD7x2VDu/PoYLCemfPNnpDgNta2fKxpShbfGsigvq5DFYxgm0o/qZS4G1n7pA+tB4WTW+rowpa8r4+SekpKo3gGqtGbIk4nbZJZnUTbwFNQf0vVs8s1ftYlMK5XdB+GRWLqSMFlWE2flijufl6808zsxNlfvv+ZTWZH/Z/cbvkCFfdQcEzM+fOFS2XHm73N4H7GMeQLwZ+BnBoHId1O7cdfIvv0ZW863yMT/47JPl8U/vK9u3b7DxQIUiyzNHny9bZBGPYFzhALVjQvTz/InT5ejx58vzR4+VaVnHL8rn/Ya9N5cbX/Ua+ZjPlElVJT9/brrs3HOl3QRxq2N3UsaI3/+J737bd/wPkc3/ppNEZ1DIt+h9ULzmfpPElwQw7+1TusQEJfzN9RN8NFmQV2awIXvJ1cXVMhl10z5+C6Ze/ZkrIzMw514itCZ7DuDnlxlhBARG4QcJJlmLsGgZmGOFwQKc/ru1ImMDlKMgJHOvPKFaZmLZh5uFWaeFBOu1XhPH0zW60ccXwvDG9nvyHHMtQG3tU6P/8I7woyRTxMKcsrLIGgw4p8gBwruC/PCtD+Fx5KG/V4C5LKX6OeyZpWzY9bKyXtpv0z2jsspURjROYdmAkaoqGIGm5F/GxxxFxiMa1neET1WiDF0RnM5lbpUoKiF6ihKQM5V2dckqn74TTb/cEoP1FYbZspcQZ8IT/U/6ejNcPDeZvIVdClkyZHRqm99562UxRxHqFKhZBeJzirqYFlcBrO1zq9kVCLHJSQHROTf+DSs+fYh2O/d7w4rOcdQKel0FbyVIa2oeI3rmwjkIgCaaTxBTe11pOajYHuluZ/TRCmQqf1j+sZoDfgFPnGBV1oOxUh6/+6/L9DkKBcmCq4j9K173VoMdLCNY80/uu9v+x7e86rayRz7mU53bFYugyp8HHiszExMBQvQfMJ7mzsoVQ8U6BTAB5stl6zYFJ0qQdssc0y13jVOnVdAJi6+sxV1YjUnsIRAr8ZE55mPLH4CwILDZ26My3AqY8pirjaR16yKlWD4PiUV/IgiPxUYmIDNVT4n9bQWKyEiCrztgCMpkR2CwL6x4xFgBtPu6uA9ZUWStl9knXBIA22Fd7SdAU20mSFXYtKzbiKuL8oSrTQQFRvaToNea/g+Fc0AyGbBPqjEs193aBSDorlPjMT9N8Q7RnwJR0f6m5QK0iKuTjXwUr5Ev+4gKxMhFZUhb588ef1Z54cWjAOYUPxLNkglnaV5WbOUP37RWlm5dtygrOtmZAOaLalenEMCyBD5pzfqHZBlVG4e7R8NlzwonAbUqgqTz5hYmZKleE1vlkJZ8y5fkY766TYGHAPBlAsz1HN0bJd8lrDTW7Vj8qR0qa/qKAEN7z7BSLy6W9/3qL5THTwyXn/v1H1eXMsYiWYv/2BdYz7Er4WJ5/pkHygHxpz3X3VI2bbtO91aNCQWStSvV3D7FRLznfX9Vfvon/mkZWbs3Erq4iiLIhZuFUhM+3KzVujZTQc/1WAunheyI3bFwXajKOD7urJOgEU4LQG2iskLhlRQXhhJmC3t0LHZNgoaczYrr7R0RPNQFZpPnmWfEdMeD3IYwNsVmH0+6WB59RrmiVdwGlzMr9SndbJuJZgXtwc9tEQ4+NCirpoE5FnO9+2wxDxczCskwpxdU/XNMcQwRq9FiMfc3s5foa4M3VmlbDSE0s8qLvCjbF9+awDu43n8fmPuK5N0xnnQylNVp8YWv+J6fLI89fKDBX4NBxn2DgSc9eHpCLtR2ZI9aO+b22a+bcdP6ioHnGp7L2tRbLiMmp6GtYbALZhK/h1YUz4cWk7+6AqhczEq//NBHlP9cboD//HVry9n7PqiAbTKZLLioGQYOiIQ+O1MKxZ70uVsZYTC0LKhOAfRF/An8xnSp7w7c1FOX2S0XAUwr6Puxhz8rZXWgXPFl/1jubj3KNDdZzh8/LNl+S+kcVHBmWsyNtFi3dmcJntsv8H3NljXlut3rFJw5Wp5+7mB57+/9Udm2Y2cZ127chOKKzpw+o2rMF+xhQEYoxpu6DksyKnin0G5ACmiXKX/vldeX62UxPzch5WDyXJk6NyNXlr0B6g3M/T79E999p9LWfHFfGvuvUQsWtGY+bEr6UgDm0rR+qeFSksuUtVKzrxjM+gALHUaJRbFOVBJ8LvQAYAEOI21cllg2szI0jCdwL4jO2U/MCszMvOANFDkN70EyWkTw54oWSjsZE8z8klfC5AHEqWFy+8Bc9YTLCcqtbWUIznrAGq9uDPQ12uMxiYG4jK8ZkFYLbZMHNh9kDKLFlL6FdPGi/LgWFfncKQt2h4An1iaAbBj98DUZ2QAAIABJREFUo9Huu9pxSGmQpmUp9Vil5XnD7hvK2u07giHl4LtUtZmTbVpmBuGWqkIkM6RmlEC3EsCzwj/bQVDuXzZc94pt8QTdFppZbChYmR/ntNT5mY56HN2OBKx5bsxvMGsXYbG80LFUWpQUQdvhzH1sI9uK7T5EO9DwO2SthJGt4I6j/vCdokP42vIKX1oeyHU2Z7gd1U/VUxYnJh3GnPoS/021xAcBI6Ek+B7MVVzqefHwmxq4Nvyc2VYMoR/gIn5vWvMte1JQBiFnYziTCTdphuXZ93eO7aj4GQOm+8my+vjf/rUAtgL7UCTkK3n169+Kmc3CoE2M99hjdzm/78tuualct25SmQV2ycd8iyt/Tk/IKmKrYFSCpL1zyi08OkC1OMmijhX5G4b1GYtQlwI+T59TYKMyofTKqg6RdA1IGZJQaZM/Or0gsxnyra2NEvMCsTLkLszX4D0BTgC/wPpFBWfaJ11rRJDb4BmfxRqvEansMu2djpM/BAuRM/joQViNRoelXDILah/uI4pnMrBamFObJZuX1BADTr2X1MdB+c4zsJ1kj9E91quQB8B7QX71+KqyDe71BSCrW+WincEhgmLTsi966FY6SWiO3abFaRVWEq9hNxywtjCjzEr86HuFK8ug0t1tWLvWsRwT588ofaQCvGX1XK156RKgnpoTYBM47xBw3bBm1Mq76xloPpl/8EM7+a+1JT6jdGb9ypxAu0f6xlU8SBZn+ateahP9a5Q0rHKDUdVQ+bOzdS67v+ZiQDvsmut2FViCbuTPutI5amCHIAYEOTOL6KkTv3pZuLGit4kHzakf//W9v1OePNZT/t17/mXkZ8aKb+LX/xLMDu7UeK5ml0E+swcf+2S57557y7WvfZ0KnqxXyufN5d6P/0nZunt7efih+8tD+8+Wq9b2l6/+R98qn3wVoVp7pXhQAtUKirw+k7dV8eG1GACRJRBNSMXfO1/MbricxJrTbgJAuvLnBlIORa3yk1xswQ8A3TZAADyqckcgcQY3k34RkA7dmhfHONhKnzywcgPfL+UYwe/HzsyW48vrwgiSQYzJUQJCJjB3AGiCZANzpUgcETDHlWVIAXzEM5DHnAqP1WI+KVeFUWX+cSpgRqEhfOvgRVuarxzb7HNl9S0n5Mdkijnu2aVQLFqAvE0VeftWQF7PaQTk6qQZKW9v/Te/Xu47IJeT3B0IyVF5Gx9oX8i8pjyrbWntRhxD9R8Ws5nSvZ2VheuxkjNBuJqQ+YTiQgKfZWhLBHdya8ncAOYMerg2hjUdoB5rQxpq+KMPCJwrp/mgXFluXn7Egei8nPkHOks3S2RapCIUBZKqVQ9aypSyNgIY/PJXwJhMcljOdS47YTNqz4FHpbAok9JVb/oOedEoK9bClDKwHS7jW29QBseh9DEPBdmpExPc871P2Oda+Zdft3t92SpgfkTXvftd71bcitw9URYyJqVBDboIIyAWcIB5ZKkKhbZHLnuvvv11Zc32PfIxVypFubJMnLlQ9lx5rRX6BjAXwSob1y3/7p13Pvi59POFOyJae42etlHj/semoJc6MH/F675SlT+77coS4jRQjdmk10+1EIS2Xhdj4pvWVWTG2QAWtiwCzHNZ5n1M7H4WoxtWRttPqjBIwBOgDWuN2LMWABbnS9L88M3E94u8z753WhGcHSTb3Fj4yc5pa/CIANsOz/PF+DgH4AoclX13owI0RTMvtwzXTlfLeXOMmue5lDW3o/1YE7V9fUlb1fierpLVvI2t6QzuiPEIRgU4ffoz95SZc2eTAcfYrJfFfO327R6ryoQbPoDuXzSWX2Emi2LmpGRbTZo1+97abupzGtvDOQcGkQAn5t/jEVbz4J/NPoXSFEWDuAb/WGdk8X2rpTgEag5hCHh+tVDhFVZ7g3+s8Ahh700DsNRurK5iwhH8OWnm1IVVgyA9rmOY3DBAehOY2/omRGFnGlu3sVcTiBWKS4DlbAP9c78QuFkhESUQZapez7yZ0QV9BNVGP4OS4nn+yZ0MN57YIYAB0o7QZsKPvGltvpRVR+ulNVtJHUkULlx5Dtz1FwLmKpqhV6f8la8SMCdgGOsplSJPPvJx5T7uL1dcf1154/bJcvTi7jK4XpU/VVqZAkMBQMNiFErPpTIi4Iyveb/SBG7epPR7kmeR6UiBW+exsOA6ERbmbgGq1fL17tSb/8Bo7pNW2oJAXE+37qVMJfjjrpYZeUmWbNVBcU0NA2C6jYVZCxMrt8cCGqNdjImtmOwoEVwJEDIxWJFYOyQBqL5O6T7LSo/Is1gvuM5Q+XMRlAod6jYAqSGCLQ2owy11nYA5snfRgZVyF9HzMRLgo858ITDx4x1UZpmFeQJbg3X1KkgLQcpO08J0bI+T0xxANT+lzEqATFJ6eoZVNXV80FkPBuRqdHryrNJIKthLjVgt9xN2xGa0tb0kQNEp39ZN60bD6i+LebuEuwt2iS665V6ytDQjYD5dBkeUuUXztaFvrfkRzjTdAuarV8klBIV7aUK0sEEWcICJwLIs5gRdMsiXdM7qxbNlpWdcyla3cDa+rsHn5tXmLuJIVJyIoWPM5zQuf/mBD0rJ6yxv/cHvk5vAvKzyAhLWTCOLjXd61Pk2Z9BYLAcf+Wv5VB8tV9x4ezn+7KHSOT9R/vwzZ8o/+4ZXlb/9+EfKRx48XW68fkNZOHehvPUff0vZvO0mg/2Leh7uNV4tJoVYJ05Lm8DQn0wH8AsmJBTxBg/xqgsjSfBqgHmF8Gk8yTVuyFet6qyn+mCOA7SYPx1EF3EGMLJyqb/xzpSM8Dsrt9FGb2rBs2qD/LufpJ2Pi+WB5xW8JyusM0DZKFEt1sFXq+G2ustgBSV3+bAC9wDmw9I+e18EmONqMCKFrQLzykltULChrBqVgv9U63lyyhzzhjCLCXjBK8Yn/ol7Ns+pxp9WcB7DGedUYG4fc21xffjBfeXdf/Sh8uhzk0zk5zzLB6py4cmsPXqRU/V7uxbn+sHBcl6yYfqZp4MVy0ptSwGXQv+KbzBAH9kRN4F3O3g7+4HV24ItAzmtdelVgfkgOc3XKa3gSrl56cFy9uTzinHSesdA5JgUaLW6P4XRgQBkAi7ZVRwY6FcmkyH5dQ/IiNDpQMtQipEDpCkV/Qskf+xjH3W15Gu//B9LCR8UT50pZ48fKsMbrhEwH8lMLBn0aV4YBjNopUfYYe8mAfM9G8p2pTM8eurZ8q6feZeUcVwIA5gH7VLLIAw4uLFiMSfofF7JJyYVe4Tho7+/T8D81WXn9beJNytdooJQz506X3ZdeU0AefiueMYiaYuXV/7Vv3/nP/ypF5/IL8xR0dp1etL1ev83jefcSz5dYmvlzwpEkw9VDJLrKMGsF24u4sZ6qgAm1nb9OfBKtTqGRZz/oxhF2Farv66BcM6xASDAzZxMx6UpEvjJVqq1VaQv1yIaE/hEVbRg0l6KCQTdloo2WcP6NXCRuWzuCtCoEGAhMILxW2Fwo1KgJENugNUG6HoR4kwrJVumzq0sYYzFqYM85kpnhqkv/J1DQAR/goEr6O/BexTLElk1ogCNXFmuuFl+5lsNqivIpMkV2NJaslRU6/G8hLxTM2rBktUGRuWK5zE48ScfXnkX7QCQN9xlGA1AbmCqxtxabhvYBtBqnp8CN2kkMrDQJK7O2TU9MG8U1Un/UJrCDgSzzngJFGF5WJyZMGPplrXxkiulesCZQT+3io7YOo5X+JZX4QlHo+EMVPiNe/fDh+vcxt1C5DfnOk+K8eXugAiZ+8NHPmgjBiAU0LCy86la5xnHUCR4hZAONTQSUITbijrmNrr2hseTYxh0lAbxrr9SOkIFNenmXUoBtvuOb9CpMFyshYvl+CMf03ZoX9m799ryfbdcKh87tbn0y8f8qf2PCmQT/IkC5T0Sj++CQOpoj2hRY9stv/Itm8Sw5Ss+My860dbmtICnZwrwibVU7eruENNHh6TXtEuCClePOQHkPrmPqPaJASNyEIY+KH/sRYHgDt1/XvemgibzNitrfWOXJEbP/cQlycoA9JvMg/uPD0h50DK5IDcTAkDx/aYB5DAns4rc5D3mKG5YgwdUpbRDWw4IMjCr3EWjvgm513UMIK4Mwd6excIEeO/ULsGI0ipSNAgL/MVLHX5mu/hLN774k2xL63KSQ+hhC3JJCS+E2OEgnd3wmh7lmFa6RFmiz04p9ZncDqLPcjnSwE1rHa6oDW1yZdmwljzCCtCSwtktVxZjB3V6pHekTCsN4vT5aQF9AXLxoTG5mgDGWXwXdW6X2rZMX2Ud7+zWOShaABJlfllNABoFhuTfvGr+bFnqWefvdpnQQKPoKIhL52lACKRWh0jDiCL8ob+5W4D64fLu9/6Cskho90C5oKeVwm1s417TM+4JzD3X0vV7/voPy9ja0TK2dVP58J/+Rfn0viPl297xttI59Xw5cvhw+btHJ8uwdmPmVaDqG7/9a0Wbr9eOgWhYoLNdAbAoObVybzjpNeVKBXqM+SUpCN4BM62Q8jQCsZNsYlHZVTJ49yWAvINNOId+A6T4CvXHCmWN+97OwsWuFMoadAsYD4MF7kwGmgCcYHAG6w1+k0A87hPA2zJHBx54Tq5GFwXMmX/ArdkJCzvAcmDBMHTkR60hYhR6Bcq7Za0VMFdNAQoMYQEljSn0PCkaCmCeQC963wB9VTkIDl2BMJ8rV2yen5cmXk0pYJ7G6fG9FZRzv2r0ac7P5edFAG0oNFjMf+gn/pX6NVAeONtWHjk+bb7XuGdD2CRjzH60PvMyQxgLT8VxSEnKnJ07+px88kg/SM0FRlFtIUhTiq0rf47uaI5BBo7mpEfXWy3mTK4MV0XFtoqB+QYpSovlhvn7y7OHHi9TcgkhdWXN9oYc7JZMXa25GVSg5oDckJ4/dbocP3q8vPzmG8uGDboHxcBsSQ+/cKzo1A64pLVJKsmPf+wjcolT4P2b/omy+ChgWwrFuRMHy8jYrtIzPBqpEiUMwAxOmah3uLRoN0/AfOPYUNm1Zbxs2zRaDqug2R/+1nttB4LM5qWI1IJCGOdcpMh50UVHuNL39om+emR0kGFQMUR75U9+9S2vKmfVzynJmdPHzzgrC7uby+HGYr6hoPS7/v33/8M7Ku18Mf6KPrQVUl6r98dEHyde8hZzgHlPr1xZQiSHMK/g1kda/4lFX89JJOMTGv7lLddybtjXWD4BhLgWBxXD6ATn+Wuykeaij8IWWNwkZLSlTnERclwD1mwpc5PZhta9sSTCbLNRdodJAGArB4DQ1o4AlQ2sbr5aQZMlQnTa8jwYc3Q6jlewbsZsphL24SZjSWZIXzFWuugPCv6cFAuysih9IWmcKpP1GKRlxYJBhWU+/akyL4unMyIY2a4qm6+8uYxtgTabDC2e32SkDcapzjlSW2PVbk06fPLDuhTAlL9VSbH84p1CJ34NhlDzyhuaeVzi7FrcxyqSNbpg7pwTtnkYeoizAMT6lTlACBjUC6yEdPMzfK2AnTBJWa18fcz14tyFCASswNzBclVlSgHk9kQmFH/SjZDPUTQpci3XJjbEFvOoNlWFowrXVrlWvUTdLpNBOukw3o1ZqCOXNJJryLLatBPZfiy4YbgmjcyS4dSI0A1Wd1mFaJOBSAa3CV0e+PhfyjViwrfqVpnoPa/9ep9PykSUvOf3faSMjo6XvVftKq/fMVeeubirDKzfKncDZWWRYhftjm34iwJx+GoPCkwvSGD1CTxdtU1ZR3TSyQkydQgATMndQeZS1s5F5QaXz5GLDAFWaReKH+OJD/isrMz9sr7PzIZ7DwoDKU0H5FJyScC8UwrA7JTWubAlmUrm5qEDXd9QDj0stlTSQfysoSkrSJqYNcqq4ogLDROGsF7uq/Uwq2DQZbnb2NKp80hviBLXPxBlq+EBF/X72LjA6CL1A7AeYfWF7giG0v3UFgQOwaXjY1FwadFaq1KKKRkD89Dd36XjsiATaKp2RyBUgH2vS/1HBpfhEQEr5aEeULXAKVmdzp6W65GAwmoJ0U6BZoJw2VHokEAcGxuQ9btDgvmcflOaQ/5TH0YGxzSe0wHMFSAKnfQLmHcnuGt31U8UE1n3l+UG073O80k72mRNN83wL8Gi8kG/2LtO39UGdoFc0Ap/U+hK7a6uLLpgVj5Bd929T0WsjpZv+d7vEjBfKIcf/5CWZFfZsONmYfj1wW3U6dUaLzY9Dn3mg6Vv3aYycXKi/PZ7/1SlwfvK7W96jYqiPVK2bB1Q1onHy5KshW3K9PBPf+B7ymYVRjv26F1l+MoblMlFhgW0EQjSSnZdP01f8dhdAsSGu5C91fAvBvxRYMw0HczVWfGtMDO3/E3VmKkkoJdxsf3FKn/wqOQ1BvO2pEdGrDACRbpauFHN0GIV383kRvyf69mMgcFJQ5DuceBEKUenmsC8pgiuPLzykpCfwYd7tTs4Il9jAj+j8meH6DLegCoDc/HyEbk5vBgwD86TMqdFNsSxejx5YPLdyq1e7G/sDlhtaLyc3Yi7vQC4NyzmjFnuNgDM3yFaevyhz5RdN91RPnpau5be3czXiwDzy35TGy8D5jAA7Rj0SjHpkaJyVmmE5TPm3ZvYWtHViolxYMmk0iWO7AqGzbuRFQZ6sLNnAPNgPPFYp1SUdVtuLGVQFvP+S+XGxftlFNK6VeD2Ou1yMVdL4plkQWL3niB38oRjJHz04BPyET8j6/NtlqcYJ2bgG7kb3K353bJlq9wGt5Vpjc0v/9qvlHPKfrL7DW+Xm5cyFwmYnz/+RBkY31P6lNUH1xXPu63d8ZdjQ9pJedXVW8uNe9aVtWOyzmuX5eGDj5Yf+t4fcd2D4yeOadNAMSpS7sZkvZcXhI1yVIxFXqAs4AJsJVN/+6UUjCtv+hU3v6qcPDuh+JYLCgw9XXZdJVeWDP6E31FXZVEVzE73TA39xnd+J9zwi/ISrcnXqHyF3n8v+jj0kgfmr1C6xC7SJUKuCTwhsMogq5UiFnkTgJo5er0GwEh2GaC7IkYf9Z3NAAMPJoDTwqkVQKs1whY1W07DChd+6vhNy0cSVCFKcUAU6eISOBK052cDCL2dG4wy2m0kGYze6KRawQNM8FtVSBqW0OzOZSAu7tLgc80xeQGN1pOqFcV+jFjxAANzVi7asZhbuUCrzgw1aQnibitsF3/6bm2jq3yuJUIA9817X17GNilAxa/oVzMGIEBK7Q/aMsCcqoSr9Tyiw6u1lksp9V1frfPDyJEyzXmB1SZYmIsLYeHBhSUthQ6iAnTSOj4ytHV4kLk+Jgu95gKgHM/A2kObORBCbrXnuG4HcwMxNjFAyplj4VyU5Y5KZR2ZlaXpuwlMrlZyfAXxKUxB5InDKh8W3silnJZ0tyOqQJpuLKSDBrAqNkc7gLiPmF6xPAeNeeQRrDnHKa3dp5ptIryrYo5qwKHdLjwGdR3EejNQr+uNlkLH7CjIH+Sxj35QcQlRyKJ7YLTsfs3XelwnjjxRhtZsKqcfv7usVaXP3bt3lFdunynHV64oAxu3lKce3VemFHmPK5ibovYuC+gDUPqV7WRWFujh7uWyc+OKrHEC0LJu8txZ5Sa3+rEK/gsYIvOA3C+p4YFrFsBc92IJSvYYsE/L5xsF27U81UfOtZuLQOv0LEopmXbwC0fBZhy5V9If8235KGCum4YLJDQi//fxVLbU5iWs8yo4xDzOyPK+JCu6i/EwosSECYgP9ElwkoWIxCTq39r15GtXoKgUiG4pEOQfdxpRALYs2FjnUTBGR1V4Qxb0ZfnKk/PbfdWdAeaLM7KQQzEouronllUyHZh7CMQNyO1lcEjuMLpocHBYwm2qHHtesSFa8J3azu6QwJybVv0C9UHGD4GrLh0fEFg/K/cspQSVAFwQ8l8zsl5tnSozsrYPrlnndGw9KqrVs1pB0PrcQVVPgRsChOdWLujaDQbmdikDmBtkqG30f/6MgPkGkVVk3PHGIXMHMBF4aZN1fhHBr8NUB/7E/U+r5PlSedVbVH1bu5JnTz1WOuQis6pnTRkWWLC1me1sZY9YrT6cOfpwmVTO6Pf95l+peuByueNVu8tH737KGSze9tZXlgPKEnH8zMXyyjtuKDt3bHPWlpnTR8W/bhG42qUxxv1E93TDgt7NTrx8YQoYUBh0gaCpc+UiBWFkacf9C/9+43avYwgJYI7LC72xmSGMKazYsCL4XddyGFB4jCWcgbz3k8w7wp0lwDonkc3Id8q75HMTz8U5uYZ9uuoKnL9U9h2P7FEE3htIo5CnEcaKge8W9A8vIDXioIKFCQLtV5YO0iUCyrGWQ5/IyEnR1Yjo64XBn02x0bxnvXcdpeZfP7Ll6TnujaVYeRpj8AJgXofb4xTKTYxxvvnsHadLStc3X97x3d9ZHnvg/rJl997ymOJeLigIu9muaMf/8MvAfFr8b7D0SOG9QFC7rNThL2dBIwalNaA0heVcVv7k5tB7ykQ/q7qyVL5dgTkWcwNzFeFR/vPBgbZy28pD4jkz5dyZEypANCI5qiBtKnfrmnMXKHq3qux0fvC28qws+KyPPTt3aI33aXdXylWvsutonZNGdWR0TH9H7c51XAkdfvIn/3U5eexMuebN7yhrN613Qa4zR/eXLq2NvrUbA5TbgMXcs7EeMQXdetagajXsUDaWvUqZuG3DcJmYPlG+77u/Vzy939modmxSrItk/oLymg8oWQA7ox0C4QSlYoxB1gxIwdu1+0op6OKrcpO8/vY7yvNnFPg5daEce+5k2b5nr110DM4xitiVBZeWS7e/6we/9d7/4Xn7X3yiaE2cuXyD3g9r3Tz20gfmr3vLt6vy53sMysO0lls3aT1vAY21glws27qQzWJyyYcVM9mOgU1YJtOO3SKQDUo510AlEY+++1yAiSv26SwJ9TZpxCuyEBKB1YYbCwya/wBNeb1LwMM0sKqISbKdbGBPywINGKxVJcDHIFXnwQ4qsgxLV4cQALXdyfg4wVitKVRCSjBuIWTMKDwacS0CEWC7rMCPJQVZdGnhRuo/mRIRGRZQ8fIWpxjIUw98UgJdW+KWU8Eot9/4Wm2bS6vPdps3tsxBAPNoAgtrQdZmgj9xnSF4FosobcOnteH4YYCK3MaiGyLII8Quhccit1xbhBtX0wZv1RmguhcBYAzEscxHknz7zjMH9rcEpBFYlsqR+4s5LAUc57Ndrjkn2HO1AMus/OFWyx2AdIlsH4aIRRjHRATEDZpDCWAuwpUlfqFvMUx1jDPAFTcSn45FqjH8zQ9m+PF1BQap7zFNrSdX4WXznH+LfaA4rwIENzURPYHOLraDQAvdxLQUu0fMTbjz2MdcQHr/x/5EJZvnvE4A5jte/bV2SzqubCxD23eV84/fV7bIdWXzlbvLP9hzrjw8f3XpX7+tPPnoY9qGndCdSHUICNF8yU1hQfcflkWYPOAjPUtli9w9zk4LkCzLKiOT/dQMfQq1jaVHNdIO+aIPyvptR4akMRQPXFm6xdwJ/sQSbquwQFJ/Lz6N5KInm0FYeRcFjuexwLM7YgWlrjVZrvWZPN1W/uipx/pSWTeGMhg0tiS/8N4+tYBsaXreMsBcYJz0KGzxIjwGFbQJbZEpBQ+PDSr6NzUhIK7nd8tlZUGW9kv6bVEm84tL4icafDLBrNsgi7l81okdg5SEj7yb1ansLPPaenY2F1UxXSBVoBSYAHFBt2TRGByiAJEEsfxDSYd66uQ5p3ckRzHWslkFkAL2uuUjO9SvfghwT8s61SXQzjolKGvzms3KTz4l/0+AudxUZIDoUVGtYeJD4IMK8IQGSJC4GnDdLUsbWVmgc1nTnaFEvxG3srRwWsBcWVtUvZAUhnVnDkG7+qIseQocxe8cxXRm8ky564GTZbPo4PpbXmE+cebkZw16ZjWmG7fqmNqO1fbx+z9YhmXhOyyr2ujYcmlX2sjnnj4spW6m/Naf7ncl81/6jz+kbFJHymPyMV6lAOH+PTvK/FPHFI83WG5XRqGhtdsVlwL/iN2JYKaxzmyuqfxabjsXlybL9KFHyqqxUWXOkSJCWkZ8zm3xZMfO0Fofo9ZFuKdwp8pPgh/6CHzKejgOUwmNNae202tXKHgp5B0WdO7hnRzAppMPwBM5P2SIaUC5qsPqXp8hehOd3/WEVrOLAwmYJ0Anvqdh7a6ywzxCwFxAvE/ar63l2inEdSICP0mLGjJtSsB8uAWYV+U+RA0NyN3DRo/dm+x75UXZzhiQy8683NDEGEDfldfR3+C3AciTf9nVNIA54QdWMrVGTp+fKnfe+Y0KaDxWNm7ZUc6uu6k8N8vchPspr8ss4pe15EW+8EzJwnZtZfVLYUF5Xfr/yHsP8DzT6lx3SVbvXbaa5d7rNE8vTGNmaAk1EEgIISQQSCgphJ0DafsA2SSknB12CpDQNkNogaFMsZnePDP22ONxHXdbsiSrd1n7ftZ6v1+acPZ1cl1nZ7guEGgs/fr/73u/t6z3Wet91rPOICWso6y0FvNwaKopQDR4dK9dqFzCDbiXIurJ6fc+8oi5mp+eKwPmOo0SMK8OKksFwHzbzE4/fRtkfUiNqL6axBnfq5WUXmuNCxso+NRAUTPRWcpYD3U4/xXYKE7BmDPK4RnmNEr5UkPQ347T3v2HDlsftUke2g7HvH/ENt30TmqTLMRXHrau489aKfrrFZx2yrbKLqmVrtCS9jLhhBLmxOKmGtsMx3w5dJa6mmL7rT/6XXvhiYPkxpSQENrknxnDifCx4ruWiPny5dS3WNSCbHstBeBqPF/r3gfutRqczxtf9Qbbc/iEDaHK8sKBI7Z0ZSR/Csg7t97VqghMzMx86C8//K4///8arv+sv/M86pJf4Hs/8+fJnwFgTsQcVRbHIs67iyhhYImIbgfIySIPWdfHovzx6HFsu/HZLPIe5JUoTuKWwdeU86dljEPmIha9A9zsKDGOOMXrcSm+AAAgAElEQVS7Eo/UI+aSSMg45m6ZkjNA252nOi9aGQBO186MSkRqpEASdjx7urnnTBg+IjMZ8Ixmzhn1nLMSRjwead7z6tfYLXKRoElA+QzfRarEKXqJEt48tBp97ZdwIzdhBx+/n2iWgHkYA/VN5+arsB3soH7LFOnnTw4weCkrTe0AD4A7IQkzjI4qZnpY0blqWe8L8ABoUh+EDU59Ed3v/wlgHmA2+llGOs0TARYB3JgcvqH5x9Rv8TD8LCpHmkfiYivvRs+U5oEb9sSD9Z/dEVOCGmVziNpNAcxV6bUQMKPNTrureMLhaIXTku3sHjN0wB2d6etYFAY1Rk5ZekTf1IQN0hzMZmSMd+Khu0VP1/Eny+Z0dI5z591gZvG0eEYBS+8J/2g2N7hZeDnetvhcRDilMhM5AxFZdxqOzxv+z8ay975v+kmLIjKlNU229Mo7/B5OqYSTPPD0vfbG6xfaoQur7Y6V/bZ3bA1UFlRZ9u22QSJLBYCPG5dN2N1Usa6iQE/PkAAskmZEnRuQI2xdOIXG7QIHvsrsHAFYSKFFzrmo2Zp6KvQjlRZ3ojTZeM3hO2/g1JSoeNgF7XuFgLGyMu3SAFtFbiamHegOif7Jt3PIuV4GLPRJOYoLAFdyWnTkLedM07W5XgEC/gaYmlRFUTjnDsy5nyLkE1L2od8EXiYBt9WVUu2R1GJEx1sWAcY53RbPvVDAHKfDC8cArkUXU+RcpzENjTgflLs/PwjQVT4D0XXZhVKOisdJ5PTiP3yPA94F1qQAI3lHwrckfKm4EJQVbFIVR8PjHCOcQ65sBJnFqjrmLH0lKs0UHPYaeOiFnCJUEHUeGx+hn4nCqagRf2tvpNgP3PGh/nHAL9E1AE4B+uTVSoLWgRBR8QU48gLa08gh5pUspL/YOBkJUWLECfUovmQVx7ttphwKCvz0aSq2Og1Gs5Jr5gmYUzZeIEnnXyO9p+3+pwaJ9hXbsjWbOWrvs3vv/Dv+VmyrL9tGUZtGq21czdjLcSLZ+ABJ6fkDdubISWtZu81m+3vt7h/9yA4e6rfdR3rs2m1L7Mar1tiBZ9FXPtlv7/vgO8mX2W4njvbaRbffbEtWXBcGQq1NC1LLVHbJJSh9bWmNMUbdu23XgzuspKbB1l37SlRnxDFKyhNyLGKb0mT1de8hGDdAc4A0s80BBDWtFSTQXA+vONYxlCB9Nr0n4787/UU2KeC7t1l1LOTQKwggDrz3axZB1yX425ceGo7TRSUA08/FohEAKLUeygHd+o68H50gcbKCXSuBV16KzVOkPFNjUWKy6+7Thn7oUKKyeMVftSS3/6jZYbcDNId9ye1JYQn9v/O/MgrKj/0h2bn4ezy3f7udjneLPuUSk9gknSBNsDYH0fs/C+iUVN+XvvY1u/vrX3VL2LFkqQ22XmrHBcy98JLamza7H7+5W9Mfa67aIlom66YCZ3eMe42ryJCkAF3qRguE96hrBgDs9St9n4jCROnZffD1vnl9k4IMqlDrRYcqAeZ1gFdyZC6f3Wk3bLvULrt4g5exL0a+UuM/gU3u66PYUyPv5UuOtaqdRuGxCU4fR7wYVC9Um97eXqhtQ0T4+3HOyTPhs1Jc27tnN6eZ47bu+reRM8YJOJH+rmO78A2WWBV0F+33HmSkra7Kkqiueq2Y8e8AmG9ClWXV4iZrwsbc9eTd9me/83Fbv3q5rUEZqa4ORxb+ew2VYttbWnzvHMY5ON11Dgehy8508X36jJUtGLMmAgt3vObN1jUyYz293fbc7uds/eZLw05qD2BsXZ2F5+P3L338A29Rsc2f2Bfz8LXcvJu+uf+nHpiLY14iucTU3Q5CEkiJ6Ojc/A4Dl0DLvPUVUWa9ICCa/ZwWoa8NKV7EMWIGpfRylD732GvcREd+vjZlCLy4tL9fYFwcLy1GN05+pKmGyaoH2JSRi2sGgMwQor+mVxQVzj7ihkyvq61a1/olNuCIGevz2p5TRDgB84TV5q3v/72RcSMmWTX+l68jdADWNItTkTRFy1VgJDOiWXKM9yAOyL5Ht7NeyTJ30KY+AZhvVcS8MQF+WTg1MduM+BxOSzxfbMKqmlkiPjsbs5fl9uPUUC2ZFhB0UJQGJPVHDKHGPKxwgNcU4XQDkcHNFJHWs6V36o/pfMJBak4TWX3JbuagU3/xk42wpb4Re0RX46NfFb0VL1lVGwEtcHaVX1CAcfEqiEqq8s1HkySqIvrFPIEw5llsUjGZvZCkP0M4ij4mfkSoU4x0WjDv/ZEvEF8+X/l0ROD1QmyC/qP/nCV86n3heIq2oahezJv0eX9QUax0rYzKwt81Jinq7/3hzooc0pivU1SI3Hv3vxK8BKhywxIiNEsvp/iZom9cZxo6QT/c3Zdva7aTs6vtfTc12f3HAe3IJR7fvw9DS4lqDGoJEW9tHgJuw2yQ0KFJ0LoAMJ9Gvm/aevoFONT5KCpwKFUEl0kRb4mZCKSL2lGKYou4ht7DgGJRUqTtq6I+iI4kTWhARiFUFoC/1FlUfEdJoKWioDCnevskH+Zd4Xz6TObOo3Faxn68IvAUvHHJJbpUGP00RXsJOHuUXPKH0jZXhFZ9VqD2AsQVuVZSo+aAIvRtrcgLQqkZwhkpqwBYj4hLzEZKm6aZY16hk7fX1DMz6NOxwaBElaLKoPlUVi0ayoi/X4mcE/DS5SC4xKE0vXlPHfzyGqgwOsWpqalxYN7dB19zaNILD4lIpDU0hsxibXM9UXL6g8jfJPxrUfJ0RDzKOm9b1M7GPko0cATVNpQa1DaevZZ5P0p/lKE9XgQ4v3CB6LuUVlBdmcaB1wwsKKh1Wyn6zwXaOTty1vKQjJOdlPToAhLNtYYV2CgEmFu5qJri8zMPug7b/c+Sa7C8yjrXrbGBo8/an37yb6RPar/+rtfb0uVX4H9gP7iTyuZMoBV9eu899om//Jb9Nlrln/vrf7Cz5/Ps9ltW2V0/3GudJKQ1ATJPEDXNJ8L9vne/1U4cp1gLQYYJtKK3XvNzvh5F1XKWfiwNX/txMhjWWs81+OyddufXHvBKkm977y9bZfMGaC3KzQkaW1qlsRYVUEonvclq5bYAX7dakb7XxPUjaBLBBD8hlvlwWyEbFPtI2EH/IfrP2xV7XPKd50CkA/j49b9/96gNTyk5sIgTqXrr5DiiFbtdQ9RVoNuT+xLwcqvkAZN4mkwMYD7w1r1PU/1XVBZ9Vg398Yh51nfpGvMCC76bJnuYYeL/N2CePVNEy/2wwPf6UPnQ/BEQl7LTlA2iJX6WXIpnDrxAIaFDnDb1WhmDqfoI2+/5rp07fsJ7Y+myFTay+Eo75uJG83jmyd7pmf/3TkI2xDQEgJsPOK7Gy1cRrjEB8wx4eyEitZkI+TC1P5pWx6QS9dXBt/Yinfb9O2CePbBOrgXMlfyJ9GdJZYFdeeFJu3jjJnvlK24l+jyFjRxA67vPkyRPEf3u7en1pM7Y01FloY9Ej1RHT0g9ThEEzQm+vWaC92FE7PfsfdYGB8ZszfW/aM3tLX4C1ntiFxSzdqtoXRoJm+l0QVuErqv5oW+pZ7U2VMMzX2QrkE1cSM7KZMGw3Xjza+3KjVvtg7/1Ht/0hpBnfeH0WTtx6owdPHKESr2n/PlVAElt0rU2rWkj6DNs7/zV99jxvlE7fPQFexbt+fVbLgtg7oBclBbVkpDs4+xTn/ydt16URuUn8g9tv50bIwaX94OfCWBeWiKOeQKzqcsDhGXGLIxOzttNCz1DMRkYT/g2FkOYt0BgKZrssUftw+n37Fg/jgrTGnILlya1kj/5n1dL1ELjiHUBUS7xs8N8YsIVVRCo8QsHAMuwWm726NHcYVB0xXGiNy+yrbVw9X+1IegR6aV4U6CmXPeEtnU6Ds3dIFnW7PVskxGoTQZAEmkXiOxJcUTRL23Mobgyr6+43gzPeOCxHYACCoV4p4RDs3Tz1ag5YTxiIFL/6pl0D9meLHqbIuYUGCoiOUXyXeLeuqPhzeRf39fS53JjHBui+Jr+r/pUJw3ep/G8+mxQQLKTkhiDDPTGeAdwDZ8p/cU/k77UFEXNvQlxMhJgVwZMv3MqQrslQzU+Ko45SSyitkibVk6ZALUAuHjlPpeyC6c2ervnHCzRIXJ95lM8tcnBeQC5TPM+Awcxz1UMJx7Eu80j3tH3Ke3M+yOeP3MhtbVHP0cZ9IAQ0imPjtGfxf2l/TyKgLze73EwzWnntcZGOk0i3p57EjDng+W1jbbk8pdrNQSgGO6x/n0P2LZL2tCmXmpvv67aHnihzAoXLfbkzwGoLHmidNEOJeNOsDmQe2R1ZfBAOWptrpiwhY0XrKcvwRz6fwTFk3yAfGh+KwJO9U1QdKW0ydPaUOVKHc0LqJZxrWGnlsjxA6iTTFlWijEHTKnAzgygVkmbilxzS9Q+svUVf0eGy0GowLn7KQJHOjFh3tTX5hNtjL4fJ/JeU6PiOdIcB/Dr2/e5cNTlzFVV5vtJgkZCeu1tRMzZw+HNE8WHQjKmiDloVIoszjGX+g9tqK6LCrzjKam0HMdCc6y6rtiGB0nYVkIyYzOKxJmiR5obOt5VYlRTI5Epkkc1h2s4Mh7jWKC3b9B57cVExx1k0r7RoTFr7KBgEJ8pQ33jAtmsuqaAsyoFtrYtxtEaxskZJlJP1U4/zlvAaUO5b/yl6CwLnOdRrU90ltKiRp4FWUbsYz60Fp0yuBMvYD7WxXG+gDkOIm2XMyunWFKzSgadKadQjWwBdnPg+B578PkCW7WaubVppb2w/dv2BFWHV2292DZuutkBSz4RPemsnz+xExnOp+zEmW679+EDtmrVItvz3BlbQ0LaK+7YZI/84EkbY7x6jg/aytV1tvv5YXv9HRdZc+dqCqbdZ2tueTORvI6w7bLZcrroN1hU5LWIi51sGG0V0Jns2Wdj3UfsM5/5mr3ufb9mnXVttqC+3WZx2ueirrKferi0eciOuO1N69ABquxagDJXUfGIediMLMocoRgXBOVyqiQc1/S8ksi44VetT520BnD1/YJrBLUpA+Z5tq+rGKWkRTiW5Ahw4iFlHhWS8gioc8aDJx/7TNoP07/xqpvqsDnpq4fTL6lpBB0mPq+v+CfbCdOmNs9ah12Nh83AeVaUyW2vP2ZERzWHnQLJPBkFeA8ODds58lQGAKPDOKgjRKp7VcAGUDqMozWME+kSmtxvBEfzvKhzXOfkCSgbp085uGzvXOrA/Dh0OY4+48GiNbnW/7vGzXvq9KOQIXk2KjBXjgKVcpDGTidgroCCF1fQNytjlGJsnPD40WwG3LVnOL86N+ipCckmq104kVYhYL7ICokiX3XhCadSau2Efvlcrk70JYEH1wePYkKiaup32UaNoPKjfO0lPKBbOzBnQPbupcYEjsqGW99GdLuKU80J6zv1LA7wQqvsWO55ch6kSftnVvXTJVxpj1RZthAxX9mpiHklAYtie/Uv/qLNDE7amvXrbQAbNATdR/unAoOaf2qn7KTGVstF177jhitwyNts6bqL7fE9h+zk6eO2j5Ouiy67KqLlGDjl08hGK/EdkD7xyQ/9kssA/KS+6M8buHcV/fPNn3q5xEvhmFPB6q/cvgUvYd6iz0xFmsta3YFS5v4NtJGb9xmIiZcjOuFXTf/JzMgcqBIIjETC7Cszdqr+6AlMRJmnBWq1ScrIqTCPXyCi2hF0Cy5kHEuqiQm0piO4nDXT+z06Hm8LsJoe24FbcLB9UWlxyNBl78ldWs817wLeZQl9zuOwqW1eNpx/Vf1vepKKf0R98olI+QJ04BrXz0Chkv4OPLoDoMCRtV/VH8Y6119OuXWSutKWkIHjzPBmEQ4/1ZCBHYbKooi5dHX9hEGbX0SqvLf4J+depI3N/yIjovZkkaNkRLPSznrSzLym3gnw7kYo9VUaj6z18zmlHt1KJysOqrMzUjeygtwAM5XxZrwnkFmTY1EkKosMrOZTilw5QE1Og/d+Zus9IhBz0i+fIhk+a1N0Nvo1aCuR/qU2RQQ7TR53ePyS7kTENqwor96fjYlvoxr25FXmHJS0RtKZi4Pj6LXg2fu/mifJq9BmrVdj8wxnTvN91z1fQ8kntMVrSBBcdvktfiYg4DiBrN3MCzvttuvb7fRYh/38xmHbObDGylrQMX82kj+jgmu0eQbjOoaRrSsjcg5Qbq2eAPzOEAUKXXpFkEcAsS6AoYaIwoFDAe2VxEvapAkm509/41EEPqVgIprKhOSReF0qLZUklSrDYAHgRmC3GH76GAmi5CO57KAqfbryhQ93UEt0vYydD3T0hKf6Omg1ztMFpOEw1DTwOZwA8bdVN0TX03wowJEQdauyQqXn1XuScJyxVgfm03zTLgoljZHYqgqfki9VJF3/impQDeBX54/z7ALL5G1x4kQ0vBlgfn7ETw5kn8ZIBJUzIOCmjU57fUNDJeovcqbRUYfKMkY+gMqni8Ov6KYzD7jHCGo3jW1U9ORz5fB/VKxH83oUezAGj70N6UE54qK7lZA0pr6ULdPPqiooYF5OQSLxyotFaSlG65xCQxegUxQUNdCP45zK8TGc2MnRM9A/lsbJkI6g/YSFcfPIIq6M5BI1PlAtzh992h48QEXZNY228tJ19sOP/xfbD/C66vrriPhyCgDFZgHFUEqqFkrE3Z6+90vWS2R/rH/SnjrIiQ2Rv5WLK+3EuRnbtnkJjl6JfeOu5+l75ndNi73ixq2cmBTbc/c/ZTe+7T02du6MB1KKKur4hiefbGW28nyNcqrofHiec/zYA/aXf/55u/V111JNtcE2XML8px8iAJOAaCp4l+1UbquTPYrVHE56Wvret77MfPmFYU843tde9kansqS8m3hP5D/4kldfexsiL8TXLP2t+fx8V4GdHiqncJASAEscnIf8oWgtUlqJmhKiKQRQD7piJovnoEwAPKa3gzRFYVVVV/PVm54hc7/v3Amh71k5IJ72sAS8A3xH1HtKVEcWkGgaPQMjgLLTdvjYceuC4iC7KxnNCoIhUi6S/rWoNH2cBI0D+kTD0Wmv9r+hARKCPegj7Cut7Gk723XcgbmUQlo7Omyk/Qo7xnxxfpp733zJ1me2f85jyML0MQ7ZPi5Aq4iCFpMWp6qLDSAlLMDudkq0MjmmipiTFNogKosi5prv/F3tU+Gh+ffJDTo/eMRc1T8DmBdwRHjl9GOsUap5ps8oMOg4RkGZ1Ic5WpHWly90jUPYFemGxzwLl09mfpy1Pcbp2BH6eQTqSOc1b7Dlne0kWk/a+bP7bWy2xmo7KMblvPIY40gCnaO0KDG0hRO1LcvhmENlUcS8Cm75B/7oD+3gzj1e5EwBLK1tBTDlDMhBl3Ov9jpnnL44f74XQF9mv/L6V1EodZ2d4vSj/zxUll377dIrr/MTVvHjxS2PyHk4bdMTFzo+9ZG36zjkJ/LFGGzjxp30yVd+6iPm26CyoHrx6SgoExtsBkTnx0IzXm9MUC2w9P4cfNRnA5i5ufO1NR/1xs85WOPGM96Te1ea/H6cJkOii/CjSuCKo6WkKGmYa9MLuT5HtGEYNaEV0fATpYjIhpFOQCOZ6FyRmbDM855VjUtmPKOIpGf0x8i6Jz1bwl5hKB2TpwiK0x34qxawYIIDc47SEfefYSMuxljnUfxDC8Wv630eC1BX0XMqYj5JxcDAiWHMOjcEMM+GKTpaUeZYI1m5aYE8UWamMQIFcGvN+ampKqU7K6m/01g5yFS/R1eliFPQDfD7o/9zDlu8Kx32BpgVqONaInBok3ElFn+P3ksfpEh9RJ/SRiJgqvb75WW4YnPzYz+BEsk6EX0YH+mHEgH3ErlE5RUosVdJWL6x6supT5GcFCcfcf2IcukrhBsDkIeBjMmm9+teEaaNk4nsK83TGNTkBmROh7Opc2A/4HbWG7pSrAt/RVPTVSM0xyLSqr/4yY54yrnz61C78UiaY9848pwlzLyb5E9togLEAubLr7g5mg9IGO8/aVNHn7SNG4mOEiF91eo+e2J4M6osyCXCYxw5P+gbhatLwBORbvYgBWQqoUuOAIabKyetoQrO5ECMoSJmw1BCCl1Sh3uIssKfSilHT5DX57MoIErvkPOkqHEJvHXymPyzWnMUMCR5TQWDmA8EoobQAS9FnlFR7vEJnGvepyi85vCUjzXRJV9zIYuqKqG6eimR1/o6VcwTp1hiIbMkYAmMK3KDUwLwlk52UFl8lrkM5AKoIrP8fRw7sbBZSk7T6LkLmAvcCJBHWyfhnWtfF2WmsgpwBLgfg+Yj2kwZ15GzUNtchCwymzNOhzaoMYTTVVE0qxwqCccaOJ71dTHeKhYywZrrH6SC5xCV+Dg9UD8WwAcaHpi0xnY0iwEYFVT7q1bJ9Zo2O0nEWhrtLS3N8NmHpBcMbYsqn6DsQh68BId0HJtRAr+6Agk0bfhKCi0pJEo+OSTSDqCiEY1zPkvCZB5R9enRs5T27sQOaqAYKZ0wakhJntdrBQDzKeeYF1g/jt39B8pt/cZmW3LlBjv0lf9h339kJ5G4BrvuZZf5xj6Atv3y9Te6Xfja5/7SWpcutIKJQcDntO185Hl0u81WLW8hqbgGalSxffZbT9lVKyqstbOFkxLlGiAH2L4IdYtqe2T7I7Z+3Tpr57i8rmklbDStzcxyatIrcXfUuvf+wCqal6NZfcr+Bp3m0tIq++BHftsK4MeX0G8X3J7F+3MG0e2Z1rmWdLajpOWut3oU3MPy/hE/afQ1GZFxtwDpdbnJTl12e5kK0xAxDxsbnKtMatFP73zJhBt+4OysPXkUW0gbCzjBEEiSZG0xkctieOYC6aVE/UuVHIyogV7T31yFxRM+RWVIknlOe9Gc5WSLyLXzj9VMtyH6f5xkCee6ipVOGZljo+w1Azh6Q0S9R/gelTOFPZkhT0LO4DCUq3FOasYBbKMSGfD6F8K4ofEvbrSuI0An+o1s1aiDcmwxic467ZWdnsJhEOe7iPk8ANgTtaMb52uor49nKraWNpKaW7bZ8a6h1LkycBqzDJjnOj3+Hg8VY+qdGjbdP0OQic6KZBUH2mns5wPzESLmdUsZHoxPFiWXIUKVJHfNbA/QNfWl94rKAtXKahbagqpKu2zqUSuYJrcnRcMDeMc4+LccRw2MaEhJ2MBtmhcbYhyIHDgVV99+4qYE9BLvu+cOHELtZcjaL3+NrYYXXkgNgv6uA1C2SA5fsjZUWXwKZw5bBO0yR66lFmC+osVWQmVpprhZFVKbDzzykP3Lv/xPggL9aU7HGtDpwiRjNCzbomNLLKUcxQYSzNs7WuzVt99uXdg958cPdNtegPklV1zrtnmK55gD5qIOqm7C9LWf/r133B8d99J/MedEpRFX6WcBmFP5s6Tk0wIFgRHjYD40l4Uu5g2Ac2Tng5j4OYd3/FdtSGnhKRLuNkS/x0blYMbXVBhGf3uYWf/S5RU100KKRDiOcDBeiiBmcomKtDhPUR6lAI7sih/zvfg6HuHMovZyOPR+PYOMme7pIFoNmsd/d75tGIRwUAQAXvSUc62dd7+EQ/2fFJPxoySPD8u4YsDEGy7CuEhJoYCIgl/dgeRcu6eImB965D444iMBKrVAeV/b2kvRMUdqIj4Vn3HefHjmYcvimQRqJ9BhzedeBWzWrt6QjkHj8FFvC89cfPNsc/LkRF2GAZqh0R7FTaPrP2cbWdbe9PzhbCWHTdfzueR38bbPpGfIUT40uS6EhFY+SZ7Z8WpW9rgAo66Tgwk0vIu8GAKRElF/PITkpRf8ji6VpohZSuTJjb+eNzkbse3HpuxOie/NelVplPSVy0DmZl+uf+NIHKgYe3m6Spqz/qzBBw8uueZLGHqfb2ky6M7+WzrZcU5BGjsNleCRRzUSaIhISbRvBoO6d/s3ACr0D20VMF96yU3sTQBONs9Bqr5NnH3a1q1usaaGTrtl1bA9PLDOqlsX21FXZYEHqdHTcSv/k5EVtaWcCPYIkeRFtYDfsnHrHRDHVmHyaTbvWKaq/ChWupIyy4oFzINmFIlxEfWXZrn2vEH8R82VPNFJpDpGgY5pFFiKAe3kOAJMRJEhuoZ0oa5dRP9M06+SHp4kMu30JQC3WunVcOlH7b8LScpUl84wADMoodUSQVfBCyUispSk7OfrNjjxCCpUqJCHokIAKaZFfYPUYGYAyjgM1CaZAgBLVQVNXpdTvKCERh6nskrc7CIcYZW3J0GPRFdFi+oWlpIcyebMs4pyMgEwl8upqLuic5Pot9c3I4FYo8jctBVBEZmkA5X4OQKnPNwFaA2lUEbOj6MLXmPTHFVU1ZTS1XA9Sd6cmoYHz1i2Q3MZ5G+KOOaJ5oZjojVRRVXXCXIMCgHXdcjFDWI/aoprsIeoM011M7bMjfJWmtNLvxL1Y63PjHVbPgoP7tAwt4qQWpyUxjOybAXFyA4C9iPPgnYdetgeOIwO/uZWNKeX27F7v2nPnThk12xYZ08+s8talqCL39BqTW2X8byn7WN/8FG79abNtHPQ9u8/ayeJlN9ywzrXrN//+D57YC9zDqexisTZ1UsK7dKr4Kj3nYQSgR0snbSWpZfZM/fcZ6959/vh4Ld60r+WhE7xBDAXOB8X0IgyzJ/80d/a+g1NqEcc95OJpR3N9ivvfqdd4HP5RPFjYcbeMrclhR2NQ7IUKRe48lOqZDmTfcpsVFi/bH3L3oqCMN/dzn3ULYa74n5fzQfZGZnhsMOyRcd7ZqAHaRwj+TM2uKjp4P8mQCjbICBersJCnCpIMrEchZZSFFpUxEYRdn0LqImC8G/3PRB2QRFvgJQnFvKtaPYY36oJMUuOh4IatZLtAwQ6oCOwIRpKT28f9JNhO09FaV0jOk8gM2gssnXak73MvFMKI0iiCpGjUFXEqa5kgavCpdaHHIGennPo9nc7aBf/u7K6hiTD0zbAayWcDLe0tdtI6zYK4ahIWgLSWSQpRmquc7OffA97ePAAACAASURBVCPTnzJjyM+iiDD/8zmim+kFfOvIzE+A4hn8Z83xMf5W1R5gOwPeeo8fJycgnoH+mDzRBI+aE1XgOw+HetWCkyRGKhohUM2aTwB3ioDXlNRW4MiN0wY5ah4G4nUVhKqgD8pYs7U46eq3fPpAVBBtiBqX4pIye/jpnXbi4HFr3/ZqB+b5MyM2QK7H0HipNa3Y4nhGJ4b6NztFyfIS9HsD0Y8NS1qCYw4wryXCX6ICjNik3/von9ozTzyJmswg82LAleDkANZDs5Nso5z70tJia23ttIuuuoqT6GovXiUp6uGhHiLmB23ztqsi4ZPx1Zx15aikzDI5MfWmv/iDd3zlxwftpXmF+biJO63n+2s/ExFzJsynM1wX/GsB5pi4Tj3wHxOIzYHRgKDZ8opjnzlw7HM+99602LJQvCY0180KF7gerwMhDxGHwZChcXiQOOaqDMJic1qGdMw9qp0t7Eio0WJ2I+3Az5FPfDmAdcwaUMnBfIArh23R2HAW9D/HlBFZebHpiGvmIq/ZRROg9aXvDkfYAZeAk0evTZIohniexRQKgBjq1cD8y52F1G6Ze7hyBx75kUfMcycCGM3F66/kpI0jZTdYEe2NGE2MV0RPYswcmJP8KVCbXwSoTfdQgSH1U6Y9npobQF1x2zSkuppHunk91NazjStu77Ji/25sozx0jEn8o//EDHGajvd/tgXqEfSaMvwFjFXARDzoKOcoI6eo/wSVP4s4ui6gZLk24gWqVpNmXUS7tMFEVDyzskHfiPs7l9bbGoY5G1ufNrwUjkfibGYbgqaLt3ku8u0RMu+D6IeQ/4yL+BikE6R4TQ8awMCHStHg1JdRuTSi/KHhH20LOcZ0xaz9RDilyiLUqY9V1C+yjs0vc2m1Agxl/xmA+bmdlD9fbBWF9faaaxrt3uM1Vk7E/IU9eziapMCQz23BntjQtR9XUtp+HCAsKktl6QWiLIBsd1OJpiXpQ9ebB2yXlSpqDZWFzzidVBucHoFIp4x3ESosQ1J1US/we2Md8m+FEwBvtJiRk5OsoSpej6CVPgwdZYoxVyBZkW/feHTiDFiW8Y/cBr2uccmz9jYiNK6vzuwg0lffFP/OEBGfgkYzRgRcwEcVRie4Xk2VNj+egntqrGppyzTAXP58Ec/h9xE3nD9KAlnUHY1xGX2gIjwT0G2UW1iOBOQ4P9c1QX+BYz6tAIB0fDlNmCAJdVqnIFKjwB41NlaSACqJT5JskUqbJOlqCGrKyLB02YPuU4R85CBH+c2LSd6kfyvhhKo0qdcawEGYhZ/f1lkHLYAN0jnQgDLx8137HGoKkUspe9QCioaJyFeRpFaqyp8TZ4lWUyiquInTlR6bKKxmg66mAGKXFUBlkUMjR2xGUXLWVT5H6bPQEyQNN+PyqbTv4EO2/VCjbbqsxdpXL7YTe56wL/79F+zm2y/1Sp/F6CaXF1RyetBuux661z7/zb2uKPX+33ylffaz/8qY1NuBQ2dt1bJOe+7QSbt4aycFik7ZGegR2y5faVuXN1o3iaCb1qywO//tAXvzz78M+coa61h3OcoyFW7bkwn0NTdx9oAdeeY+KFu32ac+8l9cknOUKOzqVUvsTe/4edt11w/tsrf9nkq2hgPsJibqLcRcz7aEFCRQdHyeBY8V69YhVrLbJc3p2A/8hFZ/SY592rVy9tUpEini7oDcw9dqB3ZVQJYXzw3M2t17AZKayFrrDsrdIPnVgxEWTr3vcbJDLDJFzcsTQK8ArAukexVQ+lv2/DOf/RxJfTiKal8qkas1HW3mRIh5MkZfTQAcFbmV7rYn+nnUPaILUocBXMVeofYyB3UN7zc9VwKzioRrwctZEigXMNVpje6ta0+R/6L2lrpmdwml6ElMBXSO4/R2nTtrZ48edbWZNgrrDC3cZsdOnfd+TZvVvJ9zL2ZQIr0pbRwxGL6n+s1FS5GtUARce4WfrOu9iWNO4rOV4bRSZTeMcPp8jGp8x+Ye/yo4RkVlaZjnN7XaxqXt1lI1ZXd/6gNEpNvhgNcAcM9bz9kznnhZSDRBXPJSnl3VgZULpWh6CfOxnki211hhNgqj6HXtP55D5dH1AgpsNdrdD//Int+5z1ovvt3Wr1mKQ4WT1XsC/v6Eta/aGp+laZH4GXSn0G7ICg8pQT9OWhrIY1iztNWWtDXZCNS2j33sT2zwzGlsEU4B99Zph+on6OTDC1Y5xaXA3vC6N5Jo2mLd3cOcBBIwZEzPnz9j+3YfsK3brk1KMynvwE9Kg85C1Pz9f/H7b/+LGMCX/ov5vJa7buH7Wz/9wFwFhooFzAUQBM7mmbIEFjSRPfnLwWvChskIBrANukaYvLn4b0gsZotCE3QuuukAVht6AnT+Po/ech0dF7m1kLnWsaASmaTKIhUCoKJzr1KcMy20DPxl0c+sFfqzVwid10bHadGw1Dot4gBUvtgT0A6aTHx2nn1Pn+E1LThHnwGsM8AXl4mIg/+PF0QtuQDYLMbgEsqO5CxHbrFBhI6z7M4UHHMi5kQhFMHWglR8f8mmq6ymWRX9ctuKzGuudwWWpTrhxV6cnz3E/sVRqqJL2XMoChqBpnSdeL4YicTXT3/TX3R1PzTWvpX6KrdZedM1VgFbI5qe7J47J9rE9Cb1nTapoGg4Z1uvSdfSHQwPR0fkNCXMCJgrg3xqgmfAeBYAzj2BVZtMAtueXCmPR33s93bIHMfSySZ736Z5mYuqJWdM90y+p18no5h4fwgsp+eOeRqOjwNWXyPqr9gwUlzOny1TiwinIToynM6Ygzop8o1aDqdzf6NT1dcuSTnPOZiGW7wPYK7TnQXimNcJmN/g7SSf0iZ6DqEZvcvefN1CIlbFdvUtl9n2vRjjJnTMSf4chGOuaJh3P9dVlFp7WhnRb9E62utQDimesr5h1hNjIQ7qKHxsAV3XoFDUEHBdCbWjvCQ279i32QQZi0muXcwDDQ0JeAiUFFgL1TYX5BH5ZdYU8XDTPHQRBY0GiVrDonF6h6g602hgi78qrWBJNeq1C6rMKScN2k0ef2tv03wIqURtUJLwF71U02UcgKyK3L7F4ueKAlKN8orkCKcBu/ncu4ECRZO8rqg9hSjhfwc3XK8J14hzr+Wr5FSBK3HMSwFCOjGfANw316NBDsgW2NBjK4l0CqCvExYF6JRA2ggPvaqK2QFALgGYCPSMjKJaQdRcajFjKMEUI782CqWnsRWOOKcfFah1RGVV2sb1tL4XttZywkHCliaJc3PEUZd+f4mDIOWlVKOZPIJNqKprZUzgmJPk6XKJRXXc8zROBZUISziOp+hIXt0y55jqZEVrXxKsC7jOrGyB9MCVJEqfDhzcYdsPttolly+CotKGk3banv7O123l1nX2/DNPIaM2a6tXAFDgz3/nazvsiUPdRLXzGGf4x1BnFsyOwS+fIAHYrKWuzJataLCp3iHbfbzfVixuIGGVkwfxm5gzZczLl21daN3QW1Zf8iqClOVhW7QGGAKvwwA955H/+Skqi9bZgw/ssc1bNtrefai64JAXoJd+pKfA/vCv/hzHkFOHxFcW6MnWWpzPaThllxxtJoMUVk4zxusppGCTbx25ZRfOYs6+pVO4CNiETchtAum67nzLbqdjJr08RJ/d+TCJ1zr9UR6R7pnspHOUExh3YM4VpRCrFSeA2wjvt6GKhGL+rYSioEThIsDU0NiIveNdv4lSFzUNEqc7eOixD+o55KR6NF62ib6ZZq4F1UvF5WKP0R31Fu0xcqSlrKQS7r5fYG8l6zc8NBggPI1JY2O9K6EMwievJ+ravrDRKpHiU6uV71EK9UrPcYEE4ZHRCQ8IqMCZ6gu0diy2/qZtdvoEClE52zZ/Tw0bGptR1r8pOBdDk8ZtruvDEGXYIH3Ogbkqfx4n8tAR1JQMH8w7D50D5UK67E9U13VgLo45Gt95FALK5/Rn5usftgZs7pq1q7x/mqCflROZriSoNsZpwTj9I4lUaZjLadcak/yp+lN2VMo1qpcQ1T91klhlLZxkNnd02j9+7cu260c7rY3k6g3rl/K5aRvuO2VnT/WRR3aZnyI5jueaOl0UDTWjsQikq1/1r5z3lsYa27hisdXx799+8XP2wpO7Xctcc3WcnDY5d1JWGUVuqxgsoKrjGzdewknURjuBjKPLRrMe5Ij1D5x1KsvF264Oup8S82l7FBqSLVd+gn3iUx/59d/NDc1L/APtIYHALuH7uz/9wByOueuY5+b+HPQLsB7AzCMN7r0G2MqoKGGvssWWjVQCMm4nkzH08tJaVPF+v0tCs/HxFGl1MKu1p6QOHbOjtuD6xvOoLI4uo10hlaV1puioSpuHsQ+d3Lhu/F+LOT7mUnkOJpNzkJ4hoJ4+H5zfaEekBeaMhxu5uUt7t/izaIMWNSL+5kF7yZjJkMAzndaREZujHzFydKZEs4jYRFvcsZGRZxPdB5VFcokCeim4b0uRS6yiDPAcR153yW4uuxa1TPXlPDci7p4MgofvINnBcVCAnO7C/cKZyuLNcw8VRJ/4XxpBb+Hc5vRi5y3mxbzuFjjW7VKH++apyG0C0wsyLr9Hn1LyZUJ+SjySmoySZaf0DEQGigA9Xlrcy7brPqnqaNrYFXmPyLcivY6z/D9zEexs3qUZ4ScIyYVMG68uG7zzhBXcsHvsnOcO2cTo8UjezMC6nxLp9xQ1jyTeGA/nwKc5FpMvIqLqf5dWjBGMBGdvU+pD/pkGiDx3zze5uqgucJ4b2mz5xmudl1vCB6pH9tlE3377hVvbbQKN2s7Lb7YfHUCVpbmDAkO7kPdS8meAac1LqaLICJcXYWjhj3c2APgATqr8KZ63tHhHiRQXI41YADgW7UNc5xoOK8rRJldCUJ4S4DR3+JZsopahdMz9Pjxb60L1k6hJomMAugHQ+pep75zwcqLHIyg0SNpUzoEihaogOitqDCDSDxR81kvukPuw36qKqNRT6oiAS0lFFTelCDNBVVFPnlYAm42wqhoVF4C/SzVyz3r0xado49AAii58dgTAJKDqmrxqr7ifPLcqis4omZa2SklFRZMUAa8H2I+hIiNuuebcpIC5NNABmZM4Ftqsmhqp2ljFnGSzLgVEj+M5jMJ/V8VTfYm3XgLwH+eZm9qJ8rK5lXGUPMuxs1fTA5hr8DuQTeshuc4jmZxRKfJeWlqGUx08+RKS3mqIfJ0HNDU3drLhwjEHjMsFKipt4hlfgApB1b9SCpYMnQaYQ2WBwpCve3DNQk7hZvBQLpBEms/xtUDcJB03fGi77djbaNfctJKoOHwfiqvs/PxnrHxhhdMjdj531u541asAJVX2kd/7OAlqKFHgfGhMl8E1f3LXCUwb0UPmSS1ygDfdsNAefuAkFTCn7JU3rLAiaCkLAOYD50Zs86aN9BtRwQ1XEGlf5o72Aq1n5pAoAYUELQa69hCJLWU+P2lf/teHcRIrbMXqKvvuXQesh3HYuqLOfu6XftEaOjaQOoOspOyO24OIWue+MhCt9ZTWlcfD3XDP2+lktvSr24J4byh1aYnHGOawvYNq2Yj4UBYSCXsQxYb0uqQ873yUyLara2T5MBE4CEw5Fy3XHHKGh9sendZwMlKtkuokjwLMldhXiv0bw0l/52+8hzlIkq8HasJ2edn2JGckwJ5FwXUxRUElAqA7T7MPiWssACYahsZBfPAJqA6iqMj21BHxLcP5O4fM6gC0F+1FjQSCrrn2CtbaOOsCmwzYnOT+FbRJwE0qIYre6hSqjAJo3T0DOLJj9uB9d7v+dvvixTaz9Ho7wvhrvH2PymxcBtTDq4gtJG1nvk+p8/Vs+gOdVOIANd+T2idFZ0lBO+88Dzyxls4foRPRBqcSZhqsuGhSLYroWfoOYx4AXTQWyYhSYEha5lbKicD3/m/buo4ALcatFJsrTraoLAp2iMajZ/eESiWjC6jrZINmFLN3qaqv1m8F60bVPxcuXIR9Yn0Rwf79P/1je/6x3XbFda+3S69db4cP7Lfu0y8gadhray65Jo2nCqcJfOtEUNWMJZ8qJyslhNLw3n6EEXhPfX0NCjq9du9dd5EY2ki+SqMnChfDB5SeeVNTI8GAai+CVEFNgO7BUTtw4IAtal5k9cITMTMB5l321KPPAMyv9PXoifk6kREeU5cFvemfPvmHH/iVuYX20v7EnFzCHa/g+4c/U8A8A8w5dBJoJQCEVlQWIQ6TpT/GPz7BY5ACXDgqS0YzAb9cRFpvn4uqR3Q6rVYtMAdGmgxaxFF1TdxTRZu1o+o4xqMlbkllmAM8evKcvxJeYCQi5mIo/pdwDJLh9eeKSTcHQGWY5x7In1tGW2DLuyKBKzcm8dyZ9KP3k7c9Nc03WcCDVwBSgZMhj5gVEwWR6oiO7p3zrkdwgx/Po8W/79F74aSDWPye4disvPRGJPOq0++0KXOQotv9PbGJcA0M8DTyjEUkekgBJnesKsjDfRxaRrcl9RXPKshtELnR0fMIWGroea+fPHhvBU8/VBWiI8KdyqI4qW8UNHdKhxqWbWX8zoWCbx5AWtvXlKIeGh6+dQTnGwc8exV3KASYy5FRWNnvkhJA4yAgNqqghDhrPGaTd6jGJM0v/2C4InEqFH/zKRQXdRwe1SZTW9Pc0ji64o8bqTgmjxOBdJDsl4n7+LwTGE4nE2pHnChgl71FRDIzYJ7a781NDkpaAES8RmwPnF9Fy5WIW9vQjmQm6hR0QxWfr5142NaUkaxz27tt9qkf2GDzOtsz1mxFDUTMd+/maHIgnTqpmWweHpEmMldMJGcq3xY3krRFVHdEkWSIvhPQLkZE5+C1YkjmopmIJV0B2C0tE9jW2tSDhsKLiu3k0Weapq7+wTO3LRJYAArOiE+phEreznVGAcWqAlrIdaU/Ls6ir0f+ODIiZRGA+1gQEgoA4UUAvYULQ2/cq/gybnX1gG5JHUrLHD74pGg32qxwenXUX15JuwGyAjtKRK5FX1xVSUdGpqwa8CxHQCBXToicCte95nlUUEhzaGwsaGZlcMK1+S4kkbEfgBlavoAjOOAebaTdUpu5AHe+ob7UdeF11F/OWhtjfY8CykeRZpSzOAS3ury6kIj5JOXJyV7l/hVwV6cAWgI5E56EOmvLl7QBavqcmKXrT0ChKYOjqiIzk4pKwl1VddFRZNDqmpbDSa60CyNnQrWhoM7OAUhqK+tRlOgkaniMybICChvOrCTPWFdyBArRLJ4F0PPAdL2KjkGxAZj/YGepveIXb7ayfOgKbfW2/cO/aUdBy+svXm+4BtayeK31woH96p33+Enl0RMqunTBmvTgfAkASImmiGDDHbcus3++c7etRM7tTT93kT38oydIdoc7W1tmZ4YK7VVveSeUh3q70LXPCuuXMR/IJWG83eLihZ167MtWteoyK+jbY3//mR9aP2C8YxF0iYYWK+k/Y48fOE/12jz7nf/rgxRn2YCTqjXIhxWUyfaCTCHDXwlr7CvT15dojGmvEcXA96lYm0GNjF3C/6+AzDwQHAg+2RX9nAJCYcVk42RPFFjJo8gQ+UGeXyVHNgyt0/+SfXNdcAc/gf+jyFgep1kkylaVWB0R2hqAeSV7hegsKqn+zne/l0qt7CE8xzh2McvH0SmQlDMUpZ1SPoqr2gRNJTuB9ACRmz85r6LMEOnllS60rvVVDoC79vprnaLxEBzlsydOeXvayGnatHUrnUGuCW2bop0C/EoCrVaSiPZmAGkRvy9evQnN+tN2+twp+85XKTDE39oXd1r+xtvRtUe4IfWD7pepnUSHZt2aQwG+j2dfareobnWijdDnQ/0oiBw/nqPdhLHXHBAwP8rDQPcklyL3enheQYHxm2fhK29IAHNyMwzVH6sBmNeTx7V0veV99TdsbU0RykQ1OMoj2IM6B+LiXo+LSsPzVLNGFzbUI3faZos7Om0RALyMvh0lmDCukz7JLXL9YZyh548cs53PPGM7fvA9HNA+a11zhbWvWWxd+3faqUP7GetaW7ZuvR+YuR3ks6KwFWLTlINUgI12uqP2E+b7k089ZacOH8delWA/qVXAZLr84svtupuu5mSjzjnlorIKfkxgB06fPWf3P/qonThy2AH/6nWbsF8qRgStlg4/eOyQHXr2oF159bVpbs7hicxrYsZ+/RMf/fDPzx+3l/Jn5o2S7K7l+76fernEbdfeRsS8lOTPiPY6GOU7FlIybGnyZ1za3KyXsUkrIKgAscn5V4ZS3dqFXxYLLm6Si7hnyzAZp4zn58koitLJfOr4DsOjCIC42dkxZqDauJ3ibBGBTkArgSX9za/pr+t8Tht9tCPX3MwgO1iTVU5t1OcyZ0Sf+3f123NcxOiwuTnq/RXGwCEvN9TinlWWOwZOSMQjgynKkx2h6grTJIbte4iIOZxQ5yIr2sy911x5i5VWVqYRCYciEGUAUG2WelFetCohqnhAkTilkk/yJKRIxI1k0wDZYne7Sm/sMw5UHLinueBbV+qObMykIB/q8vEV0fXQXvUxFiBVu/WO2PcczPkHknOnCG5Ec7NxEb1A/RV0KY3xBMZsWhUSAeaisugZLniFWF02igsFMI8ZGNuw3yTNsegX/cVdB5/cotFEu+ei/+kZ07udcuL9ERuuItt+Rc2JNI+i6+c29pjQAQFirut5o49CphJwLUCo17yj47ph8KSAIyoJAErPnubgLMl6z+z4lpUIUIia0dhuS7ZcbeV8pAKKSXv+drtp8QIre/dnreC7X7ITJ/bZ0eL1Nlu92PY/u5sjZags6o2U5zWhJC/mYxVAVBzzlYuIlHEKNUkComQSSwtnrA8euCK2Gh9FiZT0WF/Dz1BZ9HRZQphAudamHmUUkK+bSL2klfL2xQWofyj5E176KBFjKaX0DcR+KPgkeotPA8kO8uIEnxeoF+fbR5G+WEB/tTYLhOtnrQG42TVSZiJGzL0lWKSiQvIwvSow7VSBoUJAeh4bmCgy5dJP5zkniXqXIhGpzymarjUihkeowUh1Rmu0ELAzRcQQTiZKRhxsoepSBE2HOUjbpOM7ynU80q8EUjTNNRcbGolkU5FUUccyuP+jgHtVT5Vmuib+QD+AhnZPELVvWVEOF5x2VqiKIFrMOBeqJqqOWdGx0E4TMRcNR8BxhKJI5Xof19BrpQCAGigO0ope2LLeagDXE8PH2cQBtsX1VBt9DhpEqxVUtFn+wFGbaVgLYAKYYwfcjip5bnzAptDXLoDKIrszzvfEfoD54/l221vJXWCDz1u52B767d+ww8y9C+SmXHrVFlu6eJN99fN/58o8h7qQXYP2dPQs8nkD0tyH5kRy8C2XLLUh5mQn9J9/uesFe92rlxCAqLD9j56wzpUNtv7KV0JrIGeLOT9JReIzux9EmeUazCBUAq0PxlHM5+nzJ+zEsw9S4bjGeo8ctC984wmrbmu0269YZt++62HuS14EYOO6O663l9/xOnjq0BDkZPtpKYMuUJ4D6ZptsifJUPk2lNZw2s98rc4LtOfyQrQsHbiHRKrHbx3QxcVcZcl/SjYmXTeCSbP2xftx4mQ7CCa4bUr7gwNxfevkh9dFdXBWRmqbFFvqoLHouxY9bQFzJe9NMX6/9u7ftCGcbVEUVdp9VEmI0E8icKW5L95z0COlAiOQXcyYlsPjKsOpq4SKIfocueMe5d4HUHz2qV1ug2qqq+3yq67EDs3abnS2Tx4/xfpFVYUy7i3t7f55qXpcANBVcU21vbG+Hme4hj2phtOlRqtrWOjz7NFnnrAvfea/u1PY0t5pxVteZcfOK4k6G4g0Hv/Bf1z9hb2zqoICTbR/lIh53/Fjfv0XfYkqOXiUBY3sYQnR6ej0BFVSx8+PsmtkvOMFzNknFTGXLGg9EXPN1cf/hy06/ZitpfDWxVvWOYgtpw1VrMMK5nYxvHIKM7L+K5yWN8gp1+DwGOtigFOH83amm8RYTh/O87uUbyReoeTuPeT/DPUO+v1ar7zNynv22gvPPkbgod22XnWdnxDL3iliHko9yj/Qv5EfJnuntTqbP2h//cm/9QlVgmqZBBPWrt5ob3/XO2yIsTrfP2jnenq8ErFqWoxIaYcKql5NlhE8efI4BcHabdWaZS7J+r177rMOBAa2bNsayb0eEAkqreaXho89+r7P/d1nXvYfHLr/429jLjBApvs/8DMRMS/KVf4MwxV2JJkezW3N33lgNTNaueSZNASueCJjFx8IgBuIL0BOQBv/W3YsqLtkSUD6U5g/GbiQJtLfdKQ7ixeqKIBLF7l8RaKzBFLzY9Ewmpm5zBoezkPOFvv1BeADIAUtIX2pnQJNcabuk96v52Arh6PC2LsxjRvmFGbSs0U4WmgjeOY6OpYuuc7mdcyVJ2Du1JK5fs6aoGja/oe3u6axAIbur6ja+itvhR4qjePov+yB/BG4kPjlgfV0jEkCHp8XMFd0PqrLqfpkRITBSn7vTNN8fu+4xJ/cCQEix9NKBI17JJzrI5niRAkKa3MMRY1sAJzH6Z0UEW0ld2bRf58HWuwCnRpj3qYERB2d6VZKqplGzktR40Iv0kFEQ86Fvt3WqtBRHH/6fM1scNrgsrH2TVuv6Ymy+ZI9hkfYk2KDO5gx+7LKsXPbcDaF01V9LsR1vVf8h5h77hooyua7ccwPj9e5DJFaoZ/TyQ6vRSwvG8pwVuKRuAPoc8993wYyKq+CE9amNlsGlaWKSG11yYQtL3jArt6wxEp/9Z/t/IP/Yn0UhzletcnyapbZ8wDzoR6OfNM00bCIOjFL9LQMqoaitUuaiRArqjtGNJjojvjAI+OANUXweICoZIfGNpUxiwGvinKrT1zPWWvGF7BKUUPTStGoDiLmxV6gSEABKge0jkIifoMkxHmfKG9LAgpS/HH+Du/h82qfQHNUoiVxEoDdVEcEF6ehBOAntZWKSkX6+TxrQRQR8b1FcQmX/AJ/10YmJyauXQUgHgPU78wOjgAAIABJREFUjsHvrqmRGksAoiiawWbGBjhKNL0AB0KncIM909a8CN4zgyBeewN7u4Cz2qrKd0rknFbiKZ8VrUV2raEZPjBqMJO8rwJgPggwF/VF2una3EaoJlpRW+xUlkUdAGLpnaOpPoWDMcZn9Az5bLyLUFcYHuezfIsiMI7mejngTPNAfN8SVDaqAFZKRGtp2WKVUmEYPUVbVU682s707LeGSkm9ddostJbCuvU2A7DO1wYLneQCHHj0NW22ogXqS61NETEvRPt84NADtvPZUrvmLa8GrQHeKem9588+Yl+//xl77Zuu5HPT1nXwpO14hmqWOBsXXb7eBk92U/Gxm/ZKNrQADnmBrVu5EGdx3HY83guuqbPOchw+bPXiTqqSIu34hrd/wCPDsgnHnv6+HT98wDouutja2i5irauyqHIgHAZDxem2fXd9jjYOI7141N7whs12bN8RN/k/2iX1mUJ7xSvWUzVxFRz063FMOIY/ts+qOrfCWydwoRPVRNvTyvLE68x+ucOc9jK39dmC48XMY49FnYxG2Je00tO/8/aE2Mx8zmZ7iPbJL9w/wtoLmxtRoOCWh50OM+lSdN6G+Fm2sVRUFgB5rcC5OM0C5swrOe3ves/7iBZLPpZEamTxegBcC6ko2kjF2baWWiRQuRZ5BaI9TLPIRnECy7TvAAiLAJKk0+N4lvmJwwRR59PdXbZ71x7fT+tq6mzxMvISWHe953o9AFZGAqHoGCVQr5TwqD1MHPPOpctROWrgJES5A4lqov5igKUUs+PB7fbQD77NOHHdxhYr3fpKO3hu9P8HMMeZU24FPO0inK4RAg79JwDmnjCeDY3Gj58FzEmAtjJAtgfY0vj4ppGMsu9RbsjiNY2P9pcyFryAeS3AvAUq85lHreyB/4eE5q324Q9+0BoW1kVuinJx4Ct14yR1ccp1DmnI7q5u9NvP2iAUG81iadXrFM2/PAoRkW7R6HYfOIKe/zkrWrbFCrfcaotOPGQnnt5OobIldtF1t3mCqU7CQl6T00pJbEpSk9cF1qXYs6StwTpQeXrl7a9FOWrIdeWrSMDtbF9GIbM2p9aof3SSOMkpisZYYgqKMqxbt9qefp7ADRH0davW2YbNG7GTo/aVr37FNi1bbxdfc7U7GuN8Tiej2T6vk0x68clPfOwj4nj/RL7mAfOHfgaAeYqYa65m1sWxQRiL+NIknxdacNQRkYS5eKXeFkYwAy1urTKj6Duz1vK8m+T+nJQuHKzpbkFj8QiwoLm8vFRNS8dDfoTpX3GtLLnFP5tFtbmWwODc2o335qaaL9TgcIcai5vxuX/ZoDPAl81C/e6g0vW042gpdwc/Dw0v0z/nZ5SCMmpfPtHDQQehigDrBMCrl+p5Hc7N9fUUHL3nH77P+egC+Er0EGBdue0mOGJEiGI0XmyUtLF5dbK43hTGWHrAkmdSmW5FlAS0whnRcW6MUeY7hQOSouCJ8x7tFgBNY+8dlI591bf+awx28LsT8PTBT8/jn0kTwp2zoJI4h19XcPqNEhRjkwxOPnaSjUCOzAzAnPwHDA/JXgK0Sh5O+QV+AO5zMkFb7/60oaaxdekzb4/uFe91vnhqlhJu0wxKjoJDc49Qq93ZjHHAref0vTUbsxg5v7/mqoxveHH+vsz5iOken/GWevtFjdE10zh6f6Z1wRzxSNrYoD33wHdtAfO+ABm0BqgsyzZdZ2UFU1ZfOGWdC+61l6FhXvBrX7LZuz9nR6A/ddVsQk5uKRHzXdTggLPsxXxizgs859O/1RQL6oeysrFjgiaPI++mSqTBox8iWVERYKmRxZqH/9xCgiFazg5K1QeOLDTPpUnO0fJgnLrIF13XJqcZHWU42ALJY0TgC4ugkyBjLK17OfTOZwdEyL9Wtw1DpaHApSu3eEIoTkgFSikNtVxnHGUK5AvVM5VokWs5TfFZJWKKyiIKjDMXeK0CjnkB93IyE+Uk6+GVT9B3w+fpLwrfSLVCNUfkDk0BvFWdVP8TkCmU1jpOSXMtha3oB41NE0DgHEBYiX2qPCpwLn1znTaM43CUAaLqqQ6qiqMjJOVVsa61mQmcC5iLpjLUn2dVVAYVWG9tR4qNpi6EpjCIrvQE15xUNisb3iLk1UZU0VCqhmygor5U1uDAIyk6AYgXoFLVw6HBXlvSfpGVsKYnR094VHymkNd7D+G0t8Lz5Sh+8AxeHFK/RAFn3YYQVdWxCZHqWRRdZgokt4hk4vSonTuww/pGl2FbNkadiLVr7fg3/sn+5h/vtOu2ddjZ3lHbd+ic92c/Ca1lcHEnkGyUvOU4dCCBmnUrq62LCDoFQv0IX6dp7UTOFVgZow82blpivwwNIx+ZR62Wvj3ftR/ctcOuevXtthBecvGidcz9oDHp2H+WC40cf8S2f+9uO3q035rbCuzJPX0Ux+JZaEc1YHXZinp7wy/9gl1AzUJlx5/bcxYJxvcBaJCDVOBDfK/MpqX1l9sH3IKG+fTgSAJwHo+QTeT9stoRWIj1Hu9J6zP73e1K2LwA5+62uh35/L1kHPtJa1BZdB8/0VSQQrZOwJyPz4+Y61YCXbVITXrEnHniVBYAmYD5u3/r/QByStOnKGbIB08Saa1156aEeTyO9ylJx2logMVyNsnT8ZoCipRTKUwu0DCgXTKMA1QGU8EgRdfliKtwkEdHXVGkAGeWgjcA8PqGJgd91YB3Sf45kE24QDZlAHrVWQHTs6ft1MmT1td90rqPHQknow4FIYD5c2cRMshhiTQA/8F/FJyTxn91VTUUu3zrA/yOUcAoR87XdWRk1d3DVARdIJANLeVFwFxDE3txRAjS7zlgTsRcwBznVkWGjCqzlk9l069/0DatXwtVpd1aFyP9qCRY9GEn6F/X+VZ/42wXMm5qQvD1Q5FFRaHmzTRvz1Reke2abibeMWGbbnulHX3hqNUefcyOP7UdO7HYtl73Sk6HRQ2i0BkOWQU/V+AYlXLMofyXRRRzuHTDSnJ5GomK99tVN95o3YfJKaFvJdPY2NhMsbIOT04dk6Qje+gwCT5eMwIb0NLcYre94rV29fXQzB57AHot1LryKuzssH35C/9sW9ZfapsvvzqnypLRNhW5L1IbCgt2/vY733bxf3Do/o+/bR6V5f6ffmB+PcAcuUQ3Ko48AujmJlUySNkrDm40yR2UhicY3OsA1XORxkiIi0O7BDvcqIUdy8zaHLCKF/34UUZLm7+rjHC4z4K8ILFiPD4ZjlnV3k4gKYCS1mZEcbPfAw+mVqfnCuyTDK7am3BcWGQt1kBK2emAv64Vl3QEdazpdsCfO66V9ZOvcceAKYKuz+qMPr1njOO4PAyZUzMUTnSechj1+d09SdLf/od3+KLXk+n2OmxfuuVa+G6N/ozpU/G88X83/HoyAfBpJfmoyijR5jw2aHna+lR0hzYj/T8SE+MrGN/xt6CTZN6VG9T0GPMjTNFdc46Mwr1B7ckiVKkffa6k+6bG5uC0gLlzfXUsKW5vaANL2ml8FI40m3Gh2i8dO6JzTgNx3meWuJp1f+ZUxPjFkXSchGRUm/hM9rR6ZI1TTAA9YjgaWYJYvNNLeftb4yh7/phnZb/nwHW2buL+Pr4egY8rxXXilMT/o/6iy5WsHPxXNUD3jYRhJb4+t+M7XvZaILepebEtW381xnGGHD2oLLP32HVLFtjC93zDRr71adu596BNtWy2vOolAPNnrb8X7WBdTUaZy6qcfQH3Eccce2xr2jmaZiPpPg8Y1WzgnlCbOSZV4RCpgsix5FSXKo5FhbxDxX20RLXG0+ZWRI35wUElPUmBIM+2QK0ZAQhOTsONLAAUD0GDKQcgDAa3PKsOq6f1uiBE1ofhoVdVBL9dtJYinJDmOspvF1OsZ5hIEJU5Bf0rUD9RkExyiCNElFUvQ8lQrtWMM1BWRpIwNBRfHVJMaSRiLpUUivvUAhS1aUqDXMBmAi6L9MzlkORDfSks471QVRY2UYwLrrUUFdpJAjtL0Q1dbpxItgqwumOAHRriBKCCSk11cFCbqJA5yEZdDSAcwKMRLWiMNwvAD56ftuoGkkKp9LewrZQkdqppcuo1ThVNJawKnOs0oArgLdWDcdo7yqY6BLe9rh7qC6/JuShBsaOSwidDFJnp6LwEgIVFGKHyKxHiBQCR4fMHoRV0ovNMVG+4G3WJJfQN0WOc/BmScfOTjvlMRTNVQ0n+xNG9MDVkZ56713afWGVXv3yllWkedlLU5/Be+/Tv/YHVLl5EG0ft2HEkIDl90/hJkaUW50UEja6+CEwUorrjOspE1yqrS9FRn7Be1DnUVxI3veH61XbFjVdaPnJwtSvX2l8j6VaAM/HrH/41e/rfvm/bXv0G7FOBdR150iob2/AnGqgU+kXUMXguovMHTp+3c90DRF0FNs0uXsMz0ILXvPFqe+KxZ6znZD+0pSrbfC0qahTLar32dW4rwkjGugsWW5q8vs5Yo4lSltne2E6ydZp2J30kvRbFyPSm+Wdp2TY0B9zlyH1+e1TEDBubbK9uq3mvt3rEHOcwraUMK5bA168lB8Ej5gDzqhQx18nFez/wO05JUP0LnRSNI2MoakIVNJNqSWkC1F2eD9A3xHwcATCPACLHmT/r16yCzlUKWMMZ1x7BieQCOU6sgwpeV/KmkhkFflvbOoKC4nk9qk6tEzGdgjGP+FmFZqSdfgRJxBMvHObUadj3G9HkQuUFzfRTxzwnopLrlV/8Knv2NBQKPzmY+8oisdkr2U40hwxiDLQnjBHhL62qZfzR3ofKMnMG59ODXhmKSJ3KmnB9VuZ5DphnAN0xQLpLdrMs8qb9hZMkq+RzFBlC/gxwTtQdnvlGaGaVJDZ7cr6KdSlAJHUUr34qGxb0Ws2dkJ5UcCEUctz2evBJdRfGyQUZsuMXFtpUTact27LZyvuO2EQ3/fgMwLwGYH7DaxyYax5UlsFvRz6zWvr2pQW2sr3RLt+8hvwAaCzcS4XHbn3jq+35h3Y5VnJqDRQ3OWHqWxWm60OzXqcnZZxurF25ksO1BpsurLRLqO75a2+6g7k4Yo/sfMpOnzptX/jnf7JLNlxt67dd4Q7jFN+aT3qWcpyDelQALtu45sFVy5de/aKBfAl/YV9czO2u4jvHMT9Nx29/Cdvwn3GrwHOBQRQfUJpBQY5jruGcZ7uyBmRxwwgQpIXghs2hTNiq9F+P/SbAm1toHnVNUCze6BM1gF0Yw8whiAh0TGT9x4uvCJ7iQWojk8pAvkJqiWvsrUn6f1r4Ahgex0z3cdArgJ89V6LVOLT2BmYNiX+zGGiCaamhCcBm3nUWDk0PniV/Zv0UtkKGgr5QpVJ/Jo62lQnHkbIbRRZ1viLZDt4CHGZNmZwcZrHtcGUV9Ysiglp4KwDmlQDz1IMBOnWP9EqO9iNcQuROwFzFBFjp3EcblaI3KUKcwLNvMXIkkuPhgBJFDteUFnBM45p1mxtT53LyB+0q6ld/X1zDKRuJbx4DrSsIkQnw683Rs/HIAfyiOmXK1peuLu9TBGKcE4bZKZwLonuKCOmEIagsEZEOhZfY7OIHXTToLdEnMVdzZxohE6Nec/54anxcL70vN0+SwxRNjQ0g9vm4Z1B59HKa/3JI0hxz/fT0CY/IeyRuzpELqUU5UNFCzXlP/uJD+fSh97W0guGS7r//e/xChj5gtY7y6B3rKQrBfK9eMGoV5++3TQ29dum7Pm593/ysPdJbYZXL1kBj6LSDz+5BWQHOskfmItrvETu6upiI+wTc7Y1LUGcgojYwBDCnISUkZp4nal1SKspYlGJWN3W0UDVUVa2JMjv5hvb5tfy0CUBNoR2dbimhctNSeNlEg12vnOi1AGwZlTXZVx3YebRPyjdcR7/P8pkRuOJeaZsgoyLvUpdQxLy+nogzkfaqWmkXQ1WBQy4wL6dBxf8mqSYqWUQOV7wQkiqMlqCwoukkm1FfAx9VdBKAeTUAWncdV5lKHkpUFUXetfrymbNlaIsLDDfWl9FuaZajClPfCj/0rIOWMSKTiv5K5QUjZMP9RMa4cXtzlTVXFELrGEVKjeqHqrgoSgp80ykoOudJeqsneXEEPnZzSwX9RGEn1BkEzNVninDmszZVvl1zYZTI+hgguq9vnOevAuhQxIR+0glSPRHMfviqHYsvAeAzPuNI0FERVMndU+cPWT7VX/PRKJ+FS15Q3cEGDKeYsXCZW9YRAuc2q4ggeuezUmwhMn1y77225+x6W7MVObcKxnPNRVBDKu3vXn2tHZliDXLvSU5KRDORXZaik5LNWqqLbP+JEfjehbawttD6eeP4+AK7/ebFcFUP8DwldqZ/wlYgEVkN0Lzhjivs6R8+ZD0c/x+j78pxKH7nv37ITu5/2s4dO2kLSYztPQjYAhxt2LKByqLj9PEZe+qxPXYMasXeI0SKdRaCbVKF1bXtpTaA/ubw4ATH8Qu5XxmSk1RBXHyZNSy93EG37KubHF/2KY/ET1A9ROFreBrQ4SeCuX1h3r7k+1us8ZD0FUUmrIEWQS5gnkxJejNOKRzzH1GDwm2Vcm8iwuzSedqjHJlzauRUzXBy5wPzGnILJDGpwjFSZSkDpAncve9DH6JiZC8AG7oVa0T2+YWDzwf32iuGpgJsejKdZLFIVq9Y7ntNRRX1DeCauxon4FKBIfHGS1Dtkha55peUsPQt9aVhaIT9A4Muk6gqokNDAw70R/l9GFCuKtaiSyqoIoUS9a+eLwPm3ScFzJH4JMo+svgqO06ORUYRzFnmbOOK7kinpimq7fY9AhbiZV8g8psn6oyAr/ZRnBL3bnLgnA9IwmkUR1rFgnRyNB+QZx2sVZaNl//db0SnKMpOvkMlmqzVCZjX8vMD/81W5vWhbFLvjtaLao94P0f+l8ZaU0hOu4IdSshVNc1RknSdqskf/aSfOXlgssYqN91gS8iB6e86abMjfXZq9w5Owzts0/WvdYnjEqLlZSoMpNOh1hq7evMyW46DoDyCzHlUHYRP//Pf2l/8yacsD5tYDvVoFKfY61V41U4FmeRIEZggh0ABweraNluyZj1qO622ZvUqu/bS9dZEAOAHj+ywT/zpf7VLNl5vq7ZeljvN0VhJW/+ai9fYmuUdqlh7N3Pm5pjrL/0XeGgpd72c73t+BiLmt76tpLiciLlDD+btXFKFFtx84JxbVD4mAsIBPCMynUPD/Cyup+Z9AiQ5pJwQaHqvr5HsfW4yE/iRMdS6YYJLH1TH/0qc1C6ZL765A6GMSMA1dfw2L5DhaifeooR+3DmIxEZvQVqc+jmJcaTobxYtj3ZmtiMDXfP/9XfoesmxyJ4+nA71SUSDdRFtjuKMqwiFMqV1fJ3xD+dOJ+KekwCy5+GYu5ybX99ftuUXXW8VDXUZ6pxrn/dV1neBDmcA5TrqVKlkaf5mBQ4cd/vJRhy5inftm1Si/4jLHuAzi0iHU6P/eOEeb0sC2RkIF5xyR0TgPwBbLrE3nUCo0+eSavWLQJ96ic2JMUV0iqEVeBTHXLJQJMyNqozwMBFXooIACdcEVpZ7GteIR8eMzTjeevbQCdc4ZlExr2HJnwTaw/CH0kyM2BwNJ4HsBKvnnLvsde3fcS+2I9+YM4AelKQ5m6/rqt8cdCdQ75Fxj57FG3V9OZPepqx//ZqaMNxhpJ/I4Q/5HR40Ud265mXWtuZyuJtww/PHbPzYQ7a0osfe+aEP2DP3PmFPnC6wxWuIdNUutoO7n4XK0uuA37dN/es88OCATwBqtywdgw6B7vC4uItk/hP17qMwTjXZpcNEpLV2C1lHHYvGiIgqoTgcQT8BSI6dnKrRMYy/fCv2xUvWIo032gOgE08SigfXk1pK//l0OqGn86TubN8scG1yMdPGksSgKAWLmtmc4LwPE8Wua5SUIkEw9uUJ8SahMwxzXeeYMx8EzBW5L4ErXqTILe2r5PUKpBm95DgguxbwrGrCkwBIcX+HoIo45Y35rjGqqSlAxYajXuQPi7jgGFGmRZJNY6PvxwaNwi9XNFsUnwUFUE0mQqaupbHWGpG2G2GsKuB0D1OqftDpLNKGLrDe7iFrbFOkG741HHMVJWquqQcoD9IO+gWgo8qXjciZqQpsP4BnlPsNDQ+yIaJ6Ql8pQimQWQswHx7qR3Zxk5VKPlYlw9ECpzusoJ8jfNQoZgXUqSR4oQy+OQ7tBUCMqviSKUplVuRXK3km3gOx3hNpTz9ztx08f5Fd+vK1VtR/ygrRWp4h2fP4H99u//hwN84IWuc4MHKWxXvVvxrsYtZnc2M503TSOlrLbfeh8zZMgu+M+pTbybdfCb98Iwmv/dynFqD+/N4udMjH0XOuQqqz1l75+uuZo+P24A+329arL7G+I89ZIUB0CPWbtoXNngT/wx/sgj8/CTsBMCkFn2G4xpxUdFNJtRKll1fdtNgOPztgay5qsc1Xv4HTosU4tRzd9xy24ratbktmPfFd6z2TfqM/h/uoJInes8CS1mDCa+60y247KJenrD+I2ha2JhxufiL6OUvCnRKAJbnpf3HbAFUE+tadD9PfyrnxT8gQyCbGnHc3n/+4VKK/FopG+lLyp6g6QWWRU4OWuYA5c/e3PvS71nXmLCcWquBIYas6IsiYxd6uLoBjAxUh0RevrEbnvtaB++O7dhKYqbMtyFQ6SJMN4F8l8mnOizOu3C3lnnTDkz5DFLq/9xynPFQIJQo+ztzRe3Vi40Yro4IkO+e0Q3fgU/CJ6+ukScGnnjMnkSuttpXrN9q/HaaQFvbGL+K8cN8Q0yacGUO3mMkwygiGMxObp45eiqwEab8JFU2Tt+776hyId29cBmjkXHwOWldu884B9NiL/T96T6KZ+n0VZUcVxSoIfCliXk3EvAKgPnXOGo/+0NqKSTpG9cWj0VzPk+DVYn6Wzrk04AdxXuTMTIs+xoAqst1Agmwte7Ycn0LWXA1yho9P1KPmUs8J3YAn786M9lvXs9vxCzptyRWvAkDL9pG7wQngZTidb731UqQsqT3gW3vsRb7f8y1u+Nfu+bZ9/xvfsyMHj9jBfQedsuf8e77uuPUWJFLJIcKxeeSxJ2zr6kvtfe9/H0pRFQD5Cnj7lbaIufPM4d32m7/xXubKjdayalPOd6kian/rVZts4+pOl23kub8J5ek1MVtf+i+eeQV3vZTv7//0A3OpspRJlcURWBie5Fk6MEzQZ97SySB0LCaPwgYgjN/1cQHnBGszMPeicYyJFfrW6WOBk9LEC0Oio1xt8HkC40w4LWiPkLNA/O0OiHRP3d9jeBjbZP38z/Mumn5MrYrPpzWacaUdaMWK8+fJFDT88dwzjmeTwdb/Qolmfs9E9N/hlwyvPuP3UZIchg5jVsB5bB6L1D/rEZUXOz/jYxzbPgyVRVnnbkQDdK+8GOUEKpHlxkO2JbP2br+i+JLup2izMuWKiIao3Hg+URIH5+5E8QbfR+LISxFc34McNGlcwuj4qKagUVSljIFy2oWiR8nGigow1wWxoXkRj+ismBJqVJTJC0AMCPSx9Gg9n/eIhpLrAjwWOjAf5BHgycNrLZAzk45V1V9h1wOau2OXnDIB8CyiJT61J3z6U4bzGNMhnJKgqehf9UM4KKFrH8ZXHRXiiylZ0+dxAH9J4UXyY0yqzA2M2esv+H1ijAMY6zX97klu/CsFhIx3Gcfs8RAOAGj7FI7Jvh138TLRJpBrQ9NSa197sZ3d/V1rXHqR9RzZaZtrR+w97/0F27X7hD18fIGtXdtuxUTWj5D82UfEXF86hhYVRhFmAQnUiAn6TsNPn7VjZynRDY9bG46cskHAcSHReYEYccpJU0TLF3zKXiOAqAh32iGIukXBolG42Rn3+poNDUTMuwCoigZiyElwLAHo9/ZLYlH7ctC3CmiPCy0pYs4+q/U8rSi2qnFCT2mo4XPFiqqrsBKgmsTQUqLhqhgqR06AXZFzla7XiVIh1yyrQoeckxYB/7pSOXNEuYlID8ONbkTWUPfVklKUWgWANOOUcLoAUF8jcM1DttXpyFoRL+3Li62c6prD9NUITu4QpwsEwn1sVJGyiAj5IgBmXVkdOK2XzZSiO5x29VAUa5ik0gvQcrqgbzQ2lUDlGadgUrUr0jRSZbB4GqcTRZweNnElMZeXA6qYqufH+j1xq39o1Ckv4hZLKi+fJM9KJBPFZW9rQVt5AfaDpM68wirXlc4bPEnipwQLClzBQzrOxSo2BK9cFUAhrdP5RBmpCKoaCorcGe08/MT37Wz+dXbJFUtt+tQTVnbRzXahfauN/8MH7dNf+Q7PUgRvHL48a6BAKjpyM2WWfEWRoEsiax/9oqXUAeAeG6Fv4d/XcnrRRz//yhsvgSd+3J47gONCZH+AaPnKbSi9lNKXC1AY6cORWVBtN0F1OfDM0wCZGTu89zQRvB7n2A5zjVFJUzImymfgAMGaoQYVk2MxznwWB3eQHIW3QHutQZ+9tmO1/evf/72tv+V223j5K8LmeGCHNmsCTgzYqce/CSf9Odvyc29CHe8ikmC5rqu6JEodEcx8uPhBSVRAgtdxavKQn5TM6yzUoOmjO2xBJTzktg3M87TGmV+yFl04eN/dSRDGde/mgHnQv2J96+Qnk0vMAXNshKQnq3FOApijY64S73C19akPffgPUEs5aYta2uzGG29y7XslCksaN/Y07RWsWal68O8MAHlESQtU4JpmTgyPQjEh4q4CQKrmKQrKKItvFGdHCc+jFBQIOx17b8giqkq1bzR+h0yVyaO/cig8wVA2OPYO7Vly+M6cOI4jWWWrVi630caN9tiRHndExnwPV6Q7bGm66DyQnuznfDDNXqAAUz2yhANQdEbPERUXOHcTq40gRc5xEm1MhYz4vYqxyYJCvrXEjpY6Kv2c4ROeT8BcxYYqGfcqQHk10XLyH0CuLsNY1H/A1h/9jo32nnW1MOmER5EmBQfoc4yZVGwU0ZZy3B0VAAAgAElEQVQjVQylRFVWKyqYM4yFIuZNixbbJRdfbF++H5lDEs2nOJmSo6Rcot492628aa0t3Hy9a9kvb66011291i5b30lAAjlE7hE4IfVPrpuiSNTp7rP21e99yz73T5+3E88d8edUYO9jv/dhq19MQTLm0RfvutOeuO8p+9M//rjddvM1KaeAwAbtfWzfU/bed7+far0/Z3UotUiicQXVRK/ctAJ1qlrXaFcuDl//wKnKr764FS/db8wxkmfsIr5zBYZO0TE7Xrom/KfcST2rb1mLOSqLc8wFzNM9hRH857Tcc+AzYe6sadkkyVCZg9kExnKf1foQbAmEl8O8HrHUKzJqul8Cwd48RZrDPRBAkGEVR/qCh+yCyuL8QAdK8UgBIMMwubyVcJCi5gk8zW9irh259qRu8es5rPQf5jTQda8AdwEsdW39GPz5HFhPD+fA0418AM6AtAAJgJaerYjI2gUV5VCY0COm81abvOCx8wDzB1LEXGgugN+yrddZJYk+0Qz1dYrGahEKVPKaPHMRDqZGtBGzmbHoRGXJ9xLcAcw9+TAB2YhZh+2NgI82QV0wNpugZQRI9Z/89cygqhOCd+2ChP6RAKAOYF1iTL8n6olGyKt/hrKKEtL8StoIspOFFDGX8+WcfJI/UQziuQTMM5nMiOa7LnCKgOejFKLIoArg6M4uZ6aLE7qTtKJTMHyORfQvJ4XoYxhAOQPq8UBxcjQXCU/QO3auNI+zvogRjr6MfovE4DS99bs7IZqbogOkqLlz8uVKxOv68q7nswt4/xQO2rPbAeYaR+Z8YytGcs3FNgXveYZoXf+ee6y9dNw++JYt9vixAuseJolwBVzhhlaA+R6AOdElXyKAbe49yqaoQjDahBewmb7m6kW2f/8+6xqT4o3Ah4A5wL1Ym204UGtaiXwXEpnFKEvPO/zA4Nv79OV9w/C2BTilg/6yy9dSvno3XGtp/BbYmbNwseuQYexhXikRNR3rRkBSSc1SWKEPcAamuc4k1xFobwdTXoBHP814VqNfPkPktoQiR1OTUjQB1NHOaQCjjuwd5NPHUmUpRqFDEdAmos0LFsC1Jbo7OkTxISLmcrqkhCKHQIIJGkqBdo1TJYV1pmnzEnSIRyap2sgYVVW3WP5ol6/dEe7ZMwJfW84GyY+jREXL4M63IKuGmiQnD2iKF7M2+VvviBwTRU4B2BzhN5J4OjIyAXCtcd5mLZHtIspwT/PeIfi4nGlZCZxYzY9JNukJKCdn0Zds5YhZvPZRopBa1wJoI0RqmxvXBk1Dzq9XOKSvhruIKsMfzey2tMqLGjj2l04lPPYpFZIZtQK452J+5wHOZwCpR3YBMJe9nhOKcisSl0if27DZ+j/5Xvvyg09aF3ScfsAw6ceuIe+1BJxuFQm0sdTlHHEqgf52DYBcJelV1uiaq5dbbcGYHT2lEq2czuBcHAagV3H0sWlrs02e70E7edje/O432d1fuJP5VWBXXbMSxY0e+/aOU4BSZDGZL330nWeV0D/S848gAb8TEKivKiJht46E5gI7fHTQrr8BZ6pxia27/i1hL9yexxoQdaj30S/YQ2irt61YZBsuvsaKOq7gupKvlM3gzfRR3xNftIar3+m2K9sHBx5HX33zyz2BFY6NHX/oTsYMutS174qAh/dE2MsXkJTcsXcMe6Qgiexi2lEys6nWK9LMks8qQ2YBZGmMOzB3KgvccYBdBsx//w8/ai8cOuwKPW9769uZV7XpBEunAtByAMUDJGycBXz39Jyz7rNdyPWd82qhktrThFcU3E9i1VadXKVAjAI6aksGlnVyKZss6kbwjDX+UkliTQJKi7Sv8CXFII/Gc81J5s8YgF8Sgt1nTkFlKbNOivKUr73a7j943itljnOPCZcNlGfiSSZBicw0Xd0Mpt9VqUndSnBJGeFljLN2j4mzJH4K4GcRGVFYPGFFykMEI1gjhlM9B8J1ySy6ngbBQXr62bdf+gfH0Wkw2mtKVQkUI1TbbKUtzbalHIrajz5nFwZ6OLEAqBJtLsVZcBqP+pBrFNNOBZZUvEngvMLzRrBZPMeSzk674cabbQVc/9/6s/9mzx1EvaVhGcWvCSRBa+vf+yNs97XWvHqzXbliob35ps04oJJkVCJoFDLypNKMCZAgQ47WIvoK+8TRs8ftj/7mL+zwo7t8T/rlN77VGqgEOoGD+tRzz1j/qbP2y29+q61cs9orkEuCWON+Fyf0f/zRT9gtr3gHSeeV0BzbbP3KNp6h2J1FtSEVVPoYFUQ/6oP/E/hivhImss18f/tnIGL+8rey2P/KZ7LPVS3iAB+OyRx4zUVUfTwCo/67f+cBzPmg3t8awM2v5xeIReHRRwd7cZyvP4ZKh4BXRDDcIIMClAzpKivicylMlpH8nPOstgd4yl2H66WXc4v0RS10XJUaFQgmqZVEJNMpCA7E5h7WHYj0e0Tq51FI0nloCo76cZYnNqbnlf6sYGOhF/hISSSKdvlG4/FaB3CjI+ftwKP381k9e+bUoMpyGUVAaigw5DYlu2r0ZVSTC8UX3XdS/GwMlrjaC1zRRNy0OJKd8URQdVMWydW/8ZiB12MeuCOSIhd52hE1holXHs8uexd9E1g2PHqBc9n4EDaJ5woJxjhJ8LmgOyUHSsAzAh8C6jHTXC9aoVSMbKFUWXBmIvKVotf+2HHtmK8pSp9mV/IyeEtyDrSRexviuf28Q5u8vxIba65PIpwTz+WbbaL7+ElANm+zOZwtgmwM0/xWNDzu5v/3VqdOVpeF5n4k6uqSzgDw/tRnFAFi4wZU7dn+Xd9IVe69blGnNa3c6hu6qvgNPfdDIq9T9l/euMSe7aom6ENkp3mNlTR12CGoLOcB5nJSlU4r10SVNUvQyZQDMksk+m23r0Qu7XE7MVTq2t0qDz8gjjn7kgCzIoWKDq9azmfoOilxOJCQ1KESJuVoAPrGJiUnKIGISbvlttuI6P/AzvP5YkBa9zmi16ij9PaSIEh0cwSw6g6l2xXNF9FddNKDI8L+KsqKAP+GpXC+AWRc2spJ/lS17dIyJZZxkgIgHAcYS/RAZiAfUKiqgOXlimJ7z5I8ioMyfcLOsYEPEcUVgFOE8jyc5AWoC3h9BDp9BNCuZ6mCYz7LQ3S0ricYd5RjawAJZe9FOeFJSeQkEi5dfa8+DAcXJ6SO4+DWpVeQhEmElWI/eURsZ4kWjhK16yeyJ2A+hFxiPRFeyTMublpEdLnfGiqgmchB5VqjUF/obvizOAE40LM86PDwOZLEuq2JaLxyDcadKqANUvQV5BbrV+K0yJ0TjhBvnfEZ6bUZJOKcosDp2AU43Bco3pPP/WYYozxO6/IA51bDEb9xesDfbBzJPIqbPH9ui118bbtVyWmtqLX89Zts5Kt/bju2b7ddL5zlBKSAxELN36AsyeHWfSbpA927kFOLchyHJiLmCmkPckowBki8ckuHddFn3Uf7iG7LplIRlc9I7/6aS5oA7ANw8Gds7eJqe+HU/yLvvcP0PKtz3zW99xnNaNR7l2xLtuUqd2wwYAjYgAk+gE0zJJAEMJBs2GwgCYkhJmfvlHOSbEo2wSQ2ZWOMDTZuuMtWt7o0I41mJE3v/fzutZ53JMg+5/xzDr4uZ+TxzHzf+73lKeu513ruda8eLxS1gATZgdECO0UVxH6OU9Jxj/pIoIQrF6i4lWwuc0D6+GUlBG2g9UwzJsSbvuntl9nKq97DrUYpL834sONBkzv19N/Zffc9bytX15ATUG3nveMPOXe1n1N7sNPDJ2z/z75hi2/8KJRJ2kqN3NdmL373bpuzYpU1bnk3xZF22wvf/zZc9kZbdsOdNoEWe9SJ0BVzbDvJss8dRAnHK/xmiZ8C+bH6KKDgVRUdnAf4zzCx1C9EX8mAeTXAvIydAwUU/vg/f9EO7D3gNqgcyoqqcgoUq9rsGDsvzit2iT7laXDjaZ0QrUUULwFr0RwE8PRmFvGOZEU5epINjeqhApyuie7AXfKlOMRS+gDYK/dECmBDqH2o0JFAsZwtAXIXbOJf92kSkHmopUsWWMHSC+zhJ18JW5jZ52xN9Wh3ZkuT2U3rz9nUmfhoWr29sdLfvm0rUK7zKCGCNYMxb1CazlwrbLZ/uYFNIH3mtfRLwh90fFQCRdPbmubbukVzbHDnT61pHK459JxSONdOZ+H4QXj84tL7TijzVLsOXg2VdVh8c2mLzyOZdvHSFbYWxSPy2+3zX/9baz0B3ap2kU3wOdn50f1P26oL32FvuPoSuwylrQZoWkr+lFRmsWuYM849jyCp5swA9ISmUj+p74aY6089+yR66XudoqiE0Ep238rhoC9dtITaC+zYsQOtNVZO1hD5Mf/84/uoVfADu/ndd+J8knhKhF2VXgHh/EQVhu8KqDnQqz6wdnHz/3GmQX+7v9HuZHgbW4b2r/8BgHlQWWK1DOPym18Z/Ph3rwfu4Ds88ogUZ0A2IrERMU0DyP9MINR/Cq/oPY9pplikonUCd6FjLlqDg0aiVgLmCnm5FrQDyXSvDm7TvYv356gx7jroKBnYDFsbHOS4+ewefPo6WAwQdaaiZzgqWbsEgI7nclvhW33CGxFTd8DoBoAzZqosXH+MrWM9V4GDzNj+CqpFtIk7Frw/hKrC3mefcvAQyWnRLsugspTXqCDHmfZ1+OgGWG0V2fZKNlHEXFttimzkqXiCV81UQmdEV7IqjlEu3m86zqvn0OP6RI97i2aKiLnf5tnOjD6sMEYQj+M5Zto02jOSQgNCy1GKPQkBY4FlLdRpd0EAQ+AcFOjAXDsMAHOpA3gVQy023uZZT3jjBw1GXoCf9cxi7NdLdx4PEpF6gdWMqe6fF5jJxkt0fWzE+KspOq5HSecK2cTU937FMPTRktFG+isD406virUwzqA+9/8yMB/jX7HzUCISpxNAjSO365Gf8Al2WYrLrQaKSuPK80IhAePbTeJeDkjpz25fZE8erIZjOmKlc9ZYcf182/PydsBwr29zCgSIo67Kl+XQO6TLLXWW9924zLZufdaOD5Xa3MZcaC0kf/arRD1XVNU69Q/PunIh96NuVhKgS3OosjTSWYqisxiyQw4ol2rSpN3w9pvs6JM/sm7OL5lEAXJolna6U4uAnLFoH5/5chIZO6NEZXUtgT4FvtT+W85rsuPHW22E8VtCUuI0914ESJukIaWoooi5qn+6PCLmQftEpSRTFQPMVaxp/oILLLeHNmCXbRCqRRWLzDR0iB6KCKml1X9KJh8nSq7E2hooGeWSXETxpO/US1QZpDqlR1LZrmZxmxjrA2yT1Eq0TwnOfVBVmkmoqlh+g413HrJ8qCx5jFHtVk0PtNspFHVGAean+uGUN7AjQVx8NvrIHYPHAeaUwUY2rQCN+Ami1sJ0k4UU/iFSN8XYnxw4CjCnMiAFTQS8xknS1BzPl0oGEf/8BoC5OoH2FzB3OwEFZkKqEkoox75o7uaj1jI2jooHYF/jRQWrrIGKoNp5RNljGue97+RJO9g611ZsqsRp4zNwX+FKWM6hbfbCvffYL3d3WTd9OzKJ/CFPAe5wR0ZJxQLYchZWzSUSfmwQulA5fNVi27nvtI8xRbz7kP8ppJ8lkSlKU3/3lC2kumhd1aRt28ez+9wVEMxByq2I6DB0HqgpxzoGSBCV3ae/UkK0ouba7fFCyowhVZGVhJx2XJQwuWhxtV134+VWOnud7wjl1C6hnSMg4HZjkO3+v/gM9IRSm1dFOwPeLnz9rVZIomDYNKKd7Tusa/tDNmvLLeyAzHUOetdz99vjP7ifwpC1tuXW99neB+61p54+AsWq2FadM9/WvPmDUF/mhq1h8D65d8xeOY4mvAPzSFYP8xI7hw4N6TMtDQ7SRWfw9wSAUehxKkskf1ZR/bMMmUPt8H3+y1+xfXv2uqPupkZNJ3suO8daki+JSFkgD2RlKiGxDinJU3xmgWvteoiW4JxzRXxl/+Rk+1qbH1FfjtW5RZMR5WWEjpd4wTB5UrqgAKIcxwbECLSbmcc8Pd0z4CBwiHyLfigfpfze2DjLSpZfaD944IVYaMM0pjUsbdumdfrMAem4/9sfYWdjscq+1bCMayU5D0J1qV6UrpFd0xfJ+CPb8Y2FX/9Lr6efipqX4mTWz7Wy5vlWhrPW/dh3be3SxU7rEGhVu8neK8FTSbfF9JHaUTrl4u7PJll09uw5SKQuxDghj8pORgfFhlqOHbdf7TzEjiJzihwH0Xty+0/YVMsuW3v17dZApdUyAHkl56uGwqLdE+1ENTAW6nDY6qTYw3c1kWxRvTS2VC8hJDF9kLkD2n66w/bu3kliZyOKMpUuiVhCsq/GiNOU5MRJRYefQ+xM//33vmWP/+QZu+V3b/cEYadZ0bSi2nggSM6Ygi35eTd86fff9eD/Ww/9//U+9y5FlgW09T//hwDmxQBzAZxMl1tDNIBymksZUE3gLeOPJ2ybxrdQj1sLn30ZEHMgqAiVc3PTxEznDb6wtvkDzcXb6V/yhPO1bcugm3JdUEUDUqZ7dn9xs25c8jDiHsTV3fs4DQCge0nYzc/u0oqKZie+QWx3xjxP6DruhRc9vuzHZY2RjtH9JkCaLK8nVjqU04RnIEf0XxdXBJiEIN7Nx0iqiXJzJXukt8JIZl/DfQDz537l4FgTTdEiPczCcy4DnDUEr9wfMSZiBBAi+qIIuWfKs+hKXtI10+GzuzOjAgFepEeFgASMVaQnGi+rZDejw+3AOdktP79uNMaEM9N1CzqHR031k9dlI1PTZFtsfqd+j7F96v8c2AquKlKuXYWURMTvkvASbFZ0YATnYgJAUcS2opyZKUXL1Raczxckv/eIOHtMO+1eOMFIje5jUc8Qfae4cbRbVlZJW80B5qNFo1CNy6Ppcb0B4qG8n/zhtNCfPYh1rhjrMebOuLWxq6CkyrRrEqelv7PdgzivhlzE7EMP3JNsBcgAW7sf/amPnzwiHDWzFlntivVOz1dkqH3nY2icj9qfv3epPbK/CflD5CUb11hJ7Xw7+ooi5kRROXQEGogG9iCgriwP6oaeEet7+5uW2rMkBLWPw4cEHCnq3U1SZSncbpf9EuDjedYRMdfzKVqryK8vzBT9kbautMD7Wau1IOXx3nU332QHHr1fqnWuBd5P0mddY461n8RBcEp/UDAU0RPAE0ZUQqUwzDhRVVdUYVxefv5CO354jw1S8VXccj1zEQCay/m1hrnPEXjs4pjnA9ilFlKlAkOqt0NHLVhxleW1b7UOIonijlcD2GHK0AYAE1pAUokCeNolqEI1pppCXCVKalx4gQ2c2MrfaI7nq6qkUm/pY+gl/VDMRsSz558oJnXQiYrWv9kKOw7AYOmKstgaDQDz/uFTOARQeKDK1NeUAXhItELOcHh4HzsHRLaRCxTnO3+i18f7VNEsL46Tg2LKWDeJu32nkWKc5WM3h2ROVUjNpaKhEjjzOM8UEUynHrDo5wHw8eZtsqSKyoyVUFq4d5LCcrimKeJPkug0yZ+5Ai2LLrDp023YUyJ6A6dxfsehR1CWewkOBMmz4q2roMz4+R+xnu/dZt/81+etm48NjJOZIDrWNNF4ReCVY6KoNXNJkcO1y2vs5HG0zBlXfUhDaojW0h/q05VL0SpnzO07Ooys5Lgrquw8TE0Hd2KlJoH4I22vJF7RnRzwCECGm+MzV/PGs4qSMy+zq7QTYdFKlGhycRDOX1vHhsAsqqkjzVh/bkjY+eRSkSgoGC2P29e/8g/I0pXYnFlldvmbLsfhQ+9+1TXYFvqOPj784DetaWE5TiwFqpZfD2+/2Tr3/NKe/sG9FHYCgBbX2wgD/vkXjuJA8Ow4IO/9g5tt/vnX06eVvgvz460jdgI6j5SwvO6C33esJfolQI+q8EZMI6O1yIKIciIwrsRPB+aAMUXM9bxf/OpXKRy2yznd8RULptpRicjaMchAtkv6RYTAr6Uy8UpQFDDXJ8Qdl90dZfJp91lO9RBjaIyI+piUWFirRMkQRUX0GkVbtUMk51Al3BU8KSAIlOvqYqJGmZ3qUdn6Rjt85BXrJvmztrrGFi9eYKXLLrRv3vvL2G09+yut0zOA+dffPQOkz35dxj4FswKUyxhhPNSYUMMIPyOZiWRizcJkq8/6cHa8txsJ30S/e9GFV2AomlPnS0WBRGfBsagABA8d308Ox2lbvngheT41VoV0YgnvKRlb36oGWg2fvgT6XCkFGaSOovP3wu9vR7L2aGurHTp40KUttfO7G5s4SGXknAqoZvp3+pCNHd1l51xzGzlkaMXLNma0FTpeNF7Z4ULGRi1gfd3iJlu9aBb5LQQG+LtAASs5UfRzD1GSXnIG5rKzrgqvURgq1ugR+lrYSeNBO66RtGvW0tZq3/vRv9mLj++xm6FIeQG2FOjzIJBolSrMJhufn7/kzz5x66Hf7Krf1t/gpGu5Vjlj+/7XPDC/GI45FSLvySLZamTHI5r0Mig+aDMw4ujM54M4uJk2qc+XrHeyCfcbszCTmkvhSH/Xr5m8Vv9doERAncEw5du9sb2my4tDpUFV6AZPIF+RyESjSNFmGUbnmescyXZlEQuPhLpZEmZL4NwBqo5VtDo9QQqZBl867imipfEz3Xh6uogS+3l/ze4ko5EBfc4xPNjr7eU65oqCKyHTF6d0Tr8/IuZ9HbbvuafdUHh0lS/9f+GGy0gWJzklPYTAiC9dfF6TTI2kwgQy/COKNrNVri3IXBbhHIyXJpicAm8PP2fQNAIaOmRMz6fnDmMV+wTpmOSUqc3ziD6rL1yL228o9QULa7RP7DIkzkKAeLUf9yjA5nEcfUzyiDgQes3vAUMgAK5FdZgsdxUbKSqtYAyoBDH3JyOU+jX6LSCtv5SAbwaUM7jtShJ+jPpcRlyR26z/w6HzrUl/P7VBZLjNOCfR/4k+Jbzvn8miNbqvNDZSJN1zDxKXPu1yRyRebTcz1rJdiHh2tYeiFe6ciIsJEHzlkQdoQsYMBra8aQFUlnNdBSKXJMO2bY8B1MbtrrfNtqdPrbCG4gFrXLOYnKUFdmD3duiWFBgiSiyAXURkeYCkvDLAzyjKJJOortzxu+fYUw88Yi2TJNMp+o2EYhe0kmoim2MAkymimIpQrl8GH5p7iChpuBGij0jOa1IKJBTTmeCzefCKr37rW+wQ1Ur7VEaalaG7c5wiIzmUhZZsl3SQpTChhtC5fasF6oh2egTy5Qwo0jttWy670E7u/ZV1E0EsolIp/CsWJhwDEPoUiiiSFRxDTUY7MeKM5/P5qjKAOhHUEpK1lq6+1qZbt9qpCQpsULGyqkya0kTM+ZzwrApu6LMjRL4VAasm2l4B6LT5F1hO67Ocjx0aALSPGX1gEqACf7VTWu5EoLVwVjAmy879Hctt20N7sRuWX2XF4o6zlT4xjKIJQOFk/4irbBSjzV1UMd8Khg5Sg6HaC2ZNTFDcRVU56fSJUjjmzNG8kkaEIJ7nnjtZ9Od6JDUfAD+N4tEkBVCk6z9ZOouKrbRFLgosOAM5Ap1DcHgl9abBVlFjOSg+TAPypZqiPI2p0W6XTrRNl1nOK0ecT6vocH/eAuoRldmhww+RoDsIR5yR23PaNmxebQ98/0nr4N56UdhRVckp7K7bTfpIORGaUXn8XQwNqrGR7e+SAnIKBqyLokoLGkusE1H8Jnjyw0TNB4nqDdD2igSPEaVrqC0BsEA5UOBBABrHsIh7HxfQ184JTp6PNNk4Xpup0MtxQWkBQGFD5YgV4NWds34OBbhUHXcZWv+bbaruHO5NyYyMO5ymnl0/pBhkpf3FF+5Fy7ncCpGkrJ5dbm9986VWsegycgkkT9ppe568zyablpP028K4qLemze+kCNPT9u1vfNeWz86zHUcmcUKKqN6I6pVTOqbtDdcvt823fAj+/jJfIb79FIV7mA+Sd3UaHKjVrWlaf0IeUYmTWfQ8giqyAaquqPGi4kKuygIIVjKgzN5X7r7bdr60fSYBM6hgirhLtUfBDOhXkn/06GnUfFAfaddF1AWtnypoNcE81O+yCz0oN/X3h/yhdi+lvCNVonLKzjdBeSgl+bEGICrp3l52vGajDtKDo6tdEFE2crimqoNK5/9k3xC0t2W2a/cLduzgAVckWUAEeO66i+3uf/iR0+fCyUpYYmYpjV88HpIAR7YDnDllulfdgxvJGCCxDgqUq8qY7LUcT+0KSbO/WLlYnNCP1dqoxk8LdFr/ShFSGKIugFcdyygu7Ix5QS4PEMGIQYddWu9aMjasXGWfu+sPyKvG0Ua+1zXKfZ1TvoXqFpBgi8zkiVPIH55os4OHDpBfDWUFQCyakRwZK62yfQPMPehxDVRFVZBkoO0V69m/1dZfextSoNgGD1oEp1xfwS0XWM9xedINS5ts/ZJmdizK2S3qt8MUdtq5bz/XO2id7e1ejOnmt9xst75N4ikRQde9DkOv07hTrlAp91/E/ShgdrT1sP39d75pu57db2/6nXfAR4/d93AgtdhFMA8Z0LG/vOt92kZ81b5Yp9/MxUcYJz97zQPzzVvgmJeUwjHX7IhFM4PhGnQBaAOkumGOmJsbywz0+kcdJAl8Rb/5jwTSHbg7CD8LwCdDlWV0zwBUp9RE1FDmOU9AnH+iZmjCeOEGhRD0XxYN5XdFUVMIOl0n7sjTDdO1fHJ6pFiAPLsZTXYnHKRot0+HNJED+EeiSbRBRNzTZ/0hE6hMPz3JkFe15eigPoF7qYzofgqkG8tA10Kn2/cMd49G+TRCWo3t5ReembmePyffS85Dxxxjp9vQ1qZzxrXVpNvXtRUxx6gCu1LyJ9veqkjmkxyOrbbZ4MM5dSPTIlfkmpsSAIiWUhsGEM92CgQMHTj654LWkCXehKqODKBelCMRx/kOgI+jaBuXBExjIF4XV1T2kDuHruKZ6/qcjLci43yPYmDEi80nYp6naKQMVDjsTBQAACAASURBVNKNde5mcqgyRZUYtZGMevZX1kXBcE87ID6iImKXgeJo5zMR7xip+k4Rwuz+/eTZyIpBPuO2pXESi2ZaaLJ9Jy2YyTsMOc9oHdH3fcj7pFOjyJACzJF024tcoqJZWnArZy+y2WtQiqI/8oimH976C1dN+cObltiOU3Nt06JO6605ByneBXZk9zai1Z0+TrQwFxNVHoT+UVcNfUJMBigZb73pAju67XE7PgL3G/BKQIeCOsglktSmiLKmdz79uHYpqg/cludrySnQPWuNkbAHi7Uk9ZT8mY/xv+rtb7cDD/2b9UsthafrhB9cB23gFJQWqbxkRcC8bTiXEnZFU1WUaILFVmuoKhhefdUWO7rrEeuHTlIAtUbDTpKImiQCPRSq88qaEr7Q+BbXvKpSXHySJGnbxtUk6p14AQUWeMwDw0Qfi7zYzakhlYoXP128WhKMaVtVVmwuhheaQ0GfRZfY4KFHrBJgnou28bicWuV6sFgrCp4jXriqpPKvBuCbt/GtNn14m1joOJREqBWs4JrU3Ka9xuw4zngTGuVjxY1E0qjSOniYqHgF5wVQS+mDaLg47LkAc9FYpspnWe7JrfRVJ5Jm82N+E/HOpcFzABs5WuRRgfFEZWgseUgfjk2R3AfwnixDu5lduDzAhFQrpgvRNCdiPsXnC6DMqJLw+DlXG14bgQEi3ydfgc5xjvXuH7ACRCyO7nnBHn74IB192m5563r7yf1P2u4O5gjgp7isCiW5RjtFpcJJjKmcIa0CGrd1FQBHvcYg6aag0hhzuAyQPgL1cFaVCjvBBSf5VhrY/OfKOLLV0orPZEsbapBJlMSkVD18akWCcdikNGvp+zySb9ma8d0T3zxL60O9KrbCb5/C8V68sNKWr1lqSy6+lUTBvTZGJdSe3lZ77tGdcHv7oWMUsjU/ZiuX1+KQUVmVdWXpmvW25rI32IEH/sa2HRqxN910iY3XLKWNjlvL7ifs8L4uqGJT9viz7OAREJUqj+z8IOO/HsrRBz7/YStqXs8OUJ5981fIOwoYK0AkuyZb76Aw7GJWVEiP508oEMS3DtFOoQrKVOM81BItr5ZcYgLmX/3a12z7SxSTSdS/MKjxuTNgPAIGbmFZf6ToM8aY8boW/FSEXDK6ei8KCiGbV1EJfQJOMaBPIHyMsSEAOIKdUaVN2RAljutuxZmuIBdAAR9RvESL0brc0DTPTiNBumH9Kms5fsB+8q/3ETGvtkWL5tuFl11pX/jz/4qdD9qMIsAZhVJ/Sztda6CK6uhh5Ow4Hx4nIi25Lnva3d3juwVTqiwm8C17qUJCzFX/0mvsFHnVT72pEvS+DiUOenaybH04G6wHUGHsS1YUcO5BMdkU1Jpc/TAHCtZ8u/2OO8grmQflb8ClEXv57uN7ECM2COdeuw1qJzk+g+i9h71TfJGxXlBup6fL7CS7NNpxaK6Hvsb6M9C22zr3bbN11/4uSlDkK2i99nETQbsA6dFu5exebFgyG5s8y1pbQxLXdzKEBQS66dterttFQbePffjDPj5EWxEtWG3hzpvOq/HhAHzSjne02V/93V/bU//zlzYHqc3If4jAnBy+BavOs4XrNzEe8rbdfdf7lXj5qn0xf97FxY/RLv8RKn8mHXMBHYxrBjPdw0/gYoZqkcC5gwiBySxAOgNiZHwC7OiYwOgBQgLcpehsuohjEb2jC6VzubXX66zGDkI9cZG/NdHkCyjD3KV75DS4dXYs6cBc8lgevUwndl9BxyXDmJ7Ol9Z08xHBk3GLGxD4zx7Mo7zZRJ652QTFkgcevOo4h779LAL+Z33rdSkuyCDJ2/bkq5nJF58LMMu2ce8J2/v8s/6IWZPo1Cs3k/zJJJypVunNlAHLiN4Ucm7fqkIbVdFNccryvNQyHj4TNBenwGPcak/JPomHTtLZlKghHpWI6EJGFfEmkSxh4u1HQaPoTy3G0cHRQN78/nuMI7WLk0YUnXY6jkCoFitFzfW67B/3jQH26IvGlgyvR8aJQlD5U9n3BQmYayX2wiGpQ+LSyQlIr0Uhq0wpJrpF6joh1RhAPOha8RWuZPRn3KoGQhoHycP06LdroMezy2Xx3Qb/Sx+LKHIAiER10W6PD1oVl4jjY5gk2oueI0W0fCqlMR/jICLmYw7MH/ZFSpz72ubFNotoYL4Sh4dPI3X3qEcbr10325owqBetKLc9BfOQ3VpgR8nAH6BKoCKakyxMRfRVP5HtWXB7h2jvIl679Xcus6Pbf26disp6xHzaDrVqrk2x4Ej1G0POza1aHHxKj6KIakLSnaTryqRtDoBXxHyUKHYJ8/XKm99h+x7+vvUDoido80FUSeqputmOPJgkFZ3bmmxADC0lO2vROaNUUUjE+5qrr0T26xHrwaFUoEnJfYWK5rLgTRDZHuhnjJMAmosDIIdL0fmaaug1RNgVMW9e8ybLbXmKxWQYCUIkC3FIRXHr5NlHAWVyKBTlV2+Uk0DYyDe1NdHiW2/dx56xCuZRPjQRzVOP6/PgA0OtHt0e5R5yAFDVhQ2We9HvGAkhDnoLAQiKMuULmI+cBsAr8bQHDW+AMrrKBQVExQf3MRRroJ2Q0KycE8D5JHzzafSmXXmKKHnOsa1sO5+0Yiq4ajxMEQmUvKoVAfxVwKQOycN+nATJ97HYixIzxTWnSmdzv1C+UFXI7wFcQPGYInIvezZFkmmeIufnXm25r+wCHMOBP3nIpususeO7iHJXwH/dc9y2vdxiC8s67d0fut6+8af3WtdEEfrMOA8kn5bXLbUFAIKOI1spvDTqCbeuoAOvXDSKISQhZ88pguZBQiuOzuK55ajIjNua5VUA4j4oDtBtPE9BYyiiw5Lg1LxfvriM9wdD+UfzIQU3EkM85psHXnDGpL7EK3lcW4AnD5BTURoVSPt7pR+dY6tXzCECPmqtbSTbErWvr8+zXTs6ccQ4Rjwk5vO5a5sBOMX20KNHrK6hzq5846XI1m2zKZyENUuW2+leBQq6AYhdDsD2bzuJXntUsBSHvrQknAvd8JoNdXbdrW+zQ+3l9tTYhmTvUr0NBQTctoWN1937T0XONad4XoFtXzsYA3JqSqETaSdHBeJEYRjH6fgaVJbjOEYlKIJkO3YeSuLEAyQhjqKIogRsgTOBMYV5FWWVjVAEXYWhpFvdBFde5x1lblWice00HtYBSf31cR4lG2onxqO93Cs+kA3RaWUkAMrgFQogkl+Rh7NYhCxpc1OTNc5d7DvBFXD9T5w4ZP/16/cQ8a+wZfCy3/I7b7NP/PGX4Z0LqMa6oKiwA0S/v1AdEWjUBXTvUphRxUqP9vIcHo0G+Kp4z3QW4ZadFjAvDmUip7JIFrRSCc68oIHmja5veUFa17P1KuGQtA64zcfRNewq3BXfhZK9FjCVwywVo4baeluyYhmBNSpswtd2+yWDmNYOrbtOFdUKwbP1YH/1DApeDTHmplZcbQd7B9Bhh/ZGm86pnYVLDse7/RV2B7faukvehJOEuAMjYpg6BhUV1T5ulFhcwK5xIbrq5Thp66GyzJ9VaE889F375Ec/gZOfj53BUejpRP2KxPFTp6zlRK99/CMf83mmoN3ZVNnskX0M0s7tnR3259+425667ydWSY8LrEcVcS1hebb2kjfa4s2XCph/52ufueN3s8//tn9yv4qtUNbX9jKGXnjtR8wll1hUDJUlG7QxfqMzA3RF0ZbwojzxLf2eAZr4ZIZgw4v3V1Jk0wG2DFKKyKcLJECcwJWASkLzXq1OAMVBojxzDnWOOccoaqrdlZSc6KAogroul+dk4MBZfj6/lXgpXfas11JSYsQBA8jp4GyHIAPcGRDLUHoA1gCdZ4PTeGpgjNsBbYEFeNNpJX+n3wuZ2C7RpedKhipAfNxff+cxoqEky/hN+0P5WZefj445Uk1xoK4bzyFTMO6Gh4iSuKcYojGMmLb78pXRLfKmtqE12eQU+LI2yTWecq5ZGZqtAn5Oh+FsMuZ+rMyyG0+ia+KjCUxK30M8WwepQZ8R2JqUJjptGU5JANWs8p0X5dG2LsZ/UpJsgJ1560iuFv9SwJwojnS0A4XEToCi5qNEG3MAPIqYF4ha4JZyJgafDc2Axd7PGiS+7Pmx/pw6pdZzfy8+EuMw9UoC9HFcAHC1eYzkDL5HTN7VZvRZB+nqggDZfoo0bv2suk1+BpklzRW/vFSCAqBLkjKSxYI7mwGR0HPX2CHy2H/aXnn8MQAu3EDaqm7eCqtdugEcRhuS4HTq2BGi1nn2yRvKbO/hWrv24mrbPj3HSgDmh4mYDxExV1uIClAEbWQgAfNhlDGK4VK++y0XAzYeBfzi0Clay/O0I2tY30DSZrcAM4sjl5q3QJJo4hZLp1gOhSKmyBPC21ZJ+RHAueQDy2ifLTe9w/Y/9n3rlooHdJcBaCp19fnW3hHlqd0ZoS0iUSlauJ/kPVwNRpPkENEMIbp/9eWXWAsFlPqJQOYBuJTXVURFTo8wAu4GBogGop+u8aDzlUB3qYbTXIwSDCQRaz7vJrP9DxuQFZA7QWlrIuCMjVNsdauQlfJQx7nvMd5T4mczC9+4uLJ1q6y35VdWA3AWx3yMBblIc4BxODHcBkDKtT7oJEXMs3KoLnkX3gw15BnmH7saRBP1WDkA7snhdiJtSAQSgasFdDtYICJfMHDIhgqZw1BZisSHBUzos3lEzJmcloNyix15Ccehywoq5/no0bXxTuGPk7ylRbNpjeVRynuKiL2I2ZM4GnlDp2yKJEbi/jYFaMrpbvdiQ1Mkkk5yjVFk3rqooFlG1dC2Xc+TqAfNpguJw7mbbLRwgb34zDP0o6R1Rq0p55jd/omb7K5P/R3qLqWeFDqiwkxEvvPyq239hauts3UvQXmkTBlbwlMCj+TGEmEsobrnKNFSKEgA57kUVWo7DmBkvE0OQ22C1iLbLqAoB0+OXSERWCUG+xyQA+05bbSnNO9T4MFnoxvnqC3g808AXSCPaxNIhEqDVGPnmDU2FcFrb6DqZInt2XXUBqfKbOPKEnvwkRYPCshB1C5YTXU5CatIzB0WnSkP6gbShPCDz7kCKstkqW3btg/1lrl2dN8hqrYW2X3fP0hUP5wCrT2l5VCqqD4q+7cEZZliPjtx3jvtkC1226docpZXFcHZZFXcbkdynUsN6ql8wVR0OuygnONiHqoWff0aSqGXUJL99ttvpzR9vyuy1M2imJSbWinWsNtx5LDvApdXlNMHJPsR6XWpPebHBJTJWkBeIcBcfaaAlyeHqlaBkoXl7LltQoAGcO+WlP6JOhpRv6BQcoVE1Zua5uDEzKKCZL1zqlVfQkXfXFKRn/sP7rNN6xfbH9/1OZylElu2bInd8vab7bN/eY/t27Z3JliVrYmx1qavmV/O/jucF18f1WApGOZHqK1U4bOEXBB9FjtpA+iYVy0Meyxg7mtaAuW+LqWvZPfTQMJWsUZe8B6Dh2e276eMPUW+w1HSdaZ5v5g8lA0b1loZDodoKX5PafciHAjGM20lB2IQepD04odxdMoB1NVNC+1k81VWuOYimxhosYFDL9sCwD37SQDzvXb85cdI8MThkln0wIyciOTEECCYd8GN6JEvJ2+5yNYtbCSBfNReeOxH9rEPfZQaA9hqKfOw89xHiWXprG/bddDu/MBHoQFKj+vXgXkG0n33hvs9zTrxX772p/bcD38GMGdHlcBDiBBowcyzTVe/3eZtvJDCZ7l3fv0zt/+3M4342/2N+0X5wt7A98vM+10ZMH/t6phvue624hIqfwrcONII8OLGcAZ5BBD0ieQgJGbRGQAzA3sDDM9MoADKMwFldXjsQSaAeQbOz5xQn/dJGANUYNOjqQA4nceLDQUacrAYZeR1GVnrAD46f2DnuEN/Fn3CMW04CBmIchCnbfUUIfVjdKwAVPoZPPP0xOlh3InQo+j4BMyya2kLWm+45+nRaMAAEWCdQ5U/VeTDJ7xHgP1G3UTpHntPtVrLy1vPePiOdnNt2cYtRK3OVP5M3RFP5oaJawmEc9fDVAgUEMlnS9JVTgTMMVJ5kmrUfXFU69YnrITttGIv5axoRSwO/pzalXCQGJFfSQ261i3HCMDLiCtCr0VJS0nIZAWtRnHIXJJnipBYGB8im19UCkVK/eyTdgIu3NKLrpTV8z6eILKVq8RULQlyZrhXvSUqyzSgopgIUT7lxQXkfRmTrfR+iXtVH2WUoV/z+/x6icpEpHNKi2UaCcFUVdtHZ8ewTzFwXcIPjFdjuCeA7Q6AvkLvZcZJ0nG+gxRP6dQ8/TZzbo7WVHD6RsyHSKJPi46SbBSJVQRJVR3Rtx4n4ejonh3QHcapVF5HAJQiNHVzfTekGJWWrrYDtOuU3XUNGHRXiV35pmX2QncFFfIWWsuubR5B8fgN1xIw74P60QSVRZHmAgzwu992ue3a+nMb1jWdIjQJWIPuUqN8CDLwAcQIBCCHqMTQyGeYpGiO+iqX81WiHT1KQukw1IVxAAvQ0S558y2297F7vSBNMVG3E6cHrbaeQjsntQgITKnbRbkCjInSQEOI5lnEuM0BvI1y/hIA29WXbwZsPAPAV1VSzXHx5MMZlGMkXrr8kxwi5horZcUk61VoW5yII+3avOH1NnL451TX1A73JIVwiB5zwU4S/MZcv5nkYqJwQ7RJQ3WR1cBPKMwpB5gvsc6WJ+BaS8Ggxrn1igxOsUU+OUFhFkDyKM9bLu47IDVvM5zMA89aodQtSOhU/SVJFE4D4lUFMQeec7HUWmpXuqLK9PBR8DdUFMn+KfrL9nuOkjNL5+EEMMdI8J1seYmoZ4+VVMzzMahdLU/gIrJZrDybOats8sRBqC1E9DU44bdP9rfZFA6A5Bqn8ysohNLq0m37WshF6FRlRzDLKJE+2t1rxvi8mbTGVZfx/0p7+ZnnHAwXAtoK+lvtXW9rtK/+/UtcnQqq6DFP0jcqNa9v9GRs40UbrP3YXsbJqK2mwufeQz3+nhLR8hgfG1bjJO6EQ868q4QaVcr3iZNKuA0QWKBAjwamFGmkmS/lJgek4WhpzXAFp2RX9GuMAznbkbytPAfZIwUSFL3OJQl2aqrYFi6ssI2XLLcmqpje948/Qld+jFyCMRwlUbpiyroOO05ANTstSgiur8O+MP6l8jJ7EUCK+5q/fL71nT5tx45RfZgqtKLBHDhA+3K9AmzqOG2lQEVjdY7nPAxDv5lz25dtoGShA1tXhHE6QtgDpwtqHZOtF1Z0tyMAuhzWIiLWksib21DJN0mGDq6jgq5kg//2H//WvvYXX2f+Qh3BgSuGhjLNmFYRG/HEFy6YzxhmljJ2ZW+D5ojjQisx9Lx9peBRyDjrhu6gXQ5ddwDnQrlJqkobjSPevgrPUMK9stpq6+ptHuoiqlqZFarz5YZjpeAygI0/3XnaDuzfSzCgw/7oDz5in/i9T7iM4MKFc+3aa6+zf7r3B/bso08mw+0GeyZodWYHNAX03OAqt0A5PSnilux2FgAJ757gFmXsCe8nIML9d1EBt3qJrxVerGCGxqIgkp8kFnZfe9Qf/CTB3JpQ4LsAlsQRcrse+ZInSsseBZbhUEk0c71ZDU3IVKJEQ+R6mPk1gCMjbfgRlE0kWzkhDXUcXNlSfWnnoaxunu8qTk+z9lKNdtaWt5GTQRXgE7usuAvlqWM77Si0xBp2+kIYQU5IrFS6zQKA+ZJr76Dwz3wcyCJbM6/B6soG7fjuZ+zDH/44VXBPQkUcQ5a2lvmIYMDeV2w7RYY++L47UWSRQlMEOH/z6wwwP22f+9Mv2s5fEJBge0S7kr6Bo/vguc/dcpPN37CRIMnY+q/f9cEd/+5Ev6UXuB8ZxMv5fop+OfKaj5hfDDAvyC28x+2kQg9apGMEz4DRGSqIGxYBi4hW6MAzmDTAcnwFqEkh6JkzOWCZATfx2TMTJn3GDbIifVKPCLlEnxzyYqWh7AWG4v48YiZAJYPu/zSZdVm9NnMXDrqVa+YgWQPe4y6xyDsg5nxSFXFJ9QyQ6aIpspdFp50bl4H9eJj0ECnamsCayz2KGqIRruP5TxFg3XYeC6pX8pJslV9b8Ckmgr56Oo5Yy45tPrldr93fzIHKcg3BARJxtICl3nHumJ5Hhl+AWOErfh9hK0zRFBUYUsKj+NweUcfrD79i2lq2vWC1JOf4LNR3rNYBeFMkLuPLa5EpIuqoYglTROhKSFBSdUM9vqK5U4CHUEIRh76cRYNqiER8xwiBjhI5rKoEWKKlOk5YrRUu6+JNV8TCpUvyfqgX0IaiA8pJ4FzjrizDljnAIC+PRLfkGMy0v/e5DFkCz2n0Bd1GjyMEn/IidEzGrXMon4C1Ox06j1CjpzOnDRctmslpckJO9KHO6kOWa+QmtRX1sVcHFGVA72krFoOdRwQ1l90R8eLVf9oqlp68Ilsx5qUnzhUFyrWg4oTksJ0qBZppuPWKdFKInEgmqhz83t3e6RHGOpwpPVr3iVeskIjsZ9+2wI7vz7VLb1hiz52ssFJFzHe9RPSEBMBklKPkPUCshmx8gGUeAPOdb73Y9m19nMqLIaeo5MhTp6B11BAV5thSCg1p4o3KmdBCKe47wFlfRaiylAMiFI0eUcVOgrooattFN95iB5/4vnW5ZvwENAgU+uqU/CnevJyTcIlcZzn1XS/AXIBJDczjkdhodtXF59vhlq1eICgPsO0TU5F9Fi/diwr/DcCZ97wkzqnkzlIKEBWS5FrGRJ93zo02eehR6wX0TQI46pAMkycwQNLsiChktIuKAI2zeyDN4CoK9YiFPjKLoh8tT9NXLKLQQlThtQDZQY158bW72PFRGqk0t0tIvpw6n4j5wa2eCFgkuUMNOagPk0jzjbC4j9N+VVKvqFtBpEz0gtPYr3KPcis/AMTv/PxJIuaS5iusbbYJFuqJiR62suf5rpuSRCcEmGnfPJ5hCo324VO7PLF3FDB8iqS7lmM4DGOlThnqHSZnQM/Gzq90krPkbSnaqG0ldenzAwC9cuNVJH/2WUPPC9ZJpcOpvkGKn7TaOWvG7RePddIOjGvNb7jdxXDxlaQtfr6+1sHj7u5pYayzkOORiPAUJixEATTul5/bYL3HegDOJdbaInUZJwa5odHY1HzTfGJWxByiP8XLFqjUtYIVqbyiFIAJi+GReo+n0/c53FstlWKlq65xVVIiDf0C16xX9dU8xswwjqOMPCSPNN9FqwtanCLvblGJ0Evasq4CR5jiMnn5I6hwzLL6ynzbT+XKjtZBlGVQt9F15cQwl6UzTezDaTxrNzXZ/o13S9eSe5bkqwZDCgZgKAPsxLcDdZldrRPqFxw9gS6dr9x1ows86VPfxTgP2mGqg6L0wMM/tT/4/T/05NgGKoDKYasgGXGExL4K1oZy0V9YwwexQUVu2yKKqwq6o+yOlhBFl/Sd5A+1LCF/B3876BY17LTU1zdY06xGiidVY+OxJQRF8maqRodz0Y9tO0HC4cmODmxMt0eHvQw9Y7UGRZkPf/SD9vHfo+w7tMmFcMw3nbfBXjl20n74L/dHBDqtsBldIntN7SBqkt5X0Gcoj50l1hL/8i3zzAZnoEGJDsIrSgDlfeykdZAjUUvVdr3uwDw1ulNa0nmUIOF1UPiMEqZXIfQxl7o1Avok3Nu9H6AugShgtIsnmSpokgJUAuj+DCkxUmPed5MVsACnZJ2s1YNjJaE6jqM8lctziIlBrQHK01rR6ottyTkbbHVRl+186Ft2+KkfA8z17FnRvTPAXJS65a/7sFU3N7MrVIT6VoPVA8w7D79ot777dhJNj0LfQo2J9WaAdb+N4k5PPLvNbn/PB3EAqIXg8/LfA3M1q14/1XXa/ugLf2KTFMY6d9NGxoeAuZwurWfMp+p6cEPRwJ9/+g44Q6/eF/e6jquv5/sBMED3ax6Yr1977m2TYyP3CNSWkfxRXM5WKJQHRUs84pe8xqAAaJwmXpXGeQZSAwn54I8IcvpDL/ikcrTtQCnzQh3sxMEBsLL3ZfhS8oEmr7Y9XetX0k66iMCyEr50nN+DjLkiJopGJmciGSVN8jOuQgB/MUO8gJAmrQNr3QZPlwCdR22y8eeINyKp/pqDfj1ruvfsZ+akpPGvcykCmqyKX2sCbWMBe3nR2vZTVCUaLfuKduhpP2KHdr6covtB5dGFV118LX0DWPAbjpvxO1Obi2bBNQswUlr8RvGcdQ/5GJs8QDZLlLePkne8eBMLy/EdW615+SpPuHQGh7sJYRgF5L2ddA2BUL+gdjBShNrbQW2jD8qiinwc0YVIsQwspf7T1pjAgHi5Ai+tu7bbovMvdydJH5igbLgiMVrMp3QvzjWUnSXZh+1IAfN8EvGUcSZTEfSk6A8HHf7sM+5U6rtIgPI/HHjH0V7N1aPWel3gWk2ZRetkwNLz6LVsV8XHRZCZwhlVQg1VNLUgOFilkIRrxCs6FtfxFuBU2uJVuygiqGtr/cjNtik5cpJEJlXPVFWfPugBNdBV5Ez5DoCquXEmActRsh37KNohxZYJlUDn/MO9HUTuJu3cVfNsFZG+q7c027O9LKgOzLf5tqZvtapAUSGqGEMF8BqJmAOs8nBy3/6m86GyPGGDTisQwJm2k6dJZiPC3Y+euT7jSUup/dTFMtaikhXAIa8sAwAORDKlaJ/lgIUrbnqrbX/0PuuV08VjDfbjSDTkWYdTWRTdVIKbFAZU3B0lFs7ZRZEZVeacApUPA/C0/X7ZJefZoUMvcG6xPhiXoMpChVCJpkvqEVlgokNKCteOGpKHVfqcJPSKKJQzbnPPeR3RryetUxFmzlurhEj43N20t2yY66Fz06JozEZ/uzxXUncAUKpG5sLxnmQxLGTeuWa2xg02b3wSfWYUKaSnrylZNw0QpyjI5IHnoqy7HDEeegJ1j7xhqi4C4osACBXS9atZAq0EHvgkeSZQWaS0YhMkIjIWCuHMni7x9wAAIABJREFUS2pxijE+SfGh0VOvUCFRvHgWdLbnu3Fcx3n+ISK+fcNj0Gyqbc/BXjTSC1HIyLEu+hVRDFpCTl/YJg27YEVlOzzB4VfUWeNX71ch8TZnFbrtFBEq7d9jSy5cZEd2HbeXdrXYxtXQH3IG7acvdjLWxfvlVIwTATvtNojHXMx83rwc6TgihDt7iR5K4lrOKmNdc1kzoaqWREvGiAI+Q2o7AVW1qfeBjo+ke7etej3pa+uu5QiG/VYQQ2IDWiv0oWR++VC+nDXG0yRqPdrFQf7ZZQabF5WQKEnhJ/ULSjnSytc/36LnpyQfBZx5mjB07mRTVp3xVUrwYm4tASGk79pPD9jajfNs/GS3vbxvgPmBK6FG1n88gCL1I+wm1UGHmpqFU3X1f45EXT2/B7hCzjULFuh5QpUlMKPuZyYZVM8v/jZ0BT1DDbSgan5Kx7wEp6hRu6Wc8Y6PfMAefehR6CzNVAFFTrG83CPm4n431FWFehKAcpLxLN0vz8sQl52xpuCAtMYVLa9DAaQevnlt/Syi4rMA9pUeJVeFV1XIFd9ftnuUYEwfu5dtJ05QW6DF+oiOe/E7PYRMrAc8pCufa80N1fau/+3d9vGP/T7PAVd/9Up75zvead97Zq99996f+boe0FOJ8Og4OZUn7XxmAQstQR7xoTPBIf6ljySsMLP26jWoIl6tFsfG4G4btBCrJ/rNrmNsW8qe8+35aarBQFuiL75wQY11qnbA2muhkVVaLxTYPvJhfKA/Tf2cF/8Hc5Rxq/WGANe4pCN55gC4aZH3NSLWRz2PHBnPq+I6qnKqvukiOXOSpPDpqsVQblBUk1pMGeCcqsLzVq6xO9+6wf7b3f/JOh6736pwtD3YE36vAxvfuWUnbtX1HyLHaA7OTr6tnIezWD5oR1940N5y8/voJwJfoiohZSnM0QIwf+jRp+yWm261JUvQ4te//ydgTn9+/E8+Y1XTs2wjFEJJJbrikO/ixlgdm5z8wd13fUAyL6/aF8+gaDmRRPsu7QzkmZ6+lT/a+OPRV+2u/r+5cKCGQINCe0JA+etXr70Nj/CeAhkUDGMFHpL0NqcEiDWxM4ydAR0NTecCJ2DoE0egXSAxAzbxIV8W0nFBhckGXZhcf9uPSufTSz7hA6hrMogjrU86iJEh8GhMcKfCMqTPOyhX5EXVLRMPMc2jDFAJuDvocQ8jbZ3qTjUDIqgyE1GOJSMmoeMtt8da1FKENt17HJA9TywgbowxbJEQEs85pvLY/FqA4c8T/9DltDJ2e7SL5mRv22E4wgBzrRcyWw7M823dFejqelu45fL/soh5xk1W9EDcQQFz3YTrmNKvlGbyMu/5bugCfrfvetGa1iArhhFTMqaAYwZSk63xtg5grn5JwycprHi9HqcjBHhz1ZTMuUljxTdrfdtQbSJN1Ek78tyztvyiy/iwwBtQm0I6kt3yrUsHfmoXIj1Qf3JVPIGojYpY+PmjGxKFKY0xdd1Z/RwtGn0Q0TBdJ8B5Zt9j2ARcz7irDgB8HIdzESeIhTygQ3AuhQ0UEc8VxYooiTuhHOtRYP0egzRigd5k6bqxTKsn6NMYvb6jQlLwAKCtBKNdRNRLkV0lyWqsjXnEh2NxULqOHfXo1SiL8ChjS4Ck0Aasec48SkYP2MWrq2x33iKraFxgB/dst34SgTT+1CcqzjNA2bk5NcMk5HFvOBPvuvFc27njSZKHCkMLnFtvawOYE0TqhcNdBk3Eo6DuJGuLU0V5+JvnKYTLXUWSXT/yiuM0mKgs5TzTFW+40XY8/mMj1ZDzcU0qidYSgT8JnWIMXomrm3HfBH6I2sXY6OuZAhRIt14Jo2qvabv83JXQMA65fJ4KB42KhqCqpcpn4KBBzjuiwkRpngt3K+pfAogv47Vla660ibZnrEvcTz5bAVdXdJReL10pMJQHMI/y2fNJnC0gylkwzU3VzLHh9pcAOcwz6C0Fimh7KI/kMxbq3kHQp7acmVNl5ErUrL7Jcjq2cwzOmZZxDZuRDuugbPugio/wfEq6Ky6da0XDx2yQvpAG8qgq7hHBnBKNg74txLHK1VzlHnqgBozKIeVZlDymyqhDgL9hnneoHy43BX+Onc6H5kNEXDk19Ifry2vcyvH3YIP+DrWnsGDJvsoGyLYyvhoAKLMXrrCjewFbJ0/Z5ZvL7eWXegCfh20JCjfXX19q3/yXI+wsIJUmB09n8XEOgMWRkELTBSRtLobz/OBBdmL8PggBoDSjcLArfwjEajfMP8x804Ze6mNJY4bV1I6RCkMpd0U/NebSt4Ny2tsxlpw5OR+SB4zZLAperpL9JQuZRcvBcxVVBZSFZ5fDi5upYqwCMXFtp2R5RJ75w2d1F6o8q/fKkBpS4SpRoGQXVy6ttIuuXW8dh7vsqV/ssfYudvc0tp2aJyMvjjsa+ii1HKraaLOpBJonmyCb7bZAz66Hj9CG0wd+E5g7aI5j1HUOzJOOuVRZKvi7BGe9HqnCQhyjf/m379un/+CTOFZ1OD7iepd6/QpV29RYk7KLbKiAchF/N8IJr+G4KnaNStHcrkdfvGl2k+8I9jPWpE8tXXMpswiMdfUNWCuFcI4dP0aBsNMeER+RTr7EA7ROePKl+iNsnRwcvV6KA7Fm6UJ77+3vtccf+bkDjCuufh2VauvtE3/1z/bDh56bAYgCf8W00wDn0thyUYAUjAt8ntb2NHrT4psW4hg1GgOTJOX6lzw9tPqtYx/AnMCqFwfTV7Zwx/yAaG9rL7rI7v+z99pnn+63fT0kN+PVHu+Vag22QV4Silf2yoOWu/snVsiOkBRotGc61tdJUISxfdZXFpjUzlYd8odXXnopQFyjFErU3Fn2re99z3o7SfhccoPZ0ktY/AkwqcAgidylUE8+8bpl9k9//QXreuJ+EvOrg7LGuUSfkyPs45vdvHnnXWfVJCiXsT2zkgJdjVVj1r3nUdty/c30I/aD+VhKLpYcva27dtqO7bvsxhtutnXrlsbs/18Acx+LzNEOxs3HP/MpaypbZGs3n+8tLgqU5ojygoI7P/Ghv7zrg3/3aw//W/6D+32TW5GcnB97z77Wgfnmi6+8ja3ZeyRDNIV3XFwDV9E50AKgYtEJtMmYJ6zi+DrApv9PfwcHJICL/tTE1QRLx0ag8QwNxF9PHw3JwwTs02ljQdG/VPlTxkxbU0rQE6j1rSh1TooIJaDlAe7kwcclsuhtirH6PaUb9etHxFlG1JkYDszdhPpzzJCEzxrcM7sE/rHUKDPtkWLgiUKgge3n4TnGoGbos2jG+2KV65XhdA4B2qw54YO2HUKia7vfj7ZbfcHF0Ky94nVu9NORsdipX/jphl0gTMmdCZgLUKk0sDTAlV2v9wVwHZjw+4ndW23O6vMABJLzih0HjxwlJ8VvW2NAuFOLaebJZzsT4gYJNwoMRKCdP2Lr1iMHelPANkXF9IZ2PY5DoVl4/iW0cOj7TkAWzpMSAMfJ6Av0aLEepcCQJ7BicBT518Kr5Emn5fi1YmGPa8Q2q6unZMPTG8i9G19Mw7vSOIzPZL/r5WCcK5aTBnB2kmjimePV2ALVE0T/5CTJERL/U+PfeaW6RwERLVY6VgCbc/nuDlE9ByO+DR9KQ35uGtefhP9JWWEScOPOn2hWgEGBd22rDnb3esRTFBXFErUYF0/3Wz2VGtcUDthFq4vsSNFqdmfn2UHJJSpa4/r20jGWXGIukcARfqrRx+xd1y63HfsBlUoQZjFxYN6OcgvUk37ktgqhBKhNlGzpGES0EH/UiJjXUOa+n2io/haNoBhwuuUNr7PdTz5kfYwDTdF+ouH1s/JI/pTWrxxD9QXjEO1rvEVf8HpRWKmkuucklBhx2UV5uXBljR1CXWCKOcJOvVctLZREHm0mbvrIEDx4gGoABIA3ny8pUoVDcdTR0V66iQRJCp3wnAPQbWZJP5vEzx6i5x4xFYjkYcbRdp9fX2kVAPExFRcpm2UnUSupJPyez+KZxzPl8voQgL5fEmj98EgVvZV+M/Nm3vwLidodx3GQKxIqIacp8NFDYaFheKWKjlbTTgPcbx7Oz/g4fVairWKkGrm2KqZO8GxlCMxPMi76UaiZRC1mlLYqgi4zRLsODJJkKOoqW+ESFBmfoNolfOZxzU3VE1DfaEfMw2th0zSe4g+1kXpRIe+oISB7roabu2ylJxEeeGG7Nef22aF+USaIvg8cto++bx3Um+P2/e/ttB4i5gMk4comO+mDcamKgJLSU4QXiG6jLpgg2kUJgB91mPx+EkT3z+z2heRqmq4zczVsh89fX1yCYRAY4kzwRHQiXTPyQQIQK1fFgSGAzH934ItDSxsXqxAVKkGi4Xjggrk5gTMXFV9lK4MOFcA+FIFU7MyBseYd7wujVROJvvCSGhRIKmiLSXvkwUOAOIFS3WsAwwJXAONa3NtzzdfYxte904MfsgFxrxkgj3VqRsPcHY8wqZlcYjSPKu+miDnR8tqqUgfqkkys0242AL39VLttufIq1mqoaUj4KfdnybLljGXyOagMXYdnXYOsbnVtHQ60itkB0hmr0ifXsZXQXYbhQ3f29tsg/GjxzruwKV3IEba3HQPgn3JJRa847cmT0R9O2aPPvZ4IjqDUVNw0enCJHTboN5ds3GAf/NAHqFwLjY7PqvDOkdO99o5PfwOgH8no0b0KcEXQxxVp3MCETc6uN4PJ0/H+egoS+LqkAI6ANE5DDGkMyimoLJUCo5FrNXMOvc8OlC3YaLnnXmt1zdV2mkDFtJJCYrmPc+s4MQL0PXiKRNCHrawL2hhFxEagmHqizFlfZ4D5lJ277nx7z/vfD5Mp3xbNriPAWWFf/Ou77YkHHrfRSug1b/g890bEXNs6RLdn0w91eSRh/+RuGyL58zy453iy2Ad09qG7KtCjZGDRuDzBluEu6tGK5jprZkena8/P7fLX3cyOSVlQTySLyIP88rnnra31uF17xZts8+YNHhCLJoz2zaL8Q2jXD2FYBgmM/f5dn7JFDattxXnnBENCVtp3u1PkfCpnzlc//X4qN706X9y7ekZSiS3c/xP+HK91YH7+xotvo3Pv8QpgMiiA8gDhkpYLHrAD618fkj65ZjaiUsRcI3smqumGMIHxQDfe4V64J4ueZ0bYBwMDKEWXNUl8CivRUFUk9Je2oxyERSVQfbkAiz6bIpWh4KforQ/FGTDmdJQsQspzuVFI8zDjvAeVJd29Lxa6QBjhiEB5o8wMbv/TJ7LeC6PqQVYPzcS3R0T9HIAOIqNewQvD7TQWZcR7e8Q9Oy+d050msasFuofuxIX23EEqsHVX3uAA1tvFF5YzEXNF9dSCeaIg0WZjROy0UKmwhIBuRtXJ8e122ZdJa0OiaQ4apVoNoyKouJ2RWKUvn84e7eZ1FjY5Z9pSzvEqOLyVIl+KlHlRHAfFAp7RsB5r1meI6okLqjNOs+196KVfsW2+xSPHMqwTLCgFbHW7MeDeFeHXhqcqpeZiCPOpZChg7sgxG4yOxFO/uEqKrhnVCIOOnO1qqP3VlxGF9yHhV1ITxm9Zr0c/hOqCj7fU9n7J8EACAAnoUKxFtCA5HwOdp3whFlhTgpAW5qApxda0FrNsK97bSk/uEb8Yu9mOkV5QCWwtOPlenVVAnjti3E+zUA6TsDVFhLdPUngC/URPSnL7qaA+z87PH7bz11Xb7ly2OxsB5rteJlKDQoF34gRgRcopcGgFzLWOse7cfFmt7Wo5CoUiivfIgWpvZ7FvzHM5wkI45r5eaZ3iPB49UUibZxVnvbYq39VRFIRWEE3a6FtuuJaqtb8gMhxrXB/v1yGX2HEytkUVLXe4wpuxhc8xyNKJiiJd8qirmWvnzMm3Y2iOq09Zo9wpEMc6B9A96vKMiqILkOkQovfk66PQx/sUPmKOLJm/mJLzVLYEWCv5rwFawDQ82C6QrSdochcClyNw6RfVA36weWMUs5ooqiaZ6rSD+1oAUQ+f0XgYlgwdz94PNUeKOho3inKvaGoE7PcCqBWdVTtQtIW26+8jGXCIqDxHFjAmRgEBuajKTAAYFfOQYMQg+u+K5Op5vaomb4wAxBV7H/OxHVxbBcM1Bz366wnj4eyqc+RguKPhsDMb88KrPpt8fCk66Q6zVEz4jN4TXFx+7vkAgBI7+eTjtrJh0F7urbEFs9nBYGfmnR+7wYYPPGU/+9kua+vLY6dB0oY6l8YOjphyIxTNQ0ZRpMIwRoxdbkvJ5LNmL7HS8R12CiWWGcdO82sy8oMc5CUbka0r2nnT80iiU8+qoIRrciv/QbbZ5zl9noIBUSHRTzpjGsQnLyIRWJ0hB8fPmYI3TJ2glCjXIcmmOvWHMaNrsiniYFROtPj4Ku4D3Rp1DRxHjtnfSsE27ewxL1XxU5fWjoCPwbJq+3nFpXb169+KXUBKT7Up0nqgRsmiwFkQxXXLfwOY+1rJuRS5VqS8jjB8jUfMFQ0t5HeirIxJtd3tH/2QPfLAw9Y8fxH5QPl27obz7aJLLwG4RwBDu6xO1WGi+rrO8/Sz2yM6SsfJ09iQThvo64UJEpFwUTVmdpXTGpdViYxIdqxn0Q9hEbMdcwUfVFVSKiTnrFlpb3zj9b5Te96GcyjOM25f/Nb/tO99+wfMv8hZiXPpHOmnG+Oz/o4/zjo2Oy4D2npfk5hxVw4txDlRGCDpmA8ApkvmyfLGOXScvL26RWbLLzeD5sc2AoNUQRUtYvqOuZat2TGx9K0IOuftP26256dogdxnuTq/z6d0dj5XgvMzgn0oxCn91Kf+xOYuQvKUcdracdKe2bbTXjjYZafL4bBTdZetHDw+8l0IkJUiBTzZtt/q9t5vfXueto1XvRNJRHY/JA7hgg3Rxq5j7rcJaKc/l8+ps3kNyDHuecSueuN7rHkuu3xqf/H96c8HH3/S2o+fAJjfaFds4ZrpZjNgLjveR99v27Xb9h04atdffQUc80/bAhSplq5f6ytgQBhRNj1ivvtPP/l+HuDV++JeVO3ter530CbbvWcTMH/NqrJcvOX62wpKSu4JVJki0A4UY7z+GihPcyIscUymLGotI+fc5GxKqHPPGvMplhwGIPvyORfg3cGPG+MY9Yr45siAS8hYhhOlCi1MHoUU2Ilp5+DRwaoAZjiHAZRn7lW/x3MF/JcxjUimXvTbST8DqMVnfUHQuZzCEUy49Gt8xhe/LDZ11on0lrhZKVrpV+Nt6ZjL+3Wet5CNtmV173r25Djo1Y7WPXbslVci1uLXkZZpkW244vW+lZ9MW3r6ZCRkRzg2n4jKFNvfAuZqjHwMtegPYVAjs1yLzziR6BO7AOZrNrkB9+d0ykzsUsRzCeimyJRAmY+PALleBMjVIqLtnK6ivtJWXOrLM72shUITXdrR49ay/Ve28Lwrow21jSuQK3kut4VyxMTdZodhBLUJrq8onKhVmYqNLwjuFGQX99Hi5/OXfWnVEynaE2ozIe+ofojF3UeCg3e3QL7LInjjY1RgwItaxdmU1Bq7OnqdNpKUIfkCSvaRMzXS1w5YFIhUtFdKDQr7cSa9r4Q+kIS2xRU1lG8hYD+CURbvVlQMAc6CYvidbDdLFk9OWIxoRWsFMDDg7GSN9ncTJYNOgVKEyi+rIEhJLtrRKCaszu2yTUtz7FDpeiufNccO7nyJ4hPdDsb0XApQSy5xdg0l6j0qO2VvvajY9rZ3+A6UIuZyVts6kPKuV9EfeJJsrghFOc9Q/QQqU6Ji0EdIFoPyOkRhIoFmRbGHOe815y6w3W0HHcRp3esjYl5VX0DyZwClIji5anenLajiJWOmfzDXKgHmgwNyYmLrtLE2eMCqWSCNcrV9rhZKxr8i5eOQz8cll0gfF0C5EQPI1UaI5GuLfO38+ainQctgsR5hd6NCEWmuNSyJxDSXVYFyXBKS9SVWBfAa4ZmnARSd7AKUqEAS3+LaqjMlFTgKsBjqU1Jl2IwCEk0bG8u8EMoQEXHRSQbxSPoGptHALnAOvGD9OGNGHHBPPhQ2QRZxNNEZ5LROyklL24uxQ6nBk3IaHHILjAeNK7Odbp/4J2dZMQqPDaTJ6BVVtcshEMv7U8qp8M8GWA+HP8c2XHKF6yV3vbDN5jIu2sawMau43smjtuVDn7GBn33ZnnnlmLX15uPcFNpp+lcqNZp7ozgQRdJM97kW6iS0LuNIBWgAD/WjtmnDInvoxQNQdqDk8JxyWsTtF1BOsYyIrDhCjYTv4JMLhGgtSJH/tB4IHzoVTHZZNlHPl3YsI8Ch97gjFaLingoS3UVBG/X9+FiyMdLCpk80w5XEK4fCW1P2IJB67EC6R6RKmNrBoPgRbSrtdpkCRYw1BmTvXKtqzRZ7aqDBtlz3Zua8irqp/ZUUz2rjhi7WiYiOxxjXY+mZ5CB6z2jHk3sVCK8ml6i2uswrpZbD+xLPXJHuSqKjsuU//NlP7OMf/j2i4g1WRlEaaV6//o03wRmv93ZQFLwbCko78/vY8eNIZTLP/YLMKVl2UUFF88LeKoqua2eOgVMX1QcqHiRKktbhtDJ4fILfx1SsiiDLINHqHgIACgbpuCZ2S9asWGofu/ODXixn59EOu/WOT9qEMrzPjoinPvVGSSvzmd813dPa52/HuhOLVPZTTcqYISfDI+HyqtSPKj6ULy6+2p+7VjWo5rWIhpMzKFlFUTmV8yFMoR1PJf0op0l5L8L5GEqna/HZGoIZpVCcZKOOY+f6j+42e+afLHff41TTHXYlmyJx8mX/aFfZgYpGQHk1XPLyBijli6lcXG1jZc14W9j2Krw8ZFnxapW57vz4mol2q+t4zNp3/Mo2Xv0OK62WYpN2Y4Ie5JWoHZzL7qrgU54tA5gvaSYnaf8jtv7yd9iC+c3ubPf0omOOc/TTx56w4y3H7XVbbrRrr7nY1z5VXe6iEvQICmh7Dx60p59+2nbu2kNC8Sz70hc+a3/yF1+0yrzZtmjNKm83zdGgssiuTX3lTz/1/s9F/7w6X/TJEq68me/HaY9W3cV/HGAuQOUANv75BBaASc5kwNp4Pf6Xfsnm0MxxMkIp+c4nyNloWQdlk9EbN6gT/lqcL4B5JP8IsGYRcxJUfaD6FloC9758aRGLAJJ/fmbx0me1eOkdfzZNutDj1pfvXGXPISAfKDiu795qgLZ47jg2nl8GPH0w3ffMzkB6Nn8uGTtFwvigJu4EVBZ5v4qYi1MtSOZSWP7PH9kNQvuRXXZ8H8DcvaLoAxUYWbOFSIR/LotaZM8cFfhkGLV1OUGUYhwFGD1rkdNmtAQJnokPmTjmGNLj+3fY3JUYrKQgIEB9xiBq8QM4Chh696mxIkquXRV3blK/ZxFopzsJlmY7DOJvElmKwjzxJZWV1peft/mbLvFn9WQgjKlHdfwAJaixIDBmRHGRhncphjdHRTBcIUfgTbzNAM1x4gSaFcn0nYRwMOL1eC2SuzLed9xNFAoKsOJJoeEKJYc0+j/OF1+ZU+fJs/AZtbegZCktCgIdsaDFroEWZvEEXYvfAUeswq7Jq61gkjnH4DxrakwMdvkCXjl7qRXXNqY+itixylC7U4E27SDJnBPwH3s6iITTj2VwS/Nyh4iYLLAVOf22btGEtVVssOrGAOZ9AuaiAUhBQoCWxaWhbpL1IEDxleeMW0cX96BEah1Hs51Ex3wWsQlJEQp4hjMV41hNPqbqnQ6mcl1WcQSZuHHxnLlXccWlF93WhaKML255HmFmR92TSicnUbCguaKdACggXEVGh0bJa4GK0gd9Rvm0orI0QqcZS3J0hUSaHcj7GiqONY6NKm+rsB/3JQeiuiqNR0CZ+KqLmqoBZqjCAMwHAc21KF5IL3wIKoKuL8ylaJAAfk0NYJJH6EY1pYhnHoJiIlAugSp9VtFVJcSNENHv7ZQjLYQopwuN9kbAN6okg0P5rnrTN5APPx/+N05DP0BwRPrvCiRkdoNx4TKBmkvh3SfMFjsnmusOnDU3/K1kq2gvZfx4dI/LJw0jHxue1KjILYuo2ijMaUQ5BfTzpOzizrKocRrTOHUkNq45/2KkIQ9a9/E2dgyk+oLM4fIRa8httcUf+6lNPPZXtv/Fh+zwsVY7OVBgx7rhBHuEn76RAopmDoDa4bTby3HXd68DRL5lA8o4t3zYfvYX99gh2mOCh1FFUAfm7pwki5AMsMysxkusB5quKjTm2SFu8zVRnNLl/xRDEAhPvHTZJA1JjikASBUiq8kVE4sHx4ffxwbkLOMcaH0Th1c0DT+/OPMh5RlOu0BRVJ/M43ivNq3r6dvVomTDgm+v9vX1h3sevvqjtu3AcagFNznFzXeaPXCg5FMdraJEotAEOBfY00k8GJFe83nBZ0oSMK8DlNdAZakkYi5gLjpLjdSF+Go51mI3veUt7MwMW9O8BX7u0vJKX1tcU1tbWLqAR3fDiaC6dzgKemZXwdIaK3GFCNwIpEfhorSjmJ4xMDRzHeDZ29vtVDopbZUAbitQ2lJpd+VH5PM9xa7Z55BLXLhilfUxt/7L33zLHkSNxRfbXwPjcXv+v8zAZovEzGqRHRPTZObzmZHWQKFSrlXyLWOgHXVoXmRzRtsDjm3W8lBekbqLc7t5TzvwMhoC59AB86lcq5/XzCm2T2yusB3IerYTJKjFFsixPc1p/+3UuB0+wVYjDk7uI1+1qoO/tNmNKI9hSFpO9bLTVuXFwXLrCAio8mgNYBxpW4wxXc911R2i4qoyqJdQVoR/3OYXd1l5yy+QR37GNl7zLoA5Eqz0TSz9AdCjEqjGH5Ka/L4UYL4GSc/eI49Z7dzNJLI2M+7B+oP9vrv68K+etiMHW+yGq95sF196HrSi0/byrh324EMPW9vhVutoP8l4giojvvriVfaZz37cPvGf7rLlTeutaemi2ElmnqjIk4/dycnFX/rkHYdjFXx1vhiTcAZNHKUfMkfpCMeOr+3kz81XXk+BodLDV7IOAAAgAElEQVR7/GHdBAlkRAdka0fM0QA68WK21JzdUQFagw50BsBHtFELnAZcAkpZdDLNTeeOz1w7HABX4MCQINUTQAwv3ZchDVyPHKeovniGGj8eIUlgTbzBsNYJGJ2h2MS9xGcz0P1r4fUzmC6B/IDODvhnmiAMcrwW14kGSw+kRVKLixJbmFxe9AdgLplESbEJmHv0NWtLAUA1Os3ffmi3tR8giUWALhn3PIDYWoC5JmnAUC2MAZC1Pau/ZftkJMU1GyeZ0OXlRG3JNHW1+DlNRJHdKWvf9zIqUSr0E6BUcSYliAbFIx5JSSBa8P0VGQcHucJl0X5hWyMqFLKD0QYOm/kpx0Mrjy9l6nv6sB2OefMmVFkEKrSIsI0qsO8Lhq7FQqEo9ag4+Tg0RRhV0VvkgMXlo0Sxw/0sgcwjbCojH23qW+Dp2FigNA4ykB0OBPwcP5cTVARg/K6TlJzAOn8FlSgcobQv47+LVjXU1+0RbY3LIqTmBNR90ZfKifM5cbw8wqYFVy0TY1MzbJyFbVLfRF4GTh1zCks1usvFJGep+JQXWtFzyHER9xkjPkQ0ZJJdl37K3JdUobE90guYGbWFGNcLS07Zgjll1lqxzGqhshzYuR31hE7AiyrY4bBxTYHS+kqiutLTpv+vXDdsJ6iUWICKST6cao01cgCJIEsjPKJm6jNfU7VjAijXeqLiQoryNdSFlrgrS9Du/QDz81cVWmvnSESdaIcBuNY1deiYE4n3FpbsHxFwRSbHPOKt+5kGmLNj3EdveHKgpOG0++Yjkq1iZwfHeKF7R+A7j0KRmVK0mfYsEu1EdbcEfATOOGbhbFXQQ7uayOEI56+mIuEYtJZRwIIi/OppLarjtEllFcrczMthSorno80+xmva0NJug7jhGmmjnAP5aEBJUC2kga35W40DMUR/9PfDzSYy3Ec0X8mSPdCGBiZUtjz6MasI6M+gcaCh4BFaTaqYSwHIxVdOk0/BBs1tHa7j3dRw/QzAnAVqNV+8mq7Pv9jZ8ZCEXqLvgvUVFBbZhXqqNS5YvsZad27lGckXmBpGm33Sli0ctuWV3Vb5we9Y7taHrXv3w2jkP24noLMcOEl1zxHRbBSYDC14DX8Fh7U5qEctBiHUUOjnjStGbfm7Pmo/+qv/3VoHcIoERjnW8Sg34zktMg2yZSkQEo4+rydmTPYsPkpEqxSoTxQUtZdsqcTO5VRmClgFjGNxyxUYncDhU+KoKwvRF+Kd42ZyQck/KrKui2u+xiqQ6Wk7bcjfEuKPJlUHKcdhil0f7fzE6idqEJ9EYnOYQlPbtu+xS6+h4qyUsGSn6Q/Zz+iuxKdWxFz9ofOnqHmmyuL+Gp+RRGIVFJZ6QHk14LwKaVoldUpSsRYahO6zl2j4e957m23fusOaFwqvxIqpQJZyhqS64rY3u30+o4JALkjgXPF4Q/eR0VXDZsp2CjfizGCTRFHph0I3yM6KOrmYwE8DSYiu4OL5TrK72i3J88RSVQ7ddNkW+9XWXfbyVhLQ2yl05YUB06Kajd2ZO/OVZuYv/2Xmz/TL//IzunE6sFBFtgDbnudD3xZp1xFjomQWqZ9QlMsj48qtkgSqwDkShs6PE0iXoguJ4QV8X7+gwj55RbX9/cv99vDLx2yaz4/zbP1M/Altk6Udu4KuvTZ/771eZGkIKcSWqVIbKua6SPqyEFhuzSybAqi7wot2UuUkecKsADl/u3NNEjm7oMtJ2i9uedQOvXgGmP/7aLlsTaylAuZL5tbappVzra/tOWxjnS1asixVbmZNQjZzG8mfJ06csuuuuskGyEH679/5jj356OPWCb1FK305uyuNzH+pf12Mc/6e999id3z0I3bdpW9mDVJScFCvNE7Jw3nuy390u0Dxq/qFHXwjN1DM+Pz+zJh+zQPzLTe8p6ik5BsJVfrMcGMoY+5YJUCoT2KfOAlkZFEPXsoAWeZtnzlXgJuIVyZU64aPv33h0YqjyR1GKcBWukSKOIva4FcX15YPOTD3/c6YxH5tXwDD0Dh0Tcgy8FCYUY9IZHeh1xQdicBFfM0sdAG43clIliLwc7r/dK/xIbemye4IscXiokhEKGIkQ6OtrqH+FDGHQ6bMeSa931daT73dOf7EoZ3WfvCAGsefVeeXnOB6UVmIGGZUnzOcQG3oK6qp7XxpqYqfjSEVIFN03oFu6HNP632PGo3ZyX27bfYqykfrWfnW4g1F00GqvlyXXM5HtjgpGpx43QG0tfDFM2cPIY6/U1lSmwfYJbWKxVPc6mlAeNv2523OeZcGX13RS4y/VwZ1xEubYUi1SIxDFxESLFT5Y2kDJ5pMAJtAKjI0scOhm4gBkSV2aVGORTZRdXS0P8xZC5aPuLRoJOAzo9LizoYPLrUG1wh1CS3IvogBlqWWMoY2uyrg+VLNIiSpMtd/T9zSIbYYFU2S6+NjkO1+Rc2H5Dzxc3osOOOFxdVEzKlY2EDynIy4q91oO1x659Al2AVRwabCxlVWSnv1d+wHVI9YTWOj3Vh30iZYeAcpZFPdNBe5zW1QXnAcPLor+S6IBqhNNFQS3QWwaFfluvVwTqFmKMooCoCe7ORJ1DoakEsDcCtyqKjkhHNDA3xVUYGwm8i7gHljvfTEiShyzBjAZwiwvHwxfGSk85yDy2AYIgpdVV1IxDz40mIO+C4/31q31LyDSP5VVSHn2CcuSuQq1JPcpH0e6kUSZU/tr5nFrxOS7+MexkmAlG+bTz/X1DLG0Xqf1PjkUZY24/xyukGoP+Jzl1dEJUOBdHfwuPAEiaYjyA+WV0Fr4GN9qK0VUwFSdCsNsYJCnCFUUHRNtd0I7TbQFyogoqSIOlJVw04Eqin9RNiGSOwcBJz3A157AecjAEDPZfHx6i5eOJTeJxr7QU8JsOlaPW5xHFRr4CV7lNzkNA41tyKI4VOABwkbFdbKz8M1xCsXXIpobWb/ooCJ8Oi85SusjnGy7+nHaL9yqyBZs4wxsGR2n61uGLCq26j6ufs5G299xl55/n5rox1eOcH2OQ7bBPKOw+we5EneUbQQlWXVeOdZC+lcKsrbEvIPrr9+s93308dxUIJn7vKpPpRk+MPoBW1A9JaYg2FP+JZ5z6Zlts5oDRL3XIEE8eUVNRcnXMBc1CnRtsRKcIdE64QGmqpcKncj32lLOrHvWHg7y/gr70HtJoCe1hBRb3yex9IUdjgCTbr+zJrhu6E80+ZbbYzCUC+jhHEhNlrJ/S5Q4H0bY82tRqIvZcDc11TZW94NcB55HoqOi8pS51QW+oZ6AQ7McWjLsYXFSIJq/n7yc5+2++69DyrbIq/t4eNBuwqsLYWKYp8FzPV7CVFSD+Jgc7ygmI8dPbsc5lDRGSGie+qkCtagOc81xFFXxc8KqppWk3yq3/UtpzscGTlctJd2dFcut2/d/4Ad3tfia5B79NnqGoM0faWOPbPyxuvRUOn33zw+2jAttBgRwLYKC2kHWD/9WhiUmgX8DdjWuVOez8y6nXBGSAPpdFrw+HwpIJqoek5tk5XX19igsbMgwyLgrj2b5FxnuVO6Vu5AawQMkS6d0DnE4c0GuM+HGS/UTyEbm0eQRBKt0xNcv5+1rfO4rV9SYXlHHrH9zwPM4ZiXkrzrNQC01mrd11jX7mtaox2YN9cgZ7rAygr7qEq73eZTETTfk3tDGKKto93rM1x19Q32nR9/3+75yte8P7WDqtynChJQ61kzVOX2xte9wa6+4RL7CLrzN153ixcwzDjmocgydSfA/FWr9hnDwjPL3873TOKnj4bXPDC/8vW3UY2SiLmMfmCcwKHJ5Kf5ErY0gVBvsVhgswnj4C6B32yK+ftpHvq8SCA2W07OgJ44YQCfAOiKeHsyYOKYK/Etk0rMQHlcXRMsNn0DdvF52VidyyOl3onpNlJcntcyTryvmw44Zz4dVsGBWERe0wvpHmMBcbvuGDEdkOxG4FkARoSHAvQymcfJfpZBLBDHXDxEjLdjXm90nTq8hBOHdtjJA1T2k+8qwOrJKYW24crrA9DrOaMx/R4iYq6FnmZgcqrNvJgRBqFQ23Zsu3shJT2zivQo0oWmc+eRfTZ72bozcoaeXOlLPmcL+oIDW4HlrE2jYbxdA6+nMaJzq80BZN7Siva7Q5aO8YVbkeJx+HQv2oJNoovpPIA8KEpeYMhzg4i94Ex4MRvoHlIoUZa6DKgWnMy1iih29Llrj+ua/oD6GUPSueSACEXMwtEKgOcLsj+RvmLxUMRHrwgkeQzdgXU4Z35sthpn3qr4+u58qAMiCKL+8PHvn/OlXy5JUEEEwCkaNMoYmJLGMG07rAJAOJsC4c6Z9RwAyZXCSyQUPUYREGFi8WC1c1RAlGdC4AdZxTGcvP7uNrjVhTZ/ySpbXthrTbUssLNWW/XsuXYYYN7TCZXFdzOk7wyNA1A6qwKAT7BmHFB6+YYBSrOrMI5uXWCIkubojdc2iCoisBhjbKZyHIuPenSMn9IfbqhTRDyKk0zQ76OAtkXziSDzmiTQFD3t7gU0I5fYAeCfAIUUEg4WIM2n0s0EoVdRHESxqYMq2n1aYD7W2Fo456IM5BfjsIh9pR0oH4P8BISNAObFa9c4Ky6BLgPwHnEit/SLEV+YI56votxEyUWVgQGgUuyjqsrn0w0wAVgcGRqnciJABo75KaqTllHycUpaeXwVUrConx0FHU0gyneh+/slcyoQJ343QAkKjnj2Q8OFcKnhyRPN7yMyO0DF0lESHT1PWvkKPj40NpSErGaNOeWjkGdSJUnt0QTgFr80lEMCoab5JyCv3zX3khkO+oOP6hjPul7a1Qqgk9rNQZ9mj6h8k7Zq08Ue8dz5OGW4K+aiStNvFYUjNr9u0NY2D1vxrcRpWlss9+jPbPcT37MOgPmu40jLeTInfYaaTJ6igvTRyCgVjX34xAwTOK4jsnrjlQvtwScP+M6T0waVr+DTM+xHZpenvBhVAF/ZVW9xnUvz1u149hyiycVrU7SDZ2L4NSNhXZ8VZVgtqQ2nADcC5trZwdbSP2r3MA9yfgSgspwJaGkc5/hKkqDqCbWzbibREd1fcG11mepkG0qqbPyNnyMQOmgvbd9um7e8YQaY63j3Adz+O8Dwb8kT6mVPROU8WZEh2QS1YSnAW0mfUmQJYI4qCzxz5ZQIKJcDjDWevvXd79jnP/d5VI/QM6fWg5tA9TPgLR9qhpRYfC1NtswdBj44zkCWfR1nbgyjzDGMMotKxw9jGDS/pfwimlwZ5yyH015J4aECGrZAEpmMGVUjVZVSUR107pUrV9s4u3zXXXGJ3Xznp+zAdgWVvJnO+ppBBPGaG0hNhAwcZO+ffdxv/p7NB+U4yWgpaMVPrychO8wEraD4moNtSTlFFc5oGG+cuHbqE/8JRdLK2G6r5HPVfFcAWmug6FA+eJr1pzCHHYOOVssdgkc/1A2eHrSB2Zfa9LJrIqlFHatouPOz1MkRUPHsel9nlAODvWPsj0wB5LWjq+uKi3fyiG3AXuYefdQOvvC8nSeOOTuhzi1n7Ma3gkmBy/R3Ef2wpImI+ZoFtpjIedtRkvzZSZVspnZoR+iTvoERu4Bk4GqUef7HD/7V/vvffYsiRMcQlWh3mkw5CagNTVSOZRx96L232/J1i+xv/uYfbPmqTawxCjCFA8q6OZBbNDL7C3fe6dSRV+uLMTaPa1/O9wuMX4Tq0xB6zQNzkj+Li8vuCdWKDF3G3Il1I17zxEe9kOZLgPiIhDuuTQ3mb8/8HYYhVqY4NiK+2dHpfOl4QUJPIPWJFIZMxkCDXnKJngwhBOi0lTTn9JrLZvnmogMmj7o7GDxzndBZD4MQ/kFEzZ3LqWtqPs3cu6LK6UH9zZnhcOY5ZbDTe2cbQDcCKRQiAO13qmgENARFNpziIHAu0KN798byFcu/Wve/TFWvwzN4PTgFAPOrX+/8ao/Y6v+6vn4K2HGEKzEQQdA25ATX0hInTrnTQNJ1ApgrWjlsfYcOWQMFhjwqr7aWc5OAuLef31c4Sd7PAqfJWcnTtrI+psVkBghEO7kjkhZaraLB8o+Hm8C5Og7/ecm5GDcfW5KMC3lAveDbrCLM8TUiEAswLyUSHJGRqLoWC41+BiDXIhsARWzSWDCDPhVUCG+l1N8OhjwSrTGZRdt125kHGUAshlYYRd9295ciCUpgSc8TboJuWyeP54umiAh9wI009mOFj1wAxoJ/RFElyUPK8XE5rKgKOklxGZ1I4HvvC0+Ko+VJw3MxnCW1s9m5VcLhiPW27EDnvd+WkyewpriPctEF1k9VyBpFzHe8ZD1EzGNQCSSLMgTXuiYVgmFH9ZJ1Qw7Mtb5ke0MnO3Oo/EcEmNzhfLbupezjY0MRT/WkFmPGmda7WbMA5gBv6SaPc27JIc6fBximIuwY2/0FOBk9nL+GqHLHqXCWpb2uW3I6jNYzmgVswNYq1UE76J18nBaizZU4GarTKPqACxgJzAhzu5Z65HgpMclLjhPpbYbrPTgkZyKk9eY1i9cc3HApiFQoEk7jjwHOFP3U3JFzoshSGRrq4l6fhltajrMh3rl6sLh0ynqjHIBHXAfgyw+QAKn5Mg2IywcUFEHbkOzhmEfLcUo4rh9QPsj3mCLFilA7GI+5FPr1EYUXGA9cojwCTxl2oJmR1TQmNHNmfM003j2hU+fyAafxlYB5ssVZUCKCG3ov2VE3M9gE4k/rL7rc+uDLHt31LBSE2VaRM2aVBSM2p7LHzpk/ZmU3f8lyulABav257f35t+0EHPNdbQBzpBvdfqChXt64zEbYDRpCqcIdQAcmmiuUugdc3nzjIrvv5/vSXNV0jKi55oBPd81Lp85pHKR8D+ezhEPoCls+8TKlKM1rTds4xvcg1J5uR8SbVmQxqCnTUKaka6+ghK40hkKO7jt2uwTGdYyoKNyFKt+6RxFjI2hb2s3kXAy6UCXReqC/w1QniGeTG99mE0s3A/oHbAcKHOdfSh4Q8zOi0KIZxnOm5cztjuuY667UN3xnwNyDAbyu6LiKCynx05M/Aeb6Fk3Raxd40mEhlIXt9ra3vN255ZUAOgf+WhfVdth55SPJXk4wWUVLGQKAD6GVOkTC5jiepmytAkV1gP/a+joAWyU7V9gWnC0VBxIPeQDOeL7OS58WOuDnHhQ4SRx2aWffRFGxMrhoixeThP76d9uJvaiYuN2JMe+d7WpvMff1mp5zpghhGgvZTrA3SooYZ0Et/6AnO3EOKIDZeYxCYEaBIAfEJHvDSeEQJZ2QANrPjqS25XQxX/czYJ7uzU25qnFybNVsy4Wes3n2kP3+rdfCMumxE61t7rgLjJ/Elk4SiR8Y6LbHX9pn3Rs/GYmc6kmNV6dVCaTLGeBbUXmdW06n5ybE+hY3whftaqeO2sZmjt37E+z1LttwFRxzaZmr/zSI+XL1LtmE1B4OzJFiPB9gvgDZxJqKYt7TmJc8beieq+81luQ4ffv+79k/fOP/xKEeQFTimAPzikqoLCTpVlVX2ec/81mbLJ60f/jH79qKFeekfBg1PzhhcvorX/7UHa9q0meYuOmN/FjJt1f8jAbUPHytc8yhshRDZfEhIy/UwaQ3yMygdjpe4vUGzg6Iksxr4MrAZWG4UsQ6kIzPPF/QozqnLpEOdvAdxiQ+G4ZWH/CtPr7/L/LePL7PszrzPrb2XZYsy/K+JbYTJ3FWZycBEihbaKGdMqXTzjud0sIALS8tZek6lM6nLdOhy9CFFii0ZS0UWiikJAGSEBKyJ04cO973RZYta5fl9/pe535+Ekvbz/tP4QMCxdJPv9/z3M+9nPs6577OdSh8ZA61DIxhrBVNZsGWwZ83voyD5rIr1/eVyrowkM32GZDr5+SuVrDEy75aOl4QBW8ZYOUzF4eg9E/VbgNYA0b93RxC+H7J1SNZlUUyJQ/cEl+iNbB4kttHR1VtToN9SMD8+O5dbkgWC+GZm2PTjeiYl6Nxw6SM6NNGosK0HZ3zKfRMBcx5UCcnKppRgWzUT7jHtBIPh/btjv41FxhgUw1zpvD2U8mBAechE2TzC0l1fLnfPI6Fl0kbgKPehNhMUcfRT7ouThYiCa4IyGdVcfLgYw+pYMJ1+kRKAmKkUtOWjQotYjZDbabaRKbPjblwwjyiIKb/mBCiZ00wniOSoJGWmTZVvc60o51+jIyap5PJXmG3LMFBQpzyZHnF/C6G3M4FXwCEKu7uJy7RSu6QwMLtYB56jWC0c3z5fAIutvvqsxUISHfC/QdQ19+xy8ODh2PH/V/L9aFxXXbh1dG6eKkupz+qz448fZ+i8CNx+RVbolcgdkHHdLQvX6c9RhHzxx9VBFqVP2mO+qO5AZ4k5efRrs3iPFs2quCOor1EFFO7RkGcQQHzPm1GQ/BUXV7I/g1tsDqNoomMKcICcNERW0AVhWj0pDbHlQMCu+Ifj0kKkIj2iJJDu7tRZcGZzuqAqLpYI9nJsJzqiiPeo0iPotHcDEWXAfHSUS5pQMrOWnaYJo5WdS+oBnIMUEFBuRd6TI/47tOS9INGxEMvXcpxv1ScSDrUPZqbpBzCKYXAMrQw+kL0fl1Pfaa9nQI3ypFS5EnXEcDmu7Vd/HeKICkKjirLqMAdYgp2/J3nkqfdjt5PN4nCIsygY+phgfQzasukqDYOAtDAYq+q5GCvwkLh8BJXn1Sc4EwWzg05neK0Oswe5g7H2rZz2M5c2UkFSbRb5nfaN/8N55m5yVv0vgWqzrj6gk1xaMc2fT8RCxauiDblKpAAulj88s1LR6PzlW+LBp18TA1uj2c+9a44oGfceqA1TivJlXtOz7RF04IBaZ4PCfQORa+qxB6Tg0JbcalaxL39zy9fLfWQZwRotDYSa3sdOhejtNOOCV9lq/FyMWim8YB8BABy7lmSNWMyuR6xU5oTiM7SF6iwcLrUKqAxKt68ixV54yKfweePZf2nVCN9Rj550qEAnwBVxh9bxKTHMdLfC/bKUdAKJ1GUJiv3ZezlcmCIPivf4wlRWS6//gUSAlEVWY+fQHGJjqdty4e1Mgtr3YYpaSxZdCjtKcWEKDBkuUQB8w445uKdE8mGZ06VYZKg2Vvu/MqX5ByfikOHj8Xf/9PtzlUBhBMFh+4yrij4JLksei+AvlVUmDbRZNBo71qwILolrTTOHqV+6BZAx/qcFs2iDhsqm9MpbfJhndxBH/Leor2NAlndKm7UL1u0es2aWLFUiY7aVw7JXr/qZ98ao4MU4dEFKYYnJ6VBTprbbHCZdrA6VXQSrp7/DMW2yslmFn/S+rNjIXuCchM1VuRMuM/sLRfbrFoDTuwkDwdKYL1AOsWFxP8WOV6vVfx2+rpMtuJoeTAcXSdiviguW9MUN6+T0pXoHGN67/btz8oZV9VdRQ4Y73FJrbL2j544Fc923SL5RRUMYiIpmJCVRb0D5wT2v2Vuf+s/NAOu+fGDcZ2oY0MP/HUc3nUkLn6eqCwCzcYQrBnmP2os/K7vev3MSQXA/HJVe161REWjND+YF9gKkn5R4+GkMvPaZuKDn/xIfPC9H1DfTsf+vXtNde1TwaerLr04rrvmivih214Zuw7sVSGxT8fSJauT9qoBkWkdqz83s+I33vwaWcXv7pfWNjKJXeqDj85tyfe9KsvVz3nRTwmYv6eykYYP3tDTYjoikTYE1GVLZbtpEGL04/6qwIejBIDwAkTsxTsxqxzjVIbXF8kr5UZTSBSOemWkh0UKd8pGTZPOkImIagE76QyUdpQ2GeCk5c5GJR6aG5R2+7xpFgfD5I3yzG6SQfnsc2XItHZhP69b6/tUEdzcXXxpeMHF6rooAwmZprLIQAksz+cIrhxVVdldNIVn3v/0w3FcVQ+ziipN0eJUwsoFN9yS0lZ6T4Lg7HtaCU3AChVapEghTou/jBFBPnE+nDuiwyx0Z/3oSF+R1lPSsO5fe0GCJF2ESBe2xce0vr7/U7jmdDkGg+Hnjux4ADc+m2DLc8MdnVFpVKYNKtyhJTJGgSFVpVxx6VUZnYev59yBtGJEukieYtynqPxJhE+RG6IPRPvtRDmgkm1OWMKXd2BD9OyRksfAuFrPomQ51JAAn0nnpkzmHMcS565e9PSmv+14JTjypm5glf00B5Kn01IcGIMU52fke70e3DcMQeVCZvQ2n119JjkrTn/YKIeP7pcqxtf9Otrmqy6+PloXKdOf5xYwP/TUvQrSSJbuyitjSbPoB5pSrUvXxQIB851PPC6JNKm3+JmUtKWIORG/gQUqr619c3zsXGw+f0TcQ3S1S6RZ/TQ4KCrLQm3ooi7YKRRfkmgmLXTBqFyuBvaL+iTRpYh4swr7IBk2I3A+0K/KiToBgS5D8Zsz0iLvXdAQBO/t0OuagHMADpFwIpNn5ByQvKn6Jl485wSeexYkaOewzKfW5gKovwWcCJjhGDjaqLbBLe4VXWYK4jfTW7tK/0ByYtDcHtObW0SJseyjlGFm6kRnEdCmgibR9yZRYRoEeAiwtXbIIQCMy/toahaoR/e8AuZKVh1Rv1HIfR7OjOwSijGjiqJPWIFFtJZJRc4Fzkd17Ql5vIbY3qtREOERaKDApPNLmCAkPJfpO8dcZaAh53Y6edl/BtuAJp+iZfCiWgGVVXbwwu+fpbjV3qe5tGzd2uhTee/tD90XU8MnlMOxVFSW0WiePxGLms/ERQMjsfBlPyWJTSXPnXg2HvzouwS66mL7MRVK0mkGztHMPFWYVMTwnMBfV70cPBWrwenBwTinKHPL/LZ49W3L4h/u3OX5YtCp/kk53TKJiv3yuBab5nwm5kBBrVUwIFdcAjafIAqQ42hlohySF7j59DWBHQFNG3NFeVUki5MckveYV3ZqPRFxeBKgz3eORTp0RBSnyEOArwzljyi6Q/o5AJ6HNh0CjJf/aEyvvVY/K0lSlZa3Pb09Lrvm+cKJovh47PK7ltzJ6YCuYanE0guYhgqYV9V7fYsAACAASURBVIGdlkJlAZj3dLU7Wt4mKgsUEvZCO7f6zuqnaTcOKrv651//pjguKdX9CupMC5Ci7rJMSX7LFy9yblGd9s0uFprswNDIhM5gCdwoAq496YwUVww+CZLoeQnu5BSUc1KAco8A3fIVq2UfFsv5aLd+N3QZbPcuVQr96tfuiy/ds012mxwNfVgqMPOVVJmnmxkYaSAAk8au2DzmhihtRLY5Zfbf0nrnHNevBJroKKL0qcGai597IIco+okj5iPCkCRgSltfR27ot8pQcPrIvfR+j10199jo9HmOj1o0z6WecsvasfiFH39RLFu7POq053zxS/+iGgtDUsA5FmdmWuQPKIouFaMp7e1PTa+P2KKC8GVvq102HyvHvlqY1Utz/5VgQAwdjRv7j8bBuxTRPjEZF970o9Hi5P+chz75gAlQgHmDgTlyiX1x6YblsUIAXS5hfOWBB3SCKDqStMmRMn7NT/5EkXGcjr/9zCfjw6KybN64Ltau6rcjBRbZfMmlGscBV33ec+iAnLo7NMeUWFwUeuQMveedb/7ZX/hOTf+PfE1rAoP54/o+qP64c+69v/+BuTjmyraWjnnOJM+tXPH+10keBQAmYEtDWoEp26AyIQve9SJnGXD0hxRd9f4EzWVxAH6L95oAJ2klVSjBR3xaBI0yVNZZFT+ZRDMi5knpyM2ntgLKBuaYZmlTalDnNR3FsI1NQJ5ShuV5csfztZJv6z/U+mPuM7p7+FtlGPm9Bizz+JiIiyNabB6KblBi+5yiGJZLJLlRC8ARXCd6eYst/aoMh6ceVNW83TaQfAHsG2WANt54a9p7j4Fb6l+sOkBf6V5N6qtJGdcpJX860UtJifVafJW6CwotdNm0jl5PHTwYfavPT9BZ9Q0jRT968+U5HTPKNubg531r8yC3WWuqeB/iDamwkhHqVCCoNuNpRT0Ob3silm0WMOcyjIH6xpFwZ60nxxxONrrvBjF69jpFNmascJJPnXriOAoATl2HIXfVUdqdyYq0wVVrC9j2sOp9xsHGNRm1rKnJ8Blfp8ypmvNWTae8dzUrcoqUDdhTJp075ng6be5A9wP/s9ojt05kXvokr1bpCFMZ1Y6Y3jJ4cFfsfvQhPwfR1BWX3Cg53KVZIl7OzJGtX3WEb9PmK+KlA4fj0HRXnOtbZ475TiLm4ph7MOXsUBVzRv28tFeVMAUuoThesn5M0WoAJm0kYjdPUWMpovQpUVSvmxLAuvOpA3+vKFRQROoyYi6JwyYpYZBIOaV519snx1HRaLjjPAOFijrE4T6mSLzPE/SaT2nluDXaSRTYVVJet+guJwcLX1r36+rS2OgeSq3Q/EWPm/4iPq7otYAT6hjMK+gq/GVBN1H7DGXCJe5TkaR581W9UHlD4yr+0youOFH2PF1T8R/Krhdg3ixtddo0okTYljYBfLWfbuO5RpXkyLyi8iiyjsIvuhsl10kaFF1Ap+YA8zGAOdx3UVigs4xKRpDfvV6hKTH+RoHpINdzggNQ1fxtRNXCspY0LxNC07zkbKvMa/qUxcgVG1BBPGxlFaDg875GsV+AYsIEqeYifvmVW3wKsfXer/jkpa1jif52JprUhoXima/uGYmLrtsQdZ0bxbPdH3f97Z/HgYmWOKTKoCMqlAQFXxbJxYnOCmAsVFVZeK2Jx1L/uEWUgv/0wj4VOzlotaxsTM77dPjTRluOVT/4TMEN529exfn8Xqwlwq4OcB8SGOKUj67NJeb5az0lkkLpS/eU+lK5FaJLCyxS5Kk407SggHLbJUfW4d7nXIKmZVWk0tX0rU8IfXSU95tp64+x57/FzsJ8ra8pLahnd+yMCy+/QeBK65AR9/glh9wnTo6Kp8OZr+X+wHp2kMH7kWaXwC5R8k4VOOoQD7iFaDlVfpvqzTNvMk1F6j1ob6uZyBxufXZnvP1tvy67KRUkFamxeos8dRyZ01IGWaxo+CiyOFoEY6J3WUITyo5a6qJJatQ4EXYFBjJSq3kKdUR906Io+7r1m1RldJXoXW2K3rvAgdbCRBySjNN2CRWcOHzAUpR3P6bEQ4F+U1f0OTW4mMvSmaZNFuemms88/DeBZjojg13FOnqvPQd/jS6VSkwCc/2Mwkpb0TEfHVSRM2npE8DBEaDgFZV7OZnT3oKTd1aKLcNtS3V9GRZLCUFlEbCXxvhNy47H77zhv8dD930pDjX0Wq63Ucnuz+48IPirhOezjQpcHI6TRw7E06ekcPOcX0wKy9yvsubmbBTf/PfqN+gup4/HDb17Y+8dH5BNa44NV79IUusC5tDayukCJw1MI8aEiHkzwHyZgPn5y0XX64kDB3fEDkkhIls5Kifk0KGheNMb32CHdUp76Ofu/GJ87MMfjcs2bYzrr71cdlJVQ0Vj8UlUY0cMK3Dy5M4d8eW7H1ZegU4bvH5jRPdd8Rtv+hmlw393v7RGVqgFN+j7Ea2NJ+e25geAyiKOeQtyiQV22B7WIIcNqYv6eG3NHq+6k/yRNIP+EQNWdpIKzNnsVouxZqNnNx2bUEdbqzWcMLUC1URKzfuT4UCVpN5lsPKox1Ei29sK+hlZlaYlkILnmVUq8560z5xkTDkbpN+eEfLUDudBcy+pjlUrSGZHgMg+yZ/VDlp1RLWDsj8YKKch51ro4U5poVNGHWrOOYUCxQabE9mvNq6I3VsfiJNKvHKrvChV2KJ9Qay/7uZ8zmoT9uacUcxUNQAs6Jhe90KVhc2qWQk7HEECaHBIzsFF01vhbw8fORQLV29ICrv3QyLAuSGxU1iVperXHPwy0lWUjvfn83mOeNOlwWUg6Y8S2cj3QXMQhWb7E9F/kSqS2XvTfaScYe64fqVMOhUtXfZZbQR+1QuYw5UnU774KjZehraWreN+Jg9lpJ+x8RBm7JwouCElv9hrYo4kWK4GyPH18hzpEKVrSf+SJV+thuyqWZCZp0IJHLJyYXl4d0Oqa3gd+Io5dnCvK2eCqJ83cDZuEl4V6TII1Rsoab5bFTzpIxzRlZfeHJ0Ll3heTQnAH33qbgOsSy6/Ii7rOqYosiJUy86TSstyq7IMDVICG9lccacFnkh8XNMv9RNRFE4PR2zeIKlG/Vsv0A49kvE+LgDdBzAfhnebIIvno3c5leFnG33tkTrxVTIkJ9YA5ZTp7RVYn5pQv1k9o06lviVHKGB+QtU96U0Ou6ANVJsNI0SBoe5u6ZgPQfPC0RIvXXKJMwK580SnYX6iKmOKKUmmlLFPwrDpMmwy3SRtGnmLQkI0X5z16WmtN/FNSVYkso0dog84AYBHbnUXRVLbVDJ0niT2RiTX2KikVNpGcK5J0dYxJbQCbiYE9s+IQkNhHVAhSbp8N8s2jep+46KujJBcan65krBoZ5mbpqypufSH7QnAxwEDPT39UdZGYtWcT0lhy/XhV8tad/SWa9hmlTnLezzHyqe9VNPxc4KhbVZGJlsF2jZcflWcPLwv9j/1lFWFmjuW6jRex/VKhuyYNxb9ktS8uO3x6F57lU5XjsQddz8eJ6eaY0gnBhN6RroeD7RR/UaRmQFJTB4/JftWIsGszVbJ0r345r746v0HbBmcyOpoeq7JrESMrnpZM4yjjxTyWXJ18zsRcD6H45Jgdx7cOK8ZkmZzvaXlwf5pfADZGtv5cjjrNa7MY/TWJ5W4Ss6Bi26pPSQHp1gBwZMcE9YleQy+vgEzUfJsE/ersxyr5v1lUmJZfKFPgskbOKvE7p07d8XKdRcpgVjKFl6znOJlAKgKnHgKszeUMbGkri5PcKU6kCoPlDbIz5mSu0go9qrMe9+CTumZK5Iu4NskW8m1fvdP3hv//PefEb1kUXQKhBPMWr6gI8YU5BiRg06vN4u7Pq3ToyFFVt3DxQZaGUvtoOAWQZ1etX/F8uW61hKtC8m+aiybBX4b9C8BpmPHjqmC6IE4o0qT46o0icoLNmlYp1Ffe0b0OZ2eGJgrGm+t8Fzsfix/+fTL09fPlsEDT+jsZ7xkgGnZ49MZU/BbXG8bGoxOFV1HrUvl7d15SkJeOrYrVujAgoAeNDVfT896GpqV/p2qb49di1V0RzZKXrfupfY16wOdfXHT8sH4Ly96gRw52RCtiUHx1pAXhiM+dOaMkr9Px1NPb5UU7ePxzFGdkjxf9Gtyn3B4qmcqGCPv+6988ajaB2PkZNzcsyuOPPZl2eSZWLPxcp3YiQZFxJwAJA5j4ZZjD5jHzTo12bC8Py45b0ksH1gQ+/ZvV5XP/S7QN6Kg15EjQ/HG1722BsxPnTyhwnQnJK9JFeh50S6qzIhUxLpkD5u7lttO/d3nvqiI/Rn5Ue1lns786u+87Q3v/Dee4D/sT1o31+tmK/X9j5qvTNza1w8AMBfHvLX1D1koFYhI/l1JjmO9eJOofsDQ6LUS+cvIY6KPKjiSPMncIBKsJzDK5VdmrT+Sr9doIRgtDCUbCX/QLjAfiT8id0gNyWtssMFLiFRLWDWArIB1GnWruvC6753t839cKi8dCCLDBuc27AkOfaUM6Pg3P7vbk//StjQ0Caoq+FcezqAca5sc+YwOoMQBlYVSxYDMczIIVWSitDwvrv/vfuLrKvqxP+/uqLyMakd/bLhWEoO1jag8Ds/IJ4nEoNwh4A+oRTOdtjW7upn6z1FsPR8iz+rTSbVlVAZ24arz/CjmrjoTOx0BOxWMCptpzcrgxGR/5nhXPURDi2EtqDxhOtdIuJDRPAFK8RVPSKd98YVbMkLFEFNgSIacNkyr7ZZ81PNMQmXRFRophiCA5RyHsmnnnp2bck1D3RQrop0c8+YGmPtB4eJ7hLOtRIdTmSGdQGLtPrGuJZR6gusvRGsrSk7Zn2uOZjWP2VxKRNyTpXzzGl6QRxCO/py5gvGdXQbuHx9ri3uY0R4B8/3Pxq7HHvS12efWXHFrtKhSGxs9GuiHnviKNtt6A/PNC44JNHVF/cBqJX8OSHtaGsLekNlwFbUW7xaqx5p+JX9Km/u0Cq5cqoj54CAlzMu60H0HT9VJqlBSjqKLAEhRlHEuA0QWQIr7VIBVXOO+fiVDao9slM74WdEEJsQn71+kqpaSIJzQRCKid1qUmM62c3FiCECTUXh0ph3p1PSAfCQap/itVK7jmN4uuSJAON6ZhJlJqLq3ONvnBLygsriaJdFGvYOj/Y42VUc1YkSHPKRUgXOQc5iKpVTgRlKPQl+mFghAA56QGW5V+1lnY6NJfYDGclbAvVHU1SlFWesUVRtDx9zANNedKWkoVeh7UmB1BCUWRcon1MYzkkuc0DxCvYYJCJFqnoAfail5Wmfc4VlyDpBoegsrJpeUC28xV2yDmegV5M65VNkJ+tNwtAAbn9aUuZc2K22PgaFthCq/rlwVi1eslmqP1BxOHJFTLE5q5+Koo0aEoovNiv62SZFi6cRDcdGWzfHMzgfjgW3jOl2oCwLOyB7mxaza4OsvlzTikSGAefLBeZIWke9/+Ob++OoD+61e40i2AbrTBTyP7C7j5GD2eEyNPc3ObYU14FVpW5OR6ZyndfJkUrWF982613XmiKtNPkXTyaToS64zoKsgYT2huZiFwPQZS6kWG4AFZRzsOHBrxiPdctYh7zI2N4iXQ9e9Nk5e9d8zimmDIrqTgBbAfMmqDVbISH+2BABsT6v9IMdh7rcroTLDPY6Vi8HPOW78hyhwb3d79PV0SjWkM7qVbNkmigta7jtEI/npn/6ZGFdlx+Wr1ujUR2oqHfoWlQXBBCrWElXntBmVrrHRUZeQ75H6U4u45p36blcCaYui4b0L+xWE1sRnfZLAqucY14IalILU0WOHVVFyj/IKhk2VcOEbg2fm+kw8fEDBglMCw6rv4AuQC4Y6ihe7jaufyf9WP1fAvKIIlent9xf7mPqq+qXii6OpXr0f1TE0yVnrE0OxbGJ3rOwQNVL3mbDmJTlHVD1OSdIZFR/asUjAHAdbASHz5KRyNU929SUXTMXP/udXKXdiYRw6Maw+6dKJ4imdLC6RutQp1YBoi7/+7GfjntvvimdPjMbRm9+meUPxIN0Abp3378qoV433VMrnLmPpf5VvJlmu+JFlB+Pxuz+n4ImSZzdslj2XNDD0ldKvlUKLc0v1WqscsU2rFscFa/pjaf+C2Htgp2Rxj8puD3tMR1W1+I2vfY33foIq03K0SA4dPLLD1L1m0c8GB48qH0kyjZJ6fHrfofjHf77LClicgCgv4+i5kw0rP/CB35AV/e5+aQzpxP9Eb+l5Pv2trfn+B+YqMNTc1PaeClMwkZMPm0adryoCU2xHbg+2mbmS5kYfqyk5C0MKd5kNpiy8zPTOTHlHGjMj1JPPGiNlwZJRjl4ohnhGu6KPeAQuORzmvqb+ZQPLtb07JRCf8zXrFORnTLPQxpk5qLkp2hHgUmwg/ngFKsu6Kp9z8/hbzTvOBVmjs6AsQttcpjg3EbjT0/JUSQStl5c/H3pJ1W7vdRkGox07BMxP7d+foBElEr2xtaMv1l97Yz6RB4gHL5EXj0W2Hf3aKS2wCUCt+gqQiypLIloizihFKHIwdipGAOZQWWirAVeCU0dvifjkj45+OpfF0Um9B1UL+slHnQm6rfvqmDUbblXcXu8jSuiiHkQAKKM+Gkd27Ihlm1RxFHQCCEUTUF+cbKD6QdSf18fVRh6zmSIQJPSUKErFxSSyVdFCkDmsDKNPX7TRZjfR1gR58O8Y0Sp67lMg/sdcyBlQoy4mlKYzki+f8zuP1xMPUFyFyF3Ol7wSf+Ae2S+mtLhPM8nMr+mvxmvuJeZQgoG8LnMmoy8UXjq2e5tUMx4uTrC0oa98gVVZxtn4dI2jT9zl8t1brrw6tiw6HsdGBMyXrVAe0zJV/nxccoqqKMq808bRrqg4RWHW9k/qaFta5oqIb9kkTXnJIzY1MzbZjpND56KvW38fI/FK+w3qFlbqQSvaj+f3kji5aJEKnYhjzkZC35NQ2dOjTVom3SXN1QFjSphsb1M56NM6JdJrJJpyYmB1EK2FSQHgCSXmtYu6MqzS73Aq6Z3ObhyipLAYMPFqiapS/MhJoPhDuqZ8UUUJoZMylgLTuh5Rf5xKK7+oXQ3a0HDsUXFBu+esQDTRdiSHG5rQ5FbSpmg5Le2aA3IyGNoGAXadjOsmWi/63Oi4aGJkknq/VzRLiYZN9Kui6WMTTeJfEylXQE88czTWpzTQdqxxwjyPNMYGKYBA8iXYzCsbypAmQHdeQhphr/WcQzk/2GyJErtGglkBxVYZ89CwYottD9KuplRsBkA2yIlr0np65O4va5CUEKw50aRjfGgCnDg06Pi/o6Mpuk4/GLfeclk8su2x+NrWE6pDoMJl1LmCxk9/MMfRzCYKp+U5putYo1z34BFblZT38uf0x10Py46xmwCu9UfilgTGDVT97Kwp6HXJQeZFR7i9fvhbjqnXPA+sSYjmvvnVpp9Wn9dpqvoLdR33K2sOZwjwjGOHw6eXx0XFSZp56Ve13ydb4pi7xJqejblFzsyMJghz24WUtFHhWNGWY1teH+c65Mzo+lYrh8oyMWxKx8By6cNLvpDBS7clbSlf1WnBN/1ukJ7OSr6p7DVY0gLMWRHIJfYImPf3dAmYdwk0KoqtiQ8Y+9O/en987AMf8twYGFjqU5FMuMz5g50CeHVpkSzsX6zE6OWiYPeZMiiZZK/DRu0RVVGkad0XILpPe9Ch/XtFazvtZNJ0Jpj/zFHlV2hfhlKzqKc7njo6HPd+Y7+qXgrUoy2KVCENkFZ27Ui2PJ81YPnyibIe2NHm7KPZL373Rlv+VjqGaxINqEXMtbfBMyc6PinJ2HEB83YFNzTuozoNY51iJ8a1br1PaR/Z1XeNsIRelF2wao8kL+eJY/4zz+mO337LG+Kep5T0qYqqTQ4cKYdCibjHThx1sbSndu6OvTueiq0HlVNw6eviHDqvzAHoOwwUuabItlbYoPZY5Qf/o/9MqeKyVGTetOl0fOIj7xejZiBWiy4EMLdP40h5qfqpue68HF2zS2o5m8QV37BmcSxZ1K211xC7D+yOkydPuYZAp/j2l23ebEeM0+cx7bckmg6f2CNHRRr57dJJlzNzRgmtOM+fVuGh7dv2GFe16VRE7ISffNevvP7D3zIY35VfNd/EOYqb9L1Vz/7wtzbiBwOYSy4xkUX5Mg7B0Jc5RiQENQV794DQsmj8howkmDJgAGg0V16vgFuuLycy+RYJzL1lVJuQLXWuRTaTszJ4M1pc9eLWmYOszYPywfOJ+voqlcHjV6MdZ9Abl81qhn3zIxlIZQt4r42nwWUaAprvjWTO9bMP8jnLfldOC8oiK9er/jHANr7KhEw7FUgYyngTMZ9PNTIvOlBOtUFxrUyS2fWogLl0R+lHTi2m9Z6uzv44/2pRrdjUvAHzjBlJ4h5JZQFkAB4mXPmTzatBJNh6VG38DHQM5TcoO34ypqTa0bN6rTvBDlEGl7IfuAV2i7EkQlvuZ+DuazFuGd3JSF0a13rveplqWZNiKKCAd+OcHN29M5Zs3FwcAhlnK5Ggcw2QUKQSOo4rpRZgzhGbgAE0Jk87ALXb45Z66JPGApIpcw+6hB+mRP49vBm1dTSBzdjOYb4rJRRzsnvv8XWzT1P/2e5LuWZtUdAYfz7lHv2pnE8AEb1ORK24kL6Gudz6G5u8P5dT0V9zo2gckR979snYu/UxryVAyXlbpGMv4/nUXZ9W/10ew5JLbJM28bXXXxUbuo+JEtIVLStWqcDQ8nhWmsqnFUGDHgOgapEqCScpKxZOxtCwCgPp6PQ6Vf48JoyPJGG2PYF5b3fyqRs1icGh1aaZayv7FK51T08W18lnQI9eXG9VwiTKTCSYuXta9JDmVgF4FeZh/BtETUEneHjE2hzWEqdYTVtLnaP0OAOAoc6udPBwCABJCfrEF9VGCp0EDjvVRnk+ovC9CwSEFamHqgUmWNSbwJx5DGcY8O5oKSdv4otCxeHzUMwA1zgMp05Khk4SiVQUBcybby5CNUANnfYRVfPkd5Ad4w3nk4DgqF4fF2gf0canPFaD9Ck910QuOj9UlTeQc6VQ4eywpeNmq5THO7n2AKZpcvI1/c82JRel1zxWyoGJ1JfN+Vnsq5etbSsAL3NQGsUNhl9+Sg75bs0rThhIgm3o6BVQUbSMAKJ0m9vbpGM9+FDc9tLL4wFRor6+7YSSAXE2vPg8bjiQYKOSyudGp6VPYN6uU64XXL8k7n9or3OMfGpZKGE+CbBNSLBuR4TnqyWPcxssQtoUU+24tq9RgjumpHG/jKbWg7oN5nWtetVF0Bi7sJbyBJrgSzcIrIlqwUnIOAVeNG9cs8CJ69m/Xmc4oXLcMvADzQa7gi1MZ+nMiuvj9NoXGsx2yilm/EZl0ybHJW26fXssHjgv+uQcWy6xjGUVLa/ReMogV1jUwDwHvWx+HvCy7Hh+nQiJa96rSHm7kinxT6hxsFenql+599546O675ayTjyOqtGQTV61eGb3imTVZi7xDDvQitUt0JdEavaUb9ClA5Aqh5GwIuKHPrUj60NCgiowdjX2y0ThuWWkahSUoZbk/4RQ2ye4wMBepUNUvven1sfvI8Xj3X30ibv/61jgxKOBMeypgXhm5iu5BLggPWAHyKmpePb9tac76Wke4k/Q5tF1Ver4WMTcVRYuQ8Rcw7xvdE0tb5TbqmuQ8cIUqD4ErTisxdG/f1Vr/ugcOAsC8WRz17sXxs8/vi6UDfT6hHxP4b5XaynOvuy6WL10aO/fs9dv3HToUT+i06UsPPBnbLvh/YnLlee6TRnUshJpTSuI8q5yW3Ei9QfmrFrQrg67slWiaOhnv2DwVH/jkZ2RX5sXa1etFn1PEnH3f1bozcu5EX10OsE5V2IvXLo5Na5fEgNSVOnUywm7WJCeLIJz3eNY+61P9O6bch0md5pB7QPBst+bMszt3xSWS2F22fGl86NP/EHt3Se5UH9Ncuet/veMXb84Wf/e/tF4odiKAEl9QX3ybOsz3PzAvlT9zW6hgaw6Mt4zyn8r0JtBIw18B2OQXl89w9O8rYQUSrPhnkvXYp8rneUdeo3pHAiWDTd83QTsFE7gecokkXLnQjBdxdcdyTe8bbHAJWitwVE2xih5TtkEb9oTm+teZeaWNXkjFWNuo5CJL+zKLpDJyWy26alNNoHKOIhUloaUC5lBZ6uWtVgWGKmRWLVquQKRx52P3iv99ODc7jmx1wTbprJ63RRKDbHIFmGeHl8TP7OosIFQ45oBtos9U0nTLAc04A2ww0mM9e+p0dC9fVTMaJGlVT2cAXCjyeZpQ+pj7V70wa3fMW/eXwUV5h9taNtSECQJNI3FKRn/ggku8SbAZniMZSW0FmMMLxKOfoaomyZ+6eZM8+3MqBMFRbF6Z2FbRMeYSZY4ZqBMhNKUlo1tEZvlEUlXSEbQb4bErpxSec0ndcnv8jrIplA6pHs8nR2z+BgoFHJSNJ5+V8a/Fzx394xmqUyhH6hhTrwK6K1uU98wv04gUrTuy41Ep9IgHDODSNc/f8qJoUvLOWUWkpqWqs+/hr0SnIihXXntt/Ngl5+KRnUocHVgjgQFxzB8XMNcmS7RsXOCrowV1kYhlCyZVuVOCAOra6y8Z9v6Z0UdKdc+LQR339wnUjloTXP1iubekl8G19eGJxmFScnQLF2n/Fci3O6R+o9x9L7KF4lynWphoKkoi5cCDaDiRToBMM5x0n46h/nBWnEfplrdqTiqJkpNl7tvekYU5iFR6HVuFRcBcNLAJRfwB1QZz9K3mzUJkDhUxRwmICo8LVDm0Ok1Bbq1RExRgyd7O9eGh8zPOKDTYBoHzQSW+kiSK3RHuEegGyHN9gRfRYEbHBeRF6eAeOAs8X1uHnBPdj2cYFeBDWG18TJFMDShR88q2ZDU/HO10zOAlW6O44swxr/xEvKZ/c39NsFkirnaeHBFPMGrAzadwaG1jM+pcrU/PQyvHogAAIABJREFU0zKf6e/Fy1bGYlEd9j79pDjmhw0G0bZvEe90XGXHKazTdE51AzqUNHj04Xj1K65UFPT+eGDXGavM2NUEoFrdBq3vYruZ9yUYwntcxET84uddvTAe2noknWDaafvsyZL2gmfzhIePnXPfy9WqPeplL7qy4hloaCrYOG9IZUXqgrnEKgdRfeTotxIkla9Acq5TkpjfcpzqVD1zclRrQWPjbqU/GSdd2/1d2ew59t7Lm62hfkEcuOx/KOqqkx01boGi1lOKRp6SLN+g8jnuuuNuJWJfFpsvuyr55d4IcD7SBpVdrTwojgmOYwZVoAUR8eadPklzCXccBdGtlOg9rPykxx95NA4IVAG2xtAjF+95Sh5mq5wgThVdeVWA+Xm3vDAuu2qL1p1yThxprdPfqR7aIidSRc5Ebzkp2w8AP35CFDgB8gkkFaGKmDOvIlnD8thJxIdiSNugwgAMFbknj+app7fFhO5/wUWb43fe9duxftVyrYHxePDpHfE//+SDcd99W+1M66bZDxUIp9NLrkqtkEGOfK6VMufzB4fNyr6snw3MtVgB5u5T5kqJmHMqK455z+ju6JN0Z3pT6fhxMooqD5+YUYDnwKItlsS0xjka4806blPg6+desiLqRo7FwNIBnRCo/qecugs2bozlcrROnxlz9eb9Bw7Eth1Px1fufyzuG3i5NOwvjl5NH+kTmcK684iCYsPqR6/n7/zF6xJUjU2ycS9ZdDA+/E93+uRu7ep1PoUwt7xUcq2KDKVGv/IMVAUWfvmFAub9C7vtsDG2Cd4LBmGf1Vgil4nN5LTj2f174ojEHgaPH9a9zsYtt96mU8W++IuP/HU89cgzFPGbXrB4zfm//6uv3/WvNPs//GWtDap9ylzO++R3uvn3vyqLCgw1tYrKwhoACKfpT8DgRLoS1cEIlr9V5dodIdRXDZhjofkkBi+RUUZ2K6BbIi6+l43qLDBhMyKSCKXB4BOOlDbuBsrK46mLL4WcD8fO3piKcU6g6njkXMU+b1LOqKeNvMWjXCI1bAoYRhvgArz9nDS5RHgqz72GM2dBZ5ZPTkdj1qCkPeAeLojiY8SyWQpZTKJjrsXdKCoLkb2UuyobqQEfj6zF/eg9imodsVEm6oe0YrsoDOuuuCbn5xzsm/zRjAyy09A3ZykTL465gYAWOqcMHicifYBbvXl4SMkgOn7rWLZsDj0jHRtuYFUWb/c5fuaFGsD6rx5jg15vrvRvGj4Q2XxxDhI8Z9zJHBg2VL06pij4GXntC1Vx1DuvjC3yTc6Y1xUoA8wYo0s7pUIYHE1T8fKcov44aLnBFTDoLaw4VmWTZQIk5zwNc1JZaF9+yvClPGPVldW8YD4U+FHuUoASc82eSvZBNQiVK1rNY173FYpRriLscMsJalafc1S4vMcR07I555pIwEFF0IPbHo7D0ppOB60uzr/mpdEkEHUOLuHpY+KY3xMrFjTHzTddFVcOjMUDB6R3vHRNyiVKleWUkz/hUavATksW21nWO61EPUV2dMJ5w4WSS5RqCnQp8/+1OZxSBLxvAUmP6i2S40rYj/3UQNg0DAFzKbv0LhJXXUmdTmRU40cU+V60kL95sjjxDqWTJiUJDkmrHL49MoFa1TqaBeADlqVkIhDc0kiCpaeowV+3AL7UypOqAUxTciWSdjheJGxyMkdSJ5FuxrpLEfaz3nwFuhWxV9XppKYykgICTB2i3aYl6Fmg9wDUoLMon0qSnDotOKJIr9RhcEYoPmSKC4Xt1R545GMC8xQNspMFD1Q/NLc2mPpKYui4AB7VPodJMgQMWMec9+YJT65lVojWIe32nKhZ2mLDcpbk4Y1nptdfeTWj6WXieqaw/h1priRm9Vf9mhTBQtHziZpklzdfbk7x4/d82Sd42KYx9Vlre4+cGTk9Apl1OMba/JuPPhY/86qL4/avfiOePHQmTuv5nEsHfYW1KlBDAm4qp2RCr8EIc1UN6Bb/+dpNUn7ZS24CEep8AucPVYCcvcXLFzua+RzV9lGdFpjcg/cE/8WOjO5vVJ/7lK0KlCcDsGK/Eu1rjlEtV/MoawzZriM3TW2XpDBWpjTb3GAgLRtkW8GEL/ad+aLfP7xncTx9bELjPRVXX3GJkuWUK6T3TsveHpU6yUMPPWHb9SOvfHmekhp405IcP9+lBD8cPbckoT3YWflDrUWqNwOOSegDcGPTUW55RE7So/fd42vhFE1oDLhemyT2VCDQHggJxudvvDBe8NIfcdEgIt0jRMJFTTktL/zEieNKCj+uNVLUS3yqWiKtppaoL6kgidQgifha6wwR4O6MqoPynEcOSjRA2dmbr7hS/dgQS9ZcGD/+ytvisg2rPeeGdb/3f/oL8Vcf+3zs3n88bUhxePywHr5qQtjzzQH6tq+0uZ5gvAdgrqh/RswLHQaaJsosRJGmTkf96DEFcnTC6isypyhqxekF/ax/UfdqVta6jQCUE71OxFw5XP/lhcujaeKokip1wtC7IK66/DKfKoxpbZyiaJruP6Rkyr379sT9j2+Nz9ddF50XXR09mseEviZlX3cAzPXe2X0iHyrzB/jWOhuX0zO4N56/eX1cvuBAfPjTd2juNcTalWtMuWMa4hAx7gByn7b5X52IKBCz+fxlsWH1Yp0KKi8AUO6K2Pm07rCMeHl971OS9w5RR48fOajrr44LNmxS9WjJLjZ1WM/+U1/8XNxzxz3CWG2//pd/8ge/9R0G4bvykvpLZVjjufp+Rn35wHdqxA9AxDx1zHMVJFisFFEqkH628GwdrGDQa+CwLLQCWPLv5YvICJtqwhUbJv6cW1H+VpEDfFUmZAHmbHqKmWZhBJ1DY8DPyqrCbfNExEMk6aJ8Luk1BVB7V6vakA3NdpXnojXlOfJ9ZVPxAipORqFCFHyXPVPsxOyxVH52dhFynbxcLnyAa/5OBHhSxo6qaSx2dgt4prOOQV6fjWvHw/dIw1ooQT87MqdF29mzJNaqjP2cPTqf3ZEDIi7ZsyxgNl2i8wYPMmRUGETKimPJc6BCvffk4KHQ6W60qzhEUgbgg5eYbYlCcV1ASsV/5rPIiPk42UA8N0eXv676hv4rCaM5j9IopbKJDLyKkYwcPBJ96yTFRlQMg0u4ACDPZsXGjwqPUADKMiTYNcEhLAms2dcFErtvc9zzWNtK2/57xT/1hu+BSxcy1VyqIcpxz6mRKY4ef8C8h7IA8vypwPrKyaxaUe7tREX6sdrxSzSx3DMdnvIaNCbwjL5N8PDY5drzmNInGsN9Tz0Qx3Y+m3/RZzZc8xKdN7bE9js+HcslN3noqftjscp233D9ldEnXuUJScL1LYXKImC+9WEdq540kKY4Tpuy8OEcDihifmxI1BJFvJ8jKsuogDnxRVPHdP+h04qEC5iPiotbRSYz2JWrFXzEYpzUUXBvnwCp61jpuQSWoH7296NxniCI+Teu+9Q3zdcJje4hoJTJcgK0FMrS5+CzTgjkt4s2MqKy6fA16GlJJts5qWMzNfgRCNfuR1HUSSK2gCzUVgBd+kRXB7SYnGvkVfVIY91OP+020OJkHqoUtBS4yjkaJIZy4j5PdJ5TEgfr6AREyjHRfVqkzpByfimHPC5e+qQkHP2lZ8N5bZRDMSWAj0TihK49Md0YQ3rvlKLnZ82pK3rwdFsBZSSCJj2q2B1kPu1EpJXEiTP21H/yFCgDFUwtJ5bbeKU95c0kr5dQayrAFU5+mrac+w3SnV5/6RVSXzhmjXtr5sM9liPR3N6rqOmY9NSloa/XkdlrPfZ0vPa/Xhaf+PxXYs+gdMrRL4fXJHACmER3mhMuxtNuMtxzH50Q8BCfWaD1yvX1sf2o6IhyUBJEp8Xg/+7FaqmUFenuwrZQBdTPCR1Jb4L54JKbZU7yfFyDtYwsLUmjog4lNx0agVaVaCywHnAuSRalz9CdJxI9ckbOFlKWtq0UntKNkR5kPLBrDvXm2k/1nLq440h7fO14a1ZVll2/9dabkw/MqlA/7lNVxS984U79fSZe+8bXCugQsUe0IE9lrFVuG2mDmOu8AqfFBqR+NW3Hqc3kSjjgDTrSmdAa3v7U4/HFT/yNQSp7KoCRdrZIbaVDniinpTzFImmXt/f0yikRqC9zDilTByuwb0x4/UtU1nQWLSIHJMiJEveZBEHECoZ1MndIEeI9koEc1eIm4NOsiHynuOrrL7ggJkULgabdJhpIV/+yuPmG6+K2my6NPnGyx+StHj56It71Vx+Jj3zqDtFQC5/cz1xtzjZ2tTlaPFWPc+31CrT7ffqWMswsMOchlHtkYK6/icriz7aJ41/Aad6rfPv5c2xzAMokBJi3L4pXPX95NE4cjGsvvzRe+oJbjDug95yUfvlhqZbQJ5wy7FX0eefeffHZ8YtiwSXPiZayvyA/uf3QuGpRZO7InJt4ntbJaZjeK5WtfU8IgLfG837sp6KvdSS+8LnPhGqZxbqVyy3eQMOgrbgYmfehfHZaTX5Ot6p9XnXJOp1OdqgyrPIGukRx0lxEWpE1Oa05yrxtF8/umV1Px+iQqkOfd76lk5/Yuyv+4TOfiR994Q/Hpos2xhfvviu+9Pm77lm6cMGNv/Ebv5Hb5/fAl9aGeLuxQt//ov0dMPRtX9//wNzJn62Z/GkjwT+zBqS8nAu7mNhiWmqTPqPXBXzY4OZ1kqebwCYjl3NiRF4vGSnOtVKuygbEsTPHsAA1JitrSiE9jAmepNeCN97SVj7Nz4k73XxH6jHsHJXmPyUiU3YEP26Cy1kjWUX8qyble7meOZGljQZ6BSRWD+Au45rl6BlOL59RYURF4ArHnII/rpqiBFBuX6LmBX05yrLjoa8KmB9136VMqpI6+lepjP2Vbmf2cvaZk8D0CwrPvIhhh8pCxBweJPxy5BJTrgz95eznweNHok4bbYd4Zt402WC1ubkYVBlL9vtpEmBsy9igdJ35igZYLzyPjp0k6udOY5cgWa9zPQN8gHEaFQUdBdSGYvrQYHSvWWeaBUmO1ptVu43RNd5soER6RvVekl6aFQGZZ558iWDNMexEQN1en4UnT7wC0TkniZjwesbCAXpVDCunTka2EhThSJXjT/cKdorPlznseTXXEShAg7nN8SPv9UQFNKTLyemPnZJqTRAB5W70c4kc1taSo4c5pqgpHFAS8PG9u/WJVO7YcP1LVNSlS1n4hzWnzsWBJ7+qCEpnXHPDNbGsW3Jek43RKVWWnn5xIg3Mh6wBflaRnBZFr8c0B5epwuYhSSIOS2HkxgulzKNESjsnGscJ9QO64woW6XU9jz7rExnaDxj2MwnkaQMYFYETScJhcdKtxa95MqJo+xLFOYZFbwEAU7Z+WmoljQKxo6KZQN8g+kzMnIRT/ECizZS0h7I6KfCHI8oJc38/UoaZ4IiDO61xrtdJjCt+AnRI3NaYNpERKse1pZXETpSFxFmX09AjZRlACScwWU0YEI5t0ObFRxyEywqMFO6gyMywElnbpTDCiyNqL4o3nNiA0ybFAR3XBJ4WkIXywckT7bdkoJ5xVJF06huNSSpxuETPU+Gnspgab9dggLcMdAQcMd+g+KTxqkDgjJ7Ja4rXmEN6H3PLMULbPCL5RbO/zHk71iXM4enq9Zd2gmjr0jVrY9GS5bFLaj2njh8zMMcpQmWlsVl1Y+XN1BOFVCfVKypXf/yReMPPPj/+7uP/FIM6WTsmR42KrqluleDVPFb1K8ogVA5O6gXDoTUrwLdpQMpCo0i1lqAJp4eADbWK9cFKQC4xbUfSJtLD4HeKBMkp03OgFuXKwZzg4HiIYlAn4J3SrllgCicDG2J6mde19gqZWU5mqOVWR7/LWUKOU0WPdUIAAEoJxgx2oCev+/ikk/nCNTIav3+kJf52H0orCerapYjy3Off4hL2dnDkQO7ZtSs+9tFPGpi/8ZfeFAsFjm1ssaFgxkL94RpJtS77jq1xWoBKvxoFFkfMUfDSN5UdL79gbTwuecu3vvF/+H7Yjsmit4/9glveSnEavb5A1Txb1EY+C1c5k+mrezDXERTISHmrqBBILhLtHVVEfFDKK2xfR1WoaK+CAlMcYzFSGres+Nkd684/XzV8WmPXzr2xXCef9aq82dDaLUZIT2y5ZGO86PqLVQG41zkYI4rM/80X7op3/p+/Fn2qVk3dz1u1Kf9lsjJ5csXU/ubX54B3JKS+lWNO4MYVpItaS6fwnEF42Snz0cs9q/lV7sO9+HxbX7z4uoHonjcYVyoA9qM/dLNoIk1WpBnXkd6eQ0d12nAyDh4+Ir36baIAnYgvTl4QbZtv8VplTk/KsOwWMD+nk0NfndMHSbbOHz4U5+ToNut73sl9quh8KpqWXxE3vvrnY6B5NG7/wqfkEIzpNLNDBYSopqZ5B3XF4DxP1vmZ8epSMu3G1QNx09WXiBPeaFuclL3EKBRwalIuSZOcOYpRTYrqBF0JrfLTivYv7+2VSlZz9C9dG43KP/jUF/9p6P5/+eqG973vfd8R/M7puf+wH2XLOIB4hb7HNJ+/TY2lasj3PzAXlaXFOubVXMYQVlHQ3LgNdGv+VE6EXE41qJpREH0ZQLHnlMni1/TtWGXlDftv2uh4yZt/RuoL4nbUhagAvDs0nB25koXDKzynaITfDR7TAkTpwFxUlgfAhrZ6TVYpe9V65zN6v7F3PpONoqNqs5FvFpm3RIeryuKuDIbRfT5/LoaqzTTdKzTjQtyn8HPRX2GBI1cxX20nik20nDdbiq8sLPoTULbjG1+R9iy5DjwgvNQ68YZXx6pLL0ueb82oZyTN2xrgQ52M40JUB1UW+ioVbdjWAVYC5rym9w2dkL6wojCUbydSDvfV5gW04eNqni650glgeT42QowkoS2alxtxAvHk2Pnz7hj6KXMDqmgZc2Di9GCMCjD26tjO9yBBFuTD8TjX43hXbUZfeRJVFvMmJZeIjjk3LZd3W6GtJBHVhtFNNhhh46GdvJLVBvNAlvdmX6SjmF+cW6DWUYahtDcv5nt6/hNPRj4sN4+CfXIe6n9ZMpx/qzk3GzHHOfRG6KhzSaQ1GOOEXq3BuSHax+kEwVwjT0XMn/haHN2z223EMK8HmEvP3hQEnXgc2npfLGpvine85uJ4cFdWnexdsjZ6BpZIleUh1a844cQ6IB0ShWOSxlumaPh+RYbFEoqbLxuVEgmH9MxXCsegcV4vDfEpHX9TxARUkfM593VWBUeqep+UTySZLBCe6y4VWBRFF9d7TMmZVvJRm+UjZr6WIue8j0gQhsRguPT7mCLmSPRNCFAD4ohiL4SrLqRLxWxHNzNLwPZgSv0zM0M1YOwBc0gcetFESaAiIIY8ZLecC+WM2xGQ7I/bYzAP2GNcBbx5HvjiRFW58+nheilfpPMAT9wCCXJOcBC49qQkFp3QyXgB+FT9kuJEFEiaFOiDlsMYnBZQR51lxsnGLOGsjsipQp4u0If5PCQ85hwGBKYTYYvD0i96ml7veq4Zor98ylwanKVcpwnKy5f+lipQSTlJBRAVobrmBgPLJ+69OwMaUNUADq5i2qmkbCKqFGShwJc29ZOPxuv+x/Piw+//TAzJUzqpUwAS8aELsazQw057KxuiOTkuAHKOCC72Wp3TIrA3IC36KemH23Y4AJJ2vkrqxHFyCTCBbIIoLj3uB8+55pnlRBdkTQmyAHj0XCQrE+S2rCEdkEDa9pRFhfShzlsbW2TX5HBhXkx54h1675hoVcoGTbvGKZsugwN2Tk6KUzZtQ3K/Oilc+pfbe6xJX+103QLBL/6RVzhKzTWndNKwd9f2+NBffsjj9oZf+mUBn+UeELof5w/ajwvmmXqUd577lUGjrNFBpJzvBmpdaPGsU+n1m665PHYoev2c62+I8VM6CXPfZYVOHCQA+ML+AYO3ZoHXHvGHqfpsYK7TWTjiPjHVTaHgOJKu+8GPH1IyMFUtk56k+c6Jq+g6VPCdgqcsW0w7VIRQ67tXMnstcVQ5ClM6Vtpy6ytFfepUX7dHh/pl+eL+WKMCOJvOg26xxMmKI0osft1v/0l89COfz46tvnza6yGt/jPbLR4s+G54ZvoXp4gsbuwHxqviqcMxJ2KO26q8G/OUFqwu4KTq43LT4pzMNsATU58XMG9dGNddsjDW9o7HbS//WfVdXWw5b4FsOjKsMwpmnIhHHtsqe3dGFV6fEDXodNw5uSHOXfYiz2v2kDpd/8Sp8RhTRv08Kn8P7oqpZ74UdQceiVblbixbskS24WwcUBGg1vXPixt+9KfETx9UxPzT0SMPctWSRe7neiVGJCifpbGwLpqVHzEg+spGySUOSJGlW7r2qHK1aL+kCisSlqiyeZzt6BNImIo777tTFJ1x5fG0ukjUAlVuJd/qiChNb37HO178j3/7sc9902T8Lv+itm9QEy7X98Na91v/teb8QADzLDDEF0eRib0y8DsLWHkh+bMZYazACQDaUUv/H8OIQfX2ksCNn4xZE6JlAlwirKRgVNct8ZLy2VQTYH3KMBNFxLgQMS/JoDa17JNcKs8Jk1bhDaOscaO/Kj6RCzX/W8BzITXWePS1v5cL+ELlIaofM+w8C+ZLaKoC5n4itR2DCSUH0Dsp3TWSV+dbYkpHhwLJ53R8mlzjWSNNfzz7wJclb3S8eOI0SIBHpdZXXnRp0hy80/kmZXNJMAFQoW+SNiPjpa8mGWEi5YZU+tfAUW0aFscN4NAlab10mHLM+Up/hBdKQR82R8Alm4oBQZkTNqwctwFck69np8yzoUTPSsQ/HSA2xZMxIZJz96qVVkRwhVSMmDsUugUqPI3aJKSwMaHjQ12LJKZ50pJGepGxyMRJvmkjba2sfQJf96fnEOAEh4RJUj5SAHju4+lk2OnU66UVHpNMDuVeySmuFFpy88f5o2U4Knnp1GAg2lGGploTBvU5hr4lf2cMneCW12KTdFVAD21G7DDs+xQxP7Jnl+/BetlwgzYBcQNxwiZOHlYF1Qejt70tXvb8i5WdPyNDK1CtBL8eHSvveOKxODN4UoAE0AM96Kz1v5ctVATwBMm/dQLmohVJNcXOAsfjApYkPXZ1KXomrXP2xDxNSDoJgNBgSu9F/1tiD671UYfTIgA2IjTa0yuJLkUklSkngKfxFN+6TnSPER3vcvCFljjHsfDuUc1A8WRC0fsW6YfDNbfdEQDW/p8cXBeBoT/oW6rpErmmLUbGAviozcyTjrmS1KxRLRCt6dopHfSGOp3uAPw0N+GYkq8C3xkZRqg4TBscyhnx1+Ejn1HZ+U6Kk+h1Bfp0xE910izgwvvHBNxm9E2UGY44Ed4WRf5HxGkfQ/FDlJaxwjGf0NqZ0rNCufOaYtzx8XAaBfbTpqXDMUMJeYB6iWb4eTmBcXCimm/Mac1HB20zgpxzP+1QhTkySduuYq5DPUxX36JYuX6jyonvjv2KnFXrO6O3skcqsHKWBxb/lbVIQZmmk4/Em37lRfEX//sTMa5kusOiONHP0IH4MkddbaecOwm5SLo4kqv74Wz2dZLbgtpNOaEqkWm7Ql5v2SfeC5A1TCtU1k/ainRWKlpZuS+nCYBXA0sclgTMnMbgbHid4iSrj+vgl5d+t8Y5gF4OHac83KzQ4r2WXXCIBiHBSv8igaif/+Ch+jgqffvaCZf+dv769fGyH3uV+onnZu1Mxf7dz8b7/+x9BnFv/OW3CQCt9Dgxl5g/2LX8OW2s907bhrQL3g81B5zkpznjBFqB2g2rBmLjeaq4qX1jWGN0ww+9OPY8inJc7qEuyKa+JYm6S5HydkXNqdTZoch2u7SqCWqhujIlkA3FgX8B3pMCyxQpg+ICX512s39wPTqHJESkaxvlYJ0WeOfUr1PXaxW4G9PnDstJ4L4//BM/H/3iLreK/kJhI6QTF6qwUa++F6oY0solfS5w9rb/++H44z/9eAJqHr7sX7aeVfCr6hjPAxvdfKOPu/U5EmJ5TYmws8BcdkEnqskxF5WFAFjvebMdXd3M/e6b5gBUXyxKA/Pe2LR+Ybxss6g6y2+S39YW169vjeU99ZYW3LX/YBwWBfO0uHvPblfiq/h6d46sjOObXxJN49rPVHW0RYmjpw7viWbtWzufeSKmDzwl+sqgouD10aWiTd3i5w0pcf3g4eHouuwV8cLbXhqHDz8eD0hVZ6lOOFYvltNjdZVv1ognuIJL1SS8sH5Ff1wkp2dpf4+LTLWKxgQYJyBn6kuZU9jzSR1HNureR0/oFETGtb1DcroKCk7K2RoVrXbXkX2//tyrbvqtb+6Q7/5vsgkvVSvEL4pP6Hk4svmOX9/3wPxaUVkUlXxPFa3GlCZIwapVq4gfM7JWbMk3e/5pXxKYO+pTHd/zuVwQNW52BZ7KMjGoN5jLxVNxbrnWpLTLGwUuU35QwJZS9jL2jhzZviY4TQ5vrvFc00k7SeOfaMnGsLzXz1L+lmAJE1EMdnlPXr9YcF8gn9+Xs/Euz+RbY3UTkmZ79F8ALOBCjZhWZbhpGcV66ctSXr4OWolvnG3Lvklw9swDd8aoPHSug4Hm30Ur1sfyCzblZuyoUrbHPedIDIaVTY6jdoC5OObqJ7xojsuJCNuhKWB78NhO0SEaDcwJ/9XY/qWfssM0E5z8y6ZI+wxJvdHUAdKLtmpyFzOSxvNkTGzW2arGk/eNSoN7UmUnO6QG0+DoP7QNOHGMb0aTSH7iGc5OnGYEddQuw5tyHQYsOdD0H5tIgpKq/2gjTPPSnTl+OfvKTxohNnf+R7Pp4zIzKuzu2DrDPvvE/imvlONVIaGMw+UwurCRn7+sA0cJcw7lcWdJylO/8dwAGN5ZFfKq6FQGK5o3ux+9L44f2O1bAUTWX/tDGkolwhLIHjshxZb7xc1uj02XXhxvvLE+PveYjO/AOkXMkUt8RJX5oLIA+oiiomk7HUsVET4ojvlpgeebNg1r08l5DNiepoy8ADRRY4r4YlydAAAgAElEQVTsJTDP9qeyRLogOGijivz0qcqnK39a0SiTODulR446yzkAsC5A1LtJgOi0dNEV3Le2cDOgFmoCHaI1M0YxHwW+oLKAT6ZEBQHgwzkhaGYwo7YBljJKiCOTQ4D8Iomc3aouCujn1AU+eqdOBpgJjBoAEQcADXJTn+SsnFUip6P6Gq9pIfkG2jjaLGoQs0fPIE3yBjkU802ZkB1SJFxiHqnmwMeIZulaFB10UqiAOUWVxiUreEbqLeNQZtRmF+4q42/744OyBH9ViMNcajsQ2V7yeTxfWA+VQ1dsXbFIBcvk/IKS4jmXEy/tFGPFZ/WMqy+6RBSd7nj0a3cbmFlSUEAMGzWtddTS0qm+H5OtUsK11qJzOqTK8pZ3vTL+/J0fjnmSkNw3BDCX0wMliUCDjuuTv6yxQz2HZypmqatNZeOVV4BDaM119gz7sEnjSoc3m+fVbDOTQNsm2MPCBwBiTEKvnFoBIlPArDSb9gCHjKi7deCxCQRasQGqdsvU9DjiGKg942dwRopL7HFIm1ONh7vQ9Kd58Yl9vbFnDB45bcs1PLBkaTz/hS+OVgEtgBB0RaLKB/ftir9875850vz6X357DKxY7bYzR1k1APPM08gv8+MNxiuAzskNwCqLVnXquOfGKzZFjzTLq30TgPvzb//V+PT732eNdYc/SrCMnQBbT7TVII1v+ib5W7N7RbFN8KG5HsEjPjsloAmH3In4Chz16TlXKGHkJS+/LR5R9eFntm6LlStW6bRCzr845B/5+Cdkgybj9b/4K/Hil77Y7a7XIoaKAVAkKbFV330C6pOaU2/9kw/H/33v32XCZdUJuZkVW1petIdZwHv1PuaB30vPMR9soT0uTjypIuaTMkaTJJgo4Fp5qqW/Z+9ZvVAWC5ONSmLtfbFgUVf87S/dFPc9fUZa78vihVcs1a2QkjwTj0od64wy5lsUoX7wwW/YnvzzyKo4dP4NsWj31yJ2PRzHtj8c44f2KKA0UvbMtPktUs3p0JFel4D58ZFpVU5Vdd1bXxsvfe6V8cgTX5bazmOxRiB7ucB2vZ4F6qnHkD61k8ZpkvwNSSNetWlNbFy7TEn2XSow1WLgXQFynqwC5uCBk8OnFCVv1zNgI4UJNA7jyhtgzapNn1m4sP+2qje+V/7VWlR2UbxA3/v0LF/5t9r1A6DKosqfLar8aRg0h0fN5uFjU+b5LMTJ9ZIJOt5sMG6zcKTm7FbrKiOYtdVYDE1yDHm9KtqC/SXHp+LpsgCpVlgvlQBHzK2uMAeYV6MGwKssfbnNbIJmyr7BkzVgx5gV8MTHK6OcIMFvcB+4uXyuAMx8vIR3s0eRAJ6ke/Bnf9U2Rv0IVxGwrI12QtGkGUUaGnTkRJlfotfJt8yvDPrm8fI2RcxHpUHtk4kC3AfWXBQDSuAoHV77TJ4CJljmeJloMwUF4Iwi2dUIdUZJOk7ArVVMVZGMw88q2tUmYL7Yr5ufWpyNBNdJHrBEsltSOQEZ2Uunhfblhuf3zHHiqiHPqHKqLTCXxk4N6Qh0JDqlte33y2igGc1jZuVGgLki5kR4JsXPg1sHAZmCTGyOOBH5tnLv6pfsv3QQEjDkiUpG+jkpKENoPnR2IHM4Hc0qf6KWqFyQvadVNbb5odp/q+ed5ahnhA+EZEejRPKrPIt0a3KSuFAWz8PyqvqduVn6ACrL7kfuVfXPvX4GHLTzBMybVK1tgmIwoyfj0I5vRFtnS1x9+eZYt3BChlibppM/V6hi6MPaSE7JoFN4BXqBZBMV0R5Q4Z5DCiwBvK+/UDJ4AuYkp+F8TTl6LY65KAijUmURUivLtkRk/ej6jzbvUUW5+xaqGqSADoVW2AgmFb2k0A/1RQSv9VblCuj1Jv39jDjrjpQKOEF5ZdWQrIc8KFSWFmmdTxBdJ8In8N4tjjjJhmxQuX+ng2ite7UTXXGAdb04w8ybrk69RkVQLxDlTnRV651nZ2nr7wKV7OlQRDgV98kPbRcOgIsM775NUVa01UnoVLCwUCEUYRd3nG8KtRjP+6KqxKc9fUy0nnE5FcTnSf48o+uMsh7P6pRHrfHGWf0Lb1/ehl1Xm1ZOpYjIAnTTcbNN5J/02/xZL5UagJzFNj5pMY0Mu5SnVLZ1nmzKB1AEboMKUA3L0d8hTfIKCDl/hIi57FCd5OLqZZuaNR6nVaZ8viLmU0cej7e+/QXxR7/7D+Ira86oouB8KqDKOxmVVB/FTFp1tE6kduN5vXHg6KjBIjkCa5fViRphK+rxzURPP4X/Bz8qpd3yBIZFkM5pedby0KxhuOvYdttYnJpquRdx6noFOaanyTYmXyWd9nmS4/RlRd+iP6AqNSjR56zsI4pBPm2hz+wZZN9VPepTDPXLmXUvi4kVN5haQtS5ipgbNEEXQIBADeYUd1J9d2D/rvjTP/oTB5Je9+a3xbI1stVe17Qoq09mrQnsDfaB65ZgSbGx2LZWOTnni6qwcc3yTFYtjhkX4vMf/OSn4i2vf20q1Xj/RSCBNYWthyKZUVNb5zl7LuuTL/6F1pKgPKv5+m843moepx4A8ze/8Rfi2JnBuOjCy3Ti0me+OZH4ZgWWFnS3xdt/651x8NndcZWK3r3vz/9MAQKdaqZHZRsNoIRKCYf9tIDt637tt+Mf/+5jJSpPAnH2Q2XMTc+y3WYC8zLrQ2PuYFL+bAzPySnEkfkIAiCVqAXISao5bALm4+KZ911QvPkCBmxyZ8c494k0ZV4oRMzbelVkqC/e9epN0VI3GVduulDPlJVVkap84sknpUClPB6dRM+QO6b96BOnV8WBjtVx/JP/M+KxO2XyNA/dTk4zksbGF3KWHTqK61a2/OHTkzF48mys/PFfi1suWRp33PmxOLR7b6xf1CddcgFz0ZA4gUp5xDzFseyx5sqS3q7YctHaOE+nKL3dVGoVdeVbIuV5x7SXR08eV50LSQ1zworjrYduQgyioW5re8eCK9T/ttTfS19qd6Vdfofad+jfatv3PzBXxLylufU9ecxWAY+cyElfKFHAOfM8UU6+vcQwC+jwtMj4YnnPLF5Lq5p6z7k4fIny1qpITqoS8D42ROTyVDWQKAbHdjoPnxttqDbtLHxStakYJduJNI418FO9BmDm7TybDQENSfBpRQRAQwHiGaQtRqTqo3K7auLkMxajgoHhggBzb7IAgREXSGpSiG2eFl4V9TewL+9x72gRPfX1O2IEUFU6mP4ZWCtgvm59NrTqV/3Bkcxi9H0dpNlkXCeldYuBrZOhn0c5e/3NTg1RHn1k8OAz2rQ7xF1HlYiIEFEv2l89WA6Kt1JOE6pBzl7z/wFZjKWdKSgOPoIvrabvqg3C7/NWoefSSYD4Eu1SDjHYkJGDelNXqv+xkc/TUd5ZtX9mWpVSdb0GwpIYYW9qIPwS8SoGyHC32rU9PkQD2aDUnsINTTWW7DvTALJmXwHkOS9rTpu5welseOSZ4z40yNMS36FsenlVOipPFfK0hmsnRKzUV7xh8Tc2QqKt7kDjgm/apLyZQmFQn+x78J44duigI7/zVLFu3TW3iloxP04e3ScpyUGVGD+po+s2y3r1dalsuorc9C5fGQsWwzF/XNn4g8kZVoQYTDMqLnSf+OMntHehlnLFhSrNrci5EzXVXiLNUDShsqCWxleepBTY4md2g7VBAeCl2S3KC3QTaPHTArPdC6b1WbP2PRfohQYSQ/Ua14Hri+whSb0AJgp9AOSbFKmeFqUkFT9EExVHHBBMvyKZyD04nkVzGjtlmoh6hhMBgHSPiiJNKNqf/UfhH42FefxscLxHIyKeOOvFPH7aq2ROV4VUuxnjYVUDVNHELFyk9zeorXCPideZYz7T6Oqi9QKkPkDQtVtUGImCRqO6BjHMCSLmiqoP6/O00TkNgE5aa4CeANN9Sjl6pjOTSoDdE8ZnOcWZqOafl3g5/StzNsekzDLmlF5AfCTd0ULv0O8Dq9dKqUfUJiV9DilhDboKa81XFACd1jNFg4C5vBo+f1IbeFNTd4ztfyQuXjEVT+5XsR4BlXkCtqeHRHuQI91YVD3cl+qDAVWT7FeEeHzkeJw4tCdWr5QO9qCuX8tVwTbw7Dws1Kq0K1b98XJOAJLyq/k3wLvBG3PTtt0ujh1fF1lCHoiEYP3OWHKywcTw03PKRz/JabPTo/cj59ioKD5FsCaU8JxSmukYsN/gEEOv8mnQeulTr3munWHnN3mukrdSKC018MsJCnrRE3HgwJ74oz/4Q1dd/rlffGusOA+abDobCdBtffzlnJ9CWUmnO4HXIpzsS9Yr0gzALnukbd3s14EjR+K5t94Sg+J4c3Hm7Zgi145Si/JXVqg/k/SUtL2M1VlF9qGu+DXaQX+WZ8maG/QDfPLG+M13vCP6lg9kArZOLEk6XCgw2CgPlqTDN/3qr8X9dyKzp59/5R3xhtf8t6Tj+HEZg6xaSd9t3bMnXvXqn47Du3cnwMa59vjnk1WykrUAUAXCSyv9pvIaD8xnJ5ulvNIgtoP3v7SZMTFUgPmFZUOv+q3s3dm6fDE7IP8j8BptCtR2qmjPys54x4uWxtbtO7xXwd1e0rPQJ5NNevbTKtx3RAWU9ow0xI23vTJ+876hGPror8X8x+7yfu9+Zx+cM0cMzHXCskDAfM9xyU5OdsTGn/uduEYJ7l+/8yNxTsmZC0Qz6V640DU8qNQNxmHvqDmEsll9XR1x6UZJHq5dqroNqv5KxFx4CLpY1ZfZVQQFFNg5sE90KCrE1ts5IP9AztjumD95TXv7Ik2g760vtVtnqvFKfY9oDv2rSZ+1UdUHfkK/HNSb7/zeepT/362xvdI3K4htCwtdf+3NL/opZfK68mceqlZmMK9f4otl4yhAAsNeszRVpD3fn1AlFSkM7BIPla80sAmB+fLOlAs2TXf+DVCrrW5SR+aNmoDecElCgZ8tg1mLJPj9JN1luxIwlWgIBpH2lFt5c6taUoFn1iyvGTlyESIo2TI2BO8VtcbPNZH5er6VaJ7xQB4/lw2EHcOqKXrjlGSoEpgrYq4ozzyiId6F8pq1kwpd56mv/Ytk6BKYm/eo9wysvjgGlA2fUbEEqICmqshIRj0y+ZONYkKqLFQZbSCCrqgYURKiS1WE/9heFRVo74zOXqmywLMtDoxVYmpAgAdMMJo2LDdIH02XaeTnhTPrjdeDP2dzmI1Sc1FaPHLyqOioAkCK1LvvqEgmXmB9A2OcRTbmKUI+reJC5+ALaqybpNELv9zzQ9H9nCNzznacQJfAJmlTzJ2kBmQlv+Kc6dmSj1qADmMGNvC4Z3/y6dmiSGUzZa7gyDEWgKAyc/O4vdyvio4T5sSg0kqAix2JTG6lHTgxZ4mU8Tc1JKOgs+vDewwRIqgsD34lTh4SP1D/q1OE5vzrbtG8kQa+3jRx6khMi6/fLS7n2sV94o5PiCZUFwtWrogeRcx3PvqYivqccJ/jQAFEEFhY2KkCQwLmo1JCueJ8zROtLxjYPMW0dL4nBYJ72pXcSYQb3i7tKaCIqBSbPZstkfZeRd8pcZ4Dr8RIzbtuFacZpzqmB4M+AKADvolS4qjgIJK0CWBPqcFhOQcK/jjyzckGxblc+VM3nzL4QLYwx2dSiXZ1StqnvDSNa1B0FCDfoTaTJOpcC/2vWfKL6G5QUhtQxXugyPh0Q45KkWzWJqjrUAxM9xhVwKtDkXvnmSGZrKJDLs3uZ4OHq2i+pqR3TAC3xr5ZqiwTUmShiNM5Ad5RKktKHWdY/QgP3w4g84epw1RgwyaKnHqIydTwvwLM7utcQ7ZBXuflxTL3/Mdyium5yt8tAkE/8eR8nhWS0dgLtlyjk4Kp2Hr/fQZkuA+tckbacEg0Nm0tvbF9SNF+5cCkdyXqkXTNT+9/MH74kpn41IPoYeoY3BQEZDfFZ21SIapTVExt08mGpBaV0E3UuFF8ezq6s2tRrFm3JEYPPhIj6M/77E0nFjgcgLZi591G1qTWPHQonzCx/rFBXkYJ8DiK53QkZSD1HpL9/XP263xRHZy8Td+w1LgPyZ4CUnDN6Rs7yPxROQBWlynUFE5tvG+A7tWvZ897UUxveIlP3ZyIyYkCuUCAdJ9EFPDpvQFbiHSoZAUP7os/fPe75aiOxWt+4VdUXv2i3JfK8OU+wXMR3cWs5R7Gd5fKqm9Y2R/rVi0RiNLJYNkTalHlYm/4B574H7z3j+MPfvf3M99I15rQ8U+3PNlVWvucph0bHIxjR487mZO+49l4Xn5nzB2sKu1hv+gUH/20AkFLJKm0VyB6gWhPv/z/vlnOxRrbGnI22gTM2xQV53OnRZG4/fbb48yx43HNNdfEi192m+7fU04BM1KeJ4JyhNTev7/zzvj19/xN7Nol288Vquh12WdrG0ftOT2z87ca8Kb7GOxc976GxyzHNxetjgIVsIj+iwto4Rpzr5Xr5Jte4++OmAPMB2Je70C86RUbY0PHifjy3V+XM6oIhaLMZ1ukeNPZG1sPjsWJ+p64XMotj6p68ZCcorOffGfUPfQFz11bS8bXHneOOaCYddK9sC+ePToWLcuuiUte8ZNxhYqg3f/lj8fw/mdFdemTxGWfRQ44lfGeoOc0jcV2kyCCTikFyM9bMRDLxd03OJd8Lgos3C6DobmpHaNOiQZu1bKUYGQchQH27zl+8ppLzjtPZcW/977URg1cqMBJPKg5+vS/18Lve4751ar8KW/7D4upy6nLBuZ5xSJOEF4ZDEwTU9ABKRueAoSr5eT35top7BCDqdlFMQv8HWcE7PhmsxFEe/h8y4g26EjJqfWO/jEJy9W82QGaDLd8z4xbVmuCN2Qjq2qM1qYt0M7YoUzm8rYCqkpTvWkQ4SvXqfojjxbm2JPcIHyfOZtrBcz5+ITOUJF7bCRTHv1YHclNYezL7EuPNyP9W++9PcaG5f3rpdT/nhdL122OxWvX5ntyS3Ijq+NKknYycUjAXMZ5Qkd6GF2OsuFno2TRKG88TxBmYlDGoFkGo61PwJyNyZtEno7QidCUas6PDODYqWHZL1WSo/Ja5nMZwE6LT+eoElrzblMapGwj72FceEq4jnKFB+Woq/9aFypSD/AQ7WZaJYNV4MD3R3KqjtLR0jSb0bUpftOg4z2SP72pOXpWYiuVHB1Rs2qrqeYeDlVRuzD4dU9nxC2pJYXSVANAGanMQkDpIlZuYsJsLlw5o8Xhy22mzIXKrcQ4Zo5FNRsNAtwbGck3JuMpkO2unVDkfROYc0Q+FbvuvyNOqaCHoaG4h+u2PE+gSE6K3jl1esgGu1lRwfMXNUWHNtxpgZHFipi3q/LnLtEWhiXvRZGfVKiRUo9A0sJOUV6kKT6t2vEXCZiTzDcNd1tvOavEODjG3aIuWHecOxWHI/1dZwQY5AxLgaVPUe1xSlu75eRdKWIufnpSWfRZOLN+VqpmZvSHfgSck5TapEgPgBeQ39qM3joAlYQ26WCLEgPKgscNNxwWFuAMPjXgEs43vd+o50OWsKMNWUiAfkbwdeKeoA+aikDotE4LzpJfUaK48LiJnsJtnxGw5jNU8GxSBNx8e4H8ZgHzVEyi+BH9lMWEUi40i3pAZRnRc09IiQWzMEkSLHx0RfHhpAPMKUnvAjg+ns6+4SSIWcuOiqOTALzYFRtXqDpEfA3fc8LYmSOqW07KcHb1O0Q0Iq5NUtEhyt+sUwROJnoHVkTr4vNj11PPxP49hyzV2Ncup1gAukER5gMn9Ezz2uP4uJxiCn1RYUr906xiZmM7vhxv/9Vb43d//WNxgqo8ei6qo25c2RY7jo1LD306FvYJyNRJt3l0WOtW95V96e6UnZk3Hks1AC/+iZ+Ij3/or2MMh8nOb9qsyolP/EkfJ53EZsKgptg3fyTpfWmrsfdqSg3zqN88nlqP1YmD1xOjI2KRgAyJc+RXEOSH7jEuji8UJtsvXcdJyPwfp/P8H47p834oaSZFHQUFHUfODeALKC+A2mAH/q4mxZEjB+I9v/d7UjkaVsT8bbFalY2tGuXNNO0ispU8ZMowYsNmYpEc2edffbHmu8Bh+ZobdKpeSypHfsMb/7MP/EV88AMfljM+6ratWbPGgZYdu3bGMzotmxRnvJZIXjtlZBsFmOea5Is5ea2UXr6h4kU9itjWK4/rtpe8JLZc/xzrmxMYOSpa5Z59BzT3ddohu3T+mpVx5eVXWp6REvLsOUg8tmrMkeizwpQelXsRuf2rz34+fvOPPxlDR+XkefpXc72ynqWPar+Wv5f1UOsYH1MxCXjjnJ8N3osqy4gAaf8laZC+9etbr+e/qx/gqBdgLuMZ88UF7zhvwBFpItijkjY+KRvB82RRIl2c6CU30f4Vn/3dqL//s7leS/tyrjD3VABKeuI9ipZ39i+J7eMd8fY3vDHuH66LjZ2NcXLfg/GNf/msaC7LolXF4+oB5p5zfJp9hNOePF0gab5F0W+qr3ZqvvSI2gKlBR7/AlFleroE1FVADLrRiI48CVJQ7RW7MTR6Zv+H7rj9hre+6r/u/g49811/SfOaCUm0nH//Xmtgrhj8d2zf9z0wv1ZyiY1WZcnFavCiQc1IKcaACEXOxzyqL8f3Tq7KdVJVW0ygm+vCCgE2qBkln7taDCgdUatQyuyfbYxNA8lqhYBZg3f0e12YRwYPg1vum8YvP++qmywIG9tceAbrZW+zaXWbEuCmF47DXQHRClBmJNWfrdCz+4SNpUTA+JvbkJfJaEDVT2lEiRhQwY2I+Yx40/AASW5MTfE5hr70PcDnybu/6HLHuZln3y49/9LoX7U6IwZzNupksmShlnoNUr2IsWcFdOHCOXKBFi5gHSk+VRy1hJrG7cSBbTIYPUpGR283HyCpLMkhr+AWY3hGUdtx0Sa6FeWub+9Kx0hvndA9TuzdbsC/UMmp82Q0KlUWQ1fLKma0OhN6lGCnDPFmbKEiE+bFqmIM/VKn0ovWrccREloii3xSiTxErep1yqAXc0MDsBAdqzq+gOM00xmB8pF4kapLJY8E2Z6bPmYsk8GfKXPTUnWG37XJknO9TK70TNNA1Ma6TIwyTg746c8JukqLvByyf9NRSEeS19yOAtjywvzKRfiejm333R7Dikrx8SapHqy78map+rQnGDgzqpMERfOkRLBleX3cdMFEfOHxFikkrFIRO+mYq/Ln8BCyanJsrfahyLhoGD0CvEPaH+HCblo7bl6wAS9glGI1uneHql2cEUWlcqZptfXMy1olkn5mtE5H2/DDmTfZh5MCtj0UJ0KVRZ1BEpsfR7+OjRF1zGvSJo7Em+qndDyr8t57iDzr/uJwc22rrKjUPWXUmWhU4UQFxaBEVBE0rIniAagbpZzCTXRi61wF8+XV18gY1uta7KO8h7YB4FM+kfcAzAXs9bmz4ofPE5iFKw41Zcp9IQ61AL1pL/rAhP42rc+iyDJDARxO7dS6tg4VYtGx9oQKDHF9dM6HRWWZ0PsUUBMopw+SOsJmaz1yjYXd2GKkmKp5tcq5y3knuW63EzDfxO/YtoYp8eClS6/+aJJTAie+Qf1o+k6Lou6aU4Dzcfpw1S1xYrghHrjr3jimwB9a8M36PAUFJjSeU078o4CN5pT6ukuR0tNKPlggDe5jD30yfu2dr473vO29sfcMpwHcuy4uXN0azx6ckN79lI/3G3Q9aFHML3FXpZevdighF2nFH37e0vjqN44mvPBekLYLe5nUMM/4pIiYrsV6YG3jwCa9JZ3BBO4mh1VeLR+nPgNKHU4axVYy2XKjsg0TkAHMIHnpIBL/E47iYKDeHG+cHxJMpbyx8Sdjun9zOj5Es+dEyPOENtcxCfWAT2wrV3RuhSLmR48cij969++LW38qfv7Nv65qmCqg5rmfINVAtewNPHW38qau2LhCXPIldhgIqnynr2rN1WxDsRFTmtiPP/l4fOaf/jGefmqbothqg+RRD+7bp9ySQecb5ZRyhMJ7GRVChxXt5ovf4YV3d3fFj7xclUrVT6uWr1BtAp10KAJ/WnkEp+RknNF8QOJ02cDiWCq5v5UrV+o0ChUUHN4GJyCiGNOgfkmZTvWxblmdXCO5+N6Pfzre/Wd/H4MHJJVtsFAGfy5QdlttfX3t/M/c32t/KO8pf/e1yjVJ/FSyZiy+rPbR2T7Nvfnbv3TjBoC5ZKC6RI9RBdBoVcRBINl6qVI9MQCgPLDtnPqVhYyoAgVKkBz9wnui+/HbzeOmGivKJy3SCOckgwJA/Ura2XjhhVG3bHP8y3BX/LdbrohvPHM4Vut0bmj7F+PRO78k2tB56tcOn3K7wBQOO3NRc488sXbVFugVEF+3fHGsWNIv2cpuFVVrV/+3Wl/eTAIcfOMaTlYmY7+cxaM6jrznG/dv/ZsPfeTWR++448B3nGTfAy9q3khKJ67S95Oyi6rC9O9/fd8D86trOuYFrJbhrcn/MadzP9NXxkVt5iqQmr8lEC7ghTWGXa344hkfyAWZW9DsJsTHMumuCsZmVJekFsAa/DmAClxTkm4wnJWBT5A0u4a96ZYx9ST1esyIefV0vN8s4NLIpDAURwTjaZxRgGrtefPZfUGDP/3ooCgPWvULDk32lfcIedATOs9ukmMxSQRYRqpJ3iyLb0ac4W86sqy1TsD8ntsFhIf9HBhs+mJg3SXRr6iIi2j4IblBPin9CsWgkc1EUY5pectjqLLos2TqzxcNwkk9ikpXjOGTe7epErEKUUjTtAKOHA8nOJ0T8dUtTsrYs+m1diyIBkXZ4cfznOOqzHli3zZHmxavu8zcuCwNWb7szSXrtUqKPHNcMluKCrQuULINRpwEJEWcvMn6aJYKj0rokorNpKL+bCCNorLMk4JMRQWojrA9fB76nFt5GpCmycWg2Nw9O0pimZ2P7AHPBjZzxtJNLrO6UFPcr3op1aar8eU9CUJd8ISpwCeLo1BY5RnUx5FkHvDuAjiscuJr5Vw0TCES5zEZefEAACAASURBVP7hI3knorozisQ8fe8XdTI75Pc0t3fH2stvdGGPc6wLjTF6wt3TQ3GdIt/dTafiG/ulIbw2kz+fFTAfEcUAOg/aINxvQsC1V9HwoSGBTyHbDWvOmIMPUHHAyTQAAb9WgWsBuTx1T+A0DVXDPW0ClTYh7V3an6eoEKoHmYIGoAfu6tTfUOoUmoTXy7vhbJMrYhUdFJU0kA3Qn0w7OSuNc9RNoKTAx86NvbVda518A4FOFx6S3CORTkA7zlkqrKhfRGVhDTaKXpH2gl6dti46KwWHFZrEhIt+EA0nQpsCr2iso/RHQHi+NllhEWkCK/FT70FKtFFBm3pFmUnWnCK5U88BmJ0P0PbEU3Jb+5TWWoNAvYlnotooYq4I8bgizGMC/rQHiovfDri1r5qOmwsKcVStf12QSnMApZ5GodZWg25x2Js0Hvq5vWVaoDq/e0RHItI7qfXSKOeBoMKInBSciUmp3wyrP0caVkbjwMXxzLZnY/fOPaafpehJ2ijmJpHXc/OkAiF61IyAXJPW9rSAjURMIo5/I97y+z8TH3zLu2PbqTzpOUfCY2IR8/mJxp21xCLVMzmYQ4c7des56XzhtR3x5A6pwBDgqKgmmC7b7JzzOF9OlCtKHD7dyRXhPraNxClkXtiOe/l4IQGefVZWIkYsM1cNJW6ANrodeb3duQJqn+bBWSUaIxfYQJEi2UqSdg8sf0WMta3ItejoOPuM5pwBLZQMLowN0TzT622KSvb29HjtU9gI2cFjRwXM/8//Frf+VLz27b8XLUokzBAP1yz2B0uia2xc1h3Pv2azKQZcerZAzBzbaUvw7V/FQnjT41SZE91tKnjzjnf9djx474NuI8B8giMqeowjI07p1IYbb7oxvnrPPZpb9bFqxfJ43s03xSWbL4/e/kVxRqclDz+5Nfbt3O3xXKpExAs3boyNF1yoSLrAqvdckqR1gqn9q80yfRlcykB2OlD5c9pWJtqovPQPfeof4n/94Qfj6K7d+UA1AJ794Yex58PAGUTMvm/Or7XP2b5WfcM1MGA0QUYJ9a6B7wDM5zoBc6/PfSWNaGAujrnC2jI+0kwVdQeHbt70cDSPHY76M/vj9JFjEVcoqNvL+xThAJhjW2//o4g7/1ZCCiuiaWBNPOfG50XX0pXaG3fHTTddHw888Ui8aMuW+PKemXhiulPOzlAsnz8RC+on4vb3vz3mSdZ23YVXyMYLmHMiqn6oVwCG3Cr3tSLu11ywIl5w3UWxqI+oOtr/s0Eh975pVcgyT8WgHITPPPhg/M2HPxTbvnLv3Sd37fwhvSX1k79HvzRfUIhBkJ5ouQby3//6gQDmrS3t78mUjATOCV8UrZFBTWWO/PLfDTps5b2gMg6SX2VdJjBN81sAO29iAVVxuARhs8d2hVrAxmlDztExEXnkzdj50ciVocRzJYoKyGJ7M9VDXxVKKm2xrfb2lzuB22fDnUEV2wL+SdtZa2MmMyaoMvZlIy0IK4FJ+UDNMhRQxd8Airo+3PoM4pjXZYAyIaB5TiRfc8zxiqmcUq7mNhTAT689roj5pCLmvp4X4EwsXn1BLFa1zHmc6bORuZ94diKJ0H5S2cDRcamZjKkIAx40xSYyoU7tMMBNEHt051PR3rsommV0KcjM/c/qXkicZc8l53O+Fvypg7uUjKm269y+HSCPQSY6KMLt8T1PO5lswbI1hXKSB3DeVz0wcEsThOJkjR07KGdBvLiuHt8Dz34+4JyjY/1OlcoGov7aHMalPMKm3QQYpZAEGyXHpLV5WOTRyuzLvqiSiipmdG4olVHPjR2lCGJ0xZks1yszqfDty7ZaHE2fBBTQbifP0z8BXroC6WhWAMznNnYS2JiTR+4v/VvtPU42K6/xhpS9zPE8J772U1/9gihNmgd6V6s4pKsvu9HFqc5KqeisHK86JXvVT5+OqxdJ/qp9JJ4+0K0yy+KYDyyNHY9KLlHSlFZB8fAKQAjMdgmYnzytFwRONqzUnCyRckAyFTfnC4i2SmZuVMmdlbAATzct4IdcYdX4cUXfu8QDn0C9RfMm6Z7iIGu/Us5uLgTdxtBJABZ+e5ZAT0DqYjIeBYFKKCS6JzrggqUe+zZF7e0U6TNU3STJc0ZgdwbOuO5HMiYR6tYW9ZXuCxj0qRBzSI1Bxxx61zy1mROqKSV2ZgIe65UotCg3kjlESu+sItxQWc7omVoF8Kf0rGiNMw4kOlr5REYQlRXB0OS2kuCrH9skJTgh7voYNBoBd05nqD4+ee7/I+894D2/ynLftWf3XmaX6SUzkxCSkAopmE4/SlG8ekRAAZVzjChcQc7x4NWDeq8fpYt6rueDeABBqpBCEiAFUkiZlCkpU5KZTKa33Xu5z/d51/r/d4J6sH2uJP/JP3vvf/n9Vn3Xs571vO/bJFASzockNaKNyFBZp86g5kuks3fUBV0PzT0ae1hwNiwA9VZp5nskOyFOO5uPJsUSb82hG7tbyG66JB2SXAHnzZPDje7Tk4rDfnI0osKsO+9iOe01pofu+p6jkWADPe44GVRd+Z1IerWKzNQgYD5JRAnGqJjYRoH/1vFH0jUfe1+6+w8+ku47MJQmiNijt8e1i2NjNTkhdl4giPpgm2l54iw36uSrQYB9cvhIOuf0Jskg8C2JqCTGXgwNMpypTbzltaEmA2iAbpM9tI+JlHCeL1GPYh4zrrAAyI8AvGwuslXWdUNnG+PPm278Gewcx+aUqY814qfaakl32jx/sdILttpWxiY9HD1DakLR8tY+rzdE6Vixco02wJtMenDiNCM7eEIRMD7xkQ970/bzv/HfVTzAE9cJ2QpXWd0r571TVyvRjCQjZuXDVvn9in3Ia1U2F8/+UZaJyiYeckPPMSUP+MYN16Vv3/RtO47fePO3JHMZ9byH0V6rDM8/80YlA9Ip2zKdfDYKBA7q/eMn5cwouRyna71iYdetWaP07ZvSSmmTm8WMUzaAICAc/bulKhmkV+Q17v040aB7pomXLoBIjG0SGH3l2uvTx//fv1Y24kerpphy81c+wYr4l+6hapUhasrAKa9WAHbGH2UdNk2vzYjGX1ohYJ7lpmFww+5WNwT8vcgQ5zjmqVOnxx3LFIO9Pp2ZtqTeuunUrdCf7cqUOSp93mdueDhN/uRHNOlVRq2rziyLLXn4+rRhaHcaX7cxvbhvQFFsutP02HTatHaF5KoN6eiSzvT4sLLgKpnbpGKi93K6NDeZxg9uSdu//LHUKnZg9SmnSVEjey72fonWu1qeOs5rk40//4Ub07kvOkXOo+2OugaEmlEAhVFteo7phOawnEePHT6U9ux7Ou2Vg+2e3bvTpE5aZ6dnPnX86b1v/weG0r+blzWOFLM5Xa7nbo237/+wBXvuR2URY97U0vIxj1+Dj+ojcxnB8WWrEJ8A1IS1rYBy/Y2xKXOpMJKhr/UsrMyNPFM8Y+K6cW8zMswkdn8ksdCvGIMF6C1AM17ITmQTTAPf5XtOd5GNaGT3zNfNm4coa0DhYGxi81Fej/tnMqZSlgLcsrH35K4yrQHGyiSPNuE/mxZAPYyGFnH0jdMynDhlEnIKqYaoz7AVgeRcF/7mO9sEyKbGAphHrNsFJaw41c6fdqohgolBi2/utnI8W/2z8ydphOX8iVaNkFs4TM4KdTXIgcW9oK8c2r01tXUt08kdjDnXfOZ0COlHMC6HBeKnRKG2KdNdlwA4sWzNdmpBHhMDjo69qbVHgmdl7IwGye5eaLZBhbQ5LS7wc2SvjE5XapYmzhsrorLoOnVOfhTOTQ26HkfUUxODcZSnDQUo0Rpzb9pyX+djazf3orEYEJl65s1LkY6weHiRDN7aJxt5UxLxogNix2aS7zq2iAFUZPws/Hs4NuPAmUN/VMaue3HRWOOIPwC7apvjfZelhzs6FrTXI32CREtuJn1W0qdtt2ocSJbEstehDdSasy+1syKyxmmlpW4Uq9MwN57WKxIK4f6GpPs+U8xKtxIMEcd8Qg7Egs5+DxnYtMBplxIRnVRSIVDZaaeo7XXcCmBlLsyI4a0DJEoqQb4ZSwMomt6bIt+8NyfMcQGBkRot5DWScdA1ajUxrTNii7vEmOtgSNcEOBHCjrjg0vZai87182ZbrHWEHFQ6e2k+yLRd2phNX7M048whnC/RLzeIMZ8Ro+75rjabUl3gxJtbNce0Hmv9slTA4eBwHlX4xAXVZ14afNjSWYFnDBNOgvQq16VMOFRFSNh5O6G2SsoyIS0+GwpO5wDGtAAh9nDm9NmDmyJirre3Tuh1RRFCns3cJHa5mGsKPybZTWys4x4NDaF1pr8B6QByveroNK3Sd2n74lB/bE4V+ELXRhcdQNIh42AgaW/d45AcfQ+fXJIGBdAHJ3QiR9uorAuKp04iE2KXH9y3VyHtdoRtcB/jEk0dwoHc4VwVdq4ZYC7pWIscyRY0FyXCSQOz29Ob/+QPU7rtO+mWB76Zth+cTsOTDc7xIhWU0toThlOsMqcWIhp65UTet2yljtV1hK8O2XLPzen80wT+xmk009smCJh7MdVi7cAGSKHszZIT/Xg+QnzqHaLlmBrPqB5KIdvpMLwhJ8HEGNjSnrYzHMxUWVtH10GWxIXVPvWtijYzujE9MiM/M1h3jSnkJHGqymYlOmmOieb5HNIa31Ia7DadXl1w0Y9pjHV6vEEuDA8Pp4/+yR+lM866OJ139WsrAJ++b1L/XnLm2rRBzp2hH8amQDKEJagmhsn1yLOOH9XEZn5x0foZ9Xw2QEfi8sjj29PXr/16+vLn/jade8bp6eUve3lavXGj/YNGxKQ/LGZ8j9hrwkIu6+lOZ4oZP+tFinWvzb9tJ5tI1ZfTXU5FWH/jNDI2AX7azEUZXA6NsUnZkpMC4qMilZ7afzBddclFshuT6c67707v/4MPp8cfejh/f3Fdwu7aicRhlLhYvqg2PT/w8Hthv6sfZt3VoJzFEGgd6pcPocu2aFHz9/KFMyaI7+szgHlrzAXMOwfSz1/clc5uPRibaEIJa04ckf7vzz5/Sxr+Dx+WDkmfx27gRK0uXD15KPWP7U5LNf7r9dnT+rUBO/Pc9JcPPZXuPTytDXdzWq9TL1EO6YTaf9/xw2lA83vmga+l41vvcilw+PSiRdnyhm4W/ytNODaNHjf2RQmyw5Fb8L/SxyPClWR4GsONIrVam5vHmurqr/m7a2/49A824L+/VzSOYPTVcekbGmeKefnDPZ7zjPmLkbIoXGIwGnkwG5gwUADLDPzY2fNg/MQym4HponYMw1k4xMIwx88y32JiZ0Yilp24WtkUAKj0GY7bWUw48sPBho/ZgREGpIzivPM2RssAylxMrktxLA3cVp2oxouL53d+K05FC7DHUPpCVRuweLL79VK3DGJoKtqINYAbcMwrw0wmzllJCQzMcaC0ZjraJHBZLEgEZ9t6+00Kh6dMoSwY6B/0GFi3Ka3Y8ALVnfTeeQJ70YiF3glD9DsxdufkaDouRtWxZDVZ58Ti1Ag5NCiRSCxESbFTtwrstKQehVIj3jSYVxgmeSkyANM1s6E4+tSTYsvFKsHk9aFJ131g0AT8RsaGgHTKNrlGOX8EUPQZ3uMzMPE+baEt9D+Y+qEDe5Wco09Aqs11nxezgjTD8Wr19wztpfaxM9rEkI0Sx3oU0EwNgM/HEW41g6zg483XVEaitxVuGAsafJQezFV0ZoyFImKKTkADW2XNHWU/3yNfl8tVGj9OlxhCcc3cl75nmUV0jk4CAOe0KThULxGSLY7HY765nLD4gCccjNRBc6Kdt95yo8BlgIM2OcuuO/elBvBT8iqck2Nsi5JW1M+NplWds6lNoGxU4GzTBgFzhaLcvfWhNE7qbsLTISnRIjwtJri7bTINyvEIFvWM9QqfhmyGAaE+m0ZzrQWkUQMBEOqoeLnqxKu2LQBI6fWREW0WCKuozYAT+DjdPTplsbmSt7hdVNZ6nOp0DRxPfQKX6+yEkIwJNuACyHbuRKZiQCRmX9fBCbRRDofou3FixbnTB+YCVyQVYtPTJIYbcNQkCYqPc3UNgHzPUoWFmxSggJlW2xCRhSrAlJI+05tCMeW1AstzahfKO6nNR2uzIrCoHehRTsUZcpScUJAsiTiXuuf1JzpQkjFNivEnzCRzzZsctSWs8JQkLvNIIjw2ZiVLQRrDqRSg35HeNfYBPZGkiVCh0/o+Drn8bRlN7pdxOZcOSy4zqrjx8tuVTEa6djsXqvzEdXY0k5iwL7zwEm9utymh0KR2SR5j2U5SEpqecWZ7oVCqtToynxYD1yogRki4Ojlvto/fn97yxx+U7GFZuvuPfy5tPVGfjmkzRkIq2p6wkcsGTkl9yipKOL16lWVGwIj3ZhSD88md96XT1qstVW4GPe1LXHjkiOXktESccj4MjSGkSwbr/AAU0Ql2AQuAZpsOeGdcei5SEXTf2CoAfDDQtIltlGqKEyzjLnLQqE/06uaZl6Qj83I+Z9qZ+IhxZydProHN1ddmLZ8kbCNylmDU50SuNKm9zr/oMuuIaUdOeCbEXv7Fn34kvfINb0u9qzb4ujjtrR3oTKevXy7HvNbw+XGEl2qMap8M5Pt7qSnrYlmrFi0/FeP2j/ziEwaNhf0H96edOx7TycpMOiT29MDBg9LBH6Hj09qVK9M6ZV5eI3a8r39A4zYyTdZr/JKVGnDHz9D8x82KZrzYgwhxSLZeMokSwR89vyRpYudpq3se3pYuOPOF6YRO7a771nfSh//srxXCdVtcr2Km3QEh5alIM8J2xomJTZ8fzkzMkd6izUAsUtilOEHxZK3TWtG7IdinyurKr9W1IQYT184X1zpoYC7GvEbA/JqXD6TV6Sk7tHJf5EuH5AD7ib++MY285kM4CAiIYAA4CV1IZ9QMpsukbmnWQGzo7E33HZlL2xTXv0V16JPdqiMuvoi5EW1+58S894mcWJFOpB23fz7NKHoK7caz+Bo0ShXgvtB4bFJo1nhftlSvtaMr5yRDZSIaC2MKZ0+vJIz5+rqHW+ubfupX3vW+3T/MePn/+zMaQ2tVhh/T8ymN/e/9U8rznAfmaMzNmIdGIIBFHrMBaKvNZTbRUKhAyr+/KRdPi0hfXp3k+SaLJk71BmbE+KiMNIaRTJ+s5nMa1M6KRjgpHzV6eQnG28AvjCsLbtl4Zs1DrKwZPnkzUcBsKXqpa/67OCZl7jSQpQsV9woQl7GhvxMbAS8wGFLaEXClSR3gjsQWxOWW05aOq2D9yVxJevv4Ngt9tA9H71u+e5MXSq4RTLrCJW48XXKWTaGz9r9wgoy9DCxhsE2kUJ4WaJuUlIWJjlMIGlm0Z00tHc4IR3Sbo0/tSif3PmFGnd4hdB11pOi+kt3CY7FDO9ygRWhm8JgjudQSx1k3nlSdGtq60+TgUYHELt2b41ukCLoWi6euVK8F1zESZD8FjdL40aNpxTkXiaSQrIZ7yagvkPmThUD11fGbdfJOOz82aONI5k8kAT4edoPRCaG1D8Uzr+a+NzOYHcmsQyp9Fh0WyaZi6DlTYAz4yhXi2nnIlL7NYCbgQcisSmxqvmj2MV/FMfbzLePjEe0lFn/f1ACctqWtWbx9R3SgtAfg0tKJibT91hskm5RMQO3fKsYcKQtjf1p0NrrWptbOVD87mta2T6cLV6a07agYsDXrBcyV+XPrgzrK1sZGTFJh3aYFTHoUL3xQznw1JIbZKMc9hU2kUIBCdOTNkkzAsE+I9WZD6ZZlf5k15IzJGrHXxCpvF/s+ISdRNoBoqckaqP2bgBnghjoGM0wYREIR4oiXX87sT5wmjAvc12qRA1R71CgsYXcPWuAZl2VaANq6ZXcAdiEyiiLJIOsk7QugRO9L9k8SJfX1imEXYGaKwUwTcATnVgT1sOR2K3XGSH0+PEYFMpQGXdIUNgCE9iOVdj27VeqmTqLsxCafEUPapHlGNIrOTjlaT6nSlvIytjhS975b1xKYVfQ2gDk6/pZmyfF0jSmBatqHsiKDmVU0Gub1lNjvKZWRSDVE8PC9dOMJwjRqYzCNZM22hf8y068/acXAIfNpQBvttae+QCnin0iHFKEjNsbZH0IfYiPrk0ZnMuI0TzIxFRbiA6xBe7aKpe+Yfji97f/5XSV3605bP/KO9PDJBjkEKrSlpEviDJwU6tTTL7aTLam/IR088zSuRkePpWPHD0i6EZuSMG1sCGLrbPDrzShlzmsNMifVLUgg2jLkRZXoYNbql0AN8Z3QpitbpW1itHPs18PfxFIxn0hpc6Y6PT23Oj08e64i0USEJzPVGXCX64XeG3scq0hhhWMjT9+KXJGz3SkvOFcEgnxhVHeSxw0dP5a+883r0+vf/GuSlXWKvVySzj5NpwjytkYOFQl31B6ESnXCIoA+YyoY6io4L7IW1sFY02we8s9nlocl4lmAU5/F6RAw97377k1f+sqXE24YLzh1U7rgPOU7UN4KfwM5KBtnjfEW1Qc/qJCQZkuar1th5OnDDMZnNZiHRkesH+9TqEVCKdIhsTyymUxp647d6YyN69NehZG87a570p/8jy+kPY8qAl6FDXNHaVMnR0mB+QYxwJGoDnCpEzNOTfV7rEuw8XPpkKJMmbiwGYjx6+sxubIFl15TAHt1fCbb9qhwbqfCNi16qRIusUubNQHzX7xc8cxrnlaQAhFOinoypMg3exU3/m++9J00+rqPilmHMVe5ZJPolhXz4+miNR3p7qfH0pBCca8TWdCN74VOVwa1MT6gpHq9ql+XxmrdzGjqVv1e0Daa+uZ0emw7I4At+4W1JekXTrUhp4o6lGRLPs3IMquSMAqpLKfynKSr7/74Xe/6rfflyv+7/6HxRA3foKc6LX1d4y9nz/jhiv68AOaNispSeL7SLGX37VTuHiJhJADl8RuGNBsOG7HymQCoWTAQB46BPqrfq7R9RrpMaIw0R/robDlwtR4ShhRNlZLNYEykTzaINdNhG+w5h2wh2EtuEwYtjEzMTwPyDK4dHcCGxngos0mlHHm98J/VDUqZ4zGfYTc1EYouMtfMphvgwnUB5vyuQtSKoZtS+Uk93yhgDhWHPtOF4L/Kzkf3E7O9RVKWWfKb8wnqqoot2/DCtEJJK+JIESCBFYw42AaojlVLFBYBFGX9nFCCHlgPFi+y+zF5G+S0FFpmXRhHOsI7wZzR1pTDLGQA2zj+1qIn9nBGu/wJnaGTWr1JTLfcuVKtDA51qm1sd2KRZoH+BWL+UlwBKoNLQCZsCp2CwxsAXP3Zf+qZXqhorzkSXuBQl5l8pC1LiL2uBW9ascy9uSABhFj9YFUYI17eo08jbpV/A4BY3+++lRFzEwVbWPTewZbGkakX8qhy/G3pSvS/X2KhcOHjEeafcVZiaCw6LdF3vQXx2CqLQIxDru/QZfzONdhwlX73EKjOi2CvAcmT6bHbbzAIh+1vW6o4xxdcCdLVXBBY1/v1zW0a/6My+uPp/a+YSn9zb0taKqejzuVKKCPGfALGnKGiGNnMRzZv6JaPD6mPBaDO2iTJE3HICbWo8QDb2SqtN2wvcpRgDqkXZcrAlvKrLmMCZl0dAmHjMIMBXJfAcMvpck7A3PVES6w6w1SjSQfow5RHKDAPCY13wKm+K3Z4TuwqzCkb3C7JZOYcA5tsn3yPzUM4cBpkO+hEMPzIb5CdsGjDbFOWfunuF3RPuoMTg2mB7QWSEgHS9JpxKfHL+Z0Qi/pJ2MPOZo13ZFp6v0FlIfhCtIGO9jW3JgmbSDIas+nyregRKFVUFsMFAKH+Ee8cUElZ2eAg1+Hgg/mDLn5cTD5xQiZIrqQnP9FwTwqgc1+uD5seiWA0nz3mKIaFVTH/ubwlFsHkWjaoNjj74kttE7bc/T1H/3EAt8xYsyG006kBZkjC6uXr4kN2xTGHcOR0p1HjpT89kX7pg+9Ldcoku//Lf57u2Hyfy42EaEShNCfkTIujK5FYYnJw1M584dqcDihCi+Q52eS6TyvyErWBD7/yPPNo8STR9zNrHvKUcLI28MJuMRy9sYgkZkRsmiMKRz59cjsgkfIGPLT7Dr8p2/Hgwvnp8EKEhvXJGeA4/x6nWUVjHmVx5K8MTgtwZpyTkh1yoq17haP0zMp+zeAPorT1x+Uc+Pqfv0ZRjVrS+pVLdfqiPBLICwhbyyaPUxDd12nWLWmJJ2bNZcllsP+F2yO/vmiNoM8IaQphUTkh9PhkPLirFVlnJHXK1nNasmPHDm0eOyM2tu5NCne04oA/rmHZTrZqfJ+TMbd9Xqm5LveckLf3mCK0UEY2rDDjZse9zmJoY45EXg05pD75tOJtr0y7n3oi3bN5a/rvf/63af+uPXnR9eCOcWNjkDX9ulaDbBrhANlY0CaxTjB/ZyWLQjY2FVlPsQVcAw2ZTxV5TT/lM6FkDhUc7kYsmxfPmbjt4vU8gHmfvhca8yvPW5c++MYzHf1qSNGvKOKDStD1oc/ckE5eKdwLS6C5TLIsytYu+0IAgw4ZpbXtjdpET6fjWi8hM5bo99mTh9Pk4afT+tPPk/O9EjUpIs8pDUdT/9xujfdIilZOz2k/b1r1mk9XGRzMbRUCWYsdnvmMT2Ri7dM6u0fr7c9ec81778m1+5H4oXorRWs6V88dqv99/9RCP/eBuTJ/NjVmjXmZkMw1D+Bw7CikcRnTsfQW0xqjvaLDY5JW5oNHV3YE5HIFrmc0lK9REmnE5I6FqCBrnHxmBFAA5rU6tnFs2UWAqfJ5lzmzzP69lDLKyXjP0C4WZqODMhyCHTHI9b0BNLEYVB5lUnui5zcCaeXWkEFnNtEWFUATrN0MExXHKsIvORY7DAVrQBSg/JxXeumt373ZyYh4ACpYSsn8uWLDqb5Pcar1ffw/jJI+p/ICxqcFzDlOxhDX5YyZsJaw3pFFT0+AN0CUsmfDUAujlkGtF38aQUB5bHRC2Y4HU5uMCrpmS2zhYwAAIABJREFU9MMsiJxijE7KOU31a1PYLdgK+iZAA9dGdhCsVbQ1v3v11z3Dm39Ox9/IVtDyOfkOpwyw+jK409LJ47mIxnzBcptYRGKDFQAxeiwY0NCjqg4YRIPgYAjtEpblJa4/YzqHU6wkEzKLHQxucO/hIEpbZ+5MdyhhEKOOwbwHOHIf6tNW12cAnhXqATh8NBv/vIEExKmNWKDdn7l8Nsiw0wLej99xo8LSyclT3+noXRHAXO03IbS3oCg/9fK0hDFfrcggpyxV2D6FJOxasVpRWRTHfOsWRWdQgiGVr87Jl8S4EpWlY1b6ZJV3alZZ5NhwhfaYRCQzYmyJ/kHymwmBVAC6hwF1pa+8i+GsQsBcYLJT4b5GBdDz3tEtVyd6bkGOmbRfZPkkggvykphPZgzFR1siQjhD0Z0zYsQZppb0UhaN1d5+scVcWx8EqAJqGBMzlkwgp4hx0EK4RF3HOno29PpzWp9f1g9zH+NhicMlIjEBAwCJiWdOdjw2BBGOER3ymD7TLmDOeOGeOhjScbEv4bEWv+DrKPsjJp252YsDrDKuzji0YzC1JBhCzjKlz3H6PiOgPilQi6xoaqZBAFxAXKB2XF6i4wLjnEgx8mY9+ULLT2HzMPc8cj0MRtQeGqdc35bDYzBszio5n61YJ5Zy52Pp8IHIIeLNqa9VNvRYLkgQwD11jEhNhNerw1FYzHKj7te18FT65d+7JtXpmuN33p1uufZTCgOpyDTaxEyO8zNL9ZB/eRMSwNZPOanWE8kGZ2Fmj8a+nTs9UMIe2pfJE4t+xPaSlEY/kVZpk1bSiFU2ue61cLamUmEvDRsdQcVMKuOLChvg6y2d0OxL69KO2rN02hBh6PyP9ciAL4N0s+oBRRcn/nHzZvsMiG1Vll3YYcLhzSmaDcyxndRla2//1nVp9dqN6eU/8bPRf57jsdo4JjqsOfZZMgWkCo0Cd81yxGzR6SDh8GDV2fg1sLaZYS8h8yIWu8Mpqmr4Xd23dXu65JwXVcqWjY/tVrk3fUv9ZrXmjAhQ46iKM2YA8Vifys8K665iUycaghowB0ZEvhw/cTx1KbRin3wXyverZJIvY7ttqxnDKj2x/0BapxCLjz+5Iz2w5bH03z7++XRkb85rozVOIUdCK5bbKG4oXyOVr1Na94j3Lxui9ydU5yHVYV6ymbhBvOcb4cFMWCUesyJc6zIw54KuY6wV8Z1FP6Py0V4A8zYBcxjz9v60as1A+v13vDht374tPbprX3p6oS0daFqWBud7lHFUYRSJuckmwJYceZ7suMrQiz+Q5u+41u5laq/x4WPp4EO3ptktd6amDZelnte+Xe2prNeq9s/2D6fTandpTov80ne8oUGW5aUkMFApc0lW5Db2BjeciuOEoeaTY2ML733Pe97j7BE/Kg/VA2YStpye/prGU+7EH74Gz3lg/mIB89bG1o8FCxsSEac0L0egxjIZoBSAlQd6wbceTB5JsWAUZ+tgqrMh9icCmmRxS8wNfb7sEgMS5WuhmzazIRwhYAvIbNSx27wX9wDQPvpkQc7zkHGdSZeYdFw/Y2gGdYQfrM7ZUpooR0zUIlMpANCLR8abYXLjuhXZDWsFTm7FuLtgJZpAfHxWDDYJPJwsBxZY7HIF0FlnGNdbEDrZdsdNjoLiiccxpy6x+owXp16xobFQRSnC7uQJDMpADoJzoI4YpxWzrgBzJradPxULO6xugDHY1DjZi04AlPp1bypCvwqzOq04cuOKkCKnEmdh5fvs3tHLzTO/9LlmMTS1EnIafMFkuVvCSjsBkV5HO2zgrv4zOEV2AjWLnEV9S62cWRIHVr2Gxhyfglq12byd7VSm3B4GAnkOR4SgDKg9LoNpK3DZmNvAF0QQ9fUoNViJDUrZaHkMGygIDPJ+XM2bTq4YxrBk7Czfd2/4mtE7GM7QlXu0ZADiDRxJbrgmDmmhQ/KD+RIhmgOYzkqq8ugdN6RJMTZ8vV0a81NecpU3C2NaoOjj5u7OVDc9nFYo1OCA2GsY1q5l61L3ilXpqe2KYy5dpIG5wCiwEafCpUoAc1A5OEDKF5whFkwOj8wXS1kEJNsVl5sQdrC4rjddyGmUN1IBRnF8nFS4vFY5Xk4qPB/Az1yu+hUGm4gpDbDl6Gn1zhSSDSKgAIaIkkGUGhWBkyRkT94EwCYLsLqNxL72LhOYHw9ASSSWRh3/IrUBkE4L6OKoimFokUac4YvMEikN7TupzywbIMlW9Iimm8F02CacXTnt4vNMXPTxlE0RR7RJaWmR86Pm0awkPiJGrfPGNsGOO9OjyjwuSUeTZVtkHFX5dJ8JmHqkNCoL8pTpKSUZggknBbyiuSBPmdZNJ4hxrs8iq5nRdYMgiEXZpoyWxEkyRxHhfeYUEWZs22g3+stDpcKZ2g/nvJdeps3IlCKxfDdOGg3kq8wC5Y1RnIE9+lnNWUDxjDKqAjaanRVUWGVmT/qFD/xi6lx3etr16U+khwSwaHtAOfhontM1Xds2jxjzHpm0Nj4NVInRg/9CjCNYYKa+530e82aiPW/CSRxxmqOy0DlEoDGTWjYovE5b6V7YmDhu8V2xYT5l1U82odRzpLY37Wq9NI3X9cY81BOG3ZtyFzCcuh2FJY6v/PTyRrn8ZwB3JCi0L7I/n3SKqcTRGRA7q83ikE6mrv/SZ9JVL3tNuuTqV3nDZzPj+Y+NgPSnLVR/dSgMc9Fo2z5QBs0dgHm74lV3tzcrFGmTNokC001i6M1wa83AyU9lxSYXtjovBV41wdTDAn7Hmfe699p++fJIclXqkUtVBeXuB2xddAg2D9tC9lA2OpAG3LtFNj8yGPvjfiwmlIr/AvbH9VL/7Tt0OK0a6EvbdzySNm99LH3go59Lx59WGG0fpXMeVBkEZsfbdbpgeSyZnXUqPqZjtBmNIQgbymOb7ROFjLPBJhxHEYceB49SOFjkTun68hrs+y0qdyl/rnF8z8BcGvOuHMdcYYGXKMNZe/9S9UerALliDXqi6mEtHpMSwwhboc3EiMLSah1ThFetgdqUH9uXJnY+kCYP7kkLI8pDoQRF6y94VRo/+1XpsDLmQhT82kZJCWse0RoceJrT5RLBp8hUQjoU85/fTVrlUxadMm/WWHj7O9/5fz5cbcwfnd9UnwtU2tP03KKxtPWfU/LnQVSWV79FIa4+HksXqqcAarYknoWAiJhTPALMRKgz/+2nYU98FxONgQ3rZFAf3y2fD2BoM5gBfwAT39SlsPFiNyyDBONAlBIWzEaALQbKRjwuWbYEAaoKWCqF5XIY2PzZ/CXu4qrFrsHlzDx9XDNbgGLUfQ8Xf9F1ecE6HeqRrwiwZ5HQe+jFiggIBhs2vAkjh/FxFJIw3D6CzWXBuWj7d28MZ1dvCGJxWHfGhQpJSFShaotHmXObIvth0gJqxZiTYIjfcQKDZZ0Vw+pIGWK1YWU4EiORCg/LT3LvmNGGfaJK+km2twklF5oZU1SWrjYn+wHkYiznZIy8yAoEEH6rUeGdarRw0ffhLMQCG8uwN1c69SAOrjQY0K5hL8XIcJRJe/A9Z8dDJyBjOztxUsfASkEvZyuHiXRfxVij7l4sAqrkVskbPx+nxrjgK9FtpCUOdi64sgIRgn0rsid/E9LIazesdlmE4l4lbGJZzCqbNxcpTk5cNvdn+V+AC+aMtzzcQteui8wybvnYNkRfAnpISPXYbd8UuJzwtUgEdepLXubNHMmBkBG1ib2rXRhMy5Vk5qwVCp83JOfL5atTr1hzMn+ODioGulhL2GAqCDDskfPnoSG1gNjk804fT6PSDHNXQC3a7g4AvgD8lEBy2bPxAW3DDMSKZhdAL3+2SoKhcOqDYY7oLgCNBlhlvahDFctP8lARCNcCo7EHg0hbWU6DA6mcV2u0W4Ro7VkmtlllLGnHGxrQbIYDp3XZOFvqXo0NaPB1Ei16ewZHPN2Pk+4V/YQmU8E58pUmHvAd0jzaIoAXmwI2SGyYYSknJqW3bQbYqZeIcS62vF7AnEGAPl4HDgaAE+NivwVg2QQ0S5M+M6HNACCNWOJ6jkmrPq4yjgqcj+o6k5LksDkBTM+YFQj76M2vxkEIdAKw4jDubLD+jzkdm9UyncyUYV88bIoVS2nTmS9SJs5laackTINHlF0XsEd9mYKMrjyWCe/mNlX/sAHrEgA8oc3CnORRTZw8ED8dydrCvvQL73tralsjYP6Fv0gPPLFdzLCAuDZi9CUbNU5BTOCwCS7gllKzuTZjzkkNZAj8d2bKqaNXmaivwTl2zKdYKptP9GJD5vCanru0dWyQGWZs8m2jXQf9anqVNUbv13ekwWVXpdHuszKzGDbUmu785NqObpVtr/Xk2c76ZCEDIG5tDW/eABGMgP6pU+hW/HUcAUhr1P6nn06f/vOPpje88WfThVdcLdsYOuhgovPWQ9/j1NJzjdNNyq1n+G7kDYvu3a64mX1drcro2G6ATmKZJsC5NwVqRyRAfF/PKXXEYSUBemTX7rRZ4VEff+yR9NRjj/t0tkvp2n/qZ34uXfOWN1u+UoB0jJtSrrDTOFlPIR0kIo/+7kb6kpn1mLXVx2KmvDDtldNe2kP1ZD+4/8ixtFwxt7c9/ki6+4Gt6ffFmJ84plDagTSzLVe/aY1a3deZ3vsfr1ayI0WZ0jw8rizTN29+PH39RkUsYU3Br4yxkhdxSzAZw/hhAfKLcfGk0TrRLklKZZ3O61Cpt+8f626URT/lw2QpS6cYcyKzCJg7pa/WHe/4CdGMBo9xR4gnxrXWUx0BaDc/kRpXrE89Cr194uDeNPXId1Pas0XX1/fWnS9DdFrqW/uCdH5vQ9qvGOlbn5JvkN5656nz6fT5rfqUNkEmQGP9niXzdR6LjA2v6fn1THIqmHrNf3nHO379U2r3WDB+xB6qq47X04/riV7371SP7DjwT6vI8wCYv+atSq0rjXn1QY+jxSbMGotsiW7CUABsYlzD5GSglE2QHQcDnWTGIBjYwj3yjkGbJ2e2Tv5uTJRgkSMuN45E3IsoLDPEbdYkBWiGXCKDbd/Jd8tIL36U7I5xJBSMt4tVECjfKaC6gFu+5woFuLcDm4d+LJR+eJ4Hs+JrVxot7sNqY52kjB0sV4Q3FJCVoyRAtgWNuT3eI0lAYM24iB1exVw9eps05vZ0ZzUKVmetgPlSAXPbVJfBVKY3OMRdn2ETgMZbBnVGbDmOmTh+4iyLUcG1MLKp0heueGyBcl3CUIXkz+yLyg9Y27/z4VTnmOITwdohj1F5yF4ILoBJwlu+qbUr9enYe2z4uBmTBh2bNkkvWAiLcTnAzOnUANkKcqRmHQnW4XQEAy9WnF7n4BumhvCLhHycGR80o1ero2OAuTd/KiDXD/RMWWNhp+HnfQTAuA3QwyiNxCT8DltW3aC5wdlEFYTN992fscWMHglnpArgpkd8xABwCJYwhleo1o0Xsq3np/ck1pyH/t+l9SaM0wqACoxgXqz9PSJTxPygrbbdeq2dHLlOc3d/OvWiV7jrZyZ1mqAkEnUaSw0zJ9PKjiVpXZecOhWuo3fVeunMV6UnlNRiVCG+asUo1RLdw0NyRkfSC+ngoAoqB7HzT5tyRk4W0zkSCAHcJXWZVtkmiWMOH6kCWcoJLs91Ita2wqs7QyhMuMeRY4yLydMmAdknbYgkBmkLGTWJ+GKZg0AfkgTAHEeyLOJk57Q/hiLocPrBvXqXaSMhBhsTgR1oEAiHkVsicC6yXt+BxVbccTThukCz2EazkioMUpeVA8Q/Z4yjE8eWoFXPQiVrWtgAAcx1XfuyiP2XUyYRaYhFjbRniQB9ZC8lKgLAmwhH85J2cQrPqZEkCS3aJI2KRdZ3J8WEE9GFEIaj+nscQK664JgOkHVCIYBxGSNMfphyj7nYzJdHyQobSdwylvLJYIwX/EEIj86jp7s3nXbued6IPbb5HjPOlkqZUQ4BFr5qzTpdWN49mVb1SAu7fCbt26+TiaU96Qt3SjuuTiOTaJuefdKGr2p9NF369l9KnWvOSTv/7lNpy44HHa5yQpFZprXpsPwmppuNRrFj2L4Mp70Rpp0ZQ2w2ymf8CY+l6F8PcOxtnj++pNo+tMexOebLRP8J842XBzr+AswFaMRKDi67PE0sPV9TDr+kkNYAZoljjnyEFPMFRJotB/RQqAzYoyrZNhpgyrkZAkJ2ENsHsAaoQw61KzMkrxPD/Mknd6c//+iH0s++6W0G5kjGeFSY5Nx/wZIXYB5rjGVrzC/bjwDmvSJA+vTsbm/R+JaWW5KXEzo5e/SRR9KuJ3YpmdEhM/XYkAnN6YnB0TQ0Nmln11bFDW2Vxp1Y5hOyEe/4hbenyy58cUhh3Hbcj1Ch05qXCqjA2NA6QcIgdOc8ni1TqQzKRb+ENGrReM1/+yRV9Tlw9HhapoyX98sO3ffQo+kP//TzafBEJD2Kh9qdxUbr04blXem33/oqxTw/qVCUrT4NuHnzzvTZr35H4z1ryfJX3IDMXxYfHE0wIBicqJwuKxDdpiRBi8F3WaRd3rx2VOqiMhD1q03aN+KYK4Rw0lqmaAYC5ZLb0CYkLpLTphZWbyQswYHsEAHWTp6SzuZ08q5vKAq3nFv71seT6616gY4wDiQxLOkF3a3p7Lf/evriAyNpWVttetOaqbRODtZ1YszZaISeXvPKPl+xYY1hn3GRuHf99ZHp6YYPvetd75LG80f3oXHzSpVeRxTp+6rf7n9uTZ7zUpaL0JgrXGIwv3nslnHuAR/Qxm/6hxFHfNAIJrPfTPuK3tajyglCanLUAz7q48j8iNsFgAeQVK6lN4iKMEVMa0yHDMfcuDJhEi8bbyzukUFt2IY4Go/f4r5+eFDnVwOFui6lCl43DPJyvfLXKIjBcn6rlCvT/s9kH0rdM+vuGnEPOz5mOYOBueaVJmCjduFkvgxQnjcA2YgYEMsJa9t3v2VnEh4RIjCltWcFMPdtXCXARTaO/I6BEpMDMJ8TMB9H+oODD6EZ0bSXGLHUjGuUrnadyx9xcYNKvTohlv9x6d1rm9X+AnJzzhJDWwX76Ag5qseMFgAA9CkXXJTG5OjS0tGrzHf94WQnYIlD6tDRg2lUWkWyA6LXrFcihdbefjt2FuPDCQM21yEfxRjT5/U61qwVw262OSi2zJzQBCFJcDsxTlhsvfkIkOufFUfR8HKvdHHsoPJGZ9GJil6bBxBkRj1+8r1YUGITFcf0fpjti/aKR3ULWjYlfs//y/dZNA5hR7hyxh6eK7xNFJ9t3/mG2VwiE5FJ8LSLX+nPTQuY12t8zCu0X93CROqvm0gXrp9OTxxpEChfL8nTygzMh7RpA1yGAyUsU2eTpCyKY14jyvm8TaShF+PrKGRECVkQU6fwZ1rnYMzZgIRjIZFI2BDhOEnCFh15a51qEzCfFrD3yQ+bCT1F7lm/7c2Hc2ExPnBshDmNdVPxFyyJQQ9MK6L/9lnbvE5HJGGYEZO9vF8hG3XKixSCTUMziYRwWNQw51qw52TwjMyXYs7ltOpNEuyfsjkuGxADKEdFxyLPLL5JBpWVqCuOeY3Tp95nY8A0I6RjPfaKPuFG9Kvqio3guJ2ERAtqyyFlTkW2g86d6TUqZ8hRacWJPDQq9nnEzpycSMXGqzrogsyIDWGxfdH7RZjl00Vsim1PBuGFXs02yfrw2Je7rOe89FIn5dp+5x2S2SojLHHRiazSNJu6tXHoVVjLnnYlhJLj77p+ZSsl/Irm1ffvHVSY07605cBA2nNIPiRdjQL58jOYnUjrah9NZ7z3q6l2cn966rpPpm1PbBZjrjjYip1OTPgZnUAA8Fx62YPMlXgge6hnOxW5ByBnYr6BQE3c6E+HB81zxwCcNxgQfFS/I9+AkcbWcU2H7yxzhQg/ao9paYqH+y9OI70v1vciE2XIUwowp68IBRg6b4dEZB5at+0GzKdAzM1C9iC7wxYxlggHSHKrcPqFOGggG6NOCOcB7DoFfWL3rvQ/PvGx9DNv+sV08ZUv1yYt8m+Efc9ckO1qMNQG4vRfBaiHbeBBMpulCscHOAeYEwrvxttuT9/86ufSy156YXrNT7wh7VCM8Ed3P5Ge3rcvNYrI6ent1elVm4gQyf5U72Vk8lRUrnvvf0jvrUjv+Pk3pf6lilHue8+nE9rAod3uVPZK8l747nnN/GFAebF0z/4ZJwjawGhcHFQ4ogGlkN+tjcQ373wg/eFH/1caGfaOPTqRtmfQ6P7r+zrSb77pavsqAOybBYi/u+2p9Jkvf8s2vjqB+GLeDbqB9Sfjg2d5GJgLFBftqceirWu+cV78qiNJBklkWUuX5Cv9Sv65QlGrspbdmYqFNzp0Pa1pTpZAmi3F6fep2pEDqXXVJp1ctqXD3/yUFkxd+5xX2dfKDio7xfjv0lN+HGtPPT392Fvelr7y8Eg6v78hXdT0dFo2tlXzgpNxSMDYnMbaHmMjg/MJ2d1Parz+3+95z+8qxtOP9kP12qgaXKjnMY21m/4ltXnOA/NLBMwbCjAPiBMsoa1gABKDjwxCPK8Y6mZsY1IDVdj1G/zEqpIX9cygMO5k2OJ7cU2dnGt9zIuV7+qZ5mWKSQ4L7ENQGVQSqtTJIDaIrYDlQHvuuxgTlOvmAvB6FSn5XiyuHvYsHN4wGAoE2+oK5UXQwLUgrTyh8w+XdBFL4OtWNgF5iLnNOKoP73kWAx7TkyNOmtPQoEgaBrSLIKKPVYORnJFmeLuSepSwUOj8KNk6Ja7oXrE87zlozFjYo4+w9NJkyqEGwzylaCZmzA3MZVgMzLlOAaDuJPdRgIBog8AC9H0UZlrA/NF7bhfTJkc1/T4nCYV7KW8kuD4dOiPQ3iT2e82ZZ0c4yOZOg0k2W2jCOapjsZyTbjrC6OHcFFoWr8O5LrD09mUghKNisU8p7CN+BQ06KQHRWUueHV/sROyQGxmAGzLDxdLXwWjHSV+8Fqt9APjMRTiUnGUD0QqMuuhE1y8cOQtHF/KtYFztNAsDGB/2t2OrGgu9x76HOJunSGAS2mw+HRCsAtrVHpGRMu4d34MtHkvbbxEwFxtUq1jTzV1L06kXvsJtME2QcfVFnRZxNObdzVNpbatiSAvYLl21zoz5k9aYDzoJUr3S2s+xiVE5OpQ86AhSFmkjzzpFUVkEzJ3GXvNjRoC3f6mcbrXAwEpXGEqBMIcxZ/4Sb7pOJyiKY94qfTUxyN2PKjfMT5M8gWG4aT1ALuTStKQdsNXBjqo8vCsK12cgapQxAV4fDyMx0bxgY9AnYD7N6+o9Mn+SgMeRh9SeYwI+89L4ciLSoI0GZW8QELXmGamLfnW4RDaFgDJkKGIx8ZlwWyNr8cYtxhOn4ZQD/TenAWjgI1km2l8iF3F93o8OGhxEUkAIQ062lWRJG4ExQizqcmPawIwjaZFxYzOUeQqPqYpTsk+7UJOUkcMmIOZgnGiFfQwtubnUkAMWc8T4Rp6hvl2rLI2r1q1LR/bsTKP7d6TupsnU3z2TBnSC0t89J2DOxpgwmHIKF5vfIkBZq7ZbkFfr9+85qiyF7elv75RztQpfr/HUIWlOvwjEs3r2pTOu+Z9piUI8Hvr8H6Stex8QGFeW0ZEsZVEbQiSavAR45806M4Fyh98Hm9Zso6iP5Y8x20oYWDu5ZhkM2nfjKX2P9+tEwuAc7r2NJSTeKqo51CdK2nKy75I00n+RzIBO3IpMpchWANk4XcKK28cFmR/XRb8fYLwSlYVLZqLEs896cNjskHiQxdKglg2nfgJmO9o77cxP0rjdAuZ/8fGPpp/+j29NL73qldo4/n3AnOvl0zDah02N+7uA9BiD7a2Naak0Yr3dAczvvP/edHjnFiUPG9fcapXKoietWDGgzZXYdDkY0hwjSuozpieJcNCUc0Izrg3aSUlChkan03t+9VfTMoF3GtJDvrDni9ay2JRU16Qwg8/8O4xjPJ69DtraAcwzuXL4+KBDRY6PDafPfvPW9IEP/pnIIuyhB0CMd/p9/IjGXGO69IrLtC6GvIh5t3v/sbTtge36YJYwZrvomzMgsgzTGvMKMM/2t4W6GhhU2XU7Z5e/uVhmAvkc0krJX9pP2ZRe/9NXpc9ev13RjKW2QMqCrNJhOvXM2Ywdqol1XPOpsW+57ceUwkL6msd2CIwreeUR/T2goCNnXpJqlNhv4zLFsl/elxpEiCyfP5HWTzyQ+upEfDOecHDXRSDPZjlRjlMbKU3n/1Injr//7nf/4cHFbf+j+rvGjGiM9Do9OZohmZDonX/+4zkPzEscc8+aWBOeCTpsYwO8eHFl2GSQEZ/NoIKhidGLmRcTyEY65okdgjAAhP3i9XwjjHUwn+FcB1iyp7KMV7AaOB0JmAukWeOMxrwwwLlADgWGAQfieNGqltO/BtbKdcsa96xVjMLk8mK0QBk2VLG4lEYJT+h4L2BYNlwV+5WNgec94R5DysKfMOaaaiKqxBATpzQbx8UGkUvPTg4pKst3/P0CHLjC+rN/TCdty6pssTcjcWNLVIj5TPIltQ1ZP6ckhQA4E0GACDCUw7HeDVBz/0RPZimIV78cGYK6iSESZTmmVNNDJ4+keW2MrI3HZmT/glktWITXgjkaUNazVj3r2ByIjcOgUpaMN2JYlU1e/t3OXXamjLdwHAP8EdqLBW989KRYIGLscj051XD0rWc2qbkvQ04S+5wCaUCR/MlF7XoW/W8cH0fVVdNctNRR5+pilAdQBo/lLy7DZ5A05HOVvLHJ8yNDjxgjMR7cxxqQzrqIJrdogzMgsBOsy5QDOXK8rSPyrd/5ujYz2sxpgahXRJ1NF8GYa8MqUE6YNmIPt84NpV5pvTsVTxq2vWeVkoYImO8RMB9S3F+AY12t2HUWMP3eKqnJUUlZSOZyxjoBc7HKhElEagFjjjZ7XAmMYI8d3g5o6AgmamfWJ9JJy6ziGtAqxpxILkgmpmG21EhNjQFkAeLK4JzPAAAgAElEQVTEIK6VjGRSIRVndT2HT1Tzi8BWuQBkdAXOotr46adlFyoj+vG+Po7bA8DO6LvN2lAsUWKhOTHqRHmBcUSuwf34ZpPKEA52hPQT8y9gDtOOZpoxg28jMBd2HRaeruEaJPwBYM1JijMhqUZtreYRkW8UFpE5gz/GhIBWSxOb0xg3Q9Llm4hgnVG57eBpB0rhDDHno0SOITa5x3U4bBWME5t75EmmTAO86l993sBansbYYjrqM1bdAF7t5gjdLIdN6q069Xc2pXMuu0TH4ZIy7LhZMiWx5C1K/CQ/gg4503URwFohgic0l+rV9mNql84OnD01j+XZeucdQ5JI1aUv3bdUoSUlhRAobNMJQXvjTFrVeDJdfMmK1Puat6anvvqptGPfg45jPjoSTuv2/aRJkSEJ6OOsClNqiQibT9rc4R5jflnGlFFZqBhjLjOeHUjF87OAQ82VvBH3htZzEHunltLgG+q9MJ3s/zGRM1oLDLxZD2JTV9hyb6IzWC8Oc/6cCRscP+PEkkfJqGjbgu3nPouAObrfIjvhJ0C/VU6BlriobZ988on0F2LMX//GN6UrXvFqAfO80PhKsZx4HQTcow/H0mRgznve3OQ2aJWmvE+gvF9P4nn/1rv/c/rx11yd1ggAXnDhS9JSRUaBkd2rhEFsIE6iKdMVB08cVQhTNF6Km/30k+ngwUOW3CyRY+Pb3vyWtGndmrB67p/qOr94CVvMmv/vmPMCzAthUdorgHlNOnpySMx/W9q7f2+69s4t6Xc/+HFt0PO6U9YfoqiceDwsZveGtNCyNGwm5aRBOGXWKXBBI+6s8l6xoYuBuY20vm/Sh0GWn17zeKITZy0or+uzHOspVr8TDCmjqz2+cQaF0MoyUOvKyY5FBmrZYaWt1vfEih+S3LtNCSvpxON7Urr5I+EsAqBv1jXXnpc6l/YpotoZwv4NqVNZmuunhtPqJcdTy5G7tKYqoIKOGElghC0nNLDqN6f17zOqwv/1/vf/0VNR5+fGQ2PkEtVkvZ5bNb4Q4v+LHs99YF6kLBlIBKYuR+zBYxeWzyQgJhImpAAPpoMmfLDnGTDq78Jm2xgAUHx0WX4Px6QqYxvsCg8M9SyLk0WtYUgc01oAs47c3TawTD4MDXMYhrLKYGJvIxhBvBZ4kMker/Cal4wCzPPb/oDvl2H3YmDuFysIvMqEeaEtLHIstH7gsAWLTbvAPmtjgQFtVPKJ0BbH5wpQDtZazN7k8bTt9tt8lG7iPgP4TedfJsfx/mxHM7vPJXycrH8klYBZVvmnJwHmhEvE+VPG2UmGvDzG933NuIZbpGIvqwye45irDLMKATV8/KgdcRtkXOrQ+OtbSI3mtCjg1NrQQTaypc4gWO+QiTqCpuweA6XF437BCAZo9XEglTT7od/ZYOi+bChwViUSD0f0jY0ksAjmxPUI6jX3aQCbaM58biPgEQw0TmgkK/Lt/IxuNC0XZfC/+DRXjKvlcUXv4JjD6x6rHmzuu1KC6Oz4i/dZ8CPUJJ+L0xLHzuYCZaxWCgN48Lf0oQD6zlqoyxEuccvNX9Wmh4Q40uR3dKeNF0qap2tMO2yYGBaNo86542llV50SvyjEXXutgPnqNCDJ00Gl5T4mnSfzrkGZL92fujAJcwYFzGskyTh9ldhAgwv6IOKA9wmYT40JFKsD6wSCeTgaitoUAO9Y5LD2+r1F8pIZOQR6Q0mZ9fEWRWqBXWdxJtIJDprjArI4P+KEyZgAsDspkNZc5AE4cyIziZERSXX6u9GmM0cFR8V81ylpx5KsW5oUUxXjWUywgDcvk/acUHKMp+mZ+tTfJeafk2hON5iDApBLcoQPADvRVeaJvU2cf/TSutaE46azMeRUwkbQbBYRVXBqnRZYpwNG2Izo3zxyDoC5vjcJ4FIbTuq1UV1vWq8FeInPxngHcGM7sXFslKLGwSrH/DDbzKtm+3QqovHRKNa+Tf3VqnK1KQFUV7sylAo8rz73stQtHe/wztvkB3JUZYzwcm3arLTKRjYrcgy3GUWWodentXPo11zl9GROjN+1NxzRCUtK1z+4TnkJBJLEXMJKc69anVi9/qWKJvGLv5Ke+OKn072bH3a5SFbGBgTHWfwtqAuSHqpYl8Gmx7Tujy67zn5KMbfCcTi3Rt4rx4wMP4qYLXwGBh4fHP3ONWEsRcoM914gHfllcvBUcrIKEEdHHtIVW1ODcdo6gLeZcV43SRD2L15nPITcJciRwGsGmGjJTYwwPqWZtvNtMOg8YcyVKTs2dNpF7hEw/3MB81dIZnLF1cGYVxLAMC6Qd2hS8CSzMXINNpHIDIky1tAsQJh9YNokR+mTHrm/pz3t2bsrPbH1Hp9y/LK04kcVJ31e9rxW+udjJ06ouxrSCYWxnZSubOjkcctIiNwyo0375nvv8Ulmp9aMN/z469J5Z50Rpiq3cdgsN0bYt/LMG5pFH/57fw0ZTr5G/kQ4ytJWSwTMB1N3R2u649670m3bDqQPf+gvcjjURZfDw3pwl4m6hY71ZqGjJDx0bUkyLQup2Ov8uheSOAeNeOZZyuK1V09AtvOEVC/ly5bilnLT6QB/2p+oLABusdsG4AB0P3EMReqCI6ieAAs2GJAGSqyXFC3L+qwxqUxuVFbQAQUa6ZEj6dLVqVZhazf1KsGUTn0aBMhrJRGb01rW3d2Rprdfn+7/4idFxitMKad60uQpadmXRML89u7t23f979r/R+19jRXpgdLL9QQIXas598zB88+o0PPC+bOpuUnhEgOqZDycB3K0X2E+QoayCGDzXh70xeiWeObVbxbzG8tUhYTOjHpxEqoYCBxvuCnOhhhYFpVx6WWVDIPQeaweBkDZpDgetGFHsOXePBjEZYBVwGAeCo6KYSZ+kRmo2KkwDAHEMnjL9VtshyoJKDhJMHsX968Ac+qA1tDru8CHpCV8olGxp6vHphynlptRVoGY4UPpsbvuMEj14uLrprTxvEtTl7I/Rl/EZ0PCAzOl++hehGIkqsGspSxEZUH6QwQUwDRoIG9eMmNYiTsfF432iEtn1k7tSRxcpVWe1tFoZBENbSjxz6d1TElSk7auHi0wrWJnkBlFKmcDc1Y/N2cszuaFc5njZiyIoQ3G0YrNCJ9r1H1wqiK6zBJi/so5B2Dh5T1fNwiT6KtKZlm3cJaqGDTEZpB6lu0AlynRWSLOWmw8I1mpR5D/b9mWF3WGU4BmO9rmzc1i1p7GCwFYlKmySXCdA2iwr6DxYsNbNhLsMfP3+AzlJBulLj43J2B+01f8N/3YJge/tS+WXVM55wTMZ4mjq8ZaXXMs/caru9PHbxpT/N/atGy10qRLY/7UIw9J13/S9W4SmLMMRDUg/N+JYTnDCSRvWjVlsInvlMe2AOVA/4witcgRUuCzWSDe8bVh1FWmkG7QP2KGBY6bG8XEy8nROnDdifjcHcoGCkAH7CJfrRNwHhsVYCVWuCQVdQKnzF1kHHX6OzKOanw4xlyAqmkB4Z4uXY9Y5db2iiHmuFdFRJc+pYWRPgFGN8EKq5PqtfkgiRAb/1mVqbtdpwoaTzUCy/S5Q3XakZDQg3n7pd/Z39t/TOUfV8QRTq4BliTWAsCyESF2N5sImHi+MIb0hfGlP/nMmJDqjOQryJsIhajm8+bCqXzExMd4AGyy6QpjUnwgKtmCaQ+Vsw7ABhBXGQDYbY2zjq3equgzbS3YE6JmiNXu3ZhaVp2V5k4+kYb2PKx5LiZdbD+hLJsl72lQObtVZvnwCl0SJFIhMGlXgYJGCBJFovj2LceFR5rSN+4bUPsPKfqRpFEqQ4Pu0aKACT9x/nw67Z2/nvZ+5a/S3fc9pDaUd4DNa0SYmVedbXmReHACwOZPlUWt5hCtvG7HNk6JgpyMkHCeKLY52L/wY4hNWxA86m9ik3sTXJeG+85Ow6vkVCmtbknEU04aA4gHyg9dOT8zqGfu2W7kE10D8bh1OcWIfAdVAoRCAcrNklPERYDcjnmsNbpfs07yAnBPp6f2PJn+TFIWnCdPWb1Ctnfc4WlDYhEnQeGgHmXDT6pzYFW67Cdelzp7etPYnJLSkL5UJUFj3tupmOHd7WnzA3enXsnFjmoeX335lWniuPprYGU6oX35pLTvawa6JOuaTgcOHtYeTo7dnXK2p800iL+nU9cTh/an9p7+dOWlV6UrpU+3dcrrRu4Bt1uxWy5B7oPy2fK5xSD82dco77ERCwnQQjoux/NORZW545670jfu2Z3+55/9FVxwpd9tWH1zp9JSw2RmnEnlxRfwKwxnYF4KWVmk4/1YODKxk6/HhdvEvMOa549X6rr473Ifrg8oV/xya8n5Lsw5T8A4eUdwJOGkFS2b9wCUR88Tiss+sFp/YkD0xv5H7Sxau3xFau3uSiuVEXRBJ+C1OsWY1xp8pF7J+ORb1bgwlTaN7kwPffLdaU65JtR+16n7/6uM8T8rbGClfv9Of1H9WP3+g57svG7W+NGO5l/+eB4Aczl/tpD5U+PNmu8CeWArPFs9B8rr/A4DGGrw6lwL7jE+bzME9srAx0bODDUTKuZMsPB5x+4vYrRh5wLAMemQrICf0JjXandbr8VjibPNlTtzkVgQuCfaxpCxBCAzhvXUDwAWzyy+8SUyIAor7IWjCpwqVisvJmFciyEK5jRDvlhv8x1ySDKopfz6lIAyxWnUUViJVxpNVWWRqPLIyMG08867WB70HnrIMFQbL7g8dbATz01YbXXsknqCUFdEMAHYAMwlZ6mXrKSe7Gw4T/qUI+4X4DGAfV6ncrlzx/A52kzvW28ph1RiYk/JoQidfMSrle5WR32tnd06BZCxYcNESEI2E74+/R2MlPlj09aMB/7PK+EUFnKTAObscLgnjBQRbKZUhwY5P6HLX7DWvixu0fcRnYXCFr47+jMP2miiRQ9n8XSXZrbdjGX0WYxv9VtukDhejxGNU6NZztzF0SWlHcMpMZKXBNAvC4m73m0eR/yM/2AAcydyTUc8yvONz/hsm8gm4+nhm77m+QNj3tIzkNadd5UvPa22mZf0AKnFee2HUo805l1Ll6bHpUTsX7POzp9PKlPdyMkTZqYJlwiLX4eETMh6UOtds4DUhlWTisriZs/H7Irupfjfw3IOJekOMckBTM6mKXAXWWYjUMGUtOkthAo02410hex8OBjGGuVzAN0XR8RRInnoHmh8G6y1B7wJsDgEjRg+9b1DG+OBqcbgfp2Kt86GgM0CoJqoLNHpqr+kLPYl1B9EEgG8ExvYkWN0Pb7fIeY+stdmEMza79ZgI6D/6/tmzMk4qveIAT2uzKPEX0c/PqcCe5SqzwjDSJY9tO9ssEbRvud5TXQS+eJa1047EM98UuVG2qPmoLXyeHeaK/0LAEqyIaIb4QEBu90uR81m6eQJIcmmqatlSq/pvvq9SacFhJ5sUh3pF5J5dWwUUNVR/8QT30lj2gnAlsPqs9FplaxJknzLm8bsKEuzzavcC2mdAN8c6FvM3c3fOpka+mrTdZtXqC0U+hQNtkpLxtOO2qn08jNm0lnX/Eba97XPCWBtNrImpCaeJhG9SU9FprEETXX3JpO+Bbo7CRk2LE+avCFn/IVRDm8Ls+NhGpwtNWReek8A5mjThnR8xZWpXtEyiKoSsZ4DyAewDuIiAHlmyGHGbRNiQxxrSkxL3yMPI8/eij3MZzX6uxpDOsA8jxLNqjiEAvZbxZ5iB8n6eVBOmJ/42IfFio6ljT2Oxu41zHXUNR2OlnGrDSGhQ9l8Ko1Teu1/en865dRT07BOncaZIPp8m6QNSECQsnzvjm+ntQPotKfTxS++IK2WU2dtR4/bjQ3zgSNiyWlnzVHY8zZlW52SI/6hY0fTXXfdno4e2C82vjWde85L0utf84psl6MBnsF250YpG6NyAlxOdZ/NjEc7xvpRrsXvlrHoJebryeFR9VltuunWb6cv374tXffVb0oulUE4X/Mw8Ah6ZsfEBeM1dx/hfvPvfj361oOaB5PeMzV3LD8B13IE/oFHvmysEXxFF26Slrxbx0Y9ayIiS7u+a9Zc6xk7SQA+MczLwlCuwc/hw5a2LGlXlJ5GjQkyLGvT1iBA3jAtYkx+PLNi7icaO9JQXYslbjU6xWifPZlGr/vjVLPl1jvm5qberUF0/w8W9rnzisbGZaqNdjBpp8bNvf9aNXvuS1kuFzBvFjBn/GEzi8SD8Z+BUwEwTAAMj5naPIHCyGVgzBzKv8emOANXdtK+XkwyG3L/GrPO80TvOWyaY+3qZwhJ/ca0QCGADVbYyT5yGYvxiCvJ4AGCzEzmhaNsBvLU5f6+l5FWAPFiG/I7UZpiA2wIKutwXlMyqLVBY9XLxqKMOG4OE6goJhGnlwRJwwbaDfLgXhwjNmJx54fqPnTyQNp1390VQBGe2TVpk7I+tgl8VRnnMK5uTx+XTgk0NHthB5hPENFEgE5hMMU6oNGOI13blWLD8m1DRpP7oHygGD/3Fbph6cm1CBGFYImdAFmIxY5L2mImPeiw0NQXO7ZoTPhEw7fJYNjXp25xDOk0y3nTRqSMBTFC42ODYqZadIotXT5gPZfXAAAwXDk1AVBHx2axTu7SbNEZD2VFprlc/8UbUA9T/y9aIYBXnA5lsM5Q9ECPkRb81qKh44Uqn4CUBi4LEPfSl0N1vPg7YNGYFHag470MJjkt2HLz3/nDtdpgtfYuS+vPvcJzBKA4o4ygTVr4Lu/enYanm9NpmxrTQ7ub04C0pL0rBMwfETAfVOILLWCAOo6LoS0Aj0OSqrQoLvj6ZXPSpapeavtp+kXvrRxQ6mvFQ4cdZ/9LiWE+aTQYMWqN3MEAUZpmNOYwxTiQTulLPTiEmrmmvSJ1/YhUEoB1xzYXG1yJmFGkJcT4dsbB2LxANhJBhIgMszoNmhfYJeoK93ZSFzHsBl76V68QgMhC6ghfCCFNNBT97JDTI3py9yHRXwyuowdmxYZjJ1jbHTKfjYHYYLKYwoyzFgPeQzUV2TtjigDo5XyqSDSO9gOJQPIk0V1Ie5DOkJl0XMTaNDHXbUZiY0DfSjIswBxxwlt0XwB4vSQ1IkjFiksqRqZUEgupr9qU6KlVYJ3Qj03EOtR1kLVMKato31lXCXe0puOPf1s3OimfACSwkiwJHDCHAOat2mA06GjDsgppwPHEHle0unUCjqlWG13ZhGu/dUKgtzF9+9EBOdqTGCgi5TTq2bJkMr3qzKl0zq/9Rjp87ZfTrXfeq82x5Ewm/TkJCNW7wXIe2UuI+Y6dAZ3Z+545EXp5H/fTZ4Q4zLY7fsYpRmygol2PNm1MO9ouSRN1HQKpXYqt3ybn1ZAGhQwly1U8r3KUJoPg+Dum+jPn/GKQ+fcBzbxaxDpWgKFHS1Wy4YgjeuJUSljCkLLMpEP796WPf+RDAcyXckJCFKSYaxbC6Xr2nWAa5dfnahrTT/7aB9ILX/SidOiEfHmcpVY4T0REX0+borK0pnu+f2sakB/BlE4mXvtafObIuDulUKWatNo8Hjt2zCcyZCMlEdG8bPSUpIc4zN5913fFmB/yennKxjPTL77p/3D7VABmtkUVgsbEQnVhWGwvs9n9R3/Qpg4picOsJuCYBmWrpI/fuPH69K37dqbPf+EGn/5VrF9Z8Cv3rCy4cR+b3gy4i6Gt2PACIthRl+O+/BqTVrJKg+ryCLNbvXdZ3PkM8ct71kp6oiesebs045BMoBOHj8xG0Ha6XAibor+Vdbl5djydumGl198x9X+NfLsIqzir0+MpAfJabYBbtXZNqG2GdLoxLAftdOOHv5/2bP5ted7f8sO07Y/yZzQuTlX5FTLJEpbrNK6qO95/YcWeB8D8NQLmzR8LI5QhC0awnPsZGmZmO8ORKpwsqDU+gyQgpliAlDBtAWKMIc2QhAGwv2VxugScsNjlxYxJuaAJjj4ayz4JMNdEatTxkp0KrUmIi4cdjrsU4G9gXsB7mZaxQgToymDJRtovZ6NUPuN5vLjkzxxFVSnLos8VgJt387MyouUYd3JMR1okSFLigqJ/5IoluZBBpYpw8uhTadcDsakMR6oow4bzr0gdcvwpm6aySJnXYwFw9A4AshYARYCZMGOu8JIkShDrEPWNelbsVK6S7V2g5twO+qD7IgCFk57k9ggmKEs9+KLBcQByA6s8bmIc8VGBFzSg/PTtFy18izYEAHMSGrGQoTGfkeMpseuV+MpRWWok5/BGBFic75lpU0roMhgUmCGjVUK3nUdz1PsZYzqPS4P2Uu/Qk/uhX9g4hh9EGb1A9qhYjJbKiuEv8F1D9gwaLYopYIIxyzX9NyeiBWTEdzx73K45GoT6b9u3rzWwqZeRb1PYs7XnXh7dJHQ0NirNolj1jR2T6WUvmEoNYnru2D4vYL5WUpbVae/2B9PJ40MG5jCtMLOktSc6yUkxdG31k2lNP5n+iA1OCEI+syStWjGZhoeQb5BCnKN7gU7AmJ7TgDBOSkhjL8CI1IKfsMawqCSj6hWgnjKLKudRjSFOqA3MuT4h7ojq4nHP+A7Z0PwsyZ+ydECNQ8Y/HBnLKTU4jxCNXqiJhgLL7y4DfIYECWdKGPJ5MYgGK01kL2QsBIvHg83hrL6IkyshGZ1tUWASuUeNyjAmYF6nTQyJhebFYKKn5vvIegiXaI2xCj4lYE4YRcscdB1ilbMZmFZbzeqeEzj/qR7YugZ9pkH3aQLsahPRJmdYpEWtTfIRYPyobO3SjLc1OzSMrzkrZrulVQy5ADknE+ADmHC42LqVlwtL9KRJHZuPHnnUGvpRZSltUNQVk3wC2ETmMMMuZpwAPm4/3WpEG5L1kgjV1HcpUkRb+vrNx1KNGL9vPd7hsWkZCJFuVLeGmsn06hdOpkve91vp2IN3p5s/83ltZpqj/WxvxPZzoukNuca8pET87pNJYrZrTFhiZtvBhMnrCfewDQjbYFvC3ET+0Lw+PS5APqJsnT4p1Ps9ysDY2dkuTb0iWeWQipFoJgNv/V4CBMTrNGMVlD8bYC5meX9A1pElL1yjur7FIhOJeCK7LgmTWqQNn9MpJU7VB57el/70ox+WYx/APOgm5oyJVv2FAoLoeRxUjMtRuJ547LLJP/3rvydgfmbaf2xMm6aQLrYqZjkRWXAAvffe29OqpfjXNKaXXXm1mfEJMa5IwZZIXjGpzsV5GSf8YeWZYGPcIT10T2td+swXv5COHDhgDftSyS3e/c5fsRb/GQau2LpotADu+VFZ3xZ/5h/5nbmBj8fxodF0SBFZVvV2azzWpdvu/K7k2PXpl9//oTQqZ/Rik+NStHLGaQX02mYXkobxoc/oOM1ZyD2OAMuLaJESnaVCcAHMBa4rwLys79zvWSsf1yKCy1Kx5YDzDoF0YpijMS9suWVSuq91Zjz53cZERnwi1e7fLXlRX2qULaZkNeqX4cbONClA3qP2lggzNWosHz9xMB2/7bMPzWz91gfSsaeu+yGb9Uf6Y5prOE+8OlfiBs23oX/NCj0PgHkw5l7rAMgZDBp3MTdYZDCEsBsZLNrAsZBkgBF4JRBLwXhhIGM65NwvBdHkKRJvGn76RjFJndkOAKMFDo0x15yylAW9MSGMiGGsF/OGmjLgNAUofcbUK4Ymv1hY9Moc5n2sZ5a+WeqGWbB9yuhr8QUpbm4PQ7JogpA5eP5XP+wFVlpgJxjS74QvJH53rZiWCIcUTVFhKXJbHj/4RNq35QEvpg4uZgfJlDYIlHUqxXLIZ55lZDBasJkkGNJXprVrn9BGAEfNRmWoq9Hr4YhJeYliEu1cQH/0Y/R12MfS8eW0I+7H+2y8KLfZXdvNzC7zdwbaMfnCCdIZY9UvJbW4v+yTkBgbvrGekWgDXaa+I/nNvI5kJ7XBcPhF0B0e8t6DRMi10tqUMOLexKXCfEch8zLtDvL3ivGH6eR7eRfn/su95ytRPG9KAXywgvn9DCJcF18/etCyI/9T2wIUYlb4XVfP7V4+XUoKixbtF9uBaA87/+mG48Mn0iO3XO95QZ919K9K614splSDd1JtM6vj6tOa5OQr5rSxVYlixKyNj8+lFWvXSsqiqCzbtqSTJ9CYw9DK/0A3I+vjhPDfkEBAh9ha2HHimDM+J5TMBw34qoHJNHhSzKhbKNZRwCebs2kS8egfsstZfQ922fIRvTatShKObymRWixlod+lZZfueUzSkxkBEofAk+SCGnPteuxKWZeJ2IRsRl9EU94jKcucFnST9EhwBJDxZ2AMTpApNIO6Bl0P60RbxrCKjUKL45qHA6Kj+egahkxEn3GUGToRZ9j4PIz/uK7LZqFZ7DWRYCKsosCxkyNFH+qwWoy7Nh0C2XZ+zBLXWTo52yPynjBcuZ+ZbH2W69L+bYqK0yDHzRYBdDYetCnZRjtJ1qQ2IjTbqKKfED2HrKaTyh5KsAaywbYu25Tqe8+RMTyUhp+8vewaST6oeyDrYeMToR2F0+UoOpeGpUfGURMwKPVTWiOn2iUNcnJrbE9fu+5oauptTt9+bMB6fDPm6vkmtXNdzUi64oVz6dL3/WYa23x/uu7zn5VNCidyn2RoQ+a49B6/CvGGjI1Rb505EryYF5THrHk+OfS+FdtmGQ9AUZvM5tVpe8tF6VgdjnQxtwo7SebL3u5unc4Qo9tG1h8osov4MOXI89XvhYVYzJI/G4T/Q6x5mDD6O8aYpZVs+KiNBlg4WEpjLsBLNCoIkYP7n06fVIKhOgHzU3pCfqi9UmVsI18Bz1HEcUX+adQmpkYRZX7qmg+k0150loDshKMAYWtaDMzbDc7vv++2dNqqXgHctnT11a9Kw8p0SeI5Mn5OaG2hXVcLAHOSPKgERE8dGVSCopa0XvKXL379q+mRbdvcBrUCir/z3vc60VL1sWitctnCgpU2+4dkLKUdF7fftMozpFTAWx/fLf+V0fTU08fS2974Svf97p2PpW7p6V/2U29OB3c8HokHaZUAACAASURBVEENsswnrGfYn9yxeU2KjVBl3ORCO5KNAPOcNojzjQLfAGsmfYCIyjWSktdFitRqHf2ZZ/3p03ix2qlD465bSgsSDLUqmoqlLDplZhKxK2ZX5eyyLEBEviHbqCbTkJIHaa1t7OpOfZIYkWQPZ9EjsgWjOh1o1bwYmDiWDj18y+Ojt376d9LRJ7+UC7moH56bv2p8sH0hu6d2Oek+jRsdFfzrPp4fGvOmVgHzzIwzoI28zHubaYL9sLHzK3G877XRrxYYEgxvJBwpQDC+Y6bTr7Fg8tNimOwUGCyDWZW4Qmj0NOksl1BZJgTM67US1LObdSzrDHxYy1gMonA56iEvGjVW54HREXMrl5U1oXwkl49559jBJj2jZrl68bO8lIFZvBCgqvrR3E4y4KROj/TRMF+KKiMHEDR/JdIK3wnpRVyHIh7ZvzPtU1ptXjfbThvp/xvPk8a8D8Y8YF8xMpbkECpOLKp7ioQp0rMDzJfIYLcQzkk/TQoboFCcvB3IdbS9YhGKTq/WO1fLfVIBtYveLo2eX4prx8JWiljdG5XFNDdp7qJyb0ex0SLN8S/RZBZ0HDgtnV6jZCxLRGHWqM9dbhnmIucJ/jwKWRguWiskO66wF/EQ8SyuWtSxjF0axREn9G+xvMpOW3r6ZL7CqsciVhxIy6yIlsv6ekqVdx0VR2gPP/4FKOUvJ5VgzLPws4ACKrwgickePJYevf1GR8OplU6xbamkLC95mdt1TnKiToma33v1SPqb2/alE40KVamVv1GMzvK161KfkmQ8+ej2dPyIojjoTu1izNF219cp25/A37DWlC4xtssV63qCpHYCEcL61pSvXj6tUxs5dFqWgNwjUmyjIWcNRG7QJtCLIyQg26Bdsg1YY7JHEgMbB0hLE1Q9MoEODQOQSdJDlBN6LE4NKpGU9MFpmEAiSsA+Cygv7RbomW5yLoMaJeFgMxtRfLTJVZQXFm7WXrJ6snmtR3KC1lzXAnS3EzHG0gMyRGY5he2Zvu+MoLERAjhbF6u6EQaxViLyVmm7CQNq0Am7ToZQ1nnbLv2iMtaTmRLN6GIQSChJXXSaLJqSXrDuO/qM2guyjV1Gk3T5MOZkGJ1WSEXakeRJ7WqnSfUNI3BkVImgJGWBkxgbFdsOEy5w1nP6K3RaIB8AhUZckHMwYwwmfWxELLy0Mc2qCzG+cc7lO2TxHNEGihOMVk4u1A/9CiPZrs1crTbs194ymGYlnfj2LjGFdo6FDFTZNJakjE2XrBtLr/6vv5lObL0v3fS5LygaSpNPBRwEg+qrrMSqB7QWh/YStpCaL1FZYqsc88j2hf+8wZWuftWZadXlb0+Nq85OO3bvTbffq80kIf+YX9aTa4Mh9h9gDhPcpDZ1fgfmNPOp2C+PhXDsxPSUON0xzeLFxcB8Maj8QdY8xmaxKZYv8U/XZcPIphmb3iKCBWAO0Dzw9F4B8w+nJZKfbejGezikLM76mtcbsB319saQuSQW/A2/KmB+1lnpyEmAeZSxRfIP2HKA+QObv5fOWjegUJUH0ytf9mp9B4dYbdo1BkYUiYVNwos2nWIwPiyd0v7jYwqV2ZJOXdGT7n3gnnTt9dd5XWA+/sEHPiD2HAfLsENUqFj60pbPBuY+ocx2/9lSIMrhEyS9v2vvvnTH/Q+mu5TgqrNnRVojB/T/9KYfdzuymdlz5Fh63evekI4rhKPvm4G5iZxcIq/F9LtfC/tKMWPGBl4IhkMnV3rONWnMItF09s9wsvVPnOIbCzDPly+LUdGlLwbo+LUQDaZF6yROoOjTlYcjab45Xrk92PM6j6Oqkx7k9UNgvXn5Ojm8dzkiWqcmeT3jRe/vHTyehr7/tT3zW276vbTnoc/EjHn+PDRuLlVtdRSRnla/3v5vUfPnBWPe2Nxq508PwcpOM0OIDBg8UdAXYgjztC5G10M1M9aWp9ijJ4BgGMegkwxw9L5lJp4wMRl97zzg7WyDQZd1wxELNmRKR/cwznUCtoC0kgTI0IxJzXUKOvNUzn9kA5T3GfFZysFCi41nvhfz4NMC0EcGcmEb/Fi8+X42mxDQLy9B5QsyGNNIWUhhr3cnJMuoJUESmT8dKSCbJLdN+SOlw089lg48osQKlTYxPEqnnPNSMeb9auIIE1khGdwpICdArdgarQCz0pdPjCq5jDYCTe1izBXNpnI998GiewMdcsKT4qjr+rpd3eHZEOVVr2JMyzX4mS8YKDuqU/5nEJsXUf/M4wQM4Q9Fy3koiImYIQqJUMWC9Aoz0ksSVQZgziajhF4M9zJY6pIAqFoWb7s81MpizHtZJ5jHZDGsZaNYFu7SD7GJjPJZBpHrbNUVkMLtlZ1XXdWA5QHSGPNRUZ9D+LWITOEm8eaTQYfzYx4H9GcslyGf0WI2ofTUj9z6TS3iiETkDNm7Mq17yVUh1dX86JCz3u/95JL06a9sTfsb1wgQE0VFUR3616SB7Px5VBrUaVWgXU6BLfXTkkYspBEx46NisDublOhCCWjGpDcHdBOBEQfCVYrKclzZHWFPnbsAcAH7R504lNFcxEESh0c+75MO2HI7QC4IUBBq0LUIxlh6Z/kNe1UCmDvEMMy2AXow1IQZnBWKwV8L5pqMnf29JHeJ7JqWWMCw6r5IcdhcOAa5mg8XiiU5LjjOnPSBFAbSaEtmwDpqZ3YuwLVj4zenUIiAd9hyM+6q56QY8mG1DTO/VUAZJh9SnSgy6OkJdegxATDQvyZFPlni4yMS33DfsIk1CjFp2YleI2JbjbOSEk1F80xHCfXyyoQ1Z7czJeZ9QjqaFunhO1vRD8f4Aoy3tylpl8o3PKZMnc3q/xe8wpKmY49/T9k9Dxn0Em+da4zppKRJpyZNyGvU0DDw9bIDnbrPsN4jHGVTi5x+h2qU6n029QmM1yrT4ddvHVNox+Z099M9TvGO9Ig2ZnPRVDOVLl43mn78vb+WTuzakW749P8SMFfCH9oF+ZL6CRkNzpz+h3wF0G1lCxYv7LlZT2YAbQKpoHHUtmxDWnPVL6elp19RAfRMDVLE33jLnWnrkwfFCsexS62OC3p6uhRlp82JaKZkIwqbDXiv2FLdxL4n7qPqulXWp7AQ1cffx5hX2eIwyJ7VOSyf602EINn1etn0FoFhM+YCgwelMf+kNOY1IkQ2oOH3vPfszyczYSGxJcT3p4zzYntf/5//WzrjnHOkMR8Xkx4UQ7v6ZilSFunMH3rwLmXnXZa+//Bj6aorXiZFS6vvPSmt8riOSSBx16xYZunfmCbk4NickhO1pdNW9qSdux9Pn/vbz2t8yVdHc+t33v9fFJFHgNOPsFGVZYf13Zudsnj9YFtZtoVcxWy9nMZVhqM6kXvokUfTt79zSzq074AT6q1Ytym97Iqr08+97krbOuz5LVt2pje97TfkJyZGgEexqT6qxBYGgRJFW0QOZYhQLU15wWghnta7sUvMbDbAvEmsd2VhZ2HhnrzvX6qLucFAXuMwTHI4FnNmx2gdNTs7riOyODOo2g7Q3kkEFz0VKWy1bEenfAEmNDhG1TZ9rEnjx9Puh75zcPz2v/n9dODRv9QN8Xh9Xj00VojNqaM9hXaKREL/Jm3w3AfmimOuVPEfszE1qAnjYbjA3MlH/oYamTmMDW11gpeIExGnPBZCL7xM6DzXbJzKvMwGwhPFkzPMhGUzMBN2OIRpiqgsU2IIiPta75W4QOEAX6FrrPK9Zm7trMFlq2y6DU85Oqf8VUwYk9xgrsyh+P5iW+EiZtvg+2ZWx9/JO/ww+LqOyj4lnTRp62FBx0eGtCg36xnA3GWpWMbqvD2859G0XzGoC0EbLEZK68+6SE7jy7wpKWH+cunidEFADW3tEi1kAHOiwKBDbBYzxq4fYBNbo1LPCItpx6sMDF1Xg8pqPQlRXA+oXLQzcX2xc8WWUhW6MfdvRuKuH33DkXVInwKUBn6NL7ueegKa2FzAVOKwNC9WGK18vQwkSZI4JXFzERvci0gcFQcD7fMFg/XYBAZnXtowq1wN8NwCJEPRbzgJx4MxKpkFi2/ulNCGC0x4sxbgsxI+Mdvzcr3I7hnXcYITDzyKQRly2EaAW2lH2oop4uPRWBii2UMywbif1MbqkVtvdAITVuAOacw3SMrC3GDp79SC9/7XC5h/cUs62rwy/eTZC+m7OxWVZd0pAuarFC5RryvM2qiAbJfC7bVJztKgCo7rckPSSHfL+bO/Z9rAHJAF8EDGsEq6cwVzEbBUGzFmHPowItNEX2pOC+AXKQsFJhoLoJxEM0s7tXgLWEf2Rq1pYrSHxdTO6BpWpXEqTJ9Rf/0v4nYD9mgPmlCaaa2tK3uVXXRCenKYXJ2KEnaRRoUgm7DDabDQOvnX0EAqwnhmIy+pj9j/bqWhJ3oLABxwTSxzy110fU0NNztTCVkO4HGcyBhisFnA25H1SlJCBBKcMwkmAWjlTArArfgsAr8eNR51TnIDKNWTrKgkM7IzL9IbgQaipSA7RxvPuk8IRKYsuv4xJV/qbNECrygyI1rGuA7t1dFGVtM5yVpq04qzLpcEbmmaOrLNzmPzOkGgHGx02AQNKuqNfMqlwybbsK6vsIr1cgQdkAzkqCQGE7pHm4D/idFm6Y+n0lJFeWkU0L32trl0crYl3bO/W+2iPAj0L22JHEaVuOy0ofSqd74znTy4N33z05+VTVV+AU407EikPsnAPHMZqjuNoPnlaah20ngz25nH9nzzQFp9+TvSuotea1mFE//k08+SDAhwt02SiC/ecJtkV2ww6p06vlMxsXuUCRMZh2exzVi27XkWF+lk0aDnl8PA+Dsxl2ML/IOPYvstMWO8qHwzCocYzHCwv0ijAMftbVIPEz4Rxnz/U+njH/rjtAAwJ0al75KXCr4XpsEnQVN2WteJhE5+f+qd708vOOtMSVlGK8CcqCzWmCtr5taHv5/O29CXvqcMmFdeqVCpikoGOUE89FUDvfJL0AmGJgQ2c2R8Jh0d0SnY0s70wrX96X7JIa+97hs6OZUkUDKZd1/z62ntmhWVdiiOF9Fm/zgoJ5b7pMA4jqe7BcBvv+f+9NAD96cdjzyS6tUmzUq2xNjgNHfFmo3pLT/9xnTFS892A+w5fDz95Lt+N+3aursqOynrXumCxY3lrln0gfLeD3zWPer5GqQfBheQrvGBlMXv8XJ+34DmWaR1GGE9kayIvCJ6GYBckpQaOYLW9CyTBH1FGu8aSHMKdahIB+4DDz6SjqXRdPGKznRUoX3373s8jW7+5rGZXXf/0fyTD31Cd3ZKs+fbQ+smg+zKXO+bNLaO/Vu1wXMemF9y+Wve2pDjmFsLjmFiTOf5YVzt18KwhTmMRZqHwbjnQf6ZsZ0BvYx3hUBnl45xLAjOX9JrBtoxjyIcbkhZOIpuEhsAQzg6KlmD2IRGVrYIlBulqeDIDNDNmmT20m/mv8Mk+Sa+fcFEGZyZKa9sKOKzzwDpVVNbYYArwDw3kDcEHGVxfzS5JN9BLy1wMD48pE24whcS79sJhsJmVB1so3j7n9iaDu/YGcw+FB2skBaCNWe+WCl914SMAiAdVG6Mee4ppmABDahCacyJnZ/UCUMDGwFpSYloEtFdog/dDG6j6gIVG4DMxFfaLPo79NbFeMegsJ1bBNYrhtDgO8CWWZm8qbPdBOj6tKA0fhlncWQKGwWzRjxg4gPPS7NJ+xEfnZMCxpk135UrBAMXS63hMyMo2tTF5JPWIHgclAgdQZRQoGA648MxBisH79nYW8YFKPVYimgsZLflOxXHXbcN7Ruvx4YVWpg2iHYtBzgeWWaI8vddrkhAhLOggSrAXFIkpCyzMvqM1c7e1ekUNObWk0irrHHxgdfUpL/62va0r2EgXbByIR0crk/L1q5L/QBzZf48fHQojUgaQGbQdoFBJBSDAmmjAjzEyV6xFGAeim8z06rjqmXSmCsBEYy2I7EYlKi8OUQmTQWYnUTKIrCPxITfJx3ZpFZaS71HAiCDb0VTESgdkjSDYgNocP7kxIFjfbeTFSGR7twAV+0FQF3tiDFkFo1xB7PNNWHDJxTW0GNP12rm+FiyEm8kaHJ199i4yqENwojYaLoBgFg96RPjro0JMtF6sd4KG+3H+GS9EgexoZbDYYeYdUwMQHwJKdn5AzsisCw2GPBKIiWij8Bco6U3Ww7pJsZZZKLGruoqCQu/t0pKRIKlCTGXTU3Sj6N/179JyUzQh3cokk27nD1HJKXB131MwLxdjH+jwPWS/vPlX7AmTcp5bHyfwqiiuxcQI4wiOnaZGLHi2ni1wvQrMg4MvOrUIGZ+aVut3lMmV7Vjm/4eHJOkpXFKshBiPDekr97JWGpJ9x1RNAqYaLUnWUWdREqRPV5x9lS68i1vTsNHj6brPv1pfVaMOVld6WvNKzY2gFfPaEepYV7pf7SLMvXWqG3YjI4sNKZt6cw02HdRuuBFp6cLztqQVsmBtRnm3mMiQDrfLXbq6zfflm684379XS+pQEfq6hI4bxHJoZvBXDNXg9HO9nYRwKyAzTyzF89vvhhStLB/xQT6er5/vGZZmW5GvHCAafjAwABL6qOG79LGxoBda9R+gPmf/FE6/+yXKFvqpV63HP6V6zMyqBunCAJ1S8gpIfKkTgCwSRFnmgTExxWzlA0kZcBxlxjmJBh6RBKibknOdu47ki699ApLWaj7aWtXpeW9Ym01hsaJ0qLN19CYwOGxCb0ewPyuzfemW5WobnhQ8ek1p37pF34pvfD0TYvWtGicaoKl6loQMyLs+5QG8ElFgLrrwYfTzbd9N911221p7+M4HWt8KRhBq/qmWVFhTDipbstXnpJ+612/kk49ZaXt8fV3b04//8u/nebxQi7rRcYV5T7ZWMf7lWIENsglideDSap+LeOHiLWaGXFeQ+ZSWXcKaF/8PTaQmgNivRuUg2Pl8uVKyrZC82x1apEjaP/yZbIBGm/qmwnZvj/dNaTwj/IucRY1XY/UxIpPXjO8JzXu35xmnrhvaOHpxz48f2Lqwykd/Relma9W7kfvN40X7V7Sa/SEO7pD82vvv2UtngfAXIx5S+vHmAgYuzKoPS8yAC5gaxEcNE9pO8yTj5pdDIjjhDscY2IEec3zIoB5mYgZ7lW+z/fIHjfF4i02CXakQR5mlGliREBTIK3B8bL1yQJuWa7ztcuxJrpXjuI9mSus6KL57HrFAhKYLayBQ9XZyyuY3YrBsCFfZDOy0fKXAvMFM+qacpzMzl3sirytSPbAlYZPHLcRqxNYrkpZoi3sP2mwltK+XQ+lI7ufCHY32xLKtE7AvHv5SiMPwKLf5qwdjScbGcVMramRBITjQ0X0QDrjrHLKEgdi8MIHfC2GL7eZwWYGsqENz6HuuPli4O42x1hGuXwd2q8CixkB0SCVovM5L4D5Vd+7MJvhiERdvNDqglMCA3Z5FZtGxIMFJZhokqylVkeM6M5nXZ44dnUZgE6234sYquiSKKT7Jb7jV1yQDJorJeV1wYysg/K1XN7M+ubBCxgKJ2GS42TmDb0713VTGWbql5BxlHZwOLhqEarzwaCAesc4IyU7DydaEgCEMX/sjm+JZR3zRq5Ti8a6c6/UZYlZL7C3ZErAvDn9zfUPpicWVqWLNtSnvUfnpTFX5k+A+WNbFOd4SBE7xIy3KykNofkEzEfFQg+qmdsELtf0T6dBgUBOCWZxzlR51kpjrhNqs6GWfbBRzjshnxqrsjgzOpyiAC8kKbHMYQJn0Jh3KJ29pCLzxOlGgyxAPTjC2JNEAlDLzluADTCGfeCaZrS16OEfASgc0edXLZPTqEArOmw25i0Clk7gIx5KUUjzMCRrHo6S6OOV6dPa9sjE2det72vTMSV2vUlhBx3aj9Gq++CMR3fiVNmm0wSHaJST5ZBAbo2OCLqlvS9dVitpCiEYvTnRicISSZg43W4VcPY+EMdUmEyd8OCLJomw/MIEuJV9lAGDHK9FEVcIUz0hiUobZZVMpUbHiOj6zWarf9D8n1QZ6gTsDczbFGFj1bpUt/QCOcEfSSd33prLpDFDxlH91SEwPjoqCcNIXRKBq82C7i1g3ihGnCRDy0Trj6ixRgTMG7Q5GJ9U5t66/4+994DTNK/qfP/VlXPuHKd7coAZwsAMwwwZERWRJQqj3nV3XXW9a0Kv6KKrXuMuQ1hUFAUkKEFUEJA4MOQwOU9P51jdlXN1Vd/v95znqS7G9a5+PnfRC/P21NRbb3jCP/7OOb/zO0ulB3pRd1dr+cDHyTFY6SpfPk3uipEqATn3q+JMC2vXC6+eKU/4gVeRDDxSPvL2t5czzEM9xg0o9jioXWfNjcttwsTTzNAIo5Q2U6fijqXzyt6GPVAQ+0rfwGDZQgL7BedtLhfu3AINYxiDhIhYBcxrcO5c+srt95Q/ee/fBVe7rbMd+UB45gDzFjQnBcSpaKNBf84Leo6KksbcWsrhWrAuhSz6N+Z5XnusyRwvaEm5CcZrs9AvBKc+ohgWE6KFgaOMo5EtkzEPwTF//e/9TvneF7603PDc57OO6UnPdcG2iRyVyriPRNJwPuX88nWP63MvpgNgLigfQsv8gXtvRdFjqjx0cKTccD2qLNVe+pQrHxPecu9pnn6anJ4pJ8Ymy8kJPebdgMqWcjO1ML765S8yxqC8sAe97MU/WK5+PF7sai2sF+lHAvNas93rXqBewqe/8tXytne8o3zji18up5BftI6FUdtOBlsX+1kr19HV08scIg+mj/7dvKv89q/8DBKXRD2Z3O/7xKfLj/3HVweNK+uTVAvmuV1idZ+LRg6HSbb/6hpabYS513yzQym/Yh5KAvAzjWqP7kovePZu/tip4R3nB894GdpZGvY8plx9ye5y41VbynUXUKET+tfBURRuKGC2yHo2zZpoBeSPHpkttxweLROHH0SF5Z7SdJxIwcSh0jZ3arZ1ZeENTUvNv7V//23jcf3foQ/G8doiQvcyNr/xv7spvgOAOXKJbe2hypLh+Wr6Vig8aQjp0UvnXw1wKp4aHmwXlvjqKh7OAyUsX/OosF0cIt1SCQadcDVYrsoh652wiI1nWZigGAYgrUVNaz63YmGWynMp+Iowtl7LoKNUHpEK9MRl1fcVqJFNxMUxUV0uAfUqHc8rsJVYqaLH54t1OLRecdXlTevExuNIVrszxMlisRQe3474/jhV23ooDNIUGqnVxrF2cfJeAEZH7vt6OUkyTZ46DR+vcM9VTyH5E88WL+R7yfWPdwXIeA3WgQzcGudmx1LHHK5cUFmCp18V6AmUmNGBKM5RcdYjb8A+rmUyqi47t9l5ObmhpapLlYBXgfR6PXUTqhzsucZmWKC64iriwrncxCsBrBgz3oNayrZdM2oyeoqXTf6UymKRJO7N6p/pg8pRFSPL9omu8X9Ja8kWy1TMmsYSnm9fi3FQDYYA39nhdfQnZAzjJ8yY6vpzDCRFxU1c8cHkt4afq5on9XHTO1sXlImBHkc7N0HSoPimGcIfTZURIzifnTxVHvziJ+Flgt54b2ArvNzLr4uN/MDtny1tyIe+5ZefXv78b0gWbttYnrRjpRweIZS8aztyiQnMD7ChzLG5bsADPABQ05tr4uckgLUDgLZr83IZHc9ENRMcVYrfsgGFBTzmJkHKlw4llgAQfC6AEOof6nwDcFssSCMwZ9OdY1221P1QD88XlRFJQ7UVScXJKauDYnwA/NRGjyI71UITRll0HceLwmHQK6BmnEfNDwsdyV3XgAklmNA7VzNcNZP0xmpAqGXeBu1jGclDIascehNb1WtfgqIiYJUaZ3/atot49gVIUkG6oJHYN9MYFybCruAdH+5zLtmpgHCiAhonJpY2cM8mWLuvd3cthEEi/UcT5Az0HY2HlpCQhC5Dt4WsoLKSfH7JCNosB2Lce07NBBP+5lGCsZhSJxSYKY0Q2nNmqrEMbhoowxdeBx1uvkw/+Pc4tC0oZaGmbH/bWmA+hbd8gs938rwLbvwindnO+xZk2tAN/5xzjMpBx4LyWmyDDrjrvQOt5WNfXAHMdZevjfTHeqXYYRpbzE+k4F5x7Zny2OeTtIc39qN/8ieUg0cikHuLeQdtTlqQMpXOA/nujRxXI3cGY+iu+fPKvsbzoeD0EikUxPUGmB0a7CnrB1GxgHKxBa/55vVDkbBYg/JFQLCc6VvveqD88fs+Qv+rUQ+9g+92o8zS0YaxY4d4CTF2zq331ZIZ4+KRwDxWzKAcJR0pkvIrkOeYlloTMC4cEDnOE5grQ4i31PEfkQLVb1ojIVVvuVKFh/GYv+53fqu84EUvL9c967lQlAwD5R4UcLEC5qsgnBeDGlb5MkLvvNqg2unc9XjMhwHn+x6+p5ydOVEOHh8vT77umRhYczFun3/9k0NG0uRPa0s4/44hUXgAj7lynMSDype+8uVy961fDw58K1zp73n+C8vTr3tyrHV559/88FiLOEOkxoxPTJW9+x4uf/3hD5dPfeQj5eSxY3GOVQcEQF8d9w485e0Yf509fSjydlCdeH25aM+F5Td+8SeyLg/t9fb3/WX5rV/5tdLT21sOnhivnDAZmaxzceJKciFedeatvlZf7Det26urf95EjQN4eqaptyz37ORZDcwN62g9xgbNxGAx2Ii09vpd8N0wJDb2lOds7yzX7GgvG3vQ0J9cLCemFqGQzXG9J8rJkaNlgQqfvfOjODPOQAl0zUGivLnxj8jd+fXX/t4fnHxEU35H/snYRpmgWJr8GHPvU9+KRvi2V2WRytLagY55gOqEMwEKE3bE89RdTuyZL9XvuAa5IBsKr6gAayZK4BFxYCwGCZYS/PB66KqmhVwdLsGmK5YLm8RTFUVYfOcnRlmg21KX228HPywBX+21rf7IY/lWpZFe2RX5vWqih/JWDeBrnFbfU/xetTCqM+RLax/1WpEt5ft6W3nGwuyCOE/J+q7OHjZqrHBCprSszQAAIABJREFUij0DA1HFcbX5sgpLGjuCObyM++75Kpb54eiH+n60Ly583PVRYMh7lmXgQ19RgEeBOW1lYhoBZBbw0VBlaYE200HBBKUCbZRo9TBAqjY3DF2B5jp6kB1V3XvtdYo1082q9grnBYR32WuPEVOBz7i56tKjX89tA9le0fN5DRGarCIThorZ5LyHkLyD47q0iBRVeMylLynVVp3fc+vpr9qhNrBW9chj+ORCX3vMawOnSuuthkENmCsjo7rU2mvuEbJuY1JZcswkNz1k4+w+eyCGVQI8H7HfxrHSsFq97eoTQXuxPT1WtGNSauIY9iXnmp1AleWWjyEyYJn1UoZ3XVy2XHx1bMxLeMm66O+ff+ZUefPfnS7TXevLDeeXcoAtYuP2XVBZtpWD995e9h0ZD5CwESm+fgvYwNO2kMk4lIl2QOnuTfOUzs5iMciZR7Rqa1T+VDHbHlXVxGvL+wsNaz3NcMzddAVwgnNpIcrDLeEl3YCayCy856gXxDxubcdDP5kTXCAsOPdY4aDUAx9jkRaWz62UIsecgpKzdQue3mk88QDQdbzf0aFEn1U7U75Q0BsF4VVkkZIirSPGT1Pw6DcNLpSxccYM99YGjcfGVgLSqJ58b+eMggsmYkZ7A4rnlHXkuxtQLjE3xkwE28yHuu6R+0J7tNKWPaGzTgSAOWu0ADsSJRgIHHimHdbSR3S0akzozTaHYtFIAodTGtFHGBh453AaQ2FYDjqNeVILpb9svfJa2rapnLz7UzgRJjBS9cx7D9l3S7jgu0joNHl0bKoV4Ct3XWAFSCYaInjf2IeqDeNkgsqgMXdibEmXOVs2DnWXj31+sRwb6y1fHYNTi8fftlQ1x98tRK9ufNpyueCZLyDKslA+/Md/Us7iVDB/QKNr2cQh296CQbG8NOEpXikfv2++3Lu0rTz56d9VhqBbNJOs3wYw7CRZsgvPd093N4oznRg2HfEzRELiIA6L2lCbIheng5u549695Y/+8qPcJ+OfNbIPLfNukj+7sTpM+sy1x0F2ziGUy9s5UL6Wqmd7C7T1zjdjANYSfTV9Jt7n+3WUV2+vx1sgRGMSf+3xdr2yyvFgPyoeXIM5IAcO7C83/e5vV8D8u2gHoywJzP1Xe8ZrYG4faJDm6253uTP6/zYSMYb7oLLg+T52fD97wb1lFOrVd33PS0M8QIOih7DL7vUmcgruI2xTToxCfcOzvo78gwacNF/84i1l7wP3Rlt10Z5Pf8bzyvOedUO1HsdXwtAYh6bi/Rk1u/WBB8pHPvx35b47yE85cqRMjo1jmEyHkyENjVzPjQKr4y6FpQOjqwejyWTJnsFN5drHP6H89H94RRg3KsL88Tv+tLz/Xe+GjnOKsZqRh4ii5rJ47u96oazfrzbXKpCQ53VZDcMpqUZBgwoqGxKUGHMd7aqooCN+tqdMYwQn8wW6G4koU7MzkfMV+L9yVEWxK7+/Mk+dASlCG8tjL7mQCAB0U2mXrlkA8UWiThklJWhbzr5tsXHdf/mN1/zGkTW38B39lP58Eg2wmx91yuWV/29J9nxkI3+HAPMOgLlDP0NCtQdxdSLlwMzJUQFccWXoh/utygNWT7iQvUvUlt8LJRYPncfxu3oI45SRFKfnhfdikXKj5jNkSwlkXRgWqAKZyZ/scpjjfk3PpY/whK2e2DfOAbjqA9UKkHhwdUGIiZ5HqG6sMhJyUXUBiIm85lGDr9UD2hqxoOciHMmzIdNG9jpe686unvD+zqDv2t0LMFfHrGrIuMpcbbJNef3BOz9fpvBQBHgLjo5t2FAueNxTWfio/FlRKTx/3DNtYylkFU3WUbSiUXksqgHOT1ucB43rHrxh6IDHKVcNpoDz0X7JCY0lvvpM3UePCBnGqpwgOmlKCW7qpgtTrmqrMFSqP7JtsrVWIxn1Zhr3nKBtGQBhopwDpjloEYSQqarWAr9cz3/KedghVV8JiQPMZhNVDqe4h2qEBpiOjTpoQklNyf6uuOjZ89Xn81jpD0zT1M/VRpf9m0ziig/uOK4iLvW9VXe52o4B5Ff7OLvdRxSOquZTffYE9hmRsj8Xp0bLXZ+1Wp7RF4DmnsvLxosfx5tWdp1BHHZd+enrD5fXfWi+rENK8drzltExLuiY74Ivua3sv/eOsv8wwBywtImiPz2Atg4k+iYtMAR9gkB4OX/zAqBZO9KCO7RTBcwnJitpQjb1JYBeBoWSJ27Y3eTASEIFtCoDtwJQnlbzG3A90IP2NgDTZM91gLcWgO/YdN6XtIe2SoZR1kOE9OkKjRu9zG14+wQe4xQk2jyEFxuvs5U+HeNyszUS9BQL1l1fpNF4XS1QdIJCojeX1xbhdw/3zwHs5WObs5BOhdr4lCcdxYnw8FpgyMGjt3wKhRMYYXBOXX/wlAPG2+F+u7nreXdsmOiqfrtFgZyAjZThnud7syi6dNLOXofDaxa++iKvS5vpgY8uFWZRgMww7sHObJATb7VQ1W3Y/NvQNp+DatIML6dr5zPBOSi2HLylzJw+CVjjc96HYAfjx+JBcu/boeiY4DoxjSIPqjxWc1X1o1VKCgbTYHcqhEzOYETQAFYF1phowPO3hcSDj30eGsax7nLr9CD3OBPvNwXQFpjPlB95Tks5/9rnAd4mykff9i4S4OCYM34iEVpVIvptHfdh6aOjjdvL6//mDqIVK2UzqkC//7qbWCc4v6pUrtuAuRYiYW00nrlC7fB3BXf9VPXswjKp14ZU5CpQWe4rf/qBj3F/WDysbZ2A+n68xO3tFFKC7uHaIyiNfYM5nvQUrwdjqcqp8fzBGbcVqvW5Wk75fgLaOrqVwyPnYH3cWBWDX56GQHjoraXBmtTfizFDm5ocun//vvJ6gPn36zF/5nORSczchgDisfhlJNKnzp8A4x4vPOUe19+uBM4BOOYBzLswLEdQ+PhcmScP4LnP/8EyY6SHz6nKMtzdWK46bzjoZz5OjuHlPjIC+IT6hvn26U9+ohw/ejDuvRdv9VOue3b5boE57TRDFGAK+sv0HNz0yaly3/4D5b3ve1/56qc/xfiHQhjc+dr4ycjBuYdgton52B6gXK95F3zsdWh/9wHMX/i855aXo2HuvVhw7M/f957yu7/7BsZrFtCKuh5clIds0rkSOQYZyQiOv8nVRC9aMVA6HCcWyyJqbjStjb97ohJ0U+QnNBNJzSRix20mErtHRPSe3yas2s9+dhZgfgLZxrvuvg9v+GwYXEYB7MO+nu5y5RWXkri6LcarOU5ZSI+LzH6DibP0F82NTb/0y7/86/vWNMZ3/FPGOJtSuYgfrS6LCLF6f2se3xlUlg6BeQIT1wiX9FwqErw4/aNqZ4Vga0mq+LQgIzFaPII3LIDjeXh1I4qUflWXvgqfhzfTY0byZ7UwpSwbiz/er2VImPI3BWALs+NBa2hhAQh+ORO1TkqskV9gtkRXsdnqaQkaTn1llaEQS3UGBar/VZCp5vGs+coqmvKTlVWfvOkEtzW4Tr1bG8nr9wdJKRZAM9YNE85AxekUmONtifNXG0a0Y3XRAqMHvv7ZMjVKIrPRUNtQugQfueiJT6P2AV6aaL+4wcz2D295lfzJpr0MsljB0yzPvJFFs1NpJ5Jy8pZqUFv3VPZX3JcbVwUkI4z/iHtdRb5VH+cla1jZd5WBlUeLza06clI61izs9XoXn7GPsquijZTmCPDsSojHTmUWlWzWKVtl1r/qJy7u1dFrkF6Pz2ooxhXUzFNBcK1iUwcH0gjJNojtPDZtbzkBZBp5uWn6r04AtZ0iWrE6yOrB5j2svet8PcdLReMR2Aog/Hq1z507Vp4vBqWbNNGWOTzm99xMgaEqiWzLhVeV9edfEe/v//zf4gUbKjc+daV84MEBuLsD5dL1JEgDuDfs3F02Aoz233dbeejQWACBjcjx9QDi9MrOA1pH4FKz9ZQ9m/SOM2YEEN40vzcOsmlPqD6QXPcVgLkJjjHqeF9pRRtJUCkf2qI2jptp0wOgN/RBIVnkOhbwJPt6J9rToxZj5rkgOPS9+cNaJwJzpfc04hahdHTghXaojJM+tZX8rSn48ME95/wmfy5BkdBjLcVNYGji6VnO06EKCfNJBoFgXYrIcC/haJJA9Sw3cY1hQykxhLdZb7/zTg++NUTOAtQtguQP9nTZsTmTkBe4piG85177LPxwAcuCRc84SV+PpYYE9iRt4vWe5VwqxKhJLklrnnMtzTXTLhRLwpu9QqGluYpr39cL+Kiqec7y3VZ15mmb5YbeMnDhDRg1VHU8+uWyPH4kIgjNJo9yLQ0AcgF+J9+VskJTRjGnSQB/B57k8KTT1G1WL1XJBy65fSRY1sDqBODMk4Cq9OO2/tbyoa+cLQ8f7Sn3zqfHXG+5bCK5903QyH7keevKnid/H3Snk+Xv3/3+ssw64nUkSHV+rCv7lobKyo5rqIK+HgD2ugBC5gK99/3vKxs3bADnSIky8RGAHlxygU9TgJ9WGr8LT7pVS2sKnXPu4LGR8tb3/V05fJyS8zhn5BDbr/2Dw4x7NLtR6OpQY9plHGCsQaEySQuArQm6TQ/UikyQpf+rgkCCMLnhjh3pT0uOAQabiZ0B7mk3PaTmNTmTM8LB+h0DJJ1GztBGjBMlXLuI3Pqaxzt4YF95w+//dnnRi19Zrn36c5Jj7vJmO7mCuM9V4H6WIkF+X495vB5tWbkAnCPcw3pUWTZA+SHJptz8d39RGrr6y7Of98pyEgM31h6uZ0tPQ7l0J2o6RpW5slOTM2Xf0dOA0Vn6cq587KMfJmJrUT4TiXvKM5/x/PKM66/h/hZp15PlATzif/3Bvylf+exnysGH90alZWuGxFrNOaTp1MaSx4htNJYpAbCF/gDNSAF1YFR1A/ybO3tLP5KuP/kjtMGTWKe4bylA9yO1+TeA87qoWIuJ/SqucTzHQ6grcTzV19wrbHujpLn3aWS5p6X6TVSEltqEYWC/paJPRkG8vFDJyaUm5nhKdeZa7DF0eHji2LNds2ZZCPnbaI4Vxh0rdSKy16IxiQH411Qd/r9+9mdfe0+97Tz6O1uA8X0lvy7hx0Gop/xbyrP/jgDm7VT+jEWkkngL7x2bU0zO3LPPPSJc6P6cgMwfF7ZQoAhwl6H6FZVCeB55mJV3O8GzX6pBv8k2CYz8n94KQ/UeS2CudbwEIFsYO4G8aC+eIRJNAtdWFnK1YJ4j3yQ0TMB3jl6Q4bMEpuFdTXyReGiNhz2BfP1IoBSPOiJQgbZqYFb4tQK1bgYuNnL1SL40VGjY00VkknLE6pC3kb0etB8BbbRFReXwFCwM937t02VmlPFdRRZCKYUPXnz1M6g0LDD3kvXk+F1DpiYg6Z6B64o3bxlOsdxsf7eRlNOK/mqomtSV0CrAHdSMVcMl+zeaxcWsRo7VZ7OnohFqvH6uiep2dfEOEJlvxbEqp8Nqi3rP1XsB6qtP5v2kl9INNjj6S27ILI4s/s3yAtmZw/sdfZUgMc5RR2GivWzTfD09+Dm2gt/MuQOs82ZNBYqRUl2v92gbrNKxcmvI643xn4PlnEZ5elprKdA4X/Rp3mOcKgxPn2USdGg9h0iMz5X4W8Ozj6Em8NfIgs4xeqTcd/PHV8fw1kuuLkO7kYeV60okphWliyt6vlRuPb6+NPYNlcehYjIJ8Nu0c2ckf+6///by4D4UGWiPjSQqduLZ7AX4Ts81AczxzHFdO9fDX4ZvbtVHqQn2wZbheTjLSR8TsNqlKql4Gxl+TxqKNA0VdjqgiUjXmFxgc6XF+nqVVnOlTtpJF/ra4+OOYc4p9xmQrIEexYlczgGMOrCnuaYeiu8Ymp6BCmPypvT6M7wvbNEAWASY2yvzYfymbrfX3oVX23lgfwgABWV96HXP0h5ei5re4WENvfPk0Ahc5VP7Z2ing2inANcKLuzZAZ0E43oMo2X3JiNRgPxpqRpwx/GEC2D64dKvMOdMspyeIXyOxmM7VBa92xoJTsllPjvCVO4HY7W0oz2NwbOOc/Z2pzdSLXyBnWDA4i/d5z+D628tp/feXpbGH4j2dby0o+Iyi5FiZEDHoxz1Mxak0TChg+SYt+OVD2DOedWzV7WlG/d9I1FlOfVqWfeQ8Dk1xfm4hi0otrzrk43l6ERPObjcx7oLlYV+bqVdEIMp6xZOl3/73e1l1/UvR15zrHziLW8p81xbAvOGMtt/cWm58BlUddyBYdhbHkZG79U/94v0qdSrhvKT/+dPlZ/88R8P73VIiErBC6+2Xs3kdLfgSVfhxPcETlMApU985nPl81/6QplrUB/afiNXYOQ4ayrUpFMnyyhOi7GTFKqxv2lnvbUbiRAd3PsQoI1z05YdRAqdtEMbNlFk6xjjkMgC66EGg+txLxSbU8ePxTGWGMiuKa148y++4jHl/rvvBNDOBGA04nvRpReV9SSsbkK5owMwbkJ9V2c3DpcE5ipJHTq4r7zpv/1eedFLX1Wuedqz6SOBp+tJ7o+rXHLGoMmzrqMaw2uBuQav4N2kTgsMyTFXNvHNf/j7ZQfz+dobvp9E3Vb6lzlHpOrKXX1h5ApA/d6J8akwaJbYexagUN78qY8xRrhnjJEekjJf/P0vK5dccn45NTFeXvNbv1X+9j1/QW2QWeYKURYT7bkqIxuCbtvVSF0Cc+stZHQk78cIGnQewHMHHC0rM/fBt2/vGSRScl75tV/4ybJhPfx7usfkUalU73/fOyKpOjd9JT1ryUuu3/GvJRhvVWo7OGEExt6b16DxkUZdbNa59vt65BjU0e2M4kWUogLorryuBRqCqeaVjpeIRrvOVnu9QD++w99NgvHYmFY+zqFf/TM/8yu3Vsv5o7/WtABtpfV1eSzOpdBWDae/1Q30HQHM29rhmDt1VoFKAtf6zxirNaAVIDnItawD4SYU9jPs/wHutdwXUVIJPhiLcDugepWOUIM3OeZBo0gwHZNRTynecT07LSQuSmWIzZiCK5aWbyEstcIi3cjreh7ORvXENAgSaFXgOyN8cc0JONcMm3NYOD9ff7Sa5AEZ87biR7lDn5zz/NaIPuBcteAkKFTuweIwUygZyB3shN8n4AwADUozc90F0A2nFVpOALVoeL+7VO7GYz4PMI/2DOoGCy/HvfSa55BkQxtWyLZOdkw+Phs2FWJWQANLyEqu4K1fRzs1sdk3sZm2UsWsIbjt2aG5MGV4PwFCfQvV83MdXXXOufuNJq3aLBe5asG2G6qvJ/RKMFe/VvdDJKF6boF09WZcg6Avko8AiVB/zvJ8nYlL/VZV6wxvSchy8k+jLLa3oJNUt1VfotfgfcUiXJ0jvpXPI1xaDYwgrNQe+gDVq1+O76c2dh4rIaH9UQ2MQPE5ISIA7j0F6Ks95dWYi0FUpaAGQMkLTX58GgZ5hNQN8TU95mNH95cHvvipnH+cZ9ulTypDuy7ib4CObQFqHRxFDq1pM+Wph8vjtgmyUYvYtqts3rYlkj/v3zceAHgzvO+zgJOh3iW8p03lBEmV4OWyfQPJoYBgva9yYt0kNw8L9LKd9DArlyh1xfU3ejQ2tKb4jsC2VXAMeJ7GKLS6qDQNacgqBunMM/HytMovoO82AIXg3KJCjRbD4XMCWL3gs/R7d1UtEyGZ0ofuNrRq2t9ETbyd6okvaGCqCJMJo4JgFVp6AOYBeKLIjaFsgDlUk9lZ+OYzKjvpKbWtTRhN72iz1S1JGg2QxDWoJDODh3uJk160B0UXPNmnT7eUXdsWoIgAGklI1diQ9+60lLLjtXWgpjI321pOjVnVc5mkODnxOQPUUz813oixwr3BK5/Fe76CYkwHwFoet/dyhntvZh0bvPDp9CsqKkeo2LrvXtoI4wGnRBvH74ZLPjmBMYPRYul2lAPDSAmqCIz0MYG5ai/m3LKudLaqbpPRCT3NsnWmjUhQHXSaKkbrSAwdgGL0ka+2lr3HO8uhFTjCRqcEzARLwPWlYWGkfN9VfeUJN74Ep8Lx8ok/ewfGSktZ6r+stF/+vaVzeDsgFzoKJxac3XXvveVnfvrVAYAdO09AOeTP/+IvWf8EsNkvteEaf/MZgXm9ps7Tke+D3/z5z95SNgz3Ubjm/vL1b9wRyZUaorEOBqjNSKXeTBVR6mU9Dd+cg3UErDb9I0pbgcxYCap5HetTdS1SD8MhUTkMwvvq8QB1vSjCfPf3/QAJjD3cbzv5D1vie3pYBcJHDh8sb0TH/KWv+OHyxKc+HSPvHA0k85jsl6SyrHrI/wEwz/c7aNOQS4RjrjrLe97/jnLB9k3wugfKZVQJnWVyIE4DL7+LXAWSE7gfiy4dRi98HLrkPGvn1778hTI+coyxSdIsRlMPUdOXvexV0IE6kFQcKS9+2SvK/bfeVnmRM+E+QCn90cQAUN4xJm9sS447gXmu20rFmuirEINUlm5kI80luPSyy8p1T7mhPO+5T4s9Jqg8zIHTo6N45t+ZfVKB/KAFVsaYhpuPVdGBaCcTvK0ETHRFNS7mv3upD/nkFjmKfAGehzFmf2pk8byW36wjFKn+lDKXftfnftck4/o9KVb2Y1CTlle+hEPi517zml+9JU746OMftABteDEvXhWbXymfot2wlL/1j29/jvnTnndje2vbTQkEs7UDiCSmcNpUwKZG1CxuAqx43c8ngg2vuRJSeDsX8H4IPhvhTxo2bGHCh7eYzUR1DRPo2JNywYzFNpYBNjkK8SxMokwwS3h0MxsFFdZ4fX7ydHzWhxUh2wD6zXjPw9quHnWlygTpCdBW36vBZv36GqyZH6vAVXUt85REnzpxkmJglNrdyEKs50dvbbXQJmKqvKOr6FOJU0AlPL+JkUzWbsejE4uOG4cLWmN7OXLwAaqwDZf+zR4XioYtrPoFSSh3fvmzZQHeX1Asqo1imU649NrnAsyVCTWkbjiazdcFh/P5WXmfLjAzU6eomskCxWbfYNuTcNPB4tmomo0LrJtDHCVBczZLenfqRsut75y3OdBpfe9xK/Vn64b3OIHyq8FTAdYKw64aX/nyuT6Jvk+A5v+mJ0dpPzwoGBpLoQFPgaT+IRZSOKrcWyyklbVUBymT5p3nDpi1pl/cCLSpGquog1SY2pAIfn3QjypvsJ+LlqnBd158AGjbh+dhn0W3pyEYxkcA+ur1fHfVIIjm4KWg08QU8Trrv73vBMChCR3XnnQox8tpxshDX2FviAhAY9lx5TUos5DhKbFGAWs4k0fv+HjpXL+hDAxvK0/aSNIvxmz7xm1l287t5dC9d5X7DowGrWE33uc5yM6DgEMEB0gUQ1UBWsu24QVez4IxwaMGEG8YgN4CZ1k6U3RLYlfOmpQOb8QERD+r9GEHvHCTMqdJnmzhwwy1oE1ElUAarLezkQRDIyLwoKFkCKZV/wg1Mw6oV912VcO7D4+5CVnyuLv43hndvzEvAQe0jRUs9ZqlvCbAE2/1AoC6HUAcCqUWEwKJ2o49gF/11KfVBqcTPUca184zv5Na6jEf6CSpzHLvF6CzXHkxRVlmW1BlWFe2Q/fptionx1G/fOI0oXijDyjdGA7pJgoxS3IeZQqYb1y39c9MoLSnuJa9BwHxaKp3dQrgVUaBO4u33Srf4SHEYB7ccwOUra4yd3pvGdt/GxhZrXAqfwKwTRwV7I+NG8KXX0zxIdQjlqEkRR8B4OXS2xZGEKTgqA4jf1evuZ9pZ96PoVDT3dUU0YtG+n4T2ukf/WpDuetAXzlaSBA/OxsRD+UIbeszs6fKjr7p8pJ/88TSgob+Rz9+T2m89EWluW8b67jnIyk78j4wahhEX/rK18qH3vu+Mjw0WK687JLykpe9pJx/xVWsz1LQct2swXkqo+hJz9elGOzdf6j81QffX7Zt3QBXeX150+v/R7nta18NIJvGYLU82WF6bTXAIqJbrT0xTD1HzsGYtpVHNQtAxQdznYvpuHZzOEc1iS9Wb9Xn9O/nfu8Ly9VPvpY+USEqr8XrFgzu3/9weMxf9oP/R3ncU66Papdx2TXIj+cVOM/lJK49GI8C2OqzHlOqx1CV/DnY2wmN6Fg5dXQvFVG/VH7hP/8U84d13TWjKqA3CV/68ImRcjeG0QSJnCYxLpCf0oWYfS/7xTBa45dfdHm58FIcnFz3CdTBXvzSl5e7vv6NAOYacvLofQjMNaTcr+WapwGTwDwL1FXON/qOCHuA8k309zOvf1J56tOeVh5z1dXhOEvvs9h+BWWo/eUTH/mr6JF22k5jxiiDnunaK2cRPl+LawjAnp2dPHwdA6wYQa3JxvMY3ozc8/p7jq1QjslQ8ioAd8/wM/6uveJ+z0cN6HMNWPk6L73m53/+tR/N3n308T9rAca01BUpLD4+Sxse+pdqqW97YP6UKDCEXGK9YFUTwEmQC1j6HiKwz38xSfOFeARY4ssqGQgzFgGLS4DTJYoKNJO84YQ2OaMdlZCVCIsJsPx+pZGhBzcsArmmM6VhcSoX0FY85lEGGm7s1Onw6rVhpespaQK0NbcAOAVrht7iQhIf1j7R2mOyOnD0ZMWl5oackzP+n1+uQK9/Hn/gLgCu5Qi57t7h0rd5U2VEePkJsKJt4qv+zu+f4b6XKT4wdmgf9Tig3sDvq2X1TExamp8OYLLIZja4bTeAmZ2cg7kAadDc9+XPEYLnM1U75+LVUC657rlxrBpEG7KfOImU0/QExye0vml7tMkcYcwGE5aUayRhVu+m3Mv2gU1syHrNE+jEhVc7T3qXvYpsOfXXp0+fCKk2N9bO4c2RaFNvZtlkfiGBdd189YZVt3c28bm2rQsOxdDJQEeETJc4jwaN+uXmECwTVp8fH6VvkX/EI2ciq2HkRiIMVn5VAzqbvvJW5zZc/SfYzQSgZTwty5WOb0OEaQXmArIqadhwNceJNLCK3xQO+LjwrA7qPQtyfLYsSI7PnZsTCbargRfjP+dJcs41xup9Pq81/vm56N/8XqrdCHQD64QUAAAgAElEQVRzIzQke+Kh28uBO9wr8hp2osozSKhY2oVgbgkj5ugdn4RTvotCdevLZZF+wOY3vLNs2bkN2c07y/0HTkUy4h4UShZwY3cz1OQ0H53AwwpA3havZ6g9AAIAe7APNRRAaMxI6S1eIt7XNFpynMg4XwRQN8n9xr1q2N9qnHqhO/HEus87/gTsHbj3TozpkTfx0+S2lG3UYx6MFKksPJmAUhNJkdV0auX6PKV86BiuvGOCpjxg29tlRG72PPelrroecdeH4LBD8bKIzxmuf4riRoI4dcv1MqhBriSiYFtOtREa75+AE8C8BQBeytWPAZhTcfOBQ41l15YlPJN46wHfjZxvdIywN4CjD7Dt8aQHzeBFV3lGrNEBnUUJQbXZmynI8+ARFHHgo0u3mecYy0t4wam+qbGwjmqCgxc8lXnbXuZP7yvTR76BoS3FR2k+DYF1gHqoK2ianxp1wJgsuszxACHzwGjkLG0Peewmx5n0iU0DlYWkW85v5VBpbr2A6NHpM0Qh1gHMCO1zjWD08rdfgspyugtgTvInKkihcINx0cw8nJs8VK5AGeepL/mhcsfUDooEsZaxlkvj0KN67OTJMoKc3ByFzJqYZzu37SiXXHEFPPDB0gu1QSdMJPYFhUV+OVQnLIu60mcddas9m1/4wi0xJsaRZjTZ+7Zbb2UdovCOlS0BXPX3wrgy8qSTgXncFFJ4FZBjHHkOEwh9hIdd+kxMs8rRsToL07D2u7EaxvKRa0hynXNJiZWA/acbr3k3Ecv6usN7zMBZRgHl4YcfLm8UmL/y35bHX/PUALb/EJj7+Sq+6jmktRgt8jQBznWOKHNZJ38yNgDmfd2t5eDB+8qHP/pRkhN3lwXpcYz5EaKq61ib54mQ4lMOLvymDevLho2DoZQjjfLo4SPlou07yrOe893h4fbspycmwmN+65fIYQgA7Xojz545xQDevud89topvPWDZe+Bh2ONHUQ5Z4bJ18f9t8kp7+pEuWh9ufqqy4hWtZbnf+/3sFUPE1kYDvpKRL5dUzAu77nvrvKFm/++4n+rOmPOWCqq6MW2jZMznvxveek1nz+iGW4UXEUk3q7ZtL12nSuBOEwCrjzmTTjqBPJ1REVFtIwQm3we3oA4VuzJ2eb3QOH65Ve/+tc/kL396OMfa4E19BU/8gX6cd+/ZGt9B1BZKDDU3hk65gmuEmS6cwbQCO9Zejd8ZP47n6q85rWn3a8to7e7AuhsAAw2GOpj4ztDmFQuYQtWtoUITP9SxaU+bkCPcFRyVCz1MyQvnmGnnK1CmHqg5kmebASo9w0LMK0EiddFkOYiFytvgvzVe6gW1QrBVUC6+kCd5BlfqABddd9W/lsEII9QNKJRjjgSTC1dg6WDzSbvPptmlYcdf1S0CVppGcNiEfAtHSOVJkACAoMFCzMA8gn7Li7OBr+4paMvys1nGM/GWyx3ffEzJJrNpMct1qQEIpde912lDamxeARaAmSRlDV16jTX2F76KECjJ/UMVKCzxNAF+WdZGNtRZZmj7dooK9xM++cjN4F45m9+rGIYqUo8Hz9xOEC5C946Fjp1cHtI7Ak1Dje4oIiskUd0gavboT5mAGexu9df30Z0VrZfhYBnJ8fL6QN7Q0ViaMsFpYlFPxZZkldXDC8DGOZn4O92U3ylpa+0kwBW338cKO4j/O45Fuqhy653+vBDZXqUqIcau+u3oGqD911wEDzXBLx+KQ+hF9al392yfj3pLx43Izt6E5NXnupBVf9U8yS543UUpfqODSrgjutzDnGeSr8/GCJVe51Tj3DjoMz3/d8oR++6I6g6Rmp2XXk9xuFOfc0crhld/1Pl8N03l43nnQ94GyzP3tNYDk9A+RjaVbZu31qOwDG//9AE3PKVsr1fdQJ1tklCBgAftwIkoHoLlT8XKKIRIMNIF5fa36WqiiHfBAzqtesZT+9yRlY8/5zJV9yPCY86tuVfO1678dya0GkEx/HfjVziMWgeGkptgL42vLXK+dmOtp8gfhEQanGfXpIVNU5iE5V2GlEgtaJzrE3iSdbXFd5XlEXaAMqCZPniepKllrTjwddg6LSoD2B7Tk407XwGCondXXPbLXlvRdCo0skHZqCwjE+2USlzuTzt8RZtWVfu3t9eztuwCCAx7wVDAJnEU6dS6aUXYE6LlX6m1JxKN6MCgpRGpCJQyCzOzjaXo6fWAbASwM+SvKekZAce8GaA0tDFN0Sy4uyJ+8rMkdvDMxnFk2jrWY0jgPLGQelwUGIsbM3rhvEH+rgGKC3aGuZOTBM1aMEQicgQx+9sZ95ys3q/51nP+jsaAeZLZRBFk8Mj5Bvw9xAqLh/6UkO592hfOX4Wugkyexo7zXSiKjHIO5XuS64pg7su4b5JYGf8zBIFHWO9mcFQ7meerh8aoJrkxWX77j1Z/TSAlH0GzTCUWHQK8BtAVAOhOmJVLUQxngRP995zWxicx0+ejoTvI0dPhnqIACz3naQgKMsYf4czp9qTKsM4wDf/BOZ14Zx6L8vck2rtWeNB8LWY87VzReBbeV1zS8i1xcETY391/UxnijSrvXv3lv/xut8vr3jVvytXPvkp3+wxD8M7gXewDv0d65TRjfxdc809jcDc4kJW8BzoQYKQEMwYXvOWhoXyxj96W0SGegHHW7ZtJ+myj7EE9URQzYTpxImxhKWtvOgGgPVleMn7hzZEO6UzxsjUTHnJD76yfPmzn6s85hq+CcxrwLxpw3C56OILyjOvu4a8ro6yeeOGoKLOMPb6qJTpnvTwocPlSVdeyXsbI3riHuH9GOkJY0sJUfb9T376o+Xww/dHoq/RANVQHA+2SdJ65ISbp5JVhM3HUmYx11vb5lzOk9engRdtZwJ4Ffv1fAtMnA6TOPWcq9/q/cRaYr5FqrhJm0kQH/2wl73gtfPzje967Wtfm43z6OMfbQHaq1ZfcTIIyvf/SzfXdwAwf/aNLW2osgiIsIxjYcMDkwoYuciF1VqBmdUKkBVn1sGf+BYvABnz7UzmObwdM2h3qxkbckjKWLEJRaJF5fWIML8LoZPQY5vpb6DcBY9s/Bk0VJtj0aFIxtGjpW/D9tJiMQOAQfArDVu7CFQLcnopqwW4Ttb0ulYRe/VHAOtqWMWbee2x0JL9dYYNAV33WMjl34VEGYbGWaXE4kLzJ8+bINlnsaCzeC3Oj5dFYtsTp0+xgbJQuQABzLv6kZfq3wDHE6URgHkXKisqFjjSM3Flsdz9+U8R8p5BNSM3kTBi+MTlN3w3GyQoIO7FRccKg/IQ4Fny3SaoHlZhW8Iwmp2bLo141towKlbwKKkO000xhWU3yFikUzlHaJGoxc0vUa3eodFDB8uS4X8Wuybawc2/b/OOKgmoAr8Jxdc0ZIL8hFt57bKSPaNLaEhn5sVHe9fPTJIdO0K8n5B89/AugA3ykng8lxg/K0ZPaBPbawUEtQ4ObvfA+ipJsqJCgVzTmyKwzp7UWzQzORag3OQjvf6tAIWu3iGiH4wfxmLwzatqn7n5Ji/UjTd45Y79uGavVUBQhc3560wN5kHoORcEqxyjMqKUCUwpy2yjOE30ZfLibYJax9wEa8eSn6vBi+c89sA3ysG7ASu2M+/vueqZpRtKlcBLatPCsQPl+IF7yubdF+PB6ikXDlhjvpE23FG27theDj5wa3lw/1ihCCA65nIvMdIAotPwqE/Al1bz2iI8kYflvPdaed7dq8KI3jyMkGjNCpTLabNbY6PE24UXU2BIvRfLBYVaiQC5C1BoIqmbn2C2C/rM4RFvXgUTPWZ62fkJq9PkO/ie0FxOQQXppwKmLwvaG60AxtdavFeAfmitA66VDFTVQVqMSZFpQOBpRa7Qjbeb1zXkvY5FqD2TJHR6ICikDnrGsjkbcNg5VwvXM4PeuCBC7vbpCahgCLLf8IRF1p7l8vUH25GUXASEch7apo12PHVSbXAMDooCrQAOcCYGlWUU3r7X3ItXWjUbKT7e08nTVCHtQwVlE8bW8YwOdA/Dyz3/qYCZpjJz+I4yO/JQqOIY0JoBvOvYg5obXvBtW0huxWAZOc2ccH4COgb68ZTCX0+DicROKDIaDSadCnTa1fo+O4/nvJV1WFWYFhJZ8fLD9z9wcpFoAZKQfVBZvtxYbj2wvgD7WEelHdJuA0Nl02MAZBu3YgycLiePHqEfM0GyFynHxz3msWX3BRcwl3pDCrb2auookXNupV5Bec31jRlZzaMEpVWCXy0GwGsTOA7GqVMxPjVXTkABbMcrf+jICagZaHlWczGAVXhPFRYQkKdxnfOzXszTaIvXAhBX8/cRz/Nb9eOck+IcGMxrXl3fAjznT8wBp7A5MUpq8qOO+Z+86fXlVT/yH8tlT7i6omJUBm8uA/GQahXkOf52jXK1WavO4uvujxYY2jwsMEcjHGDeSdTpDPTOkyS9vusv38P+NM963hdqIjt3bC27SH4dBIAbkR4YGA61lMh3qRbZ2rDwxBYce/Grfqh84eOfiHVT6pc65t7TlvWD5fnPew5jYKDs2rWrXHLpZVQdPcS87IZitL08xB7czPp14XnnlQ0kw2Y/a4zp/a4AedVOs0QqF2mb9777j3GyEQWpEjDlctuPoeXu3rrKZa8NL2llFJdjHLfBkXdu20a1lHLy3XOt9Pqzkmq+77ruvXjfgnwjeX4/vecpjcgacRhQ/1/JmH8rgDz5M48+/l9bgHH/BD5AVaZY8j9DO/6LcMofeZHf9sD8skuuuLGvf+imMdwyHcS7mwCLUV2z8hxkklF6J8JLXul/mqDR0dYbHms9y4vKGwLykvfNpofn198ZXgQKAhINvwmso4QJnhmX2sX5pdIqD5rFdlG5P5MZx0mAXIL3COBsosT06MkRPJ5bIuwbRWg4XlXjIoCaj9Xku/yr/i/+Cm98KM5U4D1A/DmgGKoNvDJLUYU2Clk0S4KNBYQdmROtY9OJs1SLbEg81ui+PoyLkvIOhDcXAMhnkVDwvgRjJw/dB4hBh3Xz9rh20CbXl/fhIyWhFst9n/9EeIr8TnCTOasL2SU3fBcRB2kv+YhTSlmhvdysF9jEFqEONSzPUGX0VBkc3lC6h0gaIvy8bl3yQZfls8fmome3aqKIyGdFu0hQNVpw5DCAnp6xL/F4eYVD0ChS0DrcxQnC1xg/lZM5G6hqo+CP+pWK65lRDTfnc+B8GUNoCS/OEhESuYYaEwK22QVUbai+phdIQC7loJ1E2gboLOGd00st31jDzQbRg+1zNz3aYwoqzuSkycdxoUHF6SEnoRvO+orjObFi3HeC5WyQ8BBro8S2uaaPeTec/DEILKDjRlLdaEADjZwECWnkZWTJ+xdouk/qRdablQmK6Ymr1XkEsm5y8Tpj4cTDd5bDd3wj/lY7+bzH3VB6NmwjsXgUD+uhcurYvkiq3nnp4yO3YBdUCZXdBvCqb95hgaHbyoOHp8pAy2JBspprYTOHd31qormM4SXvalss6/Gge6exwQGOVa/oBrARHY97TJOQMeDdBe1H73kqrpjEuGqQ8NSEzATmDhsNWrnn0CoA5kdOOPetWCnPHBoaAFAFEcfRItSNM6hvnBwzSVJFk0yUbQK822it0DWUQVzkfKFMwvvy0LsAy21qgUtX4nwnRpEDxBPdCb9azNaNbOESoFSO+RKWkbKCJp2Gkgv3JUVEDvYMnnHbeAED4RSFlSb4/A1PpO4A6iXfeKiz7KHg0sbB9Kx34vkeAVxjY0NvMWmuMTznS6ivHIdHL62iF3UUUXwzbTtBgaOjAPPNSC72c2/TM1xvS2/ZccX1tG9zmdz/hXJ29kjMyUUoLh0A8Kkp+hHN9hMjqtiQW7CN5E/a8BTAfIHzGY0YHqCPoM643rVgDExhn7fxXZ0YrmKqw9hoLfy2fQfwlI+SYzCAEsvDBzAa4Khv6Wssn7utlC8+0FNONqAyAh+5Fy7ymc5BEvZOo+wxE17xIap0bt28uZy/ZzcVZVl/Afvep84bPaChrMLc0jO+lqaSIJw9AJB14sRxqmMeiZLuM2OnymOufGzZvus8QOR6xhr5RMj6TbHmWVr+5MgIIHO4fP22O8sBC61VTpAwXKscqJhMztYA6LWDpALoAZydz9UiGXP43KIZIL5aO3JPS6AcK2213n5TRcqYpZVxEUtb7hPp/pafTf2AgwcpovPO8m9/7KfKRY99QnqMw1mVPt1vBuZ5rKBx6TF336mO64rTQp/LMddjPogl1Y0xZBKnspLNKhrxXR0yk+RidREJVEBAT3Em1dfnytyZ/9nDSqqv+Pc/Wm4jybYPDfkBLUvu/qorLiuXP/ZynE/NZeOmLURadDJRSIviQWfp40WMgQt27MBTvzWAeILrBM1RR4Pn0qasHhr0I177o3f+eXnoVigzdZKuwJhFNzzmJoeHF9+2TN54eLarpXiRfbS5Stxs1inGNQaf3HWVY2hQqNTimDMXSY95RP1C3ScLCbmn6pCJpM+VlZNd3W3/d1/3zJvf8IaPgN4fffxTWoB+vYbP7eJH18YnmSO4DP51PL7tOeaPu+b6G9ctr9y0NEayGFa63ojkdukFzCIAwT42lMikiC1bHlmVkJFYTzqK8kdyupLL5QYa4XuBlMA2QpGZJR3AiPdVEVEizPedlWZgx8IYkolONpYr3poanQ5vjtU/g1vmDGZyBoiqNgFlrtYRSoslSapLyC6pbgDYC/DJtYcuLW+zAIZ+rROYRUAwF1JfbPxymwWDwVWG72wAvUmybnhmK3pDZfWH309vk54cPeqsZ8uookjpWYTj3d6zkfOgsnFsP5tnF1rkUDE8vsDfe9CxEQuq3NKlcuctfw/ANqEzNyL3Ig2RSwHmzaGBnmtZbA+hPe0J5QpniFDqyTzgzY25g+hCQ3DYbWu9xJUUVrQPl1GtiwJnIZoL5ML0SDmBZ6SlA9oM9yMHXHfj0M4LY/MVBccGUCXohAGnrJVhw+CRZMSiprbEyavxkdM5/qjAe7XBmWyEgbFEqHwOD/o67ml89DjeVRLjNsGdZ+NpRM9+ncoytFt4miyiolFRb6pxUfZFHmv0xJEoMBGbOP2sx6abcGz3IFWDeV6HwVejKUFlkY9aJYRWm2X2d/rkQmLLTYHPRXsZYXHrdcOxxwTRVQukty693dHcMZaMTAiCE1QFGJCDGxq+2f+OMQ2uiWMPl4mj+wMstyOHOHz+4wgZQyngc7Mzp8KYaaTfO3lPQHweOuXOkw3bz0M+blM5QIGhh49Olj4A4hDeVKXHhgGzR8cozwYwH8SjrLa59Ic4dyRhwoUGvI/BmVZhJceaHnIbOQ0fudEOO5VYskiL8xzgi3e6GZ29DsBusEGtDsn6oFrIsRHmmvKEjJ02StyrZ06OWLSXiZ7y1U9gMPSRFEm+YwxOvdlKPLUaYSPXY4ZrnoP33QE1Ru5qK5SYge6UXZuj+M+x4wAYZSG5r8hnsdonXTOPR1wlGvd0q442QzGx/Qf6MBTwuI+O0Q+uQ1zHCEDaYkg3PH4BLfdS7trXWnZsWEIhw2IkWVToxHGiUHKOrXNGW4CbwoN/9BgcagyOHjzpRkGaMQxmAPr7jjdSTVVQTFyhc1Np3vTEqMo58fAt5cwcOQB41u1vowGdnU2FlBE8oUvlwDGlF9ER3wEtB3rQ6JifyXHS1wOnnb9bCVcYsZjCMNDbbnKqpcQEyuYLeK+Cv27W1jEiAQMYaPftw+M+gLHQ21BuubOzfGVffzm6fnc5gwJW6Ltzoxfu2VWugKawhciLtBSdLgHGWD9cd5pJ5O+0HDuOgpq3u5Z7XXuX3/O+95Y/eMtbKXu+qezZ0lte9APfW756233liovPo4/ay4Zt5wHCh2LOT80iJ0m0VhA/TELzBz74V+Uzn/5kFpypnTrVXEkJxlwzI5pV6WwHhnfaBU2yAu3VclOrftR0m3pe16g9SDDJr8u9LCdtjMXq5Vz4PEeuYvG3Y8Fr/sLNnys/9lOvLhdc/tigm+Tb/xgwP0dlqQsOeWgdTALzYbjlG6WyqLxCYSWBudEIpQ/1GEcxHu889tO86WqFinXNdUoKqdcXn684916TwPWXfv3Xyt1f+EJ5yjVPiGrSZ9j/nvaU68phKEojR4+XJz32cWWEyPe+vfvLY4iO7MQoM9nTvk7N8FQ5iTYVnPMzRV6UlWpdT+fxyt95//3lh3/oR5D+ZcHherx+6SwW9/EavF4LBqly47GmWc8imbdu29Vn2Qdr3ohuqWlL8VZlJGR/pAd9zVfGaZ7fXZyffR0HgjD36OOf0gKMXb2rgvJtVbt9gja3IsW/mse3PTC/8oorbzx7ZuGmtnaSC5l04YVMnMFDoCJQ5ykbWuiYMsHkeMUHAHx6HiPrPSqtCf7cPFOWLKqvxWabIXhBiODcY0jBWJgeZUO3aJAJPWxY0F+sJiYw8Bxy+AQGU0hBdZKE2SLQBJAHoySXz6SbAMZm8fS4eIX8E28lLz55BHXITSNB/GhWuHDUTTS9xblY+J9FJPTuh5YrQH0ez2sr3iOlB72ZCIlVnppJKvOp69qNkkDyr/WIcu3wzGeRGetA0cAzTCFfpZJMi0mMgMuVKKqQeu9erJ6XM6iy3P3Zj2f1Na85PNJ6ZpvLZdfjMYd7GVSdxKDh4Y4+4NotDa22rtx+ucLeSM26d6GegC7i+Vu7rVhX92vsbuF9jlfw9B+571ZhUWiuz+n94LqWAcybzr885NtqL3VQMComTJ4td8CstunFpec4uggkV3PK40QVMI8lN84tV9h7wLBqgkIU4B+5u1GiJD0DVJXTuNCCSQ+Jkl31YaLPPI3e/goMS4E58tA9aKD3pJymmwkqL30DG0oPXjol0Bxv2V/2fQVCq/sIUJ07b7yvilBu2ekFdw6YQxAGa9xr0liSSlN52Y2oVM+jueMAedzoQ41WX7J9DdcCDLMyaXrxzvGvbM9zykOq1SxA8zpL/oWRqy548+a/7WknusTGObgVuUQq2B24m8qfx0bLINzmPsDfIuBtuH8Rz24T4Ww8vgDK9maNuaRryZvWq6wnegq5xBY4/xqUSpeF0kXIszhvaA9ttdgAc/75f0PzUZ2PCpb2t1GIxTCISDYdwagCNAqMYVmEbGJLVONMYH6GapSHT6/AxWazNoIErUlgLiVFD7dc9SnoGtMA8DavC2Cu5GAvSifSYyZ5b9+xVgArrwFqDez4fZM7p0l2nYtCRRb18TWLB2Gk9FvYBwoK/Hc7cYlrHRltjeJGNzwBYI56yW37Wsr29Utl44CRKZJnAePHj2sYqp1eJXuSpCr4PQqQlgrSi3GhUdJJ0aMxogD7jjaXHZvOlK1wsVsHzsdDvFgm9t2CHOFYzP9OPO8rqM1Yzr6tE485uufdHGP/AagteP8v2CH4P1tOjlrVM7nlw0NNHJvzW4GccTVLZKALrfZoY2KRNqG1FKwe6sItKW8MA8VCR/c+TDLfeo7JPHvTrdAT5gehKWwpO/jZvXs3IGwPEcPk6oZcnR7H2ivO77WecQFQalyvfeRaMo+j4N/96I+Vj3/i78MT+vIXPKtcfe0TyudvvqU861nPKFs3bmYuQq9jjEk/GN5+CcbPcjkGyO0gyf19731P+SDAPuX6BKR66VUHSa36rBiZ8yISQR2boRKTYzKrQjuXct4GmKvmYxQzq96LtaOax37nm6Ud61lfHSfWtmrP0QFgtA8QehoJwlu/cVf58Z/9pbLrwktW50UYKJypWl4rKkt6yd1jXb5jGa0Yzv7SENVTboEhJRH72Hc6iHiYo6UH2SiZ4ybrOejIUm9/ohwlGffU6VGKY20M9ZNBPN1ROKdKZKmpPfbZBz/0wTJ2QjnFztILMG8A+K+zYBgGVxeSkLMoovUy2C+9+KJQwwrnQRXNc59Kbrje8aXQgQ+dcfpngefKEC7gVLv5a18pP/sf/1PU06jvP0fJmrU19tvcg+KdyvBZReHVR5NiFB/I1Sa3xXwev6rf+Vd9rGlevwlq6u/wApyoRx//1BagHwyjXM+PSW0WDdJTbgm5f1WPb3sqy5VXPu7GjtbOm5RLymSU9NoFVSJCbSZT6AnyVwIyQ8hBOUo+QIBP9+kmaBNNAiImTYSmKoS/GuoPTyHUAsCWSVdLaJY3dyHX5WIFp3wFUBsZ/RxXsOmU0we3gGfdIgZ6zMNqqBM4eX9FXjc/C3AV9ZbVBoU0j7osdJafT2sjCl34N//qDG350CqDqKXtRhvedhafDnTHXRBFlrVcY0Cq8BCzOOEVd0FrZJE7eoAiF4Rjt5xPEiOAfpyCGL3rtwbGmmbxbiczrJlEKq8jElGSLJEANhb6mXL75z7FRk1mulMgvJYaFQDzG54XHvNE5Al461CiKix6EV1oz+KyXyFiIeVoEWOmRa48i/mJB++GxjEcRkH0lfBCT7dhRICenqkztP8kHE8TeToQS1Y5RgCm0oyFRJoB/vZbAFI95TUIdbOMfAM7IxfKMBoi+SYX3ciMDw9rtbBWgNoUrvC6YBQs6/UnPNuIS3GlohJlrEbDhWqYJIROEhIf3LEneOMmh+ZhAF2Z0RORnJMH7itzYxNlGF6kTOhZqFLLkHIHSQDtgIPpuBQpn6WPPEAmZibNqd4oQgzUULUUmbix9MJFZMRhpM66m39tZMTecG6jiPap+iodbwncz0XjEzG4sa8AtiMU0cjYqIyZ7Plsq3OUKUAmvPlQ7bHyLX3WycbdBdXrKdtmyoHTTWWIttm8lQJD99xeDuIe30QSpAmX0ks2DMyzieOVJVnQ3IwevMuoqqXxxftBZYE2ManHXE3suhJrWByZtCoYNCqEgzzUJ/IaLXKVaiCteIot266STfjOAcdHR6zglyXl9QIr4djapNIGtBCMBL3Fx05D0YAWokEgWcbkyRapLHLF4XCPwSGfJvmzI9YP+NREB9Qq78CbPEVBpAePQuOBN94DlUR1GFVkOnsBcdwAACAASURBVHk+QZEhNbyX8Mob9JIHbsLo8CCcezzmx/HmrwsjBDrKqZaghVx/5UKZwJN+B6osJshuRObbSEcnEovH8YAbqqHZU8cdw8bCXsdP0KYc36RS53MndJTxieWy70R3ufqGq0la741I1r6vfz6MF2e/ywpsgijwMgc4Z6rimMDIpx0e3kcSJ0bV7u0q3aAFP4oXVAOSOTQ4hGf/lMDcOYfaiwYL57Y6aiN91EgbL8xhtEFd0fixaNUkwfvNlHG/5aHlctf0tnKi7bHlcU+8tpx3wYWRPK5H1LU6wDggS5qKZdf1vtd88Zo6Uu/ONSD7h7s1hgRA8ZUve2W5/c5bUYBpKj/0yheUo6OT5cDD+8ov/cJPlwESR51jAbQBfxt3XBbz59jJE1RNXS5//JY/KX/5nneXfmgdnfDWvTYNhCy7nnSIiDqtRp4yShfg2klWTcXwrsf0S6M3pmRtUNZzqwJ2NRVnVQGm+l59f5HLUh3HY7pu2ndjSBB+/Rt3lp/4uV8uO/ZcGPM+dI1cj6rlOkC6QNx1xf3zm4B5rpHOJoH5EMB8/QDAnAJDfWiVm+Bpf7hueeljFAa6b9/ectdtt5V9998LjXGsjEABGsOqfNfb/zwiglutuqrV9oiH13Hs6GH0zE+Uh+7fi9G4MWR7H9q7r/Swtz7mMZcxbnSU2cZJYa2rZmZRHvd+5hXqLm168Om7WSKTczhvbF0LOLVyrX/76U+V//Sj/yH28HoPqAF4XJJtZH9U+0N9mRX0Xr3qR/79zbcTu8c5Yymwy9l5rv3NRB9/k7dMmX708c9oAdpvBx9/Mj9atnLJP0M/VTGgf8aBvgUf/bYH5tdc84wbW9tabwrw7QIRnFtBSXK69AJH2J6BHyBJ7dMo1pEgOEC3C06wHgAaDVA/sPBjIdGTKVVhZjSOHV5NF7gISxJ4tbw1ih8NgFsrhYaXOPh5JpPU0neEcWepZNllsRnCtOEFSNAS1SaDCgE4B1gvknRyhh8LFaVRgNc7XEjyVrkeMsUFE8H/NYPcKIBLeniv/YxuKDa0uGWVDtikAKlxXQE+XfyNDHBM3l+aGUMxZIDDN5WjD9wOF2+qbN7zGEL4ABP01hs6BmMDmsUVZiGRJvV/A3QKbr2+XJI91uLCdLnrlk8npSbuMM9nYaXLngGVBTpHcioTlIuXXCTltPudZiIeTY0LGBh5byf2PgjQ6i19W3eUk/sfIOlsQ+DIdBhhFpBIKJ/fJDY9bFZcnSWCMYdUod6PLL1MMheel26iFW6gGiEmmC5rDPF5w6pR2S94pxaDiRU378vFnfsVQDZjNHj/IV9Wv18B4ij9bsQg1Hu6ooS62f0N3M8ZohWyZkwonkEicJbQaBe8V2knjk83OjdH6Uh6kPX6T4wcDa5/D0lM9u2CFSwxLjqg57R2MoaQZGwmj6CVCMhyaPQqrWhpb+lNGfUISgm3oAHqfVt5xfGulJznCIMhuOr0h2PCbWnN5m8HRjIxxwhoEFQZq5pWQ9ewQNBuNEhUMSLa4VGqpstxkV5lI1YJ06FHwMltBh2reb/AOKf+QFBDLu2bLdMrHWUj8mibtm8uB+65sxw5PlrWA05bGqGEMZWHlULEewxdNC6iE/55B+AuJNPY8c8oqUgxogkqXloFUuBle4RdknGlANZnAbYCc711lakSIL0NA0FPtTQngbgogvRSeNYCcwE578s1J0GzA0qL92aBHYscHT6NRx8/TUtE3khcBpjrYW8DDM+RwDlKkaI5KCndGBlSRyxhLzA3kVEwe/8hi6lAz6HCprUTWvRq4++ZmSa/g/dDFYbvNJF8anRgCJ52KwD5+ElkBpmOVhAdnWyBY17KdVctIAXYRLIbiXgk1a7vT259O974UyczWbuLdlXVpZVohBKHJnYafegFaJvALsieOzNQloaug6PN/c8fLSP3f6lM439q5bsCah29VgWdm10CjMoxX8e94HWnD/YeQqYUQL57e2q/j006cKAM4TFfP9gEUGdtxKBohbO/ADDXkGnlRhxr6zB85mcwJLh/BVYaiEqfJOH3QOOVZWLT88ueiwFfvf3pdaZz9XYKdOWL6xEXjCffN+kS9WMVlAagyoIurg8xUlmPpCSMjY0xbha4z1MYyPtRqZosF192EUmwI+W//vYb0dk+W17+ypeVnUR1fFjxFEuitPRujvXWQkNTDNA3/483l7e99a0RATXB0ShqM3SILApDX6jIJdXP64x11DEXd78K1sMYjp9qn6roWLVEYzhI1tA8vJ7Ih3rEPa/FGAmwBagmTlNlmTY4fvxEufvO+8pP/eKvlm27qTUQ+1flQ3FdSMBYObnOAfNUY0kPen7GollEvaz8SQLoED81MNc5dPPnP1NuvfWrIZPbxnUPDfQTUezGQGvFoBktH/rIp8ufvvVtKOVcUEUM3LLSQqkBsOfYDydeicd+uPwL5EGZ5L6LvJTBwYHVPIGY8RVdtdb/ntc7rtgA9+8YmcWRYmE790Yrp6rxXo+bj3zu5nLjS14WSfv1/a9tx/9vntcRjVgp5bW9FWfNr/Kbsq6PPv45LUAf2Zgmee6pvncfcyf1ev+VPr7tqSxPuf7ZN7ZRYEgwuqy+bqAKOWoZtnIDzTxQV/mKwqLyAh0mqHHxXxRkuBhZdIHJnp6CtHeb+UDDApxYK3UG4ACEAeDDU0TiTyv0FBNJg+ctBQZAIJWkq3eg9G7eFuBlgfh7G554aSYWV8g0wgTmNR0lqQQaFAIN5qnSS2Z985nwfsZvFxbpGyyuKnOEJzMXW783SwJlC8V4BBjjANQA8nyvFU+utAiT+ZpZPBXda2AxWibRZP2u80myJEpwxuRXi/tQFGmRmLiljkmO9THFRtWOB6oxNpTkC9bOguSXu+jNlTs//2l+V8UWbF+9WOvayyVPf+5q5bI6WuC9B3wMPiESbVZF5U+pKStsMMfvuq00sXAP7biwnN7/YISObTXzAHRxRnJvZMcDDuV4AxDlec/7m+uxPSOMzHVbzroZvik8kLjWFTZfPa1SFiJcWtMtKkDplQlcNXSs0NokgKQ/V/RoCTIrT1fIYUUCn8YBIFjjgvGkFnxL92DZ98Wby8COnZTeTi5q6FhLVg5yeCZ/RoEMv287MK5UZJmbHsNIgs/I+5mchlewux9QBCiPyIOKIBoYswHamjB+gkJi4jNHDsPAM2iscf2NVmvlefeGrRh/4wBaNkT6P0O7qWoQhmZ439KrZ7PUigLSuEyfWVIbX9slDK6KRhPUnEh5FEXF+9GMcYcZDk+nHsCFjdC+OINevRGNThOVOd3Wtrl4ff2W7WXbrm1l3z134TE/XTYB8lA9px2giiD7N05y4zyDuAXDWhoIX6cp0sBh+AF24TOTEGmRGcenwFk6V/gjOYY4KpIlGUImZRplcGN2nrVT1rOp8q4LFO0W8xqO4d1tBCzaHpEACjXDJFC913p7Tbw8cBpuLdeqxF9UhYSr3s4XOigeNAUNYwQ5wsUzJFvCK1/EgGiHutGLPnh7B7QT6DkPHGkhfI9hAYVEcN/YtAhfvol1A9CMYeDNtHNNAnOVYIZI6GwHxB8DgLcyF9WUPo1yyfxic3nipbPwhpvLft4bHiC/osfS5gL4hnIcPXETeLvwzkvrUQ9+mTY6il659jaYKs41sIuoWd8l5dgEiaoLD5bl0xQOAlRP48FvhmLSZGVP+s0k1CmMASMaHbSLibddUHL2H+beCFvs2KIRQ1IqFJgG5CBnKBS0eQvJsieJqkX0waRdDBXWpFbaGOV/1seFkIrswWN+lrVmYvh5ZXbXi5F9xbgOMJ6UsPaQucvETX9qzvIqd7ka/2kgpkG9lkuuwoaJx1GDgbn3oY98rHz4r95XtlCpcoLk6//8E/+ewcKcdh6w3nz5C18qX7/1zjI0PFi+7/u/L8Z3FxzqMxipy83Q7Lge14BRGuRNr39Teefb3x5e2wvO3xWfDR105VtdR6V0YFA4L8M4Dm92lQ/l3JNiGQA7jV1nUhZGq4BqvhR9la9If6mcBqv3Xb1Rzb/0KbmPSOGYZ+zOlcMHj5TDB0iW5/z/+Zd/E8P4vDChw10Ve0wF0vly8snXeMw9nj9Vvo7vqfMtMN/AwBjAcx7AnEk3Ona83POVT0SukD/N7FGtGCshKUk/nEBB553v/qvyB2/4IyqEXlL1lQ6nNcC8MhgOou7yZTjm1zz+CfD5iSAqZVgVfEoZx8xJqQH1In03jiiC9BbHj4D86AiG15Gj5cmPf9w5elM4r/K+b/7ql8u/+Z4XRKLq/8xjfq4nzrVx/ax+b+1nwhGVHZlrY3gwwkCUOPdO9vv/wqv7/uHRHn3lf9UCtC3ujfJUfqyG4eNLtPXe/9X3/qXf/7b3mD97+9YbqQ4XwLx22eF0BUQBSNmxEgi7gPkBFi+T5Cq1i7D6AzyEwjKetKUyO7SjzLPYOkHNmG4A9LUdOxjaxKk/6oaR0FpFF8GNC3J4XfByLpMkqZ54GyBKeTvfmweEtMCRlpueNJRY+5IfLKm6yq532soBTdCb9Imcz36mCp1FZECZRo2QutAA9wZgXSQ8OQ/oEffp9Ftk8Y1NmXNLCYlQpF56wKnGxFkkGkyI0ePmgt2Id6oheLiEq9t6MCxYqDnvDMDckDGylGwAJsJ6RQlCYgE0kx0wfwcec13asQm6GJl13tYPx/zpcb/nNsYKtHGNUU6ajVFv/FmSVV3tmwCO6fEU3DdSMOm2kDcL/j1GS+rGppcmOIO+zjEW1GGnDQJQCkrxzraQwdcoXSc4nfnZBbXwTHoNxR76Utksvea2v9EGgaqv6YECFLcBipvp1+To532rqmPybhpF8NlVsVF1Rb102qKpox8puYMoUEyW9VsvIjmMqAvA1oQ0jSoNCdstNHo1CDGi9OgsQMkRwJ5RGcfRBjhUlUWPvYU2NBjcfAQWkawcn0mvdHrBvSb7xSIWXDLfM1IjCOkY2oz0JXKalSSZNKP56dPQUeCcA7ZWzEPgEYlyALlGwJSeTRt6xQqbDtuqMEaIM9r/ta668osO1nAE5YZuZCPasoIPFvAQ/C64IRORyXwMaClN89A4WpBK3Fl2bN9SHib58ygc8yG40B1NSoghhQfwGwcESolohY9s4qeyg44/+2NxDuANlYUoddAsvAC9Zcrw1Tkders1dBdRCJkD9EpViWJBrBPt6GOHP5njt0ifidB3UzlyUm1rACmzRyO9A0+9hYbMI8EOLtOLLeXQKTzTvYAuk0s5RRsUli4+08T35pEuPIKnehYu+kaMi+Szn4FjDmWkEyoBBZMeOgrY7mviOwl4LWmvYsocLCErnYp9WjEE2nlf6swG9MFb4NifRJdcw2ZlhaqYGC0LgNwrLlC2j8qfI3gv8coP9TLHaeM22u80vHGBqHxz9djVUheUHjpGQiSc8F7uoX83SXV4I6dRWLnja3eW9c37aOe50DAfJ8nVlAnlCfWwbyIXfHLcYlbSh4iIQNnpgee/7ygRDdRRt5M4qgLFJAWCHDfTBOcvvqAF4M444DiKGNmGrdy0mvKNOkxMwOVc5fzvKXO7XkFjDgT/WpBbq6hEIl/lHf5mXnXtZT4HwhMHufgEvI0xoXd8nrUiwC9tqzzen/3Z28qH//Zv8SAfLddd/Zjyq7/y8zG+1T/H8RMUwdvuvLt84u8+XH7m53825r2SeIvsJ7MNULKIzDkWJ5BNfMMb3lDe9bYE5k960uNjLXE6qABie+dcrbzjlYc7KXYZAQvM7crkc3NETNoWfEZE1jmYa9C5wkX5hZjzFbh074hzMrbrtcL1ZGJ8DKrTaKxL6r7349neiaf86me9DPGEqPS1alkLvD1GOouq3SmmUCq3nIkXz3nVTZJULnEYKssA4Zf+bmowYD0fo8jQzMRImVZxxJwmi82xVqk8ZZT6GF77d777A+VNN705gHkaJZmUH7ufi0ncnwpHC2Uc6svwJqIUvCdNJqoke0062CKSBwXQyLP7AJ8yMjJNNOOu++8r9z3wAM6P6fKi735+2X3ezlUHhvPCh9/5xt13lec969mo+1ABvPJAPZK2Eh+uHv8YrWXtZ+J5Dc4jD3/dB3Ao/RKv3v8PPvfoC/+kFqBPtvNBqStu5EYdPkNfZNnyf+WPb3uP+XM3D9/Y3dR0UwDBytIfNYGRjukPOokLXGo8B94NkJ4e6/jthK74xSs8mWjvLzPoqupRhSIDKe5EGTh1DEyWEzeQBxPMr8hHnRFU81Y7C9TM5u1lBaWJKG4D6NGj44RXUrEFj3l4DFh0Qg/XxcfVvqJP1ItxOFNjHfI6E3xW63EsgmFs1wtCtYQHQNWTD9hZBJiPw5E0ZD+4sT8Mgw6qK67T0yqFJegOepmlJuAVN3FRWgygcMUCS+G9xePVOUDVzC2RZDhPDLsdYGfxjAZCt6F2U3lTksqibvh0+cbnPpnAvFqEvNeu7vXlkmufmkog3tPq93KlDc83G6Ver4nRw2UKI0hvbuTP420XPM5OnQoA3qzcmco0JlCF9zopNSn/iMdu7DTACW4pwFMvqOfSI6MiSpPJpRwre87OzxbOa0pDS5ApposqmeFh0zuXNJdIDlaVJ86V+DNxXGpCL0E/aodmIqVlZX4Kj/lQUJAiQRb0NEMy7dSxI+FZCyk/+RnVJmr/hlYtx1rAmNKQM7KhfJcV7dqN1nA6wXUoA/FPA2SFvktN8xwTeq3jb57HGNOCsiIi39dQ7B02mRdQFZUNk5IUNC/7QEqRWvxqp/N7CbqJyVAN0qoYS9FSER5OpRONqZAhxIjq4LiEYKpxmsQVryht5Yr/It0J4NjMNS1AmVomWVYqQDv3N9gyH9Jg287bXnbs3FL23X17OXFyrAzDU+4EjOaRAEB6uqFe6F3FnIzEwsyzAOzjMW8BXJ6C790GRSNoNLwX+tgmSssRB4iHUUTTz8LdNloi7SX0s/Eex3jintqRb3ROL5J0eRQd8+A/c08a593w3uV3NyGFuLAIuJiDBqbeN6BbhRlLcndBYenEW65YE3ZWeZikS7XVN/ZrfFlQBz1w+OXdJE+OA8z3AswHkHpsizL0AFW6pg+FlDkibcdPt/FdOOYo1GiInOH7/SR0tmIwHWcLCm1k7knPtcWOLtg2D/WCYjd46Xu6SEzsVXdd6otFiLwnPfdy2bOS6TLc9wOcfz3l5DdfRLVqOdrr5sre274GZWCi7NnO3CTSrjzcBBz/tg4NNuUl0Y7eCE1lHEMZQ8e2ZEhCTzAJUl1wVHag5xhFmMRT3kKUgClQnnh5K8WPZjF4pSPBwee70oRaoSU1cG1LO55Zzlz4Q6W5m+IvrFmCcH9qrnid2JlLTALc2lu8lq5Svx+OA/7NMacE2UZS1SvvpAqzcyvWCNasv/7rD5bX/ffXlf0PP1S+9zlPKb/w6p+O750eOV36KNCmx3gcQPd7v/075dd/9TWsAxgKjN8l+maUyEkvThgn4STnePOb/rD8+Z++NYD5Dc+4AVoOEarKq+t6Je1MLrwRxQSfuQ/pSdd5orMkaIycQ+dBVB+tPLoB2Pm+holKIrnYOt5zPdKhkSXgUw7Q5xbuMcKrp/w0a+SpY4eICpyMRNleiu6oMHP5Nc8POmFWEU4wHHjY9doopj+uHiEVmAZoJlJWwJnvWJBuGH7TejJ1Q5UFj7nVNUeOPEARq9OMA5K8cZIMD2PR8ZgAmJs8e/DQ4fKnb393+YM3/mG5/DI85nXCT17K6qMGx6H4xXWdwsDo61H0Ia/BfpxEIUW5zKHhoTCCZnFy3ENti9/8nd8tO6HPbNiymWjVQHnVS1+Oegx9Vj00mny4ntz38N5y/Q1PKwtcX6p1nbvH1ZyZb760c571R7xe2zk6BKvN+yNc5quZiXc+8qOP/v1PawH62m36ifycV30Dd0z5LH3z/5tE2W97j/nzNg/e2N7cdJMbaTjKAnqw+bKMpD80PXZ1MZTwnKQTcM2Ez6dSlXC8lQnUSFbw5p2lymXnyJHSLc2jAmsB6+vvcpDROBeVH/ne5GZoIRTDqUGJm6agRzmzFnjKbgQSPj13AEENh7XX4Tcr3BiA3IUiwmBpRCS/OekB+UgDwwI48Q/PraDn1LHDXDuhWvTIOjqQ2QNgN5j5FkbFOWCfkoss4hWwDy1VE17w5gpmW/BS23ozJH61WhGPbDtpEyFdmKfPMCw/CxXHPEngAcnC09PVt6lcTKnnZD2veQQuF6AC8DAK1LOdnR0tE4ce4Phs9G7G0iuq+66LMkWxJ0CgZ7E9Q36y4vbPThwv6yhwpBGkfrbG2jzGShuJow1NJGGFQaHHKdstR0a2b27g6duttqY0QColm3xVD5be8rqAD69x/eGFA5XYx2eWpsvJvXdGgmUmOQoqMBTQNhe8t3odFqwwyY92FOzHmPSaaH+pOM14ajv6eqN8vG5v6TJ6loLrLiVH71qAcUAFhoCg3oTFMDW8JK/b535XOpHnZMNuUa0Hw6qJZLl1GEK2c7SD/6vGVYiZCVaq8Rf0odi05JlrPHCtRgi43yWSh006Xte5mbGSOQC1iZDPMuEsHnqyMGSlxZrLoOa8m7Tc7u3wn5dWWsrOC7aVnTu3lofvuj028h541P0omCypMWyRHugU6m/rnW0EGHcA7Jz3zc3wnCk+pPGshGBUkgwKi95nL1gjSEWV9K7PA0an8ZiLa/QaniFqZVGd+AJzsgtwqVE1y+eOn8riOYJ/sGUknbZxvnUA24UFQOc8RY8A5gOAXY8nj1pKTQda6x3kakxR8OjBwxb2aSqbBzFyaEuVOzuhpvT3ww3Hi/3QsUa823rqOb8OATzt/aibmJipN9vW7yQxtb3JdkIrOpaYJQr3CPCgUmBUzSDHqNGxZQPHHG0sI/CyOwHz6zlHK683AsynSTSlSCjA3PtOL/oZ7mGq7bKy6bzd0T6Tx/eWs+N34XVX6QWt+e0YHIw/IwijE1wX1+l6FjKX29bxmaT+CdCWAdZ6zI/iGRdsD+D114CYnTcxlmy2k2fL1VduLHc+eAID24RWjA/aWAnFxu1PK2cu+neluXd7csYrbfEaiNcg/JFg/JGgPM1togfMlyj2ooHOP48nIFckYC0P23mvXOt73vOe8qY3vrEcO3KovOJFzy3/6Sf+QwDQOWQQBZzxHPf+6JGHy8ZtO4OG4lq0EMAcmhhe4FmsMHNq3vjGN5d3/dmfBW/8+S94QRTNsVhdYusUFpDKohJR7Ak86qRPnSWT1MGItblK0K6jfWGcY6z0U1JeyUc1rqNwUW4o2Qn8nJFaWAHVWF/Nw5Hyx1px8sTRcnTf/eXU0UNI0kI5Qd5x8WxrufbZL2PdZGCwAdUAOPs1KSzOsyh6w6nMzwhnUOVXqj/fLjAHlIfHHOniXpIoekg2mD59gDyGkdDQl7LWjzddCpkl7I0O3nPf3eUd7/gLgPlbygUX7q6cItU9rd0y1nivPae68cNEd8wXsL81QpwP62hTpQ1PkBswPjlV3vqWPyqPv+hCtM4fExW8Nesvv+wK6GNEkl0vK4dDOopWyj0kpz7thqcHMK+lKlcvI9o6XQ/1ahdPqj0ko8XVe/Eh34jOuYXihD/HxX5pzS09+vSf2QL0u9bU9fwE8Y6fu/m5g3Z/BMD4Zx74W/zxb3+P+VaAOR5zJ1WC11w8avhpeC88orUruvZQ2KeV+zkAYgAIPYZZcGQeUIgTp7StoPpRg9mYaIIiIZygNsN4y4AFycVTm/eUdeiVZ8Edc+7kUOIlY5MXVLlgyAPxMBmey7EUPPEAsulAr0vBi6PrewnIGEC4NizS05tzvj4W143H/AzgTg/VyNED8HZ3B1ANPUfPVQOl6hrqIhVBqagWphWuWW9sG16lFcDbPAUhzFbX26viSIA3PdUVmHNBtArm3V/4dOUxF1CmYdFJYtTF1zwl6QT5v6qdg/jPMcy6ZQOHr7mEEPLEyP4I6UptaVinBrGeXfpVLfMwUuzjGoTKOWXT5LDe3crcWJlHTSaqjKp8EEm1KHugLhP3HxaOKX+paRznT9OGfxmSrx85GtKQyYbzp6KxBITPvon+F5xLG2KzbICOM3b4IQDrNBu6euqGoPFOsiE2YySgyQEwVyVFr39GULJwlclUgBjpVBy9HQnLBjb/wJXSjFA/aW1mDAHql0PhQC9+Xl9EL7w1qQACfH5io3f8aLjwvCk84fQT4FwazTJefateqsPfQj/rAo1kWNse8A60jaTHoD5Fn3kuef0ASMEMkppnAObzKBM1dW4pzT0A83MmTcVoyU1dA026iP07x3kbMRLTwEKlg+IyWwG7I8jpXXQ+VJYdW6gaejuAdQT6ylJII+oln8NbPot8oDfcBKg0ATM45gJZQOfMrF5sEgtJtDQHWpPDOZpdqIkD+MbzfdZqnCRijqNq6+daoHScofGgw/FBOMV8pb8vufQTSBkehsrSyTVaoKhdLy8a482oskgh0aM+g0FwEBCrKos8buyU0gPfvAMeegfeQpMj7zmMHBs63juGNRZSC70VENzfT8LheFM5RKKmnmaTMeXstrNuDPQJWigAc4w5R/924YHvJFKwgMe8Dy+4UUCBuSDfNWsaSUlnxXq81ONomo9z7SZeDvVh6OlZ5thnAJAzePjVXJcK1k01387NTyxjC72lq3G2TB78SplFHaoXb/0JlFrGUJTZsdHqvIKxhnKaRNQh7lODoQnAfd7OpTI2gsfcUuNcl0ZDB/SccYwjmWP9XfSF7csE1UA6icLNNVdtKnfcf5jrBizjTV9cf00Zvu4nS2P/npjbaz3ja0F4DcBr+sZaTnVddVYnxiz8n2n4TF6fJdhVacoaFPVErtbealo7Pk+cOFl+//d/r/zNX32AcT1TfvRVP1B++IdfFSvDnMXDTLxnjbVQmI6MSKRWtpQxM8fYHMXIMzl7kiT5Nn6//qY3lb94x9sj0vbCl7y0dJDJZTf55AAAIABJREFU61zK48hbNw/Bug0YyQ5CZ1dcI1VTTx4rG1AaaZc6V0XyIq+lWqukg8wDRLdSvTKS6+vlKZe2ygDOIjlRFwEHQUYFAOcY06dOoGry8N3l+OEDZXgDFTBxvtx275HyIz/+i1DBvhmYC+4TgKcTKWifFTBPT3lKzK4CcyII4TEfxGOOZE8PHnOpLCtUkz4xQs4T63kz7dCNhKL5Ba69s9zP7bd/o7z3/R8pf/jmP8TooLpxvde5H1V7pLd5jtLCWsK8P0TNCou4danAw34RkocYIV+6+55y/713QaXaiJTmdlRehsgH6IJiRr4Q7f11FF32UHjKBNX64RpeV+P8DBzzl7zgheStmMNzDu/F/uN1VNtBXNPqEaptogLtq6+fLV/hwl+D8+Tjj/joo3/+M1uA9r+Yr1xVfU3v+OcZ2/9qigb9c27n295j/rQL+25sb228SRBouCgS8qqZE4A3MIUJVNr/JoFV4DAAcEVr4bmLQXLS3MilUUg4CCYAeEQQWYWi0jQ2T7M04wnyuMDu8D7O7LyoLEEBcac0QbQV4qTWvIuYwFyXWlBZ4lo5dwWoXTj1wtaUhKBLVKB3tbJjGAcJeGvvv7cWC0B1S76uJvoC0nwrgC9pH/LL9ZhW7swYOzUn7pGbVS58ukFUwrCaGbs+bbc4M4GHFQ4tSTvuuILC8DT7/wDzAKPxY+Whr305NoZVEO4i3L+1XPiEJ1WguF7VuODwuoRPJhRJ2pBjlDKzQHGeFROjoKRoyOSmqvc8brwC85k14I0LWuyzdRR0cvNYOnUY+oLfoRIrm1IzajjrUJ6x/6LyK/+qDIEoa19LJwaAXJ1Z6VFPD/TaBKw0jnJ8GYVJIzCShomuuCmzE5bJEwe4PRN+SVjlHI2AhN59d5cVDJyjKJhsIrogZ9nwdNxWFT72AvQMn0R6sJlKmWfZdKKM/MTJoFO182ETnOO+o/WrfzE28vVQG5LGAXBcaJCTHil1vJU6wuqaG4Y3wTZUaGw71YK83+g7AJbhajdyjruMi7UBFGp+Aa4/EoUZxxpCAtOp0+X0kQOle/eVSG4SnrZtwpispAjrNnS66E0kVL4MWFnmeyvQWqSRdOB57tdbjef6gj07w2N+8P7bGU8nQwWlDy72GWRUZgDlE9BPzPJopd36KDDUCh3EaFFHJ9UuSfpc5qbH8BS34o3GFAnefCMKIs44DalW1VoAxQsATjW/BcKCV+xC2laSYsZMVDIRzJ8G4B5DiUQDwLERiZ94rdU3t+8WSWaZgcZwlEqWfRxA+cMZuN4bhgC+ALgugOkCBsM9x6iUObOu7F6fgL+Nz2kQDPYDbDmHtJNuaDsWNNIIUQaytwsDDcB38AQ5CXynG2Au3UYGVHefxf9Qe8GjDR4J0D+njOS6BYoBEblDzUWjopnIwXo45i0iNtphGa/9NB58HIWld9uFZWjrHoZrU3n4HiqxztwOeAbYLFDFFKrMEYwFq3UOYTycJQpg557GmBlCQz1oQ1QqPW8r9LFRjD0AeQJB1FhIYLUavUtutwoujkX6RYnFUyTSXn35+nLvIUrX77i2dF39E6Vp6OJVOopzUC+zc10AXtNU1iZ2hre7QkdynKVCyKF27Ap49Yp3GBGqlFkc34/kB9d/x7rL9z7xmVvKb/3mr5X777wz6Eo//RM3lh940Qtj7i/CTfZYfmfJqtFBEUsKTQDVxrYyMs2YYA7NQKHopNbCf/9vN5X3UjmyCzL/M5/3PaVPvX4+36qUqjRHxk5SWdD3xrKamkLXX+tHY5Ck/VbmWeS3VJQVjVgjX9Jh9O4uMSd379qeLgXawroUwWPnGvVAe09RRCeSINMoDcoaEbtxVJ8OP3RHGYHOMkyVzM7eoXLbXfvLD/7Yq3GGMMerkG2s6/HjV9c81xERYL0C7NUeYDt3QP3UY65coh7zbkrp+loPhbWO7r0rBASsyuxaFREW6TsaHBxwijZ84rVPifUo6IGVpz76L15NA0CK6TjqOZMMsn5oLB3QhCxIdBzZx5tJCr35M58u/bTd1dc8uWyAh37J/8Pem8BbdlXlvuP0fd+fqlNVp/omHWlIAgkJfSOICHhVeOb59Mm96gXkwhUVBBGxv4igXhHfBUEExSuNSqQzhPRJpamk+r7qdHX6vj+n3v8bY659dsoQQuPPS6id38mps/faa80151xzfmOMb3xj+y686ii20N8n4bJ/+Y677dTJXnv7f/4ZZEcljbx2bvWZ9us/+suP2B+86z0eiYw9SvucfmevWGvdKPK5uGb0ZZOT4x/lG++krsfn8r548Z/fQQ8kL7m45EqCUOcf5OcRnsP8QfkOzvwf95Wnvcf8hkua0DEv+oCeDQfVjpu1ZDoRxHs+wHgMaXyuf8TDJYDnNO90QO4RyzwseRazOyS0WMkDyalrxvF+KNNUCw0AaHrTLspCkwAqaTk2i3LArDy2On9JqRbbpKHt9ISggCRoFO1MF89Aurd+rekOyAmHJb+ujAyto+EqcZia5BNdySUBNYExvQS41CN+O+n4nL2v+5en1UF20EsU9ixxTjZVC/GGayMRx9wLDAlQZsBY1+E7s9ODdvhuynQ72BOwCdBb37LJtl59dQBpB7VxnWyhVdukAV6Ot3kJL+w8nH4uBDDHuyJvUgaoI+OUe0/gWol2XsVSnSBApeIoXBnQtzA+4mHXCoByCfxnL8yU2uPygsnz4bKSDiYTJPe+jY3H+1ZzxZvtJogfp9vzojXaKPSHMC//XgaYl5ZXe2LmwnCvby6KVEizXEc3Hn0Q8DNhk1QNrFuFEJzyBdKZNQtd51deqClQzTR0qhLaL/pI1cAJqyYs73xUb1OAEx/14LREJEF9kzf3z5Q3W90KxYmI+qSatzH22gzdovA4TeQ6iO+qu3LbJ3HjZbj6BA3Y748N15ZKkGs4ex/peaC9tLtvBb746qyNgegHoRu5djheqkZyL5ZQwiGzDy/UAl6yMa8S2NoJfUJ0JygXCu1v27bBgXnvoUdQphlyz3JVicpkS26w0GXzFunfOpRBavBaS5JP+RKinkxOSG2lGI+wAIzAk4JYki0UOBEwF3UCcAU4nwOcTkwC4vCES5dc3jL33uL1LeF+Opq0IS+TeAk/luMq8WCLJiMvdxX0i2K89cAml12cQQ5xGLWSCmg19YDSCdrY1Qn4p4R9QzPhesD1qYFSwDuGR7ukMaUjLuAJaIZmMs77vcNFAJlo6xJ0EFUYldd6Fo95b78UlTAK6AvRY84DgquqAYtQSUZQbCkF5OOy5r4ZD4yGWrDV1FQJwFz0uVV47WqrJq3ODbArabONl+0BJEricsZGju+108dGCOsrssEx9LM8/oPQc5YYcNFyVlnjtBZNQJdpg0YzNSUazKp1rcODP4tG/4KoHqodoXwIJRti1EGPqMGokofYQTZzDMxp17zh3Ta0SF2BjstT9Cvmo45RpDFoHvGTUU4yL7kDae5lBh73DBIwqlVRi0FfU4fzwSsSr5nW+WA8H4jnv58B8z/40EfsL//sAzZBtE2KOe94+y/aS178Am+XlIg8cV4UETloBKwTx3kO0K5CYEOTKthVwjo5x1xssD/+oz+2z/zNJ617G/SJq6/HQKNqMuubePSKLnpiOeeW9/ZsTx9VTTEmiFpF1FIPoIxMFakKmltUdg5KinjTUnDSWrDA+9LbX9e1kQhLo7cvp1eedhYvSKT9SOs6TpvxoR7rP/mojUJ3bFm/iRoPqlVRbtuvegFrAAZ6gjq5aKgvE4lj7kt9ZHxk3HItHVkkU95r8ctFZWlgItaSAVyBF70Sisvi7Ij1nT3qUWY5MBopltbQTB4Be4qv8b63ZjgrdkVf2n3dCb78KBSfZZJ2W1paXbFKHvIp+vzQ8WN2+tRp++KnP21v/a8/b7uvvIpnm6J6ypeQ4cPa+bHPft723n0f9JpaJEC77D/f8uNEqUjWT+ugrq3zjVE19LU/+To7eP+DsRfKQZYwQNx52pRTE7OG5sGEozT6XeQAfSru4OLrO+0B+l3g5XJ+5CnXS17yu3kuv+813p/2HnMH5uWFH0ioL/dAh50b4CWAeAaw0hOfgKsDnQQ64q0MoieKQAJx+pY2hQBS0tEm/DzOBsmm5Q8li9ok0n7LqHE4jMHrLL6bvDlLABVJFmqhdSAtj7jLTPkFw+BOqNw99PpEx8lrkLznXlcia19YF2Fk+O1kVAYBqQxwRQd4hch0fFQhy7u/3D09fgmRV0cef08u4qXiOF5FD35joQCXy16ka6sNLGBzUwP2GB4LVypxYB6At7mTssiX82yltut72ZjEgseGh3df4d4lDICZyWGuy3U80VQ0kChjH9fLWOAJPOrbiYKj/gibAMa/VGXw9p9XIR95inXF1L+5azs4TUU3vFEKt4fXSZuixshVc7z/k3Xk/RnRFefl6/syltRfrjJS5x6xhTG0yPlcG9B5ohZKKmw8co+VoYss75DGdFVWgcBwqD76/9y7yLmVUDYDcJojylKNdGIt9BjNi4xS5XPb1X10fLb2J8PLT6VBkQo3fFoMFokoBveRY4liZNVS3TnmBgLHS3UlRZBcCjE9FFHSXg3MfqV+8z4IT5r6Z5EbObpSahtXUEPgvUdJ1pgmebG4qgHD7Gan7ZwXNUdGH5SjCTIB61s68VRLzlP0lALbTTn1TSR/9h7eR8GoQb4DnYqfObzrK3iFh6ahhABO6vHE1gIAK/GMOyWDZE0VxJnjmCmAuTztmi0C9g7S41Eg4iMYQ/gcuskofGuVlK8EaEueVAl5CxTKUUGjDvS/tSmfGyvFSxwFi+TdFziuhvcuj7mugM1tM3iYp6CHaOzaocBIkrCrXaofBdbeIiB1nhL10F2gd2xtEa2Dwkp4+9XHrU3IKeKF7kG1pYXKofLuq2iRaCCN0FWkytKPuoon8MJrV1KoRrke2UVFYVCZAzSq4mgB1BxFmaDPKOEUj7YqisroUPKnYI+kWuu7L6M2QRfzFDANl3xuZB+UphUH4U11OkqgGmUV6CqDQ5oqShAVGFaFy1Ifh7aWAjjQUf20vVURCwyIWUXRokaExkN9LyOnkXuqQFWluoH8kaU2K8NDXtB2ac4TngHyzDPuHnMlOiZQHs4CogjiEMszrnwGnlFpTleQkyJQlw/GfY3IB1JpfYn308ojgzIBeH/WlYn37t/Dw/0RqiRP4OUtt99855vsOTfd5OB5WRFPvqvlWsdKsapc8qOcTuBwEWNznMip5rckCKtQcPqHz33R9h886kazkrjFP6+Bb10pGZoEuH194iQnjh6y7bv2PC464NtVMp7VVslJSoN/fSuSrUkK0BM7RU0DTO595DEH5xFZSMXS/InV2iwHQkjuqv8mR/qt79j9Nor6TMembV58rai0xjq3X81FJd8YtkEGRt33kAPmWhci/8RrUDiVZQ2YVxPqcWAOnaUBj7n+1j2rnL085yrqE7UtlNwa6/na+hU0xbWxknecAlwYYMoV0DlUQVQhxlkSee9/7FG774H7/RqbqHWxY9MmokUV5DQhWgBtRbkEKh7UMzBgH//kx+0F111nbe3tsYcxVlvIqXCKnXvnoxLoOBSoL975dfvVN7+VKDGqWAmYp66MlTbPqRHrYqyVzNQz/Ps987OzH+XNyCS9+PqOe4D5B//UtclxNbAAmSlZ9uD3G5f8m3XA099jflnTLVWlRQBzPTMp9ObbcAK4/Hb8kX6cBBG4Nhbr4K7EK5gSuT/TW+mbmZ5HeCW1KNWS+FS4rJOJHkC4etMekkZJ2hPpk4WwxFUa8KCKQw3IEr1Cwun5ySGOe/zBzgO6cTPesLWFKwCtDg6gnTVaBwc4C7CYeNjaoBIMz5IdMwgXKY7JC8q/AkynxVjn4D8VX5AWsT6YB1AGMIfzXeAEXn95QZvUdTNjPfbovfe6YkOAwACPLRu228Y9l0ZUIsdVVl+nO+N4ecyrKUcoA2AeICqJQldmgYtciDc2KVH73ahBHkSW11iNkwcnNULD4sUXk0c5eia+E72p/ltrc64L0zwIYc2kcuLHpT5K96PDMq6nhkB8ZF/Yk/JBJfegf8+Nk4SKZ7OUULaKT8nLX3/4G1ZBRCAiLoBvFETCS+0ncZaOg2RVTJU6it5L4DcrhuXGB5vJslSHNAZpsup4da1oHYWqnsh5XERI0yRO6231vICsN9Mm6AVEtaHH7hJfyDZIzQ0fZ72Vok8Zv9+PS+fVWUUjEgDkfdUFeHB6BeoJRhJjuf0GCkxhmEr9p0jAYgVPLUoMTZ0dtqEGb7sSjqHL7BGVhYIs/chjLs8hOcI1S2n8LICQfDY4z6hgAHRrKuatjmmo5E9xmKtRChmdVuIsoFGeYkWJeP5EaVGhn2yOCpjrBkX7GEQNRQmVAuYq2qNkNKmaSP2kA4CtPJPRCXHW8UqDBwRSlXMiLfIirqlE8QVoJ/MLJXjkRBcotE445D29RXjkoKHQjvVtwcc+i654L1zyjS3zXmVUnn55zJvwmM8B4M+eKyWpUkmhAHMoL9qFBKhF3xmdkCEcyax+I6Cilubgow+QTLnMPKvn/kfQHC9RoR547kpaVal7dUMr0YTa9k1W33WJP0uTEyhhDN1P8atRxkSJo1yDypwNAHMBT/HBa/HWj+GNL0YlxtdU+kxgX8+zlFbIiXOpyUZoMjXkAUzOVjjtRjQQ2fLKUFihivLWHTuIGq2zxWt+0RaK2h4HPvO54vnKKtm/Bcqm8V7OUitCHHkpo1STrLiWjJ2tQdmqlhai9OtC+orezqfu6e/gFK/aL7/r9+xvP/FhKjRPQfOptvf/9i/bFVde7c+U54/otzNN9D/x8+XJDiN+CsfM9CrgkxufogZBJSD8C/9yhx052UP0YYZzSPoSDj/eY+me6zvylItaoSTNntMnbPPWnd5qrwyaXk6VEdVDkrN0rErbtwF4tSYt4SnP+kFr+22332XrKc6lNTqieWvOGH9G+Z8ShOfwNo9BZRk6sReFnB5bt3mn1bV1U3+hnsJelwb/yKNu4SX2PTIBUakxBZ88Io5SZ1HPC59n/SpOeSs65s3ymEsqUZEA15on2upRkFCkicJu2ff0j7wkcc6/xEkHoasMoKaytXsTkZ8KDDM9O1HMbXRy3N7y1v9uOzrb7IrrrgFwr7Nrr6ZCrSInXEfG+/0H9lv/2dM8c6gNtTRaA5rnHlVh3PRblKclrzotY5hIAt74ClWK5aF56atfZUf2HYyogO4yrDp/+WqSt7fy7wGej/ctTE/+OR+zSl18fTc9wLyTLjlWogmY64XBYw8wx1iBnj6vp73H/CaAeRnA3Hl0vgOHFR//ilemt517tBxc+FMXIE5gJYERf+gSuHVQk51IoCc7o4A436kdE5VFFAvAEpveTPceW6lu8PCtnmopb6iq5TKcQGWDi++rQj8BEDM4HQgnc0z6X74g5t9B3s0ksJ0tFRl8fBzYT+dXG+JcHIWRIO9uxlOPxSZDtOH19Bal+5env0xFiQS0RGWRggAhSXnMtfgHMA6vqU41NXLGDu+93+k5GfgVWOnYeinemB1+rF89A35pcXMJPjxNKqWshMI5SjQXQWVRYRyX9Et0mhiL1E/qfV8f493MwxRUpuCHxwSITcoNqeTdiCTaAOA+ZbJxTzg/+65++x6X+sj70PtPHO7gLEd3CVhLeQdvJRxNqR/MwwnXV0tr67mUgDmJcAe/YaWLMzE3AXnTlCZfBhTq8rqX0OGPsferar7pHh2PZZttzM04R266O5CXJ1qceVGsciDf+zuZZ7pX/0z5DALwcR0B6YgBuRngjdHfbsDmHoC0IWXAXU8C583iJjICdG63LfgOGM0eoAzlBIBV6j47bnyFG6ZK2FKy5urMsE2NDlpT2zp7/vplO4AO+HxxJR7zjcglrrdzDsyHnFYkT/QsnJFFaBjjaIKvYAhL07yaJMxqAXN0xWuhtqi65Bzea0nzlUBHUJJeMTcneoi3k7ZLx9zbRwXRATzsNVBZJLm4AnjWOKhQT3XFMh4/FQJCQ3ys0kbhiIsCo6iDPOy1eJsFeGWIyOCex0OvokcCLV0A8eNniqyrgzLyUGvWt4e85Dn0xvvhg69rUXEXgLlSNfCO11VBRSDydm68iHuR/vkiYFQJ6FTQxNusKrgjGBCi0aggkKIr8wDuznb45rR7CArMNH9T3BfpOBIvuT952+cxPJSUWNvUZlsv2cXaQ+SG/pjuPW79Jw4CYMQ/FhAUv5djMWoqobKI364EZJ1H7ZBBAh6yRsDWibOzVFfkWtB1pvHGq85XPW1c3wK9p36nnTndZ01bLrFGrqmiawt4kWe3vdxWakjqlLSpkpzTT8YfdwNePzIY6T/lhIgzLi+voo3yjJezbkrJIxfxyjyWPtfWvKzZI5//+8LPc+t6tr7rWWK9esdvvd8++b/+FFnWSfqywj70+79uW7Zu9wqdoqb5uiO+ueRDFS0VsFRSNd8fmYFTv1zG2NaTjIgcKn39z1+9y46d7mVeUbyLjq6tqwWkkmgLMNcElGyu+kBGfc+p41Bedvn9rWmYxzqc9U8pDpIq8pVUUdOffxWCS7x3rWVfu+0b1rVxs6u86DvFWYXitATqsZV3XcB8johk7+G7bXjgrK0jwluPklghFZ7bqbUQalsZ1TCe+fCMyx6MvtL8yLjnQWdJ4yBNdCZ2K7ztJqQSRWWRIVKhAkBMpAyYKyoZwDwWO+0RcgTNEX7qw7stuk4xn9dQfraWZIgl3ldCr1d15f6kKT+D8tZjD+21PZdcSiE/qiFLy5zzPnLsGPkCt9n9995D1dkNtnXLZrsOWksrHPNyFZrD2aMqn+p70X4WmG/z0jvn3/LoV7B+K2/hg3/5F/Z77/3dxDHP2yfTXuNz7PwqxKzzvzczMfbH/PW0Ao1P9Cz9e7/HvNbkwzo0WanajeF72r3Mk6dlJdSnvcdcwJww3we0s4aPUazjNR+5AGcWFgzQlqBsRkcUMHFk5/DcvY7x4Dlqe9x8dHDmQCc2kjoSn3Ce+UYqYD7LxmRV6KeqOA5UFt/42GTmAeaSG3Qvh8Ko8rh4klxcIl3e+bqhdxpAIpLo9Hcs0t4yLdi6S+lJKyzom0YcHx7f8OY7FtF78lDqD+cnJx6xo/UApX434bR1QOYHOycRb5kWYt5YYiFUSelir7AX8l5S+8hiCLr2UP9RO7Xvkeg/B33hUVm3/Spbj+dMvHsH/6l/45cWe0AtwLyeRXgWj9UCKh+uO67+EjAn8dNVF/yG0iag7dEbLD58upK6Vf+le/Sz+7+Du+2eIG2qaT7k/OY5vnjqL11Dfaqu8C6LcHoWuYj5lD5j3L2HRLVgA6kkDC4d8HmKaajBpfBNFTZV1ciG/d+wYnjoMShoIrdyXm4vcgQi0qGNOQ2y36yuH6yMZNT4OEfLM5ChZLQge+fHhWLDi0TMNBZKdPXvrRmhYcyme/W71lXFRg8EHpGZ7Fpuf8SYJ8tXfSRDQF76asqsq6PV1zMA1r2TMzaNJ1pJ0Ttu/GH48jhCpEMuqcXJEZslubO1Y721F84bOi2qb26Xb4dj3r3O+g49hLE25HxvXX8W4Czv9CQgWG1QKfcagWR+SkrmoWHAiaYQzzSfT+OBrlAxMDybCvgU84DqkdM9KVlUVAABy0G8vjV43avxmqvKZwHHLS2VUq1wEU8wyaTQM4YmiYKRVCr5Ql1PVJLmBirL0pZF7m0RI2GOa+JDxTu6jAIEmuC90LfwhE8BbAXwJbM4huddCZ6tjWjDw5dnmjAnpNGu2VMELx3vvXTKAdsCtAvMq0oiKlo7RvC0gzvcKFA75ZlugwJTgSzhOJ8R2II+QfIbdJhyjBXn/gOMqzuvtBqk5GrRVJ8bP2cTZx5DtWgCI4eIQw3PiYCWDArXvFZaR3jvNQvKiOqJx1ym9kwX2fZL9tgddzxsOzaUWntjKVz/JVtHRcuKxk1Wufsm+Db9dubuf+F+K60Hrf6K63/Wyre/PEmFPjEo93nHdUUhmETSbh7PuDSpG0iUVBEu1/hOwD3H8c3WZn8MHr82+6L0LV4Z/9qXkgTw9d5v/O4H7a8+8kGbxRPb2lRnf/7B37JOlFHkgdZz7ykYgDklgnqESzk2vv6Z9Y3PI7FbBn2JSr9nzxLJqLIvfOUuO9N7zvN0tI7WUcG4hnurUlYvrzBMQkq35/RJ27wtPOY5Wo6v+7He+XrG9WrhKCmhUk4RaZJnwFyP4le/fgcgdHvk0vC39h2BXwH0zAEhw2wRa3OemhBnDtxBeY5e69y0wxrXbbeiymZr6tiqh8DXg4zKorngyw/9nlX+XE6e8lwCaBoTtb2RiKGAeRs/tYDyKjzm5VLzUrVpr3YaBZSy9XyOXIR+kjb379tnzRhBV14pOUMip0nmUtx6JWBW8VktjhuvnpqiCqI2ZX/3jY7CIf8H+xSqLru6Ouydv/I2a1633udfhSuSSW5UcsUoWqnAmKp2Q4dZIIu5RkXOUgE2zyNgTD75+c/bf4fOklWxzoykiCKsTtHR759cXfxDQk3fN7rZ3+rZ+I/8nH7dxvXFJXfBWH4e4/l87D+yTf/e1/6B8JiXlxXiMc+ASXRpDkj5wpKPscND7oAoDvQV0AHOU3gFzgmAWTvKlszmLN+hkjKnN11u58nKl5dlHvJoCVn4uppCa9KflidYHgP34Cc987VLJjDkIDQPOKeFL/ahBNAcoWb3KACVPBB+r8ljnYE5AXltwgLxDlR1B8k48c0p9Y1TJ/i+3CAgAHHMJeeljWgBCUYV+yh2j3konghQhCcp2j3Uc9hOU0rdaRkJ1KrFG3dea21bN4dBo2Zrl/N2Bv1BhtQ8IevGxib3mE+RISYeoJI/C8XDdE9SqLOshaczr45bE7lxzKgy7n1KbfC7VV84SI171Kbv3Zq+Ht53gSW9HzKO3lMC5X6XKaqSTRe9o77jXuQ3XAWYAAAgAElEQVRtEc92Gk9/vReXYuzxSkm1oxhak6tDcO5GB+biA0Q/TLYDMsUUSgai31sCyWF8BWj3+9DfFxqJ+szvzbUh0ufRL059iS3VaTThyY6KrBnIV6cJsEZBkbQFJ7DkXSoDRKfwW485Ew+LmzdpHqWZRJc1wzw5ryq2op7we+/4gk2QbFaIhOOOm34YScYGR/aeyEai8ALGy+WXrHMahZLYSgE0l+3oso2bobIcfsjOz59ziT21YVoeYED9hLi8NKMcEC2+dw04p6J83ppJUByAejGFpvg0BwpYyiAVoJVnWvPCQTrf0fMxI4850n/6fi0Fg8DwGAyAUe6/icTHOoDuHIB0FKA6RcJjKZSODsrba8zb+K3iRFMA91m837OA/POAhfmZJeumGI/UTKrqiIhQBbMN8Cw6yAQKMP2jVEWs1/0LdKsfV1FekTEAP3waqgKe6HqOn+d70hqXxjiZmhgcukd+SplXHLuCEViLlngt4HqcKIHAdRkRg4EBJDaraH/XLquBnrBAQqgkMQtGH7FJ6Au6ovTdF6S5Tbn7gkI8kSS2qoKwt4dnYgHqjMts0kdSe6kDUD3y6JK98LU3Ad4qrLm2w0oaum3m2F02fmafnTpz1JqbiRIReSiqaLaSXa+3su0/wpwPr2S+xrgoAlp/5IFVNE6ecV1HlRtV7KfCC/5EwmcGmjUN/828z62H8eA/mdf8iegsabXw84YHeNXe9TsftE985EO+zklR5K//v/fj5UbJQ/KGAqW+ZiUHD8+3c6R56V7OjEBXKa52Ckcvqh8q5vX3X7ydpN0hLzamx6euvp7oQi3jKPnXcB5oDZKR2Hv2hHVDZbkwIqC/R6jSue+hB11H/cZnP9u90E4BSs+ipyFx/jvuuofEaXm85cSJtd3XMAH77IYVmVQ0D2DeAzCfQv2qs3u31bR2WxHOpMb2LfJCxNFJyzyLgEU/xRoZgJxz6XcIyfgzpXY1wqOXYSNwruJCVfDLi6Coqf88sZKIxBw8bq1N8qSLM14HMG5ta3NjRxEJ/URlZ9HKwpnV4Mm9MZ+y18n+Prv3QdYJzSGOUVG8keNH7EUve6nVspcoeiADTx5yr3VB41XtWvx0GUsq4lSJF13HrcltEukisfin3/RLds9X/9X3LFFvylg88NjPUZfiTwqqVn57/937vy8l+nKd93/IPxgTBt555OhE+esEPw8x94nTPb1fPxjAvAK5xAs418619rFdQ26+GDsACs9fInYEyPWwWkJo/rUEyrTy5L0iAVSqKgLmbPoqBKsFUh7z7isI3da5luoCSSul8D2VfDiHfnNlNaWlWYy8DLxApgMrtU2e0TVecw58O/ZeQ7gOixJQCs3rC8FaHOugOA/Qxe1zJgFzrbTugBcVIQCy0yjSQr8m/8cCSeKeKtvp07lxvJcskqVOL9HGKU1wVZnM+Z2t9+QjAKqjfv3YZELJoXvPtdbavcnvJdtEvWiDaCGOTwAceOQbGlCzIYFynKTAIhK7SvD6SdEkKkomH64DywQ51W5ve2wOft/eP+k+c1EGXSfMEUlz+bjqV4QI/MtR5AnQk/QqM05+tvEFWAn6TNxZXM/bwnkorcyGM251jUgGAoBnxoc9FF+Mt+a8CgxxTNP+26yYyqoFhCfEMZ9so3+4PU/O9ZFIADkPA/s4ynjx246J6F5ENzSylNjYjN2gyL3WjvXzpjnvyaypv7JRX+PLxC7vHPdk4+aiBrqmPkvGVVBpdHy0wQ2PAf5HuXhdC0ESe2B81qY8clRsO573SugReK4EFFxas89WJ0bthde32KOnxDEXDajYrtgVVJY+qCznobJQH4vT4VHFKz0DjpsCCJfQvgpoHcUA7hqAZi10kAYKFPXjkZ4GmEvJRGGGQgFW5YrhmVbegaggquCpeT8GEB4k6bJR8ofI/okv60VTGOBW+OXV6KpPobQyNl8MPUYl46W9jJxh0YJzrDUPxsYxxLme2iVFl/Gp87alcxG95mLC63wftRUwnnvsBdIH8Jq31itREhpOtQwu+Nl468HZ0G9E2xA1ZBkKjMYScI88op6N4XHABQmnKlm/QORAz45yCOsA8TNwyVeh+JRDr5kp3M5ztsO13GUc9hw5RHLnScB0KMwsc2x1re6TYQAolXPtYbjvlSintDahbFPZYeXN3VZeD1e5BQDOeJzvOW5H994Hb7rRDu0/QqIg97iOqIQ49YC8OWh8lUSFVre8xqov+0946kXXW6OsZPrhmrPygs4gmXkecCRljEY841LN8FL0OaMzm/zZGpI3pf8d/umeYAzrd77vj+yvobKo8NW61gb7zCf/zPX9HbAx1u4tDn+Hv8R1Fu97iX48PTSFSg7ecLy6g3h/VWTsk//wJRsYGnMOub7S0FDv4FLA3J8Br2EQnP6B3lO2YTNea+etr2026pPPfPoTtv++u/2aVzzrRnvVa34yt/6l+KmvP0cOPWo7du5ey7vxdiZnk+8T+lv3KmA+ZL0H78RY67eu7VBBmjdTZRWFlPbuWIPSPhp0lTBKtHy46c4/NH8csMt/48mRa8ZRGTkLSvBUUQkB8RnyGCaHzlEeYMm2bVhv11DVc/sll7jTRZES0f+cw+8ODhXUIhJAv1Sx/ldjqInCpOPk1c430NSOW+/4hn3ojz9oNz7nOcisbrFn7Nnja4iMv1IirpVUehbFRepcus48huAsRYeqMTDDQ64CUYmM5/fK88Qc/ZO//DMbOnrUvfEy6Gvr6xdxsH2Eufobb3vbu78vyr3/Ozwq39NTMn4SkL+Kn3XpxISY7T7GGHHaH4zXDwQwryhPyZ/Ja55pjwbYyfeECyzK8xEbQFA3AuCGT0QrTiyOkfSSY97GbFlDNY5olfwpYB4O9EIbVQINIbMFJLZ0cAnAXB+ODp+zRiSelPCjxc7LM6dS7w72BA7VUjcG4jrJp51maYCrNadp7BAOUVObHN5lIM9PkjY5nVwAKp07A+ji7jpO52Mn/6TvuFcET8/0+AS3ooRoKARk8kttoIzNRxtIEZuW6DhZ1EGXOIsc4ODxE74wxk0EPWPrFTdYE4uytzYt4hESTIYTC/IcFJaGpiYKoCg5qR/vG4oLcDWLAecqS+1Dkt1non441sz6KWu7Dkv/lvcz8694X6ZjfUcJV3HyzOnUacxlsPiQJVqJEKhHGlJIN41G7rzauMTjB11Njg1TRa/V+3oWQ0YGTAkauwXSEifxqnH/7RT5AZhrOOAMT7YTdQhWUABr/RIASJt/ZuDEnBTlIQB81lYfa7/HMCDjxtOXvcNSB2XGnd9YyH9ptq3Npcw8DR3o1JzYCDVe0RAHAJoj8TTFYHh71AaAbSNMQKVW6PA5/r5/fA7urVxqRbbzuT/KZlmBwTpv0+gnl0DTKCVv4bUvaLf7jgBaAXrVGK3P2Akw7+4CmCNVNjfiJeqVdKpiQLMUBZpSOXuALiVLMHxQSCHxUB5u8syoNqliPxjH8zyTAj/cZyn0DxljisoIlJfS75LYnAQojwKc66F5SPZvmZD6Mrwi9U0HhX1K8U5PIoM4htLJPPcij5wSR5Vs2lJP7gXPNZLVSKsV4YGD6sI5xigK3d1J0RM8121wsUfGiCLA2xYffRYv9TBBb2mAM9UBw3jSaYf47FJpmQTci35TV7OIGoqeKxI68aarf0VzkXyiki2ldOJeZu6lEoNC3vKS6i5rxVs6tVDtttJE/3ESa48AijBa6hatszHoXgtQa9Y3IlNZiGpUWZPVdK63+YJWElWbkUVkfKFxjLBODZ45Dp0ARanz0G74mQbQ11YVUegIfjkGRzUGjugwKt9efdlr+XkdxYtqcp7uLBoVnk8tjooaQCnAsFfCnTjjmVc85lo251K0J88rmp4O/5XvGb/w39lxmaf9QhD3RF73nMc8ccz/5qP/E2A+bevaAeZ/TR6fF9pS4nlE9mLtiqdQRX6UaKiciT7E3asxNERZGyaBUBWWP/apfyRplzBJ4qPXwYPW8SWK5HC/8sLqt5I4h5At7NoU1S6zIkPZ/Xz6Yx+xo4/t8z87ujbYz73pbb52JYaXP4Nq1yEKcu3ec0l4tfV0e59GynwsbVrrRIUidwIZ0p4Dd9rY8IB1bdltdR3bSf5sssq6Nj80S3iU13qOBAN59V11ijVuCXAro0RJk+HGgi/uhc74d0qIVeGkTjzmnehqbtlAJV+e57Sx5pwLrhKTFE/0W/ScMgC95xQQLRVoDmCsqrHzkZSZlxir8VfbvvKlWzHwmjB8mqyDgkvFnKPMizbFPitALglL3Ys47tJRzwfkWT9rHB86dMDuu+d2W6DKtTqCZNMVIjh/VVlW/e43v/ntZ/Ln4sV/f2c9wLjJ03cZP9vTJqKH5EHG+ex3dsbv32/9YABzqCz5i3y2kP/bYVvjKmfAIpatAGbBSM73KiaAnDyFAV7jpcWxdgTgIY+56AIcc7C03gu4lKNnXVZLwgmZ9MUA8GkqwgnMTWtXZqOvxVtUjqdJi6x7cQOJ+0Kn3wovu/d7LXKXw9ny6uVAFccFdSFCdd6u6AgHnnGgSNjyniTglig8zjEN7BVebm0+AJglEoQ8g0x8bS9owaIMxUSeOG2worjIe14imokqV3qkgRjU/vttGKUN98TrxOLX88nmy6+D7xeLs8PFBMj1b+fwqdLl1AyJgOjwkuQzPtgLoCWhB2qDFxtRkSOVyMkBc91WGsfkTfZzJ0+OA27dtQCZd0kka+n2wziJflA3BHyNvwOurnVdgq/O70wINWZJwr7+nq6vYjxsXNNjo9bU2uzJjTNjFMdRCFWyXYUYM+iI1+67jXwEOMBqEeoZDszlEfbhT1fPG8OYAkreTXMjh9h1eBrrdD9hDCXSTUyAdE8aWHnSU6OdPMqxKTIQUyT1ifon3WtMH3nO1wwY549rs0+ce13F5xD9UARAbDrHp3oWoIQs0C/3jM7CDRdlrMh23/wqvGTleKzGrP+xvZR/30wi7Lj95HM7UFopt389hFxmRak9Y9cmQMo6G8DIW50bppQ84FRSgCQnzgiYkwRaxt/ympcBsqvhmrfIww0w7sNjLsAtzrVX+qQNpfCm9XwVS90FMF2MxB8OdBsHTI9OY0xQjKcUoClDVFKLKuQiRZaiYsqio44ygiLKAvcmzFEOMK7Bk94Gx7wKyoiK7AxTHEgFhqT8IpnD1uZVO3HmvG3qALANlwFOFpyOI+rLEOXspVuO0w6AEEaWFE2k/rKI/rckHqvxfJ/ulyFKYR/oOVJj0f140qooIEQfVExFkoh1yNLVb7gcKcIOTzLs6xm0ESo6lhQBppUIizf70l2V1tFSg4FSDx+fZxqqVXFVN6o58zb68O2ce5hjJ/F0SxCxwJoBVFISUR9PTKtPJB2qyIM8/fDgUW6pJIpWuvVVVrbn9RjQjT5/8nXGZwCtM1MTTmOorW/ACKH8Ov16IRjPB8seBdI8TMay5taFr/yIUfbZhVSVCwF4/nHZ+fPP6x5znt1f/y085h/9M09C37yh1f76Y38aOTc+/+NZ0I9AZCnqQlqYl5bm7MD+/VbdQmVJ8Zl57wTr3xLRjo9/+vPo5E+7I0Z0mNq6BuhDeICZgxkAD6UUpCr7SMLc0B386yyXRo3keoeoiHnrZ//Ov/OaH3udbdgjTLNmzGTtOvjYw15i3qM+WnV9rcvWiLhjPeWSBV1E1vbsgXtsHCOsa5uA+Q7WoWobHpoMzrYn6qoYGXuXEv7xPou2Us44lrLuFyNl65Qk3gsVn8hh0k8tz/DmrnZPoK0gXFVOUoYUktZUWNba7tVPobmIzuJgnGsJWOv62XxQuxcklYmRV4cW/IVjN081ZBkKmV55pmTjSZ0YEQLlFZxfSbzKF8jAftZv+j0LwP/8V75sX7/1c95nyySPMM5/iyHyjk984u+OPdFcvPjet9cD9LOWO4FxTWBt6NopxCF/2sgffns94nv4+dfxpT4m+79+u1/+P+z4hGAd2ygGJfRYrOTPCnHMk0pILBGPD7ElfzTvB9IV8EgpkQFZHGwkpQr9W5/zt8sI6mBHeuEtCXqJViI8SQDzApUN5KUN7FRNu82zUNQ1EwquYkPEQyL5sWW0nRfYrGanUeXArVgNf7G2gZLr2rCUGZj5dnMgXdeMRVYX97fl1XKw5O9kjv3c/UQj4/jcP3UG/gylteCZuxpHDpTGoZ6wyYEDZ4/ZIuFHtb9WZewdoMUxyyiKjI8M4XmbtY71bXiz2XDxDsWrwI49Cu+0byCnyuKhT+5hyxU3kmDUGZ6xRB9RT85T+lsLoZ+DmypWX81RYIhEsDIW4VIWUoeU4mOyGapqZ3Z7ccV4ZfaG/zu9L+PF+w8g6koH3gn6PHmd0/1HV0W/rZ0n3omNeS1zIfmHOV8kZmlj0vlx6rJJLxBVGMa4aOdNDI3RIQrrVMaPNNmXZ61h3+1O4/CrARAn20WdUefHnbix4XSU+Nv17DMLzMcg5nUcG4aYA2j/21vEH9rU9GjE7I4uj+hN/OdnZlwy8XTJTgbwCOWidGQytjJef5xfXnNFG8KYcGNOp+HvInjTDQN85GJEFAMSMB9BYYf3VzHedt38Ix79EL1HG+ncMKFiANwzLu20DXDEv3gM73FVsV21pxvZt/U2cOQB5sIoYFhGFUCaSpaijEziWRc3FNEVq4QjrWTHDjzYpeh1D42RqAkwXyK50sddconwpFVkSFKHeom2wlAg44iXGi+2JAqLvMpUFM+RjKE84oV45admKtA6J3EbcCovsOQKa/m8o2EaWgJRAQrxDI2gqw4A9qgC12xE//sMHPOONilMlNqGzln3mM/AQx+ZhCtbKw+ewK3mFpVLPddB4yMwhTIL3z8OtUfrQh30HBU0EiddCaSqwqp8gbklFEC27rY2ZCWVuNmBFNzwg/9kp3rmcAYAxDuJPBVRWKsazjdAp5mbktTc0a//Pf1j1tTOOZOxW4mbfhFjeEXqMs7Jpz1M7GpxgIrYO/m+Lw146ufo+8odL7Njizvs2he/+nEc8gzwyEOpfpDGuBumidaS7xXP/7cPSm7+JmMw53XIPo3fTwbMv5mHPP87F4J4nTPjmP/ae99vnxIwp5/2bO+yD//JH0QipZ4J5rKAn56FOSh3WhPmEcJf4jkbn0LRg2T4+roaGzg3jHFZTpRlzj7xmVsxuJirSh7lmalF5rGGYjYqOOc63jJmBO7xYPeePmabiHh4FJX3c+BcxoBoX6Mj/l5NEzQ5PQxaz1J/ZADzEMB8D8B8TfRAz2cigGtu+TMeev0LU30kV9/via5d2y6x6tatVtXYxX7UnoyjWPs07jn1FTdMgrqiz0TtcTZiUmnROl5HdLWpocqTPqUFLw655BFVC0PPvTjjopbIc+0KK/SF/q3Cdf9GpScZaT5GtLsPUf318NAvHGenRGr+cO7QIsfLj3El7XkZA/KQlzGXvXJq3rzSfQjw/+vdd9jXv/416z91kkgSHPflpS+UFhf+2kc/+nfSzL74+h70AHNUdJUr+YHY59uSjB1V7VT54h/Y19MemD9XqixQWb5ZeHPt/cwr4ztBeHYDbwT41j8Dn8ZDHKtZbApxWGwOjtiEeEiiGiFsrkwt56uzee25EU1bONPU+64iAUUbp0tmceJFPCzFhOS0ia3iAajEq74EyFAo0M0FgS1dw125WkzDs+ktyGPjuAc3mpVegZydM59QtN9N3FIAuLipoD0IdPl74djWV4oF+nljtK+Hwi/91rZhm1Ug9ReANS62RCLZ6DmSyFj4yth4G9s6uR90uwWcOe9RPHATg2wiHvaNNikpbtuVN6KVqxwP9W94dVehdEwNwcdk8ZbwsTLnS4ksLNNHS9OjLJpQD+StJ6y4QP9Wd+9EqlFGQDQ4Bzq958OQ8jHVhpG488o5UOQhKD76mjbDGOtsPNf85/n9GZ3nXhv/bngNQ+RyzSPl8QWiBwuEv5X9r/GqgAu5ivd1Eb65NkJ5mc5z0WIMjga8wOIV+9xhaKdYrlbYuHxe6S1NqTTOPv+8D7N5GWZBvmqL96RPHIH04JdLpzqLSGQTwGldDv6dGRoGgIA7AMyTqTTn9b/M4ItZmCu25Dzh1EZP3M0AvDvTOR9vgYutXmq+qJVoHs9w7nvxmM8wjuqbnTe/krGGliSvIOcY6T1oZQDeV9zQbGcHl+zwEJJ7lcV2ze7Nth6O+cCRhwDm5xyAF4H+x2fkLQfgSs4PoFpbLj1keNFQPFqaRC0ppNgOnvUZhd2VsCyAs+Ce36Iiya/55DMCWC7zN0bi5jTe90b41YoSqd7AIHKDDVBJmnDMFfCdGa45hpdYSZReSIo+rMTD3Vkzj3wgmzhgdnCkDKMsxkYCQip8NEg7VEXzZE8RJetlPBBN4VxDcNJhNjndRx7/IlUP9b6VakzQynBY28GTAPQquNcYeNJZD/1sJ51Z00Yk/Oq38zcFUgCQ5UvjVgp9aqVv1IqgOqwcu8/O7rvb9p8dtoHhGvpsxl72PGgKcJunZoag29D2ykmMkgokFZk3JK4Xw1+vrKQIDlZHM2p+50bn4SGvEC3gOed7xdUldnS2wR6c2m6ved3P27ZukgXzwFQGqjSX8v+deT3zvZ8+R1MSd34iX/7T91S94Bc+sRf+faH3/YmAeeYF/5X3/KH97cc/jJEybZfu2OjAXPNWJeqVpLpKDolGeQRt7QmA95XPuMpO9JwjqoIkKAmNfT1nrKm5mbnYQnXKKfubz33Ni4TpHFrTRGWpA7yL2agEeq0jyjXSnDp55ADrBBQOIqwOWvWDl1rc++RGitF3QB/PYrb+az1dZH85vO8Bu/yq65xjnt2naiL7oYB7X7WUsElblkm8HjzxsEdG2rsvxWO+E4OujeqpzbG+an1OoFzflxdeL6/4yfW0BMhL7vQeX7OibkC9gDkhqJpK+N2q9klSRLkneOpvUVSItLhXPApIOSUyJfpmc+GJIh66n8MnT9n27k05ql12j5GESrRHOV2ErCSjqLZIeleAXwaA90G2j/NbqisHjh+1W7/0T7YI/VBt4A6/ChXp7e94x2898K3m1cXPn1oP0OdK6HwmP/A7/YXrxu5njC8q2egpe7p7zJ+/u+UWSmZ/IPPiBZjMEI56IIBZBrpjjiTvoRayQNy+2CnxLUBMAKLMY+3cXAcxCilHcfNCPHNlE8ihAT5cFwOO6tSuqwhlrtrE6DjgFc6nKCGOr1T2GwBBYpC8b0vw5iQLJcpIkarOKuFOSieOHKPNApZxTwEjg+sbbc8H5u7tTOD03zib/NAEzBNA9TP4WhsAWmEHgVUHhSQrTZGUV1ZK+WiFDv3AuN7C/KR7YRSynUW9oA6vv2TZgsfI4rn3DpsehVgbJEV1pnt49tz4YqsQIolLOsgReJ2n0In0eEsIM6pCpsKm8pgvE55c4EcguxB5tyUqsNXuvJIKmmxoaSGPrSIAUTZWaoM8XNrM8g2U6L4MnMfReivTDHbfsn9P9xFnzLXVPVvZNZyE4j8+XaClTA0NuISkVCaUBCcKkyoDLk+Pu9KMbwxEGiQPuHFyEOCSgWCSPzs4X1JlyfzyWYwkCgppTiSATttCxlP3IY6p2hztjvtJ81bUGpfbzLzfa89CsF0yGlRsqn7rMVipG6Nn3fhzmlCag9nzkL0X+DvaCAgvFljuV0Kg2g0vlG66exjNZEl6ctM7bn41POnyUCJiY5zoeczAxPYzL622I4Pldv9xqldSveeZl0NlwWPef2ivFxgSJ1ydPYmKygxVOWcpZ6/weQOcZ6Cx00vaGue88qVkBUdhLC5z/6KPqOKn5A3lOeeyGjBPsMQmBphCCeF3JdQUN4KLlwGixSSRLqMsEUodc3OAWa4pj7kKEOn5qy6F7tGAnjeqKFJTGeWaK5IcpJllVPOsxMM9gZpLOQmpJ86i375BGusrTmU5h465KpyWQguZJwG0DNBdxjk1Z8v07EvXvI6EuOn1tqUL759yxJlHfeO0acNl1oq6UTkAqqqylnyO+6xh9qydOnYQTvscKiiE9DU1ZfgoKrGENvrYCtruBXbz5dLSVqEi7p9O75RMJ1GcxbkoolSA/KKiEYs8kzU1paislEMDwOPIerV/vBVK0iY71Dvt+SU//hOvt+fdeKODa4HwfCCe7x3PV2O5EGw9kcd87aFbA1HZe9+MnpL/HV8N0vOS//vCY57oO/Ke/sp7/sA+84mPOMd8W3en/ekHf9fpD8Kk40Q5T/b02969+5yWeNXle+xZz77B7n3oETt+4hg0vGlrgcLW1k6UVDrZrOm33nnQDp/pi4UGS6wKsCo52CKMrVCnkcEZjhgZZ7MoOi0DsCMhPvJARIkrwKKU91cc6HGoclpzpcctb7toMOqbBSIeDRgFinLqfOH6iOtGITztWdL/XyQiQBXN6WG07B9zecrunZdZ/bpdVtWwwapqm3JeZTki3Gjx9VqgPgPl8V4kfUahIX1WwYPWgipNS31NruKnpCGriCAInDuNBOM5JBzXaE1PdS48dPiw7RH9TWIAaax1/0sA8lnoKks81DpvuRsAcn6tKa3oeB03jxOln/X64MH91nPmJN0jID/7AB71X3rrm99xx7eaKxc/f2o9wLyRB+0KfpD58akoIL6XseaBuPjKrWtPd2D+ig1tt1SWqMBQghiyoPlRIWovnEwIOqgfAh/h88wtCBkWc3pHBk7S5iAPRepFB3LJU+uA0D2FnIuNzVVeeE+FF05WNUJlwYOATF4lvEIhAgE7LQKzE8OuQ6yKlpVUhKwkk/98UcgPBkIKIJtgUrTZrYloml8l/dsNCwdfyYOb/l6b9o64ckDTwXu690Qvzt1bQtF+/hVUCcLrAhEMGkb20uK7CDDXwqhuXOa+KyQzpSIXaic3duC+252qI4+oJ9d6NVQqBtzwkqiAmawG1x/neP29QologRpxFx0LsngusXmscv4ivC4L0F0WB1U22X0AACAASURBVM9Z066rbYUF18dB9+reo+g27680UMkxEh9kkFVj5Z7JNPb+aR4ATx2sd9bGOwBxhot1vPuq/AD1uaqVAmxmJriHRd84a4iQlAA+tSEuY7gs4L3xPoefvzDab9uW4OkLSAuMA2on25T8GeMUmjN6sVlDgo5iT2k+q4P80jF//S7Utig+mJscmWEqyUL/d9YHulj2HT9FAtvSgM/dcwB5f4P/rXHNU7vyHgRJpHk7AMWu8gIwl8e8ri82a9kuFP20u8e4bwUI6PsdN5P8qfFTDQmuMdG7z6r5/foX1dgplEHuP0t0ASPm2ksTMHeP+QDhZam6YMQAbOfwXItvPU2RobZGRUfEtV4FDGDkcosqxDMM5QU5ebjbAgBQCfTsa+7TTwIR5SRNSoNcvPAFivdUkfwpEE+5HTjBxa680oSkoeQRpyehJSDapfMJwKrPpTsuucQaOO0LgPZpDAY996KCKAHUTTdx0kkSPXSm3HZ2LFlry5xNwC8fntCzQxl7CvKcPlNIu6NqqeoC7N5cgwEKBWp5ylZn0VLv3GLrn/2jgCWMPgAZaWheLryPYjRLQw+QpDlFYR/Oyf0Oja/apnXIN8LDn8AzL0/pIqh+nLbN0mc3XIKqBQbHHEmcLUS6FpemuH/m7oooM4qEIUtXLQk/PKs4GRYoWNSz1Gz3TmywsRVyZfB09vb2e7Tj5ue/0H76J1/vnt18IJ4l5mXvaRZlz3u+Zzxbs54MbGfezeyYCz3fuTVp7WHPrYXZ+fOP8bVPEyC1Kd9znlFZ3vHeP7TPfupjrsrShJTOn3/wfbZQWGaPHjhqR0704CEmWjM6bP/t599gm3ftdhrbP3z27+Fl92PMUIIeCls1jowJPOrXP/MG+9Std9vX7nqAZQ6N88kh5inRGFSn1JfiVReKGkN7PJrqOUCqBorjQQ4CaEaia8Uqxd+8LxpIkdSwvNiah7bint0JEomUGbVO2uhyeATAj4gtg8x8HnOny8rSjE0N96PSM2/rN5I4vPkyqIaXsSc15VaDrIhQgO/kiOBZ9yJDCZhnv7VWNdRUuI67pCbroezUVONsEcdcSZwA5tAbj2hJRLPWxsNXnDSW+eOX/+/HDh+x9R3tJEfXuFGgOiHinU9L+YwT19D36r98D7knl6ZzD8Cnv+0bX7VR9pKIUp1/eHpq+h1vf/t7/imbKxd/f3c9wBhqUCXITzEXkwWlKqjKXD7CWPrOcvG11gNPe4/5Kzd03lIBMM/AmHiv46DPORayNtXxdp9wvDKAm2BugJ0MwgiLedgu/OSR2Z6HigOr+dFOWZV3g5+hpGlbp5BicZXNs4hWU/2zvk1KJHyJg+cnRgC20wC5eQ8DV5KhX4OHw+GeQI4AuQNnXVjUkHiF5zfzeOcxWhzHJ7Sew04ZcPRv5s0A/SnqjgBbUipxOo6zF8IzknmUV+BKI29VVERxCDLdo8/kEWQhxOs7j3dmVRz6lhbPftcGI+C0srpgB++7AzAljdjow3C2F9juG18CLSYq1sUCLPCm5DwBfELE2pTk4eANbSoreJpduQaP1TIb5XxPj9XtutxWSB6M0UpGidrvY5LiGjnvcR7AdnAdBkz+Rp+Qbtr6Et0l3avaHsQBv/vHgddcYrAWfZf4wgPG+ee57zJPjJL+IcAcxZFloiLFijoQBh85+Ihdcn7WjTT3NNNwecxXJeunnAbfaZXTEBuye7kyz7jmYzZxk6HmRToA9d7TPk2zewhjMQyPmLu5glXOD9fFk9IQ4DPYXGmO6yu+z8c88lyGLGKSGQ4aP7VXtGh9njTpi1UFsk+RIz89Molmd0FlEaBRv++46UehBSC1KaOPMZ7sP4DHvNB+4qYqAGSJffkgtA3oFNdesoUKhtIxB9SIyiKKBzco7jgOXihOeOPx8JL36ICmBo55Sz2FRjjvMEJboyRs6phqfDYVUEikth/GXFQslMrLIsB5ygsRnbd6vONSeREvfoaKoUVwDdob4H5jaUxPScYRz/lSCYaXAD+UKpJJO1FcKaIDFoiYqdKoP7vck/TSV8jmLcdYEIVq/8ly27Fu3ro7ZgFwFBGCFjMMneWynat27EylXbGjnXyNYduwbZ0VwEFvuOwaWz56D7ruZ+zRkVauVWu7L9+GMgoKSbOTNnb2ACXGR617Pd5uMk9LKcx0BqPmHHKKWzEAlEistjZBs5mCGy9FmXEspO0dMy4jN4sXvZmCR1JzKWaMp+bw5KNrOUM/qEDaEvNmvrzLFra82PqQijx5+pQ/j+LnTpGcPTY5YZdefqW9/b+9lfNJXzpkEfXK/XaN7XjlU1ieitf7iQB4Poj+ZjSH7Fr6fSHACzszzxGT1oLUxFj7eC7+8EN/bnd99XMYbQuoQ7XYjc99HmOIF5gk/SakDmehrEgd6EUveJHvIeIy3/b1L0EHmuNvIqd0QzOG+eatu6yhpdN+83/8qX3jrrvAw9PufKhlvW9sbiNhV3QVTCf2CkkD6rMlZRFzzqDBoR6iPpRnGRUjFXUrwnmjz0XlK8aI820p7Rm6N80FfU8KOEsqaISTQOcUXVIUHGmpa72dnYbCBMVuAZ3uCSSEpNDS2dFg3bsutfW7nsMaDeMg24PkdNJywP/cY86PJEUVSXK5RLclInFW4Htda5Ota6u3lkaSjNEvF3VF1UpFR/TICvfs2u2p7Zn6UzYO3+x3eO1X7cH9B6yDYlmNjIU45KIXibcuDrlHEJLkZs5ZxffkIT988pgdO3bY+nvPuKMEjvuhksLiX//FX3zbZy6CxW/V+0/9c8ZpA0eLRw4NwLeBI/zso49dGuPi69/2wNMemL8CYF5VDDAPlKlVC1MND4ODDv0vQErwqsNbmDEWAuhlADijBThGWgPFAQX5TtBjvPy5A+qAPwSSXdNXfz+K/l0pYGyFkHtj+3pCmyQtwledUwIPAEALygobekP7OrS6obW4PF+cH2wQyZniM+v6ep9zrtFpuJjAkN9AoiKkbdCPE/j2O02AzA2I4FmvWSThcQ1mKxu043NpbaSEOUEYriHJqJIKKGLiAHBvWvhVfGOOkOvS7JLVt7e6x9+pOpxhmcI5h+4FmEuaIvWne3/YYHZDZSlj0wlTIZKGlAQ5D9gQLUFeOq/0x+J9nmstzU0SZmWzUmlmAH8ZJe3LN++yFXiXPo4ONnXZ2DwSlM2wdg5Ix/Wir3wK5F5ZL631VxYbyYF3dbV/J74YmviBVr1Qj9tL8r7CP9XmxSYbhSp0PECP8Ooqm64SgOXZHTn8sO2iYFzO2KPRU20YNSqz7peQVz+B6XRvPozeAtc9UStyY+uHut647i/6IrPF/KgsUVnT3ylYUQ3XYZR3XszfXNg/Z/ypPc55if7000Z0wvvAQ9wh0Ohym06dEZUFj3lvGAQCOhP8fdcYfaB2cL4dN76S+YQWMe1dgdc8BZWlAgvlpdfU2Z7OcvuTf52COlBqz7x0s+uY9x7ey4MF9aeQ+YSXfSID5nh3NSVVol4Ulfoq5AtrY84No/89MYu8IUWIVPm8AuUbJX367Pb7gz5CQ5cwfiRBOI3kXzOShBVlgCROMYdXepnJ3wqdREmns/NlJLEqyVObPN5nAH8dtJTuVgCPgDzedOwx5i5JbUQ5lPc4B5Wnk++PoJP+SG+lve5Gzte43hqosHgeb/3i6SNW2LjRHj07A82lxRbOHSOvo9cOHEDHv2nMZkDXDcz1yuZdRNZIRi2ZseLRg3by2CGAdKnTZJSW0YweuqQVe1F+mZutBmARlkfkfQaDQzru4szP4BHvbKnE+IAWxpycnV5E1g+albz8GExzyEpO4XFX1KustcNmOp9rY8XrOG8155y2/fsPEqFAMpE5rslw5myvbdt9ib3lTW+yjVTFzAdDmRpGvqRdPjD3GZ4HkPOfxvzP8mkoF3rML/Sk558jH8BfeO4n+zsD5h/++Kds5NwZKnTWWgtOh41deJLh7ss4Pnz8uN321a/aTc9+lr3wBS8I2T4ej//1kT8hCjpqV15xKf1yOVKp613DfIEQy7t+94/wth/yZ0wUFTdwANYz8NGHyOMpVVl5wP6ObVtcjeUMFUPn5xcBmqUu3dnU0kykpdmOne5x/XfRanTdNjzz2hfGhoedV70M+C4TnxsQ3EABo0OHDruiygye5HoSgRtr4aoz/4tpxxxJ+1Htkggf3yvHCO3saKTI0DbbeNkLoOKRXOrUzlhLnEOumeO0lXjW5TGXLS6QnvVdFbrgXe3NDsybaEM1ycYy3BQZkHRiju7ky2esJRElfvwrM6Lc2ZAAufYHGYx/+4XP27WXXepymzVEfeQhVwROCcbZ/MkMBXnTB4lu3Hbn18mJ6me/Yv4XFp7kVn6je8OuT/zYj/1YfsGHb2e6XDz2wjE7fx5agBcIYvL4q4cfyR8iP3fx9WQ98LQH5je1td1SVVr8AQGOyGVTmDuhGoFVB7MBawKgZ6Arg10ZVokFKRjkAfCFzpI/0wFlgOgE8jnCKeHyILJQ4auwA0iMLQPQahuakRIDeCs8iRbw4NEjnopTCkCtgE8tr0xJfZMv/JECH7rSAc6C2qJrKUHGWyI04oB0jX4QXtbUZgH1qJXg4hxqo47M6BcuHSiPrGsOJkazq1Ho70wjm0XYTwlvkaQYL/ZA8pOUHeZQlCmhLPkqUorTZPM3NKHKUiEOPfdHJ6wQKj1y/93wVtUL3vzoK+7nkpte7Emi4tbnFvwVpPQI0Qvwi7dZgTyi+McKry5Smc4rRAJsKyEZFBKFKOrc6t55GS5ulHjfJx52ohwleyWgtHt2g4vtt5zssyjMlA+6M3Mh3zOeRUvCOAqQGr9DTtMJJw46p9ErV2NmUbKpKG9wz5BUOJbwmM8ijekyXwC38/Tf1hVkKDlYZAON1XKFECZ9D/dS4QOft/qnq0EEp1n0AQ9XCwT7/NCGGM1xzzVfWCVEFH3hfKz4XF6t6G6/ZlDGkxHgwDoMzTA+9LV4ZuT993mV+k19GtMqxRDS+zJONU2zzblExmYPhJDUT8MA3b1kay4rc5G2bb3u5cx9abrL+Fq28d79GFzF1o7W8Q6oKA/0qUx9iV1zGcAcjm8vHHOkWxhCUVnOU9GT0vPQM6Sk4GF9ALaM31YK5jRURXL/MBzxGRIaPXEYLnd5yZID87DXASd6sqGirND5k3iURVGpg3NdXMQ8p10T04744Y+T96CqmMvQSLgPcdaXeL6nplSJEF3+doxrgPg88o3YXzzPXAuje26m3I4TNfipH7mUEvPD9tBIs73sOdfYwvikVT8TlTCUZg5/5XPWPztqJ8+VWwNFhqYwOOqaKuzeQ2V2/VWVtoPiKyVF5XDgVRfgmJXPHsLIkDypEqSZW4t1dqx/EQ/ltNUQMTkzWGL7ewrtyu11aLwD0qT7jod0mcTWc1RCBcO4OsgSN1tTCRiD117Fc1xbq+cAYFe6ziY6Xm3zzc+gAEwHgGacyrtDXjCr50yPne05C3iH3sYYnEMZox6wesv//f/Yc6+7PgfMY/o8Pip1IShPs+yb/roQtF8Y4bqQovJk53syAyD73oV0lgceecznSh2VK8sAmgcOHbGvAcYfe4TqpidPOF3lXe96l91803NcWUTz+MBD96E8QlS2a4vVaC1PRqnm6Bvf8V57jGJr06gzTQ0P4jmfgQtODYNYGp2KoXmpAmoynOW9zpattHg6nUUKRsET116QFFvS8+8KKQ6apaYjr7qS6mWAx3zXs1xNwun69evskj3Qb1zTewZvOvQaDK8lra8Yf3XsRTuveSFrcGNyBokiE+Oppz403DEwQOQujSh6izjnCbBXJmDe2VqPwViLKguKLJLTZd8Q5UnUkQDnEekMYB4LT7Y+ZffulBz/ER0LqgrKTYePHbdekjWf99ybrR6PebnvSUH7yebFONGcKaK5A4MDjNdRqF6oh3GPrHl9yB++t6Gu/SNveMMbLnpvv9WD+BQ/Zz7A2XQPeXf6ClUcvEDQxQJMT7EPn/bAvK2s7BYeU+QSw4MYsC176gOI+hLjbnCBW60MKdzvTvBswQjwG6XLtaGHGoN7F3MIRouJKvKFBzXTytZCo+j+vPh9/JSU1tiGnXsApIBJNsqTjz0ofVRfSASLHOABRMVbD/+7gFd4Ebz9zoPTlcODXaIMdjGRBbASiFIyqoDningFfh9asfkGHEXXDU48UMfv3PMyFAslHImHV8jCKWwlj7krTgjIcQZplS8vk6zIIt7cLu8M12RR7T3yKJxqAA/JPCV8v4QMfAFq3Y8XnQAUzI6Lv6iEI+9SX8y1uWx/5s0oSYTesb/vnhg2FcKts+ODXJOEHYoXeekn7nOaUtEyQGamSSTFW9K8fjPoB7kKL8qU0GZg2TAkkqHhIyqPrhs1Ma7uLdfmor/0pza3nIEVdolv0mmjiNkS26ePSgKu3nYB8wRA/B6V5IuX7bySrPCUVtU1eb8Wqtw40YDlBSIMeKmqJAmCrvkm+nUW2ccyNp5SgW1FCGIb9aSo7BVTMj5b8+Dnedbdo+2HrM1Lj6wEMM+8/zK3PNNCYF7t1iX0fCQvu9+aT3m3RtMf8W83/0TR0HOSkdd5P/o7usuThb1b4IcDMKsGpVxBMiTfPod3+SEUQFScRAbZluteCjCvtQK8aIt47OYGjiB3WGAvuKwZZYsV2ztE8RoMlGugsmxwYP4A3PwRV2RZxMOuBMxZvNaqfFlJYSHntwJuWgnq1FZAJ6CtQ2MC76GWUsLEVtFaVf2Uxv8KMnGSJVUyqQoCCSSsct4yqCl6cmUsTUNlWcWLWItMoatdrMgbpwdD6iUUOeIelbjZVjvrBMoVcpxWCsvxYjZbFWXIa6ECTCGjt6G2Cr74uH3+jkN2amDZmktGrLWS8t+1eDy7iKqgWV4A8K8rnaNAEdcspRz6+kvsPJrgXhW0sMemBuQhx9ABoNdVAsyltgOQOtGPZjr0hq2bpHihSqfL6KMvW6mKJgG4ZuDiT+IFn0KdRtQwFUYaxahppzDQy66tsLPDcMtX0UysQlJx06ttsv4627yuyXrOTdgVOzeR5DgAOC23M2dOwCvvsyNUD53EENczOzJGLQY8vT/0w6+yn3oNcokX6E1HoZiIAPpq5A9JgPbsdSHVJP/zC73eT/S9Jzs+/xpPRnvJ2qZ1ekmFpQCzsySbT0xN2b6DB+2jH/4Le/RB1muFFWh7GdG8nbt32++87322cwfFeBxghtZ2pjCjtoeXVwoiZ+yHXv5yBABG3Qh150Cij+nayjFSl2jdXOsaPVhScWG9lzHrq0I8X9oJ1NcrHqmLvszurwSvsaJ2boxotmqL03/87d9hTOoAyy9kzGqg01ThTBHYF91OlUsL2DtEhWnu2ERES/ywbOwEzrW36DkPBRbdm74rIpxHOtNaq2TL9pYGW4dsZwscs1r2hko07Ms86VPAPNRXcqoy2XTw32ued42DxiP0x6lnAfXm0IlTNoME70/8+GsxTFXJMwB5NlfCYFixU2dP26P7H7besyehjM5rnR4mgvk7rMofeuMb3/gDLcuXe/i+B/+gv+Wn2cPPbn70b1Yolz68qPf+bfbv0x6YN5WU3ALH7wMOpRJVxcP0Wf10LWRaYHxBiw0jK5Ki0Fxa/1K3cg6BjrQguv/BwWR8Vwuj4I7+cB9rWj21XkboT2CPQiTVLbZu2zZfeLSQnHjsAZRGFiKEl86zhjHjXK6OnUBituCHhz68nS755lSCtGDzmRZ8/R2LdvZ1nSdAm4M7/dam6QZJ8jJoE3CdWwW5Ey5TG/ieWKLlgKhW1DGKAARLi9PWe+q0e3+VvOj8ZnGpBQEdwwbw86qQLJKhw5v6RsYS91yMVnmJ+IAA8Fq87TUqx+2yYShH9EJHm4NvCQgr5lxKTBOgXFGtchkvKmLE9ytq0WUG+MroKAEgSA1FbZCX2vVsk2cm4UUfz9RVMUxqJ7+8nbQ7CzDEWOZ8wnm9Ed+OMfAb9XvxsyYsqzC1EkClUV+mqICSYTl0AS/j6jLuVDZmqTA0cj8Ng2fsHJ9X0f4GDB8ZXD4f/ewB+t057lMkdq9VAQD3mMUGlp+UGZ7/iEokETVvm7eaY6cZu2mMnmaSTn2uAUx11sy4iGsq0J201dNZ3ECKiRxee10j0V/kZfcoj8/TiBy5QSAALilD7leKDv0A84fJnNT8FDDech10JrScXT5OQKh/v1VCUXnZM+tt/ymOZ+uspejO1bvXk5C2wXoA5qvzwz7nVVBnFkA+t1TKNDlvLVVK+hIPl/hp7QJUFCkykOtBgSElNCoxWXzgcrzmRRJWj0fcn9sS+moeOowqdyqhswIuuRRZCvleGWB+jM/KeU+1Byo0blXwwykEWEGmamlZB5SsErtkYycFsKiSCGoeGTqJhvsoHPIF60U6VXzeCSpsdnSa9Y9DY2Mf29pOEjCNqICIPwZ3ewGAbyVU5GyvsPquS62opotiQmU2TR7K4NGHMEZHudcC6yWZVve+qRuuMe0XVWoKo6aIdgvALPB7jiTWEbz/cxgk0/yIwqIfREDgtxdYD1SXR3vg59NvtVRBXSgos5te9ULm4XZrWtdtoyTobu9qpI9kUKH7XhzP9lmSTI8dP2bnBvq5Bl5Wrif1i1noFs+66fn2Cz/z014yPXtpjgRtKZ6Xb/Z6MjpK9p1vRUu5EPh/04vlfZADzrRRntillNuywLy965577Gtf+Yo9vPdB64dmouiCysALeNbgcW6nouQ1115vb3/rW6wRZRW9RBeJugMxuZxGwc+BI0fs7//uM3bbV9AxZ6y8T7J1R4BSe1Ra+NWGtTU0nVPznb4WqC1jvcwKHOkZF7h1+gqfCxhrHdQDLVqK1pgxVK70uet3y4HCOM5C4yhmTGvqqpnDNbaueyuUxGmolwuedyAHzMzckl3+rJe4KkvmiHBQ7o/1mmfcPdmSSaTV+h3APPaOSiZcK/zy5oZafmqsJoFzV2RxrXIVotN6F/uf1g+tDTqPtNxF15FHX1KH4o47qMfBdO/DezFMa+z6665La28Mqvp7CcPpKOoqx44eRq7yNDk9FLaanpwoLi79w+rK8+//hV94t6pKXnx9j3qAPu/mVFJbkSqEpsFBfh7lebxIDfoO+vgHApiXFBQAzBNQEazRg68FhP8HnSO4zfl0BwFQ5+MKVAdy8+7NQJFjEwera57LtKoEV9c/D8Dm4C6tUvJIVle3Asw3sxhJVxqax0N7PUFMx+swXTsDRuEZ1YIlJrG2cLU3WpOBx+TszwgFa9xxB0gyHJJRkDaBQHyR5JfIMO75zrywERVQ0pruIhka/l1tsHBxWcQvufZGp1KMj5y2ww/u87LrDsoTcIw7yIB+1jOJP+gbVoo2uAGRAJ7eFd8ZD5+Sm8rhsy5OT1jnpk2E2SEGL0/aqeNn2DwVdXTrgl9KUtSGJhmSaJ825xIlRWmDVIVR3vNKdx6FCJ6kkh61sQnEiwtfKCAv8C7JLSaDNjZ5r9zLJ09V8jLJEJBKjCIS4oLqHKpA6uFX31xknGS5AdFMJfENHj3IdZe9it0km2Rr9y7+HdVLyybOWWPfIQe1qpK5qiJFkg5MIN9BruZeaBDG3HIX95qnPPnw07wLOO/zVe3xcUjGp77DpJ7h/mYAXC0AyKwKYOYRi/yIGMFcLoPGKFoRCbxpbmVz049O9tZaACmdh/48xfwoY6OtP09ZeYD0QxPKpwgd823Xv8xK4VUUSNUH1Zi5wYOUfC+wlzyj1o6if356sgSpwgIKDK0n+XODc8xX54b8mVKBHXnKxfGeBjh3t81a/yCbPR7jpuoFNnMMXho0DsdcT5C43hpLnHb+TGmsdb9K/hQ/W9KFZaUyIASW0fHGiz4HDeaVz99gX773BJJ0VV5unpbajTdcb6Nnj9L2ausfRroTqblCAPHE1KANA2onlisoCS79dHxzeMXPY21JPYNwEDrirj6KfBxJqlBIivH0C/BLPaITXf4GquHWVFIcaLjP5gf32UBPL6H7EmtslNIRqi11JQB5DDwoO6riuaQEbPjuy4DsxSWPsbk8YiVVSu8+Lk+laDgxRiMkfo5OkMxJe1bpcxVvuuF5V9tELXMSwKdXWUW9t2UDlRoXAEaa55L1E+g7euSoV7WcJ3dkYhzDE2+83p8GnO++/Gr7xZ/7f62dZLzMe3khMP926SR+nrSmXgjrnwio53tN09ce9yv/O15OHsCq4ke6B1WFHB0ft3sB4h/7i7+wo4cOOu/al0waIWOorKyCKr6tKKnUucf5pue+yN74hp+JugvZc+pPZ1DLBOT37ttn//z5/02xoG3OF5eTAqDoANvXH9Yvjyq48VJo5/r7fC3TORXFrGLN1ZxUYqn6oIT3NVaa2ytqv/J3koFexuT2ddCfSfHYoUv299oRKDgbu9ZTrZa5QhvqiN6oyN3evQ979Kq9s9PHc4gE//a2BsZX9JZVe+mrfwrHR0NuDJQM7JxyectldCRQrnvNtMMzCcXM4SHllWppmddXo9JSBTivALCXO8iWmleWQ+Nri85LG5fJKSrnsyaJIUAXEuVFfHr1h/pIFJUH6NfnPevZaU1k7WAunh3oc5WVWVS7ZolKspYTBlr94+Wyot999y+9mzTwi6/vVQ8wvyRwLx45Fry/zvAjHrm4mRdf32EP/EAA8+LCgg/4qpI4yPEUR49lVr0DbQc9koACmKaQfu5zrRcOvMB3yXUQ6XbheRZMynlj0zGesZ43MM7rZoNrbFpP8YZN8Y1lPM4nTgDWJEUYWCFX0EhNDmydqOWxLWUa2wL5bkDI85hAsF/QAVKAX98U/ZgwInLJkHzqGtx+g8nrK8kt75RIBow7iuu7xz4sFPSS6233Nc9yUDUyesqOAczlQhEX1/FpdKaDyzUvSDpR6vScl5VjnfvvQC+89zqBPKkeJ+D3Zdc9x3XTl+dH7QAerDltQg6u5bWV18l5G+GNFjdKwwAAIABJREFUc5pPKqgjSoJHEeI8IdMYYxbnj1CwwtZ+XQFwhahd61oNjSqe8gzrX9E7MRGyaMOKgy1VsWNT5tw6r6cwONcZ1QF+pLhTjUxYG6W55bE8dfRRVGzYnPmegFodg1ILMHNjQM593YbPIY1CaMkzh3MA27MAkgGk8Q9vUzQt55B0OyGAu6sEKVzsc0nGUxgwfj9RvjYHwv3aet+94TFmPhc0Ffz5iIvk/GH5AN2vF2DAi52o/VxXIGSIzVyUimqAeT862HsniRi4aVxqO294BWFoAGGyO+aGDlgxHvAXXwUAJjLypZN4vylzf+mejdZFoZy+w/cTJB12tRAB8zloJ0tKGgVUb2mftd6hQqgc9CvJmFJD0X3MS12EsVlAo1FeeyjrfjsyDsrg+WvYK+CUL6COIjBexHtSlKioqSXfodRe9ss/Zyv33QOAG8fbuWwT/SfRAu9BG12JnuhIL5QCfJlT0FBa6zF6AMuiypzHYymJQYEXGYoR9YAagwe7gGTwZiqJ4rC09kqMi9KNtlq7GUBMBInKmgtDx6x4vpfhYa7Qn+A4gGMkFMvzL811PQqUB3dKUpmKs5TJo8i/kWSsBvCLEvP7/9LhKhhtyD+OAVEKMC6fgRrLUkm9TTVdZV3PuNYaW9b5uNdQyEleceWHaG5q7kthSJ5ceeUnJidt8NygHT9y2E6hzDKNh9VpaczzwaFh27h9t73xv/wX27Zpk68V+V7jzGP+nQBzP1ne+bK/s/eezBOff2zobkOFQ4VDlAh5k+XhnsL4+MpXvmZf/dK/2OEDBwGoSLHSuVLvkJdck0iKWQLI1UR3ZF81AMprSGh89Wt/wl7/2lf7OqZXVNcNkLoI0J/CgPr6HbfbwcceIRLRxVzVM6R1JG1D/uymh9et2+Tw0dOaIn3Z+ULhJgztfGpQFukKIz6tef4vRSqTZjkXXMB4ciOA9xz8KqrnxXfmrLq+maT7OaoU9xMVOWoHD5+xKvJ7fvSn3oBHvTbn9JAnWzKJev4i4TP47F4wz2ksuoXgt8eSG5uYO4Lob6pnRnEhqJxl0Fmk0lKPkdBAv9bTp9UY6RVETCuJugQQZ51UZNQLDoSzIeOwf+OBe2zX1h3uRNt/8FESpfc5fzw5rRagt/w59/xbb3vbuy/ym/MfhO/y34ypQmLikW9IpyJ26AWCcDlcfH23PfC0B+bXXHPTLdDcPiCPgMrkqZCCdLDFqdYioiQnLxAiMO7gA6+IFhTn8hES0yKp5BtlmvMdP48C32lR9aqKwtcelo/11bnnHubLSCgK8cciLFBfQqGZbZdd4Qv5zEivnYYrpw/FbxYGYhlN4BoPmp8zNDMyobu1RZiFTu1LC3WWjKjFODy48RPJrnhb5B10gBlGRqT5BYj3DcD3h4gUODjn3+H9jCgD2MdBbXvHOqgsW3yDHxnusWE4fJIE1OVEN3FQlnjQazrFGZhLe1BAwQB4WVt1KQd/fkkH+vImde+8HDUbImSUYT+y/1Hf2CTLpTLouhvn+6eFX8ZA5gF2YOmckDhfoMzMfApvlgC95kTQiOQZjyJJsVc6wmZsATq8seqgX15kfnuf+kl9bFXR1NNkE0L2zUmAX8YQP+t3XErF1C3uNT/+yJ3Qyic4FzQJCk+5sz9xctUnS8xJ8ZozT6HuUBthEeOnuenFR/RbwF4yklxL6g3i7KuaqhuKirCo2JU45CpyFSUiXQ1B8oGF9J2KnQj4a4w1bvpLBoBTkgDs6n+13RO0/Fbjd+Q+8B2BcA/mxCzySFT6W++5ykLqR1Fu9JfC30ehJh0BAIibXUzy7o5nv9xB4BIRCm3yi/37rHSlEn52lV0LgLz1GKFwQO/le7ps3YYu6yNRUsmf0i0XIFWSpcD2BBJ/2ygp3zuKmgrgtNyVV5S0XGQDZwft0s1V1jMOXQTPtMrdryARKH55Y51oAID/rgZrbmni7xa8e3irUdUomB2xufFj1k7y5l3HmeckbfedI7G0jUiHCu7UqhojyjpQVWZmUQnimkrrWIamogQ78dk9soN1VVGuUDxgn8TTPigk83gya0natLJ6W7f9GUSF0FvmPhdGz9pC/4MU95mm7gFtI7K2IIrPFF5u7lFmcwmGg4B4uZKEAfElDMQqVU3Vy6UoyVRSOXQz3vVJ/Fa//+VWwPZ529QEja5kHq5vmW1/9nNsoeOFvhZVUJNAIyolC/F+9YyUCpQznrMAVtGL9Jxp/g9TJExAVVUqb/3nf0Qmcdw9tsotUQJoA2pT/xVgfvVlJLRmz1A2B9wbHM/Mha98GsuFXvBv5QF/whOmNx/PN1ZUYQHFE4Abz4meqTN9/Xb7nXfap//q49aDoeEcay0bkmbln+X0TQVOAR0vD7Xn0PAjTXOByCqcFG9601sorPSseAaSx1vncJDK73MkHd551zfsKIVwyjh+Fq9uwt9rADut4eE4iDUwi1E5XU8UQD1fHsDUs8WwO5UvnCqx7MT34vPYcNxoz/V/gH6v8il+O+9LJnEZ6koRRePmyROao29m0DQ/ceyI9fWdQ/2l3Z7/yp/0gnd+fRmz3JdX93S6SYBx10dXZJZz+7ruz3tQcCQBKQqKEmMrANk1eMprcFQ0AsQboP8o8qDP9LwIiFfR54qQehQ03U/+XPK+5TqzGFanoKn84xc/5yV7VclXHcPehwDY4kfLSsre/Za3vKP3yebHxc++vR5gDshPJC3yXRpeTSF+HmbO4T65+Ppe9cDTHpjf9NxX3EJFzQ8o2Smtd54gmckHBswOTpt7C9nglt0LG6DWv5O4IiEcGAoXXtxHoCYdl/OpJg9CWg19k/NFXpXVlIiDosEqC0oJ4caKynpky1T5D74tC+Ts2JCf1xOABMwEKtxACKNCBoKn1+RxbtwRJzCthdD54jIwPAVVd+UGheNTZc07dAzQ7+8J8LPge3VPLeICTr6a+4eZUyd52X1r9j6pQ3O3vq0NkCet8lU7SVKUKnDqrC7el8CpmwDejW6SxIbjO1J0a3hmfcldA85+FvV7UGPqmpusvWujFRNGX4UnONJ/1gbYMJwX6uBVAF3XCQ+6/w49yQT4g8cc7qmg13i41MdU1wqA7qAxTJzgiPr7yXTw6pCqgBHv+66oY/W3+l2bkoCRnz3mkyfM8j0FtxsJF9c2tlot4f1FPJcnSZqbh9+54uUYBagJ5UqzXPNSLWAj9kRUbb4K8+qc0DVcD9uBk3SDmQsYiu54A3ifd3e4EmBFvwiOazaGzv3Wvbg3K/TJPa8g3G5pJEI20G9PfRg94GMjo82NuDQvoufF445xLda8EvZMkQtvt34Czvl8UHv0t4yOIVUrBATIQC6rb7HNVz0PkC898CkUa6QrSClsvnPFtlobRMJleL7E2qtXAeYbrBNgPnD4QZJDh/DWLpLAWGpXbVqx3rECu/uoCvwsuyxgmbzeSJGqtPzwMMWIxhfsDW/7v+z2f7rVZkrrAODtNlNGmXTCFc0oRSzDtVe4fxVVlOrVCc6Hp7ugwqYml21dJ2MACAYO25bGJXvoFB54klLFQZexKq76quQU6d9yuNrqFZdrwyNYQh8tcq/KwSiioM8C4za9WAof/LytW1dvGylIU8k6oOfz/Myg9Z04hKEx6Qa8QJKDIE4ouokS8sQJ9sRdrzAcRqLGUaocHtUQzgeU11M0aCd0izsfmrO/O9rE/KuxG6+qtq4911vJ+md6YmqBVDFkoLCuuEwea5TKpUsSsRpwJGNvDutnYhqVJH4XYMjpb73k8bz39tuhaGBA6JmlDdPQBkowLl5/yy32kptu9uOy17fDMX/cF9O5vxW3/MLv+KoiZwIAdBrpwQXWDjc66K8pwPnnPvt5uN5fdkrOOHK1enmypyudML+510oSCiuhUCipUAVxyugTB5sCgKpKzLPc2Nxu73vve237lu7UhHBM6BVFbM5bT+9Zu/2O2+wciYqTRFvODY+EN5ljRKPxNcyVSWIs/T2dQA4AXweCdqfBDf56XEqgvIi25Ot+x/cEyGNt9D8zBwJ9cZa6D9Uq8MP4LTGWp04ct87Odq9MPEWVUkkpnuvthX5HRIU529Kx3m546WsA7uUBwlUlk/5T27QeOXWF9+RFTwupr5XycoumIqBdwdpdQhRIEZcS5QDRJ63wzdd1tFlTc2PojfvzkqiD38R4c5102tCHAbj/0GN25gTKNkj0zknyUPtOUfHq5NTUp6orat7xzne+9yJQfKKH4rt4j+diK1+/nB+prghi7OfnwEUe+XfRqd/kq097YH7D8195S3lZxQe0rDlWUyo5ACQY3WnBcy8CPxzkAJWfZelABw51GBJYMcBdRolwaOngRiePDdkreWaLquOa8GgKJAsMuW7twgzezDlCbvNWv5F5zrWU3KLqcdpgy9kcVZk0PAbJe+vgNlbdjFMutqk2bV+41f4UxvSGOLDUAh9eYAef8nR6+/Q/tTeMlRUBN48WSNM2vONQVwOWcQ5V6/QqcTIOlFzETzVejnKKvgwBZlZIyCwS788Bskorp0Ai35GG9yKqBuJAKoyqTUsbpO8ZKUyb9aFzKuFvCmhrU5geG8FzByijAp04yDJqTh89CtiSqzToKNoDtQn5vqA7Ulu9l1g3vMpoUFh0r1KuUedpPGSAeckbv/cY0/DMJcNALUzcY3fEuEfdu9VBowOhrDqmeOsaC+9zJdKKxqHJFJ1Ywnh2bNpICJxwMBeY4r56Tp3y5E/3QrvnS8Bf3+G02WYrz7jmnWvjB/deuQC+JmrTd6MvruHeaudLx0YeikBqh4Yk2qI2CoQ5uJARl80dB+Lqi3gAnFfuU02Gpwy0uHE3OzKvnOgwmu9hqvjLIwd+XPSXAxyfauLMC3DE336ffC75zJb1W23djqtdtWh88CwRpH70yjuhSyxTlbLC9p1etmHm2/raCrt8d5cD88HDD9k4PNhaqCcwwKBooEzCpn9iFPoK8oiVFA/SU1NNMub8ai1gA57s9ZfZKM9YI9THoqIyFEaO2olh8jtO0x+KbLAutFO1cx7wDA3XPcIL8gTr2cZWmMVLvEDBoFkoKnreC+lrRR8KkCUsr2T8GCOvGkjOiA4YHl0iHF9oY+NQSuorCNuroqO86aJFlFt1+zaraeny/pgHEA0dP2AjA1LxQbIQQ0Fc5laMjFJVf9W46cGlbfLyyoMqgJI9Z+rOEqckyWjj2STIvBmd66Y9L7UxpBr/9MMP2PpLLrNrXvBDyP3VOOdZ1A3ReMSx9pF1gB/zYn1bCxzgKoB5FK8Zp5MnAWpF/K12CYTJSDgOZ/kfv/hZH3tFZDT/5hjjH37Vq+11r/5RN+4yUHghMP9WQPup0F3StPN5lv9y3jP97AoeqrCLgTHPetI3MGj/fOut9jcf/ShgfNRLsfvzo6crebdjTwBYkkciUKnCYAKMAcwrfH2ZRm+8pia8upu37rb/8Tu/abUA+OyVf89qm4D5nXd81feTr37jXjt68nhKnFQUS+MmIz+ijPkvnccrevqbYRhXk7gpepyoQ1qHg9YRc6FIVUP9+Y9kUH8StUzp/rhXAdjJSWRa6Zc2HB5K3J2hOFQ555QhooJgjQDmrVu7iQRA02HNHVeEppxkZs4vypSMhjB4Yk/JrbeJvuPGhM5FsSM5MkpofxVOqEZ45d0dzbadOgQbNq5zjnxGbXrcTWdrSRpTjZH08sfp89N9fbbvsYdtEC95MU4JAX2N/BJ7DLzzz9KYX/vVX/3tA090vovvfec9wHi38W3xyCO72UxGj3jkWuwuvv4deuDpD8zxmKNt6smfgoOxzQlEJM+zv7fGjQ1Ql8C1Psl5YgPUhoargIcW1AB08hbKw+X0EKdBxEaq43XYkhZ/Nv5FkqWme4/ClWYxLFPiZ7G17rqej1DhYOMQgBUVo0zqHfKMKIQpgJN5PpxTHcDZl2q1Jy28TqnR5qpl2BsSgC1yBKOio3s6HVsl4yIt+TqJEg69xEwGUCUDp/fcESLYpJPRB7RzdGQAwD2DCkWtVXZ0O1CdBVzIi6TNqghPkjCpe5+5nugC8/LA4LWqQnmliE1Op5PBEIk+8uJqkwlyjWf7L87aGEBlbmLYWjq7SLJqZIGetDNHTrgGfIVC8IRDC/ASa1NSNCBXVVQjoPsVcE0UDg+xSptZFfVEZ5Inkn/7vuhWibpIBhpnkuyXRwxCZUCNFciN6qMJuCdt8XAcCJAFeBXtRdDZNx1/L8LKbRsA5nX12qtsENmuMSgB4uM4kJa3LG3Kbjg5ZSa+F07ptDmLv+7njrEtdCpWyJZFVCVZU/pTfGYZJp4Ym/ImvIUxB8JgCyWXANLqP0ecXnxLU8FPm0C/qywkbXs3BGUIxGHRz9ELAcgVWXKPmqakrhgAISarQHqFtW7bYxNnj1vLpt0UpIJb7QaEIhArdml1n+0/sUSyZzlyf0t2hq7qrCm2S3Z3WyfFXcbO3EMF2hGAL21GJnEMcN7VXEDxoQ4Sws7blZftcM3tgWl0zZFV7EAJou/EaRuE63tqAGOA7WUGkHueeTiL/rkS4KSJLv2AukpyPURFkeoPd1QqOox05Rkrefsq+c68+PkA4aWUazBH8R55rwdGKBjUzPmonhkBDEmCliAlqqqL6msiBI3dVt22ne9ifGKYDPccR1bzBEmaM4T3y62lGmMC7/vgcIFt6ESa1Gl2YXj6WC9KbjVUjzxpWh5yAHNrHV7Hqgaer0YrQilpYHgWVYpxEjr32M4X/7ht3LrdAZ0S5voHhx3gy1vua4YAoHvPQy61tameRM/KJGOHhjtgbkLPt4OvWI/KOG504Jx95C//p08C0VtkXJ4bGbUX/dAP2xt/9mcfx4EOABzPxVN5PVVgnk9VcYMDAKeiR2XwlmWU9w0N2Rc+/wW747bb4B/vp+w8ksr0mwCfA8uwxGNuevuUzI1nFzBeJkDumtviQ/NvAKyMEqmVyHlSSQLjs298vv3a297syiLZ60JgfhwgfvzIY7YNB8Obf/k90FrujJwDPRkyhN2A1XMTr+z7+l2Olri8zx14lv9/9t4Dzu+rPPM903tTmVHvkiW5F9xwwzbGQAAn9ARQSCCXzSWf7N5scpO7ISHcEFL3Xn+ym83eeze7KRBIAgkQmgnN4IK7ZEuyrN77SDOakaZpdJ/v857zn5GQqXLA7Pztv2bm//+V037nPO97nvd5r77qMgU/y0mhezPnnZKjo5566nzANvMIfO1hB6jWmTfejGQiHnh2XwXkqbTXqBxsSj2ZG6kf6ieev1UXK7hofCBDWtU0S3N6gxNsOcOnn3PNWdCB7KtiLqE6EVjP9ZuQQZ07LS2ZPzP1TJd+ORrwenY893htnDDaYp6J2tMfUH2gRW3auimdkLNqWJSuAfHG2UGKXb/YYfBO9Pj4fXpgf/03fuP3JVk09bqQLaBxibV5td5z83WVmMM8cs3IU68XsgV+7IH5jQLmzQLmkUwmTwYsaHgajA4DXIBJ/GKi5AcrXqwlsWUfuCsmUnh9Bmh6meMX3/kXJj3uhRfUkfGRrth8TYHN41vQ/B4MnVjJ1c265Hov6qRJRt0Az7PVPrgYlAZ7cLwMB6+dRTR70Uk04+ncoAbEHeuL+c4GX5SHK+kMe3Wh4LDCh9Fgbz4e5bwkGDexU0B5WYQB6dTLAZEkIxGtQJrlKq1AgIJyatoja6GuMzyshA1aEFBygIPJ+U5IY+shvNQxo3JZQJsvHNxJu7DDWDhNwc3/D/748f2bRZHQzsK0GVo4lJ1ONjqfkymvXckvSKwegDB0tAP8hZe3AEK8oVVZc9seZG6Ru8sLosdDnGpQqXsPIRsG39ygE0+8FgHAPgBf5aNNAGvj/E69ICnrAgbJ3J/vBfyHtNhhNDUp8cW8RUtsHOyQQsuIdkuqSbKhPmaRswFF32nBteyhCkQQINrxVegC6qf7Mrcn28ixgyEKgt72XJn7SdlUc6+YsRPinRR3OwMkvMkemUWgnh0F+kAPQbXQqQ0Dt0kOhi0GXDRtxZCJdqfRMApjvECrEi3aRg1ymuExzwaAF3WMBdF75iwU4DuWFl9+k9R3pke5kE7Tdxe37U1PbTuVrljRrn4YSlukY754Wo0SoSyUkSbwve3xtHKGPGiH653imwC0GrV/m3ZxRPdO/cf2p3V7pBiigM9RKaCQrGdUOS+aGk2sEXiRrnqj9NSlrU7qedRR6uTdrhM472jKHGPVvRG9c0khEki6qK0pbT0qqo0YlRJcccKZMRmvtTqvWu51YTZ7Zs9A09E1jYEy2LLGvwBzS89F+qldE8g/AzvSprU7FKPRp3bYk26+RJzZqmWqU4sCNEfTyy8VTaL9qGgwtF+dwRbj/jTeQYLilGioVZri0yTZV6d5ZFCAc8uu/emhJ/akR55TRlAltlnzK/9HWi5t7W7REXhpm19e4/3uA3at7F0lLToUCuhPOqZOVJlGfWc1ENK8m76i3TztUhmsSZoUQ4FMrOMC43/8hx9yEisDcx1LAOg1N96c3vdrv+rMjuU1mUNe+fD7+OVc7zgef3bQehWsCVWwVTScQU0S25Qt85//+TPpnz72sXRcycqsse05JygmnrozBS4wYQHmeu7ISKk5DLBa3hgstAeAcEiAuEUKI4Dzn/u5X0hv/MnX2IN97is44ePpOUn2DSqp1CUXX5LueeM70te/9hXPOaUc554Xu15VaYYkBpcvnC05wKvToqULNb8xD7CbqORYamv6iH4hSJnSo0hiuViNQ6hHprnoPwwVOyigLcpQxFDH8KzNtDgbxfqPtizB2owHmmVQhmtN22xTUVANgrJHYLABOMa/nTrMJ+Hxb5LXfomyfF6xeqF3FfCYs5MUzgfGW+wys4tG0OmYnDkYDic0367buF5Bp1vk5DnmebVV7T2kB8nnex2LHR2yp+r8h2Uw/btf+ZX3P/x9DKOpU75NC2hs8uBCWUHTmZUJhRU85LumGu5fpwV+7IH5TS973Rpx2O6tgM/croGjASf2WwS4nfRdcMg5CGSRUXm4m31mAM4IFKxgcnu3gytMMFpQnXV1yyUDNuWxHTqh7JXHUp8knfCYdi9coc+Jiu/zFnVH93xremu1z9SQAGkFSoaHHBDlTVcdl8sTpQpA78rgNY6/g87A35S71JXzofTg4QhjJPAxvwUVJTw5AUoBgiTaOLL+EdevHt6gslnOWHF5BE9aQ1eeQ4J4nP1OXnFfJhaHbO74uvaylvHNYkM7unwBzKs0KdPUbKUf3LrWtJE2BVqNEeUnT/mwOK9kHYWfzLapaSluJoJhc3P5HsG1h45BvwHgAFSmJgEQ3Z3QgLDOVEobb5RPHiO3pVGtr1Q51rAmAh/jDro2XjQWNXsUC30jjJsaAahRGWT7Nz6Y5ixc5O46Lq8nnGqMoNZWyZBpgQtDSP9TFMaPfjHhx4veRIOZTuLyAILDqAi6FDtA1BHPuQAUNCKUFzDS+NxBogQ1M3SIQ2B8YnJwHHXWseykqHZoAHPN4I3SSGHQIYnJf4wTfPfocNO+hb5lzin3yEakl3aB/ZHRUwEMbEwEf7YKeUrVbemVd1iHnl0d0swDbK/oPJge3noqLZzWku5YMpw++vV9adm81vTTd1+a6vR87Hz2iVR7bF/a0SfZypG+tP2IOOK66LyZog301ihLpcDzYGyjSwJcwIR7y0iyMkt4ruHY9gtks8NB0VrEDSdgVMpsyhYqScFjGNNCxXpGUVvZIkpNW2ddOiUllfYOgTTVEVAxLHnCMQEF1zkbweNKFjaCtrp2l+oausTrvkxG5HQBIX12fEAZI9enrXslt3hJR/r6M71ppG9DuvXK4fTNrRI5GD6m5F3SehZ//ZaLDwtk6k5jAkdSralWYrKuaV3yVitQTzz07VufS0+t25ce2yKlm76gn3Vr12DeRctTfc/C9JP3vD4tkzb1KPQLPTsohFBmAJh3LnAyeNyIIqEMjS3ylmJUA9hI/BISfsne8lF1+oD4xzUCaIxPsje26fgPfuAD8vBLuQQdSn3ee/R4Wn7p5el9//uviYojgyu/JgPzCuc5e0krB53zy/nAfPC2BUK1+9bXd9zjyp5YOQS27d6TPvqRv03f/PrX084d20U50e6H6jdmaznP0jxP2VsNiC3fTHjMJ4A5YByPOYCcHQKSN+ElGRYlhMDP9s7O9P73/Va6+opLPc+V8k4Eaoac4GNPKAuoDLhLL74iveaeN6evfvm+CJR8nvrHLpqyhs6SrO7CeekK7QAtm9/tshLXg2SiNb1VrgE8FZ4g8m6V6ouH3/3B/M+cp78p0xhzgQyU4LWTbAvJRM2rdpzouYBqqfZk54pnmfOPD4xIv187u7MXqo3xrgPENe843oYgdCZY5rlae8WXqJztXc2ezzHOoaHA8T8uw+nw0cPp6MGDqVe7GINHDurYWQrwnummPylgzlpDO7NjimpOva5pIQWvSzKmRa/SPPv40Njob77vN37/8883bqY+//5aQOORqXmF3kRukwgEXeJn9H5W4yW7Kb+/a0+d9b21wI89ML9RwLwFKose+hqCIuXYgA8awCte0FCshGJQFVSVAOaGEIGLeQFszQf0kfog/K6B0cpBQZkZxfMMKAWbsPVtagUYTpqzSsnOm0kT1RcSmwDwqxVgU9vY5oQ76GTrl0oZDcKzEWHagUFUAG3zmV2EWGQLDSIzNOKzDL4JELQCjWkr8jcLEBlqAirsQc915vpG0HhiI4p/WOBm+LBUWHZu16SpRCXyAs68TIFkmkRHtFiNDJ5IbdOmpVpniYsAxJKxFHDtAFsMFntMkLELUyL+1z/QWtwNgER5hbSNf2CHks2Iv0lq5/HTStqy/7CpMM3T5qdG0VswZs5QJ53OUgGgMP+ae8SMHt5b8Kq93wFIomtJfR2Z9li7g+YROww2sDJ3nAM8K3EPysgRNsgixNb/24hRJtcMTA1+9EWjDKxTQ/29HUcDAAAgAElEQVRp/+anUs+8eaYPnBzUtrMWuZPyrE6Twg0eOu995N2L8GlHEa2qQvCplWci/NiKLDayaEPAhQeZx0yNgDBGYDEbGHQ0KeA5Rjhlj/oAUCbrkLuKNpCKyRbjpqKfnrXTPdjYGco7RzClKhxZdhYoJYYGgF+WUiQk4Y6MW4EAMsAKIIwoELKhRfQejTM4sAAhocjUMbYnbT14WgBYSjxqx56qPskn9qaO+RelLnHMh7Z8Ux7vIe0yCVyo/zrkmZsuPfBhofMxksOIOnVKmua0I35Mdqxq5UqHquN+Uiu0KO082jcADA1s07AAI3VkE0WEid0bNdqcmQpgk0d8jiQNN++VooeuKwtFIBjwClVKz4U87iNDPCMjAqwYpvK2togSMn+lDO25fgbG9Iwc2vFs2rhtMG3rE1BSCNzoSUkvKoPtzPrD6ebLxY3vWp1m151KT+2b5oym99wgilZjd5rROF3Jfnanpzc9lx5Zuz89smlMYEkex8AsBlBLr7gqnZQqy1XXzxKAVsBjlWT83vBmtWGnOeUxd/FcRXBj2bFiXMyaPk0GSWfIdSLxSXIaeguvpjKl7j90yGBtUAArHBKisshb3CNj40Mf+GDqlxyog9RVz17pYM9bvDT92/e+N12y4iJfJ4qYKRsOYvzOr7NAK1ODzscAGiTro3YH6MM2gcrDR4+mjZu3pI/8zYfT/QrmDE31CdDrMZ/BfEneA5gvsRgxwTIuokx8zvNIgjKMFDzmxVvO78wnKFAhlThX8qd/+KHfUxDjrLMqNJnKwrhfu/ZxjY/BdP0Ntzoz6v1f+VIEhn4bw8TlY9dGlJQbrrss3XrL1SpP5E2AwkL/2ePtflIdkauVt5q+O6l+KvrnttN1QJPmTwJ8odycFMXFWURNYREQhn8uuhXzQr3+xpPN+fTpiJ5HkroNnNAOn+J/4Nojp9moXZugCupZdowGClNntGNyOD325FrtCmsXj8RTztQpxS5aWW3XoN2/RfN60g3XXplmzurRo6e4BB1DgC3laJaxd0h0qHYFStB27Cwzt8k7v/7kyaHf+t0P/eknvvPomTrie20BjUXoKsgfKo22p5WteqO2MpUZ9XttzAtw/P8EwPw1a5oI/gyXp4EIo05Z0sNrGKgqg8TgzTpuL+BtjNHKrJ19vUbuAXg8Cfsdh5odoEkPqbpxLdwGeiygADYAoA4qgVK46mITkAsBdATO4ZeDdBwAGNt+wQkPxZDglpQXN+XiwQfPVQxusxccABuFmgggKvQO1y4bFE7Nnhcnc/8M+LlV4VkHf5vtRTKo9e7blvpQutAE3TFrjjJbDqoq0HAa0vQ5SxThP80gMxZxOJtZ29veD0AzIDr47NAmAHA+lHsAM+VhHpPCA3SZbU8/pMm8QXxOgX21Z78W4s6eufKW91gBgvYCnFJhKxZkSk90BP8jh0nGO5tJbm0bNjqjVsD8tHbtMtaI/iuGiVPVx3VLk9tr7L7IVBDaCQMjg3q3Gz1ib1PsMpxRtke22I8p2HCGlGygOxzeoyA/TIKOntTVrQyqWpRklQWdCk8l5aDr3I3ZA4+HDeNK9zfpwINP9YIWkTveHHhwIz3PFrPHKItawPwgKwTYtm1CX+cxEJ7woA/RP7HHEcZnxB4wlMruSjxDGA1sVRjcc4jepmWZKsWTxG6E4bjrYWxuudEAC758riggoF7jh2fi5NFtCtYTKBH4GxfYrTp5UJ8PSTbzknSl6CytfeLrdvSmzVJiOXRcnFod29yoLXG3NwHGTbEDYdKIbiNveLsClQmUHhUAOS2ujcgh6aD0zuulHz4ghZXp0h5HGadTgB1OeZ+46vWorXhCCINtTMB2WLQU9MPHRWMhqR1e+Xp5+tn9qEYWTmO0Q89Ax6xlandt+cv4OKrstSeV2XVA6jI7jzalg5JppH9q8faO7E/T6o/LmzpHHmZp9Vc1Sx+9SllDe1PNcG/as78vrd+tnap+UV10b5qv8tyqcbtFJbv9Z9aky6+7Lv3jf/3zNKNbgdajGmMjdemn3vS2vGkl0GbJPQ+DeHlOkzKMPJbTumRMa3cKOUApWBls4U0FOA6KcrVtxy6P0T7x0+tQp1GjNMoA6ZSm9x//wR8rudNEDBgKLl3dPeld73xXuu0GMjLGDb8XYF745Tbi9D4hTz3ecfoTDzaqVWulNf6xD38kPfHoI2nXdmUeHj7pe0Q2ypjPve3GyLMBEzQNT4kYEYxfqxeVvdQJg4G2IE6G8WhgzjvzzOFmQx3rECXpiiuvSh/8nfd592DyK+bseJ4oy7NPP54WLhHHv74pvfyuV6SnnnjUc92385gDyK+6eFm6/LKVArDSFxfIJZU9850z8hpsN5rGQy3r8Yh754xmoq4C6Z53ocTVCWyjf18Us8RNQK6UNsBI13mnlHAIfjq7JMQahESmqE0A47ybyQl424PCAj1QxyEviaNAz8GQwDjtNaJr+XnXdyi/7N6zX5Q0zecC2zO6FZTcM8PPNrKtozzvovvV5fv2y8FDmRrhtNuAqt5aXVv1fu1jfeT973//lNf2rJH2g/+hMUhA5zV6F+sSvfdHNIYVjDH1+mG1wI8/ML/p7jUNzc33spohKewnG++tQQ+gKybvSegrmCtlns6KHWVx4TrhvTYyimDAfGzG5p7wqgHXGXiYU42f1QtGKMKUbJycE1zs+MnqCYSCepBhlD23gWMnymlgZeCVFz5+y8R3U34z2gwuvSvtMlcgOhcwggv6TXjaDaVstPj6uqbFHqAoAK9Mi9CiLa/VmDz+OBttwADYNLHi0anWljsLp+Qq4oJch+yb1FEFqc6e5LJw2qOeuZ8BgJjQ2VXoF+DXgnxoh7nTrLF4mWvq0RWW7m1zh3SkyQbHfSg19Yv78NOkEu7v4FI8hkHlKFxFA1W50UUqyV0Zi7b97ixEOa6gyu5gRkr0R3j4o4EquxUYG6Wy7ls8wENS2enVFnatAs4OpYPbnlNiqZk2uAiCbVQdmmfM80+8XEjXsctwhtgE74aESobBdTYkKjsjbqe8X2NDIbzApYxjeawXYlMB+BWbzgZf1MFjHQied0sA4R4vYXX68yLHZoiegTzUEeNxZ+8MLrl3GTIAjyRZ8YzEj2wk2oiJ8WViDOMBI1b95KAz1HiOqs/lkW4SUADYzjqzJ52Wqsni5ZenW66bn/q3KdGPsqkeOC4+9pBUKpTUp1kecagiVRqfNQKX7JLUwpfX5QfF2VY3GGy3t9YqWHQ8zZ4l2kV/lcAlBkZOJ04yIMCygkFPKVkRhs+QkgcZ3KgPaqRwUks6cHa4AEjeFYvnEupa24zZafqCi0wx4NkcOLg7Hdu3yYYaWX4xDI72N6fdffKmizN/xZyBNK1ZmuYnGxTkNpJ27T+S+o72p2d3KumYMnOOsbNnb2E8O5Uhppt2zp6frv6JN6SLrrnWSh3TVJH7PvxhlXW7KCntafvxM+kNb12jtmVXSM8x1Aer/4Sxzwt96WWLF4s+AABtFlWg3VQVnpfTUo+C+9s3IEO8f0iqLJJMZFfs5DHVjeBHUdlkmP/Zf/5zJT2S3Kt3XzS25WFtFGAn6c7rf+JVlbFTONWA4fO9ws0RQ4axMTwyJEA+KBWRPuu1aw53QOATTz+d/vav/yY9rkRjcKc51pSrGK4GiuEN9zZOAG/Pk5HN2GM+e8yteALItZES60B4zAXMif+YxDPHaw7oBPjTH+3y1q95+9vST7/lTZU6lnpV7slz6t3QMOR3S4bw1a96ddosznnsWJz/RV/NmtOjXRdRGnWu6R0qM22HRxtZxwYnRoqyh4xmOBGcWVbnsMNJedlFIxEQ/3EM6xD8dKp78oTkLWWA2CGEgan+hJ+PTCaf27HB863fqcOo5V2D/sRaZZqg18Mw41sIiMXzraqRmKlf4B/lsV7Rt44pgBjwb817GQq15FPQfTvVjo26PoG0GEBtUiSarZ2Y0dOjezSu/8/Oznl/IUCO+sDU6wK2gJ4Jch/DI0cCkcGv9GXmkU/pvl/Adv5+L/VjD8yvvPLGNXU1DfcCHJm08PoG0CAyncBDtnYBVixaoL/gVRp/adJmkvJWIcA5pn+DkPAS8oU8FYF5mdbtzeBcdIbD6+0r5xUH7jBfZ++35e+yYycDPo5XWhJPoJF/MxaTfNm4TsBOHxO4yhcNpBZOzqzGwndYDvgxC4ALD5HLG2yD4GAbYPMjFqgCNX20vw/DIsAUwFOLYkbzWQvGNJLTBBhBr6DY3MBl9x9eHAF6bkUbRwQZEukP9SL2JwqeG9XiT/7002MnHWQWHcLij+wcW80EFsHTxmMc/eIr2LCJv6NCKq9WCnRbQr0kwDWJeXiZJGJjKe+eELCofh1HE5zdFRZXWtqGjMMdK0YPfeVER+EyD8BpnjUDQIuQOPkDvYfSieMH0hmBcTzWpwmGkvHS1NqZGrtmaEHSzqHlxbQQCihBWYlbRT8Ur1qM0Pgs2jR/50Ufeg5byRhZtGuAYNpSxIRoA7zkLkEAKI8sillQMo3h+M18X4PyGGW1nItxgnOM++pcxia7ECTqUm8EwPHY0PXlUayyHFpwujFuQs4xugRKjhd9o3M+hC4VzxSe2kFlvKyuVgyBQEiNAOKqjsOpqVO62p0r00uumq/gz0eUC+CogjDr0oAyhBLIyRirk3cdHi2gHM/eoLJrksny6LHqtGA2ZcHowlAj2FqgW9xzvP48MsgADktD/SRRm/KGNyJtCGARgJjRhrpKxCjY918idWlZ1a2pTUlS5iudveIFGCsj/QfS8T0bZbzK66xjwEy1CuhuEk2tWqB5WOB16MQRKcXsSXsPHk/rtw+lwydE0xiNvo2HM56H2NuJ0c3/bdJfX3X7q9Oiy19iTnibAkBbBMw72pvTQ5/6jGQAn0idHV1p3e6BtOZ/+WXp5UvmUB0HhcoqLH6WGV/aZZDHdalkPAHmHcrw2CRaUQGV9DwA9qjUbQ5rR2FE7YPnuv/wdo81MjaS7vyvP/wxxVAohkDjPnZg1D7a4brrla9J737bW2MXKx67CC7MYDl/VPlh6CyA3SdVlX55xxm7TnykefvRJ55K//DRj6a1jz+e9iqo04Cc8jHP0SeT6jQi44q6YeSVDJzxfd4tdexFlLUCzN3GYZhXqCyAxwLM+SmvOG9eAN452mn4oz/4kOksz/eyLjmebIKyRZXaJMrNT91zT9qjOnwnGku55kR/lGk+WjPAfnHMFBM8pgfHAKiMzHB4sSeMAAwWdoQCSHt3oUyKFav93NrEfMC/YTzl3iydmudUD8+8SHnnkDU1r5tlzJVT4moTc73NWzuxPMYPKUD1Q6f6j/+ZPtHe1NTrQraAxh0tvVJvkgQR5EkbP633Jo210psX8pZT1/o+WuDHHpgv7Zm3prG5/V48XDXaqq3H04U3xBJyBAOq1QgCIg01oAivrv5m25qFHNCAZGBE9BM8Z/XrCDjUuWz7DUv2rBp1DjyHeId1zLC2zP07yRd0UTLIOQhPCgdsebPQO5gOz4e8VFW6P89FDYuXFja8FFBtSvZmUJQTzxiUhSSf1xtTNDJ/m8k6kH/WaQdsxzZ2TJKxxQv2IsujgS618jWYHsnsGAF95iBkYGiPeAayvhfAHE9efo6L7nWwSELHPFoLhJlVX0DPpn0AxCg33HZAvOqIkog9W8GFps4AZxYUGwZ4vWkXyoEHiHpIGcDmA0GyBvsBSrFgrCWuwpC10kuJfo4WA4nbu5x4swT4oSR40Q5jgn9M9cj6595RoGU4J3vfisfRQY/0B6AzLzbhQ416oqAxipdRAb8EVrF16/IwrOjjhhYHc1Xl4Kxob3YstHgCw22lxHY47R5GVPzDWC0e9bD7uGeuPyWm6fUTo9HHUsbcj3jg4/dct7zAW5EHwMMt3P1w9yORzZiP5z6xhiIHisY3RpUQjq+F19gllhFCQh7sMVRQQPz0xSg8VNOD6FtQPv87MtoJlLjwsLa+B49slletxdJt4+IvXzlH2+ACn3UzV6RrVs9JZw4+no4cP26Fnj2Hte2tteVMnfi3CkJsaFKZBbg7put51jM1TnCmVJBGxEd3IBnPpMev+hiNfQjienZPKvikSdk0xVCwcoXrzPOnh7ytVfWRBz9kIaE/YKyTpr7JHvKW6XM9Vsck5zm461n1+WFzg2saWlN9izKJtipYVBSb5/buSU+tPZAe33hEHnEBePG3YzAG/I5dLkY1ZmLMPWFGKvBt+oy08rZXpnmXXxfeTYHFFgHFdqnFtMvbiPb5hm88nDat/0xaMHdOemD9gfSeX/lNebkFYsW7b1J58KyGcyJ45rVqi8XSlO5QZsvpSoCF4koZ20wBHHP82PG06+hJGxOoupw4skPdNKp7NyjbaW/62Mf/yTKv1KFk+WX+uvG2O9N73/VOAXhiyOKF17d47AswZUxAxyCwlIycUBwaNE/v3rc3Pfzo46KrfDitf+opA1vPYTbwJvBDuY7ro7ndsoEAc8/FwcEOkDgBzEvwJ8efz2NuZROVuxbtcmQSZbgQ+Em2Sry8rQpCfO2r70prfvZdFTWWCtDGoC0GCvfWc49Bwnz55FPr0pve+IZ0RJz90r6VxnmeX8KIjjHg2SwbD5PPn9xnPICN4pMvWDBXfT+U9u2VCk/eReCcaVJ6IaiUh3n/gcPp2BGU7yr7FQV2uzSGz/mZ9/38aTiZAloXw6By9LfUohgWkylNJTj27LGWjqmx/kgxIvfqImSTnHpd4BbQGF2gS16pt/YJ3Z3P6b1O/TBlAF3gtv5BL/djD8ynNzSsUcDLvQbBduCG37CkDLcBaf4lCy1ARN+iDiFoxJamt9ORphLQIM12nbiuVWT0ExA4owUc+gbLZx0e4bw9N8qikCPV2XJEFIJVBXoE2R5NFwFseY4jvTWBfSwSgF4AvXiUKCIAtPDwMAEKadX673CJnzYQ05vtacAtySb0DVJSNZKIq1H5AIZE3NsnSAChylsvIEtgG4s15/ICuJOQI7Z+0VEn+2neIWBBMygMwM898BDjaYmAUo4VwNZx3i3Aq4y14+3lAJPh/QsAaw+Xr82xAQ7Zrqe+cY/YiQBIVkd+d9eTc1jckA8Mbz6e8lioALGU11lYHeVI77E7EVQc2vGMPmdBp+wGn7SdI3Nzm3LrDOzdKPZIF+pG1IHiGRdzvspZvP+BE7huVrORh9JxAQRCamdBUYmGu9TRxoPKgkSdddsBSuwC0P8YHbpK7JdwS47JYMSLsk3HGA/cLXupOTZMoVgurTwC8NR9GOf1Og/DBAPMVbZJ5GEUfeOyxN9VCmwsHjY4pKe5p+udQYEPUxmRyNNV6kBLGYyw38yuyqi2rL39nalOPHhjVjDShbJd5j6nJ9hZoOgk3sKgU0TjkW1PpFbRfppEXxgXpenui+UZP6kt/enz0orl89KR7Y8JDJ5Ke6VJLlF7gXZRO7qknqGMlyPKBjoucGalCd2LHXk8scPyppP7B3oGhnKNBkZ7m9KDNwIW1UXDDalfGUMBDbuPtam9xtP89tNpVvNhgzLAciQ31LOi/uqSfn/b7CUquG6gZ6lvrwKih/qsMtHYVJ32Krvjli170jPrFci6e1CqKSqD6msefzz47Fn4GYpX+D+9k6Ax6eBe/dHY1ZVW3XpXWnTtTeb00seMU4LzkOwDlLfrZ6tUkravXZce/caHpfd+UfrcN55L7/6135HXuTMSevkZ5FwPbXtNcRwQxD17erOCXLt9/clJbnhWR2T9PLe3Nw1qDPf39yq2RPERMoBIGrNx41ZltPy6gJ/mGc01RX4Qo/MG6Xu/990/K94yVKN4LiKLcTxnyPkdPXbEyim1KlCXFFzOCCjf98UvpY+KqrJpwwYpvBy10T7ZKz7Z03zu71A98JjbG47kYQWYx7wTQBCPeewaFY959EA4BsJjrrk/y77iJW9CnUVjcXpnW1q5qCctWbIkvf4t75Cm/qKK57uUpYDNyXQWaD6oNn32C/8i7v0aZ/11j+cyPZ/3vEEGO8GW9ZKmpL+Zv45JtB8J1m/7cl/nUWXvTZ7bJp00YdqcfaVy3lmfVhB65aLfenu3bXlNtOXkA88F6bkNBnTm/y1A/kf6GzrF1OsCt4DGV5cuSYIgcSn9gq7yuPpDGSCmXj+KLfBjD8xn1jWs0YR9r7M3sjBm32bxegMASU7DiuVgHfWSObm88+xlnWlDoQxOzTsOL5e9MyzYAqNmOlslRIAFDzyeN0fKk7ACCT6AD5DU/lAtjnjw4EjHgmggw0TqxEKhnmIKDt5lpPdEko9A0uw9oS7GS5yDe1JLuTxb41AizA3gfiqDDIxYMHKAKTWRuxNwSN0pTXi94dXgoSWITYCDGFRoHTYGQv2D/0JRIBJ01NjbF6onZu+Y2xleKu8QZKkytL8Bi+H5AiBHABGebWgRtfKAO9CINsqR+AaIuDcBmWWnwkg1kjYhkcY+Bzog5tdbuy8MlSCdgGXDmx1eb7UFoBUajT3IpJYWcNBnoXtCO4SiyDjGAW2PB5M2Bw6XdrdNAaDOxkAGWjHCgtMfHmq3VqpHlx1uqvXKfTGDIvodY8Qtb2DuEsdnNnQCnIenPgwCXqHeWbavA6jZMMiD1h58Ds3GWOwmUOaotz39uU5RDzP0c9BceLANVNzUeVz72YidGpsBLquMQYP7MBg8Ek1NEjgC7APs8ddzD3Y9uB5DnnFBQqkMPp1VVh7zE4e2Sud7Zjq09QmlOp/jTKmnBw+mBdMEjHXOqtWr0oKl8wXcnxTfeEwyhiNpRlOfA0CHtFNk6qz1vkUVkWQhmWbBgvD2oevWSsFFTngZrzIs9Czp0VTgp3bR9Nmho2TTHErbJcHYP3A8zZmmpC7KKLpMTIUWZRI9jTSkbNem6XNS59xVUk+SN1xGefuIvOSSbjzUdzjt2SVv+Lr9acvePtFsULqQ9GTI/biNXV9PIbaAYqeH3SqAsg1SKGJBmWlsbk0X3XpnWnb9bZ5H/Hy7WxgtMp7lWSaVeac95s0KDKxP/aJI/OPH/iTdces16W8//Xj62X//Ael6S75OQXfwe8dQ7sA48zPiR8V/N6I6M6NFmU+77GiI2zDmcCSMpc27D0vvfTT1HTskqsxegXAlthF4feihx9OmTRts5I4KLDIXomiCgfWSl96Z3vLqO1NP98zU0RWyidCLDh2RVB4qTjKe4EvTDjv37Elf/er96dP/+AmlWd/mcejRVAz5DC65RgXMxh++boXKIicIGYZNIcnOkWi0iWNit6YA8+Bp+3vPFgEuAeZ18O4tkQjvuTnN7p6errtqtRRSrkwLF69MKy6+2s/5ZI/9WZ5rXzP6Ho/5KRkiPyvN8y989pMRX3ROnUo5S9vzk/kQ5RUytFr2NHvffUwu67eA+wyQzwuwXaZSy7hjeOSjBc76srL2FVrjxBWf79qVts5tWTnuLNBe6Q+kWv5sfGz0Q/rkyOT6T/1+YVpAY4OHGQ85HgReBHSSIEjR9FOvH+UW+J8CmCviWwmGAqR5As4kcnsWmZjsxYugTM9OAJjca0H3hFISM5VTsRu5x1RuQAsKwrnLfxmsEYAXvm3Ac/wO/xVkw/08oRq2FcZ4Bv3+ETQGgyCuQ9kNSLO70UAwAJ0n2gzUIutaXiwM7OI4v0wpoXB4BQPwBUBVQJGAfJUWf4KCAOzmMjt2Cu+0QIy53JzkE4OpjOdPyUhM/eAuLEDZULDEHmXG4wYFBSDPwlJpC5VNuw61So1OIg88yQ3SJR9Hrk2efqebZlnjPF0boMIiBciHAAOEHnYSIikToJlOIhMdq7QTsVVuDzvtFkG3luuznBsAKFNPhLJqx8Vfb5opUCEPFtxwFkDtaBDgZ2UVsL52MNz2sG3Uj2IdGRAAtEMHOYwbXihWYMQE5g51FYJVq7UDg9fY3nooLga1gHF5kgG1lNX4IGg1jkDInlX3MIYbYCpu7TaBp23JxmxwQQ3J0M0LeMSuRpQCgaXmpHtkxYhgfBXOtKFeXqB9LtcdH/JOBsdWY+Th36ZNkCzByPCQ0u6LdnxsbGLIUTbay4oO8hKqLdjh8POUgZ4NDhssupYTDtH0QVXaJ438VgXEDvftDsUaJc/pOrNPTSdFHnnUr75yRZq7aH56bu1aBUr2ptVzR1JX07AybirpiLZM6hScOSqPe62A5oiyZ+JBhZ4SSkyq/+n6dFT+udk9tWnXgVNp3/FG6Z0PpMUd1elgrxIRzWxLM9pFXakbUKIhqas0iT9fKz61rM6W9kWpfaEk61qnuT8O79+Rtjz+YNrw3O60a09f2nNkWAmNoC3E82ajxnNG+Tt26soD6361gRdzRoNc+5YUlYG65Npb00U33+lnI3IP8Ohlb7nnGBnOGqNIy3VKKrINKos85qNHjqT/+qfvS2947UvT//j7B9Kbf+l9afrMhWppIg2K1zjmMEB5GLBm4KVGXf7SZbPEWW/PXvMod3/fMSnCKPhT0p6HD+xOvVJjGpZqEs/m/V97IB3pPZiGBk74+TI1RP0NN/slN70i/dLPvVU0IPHqNbiDgjKetmzdnJplKPSKuvKpT346Pfi1r6WN69dL5zo0ycvuU0aLZwFYtyvzZh5LMbHFi8+5D/rdxWPOrqVn7Xzv2DWgHcrzGvre+RDf27sRWYGlSfQpeO7T1MZv/6lXpDtf/UrFhih3w6zFfr7LDsDkcp1VJka5LnrgwF5RrJrTrTK0dm3bXDE4Jpd98nn8fm4dK397XJ0HXBegz2Ci6zLd51xj4dz7fDd/xxqT15FYHifa/ZwLxFcxv1XqVz5hHGiLWPPxf1OA8Qf08f7v5v5Tx3xvLaBngclitd4X683vSB6uVR9u/t6uNHX0D6sFfvyBuags9dU19xbvpr0w/i9mizKRBD3A7g3zck218CvTCgLW+iTPewF5fE6oowSsMv/ZwCY8hKE3Hd4nn5dBK7MrC27+x/dxtvdn7EkAACAASURBVFHuEDvd+frhfQ1PGR/rJ14vT7x50dYXYQSE99RXQQrSXOnAAr4X9BnKQr0rXvfJ2+lxcDECClXF06wXxCgXNHYbFNyXhY1rUd+4E5DT3l17SHOL+RrQKXxINpA4H8qHgUKAT346HsC7BLG+ROLLAPC12gGoRu+ajJj6nIx0SBACluoxIJwmOkujWQ4N20H3QDVG9xoBoJOOW8DcQFlJW86QFAmjRACaNsR7eZr7QEfCEGFXQMfjcaQrRuUxJEOlpCJcdnuD3d8YIWEY4PU/g1ewud2qEhbGzFSaoPfgZaYj4l0MrHEFthXPebQjRpOtpDCOMDzcz/S+ysO4wJsLQKZwGCHOaMUowLhQHVU/94rpOTSqCi/VmHH008kaamMEtQddg6x6JIyRsXLyZL/LDGWnVnWl1xrkXibJSH2r1HeQS9M9G+TdDeqAPJY6NyKcY2+qWveGhm7aiusNJQsAi+HFuNZPVHjEtyaDpsjM6fjOJ1JD+4w0e1p7eslcpeZWMp4hPZTzFy1Ks5dclJ568JuiWBxKy7qhCmHwkmwlMnqOj8iT3CrOuKgvkZGwKh3sq057jtekaxfWpoc3D6W5ShQkgZbU2SAKRf2J1N1FwqfqNCDZxfZ6yi1wqetNb61T9sHG1Dh7ZRqXlvjAiVNp5/Yd6aGvfCOtf26v5A9VLnHY3aTuj/CK83TAwfczaUMqZOo8f+SOpu8wgADFjL0GgcDLXnZXmn3FDeKmN8Uc4mMxvmKvJAxtJie1v56RFnGJ29UPeHRRxBhXHoH/+Lu/mn72Tbemj3zywXTLG9+Vlq64ykaKr5ARnb3l0Kl8zZgnOpvOpJVLehQQKiDNWJOBgCzg3r07HSTb2j5dtJxnFACqHQIB8RMK/HzwgYekusHf/TbyQ0ZPz6SM7FvvfG36X9/5Fnudy4s58J8/o2yc//yp9OiDD/n6IYXY7x0RvyaBzuJx9seTPMyT/54MYHk+8PB7R07jkR0FPM4dygaK3OrWzc9JBaTV/UXG1CHFBmHwT1OwLJJ9jFeyLjeIvrhSdJWrrrg4zZDazWWXrU7zlq/UPKPvpAbFtfH+Px8FhfJh1JJUZ7D/uChTbemL33gkvXvN2yqJf8pQKF7/SiN9m1/KHBEP0vO88jicoO5MGDOVditjcVK7ngvgK1QcD9q8TnoZig9ixctrUjaWKnWKJ6F0Z6xboRf8NwLk79Ofu76b+k4d8723gNp5ic7CS140PDfo96fVb1PKNt97c/7QzgCYv0V3P6yO+9IPrRQX5sbGfnrbCaQ3vIjazrq6NY3V1fcCZ6AswzmWye7DvGDC62UiN9gMgFmArKkpOtKCY3go8fAB9rwVDeILIFSyhJrjbJyVt+4B1/GRJyqD/4rbE89NLIxec3BG5/NpDoNrfw7wxQOqawYGDgCWJz6ubSDpOhSvaPmesgEWMqA3JzxecQTGhcCZ6RsBmg38M5iIX8IjHkZAeGL5wNgrkJYzZ1qFpfyt8owBUt2QAPTs/S8rC3O0u4cPQo4vbI+sPFImf67rZo6b4qXHS+zyG1CUikQDwlX1CZZnFIj3dVHsCFAcCjzuoAC2Og2fMn1D/5t7j3eRaxNgl733BGvWKO25+86tEXxp6AwYCq42jBvgN9v5OmYUY8BSdZwchhmVDMqSIZG6FqoAnO4IEAulszx8OZ/x5y15jBMBff1ubyejQ/WSqryvSWZDd5WuMSYDwlveAt5VJIZCNkZltZyd21BgXfEIaFUTgzACkIZREV3loGdTsxhzAtV12kFBacdGBLKGjBnRbqbNWZiOHNxl3euu6T0Cw4AfUU/Y0yBOwjr2DB8yekpRRbsrfi4E/kfEu3fSLQ9eAXfxxcdF4WhoF+hRgpiDz96fenv7lZypKl11kTzUMryOnqxOs5atFJXlorRlw9OpR17t1iYFeYqGckoAmTZtQDlF4LqlVbrxA9VSE2lK+ySNeIqsYtodmaaKLZwhffRmAXLRU1pqpb1P9lWB8ZHx5jRY1eYdmD5JJRIwine8Rioqx/vH0q59A+nxR55I26WZHQ+E+kZ1sl68jArGBrEMQfXJo8S7FNgombJi4zzPEfqc1On1orgtu/bmdNFtdxnQ0le0HeMoDPqY0vwc054eN1BxFKwqj3mHgHkrHnMB83rtKvzmr/xi+uX33JU+e58SWl1+S7rx5lcKdLK7E9rUXIHfGVP2weui9YormD9Dhog41E3qT2Jr2EEbkELK3v37bIRLZT7t379fSbFOyiioSo+qLbbu2i3O+cHI/GvqEka2jCSB+ze88e3pLa97hefX8uIZ+IPf+WD667//SDqsRDQkvOGZ9qNhw2Gi7cKBMul1XmBeYjBy8CwecrzulmTN11KbEbC5WhlRf+6tr1Mg6wkFXx5Nt990U7r8huuU7Odf0oYNz6U5Snpz16vukUzm8fQvn/timj97Xnr5a16jXApBWWqWrGk9Rilt4Yy6JVZgoozeFdD9+vsH0pZn1qVFixemFiVB65MR8wvv+cX0lc9/NgyQXBfX75x6Ta7yhf79fBzv571HWd9i8veI5lfH95SOKcfkceTq5GPL+qQ2kV+k+uOit/2mvtp0oes0db1oATXzDP2AR64J0y+MnyfV5wNTbfTiawGA+RtV7H514BdefMU/q8SBf88B5u3V1WvqRWWxd9vgNyYPJzgxHSW29CfNMZVFIpgbGezphwGkwSBe1MCABCSyhNRlbrV5vKy95t4G2GfytQye5f4mTWxepAuHz09XphR4Bfbfhpzmj2dglb2khSdM+QCC0CksTWbNWoi8cQ3rUuMBy/5sjAe89uHxN7yIRjQyC9BPkGB416OusS8QLwPoYkTwgauXp+O8wIZ0XjZ+AHgZaBukhwUSjaf/82azdweiHGGw+NY2etCfxwvMd3mHYtIiYdWQXM5gFEWfYsRkUo5LApD1ToNBTgwCAA4KMLRtUApC0SVKQpAgXH2KSpmiU2M7PAyJKHPshFCf4BFLV1het54lC9KezewckhUv+sL0HzC1rxAUJVeZsYNyA6Ast7XDbaGBgKuRusOAzLynkrXRI4LgOEsNxlgMCy/AuLfsXWzqFmPNWTkpeaHK0NUo20TTu99sTOJ5d/cWw4kxwCDRuTaYiH9Q+2jHAgWLiO+jUbLco0dW3NMB1hwPdceexqAaOZspza86tCm9ec+yS1ONQN7Q/g1ps5KSzBCF4LJLlio5yXgalDrK7OVL0+IVl6bNG55NjaPH0pJp46KiDCtIs1XSiMcMVk9XDdnrvVWb5MfH2lN3pzji4pM3osCjMjTXa1dAFWuUwTGni12SrjRHBta6/sG0R4l09ghsDoz3pNqelYobCc3oLRvWp22bnnXQKOPIPG3Gl+umMa2yMT5J8MLQKlr5E7tkZTcrhj1PR736dsV1N6ZL7nhValbWzWgnGjw/lZk6VnbBAP2x2xVjBy87AZjtraKytAo4ysvbqv5437/9xfQzb7om7dp5OO061Zze+NM/L7WTIWXP7XIGR3Z9imSegbniLFrrlMlSyjHTFWhKUp1qect5DShI8ZCCWOkzMkCeUgAonvLe40fT3l170xNPPK6+OZEDE6EQxa7LjNkL06/+yr9X5s8lEx7WPEd89L//dfrND/6OgTkvz57MczZaYghN+jExF8fHZ70qmJZdGLWXbVBGLPELOnKa+PerVyxWoqMrUq0Mx3EZXdO1y9CtTKdH+k+loeMn0uL589OSlavTjn3b02OPPSkZxDnpjjtf6aDhZoFqshtDbSv9AiCfeGUngQqCukzfsV6p2EhcRAGoC5ctdxzMsHbAHl/7dPqFn/t5GbKSTc11/Xbe9smVPB9t59x2OOuYyQsZ/cuYyTOO27XM1WVOPk+7lo++073j2vnlNbQ4WGKHR/f9rDKC/rp+RY5v6vUCtID6s0WXJWPngnx5ZHZIEDTF238B2vtf65IA89frZqfUkZ/917rpC3Qf5mLjC70rHvMA5vKY46nMeDAmkwCAgPIAlwHAQAoBvuPvoI3od7xBgef8ikMmQCSLMdeKoE4t1EzgRmFxpJVMMuQLsD/ZIxT3oQzh9Q7symGcQ2XsfcxgGWBVjnO58D76/CjPsAIsURxAbcVFyNeNOmWg7WrnZDLcz1J5AZZDvSQbLPqueEkIggXQ2SDB48ZkHHv4AUopp4FtaUA3p8EglZE0tL8JGkwotrhuudO8rLrOsUgX7j9/ZVshgGZuj4klB8AMj5vrwmX1Ep97ORYnsLG38Kkz9TMoD3WSWLiC1x/jItoizIsAyx4nBrQYC1EGXk6qE9sgsfxZozt2N8I2guMedeKoEmhZrTJ6aHCe2zK8o64nVzKCg1JA/+arc9/KGCwc7QhtNXDjGqWF7f2PR4IxUuPtkDBOY7ch7mHDDMUajzOOcW0rdY3eoey5DTzGeQUFCppNqLoE7cc2ZDYw/FwxVixLpN/N8we5BsBHphBj6DT0GVWyY+ZM6XTP1c6UEvHs35nmClXfdllHuuv6nrR281h64kR3Win97rVPPZaO7z2SfuKymvSlDQNpduNYmjVTtAWN+REh5DGBof1796UH1x70rkl7R3NaMq8zvea6bnnTpytjbEOaIYtrq5JXPbtlb3py/fG0eZ/SlOu7FVddk1qkS86ztmfntrRh7VOW4PMuFWPcFBDqaRNPdVdac6G4E9IhdxNTPX2fbTEPYswetwBzia6x9Kqr09WveE1qnSYnV4nd8NV4DoOq5HkGg9pB0nGuuyc/AABztKrb5DHv1Bst8y4B0T/97d9Oi5ZVp6XzFqRPf21Detd7/zdRRQacJZfMkyOoN6lM46MnFSgr77faoUFe+862FoFSJbVBO1w1xNDolVTiMSX44XlAzWbX7v3p4QceSPv27A65VJWpETlBee455riyfg5LZeWen3xTevuat5urXXlOMiD82pe+mt79nncreDckA23sMDbOAebhA/fQi7GWx2E8eTGL0BbI3s6a0ZW65O1fv2W3HQrTGmvT215/h4yuxrRpx7500UUL013KuDl2ZjB98TNfTD3iuL/09ldIN/5MevTLn9NOg7LKrlqQXvryN+h+Y6l99iq1l7j2NoYj/iF2vPJclXcBeGbgmR/Yt0fa9f1p9sLF3rkBkPP5sAD6KVHC/kpa73/yex+0gVPq+oMC87MoPBlk+5oFcE8C4D8IMK90QcUKim6ZoLT4r9xRYTSqlb5x+nTVr2pr7uE4eup1oVtAfc3Seaneq/yACMPp/ZT6ZduFvtfU9f71WwBg/jpmOXXop//1b39B71hm7G8B5sp4d2/47wylA0TaYx5AED6gPcOsfV5ZA+RmJ3JeC+KzAJ/h2c5O8YJdAlRm8ETNvEAHXPPE5YU3pjUDFC/BKoc91HxvsBxHewlmYc4A3hAq1mafb684ZTbai/k4L2UGSNB1HBwYl/ItDeZd9lDpKMf7fhlsuvouT8CvuG60HODRZwG2DNbipPBsR9kjK1xWZuF8jAm3QyxWToPNfzq+4lE1FOAC7oDKEszvlak+r/A2NFzfbIiUdsuGQdQlKufedlNTZ2ob3lz3u34BFMSixfdFoSHqaN+zQXjxbJdYg2gCN7vpJvpDB7vJzI3RJzi6Xe9oKzvZDLr5O7zVeSBFO7tSkXwlFIGiku5bXc96+LmPYueEGAb2SAp4UTlLm1R61bdUfQHO2Zsla8H9yLVMlQiDIMy/icXWQyYartIf0X5YGLHHwl+WQPRzU8Z4HjaTLBcHS+cyjcmlCW2HmIACYCNJkcaM+P2zl66QRKIyROu6xw7sE+BN6aLpfem6i8bT2kPL01DnirRixcq0Y9vutHvn1tQpSkXPdFFXlPVztKpJWQur0hVKSV91ZkRKLX1K5tSc9vWOp+bq4fT1b25M733linTrXS9PX/vnv0pfXDeU1u85lfqHBKxFU1ip9Ords+e4TY/Jm/vMY4+mASW68ROfgTH1hH7iLlfn1OnvViX4oYZknOxXkCTS5G6fvDNWnjeOmX/pZenaV78udXTPrhjilii0YQOlzh0Tz2J+dvNT5vvFsxFjgUBLpFxblSSIAFC8520KAF0vdZPP3/eXCgC9PX31m8+lu17/M6lDdIyhkwNxrilTSAJqvBOz4YDrGp0vz3t7m0C6QLbuhezq9h07lS21T+BySIl99qTt27aJPtMg/v4pp6HHwz5dWRoHpfjymJIAdYiz/1OvfXW65Jpb0szunpgvC1D0mDqTntv4XLrnntemPepf7zacA/hi7OUJa2LQe8yHSR/zDOVoEYUHXe52ecFbZVwAiK9Ztcz67HXSGu+WdOVMGXvsfj355IY0rasprbz4KgUIn0xPPvJo6uloTasU8PqSO9+cDm38SupZeklq6FyQqlpUdpcj35GfFXoMdDBlk1XQMJlQx0TDQuqxXnKK7K7Am+enczPoocTA+Y3/8Nvpn/7+Yx77E/Ur9Zx47r5bsO42yPNfBSDntq64e8rk7jtOHB9Tdp5M83fn/pjsZf9uPOzlVurtR/To/ge19788z6WnPr4ALaA+IVsnWTvhkWPzwyNfr36b4HBdgPtMXeKH1wIA859gnlen/tMPrxgX5M7GFnqfBczntLevEdC81/v9gTOyZzlAW0jykUAFD2IBa7GtH3AjAFmszgEGA1RVoKtxYIEfFY+lDomFtrzK1eI64RebOI+jAuzyionTy3AGhmXbsBgFlaMyeOTvAiSNJTKoLZcrXrjQUWaBxttnBnQGpyw4UbdYUENJoWBxAEvWdcnFKzXOBktegCfXaaJNog34OwB4bk7vQoSxFJojxSgIMAQW8VqWAWKFVoQXObeR2x5PsBeq0IgPTzT/QJngIvBqffVs/OgjNMbhipvzAs8VWkYEW7oZXJ/owLhc9jt5AOX7Gz9Hm5Vg1/CzozEfOzQV7789zDGSgsIiBQndFz439woaDh9H+dHdN+DFyLHlheEWKubG//y0gRlaQgbrBvP8xDOdE/kYNAOEo2dK/0QSm/JARH3M8dc1neLcntu8oAc8dXt4d0D1cNZAPICMT77xudyTexN0Gx55ePSZv2Nw4+bKFmZcM4y0uub6NF80lTol5aGVBg/v1/lDaXX3EfGnlc58/DJphy9UMOOqtGPHXqmi7EmSLk8duuUxBYaSqGm+gjpfNutwaq4aTHvlDT2oxDiHjw+m3v0D6V+ePJSa1N6vu7Ijve2X3pke+caX05/81abUueTiNG/ZMo93ghrXP/lUOqDU6cXstrI8fUO2RDzeaILzt463mokMCo9rVaJfwaFDQ5FVkuYuz/+CVavTS5QJc8aChVFje8JpRwxr6k+/Zo95fg78nf5zgjGu5f5lDMTzY8UZ8coJ/CSNeZsAerP+7tHP9779jem9v/zG9PiTm1P1zAXpblEzoLpwHvkHItNuzEcE/ZKsCE2fQYH3YwpWPHTgkN4HpAk+JM71KSf8IbD6mHTF27s6UodoRzMlg0h/7j94KD35jQfTkrkz0k+96a1prtqzTlSuc18F4O3dvTe9Ttztzdu3hmE8GZjn+dI/4iHOr/iCcdai+s3qnqGAymYjkhapO91+07WSMJyfPv6Pn03XXX5Zevkr706HpSbz8Be/nLrUNlfedEM6Md6YduzalGqly75U0ocz5sxU2nslqzp5NM1cdZuTQWGeFg54MYC82+aEcVIp0s/BEwPplAy2nrnzTT3DC96g+hIjgod8VG+eE8Yjga/06+vf9Jb0zQek9/49APPvhkbiZiqA/FwjqDJ3hSFXpsSyfH1LB+UPJjzhk4zt8xzsa3qKtEG5TjTN96mhPvV81536/AdvAfW1MkOla/WW98Kv7XrjJZ9KyPSDN++P1BUA5q9SiZrUuR//kSrZ916YgjnOAuZXXnb1Gik23GvXRQZRABd7qj2F8jkwRdMywZ1It7HVC7hBoUXBdAToobtMIB3b8UzQpqrY0w4ACVAdHkpdNKenNvgGZNkbNuEdqkyOGfiWvyOwLsBTod2EFnZcmMW/4qX3xFhuONFYZcLkHDtcPWHH9/xNqhuDIa7HdfOXfBqTPGBtgsThxVyfh5c0zol7TAD5ArCKt6YYHQHsgwoSXnNCK1lzA3TEmjxhyhT5tti9CMAb1BioQdwzdjswQAxKXRb7tl2/gPj8RFKxePwD9k9kB+UA6DhA8KBsRB8GuDclKC7mfshYwZQF+Cluct8705MIjjUpO3ybTiyU29LN6zaPNnCCKNrNtkCcY7UgwDS7Dh6fcNJj9yTc/RwQdQIUu12KQUPVkaxEn9ru9QIGOT/aotg1Dg7mAPoT0Bw2QubWk8UzjANv3+fxHbcOIB4NEW0+qu3+MGBynIJ3DvLiT92yuefzcxBjPAsT/WSQYrpX1LFBHsf5q69ScqtGx0sMD/alscFD6ZKZfVbSGWi7NnX0LE4rVl4kgLUrHT54RFSOWvGA29LMltq0qPloaji1PQ0c2Za27exPm3cMpY27RtMJqaZgHMBBxtndJrWVN17Wlt78hx9Mf/c/7k+7lVSIFO+bldBmy7PPemyUurpPAdFQxdi1wMOMYlDmXznNPXkKdO1myTICZA8dHvY459W9cGm64Z6fTD2LlmQAHoDcb7cZdafB4gmhBcv4Kc+lZdArhic0rUDqAczDY94h8EkAKMCcAM7P/cV/S/OXVKcTx0+mz319XXrzO39eXPR2xQLUGWQPiZqD3jcc8t5DB9Mp8foHBMh7Dx81379Z3vM6SSG1Kxi3Xfz3bnm/iZuAR33wwP50ov+YA3PPiKYxTwB90fKLREOak2bMXeScCWfzsGOc+ZHSeDl86HB6w0/+VHpq/TrLnXqU+v8K0S8fG7MKcwIZSzvbWyTl2CLVGLzj9WmegPXcubPSrNmzU78ChZcvXmQvPYmhnnlcga+zZqc5Sxb72evrO2p61Hwdf5GoUIw71FoaWjrV9JKEZfdJ7+iD2LGIdQDVH/Hqxakfky4+3zUT5Cx9fShBUH3qLXNZpBPZUSEZHXEXZHIOOuDL73pVWvvEo+cF5pN3FCZa6vy/TTZizkdl+bbnYyxSwzyhnetxn3zu5J2Oc3c9Ksf5euk5OSB+W4GdH6N7v1P5p77//lpAfSC9WPPIlVXBL/jj8Mjhk0+9fgxbAGB+l+rVqU7+uxd5/Qo2OAuY33jTXWu0qNzLpEQQYeFLO/mNgYIWXdMOYmYh3ZDxUN4Usgigveos2ALqAuenla3QKcWZ0MmYaRKxV1BP7pYZ9O8Tc1VI2YG14jvrZgMQAfs0PJ8ZFKpMLAr21AVAY8konv1ybe4XHjRuH9kaAYxBzwgPbi0pxbmfsY/AIcaI/iieKmeHBDzpGPtPQQEZTAYyDMAV/GgCTPGYZmAAuOAzVDwM0orXOAB7eFOCvuHy6Hh2JYoWi9udawPuMFxi2fCxodgctYj6lr5xQvQMVAKSOzgzF5pPzHCnXcyrjsXddcxgnruEoZE9lnzugNNQtpkwfQCyAUrDYxkAKYyhrE4DIDcpHKBFQWIUwS0P/joc/2yQlftD5XAdApSGVzUbGLkNi7e0GDYBXkrHGM+7XW2yuAiBFMNTm/sKtRfDnUJBItAyJDyhn1STICv3MTzsknTGWVIFhEMFJMqF0RLnFRAV7WEJRINX19qAn2MsDWgAiqc57wbYwyzPsJ8TKDuhuw6NhfNJqLPg0usNcvE+jgvkDh3bnZZ2SeGldXYam74ydcnDufqSS9LBgwfTto3r00jv4XTy8M506tC+dOTIcfO8TwKiubDbImwKyoVPmvE6d/7cdOU1VytxUEfacWQsbduyJW1QqvQhKZrEYAkDo7wxfKg2wB6ZvGqSd/nyASRrxLFu0PUXzmoSWB5O6zacSM0989I1r/qJtGD1JXGl3JYOzvaDEWPPlDFTVvJPP1rZBPazTR0iJiLbURUvPAZPAeZQWOCatwioN8iDX6sAzb/4z7+VfvJ1d6Yv3/9k2ntyPF16xTVpr6gph6V1DjhntwOFFaQ8u+QB7+6epnpIHrKjPfXMmSsvMFmNyXjZZErLlifXyRCqUjDuaks1Nkk+c+6SFVbnqXHwLwnRYr57XjCn7/oljfjWN75Z1KIHIvlTOcczULS/zUG1DTr20zs7VF402xWUqnnxpptekm65/ab08X/4ZJo/syfdctutqU9Bqft37kzjuvZl116TjomGs2vHbilvDqeXXnNN6laAZ9eM2VIhGhawbtcuAXKUoVTE7oEN9Zju/M+YEmQRV+C3OPPt7Z0C8W1+BsiwPKIA11EV/vDBfWm26E9cC0BOkjQMJtP1GH+6KNz8l91+V1qnuIjJwPqsnYIYed/V63zg/LsC9x538YpqqnxWlpn4vHx/FjDPz83kwmk47lT3fEA7CX+pz6foE99Vz33vB6kfiMKGR74yn41nHKWVHd/71abOeDG1AMD8VhUYS+wj6vAJJPliqsXEfJNXvYngz5tuvXuNZK7uDR5sgD/jHGpawJJBNK8AgUVHOn/oiSyAHM6WLAcaiNgSe7yCnhA6FnxV5LQicUscEzDHNzbwNzD3F4C3SI7jUgAAMw85KAgBiMLDnckRcZnw1Gcvn8GsV3COyWA9A3a0uAMwA/IBRHj9c0OwO+AgpzA+2O7OEDf+zmUuOwSun9ssjAe/+c8gFSCk39ltMF2G+hA8Fb5+e/yikhFAZpZGeNMpc9A/fFsbHKZmUDaD6YDNlX6ZIN27LCCxWF+jXvaKBycpgKx/LaSZKEZepmKHJHvZi183gKnRUlzX16RvJs4NT3z2QtNHTt9KHaCzxKJnY8Ftkz3Euo7VT/L9uJwJKzqEcDm3OMDWx014ugL4ArBplxjHUeY8tvU9WVzd/zbAcr/4eyQsIzDXQZ/ul/ACArABhEgaOtgNcA1A8f1iPNv7Z6OC2wEqo71978KR5moG6pQ51HIoIoDUVHOkHymbmyyAy5iuQwKqEYdCyQAAIABJREFUhuaWtODiG+TJlPwkBrAoAW0N1aIczErNM6Ypec5xeUYPpIVLlqeNa59MTzz8kCkGFalT3UjiKyF5mctbMYxVnk6Bz9VXXJlmKsCR/uwTXWPt44+JF67ENjE0K7ZP6V/CqwqljUcTrzEGTITKRqsrfkXgtjotnl2TVkna8ZuHp6eb73mH2oQ601p4xKP/J/9dwPnELkJ+zt0u0TYcEzttca/YyYuxN9lj3o7HXJ5zAkAbtYvQIe/51z/6MUlY9llD++uPb0xVSowzfUZ3OnLgoEEv47QRlZIZ00XpmJ3a1T79g4NpVGBdShoKDh2yMXJKiX9m93SnuQsXyp5qlDe4KU2fuyA1Cax6KNiAqDwQ/mwy2Dv3u2Hx1X/u7T+bPv3Fz3meCQdGNlbz3IzG+oqli2wcNEkRBerK/DndacnyJWmnAPdcecbnzJ8nXneTPPBHrHAzXwbXSbFI+o4dVVDraFq1aqV2Khal1k5RblSfBkk41uHNpz3V4WVOKkXHGGTgnNRODRljI5mYjB3tGvAcjQjsk7UYmhdYdlD66xg0SCk6+7MlKMsuXTz31A2u/m0vuyM9s+7J87bV9w3QY8g+7+u7AevfiS5TuXgG7yqrZGWqPyg51P9H38HZmXq9AC2gdqZrV+h9md6AcybqZ/TeqD4rNvoLcOepS/6otADAHM7Scr0/qU5/MWteMpi/BZhffeX1a1qaWu8dR01B30bgIwFXAdICwAXn24CKRcterNhGNZT3xARTFzDC8QE+CPiKZBwsnvpp3wFnsOCE5kghath7yIofF654gktQE2CFyZ2ClUQ2ziBpHTo48DoNXGc+dPYK5gWbv1m0gwISC4Lhrdd6gDhQj+tk5wbAJZfU+M6edA4NvzVeaFQyfB1AmIFmXMEg3YAxgz6oJhkQR/0CKIIy3Q727BqSB44k+Y+OdyZVjBHVF6636+Ry5IXeXqxI3Q5A9yJuBJXLpd8dF4ARgfHhe4bqR2YYRb3Y1cj3IjGOec763HKTNBbGg4ud0RndQzkB4EAGgzz7uOMelNMgCcBFmQKU+Pu8Q+Bz8+5EgOkYmZG4yZfInm3uzXgMwByX0jZ7Hm9xi9i1GM7tzB8B+FGWISYCkMyf7vjwUtvLqh7T53DYi0SiDwGi2+MPpWbyOXj58pzPUNJxp51dNB+T+9Wec9sXqrEuzilFNpD6+XubAVS5gNE4HkUTPg2Ayj3y86TfGwWcFl7yEnlfBczVECcH+tL4UH86fmh/OiXFi2EFGDYo4PCO170mHZTiyjfvvz+P9RjL4VPAC8iP/MyqPUipvvKyy6VUstTlGdC11j/5RDq6b380WS5niQUw2HEjqj81nCIQmodPPHZ5kGtkvABoSXHv3Qr90yNaxaW33pJquhamDc+uT7fccVcYI5ZQZecgdh8A9ZEXgHYKQ5+xAKCLIMhoH48PA9YMzN0fYQyHcU2fT3jMSTLUKo9ys9qnSd7lRpWTxDjrPv+pNGdBq8DsjrRh886060h/ul7lnKudhyFJKB5UkOvhw4dSswycBnXq3LmzJfO3RDzqIbVTX+rsmKmETitTU2eXs7xiNNlInQTEnw+Ul88LQKx4xjUuf+nd/yb9zSc+5t3HeHry3KXfGgTE586aIUnDznT5pSvTbXfcnL78tQdTd3tXuuPld6b9vcfMa685OZguuUSJDaW7/uyGzaleoPml112XmnqmS+1mpudwko+ho48EJHNbUViJsRdzsY1AJDrFPT+hHZg2UVVaurpj91Fzy6iuC7+cgwmURRqURGcYdNOnd58Fxs81SLjfkAzMW25+Wdq4Yd0FBeaVwe/2O/t1XlCen+PzHH7WR5X+yj0TnvV0VH/+oebSP9XBqH9MvV6gFtBzMkeXvlrv9ph40ja98ZLnLb0X6MZTl/2RagGAOVslWGb3qfNDXPbF+YpVLXDVWXKJdbV1orLoSwMD+SkB5gBt/c1ka7CubwylQTl6szVLivUAaJyjCYrPzQkNj5OzQmrB4m9UDjxZ+toZAOmXANsZmHBXQDlbnf6Yv/GM+gAv5M7uaLkyAFpch+9MW/BiHYAsVhU6SpxffhgIxzEGvAaNXB/qjQ8IFFCuWQECGdT4krFM+ph8TuwwGJ1av9q66PboBoB2lXNxSr1N68ABZZSTdw8MHqF85OPLjSoQPz7nHOowoXioewC8lQSF+oSnMY4FcNpYyJQcNwh1tlcWsM+XgJnsj8fbBaBXAhy28oMCFHJo+WD3NaCJbKMOvDQ4jmQ5RWmleOSRVsM4QKd8XL+7mTAo2CIG+PK7x4/KyVY/wIw72FCiPdQ3SAlybcYCFKaSYdReveLzRfqStuM6AGiMQVB3gFwHmtprHT2A2oYd9P4OQzM6IoYLxgnb93lMuP5h9AR4wdOfx6YagSys8HABoF7b+YfAVJ2DB/FE/4kYLB4ixbseY8jj2/cNQ9QSgx4wJYah7HAIX0micNHql1gzmrE/cORQ2vzkN4GpueTxHL7mLW9Ox3t70/1fuE/XiZ2BMKRi7PpfjCfda9nKVWnFxRdbXxtwtemZZ9IutOUzuK2MX3rIlQt4XuJVKwOSMSkuseYRg+tOaYcf6+uzrOLqW16Wllxxlcf1ib7B9OzGp9Mtd96dPagWVsyGeOxK+ECGpVsm2tRSl7ns8QgG+MXoCqM76lUxoD0HZI65vOV4zNvMMZd0obzMjWpDpAo79fmRLeuVhKghHdy9WZzyE+n4iUEZOaMKimxLA1rq27UbsXjpcsfPMCZrahpSpzzSLV3TPVYqgHoSGHcFznkVoFuMkOcD5pz2Jx/4UPrd//gHooNwR8k1iu/dJgnDHmV6vWTVRalzekdavGhhOnrkcJo5o0cJrESzkeF2RDrh06Sgs2LlynT4aK+Ni1YZIUsUvNvS1Zk6Zsw0J7xWgJxYANrRVBVMwEzbKB7+MPqlj68kSuNk8lVsQ5MyhALkMRjg4Q8oGBhjp1Fv+p5nuNBU+hRc2kUbcZf8fJUmKffgnqcEzK+TXv32LZuety3zrOsx8O1eblPPJ9/5db5di9gBnPTK14vBl0dg5eIA8vF+TTT/1/jYyB/riBez0+47N9gP+Qj1LQGd1+g9KxcFPdFH1WfHf8hFm7r9D6EFAOZLdd/r9f66BsGuH0IZLtQtY6U7B5i3prRGIEZyiV7uYiHH+0VWQwEYliPzBgnqDBjMLGWva3GWeTIsIClPXCXldk3OWmQQkifNgnENla1QEZN3QAuVAR4iXjL+1nf8DvgJrxpp57WoIGdmIyGyPdpzThCqpe9Cj7uSMMdyetp6zUDMBgjnFvWS4tFWzRw86Xtm2UL9wWcYARWHt0W/A7Cbdp7n7ADpuEsBwIDFTGegwnyVwX7xkQd9KIMxHWOPoQFmeA1pZ19TVaM0YXyEBxgwEmwNXzikCfWTNPDwx+Pz2OkA6jigEdBJP9kIiDbHC5/hWrYvdAyAAKk/oH0BPnjRWay5j8uMxznKzpHcF6998fxzrIEscMb3CJAfa13w5rlvTa3UMNyPefELa6FiOJx2jEKmJDlAeURc2FF58PpN/aBhuVedeLHVAgc23ARkaqrF63U301GMFQzMaDt2cExq8WIb7eSRx5ZOBWwFWLFbGAOF2Alxa9n2hxdeo6RDgJBxlFZy8Xkyggmsc9WGZ+Rp3LH+KZUXEyl2kbzyo/phykd5JNVufpjiGfEuQ7j5DVQJomxqbUvzVl6Z6gWCaNf+3iPpuUcfiLlBh8Y+RUp3K5iSct/3T5/I80aM58mAY+78BeniK6+UM1WZNNWm25SK/Tmlkx9Tu/pyFSQUdfEj7SRM/hFGRbkmv+sjDAbStzNv9MycnrovFU/96pdY+tGnqMx9vSfShk1Pp5e9/JUZxNF/YTDZ4LQDwHfzTWyMZWOGT8q8YduaZrQtfQ4w5zh9ZiqLdgNaWhpMXTkfMMdZ0Cx6C8GSUNkOSW/7pGT+GkXRmNkjyUad7+fR4yacE2EMMrZLKXNxKfEkAJr3j87yAvtZzHSOmDSi7dy8GRhTs09/9BPpnb/4C/5y1vSu1C1AfuMNV6c7X3l7+uKXvpaqZDjcIVnLE+q7Ldt3pDoZVTddd0MalqH46ENPpEY15u233ZZmLlmYakUvqtVzQbbSWnnGg6aC8owSSeWxXuhCFMla4uqHvuPH0qiAd5eMEM5D3pCg/mHNsbv3702bNm5Mt1x7XZqh720UT9r5oD4npWDTIuPmfK/JwLxfnviLZUiQfOhcVZZybp4+J7BxabTJiP0sRF0ZQpV5LozMSbsZMbQndWK5aPkopFNjsDPg8veebs/IK171nwTIf18H9J63klMfXpAWUFvrIbT0IRKIdII8HekJ9eWeC3KDqYu8KFsAYM7Wycv0fkyD4cWcMreggHA5E5umNwmGBGzvRb6KSPw6LbDobHsRFiDHk3ZSk7UDzngyMiIMyBhAsWwfx4IFSIxJz4GImtTkR6tMcHE6YCFAIwu9aSYZYDJKKGgkrImXr8kFzckOABKUEWNS3yzWOVBXbP/aqwkQ5VtTC+K6XlzzXBuANS+O2fsW2Uvjwg4aZMGkHlyan4BJUzdy2YLLUfF0B90i2iayN0YyFQe3Ui6uAz0D0OpJ3tDEwMwGiA6wUaBz66mrdhxIhqSVVYF09VIHCQCEdCGLbbX4uy6NAaLSfXMugBX5OloEL5a+Z/eDe7PrYXOAUyi3+8/7Bb4ONB179PU9x0a76/ZQZaBukD0yfx4KOXiduRZyedG+oS9PP+f089loC5oH35E4J9q+WoA6UDn60VgcuY+s8oN3WlTNqsYYYy4lHFZJKQ4eS1VNXfpdQFmJYFKdEp7QnqS4577ur9DIcT/ThJgaeKNdPV3PYxRAzi9qR/PHKXdQIridmVJok7vDoQwJnOd2M5j3gMrGWPSwriwQj4f19HDa9Mj9sfvgEUGFMXxGo28onwFDjOUYxBkQcA+DHX0vwNUkT+jCFcrQKGBOLtv+/oNp00P3B27AEMvA4da7704dUgr51N9+xNebCGA7kzqnTUuXKthv2nQl7tF5ByV7uPGJJ1OfvKJBS4tngXdRF6JGmdHj/qV9wmQNoAOKJwNrjcZkszKMXnLzbUoQdI0DQctDEnEG0j8/2pc2bnwm3anAT8Yu4zwcAfGs+Hp5d4yyO9B2EqAKOlm8PWb9e44zsCFIV8RcAZ2iQcAabnm7Mn+2iW+NlGCjPPsNMh7seCBQlURjOpa/UTcxyIxurIDvsi8TbVOefHe2X7Sbd5UYl+prUzvY0dOz62eVZ9DOBUZibuCYDuLPyYBRf29a+0x6z7veIU83SirT0nJl59ytTKKov3QrBqBaQJlx3KQO6ZzRkXp7B9KgdijapNxz8aWXW4ln2szZLg+g3H3hMmJcYugGtW9E3urGxmbfn3iaIfHnR1R2hiO0qHqpz0BVoU57DuyVDOdWZX7dIf64VF6WX5JeddcrYxez9N2k+iAjiSe9GCuTKT0FmOORf1q67XfcepN2KYYqHnO36aT5v9LOYdVHe+X5v9JX5d6lQyYa18eWuT/G2IRhVRmjsYBkAP6tfUwvq0xSNaj+f0+fHv6AjowMUFOvF6QF1NY8LAR1EiHOAIazT4bUTerDSU/PC3L7qYv+iLcAwLxLZUQycYMGxJM/4uX9dsUra+5ZwLyzoWFN94yZ99ZqrB9TIBOcP8DaqCdw6URqUakSWGe9ZCJn2csw2qCmJMBwQiF7SPXKvOLgn6JYl72D+hvgWFLQe7nWPczx9UIbqy6KHV6QdbfgWofqQ0lGBJWDwDsKFcd52vQC6X9gWMCX9qIeTVK+q4CjPFlHBskc9KfjyNRZ8S6rHpScO9TgIa4syuFBL8YB1w9oGeDW9zIazECHtQBYmcsKIMXLW4yCAESRwdQeSTy4uY6AIGQEreGOnrNpOJKec5tF5fghTYbMfY9y2SAAnNgbHclSSP5SK2BvDzKa5E6gIq6pwHYVnmsSjwD2oTCxI2HglT3iqsvQqQFnSyVDYq0oAQAy+pbrswtxmuvqFNOWcru5NKQ5ZwyAcu3Zl1dOXuQavHl1kv/D4DJ/O9QmABRnBAiGBo9rvFRLEWTEChhVgHjAsspYJdpBteTcrAA0oq32hnafW+QvS+xBAIOgdMS6Hp7fAhjMMdd5NhJZsL2LAdUm97YMHmPFAgSQiMNoywZNoRF52OuYetF6ABzDMmqrz4ymDY98WXQc5BMB6moHPU943Q3fs+FmAzLvJkSXZuDrnQn9qb5qViDdnMWXKXGMYp0UZDhy4kh6+uGvuo9MMGHc6uf1N9+SuufOTZ//x3802OE+ACQ85HMXLjCwOSF1jqeVIOhozi5ZgKE9zdTe3Y6VpQbzDkk2ljJYikDNGK+guGp5nVdd/9K0/NprU53oIjZBbIHm54FjVLrDB3rTnj27BMxfk8FqAeZnGyMFkxVtco/xDMIDBJ8fmDvOIpovOOYyZFtMZZGWuZRZ8I4T/AkHHiDOOGX8m0Kkt+cm/13GSTxfBXhWwF2eBxgvzE99UiY5gEyi0s236JrzFixIHaJxQBc5N+AxLpgb1H9862tUAZFf+8In0pe//KXUob676c7b01BNY9q+dVs6LfB86YplqU7G14a1G2Uwj6UbrroqdfUoG6vs8aY2STcKbNc1tVVuE3EjYRwREEyZoLAQsEnALioqA/JYtyjpEKosHImHfETP4CFx1v/sv/y5Yhl2SmJxutqwVW3YnG686Y508w03Vtrn3FqM6pol6LN8N5n2w+945//0//vv6f2//quWIC3z/7nXqhhn0bvfahx5fo02rcz3Bbp9C8Yuy+DZB0wcdu4JBuTs1f3V6dGR9+suu56n26Y+vkAtoPbWRJWu1Fsb+u5a8evSWj2HUwG1F6iNX+yXAZiTDeL1em/XwHjwRVyh8wJzpaZe09rWcS/j3x5QexPQp0WPHJCuv8VJJLiJLfjivXbGSoMyvOZBWwCQkHER3yRUg0HxNc8gSwdYy/QKAHasGAClkKNiObUCCgtChc/MVnV4E+O7oCE4YEwvqwRwGbNFdIUcdedASxbxiMQMT3Vx+VXqB/bL2+dwzykHW9UZmOXNd5fTnkM4xvyRDfWMnQzmJit7GFSFveAqAqhtqGQQbm9PnmkM1QEYGSSi/BGEB/ogrhFyjWEo4O2lfAZiFYQAvSQ8vnbaZizF/YoHFPvAMo4ZBHpxLOUwcMJ7VnzRxa8bUoguA4cDzrKniRLSHQ1oExvA8V14zYI6oobHu2+wDoUEYyzL6OGdNPhRbQ3+m9Oc5ct1ReueeAY2SIKVJI/zGGnRVa8x0Qv4rra+VSAijINaCS/XtvY4gdC4wHltXXP27gdIdQByEOHzIzvJ11k60KMqOiToHiFn6N0aPMEVwzM+z3ZmNj7jsmYt0b8YcYwXex/1/GgpH5NBsenJrwpEDwR1mv7EeGWM2syLQOpwzdLQsQo52yVAKss81qgeLfKAzl6wXAaIjJJaGSgne9P6h75qTz/Be4NSDOHky65RMpmlS9NXP//5NCDAuGK1eOSSUOQ7PLnPrlubdm3dQk1zi3NDblyAStiUAXDDy18kQG2w+qwYT7Uq1+zVq9Pcy68QGAyJveLRrOzI5GeOuvUd61dCnpPprlff43EywfsPOdAwlso7e8S5n+eXaOcA6LnNs2Ee7RnPQDzDMY4aAebylHcS/Akwz8GfBFAiaYhXnTqcBczxmOdhM+EJjjllWEC1V57pPXv2pJ07d6St4uOvFwVo187t6R1r3pre/uY1Mpya04H9Sj40NpwWLlwS4ys/b3kgfsuPcz3m1OHTf/sX6XQ93vxGJWbqTc36OWf+bJVBc9+QVFQ0J8+d3aOdlMY0bTaiYRHPA3+cmzouwg4Oz0BlpPs3QPqIxuaIeOKep/Q8oZOPY4WxS3D942vXpfu+eF/63Kc+lQ7t35duvvW6NHfeXGu3N7e0p9tvvztdIxWfYuCWn36c3E8BvNErL68CzCPIdDz1KtD4rT/9tvTIgyQXqrhWshWWixxTf8yrpSaT5tl4YMJ4KgC+lGGiocscUFpiwkg/X5/EdVwPHsq/G60685t6eLY8X/9NfX5hWiA7QSWkn0hHy2u/3jAVxFucek21wDlPtAbMW/XRMQ2Qz7+IG6eseGd5zC+75Mo1jY2SS2QBBvTlidyyfZqXrDmt3/GeQHeJ4DTDyglPkjFFBjReHUNC0It4dm+dHDyaDkktAiBjL6u+C8pLTOLFW1LxQrO45Jm4lMkKD7MiLbglC13EvPhkfgoa06NWKgm8YfkuA0u8xdmQsIcy1EeoiTM0ZgDgzJ90cj5/otG00GB4GDjHdrkNhwwE8uZqpcymcvgyuRLngJ+ifZ1JOkEPKIjeMCO/aNu8rhRQVEAsHxss4mGnvaIWAVz0u1Vr/DUNFSCrrHOcUDJvUsaKzCH14Vz7OGPXwvWolD9f1Mdk8KQLmQDgdonPHEdMeSi/qRYBvPA0m9qj75BSW3XppfLAy8sqjWjueVpBrG6z0wJMYzLs9B0XdHAoBoScJiNK/KLE50oVP1fYVWNS/V2lzIRIAQa2gyIS1BqHF/o8jI/w3MPBz8M4DBgVugbjhj5zA3H8RO8FFQO0F/Xh+5pszIR2fdZ4z8/LafPSNT7kNTzRuzft2/asKQJOwJUBiM2E3NZh77EVUNSOskHkvlP5VfcZ8+alLo39usY2A6n+Q7vTjg1P2/ioU+IcCNcjSoqzcOnKtOqKS9OOzVvSrLnzUqO8xICgLc89l7Y+vc5gqajfVMbVxC8V6gsGA0GmGBrqEtc9zlM7yTPbuWB+mrF8hTyzokLQJKZhGSHFvOAni2DJbPCqDEMyHqaJjvHS2+4Kw82D1zNPhcIbz2GMHfe3f04Ac7dUBuAl+LPsRtFN5XmbDMxJMET2Twd/ZlUWA/PsMS8Bi/aY0wf5oWfeO6GxtnPfvvTQAw+kJ775UNqvjJx1GtxzZk1TzEpVeuSpTemI+Niveu3d6fc++Edpese0dEB0j7auLkkJdkbblPaNap33dS4437H5mfTwV7+QVigJ0JCkMvdt35eaBLovU5t3LZinTZNmUXWawxjUDlJusex5jniOEkgb2XGjHUcU99CvDKUo6LRPmx70FlNcIjHcczI4/tOf3puee/oZGXZS++kfTDOVdOr6669WkKkoUKLF1E+bofq+QZrtsAzidS4w5zPGGrsGFY937ljuCUXmSw8+nH7+HW9PA8oUWiRt4/EqxlhlFqyMp8n3mdxmBfSfvywlnqOMq0nXjSF91svXHT/zaT1Uv65dYtK5T71ewBbIzk885EvybQDiJAg6+ALedurSL+IWMLzQwLlbP7o0UP72RV4XYzm9KxzzKyWXKC7mvcGBDu+p1Rf0d4Vy4u/yapW9xsEt5BTkU2KbNLbkSc887ImflRlBRBbM/r5DSnKxwwAceoVTwXM/u0IC1MOWtqfTwJLPY3E3QUa/1IpusXDZRQ7Owq1q1nsOPOIabJ/6vmAowIG+syczA4AAQgUyZK6JgSzokRvFDF05ijKZYx5efns5AVweE2AhNtvD+8Pf4bWjDfPWMeda2QSAETIsDockcyTGgBdEgUo3PambBITMPS9JVQCC2WjxNn1oBLu8Btq5tK6XldkNGCueI/NtA1QCLr3zoLYIsEp15ZUGWKp8aHgbUOeeLotV4UAbooO73FQAefTTCfvMHO1sVHBNQF346TgY4yVCVyljAXx8zy6ApQtVqXrzqQP8cU9vrNjocWdGH2RDoYb21udQdahvtYjxIsb4mOhd7hvo30HAgEvze+Hsw90PmT6XzcMgI27Kor4J2gqKRKEYZA8/5aNxclBwxAKEdzWsIwApnwFE4NBDBxMwETAdk+Y1VIFBUUjGROEpuxbuNbcnZc1UqVz0KC2XjXE8rXu2dKlFg9H5g1J6OaVdBEZJNRka5RnuVLIZAlVnzJiV5iy7OIwxXXe/QOJ68ciRuwuzKcyzc8FieSpiggjqFC/HgrCRzzOrQdMhr2mXVD4aWqTQkY0tt6PbOHZOeAbwvDZJorAYkxwL1aN7zrx088teoWODe12etglTNIB5jJ8M6icBcw/9/KxpM84vG+hcKQNzz10qSwn+tCqLPOck4WkSBateHvMGAUyoXcRemNqhC+w+cCBt3bY17VMynv2i3AwKcI+cGkzze2ZKrrJZnGvFeMC91jVix+5M+uxnvpyefmZDWrhoTvrLv/lomjdL3msPWfeeX9/S1hl4Vg6YdEwBmPRvn3TpT2iH4Z8+8pG0bPnSdOW116e5i5bn3QbKXmvwi2HBLic7NKFaFXNEAeR4wE8NnvBcSJ0bm1r8LAPE4Y8f1djslRTilk3b0sc+9tfpuPppriQgb7hWyYpuvTktVTZZYkHMV1e/HTvel05pHC5QYqLzvcq4oGxlV6R40fnJc7FXNKpf+IX3pMcffrASkGr/QR4R571w/rBM17lx46Q8L55tA3nSjvmgHBQTefRRHq/8znNvo/lM+tJ49ZlfHz158rFvV4ap737wFtBYYLBK0zOt1pvJAMnDdXpv1jMTE9DUa6oFztMCBZijyoI6y4tZyzwj67OB+dVX37imob5BVBYWEACmnhUHwcUsaXUVT/KAkLzJ7WyP4YXJLsoKADNxokjxxaxoMNvXuz/t373TqyqAzN5WARrL6QEw9LfBIpMk9wPK+buJibW6uiEtu2hVqgaYF+DlRQlgwyIueGYQlSUY7eYLDBZukQBrXvazNEks9HyXvaLero+FFY+esz7qAxZurkFdyNA4Chowmilwh8vHPQwQ8s5DeHW4Z6aJ2KMYdZzs5bEHX14k2s6BcfBTVQ+8dlzKGUK5XwbbBrmqA0DeCxXXRJPcZQoYi852cKvhTId3P1RWItETet2m4rAo4ckG+Ls3gppB6kGujedUCMDtywemelSuhReY8aJrATqMDsN9AAAgAElEQVStYBI8bEsjui89UNwGsVIGlSOaMO7Iz1oNgDqAbe4Dg9L8nTEYYMiGTwSrEWcQ03eMn2J0FTlJU23ybkLsF0S/mIJVdkbcbYwLLjSR0igum8ucy2EjgdLqS+6XhyAtabOjqK7gMff41THWXNfbnH8Ao020MCHKLkuhCcX18wsDirGm4F6aPRR88vjFUIFCJmCBIdogwDlHUnirL1spgDgvbd91JPVJ6+/h+7+ejklWsbR8KW+0WLwm3bHyt4G52xaAG+C4VdrePQJoKJU4yVFlJyqXxW3EkAldGlRabCTT5uY3awgpRmWGghevuf5lQR/xcxrjobKzRAvFAxOUHz8nUdZCGQoPOQZxlJ5nsxirMXqDymJgLgpLu1RZWtRGvJu0u1ChspjOIs79wMn0B7//++mJB75mDfMFCxelu1720jS9a2ZqntacWiVJCL+bYN5+eZGHxN0HyI2MDKdHH12XvvKV+3Xt2vQPn/x0WrwA+krsGpTXtwPm535X5gR+njpxTHr1irPQrlEDnHGN2+OKA5o1d372KqMxHlzuyeeVMcozAp1pSIZct5IkVWvH0+oqepYBx4d6j6anJLlZowGGZGZzQ0f6L7/3e+k973xHuu6Vr9DOCOBfxoi+sz65HCP7Dh1Of/nRj6TXvuLudOmqVZU6Tv6llGVCaSb6h/7DIdEvI+G3f+u30sc//gk7Uwpo9zW8ZJTRGedNHqsxn8RSVsZFDNyYWya+izVrYo7Nc7NOjc/iWSrfaw54TIPw3w0NnfjGeSs19eEFbQG1+2Jd8Aq9JQ3lqRJhjaf1PIQ01NRrqgW+TQt4dtUgIjoYUfv7NXB2v0hbLGazczzmAcybzDH3lnJsHhvqFMhkz7AmOSfI8SRoWOIJE7BuqTwDHXRxJcPlg4JiwgIOCOo9ui/1ipvJtYMsUrx2OZAOrITcHkCWs70VW3Fi+/r1ChRcvPJiLTBQH4qHzj75AEKWxQuPUUivBbgo4LislQUoAwhOK0Dv9LCy+SkQ6pS2rc2R1+edShve3NbkbWvoMbRBAbZF2eQsb3KME5WC8kTrmPeevWOR1j4DIXtqBUoMKArYCz3haBfUFOpjUSqC5dkjbU95dsYFtMsCfbomIP20DY4A5tEH4TWH707IIQuYgUv2bLp/APDu3zjXZ5uegic5RsFpeYGt1sPZBSTyV94xr0IL3R4nyhwayGHoKUxVITvjamf3q2ke3FKqK0gKOr29vMBSejh1PGt+Z5wc1Ko83HwfeaEF7gxwsRVoLXdq5muz8Gfs6urn4RpAfxJQ8orMuTHmg6oSdY4hHjx+fg8gHYDduw/6PERrAnyF4RDlGNV1yEzKJSyjmcdl8PCzUYCmOvWqlCn46+4t90GMI7zxqCR1z+pO+0WlKIG+ri5AH48zHGppSy8Tz3uhAg7nz+pKPdNr0vSG4fThz2xP9/3zJ33dAkLKs+A+NVjmGQoD2OPBBleMjSifoq+6u1OPrt+oVPR8PzI8Ko6x+OQeS9EObpO8axA7VbltKoYMYyLmgZmi41x+9Y0G5UWmL7qqALAAXDFui8c8auEYlihiBukFuOf9GG7B+FN5nLlTIBxVlja9+Vk85uwwNJjKQixESp/5+IfTkYNKUV8/K1U1zzAnfeX8zjStqzX1a044dOigAbBNV2gYGUySeGfLxu3p05+9T3NHX/r057+QVq1YXRkbufFzF8T4mxiFZ32b56gJQFq+xVhH8aY4QnqVUKpKgLktZxYtxxWASRudUnKhMfUTxn0jAdai8GAw4R0/LG/4/TLYvvC5z8oI6UzLFEjaPXOWdjda08JZUnKRh75Hhkl9U3jICc5G1WWbdhHuf+Ab6cknHndf/xslQVotmcPJL89/ZRzRpzaqok7cHzok2uc4BLZv3pbe8Na3iipEbEQZj3G1swA3f+dGq/hQY8rM/+R1qHw06dPiEji30UtPZHGAJ0+PnXnf8Mn+z5zdI1N/vRAtoPGAuD1JG6fl64OnkD+c0oH//9l7E3C7rqtMcEtvnucn6WmeBw+y49lWbGKCSVVRVDGFoppCXdU0dEE11Qn0wBcHnCr4qIRQRHxh6OoGGiiKbmjASQhTCBk825ItyZI1z/N7T3rz/J7U/7D2vVeynJiOpZLJvfL1ve/ee87ZZ+19zv7X2v/6140w+N/TfWZgjjtWehzP3RhAlOx5Nz7eAphv2QpqyDZx/DiR6oZn5Q9WbxSfW/dAgz2Cc00S+B0j3pnuwp84iojtlCQawFzICsAcnNgBAHOXMfcEVYBLOqyBqyde/ytEzWO+qkYEbPVG1HpCklMG5lruFohyRL+gNxxtEV0kQFYGxlmBgxj+Yt+p1A8ZsBnRMuyOLGpvSbVtPWnRkmUqIMMIEyc82UKJS8XJQnCiJDp2hXKA8bcKGAWwlWnVAG7sJXz/jpEkgv4AisI5pnUY9nEFw2CDZtB5F45nUKc4N8AtAbGjr4ahgvmKEGM7FSsh/QMv4G9XBv1IKF+LJNhX8LgNtLgSUTy13FbBdBmcCiPur0xfIPjiiGGUX1xytl7Afw5KIKNQfGhQ/7iAj6PWItNAwWQcCix9dNxEEYiEPFFW7CjyJCz3xs0c29ewjE4tcRW1fVbd5+kGSUq/53ZyYDQO2T8EfxFFlyPjS5uOCuGeqDrcSoDVtBseE3H93AJJ1xFs0JZZFpNOkIB59BVfVcgoALFMmFcG1PeF04xxXAGN6C6phPRB8YMNo91JjREdCYBp3W0b04bNm0XXmYFzeQZFWqpn+tPH/qcPpt/9wqn027/1B0qmVksiAq7rlH0QF5v6Tsf29ZbbW4eCNAvBIearrit8NwUOew1AHnnj+XeZn533W4jq24w6R9mTqht4di5cmO66d4vGuEa4nBY7BzRo8R5wdcQ8R84FysMBJMdcfcp7kRxCH5PXqYE55RJrxC9vBNe+AMwRya8GuKU84pH9ewASX0FEui2dGKpPyxd1oIjP0nTqzMl0AUmPHu/esXnQcRD8zXvCySMn0p88/eepv+9C+uxffj7dfQeKKZXYMcyQjfGWwPyq38UfBrr+I7eh99wp6Yq3o6pmfvB3bMvk5FQauHAutXd2p4aWFlFVCIj5ZCGfz//VX6bf+o3/PfVeOI9I+mh67PEtaQ0qmS5egntd98J0/70PpUZco8xhqEL+RwWi5KOgQP1f//l308svfBWrDagVgERuVv/8sf/hx9LKFSuuavbVUXtfm7pfwmYsSDSC1QYq5DRA+YX31H/zr388/enn/1xR/Ku2jftYvrZphExl86DKNtEdUaukHs++V2SHL0fsc2DGx/A2OOA+3Ep+ZmLo0h/Hh9frgvJn75AFYPsG7Io88uWxywG8MrGzLDv5Dtn4m2k3GZhTbPm78TyJgfTMu9QAbwHMH9sKwLtN8WWCBoVaTQwgOBHtWveyuAnGyStGGcBcYBGfG8AbXauYTAAagoOh3tOp/+xxA7nYRwbn/CBzt7kvUic0ubkVUgngsRDZTys33RmcXyePOeLMyd0KIL6JByjN93BO5MUbsoA6ARKjvJfOHE0jF/s8AWPbKoCOO9YsSIPTTakD0T0eg8enaXRGBHWK5BE0GjzboeHk6LZYai4f3CdbWFLVzx3NN9qmQfCXQ6wFoOIJJr7GFzlRlftitJ37cy9xMwNHUVcIenV8A0gCxsvU1BYNBHAVE/Q4pAYvoT/YuVzCZuSwFhGzaiSudeKc6YyoWJBQgfdjH8JtVFRXZ+Volf/OE2P8nq2iMycCMJ0GrFCWOBTk6MpHoQIQ3o+PXkxnDx+BrWfQB1Z18fmZ7ezzD6Uejq8YQ+4Hg2iPmXBmVM3U7dL4ZDM0vfN7Eyecz+AVgVzwSM6gOkyDxOcb2/g72EzJpT6e3NZQTykcH9/NxiCnC+bz9q/1qq6PdnlwFNR59EvYvwb9smz1qtR37jS46eAH+7KSpnn3gu60GdUS27u6pSpy9I19af/e19Is+NBMYHzvow+kuZqu9KUv/E0aRHXIPJDyalS+PgTGSxwHNqW2tSV1rl+XGkCNkb64mu9rilWAqRDD8ZupXtzGHOfivnxKHIuOMENmDmNuLPX39ksl5rEnvtMRc1rW/pmxkraz4QzEr0n+1D2lGFFXvSld2+5b7keZDNiWKw4G5q78SQ3zBqmywLak/0gysSLteP5vEQEfTa2grfQNc4zOIB9myLdBjTfLC2ZALidXzjFyBwAojx87lT732b9IZ8BJf/rzn00P3POgR2FhrMeOwoYeDrE6Ufjq6r9LI8+2A66V2ObQ/r1pwaKe1NKKxE18x3yeSeYboN95HdcBNAuMUxkItjl+6mR67vnn0rPPfDWdQtR7Cr9d2t6Vtjx4f9p4+20A8M1IUm0B0O9Ii0HDIU2P/P+DR7ES8GefS1/+my/AjhWo4tmGPIZWgOqG1Ar++Q/94L/UNrmv4lQK9zknlSJKjtWFKUThOdbqwdOXbjrsyRWIzwOU//hPfCiNQ/NcV2q+qL1XDQqD8+I9XaMjboz+ed4ozya+notXm1uW778wyTH89dTY4MX/jI+LXlY+gfLrO2oB2J2xEVZP5/IK30PkP+3EeD7yjh6ovLNvKgvE9KoL+/tw5lMYUJ99l1rA6OAaKst99z2mAkMziGbMQjmCNzVGSiqwlFmFmyij07735RueJxZN6kq89E3T2t/B6XNJPpkpRzIunj+WLp09Wbj58ltGEFXlMCYx65T7Ic4uvqKmufaP97VQ3lh12x04btYHdnVQUixMeXD019HNAo70snfsr3iTJuCfTf2nDqZpqALwHAkSGpHYtfmORenCaDMiTyhhDTw7rWRO38Uzv5obWKnELea2VnA09/6qiTlPLJpkHbG0druBjyX0onBRYcSppe6yAMU54CNpR0aVCpMSz9kARUlpBKXsDyaMSrqPKgjQ+8b5zkyOYyIfSKNI4MoKNALwaGNDS1davHYjEvtYsS83xBNebneOwBe+N2LXOWvyK5lc3WzSQwyW/CP2BFNOYS9m7ynciYgegfmRg4WESfWHDGmLTptk7vGjwwSa8+jwE5rjAr06UEQ5uQu2IezIT5kwmm2az8PfFwE/9xCKmwYGOWqqqLiPyfGbudGKKasP8E8R6RzTN79cwFN2DgCKV4I/XQO6BGJfeCXQrYWm9MqVqxHN3etiRbBTPWgrt22+Oy1cukRR08nxiXRgzy6ogJxQP8OdSj3dLWnLlnXp1PiStPuVl9OJw5QAjgcBpWwafVuChKoa61MzdM7rALa0iIL/MTLu1RlTXgjYeG5KmBQVxQ4Nz4ntc/SbtAXQw7jKBFBGrWyqe0wCfPHve7a8N215/DvivuFkUQ0L9mjcZ/S3rtkiCGdTzT23k0q789pUT8d3efgVgTnAOBI2m0FNaUDEXBxz0lhwjZPKAlye9rz2AsYcorljU2kQfGxH70H9CqBLY8ipjTbx2lVSMB5SMXnjEGQFv5hOHT+a/vizn0mPQM+9FJi/CaAXe+Nrvrs6+lzEj9uRLLkW1CLKIl7CSkoDVHHaqVSFGxSpIkwmp30ugD/++3/w+2kHlGT6QV8ZuziYFmDM/PRP/6/p/m9/QvYlkFc+Cxwu0lZ4bqMYU//l//6D9NefQSAZTvyW++9Ndz94H4pTtel8GfmmdO59Dz3uXIMYQ6WvVl3BKhgcxTmshlGykvkG1cwNYn9p1fFyevaFF9PWf/XDaRSyiepvdSBX7uzoXevsvdlg+d50rVMYcwqv+7i+sOOzePvvh/p7fxP7KfOY3+Y4/EZ+hv5bi+1ZtZPVO/nYiyd55HHlfiN7L2/7zWyBAkzCICOVhZSWP8LAejcK3XuGvQaYr1+2Yuv0wMA26u5ywiHnWKmBmJCqUMClvXsxIqmtiiaXKg0QmzCSmGkVimwKtBgIlRaL4A22/+wRyCWeLMjocarJ+sgG+sS4ETUJcJWjsJqw8ZvaaoCV2xAxR7l186KD0RvcaGql5ylMEZNSoBjAyFF8kSwk2dV7fH+aHR7SGKdix0LwZx94cHE6eLEtNTe1aIl4WtKMtot+h/0SoGdlGSWUi7rDL7OzkkG3vYTA1gEQCZiNj0qwkX5Tipny8rWXZm2bLM8YyNKR5ADWWroVPYTRSlafJGUEbQfwmJmZUqGbmZkJRLBGEF2FhjEBlRRiwP/G+9qGlrR0A4rY4DXOVMeVwyVwyk896fEt+//qaGysTDjkrF0UaDqyjb0bbS0bgrfL8Ya2jg32pb5jlgo2KItotSbXIKow4h/g14NUnVHIRyDs1BgVfUmumNufgbmtX3A5NKbzGOFm6lxXP+VKA+3DGdzRU9qAYw4RRfqd0QAlfuJzVrfNjpJApq4N969XlBzHYwaCC/iQQuIiPYabdG7VAJWx7164FNrgtenCyaOgFcwHbeV2SCGiKjUA4yzA0fGjR1E2fUjSkVNjw3ByQDNB8RxGNb/toQXpxPQ6VWnc8cLz0W/RozHADGkwY8IB6Nm0PnVC/pCc5Lw6ohtFRMyVpCnT5Nuh+zYu28IgFqiVCpEdJb7S+eUY40oNKW6rN21Om94DKgvHE12WAjA3OHeych47+RqKMSFahNugiGz8NuuYF6Ln2J7OTR0j5g1M/kQCpxI/rcrC5E8W1aqtmpf27XoZdB846ACuFweHoROPapeK8ON+iNUBJTbrZsUqnqyOjO0BMCExq057/st/nV586cV0Fontn/n859L99zwQo8z2unZFIo9v98ZbP2wDg1PeB7jq2H/pUtr+5S+kBx5+DNdoExy1JjkltDGTOVkgrg/JviPDg+m1HbvS03/0h6maykAA3P/iB78/vffbnkAhokUFIF4FcE/tczr6/Rf708H9+9Lv/f7vpCnke9yxeiWSdB9Mt6OKK4Ey+473Cb7WNbSllvZuje1SQM7rmG2hXv4sCwzh/OsJynmcqD6aATfvCz/3i59Kv/7pT2ufOeG3aJ88Qm0jr4nlu15xLNoRNPVS46LgKDDPQFddPzb8hcH+c7+Kr6n6UX7cYAugj8mzIo88TyQn8J48ciydlB9lC3zjFigF5hRtpff3DAbYyW981zd9D9cF5kvq6rZi/kHyp5MDDUIMrAXu8Elb5/LUsKgbk1atObeaVDONwbsl9ZXRGvFw4+ZoOUHfvHtPH07950/79kqKg5CIb7CQp4pIqDneWarNLTFK5y5roUywahNWxchxlUwjD21muJLjBIAd9XTky+BfyYJaMzcxQlUmSU/Bs+/43jQOYC6QiRv5pp7mdM/dXWn72Y7UQmCOqC4KTGif3I/UIIQbCkMjHABDrIJajf+CmqTRmfaP7UDvjqRCRwgFdgOZZapBnIDAqfTAM+WlZMiY7xq0jKDB5ElcoJEKKUyuBIVkepYa2lBjmJwA6MB7RLJY2dUrC5AvQ1RTK44ALas23pNqUf6d1T/nMQKt5rOhsRqit7ZH1jCx12GbG1yxwzyN6vSIbPL3BMn6nsotWKLHmKEhJgDMT584GMqbQRPizwRq/dDZks6A38tJ4jiCjSxwyBUc2tN2lnPCFRQ5K/G9vnIiLPcmxaECVA+lGg6DGJ/8meLechQ8FlVASM4BxxzaAVsQyAO64DhsAH5f8Lj43u6BhwveR9KvPiqMV5NkBOTwPUHMirWb0sWLp1WGfc2GTSrtTkrVUeiRnzt+HH8DZIKGMHSpX8C8FlrT9VTvAGh86Pb61Fd7D3jnE+mv/vQz6i9fsbowdD6VAEyLNqxLXYiSE5BT+aMFdAUW4VF1SBWDYp8boBcAZrY192dT514WgBTODl4x6QrcF8fDLBRMptGebhRJWr7mzgIwd5PcP75vFJU05HPSMorGOyrPxbiCYlQAQ/9Oh42rn0VzUPUW47kJ0XKpsoBrzmh5LaUSBcwrFE0/vOc1SP9Npv7Ry6mmbXmqA92C45EOLovjsHgT28RVgryqIaCOI40OXUy/96ufTK+jyNDIpQvpL774N2ndaijXBCDPiej6tQC2bhxf83FV5Bm/J8gdgJzhwR07Uivadvf73ifnlNHrWdybWKm5F7rk26GuMjc9mbqgNc56E+MXEYUeupQe/yffCf68iz9xpZEroHRKsvb5EJIxd+5+NV3qO4sk2bb0W5/6VPpXP/gD6d5ve79WBH2lcNzyng0aEFZRq3Ef5kPXYrwquRMODVdGOBfUYK4gJ51jueB8hQ3Yf199eUf6oX+xVXKUfhQdMgckrs5fshiA+yDu8OqD+E/tpDNm6Vo580No8idx0/tUX19fObHw6w28d+B72J0D4z14suIVH5fwpB75xXdg9+VdlC1QsEApMF+AT9+P5wEMtHejxul1gXlPTc1WTD3bdIPFjU03PiWKeZKb1noxVAC6eqBU0uPlSNzgVRxEN0ohci2lk5IwLxJxeDBOIIp14vU8gHnf2RMyLLWss1KGIyGONkd8M9ghmnUN7NQ46J+DB71KEXOWlSfQxufSlfZytjRzdafmOXgyNBjxPrwvgA6TfDWR9J3YlyZBZeH2wD7pjiWtadNt7WnXhe7UBu6lKu1hS0kG8jiaQHzz92TCT9mWAC+FKBm3cRRWWI2/0XKC0J72xGVela/nthHxCfikpXqDWW7rE9DknodmyRuBYS7vCxDBveIrgPgUAIfeA5xfxrFmIPM2Nz0GKgs4yxmA4vdM1qT0HCO1q++4F1UA2xEgZG8EJOaYKICKcMmEwPzIONQqKm6Yo6a2kc47QJPGV0T2DeCorXI5DfedAyXjsDnp3oMBsQxgeU0dmYli/FbiLo5CZ9BcS/Cqc+FvinkPjrLShpEIi7+snUPT+zutNOCt/Cgm7cr5cG+QUiUKE35rR4lNM/XkMlA5gT+55Ab5BhW6agQiIlpOe/M3BPbxW1NBvC+NW/zBVStSyDY/tCW1NFN72xUZT6MGwPEDB+BgYRvK2CE5rx70k8F+1OBAtLy5Zr70zOehQuTG5bWp9/Ly1Ibk0S+icuM4eMW6VnHcuubGtOGBB9LKu+5yEif/4bsprKawmE5XV7uTVNn+rEvOs8BnXh0jSLOTW8yVoFMUTnEGoFxhCkoLI+ZToFBRS7tr6ZrUs3zjVcCcbbND557P+QQmaznpN38eC0T6bZZJzFQWmtCra46W1oO+IlUWcswRMWeBIYLymupKVf4kWO/FikTvpV7ol/em1qXrcb1fgZNTmZrAq3beDX1436O4IleHfdLOk1h1Og7q1fFDB9Jf/Nnn0/d84P3p3z75swgegEMd9stg/O0Aco94X8fTGOPnkXh6HhVam+BUNINPvmDZco1PyR3COxkaHUvPoOjRl774t+n5Z76SPvAP35dWoOLr4sXLUjtWTTat2winBBKLoiCBfw5ATuDK97TRSzteSUeP7MfKwFBqa22GbVCFF8cZHRlMPdhPK97resE/0lxqahtw70dBI97fg4qihPjgkdPpYvCjms4MkvSrQvJV51XilHAsP7fjtfShD/0k5HNPe4WlcC9z/19lr7jP+jINBzuuS/6WqlmMyrOvuRrS1FA/VlNf8yuoKvyJp59+GhzF8uNGWwD9xfKuUGVI63RrQ11iPF/DdXD8Rh+7vP9vTgsU0AcGHwfcP8NzCAPu3SitFOhEFw5xDrFEZU9N1VYsw2+T6CBBgnjajHpzIjYYnGGYCjf2xo5Fqj44H4oQTBD0XZSTtCBKcGwNXPnIOJQo6vwpR8y5PwFo3qwDNeffk5iSozQZCOuezRLr+K4KEZg1t23GZINqjwQ/nHQMLTSpKWqeUaIRrR6GSnFTN8q3ygrA67njb0Dnl5XnoKGN36xe2AQO58J0cmxBakFkaIpTsgCkQaL44IyoEdpFJNYYzweT4gX/0sqBoaMqUWpmEcFBtjI4N/jm/xSdVNutMqPJTNmRAY+5G+4hQIrPzL8jwKPJVSSDewcgorM0S4lCLCnPIiJ+Ga8zM+B8QmVhCgBJ1S/ZXvx+GhzmHFFbBWBe3dhaVN4I4MpGWf3R3H9NkoXzdn9zh3a02AZH4wU3ClibSbzRIbChQLYKGwEUQk2i99QRAWQxiBUNZ+tMkeI7O0A0BFc7wnwyIXoDk/JSAIo5oDWp6PDnpMlwfxG1LfLSuZJj6UdrZXNdyLbkmVDXmbu3tKOdArVTCNBJbYqWcw/UgMa1QfoDbS6VHDlp7ntJEWpcA0Qw6Y0Aj4Ziu2lPZaXSuTWvubG9Nd373kfTCsju9Z8/gSTdvrQHEnXjWO1g8mU1Ky/WACRhVaMCVM1JaF2jGErqbEI7QZqewxy5uLMunR6pg4LRbem1F19Ip4+BDgPgsvGhh9La++5FdJz64lFACeOA0oukK1zouyQuNoGsxpVAnalZum4DmAukk+YS1zK73pFKr5D5b8phon+DyjKGyOwkko47lqxOPcs2XAXMPdbdtWxXBmbX45jzN+aYR4Q8wLjrBnhM0u5MIJZcIs6lmXKJUflTGuYsyqRoOH6Dftq3bxfySRapv6n5PTo5nUaR1LB+7SoBVq42jU2OpUFwoffufQN88mMAgnXpMuzegoj6E088kdbcc59zXPI4uuY6zWA9zFP4XQwFAe4JXJsnkKz5EqQM71i3DlFrcMExJsgd5/hilHx0fDI9/+JL6fd++7egrnIOiaojqQLbbnnvw5CiXJAWI/9gxYoV6RHQXZqamgOM8+qZJ3749p270i/9x0+mPTu2K0l42fIlaenypchNWJge3fK475J0qmBj3pNqahsVEMl9nCuFij6DaP0UVkJwIwU4bgAY59ikcktx1SNOVFcv2/8Xf/vl9FM/9T+ncajC5Ih7vkFIvjDuS7w3ZceQbWJSPnKhUguSTxd2tqcVy3pAvYN+/8IurErCUa2aNzU3r/I3MDB+7qd+6qn+UjuX398YC+A6ZTcRjBOU86bCKAt55G9gvMekcGOOXd7rN7cFCsA8brjfjlfUJU7/DwYeB+G76XF9YF41f2v1vNNF/E4AACAASURBVIptmjgiKmGeCSdkRwoZdZ1hFBFRk65lq0V1QBjFN2AmGDLCbgPFpGrAWeCf4/PzSLK8dAFKIAWUVgTOwq7YXOCQ+8B70Vki+sUIJj+tRTny1Uz+RNELTcKisWAC8db6vSLPGQjibb478Bc8NKdOF3rxUvDZY/vS+CBW2nAOBOYLWpuw1L4gjc5fgETQRlXEJGBGIA2P4JET5ovaQfDmIcKJTKsDBDFqgiO2qqwZEJgvbqkbqDONEJ/2QrAjxQ+DNn0fjgTtzEimwHnY2XQd7stnyQi89ajNG5+ZA6+XxX4weV4Bx3waS92Mml8GQFIV0Ig5X4ZMjRL+MLEuv/1+RMxR9p2OFydJNkR4I6CxnIdIeVS/eZ0j/JJosy8L/zSvLkSnGDnp51SQIQibQ0R/5PypdPHUcW8f1KE8FrLknpexVaonOPoGcTyXOjgTq2+/y1QR2pD5EmoAT9Ot1FiOap6iY9F5Yl/iO7GoyVfPVzyBlcAAQavpUgQs0uwn/YZbkVMrQMh+pEOSlWb4nn3h60H0FzljsAVyOXRcdZmsIDuw+MvqNStTT88CV07Fdl/93B+ls0jspCGlngOwWYVoZE1dMypRQn0MDsLMOMqmjw2lrmaMXpwEYX97S306cHI43fvIY4i0n0hnBi6qOBDpKvN4Tiqsgycj4og4ktagqDmct3Yk+bVDak+J3TGexd8VCM8OpiPovirVkb7u49rm54yWy4mNHIZJUBbIM29btDx1LVp1NTDH73Ni57XAvBA9p8NDQB6XjLqVfmv0P//2CplBIdVFGN0mt5xUFgLzzDEnMGfEnMWFWrCCMHDuDJI/R+GQNCjiPDI6kfbD7icAwIexmjYMp2IKdLc20Hx6oIjSvWhR6gRlZMny5akeCiW+Tj3mS6kopWC89L1tZoodwXLvmTNp184dqRuRbqqfrNyAFQU4EDNc5aJDzRwQ/PbVV3em3/zN/yOdhQLMNKQr5+M6/+B3fVf6dtBOuhYshPMFmgmAcTUCGHWM3KMPp+FU7Nm3L30B6irPP/vVdGjfgdQE2/zDb3s83Xv/3Yr+1yOy3orzWbn+dvUbATHlEplgmvsjR8fp9E6hH2dxP7HWPqLp+B1pP5lHTmOQJpjvCXxz4uy59Bv/52+mzz79WSUD83te3wTbpBg1ox8aEfmugxPV1dGOe/M0xmILxjpWKOBItiKqTyebv6+FU8QbFost1dXWz8KGvw2342NPPvnLZ9wL5ceNtgDGYw+OwdouzXGso3hllJyqK+VH2QI31AJ5ms43XepwsnzsVzAAWS3n3fQI9Hp1xHxJFSLmFfO2cZoVeIklaYNI0y8ISmcQVZ0DhaR1wTJEzRdgQsdNW791BDgCVgJiXO7nTTSnw/H1wukDUBGALjBxl+d5zWUGYkzCi881aRFgOFrMCU0gEv9Vo5T06k13C1yJL4kHIWJW2RDEKvSYQZkmQX5cmDvNT57PKDgmoXPgNY8N9GmSZESzCcvdSxcjCtOyGJM6kquCMWNOMwFzEG4Y2caOBcsIGrjPPDnzkATN/Ext5G8YZbSzUvgdsZ1Atm0l2oYS4gLjUJtcANDRZ3KZS6P2YSBJTRqUEBA5lEywy4jlNCZRUh3mMJGTczw1NZpmRpjsmqNa5swLmGIyXnEbqSxNmmjVt8TlPJdI7GW/eI3CD7/GXwRi3HN0QwZLBb55rKTwXEjJ0FK5eKpIvoNs5SA0mvkT9hBj5DqWdi2XB++pOEONc7wUilGRb3sFkm8dSAzG2CBgJKgUAGds2hSfoOFrVUX0E3znEe5+Ik3BKw8sojOOvIMBqRTx3CklWQspyUoAGEYF3UYNUoNPcp/xpzT+pf3PL2B/OEBcnWBEcR7sWYukuWqARKAZ/Y7Rda5c9GC8LQfII7VkBkDtKCgSvSeOpSN7dsBO6D/YnlF5RnirAErqwQVmIuIVVG6amxoDT3cotdcjaojzhthkamuqTQfeOJGe+Jc/mppRoOjA/v1eBYuxagqRxwxXjWQFHJvjxeaGUyO5PcB8OAKLliyBKke7HAo6DfnKVdfHfjwaZBB/L1DuxE8qAlEyj84i7x+dC5brnJhUmqPl2porUZHLIMAdTm+mQmQaS6au5ERRiUDxX76p8IyY/AlQzui/kj/JMce1XY+VFfL1CczJMyeVrLWpQVKdr+59PZ0CID978jQcn1oA5ZbUAUrH2pUr0qZ770MFUMRkPCALdI5prmSgb0nx0JUQ39sexQetEm4Y7IGCWoi2XzyHYkFwmpesWpW++uwX0oNb3q/ETIJxVedUUSOmfqDQD8bMT/3k/5K2v/xCWgct+B/6b34gLYUGeSVAazschfZuJ3XaMZ0nCcLntm9Pv/Frv5ZefflFJAlPplaMve8G5ebHP/xvU0O7z0WrH2o4AzGkQ0HHXLx6n6OkF9GXTOacBhifgmNPLf1aOClawYEjwOPmhx2TfB9y3OHZl15O/+6pj0mWth590YFVoc42yNF2diBZuUFAu//SAJJK65XkSglI5se0A6Br3Un2AlUGx21Gwiv7enJy+nJV5fw/GJ+d+ejPffSTx661d/nvG2MB9C8TOu/Fc2EcAXqs4pGXaUM3xuTlvV7HAtcC88X4zbfguR8Dcce7zGJfA5jP3+agmJcSHQHKAMNcTt5gp/FdUysmgcU9uHkjYqeoWkSIRe/wvGVKcQC4iPL2ntyfLqJqnUABDUfQzWNpMi4CPU1gBPaYEPi9KceOzDFivnLDZkV2dZyI4jrSTtDsiUY/ZvRTYCn4sJxoAvC6KA8n8jlxm4d6zwDATmgffHQgatiKJfdGFMIg2Mk1OQWag4ajiasEnvJYPveI+NOWfB8Tnydm28okCh/MPOZwFuRBeMgZ1EoMUuciaMol5viS28ve+GF2ggiKuBzPaBTBblG2jooKiJ5jUp0YHwQwHzaVR7Z3tF+RqPrmtGTjXVKmYISWE7Wi+wTmsTydHTgewUmcttnVTlFQOLCdIuYMbfK9ihzhbUiRqKw7LQHVmAunDqURVjUkyNW5ZYtxU8tLIkm5BGDze0eWp7GfppbOtAbFXUAYkTUFNwBkyRSmagN12dVYDnTJ3cXqQ/QZ7cgo3aUToFydO44EUToFiAKqNXYSa1shJ7kJjguqLhLIzheNy5FPcttZzZQwf3zgfDqzd2e6Mg596cpIFo1rqKGpIy3Z/B4oHbWlhShPTyoBQQ5Xn86ePZ9OgEs+AcepEoDtyO7nRHGgcgYlTGtAzaitqk81SEomsGRVVcpfzk2NpNZa/GY+QHBVXVq6dm2qXLgm3X7n3YoaHzwCfXgAPa6CmIZiegrHtgCZPClfQ/kiyCsdXIU5Bq5z9+IF0vouOtbXrFTHyoH18k2NMhfZ0onkIHPFph2gvK2LJeUzMPeKlAGdqSga4gHMM43G0XJes8b+cj8jYp6BujcMig36uB5g3DrmiJhH5U8mf/LJBEgCTDpD1fi7EX0wdvFSGhuDFjyAOyPO9UiurcLnfOSkQtEton1yGEhrEiA2jeV6wJw0m2mAyxHoow/396cGANBaJHLWN4AiguOfBUDfs/u1dP/DWxxpxn65P0aKKTNoZ/BK+hvkCyxavBCVXjciSOGIuLTl5YS63sKps6dTX9/59Jk/+Vz63d/5HYyPCVDyqtMTiJD/8I/8sJR9VEiM/c8+QN9XVdbgfm6A7fuOpWRdLXQGIBgyuhjbHD9yaBQhr5HzU6St0BYeP3L40Pe73tiTXt/9CvKLjotWxCtuRjYzV56FjEgLE90LB54CXYfjgnxx3htmsQ9SuBiRn8V9rQk0Fia2joyO/Smc5iefeuqX3vBoKT9utAXQp/TWKH5BCUQ+mFDLCPnJG33s8v7LFrjWAtcCc4YGPojnJAbkn7zLzHVdYL6MHPN587eRjhIzcwDbODt8PM1VeNxNIYCVGloXYDmaSaD14vZZZYIAlJvn+Cn5qAXoqO8vAJgPYsJQ2XZCHeG9kIvDZuaHRwTZM58n6fiMrakhMAdvtqKSkyVBIwHb1cfyAry3c3uibfwIx5OiRnYiAF5nQS2Ym4bk3CiiyKQmIDJEQLZg6Uos52JCFNrmkyCMgI5AJvBoBhM8XmBURV0F/A1MBLyxvaY8gmC2OvChNysOsQxH7bVEWU2CQtnJNtM23G8AfINxOzcCCtxWgIgTHiOWTsKbJUcVE+w0orjTw5ek9uAocqiWYPsmFB7pWbURUVLwRRkxJ6WC+5UZ3T885bwKYGhLckk++bxGYFcjR9blKARw8yl4hcXFhyiVNofxcSANssIlfusiNpFAyQh3OCQE5uoLtcHHoo2xmINx2Z3W3n63OLmMSDIHghE2AXCCuhh3BBIV8NBmAZiFt/ETLasj+fHknhfBxWcSGz6XEwFngFFd2cjjZhbH71h1W+paeVtBx9mJoATlc+ni/p2pHwmF1Uie5R7kAshTxTE17i6n+rb29C3f+X1p4ao1iuwPgid84ugp8JgnBIAuz4yneYgwH379edE/KhgxBWiiykUtVjOaAeiaqCU+fzKNwakZG5xEJBH89MUrU8vazakaoI/nuRjXaSeKEF24cEFSesoPCFCuVzwt22i7ysHNgyyuF37WD+55X99pFAe6XY5Ojorq2gokbUeKf/NmkelLfGsu8gwcX15b7QuXp5YOFO6K45GmJgpXvt7jehD4LgHp/DsD8/yayyUUVgIClPOqYxItCwwpeTKAedYx18oDk2xJv8CxGTWnpCABOd9nkH09Wkrh/oKzJXBV8nZc4/n6yK8En+Nj42kIgHwUfdDV1ZUWrFgRCZxRfAn7eP7559NCcKU7u0BHoYyj1HUoZYhVkAC/tNc0KWkwRP6M914C20vY//HTp9Khg3txXldSa3Nb2v78q+nV576Snnj04fT+f/AEklqZz1GRFq8GrmJeAVaMCHKrQE/UPTzOh+fEqDWPNYMnlXWkYhNUKqr+ENg7AOLwgpPh7eryWh2G4//FZ76YThzcB45+VRpHBJzOGaP+rHcxDFlK9lE9lFtygKIGY5YcdNK+eFzuixVGR2E/Oi9TWAEYHR79q541a3/6J//1T77mO2H5caMtgPHGu8NGPKlKxyRPKsjuwXMfxkBcoTe6FeX9ly1wtQWuAub8CgP1cbxQz/zz77Llm+sC8xUA5jXzAcwDOBI0eqLTPItIKbinxE+YsGdw0yQAaoE6C5dvxU2NKAtto2hqxsVx01ZsC9ufQ0R0kBFR/S4ixEySk70N4gVjA3jpZp9v25xw8as6RHRXbrxdwNlLx96OADxzgx25NWDURjovUxYcnTZo0DuRVBEZYrVMJkwSpGhSx4RFMCR5MS/x6qmoWB4S4TjIeSiZpOJ85AAwEqTjFosHSf0kgH0GbkrEJJ7Rfc6RN4OcPBgN2QWIBerZdkuY2e4GLeZ+M0rtJFCBGSU+wqnCMjSlEq8AkI9CmnACkyf7mhFDUZJwvq1tSHhFNJNcVXHMZQ9TdtRrcepiZsu8tmmF8nzc2Nx/XjHxmGB0ngmYecVAQDj2rEql+PvsiTew1H1BAFg2i+RZnWJQRWhmgggC5QyQaGPqzDfDqVhz530af9NSVYmVAHYxN5R/EwmsjP7HSo1AP6LCZ/eg0MzEqCgttJntimgixgDBm1ZvsBuCFlJnOgHOO5ashQOAfAfKEWI//Uf3pKETRyUXx2isOO0xDmnFGgDrjXfembqXLsW+AABBbTl9cQTL9FOiVdjOAGxwDqrRlt2vfMXKPQD55JbXkj+M4901M5y2bgKdDPrmzwwNp2kA/AtdkCAE9UqOB6umwgCMMK4CTWICtImTp8G84+4FxoM/nh2XkrucxhT6K4NTjqvxkSnQYXamu++7n1e4bg4e8o6aG8BmGguHIa95jwfSY/RkciwGTVNbD57dcU1pyKpNpRHzDIivprKUAHM5WRo2HuO5DdcAc+uYE5hbnYWR2HrwmQnMxTEPnrkAMO3GCLJkEV00ybeScFj46gFeWFnT+3wBqg0shDULYDqK+ggncYyK1NEF+UL0XT0qqopvH06LKCJ4jqNvtkMh5eEHH5Y0I6P3OQqeVzfydZXtwr8HEdl/5tnn0hch0fjG3l2ovfCetGTx4tQFJZ6Wpra0BFSVBoDdNhzfo9D9wZyJavHHce+OCsK5SieLAvE+MY17hIIJ4bxUI9mfwJwR8hwA8PXuFc+A52kCAHwnIv+HD72RLvbhWsY+6Iwx+Z/7rgeHn5z6CYBsnisrsbIPRkBT4XiqQvJyXqUbQqItCxlNTU7xPF6cnZn90FNPfeJFnUT5cVMsgPG2FAfiMiSzf9nhLDSxC/1a1oO/KT1QPshbWeB6wJxLORTP5wCl5/hueVwXmH9rXc3WhfVV22bwbT1BCma5cTyHgJf6cTMdxc0XcRpLkwG8NSHaxYQnAXNwzq9IncXAt1DhUNdwXuo2QD6HQj6SdhPoCpqHoE8RnBuyewKxX1ACfvG+FgWPVhGYs8AQtyNwJO42/NEkyQhvrshYhK38UWgyi6KQkyYNqDhZGliwba68yIlaEf1IADTYN8jLzkd2XvS5gHEABrXHUWGp3fB7sgZoJx6DEasYNY4Mc1v9IM93hTEV018APDsZWgmQDQs78flnZygaZmzEiLm5oir0goTQWfCSEQrTRMhCOjonTtSV9YjOukofKwJKoafEzj5agE3iN7RjGmoV40jq5ZI3J245QeIi03b8OdYKKO+HPyqpR6noHKOSBK+whYo3ITkYevITQwM+fwI7Ar8AbYGqZUmeu0eMelsOyjT6rxWqGmvuQHEXhNW5BC4qBJyt+RCONyXIjoUmfhwD+a56sP9HL51Op97YLReEY1isc/yYIJ00AjpCTpoEhxv7nmLiHUDywrXvAb2lUxrXV5CAeWLXS4jGI8JNAMN/ge7mY7u1a9enlVDaoI2mAU7279mTzpy7kBasvStVtkKiEIDM8opoE4t9TV5KL3/1S4pgs9ANbUeZv+Wg2/zyA6tS6+b70p7GzvQlRMt3ne2H1jn1s0nNcMQ3PzfgmAR6B0BHcffBhtGuDDplhxjf+kzAm/kFvoZHh8bTvj2vpnvuv0+RZa7GkH9PfWxGbM+fP6/IMa+VhvpGJwFqH77OmNvgVZMrqQX91AibycHSAHVScX4UCwxxdcuf5sJBORH0TaosOi2uaMR1yLGHdtYrUu6oObnm9QDIlNQj+DUwp4ygbcbzUhVTAvNYFaNJrgLHHHP+T+PUdzmMP6gejQCMDw0OgKt+NHU0N6U7HsAUgf0TkGZ5wUzx0LXIXBwcdwAa5IPQG79t053uOz7DGcj9kvuGf58+dz49/eefTX/6h38IisgZUG/Gldj66Lc8ChDenlavXJFWLF+dHrj3fvVTBvOZD05ArisY9vL9gFx2AvJpAXIasQ6AmbQW3QcAykWViUdxtSSvcvj8D584kp575gtp8FKfQDxrXoyjkiptTHvxuuH1S7tPo8aCrl4ci6satB2j6eTLsz+msHJEdSVctdsh7vHkz37k439VMkTKb2+wBdDHrTgEMU5XHOo8Xl/BOBy+wYcu775sgbdlgesBc/IovgfPixiof/m29nJr/Oi6wPyfQ8e8FQWGqjFZf/8iqJAggvOFobm0D8DkLG6O5zH7QBMgTWPrakSsmzoXIjmwAQCOvErc5Kl+gfNjsl6FaBwEzJwgubQfsBL7OXNyH4pwQMUq00sCdJdOOoXEspj0ePc2p9M83rr6VlFZBMwV1XLo2eDcu8488xwVV7BUeDYAnf4wx7wA7/L22AdX5xwh9+ROAKny44yaEkRgI8JVge0c0ibQi0hvqPgVwGDu+kztydQVJYGqDU4+FAVGnOn8idshFBkRQh4ux+wzaFAbYpTqLSO7jKbHgTPWl9Ng8r/bTdOB/yvagXjdjKZR6ziX5za33a5FOCXYN5UguA0fnGxP7HwOE/N4agY9Q+1Vcy0bSNA7i0mY2jSamNlXM4jGhn52JbitnUtXQOoQuttHXkcUn7RF9gzbmJNMqa7iVZespKKVAZ2Y6T2MYBOYr9v8oMAQx4ydESaRcQDIwkW/h+0UTMA/AN0TO5+HgwE+uIZrsRonU0cp0ybZQHLKCSbxPaOipMvUY3WhaznoKFjBuYT2Tw70qh+rGfkDeWl+xeW0eOWqtB5KQpIoRGNPHjyUDr+xF/ZwFdOWhStS49K1kjPk6hPPk3KNlVOD6aW//avCOGUqLnB5+lBzZbrv0S3pLxevT32NbYp6njh6JK1FsSBFehn5LaE/LO7pgU51q3jMI4iy6rq4BvixL0s/y7/JXuIYgPne119Ojz62JdWxETZT4RroP98LjvQeqDVBUYOJiB0LgittMDaHqKlWIbBNU9vC1NDSUXAEfEE5Yu7LyYCPj1zZk+/FI+d1oOu9RJ3FQ9qR2/iOx+E4rkfyJ0FrE9Q+GDGnbnkuMMSESgHy4JnLbsG51ooCr/ug2GT6D9vBY5PLPYaobz/44r3HjkNisg6R8W5xx9u7URET25KWkYF4TqLM/HQe1xz3irRn16tp2crVqbOTqwgONuT+KH2Nyzn90e//Qfrkr3wS0o0jusbfB036f/CBJ1LPElZunY97ZANWj5BUiURVJeIjQs6oNKPPcpSY0Mmxx8JpTMqNKp10qtgmgmpSXKjIUnre+filUXs64weh4/7aay+ns2dO4jgeFNo/+qOa1w76l1SsUawAZZ1zzhFUdmFiOq8VXqsc+wLxdHyupL0o7PbRJ5/8D3+aj1t+vfEWQN8S21DgYlUcjUB8B8bN2Rt/9PIRyhZ4+xZ4EzCPm3OWTfxjDNp3izzQdYH5t0KVZfH8edvuxbL4D3zLI4hW9Kev7tiXnga17yRuoP24006ScwjQ1tzRBSpLZ6qMiAorwZEjK5WTQICaWISDXI9Rkypu0mdRyGcEyVWyH/6pVHv+J7AbcdDChG+IJpjGSRvb1dS1IWIOjjnlEgM8a0IP4Khj54lNx8nEEEfCOelLm1oTf26w61d6P34wculKd5ydyWGPCGjpxMnzCgAhQKAti1VLBVxEl7CkY44gGvvFuWqjzEV25Fr71PcGUKKvBAgNIn9YLaT9Ape7Gmskaxoy2UmS/D7AsMCoYswCjwTKipZn0BrfmwphDilpTFHPVNYKjRg5FARaE4gSH9v9AqKgC1RCnold/JwAJ7trWenjMhIVSRmah+gaI8B9KKAyOjKWGkBr6Fy0NPWBY85ERps0aDuyAk/QEWwBLhVIKVaUnQn+eHv30rRyM6gWmW6E33IZXYCQyZ9hJ1FwcG6iYdAOiPif3PGMKnfKCVMv2imr1ADiBjhj/O3E20hCxP7nkGfRvWIDKCb1qXffy+kyeOoV2IggugNay3cANHWAWsCx0AuJu32Qu6NU3Cyi+AQuTCquRoS5fR0SSqmLTbCIY8kVmhpOL335LxT1rKSzgGYw6fpbH39fmoS9GAHNUfFjRw+n9RupDc6Iq5P6pFxEIAz6wDJQZ0ivOHeBgS8/5ETFGMtgUNSrAMmln40PT0DO74X02PseTXWg1eQ1C7tQcNDACSY4f+HZF6AlvzKtgyOiqLbGFl4RjTUwZx7DApSSby+0o0jdUmui/32J5uRq1xEIQB4LcXRgLflpp1jXYPwtjjlAJquYNkLrWhFz0Doa6qslzSfOdIBjrnZkR4bykXKYORDooKv1pC+BCoaoMrniQwDEfdAarwLFaAHA+Mb77tHqC6gWAqQZuBYUTRgdp12xXyVPRr6AVlXw2T4A8+Xr1iNHIFcvz/2TVwTzXcmfHz1wKP2PP/zfQbt8Gko5Lek7/9n3QRZzC4A969/F2BVP3kmavB7syNBZZXEiAHJcF9Qfp1IObUFVlAqMHdJL6EB6bLz54Xskq5FOp/OgJT7/4lfSQO9ZyXAyaZbnU4NjcwWSCdltjTVQWxmxFCU01ZnnQoeWibUsetUIqhWdbG4/Du14RMoPY4XqqY985Bf+C/Z19Ylft0XlD98JC6Bf2eFUm7sNT3re4J2l3XgeLPfDO2Hh8j7eaQu8FTDnAL4LT8oEHXqnD3qD9nddYH4fIuZL51/Zdj9yrv/bFcsR/bmSfu3A6fRFAPMLuMGi9E4a56SCm3wbJLlUrh03c8AWaQXnBMFcDERVA7Gd1Rs4GXNCuAJZQgBzlJZ2RMwL2K4+aRxP8EHgA7ihm78KwwTkVnEffNfQ0G6OuYCjoV/GTtqvzpD/C9Ah7jnpCcRWObrOpXwnA7pzATQYbSMAJ3DnpA4nRMVxcu8LoBKcRXsJgku+5l4IFFSAJ9qUo42Z952BuQ4ZgJvJpJ7q+JEQYyTNxmc8D7XBk6uj+TSYG2JeeS78YkrAvPkEsT5/vjUNxHxxPlS4iTKM3I67Yl/xt+R080gE1aTx8F9wkPN4dD/gV4qyQ8IMMpNnDu1OXT1LsIwOWVscYxxgmwCHbSFVxg4CISjbxKV90DRg34He42mg7yKWzRtSx8JFkI47LTk2uyymFgVpRtQKGkKSkeh7qunwABwvBAEzGF/di5enZRvf48JXAb7F6RUHCzrhsVKQ3S8DKKg+jA6kC7tetEY8Dl2tAUVw69FFXRc2fQboa46AXv1n7vQUzrNzOYA5orJ9B98AIJ8Tp/m2OzenRQDDBCrTk8PpyN7dUP7pk6b8OCOpGLszk3NQV2lD0Z3R1Hb7g1iFAq8fSkeyPxUwZobSi1/+a10rjdCYXv/wQ2khFDXomEieT5Fxy+MdP3IobbgN+VmUYGRkP4NLOhi4RtdDVo+PN1g5FGPsIH5fXY0qr4jmV6smwJsxUOlK1hiAOSPmj6CITS2iogJ6yLitQUTaXGkWEkI/IALKAjiU26QKDGkZ7APKkjKJkPtsbl8IexGERnTYF60dY43RYsSc7leOpGdwqURbgn72Hvs0xoC6U/cSn0sG5k2I4huY1+HeZmB+LZWlQP1h/6IJU3Aem1JYHwAAIABJREFUh0HDGAXY7EV1yhnwnVsh07cIxXuopNKIWgfsLzoGUqFRW0zVybSV7LQzKi79eYzL7ABkagjtcfD1nUi4Xo18gOZCtFxDLK7XDPQLqwiwa/+ZU1CMYVVPjEOMKeZjMFmUeTekhFDFh9tzGzoLjEiTsjINQD4BPXlKlFYxARZ0NYFxRMg5lkoj9vmaLz3+NCLsr0Bv/cD+vWkYlBWCa+rpU+KzATZmEjOBPo+V28+cCDrB1M6fxTiYmsL6K4E7HINa0IpIF5uYuXyqvrbu309OVv72U0899W6rD5JN9a58Rf+uQMMZJa/XDRFgHM/d6D8meZYfZQvckhZ4K2DehNZ+J569GMBfuCVb/uZGXReY393VtbV+anxbC26mi3CDn8JNvQ83zn5MTuDqAJQTsM5PjUgMbEDxiwpEVBiNIQeZc4eLtJD6YQzJaUpAisuT/IziIrjczx7bAyoLgDk+NKAkiHQjnUjoyUhSgpxgsZErTXJ7Syw2NkKresMdwHecRAxEDfJ9R8ng09AciUea/P3eX2PfkrQzfcRwL8NzuwHGBgQ3TjGUNnU+udL94NfWT2d72cgAFnyrozliLYAv7no0NloTR4u2GBgbbgiamLahHTGSjvMFGJXPg+MwGTHbxEWcpK1SBLXRF+b20L6kYPCNjKle4vGzI5J11X16pmEIk0c7+Lk21USP7TFWuO2l3hNQIDmclq5Yk+qQfElAPnixX2Axl/+mwyOtcrabsm9o6Rwiyxf7TkGqsg8RxFqodHSCm9oLmgui6jyT0PieC1pR7ilxgHPmbFB8ZkgrwUBZhMJXPWvvsBRctn9E0+UcAUheVlt8XpKYZKVHyEf27X5Z/cfy3lZRsS1JKdH4wH+zBITqGUfx2Q9TMFITVgpYkXb27AnI2G1Ka9dvQF8CCEEB58jru+FwnNJ+pQmObZlIzaJTE5A6IkBHcYDUvRnceDgoFUz+A1Cmjaome9Ou115NSzffk5YAdDPSKgoEKGQEUUXFjgrJGW7YhIg5o+2Z5x88c9p9cc/C1AyFi32HjqZf+sQnUOzrmPjg73nkwfS93/8DqVo1ATRAZblrHxOjUwLmDz3ykIA5x8Ic7Ml2Kkk4HjzW5BSistkJElDFWBOnmhHly1JkoSxnAXgyUbfg8ETEXPcDX6O6Aq6JmGsc8je6T7jVprm4X7g/tstVTF1ciK/1lJtktJwJluLKMxLv6rCjWFEYRxGhK6BeDfb2piqM0TbIJa6G7buWLdVvGDXXClCAXjsNORqtTBE1it+LFkLe9DXKKtfKKp48djg1I2enjbriX+ORATL3TYWTcVBDdA3jmuBxsnxhwV44NyUqsyAQgDOBMHXkmQBbjSALx0kNKGTX6q8XqCo8N53OFTgoo+nAoX3pxZeeSVNwJAm8uQLTjnZPwk5VcPKmQe2Btjii4XWipNBho5M8hVUwOgpUWKFTwPaQu86EWNBZLlyZnf2FmZm6XwcgZ5S2/LhJFkC/csBRj7wjDsm6LK9ifKHwQvlRtsCtbYHrAnPff69kOsvTGMzIprvlH9cF5puWrYZc4uVtFYh2IY6BBCBEtwKIEBzOqZx8BZI+uyGjx6RAcg8BMRSxI3rz4n+eRPPkRLhuugC2xwRx+theRFgvGfzGVhHk0t8MAufIqAB+8KotEiEolBqbu9KKDbdjMmGUrwRGGPuqHZ7wDcUdPbuajsFPBbeIt4hV2XaBZ8WLtb35397//ECtRc3yInAz6iViNYjWuUc7gkpfgDsEEFYbyZF6T3p8ZKqM/ohS7iazBPrQOflQOjOdlmPtwqf5t4GgVbhGqN5Ulgwu7ZAwUs5+oSPAyLO532624KgckgxQ9Rmj8zxaVtvg/nFCA+cOo5rrqbRk5Tpoe4OeQACGiboWhXhqsFxN4MMo3WUCAyQAks87D5P4DFRI+s8fTUPg6HIsNaHi4dgw1maYKMd+IfsEdiCItkqGI9VcbqcuOI+dC+QoGogvFy9fC/lBrMYSmAbthRuZ7kAA5eRX28yybnQY5iZH0sCelxRVrIbNqngs2KYaIfZG7GuGcn8YnDPYhiEk7o7Og6J+iDQ2oOLiijVr03IUQ6HuNMf96QNvpBMo6lOFE6nDOddElJntmcG+J7CTcZR8n8GFVgXHpGnTPaCHsbALpehcP2BqdjRVgCtMcNnYWKd9ixOtpEWC9CKX/OjhIwDm6zV+pcgSicvu0nkApqho2bMoPfOV59PHf/4p2YNULa6I/OCPbE133YE8Lw3luCg02jw++dn4KBJMX30xbYH0Xh36L8uiqhCUqEPFsTzF8wq2GG2uAkwAhATopFB0LFyOOlaN4WAZiNuv5bGi4JAAr+4gjpjT7gG8C0WFOO4jYl6QUaQDGOdMW9WxSirk+rg6kJ1ZatVPYmVmAlHwERS1qUDyZAcKCa1dvSqtWL1cDsx8ANYKamlrzLMNcb0FEJeySuhv69xlecYLQoZR/XO11OH1otHcdgj3xEmA14U9FMB4+w+uQCgSHasm2UFQYm7QVcjhnmQBJPQzHTsqTeUIufst3y+L/a0Ag68Y8NiH0ksvPZt6L5xBBdQBqftw3ywSxIRPjsEpXO9KFuZ1xXGnJ8cInbRp8fwnySUHfW3g0pAcS4yageqaql+8MnNp21NP/SeszZYfN8sCGCfgDylCvjyOyWpzXPnvvVltKB+nbIFv1AJfC5ivxs6RbZb2YlDv/EYPdBO2vy4wv3P9pq2YRLZxKVoxWwIYTXhEgZhcpNOLSCVBB3mR8xlt4Q2dINY3dz4Iaw25FRNV8p8/NJA6g4j56OAlUQYykOeemQCn+owCmgU46uisJuZsGUitNXcDmG9S8mcGa6JikEcZv1VUNWC1mMrCDZr5tSPiVXGlI+rlVkeyJMEJueU6jwDReuu2CUgHSCbdw4ma8cB3ShrTLO1VgThiHNpA2T8onJRAjqLeAfDNpzboLnDnCW64W0ZB41wIlrkbLe2zfQGi8mTrdhmE8nfiDucekuqJ+0qQO9qak155VtaVDyoN37KPldBLLM/I+WwaOHsgDUGfefHaTYgaY2mfaiWY/Bs7FqY6gPM5RIVZ2IhPUjbmXQaNBZP59Dg4qqgEO9R/Ue1qRGRyFCCAwF75CmgPo65sdwUTyvCfEvN4jqRHxPlKV3zGTsOSlRvA94YyiSLmRntagdB5mGJgQB/2FcjCSKC++75X0tzouDjmzH6qx2tHTUXqqgFwxj54jFmM+d5paDBDvqgfyJOWqF6+NN37+PtSM4Dd3MBQOn3oUDqxZ3e6jMggNk1tuHaW1lxJG6Ax3tHRkMZxzFPnx9P+ibnUN4l9wQupQ6Gh+atvV8XFeViFmq6BfTAG5gAem5G0WQ8KBmUPSRHgtejEQVAVQjGGY//owYNpw+0b5N2WKrLkocmxvnrFivT6q7vTz/38z6p6ox3YK+mxJx5N//if/oAZTzGY2e15qFNnfBKO1O5dL6SHHyGVpbD+5LFs1BrjmhWCLV/JLjDNg6oskOlkZBr929nD+gCoflq4bvKymZ2efD/huCZ3XKOY+8L/7KDzc47Z7KD5O/OnMdaY9CuVEVI3qMU9qQI5bAOq/IAmhKg9xuimtWvSPfdsTsvXQ2QLYJGRXD5lFTqjclJ9WjnPJScV5+RnOo1So2EJe1JVxO22olN2jjIgzysExRP3O9JB+qFWtQxKKtd7FCLY1/ky38Nc2db2pboKOeA8bxqunhQpRe8ZpXYhq2sfOfLPzxkNHxkdSS/DETv4xi7Rr+ZgV9J72lF4je1VbkgzOeMoHhXOUDP+5r6pvsOEUtKa2F9cnWCfito0f/4ofvIpaJv/4k/8xFNlhY/r9viN+RB9zOkWy80JNwrFXZgbR2W5kGu6Mcct77VsgRthga8FzDm4vxdPUE/n/b834uDv8D6vD8zvvGdrdVXlNnIVOeFIGUWZnBH9CNAowCqusiMieQLNk0MxyZElnNnyzHE2aDwNYD4x5Kq9nOhyeXlTVwxBTUcxfFR9F/zOCYeOcLa0oHT5+jsAYCzHpiS+cAZye/hqfW8/i+0LqKrlawOKIi0iJn78hIl7tAElDdkIFxiyK5FpDP6oIHhoIEiLySkoOhfWsdY3+kWOlvNXGXpbxSYnmPL0CcIzcDfosZqDqQ/8ROSBoMj4xasAioRHAhtP0XQeH139GuC94DAQuvIzgGyfp5j0OgNH150I6zPi5uAJi0ZDYA6q0xlU60RC4TKuYmB5fGJ0DK9IuqtvAdCsc2Iww6fYP6OU8wDsMdZEbTi+fxeicIMCmo2tDWkM/FTaijbT2MCTfU+YbXUaJ8tpBUUxfRfsYQSPKwYr1t6W2lCttTRxzeNKSzFSYNSWkfBKzvmcCjAhGbX3dLoCuTd+z3BSJwDXAmzzQFdl2ry0PdVDdWWgbyB94cxYOj09P72O1YClkA5sWb0ayZsNkHsbTgdeein17j+QcNapEYC/GYddCRD7T3sq07q7wf9esQ64GeB6+7PpMy8cS89PV6T9aFstVGlqwI+fBXeZ1BgCSIEZjve2FmlRN4HfXANZOZ67+cAlkoiwzSEc97bNWC0AiM5JhaURWtqhs709TY9Npl//9K9Ia1q2RBt/5N/892n1urvUx4VLSTYvcpSnJ2fTzlefTw8/+t5CIbDCjVFjSoNcD0kaaluvKugaJkWJThfAWfui5QLmTjLVQNazwGWOfXA3ma9tLrelMamIoiRL3GS4DUHgCFZbRpCIPAlO+AycwcuItlfDUWxoaAaPuRaUi5a0dMmC1NPdkdramlML/qaCiZJk0VbKdr4pol1wrDnu8xXDU+O15IAFteeVhMvoeAkYv5auorMsNVLRXGkSFJAzp0+k1WuJl976UQrQM5A2pceAnCtTjI6TrqLqnHxKF52rnC4WVtqGImXFx5zDmGXV0J27t6e+82eQ2D2qHJERjJla8NEnJojjfAesBl2F8J565HRESEuZpjOANpC/T61yct45DpgUi1XYSXDaf62+tubnP/zhp6wAUH7cNAugr+n1MSeOcQdelPvwfB3jwQkS5UfZAu8yC7wlMOd5YMA/gJc1eH4Zg/zMLX5u1wXm99z94NbqmuptjDQ56kqAyUk6g1pGW01xUFxZIMlATZN7RJQUaeJEwc8lqcf9CM5hMiXH/HVERQHERCPwcUSrEH3ELryjpQ5yZoBGWo2LDUFhoqUbCgZ3aMmYDx1LU0Vx0intMKsraAcB4h3JM0CNqBtxBHcWE2eG1VxW5xEMWLhRAFtxnDMUL7oD/oW55Hl/jFZnMK9JLc6N52z1FVlHttW2PJpAjSONBkqmtET8rgiWI/Lrdkd/8bdAnKQBiIoT0Xdx5n0GgrR81R05To39xrM13PXqASdqUjrYMp9XkZuuCB1A1uCFY2kQiWjL1mxStclh9i+cN2kxs2BOdIYrnWIfAJ51KG5CUH/0jR1pEtxlLq/XIyI8OgoqC3+nc+C5oxUAX3YaOAaZWklVloiEo02K5jGSis9XrL8rtS5aFgDLKxc+vs9JXGSekwAdo+akshCwk2oD0HH49VQ7NpKacOxFVfNST9289GMPbUq9370u1X7hdNrzpZfT65OV6dz6OwHI16Vx8JVnAMqOHz2azp1nYSREls8cRwgUJdBx1AXYzwZMg997+7LU+o8eTg2diBp/tT8d2b4jfe40ispMpDQCCk/V7e9Jl5EEqhGF9lIfnI0nX58Asrm5RXQAJevBqaGUHcd/IRKLYx09dDhtvANUlst2Xswzjw4OZ4yR3bUrVqWdL29Pv/rpbYow3333nemJ7/5eRZ/9ew87X9t+z7ZMjE2lV7c/l977vvf5t/Hwu3A+4zj8u1h4yCQrgkWOF9Ivmtp7Ul0DEhc5xkhD4ueMvCra6yqhBJn8vQC4wD2dCGt8O0+BfctrCK+kPXG1D+OjGlx/Jp7SsSG/mgV+utuaUndnK5KMyS+HvjbsKBoQ7RRgOke3dZ2J0nY1kFbZemxjGpHVcERV4fUR6ioZjF8PlBcMdp031A4/fPhA2ggd89LjXhspLzguvPfgmfnjWWGFCZhSWKFiFuhhdOTI7S5GyEtWH+Vn+B5G/nkfEjmfB2XlzMkjoroMQ4+dYJvXGu3N13GM64ZGUFgAwK0y4yEzzX7C8hbBP5Ve6AgR0PP3uIahCjr7m7gy/t1HPvIplPUtP26mBTBOunE86pFnyZ+TeE8e+buBenszTVU+1rvMAqU4701Nx8Bn4sQH8DyFwf7VW/zcAsEJdxGHEd1W3nPPY1uRHb9NkUTecD094L+8tk2wGBFyRncFjAwWBd7xawE+ThhaiyZYwuekPSga7MS300dfR3IVyoJHlIzRUEMm83r5YFIcj20tD++Tf1OujJGqlpYFAOZQZQlgLiqJwK3b7KIojj4XIsr6Kv8u2h38dRXkiYh1ThoTkDPOjUi1JyAWLlKcW6ft9pZgH/1tSUK3hqbgErcn1Ixy9FX+SQAMAxvDZf7UiJLA2JOflSl8Gv6N4sBsX1BS+KnsLABcbIOj/PxnIGLddzspgfkz9spH9/eKNPM4AdcV3YzoJ44psIX2jV08Dx3n/YqOU2ljFrrhlKGbRw1kHIu6xgRM3KcLzDDqD7oDKlteOn/WEzoABBPGhkeGxEt1xL64oiBbi6DvyD1XNJj3QJDNNgBf6nxW3X5PakZJcxW9CnvYbmEPOTjkmRPs81wYgWWbWHkUYxXqKQkVCzsALhYDUK+srUz//IHb09RCFMMBmP3riq40tOaONA5w148+OnrqDArrXJBG87xKUDPYFvDVZ86eTbWIXK5CFHYTaCxPdEKu8M6Nko8bhirKn5wdSy9PgW+7an2aXbYSCwGgiNGJwTnK3eXpYnWBQLqpCQogkJljwmIddLhJA2IUlM6MB4LHxdEDB9P6O9ejj7GvcJyLlCz+zBHwZagM2QBqzH7w30egOkI6gla/wglXn4fDqOsp/p5CUt/Lz38pPfr+byuOwdgnnZusbJcde6N7wWf3OfnlpDbgfU0t8w8axP0nB3oalR3H0BZWNpUjSB69dLQJoq00oj5EY1Q6PhxR3Wo01g3QeY9h3+aKuE1NDUjebEzNsFtNjSt9EpATrPNVeSR8EmQHJ9/Ojm0luUwl25qqwgg5naXS1Qq1qSQSXRqRfqsIuTuu+KBd9qG41e13QlFI15n7ND/4t2Qn0aZSDfJJjNNJcL6Z5lMLO1Gph9HxUoWVa/dT8LrQcK5g7YOS0P59u8D9higuHGBWIeW1OApaF483OTahIk3sTuY+0GGqx/f6HRxxRsOZfN2MFZ2xUdQgUDehnVh+nV9Z9fsTc9Mf/dj/9nGCwfLjJloAY4biFKzYuSQOy1UKFghCIZHyo2yBd78FviYw5+nhIvgOvNAjvdU1za8PzO97bGtNbf02J/DgwSgVXkwfuOb0A2PmRE+X9jbdJAiiijiRPmFg7kmO4Onk0d1pCkv+OdpMCgv55TwGApTcwnrEeufHLJObOCHF5NTStigtB8c8gz2RNIJ2YopDBs2YzMB15SRKSoryN/mDmPMs+8ckSP4OutuMMMa20sEuaUeWQMxcU1XJ1DxphRJP5ubdFrXCjUsMkvw+OxBsi/S8OYtRJUTveB7xOzdE29F+UuxWBD1rmgc9QwmcQTmRnTkYvSkVMOZRyYUJlAQzOAmxe/wT25d21WHsrMgCsjN1yOP4OnbosPP8JDNJXWbTgWYhfTgx3J/mJkbAG59IswALtCc5vS5uYqDE8/Dag9U03NvM0wTHGhM/udVj0Ij2SgHbkY/PPvKJiVpESxEMxXnQYSO1gZZZc+cDqR7qLqZbFcetQb5Td+VaIDJLMOk+xifYB9MMSYmpHBtINYh6dyDRbXntlXRHcxW46ytT//J16fS8xjSE/nz9+PF0ABJ6FYj8z0d0konIokIwaZal52GLygvnUh14uktx0PWNoMVgVX8cxj4M7LJv4ao0vHpDmmEeAm1NsMeqqxzHGk8E5tO8GpDs3JxaoXxBWTmCy4KSRgDpXCL99NFjANmVqXvRCnGJBQoDYBpeG3A3gS6zdPGiNDA0jCj/OfwuSqzbwt4uHhnM88/ec72Iyu9KDz/2rXn0FH7nEWV7igIWgFzrYbGqQ7tIxzzyMqYhTUP51WokWOZS73wlGM8UF60cEeSV4FR3G8eUX3ko09mtaU7nj9HzGiSpU76vBUmzDVhtIBVD6iji5buKKu8/jIQXNczNFyc1ha+kqYjTH5xxU/mu5o7TCG83Qv4mSl0AcILt3a++nG6/+94SRz4cJI5ZUlWYPIv2UhWGEW7yyEkPqwNdJ1NVagDOlXh5zT372kj78OhwOn7yRHrxha8gB2RcqxKKdGNf5I83YIywYu40+PjqWV5jcb3IUaHsoRxiXC/4m9cNo/T8e37FlStTE5N/jE2e/OhHP3GgZJCU394EC6Cv6bFz6SXzosg/eg1j4uhNOHz5EGUL3DQLvB1gjuwhLRfd6kmg1wXm9z34rVshm7VNyZrFaRmTnsFRjsrxK02IjEhH1r0XmR1ZdjTZT3OAnWQnzI63p1EZcRxRUU1mkZhnIJ1JHD54BrG5aEhG0zxGC6oGLlsPYA7Or6vyEVwSqUUkmaDZEIN7CnxWAny1/0wLiaVd/p3PPaJoeXLLKwOOOWeud9FxUHtjnyqjrWh7Ecg6Ml10NQSBZWZ/JkAsMONzCAilz/3gJyL4GPAEAHdr/L0BN1coFAPWvvPe+QmlDxlWy1kBVDAJDG/wnyfyoHZwe0fq+UMXVspehRJ0CcxzIRUpnUDFBxHwOUTPGOmdQdT4wpkzeJ0S8LbdfMYaF2rcPIHNOqpfgGJAQDEAhQxx+gnowhtS1wagl4/A94yqYh902lzEBk/8cP1mSPm1oLS9aB6x+lAApRq4AqvzyVPWuYaCR0TPZWkkuVVMT6SagQupEW3ZeMfG1IkCQdMY72dQOn3HntfT0Nh0qoQqRSWATAUi5aIyaIEm5PfgrMxMgZ8LcN+EyGIbwFQtPM+hrhVpAJQfqrKIJqTKkF6lsoa0S90zei4q0cwkIpGNKsxSx4qVAJsG8QboSugDkKVhyUt/Y+d2rFowQZtrCmgPQadoL15BUHfCtvfec69oBzv37tHYY6TVPGkWC7PSEt87ibQCeQBD6Y3tL6fbYIsFS1fly7FkPPqa9/jPI4ufFRV/5mATXwmkRlQjp6AbkXPzzO1uFlfgYphrdNuJ43Xu60FKTb4MrgbmAuhMBHape64oNAGUtzSBn48VAo41AnJGwV3h0tFvA3ACcUbSQ95QEfKooPoWSZyFFbNSB/DaIEZcwV/vhe3duePltAna95QxzOcq51eceoBxRNVVoROvVOeRugqfpJsEXaVwz7rqPp4BPhSUsCrx4ivPI0ByCFSVi7o2WUyITjTHHhOC+Tf7hIWULHtYqSh5VllhpLwRwH0c3PLm5kaprswgKXQC1/riRV2fHx0Z/+mf+ZmPv/71zrn8/TtvAYybddjrZjwpWcZJYw+e+8o88nfe1uU9/te3wNsB5pxZvkczSEp/ggvhVi2Q8JbAHNGSbbhPK4I9P6LASqx0BqZmQiphCPYGmCtUtRT/21BYCilSdQnoGBxn7uYsS5YjYi7ATcAVeLUA7AWqPRGrCA4eitQoPGqwSWC+dN1tivRx8tRvOeVHpMgSgcWHeM0CDRmWej8RhC04DvkcFYGOCVavaqP5yQJLrGoZnFI5IAL53A3bwOgujqOIu8G0gKgoGKbHyEnJE2fs2ymWVtnID0UaGWyn48GES+xXgF+2dlSMEfsi39cq5jmS7L8csXT1UnOu/WqUzKqeWkSQyaLIEMElt1GbIuIf4Mk0FALzgNiMgHJLgUzSQUBVkBLDpKpcjg/CCYvfy+ZqD+0JNRMAgFYombA9BIbs70u9F0znINCmXbVgg/7j8QT6ZFL1pfbFgj+kL4Qbsm7zI6kW0WUBzPz7AOOFqKH8Fm9B4Cj3RlQMj0cC5mpUtly+fHFasKBT4H1idCgdeGNvugBta4Fn7L8akqFAvQavGltyjXCNMAIPG8EWQNZoH2TiGtvTFaz0XAFIVgIjHRmuaOi0qGJBXjX4waAGKEFX1AiaEzSCusrU2tYh7WkCcwIlgmfTFayAkfnyrLg4fPGCANZlgCldk5GkzainudqX0+IlS9KiRYvTSURNT6OfOKbVeq0awWlAdJZjNlfqZDu7Fy1Ii+FUMDrKh64pjnMWFtJ4ipUjLTbZnhoTdqWU/Cmr4z+uNHQuXCGNa7qLOZLMjUS7otMe1wipau4rA3JRjwTU/RmHRgRzBdpZZp6/YQIiCz21BjCvR2Ehl5s3ANeTeuZwcqoiQs7oL+kaBuWOjrNtpRHx0ntD6YqC+j/uNW8Vsb52NSLbka+7d72WViKRuAFVYBUhzwWBCMhDf7wazhQj03SqCM75GpGHq6LkBdvJVlfSRdSOOHh4f3ptx0sYZ+O6V5ISRVA9gcqfBPnkqbfgepygeg0i5YqM4xgE5RxnvM7GoFve3NyE8TUl20zhO26LMfYsevFDTz7589vz/av8evMsgP5GZTfRVjKP/Bjek0f+bqlIfvOMVT7S3xsLfF1gHjdYLh9RiojLRm/comd/XWD+4MNPgMpSC445523SIzI8DhDLiZYTYQH02iSa+AMHa5LihKJXwzBGVg0eNW+DYw5VFhbw4KTOX2inAZIJCYIvXpywDGy1N4Id/GtD4ljPOkbMMWlyAiWEJAgjSAgwJvypFmICVwMd7+aD0IRgnRFXqZgICHjf8qvYWKIK/VcS/+PmsaauaL9/IkBZ+juDRkcm+aMcPbciAsEL6QpxLMJLAXuD7MuMBBecAQJngtQ8khwRdxPD6AL8Oj07B/w6RqsLHqE/8MJz9Tl55UDnFs5RtpWswwMIeFk/2v4QwZ2dMRVAEmi3PSkYqFWWAEyXwS8XqQkFZmZ0yCE8AAAgAElEQVSmxjHJQ6EFwHRqfBgO2Ti0jKF+Qm40ACRlAKuoRS/Qz0S2y1B4OWUKDqLlBnE+thw3rcDQqcA3AptkXNnGM3I+5qUNdz2SaiA9qAixwKEBnB6xQiNb6SqIlQvZgr+jAzUfpesXpxV40slidPLY0SPp7MmT5vbGb+Qzhu2pwc7tGNnlyoQSigMAt3Z1pcbFS9L5Szh/cM49PqG6Qhk7nhEj5iFvV0mOMJ5M2nP7cF4ofFQHycZ21A8Qzxe2ofQdwaTALgA+rzErEHFRhIAS5uVqFqPeomDgiKRz0flgP+KVNI7161CMCMc4fPSweNk0k+U/M5h3vxZHH68XU4ZyYme+C2ickR7E77mKpQI8vpR04fO88QelDEnBqKlrTguWrHOCMGhHhb6ijyTbFXnWAuMC4kVg7ssw+NYB4vkbjgcCc/62DnkLzUhUbG1pAMc86CyImlMRyHreTqTVqoN440FRgf2yUoucu8IqloF3wR4l77/WZxp6MQgLDkgektn5YMQc1TTXrFsvh4t0FY4XJoXSmXB7WaGzyB+XBa7TBl0XsRJ0Bjkc219+Np07ewp2R1ScIxTX3ii44DxvUX9Ek6Hu+WWtKvDez2ZxHDFKzyqpHB/9Fy9pBWI+28GiSaSzzMy8NDEz9ZGf/cgnvlgcKeV3N8sCGFfNONZ9eC6MY/bhlTxyLD2WH2UL/P22wNsF5uR2UTqR1csYNS+Z1m4ZA10XmD8MYF5ZWweOudEmOYeiV5BDTRCtiCUnmACqGVcK5hrkSt83R1n5XproplVINxr/nQMwHxlB8qeDwYkwjlZipJ7ReaUZEg8QBAosG24qqTSiUW2dS9KSNevxKSPTeLJpBEkEBPg5Y3AFRGGEE89iHwSuCthd8jmj/ZrxNOsF4LVNSP/IEf6MfgVQZRefh1ub49Y8CVewvAxFqqwJ7uV8gkafqDjOXoLQOQpjBfAXqJExjJkL6Ds3OUamesUHj6ar7Es4SBE5x9fmvxeTKvOpEvqKx09XpbiUEO1yhNL0fAJCPqLCId+iw9jv2mtQXOYJcIITy0g6AShA+uQ4RABUGhzHAFWgssJSauSAcLsrAPDnj5+ELbE6oH2iLwkcMDjEUSfYjBHh1QKvpnCcEcjPonM2AZjXIrossBdjS+OWpgsniedYMF/Bi0FEGNHx1WtWApyQSnA5nTl1Fkv+x5Tcxn4U9zuGBc+DlAlZm0AOuv66EvCe1mqF1nPP6iWpBkv+gyNT6eS5PlVdVN8rws9gOrTTAdC58lOJY7KwkMaxwCzsBErQ5Eg/gNk8APMO0VkuA1xRWYRAnNQT6z/aAeHT9Qa4OuTERtqfUdVKADpfJ3ZOSfXpQcS8A/KJlwZQ9RSgS/kAkVCdees8P7VZK2CMzBP0xqURzrdGl9rBazwWCkXBYCQd27BgFPuRDggpPgB79aCxLF55mykY4gD5SIrvar9XA/Nc4ZNt5/ezIZNYjJbzHhFAnfcdnLsSP5ud/NkIjnkdnvUAmbnIDqkrUljJmuOSS/Q1IkpOjI3rgfG3AsRvGlfxQcGRjvbn89CVBLvOYIViDyrErlqzRpFrKtdUszgS1VVCf5xJsDkPpjCAr3nDPuK+zvedT7t2vppOnzokJ6kWY2YazjKL/PD6gwKX7u9cHWL1Zg4OKqiQusKIObfRSiNsM4f21EIOlPdjOqZ0DsZHx3aDw//kT/zEk597q7aUP79xFsB4ws1TlBWqwfG2RIUVRshP3rijlvdctsCtZYGAP1+/UbhgyDMn35xVtA59/S1u+i8ySuUMXVBlUcS8rn6bpOg4wQmgRWQ1YtYGFbqHG+hoknE6nyoo4m+CNyVD4r0LgRDMcoL2hMqI+Rh4t+ayO9IpGIsNBGyEc7x07Q8MzvmJCorgXUcXgPnqjQaLjAQK3PGZZf4cJRdYjahwdpFyMaQCF5PH4QSkVYIi4FAENWg7akoB3GkDgdDAwSWImdtrHV9tKkSkne/mh0Cvh5PakMPhEaUq4kSfsx95+BkROWLtHQrUB3jK5yQaijYhuMiSgY7U577Lu/bxwpXIRi8Bq/xOPUW6hQBfsTnuYx6FzoM/F+hU4jAdFUqoUW7R1TbnAYjye7Ycov+WLJQzoMEBCsx4OnXkoHbKcvaM5rkphmyVANs6c/5W9KhQ4aBTSNoUjLzu7kdSA+QHBfZzu2HzPKbU1gD17g4AOMg0rlu/JrVgiZ5j6BJA6uFDxwBUxgSS8zqLFYvoYHkJQ2CRyJCVTBHl5hGZqLkIgLyuqS4i9fOgAT2XTp7vR8VEzJ3qP0d+yQMnCIz1ILWfibMzUIaZZslzrDbwgmtqbUYyXgMoGU14rU+1AE/syjoANZY3Vx/BvqbU0BZBLwrlHAJzUUYYOZeyiLns1JjegFwNgvXDWBWwXKCj7BnoM4rKB4FiEEoMnOmsk0ajYzGxG5F7RMO9uhLOB6ulEghK9hBjgFHgqTH1VfvCpWnZ2rt9PDmLHuPss6zCZDvlo/r+ke8jAuRxf9GiiUCjV1D4ORM/21ua8GwEMG9IDVT9wZNSgpY7DG45efR0hnnuaIY58r42vxFgrpO55pHBuek3TqDmvZJUkRFEsC+cPZMWL+5R4Si2j4mcLgZU7I/r7Vd20/4up0PHDqcXXn4mjQ5dNJ0Jn9Eh4XldQrJvZ1t7GoTaSmtDrTnrWMHiGXNVpR6fMdnT9quRVCWWVkSxqhCVbz4r0B4cHRn+mQ9/+GN/eIsGnt7KRH8vPkc/c3gyqZMr8wwEshAxeeT70R+FtdW/FydbPomyBb6OBf4uwLwR+/oneI7gQvnsLWjZ6wPzLR9AxLx2G4FjVuYITOQJUEDT4FUTpN46uiV8SZBE4JZPWJOoFUscBSf8mAPHfC8qfw4EaPF8nPnWgqICw56hGcG1QovBYXycurtXgOu63rxyTaCmWRgw8+GIubnleasI88V3GfZqaVmbClUWJmPvkNsQYDpOG74EzyZgRDEyr/2EHUxdyWDVYNgg2WcRgUZRJXzoQhy4EBW3C+LIOptsBRhuezVcF01IZ+zPBSa4iX+sbX0UW6YQrY/zE4CWL0GwRfsxws8f8vcG/YVHgErGrQmsJSmnDjTvXOCaW4T3JuqRoqakqVDPEOCa44UjgeMltMR1lgQpUJo4dnC3Vmd8/qRB2TY8ZjRU7xWF15gCmMXxuZpRiTavBzCvRQVRRcfpPvE8gv8tKxQxoLi6K1cuTwsWduksx1E85ciR42kQEWSPG0eKNRIKK0Y4Q9B1CMS16uIhkuoA6hcsX5Ba2ik9GMoqokdUpuGxmXTsVG8aYyGWUF5h68TrprY3K1UicXZ6HKo2U0igBRBiNFfgGW2sByhvaWtDBLgVgCknPFPthiZB66gCg0g6ARzL3rNBdIRclt2etMA59kdpwjqAe40Z/H7lilWpEyo2vf196SLKwsvq2I7ReCmAsIorDkTgryJTOBw1x6fJncdKAqtecp8NaKeObcNpH5PgLutGgW2l1ENbYntGZbsWr0yLV0HyVMDc9Qj4yNdiBuC+yzjhukBlKby3U0czGuwarHObJlBYOlubRGNpwXsUtRE/n3xoKbMocRY8/ZA+ZCc7Sl4c8ddVWgngntv7VpHzUhCef5tVpXhPZDInnRbZEq+XLvalhd0L1NfUqM8qNW9n/8NQ/jlz9mR6bdeOdOHcSVXs7AaFijrkTihmQSroi6MvOeZoIUor+tpxDgCpKZMYey2ggQ0ODkrrfQZjh9F38s4xAE4MDAx+bOP6+3/3gx/8YHHJqXh3KL+7wRbAmFqGQ9yNJzEGH6zWuRNjZOoGH7q8+7IFbkkLvG1grsnlypX34oUX0Yu4aI7cYmd0fWCOiDmqF24jUKukNB4nqoB0eXlZSZ0EnQyTCmA5ZVFV8Dj/6i9PbJ5EHRkycYJUAPAUzxxJfefOKrpYBNxecg9Irn3khE0BP0VrGKHDsiomlu5FqzCpI/k8Ikl58s7R6kCwfhG84OTuSLaBHgFClkZ07xguGthLDIQbi+uqk9FZaVuB0IhaK8EzzrjgUIRrEoCZjShok8tWHkq0jc5RO/CqgByLAL/8nSLfij7m42frulk6UoAJAwE6T8LXioBJZjFUa7j3wJbuHx0x2lJieQE2ca9LFGiyR8K2ab9McORyCyPI3AsHi98zmg+1NK+gEDPShgKItL1BrlwI/SYiruLDAlwCoBzd84qSLT1u6JHwFcANfxMYylpylqJrqI1NjiydCny/4Z73plqomHhcOjLM5ldAwcdOCEFqJUqfL0nLVyxVZxN8nDxxGuAGeuTZSeHYljMU5yi72nHjGLQaEEFmdepe0plaOlo0PnV+6pOcNFiVRiZm0vHTfWkEVAFSBEhVoMMyg2i3CgkJ/NvBJViuAoCsoTIHbY3PGD3ljhkpZxGhKUTSGc1vbWsVB3nj7ZukknF4/2EU7xoQZaYejsIoIqSziIA2o7jOuvXrwCueSHt3oYASIqgTaAspCW0d7emhBx5KzaDeHDxxPJ07fS6dxWstK4yiLaNQ5qimDB7avfnee1Tt8vXXdur4LGbDQj0EfKvXrlIhpKVLFqPtrDDpa4VGIqifnTUopLNATfBOVDntWbbBMoVxLQqMxxC/KvlTfeExSUNkkK6hRTCu4WRgzlUWqta0IFLe0dqIVQZomIMXXYdzrVFxJiqzmE+e9cizfnl22mJEX5Xw6dEW11vhj+u/yaBc7eQ/0q1E4SL/HZU5YbdZSWHSqZhDQa4h5DUsl0ShgXQxWv/mI3jg0xTjANKvbH8pHTn0uvpC3Pz5c5A7RJVOSnjCeaSCChNcZ+G4MWGT9LbO9i4UixpSYGMY0oiLF3Xr/j2Iir15HZDbSxFm9sq5hvqGnwcW/E8/+qM/yuhs+XGTLYDx1IZDkkfeFYe+gNftGCcuoV1+lC3wTWqBvyswp7D/P8YT2V7p6Vtsye+6wHx1z7Kt1RU12yifVYFJzIonWOZFVInr4wbIeM/ombi6/NOJl/y+iN3Mz+TfjieTYsBocoAxhDaHBvrS0PnjAirLoA5xBRP1lSvgF5++IMUHQcbCJO03nDwVfUcbOhcsBV1grbSjNZHwJ7mNETsmMDOQc9S3EH0m+OUkTsBcSs8ogPegOrDt8gkcu+UxhNXzZCsIxtUAA/wcXROGpjOgyFpIJuI9AY1XBsI5EE0joDF3H/v3CkRIJ7JSMqUK9Z3t54i4PAejGIJUgUCDEyNWpcMGx9iRbStb5Ag/QS7baTBjqBxtcxzY7Yz285tK2pLH4Tac/3VARtvQPoDyOfHoSYPyaorAJpvJyLboLdGhOifsA0WFyBkXFULAnNUux9PRnS+I4kKKD8cZtcGvwAYOdNsG4t8zWqyIH3jsBGjsYRxw/f3vRZS5QftWIRqeA0F9lK9ndHzVypWKPBPEnT1zAaD8TJpmlNhLB2FbtjMisPrYHHw7OODoAuR1LGhOjS1QyGAhJUkL4nsmEOpa8S2D7ZhAPOv4mYtpgBFpRijZv1QrkY69eeHqNYxxyghqpQLtICd/oP+8oqqnQVEgWB4bHtF305HgyMM0QHWEPOExAismgsax1bV0cES1scPI6pq6GvAbXmv87ZYtW9KyZUvTvv0H0p49e+x8xrakWchJwz6aAParQL+ZANjTeMF/7FuCzZ6eBWhfXWoG0H/wkUcVcdeI4r6C+sMxQVrEFfRZW3tHWrh0rQpBlRbU8XD0/aPg3LPn9YX7oxg9t6OWqSweBwTmlVAOaRCNpRU88yYkzdbXQsUk5AWZ8Kmqn1QmUbKsqSLqP44rvldP+1GIWvMjXXO+o2QAnn+n8+X415NULCfEMpHTvHGsHmk1okJ5DHQSeD8bgUpV98Ke4nEKRy6+ycfivnr7Lkhh5ejRAyj+MyznifKaDFSwm+l4cNzRYWpAYaW5y/iQ9DD2CY4/gnFSU41rD+fJ/hyEY9AGigtpUbQlVzeQcHqxuan549PTvZ/+8Id/mfNY+XGTLYA+R4kzRchXxaFRAEQ88lu9uvhNtlT5cN+sFvg7AXMaCRfVg3hZHRfSvlvIcNcF5j01NVsBvrZxadqBb0wzOfhLnEBAzk8Z+eRrAEDXR3f01RQIcm85wRG4mWogqCI+KnfkhCNGcIgO62tRyIKTLX4/DEk6RmsLEx0nSIV5HYEU1QQzT0tzJ0p6d6QKLutjfyr6Md862E4CZUEhibB5OxOuXVmRQIhUA3Nf1GDtWuCWaCBi+XI8CAoZtMVvuFwe0WvBgcKIIAjHpOhQqxMnxX+OJDwdIvOofSy7Cj42qRCGxDmCHcA6omZycDLlRTCXls57sINkx4HtCEoAjs/e4maEzqyo6sRcTtjG7nQ4DL8BHKLGqvqQqhxcGTH6KCS7qgkAFFLIUZTcQHmOthcn3K2qEDfc7RMlRcmCHBsEugbJGjvyCJxIqPUUcoOh+31gx3P6zhjZY5FD0vmB5MvbvkqSxftZ8ti1L+wbbd9w7xboeKPUu+QsCb6sztIK7vfaDWsQWa5Xf/T3D6Qjh48DvJj6od4gkFfS6GwkM+cVewNZEmpmL08gxwEqH63Qd6aiB4ANOduMlrMjnXxpXG5nEPSRVIPkyjFx16eQ7EnFmCpwh9lGlaGnQouG95U0BfrH4b2vSad8BJrpBEkZ3JL+kMEw+5xJjKRBSNaQgE+ydQaV7EdqS1vhxH2ZQSPbRqUPPjgumhob07d/4AP67Z/92eelBmL+NrXAq7EqUBs61+Zim/bk/bGv6xGRXtrTAw36ofT4P/oOKcgUnET+LnIOdD8AKJ8PKlArkk67elYXQLGcrbgiM8ecfzoSXvJd8ModQfe15MA822LgTieM+trtrUj8BC+/EeC0DoWZqC6SqSyksRiYE8x6dUOBBgFzNyTTwvLf0by4en18RcTljPK6sEITwbgoKuhb9Q9+kxNOpbACGgn543R22DGDly6mZuRF5MTb4nF8XnzQiTp26nh65aVn0wj444MD/QD8vn64b44fVtBVkj0eXhWA6gqcJqrUsFInx+g0wPoY8hfaoYg0CmoVizmdv9Cb2tEflp5Nw431lf9xoHL+Lz3140+hFFb5cbMtgD5nR2zC8zY8eaFSTGI3ngdvsSDfzTZN+XhlC1xlgf8/wJxZ09+FJ2d3Rs1vlWXA6wLzBVVVWyvnz9tGCgQBkekMnNCD5MHJUVuaWiHALVTpiDLpBlrq53eMiJoPgg2EArEvz3jW2oh9CKQJWWqCK+h8CJgJJgYADP4nj6OeMMDl/jiX6FiakJz85mieQbkoEQQuArhFQOyiPwGPOTFHpDhzmgXs2HQd0NF1AnNF4UUxyACMYNcqGPNU8MjRSU1yxHkAeorIEdBQF5gRYLUTDgAjmToNRptd9IRNJ9XCTWML7VjoncCDQYqpPQaqchgi0qtoqagePjsq1/ArVt80Pz1sS3vgF9SsjzUBuwZhP567o+JqhqhHEsqT4d2LlnX0PtV76mMCFB4/L4qbgmJFj9hdRBWxuO9xJrYLQAwi5odfJTA3uFC1UfYBtlf8lf0t+3vEEZZJw1w436BxAyLmDfVQEJNzBscPmtCrVq9MXd3QI8cWY2Pj6cjRY+DfjgBk28ZWBYE1oH7ClQG2VWcZTgVjzEykO3jgtdS5qCbdd88DooFYLQMgmzKHeJ/7xGXe82Cj5nldGhqdS5cGh6F4weCjbTYyPGgZu4nR4GRPpAHQvK6A9uFrQkYogGCWPVcSLfYtLXPaIuhOPHeCUtNFsJKjEvaO3BbkOnFcKSUJXDtBOI/3u99zV1q7Zl06ePBgevXV1/Q5VVUMHosAMY9K03yY9ImoP36yYGF3WrVuXXrg0Q9Ew9l6oXe/8vrS6gjcwMvjSGhtT+0Llvu6iXtOtouP5zHtMeMxn+kqBVAu0G4wnkE6700890ZEytspkwh+ORVZ6hGh5iqJkj9VudJ0FslLog2KlvP60qpQEZzr5OM25tW3GJo8dqwE5ci4eOOszkknE08eg2oo4oxT9z6kDq+tzEnnbBCrKR1d3dGn0fM4xsAQxsi50+m5F74MCuAZBRfGkShazf1ilUSFptDuiUmMGbSTQHwUK5H1dfU+JzSX9x86yeOkOFFqE/sg/5/5C8zPmMK20xA3R2LxpyEP+vGnnvpllm4vP/4rWABjfAUOyyg5Igga9siGT7sxNgnOy4+yBcoWKLHA3xmYe3K5chde6PXuwYW16xax6PWBeU3VVsDKbQJjiIBXAOwWgEE0nBuKpSDAyhnTSY6MJFKpgiumFsvwpwrjMNQsgGAA6mCAH4rmCdwRoHu7DJd5bIGwiJhbLYGfOvJqoPr/sfcmUHZd5ZXwqar3atQsWbJka7It27I8Y4Y4QBhsA44hkA50SNOQv0N6rfSf1f+wutf6wyKEkAToMMQEOiFMHRLIyJBAIEDAHbCNHfAkeZBkW540WfNQpRpevVfv33t/33ffradXg2RJpeFe++q9uu/eM3zn3Hv3t88+33HQwF8EQIztVmPphW6TB6mxqEN7aVDUhukjNVGxBLmGwr1y9ia2cwycCkoZ5s3EHpaRX8I/CIiD4Q8wEWyss8UGBP3FD4PlgTDBuSZU6pPFMZBv0XHoFFgsGJYlNPdWBvwjYOEyCrK3DmKNIreCymFwJlnloPOgndc3QsRl7pCDJgFXDQowLWOiOQISaVikG2s/wkE5LczTnRoei8V0xhTe0pho2ZP/EeCg43ClzCd+erfLXtyebDEW0dvAYJONsNDUnEyqQH2wEYt3+YteiWXp5ygM34pVq9Ly1StU7lFMVHz62a1pF6KjKHa9HBeTNMWUZa1Q6o6K8kNWw2CzH9u4Pj2FScsEqtf/zLXpVa+8Sf0ZUYxMLkM5BwEhZSg4Tq38KHX1QP4K5YiyAFHhO0aLMOJ0GCD/yaceTdsf3whWfI8AlJh7lczbM7v7bC6C2H+0HethfT36nfVBtYcAO86BljiTX9jP2gxkW99S/HTvTfyNTPKbfuFNArXf+qdvYyIso6dEeEh3/NS2jUdhxERnOgxN+J//6/+dll54icqqUTCAxApGxjixVWE04XDUa8OpAkekbw6B+Qrv6y750n1seQhoC5g3QLmeR7SvO3mStfAQzonvMULQi7jlWliIwByMeR91+1z5U7HLEcucwFz3g/X7kKI5a5zdM9ZRnRXXZ0hUqppYa8w4RjXASjNdxgHnRFvFSofD1gN5jybeGhvdsl3ocAxiwialJj0AzqzD83t2px/ffUfa9szmdOjwYdxXNfS3Po1c9EE3vw+jLz2YKMpoN5SrsGlHR+uYR4B2g5EIuvsxp4BzEOZB+z+I60qQ/lURrpKTYOksDI/CerXhSl9f92f27Rv4vY9+9NO7c92l+HoKLYA+sBDZMaLbAs+WcpX7cS9Au1ZshQUKC7SywPECc4YzejN20qtfx012OsyebgnMlwGYkzHnm44vCNGYfBE5EApAZACab3a+QfmNoIMvcAPqeFXZZyBYgPwMAIhwMvDs/2e2tpeu0JfAWmzjAIZe2gTzxpgK1ImNtxxsuiLPsRe6gZec9EbsnV6PzCyXl8MhT4sXinEWk24vfuls+d21J1K9uJzH+E9LN4tzLvQfv+RdHCuzYKGKYM6HY1vCUAcFDRs1ziWoEhRx98JYfauIPCIfgeBB7gRrbn2rrtvOQHGAIPvFGGimbPHWLQU3kpeJ9TMm2OYRsLMYsMkukB/A1jHgzoqZK2RLOdncBQOatiiUtSTPGEIovSPQzErXz3xwMBshUWomy7ByW79ydG99BsB68fmr0xXXXZdWr7kEIKdPy9Fv27Yjbd2+UxNQOyhVkR9iDCnlLzY92YC6jRTBEhjyfwJgfOPjD2viYvTDl9/88vT6170ZIMwWA+JmaXl/JNAjUGSKPnIi9tlBHX2SL//5lzGB8scC+tEbw3kar1tWJ3Jgnutl3uahi7ZErD5mL5qdDp05v2TXM0bYbjA/V1/Mdvj/8ssuS2vXrUtbn9uKVSjBI8jOlh77B+UfPMD0CODplHBSKKVGizCB8KY3/jyiikCSAUdkGM5BFaMgI5iUyEgzZMu5HBU10SMA/QuXXJiWrMA8EQJWvw+Cj7bbtOEMNK/8adIlZ8rZs+xRpT5EyQclHixjLwDrHOz8tHCJnYg24uDcGXMy2fIhHaBHbe3TWHHJZJAJRyM4QkApXowIUUtPMG5gF+ENkT5lKhFzPAD5+HSbckH6lL08B6nKYYyiPPro+rRn11bJv0bR9ygnoh1LZQBwGLsGiVIP8iSuPgz2nG2+ZMlSyKX2Kf+hI9CQc1EgpEuHj+3GlTzplPAe4IgBpE/A9PUvYoXe9/3BH3y60CxP1kAn8Tf0LTLjXLFzpWeDpZK1QBAneBZbYYHCApNY4LiAuR7t9Tpjjr4I+1O42e45DazcGphTylLq+ATZS0Ili0BhIFwX1Ml7+sQ9B718kXIxH2F0SSX44uZwO8EahQqGBi0NnEm2KYQTeukfPUye46NdlmKgwVhtA9oCj2K6Df5JRhHgMOOzDZzbIiv25ha4Mq2L140g1F/BygNgAGiGaVMbbbIQ/aDfRKoTDjLah3Q9TNMcA+sgMRpgINkNZ8cJkrwqqqNGDuwkS9dANAG2pRyMpjsyPNPLaKWQmEQgNtrLjnMzEGcNbbKFAHjeJ61sWSFNBmTuhTk9usbZfpMFRfjKxlVeaQfh1jamxfZLlYeBVNOWx1+Wd8TJj7ZRCEWCcnxhrSQ/8t7KBYTM9lZKMtsmPXDLA+Cdt2Rxuub6Fym0ILcdW7eljQ9twLA94jmzVvIVjM0va+SAMfC5SiZ06EyGgAUAbC8iVjw/cFDD/FEnJYjtxle/NL3yVa8DEOvJNMExEiGJl9hsK1e+fN6JsQLqUNr44PrUfxBqAU5+VdxtixFOkEeNuslLjCmnLtjAozsxdCQ4aRPHJacBCJYTjI1a42B8GZFD7JHBxD4AACAASURBVC6XU9eqkZpxoTpqYSKmTYeCAB6MLtMhmL0M4Jxs6lOIzEIwyGsYUcQmpjKCCqMfjmm0QJF3vO/ze1nHzLEZxWgBJzyS4eV8kjaOIECqpEWnUN++OfOxwBBiqLudDIzHyIv3YXektXBQ9t2cjXCW2XM16ZO3KM6hnnqYoRk12REL9BAwYydjzgg6BqBLqYvAXCuA2sRivyH8XmF69sxg+0g/zmgyAO8M9dgLaYwYcdiNIJwa/G7UnQA6vwBQq1GL6EfhgPFz+/PPpzvv/EF6estjUPqMaB4Er90PGcvw8CCiqCxIe/buS3OxwNQcaOYPHerHHIfZ6XD/EYw+DCPKC+cotKfz0f/3HTwkXfvihfMR0hIreapMcHohVyHDjzlEdSw09LcYefntD3/4Txhur9hmwAJod5J1V2JfyycPdpJ269Hup+PaJzNgoSLLwgJTW+CFAHNeext2Lp37Xdx4e6fO7qSeMQEw5+TP9AmpOfQ6JnASbDSJiug3N4MYX9NYB/409tKBk4afPQY1QQYT0GYg0qaEOgwUIrJNLzIBu5hg6MBeL2WDq4TiXLCGz7IOMfQ24VCSBEkkBGnwyYo4GPeXumVlaWUhAZklGTEHtYq5HvDWGfMG4Hb23cFILIwSDF8AboYFVE6OtQ02Gfsuo+oCK0d9jEDM7CwwHQ6RS4JsWN/do6ijbOTQW5UKjXx4HDFK4blktKcBcJv2YNeZHt2AuJ1m4J4pWnwcK2sdba8INAKBtHfw3HE28zbNr5QxahtrCXPQGn2KqYtRDpDNusohArNHMMSuxgmD6jsSSlkqbjY6jQKVzAtt1AfAciU00ucvu0Byn0OYTPfw/Q8g+g/Ar7P/jIcfzLBGKFQzaKidLWd5DoEN3Qc2krr7sLss4vZjO7z4lS9Kt9zyRoAdrr7pWm+xvrjGZUzK0gFnTCyUPppyDjDMBNqmCbeINVp0CfUh+0yNMJvG/ASLbKLRBcYRlzMR9wtBOwA7JzTbbeJgm6MScb+xHnanqc4C9+7KAsDqHidWB3gLYErwd/7ixWJwn9n6XOaYhKwlJn9auWzUhCt7Kn9NfLXJoaOIvkRQTpDIuQNafAigk6Xh0vA9fXOwwNDVWZ2sbd2xRGL8229buuHm2Dn41kRmH8XiMQPm9jsjxHAhJ8Vv93agbck00/EgoKbGulOsP+KYc6EhjtqovcxGHNEx8E45SpmL6kAugoWdAOoZTYWL7zCcYDcm8BozbqNDkwFxPQJYRZWzjvkGB9Kzzz6F+Q6b06OPQNMPZ4VhLPksKpW60wDmQszGpNoKpFSUqwzB2ehCO2lBIrDfneh/g5ivAL8CkYHmI0TiANqxA/MWjmByfB9GCeZgojHi5qO9RwDeK+xbaewb6EG/9aEP/dljUZ7i89RbAO3PoBCUuTLqCh/Km7A/jP7jy+ae+jIVORYWOBMtcNzA3B/Gi/D5OuwMd/RPuAENq83MNiEwB4H3CbLaik4hrQNfuJz0SMBtECY04gaeg7V0uQJfnEydk7xcD92IUGIvUOEKXWcsF7eMNeN3B4LGu/JUXmQvZovMAjCl8vE6TvyLF2IAc15k0UMMeJj0QayvMrOXeDtX7PE8CCIlSyE4JDunF7SBZYunTSbdyt0egmeeLjqXZQko7xp2gW9H5V4npSJkoep4vfBZc7BlhsGPNkw+hjo0uomDeKaVoTCTk2jiq0CBo1al4t/lQMWohLssYYSA3x6W0CA8d3NNCIYFZsXeMp4LAGA4CzwDEiUzrNvfUVSMajAmTkyWs5ECLwmBlEpoZ4g5dNuqvdk+KrPZNGs7Aho5CtZHmGZnZ3e6/Mqr0qo1l4oNHwYbvfnhh9N2sL2SIrlNmY4YV+/D0fmYHo8fAvDZD3BJQB5MZjMwj+PXvnhdesMb3wLwZHG+Te5koND6rjHbAnjUlnv/5idBo5yWiN1NxwR5xzm2ToA7YuEM4Ecx3G4rgnNbNImVUoycLPa1NYePWKhvhDjEHJh8WfQHN96rZOFxbTgRyy+4QFE8yNJy8mHDFg20zLQVz93bVnpz9S27VysVxNNG1I8KpBijjPIi1pzLvDMc3zAmL/ak1Wuvz8puFzdmgKhoul38/vW+YIv0eB9yCYuO2a0lln7wSD8+6QTYfWYOP59e5jR2umxFkzMpPeEnQPFcaLb7oJWfBX06VwmlrQnQ+8CGz8LqsD1kxQXELZJLbMcCyHfv25vuuffOdP+//Qhp2qJHnGi+Z/cu3ctdZPABuin/YQQX1o33fD9W6+T8AU447oFDYFI0c2YPgjlnjHbWhXMYjsAxmYUoLyOIvjIPq8aO1urfx339W+997x/elxW6+HLKLYD2WoxMb8BuQ3opPYf9QfSfIvrNKW+NIsOzwQIvCJjTALgpObFjDXYOV3EJ3ZnaWgLzpeXyL2N4/9MGzyySCd+AzgXpmK3+SfBkL0txwAFgASgFPvGer7kO2hjZAAcGprkJWAkcE+w54HIgYh9a05OvUVcVN65R4QVMDHRSHGOyEr6pLIuQl4SB7Zg1IdM1bMoIMmoYBxQOvgWOOezPYXq1nMCOnUdwTZtQJkCA5cdlE2OjDZj6AkYx0VWIyRg8KwPP0b8Gslgmt01Uwoles7mkL43aCCQKm7EdTNssqAKwXAYDT/vbCEZk5vlaxe1/AV0ri9hxgXAcgQxJv4uO5nlkzl0f7s6GYpIL7ATsJ7vteQig2tiIMbeu4GY6Xkk6P6qfdbb8FwftPOYjDKqG9xcvMHO9CGB8zVVXACiBRQSofmLjY2nLpk0Ci4wZL2dPzWdRSbyp3VYE0mPpMM7dh8mUZOl1qn/mGXJZzMEyv1906fJ065vfjAVr+tR/Qyql7wTpAn0G2uyY4jx6+nYvCFCx92bpsn5cydMkJvGwMdkWsbM7o7ragH8myeIkWCVr9bT2tHJE9I+JgGPmEJv3I1sxhRJsevGq1SrnFjg5nOAoGwgRO9B1u4iBj+ut42hV1xGwukNgahm3nIw5JRqUqFMSwsmf3VhM56K1N6j9GnH7PSm3QKziGU+QWGTIZCtmR0menDHnM4URTo70H8CnTYBlxBLJcBSJhQy5AViy4JSk9CFUZB8+GeOcO6UqlAjpdwB1RjFhSEGmMR29uLV0tDdHDmrpyaefThsQH/6nD92Xnn1mk+yC6CdqW67C2g6b0FmYN3+ugHpltJYWzEb8cVxLrfiRoSrK0YNydyBWPZwcymtQr1lg1FVnxUe35yjj2TMuOln93q7SvehT/9973vdHP8yXq/h+ai2AfsqVOilnvdBzPoDPn6B/zvTo+ak1RJFbYYETbIF4Vx53srg5SZ+9CTvHjb+Bm/LIcSf2wi50FCvMTXqUdFxpaWfHbZ0dpS8Z6xZyB8cUZBr1JrSMxSgrDB/BF08ns8wwbTzBopzYxEhsmhjKF3JIOfiCd/TmQEiJaDOJgXCwMnMwL2/Ao6ko7+AmjQXTlWKWDHSa9xCpBQB1KYPSd86W5zjotjjcVo6QvGgSZAYzcZzAywT1yleEOaPRqOQGcKV6l5SFKMRZNRWSL1Ovozs2SiAulg2sZpl0JbTzYvujzg4idTbBvtnbGoLSjAhsaMxzcJCWtg9ZRChLXMYOIM5WgdppOkbYIfADHPeVLnnctPhatkj14MgK8zQW24Gd0rHzBM55nZw5Q+H6G3UmwGMf6sii0hjQELupNJz1dbafToNGQJDOkmVL01XXXgeN8lw5ZduefiY9uuEhhTPU5s6jT8X09KxgBnTb0hEAXQLyYdeQ24WNLQ/EPUk3cRsY1Z70i7/8JgDzOYq2YRFIMAESrDb/Do2xxdO2+OYmIbH8Fe+ckVoclPN8SlwE+ggic/IVcypybLePAmRhRb2/qlfJsWISlLK0flzF8QbA9BGCbMTHbx+ke97ChbasO6KFbN2+PXMmmAadCLYhsxGjG7cd7wsy+qh7FeByGBNoGZZvjLHaq7bCqVY+BVBnuMSL190AANnjtjBQb3UZ314xspYtLoTyUf+vexx7JmXBZSNg54ePHJQzUwLYJZPcC5BNHXgfQDdCAiJPgF5kNQrddQecs6VYFGnligux6NF8TeglK93KhlMx4+HY8XMY/etr3/hG+vSnP52e2bIFoweDAONYrMnbPhZJsv7uoxXso+gGbJ8uxF0/b8l5mNS5IK1duwZhPDGys+9QWoj47Io9j1CQHJEZBCvOVT8XQca1c/sOxCOfDylP5UH89F5IVr7d3LeLv0+dBfydfxVyvEwPRVtw8CH0o6dOXSmKnAoLnL0WeMHA3F+eK/D5Cuy7cHNieHFGtpbAfEln56u6S+3/EBS1MXgGRE0iTg0tXyKmWbUIGyYtEJzC/2R4uEqjMLmoYw6TC+kLwFpEFn63dzBftI2XHX+xGM08j8DNAqD40L6DUJPQ+ItbL3Gc4XICe1FTRmP6dwFGveztDW7xP3iIZTCgXgOYVR3wj0JE8lKnfwlyI7SfNNHeXGS5Oyg1IXhVOlYOxTkPZ8Jq3QCjRvGZKfRBm4VMJ1wCMvIOTlQBn4Ar3OtShOgy7vioLWzJzSYWnCMXVnX7MIdEIFuAOkY/zKERMI5wfc5o0w7tLIM7MGpJhdG06B8x6bBB9zN9Y8nJWut8B8py1qw4ahc5RG4Cz8B/ZYFjFCDKXgcgnp2uuuGGtOC8RXrD7du7N224/7506CBWpZZNzWGJzm1msvCR6pPQ8A5yYif2EQJ9l3mEHCuuVxoOmlt9Zw3WXnNZuuqqK7E4Fibpoe8xGke7QuIRlMJeBOSst3mtll44XOyrnr7hUO8Qbp/st4hx7/eWtaHF21ZfYzxz6UhyUhrv17Jx6N69HFFPtoMNeLgjlDeY7EJ5it0/V1x2uVbz3PL0lnQQq0vK8HLe+GnOrd1eMQJmLD1v9QqAKSe6DgGQclGlI2BxO8H48nRKWebOX4TQk69V5BxzFFge6xMNYO5+qzWt7jWCfk0GpXMnUE6dPiekMjwlZDOI7IOwJZJ9lClTAfAn483+SPZ8FsD5AqxgunjBPEyWXIT49ueJtY947dHmluPkWwOIIz4+HILHNm5KGzZsSHfedXf68V13pf179xib7eU3x9DvAO9/MdcgcsraybsGPzrA9J+3eEG6cPnS9KKr1qQ5cC4UOx2jYx0Iby3HBfcldPUbAdrf97Hb/9dXraWKbSYsgDZkN+fo+NXYGbqJ3Ad1/Y/ivotVy2aiaEWehQXOKgsEJnvBlcJN+xokshQ7h7JmYgZ2vIrHMeZLSqUbMJT7fTHjAowW8YOTKvWmFZLmsDyBL4CZwJqBDHHZZMwFPi3ShYCvdNsGHHhQP4+zYPxlCM0ikxgz6sEJDQ4L1Pum8rAITMydhOxl7sdxjZg8XGJBWByh6rpwKPAHJ4iR4XMBBSdB0iERwGIJmIVYSmO727UqKDeL2KJSOSg08MXYM27eANgOxk12Ylfn5OdWKUOwmZ1M9kKbOKMp+zUWlAm4atmzGVkSk8qoppLcGK8qmQDBojtIIeWxBYhcpsKyO1BjClZWZ0TdDhZ+z0BRG5luzTuQgUjxWSWki5eIxf07d4Z4Hdsisxft6RF11CaNtlWfY8E9v05Msrv8yivTiosuUm0HEG5v0/oN6flt2z3CT6AeawtuGidQ/6MJMfltrL5zT6Wy1Dl1a0EAudiOZsgbbdUKpFPCtGL1BWn1quWKVU3bUHtchuY9L2cJpyQmYyrShyQRpk3PEJsqbHKWkKPYiqmCq3JgQ38uCRjvP/ZRv8e4widXIQ0nt+HsWr+Pv637GTDkJxlcgtc8GAz5DK+hpvr6a67j4jPpoYceUChCY8rDPh5jXUNHTJJ9AlIqSSsYEWYEeudBsLqDCP+3Bzrubn0fRDi/S9dekd70S/8B8bb7zBbeeHaPMN47nF6CbtyjXLSnCqDPBXzo/LMc/NuWubd123gdo8ewDQjG2Z87MImys6MrLYBU5YpLVqQr1l4MhwAjHZCsELgfba+sS0z5hfkNoQzrH300fe2rX03f+vrX035MNh5CmEiWncx485Z3/jJHMuv8PvrAi/yYHB9vLltcrB1MeW96+Y3Xp+tQl27IW/ZhHgCs9BRWUP7dsY6FX3r/+99/dMZT1qY44URZAO26DGkx/OFcT/NpfJIlHzxReRTpFBYoLGAWOJHAnDOx34idEpJv44Zl3NJTuTUDc9Jj5YXl8uW9pfK9BNjGYBkDq4gshhtsVzQMssMGegwMmlbaJmaZqWySojGrAr6O4eylnq+us24EochMOQvcMWShsdoCywK+jYYI1jskM5GmQQ4DI8KMBKaOy1k3hsjjKnhkuxVHO8bJcZ0WEBXUNVAskES5g48SmNNikgNJUwxD5LwNY2iNzDYzGyQl8LXPKJ+cC9pE0hDGeA6buxTGwbocGtmYLKHVK+K0y4pWSUlLbAKrT+TLiBlzZGQVbw+dJvBMcEp2l1x5g023ZM01CqUNuU6Vw05TPcSZ0mHR6InVW5FccncL8zEZjDsafq2lEQ1j9TCwanZqh5xgNXXkV6zVEvZVgMPHAYKexsqU8gEIxCzeS65f0FEzx1HbWH3jyFjbR7dXhpejlO+3g7YJgArYNkC4SnnU3w383GC62QaIhjGnF+HrII2A81CCPpwMtslbKEkx9lggnE2g2wHXUYNOpyMmD4azxjrlWHxFO9H95CyrfkeNGV7RZuF6zc2S2bLycvDsXonY5VbjRqMobR1qsO3jRhzExKvTaTXQNRevSfsR6eben9xrtrd/5LzxJK0QqvuUbdghnbeAND5HAdKPYOLi0CBCVvpDgGW96tqr0q+869cUZpAhDisAtCOYLEpwPQr99QhCAFagTzdAjnRpN2m9YV8404yKQykHQz224RgXd4q9C47TskXz0nLIQFZduESrvjKGNx2qGMmw+8ifVfkOm+8kub5SQT2273xeK6Nu3LgxPfDgA+nBBx5I27duVRkl7wnbqHkMH6uHu+TPqq+O4McbTpM59tam9syzv6JPZt/RNhetXJLe9pabOaK5vX9g+PcPHil9/jOf+czpsrJ0Cwue/YfQroy69mLs53ttqR8n+UY9ebEVFigscBIscMKAuR695lW/GjtX9frWKR7eygNzYi9pzBekzuWzukuYlGpseWpjbGV7QRNs20WI5uQT2+LlIsZcgJGRUCxigsEtgmkDiU5uZyHb3AYZLDOAFC8hgjOd4bt5BoIAfjwkKQK7EQ/cqSVJJBxsW5LOPgcwymCcMb6GP4icDEQr/jHjlDtylrSEw/MS7ISXkgPm4zobQaiDTZULqcABMEfGVogMm1oZGQHGmWT9FQCO9XIg7PS6RcNxm+jEBrAwh8PxqAC6M94qrxdQ5WJmQgeqSwYeHDjGySZV8r/cOStJ40NnJtqBbesgEMc61NAWYNGi55hzZflbvTOowSIoA4J5c5DMobHCLl2xHHKRqzX5jtjvOWh0Nz38iCYRmire2s5055YWmXwbpWEBx56CfvzjWwdHv2kdIL0VYPDj0VQBysc1nf/RDMxbnZM/Znbn5EJrANXAQZ+BX5Yr2taEDLYZuI02z/8Snqu1tl9hzda4Nrt7GofyjoNyCHu0qESr3yY6/3Wve11aCM35+g3rEdrv0axMXtujUs+5ny3Nx3KuXXdZesev/if0xw7IXYYgdTmiMJecFEpZECfCMozjMH4b6O9P8xcjUszs+akM+RAnOErHDnsoZCR7Gj4R0T1dsWoJmPHVmCyJEQw4d6WYlMs+JhkRB8ms37YC59moFmo5Asfikc2Pp+9857vpu9/+FlbhfBZORr9CSdYQp90iP9nzL8+GZ+3rbWB/+3NBX20Uy7qHOYaNUQ43WebNGVSPJOggL1k8Z89bbnvVh2vti/7nJz/5ydNh0bqW7XwuHETbUapCyQqlK2wozh1jpJVnz4X6F3UsLDCTFgh4c8LKgBuaYZM4KeRZ3MR3nbCEp04oMBeRXgbMsfzYrIXdPVgBTlwbwGlMMTNIZfKIUEjaIyh7AQtVN2INN4pA5OEgLQPwzlCK6TXN9/gXk6EPA458JZkmNkMwepk5dmfxXXKRvbn0eyC/RklMJmBRGkzva78xFzkXGQBimhJdWDqie80mqrE7A8bKMx3WoDF6bM6DgViLveGcs1h3BwRRLGcQDdDJoA1/RHX0irtTodOpvSejqVDkgahZTswJ0KgFZASynjtUGRPXwOhZPZRIAH6b0Nro6PaXMXymS5dcKauDXC+t+mjt5XZlrRUpJrfJmQsbBRCxKpjqmHmNpbkLFqarrr8hzcNkPB7du3tPeuSB+9PAIUYZZT9ppMG/6SRQ8sGTZZuxtAPu5CeeGxr6G8/QNT7pVkyy/LylMR5E5QHVRKA8QFMrhj1fzbP1OyOT3HbbbYoD/v3vfz/t3r07A5L5e5fAl5Ms52GCYk8f5CRokxKODWNy4oEDhxTyL7a1V16WfuWd75ZTw9EDLWYEEC3WG0w4R0zobFUBgJlHR1ev3T8A7CbngWRGt2Y9zUN0kgvPm5fWrF6qVT5L6JQE6pwjEyEPO3IAXSMa7M/U6yMJLle/a9eutHPHjrRj+7b01FNPpU2bHksbH9uUtmPiK9l8ymhiwqYGLHR7NJwm61vNPaDhbun+0Anj77I8IJct/YxIKet71qEPYjTgY69du/bj37z//kIaMYM3HNqKTcXFAzm5k4EdGIOc0dY2os0KOdEMtk2R9bljgZMBzJnmrdjnYf833MynahW2lsCcD5fl3T2P4M1wvhTWZJMJdgQtyUxSF5shZL6V7MUk1hTASxjZQTT7hYNnS8Phn7919P7yl1T2Yhr3vjK2OJhvpkD2XRMwlRgRmT/7XDNukNImgmnxIEE+G15Wtg4uuWCNpDIEj8La9pY1zbVzxQKzoaO3301jTsxurJuxxS4zyN8HAtHU/zo7Lluw5HRsbDQiOpMdxQUi/hn5hueaweId32AlXQJEs2cjBfErM2VUFZPf2LVM1ONfe/myUYkMcBtQyOKly1YmSbJzDVCHg5C/PiQnqp7kPW5KlzqFnMeG6A1w2GTRvHTEYuMzJNzaa65JF1JHjlMGwEo+9tBDaQ+kA2L1Hc/kb0IrkzkicIF2j9bGPvnscOWvcLBilR+3vxQA7Z8ChOfje+ebbqLvx8qiTyfN0/WccUAx1xGXL1+eXvnKV2rRoG9+85vSd7fSSet677/2dTx4jfSvf+mL0lvf/g4bbQBDPgLwqxaFLEUSG0anwT1WATAnKw6kLhmPfefoE+PCV9KalUvT6hWYsoN7qxfL1HNBIPY4xmFnevY3P7vkWIyhfx5GjPBnIUH58T33pnt+eEd69IGHUj8cB581olGzcAgUr52LXUlS5PVRlVw2xWPBeGuhrrhzo4XZFfMTfhsMed5JjIWb8otDMQVPbQjn3o5Jsx/BoUIaMcM3D9oC0jjpyBkGkU30FHay5MXoxQy3TZH9uWWBEw7M9dA1XRr15twoaUGIiZO+BTDnJ6ldacyxly7s6v4HsEyv4JRAeykQqZkcJWhqAk6L383/xxDGy5gtwWSh4GCRrR4NvO2g0Vl3O9c59zwT6nhfjJhAGRnixgvPAB6z8QHejGIy9kvSAgJ0Au+M0fK8WE7JPhrCcMF9B5aGASM/gk2Ca3dQHGBaxApj8fKATR1EBWC4QX5l7G+Ai1gFVJyygWtp8wWILT/ThjO7kJgwsdz5PE+/c2JqtIyFknSoa8Bcf/niUGyH0Purfo5Vs7yZrzwM1dE2YxLF8cdQu1XG2sq9HFOf6yQrZciblIIXg/XTbwbMTZoTEN/ACldMvGTdunTJpZerjUehI9+MeM9PP/GEM/QNpj1GNJS+lxupHhgaq/3p84PDX8QbkaHIaIRmUM5ji5C+HN8AQ3kW3CuffTT/di4B82Zb5P9+yUtektasWZN27tyZ7rjjDusx4a1NdmHutzj/hpfdkN745rcY0Eb/IegmY04wzm7G41xoRyspEKwr4g27DVlz3mNjaR5CBi6YNxexyBF5Bcc7EWKQ90mthgg8iBXOlV8PQB5zYP/+tHvX8xiB2Z1279yedoEFH8bvR7C6phwCu/2ykTiNvtg/dn/yk8Bct0sz8G6quMux/E7wHxv310Rmyo885PofCtf2p6OjQ3+A64qY19PsYyfrNLQRSTTqyLlQELdd2O87Re/tk1WtIt3CAmesBU4KMHegcAk+X4qdQ5ME52T8TubWCpiTWi0v6+7+CF6B/0nMOF5AmhwpQNiGRVjEpRpAEzDy3wjPddilJ4zWwReos87jmVVji7LXVLzU/WU37uXkfDRZc1thkwDPI1WIJSfANRQ/7l2pshmbnk8+WO6G4J0YmvUMHOfRYwhMXSifDXk7x61yC+M3gGnGpBOE6s1tchfTbxs7PsZVRoVNyZqTeTdHw8lFgXfVUPUJT8PqrNGIYOSYvU+4M6cj0pHBbSdAH+NS7m7lBoh1pp2nWTg8q44vACSm3mwtZtKdIZYzAoiweKwRc2LoOoWTjGyjDb0eNuZAMG5tlDUI2x/7spUrxZKT2WRRnwEYfxygnEws4b6NJoTUiKuQWrx49YN6rR+1/Ny2I0Ofxc3CVfOiEfPAfBxIR1vuxj4r2PJWwDwA+GSgPTPcafSF5e3FSpWLFi1AFJRhRAdBHO+chrkPv82BtKQb0UoY0YRRQw4jlOEAIqRMCDS9G+aBN2Uhb3jDG9KcOXPSo5iIu379+gZbPE17RHrXvOTadOsbboUOHKEmwWZrMMknjrIPUNKiyZ6IspIA0NkTGOikHaED+VyqISTi8NARhCkcxCTRIUTp2Zp2PPts2rtjexrYtw/yE/hp6Gec9NmNWOacjMtRN0paDkAaxXCO5jjqNOtZHl0mbJKNCLhvmmf/dV/n7iK7mZqYcfecxznwkzkybnPkW8XXL2D10g8gVcgLi20mLYD2YMCG67BjSE8bhjF28AAAIABJREFUnzn3o123zWS5irwLC5zrFjhpwFzP88aqoHtws3/vJBs7D8wzjTnyLC3r7PzPpVLbhw0IOqtMgC0gaaUSHCQ4FTa115PiK4tujsggOK541xYRhWyTMad2hV54kjy0ZqDs3cXXZi56uJh7WzKH6Zg8wpwEpkOZhIqIvKQf9bJl70EH3PabvYwNJBAR8ADTDSacZ/jCMEb2Wl5ebpOpcNVHOiEWStF+tzSYrqAyr82FkrOzLLswBtMyYtt/08udv7v9HYgr3rGPEtiL3kLrNTaW3bupyuVtSPuwVKqvSXYsg4iR3mDvY51VKcmdRTRfI9BL2NykKwTpoaTPO1yNFS2tdGLhaSfUYf6CBemq665P87AQChMhe7kRshVO8ItNYyFSRwVjbvWFMzBUrY99cdfg8J9ghhVHl/LseCtQzi4R5/wQdntZKyCqPiSbmtPQDKSaj+WMPmNf2SSzsXx8J+QZR8D+cgKiQDcinHAOwiwA8QVzZ6duhAbsmzsLkya5giRY5H4AWXzux2I1FYRLnHRzoJg/pw8Tcm+99VatLHnnnXemZwGG1XvdflMx6PF7H8r+mp+/OV16+VqUdS6it4xhxcp+sNgD6fDhfoRVhOMAAD0MkD6E8IoE0oyJzoWDuGrmEJadH4WsZpSraKLO6s92ZzWeM35fdjBqEb1LLyMnbmrqi5c7LrLIT+7oq8vbQ69JSu458Hc3UPahDO2B4VuQEHkb5h2/7Ls9z/jA+ytU+X0pDT89Y52ryNi6hM24vwL7Ouwkr0iaPYx9M9qtVdMWlissUFjgFFqg8aQ9SZniIXALkj4P+xO46X9ykrLRe8bTNkKysfpneTEWGcLkoq+RSK5ZjDtFGREwd32wPbBwEV52AnuuKbbJjgbaFfvc1NNOXps8JLTLNkwcwFgp6rXET4FfldIgrJa31995/aZVIQD8eKbd4L+9dF3uojI30vWcLA0H+HIBGvhTiTcavRFCUcl4rG4y31YRvovjJR5yDa8/f1M+rlG32mVpM2ShQWebMJkBZyUX5W/oUq3e+e5oboqr+NU4BqRz9hGLTnbbZDlsJLeggwsLa9kGvbYY8wAknk2kp9CXXhkLj5eXCzEBXmAyKE0UJtDxuNd9mEB4+bXXpmXQKjONgUMH0/r770/79uyxcQV3OnQx+krNvBOtOIsyVwDI/3pXZfSPD42O7sEPEwHyZhmLVDm+fxZ98FcDfOftGIu85PvR6QjGves0PhwQNh8vgyGeDTDe3dcloE6pWf/+g4hqgwmMEbHIQepRaU5xgH1v0aJF6ZZbbpGz9d3vfhcTO6eWPbcC7DxWggZ8zrw5CqlY4TL1dOAk6Rp/z+bvmemUeTKWOhza7J71+ymmLGeMubn67M0OuCNnP94CmuUdFEUK8vs17xDKFsYMZFXBM+BrGGl7DybBbp5O/YpzTq4F0F6rkANZcsRFUEfgmiPr0XYne0T75FasSL2wwFlkgVMBzDle+/P+IDjZk0ENOY8H5iXMZFk6v6fnMdOYGzAlD6VNkyZNj2xkAQgEkwrbc0unUb+NLzg+JrlEvIAsicDG9sXAuLGrjUFhgTEyrIEAKQ1h9ARMwMpCNTJlZ7ca8NkYYi3EEmy8iifEaXmMY/WsbMKpAVIEJI0xdW8gIH52nr1QDZ1G1VU5YWE7pjjRQtlR6UaUkiyuOX5ShBgBUreBFtVhQnmnwGwXm7VBtE4gM2P6rBimi7XvxjjrCneEwgUyTBCA3lN3hyOXm2xER6tDGvGsFEqbwFwRYsQy28JAFlKSJrLRBy7kcsmV69JFiIdNKUQF8ak3YXXEZ59+WtnnJxlbedhMlgZBZK1e++uDlert+0ZHd6oy0wflAcjj87+hXf9HK0ZclsicEWsTK0fj+/hWOHf/CoB98cUXp5e97GUKdfitb31LUVWm2prBed4RCnvn2yLSyzPMzedNxdDnz2+VnuQrOfydr0N2mP1U91PcJ7lnmfrJ+L+jDzfIAL/VrFeN71tt6TtwOt8DDdeDU9mv+P3kWwBtthC5MGLaIs9tBz4pW7HQUMVWWKCwwGljgZMOzP2FxNXCXo+dqPZf8DAgO3gytoCNecZcOvMLurvvAT68xLQYfKEQaoFpcwY7QDijtNQoGyEIFptN4Ey2i3+b9jgjlBwAG4BzkOgSmOaXs/1NIO3gNAPTLI+NP1sSFlfcZOam4W4A93AnWD0Dr/IXHLQ3yHMCL54RMcpxJtFlLHTjrW7AOdK3tCgbH/MY5YrXPg7kmnKbYLWdTDUYaiqkbbAav0mmwbwozTE5iia0tiGChEtXGsbLAwKri0N5AXr1G6+lFSrydpCeY/XCndBVMSnV5wrIRiEmz6hxBxxkxr1dDPgbSGd5jfhjyuHMuRwI51y4+qJ0+dVXYVIeNcRjWhyIkzu57Hs4C1YfFchGRxhxw3jTfzo0VPnYnmr1GZrHM2ilJc+DdSaVZ8mj9vy8CX3ve81SllaylZNxw51paTaD4Sh/HgjfcMMN6bLLLkt79+5N3/ve9xqjUsdQ2ekA63zerdpvquyOcgisu2XPogbi9pT0TGhsjR7auN88Ceu72TMp7syQmI2D897LM/fzR6lefU+1Wr17qvIXv598C6BfkRknQ77KcyMQ5wJBnOBZbIUFCguchhY4JcBcz/h6HbG/0muwUwD6PTwYTkaklmZgTjRkE0DLnR9FDOFftZjlzs6K2QykzpeavXiM7TX2Vt88DKHFDDdJSyCjALLtXM7dGXHBWQFvgDqFIUS6IrYdCHv+BH+2GJAx2pKZ5FjxyMVAooNX4msWMs+IBSK3H5A6QwyaYyHAaZSvRU1xC4n5dQY9VvCzyms6WuB+6aeDgZdF/J1sroHp40NvznSo56ZzY0J0AFVFujG7KohgbkVS1Sgb+jbHQOUk+Beb59DWw+dqMqnmBeScpoypC/vaNUxWRadNvbEy/T7T1f9WLrUzGlKgXIMctqqlQQ0bTaH7sfC8xemqF92AlTERdAgZ7EBoOoY/HPLJhjbawabBolQehk7NJMcu/Ut/rfaHu4aHscTn1JM6/ZzJALnKjo0LgfQjb/Zz67tW+IIhDwtN4zMPcmnDm2++OS1ZsiRtRRv/6Ec/mkYKR5+Sl38cTwJTXZ+1s902tsm59y/Z/ZMdPBqre3+JgTzr7zGiIpTv9wE/dHM2MhpXqbafApC/F4D8ZM8lOh5TnnPXoA/z3Xcl9rXY+Z1DPxuwU1Iar69zzi5FhQsLnAkWOGXAnMbAw4ILD3E4jQ8JgvMTPYwWwJyf40Imnlcuv6Wro/Q5vnQizjafTlzXsyrwFrrqWBzI2OlQLQejpbMIzu0dmAHYBsuboUB7qenFJ97UwGBoyh0U24I5NrGysRF4hoNgUpvwBISL8RuviwmKysO0JmL1DdA2rjEmPlh0IXSbWIqzBE1zWascYH4pR6lpYiOvRJrMU8x+aM2dXfaCZeBeb3g6AGDN+W6QOczpyLyZpjsjstepkrSwPQIlm2xFlyumuTcx48+LHfdWykYgxss0wq7ZXABKejSZFZMKcT2mujr48KRdBywnyc/rmzU7rYOOfPEF9C0RLxra44exQNABRMmweQVWVoXEo1sR7c2aj9XvOlyrfej5kREu0jFllBU/ZzqAPP9yJXJ8RZNZsz/zAK+ZmZ3omrPt+HRHEKK/lDG5lHrzefPmaWGee+65Z5zTM5V9joUxnyytqcB5q2uzudK5Z0rjFrdnkm41v2fGpZGFXPX72O7ecH9bXFd/BE7nbyOazD9MZZPi91NjAdzjFyOna7Ez6gq3x7A/gvaeYlb0qSlfkUthgcICk1vglAJzFgUPDS7zy1XFGJ/5u3hYcKnfE7XlgTkRHVlE7bMxAXVOTw9mnRP7hdTCNdNSjPhCPxkDaxCebK/pwp1JohwlooAYvetyknh9Ua5CgGzg1Ah5B/1NtcyIbgetchgU0Ds4L+eMI9SCg1wjrrzpnOrK3sEiQwg+jdMWWxvlIYZ0EC/Q6YDdp3Pa+WokSi/4yTxi4SF7kRNbZiXUSEAueoty9sme+u4jD8LOlrZJghqGGA/KsxKY7QUcDPSqvuHoqB9ZxByrQ0NP38x85tlja3sbB2FOcmzEctvfZnWrQQ3pd3Z2psvWrU2rL7lEUhRGz9iIUHrbFLHDz5ajYq1hTWF1xtcHh0arH9xeqXDC82STOiPqSh6Mh2zFCjTepckD8jDk+/Hld+KP6YLQRiucPd9agk02S85xk1EnAKf58xih5fWvf31ixJanMXfgxz/+cZMDfbTdWuUzEbjOl2GiFmh17VTXtQLmTF8Or9+XEznJ9kCLbhd359ESFnTCJ/Fg/B0A8r9u6p9nT2c6w2qCfsE45CS+GBqK21bsD6APMQxisRUWKCxwhljglANzfym+BJ9rsDPGOcH5iVyG2dBk0wRQ/M145v8bbOa6kHiojYi9xRLjVaMw2PnXl7Oh/Mi9ybR8vEBvTiZBgOasdeNUY53CWzBG2MAhS6gluAXmGs3Al+64eVv4zVXcGTwz/bmDbJYMADmmYdoqnrzC8tGkTIKSbGEdstjuRDhgtuwN/wXbrmOUjchIxpQznXbFJme6dDys/CFHCYBr4DZiihOI46SYBxtamMaMy3Axwjh+62QAF6DYHKQ4YiuNSqdiabPUVjyVZdzCTTK+s+hsL8VwtMLoSr9OTZMDb6vWXApQfkUqA5zXqtX05MaNacumJxC6j6STWYXnKzU5duZAoBs9MjI69tHto8P/2zOaSj8ev+eBeaNB3BpZpo2/899eiT9+mK9D8/fWl53bR6fDRvci6s7rXve6xM8nEJP+Jz+xwFKtwHGzQ5Q/r7l/HY/lp2Lh43e7+xvOu90C40eSxufvz58YmdNcGvcHYyTR71Ic3YoO/wEsdvTnSIPLtRfbDFsAfZErdXLFTq7cyY3hhLhA0O4ZLlqRfWGBwgLHYYEZAeb+wvpZfK7CTm+e4Hz4OMrf6pLAwYTJoTEXa/6qG274Xfz4f/KlKsBag5wBqGoMcZI1LQ8cag3H2sGOjjDEmY4T+BJ4cQIiICpWA6kykgrSoNRD7ytcw//wIcg65n/z3damCYHClQK0XARFW7C/ptFwuYoSyLGvBvgU2zsDsg3WSwyw9NhWxggZGOnZfEsnWOVjeDwT4XIDuzYhlcXxiZ74HmS5wXeJM1gDw6OUqDgotoLSbiahEf5WpYXWVUfrYEhBgDg8imgi9QSdYaMQKA/xtnwJlsvON7Y8cKsDDgflzcyn4rnnKXmm7WVRiMOwfdZzrCyaD4B6Llm2VLKVWbMxxoKykR1/FDryCqJzmG/TAOXBLLKc6BZPj45VP75tZOQbOCnPkPN7q5U7TwQgj1qwfzNgegxdexczMDY5KMsMcVZ8yeqqe2NiMJofSbEuMfGjcDb6AsE5R1Aex0Tf++67ryUwb2XA8SM2jfY4HmNP5UhkeXniuj1z36fMM7OBycfYv3XrmERrFz4+ODY68mn8WITWm9KYJ/8E3Ntc2Zqjz5SIstH4Dn0I/WDLyc+9yKGwQGGBk2WBGQPmgjj1+qvwcQF2ylkYreVEyFrywHycnOVNN79h7fIVK+6qVEdTCUtj17G4B2FlB75zuWsC4CreRGWszlcdw99k0bFTA16ixARLaAdLKpQmptRCKY6BVXXeFIcRY5kMFcBkbaSi66n8pm6boL6GlTYGKyOImc4wiLU0WrFyCLQDwFbHsLBKhY5DFYGuR3X+yIgWogFDTaDP8qD8+B3sLNKoGmOO4koXLoBsEhYe4/uWkWY0IRFl4iRWA9nOhBvvm/1NiC6WXuCXIR45MkAduzPUmgTrEySDZXbnwGC8Xa+oLp5/NgHU0L7LXBsgV45PFlZRkyV1YmM9KNPqZ5MbMykClzvnuaZDt40Lr7iQRl6RFSJbyIh2l4PUkMrMnjM3XXPDi9OCxYvkIOzfuzs9/OBD6eB+kk8RDSfGBHwkgc5Crf4c1he/fevQ0NdwYjMAnwqQN7wNa5HAUbo9jvGm/zrOf3NmgUkZ0mNM+Qw5vdkBaeWQHCtQjv5GrTnBeQkLH23evFngfLJtKnb7WEw6ZVre7zN5myfut1qW1TiQbh5qJr8yJz26nQNzutxj9UNwPD+EZ8wf41fKD4tthi2APsmW4ogzZaGc/M3nzEbs1JE78zPDhSyyLyxQWOC4LTCjwFyvgXr91fhYhp0TQn+AB8vUq3pMXt0A5vwMYE7mnOxC+d3v+rXvdHS0XzcGgCt2lWHsFEscwA1gjS/Bqq+yWcJvXEKbAL0GEFzWapekvqE/xrOxgmN82RFQd4NNEw9fJdMLIF5u16p/zKdEgInjNVzei/OGq8MCnl1d3TgX4BvsvEA1/qkiuksXVkIiICh12IqgYv4A/LWwB5l6SiZA0TLvLizJfWBgACslQs6CA1yim8t2A6ujDCWsjNietm7bgdURsaogQD65r21bt2GJ8yE5IcZGG0Ntsh5jGmUa/MGgKsGmy7DxO9tO7YehCOni+benRzuhfHQ8dBIKJs6dvo1YfOt29kGlONrCI6HQeaB4hyBawAIOgNTyZN/9ugY4D04wJtjGIAmdCBsJiNGRiJTCoklCJKA+Bha0S6EPV118iWpAHTkZ8h3PMcyv9QsD/iakiaEJvBt3Vsaqn9o6PEyNLfUt02XJA4A3f0avPlZAHtcRlBOcn3NbnknOT25tJS2ZyjiTjS4sXrw4vfrVrxY4f+aZZ9Ldd999FNM+mf4767cTFKKVYzFVee0+svupOf3W+fEGzkN2l7v5kybrhPVaP9zb26vVykdx7ERP0p9OtYpzWlgAbcp35YuwIzSUtmewP4g+cCLloIXtCwsUFphBC5wOwJxleBn2i7AT4NyBh8zeF2iTAOcRmSULm/j2t779/5g1Z/YfxsqbHXjJUuJAcM0XLpf/pkaZCXR0dHp0EqBcSVfwgd87yJyzgIrwQaxGaYuxz4yZXQJwrwEZi6gly0yQSlkMX6LIg75AnSgdIJpTEPHyQ772gqUT0A5AzrjgLEcHY4XzXJav3A0wTQYdDgTO6ezpSUMDh/FKxXmMvY0i1MC+V2pIb2Q0DQyPYAnwwXR4cCCNql7UQ9fT4f4Daev2nTaplUCVoJPA16Uv2WubQ9jupNhkVp/MyaXARbrbJNdgogWCHb1rSqWn50sWaVVVoVEtdsTkfJKsgwv+DuvIZqYbMdBg8eQ9JnsmazEnxZQrmiqayQtsQiedGtPTay4Adz+fTcdFgS669NK05op1qQwHporRkyce25ieAhtKJyzqmzkIvEhORvu+aq36J7uHh/8SniSHjqfDkgcz3gqUR1c/XkAe19MreR47V9nVNhnIfIH31ym/fLK6tGKU8wA9bNGq0FOl25zO3Llz00033ZS6u7vTzp0707/+679m/e5YjTLd9mmu32QMeqtOZCNN8UiMCFDxt5fanwW4z4Zwp/xJtTr6Qfyy/1jrVJx/ciyAfkgg/mLs53sObBvGI993cnIsUi0sUFhgpiww48A8QyX1OsM7rcNOjPVDPHBIWR7vFm+doFAzrfnKlSvn3vSamx7Dy6qbqI4nUmpi8zEpgTD2twowXQaIJoAL3bhecASkNttPGzh1Mby2GA9PcEIKTDhX9SSIZ1pa7Acvvw5Q0LyUrDzTK5HZBSonbDd9O4EugCHOL0NiY9AdchcsO15CWQhWLZ46S96ehkeO4Dw4CrhuBECc2vj+IwMA5cNatnxweFB1kEwEZaWEJ/V0Y1GcR9K+fRic8Amr7T7Ji+ERFYOdpSQDL+xukg+y6tKX++TXnORahtFKps5S23dj0H2ua6aTlw7dNwPMFoqRy9STfedIhVT7ytvcBFtZ1CPkiCg3SY6kM7jGmHHPj2m71MUGGWwEIhZMWr58Rbr6uutSL6JtMPWnt2xJDyPaCnXktlqrjRjYWIWR5Mj+MNros/ur1c/iL7JTwZDngXkzSD8VgDx/j3wE9vxvzWDyeG+i0+m6qUBsM1ht1tZPBGbzbLt1m8n9I57PiaCvfe1rE7XnXITojjvugHN97PMgJ6rTZMA7/1u+jkeNDtijyP+xZ5pda/3bfmiAc/R7aPfaP1erjfwefuBqtMV2GlgAbcyVs6/BTukKG4zPHjLkz5wGxSuKUFigsMBJsMBpA8z9pXgpPskKcLsXD5/jncQSbxx+5llzyllK//Ed7/hTyEj+nZhWgjtqwAHCeXKNtDg2yR18pUxOBiULPgpWlSeZvISfAJBi0MG6k3cmM851XpBuBycvApiPgQ2XVpsgHyx6lXpwpMcVM201S+hrwJzXIHXRSpoE6ShTGXkLmPM3gdAadObQxpONx++jkKWQVR6FNp5M/9DwaDp8uD8dqQwpiggXBrJVOqGZ7+5LfdDIdpa6sKon2Xy8ebdtgWTjAdVDyFheB75nEhJ7eRs4tv/oglBGQ7spGotdrPNisySMgY/05AD5cLsO2v+haFFCZLm5d2qUgMCc9rR0lZScosjH4DpTEVsvR8JLogLHpD8H687qz5u/IF33ohdhoSAjlXfv2pUeuO+nsNshOVw2xdX08Za6THME4xP/a2BsjJPeOKT/QgB5JJv/zGx3Ar5cjjSoNT1rtug3k0lEjqWyzWB4IhCcl4G0AvmMc05wvmDBAvSfw+kHP/gBZFDHJsGeDIDn69QMupttkf/bwLhuWrsj9L/N9bDvNqk6W2MGw33480u10fb3YQDouWOxZXHuybUA2pX3M3XkfG/R6edaCCCVfMW1k5t9kXphgcICM2SB0wqY2zulzpBPL8dOnLQRD6EHjsM2US+mEXvENC9jEte1YM7/JZhURluIlyrZ5YicQjDaiRdwvJh5XMFMJJOg9ANgFUwzgTClJWTEDbTzJAL5OnTkZUkjOnF0FOCaOnWCv2GA/C58HwOD3g0d+ygAeRUSFEpRRiqjqae3GwAcz2ICfwDLIWjE58ydDT16NSH6B3IYhfwCk0ihid6/f0DgnZr39nIHpBmdqWf2otTV24NyUZ6Da3CdAWrkD4uMQue+4Z4fQWs+KJbYIbAxy15GTkS1F7y91SmZISI30G2TYrPQhD76kBGOjtcDj4/TuwaKzhqWoJ+jB3CAAMzlEDGajZhul6mIDbct4HngdFo0i0lO/8bPCTEMtfxXXX9dWrFqlVrn8KFD6aH1D6bnob2Xg6TaZdU0fwJzHuAXfKlSG/sUXCAOF+c15K1Y8mDHpapp2vPFbngxx9Gxp3EJl0K/cRrnzfgpU7HgrQo4FZidCMiPA68tWPHm6yLvPKPenAafFT/3cz+Xli5dCqd5JP3whz8Ugz7ZNlX5m6+drD7jftOt2nBYM0ebx8Ozze4gv4/q9a/Uqm3vRVffPOOdoShAZgF/B16HAwwNxe0p7GTJT1TkssLahQUKC5zGFjjtgLkQjC2U8CrsZAo4rHonHkrHumpZsOZ5YB6TQEvvete7vgSm+WaBbby4yIAFyKQuW/IPbPytp7sHwBbRVXiuCqjF5QGYOXHUJmkSnLdjsicnb5aA3ktdJchMxlIvJmVWAMKpWS7h4qomOrZb1BdKN8Cwd4LxrnBCKEG+M+q1UcgqqOXmSxVQj6w8JhuKRR4YGoZ2fCDt3bc/tXeWUy9WpizPngPNeZ8Y9ipAPhlgRmipAuSTbWfZtSQPZDLDmPg5ePBQOjywP+3dtVMMvKrF/4h2A2R7/QVbXZaiSZU4LokNgXmEWeS51nYmhZF0xCQhBvZRN0l6rMsp2opvZN/JknPkQLKXkMAoTJtP4syx2Pn7Kc/Xkz03Bt0kOO2w65rLL0+Xr1un9hyFLR55eH16ctMmjBwYo68INSq7dRfkxn7290O1sT/Cl134PhEgzx+P7zMJyMMsv4Avp+UqjJMB8aOkGF6bE8WUx72sfp4D5ieCkX/pS1+aLr6Yiy1imO/ee7VSaOTXShozUV3z/brV9zyob4wdNc60ESzb4j4b781yBE0rDX8Lt9pvYdL5w1PlWfx+6iyAvjIPuXGBoCWeK+OQMx75Cw2IcOoqUeRUWKCwwAu2wGkJzP3lSbbgNdi5eAJjNP8rHlDHEh0ggDk/Q2ueseZYbpus+feoDSXzyxdWK3ZML1anZsnmSsfMqCsKL4Zd11KbMYYIKd3QKQNgW0BzwmBpzDURFOkTsDMPKTQItqXZBnsO/bhYaoL0zo40AI14DRIYrpJJQEkmnd9HCbSxDwzj/G4sfINMSpCndAD8l8D60wFgXbgThI4xagy+V0Y5GXREE0Kpzag7wGeIyP37d6f+/sMuyTbphw2Hh8466sy3fUNaYuxcAHln60IGozEDX1XTgbKSRJ2phbcY5T7hFOdSIqMILswCdiuFjTy9hkyFxbIyaIGnHPNOuwj8y1loS8vBjl9zzTUYeejVsaeefDI9sv4hjGKYf6fYLyqQ3UNwSBj05h+HavWPQ7DEIf3pTOo8nQB5/mHAUSYybqft1gqk5++/fMHHjbawrUIqdRJqd6yMtvXZtnQ5HMDrMG+BG8MpPvDAA0fr1d3hnU6xWzoxPvyUd0azB7j5mXYPRafOP92F2tvvwtPn/8E9MHmsx+kUsDjnhFkA/ZkhD9l5GACBDcW1PbhiJ1fuLLbCAoUFzjELnLbAnO2ABxYZ81djpyiYs6vInB/LpNA8ax5ac4Jzac3f8Y53/CWiK4g15xYAneELyaDzOIExteOUqVAuAv2IoovwP2rAu8HKjiImOZMol6AdJ9Dnd4FTTNgsQQojEI6/cNIofmTEFcYV7war3s546vUKAD1/pzwFzDxeopKxUMVO7XtnN4QrOK/UK8ZdCx9R7cEY5wzDCKBdAUsuIM5Fk3C8Ar0rj5Mdb88W1rFwihab3dTUNeTdf2B/GkDIRQJYRSHRPEvXhducy4Dapl/l24OOB8l8Q/GuIbcoLsY8x+YSFJwbYL5xvp1T9omzGtogo+fSmWi8vPZIkS2UAAAgAElEQVQjwHgwkcqNTLlKUU+LoB+njnz+goVKe8f2bemh+x/AhNh+TzUrmPwMxJWHz9T2nUqt/hGME3NOA5OabEJnHow3y1bMGI3tZMtWclmN+3rasuYTFTh/vBWL3UpXPRG4n04e0zlnIpA+Ub7Lli1Lr3jFK/TM2L17t6QtDUfQcjyWB+7RDDkJADq3lkpDSu6pRuKZJ+u1rLfdi279XpAQP5hOvYtzTo0F0Kf5yLsCO4Me8L1E1oA6cko4Z+rZcWoqX+RSWKCwwIQWOJb3xIyZEQ+wn0HmZBO4cRGF9dMsTJ41P2oSKCZvXXvRRRdlrHl+kpeio3BSKCdbSgZi8cp7EPeai/xUsHAQmXNGbmFUFb4xxS2D2S4B1A9DDhNhF2Oy6BAXFSJzjigqDHvYCW05mXEuMlTBgkLGrOPp7OB8EOz7WL2UurD4Ta2rT+w8wbPFBzcmnC9+asRHEIWlCodiGICcMpFahZNIqxaHnO9zhiJ0xi1G8rUSJmOiI98jkMYcOnRYkVzoQIh1k9wj1BkE4/kFgyDloUY+Qwc2YVZMe8hVBP0dyJt1bMKnQLptFpjSADn15BaPxXWxsipHKIy9b8Q2N4dAshnaHfYgM371ddenC1dcqPSoI38QgHzPruc96k4jn+g7qP+/DtfqH0bYQ06YnM6kzgDipysgz98Wpz1rni/sZFKWVkx6/l49Hpa7+flxrGnknYf8tVyIiLHOexDK9MiRI+nOO+/EqNT4qIMTSXqmLavhzaBbM+Z72E2eOS+asSGJ1npMAv/t2sjIN6f5vCxOO0UWQFutQlZkyXs9yyfYXugDXM+j2AoLFBY4hy1wRgBztg8eZGQWYnieM6x+iIfYVJNhGvivMQk0i2mONEpve9vbPgPW/E3MgyC3q6vLgLgvOUmgSnBK4Fgjky6tNCZxgukeA8PNKCJkykcRW1yRWMBgYwGjNDB4BBQI2G78Rnw7PDQCQE65yWAqQ3ZCdhv0NhhyyE4cZFNWw3jjBNwjBMjUrAuAEohjMinyA+pX2MQ6fqugvMw7lQGAMdGUiFwLGrnGWy9nhoJE3fjSp1ymXeEfwRTjesPcDKBuq5GSse8/dBDSGoB9vtr9xW8A2MIaSkrCrGQfpm224SaZDkO+8E9JfQzUG6A3rbjsqHCPalStuqpNE1Bt2qZgBYEHPqkVzw3O6xpx/boe5oBjdMWVV6ZLLrtMOvWRyjAkKxsgXQH5rbIGfWjp8TKMFvwbFlf6H4ihcb8qcTRL3syayxy+NzwVS/J0YMjNhuO3U8qaTwQ2WxUsjrUCw8cDuI8l72MF4PmyZnrxnKSkVf34DGHEFoJ0OvfrEYpz48YpguV4f86nlwH1+C2IcfN/vTeHkxuPOp28GRGhfgfPqb9r6p+TNUfx2ymwAPoQh/KoI1/k2XHtgZ+irY9FpnkKSlpkUVigsMBMWeCMAeY0kE8K/Vl8JcuA5TLT3dOQtgRrHpNAgzmXnOXKK69cevXVV98N6Qq17ALns/tmKS4x378jYKAZ0aQHYJpMuSKYQC4CWbex6NURLDbSqxU/CdwJXBmtRfG1uXgQcO8wJnKOYa9xYia03oRylLIw/CKlHxWA8SF8H2X0FE7aJGB1tpl5MapL4gJCYLY7wMaLcafCnJIYJobPIbDrKiMnpBLUgoXXxExcYyCa9iMghshGE8BQJmpucIyriI4CjDME4yiA7QjDLfK4U+siwqXHjsmcxqRrYqcz1jZp1MEv00e5DXx716ZdwmHQhc6kK01KYIgzLKqNQiOqwCaKEUCXphzfXUZEtn/VRRenq6+9LnUCCHHBqMc3bU6PPvKwJrrqGrLsXCGVhCKdlrG29dW26keHa+lH+HmqSZ02DGLn5T+9ZKctIM8/S+7AH68+FQ+XiUC2dZK872KlmQggnyj9eDNYny4gn+q8rDs3GbU5P47icI4Dtef8bRdCc96FlUI5smUGyP7x7kU7saPGfdG4dwTC3av0yPre+cyRzR17Br31A5g78hf4oVia/VR0/GnmgX7NdxaJpVV+CYH4/dN4f00zh+K0wgKFBc4WC5xRwFyIqF4nsOaSxFxwgdvj/oCz8BpHb1HHAOb8JE2bRWj5hTe+8dfmzJ37B5wwKUaZoBP/dXa2AZiD6UZEFDK9YsbxYiXnzDCKQNZpEHHDhwdHAA7LAtNVaMUZtpChDBnWsIpVO9vISAOhVyxUigAmmXHKUqg5J+zkvwTkBJhiiAHuybZRa67l5H3FUbH3CO/CKDDcyggFOArQTxGIJj/ifFWYTgRnmSrgOD6oKffg41rwiJFaGL0F6TGc4hgYf8U/52JG/JtkO50Ql6q4SsUYZwfLwgssDyd0MqwhzldkG2rY8Z9AjmXPM00W5ICeQDtWHG2cowTHCXED01kjGnA5b/GSdP2Lb8ACL3Pl/mzd+lxa/+D96Uj/gEliqIlXgYl1VK7NqM/HsDLHd1X8iVny/G9nMiCPu4Dyr03sJhPcGyfk8ESyjubEm3Xi8ftEYDxjqNnyzlI3pzkVkD6WCubTmqisU5W5WUS+cOGi9PKX/2zqg7PPkIp333WXQLpw9lE+S4jAeA84Gs/uHw6I8XdbBdeHpdwJb9+Jn34fzwEufnWs0auOxUTFucdoAX9fXYnL1mLnO4eE0gbsj6O/He2xHmP6xemFBQoLnH0WOOOAee7FuBTfqT3vwX4Q+4/xoJsorNRErHk2EfRXfvnt3wFrfjXQqumZyfgCDJvOnNDZJCtkvm3hGzLjFp5veLBfkz/Jgg+DueaKHdR3E4zzFUoWnkDcgK5hzwgDOAqmnRFVmM8IwDEjt4gppuSDldWjm8x6Q9Ah6YgH67ZFhFheAHIW1IomYG6SEnvHc6IoDwmIs444bhFcUE4yzMxWBQNAV1mtbqEht+jsxl7zPOrcM9mBR60xZtt+J8vnJLgx7Rk898CEQQ46OFE+XqcANwT4ykMTVhGeZ87sdC105MsuvEDd4OCBA+m+n/407duzx7qFU4vmLKjyz1Tq9Y8PjaV/xB/NoLs56kr+97BiOHvxd9b9zqBHwe+irO87GeVtJSGZDCg3g9088Gb5jgdkT3XNdJjzViB8UmDut1nAqnGAPmdo90slsbr22mvTZZBbcdsEWcuGDRuy9RIizGGUNYNrMcnT7y/Lx0a/1N3r9X24Oz48Vh35n/jz2FY3OhkdokhznAXQPoyhSZacUVfU9Ng3oB0L56noK4UFCgtMaIEzFpj7i4nAmiuFkhkkeHoSOxdiaH7w5Vlzfs9HaFEIRURTuOqSVSu/W69WOxiFhTIPLnjDKCtaOAgvRwJaaFyk22bYvxKAcP+RITHOjB0+BEZsENIXRlWhGKUGplxyF0lbKA0xTXkbGHC9hA1R4xPFwUu4CjkLJ4eaotvkFzXJTfiH6F+TyohUpqtABwBAt31Uf4Nfl3a9xNVC6VjYy1uNL3mHdOVWDjLygOA6LgZd9DKBMCeYor74k4IQk4m7ZMbYZwFt1itYbB4j3BYbztNdshKAxYQ9cdzSU9UjDWcFVU3K6VUO67P86ISuft3VV6dL1qxRVJkhLKr0yEPrES96i8tgTGLjhqIpd1TGap84MpaoseXQwnRBeebWeGJnMiA3AxooeAx7TJ6O49P+nEx2wkTyjHn+7+YMWgH5/DlTgejJwPILkcaMS9eZ+fyDMX7PmH27OcPDzu4xlaFJphX24D0d7Hlvb18awuRwhlR8DqM9vMYGinKIPwqgwB25TdnWD+P8j2FV4Y/jF4bWK7bTyAJoH67DQR35fC/WNnwy/CHD/hZbYYHCAoUFJrXAGQ3Mo2Z4EJ6P7y/D3oeds9oJzhn6rumVZngXO4F5SFoitnnpl9/y736r3F7/r4LRzooDjQssM2LKGDTkXeWuNFwZgFYUIQkxSbMClpurdo64NIUTNWNilqKsxNCzM9QEjx0AmhaWEPkofrchU0pbxEZLREFdORwDsmZ0DjSMjQmnDLcIcMoKtCHuOWOcsyYWO93kKEyLjDYnWXbgO6OstHPxIqZJR4AwPNjyKAdLShgqrbgjZUV68LgqWDhJunaH48aMGw5hDHHh6Bh+J7vu4NsQtlH3xrqb4XkkIrbYeDwndIZa1mQ0dH4uvuSStO6qq1MXRhVYt82bN6VNjzzqunvLMwNOY/V9uOqPB8bGvqjkpxeLXLW2Rjhqz7rYpHfR6f/jq1FE6s2ntTWD3KlkHdNKNHdSxgxPIE8Zd9Pm2rf5eHO+eUmM+3XNypKjiqremYFg+/koBjy8xLg666fWp82RtByza3mO7llNNrY88A/vy6vQny+//DLJvp6HrOWnGPXp70c4T9526IntuhF97kU4qPY5iGQ+Wa1WPozvHCUsttPIAugDnKd0PXauXs3tEPafoE9woaBiKyxQWKCwwLQscFYAc9bUtXxX4Sujt7BejFF2b07eEnXlZ+jNQ2suSQs0MeVbXv2ar/X1dr+EEzMVmWUMi/MgzCHDgBwBUztWwUsYGm9GNRlGyETqyMkwjwEstwMoix3GC7hKdlsL/AAsI0dGaNGqlmDhCaapwcZalyy5H6fcxNhxvsjFynMBI4Yk5HUSVRibzjT4omf0lyqivIzVyJYDvHscctO9cFVSF5+QHaeOhX8raoox34yHTkwqTI80pV3l/1p91ME1S8hLJNy2SZUNsG19rEo9u74ZwI5FgAyO2z+hCTH23H4xUGTNYowhzUyQ05bOX3Z+uub666EjxzpT+Pu5Z59JGx58IA0NwxERgpF74fmmg3BC/qx/LH0BSXBIfzqg/FwA5NZAtn0S+2+qlXKAeDJ5SSuAzmPNwLpVGq3yiIJMxG5PxZjnK9Oc1jhQngPSrdLMn9sqTeuPEZs/xmGazgxw3gTaPX6Rndz0dJU0y3p9mj9/XvqZn7kxLZg/Xw70po2b0sOYuFzDc8W2nGtRx0OovfRnWA349/FDAfImarQZOo6+wvfH1dipVeK7hTN8GfqQI7jFVligsEBhgWOywFkDzKPWeEjOxXey5xGO6il/SGLuX8aYBzg/Krb5mgsuWHrFxRf/sNzVNWdoYBAAHO9EgFTqrgfwNxcPoUClIkBOwEqRCkGtRVgRaKQsRVFRTK7CiZF6T2MSKZntsTY7l/iIMo0qJp2KLZeOwyZv2iRMeAoAzFxkqIZ3M4G8gSCiWIJhrjxqDDlBKgE2pDguQ2XccC+fALhNODVpijHzWi1T3oJNNFUq/M3LLgDP40ZvZzITlY/l5zvIQyJyVVKLRU5gnmOxHbhI0sOsshVFbbJrsOyBb+YvWJDWIZrFkvM5CFJPe/fuS+vvuy/tO7BPAF0NF/nU6wO1trYvHK5WP4PDjHIQkpXJFgg61wB53Bqd+PJvAAvXNj8hWgHVyYDuiWbU80B/OqA5X/6JyqL7bRIHpDkN3VeZJ5n7NdJoYsQNXh+9BZwOLVY4LdmZTRdddulazJu4BvKzEiRaw9Cer09PbnnKJVq8udMXEWXld/C5vUV2xaEZtgDal5M6uUBQ6Mi5QBDX2iii4sxw2xTZFxY4Uy1w1gHzaAg8MBm1hRNvSEsTsG3Ztm3bw8uXLyebkWfNj9KbX3fppTfP6e39CzLKnLhJAMv43KN8OQP9dkBWQfQr3bbk7JCmCKhSa00AK2rcmHShZsZMoQyFQBjAFdp0Lk7kEDvVGWZRkU1YehQVALTU2ZEqYIcJ5m31UeZFRpqAHP+BWaOm3CKiGMtG0C+5CPIgC8e0PEygzpFGnqydS1VUOpfsULHOFC0PXEcUbUfcXI145Ba3PIMgpi0nK+7lEKuKM1h/K4eqFAFiDHTooP3Dj3lz56Z1116Tli6ziZ1cnGX9Qw+l7c89l6Wr8I/Glg8j1b8cqtU+Bf6cE37zGvJWoDzAeCvJSlaScZVSKc66bRVqxIgQsydirZtrnAfKAaBbSVvy4DobBZFlrZ80g+TJ/s6f3wzUszJkIy/H10bNTHqWSg7M5x+OeblKPsesrjg5+v04Er3pCav7JBtfMlFXLxbHeslLXpyWLV2mpAcG+qE93/rNxzdv+n8PHz5csK7H18Qn7Sr0BTbcJdgZbYXBB7g9i50SyiMnLeMi4cIChQXOCQuctcDcMEGdCJrSFg4xcrgR6+iMPnnfffc9euONNzJsVUhajgLn61au/O22jtJvEFgwzF8Z4RCHEOtbS8ZzcqQDYi5wMwzGmwxyuQxGXOw4p1XapC3p04lNuLgP9ef6j7+SVbaQhcQCCrxA/TjPI0gmgMchTeoEG09VuU/BdIac0hSekMk5DGSTwceulUvJnquFDdByASGttMlz4jpeorjfdpygnaw5pTMOqZWfQizzHMfkgV/0p8CyTRaVT4IfRz0spJyPYCP53YosZ4WHKVW5Cgz5suUXKmlOnt342KNpyxNPSgdPsKPQizbqUIET8LcA5LfDHWIolokAef54fM/8IC+Guojf5Q0v4+y/7d8Cm34tX82GnGi8GSaSgbQyUTPQny7wZ1pZPlnfmuSxNIGE5Kgy5Z1H+cYRF8jONP8T94FGihxUe6emI2yr2Lo97Naw+yPHrAuIo8NLouLAPMKFNiQtjXytVnoYZFIZ3b2e9qJFC9NNN9/049/4L//lH2982cvIkHMUiFE8CPqKbYYtgLZnE3ISNSWTnM/EbQd2ylbGL+86w2Utsi8sUFjgzLXAWQ3Mo1nwQOUwYwD0DshSxhBTePMdd9yx6Y1vfCMp7zwwj5VBO9euvOjT5VL7z1NKQpBbJSDnS1Uvcn/Zk4UGCFZEFa7CyVCJOI+TvARkIUWp1QGIS/AROPHSo6wwMoqChevFzEWB+NJnXHFiXwADhCNmXiZSoWTFYoNTMsNLCPj5RYBeKMMAOSd7MiILI7OMQobDstEzsNCLtoqp4QCuAspzPU+/PhhsAQucqEmenn4Gqh2gqwhI23A58xjTwkvMXyt3ChA1QE0V323dUQPkl6+7Mq1ctVJ/DyM+/OMII/fEk4+j3Baj3dwSOS0s/tex8NHHISBnhINm4D2d0IcBzGUJz+BcAuTZUwrgUXrzYKNbMeDZyU1fWjHNU4LwrBN4q7oUacrrcnnnwXtMuIyf8wy9Y/vGhM44KVo6+mMAYutm8Y86q9LLHTM7NXC6kozzcpeas+nXZz3LHPRIQ6e7c5/J0szb/RdMSXkPgqveh+PUcVGzfJ4Xn5MIKY94ZqJ2KY6fXAugTRj6MA/Id+LvhwpAfnLtXqReWOBctMA5Acyzd7MB9HUAo2TQtfL7oUOHnrnnnns23nbbbZS4NDPnnWtXrP58R6n9ZslLuMCQQgmaRltLzTNSiUAuALjCKAJUU6MtsGowgZ+YnylQypU4pfGm9AUyFQRGd5ad5/G4venJWpOpJ1iXPAXSkjpQdw1xz5GVLRiksIwWpYVhEonzSwDiZKtZRmaviaSUtrCyVMN7+u2diOgCZ0ITRo2TtmAsHpVFUVVIf8tRsI1A22GGyWVwDOuISmuvsqM8HYooAT27x14OPp82qiGDJUvOT5etXesacoTQQYjJzQDkT27ebAsqBWYOtN/W9u3havUP0TgEJc2TOicC5CxEs2xFVYiqnIs3e67ObMa/Baj4pbwdpgOU8+z6UecHmA2m2RMPUN3y/GCzc9c0M/j560JSEscaINpbN3uiBT/dYL4F6ANzR2eQt9mwQsuyZr2m4cdJjsL7wVl2RhDK2G+x+jYipLsu5p7ouI+E4Tmha9va7sWqwf+9Wh2+q7lPtgDoDI24EfuTKGfMEj3Hu/LJqz7sTxkkJZGXYw/JyvP4ToZ878nLuUi5sEBhgXPZAucUMI+GxgO3G5KWtfi8DA/YMoB6GzTN28mgv+1tbyM7lYVQxHeA81Wf6+jsvZkItA3AkyCUQFPvXbDhAuh4TXKSKJeMH4P+m8c4QZNsuA1/AwRLi06Cnjpwl6IwDbxjBchN4+GhGm0ypVhrXo/JYTXGS8d3xlfPXvHSv1OyYuWhltwxsY7HRElj3vEf2GzJcZAn+Wieo+tYbsUzt02sPcuvSaoeR8VBOiUmPBEuBRh6nzBKjCGbmJyFk0ENnhiLeOHKlemyK9amufPmKf3B4aG06bHH0lOQrNA5kCmxa/VTE+L+AGEePwLBJoHIdCZ1BhCfDJBHNufyPR91pxP6NwTnE+m440S1f8Yis+kbk3vzhjwWYN/cAM1gfNzvIUvJjW+MK3PQ2ey8udEdOZUOnDOfzIG4WOsc691q9ED3grqiZRwSrLxKRrKxyMPDI9pzoTHfoyE2s3vE/PX6AwiV+t7ayMg/T9UZHaBzgiGZdG4MCbuZO+pBSV6xnUAL8P2A5DjCSlDOdwG3rdgfKwD5CTR0kVRhgcICLS1wTgLzsAS05mWsxndpZ2fn5WBr+wDW2xFPeN/69eu33HrrrRyqjHCKXetWXfrZjo62mxEhAe9UKL45IZNcOIEwV9IUsCUwNUBtcbgtqkkbwHkb2O6YaEkGrQNAmysykwE3Qbcx1LY6aAOBcCEgAnGGJKSchcCci+xIfy08i/wpg5GmG38qsAsgNyM9UjYjlM5S2UaQYYFUcI4IccY3N1kN07MJoHQG6Fg0Io2HzSjQYZ0kXSGIFrMtsY3S5rUCObig3NmVVq1endZgxcPuPpNkHj54EBryx9IzzyDyRPDvDm4Mr9R/PFyvf3iwVluv4k6PJZ+KIWfWOVhXPA3cAgTn1Ju/iX9nANx/HMdKW9sI+OYfGuMBslLJTG3Oo22GXU0PkpeejJOE+LnNjoKu5JwJRRfKgW0viIoV1zqTHQ2eAfMmFt8K5P03uoPuH5aa7DeHgQzFRx/P95qsXjm75e9badSj7kizA6Nj0p/X02MYqXpfrVah3Y+pTyJ9RpwiYKTOmRsNwvUani4AY751ju877EvpECUr3GN7HF82wr7FQk7HZ9biqsIChQWO0QLnNDDXWxfbW9/61vZPfepTK3t6eshKLSRAr1Qq1R07dmz7yle+su1DH/oQV2zrvHz1pZ8utdVf386Ff6TX5uVgnIVNAWktfiJAM4fMjTE2ftGACb9x0SGy6Zr8SdAsMM5SNLStBOC83gXkGdClVIYbl/jmaqPGXHLyqE9AY9QXTlxjgpKFkD3HsRxAovabiyaZWt7AvMYAAt0ItOfwggCMsfCS4oiRF70vVCHW0QG6aeoTIqtcmFZevDqdjygTGkXAic/v3CkN+W4sqGKBHg2VBPuKbDZUxuq/N1Cr/UQZtgbleSlLHowHS26GHA94jgn8HOP9c1acjv7zVey/OI7xDobcHcboYyH1GFfxAOtSZoxn060rWRNkk4f1h40GxRYMts4dj3qzczTJ0p2+/HXxXTIX3kf8TyNIllbG9vO7L3Mv59I6f74QWa+08lo5G76Gg3m/D61S4x2VPPOvsio/3p/paeDy38Gz5S9faKdBupRVUF5BRpdyC26MBvIs9udQBsQWLbbpWMBtSSBOZweLJmjjiAQB+aZiRGI6VizOKSxQWOBEWuBcB+Z6tbpB+dn+0EMPLVm8ePHFYNFXV6vVMkE6QpYdefTRR7fdfvvt2w5s3/V7YKzfbhFUbIKncHB11IfGkYqDVVu+3nJANHJNiAwG2zADBSM4RCIxD16YhAN1ixrhQFZabpvwybTJ2dv/YK/FYpPiD8CskxVPfZxMwPWuvMY07ITnHoLRAXkwf170LN54hxh7W5GT5yiWizTpCQulLEgrVq9OK1atAlPeqWpTP/7MU1vSli1bUv/hfjkI0pALwKlarMtjlbGxj4Eh/z5Nkdsnm9DZLFthExaA/PifDCBz27+My3/5KDmKg22TMzVJWAy5xv8ZyHUVdXZjHVUs9vcAyc5K84DmaOj2cQCOPI1ltpEY/qZ1BOgA82blsFDOiTSW2iUkOfCcMf90EnmdOw82n8Juf8mzIk0vg0B3SGME4M0R1je/jveCVabhZIYzoogtqb4d8pXfw3Pk87gsZjUff0vlroRdOKK3EjtD98W6DTyjAOmTWBh242P3QrdbyIN4xS7sT6FtnzohDVQkUligsEBhgeOwQAHMzWjjwDnfz7fcckv5Ax/4wEqCdICBpQDpHdjb9uzZc+gLf/pnr9v82KP/8fAhrIrNpe6pL9cL3GKFC7I6AOYLXKSZFtZxdtxXt/RXvYEDZ+50DtlyDNuPmS5Ei/LUIV+xhYH4YSy9IHmAFJxKWBOTR0cZCYbD8vINDIBQCiBEK8fBFvupQ0fehhEAxSL3VUoJoAWiGUVGaRhQYpaBxQhPzj9vSVpy4TIw40tT36xZSpOLGO3ctg1SlafFktPpYKQYlk1OSKTTlraM1tMfHR4d/SYPN+1TRVkpGPLjuNmnuKQN/fyP0f+0OmhsxjYbIA/wOu636E8EseijPhuhAYDZd9RVrQ+Oe+A4ex3g2ru0hTD08ynbkvOpjp+TniAtRj6Ku3c88c37wCZdRn/VKr7svxlj7n6cX2gfUUa778xBaBzncJA5lFEOG+WSg5CBeAf/7e17UIYPjYwM/QmuIAN7UjeUlVoxAvTV2COUH/PkpHaGXuS+E+U9oc7BSa3UCUzcmXGCcS6UQDDOxxE3hqR8GvsW2IarBhdbYYHCAoUFZtQCBTBvmD8I4vjMYpy/+93vnvWOd7zjokWLFq0ql8sLANDb7/7hj258+MH1/37v3t1tO3fsSnue3wksbRM7DVTE4j42UZR6ck0SdaAu+TdObafkJEAIwbVNfFTEFMplSh1ll30wOgvipDNGug/Bl8BM1xBmUBNCEdJRcdEZvhAa8zbo1gmJtOImAQp2E9cIvrtOHL/yPBSE5ZNOneeTTRcwx7kMAcP08XdXT3dasmxZWgwgzpU5pbN3tnDv7t3pKaxYuGPrVoQ79AmuHiudVWLODPEIrfw2TAy9vb869lVkRZAwXZY8GPGQy8ff0YJ5bDajN9WZnHl7qf230F8/yDoIaDsoDnAt5lw6bGeayUZkwd0AABNFSURBVFA7ayzHLXMyDZAzTn9oxsV6h3cXgDauyRtNUi4/wNvBR33k7Pr5WkeA/c9j3ZuExYG6er6B5hryJ+DW4lS5vGL+R+YQs05yQHi6ydJYbuXDuKK0A3+i5+vMfF4L384J2dLBjx3EZPKPYt7JH+F0rjZ8yjeUawkypTSDQJRrOeQ3RhVh7O0dqC8nup+1m2vGaQOu3GSzzm2js8KwqwTjRXSVs7YHFBUrLHBmWqAA5uPbLUA5jwYw52eEUewAkz7rne985wXLli27YNuzz/7cpkc2vWt0tDKH4KH/8KF0YP/+dGDf3nRw3z6sXsnnP4A3wEMnY5xrZiagNXOR0oSg3ZGKWsJlKoQAAAZScuN4CQCkitVBR0aRTpnsNpnnGhhDgAnFETcQzpQQhM0AkfPbio1OYK4ZnQQ5BtIZupBl0QJIYLnbCewJoiIdgLLZc+elhVj05LxFi9JcSFV6MIEzIlAMDQ2m3TufT1u3b0u7n38+wVkRg0mZAccMSEwyC8WPIeAZG9tVbat/cl+l+tcoHiNJTIclt6o4Jmr6jJYrAPkJfvZ0lMu/jnb+TMirNGpjExddct2Y1DlOyuJSF/VHn4cw7gETA0OGcG0Ss5d9nIQmwDt+I7C2wahGM8sRCKSse4ThSumYOnA2CM1fHERbJvnJmaFBj2hK/F3SE6Yhth1SMdx35nTQGWH9MV8DAJzpMDwpO7jPIGEhhpDlH1cqwx9GUhhKOz02lJUSF7LEBKcLmkrFBxTlG9phE7LHZ+SGejIULidvsr7cF2KPiCrsDNTda+QA9eRqwcVWWKCwQGGB09ICBTAf3yxhjzx7njHnODUD6P699Bu//uuXDBw4/MG+vp4bZ8+ZYy9r0X3QY4P1PrB/Xzp44GCi7GWg/0g61H/YpCWcekm9ttC3TaY0sEBWHaw4rgUasNF1gRCw4ZwPKrBBlh1gmiydALzBcGlnlZxFYWE0FzgNkqVokinJQ2EadwjoJLD+uG7+/Pla9GcuPhcCiM/Dp37ylQ1Zoz1796adO3akXdgPHziQOQCaABoiBregfUgOsx+J/Om+SuWLOEAg0Eqm0nysAOQz/LjAyNB1kDj9LTozJxiqLTMwzO5EFhmb5lG4TIu/E7xqZEiSJXZYY66d69YxAl8y2ATTCvVpvd905ETGzl6bZMSAcn4zIG4jOZJ+6XfePyYpYZSkhmbcwHUmSZHjqdx0vpXVHIlgyJ00FzCPraF7ZxZYUEyjQspuGGX5dGep9AeI6HRas6+oA8MAEqSHnCMmjkY1A6gTxJJNP3I6suouSyEDzocUATiBeG/TLUP5kEYGuKMeRVjJJgMVfxYWKCxwelqgAOZHt8tk4Hwce45LI5xix6oly94yb07f78+fv3D2/IUL0+LzFqU5cxndzMBGLg5KOghWvf/wQDp8+AAA+6E0ODiUhsFAC5MArDDiCl/8jP5CtpBa7xJQCyUrmnwpJpp6brDUAAmKSe4EoeIq4zfKV7hxvZ8arikhoVJXd+rp6krds3rT/HkL0uw5s9OcefPTrFl9GXMZZCWByt7de7DvTs/vfj7t37XH6pKxigA4kr1bPhrWx6fqibLCWegHXPrswGj1c3gjMtRYMOR5EF4A8tPzuRCl6i53dX0EMPY3BZIJnNnKJrTORnsoz2poy4OpVq9wltr6hpxOse+5gSn9YAw3MX5HyfXsutwBPoG8M9bBrBt77z3Os+RcidCiW+62uUshB7gNabrc3GUpcZKx5ezfvAc1oJRj5fPNxDwgHatiVeAvzCuX3//s3r0MrXrGbagHwe1i7NRcU/7SLHuJOnEyKSNTcee9TC02ZTra0Q42I/YEb66bJ+Dmg5Q7GX+WuVU5CcTJ/LMtdp/J7P8JNmORXGGBwgJnmAUKYD5xg+XQQyZr4bFm1jz7e+GcOcvOmz379/FOv7kEkNDRWYYM5Dyxz719PakPUpBZc+aCiQOY5nA5wWzgGOqvR0cB0IcB1I+kEXzyewXHyCrWIBXRAkMY2qdchIwgNeGIrQ4ZSgfkLu3YESsZeZKl7AQIpya8u6c39XZ3pd5evt8s1rjTh1ns8cpIJQ0ODIDR70+H+w+lfQDkuyBPMbmwyQGYj1YapfMAQK4Jr/iVevcsZrPRkiP46fP9o6OfBiDnkP5EGvIA5cGOt5KsML3AV/F5ht1iZ35xS93dr4Wz9SXUJB/BItc0Hr3E5SPGSVvHjggqeSuwXxlbbZA5vzJm1tzSexsTTnbd9N8eUpTXuAbczjdm3WQn7K5k7ZmjMejhNMo1INPvMi6VUsNIBsg95L/yNFYerD4d3witaI7GGI7/1eolS963+dlnnz7zW7dRAwfqBOgEwQwdyD0/kXSi6nL4gCA9RsRoVA6F8DO/T2YuhoDkQyo+KU2ZaKNzEI4CnzFntAznbOpDRV0KCxQWeOEWKID55DbMs+ckovl3sObN7LmLyFPHisWLX9XT2fVBgJkLSVlruRJGR/EoKJ1lAOW+WQDqs/DZm3p6e1InQDTiqKee7m6whiVpxRVGMaOwWVAD8wIrBMVMM3Suii/u7LUXVGcijcEhMPJHBtPw4GAaAjs/AOA/OIAdQJzSmrov3CKE7CHrCJa4AqemixKYk7E0GtHAD8GV8jc5Az4qYOn/6uDo6Cfxlia9Pt1JnQUgf+H38alIYU5XV88H0fS/wXsggDIzDoAdgNZkLO4AZn1SoQNVTnm8DrYbDHhj5CXTp+vuM5Ac+YWkhP3Ul7SXNCtSJrM+7re8ZYxmtzI48DeG3fuzSmZb5Kk/cA6kKvW58+Z8/fyFC99z34YNXHXznNlgI2j0xgH1AM8E0tMB7sdiKwJ5gvw8K58x9miXYqGfY7FmcW5hgcICZ5wFCmA+dZM1S1vyk0KbwXn2d1fq6l6xdNFvljtKv4HJn51GDtpENpJ0BBIWZQ3AVwv+ALwTgIjt6wBY7wbr3QWQXk5lAHWygWTFcQDhB21lT6aBCCeKoU4GHbGSjV2HPp3fh7HsPWUy7WIamRnBPIbhCV5YHLDvlMYI7OC3MhdOIijBOaMspCQKvrAQc9PfBmQIgHROvV5F1l8dGK18HG9SDiNPZ1JnnOMwP+C+wSBvkoIhn7pvnvIzyuXe69GVPouucH1z5keDdXaPPOAOSYs7lx5mMMBvY3Jm/N4YtMrimTtrrkiidB5dfx7XiulmJBUH4JqFHAsTEYw70G5o060WplO38uav7y6X0poVF37nmqvWvufzf/PVB0+5wc+ADH3iJcE6We5M3uff+UzkMSnsWuzBrJNtpyzGxPvFVligsEBhgXPUAgUwn17DtwLnwZ7nwXnz9/bzZs9fNX/W7F8Hmv73AAhd7bbuvYEBiknAqHP+WzvF4AQGYK8VBo4MuOI5Aw/j73bFg+YCPYyyYjGaKS3RJDaf/GlsImUuPuRPkAGZi2MjMX8a1hejSSac2nMAbJ9IyrwVZxzpE7wTtNMD4NnUuKuEZMoFp+vDOPcrA9XqZ/qr1WdUnemx5CLmmUJuV9W9KQpAPr0+OZNntZW7u9+NnvBh9IUFMbkzFu5RN3EJiRrW+10UWHG/8+e4pEWdq5nVZk+VTxjacw/P6OfK3/X0A1DnteEG0Mm4N87Ll42C8zx7zgnTczAH47xF89LihfPvuuDC8//7n3/5a/fOpLGLvAsLFBYoLFBY4NyxQAHMp9/WzeA8gHkreUuz3KV9VmfnnCVz57+9VO54J35cLrbPQQEjTEjHimgS/F6FRoUwmPpcH3h37SxZdTLqRBmMEU2yyZAyJ4iKFXd5iwC2AWiFVWRkFvLyysegis/hA9j3kIoK7ehAhyArrlFUFyEpasvHdiCBvzgwPPxlaMgZueFEAfI8OJ9+qxRnzqQFZkPe8mvoT7+JPnlxJkthH2o4cNbfDBk3mGxD5i55MXlLbBq14fWczMlFrnzyp2RWBPW5OOq8ETLHM6QvzMej/4sxJ7BX4pyw7BMkdJj6dfulEyNRFyxemFauXFrrm93z9bZy2+1/93f/fPdMGrfIu7BAYYHCAoUFzj0LFMD82No8D855ZV53PhFAz4N0yWBWLjzvts7Orl9COLZXMR6yMYgRxs0Yaa6gaXHBRwWiuTEeuiOWNFqppu7uUqogvrlW/xSNbZuG9Qn6pZ9lGDpb5IiT2Qj2CbTJrGsdUBxnZBcCIEZ9ESBCcapwHEjis1T6PaWHRqvVL+wZGfkGsmgG460iruTlKpMx5IaYiu1MtkBbV1fvbeg8/xf6z2t97Af1iZ7rDRx3T9ba7iK6ZMokVX4VR2p8BVD1SRNRWf921zL+aix2ZLdkPjijya88XrrR6+rjXBtg7uxZad6cWWnhwrmpb3bvwYXzZn9uYLjyia997Z+5+EyxFRYoLFBYoLBAYYFTboECmB+7yfM2s3Fy2/MgPXToMSE0/3ec2z63t3fx/L65v9jV2f42UOEX2wImiM5C9hszPyk1IdvNcHQELTWu0MkoLAQtBNgA3IyVzpmlDIkYUSsyprvUiSguI4IqihuNnBUBQ+SlRVMxrGJgRcBI4VZMxgJgvqNWb/tWpTb6jQMjIxsckIcUZTIwngfi8T0AeB6EF4D82PvfaX1FZ2fn2raO8q+BIX8ndiz40mCvFeozuGyffKn+p1Ef9NGcHh0d30A45VgZ3+3+p+5AeY1+23lYRqahWIgRO52dmnMlTK6CWwdAfG5aufz8tHzFYoQPLWMxsANburu7bx9eWPrCNz/zzRlZqfO0btCicIUFCgsUFigscEotUADz4zd3nj3PA/QMeDtqaJ4smv87O/f8+fPXzerqug38+c9hNc4rCLY7ONGz1J5GEM6QEzLrBOUY3meMcwpTTKlt/CEXGRJTKC06GEFMGEWYFEzo9GF8gG0C81rVgTkni5IVd5AjAIT0MHX0OYD3b1Zrte/unRiMT8SYF4D8+PvT2XZle1df3y3tqeNdGI15M5Bxt7HXBsU1eTOkLTldeYQ2NJbbR35oGUqwrLPKAzbQzr5tvp1kL3ZUQL6MuRVzZveBFe9Ni89fhBVzSwpZOmtOHydGP42wiV8rlzu++oUv/P09Z5vhi/oUFigsUFigsMCZa4ECmL+wtpuIPZ+IQW/FqjfLYdr6yn3z58/pfWVne8eNCNP2KoQ9Ob8dAJ3Lk4sRBMChplyT7aqQsgiOmKqW7OCYwh8aABe7zigsYNYt5CFjN9vKi2PcR0eeGxutbcKk0ocxkfNfDo+MbCIMsgQc84+XrjQz5nFu86ehpPEylYIhf2H97Uy9enZnz6yfb2+r34QK3ApN1VKBcyDrEkZ1GKPf0HVMWvZOg94imZf32dCyMOa4o3L0ebLhturtPCyYtez889Kq5UtTz+yeVBnDIl04t7urAyFCR56Eo/v3C+cv+srtt3/mgTPVkEW5CwsUFigsUFjg7LZAAcxPTPvm2XNBjNzeSocerHmeXc+D+XHf+zr75s7q6lwJXfqKcnv78vZyx3IM0V8IZntuW3utd6wy1gP9eA848x4EVuytcknyejqMMmC58PZhQKBhwPZh6MsHsHboFhDpm6AX33iwf2RjJVUYLzgAdB6M5wF4Mxhv/i3+bsiAC0B+YnrWWZhKZ+esK9o62l+LSEWvRc+7Ak7impBT6dbxu8lkKfZnuVxOXVg8q6vckWaDCa/X6ggp2iV9+Dyw4lwbYNaCXjidnMxcPzQ4NPxAb1fnI0PDwxvqI6P/9uW///bDZ6EpiyoVFigsUFigsMBZZoECmJ+4Bm1mz5sBejOLPi1Q3gTyWzkAx1KDVsC5GYznQfZE4DwP5PPsOstSaMiPpUWKc2WB/7+du1uJGwjDAHygqGsslqC0PVhBhd6w19AbKr2FpUe19YcGFIp7EhiGmZ2JW9ds9jlyk52QzDNz8PrxZWezdt40B1f7+3uXJ8ezi6Plrxh9/nJ+/Pzvqbmcf2qW/1Q2zemHo8XiZ3f99aL7/euxW1bEu+bg8O/940N31n68bdv2x93dn+83N9+8vGlfESBAgMBWCgjm/3/ZagJ6tjq+fJy+wh6PCYN+/zn8W5pJGMr7AJ2rlIfhPNU3Hl8nkJf0fU+AAAECBAgQKAgI5m+3RVYF9DBkh0G8b4FJnQur5XHlvGYWNcE8VT2PQ3h4LJDXyBtDgAABAgQIEKgQEMwrkNYckgvoYTgPe9Jz5/sxYZU8Xr/4OH7ZMm5lSR3XBnEtK2tuDJcTIECAAAECBEIBwXyz+6EmpMfBPDzOhfLSOqZCdPiLKakqePx9XB1PHW9W090IECBAgAABAhMSKAW6CU11VFPJVbpzL3eWXvosrWMumIfhOtXqIoyPatt4GAIECBAgQGDKAqVAN+W5j2Vuq9pRUhX2sGr+mjnkWlBWtabELTGvua9rCBAgQIAAAQIEVggI5uPaHrn1KPWSD5lFKmTXnhtyH2MJECBAgAABAgQGCAjmA7DeYeiQ9cmNra121457Bwa3JECAAAECBAhMX2BI8Ju+xvbNcMj6Cd7bt76emAABAgQIENghgSHBbodYTJUAAQIECBAgQIDAZgUE8816uxsBAgQIECBAgACBpIBgbmMQIECAAAECBAgQGIHAC8w/VXiBrg/dAAAAAElFTkSuQmCC\"/>\r\n  </g>\r\n</svg>\r\n"

/***/ }),
/* 1702 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1366 600\">\r\n  <defs>\r\n    <style>\r\n      .hmb-cls-1 {\r\n        clip-path: url(#clip-Banner_Home_Desktop_Business_curve);\r\n      }\r\n\r\n      .hmb-cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .hmb-cls-3 {\r\n        fill: #0064bf;\r\n      }\r\n\r\n      .hmb-cls-4 {\r\n        fill: #561770;\r\n      }\r\n\r\n      .hmb-cls-5 {\r\n        fill: #fe2b09;\r\n      }\r\n\r\n      .hmb-cls-6 {\r\n        fill: #ffc000;\r\n      }\r\n\r\n      .hmb-cls-7 {\r\n        fill: #5f9600;\r\n      }\r\n\r\n      .hmb-cls-8 {\r\n        fill: #4a7e0b;\r\n      }\r\n\r\n      .hmb-cls-9 {\r\n        fill: #61a50e;\r\n      }\r\n\r\n      .hmb-cls-10, .hmb-cls-13, .hmb-cls-14, .hmb-cls-15, .hmb-cls-16, .hmb-cls-17, .hmb-cls-18 {\r\n        fill: none;\r\n      }\r\n\r\n      .hmb-cls-11 {\r\n        fill: #63a70a;\r\n      }\r\n\r\n      .hmb-cls-12 {\r\n        fill: #ffce00;\r\n      }\r\n\r\n      .hmb-cls-13 {\r\n        stroke: #fff;\r\n        stroke-width: 0.488px;\r\n      }\r\n\r\n      .hmb-cls-14 {\r\n        stroke: #0064bf;\r\n      }\r\n\r\n      .hmb-cls-14, .hmb-cls-15, .hmb-cls-16, .hmb-cls-17, .hmb-cls-18 {\r\n        stroke-width: 0.488px;\r\n      }\r\n\r\n      .hmb-cls-15 {\r\n        stroke: #561770;\r\n      }\r\n\r\n      .hmb-cls-16 {\r\n        stroke: #fe2b09;\r\n      }\r\n\r\n      .hmb-cls-17 {\r\n        stroke: #5f9600;\r\n      }\r\n\r\n      .hmb-cls-18 {\r\n        stroke: #ffc000;\r\n      }\r\n    </style>\r\n    <clipPath id=\"clip-Banner_Home_Desktop_Business_curve\">\r\n      <rect width=\"1366\" height=\"600\"/>\r\n    </clipPath>\r\n  </defs>\r\n  <g id=\"Banner_Home_Desktop_Business_curve\" class=\"hmb-cls-1\">\r\n    <image id=\"BG_business_v1\" width=\"1366\" height=\"600\" xlink:href=\"data:image/jpeg;base64,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\"/>\r\n    <path id=\"Caminho_28343\" data-name=\"Caminho 28343\" class=\"hmb-cls-2\" d=\"M-615.718-14.277h1.084L-619.976,0h-.879l-5.322-14.277h1.064l3.594,9.717q.82,2.2,1.1,3.3.2-.732.771-2.275Zm11.24,8.955a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1-609.214.2a4.5,4.5,0,0,1-2.461-.674,4.31,4.31,0,0,1-1.631-1.934,7.033,7.033,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1-604.478-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413,3.257,3.257,0,0,0,2.72,1.226,3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408,3.3,3.3,0,0,0-2.729-1.211,3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0-612.856-5.322ZM-597.3.2a4.546,4.546,0,0,1-3.564-1.436,5.782,5.782,0,0,1-1.289-4,5.879,5.879,0,0,1,1.338-4.106,4.7,4.7,0,0,1,3.662-1.47,7.363,7.363,0,0,1,2.637.479l-.264.859a7.74,7.74,0,0,0-2.393-.459,3.633,3.633,0,0,0-2.959,1.206,5.287,5.287,0,0,0-1.006,3.472A5.127,5.127,0,0,0-600.132-1.9a3.448,3.448,0,0,0,2.813,1.216,6.9,6.9,0,0,0,2.686-.518v.9A6.086,6.086,0,0,1-597.3.2Zm9.551,0a4.625,4.625,0,0,1-3.608-1.426,5.731,5.731,0,0,1-1.294-3.994,6.227,6.227,0,0,1,1.25-4.067,4.126,4.126,0,0,1,3.369-1.528,3.638,3.638,0,0,1,2.959,1.309,5.4,5.4,0,0,1,1.084,3.555v.781h-7.646a5.022,5.022,0,0,0,1.021,3.34,3.592,3.592,0,0,0,2.866,1.152,8.89,8.89,0,0,0,1.6-.127,9.7,9.7,0,0,0,1.743-.547v.879a7.774,7.774,0,0,1-1.66.532A9.214,9.214,0,0,1-587.749.2Zm-.283-10.156a3.18,3.18,0,0,0-2.461,1.011,4.767,4.767,0,0,0-1.084,2.915h6.563a4.629,4.629,0,0,0-.8-2.886A2.641,2.641,0,0,0-588.032-9.961Zm-2.949-2.314q.605-.654,1.284-1.523a16.806,16.806,0,0,0,1.079-1.523h.957a18.8,18.8,0,0,0,2.363,3.047v.156h-.684a23.125,23.125,0,0,1-2.158-2.021,23.9,23.9,0,0,1-2.158,2.021h-.684ZM-571.323.2A3.879,3.879,0,0,1-574.9-1.641h-.068l.029.82q.039.723.039,1.582V4.8h-.967v-15.42h.82l.186,1.514h.059a3.836,3.836,0,0,1,3.5-1.719,3.947,3.947,0,0,1,3.276,1.411A6.456,6.456,0,0,1-566.9-5.3a6.215,6.215,0,0,1-1.187,4.058A3.971,3.971,0,0,1-571.323.2Zm-.02-.859a2.953,2.953,0,0,0,2.524-1.211,5.615,5.615,0,0,0,.894-3.389q0-4.678-3.379-4.678a3.387,3.387,0,0,0-2.725,1.021A5.107,5.107,0,0,0-574.9-5.6v.313a5.846,5.846,0,0,0,.835,3.555A3.248,3.248,0,0,0-571.343-.664Zm16.162-4.658a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1-559.917.2a4.5,4.5,0,0,1-2.461-.674,4.31,4.31,0,0,1-1.631-1.934,7.033,7.033,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1-555.181-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413,3.257,3.257,0,0,0,2.72,1.226,3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408A3.3,3.3,0,0,0-559.9-9.941a3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0-563.56-5.322Zm15.205-5.5a4.407,4.407,0,0,1,1.992.42,3.965,3.965,0,0,1,1.5,1.436h.059q-.059-1.23-.059-2.412V-15.2h.957V0h-.635l-.244-1.621h-.078A3.928,3.928,0,0,1-548.335.2a4.164,4.164,0,0,1-3.359-1.367,6,6,0,0,1-1.162-3.984A6.655,6.655,0,0,1-551.7-9.365,4.018,4.018,0,0,1-548.354-10.82Zm0,.879a3,3,0,0,0-2.612,1.221,6.049,6.049,0,0,0-.874,3.545q0,4.512,3.506,4.512A3.182,3.182,0,0,0-545.7-1.709a5.546,5.546,0,0,0,.84-3.447v-.166a5.909,5.909,0,0,0-.825-3.54A3.15,3.15,0,0,0-548.354-9.941ZM-536.05.2a4.625,4.625,0,0,1-3.608-1.426,5.731,5.731,0,0,1-1.294-3.994,6.227,6.227,0,0,1,1.25-4.067,4.126,4.126,0,0,1,3.369-1.528,3.638,3.638,0,0,1,2.959,1.309,5.4,5.4,0,0,1,1.084,3.555v.781h-7.646a5.022,5.022,0,0,0,1.021,3.34A3.592,3.592,0,0,0-536.05-.684a8.89,8.89,0,0,0,1.6-.127,9.7,9.7,0,0,0,1.743-.547v.879a7.774,7.774,0,0,1-1.66.532A9.214,9.214,0,0,1-536.05.2Zm-.283-10.156a3.18,3.18,0,0,0-2.461,1.011,4.767,4.767,0,0,0-1.084,2.915h6.563a4.629,4.629,0,0,0-.8-2.886A2.641,2.641,0,0,0-536.333-9.961ZM-517.72,0l-.244-1.68h-.078a5.041,5.041,0,0,1-1.646,1.45,4.4,4.4,0,0,1-2,.425,3.455,3.455,0,0,1-2.432-.8,2.864,2.864,0,0,1-.869-2.217,2.735,2.735,0,0,1,1.294-2.412,7.036,7.036,0,0,1,3.745-.908l2.021-.059v-.7a3.61,3.61,0,0,0-.615-2.285,2.386,2.386,0,0,0-1.982-.771,6.631,6.631,0,0,0-3.057.82l-.361-.84a8.089,8.089,0,0,1,3.457-.82,3.446,3.446,0,0,1,2.612.908,3.99,3.99,0,0,1,.864,2.832V0Zm-3.906-.684a3.643,3.643,0,0,0,2.681-.972,3.629,3.629,0,0,0,.981-2.7V-5.4l-1.855.078a7.009,7.009,0,0,0-3.188.7,2.011,2.011,0,0,0-.952,1.841,1.98,1.98,0,0,0,.61,1.548A2.481,2.481,0,0,0-521.626-.684ZM-512.6,0h-.967V-10.615h.967Zm-1.1-13.564q0-.937.615-.937a.546.546,0,0,1,.474.244,1.2,1.2,0,0,1,.171.693,1.227,1.227,0,0,1-.171.693.541.541,0,0,1-.474.254Q-513.706-12.617-513.706-13.564ZM-501.646,0V-6.885a3.357,3.357,0,0,0-.674-2.329,2.72,2.72,0,0,0-2.09-.728,3.618,3.618,0,0,0-2.788.962,4.534,4.534,0,0,0-.884,3.12V0h-.967V-10.615h.82l.186,1.455h.059a3.99,3.99,0,0,1,3.682-1.66q3.613,0,3.613,3.877V0Zm8.281-10.82a4.407,4.407,0,0,1,1.992.42,3.965,3.965,0,0,1,1.5,1.436h.059q-.059-1.23-.059-2.412V-15.2h.957V0h-.635l-.244-1.621h-.078A3.928,3.928,0,0,1-493.345.2,4.164,4.164,0,0,1-496.7-1.172a6,6,0,0,1-1.162-3.984,6.656,6.656,0,0,1,1.152-4.209A4.018,4.018,0,0,1-493.364-10.82Zm0,.879a3,3,0,0,0-2.612,1.221,6.049,6.049,0,0,0-.874,3.545q0,4.512,3.506,4.512a3.182,3.182,0,0,0,2.637-1.045,5.546,5.546,0,0,0,.84-3.447v-.166a5.909,5.909,0,0,0-.825-3.54A3.15,3.15,0,0,0-493.364-9.941ZM-478.9,0l-.244-1.68h-.078a5.041,5.041,0,0,1-1.646,1.45,4.4,4.4,0,0,1-2,.425,3.455,3.455,0,0,1-2.432-.8,2.864,2.864,0,0,1-.869-2.217,2.735,2.735,0,0,1,1.294-2.412,7.036,7.036,0,0,1,3.745-.908l2.021-.059v-.7a3.61,3.61,0,0,0-.615-2.285,2.386,2.386,0,0,0-1.982-.771,6.631,6.631,0,0,0-3.057.82l-.361-.84a8.089,8.089,0,0,1,3.457-.82,3.446,3.446,0,0,1,2.612.908,3.99,3.99,0,0,1,.864,2.832V0Zm-3.906-.684a3.643,3.643,0,0,0,2.681-.972,3.629,3.629,0,0,0,.981-2.7V-5.4L-481-5.322a7.009,7.009,0,0,0-3.188.7,2.011,2.011,0,0,0-.952,1.841,1.98,1.98,0,0,0,.61,1.548A2.481,2.481,0,0,0-482.808-.684Zm17.49.879a4.546,4.546,0,0,1-3.564-1.436,5.782,5.782,0,0,1-1.289-4,5.879,5.879,0,0,1,1.338-4.106,4.7,4.7,0,0,1,3.662-1.47,7.363,7.363,0,0,1,2.637.479l-.264.859a7.739,7.739,0,0,0-2.393-.459,3.633,3.633,0,0,0-2.959,1.206,5.287,5.287,0,0,0-1.006,3.472A5.128,5.128,0,0,0-468.149-1.9a3.448,3.448,0,0,0,2.813,1.216,6.9,6.9,0,0,0,2.686-.518v.9A6.086,6.086,0,0,1-465.317.2Zm14.043-5.518a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1-456.011.2a4.5,4.5,0,0,1-2.461-.674A4.31,4.31,0,0,1-460.1-2.412a7.034,7.034,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1-451.274-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413,3.257,3.257,0,0,0,2.72,1.226,3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408,3.3,3.3,0,0,0-2.729-1.211,3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0-459.653-5.322ZM-440.933,0V-6.885a3.357,3.357,0,0,0-.674-2.329,2.72,2.72,0,0,0-2.09-.728,3.618,3.618,0,0,0-2.788.962,4.534,4.534,0,0,0-.884,3.12V0h-.967V-10.615h.82l.186,1.455h.059a3.99,3.99,0,0,1,3.682-1.66q3.613,0,3.613,3.877V0Zm10.977-2.764A2.523,2.523,0,0,1-431.04-.571,5.276,5.276,0,0,1-434.116.2,7.336,7.336,0,0,1-437.5-.459V-1.5a7.457,7.457,0,0,0,3.379.8,4.457,4.457,0,0,0,2.388-.522,1.588,1.588,0,0,0,.815-1.392,1.7,1.7,0,0,0-.649-1.348A7.141,7.141,0,0,0-433.7-5.039a12.222,12.222,0,0,1-2.236-.991,3.09,3.09,0,0,1-.972-.937,2.355,2.355,0,0,1-.327-1.274,2.177,2.177,0,0,1,1-1.885,4.863,4.863,0,0,1,2.8-.693,8.377,8.377,0,0,1,3.262.645l-.361.879a7.649,7.649,0,0,0-2.9-.645,4.2,4.2,0,0,0-2.061.43,1.319,1.319,0,0,0-.762,1.191,1.649,1.649,0,0,0,.591,1.328,8.237,8.237,0,0,0,2.31,1.113,11.364,11.364,0,0,1,2.09.933,3.038,3.038,0,0,1,.981.942A2.3,2.3,0,0,1-429.956-2.764Zm3.574-7.852V-3.74a3.357,3.357,0,0,0,.674,2.329,2.72,2.72,0,0,0,2.09.728,3.648,3.648,0,0,0,2.788-.957,4.481,4.481,0,0,0,.894-3.115v-5.859h.957V0h-.82l-.176-1.465h-.059A3.99,3.99,0,0,1-423.716.2q-3.623,0-3.623-3.877v-6.934ZM-414.458,0h-.967V-15.2h.967Zm6.357-.664a7.252,7.252,0,0,0,1.6-.156v.781A5.124,5.124,0,0,1-408.12.2,2.639,2.639,0,0,1-410.2-.557a3.491,3.491,0,0,1-.669-2.363V-9.775h-1.572v-.566l1.572-.439.488-2.4h.5v2.568h3.115v.84h-3.115v6.719a3.066,3.066,0,0,0,.43,1.807A1.56,1.56,0,0,0-408.1-.664ZM-397.759,0-398-1.68h-.078a5.041,5.041,0,0,1-1.646,1.45,4.4,4.4,0,0,1-2,.425,3.455,3.455,0,0,1-2.432-.8,2.864,2.864,0,0,1-.869-2.217,2.735,2.735,0,0,1,1.294-2.412,7.036,7.036,0,0,1,3.745-.908l2.021-.059v-.7a3.61,3.61,0,0,0-.615-2.285,2.386,2.386,0,0,0-1.982-.771,6.631,6.631,0,0,0-3.057.82l-.361-.84a8.089,8.089,0,0,1,3.457-.82,3.446,3.446,0,0,1,2.612.908,3.99,3.99,0,0,1,.864,2.832V0Zm-3.906-.684a3.643,3.643,0,0,0,2.681-.972,3.629,3.629,0,0,0,.981-2.7V-5.4l-1.855.078a7.009,7.009,0,0,0-3.188.7A2.011,2.011,0,0,0-404-2.783a1.98,1.98,0,0,0,.61,1.548A2.481,2.481,0,0,0-401.665-.684Zm12.236-10.137a8.307,8.307,0,0,1,1.445.137l-.186.928a5.656,5.656,0,0,0-1.377-.166,2.674,2.674,0,0,0-2.227,1.152,4.7,4.7,0,0,0-.869,2.91V0h-.967V-10.615h.82l.1,1.914h.068a4.5,4.5,0,0,1,1.4-1.646A3.271,3.271,0,0,1-389.429-10.82Zm15.381,8.057a2.523,2.523,0,0,1-1.084,2.192A5.276,5.276,0,0,1-378.208.2a7.336,7.336,0,0,1-3.379-.654V-1.5a7.457,7.457,0,0,0,3.379.8,4.457,4.457,0,0,0,2.388-.522A1.588,1.588,0,0,0-375-2.617a1.7,1.7,0,0,0-.649-1.348,7.141,7.141,0,0,0-2.134-1.074,12.222,12.222,0,0,1-2.236-.991A3.09,3.09,0,0,1-381-6.968a2.355,2.355,0,0,1-.327-1.274,2.177,2.177,0,0,1,1-1.885,4.863,4.863,0,0,1,2.8-.693,8.377,8.377,0,0,1,3.262.645l-.361.879a7.649,7.649,0,0,0-2.9-.645,4.2,4.2,0,0,0-2.061.43,1.319,1.319,0,0,0-.762,1.191,1.649,1.649,0,0,0,.591,1.328,8.237,8.237,0,0,0,2.31,1.113,11.364,11.364,0,0,1,2.09.933,3.038,3.038,0,0,1,.981.942A2.3,2.3,0,0,1-374.048-2.764ZM-364.868,0l-.244-1.68h-.078a5.041,5.041,0,0,1-1.646,1.45,4.4,4.4,0,0,1-2,.425,3.455,3.455,0,0,1-2.432-.8,2.864,2.864,0,0,1-.869-2.217,2.735,2.735,0,0,1,1.294-2.412,7.036,7.036,0,0,1,3.745-.908l2.021-.059v-.7a3.61,3.61,0,0,0-.615-2.285,2.386,2.386,0,0,0-1.982-.771,6.631,6.631,0,0,0-3.057.82l-.361-.84a8.089,8.089,0,0,1,3.457-.82,3.446,3.446,0,0,1,2.612.908,3.99,3.99,0,0,1,.864,2.832V0Zm-3.906-.684a3.643,3.643,0,0,0,2.681-.972,3.629,3.629,0,0,0,.981-2.7V-5.4l-1.855.078a7.009,7.009,0,0,0-3.188.7,2.011,2.011,0,0,0-.952,1.841,1.98,1.98,0,0,0,.61,1.548A2.481,2.481,0,0,0-368.774-.684Zm9.023.684h-.967V-15.2h.967Zm7.441-10.82a4.407,4.407,0,0,1,1.992.42,3.965,3.965,0,0,1,1.5,1.436h.059q-.059-1.23-.059-2.412V-15.2h.957V0h-.635l-.244-1.621h-.078A3.928,3.928,0,0,1-352.29.2a4.164,4.164,0,0,1-3.359-1.367,6,6,0,0,1-1.162-3.984,6.656,6.656,0,0,1,1.152-4.209A4.018,4.018,0,0,1-352.31-10.82Zm0,.879a3,3,0,0,0-2.612,1.221,6.049,6.049,0,0,0-.874,3.545q0,4.512,3.506,4.512a3.182,3.182,0,0,0,2.637-1.045,5.546,5.546,0,0,0,.84-3.447v-.166a5.909,5.909,0,0,0-.825-3.54A3.15,3.15,0,0,0-352.31-9.941Zm16.8,4.619a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1-340.249.2a4.5,4.5,0,0,1-2.461-.674,4.31,4.31,0,0,1-1.631-1.934,7.034,7.034,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1-335.513-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413,3.257,3.257,0,0,0,2.72,1.226,3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413A5.317,5.317,0,0,0-337.5-8.73a3.3,3.3,0,0,0-2.729-1.211,3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0-343.892-5.322Zm17.9,2.559a2.523,2.523,0,0,1-1.084,2.192A5.276,5.276,0,0,1-330.151.2a7.336,7.336,0,0,1-3.379-.654V-1.5a7.457,7.457,0,0,0,3.379.8,4.457,4.457,0,0,0,2.388-.522,1.588,1.588,0,0,0,.815-1.392,1.7,1.7,0,0,0-.649-1.348,7.141,7.141,0,0,0-2.134-1.074,12.222,12.222,0,0,1-2.236-.991,3.09,3.09,0,0,1-.972-.937,2.355,2.355,0,0,1-.327-1.274,2.177,2.177,0,0,1,1-1.885,4.863,4.863,0,0,1,2.8-.693,8.377,8.377,0,0,1,3.262.645l-.361.879a7.649,7.649,0,0,0-2.9-.645,4.2,4.2,0,0,0-2.061.43,1.319,1.319,0,0,0-.762,1.191,1.649,1.649,0,0,0,.591,1.328,8.237,8.237,0,0,0,2.31,1.113,11.364,11.364,0,0,1,2.09.933,3.038,3.038,0,0,1,.981.942A2.3,2.3,0,0,1-325.991-2.764Zm3.838.439.117.205a32.562,32.562,0,0,1-1.7,4.7h-.635a39.349,39.349,0,0,0,1.074-4.9ZM-309.478.2a4.625,4.625,0,0,1-3.608-1.426,5.73,5.73,0,0,1-1.294-3.994,6.227,6.227,0,0,1,1.25-4.067,4.126,4.126,0,0,1,3.369-1.528A3.638,3.638,0,0,1-306.8-9.512a5.4,5.4,0,0,1,1.084,3.555v.781h-7.646a5.022,5.022,0,0,0,1.021,3.34,3.592,3.592,0,0,0,2.866,1.152,8.89,8.89,0,0,0,1.6-.127,9.7,9.7,0,0,0,1.743-.547v.879a7.775,7.775,0,0,1-1.66.532A9.214,9.214,0,0,1-309.478.2Zm-.283-10.156a3.18,3.18,0,0,0-2.461,1.011,4.767,4.767,0,0,0-1.084,2.915h6.563a4.629,4.629,0,0,0-.8-2.886A2.641,2.641,0,0,0-309.761-9.961Zm9.18,4.5-3.7-5.156h1.113L-300-6.143l3.135-4.473h1.064l-3.643,5.156L-295.542,0h-1.123L-300-4.736-303.364,0h-1.064Zm10.156,4.795a7.252,7.252,0,0,0,1.6-.156v.781A5.124,5.124,0,0,1-290.444.2a2.639,2.639,0,0,1-2.075-.752,3.491,3.491,0,0,1-.669-2.363V-9.775h-1.572v-.566l1.572-.439.488-2.4h.5v2.568h3.115v.84H-292.2v6.719a3.066,3.066,0,0,0,.43,1.807A1.56,1.56,0,0,0-290.425-.664Zm8.076-10.156a8.307,8.307,0,0,1,1.445.137l-.186.928a5.656,5.656,0,0,0-1.377-.166,2.674,2.674,0,0,0-2.227,1.152,4.7,4.7,0,0,0-.869,2.91V0h-.967V-10.615h.82l.1,1.914h.068a4.5,4.5,0,0,1,1.4-1.646A3.271,3.271,0,0,1-282.349-10.82ZM-272.7,0l-.244-1.68h-.078a5.041,5.041,0,0,1-1.646,1.45,4.4,4.4,0,0,1-2,.425,3.455,3.455,0,0,1-2.432-.8,2.864,2.864,0,0,1-.869-2.217,2.735,2.735,0,0,1,1.294-2.412,7.036,7.036,0,0,1,3.745-.908l2.021-.059v-.7a3.61,3.61,0,0,0-.615-2.285,2.386,2.386,0,0,0-1.982-.771,6.631,6.631,0,0,0-3.057.82l-.361-.84a8.089,8.089,0,0,1,3.457-.82,3.446,3.446,0,0,1,2.612.908,3.99,3.99,0,0,1,.864,2.832V0Zm-3.906-.684a3.643,3.643,0,0,0,2.681-.972,3.629,3.629,0,0,0,.981-2.7V-5.4l-1.855.078a7.009,7.009,0,0,0-3.188.7,2.011,2.011,0,0,0-.952,1.841,1.98,1.98,0,0,0,.61,1.548A2.481,2.481,0,0,0-276.606-.684Zm10.859.02a7.252,7.252,0,0,0,1.6-.156v.781A5.124,5.124,0,0,1-265.767.2a2.639,2.639,0,0,1-2.075-.752,3.491,3.491,0,0,1-.669-2.363V-9.775h-1.572v-.566l1.572-.439.488-2.4h.5v2.568h3.115v.84h-3.115v6.719a3.066,3.066,0,0,0,.43,1.807A1.56,1.56,0,0,0-265.747-.664Zm12.676-4.658a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1-257.808.2a4.5,4.5,0,0,1-2.461-.674A4.31,4.31,0,0,1-261.9-2.412a7.034,7.034,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1-253.071-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413,3.257,3.257,0,0,0,2.72,1.226,3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408,3.3,3.3,0,0,0-2.729-1.211,3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0-261.45-5.322Zm17.9,2.559a2.523,2.523,0,0,1-1.084,2.192A5.276,5.276,0,0,1-247.71.2a7.336,7.336,0,0,1-3.379-.654V-1.5a7.457,7.457,0,0,0,3.379.8,4.457,4.457,0,0,0,2.388-.522,1.588,1.588,0,0,0,.815-1.392,1.7,1.7,0,0,0-.649-1.348,7.141,7.141,0,0,0-2.134-1.074,12.222,12.222,0,0,1-2.236-.991,3.09,3.09,0,0,1-.972-.937,2.355,2.355,0,0,1-.327-1.274,2.177,2.177,0,0,1,1-1.885,4.863,4.863,0,0,1,2.8-.693,8.377,8.377,0,0,1,3.262.645l-.361.879a7.649,7.649,0,0,0-2.9-.645,4.2,4.2,0,0,0-2.061.43,1.319,1.319,0,0,0-.762,1.191,1.649,1.649,0,0,0,.591,1.328,8.237,8.237,0,0,0,2.31,1.113,11.364,11.364,0,0,1,2.09.933,3.038,3.038,0,0,1,.981.942A2.3,2.3,0,0,1-243.55-2.764ZM-231.333.2a4.625,4.625,0,0,1-3.608-1.426,5.731,5.731,0,0,1-1.294-3.994,6.227,6.227,0,0,1,1.25-4.067,4.126,4.126,0,0,1,3.369-1.528,3.638,3.638,0,0,1,2.959,1.309,5.4,5.4,0,0,1,1.084,3.555v.781h-7.646a5.022,5.022,0,0,0,1.021,3.34,3.592,3.592,0,0,0,2.866,1.152,8.89,8.89,0,0,0,1.6-.127,9.7,9.7,0,0,0,1.743-.547v.879a7.775,7.775,0,0,1-1.66.532A9.214,9.214,0,0,1-231.333.2Zm-.283-10.156a3.18,3.18,0,0,0-2.461,1.011,4.767,4.767,0,0,0-1.084,2.915h6.563a4.629,4.629,0,0,0-.8-2.886A2.641,2.641,0,0,0-231.616-9.961Zm20.449-.654v.674l-2.2.137a3.75,3.75,0,0,1,.879,2.4,3.242,3.242,0,0,1-1.021,2.485,3.855,3.855,0,0,1-2.739.952,5.956,5.956,0,0,1-1.016-.059,2.527,2.527,0,0,0-.879.713,1.439,1.439,0,0,0-.3.869.8.8,0,0,0,.386.742,2.628,2.628,0,0,0,1.294.234h1.855a4.308,4.308,0,0,1,2.646.7,2.433,2.433,0,0,1,.918,2.065,2.94,2.94,0,0,1-1.362,2.593,6.948,6.948,0,0,1-3.882.913,5.342,5.342,0,0,1-3.1-.771,2.479,2.479,0,0,1-1.1-2.148,2.549,2.549,0,0,1,.679-1.816,3.517,3.517,0,0,1,1.841-.986,1.872,1.872,0,0,1-.767-.581,1.382,1.382,0,0,1-.288-.864,2.272,2.272,0,0,1,1.357-1.875,3.026,3.026,0,0,1-1.445-1.2,3.415,3.415,0,0,1-.518-1.87,3.361,3.361,0,0,1,1.011-2.554,3.8,3.8,0,0,1,2.729-.962,5.032,5.032,0,0,1,1.621.205ZM-219.761,1.8q0,2.188,3.252,2.188,4.18,0,4.18-2.666a1.536,1.536,0,0,0-.654-1.387A3.984,3.984,0,0,0-215.1-.5h-1.738Q-219.761-.5-219.761,1.8Zm.811-9.1A2.448,2.448,0,0,0-218.2-5.4a2.856,2.856,0,0,0,2,.679,2.841,2.841,0,0,0,2.036-.674,2.57,2.57,0,0,0,.708-1.953,2.654,2.654,0,0,0-.728-2.036,2.871,2.871,0,0,0-2.036-.679,2.7,2.7,0,0,0-2,.728A2.739,2.739,0,0,0-218.95-7.3ZM-204.7.2a4.625,4.625,0,0,1-3.608-1.426A5.731,5.731,0,0,1-209.6-5.225a6.227,6.227,0,0,1,1.25-4.067,4.126,4.126,0,0,1,3.369-1.528,3.638,3.638,0,0,1,2.959,1.309,5.4,5.4,0,0,1,1.084,3.555v.781h-7.646a5.022,5.022,0,0,0,1.021,3.34A3.592,3.592,0,0,0-204.7-.684a8.89,8.89,0,0,0,1.6-.127,9.7,9.7,0,0,0,1.743-.547v.879a7.775,7.775,0,0,1-1.66.532A9.214,9.214,0,0,1-204.7.2Zm-.283-10.156a3.18,3.18,0,0,0-2.461,1.011,4.767,4.767,0,0,0-1.084,2.915h6.563a4.629,4.629,0,0,0-.8-2.886A2.641,2.641,0,0,0-204.985-9.961Zm15.752,4.639a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1-193.97.2a4.5,4.5,0,0,1-2.461-.674,4.31,4.31,0,0,1-1.631-1.934,7.033,7.033,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1-189.233-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413,3.257,3.257,0,0,0,2.72,1.226,3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408,3.3,3.3,0,0,0-2.729-1.211,3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0-197.612-5.322ZM-185.327,0h-.967V-15.2h.967Zm12.334-5.322a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1-177.729.2a4.5,4.5,0,0,1-2.461-.674,4.31,4.31,0,0,1-1.631-1.934,7.033,7.033,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1-172.993-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413,3.257,3.257,0,0,0,2.72,1.226,3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408,3.3,3.3,0,0,0-2.729-1.211,3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0-181.372-5.322ZM-165.815.2A4.546,4.546,0,0,1-169.38-1.24a5.782,5.782,0,0,1-1.289-4,5.879,5.879,0,0,1,1.338-4.106,4.7,4.7,0,0,1,3.662-1.47,7.363,7.363,0,0,1,2.637.479l-.264.859a7.739,7.739,0,0,0-2.393-.459,3.633,3.633,0,0,0-2.959,1.206,5.287,5.287,0,0,0-1.006,3.472A5.128,5.128,0,0,0-168.647-1.9a3.448,3.448,0,0,0,2.813,1.216,6.9,6.9,0,0,0,2.686-.518v.9A6.086,6.086,0,0,1-165.815.2Zm11.709-.2-.244-1.68h-.078a5.041,5.041,0,0,1-1.646,1.45,4.4,4.4,0,0,1-2,.425,3.455,3.455,0,0,1-2.432-.8,2.864,2.864,0,0,1-.869-2.217,2.735,2.735,0,0,1,1.294-2.412,7.036,7.036,0,0,1,3.745-.908l2.021-.059v-.7a3.61,3.61,0,0,0-.615-2.285,2.386,2.386,0,0,0-1.982-.771,6.631,6.631,0,0,0-3.057.82l-.361-.84a8.089,8.089,0,0,1,3.457-.82,3.446,3.446,0,0,1,2.612.908,3.99,3.99,0,0,1,.864,2.832V0Zm-3.906-.684a3.643,3.643,0,0,0,2.681-.972,3.629,3.629,0,0,0,.981-2.7V-5.4l-1.855.078a7.009,7.009,0,0,0-3.188.7,2.011,2.011,0,0,0-.952,1.841,1.98,1.98,0,0,0,.61,1.548A2.481,2.481,0,0,0-158.013-.684Zm9.023.684h-.967V-15.2h.967Zm4.521,0h-.967V-10.615h.967Zm-1.1-13.564q0-.937.615-.937a.546.546,0,0,1,.474.244,1.2,1.2,0,0,1,.171.693,1.227,1.227,0,0,1-.171.693.541.541,0,0,1-.474.254Q-145.571-12.617-145.571-13.564ZM-134.312,0h-7.578V-.615l6.3-9.141h-5.84v-.859h7.1V-10l-6.338,9.141h6.357Zm9.063,0-.244-1.68h-.078a5.041,5.041,0,0,1-1.646,1.45,4.4,4.4,0,0,1-2,.425,3.455,3.455,0,0,1-2.432-.8,2.864,2.864,0,0,1-.869-2.217,2.735,2.735,0,0,1,1.294-2.412,7.036,7.036,0,0,1,3.745-.908l2.021-.059v-.7a3.61,3.61,0,0,0-.615-2.285,2.386,2.386,0,0,0-1.982-.771,6.631,6.631,0,0,0-3.057.82l-.361-.84a8.089,8.089,0,0,1,3.457-.82,3.446,3.446,0,0,1,2.612.908,3.99,3.99,0,0,1,.864,2.832V0Zm-3.906-.684a3.643,3.643,0,0,0,2.681-.972,3.629,3.629,0,0,0,.981-2.7V-5.4l-1.855.078a7.009,7.009,0,0,0-3.188.7,2.011,2.011,0,0,0-.952,1.841,1.98,1.98,0,0,0,.61,1.548A2.481,2.481,0,0,0-129.155-.684ZM-116.86.2a4.546,4.546,0,0,1-3.564-1.436,5.782,5.782,0,0,1-1.289-4,5.879,5.879,0,0,1,1.338-4.106,4.7,4.7,0,0,1,3.662-1.47,7.363,7.363,0,0,1,2.637.479l-.264.859a7.739,7.739,0,0,0-2.393-.459,3.633,3.633,0,0,0-2.959,1.206A5.287,5.287,0,0,0-120.7-5.264,5.128,5.128,0,0,0-119.692-1.9,3.448,3.448,0,0,0-116.88-.684a6.9,6.9,0,0,0,2.686-.518v.9A6.086,6.086,0,0,1-116.86.2Zm1.045,2.646a1.719,1.719,0,0,1-.659,1.47,3.018,3.018,0,0,1-1.841.493,2.662,2.662,0,0,1-.918-.107V3.838a3.052,3.052,0,0,0,.9.1,2.057,2.057,0,0,0,1.162-.273.89.89,0,0,0,.4-.781q0-.918-1.885-1.182l.908-1.7h.938l-.645,1.143Q-115.815,1.5-115.815,2.842ZM-105.151,0l-.244-1.68h-.078a5.041,5.041,0,0,1-1.646,1.45,4.4,4.4,0,0,1-2,.425,3.455,3.455,0,0,1-2.432-.8,2.864,2.864,0,0,1-.869-2.217,2.735,2.735,0,0,1,1.294-2.412,7.036,7.036,0,0,1,3.745-.908l2.021-.059v-.7a3.61,3.61,0,0,0-.615-2.285,2.386,2.386,0,0,0-1.982-.771,6.631,6.631,0,0,0-3.057.82l-.361-.84a8.089,8.089,0,0,1,3.457-.82,3.446,3.446,0,0,1,2.612.908,3.99,3.99,0,0,1,.864,2.832V0Zm-3.906-.684a3.643,3.643,0,0,0,2.681-.972,3.629,3.629,0,0,0,.981-2.7V-5.4l-1.855.078a7.009,7.009,0,0,0-3.188.7,2.011,2.011,0,0,0-.952,1.841,1.98,1.98,0,0,0,.61,1.548A2.481,2.481,0,0,0-109.058-.684Zm2.49-11.455a1.707,1.707,0,0,1-.732-.181,4.925,4.925,0,0,1-.986-.7,7.455,7.455,0,0,0-.61-.449,1.1,1.1,0,0,0-.61-.2.931.931,0,0,0-.732.337,2.7,2.7,0,0,0-.469,1.187h-.713a3.021,3.021,0,0,1,.615-1.7,1.662,1.662,0,0,1,1.338-.62,1.59,1.59,0,0,1,.859.244,8.117,8.117,0,0,1,.8.576q.332.273.645.488a1.061,1.061,0,0,0,.6.215.948.948,0,0,0,.752-.356,2.651,2.651,0,0,0,.469-1.167h.742a3.272,3.272,0,0,1-.674,1.729A1.639,1.639,0,0,1-106.567-12.139Zm14.346,6.816a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1-96.958.2a4.5,4.5,0,0,1-2.461-.674,4.31,4.31,0,0,1-1.631-1.934,7.034,7.034,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048A4.34,4.34,0,0,1-96.9-10.82a4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1-92.222-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413,3.257,3.257,0,0,0,2.72,1.226A3.257,3.257,0,0,0-94.2-1.909a5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408,3.3,3.3,0,0,0-2.729-1.211,3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0-100.6-5.322Zm20.4-5.5a4.407,4.407,0,0,1,1.992.42,3.965,3.965,0,0,1,1.5,1.436h.059q-.059-1.23-.059-2.412V-15.2h.957V0h-.635l-.244-1.621H-76.7A3.928,3.928,0,0,1-80.181.2,4.164,4.164,0,0,1-83.54-1.172,6,6,0,0,1-84.7-5.156,6.656,6.656,0,0,1-83.55-9.365,4.018,4.018,0,0,1-80.2-10.82Zm0,.879a3,3,0,0,0-2.612,1.221,6.049,6.049,0,0,0-.874,3.545q0,4.512,3.506,4.512a3.182,3.182,0,0,0,2.637-1.045,5.546,5.546,0,0,0,.84-3.447v-.166a5.909,5.909,0,0,0-.825-3.54A3.15,3.15,0,0,0-80.2-9.941Zm16.8,4.619a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1-68.14.2,4.5,4.5,0,0,1-70.6-.479a4.31,4.31,0,0,1-1.631-1.934,7.034,7.034,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1-63.4-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413A3.257,3.257,0,0,0-68.1-.684a3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408A3.3,3.3,0,0,0-68.12-9.941a3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0-71.782-5.322Zm17.9,2.559A2.523,2.523,0,0,1-54.966-.571,5.276,5.276,0,0,1-58.042.2a7.336,7.336,0,0,1-3.379-.654V-1.5a7.457,7.457,0,0,0,3.379.8,4.457,4.457,0,0,0,2.388-.522,1.588,1.588,0,0,0,.815-1.392,1.7,1.7,0,0,0-.649-1.348,7.141,7.141,0,0,0-2.134-1.074,12.222,12.222,0,0,1-2.236-.991,3.09,3.09,0,0,1-.972-.937,2.355,2.355,0,0,1-.327-1.274,2.177,2.177,0,0,1,1-1.885,4.863,4.863,0,0,1,2.8-.693,8.377,8.377,0,0,1,3.262.645l-.361.879a7.649,7.649,0,0,0-2.9-.645,4.2,4.2,0,0,0-2.061.43,1.319,1.319,0,0,0-.762,1.191,1.649,1.649,0,0,0,.591,1.328,8.237,8.237,0,0,0,2.31,1.113,11.364,11.364,0,0,1,2.09.933A3.038,3.038,0,0,1-54.209-4,2.3,2.3,0,0,1-53.882-2.764ZM-43.628,0l-4.1-10.615h1L-43.989-3.4a22.229,22.229,0,0,1,.82,2.422h.059q.4-1.328.82-2.441l2.744-7.2h1L-42.651,0Zm11.143.2A4.625,4.625,0,0,1-36.094-1.23a5.73,5.73,0,0,1-1.294-3.994,6.227,6.227,0,0,1,1.25-4.067,4.126,4.126,0,0,1,3.369-1.528A3.638,3.638,0,0,1-29.81-9.512a5.4,5.4,0,0,1,1.084,3.555v.781h-7.646a5.022,5.022,0,0,0,1.021,3.34A3.592,3.592,0,0,0-32.485-.684a8.89,8.89,0,0,0,1.6-.127,9.7,9.7,0,0,0,1.743-.547v.879a7.775,7.775,0,0,1-1.66.532A9.214,9.214,0,0,1-32.485.2Zm-.283-10.156A3.18,3.18,0,0,0-35.229-8.95a4.767,4.767,0,0,0-1.084,2.915h6.563a4.629,4.629,0,0,0-.8-2.886A2.641,2.641,0,0,0-32.769-9.961ZM-24.829,0H-25.8V-10.615h.967Zm-1.7-12.275q.713-.771,1.411-1.675a11.509,11.509,0,0,0,.952-1.372h1.377v.166a10.682,10.682,0,0,1-1.2,1.348q-.845.84-1.86,1.689h-.684ZM-17.036.2A4.546,4.546,0,0,1-20.6-1.24a5.782,5.782,0,0,1-1.289-4,5.879,5.879,0,0,1,1.338-4.106,4.7,4.7,0,0,1,3.662-1.47,7.363,7.363,0,0,1,2.637.479l-.264.859a7.739,7.739,0,0,0-2.393-.459,3.633,3.633,0,0,0-2.959,1.206,5.287,5.287,0,0,0-1.006,3.472A5.128,5.128,0,0,0-19.868-1.9,3.448,3.448,0,0,0-17.056-.684,6.9,6.9,0,0,0-14.37-1.2v.9A6.086,6.086,0,0,1-17.036.2Zm6.1-10.811V-3.74a3.357,3.357,0,0,0,.674,2.329,2.72,2.72,0,0,0,2.09.728,3.648,3.648,0,0,0,2.788-.957,4.481,4.481,0,0,0,.894-3.115v-5.859h.957V0h-.82l-.176-1.465h-.059A3.99,3.99,0,0,1-8.267.2Q-11.89.2-11.89-3.682v-6.934ZM.991,0H.024V-15.2H.991ZM13.325-5.322a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1,8.589.2,4.5,4.5,0,0,1,6.128-.479,4.31,4.31,0,0,1,4.5-2.412a7.034,7.034,0,0,1-.566-2.91A5.974,5.974,0,0,1,5.19-9.37a4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1,13.325-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413A3.257,3.257,0,0,0,8.628-.684a3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408A3.3,3.3,0,0,0,8.608-9.941,3.252,3.252,0,0,0,5.9-8.735,5.391,5.391,0,0,0,4.946-5.322Zm17.9,2.559A2.523,2.523,0,0,1,21.763-.571,5.276,5.276,0,0,1,18.687.2a7.336,7.336,0,0,1-3.379-.654V-1.5a7.457,7.457,0,0,0,3.379.8,4.457,4.457,0,0,0,2.388-.522,1.588,1.588,0,0,0,.815-1.392,1.7,1.7,0,0,0-.649-1.348,7.141,7.141,0,0,0-2.134-1.074A12.222,12.222,0,0,1,16.87-6.03a3.09,3.09,0,0,1-.972-.937,2.355,2.355,0,0,1-.327-1.274,2.177,2.177,0,0,1,1-1.885,4.863,4.863,0,0,1,2.8-.693,8.377,8.377,0,0,1,3.262.645l-.361.879a7.649,7.649,0,0,0-2.9-.645,4.2,4.2,0,0,0-2.061.43,1.319,1.319,0,0,0-.762,1.191,1.649,1.649,0,0,0,.591,1.328,8.237,8.237,0,0,0,2.31,1.113,11.364,11.364,0,0,1,2.09.933A3.038,3.038,0,0,1,22.52-4,2.3,2.3,0,0,1,22.847-2.764ZM34.663-10.82a4.407,4.407,0,0,1,1.992.42,3.965,3.965,0,0,1,1.5,1.436h.059q-.059-1.23-.059-2.412V-15.2h.957V0h-.635l-.244-1.621h-.078A3.928,3.928,0,0,1,34.683.2a4.164,4.164,0,0,1-3.359-1.367,6,6,0,0,1-1.162-3.984,6.655,6.655,0,0,1,1.152-4.209A4.018,4.018,0,0,1,34.663-10.82Zm0,.879a3,3,0,0,0-2.612,1.221,6.049,6.049,0,0,0-.874,3.545q0,4.512,3.506,4.512a3.182,3.182,0,0,0,2.637-1.045,5.546,5.546,0,0,0,.84-3.447v-.166a5.909,5.909,0,0,0-.825-3.54A3.15,3.15,0,0,0,34.663-9.941ZM43.647,0h-.967V-10.615h.967Zm-1.1-13.564q0-.937.615-.937a.546.546,0,0,1,.474.244,1.2,1.2,0,0,1,.171.693,1.227,1.227,0,0,1-.171.693.541.541,0,0,1-.474.254Q42.544-12.617,42.544-13.564Zm8.838,2.744a8.307,8.307,0,0,1,1.445.137l-.186.928a5.656,5.656,0,0,0-1.377-.166A2.674,2.674,0,0,0,49.038-8.77a4.7,4.7,0,0,0-.869,2.91V0H47.2V-10.615h.82l.1,1.914h.068a4.5,4.5,0,0,1,1.4-1.646A3.271,3.271,0,0,1,51.382-10.82ZM58.872.2A4.625,4.625,0,0,1,55.264-1.23,5.73,5.73,0,0,1,53.97-5.225a6.227,6.227,0,0,1,1.25-4.067,4.126,4.126,0,0,1,3.369-1.528,3.638,3.638,0,0,1,2.959,1.309,5.4,5.4,0,0,1,1.084,3.555v.781H54.985a5.022,5.022,0,0,0,1.021,3.34A3.592,3.592,0,0,0,58.872-.684a8.89,8.89,0,0,0,1.6-.127,9.7,9.7,0,0,0,1.743-.547v.879a7.775,7.775,0,0,1-1.66.532A9.214,9.214,0,0,1,58.872.2ZM58.589-9.961A3.18,3.18,0,0,0,56.128-8.95a4.767,4.767,0,0,0-1.084,2.915h6.563a4.629,4.629,0,0,0-.8-2.886A2.641,2.641,0,0,0,58.589-9.961Zm9.775,9.3a7.252,7.252,0,0,0,1.6-.156v.781A5.124,5.124,0,0,1,68.345.2,2.639,2.639,0,0,1,66.27-.557,3.491,3.491,0,0,1,65.6-2.92V-9.775H64.028v-.566l1.572-.439.488-2.4h.5v2.568H69.7v.84H66.587v6.719a3.066,3.066,0,0,0,.43,1.807A1.56,1.56,0,0,0,68.364-.664ZM78.706,0l-.244-1.68h-.078a5.041,5.041,0,0,1-1.646,1.45,4.4,4.4,0,0,1-2,.425,3.455,3.455,0,0,1-2.432-.8,2.864,2.864,0,0,1-.869-2.217,2.735,2.735,0,0,1,1.294-2.412,7.036,7.036,0,0,1,3.745-.908L78.5-6.2v-.7a3.61,3.61,0,0,0-.615-2.285A2.386,2.386,0,0,0,75.9-9.961a6.631,6.631,0,0,0-3.057.82l-.361-.84a8.089,8.089,0,0,1,3.457-.82,3.446,3.446,0,0,1,2.612.908,3.99,3.99,0,0,1,.864,2.832V0ZM74.8-.684a3.643,3.643,0,0,0,2.681-.972,3.629,3.629,0,0,0,.981-2.7V-5.4l-1.855.078a7.009,7.009,0,0,0-3.188.7,2.011,2.011,0,0,0-.952,1.841,1.98,1.98,0,0,0,.61,1.548A2.481,2.481,0,0,0,74.8-.684ZM96.118,0V-6.963a3.467,3.467,0,0,0-.605-2.266,2.3,2.3,0,0,0-1.855-.713,3.029,3.029,0,0,0-2.412.9,4.236,4.236,0,0,0-.781,2.822V0h-.986V-7.256q0-2.686-2.461-2.686a2.9,2.9,0,0,0-2.432.972,5.061,5.061,0,0,0-.762,3.11V0h-.967V-10.615h.8l.205,1.455h.059a3.043,3.043,0,0,1,1.25-1.226,3.722,3.722,0,0,1,1.787-.435q2.51,0,3.223,1.885h.039a3.609,3.609,0,0,1,1.392-1.4A4,4,0,0,1,93.6-10.82a3.407,3.407,0,0,1,2.607.928,4.213,4.213,0,0,1,.869,2.949V0ZM104.8.2a4.625,4.625,0,0,1-3.608-1.426A5.73,5.73,0,0,1,99.9-5.225a6.227,6.227,0,0,1,1.25-4.067,4.126,4.126,0,0,1,3.369-1.528,3.638,3.638,0,0,1,2.959,1.309,5.4,5.4,0,0,1,1.084,3.555v.781h-7.646a5.022,5.022,0,0,0,1.021,3.34A3.592,3.592,0,0,0,104.8-.684a8.89,8.89,0,0,0,1.6-.127,9.7,9.7,0,0,0,1.743-.547v.879a7.775,7.775,0,0,1-1.66.532A9.214,9.214,0,0,1,104.8.2Zm-.283-10.156a3.18,3.18,0,0,0-2.461,1.011,4.767,4.767,0,0,0-1.084,2.915h6.563a4.629,4.629,0,0,0-.8-2.886A2.641,2.641,0,0,0,104.517-9.961ZM118.892,0V-6.885a3.357,3.357,0,0,0-.674-2.329,2.72,2.72,0,0,0-2.09-.728,3.618,3.618,0,0,0-2.788.962,4.535,4.535,0,0,0-.884,3.12V0h-.967V-10.615h.82L112.5-9.16h.059a3.99,3.99,0,0,1,3.682-1.66q3.613,0,3.613,3.877V0Zm7.2-.664a7.252,7.252,0,0,0,1.6-.156v.781A5.124,5.124,0,0,1,126.069.2a2.639,2.639,0,0,1-2.075-.752,3.491,3.491,0,0,1-.669-2.363V-9.775h-1.572v-.566l1.572-.439.488-2.4h.5v2.568h3.115v.84h-3.115v6.719a3.066,3.066,0,0,0,.43,1.807A1.56,1.56,0,0,0,126.089-.664ZM134.272.2a4.625,4.625,0,0,1-3.608-1.426,5.731,5.731,0,0,1-1.294-3.994,6.227,6.227,0,0,1,1.25-4.067,4.126,4.126,0,0,1,3.369-1.528,3.638,3.638,0,0,1,2.959,1.309,5.4,5.4,0,0,1,1.084,3.555v.781h-7.646a5.022,5.022,0,0,0,1.021,3.34,3.592,3.592,0,0,0,2.866,1.152,8.89,8.89,0,0,0,1.6-.127,9.7,9.7,0,0,0,1.743-.547v.879a7.775,7.775,0,0,1-1.66.532A9.214,9.214,0,0,1,134.272.2Zm-.283-10.156a3.18,3.18,0,0,0-2.461,1.011,4.767,4.767,0,0,0-1.084,2.915h6.563a4.629,4.629,0,0,0-.8-2.886A2.641,2.641,0,0,0,133.989-9.961ZM153.56,0V-6.885a3.357,3.357,0,0,0-.674-2.329,2.72,2.72,0,0,0-2.09-.728,3.618,3.618,0,0,0-2.788.962,4.535,4.535,0,0,0-.884,3.12V0h-.967V-10.615h.82l.186,1.455h.059a3.99,3.99,0,0,1,3.682-1.66q3.613,0,3.613,3.877V0Zm13.174-5.322a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1,162,.2a4.5,4.5,0,0,1-2.461-.674,4.31,4.31,0,0,1-1.631-1.934,7.033,7.033,0,0,1-.566-2.91A5.974,5.974,0,0,1,158.6-9.37a4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1,166.733-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413,3.257,3.257,0,0,0,2.72,1.226,3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408,3.3,3.3,0,0,0-2.729-1.211,3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0,158.354-5.322ZM182.271,0V-6.885a3.357,3.357,0,0,0-.674-2.329,2.72,2.72,0,0,0-2.09-.728,3.618,3.618,0,0,0-2.788.962,4.535,4.535,0,0,0-.884,3.12V0h-.967V-10.615h.82l.186,1.455h.059a3.99,3.99,0,0,1,3.682-1.66q3.613,0,3.613,3.877V0Zm13.174-5.322a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1,190.708.2a4.5,4.5,0,0,1-2.461-.674,4.31,4.31,0,0,1-1.631-1.934,7.033,7.033,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1,195.444-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413,3.257,3.257,0,0,0,2.72,1.226,3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408,3.3,3.3,0,0,0-2.729-1.211,3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0,187.065-5.322Zm17.9,2.559a2.523,2.523,0,0,1-1.084,2.192A5.276,5.276,0,0,1,200.806.2a7.336,7.336,0,0,1-3.379-.654V-1.5a7.457,7.457,0,0,0,3.379.8,4.457,4.457,0,0,0,2.388-.522,1.588,1.588,0,0,0,.815-1.392,1.7,1.7,0,0,0-.649-1.348,7.141,7.141,0,0,0-2.134-1.074,12.222,12.222,0,0,1-2.236-.991,3.09,3.09,0,0,1-.972-.937,2.355,2.355,0,0,1-.327-1.274,2.177,2.177,0,0,1,1-1.885,4.863,4.863,0,0,1,2.8-.693,8.377,8.377,0,0,1,3.262.645l-.361.879a7.649,7.649,0,0,0-2.9-.645,4.2,4.2,0,0,0-2.061.43,1.319,1.319,0,0,0-.762,1.191,1.649,1.649,0,0,0,.591,1.328,8.237,8.237,0,0,0,2.31,1.113,11.364,11.364,0,0,1,2.09.933,3.038,3.038,0,0,1,.981.942A2.3,2.3,0,0,1,204.966-2.764Zm9.316,0A2.523,2.523,0,0,1,213.2-.571,5.276,5.276,0,0,1,210.122.2a7.336,7.336,0,0,1-3.379-.654V-1.5a7.457,7.457,0,0,0,3.379.8,4.457,4.457,0,0,0,2.388-.522,1.588,1.588,0,0,0,.815-1.392,1.7,1.7,0,0,0-.649-1.348,7.141,7.141,0,0,0-2.134-1.074,12.222,12.222,0,0,1-2.236-.991,3.09,3.09,0,0,1-.972-.937,2.355,2.355,0,0,1-.327-1.274,2.177,2.177,0,0,1,1-1.885,4.863,4.863,0,0,1,2.8-.693,8.377,8.377,0,0,1,3.262.645l-.361.879a7.649,7.649,0,0,0-2.9-.645,4.2,4.2,0,0,0-2.061.43,1.319,1.319,0,0,0-.762,1.191,1.649,1.649,0,0,0,.591,1.328,8.237,8.237,0,0,0,2.31,1.113,11.364,11.364,0,0,1,2.09.933,3.038,3.038,0,0,1,.981.942A2.3,2.3,0,0,1,214.282-2.764ZM225.8-5.322a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1,221.06.2,4.5,4.5,0,0,1,218.6-.479a4.31,4.31,0,0,1-1.631-1.934,7.033,7.033,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1,225.8-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413A3.257,3.257,0,0,0,221.1-.684a3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408,3.3,3.3,0,0,0-2.729-1.211,3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0,217.417-5.322Zm23.1,2.559a2.523,2.523,0,0,1-1.084,2.192A5.276,5.276,0,0,1,236.353.2a7.336,7.336,0,0,1-3.379-.654V-1.5a7.457,7.457,0,0,0,3.379.8,4.457,4.457,0,0,0,2.388-.522,1.588,1.588,0,0,0,.815-1.392,1.7,1.7,0,0,0-.649-1.348,7.141,7.141,0,0,0-2.134-1.074,12.222,12.222,0,0,1-2.236-.991,3.09,3.09,0,0,1-.972-.937,2.355,2.355,0,0,1-.327-1.274,2.177,2.177,0,0,1,1-1.885,4.863,4.863,0,0,1,2.8-.693,8.377,8.377,0,0,1,3.262.645l-.361.879a7.649,7.649,0,0,0-2.9-.645,4.2,4.2,0,0,0-2.061.43,1.319,1.319,0,0,0-.762,1.191,1.649,1.649,0,0,0,.591,1.328,8.237,8.237,0,0,0,2.31,1.113,11.364,11.364,0,0,1,2.09.933,3.038,3.038,0,0,1,.981.942A2.3,2.3,0,0,1,240.513-2.764ZM244.214,0h-.967V-10.615h.967Zm-1.1-13.564q0-.937.615-.937a.546.546,0,0,1,.474.244,1.2,1.2,0,0,1,.171.693,1.227,1.227,0,0,1-.171.693.541.541,0,0,1-.474.254Q243.11-12.617,243.11-13.564Zm7.461,12.9a7.252,7.252,0,0,0,1.6-.156v.781A5.124,5.124,0,0,1,250.552.2a2.639,2.639,0,0,1-2.075-.752,3.491,3.491,0,0,1-.669-2.363V-9.775h-1.572v-.566l1.572-.439.488-2.4h.5v2.568h3.115v.84h-3.115v6.719a3.066,3.066,0,0,0,.43,1.807A1.56,1.56,0,0,0,250.571-.664ZM258.755.2a4.625,4.625,0,0,1-3.608-1.426,5.731,5.731,0,0,1-1.294-3.994,6.227,6.227,0,0,1,1.25-4.067,4.126,4.126,0,0,1,3.369-1.528,3.638,3.638,0,0,1,2.959,1.309,5.4,5.4,0,0,1,1.084,3.555v.781h-7.646a5.022,5.022,0,0,0,1.021,3.34,3.592,3.592,0,0,0,2.866,1.152,8.89,8.89,0,0,0,1.6-.127,9.7,9.7,0,0,0,1.743-.547v.879a7.775,7.775,0,0,1-1.66.532A9.214,9.214,0,0,1,258.755.2Zm-.283-10.156a3.18,3.18,0,0,0-2.461,1.011,4.767,4.767,0,0,0-1.084,2.915h6.563a4.629,4.629,0,0,0-.8-2.886A2.641,2.641,0,0,0,258.472-9.961Zm20.947,4.639a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1,274.683.2a4.5,4.5,0,0,1-2.461-.674,4.31,4.31,0,0,1-1.631-1.934,7.034,7.034,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1,279.419-5.322Zm-8.379,0A5.4,5.4,0,0,0,272-1.909a3.257,3.257,0,0,0,2.72,1.226,3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408A3.3,3.3,0,0,0,274.7-9.941a3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0,271.04-5.322ZM283.2-10.615V-3.74a3.357,3.357,0,0,0,.674,2.329,2.72,2.72,0,0,0,2.09.728,3.648,3.648,0,0,0,2.788-.957,4.481,4.481,0,0,0,.894-3.115v-5.859h.957V0h-.82L289.6-1.465h-.059A3.99,3.99,0,0,1,285.864.2q-3.623,0-3.623-3.877v-6.934ZM306.753,0V-6.885a3.357,3.357,0,0,0-.674-2.329,2.72,2.72,0,0,0-2.09-.728,3.618,3.618,0,0,0-2.788.962,4.534,4.534,0,0,0-.884,3.12V0h-.967V-10.615h.82l.186,1.455h.059a3.99,3.99,0,0,1,3.682-1.66q3.613,0,3.613,3.877V0Zm13.174-5.322a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1,315.19.2a4.5,4.5,0,0,1-2.461-.674A4.31,4.31,0,0,1,311.1-2.412a7.034,7.034,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1,319.927-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413,3.257,3.257,0,0,0,2.72,1.226,3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408,3.3,3.3,0,0,0-2.729-1.211,3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0,311.548-5.322Zm23.633.283h-5.8L327.388,0h-1.1l5.742-14.336h.635L338.286,0h-1.123Zm-5.439-.9h5.107l-1.943-5.146q-.244-.605-.586-1.68a15.658,15.658,0,0,1-.576,1.7ZM344.6.2a3.878,3.878,0,0,1-3.574-1.836h-.068l.029.82q.039.723.039,1.582V4.8h-.967v-15.42h.82l.186,1.514h.059a3.836,3.836,0,0,1,3.5-1.719A3.947,3.947,0,0,1,347.9-9.409,6.456,6.456,0,0,1,349.028-5.3a6.215,6.215,0,0,1-1.187,4.058A3.971,3.971,0,0,1,344.6.2Zm-.02-.859a2.953,2.953,0,0,0,2.524-1.211A5.615,5.615,0,0,0,348-5.264q0-4.678-3.379-4.678A3.387,3.387,0,0,0,341.9-8.921,5.107,5.107,0,0,0,341.03-5.6v.313a5.846,5.846,0,0,0,.835,3.555A3.248,3.248,0,0,0,344.585-.664ZM356.509.2a3.878,3.878,0,0,1-3.574-1.836h-.068l.029.82q.039.723.039,1.582V4.8h-.967v-15.42h.82l.186,1.514h.059a3.836,3.836,0,0,1,3.5-1.719A3.947,3.947,0,0,1,359.8-9.409,6.456,6.456,0,0,1,360.933-5.3a6.215,6.215,0,0,1-1.187,4.058A3.971,3.971,0,0,1,356.509.2Zm-.02-.859a2.953,2.953,0,0,0,2.524-1.211,5.615,5.615,0,0,0,.894-3.389q0-4.678-3.379-4.678A3.387,3.387,0,0,0,353.8-8.921a5.107,5.107,0,0,0-.869,3.325v.313a5.846,5.846,0,0,0,.835,3.555A3.248,3.248,0,0,0,356.489-.664ZM373.608.2a3.878,3.878,0,0,1-3.574-1.836h-.068L370-.82q.039.723.039,1.582V4.8h-.967v-15.42h.82l.186,1.514h.059a3.836,3.836,0,0,1,3.5-1.719A3.947,3.947,0,0,1,376.9-9.409,6.456,6.456,0,0,1,378.032-5.3a6.215,6.215,0,0,1-1.187,4.058A3.971,3.971,0,0,1,373.608.2Zm-.02-.859a2.953,2.953,0,0,0,2.524-1.211,5.615,5.615,0,0,0,.894-3.389q0-4.678-3.379-4.678A3.387,3.387,0,0,0,370.9-8.921a5.107,5.107,0,0,0-.869,3.325v.313a5.846,5.846,0,0,0,.835,3.555A3.248,3.248,0,0,0,373.589-.664ZM387.417,0l-.244-1.68h-.078a5.041,5.041,0,0,1-1.646,1.45,4.4,4.4,0,0,1-2,.425,3.455,3.455,0,0,1-2.432-.8,2.864,2.864,0,0,1-.869-2.217,2.735,2.735,0,0,1,1.294-2.412,7.036,7.036,0,0,1,3.745-.908l2.021-.059v-.7a3.61,3.61,0,0,0-.615-2.285,2.386,2.386,0,0,0-1.982-.771,6.631,6.631,0,0,0-3.057.82l-.361-.84a8.089,8.089,0,0,1,3.457-.82,3.446,3.446,0,0,1,2.612.908,3.99,3.99,0,0,1,.864,2.832V0Zm-3.906-.684a3.643,3.643,0,0,0,2.681-.972,3.629,3.629,0,0,0,.981-2.7V-5.4l-1.855.078a7.009,7.009,0,0,0-3.188.7,2.011,2.011,0,0,0-.952,1.841,1.98,1.98,0,0,0,.61,1.548A2.481,2.481,0,0,0,383.511-.684ZM395.747-10.82a8.307,8.307,0,0,1,1.445.137l-.186.928a5.656,5.656,0,0,0-1.377-.166A2.674,2.674,0,0,0,393.4-8.77a4.7,4.7,0,0,0-.869,2.91V0h-.967V-10.615h.82l.1,1.914h.068a4.5,4.5,0,0,1,1.4-1.646A3.271,3.271,0,0,1,395.747-10.82ZM405.4,0l-.244-1.68h-.078a5.041,5.041,0,0,1-1.646,1.45,4.4,4.4,0,0,1-2,.425A3.455,3.455,0,0,1,399-.605a2.864,2.864,0,0,1-.869-2.217,2.735,2.735,0,0,1,1.294-2.412,7.036,7.036,0,0,1,3.745-.908L405.19-6.2v-.7a3.61,3.61,0,0,0-.615-2.285,2.386,2.386,0,0,0-1.982-.771,6.631,6.631,0,0,0-3.057.82l-.361-.84a8.089,8.089,0,0,1,3.457-.82,3.446,3.446,0,0,1,2.612.908,3.99,3.99,0,0,1,.864,2.832V0Zm-3.906-.684a3.643,3.643,0,0,0,2.681-.972,3.629,3.629,0,0,0,.981-2.7V-5.4l-1.855.078a7.009,7.009,0,0,0-3.188.7,2.011,2.011,0,0,0-.952,1.841,1.98,1.98,0,0,0,.61,1.548A2.481,2.481,0,0,0,401.489-.684ZM428,0V-6.963a3.467,3.467,0,0,0-.605-2.266,2.3,2.3,0,0,0-1.855-.713,3.029,3.029,0,0,0-2.412.9,4.236,4.236,0,0,0-.781,2.822V0h-.986V-7.256q0-2.686-2.461-2.686a2.9,2.9,0,0,0-2.432.972,5.061,5.061,0,0,0-.762,3.11V0h-.967V-10.615h.8l.205,1.455h.059a3.043,3.043,0,0,1,1.25-1.226,3.722,3.722,0,0,1,1.787-.435q2.51,0,3.223,1.885h.039a3.609,3.609,0,0,1,1.392-1.4,4,4,0,0,1,1.987-.488,3.407,3.407,0,0,1,2.607.928,4.213,4.213,0,0,1,.869,2.949V0Zm13.174-5.322a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1,436.44.2a4.5,4.5,0,0,1-2.461-.674,4.31,4.31,0,0,1-1.631-1.934,7.034,7.034,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1,441.177-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413,3.257,3.257,0,0,0,2.72,1.226,3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408,3.3,3.3,0,0,0-2.729-1.211,3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0,432.8-5.322Zm15.8-5.5a4.05,4.05,0,0,1,3.354,1.4,6.414,6.414,0,0,1,1.128,4.1,6.246,6.246,0,0,1-1.187,4.082A4.086,4.086,0,0,1,448.56.2a4.384,4.384,0,0,1-2.041-.469A3.575,3.575,0,0,1,445.083-1.6H445L444.722,0h-.605V-15.2h.967v3.818q0,.859-.039,1.582l-.029.83h.068a3.876,3.876,0,0,1,1.46-1.406A4.367,4.367,0,0,1,448.6-10.82Zm-.02.879a3.15,3.15,0,0,0-2.686,1.074,5.99,5.99,0,0,0-.811,3.545v.166a5.522,5.522,0,0,0,.845,3.447A3.184,3.184,0,0,0,448.56-.664a3.021,3.021,0,0,0,2.617-1.216,5.843,5.843,0,0,0,.879-3.462Q452.056-9.941,448.579-9.941ZM456.987,0h-.967V-10.615h.967Zm-1.1-13.564q0-.937.615-.937a.546.546,0,0,1,.474.244,1.2,1.2,0,0,1,.171.693,1.228,1.228,0,0,1-.171.693.541.541,0,0,1-.474.254Q455.884-12.617,455.884-13.564ZM461.509,0h-.967V-15.2h.967Zm7.842.2a4.625,4.625,0,0,1-3.608-1.426,5.73,5.73,0,0,1-1.294-3.994,6.227,6.227,0,0,1,1.25-4.067,4.126,4.126,0,0,1,3.369-1.528,3.638,3.638,0,0,1,2.959,1.309,5.4,5.4,0,0,1,1.084,3.555v.781h-7.646a5.022,5.022,0,0,0,1.021,3.34,3.592,3.592,0,0,0,2.866,1.152,8.89,8.89,0,0,0,1.6-.127,9.7,9.7,0,0,0,1.743-.547v.879a7.775,7.775,0,0,1-1.66.532A9.214,9.214,0,0,1,469.351.2Zm-.283-10.156a3.18,3.18,0,0,0-2.461,1.011,4.767,4.767,0,0,0-1.084,2.915h6.563a4.629,4.629,0,0,0-.8-2.886A2.641,2.641,0,0,0,469.067-9.961Zm11.191,4.482a15.133,15.133,0,0,1,.757-4.844,12.041,12.041,0,0,1,2.183-3.955h1.1a13.013,13.013,0,0,0-2.217,4.028,14.552,14.552,0,0,0-.771,4.751,14.087,14.087,0,0,0,2.969,8.662H483.2a11.509,11.509,0,0,1-2.187-3.877A14.74,14.74,0,0,1,480.259-5.479ZM495.64,0l-1.426-3.965h-5.459L487.358,0H484.9l5.342-14.336h2.539L498.12,0ZM493.6-5.977l-1.338-3.887q-.146-.391-.405-1.23t-.356-1.23a21.888,21.888,0,0,1-.771,2.627l-1.289,3.721ZM509.263,0h-2.3V-6.641a2.906,2.906,0,0,0-.5-1.865,1.944,1.944,0,0,0-1.6-.615,2.539,2.539,0,0,0-2.129.859,4.745,4.745,0,0,0-.674,2.881V0h-2.295V-10.8h1.8l.322,1.416H502a3.2,3.2,0,0,1,1.387-1.191,4.647,4.647,0,0,1,1.992-.42q3.887,0,3.887,3.955ZM516.1.2a3.762,3.762,0,0,1-3.154-1.465,6.584,6.584,0,0,1-1.133-4.111,6.606,6.606,0,0,1,1.147-4.136A3.8,3.8,0,0,1,516.138-11a3.724,3.724,0,0,1,3.242,1.572h.117a13.76,13.76,0,0,1-.166-1.836V-15.2h2.3V0h-1.8l-.4-1.416h-.107A3.669,3.669,0,0,1,516.1.2Zm.615-1.855a2.5,2.5,0,0,0,2.061-.8,4.19,4.19,0,0,0,.664-2.583v-.322a4.841,4.841,0,0,0-.664-2.9,2.463,2.463,0,0,0-2.08-.859,2.11,2.11,0,0,0-1.865.981,5.029,5.029,0,0,0-.654,2.8A4.9,4.9,0,0,0,514.81-2.6,2.143,2.143,0,0,0,516.714-1.66ZM530.4-11a5.525,5.525,0,0,1,1.143.1l-.225,2.139a4.337,4.337,0,0,0-1.016-.117,2.939,2.939,0,0,0-2.231.9,3.248,3.248,0,0,0-.854,2.334V0h-2.295V-10.8h1.8l.3,1.9h.117a4.279,4.279,0,0,1,1.4-1.533A3.331,3.331,0,0,1,530.4-11ZM542.72-5.42a5.9,5.9,0,0,1-1.357,4.131A4.864,4.864,0,0,1,537.583.2a5.178,5.178,0,0,1-2.676-.684,4.513,4.513,0,0,1-1.787-1.963A6.685,6.685,0,0,1,532.5-5.42a5.855,5.855,0,0,1,1.348-4.1,4.886,4.886,0,0,1,3.8-1.475,4.758,4.758,0,0,1,3.711,1.509A5.828,5.828,0,0,1,542.72-5.42Zm-7.861,0q0,3.74,2.764,3.74,2.734,0,2.734-3.74,0-3.7-2.754-3.7a2.348,2.348,0,0,0-2.095.957A4.87,4.87,0,0,0,534.858-5.42ZM547.651,0h-2.295V-10.8h2.295ZM545.22-13.662a1.271,1.271,0,0,1,.337-.947,1.313,1.313,0,0,1,.962-.332,1.285,1.285,0,0,1,.942.332,1.271,1.271,0,0,1,.337.947,1.247,1.247,0,0,1-.337.923,1.274,1.274,0,0,1-.942.337,1.3,1.3,0,0,1-.962-.337A1.247,1.247,0,0,1,545.22-13.662ZM554.575.2a3.762,3.762,0,0,1-3.154-1.465,6.584,6.584,0,0,1-1.133-4.111,6.606,6.606,0,0,1,1.147-4.136A3.8,3.8,0,0,1,554.614-11a3.724,3.724,0,0,1,3.242,1.572h.117a13.76,13.76,0,0,1-.166-1.836V-15.2h2.3V0h-1.8l-.4-1.416h-.107A3.669,3.669,0,0,1,554.575.2Zm.615-1.855a2.5,2.5,0,0,0,2.061-.8,4.19,4.19,0,0,0,.664-2.583v-.322a4.841,4.841,0,0,0-.664-2.9,2.463,2.463,0,0,0-2.08-.859,2.11,2.11,0,0,0-1.865.981,5.029,5.029,0,0,0-.654,2.8,4.9,4.9,0,0,0,.635,2.739A2.143,2.143,0,0,0,555.19-1.66ZM573.306.2a5.225,5.225,0,0,1-3.94-1.47,5.579,5.579,0,0,1-1.421-4.048,6.121,6.121,0,0,1,1.318-4.16A4.554,4.554,0,0,1,572.886-11a4.451,4.451,0,0,1,3.379,1.3,4.963,4.963,0,0,1,1.24,3.574v1.24h-7.2a3.547,3.547,0,0,0,.85,2.417,2.959,2.959,0,0,0,2.256.845A8.328,8.328,0,0,0,575.2-1.8a9.343,9.343,0,0,0,1.772-.6V-.537a7.046,7.046,0,0,1-1.7.566A10.42,10.42,0,0,1,573.306.2Zm-.42-9.453a2.306,2.306,0,0,0-1.753.693,3.3,3.3,0,0,0-.786,2.021h4.9a2.989,2.989,0,0,0-.645-2.026A2.2,2.2,0,0,0,572.886-9.258ZM587.6,0h-2.295V-10.8H587.6Zm-2.432-13.662a1.271,1.271,0,0,1,.337-.947,1.313,1.313,0,0,1,.962-.332,1.285,1.285,0,0,1,.942.332,1.271,1.271,0,0,1,.337.947,1.247,1.247,0,0,1-.337.923,1.274,1.274,0,0,1-.942.337,1.3,1.3,0,0,1-.962-.337A1.247,1.247,0,0,1,585.171-13.662Zm18.633,6.5a7.81,7.81,0,0,1-1.743,5.42A6.3,6.3,0,0,1,597.124.2a6.348,6.348,0,0,1-4.966-1.919,7.859,7.859,0,0,1-1.733-5.454,7.737,7.737,0,0,1,1.743-5.43,6.423,6.423,0,0,1,4.976-1.895,6.293,6.293,0,0,1,4.922,1.924A7.8,7.8,0,0,1,603.8-7.158Zm-10.9,0a6.4,6.4,0,0,0,1.064,4A3.758,3.758,0,0,0,597.124-1.8a3.751,3.751,0,0,0,3.14-1.348,6.413,6.413,0,0,0,1.06-4.014,6.427,6.427,0,0,0-1.05-3.984,3.712,3.712,0,0,0-3.13-1.357,3.789,3.789,0,0,0-3.169,1.357A6.34,6.34,0,0,0,592.905-7.158Zm22.2,3.281a3.593,3.593,0,0,1-1.377,2.988A5.993,5.993,0,0,1,609.927.2a9.064,9.064,0,0,1-3.965-.752V-2.764a10.777,10.777,0,0,0,2.075.723,8.8,8.8,0,0,0,2.046.264,3.255,3.255,0,0,0,2.046-.527,1.72,1.72,0,0,0,.659-1.416,1.775,1.775,0,0,0-.605-1.357,9.115,9.115,0,0,0-2.5-1.318A6.614,6.614,0,0,1,606.929-8.2a3.823,3.823,0,0,1-.8-2.441,3.419,3.419,0,0,1,1.27-2.812,5.266,5.266,0,0,1,3.408-1.025,10.014,10.014,0,0,1,4.082.9l-.742,1.9a8.918,8.918,0,0,0-3.4-.8,2.608,2.608,0,0,0-1.719.493,1.62,1.62,0,0,0-.586,1.3,1.835,1.835,0,0,0,.234.952,2.394,2.394,0,0,0,.771.747,13.052,13.052,0,0,0,1.934.928,10.58,10.58,0,0,1,2.3,1.221,3.59,3.59,0,0,1,1.074,1.279A3.848,3.848,0,0,1,615.1-3.877Zm5.518-1.6a14.716,14.716,0,0,1-.757,4.785,11.447,11.447,0,0,1-2.183,3.857H616.6A14.087,14.087,0,0,0,619.565-5.5a14.581,14.581,0,0,0-.771-4.761,12.89,12.89,0,0,0-2.217-4.019h1.1a11.979,11.979,0,0,1,2.188,3.97A15.205,15.205,0,0,1,620.62-5.479ZM623-.762q0-.957.781-.957.8,0,.8.957t-.8.957Q623,.2,623-.762Z\" transform=\"translate(683 574)\"/>\r\n    <g id=\"LineColor\" transform=\"translate(0 536)\">\r\n      <g id=\"Line_Color\" data-name=\"Line Color\">\r\n        <rect id=\"Retângulo_61\" data-name=\"Retângulo 61\" class=\"hmb-cls-3\" width=\"454.86\" height=\"5\" transform=\"translate(705.511)\"/>\r\n        <rect id=\"Retângulo_62\" data-name=\"Retângulo 62\" class=\"hmb-cls-4\" width=\"326.97\" height=\"5\" transform=\"translate(526.807)\"/>\r\n        <rect id=\"Retângulo_63\" data-name=\"Retângulo 63\" class=\"hmb-cls-5\" width=\"424.01\" height=\"5\" transform=\"translate(241.765)\"/>\r\n        <rect id=\"Retângulo_64\" data-name=\"Retângulo 64\" class=\"hmb-cls-6\" width=\"383.38\" height=\"5\"/>\r\n        <rect id=\"Retângulo_65\" data-name=\"Retângulo 65\" class=\"hmb-cls-7\" width=\"334.38\" height=\"5\" transform=\"translate(1033.041)\"/>\r\n      </g>\r\n    </g>\r\n    <g id=\"botaoComprar\" transform=\"translate(504.243 407.23)\">\r\n      <g id=\"button_sombra\" transform=\"translate(0 6.511)\">\r\n        <path id=\"Caminho_28305\" data-name=\"Caminho 28305\" class=\"hmb-cls-8\" d=\"M365.81,381H652.287a35.789,35.789,0,0,1,35.81,35.81h0a35.789,35.789,0,0,1-35.81,35.81H365.81A35.789,35.789,0,0,1,330,416.81h0A35.789,35.789,0,0,1,365.81,381Z\" transform=\"translate(-330 -381)\"/>\r\n      </g>\r\n      <g id=\"button\">\r\n        <path id=\"Caminho_28306\" data-name=\"Caminho 28306\" class=\"hmb-cls-9\" d=\"M365.81,376H652.287a35.789,35.789,0,0,1,35.81,35.81h0a35.789,35.789,0,0,1-35.81,35.81H365.81A35.789,35.789,0,0,1,330,411.81h0A35.789,35.789,0,0,1,365.81,376Z\" transform=\"translate(-330 -376)\"/>\r\n      </g>\r\n      <g id=\"Seta_Direita\" transform=\"translate(305.394 15.01)\">\r\n        <g id=\"Elipse_3\" transform=\"translate(1.777 1.747)\">\r\n          <g id=\"Grupo_52\" data-name=\"Grupo 52\">\r\n            <circle id=\"Elipse_15\" data-name=\"Elipse 15\" class=\"hmb-cls-10\" cx=\"19.595\" cy=\"19.595\" r=\"19.595\"/>\r\n          </g>\r\n          <g id=\"Grupo_53\" data-name=\"Grupo 53\" transform=\"translate(0.141 0.172)\">\r\n            <path id=\"Caminho_28317\" data-name=\"Caminho 28317\" class=\"hmb-cls-2\" d=\"M19.533,39.065A19.533,19.533,0,1,1,39.065,19.533,19.506,19.506,0,0,1,19.533,39.065Zm0-36.461A16.928,16.928,0,1,0,36.461,19.533,16.894,16.894,0,0,0,19.533,2.6Z\"/>\r\n          </g>\r\n        </g>\r\n        <g id=\"ic-chevron-right-48px\">\r\n          <g id=\"Caminho_892\" transform=\"translate(15.366 10.678)\">\r\n            <path id=\"Caminho_28318\" data-name=\"Caminho 28318\" class=\"hmb-cls-2\" d=\"M14.274,8.2,11.8,10.674l8.2,8.2-8.2,8.2,2.474,2.474L24.952,18.878Z\" transform=\"translate(-11.8 -8.2)\"/>\r\n          </g>\r\n          <g id=\"Caminho_893\">\r\n            <path id=\"Caminho_28319\" data-name=\"Caminho 28319\" class=\"hmb-cls-10\" d=\"M0,0H42.841V42.841H0Z\"/>\r\n          </g>\r\n        </g>\r\n      </g>\r\n      <path id=\"QueroAgora\" class=\"hmb-cls-2\" d=\"M18.09-48.348a15.718,15.718,0,0,1,6.416,1.209,12.9,12.9,0,0,1,4.53,3.259,13.711,13.711,0,0,1,2.706,4.715,17.147,17.147,0,0,1,.9,5.535,16.8,16.8,0,0,1-.8,5.1,14.49,14.49,0,0,1-2.4,4.571l3.567,3.485-1.968,2.05-3.608-3.526a12.942,12.942,0,0,1-4.079,2.255,16.688,16.688,0,0,1-5.268.861A16.079,16.079,0,0,1,11.653-20.1a13.289,13.289,0,0,1-4.571-3.28,13.256,13.256,0,0,1-2.706-4.735,17.185,17.185,0,0,1-.84-5.637,16.5,16.5,0,0,1,.922-5.473A13.8,13.8,0,0,1,7.184-43.9a13.028,13.028,0,0,1,4.53-3.239A15.607,15.607,0,0,1,18.09-48.348Zm0,2.706a12.136,12.136,0,0,0-4.879.943,10.825,10.825,0,0,0-3.69,2.583A11.337,11.337,0,0,0,7.2-38.324a13.141,13.141,0,0,0-.8,4.612,14.61,14.61,0,0,0,.717,4.571A11.143,11.143,0,0,0,9.3-25.265a10.567,10.567,0,0,0,3.649,2.685,12.689,12.689,0,0,0,5.145,1.045,12.689,12.689,0,0,0,5.145-1.045,10.445,10.445,0,0,0,3.649-2.706,11.394,11.394,0,0,0,2.173-3.874,13.524,13.524,0,0,0,.676-4.51,14.684,14.684,0,0,0-.717-4.633A10.547,10.547,0,0,0,26.843-42.1a10.549,10.549,0,0,0-3.628-2.583A12.562,12.562,0,0,0,18.09-45.642Zm22.386,6.191v11.357a6.523,6.523,0,0,0,1.783,4.92,6.566,6.566,0,0,0,4.858,1.681,6.588,6.588,0,0,0,2.685-.533A6.315,6.315,0,0,0,51.893-23.5,6.85,6.85,0,0,0,53.267-25.7a7.382,7.382,0,0,0,.492-2.726V-39.451h2.706V-19.2H53.923l-.082-3.4a7.713,7.713,0,0,1-3.157,2.87,9.633,9.633,0,0,1-4.018.943,9.63,9.63,0,0,1-3.608-.656,8.318,8.318,0,0,1-2.829-1.845,8.2,8.2,0,0,1-1.845-2.89,10.711,10.711,0,0,1-.656-3.874v-11.4ZM82.008-28.135H64.378a7.267,7.267,0,0,0,.779,2.849,6.92,6.92,0,0,0,1.681,2.111A7.23,7.23,0,0,0,69.2-21.862a8.83,8.83,0,0,0,2.849.451,10.238,10.238,0,0,0,1.886-.184,11.25,11.25,0,0,0,1.906-.533,9.213,9.213,0,0,0,1.722-.861A5.166,5.166,0,0,0,78.892-24.2l1.845,1.64a9.288,9.288,0,0,1-3.895,2.829,12.919,12.919,0,0,1-4.8.943,11.6,11.6,0,0,1-4.182-.738,9.518,9.518,0,0,1-3.321-2.111,9.847,9.847,0,0,1-2.193-3.321,11.4,11.4,0,0,1-.8-4.366,11.054,11.054,0,0,1,.779-4.182,10.024,10.024,0,0,1,2.152-3.321A9.69,9.69,0,0,1,67.76-39a10.389,10.389,0,0,1,4.161-.738,11.9,11.9,0,0,1,4.223.656,8.63,8.63,0,0,1,3.362,2.132A9.035,9.035,0,0,1,81.6-33.322,13.034,13.034,0,0,1,82.008-28.135Zm-17.63-2.337H79.425a7.385,7.385,0,0,0-.635-2.931,6.208,6.208,0,0,0-1.6-2.152,6.96,6.96,0,0,0-2.357-1.312,9.017,9.017,0,0,0-2.87-.451,7.582,7.582,0,0,0-5.125,1.763A7.645,7.645,0,0,0,64.378-30.472Zm25.092-8.979.164,3.321a5.975,5.975,0,0,1,1.209-1.722,6.3,6.3,0,0,1,1.578-1.127,7.037,7.037,0,0,1,1.8-.615,9.6,9.6,0,0,1,1.845-.184,8.17,8.17,0,0,1,2.439.328,7.879,7.879,0,0,1,2.152,1.107l-1.271,2.3a6.031,6.031,0,0,0-3.485-1.066,6.178,6.178,0,0,0-2.46.492,6.275,6.275,0,0,0-1.988,1.332,6.217,6.217,0,0,0-1.332,2.009,6.537,6.537,0,0,0-.492,2.562V-19.2H86.886V-39.451Zm22.919-.287a11.045,11.045,0,0,1,4.12.758,9.658,9.658,0,0,1,3.3,2.152A10.074,10.074,0,0,1,122-33.486a11.177,11.177,0,0,1,.8,4.284,11.278,11.278,0,0,1-.779,4.264,9.644,9.644,0,0,1-2.173,3.3,9.559,9.559,0,0,1-3.3,2.111,11.432,11.432,0,0,1-4.161.738,11.316,11.316,0,0,1-4.12-.738,9.559,9.559,0,0,1-3.3-2.111,9.894,9.894,0,0,1-2.193-3.3,11.023,11.023,0,0,1-.8-4.264,11.436,11.436,0,0,1,.779-4.284,9.977,9.977,0,0,1,2.152-3.341,9.444,9.444,0,0,1,3.28-2.152A11.272,11.272,0,0,1,112.388-39.738Zm0,2.5a7.909,7.909,0,0,0-3.1.594,7.226,7.226,0,0,0-2.439,1.66,7.332,7.332,0,0,0-1.578,2.542,9.156,9.156,0,0,0-.553,3.239,8.7,8.7,0,0,0,.574,3.218,7.343,7.343,0,0,0,1.578,2.48,6.816,6.816,0,0,0,2.419,1.578,8.423,8.423,0,0,0,3.1.553,8.379,8.379,0,0,0,3.116-.553,7.067,7.067,0,0,0,2.419-1.578,6.949,6.949,0,0,0,1.578-2.48,8.989,8.989,0,0,0,.553-3.218,8.864,8.864,0,0,0-.574-3.239,7.761,7.761,0,0,0-1.578-2.542,7.01,7.01,0,0,0-2.419-1.66A7.909,7.909,0,0,0,112.388-37.237Zm45.222,11.4H140.965L138.013-19.2h-3.034l12.874-28.7h2.87L163.6-19.2h-3.034Zm-15.5-2.624h14.35l-7.175-16.318Zm42.065-12.218,1.886,1.558-2.173,2.583a13.006,13.006,0,0,1,1.927,2.788,8.617,8.617,0,0,1,.779,3.936,9.8,9.8,0,0,1-.369,2.665,8.721,8.721,0,0,1-1.127,2.46,8.37,8.37,0,0,1-1.906,2.029,8.082,8.082,0,0,1-2.706,1.332,9.225,9.225,0,0,1,4.428,2.439,5.9,5.9,0,0,1,1.558,4.2,6.294,6.294,0,0,1-.881,3.362,7.751,7.751,0,0,1-2.316,2.4,10.792,10.792,0,0,1-3.321,1.455,15.367,15.367,0,0,1-3.895.492A14.354,14.354,0,0,1,172-7.533a9.5,9.5,0,0,1-3.259-1.64,7.757,7.757,0,0,1-2.152-2.644,7.777,7.777,0,0,1-.779-3.526h2.747a4.917,4.917,0,0,0,.615,2.5,5.442,5.442,0,0,0,1.66,1.783,7.488,7.488,0,0,0,2.419,1.066,11.375,11.375,0,0,0,2.808.348,13.5,13.5,0,0,0,2.767-.287,8.584,8.584,0,0,0,2.439-.881,5.175,5.175,0,0,0,1.742-1.558,3.928,3.928,0,0,0,.676-2.316A4.017,4.017,0,0,0,183.03-17a5.314,5.314,0,0,0-1.742-1.6,8.53,8.53,0,0,0-2.46-.943,12.63,12.63,0,0,0-2.767-.307,12.983,12.983,0,0,1-4.284-.676,9.75,9.75,0,0,1-3.362-1.947,8.646,8.646,0,0,1-2.193-3.116,10.774,10.774,0,0,1-.779-4.223,9.465,9.465,0,0,1,.943-4.325,9.578,9.578,0,0,1,2.46-3.116,10.342,10.342,0,0,1,3.4-1.865,12.23,12.23,0,0,1,3.813-.615,15.082,15.082,0,0,1,1.537.082,10.914,10.914,0,0,1,1.6.287,11.269,11.269,0,0,1,1.537.512,6.645,6.645,0,0,1,1.312.717ZM176.06-37.2a9.4,9.4,0,0,0-2.788.43,7.387,7.387,0,0,0-2.521,1.353,6.978,6.978,0,0,0-1.824,2.316,7.251,7.251,0,0,0-.7,3.28,8.073,8.073,0,0,0,.615,3.28,6.578,6.578,0,0,0,1.66,2.316,6.759,6.759,0,0,0,2.48,1.373,10.2,10.2,0,0,0,3.075.451,8.281,8.281,0,0,0,3.2-.594,7.656,7.656,0,0,0,2.46-1.6,6.945,6.945,0,0,0,1.578-2.357,7.506,7.506,0,0,0,.553-2.87,7.634,7.634,0,0,0-.656-3.28,6.563,6.563,0,0,0-1.742-2.3,7.382,7.382,0,0,0-2.5-1.353A9.46,9.46,0,0,0,176.06-37.2Zm24.8-2.542a11.045,11.045,0,0,1,4.12.758,9.658,9.658,0,0,1,3.3,2.152,10.074,10.074,0,0,1,2.193,3.341,11.177,11.177,0,0,1,.8,4.284,11.278,11.278,0,0,1-.779,4.264,9.644,9.644,0,0,1-2.173,3.3,9.559,9.559,0,0,1-3.3,2.111,11.432,11.432,0,0,1-4.161.738,11.316,11.316,0,0,1-4.12-.738,9.559,9.559,0,0,1-3.3-2.111,9.894,9.894,0,0,1-2.193-3.3,11.023,11.023,0,0,1-.8-4.264,11.436,11.436,0,0,1,.779-4.284,9.977,9.977,0,0,1,2.152-3.341,9.444,9.444,0,0,1,3.28-2.152A11.272,11.272,0,0,1,200.865-39.738Zm0,2.5a7.909,7.909,0,0,0-3.1.594,7.226,7.226,0,0,0-2.439,1.66,7.332,7.332,0,0,0-1.578,2.542A9.156,9.156,0,0,0,193.2-29.2a8.7,8.7,0,0,0,.574,3.218,7.344,7.344,0,0,0,1.578,2.48,6.816,6.816,0,0,0,2.419,1.578,8.423,8.423,0,0,0,3.1.553,8.379,8.379,0,0,0,3.116-.553A7.067,7.067,0,0,0,206.4-23.5a6.949,6.949,0,0,0,1.578-2.48,8.988,8.988,0,0,0,.553-3.218,8.863,8.863,0,0,0-.574-3.239,7.761,7.761,0,0,0-1.578-2.542,7.01,7.01,0,0,0-2.419-1.66A7.909,7.909,0,0,0,200.865-37.237Zm18.081-2.214.164,3.321a5.975,5.975,0,0,1,1.209-1.722A6.3,6.3,0,0,1,221.9-38.98a7.037,7.037,0,0,1,1.8-.615,9.6,9.6,0,0,1,1.845-.184,8.17,8.17,0,0,1,2.439.328,7.878,7.878,0,0,1,2.152,1.107l-1.271,2.3a6.032,6.032,0,0,0-3.485-1.066,6.178,6.178,0,0,0-2.46.492,6.275,6.275,0,0,0-1.988,1.332,6.217,6.217,0,0,0-1.332,2.009,6.537,6.537,0,0,0-.492,2.562V-19.2h-2.747V-39.451Zm31.569,4.018v-4.018H253.1V-19.2h-2.542v-4.018a8.429,8.429,0,0,1-1.578,1.947,9.561,9.561,0,0,1-1.968,1.394,9.035,9.035,0,0,1-2.193.82,10.123,10.123,0,0,1-2.3.266,10.879,10.879,0,0,1-4.038-.738,9.87,9.87,0,0,1-3.28-2.111,9.7,9.7,0,0,1-2.214-3.321,11.4,11.4,0,0,1-.8-4.366,10.89,10.89,0,0,1,.82-4.3,9.921,9.921,0,0,1,2.214-3.28A9.758,9.758,0,0,1,238.5-39a11.04,11.04,0,0,1,4.059-.738,10.664,10.664,0,0,1,2.337.266,9.447,9.447,0,0,1,2.234.8,8.463,8.463,0,0,1,1.927,1.353A7.256,7.256,0,0,1,250.515-35.433Zm-7.872-1.8a7.937,7.937,0,0,0-3.013.574,7.5,7.5,0,0,0-2.46,1.6,7.236,7.236,0,0,0-1.64,2.5,8.591,8.591,0,0,0-.595,3.239,8.548,8.548,0,0,0,.595,3.259,7.5,7.5,0,0,0,1.64,2.5,7.342,7.342,0,0,0,2.46,1.619,7.937,7.937,0,0,0,3.013.574,7.673,7.673,0,0,0,4.366-1.168,7.422,7.422,0,0,0,2.6-2.931,8.617,8.617,0,0,0,.861-3.833,8.617,8.617,0,0,0-.861-3.833,7.422,7.422,0,0,0-2.6-2.931A7.673,7.673,0,0,0,242.643-37.237ZM262.938-47.9V-25.47h-2.911V-47.9Zm-3.4,26.9a1.8,1.8,0,0,1,.635-1.517,2.227,2.227,0,0,1,1.394-.492,2.227,2.227,0,0,1,1.394.492A1.8,1.8,0,0,1,263.594-21a1.809,1.809,0,0,1-.635,1.5,2.172,2.172,0,0,1-1.394.512,2.172,2.172,0,0,1-1.394-.512A1.809,1.809,0,0,1,259.535-21Z\" transform=\"translate(22.994 68.512)\"/>\r\n    </g>\r\n    <g id=\"TextoCentro\">\r\n      <path id=\"SloganFooter\" class=\"hmb-cls-11\" d=\"M-589.366-23.688h15.7V-25.55H-591.3V0h18.068V-1.9h-16.133V-11.972H-574.4V-13.76h-14.965ZM-563.378,0h1.971l7.556-18.031h-1.971l-6.57,15.951-6.57-15.951h-1.971Zm14.272-18.1V0h-1.789V-18.1Zm-2.3-5.8a1.442,1.442,0,0,1,2.883,0A1.442,1.442,0,0,1-551.406-23.907Zm9.782.62v5.256h-3.833v1.5h3.833V-5.548c0,3.54,1.241,5.8,5.073,5.8a7.882,7.882,0,0,0,3.395-.912l-.621-1.46a6.688,6.688,0,0,1-2.774.73c-2.81,0-3.321-1.715-3.321-4.161V-16.535h6.132v-1.5h-6.132v-5.438ZM-521.476.256A9.912,9.912,0,0,0-513.7-3.212l-1.278-1.022c-1.35,1.788-4.125,2.737-6.5,2.737a7.094,7.094,0,0,1-7.336-6.68h16.242c.694-7.044-3.832-10.147-8.906-10.147a9.065,9.065,0,0,0-9.161,9.307A8.843,8.843,0,0,0-521.476.256Zm-7.336-10a7.207,7.207,0,0,1,7.336-6.935c4.344,0,7.264,2.482,7.3,6.935ZM-494.283,0V-16.316h5.949v-1.569h-5.949v-1.606c0-3.139,1.314-4.526,3.577-4.526a4.935,4.935,0,0,1,2.774.913l.876-1.314a5.9,5.9,0,0,0-3.577-1.241c-3.978,0-5.4,2.591-5.4,6.169v1.606h-3.686v1.569h3.686V0Zm11.57-18.1V0H-484.5V-18.1Zm-2.3-5.8a1.442,1.442,0,0,1,2.884,0A1.442,1.442,0,0,1-485.012-23.907Zm7.41-1.642V0h1.788V-25.55Zm22.338,7.519v3.942a8.18,8.18,0,0,0-7.373-4.161A8.959,8.959,0,0,0-471.8-9.016,9.021,9.021,0,0,0-462.638.292a8.43,8.43,0,0,0,7.373-4.125V0h1.789V-18.031Zm-7.373,1.5c10.038,0,10.038,15.075,0,15.075a7.241,7.241,0,0,1-7.373-7.556A7.211,7.211,0,0,1-462.638-16.535Zm27.485.621a9.449,9.449,0,0,0-6.716-2.409c-3.65-.037-7.191,1.5-7.154,5.037.036,3.613,3.5,4.27,7.008,4.854,2.956.475,5.949.986,5.876,3.577-.109,2.847-3.431,3.431-5.621,3.431a8,8,0,0,1-6.607-3.066l-1.314,1.168C-448.111-.913-444.972.292-441.8.292s7.3-1.059,7.409-5.037c.182-4.2-4.234-4.745-7.446-5.293-2.263-.4-5.4-.876-5.475-3.285-.073-2.3,2.628-3.358,5.439-3.321a7.709,7.709,0,0,1,5.621,1.9ZM-412.231.256a9.912,9.912,0,0,0,7.775-3.467l-1.277-1.022c-1.351,1.788-4.125,2.737-6.5,2.737a7.094,7.094,0,0,1-7.337-6.68h16.243c.693-7.044-3.833-10.147-8.906-10.147a9.065,9.065,0,0,0-9.161,9.307A8.843,8.843,0,0,0-412.231.256Zm-7.337-10a7.207,7.207,0,0,1,7.337-6.935c4.344,0,7.263,2.482,7.3,6.935Zm40.077,8.358a7.257,7.257,0,0,1-7.3-7.592,7.215,7.215,0,0,1,7.3-7.592c4.088,0,7.373,2.482,7.373,7.555S-375.4-1.387-379.491-1.387Zm-7.446,8.906V-4.161A8.138,8.138,0,0,0-379.491.328c5.073,0,9.161-3.285,9.161-9.344,0-5.8-3.869-9.089-8.76-9.271A8.594,8.594,0,0,0-386.9-13.76v-4.271h-1.752V7.519Zm36.536-25.55v3.942a8.18,8.18,0,0,0-7.373-4.161,8.959,8.959,0,0,0-9.161,9.234A9.021,9.021,0,0,0-357.773.292,8.43,8.43,0,0,0-350.4-3.832V0h1.789V-18.031Zm-7.373,1.5c10.038,0,10.038,15.075,0,15.075a7.241,7.241,0,0,1-7.373-7.556A7.211,7.211,0,0,1-357.773-16.535Zm14.016-1.5V0h1.788V-10.512a5.989,5.989,0,0,1,5.95-6.023,5.8,5.8,0,0,1,3.066.839l.8-1.46a7.04,7.04,0,0,0-3.869-1.059,6.344,6.344,0,0,0-5.986,3.395l-.073-3.212Zm29.857,0v3.942a8.18,8.18,0,0,0-7.373-4.161,8.959,8.959,0,0,0-9.161,9.234A9.021,9.021,0,0,0-321.273.292,8.43,8.43,0,0,0-313.9-3.832V0h1.789V-18.031Zm-7.373,1.5c10.038,0,10.038,15.075,0,15.075a7.241,7.241,0,0,1-7.373-7.556A7.211,7.211,0,0,1-321.273-16.535Zm22.155-.073a7.221,7.221,0,0,1,7.373,7.556,7.21,7.21,0,0,1-7.373,7.592c-4.052,0-7.373-2.555-7.373-7.556C-306.491-14.089-303.169-16.608-299.118-16.608Zm7.409-8.942v11.461a7.982,7.982,0,0,0-7.482-4.234c-5.037,0-9.052,3.358-9.052,9.307,0,5.986,3.978,9.308,9.016,9.308a8.49,8.49,0,0,0,7.519-4.27V0h1.752V-25.55Zm22.448,7.519v3.942a8.18,8.18,0,0,0-7.373-4.161A8.959,8.959,0,0,0-285.8-9.016,9.021,9.021,0,0,0-276.634.292a8.43,8.43,0,0,0,7.373-4.125V0h1.789V-18.031Zm-7.373,1.5c10.038,0,10.038,15.075,0,15.075a7.241,7.241,0,0,1-7.373-7.556A7.211,7.211,0,0,1-276.634-16.535Zm27.484.621a9.449,9.449,0,0,0-6.716-2.409c-3.65-.037-7.191,1.5-7.154,5.037.036,3.613,3.5,4.27,7.008,4.854,2.956.475,5.949.986,5.876,3.577-.109,2.847-3.431,3.431-5.621,3.431a8,8,0,0,1-6.607-3.066l-1.314,1.168c1.569,2.409,4.708,3.613,7.884,3.613s7.3-1.059,7.409-5.037c.183-4.2-4.234-4.745-7.446-5.293-2.263-.4-5.4-.876-5.475-3.285-.073-2.3,2.628-3.358,5.438-3.321a7.709,7.709,0,0,1,5.621,1.9Zm14.783-2.117V0h1.788V-10.038a6.266,6.266,0,0,1,6.314-6.57c3.906-.036,6.424,2.154,6.424,6.241V0h1.788V-10.4c0-5-3.322-7.957-8.139-7.957a7.174,7.174,0,0,0-6.424,3.541v-3.212ZM-205.057.256A8.813,8.813,0,0,0-195.9-8.979a8.934,8.934,0,0,0-9.161-9.381,8.934,8.934,0,0,0-9.161,9.381A8.813,8.813,0,0,0-205.057.256Zm0-1.752a7.126,7.126,0,0,1-7.41-7.483,7.309,7.309,0,0,1,7.41-7.7,7.309,7.309,0,0,1,7.41,7.7A7.126,7.126,0,0,1-205.057-1.5ZM-178.3-15.914a9.449,9.449,0,0,0-6.716-2.409c-3.65-.037-7.19,1.5-7.154,5.037.036,3.613,3.5,4.27,7.008,4.854,2.956.475,5.95.986,5.876,3.577-.109,2.847-3.431,3.431-5.621,3.431a8,8,0,0,1-6.607-3.066l-1.314,1.168c1.569,2.409,4.708,3.613,7.884,3.613s7.3-1.059,7.409-5.037c.183-4.2-4.234-4.745-7.446-5.293-2.263-.4-5.4-.876-5.475-3.285-.073-2.3,2.628-3.358,5.438-3.321a7.709,7.709,0,0,1,5.621,1.9Zm23.944,14.527a7.257,7.257,0,0,1-7.3-7.592,7.214,7.214,0,0,1,7.3-7.592c4.088,0,7.373,2.482,7.373,7.555S-150.271-1.387-154.359-1.387ZM-161.8,7.519V-4.161A8.138,8.138,0,0,0-154.359.328c5.073,0,9.161-3.285,9.161-9.344,0-5.8-3.869-9.089-8.76-9.271a8.594,8.594,0,0,0-7.811,4.526v-4.271h-1.752V7.519ZM-132.678.256A9.912,9.912,0,0,0-124.9-3.212l-1.278-1.022c-1.35,1.788-4.124,2.737-6.5,2.737a7.094,7.094,0,0,1-7.337-6.68h16.243c.693-7.044-3.833-10.147-8.906-10.147a9.065,9.065,0,0,0-9.161,9.307A8.843,8.843,0,0,0-132.678.256Zm-7.337-10a7.207,7.207,0,0,1,7.337-6.935c4.343,0,7.263,2.482,7.3,6.935ZM-111-16.608a7.221,7.221,0,0,1,7.373,7.556A7.21,7.21,0,0,1-111-1.46c-4.052,0-7.373-2.555-7.373-7.556C-118.37-14.089-115.048-16.608-111-16.608Zm7.41-8.942v11.461a7.982,7.982,0,0,0-7.483-4.234c-5.037,0-9.052,3.358-9.052,9.307,0,5.986,3.979,9.308,9.015,9.308a8.49,8.49,0,0,0,7.519-4.27V0h1.752V-25.55Zm24.236,7.519V0H-81.14V-3.832A8.43,8.43,0,0,1-88.513.292a9.021,9.021,0,0,1-9.161-9.308,8.959,8.959,0,0,1,9.161-9.234,8.18,8.18,0,0,1,7.373,4.161v-3.942Zm-9.161,1.5a7.211,7.211,0,0,0-7.373,7.519A7.241,7.241,0,0,0-88.513-1.46C-78.475-1.46-78.475-16.535-88.513-16.535Zm-1.132-4.708v-.146l2.737-4.38h2.373v.036l-3.358,4.49Zm27.886,4.526a9.155,9.155,0,0,0-5.11-1.642c-4.672,0-8.468,3.176-8.468,8.8,0,4.818,3.249,8.723,8.468,8.723,3.358,0,6.826,1.533,6.826,5.4C-60.043,8.4-63.255,10-66.868,10s-6.753-1.752-6.753-5.438h-1.788c0,4.563,3.759,7.191,8.541,7.191s8.577-2.336,8.577-7.191c0-3.1-1.752-5.329-4.928-6.461a8.526,8.526,0,0,0,4.855-7.665A8.451,8.451,0,0,0-60.59-15.7l1.752-2.044-1.168-1.022Zm-5.11.146c3.723,0,6.752,2.445,6.752,7.008a6.919,6.919,0,0,1-6.752,6.935,6.605,6.605,0,0,1-6.68-6.935C-73.548-14.271-70.555-16.571-66.868-16.571ZM-52.889-18.1V0h-1.789V-18.1Zm-2.3-5.8a1.442,1.442,0,0,1,2.884,0A1.442,1.442,0,0,1-55.188-23.907ZM-39.055.256a8.813,8.813,0,0,0,9.162-9.235,8.934,8.934,0,0,0-9.162-9.381,8.934,8.934,0,0,0-9.161,9.381A8.813,8.813,0,0,0-39.055.256Zm0-1.752a7.126,7.126,0,0,1-7.41-7.483,7.309,7.309,0,0,1,7.41-7.7,7.309,7.309,0,0,1,7.41,7.7A7.126,7.126,0,0,1-39.055-1.5ZM-12.3-15.914a9.449,9.449,0,0,0-6.716-2.409c-3.65-.037-7.191,1.5-7.154,5.037.037,3.613,3.5,4.27,7.008,4.854,2.956.475,5.949.986,5.877,3.577-.11,2.847-3.431,3.431-5.621,3.431A8,8,0,0,1-25.514-4.49l-1.314,1.168C-25.258-.913-22.119.292-18.944.292s7.3-1.059,7.41-5.037c.182-4.2-4.234-4.745-7.446-5.293-2.263-.4-5.4-.876-5.475-3.285-.073-2.3,2.628-3.358,5.439-3.321a7.709,7.709,0,0,1,5.621,1.9ZM-8.249-1.1a1.442,1.442,0,0,0,2.884,0A1.442,1.442,0,0,0-8.249-1.1ZM32.229,0,20.768-25.55H18.615L7.154,0H9.271l2.774-6.278H27.3L30.112,0ZM12.811-8.1l6.862-15.549L26.535-8.1Zm35.478-8.614a9.155,9.155,0,0,0-5.11-1.642c-4.672,0-8.468,3.176-8.468,8.8,0,4.818,3.249,8.723,8.468,8.723C46.537-.84,50,.693,50,4.563,50,8.4,46.793,10,43.179,10s-6.753-1.752-6.753-5.438H34.638c0,4.563,3.759,7.191,8.541,7.191s8.577-2.336,8.577-7.191c0-3.1-1.752-5.329-4.928-6.461a8.526,8.526,0,0,0,4.855-7.665A8.451,8.451,0,0,0,49.457-15.7l1.752-2.044-1.168-1.022Zm-5.11.146c3.723,0,6.752,2.445,6.752,7.008a6.919,6.919,0,0,1-6.752,6.935A6.605,6.605,0,0,1,36.5-9.563C36.5-14.271,39.493-16.571,43.179-16.571ZM57.159-18.1V0H55.37V-18.1Zm-2.3-5.8a1.442,1.442,0,0,1,2.884,0A1.442,1.442,0,0,1,54.859-23.907Zm7.41-1.642V0h1.788V-25.55ZM70.846-18.1V0H69.058V-18.1Zm-2.3-5.8a1.442,1.442,0,0,1,2.883,0A1.442,1.442,0,0,1,68.547-23.907Zm15.549,7.3a7.221,7.221,0,0,1,7.373,7.556A7.21,7.21,0,0,1,84.1-1.46c-4.052,0-7.373-2.555-7.373-7.556C76.723-14.089,80.044-16.608,84.1-16.608Zm7.41-8.942v11.461a7.982,7.982,0,0,0-7.483-4.234c-5.037,0-9.052,3.358-9.052,9.307,0,5.986,3.979,9.308,9.015,9.308a8.49,8.49,0,0,0,7.519-4.27V0h1.752V-25.55Zm22.447,7.519v3.942a8.18,8.18,0,0,0-7.373-4.161,8.959,8.959,0,0,0-9.161,9.234A9.021,9.021,0,0,0,106.58.292a8.43,8.43,0,0,0,7.373-4.125V0h1.788V-18.031Zm-7.373,1.5c10.037,0,10.037,15.075,0,15.075a7.241,7.241,0,0,1-7.373-7.556A7.211,7.211,0,0,1,106.58-16.535Zm22.156-.073a7.221,7.221,0,0,1,7.373,7.556,7.21,7.21,0,0,1-7.373,7.592c-4.052,0-7.373-2.555-7.373-7.556C121.362-14.089,124.684-16.608,128.735-16.608Zm7.41-8.942v11.461a7.982,7.982,0,0,0-7.482-4.234c-5.037,0-9.052,3.358-9.052,9.307,0,5.986,3.979,9.308,9.016,9.308a8.49,8.49,0,0,0,7.519-4.27V0H137.9V-25.55ZM151.584.256a9.912,9.912,0,0,0,7.774-3.467l-1.277-1.022c-1.35,1.788-4.124,2.737-6.5,2.737a7.094,7.094,0,0,1-7.337-6.68H160.49c.693-7.044-3.833-10.147-8.906-10.147a9.065,9.065,0,0,0-9.161,9.307A8.843,8.843,0,0,0,151.584.256Zm-7.337-10a7.207,7.207,0,0,1,7.337-6.935c4.343,0,7.263,2.482,7.3,6.935ZM183.3.256a9.912,9.912,0,0,0,7.774-3.467L189.8-4.234c-1.35,1.788-4.124,2.737-6.5,2.737a7.094,7.094,0,0,1-7.337-6.68h16.243c.693-7.044-3.833-10.147-8.906-10.147a9.065,9.065,0,0,0-9.161,9.307A8.843,8.843,0,0,0,183.3.256Zm-7.337-10a7.207,7.207,0,0,1,7.337-6.935c4.343,0,7.263,2.482,7.3,6.935ZM220.46-3.723A7.636,7.636,0,0,1,215.094-1.5a7.14,7.14,0,0,1-7.519-7.519,7.14,7.14,0,0,1,7.519-7.519,7.645,7.645,0,0,1,5.4,2.154l1.168-1.132a9.378,9.378,0,0,0-6.57-2.7c-5.219,0-9.271,3.5-9.271,9.2a8.89,8.89,0,0,0,9.271,9.2,9.223,9.223,0,0,0,6.57-2.7ZM234,.256a8.813,8.813,0,0,0,9.161-9.235A8.934,8.934,0,0,0,234-18.36a8.934,8.934,0,0,0-9.161,9.381A8.813,8.813,0,0,0,234,.256ZM234-1.5a7.126,7.126,0,0,1-7.41-7.483,7.309,7.309,0,0,1,7.41-7.7,7.309,7.309,0,0,1,7.41,7.7A7.126,7.126,0,0,1,234-1.5Zm13.286-16.535V0h1.788V-10.038a6.266,6.266,0,0,1,6.314-6.57c3.905-.036,6.424,2.154,6.424,6.241V0H263.6V-10.4c0-5-3.322-7.957-8.139-7.957a7.174,7.174,0,0,0-6.424,3.541v-3.212ZM271.888,0V-16.316h5.949v-1.569h-5.949v-1.606c0-3.139,1.314-4.526,3.577-4.526a4.935,4.935,0,0,1,2.774.913l.876-1.314a5.9,5.9,0,0,0-3.577-1.241c-3.978,0-5.4,2.591-5.4,6.169v1.606H266.45v1.569h3.686V0Zm16.972.256a8.813,8.813,0,0,0,9.161-9.235,8.934,8.934,0,0,0-9.161-9.381A8.934,8.934,0,0,0,279.7-8.979,8.813,8.813,0,0,0,288.861.256Zm0-1.752a7.126,7.126,0,0,1-7.409-7.483,7.309,7.309,0,0,1,7.409-7.7,7.309,7.309,0,0,1,7.41,7.7A7.126,7.126,0,0,1,288.861-1.5Zm13.286-16.535V0h1.788V-10.512a5.989,5.989,0,0,1,5.95-6.023,5.8,5.8,0,0,1,3.066.839l.8-1.46a7.04,7.04,0,0,0-3.869-1.059,6.344,6.344,0,0,0-5.986,3.395l-.073-3.212Zm17.812-5.256v5.256h-3.833v1.5h3.833V-5.548c0,3.54,1.241,5.8,5.073,5.8a7.881,7.881,0,0,0,3.395-.912l-.62-1.46a6.688,6.688,0,0,1-2.774.73c-2.81,0-3.322-1.715-3.322-4.161V-16.535h6.132v-1.5h-6.132v-5.438ZM340.289.256a8.813,8.813,0,0,0,9.161-9.235,8.934,8.934,0,0,0-9.161-9.381,8.934,8.934,0,0,0-9.161,9.381A8.813,8.813,0,0,0,340.289.256Zm0-1.752a7.126,7.126,0,0,1-7.409-7.483,7.309,7.309,0,0,1,7.409-7.7,7.309,7.309,0,0,1,7.41,7.7A7.126,7.126,0,0,1,340.289-1.5Zm23.324-16.535V0H365.4V-10.038a6.266,6.266,0,0,1,6.315-6.57c3.905-.036,6.424,2.154,6.424,6.241V0h1.789V-10.4c0-5-3.322-7.957-8.139-7.957a7.174,7.174,0,0,0-6.424,3.541v-3.212Zm36.536,0v3.942a8.18,8.18,0,0,0-7.373-4.161,8.959,8.959,0,0,0-9.161,9.234A9.021,9.021,0,0,0,392.776.292a8.43,8.43,0,0,0,7.373-4.125V0h1.789V-18.031Zm-7.373,1.5c10.038,0,10.038,15.075,0,15.075A7.241,7.241,0,0,1,385.4-9.016,7.211,7.211,0,0,1,392.776-16.535Zm27.485.621a9.449,9.449,0,0,0-6.716-2.409c-3.65-.037-7.191,1.5-7.154,5.037.036,3.613,3.5,4.27,7.008,4.854,2.956.475,5.949.986,5.876,3.577-.109,2.847-3.431,3.431-5.621,3.431a8,8,0,0,1-6.607-3.066l-1.314,1.168C407.3-.913,410.442.292,413.618.292s7.3-1.059,7.409-5.037c.182-4.2-4.234-4.745-7.446-5.293-2.263-.4-5.4-.876-5.475-3.285-.073-2.3,2.628-3.358,5.439-3.321a7.709,7.709,0,0,1,5.621,1.9ZM443.183.256a9.912,9.912,0,0,0,7.775-3.467L449.68-4.234c-1.351,1.788-4.125,2.737-6.5,2.737a7.094,7.094,0,0,1-7.337-6.68h16.243c.693-7.044-3.833-10.147-8.906-10.147a9.065,9.065,0,0,0-9.161,9.307A8.843,8.843,0,0,0,443.183.256Zm-7.337-10a7.207,7.207,0,0,1,7.337-6.935c4.344,0,7.263,2.482,7.3,6.935Zm34.347-6.168a9.449,9.449,0,0,0-6.716-2.409c-3.65-.037-7.191,1.5-7.154,5.037.036,3.613,3.5,4.27,7.008,4.854,2.956.475,5.949.986,5.876,3.577-.109,2.847-3.431,3.431-5.621,3.431A8,8,0,0,1,456.98-4.49l-1.314,1.168C457.235-.913,460.374.292,463.55.292s7.3-1.059,7.409-5.037c.182-4.2-4.234-4.745-7.446-5.293-2.263-.4-5.4-.876-5.475-3.285-.073-2.3,2.628-3.358,5.439-3.321a7.709,7.709,0,0,1,5.621,1.9Zm7.117-7.373v5.256h-3.833v1.5h3.833V-5.548c0,3.54,1.241,5.8,5.073,5.8a7.881,7.881,0,0,0,3.395-.912l-.62-1.46a6.688,6.688,0,0,1-2.774.73c-2.81,0-3.322-1.715-3.322-4.161V-16.535h6.132v-1.5h-6.132v-5.438Zm12.008,5.256V0h1.788V-10.512a5.989,5.989,0,0,1,5.95-6.023,5.8,5.8,0,0,1,3.066.839l.8-1.46a7.04,7.04,0,0,0-3.869-1.059,6.344,6.344,0,0,0-5.986,3.395L491-18.031Zm29.857,0v3.942A8.18,8.18,0,0,0,511.8-18.25a8.959,8.959,0,0,0-9.161,9.234A9.021,9.021,0,0,0,511.8.292a8.43,8.43,0,0,0,7.373-4.125V0h1.788V-18.031Zm-7.373,1.5c10.038,0,10.038,15.075,0,15.075a7.241,7.241,0,0,1-7.373-7.556A7.211,7.211,0,0,1,511.8-16.535Zm22.155-.073a7.221,7.221,0,0,1,7.373,7.556,7.21,7.21,0,0,1-7.373,7.592c-4.051,0-7.373-2.555-7.373-7.556C526.585-14.089,529.907-16.608,533.958-16.608Zm7.41-8.942v11.461a7.982,7.982,0,0,0-7.483-4.234c-5.037,0-9.052,3.358-9.052,9.307,0,5.986,3.979,9.308,9.016,9.308a8.49,8.49,0,0,0,7.519-4.27V0h1.752V-25.55Zm22.448,7.519v3.942a8.18,8.18,0,0,0-7.373-4.161,8.959,8.959,0,0,0-9.161,9.234A9.021,9.021,0,0,0,556.442.292a8.43,8.43,0,0,0,7.373-4.125V0H565.6V-18.031Zm-7.373,1.5c10.038,0,10.038,15.075,0,15.075a7.241,7.241,0,0,1-7.373-7.556A7.211,7.211,0,0,1,556.442-16.535Zm27.485.621a9.449,9.449,0,0,0-6.716-2.409c-3.65-.037-7.19,1.5-7.154,5.037.036,3.613,3.5,4.27,7.008,4.854,2.956.475,5.949.986,5.876,3.577-.109,2.847-3.431,3.431-5.621,3.431a8,8,0,0,1-6.607-3.066L569.4-3.321c1.57,2.409,4.708,3.613,7.884,3.613s7.3-1.059,7.409-5.037c.182-4.2-4.234-4.745-7.446-5.293-2.263-.4-5.4-.876-5.475-3.285-.073-2.3,2.628-3.358,5.439-3.321a7.709,7.709,0,0,1,5.621,1.9ZM587.979-1.1a1.442,1.442,0,0,0,2.883,0A1.442,1.442,0,0,0,587.979-1.1Z\" transform=\"translate(683 369)\"/>\r\n      <path id=\"empresas\" class=\"hmb-cls-12\" d=\"M31.886-46.637c1.788-12.069,25.926-11.622,26.671,0ZM45-75.394c-19.966,0-40.975,11.92-40.975,38.74S23.691,1.639,46.935,1.639c12.665,0,24.734-4.023,33.525-12.218L67.05-25.628a30.5,30.5,0,0,1-18.923,5.96c-5.96,0-14.453-2.831-16.39-9.387H83.142C89.4-58.11,71.073-75.394,45-75.394ZM167.625,0V-40.528c0-8.046,4.917-11.175,9.536-11.175,4.023,0,7.6,3.129,7.6,10.877V0h27.416V-40.975c0-24.436-12.218-34.27-28.161-34.27-10.132,0-18.327,2.98-24.436,10.579C155.854-71.52,148.7-74.947,141.252-75.1c-7.6-.149-15.645,2.98-20.264,9.387l-1.937-7.9h-23.1V0h27.267V-40.379c.149-8.046,5.066-11.771,9.685-11.771,4.917,0,7.748,2.831,7.748,11.324V0ZM254.79-6.258c4.023,4.917,11.026,7.9,20.413,7.9,21.456,0,35.76-15.943,35.76-38.442,0-23.244-12.069-36.8-33.674-38.144-8.2-.447-18.029,2.086-24.287,9.238l-1.192-7.9H227.374v104.3H254.79Zm14.155-14.3c-9.685,0-14.751-8.046-14.751-16.986,0-7.748,5.513-15.347,14.751-15.347,8.2,0,14.751,5.811,14.751,16.092S277.14-20.562,268.945-20.562Zm54.236-53.044V0H350.6V-38.293c0-9.685,5.811-13.857,12.665-13.857,4.619,0,7.9.894,12.367,4.47L386.655-67.5a26.631,26.631,0,0,0-19.37-7.9c-7.152,0-14.006,2.98-17.88,9.834l-1.639-8.046Zm92.231,26.969c1.788-12.069,25.926-11.622,26.671,0Zm13.112-28.757c-19.966,0-40.975,11.92-40.975,38.74S407.217,1.639,430.461,1.639c12.665,0,24.734-4.023,33.525-12.218l-13.41-15.049a30.5,30.5,0,0,1-18.923,5.96c-5.96,0-14.453-2.831-16.39-9.387h51.4C472.926-58.11,454.6-75.394,428.524-75.394ZM474.267-7.748c8.344,6.109,22.8,9.685,35.611,9.685,17.731,0,34.27-6.854,34.27-25.032,0-19.519-18.476-23.84-33.823-24.287-4.47-.149-5.513-2.235-5.513-3.576,0-2.682,2.682-3.576,6.556-3.576,5.96-.149,14.453,1.937,18.476,4.47l11.622-16.39c-7.152-5.364-18.178-8.94-30.1-8.94-17.284,0-33.972,6.407-33.972,24.138,0,17.88,17.284,23.691,31.588,24.138,5.364.447,7.748,1.639,7.748,4.023s-2.533,3.576-7.45,3.576a47.862,47.862,0,0,1-26.075-8.2Zm134.7-57.961c-3.874-5.96-11.175-9.536-21.6-9.536-21.456,0-35.76,16.688-35.76,38.442,0,21.456,12.069,36.8,33.674,38.144,8.2.447,18.029-2.086,24.287-9.238L610.751,0h25.33V-73.606H610.3ZM593.616-53.044c9.685,0,15.2,6.407,15.2,16.241,0,8.642-5.96,16.092-15.2,16.092-8.2,0-14.751-5.811-14.751-16.092S585.421-53.044,593.616-53.044Zm53.342,45.3c8.344,6.109,22.8,9.685,35.611,9.685,17.731,0,34.27-6.854,34.27-25.032,0-19.519-18.476-23.84-33.823-24.287-4.47-.149-5.513-2.235-5.513-3.576,0-2.682,2.682-3.576,6.556-3.576,5.96-.149,14.453,1.937,18.476,4.47l11.622-16.39c-7.152-5.364-18.178-8.94-30.1-8.94-17.284,0-33.972,6.407-33.972,24.138,0,17.88,17.284,23.691,31.588,24.138,5.364.447,7.748,1.639,7.748,4.023s-2.533,3.576-7.45,3.576a47.862,47.862,0,0,1-26.075-8.2Z\" transform=\"translate(556 304)\"/>\r\n      <path id=\"para\" class=\"hmb-cls-2\" d=\"M35.224-6.216c4,4.884,10.952,7.844,20.276,7.844,21.312,0,35.52-15.836,35.52-38.184,0-23.088-11.988-36.556-33.448-37.888-8.14-.444-17.908,2.072-24.124,9.176l-1.184-7.844H7.992v103.6H35.224Zm14.06-14.208c-9.62,0-14.652-7.992-14.652-16.872,0-7.7,5.476-15.244,14.652-15.244,8.14,0,14.652,5.772,14.652,15.984S57.424-20.424,49.284-20.424ZM156.14-65.268c-3.848-5.92-11.1-9.472-21.46-9.472-21.312,0-35.52,16.576-35.52,38.184C99.16-15.244,111.148,0,132.608,1.332c8.14.444,17.908-2.072,24.124-9.176L157.916,0h25.16V-73.112h-25.6ZM140.9-52.688c9.62,0,15.1,6.364,15.1,16.132,0,8.584-5.92,15.984-15.1,15.984-8.14,0-14.652-5.772-14.652-15.984S132.756-52.688,140.9-52.688ZM199.06-73.112V0h27.232V-38.036c0-9.62,5.772-13.764,12.58-13.764,4.588,0,7.844.888,12.284,4.44l10.952-19.684a26.453,26.453,0,0,0-19.24-7.844c-7.1,0-13.912,2.96-17.76,9.768l-1.628-7.992Zm120.916,7.844c-3.848-5.92-11.1-9.472-21.46-9.472C277.2-74.74,263-58.164,263-36.556,263-15.244,274.984,0,296.444,1.332c8.14.444,17.908-2.072,24.124-9.176L321.752,0h25.16V-73.112h-25.6Zm-15.244,12.58c9.62,0,15.1,6.364,15.1,16.132,0,8.584-5.92,15.984-15.1,15.984-8.14,0-14.652-5.772-14.652-15.984S296.592-52.688,304.732-52.688Z\" transform=\"translate(199 303)\"/>\r\n      <path id=\"_\" data-name=\"+\" class=\"hmb-cls-12\" d=\"M8.44-84.4v32.283h28.7v28.063H71.951V-52.117h28.907V-84.4H71.951v-27.852H37.136V-84.4Z\" transform=\"translate(90 343)\"/>\r\n    </g>\r\n    <g id=\"TextosTopo\" transform=\"translate(-199.498 201.178)\">\r\n      <path id=\"comodidade\" class=\"hmb-cls-2\" d=\"M-203.352-2.4a9.612,9.612,0,0,1-3.163,2.09,9.67,9.67,0,0,1-3.607.685A10.639,10.639,0,0,1-213.8-.259a8.507,8.507,0,0,1-3-1.85,8.951,8.951,0,0,1-2.035-3,10.081,10.081,0,0,1-.758-4,10.128,10.128,0,0,1,.74-4,8.815,8.815,0,0,1,2.016-2.96,8.507,8.507,0,0,1,3-1.85,10.748,10.748,0,0,1,3.718-.629,9.182,9.182,0,0,1,3.46.647,9.057,9.057,0,0,1,3.016,2.053l-1.628,1.591a6.876,6.876,0,0,0-2.257-1.48,6.9,6.9,0,0,0-2.553-.481,7.8,7.8,0,0,0-2.738.481,6.409,6.409,0,0,0-2.239,1.388,6.591,6.591,0,0,0-1.5,2.22,7.69,7.69,0,0,0-.555,3.015,7.932,7.932,0,0,0,.555,3.071,6.232,6.232,0,0,0,1.517,2.22,6.59,6.59,0,0,0,2.22,1.351,7.766,7.766,0,0,0,2.7.462,7.349,7.349,0,0,0,2.719-.518,6.853,6.853,0,0,0,2.35-1.554Zm11.8-16.132a9.967,9.967,0,0,1,3.718.684,8.716,8.716,0,0,1,2.979,1.942,9.091,9.091,0,0,1,1.98,3.015,10.087,10.087,0,0,1,.721,3.867,10.178,10.178,0,0,1-.7,3.848A8.7,8.7,0,0,1-184.815-2.2,8.626,8.626,0,0,1-187.794-.3a10.317,10.317,0,0,1-3.755.666A10.212,10.212,0,0,1-195.268-.3,8.626,8.626,0,0,1-198.246-2.2a8.929,8.929,0,0,1-1.98-2.978,9.948,9.948,0,0,1-.721-3.848,10.32,10.32,0,0,1,.7-3.867A9,9,0,0,1-198.3-15.91a8.523,8.523,0,0,1,2.96-1.942A10.172,10.172,0,0,1-191.549-18.537Zm0,2.257a7.138,7.138,0,0,0-2.794.537,6.521,6.521,0,0,0-2.2,1.5,6.617,6.617,0,0,0-1.424,2.294,8.263,8.263,0,0,0-.5,2.923,7.853,7.853,0,0,0,.518,2.9,6.627,6.627,0,0,0,1.424,2.238,6.151,6.151,0,0,0,2.183,1.424,7.6,7.6,0,0,0,2.794.5,7.562,7.562,0,0,0,2.812-.5,6.378,6.378,0,0,0,2.183-1.424,6.271,6.271,0,0,0,1.424-2.238,8.112,8.112,0,0,0,.5-2.9,8,8,0,0,0-.518-2.923,7,7,0,0,0-1.424-2.294,6.327,6.327,0,0,0-2.183-1.5A7.138,7.138,0,0,0-191.549-16.28ZM-164.354,0V-10.582a6.378,6.378,0,0,0-.389-2.257,5.392,5.392,0,0,0-1.091-1.795,5.181,5.181,0,0,0-1.684-1.2,5.278,5.278,0,0,0-2.2-.444,5.278,5.278,0,0,0-2.2.444,5.181,5.181,0,0,0-1.684,1.2,5.392,5.392,0,0,0-1.092,1.795,6.379,6.379,0,0,0-.388,2.257V0h-2.479V-18.352h2.331l.111,2.923a5.006,5.006,0,0,1,2.442-2.423,7.9,7.9,0,0,1,3.219-.684,10.36,10.36,0,0,1,1.961.185,5.886,5.886,0,0,1,1.831.684,5.8,5.8,0,0,1,1.554,1.313,6.27,6.27,0,0,1,1.092,1.961,6.175,6.175,0,0,1,2.738-3.163,7.971,7.971,0,0,1,3.848-.98,8.915,8.915,0,0,1,3.163.536,6.494,6.494,0,0,1,2.424,1.573,7.261,7.261,0,0,1,1.554,2.5,9.164,9.164,0,0,1,.555,3.275V0h-2.479V-10.656a6.665,6.665,0,0,0-.37-2.257,5.11,5.11,0,0,0-1.055-1.776,4.93,4.93,0,0,0-1.646-1.165,5.344,5.344,0,0,0-2.183-.426,5.278,5.278,0,0,0-2.2.444,5.4,5.4,0,0,0-1.7,1.2,5.24,5.24,0,0,0-1.11,1.795,6.379,6.379,0,0,0-.388,2.257V0Zm29.378-18.537a9.967,9.967,0,0,1,3.718.684,8.716,8.716,0,0,1,2.979,1.942,9.091,9.091,0,0,1,1.98,3.015,10.087,10.087,0,0,1,.721,3.867,10.178,10.178,0,0,1-.7,3.848A8.7,8.7,0,0,1-128.242-2.2,8.626,8.626,0,0,1-131.221-.3a10.317,10.317,0,0,1-3.755.666A10.212,10.212,0,0,1-138.695-.3,8.626,8.626,0,0,1-141.673-2.2a8.929,8.929,0,0,1-1.98-2.978,9.948,9.948,0,0,1-.721-3.848,10.32,10.32,0,0,1,.7-3.867,9,9,0,0,1,1.943-3.015,8.523,8.523,0,0,1,2.96-1.942A10.172,10.172,0,0,1-134.976-18.537Zm0,2.257a7.138,7.138,0,0,0-2.794.537,6.521,6.521,0,0,0-2.2,1.5,6.617,6.617,0,0,0-1.424,2.294,8.263,8.263,0,0,0-.5,2.923,7.853,7.853,0,0,0,.518,2.9,6.627,6.627,0,0,0,1.424,2.238,6.151,6.151,0,0,0,2.183,1.424,7.6,7.6,0,0,0,2.794.5,7.562,7.562,0,0,0,2.812-.5,6.378,6.378,0,0,0,2.183-1.424,6.271,6.271,0,0,0,1.424-2.238,8.112,8.112,0,0,0,.5-2.9,8,8,0,0,0-.518-2.923A7,7,0,0,0-130-14.245a6.327,6.327,0,0,0-2.183-1.5A7.138,7.138,0,0,0-134.976-16.28Zm22.2.074a7.613,7.613,0,0,0-2.682.462,6.43,6.43,0,0,0-2.183,1.351,6.154,6.154,0,0,0-1.48,2.22,8.174,8.174,0,0,0-.536,3.071,8.031,8.031,0,0,0,.536,3.053,6.374,6.374,0,0,0,1.48,2.22,6.29,6.29,0,0,0,2.183,1.369A7.613,7.613,0,0,0-112.776-2a7.121,7.121,0,0,0,2.738-.518,6.471,6.471,0,0,0,2.183-1.461,6.921,6.921,0,0,0,1.461-2.257,7.613,7.613,0,0,0,.536-2.9,7.512,7.512,0,0,0-.536-2.868,6.71,6.71,0,0,0-1.461-2.238,6.564,6.564,0,0,0-2.2-1.443A7.163,7.163,0,0,0-112.776-16.206Zm9.509-9.657V0h-2.4l-.074-3.626a7.221,7.221,0,0,1-3.052,3,8.9,8.9,0,0,1-4.125,1,10.18,10.18,0,0,1-3.626-.629,8.561,8.561,0,0,1-2.923-1.831,8.287,8.287,0,0,1-1.961-2.96,10.851,10.851,0,0,1-.7-4.052,10.851,10.851,0,0,1,.7-4.052,8.287,8.287,0,0,1,1.961-2.96,8.561,8.561,0,0,1,2.923-1.831,9.656,9.656,0,0,1,3.626-.592,9.075,9.075,0,0,1,4.144.925,6.5,6.5,0,0,1,3.034,3V-25.863Zm8.251,7.511V0H-97.5V-18.352Zm-2.96-5.661a1.56,1.56,0,0,1,.555-1.3,1.863,1.863,0,0,1,1.184-.444,1.91,1.91,0,0,1,1.221.444,1.56,1.56,0,0,1,.555,1.3,1.55,1.55,0,0,1-.555,1.314,1.962,1.962,0,0,1-1.221.425,1.912,1.912,0,0,1-1.184-.425A1.55,1.55,0,0,1-97.976-24.013Zm16.946,7.807a7.613,7.613,0,0,0-2.682.462A6.43,6.43,0,0,0-85.9-14.393a6.154,6.154,0,0,0-1.48,2.22A8.174,8.174,0,0,0-87.912-9.1a8.031,8.031,0,0,0,.536,3.053,6.374,6.374,0,0,0,1.48,2.22,6.29,6.29,0,0,0,2.183,1.369A7.613,7.613,0,0,0-81.03-2a7.121,7.121,0,0,0,2.738-.518,6.471,6.471,0,0,0,2.183-1.461,6.92,6.92,0,0,0,1.462-2.257,7.613,7.613,0,0,0,.536-2.9,7.512,7.512,0,0,0-.536-2.868,6.71,6.71,0,0,0-1.462-2.238,6.564,6.564,0,0,0-2.2-1.443A7.163,7.163,0,0,0-81.03-16.206Zm9.509-9.657V0h-2.4L-74-3.626a7.221,7.221,0,0,1-3.053,3,8.9,8.9,0,0,1-4.126,1A10.18,10.18,0,0,1-84.8-.259,8.561,8.561,0,0,1-87.727-2.09a8.287,8.287,0,0,1-1.961-2.96,10.851,10.851,0,0,1-.7-4.052,10.851,10.851,0,0,1,.7-4.052,8.287,8.287,0,0,1,1.961-2.96A8.561,8.561,0,0,1-84.8-17.945a9.656,9.656,0,0,1,3.626-.592,9.075,9.075,0,0,1,4.144.925,6.5,6.5,0,0,1,3.034,3V-25.863Zm21.127,11.211v-3.626h2.331V0h-2.294V-3.626a7.607,7.607,0,0,1-1.424,1.757A8.629,8.629,0,0,1-53.558-.61a8.155,8.155,0,0,1-1.979.74A9.136,9.136,0,0,1-57.609.37,9.818,9.818,0,0,1-61.254-.3,8.908,8.908,0,0,1-64.214-2.2a8.75,8.75,0,0,1-2-3,10.29,10.29,0,0,1-.721-3.941,9.828,9.828,0,0,1,.74-3.885,8.954,8.954,0,0,1,2-2.96,8.806,8.806,0,0,1,2.96-1.887,9.963,9.963,0,0,1,3.663-.666,9.624,9.624,0,0,1,2.109.24,8.525,8.525,0,0,1,2.016.722,7.637,7.637,0,0,1,1.739,1.221A6.549,6.549,0,0,1-50.394-14.652Zm-7.1-1.628a7.163,7.163,0,0,0-2.72.518,6.77,6.77,0,0,0-2.22,1.443,6.531,6.531,0,0,0-1.48,2.257,7.754,7.754,0,0,0-.536,2.923A7.715,7.715,0,0,0-63.918-6.2a6.771,6.771,0,0,0,1.48,2.257,6.626,6.626,0,0,0,2.22,1.461,7.163,7.163,0,0,0,2.72.518,6.925,6.925,0,0,0,3.94-1.055,6.7,6.7,0,0,0,2.35-2.645,7.777,7.777,0,0,0,.777-3.459,7.777,7.777,0,0,0-.777-3.46,6.7,6.7,0,0,0-2.35-2.646A6.925,6.925,0,0,0-57.5-16.28Zm23.421.074a7.613,7.613,0,0,0-2.682.462,6.43,6.43,0,0,0-2.183,1.351,6.154,6.154,0,0,0-1.48,2.22A8.174,8.174,0,0,0-40.959-9.1a8.031,8.031,0,0,0,.537,3.053,6.374,6.374,0,0,0,1.48,2.22A6.29,6.29,0,0,0-36.76-2.461,7.613,7.613,0,0,0-34.077-2a7.121,7.121,0,0,0,2.738-.518,6.471,6.471,0,0,0,2.183-1.461,6.92,6.92,0,0,0,1.462-2.257,7.613,7.613,0,0,0,.536-2.9,7.512,7.512,0,0,0-.536-2.868,6.71,6.71,0,0,0-1.462-2.238,6.564,6.564,0,0,0-2.2-1.443A7.163,7.163,0,0,0-34.077-16.206Zm9.509-9.657V0h-2.4l-.074-3.626a7.221,7.221,0,0,1-3.053,3,8.9,8.9,0,0,1-4.125,1,10.18,10.18,0,0,1-3.626-.629A8.561,8.561,0,0,1-40.774-2.09a8.287,8.287,0,0,1-1.961-2.96,10.85,10.85,0,0,1-.7-4.052,10.85,10.85,0,0,1,.7-4.052,8.287,8.287,0,0,1,1.961-2.96,8.561,8.561,0,0,1,2.923-1.831,9.656,9.656,0,0,1,3.626-.592,9.075,9.075,0,0,1,4.144.925,6.5,6.5,0,0,1,3.034,3V-25.863Zm23.051,17.8h-15.91a6.559,6.559,0,0,0,.7,2.572,6.245,6.245,0,0,0,1.517,1.905A6.524,6.524,0,0,0-13.08-2.4,7.969,7.969,0,0,0-10.508-2a9.239,9.239,0,0,0,1.7-.166,10.153,10.153,0,0,0,1.72-.481,8.314,8.314,0,0,0,1.554-.777,4.662,4.662,0,0,0,1.2-1.091l1.665,1.48A8.382,8.382,0,0,1-6.179-.481,11.659,11.659,0,0,1-10.508.37,10.465,10.465,0,0,1-14.282-.3a8.59,8.59,0,0,1-3-1.905,8.886,8.886,0,0,1-1.979-3,10.29,10.29,0,0,1-.722-3.941,9.975,9.975,0,0,1,.7-3.774,9.046,9.046,0,0,1,1.942-3,8.744,8.744,0,0,1,2.96-1.961,9.376,9.376,0,0,1,3.755-.666,10.74,10.74,0,0,1,3.811.592,7.788,7.788,0,0,1,3.034,1.924,8.154,8.154,0,0,1,1.887,3.274A11.762,11.762,0,0,1-1.517-8.066Zm-15.91-2.109H-3.848a6.664,6.664,0,0,0-.573-2.646,5.6,5.6,0,0,0-1.443-1.942,6.281,6.281,0,0,0-2.127-1.184,8.137,8.137,0,0,0-2.59-.407,6.843,6.843,0,0,0-4.625,1.591A6.9,6.9,0,0,0-17.427-10.175Z\" transform=\"translate(1510.498 -59.178)\"/>\r\n      <path id=\"_mais\" data-name=\" mais\" class=\"hmb-cls-12\" d=\"M34.647,0V-13.464c0-3.315,2.091-6.222,5.457-6.222s4.743,2.805,4.743,6.12V0h6.222V-13.566c0-7.548-3.519-11.934-10.659-11.934a9.1,9.1,0,0,0-8.415,4.59c-1.428-3.468-4.437-4.692-7.446-4.692-2.4,0-5.3.918-6.63,3.468l-.459-3.06H11.7V0h6.222V-13.464c0-3.315,1.989-6.324,5.355-6.324,3.417,0,5.151,3.009,5.151,6.324V0ZM77.13-21.675c-1.428-2.5-4.641-4.08-8.007-4.08-7.344-.051-13.107,4.488-13.107,13.158C56.016-3.774,61.524.816,68.97.765,71.775.714,75.7-.714,77.13-3.672L77.436,0H83.3V-25.143H77.334ZM69.684-20.2c9.792,0,9.792,15.249,0,15.249-4.131,0-7.446-2.856-7.446-7.65A7.16,7.16,0,0,1,69.684-20.2Zm25.092-5.049V0H88.554V-25.245Zm-6.783-6.987c0-4.845,7.344-4.845,7.344,0S87.993-27.387,87.993-32.232Zm32.283,9.69c-2.907-2.55-5.865-3.315-9.792-3.315-4.59,0-10.608,2.04-10.608,7.854,0,5.712,5.661,7.446,10.4,7.8,3.57.2,5,.918,5,2.652,0,1.836-2.193,3.06-4.539,3.009-2.805-.051-6.885-1.53-8.67-3.519l-3.06,4.437C102.681.2,106.659.867,110.637.867c7.191,0,10.812-3.825,10.812-8.262,0-6.681-6.018-7.752-10.761-8.058-3.213-.2-4.692-1.122-4.692-2.754,0-1.581,1.632-2.5,4.59-2.5a8.479,8.479,0,0,1,6.222,2.244Z\" transform=\"translate(1155.498 -59.178)\"/>\r\n      <path id=\"compartilhado\" class=\"hmb-cls-2\" d=\"M-255.45-2.535a10.132,10.132,0,0,1-3.335,2.2,10.192,10.192,0,0,1-3.8.722,11.214,11.214,0,0,1-3.881-.663,8.967,8.967,0,0,1-3.159-1.95,9.435,9.435,0,0,1-2.145-3.159,10.626,10.626,0,0,1-.8-4.212,10.676,10.676,0,0,1,.78-4.212,9.292,9.292,0,0,1,2.125-3.12,8.967,8.967,0,0,1,3.159-1.95,11.329,11.329,0,0,1,3.92-.663,9.678,9.678,0,0,1,3.646.682,9.546,9.546,0,0,1,3.178,2.165l-1.716,1.677a7.247,7.247,0,0,0-2.379-1.56,7.276,7.276,0,0,0-2.691-.507,8.221,8.221,0,0,0-2.886.507,6.755,6.755,0,0,0-2.359,1.463,6.947,6.947,0,0,0-1.579,2.34,8.106,8.106,0,0,0-.585,3.178,8.361,8.361,0,0,0,.585,3.237,6.569,6.569,0,0,0,1.6,2.34,6.946,6.946,0,0,0,2.34,1.424,8.186,8.186,0,0,0,2.847.488,7.746,7.746,0,0,0,2.866-.546,7.223,7.223,0,0,0,2.477-1.638Zm12.441-17a10.506,10.506,0,0,1,3.92.722,9.187,9.187,0,0,1,3.139,2.047,9.583,9.583,0,0,1,2.087,3.179,10.632,10.632,0,0,1,.76,4.076,10.728,10.728,0,0,1-.741,4.056,9.174,9.174,0,0,1-2.067,3.139,9.093,9.093,0,0,1-3.14,2.009,10.875,10.875,0,0,1-3.958.7,10.764,10.764,0,0,1-3.919-.7,9.093,9.093,0,0,1-3.139-2.009,9.412,9.412,0,0,1-2.087-3.139,10.486,10.486,0,0,1-.76-4.056,10.878,10.878,0,0,1,.741-4.076,9.49,9.49,0,0,1,2.048-3.179,8.983,8.983,0,0,1,3.12-2.047A10.722,10.722,0,0,1-243.009-19.539Zm0,2.379a7.524,7.524,0,0,0-2.945.566,6.874,6.874,0,0,0-2.32,1.58,6.975,6.975,0,0,0-1.5,2.418,8.71,8.71,0,0,0-.527,3.081,8.277,8.277,0,0,0,.546,3.061,6.985,6.985,0,0,0,1.5,2.36,6.484,6.484,0,0,0,2.3,1.5,8.013,8.013,0,0,0,2.945.527,7.97,7.97,0,0,0,2.964-.527,6.722,6.722,0,0,0,2.3-1.5,6.61,6.61,0,0,0,1.5-2.36,8.55,8.55,0,0,0,.526-3.061,8.431,8.431,0,0,0-.546-3.081,7.383,7.383,0,0,0-1.5-2.418,6.669,6.669,0,0,0-2.3-1.58A7.524,7.524,0,0,0-243.009-17.16ZM-214.344,0V-11.154a6.723,6.723,0,0,0-.41-2.379,5.683,5.683,0,0,0-1.15-1.892,5.461,5.461,0,0,0-1.775-1.267A5.564,5.564,0,0,0-220-17.16a5.564,5.564,0,0,0-2.32.468,5.461,5.461,0,0,0-1.775,1.267,5.683,5.683,0,0,0-1.15,1.892,6.723,6.723,0,0,0-.41,2.379V0h-2.613V-19.344h2.457l.117,3.081a5.276,5.276,0,0,1,2.574-2.554,8.332,8.332,0,0,1,3.393-.722,10.921,10.921,0,0,1,2.067.195,6.2,6.2,0,0,1,1.931.722,6.114,6.114,0,0,1,1.638,1.384,6.609,6.609,0,0,1,1.15,2.067,6.509,6.509,0,0,1,2.886-3.335A8.4,8.4,0,0,1-206-19.539a9.4,9.4,0,0,1,3.335.566,6.845,6.845,0,0,1,2.554,1.657,7.653,7.653,0,0,1,1.638,2.632,9.66,9.66,0,0,1,.585,3.452V0H-200.5V-11.232a7.026,7.026,0,0,0-.39-2.379A5.386,5.386,0,0,0-202-15.483a5.2,5.2,0,0,0-1.736-1.228,5.633,5.633,0,0,0-2.3-.448,5.564,5.564,0,0,0-2.32.468,5.686,5.686,0,0,0-1.794,1.267,5.523,5.523,0,0,0-1.17,1.892,6.723,6.723,0,0,0-.41,2.379V0Zm32.331-2.145a8.186,8.186,0,0,0,2.847-.488,6.4,6.4,0,0,0,2.3-1.443,6.859,6.859,0,0,0,1.54-2.34,8.465,8.465,0,0,0,.566-3.217,8.618,8.618,0,0,0-.546-3.179,6.437,6.437,0,0,0-1.521-2.32,6.536,6.536,0,0,0-2.3-1.424,8.3,8.3,0,0,0-2.886-.488,7.381,7.381,0,0,0-2.925.566,6.85,6.85,0,0,0-2.281,1.56,7,7,0,0,0-1.482,2.359,8.167,8.167,0,0,0-.526,2.964,7.908,7.908,0,0,0,.546,2.964,7.25,7.25,0,0,0,1.5,2.36,6.85,6.85,0,0,0,2.281,1.56A7.28,7.28,0,0,0-182.013-2.145ZM-192.036,9.2v-28.47h2.535l.078,4.095a8.148,8.148,0,0,1,3.2-3.237,8.891,8.891,0,0,1,4.6-1.131,10.489,10.489,0,0,1,3.764.741,8.787,8.787,0,0,1,3,1.989,9.21,9.21,0,0,1,1.989,3.1,10.944,10.944,0,0,1,.721,4.076,11.362,11.362,0,0,1-.741,4.212,9.177,9.177,0,0,1-2.028,3.159A8.641,8.641,0,0,1-178-.292a10.88,10.88,0,0,1-3.9.682,9.455,9.455,0,0,1-4.31-1.053A7.458,7.458,0,0,1-189.462-3.9V9.2Zm40.95-24.648v-3.822h2.457V0h-2.418V-3.822a8.018,8.018,0,0,1-1.5,1.852A9.1,9.1,0,0,1-154.42-.643a8.6,8.6,0,0,1-2.087.78,9.63,9.63,0,0,1-2.184.253,10.349,10.349,0,0,1-3.841-.7,9.389,9.389,0,0,1-3.12-2.009,9.224,9.224,0,0,1-2.106-3.159,10.846,10.846,0,0,1-.76-4.153,10.359,10.359,0,0,1,.78-4.1,9.438,9.438,0,0,1,2.106-3.12,9.282,9.282,0,0,1,3.12-1.989,10.5,10.5,0,0,1,3.861-.7,10.144,10.144,0,0,1,2.223.253,8.986,8.986,0,0,1,2.126.76,8.05,8.05,0,0,1,1.833,1.287A6.9,6.9,0,0,1-151.086-15.444Zm-7.488-1.716a7.55,7.55,0,0,0-2.867.546,7.136,7.136,0,0,0-2.34,1.521,6.884,6.884,0,0,0-1.56,2.379,8.173,8.173,0,0,0-.566,3.081,8.132,8.132,0,0,0,.566,3.1,7.137,7.137,0,0,0,1.56,2.379,6.984,6.984,0,0,0,2.34,1.54,7.55,7.55,0,0,0,2.867.546,7.3,7.3,0,0,0,4.154-1.112,7.061,7.061,0,0,0,2.477-2.789,8.2,8.2,0,0,0,.819-3.646,8.2,8.2,0,0,0-.819-3.647,7.061,7.061,0,0,0-2.477-2.788A7.3,7.3,0,0,0-158.574-17.16Zm18.486-2.106.156,3.159a5.684,5.684,0,0,1,1.15-1.638,6,6,0,0,1,1.5-1.072,6.694,6.694,0,0,1,1.716-.585,9.129,9.129,0,0,1,1.755-.175,7.772,7.772,0,0,1,2.32.312,7.494,7.494,0,0,1,2.048,1.053l-1.209,2.184a5.737,5.737,0,0,0-3.315-1.014,5.877,5.877,0,0,0-2.34.468,5.969,5.969,0,0,0-1.891,1.267,5.914,5.914,0,0,0-1.268,1.911,6.219,6.219,0,0,0-.468,2.438V0h-2.613V-19.266Zm18.72-5.694v5.85h6.24v2.223h-6.24V-6.123A5.6,5.6,0,0,0-120.7-3.2a2.812,2.812,0,0,0,2.613,1.092,4.855,4.855,0,0,0,1.384-.215,11.74,11.74,0,0,0,1.424-.526l.819,2.184a12.354,12.354,0,0,1-1.853.683,6.919,6.919,0,0,1-1.853.254q-3.12.039-4.465-1.677a7.463,7.463,0,0,1-1.345-4.719V-16.887h-3.939V-19.11h3.939v-5.577Zm13.026,5.616V0h-2.613V-19.344Zm-3.12-5.967a1.645,1.645,0,0,1,.585-1.365,1.964,1.964,0,0,1,1.248-.468,2.014,2.014,0,0,1,1.287.468,1.645,1.645,0,0,1,.585,1.365,1.634,1.634,0,0,1-.585,1.384,2.068,2.068,0,0,1-1.287.448,2.015,2.015,0,0,1-1.248-.448A1.634,1.634,0,0,1-111.462-25.311Zm12.09-1.989V0h-2.613V-27.3Zm8.931,0v11.388A6.785,6.785,0,0,1-87.457-18.7a9.435,9.435,0,0,1,3.724-.838,8.91,8.91,0,0,1,3.53.643,6.763,6.763,0,0,1,2.5,1.794,7.709,7.709,0,0,1,1.5,2.749A11.7,11.7,0,0,1-75.7-10.8V0h-2.613V-10.8a6.872,6.872,0,0,0-1.4-4.582,5.361,5.361,0,0,0-4.329-1.658,6.405,6.405,0,0,0-2.574.507,5.829,5.829,0,0,0-2.009,1.424,6.7,6.7,0,0,0-1.306,2.125,7.176,7.176,0,0,0-.468,2.613V0h-2.613V-27.3Zm36.777,11.856v-3.822h2.457V0h-2.418V-3.822a8.018,8.018,0,0,1-1.5,1.852A9.1,9.1,0,0,1-57-.643a8.6,8.6,0,0,1-2.087.78A9.63,9.63,0,0,1-61.269.39a10.349,10.349,0,0,1-3.841-.7,9.389,9.389,0,0,1-3.12-2.009,9.224,9.224,0,0,1-2.106-3.159,10.846,10.846,0,0,1-.76-4.153,10.359,10.359,0,0,1,.78-4.1,9.438,9.438,0,0,1,2.106-3.12,9.282,9.282,0,0,1,3.12-1.989,10.5,10.5,0,0,1,3.861-.7,10.144,10.144,0,0,1,2.223.253,8.986,8.986,0,0,1,2.125.76,8.05,8.05,0,0,1,1.833,1.287A6.9,6.9,0,0,1-53.664-15.444Zm-7.488-1.716a7.55,7.55,0,0,0-2.867.546,7.136,7.136,0,0,0-2.34,1.521,6.884,6.884,0,0,0-1.56,2.379,8.173,8.173,0,0,0-.566,3.081,8.132,8.132,0,0,0,.566,3.1,7.137,7.137,0,0,0,1.56,2.379,6.984,6.984,0,0,0,2.34,1.54,7.55,7.55,0,0,0,2.867.546A7.3,7.3,0,0,0-57-3.178a7.06,7.06,0,0,0,2.476-2.789A8.2,8.2,0,0,0-53.7-9.613a8.2,8.2,0,0,0-.819-3.647A7.06,7.06,0,0,0-57-16.049,7.3,7.3,0,0,0-61.152-17.16Zm24.687.078a8.025,8.025,0,0,0-2.827.487,6.778,6.778,0,0,0-2.3,1.424,6.487,6.487,0,0,0-1.56,2.34,8.616,8.616,0,0,0-.566,3.237,8.465,8.465,0,0,0,.566,3.218,6.719,6.719,0,0,0,1.56,2.34,6.63,6.63,0,0,0,2.3,1.443,8.025,8.025,0,0,0,2.827.488,7.506,7.506,0,0,0,2.886-.546,6.821,6.821,0,0,0,2.3-1.54,7.3,7.3,0,0,0,1.541-2.379,8.024,8.024,0,0,0,.566-3.061,7.918,7.918,0,0,0-.566-3.023,7.073,7.073,0,0,0-1.541-2.359A6.919,6.919,0,0,0-33.6-16.536,7.55,7.55,0,0,0-36.465-17.082Zm10.023-10.179V0h-2.535l-.078-3.822A7.611,7.611,0,0,1-32.272-.663,9.377,9.377,0,0,1-36.621.39a10.73,10.73,0,0,1-3.822-.663A9.024,9.024,0,0,1-43.524-2.2a8.735,8.735,0,0,1-2.067-3.12,11.437,11.437,0,0,1-.741-4.27,11.437,11.437,0,0,1,.741-4.271,8.735,8.735,0,0,1,2.067-3.12,9.024,9.024,0,0,1,3.081-1.931,10.178,10.178,0,0,1,3.822-.624,9.565,9.565,0,0,1,4.368.975,6.848,6.848,0,0,1,3.2,3.159V-27.261ZM-11.7-19.539a10.506,10.506,0,0,1,3.919.722,9.187,9.187,0,0,1,3.14,2.047,9.582,9.582,0,0,1,2.087,3.179,10.632,10.632,0,0,1,.76,4.076A10.728,10.728,0,0,1-2.535-5.46,9.174,9.174,0,0,1-4.6-2.321,9.093,9.093,0,0,1-7.741-.312,10.875,10.875,0,0,1-11.7.39a10.764,10.764,0,0,1-3.92-.7,9.093,9.093,0,0,1-3.139-2.009A9.412,9.412,0,0,1-20.845-5.46a10.486,10.486,0,0,1-.76-4.056,10.878,10.878,0,0,1,.741-4.076,9.49,9.49,0,0,1,2.048-3.179,8.983,8.983,0,0,1,3.12-2.047A10.722,10.722,0,0,1-11.7-19.539Zm0,2.379a7.524,7.524,0,0,0-2.945.566,6.873,6.873,0,0,0-2.32,1.58,6.975,6.975,0,0,0-1.5,2.418,8.71,8.71,0,0,0-.527,3.081,8.277,8.277,0,0,0,.546,3.061,6.985,6.985,0,0,0,1.5,2.36,6.484,6.484,0,0,0,2.3,1.5,8.012,8.012,0,0,0,2.945.527,7.97,7.97,0,0,0,2.964-.527,6.723,6.723,0,0,0,2.3-1.5,6.61,6.61,0,0,0,1.5-2.36,8.55,8.55,0,0,0,.526-3.061A8.431,8.431,0,0,0-4.953-12.6a7.383,7.383,0,0,0-1.5-2.418,6.669,6.669,0,0,0-2.3-1.58A7.524,7.524,0,0,0-11.7-17.16Z\" transform=\"translate(1511.498 -109.178)\"/>\r\n      <path id=\"saldo\" class=\"hmb-cls-12\" d=\"M22.79-23.426c-3.021-2.65-6.1-3.445-10.176-3.445-4.77,0-11.024,2.12-11.024,8.162,0,5.936,5.883,7.738,10.812,8.109,3.71.212,5.194.954,5.194,2.756,0,1.908-2.279,3.18-4.717,3.127-2.915-.053-7.155-1.59-9.01-3.657L.689-3.763C4.505.212,8.639.9,12.773.9c7.473,0,11.236-3.975,11.236-8.586,0-6.943-6.254-8.056-11.183-8.374-3.339-.212-4.876-1.166-4.876-2.862,0-1.643,1.7-2.6,4.77-2.6a8.811,8.811,0,0,1,6.466,2.332Zm25.864.9c-1.484-2.6-4.823-4.24-8.321-4.24C32.7-26.818,26.712-22.1,26.712-13.091,26.712-3.922,32.436.848,40.174.795c2.915-.053,7-1.537,8.48-4.611L48.972,0h6.1V-26.129h-6.2Zm-7.738,1.537c10.176,0,10.176,15.847,0,15.847-4.293,0-7.738-2.968-7.738-7.95S36.623-20.988,40.916-20.988Zm19.61-16.059V0h6.413V-37.047ZM85.277-20.723a7.456,7.456,0,0,1,7.579,7.632,7.406,7.406,0,0,1-7.579,7.685,7.343,7.343,0,0,1-7.42-7.685A7.208,7.208,0,0,1,85.277-20.723Zm8-16.324v14.469c-1.537-2.7-5.83-4.187-8.586-4.187-7.632,0-13.3,4.664-13.3,13.674C71.391-4.505,77.168.583,84.853.583c3.18,0,6.413-1.06,8.427-4.187L93.7,0h6.042V-37.047Zm24.38,10.388c-8.321,0-13.515,6.148-13.515,13.621,0,7.526,5.088,13.621,13.568,13.621s13.621-6.1,13.621-13.621A13.209,13.209,0,0,0,117.66-26.659Zm.053,5.883c4.346,0,7.1,3.816,7.1,7.738,0,3.975-2.385,7.685-7.1,7.685s-7.1-3.71-7.1-7.685C110.611-16.96,113.049-20.776,117.713-20.776Z\" transform=\"translate(1093.498 -109.178)\"/>\r\n      <path id=\"tecnologia\" class=\"hmb-cls-2\" d=\"M-206.572-27.52v6.45h6.88v2.451h-6.88V-6.751a6.176,6.176,0,0,0,.731,3.225,3.1,3.1,0,0,0,2.881,1.2,5.352,5.352,0,0,0,1.526-.237,12.944,12.944,0,0,0,1.57-.58l.9,2.408A13.621,13.621,0,0,1-201,.022,7.628,7.628,0,0,1-203.046.3q-3.44.043-4.924-1.849a8.228,8.228,0,0,1-1.483-5.2V-18.619H-213.8V-21.07h4.343v-6.149ZM-175.01-9.374H-193.5a7.622,7.622,0,0,0,.817,2.988,7.258,7.258,0,0,0,1.763,2.214,7.583,7.583,0,0,0,2.473,1.376,9.261,9.261,0,0,0,2.988.473,10.737,10.737,0,0,0,1.978-.194,11.8,11.8,0,0,0,2-.559,9.663,9.663,0,0,0,1.806-.9,5.418,5.418,0,0,0,1.4-1.269l1.935,1.72a9.741,9.741,0,0,1-4.085,2.967,13.55,13.55,0,0,1-5.031.989,12.162,12.162,0,0,1-4.386-.774,9.983,9.983,0,0,1-3.483-2.215,10.328,10.328,0,0,1-2.3-3.483,11.958,11.958,0,0,1-.839-4.579,11.593,11.593,0,0,1,.817-4.386,10.513,10.513,0,0,1,2.258-3.483,10.162,10.162,0,0,1,3.44-2.279,10.9,10.9,0,0,1,4.364-.774,12.482,12.482,0,0,1,4.429.688,9.051,9.051,0,0,1,3.526,2.236,9.476,9.476,0,0,1,2.193,3.805A13.67,13.67,0,0,1-175.01-9.374Zm-18.49-2.451h15.781a7.745,7.745,0,0,0-.667-3.075,6.51,6.51,0,0,0-1.677-2.257,7.3,7.3,0,0,0-2.472-1.376,9.457,9.457,0,0,0-3.01-.473,7.952,7.952,0,0,0-5.375,1.849A8.018,8.018,0,0,0-193.5-11.825Zm41.108,9.03a11.171,11.171,0,0,1-3.676,2.429,11.238,11.238,0,0,1-4.193.8A12.364,12.364,0,0,1-164.539-.3a9.887,9.887,0,0,1-3.483-2.15,10.4,10.4,0,0,1-2.365-3.483,11.715,11.715,0,0,1-.882-4.644,11.771,11.771,0,0,1,.86-4.644,10.245,10.245,0,0,1,2.344-3.44,9.887,9.887,0,0,1,3.483-2.15,12.491,12.491,0,0,1,4.321-.731,10.671,10.671,0,0,1,4.021.752,10.526,10.526,0,0,1,3.5,2.387l-1.892,1.849a7.991,7.991,0,0,0-2.623-1.72,8.023,8.023,0,0,0-2.967-.559,9.064,9.064,0,0,0-3.182.559,7.448,7.448,0,0,0-2.6,1.612,7.659,7.659,0,0,0-1.742,2.58,8.937,8.937,0,0,0-.645,3.5,9.218,9.218,0,0,0,.645,3.569,7.243,7.243,0,0,0,1.763,2.58,7.659,7.659,0,0,0,2.58,1.569,9.026,9.026,0,0,0,3.139.537,8.54,8.54,0,0,0,3.161-.6,7.964,7.964,0,0,0,2.73-1.806ZM-130.935,0V-11.911a6.859,6.859,0,0,0-1.849-5.2,7.051,7.051,0,0,0-5.074-1.763,6.836,6.836,0,0,0-2.838.58,6.592,6.592,0,0,0-2.193,1.57,7.386,7.386,0,0,0-1.419,2.3,7.742,7.742,0,0,0-.516,2.86V0H-147.7V-21.242h2.752l.086,3.569a8.008,8.008,0,0,1,3.268-2.989,9.313,9.313,0,0,1,4.063-.924,11.787,11.787,0,0,1,3.87.6,7.865,7.865,0,0,1,2.989,1.828,8.583,8.583,0,0,1,1.956,3.031,11.354,11.354,0,0,1,.71,4.171V0Zm18.92-21.543a11.584,11.584,0,0,1,4.321.8,10.129,10.129,0,0,1,3.462,2.257,10.565,10.565,0,0,1,2.3,3.5,11.722,11.722,0,0,1,.839,4.493,11.829,11.829,0,0,1-.817,4.472,10.115,10.115,0,0,1-2.279,3.461A10.025,10.025,0,0,1-107.65-.344a11.99,11.99,0,0,1-4.364.774,11.868,11.868,0,0,1-4.322-.774A10.025,10.025,0,0,1-119.8-2.559a10.377,10.377,0,0,1-2.3-3.461,11.561,11.561,0,0,1-.839-4.472,11.994,11.994,0,0,1,.817-4.493,10.464,10.464,0,0,1,2.257-3.5,9.9,9.9,0,0,1,3.44-2.257A11.822,11.822,0,0,1-112.015-21.543Zm0,2.623a8.3,8.3,0,0,0-3.246.623,7.578,7.578,0,0,0-2.559,1.742,7.69,7.69,0,0,0-1.656,2.666,9.6,9.6,0,0,0-.58,3.4,9.126,9.126,0,0,0,.6,3.376,7.7,7.7,0,0,0,1.656,2.6,7.148,7.148,0,0,0,2.537,1.655,8.834,8.834,0,0,0,3.246.58,8.788,8.788,0,0,0,3.268-.58,7.412,7.412,0,0,0,2.537-1.655,7.288,7.288,0,0,0,1.656-2.6,9.427,9.427,0,0,0,.58-3.376,9.3,9.3,0,0,0-.6-3.4,8.14,8.14,0,0,0-1.655-2.666,7.353,7.353,0,0,0-2.537-1.742A8.3,8.3,0,0,0-112.015-18.92ZM-92.579-30.1V0H-95.46V-30.1Zm16.555,8.557a11.584,11.584,0,0,1,4.321.8,10.129,10.129,0,0,1,3.462,2.257,10.565,10.565,0,0,1,2.3,3.5,11.722,11.722,0,0,1,.839,4.493,11.829,11.829,0,0,1-.817,4.472A10.115,10.115,0,0,1-68.2-2.559,10.025,10.025,0,0,1-71.66-.344,11.99,11.99,0,0,1-76.024.43a11.868,11.868,0,0,1-4.322-.774,10.025,10.025,0,0,1-3.462-2.215,10.377,10.377,0,0,1-2.3-3.461,11.561,11.561,0,0,1-.839-4.472,11.994,11.994,0,0,1,.817-4.493,10.464,10.464,0,0,1,2.257-3.5,9.9,9.9,0,0,1,3.44-2.257A11.822,11.822,0,0,1-76.024-21.543Zm0,2.623a8.3,8.3,0,0,0-3.246.623,7.578,7.578,0,0,0-2.559,1.742,7.69,7.69,0,0,0-1.656,2.666,9.6,9.6,0,0,0-.58,3.4,9.126,9.126,0,0,0,.6,3.376,7.7,7.7,0,0,0,1.656,2.6A7.148,7.148,0,0,0-79.27-2.859a8.834,8.834,0,0,0,3.246.58,8.788,8.788,0,0,0,3.268-.58,7.412,7.412,0,0,0,2.537-1.655,7.288,7.288,0,0,0,1.656-2.6,9.427,9.427,0,0,0,.58-3.376,9.3,9.3,0,0,0-.6-3.4,8.14,8.14,0,0,0-1.655-2.666A7.353,7.353,0,0,0-72.777-18.3,8.3,8.3,0,0,0-76.024-18.92Zm34.572-3.612,1.978,1.634-2.279,2.709a13.642,13.642,0,0,1,2.021,2.924,9.038,9.038,0,0,1,.817,4.128,10.276,10.276,0,0,1-.387,2.8,9.146,9.146,0,0,1-1.182,2.58,8.778,8.778,0,0,1-2,2.128,8.477,8.477,0,0,1-2.838,1.4A9.675,9.675,0,0,1-40.678.322,6.187,6.187,0,0,1-39.044,4.73a6.6,6.6,0,0,1-.924,3.526,8.129,8.129,0,0,1-2.43,2.515A11.319,11.319,0,0,1-45.881,12.3a16.117,16.117,0,0,1-4.085.516,15.054,15.054,0,0,1-4.257-.58,9.966,9.966,0,0,1-3.419-1.72A8.135,8.135,0,0,1-59.9,7.74a8.156,8.156,0,0,1-.817-3.7h2.881a5.157,5.157,0,0,0,.645,2.623,5.708,5.708,0,0,0,1.742,1.871,7.853,7.853,0,0,0,2.537,1.118,11.93,11.93,0,0,0,2.945.366,14.154,14.154,0,0,0,2.9-.3A9,9,0,0,0-44.5,8.793,5.428,5.428,0,0,0-42.677,7.16a4.12,4.12,0,0,0,.709-2.43,4.213,4.213,0,0,0-.688-2.43A5.573,5.573,0,0,0-44.483.623a8.946,8.946,0,0,0-2.58-.989,13.246,13.246,0,0,0-2.9-.322A13.616,13.616,0,0,1-54.459-1.4,10.226,10.226,0,0,1-57.985-3.44a9.067,9.067,0,0,1-2.3-3.268,11.3,11.3,0,0,1-.817-4.429,9.927,9.927,0,0,1,.989-4.536,10.045,10.045,0,0,1,2.58-3.268A10.846,10.846,0,0,1-53.965-20.9a12.827,12.827,0,0,1,4-.645,15.818,15.818,0,0,1,1.612.086,11.447,11.447,0,0,1,1.677.3,11.818,11.818,0,0,1,1.612.538,6.969,6.969,0,0,1,1.376.752Zm-8.514,3.655a9.863,9.863,0,0,0-2.924.452,7.748,7.748,0,0,0-2.645,1.419,7.319,7.319,0,0,0-1.914,2.43,7.6,7.6,0,0,0-.731,3.44,8.467,8.467,0,0,0,.645,3.44,6.9,6.9,0,0,0,1.742,2.43,7.089,7.089,0,0,0,2.6,1.44,10.7,10.7,0,0,0,3.225.473,8.685,8.685,0,0,0,3.354-.623,8.03,8.03,0,0,0,2.58-1.677,7.284,7.284,0,0,0,1.655-2.472,7.872,7.872,0,0,0,.581-3.01,8.007,8.007,0,0,0-.688-3.44,6.884,6.884,0,0,0-1.827-2.408A7.742,7.742,0,0,0-46.934-18.4,9.921,9.921,0,0,0-49.966-18.877Zm19.35-2.451V0H-33.5V-21.328Zm-3.44-6.579a1.813,1.813,0,0,1,.645-1.505,2.165,2.165,0,0,1,1.376-.516,2.22,2.22,0,0,1,1.419.516,1.813,1.813,0,0,1,.645,1.505,1.8,1.8,0,0,1-.645,1.526,2.28,2.28,0,0,1-1.419.495,2.222,2.222,0,0,1-1.376-.495A1.8,1.8,0,0,1-34.056-27.907ZM-6.063-17.028v-4.214h2.709V0H-6.02V-4.214A8.84,8.84,0,0,1-7.675-2.171,10.029,10.029,0,0,1-9.739-.71a9.477,9.477,0,0,1-2.3.86A10.617,10.617,0,0,1-14.448.43a11.41,11.41,0,0,1-4.236-.774,10.352,10.352,0,0,1-3.44-2.215,10.17,10.17,0,0,1-2.322-3.483,11.958,11.958,0,0,1-.838-4.579,11.422,11.422,0,0,1,.86-4.515,10.406,10.406,0,0,1,2.322-3.44,10.234,10.234,0,0,1,3.44-2.193,11.578,11.578,0,0,1,4.257-.774,11.184,11.184,0,0,1,2.451.279,9.907,9.907,0,0,1,2.343.839,8.876,8.876,0,0,1,2.021,1.419A7.61,7.61,0,0,1-6.063-17.028Zm-8.256-1.892a8.324,8.324,0,0,0-3.16.6,7.868,7.868,0,0,0-2.58,1.677,7.59,7.59,0,0,0-1.72,2.623,9.011,9.011,0,0,0-.624,3.4A8.966,8.966,0,0,0-21.779-7.2a7.869,7.869,0,0,0,1.72,2.623,7.7,7.7,0,0,0,2.58,1.7,8.324,8.324,0,0,0,3.16.6A8.047,8.047,0,0,0-9.739-3.5,7.785,7.785,0,0,0-7.009-6.579a9.038,9.038,0,0,0,.9-4.02,9.038,9.038,0,0,0-.9-4.021,7.785,7.785,0,0,0-2.731-3.075A8.047,8.047,0,0,0-14.319-18.92Z\" transform=\"translate(592.077 -54.46)\"/>\r\n      <path id=\"alta\" class=\"hmb-cls-12\" d=\"M24.766-24.65c-1.624-2.842-5.278-4.64-9.106-4.64C7.308-29.348.754-24.186.754-14.326.754-4.292,7.018.928,15.486.87c3.19-.058,7.656-1.682,9.28-5.046L25.114,0h6.67V-28.594H25ZM16.3-22.968c11.136,0,11.136,17.342,0,17.342-4.7,0-8.468-3.248-8.468-8.7S11.6-22.968,16.3-22.968Zm21.46-17.574V0h7.018V-40.542ZM53.882-35.9v7.366H48.546v6.09h5.336v12.354c0,7.134,4.06,10.672,10.266,10.44A15.806,15.806,0,0,0,70.006-.87L68.034-6.9a8.084,8.084,0,0,1-3.422.87c-2.2,0-3.712-1.334-3.712-4.06V-22.446h7.946v-6.09H60.958v-8.12ZM96.57-24.65c-1.624-2.842-5.278-4.64-9.106-4.64-8.352-.058-14.906,5.1-14.906,14.964C72.558-4.292,78.822.928,87.29.87c3.19-.058,7.656-1.682,9.28-5.046L96.918,0h6.67V-28.594H96.8ZM88.1-22.968c11.136,0,11.136,17.342,0,17.342-4.7,0-8.468-3.248-8.468-8.7S83.4-22.968,88.1-22.968Z\" transform=\"translate(259.077 -54.46)\"/>\r\n      <path id=\"total\" class=\"hmb-cls-12\" d=\"M-122.438-35.9v7.366h-5.336v6.09h5.336v12.354c0,7.134,4.06,10.672,10.266,10.44A15.806,15.806,0,0,0-106.314-.87L-108.286-6.9a8.084,8.084,0,0,1-3.422.87c-2.2,0-3.712-1.334-3.712-4.06V-22.446h7.946v-6.09h-7.888v-8.12Zm33.7,6.728c-9.106,0-14.79,6.728-14.79,14.906,0,8.236,5.568,14.906,14.848,14.906s14.906-6.67,14.906-14.906C-73.776-22.446-79.634-29.174-88.74-29.174Zm.058,6.438c4.756,0,7.772,4.176,7.772,8.468,0,4.35-2.61,8.41-7.772,8.41s-7.772-4.06-7.772-8.41C-96.454-18.56-93.786-22.736-88.682-22.736Zm22.1-13.166v7.366H-71.92v6.09h5.336v12.354c0,7.134,4.06,10.672,10.266,10.44A15.806,15.806,0,0,0-50.46-.87L-52.432-6.9a8.084,8.084,0,0,1-3.422.87c-2.2,0-3.712-1.334-3.712-4.06V-22.446h7.946v-6.09h-7.888v-8.12ZM-23.9-24.65c-1.624-2.842-5.278-4.64-9.106-4.64-8.352-.058-14.906,5.1-14.906,14.964,0,10.034,6.264,15.254,14.732,15.2,3.19-.058,7.656-1.682,9.28-5.046L-23.548,0h6.67V-28.594h-6.786Zm-8.468,1.682c11.136,0,11.136,17.342,0,17.342-4.7,0-8.468-3.248-8.468-8.7S-37.062-22.968-32.364-22.968ZM-10.9-40.542V0h7.018V-40.542Z\" transform=\"translate(565.498 -109.178)\"/>\r\n      <path id=\"controle\" class=\"hmb-cls-2\" d=\"M20.855-2.795A11.171,11.171,0,0,1,17.179-.366a11.238,11.238,0,0,1-4.193.8A12.364,12.364,0,0,1,8.708-.3a9.887,9.887,0,0,1-3.483-2.15A10.4,10.4,0,0,1,2.859-5.934a11.715,11.715,0,0,1-.881-4.644,11.771,11.771,0,0,1,.86-4.644,10.245,10.245,0,0,1,2.343-3.44,9.887,9.887,0,0,1,3.483-2.15,12.491,12.491,0,0,1,4.321-.731,10.671,10.671,0,0,1,4.021.752,10.526,10.526,0,0,1,3.5,2.387l-1.892,1.849A7.991,7.991,0,0,0,16-18.275a8.023,8.023,0,0,0-2.967-.559,9.064,9.064,0,0,0-3.182.559,7.448,7.448,0,0,0-2.6,1.612A7.659,7.659,0,0,0,5.5-14.082a8.937,8.937,0,0,0-.645,3.5A9.218,9.218,0,0,0,5.5-7.009a7.243,7.243,0,0,0,1.763,2.58,7.659,7.659,0,0,0,2.58,1.569,9.026,9.026,0,0,0,3.139.537,8.54,8.54,0,0,0,3.161-.6A7.964,7.964,0,0,0,18.877-4.73ZM34.572-21.543a11.584,11.584,0,0,1,4.321.8,10.129,10.129,0,0,1,3.462,2.257,10.565,10.565,0,0,1,2.3,3.5,11.722,11.722,0,0,1,.839,4.493,11.829,11.829,0,0,1-.817,4.472A10.115,10.115,0,0,1,42.4-2.559,10.025,10.025,0,0,1,38.937-.344,11.99,11.99,0,0,1,34.572.43,11.868,11.868,0,0,1,30.25-.344a10.025,10.025,0,0,1-3.461-2.215,10.377,10.377,0,0,1-2.3-3.461,11.561,11.561,0,0,1-.838-4.472,11.994,11.994,0,0,1,.817-4.493,10.464,10.464,0,0,1,2.257-3.5,9.9,9.9,0,0,1,3.44-2.257A11.822,11.822,0,0,1,34.572-21.543Zm0,2.623a8.3,8.3,0,0,0-3.247.623,7.578,7.578,0,0,0-2.558,1.742,7.69,7.69,0,0,0-1.656,2.666,9.6,9.6,0,0,0-.58,3.4,9.126,9.126,0,0,0,.6,3.376,7.7,7.7,0,0,0,1.656,2.6,7.148,7.148,0,0,0,2.537,1.655,8.834,8.834,0,0,0,3.247.58,8.788,8.788,0,0,0,3.268-.58,7.412,7.412,0,0,0,2.537-1.655,7.288,7.288,0,0,0,1.656-2.6,9.427,9.427,0,0,0,.58-3.376,9.3,9.3,0,0,0-.6-3.4,8.14,8.14,0,0,0-1.656-2.666A7.353,7.353,0,0,0,37.819-18.3,8.3,8.3,0,0,0,34.572-18.92ZM67.6,0V-11.911a6.859,6.859,0,0,0-1.849-5.2,7.051,7.051,0,0,0-5.074-1.763,6.836,6.836,0,0,0-2.838.58,6.592,6.592,0,0,0-2.193,1.57,7.386,7.386,0,0,0-1.419,2.3,7.743,7.743,0,0,0-.516,2.86V0H50.826V-21.242h2.752l.086,3.569a8.008,8.008,0,0,1,3.268-2.989A9.313,9.313,0,0,1,61-21.586a11.787,11.787,0,0,1,3.87.6,7.865,7.865,0,0,1,2.989,1.828,8.583,8.583,0,0,1,1.956,3.031,11.354,11.354,0,0,1,.71,4.171V0Zm14.19-27.52v6.45h6.88v2.451h-6.88V-6.751a6.176,6.176,0,0,0,.731,3.225,3.1,3.1,0,0,0,2.881,1.2,5.353,5.353,0,0,0,1.527-.237,12.944,12.944,0,0,0,1.57-.58l.9,2.408a13.621,13.621,0,0,1-2.043.753A7.629,7.629,0,0,1,85.312.3q-3.44.043-4.924-1.849a8.228,8.228,0,0,1-1.483-5.2V-18.619H74.562V-21.07H78.9v-6.149Zm14.19,6.278.172,3.483a6.267,6.267,0,0,1,1.269-1.806,6.61,6.61,0,0,1,1.656-1.182,7.38,7.38,0,0,1,1.892-.645,10.065,10.065,0,0,1,1.935-.193,8.569,8.569,0,0,1,2.559.344,8.263,8.263,0,0,1,2.257,1.161l-1.333,2.408a6.326,6.326,0,0,0-3.655-1.118,6.48,6.48,0,0,0-2.58.516,6.581,6.581,0,0,0-2.086,1.4,6.521,6.521,0,0,0-1.4,2.107,6.856,6.856,0,0,0-.516,2.688V0H93.267V-21.242Zm24.037-.3a11.584,11.584,0,0,1,4.322.8A10.129,10.129,0,0,1,127.8-18.49a10.565,10.565,0,0,1,2.3,3.5,11.722,11.722,0,0,1,.839,4.493,11.829,11.829,0,0,1-.817,4.472,10.115,10.115,0,0,1-2.279,3.461,10.025,10.025,0,0,1-3.461,2.215,11.99,11.99,0,0,1-4.365.774,11.868,11.868,0,0,1-4.322-.774,10.025,10.025,0,0,1-3.462-2.215,10.377,10.377,0,0,1-2.3-3.461,11.561,11.561,0,0,1-.839-4.472,11.994,11.994,0,0,1,.817-4.493,10.464,10.464,0,0,1,2.257-3.5,9.9,9.9,0,0,1,3.44-2.257A11.822,11.822,0,0,1,120.013-21.543Zm0,2.623a8.3,8.3,0,0,0-3.247.623,7.578,7.578,0,0,0-2.558,1.742,7.69,7.69,0,0,0-1.656,2.666,9.6,9.6,0,0,0-.58,3.4,9.126,9.126,0,0,0,.6,3.376,7.7,7.7,0,0,0,1.656,2.6,7.148,7.148,0,0,0,2.537,1.655,8.834,8.834,0,0,0,3.247.58,8.788,8.788,0,0,0,3.268-.58,7.412,7.412,0,0,0,2.537-1.655,7.288,7.288,0,0,0,1.655-2.6,9.427,9.427,0,0,0,.581-3.376,9.3,9.3,0,0,0-.6-3.4,8.14,8.14,0,0,0-1.655-2.666,7.353,7.353,0,0,0-2.537-1.742A8.3,8.3,0,0,0,120.013-18.92ZM139.449-30.1V0h-2.881V-30.1Zm27.09,20.726h-18.49a7.622,7.622,0,0,0,.817,2.988,7.258,7.258,0,0,0,1.763,2.214A7.583,7.583,0,0,0,153.1-2.795a9.261,9.261,0,0,0,2.988.473,10.737,10.737,0,0,0,1.978-.194,11.8,11.8,0,0,0,2-.559,9.663,9.663,0,0,0,1.806-.9,5.418,5.418,0,0,0,1.4-1.269l1.935,1.72a9.741,9.741,0,0,1-4.085,2.967A13.55,13.55,0,0,1,156.09.43,12.162,12.162,0,0,1,151.7-.344a9.983,9.983,0,0,1-3.483-2.215,10.328,10.328,0,0,1-2.3-3.483,11.958,11.958,0,0,1-.839-4.579,11.593,11.593,0,0,1,.817-4.386,10.513,10.513,0,0,1,2.258-3.483,10.162,10.162,0,0,1,3.44-2.279,10.9,10.9,0,0,1,4.365-.774,12.482,12.482,0,0,1,4.429.688,9.051,9.051,0,0,1,3.526,2.236,9.476,9.476,0,0,1,2.193,3.805A13.67,13.67,0,0,1,166.539-9.374Zm-18.49-2.451H163.83a7.745,7.745,0,0,0-.667-3.075,6.51,6.51,0,0,0-1.677-2.257,7.3,7.3,0,0,0-2.473-1.376,9.457,9.457,0,0,0-3.01-.473,7.952,7.952,0,0,0-5.375,1.849A8.018,8.018,0,0,0,148.049-11.825Z\" transform=\"translate(258.498 -109.178)\"/>\r\n    </g>\r\n    <g id=\"Logo_Simbolo\" transform=\"translate(585.009 27.076)\">\r\n      <path id=\"Branco\" class=\"hmb-cls-13\" d=\"M0,0H30.425V36.557H0Z\" transform=\"translate(98.316 97.018)\"/>\r\n      <path id=\"Azul\" class=\"hmb-cls-14\" d=\"M0,0H64.381V63.162H0Z\" transform=\"translate(64.347 133.561)\"/>\r\n      <path id=\"Roxo\" class=\"hmb-cls-15\" d=\"M0,0H30.428V26.623H0Z\" transform=\"translate(98.313 69.205)\"/>\r\n      <path id=\"Laranja\" class=\"hmb-cls-16\" d=\"M0,0H68.219V64.379H0Z\" transform=\"translate(128.741 69.193)\"/>\r\n      <path id=\"Verde\" class=\"hmb-cls-17\" d=\"M0,0H98.316V64.371H0Z\" transform=\"translate(0 69.194)\"/>\r\n      <path id=\"Amarelo\" class=\"hmb-cls-18\" d=\"M0,0H64.381V69.2H0Z\" transform=\"translate(64.36)\"/>\r\n    </g>\r\n  </g>\r\n</svg>\r\n"

/***/ }),
/* 1703 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 735 1399\">\r\n  <defs>\r\n    <style>\r\n      .cls-1 {\r\n        clip-path: url(#clip-banner_mais_para_voce_mobile_1);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #5d3b81;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #58595b;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #4b4e5c;\r\n      }\r\n\r\n      .cls-6 {\r\n        filter: url(#BGButton-para-voce-mobile);\r\n      }\r\n    </style>\r\n    <filter id=\"BGButton-para-voce-mobile\" x=\"-30\" y=\"966\" width=\"795\" height=\"378\" filterUnits=\"userSpaceOnUse\">\r\n      <feOffset dy=\"57\" input=\"SourceAlpha\"/>\r\n      <feGaussianBlur stdDeviation=\"45\" result=\"blur\"/>\r\n      <feFlood flood-color=\"#020202\" flood-opacity=\"0.141\"/>\r\n      <feComposite operator=\"in\" in2=\"blur\"/>\r\n      <feComposite in=\"SourceGraphic\"/>\r\n    </filter>\r\n    <clipPath id=\"clip-banner_mais_para_voce_mobile_1\">\r\n      <rect width=\"735\" height=\"1399\"/>\r\n    </clipPath>\r\n  </defs>\r\n  <g id=\"banner_mais_para_voce_mobile_1\" data-name=\"banner_mais_para_voce_mobile – 1\" class=\"cls-1\">\r\n    <rect class=\"cls-3\" width=\"735\" height=\"1399\"/>\r\n    <g id=\"Button-mais-para-voce\" transform=\"translate(104.51 1044.276)\">\r\n      <g class=\"cls-6\" transform=\"matrix(1, 0, 0, 1, -104.51, -1044.28)\">\r\n        <rect id=\"BGButton-para-voce-mobile-2\" data-name=\"BGButton-para-voce-mobile\" class=\"cls-2\" width=\"525\" height=\"108\" rx=\"54\" transform=\"translate(105 1044)\"/>\r\n      </g>\r\n      <path id=\"quero-agora-voce\" class=\"cls-3\" d=\"M-100.823-15.39A18.6,18.6,0,0,1-103.2-5.585a11.827,11.827,0,0,1-6.7,5.291l7.307,7.6h-5.186L-113.757.378l-1.155.042q-6.782,0-10.467-4.147t-3.685-11.705q0-7.5,3.7-11.621t10.5-4.126q6.614,0,10.33,4.2T-100.823-15.39Zm-24.46,0q0,6.236,2.656,9.459t7.716,3.223q5.1,0,7.706-3.212t2.6-9.469q0-6.194-2.593-9.4t-7.674-3.2q-5.1,0-7.758,3.223T-125.284-15.39Zm34.056-7.622V-8.083a6.006,6.006,0,0,0,1.281,4.2A5.218,5.218,0,0,0-85.937-2.5q3.611,0,5.281-1.974t1.669-6.446V-23.012H-75.5V0h-2.876l-.5-3.086h-.189a6.947,6.947,0,0,1-2.971,2.6,9.986,9.986,0,0,1-4.336.9q-4.2,0-6.288-1.995t-2.089-6.383V-23.012ZM-58.39.42a10.573,10.573,0,0,1-8.052-3.107q-2.95-3.107-2.95-8.629,0-5.564,2.74-8.839a9.1,9.1,0,0,1,7.359-3.275,8.678,8.678,0,0,1,6.845,2.845,10.9,10.9,0,0,1,2.52,7.506v2.2H-65.781a9.122,9.122,0,0,0,2.047,6.152,7.08,7.08,0,0,0,5.469,2.1,18.535,18.535,0,0,0,7.349-1.554v3.107a18.444,18.444,0,0,1-3.5,1.144A19.646,19.646,0,0,1-58.39.42Zm-.945-20.933a5.692,5.692,0,0,0-4.42,1.806,8.323,8.323,0,0,0-1.942,5h12.031a7.663,7.663,0,0,0-1.47-5.05A5.173,5.173,0,0,0-59.335-20.513Zm25.846-2.918a13.638,13.638,0,0,1,2.75.252l-.483,3.233a11.872,11.872,0,0,0-2.52-.315,6.133,6.133,0,0,0-4.777,2.268A8.268,8.268,0,0,0-40.5-12.346V0h-3.485V-23.012h2.876l.4,4.262h.168a10.116,10.116,0,0,1,3.086-3.464A6.948,6.948,0,0,1-33.489-23.432Zm26.056,11.9q0,5.627-2.834,8.787A9.983,9.983,0,0,1-18.1.42a10.373,10.373,0,0,1-5.48-1.449,9.562,9.562,0,0,1-3.7-4.157,14.488,14.488,0,0,1-1.3-6.341q0-5.627,2.813-8.766a9.95,9.95,0,0,1,7.811-3.139,9.735,9.735,0,0,1,7.674,3.212Q-7.433-17.007-7.433-11.527Zm-17.532,0q0,4.409,1.764,6.719A6.122,6.122,0,0,0-18.015-2.5a6.163,6.163,0,0,0,5.2-2.3q1.774-2.3,1.774-6.729,0-4.388-1.774-6.666a6.234,6.234,0,0,0-5.239-2.278,6.135,6.135,0,0,0-5.165,2.247Q-24.964-15.978-24.964-11.527ZM24,0l-.693-3.275h-.168A9.683,9.683,0,0,1,19.7-.346,10.464,10.464,0,0,1,15.432.42a7.686,7.686,0,0,1-5.365-1.764A6.433,6.433,0,0,1,8.125-6.362q0-6.971,11.149-7.307l3.905-.126v-1.428a5.834,5.834,0,0,0-1.165-4,4.793,4.793,0,0,0-3.727-1.291,15.185,15.185,0,0,0-6.509,1.764l-1.071-2.667a16.378,16.378,0,0,1,3.727-1.449A16.141,16.141,0,0,1,18.5-23.39q4.115,0,6.1,1.827t1.984,5.858V0ZM16.125-2.457a7.074,7.074,0,0,0,5.113-1.785,6.6,6.6,0,0,0,1.858-5v-2.079l-3.485.147q-4.157.147-5.994,1.291A3.894,3.894,0,0,0,11.779-6.32a3.591,3.591,0,0,0,1.144,2.876A4.75,4.75,0,0,0,16.125-2.457ZM52.6-23.012v2.2l-4.262.5a7.327,7.327,0,0,1,1.05,1.921,7.33,7.33,0,0,1,.462,2.677,6.8,6.8,0,0,1-2.31,5.4,9.317,9.317,0,0,1-6.341,2.016,10.559,10.559,0,0,1-1.932-.168Q37.037-7.286,37.037-5.5a1.5,1.5,0,0,0,.777,1.4,5.675,5.675,0,0,0,2.667.451h4.073A9.121,9.121,0,0,1,50.3-2.079,5.471,5.471,0,0,1,52.3,2.5a6.534,6.534,0,0,1-3.065,5.826Q46.17,10.33,40.292,10.33a12.22,12.22,0,0,1-6.96-1.68,5.423,5.423,0,0,1-2.446-4.745A5.329,5.329,0,0,1,32.229.273a6.842,6.842,0,0,1,3.779-2.079,3.646,3.646,0,0,1-1.48-1.239A3.278,3.278,0,0,1,33.93-5,3.706,3.706,0,0,1,34.6-7.2a7.064,7.064,0,0,1,2.121-1.827,6.216,6.216,0,0,1-2.908-2.5,7.342,7.342,0,0,1-1.123-4.031,7.446,7.446,0,0,1,2.268-5.826,9.258,9.258,0,0,1,6.425-2.047,11.683,11.683,0,0,1,3.254.42ZM34.245,3.863A3.123,3.123,0,0,0,35.819,6.7a8.691,8.691,0,0,0,4.514.966q4.388,0,6.5-1.312a4.018,4.018,0,0,0,2.11-3.559A2.816,2.816,0,0,0,47.787.2a8.969,8.969,0,0,0-4.346-.724H39.263a5.5,5.5,0,0,0-3.7,1.134A4.051,4.051,0,0,0,34.245,3.863Zm1.89-19.505A4.685,4.685,0,0,0,37.5-11.989a5.449,5.449,0,0,0,3.8,1.239q5.1,0,5.1-4.955,0-5.186-5.165-5.186a5.114,5.114,0,0,0-3.779,1.323A5.327,5.327,0,0,0,36.134-15.642Zm41.047,4.115q0,5.627-2.834,8.787A9.983,9.983,0,0,1,66.516.42a10.373,10.373,0,0,1-5.48-1.449,9.562,9.562,0,0,1-3.7-4.157,14.488,14.488,0,0,1-1.3-6.341q0-5.627,2.813-8.766a9.95,9.95,0,0,1,7.811-3.139,9.735,9.735,0,0,1,7.674,3.212Q77.182-17.007,77.182-11.527Zm-17.532,0q0,4.409,1.764,6.719A6.122,6.122,0,0,0,66.6-2.5a6.163,6.163,0,0,0,5.2-2.3q1.774-2.3,1.774-6.729,0-4.388-1.774-6.666a6.234,6.234,0,0,0-5.239-2.278,6.135,6.135,0,0,0-5.165,2.247Q59.65-15.978,59.65-11.527Zm34.14-11.9a13.638,13.638,0,0,1,2.75.252l-.483,3.233a11.872,11.872,0,0,0-2.52-.315,6.133,6.133,0,0,0-4.777,2.268,8.268,8.268,0,0,0-1.984,5.648V0H83.292V-23.012h2.876l.4,4.262h.168a10.116,10.116,0,0,1,3.086-3.464A6.948,6.948,0,0,1,93.79-23.432ZM114.135,0l-.693-3.275h-.168a9.683,9.683,0,0,1-3.433,2.929,10.464,10.464,0,0,1-4.273.766A7.686,7.686,0,0,1,100.2-1.344a6.433,6.433,0,0,1-1.942-5.018q0-6.971,11.149-7.307l3.905-.126v-1.428a5.834,5.834,0,0,0-1.165-4,4.793,4.793,0,0,0-3.727-1.291,15.185,15.185,0,0,0-6.509,1.764l-1.071-2.667a16.378,16.378,0,0,1,3.727-1.449,16.141,16.141,0,0,1,4.063-.525q4.115,0,6.1,1.827t1.984,5.858V0Zm-7.874-2.457a7.074,7.074,0,0,0,5.113-1.785,6.6,6.6,0,0,0,1.858-5v-2.079l-3.485.147q-4.157.147-5.994,1.291a3.894,3.894,0,0,0-1.837,3.559,3.591,3.591,0,0,0,1.144,2.876A4.75,4.75,0,0,0,106.261-2.457Zm20.786-6h-2.2L123.772-30.7h4.346Zm-3.653,6.236q0-2.855,2.52-2.855a2.4,2.4,0,0,1,1.879.735,3.068,3.068,0,0,1,.661,2.121,3.01,3.01,0,0,1-.672,2.089,2.387,2.387,0,0,1-1.869.745,2.553,2.553,0,0,1-1.806-.661A2.849,2.849,0,0,1,123.394-2.226Z\" transform=\"translate(256.49 63.904)\"/>\r\n      <g id=\"Icon-arrow-para-voce-mobile\" transform=\"translate(446.014 73.788) rotate(-90)\">\r\n        <path id=\"Caminho_24\" data-name=\"Caminho 24\" class=\"cls-3\" d=\"M.542.55a1.866,1.866,0,0,0,0,2.629l9.217,9.188a1.857,1.857,0,0,0,2.562.058L21.4,3.372A1.856,1.856,0,1,0,18.782.743l-7.8,7.685L3.171.541A1.857,1.857,0,0,0,.542.55Z\" transform=\"translate(9.05 15.119)\"/>\r\n        <path id=\"Caminho_25\" data-name=\"Caminho 25\" class=\"cls-3\" d=\"M0,20.032A20.032,20.032,0,1,0,20.032,0,20.029,20.029,0,0,0,0,20.032ZM32.013,8.051A16.943,16.943,0,1,1,8.051,32.013,16.943,16.943,0,1,1,32.013,8.051Z\"/>\r\n      </g>\r\n    </g>\r\n    <g id=\"Texto-mais-para-voce\" transform=\"translate(32.937 399.949)\">\r\n      <path id=\"paragrafo-para-voce\" class=\"cls-4\" d=\"M51.369,14.1l2.006-1.122a7.865,7.865,0,0,0-1.819-2.023,9.531,9.531,0,0,0-2.193-1.275,10.305,10.305,0,0,0-2.4-.663A16.523,16.523,0,0,0,44.5,8.826a15.86,15.86,0,0,0-3.111.323,9.611,9.611,0,0,0-2.941,1.088,6.464,6.464,0,0,0-2.176,2.04,5.362,5.362,0,0,0-.816,3.145,4.881,4.881,0,0,0,.765,2.839,5.925,5.925,0,0,0,2.006,1.8,10.79,10.79,0,0,0,2.839,1.071q1.6.374,3.3.68,1.394.238,2.7.544a10.038,10.038,0,0,1,2.329.833A4.868,4.868,0,0,1,51.029,24.5a3.158,3.158,0,0,1,.612,2.006,3.7,3.7,0,0,1-.7,2.329,4.692,4.692,0,0,1-1.751,1.394,8.31,8.31,0,0,1-2.312.68,16.014,16.014,0,0,1-2.346.187,12.62,12.62,0,0,1-2.227-.2,8.493,8.493,0,0,1-4.114-1.972,6.654,6.654,0,0,1-1.513-1.938L34.607,28.1a8,8,0,0,0,1.751,2.431,9.345,9.345,0,0,0,2.4,1.632,11.794,11.794,0,0,0,2.805.918,15.477,15.477,0,0,0,2.975.289,18.505,18.505,0,0,0,3.315-.306,9.636,9.636,0,0,0,3.06-1.088,6.6,6.6,0,0,0,2.261-2.108,5.882,5.882,0,0,0,.884-3.332,5.447,5.447,0,0,0-.816-3.111A6.243,6.243,0,0,0,51.1,21.474a11.673,11.673,0,0,0-3.026-1.156q-1.7-.408-3.468-.714-1.394-.238-2.618-.527a9.854,9.854,0,0,1-2.142-.748,4.2,4.2,0,0,1-1.462-1.156,2.76,2.76,0,0,1-.544-1.751,3.487,3.487,0,0,1,.629-2.159,4.522,4.522,0,0,1,1.615-1.326,7.4,7.4,0,0,1,2.176-.68,14.685,14.685,0,0,1,2.278-.187,11.393,11.393,0,0,1,1.938.17,9.862,9.862,0,0,1,1.9.527,7.675,7.675,0,0,1,1.7.918A4.673,4.673,0,0,1,51.369,14.1ZM74.183,25.588a10.809,10.809,0,0,0-.34-4.3,7.493,7.493,0,0,0-1.734-3.009,7.157,7.157,0,0,0-2.788-1.768,9.869,9.869,0,0,0-3.5-.544,8.616,8.616,0,0,0-3.451.612,8.035,8.035,0,0,0-2.72,1.8,8.313,8.313,0,0,0-1.785,2.754,9.167,9.167,0,0,0-.646,3.468,9.455,9.455,0,0,0,.663,3.621A8.166,8.166,0,0,0,59.7,30.977a7.893,7.893,0,0,0,2.754,1.751,9.617,9.617,0,0,0,3.468.612,10.714,10.714,0,0,0,3.978-.782,7.7,7.7,0,0,0,3.23-2.346l-1.53-1.36a4.284,4.284,0,0,1-1.1,1,7.64,7.64,0,0,1-1.428.714,9.33,9.33,0,0,1-1.581.442,8.49,8.49,0,0,1-1.564.153,7.323,7.323,0,0,1-2.363-.374A6,6,0,0,1,61.6,29.7a5.739,5.739,0,0,1-1.394-1.751,6.027,6.027,0,0,1-.646-2.363ZM59.563,23.65a5.971,5.971,0,0,1,6.29-5.678,7.477,7.477,0,0,1,2.38.374,5.772,5.772,0,0,1,1.955,1.088,5.148,5.148,0,0,1,1.326,1.785,6.128,6.128,0,0,1,.527,2.431ZM90.367,33h2.278V23.276A5.861,5.861,0,0,1,93,21.2a4.815,4.815,0,0,1,1.02-1.649,4.957,4.957,0,0,1,1.564-1.1,4.85,4.85,0,0,1,2.023-.408,4.911,4.911,0,0,1,2.006.391,4.535,4.535,0,0,1,1.513,1.071,4.7,4.7,0,0,1,.969,1.632,6.125,6.125,0,0,1,.34,2.074V33h2.278V23.208a8.421,8.421,0,0,0-.51-3.009,6.672,6.672,0,0,0-1.428-2.3,5.968,5.968,0,0,0-2.227-1.445,8.192,8.192,0,0,0-2.907-.493,7.325,7.325,0,0,0-3.536.9,5.674,5.674,0,0,0-2.516,2.907,5.76,5.76,0,0,0-1-1.8,5.33,5.33,0,0,0-1.428-1.207,5.409,5.409,0,0,0-1.683-.629,9.521,9.521,0,0,0-1.8-.17,7.264,7.264,0,0,0-2.958.629,4.6,4.6,0,0,0-2.244,2.227l-.1-2.686H78.229V33h2.278V23.276a5.861,5.861,0,0,1,.357-2.074,4.955,4.955,0,0,1,1-1.649,4.761,4.761,0,0,1,1.547-1.1,5.219,5.219,0,0,1,4.046,0,4.762,4.762,0,0,1,1.547,1.1,4.955,4.955,0,0,1,1,1.649,5.861,5.861,0,0,1,.357,2.074Zm40.46,0h2.278V23.276a5.861,5.861,0,0,1,.357-2.074,4.815,4.815,0,0,1,1.02-1.649,4.957,4.957,0,0,1,1.564-1.1,4.851,4.851,0,0,1,2.023-.408,4.911,4.911,0,0,1,2.006.391,4.535,4.535,0,0,1,1.513,1.071,4.7,4.7,0,0,1,.969,1.632,6.125,6.125,0,0,1,.34,2.074V33h2.278V23.208a8.422,8.422,0,0,0-.51-3.009,6.672,6.672,0,0,0-1.428-2.3,5.968,5.968,0,0,0-2.227-1.445,8.192,8.192,0,0,0-2.907-.493,7.325,7.325,0,0,0-3.536.9,5.674,5.674,0,0,0-2.516,2.907,5.76,5.76,0,0,0-1-1.8,5.33,5.33,0,0,0-1.428-1.207,5.409,5.409,0,0,0-1.683-.629,9.521,9.521,0,0,0-1.8-.17,7.264,7.264,0,0,0-2.958.629,4.6,4.6,0,0,0-2.244,2.227l-.1-2.686h-2.142V33h2.278V23.276a5.861,5.861,0,0,1,.357-2.074,4.955,4.955,0,0,1,1-1.649,4.761,4.761,0,0,1,1.547-1.1,5.219,5.219,0,0,1,4.046,0,4.762,4.762,0,0,1,1.547,1.1,4.955,4.955,0,0,1,1,1.649,5.861,5.861,0,0,1,.357,2.074Zm35.326-7.412a10.809,10.809,0,0,0-.34-4.3,7.493,7.493,0,0,0-1.734-3.009,7.157,7.157,0,0,0-2.788-1.768,9.869,9.869,0,0,0-3.5-.544,8.616,8.616,0,0,0-3.451.612,8.035,8.035,0,0,0-2.72,1.8,8.313,8.313,0,0,0-1.785,2.754,9.166,9.166,0,0,0-.646,3.468,9.455,9.455,0,0,0,.663,3.621,8.166,8.166,0,0,0,1.819,2.754,7.893,7.893,0,0,0,2.754,1.751,9.617,9.617,0,0,0,3.468.612,10.714,10.714,0,0,0,3.978-.782,7.7,7.7,0,0,0,3.23-2.346l-1.53-1.36a4.284,4.284,0,0,1-1.1,1,7.64,7.64,0,0,1-1.428.714,9.329,9.329,0,0,1-1.581.442,8.49,8.49,0,0,1-1.564.153,7.323,7.323,0,0,1-2.363-.374,6,6,0,0,1-1.955-1.088,5.739,5.739,0,0,1-1.394-1.751,6.027,6.027,0,0,1-.646-2.363Zm-14.62-1.938a5.971,5.971,0,0,1,6.29-5.678,7.477,7.477,0,0,1,2.38.374,5.772,5.772,0,0,1,1.955,1.088,5.148,5.148,0,0,1,1.326,1.785,6.128,6.128,0,0,1,.527,2.431ZM183.459,33h2.312V23.548a8.978,8.978,0,0,0-.561-3.3,6.786,6.786,0,0,0-1.547-2.4,6.219,6.219,0,0,0-2.363-1.445,9.32,9.32,0,0,0-3.06-.476,7.364,7.364,0,0,0-3.213.731,6.332,6.332,0,0,0-2.584,2.363l-.068-2.822H170.2V33h2.278V23.854a6.122,6.122,0,0,1,.408-2.261,5.84,5.84,0,0,1,1.122-1.819,5.212,5.212,0,0,1,1.734-1.241,5.405,5.405,0,0,1,2.244-.459A5.575,5.575,0,0,1,182,19.468a5.424,5.424,0,0,1,1.462,4.114Zm18.36-13.294,1.326-1.5a8.135,8.135,0,0,0-2.856-1.734,10.5,10.5,0,0,0-3.468-.544,11.254,11.254,0,0,0-2.448.272,6.89,6.89,0,0,0-2.176.867,4.932,4.932,0,0,0-1.547,1.513,3.85,3.85,0,0,0-.6,2.142,3.568,3.568,0,0,0,.6,2.125,4.5,4.5,0,0,0,1.53,1.343,8.293,8.293,0,0,0,2.108.782q1.173.272,2.4.442,1.02.136,1.9.306a6.2,6.2,0,0,1,1.547.493,2.676,2.676,0,0,1,1.037.85,2.266,2.266,0,0,1,.374,1.343,2.14,2.14,0,0,1-.442,1.394,3.141,3.141,0,0,1-1.139.867,5.446,5.446,0,0,1-1.5.442,10.289,10.289,0,0,1-1.513.119,10.137,10.137,0,0,1-3.3-.646,5.916,5.916,0,0,1-2.754-2.074l-1.428,1.564a7.277,7.277,0,0,0,3.281,2.5,11.5,11.5,0,0,0,4.165.765,11.64,11.64,0,0,0,2.5-.272,7.356,7.356,0,0,0,2.21-.85A4.647,4.647,0,0,0,203.2,30.7a4.34,4.34,0,0,0,.629-2.261A4.1,4.1,0,0,0,203.162,26a4.561,4.561,0,0,0-1.683-1.428,8.709,8.709,0,0,0-2.244-.748q-1.224-.238-2.346-.408-.782-.1-1.6-.272a6.86,6.86,0,0,1-1.479-.476,3.272,3.272,0,0,1-1.088-.782,1.769,1.769,0,0,1-.425-1.224,1.743,1.743,0,0,1,.34-1.156,2.968,2.968,0,0,1,1-.85,4.932,4.932,0,0,1,1.462-.493,9.681,9.681,0,0,1,1.751-.153,10.414,10.414,0,0,1,2.567.306A5.676,5.676,0,0,1,201.819,19.706Zm20.128-.17a6.015,6.015,0,0,0-1.207-1.564,7.018,7.018,0,0,0-1.6-1.122,7.834,7.834,0,0,0-1.853-.663,8.843,8.843,0,0,0-1.938-.221,9.155,9.155,0,0,0-3.366.612,8.092,8.092,0,0,0-2.72,1.734,8.227,8.227,0,0,0-1.836,2.72,9.031,9.031,0,0,0-.68,3.57,9.455,9.455,0,0,0,.663,3.621,8.041,8.041,0,0,0,1.836,2.754,8.185,8.185,0,0,0,2.72,1.751,9.022,9.022,0,0,0,3.349.612,8.4,8.4,0,0,0,1.9-.221,7.493,7.493,0,0,0,1.819-.68,7.929,7.929,0,0,0,1.632-1.156,6.99,6.99,0,0,0,1.309-1.615V33h2.108V16.2h-2.142Zm-6.528-1.5a6.363,6.363,0,0,1,3.621.969A6.155,6.155,0,0,1,221.2,21.44a7.434,7.434,0,0,1,0,6.358,6.155,6.155,0,0,1-2.159,2.431,6.363,6.363,0,0,1-3.621.969,6.582,6.582,0,0,1-2.5-.476,6.089,6.089,0,0,1-2.04-1.343,6.222,6.222,0,0,1-1.36-2.074,7.61,7.61,0,0,1,0-5.389,6,6,0,0,1,1.36-2.074,6.221,6.221,0,0,1,2.04-1.326A6.582,6.582,0,0,1,215.419,18.04Zm16.49-8.84h-2.278V33h2.278Zm7.82,6.936h-2.278V33h2.278Zm-2.72-5.2a1.424,1.424,0,0,0,.51,1.207,1.757,1.757,0,0,0,1.088.391,1.8,1.8,0,0,0,1.122-.391,1.424,1.424,0,0,0,.51-1.207,1.434,1.434,0,0,0-.51-1.19,1.755,1.755,0,0,0-1.122-.408,1.712,1.712,0,0,0-1.088.408A1.434,1.434,0,0,0,237.009,10.934Zm15.572,7.174a6.582,6.582,0,0,1,2.5.476A6.032,6.032,0,0,1,257.1,19.91a6.167,6.167,0,0,1,1.343,2.057,6.9,6.9,0,0,1,.493,2.635,7,7,0,0,1-.493,2.669,6.36,6.36,0,0,1-1.343,2.074,5.947,5.947,0,0,1-2.006,1.343,6.544,6.544,0,0,1-2.516.476,7,7,0,0,1-2.465-.425,5.78,5.78,0,0,1-2.006-1.258,5.857,5.857,0,0,1-1.36-2.04,7.38,7.38,0,0,1-.493-2.805,7.511,7.511,0,0,1,.493-2.822,5.655,5.655,0,0,1,1.36-2.04,5.909,5.909,0,0,1,2.006-1.241A7,7,0,0,1,252.581,18.108Zm8.738-8.874h-2.278V19.57a5.97,5.97,0,0,0-2.788-2.754,8.339,8.339,0,0,0-3.808-.85,8.868,8.868,0,0,0-3.332.544,7.867,7.867,0,0,0-2.686,1.683,7.615,7.615,0,0,0-1.8,2.72,9.971,9.971,0,0,0-.646,3.723,9.971,9.971,0,0,0,.646,3.723,7.615,7.615,0,0,0,1.8,2.72,7.867,7.867,0,0,0,2.686,1.683,9.354,9.354,0,0,0,3.332.578,8.175,8.175,0,0,0,3.791-.918,6.635,6.635,0,0,0,2.8-2.754L259.109,33h2.21Zm19.414,10.3a6.015,6.015,0,0,0-1.207-1.564,7.018,7.018,0,0,0-1.6-1.122,7.834,7.834,0,0,0-1.853-.663,8.843,8.843,0,0,0-1.938-.221,9.155,9.155,0,0,0-3.366.612,8.092,8.092,0,0,0-2.72,1.734,8.228,8.228,0,0,0-1.836,2.72,9.032,9.032,0,0,0-.68,3.57,9.456,9.456,0,0,0,.663,3.621,8.042,8.042,0,0,0,1.836,2.754,8.186,8.186,0,0,0,2.72,1.751,9.022,9.022,0,0,0,3.349.612,8.4,8.4,0,0,0,1.9-.221,7.494,7.494,0,0,0,1.819-.68,7.93,7.93,0,0,0,1.632-1.156,6.989,6.989,0,0,0,1.309-1.615V33h2.108V16.2h-2.142Zm-6.528-1.5a6.363,6.363,0,0,1,3.621.969,6.156,6.156,0,0,1,2.159,2.431,7.434,7.434,0,0,1,0,6.358,6.156,6.156,0,0,1-2.159,2.431,6.363,6.363,0,0,1-3.621.969,6.582,6.582,0,0,1-2.5-.476,6.089,6.089,0,0,1-2.04-1.343,6.222,6.222,0,0,1-1.36-2.074,7.61,7.61,0,0,1,0-5.389,6,6,0,0,1,1.36-2.074,6.222,6.222,0,0,1,2.04-1.326A6.582,6.582,0,0,1,274.205,18.04Zm21.522.068a6.582,6.582,0,0,1,2.5.476,6.032,6.032,0,0,1,2.023,1.326,6.167,6.167,0,0,1,1.343,2.057,6.9,6.9,0,0,1,.493,2.635,7,7,0,0,1-.493,2.669,6.36,6.36,0,0,1-1.343,2.074,5.947,5.947,0,0,1-2.006,1.343,6.544,6.544,0,0,1-2.516.476,7,7,0,0,1-2.465-.425,5.781,5.781,0,0,1-2.006-1.258,5.857,5.857,0,0,1-1.36-2.04,7.38,7.38,0,0,1-.493-2.805,7.512,7.512,0,0,1,.493-2.822,5.655,5.655,0,0,1,1.36-2.04,5.909,5.909,0,0,1,2.006-1.241A7,7,0,0,1,295.727,18.108Zm8.738-8.874h-2.278V19.57a5.97,5.97,0,0,0-2.788-2.754,8.339,8.339,0,0,0-3.808-.85,8.868,8.868,0,0,0-3.332.544,7.867,7.867,0,0,0-2.686,1.683,7.615,7.615,0,0,0-1.8,2.72,9.971,9.971,0,0,0-.646,3.723,9.971,9.971,0,0,0,.646,3.723,7.615,7.615,0,0,0,1.8,2.72,7.867,7.867,0,0,0,2.686,1.683,9.354,9.354,0,0,0,3.332.578,8.175,8.175,0,0,0,3.791-.918,6.635,6.635,0,0,0,2.8-2.754L302.255,33h2.21Zm21.182,16.354a10.809,10.809,0,0,0-.34-4.3,7.493,7.493,0,0,0-1.734-3.009,7.156,7.156,0,0,0-2.788-1.768,9.869,9.869,0,0,0-3.5-.544,8.616,8.616,0,0,0-3.451.612,8.036,8.036,0,0,0-2.72,1.8,8.313,8.313,0,0,0-1.785,2.754,9.167,9.167,0,0,0-.646,3.468,9.456,9.456,0,0,0,.663,3.621,8.166,8.166,0,0,0,1.819,2.754,7.894,7.894,0,0,0,2.754,1.751,9.617,9.617,0,0,0,3.468.612,10.714,10.714,0,0,0,3.978-.782,7.7,7.7,0,0,0,3.23-2.346l-1.53-1.36a4.284,4.284,0,0,1-1.105,1,7.64,7.64,0,0,1-1.428.714,9.329,9.329,0,0,1-1.581.442,8.49,8.49,0,0,1-1.564.153,7.323,7.323,0,0,1-2.363-.374,6,6,0,0,1-1.955-1.088,5.739,5.739,0,0,1-1.394-1.751,6.027,6.027,0,0,1-.646-2.363Zm-14.62-1.938a5.971,5.971,0,0,1,6.29-5.678,7.477,7.477,0,0,1,2.38.374,5.772,5.772,0,0,1,1.955,1.088,5.148,5.148,0,0,1,1.326,1.785,6.128,6.128,0,0,1,.527,2.431Zm21.59,8.16a1.377,1.377,0,0,0-.51-1.19A1.831,1.831,0,0,0,331,30.246a1.779,1.779,0,0,0-1.105.391,1.348,1.348,0,0,0-.51,1.139,1.3,1.3,0,0,0,.289.9,1.583,1.583,0,0,0,.731.459l-.952,2.958h1.7q.544-1.564,1-2.6A4.429,4.429,0,0,0,332.617,31.81Zm24.82-12.1,1.326-1.5a8.135,8.135,0,0,0-2.856-1.734,10.5,10.5,0,0,0-3.468-.544,11.254,11.254,0,0,0-2.448.272,6.891,6.891,0,0,0-2.176.867,4.932,4.932,0,0,0-1.547,1.513,3.85,3.85,0,0,0-.6,2.142,3.568,3.568,0,0,0,.6,2.125,4.5,4.5,0,0,0,1.53,1.343,8.292,8.292,0,0,0,2.108.782q1.173.272,2.4.442,1.02.136,1.9.306a6.2,6.2,0,0,1,1.547.493,2.676,2.676,0,0,1,1.037.85,2.266,2.266,0,0,1,.374,1.343,2.14,2.14,0,0,1-.442,1.394,3.141,3.141,0,0,1-1.139.867,5.446,5.446,0,0,1-1.5.442,10.29,10.29,0,0,1-1.513.119,10.137,10.137,0,0,1-3.3-.646,5.917,5.917,0,0,1-2.754-2.074L345.1,30.076a7.277,7.277,0,0,0,3.281,2.5,11.5,11.5,0,0,0,4.165.765,11.64,11.64,0,0,0,2.5-.272,7.356,7.356,0,0,0,2.21-.85,4.647,4.647,0,0,0,1.564-1.513,4.339,4.339,0,0,0,.629-2.261A4.094,4.094,0,0,0,358.78,26a4.561,4.561,0,0,0-1.683-1.428,8.709,8.709,0,0,0-2.244-.748q-1.224-.238-2.346-.408-.782-.1-1.6-.272a6.86,6.86,0,0,1-1.479-.476,3.272,3.272,0,0,1-1.088-.782,1.769,1.769,0,0,1-.425-1.224,1.743,1.743,0,0,1,.34-1.156,2.967,2.967,0,0,1,1-.85,4.931,4.931,0,0,1,1.462-.493,9.681,9.681,0,0,1,1.751-.153,10.414,10.414,0,0,1,2.567.306A5.676,5.676,0,0,1,357.437,19.706Zm20.128-.17a6.015,6.015,0,0,0-1.207-1.564,7.018,7.018,0,0,0-1.6-1.122,7.834,7.834,0,0,0-1.853-.663,8.843,8.843,0,0,0-1.938-.221,9.155,9.155,0,0,0-3.366.612,8.092,8.092,0,0,0-2.72,1.734,8.228,8.228,0,0,0-1.836,2.72,9.032,9.032,0,0,0-.68,3.57,9.456,9.456,0,0,0,.663,3.621,8.042,8.042,0,0,0,1.836,2.754,8.186,8.186,0,0,0,2.72,1.751,9.022,9.022,0,0,0,3.349.612,8.4,8.4,0,0,0,1.9-.221,7.494,7.494,0,0,0,1.819-.68,7.93,7.93,0,0,0,1.632-1.156,6.99,6.99,0,0,0,1.309-1.615V33h2.108V16.2h-2.142Zm-6.528-1.5a6.363,6.363,0,0,1,3.621.969,6.156,6.156,0,0,1,2.159,2.431,7.434,7.434,0,0,1,0,6.358,6.156,6.156,0,0,1-2.159,2.431,6.363,6.363,0,0,1-3.621.969,6.582,6.582,0,0,1-2.5-.476,6.089,6.089,0,0,1-2.04-1.343,6.222,6.222,0,0,1-1.36-2.074,7.61,7.61,0,0,1,0-5.389,6,6,0,0,1,1.36-2.074,6.222,6.222,0,0,1,2.04-1.326A6.582,6.582,0,0,1,371.037,18.04Zm16.49-8.84h-2.278V33h2.278Zm13.09,8.908a6.582,6.582,0,0,1,2.5.476,6.032,6.032,0,0,1,2.023,1.326,6.167,6.167,0,0,1,1.343,2.057,6.9,6.9,0,0,1,.493,2.635,7,7,0,0,1-.493,2.669,6.36,6.36,0,0,1-1.343,2.074,5.947,5.947,0,0,1-2.006,1.343,6.544,6.544,0,0,1-2.516.476,7,7,0,0,1-2.465-.425,5.781,5.781,0,0,1-2.006-1.258,5.857,5.857,0,0,1-1.36-2.04,7.38,7.38,0,0,1-.493-2.805,7.512,7.512,0,0,1,.493-2.822,5.655,5.655,0,0,1,1.36-2.04,5.909,5.909,0,0,1,2.006-1.241A7,7,0,0,1,400.617,18.108Zm8.738-8.874h-2.278V19.57a5.97,5.97,0,0,0-2.788-2.754,8.339,8.339,0,0,0-3.808-.85,8.868,8.868,0,0,0-3.332.544,7.867,7.867,0,0,0-2.686,1.683,7.615,7.615,0,0,0-1.8,2.72,9.971,9.971,0,0,0-.646,3.723,9.971,9.971,0,0,0,.646,3.723,7.615,7.615,0,0,0,1.8,2.72,7.867,7.867,0,0,0,2.686,1.683,9.354,9.354,0,0,0,3.332.578,8.175,8.175,0,0,0,3.791-.918,6.635,6.635,0,0,0,2.8-2.754L407.145,33h2.21Zm12.852,6.732a9.348,9.348,0,0,0-3.485.629A7.832,7.832,0,0,0,416,18.38a8.273,8.273,0,0,0-1.785,2.771,9.484,9.484,0,0,0-.646,3.553,9.142,9.142,0,0,0,.663,3.536,8.206,8.206,0,0,0,1.819,2.737,7.927,7.927,0,0,0,2.737,1.751,9.384,9.384,0,0,0,3.417.612,9.481,9.481,0,0,0,3.451-.612A7.837,7.837,0,0,0,430.2,28.24a9.925,9.925,0,0,0-.017-7.089,8.355,8.355,0,0,0-1.819-2.771,8.009,8.009,0,0,0-2.737-1.785A9.159,9.159,0,0,0,422.207,15.966Zm0,2.074a6.559,6.559,0,0,1,2.567.493,5.814,5.814,0,0,1,2.006,1.377,6.436,6.436,0,0,1,1.309,2.108,7.351,7.351,0,0,1,.476,2.686,7.454,7.454,0,0,1-.459,2.669A5.763,5.763,0,0,1,426.8,29.43a5.861,5.861,0,0,1-2.006,1.309,7.455,7.455,0,0,1-5.151,0,5.652,5.652,0,0,1-2.006-1.309,6.09,6.09,0,0,1-1.309-2.057,7.216,7.216,0,0,1-.476-2.669,7.593,7.593,0,0,1,.459-2.686,6.081,6.081,0,0,1,1.309-2.108,5.993,5.993,0,0,1,2.023-1.377A6.559,6.559,0,0,1,422.207,18.04ZM457.193,33h2.312V23.548a8.978,8.978,0,0,0-.561-3.3,6.786,6.786,0,0,0-1.547-2.4,6.218,6.218,0,0,0-2.363-1.445,9.32,9.32,0,0,0-3.06-.476,7.363,7.363,0,0,0-3.213.731,6.332,6.332,0,0,0-2.584,2.363l-.068-2.822h-2.176V33h2.278V23.854a6.122,6.122,0,0,1,.408-2.261,5.84,5.84,0,0,1,1.122-1.819,5.212,5.212,0,0,1,1.734-1.241,5.405,5.405,0,0,1,2.244-.459,5.575,5.575,0,0,1,4.012,1.394,5.424,5.424,0,0,1,1.462,4.114Zm21.522-13.464a6.015,6.015,0,0,0-1.207-1.564,7.018,7.018,0,0,0-1.6-1.122,7.834,7.834,0,0,0-1.853-.663,8.843,8.843,0,0,0-1.938-.221,9.155,9.155,0,0,0-3.366.612,8.092,8.092,0,0,0-2.72,1.734,8.228,8.228,0,0,0-1.836,2.72,9.032,9.032,0,0,0-.68,3.57,9.456,9.456,0,0,0,.663,3.621,8.042,8.042,0,0,0,1.836,2.754,8.186,8.186,0,0,0,2.72,1.751,9.022,9.022,0,0,0,3.349.612,8.4,8.4,0,0,0,1.9-.221,7.494,7.494,0,0,0,1.819-.68,7.93,7.93,0,0,0,1.632-1.156,6.989,6.989,0,0,0,1.309-1.615V33h2.108V16.2h-2.142Zm-6.528-1.5a6.363,6.363,0,0,1,3.621.969,6.156,6.156,0,0,1,2.159,2.431,7.434,7.434,0,0,1,0,6.358,6.156,6.156,0,0,1-2.159,2.431,6.363,6.363,0,0,1-3.621.969,6.582,6.582,0,0,1-2.5-.476,6.089,6.089,0,0,1-2.04-1.343,6.222,6.222,0,0,1-1.36-2.074,7.61,7.61,0,0,1,0-5.389,6,6,0,0,1,1.36-2.074,6.222,6.222,0,0,1,2.04-1.326A6.582,6.582,0,0,1,472.187,18.04Zm-3.876-6.358,1.53.612q.272-.85.782-1a1.936,1.936,0,0,1,1.1.017,6.535,6.535,0,0,1,1.241.51,6.724,6.724,0,0,0,1.224.51,2.761,2.761,0,0,0,2.023-.306,2.73,2.73,0,0,0,1.241-2.04l-1.53-.612q-.272.884-.782,1.02a1.932,1.932,0,0,1-1.122-.068,7.805,7.805,0,0,1-1.241-.544,4.169,4.169,0,0,0-1.139-.442,2.708,2.708,0,0,0-2.125.391A2.946,2.946,0,0,0,468.311,11.682Zm25.4,4.284a9.348,9.348,0,0,0-3.485.629,7.832,7.832,0,0,0-2.72,1.785,8.273,8.273,0,0,0-1.785,2.771,9.484,9.484,0,0,0-.646,3.553,9.142,9.142,0,0,0,.663,3.536,8.206,8.206,0,0,0,1.819,2.737,7.927,7.927,0,0,0,2.737,1.751,9.384,9.384,0,0,0,3.417.612,9.481,9.481,0,0,0,3.451-.612A7.837,7.837,0,0,0,501.7,28.24a9.925,9.925,0,0,0-.017-7.089,8.355,8.355,0,0,0-1.819-2.771,8.009,8.009,0,0,0-2.737-1.785A9.159,9.159,0,0,0,493.709,15.966Zm0,2.074a6.559,6.559,0,0,1,2.567.493,5.814,5.814,0,0,1,2.006,1.377,6.436,6.436,0,0,1,1.309,2.108,7.351,7.351,0,0,1,.476,2.686,7.454,7.454,0,0,1-.459,2.669A5.763,5.763,0,0,1,498.3,29.43a5.861,5.861,0,0,1-2.006,1.309,7.455,7.455,0,0,1-5.151,0,5.652,5.652,0,0,1-2.006-1.309,6.09,6.09,0,0,1-1.309-2.057,7.216,7.216,0,0,1-.476-2.669,7.593,7.593,0,0,1,.459-2.686,6.081,6.081,0,0,1,1.309-2.108,5.993,5.993,0,0,1,2.023-1.377A6.559,6.559,0,0,1,493.709,18.04Zm37.6,7.548a10.81,10.81,0,0,0-.34-4.3,7.492,7.492,0,0,0-1.734-3.009,7.157,7.157,0,0,0-2.788-1.768,9.869,9.869,0,0,0-3.5-.544,8.615,8.615,0,0,0-3.451.612,8.035,8.035,0,0,0-2.72,1.8,8.313,8.313,0,0,0-1.785,2.754,9.167,9.167,0,0,0-.646,3.468,9.455,9.455,0,0,0,.663,3.621,8.166,8.166,0,0,0,1.819,2.754,7.893,7.893,0,0,0,2.754,1.751,9.617,9.617,0,0,0,3.468.612,10.714,10.714,0,0,0,3.978-.782,7.7,7.7,0,0,0,3.23-2.346l-1.53-1.36a4.284,4.284,0,0,1-1.1,1,7.642,7.642,0,0,1-1.428.714,9.33,9.33,0,0,1-1.581.442,8.489,8.489,0,0,1-1.564.153,7.322,7.322,0,0,1-2.363-.374,6,6,0,0,1-1.955-1.088,5.739,5.739,0,0,1-1.394-1.751,6.028,6.028,0,0,1-.646-2.363Zm-14.62-1.938a5.972,5.972,0,0,1,6.29-5.678,7.478,7.478,0,0,1,2.38.374,5.771,5.771,0,0,1,1.955,1.088,5.148,5.148,0,0,1,1.326,1.785,6.129,6.129,0,0,1,.527,2.431ZM545.151,16.2,540.6,22.8l-4.59-6.6h-2.72v.1l5.882,8.058-6.324,8.568V33h2.72l5.032-7.038L545.627,33h2.72v-.068l-6.324-8.568,5.882-8.058v-.1ZM560.315,31.13a6.346,6.346,0,0,1-2.516-.493,5.972,5.972,0,0,1-1.989-1.36A6.32,6.32,0,0,1,554.5,27.22a6.894,6.894,0,0,1-.476-2.584,7.119,7.119,0,0,1,.459-2.584,6.1,6.1,0,0,1,1.292-2.057,5.972,5.972,0,0,1,1.989-1.36,6.435,6.435,0,0,1,2.55-.493,7.238,7.238,0,0,1,2.516.425,5.7,5.7,0,0,1,2.006,1.241,5.612,5.612,0,0,1,1.326,2.023,7.512,7.512,0,0,1,.476,2.771,7.38,7.38,0,0,1-.493,2.8,5.98,5.98,0,0,1-1.343,2.04A5.579,5.579,0,0,1,562.8,30.7,7.137,7.137,0,0,1,560.315,31.13Zm-8.738,9.894h2.244V29.6a6.5,6.5,0,0,0,2.839,2.822,8.243,8.243,0,0,0,3.757.918,9.485,9.485,0,0,0,3.4-.6,7.533,7.533,0,0,0,2.686-1.717,8,8,0,0,0,1.768-2.754,9.906,9.906,0,0,0,.646-3.672,9.54,9.54,0,0,0-.629-3.553,8.03,8.03,0,0,0-1.734-2.7,7.661,7.661,0,0,0-2.618-1.734,9.144,9.144,0,0,0-3.281-.646,7.751,7.751,0,0,0-4.012.986,7.1,7.1,0,0,0-2.788,2.822l-.068-3.57h-2.21Zm23.868-24.888h-2.278V33h2.278Zm-2.72-5.2a1.424,1.424,0,0,0,.51,1.207,1.757,1.757,0,0,0,1.088.391,1.8,1.8,0,0,0,1.122-.391,1.424,1.424,0,0,0,.51-1.207,1.434,1.434,0,0,0-.51-1.19,1.755,1.755,0,0,0-1.122-.408,1.712,1.712,0,0,0-1.088.408A1.434,1.434,0,0,0,572.725,10.934Zm10.166,5.27h-2.142V33h2.278V23.446a5.421,5.421,0,0,1,.408-2.125,5.161,5.161,0,0,1,4.794-3.179,5,5,0,0,1,2.89.884l1.054-1.9a6.533,6.533,0,0,0-1.785-.918,6.776,6.776,0,0,0-2.023-.272,7.959,7.959,0,0,0-1.53.153,5.836,5.836,0,0,0-1.5.51,5.227,5.227,0,0,0-1.309.935,4.956,4.956,0,0,0-1,1.428Zm26.18,3.332a6.015,6.015,0,0,0-1.207-1.564,7.018,7.018,0,0,0-1.6-1.122,7.832,7.832,0,0,0-1.853-.663,8.843,8.843,0,0,0-1.938-.221,9.155,9.155,0,0,0-3.366.612,8.092,8.092,0,0,0-2.72,1.734,8.227,8.227,0,0,0-1.836,2.72,9.03,9.03,0,0,0-.68,3.57,9.455,9.455,0,0,0,.663,3.621,8.042,8.042,0,0,0,1.836,2.754,8.185,8.185,0,0,0,2.72,1.751,9.022,9.022,0,0,0,3.349.612,8.4,8.4,0,0,0,1.9-.221,7.494,7.494,0,0,0,1.819-.68,7.93,7.93,0,0,0,1.632-1.156,6.99,6.99,0,0,0,1.309-1.615V33h2.108V16.2h-2.142Zm-6.528-1.5a6.363,6.363,0,0,1,3.621.969,6.155,6.155,0,0,1,2.159,2.431,7.434,7.434,0,0,1,0,6.358,6.155,6.155,0,0,1-2.159,2.431,6.363,6.363,0,0,1-3.621.969,6.582,6.582,0,0,1-2.5-.476A6.089,6.089,0,0,1,598,29.379a6.222,6.222,0,0,1-1.36-2.074,7.609,7.609,0,0,1,0-5.389A6,6,0,0,1,598,19.842a6.222,6.222,0,0,1,2.04-1.326A6.582,6.582,0,0,1,602.543,18.04Zm16.9,13.77a1.377,1.377,0,0,0-.51-1.19,1.831,1.831,0,0,0-1.1-.374,1.779,1.779,0,0,0-1.1.391,1.348,1.348,0,0,0-.51,1.139,1.3,1.3,0,0,0,.289.9,1.583,1.583,0,0,0,.731.459l-.952,2.958h1.7q.544-1.564,1-2.6A4.429,4.429,0,0,0,619.441,31.81Zm-517.888,32.9,1.326-1.5a8.135,8.135,0,0,0-2.856-1.734,10.5,10.5,0,0,0-3.468-.544,11.254,11.254,0,0,0-2.448.272,6.89,6.89,0,0,0-2.176.867,4.932,4.932,0,0,0-1.547,1.513,3.85,3.85,0,0,0-.6,2.142,3.568,3.568,0,0,0,.6,2.125,4.5,4.5,0,0,0,1.53,1.343,8.293,8.293,0,0,0,2.108.782q1.173.272,2.4.442,1.02.136,1.9.306a6.2,6.2,0,0,1,1.547.493,2.676,2.676,0,0,1,1.037.85,2.266,2.266,0,0,1,.374,1.343,2.14,2.14,0,0,1-.442,1.394,3.141,3.141,0,0,1-1.139.867,5.446,5.446,0,0,1-1.5.442,10.29,10.29,0,0,1-1.513.119,10.137,10.137,0,0,1-3.3-.646,5.916,5.916,0,0,1-2.754-2.074l-1.428,1.564a7.277,7.277,0,0,0,3.281,2.5,11.5,11.5,0,0,0,4.165.765,11.639,11.639,0,0,0,2.5-.272,7.356,7.356,0,0,0,2.21-.85,4.647,4.647,0,0,0,1.564-1.513,4.339,4.339,0,0,0,.629-2.261A4.1,4.1,0,0,0,102.9,71a4.561,4.561,0,0,0-1.683-1.428,8.709,8.709,0,0,0-2.244-.748q-1.224-.238-2.346-.408-.782-.1-1.6-.272a6.86,6.86,0,0,1-1.479-.476,3.272,3.272,0,0,1-1.088-.782,1.769,1.769,0,0,1-.425-1.224,1.743,1.743,0,0,1,.34-1.156,2.968,2.968,0,0,1,1-.85,4.932,4.932,0,0,1,1.462-.493,9.681,9.681,0,0,1,1.751-.153,10.414,10.414,0,0,1,2.567.306A5.676,5.676,0,0,1,101.553,64.706Zm21.9,5.882a10.809,10.809,0,0,0-.34-4.3,7.493,7.493,0,0,0-1.734-3.009,7.157,7.157,0,0,0-2.788-1.768,9.869,9.869,0,0,0-3.5-.544,8.616,8.616,0,0,0-3.451.612,8.035,8.035,0,0,0-2.72,1.8,8.313,8.313,0,0,0-1.785,2.754,9.167,9.167,0,0,0-.646,3.468,9.455,9.455,0,0,0,.663,3.621,8.166,8.166,0,0,0,1.819,2.754,7.893,7.893,0,0,0,2.754,1.751,9.616,9.616,0,0,0,3.468.612,10.714,10.714,0,0,0,3.978-.782,7.7,7.7,0,0,0,3.23-2.346l-1.53-1.36a4.284,4.284,0,0,1-1.1,1,7.64,7.64,0,0,1-1.428.714,9.33,9.33,0,0,1-1.581.442,8.49,8.49,0,0,1-1.564.153,7.323,7.323,0,0,1-2.363-.374,6,6,0,0,1-1.955-1.088,5.739,5.739,0,0,1-1.394-1.751,6.027,6.027,0,0,1-.646-2.363Zm-14.62-1.938a5.971,5.971,0,0,1,6.29-5.678,7.477,7.477,0,0,1,2.38.374,5.772,5.772,0,0,1,1.955,1.088,5.148,5.148,0,0,1,1.326,1.785,6.128,6.128,0,0,1,.527,2.431Zm30.8,9.35h2.278V68.276a5.861,5.861,0,0,1,.357-2.074,4.815,4.815,0,0,1,1.02-1.649,4.957,4.957,0,0,1,1.564-1.105,4.85,4.85,0,0,1,2.023-.408,4.911,4.911,0,0,1,2.006.391,4.534,4.534,0,0,1,1.513,1.071,4.7,4.7,0,0,1,.969,1.632,6.125,6.125,0,0,1,.34,2.074V78h2.278V68.208a8.422,8.422,0,0,0-.51-3.009,6.673,6.673,0,0,0-1.428-2.295,5.968,5.968,0,0,0-2.227-1.445,8.192,8.192,0,0,0-2.907-.493,7.325,7.325,0,0,0-3.536.9,5.674,5.674,0,0,0-2.516,2.907,5.76,5.76,0,0,0-1-1.8,5.33,5.33,0,0,0-1.428-1.207,5.409,5.409,0,0,0-1.683-.629,9.52,9.52,0,0,0-1.8-.17,7.264,7.264,0,0,0-2.958.629,4.6,4.6,0,0,0-2.244,2.227l-.1-2.686H127.5V78h2.278V68.276a5.861,5.861,0,0,1,.357-2.074,4.955,4.955,0,0,1,1-1.649,4.761,4.761,0,0,1,1.547-1.105,5.219,5.219,0,0,1,4.046,0,4.762,4.762,0,0,1,1.547,1.105,4.955,4.955,0,0,1,1,1.649,5.861,5.861,0,0,1,.357,2.074Zm29.512,0h2.278V63.346H176.8V61.374h-5.372V59.98A4.4,4.4,0,0,1,172.256,57a2.916,2.916,0,0,1,2.295-.935,3.7,3.7,0,0,1,1.326.221,8.115,8.115,0,0,1,1.258.629l.986-1.7a6.075,6.075,0,0,0-1.7-.884,5.981,5.981,0,0,0-1.9-.306,4.956,4.956,0,0,0-4.046,1.6,6.609,6.609,0,0,0-1.326,4.352v1.394h-3.332v1.972h3.332Zm13.09-16.864h-2.278V78h2.278Zm-2.72-5.2a1.424,1.424,0,0,0,.51,1.207,1.757,1.757,0,0,0,1.088.391,1.8,1.8,0,0,0,1.122-.391,1.663,1.663,0,0,0,0-2.4,1.755,1.755,0,0,0-1.122-.408,1.712,1.712,0,0,0-1.088.408A1.434,1.434,0,0,0,179.515,55.934Zm15.572,7.174a6.582,6.582,0,0,1,2.5.476,6.032,6.032,0,0,1,2.023,1.326,6.167,6.167,0,0,1,1.343,2.057,6.9,6.9,0,0,1,.493,2.635,7,7,0,0,1-.493,2.669,6.36,6.36,0,0,1-1.343,2.074,5.947,5.947,0,0,1-2.006,1.343,6.544,6.544,0,0,1-2.516.476,7,7,0,0,1-2.465-.425,5.78,5.78,0,0,1-2.006-1.258,5.857,5.857,0,0,1-1.36-2.04,7.38,7.38,0,0,1-.493-2.805,7.511,7.511,0,0,1,.493-2.822,5.655,5.655,0,0,1,1.36-2.04,5.909,5.909,0,0,1,2.006-1.241A7,7,0,0,1,195.087,63.108Zm8.738-8.874h-2.278V64.57a5.97,5.97,0,0,0-2.788-2.754,8.339,8.339,0,0,0-3.808-.85,8.868,8.868,0,0,0-3.332.544,7.867,7.867,0,0,0-2.686,1.683,7.615,7.615,0,0,0-1.8,2.72,11.051,11.051,0,0,0,0,7.446,7.615,7.615,0,0,0,1.8,2.72,7.867,7.867,0,0,0,2.686,1.683,9.354,9.354,0,0,0,3.332.578,8.175,8.175,0,0,0,3.791-.918,6.635,6.635,0,0,0,2.805-2.754L201.615,78h2.21Zm21.182,16.354a10.809,10.809,0,0,0-.34-4.3,7.493,7.493,0,0,0-1.734-3.009,7.157,7.157,0,0,0-2.788-1.768,9.869,9.869,0,0,0-3.5-.544,8.616,8.616,0,0,0-3.451.612,8.035,8.035,0,0,0-2.72,1.8,8.313,8.313,0,0,0-1.785,2.754,9.166,9.166,0,0,0-.646,3.468,9.455,9.455,0,0,0,.663,3.621,8.166,8.166,0,0,0,1.819,2.754,7.893,7.893,0,0,0,2.754,1.751,9.616,9.616,0,0,0,3.468.612,10.714,10.714,0,0,0,3.978-.782,7.7,7.7,0,0,0,3.23-2.346l-1.53-1.36a4.284,4.284,0,0,1-1.1,1,7.64,7.64,0,0,1-1.428.714,9.33,9.33,0,0,1-1.581.442,8.49,8.49,0,0,1-1.564.153,7.323,7.323,0,0,1-2.363-.374,6,6,0,0,1-1.955-1.088,5.739,5.739,0,0,1-1.394-1.751,6.027,6.027,0,0,1-.646-2.363Zm-14.62-1.938a5.971,5.971,0,0,1,6.29-5.678,7.477,7.477,0,0,1,2.38.374,5.772,5.772,0,0,1,1.955,1.088,5.148,5.148,0,0,1,1.326,1.785,6.128,6.128,0,0,1,.527,2.431ZM231.569,54.2h-2.278V78h2.278Zm7.82,6.936h-2.278V78h2.278Zm-2.72-5.2a1.424,1.424,0,0,0,.51,1.207,1.757,1.757,0,0,0,1.088.391,1.8,1.8,0,0,0,1.122-.391,1.663,1.663,0,0,0,0-2.4,1.755,1.755,0,0,0-1.122-.408,1.712,1.712,0,0,0-1.088.408A1.434,1.434,0,0,0,236.669,55.934Zm19.822,5.27H243.673v2.074h9.452L243.1,77.15V78h13.43V75.824h-9.962l9.928-13.634Zm18.156,3.332a6.015,6.015,0,0,0-1.207-1.564,7.018,7.018,0,0,0-1.6-1.122,7.834,7.834,0,0,0-1.853-.663,8.843,8.843,0,0,0-1.938-.221,9.155,9.155,0,0,0-3.366.612,8.092,8.092,0,0,0-2.72,1.734,8.228,8.228,0,0,0-1.836,2.72,9.032,9.032,0,0,0-.68,3.57,9.456,9.456,0,0,0,.663,3.621,8.042,8.042,0,0,0,1.836,2.754,8.186,8.186,0,0,0,2.72,1.751,9.022,9.022,0,0,0,3.349.612,8.4,8.4,0,0,0,1.9-.221,7.494,7.494,0,0,0,1.819-.68,7.93,7.93,0,0,0,1.632-1.156,6.989,6.989,0,0,0,1.309-1.615V78h2.108V61.2h-2.142Zm-6.528-1.5a6.363,6.363,0,0,1,3.621.969A6.155,6.155,0,0,1,273.9,66.44a7.434,7.434,0,0,1,0,6.358,6.155,6.155,0,0,1-2.159,2.431,6.363,6.363,0,0,1-3.621.969,6.582,6.582,0,0,1-2.5-.476,6.089,6.089,0,0,1-2.04-1.343,6.222,6.222,0,0,1-1.36-2.074,7.61,7.61,0,0,1,0-5.389,6,6,0,0,1,1.36-2.074,6.222,6.222,0,0,1,2.04-1.326A6.582,6.582,0,0,1,268.119,63.04Zm21.76,14.926h-1.768l-.748,2.958.408.306a3.826,3.826,0,0,1,1.462-.17,2.439,2.439,0,0,1,1.071.34,1.372,1.372,0,0,1,.578.7,1.483,1.483,0,0,1-.85,1.853,2.958,2.958,0,0,1-1.411.2,3.178,3.178,0,0,1-1.241-.306,2.881,2.881,0,0,1-1.037-.918l-1.156,1.054a3.636,3.636,0,0,0,1.581,1.428,4.821,4.821,0,0,0,2.091.476,4.628,4.628,0,0,0,2.38-.578,2.939,2.939,0,0,0,1.462-1.972,3.594,3.594,0,0,0,.051-1.258,2.376,2.376,0,0,0-.476-1.156,2.842,2.842,0,0,0-1.088-.833,3.863,3.863,0,0,0-1.751-.289Zm6.052-2.176-1.564-1.53a6.3,6.3,0,0,1-2.159,1.428,6.753,6.753,0,0,1-2.5.476,7.137,7.137,0,0,1-2.482-.425,6.056,6.056,0,0,1-2.04-1.241,5.727,5.727,0,0,1-1.394-2.04,7.289,7.289,0,0,1-.51-2.822,7.067,7.067,0,0,1,.51-2.771,6.056,6.056,0,0,1,1.377-2.04,5.889,5.889,0,0,1,2.057-1.275,7.167,7.167,0,0,1,2.516-.442,6.214,6.214,0,0,1,4.42,1.8l1.5-1.462a8.322,8.322,0,0,0-2.771-1.887,8.437,8.437,0,0,0-3.179-.6,9.877,9.877,0,0,0-3.417.578,7.817,7.817,0,0,0-2.754,1.7,8.1,8.1,0,0,0-1.853,2.72,10.136,10.136,0,0,0,.017,7.344,8.225,8.225,0,0,0,1.87,2.754,7.817,7.817,0,0,0,2.754,1.7,9.776,9.776,0,0,0,3.383.578,8.707,8.707,0,0,0,6.222-2.55Zm17.918-11.254a6.015,6.015,0,0,0-1.207-1.564,7.018,7.018,0,0,0-1.6-1.122,7.834,7.834,0,0,0-1.853-.663,8.843,8.843,0,0,0-1.938-.221,9.155,9.155,0,0,0-3.366.612,8.092,8.092,0,0,0-2.72,1.734,8.228,8.228,0,0,0-1.836,2.72,9.032,9.032,0,0,0-.68,3.57,9.456,9.456,0,0,0,.663,3.621,8.042,8.042,0,0,0,1.836,2.754,8.186,8.186,0,0,0,2.72,1.751,9.022,9.022,0,0,0,3.349.612,8.4,8.4,0,0,0,1.9-.221,7.494,7.494,0,0,0,1.819-.68,7.93,7.93,0,0,0,1.632-1.156,6.99,6.99,0,0,0,1.309-1.615V78h2.108V61.2h-2.142Zm-6.528-1.5a6.363,6.363,0,0,1,3.621.969A6.155,6.155,0,0,1,313.1,66.44a7.434,7.434,0,0,1,0,6.358,6.155,6.155,0,0,1-2.159,2.431,6.363,6.363,0,0,1-3.621.969,6.582,6.582,0,0,1-2.5-.476,6.089,6.089,0,0,1-2.04-1.343,6.222,6.222,0,0,1-1.36-2.074,7.61,7.61,0,0,1,0-5.389,6,6,0,0,1,1.36-2.074,6.222,6.222,0,0,1,2.04-1.326A6.582,6.582,0,0,1,307.321,63.04Zm-3.876-6.358,1.53.612q.272-.85.782-1a1.936,1.936,0,0,1,1.1.017,6.535,6.535,0,0,1,1.241.51,6.724,6.724,0,0,0,1.224.51,2.761,2.761,0,0,0,2.023-.306,2.73,2.73,0,0,0,1.241-2.04l-1.53-.612q-.272.884-.782,1.02a1.932,1.932,0,0,1-1.122-.068,7.8,7.8,0,0,1-1.241-.544,4.169,4.169,0,0,0-1.139-.442,2.708,2.708,0,0,0-2.125.391A2.946,2.946,0,0,0,303.445,56.682Zm25.4,4.284a9.348,9.348,0,0,0-3.485.629,7.832,7.832,0,0,0-2.72,1.785,8.273,8.273,0,0,0-1.785,2.771,9.484,9.484,0,0,0-.646,3.553,9.142,9.142,0,0,0,.663,3.536,8.206,8.206,0,0,0,1.819,2.737,7.927,7.927,0,0,0,2.737,1.751,9.384,9.384,0,0,0,3.417.612,9.481,9.481,0,0,0,3.451-.612,7.837,7.837,0,0,0,4.539-4.488,9.925,9.925,0,0,0-.017-7.089A8.355,8.355,0,0,0,335,63.38,8.009,8.009,0,0,0,332.26,61.6,9.159,9.159,0,0,0,328.843,60.966Zm0,2.074a6.559,6.559,0,0,1,2.567.493,5.814,5.814,0,0,1,2.006,1.377,6.436,6.436,0,0,1,1.309,2.108A7.351,7.351,0,0,1,335.2,69.7a7.454,7.454,0,0,1-.459,2.669,5.763,5.763,0,0,1-1.309,2.057,5.861,5.861,0,0,1-2.006,1.309,7.455,7.455,0,0,1-5.151,0,5.652,5.652,0,0,1-2.006-1.309,6.09,6.09,0,0,1-1.309-2.057,7.216,7.216,0,0,1-.476-2.669,7.593,7.593,0,0,1,.459-2.686,6.081,6.081,0,0,1,1.309-2.108,5.992,5.992,0,0,1,2.023-1.377A6.559,6.559,0,0,1,328.843,63.04Zm37.6,7.548a10.809,10.809,0,0,0-.34-4.3,7.493,7.493,0,0,0-1.734-3.009,7.156,7.156,0,0,0-2.788-1.768,9.869,9.869,0,0,0-3.5-.544,8.616,8.616,0,0,0-3.451.612,8.036,8.036,0,0,0-2.72,1.8,8.313,8.313,0,0,0-1.785,2.754,9.167,9.167,0,0,0-.646,3.468,9.456,9.456,0,0,0,.663,3.621,8.166,8.166,0,0,0,1.819,2.754,7.894,7.894,0,0,0,2.754,1.751,9.617,9.617,0,0,0,3.468.612,10.714,10.714,0,0,0,3.978-.782,7.7,7.7,0,0,0,3.23-2.346l-1.53-1.36a4.285,4.285,0,0,1-1.105,1,7.64,7.64,0,0,1-1.428.714,9.329,9.329,0,0,1-1.581.442,8.49,8.49,0,0,1-1.564.153,7.323,7.323,0,0,1-2.363-.374,6,6,0,0,1-1.955-1.088,5.739,5.739,0,0,1-1.394-1.751,6.027,6.027,0,0,1-.646-2.363Zm-14.62-1.938a5.971,5.971,0,0,1,6.29-5.678,7.477,7.477,0,0,1,2.38.374,5.772,5.772,0,0,1,1.955,1.088,5.148,5.148,0,0,1,1.326,1.785,6.128,6.128,0,0,1,.527,2.431ZM380.557,78h2.278V63.346h5.372V61.374h-5.372V59.98A4.4,4.4,0,0,1,383.668,57a2.916,2.916,0,0,1,2.3-.935,3.7,3.7,0,0,1,1.326.221,8.115,8.115,0,0,1,1.258.629l.986-1.7a6.075,6.075,0,0,0-1.7-.884,5.981,5.981,0,0,0-1.9-.306,4.956,4.956,0,0,0-4.046,1.6,6.609,6.609,0,0,0-1.326,4.352v1.394h-3.332v1.972h3.332Zm12.954-16.8h-2.142V78h2.278V68.446a5.421,5.421,0,0,1,.408-2.125,5.161,5.161,0,0,1,4.794-3.179,5,5,0,0,1,2.89.884l1.054-1.9a6.534,6.534,0,0,0-1.785-.918,6.775,6.775,0,0,0-2.023-.272,7.958,7.958,0,0,0-1.53.153,5.836,5.836,0,0,0-1.5.51,5.227,5.227,0,0,0-1.309.935,4.955,4.955,0,0,0-1,1.428Zm27.948,9.384a10.809,10.809,0,0,0-.34-4.3,7.493,7.493,0,0,0-1.734-3.009A7.156,7.156,0,0,0,416.6,61.51a9.869,9.869,0,0,0-3.5-.544,8.616,8.616,0,0,0-3.451.612,8.036,8.036,0,0,0-2.72,1.8,8.313,8.313,0,0,0-1.785,2.754,9.167,9.167,0,0,0-.646,3.468,9.456,9.456,0,0,0,.663,3.621,8.166,8.166,0,0,0,1.819,2.754,7.894,7.894,0,0,0,2.754,1.751,9.617,9.617,0,0,0,3.468.612,10.714,10.714,0,0,0,3.978-.782,7.7,7.7,0,0,0,3.23-2.346l-1.53-1.36a4.285,4.285,0,0,1-1.105,1,7.64,7.64,0,0,1-1.428.714,9.329,9.329,0,0,1-1.581.442,8.49,8.49,0,0,1-1.564.153,7.323,7.323,0,0,1-2.363-.374,6,6,0,0,1-1.955-1.088,5.739,5.739,0,0,1-1.394-1.751,6.027,6.027,0,0,1-.646-2.363Zm-14.62-1.938a5.971,5.971,0,0,1,6.29-5.678,7.477,7.477,0,0,1,2.38.374,5.772,5.772,0,0,1,1.955,1.088,5.148,5.148,0,0,1,1.326,1.785,6.128,6.128,0,0,1,.527,2.431Zm22.712-12.41-2.278.238V61.34h-3.434v1.938h3.434v9.384a6.506,6.506,0,0,0,1.173,4.114,4.576,4.576,0,0,0,3.893,1.462,6.032,6.032,0,0,0,1.615-.221,10.769,10.769,0,0,0,1.615-.6l-.714-1.9a10.233,10.233,0,0,1-1.241.459,4.232,4.232,0,0,1-1.207.187,2.452,2.452,0,0,1-2.278-.952,4.883,4.883,0,0,1-.578-2.55V63.278h5.44V61.34h-5.44Zm24.956,14.348a10.809,10.809,0,0,0-.34-4.3,7.493,7.493,0,0,0-1.734-3.009,7.156,7.156,0,0,0-2.788-1.768,9.869,9.869,0,0,0-3.5-.544,8.616,8.616,0,0,0-3.451.612,8.036,8.036,0,0,0-2.72,1.8,8.313,8.313,0,0,0-1.785,2.754,9.167,9.167,0,0,0-.646,3.468,9.456,9.456,0,0,0,.663,3.621,8.166,8.166,0,0,0,1.819,2.754,7.894,7.894,0,0,0,2.754,1.751,9.617,9.617,0,0,0,3.468.612,10.714,10.714,0,0,0,3.978-.782,7.7,7.7,0,0,0,3.23-2.346l-1.53-1.36a4.285,4.285,0,0,1-1.105,1,7.64,7.64,0,0,1-1.428.714,9.329,9.329,0,0,1-1.581.442,8.49,8.49,0,0,1-1.564.153,7.323,7.323,0,0,1-2.363-.374,6,6,0,0,1-1.955-1.088,5.739,5.739,0,0,1-1.394-1.751,6.027,6.027,0,0,1-.646-2.363Zm-14.62-1.938a5.971,5.971,0,0,1,6.29-5.678,7.477,7.477,0,0,1,2.38.374,5.772,5.772,0,0,1,1.955,1.088,5.148,5.148,0,0,1,1.326,1.785,6.128,6.128,0,0,1,.527,2.431Zm42.024-8.466-1.768,2.108a5.512,5.512,0,0,0-1.088-.6,9.345,9.345,0,0,0-1.275-.425,9.052,9.052,0,0,0-1.326-.238,12.5,12.5,0,0,0-1.275-.068,10.142,10.142,0,0,0-3.162.51,8.576,8.576,0,0,0-2.822,1.547,7.942,7.942,0,0,0-2.04,2.584,7.849,7.849,0,0,0-.782,3.587,8.935,8.935,0,0,0,.646,3.5,7.17,7.17,0,0,0,1.819,2.584,8.086,8.086,0,0,0,2.788,1.615,10.766,10.766,0,0,0,3.553.561,10.474,10.474,0,0,1,2.3.255,7.074,7.074,0,0,1,2.04.782,4.407,4.407,0,0,1,1.445,1.326,3.331,3.331,0,0,1,.544,1.921,3.258,3.258,0,0,1-.561,1.921,4.292,4.292,0,0,1-1.445,1.292,7.116,7.116,0,0,1-2.023.731,11.191,11.191,0,0,1-2.3.238,9.433,9.433,0,0,1-2.329-.289,6.209,6.209,0,0,1-2.006-.884,4.513,4.513,0,0,1-1.377-1.479,4.078,4.078,0,0,1-.51-2.074h-2.278a6.307,6.307,0,0,0,2.431,5.117,7.881,7.881,0,0,0,2.7,1.36,11.9,11.9,0,0,0,3.366.459,12.743,12.743,0,0,0,3.23-.408,8.95,8.95,0,0,0,2.754-1.207,6.428,6.428,0,0,0,1.921-1.989,5.219,5.219,0,0,0,.731-2.788,4.892,4.892,0,0,0-1.292-3.485,7.65,7.65,0,0,0-3.672-2.023,6.7,6.7,0,0,0,2.244-1.105,6.943,6.943,0,0,0,1.581-1.683,7.232,7.232,0,0,0,.935-2.04,8.125,8.125,0,0,0,.306-2.21,7.146,7.146,0,0,0-.646-3.264,10.783,10.783,0,0,0-1.6-2.312l1.8-2.142Zm-6.732,2.89a7.845,7.845,0,0,1,2.4.374,6.122,6.122,0,0,1,2.074,1.122,5.444,5.444,0,0,1,1.445,1.9,6.331,6.331,0,0,1,.544,2.72,6.224,6.224,0,0,1-.459,2.38,5.759,5.759,0,0,1-1.309,1.955,6.349,6.349,0,0,1-2.04,1.326,6.867,6.867,0,0,1-2.652.493,8.459,8.459,0,0,1-2.55-.374,5.605,5.605,0,0,1-2.057-1.139,5.455,5.455,0,0,1-1.377-1.921,6.694,6.694,0,0,1-.51-2.72,6.013,6.013,0,0,1,.578-2.72,5.786,5.786,0,0,1,1.513-1.921,6.126,6.126,0,0,1,2.091-1.122A7.8,7.8,0,0,1,475.179,63.074Zm15.164-1.87H488.2V78h2.278V68.446a5.421,5.421,0,0,1,.408-2.125,5.161,5.161,0,0,1,4.794-3.179,5,5,0,0,1,2.89.884l1.054-1.9a6.534,6.534,0,0,0-1.785-.918,6.775,6.775,0,0,0-2.023-.272,7.958,7.958,0,0,0-1.53.153,5.836,5.836,0,0,0-1.5.51,5.227,5.227,0,0,0-1.309.935,4.955,4.955,0,0,0-1,1.428Zm26.18,3.332a6.015,6.015,0,0,0-1.207-1.564,7.019,7.019,0,0,0-1.6-1.122,7.834,7.834,0,0,0-1.853-.663,8.843,8.843,0,0,0-1.938-.221,9.155,9.155,0,0,0-3.366.612,8.092,8.092,0,0,0-2.72,1.734,8.228,8.228,0,0,0-1.836,2.72,9.032,9.032,0,0,0-.68,3.57,9.456,9.456,0,0,0,.663,3.621,8.042,8.042,0,0,0,1.836,2.754,8.186,8.186,0,0,0,2.72,1.751,9.022,9.022,0,0,0,3.349.612,8.4,8.4,0,0,0,1.9-.221,7.494,7.494,0,0,0,1.819-.68,7.93,7.93,0,0,0,1.632-1.156,6.991,6.991,0,0,0,1.309-1.615V78h2.108V61.2h-2.142ZM510,63.04a6.363,6.363,0,0,1,3.621.969,6.155,6.155,0,0,1,2.159,2.431,7.434,7.434,0,0,1,0,6.358,6.155,6.155,0,0,1-2.159,2.431A6.363,6.363,0,0,1,510,76.2a6.582,6.582,0,0,1-2.5-.476,6.089,6.089,0,0,1-2.04-1.343,6.222,6.222,0,0,1-1.36-2.074,7.61,7.61,0,0,1,0-5.389,6,6,0,0,1,1.36-2.074,6.222,6.222,0,0,1,2.04-1.326A6.582,6.582,0,0,1,510,63.04Zm4.216-8.942V54.03h-2.72l-2.55,4.216v.136h2.074Zm14.008,2.142-2.278.238V61.34h-3.434v1.938h3.434v9.384a6.506,6.506,0,0,0,1.173,4.114,4.576,4.576,0,0,0,3.893,1.462,6.032,6.032,0,0,0,1.615-.221,10.77,10.77,0,0,0,1.615-.6l-.714-1.9a10.236,10.236,0,0,1-1.241.459,4.232,4.232,0,0,1-1.207.187,2.452,2.452,0,0,1-2.278-.952,4.884,4.884,0,0,1-.578-2.55V63.278h5.44V61.34h-5.44Zm11.356,4.9H537.3V78h2.278Zm-2.72-5.2a1.424,1.424,0,0,0,.51,1.207,1.757,1.757,0,0,0,1.088.391,1.8,1.8,0,0,0,1.122-.391,1.663,1.663,0,0,0,0-2.4,1.755,1.755,0,0,0-1.122-.408,1.712,1.712,0,0,0-1.088.408A1.434,1.434,0,0,0,536.855,55.934Zm18.972,8.772,1.326-1.5a8.136,8.136,0,0,0-2.856-1.734,10.5,10.5,0,0,0-3.468-.544,11.254,11.254,0,0,0-2.448.272,6.89,6.89,0,0,0-2.176.867,4.931,4.931,0,0,0-1.547,1.513,3.85,3.85,0,0,0-.6,2.142,3.568,3.568,0,0,0,.6,2.125,4.494,4.494,0,0,0,1.53,1.343,8.293,8.293,0,0,0,2.108.782q1.173.272,2.4.442,1.02.136,1.9.306a6.2,6.2,0,0,1,1.547.493,2.676,2.676,0,0,1,1.037.85,2.266,2.266,0,0,1,.374,1.343,2.14,2.14,0,0,1-.442,1.394,3.141,3.141,0,0,1-1.139.867,5.445,5.445,0,0,1-1.5.442,10.29,10.29,0,0,1-1.513.119,10.137,10.137,0,0,1-3.3-.646,5.917,5.917,0,0,1-2.754-2.074l-1.428,1.564a7.277,7.277,0,0,0,3.281,2.5,11.5,11.5,0,0,0,4.165.765,11.639,11.639,0,0,0,2.5-.272,7.356,7.356,0,0,0,2.21-.85,4.647,4.647,0,0,0,1.564-1.513,4.339,4.339,0,0,0,.629-2.261A4.094,4.094,0,0,0,557.17,71a4.561,4.561,0,0,0-1.683-1.428,8.709,8.709,0,0,0-2.244-.748q-1.224-.238-2.346-.408-.782-.1-1.6-.272a6.859,6.859,0,0,1-1.479-.476,3.272,3.272,0,0,1-1.088-.782,1.769,1.769,0,0,1-.425-1.224,1.743,1.743,0,0,1,.34-1.156,2.968,2.968,0,0,1,1-.85,4.932,4.932,0,0,1,1.462-.493,9.681,9.681,0,0,1,1.751-.153,10.414,10.414,0,0,1,2.567.306A5.676,5.676,0,0,1,555.827,64.706Zm5.678,12a1.424,1.424,0,0,0,.51,1.207,1.757,1.757,0,0,0,2.21,0,1.683,1.683,0,0,0,0-2.414,1.757,1.757,0,0,0-2.21,0A1.424,1.424,0,0,0,561.505,76.708Z\" transform=\"translate(7.063 489.051)\"/>\r\n      <path id=\"voce\" class=\"cls-2\" d=\"M48.16,0h12.1l46.368-110.656h-12.1L54.208-12.768l-40.32-97.888H1.792ZM175.84,1.568c31.136,0,56.224-21.5,56.224-56.672s-25.088-57.568-56.224-57.568-56.224,22.4-56.224,57.568S144.7,1.568,175.84,1.568Zm0-10.752c-25.088,0-45.472-17.248-45.472-45.92s20.384-47.264,45.472-47.264S221.312-83.776,221.312-55.1,200.928-9.184,175.84-9.184ZM340.7-22.848A46.859,46.859,0,0,1,307.776-9.184c-25.088,0-46.144-16.352-46.144-46.144s21.056-46.144,46.144-46.144c11.872,0,24.192,4.256,33.152,13.216L348.1-95.2a57.553,57.553,0,0,0-40.32-16.576c-32.032,0-56.9,21.5-56.9,56.448S276.64,1.12,307.776,1.12A56.6,56.6,0,0,0,348.1-15.456ZM424.928,1.568c-31.136,0-56.224-21.728-56.224-56.9,0-33.152,25.088-57.12,56.224-57.12s58.912,19.04,54.656,62.272H379.9c2.24,25.984,22.176,40.992,45.024,40.992,14.56,0,31.584-5.824,39.872-16.8l7.84,6.272C461.888-5.6,442.624,1.568,424.928,1.568ZM379.9-59.808h89.824c-.224-27.328-18.144-42.56-44.8-42.56C402.08-102.368,382.368-86.912,379.9-59.808Zm42.336-97.216h8.96l31.808,29.568v1.568H451.136l-24.416-21.5-24.416,21.5H390.432v-1.568Z\" transform=\"translate(86.063 441.051)\"/>\r\n      <path id=\"para-voce\" class=\"cls-5\" d=\"M58.446-7.258c-21.583,0-38.2-16.617-38.2-39.728s16.235-39.728,38.2-39.728c21.392,0,38.582,12.988,38.582,39.537S79.838-7.258,58.446-7.258Zm-38.964,46.6v-61.12C27.5-6.112,42.4,1.719,58.446,1.719c26.549,0,47.941-17.19,47.941-48.9,0-30.369-20.246-47.559-45.84-48.514-18.336,0-33.425,9.359-40.874,23.684V-94.354H10.505v133.7Zm191.191-133.7v20.628c-7.831-14.707-23.3-21.774-38.582-21.774-26.358,0-47.941,19.482-47.941,48.323s21.583,48.7,47.941,48.7c15.28,0,29.414-6.876,38.582-21.583V0h9.359V-94.354Zm-38.582,7.831c52.525,0,52.525,78.883,0,78.883-21.392,0-38.582-15.853-38.582-39.537S150.7-86.523,172.091-86.523Zm73.344-7.831V0h9.359V-55.008a31.341,31.341,0,0,1,31.133-31.515,30.342,30.342,0,0,1,16.044,4.393l4.2-7.64a36.838,36.838,0,0,0-20.246-5.539c-12.033,0-25.4,4.966-31.324,17.763l-.382-16.808Zm156.238,0v20.628c-7.831-14.707-23.3-21.774-38.582-21.774-26.358,0-47.941,19.482-47.941,48.323s21.583,48.7,47.941,48.7c15.28,0,29.414-6.876,38.582-21.583V0h9.359V-94.354Zm-38.582,7.831c52.525,0,52.525,78.883,0,78.883-21.392,0-38.582-15.853-38.582-39.537S341.7-86.523,363.091-86.523Z\" transform=\"translate(171.063 264.051)\"/>\r\n      <path id=\"mais\" class=\"cls-2\" d=\"M9.555-71.37v9.36H43.68V-27.5h9.165V-62.01H86.97v-9.36H52.845v-33.54H43.68v33.54Z\" transform=\"translate(73.063 292.051)\"/>\r\n    </g>\r\n    <image id=\"img-you-mob\" width=\"694\" height=\"458\" transform=\"translate(41 66)\" xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAArYAAAHKCAYAAAD2CwjLAAAABHNCSVQICAgIfAhkiAAAIABJREFUeF7svQmAJVV5Nny6+/a+zb4vDMOwDotsKmiEmIgbRkkk5ldRo36a+MUk/BgxKo4LGkExGNcYCX7EL6jBGBUBV1REZJFNh3V2hll69t5vb9/zvEtV3dt1u2/39MzchqqhuLfrVp06561TVc95zvO+b1XIlswCmQUyC2QWyCyQWSCzQGaBzALPAAtUPQPakDUhs0BmgcwCmQUyC2QWyCyQWSCzQMiAbSjLBiNZX8kskFkgs0BmgcwCmQUyC2QWqGwLPFuA7UTayX0nCmQnun9l94qsdpkFMgtkFsgskFkgs0BmgWlogYkAvunSvFJtSts+0fanAdhSoDYDu9Olx2T1zCyQWSCzQGaBzAKZBZ4RFpgosKvURhe3I/l3Od/LbVcSrJb6zrKKQW0Gcsu1cLZfZoHMApkFMgtkFsgskFlgkhaYzsB2PMDqv0efN339piUzZ81cXZurPbG6pnp1TXXNckDQ1pGqkWYgz6YwUtUMxW27ItORp0dGRvbiy278tXd4ZHgPft81NDy0qT8/8NADv7v3ocsvv7zH7J4Gcn1bBnIn2TmzwyrHAmvWrKle+PTCmrpF22ryIVTnGhtrWkdGqkNf61B36BhsPvHEgYsvvniocmqc1SSzQGaBzAKZBZ6NFphuwLYUM8vtSSBb9Z/X/ef8RYsWPb+6NndOVXX1GVVV4dSqUNVajS/FhRB5AsSWFNZW4RgBu9jHF24bGh7eEEaGHxoaGn44PzTwwMYt6+54+9vfvicBdovBbQZyn4132TRq87+tuWZW9WD/aWFkaDUGcyejn5+I9dRQg0Efh3tyl+AeqqkO1dU1oaqqOlTlqgMGiSGnf2+vCsO7Q/VIR6gOD4XhsLYmV/1QbW3tgxe+4x0+EJxGFsmqmlkgs0BmgcwC08kC0wXYprGzBWD2mmuuaT39pNNfV1dXdz5eu8/DG3aJX4gkmpwqYFvqIo+MDN8zMDB4S29X960vu+hl9wn5G6+CjxPAN62K06n/ZHWd5hb4ysc+/bzh4drnheHhc6pHhp9fPTKE+2YYvZTriA4Cq6tl2FhVPRKq8YkBnQDbmpoa/oj/qgBsudZgVwBdHDdcNYwisOJ7bS6HXQB3h4fWV4XqB2tqc/fVjAz96MJ3v/vuaW6+rPqZBTILZBbILFBhFqh0YFsMaAtYWVJHP/z+D1/a1NR8CV6qf5pm22KKtFSDxxLBOmMbodAEc1vqesoxI2HX0MjwrQP5vpvPv+D8b5cAuWNpdSusu2TVme4W+MInvjCzpnrk9SMD+T+HrOYFAJr4J2g11KDDAqbiLwDToUEBqNI5CVZlJdDFbyNDALZgaLEKYwtQy+6e42wI/mbHH8Y/glrebzKYtLUav0MGZDMkw7trcrmbm+vrb5nR1nbLmRdfvH+62zerf2aBzAKZBTILHFkLVCqwHRPQfv26ry9dtmzZu3I1tW/Cm3P2WCacDLDlS9hlB/69GNxO+LIB5A4MDvzrhifWfeFNf/WmnQZyWUwxoyvbsNThs97WWnySHssVfXIbdY1cB4s+B/B3P1fUHbLIbHk2W+Cr1371NWFo6HUAsxcPDw6FwYEBgFd0G/S+HMEo2NUasLQEswSvVWRs2REFmSqw9a5K2EpmVlYCVgBbQFWoFbhNJ1IAa6Vj808By9iPgDYH9jZXk0MHB/QdZpfF+WtrQ11dLX6rvSOXq76pdXD4K6deckn3s/l6HYq245nSYM8TPltKPVN4AdOeKbxYyWeKXrxsySyQWSCzQIVZoNKA7ViAtvqbN3xzxYKFi96Hqc3/zx7M45rTgW0ETEuwrUkAnMbQHjSwjWuaHxoc/GZnd+9n5y+ZtXX27NkzscyAhKIV5xAgiylevng41TuV0RQE5Np6AJ/UAnPdi/NmTj/j9qTpt8N1n71u7sjwyKVY3wlQM4PgdQhgcmhgUBhZaGgBYCEhoGYW36uHCXTJ2uI7miuDOq4iRSDrqmB1BIwtpQeEs8TEBLfcv8aZWfw2jB0Jigl4CZSrwe7WoBwwtKGhvkG+j6Au+YG8SBoIeGty2EfkDVV7AbA/lxsY+Odz3vY216xPvwtwmGtswHUWTjsTKz+hiw4Esw5kp7pGvfY86eNzxNY96DcZ8z7Vls7KyyyQWaBsC1QKsE0DtK6hrfruTd9dPbN99vtyuZo/K7tltuN4wHYsQDv+udJw52iTktlC3eWlnqvFype4ON9UP97Y3HRL24yW+wlisfTjsw/b+aLox3785Ep2pJiR9b/TmFwyu1ydoXHm119yxU3ji2gfVgG6WHdnLO/4V79S9/jKZ7+yZGio+h8AQN9WPTzSSLDK8VwVge3QAPzChoQxVakAQS1+o7xA0KgC2xqCUqJWrCOyKnAlIzsIQCqsLvUH1NYKsOXfJH4BlilPsNsA6gUBxLwH2OfJ/mIQF+qxsizuTyZXz8X9UBa/D42E/u6e7nxv77/27eu/+k8//v5tlWrvI1EvXLvWBIAliOXK+7x48WdIcmDL76WeKaTq/flR/GxJziL5M4WfZH+LF0STiZ4nPoDWaYBsySyQWSCzwCG0QCUA26Rulk11QFt94/U3Ll28dNnHAQpfa9un3BTFkQ4mdgJTEbDGhnGrqmpCrUyrOohVhxpfhgEewNiKA84QpoT5fXBw6KH9+zs/+JJX/uGtVlI5DmcTq2pib7S5DX+2YJ2Bld+58nvyBUUP9gjo4vsOAJls+nHSVj/0B/7L1V9ZAUD6QSDJt9D5S+QESrGqIxj6HKf/6dRFMAsmV39z6QG2q8PYsCAblRlAecsVWxH8QMDpIPW3dpfCIUzKqsb/uEn+pnRBmmsSBZEnECOrwxnZW8oPalEgB3qImKAg2W4iAd1glbt27w1de/aF3s7usH9f579v69h/5dU//c66Q2/JyjoD7lfeq/OwJtlYXiJfKNvgLIyvHKh2wqaHJQoF6scHHJ8fBNsMl5h8vhAc+8LBMwfOMluE+lGSlS2ZBTILZBaYUgscSWBbkqX91Kc+1X7WqWe/v7a2/q/wvktjIabOCJxq5Qsdy8TlBkJ1icawvr5e1tpaURFEyyCBK17SiJQQBvLQNdq50howPDR89/59e9/38otefgd+T4Jb/+6HTaVEIaoKXlBN+IMv0Ln2yZeVLzTSDqxbsG6Grcj6ZEsFWIAOYcO52ivQlf9OgSoXQa5AmgZeycQKwFW5gYBaRi3gp8kF5IYUADwk2ljKDYS/FTaVkgWNikDdgcJQDNIIZAmUpYxEzD3uKLeH6nYJaGUQSYaXsgTMYBDQchBYx0+CW5H6Enyj3Hw+7Nq6LTy9cUvYv2dv6O/Lh0HsUDej/d/mzV+w5tIvfWZrBZj+kFUBtqLvACO7LMUqsbVtoWxoF9YOrASGHZU84EQ7WPfkM4XyCF/4DOF15DNlWyaJOmTdKSs4s8CzygJHCtgWs7TqjI319tt++c76htoP4SvZiUO/SPSCieNEvpjr6+tCXb2ys74MDg6HfD9ewnDOIZiNnNBEU1jeTBycen6yd/eeK1752lfei3IPO8D1tqDuZHAd5C7E9+Q14VQjX0ib8ELqOvQXKjtDmgU+fdWXLgMl9n6wqzOim1l6jLGvAmKVVVXHMAWh0qsAIDGYki4meFV0s6aJNZZXe6zNOKAcMrZVoIUFt5JZRRksnyDZ2V8pnkCaDC3BMaQPvF8EtBLk4ruwuiiDTmP1dRgUNmBtrBfJTjVmPUZQr45tO8KDv30w7Ni2PcyeMzscdcwxYf7ixaEd32sa6j4LpH3luRdd9Ixh/WCzBTA2wexyrJQN+cIBJQEgQSxB7bRd0MZGVJ5Al+tirA50CdgpN+EzZQvaSUe1bMkskFkgs8CELXAkgG0S1Eayg+uuu27+cUcdfyOmKc+ZcCsmcsAkgay83vEylhdwQ52BWQXEiHYgYLa/rx9AwSvD39A8Fxty8wQBNNiw7+3du/uDF1504SM8OmVNnmwiVpjUvhapgS8jglyu/vIlyN2AdWPG5E7KtBM+6KqPf+7lIDC/DCi6RN24uGjYLQJYlR8oW0rwKdyrEKYx4JUuCQDpgy+JQct+7myv9VeRLQhQtfIpUeDBBlR5Hge38ouNFQmiKWdQPTllDUzmgAEhwKwcj4IZMkwYXDK3TY2hsaFRwO4IRL2d+7vC02Bte7q6wqw5swBu54ZazIoMoS6D0Apj8NjX39//L4P99R9/zd+/hdPc024xZvYoVJyr309JkPfUM1nvblphPksWYZ2PlSwBx1ME8nymbEX7y2MEpt3VzyqcWSCzwKGwwOEGtgWzlfIOxevtB9/+wQtmzpr9Dbzt5hyKRo5b5hhgl/KEOjCzDWCTOF3qC9nY/r4+AFqAWQuNpBJB19PyWZxs7ri1KNghEW5sBBrcb23btvPDF7/h1U9iJ+HabOfDIlEoVXPUkQzuCqwrsbpxyLpsxEomN4u2MLHLXtbeH1/zmauRIOEyYU+l7yYkAH5Tua7WAK7vUwOMQMBJtjaS4NhZNQat9WADxfxbQLEN0NjX5TuPT5xDgK05owk9LOiW50LHoMMkEzpgZoNZyghyCWjpNMbbRZwqAVhzmP2oR8QErsxqRglPb0+vSHg4K8LTDYD9HcRAktp0DVvG6A7hwEB//6dzgz3XXLxmTcXPHsBuZCmPtnuHulRfeN9sxvr0s/XegW0Icvk8IWvNhbr+TVg3wCZkrrMls0BmgcwCY1rgcAJbR3nR53nnnVez5h8/cgW0qe/FWzD2sJIqa9XGEglMqvJ+UKJgamT1JR3biixSIxgkAlpf6OwFhij09QLMiqwgWTv/rs1grE9disGtsmcxFPHjCvdLShjUq31kEBKF/1i/dd1HLrnkErIZlQRw2eijsK7C6oMTTiXS0eeRw+XE8ky/16/8x88sHKoZ/h5TREuILQm1hf8JoNTJAWFv5W9FuyI/MB0t92O0A+peZTBGFtZYXmV7NVatx7GNblQlYQVYDonjGP4yplfZYpaj52G/jRLvKtUr55C6EszSYUxCe2l4ryqA3jpq0zF4lG3Yhzp1ZjETVjaPkGAAtiLrQfnUrA8B2BLUDuA36nF5TnHEHMjvHsoPfbIzdH/u0s98hqGoKmox0HYCKkXw5gvBGplJDgQz50yzCmzFB+8xttJ5jksn1kf5XHm2Av+K6tBZZTILVKgFJoUNJ9gWP0cS2FZfffXVM84549z/rKnJ/aFgtGqbEpX3sf7jC1LgY4laim6QlTnYVgi21OrRmYWAltOhXPjS7OvtDX39ffLyLF6c5ZJZW8Oo8mIX1ip9SeVxC9je4uOscGsn6vHFR9Y98vG3v/3t1BcmEfYRZXDNXnQ4Ox4rGRcXH5OFWouXESUL2TIJC3zg8qtegst/I+QCMzUxQjxkUlCr2b0EYLqWFj8IqGS6BAG3FulAQn1pxARlYlUPG0cm0DETfyHUlXS4ALKM5BGxtF4ez03AbJ8ObGVfOqExfBfvU4mwAFkCoyAg1BdnP6oJbKmpBditA5hlpATJYsZW4HhGXxDHSwBY0fISwKLMEdyHlFAQ7FLTTj07f9O/gQ2Hh7fhHrny/7/us5+fhKmn/BDUjQwkAa07gRGgcdBHFvKwRC6Y8kYdxgJtQHAsTulp0jlo5uwVnykMZ5YtmQUyC2QWiCxwsJBwPFOmgtqv//vXl69YsfJmPJRW6WuVb0VjOA2slgVsedh4NSjzd05/EtC6I9gQXpy9PT3CzkZ1S5YVka6JJkbAlmC8tCwsFdiy7GLSOjofjTIKKPfk8/kvrr1/7VV/9Z6/or6w0gAusQ6nW/lC8ugK9OQmg0sHkWwp0wL/cOlH3w8G82MKDjGlTwAra2I+wHSv6oVJ0MrsYJJCAcDSo37ozSaRDQzYskyCSEmMIF3ZGFsL36WMK5naGNQKGez6W/yGWLma4IEDOr8H8IWhv5wlluEq6l4LjXotnMUoT6iphUMZziMaW0vgQIAtwRxwLM+p4fAYf5cr2FrG4OUAk45vqHceoFeyqCHaw8AAfhOHuCFJQAHt+ybEwf3IR79743VlmnrKdjM9Ogd4nMVw7SwHouz/T03ZiZ5FBZnjGe1JJpdOaFzIdv8eNs2SQjyL+kLW1MwCY1lgqnBh2jmKQa28c7/zre+cOX/uwv/Be65IT4u3WYRylSnyufaIUJWXdiwAKAkQJ3DNydC2tLRYxiMIusD69EDXx+nPeElhX/0N7q0EKOWLmyBBaFMBoums7RQBW63eSPUByCOu/e2d9/7zpWsuJRPkJ/aTJytRmkaegM0muiteSIyswBcSWVxeWsayvBcvo2eMR/tEbVLu/pf+7w9+DVrUSyg5iNLXYppewa2W4g5bzrBq1AN19mJWMU+e4KhTAbHuo9MhAJeSXUw6lKz+p8a8VcAahQaTXZQZVuCMDcLmctUx2JDpa1Vna4kXcrUAsxraS5zG6gCmqbEFyHX3N9Xv6kwJZQaqp+WnamtdX0vGlnIEAdwAsjwf71nfTuY2P5gH2IVjZ37wcbiZfejzd956Y7l2n+x+qDf7NwHtSVgZ+4/W4owFwRf7fbYcpAVgY/ZUsrccNDOSBG28EesDGQN+kMbNDs8s8AywwKECtmmgtvqW7//oFe0trV/HwycOZWNToZE/lL00aVu+zAUmklVKAYljV37sXxlWqLm1BUHidba8P98fert7dSpzMksRsOULW3WyjiVjSD42sPVjfC/72xhbx9OsojoOmTR5JOzuG+j71K0//sEXP/nJT3J6sxIBLnVzJ9rKJtDR7L6MbRnd4f76r/+6pWaw9btwEDufAyYBtQS3EplAw2jlJM6s9ATL2GXwMJIdMFuYyhaYQIH9kV1GRpjG2Gp/Uu2tsKUEouYoJvsIAFaGVu5BiVmLxbOUEWAL8FWgTDDK3wYl/JdQrxg00lmMwNmy72EwqVnIIP2BwxglCc49S32sbJYlK4ArZ04U2FKWQCkCWFmRJWjcW9Y7z6gklCYA8BLkEtiyHgMSS5p63fxDiKjwwa/d/4vvTuYWH+8Y2IAzFKdiZTxoLo9hJUPLBArZcggsAJszGcQpWDlo5kIN7sOwef4QnC4rMrNAZoFpYIFDAWxTQe0Pb/7hRa0tbf+BF1iRk5hZKSFF4BbZicCWL8coZFa5hKPqDdMWemI3NzdJMgWWRo/rnu4eYXZKMaxlXcdxgC3BiOga2TamHOXZPJqCn0BAqlFeQko4GLZtpgP242JgG4NhAIPt+f6BT3z1P/71qzfccAMf7qUAbrnGLKv5E9nJphRPwzErrJEb8PlgBgDUiu+85O8XD1dV/QiDrxNETiBg1oGtgluVGeitoUDXQ3VZKC657GBsmc6ZqWoF2Nr+xrbKHSLsrTK4zgAbdWsA1sKDUW7AwZXEsyNbq31TQ4v5EZQsmBxAAKqyvdUQ2YrjGEE2NbUEtNDZVlmihhGJ7qBpdRnnVmLryqcyssLW4j4lOKUcQcKLQXowxIgIlCnIdj2va3J5TD+BMOo7YGwv9xEWeGj4Xljj/d/43Z0/nEi/LbUv+jNjsp6FlZIb3uTUzxJcVZwD21S0txLLwDWg7XkNeC34MP891kczJ7NKvFpZnTILHFoLTDWwTQW1t333tj9ubW/9b7y8cgLwyMgI22jYSt6RhVIELyjiPO0FnMTFo4Ch2UqnZuOmOTxsAqCljpZ/k9EhoI0Y2gJ2Vd7ZWCzCwThhFBVKsD1agcShqVcvgqzJc0YHxSB1NLD1MYFjUp7TWice6F4yzTm8qbe//8obbrz+huuvv17RSLxG1fTqHtpull66sS1n4FfGsCQgIMNFQPCsDc5+yWveNbumMdyNqfqjxaGLbG0RsBUnrITGluDVnb+kBzjQFGcyhNsSxzBnVZGsAdty5oAmV0b0uaqltT+lPwtLa4BRywT7CpAqYcIkNq4uBKRyL4ocQbdpvgb8geNViqDOaUzuQPBKOQJ17SxDAuMxHBjD6dlzYXgIjmLmDEZAKqDWIiLwXCpJAFDlKppaOpORlcVKMIxteewzMIDvks1M5QpCVEt9JcvZHUPDI+/59iO/umsy/R/tIzNLMMVpcbZ8PdaHsunwyVhzao4xR7PTURqBLgcWlCfwumRLZoHMAs8SC0wlsE0Ftd/+5rfPWjB/wY9UfsBdNDzR6CXpbKVQMQa1CSCXZGKLGM94r0JgywgHLZAd8OVKINuF3POjJAcGMiODSGEKFIeLgO1oo+mWUTKBRCPlfW1/x/DTXv423RvzXj7F7ODBBwAuOxAokCiNqKMQ2PqpASIeRyzQj7z7snd9a+3atUlw69Up/jzsXR8vIwZmP9NeRmSZyd4+ftgrcoRP+Jev+svWfH3ulwCdp0qEA4LBmpx8angvZTWVsbW7KfpbGVthcOUu0/5B0KupcFXOo/uYNtb2VwcxOn/5BjWE63BFXoB9CKYJbum0JZEOuBMApOht8YcwrACaNdU53DMKjF32ICH1KCuQWxN1IoNrCR8Ys7YaOlsB02RtUb6yq3QeU1CLL5pBDXvxPJQXSJpqYWPVqYxsrUgOKEXg3xJZwfTBOA78bvRQEfKZuBv/y48M3zI4MPz+W5789f3ldgH02dXYl7IDLhuxEkBlkoNyDXiI9zNZyHNwGsre6Fx7T6bpP8RGz4rPLFAhFpgqYJsKam+68aaTFi5c+BM8UNQrPsEojtl+eTkruBNdX5m1VE2rLjp1WwVA24zQXXXCHpGh7YMOL3UpBra2E31BCiMcjJY5FGpp9cBqHuf6REchHk+0VCgwi2sWR7q16V9hg80ISaY7akhpYOu7oI4PdfV2r3nJy158s5i1MhlcahQpUaDHM72cf4tr+HSF3CuHtBpvPu/NDX0zqnCvhHMYw1VYWIC/EepSZRrfga3JEIy1leBYzuiKbJWA0sJ44TvBKIFtLM2xqAfso8boakQDsrFEyzYCU7GrOnGh7xGk5sC2JtlaibZAnauxtzITY2mjTYkbOZZRAqShwOTmlDbxVJLljNpeGbDGK88j8iApEoAZGniNssDZCMoJNBRYv0RNUEDtzC6B7qDpfEUljPoTUOt3Ms4cB6p+F7g3wDdNvw8NfRsU8D/euuFezhyUeEzIIOx5WBlblUD217BtljjgkN4dkysc15ribdf0c+TEaCx8plR8Eo/JtTg7KrNAZgF5xUyRGQrfSiCKvvzlLy9Zffzqu8AwxdEP0ojatAoYKI0Y2wlU0kFmU1NToPSAb0Kmuu3q6jbnmXSJr9KtfOknTUK2By/zAiA6FrD1Y6k91KlX8Sq3aVjN9GQgNK1N5giWbLemQOXOKfWOQO74wNZPh2ncuzs7ez52wYUvvk0rkwpyuXu5V2sCV2f8Xe1lRDaMKxc6mDGCwoHxj56+e/z5q998G9r4Er0pVRtLhpYOV6JPFSCrfUoAKUCmRDwwZzIq1/U3ZWt9YBcDW7/dVfeqzK1KFai/JUhN6tKF4SVo9btCuhizjtlDw0J81QhQ1L14XpEFYBvlAMLMYjtDbylDKzBWwbMsqtHlmE1KENpXgSvvR0oPuPBzhKG+XJpgA1gBtPhO1pbsrTPGosklW2sRSiyThQBbMrQSE5excAl4sW1A2FueU2ddwBT/R//w8BW/2HT3Bu9R6Jd0fDwb6zLb9jvY68Hp2+OePTXHtSNrS/aWA2cua7FS8jRJT+Fnj+2ylmYWmI4WmApgWwxqq1/1qlfVv/fS9/4CLzKyb5NY9MU8GWDLl2drW4vEoyULc+DAAZ3KtMUTKoyqlL3sud1f8Bq+iMC2cO8kAJAJW/ceT+zmwDby2OFvBp5TYtLqkWnAVhWItibr4XINs1IJKUKa8Qn+EUD/zt2797zn1a995b08c8rqhx4pgMtRiTuYsQ4MyE6JQgnKfRLdrEIOee2Fb/wyBj//S/uV9n1nYTFGNCALoOuA1aQIOZEhqEyBiFM/DPDa4JC/IxltoqWFjC3PqJnDdHHMKewtWU1qbPk7QTWBLplb+43sbI59msBUWF8ARWpeKSEgQAS4lXLh6KUMbXxfy2b+o1SA/wgq0YclAQNDedmqh4OpJWAmYJXQXtJ/sUkTuDDNLqUJLIvH6T74XedMxKa8h4dF5qBaY4mmYGw02V0NSqbIVlhqnreq+itV/SMf/smWOwmAzsXKmQSGqCNLm7F+FXL/lFsNczDj4IThB/kc4cDkSVzLI/KMK7fe2X6ZBTILTMwCBwtskxIEIX+4/vzHP/88pv//0l6VBUCxvOpNDthSckBQyxdoX2+fsLRlLwnGthjYCuNTcnFgm9QIqxRB36ny1k8cPUHGtvi8NtXsr2z9uXzGVvZO1AfTuz/o2LXzitdc/JqHtaCKY3Bnok58GZH55wjld1jp7Vxo8LIvdGXt+Gcvf8NbgBqvIzjUcF7ab2KQa+BVMnLZbAH2ZbSsHCQLzuAS2GpYr0Im1xlbb7Wky+XKfoSN5h4ZzVR4ZARlcpW1JQBkeDym0aUcgDFomT5XGFwP/yWgUPWvwrZKmC7PcIYMZMI2i+JW7gmen0kVopi1KIsRUFg+gbHoccXpC58ArUhMKKBXnMiEVVUpwQAdyUyTq8oILYfsb7HHJP+OndoUwKoUQdXHwtomwDDZ8pUnrArnvviFt/7xRS+5adGSRT9HvZ+orB6U1WaiFsB1X4pj6GBGOQlngu7O5CQTtWK2f2aByrXAwQDbYlDLv2t+fMuP39Tc3Pylg2vyxIFtc0tzaGxskJfh/v2FLG2yLmMxtjI1WqTOkEnbEhHKvFwFikXAVmgsQSgRsKUDzVgz/O4Ll2Sqx4LUcdljAFun4BJgNglsrQ0j0CV+e/v2p6+4+A0XkxmtRIC7HPXidGIzVrJl9+NltPng+tmRPfqVF7zh9Nqaqvtc2lrI1kYcqgBCZTsV/PKTMWw1Ha5GJSBCZTmUJ2jsWuwv+xQytlKG9HOLZ+t/A8RJWcZx0jmMsW25H8GmxJoVQhNaXHI4otsGAAAgAElEQVSz/I0oEaDTy5N+RTAq4NLCdkWcaTy+Exc0mQ1RWYQoD4Tl9cgFGpdW2VdNzVtFDEyHMHMqk8AM1OFSG4tzkMFluRL2Sxha6mqVhRWQjHYIIDbJgQJqlC/Aluxs4tbE9/qGxnDymaeFGTNnhM4DXeHBex/u2bl7z7UdB7ZdtXHfRjojZcs0tgD6Kq84E2mcjJX506nlZ0ztZ7TkaRpfsqzqmQXKtsDBAlse7+/I6pu+cdOZixYuuqPssyd2THKaovyzmo03R8Qpzra21lCDF29/fx4RD7rkhVcKQJYPbMlq6Ws+nqgtblkRE5v4WQCy/exAMg3YJi/AhIFtdD7HoX45xr4CKcDWq0pg8J9PP7Vlzeve9LqNZkRH7Em8zROMd2km0w3GPQZ1Z0YnvoyIxJiil/rbPeMeWGE7XHDBa2c1VNU9DMnBIgWsxtJShiAgVsGsy1B8FsFlCs7OslmylwFdYWxZBiUKAnJFpaD7yCfLJtuqfwuHmtiumgBEQMB2Sh2kCiI3sEriuwBqbBJdrqXNlQ5B5lMyganTmWhjuZ+1SS+BzjWIJIDsrANVYU3JoGrUBXUQsyQMEr5AY+Tq/gTDdPYCGKaWloCVSJUAX8CrQm06jIl+Nypbz2teZFoG6yK18kgkCIS6cEE48bSTJCPahsc2hA1PbAzIXx32dXaGvv6+/Tjtp3u6aj7TEdZmcoQKu68mWh3TTjPBA7OYcWE0FkqesgQPEzVmtn9mgQqxwGSBrR9nc4uh5rzzzqu98kOf+C1eqEydmr7Yu7H4R3nRGUyK9at+imI8FR9dXw/pAcJ4cekEoM0D2Mqr015kaZWoMmYq9Tds1LM6ZvO/0sxUWK80lJcWLUHPa2wc8UJ0Tr6X0/lZKadAzlBe7/EUv+Xsra2JBA4DA0OD161bv+kTb3vb6+m8lRwpHHGAm+IMsgF1JIM7bQLiv+qlf3E74OeLIibWxnKuQ1VJwmhgy2vpJLyE7YpCgakWl0cIY2tAl8CWDl4OnBWommbIATV7pMsMua8xugS3Wot4BoWMcDSzIYwr2FS534qALZlbOn8JEPbgYzyhRiXgolpclRswkQIZVIJVGZhGwJb7m56W0REM2EoqXWN7yfQSxLq9NHiZsbXW+aUDk90VeQPzGcYafmV4tVWrTjouLD16mURQefi+hzV5C7S9+/B8OYDMhCKX0IuwF/X+p6c6H7uqnPsr26eyLYC+xAxmDDm4ECtfJIxHXDI6RmW3JqtdZoFntwUmA2z9GH66rrbmJ7f87B8QiWDNmOYsBWz5grKX+Ghgm86+UnrQBOkBX3QH9h0wltbm0McFtunNjkFmIbBNb1MhvisWfJZKHqFlHR5gO1rfW/rqyGDApm71vS0Apjc/kP/y2kcf/uS73vUusqKVBnDbUSfqb5ltiOQbvZ1/j7rze8UuF77kdW9FHf/NQWwBY2sgMnYeK9Tcxo1i1AGTJljEBAe24mRmmltkRBHnMT+XH68aWouTTKBrUgaRBxjsYzm+ukSHbLChWJUtDEOKILSsZgmkU5YkdbDsYQIffdTKDmTaWK/HCI4js4uBlBwvgJXAkyQtGVmLjSsJG/idZRvpyjIUUANsCjDXNBPeAjKyfifr2FCBrR7jLK1GZahFsohTzj4ttM5oC3t27Qm/u+8hqTY7fFdPT9iDZ0yekRfsnNHoYgRT2FUjV2458PgXKrbDZRUr2wLoIwznxmcKgW4nVoYHe6rsArIdMwtkFjjiFpgssHUMyPdjzXVfuu7o448/CQ+AwJA4pZeSwFZfIPHUa7KIQgBJhqqtvVWiHtCRpHN/Z4EzVMQclZgpV8Z2PGBbznWZxsBWwEkhxxy1Rn5Kxj0VJrdzOD/4L3c/cNdnLrvsMsaX9d0j3JCwWBp5XY5BJ70P6svMT3QGacXag5XB8sniVtzy4he/ZnZTVcOT6OwzBGxKNANlVNktlR0lTvQxo/6d7LM26IgIXQWfLjdgqDDGwdVtopOVlLqmi40Y11hDy6up4cJMomCMLc8rIcVkZkHrIYytsLo2PBMHMDCmbmmTI0hmMtHRqtZWoiuAVpUBVKLveSQCMraUHgzyGGFWKWXQpAtSBhlcRlwQllajKERGkw5pNWDkA9SOK8uIq6XHOVjldv95xuyZ4eSzn4M0v7Vh07pN4clHn0Q4NQBu7N8HCcJeRFbp6unFOfW5ESX7k8ui2/CxEZrjD2/sfOL6iut0WYUmZAHT3x6Dg5iAg+80RsKggxmffdmSWSCzQIVbYKLA1vePJAh8d97xk1/dWpPLvXDctspLdvQpnU1JfVHF7w5Jw0lQyzJ6EfWgB1EP0hqQpiGVF5K8gbzqo2sbM7bjtsRKS7w4vXw7dDKMLdufbh+hm8qpVOE+KQC2VCGKVIlgCD7i6W63pfCGIyN7+gfy19z64x987pOf/CQBZKUBXDqDUC9HZxAyzNTfUodbMcvL//B1NwDMvkF0qna9Fdgm5QIe/YAg0hzHpO9qMwgyhV23vx0CV9uARECtSRlqUK4M5bxv2f3nIb6kzxNIy6fFtxWG17OGMcpCHK3BVeeaYpf7Kzur5SjoJSBlHVmmaGUlHa6CUvYYMroEqjopoNIAsrUDBLcmFRgGCPYMZCR/hbGlLle6nLZfuqSdQ/E2Nbreea2mBqSVvSX81cQpVpWw/JijwsoTqZ6qDo88uDY8/dQ2ix9cJWHE9h7ohAShS75HzxXaUm7H+FxaHRkYPIa6fGjj/se/UTGdLqvIpCyA682kDtTzM8kDl3VYKXl6xoUcnJSBsoMyC1SoBSYCbH1fJ2uEELr1ez96bXtb29fKal8J4MZj+RJTUGcvnkSUAW5mWty2ds4OYWoQejdmEJsYEHUUVvqoiZVXyNgWw85SwFb3S5ciTDWwnbjGFlUr6hGR4xt/ivnZHfl8/srzLviDf+Wl0zd8tLKBaUxuWV3kYHdCfetQhjuDsDWMnMCX0RF39HnpeX92XlV1zc/UOcxXG2vRvop15bfRGtvYMpFTowNdWFv0sJYqNy5bncei8F4Ru+gMr4JLiaRgYFZ6pxxjK8tOhCETuGgiWZ34VycwvXNVsMDMXzwDY+EyqcLA4ICysBKPFsdbKC/BweYgRq2tJlWA3IAAFruJ3lZYVkY7sCgL0maclSl6uY8N+EQjKwBZga8uMUMsrC82sywBwTj5sauPC0uOWi71e/jeB8P+vQdksCAOplgPQF+7e+8+ZDcbiFhiJYoJYLWL09Y+HOB2Hi8M+kjVgwhR9sEnOx/93sH26ez4I2sB9B06cjAiyzKsDDn4e6yP4No/I0IOHlnrZmfPLDD1FpgMsI0IonPPPbfuqis/vRY3OKeCo6VkoaUYSRwZISOb5oymW/GLOIkh8gFfTgcgPZBUm/b6mkgD9BwHB2yLOVo//yg+lQ4wxSDR2jlpjS1fohLxIZ35HtU9SjC2pbhf2V7KoHyR29ytAyeAiC35fP+VX/u///6166+/vjhsKEs7kgCXo6AzsC7CSqM9ivWIZht66fmvRTD46pViP72IlohBwZJssvS4GspLV2fxlRHV46KkIXK/WAYx693eP9SBzEpxIO3nFVCqv/FcpKakDgLMdBvP5d/drVHj3BLc6v6i07UQYJHMQOQIxqAC5ErSBYt0QGDrCRgYGmyEjl/G2g7iO2PKDkGnq+DWohYwNJeE59Iero5fTMMLEJ24z8QpTKqm9fNFvhqw9fS6q884JcxbvDD0QmJw/2/uCwOSahuWtDTGedR756694UBPtw2xVQ6h184TBtu1sBvHByUcZNSgcnUA9vU11fe1VtV+4PaO394a1yj7Nh0tgP7IWNrU3zK2NoOkc8C8aTq2JatzZoFnsgXKxYUxBZJwGLvl+z9+S1tr6+eTBioNG/UtmqajdVA72tAjiE1bH+goJvFp4cAhrI8tY54r5aodLLAtrGcyQFDBe1TOLDE+U6zrTnJRGxRL6DFMOZqQHDigiaIilACqJTuoMXRJGUMx0uS5C8B6SWCL+sl0rl7D6DiZ6h1+sqe356N/e9nf3rh27dpojJIo+kgC3KQzyBHLNvTHL7zobTU11V8hE5hMwhCzq2oiD4YQbU8Btt4vyE76d9XBEv0J7o0ZYb9eAmxdcqDXz0GtanQVpMbAViMZ6CjWnMz43QE4j5HzxD3aU+FGpC7BpDiAQSdrwFYcywhc6WTGewRgluBWsokxaBeqQFA7aJnBaBVGFJMypa+JlQRskoFFydp/Zdylml5ZCj9kE/evrs6F1WedGmbNm41B8oHw4N33i/NanJoY2n2A0j379oddWClBUM2EOr6JbQ1ayz1rAxAZXOA72W867NVirce1rsUFbcRnfXW4o34kvOfbO357V8n7NfthWlgAfexoVJT6W2ZH3IWV+tu906LyWSUzCzwLLDARYBu9C2GXGrC1tf/08U+vhVMK2FrHLfry9Mm5dPulw9EEwRId1tTcFJqaNPIBQa3Gp+VLyxgjT5M06kRppfn7rjQcHssY6cgsfuEXn5F6x9KMbVyH4toUh/aKwK6/sB2sFrc58btMj4qNDOW4zex9X5wiOC6q9BBD2LsiA8kpE0Ac5/xdV2/Xhy94+QXf9VMlPqUWdq7SF+gQ3HQpziCHPdvQS1746s3V1TVL4ZUUAVukbFWAKQMFhu5yUGrbJNuYLWR3uZ/GpVLWVgYavM7GIkbT4/zZnMUceBmwddArgJXH2SBFFalQoMp5FNCK45j9HUd55T7sC1Z34zNlat76gwBcxoC2yAjU2Arhz8gHkCZIEgfx4lJgS4AuEgQCYQJc6mut+3qiB8kYbRs18oHS8INMw0s72EiLkgYuYrn4sSTbquFwetrzzwxtM9rD7o6O8PBvNdmeSj9oixrhYvd39Yade/YiZm2/MeMK8fV2sooZayv24T8mwoiAbTXYWoBblEWJBwFunYBbYXB/gL8vv/6pX/Pk2TJNLYB7j8Q8Y2pTf8vvG7DSaZW+B9mSWSCzwBG0QDnANiIU5emua+7Wm3/8ltbWts9p3Qtxik9/jm5XsqixW90MUNsAUEu93oF9RZEPohd4WvXHAGdyytLANq1G5ZQ22gJ49U4C2LrMIFmPUsC2gM2VCtg1EABjwDZZUOJ3DXg0wdYCOYgzkByadny8DQ/9e7q7ute85MKX/Nh2djMWm/NwA1x3BqGTGZtzWLINvfj5F/4vJBL5MpFrNaa6CYLEEObIqOAx6UBGZtGSIxg3Lul2BUwSsMVmE4CodKaAY+nh1gccxLr0Rf82ICcG0PL0juDxCloFxhGkCVDzAQ1RnR3vgNeYS4JaIXKFUTVW1ZGmsK8AtGRs8Skg1wAvRqwCzBXMWmpcO34ETnMCXgURo3yRInj5mi5XgC2Px6cD2rQOJe2B3U8/92wBtdueejo8+hAiwyHyQRTvFwMOgnEmYni6Y3fohL5WcLTZ07husbWGRFOfgJwwtNATi73wyb+5wpB1AmyH8TeALc5FgNuA7QC3oT5X81/1dfUfuPaxn2WxUks8jabDZvTJBtSTEVlWsBtinRYhB6eDbbM6ZhaYrAXKBbaj2NqrPn7NWoCuJTr1F1MjYzO25YFKpsZtamkKA/kB0dRObCkHipbTbD1rWmml4HS8PSFTSLBGcVnpjG0asI1oUmfE3BjO3EZv8kJgG9vMwisZGIoBlbcuad0xbEd2b1wYWng8tJV3Hth74H2v+NNXcPq1GNwmSxu35In1gbH3NmeQ07DXctuT2YYYkP2QeDv/0Tmv2oyywdYSSAH6WCIO9ex3VtSjIsTgU8GswVUBnBp6y6fG42l3IjBnd3XWhIvei/zbY+F62Q7TFNY6Y6xwkc5iVid+JzgTQOtlxvIHcTgzUC16XQOetkmfChYVQdhWglvGogVryygJlCBI1ARqbMnWYneJYyudhYMzT72r5K46rbE/WzwGOpxxCw4QiJwA/MkeQHuTqZ05Z3bYsn5TWP/oEyohYPxfS3BRl6sF+1sVnt61O+wAW8soDDIfI21XG9IE3J+r170G5xZNrV1H2o6jJ0aSqOMpUEcC3TpkRqzDtgZsq8d5G/E3ZVZ1TfU3NM2d8aEP/vBbG6ayj2dlHV4LoO/NwhmZ4GEuViaKIXu7/vDWIjtbZoHMAvLuK8MMSVArbO0t37/tte3ts66PXyTytjW9mb7svGBhN+zFWg5bWgdHMabIJcuzb+/4YQOduWQ7YpA9Fk4qD1wn7VJcmoCNEi9RPS4B8CYCbFOYaJ1sVuqoAFhGwFZ41Ki6hpUS1afXeuy8q8C21GU/WGBb1HarBQDubbt27Xr/ay5+jc79jl69vocb4CadQeiRyPo9ij41ZfV48dkvfwcckr4k/ZRAFWydfvdVQSc2G4AyWBdlD9PfE91IGVb8TwBe5FUlE+JJMjcCtvwi0+0Szst1onY3Wj1ciiDspgNbnFQkCfxbzulT9hH0NAc0ML2ySfup1smkEoyAIHpZTbUrKXEH1JlsmOG9kA9XeVv9J5IEbJP2Wj+VEGDs/9Z1BPDiu0gQrDc5a+uxZvV5JIWIpnbuovnh6S1bw+O/QzQuYVe1PQSptWBz62rrwj6wtOuefjr05hXgO+iX65OrDjMRanDevLmhEckcOqHP3bVzVxjqgz4X9fNkF85yq9YWD0seywgR+LsB56pDvQlum2trEL4wFxqaG0LzrOYwe9XSf1ty0qo1F1566dbEzZt9nWYWwHuBkRMYQYGRFKi7pf6WOtxsySyQWeAwWWA8YOsoUN538ozG+suf/fp7iFt7fjG4U5BZDGxjhifG0emnZUivVrw8yOZQUzs2eCxloTHAmb2uysPzB3MF0usQb43BdTHMTmpjRVJgTJQNHUaNRESdKSiAzmo2sSygRxCGNkJRkHxVYDsJ20H3OF5nKSx1lA1A1g19p2N/xxUXXXQRGdJKArh0BiGD24iVYcGYbWjLwfQAP/aPnvcnj8H8xyrrx2vBaXF69CtMc0cylx5E0RGMJSRQSoI8j2TgQJcgkqynui15GLlCXC6RFgzoOSvr/UJBskdP0AGp62o1DBjAmcgi9Pq7zjqOvWuyG9HLKrCVfsawXtIFFdjyu8SlpSwBwFb0tmRvuZ37CGNrzC3BsByugJyJG5LyGSlT+r0CWzmW4NfubxVVaEVOOPXEsPiopWHHth3h4Qd+J3YgmAVhKtKBegBaSAKQiGEgbHp6W9jVSdkTW61PCZEqYP+WltpwKsKDHX/ccaEBwHYb4t3ed/cD4cDuA5pW2O4uccQjYMbf1NhqvGDqbXEurLWA8Y0YBTQJmK4NjQC2LXOaw4xjFof5Jx7bN2PZsi9VNzVdef6FF2ZgaCpuwCNQBvolb0TKnVZLN6igkINHwBzZKTMLHHYLjIdVHHe5trbmmk9cs/j5L3ghgUlJWqsgHM6oJqUzpjV407QjnSVfUGRqC6IDGFejr7rkEgO2wtMIvZO6aAnxj/G3QjCQPLj4rEU1SDnPQQJb1tDYqgJgm1JF1WsaiDVmjhWaOLClJXSqN3WRIA/jdZdCq5UoC3hm6MZtT2/7yMVvvHiDndAp5WLDlb4oU3yrpDiDMLED2ZZ9kz3Vi8566Vm1NXV3i9V4bQyVihRBmFIHtsaoGmp0HayAUdmmduchOiEeL5Gm1QYeymAmzGaAVAc9LAkgTNGsFOt6XI1PqyHA2KdcfuDaUU3XG0tsNCICB60WFcHOqxnGwGAyBIH1GEZGIPhmXekISqBLre0wBrCe4lYyjTFGmBxG5hk1JWjlsYwPK0BXox5wu/Zx/V8EjMkS85FgnWrFqqPDyhNWhT1gVh+89wG7BgC1YF+ZxKIW8gMytZT8boeulhKEAf5B7puPEJyX2timhtqwcEF7eNELzwonnXCCJIrZ+tSO8OMf/TJseHKztMVj+FKOQac8B7fuUFYLqIuoCJAnDGGFQxnO31BfC+dYRH2Z1RRmHrs4LFh9Yphz9MpQ1dLaXVVXf+3AyNDV559//qT732T7bXbc1FgAfZVZyxg9gVnM2C2PeMjBqWlZVkpmgcq2wFhIxX9zkkjIm5/c9vMPNDc1XT4W4og9qOX1U2SB0cCWL+8Zs9qjkF5R9AM70l+pBF5J0Cwe4vbyHF2f9KYNGWD0SsUTvekt0pdkOhhnGWm/+LRq8W8xakuAFSsjOo9Uw6ZipZKUcmhtHewn5RdC1BZb2DScvjkJcuU8ZeHTIoyZorGNndRiqcMEuvsA5CZf27Jxy8de/7bXb5OGxp3lSAJchvAhe7vC2kKdHONV9k2gbbLreWe87ItwWnqnmJvMn8gQFEwywYCytK5/VUbXrzWZQunbioqjgY79ab3eUZwyos6QRriWwJAbRYKAfwRd5jzG+rgkgr9VA8lxpOp6UamLMb0EZ4qDrRzWyGUNPqgSZpJXkSdFfSRLGKok3+O6Edh6ogamyCUbK7pasq8+O6Enl7rTOU6DIWgfi9LiClsraFfbbb85sJ23eEE46fSTw95dexDSC6DWrgEHFXDkg7QATlwAqDzPrr2diFm7J+QtY1oOhbEtBLXNtdVhVkt9WLJoZjj3hWeHYwBsc43NYcf2jvDz2+8EC/wIZpc6FcyKldl+ZWlFtwVNNTW2EteWZWIgQGDLtbGuRoBty+ymMPvYZWHhqSeH2StXhvr2GeD5ciE/MLBvYGDwU119fZ+58MILM2/7id6AFbI/+iljap+FdQHWIxZysELMkVUjs8Aht8B4wNYRmDyj586dW/Pd/7r5CbzweIOWsRTjEx5SCPf4cm2f2SYv/T274bSR0IP6CQqBbQxAPYd9ekX0PMU1ECIpsUwVsPVaxbVLwmHdWhawFfv4nuqB7cCmGNhKUyxpQkGjisC7njxRh0oAttZMtLAPCTe+su7Rdf/01r95K6dfKwXgMgg7g7FTh0sfJfd2LhvFn3f6S7ugr20WVpQkLYEiwSyvBz99ij/BtBen1k2CW7l77NqqNECBrejYI32rXmpnMzmJLwMlYRKJrwl0k+d21pagV6fQRdSQCG3CKXuZwsfpPEGDnR1Fcxpe+5YAX5ynyh3FkuBTlAoqGdBsY2BtwdwOGLhlN+fxnvpW5QTSYAG3IlSQTzqUxRIEbaiHPtMhYevM9nAGIiD0dPeGe375GzmvDyj4nMkh7FctZE+UAjC72BaA1K6ePgGj4uiFnWvR0BbMIs2qz4W5bfVhztzWcBK0uitPOTk0traHffu6wm+Q2OFBhAzbtnkH2Ge1r0aI0AtAu3FQwHJr0Bg6k9UC2NbiGtTieyNAc3NzXWiBxnbuCSvCkuecZsC2PVSjbnlkPMPoL/T3D3b09+f/6WUXvuKawqdX9td0sgD6IZPFMIJCO9bDHnJwOtkqq2tmgYOxQDnANgrxddM3/+f8xQsXfb/8ExbDytH8JuUHubqcyA88o1hh+TqF6oAxWWGG1IpZw+JapQPbYrZSy0sD4HF55TC2hSXoX8WtnQywTbZcsam+yKVsvq2TAwFj1sQDvcQidagEYDu6fr35gfzn7n3w3qsuu+wyeg0mTVp8gUo3sPzOWdaeeBktx450BmnGStaM3s4bxjv4Bade8Mbqmqr/ow5XGlaKFJ541wvAVVbSEwN4ec7aKmProNMvWIK5dWAr3vs0B8Gt6q3Vnyx2xnK2U0AXe470Ez93zBSzruLw5EBbdvUICQpstV9bTF3+bs5rCjn595ACaAO1qgGW6inDKokamLSBjmOWRhfglpID792ulyVj685gHASI1laKUADsgF1tpyC/HhFVzjrv+WKH3/zi1xJZJXZ6Q/vA1tbWQVcroQSHwpat20IHEjEMQxapoDZISK4G7DcD4HJuY12Y3VoX2ue1hhWnHh+OPnl1aACj2gensYd/9yhi4f4+bHpsY+jrhCO8UMua/UxsgFrJYADfc9hYT0CLSuYc2IKxbW4BsAVonnviMWHp6c8Js1ccHRrb20MVZBIDw0xHDGCbxyfWfH5gaz4/9LE/uejCL43X/7LfK9MCuAd4m6zCyrTflCoclpCDlWmNrFaZBQ6NBUpBHN8eaWv5jP7ZbT//WGNT09/JC8gYwIJp8VF1HBvYtrQ2h/qG+tDV1R16exkhRRdlWOKqlQK2rEK0G98pBecvgpVjgrmxgW0xy5w8jZ+lkMY7GGDrr3c9C11iInbMmCl7jUu14pz1ca00CkJx+/XFLyrJslKcF2FH2rpokzu3Kcl6kIuVDSizD2DkM7ffeftn16xZw7SVfnH87MlaHBaAa84gJ6AudAaho/serPeM5e18zil/dCuclC4gIBN9KmUIBmiVwbW/CXQLGFvt00lgq5ZNAl3+ZapO0a4KBNR9BFvpzSDOWExnS5Dp8W6lezlzTHmERzrQMzgrqwke1Kks8uzHd0YwYDuExWX/U8rYLj42UF+LbRLHWUCeAVsBtbpvFcC4ShKGQz/2J2urmclMkuBMr4BZgODEAHaY2lvu53De2Fu2idrZswFqGxobwz2/ujt0Heg0UKvZ3sjU1tSArcU0P1P37sFgeueuXaEfzmwMwybZwtCSRlyrBqytAMBz4dw1u70xzFgwIyw9CeDzuGNC88xZqFcI69ZvCY8/si5semR92AVnsoFeJHRwW2BqiHbgQEE0XLADpQgEuGRrQdYiugLO01wb2hbODPNPPi4cdcYZYdayZaGxDVIEsMXMejYIJzuAWbUDwG1//wDqm9/Q1zdw5cV/8adfPci7Ljv8CFkA/YROZSdjPc5ubg85mD9CVcpOm1ngGWOBsYCtIyOdncSj9le3//rneDGQvSoT2MqeRcbSUzaAWWlGrNp+5Gjv7Oyy15TumgZsvZBkhceGU0XAbsxLNjlg63XhZzGwTYY881PHZ4nr5t9iKFxYUff1LnYaMkvp9G9R26LwXpz/jjDHRIFtcaExiI6uhYwqUhBvGbdH8cAo0kvasQBiO/sG+q6+7Ru3ffmq64KyF6QAACAASURBVK6ivrUUwD0s4Nb6JXEP+z+jKLDxm7EyggIBeMECYAsZLYEjJvaFtSXCUabTkKslB4hlASzAf/apc2HnExdYB3wsx9Mr0MHKA2aZKEBAJVPTUt+aALc2ba8YmH0DAFSALYGfWrgGoxcPSaZZtSwuq4FcDRWHaXaXVOgdq4MvAnQAOBHlC6BVoCqDLwJwRm9QvKsREfB7HoCNwJYAfBjsJOvkfYMJLAh+GedWF5UnxLFuWazFvQXjeta5Z4YZc2aG39//cNjx9I5owCCaWgDVWjiKceUxu/buCx179oB5zWM/6GAZigtNq0cbGgmC0YhmANtZbS1h1uyWMHM+gO2xy8OyVStC64xZANvVYev23eEpANpNj64PTz3+ZOjevQ8RH3QgajoKsacODCBBQNtlJbDFE7UBof3rwdi2LpoVlp5xSlh55pmhfdEigN02aLCVoeYAYIDMNu0A9pnMLQEvozj05fOP9g3kr7jk9a/7Vhm3XLZLBVoAfZ1hwShPWIqVoJYhBxFJZepCDlZgs7MqZRY4pBYYD9hGIb7e/OY3t73zre/itEl0TCkZwFhIgweTMWmDBGEQgdolrFfEv6S3NQ2ijgdFx2JZR59lvNIsjFJK9bxuhw7YqjXTaxB7qRdUzXS5nPVyB6F4fEFwoHE6J7QIfi28sgqyzHaletIYJxGgY1PuSWCr0+i64PtW6As//uXrvvjv3/rWtyQef2KVXXzXCbXnIHZGnUCpiTPIPKy89AXezmef+KIXYgD4CwGMJkWQdorDmLKlXITNlexXfnXBhOp8v7Lx/DBUW/jp8gDATiFBVUfrIbBUg2oAkcCWwJfJEMRS5gsqWNO1p4nYtWRjUQeXIMinSQ9YIWbU4vlkKsfZaLsEhNV0+WK96UwVscTuTCZ1smgHUi+G/yJoU1DrsW1ZX1bWIoaZ7laNolnKjK9F3VSTC7fzE48PRx2zPGxatzGsf2xdBGpFXiFMLcJrIaxXDs+ePfv2AZTuDL39ALUE7qaFrUO7Ga2AGcNqydoipnZre0uYPW8m4uDODouXzQ/LVywLLe0zATxzoeNAd+jYtS9s2/BU2PzIY2H35q0hv79bNcYSMsxsJ3aBwxi2ENjmqpG0AaLbhnqA6Blgg1csDMe+8HlhyeqTQuvceaG2vlGGCgT+TBQhTnaMGsFPAFuyuP14duaxAtyyHQ/09PZ/4B1ve+PNB9Gts0OPoAVwvyZjajMrEQfMTx3BKmWnziwwbS0wFrAtkCH8z7e+9+r5Cxb8x3gtHQsi+ot61mzgAuy4d8++SAuYjANQfI6JA9u0I8aq+eSBrUOSwhIUcI5iUgV+GGrxqWXFMBFac5gWQcgY56Q0QFBNie2OjkZf4rFsXdJK4wFbO7C4NgVnL6qKAB/fljzQwAo3uW2AYNb39vV+7JrPXfN/b7nlFncwS5r9SADcJagi2ZZWrGSVmb3siTOPP28NpsU/ROAnma3MSUwiEaDDyN/uOGbREYSZZXsj/W06sFUzu8YVnzaikggC7EfG1jrzKQDXnLVEFpDsMpT7GXB2pzCtr4JbSeEbUcgKfglsRR5s8gD3MZMIZtLnycqSucVOXhcL9eV1EtaV2xjuC8BW9bYAtqynrQrMlY2l/JYsK+2m2cjwG4u3+6Z99sxwxjlnh/14ntx35z3RYIF1d7Y2B80q186e7rB123akzO2Ta5AjW8v9UFY92lyHBtWDTq0DEKZet3UGkjIsnBsWLZ0f5i+eGZYsXRTaWmeEfjC2HZ09obu7P+zZsSdsfXJD2PbE+nAA8XKHe0G8ceyISjI5g+if8X8mZ6jF9xqG/IIMob4JCRrmtkGCsDqc8ILnhVlLlkKGQH1tzkA+2XYy1Apuhb02W/EzDwkF/RIQPSH0AKT35Qfv7RvM//273vqmO8Z7Tme/V6YF0O85G+QxtXfiO0MOjp+pqDKbk9Uqs8ARsUAasHVUKMQLVplJ++ltv7imqanx7ePVcjyIOANMLb2R98Fhg4wtFz0mDaCxChYnM+XEBVioAEYqSEhb0s6i+5X+JUFSjyrSjTUa0I0uL7ZNXLskBJffDaj60VFK1VLtiaZpx7syB/k7KlSat47LjjSGtinWSovbe8GS5uQmQDYB1otnBcBire3p6fnIBRde8N9R10mMCxIXcqwLepDGKGgvq0ydHPVyJOX2X/iHf/7Bjh07zyYbWwPtpgNccdoyYEuJglGyqsE1AKlOZShFMGfsJFioZbdpf/zujmGRzazVBJ7O3FJSLQ5ZIg3gakk9bF+/91gFETgIIFRHK7bBr5s8EPA/almFneVPKIOgMJmNT5rC3sJxi6LtiEF2wKpsJFYAW2YkI7AVUMssZRI5Qcl57k9gK1UVMBu5qQm4zYGFfd4fPl/qfdfP7tRnij25qBMmsBXGFislD5u2bJEICLwQDMVVy3Bc/I7iG9AuAtoajBYIehshlZo5Z0ZYvGRBWHrUorBoGQDugnmhqbEldKNO2xHmq7urP+R7BiQBxM6NW8J2MMbdO3Yz1ofJMmAJDgKAdJmCmMCZ5dc25EL9HIBmyBtOedE5Ydnxx4bmGTNCrr5e5RauN8Yfkp1NAC0TWnAgQIDLtMSMB0wHsyFhcPtgQ0oUevODPz3Q3/ve977zrfdOWUfPCjpsFkCf5y11EtYTeWthXYeVTquHJOX3YWtYdqLMAofJAmMB2ygaAuqS+9XP7roTSRR4s425jAVsG5saQ0tzY+jFi6UHYXZ8GRsMlwa2hccnIWK6EKHUeSy/lxVXWM547Z3I3mnnHwVsi04oQG+MSjiwGa+eB/37FALbYj1tBJxKNDQJdH2KHZmtHuzq6f7wy179Mk6/ummPGIOLehHUnrJvz76TP/2Jz1+3G05Jjz/ypDhFEtySCdWoCDbNrzl0YzbXQKwrBQqjFsTREPQ6jgFs+TMBZQLYck5fQa2yoGQBxVDmZCYlKhoV3liBLWUSBGEM/hURu/JbDh5RKjtQoOsPCu5IllcTLCjo9YB7kQObObsJcCsCtgRsnG6PgC3bYFE/NCmDD4HVdtT7nv6Cs8MMzAA9+Jv7wZzuljrLIqwzHcVqoWVFBAScd/NTT4e9kCEIfBf2meAWzClkBbX8RLv4SXmjgGaE+po9b1ZYdvSSsPK4o8DWzg8L580JDXVNYR8kAdsAbA90dmMAkQvdYG/34/y7Nm0JO9ZvCj0IXTjY2xOqAT4pQxBHBdoV56gGW1s3sznMX7UsnHDmaWH5ScfhPHNDA56PBNSE7hIkAs0VeTJlCFgZIUFsxKgSko7Yk11AlkBwa5EmeilPQP26+wduRqiw913+N2+hbjNbppkFcM8kY2oz5ffvsT6Ce3AKvHWnmTGy6mYWmIAFxgO28jw++eST67/0+a904KVF9d2YxZcCjzl4+c5AfElJlwtv5ORyuIBtasUTrJWyQmO3r7iMqQK2Y9ugtMkPJ7D16WevTbEDmECPVB0uf4mfxcIQyktbje86WwFkJZqaLFfADg/FzmD47t63f//7XnXxqzj9Wgxwk1B5rPHBBG6ZsXd97QVvesXMee3fn7dgrrTlqc1PIzvVBtFKMu6Ta1fFqUwiJZjeVrqeIENzILOoAyYNKJuxlYtgwJasqCAj1dPShuKkZeS5ZgOTi2b1ICWqF4HAltm5yGpGoJdAnABcNLgK1gyvK0kq0gXV8NLpUZMWsDrGworzmKI1B7YjCcZWQJsxkZQleLpgNomREViS1kWB7fJjjw5HH39MeApM6aO/f0zZZsHVmjaXLG1OwG1d6Ni9B6G9tstxAmjts04ArQJbaS8HHEwNwQQUaGDrzNawFMB29WknhKNXLgtz8Ayrq2sM++B0trVjX9jX1RNGIHEgC94HcNu5c3fYB8e1vWBw93fsCgM9vWFoIG+aZEgdGutD06yWsACgdhXKXLpieZgzZ05obm0J1agHPetUN+waZQO2ZGkF0OqnsN38ntApS0xg2DMPG/ZK9ASAXUgUevr6v9Uz0PfBD/7dXz82ZR09K+iwWQD3bTKmNh1VmTBm02GrQHaizALTzAKlgG2BvvZzn/nccaefedZ9bBtfHmMtpQDazFkz5GUpulqLWenlFB8TI5BYqzoW3LRXniIdW8oGnAamIkQ0MVzrs8ZlXfY023g9Kx3Yio+u6Sqj6+bANDEYKA1sYxPpPga6BBCp0QW0JGUIAmV00c36V8T+JehsTGX/eN/e3R949V/82f22YzHITXa3sq7XZHY65ahz/grDvy/MWzAnnHTKCaG1tVWm2Dc+uTFs3rxFQBdDSwlbK5nIXMdqswwmSXB5QhWmxzXWbbJjjs/YJqf/ST8q68ewWprNS373eMcCZi18mEAqHd/JNL6HKbPzq/Obrpp8gNdPkzuYcELNZtdSZkNE/mDnE2CryRZISxYCW9XakomUgY+AcK2PBrAjsAWjiQ1tTMLwB89DSK+ucM8ddwvg88xutG8OLCxDCeaYhAFhv7Zs2SrxYCVpAmPZov50EKvHgFvlB7QpQ4IROLMBOCMuUyPCfc1ZNCeciHBcJ5y4KswFO1ybqxdgu31vd9iHJBCMYMCBCvW0g9DX9uw9EDoxeO9E5IVehDLM9/dhH8SxhWa3HfWes3BOmL9sQZiLPjJjRntoRngyyrNEaiHXQtXKYiPWxK6ZAFkbFMi1lLBpFgtY5AnKeNN+ZHDzUQxcgFxIFKDD/Vpn99AVH778HZsn07ezY46sBdA3lqEG1PQzpjZTft+L5wJDD2ZLZoHMAgkLFMM4/zsJbHM3ffM7r1i4cOGNPG4ywJZhvRrxUO/CtB3DexWftDSoi73+px2wLWIu9WU1WlbwTAe2xQy4YlEFtsWMr0AjYatSFgIdHmua4qQ+N7kdL/Xv7tu/74qLXnfRI2buwwpwTznquddWV9W8WyIGADgdBUbuOATfr4eHPWUJTyAsVEcHpszNgUwiIpg8QfFgYUSCSQNbifWqA4KRYcQqiMJ+qae9/hCH1hIRgkgI9J4TiQFZTAHfLpnQsGDC2JIVRfmur/V6e5miIbaylHmNr7fGrMX5+YnwWGRnRT/K6XVoRQXYmsMY6y3CByWzaSGx11nnnyMs511Ia9vd3S2yBIJTtTucssCqtrS0SJmbNm9Wm+NYBbUI/cUoCWgbV5FdGEutbLSy5rx+DUin2z4brC00tscD2C6AFKEeZXdD99rR2Rf2Q1Y1LIMUlEsHNXwOMe4sEyrgt35cc/LX1QDMjc1NEmWhtb05MIZ3C56L9fXIgAZwrQMcuQqWQIWSBBvERWw7Y/qq/pYgVhNd8DsjSCjIFVvKqmHUGDlhQJzMqL8lkwsns4G+Lw0O937k/X//90xlnS3TzAK4R6m9paaf0vANWKm/zVIuT7PrmFX30FkgDdg61ori1976gx/+XVtr+0f0tTK+C1ESmIgEAWwtMwAxtFcak1oK8MUzy+MbwHimaMdSjO0o0IQNOl1q6xQxtsXMpQO84vNPF2BLA41/5Y1xSl6uImmHmpesVMwYihTBDCO/p4FbB7amuVRmS08k8VptEVhMn6ShwW9t27btQ2986xv54FckrUtxd0vF0eP3uPQ9Tll29q0AOReo45JGRKhDPNRVx68My1culb+hwwXAXRe6oDOPEjgkmVreZabBTSZ10PvPmG0DwKOcx6IWusMWga2yf5qsQTW2ngHMd1dgq/upmMBkEwZuFeTmNN6tOMApsBUAaHVyptcFCDS1DGScsSXQFTmESklk5oaZ04ylJQillz+BLdlIkU4IONaGK2tdFY46dmVYccJKYcHXwY7ys2hjlYVlWK/m5lYMphsRjmtX2AKmvA8DarK1BJEObPlJRloAsUSBIGhXCQPPV4esY81tjYiM0BTmIuTXoiXzwdjOBSBtC/mqurAbkRUOICnDMI+3kGJ83tUR4IIxZixfhv4ixqfDHdP4NkKKwEFOHfS7tXKMySYk3nHcRs0OaJnkZAyiAwPazsGtXFORbyBqgslO5G8y3QS2prmVWLgYQNDBTJzM8v0AtwMwSf8X8kM9n1hz2WVMZZ0t08gC6AuMqX0q1mN4N2P1lN+TiOU4jRqeVTWzQBkWKAVsCxzHfvLD2z/f2Nj0Bi1vYshv5qx2mdLcw+Dlwr7EJSQ93tMAnyKQcnFHYb3KBdBl2KjkLjxH0hvcd2S7VBOYviRr6t9lb5u+jY4U7KaubeWYPUqdKjrHsRcF3n4mgR92QPGnb9aYnMkleRS3K9tXtBQBW99PnsX2Ik+yr3q8DjUcKIlOVLCw1k2ALMCETm8rM+mLplqlLaUI4NuhG7Zu3frRS95+yVZr5CEFuKuXnb0R+s7lnA4X0GeOY9UANk0tjeH4k1aF+QvnCwjbBi3menjRk92LpAcGWB2oaYgwYxHZLGMTDQVFrHdSa+2yEZqCmbpUfqDT+gqOVB7gmcDEjnadyPpJ8gUzo2TskgQHXAFsa7QvEuDSrUxZRqsXrxwZUzG0nkszkxnTngBnpCV57ZiFjCyjZiIzYAvwxXqIFte6vssQmsDSPg9sLUBZ+PVPfwW2VE5u0ScAbBGntqW5GQCyGfvkw6aNm8J+ZiDDP0YkqCWwZbIGDjzMeUwjQGiM4RzAZzU0ufUAoM3Q17ZDD9sM1ra1uR4sK2LOts0MTc0zwhDkCAS2nXDUGjGttOiSDdjWUbeLvwmcaxE+jL8xhq4Aa8gOBNQS7Mr1RXxbgOEoLJwb1Z6WDvCd9aZNNK2wsu9iu4RcQcCvMPQmTzBWl6wtHdD42Y/PHgLc/v6uvvzQtUOdQ1etWfPuA8W3b/Z3ZVsAfaMdNTwT6wKsTN9J9nZ9Zdc6q11mgUNrgbGArTO2tT//2Z234MH7/IlWhVEQmhEFoQcOFD3QojneKBcaF1NrEzn/4QK2cVuSIDHpKlVY61JgmHuNcnVVtKt4rAyjxeBGdy7UZRbWIwlsBYAIsElCxCJgLo5AUwxsrXnRAMea6ZpbB6lJ9ltAmINXAUxxL+G36BgBxrGr4+DgwJfWP7nxyre/++2MDWk+52KT4m5WekRSRgc8aelZwDlkamNgS8AkoIXSWnyfjbirJ55yIqakob8FINmyYUvYsgmx2HkdDMRq0gYiSJ3m9p6g4MeAqFwOBfjRtZOvYhj5cGA7NMwECPqTR0iwP+R4DsTcwUzT5aosQcEftbYAZwBlorEFuFWnsbifObj1VLtyMl+kLh5qLNb4StQEgmyCMNGGEnQNKFAD2OfCaAZchE1Fnc564XNDKwbL9915L2aA9ss2/siQXhIBgc5ZYGpp1x07OsJ2JGJgCDHG360DkJQMYyZHkCgFZJ4JPq19dWBTqxByq30W0twumYcYtrNDS1OtZA4bGOwH09oI0NseBmvA2Pb0h54hOKubDlnYX9aDoJXngb0E2NbRiY1hxyhX0N8JsHMAvKyPn1+SdWg8OJvgUft6v/ZBnKo4VKesSS1sxXYCXEoRXEvtv8l2iRus4cHysAnBLZhbGQB09+chG85fXdNT/89r1rwjm9Yu416vpF1wry5Cfc7A2oZ1L1bGv82Y+Eq6SFldDpsFxgO21PDkfnn7r+8CW3P8RGpFhodREPjg3YOpV1/SAGepcg8G2KZxlgdT3ug62gt31A/KMRdLI8ppfwGwdVArV6g8rFUYIaHY4ShZ0aS2srgBxhBHrbByzJM+uXcxFNa3cFFdUxhbo18TRVlJdqhfuzRgq6eIZQypwBbFKVsYA1tDCD0IZv+FBx554Or3vOc97JRTCnBPWHrmakCSh3lWTVPr+lTXfhIUavQAgtXFyxeHY49bhXBU9XAw6g/rET1hx7YOcxajh78xtabHlUGRMbjRmCfF5KI1oI34W4EMwcCua1yd8TZg65IO0dQaaPWwWGRrXVpRBb2oKiUKhUnSLm4jq0wNtV1h0U27HIFMrjiEoTWsp4AzsrZgaY1RFAcofGe2NPUz1UgFi5cvDSc856SwDWlsH3lwrdRHtLUAirQ1ASSdsPjs6cJAevv2HaEXnzUwOkEm09sKqDVgy3oS2FKSEDGp8AWoampA/NrZYeUxS8Ly5QtCc1M9AGEezO8BRBxATWoaIUWoDfvB1qKWAmxV22usr0Rj4DkJcCFpgI5WIjQIW6zgVkBvciXAtQGRpF82aYqYkKayWQsdrFDBYbplt59FU6AsQRnbmJ0XcCtRFDQahafpHcC+fYN0LMurRIGRFPL9u/v6Bj7xkfe9+9MTed5n+1aGBfDcW4WaMMEDww/SSTA15Xdl1DarRWaBQ2OBsYCtpjjHLNkvb7/rt3hZrCh29hmrSm1trfJAp66WU1++JIHteOVNFogK18UXgOkEk/Wc2gCAZDoTyMKkBNw0VvTdUkKBqG7GXMYT+7ZhnD5QzNhGNi8Al2rVYvypeauMIeJ7lQeT+CNI49+lgG1xQcV1LAvY2kEJYCvg1TcXncNZW+k/xuAK6yuXolC8kkZ0Yw9gkqFr77z3jmvXrFnD9JXe1aJTJppR3qgCB6xacspz4Qp0lwA8Z2kt6oECH2NkDfRWC7DJhZWrViCU1AqxeVdnV3j8Uehv8anRECzcFoGkMXlJ4BPfQ6yxIPpo1eAHkMVI0oM44YEws0L7ad9lGarRVO0rF+mjBlLJbEbJDjCdTkeoiFm2XpOUUsh3uQ5amAJb73f2nV2aLLFJDjSmLZMOwHkMenwBZ0MAjqJFYKKImvCCP/4DscGdP7lD2F0CWNaRuliynSIxgIyAzxsOpg/spwSBKWwJavmJ7GIEwdTiCqhlbFkFtY3QQYtEADNMVWB958yfHY49fkVYsmROaAKL29fXF/bsPxC6+sF4VhPY1oRegklCdBl4KKgluJWEEGS5TY5QW1cIYgVESxgyTd4h8ghjed0BTsLA2b2jfVtuRiXZ8UUYdtFKqz1VpmAxijlQieQIPMAZXW5HfzAd7oDocMlE5yWKguhwmeBBAG7+qf780Mc+cvm7vjzOYyf7ucIsgP6AEBuiv2XiGC5M+c2siIyFmy2ZBZ7xFki+9/2762sJao2xvWstXiILxwOibi2PWcsYip0IxxMdJ+/KmEUbr7wIUaSCo9LXRuKtTgLYlpq6T06F+1m1SqMxD/dVfqk0N10K2EalxQ2X08lLLQ2hmT29fkmNbcxkFjO36cMFATU8l5zH6p5oHqIVjXIeUxMUAkl/GY995wiqGb1LCWDrlo5Aq9NWZhO+1H2JbDHurStho3bl+wc+9eNv3/aFq667iilxDwrgHr/gOS8CILmdms04koACU2VaaUR1FvI4tgRnBMKNYG2PRUzWhYsglcM+uxDsfx1StA4ASAnIkbvS2FDazlk90bkmO4cCIAes/E4WT0N9mQOS20+IXQVG4lUvzmV6EST4l92rCmwVsHFFnC+pj07lq2RCqmPHKLBlKbGc2c8T9Rc2geemxlYYW02nK3FsydaKQxlWakdR7soTjgkrELf2id8/IXFrRXMr8g4FkJzyZ50lpCAG07uQIIHlSh1ZdwJIYUUJcDWOLR9wjIpQD7BeD2BLGUIddND1iFYwf/G8cOwJR4dZcHzlfYVYyeEAoi/0gbEdqK4PgzhnXm4T0ZcosOV1FkcxZWxFnyyyAzq00XbU3JoMQbS4mriDumA5hvVDmaJxdudBsz3lJyIrkUvLgUh87RzcCosrgFdXAbe8noyWYNfYyHxhbbmPZDDDoCcKEcbYtwC4eVmhw+0bWI9INmuu/MD/vmHcWyrboaIsgGveggpRnsDU38xa9iDu4ycqqpJZZTILHAILlANsa3/1i9+sA2Mzczwg6vWbMbNNptn24OXiDiv8TULalDmtHrfVpuVSG58CjvhSNngiHKQcbo5GhlxK2XEsTaofU8iQpZ9fGFv5KR2NTiWwTWvL6Otk8T+NNUsD5A5s1e3dFkG5JqoowdgeCmCbBpj9he5TsgRSzjwrc6t/u3yBICNyJEu94MaIkeQcDtvAWn3i//zn9dfdcMMNeesmyRGAX+j0C27lH7/w9AsAZm5Vsk0HBypH0MQBIpmV6WplGKnDlbS7wvCqbKF9RisczI7HZ5uw5E9t2RY2b9iMhKwcDKijkTK2emW8f/v5ZGsC2Apja4xdBGwF4LKTEhxp6K1iYCtN0lOqdIJAUHSoBGFkSQnkdPrcga04cfnAlQdygOljBQPQ0SBRxjYEXcYeC9CisxM0tgBUAnIpSUDdausbwrl/dC5CBebDXT+9UwG3NJz2VLazHmxrHRy/Oru6wvYduyQKAvehgxvBIm1GhzEmZFD2VsFtBGwZdgsyhHqE5GqZ1RoWLp4fVh67IjQhLFcPQnbthp63G3KRflR5GOG+hnDtBuVC23WUOvFPBdcEsASyop8lcMVJycxSKiF6W24XDa46ltVhH9czU65A+4rjoIUBS3ZhXjpJcMFLJMBfpQoKapW1FWBr11YGDuJs5qs6FCqrS+017I3vA0DLZHCpvyV7S6a/h2HLwOJCwvNIX3/fFR/7x3f/V6nnZ7a9Mi2AfjEPNaODGRM9MDvSPbg3dlRmbbNaZRY4eAsUA1uj6oQfcsa29s5f3gPPlsD0fuMulB+0tbUgbW4v4kvGPgjyIjLwwTdSEc9Xslzhdw0kFO6kuMMIpgIIqdCMwEY+ImBr7+rS5ypgvtJ348sjdrQqjXO0XunANn1rAm7ypS+tSyylDkqpZhqwjeuSxGvxwREbGtnAzm51YWWKncfk6AgsW1ll2FAvT4rtkpuKmWC7eApiBRXp9TeHKAIKB2522SP61VuZtGnUr8SuCkoA7jf29fRfee0XP3PDLbfc4vrbsgHucfNP+xM4WH3HIxcoKFHQKmdhIgOCFgE/BmrpZCYsrutp9XPhooXhmONWSvxn6k03IE3r04iioODJgLP1bT1fcrikQF/toYMsdRhTEOuDg3gaO5Yi+CBBhAR27SW0l7VDwC29/AHahIl2qYX1T2d3o3tEyoild7hs5gAAIABJREFUCNENqzoJuYwS9svANxlbOpJphASyicPh+FNOCouWLgoP3/dQ2I3MXjpQ1R5NoN0AsNjUUCvM7hakzd1HCQIBLH5nn2VEWIl4gLpSgsBxgYT8wpd6amEl7S6kCA250Agg2z53FpzG5oZFyxaFOjjAdgMk74ejWBcAHvjzMAy5A0N8DdtgBAkZFdCzbJEjqJOaOtxRA5wAsiJPULY20tgKOFdHMo3agFBhwtIrC6zPP22DdEYHsfZdTanSD3cqi665gFoFvtoHTIFirK5EVogAsWU2E40z7I9BB8FunuAWTmYaLqz/fjibfeBj//i3Pyj5IM1+qEgLoI+sRMWov23Ayigx96HPUoqVLZkFnlEWGAvYigyB652/vNeym5QGcm6VWcjMw+fw7t278bT14pNITV8AadP76Zb1qdZiZOfAVutU+GspMKwvgORSDktb+oqPZY/CGikgLj5/GlodBWmnuMMlcZqePzZJcrgR7yd7pURF0IqlAOUxQLg4Dindmr4kTDrqWplEgmwe4kRFx2MG3RbTG1p/KK6ZgF9rbPK6F4JCGds91tPT85FL3/u3/7V27VovZlyAe+z8U/8cwO9G0Z+ilIitNdZNgY8ydAJ4ydYKa0sG1BzDIoCkcWOXHbU0HHX0cmH/GFnkicfXhwNgD23uXy1i4EcHj7EBhcEzNttDfOm4wHWZdgUF5KgzUsT82cBCiVEFWF5vYSQJbAnSvb7YT9UR6njmYD4annm1pAI6ZmBEBI+KID3JUupKDFZJ1DCICASN4bl/8FzE/t0fHvjNfZFNCVlZJ8oHGhHFACkoELN2T9jZsUeiAmg9IgWHMLcSEcGujUoTFNjWQybARAm1iC3bhAQKM+bNDrPnIysYkjHkwBbnUeX90J320DGL0SIMdI6YHERjEVNSIgENNB2x2AvbGNJL5BK0mTqUqRzB2FxmljOHNnE4MwZasqgR2Dp4ZopfGzTSlMq+6vVTYEsZiTLw7jjmsgQ3uTO6Othx9jYBeu36q75Z4+MS2FKmoFIFTfbQz0gK+fxd+YGh93z48ncxlXW2TBMLoA9wvLca6wl2ezyOT+pvOVOVLZkFnhEWKAVso+QMbW1ttbfe/DOiVHkZjbXQu5sZdbq7O5FlCZJF2d2AWgFeGwPYjDqBA+HiHwqBorzgbReZPE9leacG2DprmwRe4wFkB7ZaRWeaJ2KHQ9fftB3F17ZoWxLYOivrx6WxryWqGzPe47cnGd9We5Kykg5s3f5aDWezCt0Doy7I4xMDqsLvyj7Gi7GsI8MPdvf1rrng5X9EdmpcgHv8gtPeBJBzfTRNHjG2xsYasyqAx0ALvwsQNo96Z/2STC/B2yroSxctXijocQ8A3JNPbAi9fb0Roye1Z/mJVkQAlkye6Syd8FY7EgkpGNLwUDGwjYc4cYlebw2RpeG/iOREW6qnl1UkChHTWHSdmbRAgLUmL1DG1kYm4r1PtpZgSr33Tzp9dZiFCAX3/OIuAHtNaOExdQUggj3msnvPntCxswNsLy+ThsuSDGr8C98d2NbKdkoRKEPQ7GMNjKYAB68GRD9ondUGQDs3NEFO1TxzZqgGsO1H3+oic8kSLbyYjSjMccwGKjJwURtQViCrSBA0IoKuDmypWVawS1mCxwoWEGxShSgKhQ0epCHWDXW8osy1X0MZlPC6kqWVzH7uTOYxn02uwP3E6UxmKYyxdQc0C/tmkgZKQfR6KLj1jGZkb/OIqAD29if4vHzNe//m3vHv6GyPSrEAng2cgX0O1qOw0qmM4JZOZtmSWWDaW6BMYPsTANvxF7K1fJnu2+vpq+3BKy+9ibC0yXONDWyjPcmI+nns8a+/eRP182AZ2yQwmwiw9XNzOjpeCtW25bPY41+L8fZQYm+swcr4wNYB8UgJYJscbIxXn7Tf04CtgDWKCMHYunxC21IIbAnxpH6JHj4esI1/V1DiYBeA4b4De/f+w8svejnZqWKAG13Q4+af+hawb1+V2hBACegzjW0BE+uaWstORnZOHPzNycyYXZ+Gdla0FYPGY09YFWYixirbtRXT7pQoEAB63y+2owKdOKWtXna1lYBdyfCl0RCU4VVHI+nnshe4UBROU0ocWzKRxt4WAFsDjKxr5FRWMFiwmiWBrVgS52IKXdpMps09kQTDZNWH0889M+yEBGPtbx9W9tKcssh0c2XF94DB3tnRIQxvrgrT+PxHe+NcIlXFXu5AZn5v4v/GKAr1aFN9LcAtpAzNcBybvWBuaJs7J1RBa1uNFRkbJAJCP0oZ4jNMdCDKYsvMQ3SN9W/XV4v0QQYs2pc0SYNFQxCgq6w3QS1lCc7eK9CNpQk+AIpGDQU3FVvmINWcP3FtFeDqdVWpjm2L/k4MYuR4S3csYDcGv3RWUyc0DxNG3S0BrmY1k2QPBLfQ4/bmB7/Xl+97/0cv/5uHJ3OvZ8ccGQvges/Cmc/COgcrZQn3497ZcmRqk501s8DUWKBMYPsjA7axlq8YhJFVora2q6sbTh6ajMHeAKlEb/kgbrQUwQFV8r2ZfN6PhmuFEGuigHRqTC2IwlazTZGAonybxDVyDmeidSyMeVvG0ah6sdObtobgMQnWC8tyvXO8tfS+xbVIBbby8o2BrVhVKjJat+3A183sSQeE60p0HpcilAK22pUFKP9s7779H3jlqy8gOzUK4B49a/VbkDb1qxqmi4e4xraYsVXAq05kKkWQEFoR+FXJQgGwlSro1PTc+XPFsYkJUOjVvmn95vD01m2pF7EA2ArY0XtBQCyBrcxjK6j1kFFRdA2zLWPF8jiCNAI6AkLRBTN+ljO2rJsxtklnuFGVMhmCAGetnK3Krqqjk2pBVwLEz0Zb773jN6Ebuln2NepZJb0vwCH3PYAQXB2794gGVBhSgFDRu8qYBlERUKYwtthGja1UGYUzpq0D2wawtY1IwtCOhBnzoeVtWTA/DCItbx8dxHDMENLjcpXsbHKN9Np6gyUKRCQZUEmJSjd4Yk3UodpZBbYaXYJ6WgW3Eq2BERIittbYXQPFMkBy+Y5JKbQeCmxFbsIBgVxIc881gCqd1CIoaJg3vV8ippbXwQAtf3QwLBpd6RoaVkx1uBo5g05lwuJatrh+gN1+SBT6oEGGROEbg/mhD6x537ueLOOpku1SIRbA/bgcVSGD24yVSWyY4IGOZtmSWWDaWWDKgO1MJGPgS3oPXjJpSHYyoE2tWbnA1ttULENIm26PAWgS2CXNP5pNHt2beGzhMZMHtmkAcwzQOQlge0gY2zRgW6g+iMzmU7OxydRaxderUGPLwwsZW+2GsW4UL/ebd+7Y/YHXXPwK5mePAO6KWavfDK3mv2kF6OyjobyiRAvGxGogfm636AgShzUGrgpwiYkIipQ5dkbWQQ6PX7h0oehv6XXfC899ZFYLuyFTiKen1eGIYESYUdZKAI9SsKq7xUYRaxrzx/gL3CjjFT+GDlEAdmZIsoyC68x731lcGSsYiJQMZKQvRy3OLMb6Wo9zW2X1ImvLeLRnveDssBfteeA394tcgdUSRzYAQ9qFERA6OnYhJFVegaSxpw5sxWkM5xd8KUwyncecwR2WTGR1+LER2tqW1vowG05jC1YsD3Vz5oVepLjtZGxXmqK6VnS1PvCQAQYbi20Eu8nt7tjn9SHDzEpIVASRPqgUgX/nwBRHDK1IO1RmEUkRRMpgA6CE3lYlJ/4cUHZWQGnC1jJwkYGMAlldDdjyapvshGoUE+kqqJVVZ9o8oo18t77j4FYTPjjAhUwDBTE8GHW41OBCI319X3/Phz58+d9tnnZvxWdphdE/eLtQe3sSVvrXrMPKFL0MFZYtmQWmjQUmAWxjxsdbCZZK2I7enj7oa7vlpVy8xMA2Bmfj6VLjMtIYV0uOYDv5Ho4yCs9/sBAr/XqWC2yTdWNJpeDj+OB/6oCt1ENQzagrVaKx6YytcjpWThHK1tS4Y4DlcW6T0YwtIx+oBeHHH9Vft41eRgNb3ceZLj/CwaPaQ5kwlxDoATr1rOgyOg+iJA3dtLVj+4cuvvjVZKdGjpm7+pJczoCtHaNZxmJQpBnJlHWUaXtJU2vAVvSZFm3ANJoKihUgOjOojLDm9soB1B59zFFh8ZJFsm0fpuWfeGx96O7sEZDCS6CJFxLAltoCHMsp5kiyIXIFAqE4lq001UDRsDGE3h6J1ct6CDtpCSmY6heHEEDSOWt8YOuMsfYRC3QhcoSjkbRi0ZLF4cF7Hggd2zuE1ZUsaEywAPDX1dMTtkNT241PCeqFIgRwm75X4y4nNLbO2BKUYnsdTAppLSIiANiCsZ0xszksWLokzD5qeRhsbQvdkDQcYBQEgn5NF6f2F4CcBLYqqhVw685k8rtGXhAHO4JxrtjuUQ8IYmM5AsGsxuIVYAvZQm2Uktn0zAmAq/1BO6JLmyToV+J+9rtS2Vnts2Re9XqaFIF/GmMf9RFqbmVn0+XKQCjCvjogEu2uSRYw4GBMXWpv85g9YLpefqceV74j01//8NDH3v/370ifUohup+xLpVgA/aMedWH0BEZRYGaX32N9BH28xJO2Umqe1SOzgFpggsBWWSUu8TMUsTcBagluPW6t7jIa0BTjqDQAPPrCeBUL0bKyouWCpkMDbEt1ItUnkhWL94ghHl4I1pQ0pnfsjjka2B5MR04CWwWhyuSkWdVnQkefj29K/hczSBGfJCaY/LMwqp9XyJhE7V3K4EV9Ub4X1jwJbAs13sqIxuBAgYn2KU5eE5XGYFQZMrthigZtOAdmZoe+vnnL5o9e8bcfPh/s6b8646qfceQA0e2K45WDV4uQ4M5jAo4M8HqcWwO2zhI6gJL62n3GVrcgqcAxxx4TZs6eJUzr9m07w7p1G8MA0qXKVWCc2MhggHbG2Kr9FLmQgQM1GjO21mpn7NyhjbiKwFZZZwtxZeCWdmXdmO2rQO5h9lOnJgOy6s4vZ1E2kX8Py7Fnv+C5IY8wW3f/4jfSJ6nr9Hiv+Xx/eGr79rDvAOQJlEjgn2YXM5At4FUgu8oRcAJxHiPo5SfOV8f0uvjSUAdg21Ad5sybGRavOCq0LVkaehuawl44oXUBqFlN0U7EmZXrqWXFUgSTJLB9cu10cKKaXuwnYFUbL1nGCFwlK5kztBrnViIpWHQESiQ0wYMCYpFeiGRF7c2+yTpID5YT8r/4PtPbxJlcPbeR8hFz61EVlMG3e1hArd3/bLioRFQWomsMduUMEUjWQdIABiQCai0GMWcKmDkOkRR6EQv3C0DAH7/00re5A4b1iOyjUi2AftGOup2NlXFwu7EyPW/GwFfqBcvqFVlgwsDWH6b+juS0IGUIDIje1cm+H4PfNDunTdNP7fXgE7kYmh1eYCvtSUOHxpo5Spo4sJ1aSxWXJgHzi0cfvpO8sFPOnzB3DN5tv4MEtn62iLlN1E1AmC0xsxsbXV7YfhkSA4mYlZWeWgi+pIE+vWzqYAO4yX6dvG6JwUH+8UefuPOzV33uvK4DB2x6WoFOcdgvghplbsnUxkyfOwqpfMHAjOkrVY6gwFenwaX6MSAnqMK/GXAsO5bxb5uaBMxu3Lg5PLX5KTJnag+/xM7EGZ2n2lZKFix5A/azoY4cR2uzfGEtBXQrQJc2GFsZh6YiiDTbWqeJB8QJRlgqBCZWcZU4wbGCS5ctCSuOWRGe/N3jYTu0wx56iuCOIHf37l1h557dwggS5LHl4kxmgFaAp15e1A2srZkL8FEAYS1OVo+NtblhxMDFoKCxBpnG5ocFRx8dmubPD925eqSkGwx9rJXgSJYNptiiLcggz0CuSBEoubD2RrIT1knYeg0BJteTgBSfAlolQgK/KyNL5zKVIHA1oE55AgcR1hfYEB/46IyCM/wJhsIGaPIIMj2zX3gFsWpr7wce9ksHpyZFkIPl5jVnQtvfvAj1eL3XvExJ8MHVNbhI+uDZzSRsGGMSDw10InXvP1cN1X/q3e9+w4FD+zTLSp8qC+AaM3PZ6VhbsWL6JNyL+zkboEyVgbNyptwCBw1sm1uaJYj8XsSZlBeTPPPTENBE615OGanokY/bopMdAWCb0tzRU/9xG2my8aUIE7XhBPe3t12q5csAtn62yPpS0OQZ26g8A18CnO2Fquyi7pHmCBextdIhdb+YtXXGVoGBL/K7IhlCOAOOyqAm+3UJYCv75JGd6ie3/TTc/N8/QHiqLpEdCPiy6WOCHGXgzHFMWE/uoiygygwUMCpwjGULwtqK85AgNsv+lX4LL1pC/e1STGvXwpmzL6x7fF3Yvn2njluMaRMm1i6PgloCH2NUBdMpuEkMEWw6HvUCEFNwbmA3oQGVbbQgG2tLDGx5Qj2pOo/RiUxZQ1/Pev5ZMjV/9+13RgkHRECAfbqgq93ZsRO62l4mLZOLyzgIEh9YgC3/xddbgS1W7CsSCfxaCylhHTZAWouICCG0Q187b8mCMGs59LWz54RusLP78CzLiweaXo9cVW0kRZC22EmizGAObB3QR0kbmJSDNlJnQJEb0G7U00oaXabg5XZ3GNNEDcrgcl/VDsch4mK7K1sb35iKtz0SjQmEXHtr97azuQSuRpjbPWUcbyRFsDGug2EbEOntZ9psvfnkeD75JbyYgWENHafhxgTgCpPLOLgAuIMje8HwXl1T1XvtO97xjjiLT9Rbsi+VaAFc5+NQr1Ow1mHdgJX62+z6VeLFepbXqSxge9vNGu4rmkLEi0Qemzh6NmJMMlvQvr3jD8AjeJkCfNMgql8bmW4cdYy9oUddwLTt5QPbNHA52rkoqtmEuk9cdinQPpYVJnSqye2MF1RBzZLsbQl5lRwRJeIoPK1esqkDtkk2uRDYut1sWtWqEfWEMYBtkrWNgK2AWmfEbNrZQEM5hmU5vdB+3vb9H4Yf3vwjAbvUaQokRV10Gl+n6kWWIKxtrK11cCsASFi7mBFUVlTBseo+lQ2UxYCes4k8x/IVS6FVXSA/M4LA44+tC537uyKmzaeTNQsZQa0yqnTkksl8AzaS35c2EOCPNmD6XEF3MkSZyROERVVNsNP8hcBWr5cwtSifmlc/T1t7Wzjl9FPCto1PhQ2oK7WcIuHAXkiaIaCW4FbSBFt/JRCUM2JfYTLFzrzoHFBQZ6yDIHUeA6jFdr6ZG3IjCPNVHdram8LcpYtD++Ilobq9PVC12wlQS3GhgkeCZnMEJIXK4Y8xtmJr38+uoR5jgxmcWyUFeh0FfNNmlBswBBiZYxnkaOgvxrx1WYIDW0oapB8I42t9xphydV7zwRefyQo6RwFc1lFmMYy1FZPEdvcBjEhUbMQoTobuWMhrZdEVvK/J/eUDErGK63G1LwkHLHIGxsJFNAVsk0/ISvgz5CU7kML3E+/8X6+/tpz7KtvnyFsA1xtDQQG3x9oThw60v0d/izPmHPlqZjV4llugLGD7I0nQoCFffOFDrB5pKFsZ4gsSBEoRxlscXo6agrc7pNTxhwPYjsWWJp014jqWAtalrVAIbJOmj4HZeDY81L/7NVLdXRJo401UhMdjC8TMnL/0+Km63EMDbJPaQJ5FbRsDW/axYo1tKdsVhPuSQZs6IYktjEHlsROZifB9uzo7wy3fvTX89LbbJTWus66RFMHmyVWrmmBBBSQVyxEM/BLMiBSBzlQq4FR4ZdfLASUvIbbyPl0JZywOQmmnHdt3hXVPrEckhX5zGNMdxR2NwAZoRMNlxexf8XWsohOXMbZJz311vDMWV42m9YsGpnF/kF4T0YZa11XHrwrzF84Lv73jbhkcEMwxkUIemb86du0KexEjm8yf1BFl1oORrq9DilvQt71Ie8vupoDaAS730wEbwS8Z23qWiQ31ALZNTbnQhvjbsxctEhnCSGtryONa9OIYvqmVHSfrrsBWwm5xk2D2+IZQFvf/sfeezZVk6ZnYgbflXXf5qq6u7unu6TEcGoU29DcU+rQRUkjfFbGMNVySS8YyQmRoKYnmi7RaRShWWu0H7YobSysGhxSH43u6p32XgakCUPAeuLAXep7XnDyZNy9wLwqowszc7M4CcG/myePynOc853nfN5EkSB2oJlbbXPMVWW4CVA+1K4sXlyRkRmRZBDMzIBNgrH1SJSAGaOOiyPsAazK+yboL4Yyt8e8Za5+9M764yICts7bygmVMv7xwPjwYOCaI9c+lWfWCmKZodVXmQmkCwa4CXvrErY5Bl/ub/81/9V/8L/Xe0dbnJ6sG0K6UJVCeQJkC/XuSvR06Wbls5eZntQYaArZ/8R+/OZcSphw2aWRAozFaZc/PLUY2d7+KdGajgI9kQkshVDENZyD8c8db5cZjZan5IK8pROa5jDnOgTmfvLIca15iTpruN1nyzdZC04861A1Z0fLspyCGYpZjuxWArYEsN96pyUixsUvSzd2j1FCu7bKta35XC559EZZ7VAJG0s8zhg9pASyo6Z8Zj6mgskaO0EjlZtKHvbC0sBT+5I/+NPztN78lOlFnO4WpNb2sehxwFjTR4TqIcZBEgESEg8PZ3TzI0n7rrJ1LNU6dPh3uQX/bD/kQgeGTkfEwggAPtGDnwYAG0XgwaW4CEHP4FIstLrdcimCGT1leCCJd53owsBU4RvYV5f+l/+yXQgUL5Y9++L48q5s+ZKEPXl1eDfOILra5uY6yVxECF9HC4BKsGwEUujq6wyY8GMzPLYdtAGCRfUS2GHXNemKdicZW2druDrC19Igw2INIY5fD6Vevhh7IEHYH4BsYoHabzKdgWP5Doay7XnPvFPpdHAsE2Gqdu0RAelECOhX7Jp9ZVDJhbHGdRCCzKGUqP6B3CfWHG7/nM6w/ZPWd7i5IQ7LE1lYGcgWXZoyt1zkvcr26srXZ+Kjf2Zti76CtH3W8FuzqqUbsawDXgC0BbwS5zvDqeiZ1GaZ+csNjaHT/2X/59//zf93I+9W65uXXANqfhmU0MKOhGXW3P0D/n335OWvl4Ge5BhoCtn/+H/8qB2ylwjDAMtJYajR2UEU6sC1ep4NjLbrxSSMFkynuLMGlOtrWwOQM2Or9GazJtkjzaKseO5flxdmRfGnqyQ3SsugdZWju+dnNg9qg4e8LjK1MeaUANL9oSNMvBbb1VjD7gFtlj2XGjS2XY2wN2BIYOYgrBbZS7fogyYYBF99e168VZUYWV7b5M3DWDGurdeH9UetpdnoWAPdPwve//QMpT7R0NxAkYCVqKo39NPZWtbfE3vZTsuWMYCqZMKmCNUaUEwjIgInzq1fCndegJwUw3NzckvC8z8YnZauaAFb6ePIa6f26tawwSbfSI2iz0LAqpzDdbW7lkPHJFh9OchZr1lxHXUZghNcRlGHo84dhBtHGyEXTkwGN8Va4K1ShSGAnnD3TE65cOov898BnKj0mBFyzFqan5iFXqBhINu8Wyr8bsDUDLqTbDXBM/7X9Z08JqB185ZXQCeC/C9HtLgpPOynpKrbVv6eh4TI22vqrglhbAAsj64ugjKmVRZK0q4FipmlyBAJYMtKuqU21thK9THS2NCCjREH/Vl2zGhj6zwxQMzte+cK5Wy/Q/hebRbS3zqhmi0Z9zZL3jG3j/cjaSf9Eenwt4/cGitmDbJBmf+JTxJWYpGsJ8Ye4E1PjNA/3zI+3t6pw4bb1yezSyq/9k3/wX/+75I7Wrye4BtBn6BqMLsJ6cT7BSQ8Kak3eOlo18IJroCFg+2emsZXhzIABDcYG4GKI2lqGstz/8MeUoxoFg2XIRsFjji32QbMc1Vo2is/J0s4GV70mY9XyJWgGwJTLGPJVWwtsy2oszXc9BFh7X70yHGVfajpSmTxc2TIe2YSqf6ccr4PMevl1rwe5CTdlcJFAfE7C3qqLztp+pc9TQKLAMP1JcOZBHDKw6ACymX6RX2QZsLB8T09Nhz/+d38cPnjvAwNMDlJ8u5p/kygkc2v6TgNEhrGMlMw0lg5uNEqVuy/L+riUW8CEAurrN2+IBpf1ugq/tw8/e4j32XZfHNhaw1F7G4GtsZLKNoNRpCEZ84nP1cgJn9vDbElgiwjvDCLWjGZeCo6q4ctfewfRC0+F9771XYmG1U4dJvTJa5BzwGUUQPgG2NlquPnq+XD31jU8uzPMQS+8TP/ZK5WwiJ2jFYDgTbC2WQQugkll38nWsm1pbAbbNLC1fWEQ4XNPvfoqfl4KbRjTdlAvBLZuFBZ9HBsLrHWcjYPq21aqO7K1KWPLCGfRv23C6Aoja75qhZkVQzKytApe5W/zkJBqrfm9BqJw5pYPVpDrIFuM5ZJ+H9sgAbYiC7BFl49f6c+4rjGQq+tc1dDqPwpsvT/5Oy4tie/lmfL+sWVV46zcLj/XHIn7MP5HA0L+vdsmzPsq2nMGOxzTs/PvPZsY/9V/+7//wZ/WGxtan5+cGkD/4GryHTuZsc9xfoh+iReydbRq4MXVQNPAViAABtWzcPHFnwvziw3kVg0uaplUvTUDtmXg9jDAtn6WXiywzcpTjxkuz2n9uiq7/qQD21xpDCgZFsiKU9b09m0ZsE3dfbFrNQRsk8VQBLfWn71fKx+pYER5xkw3mV3TQJfXnp30+VSvqqCTAGHi6Xj44z/6s/DJR5+YSyjT2gpQVFdPEkaWGk+TLbTB6kqIZWF5s+1vZ5kJlNKj2D8SAjx09/QgwMOdcPkKQ8XDlw+CITx6+Disr6qxc3xfFNHEZB28ESBrkAnzu2quzCKwjYZNeqtwhhYwQl1K6SKChlS/8J/+fJibmgnDYGyhFKDX/7CyuBh24XqLnN8uFtBdQLvXr5wL16++IhrYpbX1sEHQi+hjq/Bry9C71PzT+l5kFbLRoCDQ/ct2w+d2Z29PGDh7JgxevoTzcug5PRC2UZZtqU9nVk2OwmzaaiJbBHm9W7l4T9RjuxyB6WhgCa0vZ9rN0wGAuTzL5AkEsh3wkCAGZRHYugGh3UNvCpJOxpi75lZAty3UNJ8KQP0/B5YCIq3Z7M1AAAAgAElEQVRxM3DrTZvpYhW8isfomr4Qu4MDXqYpl2u/1hv8DXAdbvZ30pUMLLN9oZOubIUVANtpLLCeTUyGJ8OjYWxo9Lur8wu/PDTx42/lOnbrjxNZA+gD/cgYw/Pexknjmx+jbz48kZltZeqnsgYaArZ//id/Fb0icPDkQHz+wjmLNKYTYH1w5Ra7HO90O7Ps0LGwHN3UJ2fL09qvpcqArY7x+bSaYebqM7bNAds8+G1MllDMZ3lenr/v+naiuq2yeatE25p/kjK2ZTC9Btjuk8V6jG0sKx4Qa3ofxlaYs1x+jMuyDubAwOyydMIVwyHtmylTV5vd8kWZ93fvXhGQGyBQnLcXhqF1/bM/+YswBLdc4gqKVvR4SBZW1yOUEaTVAlsFua61TKzkIyPtbZaBFNES23s3CGD32v074RSMp+hxgID78aNh6FtNf+sV5zXorG3U1ybAlp4e2CZ+TVo1DmqZjgdowHWvAKjexfMffvx5WEQYXTipDRsArbtgbOmhQZyE7W4D8CGYPZzPDgz0QyuMwDC9vfKcXbC0awC266trALarIpEiEJZG5MlFAqQX7fBR2w1mtqt/MPQC2PZigd4FzXEHwO4WKnyPDLTIT5zptbGNrWEsf9z2Z6+IDK7KPzIPKgSyXJjwHTBgK4slNTyThYrLCqJWGXID0dRCgmFBHMiEe4hd1dtaoIYE3MoCSMblDIgrjZxfWGV9NpOGRKFBHP6UQdVDF2Bw1hWH7cwQLetPulByNtbQrKXgsgQfP0yUoL3I3lu5H9KELfS1ldVKWMb5DDsao3gnRmHkOAf5TpWGlzu7/y8e8w8fzfxYBdit40TXAPrOBWTwGzi5al7CSf3t1InOdCtzPxU10BSw9RJnMoSlaHhSVhsKdnWALIc32V3lwFYH2PrAtvk2yAgFZYIPLUWIQNjYtzQrBoRSoN4MULYpw+puf/BerJvjArZ0vq5toZOitGiDwJb3FUtRvoQpb88U2KaeOSTdwoLEHbMy/ZwvW+Y5B2wFYsQyZWWjIlIZO4EFsgWd9cF8O2alKGajyNBnOlXkC0wkAS7dHrlvT0Zo2sHEPgKG6m+/+TdhFswliVfxZyvMngJHpfiwnU5vCA4cDbwqsMm20R2MF2tV2bbaFmB9Xbp8Idx+7TbcYHWD9dyGcdmTMP50Im4X21Ig69pm5OTuy9Q/qwZCiHWadlJxnGuuwxTRyHVvvftWOAug+f53fhiq2I6mAdkuoqa1wT2UgEWUCw4QECmsU9oc5F44fe4Cdo7OSujaTYTyXlteR7SybfFxu4l76VpKgiEgL5RLVFHmdjC17Qhe0d7bF3pODQLg9oU2omVUNtzbWltrPUcDwsi4as+Xd8BAqjPX2kfszZAfuhASLwb+3tg1DmyFRRYft5QfME1tYw/aIIsb1KdEIrN6JrDVxY7pfQ0cU4usecmkF9oE9ZaV/CbR3OrLFN/TdNHon/rrHiVBda4XFt6eLB4WZG2RRDS0l4VXwWeFgmd6tQBbu4DFydz8cpgYmwhDcPc2ieAiG2swuqfT4hhMZPc/bO9V//GT+U/oaqp1nPAaQPveQhbJ4A7gHMf5HvrqygnPdit7P8E1cChgS28InLzoDeHgI8IgG+rK72gE2KYgpnmgqM/NAlYdDbAlm1QLPT3caVbWw+b3IKCaeoY46NqD26r+FfRByUNAhk1c9dj3LJVMY/s8z35uYGu9PIJN6YnlwJZgV8yOdNWj+kAcHmwgw2jpToQD7IwNje1tkz/LQCaU2+NbMNiiJwJul29gC526wk1styPsqJzrCKjw5PEQ2NvPwzaMoVSCwK1nAlztW/KZG3AZ2BLDMpRMfhrIKl8U+mufAHN7MRgaleDq2s2r4eatG2LURIOsoQdgzmbmHa5G3ah6AtCgAxwTPGQwt8v9UM2vHcLYqoFaO02LqK8EqPulv/dL0MguhKFPHwKkVsIO6mAPddSGwBEsQ2dXezh/rh+eWAZQR7thdnE1dPYNQpMLSdT2ZliHxpYuwfaATjfgDmyTsgVG9KI0Agl0dAIVEyAC2FJLuwcXYWRp9wgmAR7bREJh77LJO5hDB5Dengqy0/5gi42kj2XvOsEnfeuaDtfaRRlcY3dpGGbeD7ydVWerDL3obfFTyiGGZGmwBq971eWqDCED3vq+xopPXkH9sAbY2qfynYNP6dJEpk5S6Hf57/UaX9ypEaIevE7dgBmnm4Jh9gDiVfS9zc2dsAyGfm4J2lowtMMwaHyCPrdCjztwCRafLzidHhQgT9nd/b9297Z/dWz58aOkcK1fT2ANoB9wQHgL59s4OcQ+wEn9LWN+t45WDRxpDTQNbDlwXrgIGUIFBhumw9s/R+kj6rOP9YFtxhQeBbAVp+M65Mp5aMbWkhD+MimW/1okxA4LbMvrNq3H/CRypL0jSSwDtiyvtcmBDzsI2OokfBDze6DxWJqPNNRuMonykkYYW6IWgrLYSwyMJDw1LhGeyX7qYqmKcZugVbtWCgJ0cieQlRNgtoLtdRo4cbt8DXrCFepECXABeAki1+C/dYl6UUQu21xdDnubALcEggS2ZPbEWEifIWCS3KIAXwWLqe62fhOl76V25iJg6cTW/V2wt/QrS4REl2UPP38keVTAJPSgPIIsIg2eBEQiHwRa6g+4IOEwl2K6OFK/uZegc73/1v3wGMZrk5BAENi2gc0mW8stdnDbYbC/J1y7diFcfuVSWF3bCKNj02ETKonunt5QBUO7AbaPrbKDLe01MM1siW7UTVdPtwZCoGYVeuJOuAfbA0O7B+ZXmGVjP/m9gHShWPUkY+tBJpQMNUkB2VKTK0TG1ira+5j0F6seWdozAZVrq5cGuV8aTIGte5MQuYFHHcv8GJO5dbCrfoON6cV97inBdeGRUbai1OsDStznx6/s2myRpq+7Bu2Iullh2zMA7COq9v/8mKRY1N8NV/XynVFf01tYhKyvg62FPnpydiaMg60d+fxxmHn6LFTxnqjLMXXDJ68dgS2MGatY9PCdQ8r/Ctf9xsQGthdax4muAbzvPcgg2du7OGlU9hHOL9Bn64ODE12iVuZOYg00DGw5AXGw7uuD0cWpgbC4CG8ImKTLjsPoVTPAWUwxA6BHUYGcrGzIlsE6G4dZFRGWGuN10BNlysoN5H5H8S1tBNiWMa4KIDw1Z8Ey/a3WW5bvg3Ks36fgvpE7MoZG9xh1W1E37bV9bMMVPz1vmq+8GZM9S7LreeDsu7+euBGNbWSEkuIk82tKXWWPdttxo7WizMJdfrE0srVvmki6E8Nk2o4gO50dDBMK11JVgDCBuZ34W6ShMtluYzImyKID+t1tgXAArwCzYGbJTq3AC8EStKBLS2thCbrQysY6jGawlQ5wuwnAu42t9G1cy1rixN4NrWYPnqtRyAhsNDCDGIrZtrTqLHWxltsqF0CWgZDIrDmTyPzLh0UmTsHzIN73e/fvyrY/P3j2bCoMPx4VqYJEvmJPMEt+ygI4R1Er6h4FlGVWoEdQEkPoSljkvfDGO2+EixfOh+/89d9BI4uoaJBkdHDrGXXXjr7WAUuyc3DLdevW1XAJwHaGzO7IRFirYF7Ec3bActNrwg7kGhUsHjbol5dsLQBtN0CsBELAzx4A2zboGdoJasHYMmyvg8V2+uUlqDXDO2Fq3YDQ6jcHbKNExcYA69IZs8subqAevwpAtkWASl0c5epzyMryXomiRtBK7wcGcClRYH26pwSJZEZwK9dn92iSrrNWMB3zE9+37AXxNimOAAI9bUjJZAdsOy2r9JXke70/Y2w9vcjq8lth6dORV6/fRjuv0/APi5U5BN94Mj6B3QoYjD0cCduQlogrMMk7nqtOdvG/RscTYCt/2/ND9Q/x3v3m1Orj6WKZWn+frBpAu2EwCT+Pk35wGbaU7sEoU2gdrRp47hpoGNjySWQaaGRCq+LZ2YW6D98f2CYTwYHZd9B04IUlF5Q/RwC6AJkU1BqjYgN0BhT5gV/bTL7zTEYjoFaG5hwS0yLlgW1tMesvCA6qs3zdFkuXh5r5a519Ub+xGbDNs68HAdsE8h4BsI3hQqVHGwtsE7FXZFk7pJ9loET5WUO0Ukbl7zoAoiAfqEAetlUJfV3V0D/AOuB2uYENAA1akW8DXHHCXsPOxkZlFy6MKjJ5r63vYst1MywtLoV5nAS4KxUwVogCRsaREbRoSCMusMQNkjJcqvndsYhZGh6W+SMwczBD8BNluNGQLG3ZlEnLgI+DXsUHKUBJhweEz750QSKY9cJgi2D7KfSPT0bHpL6l/ASQBF2iDc6MmaQ9CKwFBCPvrpUUgLQn3hAY7vf97/0Q7r224OYL5cYCQX5iy7mnuz1cOHc63Lx9PQyePR0msVU9Dsa2ggXCBhYAZPy2aXyE63nu8CGiVbUQtQCtXQCyPRi3qKftpFeEbrC3/J2gkdv+BLbwSCB5jHXHNYQBd8u7Gk9aBDKWW8Cq9g4JZ2swTBlfXqpAU/YAJF/yv7kg0z4mXg18cWLeDghs1YhQTw/L6yF39W8L4GC/O1PPTV/JkSwmsr2GbDyxdpU20Wv9iHraHOvKfqHX+euegt96Y1cKZGXHh30reRLXNRtYCa7gvVjGezA1PRUei8HYcFiamBHW3jG0PFf86HKhR0ALplZ+ZuOc5gkrzbD3B2Fl878bC2MMGNA6TnANoI8wchkjmDGS2STOH2IsoaFZ62jVwKFroElg2x7OXYATc0zai9g2OtzRDEA8emBbzHMGdLOh/SBgW3tPbU34oN4oqK03OTiwzVg2f5Y2XQkWbrBZaoFtemMyX+islk5J9tBMxqGMbV7WoSkUO5hmmv8cJ7DVkijTa89J2Ku0nI0BWy1HG9w0ri1vhAefPg7jQ88CuD+EZO0O/b2dYXCwC8xmJ0JMw+qeUbF6ATp6cCJ2qyh1MRHvgH1aRdjX6dm5MAmr79nZJbBUa2FucTPMLwH4VqDDRSj27V3kGYiDxk+kqQSfgIlVn6jICD7vAYvZ100gadb1onMlmNROkcoRuO2d9cf0d20dX+gpzkzb2tvIWtEWhdduXA237t4EMOwKG5BVjIBhm52ZE0DYJWyiMpUEjNovFNRGYCsgSY8+GG/Rf+0wvEEMPXhE3aT4ryVr247ik7HtQ6iwi5A/Xb9xPbRBWjAJw7r5uSXokrFggBZ3HczxBkAQ9cF7yENVkCS1rZREUIYAIIu8ckFO92bt+J3gtovsrbjVUlaXmmVaexWBrfRWAk8DsM5Eu2TB+75jV61T7fyRtVZkKHXNWnWJhgLfDNj6gkCArRuMEdiSvTXZQU6qIMDXGF5nmE0jHNlbbQVra+vLslDSowzYFhf+8j5J17Bxp8Dqpu+UXpsuotRlWPGzbbRZBYu/BUja5iBzeYKF0uMvHoWp0fGwh8UffRkbns0i4iFd7oIoA6zA1w8z95SMQuKACWrvf1hfbf8X8+ERGcHWcUJrAP2CneoNnF/GCTF8eIyTIXrpKqx1tGqg6RpoCtjSGOPs+TNhHRq4NTBQZUeZDjb7zLfG0sfWMpUZ2PBRKzFMyN+6T4FrAXQZ2Kz9rAimmY4CN2GeElC3X203el2aRjljq8/PD+CWJd4sWss8DG2sF5QD2/KUisDWn1CUEKRAie2afe/NJj+PGNi6z1TZlkz6x1EAW9muZcsTCOy0h4WZVRg4jYfRB4gaKf6hqOWEthQorL1jBwAJAJR6SIAxeJbC9ncVrqno93kA4BdBTU71AvQSaNF3azvYxr0wt7wdxp6thM8ez4fJeUz0a2pIsw3gtoH3bL2yCoOpdfDF2wAxBGx41h6eBbAzgOcMAjyrURH1wbb9bSDKFxsdjEhg5fDWK1901WNsM7mCGDUBLN567WZ49dorUjf0HTv0aCRsQk5BPKsRyJStJHjzHkRQR7hLkEh95ZWrV8KNm9fCBz94H2AVXgXBWLdRhkCNLU5qhrlwILC9iGAK27hvZm4eDO9qqIA9X4VsYxXgekf0zTSo61AW0lljYZIBXqEXJtAm20wZAsFtFyUJBLn4ntcQTIqXAubbNbRMRzTXxnwaU65GZFLJChntd4eJ6p0ikRwYk+s+beVy3pcYfYlGmiBXFijK5IoXBPGWkITYFaBLplllCBpy19h6A8pS/+YpwUfCCKbt2d7++eEjAaTJQBLZ1wTc+tdFwJqOV2YyFqORyT1Ig4aUG9DP0mftHEiSCSxWRtB/hqHh3gDI7YhsrQFp2UngiQUMgC0NznJzjY7ONlbmyjAPadDvhLWt3wODWz5pNTZgtq465hpAezLa9bs47+OkzvETnJ+hnzbm+/KY89dK/ienBpoCtr2wKD4Fvd0S9LVbDehrs4Ez4QacyigZNMsnXL23lrG0EbJuXdciYB0IM92ZpmvMogGYPDvpU0LKPugD4+UyPWXl26/p84xm452ET0jdXOVk9kcEbPfPTRHsSw3IFnz+0LpwX55Fo7C41DgOYEuWRpSszkA+D2OrQIaNvGcAhQlXtzvDwmQlfPHjkTD1ZAU60G6wuGIKpMseyhBoxS+UHGuGEoUtABPWE+nHKgAWsAzB6KluvEtdoR/Snq7+ARhC9QDUbofFtc5Qae+GARQYXqS9vQOPCTtbMCZbDKuLCzDgWoBWdwlM1zLyQy8AO1D3boZLA9Vwod+s4w0cKYOoMgACIB5u9MRun0ovvB3zi6Ti8JD1fakflLcX/mTvIjwv/VoTlM3DB+3TkScSjVDCBdvLIoyt9hoYSuFu1icyce+N18ByD4Zvf/Pbco94QqC2FmcbwAvZ7n64HruABfUg3HNVMO7MzC+FReiTK3QLhr83Kd9w6CmgVEGea2TFFyxkB11kZgFqu2BwRqOydmhwydryO7oDc/daWRQvA5cGbGXRFAFv5hVDqVgF8w5s6Q1BLo9A2OtO2Vk1PlQmW2QchnQFDJt+1oMwOEPLtFQTnMleVKpgelyRX/N77X70lasAV9/XIrCV1zDpB5rDEmDrF/Lb+HUGONMxQMGnA0wJ0JykqOMtT7q2W4X8ZnF5NUwjyM/TsWcIpTwUnqHvtKNdGaBDrtUeZBIEB7T8mWeAxW+yA9vcE22M39ubQl3/1tjq499P89v6/eTVANqdsoSfw3kNJ8PyUn/75OTltJWjk1oDTQHbU3Bk3gvjMbr9OdwSyh9XCzobqaA8G5wfhBu536YWGeSbOTKn4gbwjKXRidqmAhnwFbrJHJXND/KoWpDfRA5kgC8/6oPlendoPn3yyQD6fvlpHNimLGAZsJWnyCR0xFIE2+qsZWytrQVAJM+04pZLEdTTgJTayAL+vV0BW/h0LTz4aDTMT6yHzj0EB8ADJTSqlAhsoXUDN6oCeSsW3LI4kUmeTNM2wAeBKy2+dxHCFc9pp1HTQNhp74PVPrbL4Wd1lwZi6q0/7IGVI8wjI7m5i+33DRqdrUDzS08KKwiFOxc2VubD6epUuNi3qeBGQBK3qcksO0QgNlM/qNr2CspiT067DcFF0i3c4l8+FEbRHoIPzpw9G15/424YoF9YfD/1bDI8G4dVuz1XpQhym9SsA9uvf+OriBi2Gj58/2O4dcKGNQ2/KEcAYwerO9HJDsAjwuAp+J7FqmAFW9RTDJ0L7fIO0t4CqMXVUlhfM6tnBgOQBjjV/yukEqjbTrj7ojeFDjC2orOFLEE9JChw5O/6EjtINpmNgXmtu2yBHA3jrC5VhZtJDpTV1X7oetq4gLZ0VGNrzcEFAQGrgFI1zFNpAqUnmRcEBb5qQKZhd/WnAGUBt+pSLM1vrt0bWpBrD8gArY1FBjyzAVA7SgS1dk/ivTZ+Tx35BrTUi2D55+H9Y3IK7r0ejcK913BYBchtx/d8k9JRh8/nu0KmNgW18jy5UDIkA6+PaQ6i82NSeApdw2+OrQ//y/1GvNZ3L78G0H5XkAsamJ3BiS2y8H20ZX3jnpef5VYOTkgNNAVsL5w/J4PL0gLYIp8LGyiIDoputGWjdwP36UhY70IdxJo/mnw+HlADbG2aygFbyUiWdi2Eaj6n6R315Ab1AXMZGPUUzQhE2qSRfBXTchalyNg6a6Vp1nPj5dGu4qP3acdY7sjgeNoJY2NsTZZL2043hl6bJg9sveeIURbBlwEMZTIVDEhgLAck+LmxugNtLRR7H4+Fyjw8I4Re6Rzc5ges0O4ogMjYSQErNAgD9LLteF/40BBMopD5cwn38NwqWDZxW8XteG6rsx4JIgm2oG/Ypc9VaGurBLsAZbyMzq3ESySu3oBrsPXl2bA5/aPQtvZU3hFus6sXq0RfK6DIgan1AaQV+y3BdmTfvP4c4HntKVLNwBMoFkQQu3XnJgIpdAsDO/ZkPMzC2ItlMFyIhNVNE8Hll999WwJAjEKnS79p9Fm6xyhT+J156UYe+wYIRLuhpd1BqNVleJNYA7jHgoBgR7KuWl5hSbX65VkieZBtfQXylBx0EcR2Uw6iWlumq1IFyhGoEQZ4xDXSLlY/YkDmCUv6dYCtvUwKbKWlcwZc2g0NaBpjm6Vl16u8WiQKZGg9oph6SnA5gvnmdR2uAFv1kCGGcGwWKbtpnE176+WIILuBl9+X1H5PJknIxt4cmJX33sCwDy0OPPG3uPdCO9KwcgYGgzMwQp4AWzsCn7XPoK2FNkeMBvWwccYXrQxqEvW12XMiqJWX19o/yYdnI/2JKx/hvl8fWxv6P8u+b312cmoA/ekecvMVnBhwwzBOMrgbJyeHrZyctBpoENh+c46T4HlsB25AE0WNbTPANl/ohpBUdouOVTbEpR9TT/ligK0+NX1W+jtzlw7ETZavgR5RBLXl2sj8sO2TTXnynsdm6q9YZqbhOrdES1vCikrtFaKUNbq8aBTYsg2yHDpwzya5dKIstqZMobLd7JIPBWtMT+ZY9kGclZXdMPzZZHj6YDpsrwJMBGxnE75wy9cBsIBavZfpiWV60n/9c81DCg6IZZzxBcCVbXjbU5b6I+qkypYuyEBmAqzsCODtClXKUWDRL9GzxGWVMr3b20thYezbYWtpyECsMobiQdYYTmEWE/bR8xqBvoCKpPaEfVRwF3t9AvSYFj0Q3Lx9I1y7Dv0tyrBeWQ+j2GJegXxAvJEK61aFZvYSjNBuhc8+/hTaZRiwI8E9cfNFOQJOPLgHgLMXDCuB7Dzcoq3A+I7AiIZHXFYJC86IYmQqxTuFA0RjO/mBgeousrNgbBmYoZPuvsxbQqcwt/p3p+ijwZ6LUFgKaoZ4Jj3YD9jmGFvNR9YvtM6UvXXwrd9zUbQnbtqYVR/wjIWl1wZnjoV9t3DLuFjYWQO1jE6mRmSUVOjnZJK9fTNtr/VH75cNgFt9f/NjRdJzs+9soVH0mKA4FZ8SmIIYqUAXvQQZwgy0tOOT02Fs9KkEY1iD1lZ01RhO2ukXmu0bfUPTvRdPOo2mdSHPLF/sjWX7WrVSM2sHGxjx/cfoNr82Vnn878vHytanJ6EG0E5cpdG4jAEe+Ooz6twneKdq2ZWTkOFWHl5qDTQIbP96jhbFp6GFW11eE1+bDmybB13NldfH+dq7MMjRvU4y4B4M+OK0vW8mygZDvcFhyX7AtrnyNXJ182V0MFIGXL0MDsibAbeeW+82LxDYsvbNStonWq8XslPKruYXGLpNSaBgTGNxci5M6uxr4kZIwCrZTZ04d2HgRR+1qzDsGvl0CnKEpbC7QeEB3EcBOtCqPu0zdDzvOXFta/qi5a/VyFTSMwkWo67QIVGybCKjiyfS8EaNBunjFawt7gX/K0wfQe8egLZs/RPQAfBs74LlXPgRgqqAwQXoIagVA6sE+Pjz/ae6itL3JWXt5CMy3G4YpjnPb3eL5lMB6W2wtwzowuQWAWSeDj8JmwC6BCi37twOl65cDD/8znvw3Qu7HmIVFIYAVXzYIuUegE7meRVjzjLcQm0R0OI7dfFFoKSW8RJogZpmg5KyjS9srS4OuN4SOQJYbwJbekoge9vFoA0AvO04u2lQJnpbPUV6IfWkaUVvCNZWcbekABKFLTWAHUccB7WxWg32yr3MI+vUPLayI0reVd7i8gKRJ5jcQN2UuVQC4YZdosB6MJkIWXyyvpofXcBoX8tkFAeNmUIexIWN9lN5L2KHtneM/cT6ruFYXQ1yESWLNO6A0DMItbWVsIS2nIS7u3FIVqbA2E6BtWcI5SoY211GkIMrN/qwdSMx+UkttfUNI2ej1KUesC0bX33kS79DSN8fAnj/02ebI3/eyJjcuubl1AD6GMPyMsDDLZzrOOk9Yfjl5Kb11JNaAw0D275+WHRDP7cEww2xSrURu3nQ1VxVHARs09QOGqR1UE6L3FxeXurVkTZ7vvxn7cVJ5zCg1qdq/nwxwDYCvgOALUGIV5P8TECttn2hvJQHxM+ICjXE6y7BrLBCAIwAtbvbNHaphuXpShh/OA8DslWwjtjKrtIzDYyhGLVKpnAFi7jF/sqMtmQylYnfWVyd6L1swpDGFsmYPknJgBPfOXnvRDqhkFP/N7Qkel55glGCvBSBC0Tx0AYjtPkwt/FZWNmZFNkDb1MrfO5/Z73btZv+ibOzkivJi5lqJQuDDPgZYOb2v2lATyME9x24B+uHoRnZWupvKVF4/c37oR/g93vf+q7WDbeZXV+AsLj0vEBgtQkDuvUNhsmF/ADfE/AQ2DJsLttJ6o5gmvkyQOnlcoDungbaaUAmwBVGZOL+i1pbB7oqVWhnxDK6AiMDLmsDBZDO6utCyTw+WCUpw521u+JYfVcNSiro1j9iPqOlYfSiwIVYdg0NwMjk8/CIY+7bVj0maJrU2WroYHX/JjIKk1CkoFZ2GIi6k/4qQDdrfvktB1zlExVX6Nq+5mq9pyYV7avSJyXKGAMyoC2xSFmFFGEaJMk0jA2XoJneXK1gAYlAG3TftrIcNpcRIhkAeBN/b8HrBb9jQKAqfrL9ma5vAql8RhnbA+cjxdp6h9A1wcsAACAASURBVL37IjtyZjgEdsb/drwy8t1ClbT+PEE1gLa7gOz8As7zOOmv+AdoR+pwW0erBnIjkQ2n8hlHUp6dp0+f7vrzP/nrOXpD6IEebX5GtdsHSREOHGAarPxmgG2aZCMgN84gySDXYLaO/7Jk0NVh+2gOtouDqXyKzQJddpPjALY+aWqJlXXVnDowjL9HFGslKQDbsj7g5U+NH5VNIrBS4MStbjJLW2CNCGy3YKW9icAKa/BaMD2yFDaWwZQC1CqwVV+pMu0bWJSt12Tur9cXPS/eDhqEwcF5loAzurEPGCAWiGmYVo3V6C83A/f6QttWvbCOGkxiFQB3YvPjsLYD37PRuEgKIFmR7XHXlRoY0zIoS5y7R27LM7bq5itveMWquQR3XTduXIM/WbDM9JqADxmY4bMP4dUHYIV1zoGFBnnU8jONLXy2SemBfA+GlmGJ8XObwBafR2CLfIifX8lmxk7qFrwyqJIvMprcthe/tj3C2FI6QWmC6G/FmExdg3XAHZsYexlAF/iniDUDrV5nBmp9gaKXKhDUr1yCoPmJIFguyT6TfgTmVoGlSgmUjSawJSg1KYJppDV4gwZMo6ZWfRmbftrzndZHAmpzeTLZiz3W8CueJ++Y9yT3O+Brxkyrn11jvdl3S6w/s4xsq0148qiAkV2DK7sFsLaLALAbMAisYuHIaHu71IivreAdWwkVRKHbWIeeGgB3G59vb24I8N1FGuJBQ9aeyJ8wwnr47kLx3apZ1PpLZ23jK2JnmwHH/wKp/aOJ9dH300tbv5+sGkC73kaOyOD243yCk/pbelJoHT/DNZAuvfcFtmcR+Ycgk4ZjPA4CtkdVpycR2JYDw6MqcTYx+ISoA7YN3AZMD/u0kw9ss5LFyegAYKu7pdmGuQIwN1Ysr6kMJOpvZGw4YQoziO1QOo7fgA6Qv28gdCuB7focAgEsAMxDhtBehb62aq6XCJgEDCp3VHw3GllkKR4rB7ZM019U53UVNCkAkt/lf5OgMB2WX3LDid9BFYGwLkboMH9ldzZMgcHdrC4STRlgUzhFYCuHgSIHtl6bkaG07wUOO3iMW/cKAN0nq7LV7eEafN++Cv+1rC1GcnsGjeXS/EJYg+9eibxmIIggdgsnwxNz4RFBLcAuQ+gS3G5LEAsGr1DGVgotRRGFsoI85svAOgM4ENiSZWewBolARlArQRsM4IpBGWULHt5Wo39pPSentVm+Toz9LADbyN4a0+ukpzOjDogVmLMcGRAWQE6AK+BVwykLUysgl/WrrLL4F47AVn3fuheG2A4G9IU91u4qC4joq9f6kvYrhpDOVmmym4E6ZiAMt+9ilDz2sWjv5ZVhwFYWjLyCruvAwnOhso4F4xrCS6+s432r8L3D/QC6OwC825sIKw2PHwS1FXj9oERlG+GmCWx3txBqurImkoUtnAS3IkUROYqyuNLjCzsz9UCtbehomxqilcVzQirg9/8HDPGvTG49oaazdZzAGkAbsSe/hZP6W/7+Oc6P0OfpC7d1/AzWQMPAljq5LYYIhUVy5PbSu4+r8myuKj5KgMw+xmONgAlnGcoGw+MqTlPpxpE3u+sgwHZQ+vWBrdSCnZrK/gCeLXIcjG2+rPLXAcBWNbaJElSAnaYTJzUDgsV+we8F1AJAbTJmPcDsmoX4XMH26DpD4q5hwgWwra5jq3q7D+6IAIDgS5wGLmJyJuDOAabpa5MOW9YX0880r5rhDEAqOI2H/ao+UPMfi6EQPQ04mLeyanq+hUxWizpOBo0AM4kgEQQpZEkXKxNhfPmjsFFlNEGBPMIOOpyOEawMlCnUcZZWwZZf62xhDkgJCDNmUhsFfmnPhdcRnpfbQhcvnJVt57/72+/BRzaACwEU8sW87ZiRmPyUvwl0wd7yJz4jWCLTzhwIsJXnKHOroM88CFh+qwb26AmBYFYkCQCyXf6TDC7+JvBliF26GxMJgHgbYJlp6KUtkLZhBPpSM1od3lLK5vs9KgFhAId4SLr2vYDNfF/QRQYNw5yJTplZBbYKatVFWGRtLe+6YFJdtBiiyQJEF2WSbwH/3oa20MMTqRWXxRPfEbpVY72LtEUNudg95RptUgOXbtAnq039Tp4Pd3kCRPcksAbB7eYm2g/WkG0MIQ1wu0efzQjwsb4GULu2hvcOJxjbLYBbgtqd7Y1Qtd/J7u4g3DLTpNcR0cZL/1Asw3KJmggZY/34u5QHrVrX+XcxD2yl3uX92vs3iNX8a2Objx9lDdf67STVANqIXhO+ivMuTkYt+xBt+/Ak5bGVlxdTAw0B27/88/9v7hw8IqytVGCAknnZqMG1xiDZPtuhS1AD3nwO8Ac6EIgZyFgFnWB1YksHsXxmMuBz6EwecONxsbplwDYFQI0B+rLM50Ft8Yr6rEcRDJdXTC6PMk3XO7IJ/yDGVidU1XsK05JLUgEmdawyuWX0lE58erNqaoWtpbU2fGvCMptO4+fml8Ps3EJYRbjPjdUtsLM9oS+cDn1tp0PvHli+NoQVo2GPPVOJLgW5knihgGl/yNqoBqLaYqKkbqyLp7C2DWWjnlKKQkNKN6ak8Zq9IwIwBVVqOxGwUgrQhWheW9QtAgwMIEAEQcDY7OdhYv0zGKJVOJ0ra2tgzvPsn7mVPZPNyxY0WIBLERTwGTtodcSWefWVy+H2zRthYng0fO3n3g4XLp8PXzxA5KlhuH4aGlUDVXpPEAmCAV2RIQDQ4m9GGnNJQpVghm3sIMaAI58rUbviwoOaWdPLMmiDuPmiARlkCQC2dAHWhchk/Ew9I9BFmPq1dUZU6oFIySlXNnUErUnrxLJad9gH2EYmOOuYlnyyeDAAqosoBnTIIrt5wAZx9yXAVuUJLqHg39I1CWwpa2AaFs0s9g+CT2Fi1fMsZawEr/JuoN75OT8jQ86TAJUX7tAPswFdejyoYqHBa/k1205GY+mPql0X5h1fclFC3br4gaZXET6LTCykBhVE26usrJsEYUt0tvTXTHBb3cLvjDS3jb8lLepuKUtgPiB14HWMXifjv0pndEmlo4OOKTpH6JH9XjbGcR9AXmlrP1zzv+5V2399rPIAvslax0msAbTROeSLAR7oBxfbUeE9tN/kScxrK0/HUwMNAdu/+su/mztzZjAsY8LfwnaRjhD5uTtNSHanXtKhA5BO4uXA1vbf4iCXH+bqZfuw4PG4AG6az2Le6gP6/RrlcMA2n+L+aaTXlmA/7VapWzBnfBLmMo3AlpY7s/3IniJMU24CS1g2pklDJRxk/zbI1sKN3bIYtMyFyekZnHNhBX/vrO+FU/0XwsWBK3CkOBC6QQx07MEjAjzQGPaTdAggBV5b4fZbZKTMbK5eCDDyW6G5Ks6xhCg0wYyZzYiXEH855TUQjYZsyGuWhNEl4iAwVLDC+iZbyaiC9PywARCxsDsWZjYfInDEZgSoAnATltY9BfB5zvpJ3pC8A1sHvB7iVo2vVCJxG+7Arl95JTz40Ufh1u0r4d7br4fh8RlEEtNFxlPIE2hgRqZWjIUMTBEQcTubYJfMLSOzVXE9NbkCbIW1VSAdQbWBQUblcpCyZz5fCVxpO9BDvS2BrcgTIEUgmytGZPQ+oKdKKkySYLITbxx/ltSH/cP68tEmBb9yj62BYv0Jq2lwi1phqVcrA9MxYOvSE6puVctsUgQCdXP1JbIJ3k+DOpz8nPILLoKEidbOIW3rz3dXWgJkhZ1V0LrFhQWA4w4Nu/ieQG++RoMu/KROmmw5Nelk0zehgd0RZlX/pjHgNq4TdjfSt1pj2pfUyK2zA3XNfKJ9qtw5gUs3AlmysmSKq2TryfYSzCIfBMA7oHp3ydazDyOfCmzRJ6jD5rMdlJtrMC2xzgn5MVl1537kwa3l0fq9oXR9r9rafn+zWv3nU6uPp3MvaOuPE1MDaMvryMzXcTKSGRciBLjclmodP+U10BCw/Zu/+s4cI/8sQl9LEFB2uBZWWLLcVlpjNXhUADAFtnxyLcN5OGDbWCmO/qrD1ksZs7t/7l48sPX85HjLQwLborcLAbXC4ipDo0ZPtpXMyU32UYmXAJSwNUp95zJYotm5eQDb2TA5OROeIX59BbKEsNMVLp27Hl4582ro3oVzf3C37fi3DSHDmPdMj2qTtnQxbh2nXhfytV8P2O7XRglrJJdx610jMdHVF7eabUvbKlTzpQylE1MUT2yDDZXtVfMoINHBBCClQKca5rdHwuzuI+zAIlJaqsEVTaaDIzPKin/r1m0W3YwMZwbSxK0Vnnf//r1w6ey58NkPPgB7ez5cB9D9wUefhLauvnD1+jVJYwO7Q48fjoQZtEMbAQ7yS82tgC2Cc9Hg6lY0T6CeyMy5uyxpCQG2CuyUHaWcQP+m/1e6MiS4FVDLEwCXLsDo/ssjkREQxvtFzpCNI/6MtD9LWyjElSMPcNlOGTPg+UuBrQBfAbRWd/wLz0yBrbtck5C6Uh5lp9VDgjG6ZJ1ZFniYILiVd4CJ00DP+4/ULVlaZcHFYA/1ukXNOUAkd+kqkASsw4/wOt6TVfxcg0/iTfg0J8hkO7H+t8moAtSKdwtZZJC1VZDpPKlXie5u8BV06Q7bgi7WkEd5P3WBRLDr0dfI7srODMG3aWt5rUQkAzjlu6zssTLG4r0HfYJAl7sbfFLi/cDGBQe79d5PfZfzi1TzZhL21pGhP6i2bf722PIYLfNbxwmrAfQXvoRv4KQPXFr7PsBJicLWCctqKztHWAMNAdu//eZ35/oH+sLC3JJOoukIzt/jB/pFVDsW2KcjzPcBSdVKEbKVeJ4rbB4Alj/aeWL/1ieyxjnMF1A7BHP835ig/BMPzmk9OUKWTsqS1y+PppN1mnyLJPc1wdgeDGzNYp5PZh1g5iOvRc8HdBi/yvCe8Ks5iShZz6amwjTA1AL8rq5BitAJIHvn1fvh0umroXO3J/SAt203ja1MzWk/F1ZPIY0AkeLLkRQv6l/ts7JdgfSzaJwmgJQFISjH+GwgQFhVPlNYLAWrAhQkQqyyfryWDJj0A/Nw4Bb4AqQElBqAwDUM+7sAgDu/N4yS0lOBywpM4oBsuHFTxiBmbKIAAgPWCqoU2L795S+FXoCthx98Gs4O9oUz58+GkanpMLuwIm6+bty6hgAOF6St6Dnh0eeP8HNFZAiyHS6AVtn2bQAwsrp7AmzV34UQ1bZ97KA9+6nAVMLRitYWwE+CNuAkqIUcgUC3WwI26ElvCRLaVsqjIDLfNpm8SdnWPBiyJYNlyYAtM+rvouXVTf5cOSMBLTw9toulS2M5b1OVIgAUSvup9wQFiSq3UCMyl08QTSow3BKfzQr26P2jggUPNeUVbPWvYfeC4HVpYQEnQhgvLkIesAZDLrCpuI6sOgGsgEWTHLCx1HVtBumLY4ZPOP72u22a9g07rC74l7g2s0WJgnV0Zls4KvTPxhG+axrfQwNBqD2Zsr3sG2R1CYLjY2wccE12OmJluyaurfZRysaudOYMe8v49Hcry0v/YibMrL6Akbz1iCZrAO3ZjVvexXkfJ7edP8T5AP2ugF6aTLh1+YmsgYaA7d/9zffm+uBvcnZ6XidxThw2KJeVqmwr/HDb4/vXWTmbqf1U5vDSLd080/L8wJbp1YLC9Cmpa6mj6gWHqk8DtkLY2GSZz8/+4PZgYFtkyMvTaxjYWubUMluPelKEMv/EwupYOdNnyjalbHFz630zrEPTtwjwNAvL/PGJScSun5ZgAitwObSK8/TA5fDa1TfCxVOvhI4dbFcD2iKmLeQI3J5OFnICLEzPaIyUsFI5oJm9cqXAVjKswChX3/hc9LTGRLMuduETlNvE6s9ULed5ZPdBU8vtXQd4pi8UuM3f8TnrSECa3KfyUaYlzJi/PwQLALhzu8NhYW+UUEaBG42ZuDwQkMXkfGtcDa6EtRYwptvico1ksApdLSJkgil/9PFnkAFA59rXF+ZZ39iG1oVHNfQwwAMikzEwDMHX1ORUeAgGd51b1QC0BFaUKpBZlO1u8XEqER6iuywZC+TZ+SALStwynxpOt4u6Y2FtYTgGYNuHU4I1RHBrcgSWCzdTpuAKGcXuWbQ5Hxqd5ZMym3GW/i57CJJP+VMrz/e5rP21v0dgK3/odc7wKlDnx8qQs60ZLIRztbYppRcKzMjo891hX/Q+uYG+U4Ex1joM9xhRcmVpNSxCVz43MxcWscgjkN2B7KCK+t3jTh1pXbld/3P2Uz0SWDm0B0rdcAEj/UgLqY0vCyp+aelY2fWGlOPm39qn5T/vP3K96oSZhmiGRZKh9aWKWl24yjsODS5zQOZWwC3ZfZaDYyC1uMxPyfitqWmZ/D/rveJZJM/g+jvXPofffqe6Uvn9sTCGiCOt46TVAPreaeSJ+turOOniie7BWnrpk9ZQz5mfhoDtd7/1wzmu/BfgSFuHrf2BbTFPZUzUc+Y7Djq1YKsc2NowxaEq9+hGwFpZXouAOB3oDptmvTRSkFMEtOXgvk7t6nySOF9Pr3t+UJul5kA0A6S5J5UwtsUcp630PMA239w6GYuRDCa9TbocYphWMFPzCDwyDqZ2ano6TENfuwyQRf+Zm5WdcPn8jfDm7XdCf8eZ0LkD8MOQ5bsMdaq5lC1q/oe/PeiCT4rytzGgaRm1rW1r3L4QEGAg3ifulPDNT6bciofWEBO1sHIEbuzdCduVLUINEBG48rFiJMQ/bFJP78HXdHOVKkIiGME9O9WtMFd9HBaqYyiXyh+E5RVQ68A2AZLZXroBMnbAavjFX/pGWMHiYfjBI/EfS10rNc7raBOCVIIo8VaB38+Bzb15+zp0wN1idDQ6Mh5Ghp+KfpPMobh9ogZXTjJzGU+uuMnAoAAgspc2DAggJHjFljcMyMjY9ogBGVh5ugGTELxgbpk/AFl6SJBQu8aQenuq/pVISd8vgWe5YUZQtI5Z0kbZzxTc6huoX3qTZIwt31tLnfmOZbL6x76CsNDMn6RDjazz1/qBhB8GkmN9rcFt1grcaa0sIewygiQsAsyuQWq2IUZbDIhAIKtGV8BxmfbdwariUClRugjyOvFxyTXzvgioec+toH69l1v/VhY8M05kqVR2IQ836Y1op8XHr9azwmNE2KNQ2KCuLHgAcsneCrtvkgbtK5mrsLL8yTslbeuyibwnBalvstWq8Oa1k0jxt8ZWH/xBMb3W3yejBtBeNCz7eZxncFIn/X2089LJyF0rF89bAw0B2+99+z2sRNuiD1sfOAsY8XnzckT3l4OpIqA9oofFZBRQ6AAoA+UhjkbBcQqqvQHjxJHH7flceNWUXtM8sBWQnHvC/oDWLy0ytjWTiX2QlU0qVQ5nbB3g60+r+9gx9WJhSgsAwy3tt+lyiA7iF5dFgjCNif0Z4tY/e/YMXhEW8R3dDHHLtT3cuvp6eP3GW6Gv41To2Aa7CF/gHW00HmO+nB1jZdhGcgIUhd0UYJuBlay8maY1loegLgFjEdQL3rHCCAtGgEIDmt3QZdvNHsiBV7qLKO2Sxv56/pxFE6CjuUmBhQIvZXG1T2s5eUgULPy+Va2EmeqjsFQdF+8BzqiJFwLRnxqYlChY8oAIbLsBEr/+ja+EqYmpMA4jsW6wpARl6xVYxXOLm2CD7KKAW/WIwHp85dUr4frN67LFTqb98YPhMP70mRgSqfeEBNw622zPTRlb3co291cAtmJkRSMxsLZkiRmwoccCN3Rb4AYBudSwsjxmTObvqweBiKCWqTt6jZ1eK1rZVhuN5COTyAiQ07byoYTf5oCtIV5lETNts+aDgLZdwysLkw3Ab2BWdwxoaEc9LDSyKysgKRBBb2YmLAHUkpmtYpGwh7pvl7jM+k6l71jZ72m/yfq09nMfj2SbX1+N0iMFx55erDJ7t70vk4lmf/BQyRoQRV4WfWcIdMFYqyRGg1rIOyl1q1IVsvzq7UEXQ8LeimyhfMwuMrPFPOYKJS+TtrO8oXt7T5Dl33i6/uhflZe+9enLrgG00evIAyUKdHPzGCdD9NJVWOv4Ca6BhoDtD773wRxX+cvYqnpZRz1mshwMvgxwm01r+21tHbb+6pbfWKIIS/cDtvs+fH9g65OEJ6HsZFFBWj8NZxPTe8oBbtxQz62b5NoE3NYHtsl15KgSCZUkIa6GYBwDVmqVxmLzi2BpZyBBeCZx6+cw4a8g8hFdDO2BHWyDa6/Xb70T7kGK0NsxAGALBg+MrbgBksqQGVUnM6E5FcDFQ2Z1neoMl+hX8plOytK2xtT6Nq1GCcv3Y6mZBGTynRRvAGasxW1ZZ7gUSHte3N+wPlqMaeQ7ZkFDnUpu/HmS/Yy1zYNebR8xOCO4Rrj2ub2hsNo2Zeytgg1lcA1g8yPTtPLuAej1v/zu22H8ydMw/WxatvXFMAyLDQmZa4yyuI0SIALAam7bCGpv3LohIJd1xu3zzz99GObgyUIYWwI6aiqtnrwO0p8uVVAQTgEyJAlkbQ3Ykj1WYGvRycjYUq5gnhIIbDXwg9aFkodZm3v7q/9Wb0MDX1x0+Gdys2lopS8osHVwJK1g32t3USZcsZz+zryzqDFiHvu3RM7TsMP0GrEFoy4af60uL4Vl1NMaNLPr2KXYxkKCW/OixxYGM9sxsB6R64MH7UTld5NUjmDZtjLpB9nnWZ0Vd6IEGsb7awc1B8RSHyJ70QUCAS1/Ee8PlJqIJwxnlS2YA8q5I0ZlCm75AiiwtdaSB2eLOX2ntSxantr8xAV2XCmynF6A8BCGpr/+tPLw32SptH47KTWAdmJMdBqXMcgDHSF/jDZGOMTW8ZNaAw0DWw6WK3D39bKO5oDt8edS8yPDdO5hcVKrR1EcMmv1yo/d4Hg8XzS44wW2ETT55CETctkznxPYJtvQ4uwrAlud3Kir3aTLIkzsdF/3DN4PxgBqnz4dC5NgsJbBZm1Ad7iDa9pggdQBEHvv5tsAtm+Cse0P3fBn21kX2GpjxInPAIgzkE4wyUUObA0I50EDv7TJ2CbY6JrJGSh8TvBIECfbxQYkZeGA0w25hC2W8LQGwwlkjZ0S9rVDGVEB5wSU3L41gCByTN9CjyOF+TolGMJnHulqowrfvwC46x2zovtM9baZ+y31sTo4MBDeefet8PTJGIz0pqQ66OZJQSz1vOrr1F05iX9UcrbymfpYJct777U74eyZ0wLIpmDs9wUA7goiVhHc8h7dSs8AvtZBhrbEc4MZVlETLNHHqLOlHEH821KG0INnEdgS5Grghnb6tRUPBAZB48/IqUv7KVBNRgh+JOsb/qMLHe8vnk/Nneq05TuDunahAnG5n/0D2+2oiy36hGWIYRh90XCKLtvoB3gd/XgF/XkVcoNVaMgrkNdsQ+7RBrBL5pLXskJ1G90ltNF8remRal/gm1R9mnAZSCw+OE1Xr3e7Bq0hea+sntWHr+0gUHcMV2JpCGjpUxwHKHMx6YrLk7S/JR4d5HcPIa258t2yYr75uYNbdWuXvb/ZrlL1Izz5VyfWR/6o6cpt3XDsNYB2GsBD6B7sJk6G5aX+9smxP7j1gCOvgSaALfSI8On5so79gK0PagcxCkeZ9wzAynCXS7peXp/n+Wma6aBKx+Z+HCewlS29pADNMrYObCOD9RzAViamwsIhGo8lwJY231HDKBMNncLvibZ2Hlbe3IEYHZsII6Oj4QnYw5mFebGw3xWXRWRsYF3eNhDug7G9ffm10NdJH7Y9wIKIOkZNYwQmum1PZpHGRqlOVic8Z3KV3csOsneCIrOPeL31KGHSDCDFABMW7c0n2PgTd9F6nMymwysHcqlv4Ix91WeqvtCBqHpU4FFFWqpRJIzIgIRnVcCwPDPzikA/E5thJcy3PQ6V9nnTRqoUwV1NsRynTw0KYzs6+kQM9aSO+CxuCRO40hWVgY89Gv/wdwO2+nmbMJIEIQS2r929Hfr7+4SBGx0ZCw+/eASQBzaSqK+w+MwWHea5QaQSysCKjpbSAwJbkSAA2ALUkrmV3/mZe0mQLe+k6Yy9zbF7VlnSVQ3ksj7d/FZctKVsYASzZhxl44r2AYG+AsQlyhYXAOij9CG7Cd/iZGW3AWwJaimjYYTI5cUFnNDNQke+y/oA4Fc3d8pGiueA3HsUcxb7UDNjVun4K/jemOv8MClJHw7YpihZAaQbt+sugbq4U/mJsvLiCk0kCjoOSM837xDq95ZSBXUb5v2mTJ7Ae9w7STH/vmCUxYcwt7oQU3/R2oSSz729H6AL/9OJteG/aKZ+W9e+mBpAf7qIJ1F/ex7nDM4foN8svJint55yFDXQELD94fd/PEcGYAWD5VEcNZPrc7CbsiUnQ0i29dPIYFksx/6gOE83ZGxtNrHVbqWV11Sz4DsybTo3xiM1qOKHkRnKAaeMYZBrjO2rkzNLpfxbnVb18DLU8q31WV+/P73isIxtEdhq97HcObCVJjMvmZxL8D01mAQBa7AAn8d27PTMfHgyNh6GhoYAsMDWgu0juylbk2JcT9+ag+HWlddFijDQPRi6qgZqCWylNnS7XwGH1k9uYRPrXL9M+6ZY0hf6vn5PVlUyrW3mRjIERwJqxAwogl6+AWKkZugp/U4n4bwUwSd/amOjztBDoxoTLKEOkrzl+h7BpQFbspZ8Br0LuGCX920EGCV1AGC2LUtoWmfNyBKfOXs6vPXOm4gy9kQM9Zwlo69RAQKY9amqlc/ZHnTZpB1PI2LhGgJbNTATJBxeeeVSuHXnhoBTgruHXwyFJ0jfmTTFt8ps69uifoYpK1DWli6zAGwt6lg3vDQouFVXYN3wkiB+bQFsu1FWcf/lzKD1g9i+EaAKqpN2qdV7q07aMWue683LWaQ/qWmgll1cnKmbM47Lm9Abb8AYjGFo1zFGL8K7xwrcdG2AnSWYVR+/3m+0HqReDHj5Gy/Zlj7mnxz+py9g03ckHTviM0u29YtPrWVs81dofq0u41cqg2F7S980YKseRPQiB6KqQUY9tdewRwAAIABJREFUCdNP40MNUiHPZZ9h6qbt1XqrPWShLzsh+baTdzjWs+mp7Xb03W+hZX95vDLy3cPXdOvO46oBtPUdpM0Qvf04h3GSwc1Crx7Xg1vpPncNNARs3/vBj+ckMlMdYNsMQ6mDZx59NQv2iqXO2NNa8NBoDe2fh3Tri8/wvzPr2DwIIJVTPjscpqysrVTDFyeI5BECGAug1q9L66c+6K8PSqXJ7EzrsxmN7csAtuqGSFk7uoWinIZ+OpcgQyConZiaDCMjo2H0yRPxgkCQIGVFRSLwrDRhb+dp+LB9I9y6fDf0dw2ETkQcE7YWsqzcpG2ANK0fAaWGEtLgB35N+t5koNj1ugpsNUMOiLM2iv0oAdPStmYDw8lUwRRdfmWGQLXvjtGOSEe1urrlT60it6rT/ippGgsqZUNinTQcw3NV30tUpE/w+ypt82G+fShsd6yJf1WyWQJs4cd2aGhE/AUr4MRNlELQsMfTYDoeXcoy7nIEAjw3BGTd0ZCOdXzr1vXwKvW3+HAVUpMvPnsA8AzbV5RNGGjFtMaeWVADo16FtaWRGH3bggGmzlYMyvCT4FaALiUJ/B6+dgUYu2FcbKhs8SLvLZ/LcrEssTkJwoyZF+DLuhTuPr5lujjRtAjOqNelowIaPdK9GSNA0ofxJvrzOrwbrEFysAJAS3ddBLTC0AojS50yFwcKWLMhI9OwFvvEUfydwj/fddCOUUjdgP/zP9P1sck7IyCTXkuwi8IaFmkC25gyEh3D4xslxmWqN+bOi/pJVsAr7WLSG/k1yWxKaDRDjuTKu7f3Z2ilfzKxPvr+89dDK4WjrAG0KTvK2zipv2VX+BTnJ3gvyyNVHeXDW2kdugYaBrYVGNvQWf1xHM0A47Lnvxhgq6MyB0rd9tYhsQgUdXDLGxuU5blsEEzTKrJlzkyXplWYL2rSdlZ7XyrmYGArTI+93cJQJOyFs6/1CJhmjcfMsU5h/NeZmXlIIwgZsaLXJmBQJ3b1Z7lBZgtgYBl9mDIEekAYffoE2tonYQZBGbawjcs0BaS1I8RnGyOLtYf+nvPh3rUvhStnroY+RMXqYihd+EVw4zHdZpWeII/PtyGNzzRbvg3qBWK+UgMxd68lLos0JUk132Qqa3B2SAMj6BpK+Fu2CZ3lWxrKCOZZorRvkMFm+rodrn2WmllpY4AAf7bkVVhDNTwTUGt9ytkv336t7dfKDK61zYaVrtGw274Zzl84F958+3549HAozNOFIEEeWWBjbLXKbIvZQv8KMHSm0d4x/lCgq4BVtpaxeCEwvQP/txfwHH42B7BHAzNGzNJn6BNidC7RZeo2NTWaBLAdDLML1razhz5uGXJXfdz20P0X9bc4hRGUaF7WXtZ06S6LjxPSP5LR1tnaIrOZtT37Eg3UlKndBENbARO9A2C7adG+qBOndnaFkgMwtNTQ7uJ7Gj1mdaVa0iKTeJgFtvfdo/5Zf7H9PE/KoLW6Y1N5h/r8NcNGCbpBYzOqYNQNoPYjdRtHrbbv4GjgCeuDHgREulERqZfnuThHlV2FvvrvoQH6xxObw188T8lb9x59DeB9gY/H8DWcd3ESCNF7wvDRP6mV4lHUwKGBrUO7o8jE86bRLLDNgcYEicXVtw1XXjk1JEMJeitOFAcN1gcBW6+TlBEoq6ejm6CKpSwZsGXcz4B7js0TsJAHUQe1a728C1hLuSWnmqzTCcByEBRpKAXaei+zYtutmKzIcFF+sAgGbwlAgNHFxsZpMAZd7fQUAM+Kglrc1kG/pjA4aW/DpAdDsbMIznAXUccun0I43bZ+MLbqM5ZoRmKXJS+CM2wWFkKZSOYn6S9pX80B22SSdKCZolr9WssUF4IGLuP0yonXNNcORKVNIljWKxX0+CStP1kmXSxo+mL+EllognDzj+po18qthmsKwlIQ7hpoce9qZeNzKjAu67iyHF5/51Z48PBRWID/YHkOr0uAvEgGmE8z4HFA6tWk+VcpgvQ8Qbm6iBFfpbjvFLS8d1+7HXrBvhKsjI09C4/gIoxGVr6wkLIasJUIY5Ay8NniBaGPPm1Va0vWloZlAmxpRGauv8gA6qJAy+DsZDaw1r5H8omteHyXxXbHrfcqS8udIe40UHrAaGCb2DWr0LfyurrsWkNfpv9ZGodtAfSKNMOMwgSoySrQlglmBHjQO3nQ95qmXnXQGHdQWv79UaRTf5z0ccnbSRcxHo2NhoDyHvoC1aqMLPfuDha7XMhRm+x9zJax/g5lZbA+WFJoeRd8MchxI79ajfUYX6228H8gut6vTm2MtoBTo53oBV2HtjuLR/0Czks4GUaZ+tvZF/T41mMarIFDA9sG0y9cVg8qHjK1evTg4ZKLdzlW8Z/NgNaDgOhzZq3m9v2AbSMsQTP5KS4I3AgjS0Mnkec+BBDm0/Fnu/N9m7bVRZFdyp8OapkHGoDtgOmiF4QlsHVzYAenAGpHnqj8YAbBGBh1iVGJmG8Jnwpgy8hGe2BrGUr3ytnr4c4rr4cL/ZfA1oLBA+BVtpoze7Z9rABWZj/T2yqA5BG3Ypk/snz4zEG41pW+F5FjwnUZ0Elql0AvB/gdXNhyw1yEaR1YypxIBXiaVwhjpT0dZ/bkewPFCmxT4KJvglp71z/8GWnLpRIalplBLU5f6AmvvNMTPhz6YZieh7svN+oRZGhPkLbU/7j5K9pHo7WNoNX69QUMfxVNrnp5kKhzElq1Gs5fPI8ADzdlC5ogcfgxjAVhuKY2fSqj0AhW+El/tvidUccE3DLELj0lEMyK3lblCNF3MICt5F/KYC0pQNfb1d+JdOwr39HhPbrzSfmCstFb6Ls0hCMYX8VuwwZA7doyAO0cooPh3MBnVbDUDDhCllGWJiIXUY8Hmg1dlDzP4WOJRC57AcC2HvlQrwy+4Kv93ntj1nNdFsRFjAPcjk5EXOXiTEYeLpK0PoFuVX9LjbL4U/bFgqar+dT3o95YXDtu5se2bJzWF9ffI6T6L+Fc+J+NVWAI0DpOVA2gTW8gQ/SgMIiTnhOovz0aI6QTVdKfzMw0DWyfDyz9ZADbYlM2A2xfdDeox/w2w+RGBvCAzOcHaB/U00H6+IBtnEQ452AycWCrwIagzcCbTOrKKhHUbG/uIKIVAzGsiKHSKNx6PRoegt/acfj2BCjwyQoMWhe0eF1g5Agu2ig52O0Or5y/Ge69cj+c6T0PD96wIRBwSjaROTIpgMEvwRCKTiL8LJtwneWNU27K6MbJMlsipEA4D2wzYyhJKwcKs8ZU6avWiVt1R6Bi7o2cdeR1BJNasjxD7AZgnnKxbMISJ2WXGkrKxnYjg3v2Qm+4+dblMPr5dBibfxxWeyZAlQM0CAuuhzpMkuWC5EMN4FTW5k3s+ZN72CeE4VUdsPpkpW9chB0m0MV3N25cQ4CHqwJmKgij/OjBUJgB48ntaPF3ShaWnhEkGAMlCRoRjcCWn9FgLAJbkSJo6OAsYIACVq9b/enAxwpmfml9MSPNJl+p0pb/sXz06bsJwLrBcLdgY6mlXRHZAUI9U0s7Pw/mlsZhBuYB/DVkrrYzY45lg7vXY9Ynmv0tdi1JXltJ2+f5j5SxTRd3nnIjjG59YFvMn7YHy8NdCi5iZIHKhYn5vtUFnNWl+bvlIkmNylS3rKvptG1Nf548Tte15XK1sjKlpEhaHjz593bX2n9rKjxmhKzWcUJqAG3EF+BNnPSBy9XjZzjpA5dMSet4iTXQNLCVAS1upxw0sOVXptkkVb/EZSCrHvBqZMDbr24bHQwPArY+fb2MdjwMsG0UyNZMCXELzbXGOnBnxwsAtniYbD+j0t1nq0zjjPsurKNZyyOv1MhtwLXXItx6zSMQwzjkB4+GhsHWjsIrAhz605+n9GfTVwpjq34vQxVgB1KE65fuwdXXvXC66yxcfyE4jemr9Z4kupFNlg6yOHNKvyi8AoJ7rcLSfpMa2LiLU9/OzwPbrLZT2LSXGIjxc52a9UkqMEhAKplZe3VVI6xgiJ9FvS0/MoZU3zPVJ+Zam4ygjQX7vYueT/ZVZWx7w+23L4cnn82EhWl4othDiNee6bDaOxWq7fAfzLoTAz6XQzB7NIDSTBpRK6USrwhSz+YhQcppaxsubCBD0WAFcOOGv2kE9hrkCZcvYycRGVtZWgmPHg1LFDq6ams3bwdk8+ghQfS24r/W5Anmy1ZkCxJiV4MAqG5Tx0ZnaxXUZ0BKqlyu8QVQVucSApYLDxRza2sXPmg3RFPLwAr0RUvjsKVZeDtAP14HY7sFTwhkadWYjwZ3eekBn5vKG7SdD3/Yes3q2oBtsmg5KOVGJAzFcel5x/d8nvKl9zYSrwmU2TjrTpmCyUykwmSxRI8JdAHInQD7W2Q7eugYrEZnfqRlSX/38eEgYJulG5NcB476vfVK9bcXw4jGtm8dJ6IG0P6MWsboZYxixqhlP0b7PjoRmfsZzcRzANv4Cu9TdRnQ2Y/pPQhoHe0Al2X3KIGtDESH6ETPC4oPAt2NMLeN1oMN4/uUNA9sG3l2aZXJFmq+NnWOUQAmrGAKbOn3VKyWiRqJDjS8Kq3Gl+HJY2lpDWztrLiXevz4MVi6mbC+virRh3iP+rqExIBAhQY7hIXQ0na1DQLYvgaPCK+FQXhH6IT/Wt2kd1aORimqBXVNarq1f9AirTj5xckMRcicUmX9at9FTKKjFRgqVaXQlnXlGlr6LhU3YwnrlgJb9Z2roXPTfiH1hDP1H+zfE1SqXri2NX3S50+3RD9zoS/cfudKePLpVFiYWjV9KjlGsOs9z8IaAG5oV4MnqeuEG9T61U+lvgzYRg2uMcbeDiJHQV+AZlGDWdj3A6cHw/37r4UzZ05JvmbgOWH4ybhcK1vUprfthPcDcQGGz7q6AXb5N11+CWOrRoG0us8igjm41fryAVbArK4cDNgmfcj46W3EwN0EU0s9+Bp2E9Y9WhiMHRcR+pbhbzfp8YC+lskgmgsv51B1zeWNkAe2KUPc6DCVLsL8dazXBw9KsxFgy7pMjUKPdtzXxVw64WmeVc8sp7l9E+8JWMjIu83vyYSLxwSG4NUgJvxbgKyNR7KjUGcGSN9zlyDVjrk6E3i/LUYeTOpiCX39d7fX1353Jsy8vIhJBzX4z+D3aLvTKPbP4byKcwkn9bcagaZ1vNAaOBSwzXKYzmRZUvsB1f1WqsWSl038L7J26gGztAzFyV5ARQEAvKg8p1tZ6TPTchwEtsrymq8HZ2tKr5TB2Y8jAbaKZSNI87TVl2sGbLgrJD2QGkvTxK1X1sMCGLn5uaXwFIZDDx8NiReE5aVFaG+5sCYw5Ta06mbJegrLxjmw2hV628+G166/Ga5euIVYY/2QImBhLkZSyiQ6kym/89kFZJcu5ooSgGLtxbaTdHQCLr4rRVDJS+Mz5A9L1e6Pz9DETCagG95SVcY6pe0kEy6+ExarMFG7xra4SI3McgmDpxO1bpe7vvjsRQe20wJshd2W/CkLBggKcDsR1vowJ7Spb9BYVgESWdbImvuiRzS20gwmVeEz3YUYDauMbePzqJYkcLly5VK4Cw8KvdDS8t5xhPhlNDpZ5FBqQNdeBLbU25LFJauLz3uM2RW9ZsLYMqseTpjsdBwVZQFlEN3AbYTskL5IxDCAWrqjW2WABfhUXkEIXOpoF7AoW0Ko502EwMWFGqVNmMTMw4MvYKSirIJqDdLqu30r9se0b2mS+l4fFtiWpV/8rDg2HSmwjRIQfWrGQMvLERdXIivh4pZMPMAtVy/qbxplt4UE24oMroJdb4MM2Ho5igtD6Ze2OOe7VW8u5CX+rpSlJe0Qwix6wG+3r23/4VgYqzRSv61rXkwNoJ2v4Ek0MCPQpT76PbTjyot5eusp8n4n1aBvuJ6c1Xh2nj59uot+bMvdfaUe/ZJhVCYpe/0K9Zy+zAcBrvTWIx3kmmz7Yj5z+dJBJnfo2vvkHM3U8365dvZNOo71nNp2Tkt+iFqwCVQY2+R2Z2n9eSpD0IlWOq2wtuazFtrErW0EFKFrLwRimJyaDY+HR8LQ8GiYnZmCZfm6MSOIKU/pAUEcAYkwNPwVkxpkBwNd5wBs3xCPCL1hAE6+YGBi/KGZV+kWdElXL/ZzD81Z1qd5fyo70Po1IMryRRCtd5eBC+pTJSNWZ/42ZmA4A7RMQ121GaObAnJ7nrOrsQ0EjJmm2PLmZYl5ldopY5iVPdR8Q4pwvj/c+bJKEeanlhXIk/FNtneZ9k4bvFn0j4e17iksOvRept9OCUjsHtJwkoaUlesSk1pIHxIwi7REd8tM0Lcv2WHUh2hrFbxev/6qnPydzO4YAO4ConaRvRVjMok4plGs6Be4U+5T8Evn/85oZ8DWdMLGdEvzOAMYFxrMLD0fMHAIQC0MxNYE1C6HVfTb+dnZMIOQw8swetyBRwTRdyZhcHMLEq93aQBF/t6b88N82gP3/71srN5vLNwvNd/6b4QsaCad2nkhHXOy6c0jkzmg1EWxPilNQ9tRddMiT4DvZQZ4iF46cKMY6Uk4XpM9ue62sKivZWXL391iedMxtZi3Yv3h72fI0m9NrA//YeMt27ryuGsA7cLOdw/nV3B24XyI80O0pzpLbx3HWgMNA9sNaLrWVmGsYONGtrquBS/qqsanuP3BTSMvf3HwKrvnWGspSVznpPyW7PM++zjS3C9Ph2VS85OaPiEFu/ZJ8ujDAlsFq+naqMgY5f52NsnYuW0YDK1hy3YJMoQpyA7GJ6agrR0KY3DvtbKyLIEa5ABAErde7uNSwJVugfd09odL566GG5fuhrNdF0IfQut2tGF8QlQsBVjmC9NdfsU1okbsyoymFGTIvwmAjEAorS0H9bZqEDBvb1L6DsTtTLtXXuIC+FV8YwZVDv4TRjVlf1Oi1bMo+S8ATQGQ1v/TvHkRJF9OhRGzCfiUGGah3UAt4d6p82RsaTw2q8AW7UaGTD1c1PaZnXYYTvXB2K8Xhl6C35N8EGQLmiVwlB6Z6/qm1AWwZV3YVwaKqZHNLOM7xFftDRiXXbx8QcAsda7jE9PilYDuvdRQTEEPwxeL4RE9v5HYI9iWNrAFAHGRMYHqRzXP8uu7A+bY5Acr0PiSrV1ZQahn6L/nAWjn4Gt5BUaPO3i+bn2jfiTYQu2mt/YyZyJtsRdrIh3mc9XT9B+HB7aah7pjj7Rr/Xx63fKqLA1nPdP7yoGtAtp833Cj02IlCLBl98cX7JfdcPWmixKtY2dqZdfI2VsLhuFp5RYdyXtdv/z2wngXLYwFxV0Sf47MRcIah1Fk+jcm1ob+t6YbtXXDsdUA2htudsS4jEZmnHg+xPkA7XaIyfHYsvlTl3DDwJaM7TrAAgV7OoD6JOTto0npC5g6K0pZ3aT+CoNzPSY3S7N2UNyPxX1eZuCnrqVzVd/8O1VWn4phfEotq7E6bb9f5QoIMyCYXsfPhYDTvMf8JODN/ZgySt4KfNbOwnp8/NmUhM0dhnunmZlpGJPBE4LocVNQm+hm1QdUODN4Pnz5ja+ES4PXwu4qGDoYkrXvaQx4AjAGcRAdnGlSFcjqgs7BqL4QVtfGkDp7JhN1fF9qQW8E7kw1WUi554F6VeiLPn83MgO7jAX2d8qf4SBcwbe2GYFbkUEVVpXX+MOFIc0Ai3gtSNyZkQ0VF1+4rJ2gTP6j8RjCFAPYPvlsNswB2FLDyLqkcVcExvYMzyM/32qDq6uBZ2G7V4M6WA0qY2t9giIEByFeB2KIJhpgUy4zzwJQ1VWXsO5mMMRFed8AgPftG2FwcEBA68ryOvrOrESjUg8I5vuWYJbA1hYVHsLV/3YpgroCy8ZHB9vUaor8AAaOyyANViE/WJidDnPTk2FmHFIMMMZVuKvjdWSRY+jhQuMneD1usR8dlK3tabUL3CN4Wh1gm9ZbPifZGKYkS20+s/kh67W5RRzfVenueTDs0QJlsSjMPMYK8ZjBCGb2rnKVRINFhoPDw7exQ6SLYlvQJeNiI0RCEbim/b7eu+593r9XkLv3ADn4tYnKyL/d777Wdy+2BtCedAvGAA83cWI1L+7BWm7cjqkZmge2MSNFYJsa1aTAthb4OJuUG07SEadOYYsDRBmwPWgQ2Q8MH1Mdn7hkD6qjsgynA62wdQJGIq+a9YrINGQgqakKSIBtbsrZB9i6L1v+ZHSx9bX1sLiAQAwAI8NgaUfgs3ZiYhKGZAAKEoWJB/SSvsVoTJH2DbIfbeHalRvhG+/8YhhsPxfWF7fhjQrRyOApgVvHih5wqeBYGpcQZ3FyVWBLoxIyfGosVADi9nTvhxFU1mF1HCT7u5K6z1LWNJMYyF9Sfwq8nFXNt50CVw2okP3ubXQQsE1swXPNSkBZhUHw9i4Wv6KLDfBA0At3VKwmgALUzR7YbtbRmUunwh14RaC7r/nJFalv16UWfSO7DjjdJdlsWw2bg5NhpxeyNWFC2SZS9bYk0qyptES/IICVsKgGYoFWFNQSsIhOlsZC6tOWLr/ICp89dzpcv3oFwRkYaS6EuYUl8YWsxnKqz9bnKNvoAFZZW2V1pUtFUCtXG+unrugqALWr6K9L8HqwiOhhZGpnxsfDCqKl7aAvE8yKwVLUcmpPMLWu/J4uHxXkNb9wzTVmE3+UPa9RUOaPScGrL8y0j2bTU+45/rmAYT1kjWX35KcSG6NSgkyqx6VMWl9sT99hSHGuL1Z88eMBPDTiHQ3JGAyEiw/V22btZHBZxq1MC12sr2IZU917EeyWNYuk519Yuey+D7Go/FVIFP5DE83ZuvSYawB95iIe8fM4z+OcxPlDtBcNzVrHEdZAw8DWpQiNPFvlJT4wHYK1a+AhtZDKBzgb+BsAyg085lguKRqcHctDDkj0aCY/shaZB4MUfCjEONwEy4kgN1b7zFWHseXlJEvo2qmC7dxF+PtcAts1NDoWRsaeYDt5IszNzolPU7UcVz+ttHDXrU19WgSbAGJ3b9wNX33z50LHTl/YWgKQgTFZBxhb0fISUMpWtKEp2W5X4CbgyoCuwA8JaZuxms4OqWcCey6zhNPZ2HSyS9uJlv9R58p7EgAjT1AKPcei8jNlmXLwR0CAONtPyq3VrPkVNW0BIBG45VuGkzvTpyeBrXDhSmc4c7ENDOQCFheIhrWFAAMVeCXYwX27MPKq9mLi7xXAeOeta+HJ53D3NbkmwTDkiQSaUhAD6AlT7XnjT2WhwWJ2E+BOh93eijKy/A/1LVv/xrZJWfAdA2uICzTRTgKQ0uuBMLbqFcOBrfi0lUUJqpFSBZwXz58JVy5dFN+2dPc0C0Mu9jEB4+aNQtosJzfQtmUfyZYexiwjDcph1m0XbGUNTC3SnHk2Gaawu7AM7wdV9GUN8wqwpIhL+moGYzNoWyQIGnm3vatYFzz0j2aBbRmxED8rAFVdONs7omyk/hE/d6NDJU8isI1wt7ZYWu7MLRcXWtrn9draNQG/My219wmOG+wz0g8N1HoAB/RL8Vhhi062m45n+bGwHviPOzUNLE7iuOLFzANbHQeq1e9Xq22/MrEx9JeHbuTWjUdeA2jnO0j0qzj7cNI1GF2E0aK5dRxBDfzUAdsjqJNjT+IkANtiIRuZDGsrphbYxoH5iICtTuYZ65n5LbXPMGdQp8gwqpvQga8gwtg8mLVpON5/iEAMT8F+MTDDBlwocatbt8rJEKrhkDKsmbaT33V2dIf7d98Ib9z4UugCsN1dB4ABMBOjMkxo24xGRDDrbC3ZPtHaKkureJGMXd6zgNaNwRwCrsLiq8iKp/OV1oLeKxOaseYC4FLgnKF0Bb4R2OqzJWdyv8s68tbZ+wFbmShThoiJkLUK0KD2VMJrb/WEO/f7EICBningTo0BBtbh4WB1D9pRRH8D870GWUdH50C4Ck8Ewx8/CzNPNsPuZjfqolfahM2dheHNWK8UFkhUMfHbSu8A2yGc2ghbZ+fDTjvnBZU1iH9SiSamQ1w73XSBpaXhWBu8YLgMQeQC4o9WrxVreI/UJe7ftAfSI8LlyxfD+XOIqAnwvAPgOTUzD5dcANXeBoqsckyjekLgWor/0shNQS2lXWRqec5j0TU7BfkBdxWwy0BDMQ8IoG7M6g1J6c6YXZO9LtlN6SgvPdN60+HWnc81Pnpd5RZl1n9TkOx+gWvGqdiL9R3L7jEjSytd2fiWvW6pD1qvwyLwTKpP2tTeG+kv6D88pW3VFZguQtSgjKwrPbNIGYWx1XcvZaPT39O8NjMOl9VhrtzMa/xg71vI4y+PV0a++1wN2Lr5yGoA7ccJ4m2cb+Fkp/wY5+fo08fDBh5Zzk9+Qs8NbMtXng1obGVYKq5j61dY/tpm7nz+Rkgr6SjmAgG25ppIBnqZD4/WIK3ZUjczoGZpJ0yJfZha4R8FY7sfsGWeOZEQ2NJh/SpA7SLcexFwTID9YoSxqekpgKpV+P7UyFYKdNpCVzsjjGWtqYCZ2lm4deroDa/dej28fuN+6Nzqhcd8gB4AWzAf4cLlswBv18D87WD7GJGgVjfCwvxq2FrfxDVgJpGXLnpaAOtLH6qqwaUVPUGbAlKdkJWh9aMIXrQeMxDM62pkC3az9yH+KeC9cMRSxuen/U0ZqSwfJRpbv8+ArV+r+JiT+Fro7F8Lb32tO9yGHfDAqTUASYAzAWWqbWV9VKudaCvUTceZ0H/2Rpgcng6fvjcdRh+uhd2t04B9vep6jXDBMp0ulPhcfsd3R7Z/CWxhZNwJzqPvQnuYrIwFyhT6BwGSXWbABQRZWABb6mhpMCiA1zwisOR6rbKvzvAKQOXnSb2T1e1BFLJXX7kYBvr75FoafNEH7haArr3IEdhKdTnQMjdx1MpWYAy2BkC8vIygC/BRO43AIdPYVVih9wMAXgkGIO2oxn+pHCPftCXAtoEXXxdCuhX/oo6UqS1jbaVtE4CbvBq5LCpxbeW2aSAuGNlm+5bJv/SfOhZkR3qzfp6NEfreqhcM9hUOwVZzAAAgAElEQVRq9LETgN+lLs3NIH/SP7b0UTH4wy4Lwe0+wNbBeb0xuJGxWdIolKaMTUcZ/hT5/Ydja0Mfvai2bz1n/xpA+2KSEf3tXZz0Tfw+2u5Jq94OXwMNA9toPBYHgoxFSwclzUpjwPZw2T5qmHm4XPhdKcQuECMx4eJYmxoA1Q6l+fy8qLmnkcGztqYyFrBsliToOcwRjTdKtu8kZKrNyASj6ioJEgR6QcD28CzAAQ3GnmJLd3TsKYADtIo0wLFtTNFUmjN2qdtYBAVT/K6nE8D29uvh7tV7oX0DY842tq3bAIRRnNMX+8M3/t7b4cadC6Gtuz1sIvrTF5+PAthuhAFoSsdHYaw2NCHSiC74OiWTuwUGDorT0AMXYkhJvQAIA6QTp8gYZM9S86BeDzKDKAFboiO1pYJlnBrOXL1bB5RJlWUxna0kLS8pL1dGSUAynyc/UmCrPY5eDGoYIQNEcoGANlXW7sGoq/fUSnjrqz3h1r290Nu/COBIYxqGeSVLbqBcCAoAy+7zYfDs/bCEBcgXH0yHj95fhkurfmiYBwE6oculYR/1ynSnpKIIfKY+as0CXIrdBqu0rb210NMPSHy2LYzMDIUfffKj0HemM7z97pcCXBUqM0vmFcCWLJt4wjBgS5ddqTGYs4lRYiD17owry2wSB2RocLAf8oQLAnSZQ0oTZhEVLBrAxTpy8NQGwEMNuILalVVoaqGjncNuwhTCPC+Cqd2l9wMzFtOtbO0fUQsdX6Y6I4038mFeuibuif3CgHsjtzYCbFV6oGVrCNjag30BrfIZH3OKdVQ2kpbNJbV1m5E3utQU2Yq5BKMLOOk3XGTbO0O3bM7gCvPOPKXyKlvcprROGftaHJOd5S0jk4ogNreLY/WU7u6gIP/3Ttvur0ysDH/RSPu1rjn+GkC7nsNTqL9FWMQwg5MBHhaO/8k/fU9oENh+OMd45asrG8m2pzIK5avv4wS2tWmn4PJ4mqi4sudTDAAYONHBuHzCSV0r8bqUeUuH2+LWNK8t3ns85UuZiWaekAHb8m10Yx2tXhoFz3FzMKcL9UleZnvROhKs6rbuRlhe1LC5dK7/ZGwM5xPRQm6i36rxDfWOOgkJKDODI5ljZC40V074vKujJ9y/80a4ev566NodDG0GbHd2cWP3Trh253z46i/ex+97YeTpuBiK0cjo3JnTYWFmJXzn2x+Ea1evhtdfvxlOn+kHk7wZPvrgQRj6ZDzsbQFcgdUl0bO9A8CL5/d26Ta8sHuiWWU/oiZVf/ND3jgD9QJ22ecEtPIf6ksVhAmLjXsZTMC3Qw03CxT1hRWvV1DgYMKeZtun6bPUq4C3t2+r2nM71sPAuaXw7tf7w9Xb1dDVM4/6VVkAwy0IJGWdW9k6AWwHzr0ZFuCG7fMfz4SP30fo2OWzALNkbXsEDAN+arlocCYpKfCn5IR412UGG7uL8IvbF9p7t8Ln45+G9z/9UVjdWpF2vnX7VvjyV98Og6fo3QAaaWojybIxuAJAbqewsmR0HbAqI+cAQIzBIuNqrSDg1oFXG6QJZ8KlC+ekDxDY0G8y/d/qoQsHceuF7MsCDAugdfiqXUKQkNnJqTA9Bv03fnJhtIdFmng+SBZvMtJ4m0uaaZ9IDIe8k9RDhM281vtcK+3gg1YTwNZ9REutlORRF3nEjD7W5oFo1hfRD11jW8Sqxox63eefk1+oNVYd2duXstzyntkYIgaH5llDV6pYwHBVS3mTheIVw7I4lmX50EVLIoOKC6fMAHC/MTMFs/XmnmI5S67715vb2782tTE63FidtK467hpAm9/EM8jg0pPCEE4yuBvH/dyfpvSbBLbUk9nWi2+Vlg6k6eBUtlKurcLGwWnzaT9/g9Xb8lPm7aDjZwHYpnWQDcZ546TnArY2n4oHBJlcMYGA3aJBGMHCAnS1U9gSHgX7NTwyEiYmEZoVYUnFqT37qngs0ElVwa2d/ErYXAUxBEx9Pf3h3u03wqtnr4bO7X5Ed4WrL3CtuwC21Y6dcOPexfC1/+TNsLFTCZ89HA43b74SLkGi0N2F7fYdMIfD4+HCRbCSgz1gdAHwsAU/82wlfPLew7C+gPEJk9yVK+fD9ZvXBHgPP3watterAFpg/1BlbTB0IrDdBRss2YxAwgILONiSXCvYUcMpA0EsE0ECmWl+K+7N9A2LXgfkNdJ3SY3IbJtVklNdYBmw1UATyvwKWEXghO29xXDp+k74CoDtxVcrYGTB2MJDgrpqBGsrFa/wmWkS2A6efTtMP50MH/3oWXj0CZjXlbNwpoDwtu09ynqS1Wb5ZLzRcsu2PFGttKEy2FvVJXhZ6At7nZvh/YfvhU+GPw6V7XUpq4B/SBvuIXTuW195JwwMnhJn+wzCEDW29J9LAz8CFGPyI3NbwyBqfWnXyRYDZH4vAtyeA8hlIbmLMDO7EFYAYAmCuMjYwmJmjb5qoaldgweE+elpSBDG4QEB7svg6ouGj4Ljbfs6N6ZEzUCE+L4UiT0hjrJHBGydBU1Vmto17Ek27hW/rzcWxuAnVnexSN4NtXfY+5kuorTzyJa+9VnVK0tL5B/Hvhk/qTcwNzYfZQlnCxkZRthGtrjQMLy69OHChjsBzCR9Jvv7QyPAnR0Yrcb3SfOoaanRWhm4TT/TutK6cdZWym9/++9l4Fbbq/7s6mmgfv/ntr3t3xyrYKurdbz0GkC7sdG+hPMdDoM4P8H5Kdors3x86bk8uRlI335HjPxZiDz2ISKPIX45BuBsgtQBov5Ksf7L9PzVsc+LKkNA/kgLud+wVn8oLAe2ypTps+rdy+/2A7YH1UWzw/BB6dX7vlHQmb9fJ1o/atM4nBShjLHVdZTWsg76ABCMMIbt2xUEYliYXwoTUzOILoYIYwC2swhFSt+SYmhkwJX3cls6AwG01udEw8mLVs7KBPb3DoQ7N+6Fq+euhfYtbJED2LZxG507ip074d67N8O733g9rG7QV+58uPPaDWy/d+NZYBOR3jzy0tvbFzbwzuzgs+6unjA1Ph+GPh8LfWBnX712KVy4dCacPX8qrMLf7kfvfx4Wp1cF3O5tU43aDZAFGQO9NwhTmpWdmdTIW5zkDOTFErlu0n4S3JI1ZDe12VQ9KygUFn+v+MO3950t84HA2d64EJCObuAKifJ6+CaA0dZSuHprN3zl5wbCuUur2PaH95o9Alu2Pxnb7OA709EDxvbM29DYPgs//M7T8PRxV9irXAKoB/MKuQaN8whs9b1yPaW5Y2Lbm20FAekuJGnnrvSFzb3V8P1PvxcejH0Rtquq7/U3k/nvRsjcN770Znjr3XdDH/SxZNkIRqQyKJUQjwymsRVmX111JWsK6ycZoBWwEQcAPKO7S+QJlCnwmfR68AxGjGv4ubGxI4aNq9B7L6PPzExAVwsMsYYFWRVMrruJiguxXJ3pH2owl71vCqkEKdaMeYcdB+K7bCnWA7aNMoSenhuD+aLBxwrnn72uvTyyuCobWwzUClxLJDRaQRmwTQFgNi4pSG320HscINr4Y3Xv9aCBO+gPme+USoRUZ8soZaYJZ58WWYIvELT03qaeZwebsY4SYBvzzr4qfcJ3T7Tv5haj9ncKjItlT5/F/GOu+p+qbZV/PrEyMdtsPbWuP/oaQHsijrtEL2MUM4ZO/gBtNnz0T/rpSrFJYLu+D5A9uRWTbvHX29pXMqB81EvZhVwpk8sPA2yLNdaI7CAFj81OLvu10PEA2zzwbbSHNAJsCVgF2EK/ugRwOAO95iSA7aOhYbC2T8HgQlsLpkRcQwlI0tCYDlU0pKyBFAHMBDqqiR0YgDuq63fDxcHL8IoA3SeALbzeKsjq3A3nXjkVbrx2JXT3d4XB0/1gH3vDxmYF4KkrnD57CkZBCMWKCY5sLMHM+XPnw/rqVngILe71q6/Cuv5M6DsF11eY5BZhgLZV2RY5wvL8WnjwyQjYvNVwdvBM2AEbTat7AiQEddWsY73eDa8NdFFFqQHT4AS6U92W0lTNYK2LYWCRZ5ZLpnuUl2CO26PKpCrr6exXzkBJALEeOYDAu7BtT4tvAXWySAAbBSB7E8Puu1/vC6fO0LfsAkAi88MnU/ygdS2ghoC4+1zoP/2lMD40FX7wrbEwMQzDru0r+A71jOhuNLAiGmZ9ix7YfIx6/6kaacGyt3dvhnOv9oWljdnw7Q++HUamHqNOwNJ7oAbHgeLaqzP09PaGL73zNgDu21h8QD9NXEi3bdFQzAAKtbh8bly4xt4Sx4kIRJgxA8UsY19fr+lvIavAV7MAr0Mj4+JbmX1jEdHwnj15GhYnoavF4ofyCgW25ibK8yzrZv1DZCMFt1HHCmxt0NtvjFG2cf+3WodUq18dZLPFgIHFNIn4vBpga89heyWLidzjjwnYKlualdOXXOwcXj6PSCfaW+huZeTjGMPQu2Dw1eBR3beJYSDBrfSO2gpMAepBY2YKZHlt+h57XabvcPpOp99rFzbiIIQ1JPR7K2vV31kMI4iG0jpedg2gDU8jD9TfvoJzHif1t63FR52GaRDY/hiMLUPqcosvO44SWD1PxylqVlOQKoNLA4nvB2wbuF0ukUFGCJSE6uFgUxj9y7S0/oxifqMe0i4oAtCjaoOjALb5etof1O73vFKNrTSiBR1AfRLYbm1tgRXdCosIOzoN4xvKEB4PjYSn+FnBNvCuMFxecSoz0IOQS1pM/levrR4dqj2cO3053Lr+WjjXex7Atjd0wmiVUgSypDyq7btho1oJ7T2QLfT3ACB1wtJ9LfSf6g5vv3M/dPd1Y9sb4OZVhmbF9fDj+sUXo2H86XS4//rtcOp0d1haWwAIPoNte7KDe8L27cLv6/DD8fD485Hwta99OVy/cVW2tSfGoUX9bBieFQBVweROYAufDDUNt+7euxNef+MeDJO2w0c//iScAigfAOO8MAlfskvQbYpXAuRbsKhKZ9RNGd8Ll2foz3RSdD+2AixRCI9CJsS1GHJxsue/CF7Ruxpe/1I7AGN36B1EJLGOJQBUAGiCS2kDh7jKv7Z3nw29ALYjn46F979NnSkN9GCMB1/BBAsEoOKCjZbmYLsI4jVv9n4JKUZjLDy7fzucB7CdnB8Pf/f+t8LU0oQZmqm8gBieaZBFE6kJ0qIUgaD2na9+Obzx9ptgkLtZKcrasieY31JnF/lOu1yDr7aMFQLUtS/FI4JgNS46A+O1s+fPotp3EYhhMwwNjYVPPv4MspSJMAO2dmuJPnwV8FCK4OxbBMxaXAVJknZecx079zEwtvl3ufyvtPz1Ftw+PomLZ9zggThqU/TdhvjCWj3Xz4mPMP6Oa7vkWqSRYjR0TW0EVJXIpIeUjzsBXdRyG4NK11+ycLGQyOYtQRfbfH+y/YxEFqCLwLpES30wnLK+6TtdLOR+6fu1eDwGmbb/fn118X+cCTO01m8dL7kG0L5XkYWv44TuKTzByQhmay85Wyfu8Q0CWxqP1QLbk1KatBDKRSWrzxcIbOvVRw0Tu99+WJECKdAiXrZGAXujbXQ4YCtDZ51H7A9sCbLKFhzpxKR5MsYqm90F1BIMENhW4GaLW//PpqYRNvcpgO1wmIIxTqWyroBA+oOmKo745VBQwuQFoJF5IegB4KEQ4PzpK+HWq3fDmZ5zoXsXoPb/Z+89nyTNsvO+UybLe9/e9/TMdI/bmZ3dnTVwpPRRf4I+KIIRDIYi+Ekh0YFBhigFSZH8QkpQkEFiKRBYACRBgqAIAdjFmjE702Pbe1Nd3eW9r6zS7zn33sw3szKrqnt6BrtE52xuV2a+5r7XnPvc5z7nnK0GjlfcW83OedsA2K07YBOjGFiZXL3+FhtKNITGGmtsrbehfQNobbu8rA9HptiGXrTTzx215188AttbbwuUcYPUXE3NOQdOi4urdvvGCKB12l559UXYxcCo5pgoV1ZXrbEBEN3QTDD/OZ5xDHDW6OlfW1pbXLt5+eJ16+/ps97OHrtzY5gwWg/IXkX7UMaGXIN1drY7gFuYoW4gRRWeTBKLAvhwLW6hhnwg+USpetRErM8OZvV3gKtANmvpXLIz55rs+Glcv5oBtrW8HdjqOLG2Qeu7oaxv3KC+sc8a287Y9U/v2Qc/HiF2ayeMbS9HKUxa7AER1Aoganu+5KWdXi8LdccjtfbV273RW/buJ2/b1NJEkFgIVMcFpjSuAvcqj2t2o4OY9LeKnHDuK+fs6HPHPWGH+oLAr58bFwF+74waKQHbbJmKW+zB9qi/CE+vce+25kbram929n2SfvreO+/blU8vodYgrJcYPQc9idELgDzA8PBSGwQVdNGulVOlgdGt5sy7VyvwmMd5FZWCOx9d3omycJNPKZRaZGzTr0EvH/ucGHIxmulZ47/VSrUbsN3OJgfwHNpnr8+abEWxxGmEJDuS2kifPQKHFk8KCUZf07BJaa1DdjLFug3t7Xr1ig6y29tRZc5mJSs64xWfpdyGF6UMIbZzsZypDqpXQhZUU2cT3P1/uzt/8x/utdaeHffF1QDtqoY7xfsl3soydJn3BdoMq/7s5TYoUw3ZBe82ja2iIkhj+6SvLzMpQckEsK3Aldb0FUBY1jY/6UOXnVe4y56NarxAZG4qn7b9ecqBdPl5TxKGqxLwLW6ZVQK3OwPbFNKrEiuRNcihBsJU5/K0qCkTC7cKsJW+dmJC0RBGcRq7a9dv3rIppSOV93wEz4n1lhQhTXZBe8p1ZfCdyYzxTolvO9C1zw72H7H2ephFdJ+2BfDESWr/oV47/vxBwFQOULoMuCR+6fKGT2KSDWh8zM8suzObiqz4ugJ/gaGHJWxssgZY3t7BdtjaVrYsKQPeYj196G172z0G77WrtwCqTfbqG2ctB5u7urbqW+K5Brz4c4QOcyejxAZpAgwTqLSbyPlwfGuy9bUNwkhN2Rjla6hXvF6lbyUzWG8fDk7d9oD4sdcv3SURAIAcYCsmuEbOdbxrAawewovt+c06zlPILj0DlJvYT+l7BXI9sYGOq12y9t4V2M82O3xUoFU7l0gxYLWTo1mAlIkRRhLQ1GcNrc/Z5Q/u2Idvj+FQR9KDDdhrFhCBmlRbp/itxQk9yBIACw5qAQV1eZhfs0ZOv/7gmp2/8FNbJCKCYtK6cfMyKvrERix3gIfeb/lL/UHhmnKw5V093fY8DmaHjx0KGuYo0/CxU8geF52b4rULwzu2h24Wxpr+nz4BHl9iQbK4gH4a+9kJi9/IAmiOyAnjDwlzdv6iZ8RTXw0AL6OXDCUt9P5tJshXZQkR6sZ/BsC2vB5iISuNadeeet2H59oGbNP3cZclOxlVM7/pGtnfs7auErANxz4esA3nFO9WZDtj+xTaTc2QQsjJmcz3J5xn13ML2ArUensnWUIhFFi4frntKwWY4ZhCuuzMQqZoi0trq7hoLTryZhdA1VjhSvfl6UY49+/eX7jxz6q1ybPvv7waoC0Eas/xfo63Ykoqe5mymP25f31pwPbLrOmdgW0lR7AEwopb10XSoRIQfrKn+WKAbfnzJC1ehjMpoycccISpdM+v6oxuNQC7d2Cb1Yll71P422eoBHiCDlGgcQWwJjA4DjgYfjASHcfuu45RDhue/Udn+qTPhOBb6uG5FVzLowUAbPTSMWJG63Hc2t9zwPb1HrJWEgk0bkq7n8NqrNvBE/329V9+xb3wxVWuAmYFWnMwNLrWytI6GaRmYU5v2vjotLW1tFtrM8eCcOYJRzYH6EUKy31ggP2JaAexcwDWOgBvLXFxUQ3bsZP77dxrp5kESbuKJ/3c7ILraQ8eHKTgOKcRKqqxMedgV8DXtcNiGgFkclhrBNxqUpXGVxKHRphdge6FORhiIi0sz6/aEu91ZByjw+M2P7HEE+JQBcj1LVN0xA3dDZbrrre1WkJxreMEB7u4sULdwwCTE4FIESJjieRAIobB/XV27tUuGxzKo1OeoU7YGSMjWNq+TQxe6BGKY0t62qZT9um7t+zjd3DyW+zhekREoO5DsAUh1yRDCCHLknOVftKCpYZ6QPxsbT383rRiV+5esk8ufwhDSkjCGFvUYYUARWxzjykagW2g7ADihP4K4JY4ww0tLDi67bmzp2zgIFK2gGpjzN8wWhJYTv8W4af0uGE17JCfRcI67a6YtZLFCMxOjI7aCvFrDx8Yso7WNu8zD5AkfPzhZx6H2UdsGpTRMldiRFWOtMArlClUWdXt6z0P9Mc8sBwYVQNKLgOK4DXdotRCBHlRiILhTxjHyGMWKHP4dmAbrpvqrNqVQz1mfw0rltQWhZ+20b7BTnlGMmeFo17b2dLi4k7A1h3KYhgwsbhQ937DtHgryFL8zGK7ltvKVN/VgG164lLAX1oHO12j0nX57g5d92/fn7/+L5+8dZ6d+bRqgD6hsGCSJxzijeeu/ZQ2Gnta1/95vM6fe2BbBFJiY4rpK0ttVuWoCI/b4LsB23KgWWgcGdpo4Lbfs3LZtm1LZR7ITayzmXuHtpWB7U7gdWdgmy11YpgLeuLyGanwOWpsPdsYoAHdt5IyKLTSnTv37cbNmzb86BFxY5dgLUFfcTs51FnY1vcn5noSHfg0lLyZmYyUSreRBAH7CfMlYNtoLVYPsFVyhjWAWu/BdnvrL75qffvbAU9Ba4pOAWCrD5I0aGKqgUVeAowS2xUnIgFbAZhVmN2RexN29cIde3R/FgiHdnczSBk2AM0r6EWVzawOGcPJM0fQqx6HhR6zm9fu2uw0+l2iLBw6iLShv8MWVxZxPmu04ycOkJygERZ3zTNgdXZ0EiuVFLXu3BUiQMzjnCZAL7DrTCvfaUJtQlfawNb75Chxd7//kU0+mCeBBCBcW+IN69ZyoNEa9gPOmoH0tYEllk43D7DdEiEN25vHca9mY8X6SY5w8kS7HRjKcc0lGGDAZZ7fVCFy8EodWX2OiqvN9cFWH7XzP75uF346bZsrvdQF8YK1qyZmOG67ikUuSG687YKuVkWpJTnDVu2adQ5Q5tySfXbjE7tw7RNAr1YOKf5sYOITQxe6UQyZ5t/H5A3UieqnjvjFWnQ0kGijk9Bdh08fgV3vCd2owva1gE5KmetOeqFzeTnVD8SuKxveEs6NM1OTnl1sgox4y3zeNziAJOU5l5No9+HGtZt29dL14Di3y6vA6kUQ7YeXgcbdrvG0fn8cYFt+bNFCZOxQAds/TWBbyc6FTlmOTbcvshNILU6V2b/i2sevFWQ7AQS7jl2SlxTjNt5MfcQjX8iGxVCEipywhTbI+7qHNQsROZLj6zb8HBtvJ0CaWNlECehzlulNvxfZ52KPSGOuuHgr7S2FdtyyKxz7t+4t3Pje0+pPz67z5DVAW/Rx9ld5K9HDMG/pb/Hm/fP3+jkBtpVgXXXglF3hbm/SLKQKDEsySunYxDBlhvpT6Rk7AdtKT1N46icAttkCl5v1YLx3Bp7lD1wJ2BZX848vRUit4C5BEbh6vfvkUPoqOA7xtbz+9dpYI9ATLNc0jmOjhFS6eu2G3b59mzBfE+hrlfWKY7SN7vNM2g4M7R2hToEJ8QmIe8tpqa2xnTBf+62/c58115AwYFPsqra/N23gaLe99u3nbfAgmtB6wCrgWsH4FwGxne0K30UEhZxYQLHAPKFrO0M4MY+sRTzbiUcAyT/9zO5df2iNyB5a0Mh2drdaJ1IEiQCWAaYT05MAUhbepPG1PPFzCYWrQADKBiYnozqxzPxPURm6uttwYGtAa9togwojNtgNcEQMMAd4htFVPF0xQvNsh0uaJeZXO6QLi1yfZ+5o7iD71x1i7N5iMys4vWyS7KD1MEzoPljpZmKsEiM2LAPEQEkHq2fT/6OKZXKuW1+29kYkFS01aIDz1gzz3EwZG0G0DVyvgYcn75cnRNgCzNfBhG/l9tn5H1y1y+dheDcBj3kkHx4rOCwUQuYmTcaBUXdZiU/2QcestYQReq1rqNVWtqbto4vv2/W710JFiZn3Le2gs80mXfBQTAIdnO5KVgEPKiSHZKMeQNvQCHPt6XYFwNHg9nTaoeP7rasLzYNnw8jAmhjTW+XjqQoOXptKyED5g8Ptgs3PzpK4Y8Lj1s7SV9cVCYEYzKrSE6eO2ennT/o95cdw+cIV4iDjE1JlzVlt56QaU/pUDNcOF9kLsPX2SrrlzLUqLeQL3xVs1Od/gmKdlVsWt/wlNwimqPhdYl6zz+l9Jx1SZUGR0jMn2+J9zkP3hR01X9C65jaGBNPukvqswg8W0HKpNCU4MIbXbu1dALYZkiB7ThbYZvtUlqEteWaN3aydztbaln1Cdfz1e/PXf//zt9azK3zeGqCdjnONV3hruxGjaJ/Slqz4//y8vnBgm25QxU7voaYrgdp0WmXHpScFtmF1G8FPyTK5moPUHopfZsgjabTtxKcBbAsGqtoSv8QYRUC/R4D7tIFt6BeB3doN2CYg7jICMTpiQD1+7ZJNTs7aMCl0BWzv37trUzMzMGVBS+lhsDxua4SyJax1YFUUAsvfAAtpTVsFbJEi9LQOYRVgEdF9CsAB8ezwmX326ndesB6kCOtMRCMjk/bp+as2fPehHT162F5543nr34ezKlhMySMW5mDrYI9bce7qIgOZpAPSwd6+MWo//clHBPXvs+fOHLOhAz0AU2XDEutXg6RhGWezCbt1fRit7Jy1NLaihYUBJCzY3DRJJ1aoNUBySHCklLZyZgPMow/IkV62ravFjp4+aF39rdbShtMYiQlmkUKswrJKFtGAs1pPj6LHbCGRWLTrF+6RFW0Y9hUeW1EPWjes5TD1N7huq2zzS47goTk9C1jYcne2WsICKQIoSKNCZq0rLJnkCNQYDSWr2gLbXc91G9Zz1lnfZm04v3W2E7mhvc8uvXPNbn82gRMgbDKRJzaRQuRJcCFJhdNekkaEaTxsWfgA1d/0A904lyciArGA18ftQ/S1Dx7ddYmIQIXOEwgWgKhD1yoWzBGlBHUAACAASURBVMO5xT4Qtom5j7aNKa8cx+qIN1xfD0OvvuCfAfExTFh7Z5sdODpImDLFqE1lKhTK7UYonvpzjWfEk7PYItKDWTTfU+MkZBh5ZItkx9tEwiJgmxi7BtjzF86ecX2vriiW95Pzn9n4WGk0n+I4ifdXlVQDG49nmp746HLwU+lCYWs+RR2pdqvyqAjBPjyNVzlYLXamcPXtkoUiak1sfWL9U5Fi6hPvmxVBZpz4CoxtBLZaAuknLdSCE1lKvxtCvnkiCi3iSgBp6PblADRbN8mxbHt9pT4atLnhecPzJRCbQG7xu3CV7DSyG5COpMS77Ab99XuLt/74abTbs2s8eQ3QpjKiL/J+Qd2N96e8r9FOT2dQPXnRvpQzvzBgu/vaeG/PpwnDtya3NUd1xrEasA2XKN26Ly9nMoLFgfx4zOZOT1W4UoXKeXJgWwT+WWC7U+/127sUIb12f8ZiwPviE+7M2PpNqlaHm9vtYrbA1kbDGxYa8Spu7MVuKPsUelbYrRm2dCeQIdy7N2IXr161Rw8fwkQuwoSESVJbedLtpUnJJ1e32IoGoLiuEdgKyAB6coCa9sYOG4Kx7WzqJ2MuqVgBkF4k2MFTLx2yl956Dna10fW9Vy/ds/NvX7KVxTzgdMBef+tFGzoE+8g2+cTYDLKDW3aX+KWDA/320iunbOgg7Cl2ZQKweuvGPTtETNuhoR5YwpD9Sn1cYEsOXGIMZ2GCHxDaqwHmcB/XWFlcY8v6vl3+6LatzbF9jrRK7KvHdc0B6XCKVaYzcsDbsecO29mvUNbOZtjtVRJETNr1y3cAxgvWTKir/fv7AdzEfwXwjtydsKWZFWcdN3Fm22xfs/YT9bbRSwzdepzS0NxGdWrYZhcXGhM1MBN7XebEIutvfguOeehv5ZgGC7w6vmlzw4DehQbrqmu2o0NdRH04aXO3R2yG51sCqK+uoy8G1OY3pfPFSW4NsE7UhjXAtKfQRcKg77mqPnjItdqmLetFFjK9NGKfXf7IRidIWRxDkanVJcnQ1r6zbnHxkoOxrqdua5SEIQJbyUkc+OZIEKH4v4Bapdz1tyduiIw+z9gOsN13lEUPdefYO4WJi6A7EH4AW4Wiw4lwQXFr0YCP49woGcIKTn6bArUxdm0WkHSQkvkVIjSIZdfrkRzMPr7ojoHhlQF/jvUrWdmdLNDT/624UPCBVRHkBXC4M7D17W/t1nwBj5QFhAkvpvv4QnmXxUFIXBJeWZ1t+DYuugq/c8HEbup5ohzBn199zncJwgLRo2FkWNsULUHjyOvCr51A6PZyZgFp6TMWoypUY2DT8xTrfXvF72XRUqiXWKHhevbjrdrav3p/9uoHT7/HPbvi49QA7dHC8WJvj/FWrm/JE/6rzy731IGthqHriyrUfja0iwxCAC47LyCKv1a6Zik0i2YmmJsKFrISfNuzerbcIhYt3Z6JhccBtqn+AtALAK9Qp9nKjQCu+OzB0BZqZhtyL0DFshaKZ1RpjkrANiwE9/CqdstUtnTr7dRJAdi64QYsaYtXqWZXV9YJ8zVD6twxu0OYr8tXrwFyJ2BylZQhzAdiRaR1TBBepGLoG4GtU4+S5tQZOgFbwFNnWy8yhAHrbOh1YKtQX4qHW9O4bmffOGFnXj9irV0NHmbsymd37P0fXWaqarSDR2Fz3zxj/QAtyR/u3XoI6L1goyPTyAXa7WvffsmOnBxiu7vWY9AuE56rF0/81haiGOCYNU3w/rFROV7V2H4clzq7AE5gRemF5wE2A/3dXs6JR3P20x9csOHrk7h7EUkASUR3f5udPnvC2rtbbBpN7QMY7GFAVB2SiN7eDmtEczoHMzuGo9jaIlIG2NEmQLxv0as+iB/rW+m053o9Tl89MLZHqLseIqHkFmyjTrtYiXULYg7XRSdAEDtfmP/DpOpOYEgptpZIKzxWb9M3Vq1pqcM68jk7ta/V3vzaYbOHw7Y184gDYavQ0+aJ97sBeN0AGC4DbBfR8y4R2xdlCSx8HZEocIjLK+YszC6MbUMbMYeHmmxm8ZFduPqxzc5P0VbyalPbCxiTctmzzwVLI0AhyYHCptUora6Hd/MK8GeSE56HavJYtzC2HKu+onoX0aHoCQ1yMFQUhf4u6xAApVM5m+YgJHQwMdtrSEqWiNixhBRhamzcQe0kaXTXkc9sweZqG9rZdgEBD7NW3LnYf2CfnXvlRWIht/jvt2/etUtIFJRlr/D6WQK2sSzFLfRSm7ATsE1gNgKiArBNn5Mt/zyAN4C+2DYFEBvKuBOwTWAxZU3bZoezs1zCt3EMJMBYkMF4VrIQTlA7M2mnKizWZdeI4oJ0yuMae3i7CGy9vHEC4K+SRCqZas6C3Gztl8gP4g8l00eZzc0C5GJIsWQ3K83qpb8VFwlaENb/Jwbd/3xr+rPPSnvEs09fdg3QLtLdKsFDP2+Mrn1A35Cj2X+Vr6cCbH1ydFY16OAgQHbXADlzGgZt9eFSTG6Q7lGtFZID0k7H+d3KQOFjA1sZl2gmAxNUWvqdVv9+/xKmdI99qgzYpnsGsLe9jnYC0DveMV6v8jHlcozAoO7pVQ3YVjg5a1izPydgq0lgHX2twnxNAQZHcMi5desu8Wtvkd52hi1gxQUN9aLHEVBJ3uo+naStaFg711I6yJVnPNEDcB5rb+oE2PZbhwNbLXYblDTWcq2kjP3GaTv98mHS5+KURXD9zz68aZ++T+IEWMiTzx0C2J4GZLZ6eKkbV+4DbGHbJpetl0xjX/3Oq3bwGDYFT355yuvV1tLi7N3U+Lxd/PgGjOo9kTV28vQBe+Ots9bZ1+pjaoq4tnISa8HRaHlh1T5554pd+fgueBCNLsD4hVeP2cmzR4gQQDQEwNrE+Cxhw+64xGLfUL9LIKRbXSHCwu0bd+32tQe2PLtOBjNFQgC8ASh9Kx2AuVy3bLnBLWs6LGDLVnrNnG01aNs01V1g5Yr9OLs6ifpl/S6tLA5ym/M5W3xAelnerctd1gYre2qw1b72DRx4h2+bTd7FXsAWa5vUddFyCuNvgYB6QD/geI2oNtMLtXb7EREi1lhUwOTmYcWbu+qtazBno5P37frtKzjVzYtLDgkdHNiSuY3IEKsCknHLR8HzBWxrae8cTHjaKk5jU33CwS31mOP+ipTRQMQERU1QPUrfrEgTTdR7e0c7mefabRFQorBoDp887u6mR6eQ09g8ESwmAbYzgNpZhfZip0FxwKSV3pCOOMMWFndceHzKcPL0cXvuhdNeTh1/5eI1u3n9VjynaHey530eFjcLrquN63LCoJzVq7plHdDttsu6vY7fluwhZQB/uGaVFXfmipKd6FWUD4QfS0Fy+C6VM/tbOjb7e7p8tpzV62b7vdO1wv0Ca+sSGG21+FwQWHixtXKI1QdlVExZ5qL4p9BPUnSQBJizZc7eS8+VIiyUHqN2kM68UOmhPuJcvNd2zx6XHObSfXxe9HuEnQ8+/k4+V/fXb498cLXa9Z99/+XUAP0CRsFe5d3KW6HBFCIMo/Rf1+upANtC5i8ZkdC7nXnKmqLtJq0IbJ9mlbpqM1Aopa9YgBIoJuCzx5sX7IAMhhuCYByzwHbn540w/vMAW58byia0LxDYlmY92w5iw4RagNF7rMnKh1UDtAUQ5RNdYDfW0CjORRnC8PCI3bhxC9b2nqfWFVhwM10gFF3M4g0mWyugqK1lZ+ciU6ttfzG2jbWN1t3eY10tXYT6IjkDURFq0YhuoF9t7cvZa988Y8ee38eWdQ1gc84+fPeq3bg4Yjm86c+9egqAedRaO4mgQPnE5n7y3lW2+JedzX3tm2ddpqCt8mXAlgCUYs4uzS/b7SsjfuzaAotDyi9G+K1fedn2H+vzdK+zOIKJU+yG+c2v5u0akRU+eOcCTkhbdgAJhLS9g0e4NnFxlwFUYn+lc+3thq1tQuOqYPGqFWlPCZM2M7loF85fA0gP2/o8zl1ykMtTZ4DFtcYVqyfSVdNB/u5YsBWiHOQV2yvGas0CgsDiZkCuV3OQIqCHANiisl2ot8URmNNxQOEcCwckB6f3d9sbXz1odQ/uWe0Eb7K4FcdSaGddCYhK3dexrGixyYU6uzm2btNrRIEgcsUacou2PqQNvTl7OH7Hbt+/iTyETF4ebDeAmQ2us4IMQ9EzFHpLn+VYVk/kA4FFD+8mZ7qovVVPDqBWyTrE7DYj22gmYgLREpBv1Lv2lqBk1Kl00x1tbdZN9rjW1labX1uxOxPjLLrQz3IvT2gjYEvbTT56aNMkZlggta7raz3cUwrUn8BYqdY81bNA9fNnn7NjJ454HUl/e+GTS/bwwaOqmsvs9nJVoPmEo3UvwLYSuxpIhWC7kh+DfyiSkXuWIhRJxmRx43Uzk0wpEbkdFKcFQEitnfk9TGABmPlUFtsn2vxUbdUYZH3v82HhWX2iCKdpES274wcFJ8ZYBSH8lyQIMVqCtLdK3hESVshhMkryHLyHMoUdl+KOVNaGJga3fLESNPJZB8o4lz0lO+6PmQW2LCAZOCxSsUf79//66dMv/Y3vfvdv4x357PVnVQP0DXXuM7zPxjJc4N8rtNsemao/q5Lv/b6fG9huA6xxokvANrgHZXiEwuL7KQPbbEEqIEwf4BlDVTBQuxABWdPpRc8CU66Z9FfpuPLjs02R7l/tllUnIe6ZgHTJ9aLRzRq0YOii6du+mti5Z5QxtgnYBuNbDdgm01zp0mVPWmj76sUoB7i+E+BAR1u8YjUAtmzJTit+LUkI7t1/YNeu3zAB3MUlQBjATROGdLghA1UEDDFlqlgdgVhtBwpc5vjbA/UDaBphMHvaeqyDqP8t9aTTZVELzAGjrVvnULN95VvP2+FTsK48x9jDaXv/J5fswc0xB49fefMFO3nuUEjegDb24se37fKHtwnMv+GOXF956wXY3HbPNCZGN2g963AsWrBPf3rdrn9yH36z1belG9vr7Ku/eM4OnR4k5qvxrDM4Ii1a/wBlqssRNmzcfvynH/i1X3vtRTtx+hDhvwDUTIqzRInQmOtAC6pkEEq6sCZ5BpOkojU0wjoK2CuRxCfnr5Mk4bbVwoI21DQ6My1g23oIlmXfuq23Ltpq/bIDW+9KXCvN0Wl7N7vwSJOaT7dEc2iuQcvbvs8GWlgMrDbb6uSGrSC3aGOiPnmEVLN3bln95ENCfeGcFhGON5kvYqIOEU3tOkkyRucBtuPrNpNvwZmNEFm5Ldhaaqyzxh6O3bEHI3cBscQJRopQq4mU9hZzv4zWdRGwr2gTa0rawZ18QePAlud2RjYsbBzgSnftrCxyDVITtzS3Uo8AWxy8xOJK79xEJjHJBFoI59bRTlQK/lVcYS1C7hP14Prd4RDmCwnJPPFrZ8ZHScjwiDqfYWFCuDKP+BCyT4VXWIiXmK0y5NTW3movv3aOPsBih98muM8H733kGedSvadRtRcGd9sCuWxIFmRjcTGdZYLLWdrsqVk9aqE8yR6FgmZmg/DQCd7J/FQDjMVnCzY42PO021cKbMOitrhgSOduM4dOUugqsR0yDVAEhG55UysViM4SHxwvuCIexCgcEYQW7psBunWMX/8Ytbc+rNzGRZlBAdgGeYKHAotkjW8OxmdLYLxaO1YFtqq3CGw1Th2+P0WCQpfz3RclOVEEFYCt78CQbGbg4EEW+SeJBNP5f21a49/+17/2Vx+WdbtnH7/EGqCPyL/3Zd7KYqa0vJInKEzYz/3rMYBt5ZS6WVbPL5ZZqcpOyHBIzbj99fmBbcF4acRHo+TfRWMcilN674rM4A7gNoHEwlWSUY1WOAUUD5eI5kb3L5jD4pMX19rlZQrn7mTU/Qxp8cqkD8EupYcP9yqA7McGtqHc6XqJiQ+3rqynrca0Fmesshk7VUe1hUj2eTKdxhcUcgZi634Ffe30zKw9ejTuwPbqtetEEcAxB8AbsEICCpFd9wVIMONh6zkAH23Vy1HINZX81pJrIevYkMsRcjhm1ct5DKZyk3ipg0d77NVvPWdDh7t8F/HezVF7/+3LNo6GthmZwJvffAU2dz9RCdDB4jj2yU+vwsQ+9MQGL5Js4WX0udLACmitb6yjeyWSLWzc+MM54rletvtXxwG2TV70FpIjvPELZ+3ASeK9AuAmp6ftIbrZQ4cIO8XW9zRs8fvvfuI61tdeO2t9/URioEzTyCPEFHZ2tTvo2mD7ehKZw+1bIzB8o3zfYmfPHbcBHNZ0wgMA8tt/dN7mYUIba5BdyHGsZdWaj1A/gzg/Nc4DbHFG47+Udtj7qP7P+1xibEuBhOqyDi1t01aznRo6bkcHj7BQaCPZBVuTisxAwonaVcD6xcuWmxwlbTGJLmJorhD7Vtuz+kb9DunBRqONoAa7M0308c0WW0ULXdNUY737WgD0pCsG2I6OjZCsAhBOHxEwdQkKbbzCtu4y/WKZmLuLq0R48CQNmndpe5clAFSReDQhTxCAdUmK/lb64pZW/z7HWxESGpTCmEWMQKzAbJPeAF6dXy+ZQlw8Sdt77fZ9+4S0udOTkzY9huOY4isTGk76WgHbjQ2FpFM4swjrfJgIdCRGc7vF1BhQmuZzr561dgC1XlcvX3eJQtYJ7XGBbfZOCdBm/SE8dFUCd8HIF04pt6+7AdvEhBYsVVjt+8fdQG2wdRl7F4tS0fui5Joc4eRAmd0VpPWoIqX2M5SlgvHM6Niqbd0nZjVrO/1a8XoFZ8SUxAEbtAnQlNul23ftSsH4S86yIXvnMW6DU2ZxjkshwYogv2qZy7qRXykMYge1pfPU0yHsAqHAGMw1BWArg8mCsJvYzQNDB625rYNFZG4Fh9N/tlW3/r/+m1/71dLwH9u7/rNvvsAawF4wgbj+lgxAJscyJXgIK+af09djANvtKXVlQAUOkiFNgKpkFZkY27jaTMYpTIr+6YmrrmRVXsEO7bYNp4llt1cCo2mFHIxBYAGLnr5xckpcaQS25dcuBbbFAidcutNOQKiqoka0UrnT83xeYFucaIrbzAIc2cmzdEu6YmmKbZtp+5Ij3d7L0SguC0r3DwuHJi2vjpP+bGlx1SbR0yqBwd1792Fsb5I+dgxGLuhr1T5hwaXrh4xHWoBoEguOQElXqxBfchwLWtsmvOKHug/C2HZZ7Qb6U0CUZ7ysW7PjLxywV4mI0A1zmweU3IOpfe/HF4lPumBtRB741q+8afuP9joQnSDr2PtESxi+QfIX7v0qbO5Lrx9HJ4veFE/5ZcBnV2e733scZ7B3cQYbvUU2MVhTOTJ1DrTYG7+IdEGsJmBzbGLK7ty8b4ePHCSKQq+ff/M6TKt0mCeOAbTY7me7feThOH+TOQ3wI5A1PTlj7wGApd1VqC9FYPjaN3BiOwEARyc6PTXPvT+0kZvcG4cySf/yrevWehQAOkhEhNysrSC/yit9LXWpOiyX+njqWZ9zQxt6amLFqkX/2wwDfebAKaIgHMIxT6wwzCjlqIFlzM9N2/KlK9YAm9lAOrbAz2b3G4KoAWbHFlbr7QGZeu9M1+DW20LCCNoMnXP/AVjT9jyOcneI/fvItbRKs6wyyMGL1nb5gZjaFdIML1Jvq2Jttc3LA4m5baa+BFLbCInWjOZZgFaLDv3bgFREUgXVVQ7Q29IiWYIkCsrmFuQMOlcA2SMraNGUei1lkN77/Eef2vf/+E/wk0PXjDRBoGVLTFxMqxqGdWIgFR0jXGAnrazGzKkzJ+0M+ls5Pyqs2KcfXvDF3W6vwqK1LPST39PHTNYmFix6YSu8/PqfD9gGm/Z5gG1xByHWW/yifMFdTXKmBbsvJqpMBaU+GcWrJO1rpfoIa7/QkFlQ6+PDo2xIwhazkqnO3Q9A+hkOcDkCds5TgmsBBMPvRihJdLzHFBYBWWeyBKqr9YE0/ziIzgJbZ9Efw2ci02dT/y12+/BsCqYtYMtAxH7yfPTTVmxeV18/IQg7nFBo8EyQ6wvLS3P/ZGxx4h98/IN/r3zcz15/RjXAmDnGrZXBTKl6JU+49PMqT3gMYFvK2KYTswCnYBvKVrthwqqAPBMQrNKQBYAWfy9dXZadlEBS/LoaZK12DTeElU7ihCIgFe7IgsvAWBUZjHhkpUd1c5TeVQ4oK0C1o6r2ezneZH9MzJoD7aIWa6e1RHn9JOlFALbpCdKipIw9KSlYptYKDF84oADk3YehfDJNDVh8Fk85qfMw+AILmsiVbezhCJm5bt+1azduoCud9t823UiH/wRWHdjyciZPWlP9rtBOCsjvejdGMf82iEGtJbtX/xH+JX4tLKGSM2yiPVX61v04fr3yjeds4BDOYYCkW1cf2E8Br6sLG9Y/1GlfI9Vu/8Eu7rRh9++O2fl3LtvofZy+AEBf/fY5O/nCPnSa9TaDVGCe1LZDg/2wfY02Q/itD5A0XPn0vmf+amqus+NnDtjLXz9DzNQ6d0oagW39BOBy6jROYqePenebIeNajomhjZiw0uHdvz9qo6OTduLkYevv0wI8ZGebIc7v7MwSdVcDeCOOLBnLBMTFzYw+mCKqw2c2dmcGhhpHL8pe10Uc3GM52+ibt+X6eUJ9AcIE2nziCyAkACB1+6LGL/QTHacYtrDgGznrznXZC4dO2sHeAwgKAIe0xRZtV0MIrBqkFSuXrlpuAikH8ozUD9z5yxs7OJLVIA+ZJ2TYvcktuz9bZ/MIGdYB+03tOMYdJoFGwzIJOh4QGWHa2WqlORYgkI52i/utR+Zrlb6xTLutydGLSAnibSVHUegzr5e2Vge30ssKqAbnF/UTgVfALse1kEVO7KzizkrWIf1riKoRAKnYSgctztAFBx39vQiQ/4Pf/8/2R7//X1xGI1C7CWAJzHRxxArIFxBLHLNVxzo/CGi/8vpLpDIe8MNGCQ92/v2PWcRs9wXZBvQqANuSe2UW52GBmGxdaYn2CmyLdGyZVfPnr04wlNvAUF3B4UqvysC2+HsqbXW7r5FQ+f7bS1a8iqfDrtI42bryY9wmhX8LoNaHT9hBkqOkB5COz+ZOlPQPj8MdY92GtLupvxRnxiI7H+6xE5mzDdiqPPEZyoGtXyfepmxW8TMq7dSl5/bFLslnatCoY/TQ/ofkJXXIEdo6GGvsOikjYx332GS3ZnlpQVFiZupra//B+vrmPzp//j/+XLOFO43Zn/XfaFfEbw5uT/BW1rL3aNfRn/Vyl5dvT8D2w/c/m1zVVp7nMw+GZSdjUKkSwo2y5kV/Z6HrduNSuEsspSf+2aGGQ3zAnTngagZup4YrH8QF41FE8pl6CY9Z/jTpadP0n2oxe9/yZ9s7sE2ODpmrxroqLiiwltGK7cZUV7pvijpRWk+ltZ2tpyL7k23j2HsK24SxNbxyijWmbcPsS44UqtDgOAbzRggsJWa4Bwt24+Ztu8Z7YVGOYwLAgZEVy6FA/7W8C6Gp0ECKJXVZQmRq6/ldetcGxKwdzd22rxsAmmfrmW10z/qljF8Y4FwT+lTAVFu3tqkbiC26QjpaABrsZFdfu73xnRdt8DAZyZif7twg1Nc7sLkTS9be2WpvfOsFO3pmwOPbjo1RbkDosSMHXDObJ5nEg7vj9vEH13A2WrF9OIOdPHPY9h/uxal4i1S5qzCud+3D9z4mmcNx4pwK8CqZgUCm7156yt0rV275tqU0t23tsK+AUdWbnjeFnPVMaJo1qe+F+TW7S6KIT5BTrM5wHGyxotXWtJON7DBMCzFspa/dyAEU0dhuEjFBjm+6KZulQZUYO0rQKUawy1/wqeh262ywdQBge9qGiDJRv0Udi5kSWzs5RXxbJA4k1ahnm74B8K6XSw/8fHUH2HfJESjX7GqD3R3P2yihw+bggTd4oJauOuLJKhvYgk3OjiE3WEKKgo5WwDZGVsgrnqwztqTXgM2VLEHsrfqpa3EBpC1NJM/oIloDW/uSFgi8So7gtoTGVAQEsbTNfB8ALrIDgG8OYCsJi4NZx8AByCbg4ku2bPxTxS8mKsJ//J3ftx/80ffR2iovcRbYRg4wAtqChjJW8k6AZf/BffYS8gSxx3r+9985T+i48ZIxVLK7tZOxy1iyAJTCF6USguIFyssVwE1m8RptofPxZYRHAKg7g9qsLcoeWnyeZFNSObcvlH2dUfU2kQ2tUCdu3bLTlOohOwftYKBLwG0Etr4MTLIO9ZVoi7RVItbWF0JuwqUPD2G/PAyYa22LwDZFTCi3t4Uhua2eYx356E1zU2in9Ag+T+w1yo2Pz4y9jgvd8Gwh8kMCtltEFhGw9R0N7F9nFw6X3V0kaWlzS7JBf11mkbu0OM9CnZ2Spo7x9a26v/ejP/rn/2gP3fTZIV9QDdC+vVz667zFklzm/RF9uvpg/YLK8aSX3ROw/eiDC5MrSg9ZALa63ZPocXS78k2hVFcVnJPSIKwAbHVWdvyKTXR9lwbZDrXxJMD2cSu3HFyne4bvi6XbDn6LMHTnHlRqbZXpKJr1QlGTJqtwRfpk6pe7AdtKz1suNwnHlLbZTpNUAV0Jj8WHK0x0uwJbTT5a3QNQWGDN45gzNj5td3HSuXHzlt1GjrC0DAhTWi8xhp5vNUyk0ntKguATTdr+0zGAXAHcHCFpxHw2Ete1r3PQelv6yJQFEweDiUWG6fQr+rkbbJmHzFYhk1VghYFxzaTi7a6zjt5WB0GLxIodG5mChVhxXe2bv/iyHTyumKeAWBIlnP/okh0kVu3ZsyetEYZWDnFicVcI2Cov/Ja2JjSdChuVd6nCZx9et1tX7trBIwP2DeLh9g52wqIqnKvCji3b3dujxDm9RoSEQXvptVNoQ3MOcGaIjtAMK6xJpMFjaCo5mCJKLJGUYdzuXHtoE8PzsNNsG8pRlj6i+LDWDIPaSszUZmAmSRCkZ61vphZIJFFLRIhNQpZt1AESld+e0wiA4BOXtk8FSFGbwtjW22FkHc8dPGk9pO1VpFyl1zWyxS0TIaAFkLxxDeexsUdWdThajwAAIABJREFU7+1GdQtMihFWv9I2rOub22xqucFuj23Y5EoDFEIj9wd89yK5ONYBcJ3lkjMAV/SzyBA2ALEC+/IhFDAW67voIb/W+XfN/w2jEAAtKQKAtbOj0zWrAq0Ct1q4qP8odJq+a+RzM+G9nK0VS8tErWxmgZ2NzJsHSVZ/CP0uML6JQSsu7oQdJJv5t7/52/bOD37kWsrEgAdePAMa4jBXO1fe8SqOVDHLZ19+waMn6HWDulVyh8/7KtlSr3CxSoA7+50/W1z4lB8bdLzlACl8Ds+bnMOitfHdsvDrjramUjn9rEqvcha0eIyXpOx+MehGsOJ7ALbeK5wZTf0iTWZB2iM5jBbZ2mly7asAr9usIP3yzGSSJcRIGuG540xSZVGQZgf9nNU8F3thfMY4gRbmxB0WGTv1o9DG8Srq+9LVAmjNQS3/qv86qG2x/dgo+QloAalnWVlZxtFy1uM9NyH9yTW02dJ6jc0vrz1Y21j7u+f/5F/8n5+3Dz87/8lqgPZRo57jregJkon8kLZO2WKe7KJf0llPCGwLQ6dCMXcD9aUZaLIDtfxiBYBYBdj6PnJ8uSNGsCJPHdhuB6A7t045sNXRRVe5DLAtALxwvVIzvjM77ceH/eCMhU2sSJgwUk0Uain+8STANt2vtC52B7ZhMos1wp97uXda+qTJy8PgcCv3cmcrWzFsHz0i5SwyhJu379h9tIWrGMg0JXpmgziRpGsFJk0MrqMNB7Vi3OqZXAT6GtkyG+zCOaupFy99tK44PwnYKqlXcBAM5zlLSnkC25IAjCYl8Z0hHFm6vk/cAMBGJAX7jw5Ya0cz+th1kkncwIDX2cuwr8+fJUQYDGt+K2npHCUCQDc9Q9nNSyN2+/IIhn8FwFtv3/yVV4jMAPvbABuJNGPi/qR98vF1z3D2yitnALYnram1AfZy3T776LLdBBDLs7+zrRPGlFi2gOd55BCLc6u2ucozKGWwNLHqLQo55PUmUQK/w9LmSQAhja0ykrkEuJ7nawLct6JhJQ1wHiZ7E3COpM6TRajCFMe6ET3tvvZ+O4sXdCcRBmqps0YeTY5ji7QXp1qeMG05QmTVSYpA3aaEBYk52qT+N2rabGy+3m5PbgJw62yJiAibZELr399qg4fabHl9FmnBoge31+JW4d6oFmfAJGqQBEG62nmY4nkW5gssgDwQPs/kyRqYTCVFUNavZrb2m5COiKXV4qWBPiHZQXOzjgugVgDSgaYWFiGEg3/2NlcqYYdkSY6QgG0Y3f7/LucJA3H4/n373f/ne0hR3gsjxHcayuQJfA668IytKwODWWs0QNzir3z1VV9gzRE55N2fvF+InFButcpZ4ezvgYMvsqy7AdzyaycA6v+qbcOILDmssMj3qgk+C0lP74uDMqBVWFxXmGKKO0ThFqm6CovojJUseU4/oDJJk71NodXUxdMFdgG2oRzBSTULbN2MxAtqR0kMZwC2oeCuZedDAP7BmUy+BR4hQbsRntgDbXCVma4asE29MD3XNrb9CYBtkZxI4JaxgD59E0CrONRb+C0oxF5TS70dP77PDpF8RPG7pWMXeF9ChjA7P8vO1RrjjfMY89ML6wK27LCsYq8WbgP4f/XT7/+rXy/vY88+fzk1wLiTt/G3eNOY9jZtfu/LufOT32XvwFZxGReSFGG3G+7A5jo+2MEiZC5dDhCzEK4SeAw5tuMUsu0+Ybhnr7HbU6Tfy++V5ZyzW3zJMFcDtqlWtDIv6BWj8Qv3yl75cRjxCLwKDxRKkExNwV6lBYJ+rTA5hjJtr5XCV6rfkp/3WsYnA7Z+KzEXIBVtzUlqoF0DMZGjbLVeBxjdvHPPHhEAXwkEnO3zvhUiH/gkyf+cRdO1AB7S1fqGWWQZtD2u5AXNjc12oPewtTZ0g83QiJLhqpZ0uqqSUG36g+nJmU05eiR2DmbVnZH0dZixdN+QGIJyK7wXTC/sg7OadWQea+rA8QgTUd+0ab3ocwcPDhLZoNeZQIHLNUDt9MS8Sxom7s9ZfpkSi61qyNu5r560F79ylJSuOVjeFbvyyS279MlNl0YoScSb3yKxQy+TCvd/ODxhb//ph+RBGPNnEZMqNlv1qbBhac0htrYR5646jlH02bAoYkJVs7kuWX8rNoISHbDVD2O7AmOZbwPpkiFtHXC7wWfIb8AdEhBAcAPPfgQv6HPHjlhvOxMZjE2OyXgDpn3xwQiyD865ece20NjWb64pgZe3n8dCcC9wOaoR6oskGSNoa+8DbCfR2i5S7q3cBumJ261vCEeyrQU0z0thNyK2vUJ6yVklrwxgqk+AwSKZ4mZJtzyHZGWdtlBKYIHURtpd2loxtgK2khu4s5ji23qEhBD1QGC33qMtCNFGW+I7AAHg+jasA5hizOC92RcyixGu7nvf/R466k+3AVtdI21rJ7tZaexm7yWnttcAt/v2DzrY/xDd7fC97Vk0dwS2cSyVA9pqtjssTMJgKYyXUPjCmCytjwqGRmf6dni4QpaiKAe1laUV23WvxWVEWHCUv8J1drZjhfpOdmRvDRtArafRjU6VAeUHW5LKwkextkXGVovukHq38Mwx5vFWjJYQFnHa5Qh1WK1NivZwe81Xir5RvpDY6TFL6z+0cWCcKXcDiWcwcFvS16KzraU/DpCk5sXnjtiBwT5ra8Yp1xMEEpd5ecHfOj/P1s/icp4xusZYZWcHsLuwOOdJVppaWi5393b/rR//1t//7T1W/7PDnmIN0N5ii6S9Pc37Fm9FTthj6tGnWJA9XmrvwHabFGGnO2QMRbpDYZn4xQDbsIUZxrrfqgqAflJgm33abKWVD3Dd3U1lXJInxrLI2KpsYXs8AIhsfSSAuruxLa39CsA2w9jGasna0kgZhKuUTJhVgG34OuO04Z/3AmwLZ2Yap3rf2dY+Yih4rwMetb2+AFs7DeP4ANbvOtEQlE53glihIS1AnBB9MnWlpvajC4sZMSOeWcpZkaA99ZBfgN3WxlYb6jlkLbWdAC2kAISmqvGxnCaiwGGRJtJBbShnYGyDbtU7nE/GQfqg8giQxziU2p6LTGjvgVZ7/ZsvAEBbcXqatRFAusBXG7FRVd65uUUbHZ5EzkCMqxUAKawquJEt+A07RFre17/xItEAGm347oR9RlixqVH0xcxz0gC/+e0XcT7bbw0wJErGMMJ1hu88tFUiSbQ2EYmBZBKjhElTuCmF/ZIW99GDcZt+gF6YeLY1eZ7dAXxkDiMrWSPmyKtCbC5JJgQciZW7hYZ4lfBXqwA7aV/FJMmBrp7rtpDooJdn6sFZraeN5AzIGGp4tpr5adtPhralW/etlugWLTDDDc70ekqGAHLFfAO4V2iLkZktuzuZt1m0z0uKN9uct/2Huq2bpBkbmyRlgF125y2PnRmdcRRGCSBPkjqYHzKQEY1iHrZWjK3Cralp1faNaGxbALVKuNAsKQIRJsTOhmQMLEAUFYGJWYuOADA1fHVtyuosbQwlFx2BAjO3dxsXxlSYH65fvW6/8S9+w65eLE3QVAQuYfwloFsZ3IWxpd+OHDvs2lsB8utXb9rFTyWV2/sr3SdrI8rPzoYrC1rrMGIKcjwHuvomOHEWX0VDU8kmq/xJR+7Pk0gJJwWKC/MsqNvJoSuWatvDJ73q3mtlb0d69AOXLEUJQlwgO1sbbUdhYREXRW6p1KcEbOMuUWB3gywhL/141N16NIdITmT7wW6LnlCX3kChn8TH8TaoQHakvrRtWkjHun0oLhmkSweF2mZjm4PbPMxsPfbhOElqXjpzlKgzXdYOY6sAi7Kb8yuLjFGFNdtCkrBmc/OrjNNVxukKtnHBZhZwtuWziI12HM96ezo/amtt/Rt/9M//1n/aW0s8O+pp1gD9ax/Xe4u3WM7v079/Jh399gxslx8D2NZqgksIM1i5ADidBSgOqr1UeHZAZQurcwtpdAsMaAZF7wBs93Lfz3tMIj8TOR1gTjT7Xt5KoPBpAluZm3CPkpA1boa2vxyzRMa70rOr5Nmtw3CN3YFtMLTpLVCQ2OriXbLflU9yXiaM3hpgRFmdpA+dIMXs/fsjREO45YkZ5nEmU18o6Bqd+Y7gk1unTwrcnyYczY6BW2MbHmPcBug7qIgIaOXr8wr1BXsJsNKWoPsFcahnLYsyhzQlFOIYO6gLoKOwnarJWNpmJqq8ngObT0RVa+3P2bf+4qtspeMgpq1+6UIpiad45Th9lub23p1Re8C7nhO7MOpCfGKB60m8ICA89Yi6uDtrW0gKVM488XYHYDJffOOkHT45CGgL3sgeOggntTpA+crSul29epdtP0KFnTpAsPQcOt4ZO/+TK3bv2qQ/e45nd4AWV4iqpRDvU9XKdj9lXAfw5QnfswEbu6yUrwDBoF4NMTcFhMNbmlu2/QGsTbC9DTCn/c01duZEr40TWWJjYtZalB6XesjB9jYBhgkFbM1Uuhzflkj3+2B63YanmfRg0tdow8aWTdITM0F2KbA9bK0yowmMR71ijbzMAaWIZKn3GqQIAFu2NgVql9h5WmdLt4b7KCRYA9EOFOarhbeAbQPfexpdz0imhZBSgoqN9RESOm3qw/ozAtvQr9Li5nGBbRwf8fKffvSZ/ea/+jd299adMH4zgEOfA9gpvUc11k6A/Zu/8HXaucUdyt77yQfeH/byKge2yZZlzy0uioPjn1u4VEDv/9UY23gVZ+e3v8pt0U4gPp0dtNlBQlEAjYVCB0BcPDYBO428Cqv5vVRQlWP0zEF/HXbgXLIU2y1TsmChfK6UjY59R/1ICzSP6BJ02k5zKP5ylCLImUxRE/QSI1+cS8IzVWqnbFHDfFAEtqn+K7VDOi/VUJG9Dr8Uo+F6aUKEBxLc5BvJkghZsMUYa8Zn4MXTR+zMsQPWR/SRbqQ/jYyvNSIiLBB7WlKhJZLNzBFhZpZdqDV8DpZ5vrHpKRtl4TvLTrFHW9HuiI9PtPFNjR80tTb91U9++x/++HM01bNTn6AG6APKNf+LvCVN+AH9/WcuDvEege2nkwK2C2wDF6Fjdts81k5krBITqW8LAyIOpsyYiidl14yVarm60Ska/IqmscBE7tR2xbVmGuiPY+R2OjZbJg/kE+siGLDdgW35tSvdK0LXLHKNID8AxLCQKMLKUBMVWs5BTDSxfozfLd6yOKWXM7aVylT6XemkHEtS3lwlE04ReKdoBjLeeWklcf6ZQTc4hlf9HbZWFb/20aNRW1U2Jy9v0KcldiaxatLRBpZWLF30PpYGM8aMzBGapg1jfHjoJI5jLURFaIG1FWupCUbvVDMCbHHykBohMreBdStO6omtCn1dHs6KKsBRALh14sK2DuTsq985a4eOE2+WyAcCRe78qNEVvew1PSt8mTSx2phsacb9ijJvQEEuYOgf3BuzSx/esZmRJXd0Cw5TSB7Ymm8l1eyxF44QGuyQ9bIF2EiYMdWLyr60sGoXPrtunZ1tdop4tuzsuwPaBbKkXfzgDtEKAPXrnmIhwH6F6NKUJcCtxZjkFTzTBpNLHqZzg4xYSwDbNa6/HutJrK7qWwuGEAgYYAvAbWBrsXZmwQaQY7xwptfuX3hIcgic15Ai5KgbsbX1sNqQzTDnsKlMflSBLeRrbQqHvCX+3oS6boeZPnCU8FydqvMV7hUWD3JaEbithSWqAdhuakHBU6wyUXqKW94rCvUlsI3GOQeQVUaxJo940AJrD7DlucTI1gFYA/AIrFsA7KFnOXsYv0+RD4Jj4nawWQ5KK1q4EuCqgRjGyQfvnrff+vXfsgfDmWRAZUMuCz6rXVtA/RvfftN6+rqRky0iT3nPQ5Dt9qoMbLfb2rCYyyxzvZJCQSNeq2J1dNzegG15WSvNGgnYhvtmyukHB7vrZqK8vncBtlmgnK5d3q5FWUeQpri9ccZWtw07IKHnuKGN5Qn9STIEL5d3MGn/42LKbU/c4teZsldaBIvhVDgw7aI4sI27K6mSdE+/W3hta7HYKOW/l88TxTqX3SttgeJCI44P/a6DFLe2scM2GnFwbSLyAeOrhwQyZwhDeKi/G2Db7OC2CZuxSBrquZUFZ2xX10n1PY+2Fn0ta3BbZJyOzRDSkeySK6QR1y6SP5Cbd9WJbAzSrpr8nyA1+5/u/+BffFDeR559/uJqIEoTvs0dxOC+Sz+VPOFn5pXt88lu61/tG+ld39HRkfvogyrAtnB28TJuUBiA2YGVxrGGWCmzUA6MKiGenVjB7Co8ecw+Xt2WhrEpXdXvfKXqZiDYqdJnSZ8qQcF0n2BvK9VBpXuFunRHmSww3G25Hm3D9mdL9wgXKxhuPhYm9AjeqtVLaPPdWFyBozIjmUmUEcBUYHW1/eRTgRyCsHbLbCcrDuwj0onevU9EhFt3PYSSMkt5zQFEQ8afAHAJluPbzTKK0tnKECaGVVvL60wSHEJHb/RQX0cAtjV43iuma50cx6JWN7MkcTCsiU6OQiHLWbHfFY29W/kIdkMigLwDQvSeWyvWMdhMZrHn7dAJnMBgG1cpv6IfPLg3SniwNjt6/ACgDUcKOWzxn9SxYS6idnEicSkE5btz9ZG9+/1PSMsrDVqzg9jBA13W1MWWfX6F51tmnqkJDlGE0tE5G2tbdufOMAkiOu2lc6fY3mshO9mUfUa4sdsXHzmor4Ul1SQSttVFk1B+tQVtohZRFIRNJUDo7rQ1JqklQOCawK6qw1dwMQqFQjeofjhP6RIamMhqJudtkOgKL57ps/uXJ2xWwDbKchzXuy5asgQh9bD1WoMOdpN2VF9Y31qzru56NLY4fXWo7iOwJaqFQC377jyzPLKV8QjG1oFtkLEsEg7MoyIAouUIllO9KOEC15eOthX2tl6aj4iBkm1w2VAYFEGiESGDgIvPtYX4yKFj76Z5DDtXxUFQBEnFce7f8T9px9/90dv2PZzMxommUP4q2YqvMPazAOzVN162o8gT1ulDP337A1JS70C0xGv59aM9S2OrdABHfaX6BguGOPy83UNdpKO1QEqgroAxg/GK9qsEizpYK7MTXm9FwBZGWZaa0LVCW32RwDbYkFg4HxOBrfbuT/ly9KEcY0bxjfUQ+qUAQFULsqkuVQovX/SmZ+UBfZEGqA3h5IKm2wGuA1tsYcxIFkKBhXGZ+ktYdG2Dstu/izY2tZF3b723nxoK6fYg/hkLG/qxniOMAz3QFuNqq6nb8s2EMhRjiwxhYF+fnTi83wawbR1IfbphcNuJPjK7MGdTJGqRtEkL0cUlpAkA20Vs/TxjdYpF2AwL4TUW825z496bpyD20INImJRam/CHPW1Nv9/R1Py//MGv/c3PSnvNs09fZA3QB17h+i/yvsZbKXl3gjhfZFFKrp3txgm/6N8SYPshwFbhvhYUXD324KAHKl6r6NGqSbf4bKVYrQhs97K1FIbaTkCpYA0es8KSMS4/rdqornT54jPuhiX9CQLq81clxtRtR2llJTMSTwxmPJqWQoFCOPvYFnvqUmLGKh2YChh+qwZsszVR+Xa7A9vsBFepBRKw9ZA3MtoKUo6xWyJ81hRpSR+NTXqIL0VEmCG1rtKlOpjVf9GxSzOgtq0EbMXYCtg6k5hCSknnLB0ns4oiA/S0D9q+roNWsw7YIbtVndhaDQNNNKl6Y3lSc246Q+y1VfYYIfRcAIKheWSMFQ92o2bN+knL+9VfeMEG9rNlhzhhlNBg779zzR7em/C4t19583k7/eJBD621jlGfI8GC0vTKZgzh9d5FCDFNXmJa33/7AuGjpkLyBjRsbXJMQ4KgLXIBDTG+qp+piTmylw3b+OiUl0sSAd96h6lcmF6yufFl21xCV6poEEyg9bBGW6obAXSFT4vJP9R2YmzXAbb5rg6ALVKEArDVjK3aCBNtIUaAGFtFRWCyyk3PWz8+Zy88P2DDl8ZsGn1wmvwdBPuCQIuUUKcev1NxMLUC4dob+WXr7qmzA4dbrbUNeUU9qWnVRnKGg5ms9bccVuTJJmALpwsYkK5WC6ANNM8CokqPmyPagdLoKlFGIwySnMkUxst3OkKIFW/aZM6KNiu1eRiTHhUhvkoAa1mvqIoZCvbSocW2sxzjA2J+9Ec/9DBhU2SiK752AzERhsfLnjh1zM69ctb79HuA24cPqmQrS7KKjHELELJUz5/Ajbc6Doa+OBFoinY7jJ0wpewV2IbqqA5sC+KB0N0y01DYGatsj0uP9AVq4cAym5U1tfH62VbReSQTCHID/sszlsQ66uaSsgi0tSprnXTozkbS9xiDvpD2c7TuAgBGe6KFk8de9vuGuamW/uypvqN2OzishkW+J26gH6+zle8yJjmvej8NpUz63GxHqgR2S/tzHLc7TIGKdpJe2d1SjXON3C3tPLGozDf3Wr6lx7aIxiKg2zPQjdNYr/UDbFvlPMtY62xtYtdgHns+Rd9eZWHO7g9+DXMA2znSkM9RX0u8tUusnSvFC/eiCdS6NVAPW7PujkY70N9uAzDBPaQ2b27IfW/Dcn/tn/7q/3CjbCA9+/gF1QB94SiXVsxbJXL4AX1tNxDwBZWkslWsCmzPR2C7KGAbl8zRVatwpQBs48CKBsfNdNlAqcZmVH7SSoY+O7hUfxGk+tcZsFml6qLpCyt/L286J7v2f5x6r8wUF0FqrIzMJatPcD5yy26eylgZRqbn2XuJU8ttn0Djmj3UZGE2L588ineqnLRhtz4dn6dKJcj7P72cieCzDPcGxm5RwJaICGJs5TR2796wTc0CbHE00EsaUgdFmnSik5hnhqJvaiJKW+TOgnCcsx28CUYDizCIcdznaXQDYxu3Ab0Di2X2DhNZ2DR5h8VAmMhD/0vVFoCtvgkTqFiZTYDtGgzj4TND9pVvnoZhbXcP/Ts3Ruxt0uouz20Q67HVXnnztJ1+6Ygne5ifXbIrn93B8eemA/FXXn/eXnxZ6Xnr0Y2u2M1r9zH86+hlDzso1h0VF9fzznPPeiaR4OCDB/L8Mml2p60DCUGOetF4np5atNs3H5IlDX0tAF8ZgZpgWaRr1vFKGrGOm4BS4kpaUEMdb3DhDdjOdTS2q0woS1wfeOkOVYnNDO2gRYPeMKSUpxHv5rqpWRtEY/vCCwDby+M29ZDsZtETPsglwpB0ViYy9hoSm0q7y8y6xcJgYKCBOMAthDWjbtEVh0AVMNLSKMtZxVN5KpYmb05e596rbG1Ka6s+VYfcoBFQKxlCPRNvI8dJeqC68jKX9E1flYQuGZrbnzFMsqVjqNy2FS3LzqOzEmNbPCO0XWLlxLb+4L/8sf277/1bFjxzO164MitsNkS0hG98600/9+Pzn9H+d7ZfZ0dgG8B+wIWpsnzJE4CmqiyOiAKfmraSszY61me2uiuB2nJLVeDMKwDbAnwtn3ccgqZxqv60A7DVmI6OXx7oRI5bsksRCDc2KIoKiyKPXmC2yqJjgXCDGwDcng45oXZbJwtGLaZXSURCzlibml8AtC17VJIWQG8DCy/fgVC655g4RPfQWJXNUii6MLcJqquDBwmVb2h4eQKw9TBgHu82MLehzQu1UGjXpw1s3drpfn43H4AUEyU9kq51QG2eHTC8Mh3YNhHmsKenDfKgGdDPuGPctMHcrq/izEmorzWSq8iJszbXzq4KzrNrm8gUqBckZiIznIBw2VdoP18QSPZUu24Hiel9GGB7gGv3wwS3seuiXcyZ5bV/9XBq6W9+93//S/d2Hn3Pfn0aNUCb9HOdX+KNx7P9Mf0tiMD/jF7Z4Z8dESWM7fnzgbEtJGgIYqAMBiuVGAS9ZnxVATDbmYnHr4HgTRy0TGFyDK/tw7p4bffaLDHGGjRuQvy/p/dSDUTLvY2F2X6XZJAK5E3hkJ2BbTmDsnv5g/FLE0jp8UWgX1ik6IDt2NxP+0KAbWat4WWQ0YaVUGIBhZuTxvYRW6jDIw/t4cNRmya1rPSCCswfgKTSm8bYka6VVKxaQAvb0iEMlwBwcNBQ0HM9Wy1Zxjqb+qyvZQij2wq4BcR5BjPVU9JXhrZMz5zChfkd4za5V1Xs+OVskHR0eQxxvm7VTr5y0F5+85R19jQx8a3ZlYt37fyPLxlRq6x/sMdeI53u4VODfj8xre+TuvfW5QfumX/21ROE/DpFTFzkBgDF8bFpD1HVj35SZVoi+sEYqXLHHk44+3js9EHr6e1QKEm0uTCzSDn6+3rZelc6cAAp2ra7RE14NDxqg/19Nkg4nkaAreYSjXc5lt2+ROSJ4WnbXFG9klJYoB+nsXVivy63NDiwlUOZdG++5Ro7VWDPwZh8rqOuGwHiddOztp94vGee77e7MLYzjxa8XTRFOrB1bU0EtnFB4YBZbCDvWmLY7t/fTCirZiI/KFkGbL1LAXgeGFcB2zrJEvgXLxOPDStgK4cxAQGhViW/EFOb4znF0qpv+AIoyRAyFiI8SqU9lkxH9XYP4yoLIJJFCvKFom0qH6NZucD2HaoisPVxGFH3Co5wf0iK3v/wO79XNU5tuk8lUNPb14Pu9mseMeEyURiuXNROYuZVEdimughAO2SaSoxwEX4WGdOMJc5OCpHQcWtb0KmHe2ftUmZtHQBNWlD43+H/Sm19YPz9VWbKE88cShnKHy6hxWhsKc4JOvwg3xF4laxAKbTFHq4BItVPunxLnd0OXyATW5sF08zKEgB3zY7uH7Ijff3EaaYvKu428psZYrWOsrM0Tt9vbW5H9oSNoQyas5ZZlC6g/V5iN0PlaOG+LVxbTK3C8rGe57paNArYhqcIC376M4vilKFMAFngNs1k5RWwO6EUlguVpAipKrdvMmvnJ8ybLj4k4oqY2o3WPt6ETeRZN5XsBI1/I0ljWttyPDvOZCwiG4mCUqNIN2Qd2yALX620uXVttraJwyjpv8G22EbALbjDjVEE+f7sssMuX8jbmcODdri3xQ5hD/eRAKIDtjzP+VPYwYezi3ZvduGf3X0w9XfO/+u/9rD08VXeAAAgAElEQVR83D37/HRrgLZhNWO/wltM0x/S57bn9n66t6x6tT0D22W8mZdgeApWIwTCK3wu0XolYFsFJwajohXzXp6y8go0mLbQ4UtfCVBWvra2S9I5IVh6OH4nMLyXUlY/JpVzt6vs9Jylk2jplUq3Bne7y87lrHAf/yqszINRCWylXl8EsPXJSv1HTK0DW+7pXv0wtmStmmVymJ2bszG0tZNsyc4CbGcBu4pRKi1WwEXKWAWYlTORtvUoq9gTlV0aSoGZGihU/0+6XBIydDT2knVsALZWoWgaC9vooZMWJ+0CsA3VEtd3cUbkn+L2XuyXYhdUf0yIchzbalizs28eszOvETMXJkNg/eInt+3jd64QzqfGDh0Zstfeet72HWIrDwCgDGbv/vCijd2b9kn13Bun7ezrJ9lGJzICLKRAfQtZsfReRaOmmLWXPsSpbnjcJ5M3v33WTjx3EEYk52mIBWAGh/rs8JF9fNeAvjdP6DTS2lJXQwO9xHAVuyzQokgLDjctz3WvfnzXPnqH9LvzipPFFiNe9hsA2wVYzhW+Sg4wAejomVUXcduVz41ixmmrHMzVvo4cwHbA7kQpgqQmaWEnzBNqPLIzHkM3qBjRiVCuDTTIXYBzYs2SIW0LFlyyC2a5KEWg7dTu0tkKzbOAWXPgrGgOnm3DGVtpa/WvJ1yQXEXJFdTW5YbAmz5jY9KfPi62705UlCIUQNR2a1Vuu7K7SOG0JJuKRlVF9AVX+CxnsP/8e39gf/Af/pOtxp2LamO8HNx0dnXat37x6x4F4g56dXwpiqdWAra+jZ4B2v456l4LQ6QAgzL1pmPSAXGA++olDK1KhEJgqENxEkNbsOw6NQ7LSna7/Dm9jLE0hVLEP8KiKT42fa2evtQO89fX3WHtYlYZB4rIMk1mrCnsjMK/DbEw7JBGW4teTl5i0TS5Snxk9N8vHD1qR3v6fIdCGcNWWUxN4yA1PDVlEzDsHa1E8yDOaw2h+BTCcIlrz7FAnV9iHMNi9qNbbyXBgRb0y4DdhZUtm1WyAoFbtibkQBp6BXIEadDF3kZnsrC4T7VUOi/uGdgWWi07v6dhUbSD3i6p7agHH/8kZNho7bWNtn7bbOsjY6EYW9T1yA+2kEcpBGEbf7ew89KoVsV+5QH+MAyMYaX0JiU0fgCryhgoV1Keaw35EK4G4Zljv3dHVs6vb9iivgfsCLG0j3Y32eG+Ntqs0RfrEySgecB8cQ+51o2HkyvjUwv/dGZy8+/N/+BXf+Y8+KuN15/H7+l/5Dm3v8BbrOP/R5st/lk8xx6B7YVJeaSLwUnbDz6A/OxgMgLWKVii2BMrPVIpUMiChsoVsBdgGwZzweDHQZAGXwLAviWcWZIGmBa3b/xxChYuU5TSwVxaxqwRr9Z84fwsS5oF9GmLMRxTCaRG658BV6V3enxgW+kpg3VPM40QmgoUy56RB2Tv/WTANnuFdM/YjRxopmIoMYPc4Jl60FjJaWqZ/rcCgJ0HIC0wySim7dw8Oi2A7iQShVkYySW2/shvwCQjAIPeMm7NJUcOTQyKUepAl+MkX2iEpe1u7rOOHMAO9hYTTDmiE5H3iozwJjaeWF/fEkt1Ux6mMz5mwsVydthAhpBr37LXv/OiHWUrvgGwOYvh/fCdi3b9U2K64mJ1nEgGL3/ttPXsa3Nt3sjdSXvvhxeIfkC8V3Rpr711zk6+eIhED9rGlG5v3UNVCRzMTBDd4P0bdufKQ8uzpdfciTf8L79KBAGyqeGw9Whk0t758Qc2hDPHq68RC7e10WUcSk+sGJGdSAs2iaygRaxIEiUlaIbVVByvkTvT9v6PLiMdUHgtor20s+UIczVHXa56GLI00WWHDo3JdXJMZE1opGuQjdTTdvtxjDv94qDdx1ltanTJ6zHpqnW8/i50Oc6Vk4zMzCbxahtI8XviBLnmu2nfRjG2Aryc75mOAKlkLxKwrRU40FaxElI4a8tUKJEgZa0DjCvzm/71DHSeslbe7GEy99BLxe5f0ZY5OyZg55KPcHzoutvtRQFU7WRKdG4BYW23JQnIqnxZO5duN8cY+P3f/Q/O4q4DGIpgLVjoQmjEaCdTmdtJb/qtX/yGZyq7h1Ph+Z9+FG5eFdimssU6KswBcaFXKHrWbquOAjrx+ik4eIVKexxgW6joKsDW1yZxzBcXmUGwlV7ZxYOWPJoTUgu2shg8wK7JARjtNmmuKTYEoE3i6DRK+CkByQN9A9Yu6Qt9WuArj652fGUO6cuWvXzqtB3qhK1kh2kNJlaB/ObWAVhTyG4AWl0t3daErGdjGRmBGFuY1xm25Nc2Vm2gB+fPTpw/FQrLWVx2qJZwLEUSJAZyncW47JUvxHhLd637u1QLEK13kCUUlgDF1tiVRSrtuV4jpdg4Skwy/TSytd6kmrsaWey29doa/gqEZiEYVJAiCNTWwdQ2sBgXW9vEeM0JnGK/1pBwyMYrGUoeKdQqEVDW2ePR9TZ4LoV4dDlTfBK3uerPXKORNN+n9vfaARbKx3oa7SiShGbs0RoOsmNodUeot7v4J9wcnSZE5AI2cZPtodw/3sq3/P2p//w/7qzj2T4En32zxxqgjdo5VMytZkWBW8kTvtTXnoDth+cvTq5EYBtKp4FT2GjLmoz4W/lli1AqmJDkQ7qXZ90B2JYMvHDlZNDTOA6fE/ANf2fnj2BwS7fms5ESskawtLRp2zGVr/KzbGPwKkx8xTIXt8iKV9tlNvQDyyxQPLkw4ZZNmFmeyRVcDvIyUg5fGQfAkK5eLRVuYnFTeRXwP70KoG/HZg7Hp7N0ut9LmjGVSdl2ALVbgLw1QNgGW7CrREdY4e9Vtqnm5Tk7D4M7OWOTgKZxGMEFmNs1eRUDbF37TfXIEcO3ivnPc1olwAuYbM11WA8OD83W4el0pbl1x6cMW1uyaPJr+Awat/8oMwUvTo9pYlEWruCqx9QDG7Hkobje/OWX7OCJHmdHJ5EavPujC3bv8ihZrlrs9LljMLInrLMPqQHPeO/mmJ3/0SWbB7R2dLfaG995yY6c3gd4E6OjNMKARhyhtFM/cmfKPuBas4/k5Flj3YOt9o2/8CrpZzsd0A3fHbW3AbYnTx6xl0m/qzBgsywOxoiKMIAEoR15wRrbgjduDNvlS7dwxGiy504ct8HeAbtxme8+uWNrC2KfqZ+ODltqbbYFtrK138R8VGRt6W+eoleMLw+fY4w1sq1YZGwb7MTZIbsHsJ1+RMIG78GhDysKQIo2EKIrhOD0upCALY7W6InbPSJCbYNi64Yt8TqArQCtZAjS19ZpC1Q6SZxw5GApcOJMNPWgzGL1sLUuPUgJFhxhxTGdAU2F3lw2xFK/1/OlnxzYlvtNxAvEfGS7g9eysVICYjO/ZUFwdpxPEQrv97737+37f/jH7li03f6Ei2QZPMW4FbhtIbLGrRt3yICGY3n0xM9uq4XxU2YF3UZEWKjFoOrAn7loHzWMHI5EW1ziOO27Attf5Yxt1mZlblk8NxYjldDvqbZx6Yb6Y/EVsLhSFWsHR0IZgaiwtd/b3W4nD+23gyQSaJE239u01qaX5uzhzCQL5zUb6upnoYb8htirSuFcxwJ1eoMkKWTke+15op104jzFTswqTKwCgywQoeQeGfbmOb6T+K61LDpXWDzqusvsOCyQEroJ4Hd4cNC6GHPS/a8z3y6TUnYcB6thZAyPiA6wviFnMskj6NsChgJ+ch4T2IuJGzyBAxr7sJBJ9jvYqr2+qrK71KU788b5JNjSOHdKDgiQXW8bIAyggC1ZWJtxjmVXqIYU361kKWxjkdwsGZAakPpeBryvesIUMbaMU0VtYaCKrfUxy302IDU8QkrsWL7zwvlwvTi/1tkxQokNIm063NVkB7rxD9BCW4zt4oY9IuHD/ZlFuz8xQzptJEu0WT0Lg83N2mke4u9P5lv+if3Hv7R73Lu9Vtyz4wo1QB9RjNu/yFuat/+XPoWX8Jf3egxgK41tcNIpBbblhU2GLmvu09/Fqd+ZkQLo3OmBdwC20ayVgthwrUqgroRV1lM4c1BpdVtc35ezKNsH/c7A9nGbcifW5nGuVbIlWgZswwQcHt2BbbYK0t8ZYBtsihDn9hJ8HmCbJp/Uo3QDMWByXJL+SqB2C1ArLWweI7jJe4sVvLbg1uXh7g4GxEKExR3HKWkcYPuAgN5T9NMl2I0ttrfEBNQqyH6UoGieE9QMb0VMyFlXUw9ZsTqtYYPjiQpQD7B1k10B2BZAmEtxQiW644ZAUwRGYTcj/BaJLwdVq2TJ6jnYCrA9Z4OHO5zFGhuZth/9yUc2ObxIooA2O/f6aXvuZTKgddYD2tlGu3DPPnn3qi3PbtjAgT57g8xi+4/2ASQJiUNmHjk8NeMwoUn21pUR++BPL1l+XoDa7ODJfnv9F85aew8ZgKjXG9eGAS2X7JXXXiCKwmHqBi3a9AKOeCN26OB+6ydcWB4nrVElbHifhA04tbXVE0asvc/WiCO7PAuExXMZDsWae3tsBW3vIuBwhedUuK88N03LFCJqacrzia9BURFoOwHbBp6pv7PBTp7bZ/eQIkw9mnc7ENZDYaGQFpYanx5D2Puk0havWjfpgg8eRXrRpmgJYmwFXuQsGJlahTVj4q/Dwce1t5owtQDRgUrgIMZW4ZgAt3p+NyGRsd2+hR27fBVMkLBD0XWwArCNnTsKX4rAtmD/to8p7zkJPPgis8LAKzum/Cqj6M//3W/+rv3kBz9y/Xn5Kz1r+lfg9hd+5Zuede3m9dv2yccXY4QB1VGQGzjILreYBcAUYE6pHrlYcaXANlOaPcSx1T2zVEhYbyfQlq2b4jzjDqLxVSh1rEcx8y1ow6VNVxfQS8kCZEt6ukhwcvKYHYQ5zSmIMm9p21fYybg3OYptWbBe9KM5ZENyaNW4qgOwTa7NwUrW2sunn0ND3m1bLErXkRIQbdbmCLt3b3wMhyiyZ9UTI5tztSiXJnyFfr1MkpGBvk47NjhkzYC7FcaInARZxtvY8rzdnRi3CZxIa2tZvMH2igjT2n8Nu7gGa7vGol+AVuBW/giyl0FvW/pKNZX462oAdtv33u7R3sU6LCzsNDR1YTGuyCzWcMLdAtiut3TYVksrYBc5B5Krbt4d1FMLdZ9Tm/OWj4Bs9zLl3VIyHKUwZyWwgW2VG6J6bUiLHoRJPl/wVtTyFQkXCPW1n4VIHyx7H3XfQ7KZZjHE1M8MjLhY2wfTzA1kO1ymrWqIU+jxubWbp79qaseQJv69id/6y/94+yh89s3nrQH6iBI5/LdxsP4X+tWXtoh4KsC2aITTNllarYeOWRor1nurT/xFNnSn1WTRWD1ORVdmK8PgSK9w/6xON/xYdcVasQBPF9hmb1GJlXmcOqh2rMP5ODkIUOgJgjNUZpIoB7a6WAVJwucFtrpsATPrDxlkgO0WzAh7Smwfsd2OAcSK26a+w4gHL2U+w2zIoUPes5NsxU7AbAyjIx3BaWBG4XWYJOpy8raV1zsB+ZlIxAZLZyspgsKA5fDk7WgQO0OkgHWO3+BYpAhyLguvOIEG2il0XfURN/SqN5gFgXD/OcI6sVAOcnVgmGDkKJKvXbV9J/vsa7/0knUP4eTA9uMDWNQf/8knNj++YW0wpm98E5nC80RnaFRq3VW7iF72xmf3bIVUk/uPDnn824H93WzZ5Z2plk62nQlkY3nDrnLchz++YpvLsLjNOGi9fMSef/0Yzsk4eGHYL352265evmFvfeM1O8K1pPudHJ8HxF5wxvbsSyfY3sNbmclxZhrtL/e+8tFNUu0SEqsG4MjEoGgRed92bCBOJaAR1mSD+t1QrF456HlSBK8grxfVQR2Tr0J9bcImNrC1OtDTYide2kccW4X7Woxez6rqMP48dm0CUqkuYbZq6tatt7+JGLaAeSIiFICtImDUKo4t27SSI8REDQr/5Rko+F3A1jOTuRQhZBdTJrrkdK77arIrtmKm9XcAtkWHmtj2hS334ugr9JeMDCqkJy4fofGL+E/2tuXgthKcK7Edcaw+GH5gv/Mbv23v/+S9ErATQGoCh8FeS47ynV/+ptfN5UvXPbVv6Meh0+vv0n26ABmDTU3ANsH8AOXTKwtsiw+uI7YDsDDsSnfWpKlMr1Cc0soLU0oYc/rb5SXxb/3rKWgVdYCLSI/ew7O2sPip95WnnKYInweIbIZdfPH4CTva2wd4ZcwqlCDHrJP2eWRuCoCKdh1w2VaDhhs7ta4Y2xjRiWX04wCsF44ftyEWqPVoaDewVavcd3oV1nVygnCZ6zipdlhDHtYQwKxdjhWuuwXTe+LQPrz7B6yRnZe1eUAx5y2i2R2en7Fh7rnMwrW+FhIsAr81nmWFayxj/wSCPWED40w2cV12U1nKYoX5zklclPhXFSVv4eCKc592vTJtmXYRgqwk9OMtpD/5dpjqjv222dpv661kHkMilUfu1IZTVyf/dstWMebYqPKyLrLzNg2wXZCN57k3I/AUMBWwDVraEBNf65QcbK8YeIhXW2ahoTyOg9jMHu7TwZgWG6x2F6hfxHdgCpZWUo4V2nEF2YjvIBKj2/uH3r4q9p40zPP9nenf+Mu/Vj4in33+fDUQZQn/DVdRgwncJnb08114l7OfGNiGE5Osv3iXZOTC9B9XXDJxERj4KMigy2pbZdXLXQSSO7GblYGtbp22UtwkZ4pSZfbatfp/3oFtmH7S0wcwpocuTjieTlVfPyaw3anqsluN3jVcfqA3Bh+gWoNxXsehYh2HxTxMijS2m7C1Ar6JjNE1FLJLhn2WY6fYVh8mReutRxM2AeuxyLaWNJcK/9QAgE2aSs+KxRPJG76Z7f/Oxh6YEsJ8rQKK8MrVBmRKnVvIIiYDqN1Uihh3N50pDEZeLiiZ+vIyajIIOwKJySXglHUOtdlr33ge3WsP36+TNpVQX396Ace4PClim+2tX3jZDpNutg492vTEkn383hW7dWnYncyef+U4GtvnrKOvle22vI2OTlgrmb96YZm2MN63rj60H/3xR0g28uhoewgNdsoOkVoXEpN4kGv24YfXiJk7Zt/65utEFeh1Q/+QCArv/PBj1y+/8trzdubsUWtsC44bm2u1dh9ntB/+4fu2NoumjWgRDVsKU6RUvXguo3/YojIEdDflfAVzLOYGcS7OW7xjX6rhuDzezzY9Ayu+BSvWZMcBtncvjceoCIGh1CJB/SAteH3Bo/p2VlbM2brth+lG4kisXhY4zE5etyxUaqV5jMDWtbXaZ1Z6T0VH0Haza2nlYBaiIgi8efuFuS3YJ96B5wuo07dd08dsZy7gz2hD4m9+VrUQji5CDgdGLFA2PMK9fOjJRCZUUsUspbIVxm2FwZa1j3IO+953f9M+fv/D8IRlwDad3t3TZd/+pbd8gXAR1lbsbSmwDXUT7hsqr6iALK+scmBbgFqZGovjprDLESsogaZ4ZDGQXKibCtxx4blUOO1YJP10kAOxCEZ/r7HaTXKSwa5uQBb9QcBUC1P60DLMKqShnTp8yE4O7bMmxT9GMiCGUMzrfaQId8fGsEd5FsMsmGEZpbld4/wpQPEmgtwzR47YEPpzeqMzqCswwVOEs7o7Okb2uy3rbu0gXTSsohbn9JWlzRVrI/7q6UOHbB8scbOAK7aP/Hg2j4Th/jROsux01DHuhIRVVGltF1l8LmL3FtBTr2AXPSOZ9LV6HkCuQLUWiN6dPgewDf0k7G+VLPLjdQOxQe2ir93sRIbQKWCLAxnAdo0FRA1huDoJQ9jCgrkLYNuJXcB/zJ9xAWA7i91RVIg1LSIAts6pShevFnb5kRYdJHdhEd1EKnG1repb/2lTpoMFtpz84Iu9fH4GpIdkOBvU06rPD5onlLCnBoCr0H/y2QgyKTm4OrUVxtwtdM+/Ovcbf+W7FYbTs6+esAboI12cKlmCQK1kCSGj0hf4emJgWzTPiZ3Nmuugu0kgtxgzMBrFCGzTDlsG5+7hUZ82sH1SQJuK+sUC28djj0OZkiGrVpkBboXVdmJss9q0cmCr63lApqcAbCsuRrzrUCIZZ6U8ldMFgHYNT+QNAKtYW0kSBHoCkAltptW7wKa2WhcBv9KLjiBJELC9T6zbKbyJ8zB2tSA76dIaYBUEbjwLGec3osdsbe6ESeglJUOLSxEEbHEvc+ex0C/DZOz1E4GWvg5B+ePiTbBW4N87dIRGEfAKFKicCt0jod9WHQoy2NgOHKhkrNdhUqcnF2Es2B4lucIrXz1tx58j7FgL+tvROfvovctEOphwhlra25eIcdvMcYswSddv3EW71mLHj5IalzsvzK3Zp+evk41tBkb2gJ04uZ/YtoBNJva5uSV7/6eXPHvb17/+MulV25n8Nu329Ud2/icXbZZ4tmKyTpw5aM+dO2IdvYTTkjcz5bp5bcTe/8Gntjixbk1aAPCfy+R8NybAHL0V8sujUghI6AfaSfGE5das6aNW24FMKl1o4Y6/vM+jIswS7isFJ/G+ngG2At4hda3qUGlw1+3wsW5SdIqIDfpFd/iSM6AkCAK2zs4qOQfssYsoJU0Qcx9+U9+pTdEQ9FnX8CEcgG1KDJF2IqoB22DJQs8I/x8+7QRs1YeyOxwJ5hWuorqMY2w3q1S+U7Lr8bG8t67dsO/+379u1y9frWYeWDj0ssD6Olivzj547yN7cP9BeEb1ae/X4dS0YFOWrNJXFpXHenFzEwdQYRkd5owQ7q24uE4LCwf4mQsncOsjLBOiK3uy88Qund60Npwt25FYCBApNOQcEUSUZKijvZMt7D7rYvznAa7S12pxtAp7ugxLOsTuxSmAbZu0t9iQNR54Cf3t/ZkZuzs+wVhahHltBaApcQnKb7bSp5axVbCIJw7usyGAcwv9TW20iO2agJW8NzrpAKuvvSvGTRZARd5DkOh+IjCcOnCAONodRAuQrYCBpZ/OrGLPpqfR6q5bKzKELZyilKyAywCIDcCMzWMnRDtWbj8ViSFGY9jAjirGbSAQCpNx7Kmxz5ZPvGWfi3OPxnPSTwdHzwJrq0U9l9ugPjY7h2yz6wAREXqQIrTYCprtBhxM2wG3TThrtoFEOwG39dLIItWQtHGe+l2SrEwPpUg1nnFNDp9BfgLcVXhcd5xtUVIYpSdnodxI/bi0QVIz38ELzHqdtNOcha8sUoUQC3iNBYoiO65h02fxv5hkkb/IDleeRbY0/dokTH16hedhR+9Sb1fz37z7f/z3v1t1kDz74bFqgD6oOLcCt9O8xdxu10c91hV3PvgxgG2IihBeMkPFTakwAKoD21IwEyYrv0qcNbIAYvdn2yuwjSXNzh5ujMsZ292mhN1KVNRy7XZkpd+zwHUnBvpxrr1nYMtFHdi63Yv1UKCKihVXmHjS6M8UxsucqWMF0d/plZ4xSFQ0k+uNseS0PKv4TYz1OoB2jWgHqziC5XEu2EKGEJi7iEICHeNbyR43FeOkkDxzREUYA9jeBtjefPAQfdUM+jXuA+DJAWobcMxQallFRdCknYM5aSGn+SDbZ+31TDh5QJAzttJhbQe2BYW4MyDpd81tcm4KQK9UYxjxkn5M3YwJ1821tgr13HoOpyQx5sS5bWonJA5gtK2d0DcAwRlS0M7jACGN6fOv4FhGDNs2Mo+J7fjo4wseTuhVNLMKgK7tVqXM1UQoRjIHMJWOVBnEFtjePP/BJWd03njjrIcaU6iv65fv2e0rD2weYDs/x/im/QcP99qrb56xQ4qmIA3t/Aapez+265/dZxuVCV1xfj3UEbZJeF2JMTShpq6giY/6VXnciUXPrAlDMgUWIZ3EnTz+8pDduThOSt3FMilKgjjBASb0SzHgArZrduQEwLaPOsvJ+YZLiymWFMG1tUo9HEC12Fil1JUsYYt+Uo+DnVhcsbXqNx7yLW5Xu/46gVvdM4KBrEUrwWI+XaZXAHsBEAd2qeIrxfvU9XVAwPD+ylqQJIzyYxJj7HarTGurunazGyt9FzNW8iycduHjz+y3/uVv2O0bt7YXl2sNksThrW99zcv6w++/7Yk9AnsX9ZbxrJTIoPQi222Af1OwH2G+CEUXqiits8KzVgC26hMlG+Np6vEhFj6oOZubanHGIjY1IelaAVXqi7N44I8BTsXk7e8ZsI66ZttYYIEkLT8GaJU+No0jVytATHrXbnZ7Nhkja9raXl9B4jSPFGGKCCzzRC4gW536EOWR7VmEDRYIOzDQZQeJKa3sY2JlZwHTY0ijRidx/mIh2UYMWyV40DwkQL1B7NsDLCROHthHuMFWkqQE1tHlDUtEfME5NscKrh0ZgkKEbSqlLv12jmuPLi+ylc/CH/snMKjdKzlbudaWtxK3eKSEErsd5s9EOpW0m8ZMtulSnRakCKF+k+3zPk/bKcX2Okz0Ruc+0mzvNwwUbC1xrnnXs6PURFKGRhaTTbw7GYcCng5ssWFL2KoVoU7+F6RA2kXRjlBYJEqMoOgxrUgOOgC20hMrbkInDHA/ddwCcaHvVmHbG7h+M/ZKkRda+bddOnoe1OsFCZX8Lh4iTRieJf439nABcLtGmwjgqo4k3shzbj9pxockn2jY/LCnteFvfO+v/Hd/sNOc9uy3vdUA890+jvwl3vcZ4z/c21lPdtRjANty5zG3VPGuGeviRrhYmOzqvvh3OE/bAHrtHdgW0EE8f7sBrXyt7GOWareKA3xnQFZ8ovIZZPuMkmpjL03yeYFtuvteS68y+TQSC+lmzsFHtj0zJS9YunCHkprM/lboCpmSJIySvVxo+DChycCqD8j5SkDPmVrkB4DaFSagVYx6HkbCwbfSSyrgfgS1PnvxdnAQtbYLgOCp2QXYkXG7MTxidx4+Ij0jbgY0cr1ALRNVk1hbT1VZD8hlmww92P6uQ9YBsK3fUGIGJh0ZVwGRguYBYCVDG2vAMwTFfuvYPNZDmLwFWPzLuL1dZLZCNWgyiHUkQBqlAjIAACAASURBVFRoCD1LSBRZzOCVtudDKuDG1jrrGGiyLthWbdM9GHmEPm3ZnnvxuL2APrYLllUaM11dTiUpFFAOcLe8sGqffnTVmcyz506StasRecIKXvDDsEstRIZotqtXbtnly7fQ99bZV756FlkCzG0nAHgJfe5Pr9mn712zmhXJEf5/9t40RrIsu++7uUTue1ZmVtZeXb13z0xruIuSRXIgeqdsCf5gfzAEwV8MAYIBw4Zt+AMFA6ZhCKIhy1owlgkLkmxyTJEUTZOiuA6HFGc0w56l96W2rMp9z8iMyN2//zn3vvfiRURmVk03bfZMzGRXZsSL9+567v/+7/+co6M/GFoWJI0HAVtjV612aU47syewr7bzf1lk6OthyvlMdB7bANhqFTMQG9vH7YIfcTrb5MC2t/+AhBNjYWRM4b18M2EbHJgZeVWb/CDZJMkQ6GdjjMXWKug9x6CdCvOlpAySJ3jGZN3E7uUbLQe2PkwLqnP/qOGV6xaNi/VxfVFg23ir7K8WUyYrR9HaZpEBimVsc8/0dhnc6v0/+vJXwxeQKMzdn8u/bUahI9y6dSN89vtfs1iiv/Mbv8eGic2EtXBMcsN1MV+Ezwxry1bWr5X9jcA2OggWi55AcNEkJdGbjROB28KH3mZp3KnbT8MsjpAvABanhzwElDZsNUDkcnUzPEbrPTwwik4W4AXZqWNxaTmrfL5aR1KAwbkyORmmOU6XHTgEJG4LFMPULq5t47RJBjFZCklZaA0l/1DUk142ktcBtrMwsH2MNQFLAds1TkvWtpAMEIfQUnzbqYLAlLTkbCQncRy7PB0mhgbZbGvewBwDluWotkubjzA3R4hE0q0U15pDbM42iJiwhUZfR+3dkjawEa8rO6NOukxjK5aSOLoAbtOsF+Zlq823tbmFMCz0RLJP6tik2cnaOs53AVvm2dHweDiamEWKMBM6YGzrZF47JYvhKU563bC0fYD5igCn/B24h5x/6wBblfFAsQUVYtrIBI/VqwAbdk7IfJKjn/wPhuWgRlv3dB+FSaJITOP816s4w+ZPcWhREoZomwHKiy+ZAeE+NrEmWcNiKaPZfQDtfbIpLsDarmMT9wC3Yot1jRzSBnnWZaQTVyEPJiF8p5GEDfd0/yFa7P/ir/9Hf/5L50yx7358ng06PX2GS5R+903s59c/rgYrWhwzZ/GnIfOYh/sqAtuzi/M0x+e+ILWDZ6lYF2mGCD8KgKPxW09yr4s8r3R3MwZayC8GNVsB21bt147N1Y408R0XZXybgK1VoX37p8w8rbnpxu81lMEoteZ2iJDFAI0tDXJ6wEFMnsRHaDH3AbV1juCO+FuhXuTIpXSp0stKL+lyRc92o5AwssZyItvlHlssPkssXPdJOvD+3AMiJZCyUYOaxaQHrW0fALcbEKTfK3goTwzOhGsTNwC2o+h6ATzKYCVOqODoowVM7KTVVO0thkT9HBfXcn+JAbB1Iu7w7Mi2gADsuDkBKWNPGhd+g7YWHSBFCcivOThBjwY7oeLJg12LMJxHmJodCS8TKkygtxfNnuL5LnNsOjY2Eq5eu2wL6hvfehcmtzs898JNsm51sQkg/i+aZGUcG+LI9oRyL69sIumoAmhJgXmJo1GuO9g7Bth+EL5FdIZOgK0iR/Qq2oBp+FyrFqtUqIvH+U162eKOaATG9vanLlvmsfUFZR4rjqE0P13a4YfUAsWHhDsDbBHqq2/wwOLX2kaHNuqiL7XxcfG1pyW1DZAeqvflKIYOr4sFtpPFThERnGnUem0dkZfbuiYHtsWeSXPaQYD3bza6s/l+NmMrRGY64gIpkIB0moXpmcW55G3hL32ekqQUrc9F539pxhqb/uUv/kH4wj/6QlA0BcP3/Edz85VPvxSef/FZ2Pxq+N3f/JJtTCy9awFIpjLkwPYsu5kTC17ezHplX0ptaqH/DLjnemefcjmwzfeIDqjVSjqBfvHO9fDClaukb8Yp1CQtfMzpxQbH+3eX53E0rcLqDVlM2WNOhI64ZotN4np9l7lTD6Mco0+NjNp80QaxShSDDSWIQet+BGtqWfLiGnMEEO3GAezG5YnwPEx3P2BKgE1zsAro2oAVXiWiyA4bRPPJNZvtI0BDdhCQdmVyPIwD3sTm2nfZ0MshVpvrSTS7o4SzU0IIbVz3kEvUAXyDOMApJN8pvgR7OJdVYT83mLtbEAPmUCbWVlFkBLzFStu4cfBYfNk84EchthqpizTgXIqQfAqsnd2EeYvT4Icjk+EQYHuKzrYTje1Bb384gak9JulEB5KBHjnqSRmk+ap2gyndV9kUeUL9YzxHXMvsWSoU1/OdXu4xiE3rkdSA5xE5DOYXzS737GEDa+EgsYJDvDdCHw/xvUHmPYAUYKuKObDdMmC7H+7yM6/4wMQG3qVPTjjl0tyGuw8jQz1hmtOsq5yaEZkxTAOWJ5R6m3YnIc5v0GH/9U/+hz/+1bNG+Hc/O7sFmNOvccUr/Pw+c+H+x9FeRbudVhT92wRs99lhVZnUZljjQtzKkD4dqDVrFX9aVfNJwOgfL7BtVV+f8B/Pq9jm7dr6vAWuFbB1M1v0fS2V3xi1vFa53KE9sDUjXkLDfnV6Fi0lUabCvbBxOqoiPxAQBdhKiqDMNGaI2al3YzwVxskdgQy+uKYToyVmRKxEDaZCbMoaaWMXiGv74cN7HB0uhD0Mn1I2itnojcytHMr6eobDzPg1nD0us8snhu0hrB/Hfh06Wo9AwkCEgG2MfGDH7fwIKKo9dNxYBK0GdhRqLFr+xJQUW9MkCAa8bDZFAIuWzLIKOWebg8LiNwU24oKqvorOFerP/SNSUxInt4JxV0YtTdEaQL+fLEpXALajpNXdI+3nIH/feuYKcWCHWKQ56iQj0k2YucERwCFMl2mpua+zPJSGI8LVxe3wzT98P8y9u0TkCIVE4/48NLFmkoKoR1V3aystesb+PAmwdRvgGDfNoMTa0n9ElBifIl7lswBbMo51Egxf7LMcxDoQ4UleYIuvpEYqTWSZTO8rCQLsURdsvdijCmyaQjiJ9RYITgt983G/Otu6KPZUgcWN75WBrc0RK34Ex6n7ohShlVVoALD54xouLQJbffCkAqjyMwozOZv32qh86bd+L/z8//HzbHjWnOXj/z/wQ9/LGJoNyzgr/sHvfcUmdTGcVrF9isAoPdPmR3xgo21Sf+duYRmg96GQMed2RYEoMDFE4WKBDgE+gf0DJANdhIF76flb4TNEN5gm8HGX6TeBbYCcXbSYDzaXw5s40ynIymBl0Oa8QmfJO3+LU58agKuH+ykTWJ8ifigCAZ8ps+GhTpeKpIWV4xCHtJ7wPS8/G24AhhUFxIgg7NIO95IU4THxqtd38BXgWWZJvWmtHp2MwyGYwhHiQvey6VJUEsV4rcIS93J0Pz5MGl7sVq+YXjbYNTa3Yzj5PXftuuVI3AM47wBqd6jDGsB2aZ14u9IOx4xkArWenUybZUUQyXXSZoEM2JoKPrNJ+QoWddUlYJsNa/UNm8YDAO3JxFUHtiShOEZyIVB7AoMKVesSoIibtRHWpkUyANXVQwN6qqqjaENEJshpj68SmxYGVpkC+b6ALiQqeluxv+SIZG1QggrTVMOYj/H+KNcPIUUY5GK1mVr8GCnCprIsErbwITFu5/l3lTYSsD0G8OrEqc5mWZuMCWRgswK4fR38oAuOkgZzWjNH4c5f3jms/Vc/81f+vbdazefvvnd+CzCH/ixXXeNHCRw+8mxwFwK2r//RW8bYXgTY+kQp3vb8SvoVydSWIWG615Pcs3yP4t9PuiScXf4nBbbtanfhVioa+DPa+Sxw2wrYOjPWmKGnWKakIcwMmoCuPT9C1RJDnQE88aqlrktQ2LSMMVbtKUb8EAbxAKa2rgw/LDB25GiOP0p/CniR5k3aTQMvztYq3I5YCemsFOhbaSi3yDizgg7u/sJcuDs/x5FTlathDPi+MbX828uC1wtjc+caWb76LoWufQAP2lF5JIkXcErO8YkdpYtZsopEx0irP5+3ArbSn0ZHt1b9apsCA1T5hk0LfA5sfSH3Js1aywCfgUctQgLaKptAvu0e0IopBI7pWZMSErmAUtJaeylcFjFlMdQCsYPoyJRidg+nl6npiXDzuevh0gw6Y9JeKiuXxcKEwd3e2Av331sIH74xF2qbB7BGCvulhanAPJr3ha2OfozoyDarQ/Kqt9rw2cjkYLj96Znw4E3CfZGgIZ0I+GZJmwhrZVvEoaMsbW5X1wGsdG+4dhuPcyIiCIRLUmDAFn2tAGw6Lc2ez5ImJxRpbLtgkLoBtxVYpG7pj43tdVa8LbAtdZ47T1KuOKATY5fq5bbPZ3g2M+K8MJBo4Lb9ptfZyZacWbbR0r1dBpNPKp/rDbCwadhdBNgmMK6N4m//+m+Hf/aFXwrbpIHVWP2zP/KnwyTZuBQuTqHA0vOsHBGklR+aiuUl8/+W7ZJrbNMY9zv4sNemQuPYt9NZHNs4to21pVw9jIF+Ti7EdArcKoOXNnmXkSL8mc+8RugtxgvA9ggHKz2rhoPY3M56eOvBo3B/bhmgBGCUExmgr67QgfKmx6aotLb31NiW9IjxFWMMWF0y0M4YqlSOwks4an72hWfDlGwV9ziEBZacYBPWdg7dP2ldw8IKMepjVBFvEpdVqIZ6VgpRJgcxVVrH8UokMoCWdEjxYCmDdLmdgLdXnrsTXr56HWkQvgVs5PeYrzt8ZwlHtUfLOLjhSOuxbRUlANCGffV4xsk3IB8/rYFtNHfWH5TQdOh5bO9k7i1yAXPraOxyOJ24Fjr4twOZx3Ef9oU+UTAHOeZZ5kdNAf1PttH3Gm431MzaTMuuGVOr+OJuA+SzoZBsmrP6SMUQ6wuRLr9QQK90zgrdiFQJmzCERGkc+zWsdjPZg+RuPqbqPG8ZIDtPfNs1/tgg/Fodplsbcx2y7WJr5DA7weZ/AvQ8gU57En3vgG2aZEEVWl1JTzrNeXf/6ORnsaf/7T//q3/hg6YJ9903zm0B5pCcyZSC91ewI8mB69zvXeSCJwK2eYKGaIBKYCY98OmAbbG4Cf6lZeBJQG252mmhiYvKOaA7N1hP/8wzF69S8c56ylnM+EU6t901xdA5yddLAMAMSQMzEvvZTLmMUHEBypZuM315u/lxsL8UU9Bjkjb0rrGaOn6StkqxInG8wCAfbOHstYb3MPFZO1hc9T1LsCBdrMIzYcnkEHQsI0NZnIU4ttSzhyxc+luhb+SQoCPDueWlcBdw+5gQPbLpFh3B7oXmqzKM4RsKt2afxXhN4RTFUTXxJcXqnohxTcDUgKQb3jSSDLdFYJvq2gg04uapOD8KbeDAM8kTGhtHdc6lJWryxqPtRPQKUHsZtQ54VrUEaFN/GChQRIYIji2KgbE1LLw4nZmjn31OOB2Cm4+Ra30MJ7QBYnkKXdYJci5gu7YkJz76UeHTiA0sJbLGgnR8/kyNjwhfEkWv+yYPf/NOzG1GJkUA2CpBgw+t2Lr6voFmTxXqXiUsWn3HJKjoD7PXiMrQ5yl2bUyglbZxIWbWzjP9PmL69ZfxzixynWLqcWapKCg/q2I3LEwqk4Pb1sCrOG6TqsaeUKhPPkv0W2N/ZfWyBfx8m5KBusYpk21v0qNLo8bu7c9qBInpNmcBWy+Zs6f5C/aTOfUvfuXXw6/8wv9t+trP/Rt/LvTRhl/63T8MqzhRJUbXtplpkreqooZZZAN9S5ouEsgRiPMyJ5Y/jYdmEOzAKOnbK7BxinwwPoSkgD7tYTwcEL1g/3iPaAPV8P2fepXoBlcCBD8SpzpaTk4d+XmMzvZ92OcPHyxyjK1BIn2704mmc7cx7PYto0HSfI8gyceA/nsULk8Nhh/8zAvh2dlpdLmDZDBUNBHmD2VZ2t0mpetqeP2DufCIeXSieGKwh96Phf6K80jvplOP5EBlCUU0Zo2xJeTdDM6dzz0bbhHZoQsAvYcvgiI3bPPzeJsNPREYqgpTphCJYhl1IqawZFDUYm3t2dYFac7qb3e6NAkW/7fQeylahZEJvgHMv+fzTP1xCFlwPHElnHL61aGsY2QcO1ToP6XjBqHahjNu5J2911hzgsBsqXsv2/MFbk2uo2LYfPZNhhhc21zwmcnPLOCJALCfnMleddM2g3w+BLDt57OK0qfLNtrcUFSEU8KjnYQ1AO0uodcOFBVBznjR8VVbH4Vgk9PtIBKsEe4zCDjvteyESXqm8UKpGFOKJS5tNh/9TP9A709+7T/7iYelafvdP89oAea3wlb8BD/b2I9f/ygbq2iGkuXVvw1ShMTYtgK2zcyBBuT5BvyjrES613mL00XKVQS2Z7Ge5WcW6+P82Rkvze1kVhIGNCORv9zuRDDeZgNRfELTMeoZj7fg8PGVMIeAmzEkLYBtdnH2WbGkjQtpY/vpQaWFPtVTzxIwg52wkF4coe1vrofaxipREUizChKVIe/UsTFHXdJGniruSwzn5OkkJfwXW0uQcgCt2AmxLYpTWAWULXDMfm/+Ubj7eM60blpeKwCcLhjbfmQIQ0REuDX9DDtzAVu85klZ2c0zxNh64h5nalz6EDWORtMZLNUymPVawzywsDUGFfJO9XUyrZfWpEUJQ/5BPPozkBHBill/X4xMn8bfpsG1Fcg1c/q7yxC4u57pJZNvi3X2jhtn6/64UHscRyEPMZEKYi/QGKUQRlLTB/xYv9Jf5lynEDmRYTZwrf/pfoYCYt0j0PZhnMrvmmEDtp9GYytgi8a2uDFKbWvA3XTNOKgBbPsGToj9OxQmZ2BcCful1UTyFNN7KhGDQi+ppuaQIy2iZ2ey8GM6Cu0j9BAOLUp/Km2ysb2Fw5tWdqxpCsVhbyM+w2bxzdS/DqXzl82ZCJyjU6GPrNavzC5YF+VXFWdZMtT5HfJ38myKzfdP9yvNWCtNGhOt7rlHtJFf++X/J3z1X345fM8Pfg/RNA7Cb/36F42V1BfF2qVXOxtrDH+8qAhsTzTe0uZIjF0KFZGujePdpoA2S5oX2qDx+QDH01Pjo+jkCdanDbDAGNfsHu4Rw3onjOKR/ynkCGM6rgaY6zRH0Q1W6lXSraLFR1++B3t3gFMXVXKnz9gW5f4ptrk+84gdCg11El594UZ47fmb4dbURLgEsFVZVMc6z1rcWg/vPp4Pb9xdwKF1i7ZThRIYiyMhDhjr+2jzrfqGCFNJ1ACSMB2HZ27Ohleu3yDD2SgaYVhcbOAJ4HcDG3ifUH/3iQpTrwO6xBsohjSfq41lL7VZKZM3iXV35zEvjMfhdsLCoxTI1njPOcD1UyNdc9QjxhZ9LaG+OnHGDX1D4VCOY5JExSQoYllTmDCtP0qyYPWlv+F13b5achdlCXRga4x2/CydyAimKkqFnizHsS4ZRNtE+0afMNVmB6Xq6uYzbz4Hthpakq8ZoNVJnx0WyCCmiC6KnsB9BGQlb1GZ6YJeNhW6px6lVFoD9F+XUv9yv7rWG0V/4cOT7o6/01np++tLP/kXl9tM7+++XWoBxtdl3vocP99kTJHL+6N5FW1wmrv6twRs31irEW9O4b6KOz3fbTWY8Y+mVBe8yx/Xs5tAY6pzG8CZrXHFeqQ3i98tt127prSVqN1SmK0WZimKC2O7ZnSo6ffL1mcrXwzD3eZZCQc0MjuNy2TjM1u0RGanXYYgZlayg4PNjVBbXYW13cJpbM+OkKSblMd7l3b/UY5g6VH5TEytvJEVq/FAqSslaRDgw1Ad86NMW2s4vNybf4zW9mFYRN4gpy9P2CBJwhBxEMfDs1eeR5c1SfIBnMrgWsQiu4zCG8eYDIN+/C+yFnqOFtEMtNsiV55K3hLJUcwRgPNV1u6+QpjhTi9nrBxE59clJs4dtYx/4DqxDIaxeVdGWi9pDYtgKC1CFmPXvLsSG5RYVk102jLqBjsxzsaIxbpkC3ixU+X4xPU6klOCC/1u9eBiO0WM303bGf/T62jsPSuOYuQWncfS53YUbw+1q62lxFBpMR8YRpB1ezhMTiv6gcCusKxkCJIj+IbHviX5guqgTGg6RVYBWJgq0tgCaHuI1WvpdC3drn+nFYgpVtmuaQCZxV4r9J9NwNbhGQ0SxPnpD8y/d87MzouSTVYrkAaQ9Vej4rbN3axt06lD+entS2DnLyo3/6nCBn79a68T+mstLJLo4/e/+OWWwLbJLkcT4a2WlpnYBsbK589vBWz9Oz4wLDFFZJaHYN+vT18KU4MwtnIrgn0TTjlAbrB9vAuIrYXLk2OEbiI9rlfCAIuchGrSweIQppB3ki4tE45rnbS1yoDVuDPx5m8sdWrHkzBGTOnPoq19/tpUuM6zpkdwuNQ5uelykURto/UnOss7j1bCW/fWOEnSAxR1JbebVvs4b/wkKLclqo/AWwXg2g37Kc//qzC21y5NWjgysZIax2TphYmsk0BiI6yuc8JiwzAmWpEkgQ2ExcCNIcD8kYmFtImbjJLXN9m6aPeMRY1dZqUzcxbnNeU4xGFMqXQ7hy7B2CqVLsAWxrZDIlkBYoFNE9m6JMGDHvqN7NHq3XhjB9re504oOIUgfas6WPZdoLLCNZrBtk2woeXXWdgufhPIRYofX25r7X5cLNDbI5ZfawzXHWtDbM9SyC9sR9wIGItrppPTAQp4Gds7ywnRBASICJR12nWFn1U2EHv00UFXZ43wa/8LapifCv/gP1lPT//uv+1bgHH0WT59kR/pbVc+irYqr8Zp/jYB2zqMVzWLY+uPjvu3py7HhViSOMme+iFP8sVkP8vfSZMs2uUnBdQfhbzhrGqUmeVskx+PfVJvZQZb4CQaJTeqacHxJdI3LAlLJ8uQH8uVj8fPbuISd617x0VW+gDFrVVWqn1izu6ROvKQxbMTbZoZVpgPOfzIo71DnuzyHKBOYmUlF5DDhzG2HPk5eyQmwdOnyugI2D5aWgr3Hj/mZwGHDMwUzJ4AUS9OI5PkNX/u6vN40o6zMMLmnfAsGwNuAO3/8e+08KTWSA4xDoI9lFWrVwOwjW3bsJDxNT96FNgUNRxNuUKZmfd8WmRUGOVY16zzkF56uaF2FC6gqXA4Kf6rSqTQZp43vrBgxi/rLg7PxQD7c8S+JSNgrEwEBKn+Kp/rzKR9Myo7FsS/l5yK7Lgwm7sRsKq0vD1yiTi2KSqCSRHiAmlaXa+T3UsLIAtGB6LekYnucB19rUJ9dZDhyYIgsDApdq2YfD9KLWgxxUBrQbSIGjgfyjNbAeOlVYTp86xj3o6xt7PuSz1ZICK9rQvgNoc6xfHt4Cu9LnLi03zfs2dT8VPfCOiZ6ejcP201En18eUtna33WdeV38yvyzWx+jeKFvkEM5f/r//xF09w2oL5CARtPMdJWLa0bVnPfcGUQx9vY7Y8DnrwNdXoi9tABijYwSpF96/JMuDIyRnIV+lqbXGwHZ8dhh4xea1UcUbEN0xOjYYQNzQhgaxjWXoDGxxc2RKmpCck1Tyruh0ubxKj1uLDlV5oTsdTehpThEmGhPgVj++zsFClxxwn1NQGTyMYTx9c9TqLWdpTiezu8O78avvXhMmG/FDLNga3H8raZ2QbYaqyfWgiqqQky7pFhcACN+CAOZUNs9rskL9BpFUNuGyZ2g/B9AudioK1TFIaP53j4LzmQKc6tfBE8HJibLD9N8Lmfj6P0nlUzTUYDkIW2iVIFyz7YOxxOBsZgbIkuwy60Z2w09MCYSyNsx/hy1tR1sl6y02bneN808pE8kB2V5MDK7lXQ87QV0DhRXfdx4Nu3uLM57+8jKpEC+q7PazsR9AnmdbSWP2LcnLIhGQjjI4NIDrANOI0J6CousezfvkgTSRQYl1pr6jzzlGeOE+P8JrbmCs/ut9i5J2GdOq0hXVhHtrCDUdrimZvodrer+zsn+0f/E6HE/sb6P/5r2xef1d95V9LH6qZ/kx9yRod/Rl9JIPRtvZ4I2MrjPFlNP10sTvcnL8f/b4FtBHUNC0RDS7UGMe1a4OMGtk3PzdBXmxKVjvuSsY5mLvtScVGRUUi1Lr7fvtfTMtoG2ArECNjC1grY1gnRtQtje4zWtgsjbI5UAraAEGlsFe7L82T6kaFiD4ppPFT6SH6MtTRgq+PIbgO2mxw3LuLd/QDGRHFtVze2bLcv3W4Pob4uowl74foLHC0RIutUbK0fZ9p+IC7/VtdkzGX8Y4UbNjdigtoB22hUMzZSd46LmR/7e4QFdYlyl+v5YiYsg1Yh2oCFF/OOisx0vsCkFjbHLbGvsZS+HhU1z7Hw8asdMcasejYxZWVg6+tC/iz9biGf+NcjQ+SLXQJBapsEbMvjQ983YKuUum8umcbWF3jqDShPL5dRaFFlLMDQjl8SsGVhH9bY0IKvDGKegMEYW4FwA7ZRiKFxYo0rLxOYGYBNj+QIgAIxtsYixf7MgK2thgWc1oxv4lhI40BlbAVsi4t/M5Bs1SZPbD0jAPS7N/D+1idlC1Xsw6zE2YRuBJDFEhfUGhlTKpnHBOykGNx/8Hf/YfgXv/abcXPlgDR/5SDVn582TTYBvH8jwNPvxWf55/Fe5qBFlAIAXr+ACH2/D3DcZ1M8QcSA6yRbAK5aKm7p7ZXcoHoKsEXetEF0lR6ou1kcJGfGx8IU148CcAUMLYQTtkaJG+Zhoe8vk1lsng02Gkx/djPAj1MwzjEPD/XinSvh+atT4c7sjGUd68f+HHDPPezaJvZshZ+3Hi2HN+6tEBkBfwJJEWJ7WCPEuZ36KNvossgODFTCVdJj37wyTfixITC70uoiL+D7ilG7Q0jEdRjnNX60t8dTEkc5bTx9fqjF62JppbeVPwPfFWurHz3PMvfxfLMTBWCbypX+NTY1zo3i8iIbIltwDOA7RebVwcZh8BIs+pVrOKJCFlBe9Kc251QOEck9tL2SYmiu9lviFMpsEXDETDsY12a8gr5V5dun7IoSoYQOIif2INmklmQoGQAAIABJREFUFfZ56yuTynSMPMBOafj7WNEn4l7MMhdaxykj2RGbkf5wi0gxlwC20uNKQzugmLiAcJ0q7WkjoOcrIoZJ244sssYo4HaKk+sRnJG7SKFcY0exx2nBAex5leQa61RukfItK5QYYSc3SOhRre5uIH34H5dOKn8r/PJP7j3xPP8O+QJjkTO58G/zs4AN+d1vt9pPBGyLjO23A2pbMZ5nsRtPypA+daNEZlYTPWM4EggwKu/pXn/swPacYnoczeZXcZvS2B/JfDR+J2duCytkdsnZwNYkvTK2lpBhO+yxsNQJU3MK0O2WURY7q8xRCvMlhs3So3qIJtNOwtAocLpiNMrQO/bimeZ4gKHEEm+hDVwldNjDxeXw3sNHYQGQu4f1FwDsIyLClUmYlqsvhqHO4VA54riaxVELQvJsL9DWGQuaMZel5mtYlGVDE5uWAKmvX/xHjCdxL81buA57qMUfpzcM5oml8xXoUhxMsZ8EbIz10qGb6VuF37mNaaJ5HYldSnF0ZNL9ISqBLTgtAXcB2KbDbMEKK3OBsS3PSfs81tuD5Ds4TKA4a4PE9LYZh0lje/+NpbCx5MA2u3cC0bZx1vOUUvMwTM/2hys3yHrWu4/GVuGDND48aYeArbG1+q70dnHJM/0xC26X5Ad4blcI5VNRTEpj/h3wx7XPS5oBWx/P1opFhqpQnzzO8TnANgH0Nvexx57xWdup3GpzagVuBWvzu6T+K+JG37zFJsgAl7eMNlSpfIX9Hd7jlTBKrGM5KL395nvhF37ul8JX/vBfZXvAxnI7s2ysWaEA+X29DZuBrTsraW8yTiYopZ4doy97AblHeH1tVLdJjVoj5uwIXvCE7cImKC7qgbKMEa92ncgA22xuNYauzIyHa2hgb5II4fr0tGUGg/i3aCrb+9WwsLEW3oNVfX+OVNwbxInOGMH8BCPVyVrGkRIbZCQys6PhzvXp8NLNq2F2bDwMUuADQu3VALZbyKoWATlvz61wbzbvsHmewMWlNnabuBkoAltrexrkyuwYERBuUebJMCYwzuiuc+8d7ruG3VwBvC+QNGKNpAM9JFrp7x60hBoCZmJCtalT5BjFxrVIJ9HhViyuQJxraX0D7NrZ/DSoeEpl0UXMvObroDGgFuFAJ2jMP+7VTbteR9d87fpNkwHJUXMMxlzh9ZT2XCcsvWwsDgHlStgwALA12RBlk4OcRXyJJ0I6WdFcrbFhUWxtEWt7SsELmN/nPZcd+WZKjPQ+YbsUlm0fG+/hcWWbvJGtrRkz7I0IBXeNKBY3wzgnOIOM4wF090pv7hsvzwinb2gDJ/mGNgQ9/AwgeevDb6OTEJI9jBklxwjTV8LhpcthD8Z6E2D9mAQQjzkpXCKaiIiUldUN4heLpe9eYuX67x996Wf+Vts5/R3+AeP/WZrgB/j5HfrU83g/5etcYMt9Kx9+OOcJGmIcW3+WL2rZrrpQgMxgFT79OMFpYl5soSpuJ7U4lgBp+XjxIu0W9fQXudSuaVgsYxs8KSwuVuPCD77ghUWAkn1FmKDUh2kxUo38My9VEagnJiYfB2XIXGJs023ELGKAOizMF7vftZVQW1+1eLaYN4yyPGoBcgK20kQCZBR032O8Sq+pxU0MBAbOPH/dkcGPoZS0sZN4lMgRuPe8EjYAbj94OAeDwqJFGfo7hsNNHMduExVhoGMISIsRxVtZwc7dCcpfiT2xetpxnb/vR6g5QyUAkF4ZqNV1WszFDpr8Q6VX2C1SQk50hOdfgkUihBWYKywvr4S7dx+zKBF/lpA0e1Ut0sropTIpaw8aUQFvPLjlfGIYTLIL2Xat/BlH57FcYyGbmLtUdgOlkW10YOow0qXD5T5s7PNU7+IxdVkbaRuMAhC2towgadgSNMyQUhdgW4iKkAE8A1paKelr2Leu7v1w7dZImJqB+SHUlxa7LqUlNQ22dHyqf5QVWPSKCMCpTBdjR2G+pNOWHEE/xjTHDG2O6fz61IPJVhVtRTP4jLq+htmuu8SV1DugYUxkf1zwlzM3+81d5CcBEXWdZ2/SrLSa6//RcGoY+1hPLFfJGS6WXZco+YcA7jbATevDPKciP/dPfj68/tWvO0DyKWPtkIiCPKtb3gitEsCkjar2s8OEX7p2+VKY5Th+EhZQrKUct+QI9hhn0zVARHcH+ml+jmDRFLZLKW63SaigWM6gLwv/def65fACMZtvXb4MSBwwB1UBvOrBLnKBtfDWw3ni2y6F5VWFykrjoTWw9RhSvgkeHOji/iPhuZuXw82ZKeKrsiHFLtWwbRtsrhfWdwC1qySOQebgBGeJYy+OlGRzTkJfb2d45YWb4U+9eMeY4EEcacXBHiEl2AQ0P4YIeLC0zM86zPQhgH+AzFuk1lZiBkVC0ASVzaQv9LfAo3wTBAItcYMyB2YDxUP12alP6poEuM2OmcGxT9J3bHOrHzms8q9Y5P7hofDSKy+HGzduG3supnaKNpE92AaMV9C59wMo9/ldkpZe6qR/ZYss8oNsRESjAsVy8twFzG4CbAVwldRB2dX2LcID+nudcjGf9wGdCke6i6xEP3vop49gWBVT3AosEM8zBkhJ9kM/8KoDW5wOh7ANArWyewKwKq+FVFM5qKskbtJl9tJmPZS5Y2UxHM7fDb0HbMhFvEzfIobvTNjvHyVcWKclfVhAeiIy5RGZIRcXYekJx3bC2iKzip2cAzL/dw/f+9XPX9AMfEddhp3416mwfPQkSWjtsHCBFjkX2I6MjFRefz1mHisAW2NsLwhsP05Qm9Ux1aSICPX7RwFss4l+gRaNy1lx3WkN/y92r4/jqlbA1spYKHSZsS0C23Zlaq29bQ9s5alxqogIHGnW1laJiLAeTtlxG7DlOM8Mh9haxbJFx+TAVh6t7H3llRoZWxlsYyNkYDUs9T2YOnBt2EZ3trK5FR6xc/5g7hGB0gknhrHqDcPhpVsvh2uwtr2nHGSSgUjhrBSKR8M6LfBp7Ko9Go5wY1ulz1sxtrak280Yhi7WlWoLMFYLV2/2hFdfQxvYD+tUX7WUsEdkwBkaxtO5d8AA7tZ6PWxsYsRrHWF1fjtskuP8mKxfXR0c5QF2T4i7q387KbsCv/tmM4ObvoIaQnC9or0SgrPF1VmjBCIMuKuWHhKi4VXczOgDX+ccSTljkgeud71e/rji9NHjk/NYArY5c+eOHXZP+5I2AYplfBCu3wTU4DjW1QPbLUCrUD/a8LAwuuNYZJqyQayjWAFgOR8SgEk56gkYL2BrnGa0CxcFttZ0DcxqDmwzMBhBbj5mnlxvW2z0pwe2qYda0Q55v6TpnvHwGcA1dGwXuiqy+aWmEAi6dGnc2mUVb/w0/9/85lvhH/5v/xgHM2Ux82+b3CRjhjVmckfH1sBW12jP1hmmL42FZ67OkOZ01Bym+uhvyREOWffmdzbC+48fwYwhY0RKpBLXYdn2iIoi5s7kLTgfTk8NhRduXw0v3b4V7ly9SpxSjskBPocApO2DGmBkLbxx/1H4+rtzYWkFIBJDx2SbnaYJkZ+OiPzvQ9c7MUYqVpjh0SFkTbSbNKHbHEuvbhCBgXtKH2oj25q22Mb6K29lATXZskFiSn/fay+E1164E6YIaaZ0tNKBKkzfDoD98dpyeHfucXj3wQKpfgGNAPtR9K2yAIoaowa0nFyKImAhrVwfbwA3ZiTzDbrbKOnxc5LI38te2ghniNbfNYdR/Su7qx9+7yUqxPf/0PeH6zC2AqGKPztzGWBLf0kW0ssGc5DUwZJqaB7L0a5XJzByLuN5AraKhqPNpzHE2HJJDyS5qCs2sCJbAFwlRdDJV4VQY5JsicXdIVOb/fCcHUXZwYFYBIjBAFEd6PUH2IT82I9+Pxsc0qjD/ksKITCrja4Afw/2wtT5JlXiPTYCAu49YpQFbNeXw8H8++Fo8zH2BA3xzJ2wP0hyiqHxcEioyE3WrxVOCe7Pz4e33/0gzM0tho31bcZ/rgE2+3N6+iGM8n9598EX/2mL6fUd+xa2RJKEf5eftxhvT51y91xgywPOZGzz46lG81cGdh97T/lKe+5jnpSxjWu3T2QdczYsbuc+rmAXSsJ7K+755T3vCa0WvyK2b/X9lgumAZ12r0YpQpGRP4+VSqxgw521gFrsFQe2JxHYKo2ugG1F4EzhmzDiYuQEXORdq/CPrr8Sa6HjNZwn2MWT6tB+LPSUvqpg3nY8XTHpwRYs7TJB0u8tLuJEthg22UEPdI6GV5/5NB7TV8jBjnGDDfWsYzLuxdHrJU/LUM5iN7ZVEdja4pABXwdEtgiYTII6d1XD5WsdANtRmFtylm/OhXmiN4zicDEzw+6fOq2v7fIA5Ugf5hh2DIO9F+7dW6BsvWFq8lrY262Ed95eDdUtxZRlg6tsYMYgue7VejMBCVu7IrgtVM00tqpb3KAK4FisW/929soYaK5LR5H2Ofd3gOPANr2MIIl/JBxtkgW7Hq0aGtssKoIY29hY+kyLi8qq0DpinroqSp17EK7eQBs5KSB7aGBHoLUi9hVG38aIBZBXu7sDihHZFg2BI2el01XmIl0vGUKcy6lfvSoO0IuvVrbiLLBZBCuxebKR41VsHleNo6jxrzOBbYsv2hjNwGOzzrY8w4tjOpWtXE6PBpxblATiE+wdhPUaJJaspDQ7HP17vb33f/1XfzP8ws/+IicQpMsWWCjazqw9vM/0ajgxijNOGs0rpKp9+faNcGNiIoyyYa0Y7QngZqOyRmiv9xYecRqzaJENBEgF4kyiY/NBiO0wTE72hhefuRZevfOMZeyaHBhCh4AECIC1CwO6SFSWtx48Dl/51odhRfcpSTpMRpHaPI5jHy75+1ofBgCjQ2SukoOaxntNTtfVfY7IKa/ZWH0pB7XN3agrNJZhgokn/X2vPR9eeeZmmBnFcZJxrGQNem7tEIZ8VWnDH+GURuSXuQ10qx1ILPoBa645V4u6g6RvygVwTYMsfat0ugBvA7zW/C4tSkyllSvaBeubVP84R7zqBtDcDsTIKqfMsx/93I+FK1euGLDXxnIGtl3V3kQ6oTjIAzC22lAIwA4BLgfRt+qERpuQCv1t4bUUPsv0u7Cx9JPsuJJnVGFrxdiaAov/iaUWS6+EFJtbHPsjT9khEsUGzshVSA0BWz1cmcnkODY62ht+/HM/TPzyaddrY0vEIHez1likF22alZAhxs1VuQRsuwDpFaJcdG6uhqPF90N99R4xb4mHfu2VcIgT8gmxe08A2TtsqlYB1orG89Y774cPP3jEekNIQytHHC/eZJRK/+n4XWQjf/WDh7//ZvNY+M58BxumlLsv8aPEDU/leHcusG1gbBko+StO0WwBb4ZFZYDVajprnvgieUYnxlv7YIjDQyDTQhgVTMtFcOJF15bCvbJfbeG82A1aLoqx7NqJOg6/SIEL7WIN0PidcnmKpUtHv2dNj6bvt6yepAjOKfh65Bf5MWYym2naNnKXRbeWVA5jPxOwZad9ilHaX0eKIMaWRVBBtwVsdcSsVLi4reb6WnMYExOD8wSLxgEGp452Szt56cpkqHTcJU1lF/nVD7hODM7aVjU84Hjo3uOlMM/xUB/yg0/deS1cwih1wILqGLOTY3/z6tdxdqGf/Wi21Ffpz9heea1zdtTGu8qke9pYVaxYjs8q9TA0ViMm60F47sVRNGgc01XXqcdemJgYh63oZZdfDwuUc5LUmdMzIxjbEww18X0B7P29E2Ft5TS8/rVVJAwAWkB6gL3VwU03+mLO0ozFcHTpyRSysZbma5xzSUNpwdn1hRbju9gWBmzjbi8x/4m59eHgD8hiJevZ2QD030YuEe7rVeLYviXnMWWFi0u9afViNjDdg+PcrgrqtJ4D9LVDivvO30qnqwQLnbDdhG6TYyFtYskaTF4QjYRiIPNTEVNLGl3FQe5mXLhXPa/I2GZjujxJCram6aO2NqBs4fzu6fKL2o4M+JSe4y3r90xt3jRdM2BbLrVrj1t+z0Bc88R315w0JHJAltdSv3UwZkfM6WdzY9s0t3k9O8L66nr4+3/780RPeKf5RCgbL/7sMrC18Qggmbo0Gj7zPICUTd90/zA2grmuzSzjpUri1UcAmvceLeD4teaRTywUXsweSB36BzvDtSvj4TmkCK/euR1uI0UYROR+IHkdc6rOOFuG6fvGhw/C199+SGSEmgHbDMxZG5xj91UXmxs8m7BcAkqeQEasoWtYteW0jaTdK79f0bT4YzwhQD8g+dUXrnNsjnxi5jLOb0RvYRyfcAS/ByBfWJEMYSl88/3HnEZtsCEWeOMG5ndLWD3Y2wkkDHqWbKM0obswvTrGP5bTrSIqAArlrBrhdG7jrRj5zDV4aBrcNAZ9/UqbdgFcja8jLvyRz30ujBEdQhpbOWtOoQ9WQpgdnK6GFA4N8KtNq5yzJAUQsNV0VMgtO/bXSQt2XPfXSZeYWmPhLT45Olvsfifrg7JIdkNeHCn7GmvIzl41bG1vQApw/L++gb3UmhDBuoHm0zADc//nf/SHOQUYp62kMcYejQ7bhleSNqU0tibUKaFOBihYtzpFJ4mQMGFzMfRsPQ7VxQ/JZMa6MftC6EaOcIrOew+bu4q+dhGCRuEl333/Xvjw/Yds+FjjxMq417BtBpJvQ5Jz8tb/3LnX8d+8tfI7Cuz9Hf1iTGm4ibWt0T5PlbjhgsDWU+qWEzSYOSxN+LPAWvF4suHBtvNr35dxrvskistk0f3piQHiEw6b4v3PNXDx3u3qYyYtVr6dJ325eOmZZTBs92q1+EWDVD4eT/dtAm1mtJo1kXk5xDjmACX/fgKARbau8anNR/QOiC0EldKBAWyPlDkHrVwdYb6iJJwAzLoBtA5gBGzF2rop0EKhHwWJVzYkOVJU5S0LsBVDomOlfo66zFmIwOG2T6fBNzF8i2ub4S5HQ/fnFoj/OIizx6scSV4C0OJcBLDtkBE0wJMPRmfycmNubWLYzjsx42vi8X1qR33J48cie6AOWogt6xeMbaVv3/S1V25gTLuW0dhiqLthUhSzFUu7ub6LxlasSieL+jjfpz1wMuvCu9vC4wBil5eOwze+sQYzQZphZBUHZDTqJJGLwLkA7glevJ1KFKGljvb0aA9xe0KdLOkChtiCkHOVsrmleqf+bTXWi2PwiYCtDHpsM888NhPuobHdJBtTPi5zOYPrfHW8Wce7+ijMXieE0CALEW1hKTpxIJIUQQyQMsrJ01rjRSGF5ABnY0eMP1rcboCt9LgVGC/fUV5gU2nlbRgKhXKeA3Ja2JfinDnP/OTzvVHKUJiB2XxtulcBkBdtpK5z9W9eKatFNK6aXaWtW0sw5+am0elOLNckDkICShuA2/zlJxfa3P3mr/1G+AL6W2laHezrA7/So2Jo0Y96VvWPNiCGBQBAjP1nb10Nn7nzbLgxPBGUeE5JI6SlXScl9CLZve6TCW1uYYNIBDjqxHVCpdQx9wypomcvjQBop5jz18Ps1CV0uhWyFcoRqRo28XB/jPPqm/dg2T5kTOKIZZELYps4uG/s8+Lfbh5iXTXHor3IT34MwfuxfWHN9GN/v2+RX/d9tGLWdoTnbk+HT730THgZpvnq1BTyCcApIHwLVnAdBnR+fTO8gRThvQec3uw6qJeznJjdW0guhpHhyJnsQDG/adMaJIA2yHKaEyEqzW1K2pD3v8qkTvB6+ZTJN+z2VzaH5OzldbNYsIDS7/m+74VtHjJWdQDN7fjkhIVh20EXrBOoXsom29iDXR9UhApYf6VEVsmVulasrZEBejbtuYedVwguS3mskF+caEmq1sW8V4jDOn1eZx2pElqtSpts4wi4tkZcdFhy2X9rc2lssb3Xr1wKP/SDr1lUDPVPP+HTRgijJrN/cFAPowBvySCsW+iIfmyH4uGeQup10249Oyuhe3seYPsQhnYo7A9fCZXLt0I3WeBwjQjLMMXzAGsB2/v358LD+wuURScZ8SQtRpHwjaQ1YjYH+eUBg+c/fnvui188z0Z80j9nfqXEDV9kLsw9aX3PBbbcECnCI4AtRqCBsW39qLNAph1qla1nvE1cb5pu2qD7TJ+W7pGBiQvU3jT/bknavs4E59HAnfdM35k3P6L47G8XkGdQpLAA26/x73ZtqlK1Ai0JqLQqdRHYps/9Hi00tIUbNAHb1C6a4OzaO5QKF83UAVnHJEXYR5YgwNuFwdKu2aIipPi1xjJ4qBobj+ygdSxlhk8peNGIDegoDp2XAvJX0NHJK15xHnXNErEq5xbXwl2cRDpP+sMLN17Cg3k0dJN1TI5ZAnuexjUnK7I+im3qQLcwePg1P/x3c6UoB6GTY60eriVU1fEJzAELi/E1LDxdePlfxcP/mWd1vK5n7sHYbsDQ4KE72I+TJl61xNSUjnhWjhd8dxVGW+B+mCPJQQKgr60dhD/62jzgdIL2wWEE5kJxK+UsYc7CMRvtEcd4ShvZKY0Xn/XghKamlzObAwlfbnNYa6PDwEZ5jBibnTY4tig3vlJ8YhsWRW17iUVUuK/br0bnsQzYOtjJnmkFUozOGhuVk3AJJ7sucqN2ViRPECsPAwuwFVjtoz3Exlr65RgQXto++1H8Y46slVZXsoVWhyQ5qMjBlg8Ca4rWL61HLZzsWs3pszYKaS42fi/1jc+txr5pU55sXiXT1gRTbZtQfLkN8we0YmxT2RqNpTeIDZ9C44wSOqkPELDNycgBDFuj7fPvSHP7d3/677HYs37ru/Z2vF+MOSqtZZ/SmCrusBwEOanYP61xpH0Snr95K7w8eyOMsAk9JLrALvN/fXcnLGxvAUx3yCS2w6mHZ9myI3LYXgGXm9fQ5wK8Z4mqcPUSDpuTk6TgFWt4hHaTxAzEu32EI9Y7D5cAiMt43yvclxyauEWU5pRbvWGs2lCJc8gGmEsg3J5GGVfCifE6Y8/jImTfjAtjYvD0vCEY25fuzIaXn72OPviGAdsOA7Y7gO8tyo1jLI5K7zxcDu/cV7m1adBdj8MYAPLODUJuyYmWUGCHlEVsqgJuibUV8yn5kGQJpreNCW4cy8ZBb6DW63L2yy2gRVlgbj5Hut8BNMHSxypu9NDwiLHCIh8GeV8OnQpF1o+N7mbOKvlEH3IAgUgZJ7mv9TJ3pUhWX9YA5jXGlKVOp8wC5bAddiLToVi9aKX3WQfqbHCqpGWvEglnC4dGj3crOYacbOUQdhSuXp4Mr77yPKDaHRAHcEwchrEV8N1FxjALMy6wrc3YMaSE4gb3KUsh/kW9rFO91ZXQsfYoVImMUCEhxeH41VAf5JRtdCLsU/J1tL1LAOslhY8TsEUis72pk+7CJsakN81AJE0HInL8zfcef+k/P6fRP/EfM39+jEoOM/5+6Ukrey6wdSmCGFtlHitKEfxRRdufM1tpNfDbp4cUga3tV8yg+pxuC8KaVs8nrWLj9RcBtsVvnLVQnVWSdIyVL2p+9ccCbGNBUjs7sHVdZzuj1A7Ytq1TCwPv9zh72W0FbDPgJGG+js0xsodkHKtxfFTHUCv9pXbs0mfpqFksnF4HR/t2fKifGrv0PcT80rBJbyYWVxnF+tn998MWyImhG7ZCAFmhv3YxqmtbeBIvbhiw7ToaJCrC7TDUzTH/MaAWla2OLz2TVmSvMlY2b5UmYKtxHFkNc1EQMO5kgenaC1euD4XnXpoCTuyFB/cfciy7FUaGxxS1DJZ5A0YZ1qJPKTHJnAaTNQw4mJgcZyEYsNS/0ogNYfDrLLRvEVJJYPHO8zfDNDE55+c3wrvffBx6kCF0duJsBgg+pOOVMlLXiXVQgLB0ACrnMjmnHSilJwZfaXGlye0UGLYJ6IY3Y+SKIDNWPyVfyMZZabC0A7aedjd/NQJbJWhwK1IGtlp49g+rAYfjMDxOWftgtgG25i2t+JMcYYqZ72MDoxBCArIVFkdzKqPfK4wfMbaWyMEcRFrop+OEdL1bYz/nE7b9TC/PoyeZb2YPYjs/ObBtYzFLm4hUcnuOYsXF8Zq/H21Fmyq2shO6tAxsNV8nJ0ftJGaNDaS/8sU8mQl54//cP/lC+I1f5YQxaWBtk+Blk+5RY16MmoLnd+Eotd+Bfvdg205TbsxcCbPMoVOOpRXbVFFOlol8sryBw1CV0x+NbY16yX6Yi4p9+wwxS28Sa3SKk5wRxszIEDpPjsg9ZinfBxDNwfC9O7cUHjKvhJvs2N02cc1MdrHtcnZdJwUaxXExsxFtPWz/lQnL1ju1X3zfgGO2KCRW1J85PTUaXoapvoVD2lWSP0whU+oBpCmU2Dab35W9nfAIx9g3iaby4PEmR/YOBHX3cTbAd65dJfpLF5uNHR26cyrD1Odhihixi5RBLKg2vcoAKfvjm+98U5+PFaNp2oyQCHwjmyKmfcjs2KQ5Ymnu9WKHdeavTJGSidmxP+07Rn36mL8KXagQfkOKeyu9Pppny95mTnTSKetEDmdAfnQPRS+wXhb5oRMswKvWhDpsbQ0me4/TOW1wRGjoOdqkmPaeVhhF/3z79nVANeuKpA/QsbIjqvg+jPLlmenI2iojI9IENsVDsiloyPv5fGBnLRwt3Q9VGNmu4anQSxz0au9IqAHQoVbYKNVMS7xIlBsB23lCyB3sN27ibFbYPC2cPxc2eaob1X6TPvtL9+Z//902Df+Jf5s2ko7m3+HnX2EfWQAv/joX2HKryt3I2O4I2JY2b0nHaUDVJkUuT/DjpdbA1iaN1mD+VQSjs6QI5+0X21W3lYTgowC2uWFrN9kLYvt4cQZw3VpcvIfOubJVCRKwZU3IgG37kvoD2i1g2eMjk1ksTmbUU3WkTS2xWCkMVl7/ZO7doIo5PMZwHWGQ6jh41Yn9dwQTY96x0kUK2PIV7d4PCO/jO3OFczmwEEPyvN0/JiajwsUABiVDGBwZDn2D6KbkRAZjKwXZnhyyCP8zD7C992CRVL6DxJy8SgyPbiUGAAAgAElEQVTbEZ7FsZQYGrGdBgzTkahX7CzwksaYHx9qwRdVWkfXuRtuPz8QXv1TExzHHYSlhfmwwwIzSTD5CgB8hYW0i+NQgbEaHtzbZAxaBxAcszDLo1uRDqQj65WGFJnBJmkyNZmeewFgizPG6tJWWH68wQYA4KtFHg/gg5hmWEfw/Uofy1GdnEd0T+VHl57ukMVP0R86+VugFg8cWxjM18bYGT+GKzNSPmwLG1VjowpjOZ1kWCn9/Qy06b1CeLQyY+un0C0YW3p9n9SoA6OA9EGOmIn729mto2kALIBV+r0BAqNXAEFiiKTd03tiiaTfU8zaFA7MYnrKI608/cw+qd7lg/vY78mwZZO+eULm8yC3fRed4G2BbUKCsV0b56+z7HHmNj7qiYGtL7rtLJLH6222Hs5FxmJEO64NmbzMpXdUutpcSViw7/FLX//a18Pn//bftyNkm+D8X3N4jKPrUebwGIBnQBsR3hPLWIW530KDLoZxBADUD2gSy6hQUNuwaVqb5GTkYFnbOS+fZBLX2Ag+e3WadLek0QbE9EueYuCKRA44BC0ADh8iZfgQ5nOrihNqchyLwLZ1Xya2O7ZNnBv6y4aML32pleK5SHOvGbQpNK/1A//R4YjYxRevXiEaxAihqXAktRi+Hm91D2nTEoD8AeX+1gdzRF5AwiUHJcpsgJ45cIOEEZOwpYfyRQDAKj1sHWC4C4jVCZacpcR2SsvurG0p4VPE6D4Em0eIbehTga2RfLJIH9vPZrOPMrhmQZpV+QLod6UA9jB8Pepj+lpOnpKd6IRO7K2RA1wqNlfrtfwodApg8jMICncS9vBkkmZ16aRNemHWkUPqpfrKv9APrgQjdVImuQtMMPrnCaJsjLJG6JkHkAq6l+yw2GLJIgbJmKYwdvYiVJw2W718f4DNwPDedjhenbcYxQedrDfXng0dE5fDPrZ8n/as1kjMII2twn09WkQyo/LGsWLjwoydPSs/vvbx37DOGNHQUWMU/7UPFr7yv17UnnzSrqNNfpg6XeHnn9J2Fw7/dS6wLTK2YpDShrRs6ormL8M5mX7E+zB9J10r4CUTjTNn21di/FoxZa2+1ASs40X5ztrfaDbVjaD8vAGSA5pWd2oGtumZra8+72mtP0/3arpnbGDbaMSf8jXl9jwf2Ba9o2MbNp43xlZtXoKbSp+cs+RJqxi0GKxTwGqdBaaGRm8f9lZOBBWOC6Wx1ZGZnA/20UBJW7fLcY8WNdvBi3VgvAvAKbPUIIuXGNv+ISQGJmHQwRY6LQyjArbPPV4lviDRF2p94dLgZXL4wfQBbLs4yjdMa+zw2fKKVJ/kTJGDEyEEHX8RyqZvK7z4KRjbV5TtijibXbC4xpjBLjDgV1c20KGNqZYW2ksZgw4IMK4g648eLwNcN8OlqWlCfR2FTQKwd6Gflcf3LoChg7AynXIWA5AOEUlB0gvFda3EvOcnUE5qI9OeYfCrtJkWPSV46KONhnHAUURMSZyrHOnu43xxBNjVNa64VSix3NCmHvVMY/6yVkpoXsXX78VNjbSuEfzaHC4Y7pRS18J9kaAhHYk3yB80NuiHow4aB6a21gEL2I1XMlESeuQcCMOjo8x+ZAgDYuC0IAnwaGMDOKrgGW5xa+VUxgJp9kcbaJW9sLH0+ZFbr+LoLS802fl6aTLZdW1w5nkz+1xg2/IGelgeLiu/JC6Q1tjNUMSlCF54L24sdDaPHZg0vlo9xwFb+p8zkS7RSeG/xNo6q5uPF0d6+TMWSHP90z/1N3CEXPPyMr7GSPpwiaPhUTZlvWLmNA4AQjXm+Cbzf5XoBWLwNAY0Gi0hA2NcEVJSlDo/QXEwITCj8Fu3rkyGWbKljQNa+gEtYq/rAJF1NtQLOLjNL+N0pHS60Yve2sHGb3uLXTZ/jvF83LsiwWPCFKM+NC64aeTFZ/C9lDBB5b4EA/4irOsV4gUL2A7CHPZY2ldCAaKVnQdAfUBGs7v81LEdKamE5o3uM4nj2DSRJCpsEISjdgHDu6ZXpb0sGoJArdLsypkMYAhT2khMxA2fFa/1Iu32UoA19i3/pmQP2mC7DYipcrW5NA2ySAtkB+onRS7RqYo2nbHdlFXQR5RCkHlSGpVTyRJ0MqfBkiQbqa9TdAZjc2MIM0upHe/jfSXnNMAtdqGPDY4ibkj7m7KMKUqD6tOtTbOd+pA4wrJDKmMZcgnGSx+bq07Aq+RwNe2jSCE8ND0bKthgyS2kX15H1rIOcbHLCcJpBDd5Qpc0N30eeJ+ZcfSRFqeHjYzcpvzswdLqX74f7jcfmbe0D5+cNxk/g9TmL/DzBn39zYvWrHGe5ThIuEI/3QK2X3/9bZci4KSTGrsc9qroCFU2BYklTfNDC50t8QISNtx80THjlh3rFqoQ2ZzyMd/52p/8HkVW5aKN8+1cVzYD7c3j2U9J33ua7ydQe5F6NAHbpsW7BbA1yFhkqWzlyh7X/vl+XQaG2JGfICuQDGFXrC0AtxPmU44B2rVr0CnywS5erwJse7C2tqDBNmg8drILlw63H/ZuQAsXRqa3Dy2XZSrTkZKylJ2wKFYBtevspnFwOYC9qYyT/pIYp8A8xRKz2IlRipAqUTQwtmDFD1SDNOYzp0jZJ3RcoWMv9A3thE9/Vg5iFYzdPGVSogEBZ1npU1itbWQJeA4DaOcp0xpxOG/evILMYNKOGecePg5Xr96waaj0wUMD5F6vDBMt4SC88a37YX1lLwwT81axHPcUhJ6S6VhvAM2pjnGdzSBzDmXW0b0WBx3fiplRohURy8bwKog5RyY93WiSiSJxyLNqdR1NekBxdadS/SZMYql9s8U76gq1IBdOZ+zauNDJThTHgRbT4cn+cIeUugnYJqNS1vWeoLGtw9jud+2EjYMVNII1AA1jAh1fL8xgHwyWjq2l2xthQzM2MopebtTGwABgRrIEsfZpHGSRGgoTIvVnky1JC02LyXPmJrCF7vas+Zc2mM33jI2fjGYTrsjfKJ6c+O/pqLPxGL2JfM0Gc3He5uIhH++Nf6e6GFxJ8iT6Pl01oPBN0okrS5TCfDUZLn8jFpPQTDvhp/+Hnw4PPrhrY3aIfruMDnZMm1pOIUS96Qj9gMViEwC2jG3YQlsqx2lTdtra4EfTDWDexqg/SGGOR4Z7wyROQuOME0UWQPkOu1ZHqwrDRoIHRVMwUGsLUXPbNvdhku0kp7xG6GdzJFrDBI511zyvV9Svxu2BPzKiGtVLjk2M3+s4vM3CME4Ma0PKeFYyAsDdEiELHy4sh8UVUgCDsAw4xcbWXcyRFl35MLZQpzean8kBKx3jG+iUlhRwd0jbirGVlMRvk7dBvg9sBrcNjG08dnW4XtTmep87w+uh+KR7tegzahOlx7bqSwZmF/qPelhhtwqsWAa8Dfc5+POREFeeQhGLQhLXdEeoG22YmyyNY7G/bPxN+mBoxGyGQK63B7pfLrbUFQpBGP0PxApztmaSN50iqT5yoJRTs0UHsXRt+WDP5qaVVmMtltpwj8rnb/nIKOJa69qvhlr4tz6ovo6zxXfWi3b7Pmr8DD+/yBgSDXTuqzhSU1vq3wzY8jtShMdNwLbdnRuhjXeOAKyNW/34WGwAtpbALr5vu7hSp9p3bTfXaHCeFNg+yfXnttwf0wUN7Vm2K47r2r7O+qz8pVbAtvh9c4g645UmbRHY6vJmjW1hpTMLLNdcDslgIvdxiNjFq7SGHEHvaQetHzGVFpibBW0bNlfHUcY2mGFLx1qI/GHsFPy7T45jADwZRYWcsZBfHFNucty/sEIayiUYzPpAGO4GLMKE4lLF2HJnEQ835QNQ5taAWRx3UYXaMA6zkS0bJoOneImdh2TgqYXPfHYmXJqphPmFeyyeS8Sp7Q2zV8dgUHAA2V1Hh4ZWEMZ2e5sg7ivob4mxODPDERkTZkusNaBeDESvojsAgHd2YKn3esLSPGwsTO6LLz4HG9wdHs8vh/tkTBoeGEeaAJDe4tiWuooV6WYx7ITt0iLZK7DAgmJG12QIWmapIwBCi8MxUgWxxjtVFnkSPyhUjrq941RJDWBxJWGwkD85uNWEdlDrmu7sVWBsjY0w4+1e2KNTA+EZgO0DY2xTVAQBEQ/3lVDPCeWuHePcs78UVmtLhOpVOl0ddZISmWNOxZ+Us6DC9YxwtDhBvN9RUpqOwnANw/z1WipdSToYhdLu+c7Zlo2kJzYYU7ArxSF+7ilGtEsXMgWxbWwpa0Z7rW+h61LD6YqS/UtfSoygbzh8A+qPKKRUtnUzzui0gKbr7Vg03i0zxJoLGh2tgG3ZyufFVxmktdXLWNtEo57TSD/9U38zvPHNb9lmdorvzwyNhD7GluRKR9yjDuDY5Ch4DUZsx04gTDhTiI3rdcuO9hNQcOiigxsDen1yMORS2QWLCCC2106OrLUipCgUNm5wmm1pHNOyGanpYrsXyRkPo+evpNfN/y6OvTTuZXjcAOmfocFeS/wwNopdU2xc2kFRYJbJZiafl0PFx5VvgAE0b5Osn2MbVCxhDXcUwjdWUqHwYrZCScFgJQ+ReWnT65FcvLTpdZF1065pALaxN5oaLm6SbXQ6sPQIi7IfXn6reIxMkFho6+voa5HNH7PRilErDS13SieBxXmSqqJ5b3WLOvPCfDKgn5jn1JvRpmVfN9SpDYOSNzBOIiss7JL6ykaCXaM7egY323jZSuXPjRA/9lFCOrnhtOnOdUXfW3/HxtuDjs7jz32w/MaH50ynT9TH9C0i6PDv8/M+4+xrF6lccdilVta/5zK27W5eXNuyayJrE9GCvV1kbBOwLbK+Sa7e8n4Xqdkn5JpsCWmDUpNDwrdb3eJimzFyRQz6EQHbNLlTdZS15lRxaRWSRsJ/Qn4J2J5yPq+jom6Mlo4ZxUpu4/G6R2gwOTpIWyXjp6gJchJSvNJ+wI68axVeyzxmpaNjccT2831yy8PYLpIBaHMdJ4kjdLgBLZUBW7HC8chV4XIMnGoE5sewbtybnW+sPraD92w1bpcP0fgehVt3JsLwWCUsLS/Cyj4if/p4ePmVWe69zWK6g5NYP2B1D1C7abKKKxyXDgxQZztuJ0c6ddaRlhjJ4eFJQnxtkbZ0w4DwJZxh7hBwXtetwnK//y73v/psmBonPuzdlfDe2w/CGNfMXJug/ch6VCfkjI7zAPjy+t7bE2BX5h3SoooxoX5a1i0wvRZ/5A4G7Gn7eo3v1buRNMDqwOgK5JrTmRzQVGEBoAiSsmEqJIExloxETZdS7grojE4NxpS6aBoL4b50Tc44AmjgQ/ZOydpUnTfG9rgTBhCw26nQXTCxfXIwUlpM6TJhaieQZahd5IA3MjZk+j2FFpJ2T8XMhnNh0fL1rfXkuggAvcg1aUUrP6V4itTqPg0JDQoAycdccTHMx6W/315KU8TU3gwRPBvmjyAs4V8DG3mp8++2B7YqW5G1FXN7kZecyj7/dz4f3nn3HduIKYPWoPTljD+NoV1kCNsAWwXorzOXDblHEOA2UOjIGTafhL4hFaxQFi6BHgGgJJtw3M9mThvZhCJScpPoK5DBDp/WGehNYN3ghm3apPnMZTo2pmKl7Tn2R+Gd0nhTOZWaVi8/CXVQq6/o9F6xuSWr0lzTs01+pXIL+GuDHzff+qbPYb6qOlm7+GZHtlTAVnNHoFa+B56l0FP0HuOncIxd1eMTa5uyGJajaaT+TJxz1r9WxdgvqQI2v/L6p9+9/R3YpuZwn5vY2P6x1yVrryIaiBDRPvO28c1q8f1WI8/LV+6jJGmwTXjcy3lPxL1l9oU4rtgMaENxbOnNnRvOwajB9YLBSfPRn63zBbOcAttxjKa2cDScj7X02FQWnCLXOKT7sXsbb1z4WL5VK/xJe49+/V7K/Cw/P0+blcTgzbUp2to0j32kFKQIioogHV5RinDRhikDpvS9MrDVjqlYmD9JwLa8MBaPrOP8bWquBB7Pa8dsCWm99maetufd57zPy4x4WjjS9y7C2PpC2bioFhnb1E42Sc1iyHJFYCvxv2QGANsq0REEbAU3dQyuha2KBlfAts7Cpl23ZRcDgHVxzCYHMzFz5jzEj3KOm1EGXElLBgmJNvWIwOsCtrDCOOJ3n8DWHpMhCGArnatMSdotW6hxGVnpcwtIoJyRLKuPsQXRAsqkybGhm3t06tQEIKZUwMf7BC0XY6toDXscucqJAVaxH8CoPOg4Iwzy+8E+bVDfCTdvz7KA1cLcozlkC1vEs53CY/ey5UNfRp87MCAgT33RgynL0sMHS2F68jrMzgyg9nG4+8FCuHHzWnjpU6S23Of0ikgNCmPT09UHqO0g5BLRIe4uw4IfhjFYzn4Y7iogu0a7KxtRVzdOWLTlIE4gQ4CM08NeGG9ythO65uhQoFaKXaWC0whxXu9EerTs5QM2NV+RuUvOYw/eWglbyjxmy0JcUM3o+0ZBob7qXaRE3lsMW0drBOQnviigR04/Yo6VFEApOiU9EbCVQ8j09CW8ySfRJ7OpgLXth8WXFMPsSwkcXmROnHeNLYTFSd5mniYQdtb9yuC2CGw9O1z+agS2biV8PPrv7QB3qw1sBhJLwNaeVnD6875MrLD/3vxyoDJJUgUVZZVU1kUw3a7+AjXSLf7sz/5ceO/D92zDZw4/OjXgSwrxpJNdO1ExIOfAQSUw9lYOYwbamLMxLJ1slkWnMbDGmDZ5juYiUI17aAxp/KaMeH40L+FkhB4xWohScJ8qUxefJTCiaAKeuU+ZzvykwWLIGvXrnKm1dWHMeYxZmaWEnAR0IhBLYMs21JEtN6TkoCmtKQLQ2TlYfJYx0LHn/RuKCuF9k4BtOrVQfGdja6VdjQkXFGtbkVlOLd2uWFu1g4oeyxKjaTT1nQHR3MJnGyV7cDpQbwS26R4ZoItl9PcdvqXNQsqClsrh+dOaX7Ylj/X17+bX6O2mjWsJ2GZXx/6yPsv2ITkQ9uGuzV48FTGmOOHXKHyI30thFM0+pAJpyNpJo1XTx1Ls2zgyWjWx9aFPbc8KyVhePz08+jMPqu+/3bJBPoFv0oZ4Ioa/yM+btNs3zqviucCWGzyRFMHHdH7bpLErF+QiwFbfac89NN6xMJbPrHO7dee8hmr3+UWOaS5y7/OYn6dhlc77zpngOp+xsfhR/1SojLM9xdrJkOdvtGOTIxTwCcs9TmLucmls60QO2EOOcAo7U+EzaZsOOSrfJYzKNlIFecaq3N2W49u93uVVax61ArZmuJEnYLy1mxawrSPg38NJapl89iskPziooyk9RRIAWAMOU4Hk5JCXPTeQrr/yV2Ns19S+5nEvE2WLmxhKzL2l/9WC5/dU+CECF/GDHpYUn70DCkXUjbNbBVAGswjzOjJYYfOIVGJ9Kbz86h3YSCQY9U0W9T3qXQ3jEwQSZxWr48k9CLDtBdTvAoj1nKWFNUL8EHGheyy89cYDYoauh+eev0UiCMDw7hKLumIDdwKS0eYOEYqnayS885bC0awQ1/Fl0l7OkDmqGl5/nQxRgNoJMp4dKVsQGsSVhVXqNIiB7oXdIUoFMYCV6ayTv7sVVcGczZQVwoGEszCR7Vb/esiF7OWMLczym8sk8qna9QbHkj4VQHLCYnqAE95RNyGdjgg+f7wV8IkG7B7wIx2z/g+TJfYJMKNA8CN4gE9PT9nP7OyUSxKI5ykGUaewjsue3gJkc7QNK2Rjpt1kjyCs1ceJUWiYSWq3ixgOtVsDcvRNQdtilMpeDMWWweJyE8WyG1xT/yaw2/YpJ6azVbtLNqCUuue9Uh0kD/i9P/i9sIKTmNqyG29zbd66OZnpZSMr5lIbGjn2FJlNS+jAPO1lgyZgK62jxqRY/VM5UzJPBGy16TXgFgGUoiyklNDKZqg5rfGq35U5TCGw9By7n/0tPauDcEkYlAVxn82g7mdsqsJmSd7Av4qdqn8Vikr1snw02DHF4lYkAt37WKDZwm5Jk+l9p5MQH0cFgKy2N3sbJRjWD64HNTBv1tS3iJZu1k5MkrxHgNyjDugXC5NlaahdfqUNhMp9SplSHX2e+EDw+RnZe5t3+QBpnk0O5jM21y7I7+M3jECtNCiszvl/SoDUN7yNc8T/KgJb39TlV/l0by6l1S67sLF8p5a1LjcVNt4TYNWm2lsj9o4/K7VR1HFYTPTGDV20gerGVE1rU98IWk+XjUfRVjnm5xVlQ6enK0cnnT/8aPvt90vN+In9Exvxp6ncNX4UIaHIojTV+Vxg2+A8ptAsF3gVAVVb5oD7FKMi+O4lfz0pY3vRRaCs+bxAddpe8lGB2m+nDGcB4o8V2EYD1DR5k85J/WtzsYXpK3zJJrZYVXSzR7CxVbKD7XL8fsrRuVIZWsAf2BFlralKhmBBJlnAdMSs2KQYZxP6a7FDQycPYGPnxNbaUSNAkOPznb0DACPxLleVtxvJQiBqwiFA2DaCAmGpF4yqSGuI2ZrE0rjRzEda3r7RMPq5WTSKKfe6jziF1uHQj88lczCpmy28p6csKIqAyNe6cYLTkekxJy1DAN6JiV6AGdnHZhTCTPdR+uA9i35gPFbnEYykHOQOAaXryAqIjkCYsHfeeoBn7nZ4/oVnYIhHcEZbMY2tNLJvvPFOmJmeCdevXgf8LocNtLy3bt8EFA6x6B6ENwHF3b0D4eWX7/CvO25ssRl47905AKVC9IwAsgHcO4RKgmyt77ExOOxjgY4KxVR/HZOmNlW7WNM42B3Beez2p2bDQxjbDRjbBDidlaKNBSDIwnYk6UE/coSOnVA7IV0r/6sRy9iOluOmKi65MPcK9UX8UzIHXSb16uzlaVjD8TAxjtcyURPE5rtTdmFEZmuJs0QXmc/+XK9Yq+vLTrXZ3D4D2Nq9UmOlxexjArZlW2P1jmVLwLbJyS4DtlbprO1bzW2/v2cSu4TTk9jMNTaU572KdkzzYnV7zeax5raBWAGzqLtMTFfCAjYGbEPJFktgLbahAvpXzPlUx+3o+H0yx0gFOglSZioft85wRikG1wnYqkx6pkCtaz6Tw5ycjMT6ejRazW2BXDHAAoayUfrcTjHi3zp10jSoYePk3S8guY/UqE5owyPArf9NFBNJLXCU1T0OsYl1gLCytYk11nWn8vpXuW3DyDwwcOubyeSM5GYospiRXew2KYImgA/fTjYM/reTC9LXiq21ewtgq8MibeknVfl8Lp9cNfRtAoAZtJVNKwJHb+eW64LdyG2Av9La4X87sI2fpXFoV/lKk79yhNhujGZXNy5g/hyB0jQZ4pOtzJK3WDunMiSU4ptLP9U05G9lanHrWMSEUmVzCpvhll9IiEUFytcev0PHXP3w8HsWqx98RziU0cbDVPsn+Pk6c/zNhnFX+uPCwFZMmUsRmoFK+QH5sGocbsXrrGM0wfi3wXms5ZDOv3kWy3h+yXxoXOS6MxvtAm1w1vc/ys8+NmAb2ylnZUuMrTpQk7mhMoVdtRlXN2FNrxKwlcWXET9kfBmwRY5wDJDtxsAqnq3pPC0qAkYfAyxG1sL9KJSTDLP0bXb8785mftSnBYxg5ixQNXSlVQO2OCJt1FnsSOt4QpzbA2QLpkt3I2RjK7FR5vzkeqgcwCTGNpoVq5obamlTzSjHOtu/BtT8kpzN82vSMVsyVr6wKm+7NawduZ+Ssayzy1OK9g4Q3YDfO4iqMMTRu66t1jYBvQNhZpbwXVyDIgM2ts+cSjZgvQeHkBIM4XRGVrMBwtsoksTdD+7DZuLUBiNr2cx47hCe4opAoIDq9z9c5HeC2j9zM6ySGlKbz+tXZ5FxkBWOdhybnGLRJSvQ4RAyhr6wtnQS7r27GnY2FAKe401bAKPTka0BOZfka4KiIuA8Jsb27ZWwuSAP9zRYaIN4FHyobG0kuegdw/mPfw+JNGGqWz5XelABJgFcY9X0O0er7AzQWvcThB1wO3sZYIV3vbG2hAFjI6Sg/BbGx8Ki+UKVXo3j+IwZ2n61si+1A7Y2StICH0F5gz0szonCon0RW/EkjK0Nx9L9i8DWAFN5ylpIImelGrBGQX+bl9PHr17aUCgb2Y7i2hJV56xX2Y4pHnSNiBi+qfRv2iG8T7A4ZiLDGuUEnjY6ZzldYhBlLnGMmW+i/c/BlQBx1mdRlytQKNbWZ7ZNNQM61jZJw2tV9DkbD6Zj0yBNMJZXkiTGJNcJ9Nom1p4apRCib3kZA6zxy98mkVAUCP5WWKsDHGq14ZezrIPeOvMOB1IY4m3kS0qyIEb4EH2+M8TYSSWvUVxwbKYMmDbBg8x9+R3onkpBrrXcyqy21f+4TizzcWRsdR+9fEgmMJX6wQybd7H6wS7M/hPHuN/XwgNa9IM45vQVkze0o5e0wfD72h28q+323mcFYJt94v1QnJYX2aCaU1ebCCZ+4J+N+FiANK4byQ0bVlY+b+/0sil+rlFx/wNvPr+46Ss2x9QWjS3hF5ut/crDrXd/IHvwJ/wX6vvnqCLpOI21bctnFk1Y6k392xAV4UOiImTA1ganWRZvwhLIy81a/DgOkVbtndaVTHNygU45iw1OlWk1ntJnbrTLljuBMA2WYltlpu2ckp315AtU6txLyq2a1+GsyXPWBE8MVVtGvXhjHu/C+HRonGZgBLZZgxc+j3Vq2gNEI+h972yRWAjFXt3H0WTHgO1qOMT7ucJiIKgkA6SMM3KwMuaTm4qhteQDcaExcGsSBKVO9di1ApsKTF5lgVC6yVWO2qu7BNruId88m7+TmgJ9NQLbpLfL5QdpvPsS5u0maxYNYwyFJWPoo8WDz1hiCgN1Odi3tcAMu48XvyQfrenvhPPczLneT9s/GU/9zxxBeL4W/0qvspcRRJxwYgNDp2F8fJAMZmRcI5GBp58VW1WDkYXRJMuOFkllc1J2nz3SiQ4C+noIVXMMc6zyzhMTswvHsampmXDv7j1ji15+6VmejePYCQxYzwCAdx+Ht46wsUJq073hAPXBoJIAACAASURBVLkWDnZVb0kSIpiPq16SYohlTwvgyATphD89gxQBYCvGtmhLbP7BaJ0S+QJ97dAlvtfDQo1emXdNT8yhsOmAtQkQiNAiXlM8ThkuZZ9DFzwKUzsJsFXEBB2LK3GDkgcMoTPuk4xFESJgyE0PnRaX0jxsthJ+QSpvq1nfNJ9a2Uotqj78fRzE52b3fUpgm4+nArPTYCCa14Gs6UsgtWxD07LaylSlhbncXhqn4yQXUBSOTcJTnfXKJBGFvtiHnVe4NwFWhTZ14Mq8lt2wDa33hdhQa8fMYSoBXnesip9yrUuD7OSA6wWSPQpKsXbqGx+rKpPBMNPqW0yNyMx5r2XAmCdYaCjGpt1T41NhocQe8+MbsCgzSP1tdiRah0w3HMtjDkn+Eitrc0jaTGNrnTWuC+xKwiW2GCZXCQrELEv2YWnG+REY1nomsL+PDVQyDLHEen+P3w/ktCt7qrB/FmmGcppMwlvM2yrN52gHDWz6ZsFZYrNq1l5GLkjmYFEXIBmYYw5uHZjZpVax1utqtjTrGfE5aczYygKO8fGq5yboofs2AlsHxsXPyyPP1x3XUrd65TM7Pc+JiTR+vAgeQSJKCaIDcbqhymSZ3CJytfIb2i3UyGydCpu/7x/HNrV6eltl66hdG6+yMWSs+/9+f/3tv9yyKp+wN2lDgdof5+dLtO2DdtUr2qI02vRvo/PY1z2OreIS2rBUK6fdTmNcCvu8DA3T/qxpEGWDs8VO5SPrEDdaCeQ1x7L0Ummymgifid54xNxueTuvgGctBed9N32e7pFZhMYv2qR52vL5rS4EbNU+yaDE3UhWshIAbuxJdXCLuvJ2dEuwljdBvWL/CYDCNG6vrKC13QxdSsEokKiQX3Gya9hpiTFWw9IrCrg5yJGnvLRjFWWNoW2OFREBhmMLnZ+yjq2QT/7wsCtMDF0L3XW0osRq7eHoPokmbOwm0BHHeQplZQugJXuQJk/OVX705AuWukFAWoATpyb9a8a+2H/xtCAeEfrRVRx7xkrFI95Sc6Xr0pjkib6oW9+lxR0DCpN7IlkDR/jKMdSBTKGHCAt9SBUqPQcczQ8DVgXyiOEJqJWkQelGe/u6kGpU+V1axtOwsbZqM1hh0+bmHphO8NatmzzT7zuAI1lX9yVSBB+E99/aCo/ukjDiZCx0obtVCoh8PKXFJgKAONZU5VEY29ufErAlKsKCa2x9sYzLpdoVR7HOvqMwPEX/9wvYimXSEawyAqu/45Ey3zmiD2oKMG+LPsaL8GhjANphY2vJTKbUrErRCdDqq6TYt4RPIolDD+/rmNaSedhojPMi/t5q+CaGr5h18bwZXbZ9DRua1qtrwy3POpnJL0zt12wv/PtnANsITs6rR/FzZ9rzGV8gwLPLRnHgk651ncgdCYC2fEbaEBkwzBtku0YmQsa0AFK3gK3FhkpjJX+2AVzTePs1Pj/SiBJg9DbR3DEZAb/LMTWBS2fvcgbY/bIECn1u2jzPBkdEXmkOS3epcHJc49cjX1AigQTO1EaGRzTn3Zim+W7bVqOR07OVK0sbriQKd0AbjUwEbJJRAGQNTFlFI+B1m2KbPul2AboHxKc9sIxdYmuZQ5I4KPOYTseQQUjeJcBbg0jYhwGu8d4+n3kmMjbTagjT/LqznYPZOE+i7Mw2HthdA7Jy6NWPUt1aX0WWXQW1NlbfpfbL158ERB3AxY1faj+bmP6ejY34/KJ11dhLG5gM2MY5XFyisrGn9k5rmj0xveIJU+xr77PIYMerdK1Hn3AG34ucNi7xTrJPRrrEfo/yqRTFwmVoqf7+nQR8m8igRkvg16Z2iOOto7vzP727/Mbfazm3PmFv0k5K2LDDHPqtdlV7YmBbPE6zL5d6weZZYXXQr22B7cfc4K0Yy1ZB2s2gRWCbayiTxS6XPh0LNA7KvCr5509avfZOH3GhikY2mwT2y9MB21YLZXF9bborRimZljizsg2AGaU4MQtckU2/lsBWY8Ie5o5WdgyH8T0C2FYJlr6zuhL2cB5RSq5e9E5yFumAXZPBtGNCHnbIBkTHagewuEq3KLAj5wgdpysVr5gDAZ06n23IAWqDjDBkNevuHDJg2wmwPTmQ25M4YRnsuPrYolnsTatYqjL1kUMKx3tDJAgAMGkRrbNQ1FgUlPAgKHuX2soWI91TYM8X4nS4qdtZhqGSxW1kb32BTIY125hF1tgWCO7bRdgeL7vakmfyk9hcPjIQ2dUtbW7VnND0o+C0ysku0NFPHNzt3Q3iwPaFm8/MUC9SE8P09veLbVJYJen/ON7Eqa0PIKwMZSsrZIDb7g+Lc8dhbZH6Ho+ySMiJzHOye2sp2YW3Y8bw2BhqBLYbSBFS+6ZWPwHI0Ltk8zkiNBjf7lU6XSQoRp8Rh9eOj/U7ESG4o9aPfVjbA+qlDUaPgK2BWoLxw85Ki31IYfaVZYguksOZWFzpigcH0Vvz+YCylMnx0OxZ3DjE0seVy8dz4ZX6q/Hd1rO+fM3HD2yLx7apTM1HwOUNVrn0RTvQ6ujW6pUhjOaWkPRjZGTQWURlrmz1SkAlAtF0gqdL9cw1NOI6nejpZm7Lo19AM6X45ndjSW3cCWD6BkX1SsXyMHIaOs7EClSom3VtiludRUngAgOxGBlrLTdsxtiKHdWclNzJQFZ09tLNxE4LgBprKZtmmnoHdUl2lGQHuq0y4vk9JKWRjMcBedKP6xkqbMoO5v0g2YChPfuuRQ8RKSAm2jbYMdJDbGMBN0ubyxd00iESQBpa/XgMX2QNArr8yMFN+l+L0EKCmD0A7i6RaJTCfI9/JYmQ5EEg2VLvmm7e+1ubxj6S43TjuCf5RQehAC0SjCxT3Bxk4F02Is4xB3Y+Tu0QzAC/9Z7Vz8C/0fKZIclkMj5DvW/SfFXmr8QvZ4KHBB6NAvYy+1Y7X7MynKCxEZ+V4tomVjb/Qmpc7wTf2yU21rX/1ip2L7/A/rbNi9tGjRt3QnQHRY/04e9ZLzuwytaHHMek+RXvGWuu9hSpw1de/WDxG2dqT2Pp/0T/Q7u9QgVe40ehv1oalQsB2z+KjK2OOYrA1juhEQLZhPv/CNheRFtTBrap+D6f3Fx4vdLRaWKe0qAqA9vmMXKRcrQaWe1ZGQGWOIFjgbNr41HFk43U5gUoZzf8Tk1LYGLoLYWVGyLXaDVi1yKwPcuvOwFbm8AyzjAEYmxr21XkCCs4kK3B4hIZgZKIVTPHMAynmACFexJLp2O1mhlknC0wCpInKPxTRfEvMazCmbuwFGvEr11eJX4tiQukr50YukoWbowvzlBKg6N7GvspI6UjRdulRxga6+jDQ4aXGLWE5VJaRgFrHf9V0PsKeNvxG4tTF+emWpbkgEIUHcqolJVmua1lE7BNiKDY7/6MuIzJsJfAry0DCWhzS6WcjByDAVaLp2sbIFXtKEzA0o5ODAH26VEKpYXzBBZHTilavOSlfQp47aRfe/Cj6+nFIY1oDEoWMYx8oavrFC2tnH8OwsyVCcDwCAsfzj3LRzC2a2FrlfseD2GtXe/sEpBo8GNAyAxk2PTCeeySGNsYFYE4tgaYCvUUsD3BXvUMH+Noxke92B2AbTftakk3tFGwmMFaJDkm1sJNw9Tl/EK/DwwMkSRg3IDtALIELbI1xofSXSoO6h5jRn08ApurEGGjxAkewoO/P4aM65Jjja8tpY1ZI+OZLWJx8vkMbf0qz7iPE9i6DUvHtjZyY6Faaxu9LGeVPlVQ/dRYv4Y/S2PVn6zUsEpEQsKGdk5kfGglawFs9cUjYqyu7KyFiphB+sakSIwFMYqZrTUi15lZHYUbGBXjqD4RgxvBoB3px/mtkyBn3Ytt5PWzEF8CZYqVHZnKFOXEx7lu7LVPYNrBCvNIG3DeF3NaHA8GWuVUZg6uUUYV28znbGST5VsQ09EqWoKXId9we9gw7p2FNRPrG9nDCPJVLrWDR1qIJ1Fx/glk2XsRPLkjmgMrT7GrjIRieaXxRQImGYPkC8yfXeyzgG6V6DUCwZKZmCaEOaa5KL8GgVsfaR5BwE5C9UyTfbh90HcSi27AVXZLdYpzTpdYZIFoAz3qhSqlDbez9voxplYb3YzV9rYQUPSIA96/STwhW2Aklv3kozdtgmzDpOXWNkHRZqt9NGZi//gIiTjATul8DfM55/d0TJvWkfRZ2oBEdteAbQS0CrkGC59ODjJ2X09qwFhlS+I1s5CGlcr7u6fhtfn5r8FefHJftI30g3+Jn2/QNi2B/BMBWx1fFBu5lRG3Y5s0YGxAtWds03GMDZMSQE7d0h7stf9OuUud+Yq6oYZCp+GcUoK6gU9x86L1ytbcpwWs394Qi4uODHMB9GT3fApg6wty46T2yejvmlEpF5rPMp2tzdrWi3i6qz+h+ejTTYIf5WRHPDLK0nsRK7nO0ViVXNu7HIkfY0i7tFBhzCxOLfpIpdg9NY0obAOGV8BWRldxLsXmCdTqR45ksrnbyBDW0PctLG/iRAXb2jsWxgZmQked47JjgC0F7oJhkF1y1sABexp3drQYx6cxIjriJzSXjlf39tB9AlhN6yuPWOsfNzKaBb2Wc7wPEEm9iDggIJZazceSM5ytXuUNpPVP/En38PHgDJUWK0/L6JXQ7cUPVHrUJvQmRFcPR+/qxF5YtD7aUwuFmBstDAqTJh2vshBVd0kxur/NPbQQ894R855wYQK7Y2PoV3HOOtzvJgNaLSw+qtJuyBDIjKbFR6lObdG0Y7iYpSwbFG7oRy4pKsJlUuoS7msJByHTyPmiYO2hWLVERKgMHobBcf6Gse0E2FbE2sfEHMpP3CF2SAyuyRK6wr5AO30xAvgenyBJA8B2GCZJjFKNjZOOXteJAqEUqmucCGixUl0mx8fs2jFA7hBMbh8bKIs8YVpmH7G+jnr5i0tLw+/qjzaTvbwcNVwW55O/V7zDmd9qelIOUJsBeJti2dtn2djmh9gXzrpdw/107yE578GcS2drQKjVK95StS8rH2WLqpw4bFQZk/xPx94Cm2IaHXwK9PBNjb847qRxV1gtMbziwQTaTI7o/Jq1sy6tmA5W4Nn1pjrx0diVT4m6QlFWUpxazXNFWVAZFQpP5RQANZtEPbVR9Ox+HjVBWMu1tzFbFeNH41eAWw5lOolKqajVJLbpjLFyBZZrSARkB/q0cdbnNjfS3iJqbnmu7iNAZKDMDJiPU/M3EAhUZAbmuQF+7/H4X7dzxhTG9ne9aiEDYASgHvrM9byyeWJwayIi2BiLjd/GQVA/u9g5RVc5YNMvGZOebfczpjgmlcj631YBc1rTptzmWCyd2VrJgyK4Vdt3QSZ0yE55eJNo5wgHqVBl2tmqQ1UX2cLolGfRITRmTOcre0mfaYMkyUphJpvNisy3lcMIikJ7mWkVWeIyFm8uu9Dun9uIBGp9FLs9i/+qX7QpsQ2Ob0QS668Y4Op7GzfmSKiNlTeUb6Qy+iLrv8xWaOgr/bzGSUfnz7w79+W/cuYE/QR8yPj4EaoxStv8UqvqXBzYpqgI3oWpW5sM+VnANvbSUzVr2fg2g8yLLQiNjG0B2MbFq/E5xUOLpyr2R/Cljx7YqlDpyCVOz8bFyKds08sUVhGI2ednrG8ObFug32wBi/WKWEyMrZwY6soxT+iqGsDjSDnhOf7SYtItkAjg0BGeULeMwAHf2VecSLG9cnrQLlwLDQ5EAqcHhKDahl1YJrXn/bllwFoIY8OzYbB3gjz0sL8nviCIGdB4krGztkk1jxuJvC0873wPYbD0Xp3YuEr3KwZGGl87JjRg6QZUrK7Y5j0iPIi9del6nDuGmHwBTMar2ODGOkT9ejYmjTmKXEgGiOOxuY4z7aw+Mb7OMNgiFxMnSKNqaSfNckuTLOa5h3zy6CClS7aFmjJyG8WLVfnNWY1rtfgI4NbIbrFHHx3StsdERzg9YnEG1GqZ0LXppMPLHLdHBvh8EVW/jYqxtZS6hBsjvbG1SDxSdeCIvi/shb4R2GN+TntweKvEFMtiJsxxUCHeJDmhDPyrsG77fFdphAeIGjE8BhNLtAclpdCYkUxEm6AtGKc1dNwP5h6HxeVlK+L01BT640thUil5AbdiegdhcLUxERDRAudMUgtgG1efjGVvA/pab19ij6fvNGxS823MxY2Il688Mc+Ka2vT+Bygmj0/ndqcWaB8w5rurTElJzJpPBUhodXL2sf6PkGGuMokE8JnjzeWTFdqoMMYT41tP8o2XW0EL2Jb9RK4FVCtsXbprr3a8HLNjsIGAhz0dy/jR3pV2UMBqYy5FLPKtQKph4AZxauVk6XYWIFq6dRVFj1XEimBaIuzG4FrOmp2gOssrY6LVV5FNRBwFWA1sAjYV510AmSnPZxOWXAQgS2eLVlChbGYxp8mjMqgdMAalpq7R5zC6FnGQkcm14ICmn1zYGUEj9m4aNEEHrUZsPnn7S845jbJ7Yja2N43OYfu4Wy42TMD0PFkinpIFqbTKUums70dtjY3wwbJdqpIwXaRN+zS90dcY4kxrBTR+AvU2u8O4sxF1vwHkqaamkgLz5zs5F+rg7G2krHJz0KxgB3YkrjAQG1H1LS6FMS1/3KalSNdhQ2xwK3N6bgJMLsjoGkhuyRr83a0uaEGskQhoiv0GG0iXI1h8z6eCCQnucTou01wJ9/0UvjEVG0fa05IJLbfxoNOngR0o1whmnFvs3hPv1/sR/6RndLJocgdHAx/7N3HX/7tlhPtE/Im/XKdqvxr/Pxz2kSOIQ2vCwHb17/xjkdFQCNVxDIJFqYmtr8LbFd6v4H9a8PMtm/v8hPP7pksMLxNzKRj1D1yFivdwd/1XXVLFsIeXazlRzEqUpOXoWOqZxu02AppqjhPzNj68ZCHlUqvtBidJbPw79kjC4t5tpDaeppWoWI7FZ4Tf82q4noGN6QyKornqGMvEjEoScNJjRMVGSqBPAy+EhIola4zg2IOFPoGUCvjZl7L3MuMnjOwdcJTbW6RkhVg+3BhBaBbCZOjV8NA1xiiTKlrSTJgkMtQi5uJOD4TO+5lzevQTWQBMbZiH5SNT9o1LWxJypAWH5W3n4VQzJ8FZZfhNaAXga3dNzpj5E+3j2XwPOtZiXmzkuQOHA27D4qoRThnyRvHkS9KepC0r845qMbS4NnxnDEzcn4x2wg7Xgn9cryyDQW/87ec5uyojGJt4Ii3Cgt+TFq3rA2NWYjjwOrnbWt64zhuVI7RSyRo+DSM7RtLBmytfe141b+rCAyHHchGBg9wIKuFnkGiY/SwaJNa1DYuBhKkpab/jMEBnFAKMbdicpVtbIBQU8M4wClDmzLTqU0VBmlnp4bWeissLC6GD+7fJ4vbsmmyr924Fi5PTxMiDIAL2zuO/nhoSEkGyFxmYEaNl7jEFmM6W2PyidrQA1avNq/sg/y4OTaYL/gXftkkjCPWQYf/4eVuZ0LaFqsV4E3z3LrXbWP5suJzkq2YmBgxoLDaRo6QkiakehuwigVLTml7pNVd3CYUIEflupeYSmmnXZso4AIQ5T0BSR2fm+4wtUic1w4M2AQBLg1IUXjLYMcGT4BCEh3ZFU9m4CcOCi2oaisxygmfCRALrOu43hhoyjLABsricbN50omNy5s8TKEAmgC2XiprYnn1PNesKg6udO2EpCMl+D7f6e5SRAEHZJ40QeBX9UN6I8cxxvOgwv5RMNkXMX6mEZckQBtJq5vbhHQyanY2u6fPp4STUhzlxA766Ulu+dJ+ycqTyI04Fookk+oidjgBerWPTqskW1gnC93i/BJpwtcBudWwRUIe6fcTihcxoM1IxtjbBgZjJDZBjCSh/JQ63TLLJad1ynMIqD9lTGgNEdDlP4BbB/0mK+CethHmJEjzqcIJXY82ABobBtK9vD5WPD6xHe0bkaB7eMwb/ffQlioHpNYmxvjzJB9Wbu/SnDUAr0ZMKdpdtqJ05PrXpSc+JtyZjG+aQ7TWNqU5FmvrGw3bgMT5XFx/09zVpkzJSax/Q8fddx7+yzvt5vUn5X3a4T+gLvdox6+W63QusOULlQ/vzq/VmYApKoLdxDoyP7JtkCgIiDwxgG3X3Pni7ukEC6+C41RzZ7cy43G2lx5VlEQ03j9WNFnWpx0RemzhuwlINVRFE8BkPU+ykGnexBl14bIlYBvbVZNe/WgTO79Xczk84LhezqrJtiTQrwkZDUMpSkbWL9aUXB8Xkzh8Epx0Y8EYO0bTdcCOX1nIJEXAapknr56lXbQMlB0psQsW66LMYpIBWCxI2ZDIanqYr6ivJVnBo6U1njUUpkaukZQBTShpYbtOkSOkOkWT5GV0sG3aNtu1yzq6gequaBEjzJU8jmEnjtjJS/eXvGPj183uKvOSGAId2R2T/cw3Vz5nEpRuGqXpBjKkBWDrIFeW0w2nLTrxy/rdjtqsidMmpfU4yvo1fiyNbkOGNPVv+h83FHuiZBhyNGMdtMVc2aDkZb2Dzs7ifcb6qHzpqV40r6traNP4igkajLElQYM0tvEajzaAIUfHfHBKIo2eWuj6f7l7sxjLsuw878Q8j5lZOVVmDd3sKrInjpZtmSBkW6AImKBgQIL9wAc/GdILCUkv0oNFg4IhgA90W7IoC5psQiBFERRpdbPZTfQAdrGn6q6u6qnmzKysnGPKGDLmiPT//Wvvc86999wbEVnddGff6uiMuPeec/bZZ++1//2vf601KoCiIg1KZiBGArevFiXyFVOJiqILJO/F3azFgmexpx8AL20eU/8jxYg0UBG1jg1bU7vv3l0obt6+pZ/bkiesKIPEcHHh/MXiqcuXi4tPXijOnVMFMxV4mBY4hlnLbHhqYTyKPK/zNHD/5xHVey7X51dM+QZ75X49mT2ozhtztB5bCvBqfsVdNb2OY4/av1M3l/kz5gIBe6urCmLUZrT9Vbl3bWCyfDVGUV5L9P41sezrWw+SDVLvqNucss2GKYKHcgovyxBKEAJTmrIrCPAiuYkOCj+K2VnGFfPdNiVkPgBcJACkvfMI1vuReiwCwPYoQatxxQYIUMt50PnThj28UDrGWV30N3IpQDRA2bluExUHcIWlhdUliwEbRReWoB1JY8u4p7EG5FxbgXTc22Ca9/u6H8Yo36O/CPTCJo/CUuv7eLS4FxeuccYG7jcC3jivpwgALq0H0Yex4Y0Ui8ESxyvGSggJEsPLxlnvhS2J3MAee+jsmf76cZ5d2cIdMizJ63NPNnlpcUnFZcTsAnapLCmQTp9axpGuR7ujWpo2skioAJ3WynJeXQstdUp3RmCcgWiShtlO2vsFow9bS/yDNsaWI3hwub1lEJ4zsqg/UqEfd3YaJ5AXOXA1ZANJHsBz9LmqOWTPlT0I+qENqc88lrm2bGikQguvIcuvg37pO7xjGgd4yTKwzfOoCdR6jqi9zu3uceJJ8b+8evXPf71xUv+QvKm+oBLZOfXpH7TfUt2axlobPy3pvl5++bUWYFva4S7g1Qzb9xrYuqUVo1ibX/61HFNpHNZBWnXTRlUdjzXsS+uSXJ0/rWDvZTCkBbDEgTUAWW+bd6oN61vPSz8qsO1YyDJSigb0Arat7YlZH1Gv2LHWG+iYiH4EAewi52N6MaFdihLWVkFZchfuC+AeimV7yELIrtd2CGPLNSNBP4FkGKLYcZPii4TosLX7kiFsF4sKHFuQtu/mwn0ZtZnijALHhg7FdMiFrmXMxpmXZQw+L4Mh3suRsQHvoob8qMAVCzQRxOTVfYi2NO3M46gwcrRxVGwhx+xIskC2hDzEspQnpxLLXYDhjFcGwNWmzsY3LTqZZsmse9jnynUbY7xznAcLYyubmhk5d/kjB53VNyIBNmBoBCpZeG14AxBEQQrvxPxDVHh7OqdyRtmNWbVn+tRokiIsFMvOYxtrvCPAYeCUEWH7cF3SAmkqh8TcqvzwyARFOYJZGxWgGHagl/TUlExlcdDP5o6OFIMMi0cmBL7DZgj5hXuHhUmbJ4INcZHeVVq5JRUDWbq/qOOk6RXj8cS5c6q69qPFcx94X3FR1cvmJWkYF0jOwTwxVliFwpQksxSPzffxqMA2j4Lq3zQTqzfSc8vX6jyic97WpVcRsNn6iucS4Kbb+botpvXv159vE7DNcgQ2eRvSvbe/mMf5lfu13SbzNwVaXn7nHY85AJpZSoCt/g7GMjSxANHwkhTemHB/uPzt3QHIEWQoBjB0uDpGYMpaXbNrgD+8QQoMhe3XuQGiw+j3HdS1b2aRMQuYwBbw+bjGIuCSIEXAKtIpQJmDgpgjSY+7to5+XdvsiXGn0uI+SElnoCpAy8btUO1x8JvmhAE35yFYTneCZhzWb2Nbml4zdQK5pLvTMRzPizLkcJJ4XGABmd8w2Ng559hNWRdot2MYmL8AXr2yC577jgILsbkPmRFrewDKeAW45Zycw7IAfQRQJ6A3hlUsyrTdGlPbIYhVQKlYbj2rVW02lxYWizt37xR3bt8t7i+rlLgAMJkZbF+YV0iCLEWKIjyA1ZzlAXBLn2OsGAuh2Y81Kdoc2XSQ5yI5Q6ZhT5PvhTbGBjxLMbg7gKc3AyZ+QtOMh87yDNvF+pyJfikxSsIhtjs1Ps4+LMaOmXR+4vzYDXvpsPMaXzx/bC3PPGtx8/wwMVJbZm0/PQ4U61ACW7TH+5feuvmVGx2T7YfkDfXDZd3Kz+rnj9WHSqNUveooJFa4YwBbD4NYTRu7qMmAPnpf5tUjTaOma6aveOKkn+MD2zw486pRHzFpUnZjbPOkPYLRzZ1aotZ8XEYYMa1iV9fcpd277xGBbV7wWgBs2a7OBTKgX3qlCd2i90kApzmdWq35ukae5/l5+e7BR+iLZJD3FZhwoMXiUAvgQzIPaDGkjnnFKAQwhqnlerEshw4MF92ujOWmQOd9abqWJUVYksZrUf+O9MnFPHFeQWOi/xQ4JnMextb/hZHzI6BP+V+SqPB4ccNzpbFUxYcEPy315AAAIABJREFU6OjgCAKxMcv/j1FlwRMbMqyqSyyYaHFZiCw9sFEKF70v5xuvDGyMwjB+LYxtArYekWkOlC4vd2+Gy2kGe5cR38hTpgS26XFUrahY5Dwbsi4vOEM6mftE35iHKEeHq44FhcU3imVEf6Zf4suBA8vXFMDWWREELHPlsfQperR95bDdOlCw3+6SKoopgHBsvxidIOOFKqmNDTsQiTReo3L/jpD1QJpqWXZlwNgvVhXAc1+bIgLJcs5TL8y0nWdLEzVGCHhZFUO0vrZeLN9f1nihslmhjBATxUd//KPFj3/kw8Uzly9KljBtwIKkJPVmLJoGy9UrL37HBba1Q0OG0WXe57dbgCMLbV5Um/Fo+RyqrZFGX+N3w2LWmd6WtqV5zSDqcam4XrYLtS/W233q1IwHY2d2hGT70oVbrlOaxMpafPPK9eKdewvSr5MvFZZVenrraKVr17iwNpPsKepXGMLMxjp1U2ojoNdlZsEd+j9+5xkHwMEzQWnc0L4yzsjruik2cVhAkfRw9AZAkIpevJAocO64liQSABPanlzVdisnBtKMoI6hKls4grQZw52u98gfTUAbpXYJYqTNAGNe2YPknhAQ2tExfTqW88RcjxLABtFkKOA+JGsYlteC+8M7Q1EGNshmC9M4YlNKkJxvPJFS+Yl4TpsVDpvoILx42D7eG0daztf0PbPPuk+cq3jUqpSFAugpvRr3y3EcZnJDz4L+BjDS57C5eINgc6++fa24KT38mgI+9/Q9B3Ryj+o4Azr6xddPz5Zz5jEbVj1sLs/Idh3bCvitr/MBfG0f03/ZkkXwWQK/nNfAnItG9pz6uM/zhjFVySD1bhmEWn4jNg/6E3thmYS9gxHs5yBVxgu6ZRfMiMC9PHZzO6s7CKA8ii00sA0cpOfzb7977Yv/U8t8/iH6Q/3AhP2b+vmO7vWb9Vtrsc30Rfrpydi64/z0mnvp5MC2MlrVGdPJWUDq10mD2UOqy/XDAudbaWtjCwgNo976qg/4dJ4jgKu/VVtsDDzaWOt8hy3tbmknN9a5dBzFlsTGmYEdu0r/1caatt6f+hN2VA1qYlMr1rC1La0LX3alV2fOAnl2wvlVZseoNSCn18kckZvqNFW6HrthsSR9aM5k3A7FfBwIpBxocSJF1UMnDI8BcEBfyZeE3ipitgRo0b1qAdoSqN0WQF4mJc2DALgr69sKGjtTTI+eEwMsTayArXPYwkKyT2c4c8toZjHMJYLj5NgxWJ5YjNBfbalEL+RlNoB8yceofQDuUS2AMCmu8y5hFnMwdKzRryzItr8JDOZqSIk+iOeYxlT5nHI/ZoPatsnLIx4jaYY3fd9PpGFDaD0ut5fHTYmA87TAiMdCEEEoALCaOU3jHCNPsYr6dAxpRgLoNXTFvZAV4VlJEa59+54Y27UWg239oBjbjb1lA9vdPjG6g7tiZmW4AbZiwSekQ6Rc65TSdI0T+DY6oXFAdShlwRBgvScN7Y3bdxzEwuIKi4XmeQjjT8CQGa4DsUGK5laQy4rKBW8KABwK9c6rWtlHPvKR4iMf/LHiqYsXitk5MbYCtq725m7xFqqH7YltW8uGsc3CtP/Z67tNJq60JR5AtbN5HtgcVG1I9rJ7EzptYLQn2ZJ0uvZv9Wpzy2c1+QPPjI3hysp6uMPLV+vZk0nLNxEbkpp9JffqH/351wVs0aHitpf3RXOLSlx8BtM1JjAK20pAkwN09D08PGMaQzCv5L4GnPJdqnnxfAF2BGKxScMbk6o6ebPMeOFFUCEgkeAeQAgMpfPDqo3WfpcbIG16pfsExJLLt18ZPQhiQ9LH/aG/xxMAOEbXO0TwD8FlBpdBIuCRQO5AlTGAMh4IgtdoC+ci7oVAR9oO8wywJFgVN3lIKsIuugBJAqcw1pZZ4JIX0I37Do8XTLHTkcFUZvkELLHmDpsIF8TBFvK52hdyhXDzO5gPbbKeA991AQkAeQbF6mvuMfSpMMZx3QC2UXDHuYRpl0F2yOMIOHvr9beL737n9eL69VvObOJqbAmsusIjr2TvvA0HZPvNpHfVd/gbU5uPC1sZx0a+2TQYbe7DzlWbx2ouZGBr0UvaRLRvOvOwNqDm/s16V4SAW4bNZPwxth2cGsDWJeHdXmwum6tg7kOiEBGF1fyMRStImdiAOR2eL0CRDz2TvcOPvHbjS9/qPv8f70/UF/8100n24RP1O6nbzbwu8u/3Cdh2Q6I0qWaR/VxqULB+GBOLwRjjtssr30rnxy314RNA6PpoM/A8LrCtnQg5RmhQ43Ukk9nWiPaFo5u041GArY2AF8E2yUi+X+9y61xP+0Jd6W3L+0uRn3Vg2562J+ZbiODN/6kNPEvi6ekpGz0tBn0CgocCKEgR9sWo7QvgPiSli9P7RHjUPtYL4wg14LRPlIsVq6JFYENat40HioBXVgVK6fL7hoDo1MQFBY7N6WAxfIfSa6kTDKwtssMAJXALmEu3H2s8/RTc5ZQWZ9qwrcAxgG2/gjwwyuazMKgseoJmTvWlRQbX996euRR9J0clp8CDCF+oPYc85nOvJuOawHwehu4rLwpJ/1sfd2Yk6kGT9YGVWGlflZ8kNmgaB/RB+by8QkZflcY8YeUaa9EyTW2AuXYr8srANuexXbkbJXXjJ1Ie7R4qIXzfWrGxv1Rs7q0okIx0X2J8FLRHlgOewbQyHswprdf0zFwxMT1T9JPVAe2vFsk1pAZK60UEPgCGnKcAhAw8mJcwtktyd96TZhM5AgzQnHLfXhCYfd+zzwjUXlS2hHmVJ54wKxeyFNoIqK3fU/vEzX3f9n6PP08KbPOpfFwPYBs7p6Pa0Qls6+dPMD1OUwPJ/N00v/21ul2tAVsAHlptdM5sKqpXWxti4CXAoXnXcA8vvvpW8d13bqlEsp4P7mmNy10t/HuAAdkKTG9oWQXY9C+6XgACsgT+xZMyq/HDvCVbBhtOzuFKdJq7MIeu3pXkAdZTInlAcyqdq89PcBobauQMuMd1NsZYuJlD9pI3viMqhGIWmfd1bhg50u4xthz9rl0ZWUoC+Okz2qnvAfLwCpFezFlM9H2zvPohu4MDahNLzL0AYi0vUPscSOcIe8miSJFGHyXGlhvgOQW7GuVfMYO0n+MAnpAEvn/1B/eD1hYj6f7mb/UDG4vIINDnCmYAbwI7AeL0kYnRxObGRiA2CBEMlYFtZLqw3EwHOagtrUH8ti3bfVvBv6++/lZx5ep1aXOV4UaBxQ811+Ob4TUKg5PsMBfJ6y820ZuYaj5k25ZBRC4jXG0K68OTepPJQ5PHdlrHsv0uwWS6ZklGYDdg7ZMt9fqX7areNKjmGMsSAozyTNiIsE6zETGwTQFmTqGW5wP9m5oJ84u2mywxnC/O5biCj792/cu/eJQVeFw/Vz//iNr+n+nnD3XPZcqV+lqU0WBe6j3Op6enh9o1tjZefhjN3dGdsa0W1uN3ZM2a1oxricFqJ2oFf03gttOI19mJ6lTpxvJFGhey2ujKA7XeltTsDFWSd/vodSad4yimtrWtXR5EYydHHzQupmWn5t1q64pSMYeJRc+rHYalAdg2PaP0CG0m4uzhlgtgmMTz0ko+JFqYtDwCtjvSpEmo6gwJDqig/d56iWGwS4dFkPK5+3JH7zjF132V0N3Y3NAPuRbl3to+KOZnLqvcLYFjqkbVh/6Vy1PYISf9jt06UDu3KXbVAbzRkE2JLcS4uOgCTCzLAauXjWcYeFo4Jj0oTNKuAHAGtiBo7/Ld4nhmFQZoQiBpg2FLGAyDx1M6KNe6z31aGc+cOSHupmWS15gIa0Xz+Th/yX74sfhvL05mldMmqM1w+wb8pU5zkNvZ/m9kRTirPLbKimCNbQVs6bu9h2JaBzaks72vH7kgCwEPRTT3a8FD60u2g2mVzJ2fn1cWA7HwStM1Kr1ivxZUSu1uCyRsauHbUVaMiDgOTSUsFn0GC7Kq8XFbC+StW7c1braLGVUqIyvC2bNnitOcV7ltJwVqCUBzCjTfN72ZfQ15k9b23JzHt+lZNk7Gqv+7fNxrZncA29TC8oG3m87GdnXaxHpTIlo+xlHTXTXdazdgy3lPn5m1tnJFVQCrV9vZ0xjL7FptkpSHUO3vdz/9RYNKAOYoAVuaywDYIeQBAGNLZ6JSGKwZsgTm5Ji0tbvSVLOJMoDQ5QEQufIXukrrTvVvAIqYsbYMbBo1H/DE8A7XBrCPSwJBwZh12R6u76wKbMJ1EJshqhTyXEjRNYYuXO+TC5ZjkQHAPOY8trF5pFCCdL2w0m5/nIcDAT5cAz2xGT3AO4yqAXaAa8xjFBuIFGCwpfxtDwb9o+sbzCYQjsRiX/fk0sXWLSvLiPqSawBy2TCwYQ7WW1pjQCp9hv2mcAr9TYYV3OnYPYiIZHucT1fnsL1KADQY4ZALOeZCX7ZWGkBGyjMzwBEAl+LBbNOv37hTXH3n3eL2rTvKyrKoYjFicL0uqH15PWLcszFPmreQdcX6kgyop3N42GJI1UsulzYxDUsHqKVZUJ+PmRjqNjdsT7GhDnhGQhH95HN4fKYYEzc8bK3zpidwS+MoiwzZk9OaOeiRRqfOzYIoy2kIFKS4DOsZ/ciFILG2Dz786t2vfbu7BXp8P9EzGFPr/3v9vKh7fiPfyfGAbUr3RUL6/OrNmFYLd3170QQ1j9WlLaOpOqIbC8rQyaUxW8/fOQQrIxwjPJb6OrCt/uxsf43xTJqdLN3pwMLHwJ4tC0dtZ1hrUcPi0r1Xmy8ZzlS/PD9qV/Wv9Xuv8u/FZI/DAkDF8Xmxr0Bv21UbGpGvWF45ndiLKAZXBvVQABUJAsB2W+zboVLt2MJh2CnhqAAuXDiR3iY43wcCwyvKnXhXBu/2vWUxtorAtpsLMDNQnJq+VPTva1HZBXSOJ01o5InECgBUQ8aR3WRspCP9DIQCbMiwgBWMhZc5AJn/pQoSUdAp96CMCal70JTtbhMcwgKHwUoRq1zBDEViazlbDXDmUZiscEu/18cz47zSDWaoHG2ORxM9HGES6dnVga1Z+fQd33dmiNOVcUv6+6FfC0OdqiD53uP5G9vC3GCsawxdNKHaRMV5lFUbKcJHLyQpwmos2HEm/S4ZilJ9kRFhv39DPwrMUfovQn7Y0KAXBJhMKBUZsoEnzp4r5k6fUnovUpMFoCFTxo4WA55JjtDOiwb7LxLf31e6IcbJPRUCYVE/rQwIZ5TqiyINuHcncWWLIR7QZ5mtNbhP/ZotXH3KxE2cHNjWn2nL7/R57Y26fcjPtxGr5oNaDEqMh3bPT7WxTytleb22g/NYb2hsO7ht+TvN6XzYrILxCGhaVDBn63HtjS0NTMdGwfsoff2L33yt+M5b112oBXA4JRaf0tbMNQdWaoqZtRXzOqvNDwFhBA7CKO6oJCDsbB/FAZjfjBvSLOkwCsE4p6zeE7FjqYE1oElTG+m8Brx5Qh9K2i4ypZAZgY01WlBAE+109gPOSclm7IdA7YONLXsQaDP5ZwEyExz7YEMeh12n8SLvK/lWmckAvQnJbgCF+2o3EgRSDPKCJSXVGDmbwxsW3iPuGZti4C2gQ7YFjkODDIPoHKqAHgFCvEtsDPaIZ1B/INWAGYZZNiOr9pGNwWnP/Fjw2MXYtPSBErvqb9hwnqLz6wJYwyFl7bolIwB0fc82JQVgmaHEXqm9Q8iFZF+di5fz6JouDKHPCLKCU168v1m8e2dRMrMNpY5bLu4pbd+uvC97knNEctmo7sWmgOfiQhqk5uJ6gHyzpzlFYTWYy6xAzBFvdpJ953y6iWyhYmoFu1yOWNvFbOsqgiCAbOi9M4uaWVljTp4U64BeXk/1Y9xSLukUGYnyx9wPoJaxSIti/QgNtaIbnJd3WHYRrxXZIzgNDk2TRXv7//7Vm1/7H7ramcf8A9mRX9ItLKtvv5BvpW43c3fybylF0O9DV67ech7b4wNbU1j+L16sfMm1+T3sxFZneXXikwDb3L68TEe0d/Or7KAS1eWhzahObJpH6aPdZLtpr5+lZPg6Tt27vU0tCTAWz6UF2OYv85k/79bD1dyLxan797r1RMsinVfndCpHusqoETR2IJfl9qpy2u7LsCbGjohb73jTognni2h+wBWj5I6WEbi/vl5c167+7bevK/hgQRNfLN+YKo4pcAx9LcFjIYSQ3kvsKs+PzbAXft9/9FF2maHFQ2tmg82koC0EiMmWOP2UjJd324BcqqCle9nZlGxhJ9Lo5F7jI5KG+5pZGwboLUFnbCjqusL2fiwBY20IhsOtvtmKo9qBbc7ZmJ3J/J2ZG4+K9DycJoe2Au7tqg3GoWJg4/z+O9tjf157v3a+uK6qfdUKNITGNo8fNgBaiPrl4hwX4zO0KWCpBVjpv/YdVEZRicSQCXyeeuK0shicLabnZpy3Frcs7WANA9wSwUxjfHZkJ/QOKYdkyxaW7hd3lBWB8rrods+ePV3Mzeo8FGYgMp0AoVKiwn3DliXA76FRm3f1KZjKCJdTqRF5dpsVne/nUePnXfs4hmgvi9Fwroav121BPMvqOA/Z2lW7FXqojomD29tV3+TTv+MTo0reH+VYj76HgABNr2UFFP32f/qsdNPSsgvckq0EIDOgan8Deg8ACkAFJDI/0VpH8FOwgtwsoI42ZCZ3Td9FLuA5qv8f1bk25DkCpQEgoQVxDbu0d8o9SuAXjOy4wOeeNrEUAWEssrkF+O1QHVEMMdpwCspsSzLF+KJKGe3ZEjjBZgAMAdIwpaS9unD+nAHUiuzfqrTgZFEYMysnVtW5dCNQaEvtQ6ZAdKAD6mSj7osR7xPIGTPYhLUNMObUXToG1pj5yEZgWps55+WVF4oATeuRU4pFjo9c3ALxyBKQV+l+uQa5eU0KkCVC54xAuj6lWWTzQGBfFJ1AIsL3xhX4Sd+HfQzZBBIJ+p9+IsMDRtheeMBpSkv2QPdHtbm+oXEFDa4V7y6vK7hUmw200YBiNjayDyMAZzrEoF1ZIrSG7FEWWP1JMN6ONjU7AsGw9aRm21E7t5G8pUAt2gZD6uXRQWIx4b0hTzPBG5ba+lmfIXnTGDY4Njb2/qXMCmansZMGu8nTqDfMVGcwzdm5fzYntEc/gxqD49rIT2lsjE9MFSOqpshzcpX0A3kkl8Rea627fXuxkLPTrHlsGPAukM1BHsu93Weu3Xn52vEtz+PzTT2n/1ytfVL9//u51UcCW0sRTsjYxo66WnGzrrXciDwq8mvr6+8lsI0E4bS5amX7oy0/ScA2O9Nj9H+/gW1Wux1/wDVD3hpL6AnYsEDWwFLF6KTrJtDnvihBzsmBbZ05qruqWQQxauSuPUSOoJRd+6p21W/jGdOd75NPNaripJrs7PKV2xHWDlZiSAwKwREbOv7G9bvFm69eL5buqd75GgeIjRucEKM6bG0lUgTAMbthp5XhrxQIVlWfQVsZoA5QY3ed3OO7+xEpHf0okJwWjRFS++hc+3uU/oTRFVArwTKsHgxRBhLB2CZL6AWIV+ix4h7LVwKQMb2CLa2/Mi43KE/gvw5sfRSsBCDckcUVo5qvWbqAaQMMi12jGbTE1cJox8v6w2Sgo0JRa6Py3wABXq2Vx9b9XrSD5yv3o1J8DY5p8RzV7wOUSvbNmIJAf0eFHYz8vBjWuTNzxeT8rDYYAgrON8uzjJRvPp/djwFi+IH9YIO+sLRSLEhjC+M9K7YLPe30pBYNggPlznX/UJAigdmyX93rnu4t91l2Rwa2+Zqtj6fxr17grhewbTpZz3N1wcHdj4ln4uft+z4GkE4AvDxnthdpwACgCMjb0jNo1dl2A+px5W6v3/nEZ8W63xcoCtkA4tJhpT16ICBD/lnGC6579lQTAoYAKAotzM7MGnStawMMUCP1F253xgeBiLCTVK9y/lnAkQAPEhjGBTII/gX0jXNOgdQbN26YgZtSiWZ7CwQm0PAybNeUkxvGdGpqyswo5cHxGkAWmf4hQbTaSu5ZAsoYh6v3Vx1UBjge1WYA+4B2eEQAb0zR7zC72D/ANp6iVeRaSB7k0Tg1f8op1ZY1vgk4o5oewDuAOKqubQOpcW0EeLB4tOgL+vnU3JxB/wPZXOJERrUZ4Jo8PsAYthImFHAGuEcuMMy8tC2JlGJoqJEjEMzEk6OPOTf3wjNCPkEgKNkLxgisU1so6T3gORryCTY9DxRbMarNAOnURvR8Hg6MFC9+92pxZXGtGJlVjmkkSLq/QV0bbmJMtn9Y5zLcR2Kma1pD7EmMNprqiZyfvOdK50Y+XY0TADCAdlMykg15CNfV91usOzIiW/p8Te0ngC+YY9lt8hWngAxGpzMaeJIEQM3mz2sc7YFdt71NwJYVJLO5zi0csgkTE7b5ugbn1eZl7olzxazkVhTLMbEySPU1bby1xk0qp/rzl08Xz106W1B0eWlhqfjsZ75QvPTyK3r26nPp9TKwlefg/3j91td/5Rjm6LH7imzNs2r0f6GfP1KfKwF6K7eYbSj/tgaPvfK6GFuBglKKwAPobuaqRa9ukILj6Mrb1sBUe8+2u8/y563Vs6qjHomxbVmMGyBhuqnqk7yHS++0M73NqLLnoOm1bNT77RjLS7kYdV6wdbGqWMLaN8tnkYFT7YrpV9+ef6/c2Y86I+oLa2Z3qEJm1lZj7kD5Gh+Kse07TLkd9axytRZcgTQjIk8TICGCHbdWMigk7t9e3y/u3Vor3nzjZnHr3TUZOeVDHRGQoeSqmQYd77K3nCMCQeL3uCvaaEbWO/Y0cRzAFjtkAzM0Y9gyGAh2zfpYaVXFNKZoVwytDR0aKNJjBdDiqpHDNcBsWMaaDrcObmlDBrRpza/PxNhsRJsrYFsbtenDJmCb51kd2CaZWgA8nybAfZ29zWxu7qcsR8hFLirwHA2bPjXmPLbXv0se29Ba5g2UlhslYQfYSt83rIV/UH1KFWUWf1gIGXWCJFjU5sXYzqhK2JgCkijewKJq6Qjro/4LVUQGp2q8Fkxyk1J97K7cmBtaMGG6zihobF4lX5Ef4A3IG/GqX6vxX4Lass3R17mH+9oY2+PMieMC23yu3JomO3BSYNubMeWhuzN9f7mAxlH31LJZSsfWjzl9OmQB95Vfuv5qbktvYPvKa28Vn/rslwWUxrzYU13OaaYAUnLvT4pFpZ82FEjI3JwR04+melvgBJAJkISl5Tg21LxHCrkVZdYgCwusKeTukiQr86fm06b6oJgWSIUJBvQEiBNgNQNLkKP0tgJRKytLli2RoQEQC0Ce1IaMwghDKXodfeykACbp6wCAC4u6jsY0m1FSXjEG0Y9zL4AvpFZsqgGlzq+LCdKGnhfnFby3jRlXUB1MpZXG3lBGPlyzvcQmuFIjObYJzJRMQt4ufrfcwps7wGqUFJ5Qn7DBJVgs65YBfWweJ2EPRR3uinVGdwtrDig1q81mQ3MOucSoiAYH0zrfrvL26rMJgW0KKbiwBOBYrTQhoL831Lecx2nTsBnTs5IgLBd/+qWvF9vDE8Wl9/+IymbPqH/RBKsoho4nBmJIbYYACXFaBJfZVjnAtwKh2DLbB77vP1JAL6CaPvHOlYBkykCrjDgbEXIw63cYcsbufT2LTbXzgMw3eraQF+GUqmyw1ySbrggedltgWtEd+/dgb21c+R/PRjZkQON5VjKrQY1fYkl23Q9IF3R31ngItkuW8uTcaPHzP/uTxfPPPKlNyKByAC+4ottLL32n+MILLyof8LqfqbTRK6/ffHH+qLn7OH4uu6FOKpAjfElr2JW6Pc6/5zW7J7B12iJbu7ppzYdG9HQwWw7rKY1+mMcSFrT0YXkqjm3r3U5gG98IYNuJINuBbWUaMxhtenxxznYGzG/W6KnWq5UIsONeeigauo6dpoUqf7nbhqD3Mc33Gf2RmNt0by2LSgIEkRrA5qBkbvw3jJ87i/9778C2nugalsCBBQIg+1ShQT+1qawIArYPD3ZtgFg8XGnMO+94Pk4RY+PADzviaF/cZ8gMOHxjfbe4c3O1eOvNO8WCIvKHBW4nJrWQiL2lYIOrDVG21w8wtNp14FjVOefcuOb0NV3b6WpY1Iho1XEwB5jqXYLdXH0ngLFssBdQb+ZzGhhYAKcMChdW0xjMz6cuBWiSKrS/V7rHGk6aGdv2UVJeKz3jXLyhHItpAxFTo5Im5M/ZdLBYAV6iYhePrdJrT0uKQLqvd75zT5XHokBDoCcla1dGBNjaoXEFwgzpgQ3JNWlgG9o79GNjSvE1I5Z2TsDWi5tK3w4K2DqFmudw2IU8xr1FYLGhrK4WJ9K/IUXAfkyKDSO/KhpFXNqeDp4ggeRzgF29j0rhREOf9vcAttl2tM/Z4wDb9mdUzpmG/u9qYNr0z+71NJe725E6Y5snfX7mzUdV7H4FiuttQmcLyGovr/sowBYm9Z/9699ztP8ooNUltgkoC7aK5zg1NWPGFTBrVlPADfDmwCP9R4AgqeGmJqcFzJAT7Ft+AGDhmY2MhnvfchbZhk257wFpuNHJg0ysx6SALj3FMN/GVZ8yBUwLlKLrRH4AyIMggr3FnqO7NeDUuAXM8aKdzJ/zFy54k0aFvC0BSlLU8YP+Fr0lbOaugNQQXirNCQA8519XbmZA5YwyhUSQGqmx5KWQLQU8E9QF2I5qemKdBeKRQgAFndvXQCsC2WBmA9gKeBPkpu/Dbq9Jnz4hVhlQThEG9MXYZYDlmPqKLA5cD2KBjQIbBLOZeaw6w4zeklFGnoCUy8fjOdM5uSbstKul6XckHvc3tosvCay9eWepePK5Hy1OXzjnZyBca48ZMjWOo40utOPJRu7qRM54GOsu9ZGXhpI8oB1p7ccm0059FzuOlCKETEEyxLHm2P0MYblhgQH8BN6RS3ljbVMbHrG80gAvaDOEfZzSs8ia5fv3VyQTESMsVpt7tMeQZ0+/A34d7zEkuzZfjIjx39Xx8C0A4NwSFxOiZLNa1ueMAAAgAElEQVT6b2PxbnFxdrT4Sz/+fPHUk+dLWdxA31Dx6U9/vvjqV1/Wpg1gK4LlYPeX3rr1tf+3q314jD/Q8ySA7Kb6+yvcRh2n1VFnm8b2dovGlofVCWzrp8sG7/jAtgpvSTCiBiZb+7sCpybYjgFsq+O7A9uezEUDsG2G1HElkxydePvIYdMLpOLsaPr85MA2vLp541FvVGsfxDSKtbt2M+mC1frPGyeXInS9rk7HTpYAsh0ZiG3tkPcFbPvJNyk5gstdKsgrqlwll7oDFSJdihN4J5CUo4h9XxxHlR9Fyu/vSAe2flDcurlSXLu6IMZGzEb/uBYqGABylgokybjYhKWdNB2B9i4HhQTukaEcFONCSigxNmYjlD8XrZocbE5Hc3DArhwjFAElWeIQZYE5RwD5XSd4z0Cx3ueAiPfWv90HXjcpSsxBMx7eaMJmxCbHG6zEWudx0bK/pKu5Vxlp6xnT3Ml6RP6OrAjnFDx2R4zthsGkI4/1fKk6NjqtMr6TBPKp6pykCLLRZlYdLSz3HKzXrALHZvQzKX3tkEAK+UcjI0UQ79X8ZBMEcyMNocbUAzEvy3I1EmFNAA8M3vy8ctVOiFEyMI4Nhu1RtnNtHVg+jRoozDMkGNvWzVDr0+ycLScFtrZiJg6aNxZdn3cDsM2b1K4jLOW9y8SD29oBplutUDtjyxiqv3BJo7O973y21Yansx+ylek9/n//jz5VvP7m1WL21ClXnAP0L68sm6maFFCdGJ+y7h53MmAFQDkpWcGCsmKgGWVsRcqvABDMR7SqADUCmBgnAMFtzWvyx7rfNV4NWvX7ssAkrOeE2Ms+2Y4NBYEBDJ0TV32Fq5vgpzF9nzHIJti5d1P0P254l4XVwAUgU5kM9m9GXok+nXdhecna3HG55ZHbYGdgGaOwgqQVGtOMKsDtoK6JvhwpAsGruOoHxKgCQmk4fwPukYHQ3+SC5j28FzC/5HXmXKS+A0gjWyBtGWB4Wjr2CdhsVe1DgM69Ym+9TnC/ApcTerY70rCygQSwGUDrMQL68Kgw3th0wOD24+HSsQSNwWaD70gXhq1EY8wDIVtJn2zyK6++XXzj9SvF7IVLxeXnntNGVnNe1+sXaCfgzGwtP46BSKSabVfNEsDaMnw9hml2/B0z1l+OeaWuiqIdeH8iCwGyMucC1jmGYZhhiZOXKI4Pr1tIHZAKSzutfuB5DEsjG6WJxV6r3xfuLhZvvSVJhYpPLKoIBZsep5fjeCyV7ndKmVlgbQ91Lc8QyxjCJvmOWOf0+6b017srC8X7L50vPvDsJW1CJK/TWnlZ6Qrv3VsqPvknn5N3Sqytge3e76sS2d/ovh48vp/ouf1ltX5OffLxur3Nv2dL0sbYvhbAVoM12yibmg7wlt6oMRmhGPFo0gF5CLR2oAFJzTbWzWQ7rsqXjQUokYapKb56OY4rN/J7fVytZjvNiR4nTdk7/A3Pn9p328913LY9CrDN525mipoXC7c37WYtYfcqmtTE6WZaHru/UJ3ruHi+vm+pFrTgpQGhuzKoW3LF7YlJGRBbCxWC8Xfwgw1QuEbz4p4neoidGGmJSfaXI6rf+SIdMUsQBQFRQ8Wu7Ofdu2sKMrtd3L6xKlfYdEgURkh8TrL2iD6OkyZgm8CPo3fJrzrcZ0M9KsNPZPRwvxZtubrXpHE72OeOcrbFdH96x8yITxrpePZsFFOlHs8Yo70wuIk3iNRL8eomzzlqPAUrXI2I/GsrYx9ztn9AC9ysUl5NDCvjxKYXK1I1eVNheipAZK7rDked3XC0O0sS6tfkDkKKQOUxMbZO95UiuSU1KQYV5T0nGYmkCAMDWuyGKEWKCxXWVrpmLWiTSvU1LcM/JdfwhFiNIbE+gAg/Y/eWeygtVFEogsUKV+uaq9EphZwWHoDCnGQM09MKPNOCAFgoezjwW4P7PW3quYK/3PZMzM7nBbV6GiXwjW5reXXfuFTjJQ6o+w46n3R9HjWOgyZg23PAWNCRLx0tSOOnvJaHaa0P0nfK0+bPahMepm1am8F1bS4Ai0e+0jnqtrNuZ77+jW8VH//EZ7zxBGyhy5zT2GCDuijX/p42s0SM487FVQ6jBzu4ruAzNKpsxGAZY4OWYhkAVWLx2ZAx7jl2WvpZQCVAhBy0AB9Ljwz0BYLF4gFax3R953yNDnNmBOYC7OYI1cRgBKnURxYGnQ/ABGC0rEoDFQZyS4ws2V+GZE8Aqi4bTpCT/pvWmA/PlWwi3h9dZst6XKQ0Yi8tyVDAmlhBimLwN4AYaQPXZGNBv3O/6IOnkA9oPqxLT8p7tA2pA5gVOYOzI4Cp1LYZ9QGAGh3tnq5NsBv2ZF1gfFxBmDPaMOCWd/YU2TW0uoBngN0m96TzwPBaV6vzEEvhc+u+aBsFVGCKd7YeqF0TxdzcqeLKzXvF577yknKPzhYf/ZmfUd7qqVQbl+el/iITgM6BN8yljhPmiOmZsxxE1bSK0PHCZk+OJWYASssAmLxhez3fKB6ELdRf3kyo3ydkhybHh51Pm2wRyFF43pzFzDbZL9DOUkAosdNhyTm/jYqf25qCDO/eWSgWFlaKxaVlyUzWRLIod7uuNuwqYkirkNUxVmKMUlKaFHeAZCrZHYhIWVVmiCmtQc9/4Nliflq6aYgFtfnU3HzxorJ8vf72TY1fiIOD4s3rXzjuEn3ktPxB+oKe24+pPT+hn9/ReGxJmJVBLf+2ANtXvlkB2/abicfPKx8eO6L23os0SsGGNL3qC3V4EmKRaQbQ+Qw1g6pfs4sht6l3Ba7jP5b2FldgtfsYqS2RLReq+qrp+s19E72b/qstEO6fLv1ZP3uzOzpfq/WaJeQpwW1cnUCM8uXnU72q3wMQtZ6j+T5LQJU+Ls8BWMVlLHfXjtyBh2Ij+glW0C6UyR1parwCpbFRQYYQ66cetrGEpUgIjLGHMfCOnMTXIR1wCdQ+pbbZ7VPqmHUFmd0u7kiLe3ioADNF4U5IqzY4qEA0Gc8oeWgLX3bAgKwp3iO3jbdluAhiAMoGCKSpIS8IGUMEprG4YoxtXNVuBzuxuAak9P11zJXavAqNbK3nua8W0Fp7PrXvRbWg8gmF651WZPCQ/qUFw6r2ZfmxWAvxTHaN4vqEvcF9isuTxRxNI4HOzmx0gEtTN2uEGSc3HEtsA387eOxD5LG9V6zelczEwjTOIdZoZL84dV4gc1QbmkEqYABsI8AC5mxAi/SEgO2kdIgTZEMQ4zqk9wC9JQxLQ5qejM0PbYpSnasqrUysAAE7LEyAl3EtUjB30S/1kV3NjTKIqiYVyX3WssnwIR58Vb+mPs1nb5/lJDLzUQCkBD6dss2LbH3+VG3r5ITz9dL164fl3x8F2DZ4C0rW1oYw2LHypV9ZPPIrM8v5K6w4zKE5aZrJK9seQNbR7LY+KNeDZO/5/srK/eIf/tpv6BlqHDibhVhZAdlJSQsAYYe6qIOQBEI2ldsa9/ekAOOmSm2TJxYwui13vHW6Zma3/fgI9iKCnkAus7YChLjuLVNwXtdIp4VLGXaUTe224gEodYs8ADY6S6SwWQBeBwZhw/QZc8fySt0jTKXjBPSNeQE3XNYEEhFA5A22JiLA7wGyLEAgWQt0MGnCAMUAVQLmALagbdKbcR/bymZghlzfA6RiAwmupV2LYl659xkFJvGa0P2yGaDUNONrVLKCKAKj2SkbbA27/gDERa5b8u9G3tsNAVju55SuG5kSdE9ixncUqMexo6MAd4F4MiFQTEXjiiCvDJhdlYwAOmdjUC+pf8+fPesy2Z/83AvFHenif/pnf664+PQlmxXWI3KZ+/ckTYMs8Pk8/QCtzB/iGsJuO/WfbVG5f/F6wisyFqQkZmWsRXifYuMtrxGUMvpg3f+Q2oikZVtjapeNi74BCz/KxgLGn02P9cze4sc1KHNscAJLHXEcjglI3kRkIhveREU5CMYu/RVFQeRtEqu+rcBEUsrhOdgSqH2gfllV0NjWxqpiBWa1sWBD0q/31x0gubK6VVy9cU/WVeuSvCQK6Pv5f/d//+NPN5mHx/k92ZkLav9f0c8nNS+X2/FJtr3HBrZ0RgDJymwn0ix2SzHKWgxdUwd2AttwvXcHthm+xtmyS6FsT/3Oej6xapHv9rXewLbpQq0AL5+3anH7Alr1Yrc2BHfTxuCobx8d2DZfs+yNNsDcAmzbGlk97wCT3c5RGwVp1KR1O/sq02J1gHeASGLtXvvI2YgMATUcCwIAUoYgot2z1jv1TYSWxmgUIArjloAtjIcBFB9HflPOZbGMPuuXq7AQKFtf3S+uXVks3r4i0LXMgjWm6GdJFEbl5tNixUIWpE7sxgck8sLg2QUl1oagAwIgeLEAHOo9Fiza66ANz4kwvASZZSwVmakApwnYmgVqBzbBDgWb0PnKoLWZzQ0PRiuwjf6wtCj1TQbHPJLRMbn4dH/b0hS6YhGdS/YPFnSnsAHsEtyFe1cLp9KabarK274qrYHV2DSYRXW2A1/IC0gJbFVSd0XA1lo4stXuPlD0b1GcOa+Fd3RL3wXYRlCMGXldc4RAGrF9E4qKHhdzBUs+QIR10tf6SglQZ5ckukcWAthaWEI2NOgmZ2YmnEKJBdjpkKI30k+rfWkHsX5OGbDWNg5NzyWeY7aQ0SpjwvRlFzfxgtx6zlYWvbVt3YBtbn/92PL3hmFT2+M0NL3G2OZP0zi1SzRN9OpacYGBwA5pXYhxnf92XIT+YBEmmh/WqucrnYvvxBiqfbsG1P/B3//14pbYryGYT+u5B+TGVqYLMhGIJUWiQMq4PaUDg1mcn5kpbrx7w5lTyLCBR5LUVyMCklzCxQb0C+54/kbC4kILAr8AQ2QNpI0zGIJ5pfACXhuBSMAnnQOgcsQ8wVACmJbLwC7iwtd73A8pwPBGRaCUhDg67znlZSanLbmWx6Vlddo9NYIMB2wibScotJDOT1udykzfI2PIvs6HnhbwuqoAJ8bKrFz6rqSW9O/OaKAGbKN/tf3rszwDRhmWlRy99B3FGACupBxjjuHlgG21RlTMNTraKQFxpCXLKk1t9lp2dVPtR287Nz+TJEkCdUlCMSLpAFKzA20a0CkD8mgX1yGbBNIIADKA7ktffal48VuvFRc+8KPFcz/5kw7Mw66SQgzr5TLKAoTYcqcYS1ISl+b1oIugORh2tMOMaP4GkPNyoCyeOINI9YlzpXsyGhh7nVB/EvoFE0t6sLvvXjfL/uSlJ8Mu6Ydnx72zFgzpcEomczxmxakhrdGWOdMbTpWGJljfc5pFli3a4LWIMR4yg0Fy+vIv65zXvSAXYPD5HgB4a0v5ifVD8B6ZghBTwQwjoWFDRMupxLiv45DLaTz/5t/65b/+d3pPusfvU80Jdmd/XT9fVN9drZuJbNH5t0Vje/VaymOr3UTTqwK28WmkCKysaDuz1HSO7wVjWwKqdgPYdsGW73k4VaxDu/PPa3kjkMhnqXdhvlAGL60XTpu1tKC1H9e6kLb3UXZct7x/QmBbtq68n85rln3Tds+Ak45XesStg+jkwNbso21QcJW7mogbcstQSndAO3hADy6nyG0YbvCHUD9Yex1A7mG7emwhEmNsYBuO6X7abtAY9wugNOthF1+4p8I9JMNxKOO6Pyj9n9KEvbNcXL12T2CXYBSBqHHpOcUKDesHsOp8ujoPQUck0iZwaIT66yxaOifVesjI4MhXXF4YN29OAnDzl/MX6n8Yq2MD2+pBtjwS2JcyQIMr0a810BWBafXn2B3Yoh8eAdgqfRBMJznYzW7r5X5Cb8ZmQ3lnBwVsWRRhare3SKnDl3KKMN1XDTizONYZWwePYaXJU3ugNEynBwLYjqAbFHsj6+88j2wotCCNyj05qmuNiWkdEyAZ1oLKYmegoH5MxY3T/ibqzyM9wc1KtTECiNhgTOscU1PSVYu9M3Au2dpsBnvPR29NPP6bNxnVg8GAxPdi05CfQYZ6DM06i15/pBWqa9/kVEe3z8rcfk+oAJddNkIcWY6Phk2UG072m/rx6XZ93trEr3/HaZvSK1/foJ05lz6bF9BiniwpiK/n65jA9rf/n98rPvOZP1POY1zKgIoohkAfjMjLQJ7jQVIAki9VG6FZBR2SmxXW2JWhmKMcSxuRBDFXNZ/QfvJ9AN+ymGFsDi5//gVMka0AiQCAh0OYBwBGgsrYQI+rDbDAAGMAmLMbEHClDRUMK/peACrAFIsFsEUmwZgkTyubeKfX0n0wFwmiBFweaFOwoc0/QBs7xKbbm351JgCR4C36F43r2uqKJRdcGxY3p/0al6wA+QayBe6ZwDA2eUgHHEmva7j/1G94Se4tLvj9U/KWMGcfaD5xb/QNUizY2XW16YyAOS58skLAwHI+9MLYYVJpEWxFBcdZ+oq0jsmeoOeFNXZgnjYYV6+8U/zZC18u9gfHijNPv78YIGBN7QXQYTL2CQq2djiIDvSozEunJfMmOmyvNwWp75z+jXRulP7VD/YIYDoEEAUSOid57fg0w70N0bVuvvuuNMbLxXPS+QKtc15tnilaamzLDFpnrz80h2egFF36dQDZhNOTacOk31k+HHjHmgSAxc7hFUs50e0N9PsBbBkTLBeuKJc24IxdPACAfTZtIWeJlQ+wvUu+X7WUHOAslhonr/7yL/5V3PY/dC/ZoP9RN/WabM03jgS25LHtJUVo6h0by2RUO8xuWmjbl4MmeHjins/n7mXIebzl9zzyShMcbYq/c6okBl13Qqa2iLQ0th3qVx/2Wgb9WRPe9dvxX/2Vlq22boo29bxOS//Uv5kmY+6RHv3or2SkXrta1cJWYJCZwN7PFICjiSiDf5+odQHbIedMRHsa17NWyCRsgBEmuh3ZeZVNeNfBWV4qAuq4XV68431zUbimiBrmhP6hyg3gWuAW17py0G5uPVSQ2XLxzrVFMX645wWoFIwyPDyeduspX60WATnntFuPgI4AqbjMFDyCUaKKUBpItCVyLMYO3tV1SikjN4A8ouTB07kw4K29F9qwCrjkPo5rx5fDxdaNXYyLtrN7ZhR1+ZEx2ARV8ZLLS2SAXrjPWETErmjxiXyWwajCgqE/3BGwLQ5d2aDU2GavS77OjDS2zorw6oI1toEQAbYbxamzowK2CrYYFFs/IL6BVYAFBxczSe3FyBGEQ17HURYQdIV85nRggK1ISh7AM3R72yprTMGOdQJm9AkBLgSNwTIBLOwOtsnK86ayCe7D2gay/nvVd91mWzzp/MrMbb3PY0yohxoMYDuYrT/94wDbTkCbdKTeBMYFvZnM46PjNgLYNr2awG79e3kTma/Rag1w82tToUV+cWk1zcnq6HzuvI7kcd9uH+tN+8pXvlH81v/5b1zJCUkC/Jefv8YkWk7nqNWJxtgYoR+VjnVGGyM2qktLSwZXuOzZ8OCyxy2Md4Z/qawFS8t+DXkRle8AFxuyT0wUgKnL4rq0rFhEgbVxjVM2LBQBiEplysIghpdMBU6lJQC1qoqKAFki5l01T68HAtvcL1rgMcmgcF8DOJHSUHSAwCyAK+cZ0HglD+uExvKIXP2ca1NsMXpaZ3fQcfi0AMoUeIDBxjNBv5LeDMZ5VAFvgFO0olGid1d5naftdVq8txBlerX5mxLDPSyAf0/v0SeXLl7QPQ9LH7qYgvJUEZDy07J9E3KHU1IcidG+7CIAflbHn1Emk0XpQZeleyZ39Lw8Ljv6DMkGDPO9hbvu1ycvPqmcrMvFC3/2RWlOdb8TAsWTM0oEqG2HmWbmi+4Mbxi2AUCre4KVjHEGceCRF78nkOvMA+oLNgtm09nIJAkSy4dLKcP4mmWNkuhmbrEr6v81bWzWBMx/+qd/ysGIC5KLUBHOul5dkKBEmGFy+8LeE+gKDzNIOja1eUo2C3t2uK/UaLJL89L3MzanZM+yB2+Eoj8u/kOwms5JZTe0wWi3NT693iU5GWYTOQgbEz6gX9hImB7S+3jZ9vQlAD8bGOR3tssDw2f+51/8K4uNE/sxflPz/a+p+Tt63p/7gQG22fz3AmTtfd5h3EvQDIBpfkIZDDR/mlwBXsxM4nlyNC06cXx3YFuCqWMOlNLwnwDYJmTZdoW48vGBbT48jqgD0xbWvUs31BewzlttYHmP6g9Nzl0FjGFEALaDsCfac3qDAUylfK7aEvrYanGGwA0slwyRdsQhhU1ANgE9GzyztLltMLeRsBtdlzNaOIe3ALbKuBD8ta9yvItLD4rr1xcVaKbFbEAu7Okzzv0IO5SyJSrKV+4e2AB0U9YDpx5NjHKUZsXGBZhgIeRfmFYTD/7QaNeGO/dtyC6i4/LveZtTHy51YFvv5oqNTM/Yhhjgl9xbCdjk9wx21ISxcbJiRoqshwe0Cege6Wlg8B1GRbCLFjEihIl83pEmrnhIJbf8nayFrlo0PT9aPC2N7Y03lpUVQemStGDvy9j3K1js8lMzCgrToqNUX/05TzDuO5gt2CFK3VJ1B7epQMogxl4ApF/0h7MicC/0pTXPgHLlnhSbtu70SFR8UsSxjiOoBo1cgJHol5MC22Baq+fUObS/B8DWDaudOT1wj9PGuVTZpOMA2zLbQQt6rNmEBmDr89bmnhfYWluq6+Z+Tf+mW6GFLPzkb72vtEikr6q/OoBt+rD9futNW15eLX7lV/9hlIYVEOCc6Ge9CWM+0ki7jQlEZHzJPa3vziogCZ0qLCJufqQBjG1SWnHMJEFndvNq7Gjsjaj4gyPc9TcBWwQkAoABp/wNxsLly+UAecgBDKzEDgI6NjbW3UaqdgFWrfu350iBWAJ/GCBkAqGPFejVPQBkIp0YwUNy3wNE9blTHpIPWCwpm70ZHc9cIg9rLoeLBIHKYlRDW5c2mLlL7l7AL9lB2IxeUAT9ju799u27ZrIn9Bn7RDYeFCjY1mdUcuMYAujYCBhQCxQz5wDUlOFlRNJuAtLIdED+2ymxrCuSKNy7d7eYUd+eFpgluOyda9eK5597v/XJdwV2JzSfL19+0huLTRVHeOELXyquX7tuj9c2mWVEJDyUrVWtmwimY0wAVGHn9UOgA+/lTTSm1m5+oK3JjBQk5ihUfmJlCKkIpX71DY0P5rT19h4umUpiLdgpVlTU5TSFIXQPm2r3kMbGfrKhY+orp5jDHgqkw6STbza3k7HIJBkVATAy0i+phbJRoNvWBmtCx5LJgNaO6JqjsqX0vyC8/4ZBJp0YGw68YzzzqmhOaLbJ741HAKvs7B/IPdQHD7Sx2NO97Wg961cb9vAsDgz9jb/3N3++rNLVaEYewzf1nCnScE7z7T8eH9hqF0sk5HFe2bXcbpNbjFfbiepGCpuZQctxNKTlqerAtqmhGODEch3nPnL7OxaQElHXgW3rtzxtmqjexGQ34ddeYLSJsS13pC03k3etvNlAA5Xfbb1aBlEVK9zWGnReDZ12UmBbZw8bnwHuPxhbZRU4EPswCHV6CMgBgMAEYoxi0kZ7gpnjx1pOmu1+z+0HAfB5zvCQchvyub8czK2BLQFSvAWTS/Ugsifo30NnUBjQonRQXJc84doNKlbhxkZ7K2NDOhexCVQtI1E4pR1ZdFzFjN21jDMG0PyBjSxGM3Ku0h+h48ot5sZCKZVfLfIBHxSfNJFpHZu99PUWhs5SCc7QCmzjrO4As0rDo3EfW+TgdHYHWI7Ebrr/Q4OJoR6SgUYzuSN2FGBrBtrzLemg081w/zOnyGOrdF8KHluWFIHrAWxHRveLS88op+w87kHYYPWdMb4WHyLEqSinzcSgqowNaZEc0sI6pEUaxhZDbmNPq1j4xE64epFA7Zr0fgS2AGioPjUlNgtQS5s9W8qOzPM5OjjLb7KHJz+PXjapFdTV7UPqXQ85rlkNUfow27x29rwDvZ4A2JYDKD3XahxVMLRlDOncEchXe3UDth6A0RiP6Zq56ATUFbC1nl3HAH7IjLCBPEQbokd6tQXD/d2/9+vKgrBiDwngz3NIoAwGzEGEGosOMuR3NJgUOhBYnRN7yNi5e++e3zt95rTztALINjfWDPTOnD1T3FZ6MOQ2US5WQUIpEwdgDnaPsQ7ThlsbljKXr83eGDSTBqkafwBvdLl4dxibgDXAM4wpmzfAL8Ft42yedRwBafQ3bC3nYOxOKz8qcwNtK9enwhhyAAeIIX9Q8QDuC/DouUvgFh4OVzqTlEAEggG7gNWcqpWtCviS3B/ZA4UPqMZHDuC3r16VjEdVwNgICDxzboA/DOITZ59wP6yLEWZ+ucqYjt+S7d5QpgSCby8/+aTd9Levv6MiKKrWpuOvv3vNacQuKh8tgW1kVzDgFoB++80rxde/9rIy1gjcCxnuDCpriYD97NlTxZx+yGHNZoR2OLAOFpcNrW2ppBtIwJA4EITllIsRl4GbnjzBDyhhjK5ZoB7melc2Hk8g0jS0yy7mEAtJCjgOJpQKaBOjYvy1uZHD0OQDM4D7tpzJ1c6iEqa1wPqQviH3Nt9xCWLZsVNPiDmXEBfNL1IEWNoJ2Tanp0PDLHtABTklOnCaSzx7BKXhvGLjhPZ5n/HA+E9sNf2wRYpM7J7agQeLDR79ty6yYW1T31cKS/TFG1tbH/u//s4v/+ojzbkf4IM0rz+o5v24fn73WMD2m996fQnjY+amZsCacFuv++4J3BrO2+v7tqu1i/m7x2hQ51LT+0nVcITXmEpXxipQFwe0AcW0InWA2wRsmq76CPym+6A7SO51twHqylf9wdb7tcZ0Phqw7fYUW89WAmtdD8YWd9WejCcumwHpOF3xKyWwNmOY2mjFKtpSvQfzWS2qoYHMco1c+zvntvW9l+CO38mRG3XKA9iSigfdlAykgqGIrCYMd3u7v3j35n3pv5ZlFFXecuK0fmZ0fRa7qP9O7kryK5qVNW7K1dECFbq+eeKScZniimNhi/ZEzZz6Q21hsMw9BJjIIJmjKllK7teq3yvJQnwvR18b8EaJeWEAACAASURBVDswJdhbX4fxKZQyPEZ+TzI7KEBBYPWh7p225mzKUQKYwafvioxAw7ZLPkaVWjtUEJ5gvfs/jgiwnF+k+7IU4bv3VOMcjSXJ4LeUxmuguPy0GNsZ2BN0jmoLuT5x8wJcqYjEYjYqIw9zS2o1LQwElbFg0LcWn8iYAxxw0ZHPc1MsF21A74gGkihyGGbft/O05r5qBbYRDV0bp+kR+X6aJkM8iBKzVk+gPgdColJxnDEPs+nqAIWlPCJ6L0HJ8CzE02wwJfUx0NuK+vlXJ05tSzfaskGMMVd/tdu2nNGhyba5a9JGkt9h0+ZUWveB2DmqOh3r1W6jyuZE/33sY/+2ePHrr3i9JysBvUXAD0DFc6UWYOiCKrCkAoe4kp3sXwAP9y1ACIBF1owNZQhgvj4hsEvZ2vtKmdWPjh6QSJUyAU+kRIBgACvSly10sjreFccEiAjEGtP3CB7bAVQJaJIlIOa+wK1BePQ5esodVZSaloub6mR8P4LOlDpLYJm/0ayiM+U4vE1kbKAK1p6Ogz0+pVR4gDgDV32fEr2AMNzweDAslaCy1dysg8s2lCliTrrZGZXTJUvFjtoLMISVnhVDOay2s/6TL5diCjNidQGFK2J8aXdsVAYNemkfYJGMEpQERqdLgOaI5vEGuYUFyPCW7CpQD4DN+Xk2nNseH4HHt958u7gjKQL5awdUNvv88x8snvuxDxTPPHOxmJ9VSkUFpRGMhWaXZ4Fum0I4tvHM/9K6IveKdZrNDiCQIcP32XS4wEQCtAFqSW+GdyrsPm2CBXX2jo0tS0/YYFCKl4AtyiJDfLCJdiovtMJs3JDBYedhrtUv3syRVUd9N6nNx5ju/1D9cUr3hsxgclIyLl0H75EzO6hfIFrUWbJV2swjS9Dfs+pHvA88A+YsY5BxbMaW/Ma6TzImsIiht0XXvUcauocETg7q2QD2NR63t7/2B//b3/qZY825x+hLGkfPqLn/pX7+6PsObJtMLIOr3Ry3NyStEWW3dltHwtr3/LQ8R1y3XamaP+6+AETgQ1r+WnBD7Nji1QpLUxx4Ag1x7nzlbnCzGxPUa2lqOlfZ1kbYm/u+DUanRaP9WiWo6rKWH83Ydmt9M7DF9LBTX7p7t9gXsB1wqi8FEcGwoFPFtYeLCZDLc2eBYnHGaLGApYFjA5c2EQaCPCH9bVbXBjAtdj7eol0Z6MiRa6kCEcRmVQBr5L8luAxDOaodfl/x7o2V4o03VBVoR3q2qdNiQqRLU6lHpwUzQBTrSVvRc8nQYYCcskrsAp/h9na2BLUTw+jRUY6z4EJLdrs+YVJ3ch9RLCJDHaJ508SqdXngzzTyCATiKw6yCKIyGGOalOQZ7kuBVYHHUf0QbMX9H4ixjjy1SYpAC/ldXsBRpQXjlJScNLBFY+uMCHYAuvfZNBhc6HozZyZKYLtwY1mf8tmuqu0MFpefmVUKL1J8sWiF8XYieoI7iFDXv/1aLAal5xvApZsYW1dx4ymq/URKk2sUDxPglnsmMnlKoBb3N6AF914Aw9QRaYaW05m5Y00D71RCqZhbXSZD7tM03uLcrYCuOn8EuqSRWb1d+63Cge32DTCRtgu1CK5Ob0hlCRovwNXzxrX+BTY8tI7xmPTKHUFk6fst1+xlqPi+52Ocmw3kvCLmSVPF5qPXpr68e2/mmu6EMVkUv/cfPqF8tp81Y+aRJ3vBs94VUHNAkeQAMHW2szopAVt2zeqUsMcGw7pnGFSY3GlpVzclHQCsESAK40o0PufHFgFiuX/nj9XfFDeAhYOhS4/e854AtDmBSAKqqHBGYJSzEmjewyDTeFz76ClJvQVQXhfbSnsAV+hxYZBp87p0ubCAsIaLAtPIHmCnySbgYhceUmw2dd8URaCfBTiZCwBapxBL0f/jkuQwr2g3m1nmEKwpx9Ie0n5hr0gdNi+wTB77Wwqe4vN5FcMgn6oD4MgzreuQp5asEGiX0aUyF9dVenZVOVpHxQBPyQ2/ruwKT5w5ZVtI0B3ZKGh0ZrHffed68c71G+IQlLpN9zz99LPFxR99rnhKoPbsmZlibkoMJ0Dfds1iAl/HqRVhZcsxHRt0Wz41Zi+tDeHZQ/qRKpc6u0lYSPw3/I9AK0vJLDOIMcePPXv6z0HHsnP0L/p9vA7IJ7h/yu1uacxsq1+sm1V7nGHDZYsjyHWAADKNAfTNTtkmwMq4I6gP0IrcgIw7FJ5gg8HmbBL5ldoGUOdvx2h4w88Y1jrF2qLzw7rHJp8NksC5GOst/ezuyiOA5AcZg477w9/428cDTd0Mxw/g+3q259Ss/0Y/f3piYPte7ucogJaNQZ0JaGWrHv3q2cR3c+lXrE3nNY4CtrE8hWnOSxXrTZ3hKO8prYlNo6rThRdtcdsbD4jrdS57+W6aIXS827qUmAFs6N73BmyPXlirS6ars/uWgVhWkAJShAHcaEmK4JRMBrQJmNkVFKAtCM+E7DBMaace36TTwyDZJYlhs1HU26SNsfEKja1ZOr7DAkYaH9LSUBddsoSHaWfucoYFgRM7xWuv3SqWVsSATD4hQzWrRUtGSuxu5HgMKQK5DM1weoBwXRIw6tf0CGJDE3yoAQQmMfl2q7ngAZVAeICO1lcEIAWLGwaa360zs2Hmglr4HEgTYDNXycngJFjbAJREgg/LkpLkfVf+rH4VnSAJvc8P40xFHrtzKU4ReSm3lR/2kGwIagpZc8ym0xSMNm+k12wCttfM2Ir1Eagt+sTkTA8VFy4LfM6ghaTmvQCpQKwrQZG+iKpJYob7eE8uO9J8EXTSrwCgMnjC+R61yFC6VGwRt01QByzthMAwEgRHPWdg6MCt5nkSK1ppldJMZC42zxW+mdIo+06z3s8jsERkeZYdB9h2sZg1XE1GkO6vo+dfJ7ANT4fv2sA2bbp0Y93sU3l/xwC2cXJuoK84rZRfBGqRhq3roTXgHV6K1rv1GI+8TsUXXvhq8S//1e85GpwTEhjG+N8XY4+7HS0mmUo4h/PbMse16DM/nadVIJOgK8AeLn/un892xC6iaZ1MGTlg32DvzLKhiRT7CQDEVa3qTrIF0onqdwDxhEBvpNiS21njD1c4AINNMkwo9w9w5dq4l7HLMLTcw5DAj0EUwWv6HUCy6wppkR4MkETwEi55ArrCA6E5SzlbgU+XhHWO3Ug9Jhe0N9ORgSGi67EF/A7rC2ttF7delnJoIuMep0wx/Tw5MeWNPun/yF6ALQYAA9oBt+hxK0ZaG0+uBahU3x2ITWaDvypgu7Ul0E6lNkA5kgv11ZS0uw80Dq5K9rCh+Ts0NVf0SwZx6n3vL84++3Rx9uKZ4olTyq4gdnOEDCl5Q489Ypoi53L6xph3eayaslAf7pqh5571vfwv64E39THGybSD1pnNj/udTVDe2PmcHuk+t0kF/X1Izm79j6w3DkZm84AMQv2+r/t+IJC7JlYcFjs0/LKKCiZz6Vw8BdqgOMBXP2xkeP7DqhTnYDayXWD7dL9jsnn7ypHMeAPYWwOMVhxZHnMAxpZx4XRwnrxm2Qm22zWwldzCJIVSg2kzqYpqz3z5d//xtR7G47H7SM9FIvXiv9PPC3/BwDYW8KZXftdLzDEZ2JP0fDbxjWmzfKJwZzUZ757ANlnaXGEkt6k9Fc5xgG3T/ZRLU7f1yxOv82XY1tSPTMJ0v+1gvgncvjdgy4VOKLDQ5ERju6Jo2z2xFoMKx+8/IM1cLIYhukyBAPoXkBtCegxUHl/cpD5LO/HDBBKzu91uJ1ul+PFO3G6kVJmGvzFsJN7W9XFREd1rDKRzshANaNE8UGqwleWt4ory3r57U21VSd6JydNaOBTUJCrThRjQ3rp9CXgGXxXg011Dw8M4+sUYzL8G3ZrmQwyAkFI0PfE4f/3FfTlZutd9W18by8jxG4DOINQaX6A+oB5tMDkzKcIgVyg5Eknz9xA2CyYgzmUXpIEn6WxUxlTncKqviJawNs362hRcVUod9CnpvpAiAGwJHjvQxuWhgO3w2MPi/MWxYnxa+l7pdgdHMOos+gpcScwsoLZP71OooV/GnKwGBI9h3LepWCTDvSXDTaAYLxaFqZTEHvkBzy52FKnP3WddgG16PC2dymF+Rs3zrgPYpu9V386/ZZ1zMEtNr65AkqmQDqgPnc5zNJ+3/r1OYJuD4TKwTcUjvJmp3UUGnIyh/P5Rl6uBe746ryINjKUVsXpdDz0C2PIkIijzoXJPXy9+7dd+01Ie8lJbG61H7cwaOBsAWQKMGbQSMAYwiKwQMVcI8omcyJGaCfZxV4Awe1A4HpYMILKnioh4cgBwMHyANBAHY5DJwVyCXXMlLQGbc+fPK4hxw14QBhHMZy4QwLWcH1bXIh/pKHIZsi/ovCTbx0UNqwn4oXgDmk9YXOYufUh7cEkDaAHQ6H4pLvGQqmGa0Lj8SR8GiDTTB0hGd86946vKQVPqSYB05IMF2CNfUPEHMc3zqmR1WszthgiHRVVVJGDNvkwdy71zn+TwRSIwqnYid+jTNWnvDiQFAWVOcyaXvto3rnu+pFywSBrwCt25fUcpxRSsr/k+OD1fjD5xrph58lJx9vKl4vTZGV17sphiw40r3u0OIOptespuE6A2eaG4F37UP8Q44BjLOWCjoE4ws04Vps/EXaTUWSI0dFshbUusLScy0I9KZLYAli+QPlJtSZsp2sH9U69SxKsZUrxVB0gaXPlwQ5siyhlH/AHMKhsjp48UCLVGWzS7i0vBemsNYhPgEsy6JizugTZPZOHAPg/gdcArQFuRZ2i88cxoJ8UjWOIsEdMPDDPQ38FyA4O/8MLv/KM/aTQ8j+mbskO4SigZ/NL3HNiWBjd1TgDVAIzBYLStvsmi5aXlKFDb6W5rfgr172VgGon4Q5/SvAh0t8wxlGl/XlH4F+MVx5QMW/64GxBNi1K3j9vb1XHdEw267EKtHZQXRbf7eKytj7Z776SvYEJP8gJw7WriLyuQY1eatiESiB8QAUyyHl4RJOTe90QO4MitxGbCg83jzHgBtpB/Ule4P838hJsIRiLSfRFcwO/s1tPfeQfO2DVjmzRUslikchkiiEAMJRl6rqigw9Wr1HSXNGHyrAICyGUo5kcuSvOD4ffn6tG87N7m9zpgyO3DruVG1zu+2xC1rqu1p7mvCKiKUcQCPyjGk4Ur3KiJNaTLuB6LP+ySgB8yBAyq9WM2+ABHgigIssPGR1/A8oyJsTUTpQIN6Gt5RhGMh9Y27t3gJ91nK7BVvmIB24NDgQwFj03OKvfnFK5XBZkoHRfMMamNCHqh+hLAFtYW9rbPIF2tYfElaTvBN06LhJ6SSkA6jwCxNbUCIwR4hP4igGk8hzRmHmF0c2T7ZrAObPPTyHO4enSJIfKA7Q5s60+zHeRmLFyes2FyRp/3nn1NwLb1up3zN7wCceoTSRHKDomN0azSHcEqLi+vHRvY1ttWrRXRw1QE+5Vf+V8NxIYH8TAw5oEYAjXYIQ3w4AESkGW8J4ARBRlCKkSbnMxfnRw5TwXSJBFAUgAry0TDU0DuVlzFBE3ahuh9ACMAEwaUDctDgRDjG9KOkTLMZXQVnEVQka5FVgV7SdigpYDSGFPhOjZTGwtoyq8aHZ91+YBb2Fqn7xKQASwjo8DqkfqL1Q6gY/c085FnR5orzQ2A6AHzmQ04Kcn0w4aU7wN6CUSjnQAv5nesAQRnkZ+BSlYEUg0rW8CCNwvzKmMMW4yul+wwfB8ZAuAsAtiQn8x5k7q4cM9yAoAuetYNaVgXFpcsIRocFws9d7qYvHi5mDx3tpg994T0qNMqf61qci6mkrwKKTCVsWg5glpl75f+lytB4tGILTvFHGTb9TlyW7O7fM/AM4Ctv2upCRv9FEyGF8vpFrBtxGEQDxHsr+c6644z4OAl4DyRmssiMxjxBHRdGMDSMYCmisVI/gFD7bRjAFoyeOgzpDMOgeWmNF4J9rIkQbaXtHLEMgCwLVkw865Nib6MNpznFwUmYGgZE8pPbK9E2Grec5lenv/A8K9+6Q9/42O9rcPj96nmDrlsXz82sMUd0S0rQrtNLV2bNiHpldx3CWuUPZbXdHY9NjlHsLXdgG3dNdH+OE4KbOtrQR3HJpsYp/cflcbWQSjlQmlvdMur/DN957ggMS+Kj7bu9gK2ibWqtTIvco1r4SMC2ybGtpdLE8NJ8NjKwkKxI41XP5NRwIdoYSYpiwEGggXC1Vq88FBxRqbEtwuLG7v2PJ78q37yYhxfiEIiGCvXELduCiOgoAmE+9hHjBQGUKAOAIxFNAilaowyIZDuBYOO5GB756FTgX3zlXcUkKHE2+NnFOlKeUlS5yBdqL9icUl4M82SMMj0DcaXMVufC/7dt1QbkZ5M+bydwNYAJDNqupyBrW46atQHuHKgmpnoYGDVAzac/I6mEAbL+XaFD/YkP3BZXdy4Wsz7YcM4n/7F1UXVsT4FKTwkZBi2XNcmoTov17RPbZk9LY3tR88XV79zt1i+vWZQu32o6mb9m8XBgGrOTytwZ0o5RaV7nFTEOu5c2CqALQvwQ92HQW3kxFGEMmnJXC7CXUrUOhWjSKUzZkmFQK2Z/Zi4Xo88GOjwNDjajUaXv7O9ymaqA9hWTzPGn6+YfqzLyC79ugVo3WC2X9rXrFC4P84AOtjj5tdJgG2IU+otrp3TQKt65XFVv+pxrtXSSp1zelrBf3o2i4v3jwVsuz+i0koWv/6P/qnKYr/uzSRSBDZWjAsCd3DT50IobHQAEFGMIRiuSM0VaZ7YsPlvDRqCboYEYtlgUYgB7wbyFsBtJOZnY6YNOW5/XROmlUBrpDQAEZhbA2DYN3LWYjMI/CEaX+sqeWTxpCChIW1WgM9gTtncIjWgpOoGWlh1AgCSkQXzR5YQwOG6QCxBeAaiugaeDtrFT94EkfEBTSz9QFoz58LVvcPG4u0AkAGe0JZi16jORxlgNrOutKZj0QdbVmUvVGxssZMwxLCF9Cs69k0F2R1SmU2Pxjpnge7VNWWTkZ1Fk4xkA5kRQHxL97GkbBYur8wGdELFcE7Jfp67WEyqrO6k7ndmfkJBcCppjLfG3jhvCT3v2Rg4BRispacKbGrkO9fWxJ9ZXgDjavCZtOOWoIW9DYdaxDtkba0DDO29Y3OvM1ufredMX7GOcx5re3H/B7gtc6Iz5rCpPEtkbmyyWHMsC+H60lHLU0FBC0AtNotZBli1PhmPV9qQMEdom7NxkANZ98jYCIAaum8TOfYOaJOl6xA8S1aECGyLDQmyEU5OykOB89986U/+2Q9jBbJfUvcsHRvY5qwIdePiJaENiIYBrAxNfD8uUxrHdlRnsNctqOtosNtu8DrYDbstYsCXLFWHlazaXDfi9ab6/RquqLe6BdgGVmh5+bB04hMtpW57d01fd2OfG9vW2e5rXp1sbT5XI/B8ZGBbb+FRC7jRpIPH7ktju6VAib49RUzL5Yd2CTcdLwy3GVb+kCGGWWRn62pY1o9WY4YUYXb18uwT0xtVhsKFmpNfx65730YLNgRDx+673+4mGQj0mhgJbDrGQYvCkH760bJREUbt2N9XyqA7D4qXvv62DPWu8ko+KRA4pbaJ3ZVrtMWLYIMcQ6KcR+kN7svat2R4cw+Wcw18lMB53Gz1PDOQ6pgT2nihSoCp8b0q+AFms7+P5OHBrMeGIAy12VsvFIlRBMUORY5Hon7JwTgjJtRlJimNqprlO2JsxSMEQ80I0/mprouhpQ/NkqufpgVsnyErgkrqLt+5LyZlu1jbk5HfWy5WdpRyaVyuU1U6gtFjEZ9T5DppcFhkyT/q+g/0OeWM0cwCeEm35JQ6AWop+Qv4YOF1BaJAh+6r+C0633bHNizGQ33uN82tkuFMdq/9GEdhN7zcB36/1brE+Y6YF4wDxkRNDgATF/fhwRBn5iJGMdU1jgKc+X56A9u8HWi8tfLNo7IitB89RSCfwNOSijR0TaGWdhLNvZrPWN3zb/2Lf19cfePN4urrb5q5HFJ6JgNX5jssogY2wHRMY4YI/SiljMY2M9OgIdJdUYFrQj3Z7+hydncEW5GiCjDrwi5IlXSuOQVXwaziogdIUZQFIohTD2oTlsGfy5yi41W7kBKYSUOqo5tDV3uQKo0BdqP6WDDIgE0i8wHVMME8b+fFJRCIsquATEC7QI2LpqhNJP0ns8Kycs4y32dmZg3gNgRuGG3Ih3BnI9UhDy6gDzlBLvtNVTZYW54Lto50YGymliURm5Gmln5cEPmAfpeMEbQL4A1LTKBmn9pGlbFwkMBwi5HUucgIMchGU6B2RdpTwDXleVeUh/ihbPWAbMqg5vvo/JliWD/jyhwAsJ2cJgUawYCRVs3BY6yztuMhPbAe1lMg7HrW07LhICuCQZ8L/OjZ5eDgBIZ55pSfgdOIHN1gQNka2wlK5RL0a05YYwnKF8AaAJuxANHi88L0JvkB5zT7yhh2A8PbBVEwBCmj48nXTqYKF/HAhnFNgLS+B+BlQ7ZNZgsFMjrVm+4L+ZXng/7P+moyWOh9imwwngieBdii0Y5cyVEe2ppq3YcLNfT1/+5Ln/7nsJs/VC+NsV/QDW3X7UXGW+779IP/YujaO7fLdF+5F8rFuK1bKhPTasDLrzVZqLzAVCaya2cfxej2ekpl29rb4PnATKktCIybkvXrsdxlMW27Ti4d0nS7vY106x3kRZh/38u9t/dLt0XIwCgtJhn8dbv7XsxrwhC1LU3vxZv25UV4d+tBsXJvKQFbgVmBW0AWuixqkGOZh8kj6cT8Kd0TQMfBZfEsDXJrwMVyBTORIdQPkMlbAC5bMzOZuLJZ5AjuKFlajJ/+zrpRGkAgitlDgkdkXMwI2ZXVp4V6t3jlletKWaZqM+PnxDIopZAoz4x5HFSlHwf+YPzMxsbGzvKDBHDD4ZuyN6RwJwPN1P4WV2ypNWsGZ4cCpkTbYuDMQAvYBpiLYe8IYhYKNgD6JJgt+ou2qQ2q/oZF9nikzVCeMqijLFKONg8t2qAAPAy1g7mQB+QknjoGqSN/Ts6PF09/WMBWeWwX76yILdot7m/fL+6s39TPu0Xf6ENXL5pX+qE5pRY6d/qMwQNpgoa0uA2QGUHMzShgV3KFAbmKCfhxblGB2hG772DFYjNhl3Bw0wHiO4xEzMie4/k9mP9egDmu2cUi1GxIuNB59vm79dR2XRrn8V+9shu+/u36XM9zPwfCdtiMZBeartYE+MtdWz6g1vGMLaprkcdzOQHb9udStr3Hddvb8i9/+w+Ka29cKV57+WWNUYE1BTyNKpfqQ7wmAgZoEUPfHllQYMEAnICIyDuLxlxMmMYN8x+tKwFaTFUzeZo75G+FgQXEebEEMDNNYGHNdgrE6Q0AC3OKAgkA5Y0H62Z1GYPZg8H5nXcVqUIq4jCKN0j2jMCjiMRHVoNXikIlmmukIaQd0o6z2QewUOAANnhRYJO2jyPhkV1aVBlc5HdUS8PljS52UxIDAol2ZU8JpDwrdz8yDlzZ2DLYVwCy/wUUC1i6wpWYXYBvSDVgnJXaTEF0bCAdKKbP8JDcu3NX2trQ6W7qvNwzzOKUsgC4n7gP8qnqWFhEp89CCzwsDxg6Ys37EYHaEVVKG1YA2cScqp6Ru9rXCW06wDR725CeIMVw0R59NpiAJGOMfgfAYwdgzx2Q6rRakWEgNMZhcuFC0dayBpDuEfc+WSmQ67NR2VLQHH23A9ECOJSLkD4l1SPECs+G9G/RRnS6rBti3QN1h0zBdlBX4l+3o69YkOyOTQ0biAC2qcw77C4bG55bLr3LGqHzw4KTgxg9N3mAuQkALhuOXV3TmRJgk7WmmYW3FxIN9qj6mnHe/2ff+My/+Ln3YNZ+IA9V//63XkZrrTNWTT8lsKWkLnlsGTyk+8gvf7GBnegKHnt1QwlsbVrTT+sB3wtQ5zN3XUPi2q3GNdi/KmvqCZ5lG7A9CZhtv0qIBsKt3G2xOWn/dCzitfZ+T4At46NcWOvPtBtMru5sWwZ95a70qgqaONx5oB8xJhbxawHQRKZMJQEdZk5lSEa0cLkGtwKZ7MfhEkZw2T0fQNdPs2bQKp1iuK4AYpG4mx29/pahMGNrw2R8Z8PDvt3XcSAbml/+jEpi7LwPpWG/dWujeOUb18XwqCLQ1Hl9R+5Ggq88wQxhg8nUj11T/j3ecJ3zxEQ46Mq3EyyoAVoDsMXdmYFJ7snsMg5mg+o0oc8CoJPlwQUv/Iy4pie022C9Wnp2jDsYWoBx1nBZuyu5AbkkhwlUgK1IbY8ME/zADiPBCAbM0bwy0DAn43PjxVMCtte+rfKaYmw3xdgubq0UN1feKW6tXVecWlQzw2CfVjL2JxVEcvYM4FY5biVPGJNMgbKoLqurf+nzyPUZ0ezOesDGxqsovRE+j+7ANnrs+wFsj2KB45oNkqFodtnmnD4w744oXnFke9Px2ao2ZVDwGPGjj1EZ7e2+CT3ymg0mkjt0ppHa1Oc8lGEmU8XKMgGE4R2ov9p75TjX/oNPvVB846svF3evKbp+8Z7d6JMCSIPKGxvlWMMbgh2hcEOe8y5pa49OaO8p9WqAiASGqk6yQQAKZ1rQ++GliQ3yhgKCABkzCoYzUyuQQzlcgAWAC1CHTpJcr4Dl1ZXV0IwnME3HOJhKwIbzAaaQCvh+9VCi7C4Vq1R0QWCac+9QDEWMKp4J9MCAMIM3nRMt8APJuDBRZ54464ClHbGiSAAOLIWJVGfoNJn3Y5JUPJA9JRcvwJbvIZeAwd3SfS8uSyZApTEx1hcuXBAQW7C9O6sN54E2Bffu3DYwnxeTS3Us/l6THossEp5zOHt0Ppea1X0tKECMZzArALskXS2McZ82HsOSIPSNqb9n5vwzrM3sAP2E+30obBRSDSqaTQugz2ruw/q7khuyCYJJ2dTa1iCLiOBTbwj1/zzjCL618j+hn0ryhZlnCPK8THSkgNoYo9+L+AAAIABJREFUlgoWNCBUWjM9K/qFwjXLavviwv3i1u3F4sYtlQhfYfMSempXquP5MPYdu1EF6MK5YncB2bRwWVpkPAqAY8dFsHylOQmBA9AGMLtyOFIwHYtnivcA9IxdngGBZLSfO0bLC4HFJp/4Ecs+CCCDGBoZfePP//ifPNcwXR/rtzRnfk43MHEsYPutbwNsOzW2fzHANprYxcPX5SFkUx4YJ99kb2CbFreWM8aRASmqV4f8ohujUAOLefE4jnHOAMNX946yu4u0/XzHAbgd0DItOnlX8/0Btrn/6iC39fF5kdXH2wK0y/eUFUGJww+V4oToZYxiiKZgVgVAMS6koiIVjSz4FJVrxPJRIMGAAKOQ9m1xvwGu8KcxlnCr5ZKJWSJAQEFUAEq6W1LqZGBr4EblHwUtERCG6NQuMXb5MlgAR52fnTss7u7uYPHKy9dURUf1xMfOyi14BtWfzxHPKDR/HlomT+M5l5sBDLBNXwIZllTEfcSw4P7y0s9x3YBtzB1caJYhIDVwyG+1jYuysMHOOuArpc2xMov3wb8wvmI8+p08nLQ2ai0R5mqX09wQHUwwR2Z6HZgWrG/CzJF+SJ9PSC/31IeoPHanWLqzWmwI2C5tLxfvLF0p7mzcErMml50eEAvspH4uK5r88vkLxRmlhzqjqj3Tc4qOFosDqB0h7ReZEwgsI9rXWlp2GgGw3Vfp+effu+aL7jaPW4fpif46Ctj6iXbfbce1DDbTs0+G8CTANje4V2qwciE4AtjWb77RlmXjUltZjM9S39ZtD+5p9JirKqsLw3QUsG3q+PY2fOLzXy2uXbtd7AikvfryS8XdW7c0RqTTFlDqw40PePAGLqRH7k69t4csxxHlERDsog1k0GBcm6HEhUtkuYIc9Tm5XQG8a8rcEqQDrB7ZDFSwIbm6xwVAHVRJYI/d/oMuVkCJXpcRZpOsuQMgAbhiPwhEAwyPa1wDgjOjT1vHtAlAp0tQUJ8KpnB9TNr+gfLVAsw15oed4kxBabKZMMajaHDFONO/pNra1LFUE0OyQ3ouZ4JRF5BuC/kBx8Qm96GLLBA4RmEKguYicl+bWQNy2QPNrBmdm1Re5HB1X4qpxJvGuQmQQg7CfQDAHXylvqMfYb/xtKyJxMCGj2jjMahKjn16VqT50s1qgztQzJ2aKj743DPF8++7XFx4QhXhSPmXNmPAt4cEwFGSm36EnJC5pHgF/Y48wKnf0tQJaVcw9i5aQzaDRBx4uOrGhwjm0h94eUZ1rxPafHFjbA6cgYH7UJ+Ni30eV5tHxKTaqyWbA/BdW9tSdo4bxbdeu1K8+fZ1bSgkexlRvlpnY0lhbGpXJsvAFuPIDcQGr9yX3lbnHCZLApsvxij2Gs+BNu3MF3TdLt5gFB4vSxb0fcYZPwQRwvTaHqtDnL9W9xx9HmuQ1p57X/3Tf372RMbsMfiyxhcFGk4fC9jmymPofI4CTiVsqZ/5qA5hw9HCWrRax27pcI5x2hLYZqh71BqS5oBPnW+h/VbqWsmj2lCeowNNdh5ZDtUKl1eNOOpCJ/i8vSmZYbONdwdU4CkvHE3NPxKkp4Mq5iWfpRncGthqIq4vLyuadqU4oDwk0b7b0q7hJiQll5sXOQvRMpGGi0o/VPeh9vvMpAAuFam0iDDJc9CVtXQCn053gtvdbnM0uawvKX0MRpdSunZzRXSrLWUyIgCQURmpQVXE6Zdu9pBoNWt91S7tvFkIYXIAuvvKDnD16r3iy198U+eYkE70khbNcS86pCIyncIrgdosjTAoT9erA1nv3mPlKJ90Bu5+P+m36sMgnk98H1aHH4wbEbb9zkkbhtM6ZLvP0GLBeEdOxvwCqPf1HwhIqvTm6VlXMuJZkLd2nRr0CoLYF9AFVOY8wVHxh81AvsnIHcodTM4JrBrY3i0WxNg+ELC9v79avHX7DQPbYhiXewSwTGlhPH/mieKpixeKCypr+uQFRUifFbhVcv8xuV9doEESC/dfYtDCeRsbBf6Xo8rL++kCYI8czyeYY+3X6jX9jwS2fortZ6gW7BZj1TIAWhvc9Tqtg6ZljB3nlmOY1ec2yKDW3vR5+x3gwqa6l4EtukRv5qpXFx675Tvtz+xTn/ty8dbVW0W/iJiXvvRFja/b1qOO49aWXWATjOcneykAh9ZoJvrAwaIa+zCs5F3FKwEAwtPgIC82Z04TFtlW2CzwPgxeSBeUKUXnQqrgNE7QIh6GYmJlx2AQh2F8vSml1HZK+O9rKldpCuoEAHMO7g8tPCVpIRIZB+QlHcVtrzf2tiXN8qZUUgEBTAwa9g8AQ1wMMoCQ5cTmD50tQeD0AfKGNEtsk2CJCeriWhwDyEVn63y5lKHWXCP+AbtrQkHtspad86s/yHSwLRlZvCeJh463xlPtA0hjKx2ghiTEUg659dVmB0+NCtAqD/ihNbYTxdPvu1T85f/qp4pnn71c4Igje8SaZA3rFEDQfQGsNWhUwCfWgU3ZohVlGdjUeoCuH1mJQR0kRcp84KfghwErn6RqyWbYRtrrRg5tNjjS+Uv29NTFc46tWBHZQllldNSjE2JjBTLJbuGNP1lkJJU4JY8S1ddgkB9qLVhYJN7iteIbX39TmwNJ6mxHAdZpbYFs0HsUXoBlBtjyzMbU16QwhJ5lswR5Qp9SWQ7pAgw7LC73BaC1qdX/Qap4bMPi6h5hjl2MA12xXXDhkbPcQb9/+ZP/9CQo7Tim4P/37+j+qKh2+Uhgqy+VGtvvK7B9xDRcvXoyL+vegCZz3Q3YvpcnchTY59wAqV7fc1tTI/mndD0es2F1sF2/Tmn4GdfpXB2R1IkRymxh02h/ZJYrXbc6Z34qDUu92rGviU0O28011RzXRAbY7sDaauHAHWPG08niwXL6voXy6J9Id0MxB1xrUUec/KcYeFcrw9+jGyQzQLCbES8N3sVlzg9GPnRJEQSA+6Zqd+zwR0Zk4PWjA/QdLEqwoYDGUedJheQh9dRDueweFF/8wneKhbs7KnP5jHbuszofi0CU+/S4wMT6HGl8oHLggxJ0VjIEDFPdc3FcYGv9bJJLsDBS774PUM5zT8ywwX0CT/Rr+ZTYbFi7rIYprNeBZeoHvs9CyO+bWlBIB+bYpRA5J1ZFmwfTveE2zzXqp1RS96kPXSiuSIqwcEdpbw6U6ufBQvHG7deL5V3lsZQUwc8HqYOM+2m5LC9dvFg89eSF4uknzxXnBG5nT88rBZPKU0pj26+8j+X8aeFnY9K3CK7yHChBdzXBvh/ANp+9F3N7LMDZCue8CfErT6NjLVHp2bTZlJb7bgP9vXT25TZLx4Q2u7QwwZi32662PgfsTE+Ni+WSDhPGtgZss82OU7Ru6JpMYr6HP/7U54sXvvCigk4Pi9vvXJPbXy5eTZoxAdsxbXo94fVi88pcwlY60b2ncshwADhkYSEwkiAswC4gwUFPpJaTzh8NKjaDClJRclaptvTvoeYHYBDGLB6PWECCeFzkAA9QKgSDnEfnGhUIZbQD2AB9eCkIUAOUYcMASfbMqG+s0dW5RxUQh2aWjfmowMyKAsRw5w+LRaTqGQGwZByABaUF62JcAT2cDxvJvUwSjJTAETJDmGJ0mwB6g3a10wFkArkwvsxFtMcAKqRgtJ2SsmhsZ2emnSt6ZXnR/Q0oBtjSr5Y1JWYcltp6UX13Q0z3uuQSMNbOLjM+UxyMquiD5Asf/qkPFr/w8z/nDAjky11SYNm6qtNt70jypDty5TD1z7bueZ9+07O+clXsKJsSiue4v8Irl4xpuPaxrcmD5GwF2VYwfrMGludv0CvwuaN1R5sRJBg/8qEPiVGWDEIBrWyqZ2ZUmlv3gfwBlnqDQgwaF2wWZgVwz148JQJg2rb+6tt3i89+5ivFO+/eDY+WgHDW/XsT5Q2UbJg+W5Q0gzVrXM8HcAuAx0MYDjAAqrJouH819vQ95ypn/QIIYxM8BYPAwDNnuwz2SEFpTuWmsdinY7/48Y8dy2o0zbcf1PdkB35CbfuRI4GtNbZJikAKk+O8OgzaUd3nxSd2sJ2vWGK7fVL/fpP5K8d2+uJRwPa4bGw3INm1f7jH2jrUaJzbb+CofuN8NXa1l8Hns5ycrKu0oWGxz+fstuh3BwNpFKR/KvYl32SDjk/XfyBAu6rJvUe+SNxMSjKO7GBbBpRqLofonDBERpRRPYtFyDXQ0YFTRlVFBSAclatPoCzyzY7IjYfbCE+M7IB0WnLtiOnDQ8TuHDe9ARznZneL8bQLJ0alU6sQIKH8mKNiFyhWAJCLcYvhkOtcu/gBgay9h6T2UeL5pa3ixS+/UVx7a1nVeZ4W8J13m9DaRnYO/BQYtMzIYX3j2kE2RgquYB+jJZno9V9emdO/XRhbPx8AvUt9spNHX4sOIVjZ0J4GaHeVMp3T0dm8Z3CCIdbXxdiSXougDUcEq+Xoa/m+9cgRmeSmZ7Y0hA2xmFg37PyTqmA0P6bgsQvF1W8pIftdLVp7m8XdjTvFlbtvFWuHio4ewGWHazrSjhFFfl5awaeUqP19T18uLgrcnhZ7MiM5AsnoB7QApodUh1buswiMa7Aqf8HANvqmm6SoeaLH1O6wpqmfT5YfOnrg5MDWY6xru2ubZVrqMZDaexxgq8WZlG7rKklKLtOjXpWtqfqk3jv04r/77f9QfPw/fVrzWy5/sWsbpJjSpBmbnitGJVfC/Z8tULCH7Hi5RfpT9gA9o/WQiiqXPSDwiOqDAIK4PTw4SeYiMAJAHmITTb7ZrHMUkGOi4gpH2kBAkTX8gGX0n6Ti0qYZFpLB6YAwzSl0qDZr+swR8EkWBdB0wJqzMcT8JUsMRo4iBwSCLQsAzpw67fzOsHwAW5dxTcFeFGtwtTJyn+qaOT8uAJO+R+mJix0WnXbgGke7DnjbVXCn05xxTY2FCfLM6p4pD0z/QBDsCATTr/siI7BWkeIrGOdcxhy7SqEJwCwMN8ywM5mMTxX9EwK2Y1PFmaefKn76L/2ENrR9xe2bt7TpEZgXoEW7TPll52ZNwV33FXQ1RzoysfMERM2fFbsqG4UkwRuW9KDt8Q19hfsM1tZv6Z2yxHp9QweYxDYK1K4pR2+fxsjpiyokIWncsIIR2UDA0M4oc8sZbbDPnz0l+3TKgP6utLILyvZALMDTl84Xp2cF+uXhunVjsfjcZ79WvPXmzQi0VTAucQ+MJ65FYC2bBtJ/PVBfk594ROw1DDtjCQ7lQEFreMJYZ2BuCXz0OMv3i43Ho4Bt13F8DrGd43edbYExSuwIG4Dd/Se+8Ml/snDUvHucPtd4+4ja++FjA1sSJ9eBbT6wjsUaTfAxwBkdV+3266a8vqS3wt7KhEYLmhavvCy4CYEVmrFz7cmdBNh2PPB2K5u/kG19Zfabx0qXvjoOkxQLUDqt16LmBbHsAnQ2uRUJT0UndTnupO/XFuTc/7522cx0rfTgAD8Y61Xtzu8TXEBuPthYGT/YWliCPSJUZdwwsLssHsgA0FYBbKm0g4HT5w/kliKvKll65ECXsdMPoI1gfbGOeMVOqYrNhTMEO6DLxY1jG2Ewh/7VLkQBttI9r3bjriMH4NCQKu44cAwgGCKaPs4rnxl6T9LBYExWlh7IDXWteP07t2UEL8kgzXkHP9AHm4ELFOBlztYd40UggQP6LOezzPPDQK3U1QZoq1jcyFdYf3kMcE6dzDlsYavVbKc2AqyY+QiQG690hpSE2TBMFyHgxFKGBGKxx9TBYdHmErAK4fbHoMaZQg4QMgAq8dBHtAGmhawIz37kooPH7igrAsD29uqt4vqSGLYDARFpbJF3RAoycjtKaydN40XpbJ+5fLl45tmniotyEZ5WmqGJqUgZ5WdX2/62TMVuwLals3rPmeYJe7J3e7G2TWdqBHL5xrpP7+6NsqnsPNDv5PfbP87goHbWgOfZ8ufODS+KX7G76Xi126TM2K6uqjxt2kS2H5TgSJdzVZ6FfLl/9Vv/pvj8Z/9c2k6xgtKUbsvbc0hWgOlZ/czYTwNgsx2CNYUp03+MSyaHx7RPJm8Oc4f8tmlecVsurCBwHCmkyH2bsqyQ7g/WWScmup1tOwDCDCFzAPsDYCbgi2BHHfdAbCPZCJBQIWFApsRYJyWT4wiQRB0KhFBMwRrkkD14dsEK6x0yFawJDPVrwzypymDoMwG12EUAMxt+t0P3NGlgr/R8ei+kXMgO1B5YZ0mr0OUi18LmArIMrpNIw3pN0kqhqycjDIFMyBv0sy1QS47bXMDAlcsAvMklbuCs4wHTsLfOiSuZGZZzRMB5SGCxEFkwe/FScfHZZ60tfffddw2mCfKzLIwh5ZgGMkTo+en+l27dLC4pmO2mADCgfkKeHfc7mw/c/tg9LE8aRA5mTfpU2FyYeAiNXKKYi8Q6SnCsnpvA/aoC5eCJz6oC2j3Sk0mrLf1T5MG2t0/SD206Lgjcvu+pi8WZM3PFho67duOmc/4+/4FntdZMFKclUbhxfbn440+8oCCzRWeZ0RO2DQ6Qrc0ABXHUx/d1HQJhYfMB/mxQXGAEqZjnF/mGeZTIJqIKZi6T7jy5zsoR9swSMx3FJiOKhkQeczpHp5j7/B/+78q6/sPzSoztc3Xzk20I/7ZmRRBj2wRsfTALcrZnJXqsdZTX7C6IrUt/lra1Zh/bDZwfXD5vMqTdrtME8nrKAmrG/0RtTw23ya/fcu0+/JWTdUdvkFrv23QdM2xdgWhtTcozvv37TccmN2FezspHl67ZeUt+QtX617BiuVoLzUlGf1sC/VUxD6tyrY1Y2yY2VgZwjxrX+gG8HmyTggVtVpQJNIOo9mIAcfcxTqlis7sL3yedWp+CG/oFbAXM9uTGgQlExD8wsF/MTg5rV31GQUly7SEjSKVkXHISFKzzelcPQ0lQgd4f1AISgUoYicgq4EAEHUsZ2AEqw+ggFr3lpc3iG1+7Vrz67VvKA3lZhp20X2KNdW6YW3SuMRxyFoR4bjZI6tAW+YcNO8Y6cd9ph+DHz/vmWNtYcBbmgJxuo1N2BYUaTLMJvDDm/AQjZIvoxYRT23XGIoGBVXvpb8pkUpQCxpYXbAqfRy30eAUo9xkiUbk+wRjDpI/Pjxbv+7CArUrq3r61LGC7Udxeu128u3JNjK1yavYHW8t/LvGrZ8fiT0nPCxcuFs8///7imWeeKi5cPO98t1Q+49xdd7fHmG9N6e+Os6HsYsIa3+6aq7XLSZqBbephG5hj3FjLRG1Gw7EB6n0nLeasm21JpzhOv/EdorqnFPDZC9jG/Oi805xrNFmZsif+tYDti/8fe+8dZFlynflled/dVe2q3bSbmZ7BeEsMQC6llRhaacUQFYwVQ6uIVeiP3dCG/tmguAytk4mg0RppJe0ySC4ZJEFQJDxAAgQBgoQfGM4AGIzpsd3T3nfZLttO3+87me/devWq6lVPwzRWb1Co6vfuuzdv3syTX57zne987dvWiUX/E0kurfwGfQXYOjrD1glwp3EOgOOW4Pl6I2WtZs3J7GVlDBoIyCYxbwC/vJgvUTlKslYUPmAmC4QARD1v+EHuCTDmUDGKJPKKwv8X4J6SzivhfPqhVAMjObVHm2fPHGyBZ3BwJD3HeFBk1+u8Vohx+egbafNWVTsUN5MNApQfVELsCZYnkz5w250VRTEV0SUswYXKQ5f5s4DqqUmV6gXoymuLogF9gyQX9gIP7QYdB0ViStQGV2TTfczKZscGgUIWyDIGfzT0VlUy2Nquwb+HngGoCo1c6BIC9ITr5QEdEo/+4H33Wx7w5IlTUUgi258wcbEBwQvbK+fBIqF/eVO3CNCePHkm7bn7bkkAUtIY3nLwuYLTHxsPaCRRiZGNdqwXGKNByhJznzqfK07aPMampkMAH68wCXubFTEaJxlOer43lWOBowT8ccN9SiSvUxzboXTPgR1pVAmucGUPv/amNuA70r1375XnVioOKhP8za+/lD7/xedECSFCQcEI7G3YSIYVnG5KKDMuekUB6TFnO7AOSYLkhyAX5vwQrzvRDkArz9za63qWpta54xC1Q5mRynvx/HkWaH9//gP/fD0GZD2m7gd2rOzKk7r4/uqNFfvB76U6tiekY4uOW6Yi2DPCwuVRkBezBiC35M5uQ/fVssV5yOXkzchzq3Vp+eJtaM+6nlwLwDYSgOqry60A4BqObASq62pscd5UVroMdjiNvXbVha0VYLvS9cslMDTagV/RTnVKFWioPNamSezKYKYjKASFt1ag9To/mqQA20UZ9WkZAUJxsk45qUF8pxmkWNBtHVEJ1hFRA0iaIGQj8CuagFIKdB8CuddmBGr70+7dI2mrpHr6e+GRhS6lq5npH4y7WKjxzuKlDa8JFYbMo4PzC3CTNxL5VqgIhK4wbBcvXEnPf/NIOn5kPG3efJcMj+Rs5K3FU9Epz20XVIlCrPZUCrKIDbo1NXkVIFOeS/b+MO8yeLSBY19ekYAqkYd6FwOYI9mAWvSAdIMDHBrO6o3z4omI0rPh0eIendCiD6B9uBQlng4dAI+Ov3nfi3DeZHEfhMei1yJhA2H1Ln0OeBhUn+97gOSxC+m0ZHKmFqbS6clTBrezbVeSfGGxmMNzs6EO3UykiIalqfnQIw+lBx+4L+3ds0fekA3OXO6BJpHHWZnetRHcwnxvubiA+2UNFLjCeG8F2MZYa2aocvi7pblcRlFLB8f4XuuWyn23cuo1gK9HtY6hHOuggO2EPLZWCVjvK2+2aXp5xP/u3/x2+tqXvm5bSrIN87BNVKRhARMyzpluzm7XWHS0wvOOaAb6sMjWZS8unwnQMObwogGU8WxG1T5luuckMTbbgBorijhhi01eKHMAYq/qc+7THrW8YQS8AGwnpNzg8D5tssc4okLeKNsWhHENqUJnsofiAht0c0IZ8eLOSn1hkwBenzyfgL8AhepfvMAu2ytvKiBd8x7+JuCXew0ZMugKAM5IZILWVdRL8M4io2g7oR/muz1+TsqVFxBN15xMFoUuIgJEqJx8HOtKUzwlUzTwGnJtNhxMIdQq8Nb2y9N64L5DaUje0LePnRT3dirfm1lPHpqlyA7ArkftnBGX97r0zbHJM7rWzgMHBTLDt+4tsf6Iwj2ROEc/soZAreA5AK4xe9AE8Gq7Khe9pu+RNIg1adP7U9IFpk/g88/BTVY/39RG6QagGRqLiziwqYeqltI2lf49cNd2UxAuiFJ3/PjJ9OTTj2mdGUqjWzerzSl9+GN/ofcveO0wHUyOFnzjXF/Lh9eyCW164M31qX1slKCBxdjTc+M4FDWgurggjZQS1G7sC88BGTkD29zvtBM6joF9/pzNxhc+9C9bsIzrnZQ/2ONlV96tFuxcE9gWju26gO07uLeVsGc1ybZ2+jsM2K650DYuLusddpXOK16TZh7nVj0qtX5uAdgufeQ1OLWiU6k8T24REEcCEvzaa/IAzIv3taBsX0J3YCwM8uICYbyoGENoy3W9lQQFuEVqBg4uiQ5XRUGYvoKSgi7duUEAS15bAVuZAn9HJl0mhIo6qoOuqJ5sv0JGMnB97SoEoNKNUBPkde2FnJ9DbeagWm4rDBFZpeykbTAtDxPJWdAQUEegxjzG9szJSe3Q30hzVzp13h06XhQGeXotuwIlQUiYimQFVHhBs3njOhjZ5TzkmwKYoZ8ZPc6z9L/jW7XHUKXUGLf4uJD74vqxoIcnwMbVHs8wjlZPMKgF5IdB5ACS5bK8vWugo9FoP4oWRYAJC7pBn1cipGZCTslcWX2GDJATVyipK4/t0ZfPCtheSJOL06YhXJ47nxba5G03lSOqO9W813hr9EyQIHr6x55Kjz70Lnnbd2nDsMlaqN1c2//Vh1x1vq1EMarNhbWAXWWAtzJ/mpnA1oGtn6zvpMzfAnjLZma1Niz9ztrGeFVgmzfJherU0r23CGzJ7h5Q8t/EhJKxMshc1tq1nou9mvWDfvWf/e/ppe+85Dl5VcAE6kH/ps0CJJsdhndOOuA1V/QCCMBphBMKOHW1LbyOqAFo3PcJFBNqBpQBgLg1PHuhJcqGDzUDSp1qbOsekMV04RgSsDT+4UTCW0VT1OVtAYaI6huMwOPX5lxAjoniynqadC6haw6uPKA6ZkZJSfBuebnctnedmB556RTJGFKYGw9ceO8ikx6PLMe5eAx8TG28+0hyg7JlrV3oOxRZCIcVMlL8wAtm7rk8sBVc8rzSXKStgHokvLB98HBJdCvlzvE8m8aA9Jj6PcBz5nVjZ4RSZxVtI5qFF6BHsl69oofsVvRl790H0wl5Xs9Lv7yAWDYhsYeMCJZtHGF42Rs8qRShQEd2o6qT4UlFss2WLfNpeQ54jdmUuG1584RjgkI/QUWQ9zyXRLZJtUcUz7AuLAA+LXCKrjBctT61t0eyaPSxy3qTY0DhDwPqyE/AMbJ31zbT3ODcvqYKeN193emJJx+Vx7s7HZDN+tpfvZz+QnzbxdmIZBFJ6zDHOzzSPTrvFSXWTSP7ZhlLRR09zsmn5rlAJ4PuEbQMNiDIjyF1iZSaebmsUXC/GUvub2hyOjYXA1FPXnn24/+3OCA/Wi/Nl/fqjlqU+yJ5DFmlhgINpUs89lYCYXmlqX2Mp6mJx4NdqXdbxRPs8RleKb8qBi4GID/rRH4roebv4bOtAsuWFoXvYVsaT10Fv41tW/Lv1YBtk/bWz7vyqkToxcZZv/G4XhGoRRT9Jp5YAdvZGUmfEAYDYDljFIDL/0Vtb4Afw4jQGOE2Er0sgq1jZudINLgmgCs6wNisvLpKflgAKApMyuuC5Eq7BL+3bFHmaYd4vZOXxR+bU2ZvV9o1ulkJAZJtEXcTTws8KQBu8aLQZhY2wpUYDvhP1rnEyRnFwNO8FoCZGXlsL86n1149K3oFC+RmnUei6/YFYMC0GEJJgAVmrm6AWnuIs0EPMfE8tTwPfEQN7ND1tAXwGVGm6O/qmAucGXMj6vH6AAAgAElEQVQuggIYUj9QvRtSRjWVjDh93v0XSaSQP7K+LegXo65juAuXhfQcJOwK7ys4cFF5B7kZ5AGjTjv6j9RWLx7bAw/tSW+LonH89Nk0sTiZjl8SDeHqpbTYLk4gmxnduz1qthcCGugPy/Owbdu29N73vDu96757xK/bIXrCBnuI4Cwu9XZWTMYqZqIlb2Ue4wVA2T/eAnhrnBprAdtl0ZCGE9TvL/q8lVe1nauC+xVOZ7vcxKO7KrCmdWv0D59TdYzkv3EB26q8XPW+ltmohnbWPvcacTP9/N/7B+n8abLPJUeHPqoSkkZGd1B71OMHMGK7oWORCiRxNKSSoCOEZqilBfHQ6thQM4CeoEx1AU9X6FL0gXA/gALwZtsA0IVqoGYAPmiLASBgmWQuzo+tEnBkg0eoH2/nxfPnzHUd2azkNhQYdC6rKgCIFaqH9sDGfZokKsrw6hx4l+3ZdWJAWxpQZTPsEbQBKFNsugG3qMgEpQDalqQTPdFjkgNMN0jNACfBuLyfjtaozwaV9c+8o60DAkulf/EOTkiGkek+KKAFSARsY38AuCSNAaL5HM3bHm0I+C78XvqC89N22sWOuRMFB3lrN+8YTffed5/LFh87fsqbZ9OjCNOHMYtNuf50IImHp/6akbebCmMTcoTgrZVOgysjFqmrsKdhzHwPlSkT4zlHnAu88DHY1qhIBw2uTfc4o5K36PFCZUEy7rpBbDznNqvphH42YJfv42IYkEzY3Xt3pD65X2d1Xy+/9np65sffI9qEQLwA76DoF7/7vk+mC4roXZeigyyl2gMPWeuCTowtA8BfvnxJiWpah9RPqG/QHx5vZRVBfYf+1MsyklwbCUTUMOg3PiCSoL5n7BCNg3ayoP6ThNibX/7o/3FvKzbkTjpGz/avqb1DVZOflzUPgaUc21feELCtJI/lwVC+XPOUrAA068fVVgj/YW9OBWzGchsvBqaDGwzAwEBLXj7nej22t/EJhQej6iu4jSf/Pp2qlcXHTakA25WaVn3GawJbP9MwVujWzslbS51xPCwsKtdlKBdUcWxOEi8z0km9DrdInk5AYHCm8JTGYhKVpkJaxjt6ZyOLbCBgOyPP7YzOMTE2I4A7o0SliTQ2rixgfU7iyrZtw2l0dETG9Jo+vyhOrMTce9rS/r3bVVWH+u/yEMqoEL7CoxOyQLmqFV6QzGMD+JZZgzfiiozZ2LgWEnF8L44pkeBtVVGbo1KXSnPKutDuvi6ksuBK4bmt1wcPc5zBZgYURdw++j5zbPnLi0WEU1kIq3rPBdzGIh7zKOy5QCopuN5cwjfL18pzN6rWhNqEdxPmyBq6etG1DigeZ32XKj94A0L1wGQNL+TBYIzEOxYBOG8heQRI1sK4uTftf3BXOvKSEsbOnE9jFGe4+HaaviGOX4eq5WiBAgy77Q63os0YFI9Dh+5N7373U0rU2JN2jm6TJ1w8ND0nsoRjuYn7XG4smo/cZhvnVqbfWnOn2TlW+k5p7lrA1lOxdnOtAdvGdjRrw2rg/laBbbnuivdcAbZjqtZUc3Y0bEKWAdtijyo35jWC0awu+Ts/87dlN2Y0YjS35KEc3b03dQ9ulBSTysEqyZCCHtiHSdmVQc9rhea1ATPQVWTI5zF4Cm8rmzNAgec/8oGAXfitFEyQJ5fjZ3Ru5gfVpjynGIcZPOFZQ8kFL6Erf+m8lGblfpnJC+K/QsPCHhHt2SjPMvPIkoOAWDaK5vAqCiX72EemPLQCJPlyBAYPK6CSa1hdAb1akqTUBiS65kRFmFNGP5QiOKUAXBRk4OoWqgCULiqjASexqchYQVEgyjOusDieWJew1j3j4USjFm+vKy5CrRCwxblgfVWcDzq3w/66T8L+zHuS0yzvpX6gEANe1nvuP5Q2bhpOLx9+VefAxgRvv11Gx2qKBSSwudD7/HTonNARzhw/LtuiSNuBu9OsHR1EmYJOhes2glD1KFZ96gSgCFp+2aTGfOJyaHZbOkt9NC2VA5woG8VhXtQ1VTE9XvbUUvUt+sjzhGflcXhd0b+NKigx7Od9VHSEPkWannzqcYHWq+mh+++W/Ne307NffRnWgWyd1j1FEjk1z5tk2z5tVMYFbLlevyq64ZApjpyIksmjD6dZN9WjcccYgypiCTCapzHAZowXCYn8zTh2f6rNijJ88Usf+Vf/YaN9uNP/rf7467oHpIFrr6bAVp92HTt5zpXHkNqovfImiH97SDQYpHJcedsDqOqpZQDVBlV9AMe54ltewlfgsxUP7w/iQRTQUNkELmvGrSx8jSdZtiFocrPVbl/vUtdqG8vCV4dU4fFo/qq+3/yYIrWCdMBVRQHQM1yUsHcbQtJeCLRwyFAiBj47o/rclvBSOEivQRINlDA0IENhaR6PlfA2hBRPaNDCeaIy1jUycEVXIAo1NSEDLykwdDNPn7qQThw7DuxKo9t3Sp5lUFIr4wK4Z9Oe3cpw3b9LoTmMNBI4SpzQLntQu10Mu/l0smCEIMkKxpjgBaWsJVqKk/LWTs9dSxtHRtO2Hbu0OLYrJPW2gDOL6UaB+Ll09oTKUIoHjP3Es8Oih0eTHzHfNJ2QE8tVcvJC54palazE8LIUw50rfOWHUuZWAbaRfBHAlkW40B4cTWXKObkkvJ4FKARlQd9C/obv56hKWbwj61lHZK+V5yyY2TQGOGARXgujn7+l44cs9zWaXn/xVDonYHt+5kI6duFIuqL/2lScgYQMFljGmJ+r+pbvD8kz9fS7n06PPvxgumvnaNoqPUk8fpHMExzF4uFZPiHjnRpQ86H12bMi4ONLa0yspuBrHYapzKXvB7Atzare77qBbTZ8K9kPf7yifah3DDQE6AiXLqn8a7WbK0ZtWd82PIv4PDa0JJX+13/zbxHkUQi23/JPfQoddyqLnblpJRVzDAN8UVCFTSSUAXirzGW8pfNw/AFSeESZK0gj2Zsb3lKiCR5v+k1Uh402lbbMeNXfAGVuoYuyu/pdFA66BLSLUgDAEFDdKzA5qwjVDHKGeAmZh4ByqgRqcgGsAbhQFDYNi1Kh+2FDPZGrtdlRyT2xudaNowccVAm8zeHNozGAcTjCAGMaiqcP0NWXPceMPSqbTV+Zyh5SAB88Xn2diJT611QF2WUDec1tADygnLayobVMYPZ80m8kOTnqCt8Z20ixAehdakOb7Phd9yjqsn+/KsUdFx1lWlhRfF4aC8eVqA29bGBLJ8LzVbKe/gau9akPTh09ojC/1oKto2Ll8xyjyAebDiJIwUOGwhEbDe4l+MKBLRw15HdIqsSL5+7aCDqf2otnmM1A/8hwAv34OnxbjhZAeNARkDKMPABAPnSCm+L/3rt/t+kCaPHy87iAbb+igvfuH00bVGXtN3/jQ4oWij6nZ2NaS5zZY49xgYNncnpSnmLRGrQRMGClY7gv5zuIjsBaxAYGJweVx7R24t3tFEUFW1h0mZ1QSFVOgXEiGdJc/sNvfOr/+W/WYabuiENlD/5TNXRxTWBrji0e20Zgu47bXMLzrHg5q1ywZlzQxkt4wV3BK7yO5tSMbqvnCt/W8lcVhDd+utTL1lrrqjxi7xwLGKnNubKrXGFBLpuNEj5s7bK1o1ZcjMrmIj+7wA8liWzpShNcz5VfcY0wVjc0wWblDZhXRqrDzU7YgFYAsI3CC0h48TeZzHgXSIjowVNib31UWLGuoeVQOCm/uULWocWzgbGjWg5GP+PfBWkjXro4nt549Wg6LXBF2G+bSjbOiAJBUsTdB/cprNOXLih5YEbAmuz7UWmnbiYLHx6uQC9eFmcaYw9ZhNSOSR17U1zarr4N2jX3yDBJwHx4q7wdeHfE9/PCouIN5y5pMZIBkjGfl9eGksCA2jcOv61Q6oT6wMtbdrfql8EjSWe8R/9xh7HwONTHTj/4CCEDVnlVNyH+m3nEsXm8BDQIo2lwa35vgBPHJPL5qlJjhSZkagNUBZ2utvFhEclzNeZs0CCsmqBzbdjS65K6b758Op05fS6dkdTXcXFs5zukldmuMJm8FXwvaEkR+GuTBu9OFWh45pmn0z3796XdO7anESVo8BxYPOK1CgLNY7h2xGqDtNlcd4esPaFaAXSrnQXMVECe+36ldrJwc6JlnwdVpRk/Oxgoy6NM2ao0OVlwGpv17KpdUQMMSxNNG/tmw5Cq+Glej41Jrio/veb3VO/6GmguY7Ly5N8Sn/EX/4dfdGGC4S1blTSmOaf5RTKNvZzm1sI1lOdWtoTwviuAAXbsIZUdYWOMxJfeJ0HVSTj6jsu+aj4zkAFOnvZWAEBhhQz0eBBRtZBiB6GCgG1irgCIiRTZY2l9USp/RcUuKDwA41kBRsL6nLNKzQCQbtwoLrn4qHhtqSxGchH2jE0+835BoN5KJthl21dsYWwwQYkUXsBjB9e3prpAn/BjwE6iV0S+GDvwiWkLQJRNdwBDSSgKgAc1Key8bbY3FuH55DwkiEXBg7ALHIsNJxEMmkS7aAobR0fTfQ8+JI7spFUNKCwBrSummf6v5rHNygYk1+n6jg4B4OUImRi7rPvfLFWFoYjWmLoVkaV4HGX+ZF5yZSRTb4ZzOSEWWUlAsftCnlOeL5QUvNDy4gsDpV5tKK5RlEfj5ppoIFASAOiAxQCNOXdC/QUVBYnKrZsGldyqZyZqxrHjJ9Kuu3an/eIS93XeSM88+WD63Ge+nr705Rfcdy6fS2TK/wWwHhA3+7wq57XpmoMj0igmeU+fQV1xEpmNqjYYftSKQuKxle2kn+eseqFcEfU3/Yl3F7UEgG0X2sfXbvzqdz73m/94bYt2Zx2hMfizavHZ7wmwrQJW294GMFrdhXv43SbAetseQTGasfb7Z1Vg2/gh87KhMa0seFXlBwOU3G+lDY3nWMaZK/P4FoFttclLrtUE2NYXu9K6+Hb1vt0t5R7yYhcgSLtLAdZ5hQyvyltBmCtkYcLQOJQNYgOwkZwlw0xJQbwt5lDlp0EyQgkh0l4I/3h87QaFUwpAY5aXc5s4j/h6ZO9CC7gyNS8dxPPp6NETpi4MErZUmJIiDHg3puxJoW56v6WJ2En39EtXdUS6mEoKQGTbiWwKBbGA9sjIXpPxgBe1QfxPOFZIe/WrdKhF1uGl4eXQe92dfU7mYKFEk/WGKBdjl6fTpfMz6eSxMwLB4gAD7Ag74bWeUQLLrHwGN9DEDKkxuLoA3SJGbopGfjjlWRRgG0A1HgnPoHhmy/shZxQLlNcIz80Y/Jyz2UawBkA5puY9DkNr74LHQF50uBv6UpXH9j0sYPvSCW0qzgnUHvfPtW4tiAoDAmzjmrFA81+PlA8Oveve9PjjDyvr+C6V2d2iqlUDWlDwnpSRuzqwXfLpKsC20T4VG/X9ALYRR42XIf0K7Syeynxgfep6UW8ObK1m52e6tJ9i+9D8Qg7lNhzPOeoB3vql6w3P1IDa5nf5NTl2o/icjMUJ0YNuFdhWr/6VL3wlve+3/t80JA8XCgVzmpNtDrtSUavHwA5qALdqiS11Ax4u82r5kWasgU0Gak640XkIocPjh58YkniE69GWDYlBQCvSVwBBeKTBrSU8TxEFwvOhKwoQZXNevJoGoboe1flQH3BbnPQVElnITAFOBqR6AFiDh5pDIgbBffJ6Ajy5EQowsCF1ElFOTJtTtAtAQ/nXoBgJ8EDJUJ9QTYt7IRoWbSpWlbmLBzDGkBUfaCcKDxlQ0eYi6xVjo66/TRlh+Li2s5kmBcWDv6EjoeAAV3XPPXdbyeHFlw8H/SDLKVrH2xv0+B1UBKTXtBbgwNCzWFA/s5ndps3tZgHkAYF+KqmZVoGnmkgdDhJvMkIDNypx0a/h2QgnCnYuNIzxfvqH0B7av6JmjAlUnj1z0mOmHRUcCjNIuaFzcJMoU6JA7NmtIjGb/H3svKuE6b8r+i5Rx+6OG2nPjm0CylcVITxt4P7wE4/5fE88sE/e5870a7/+QXn4yRuhaAORxtgIsMoNab0gmjmjiOOQKCqUhGYTE04fjRMdDKCmWidfdNlidZedEzag2NuwISHtJlCuf/BMlTP1d57/3G+8v8nsvWPfkl3DiP1t/bzyjoHtal7PZgvE7ey1tUKJt3ytAhAzsF3pPF4eYktaf+U1oxHYlgNWA7g1pYB8vpU8tr5svvaS87UIbJcB4qZrU2XxAyRWbzEvdOGFKwzrOMBhmAZ84X96xsaHN5S0sUCJRBmAm4TLtFDAqbRHTysmoWW8m3hp8WiGUTazKGsNAvZyogeYyUaZPzBmCncR0nPcSZOaet5207IYi/qQvQklCxtDOqeCDmRmnz51XmHRGSV9TSskx4I0oIVRkivilm2VADc6t1MK1Q0MdWvnvVde2C5pG07quB5pQE6nWQyQMmevkwChW926Y6sqjknQW/c8LY/MDiVKbFAGM4AeT3SfSmO+/vpR68CSNTs3J5kbfa9LBSXePnos7VMVHrzGLDIA4ulJspAF/HVrExenBH7Ppbkp6qUThoTrFnJkvlmvC3kAxz+XPJiaxz1vKvk8EuSyIkPeNBjXZrBcA6pxhSXnM72hbF7ymOBcAYhjYQmHyk15bAPYvvHisXTm3IV05MLRdFLA9mqXQK2oCHDAQh4pjDTX3yjPx8OPSuZL4PaAKpChGUm2OtJk0EBiyDUMvMYxW/14FWAbX8v9mM/hebbS9yvvt7KBbTLdKvaj+GyKBnHzeyrAtmxOal56NhOrANtq+4r9NJ2kds/V1sWsi67Nvysb1RV7mzFV+q3afw03TuIfIerpKUkv5acXNnV5D5VrLbFDDTS1T3zkk+nzn/uKqSyUaV2EJ04ylQAVmqneVALKvHEjcSxAkDmji3g8NZfMpcELGWAf2gKADuko8/f1ffoXJQC6hJK3JezNZrpTG18rhLAs6P8KjxMPKE8WWxLey4h0mLPvhMysWkKVL3FSAcfdGt+mMeh4a+zmnALC8gZsOr8TzTQHANf0jc+lc/O9UjmRbHiOK9JXQUMKbzpmkrkGAMYWFiBreo8+hzIBiMW73KM+nVN0yeoO+g9wxat4eelL803zQyplap3gpDfxpA+IT7tz3760/95D6SWB2nHZzU4BceSoAGIhPRhKDHGe3IeAOa0Xsy66MZ/2Sx7swScfk6Ys9wbojsQ02sQGwclt2P+sF8ap2CjYy85aYG97eHI909msQCfgN8Vh5HC5cPKEygRfdF/i+W9TEQvdRBoa3ZU65KjYd+iekAHT+nF5bFwhfiKL2gipfSj6tAvQblHp3WElIo9JxWFyYio98OgjkjgTnU5MgZ/8sSfS+37/T9Lrb5z2ZsngFrcNQFTjoVt/MEbHxiflsR1WBIKIQfRNcMCCNgblpI8xrvWS+cTngFiPc9ZGLcp45q2BDi+YYiIpPSWP7fOr2qI77EPdLzWk/0v9PLcmsNVBdY5tY0ndPHl/GO+/FfDWaENrhrqZFW1ykxzWaIjLRFlp3VwV2DZa9IaT1BaxyqKxZHHRP/yVNTy2Tfum4Z6XAuZY+ZbfU0ys6oqPzE6sgXF07bQGTFTMuSbjpEQxeQrY1eIpAXI60x5gBqD1BISzFMA2EsIiSSpCdCwKEUJqE5c2PCxs8jFc2ZugBUIHmGdrMG2gBiUhDJ6lWTPQCn1AeVQENsfHZ9Mbb5xy6cPZWfFr5TXdosQB9FMt+C4QOiytwqd+7GFzRaeVlIEn7OLlCS8+dx88aJWHF196VYZuIW1XglOXgNqFi6o2o3sb3bHDoUecyn09A6pGc9YL6F//qfdqIZbUlRZRkjTGlDhAzXHXd9ficuHC5bR5y2aBYUlbUeqyeyC99sqR9PyzL6WO6zJiyjII6gLcN/oQsBsPwIDXxjz0O6svsp/tCfewCT5cCMOXZ+tJHl8pC42NK+euIrrgh9XGA8/Qd5b3M35msQkZVIGG/QK2Rw6fTifPnk1vnX3Tcl/XuxU6lZawuWumRURGLxzHXarq8+ijD6b77zkoNYTt4jyLlywvl5NFCr92FUP0TgHnMmC7wrXe6XXqEhX5GaxsSNy/AUrlYcsQ1GDVwLZqGeJvJwFW3i+bm9qRjWg036MX0hVRbJOOqGxwPGyWtSe+Q5Y4/Pcr8ixGguJye1rOvswk53sx7zB/7zd//X3p5ZdfN6DtlXcN8GgFE+upkrEvIKi5SR9clYdzMWvQBpuTk+AxC8PAHOKajD28h7YbskHQDgCCeOc4p8GfbEIp3hBKHvpiphzwONhMR/g+xj9AG7DHe3gZuU7xzjrHgO9apSEDkzyJuLbD+9hi7oVwtECLw8/QDgCVMqRwfAHeyHvh0cMOYbsArXhUOS/UB14UPiGpDG1r0ySgJOjHES0DVQorhIY190kf0AZsGC+DvvquKuwHbWHDST/bS65NhIAWpWi3qFLYvQ88IIfAtKNk7fA+UaowmAW3RTVHOsvDUefoUJ9dVXLx7KWLksialY2Qo2HvvtQtJ8EiFDCuQZAO+kPRvs7gvYx3J7UB+jD0zJU8b6IvY15wSx2KmrWJirY4pURWJ/aRWKjnpAgepX9dVkH87c27d6cRqbLMyVtKv8xRPEhtgUftmUsf6Zxdas+eHVvSvBwg58+cSQdUSGJElIQrKnLxHz3zqChpk+kP/uhPnfRHGWcLlrHJAdzqur0aH1fkBGrTc+oR1xfZMSdPezyFZ72MCSg0tYRi309QMkqOg/eBbLbkrFlsmxt88c/fL9mhH52XnuEW3c1/op8vrQlsl3BsawUa6gZoLZ7q99pru9JjaQXYlsXc86f8LFkQVjbK5TtLPLYZ/NkOVRq2njXh+znMlixyZe3KDW/0BGMJmgHbpStexcPjG8FiQG4Pg04IZlHh/llNcsInePiYeKa5cayNGokIocfoLNOceRrgNHhQzloGzmQAHRItSE9p8cEQETqCfuCkEH5igaD6io2fvLgGtoBdtzNu/qp23BzDzvvC2TEZ3tPyohJaxLOkzOR5nUNJA3cd2Jne85NPSWMQoW4ZfM2Ls+fO2xuzd+9ue4mPHD3uet8HD95lybAJ7bovXBxThvG0wOxpZbACzAa0i590GGunSsTu3LPdBm27JMcQrmdRuColAZJr8Ow+8NB9KjYhICBO8o5to+n0sYvpxecPK+SlkCTlOFmECa3hMSKd9jqJBkicxILnvX5eLBnmXmhz6M9zwYkJsTDRkBIy9YakNqaDhxvdVh/Z9uxVqAglHB6YGMDABQH0ArZSRcBj+/arZ9IphftePv5yOjV+UguG7LYqwBE+dkJG9t6g1XlI8l4PS7v2Hsrpjm6VJqQWbZJz3E7aG2G39byi+a3NzmXzYYULefNZ2TysG+jWtNfWALY1mxXP1OVGy/No3LzkfilUhGrTPR441yoAekkPtdBdS2xfgz0t12YMDYuDiIQk4fCifJOn9NqPMY9fIGnZUP3CP/wl66QCjlAwAGgww7v0N6M9uLFtBnXwFOkPNGbZ1RaKgqX99H02udgDBPAZY2x+8doyXvCKkegUnsqbAucL9qwBPL1Bx5zY/oRcHc/GHkJ9z+FynQXvIkAT4Mn5oipiJKSycb0indXr6M3q+ySLlc1l0B5Es5DNiBKpUmXQ5tqVvQR4rLDChh4aQQbhBql4Az2PoRXA86VwQXj38dQCDkuUJKgGAmXwkbOB5hxwR+kbQDNewrj/aFqR8zI/n96GFqbrcayrNiqq1ScKwj4ljI1Id/bFVw6rJVRtkw1lDrP58Ymiv8oQdqxOwHxaduKa7B42pHtoOPXpHOoYs1K9GnhDzv2VHAueeESx8H6j0EBYn0Q9l1H2uCxWrWzA5bFmnZieSAs69oYALvQEztQtahm6uzfFr53S2Nii4jA39CzQLuZZ44wYFAcazVnaeAUtdo3Fm6JN7N6+Rdq7V9N5lQmGurD/wQeUXDyfRof703uffiL96//r98Qzl4Y7z83ANjZBqCOE1GSHHSp98na3IzFJQQ31a0grxmyz59/9HvJyZnPQLy7KgyqC6AdEDVDSaO848vyf/7u7155kd9YReqZ71OK/pp/PtA5sq5XHGgznarf/gwC2jRzfldpXgG0Z4ut9jM2+V0Bt6dgW1oE1Lmv4UTum8XwrrUet3MuSZ5MNUkGv7xTY1tZYICd8MYTAFYJfUDLVdU0wFhNPzFLlimnpUFQJzYXR5QVe8jMlrJIXNPeJP7c4loyw/l9eB/QatSIY2JoHxsKt6wfnK5LIrgl4Wi4n96zFtQ1uwzjao6tjqJ4zOT6TThw/r0oxY+K4KdO/ozfd++D96ZmfeFKhIfHuNkrYXEbjMtmz4nyS5Q2Qg6cLp2xmei699cbbrnBz8G6V1RXfjUTMjfI2kGBCiPDw4bccSsOjMKUqTHB7XX5Si2+PFgSKTpxTstndh/alfQd2h5dHwPX17x5Jr730Zsi6sEB5lw6I1YIk762CsAa4TirBC5U9uN7h07FlMBVerheUbPT5nQ/wAl3r93gm9qqUh2z3h1fz/Fl99Bt0aaU314vNhP69UQUa9j20PR159WQ6ff5sevHoS6o6diZd65IhF7CtawMH26xfihUPPfSgqo0dSnfv36PqPsNpUBqohN6smMC1MyewlXFfjlkP6CyAtTpn1lOBrOVrsRHMDQz9ipUtiBd0Pwx3wyrANs5RA76xpfF7NRvG9GoGQjPwXdEArdXhKwBbOKobNwzYW8t8MB++tKoVo9YAbM+cPZ9+6Zf/je+slxC+zodnlOIL3JdD+qYfhCC/RfsBZnrPPn+HaiO64RC9zo+tMB2KpBuP+RDGD53p8GLS5iiYEjqtHAQYNN7IHkRHoXQMXk4nCpGspJ8AteGhJTGoFF4hLM7xeE8BmS4ModORyGbPIoBNwJq/r2VecABO3R/AT2A9OL6UzqUCGKA7vJS8h/PACWG6bypuERXC7s5ZqQHucSTkWrpKVwaE059MYKQV7SQAJNXsc/Dp7TFmAxuXvgQAACAASURBVIF3m3LoFHSAW4vnWN7OYZXDPijN2uMnTkjVQRQEnQt5GTYn1+2iLMSX6ENOj3jVgnR25/VDOZg2lbPtFMDsEoCEvmCgDpzNtj6cFMH55X43SknF23A0dMlncKW3Eo2qD15jav0TXYYFAdtFqRFch55B5E/Pv1uqOF1KIGtXbsS0ogyDAtZXdc9wo4dFk9qwYZNpL6gR9ImLfVGFHcZU8lcGPvXp3raJezCpRGRk1h5594+leX13Xtf4mb/xE+nPPv3V9O3vvJr52xnYZnod87pH/cc8Gdq8NXWQDFYArcdpRCQZi6h6RPKixo8TdvHOqn/VN3jkoxKc1pOr13//W1/4nf92ral7p32u+XCf2vyEfj7aOrDNqghreWgbO+OHBdiut93NHmp1iVkKN5ceXcBtWThu5wB5J8C2fLcGO/KiE6Bx6RJaW+Tyl5qrPNSWonyLlX/nKgOcGw/ivACtQa1CgAZZLMb2yGXwahMaRA52qK6iw0Jn3pGXFXtC3LcZfJWdNwaJnf1VGSKyURUodCWXkP3CHucELwNb+Gpw1IL+EKHcDJAjAuY2GODipZDXhgSzM2cmldl6OZ29MCOgtVWVcu6WkelMW7ZvkrdV5Tp78BLFt4c2SmhdtAg4W9OSFjv8ymv2qN5//wF5YmWYBVbHJP8ydnk87T+4z4sCixiZyxfOS5RbNIMTx8/p87G0S7zc+dlFeWyPpA1SARgZ3mjKwU1JiE2cH1fxhwmVXezTtbToUozWN6zNgRLMrl6l70P2JjsCYlHkP31ub7qX9eDWxhwJYFV8n4a3eZH2Y8iP2LJFAGb8wN558L+c/JAXvOIVsVeVhSePkg0qqbv3wa3p7dfOpLdPHxewfTFdnBWXTcDW0kJUfcvZ6PTbgIDt448/kh64/x5pDO9SeUp5bJS454x2nh7XqwGzlYBg1dTVZ0Ldc7PKLM2HV2fIipvnFS7fOrCtt6MOPZe2jfeL/ak/J9brMlmXIsP6XC68RfotqypUjEJLwHaZgc9vNHRv9Vw121uxMdBIkPua1PxgMY4ojFrVCqjN47D0Ab+//vVvpT/6wJ8YlDKXAIxs8gASAFmXzNVm2gld+MW4HvZBZbb71RYAHcAU7yu92yeh+6jyJbAjEAkomlVousgmzZvDKQ+fgAPhfCex2nsnQE3yo14z8jAC0AATpgHpuoSteZUyqHiCbX5JIFMb0INdlA1jgxy60GEHTQ/ST1QVu6okMWliY/N0PB7J8rLXzu8DmPkNPUv0B22oQ2oseMLxOdQKaWpTHljHzEjvlrZ2Azh1LewpzoHY8AcdA2PAdxhrRbmBdpmeAIAGqOIBdzJW8IA7RR3oU4LXvnvvk2JMZzp+8pSdGDdzhM4A1fqzlFlGP1eA35rmSszTxmP63Bn0yeSplsqFeLqdAo7tAns5s8KKAhGticgQtp17J6EMreJxFZZADQKQaHmsxjGM+cD+6bsSNEuLAtGLM/KgoruLpJbAbOeAqruJT4vSDQnF6A33aoygdEChjPMXL2tjoIIYSi6j0AaRAwpV4MCZFy94nwozXNc5Lyiy98R7VRxLx0xKEeKJ+++SQ6Yrfegjn/a6dE3rRskZcR/rXhgrRDU2qSx0p+7HeuJ4YnUfcKO5H+wlyYLcNxrEPF/uFY3bSHTUhkxfYHwrifHvvvqND/72KhbvjvxIz55yuvv0LD+wJrDVgV3HT51/R3Jf77SXbgcofadtyLa0dpp6xzVOkzDQTabPqt6X9bSvBkzX8yWb83ittHZUF6MqsPXxK3heKj6ffPYaCvB3yGYlWWpWnKrrmlRtMlRRmSrz2gAneDtYZwAphMydgED4LkBVSXagT9l9RpnX8CJyDUNiPDIYYu9WETYP72zs3AMKRParvA0AXCeIBLD1ypKBXQHOwbcL6sMNeT0XpTk7oaILx46NpWOnxtPMgnbr/SM2ZKgfDEg1AeRNBvDW0WHxY/slEdaXRndKdkhtmZuRAVIlmhsyXCxElMk8e/qCqAt3KUlEerjyXPcp89+11EV5OPLWCZesvUdJatAjvvrsc2nb1m1ps7QsD7/wZjp37EJqF7ilOlK7XLFtomHclIxMWw8eJvR1AYf4H4K/Bx/PFdrI97imu9T6SvDKkuJ4eNlM8N/NCK+WRctUWbyh3iSQIBaLgF9GvEaUsTg3oQJE34c3zNBXx2wQN3nPg1vS26+fTm8cfyu9/PYrqjomeopoHVQYQ/rH0jZ4JtQvA/KUPPnUY+mhB+4VsN2pPtDiIZmvoETUQ/+rg9TmwLY+K+qTaRnAWwXYNk5Bf3clbL3CfG0Z9JYZxjXyZrQKbGOOxlhufl/Fox78x/wQm7aq1TY1c1yEXFy9E5oB20HJ3/UKbF2W1BevGse2tkFZobPK2wXD53+///0fSd954bCAkZJ3kFuynitcUrxueBCZ9/LOsnHKnkVzSvFs4Ymk3Kj5o1Elq9gEynYjP4hyAeMYWgDqBnjCOvBu0tP5kRPO93E6H+AODy20AniaAIsheRmhHTE+Shi/PRc5wYqZwwqvUlELa9DC7USyCaUBgGbWqLVtzE/YHEvAsT2m2szqe6gzQH9C6okQNdQLe2yZ+takDvsanloqxyoplUQwnAwGf7nSoiNXUTkMbx/HUBKbSIl1qnMiXtG/ps+7bNsB4NQ0V5tIahIYG9m+Pe3Ztz+9+fYxPQeND11jUJv0aak0dCuZapNyGACiQ+Lhnjx2Mk0JjNo5ITs5qepspmAI1LYDbJFM5Pp+IrFueD2pjbnw4m6Vcgpg++zpM/pItk3PtkTmbI2yHeMZ0nf87rom1QVVorw2JyoBHlvWE6nXdEktp1OyX9f0HagjQ7JJgNphXeOM2jeNfSdxDOk02S9v0Bln+v6MgPI2ldOVmE46pWINhx58V9p2YH+6qITlTT030rsffzy9730fTWOK8jmJGlkztzVofDTT2sSKRPSqDYwZawezbhJ5wPPPRoW1U+9RTc7OhrzBwS4zpO1p91xov+/15z/8+hoz7I77WOPub3DTeq6fXRPYwrF96fCbP1Bg29jDtxPolsSD1tei4tla/tyrC6tDtTZ6EU5cCUzeyui5VWAbe/l6W6qLUuNCVvuMiVVp5JLjsuc0eEFhaTPUib/h1SpsM4fmIskKmuTtArbhqY1QEfDKxHnOAQ2BBCivzeF74DxeaOw1iMnqqj1l7fZbJszKakfCmKNaAnsGcvBoMyiznJhJ+lGWl8uHHzHusMhdxe3STyEPk50B+ht+3s104dJ8euvIOXlwJ8TBk+zX4Ig4VkouwCsir6tJ+/Le9ghkblSi1MCgds1IgElN4er1BZfyfde7DhqAXpFhn9COfmBAXpc2URvMrb2Z3nzrmLy1W+VBwSMq2sEbJ6SJuCVtVEjvua98J505ckEhrt60ES1FGcz5eSktyCjbw4I3GsOobutQecc2gcA2vKBaiOEb4rElk3h2XkkXkpq5Kc1cuXqVxYshhTpCf3vwEqQN/JoXLP8Zjzo2b7WJUx9XDusadJZXAKpINJFHW32y5+Et6ejrp9ILh19Mr514Lc3eFKdQZY4DzKq9GG5JeRF+HRK37Okfe0rA9h4VZtimwgwjCgHCESwjc/nsCuWXsvzHnPVc9MOMMGfjqyUw17A7XAZkm2PKJUBv+ZVv/Z3mhVJWArbV66zOR16rL6ob32atL5+X305MrBwIDQEwAefccy+DwyrXd9U25JPZ96zn+gv/4/9qXqMF6gVmALfzijKi+crc4/0iom8+st5jk3xDoXyiPfZmQgnI8oKmC8hWMP6oBmVOro5hsxwV+PLoMhAmGx1OrsLOaITKWwcPlvKmAEMShSz1Zy3WOKeBFJ5KNot4QOWlnFLWP0+OoiMzKhVLhineX0CyE2s9+QLoMr/wQPOiMIX1au0Y4BfJXdAsAszA/ec3cx6OZVATVFSCUrh4b/Foy4gAlgBG9J1lyNQuHAUkr9JWMu1RSaAdkWgKSA4ufCT+6j1HubSxgL7E5lpt7RcY268I16y+e05JsPBpURPYvmeHgL5stq67XTkGw5rX6OQe/u7LogLMyFt7PU1fvKA1RHxiAWS8pR2ys53WZo3S5Px3HRUc33boecNzRWGAjROJcGdVttvb+Nw3QSGSDWC90QDCJ85nnLFDNnR2/LIqV87aG04eRpcSxzoFbLn2Ddmc2HgLqFKuWN8DjG6igIPGBpSBTo0BwKcTdXWtBT3/ftn2TaJPXVAC2UYd++h735MuqOLe/Mxkeu+Tj6SvfOWvVMTniPsZEMv3IkLJeofdVOs0Fro1ptq0eTPoxROPdJeeP0d2SLVhRmMIOwunmMgnz4uy0awF7fqtM1964dk/2nrrFueH95uaSz+n1h3TmPzmv/fAdv0gMb7RKrj+XgJb2tE6II8BWYdxvovaGZoC2ypQbTKeA/tgWuqLZAG2clIabE4rVL6ArJcmmJUUXV0HCcEAGF4gBNzsrYXfxgTNHlvvr+0NjBxl3yto2PyBWAkNn+AjsWPHHWn+qAwUmcwKw+OhLV7b8NgGqLWuoU/BTQYIC45b+Nrjd+be+XIBFrlVrZcKIy2KnjCt6mUTCqei0TgkD4m0bxUmc1IHiRk2KIA8/SaxS2Vz2qTV1dF5UwliI971k00LQNu1a6s4vNNpyzYJscv7S8UcQrWxcLRL7/WsPDmS/hLofP7rL6ZzRy+qYK8oCLqnDhlN1jWO66eakQCzuXzyoCwI7M8KTC9SvcgLOsBb/cxiTeayOdDyEClJTgK86kcBYXVM9oWy/3UIyxg290N4t2M/Ea88jrLHxGMsA8l4ZEtBFKoIdz08ko5KfeJbL72QXjnxSlpol3dE/WNPGMBWfdYFV1D3s1mqFE9LGuf+QwfTPhZA8eYAtnXsvBawjY3S6h7dGMvrfbXqob2Vc7fSliqwXQFT106z9PZWAbYx0erfazb3y8lW6LLq/cYcXvqMNg8rw1xAa1oZ3x5B+TzrAbbF1hxRdv2v/vL/Kc9jlGxFN9bcUWmmWgYrXz+0siWjhGwS81nXddhcQIzPkI+LKEDwRFFX4Fg8r2yWDdg8lgNUucgC/HbmRe5OUgagHwD68ODyQhIMTxkyVYMCQ8wpgDLc2ahWpVAxm299D959lNMl6Ycy3NCJCIdr3lrOCb6kQKdLiUf+AvbLpVSxxYBgXZPv43E04MneVfoGu8ex8DZpO0lq3BfJqiTK4eEGDPF9vM1sEkjw47q0M7BhcGpLUh33WJwCN7A5CuGTZEXSJ8B2+65daZM4qSflOXWRCvXlqPi2PZLMMt0DOodC87RnToD+3MnTkIHTDQG26bFL9gK367Obeq6d2ti3S7otttGx9sCd9vji2eoYPL+U8YVrzLOfkgoPsl/Y78JzxrqHk0cbDTY0rCEo7ahi2JQ8rNAgLHWmZ4UaQsfQJtERBhRdE23DK0NEAM13tVe9x2saEBsHAg6OSObVs9R5SEjbQrsEcumfn/rpn05nJBE2JTrCgT2joktMCtx+wzS1yGnIYJtzwndmI6O2Dij5rIcNE84Z+NcaU0TnoMtQUQywa21blDH0byrj0U8LJJtFlOG3X/zaH/3dVmzLnXSMbIwmVvoZ/TyvsfD6v/fA1kY1J8KslqjR+JCLR3ath7++BW3lhbVQGxqXcBuapo1oZZF+Z8DWy18DsHV/5oXquibdpGSuFkRF6CCT2DvrkMMp/NaQeYnEJ0Jk5mRhEAiRZzBVjaz6/jnWq0nWODRlAC4Zmc64KYLDS0WdAmzjN/8OXBzANiesBBLLwDa3PwPc2pjIfF2AM54cEroW5qVPO3EtnTs7LQ1cJRwsSkxd9AQALiAdcIvRZkFywgIRTocEAfGA3SjHiGEEqHHLvQNdqp2ukJyqm5H4geHeIdDbJ83cXlEWkH+5cOpSevU7b6SJM+Npm+qt3xBP8OpVdDi1ACpUeENti0gUrpVQMcBTOyCOGuErQp7z6GXK6C4CYqEi3BBtQSoKsW8IvrNBLVuKglv9ZMM7737Jx9W9oTHmmvFPvTEgpKl+GRjpSXseGk5vvH4i/dULz6c3Tr8uwXMZYtEp6Is2AXM2B1SYY3HcrYIMANt7D9yVdm0bUaKGvONadPN+ZNUpuDwqsfa8WM+c/WEAtmsB2mYdtKqCBFjJwFVnzgYnM3KXnarav+XDalJdY18WLjfAFsDED6+VSnSv+CzyY6R5n/j4p9PHPvxJb9zw8t8QnQbAam6rbUBwScu9QAsghG9Kk8YlQMDeSd0zXl6AY1eW4bJ8F/xRZ+sHrcdgxpJYIZ9XeOZ4AK2NKxCB9BJzj+OC28oGFMCMJqxAGkVX8KblhDBAMIlILoYAcLQHNqpMcW2oALzw0i5S/lceZ7yj5vQKpKKFDTiGX4mXkvthcwy4pass/4c1AcCpn0zT0v1ia9lYk8TK8VEKW6Acz6xtKY5XpLIyFcmhsqxGomuzIQgJQbzFAbbwDHeKMtChdg2oWMYu6U5Pi296GXqBPNMA283bt6UxRfKwk3BSaTt2ycCMdunasxPjivTNGKy2AWzx2Mq2QmPIo9P2sURiaIW5+Woj980mgoQqPJoAQMcD2dzr3CRdhUKO1g0SAlGggX8qCgWe2tBOhxYlSocSw7pUlKGN8cR6pQsBLEuMqrYmYe9djxcVAlEnXLJZw07nm7pwLo3oPrnWxQvn03/xX/1cmlCfjwvYDgqA066vfvkbEUmw4yU4tFAZTEvQe2y2urUZ6BZAblOfwL+lzxgHpoFQIIhoAHJ0cGr1voE8VDK32X31sy8/95GPrWo078APdV+71Oz/QD9/IRtzfk1gqwN/BDm2cdu1m695l1YDlvG0a4O5wQNxO8bCaotNq0C6trgs8z6tvqDfisfW/eHrLPf+4IGZ10554sIlcWsVSpIxhl9rORYWA4w93zTQK4liLBJZwxSAY49t9v5l+B4wOD87eFNGYujZsssFPMd+mpeVD/gYXi1VfQxuAdEBLp3py3kNoCNc43FR89pmkJY9vPYP8zcGnQQ0jL31b9vS+Qvy3r59MV2+uKDFZYu8sZuc3S8LZJ4o62pgTcBC+EPts/aiF9nXAF0uYfCrOFSUAFVpRQl898l7y++NSkwbkHfg0pmL6ah0bIdERejpRzxdx/WJ+iCB+G4Z/nmF1CbFa74yQy1yJa1ckVbovIyk+LXcdxsyRlq8OxW+GuzSOZQgcdMi5wvpCosk3Qm7Q+8BRik6QRiUNjtU5vvIANjPafn4qr8XnwES8BYDbPc+ukVJdUfTs88/m94+d1T8WnmJdPsO/RLq0wJI+c0BKU0cuv/+9OhjD6kww840umWTQoDivFFxbJ2vxvY0fn09gHbJPFsbK9+SN7iV21urzdWmNffYNoHF+lK1d2OGr7B9zietemQNNBhjFa99uRfeQ2pqo6ISVzQmSzLVuoFtGGO//pd/8ivp9MmzkcwIPcVheOyA5pY4sgDXQge3N5SCC67EBB0hU5XsMYXrH4Clps6Sqxi6EIjmI3YEnq2jS75PzYWclIoKijmpAntwdtsEUpg/gFE2pC4QgdQWiaIAYCeORfIlVzWFyZ5AolrRBry8gcnjOXFe2w4S7rhD5ibAxtzZ4NliewGcqJFwj/Yq00yAsO4h6AdQM/DcklSmimSU5NW9opPtCmPuJwAT3uIQ9UdGKp5p9LsBOOCda/LvTGu4oWPhwcKt3SLPbK8A5vnzohTofHiLCS/1C5zNCnw6uc18gLD3wO9uHqH65opK5gLOoHUAKm8qYnVT3lqbIq8LscFmDcjWVO8FPYE+xZNpigv9rvvwugGVRJt6eM/Il5mb6rWBinPhZGAM4WRB4WBI9Ah4vdcBnPbUh+qx9XptAmMN8nzhQaFkYQ+/nBVQB9AZVn9OnDml+9ImRMdcEr3ip376P0/tUsa5oAThDsaL2vnd77zMUIp1MXOGWddUjNGawjg6sNn98trSv/EcQr7O/WQVDWxsqHIYGBc7rd9opE+1Xxs4861PRpjkR+glm/Mu3c5j+vmw7nlxTWB7Ozi2vsg7AoLVZlafRgsrSu3w4Nmt+2VPYvGXlhA6t7P+hXWta99+YFv2tVx5fcC2hPpj6mRw2QBe6qHduE7V462ocppReGXi/HnTEDrlTcWjyuIR2kSZI2VwhGELwJmvlo1peClqljTbjlo/YlDsmsRTq3Pa2EeubHDA4q7tgTBYA8zqMDwLWR7GnM4K0Cxh03jm2TOce884OC8x3IK5b/yW+gDezitTC5L2OqsEAWkgqmjCpg2j4t8iAxMLENfBYKJTGNJAUVGtU0llUYAiwv6masCVxXtirmyA3i68uiSJIcKrn15AKpneN2Wc1QcKVGrnz0LQJj6vCjkoYYG64BvEZ9ys8H0/i7E2GJcuXUqnqIQzrWSQKzKqLP4wb+1hklHW4tHbLTAtb8WgxMg71c4pVdeZIjSoJDo4wHiU4vlnj643J5lHae5dfeNYEtEYSE6OGe5K+x/Zml5+7Wj6yjeeTScuHpMmpBYe8ZLt4Sb5TYtZr7iGwypK8cQTT1jqi8IMW1RxrFdJdlD61gJ1q823leZaowdyrWus5VFca86Xz9e6zmrnKaBwWfENL/j113qAbZmJEZEJ53+rr5oXuwlm5hx94hoO6Idqf7Wx0XDyZkC3WR+dEX/yn/2jXzaQMbDNChzdGsOI3kFH8qbRnjY2uiFqj/cU7yJzmqQovttFKdo8JyOBLANEbITaZ+8knl39VxK57CH07jm8q1ynW2Fo3gpKbYAsAJNBMQUJbJOCTgAkdKjZ31HIWECW41EHsJ4r3jad3B7U7BE2DuSZYN8Abvo/ACM2xn0Er5NQtAAcZVYtvyXbiPID16QdYedCL9Y0B10H4ATvllfRxC4V1opmbzymcBjEOZAX5B+EzAUQSe5VZKhdwGuD6Afbdu1Olycm9KwnXdaYTkXlZN/dB510dVERvVKYx/KPag+FDW6I4wo31XBXm27dSGpHEQDKhf7D7lpj168oDhMwN9pCrgWRK7SAKVMMeGXTQV8TtrMUpL4R1CddRT9sTGgjm4FZUWTwOA9K/WARL7ruE/WGoB9kIA94zN5q593Bg80eXVYPPLZ9bKD0HC6fOCa610zqVf/DiX7ix9+TtqnYzFlpm9+A4iIKyDFpn+N5Ry2C9cDrGPafQap2Q69AVWJA/UqxBo8NxhheCNYBEg7Nu8YZEXjHspF0jf4W2P70S89/6G+2Oo/vpOM0Fn9S7R3RPX/ct1tpfB1VOCjqHyUCrj95rAoga0Ovyc7+nXdc3XJmJVJ7FooxL9c27MqTYKlsVetgt9pR5fwZ57zz21jrDLrQautKrR2V4/IUb3rm5tJdlUPDaoW3dK222cjlcFDpY76jyTYnfu2EAFQb/J4sGm7PqACMF0v+H2PAVTAeXJbJnBM4zHllevvgssHgH+ExNJTifRsyjB1/51xZc2JL2UikeKImuG0E/KS8KtCevIYt8Ts7kzTsQZhM2pcd0+aT0YrsreGkTlIT2JybvaFQ04yKMFxWPXf4fPLckjjWo2xWeW9ZIoMhEJqUsaNWo3AGZyBuI50BBV4Bg1sWICeSaGHGM8NXghWQ2xcqDuHzIfQEuDQDTcab0Cr8PRlaeXt7RGlo19/wwtDg7dZ9IK8zKS70hDhuDmsqsaxbDe0UpxeqAvw2lC1vsMhI7ZHCEVclb+MkrQwG7CMzlzUSMri/kpRD+6Neu1QhNnenA0/sSC+8+Gr6wte+nC5OXRDfVx4irVaIj+OxxTMFFWH37l3pmWd+LN17cH8a3T4ifu2geYh0QACdsAHNvIONQ7cKWuubspUH+HrBZu15+vEVK1EeUJPreNizOMWx671es/truGpeeFcO9a9092sB/9XMQrkfL7y2JUuPHpK3lpD9hBLHltjVZUA8z49VLvaBP/ho+uSffMZzAk+qi5LCfVUkgnlwFWArcBFRBspVs1kO+TnbjpjJPoZ/eeObJ7ptqD2cUcwBrizjk5D9osBKKUEbvP7YCPNijDtPAP1bvWXFBYXnmZ+AZyS7CJX363wYHagLReKpFD+xFxQ7qH6irXhR3ZeAFRyD2StojzfzzVGVgnQ9mtQftFVZ+fLosTmNJK/2GucXKUPfd44MAfpMvdALOgb3FfMZ21J/CCSZOWpFZ9mGgaeiXDHSV2yMu5VstUNFDLqkcnDiNCVjcxt1/L6D+1So4e70wksvyXt52c+O65DwxlOAhrBwZVIOEXmrcQTI5rTD15U9APRhKEnSA/AVPjBe2WuKUrnqmugErjgJDYWiPNlpcAObCO0LSoMAcqeAq9VXSPQiUuSkPrz919O4ADcqDMhr3RCo1kPMNAGGD7ghNkrOgeDHLlI2Q5lKosOgkIi8kK4pOfjySQFb5NRwCKjbHn7302lURWcuK6p5TRSIuckr6bIS66ZE23P+A+OTS3ld44FIB57iI2rzhtHtrkRmjzlrAeOZMSXge12eaMY19BJTThibOW/h+uKNn3v95U98aLW5e6d+prlB4thpPY+vcg/fN2DbaHBvTwdG8wsiL2Ap44/6ou+xmEFsQSf5m7fkxc2N/+EGtg1Pt9rhS/qgyZPIwLZxQWr+zDKwrXzop0KGqHRaDWzxZGghAIDinSW8Tr8XuZZC7yinKILngN54Ptlg66/CFbM1N/AOYAs3ix+OtY+DUFoOR1oFwZt46nHXF/lYuDJ4BWBk6x04OnQna3xRfx6jLcPt+DfXwMOQYbHrusurOTcLmFS1GgHb6Zmrku86my5fnlGWM8UXZCT1ExI9kcxVYqWGzPC39MN16DHzjw0aIzwJdo/wZLTE/gMD4EDG7k/uy8ACzwS7+NgQeOOA01hrbrviXz3y7vbLE9yj0P5NbTiuK7kNb1GvgCPg2cLmC0rykSdpTmCXhJob6OMK2ELD0Jd0Vv2gnauTeruBsoI3RnibtjnFNwAAIABJREFUg2bie1H70Gns3SwZMwHb5779Uvri17+SxucmnDhmC87CCO9Piw0yag+o/Objjz2S9ouGsFUlWIdEQyDkBlWjLLb1kp6tg8NWgC1P+1bB5lpey6WIrj55bvV6rbR1PTb4HQHbKgpqctHNIxscQYGKsBqwXWuNYDz9/b/3i9aX7RL4wUs1BxiC045sHeBOgMReR/8t8KLxiFyXvZw5jB5zQ15Yb3xjMwyww9tp7ysbS49sxnJszhYEIIIfGyAQsDcg6gzUAeS38MwGFSooBpgHdGoXqL4oEIJX0N5apMMAnMwRASVTGPRfeOwEzE0ziGIObPQAnnPSQ4XaAK0Kz7EVEUhI4zuAROykbCx0HewXRSqs7eviDESIRM3wZrwUrQkuPwoSBqhQI/wT3mb6xlXVTMWgvcFHjoS/oHLgraUv4MTflNdz09ZRlQ/fpdK5k/bYmpaV6Ru7VJ1x/333psOvvZ7GFD0i8QlIi+OBBK5O2az5qQnzXg14FTViQ4DqDH0PlQSvGyF4yiKbamZpLpQsQgeWl6sxepOM/JZsiu7bP3h/dU2XS+ZespeV54ACxjV5radEgxiS9u4coX0K5ghQcj6H0wCyjDHGj/rZwNbyXhH9c4EOnoH6hgpmY/LWzly6YK+x+dX69HF5bDfKps0JiF8Tz3xGm7ypcVH3BHS9LsIDzmuaObbIQEoqrkO0jiEB25um10CDUHN4Vjr3otoNwIUSgk10QQ+3lcTCGzMLk1Nbjh37IhmFP1IvjUWFRROe6Oc0vt+IVbr+KviQ37fdY7seo9pqr9cznSueq3xXtcW0gs4MUv5/YJv5Z6v08i0A28aztWm3PKHqKxPiVkGeb3dpwvDgWQqKnS0T2JM4Pz8Aqr1YRZ0gA1s75WIEYehqXkq/B5KjqlbQEsK7gFGOzFIMsMGsFgFnxuobEeQJL3OZBOa+5lcASfuRay+ONITkuEC+Ydw5AiPk82VQDR9KYLBd4fwdO/fIMA+kL3zphfSnn/5iQti9U54Uwl79fRvTRlW02SDvBgshizNJIYB3OFpUF2PBQtsXw09HdShMz/UdivQiFh5Sc8x87xhaLZp4wt0+7jnfawHmLLQAYcTAETzTb4CysIC4ZPIy6+9uuYO7kduSZ7eD7GJdtkvAlzByPwuDzkWSyLQqq01MIUZOfXpdy5Ew2oofgf7SQo3XBcCg9gNs+7Z0pXuf3JW++vXn01ef/1qaWpSXAsUIhgUcQi++HWnvvr3pscceS/cpZLdbesCbNg0oOQ+lCJpfp744DJifVKvAsDVgy8agbJNbtUqVMbMGwGt2xlbb32prql7qlXiszdux8n232sZmldnw1G7cOCCwNa+wuza71TnGnGr1xnQcRRl+7d/+bnAw9UWDKwCsxifgkfB8zUQQzbB9icQpABBtgVNKQQQn7OiWAwTEhtabR+yHxm3IZ0Wi2VVlzhOo4PvougI+KamKtxCQg7QXnkJ4rLWRqXNQyIHqXlwb7dFrJEup3a5W6GhG6GajTuDEJn2Hc/uedLwronmzDkiPORUyZgGG+a61eeGW6sQkQvHdHnlQAbYGqmofIv30Cx5oxjeas2jZloI3XBePsedVsbvshvWC1sB3AJPYGB6gvckk6KnvrFur8rM7dkufW+c/ibfWhpvdNF5O9c/GwXTPA/e7lC5grV/fGZcT5OxZrRWovIiy1oZ0odUAIpl0UcddW5BHEiCYVSwoZxue8nBwWE0lg1dXYzSIledeQBuvpW04tog1CFCbbf5NJ8RB51AUS3/OCYyiXjAgea9xgefBzVtkA5FYi2Rf0xdknxhnbKJKcR3GCNsV8jyoWjYmp8646Baz4tRel7cW+409vKFrP/WTP5EGFYFy0RBJhJ0/fU6ycALqaBnz1Ehu4/6w7dAfTEWQAoKUdIaUeAclwcA1b0IW5ekF3LfTf6asRMKiC2swrzq7fuPIi3/899cxve6YQzVGD6mxT+rnTzVvJ2j4bQe278QDWu/JGnRZtXNX4rnm9TtsSvUOOVsO+5UTv5P2NhrhJUa68brvZJg0XKgRcPnUMTdrr+oSUfM6euEwCqq9ym5mSfMyYGutZGh4bBtfhMmnLl9Ol85KQ1CG1HIqcKHg/jDpaHDeZ5THZL0+NS42LCxCISReo5GwQwUcY1B9u/naaq/NLh4XJ0iUCuKxKAH2oCUEgg5OaFTyCa+EzwTY5q8MWMPzG6/6Qh7hHfcZ3ViAi8Ca65R7QQwwSUGHGzLII5Kq6pFm45e/9kL6wEc+lSYk/H1NDQDImqsl8NotQNuNl2NAhR4U/mKxHdLi0Cvv7mCvJGYUVu3M3tC2GzLeAo6xkOHkzEDfFIwAwQEmw6sSiXl4XqJKWPRleJFKNaOM1LMhDH6WgbOl2ThW/Shur9cxZTJ0ycvbLcDbJUpDT3/weJGVie8JOIiiMDl2Jc1MXVX1Jbw5UeaXdi1Ieqx/K8B2T/ris3+VvvKtr6YFLWTQEPDCgiZYPNAApYzuIw89pKIMlNHdpIQ8eZIFsquvsh9pFWyV77YGbMt+aj1wqzIHY8ex5qtxTq75hTUOaASwHq9sJKtAu3oOpsWyc4YFaQY1W+nrlWwHIK5fHOkJlY6OynVL+6uF7qp9Ae3aM2dUqMQjO3BKj6IPC/Ap8WSySVRkBPAR1IMY23hmUTeg5K61AjIghFJjebDMh4WzCGXAx+FtFAXBbdaF8LgWAEz05ao27nAnBwiXAzYKR9I7xoi0uOxtTnBzcpsBZKgblIiG+a/EQEjuJKqFTTFvOEAKICo4sZFYFpFIrhGhfqsqoEwAWNc9U7obVYErohlxP1H4JNoSNCEAFIlTkXXP9fldqD1h0yLCVuxwoUvY4wtw4vsAamS4BLiokLVn714l1F5UAutU9ozypPGOqt/E4x/cuCFt3blD7VNFLl3z1KnTklAMakqn7OmoytSSaLUgMEek6JJyNcaJ/rnAj47C1lBel2ej4/rlVW2Hv8wPmxD6jLMBaEniU/us38tzdHfFOuNNQfbc453vUGRxWmW+HQHUuSa1ARvZscMauga0eGZ1HN58bB7jAM+/k7v0/GeUsDsrpYM50Q9mJsZcPr4jc2DZOF2X96B3eCQ9+p6ntS5IJUE2dkzVJs+eOuONXuFJ43DAO20vNmZEgBcOdJ8K9PSrmAX9HHEEeZgBw6YizJg/zMYG3i0bL+gStHv+2o17j776qTffqW35Yfy+xuhPqF07NT4/WNrXMrBlJzGnjv/+vJpCt2WXXhPYNmls0Uv8XtxHQKNYy1ouDdlKQ5ouPPla6wDQAXSWoN+8213eiEgIWLroNG9qLH+NL4z2VRneM0ePKRxzRRV+bGNMQ/I3Mv/OWJNL2UPBolFfZEuRhthpc6NUFAtvr2+7gDT+VbyThKI4KffqcwK6A75zS2UhKItzDdz5XMFtKk8xHPxFTibgtzmytdsNEGtvS66khiOFxY8wJJzUwY2bZcA2pM9/9bn0wU98UooDcwKJJGnhlQGkR/lK5H9wLbPIZIGHtEGZw33yFGzqG07DKgLRJw9CT3e/qAP6gStbAC/0QY8RGWlAL7xY9wmLESll+m1aMiA3+jgysaNP8BAH8A0POp6L2ACGh8gvU9sC3F5H3QL+LmBU1AWS9/pUCGJQhSj6oDWobd1q5+LczXRWkmTzs4AKTqBw6E1pZo72pnueuit9WcD2S8990ee5TmIP7aKFGhu7du9MTylp7D6FLPfs2JZGJIHWLyAd3LHmg74VwFXGaavAdunxq0zW6hSoNG9Jm1ZAbetpd0vmIg/QcrnaBq3Zl31sAMPmHy/ftHrOeP6t3BrPwdhDLXkNSS8VUEDFsZhx9dd6PMrf/e4r6V/9i183d5Xx0E+yldskChTyggZ/jEUKn7CpooKYgJ3GFlq0hNaR24KX2I80FUk2AhHMfus9A6qUNQ8QAoyzCZ6T14376hV4dTKXXoPatM6qqMCcNu9DStBErGNWhSIAO1AVnLiFF5a/mYPYPeaO5hu61AAilAd6CJdjbwAyCOmrjyNxS5tkUx1C3aCoTXBtgLb59+pjkr2KXjceOydJZRNusCuNbwCcaQYZBAOUOEdwMqNAQ6jH5E1yBrOhphDHlI1/mYMUJ4A2Qf91KLzfLR3vXfv2q0hCvxJp3/I17R11lE4/Bp38hk6U7WBxJvh6mJrrad/oZiWL7jAYnxT/9IxK0Z47d862ko2GE++8CQHgCfBj5+LGRLNSX+jfLihh8C2vuGgW/HA+1AEYLNbKxqurcwBSUWO4OjOl4jdvqQjMZkmUyTus842MCti6wA0yXigdBBeYvARLiWm8zSg5jt9U2byhCCXFghyTpE365Y2JnhnRu4MPPpB27t9jOgObk9deeSOKbNg+RxTQhYE05tiguUSw2k1eyAZVcOty9THkvpBqpCom3m0BWxL/8Kg7woDyBv3sSNnHXn3lT362FdtxJx6jMfm31O6LGpNfLO1fE9jqQMt9wUsqmoPf+5tf1RTXLr8uYJsN7Dpw4LpvcwmwbTD8Va/puk98O4Ftg9emcXGpDYyWgG1ZtZauXuEn1JzWonP+xKk0dWncCQEd8DYx7PwnC+aQVsbFocUXhtxe24BmGcRG0oO9qPY2ZA8CgM0hQ7wU2dvrc4bxLmVg457s06l5HlgEDPBq/wWLLryb0ahoX/BWDT4NFoMzWveyBbANuZmgMHCssbXO1yfZrx79fP6r30ofELCdXpx1dm0kH2B3nN7v0KFfBZSzkNAeG8XsncUDxUIrzwg10Ad6BHQ7JQOmxbtXQLJP/+6Tl7dXgJcfvLmcHyNPqVz+7T6kbU76kseG0JW9u8GDLWCkhDbjIQT4Kb3lbsjgxnxp7j44CFo4WTTwEmjBgJNGwpn1ceIeALZDArZ3P7k7fe6Lz6ZvvPhNWZjsYbELWt/QInPo0L3piccfTnvv2pV2j24TXaNXC1qmqKwAbJvNq5VA43qBrXuhYe4sud47ALaN7b5dQHcloLgEb+Z7KiHd5W1ZDmxpn99dDdg22I9y3uDXXnNhhncCbP/nf/rP09G3jhvM2SOr+d+vcQNodLKUQE8/mqdqx5SKEODk66FEH/YFEKvvzQNqBYjxgiKX5YQofY63lCHvSmTQDQQcwkMbm2T+Rvc1hqE8wALAAOdB6ZRCQVjUv6EKAI4jISuANI0ABJZNAZtY5lxo36KYEF5aJ5jlIgkGk6YfqDAMWe96cRxUCwB26N6GmkLhv1Iql+szx83JFWji3qFIzOo42gMwvC4vM8CJc3Od4qkNugGh+dDgLfOf9/yZ/nObdW4nmakNJGTJHZyGt49K8eAeVWU8nqbEraWsd3A9g4YA8ATQYRudnostxOOBFbENjJyJQYHIrZuVeKv3L09MWW87ONAZrRsARw6C112dmwQw6AH0XyfUAfX5pDYZyI91azx4QwPNy8lUJBvKe6pnzcZlSBSrq7NX0rjA87E330z37DuYzotKNyQawqAqH7qp3P/CXJqV93tGnugFHb+oTQ3JX0LL3qQ4j8Sylnlh445kv6/ruhSk2HvPgbRLetwDclqQ2PjGG0fSBXlsibTVdoGsO5yDaCPAnLwNvPNq5/DO3XBXdCy5Fvpc/b+g8U7iHM9EA9M2nfvFWcEY1GWeeOvVT327mX2809/TmNTDSf+Zfr4jLHC43M+awLaoInzvPbb1piwxvLWeL4tr5VE0WeBq3200uquAw1YebiuAuArHl3s0jAaWr4XVExfwvfzQFdeQVWV4ll7OE6fehPqHze6t6rENXJf5pMvuoOGeagslYfKb6fI5abtqt91BuI3kCPQg8QIa2LIrxUuh/wPYWj8xDATvOYFLjQMgmVuLFgz/w4gZHLq4V0AuUxdYnoNrWhI3vPnheKsQYFcry2mW/8mWEdjrBc8v28/CTQ2vSCSWZHiX79MgxD9Gb2FqvQACgJWBLA5t19Bw+vpzr6b3f/jjaWJWVXDwcnp3Hj3ve8x/uz/oH4cw9WFc0O0m7MdhGC5LBOGh1f8TeiILvEc1zfsUnsPLOyjPwIAqLw3Ig9LVKdArwNvX1afwHnAZygJglqxtPLw8K05cnWMR6OL+XPPcH+VNSb5nWl/6kwWGg9x73H9e9EN1IjYV9OeCikls2NGT9j86mv7sL7+Unn/1u0o4YVHEmxSL/tCmDemRRx5MDz94X7pLVXm2jUi7Vt5axk5sEFuZjasD0aXgcdlEWTrKVwO05cjqKSrNq12nfN7cuC0zQbcD3DY7x3KTUG1YM0uYx3dtxYgN6eo9trTvS1gbALkB/VpxChdUCKHxSbbUXrXjW8+9kP71v/z1yMAntA3Qlr2gdKjHSCZdzyvCaHkmfcdSV0QbCNPLdYrnDS1Z4BUgkXMF3UA0BZfPFViDB4v3Ei6rgAseTZQXZgUUAWF4BGvAT31yVaDHUnUCc8HxD68b99mt5CM7h6gUJeCFVxUPMADE/FdAovmyEdaijO2QEoWciGSPa/CCbd4AlvoO1aSC9xsauaE5G7J9DlsrPB/vB5/YYIk5q7+ZRiVfgD6Zt8xXeEzr8ysSzCxV6O/nCJjtrgATtAUUIMxl1cZTtmbvPfdK/7UnvfLyYd+bbTdeVYPa4q3N1w5uU1zPHNx8b5yfCJLOfXl8XBq2Kh0u2S3abfUZfmyPglI1KKUUrFW3eM6AaLAKNoUksVnKA2ODGBuyMXh78Y5TlYyfAf0MouXLtc6eSW+q3Xhct23Zls5Kg31Ev1GJmVeCIgCSUrskrMH1pX3kdUQCF4YbExr5FlF1UhaaBES1f1j0jN379qVR2bMORbWmVTL4yJETotJIDrPmzMh5IabP6f7ZaEEP0fXZQGyUt7ZX5XivY4+xxUQFNcavkjSGTry9INBa0G+WF91gv/3PXj/8aYDfj+RLNuNh3dhD+vmU+mSyZqYqd1vsDL+XJI+9fPjNyzzc1akILVrsFbp3LV3YwvWpfn0ZqIt1v7YjXro6rb0crnYHVY3IZm1pvK2mhr8JsK3eQ3HalYWgpZGYQ/rNjl2NdrHUY7X8zqOudn3f2Qhso405YaqywSiLk0GP/psen0wXqNWtHaWhHsYoUKMnr9ULWHwsxxX/NrdNExZPA8aaggPsxDFEDjHiaSR7lvCZAWAkHsWr7jUND2vw2+CZRV9j0QkThifCQTfuBduacV3gtgB1/oxFysYG25W9sb73eM+372xcvhie2zDWqgQjDln/pi3pu4dPpN/5ww+m0+dP+UKRrEZbAt4GVcCrTVw7gyOD5IqXgs8N371w1p+6ub8Y8PCVZ2Mbi3xv96A8uPLyok2rxa5f/x4c2GgPr/VqBYh7tRgT1uXlqkYYW/F/nZ7Gud210eZQPuDfbDyCQhAv9Ym9vwEm/KwwsrlL4NAu3lxIG3f3q/LY5vTxT34mvXryaABbuI+WC2pXwt0Oadc+kg7duz/dtWu7EuzkhRbVAX5b+Ifzc6zfftO/WgGH9Xmw8uxvDL82v1jl3Vp/ZIBXfU5lvq6FDCuna+U+1uiK2sfF097q8X7sNbu1cqNbaSP8UzjSY+Mqsd10o7y8VY3tBVz9Tz//v6UL6H8CKpyMCvCiOlZkgwNAUUApmzLmjKuP6bkEh1TKH/LQAWyRR8L7aiqC+aahhYukHOM+9K/xcAKI0ITVOij+qkPSAqhUDMOOASYjikNESe3xDpRyvToW7iuqBHlDbw8lvF64qbqGM+WzpFfhQtMe05IMjCPS5E2kH0FsFgHkTETmGeDYHmKAOaFp/XZRBd0b30FTtVRfg4NsTd2cfFQK2HBm+q6sxcVDy/uRWBa2Lvbx8iTSx3qjA6CuqNFWhez3HzqUXnn1tTQzMxsbB8uvZK8sdtvPC5uc6WTZaxs0hZiDqCLo5qT+IHUCAcpNUlfopdqWNx54MR13CmUUPe8RcU5ZHxbwVOo37UJSsl3PEIlEVBeI9vQoaRcPbQ8Jqpg3ijagNiAlgnFVA5tUktdFlfPdqKIwnAPVDkA73nO0cB16yt5Yc3CznXX0C3eB+h8Fhm6N80Fphw+p6trw1s1pq0DtoLjOKPNcUZTgrMDs+fMX1Uda3+DfYjkZe6aFeMJ5PTGdTxtAnuGgCkWgX4ue71XawTqBnBmgV2DbGiCOWmKW+X5U21MvP/Tqq3/68nrm+510rMYoaghdmh+fqLa7YoJrG+hbBLYrdUedE7dahvFawLYsZVXTejuBrYemQcVS421g8z160svCedlbWF1iywNqxit0WMbGYOkrANbaQL7p9yqwofSF759LNV6HyZQ9EmUBXNpOSc1MzaSLZ86pXjaTj91t1of1SWUY7amN0pCW4/K/kTZRBSzxlSYlgzJL2IesXRlKEk+okoVh5HimLpzOXknBkElPiAmKKJJQtBiDZ60/y73gzQgdS3t1cpKGOYOmN4SXMl5OK4n740GZI0UyWgFv0ce8WCQQL7McF+CcnTbhfy2GG7bsSNv27UkvqXzsr/3W76bX3nzdCwf6sgaBBuIoOhSaRFS3ya6T7P0t4CKAdvVVwDXv+foAhpxIRjKMqQCiCVh+C0qDijHcFC2hs119JlA70DuYRkSV6JeXlyzgPkkWoc4wiIZjlG0IkXTaJw+v9Rn026ABHE4vFZDidVcLihPFuJ/wwhhsY2t1zwsCtpv3b0y7HhhJH/z4HwewRUoHjxCLmsKDd0u8/bHHH0qHDu5No1uHU/Ayw8sUr7wpqD2rhoFZ+Wd1E9p0buf5vnSj1+x8sZFb61XmXvW4Rj1Xt6nM2xaMSyugcbV2NUsma+Gyy8bZkp1UQx8vud8mdpTnP6ziGgDHKdmEVl4F1FadCn/5F19Ov/c7H8jeuyh0At0GoMfcLHOARZ3wuG1Jrpjl5FVsARxM5jMyWiz+Gk4hfUVmP17gKJqAp8z0ACehCfjChyX0rpvBlhBBCVAcVcy4R7zEbKLx9t6UFw1eLwAvstM1F3xtbEcAVuZ/SUgzeNXZndGv9/G6Bj841iVz8nPSF23hc0CxzwJtAsPHzZhCETSmSJCNTHlKxfq5O2mMqE8kjlm71Zv0vJGPXauvW9QZ+FpJWqNvUCbw8sP15ZHsE4g7eN8hA87DArb0m21AkTM0rxaPbXgbY0OfIzC1qFq2vtoMzCgBC+WYK7KtI7ulhyu75L7IkTD3nsArRmhIoJfnQfZ/n76DNjcavp29yLV1+z2ZD68heNVnlaR2ZXxCcpQkeE2m6bFLaV7c2uu6bhebANMsQpu8bnRyGi7RwNyn9shScldavf3iVyNPOCyQvUkgdONGST3Kg3xNtnBWXF0KVFwSJW9SIHpGNBxKFHvvk73gkV8S3n0XHRLgBnhDL+nRuVFmQMsXOcQof5ydQXoOeGxdere27mea3fUbv/fmG5/971qZa3fiMRqvA2r3z+jnsMbUd5bYoMo/qqtFU4/tbEPy2HJI1XxBaAbKbqUjq4CP7zcDtj5vs4atAfR882U7utRK30pTW/rOsmWyiRcDE1NrW8NZVwS2FYBcvlIWstWeWXVxt98veyTLORq/az5q8Sjmg6rPGjM1f2U+XTwnuROpAWgpiExiFqPKdyPBIhIqfM1cTIG/rUGLpE4uewgQBvkx4fFM4N31Z5b6iV10CHrBRaM0K2F6aqdDZ4iQIGFJFiI4aoSKMIp8yOOPikNlMQnVBI+7Whgub3Qqi7crDuV+oH0OlQHnxHvdsHVb2rx7dzpxfjr9zu//YXr2m8/ag4nUlnfdgFoD0jDqAXr9R+7/Qm2gbaHNueRVnpEBZNmYLX9SS8Y366oHFjQE3S8LtsBwpxLZeqArUHFMxnqob0MaFJ2BH6gMXR0SXu/oEyhW+FT9hGfX7cbDzJLjJDRAcHiPrWphL1Nc8LoqpF1tX0zbDg6nzQcH04c+/qn01vmT8nBo0QJMqO8GFap+5JGHpIhwfzqwd2faIk7moBaIbigs3mFUzVTz0dwIZqtjsgoSq5GRVoCtbc4tgNsasK0+uDKxW0CYdxywpZ/cWfUbtsyXvFizynInGtP4Kve4WrQKL+DP/4N/qk2v5jw2AxeYXiGqH8U9Cjh0xr/tR4TPXbwBfmvmzVoAX3MsgG2MPcM5voMtyd5gAKrD7uadQnXIpXTZ5GYgCBDGBtEOwJ89sYx7PGuaW4TkaYc5nrm4AZGoqLjFYUSfyM7nO4DUnETL/Mw0Hjb/tp06xtnutNPcXWerBhDPFAo4tpyK9zgOj7G1d+Ht4lgAvOue8UYzczvl7eZhOWLm8ErerNpLHO6MAnzNrdV1sLvm0Yv61KYo0Pa9d6W9B/anV145rOQ5eTppF+A6nyPKhZOlH+8Z9BrYBna0FiybDrUDVQGuuojHUv2/fd/+XEQB/e9QMQjvKAldsuNOVu2U06PXUoS9tk3xzGblFZ0eH0vTUuiZGhsTkJ3Q+cXZFbi8Js+71xPnB2TVDOOEoJyh4uI8hDJY2czL7Y9HdsOmjWnzti1pZJv4/6IHUE2tE2+x+o9cpGklTKPyMK2+uKI10LQYSrBnUBx2JDYTkaAcOSKh7qPnaa+7gLpAba+u1a51q2j9eEw7SQwZMEU4Bdavwetm7OHs0cPXWjp/tT0dPPn6584sm2w/Im+o7+7TrTyhn89qPF2q3lZ1ZVgR2L60AhWh/uWlC8ztArLN+t98o+JlaQ1Zx2laBbbfx4febE3zLTUi+BXaZEPcpA8KGKudxq6uCrTN/dd42lsBtg4/F14qTa94FAuwHRNXiXKC7VkWq1QJq01ujDnto10AOluV4KA6DI6Xgl09hiV7RNFQNR+X0BtZqAC8LOmD7h9Goigc8G9AMBmoxTNsL6baSzgR4fM+8dkG5Rm0tyR7EAKuxT0Vj0kNWNowR68akPva4TmxB1qgrqNbHNeRLalfhm9Ga/kXvvJc+sCHP6YKX5P2XgYnNa6RdQwMbMtzrXva6n2zbChkYBsLRO62BMA5AAAgAElEQVS73OYw0PhBsweG67jdUB3CA+lrZ08IA8+PQO91UmGMwcViDpDVgtItakW3KA1D8uzi6R0QcIez1i0qQ2eHfiO/k/28IUkWg9mAmw0KpX+7rqdRAdsNe/rSRz7xmXTs8hkleiijXcaYDOvRndvSU08+ke4/JO3aXdKuFRgahC/HIpnvYy2PbRXYNh/jyyfU2sA2Fvf1vKpgrdn3WpPTy+ZrndeuXu92eGxtQlsA9b5uxR6UdqB/TJIOi709lqu8Vurn3/6tP0if/8sve46QgAZgQxrPcx3vmr2SRCfyuDaQirKivOCDOuMf0Gq+pcCu5qqTsjRY0XX1JhmVArWVKAIAFOAI1xZbYf1Wc1SD8245JvCozknCGqDYgXLAhdoCSIFzC02A7yALhie4Vsq18Nc9j+XVdSWxSIgCROMR9T3Z8xkULFyx2DKu1yNQyb+xPwBOmFkFoAYAlj3SOeHkhjJDgNfisQ2zm+1DBvjFhhfvcHkeNe+iruPqblJnEcqT/NTWdEiyfHB+XxVH1cmodtAWh0EA0VBCyHqytlHRj45Y8ZzoSD2jK6KvDQ8Pp5PSQB/etSdtvWuPE0ytTAC1QCAWOsGANry98spSrAJ+NUUK5iW3NaPvj0tqbOKyAK1A7Kx0aa+KAoCyQFt+njYlkTiQnbLZI+u9cwBbxwOxe9p4057t27ekLds2C9BuVUIZpb377HiZkP7sRXljx3Vd6AVzaDQLaDJ2mDIMTcfl2DTksVnmUrhJMq2NZ6NnfU1rFdGGwQ2SalNBGvoMSfPi7GAjBA3F9sPgVnQZaybHHMU7r8v9k7de++yvrMde3WnHalz+x2rzsMbQhxvbvg5gC/E9JE541UO2S8FMs84pF1nfstC8m6sQbdXEqcav3wKw9YQGMOQlummLGoHl7bjJFkfYisCWnX2Zt35YzYFtY1OXA1vPlCokbmgZ/ZMloYxJGzY4em9OO9Zx+HDiAbHgGFDiafEudTlHlwuwLLEYUZKSUwbejT9cDUsT2lnMNshk4ueyiSRrsHDlTH/0Vw2OOd5hvQDK7GoBw1SumRXdYVqZrcA/FrqN2h0PYVBMYbCpcHjSoLF0I2MCr4ENYOznuTfa4TAdYSaBwZ7+DVZF6JD3E3mW46cvp995/wfT8y992xxfkxtK+Cnr0dY9toDkHBrMO/tmG8aqV908ODxX+ZnH+CUAmzV5MzhyNTD+1v9YhKJvyziJP8lmzofYExthLn7CQ9shb0aPjgG24vGhohqySf1a6IakvTvYN2RAzHNEp9fJK3o+W0ZH0ugB1V/vnE0f/ZPPplPSpuykAITDqDfTu+SpffTRh+St3Z126NjBAQEiJ+kUSlAsRsUKNZsqtw5s43kvf8WDXw+wLf0bg2P53FgPqPU5KvOw2T2v9l5pd7XnbsVMtQL+fbtNgOtGifLTh5PSr13r1ayfjx49kf7xP/oVU4kYR4CEXrypbIiQRNJJnVyp8VgSruC/Mv5is0piKFSoUGZxmVuBgQWtaQx/VAQCJ4SGLGdCpaU7H8fc7kZ1Id+bgY+9xIV2Q4KXkiMFoHqgRcHzpcKZ3qOSnzfG2UYQoXL1Lza2SDZBo5BNClUEKASiISi8bL4otlzvWd0Er162SSgvoOEa1llzA+BtOkSmS+g4JMcAV9wjn7nsLkAXj6BpG0ERco5DlisMxZmwD2UelY09v6E/2HGgv7s0z9sUzRk9cHc6cN996dVXXkmXL41Fe50DlyM2jH9Atr21kcwbOI2+i+SxDpLx9OZVVUnDCdEnm3lO4ft7H388DSi8D0UJvWzrICv5insjeWv2iqhqOm5CJXCndO1p/Y1SwaKUMLD59AsqBQEtsf8xl+L6/n+PmWJTguIgXVxJam1RhS/4/lu3bzVfdkCOD2znrPrz0pgqionKwHgmGXJeWrvkKPCMimyl1RHo32xWHNUrzhK9H1SuvKHhOZGQpv4YkJNlQBKRbGoo/+5IVXZIMEhx6ABs+bFVhIbAeDVn246L14+8/lm8mT+yL41NpCGQMHtT9/xXjTe6JrDVF7pOSO6rMXnM/hgW+zW6rgwdg7B1dnMVjpWvfj+BrUfLehu9znt8J4evBGx9TjBN5eTL8HeThbK6cFWBcXhTm7XUDLEaSLIBzIfF99u0W55xeUJtYTP/FH3FmIwYAAKAnow1I4OXosKnzOe0AWQhycA2pLiY9AG4nPFLSJxdsWP9IaVj42FPhPhyGYxigFxXnB21iG/zWiTIQr4igwgHioVlkwzLli3D9giZm+sSimH/LISON8JtwzDlJA88Lhg3Xb6DpCxVFNswslWGUlWJ9NmFsZn0/g9+NP35Fz4nMBfSRK43jmnNu7TisbU3N+JhNU/ZSsC23ukAVC3cuS/pIwdYbUCXD+aYmzlDOg7yszTlwQYywpBlX1R7uqYZFMZ1LLw1FCwqAgFF+gEpsj55ddDr3LhBPF4lmBw4uD/t3LsttfdfS58RX/IsUjckvWgcbZUn5LEnH5W39t60S57bzcPyCsOp9nhoBLaNI7q1mbQaOI3FPBbt6qu+0K/NsS3fq4LrRqC9BPS21uyY0nljso6vLDm06kH2va7zRPXrr/7NkgBTjgLkbVBCDiFaql6t9rJNq9xnASD/8Bd+KZ2QdCBex3mFXnuQ89LGakZz9qrmPl5/lnc8XST24N93yJZNdA5/c17CtWhGl5Cwiy8QbpZ9WMDDSkKqgK3VExQ+7pN30BQB+JxGgeGltZnR+QCogGTOjT3BA4wnkfOzcbY+rMb3ou4bvn9xxvD+gu6D8DT3xBhz+J6rcH74vzq32RZ4qOHx0wwny8YmmrC8o0PZS8dntNIatpChALZZ/olnEGY30w2yTQgGVY6YsQEGlGYObqElmEqTvbwGwaZ2yKOtjWz3ppH04FNPG4C98tLL6oNIpCNkj/E1lYHv03iD2rpNsdShQTulbOX8Vf/OqJQuvNhp0U42C1Te99ijKh8bdDKAIeVur4hOQPGf8YsXxZO9LP1YKpJRrQzVCNYXbgrLV1fv8H4kA2pfVy+811yffoYnO7xla9q+a0favnNUJYG3CMiKu6t+o1rcpbGJdOESP+PiyJLUHMlekbOQx2wGqqxqpqF4HJeYnCytAXUk9noA8Rz1PKCIsLHoVVGagUFpIctOOuao4+xUUZcB9qEfUKiHcQYVBD1xzuESzWonRSh4lopkvOet1z7z9XVO7zvqcN3nu9Tgx/TzOdnrC42NXxPYIvf1So2KgEblrS0ot6PXipHz5LcBzN6y2iK79lV+cK1fvW1VQFjuj9+rtXe15cWflS9nkFs9F0a5SuvwNfNEDOu6FMzWTuUTlySmAALVF4Y7+KL6Q0ZwBrK8qrCQ5Yrh8S6WCZgnoaV6sjcugFSu7hJbaz9njJINpP7IiocRTtN38UAEcgOV8ZO9D4BgHcPx5gvL2GBrYxGTR0R6q4TubKBYSHSOaxL8Q4lhWslqY/IAIL6N6PrIMFWv5HVVZi0GhF27k9K0EHXIIluGx+fl2rRbMl8UU1D1sG55Lq8pjkRRhomZ+fSRP/7T9Mef+bS9ODe0E4/+Kvv4Sk9mkBkAcumTjueUF9ryFZ+jeCX85byIBo0iuoj38xc8j7nrwuMLmkL5uJqws+RaBXQAFny90rySeFc8m0HkQFYMgMHzCb3ca2nPnrvSX/vJZ9ILL76eTp0979MjEfSAKo09+OD96aC8tdvFX9swJGDsUHMxO7FQxI/fXTL2Gnpk6bisjdPWLcCysf0OgeWSBnEXVc/mao3PX7xVYFuoCH6m1XvgeZsGtKwrG5vqf7fqsW1s58CA1BA0X8aVCFpoUs0uUEBtbbRnIPD+3/94+uxnPu8NV3i1lDCK91F/O8SuseNqY96UIZ11zd7c0H0NMMVcBehc1yaWkqfYiT55Gwk1X7ky5YgC9APGFCASLzB9Bf2ez6g2BRCi/YSC8QQTG7EXkw0y/5LNIophyTC3U99XNAKg6vPpRZY+YCUiO6HQYAUG2RQADkCVhLDw8gJgg2aBjQGAMfbn5BW23i0yX1ZsCG8x4IdZ2S89Xa4NsO4SX97eTR1fMvCdoAstQ9cOr2nIpAGYioGwycgOh6xaHAo2KJcoQkMlrjbZuN2S93rgscfTC99+MV2QrCPPzklmlrviJzy08VP/2/+0UQog3YNt1uZiVqVs+xX6n1GE7+lnnlFNl47wjIpWMKbqY1cmxkVrk7wVdAi0W/3Egu5Uy0DwUlBaHYM7yqrHe230r+hnI5uH012qaniX+ME79uxOQ6oIhkbBhOgy57ThPiPbBL1gUs4ZnhPniHkQkzXKLUfCYmyIA5PEEpl11X18tMFrEeA8e9GtAawX1eEoaIGz4yrPW+d0xUx9xvhmk+NiHNANrCIXmxZWLby3mQVtWTI9od88+eZf/vfN5teP0nuyMSSNMUaXqCGUe6xa+bJS8HtJ8tgrh9+Sx1byG3K3f6+BbeOyU13SY4FrfWG6kx5kWa6rbV6+dC+/o2pvlL6qnat8uAKwbfxuI7DNGHYJhIhJmoGtJ/JS2alw/EXy0A1N4Omxce2or6Q2ZZwGP7b8hBi6w4fw0Xxr4e0zhy07BGs4CqPgI+LH6gT8Z2+DL5qPyLtiA1uAMJ7P2MHjFXDf6H24bq6ag8EKzS/fF8Yfg4+HZVJtvyyPwFX9TaWvDap+heeJ5IxucbvYzber1JANHgsE7c9lPHtk9Lvk0bgmD+ZV7eo7xIWbFYj+5Gc+lz72yT+zYAEhJkJXceuZElB5xI2evvJRzeNXeb65+3yDkayUT8tdNQJbf6/+9A149L9SznG1GebPWCTyQbVjDSp8sUiGYGHxBqfo9VJIA+9IR9q5c3v68R9/b/rOd98wsO3QhmF05870+JOPp3v271OlMXFrxWHrR5KJ7Go/4eJViufUCGor3db0zzpIbd1+rMQpvVWA2diwRg9qbVexws3c6nWLd7ZR9cW2NC+grdC6bhXYjuhZXtW8mhYXcTWbFnYrPGB+6Y+XXjic/oUqjAEu4ZoSWemXJ+0magS2Q1IiAEQKaPYowcZJZWh4emMcIXWXkQ3eoZNtgKT26ul1RV5kuJI9AqBOrsqSSQA+AKdHi+wESW9UF+whgmMZK2nN4jXLCWnQBuxRFeCmDXjUqLBGv0IzMDjONoayuoBIuKI1D6YuA/eW8/SSKARfVMlNyJgt5oQgUxYEZDjGANub+yhTzv0AbKOKWHBxsU+WvgLYOZEs1k/6xN5Yt6dOtAsgHeDderh4eXPom+eC99cgWGC5Q5uCfiXGPvKeZ+Th7k3ffPab/x97bxps21mf+a07nTsPkq7mASGDQIjRTIaOx3TccarjL0mcL6mufEh1VVc+dCdVqXRVnDidVHdXOXHZ3SmPcbfjEbAbDAYMRoAAiUEMwthGCIPEoHm4V3c8053y/J7n/6699j57n7PPvVdgQPtq65yz91rvesf/+7zPf5JTn5II2LktLDcRarJya7ka2KbJONpZott/ouv2qM5ndcCA1UQgLyv5AX128uQpl4vtKWYF/t67BT9bRjSZWbTneFakaNrH0Z03jP5B+TrcKCD7ottuFSt7rcgKgUln/zrTPSFzuccUhuvJJ+VkdmLJNtw+jDtiRPkpDPaPJn8iiwG1ZQKW3ch1dL/X/HCYOfUfhy7mAfbau2RyQPhFZ3pUJ5DmmTmOqQhD0+QxdtscgjxSHEYKysYMME6UjLkY2wfOLS2//pvf/NjyRvLwe/l79fnVqv9P6/0lzcepocyGUr7JHH72wFa/73j0sWdsijAZFeH56BxX4nsBvLb99fnohFq2TR5s9hHzANvhJjnaR6bAa1iTwemiAVvXjYVeJ9R+IrEgWYDYiSnMyWmdtDlhX1AqWfJ8N6YWQGu2lvutKqTRYfWyCbW4kEhCFjlhpPI8Lo1TVIRmgFumr+WZmR6CfPM7YVHCvsDYRhgAbOUljMDwxh5QysvsomUn6A0LimWzBUcU43BJyRUQ2ocPXyVHs70OMQaT0wLFk1KSzRUV4YLUSVu0KbFuhNy67WJRTq2gfv949873/rntuNgobWNLu4od2XisszHFa7t6vY3PcE42dq7/OVpXrbsmQ+yxcW40ramr+98QpMpsJ6CMxqAJzZwhpiYGBAqBdtPNN3Zvfcvru/thbBUK7vA1V3Z3Ks3ky+94efciqQGvVp74ffJwxlYxmDvlpikbmz9N68OLAYXPN7BdU0/P72H/jV8xbxsaeNmoHxqw9XU1lxoIXm8ezuNE1upKqtK9GsuTskNcraQM08pu824IbLHX/OcyQUAtnXSuObQZtSjRx24BPLKH8cIEAbC2hHe4gCx2ioQMdPYwUsXCkAowIB/2aF5hCwvowAEKVtUMqsAyTknIH1TqzDQDUv29rLrjmWUA4Xi5AWd873kpeQGTatBpgBiTFmSNtTv6t0QGNJsbAHgUxknP5fuk3o16eY8yCiJ7YOk8LGIXSexg4AxIU7lmrfXPALZi6Do7GgkkOABQP1sHKcKAbFYdTbrs6l13ynV/RgZTFr8nVm3IgnFb24RCA3ThCLdNpkXb9h7oXnTny7tXytHzy3/zle7rX/l6nFAlZB3Hlzjh2cz9DvnAmz6NnIHEwGzK6dYBs8ef63bpu1PS8J1QJAP6yGZVBu4RLcaR/PPHJQvcDpWGLT6JNmxaICdXhdy6SvaxN8j57DqZGJBSF1vfJclkWNmn5dT85BNyMiOkpMYXsw+HjlO57i8cghtQdRUi85ryZ6SxYgeJ/bYdiMvEwOYCkDn6mzFG+0T2tzjyxe6bQw5z56xSHpPqN2ZPaAnkNMgc8H4E4UJ6Z+Z90Ts8y8IYNtpZO5fV96966Mt/8fWN95Dv7Ss0P9+iFtym9zu1xqaC+B6PeLWN3uPhvr7y0BFCgxCyor1mi9/ZnTZ82Hpd+3cO2E5W/GIaP2xwCUI+GrZ1+JhLecS8wNbAJPLCr6mMTIHEqE1bDUe1G25y0Zpb/JoZWRJDc0o2SdjXXjirzDbyiudhUQk1tpVSS3DxZY6qyQHux+SZjjHbPxZg15gdQFOz84yw80RGSNVpOoHOjVbzLP0HW7usOb3aqMexmR0gZocp1EIY68sL+biy4Dz1xBNmcrEXPUzQbJ36YXF2Sn22S6YH5KZHuGJ3Z2yseuyQMNuizeAZ5Tx/959/uLvrnnsLvCc2bpzqqm9rQHrQumahtM1nmi1oVMvpsBrYaXO3Do4j2+a6ZQJcDxnF0UhkvliAZ2D6eTM2FzwZskFkf9MGJmG+XU5mN8p27s1vfX33hS99WSkvlwRoX9rdeecd3Y03Xtddp0PDlYqEANuFXV1e5XTBNLlEYNvW2zwgcT2Gcp771wzdOh/0LPxG12xQqIe7H5O1Fw/rHdOUNl9qorRxrVuHcmhexpZb23MI8cWGfFTgYezMM1G1kWTJusar/H//336x+4ayMzGHnLDA8oEg/QKkAlA4khI4n7XGejGQ0M2AQ5IJYQtrB6yKhsCMZQ46yoHAIawZqvoVaZNgA1HZb3Mqw8ggbGydyYr0uTDCWtstEgvM5vZSo3ve67kcggFPsK3WNGBeIOYvDG/qx+e0DRBq4CYQSJ3IQuYECrRJ4DPaDQFuzJuq4/ide5Cfu3WAPmu/grCWWWNhatNfsLtEaJFZhhjVxEQFvMXRyGPfQKflVMKf9evDKDJEAgCP57KetyvyyVaxtTsV7eVNP/ljdrK69+57ZCJw2iEUsZdPsdGx8EcDoD7cQlDwmTcp1Ru1uup4ToeCZUWLwUZ2VX1BfZt8CSZGzgDkq1zKQZ6Q2UvatN1i8Q9KHhOx4PC119jMYLeYeMQ7aYSPyZwAs4JnZSd7XKG4FnXokdIu5mSOuBJHYKc2R2hbfOZ3w2dvUTGxa4f7Fs+WuePY4XV4aindcXZj/izoIIWWzylvAbH0ZyNQVDSHkoS6bGOAxlKZ5WDIVSfLQTtMqgY4TyLjfcrjbwtjKvePvvKl9/7+ZmTO9+K1mutg05/T+ynNiY/OasNw2/N8r/dMYNtumNeNYgiF+gX1vdijm6hzwxRz3TK4eDgYww1lrnIGF1lmeIMb7U5tYNtlk4zt6O8GGFMDF9Hs8Oo0P7zXnrXeH5swKJtWne5PiXE5JcexLTptaidRnUZmC4aZBp6cdstKCEFntUzUSa0PbAdW69cCp23GVcPcHaHcmyuw2IlOwHZYp95EYSgTCLWJTcccTgE9y4uKIBAhzEZTqh+zKMo6pEw4pwRQH1UudAJtHxSwvUJC/pACaBOcG9ut2M4iLMvpDOEp54Snj57o3v6u93ef/MLn+k3FEt52VdXf3hVq45kx8H37+w4aXZ+uyabUj/+wHORhbAbq03Lw8C2jWTdk/SYZQPdzPWKkws5BZVRuRsWMFupG7OjkUEd0iBtuvKF705tf23314Ud8ILjzFS/rbrrp+u56sStXyqZ5t5gs56n35jguaSh1luwZypoZXeePDQRqzDdmSEd9MgkKh+Ws97y1c3bt1ZsFtuuxspuRP2uuHQBbvhv29WaALS0E0B08sMeECEBivb5uh9bG2P7S//Vr3Rfvl5ax15gn5bIPSwBF1ZPDJps+hyAYrdh/JgHDokIukQUKcHiG1LPMRau/WceobgFYlZjATma6F824WdlkuAKAEpu0hfJKNAEBWgE4AxNs83WAh4WjbQAdH6IB3k5QUPbliCKxcZgYcB3MJ4wdNvwAHl62ocX2FuDqEGEJz7Uotpo6E4c3NrJx7kxsXcJuBThzPeaCSYErVtl2wLkOPwL6KzM5a7SZIlhMGNCC4cpfodZIZqnapf6jvWRf264D+nm141aF93rrT/149/UHv9Z98bP3O1qFQ3pRv3ZGiigL2VAkA34P9FHCqOl3yeALlWSgxQN3HBfkIfsKjKTNJmBk5UhKMgQlZNgnOeFkCAKwhx214IAzoGGPfFr9evzYKTOx2MeeUPpaNAYtVrHnEOV5XwkPa3HgPaxCb9U3/qwcfAvW2lSCPQWnY+ac547uJCYy8wWgzYGJlL647yZOLftQCBnsopt4xm7WWeLYLYiUU2NAKDRH/iHaBXa23odGBw//zZgBhrdt/ZWv/OV7/4eNZND3w/daP7erHW/U+17N22/NatNFA9vNdNLoFLiZu753r93MxtIzaxbZo9fzBWwH23SPf9qGM77xFFCxHAwYjIosIbWyWCE2ynTAHrA+1trDH+/VkwK1i1IpbZWjFsDWjCmbSTWzZwTLGN+8g3eXMk0oATsEtu4je1w1sVunMZ6LsKoTrIVACRTjPH4vT1XasiJhf0bA13nQCugFW0bw2/TBKrwIwQbwOVmfIawPNrjKXrN4+qQZl4MHFaRb9rdsenGeEKDDyULvCwg8CeTH5JDwjne9r7v/Kw/Eo9WHAio3ArbUwE4XBbxmrYJgyOrJxsC65vlsDPiUFB0vs83SqA5HOHf6zJsEdRmHDEUOFdXH/fOZF6hqCTNECmOCuSen/M233NT9xI//SHdEmw+Bzm8R0L1GqSc5JOyTXS22hz4w+TXajucFrpuRHBsxryMwt/bpG927ZhzWqdgaYDtFiKxhW9t4X4KwmHxMInFsIIcMkjZ+6D7F4GQsjykkUuTF7HuGwPZd73x/9yd//F4PPfaH27zJE7tT8VhV3nln0Es8V8I/OUJKqW0BFzwFm16SsVhNi80tnwMgbOqEo6hiyWKCpLmZmK6E4Kq0s4AaH+ZzrIL5xCzGUVQKINqpR86mzqTYzBFqthLSEBBFN8LIxiQhtvT8nWgF0SI1O0qDVwCzTSKIoytmVPV0ODJ95+fRh9SJSAqsWdacnm8gjkNYmSdxncGk3jitAWwNLHl+gU/601FlBp9HDR653j6nLA4NPGyHDqbbd+3vtikZwU/+7M90N958c/dRaaAe+8ajigOOmp9n6tk8yof1ZDYDsHIAUEUcaxbfCzPfPJ82URf2FYO12MQiUDAbgHXdJ5MCkiBcKRlxlex6Dx1GU7bPbPyq/BdOOrOX0uIqhu0JsbGnBGTJ9rW6CgNabD/TuqLQGMiaUBm9QohotKkP17nXw8S7n+mHcio0Q1tj7cOD3qRb5pDiDHW0o8iZVTm4tRBghHZjcjIfGU+r9PSZZaf6g/lHfycyTuag4ybbNM+D7Tcxe/3SDx2Y7n7gb/78pzYj876Xr9WcwWmME+qfaq7M5FcvGthm+9/45cmzwSa9cSnf3St6ADarHdMQ6fCzYfXX6bTJYjbDCI31UFsD9SHltrLXMDBeK8W2ljDP+slpkTfOVFaVIJy8CcAUROAHiwLiSFebjYLEq6gIF2UzdWbxZLddIA5vUFQtQElu8vyxOUHUaE2YkkvcQLNh19pnzSq0uWQ0lXcTQVZvFSDlq7gTMEfbSbli3OpBOIwh9Ox5ihAp2zLDQsueMHoWirURNccb8JZtg336Jvh5YtcC2ImQwNazALMhIOcYlzAZBBaXk8BXH360+8P/8GfdQ498o9SqNCjCzk50gwkQEDoBO6puvsv9NrzB8HL8dFTXtbkxBLaj3wtEt3npuZP2D+f9tDWQ67Il9POr7qX6gHoDE0At9sdiZ8mZ/qpXv6L7yR99s9Sv2BnulEkHaXP3dHt3i2ETawGb1sobLpd55M0sScG9wx6dB5S2fh4vc1SLecpYj1kdEwtD0DejoeO4sC4qNmxSHs8SPxtK0gJu64osrql5Mq2qzAg240MH94r1POM4nxv2QxV07z2f7n79V3+nZEuybDEbsHnNehJYW41JAedotChmtWBIAXkAI4d6Ktzg+LMweQA8mNKwX3EwA5To4Gk1QGQZY7qK05a+w15+1Sww4e9iDpOwV4AiwoahJpadrJ6HuQJrHrAFkxrmGaA0sqEN2Iy5AeNjfhAmlHTfjiAgRzgcpfSZga2+h8n1M3Egs/kCckyAXmruhDMLYMbkIA008SsAACAASURBVIdporPQV2QIC0hO8pdS4SOHfcdo5JJkIjbwwzltUGv/BLKVyTRopzKY6n3T7bd1/8V/81913/rGI90HdQg5I3MivPq3Sv5tEagnCxbOXkmPTsatyhLHczB5cPQY9U85DTdzC5j2nToMHRQTizMp4f+uUUptzAp2ijS4oDosKuscZi1HFEeWWLLHTigWuT5bQQ5XXzQQTxsbG529osbYwHYkDxD66SGYbfqmQkliK4sjoMYWNpwrnBRD9ty92UXZYHvOF0NPlIww4mHqKdQ+EcxX9k2N5S5pEyBeHKWnHKrpE7Ji8vOsAHtLZAJQZj6y7y7YMc+CnfIf1i9v+Ou/fr/s/b7/X+qX29RK7Gu/qHF9YL0WXzSwbQBp2gY0KVTHNtSqzaVsUnMP4WTlJnDCvOWsC2wnG9v2m6aPmXjIGmZm8P2wKG9UBRKm1XPGY31pS+HZNsLhhu5xA/8QtcDAEkEd8OcFBmgjfWMtaNtmWV0iwVFxGnO6zsJLmseKRwi7qYWO7dk2ALDiNG6TkwegFhUUwJbUra1tDdhGzhZD0k6rxmgBOA3UtsQCCe7iL1xW29BsvM+qxz5Nn7NZOJJrsbUxn8J7OOyP+weBEZGX8miXz8uxBeOf4zI2FnlsXNkJUz+cVxB2nOaJ14lxl9M+YgcmQHdeP7/0wEPdH7zjPd0TR58oADrYXCaArbuk2LNxtbl33xHoHJgVbMTyDufR0HFs8r4wJ5XEofp/cg56Y3LbE82hzdWoy1AHZxxw3IHpQS139bXXdS/5oR+So9jt3ete+VKNQZwq9snRZ5eCri/AmPXtGQDIeRfqOte5NB8G8roY+RM5sPbO2QA3h4Z5nK2GVZ+dvGG0kluZw7kxlMkXDWwn+rAxlJOiM8BxOmHCvovDGI5jx8SgoXpvzkvrDeV9n/p896v/9v/16kvUk4yZkxfoYMQhaVFqZmKo4lzDel4hkQGJDagPkQBUUavzfchlboaFZN07CoHKdjQDlUnqaOLQrhocc8gSw2sQligG2DgmrJ/iccsGFLbTYfrEstF01O+YACyrDoBZEjgkcgHxUQkDSH2iyWohDs+Uza3ZRsnTXZINyNY41cYmluc7qxW/m30FwHuxuWzWCckfAFysl6zDyF6D9prnjn2r7wyeLPtiypA5Q+SDJJ4JK1vhyKLyCott04tEXcCEaEEJZ0jI8J/9l/+we71s5O96/0e7ez9wd3deY0LIMUfIQRMFiCsZZfKgySvsY1UP3kSo2a45wkH3aoX2u/q6a5QQ4WqZF+iQK4Z2z15FvlBNlmRu8szTR7oniSF75ITMCsjqpT0J0GyVflLexpksphC8bPNaJ4hyMfO8iqMGlQjt53Wi3+OPgd10HPtW9NwlHXDoS8xKMGshMx3zzqHeTNSoj2B3udfaQNnLOqRlkTUA+YQ7LxkQmWl8jRaApBkcpJwKOYcWH4za3sSltJG+IlkD19EEDiFbtzy6ZeuFt/zVX33g0fXW1PfTd+rnn1V7sN15l/qgwglNb+ElA9tW7FDwjcfAHH/wpWwsmbH93F1/zKZdN++936XZMAlsh9VIkOzRptqubUziTE6+dVmhXLOTLBizsBFevFhAZ7F1clgShdUhG5dO22SaQYBaK1NqI55thrRYWjxSDTCLZQRQSsRK5GhD0s9tLHqeZeDs8NXZsGB8AULVrGavmbYMBqvY2py+0/KA3Wz0zXM1tchmRu4gVE8A29hOIdNyOoZlZYOJTS21xPoXaVNANaVE6JcggS3ie5cE0K3Nwc/X7zCPe1CbyeRg8bRUY8+dMDtNBi/CE6FQ/Pinvtj9yXv+vDu+JCeJlBSh36b0YAJMgiW3e4CpDCRrTrTfMwgBm/NCtwZMh3Nt8ve2+bVRad9nLGJH6CDzHpeo5kLkqp8kkHfv39/d/KJbu5e89LbuZjmOvfjWG7rbb7tJcyubLIBjQWHTxsJRtXEe9NF6ddzou9Z1kz0zD+vaxmm9Pp23nI3q2T9rKvIeKk+HMDYbqVXL9YChLJnnmbOumUzH267Ls6ZW0uCAcG3IkpNi89prvT76wn1f7H7ll37NB00Ai+tvQJd2LgiEIsIAHcx71idyCpaPtWkwyvoUSCUkmL3PBUZw6KIMIh8glxzqDxCnubkA26qyFwVMmYeAZ+QDXvvUFWDpNLpoqKzyj9037UIDwd8woqxz7tsl5zIcgZBrZk8Bj5g62N5VjmQkp1AbDI6r/yyLcXLDDKFCJwJuAJqnTp40aMfRzOwybLNBGRnOAHjLttst9s51TrY14iAQOjzhuQK2Q1xY4hnw5zBqNXe9ogbPQQzSou0NsNpb5TS2oOQBu6Vd+R9//p/JJGF794VP/WX3yQ9+rHv84W8wGga2caQrqQzeQ2whB1QnwPpVcg69TpFPrgPIysnrwFUHlZRgj5PgkCDjhGxin1HoraeeOdY9o6QIJ2Qrfc5sbNhOnEcjZ/r/eT8Zm4vGr+X05cpEMHr+2V6WPoyfgMGtCgNoM86w9RyeaDuHcexlGa+EMMPkI2SQD09FgtB9BsYqF61AI0UYF+IWs4eWOMuuBlglwoTNY8RgtzGgDvQ787M2BT/Xpm0VZ1jXyN76ydWVs2958MEPfvNS1vb30r0aO+VV7n5M77/SeP31RnW/aGDbRJp/MpH4XxOsg03JA1mgqi7N4tmoZpf6/bzAtvXA5azQtGfP0Z7hYExWZxLYtuIavlqv+sMxsPqLBUnQby1kmAuEM2zsqoQlsRDP6LSKYwZ2P2dlHxvg6OVqBgI2A0bO9mEJ4joAthEUtiiAqUWVVvZvZmwxb6jR9ynbp/g69dY8aYG029xy6JnQErG/pSYFLgOtyvjfTEEArIlVl5eQLQHKBeCdlCEMBvay511u2A7/Wq21bGFu2+Y1alCz0/VqINteyNp0YGwJLg57iw3vSTmXsZHuFiN5UizDn/3Fx7u7Pn5Pd1pe2GGXi82wSOyrOHOmRHamH2wvaHYlr1nREDZicTcCtmPaCrMaflodKvSrA9VnzG2KUhup7e3EaO2Ulzig9s477hSgvbm7QfnWr7v2SqfLXRFjy1jHkSezaNY8vtTl2e6fBHwbAdLR99NrsNH9cyz7NZfM1uqsJyHG5exkobVPBhRMfDlsQ+bh4IqB7B4NTsaprePJZ+0TqNylOM8npCZmvfdzdFjW4KZ7Pv6p7jcxP7D6tkBqRUVpGhN/x7rHVAWgRkYt7GjFogEcHFNaVywJpCKfiA+K85cjDwAMB6p5bL3tJGZZItZXANnmBpJlCeFFpi+BEc1NTGMAnbCyLSQfbYJBc+IEAZSdMqFZLlMEO4bB5MrZC8BqgISs0pMc21bPthmEnteiFHAt2h2ckXaRCQ22WPIXEmC3QBXqfIbEqXj1XOTb0tJpg2UfItUGZFYDonRtyzDWx7qt9AUOETUxAxq4bTau3M+zqJ9lPZEQdsjxU6HRXv76O7t/+s//iaKZnOqOPHW8u+s9H+o+cdfdNkFAznuUlB0L29hDCtt3w003djcovN91iht7WMwsCW84pKyK2T2lhDVPKpTiY4890T311BHZySpagT4zO21ntKQ5Tp2RPaO6tykak4/pm3j2rZJZlrXmdrOfIacAt/zOfqhxO6kwYyuEfNPcIQKGs8qReY6HobE04GQvkA03Jh7MQ7XY/W/5hZkB5iE6SNm2OkkUYuZCPHM0nzGjAURnD8iBCZYWMsAJF6hbAp2HhVbhhP6iP/TVE7Ir/7H77/+z7/uwXkO5Ihn1M/r7gN6wtWQSWfe1KWC7Mgj35VI5IVfxTWA2Aeqv1yyh0ZK61I1qo4blaLThVQYrYx1YrOhF410muIHHHA+fqN7FANvJXaqdxIdtH5aLLSeLj4VJKj6ALEL0jE7Gq2R0sXG/BKnZA4SBfkJWAt4Q+g5PQ2BxvF9Rn6Sf2wnaAAdzBG0I2BCd0YaAV62RJAITu7D+FB2BbBsyhJaP5AVAETa1EcaBq0CtTdTCkjqwNZsdAkKf+i+f6kvtZkGGM0NMFHLix26qzChQwaEqs5kBtnkFkMcmTwRZTm+AtZgl2FGuOj+CqDYZtRuV1U55D1M2YYeIr/ik7MH+w599sPvsF7/YraQiBbhTtjOoTSKOKdN3GpCaOd9qLs5eBSMGPMt5bQXGgC3XMNYMeW0yZPFx1zBGjcnmEOA0b9u7a2V+8JrXvrZ7+Ute2t2iyAeHrzjQXaFUuVdcIftLOd9g7+wQOwPQM7lyNr+SNl737YqNgOks84PJJ2xUzvw1GgDUARq3enNsfNYKuPXqMJTLQ96XejWtQV9HntOKH5ISg7G3jW2rz2DaAESvPLjPrOgJhfsbCuHJ+vH32/7wXd275VDZkh44BqvKXRBLiJjgIA3zyPoAjKIWNmAkjJXYtFXsOfUdZgBEGYDt5GBJOWTeYl7u1mHT9qYFKAHDxILl8E1ZaBkwQ7C9qp6JXIQVJVvaVgmUZZXDZxxQeY6HRXUHxDoMmeoISwwQct1qrHwQblKi7ICxP222uNhMAnYA65g9IH8MeHUIhqlL0gjaEH+GRHfBB+tsxUTVAVrP5R48553AAkKiaeJKbgH+kN0JKTWaif1eUXMgcVEzHwBaXEwyhu0Le5VsZl93TmPyY//grd0/+sc/1x0n/bgOLl998FvdZz9zv1KnH+8OqH9uEAt7k8DsNYpUsFf2sjt2OXGAWNAz3RGF23rqyae7Jx9/WmD2GTuPrmCvTFIbJ7bB0TQTz8DTv+ZAg56vJeVp2rqRLe2k3Br93V9jGROnL8oHckK88P2y9r6TimvLAWivtEsLArYhOqLts++GGeAAWvqHcWaMHJVAn/tQ4f2SPY1NKuEN0RkyhpGR0UZwWIAZRsu1oGcmSgRmJfmdV3w4tniOO7qGnrN1x8IDOnD99N/+7Ucf24w8+V6/Vv19g9rwk3o/oLH/4jztGc6Itgb5OZ6g4XESNLBoMKDOq62PacB2+OBZU+753KzmaXi7Zmq80MnKTTRijB2b8rChwFjz9ToNHz5m2K/rtWdWvNMh6zMsFyFDoPRlBe5eknBCaMPQInDPkbkGJhDzgWagzqLmD+lt7AEKsGXTUaFhBWBTY0cG6xDzBAla7IdUcYKSYwcXG6QKtVXANqfm2lj9HadbigbojWyz7EuGrZy9bgMuA6BjDwYw4jdUkQDbCAUKZiNoOix6MXbFyfXOQEjo2k4qG7nVXPzeS/+ctNufHjrUaphalFMLHzUP5NQtaRDZPBdkWyoMrfeW7isPPdq9453v7b7+7W9IaccCGp8IsTxur41Xx2xWb+1sGZ8jQ0DUNpFAnY3Y3fRgFn9jZh2arRiGctSOM57GaJc2iFe98lXd63/4h7sXKxLC9ddc1e1XetX9SpW7b/9uZ/zBe32j1xrgtdENc3w/LxBde93ssZm3zPWqRxnT5MdaYNuMKsbrM6sOGwHbGtbMwiFQbWB2WGmW1vC6wfV7YWvFch0XqG3hqfpZPTHn/80v/1Z377336bCcbFWUycZvhhOQ57XYIhwseC3CaC1LpY+2CAeqM2JWYWCteZIM2yvbzNheEvVEpgROfoCNL9EIjC7EfkXWYKtq5yrsGznk6nc7oXlNYx8fVTEZo3g25g2UBZjk+gVF+EDe4ViEyhoAScYqnmPwYoZPQIb1oVIpBwDH92jIkGvICTKnYTO6S4fh5pgL43lObTMvrjIoC7ta6ob5AeWTmcyaNH14Rm33xm2b22R0tFgr+dUY3OEaH4m6ZrOfWYJsTJ+ROlzM5c59coBVcoErlLnr1uu6//6f/XcKrQXDrMgDZxI2MbFcMQVBA3jesWKPKt73E8os+O1HHu+ekp3sKQFI26xi2rAVu1VAW+qPDIlMY8JFm+VY5J6Oqo9+OpxaA73I/ZqqMSkbvgYT0gSCh0//Yz8gzbrmltmPs91pRVI4qSgKe2RmsW//AYFH2HzYUpEyhKi0iQu3lv8JqZHpb40fBI8drO38VaBWfRZWPdneGD+HL/P+lgRA1h4QR5lUyiqLLJfeY4vs8PzQgT820IBa72d3bzu99WcfeOZjp+YQb99Xl2he/OdqkE4bjoQwSqawTis3BLYHDhzY8cCDD80NbDfq0UlgvNH1z/v3VaGxTX0jYFsCeh4gMFn/eQFJq0I/QEM8Mih0GrDtN7cqxLeysLSysMFalYA5rVSFJ48dE0u7aLUIdj/YJaGGc7THcmiwugs1n1Z3wmkl2HgChQO/o5oH1CaeIrZsCWnDAgU4wyJgr4uQMNMT8RlwarBZYWwor4Btb3lqJrOU1LZFara9FR+VTUPoOFER9K2QpGWWHxKHtVC1kZmtH5oMpQXnLFgtg8xItzA47sdg3pRZ/d5Y6RBWYSr9m4W02mQnKIF7UsJqUzi5fL77+Ke/0L37fX/ePXfq5BoVLm1tZVPOPM5GAUDl4DUBGCbn3Fpgmyuy6cVRrP2d50+yg+Mlpv0RugAF255hBuIDiNpi9ZlS5954Y/djP/ofdS+//Ye6m66/rrsKpxCpbXfu3KbMbbvM4vxdB7aTfbkRg3up4HZW36/VAA1F96iWw7kzKcba30PGduwaNlDGf1C03TTr82FfTIP3rPcrxNbCsKJmHp0Im4lJfj7yyGPdL//Sb3XflFd9cxi0Y0xF0bB8wfEJ2VDRANj4Aa84crWUry3xCglRYG4BEzsFNjEjIL4rjlk2t8JRRyp9ygP0ArixuYWFtXNV2ejS1LaWbVYDVAXwCqDAFNM+Z/6CUcWrXdcAsrmfMH8xtUpAfSeFsDyVLFBJJHsAQJMswal77awGowcwRKsjW1pU0mLumtPbotLKIocpm3thlelTTC+o+w7VARkH64iZAzW286X6z9DeB/hIlqGsigxsEicjGRkQW2G0KHxKNBMyKG5bEKYghuyhK52K/E0/8obu1hffYvYaswyyvS1pTzku1vMZOXk9I/tYwm4B/pCPDvOHDb7DVCHPxQTLXAGfi6Tz5mnNU4LfYx/LeJUIdnsMUWsfbFm+UvnB/A+MrQ+CeMNYM29gV3Ug4WvirB8/LpMOIjqIpZUfBEy/5xzmAETwYe6gbSwDXztNsz7Yr7TBsFeGBU+4xjjaRfanPTycaxMlwX1shpp0wwK3aCq95xHDVteXLXaT7SxE70/nzv/G1x759D+ZlEU/CH+rL25TO4mE8Jfad748b5s3DWzXCPrBB9NF7fgd3w1g26IEMM9mZ3Sat8s2f91UswTWaKSNXwF7gwWqxeINKGt+uHLze92/pmyDtLJJdaElNHCa0IazJKb21El5lyoG6xklG2jBpREwPplyPwu4wA3qfqdANEta5dl0IGots7QAWf/MdRZmhLDRQraZgwQx5g3nCP1io1U2EOqYdiQiA0s46DHCDDGWz/qTfAktADSUMoAK+8z4daW8EM0xt7BooZ4Y/PMo7HkzCULmWnAAxPQ51bKnQ+v0Udd7C6DMwYFm6CAZlWMBXNvhpi92iMVZ2L2vO3JitXvX+z7UfeQT95h1zp4yMj0wCDd+mJwFg3Hf4Nf1TF+Gc74Br6m2tYy56j10GApYD4AOkC22uuakg9yzaVhlmPUFsGWzeMMb3tC9/nWv7m5Tfvar5e18UE4iAJkdchTbu3enNhUdsmBAZryGIHEakJqnd2ofHLt0+Nm8QDTtm1baeC3WK2/IxI6t/Q0OJp5+E6ZNs7RCk33mfquxak6a08TJ4LIxOeRrfQoctbOfpRMC33FrNb7PVdzadpPBQhXwoQ98rPud33lbrU/UtWJUlU4UNToZwxz3FPYPzYirHrBG2Cke5/S4kmMwq8iVBjD5LFEKsF2F0eUAjOOOgEktawMP0l1j46jfYRyJPwpwRL3Py7IFmWDVckwemi0rdYjzVsoOS5f4s2F+473u+5GR1J9n29wGFldAkLiyZkO5tjKFIcs4mOuNfDa0c3/nvjhjAvbTL6ilseMFPCcyAhmtApCiyncVSzsVjUhjRhuDO5I1YUyzxkmbK+dhnN/oS5hhMimKrQXYKlSB68b3C/qM6BQAulWiJ1igZhYxJg53WHtG4sIGYPJ/R6qtvYQfvZYMQF4y0F+789r0zQTst8zGTNS0bCszUzV94Db7Z9hrbIDN1urnouLenhK5A0u7VwduNhEOFpjjOfoPUSdgxH1wiBkIfVbw2uVnf67QYPSfHwrzOqgUs6DMCzjkMK/CB0hLUHszn+ewEX8Q+3qQYay7cFzns//2occ/++4q8Qfqh/qE4SNuLV29btzayY4ZiibPgXrPNEW41J5tD7zYjepinv93AthO7iYWJqMPh5CmCQFSRgaHlbAabjB1/5Cd7Rc333nRBSzZE1gLdUWn6kWdpI89d6Q7owV8AQFrs4OAVj+m7D+bvRdCPYKv6mpbr7K7RRhrI2lAzvgMBq/elMeGA4Nygew/GODTnki1MkOIwOjBlC0WdJFtcss72vKDxtRJXuWzwWxDlWM2II4gdgWwyYO+9Y+oJNmYt9Yuw3Gh3AcMbEeSE9VXQue43/z0MMFhcGtrrn7wBtHsHpsABdQWEER6bdfGsFXvh771VPcHf/Kn3deUrYz65hGF4PM4vy4J2E6Aj7F1UkMXBqQ2iDLnqCf3krgBptgbt/ZE8ObwkvH2nCyw1W9azAdtDjvEjt3xyld2r3vta7qXveTFNkE4qDiUewiXg5q2B7aKurEOsG1tyIZyca+2JoZ3e5rPASaH98zDoo/GcHpdLyewnY6xx1vbR0kYTPOhGCoR4cq2O4c/a1KOJuigWR7zQWHICRJsLIvNJMvYcD4z72Dzfv3Xfq+77zNf6O1pA3UQCGHnmFuAVWqzW3MFAIgmiTnTIguYubNTDUglal1i3NoHAFAKg4ZjTh0ubZsLMObz2t5QARMVBQANEIbBZWwwIWpspiMiwDKWLOUn9rDJPKY17ENyzI4c61T13ikGE/FpbANDZ+cnXUUbHJA/Kmxn1QOoCtC3zo3qusxyMCfQ83bKpMNMrG0vUfEH2IKKFxSVAbtMHMtgkxFc/B1z9Yry0k40/bg1k4MM3Gj/seS2GQRtJEaVs4ztUmxaWGIBVf/UmJBamIgQ1usBsllL9ITl7xCEtmf4QWNaqkZYtOlj9zfqzQ/L2tFqN2nQA8XmA+EFPJiXo+vHgK13hAK2HBIYAPXnkpjaU8eO21SKNLxO+iHwicP0WZvlrSTaBSBU9yfsY5urHH5IcZu/m0FQdqqSr7VHeM5ywCqJn/VW7fPEwsk5iTbC6MICJ4GRUgd/RoeGn3vo8c89Ml2afP9/qnnwcrXy9Xp/RnP1oc20eCjn2rzk51hK3aEpwmYKn3Zte+DFblQbPX8aCPSGUmjlu8XYbvTcacAWr9xSErvZCEkvsgK6o80j8rFtSkWK+jPbS2mzgQlY1AmVBb146oRBpQ3oLbgL7PA7gIaC2Shqc0j4l/ISK7U+8jUZtqKOdl1M6CUkTha5PoNVQFg60Dh2Su1kn+cm4Hk5j3EXWYWs6okZgeuiW8yWVISFxpTAtO4Sy7NfmXB8Gjb2bSyvFWspg36kf1xXQBr9kplIzaMOq/rEK8ZA1puSVVgRRsMxMjPtPk85FsZudphbHFK2iNEQuu0+/6WvdL/ztnd0yxWBobESk3P5YoFtGO0NVoZxwMjEoNkp565+5+gL6T8xuE32pATIb6y8G+0m2265NjdUl7fedlv3pje+ofuh217c3XL9Nd0Vh/Yp+YLYazZgXQert2fPTmcHmtcUYVjLDVo69nVbE9P7ev6Snk/GdliLWYzvxs6oTXyPZml/IBh0wlDgr+mTwQf9dRNMsS8JDhmbcvv3yRZTIJEsY60NbT5//rNf6n7j135X4PZUMZNZa47kpYUZljMe4YAcYoXS33Hw0gGxzAJsMuD1TTBBUpjiWCYQgmkBjl5akrCaMG6o6Y19Aawlo/Asp9LILexTk5o2dve+Nk1z/Q2Skbf62zFqVR7mDTyfsrGJhXGjDDv+6EbqaocyMbiJ9Y1FDhoK7Hbl2Y7JAQc7tRdW2WY7ZgR5aLKEwSZTmBNRKGtVy5aGfa2DoppzLFEDVNdzHVJM9Yp9bmRnDgBZxdaOQQZYhqfsJjN6tlTXwv7aBpSYwTI/IP62bBGUGEF9ixOTwC3A1jGEi6F0yp2Se82xNHPHlqV5XgHbvt4RtyU/Yo6WKRqCw3sE1zQSodqbsmqSWuZF7tXuXpK4yWOmlvrH18SuFvOCJUU+OHn0qJ8IqOUQDsmAzeuK0hdjfmANY4Fa+ilseh5nTYIjcITs8PmetrpxQyOf3MD3ibSbV8rLJzmkELM5BxoOWe6r8xd+/mtP3P8v+5t+AH9RPyEUYGsX1Sfv32wXDOVck4z8XMPYYhSPh/elvvp5eakFZe2sebXF4Ak02p1r2YwWy+V4/LxljAEPn/5K5eKFUhN+UFiqjf2Rqz0CjgYSTSq0lbK2FlGrBwgjLPH6hKk9KVC7ohSwdpLgJGkVTVRQDRgj9AxoCedlcBpQ22yJXHvqbQFNbL/+LFs2VFmc2f1Y9ckI05IkXLiAPW/bFsMmN9ulCDvdiYmAbZci9LkG22AEzrLMJ7DZhSWBHSJO6mGlWjysbDUWGLarRZUDiE2B1LBFLaDDrQwDvGLbxGS34C8BJhVQY22wgWrbd2MCPBz8zyfxAr1cxXMNAsNcUK8tqOTkTfw5Advf/v23d0tiaCIEJ2HBaAzXA7f9PBoI/eFno515Yk7062S0YBobG4Yk9l89g9MmpQU6GyE20yNb6lZ6C0TuDEgqekEb4fU33tS97odf173yFS+Xh7RC/Cie6X7Z08I+NceWzQLb/nl1uJh33c26blIGzQKTw/vHr5l9ipinrGG5s0wKJuu+MbBtm+oA2E4UYpm4TucNW9VfV+DIpa49/7g0HEX3ySmQDFCErPKq08UndZD+3X/39u4zn/qCwxWx+dv+FDtSb+oACfvUZAAAIABJREFUP1TqmAvJjlXgFC+hJnMAZEQ5cFg+3dOC1+OQuUMHqJg3JTEC6xqZ4DTYer4TFRiwsh7FmMLS2pknB2fK2yPVukGh6orJAipzH9ZKRtte1WZSCdllFlfl2J6SvigHUgNph6wrRx+Dk4RRpM4944qNsE0KZDaBSY7WBGCeZ56TwxX1xnzLh2lAGFEeyr429sXYstO7OWQClC2fDGaN8Px3A2O9eVftGe0QnjmHnCybYvcHoJjjqUwrlF1su0J7bROQvSAThPM4yZF8Qj+b6VkDZ4DCft5wILAMDFXi2OCurmFgwVzDU1fVhIOuTaA2al6A3H+1mLr5hpf7ht/rgSFhik3t9/sC9Ho0kQxsBsD4qY2rik5w/NlnNW/OyQRhn+OLw+Q7xKUOOswl+jFMurs5e5h/refWAT8ZyiI7A2iz57VoOT5glJwPeVQv753J2pCVmv6z/faF7ssag//620cfmNuWtBX7/fZTffdGtel2ve/WfHp8s+3bENhOOo+t+4A5UOt6gnVa2bO3kICrma9ZN262Aus1eNozGlDtd4HaEJp9J5PZ8jPAMos0i36kXWHBZxMKc5BCo8YYVchLY6I9bRnyFao8UjSeBtQq2PWSYg9u0SaCmNlGJIEmCL1yI5Cah7/NtgASrhTAtsz3Sxg6dmvZBvV18KKnvqljrBqqjQZQeM5K0JjNgBEFuJbzGJtQv/hLOFGOPoStaOkdl6XmXJbAP63g5aflzXrsxAn9vShge1ihpa5xaB82Sse2VF2uuOJKmYYl3SMbJ88IsIw6HX/bpDsEqGsThUbSRQbc3uRGauvsKallb2NrNrns2Px1RK0DtEuVt2PPvu7hbz/V/dq/f1v3yJOK0tJOKz31kD4aM0uxPefoNQaWqk/6b9t8mAZ2Xd9hQe3vjPXwmZ5fbVOnbpUyx4JaVDx2iN6wsJfTdb3gtqCGvt/aXaM0mK969asNam8h5M9Vh7orxKYb1Ebu+wWzt1eM7ZKA0DymCKNpkcauJxPGOm6Tf2wEStc7dPR17AFGVfQyyZsxYDs5ppmR6Zt2sGtsV/1kyveH6MEBYd7q9ezvRJ9y/yE5jLGWCf/Ei7nx4bs+3v3JH727OyETBHiSs1r3sV+NataRCGrjt22hpvxOmEzbzzpepw+gzDnWl9W+aiKxaTHx2aI5tKJDLodr25uSLVHPVYxPyxlLE83hZNQC5MaGNh7rddjVfWdk/1qYxOAlTGpMH8zSYnql62FSOQAz+VawQ9U4b5dq3i+BJ/wTnLCh2FIcxJyxCjOIBqgtT+Oga3ZXZgTVSmucgOROhkOPWeUvntHOXImzS0WTxjzsb5IhUGaIg6ET6zDTW2yWI5vGI/pAUkAsYKsrOahrGJcdklvbAbOwtQK4Zx3TVcDWbHJpbDyZBqRG9ak/LRmnEmu2hGQI+R/tGV81bVmogNrfCui5HLrb16acxi770TV3nAbD9tAhstIXmJVJphOxQCB1K5oy9StxalcVoYcYtXsFbDEViWMz8dwDapN9MxEhKDN1TkUswzyv0izD81pY/qitq2pnbi1ZW21IiDw3IDLYj/G+/i+/9dxXfr467Af6h/rjKnXAf6r3E+qjj15MZwzlWutxfs40RWg3XOzmMq8gbY1Z7zkbqffX7IDrPHz4nMnLxja8fndYgyn7xVlzvE5sWQKZ16MutjodQIsKSW/CTpF5BZGLXJBs73aVMEUVnFdJhMFID/DR2PiDHwkqviTwd1LxA0/LYYzFTUlhBtpGp1oUc9vATvvJAm+LvdkYWrWC/ajVJmFI4w0axq9na9UONqQGlL3+LXwkhORZazFmQVKn3ibAylShjYdxMWo/+sixKAl6DpqM8wehxE4LsOMQZ9ah4j06+DlheARm9yq+ItltDiv3+B797hzmEmD75TiwZw8CO+o924/W4Pd4EXs3vqWekdoRSwUCrTozgk/3G14gtHG2UPieHQo/dGLxTPeH73hf99F777U9V0a+jWUxHAazJeAngW2pg3szm6YejnyMrJ0AymNzf8q8n3Qea3N8NAewAwz4D1sbhgFBbDbMIZU0nlyjze7AwUPdG9/0pu6OO17W3fqim7rrrlJoL/X5Lnl+RxU8OrhcLLAdm+A1BhcrhybLyprdqLR2sJx9XTap2ogHm+C05836bKh1atescR4bqJNzzfqSuQHb1sTMv+kybKO+Gbae1LkcXAjvxbp8+Ovf7H7jN363e+Sbj1qjwaEUgyLWmIPPmwXNYREwt530sDhotUM1oETfRSUuZx7WtOYbYITJTorV7eWNzz1EYbEaXxpFLwEB2HPyQsckJmwwcoMEBzErwNGLKASMEYB4aGlhZrZ8ChDYZmAlK+wIBZiskFqYz8DY7nD4LwEigWESKRh+I6+MIsP2NjMniAyAcZI9kAhHsrgiyVAGVcdGl+gOsb3EdADZkriprJmsPwiFHSYsaBdq9qSvrfVYB+uRHK7RtLwKDou5FoXpA4CzzcQiSjg0bJdjGE5jhPg6p5/nBHABto7Za/qxTALKHCHgvJnN1ZxSf+c40m80foCv816Q58V+tUwRfGhOO+IxUQKuQGtboy65QD2s7xaNh/9GRvPmIAGwxXREew1ZvlYdnWfRz9sjub9T4dSI8IAZCRqEaBULZBZb3APVPHikAZ6yQNrO7q9KJrdf+02lF8oxBckYnf+IbvjH3z7+tYc3IyO+X69Vv9ApLbzXe9RHo9SFm2j0poHtJsq+vJcO5Xb9Psk4rfvAdZBrD6JK0E8DtpOQ0hNZY9BOkW0SN1Z1BGRTettYEIjOWEMgb324rEWI8F7RwlomELkW5IIE/t5dAmQCZXtwjiobs6h4imFwXceWk/+yyNIzEPSLCi21KMbk9HGBPnt4SnCXPLPsHSxAq5gM2lqbAljDdsRWlZfDamGqwAZg4RS22SDIZUeQOdSMgW3YCV5Zx9rmHISdPokKrQUeb2rxBgzC9iJ8EzMXRxAnpcEqi75oZhI4b0g4kWISswsCtbNx0GbUTKS55BlEUCD2JJvDWQk1wudcefjK7gqleUQ1RZYhOxL0KjH1hT7Lyzxs9bl7pQTywKzE9aWdhEdTBqFdUumJsV29sK370/d+qHunwn1xaonojpnDOIhpwCl907/aBC0A2wMwnjWhtRgHZ5nJw8NPBGobj7WItwFeR5ywoxgbsrzIzbDXXFa9HZCcTUkbLoz4HXfc0b1RURAAtdcrOHuYWoUw4oTmSlx+YJt11SDaqLsu5reNQO1aVn0oNQZDtSE4vpjaAUbGwfTQTnLjEkfj3K+tSwC27ne9AaYHFI+YA/lXH3y4++N3vLu7//NfSrIBDp8AO11I9rlVO16RkUlhthzKK8x9bO7PyQZbQFSfAtic8UsHIhhNGP3tkoMkPMHmFrAHyMLudSfhrvQCMBv8wZgqqx/2szt1DzMO+0XkKYAW1pa1j33sTkI7af4aSOo6R1uoehlkWzUcGeYUuVoziXNLua0Ocsgl7JYaCSjFRAFzB35ih5uEA8R7VfIbXXdAwf8BUiSO2KeoIdQX8ypME9CI5JWDEY5i3LtL+wCyDRDryA2sXZsNxWaWNUZ6dJjm3gTLxQQUDqej+9zmDJHpTmGNdotQjEhVAWZMPLarr+3kKhkGsL1AqDR9x/c+HZT8MCFi+dKMHArUek0229vap9gr6/Dl2Qggr3vb/M3nVablfCISBLjrg9orkL1Ozw4Trc+2AUqxrUYm2awFkIp2kM9kwkb/qf+ZJ8QNxgQFtnZVNswhQ8Lmt/qEFa9Jrh/MhTDBuSqyoN2R2rtbStCO1li1bAr7pGseUjv+6WMnvrZp+9HWX9+PP9Uvd6pdr9V7U+G9JvvikoDt2m0xxY+L4MvT/b0g7+fKrKfPeN4GwHb4dYMyrSQmqjN2IRAKjGHvg0ejF+tw4hpw0QkBMMVzVdYUOWVakCgTiwTaErH0BLqWtPAW9XMZJkHfI+SvlhA8LHbxgBYiOaXbI/xzrOn1QTXAgFInWNLjLp5UnD4FoCYZgwGl6m4PTWxKq3EGs3ZWCGgjzaDhs1UyFFphTgxss9r7zFt+ZsqzzVwrVZflBAxjQUiu9h2n3pykW6xcn4pLaLnu7W8Eo9WqqMsqWgF9W0J9BLEivFFFUjvYHxwBUDktKgHFik7pZ2S+0Lxdswlmw3KcReqt+gHOrpLq/NobrteJXoBUG4YxdQFHt896o4B5gFpsvgYC2+yzvkedp8Dm26TGwxThtFLHvu8Dd3fvfO8HFDNX/WqnEU8Sj0JAev7ORhTmYdpr0nFwmjlBvwg9NcsurQrzmFitOXrlwMQrDK3/cXjh7f7mFFKmKcwIVdIRI/Q9drW33HJz9+Y3vaF72Utf0t14/bXdVVcclEpYTK1z3LeyR+25XIwtNR4LTdb36NSuW/fDzQLbVlgbt/G/h2M6/XCx2RpO1q/fRGfMk43KbweC8dmRu4biZTgLh6w+vx88sFfmByfkGPYH3Uc/ek8C0lf0AYM6rVunkFWZJ2Tbv9OyTKYDBLZXvb1WBVCZD1YFOyyWQsEJeBi8wGQCMjVf+xSvAECtL+rF/TYbMEhLxA4OrAayArYkomH2IT+b2h/5a8/+Ooi3AwtmEj4Aq13Iq5bGO4REO7SX8y4mDqWxcNxam19F3Z/ILwDlxJ7FsQ1bWbIR0k4ALoCWdbZCaK8Cp/QJTC5yZQfOWtj0Qn6oPWg8OJgDot3wBqCY78Zg8SuIeEaGhFGdPGNNbh2eA5KHNvWQ0y9s7TaBWswQiD17QeD8nA4A5wHpaA+dZS32+J4XKrCZEQznTTBf7zpWU7H2HPoT2VH2zG3+cY9/F3MRUxHaT2zeyuiFWQFRI9iDq19iwoL2Lgki4rDHZhAG1/s2MWTVh3Gq0wFEhyza0oiDgPyUGxvmJFvIK4fmfj0g2ydxhOeHhy3XDcBtD3DrIOASL1x4VD/+z8dOfe23NlqjP2jfq2/2qs0/qzdJKN6ntT19E5yjY76ngO0c7Zl9yeSEHFw5ghiey2V72qZ2bCg55cM68DtrCXuoHc4ik41/dEpj2SJYRqxY2EadwrXYcHg6qRP8KTELx1YUU5bfsRn1qV5OCCrryr37u1sPX9tdd/BAd1DChrR7ZkjXSqZaR1Hv8TU2YysGtSdkhnAiaXIJRG5hEjOHSJCCZOVkZUcJ6u1FPWILmxPXqDfKZmi42gFDqMgsjMv+0uXkmfFQDigG1PokbvV92UbxRNR7Dije7DfDa0awwGYk7W0LFxZmGMFeA2twRv0B9jiqnHMgdINcebuunl7SxiUmd5U4hYRz0SGCZA6qBuwP47qs79iMDl0BwL3ONqO7BXIx7jPg7p3taEoYj57lpoMMGnfIaldtxk5NwHZBh5Njeva73vOR7t0Cttt3Sz2K0B9IyOH8adOyOXcMwe/k5PacK8nbTAhGTiQZ436Hq/FqMWlbWb35iMenoh5wm+d1EnLYe7vUx22tOJ2xxv3Kw4e71yqs12te9UqxtTfLrvagky8QHzRrYMA810Px/t1MVIRZi3qSGWlT8mKk4UbAdv06bPTEkg9GSetLsUlmeCOZt7FT2doSLqatDQi30la0lr7y5a9273jbn3VfkxbV8VXRiqBudwgs1Po4YibuKbFXd2L/jokQMaZh+fTdgthAJqrBp9hTpyHVTTCfLXFCiy1r+1cO0YBAycrIloTucqpdrT8AMGDacWX1PYzmWdY7SRZw/OJQBjAzgIWxjNaE7xkanonU4f6EDwsTzJdOg2ptFbF3CTEmlpeIDET7wIbXQf1J/iAVfplOtfVFGWiUdkkFTrlolcwMqw6OeKAHtGcDyB2xQXWB3a7TdB00Ez2Bz/w9WdHqWNp0F03r1uRKfyABMNLvllsyrSCKgvcmtdvmB/JFkAmVUrfqrbHDcQ9WHFAr9tbMJeYC3k2qrOwamRYR8flVMm4EChN2qwS2oxXYXJn6IFdzarazl1McE3ecj3DiwqYOUMr+UIefRNIBvErOc5iijAKkvZkFZVrLFCe+hLTU3MRExRnlUleY32gOm7PXrBWXxk0eFlqzfVf/5fjBouKfP60S/vVjp7/+Kxut6R/U7zUf/hO1/Rq979JYPX0p/XBJwHbWgzcW8xN39pvuRlJ/+n1zdcCcwLbHjl5wWac4CyyR3MApBJPJhsW8DcbWAihBves/UEGWuj8KO3dGgg9zg9M6lZ9YltMTHpr6eUp/ky5xBUEodcpuCZGr9x7sbjt8XXeT7BQPKdbeThiEArZDxWu41WwQfpzKQCgunVqUTe3xblksyQUEX51g7YFq6d3AacCLNwvETtWXBRqBwytqq1nMoBk+yEw2NjYNgGYJUO6ljg53U8B2q/rByTP1E2EUOC1Bozq2Q0Mc1mAFYYnZhBBEAZb2ey62pZeitN3A1q4EjhsJc9TslxHexChckZMZPzFRgJ1BhYc9Vk77scdyZiEdOryhCIAdvu4as7gHr7zC6lFJxWIF4gEMK2U/bOqHQEadJ9u7bahWYT7E1Dz57NHuD//4/d0nPvMZlaHNwsB2LeAbmh8M2bGN5rflKX1eJh8WsNXfTdb2ANaXtpmdeeBoBb2Kk6fV5mfGlrnd7H8TgZKyiSG8U446t7/s9u41r3ml2VryxBOvFrYWoOKDR/+slMurMbbEOyUG6aW+Guj6rgFbL5T1QWsbo+91YHtcge0//KGPWLVLmtRPfvLzNa6AQ6WFFRjq1cR10LWTKXPeoQQQP5XAxQwZZlnKwiW5xyGc7E+sPWLF0qeAOB+ikEOAVtLolvkW6v9M9cgx2FAyjEW8RDMD0GZttzB1lgmaKHbeKvaUwyk1s3MY8lp1MhMsueC6EuvWcj+gmcM7REdLZrJXMprQXGiHAObUHbDttlaq4LavoPZn/TSiwWREgfDIyIDsxIsW+NR3zG/7NrBO9TtA2J81O+t+AUX7tdZ+PrLGfVWyOd7/apP+JrXt1u1iaiWztuAbQCQGmHEOKIB6wn/hdEc/mZosPWS4hZrSLPbsR5H7ZWpVsDdrU3Xm8AM7Sj+rH2OXzNhK3po51d84AnrPSkxis7SQFQ732EAobHZM2qhStHvRdA1BdwsnydPxt8DUjCqaqbVjYOrlf/zhvyO7qsr+4aHpXzFTcdutxWsb8DTkc+E5RYz5vy+cXPyVx7vH4135wmtND6jvmwnCw1oHn77ULpob2M4b7qttmYM5MAJFxa6tga9eIA3drtOkafNmAyw8TweN1Vl/5DSZEyfOSuTyPi0gdFrACHMBUiom8SwnWENcA0+rxCxsIkBI9Zp/ApxSiZw5J7MDlXXqjMCtGI9F/cQcQZrq7gzA8OzWbqeA0zV7D3W3XnVtd708+q8S42dgSx8VWBlZsRulpolmKxQc/dRSt6wwO4uKGnBOAE27hhoTMwTXFMBRoWlcXjG2NuJ3/7LqKw2tnxfg4TVfC7ixSgZLINMSsLDFkRMRuhbG3hgS29YsiYTpNp20qY/NIwqYt/iFzY6pRWHAI9/jgyBGAAKDYVVcl8waf9/AGSAcm1yAs+usOsEYWZBx6iejDJuQvGHJcU4+dt8Tuy36irLpy5MyZTgNs6KN7UrZ4R6W7SixD3FkMbMAy6CkDu433X9mVfdrs91/4KAiIugabQjP6ZDx+b/8m+5P3/8X3TGiUrCZozosVdxwSo+YtBKytHBcom4wnQNIh+WMJHRuHZbXIjskNBpjGTs/HjnaIDP3HMUDFTDX4fQiYHv9jTcotNdrnDL3RYqCcNUhsbVyJtrh9MuesHRML/cnge1moyJMa/yQtZ3Yi9KWmh8bdNzY15thNEe4fWT7Pr2etYimyKtZh8Z56rxZxnYzbRs+/7S0Hu9+1/u6D773w91P/sSPeA7cdde9PuyjRscWFptX1n1MfMBF+tvsqNhOrSdAH1PCiQQ4FDKfAGrEr9V1UtAjTGzmAsgE8Do6gJ4F28lrt9hQM40e2xy+Y8NP2lpFIrDDbYgAbCtdYs3Z2MtiikD4OmLgVgazsuNFPQ6o4hWAlrSpNoMgs5mYvqTLbYlmRodsHHV3LCiNtvrA2iBsP3XIBTgCfjBXgHG0Ta7tcTnUwxgHkCVhwyjObMC25FAx0/SB0/RaRmUdJ0xf1nvU52EU2x7Uxq/fk9p6oM8BirCV1G1hn00QOISfL0BrYAtra7OJmCH4WV5UVKCkbwN1tKai97j3HIO8Ab7YyvrgTtgyDgwq5qxCnMGoOj4wbCztN8kAeI2dLKYSEeQhWMzIVltrtzE50sK7pQ8CvmsziizTVQsiJhzLHADsPotW0H83SeFtZWSMuHa5Zl6kZSnXD2qC3L96HKROv/Bvlha3/OLR7usn5lnLP6jXaCyIgvAP9Ab4v1fz7JLZjk0AWzGBy6g9Bq8pQnoNsGWetM15CrDti5hzAx8+suGwS50Qk8A252kJFcCKTthLEqqLOCbpRE5u8CUBWw6SaIRYq7Y1J3yN1etR1CBrF3bAVsquR+9ui4TsVpk0COAuqczTElgrOrEuaXEvSyW+fI7sOEr3uHVBYPZgd8Ohq7qrMUXQKXoXpghueG3Tg04AVLOoENoJ7YXD2HHblCIkwlwm8DkMAAIWhx+XxgJ2wVGdWDB5kUcwtSdGWIwASjsRx+5U3+IBa/DYGIOAz4T1GU/0sAW1kGLZEizbDgSDZ3ocPKgFXAtM85nLrrlkO1NVOM5t1K7AbxP2KhpfbN9QoBPgTBl1gx4tYbqit8A/bIBtb72xkLc7zC8bKHZvJLc4ceykmaT9Bw501954fXdAdqQLbLrV/1Fp6mAiW90F2Qielc3a08cXFcP2b7p7Pn1f98SRI7a9depJ2mHrkenqr/XBxzygd3JhuudqzEfftYgVAaDMj8RXzFLMPWaOzGDEhpFf8XC/8uqru9fIBOEVd9ze3XyjDmFXH5Zt+C5HQbB9Ygn/gOTxFTrNxnaaOcY863oaIzx83DSwO0+57oHJik+5ccTyZLOf9Zosa9jeIbCd55nDZzzfwJb5/7733tW9990flBZosXvrW1/XXXftYcWmvb974klpC626r/BUrEnYxJyEKhwgzGeAA6YAgE2YOJyY7ABVYBPAaEHK6jd4DFMJg8tcRMPCrGqHWggG2NmkKE3oQdvZ69G26y5hYjtxlQCIS4ithB0DNBuEYmOq+3AqQgacB8CW9iIh7i4YjAI6YWuZ17b9RXNT9QnoDcMKEHUGKbKFWeYoogOmCTgpAd4A/I7Ni9AOw9in8QW06oXcaY6b9Ke9HwDizUHMGsEA/9gWJ8nECF2NJuKQhHDfel4nLrAjNWxThjGl/d4qYIvJwRa0UsXYbmFMDGgTxzqHFOZ5GO0AxJIV+ol/RgAe4BNiIaZm7D8G8MhX28kSVzaserLLEWoLWZiwZTYnKwa2pZnttYl6QOLzBkD269sHJIB+VkcjPtqBwaHXaA8j2Nhd6mbQPJIY/NaHcuTqIVGAbBz0clWiX44u5vyFZdXq1y8sLf4rMbTPzpIHL3zejxODQhQEYud9QP197HL0zZzA9utHON0G2NYtxhZrJfk0YDsc+ck7otnoz3ZT2jSxK45dQSXGb7mYDbLNayc28KoQ64BaX4Jj+YzsMsWsrurnikwHYOUWl6WuFtF35gxqI06S3IWNWdgHFignbCVbUnSDrlNSHgFcBCoLCeZWLK3W98pZORCck72V39oUugU7DuyXN/0VChN1UPZYu6UaWlAK0gDb8ZcdgRBVagBxCBcV2uvEsee6FdnWAmptsyQhguBmgWPbmHSOEYYN0MDCNX//0UYdkGdBbqHjjnEFmlq7CYA6oTq2o68pAWC4pN95JhEHfPomjzveyQi9MkVo/W/h7NNyE5CRObFMqFNyCq26F27le57bewKXrW4JMKvI/HUEstlH7rDtVjYqb4pWbRFaB8YnwdDZZLBZXtKmTkzOkzo47JPH/6GrrlA4q31Su+9xdbGhW9BYkQmNFJRPHjvVffILX+ruue+z3ZETx0i3YQDupnlzmA1sZy3sEYgbTobJ9RHR22y8h/cM16vHsA406U9MUtqBp30X5ku0jR0M2U7ol/2HDnR3vvLO7tXY1d58Y3ft4UMO7bVnt1R9NpkJsPVwDjcGNyyhixLHlnTL5ZG85rrZ4q21Y9S21gcFaPyU0WcXKyjnAZnj1/DMNVtfWl2TfCMGfp5nDtszCWxH7Z6/1W39DWcVwOdDH/ho9ydvf093QnMeB87bbrtFh5k7ur998CFFQfh6nMAAcwInuwQyAXXIG1TxPvQiQwXozujwTvpSAz2coRynNiCJe7fDCNo0QOyvU07n8BYbdhhgebWrXGJUU0fYX+bNbmlFbE5QgIUvsZs1YNL3AN5dAsYOF4hcZhx86AoRAPgEtAKQUYlTl9gIE0IMuVOyj3mPBor7YTQwicKXoBhKAC/rgqgNjAfyowEr2pIQZzF3Yp05XJnqZ0AMKKcvDGozZx3BpbRczCeuRQOFLPJOUyZHPZFimdlAZura5qHlZq1DyoY5BWjG3EFgT06uO/YcUOQDsbU4e5KIwTa1kgUcPgrQet6WzAgDSlkBhgBR9po+iyRMK1nTKjJG9iDil8f8DMFgH4vGzMLSNqNXy/FiVHM6yYpqsrzmRuRKvw1kf6AuhUmaA1jwNwek5ucRM4S2Jtvvw9XS9jf3V8ml4bocP4i6JPe3yI3fXNl67l88u/itJ+ZffT/YV6pff0w9cLPen1e/fvVy9cZQlrXVwM+JOLYA27NSyyoNYQMenudT0Fa/PKdXcc0d6+HWiKIsoinljoIdb647moNNTp0lTlrFBFKxhcV7dvksDl1yNjon9vN8stysqB+WBWzlD6QFgiot4JZTrdXlXrgCthJuu6Sa0v7d7dml2HkCt1vFsAOcYILP6jlnBWjlaiAQDeAhqwsn4+3dLgEjwtXslHDZWUI7YU9qw3Zdrcj3YKh3AAAgAElEQVRCClrwrSg96SmF9ToNWyt2WWSxewzbsDALAZhOg2tgG2e0LOKoXvp4iBYSLP6oVwF9LsOpVUfjbouq1m+qCiZ0WeIjxhvBTezG7XbUEEsgE4ytmCC4PQjD1DPFDKdgG1P1k+1r03ZPF9vU8TPPMYBKMRaKzTGrpeq11QMbpUFaVdgOUTDsbFhsLtjLAuALdHsbiz0tts/Y5y4plNgJJbvYIRXjtddda4cYWBgcQnYqLM8OOWBsk13t08eOdff95V93H7/vc93Tzz3XnS8nmjbVYw9cm1gJ5OEMbutqCAozHtPXm7ukBmIqgGp4q65rfzpVLpukN4SwteneOI21OLZOQ8zn6r/9B/Z3tytW7atedWd3y403djdeJ/MM2dXuwq4Wh3VbNUyASnIt9+ObjX+P2N1Ls7GNbBh7DeZifxDq59T4pe2v9QDnZkGmp2DN55G50PrPHY7dZJ2m3zn700z/Uq9u5mavn8hCDsF3f+QT3Tv/6E+7I888G4ZUbTqow8xP/cd/r3tW9uKf+NhnKgYtDlGyVdd9OwrgmtmTnHGQfEAU6EMyDXbUUQf0D9BmNXJpUEjhGkaUaAnJghWtiVagJhRmCNQjkQ7kCNaAnwEjCQ/kzKU1Gk1O7DU56HPoZF047CCmYp7EsJsC09UuGm0fCF2PiYDtzW2fm2tXVS52vYBFnNB2Yi+sdW+nLbUL21OevyhTBIAc12J6xvqxnBeYs3OZ+oJ4qYTNsszC9Ak2ttVPVYfFZv+Iw2YAPesyiXB0SBAIN4Nplja+EZgUtINJG/IhMBubU2UO4IM8Y7ZDoBaHMTG2pM7dqoMp2jyc47JHlAwo8qTN6WDQmATYFhaGuRhX9htHFiCEGEAetp5YwsQur+dHI8if/C/vFtWhT+muR3juMKT87vJrzbdNpwSZscFEJzRAz/haa+g+HAHfBoSH9w2/nyQB+K6lXh7KZ/pXoPz35SD5C08tf+sbm1l2P+jXqk9foj54s96PqU8/djn7Y35gq0W4JDW8p1lRmxuxD5de0Uz6BneG5XmKB93M9ZjxU1Y2RAMwFhWTs0pBsC8LqC5JiC2dUe7o8xKqYlnZ2g0gV2Q2oPeSwC3A1sKUMurAjWBEGAPkYEixN9y1U0I5SVtMSDpUjDb782LCCA2DKb3zcxMI3IswCxHRbocG2tmrXyyKgZn2LoUFIBbjomw5AbYrp2XHCfOAvZgXYyyR2ChGbG1FWdDnOfwHeNigHzVQsQchXeL0gQxqAtd9pypV0BdGwr1ZviEui2dzOHBIKG1ksM5WOWkDwI4DENl4em+CFmCpRw9ZfPBInFhzx/bIzcMtvIvGbiYJMVvN2Lrtfgc8exb5v9GcoR+tyitgG6BOIZgmsPEm6xtFMvawT5ihUN41cpSCpTl65Fn37R4xlpT19JHnuvu//OXuC3/1JZkfHBWjpViVSabe163lVqee6evMxkZBTK6rXqBPnevp+2lrsbEafadWv7mHi6HNISTPZ3x5RNSgmYc+THhwtoqp3tu99GUvLaZWSRiuOdxdcXB/mFpYboPatpKqWU1eDPqddbFb9yzqMIZX+cW/UvORDKhnuysbg7W+jPi7CGzb/N1sv3jdXCSwZQ3ee/cnu7f/7tu7Jx9/ymCkASrm9k/8/R81uLtbdrU4/DlUF7a0eh6xoVkjyCJCKQHmspZYs2VaQAIFr2GSuyRWdJM6zAGYWsAmIJbvOUzz4sDJGtmlgxCyaFGmEQCu7TDEhArTpEsYKD0Pual5eN6RBABuO206xvoETNM/gEVCUwO0UV0z/rbdlzzGHIIoKgbUAtmWK6qvgbjV/rSAhA+0W4BJbXXMUxVs5163ucmwxPLGbAcU59iqeo5DZtlkC3KDGLuql6PB5Hv6jPUB0LZTWTknh7HEYYrrMjPyTJ6TqAp5jdbE5GHXYJqkBPSbDuEL0gzu2K2oL4reIkQutjYn08YWJ+JLFennJxSWu4V9BbMTm3CpP5qNLH2pehvI2h44dERIhOxFUf+Pats7fNEm+rgAa9ZBzAvS5uxptNUylB3D16816RpePwS2vquA8QgsV10GwHeaPB0CX9+xpXvn+TMX/pfHV75x2ZjGGsTv+x/qy6vVyJ/WG7taQntN2LleWhfMDWwJuu084Aa1ue1yAttpwNOz/3kAtn2XpfgIDP1CdsVlLdAT8tY+ragFZy5IiMpak0iMW2FYpVI7c0betzZDqGQBqK6IeQprWw42C1ZnJUwSwhY1PJtCHACS9QpzI8cbtHNEAogT55FTe1vZPczLkTTVZrNwn6DOwblANsBycCLD2KLYRDuMlRkC/YdwBqTAGiDgk1yhfvZAxw8weA4QRADFfMFCB2CL0DHLG6DgutG+Eqje2JoAS2lmLLjabUPFaGBL/TSPqKPhZqmtm6Rz+2qEXC0Ac0BK88htjESLuZrviwXoby5woyK8+QyAVYBg6p9IEbGpzRkimw6b5XmZiiQRSiIznEGlBlGhT8i0taS+//rffr07efKYQ8jgQPLkU093jzzxRHdcBwwcA1cwOREQsEAvaplwQ20NjTEN1H2wthqrkN4MeB0HYoMdYN31mA3KVze2w2A1zJBtF80AFUPjU0vmLCMPsD2kqBAvvu3W7k6ly73txS9SWC85NsrOmEQigAmH03GuzElg64kSuVEvgMse2elg2pRwRZfrZWjnwiYZ29b+zTzpohjb2oBHAGP6E4dlz9R8DebyPPW+WGD76Y9/qvuD3/697tFvPlIkag7nBov6+fd/5idkOrK7u/uj98oc51TCX7HmADkCO2gwmtkJgNAppkPrWavBvEK9v6yDzDY7mMURKtFWshYI+7W8SPhKTDwDKhMuLIDIYb1gGvUn4NkqcGSq5hYAmzmMuvmcSAj+xkyB7kPTGNlHultU4tjQUiTyDTvYyKmdYi6RpU0ONG0Pbd0h0LdI3VQg7YOlBHwS63VlOdkNzbA60UFScwP8aSd9wf4AoLYZhp3bYraAhs5z1ex2wB+RHvjdoQoxPSj71oDXyKYGnr2yvJ7bnM/fa+dtHTLoDxE2PGdhlxKoKKzkDpmIkCFxGwktLBNKFiDbDWIR7NFCAmJ9GOBt060kQIiNLNfEjjYht+Ls1ZMk1KukA0Paqm3YW8vWjx9M9ADatqbzTa/palpG7jCLvXaFNGKHcUg4uHHZNJKvo3tpb0w5Rq/h+qQsObd9QLDgf3509eG/nmddvnDNeA+o30kj+A/1BkZgV3vZnes2D2wHAOFyAtsZ4n9uYDsdGK+dnD0wsAiLcEZYrgq8LWrhHpdAee7UCUU/WJQAUuxFmE7WlkIXwNaeVeSCC2Ly4hCRRYDQNgQoByK8e8kdzvrABs2AokACHp8Iu1U7OgBod9gpgRznJAnYKfMFx1cE41hy1XP4tQCOFziCkIwzqu+ivO2JhLCq3OmkzcWWKaoeAmah+hVjKtDcgCkn/ea84X6zoKcvYn/VkGVEJp/74WMHmRHoHrGsYQRiM4mkCeMhxlpC0/EpUZshWGWvnHi2FTfSgDrt7BnVAqveHgs0+3uD8VH4M/62CQT9VarNScFusqDHjAXMrYEvxhZhbvvbjJkFuMbHUR4wE4HTlZPFOV1wHrW8fu5V5qCTMs35/Oc+3z315KMCaacr65FYXQFa4myuqL2L2viwB0waTngqHYowIzFTHG2st6VaibSnhVcbss8brbXZ3xe73Q4gHpowadvEJtscoTYzez4DOnC883iT8lRmFwp3dgeAVjaWN11/XXf4StnUCujsFTglTqgjbdBvbl0OM+Ov9Hl7ARaeP2Dr1bEG2LaoHO3MNKzfLNB7McC2lTsM3bamO2r9ts8vCdgOzjY+/Pl4Oa2Va2vxxfvu737vN3+newh7WdTgMHJaTGbsPQG67kd/8q3KzHdld9+nPqd5/pSDpFzQId8HcL2Y0w71B6ApkGLm1AedaCRsE6oqcbxiLWa9holjDtqZC7mDrCoA5CxlyAzL1bJP1RWATNYSs8yJDphZxYRSn7OKPEPdiZ1N6MNEVUDfJrBINAUYZjRpfGbZr5JwdMV0wLF3+Zw42JGfe2TX6yyGAm/Y+FLfxaXTlvusU0A2a2RRtmluq4DvbsnapPhVHQFUqj9MtNlYOWeh+QngTegyDgY+3pvhxEwrcziyAHveSjwwMYQNmDnerwFZyeI6EAUYNnCYPqeNAOoFMbW79h+0KYIqkrFzX7JpQdLkcOI4sfS/WWoNnu53fcwyR97b6asIEa5hbtim1q/RXLTc4RPL47VzdO06CBBNdzS2lkqa1vF3OZYXUp5SJs9pMYHbYcVzppDwZD2mHwyqJVJq6Mn/02NL3/zM2tX0wifz9ID6G8HxM3of0Puj6u8n57lvs9dcBLBtrN1mH3Ux1wexjG+Lo+UyNEXYLLBtCx62b1UORKfFqh0T4/asmLaTiye0eFfFRu1QWlvZTcqx68ySFrRTcxO0u9It2lY0WbY4ufLyiRzhiOoK4efVl5zmwJoGiHEG4AU7QQxHnC/27FMMUMXZAyzAqgZzZkEDuMwoehnDoiJ0FFFB6RkXlf1nWfU+g50Xwhu2QGU7xJWuRchjPwaIblEKGkDsM1m5HVEt8Z3BilmEslm1lIyYCcsX4dTEk1V6ZkYDEA28q+3YC5NxyA4UAt4GtlL3h7FNmVHPDeZIlZ1HhoUwLHQ/xL6stcHCEuA6EOLcNjqhZwa1OdJYjrAzYTPzOymAeVY2gLOaF+cJemk7NzmhwPrwHP3cLSexU6eXu/u/cH/39FOPauMTgBXLjw32qvphWYB2RWpQDjDLZJhTZAUYXzbMVYHlAO0S9K2txRQMVV4bgavxNo02jCa846TDs2KX575mTZmdZY5Fs2C7urrmLEHRxcLuU/a7F71YLK0cxV4kJ7HrroGlPSS7cQFabeCY2VAOMUoZI8wQmmFDgOxaiOs10oDtUkD/5X15NtTGOarDRlBvnAlPjTbq+3nqPQK44/D5sjG21bDW05YxGwDbv33gb7vf+dXf7h78q68EOCLHBn3WstW96S1v6G665abugS8/2D3wNw/GVCVLsOz99Us5Krk9ADHmVqPPPL9Z4zlZ5ijHX1nPcWgt9ree78MlTCqsYH1m9b0BVMAbTrr4IiSjIWIldqlJZRswyMGUOW1bV0JbNZpQt/hQb21STKwiP2KDb3CnOrQoCNaw2bQrWjWTBaDzAbDFtKwoa6fAtd2rPiP1LzLIIA8xwgGgACMsMQ+CSd6utjTwbic8yUjAN5cAgkfZGMfn5BCcNZkxDPXVvodVNyYl+gvAU45i+w4ckgXCfvcRRh/sR1tNjod5TczYxAI2C2tmNmAW8Ot5g0yu9rSx8jjX4Xy4PkaAsWnkpq3ISXkxYljH21ol1344BM/DZwZEx1m1rWePb82/Nk3bdzPJgQvdZ9UNPy+Tg7vmWfMvXDO7BzRPf0rfXq/3F9TfDz5ffTUnsH3oiE0RtFkPAcLMSk3fzy6iDbOBrU9t5VlLwRsxWpMTPrajAqx2EjvbHdUm+5SiCTy3JPZTbO1Oee4e0Al9z1blyRZLe25VSxfVtNZ91GgJIG0Wwkwcgj1CGS/XbVbLVngaGASzBgXA+FkqW7qK73bKvmlBAgdQi+rKnr5VPszHKM5sACACFi9kzA9OyVlpVSwCzglRDUU4NZtXAulTdhi5gNbG0qWWEQAIVySgATXX6Mtmh9TzcP6+DAiMRAMiHGPRwDbgKVlqIogBtj2rbeCNM57UbI6MkE2vMcNN3JmtaEjXgtTKLde1ef2mDWFQ3QqXlZE2EDaLUKKMOpf3cF2RsvymHL7Hji5j46rxXNh5frL58Cw2d43XLqnvjkkt+zeypT3+3BEBWCV+0Jt1cobQZ5ghLIe5JdYnbJFDxgn4rii0mw8d9HnNHzo9TjdDWDIS/mOgfzDfG4AdbhNt+Y3WxMiExGPnsaHNgAOirQTgcygzEJPG4Iqrr+xuvuWW7iUvuc1M7Y2yKb5S9rT79u62k0/IIcaIfoqpRQ5e/QhOrPeRUABYXLrz2CxxMglsU8+NgO200r5zwDZrZp7XmjpN3BZJNL2sh7/2UPcO2dD+5X1fsA25gUros/5nO2y94pUv717+itu7xx99QqG9Ph/cpgraybKAi1XoZm4Bs7Hb9zptGhiwG+uK7w14OJAmkUsDqdZqNbYXwGo5yYfR3nj1xnbAz+VlYIs5FXuAn8Uqio04vyOHCLFlJljr0FnC1C+27a1ybG6EboI0vs2Olb4roGu5rPWw0mLuAst96E2qcdbP9mJaMRlA9BDfGp+IZZzdVADriWcDjukbfjqGLWBZ8rL5PLAVYGYBqDTo9rZXbGUjFiLVxg7/o0Nt9pWA28z3jEnkomPF6pmwwxxEdwnQ7tGhFRthA3vawxjYTtboNgDeCWuyJ1guuS7YRpeGpsn/7GzR+vVPH03pIYB0KyaF2djEH4KHyXncyInMn+GePzQhmCzfEW7Y29w1zXhufLVNM0HQFX+tJ/2vjy9+8z3zrM0Xrlm/BzQub9AVL9P7IY3d88p6zw1syaSyZGCbybHha45LNiyjFkDO5RMvswE5OaZK6z1wtECykL0MbeeKWuukbKuekTr/cYXKgrWlqANyVtgnA/udF6SmEaBlMW8Ri47tJaoqTrPbMUNwVq3YexnYAmr1EwHXgBf1g6VyAO4eFJaKrkArzjdxfsgGYfCpirKR+F9tKBYu2IohsMUIkogBxnZVXvuc9DElaA4GbAAOeaO2oMKjDg5bQ9nYUKbKAYF2pIgwDXAMm2p1k8dh1L89x4nAQygWKxEHh9hoWfvIBsQG4MDlSZVpRlmg1g4HsocLK5Ax8WZWgqcPiUjbB8DW7hIGn5mHRGqwiUUDL7VptkJjnZBNsj/1c6sZGzc+PBJjp8OIt9I6lGTPD5g9v0WOIgVstyhGLc4nzz57pPvagw9KDalkGITQOU+qXrLThe3Fvo/fCeuzRPpkjdGiQO6yzFqWcL7RdDiLDbEPSaoDfWRg2+Zrze1+6jdGqRjzwZgE4E5ZJh7LtoLKISyN9cWOfsAYCeQS9mj//n3d1XIKu0Gxem9S0oXrr1eM2huvSfIFxa5bkEbBoYCYMwYVIyDjdbC2CjV3Rt/YeUyHLcJ9DZ3HLgeQDDAbHXAyUwLAN/u61Prk/rGtvq/COGPbxme8knM9f6JddUQcAw+PfvvR7l1/9M7us/d+xuApZ8mouJEjNgvwevJRvPuh21/cvVLA9rmjx7qPf+Se0rxkjTWpGzkRFXjTnDQnz+bUNIqtyhquRc7atV0tshLZETU23eQUziQ1MDNIudhGKqUrIwqjqOetSsZZRhpcEz6qxYHN/c2e3mp+zLJ6kFemYbC6OH1JKxHnrDyTZ7SQYABWXoBP5g2RDugna52IamOACHlRDC7AWesIMI0jL+tiR2W4Yu1n5gOGdY8Ohdi5Nocm5C5hx2ympOchJ4n8QH84Ni9mAMgqL+7pwDZiLCMfOTeaFP5cwNbxYilT9r97ZFuLrXPCUwb025627J5zz9AhC0Y6oH80n6tNtUcPt4gxaFoAtM3lEXO7udXYgOzw/uGeb/k5RfhQZcxiJh3FJvHCGFC+0H1NPfALjy99822bq+ULV8/qAfXv6/TdK/R+Un3/kee7p+YCtl958GGH+7Lz2IxXll1eAR2XoepMVoqadcqa+znZXMwsFvCJIMC5QMBWAu6ZU6e7x5872h2XUf/u7QK12uR3i63dJlALsEKogUudxk8ClWxge7U5JyB9oEMf4L421hYAv6k+vLiNKQoaEu/eDlnZHBwVyWgzDmRsIjuKlc5JOgDUwFYCc9XxVU/aDAHHB8K4AG7NBjqaACBWgEUe6ARHd6gvMw0tlFOJ/aZeq2FDaGezibqpCSUzFh7WAKsWccF1qkw2fGuvWq5wqIiEGSN2pe+Vyt45v70phV3uxTBC0AKqEDfj7rFPXMiBuK7JBfuYg0RzQrHOjZcZH+z52FAbtKtJSZmwC7XZtk2XSMI+KqFSh12i72kJG6ESZ8S+FrOEOIA88djj3SPf+qaAq5I8AGxpm4EDoAFHQx0yBGwJ00OovEUBW1IoL2kdOfKG5h623TApVk1qo3RaYqtN0wzP/9Za1cfMmfuH+TxiIhtbaqZbZTV7uxQStpr52c8zaxVkQ6v+26+EEgeVLe2KQ1d01yjRwtVia/l5+OqruqsUr/fQof3d3v2y/9Z8bwewgI0A8jiJ0O+z0OOwFUmpaxvbJcDFyBRhLiBXfVGGiKCk9sm6P3v2f66r1160Xt3GQeqoPrPMEOatwqb6owrNnDYE6p5WAoX3/PG7u09/4lM1RthKZk16flbigb7GuvdFt97Svfb1r5ZD5EmB2nutCs86CHhinnHYzrQqOVEztIVnsk06mo02H5irBmiRf70ZEbU0aEvZHLypviOSGOTqEKUv20E9bKlYT8ky2ETPKgNMAGCAVyJ7JLYu5TLXYv8ZsBbzmxwmeSUGbh3gVYYj0hDJBFmK2r5kJU6Ou8jMZQc0SI3YITffAAA4f+P0ZfMCoiqg+leZ7i0qp86LtBtJ0ZiGkVxCwN2+FYRvlJOZ95usqwZYp82b0RxJmQF4tXHWDSSHMIB1f8iMSACcq7OX1Lq13IGdTe2atHWpjHubX+0hNR8yD9IPw8QGfb0yuH3VLxXYjtpYvchzJ2yL28PaY4fOYDaVqTpP9qe++rYmyv/x+PK3/t20vn7hs4vrAc2F1+vOl+t9VO8PaQ5cSiicuSoxF7B9cB5g6402y8HTeL79Zv1K1vqcBmxH4mFQxIxneoLXguVkHDyTxQaoWJSwP6qUkU8pBuwpCYE9Cn+yi/SiMj84uyJhJyFLukgaZXWSVvl+bcz79uywyYLVaZH8pf4f2SEB8GB2zUCUoSwbAqFtLORrz/eCN8AdiRDHJnAoGwkfBKRZvqiUcGhYVZ2xqz0j1ZfjB9ocICd8GEPsQbHz2q00pwBLhxDjXeDacV31sn1XLfihoMrJPZ2X+MUlPAeD2553vpgfNoZkqVGbyzyBzSW538G6YjTMDFDfcpbw3PG3BpYGxe6bDKjj59bTm6Bt9aRPfR4AjLuIqPJNWjiUmsobCNZ+S6nxapuOY/ja8Y01V1d5c9YbJnWbNjU28lLfs1E+9u1vd0898Xgc9rwVYH8XZoRxa2l8GStsbAmXt6xrTxDFgti4yny2hGkCocRwVnMEiGxk3m7anKE9tb4cb9av2CqOhHrSOQ83Ea5ik219aICLJgEWXyB13x4lAZET3FUCtFddwfuQwncd7PbL5OCgGNoDmB6Iwd2zV4c8sbU+HBErqVH91JENEdOLandVbsqP0eK8dGDLWqpHVDi22c/NN98ZYNs28DZbp9Wq9cNos59V94sFtkcVa/b9f/q+7pMfu0fgNbapo+D5gDzYSM1PzbukIo0d5U03Xd+9/s2vF6g91d2jWLUcyDyH7AwUh8JokEbtBESlb6M9ayyu/0am9CA47QZQ+rda3wZDPTuruLhonQRskVvInMRp5e+A2T78E/XyAbyAmH4idwgtCBPre5irqhOHp8Z42n631pUd5iz7YsqQewDC2Rcss6hegXJsbGFuednelnmv74iOwN+k6SZazk6ZsPFKSl9MJGLffga/CsBlmUj4yG4ZQzUrM1rF8I1mLiTGzM205FojTHzQMFBtB+OYyZ1z5JGMEaDdUS1qijaTuIRMzDMtJ2qMmuj05SWjJ+frSDaN1vg8wLZds762ddbqKEDds9lrr6O+Nf16+dm3bXC55u2T2iv+1eNL3/h/Zj/thW8upgcGoJaMYoDayxkGZ2aVLhuwbU94PoBtPzvXrKhar+3zKcA24Mx4xwLYy9cgLjE6ERuEYwJsnIBVg6EgSB7OoFIZnxH4QCgRPgYBDzO5a2Frd0DpxPYRv1Nqa3vXAjQQdAVLAFYJJRV21qAN+ymAmD8Pi+YvjRUKzsDKFQPKZuJ0r/UT9TmMLB7EREM4L6/f82KYAbUI85aeEvYPoOR0jmIZADAAkpZ6ElAdk4QErW6b3hioLlDb1GAIH8fULQHHOBtAF5AGfNu22GYOAVg4t8ECjLLoqA9gM5WVxuklixWOA1tO/CYj6UNLpQgvs+EFdvNbDXTVB3xO3Wxm0r7LH7HLLYFcRSYsm6tYVyPL/XtUnkyWOFtpA8DuVWDyvBjbC7DrytbDI07I/OPRb33bznt2rKgjXa/CA9zCRnMQqSgJy1JBLgrcntJhBLOeZc2tZbG2gF1+J1gQMULN3jqsXuByZk/U/kwWhyCjMXhDF8Zw32HjCFvrugf50X846DjkjdSQmBIcEJg9oNTAhxSy7EoB2SsBsXJc3Ld3r73A98iOltTAe/Q3ZiwLu7VxSx27IDvwbWSN0snI48T8dT8TKg8GPgx5ttDZrxGwlbe52jt8Dc4g65RQrHxauMHTUszzCWzH6x8J2DJr5bv1QezFANhpnXPi2InuA+/98+6eDwvQ2iwpsonyc8gCwGJaVL8bPCUm7TVKk/uWv/dGOUQudh9TrFq0Cgxy0zrZrIg5lXArtQZrjlrAYvcaeRcVd5jY5q3vRCDM4lrzBsE+aGXOArgyTnHOItqAbYBhUQU2F6QZI5xeA6P2F/CzkrCAl9la1QNZGEfZJDmwaRQsbZkWsNJJ9sB6N8OKiVGBcMt4a7zkG0AIMmlj+K73EQAkI+P0JvIB8s8Z0fSsFdVvmxhRNDqE/gIE8+yk5q0YupUkB7a8TYsGuvk79UiijICyAO7+1X4v0NbA5kiLE2a6yQ7vHTY3yMtyraG9wSRiPC7LPBwwtOOmAmnDkLG9HMDWq2sDodHqMTxo1bo8qlt/cevS2X/7aPeoAqy/8LqcPaD+fq3Ku1Pv43oDamer/C/ng71qRq+2Q/BzLPPYPIxtK+ayAtt+Ma63TdZFM3bTxjqCFQICEoPYM/EAACAASURBVBe1gSMwAupgnHqWcMaCCZXTz1kBDtLnwh6YCZAgjBrugjb/Hd1+sViwA4IWUU+ZtSr2QmAXL1qnS6zTelO/meyiHJgzi9aMgh2W2GQQqoAbmxaQdpHUhLqEk6nVVDiIJTi61f9ko4HJRd3E/aoHQhHPfFRpxIcE2CJcW9axBNMP0A3j1sDFQOHE58V+NoFEW9g42hijkjPzo3Y7KYXbms0OoMum1ACYn0e/cz9OCWZzwySMWOFykmssTxv/Blc9DeII5bc32oyJHUeqrJZm1Bt6gVdD57YBe1MYAWSb1BrIp74B1rrGjmICtoTFwu7ONsrbHTf4ySefVGamZ2xWEfMH3tm8XX3v/7FbZqPFoYz0ncsaT5J/kJxgWQcTEj44NJjGnLi4hBg7AxipXc8zpHBsA7b0t+e1ByasVX8IMBhJXnfGgnHHGXGfojjsU5rm/QKs+/XzwP4DTgl8UPZ22NXuIX2zWFxY2QWyqJGFSXPH0TSIVavPsRvcAbjlYMSbPgQkGTiNgG0D27NWbQ9sBe6Hpgj9YpjczNcIvUmguLF8+E4B22nyuc3vWbJ7o415I5lPcpaP/MVd3Uc+9JFuWTG4nSODQ53V2NEW2VnKMoqfkWvIG8DXNdde1b3hza/TvcvdJ+7+VHdaoavQm8TKg4x8YW2jch5oNCgb9T5zzk6zAbIOg4WzZWnHnLXLsinhtFy5eEi5abGtTXSEVQHCLbqX5AqYTSDrmL8E/EfO8jvPiLkAIDMmTshKmw2U2RLPsY2t6oTdasy3AtZxpOXRyFLuBeSSuazZ6mNbS1zqZv8bEKwsZGTe1B2uj25kHfLiufSLiYQWjqxMrBL2LOZBtGWXnk1/LEqG+LBJv3qMMmjIbuZDwomVTLJApb8iWmcCwgKVkR6xU3ZEhiYDh4DW8q+w9QbAcKP5t2b+Tsjvsftdx+yBjXQar9YEkJ/y8OHz5mF7JwG2mntSU+6XlxdP/NLR7uhlj6G6UX/9IHyvMWqOYifV3r/QGJDd6zv2mh/Ywjo157F1qvcdBbZz7G8xGg/24HLbnprCGzUdAXVGkmpFQBZgu7SoTF6nYUJjtL8dwQZwI4sY6UC1uZNtCfBgZy3ssWBDKBUwq2uITUg82tjeBojxSG8C9dPA1uRTUi+eEZMJQD0r9g5GE8AK4+eawsTpCYAkp0RsTC5AF4DJZ8Vw4JADY3teO9wOHIIEZMyaNlOEsrVtrFJTxY2dc9xvEZGOeVpAsI2vARt1gJ3Re0FlOqxKgVoalqw8xIkMyOcrzAJiX8tGENY2QDSAsNnvecOzIPcW676tbdD9jm0c9XLiC+28NkWw6i6gtFl8JstNbHcphTq04Y87DH/nHh8vygtYo+7kGeSW37pNZigGt3L80Px4TtnFjjz7rACu2Fo5obTDUwA3QrsOTn2ZYdCx21sB5OoZi2J6DXSVpGARcKu3Q4Vhl1sgxH1AgWpbY6MbUGETzUHKV7nuZuF1vQ8wHg/mqTQLyhx1QOzrIbG02NPuFchFA7FHsSz3am4Qd3M3DoZkfxIzhloVJ5cLJBnBXlCfsQaIwQlr60NSJR2xfTImGIwjznDNOWlshY0LjJnANkPgOy9xr10job5TwHZ6/NoeQkyVnBcLbFF9333X3d1HPvDhzEXLExyBAor6NvtQn/XYwlV5/WrO3XTzdd2rXnunU0V/6uP3Se6dtje/JpAjfHid6VpY/xzUWCOJjZ2weLHBja07879kq4FfbL1buKuMa1ZmCzNo1bnlYcpzOCqBWtZ4ojYAhnOAtTOX5hfOXxzenEZXc9RxVfU50VfQxhj4OvILSz/tjkqfsiWX9SxruOrgT41x8uLQCgg2cWBZuuqDnQ/rOnBiZ0s/QEq00H34MDCfEykn654+4rPY+SKrtuneFZMjrB3Wvq+pNYpJSPp1ZHpA3W0eoMpZJpb8cgSYWYujB6txCuMwYHOmWotjILCubSER5wGIUycvozlZn/WAbRWSQ1KBdcvM7MfzrIXNANuxdl24sKTe+NVTS2f+tfRt2Hu+8HoeekDj8xYVe5vegFqYWoVB+s6+5gK28ziPZTvKvtTvtZtpyyRIbfcOJv2a4mYB235zjHCPkE8FvSjaIqoCDYR0sD1zRvFsBd5PnFw2awFAtCqJBAfa1HfulOerhNQuefljWwuwcLIFWFWVhcDFljXCL7a3ATpI7vB5Td0e0BjzBRzBYGbPrirIN2CWU7YBltgAQ7uyfzKAhcVtoJc0vysRxA3YqlxYmGWyXem5OwVY9grAAFRgRfqoCAbYAKawf9bqm/0LEByFnaIB5RxXYxt3iIBsmB/+NFvLpfqfW2amMowlm4zzpdMgMxnE/+W5yT5kntPszshJwfOpgK2v5RrK5zNMCZwiGCc4Hh+mNRucagfT6uQDtQe4Sc3eLzPU08D15GcAqRle7qdvrBqFj6dNmJAI1Krfjx492h0TsIVp5FDDYcSguuZiEj3kQMOrTdEAUfWJx0pxbslsp0MJzjmndZBaXgboK/MdURWwiyxgYntlALatE9A2JBYum3XTECR2aEXjwOabOaoNGSeRg2JjMTEA2HLA2a3PSJjBJkukDOJmLgjk7oSlJa2mQIXz1YudJdi8zWdQBeM4hjlCY249n8DcaSEjhNNPH8as0bZTZMBUYLtGaIxE0zyb3Uai5rsJbEdmCdOF3Gbbx7q7V/azd73/Q92pE9o7epCQeZ2zRmmDOHjWem5xpm1Xqvlz/Y3Xdq9+9Su6Y8eOyx73vsR7RfbEg1PzZ7fngkNRsTZ0DzIDkxZGHDU+cx/ZaOdJ3dsOVU1rwrhYc1ObQ9ZsQJ8Pzax5yw4AsMClQ85FZnNLzBVgfANqOYCR7Yu62MGKeaYLibRhWYbpAmuGNQlhgDlAgVyLONYQiVe4zQxD7I23ycQIZhZNEvKG7GEcFrjXYNqMcqf1owQRyD2wrj5I9AUy6K36EOl1oPXL2vaegEmEKsg1+w7sk/3yiX5PaU5oEBONsc341Typn5Ylwbb1Gm7b42CwHa6pD+PGKweO0T2X0xxgct3NZJMnLhzJ41H9h/dOA9qt3tOBbUMfowc1zV717a+dW1r+F091Sg35wut56QGNC4Pw43rfqDc2tR/+TjO101ZIf7BjLdR7u2zxdjwwxXmsV5ayaLTiYge5eWDbJnizRF2vx9fsfVMuzqRHCuTk3Hvu17XBtcNNM18gSFeU/3RZYOzUKVTFOALgnUpecp20YWsBC6h2cUowY1nMKJ66AhSYJlgdJmHoeISIolQltrX6o/kKI5gjELGT1RubOFRlFqyxT4vLVFS9LSQO16NSc8pXXbuqMFJmRysjDO11uQacAuBSMSNwcXAwsIXRw942sC6A0cA2G8nZelYfMabAbsxg07e+z32LhzBeyrDXUUsnE03AowkHxzhNLNuwqgHtAaPDVIixvw3grJlkKZ95xatN0Cbh089pSQNWEWJsWFFvBmTiBc7mVWpBQDSF9CigmSWkXdgK2uSBY4UavqoNAgB6XDaMR44ctVlIvLCjlk2WnQZow5q2SrsrUCvWJs7fNk3QG/YW1skhwTiMiA2GxW0phPkJk2VgTY8x58TCwOrCXjkWKeCbjVhtNaOq+Umkjv1lL7tXDO0eMbTMgd0CKtgKUjdaaPMCzVkA7QJzxAczsV41hx0rFJtaDhHOJQ9jq7XAAQ8Wl3lEWWZ/hmNQavAav37wahzXZWy5ZgL/+c85ox/Mkh9tM5wOLdeTOqPvNgtA251tPYxKWrsJD2sw6znMs8/c++nuQ+/7oMDoifR9ndjdPUxpfegU2F57AY5cwlqNDX7CWt3+spd0t73kVpnTHO0+de/nrBFKbOxVH87NwjvDVw6ViBPWz3a0F3oY2hrmP3G3GX0H/0cT46WHfMzPBiRjAx8wyuRr4ZdsroW9qu3xNY8lJ8gY5iFXfVnjgEPHhi25m6D7YlZVX8qzKUBFK7DDmdrHoS4MLwfrkAxUyo5lQqULgHZMsOhD0uPqvmUx4MzjhIcK8cB8R8Y69CLrA1COM1aFZ2QQsP1t5mpO1qM+DGAXyUEEh9KuYcpDuDJkYcYmdaK8xpz6E30xAp/RWI1e7cg8Pmcn58yqo8/ExGwS2E6b7bVrzrcQNrhqCFpbe9ot05jZdEPaPA9z7LZa5uS13j3q5f9PG+svPL78+LcvS+NeKGRqD2hMmJg/pfe1ej+jN1nFLnf2nbl7f3j0mw1sv/rwETbePo6tl+Ng/0HoMcGGnw9LnlKdyZPdCFrMrru19nOUG4EBohxl34poiI1oNuKAulZnA00NA+q3FbFngIfYciW2rB2uBHiIcIBmDEFsu1pszLYJuJHdy2wEbF+puI32wzgYYLHxmOVNDMUzciTCYx6v1S0SzFt5U8u49JcZWlhPCz59jNCPOYLqh/ACCJX9mpkYAK7+hrFFnbi7gA3B/wF6MKsA2yZY44YDGAswCdYbCtZsQq3b7fXcDgwGeOfkYS/GD7YD1STpJ+1wEXMAmznoZqu5DdASrzE+/TBAGQWPBuPFhsjfrgOFhMV1j7BZ+NpiW9y9FRXBjlTFzpctIaxL8s1rMy8nEof3McubDZt7HMDd8XeJGhHwC8kEJIdtWtKGd1qe4ieOn7B97fZyWnE/qYyEDsoMy2Ek9fPmVFMxsYDzsgbB7HvsDpNyN6GvnPGMfmWjT0FmbHOfALCuXxGr25zMNEPdkp3qX7OvgFrsZTFB0Ni3scHcAHbJMeXc5rBoqEaxZwywxQQB5xfMDQRYbIqQ7EhbORgBhGWCs6CMfGzSgOjWX15T9HMxzS1UUd/owS/zAdvhcWZ088WCy0tlbKnBxT57M8B22jNYf5/79Ge7D7z7/d3R5471zj/uIYYRoOjDSh0664Dogw8AquaxtQaaZ3e88mXdLbfc2D35xDPdZz/1xcwt5h2H6zps+gCKp77mADbfKZ1/oTC8VlCxi7X1p1RCAq6PrmKtR0xKqAd1tco+iJvedN0MFM3eAiKVdcvsZUBhi6ftUIdovLTJIPuY05AKcTpLqKx2sKTsFmmAtcX8TqQA1nSAN0APhhZTDM9pwKvWOM9lTvsAAGOMCZVkJW3kHg6BmA344Pn/s/fm33LlV5XnlVLD06xMZabTxsZ4ttMMRUH36l6re3X/S/1DrerVFMVQ0FTDYiioMgXdHgqDjfEIuLAbKJeLNmCwjeec51RKqUwpNevpaez92fuce2+EnjKf0jkZFMrIiBdx497v/Q7nu7/7u885Hjsw1ZFksZOBPMIyMRyQVV4WjNRNIizA+Gax0PIM1w/jhZ2msg+9GBnBGvZzAdj2NL04sub9BnuUGLyx7l4Wz8ic5TG5PBevN2Zv9LMXOue8vC4bz5mN3Mj1XuCe/khRKH7q2bWDD23kXDePefE1oLZkC+d/1fMOPZ9Su3zxxZ/tpfnlhoHtchzb9YBtF6kn8xsp4ksJbLONFfCWtLK2a96uxSI1o9ar4mibnAbb4OKyZgmAhfWd6MdsSzAORqY+L7IF82Wwhmhq9TQjyHUwwpYe1ICt1aX1bWbnlIlKxlJbIxXOy6KE4RZAMvODQV6D2WJdygCuAWyLrSV0VrKNhb3tiQvQsoZ3QwNbOQw5zBeMg7fl0uyJEjGtlA1Gvecdj+WAydatBuTz2yluaUAvjC1bdJwVbTCRAjoChauee2K70fKMyBRy9uiHY9My+VmlxjzWwNZgNiDZ56rj+Lnbr3rwyAS4HcNURBrC1qbaFcZHlWvARgMB5AsIe2JV/XIf+X6T5AFrw9Hjx8Xcnw0bhTe05RV4UcM8p/4yEWVi6sVL7tlIwzc3rrPol/W3JzPLEzIJeZFEu3Je2roAYhZG6Vdm23S2NRwcAcLWIOLThjRGwFZyARzAdgrE7tTkD5jFmQUW1olEdB7OYZYY5l/XNYglZrNYXeJ0OiW0jjeYNbCNtMHhl2BpkSzsFBC2U1qSNVhLDpBx6CevRUZmcL25amPANmM2DTw3Uy8OYAbgvTSPGwW4c2B7I7IEfvf1r/zD8Kef/pPh2aefLd1oj99mrAI6fW9UNjssBWzbv6AduhiDP/rP7h4O3H7b8MTjB4dvfO272flBrlChAhNhAMfZNe9SsYq3dTK2DECyxpbdEB3Jlje2lj7SOxjW33oQhOUlVnjIhIwZAHPinkYX7ygIjg2dbX8nZlBfs9zHrCqyCEAkO1wJwwVYtANu7cw5q1j5I3Q2PRaJLLw6MQ49gP7qbsWOi56OUe0EBsn6ZUbZ8wHhEiEtVB9e2LeOP0617KIwRtju5878XraZOcIZxDQfMJYoryMsaFyeZ1FsP4cqE/OTF9WG+SOpsMB42t7NZ1uMZVVuDYt5f/ScBzAvm8SR4VcWx9B8JLwQCN3IqLkGqLo7ZsRd79ptG56naAuXHgFw9/V1CqYrflaLi//jyIWD395IuW8e873VgNp4r84AU7tLz8f1/Gu100tlal904b4nYDteFXu6XITrj6OFjj52fpuH6bHez1+IsW22wAt0D6wMrgZvLqUMYYMOG2lvKWfrrjWzBsU1IB1l0ODOoWTjWQyQBGoZKJFDXEZZhyXbWCqDcztMrIGM/llLK0DBdrO2tgjXJcstljbMhvWpsCX8hEm4HCcSegZbFqbzMueQsXREAWXuuix21IZMf5vtk5TCWk7XgcKUKbTTLnm/J5tZebTDchRgNZQswGpMWxDSdTQCt+J16zNr5ji7jDTMHPfNlqS3+4oVchihAntZGWRh0QKI1AqRHgB7bQQzMUPb0gIBt6nLMG6amFy9EwPhs/R1XE9si8KKiGEpXbFZcjIWUQeabAIucs2kjoz3NdugbLnz3THFAj14+LCd+dyWnphhVxL43cuPWuTE+zuMeg9pT+QGpXS5GWPSAKv7JlvETPQNRgCeLKp6x5H7r61d+i7tRtxbtLoXYeR0boDidt1XdLWA29LROr6m2gUJCsy17gB2GIe1M0pIcl47BtyMY9UiWVG8Y34PcNgM0MBJx0ytQK0dywR4xdZucYpmZAmcH61zIjA48ynAVrXj6BwG79faphcEtvOfXGMir92K3SjQfDHgtu3QvBgbvV7fxosBtt/6+reUXOGTw2GltLU0xFv2iUzgxU4Bxdi0Au0FbKe+1Ak0AFYrw0/85I8ofNv24f57HxoeeuBRSxayqIvNCITCFsa+APKs03Q4LHbf9Yox0iVhKLFR7HChuaUPrGnxyCBggWhnQhMMYSV7QRxUmb/nswbnx35gS6xz1/3G6SxShdjgJDwgGUInYHD4qgrRhXQBVjVZFTtJQ/Z7HKDMRpYwjhe9MKNdGBfcY+4+oNEhyxxuS3a5GF/0vywcLekoKQTH8lt2QiAqeJiV1mdxriP7IJnSItcAjK9oYZioFPhQBIRmcTx1+ga23W9iM+ff570XBq7O/DjzWAgR21S+nZ24iZxrR+T3/skLAdsbBbHXlog+v/jpAnC+evULVzZd/peHzz351e/9bm6eYSM1oPq/S8f9L3R7Pb+t/vWtjfzulTjmRQPbF1u451s5judcAspdyBcCtja6nlgnY29AVOAoK92aGOuzaCWzHcSBsGAEwbfZZbI2ewarBhPIBJAtYRCMHbKsqw2IBbZZhlA2G8cazu1Yr2J4L0i3i/E3qCWkjL5jWzv3hzfzZIicqYdVdwEeA04dz6rf23VsNV0mFFhkDWZcvI0XmcQFIjrIoO4UsIWNQ59mD94xbE/KZuNdBjLgkVoOY2u7yL+ZcfT96DqAf2QNMfJx5CLsFvpTZwjyWbIVad1fgVTLMUp3yyXSGjHM0cFVMgvYkgLdnpoKCHJIQ5vlcqX/MDHCKMUbOVIEVXcFaXeKTl04pG61fTnHMImxFX9ajoNPPXV4OHXiRAHrCUyz+KjLjMA/wc1pn9SZ2e6uM8hh7hOWtzpyHGs8w5sFtud2tbP7rxkt7j/B3ceMYU44kQUYNex0tHbmSQQO9LPIEfjb0g/6JhM9/Vmv9At0vSclqzh58vRwRq8Ubj/pchXHdpeSMKwIsMDcIk/YrCd9iCfRNW4h7Bfhv4hzC7iVEyULOzO3tThzrfoeEuTezoVLDwNbUuoiW5llHrvmwPU+sJRr8bFRoHmjwHYBTMwuudHr9U82Dmw3DQ/ce+/w8d//2PDow49VqEAY89rtcIi1Ymxrkeie1GbDA6W2t4vxp6/t27d3+PGf/FEDnq/+/TeG546dyAK9YpxiNJC48Mz2dbGEmE4WVV5YZhC2FpRLxW6wRY/eNZFOGoHF+TGLLo7D7mVhGcCXA0vzziIexzAkAWKKW4tr0K3DDBJhclnYGbQlFBf61YSaizMcoJaHz6//sLssbu2Yxhg12E0KX/p5x8hFuuWQXDrHlkqAgr1gMcB9E2faC2VLKZIAx1Yb+617Z7wSl9a6Xy98iaQi21gaV6QOhGFDakHB2D3KFBGpU8x+gdNr+nZkYJ5TxgWB71LPJHfo+/U8VvakyYJlwHkjfbdHbo+DbrVrh2Xbu8WxvjzXeypeAqfrDfHOaNexuPtu5yA91eXZ6asiR/63Q+ef+NJ657r52ctTA+pHZBL753piMP5KbX3o5bnSizvrawLY2mauU34PaAZDfedjrjMwfA5AKTWNca8B78FolqN+DGNr7de0Sua9NY2ekDlHyQ+4dm1LwY5d8iQdFhG9LY41YVI04WB0CtSGMYBliIbS6W+VeeqStqouCdQCWgECt9gAt74qaAAGMyxth35J5bTOdk3yBUCtwWOFB5uiIuCMlKxjAHSChcPYrkiKwORgDSVCNZXf2+hcz5rh6OayZRmv6DZK0fbGInGvYTfDLDMJUE7unwmMmIybfT+py9COLBay9Wg2xfUeh7JIPaYGtd62Fhx21mhmqsE952VlUfWR8k8OTBTT9cZvcaYqD2wzneWxTa50xiLtnQcTGhOofkzsTU0WR545Nhw8+JRlB1txXnG4ofShTEjFYHc5RvDvik19ud9Vv+bn9eN28klygw6cnn4VFUiYbP5OpAmAAeEHWDDVtjDfAs5r29ZOXvrb0Tjk3EM7oOlrnSLsK3nqAZEwbM8dP6noDseH504c1zmvOqbtPjKOibndpb4Ca8skvBmNMgw2kg4ALWyuGNvtAraw27BPbBkDHlhIeIciIySAw7sbE2Xbkyrlw7t9VZM9zPMNPV5BYDs3N3P7FNsxjZGNlH8Obtc7/uEHHh4+9dGPD/d8+7sl2wlDawesCt8WJ6iwkeYX6V/FoLZhzC4Cn2eMv/FNbxje9e63K4zXueErf/cNeeWfrbEeYIse1PZP7eSFUiynbMgFM5EBugk3Z0BXttPjyXYjSRH8lt+qTGOKWyxpLfJggHHESt0l6kjCgaUfWyqlM+Ak5u16a2/FFteiEPC4Tf3xgkIhWteN06guh2MnJc6CPYkNGC8wqbYB6pvo0UM4BNhyzpARyCTQFceOmBHnLkqzu31lp3dHAMgtIUC+0+PbWl1dY/U8IdICoHH+ZIGZdsA2Es83TmuE2DM7DODGYY7oCmbKa9yU3Rj7B+1Y3zZQdZ8sba4XFvXjBrcBtvTNRULCrbN8/ut03OW52HVSx643/TYT3GNiAaRX3cYwvPCY6Z2u+fi65ry2kcM3VHc/fWTtic9uZPzdPOalqwG1x/+gs71Nz3N64iRGAobX1ONlB7YLq7blEdMDmj5/HcBa0YSmSlvnuIDYehpR1XuD0PpBgSTbaSaENhoGQxj2CVSMwZoAmeWt6zi1WfRn69XGNYkOnKI2iKeAFqAWzEriBOkhNYGvaWJpJzEzmxweJGMDmNeAW6+8bfCyncc/O4ipLDiLXakEB2jO4nHLdQj7hWNZkjRclMThlq3aWlaor51i4wxqKwYjNRS5RuonBj1B1KNxC8PY6XIToixSBof/QVdnVrSZ7WzBOcMVN27WFqAYpglgm0QJgFBf3fdsZqNMZoAugeBr274csuz4wYKl+o6Jl5rU2wiOkzo1ZuPZoCAphF2fXkxkwjT4LYaec0UPLLCg706fPT8cPnx0OHrsqOtZtxXAzjVh5T2DZwFlYUVNJLmnseONwMcm2IA4v5/QbqaLzniWbcPqmJybfgUL6p/AADHtC2DQ2UqnkAmFRVbrl8Puuj1rwcWxcT4D3CsJhBZWMHbPPPNM3eNlpc7drxS6eu4Vc4ssQY5kJGmAsQXYihqzg41j2epzspIBcgkRRoxbGFs05o5QUeweVdHJQnrw9uSb+LpibEnQUCGJNmwVX2Fge71ybRQkLNz7CA+msz7x6OMCtJ8YvvGVb7hZHT3FADba5d5q7xjUZmwBafQ9U7XpMxM4oh+GRX33e98x3HH7AUXyOD78w1e/bV11x0bFvhjYAuLYAbAcIUCKBR17AtGCIjUSUGP0FqiNcQMMamxLFtW+BZ0W1mZM5wrTmli3K5K5sGgmVBd6Wm6WorP4tGSFxS42VuOIJAsBzVl4Y4fsrKYnSSSs6ya8F+c2K1vRCmxnsmhFDsExdvYicou18wDfZAPjvWUFNSEAlC1fQHqkG6D+2Ok4x+6arstOCMuJxLtN+RoYX7h43g6VtAkadtsYymwJRUCtYz/r/DDX2zSmWFBQNlvhmg963krvmBEvDHk3cz5rIBnypD/PvDEtoBYn24301+Vj5nM3Z7vOFO3CxUEvZct9VHn8u1qEYcH8/RwqL46wuVyiHZUbENf936dr/czTF574ow3bjJsHviQ1oPrfpxP9z3ryelTP/6r2esWyid3ITWwY2CYc0ZTmdyMD5RrZQeb4GrZTMfkMr971HuutHj00igmICWiiLNtwbeUb0/ocBmcN6GLAg0PiqBNMOWmZDCw5V8XmxOgn3iLaTSYXaw/8d3udemLyRdmiZ/tbgFbSgYtiay/qFYZui4yYo6O6UA1kJ2Ab6UFYx3xdURH4DGBLSl2v+mFtMeKwtIR2QY7AqMqkSQAAIABJREFUe7S2kiKg3RVju32HMk7t2W+Gw8aVLXGfv+UBsC0YXdJT6nzkEuae9Le3yYjUAHBiYjNDEF0Y22wGop5k410fOQKNkfI3aL6s89lbHoa1DHR2MKoOPDFHb2tmxfcc56q0Z4FeYtMaIFbWK9rU5ygGnjYFBPL05BWnFht/dLsV9scTqIEzv3NshuGqvruo98+dOGsgcFLxQS+d14JUsXYJ7+bYliXj2KTVFlf2YqbasQPPuzi1OOn+3OPAr62rsLHPvU7n6PNSfhio/E2/skMMoNHShPotEIBzcp7aMjbwMQhOfx2BriddRcsQsCBk2eGnDwvcHvEiZffu/QG3eu7dK022QoUR/5hICZuJpCAgspWsZMSyJfatga2+tzQhWtvtkiUkUUarqMPw0RdHBqf6NAugHQBbGFvrKNcf++sbhEUpwkbsUJ/HE+MNXOqFDr3Ra4+GSSc+9NSh4VMf+cTw91/6MlH5DPSajR0XKrUw9O6Q2gBWnOMiH4oetv4bF8b0+QMHbjOoZSH78IOPDI889LjtGztO1tLSPxmPli6l/zl0YYWRsxRVYnZGhtN6Y5y1oLD2Wl8CDi1/0ZNYr1nMKMshjlk6L6HxkAnEoUqxbrk9a3DXAhDVt3F+NJuJfdEBnYKX8iGFYVeLCCuJiy2bi57fQFw2FGDIbhiSKH0Ps9yyCjul6bxEBVmrdOPcuxNMYGVq4Y4kifaDsSXCh8OUYacArtg/nQMyg+d2ncuWCsIAWQLfyxa1Pp/5AGPAuZAjeLlOOQDSOt5EiK5Pyt3y3kjkhGJzvEDh/F4Z16P6queoHsuULxqqsh0TiGyJyDKwjXmaCJ7+e72+vV5/vmYOv86g6N96Xq5r5tA2kvVqm525+HplaFDMwsi7g57rh8d03p97+vxjH3qhcXnz+5e+BtQmpMYlRS6Pe9Um//DSX+WlO+OGge1yVISNFOF6wNbYZ97n+/3SSXtQ98e91lu+NseZbSiNY6gzxlTd3myBCCfQ5sOAGBC2pAM0m4FhgSlkS4+TwwIy0RD+qMAF58d4dRBxOyf4pEhoZQRlyM7Lq/6iPOxlyeIQZQAXUGi2ALCn9xnM0W+Nq90RdOczzmlmFjBQx3Z4Gdhbtg9hAZBNXJAcgTSwK4T72r1XkwEOQdqiBtjq3yir0LW93e1wWbjEhZbeDOArBtf37Qk1DATA1Vt6esA+h0UYvDVNODRnAPNngGsxpoBk30vuM6ztnF3gTEy2aHe5NbEq/jstNYVLy6TuZ/Y+M2k2sO3e7IknbDqzpuGvtz8pPxN7QDT9xeGy2BZV3axd2TycPLOq7Vqep4ZzJ5WIAW2gwC1zF/fYId2CUfuCfT8F1qvcvqvqi3Nwayw6Gvyp/XsYJB3uBN451Cy0JsjLgF0z5V5quEyRYxSQNypJ/Xhh4UgUhuFmt2CMALZHFKf8aYFbsiBt37Zz2KWsZLfeemC47bb9ciLbPayI5WdC3wbIaMcxnNEEaLdrS3VFC6YthP4SQCWZwwoZyUglLRDWkTc9jrw4qvYtYLvA2MJa3YgT7RJje+Pgcg4vly1JmY2lj68Hhm/82leHZ1Xvn/rDTw1//YW/KhkBoLUWa8XEshOU3YWw7V7s4fhJm44626lvefwxFgQE3vmutw6vf/3rvGj45je+o9jLJ23f6OvedWqbYpkILGlCWwFGe1nPOCTxCNv/OJDRno6nrD4GeKM/oT91Om3ZJJjR3rnCHnk3JPl1fT1A6ZoBXs5h59ZiTrF5Sd4iWQHOtPgBAEIt4RIo1vFIYxJjF0c1onYkhi1sP7sG2CIWaNiYbdplWJGE4OzZM14sw+AiYYhdjWyKMuFgSeg+M9gsHLkH1SJA3OyuygHDTWixsxojdpbD1wLtLc6U2A3u3dER4tSJPph6Qe6TVMO0UeQWnYCCasGBGEc8L4C9GG9bOHW8cTFoyxgbONoTfeBFa5ETdoDOUVnglJSpz7bRfvpSAdsu5/VB8fMD2/69iZDNwyEZ6F94eu2x315/tN789OWsAfWJnTr//6QnobzwkPyS2vXpl/OaL8W5Nwxs14tjOy+AQed6y7CeFXrBluE3AdvnuYt1ga1XbwV46rf8mew6y8vARWBro14fNXhssDUaAcpmsBuQyffNEmKgvT1sxqwmQQCOWdDotGxY0OMqesGq0lOuySjK4ll7CggE2CYsThiAbCdS9hmg5X2Vo++V8tgJDdkBAcBlZPtpKQLyBLO22u4jpBhMmSajFbFvuwRs7fxjKQJscu6r0382sAVg4JRkplM3GA1Ytu7CJmXry+WlLllNl4yC+4GlYTvaDmIcqLrhmqZkDKzCigeTNmNr3jSAs1haJ26oydqdpYC2W6JA3ggUu+GqQdwser+lwZ1j5/LLwFAvELgnX5XtULE9aOI0Ia5dvWU4u0o6ZcWtPXN6OCtge+7MyeGyoliIL9I5kSWU/KRkArn8nIn2zdcEk1eKRh8tLD4y1/P0we4/NTYMYguYBsRz37V9WtvVbJO2XrrQbTF5gKGJsXX4Ik+K8TInDSvxeJ9WxIcjR57WfZ5RuVgA7R72SIpwq9g+GH6cybZp+xjWdpPYLUKCsb0LsN1K1AUtmBzTVsAWOcJ25Ai3BDiYglS5A2x7QTPF6oT53onGljjOBrbPYwSWvypgu9HJer0ze+zfwCWvd+hGytDHHFfGuk//4SeH//r5L9TWesCOH4yZZme9UCmgWJ9ZnoCDJmCo+oUxDK1a59ivBcndd79DIHDb8MzTR4d7vvuAt8ATI7XXo2kPHnzXQLcdVGFtDXZrkexoL7oen9PfAMiW9LB4CYvmjFzeVBEDwGKxt/r5LeOZrXviSSNlgbGFOeXalgixwNZi3NZAfaVT+ZpI0N9025AIKoNA49bascFpF6YYWQydJ7Fvw+yxQ3WRlOTsaOkf7C7dC5sJswv4pH4pbyQKSQ+NvYl0RkyyyhhHWkC1MpBp5wbdrEEtkUEA+GQ/k52FXY7NFcjWd9gWdOPIDbCdiZQjwEx8dAAtrDa2zTZ/ckSd96XejfRn1HPZtEyhsb0mGlzmzFPLEoBevjURMGd057udOfU0p153WHhxXCD7ecZOiIvc8/pjj0+vP/p6XlafP6qj/u3Tq4//6kswVG+e4kXUgNri7frZT+iJlg0wSyivVzw97oso+sKUMs6rmNp6OvPYvfc/eozVdEsRMm8vds4bAbZj136BCW0Z2PYg7BtNnvrIC4BJHhRCrjYFPvds21J/2zmqBpWBmY8fzxazgXH2dl2ePpXZsmJMqpYCFaJv9JV64Mv4XwTUCtCeF7C9jDOELiLf2TIM8R72Vn0BWN9FAdspNmrKMgHwhLtB00ZEBQctJ+SXCmjtHMAWRkGGmbZiq++KQMBOOQbtUCrVbTL43INrZwZsY4jQR1ZGIBl864cxmuh3YU8Blt4arwajHkfmM6yzHbY0AbVTholDV1CxiejO1K06aPhiqLuEvkmdJ6d7mNjp4W27AndmJCnTyFDkHgyA+Z2ZymZ3m9nM2cIcMz0IeCGtIKPWym6BW028upULF5TuVtEriMW7JtbnjMDteYHbi6tnvSjZqhtLeE+SdYRBMwNcRV0cFsz4uZ/+3tu2JcmYGN/ca01hWUQAYuphYGOnP9gdcGPq9Jby4Daw9THN2ha7DsAH5NoBjYWF+o/6Iw5EzxwhueTTw/Hjz3nMkIlpNxrbvZIkiLndt2+PstZFS7vFLO2KmTLS725VaLAtxMg18A1oIdyb/jPoaWDrRYSZQdf82JcT7gtgS1SESd40a+7rv30NAVsK+ULg9tTJk8OffPzTw//7J5/zOO1FYiZ/2hltN/012tqWGURb2wuc7KhYRlS7EElekLBb73jnW4fX3fU6j39CeR0+eKTqOnGS53FtO7whNo5dm3Yi9ULYcqHEaiZhDKDP0RO8uk8P9YJRby0h0YMtfRy4sugsbWyBG7btXUb1n4Dm6HFZ0AHUkVTZjhrAEw4robSIuIFNYWGdXZYktSEmc/seOPoAfbumodib9HtifUcyltjNLOao29aBIqHocI0AXVJMB5Rn8QVwhnXFJtKfLScgtrOtZ3bwYI/jnBkWmzFAG60pLbqvFUzqhT/3YakJpIIdnLNAYPK53hQYO5F6nwRy07Dgtpk/qEMD3Vo1j8CwbXWtqn3tmmNeCNg2OL3eIJwD1/UAefpCfr3+99cf3mr/k2r6X7164dyvPzs8q7AtNx+vdA2ozYhN+z/qebsN9zB8U21+zytdju/legvYwdYpzxcGtktX7R9eU5jGvxywvFD7HoGt2TCdM1LYOnltz2RwTRfIStfTa9jG0tVm4AGMMEa15V+Mgc9vxiATSztPeGBTSZ5kIkconyiv6nFwOC9nsYtiFQCfuF5sEWDM1jqv6GMLiHvwO8pilWtRipBtfcocvSvnlzULsPV5mIgCQA18yWhmcKu/BcVWdu2RFEFby3IiS3Dyin7g6yfmIWVJ/Mc4pMT7GoMeJoT6iXd+tHSJu5pyuiZKF7y1gGcC9mPLG4zCOsI2VTieYji7r3SCA4NAP2lXF9Dsr4Es/5jYq+7dtr1+KaAbUBBgOw+LZDECE0T1ExzrVBnWj14VUNu0fZflCOiSLSEh1rDkI+cFbHmunj4xrJ46Ic2fJi0WKdSRmh7ZRdpf51+HhEj91D2VsW+2cA7MqQeXuwaIVdt1T3wX1jaMbVZTvsmEinPEhID6UXvbiwmDo8gWPNlqMgW0nD1zbjh69FkxtkfkSHYsgEv1AWu7b/+BYc++W4e9+1kQ7bQUYbvYWcAJcpatAFuxuFsFTAG2gBAiJpDGd9tWAtXjuJY76T7OHJ5+lD6PnANge07jJJ74N/D4HqQIU397aRjbvp/1Sn9Oi9o//eQfD3/6iT+NtnIEsgE4I7ClUbVS8mc0rRcw6VNjJjy/j0Ok29rtrYTsb3z98PZ3vMUAjnTP3/nO/bY9+AVMC+Kud4ZWoq2Y4VQDWXPrvyMpoL0cOxbdK2Ovx7te7cDlBTAdMA5RMPiwuNZ9Uj6P7xj6OMQSc1ZJCsRsYjP8S10YqQGAjAWO77VYTTL8OcycDrSDqoFytLWwquheAaIAT8fJ1nVJPBIdfpImWEOsOYBMkL4vmN8CfYB86+SxIyrLBbHFlItjOzoEOmLK1LGwkUWxCN+uhZ/lV0RT8bWYF2CfY3uJKLLmmOLscCVOeMCynOV0LPdFOt3IyDI4OrpK959QMmm7xbmr57HFCZN5JFnXpkcDyf794nlqUNbhPWUG+8aA5aWIgnwya9OA9d6hHMtt2zoZwDl7vN7YmK4xm5+vXsWh4TdXz2/+v04Mj524AYtw89CXsAbUjj+m0/1wnZJ2+Fu153Mv4SVekVO9ssB2YQTWeHme2wzkzGPdrQ3PnA1YYpgDEOs3AIAZgOTTADPA5Whf6vxxqsKIepCWcWHCj24wq9AewKOGE3lBgSyv5MUWnD19elhTAPwrZKkyEAJipnwTiMu5ArQLGLOSL8DoyaEYFB9XzmIGtrX9xARk9tdbvgG0diRDSylml+RjgJXdYm23Cdha46Z/lwywYWs4VRhktgHNPut+EnuyvJWty0vcxhi0sEBmgnxDXefaSvQxOF4U2DMSY3EQIMZE4G1A2pMYv33vPRGaSQ6wBUB24wfLBSQ3a2spQbWRQaKBQXEbBW59PesDs+yyzpDJmymWZAwCbJtVL1duwRkF7V9iWTLpeutQrO0F6fDOSW97XuD2gkBuFiuE9NFk5Qk5XtCekqrjzQ17ZBaLk0/0dzjk1UOHhIDr7YMsIpr2MODpkGOhpD0eug82W225wljXxZQX+2u2T//QQJ6TM+NxhftCikB0hPMCFNTP1m0rYmwFagVs9916q9h+xUAm/Jc0i2ZuyWJG/FoxtoBbHMzsZIZjmTS22yVETqzSlD0LyMheegucz+hfuwC2LUW4EVP3MgHbuSFcZ41y3RIuM7Zst3/uM5+VY9jHpfMUy+8+mEVeIhqUrMd9p3YZzHIXeHVHyEImzP0EcA169TdtcrfS4u6/dZ/r9+GHHhsOPikpYoES70Lpj67/fp/0rT1+IxEhu5ajrXjRE4dNeoojuKgonMqLIsaWBy4gtzLWqR25X4fmQ86jXxpIYmO8pZ974BgWQIBEwLmj0FhjSx9BvoKtSWgsbIclFCorbLBBIlII0vVaVhHnMMaowyzqHNhEAC6P87J727UI83v1L2we4Nqhw6rvcQ7HWNYr8inrdwHqjnEdu4TumAUY0q+AeTmHkYJX8i5HHXHECJLliK11zOhbtEt31veABpdds0RdqHv2GAgR4XjlQbdZwOfdON5jIGM75w/3FzdtPmcst5xhuR/2wrht5PL3yx16+t4rbPfZfqRbNfCtDGwzW9cMsOcxd19PlMuXWCh7vqyrbBp+88rq6i+yh7Tuj25++LLXgNr/dboIYbx268kWzLfUrve97Bd+mS6wMWB73yOSIpCxKFtL3iaZ9culty+qqNf1H8FZZnGhOp6frXaMeMI1BWRNA2ZhNWhj0KvhZjNsPzgH49ZjN1tenhhqYt6GvrB2vOITNGmIiijLANWXGJo16TPPCNhelEZzK4YUT3HraHFksMjUYNxnYmZpns4AcdKZjmU0qEXzCzOQjDWdjCFRCviO7ShkCDKmaicYuAs4VOj0W7fvFAO3z8AWjRkGx3rkNo4FktGNTSHMIFfj9etyoMszGGudVW3bFahuA8UEEI/hTOKOdMAd1rYpVIy3D2uCdx24HAF0lmbU1inXs1F2DYWJbT2hr1GdwrFdq1yOIlCTQvSnJU3wsiKxOKmTTQJo27TtvknyjKtb5ART3xEpAgB2kTLA9ogdwplkFeZW7emn3l9alS6VUGA6v2UJmsDpF8GcAd/NUBps44FY90P9x/bnzrwwoA4iTHYf5dERKFwvBXq8/ezxUFKEkod4N8GfwbinDCMwpm70vbdlqWm19yrAVk5Fx8TWWmcrAOaUogInOxQhYR+MrfrMbj2RI6zYiUzglpS71J2lCHqVvpbvAbZkPbtFwHaLwS1gLAKMLMp49lwXHe4Y7utFJWjogb5oGF5o8m7r0K+xCS/usQwY2Jr+iz/7/PAxJVc4pUWDwUGxmFO/DbANaOV72MMcFwfUtKGPr/7eTK3TQat93vL2Nw9v+qE3eayePHFaWlqxtIDLcSzR1crWFYAaoyBgKxnvumkWV8kO1w5+9eqdIOLb0h+IBxsN9LjVDejTMbYlXrQI+CEr0MC6qL+dgIFzsFByDFnNGeqUAE/8ALw4tlNQtvhtc3TPMJ84K2Ln0MMSEoxje0Hkc8F+4uSq/pQ1QUCtY3EDmLHBujTOZuhZqQU7nqmdL+AEquM5jyPHEO1A/Zl7YxHLG2I3w7B2whRLMXR/SCA4hutuIRoCY5Zy6DvHpFVdcE7uFXCM7tjyBxpZZshps5GQebBj52Y2b+yDWeRc7zGBxwlgeufPc8gEdvv3y4xtg9M+z3pjYf7ZAtM7A6k2r0s/Xpd0yt360cfPAbLLceXK/3Nh7crPKmr4Uy9uFN781fdaAxobpML9cT3fXOd6Qq9fUft8X2hprzteZl/UTOt+uI4UgXBfGKl0VHfS64/DG67v0Vlo+ZfrANuekOz8A2OLQVtYIfatTAO+A1e3EcgkCLDITQCME88WViC/N/uEw5jKYDlAD1QDjTC4bYsAfwZBChN1Tg45V7T9uF3fE96Lszszjy9Omdi6bgOVuvRh3oYPQ9oSAa5qpgKD38C2tuHcBExilfUH1pZwYGz9wb4klu02ebzvsxc7RpfJ0wsBXz+scOcrJx5pb3PaAYnqKWDL9Tne2lXuqNjVyDdSh637SxSF6h6esKeOArAFiHKAAZqRWGmZKU9p0KJDLtYWIEt7cL8FYjtqAFdpwwrLPHZirzpqS0/1cMlhvdRXNPFukTxj65591tVeFgMTAJZ2iQY39Q9bw5YoXsxEt1jjqbZdOyuHMmluCeRuRp779QLGpXGn8HSjczn8meQIYbezPel2c8eJftCHIFVxOXLPDufEd9XBWofIPXWEitY957sCtpyVOjLIzSv179S6BSoIgo+3PDIEGNvT7DA4dbDidQqo7t4DY3vAIcBwEluBocV5jD4Eayu2FSnCNj05nu+cYpd0u0QNIbRcSC7XaxYMxkG+P44h89iLliJUf4kuY/FxI+D2ewO2AW+MnS/++X8ZPvahjwxHn312NAjuhwa2pJruMTADsCXXYbxNMoSAmwXHwdJmvukH3zC8/Z1vc5ID9LEPPfTocPhQE1zpJ33v80WxpVruzxUJRX/H0TbZuqy1RSrQ0iz3+8SUZTyTcCCZz7J46xSw9D2kLdwndgPmkjjQHt/+be4VwOfICh5fWVADhFn0JmwY4DEM6i1KeGM9q85DdAPwH/pdrhXwzPwT8Oxz2x6qP5V8AHCMveb357UoBXxzHJ+z0IS95R5wRCNRC7+7TCQZMdYOBQg4LqezXnw48kIBW/ZYkFt4TOppRzSdj7EVxjtJGJzEphhlwixe0M5dR5Fpm+3FfI99StV6+aX+vAwwu40TjrLni2uXZ88HbGOaZr/hfsb5aLI5U3+abDu/nTurtS1rwLvcDxduZ7rOR3T3/+rI+ccfvWYA3/zgFakBtS3T6Y/oSRgvHmRu+bLa7zUf8WAjFTSHpi8AbMt57KUEtvOxlXnw2sd6wNaMBKYhs6edwq4DbPvzDveycIGSMZhVwtTWeUygEcbFWlOuUOevAiYAvq1Ddl0ogyYHHI5WT50cViVDuEUGE2CbcFg8k23Lx8JYzO49MWv5LLRWgyuDYCYTGeZIDuIcZua2GU1+V0D3irbIHT3BMSlJkynzIebDDmQCKHaAKCkA7LFvh4kO/RwgTBOLnaFoY8sGqraY7GCFVe7sdGcSHe9LwNF3VkAq7GqAv5nD0FMBfWw/FtA1QKMNuy7dmkZCrq/E2KQwOoo24egCjwmhky7b+sXwyRP4NUinnwCsuDoZtJAf6Hl1GxKEuPS5L7lfT6Df12bSt7wDj+Y1yxLWxG5eOHtKIPeUwridG64ycTNZLwBbV6DL7v0AA7G0cbYDMlFc1W7B2OezsnHfKExY9Zw2sPSg9I1ZQJTmUu/cHxvEFhB2G+WHuu8kz8iiZJM9yk9pAXZCjmPPPnvUOwyrArsAe/rILgPb24e9yBEc0xbGFnAbptbAVq/bBXhZMFmKQBYyIiPA2gq4Amw9NtxXsrPSsYy5jR06fi5FuB6TdI1BQIowAttl85WjNwpuvxdgy1j86y/+f8NH3v9hAczDU7+rybtlId45KDmMUxtbWlDSGQMkvp6kO+0A2O15+x23De9577u02FC/VZ86+NTTw6OPPG7GsbXM81rocel68O5QFq90PfubWrZUMaL1GcDW8WHZFfIimVjZOIyKLWUHCPui8mEvsoOSDHe2Q3rivEZPc3YugW47n1nGgB43Eh2ibqxK+5vQYWT9YpxVIhhkCLqeNf6KneutfTIAIpPALiH5IW4tdg3dLYs0S6oSHozyAHSxedQZ17ROmHHBIh7bxTiEoND1nfnLjnFa5GObOa/1wgDpqhv9lgVEJ79B2rAmWQOhxriHRGEIAcH9w+TCRjv7mMpDaDNkDAbRRKqxbMsdM6C4GdsR2GYRep0ZcKE/9zihbrD7HdnmmnFSNiODMDa0H8vzrMvGhwtz6DSOMh9OC+1lYLvetdf9bNOmz2jR81NKrvB95Yi04fv7PjlQ45isYcSkRbPDdsV39LxPfSuT0z+Cx8aBrYwVUREAMAzeji6w3jbEnGl6vjryUL52sbn0k0z4c9YvxhseLFmlGjP0D+fjM5NXg7DZxVoOYNtfYLKABfc0smAGO0mjGDaObfraKswnYUNknFcFEM4K2F4Qs7ddxwNso2wMQ0IoLQzMGJZsBIeZUNqZIKtxypzt+CRKCOuQSUiTilnaBsRhOs02FLNLyC+em8QmEO4LYAt7az2ojNSClhfDb8Cqm8GAZbYttrB0YKMRTR3GXqZe2S5Mm8cARo8btnCK8Qv4CtrJdnltt8+v4/qqR7GmmUzT5wzLagKw7MDAmMVDzpupIW3Ea5pY/yPTkSbLLWIXN7PdqcQVVzcrExKhity78mxgmzkokx6vBrc45Kn/XxAovHhO0gTJEc6fOSXmdnW4SrxNTWwsYuzgU6OqazJ3VKDW7RygmjI3HO9+mixr493UvXAG4p16LPinzaKFDfSWtTXQ07lzRm49OsMw6WKQNEmfEfN84vhxs4y8P6f78GSp/rFj137pN28f9t12m3W2hDSCrd0iYGs5gkApbC2ShI51yzbu1u0wbYnreQuhv1qrY7Y8mL4nSaIonFOsVWQzN/RYALZp3kLw9cd0tusB3LZP8+9f0AzNCvn3f/N3w4d/9wPDk49p1y6NGfmAH5Fh9PgZF12Wh7TueRof3obg6JYh+MebFG5tp5IsvGu4887b3dbH1VYP3vewFiACc3Vsdj1yzbZx7ma1ePJ96u/Rnui41tP2Ih69feJVR2IAWxvPfQWtJLmCpQIA4HLWErgDWAJAacwAyUjUcC6MvVI/Gh1QGUORIOXYOJE1uAcQsitCiuVLip3rJBC6OnONd410j1yb8/J5s9l2qtV1AJ1hZCUtUB+8QJlVXs4DYAUwOksZu2SqN4Am4wUZEQAzCRQom+QDJIQAALOrIxnCOcmOPG70PCeyAuaWcenyIGXQLgV1QDY17gc5DrFxIQc453nt2gFq2yDU2rX6yXo9rgzHrK/N+2jWQdklcDrtoGUfvV5fv55EYIEF9o9TxL76yNR2OWYT6sICtEHzUnmvue7Vq3++6cqm//3Qxce/Pjv05ttXuAbUrnfqkv+9nmQOo9Uf0pOIB8Sn/Uf1mI+k4II8F6QI99wvja00QnMpwiJDWnXiCffawXndATZO38/HspT+crY0OR+gAAAgAElEQVSd3QPvotj0cRB6jBdLVQOxQ2eldAFfeaiMI7AtcGZEkFiGaKvmQv3WMfFL+29UiC//rR8xEQAWTp84oaD+p4ar8p7fhXErSxbzU0kfeM+lagXfZXPsxmJFDKpK39qspZkUgVkANFraTCZhMH1CJii+k6GGDVlTyLE1vHjJwjMmacDjuACQf1b1Yf0spyMEVi0UuDezbQVsvY2e+7B6sts5lw5us0Y4jGOHwnFYL5071yXDTyyo8737/eRJHbBbQM84sNqM8tEpR1A79bHedm/2tsR34yB1RAttO24iQYVYR9LDXoY52iyGRtd20YvZNRhmMVG/tjZ0BO+JIYwsgbTGyBLOn42W+pJyxV+6IPaWrVXf6zRJ9GQ0AtuuT1d3ORSN/bNgdgVb7joeIzzAO5e20HVqMAXjHYBj9tt1xEIwQIv2YKJ2ilHaQL8BlMDSnjx+wjrbczC2JBNBaqSJfWXXXskQbhNje0DOZCyKFCoOxlagNlpbAVskCCVHQKvIti9ShG1kIDOwRYZBIbspWExF8gEIwMHmrMKqNbC9HggdG7LfrAdsfaMZjX3P898ts8HrLbzXtWdLF//m174+/N7vfnB4+P4Hq56rnemzBq1ZcNRQ0h8lPcDOwdby3XzBx+8QabsvpOwrYr/frvBdP/hDb/SYOauEIQ/e/5Cc/U6U0xLnSZSWavTuPbED3Yd7bBu4xnE1jGx2BbLrk4xjHfIr0RHC5tr5S9dIZIHIqBz+Sq8JISZghwSgFrT4JiDFt/MYmu6KV4u9WlnRDonu1TtD+n0zvpzUkQq0GKK7XlBUgYBm2E9kLXHCArQ7Hq3tQEA8oJFjHXWBtL4OHxYfBOKNw6TCajsRhAEyEozEx4atJYsjoe9YiJmRFaPsiA2kkLZ8AL+FK+r7StAgsOpEDGoj64M9l2ie0HkDXq8M+yRvwi6fWzvn7GqQD5yjMwZSPzGd01b/Ql9dZ94cR06G9KinjRwktuKFxs0LzccjvMZMMy2mUNcMu+t9sHz9+djSWb58+dLVf/HspSe+tOET3jzwJa8BtckenfSf6/nGOjlyg6+qb5x8yS/2GjnhhoDtd+592MCWuJN0ekAQfT9DvCfxaTBMn9m2F3wt0DsHv8E8fi4PpalgQU1zxtZjT080pC4HLIHxb0BTYdSAlKVB6r99sVzBZ/dHYbf8zczIeDec1XGxYiGhejLSxKQf4zhyXuGhTp04LinCqWGLjt9BFiYztBM46jb3lVzulKAX3gkDFoZ2ZGtzgzZqdqwwe4jzQzSvaFSdJIHJytq4HLPGU4YVT3/AyXZFR7BnO9EPAKxjy3nGCx4C2LouA1w9CXctFYscNXIMalgXjmC6Su0FlCdShGUPDWw5yvIG2igTfL5vZrjZ3moDT9Bt0fUdwLquEQCXdshz3LzPuYMwkqFLDcb2+mZSaGrBAnuLzvbKLZrcYPwJPO8eGnbZ8S37PqqNeiKBpcmWqOpfjBLg9qKCt18Ue4s0gXBgmyQHcaimUSiTxUEvQHCQ64eBbfW3AOpeGJT2eDyw75X+NI0jX8fgvIBszUz8nS3kgCzYq3hus1UKgFDkjmJsT2kxhnSGTE2Mb9jdzdI37tkPsL3dSRtgbYllC0u7Rc6IhPm6pVLursiBjJBgAAli2pqxFTAwsGWw1HhxS3pyDgiHsT1/XnWoslA/c4fG0R6MA7IqosdtVljrPGJNMuaXf7ze8dNnzwdsHxKQff9/+J3h3m/XDqrxei36ssJwH/QuRVm0Hk/N5Hq/oVj2HldxLkpfZSwAZt/5rreVF/+l4aEHHhmeOnh4ZHMjgcrTTKp3V6bHnKkdbY1tCWMyoLMBrlPQ6sfUe0sT0OU7fBS2pPopulHfVzkqJjkMulaNZfTSJdeC7Qe88kpoOO8qIazWGAZYwsraXwHQK4DMdeiHAD/6ztpFnK06wQPZ1kIu9I4PLCkgeYeAv51ka+cDeQtt3kyux321Ail1GWN2PJNtpU94HDpJBQvt2C92nCy/YEcDqYElX5InyF5auqDf7dm9x74Tjhqhc+JU7AUAOzX6Dffk9MJ0eaLosKAko6HquRntyBB6QVpzzmx+Wnf3s1uYec07d2GvWZxk4rx2IDS4vB6hRN9Y/s59pM7Vi7S2g2NfGr+fw4Zrx5XO9DWxBv/q8Npjn3/+UXfz25ezBtSehAr5UT3f6Q4/DKf0/Jra/tDLed3Xwrk3BGy/fc9Dx9gaCrBtINoTSAHXYMoRrGUCrmdDW2+hzYChoXEe07sJ7NpIecJfR4qg3+AQZEPtQdls7XhCn/V5V5T1O4PMWU0w6BPEPxMCRtT52sftQpsGXwhge1F1c06xQU+deG64QDQE/W4FAyejB2PZUKagX4CqEXiAYO4/ANPMa8eJ9ftJn9mg1saSuLVs6xm8ZDsRB7bLdlTQpMGTGItiuFYUHshJGthSBuQZ2KZtggFgMgrC6sXMSgH5sF0pg42pwVcBMDu+BFzOV+oNErlAAHQq2A4oBWyZ8L11XsC0+0oYW5+hfxmoEFTkem92awyfZB0jHYvJPnpTH2kAENAgVOfsWU4egCZPuj/kCYBbbxbWJNrTxAgSKH1pDw0Yi9VyG4jhvCgwuyZHsrVVsbdib66IsbmiLVXHAVWbFIcYeQFgM43eA2OchBPLuAcQ/d43nc7cAL4HX/XVhINKPbmufdoMxO5VjgXKxEvWsIpj3MD29MkTwymxtoBcvLgJj0Q65ga2u/ffqoga++V8uD8a2wKzAFy/txRB74ljazaXbWqul0QNbksB3LDp3JvKCDZXmdnGXVOGKPSY0xiO1t3jw+1dYLh/Pp9Yc9M57wK8m+/azCf9gN7rPdYDto888NDwkQ/9/vC1L3+l2iG2zn3d/S1lyAIj/a8v4SVF3bf7s/tmA7W0U+vP77zrzuHdd6OjVfZKFfmJxw8ODz/4aOzOTKLQun/HYGbcmbXt268Wd50FwHYFZvdHI7d2IMZXwK51pXGWxImsF2/87VBelJM+VtsyWdCmxllow9o6lJYZ6UiceLXOFWZeYw7bwo4WnwOIWexaruD663Tb0qtqUYSNISICEQbm8VLRAvNAv22HNBhUjeN29m2duaUOtbi1FUCyRFlhex2ii/BdOLORDUzjVOeBSLBEy+UjNi/2VddQWS/o+B2S4eAotqZoImaSdc+OLoGdZGeOiCMqH3FqKb/vUWOfcTYmnKFvlCl8PsA59s9qv/ykaBfIjdrJ86yyOGnVUJj6/PNfJwvMsZ9cd2TMT2ujNI65dcDxPSrWTx++8PinXuB0N79+GWtAY5RGAswCaknPh9TgW3o+qDabG8WXsRSv7qnnlr4tP68LUoRvfefBY2i72DqMKWdANDDLDfTc1Za2bXwD2egrY9D5LFvf0Qv2FuLyQBkBzTXANgPyEmCrDAAaqvn8tryQvd6WTXv0LzeDowV4yy6g2mUe47OGCeOCdpYQ83RG2tqT2ta9JJCzIgCxHWcisQQTB1ggz5Zqxpd6Ek+lJs1ir8qje4sTU3+erTWn0C0nskx89RsmLmKwOjKCDK1jNcpYa+t4p7bK2DJmqw2mIm3GfUVbZ861C2KExASWzDphR8LmBlxiVANQMrdnrLgt9Xb00PdEV04nBWBDtgaQmdEzkxWQMG7n+qy1h22gm4clIUy04TnD+sIwaiLMOQB5sy5N+Xwd5AiaCAH1sF6wMmJszalzf8WmNQPsqUT3mb5V7QUAqPYx0CX2Z8lC1rSleVGA9rKA7SUYXD0vAwpY2JQWziUzIKLkuQ+XtwGIvo8eu+rQF64lkRcDUz0E2Cee5PjQIbDNDn9W7Zixp9rSZEyKz2hskSJoISYnuDMCtshnCPcFiDmvLVciali+suc2s7Z7BG53KfzXTi2OzNqSlEFPZAk4j5FyF2mCga1i2QJsWUds1VihX7ZWvcsZ9jpbxcRadkpdty0dKrKWLCijMx+99eeWquoonS71Na+HNFmA8eIXyyeZvp0D24NPPDl89IMfHv72r/6m+px7W3Xw2IKe4N2eBf7yaR9X7w1q8409790oAfsE9b/7x+4ebrv9Np/jmaefHR6Q7IAkC90XmwlOPZZDa6VJjhyhwUmKNDJvtThwPXjbKc5jIzBS3dLUMLN2hjKzq8PQbxrYJbmBI6bo1O2IxZ1gB1ng8TmLJdhYGFbK450Cxn0tQp06l+gLupjPod/EcSw7Cuwi0M5mhnVCa2Mr7a97NEBUkoSO5JJ05FfDmOpa6T9xKOs4t07Nq2OIeBDnrk4Ckv7E+DdbzAJLCz5S4FIOhxHTv4QQS9g6S7O09AWYJ2wZ8ZxZlJFAAntLAgdkGorpKykFi0jH3q3EDSOaTc+oPtn28vr90Ys6d88s9sLSugH9mRfelr1koTXOd+5+k60Yx0L1U/dEfX+9+XA+YtZ7P/9dz9dqm4d1xp89fP6J33+h39/8/uWtAbXPG3QF0uCSPYzO8oCexKS9QWeGl7ecL/fZ5yMrc26eC8D2698E2F4YTomV9MDwDFTgdp0SsqUUbWUGWGtSM+AAIwFE3tb33IzxT1GWwS3MV4k7RzlCk5hOKOsRHcaWRw9wM7iwYBPirlsrczFOen3LfSNlRNh2BsAYdDIpNTMTsJBHmIe1c9IsKvXqieeOOczXTq3Yt1VShjDOZd4K0E5WqMs/u3bpp8K6xGPZRs5AO9txnngAtnZMCFAyJHI6X1gD2AKBBthFLi4mZKekCNvFutmD3RUfUEv1+FrGUF0XKTF1Z2co/uq6SGGW2qoXKNP9JBd8NHQ8GoQhkUR7aZ2g6zHAdv5MbaSO50a6m8xZ0EBPbpfanqWcyDLm7V336egWOIjIaQyWCyB8GSkC2eaYhCtj0vy3xR2OE4DxkxdSBRTKixyGiIWEE2MAcDW5XVC0hMsCulcNeBWkv7SF5lYB/p6U1D990ur3FkT0vJe6D4tbkgLaqevDjVY4q8bOVRY31d97DDSo5H4BAo7LCXsGiBX7dErA9px2GM6eFmOrshIPdU2LNDTHW3buHfbfRmQEwn4dGLZXFrIwtYqIQKSEStAAyF2BuZW+dosZW7zTE7+5AVn6WcYWgAJNLjIEtr+n9s7uRkBpHJ8CsKree5gsv14P2M6PW0rssHwK2vXpw4eHP/pPHx3+219+YdzqnfiNLKTSR2LXbJqMLWs3ItBlfPhYt1P3cRZaxFndJob2HcOb3izJm445rfq/R1nDTkmfP2l1e0z0rkglvxBwihyBfkwfAsnMLuoulvqLBCGLhNiq2DOqCyBLGl16GAtlbEUSOERna0dCndfyBVhU3Tv9HCkBUQ0SOSHJFNC3bldyD0uf9Lse+64vXYxMftv0PY9YlpSHMWlQi7xBn+BwtU2glMUVC1Z2krBl9KExCgSMKM5g5cxm86bfGJASYqslE6QbR7+rY50MgjaotvAukaPDZKcrkxC7CVlwUF0G3GRLk2h+Tfp5z1gaOwBX+qM1yCU/AZCbbCDmLbFwVX7sNPcZP4W0z7hbU5B1WkgvzwM53u1Xr6Pd8d+ZGxrY9rH9Op9Lp4XzNLeuB2yfD+zOvxuBrefyqwf1978RoP3d5fF08+9XtgbUDjiE/aSed9WVn9TrP6jt/kmmJd4QsP3qP9x37OwqwFaxOzEOzY7Ot0K6HUfAlMkZ8DQ6ErG97c8CauPlnQGHwQjQmq0mbYhKF1XHMdKLgFBg/TYIGwG2i5POZAzqej5vUiV6atCNSvgeIOPyZcL2v0YgKhuMwXklZTglUMtziyIo7NDkjvLR/ISBbSafzNdhP3ONYuT4y6RKmNPOUEMZvaXnmagmef0dpiKZxsL+xWxSMQ66jhxB318gTSalgJkgUxSMmybV6OJyH3PAkQUGk3CxAzprp9cdDdpIDSwuQhZX8q7dhtvjVrQNLu1eADqMbxwA0weKiS3wkC6VCX50ZHO5A2x9PrNXTP56tbF1p3CVmTkuXZ/lCGItW0dHtjEDW/VJnMh8ybpe+mTxpXW/ZhHdgJnoF9qEemdio941iV9xYgel1ySCwnnFNBbYvSr2aDOsGOduwOoLFYB36t005VSXmRGTmCHfjeDbddZCB5UteKse+Z1DLtnDmzbXE1ZK//DiJjseT5I1AGxx3CFmKUlYWAxtE7Dde2scyAj9hZSFEF8dw9bpdA1uo7HF6YlwX2Mc2xmwjUNV3Vy1CwH7AbXsKqSVs4DqeNEG9AZnAl7WMroFRnBs9mpsrzmyTR2NjK37OKDl2vHPzznu2NFjw8f/4GPDX37uz62fpi4nzqvGSfXDslhje6TsAKUZe94lc39Mw7SNe6sSLLz9nUmDC+v3wAMPD4eeOpx2rX7ebTyG/iq76bFYuyj0+UgRUr6ugf5tO7zafrXOtoAu5RmBLXYOm9Ehv0pH3iEFEwM38ZcdC9asfxasHse1a4KjFOeJHc+9eFx7IZNYtTwAwWhfvYXvUF/6nY5hu59te+of4AjAJRIM1zIApQ6xwWZDsX2RCnSGNmdUK+aV8QnIxZExMb4BwwK/7F5ZQ8v9Fhmg87Ob4Wgz7m+Mt5JVEEFB0T1IDGHZT81TTlqh42gPmOLz2qGhvmlT7jkShOXFP52tFq/USw/VMjyLPXgax9mxSBs0QnbfLnvQg/5aBrb6hU/c9mC9MdDHzUuQ+Wkq4iLDq2+eUYP8kjS0vzEedPPNq1IDanfp6wbS4L7dhmYYlB3GjmH/pLO4zXt6T428LjC2X/77e46dkQzh5CnpB2tb2vP9hMumOQZzR9BRDQyv7s3KZks7hrpZHNi2gA+D3NomjZPYNKhqF3Zhzl4Etp6damU79a3g0dlquQ1IA5UClZ7w6pJtHJqZszH2ecKWmJ0ZJ8qAHJiEs6fPDseffWY4K40tLkk7xJBugbHFKBvYBrhNe9vzcvZkHcMXpqUYFiYVtFyUQx95a9DyAsLUlAMZW91cp+51ZFyahVGhgctMKM4QhRyhHD564WHT53ox9wTyGrVyHMNktvxoMMpvlp30ws4yQ0SKwGN0SCjQ0MwXgLTr3bi3AWt+VUBu6qYGCHZCizOOM5mVQ41/QrM0UGY7kfit3C+hvRwrM++vIkXA8YoyxsNpAo0u73TNMCcFanlXIMkTTrFg9hTvcElIQaS9RZpwRa/ocC8qcsJltjN9XLYvvRuB9tgjb3HiaiCfuqtnWa5ui2Z84nbGOJt2ElKXAbakO00M48q+pon3jMCswa0Wq8RfJtoD4IR4o8Q/3iagAbDdA7C97Q5lJEOjrTi2ArKOjgBbaykCiyX1K7KQOSICgAUAwfXT78f+UAONvwNsASjEd3bhAxDHiThjL/0r8Vb5INvpteBkWNRhaXMdwlZzA71ehI0fLE7sp06eHD710U8M/1kpcB38P/A7bT32vZTBewutrxrbYbFfzttlfF87Em/4gbuGdysN7k5Fk2BMPPbwE8MjDz9mjWvad3nnIp/Nte4tZYhWPc5jfp2Vq/XMPabGsH4NanG4LbBqqZXfJ5MgwNSOVOqfa2zHY7LYHULvytJD10qfDwNKxwWg2l7C7BaId+3pt5zPKW3V/1bPKrIAobwcaQHfg2QPdHpefW+9rKO6SJJQ8WAdA9zRG1RH6MMZ67qOZQSk/bYMIvG1zSojN1IZAeUwtbDMyAOcdU/XipaW75OYguQZ3j1U+dk9wMGUtoaJjTSC3ZI4yWJ32fFISLTodbObddURRfgOBzJkJFMoxe4FefWY5Bdlo9KzbAKmkb1kdxzmsciM+dl68TYuZLqv+zrVL7Fpvt4ibJ6TR8u/71lgPgePE+QwnNC5fmXT+Yu/cWg4lO3bm49XpQbUDjTte/T8YT3R3qzqSeiuh1+VAr3GLrohYPtXf/OtY6dPrw4nTmpl6m0QGUdYAOviisH0RJBBazsrYzCmWGX715MsADeeqHbq8edkkcEoZUUc8JtxHoPf5rJqzkYhek+rrWqVbWMxq9yM5Wsnngzy2pKzsZ9+NDcAYSry3QKwrdMyAWNw7YgjYPvcM0eGVUVFWNl8ZVghSH3sfu6Fx6JtGZmnLk8HRx+nVpcNOUTV8xKwxfB6UqAtXF+AlmxRAbbRwPlVdWAPZ9pDxpd4kXa8qPiUk2FLvMVJZtGFnoDtxBb25J+6GRkF/WTUVFqbxjyUcEIdlsskoyUDPZHDjqTfpK5TYQ3a8mnpcOvz9JlaKMHYIkcwsJ8q221WwNZ6Xk2el+l/tZU7bBawhUlCF1ggBiaYO5uDWteCQVMKGKYwANJ9xGxKgBZZ4NyObOfiSCJmirS8FyRLuIT+VgwukRPQ38JOmZ/29qffTJ0EcJYbr7IwwebrxcxlqW/3aM+aEzhvb/IA22RZ6sUEweYBtIDbc7C1YpctT0CKIIcuB5gXeLUMoeQIREYA7N7iZAywtYDbAFuY3BV0tmJsCfWFHMEJKwoUzOuVuuxwX4AS2K+oYDIJN3+dFYq/SF33mAXYAuQZf67vyqRF3fADM4PNMM0H3WQLcJb7449/evjTT/6xnebGsQn4KVBbtV9Xj20Lcd4sbH4WTDL12Wq28WXf/v3DD//oe4bbDtzqo2FnH7j3IS8k3Gc5p9dVsXuLr2UrbRN5H/vpBQx/w9ga4GZREJuZwZTx1BplKq0+y6A0gLUNdR3OGNsCuehOeWBnALcwnbQNIJe7RZvKQujSFUUPQDZQRjtb+7E5nHcLUUhw1BJodTIHQKLeO0KH3hN6jvfct+POqkwGwFxFoA4b5zS4SA+whXVvSWNbiRgY/yw+VA/IJZgZdqiPmjnV8dg9PncdGuAS1kth//S6rSI2OIKKbITrTdWFsxjAeCsObWR0lD3drj4ebW7Js4qAMHFh2YWAtMYQdUB5pgV79Q9D/+X+me/WS9Dg5bSd1LJLN00m/KD7Nr+f2rvHePpSnft5gO1yf0236d3WGntXrrCd/e/Wzp/+5eeG5/Csv/l4FWtAfeFNujzhu3brycR9r57fUXu3rutVLN1r49KTtY+N7ucCY/tfvvi1Y7C1R4+dqomdwV8TKgbTAytMibeGDF4TTmUbK2dWxcV68jnGwlv76PEELuJFjZMLcTZjuJkUbbwNNGaVVcCW67FlOgJDz4PTgQ1s1wMpI5thti2GoR+ZF2Lss30WEMYkEjZkAhkAOjzJT584ZWB74fQJhflSLMptTOy1hVkT9ry5Y5zz7Al8Ylamvuly1AKiNbYO0+OJKA5k1JBBoDWtRj6aD7JtiAOZ01VWmkgYDbSQ2wCDLCYqlmxAYSaJgMi8a+bT02YBUT630a42j1HNCiCgJQ5KZnJ83pRl1NgC4EIvFjgljm0e7VGdlsxEnTKk/7hPmSVJWB7HBuXvEVhUnMma9JOKkwk0v7tCqLNmeMk6hkc04b4MDAALAOT0hcV+M/UPt1n9mT4IuC1G12OBG9H/YSILFFxUKKNLgEeArQAu0RMAuZpZk5ZUWj7YqaqY3LPrucuRLFNzxt9NxDgLmsG7J+NlHD/ZJXGIJdjaEfwrBqhYJYCtn2JtCeEEwMhTYf0Ici9wsWe/2NoDd5i53UnIOAFZHMgAt06z2+BWf++oUF+WIrA9bcaWImUrOk2UCZhy4U0PaEKK0PjV/bj6Vx1ewHECtoCH2sAoZ0aquvpfLSziCBYWbzJpg1P4fu7TfzJ85o8+5fsuJDgBAP9qBljd79Pf+TROiznj3Cgt2xi+Rmv5nve+c3jjD77Jx59QCuPvfuve4fSpMxmvtYB3CReAbRYnzXTnfdvUAraMB+xLAdswyf27tonBPr3odPfS0+GxyrbxfTuIJbZt7A32wjFg6b861mOX78txlfitPJGu0OORodjJTGVKhsW2BZINiCH24kM2IOlzkwDCsWS9m6N6tSQh4bjQXlPGONISgqvsAJ9ZqsQGTaIh2NzZYMd5y0SD5EAdwWZNDs8A3LatljEQnotxb7AtUM7CUOdGA4xGttKnGHxzX2jXkRpwjTjvZcF8Udeh/NuIu2t2N062nXLYBa3HuFjnJHMmZXYMvWvep2JnQm7A2vLo3uz3S2DVf6aqxv58PWA7L9fyefJdkVVXr+It/ttXVy/8n2Joj87v6eb7V74G1Fb7dVUSLNxRV39Mr19XO99kz5eaY0PA9rOf+9tjJ06eHZ49dsJGqY1gIQ+/xNu3R1acDTA2aKXQprIdhGFz8G626p0qUZo8T7iA2jgqmWVDy2pmIuedBuuMacUow1Z68spgzLvp7/m9Tjca7187hjXDlqEcAKX3YTJgStGvBqQHsOUsbUxxbjgvxuekPMuPyvHkwqkTwy45G2zfxr0TVisArSeqiS2uidjatwkUGuyO95N7HcN92WjiMAYbS2SEOHiQ8tmg20gibJK3EwlAXhl5OEcy7iAzTUxTx33U39G1pvbmrEDKVROs2yDv257mfUAr5TKTaVY+W3JuQ9dXt0uM7ujdXPXYzh7BIpQBtiNMU0/u8TSmM3SQe8BsAtWHrepFQtU1ZfVWIQwiZYkEwY5jaHFZBOA8Ys0pGmQWBX0uCpZJZj6RpOUnuUB6WpjDuRTD4N4YlS1btW+FBaK9YIEuqr8Q//aynMouKILGVcABXuVmcAsYG9iHIQyKKlRiB6hJu0f9jJnOvJCsfmotZhYObOGiITTK9C1cGc5JV0t4utNKq3vOMgQBbUd4oD+veWv1FgGM3QK2ew8oAxnMrSIkbCdzm84FQ5tkDYT9ksZWII5+taLMY51O1+G+aq6Os2DdixcqWvDqPIDai+WxPrJbPRbHMRmzMp+AUxvVt4wVwj5mJwe2MPIdjx/d70UB9c999nPDxz/8MUUvgXDyCdM/q2CFj2I9+GH1+QwOlZ+Pqs+mIicA0X/zynh62zveOrz1HW9x2xDf+v57HlTa3SMxjyNondvLgP0eb9NxAbC9kzWlTp6AbS/4fPI6tusqi+f0U48tL5LTmwCpvYB3YoOyhbYdjGkdb9yFkUkAACAASURBVKcubGVFRuA3tKWjD5RuF6dU2FBsDbdwWQtkGFIe3lnRGFuVf0YDec6BoxknZjxsdSKFxI3dqR2B2F2qgnHEgq50/vqIhdeKFlZat1s6wHun/WXnShe3o6F+g+SKY7EtAOg19W+n4eVedH12L7CHSUtLOmzmqABj+jL3yzjgPfpaWV79nhS8kMhIRxJxgcQS7Iy5XfQPthapwvLjRoHtAvHhHaIw1emaeR1t63pAeWHOnEqzDGLbhl9T4FT/76xtvvpzR889nnzRNx+vWg2o3fC8/HE931qFYJGBjvbYq1ao1/iFNwRsP/6ZLx577vjp4dDTR0cG0fgLQzFOwrWVZuOa1KKAVp4dHH6bgCwrXIAt7zE2GEHiFhrYegszgBiVL4bSoZp6/jGAaSYCtixAiwmtb6Rh7XK9N9uKGnGc9NCUNSvbwFZGobf/wyhkyy+hqfIIsI1WbU0g4MRzzw3PHD40XBRju1syhB0rAA554OswZ18qQzMHtgaOI4jtyTmzzmjEDPACpuK8Ec2tgaT1cISgKvlGMXIxVgmUfoE4oYBbA2K2CNmC22Kv7ID1MGvNlNmg+v5Sx54S9Zo4nW1MMwH72yoTAcjNoAhobtekgkYtspOJ/e26MwAxu5EO5NBjBXyS1SeexGZl+bzAGh1iTObgOg2wdVEMUtIPePi6BbI7R/xVwJ4XTvQtwC06WxhblcXPyujkS4cFDrTPw3e9ziRC/29HEeOh7oAGVgHqRCiyrIQFCSAA9vYccW8FKgVyiaKwCYcUFh++l9r9sGNgTWiUAdBWmswOSG/QXwubBj5xdKwtao0tpyktLTN9iIgIyGdOnT7lsF8wyLQfbC27AKsC39TJLoX62n/H64YDehLLdmXXLvUfMbYsjgCzJUNwjFyBWksRCBNMv7dPX/rNNH7TZ6yxZSvbwDb9YD7pFsQzWMh4S1/kyXcTsM2YjA0oeQI9qHaRcE77i89+fvj9D/zBcOzZoyOonBjWAtx9Hc7lvtXtPvXzwOguz9xsds9WWp83vWF4193v9K4IC4WH5Bj2+CMHXbZJY96LrxFTe8HVEiBfvhbRc91txmokN/68GNsFYMs4hTWtsdkA3aB2Dmz1vhfu3v2pXaFobRM6kAgHjoctALlV5YuDGTFgY9OtQVV94JTFuZGVIKdBk+oYtXyHU5Z+d0FP+ihtjjQB0MlvvBCrcGGA1PMaF2i8V5QEBGnLxQtKV42cQfMEdhZ7gH0hsQe2wBnMxJyGMU7K61uYT/SETVYndufwmlhvkTrwwM+A8iCD2VpSCcrJIhS5xCrOnjoujmYJJ7ZbCRosW/FuGUkZEqs5kSQiSetFy+TYONnyeT/u3hPTFZu7JLjzeHTsXQ//Cdh2b5vvEjRAnY+hEUxjxwyOy35nMLWBHz8fwfRw9cMqy88cOf/4o1PPvvnu1agBtQkG7r163k131POsnjC0j78a5fl+uubcQsd257kgRfi9P/y85oUTw5MHjxRjWw4HTPRMXEw3AKBiWSEBzdyR7QhDqPdosgBUO5gEEdrLIGKkMHYGwdq+j+MJjiXZKk9w/Ugaeot4AdjiCOFBOt3GCwFbO/nURMhghqHIlFUTRgFbb1/ZIATYtkZ0NBD6HEO4KlBy/NjR4ZlDArZnTg17VxRaazsMalb4DWzjDBSGthk+yypjZQpsTxN8syyd7rK1lR0Y3IYPo1pNhsyACbHrA0ONhzsGl+23aF21BQiwVb2H7Qs73kkWqJh2ATFIU/m5Ru4d09uglgmjjXKY5DC2tHXYYNoxTOtk3G2AfbddTv6K0bZWlFd9EilLRT1w/eS6AbYF2MyqJqQYEDRa39Qm17Fur5hLp7UE7BoEJo5tvJvE2Op3l/ktILm2zPsaOXedMyUYJ4RxMuF+3KbdlplMPVH06q8WQV6YAGA9CStmrKUJCrOlzGWXNaEjT7gqFssJMwA4jAGD25wbBrYZfhz6kskpumE70/h92Pt40MPYwkaRjAIP8YBr2KizYmtPKfZyA9tmbJn8Sa17WccTv/bA616v513DbskRVpSaGYnCLey0CLRs0XjeJgACsN0mYIvsCAkR+nJvIHhh2jsuXT9pnwBbaWwrZul6wLZr3sz1wvTfYGBabHpMu4WyMP3Lz39h+MBvf3A4cojskYBFQHZ2ZKABM78XUE2nmQo4tvqsAxicxk4sP269bf/wXulo9+1XxB0d96QSLNx3zwNhMa3bbsb6WlDrRZ3t21SmlnLZ9vR3ANvW2K4LbHMPPY66xlzWWoB6paZ66q35BrfYEtalHTcbBpftdWwGYNb9phja9HtrC+q+ApyQXsDW26FWv4netZwDNa7azjsltUOCZX6gvwFEGe+rpK5VfcGyksYXbWuGXFhSxnRCHXI9SQysPY2jmFlkg2nChQVkUgbuhe+x1YDSpEtPAgnOA6OcyC9hXVmkJ+FEha3zLqNkFyr3JY3N7cTC1nkvS1scWcPmZM9TdbQzWUeASNXPZiQj2YnR9QK+gC02blzC6k3aJnKL+S7N2K7z83IEthObSC3YXof0ySVGw5iuW3/PGVuNqE9uurL5pw6tPXr/NR385geveA2ozd6ii/4zPZW1ZWBF9l0971WbXbsl8IqX7rV/wRcEtsPevVv/4P2fPHZYbO0jjzxhA2eHGQxkTeAZoNE5MZK24kAiVhbwCtBh25FUiIBb8miTKIDJkM9WDHRhgAgVlADvPI0z7F0dkMRjPveYyES/VXXc5Kdtxzr1bqeBEVQWKFsP2JaRGKUIMnZxcltkbG0sALZivI4++6yA7VPDZbFwe1fkoCVGy+FlmIyCUAwOR1CL0WKiDAoN0K7Pxs3ouqFo5Mrk6Rhvp1Xa3KwqmsUJGOQjwC4GfXUVZyBirDJJ6ckkIMNPO5gpN4AMcB/rzeAzZZsMXyCDnb4KSGeyTp0GOOuqliAkPi2B2xvYti2NweWvGPH0H3Oeo723PtNM7yRliNJ6ylJmMMDkTn+jX4wtnjYatbjUu0FeRVEwqMWbWkDPyEs6W+4Bna33PLNdOep2q8MF0KgOivlIX4wUox/T+5JrACY8adXebzH0XgDAjNm5TG1jhy1lL5NDE8B27dwZM7q0oqZPL9PNelInvpiYLl2764h2ZPwYcNpRLCGhDOxhxOyJHueeABUWYwnxder4cetskUc4hBIsHeHrkCWofnZLfnD7XW8Y7njDGwVsb1XIr112wrOkg+tWP2I7ebvGb8aJAAhslsEt5ZwWB11X0dkLgIzANr3Pdaj/xt2BcWUR5ncCBV3viyCTXvpXX/jr4f/+9x8cHnvkUd9z0tcWoJyBx96lMMh1H1rsSTUyx8I3tg4eztHYr/f8yLuH1//A632No88eG7777XtVt5Pkbc4OcxGO64WkzSafzcoYcEq5rWwfF9UjyC12t+VR2eKfg+OM37Fn1pvUbZ7N4LGoz+Ke2LUtMYvTVwBkkquwODbABTzVjlo0rvktES54OJ6zw2xpUa/jAjyRP+2wXTgtXbMdt1hs2UEs8WBxcaWPGpSXU5sZXd0XoDSRcrKAhpXtMZ0sYvwmfgd2quNvXZNdI+uDnbI4jmnYYM8l1uKKid4qZt0guyRONWYZQ9wHY4J5DFtDulz0ugBvJBSUp4E2DLTpHe55tgs3GofJSmQEF+JcXiin0cqpj/jltrkeGXWG7u/rzXDpv/1gLI4xhWueHifQRbv1OdmFf3nkwsFvX1vem5+80jWgvnFA10RHe1s6wECUg29ojNPpbj42WAMvDGyHvVt/5wMfOvbkwaeHhx56PB6iFdTa3vY1xhoadSgptnTYrgTEkhiA7aIdWmXvkAPKDqfnxOFE8S9hbgV8YX5aqsCrU3Ea2MYr3+CrZxdgBvigGVvdbCer6TBJ65sCDPnkWdvZxTLdBCzxaMexBis2rjNUPbJ1MqwGtkeODM8CbM+KsZUTzQ5CImHsG4BgcmbAdsyE0wZmBLa15TSbjMyuUCaAMD29pAnWvXniZ59tAoIGm/oFQc5hbGHf0BgG2MKqbrKBTjxbmGjwXPSYBj9tBGvlnyLyP8BuFjABA5lMqSNLESiX48uGSWRx48DpBUIbCDdgNXnkBVKFe9J5mROQogTEZUHQuudA62KMPZFnwsljki/0+aM9zXGeuCxBgO1NmKBNsJgGt7C2ArZMs7XV6zqt+3O7A3apnmqD5bG1wMq4/6QBw6in3VpSkombrGVahKNtJMySAAFpea/A3mpxtCpwa+9ztdktsFXuPwF8nuxhxPmwtvQZT5uc8StpRsOOEcpMx4th6gVA2upSOY2dkYTmuCIjSBKhBRB6SthcJunzsMoak0REeJ1A7a133jXsv/0OJ2mwlttgg2vBrrEg1auTMwSAknUMgNs622lJmJqbA9vEpy3IXsCr73eBHa3oKPx+Ec7mnH/3118Z/uNvfmB46L6HTPC7m84WRwaLI3ytxUtaGfi43KQFDlWy0MUFCnNtGMZ3vOttw1ve+mbfy1nple/77gPDM0fiXzO3FQsn9gIp48anNdClb9XCndcCqT0GRsaW9i/gZvlBLdr6+8h+AuA9TL2ootzzErScqeyMVU6JYzs6jzWoleMpoI/F0BQzm/MF9IIeAXaJaqA+UWOE88RPgh2COIo5vB7nsZQB2RlAOOwozCz9CLCb65F9jAVmnNU4T6f4RhZARBczsTov9s9JKrz4x0E1CzonikD7yjgpsEk1YI/sE0D/Vh0i0QnAJYtZWGkSmTBmkecw5tCOM1a5LxYyRA9pZ1iPJ6JHuI4DJPuxMF/MmsHmxLYuyVe6P8fOTDt2kXrkWxQVbUfch2fAdLHjNnHQ803pyN19aaCpL+vvL2lR/y+OrD725Ws6/80PXvEaUHvs0kXR0b65Lk4c2r9Xvzj5ihfmH8EFNwBsh62/8msfOPb444eGe+8lO1tATpx7egYBcsRoe+sR1gb9rCZHgO3Kjl3DDjme7JAn9U4Fet+9e5eF+TsFAHfJYWCHVvRbZUAAw9uZKImaICcsO5iVPCEMxWg2fH0kKD3G5/y8AeCCPS+g4W2gZixgFKbjrgW2xap6S2o28TGhMHkAOGXIzp09Mxx+6qnhuacPC9ieHvbvEngXa+tMO/oZhtiTVdVZvDfCijRD1cDIgHpJxzlKImqWwmnDa/gCT5sUi3Wc6T0vBmySVWht9aK1ZgREv4BnPkZY3xNLk4WGs0QVQzQBwbAOc12W7SF6L2+FZ1Fhk8vszNYjGl4bZU6fSW077Q/zPjLKmXj9O0++eR/YHlvd4G3MxuVDwoSUO9UEZr3FW+UoGIL3fcBwsdcFkg3yzPByrrC2myxVyBb9FZhbX6rO6a3e7KX3AKFswSI1GfUMxT30ooP3xeoGLOT+POEZMBRDBvPF+KEPI42xA4xYMbKWaTuWVzKBESnBwcjoLzBoYs62sCWr+8KbmycglkUUE/BmO2UWG2b5RRhrtwHMFROxFjxJpyvGVpnHjpEGGkZOE7aTeuj9ecCKZAd7Dtw53PkDbxRr+wOOjEA6XbPDgA23v9qasap23sa1y2EMYBu2FmCYBcH8QR9hrMPYAmxd97NFnptitExpz96Odf+pJ++/8817hn/3y+8b7hFT2sDO/cs9JiCSQrQTqj/lI5+zwOB6UJnqWrQivoU3/9Cbhne95x1eGKIrfeC+B4cnHn1q6f7Wg94UegK2KUMNXb/qXy3GJkY3WtpIgZZ0tdcA22lh3uvPaXx09Xa0FyPaMkWx5ZPzWEVSkd7amQ5xUgUoWg6gVqAfatGFXTODqw/5DhvQEhjYUu8SleSA48yUesxUqEauSTSQYmS9wNNxBpblgGXzopsA8EKYGASbMQaQqgzF8nJtM8Us4vSbZGVk+FJggVWAdNkEnM0MlPXbUma4DPR7g2716YQMu6r5SYBXdUCq6SRoQEUEEO5EDGR5TFIKA9De0al6mZjZtIRHQdln966Zre8+PcpEqM/6jbMjjv1+48B23il7BMp8fEWXRXLwFwud9uYfr0oNqI8w6fyInu/Wk/d4t5IxbNGovCql+/696IaA7c/9/G8J2D413Hfvg5MjiH6JAbOuswZ0Rw3o9LNsN20VS7sVgAtbK1C7R2GDdmpLE3C1QxPlboAtLK5AL2ALfe0WgVoYIEdPsBShIiaUoxNGBMOVtLkZ6B74vSK9pj0aPMWYmFFj1TxDw80sejVdmrLYoWwN+jEDZp4YZCBhvAC2zz51cNikeKUA212EPtI9W4pgJiVmzddtMGPmmI9LL1ir9Qa2AbvFMBvE5xzxRs7EZK7J6WBnxSvDeUmuw2gp0X8BbPECxmDjLIfGdqfYNxYRrbFtbWbHHA0wy7V8HUAWYC9UWCbFmvgjR0jYK0CEtbs6pvXV1jYyObsufIKa1ctgu34KkAIdubf6LNXe+rOY/3yXc/psnkhq4vQCKIyr03IW0AW0WoNq5raArTyd7UQGuIXeHGk0yjdFXAizFr4vWuP0hwa5Zsfog6rbjraRyZ7QSdEEkpTBCxcvSrBgybWVklZbGzQoxq2dA2GCcMJJW3sxBNNEjEzCIKEX1D3jQANI9G4HEhjYrgpxZmAOqK3+690KnY5wX0REIEEBjo+rZ+XEpq1W2CgYLBZFO3bvG/bccedw4PVv0PMHJEu4NSw/+ne2e13/Yfs9RnmFsfViLjstvPfYqQXl1E8DyPE4v2DGllucGMae5GdDroeeT0Gd3acUtL/zW+8fvvylr2SMAjxYVM8Ro4FkxnADw+ppszFTuwPjGErbLmzn6+8Dt9+qeLR3y37ttr177NEnhgfuecjAb2KGc5KNMLbzYnL/7ShJ3Y4xn8cxU/pgiubv59Evcm+xURNjO95gvSnz4fEcG0cK3dS7QW2xtu2Uys4C/9AJYz8ahHXIL0e60D9sNEzsRWyA6sVRbji/ZQiM+ZLK6FzIokxQlONWnOQArkkTvqJ54DIplm1GZm2pe7D8ivjKSG50DXYYrJ1lsabvqHPGQrKOVRpvy6KoWxzFaCdGXXZR0ASbES5JjJliwHPJL/BFwI7hQ8H9rKjvo7GlHriuZTv6fdo6ZID7QTpPWYj06Xl/mJZ4EzubPplv4jtRfgd1IixwgG31Zy6xtFisjlfXnbd+7KXK922pM3/60IXH/ni5b9z8+9WpAbXh23RldLREPUDP8i09H1B/WWQCXp3ifV9fdUPA9l//6187dvDJw8P99z88MiljGC5mrwJZZv2wluXV7e0obw/hYEJ+ebFA+/aavcXLFIC7a7few+juAtiK3ZVWb6scyRI5ATYK45T84EyeHXg+MWwTI7FB37Q1nYHf7OXUQmEswpSWFrK+HLfx9FUy8AT18nnrZLEavep2lAIZIQDC0wK2Rw4+OWyWF++tuwHrYkPNZEVvOu5mcm1PItGuuYy6RsdB7c9sG9miN6tS0gmuzMUBRyNbyyRfGtsRbuXeyR5FKLI1MS+wtrAvTEC8py4BtjvxajdzGQBids/RAVI3HYWBPzxBjFrn5HiPZlll1HdxLmnwigEmgFacCBe9uVOnHeEgTl/MBJnI+A1Mjk14gVWft9BOg8oGmzH3Aie0p3cLMnHy2OwQPfltgE2xl9wzzKO+v2o2FylCXy9cX5cvzk8B4ylCO9H5j2BOg4PK3KSJkUnUk73aileALVNTZCUBxiwKtzI22C4tDXcmRerRYRT8NNtppJC/rSdE44eDC+BWABJQu0MT73YB3MgsIktoYGudYdCj+w46xbNibU+fPCUHslOKw3xiWD1zWgy/HNrMoorVVxQEgC0yhNvkPLZr337vqjjaRdIJ+nztgBhtb9QdcWwrfa0XBQHu/WBxwfYviy085g2hGtj2eEz1jo8GB488+Ojw/t/6wPDFv/xvWcxQmwUA54DwakeWqD7UrOfcWvv89Is6x/y7Lu0ujZO7paO9867b/fWRw88M9wpUn9VioG/pewW2LgadtNjldnRbj7lNm2ZHInp2+nyB23rfuyGzKq/mr8Wn+2ykMm1j5sDWW+1a6Dl8FjYD9pWFWkVJsJaaMtP+ujY25RJ9lUVjGWT6Q8Y1yVSIU4tTJMkSoselflvL6m13nZOQWhdlryxn0wUMUGtRAqh1ZjEdR9xlqspSCPUhzoUkxuNLC/oxgYVJl8rc2FFUWBhakhT2OfC9R3gt1nQfYavZIUlf5b4uXVJ4MhzV9F0iOyRqTkvyWiJSE1LatDvSvDN3R6vvAn8z31AX/XAUFkBpWR0z5P4yJ8sC/9rHuOCnnq9cfVCH/8yh1cc+uv7RNz99pWtA7XinromOVt6mbvgH9fyW2g1we/PxEtTAhoDtz/7MrwvYHhoevP8Rm4FoqAqQ0DIa9BjY9tplVdvbSDa+Mljx4JbUAHZWk8VuTZS7xd7ugsUVyEVvy5PsLiuaQImggFPK1srilQxKCbvlFagmrmZse/G6sDL2h70qLibDYPL6wLbrky1jjDgPa0abDVwAtomJeFqs16GDB4djioog2ms4sFf3J3C+zc40yZCViRNDCrANcHEayAK3zXwGIJXUoMo5AvF2QmpgXgYuCwyasU1etsQcixHHJDG26G2bVQXsUgdkjtqzZ5cdyaKW0FkMsJIFyDZZVeh60PnsoW+EmO18bLGBra7cGYHM9s4NubcO24ksLFNOAZU3AXJ+lNScAUG+E98XACoO2A1su41GZz47tPGLYlzNFhaL7fqfgI8lCLQln/u+Ncmiu9Pkm2mFsF+16ec2Ny+scgfMmjcuIOudCk3+HeDek7uYI2fTqpiwiatJvOH0RQM/6o+4zsTOBODhXOnFW2mLawHhqbYWPrlogVzLGiIduELYIdUxqWxhlNyWsKblyZ1QaYD5Ak5uq0yeZB87J8exk0occFrPs4qQgEMZSQy4272KYQuwJdzXPulrd0g+tFU7ER383u1IM7ErAYhlsaAPALaEh3J4KjKPueFmWyMeUwELHcfW/X8J2LoLzAzcU7I/H5BT2J9/9i/ST3zxGaCr972QgYAPVszYGMHn+OPUSaIWXPuAGXzHu982/NBbftD3eOrkaSdYeO4YqdinhxenZh6vgzLmB9dYDRDNonYs11ShKVcxls02j5ESCgAn6kUSNtjG9E6FbVQtBD0Ws5AydIL1rzVGbGbvNCTmMo5deRWwVb1Yc+1dngBiwFwnRrBOFZ0/45Ntc8J+6Q9+y2IZYMh1kaNF4nLBiWFYeEW2hDwhINHaW4AwdqasGX0C4I3dTxgy9XPtNDmDmEqe2MiJWZw+yLnCRvve9J3taWlt0dJjF5IZLQtRZzQzuCX2N6G+SKlLtSDZgXHWzsXKTkt1rCXG30PjC+a5yZssCGZCAcpVE9LzAds545r37bQXyYf7fwHbRPZ2c82AbQztwu6A+9d4C0+oQn/+0PnH379e/7752StfA2rnPboqGcPeWFc/qFdkB2SLufl4CWtgQ8D253/2N44xsTxwnxjbYiGJWWhwUcydWSj+9qjMhMYkGBY1rEKHJlqR/IAUnbv37Bt2CtTu3StgizxBjG30nzhgIWEA2AKM4s3qbU9YWzMbvkptiWeAz5MKxD4ViI0JcLlGVtQhwmL85gbCyRlgbGdbjNbJ5qB4MXOPADsZ25PSKR568uDw9BOPD1ukkzywb+ewd6ecx8SiJbc7zJYvXaAW5q0DyHf5YD8p76x8bJhhmMshoTP6JMxOjuXRwDmgMPcZsEVsRelrZYQviDFMfSmwuRyFnC5S9bpPC4sVlTWTpL73hFoTJm2nfwbJzgpU22N872165AhY2sTMzaQS1tcghQmfBY7BLKxkT8QUEb1r1U3di50Dy3o7tm160YzlpHwckPrsrUqzJN7YD2PbUoiA8ziahAkriQORG5CJCFgx6ZJ1zFIE4uR6Apkj86pTAJuvkyO88HEds70aTSpb+Cwk6BOAWzP+1LnK7GgFxYgDYs3Wkg0MNkiAABYooDDhusLITbrQXi04gQN1jQNnsbZXtJjarjGx086X6Gvj3JXYy1XHJlizwHKKZZ0DZizxbKW1FWN7TjsPgFyYXJIc7NmrxAx3vk4OZLcNexTOasfu3dbwbtZCM4uKsPhZTwBscw+e/Lk2UoReDK0DbAERa8Vs97jMIFt8PCOG9IPv+9Dwnz/1ZxkfNQ6z7VuLFi8e0yc6MogBnftejYrZpB9AnOc0aqbj3iww+06BWuwPC4D7JcF6UlKs9R8BkQsAg7PWdRe2jKsMffz0Wma47GcY6Jx3lPH4s14cMs6yaBkXRLNFzCjLmgFbyt7JUaoSfTv+DFmCQW3ZJbOu6Scs2ChHkjBkQW5Qq4eTPDh8okaPyIuYg4RnJFlB2xxOgAgHDSypcX0OoiPUAgjgCpFhqZSduXA6LcbW9iwZyax/ZTGnL+0UVmWPY7EyialPUwYW6Fu2CgSrDOyKxDBmAUAWr5qSPD8xfjl/orgkRFlwpq4p+RyvjlKi8zMvkX6asc05OsmF+1NBzlype9V1ugyjp+y328C7cKnHcd3lRW1s0Qhsl85t/D7ra4WIj+hnv3ho9dHfuv7Vb37zStaA2pptih/V8516YjxxCMMxDAexm4+XoQY2BGx/4ed/89jhp54eHpAUwQYi5OC4OhwHcxluA6QyJsaAZm8CSDMJaut0t7S2eu4A2BrkCtwK1Lb2loDd21fEZpXHNdrbANtMoMGLgJUqTBmLzCeZtObi/DYk0ys/mN9+7glj6SDlBSg5D5m0fFYM9Ahss6o/oZBJTz35pBjbp4bN2m67fe9OMdBs8ausbA2zuW6gF2AL2JtYY5jUBrNEdrgW2Cbrj3+c8o1At4FtsaQ2hDGYYCrArZk5gC2MrW+AuI7aWpRxpgy7xMKx1eoc7p44IzeYx5D1BG1dcDR0qd0GN6lCA2kzIWFE7VxnuUWYn/aSNhNVTiSOTlCAJBNDsUwqqX/ve8nVAmf6Odt+rjLfggOdjLqtNQAAIABJREFU2yfaz4DZSA+ckAEQnhnAn21WmB+0dUQMuNIaW0B0atD9q5M9cN5cMQVK/Esm/ItKZKAtfYHD00qycFFAE3bIbA1tQT9nl8I6ZkkO0Js7fnNYNofKInkCcoSSTtC3zXzOYguTlKHv3W3EguqynFYAAZq4N+k9WJYQc7C2AFuyjcXZsnTCPl/dhV6tqVQfv4AGW/IDwC1yhBPHT2ihdtpM6u7dBxwJYd+BA8OKdKVERCB+rRM/WOdZE6/BZD9ZwCR2bTS2AE6jhAyuelAuIqGssQgAHPnz3l3JQTCjv/cff2/49Ec/M27P+n7cIEHUYVw9IEegmkVRQYJiqufgdjlsn/tNQZE777pjuPuH3+VxARP3yEOPDY888IgBXve++X2MYLbsXn8X29N/zRZKFDXdcALD9Vv/phZ0AbA5theGYXHTrg3YO+RX64vT3hUCkXMB8rgWXTI1nLrm87J9SAimnaQCUrSJvjc4pfV0M2hanewFW1LMqJ0I0ZpqoZV6zdgHpMVssLuXWNOXCDWo/m/2F/2uNamxiZTbeyJeCPFZIg0AUtGpM1bw0UAasEpGMOyqjmP3KSluyzbrvDtEmrDQJhoMANhgmli2KqsdzpC0aXFGEhLKQj+kvIxB7jF9KyB4q8GxJAfFFntHphhjx0Mve9j2q2fEGwG2ITMq0oTHQNrMNuQ6wLY+LhzbdvPqc/rlL29evfSbB4eDq/N+evP9q1MDalta8h16AmqV/nEgjuM3NZYVuuXm4+WsgTmy6/HIKxSlJZJ6bv2lX/z3YWwFbAMWarvFFrNHYhnMvBSwhDXRsWbrCtwWMNyqSAhobgn6vnfvvmGXgO0usULobgG4u/TcbklCwMCKQK69+O0Yk8GfoZ9byGQSw9wZe14MsOUcAFsDypowm7GdA1uMGswcDjgHn3hieEYa221KJ3nHXt3P7h3esmIbDWDrCcUzi6CTJ4X5s7WqeBdPk3sfkzBRUVmFwW2QkHM6UkHJGvjADlyeFHQfhG6y8xhRCwChmezQqwF6mWh2S+OM3jahcorFKmA5Or9Rx9Yzh8nmfsyQAiPRUevWOvOYPaP5vcFwtiPH4PjUJ4DHQC5gNlu4BbzcN1L+GPdc11Oyi57rTkxdkMII2kzFFIArhjihvpzmILsGpPnEexpPaZ6SBAgNhhXxpDYDInQmZtfSRXfK2XOaXM/IqeQkDlhyHiSDF97S21SHO+woSYrZRCsA0AbUxunF4NYhsvg70pqW9rQDHxrWXgQGdBXIcaXA8AAwBG61QNmEDlC3TNYvxgvANpnGwvwahJbu1nVeuw8wdDDxl0ihC7g9pfBfx08qSoL0tgp1tHPHXgPbPURD2KOoJcTw5F4c6SKSA0+8zS57LcG9VDpt30NY7vk4pPz0tU6p6/ioaWH375MnTg0fef8fDH/0nz5h4NKsagAh7d1yFvpqdlIa4LbG3tXUi+8GvcXeugarHvv9nj27hx/+sffKQYzQkYOkRYeto11TuLyu+zHSnT+pR52nj5l9kbf02VpwhiZM/+6fTaxxWO8x65nlPhP4bXvWO0Ad2qulCI5O0QsZA+ToMrtchZezK+RisZsS8D0urLFLBdTaETS+BknSkOgICfOFHaBMsNmcESlC3ZxlB4BE+jiLFo41sFT/BHD66rouDG12g5JMAV06i2zHd5ZTocGu7ymLbp+HhBc+t5h0RQ4xO6/rJ2armFjbkSz0LS3QuMbOwfZ2HF7kDABc6hqwzK5F2iNzGb4RsMIsOjFFvma1R4B0yk/s7skpk9/OdgfS9Nc8Ftj7uqTlIZ4Tkjho6lIFbLnWCHHrvLN5Tqc5rbb/9XPnTvzqc8NzeNTffLwGakBt/QYV4yf03KsnHf8+Pb+tvjzFhHsNlPMfaxE2BGx/5Zfed+zgEwK2ShEZz3K2jaMF7RiD7ceH4XT4o9qupOKcGcksT1bCvbonYsJ2aZgAtbslR9iF5hZw26HB0NwCbslsJMMIuPUWqyUObbYDbvhgWVawbEgWdE2hMNc1Pg5BNGNsHf2hJshmbJkEyKIDsH1KwJaoCFr7D3fuk2bYUgS0lBjZGXtDnRmYNrAFpAAUs40PsLV1M7aKrs2aMDsSTWxur/Jdtzg+VaSEvj9nU8MgluPHmoyzJ6u6WwMaYqjqvCtydIMtZ6JxUH+Dy+DJMTamayqygA4/5kmKdjbCada85CYFnhLLIMx5GKcCjgYZ2RqPfrnBae7bG8vUN7+1vpa/wzdRptj1BuF8D30f0JOn/qPPwXBZVxvGNowxjKicxjZJE4gjC1ElkCKYrg4I78UB9UjdsoCB+UZqcPbseQHak8Ozzx0bjirj3HN6PStwu0PblLft2TvcpugBe/WKh7ezMcHMWlIDKMwiDcYJYBu5QEB9ylpA1H08YCWPbHROumIiJCg8F4yawrjJ/c0RLtCmwxADqg3o0S1z/gK3HiNm1L3d4Qgbly1JOOcJ/sTxU8Oxo8ed1nS7wtXtRmerxAzb9oit5ZzWuVPvScKQNqWf054J3t+6Wi9Ci7FdH9iisZUkosbZWSWo+MMPfWz4/d/9sOUQEyObfuL+4H5Z7V7t3wujOUistZLbsxNZ0GW6/ppppR3e/d53DT/45jf53CeEC0iwcELg2g+ARpmJpeVONctkPxYB8/R57ZVM90AfLpM1Auy+J/fz1Kvf1g5X+n/7MJT97bovBBypT8aVM8kWQrJprF6Ue2gqoEyNTQ7/S1xY61lLyuR0417oE5EgCRqa7Y8jWcJdMS7pbzC8HMPuWkcBScQGL2/8DwaWB3Wf7ffyK1D/R5aDkxnOh8wfRHbxoqeEwRzLuGIcMp4ZI7bTYQ2sofX967wwsThJMn65Fmyz5TI6ck3AGRlSO/IydtiBSUgyuUrofWR2ONEJhAsMs/grwxybTL3qWEexKVnbuDNQ9d0vU2+oFujO5IVFbOr8nN35slO3HrB1pQiRb/4PW9Yu/5IYWrG1Nx+vhRpQHwXI/nd63lXleVyvpMHFqN18vEI1MEd2bQN5XWBsf+Xfvu8YLMaDDz42m2wDtjKwYQB6ONZgL2PdbIPDwMhYbME5yROeDAP6QrFn5JwHXAFw0dziVLZHTC7hv3YqWgIAwc5kOJKZtWVynk30PlmMfz+uWR1jC2qlG+A4N/lV9sKVBn1mL8IoZmLJMY4Hqj/MIMiwn9b27cHHBWwPPTnskBW8c/9eRUUAzJS+s4xeAGu2r1JlAhWlqeK8HWS8J9PoCQFWbMuF9WoNFtYuIb8KiJkd7S2tBscCynid82QLsbXQMvxETGCicuxGssEp1BqxhZ0pzl7LzOgNRotpMkufts52YqIAGLjWoqLDDpmpNrilrtIxumU6dFqzru3V3axrN1E83vMY4d30kT/12d3mobeY0HnlG8ek9Lb5BARSVjmQqA9qmhsuwfghn4B1Bmg7S1G8uVkUAN5xpiJT15kzArSKHHBcmurjkp88+8yR4dDhg8NxhctSjx7uvON2PRX3VSznrQK3e1SfK0qcQBxnYjYnqkeydtGfvdArYMstGMjSr63HxdGlQHnVXzTrWWApd4kBwGVCg0lju9ns1OYCtgIIjBVnHtP9OotfwpuN4c48YSIXASDLw3tVchU9TypKwlFJAACWAJWde28VuN0/rGgXZQug2cyv1wHuK5PDW6RHSaiCHpmxmaxPbqNu1GpPWOPEgb2kmLqrwyc+8onhA+/7oDW+I+taLd/2w6C2elGD2JHNbRBnE1ASBfrrbOx6oVaLHhYRb3n7DynJwlvd32nf+7/74HBIciv3Vfpzl3XshXkzftf0WtZuY//mXY7JGeJemRHg8tRdxFxlVHQ5faqWI3Cs11q1qDbILV2tmcxJb+s+UTsUids7yRpGcD67D67qxVs9AmyxIeXAZLAZidG4S4P9sL428ZRZHHszSSezA5euCVubXRoeAZsNttnGp09mQU0yhYSJNNusPoop6TBdlrtwFg1oLzQB2o5AgMxF59A1cMxtUgW5Wu8kxTksNhpWGikC92cZgsgRj23vxon5JZZyyS26L/V3jugDc4wNLiabxVtCfFFdISyWyZSl7rI0y8x3L4ox9yKisoy1kcT8ttRnfWD7Pq1rf+Ho8Pjh5evd/PvVqQH1A6QGP6bn22MRBhYb6GiPvTol+qd91QkJTkiPzxaA7a/+8m8fe+qpI8OD0ps1w2arVkbbg9vbKTGWDv1SRjuRATDqYRPiXBCEwkKciQVnshW89PfJmQzWFgbXzK0iDJCdTMwuINdbrWKMthk0hi3yZMC5JxrE5QqrGa2jzex8cnUxF1BSHZMyYSTtIMBR6NYKO3VXAZzABABsTxx7bjhsje3BYacM9IF9Cmkm9u4WnGxgEDyVgRMpj87ryaKMpcFrVSMOZQaOOtZzgnlcb3n1pJNpEqsKmwtA7nsLwPS2os8dZxDAb3RhCTsVViBaUjSW54lvi3ewgJaZcgExxyo1MJ3asOaJ2eStkuh8TsWZIvvRE2xypk+fTUCkPsu05f/7uwIhUxesRYtZ3dSFYU311vzWF6xJLMA2W7lsf0+Oij43TxzMHJRd7IyqYfWC2EImJzO4cbZi/9c6XSZZTdyrmvROCcweFXh95pmjAn3PDsfE0B7T68njz2mr/Kwn523S4sHS3nHgjuF1r3v9cJciCdx2q8JlkYjEiTCSfAQ2FVBnWUIxmh1H2Mxi6VIZM7BPnTTD40d1wG/cFQG5KuRFbcdeBdwyaat+VtDzavJmwkZmYkdPAC6A1MC2tkt7TDjAArIG9YVzim17WlESpLE9Czuleti+U31C2/ROpWtnSP1e469TTDuzU8uMDBxh7qjG6CW7GywDWzPUur8/+8znhl/5N7/mVLReHDcQpV+4zfJv2savli9Q2GN7BI2UweO1GM//n7334LIsu8oET5rIjIj0rjLLZGWWk6pURrYZGhr1wjQNA02vWcNaMz9iVs9izTAz0Ag/eAkJSQghEAhh1AJBCZA3IBCNkFSSylel9z7ShM+MrMz5zN7nnvciIhX0CGWq9V7Vy3jmvnvPPWaf73zn23vH+XJtyd2N2+/aUR4CS7sGC2YCqf17D0BLezhYwa7P1g7c96IH2LrX135ZezeuGyN1HrDlMRLLZF9u7sXrbX+RURHqronujXaucxjLe81QfbkbRilCZWyzToXCsoS2hx5VCXJpw2NxLBtl9lZSBCZoUESXkELRGVXDEjpcfhcOYU5t6xS1tnXO/sUFNB+0K1Fl1i2jDBwXLAUX2x7VUU6UWxIwFcsF544BJQcZVpAfc9hmNkZhYYLmiH5A3wguc8ksa4xj3FmyAGcxHsMdLXy3GrtWvDfuynA+Yp9TTFuMLR5L6Q/L5mvHYt5rAd9ONqbf9jyqrVJ9mZxQH4rFQ2WsszWEmhcGtmid35+bvfpTF8qJIwtcavDRTagBtB+b+CE8H8GTnZn5tMnQHroJxRlcMmpgScD2Tb/6TkSzOln2YwKw3fGo5mSbq30ZIG2r0wnKDgHVsQOfmWEgG5UOBuG1TM0ug8yLncU2/kbqbTeAwUWGMsZapeY2tnUpRVB829WO4ciLiQEMg++VtEx1beCFmFsb+K8ObDUB0bh2c6smHrEIBLYwhBeRuYlShIunT5Y1ANxbsG27FsCW7ID0gDRovBzZMWhwzZy6rsxyh4QiQC/rldfVWkEAluG20opGOBtOl5qE/Nu8xw7Ykm7hdRhqituIkR6TRpWLCiQ7YfmnoaWcBStBsMzttnVw5uMCg7nfmSSjAxoqZgWT6jTBNKRuTxVO8BUMaQt23fZZ1mYFRYAWzGyy4opkG5O96lrn5fV9RrZxcMj+TgyX9sV7gK3AkzS0/Mp9j3TjVcz6M3PX4wlkx37KCVcAuOuzlB9MA+CNQXZwHH1/34ED5fChA5CenEd9wgeAbBNrjpMQfrcamvHNm7aUbQC1d2y/o2y/bWvZBHDLBRo1fko7SoApYOtxoOgBUk+EoxWxNeqPuxoZIcEyBfejCigFdMmaMzrCDOLaMv0uWVvUHqUIStjgmLbUxcqZjMBWjpdeaEnBR8mKFmiY4KEnnQK4pQyB27JMWMHtWmprGV96BReTOo9lEmpTgg/Fq6XunuxcyhE0JAVu3S2yN7DarpXPfPLvy3NPvVA+/qFPItrA0Q4YBgizUYrFsP4moE002IGJ/C77WPTS2nedte562bBpfXn0VY+WzVs26f6PHj6GaAd7JCeqzG+97g1Ai42MjvRjcWDrrpv9tncHYjFgq67OcRGLPe1kaJwEsFUd9TG20RaKbcuwWWxjLQx6QVfuqtkmdcBW/SEWxd45oi42QoAFa0t7pdBWBLUY9I4wgCQwDH2Fc0nDKgrX52KWMNsDaHEhCciIDuzLLJ8AJsuNX1uv6h0KhRdk/eIYhfAKTT93YLTA57VwXc0j1NZGZAaOJd6HnCfxW4Jp7iqwj1vjC0INv5nFYpCLRrK8c9DM8kcrsZhnVJMEoSmbYzQEXZGkDUEzxzxtk+x30wPqgoy2uOka6h3ZIw3ASVewfJZ02bTZhpsoqiCZ82u0EazU+zEX/Oezl48NnI56q/emvkO77UQBGL5rLZ5c/TyL53Now6Z33NQiftNefEnA9i1vehcYW0zuYGw5srU1I92TRqUNTqz2E1baODvWbW4t2bEoWLicrLimDm/w1UzcAEeyDRs2iSli8oY1axjjltnJEAqMIY3oTAY2lKyUQKA0ngQlwUbJVLTA1tNLz+OrAFsaV3rusnIEvAR64gwNsJ2D88Q42Dw6j106e7qsQ9kS2BIA6DKsHv4Vk+qc466r7ktPKtaqydrxZ5xQ+ImsnyUA/Ju/S22Xq98MsIxkODrJ85hAmhpRTlIxQelerjG8FbRmYCQuMyOZ2JMChhwh15iRjJpm3IuDwLtec4KucWH5Seh2a+3ifbKC/YxRTuSZXMKsVYKWbsuVSDTBlyYRXpvtHFu0rJuuKXQA/u8FthnaSpnH6hYu42xiMsONz+CfacpT2Q6RYUzHhc6V1yBrPwNG+wI11Oj7e/fvLwcP7oOmFhFa0I7SJIob9qqHDOQInCG3Ig3tnXfcWe5Exq6tW7eWjZCmCBhGCC5rxK05p7429eJi45Kx5TapQh7h7KG1VV8MpnMlx5agKSUlkCRgsl7GiRll4sROPfpqhhNjFAPF67XEwXF82ZLeENcuAvoJQYB0xAC4lK1IWyxpBqUTjpErh7aM2sByC3iRMfOiZSVBrQNQGNR62FQQyDb89Mf+prztjb+FzGeXy7e//lvLF/7xiXL0yFH2BIO5ahM81moCBq1O+AkXL/qjeufhKWFp+1LH2EKeATbuoUdeVu4KHe3YufPlGcSjnUQkiJZpczv6uvq8duqA2dmBewxJc7x/WX/fWRyPnFiiVRDv0zXMMqtKv3eoxC6cnRdcrpoAvAKyrnffq3estL3OzHCqGNWQX+d9RaHS6MtexBvrys3IWttv50L+XLtYArZ4KotegF5qtPFlZg4T2GUoOSZ0YKQBlgUP9i2nu3XSB55fdhsPxmLmPWd9GfSF7IDAFnaLbUyGVfGhSQjgPXfv6GjGceokIZQz+LUXZmCDqaUnCFf8XBwvXwSDYzq4XgtHNwJlhSRE/1a6YIwh/iVT7Truyp3xc+v81/SH2t3bWbX2ig7Y8ie22UlKNIC4d8z8Nez/j5++cuzpBbrd4KObVANou0249OvwZKIFPhguiiytw4gMHje9BpYGbH/tXWOnTp8CsD0UeiMPyFzlJ7BNAyrnsQAt+pvsg6QINrgGcTYanqwgMQAzq7i2kCQQ4K5FljKCrTWMccvvMEnRSYfpdpUBSYAzJA4RBizWwD0VO4+1vQGwpX3Xtn0C2xsytpfLxXNjAraTF8bKegCJBLbaDgxUKzBKFgPMhBgRBeyPGUOOY7lqZ51ab+V1Q4DZRMfaEgujGBpb/jaTOFRgSxArnbAdPhh/UsCWhl1b9dadEjpfhgFneCdGTxCIiVjCdL4gGCPrIU9gam519XB2anpODVOGa7QyBIPOblKv8hA1d8MoRZ+ozFmuIgJMuHt4guZrASDcrJIk6Dvrtz2PB6IiCOBWpAArQSIDw8P7+hoZW9w3qvklMNd2RrJ2kZ4iyUTKsQr3Mz41ATB7oRyAjnrPvr3lyJF9YKBmpF/WVnD0JUJNSg42bNxctu+4vdwFcHv77beXrYgBux7yGkedSEcrRsxw/yXjWceHIkbgc9wTWd7cgs3UxLyUJ3ksOASryfqQkYc9pUMN2HdHXgi5Q0gTuHsgJ7pAntEd5RjDfkKP9JcAWK7SgVHsVGg0la6ZoJWLHJaNgMnhyOw8xrYgy00ymgDCzGKsNQWi2UD/9W//a3nLL78NCV5o/wvkGtvKv/muby9P/NOXy2Gkps1+VW1G9LPKzYctUd/PPhFt3doZ9c4AyOy797/8Puho79PigLphRjo4c/psYGT3zYr62lfRN3VA2ooOH8432tF/0/7NP6AbA3lrCapdhACo8UN19Xp/4XwVH1qCFeMnwW0DdDMKiM4Zi/0ErxozOZbiflMD7E2h3AmKNLU8HucheGUfyQX4skhgQ3mCNLO0K7RZfC9gaxacix5GGOAxo5CTeZHtZA6UJTj5C4GqwbPZaevbs35Y/dTm0qFM4QvxHaVpbBhJcSgFovQL9UIAzUUc5RGyQ/aic6iw2CnLxEKszisYxwo/Kb8Ploe/Yx05Brgcz7DAZPkVzhCFSftG2UW7MMo2b+eabFubb0up0mHOulo/2l03tVu5/lkYpx85OXf0iwv1pcFnN6cG0E7seK/G894oAePQfgH94OLNKdHgqovVwBKB7TvH6C394gv7rO2M/ZaqDwr2VkxkrL7TAGiiEesXThC5V1OX6Ga9aIO4bUq97VoB23XQ3HIrF85YobddO+ooCc7qRSBBL1gDA221ctvRKDImrc5wdFYkX311KYJA1ELAlhM/DCoZ20vQ2B45fKjMXLpQNgJ4b1ozXNZAMiFgW5lsFolOAga2miwpIxARa/mGZQeOc2tjx6sb6PI8wggEqpya4lieQ1pglocMQDC/GZdSGth48pxiosmWoHAKp4NTMe3rFero9PTMR3DLcGvWgjrXuzWP3VaZ/Kw4I6FgSd6r3nPREtVcjT/bJUAJW1yMbTBW/sqzucGb43Hqc50nUYWvz9iulaGLRZOOEqjlQikZLANeShKYgAFTarmCjjaH59WXCHQTIKQUgPVippA7C5RyTINdPA/W9tTZc+UQknDs3f9iOX3qOLbuGZLQHNsyxVJ2Px9CNIFt23aUOwBqd961E7KEHQC761SnZNN8mzkmnNDAsYNZZkoRfG3rFB11gpN6Rnfgbwlsh7SNS6YffQrbupQjvESJBB7clqVnunS2akNv8/oarlctCAhs0e5XyO7jvIxHQdrVyRbMojkXVGimOdaCaeaNp6zIdcadmYxf66b+yhe/XN7yi28tT335mWxFNeUWONr92+/+jvLkF59UrNjsv3W81cEara/J3gsXlVtUcPaBrg3zs5277lI8WjpFknV78YW95eCBw657r34qKKngw73MY099Kd8116rlmv9iIZAz76gEwE2Xzn7fY4jxJsN/ZVaxXLCxWAls0zErw+mlRKTuXiWwTWY3Gt635oWlGUyZI9vO2HkjkFVdcEFepQnh/MqdGZwkwyLyBJnZkIy/YtMSECtMGHYA8H417AjjxArA4rXnDkYvYLQNOrTSucxhuZTKFv02U96qX2BMSHagRrSEgY5qngcigxklOezfZF/lB8HwXdhtwOKLLC4XdiynmFlJtObKWvQRLup4vwbjjE/uaA/ZpmSFVWMct9qF9I6l+m3TyJLmte/9I3Uo2Xa8dIxf2KAIc5Z1HL/7HP7+59Ozhz99g642+OrrXAPoq+xur8DzYTy52memMGYMY+awweMWrIEeeypr52eP89ibobG9iMn9xecBbGOrKoXwGrTSViWLyzN4aycn00xJm2kn66o2PEsdVNxbTisZZiji2m5AqCFmJ2PaXUZHkKe5AtG3k3UAA4IDAWiZigWrWtfNvcwFjgi73uM8ZvDG+b6bZDUxkn0AS0bnseNHj5Tpi+cFbDcghi1T6hpeh8Qg6idDd9UVOspC8JSglMIt/kZGm3UjYBsOByx6LCpqhAQWLFQX0sAFsNX5xJ44TA8f6QiiyQLnduB0hhgD4Mb3ZF2VXlKhwph1B+y4sr+BIQfjIRlJZUXdSTzpZkUa0rI8dnsLH/YACAJpAhReyFS9X3yvP/laoMXsvsoe/+YxZBoryxmsrcGKF1DeE4+FFF/TUQThveZgn8RKUmPMZ/SUlFd4qz8WSnFtTtQTU9NlDNEvTp06U/Yd3F8OHz5Yxs6e8UJFWls+WBcGqOyz2wFod+3cXXbeeUfZgiQH6yGtke41pB06PYrqLF0uq6IIiH2zowzbIdO11kUcjmM2JaatdZckY+a4tmSwOOHy81UEsozE0Diq5bY960pkFltKkhdd0FvelEmITTaLJnCreZ2AgvXuMeZzBXuOo6gVZh4TgvDnn362vOPN7yj/9Pef1zHVyESdbgaL/Z3f+50AvE+XvVgstxKEumCJblWBqEB3nCmBWZzPMpVlikP72KsfgZ52g7agDx88XPbAZpE1VFSEHkAc41kF7MwgXyWw7Y6Ie8+u3ntXfteco+eweW+CKRbIjd/F6zxUMF4AzfBTGfTEuAvT1eJ2jmW2fZaFZL93f3RjJSMcYzSuazucY8z2W/cf8gLHuLV9z6QMkiMotisX1XYuU6QEMrVyUDWryYQlTG7AB/suQamyikX4O4LcjBVOe+G2ZVpdW07ap7RnTudtWRtBq8Y6+3kkP2G/pyOYfTpwKqWojrCAXKBKMsXdGO5z2M5RU8tMl6yzWfga8IerWE50dvYX7yy6f4tZ1vvOp8HN3fQhvkuTlEdbAAAgAElEQVTSpr8vaBz5vjLmb8vY4uMnUb6fOH35yF/fuO8Mvv161wD63G5ckyztKJ7s0JSFvIjxvjDI+HoXcHC9BWugs+gdqLWFaRI0/Pqv/NbYJPLKP//cHk229uw3IKMB5nZmAtvgG2UExEQx85S8Uz0p6iEqzokFJFvQRwzTgv+h6xuGVnE92Nr19Cxfv1EZytYi8QE9mdfQkUxgywyUnvLUtme7JxgbkfbRgen5TG0e1w9sZbpYJho1nlvvY5KIqAgXGBUBMWxnwdhuYExYxLBdDcPqbeQEtg6B45U+gaojIFSWNUCrEVwAQgFbgrqubsXUihX3QoJzAGXqBsoGwHlOB1aHcxFiQZqi63Rz3JZz6CMvKHhZx9AliPE2JCcjxV0FMKJ3/EqwKQJXnICM9eu2fTK5ymaU9632bpo7JoKOiY4Wij6U9apaVv9IRs5dVBNDnIOnzbTKmsDswRWMJP9iYaG4VIzjitd4XkOYL0oRwPGwk6HuLGPIqV2dXuCB7H8HVFjfSsiA/n8ecV6PHDteDsKJ7MihQ9BpMjEDnV24fU/gbpZ1FTKbbUBig1137yq777677Nh+G+Lboh9Dv5zh1MQsabL1OFF6UTpiib2NCbOC9chiRuBNAMy/XAQSxKh/EFxQJws5AtqdlAKGhNpYYcbYdwV4AhwmsMUx2ilB28p5R0DYsUCzfEyva+mMgW5tJ41lq3U1bnHOQ3v3IWzXu8rffeozqthqXGKiTxiwfsO68j3f/91wIHuuvPjc3p5xmoC5/dCfNYiuBRU49whYt0df9Ypy107GRF8GRv1MeebJ5xTGy4Xjn155lMvsMd0CW7/tzGKO+Z5C6k2vHVkM2Kbd6f2+Y5uzn+ciztcxsPVLL9j0GaNiqNwuY6exjR2HGAMV3Ea7CzQ24FltyHM3JjI2iNzOsO2UHzhyAcFcLC1T4hTb6LTflDnxuPyNbCiBI53y8IYAlX1JOn5KlQiIeX5t+3PnjTFkkbVPi3oDTz6d+IU8fRdui0wvF9kEsawP/oIAdTmuI4cwamNhu8gAW4plO8L5KkkW3guBLBOEcOfjJWppqQcOh7JZOoyxguM+VCEyn4vjGNdlhDajnY33C/2Ci+EKaq+XF68vv/6Tp2aOvH9+/xp8cjNrAO29Bdf/FjyZtYVNSUPFrGFerQ0et3QNdBY8zL8sRh+wfdMvv2OMW6/PPbPHwCmAreCG0FcwtnqfTIPPpPi1yTg0VWGsxUsF04stVc0nOHYIYaeksUUIpfWICboGr9dJbws2l8kbwCamzlYTdnhqewvV52ytdo9RalLw9rfMosCWjIdAREwovAaNOqUICPt06sSJcmX8IoDtMDTAML7UpNrWUcTo7Se9502zrjIwebK1AdxEIfKfYAf489DcpsTCzMl8YEsInEywtgU1eZBdAcDFawHA0LjJOUhbYzTg5lcZlJ13aDGBQaI+IzuoeKwIyQaGw2HVAiTgdnJ7WyGo+PuYANSxhH2yi0VfEeIha5oaM0/yPE7wJXSZ+kxOM8Hu5kSvNuDJO0DFiduLnOhrwTySpb3OyAhygoKGDtcQzofOVlIQnKhjkhMcqAsGM6YWd+gvRA24ND5VzkCSQ0nCITC3J49hQYPkBmyjWp8qHJ2WRssOaG137dpV7r7rzrJ92zaFBCMIq/1TCyYzeBwnimOLeyG4zYejTBjcKENZIBuCWoXaEt/KjHCcMDFJM5UoAQWOs6MLQS77L5nrAId6j1/yWpT1KFlEhiPLevA4kuMQnQ850ccEn8yggC0OOwqN+Xt+83fKpz/6SddnFj4Aot93poYxk7/3B/8dYsfuKc8hIUL7SADYMrf+zHXSOiVyofWyhx5QPFoCl0lkT3vqK8+ATXe8+gR4Wvio35iNV0lUN9H3snRZ3vjbX67WWPYD256buNGbBJUcZz0yGve1XCT4ZZQvgK0dDROgx/0IzHbA1sx/SFeCvU2mu7vfqIOmVXKYdjbE4zWzj/GNABnHPH7HhTt1qOwbahe8Z0IFAVyxsxklwfblJdghLZYoayBzy+gdTGnNPhX1Jd1/7oBwbApRGmhTqkBZAcvE2NxuQu/qCDBzYSYbbTKB44ExpClBcH343CybUzqvQjrpqRqdgfp4SnpcWprt2ApbrC2jferconJ7vMkEVrPXyRMyVjmA9iFc4WdOzR79/SX3m8GBX5caQHuuwYXI0O6KC57A3ycwdgZZ3b4uLfC1uUhrq8Oyzge2b0TmMRoFZuVJlpX6JgvqY8azeTOQIW4IgMMt1WSArE+KS+r72F7S6jjitfJrTFLrwdSuB8tlvS3i2wIUMErCWob/YggiaQi5dWpDTlDrazXAJwxuT1UtAGw74Gv9oZwFFFfR56osUkyK2qYisIVhv4Qt6tOIYXsNAGctyjMMYMsUp8aoujGc06G9HMnAwFagQSCVhtjMaQ8oCIOfYWBaYMtCykgmiBBgDkkIjbL0vHQgs+NGet+yzaSLI5hV4odoJ7QL70WQlpMDnSkEPg1srgHpMZwVM8IpXWtMFHa8MFiSZ3IDbHVfqj9PojlhVmY5QEatZOJUTpq8J9WzwVhuxQeajab0/Wv2ENDmdielEpFwIeQHZQWAOBZBpGB5D2QfCWwznWgPCaN7MGMkUjfAguoIl7rCZAIIh3UBaXRPnjqJ0F9HyoED+8u5c2fkhJJOOLxX6QgBFNdBJ74TjO3uXbsRJQGOZFu2lnXovxm7M+Ua6seqd299ipFVzE8746WW0tpf3q/DHRm8OiECmX0xtpz0yVrxPjnCNBxZp/b2ulaBDyMmAMwq4gFDg0U4MNW9PfPrVjS3nAkKtOEQIb1QrrOnTpX3vuvd5eN/+WEH12eFavwZhPYD2nxPicv3/cd/X/ZBhvD0Vxghp/dRd0V6gGYA2xiU99y7qzz06INK3MJYpATJdEQTHGx+p9cEG6qLBJPul9mnehjaRcBtL6hlIRbf+em5mwpku099vV5gW8dBjplGNpH3ZJbWi4m2jrrwX14AOSZzLvb4OtpDUh2DrwRhiSoTXEr+hDJoB4dLJsWvZcP7G9srMrW0LY6g4c+YHteSBC2W6XwpJ1zPE7RHtNEEvAppx21/prbFsZJZ0KU1dOX8DZlXhZfjLgjnGe1sQOKA65L9ZWY87i4oAgOuo9BgvAbuXRIHnhd9ntdmtrI5OFZ6d4Vjkxpd9HLMOSzvCHYCHccW0UXYhWn7IoLCvM4Z7cMTVfshO5z1GraOPwwbaFvP4186CWv886emD//mQucdfHbzagD9kLvUj+L5IJ58TSDLBAunb16pBlf+b62BJQHbX/2Ft45xq4ZsSA7WBGVaYQew0pzD8cztUU0imVQ19a82sFplBx42i+ntLtpPxj8kqGDopHUI+yU5AsDtGoAEOpExQgIN1bDSlIb8AMcz/FeyW5HhoILrnsr5ZwNbbzElYjZYIJIwsB2/eLGMnTkLxvZSWYv93xHof+n9LrmGnMG4BRfAVvoxGn7LESrYk9FTrRkMynjaQFbwysoJMJzAtoLHqP8E6DoXNbdiT5xlzNraCNUT5xGDEeF3eIwZPt4r2UFu4RsIXsE5xNyGc98QtvGYsSzjPSqOaToVhbXPCdIQtQG2mhCseasMUoAJSe3wXacTNGNr7VwAG53f50iwxq8ypShBLKMgALWV5QDjyxS/ko5iDtnjbMNkeXIqD5CDz5x+lQ3My4XulVIb9ktqCBGPcxxJDC4gQ9fxE6cQ/utgOXj4IDKRnYu4nWzvZIEdkm4zQn7t3n1PuXvnrnLHjh2RuGFtBY7GOBmXU6so9WM7X3pyNoNrBpZ6dWkvCeY52Qvbu04IaJWNjF7luD8ulzTe+B37E9s3mFmm+WX8TjmXpXMgWW8VKPo8z8C+FN7vlLUQ8DBKxJ+954/Kh//8g2LfcobPGm2zxqVN8Bi0uSGo+Q8//APlIBzHvgIHsnx0ANMgQb9Qn4xGwfttiA/8KHW0CKPG61FDu+dFav/TSz36sH7t0VTBHM/TLE4D4QUYD9i9CLCthVzwRfbyhY9qgXPeUwLb7r1utt6zFwgBgONzM/f2X+gHtw5V1+0qkRxw1JhYNAWg7XS5+E4Nlq3WTQUhdrL9lBg7wCv7QiyaxcrKvnjRw0HC7f+MZ8vxRaBLGziN3T4u3nQlfM65RA5pzHzIuLv4j79j9ALuKinurMKWRaYv/IwyDAFWQmAmMKEzWoT/Ymg7AWnKcGJByM9msaPGOrF5JKvrUJVatPLO6YOAe2BSGqXf1c5ad7+qnaieZJPdXm5nndf/dOQHQS4dL6PO4pbHsKvzS8un5t6O9LfUxwwet1ANoK3uQ3FehSejHjBkFyUHvRqpW6i8g6J89RpYErD9xZ95y9gG6OKe+PyXPPA59gXcPKhpjGiEvaLn3Kxlb2VFdBEhNW/Rp8GueFg6PsdEpOc/DRq9y9cGa0sZAkN/MTuWntjOZTgken5rVQ9DJT2okiIYA6UubF4V/LOAra1ahhXTPeG9goxzWx+GefzihXIBwPbyxKUyCupslI5t+Gu2iwY/GNtgPwxs+R0lCrmNF/UZdcjvVZ8JbKOec+VvYMxnTks4PsCxDa4BcQZVV+YgehSHsc2sPzxWTJycPnA+eQaboRb7qdSzYLDJKFO+QLYOIGgVJiCGZmM2OGYHcqYyx2U1LArQaojuT1heTwf6tzKcOUvEV2ILVektQOFZOoZMkwkdSsRyGvhpUhcYJVhb7efqUfzFpIcOQbaRzi2cmL2Qikkp+qMBdAts3X+9y8Bic+K+jiQGM3YmO3epHD1+vOyH3vbo0cMAvBfNLPG89rYSwzSMcHWUJOy+576ye+fdkiRshXMTnWhSc24/hE5vKweuALbJ2EpqwfJEh2bZFAdXH9jjejkXM2xrgk0tprwYytqmTpz1wUxzTLwg55tg4F3lBpQcIganvpocEdE3GBnl/X/wJ+Wv/uwvkIKXwevZLmb4ut2GbLdGkhCANoquPz/0wz9Yzp4+V/7x7z8X9sDfJgj0uQPY4tUahAF85NWvKDtu365jmOL7aWh0U0fby/K6Hc2Iuzx5rmsM6YbzZvZDvekDsy3j25b5Rq/b/rnQcQuC2wpYk1EN+5j1UG2oaibAbAtso7+qL1jLmjsoslUaH+zDsfOh3Q2PUdVXjiqZ9BbYuseYZVTjeqdOrL37eDqUOY4tnU759CJai2WGB+Nv8FuG36L0QGG4SBLQNkXIQ75NhyqFfsQi2skaGLmE8WgRxYBsLO1o2BXqY9knKYVgSnYuwim7EvilLEGNHzYIF7gMJ98hxqfTGcgcO+sYM0dmmEDdFx8eiip77tSpb+OcGSmhA7Zd/XQa6VwoCNyOo5xvvDw98aaz5ezkUvvS4LivTw2gfRiHljraDXjSWL6A59Noa3tcDx7fsDWwJGD7C29409j2229TQHWDlIAo2lIn+2WGVsCLRkB2uDOgmZbWbgHJwMj22HiKEQvPW26qcuUNg8WYthsgR1A2MsQCXatUu04iwFU2NVrpbMO/q7ntrMhEYZ0WapYAtnkPCSDzUJaphrGJqbsC25hcOmB7pUwgWoSB7biA7YjS/YYJZb0QbJCFrKt787Kpt5IRDcAZGXINEmybXZ+eXQyuhIW5PRhtYE8FTz4CMnzrdlCqS/6lHCHBK5mSdP4Q+A3WVluOZnlZJ2RVuEVNwSnZzpeu+Hcy/3R2wuRC5pwsLicaOZsJfOH70A7mtp4LZSib91UXOLrPnAzwPZnGxMNaQS08tgSkU0uoxAYG4svgCLUCzlsrxdZCisDQQjgPQ1rJoU5OLAGbiI/7QI0m3liYGTgHKGLb43ezYHZmEALs4qWpcurMmXLk+NFyAHrbY8ePYKIFW8oFQkz+vBGyS9SK7959b7nvvvvKTsS33QFwu0aOZJZ86CalLXYs2BbYiomO7eVkrw3WDEa0mED6Y2EWLgrD+5ySBIcfMrAV8CXLvgqLQmbGE1vrCAhSR2vQRj/L9ou6mYC2+P3veR9A7fvKNOLBanjHgsXdLWQh0VSdUWnNS287fu8PfI9Yur/5+Gd6vugHgGS9H3rkwXLv/YhHi9NdvHCpPPXE0/oryVMAMl0pJCz8wudBuQRqbXM01sV4Ur6R73UzPf0g7Vd/z+svW/t9Cwzn91i3V/dIgOkPazKGrL8om64XdpQSErO1Ufd67wHlRU440ra7SwFqWQeyYXLm9Tm1SOJTNjmaPsenas7AttqbsBUaOzJFkaFM8iaD2pQfaBtfW/ne6eBi0s7G6iwhV7C0QMYf51LWMe4aRRryq9q5o2OjQ81p8Y1j2d851snWOp21U+CqM+DeuXjVbg6uQ5kKnctUx7IzlioYpKLcGMs8v6VbDruYmx/JbNtWdza6sxdpt9yGYoDDTqPWpvGzt45PXP2li+XQIMbp/AFxUz9BOzFT2GvxvCsKQg0Tw3fZuA0e3/A1sCRg+3M/9itjd+66A9uGT0nTJBAVE3GeII2wvoNZzBVssl5ivsIEaJtKK/COCTROg/cstFB6hePptMToCJQhbIQkYZTxbAEIyNqO0KGJmZW0bRuMLY2cAqwugoZ44j5gmy3YgSsyBWQxUxiQIXSsgZR2ixMkDTTqYgLb0ucBcK4Q2IIwXk0HIBpOcJ2SG4Q+zT5RZnA1HQvURwxbGs/KuHIybvEcf+PlZDInfumJQ+clmIrvNZ3ru9Dw8qpiU8L5gwH9YzvuKrYKjWW8uGDda1Ig1CFQZEHUbozpGvpjMTR0snBGn5Ur6cgHWQhAE7f/6IQhBldOgwbVXbQKnjIAee15rkvdjybNBPLuA567rUFuWTln8OIiwhm1vBULthxglhKEFXg6i4DDepGxFTCX5tj3zJv2OTs22F00tcahUyQAIGBgO+D3zNBFScJFtP2p06cVAmzfgX2QJIx5wleaYl9C2kGA7W0I/3X//ffLmexOvKbelpplOow5tIUa0MCFGkSyVOg/0v0GcFF9xHYza8aRLShJ4MSKe2GaUk7Simkb2dEAenlqLTyw8FsJtp26Wkl3IsuCNfDNwijqnI5oH3jfB8p73/le7EwASMbnHjMERE4rrEK0jxsMvzzHdyBBA9Nmf+SDH+v5abvQuPf+e8qDiEfL3RlmK2MaXqbCjcsbjAbwC/OhsmTMbPXlcLyyHXIftpaZP+0WMVmuBLWLgdveG+3e3Rj0dsC5+wUBlttPwFsrwqjJANq5gFFd18/MHrqf+rydxpZ9Ja4VQFeekOrP+UydrfuPL5sGx7ZTtkO9MZjaGJt6T6Y1bBXr0lka2cdgF7CDRfZVgFhA18sqRmchu0rbyQU3GVP9lgtsjBcuott5ggyr+jwWXt5duqYkDVqkcyDTrsCOKTmIys5GNWkyR50tborOYVcxDqnHZf9hGXJ3QfZOYwWyCCaKCDbasgK3QdZxu+hmTSV7WxekGuj6Rk2CM7/18rWXfv705H4G7x88bqEaQNuBqSmP4fkyj55CL1MmWDh3CxVzUJSvQQ0sCdj+1P/582P3PHBPeRaZeybhPOMtvhzRBnoyjzRG3E7Cf3Z+8fZmsgQ0PpYveMXssGFmSIlpnG4xJnkcy4l4DdiutWBr6Yizhowt/yKuLR1Qhhn2C+l1zd4hlShkAPYy75tom4qio9ZiDxsxA1vFaxR72AJbnJvsawBbgvzJ8XFrbCfHywjmkGHobFU3BJshN6ABtVE3ENAWseYHA1BDfG/vuQxdxAJPNBV/2niKFfTnXl9ELFUdFxIRHheLDEkSsI3u3zm+rdpC4lGDSYF55Xe3ec7JLltaelYBXEgwxMJ48gIl6rA9Cg1GoEvABGckbX8aUFmj7FrXFjvbmiwOziOAFh7LFdiqL7VggCDa26oZY1Xhe8gq4/oEtMsZsorXBnu8HKzkcvwlCGQhVMe4pqQI9NxmveXWY9MZDJTYPbutXUsAAgzwWC4AwBYpBNjEhMDtEUgS9uzbh6xkh8vEJCQJcsxjwgJKY1xvqxEl4fY77ii777mn3H/vfeX2rduxaGO6aJSbizG1pbXHHjcEsTGmAtxmdIQEAQbCDPuFOuSWLes4kjVwUle6Uq5NGDWE8UMxPihDIFsrYBuSEw+JGM+4d0psPvLnf4nQXb9bLoxdcF+IzQCv7tS5ouZSdsK3uUjpdnWyenNRku9f962vLUyk8Bf/5YNNC/h+d9yxvTzyqkfKOgBfAqe90NHuffFAle6IoWv6R453FzGArWGZ3qfznc2CmU52SXcy315bvgqudfji9qIt+H8bsE27GQBXINVnrX/jXv1Z8MJxnLPm+ZlRQfJeUrriLHIhY+Ff7QA0v4nztvdiC2Rgy3Zu42OLnA9gawcr/5KLfGYck33R4pG2xt1kFhpb2iCB6ADiTrt7HTYcu2x4MASXwgniNeeFBP2Oww1pGkgLL4BhU6DXZcZEZkeUDYpC8A8TLYzCD4NxnicgD6KWPGVZWYf0gbhKeQK1vtLm2u6yHucBWdlmt0vea6e3tWH28Ln+uxh6P3VsZs/xti4Hr29+DaBN2UQP4ElQyw43jedX0N4Hb37pBiX4l6iBJQHbN/zIz4498ND9cNLYX8Y40QX4stNKZ3CV5Uk6x4jLWbfHYgKBCUjmj+leLT8woCWLSCOmreLwjuFkPAIjRQkCmVsyPAS3ZG1HABSGqRUEsCVjSyBFzacZ2xYU9VbbVwO2vLYAdwNsPXGkI1MHQrk9NjU5Wc5RinDpYhkG6zUyFMBWoJVGE8wArB+9/R3blrIE11t1wAuESr1aV7deBGRaUnEiMqINeAAiEWA2BWnjHNN5yhsIdJVEQIsJA2JlOYutRE1cagd/LjajKZ/KKXxgcGeQmPo78baawBQ+SoDcIbcc7N8TKBkZAt/Ui4rT1zW8KJK2Lq4rDiZCGmXoKy0uIh1txisWQNY1sKVOgIu/BLbU1i4jiMNfbU2LcXabypFOqUG9OMh7bVlClQr9R/1YfbnZ5mXt4wDWFVnbaehtGd/2NGIZH0T2uQMHobc9dhhZyab1O07GK1k+RmXAeUew03DHnXeWB+57Wdl1586yhel2N6zFlinK78lRwNbtjIdS/CZoiS31KFNmm3L5Ij4f61DgnckaKItgaCNn9FtJPbTSUaNuyLCjPpm9THVPJlPs+tXy8b/6eHn3295VTp88xUb3+HbRDEqE/C2RURFlA7rFZCdT6pjFBA3tSHzklQ+XBx68X4wtgQ8fXLy+8rWPyUGMj6OHjiESy3OoT/pzdKz6PGCrQqarXDLwMXaqLKEDgV40sc9+fYCt66kfIKdcgmUxGWAAro5Qq8rA1eO+BzxXUN4B9zb+ceeASWfDvPfQo3PcsEyUJrB/9ZUtljheGqitbUNsvgz0aD8cAcE2QVnFuAOlcWZ5Au07F5N5O2RNM0oCz0VtLNlUAmL2VzqS8VguCDMtO89N25uhujjuKW1gn6bdn0MYPo0zjH2CZUZp0L0rLroXxAwP5j6TfZKMrRfVXKSqjtkXcG05qIWkJX0gsg00LqMZTXpoB+BPrl+e+8ljl/fva/v34PWtUQPoPwxu/Ro8qaPldinDsDyHtst4k7dGQQel+JrWwJKA7U/8p58ae+ixBxFO52g5fvxUDG5rMXMiy/BIDgoP9o5ABq+l/dKWZwImsn52HkjjyPc0gGSKxKpxBU1AhBX5akgORqGrXa+QX2ulV+SKfBT6ztzK5QpcsQnpuIXV/I2A7UJShHaVLuBGzEO5BF9wAgiAbgMXoZAIBFHWaQCbMUgRpuFEthpbyiNMFkGQoBBfZElDesDpSojK22+eugwQ9YpgM+UFlQbgNwSlwaBgEjFDazYqsKEmFIM0n9P347+VXReOY3kMnqw1zQkrftMAWx4rNkRnig1ntrfPrMUH60Pl9//Wt2G6sLbX+lJ+n/nryaBaphCyFIIyLhrkKOXJm1OuwasnbOto/Rs/nSFLfUoyBL7vYtWuYApNTHSM3KApmKAt6iozJIntjv7XggX156j7ZPnY2VMOsDKckJSZCXV3Bf11emqmXARze/LkaYDbw+WFPS+WCxfPqW9T88289kMrmauei7fr0o3fcy/0trvuQbrd7WXrVmTXQ7ghOrfo6hiRAo2Si7BSEpQYAGk7HUca8HIZQCBg8L1C98XwRxhHYMDYL8huLRdTC30tdemUIkTSBkoYAjUhBu2nyu/8xm+X40eOhoExO2ig79duIyehiM4WPcPf9Y+j/rqNU+jPfS+7T1nCqLGdRqi8hx97Rdl9724VZ+zsWHnyS0+XS438oQUVPm88s2zRN7vv4tZU8ASFXV3y094kCAaQPm0A+uZvBzXbu+he1/qZB2B7jwkwFGVKIBvgNUBsreys87jHfmBb4+BGH+mJeBCLezOfLWsd4ygWSK1j7Lw7Y19kn+J/sV0fBsCSG9rKsNdOOkBpmePYMmOfky7Q5Fl/y7BstId0+lXIsAxFiAWYoxnQVlA4HYsn2ZcIeYfXlhFRj4uU0VikEUx7Me/IJXIixpi7jP7EDxRZgbaO4cAYfSElFdzdgN2QPCLqhsclc5tOY7ynTmsb/T9sBOzwBzHOfvzI5L7nFu4Rg09vZg2gXxDIUkd7e5TjIP5+Ge09iEpxMxvm63TtrwpskSJh6D/9b//72COvebScw4RzCDnX5QxFo8P/gvnL0DJydsFzNdOHJrANfZeMnIwWwWOEERJDa/0ngcKVxihy5b6KwBZAlpERyNauQRYyhvwia0tgy+1vsXkCtuEMcyM5AjNOBdvEOp639URAR1wRUQDMGJjZcrYrh2YS8ENZuR194dxYmUKihmGA1hFdOyQVwaQKDvK2fWJtOYv8SHAqZEiQGw4WeTyNdsgWDC4NbFXuRJN4nTo0XkTl0lZeAubmb0xGNWIDziEdnNiYgKwRl9LA2Kymvfdzsk9M003+ZEOTFRXmIZvDeLnExbl1zQlBzKClB9bgmimB8f8AACAASURBVNk3O+r3jo2L0GJcGIXEhLQjAexysPP8S3aG7CxfK6uYHEcsTZDzCc5NYCutpTGzJj7lrg/nMYHbWFT0jDW2UzBkBrTJ2mLS5Gu2Pfuu+iwma2xpTkxMKgTW8VOnJUk4cPggnMxmBGpHkNhiCDIJ1sMsjr0CBn/rbbeBtX2g7L5rJ0KAMSvZBhzH8hLY5iLDjGOybSyjQS3r1MypdOhcLORWM79FkgamPL3KNKN0wqTsABnxVjAMHUN8EfhLn+yUvJ/7zD+U333bb5f9e5Jw6kCs+lNYCF7XuC8WJVzYqNW7/tU7lrr+0mvLfBY6o3776/81kjscQ6SD2wRCphFtgnFtTx4/2S2YA7TNt4cd48n6UPlaUMl+1gNq/T0PySgJXjTk7/Ci6+a63EJMfn85dDce3hUQt8f0lEl3nui59/wJyLWYiTrV4qEBtQm4XDj/482tcA5bEOCGPjwWQ66DiBnL34Y8ITW+OnE7K8SC2c6uXmGnvegiI3gnSCG8IpYtj2F5FXeWkRLAylKfTnbVYJjECB07bV8FeNFX5dQVTmQcY1wse6/CjxHGpAW7ywQMYnWZZUyOr5CBQVev3SgBUtpCMsZI1MBFrnYIO5LOO0Quo3fOularC1xXvx5JQOCTT6D8//eJ6X1fnt8nB5/c7BpAu1JqQMkBpQdsvbN4UkdLTdXg8U1SA0sCtj/6f/xfY/dBikAd1T5o3WR6ZRgA4LgilpOAdaPp1MOtZ064cu4ScLEBFhlFg0QJAv5m3EP+pQFkhhkGw09v1lVMDMBICNjGZcKGUehrGc92BKB2DUIpUSvISZFAaRUiEsjTPMBM/6SicofGth/Qtu1N0J3AVnylwI01ntaJcTLDMTDi01OTStJwCYH6V8F4joKxXY6bc30I5elvZbbFrlpLmdu5nZRAUxVLGWwrf+ots4QQdNjPh9Nd8jz29DfRJxFcDzDg+bR1FuUgWBLLy2vh8KqhE9hLvZmLT8NuJ5yGVVIF4NpxTaSFdJ8QY5OLHZYlKyvuitcFCuD8SPaWfYNgsTK6AKmdsxT6T8SrVHSGWMBQYkBGloDWEQ+YIc33l1prJhvIdJ2SI6AY6dAiHbdQbreoqX0hZjGDSYOQZMXEIhP7aJvSiUYU3xVj4goz0MF58CzCYR2E3va5F5/H67PaZl2LdMTD0PyyqqcxIU9OT6mFd8OJ7AFESdh1111l+5YtZQN05HSGlGOM7or9rGnsGHOBxALwOGWpwW2kI72G7GNgoqo2EYB5NcLjLY9FH+uF65SvfP6J8vtveyfiwL4Y47nFM8FeRptqEaUH25OMmlubzxQI2B508oPF7af7xL337S6v+lePqY9xK/qFZ18EuLZt0dmFNLpy6OoNcE2HPwmDor1cvoDgbRsuCHCTvW3v1bcoGOXTxm37RWY967+3Dqrm4Z1ZnQdsNaD8fQucK9Os7fKub7oMLqtDsDXl5cKnAlazv3a4NKOfIDYlDrqGzhPfceFG3bpkPQEfeW2XLqozbBHbN3dn0k7gKCZ6EcCV7aE9JzA16CTDKi0txoksmLoMIotAepIpbrkYVZxt2CP2f5IbjsxCCYV3eAhUuZtnyQHqIGQQGdrMOwjW8/P3BNhM4nOFizs5OBqMe4fJO2Ma23jPe+fck+2Rfbja62hKjPXPwWr86ImJPZ/tb//B+5tfA2gvthSTKzDJAp3EGF6NkQ5yC+rmF3JQgq9bDSwJ2P7Ej70BURHuBGM6Wl5AWl0BNYGv2I7S1ixjhBpc0X7RCJEVorFRAP/Y+qJxtIEhq2kWjT+iAaRR4gqdxpHAllvaNHzDYGjlOAadLVnadQABXLmPAthyu5fZsLjVxPAuK8nq5RbuAtVYM5/JxvYChzycuCfDYNnQmamTQ096IvNewUpehs7y/PmxchHAdgWC468Ve0x9l42pqMKYKsT+Cug6+5dAKb+LcnRbvFEu1XMnRdCkFseaVUiGNnSjOfkEsG2BhsrCB9liLTC8EPHTbLFiObYsZiDbnOD11/+4D0Q/4FuB1ZiQM/4lASC3rtN7W9MJJlJBb0kVXKcOscWKdXQDOaDJIYyaQDCMAIjoUPKSFuNIRzEcR6BBL2g5H3LLUgsonI/b7zyPJAwBqjnRKtxXgPdmazV7QUCpJm1rOHERDIhZZvk96aPkMdEzY9GVMgW28eKliXICeuv9hw4ixu0xbXWSRRpBP2U9z+L9xOQEYuFOY+dhTbkfwJaOZHdBkrBty+ayDgBUgewJbtQ0luRkm8c6xPUvjMJyWA+coda02IQcQX2N45DyAzhaKssY6nMvgOy73vz28tyTTwlsBIxz10hMqHcB5uoYSm62Ih+DlQp6e8fTYiB3I2L4Pvaax8rWbUzFXqBRnyqf/vjfCrj0PtzPOkcds2vdowWbBilNUc1iBjbr6su/7weUVZLgL33nAoHRM3TLBoULPWJELPxd/KZeM87Tw4sH0KzAXJcJeFmBLccHx5ObRv2j9XGInYU2dFjuNrQg12DX4zAlVto9CSBcx3dzqxmv3BIZL0xTo05fCZIA6QgsUoCLY4xL9n+CRi0EuRvFz7BrkREaHJrLgFlxs2kX08lM49txaS23oXzBi26CabK7Ynplu7yDqPi5Lpw+p2Y3yy5tLmUSYopT4uD+kOcIc6e+kzFr8fWXAIR/4tj4no8s2MCDD296DaD9dqIQ1NEyjBcNCTJJlefRzgtP8De9xIMC/EvXwJKA7c/99M+Pbb1tS9m2Y2vZ+9xes0FiC0InS2DLbR86C4TEQKCWjBxAypAMpyffmCLkgU8jxFU9ux9DTc2BqdXWFcPDMGUjDRV+wWQAo5QhUGcLQMBwX+vX4bVCfiFmqbKOAQCPUFtJzaVvK1mdthJbMLsQsOUvuYWe+jEdE5NB6q3EeMh+gn0AsL0IGcLFs6fLcjAEjIwA4lhMgR7yuE1wa2lB6tMMDPMRE1kDLPN3WU4dUcG4p1NeJ421JsOYKBwOjM+c9I1iNSHqMB9rzW4AeURx0GcBmF2HXRcJ6ZvrVudx0PR6D4nH4wge48WApQbJFtHV6boczDKLlrdHnSXJDmHUyiojFv8yhBcXSHoypa/bmFVFLR8duRLYarJmfFYuprTIiMmLTcGJTWx8tgEbmrXCLX+3g6rXWgQ9svyWRRjsaCuXdaS2wm8xsU8jHNUE9daIr3r0BFLuHjsqeYIWZpAjcIFHJ6jpmekyPjUOScJc2YasZC9/4OXl3rt3lR1wmNoMuc0omCbs0Ory6kNRDptoIizDSbeNncv4sNNdtivBBLWJK6FRZ5a4IejjD5Y//J3fK1/4h8/V9ssAfB1SCmTrW48y9II5XbviPerNs95iV6B53/YdOnY+DIexu3fvVJ86DU3yMAE3bMPHP/TJ5ortXOSFj3Y/mpHS2yezLrLEHhcJ+pOlTERo0rIDuAn0XJ8+R127ZTfQIrItQRS3KfV857Cowz4wnMxslDqq3v2/lqFeNy/ge/LB/tJ/urpKdjZBqxlJj9989voKxJjD9wr7FkC3Msd5i7p37y6lA5llCV4YK/Z1OJ/S9utjsqKhqxXYxPjgLgKlW7xNS5Wa+LL4notQLa4JPDXOAGpj8cx5hA/GrOUi8goYfkqV7MDlkF2sf84X1OyTLFGkFS1mI2IMuy2Op3RN8w5lOjpH2smsS7cMyvjc9evLf/LY5Asf6G3twbtbpQYwh21EWZhgYVsMT+qpmDWM3qaDxzdxDbSzVmM9leaAz5Xr168f+pX/55fH1q5fU+4Ca3scDmR09hAYwqaptLIwZnMwdtwSnoORmhOD5kmXxmM12TYCA3me5pYlV+fWZikVI/N2Y2ufmkXJEihJALhVUG1MzKvJ2gLYMvwXwe06aG3XirFlznAytTgGOsLVcCrogG3vpCyDFdfP123bawLABwlsk7WtW3ipZRRTZoZgdnq2TIxfLOdPw6kOoGV4BQKDQ45Q4/zqemYQpOmKSaGdvnvAtmaG2NJVdUU2qwC0HYg1TOWkX713OfUFG2Hgau1rB1QT3CYoC2DHrUXet9L8kiHxAqT/IU1w/TCm+hAYqnjBxut6rKN4ajZL1p4dS2Gw7ATm2KyeYKSTJXCFs5WiG+gZ0Q4oBQhpiwAcnvzNFbH7Bvd0VuSExr5AFiqTd7DImbBCKoQIEZRZlHxLBnUpD+En2pyVftFMvUhlbt1q299bool4mFWJsVYvIr7tWURJOAZwe+LUqTKFDF0jw2sE4Bhbdgba2wmEhpuZm9Ei7O477gZre0+5fcf2sh1AdyMWcKvQ3zm5u4Y9MfNp6QlfJwjSG32Wjprqa8H4sh7GEGf3fX/wHmhpP9v0E7VQYr2EybHYcW0keIzlWdMVEpKpRBVcmfXq4F/+nvfN6Acve+gB1cHE+GR58oknpdd/9eteWXbdu6s8/qd/6e3qBIFG6GqBfmCbTHAem3i/Mq0hlO0BtixpZUV7wV7H3uqu497jdpMgDmD7z2VsW9CcFdjDLMcV/Zk1w2lr0nJlX3drJUj1D+cD21zEzge1HcAN57EW8Abx4F2pzmZaWx8SJ/3NZwtsA8SiIbgbYsdgRyChPTCwZWxlRCbAqe1LgYgd6Kd0mMy039l/FYpQoNQLTtmzcGJVzFmCVi5qKS1g6SSpClkBHcRSYoXPuPOncSy9rW0/z9fJDDjeA/jGQgCHHMBJfvrI+J73Np1+8PIWqgG0H1PfvhrPe2IIMYQLdbTjt1AxB0W5iTWwJGD7lp9+89gQtkh3P7CrnDt1towz6w8NGAwPY5pyfudq/QpeXAbIuEzvVXyfoZxWwyCt0vZyAFv2Rm6ZpqHkFrGcDChHuKzUizREl/E6WashhPciqCW4pcaWIcDWjKxRooaVzKiE8xPYDgPY0pksJ6ms24WMWmVCAzTm1MZtcsc+NLOXv3U8VmvdZPLJGFJfeelCOX/yRLk+M4WQX3BigMKnQkBN9gk+LUVogagmZtYDp6kAsQmyBFokBrVR5l9v1UV4LP2Uk4kEDd6yrsgzuNRKRBDMdgH1vWXnsvE36VDmOmkmxqhJAcOoJx9jLaB+rPLES3zmGKzeCvaDW59dDE0lfxCwDac8yA50DgJeyAyYNWzFqlE5iKHTCPCq3qVxdhtoWYX7oWf15SuO8CBZAwEt42FK0sBrdl3cjmOZDYntS22d+2QelVXI2yF8NZNsQGtwa6Arzta4MmQrKMtlhH8DkD2P2LZnwdYeO35CulvWmx1juD17GRrDiTJzZVK3sQl9+m44kd2JjGTbtyFKwmYnbmAYO7d/BxZdIgPc6BRud7z1Vq4bm2Udg0Pj4+/7k/IPf/Nps2BqqgqXxHSZsW1MgG7eDF0LHGuX0rXc97wEJOPvb9Xbou9kJ9wJdpbRDhhzmgvW5595oRzcf6j20fseuBeyhEcRGeFvy4XzF+s1O/DRAtvoSryGQJ3+6bq7gJr7WoLEtALSxjbAlkeZ6e7YzNpT4zwGzLxW1E8D+PLY9u9CjK2uENeu59d5W7ObocDStrRtlM3D2vX3Pqf/qcC2vnf7uBp8nl7GNpjskIW1TK6TnMTuStSj4nXXtnUb205E9r6QbCnEF+3aSxkqka9hL2jHBW6xoxKyA8rNtBOFazhxjPumbCquzzHqNLfuhxVMR1U4DnaQBDhO50AhDV59rZSN5W9bYMu7yEgtArVhz/H6OL76uSOXXnjnQu07+Ozm1wDak0P6FXg+jCdDXjBrDHW0J25+6QYluJVqoLWwtvR+9jC2b/25t4+tgIMQge0UPcABbmXkwkgwuD+B7SzZM+pO8WR0A06SZGqHFLTfOltv43PiJMBzRARSpC+BsRWwjSe3qpR3nFtd+G8IzCwjIkiSwOeadQjgvk6e59xudQSFVd7eFLCVWff5Awe0q/W2EVrG1IxnwAkaylj1e5IID/mYJPk7asYYGeH8qRPlKhyIhpHpyYwtZwRP/BnKS/feF5qL501AYLbBRj9jW5pF9b1Y/mAOzTIGM7YEeHqQMe3pXYk24/j6fceCGHTnj/JFgJboDMnGpRQhE26I3dQFg+HVBGMnK2v2eB/euic41V/8xlICA1tmD9KkCnDLFLjXqaGFsxXT4kq+wMlLJ9JuKf7YA1yb09LXEtgi0xZeMy6msqFx8lM2Ok7WyWK5DqjHZaguTcbXYju0QW7GdkZMxgvhNBjgVpM/Ya1YW/dlTaicwLHjMIuFzsQkdNdItXzy9NlyAozpJbC41P1yh0PZ3dC3qcMeArs/ChBOcLvtNuhsb7sDwPY2aMghs0HihuXsR7zPgLfuA10Lq6zRxGLHUbaL0Hv/5Z/9afm7T36iOsU4oUiMiAQ80bbuWX604yB7RFZN56wVSzZdl3DLAKRDmADrWzeXV77m4bJp8yadc+8L+8oLz70YDm15rQKd7eby+u/+jvLEP30JUokjFYTVLiwZjWO85vnrYqoteACxbhtdHa9zbNOxCXwDbDagtmNtm9HDLhCOXIaTPsdCD/WTkLz0f98ytP2AM481KO7kES0I78B6lrsrRtx2lE29w1825VwI2Gafdv/2olNjUYvPZI47GU+CQba3nV6908Y2ycgI/usxqXGGsUBgq5COjB1NO86FKFPhxpjRwpKL7bB3vBEBVdlt7uC4XAKysdgiAOackBMVP+dY5F9ex2sRjwXbLWuzK4nBJYK+t+YWn5/Fm188evH5X1+wcQcf3hI1gHbajYKQpR3Fk+lJKTmAw8/gMaiB+TXQWuq0FfzbA2x/8xffOUasuOPObcrudRKB02VsYEXk6IVsTpQhXCa4heGaYVQDgVVnkHHaW3hvS45gRoHh/OX/rb1hZ72iNsrhYTKeLZlcaLMIbAF4huFhziD36zZswGskbkBMUDqRMdYttbyrsLVLYLtS3uW+tRbYLtYBDBITyBgMmwmlc5vBd8tueIvaoGMugO2ls2eQpOFCWYV7Wk1SIbaDnUDB8RCFLgjm65Zty4XRxtOoG1yajyFLGmCzw6i1fDzKwDfKz3IG2PU5/E816gLaPrdiNqqCEihrWslaiNeqwJhY+FU78Qd412Rq7k8MGZmXOllag2kPZ3ev1KySsRUIZtguANKVyhaGHSY+KT8A0I1bNrDRebxQSoDMLUoDW3tCS6rAyAqM04pteIVmi4k625QB3O1kQsdHT7LuKNE7KobyvbrdzQgZAPgeeJ0Etqo5LoboHIP+ehk56C+NT5UzSGZyHMD21NlzZQZxZck3iHvD+SAHL2vAyjKSxnKUhWD2ttvvLltuu71s2LgZcZvXoE6cFIQFqD0lgK2aJfTB/HICi6qPPf444tF+RFEGsg/FXblH1eYzVAsoFYd0ooP+hV6MDB2neB5NncmJLoDnCJzfHn3Vw+XOnYiJjro/fvREeebJZxXGKx/+KccXyfjl5T/8zz+INLlHBW7nbd0nsM3rRXu4sdwnso3yb27Z+/6bpu0De10Wt16gWwvasLW93X5hcNsPJvM886QHDRpNoGuAWUO59Cyouvbr7rU7hXtFex59QCBX6yqxrhcJ/Y5kHle5eEvZTTdOzdp6UAheUjoWwNZrG9t56db5gTTskbpac0Aka5AWlws72/kMJcizcjyl1tWpvA2YOVDS+au15xqPMSYU2kth+bx4kx+HbG7H9rrHuaI8dkVeXITu99euT8/8+olyouug/RU+eH9TawC2hl6m1NFuZrfAk2FcnkZ793ub3tRyDi5+a9XAkoDt77zx98boX7B5M6La4nkawJZaKIaZIlC4otiFBrWzALlTALaUI8xBluAJjIyct6bJphncOuyVdKDyxrcWi6BW4V8Yp5AxDcnkMsA2gMoqZhvDNu2okjSs1ZYtmdthONwI2JKxxeuhRmeb1b0gG9VMmAkc6mQYwDbDV1Vgm8AtZjs6ujH72PjZs2Vq7FxZCRaQOltqJAUcklKLSYCGX2XhE6x1ZYMEpiP+bdNHEtjmaSyBCKOteaRjcMN2hxlPqUBi00BsOlGXWMEgo0N1vC3B4wDEum+BKANhx83sQB/PRe9lTZC8pWRL8J6OHMJlwWbxOKenDecxMfnW0K6CrGTFakQPgK6WKUA9R3bMOe9NBC4jJ6hMdgxJ5zHeQ8oEtIhCtAz2n9aBLMMSsX+5DhvHkbiWJ/BuWBikJ/uMv8rWxBiwydjy/oIRjYmcQHsK2usLSDBwGqD2KBylBG4RNYOAexisMkHtJmhWhl6aLbMIGcd73rz9rrJ5x11w0txRGD2AiRsYJUGTthvGs3N0K273su994kN/VT794Q/VDF4dCvbxLaDNMwiU99iiXmDbC8g6xrc6RcZvlwOts74ffPhlSLpwr1ljhL978ktPlfPQGvfvkvSPQzK2jGZCB7I26oEWk9KdBtsWaC7u3n28uQGX11Dd1eT747PuQzT9tpfJzB2erkJyQeOBEGfNE/bUm9/0A9g8JLPX1fcaV13Rc+HCfh0nittq2i3uJRuywcb5E/1NOYTS6LIXx2Iyy5dgvgW3+R37dY7dLLOYTX7OMa7x4QWJQWgCR/tTaFEeEUcEdCPzmJIqEPzqvWPJOg2uQe98uxyLHk44eORuVPZWjVm2Mcd7LPpYqDBrsjndGEm75vYLymBq2bVrb5mYuPKrF8uhiws05eCjW6AG0L5kZhnpYFcUh2G7KDtgGK/BY1ADN6yBJQHbd7/53WNDAGprwYZuuX1rGT8zpoxb6VxFUHsZRotM7SzA7NRlxHeF3nCW2kcxtmTnaKjp/ZpOZM4d7rAx3EKy3ooG8Rp1WFzpAySKySXYgMFaAbBCcEvWdg2ALaMjrBk1sF2FINwEv4xvmzpbm2JZQVVCa+b8cXwfpjANZk5SGfvU7G0Ap2A9Qskm9uEydJUXwNiOI3bp8rlZAVsm0JFUrLmG9bqKY2C2L5inBK2ajgS2utKake2aSeKD3ArUYcHmBW6V5rFnwu+AcK0E3k9KGsQe5yNeJyDVXzVST10pq5gmlShnfW1GqN1azcQdxgepj6UGN9LfMuoB2nTV8FroahHvFehVMgMCV8k2EuA6PaZ2ADhxc4GAJxlbhtFy0hCDLGUmQl/hOVZGBjOeU06B0tgC2Kot7FzibdWYuPVJL7CtrBY+1v3VMGVO/anjCcTYlfGXC7EZOJKNU7YDkHcMiRv2g5U8h+x0LONa7DBsweJrExjZoauIlDCFJB/Tk2V4/aay/e77yg7EtmVa2U2bEN6OMhtl7vO5UyXNPvcpgNmPfvDxMtMwogYALpMXJ3xpcOa7av6tCxoe4rbvB6LuGQEWoo5yMcVr3XPf7vLQIw9KDjSLMj371PPlyCHOQR2z2w/6WjDD1Lr3P3hf+cjjH1W4v9oTBVwIboIxjC+6+/MNteVtWc88z+LAlr81mMv7bsvpj7vvctegbzVQy7sQsFWtJfiqR/ozn747fwW2eZ/dasTH950ne6ibN0B8jFtXjNu+7nbQ/qpP+Jk7GSyDxqt2QryFn05kOjZ22HqsRCxyDXC7BDG02drhCgaXjl4OsWcAS3ZVr5m8pYJa26J6j7wfLhR77FL0Qo77ps9q90MMbaTCVX9oJB0xDvhrs80vvfml68v+X8SiPdc0x+DlLVQDaF8O+kfwfAhPvmZihc+jfwza7BZqp1u9KEsCtn/wtveMrYLGdgig43ZERpjBhD2ObVZpprS1BOYMIGQawHZq9mqZmLkiYDsNgIs/CuWiqAj0DQJTRdND4CelJAAJU9CSoVUoLIJbnAeWD0YMMW3J2hLk4DfctmawecoQRsHUjjBxAwPgA9gy7Bd1uHRUGRl12lAmA0hQa+PWgdl2YlAjhcHMHOWaEGWMbXj5OrfBCW7oxcuHvHwRcPwS2KmLiIxwbXZSaXW5EFgeDjo5KXgigPEXsI3ttDTUAWZTpqBjVSxHNqgTC5M/BBDTxBme8hX8ir3oQEpERe/ph5ke06yYp+92gmwPVhxYHieBrRcCIWIIUBFaOLG23URNRlOsmcADJysztboaqVeG9AKQHUK0ixVk3AlqKT+IyVgRM0Kvl2ysmGQCS0oYCPApfwEYmpWXtbc0BWzZ1xjyS7sDdjpTW9IpUBmNHS+zgi/dX9xb1F3Wt2Ls8hGgQW0fADuBkX7CbXOBcLcPk4xMId3u+QsXECXhAoDtkXLw2DHFux1G+TfjntdiTA2jj8/MAACPXypXsTi7ffd9Zee995a7d0KWsHkjwto5VjPvhfVOPfFnPvGJ8uEPfKCMQ8dbgVlFXNmaKrSL3vxb2zbbvrZZB13ms2juJf7czy1bt5RXIaoBoqZo92bP8/ukpa2adKL8eCy6W4Jr77h9e/nXr/8fyhf+8UtI53us3o9/0wHPPFc/sO3p2FVVG2Av7m0+Y7s4qFVfbwGimp4dOBbBrcVsLl7Bam+B6m7FYqDZXYvjxI6B9T6bsaS+F2C1GoI4uGv/KGeWN+teXRM1kAA2/nayhNhtSZmN5DzeJbCzbNeD+KpjamMxiH5PsEo7rmQNKUuI3YuO/LDsjAtR9ZGwd9XPItjgBLhaeAuo0u7oyrINeb9tn+oWJ7H4izGc9hrn+u3puZmfPjd9+GRf8wze3kI1gDa9D8V5FZ6MesDUt19B2x64hYo4KMo3SA0sCdj+0Tv+cGwEgJRZojZv3wx7s7yMnQCI07Y6c4A7PNcUYgyOT8N5BmzV1AxB7ksIb+QkC3TkYVSEIYh1ydrSeYzAj2CAeluxtkYdWNGbvSWwJQChV7nUn9piRsB7gKHVALdK3ADmdpjxbPE5t5+p8xtVQHpud8sSV9BWjXJf4/SwAHViI2tAZsHBx3PrS9vdIUfQaXD87AxCOJ2/VC6cOV3mpi6VYQB4xrKlLjkUiDrUGloCLALb2CrM8plkqxOHNGsBIhLYetINJixwyHJk97Ld77TBPbcXdRDcjb8S+O2uJW1sAjh934Ze8i8d4CzKqEkmCqAJOCbBuLABJzNyvQAAIABJREFUn4EtH2aEnPJWDmFKiQuwhjBYQ9JEIwsigC4TNOiekwXigkKMfjigcYKPMF4OJWTpyiw0pQls2c/E6jKZQziPWY/nuLfy1ubkKxY6UmxywhTwTcjuRQ0f/cCWt5Kacd63GcNaMbl6UrSGK7NXyuTkdIT/OlX2HjxQTpw8WebgYLaOkgS05Qo4k12B/nYaMZBpyTduv73sRrrd++67XyHANkNPvg4LuOVwSvyHz3ymfPD970cEgfMqWzJwrvZu67o2TXze0x/yTQLb2u4Z9sj9ovfRSRHWrB2FjvYVZccdO3TI0cPHoaN9Tmxtlsk9ZiFg6/7g+MwsshcJP/TDP1gO7T9cvvLFJxcEtvOxZPa9ppTZBg0gjJeNFKGTHGRMahejW5C1i8IeFjZXgP9cYJuFaIFqU+wEcl0It64sXdmibVvGUmDXdZhFqwvL5p7cEtbO12sJtIaOVmMzmNn8DH2CkrF6/wSYAbtz9yoXxRyedhyzg5hsJsM9cozxc7K4ydRmhISQLNSMXyRdg/2VjdZoDZa67YhcvJIRqYssLyTllEwHMo7h3Ily//5DTEk/eXr2xYMLjoHBh7dEDaDdbkNBXofnJjxplJ/D81n0vy4H8i1R0kEhvlFqYEnA9o9/64/HRpiuFgZk3QZoWzHRnjt2Ql7gnE8ILi4DXEyCuRyfwhYs9IWTALYTeM7M2qhS68hJjGHDGL+QURbovC5dpoyQ5QjLuPrXqp86yNBnCRASu3GLGews5QZgbAluRwBs5UAGYMvt52GwtaN4P8SYW3F3Bn4BE/sYuf5JvDI2+gkNZTJ8zm6zELCdA4s2dRHbyWBsp+FAtpqREbgQwD3af9+PBLbkn3My6rk+Wb+4bjpp8AOzjRmMP4GtwaW95A3ahAkbUJLslrfhEqz4QB8WLAjPIFYqK8wpLU0SceVBxG1wYwIlz5VboO32X4A9smexvakJVVnAGJ/VSReWAcyuROKCFQjVxkxiBLWpp1S9x1ZlLkZYWjGlBMjU4IYMgZOjw8NlSl1Pcsxa5qx3Zo1dj3aa47mVU16sbdSZwH4H6FqAw2PMOFuK0M/YRvfSuaxHdqzcq1jwSZIAHezpM+fKgcOHy979+8vpUyfLECdkOhUSXOMvF4YMbjeEfn0H2NqX3f9g2XX33WXrpk3l0IvPlQ8//ueI/XrG18iOne/qKA5QVHvcIigs27sep97ZRRFo+pG7BCNMDIWO9h79auzs+fL0l58uF9Hvax1m2fSbTvudY6o9rr30d3/fd4mJ/8SHP+VxUQFcMJU95dRZ6tiu4Kuus7p+3AJbM55tP/V18v56QKwWnX1scUWP8wrjcZJAs+/rXnA8H6zVLXg5ymnAVVDXWyZ/V3totIv6ZNMfWgbXNeVIBlmvWdZcnIuV5fjWgt27IfIPaHwJvGbo+lKNyy1trW9YYykiH3TJGTpgS3KAY1VjT1IEy7JsVNIeqQP5EU3cMrQGvV4ot5/n63QgxSn+HFF6fvzExIvOFz143JI1gPZkpjDqaJk5jA8uQMjSDpz5bskW+8YpVDvzpenm356oCH/yzv8yNgqgyM1QxordvH1LmRy7WGYQbJ3G5gpkBLOIDjABQHsJ268X8RyfRPrQaQakJ4gwGFhBsEfWFSCXW/UCCGl0McEvpzOVRJD4q7Av/K3j3crpAOdxilCwtvAiXw1gNIIQYAa2lCKshkSB8gRGSgALKE+rjoUTpAvjKNuZIFeMYC8IqPYVxVEGtGS4yDIppFUYV5YNwGr60iR0tqch0ThbVgKkjCA0ghL6ANwGioxQNrTY4caQNpzl0Pnt0csHy+PtOMaGJACzpa+60ABiBrYR0LyCM5+Dog8yvAxFlQyLway/7wfBqZ3Ub4PJq6k2xZJEUHSVzx7GBrvuOhUMEJjw2rG96UQMZGmpq0XyBeqh8VQCBiVkCImCUbPY+oxckHXBe+9YJrM2dByjxpmh5RI89UsRVsa2KsvIic/xNs3Y8hqqh4blWWzoJrDNpA++1z7wk6hD1DD6DSU6XPRQg31xHGl2T5Y9+/aWF/e8UK5AU/sSsy9FxAztCrD5sQBYv2FTuffe+8sI6m/Pl74AEGlAq7qoM3/H0CYa6Hpw78Tff09dX+8AhXpRnMDdMfoQPrzn/nvKg694uRJHTMHRjZEOThzjrm7H5LblE+MWmt12YbJY3VJnyyQOH/vrT/REUFjs+Pbzrg26cZPAuKsrr8jktOiR1LCXTckDLLb9v/davTYiv8uwYG4gHzPvyAS+DSirx8RvHKM5WzmBbs9ddMVpQXD2jT4bNq/do2B5m2I6Q7oj1lbAttHaRlkzDnDUnG1o2Cz7gdHGWsDew9hyHMeui6MjYJzSrsdui3b8SFo0DL4BeODdBTqAFrAcd3LY7LVlaNePAjD/+InpfV9eSt8ZHHNzagDtBtapPIrny2l28KR+ljpa6mkHj0EN/P+ugSUD2zWrV0JjS1AHfd3tt2E7FewsPL1pXOi8Mwut4yTZKXqDA+Sdn8D2/BTB7WUBgJXYGubEKI91aFD5nxzJaExRCjKblCZooqczAS2mNtEMKqnNUgpFgKBVkB6MMNQXnsN4rgGYXQWQNITPGSlhdA2jJzBdJ8FhgJdgJ5M/7WdqWZOVpZNxjaohziaDGDpbfjpEsTANLO6Fv2G6yDnc+zkA20uQI1zDtvIaMNyMOmbW1g8bYpaAyIGf9jGEDXiux7MW9Jt04OqYMB5Dr3TOMXKwi3ImW8Y6JgD37w2EPIfEVnFcPu+7Jo6ICU1sUmxPtgHoKwMnJjdurtXYilUlWCUbFBIESA+W8wkt9DKlyg2gq3BfycyZWbYWjzIU32uGD8uoB7oRsaKMvOGoGamNrsAWfY2/YwxlFpKToSN5dNKS6t0dUhNeKyUI/QH3O2DbTf7SRVagklpkT/Q6DydwRAmZxli5iPBfZ8+dK0eOHi3PPv9sOXnimEKDcWeCPYFMlkAapRT4/UrIFa5CopCPpQLaG1mE/sWbFzn+hYGte2oCBupfH331w0iGslaRSl5EOu19e/bW7d4W2JoRbcZQA2wzZNP86/vam7dsLv/2e76jPPOVZ8veF5kVc+kPLQZV7i4KSHud3LUQsKUwSIuubnz7lrtFQrdIa5YJfYCxfWug7EXnPNa2OdCXiVZs/vrj5nPdiu/JIC/KkWgv6tmN1oHohYB0tmt3bNiiONjh8WIB2kZFUJ/uQoM5VF88WH8V2BqAZqgu62ydQpcREhQFIYEtxyhfKzqCbbkAsYBttyhZyC7P7zftok7X/+xLy6796PHxfc4XPXjckjWAtmVHegDPx/AE81Sm8GSkgyO3ZIEHhfqGrYGlAdvfet/YKIDtarKssLnrEIpoFQLInz96UnFU6cAzQ8ZWbC0ycWHr9fw4WFu8ngbQdRYoAGOlOoWcgPrHCOTv7E6cETHByzEKAJdPGfiIIkCAQLaNYBdfMNMYHcjWwHFlmFnIsH07hM9WgcEdxSS8BsCWWtsVANB2wor/jDV6HvMNaRhZzRsGjdpa5jYbwSw+V5YngiX+paFnLNVp3PuFMWRmO1UuT14qa8FOD68CMy0SxhOf8GyA1wQURoa+pr7jMyYP/dXn3jo322xP5PwNWVmT3Dq5ISvKmlAxJ0izaNQN+7eajOM8eTrXhfVtOVH7934vpkT34jZT6uKIyqA2FLg1m6oUutLSss3N1FKCwMxi1NrSk1BsUbK1RkWWCGjiC42xK8DaXC6EqP1jKQQaAWyxqLiCkHAsu5j0TASCvwS1mWc+GVs7jln/lwsB1WuA6GTms5P4vuJ+eVvhjGZmC5phfecJ3o3o8pol50Tu7GiTSNpw8eJFpdndd/BA2b9/rxzLlJ2JTDgJLyZuuDJTlrVJQeqyqJ3MG9Cli86DNT19fDFA2fWBXmC7Fg5rj7360bJt+1bV86EDh8vzT78oIK6sU7rZvGaFjn3X7Pq0qiTqd7Gy/MD/9P1ItztR/u5Tn+0doFmtzbjtxZnJmvcC27r4it+7D4fGttWT804qdhSUrGAyy7pYmdXuTWkTJNeP9H0jA9C1OqDaA8AT3HrgRTlUmu43/TVTf5M36Y6YdiN7Rl175r1GGbrYzJGcIWQ79fMsr5zI2k6e3dyMaV1QB2NrYOsdEadNbyQJJCgEfuNzLQIjA1hIjLJL17ptQH5rr1GiL4C2+Imjl174+IKdZvDhLVMDaDcEt5bsYAOeDH/yLJ7Po692Wr1bprSDgnyj18CSgO0fvf2PxtaMANjS8QvGj9v867ZsLBPI9z47Pa1sYVPMuCQpAphchAIjazuBLdhpMJnUT66Ec9BqhnaSQ4/j2ToeaU6RDMHkBAWSJxg/GQzKgYsrfQNbghcmZWB6XWYiG0a4qNXwMmcCh1GGAFtH1pZJG5w7vLphCTiluTeQ7KYmTyCpH2Opcju+jYygKSeAjmOy2uBfJbBHKtUzSK07BYC7GuN1lAH4geE8L0Q8zsS4DTjV9KcJicVpgLWmNzO2jAxBB7u8l2TwlsF5rI0rybvTRCOHvJhI21YWedsbNke/MeomAtFVM31w0Fv4iODSDULmK1OSViDLXxGwUsVCAEGHQXrzM5MYwSzYWm6z88k6W54JGoIpamPWyrs6ddWql2CwIgayKgp9gkwtga1SdlKzqnS6ETMZlb6K/S0CvvOaArUEnRl+KAFugK52azMHdra1neucBIKfCWA3jG0L9vg6FxpmbeFEiXEwiXFxdmysHDl2tLywZ085DtZ2Elv7GEBl2QxkZXAkc++syxK/68GtftP+u5gRWgyQZR9pf8fzDaO9HnoU2t57duoez54+p3i0E5AcdYysdxy6hVn0HnSdLmQVO14H+Raq1/4yv/p1r4LT3K7yob/4iOQb/Y+W1cuFX9aV6qjzC/PCJxZote70wvGRs0J7gWWCzl4guTi4beFi2oTaa2rxrzXztvqSLt+A27Y80bCu6zw2nDB7Vk7ZJ5qOEees/UJmqVu8Zj9qF2q6XITDa2Pcuo9bU65ytAuBtMlRHq/jLO/RwloLRia28a6LfAXoLyFnMrO1GQ5MyR04JpkxLKQQ2c76ywLEJOC3YaNLeQYne8PRiT2PL9b3B5/fGjWAdlyPkvwrPOltyu6yH0/qaAEMBo9BDfzL1MCSgO0fvu29YGwRIxbb65QL0IlsE+QIVwBqx5GTnhrbabifTsppDJERkEKU4HYC3xvY0kMdjCq3ogk+GAZLExGtL9k3a2mvXw/2iuA1JnQBtwj7pC1njI0VYH+ps2WyBrK2IwC0q/UeLC6A7tr1ZG3hQAZmmGCQYMY4kpm84rp6m5MT/84HttWQCu/Zm17ALgwsp57MpDYHcDI9OVHOnT5jOcLsVFmP9FKjqDNKIjoITdBuJtgOoFEO2XCDywYTaCKkLlSJGkKLxq1BHcqyMCpCsCYtm2HnKGp0eYGYCDusUSf4xANKZMlr65vIQEQAXMvngOh14pR+xOxshvESsJWDGJzDwM4z7vDKBLZMYYljr6UTVoDCBJ48TzrMcQLMCAUC/KmTJQsscO1jmZ7zCkJ9Zcgg7gYQ2HIilqMiE0A0GltNuKGttSd3MLd9wLaFLGamO1bQgB4LM/TBXilC9ifrTs1isX088TNCwjSiZ1zE4uc0+si+gwfLCy88V84dOViuX3ZEgXwEpPkXAbR5jbavEMjcj+QKD77iZRoz45cmpKM9fbLT9na/6xyV3e8SJ7LU2Zs6YFuBikd719977riU7ZA9fNvrv7U88fkvlSMHGQe399HD1DVI32CRfbG//prOnouDRmPLo3Mc13rPcd27ktDX/cfGUtDXjkf/QkKLqQWAbZ7PxU7w5pNUzJvgVrskvoatWMsAN2g+fqzhnrYhFt09NaN75HWs580EJCIM9Gw1tl366n4wnnah2h6OIY2nkG1Fhj9rbh3tRtIE6WxT2tWNQbUirk/gm+2ZINwtqV2mfTANP3Viau8fz+sggw9uqRpAv6DUgJIDSg/YLU/h+UW06aVbqqCDwvx3WQNLArZ/8Nb3jK0RsKWXudXe68HYUhIwduy4PLpnqLGFlnAGE/gswO0kQO0Utuen8Z7sFRm6IWaZknZL0EQGeA6RFWhpmTecWcZSH+og+DC016iNtMG8gsxNsveUNgA0rcGW6Sg0tsxCJt0t/jLd7rr11N2OOiVpgMIEtuKDW4CnNx2UqY4MnmY0oVEaVFNJNj8mwBdwImBDGafhEHQBQP/c8ePlMlKcroUUYS1if60eCv2lgGJeX5DVJlvgje+DZc1r6Nr2au7KFRESeE3cmzW23Q21IFcOUtQsR1ajECBUljwBm8Gz0LvAtWNqNhOuZkIDX/njJaBVmckoIVEB20rMLOPTwqYB0K4Ei86kGQ795ZZNxbG9rhMw0mvKzHR6S3OhoxbgeZWpDH+V3MMREdinFEM4GFsdSw04ACdj7yrDneIn9+pgxfxrkg32KFimbIeFRrnBrYcKFym8mV7G1mCiPkKeISYdzBV/zwgil5l+GeG/9u7dVz79sQ+VYweoJ40f1t8bYHSPupTQdW/0uBFDu9jv7rjr9vLIK18hXfpVLE6ff+aFcmDfoUUvU0OkRb/NLX9fOxdsOaa8E0GwxPGbi8K2v7YX+iGk1z196kz5p3/4/Lzr3xDYLgBE2xNUoETZTj8onvfefa6/rueDVrdcC2zzmu2xCWx72eGOudU5AoAmM6rhVsefbVCsULv+Etd28eeXNwRFUSR3rq4MeU5La7pU0e7njhXtsSn7ZyTsq8TrllnNkHyyPaGfrWl2Q4bgtOlMke7ICNrVCEcy/Q7/uZ840QofDvgiO3cUg/5nj03s+50bDoDBl7dEDaA9H0RBCGrp4DCO5xPoNyduicINCvFNUQNLArbvfesfINyXARodyGgMh0chR0AAeTqQMRf8jBzI+ATYwCQ+i0lyBvIEphZlLFjOAhmCXGAtgJSSPOB7OvbI8DEiApkEbiHTyEZAfQf65ga7GdOVcA5aPYIoCGBoR9cgxS4kCKshSVi/YWPZsBEsLkKSrQIYd3zSLsOUIska5dp4mt6oj55JNyeYYKLSgSwPJvCmVtjxB0q5PDuNRA0XwNraiWzV8pfKOrC2rrfM326WszqRZRkqjuR2HhmvbnLzNn3EXiVjLUIsyp9xbGN6473oaGlUnZKygt240czOw5JkWko7X2W9cEJLNjZkCwKY7fdxDEDtdbC016RvBSu/elROfAS3y8H+kaHVtEUmJ9qdQJUJLtiOTLXAe0029Wpo8ro4qI5CcV1ObI4rq0mRCx2E07oKGYyYUe4CcDEUcgQyqpwoVxKkB1D07zqNbY/zGNshmdto4G4i75i0Torg+ukAQOixoz8JxoWDDE9H1ursqbMI2/UX5Yv/+NnqGLc44+eh6aLPB7S6TPSBNhXtQlYrgVN7pg0bN5THXvMIEi1sVl85sBcM8nN7BDx6gWevBM6XZHkMWtvBI4YyInAkOM9zCSB5wNXztywoj3vNt7y63L3rrvLXj39E5Vjo0az56tf95/EXHXjrDoyyC7B1bGcv6GRbz08M0V+WGy0iOrDZ96toRoPDplm1sM040S5357wYx+p+oicEEO69z/4+0l2AdVbxu5ou6oZRaPJarBPJEuL6NUkDL+oxmqDWzagOGDsTFkg51F3EiY44tpImcBEp51/LySxH8MIyH0kcaDzFcgHHn8ZC5BeOTe79jQU7w+DDW6oG0CcYtos6Wobxop7oKTz3oN+0y/5bqsyDwvz3WQNLArbvecvvSYqwGjFomXQgEyxsQZD2OW6vSo7geKIEqXMwXgzFdIXgFuwtX1OnujwmegKcOTkW2ImAYJYyA56DvxXLk9mdgi0lEGRkBGYiEyACaCKwZXrdUYT8ImtL9nYD4n5u2ID3cCIbRvD/a2SBBQzD6NYJWea5m8STOOuh3lqWQ7tpeghosowCtk5GwDJRZzs1MVHOnz1bzhw/gS3mSQDblWBth7QgEDtDujpmGs9PCWSDte2b+A2CyXZSUuFwWwS2dqzjbxMRB6OSwDa+FxMbE1EyIwmmxIgHG9Rl7U0eKnSt/HGAkjphB3uzfDkFxACvkB4Q3K6Cw97QKgBbhF5jljhiVsCkRgPs+yWoXYHfaVKNek/Qe5XlFijvbCHZUZYhw32Z7aEUYU46PvaLleiYYpoEbA1qGb3C2Yfczc1gLwBsmzpnZWdkhH5gmwCKMocETjXQf9aj2saLJ1U9+vw4Uul+5PHHy99/8lMoK+Q2Kk039HpBkj/Pf/tB0kJs541AVmu2eM5h6OMffuyhsnMXdbSlnDx+qjyNaARcnObjxsCWndaLJx/nQZF1k4uFyvZF/8sy5iKr/U32zy3btpTXf9e/KU8hPu7+PQfaojdl88sK1BLwxQe9ZQ/w2oLIKCs7Z9atQHffIqG/TXKsduXuWPr59e8xlAuABdtHXSh7QgLNDoznb1rQrtdNreRIXWjh04ucozc1P9Zvw3TovJIWOczfPL2tnQRqpQsbt8A2xo+jHFiCU6MepCOogGy3U+JYt12oL56TYRVjPDGt5a9cm5p9y7FyrAsNsmCPGHx4s2sAfWEjyvAteG4Lg7AHf59Cv+pyZN/sQg6u/01VA0sCtr/36++2xhZPhq8isGXM2bWb1itZwnlkIaNR4pPA9kpkhLoK5pas2mUAXK3S8Z4GjeBiTuwsYxviN4wqALb3cry2dIFbYEJ0MKJmOO3RHh7/0FIODyM6AuPWRuivdes3lo2bN5f1YKPWANiOAPjScSGBrQxuA5ha2UEytwsBB09muZ3aAFsxdmQUCdLo1Q4noSk4ziEz1GnIEWYvjiG9LmQbYLdXsc4EvHKS6aqekwFJEYG5PmAtYEtrIbAX4a80qfQDW7PGmYghBAyVJa3MWXRvnrMLdJ4zXLLZvl9e2JNebA3y/HwfyRQU7oyRARDxAKsM/E/pAdMZ22mL7cd2ZuSMLBfvmiWVFIGTaAJbti1eK2IBj49yahFD3Sx/FyySgS0y3kW/Yt8aouyExwSwZZkZhYPh5HIrOiMiZFSEfqc7XrKNxnAjYGvg0TG2olZDgpChNyahNf/4Bz9YPv2hDyuigB9u9wppajfoBbTuc+3w7BjapQDZFkjyXFwcPPDgfeXlL79f9XkJcXWf+tLTZeycs5i1j6UAW3cO30l7fG235oQ9rO28/t17X9//Q/9e2ulPffTTfczxvGK6NtUfF64n2o1kGRPIZRt0co/e33LRkkXUabniq+dP9noBNrinvdpaSJDbV/4GVPL8KkXeS3zn9a+vtdB9dmds+05+mvflftpWUc/9kWnlWKRdcocPcGudenUiDWAbYqrK1rJtc6FPFwDvxHEcxYJWTC1ZW4Nasra0+RkpocuwqJ9N4PM3z0wv+7XzZR+3sAePW7gG0PZMfcsUuPeqk5VyDE+G73LWlsFjUAM3qQaWBGx/903vHmPCgTUI8SXGFpM4/w4B6K7ftrXMwCFmGqF6CEekh8VkII91AtvLYHHJ5DKskTLO0LB5S5jHUL5AppdRFRgyzIytjaumEQJTjBm+puOB0tHS+GKiXoXtboKpNesQ9guM7VpESdh823awthvLOuhvh5HMwfFfgxmVEeZJPfEY2IYsIOaillHKNjGDjC13Ms7+oRlg/MMJkqmGHS8WoB4644lLlxAd4WS5iAgJywBoNq1BGYFwOXkQYCS49mRlMOmpjYysPbo7sKDZtbKenmw9cUiX1szYelnZRwItH9OC+eR8KkOb991uzfIetQdupZ41t9a5UmR9He9VH9TOgqldAYaW0Q+ouSaopcMYf80YDpQWKI6u5MMGQwS2K3gO0WCuyHTkIiutj6Ly3daRTSwmeDH+CvU1Z2cUssAI7aZIG5QfKHsSngr9ZTZKE7DCouWCIDOQ9QGzmPWTkcr4tSyO5/Z0sum0u14gBPhHwRkp5OMAsx97/INKt6zfVobQtdpRb/MB7WK2oGXxFluALfTbnbvuLA8/+hDkQyPlCiKVPPf0C+XIofkOWm1/787TtoYXmWocdS/Wpbeza3kSpKlZsxXbUkUHjo9yPLl+lyu72UOPPFj+5uOfQfi8i/NuZyHg3Eox2nGTiw/3qF4wWrf6c0BFK6nrN1EAauvoONsSg8T2fP3nTzDbLhR7AbTvtxewGoQTS/su6/fR+W4Mbhdq+e6aCZx1lE6f31naRXua59dODndAws9BfTsYXWHfXFTL1nhcOwY2fQ3cX+RLliG9aiSEVt8OW06A67E/g0v85vVls79wbPzY/JXWQrc2+Oym1QDajMbuFXg+jCdD4dAhjAkW5nub3rRSDi78zVwDSwK273rj7yLz2MoygvBVqxHPVk5TYGwJ1DYjnz0N2KUzZwRs+WDwADGx0ttiqxgARBpasLeUVVE/N0cQiPcEtjPwbGcQ+0mAgMs8xj5UnkFkRG2NBZDwJg0x03wOy2kM4b4AbNdv2ly2ANhu2rqlbABjuwq64ICFYYA9MZNB1I1nlIEw0PrIKLhDVviME2M6OuVcnckDWEYFuYqwUtR8TgPYUI5wFsH4L49fUtiv9aPYqmdaYrKcAo0EuelUxitTW9bpGXOCbv+K2Q3qJQG47yP0qwl0VXXppLYQuMA9NS3vWAg5hXuLNic5fad24FY/M04wVTH1z34yNi3T4tJJjAsNMaaRuIL1RvZdSTJiMWB2ytpalTHKL+9pgWAvGioLRyCcTnoJbKXL5qLJCQ5UexEJYSUA9xDZYk3MTg/qc3E14Hi/rbY2X9e2D2tQ464GyIlqV93Ye7wFAg6PhD5+9VN//ZGVH/rzDygma9aoW5v/5Pa33sSVAujWd36hKo+mW5yhXQjmdSfaBA38K1/7aNmIhR63ffe+uL/se35fj7ax77J6+9VAM793+QhsejW47fl6mNwoKuuu//wJA/lbSiW+/z9+XzkIB7bmFSiPAAAgAElEQVSvPPHkvOItdMct4G8qNawR+2/WaaerJZOve+1pimix+K73vF4A+96TAW2AY4DdvH4P2Fd7LhHYskwRA7EX2MbiN8bAQu3W3XvtONmb46+XtQGb3c+iHyqmtAe+5DuSgkUosNTYelHKE8RSORbRHWtLJ9sgEhTmy9IERkNwuK9WimDWFr99BzKR/Nzh6cNMZTd43OI1gPbajSK+Gs9RPBnOhaG7GMJr8BjUwC1TA0sCtu/81XeNrcG2/+gwgC10ttIuQuhJtnEUEQhGwZROnDsrr285EcD8OY4hvWCDtYW2cA7sJdnauTmneWViBzqZTV2eAahF6DBs4/M7sqoOi4izxYThDGKxFR8e9UMAVUNwIhtBaC/qbNdv3hrAdit0ttDY4jvZ4WRt+ToYBgNYT1Q6JsCzGBn+Y2rX7GEAvQQjNuT+jhMDga237FhE3Bfq4RKC759BxIhLSIe6DNEcGPprBFrbVag/ThiKuSpW2rpZn6kDob2gIMoSZXJ5u+lJ9RSfKWSX9LwBp8SkJHTgzcXkQ2ASx3RAMvWo/q3DePH+yXo6qYIcxci54jUdxpZBz0qmllnlmF1OSRLSwYs1H/Er3eMNMhLYqiz4VCmDQ3/tNu/YsPTQTukCz8IJUnpsZu6KZAYV2OL67J8Etgy/sYL1nSAmHVsa1rZmCXMBu/4QgurWU1130ADbZPZw/rmJ8fE//eU3/Mz+k0ePvoH31AVp8o9yoCWzm22udotr9/9ZHNDmkQsDWyYnefRVDxdGPODj+JET5WmE75oFW9tBu0Uu2tTB4keopuYB234w11Of2V/7AF4CxTyW5/g33/ltZdPmTeVDcCJTfNQlPOaxmTE+1efc9bT4iJfVOauKC5py+WULWrPWOsa2u9dm4aQx0/vbLPriwLY7PhnbHLr99zTvfXbIvvr5aguT+jNJNaJOuOiSgybHumUIZGmV9hzfOUJBAlv3Wv1bnVPDttoQWYrQAFuObwNba+Lx+j1IavOTJ2YPHFlC8w4Ouck1gD61BUVgPFr+5eMZPtEnOw/Am1zGweUHNVDtbVMVSSzxLxENnyvXr18/9Ju//M6xdXTUWs1sWoghyy1eAFsyjswutXG7U+xOIbMSH9pWZhxDgFsyRZdn5wKIENx61X4F380ytifY2ikwtZcQqH4KTOdlAGHOgdzCpoNQOvI44YCZ0yE6B8EAM3wYHYVWI/QXncXWbdlWtt62o2y77TZERliHpA0ML5bMkkEAZRIGug2wDWNsXBpb0w3aID/RTipmqmLiMyqMnToDGGqHZ5h97fTZcg5yhInz0NqivtZBaztKOQdAF4EtE0h4guiAZ8up9IPbZGnnIaFkQ6MxO7aWNx/OPfwuAV4y1Q3M4VGMVuD4loRljGbg19fFfFp2APcOLy/I2KLuydTSkW8V+gFjoEq7qMmSMYM5uZmZcd2n93dEQ9BRTo2re4vjKrCNBUWC5QQHPP6yFkqQt9DhRM5o4ThGYE32iROzoiQ0YYuU6KPLOsb9Ul5/Ida2Lhwqe+fK7TKPse2WXZuaGv/gJz/24Tf99m+/8chtI3f+8NCK4Tdma4oA069yaEUUih621udtwe1XB7TR0PxdMIj8hH2KW/nU0vJx/twFOWJdvNCFjuxfyXZnysVdf2nyCP+yu15KOPq323sXZ2095gKspwy1T3a/u3PnneVbvu11Sg7BaA2LPbp67paG9ViNe63eAtTyb3flDCnVD5sXBKBCxb2lSGDbsbf+vht7vSxtXVw17ZUguIcZ1nW8AK1AN847D7wvWjNL/4Lj3LcXsghFRYCcR2Pe2tuaIKVWQy5q0qbSlnol4XHcAtvYhdGcIGD7pwjr+OP7zz77z8udvPRbGhz5NawBtCeZWUY62BWnPYS/X0Zf7LxNv4bXG5xqUANfixron+dyBu4Btm//xXeMrYNOdBjsF9PEknUkJluJLXY6ko2AsV2N5AiTY+eUIpTIh+CORm6OGlvIC+YAZBkGjK+po7yCVTtDgU0hOP0EmFqm4SXApXSBvAAZXZ5D4FZqTc9Q3EIkiOIkPkR9J2PakrVFeK+NWwFsd9whYLsRIb+oKVxGEaqAaILW4BqCQfI2uWbsDliFgc4KzniKWVmacGLS7BhGlDpAru4b7NgktqPPnTpZziLD1JVJxLUF0N64FuwytlsZjmoFwoBxUvH0YMbW5/YnBrx9wJzgT/Pe/C3dPNYTZTw5kcbE6HP6XvloJ3XHqqSW1lEe+B5LF2jt6ByGuLRoZ+T2UpKFOTm74TiytQC2Q+gPqwhwlVXODFBGOUjPZ897jlW5jBrqWBgkWM/wZAlv6iSOYrXAlseT4WW2OwFblIV9QhOxtlA9ISuSQm6pKjYv7ge7BSyXZCSxgNH5mrBDtc0XZBi9BQ8W6/rs7OxH//5vP/Grv/Ebv8BtOEnAt4/c+b8A2P56y9D6fFwidCz6QuBJXbBpp8XaN8vXlpPH7r73bmlTuZibQYSDZ596rpxAyuvsQ7Xt44cd1O7O6FuuLdD3ugO2zS98d/GTtu/S479dmPE7Oxa1EN59m4/+Ovl3/+N3a4x85K8+1ov6mwpYHNh2Zq3rT/1As3GIbCs1QF5/Ped7SymMkfNvV3Yztj31sdiJ4p57QK0+i3LqFvgPLhbh6hYCtt21uwVG88ton7QwcYEF6ts2okvOwBjQGkscrwK77hsJ5N2UrAgvDOsWFhezfEYSBu2IKATctQ9dvfzSj71w+omnb1Alg69ukRpA2xIDPILnQ3jy9Tk8mWBh7BYp4qAYgxpYtAaWDGzXYBudOlsxtgC0Q3DWWSHmkd7nq+BEtg2OKdNlFo5k3B7OFLgvzTlDFB3JyMbyL7eQZylDgL52ktv24+MAtlPIzDRr4AF7SWDL3zGclQwldjzClQkAG9ve2srnk+AKZRodBrDdWnbcuROs7W3YytyIcF8jwDZCVDLCiisQM10CKk0dOeEGgycnsQSXBEAxsUSkSc1cNQ4mAbPOYScaxWfFezo1zSHrmiMkHC1njx8rK5GEYiMWCBvg2LYajm3LUY9iFsnOBEeapFIyP4oG0UgmsiVr+VJ3Gy3ZRh8QG+P5qAMOnHhZCZyQYmZmlTBwPXlUZQ5DnZKJvc5oD8wiBoDBVLhk4AlqHWvYIdcYeYARCdwPmIzBBREzyvMSNAa4zjJLr8yyse6YOrcBmQLUeJ/SDp6PutkEzFo0gK2lFMEpOwG3yeLHJExAWydkMk7U2qpMvJgzGykTHds6tlHt+NL7mA+43HEuX5752y987u9+6Y1v/NnneXvxlE7mjpG7/teVQ8OIuemFj2U5hqxOqey6WRDYNmziUuxVlm8rQmS96rWPITHJOmnX9zy/B6Gy9tdFWu0v8aKFre3gVzdpQGcvsO6FwV3kjYVBqRFfL4Dl+ZdSz1mGXffuKq9FXNsv/tOXytE+RzfVqPq967ICvnrJfsGFkWhXxZ3Uxa3TELJfpR36264CUbdsXKMB1n1Avv19P6jNvtEC2Hl62yX2k+jxPa2+GODW9aJf+tq06xxzXKjiG23cqLKrDrf2gWbs6q4rkE3W9upnYTd+5Jmjn//iUvr14JibXwMYg9zyYbQDRj2YwpMM7eGbX7JBCQY1sLQaWBKwfcvPv32MsVgJbNdiO30IgGwVAAO31BUVAGBiBLFjVyFBwgTShdJb3RorZ5qhB7vCfjGgPsARwzTNAtxOMxMTwCxz0V9E/FcCXf5ObG3oIQkNCJKuAhR6uxzXhtEdUapWMsYAYdJ5QhIBYLv9jrvKbTt2lA0AtmvWjkrHahAX3vACHKZVtDWuSVIW2S+ScUiNLX9HY69ju+ryZMDzeFaU5hbHOMWupxVmcpqdnoIj2ZlyEnrbqQtjZSU0ZuvXDpe1iOYwAjC+LOKvOoNZpK1tJi9NvJo8mvS7+VnV3HY6vwrIVIqFgVSeUz8nk5a83vL/r703AbCjuq5Fq9VzqzULzRMaAIMB24CnOI4Nfk7ei/Pe+/H3d5z4Jy9O4rxvv5dvYic2NjYewAwGGTAeMDGe5zEhxgMQZgMWGCQQQkJIAg1IgFBr6FlSv73W3rvqVN263belVqsFp0Rxb9etOnXOrnPqrLPOOntLfoSdbZBFYA3ivgueDuqgqZVz+rFgC27ZhIFHCGT1SgFZhTDnUh+oGQYA9gGBAQZlc2zRjXX+MBhv7awPBjMGNMGyhmCF0cS8g2W/aT6PuSBRFwFiRz500UsGbOmuCFML3stj4WAIbDGrYGnqOToIwsaPYEAggHbFwyt/e/FFF533gFYWZWmD7wfntC18R0N90+dz4DGHHvMAEbdwAMlragQtOBWRwqCjnT1XQrBLvjdtfCpZI94OoO/OlgJqWXgPrzN6SGuGPSvWEzaJDIwOCmxDsAYb2cBPk+RDrQC24UDRslD6kdZfSfM//8kfcvBy0423pOeWMbw5sMiSBcDWwG/xZhWDC2vHZYMOXFtVsgDcFz43fy/YDYuL68LAEP5syj5V0qODI3s8uSAOg9lwuL+FANvbHggDja4HzS0LmRtIZFVAPSDwufCLtnV5j98r7fP8VRvuyR7ecDMWzx9VC8hzmyE3PFP2KbJj6nS17I9KHahN6D6quY03ixaoboGagO2VF35BgK2CWgZqEK0tdLYAtvCQAOyIEX67SAF6RFLQJawtnXFz8ZgEXhAQq6AW/mrVr22X7HvhCUFkCJg63SPXgYXDuxGyBV8hT3aNLJ0yl5hmbhEWsZlT+QAymApvJMidOHlqMnv+fAG3c5Ip06bKgrLxtvjBpu0BoPhG1r91lbOZgB2yLrRSzacajeeY/fKwJGM5MjykacOVFdMC6wwNsYTXfV4itD0jett9Bm4nCTCBPTF1jCl8+mqlb1ftSFSWoBpcSDdCDw7h46QOFuyVd6S5HzU/aWdtzKXieGWvsXTtIKaN5XNcY6uA2hYZoLQnDTJIqW9oZmcKm/Xs75XFR8KUyuADZzdKfgFsG8HaY7EJnkcAbGk77HT/lgHbLKdYxKbPltHhDPziOoBTMmxczKKgWWW7uiARTL4uQPHyqbsv+sU1fa2yTciXpqVYS4JowJemdcJ+T+YPNpD0QPDT+vbQhR1e+fjaRy//yEfecwesFuw5UIvjc9sW/UV9feMXbTihTyIHbLMD+oRNIsFvGajUiyouZHKYnXjJKScmi5cu4rN57pmd1KJicGg11q4O00NyVudZp9OlhZbFoYBtVqnS9qI1q0oZvW1pHkLAnKU09LfFy45PTn/Fack9d96XbBdf2b4x/wYmHYhl91DbhXlzW/v11cCrA/yynLEu04wK8Lx+VGNd/VlUplXJ6lZnbq2+6ONJAebQlgsei9mp+AwqmeeM+YYdsDiUg3STIjjjnUWUC+sEmqa24wMH968cODDw0d+tv+uGWvMZzzu6FpC6gUhh0NEichiq+QbZwdJKDPu4RQscexYYEthKkRqvv/pb4hWhQaJoNckCMpEjyHcAG+hrwdzqdJywthLetkF8mnZs365uvqipVS0ko5LJMXzCE8I+WVC2VxaL7RNA29PZLTKEbrpwIrDlSmhnanXqmB4WsFAIi8Ww8l0+sVgJLr+g88SUfruE0523cGEyY/bsZKpIIwBsweRpR6SdrGo5MS2sPjg5ZWz0nIe5zRz3o5lnwBYnsoNJGRqdmvMFbnoPncoDDuMyNWFo4du2U/S2z4pLtJ2iue2UxWRNAqQmigZ4vLC2kCXAuwPQG3TLSF6j/5hXAoWICsYNAFmWiXeZH2cl8Zkyudoxaseu38nOyr25sE8OHuC1AgJhy2ZxkdbSRuZ9nLnuQtqwOwJodHf1UQaAvMALAgYUqAMM2GGMLe7i0gLc1F20uY0csOk4woAtzWwL+pAdLgBT5pZMtoFcsNZwpwbWH3UJwJZutwSNavALC/pg/mwVEJsPTkMmDMtsLuRcX808wjImsQAAlnq7/qmnNix///vf9XP+WIWlDX8TYPv/NjQ0XVsNlPIJlLCy+lRDIFruuwBgFjpa1JVOke4gYtj2bTsKbx2VP1TCYgXSNEMAbD0/tYLPHLAtK4u1s+IMg5fd21otr0o8zz/6kzczKtptN2FcoVuaV58azyWWDQocqIbAthqorfZsPGmnrLIiZxb2+skmaI9xMPJd85C/Xu+vbbQsL8rgyi8c9KYn12LG/Dkc4eVrhw8OcKL7ZObA0FyAaRtyUO/A3Aau9q6RtrhWgO0FK9bc9v3hZypecTQsIO0IboOgo4VPWmx4mUBHW+lA+mhkMN4zWuAQLVATsP2Xq76+eUJLU1ubgFoEaYDbqgZZLQvGtonhS/WFjJfh+GnTkm5hj/Y8v0sZWgGxWCgGcNsj06RganuFmd23T0CtdFh75bOXoFYWlVGbqxpbkmpgaiFnoIcEW0AmN4N7LTjhbxR2EQtMwMwBaE2YPCWZM3+B6GznKLAVTwkA4CGw1U5RFkIZsE1XTstR91OJc+iCCgDBwRmvwmZgjJbTwAwOFhzYKrjVJzIOaUETKh4g9omWeOcz2+kGbJ+4A2sTlnE8vE20tCRtEsGNkbLgO1IuJiDngi3th8BYKnucXySCE3Sq2aYtcT57YQXZ1hvSnirrEDvKYTwPuO2qExt6gAWAWoTDrRdQS9+0xvJhoRYGHr1SBrKakkfkGXlRYGvsqIBjtZKugOaUpHlgQAYUjDu4UsaW+VQDmnVRVmNakRoGCZwSBaOK4B4yUBD/yACoame1NfLEc7GAzQI6UIaC7BAM6P1QJ2EWRj8yAOhR3eqo6+7ftHXLU8vP++Df/6ssEAsBbYX0gAXN9oE54xf/hbgau16ffH5zOUAO0NhT0jMBOPwafW4O4GbOnpGcevopEoCkXQB3X/LYatHRmreAkL30dPLANhv08HmgzFqZeE/WXx8l5bKc1SccDmBY7q9iOTPJQeYFqMiY1gqikfbSE5eI5OKlyb133cfwv2aptL6QUeRR52h9EFc5iChjKTUvPiC10vgYI2U77XiAR/k8UxBbxsLa0zAcmQe8efBaBLSatg1FLQ8KnjPT62A2eH2H7WcwVF2lbtKCNlDQmSP1R633Nc8JJkcwazElad+bZYR5wYpHb/9qSdLx0Bi0gNQtVJxlsp8mu6wMThApDBHDEDksbtECx7wFagK21y3/2hpZ9DSjFUEawNhKFDIARoAwBmtgmFjZ5Y3XLOFtGwX07Ny6LemWxVNgZyk/YMjc/eL5oCfpBoMJllYYW0QbA/j1xTy6al3lWvvB1AqYgbYTAR506ll9xhLQCtOI6W8uYBKmc+r0GcncBQuos50isggwtgiKkL7nCbQqgW1xIUQaVpVvbi45YydC/7YmV8g6Un3NhyySA2eyH0gDZQJbDemFyDR2ihuwnc/sSHbvfDapE5tA3jFRWFJobpsg9aCHAZ3epyyBu5kYwNCpIbn1OAmc4KDVp7YB8GhP5gtFgJRDGHS4u4JHCtMNN7SMl2clwS2wC8CuF30t74lpSLjuQvEZulYYd3l+8IOKh4y8kS2HyzJOWSqwBaB0rtAZcfU/zB4wbSy+Oj5loBnIxjbvSM3tkIf1RNnAfoOxBSg/cEDBKjtjuJ2jJAZO5Y09dofzvvjFgC1lJnysNnjhIIpM8Lbt2zZf9dGPfOAHHR3boS+rFdQ6MhqY17r4v4ndfqRASbcQTLkAIMVNdo5D+jwbWJe0yyLD015+anLczOl8nhskaMGa1Wsp7yGgxQp9LqIKm7EBIstDXhme5kpBfZZNPlfffMmbjTjS4ZGVSCsi6zWHeblyZqBVB4C0QfZ0bWCWu3Hwa+VXPNM//JP/xDK71lZxePYu0NC5+RZZtH21vzNgm+FEB6E+cNJ6yodZyrhnUgLNlmJOLbX/naWZ/VbGHrMO41VaBprtHcC37VDANo+kB7Wx24aAlmW0SH8WeSzV17JN6jtFbPK0WOWi+1ff9vkhE48njBkLyHObI5mB7GCS7IjzDS8Va+W51t4ox0xpYkaiBcotUCOw/eqKSW2ti+kVIQW2YOo0vCh8iCq44wtPPCTMIIB7bvszBLY9BEYCcuEFAaFzBSB1dXUz3CgjjdHXqS4Ecs8x/QRhEp0MjC13AbZAvNa5EMDA1ReArYHbaQJm5y86Ppk5e24yRRjb8QIM4IqKCTujUQXYej+g0+gWBpaQBd9tkRJ7nNAftYFdpp+B2wHz48oOg1BPAQg8JfRJ+fd27E2e3/m8ANztSYcEtjgotmkWIEY2XABmmywsa0bAA9PeclrePTOQPCk8Nt7bmCrJIxfuId/4FJuBDZfZe0Z9g4cHBC9okMFHc6sAf1kk1iTR2xpFDqESADDF6o+Wz0Ou75E8k3kXWQnu0oAgHfCIYMAWkgkHoKphZpdOu9E3Le1o8C341OhtqDQKbL2zxrOlq65gxzMB800pAmUIWuf0HKuHgb5W64cyTUToAByya8hnBV0A3Qf3739u+45t11z0iQ99e8uWJ6ApK2pnK7S0mpo6wwj3OS2Lz25sargJh8unvCEFCZ9d2Ch1lT82RHA7+dSTkoXHL2B9h7704YcepfzAt+rANkuzyPrhl3KRQ3ANH1UojNAcp7nWaCX6hEO0xnPsLAIzqweF7lJnHXxiPyx/9e+LlixKXn7m6cnvfvtg8qQskstvtlizilnDPPl1xYEAL3WszrqhZ7r7qzJgmx+E5HNUBLaalp4TAtYsP1kGXBYQjlVS6YIKwDVv+FIFaPusSIqqBzFzZotA9oPBYiAHYp4oVed7ZqdImS5t7Oi55p4t92i86LiNeQtIHZ4omUSABVltyvfWOtlXyTMFuI1btMALygI1AdsvXv6VW6e2t50GKQKBrbCgXDREpgxTwHjhyrQ5gJSwq40S3hbAacsTG4WZFYZWfNVChoDPLgFJCJ+LaW2AJYAUwj+AHAeI8gU6W8gSUmAL105mena78pLVIAcKABsFDEydNj2ZJ8B21py5lCLAKwKAbeqnXalN2SBF8AUu2swdlONXdUGlUYYE2WFi3ToT/qq5MEiTGTDTMPoJCgjQy9v5uBryDASmEBnG7l3PM/TuTvGasHe3ONEXANostqX2VsAtAHuzMLgAkfQ6gEVVBo2UVVGGlHYnfsR3tVs/8i0FgB6VABIsNzweSDCLBgHQALXNALRybJyAaIafRV+ZTkEqGoSWlQMQyTNALgAsGNsmY2yVrVXGFlOWod4YTCgX/BWArQ4edMGYbkpFuUshMtQmb1AGS+vHgf1aXyBHALAl8LCBlTPGzA8GAna9ozK6YxMAzQGS3FukDB3P7th27eVXXnD9YytXooN2hjYEskVQWwpo/enObV30KqmH91glq3hRFCBi+ruCGHVxtmTZ4uTEk0/ggG3P7r0SVnZVsvO55yvScglCmRTBT86AbQZnQ2BbpGjY/LCPFLAt4YAOBdiiPG9+y5ton1/dcFMBUKOF2QAG9wvfaClARcXOTKigMLUSv2TA098R2p70t2zQ6FdlLG0los6DXs2Us7D6vBQ0ez1x4BqmGYJvTQ8X2WyNUuU2cCsgZi9MyNgWBiBhxcvfU8PquvzAF49pGxrYI3leLl75r3j00dt8pWJFvYwHxpYFpL5BagDJAaQHeJJbZX9AnjHkB3GLFnhBWqAasMVbl1JW7BJ57N+ntLe+Fqv4Eaa2pUmCJFiUKRKJeFkjqIKAB0wTgxWbINHI9kjEoy2bnqJ/WrK13Z0CcAFyZRFSn65wB1gi8Emn1hSwIDADJAg6hQ5NpWoiVT6qwBYLyQC0AG4xjT5NmOJ5CxepxlZcf6XAFpcYi6QgKyu2d+KuCUXbPyiuxVLgxU7eWRxFqJi1SSduciAgWwSkPmSt02W/oPWHbDDKhql9kWJIKFaJDCXhd58W9lY8JvSIlwgpvdhYwKdIEvDJcLXwE0s9sfnvBXizfME1mupnLTY7XGKBWTYGFgC2WXz6tojcoQkaWgSIoKsuLLqT0LgGED02vIbRVFjeKwORvm4sHBPsJ4fgDYOLxuheS5lalUpoeTPCFjbLvEvoDwpo8ZUaZ9MCE0B4h0pNrbLxyI8zWApsTYYAsI46Z14TEARNpQiWHzJMkHFkrsNwb8pb9vftE/dr11/7xcu/fPfdt+6RTB02oLU3w8CC9qWnCOMtoSZLEB1u5PUupOPs4jnzZiUvPe0llM9gEPGouO6qZCezd1DIllZKEQySeTYIooJrq7zKHGrlgS2XWgZXaL3Qupwdz4NF+61gBm1HTnRXyUSVw/MXzkvOfPUZySOyYO7xtet57wwQmvo9PcaqplvIcPohvmv8RnpiDtj6Aw3fE8FJg4NaB8N+86Lt/H6ZHVPgynzk5Q7hb3yJhADdpAE8GILXYv2qGdh6ewlmS5KkS8aD1/Q27L909ep7KkdYw3uM8exRsoC0D9SUk2Q/VXYsEkP4wRVSv4qrTUcpR/E20QKjZ4EisMWdudxGdtCDaBANV1/8pe9Nn9T+5vZWifAlARoQfQzaWryEhbzjhtc1Q+Wa14PG9vakefz4ZMPax5PnhHFCQAaEzAXARYCGdFU7nfUrmFVWQuEgF5ER3MIPLuQKtpod97IObBy8IcjLPQW2orGdt3ixMLZzkmnTpxHYAoDBC0AaKpdqhszXrDNUbnIAXE5R2yp9ajGN0lXiQoEtJAneZYHlSKfV7agGIGDJtFzppp0Q46kJUANghHZ1b4cAXAlJvPO55wh2+4QlRRQ3DBwYjALsODXNqm2l7eleC6kHtuPCK7ELnpOAWbjkahVAC2Cr/n7FhRcHBAr8EFGMgwRzqUVJAb4LIwo7Q4bQI1ppAHGUAky9Sz9wfxz0KX8AS9dBs4xkvh0ABcDWKgxktwRHxLWh/1qwrurlIJ32hi9jqUOoX2TUDQDkpQjqWF6nTqEXRJqarjzPnp3PP/vNb3zlS9f88pc/3iVZCDW0ZSwtMuznaOZz3Hv6+FPkImJm2yoAACAASURBVFKEBaKRfnI4wHaS+H8+7RUvlUEZXEfK/OCax5O1j663xXGH8iIo8YoAqQeqnSVXDrtTxUYeJFVcVazP1v6L4KkE1PqboujbtVjKMgkFzjnnj94oOvTW5Kaf3yL1soc5g/8RHVTZe8HeIfzR3iWpDtjaoUpe/K7VgW16hkfJM8B46MDWU1QGl2+6AggtSztkbPV1YgILK19pLbH2UZSLpOcaOZDdT0G15gku/Kg9uEZs96lVT/zmmUOpifGao2MBeeZw2wUdLdx4QV61Up7t40cnN/Gu0QKjb4GhgC0Y28blF17z2RlTJv/VhPFgEWVFPFg7MHYAROplnwCF0gEBHp29sjBMANG02XO4OGzVAyu5qr5bmCj4qu0V1hZAk6vYGZhAw6aaTxlaQafU4YxfmV2yu9S72hQ2gJ0AW7zkEfkMjO0UYWkhRZgrvmynCrBthxQBwFb6PbKZeJlTIuudc54BYecI9lPOxb1wDdxigRHVBU8IKutLayy9gM1SPlmZJCxsYydh2luCLTCa9oxxrupg5R6iM+4T92fdAvw7xUvEXvF7C3CLzrtP7CcsI4EwCRtjOXXRni/ygM5Y3Z5hbxEZCDSzALMA/XAPRTtLHgZULEfg51P+DEVrbKeypZpXeKkAsMUiQNGi8nlD2qFAW/XNfr4yripHIYTCc2KoWtceG5vtDDfNqXYlMKaUwQcdcNOlull88pnDYwY0yjIYILtugNqBrdoC4F+9ZKi0giGY+3d37PreD3/y3au/981rwVZUA7TFxWIVGtr00emXCny4KFk0OZnUvMuBmz7vjKELpQjNwpqfIgztgoXSB8mD3frU1uQRCYNLZrxiMDScF0MR2OZX7zs6L0sxx+vi+aRYPiyupse6VI0J9MQDCzEt/p3OuwxaqEqJRZIgytrvn/06ao5/c8e9CsRM86vfLcmQ1bRnkDLKBnj5FiCQGxrYaq5VLZ9d52Ou7GaVILVaER3Y6ruoHMyG6fp5psOG7TUjuSFzxd1C0OzPSgd5aVAJHxQQ6xuwlUb3tYG+/Rc8uu2BoqB5OBUxnjvKFpA2M1luCR0tAi3g/YXoiI/Ic4XeL27RAi8aC9QEbC/+2BXvmT9z5oXjhbFtEe8DYG2bCCTQJ2t3TT0nGFsBaV29As4EpA2Ma0wmSXjbzZueTDau3yAgSYAtVrRzMRbADMCLsIe2GhdAN11cI+nR1Rc9IgDcCmsLgINOhlPvwEIK0sBQwkXV9Jmz6Md2zrx50glOT4Et1hmlkcekiQfv+PRBK/DUTYEtgJnkAUEBcH+G94WQFeFk0UlrKFhuOfYHJVDXU6l2NKhOOtWo3Xt6PcpDeYL6+gWYRWCHPll0x7+F4aY8wlfW2X1RfAYwsEV0sIN6iIA0Q2O9q0TBwLpJFhCQAQEt1AOCRuxysOr+Y1Eo5IcyErr5Opj6LlYfxgogEQCBchQDw2mgBTK2iiK0nNmiLTVy9hyVYTXpARk4pKn1C7alJpaDG5UipIw97OxAHNrfFOgTIR/o2tf505//4ifLr7/2SrixqdXLwbABbfi2WDjpxL1ScDAlYcUwxlQX5Zxw0tJk2UlLaP+OXR3JStHR7hL3eNlWzoqWv5Uq+dcMglkeLLyvs99hOiEWTOt/AFiL0gENDWylMzCZgtaQIU2BMaFbestD1dh6Aq+QMLtYVHff3SuSbVu25duY3aYC7vnxML9G6Sr207ZYBKZ5e2fPxAcHedmA1vWyNDJ8Gb5uMxuG11RlcO1R5lQlBnCZ6lAg1wqTDiTtIabAllao+964gYMfXb3ld+vL61o8OhYtYDral0veFttLBwMSuO/KVpuOxYzHPEULHCEL1AJsGz587ifffPLSJd8fL/5rm0WGoMAW4A3QzUGLAkC4hurqkUhiohXds7eLwBaSgZX3P0QtKcAvOhEGVcDLmJpRuO5S/61kRiRJXeCjoJY6WzB2YgRKCvASJnBSQERJgkQggyeE45eeIMB2bjJD2B0ytlg8huvQeRHgAbC6NYFh1AQoi0oiFIipxlY0mZgClwVHyAMYSHpmwG+mFfRFZtn0qi6Ck1JVMDHKdOWZIhBO9TgO8AHXTfJP76MMNV10yf2VFVeGFyDT89kggwd2uQCnAKoA+ub/low33KUBMCPMMdKAzREKWXzoUsIBeYL5onWwCnuAee0TLXQ3vFoIsMX9Ndqc7qqvdW8IZjfa2EMXk4hMQZCy7Zp3PQgmVm3BnawtjKNAXfWxeghlxsCGkhQsIgTLq0MjXVBnsgXT5g509XTeeNutv7zs81dduomPPu/poMzLgYPZIqiFKULkWIkiCw1z4cQTfyNZfg3raAHHQCd6ymknizSkhZ5BVq9ak2wRplaBv1WOFFRWgqDyd4DDrOzXPCw2Jj0YzVVjWp2xzf9eTB+jMs2bs9H2RzrAS5nqEmvl0mYyPvOB755zfBqTysTZOLkh8tqb//gctpVfiyQB9YJnsN1aCiFT6WZJ253l3G0eGHXYwFZvnMH24L7ePsOpfi8E8XUwOKh23/Rauw/NEEi/vIbwvMGArbWxtJ6FQw2+cwf+bX//wHnrtz/4aHkdi0fHogXkeaI2ILjCKWgaskMDDR3tc2MxvzFP0QKjZYFi7+k9i2tsKUV459vftfAPX3/OQ4g+1srFY+rqC+5rU2BLACg+UqGlFSnCXnFNtHtPZ9IhU+vzFi9M9kjkrQd/+4B1U2BZNXqYOlg3Z+Dozgy4kmWUl78vIAO46ec9dEpbOw5702NavKk1OW7WTHH3tVikCPME2E5PJhqwBWOLhW0Kag3gEnRlwBYdKcGSudXCvX2qHMAWZRuwRWy+mh/MM0Cn5tkZWAVtdBsfdOz5Dk77akYt06/ijxb2VIqSU/AG/nK+qngPtRG7foJ79nqWnvqhZGALkS+AHYfvYOiaCQjp1QDsNrxIwAewfMegQh4kpSX0bqBVAt4UAL7o5qt3PwEmgnHA1RfAJEAkPzEg0VGBgnIAW9KxGJ3oh9pHGVv9KbM7BxOk/rVzVnCqkeTUgDrAQf4ZVIKssz4rSCO4chsVUc7v6+u55d777vzMFZdegCm4WhaFjRig9Qa7cMKJ10vW/hpl8bo8Zerk5GVnnJZMlk+UY92a9bIA6onAK8ThNPfhAdvBkHnNwNagHIGSVnduznrWCmyJA7HS3waSqOsh26pyJU3c2w+e/Zx5s5NXvvbMZPOTW5L77/1d9rsXzupizqoGbBUyq80cZA8OaMNUMrFGEbhaJtImXw5sNa1KVjYnAklvWAGKffFYCKAtvUHLYMA2RdOaCdjgZmmt563d/OD9h1MD47WjbwGpuwvlrmBpx8suziqSh6QObBz9nMQ7RguMPQvUAmwJbr929Te3TGxrbkYwgWZh+xBkSt2EEgGqXlQACBaJ7e3JgO0uiUKGcK3wVLBFfFBu3rSZelASbdTV4h3rDJ1mRxd6KaPH4AzmugrfdTZeuyZ8R6QpRCprEH+sU8UrwuITTkjmGmM7UVaYN4omGCwlpQUGBA/sV8bVAzNkHbP5+bQOkqwtQLT8zchnxkbSQ4P8hiheqR7X02MRtGvXXk4/Q/aFjA0HBaaVYweu4C6c3lQWW46TidIyazoKmuhKiwMDA1GQUECzS0kI/AdrgAzqUiklEKbdZApwIQapgrK06jpN3YnpPSCDwPW9oq8FW45rqaslsFXPBWRtyawaukG5OCAxFs7JWcBaA7f0t2vPj4CegFYXelGa4h4RaA+1H2QIBLUWpIOMLbGsuhnr6+9d8cDKFZ+69KIPrUS1sH0wt10jDmi9aS+csOyfpDyX4e8WWeh0yuknJ/Pmwyd6kjwpdf9RYWkxWBi5rQZga/Ws8sx8LsrgVaUXA61/fDIpu6zppMDWQH04sNOKFVzDNlEEmZo26zjGRQ5sC0AV93nt618tgVhmiNb2vmQHwgoX32SaUlZAA7aWUQ60wq02cOveQiqfHoEsa6tuufR03Jduzi6H55XdPwO2Zm8DtuG5tJgD12qVqjA4kAd1r7y7/mndtpV3jVw9jCmNhgWk7k+X+5wp+zTZ8Y4TLyzJo1IH8hV6NDIT7xEtMEYtMBSwBdIhsP2Xz37tP6ZOaD2tlcAW7B1wiOnSCEQB/A5w6roT4BaM7d7OZJcsgoJXhEVLlzBs7Frp2HvEhytextR42ouZk/DWOSizID5HBSRRCiDsIVqtLiADSDKpgqJDad2yUl8Y2xmzZwuwXUZgO236lGQSvSJ4h6OLzrCeiYEKDJhaN8QPZ2l9iZfiUnV3RKYQ9waa5mFjmuA1wQCv5jJkoEhI8Rh9zoJpRZYJ7AKqCzbAWe4ZAJcYgHVyhswmU/IcI5dYRAV2V+xBbw5wt6ZT9gC22KENpqZZkKCEe6ULMQw0lHF1/7hZCE2vp/CEwMVr8izhnQLeEOgzGAAYuloPisBFac6BGRuL/EAuwZ4+8EhBO7JwuuYHTxkL1wzY6oI2AGYFtbyc3jGgcUY+lB3HBrZWtMcPrn9izWfOP/8f7pZDoYa2WpAFjofMjP6pDygzrf/tphjW54IJy94idroBvmiXvWQpr935zM5k1UOPJLvFL+3Ib14jPGVl87OGHQDRQiGLeTlcYOvppYxtiSU9xHIGznwAqPWC/8eCQWtnznwymp7VfqTfIoFM3vRfzuYMzC2/vJV1NWV1rY5UMqPagrIp+cwCbF0l4Dg8I2fVkDW172XA1sE+yxVck9qqADqrncM8m+Y8P0g2m5WkHT5fXlNX9zuZtvnomi0P3Tjy9TCmeCQtIM+/TdIHQ7vI7rNBPh+U54pwkHGLFogWCCwwGLDFazTzZfuZL4lnhCl/2QadrbCgElWXgE+nComsCPB6ZaFTp4DbvbK6W4Ht3mSHBCGAq6ZTTjuV7nlWP7iKmlJddYRpewWrCua8A8gDW3TX0Od6yF286PsJEKGzFcAlYWHnygrzpctOTObMnZ1MnjIpGd8Gf6tgCDXYAjpL3AfhWFWakA1yMTtOwGwa1nSakmypTq870Ertx0w7m2oAlx0nzodZMn+3ztIwpEIQvdDvo/pihRYheMV1lpoBlsyrKO8DUMnFZ8puI/Qt9LSM0AUgKOmRrZXp+ibX1Aqw5aIxC2Lgi67wt4P3ri6AWk0LG5leLPRjYA7zcwlGWZ6hAw7FsQAqWgIy4sbe0lsCj9vSJvazyoABpDLgBF2OmZsvnA5wS421ShHA2GITd3FrNm184vLzPvL/3YziBXs1/ayfEwJbN3WIDIsoMWgqtX394meuO3vlylW3wOsBIoU9svLR5Omt2zPycggAMtRdUpaUOKwMiVV6RUgZ1qBuFe+TB8PZr8NhbAuVV/90kBmwvGy1zuqyRlg5fOSG564NKD2vCPjw++y5M5PXvO5VybPPPpfc+R8Y2xh7GaZnx4ISHSKwRQrlUgQHxZXAVqVDOYY1B4iZ4zTfnv9qdcA9IvIaw+FFVrfsWsnDYzKg+MjjT6/8yVD1K/4+tiwg7Qfk0ktlf4ns+P6s7L+V594xtnIacxMtMHYsUA3Y4jgaUcrYXvzxy/90yYJ517UKKGoTVNso4R3pyxadD17eZOYE2FJjK35Zxb3XbunYO4Slek5WfO/du1eiabUR3CJwwxOPrdNIUwYlVC9r05DsEBUAIQIZXH651wWu8repbDCJYCzHiauvpgkTk6UnnJgsWLAgmTV7VjJ58gSJkgYQZuyqpKkRusBsAsTaav2UebXf8TdAurOzDmytg84ReySbHI4qi5yxvRkTRVBMtlYXPGmvXYahdAEMT/EuDwDAOnyCD5MmcCGZgWj62hV5BTW1xtIeFJuBRbdekxHiAGzpogt6WgbYUIAKQMu8kSlDtDFJR6QI3fClC12unNMEl2pcMKayBUoG+LzUBth8gR6zy5FEJktQwIuzbIEgxzUKaNUnMrSyKscAcHYj4BkDYGM2oK+vd8PmzRuXf+xj//sGYehCQFtcIFb8zQ3uI5niAzhsQCvlg4udV8o+6R/+5v1fEslB+xOPb0yBXXqDEQS2XGxYYPycfM6Aah6y6iCpWFyFlmVAeTBga6O3tL7mK255Ffe24K/AolwgBMIOgLPGEDQMK8LLJNTu8UsWcgABH8AV0/LhAIBvu0rGtjYZgtbdLL86oAvtXwuwdbBuDbMiv+WMrd4bL9q0+tTA9Er+NsjA8BPrtq/6hts7fh47FpC2sERy+zLZW2RHtDd4Oth87JQg5jRa4OhYoAzYIidAFrkFZG9961un/9Xb/mod3H21YEU9gAh6HLxsgRR1fp96zr0CbDuF8YPLr47de5LnJfDAPgG5vTJdOH/BQmFa5iSbN2xMntshg08j8sDkKugxn7PmVghEHxaMQZLgjCskCgzfKsfpGkr8tk4Ufe2Spcsk/QXJceIRYeIEibYlwNbZUXV5pdPaJA8ZQEF7Ry4SM/YVvytraXpegjMwhb7aPwQF2s3peisTF0AbzM5TuZgUoKJ0ZKLEh2TwrEOdYn4pm/ZlNLEthQZ7iWPueQDJuCsvyDS40A7SAzC1Bio5WJB/9Hxg/ocRoMGjcjlr6yAXNkbkK0SIQyANAEuc0whWHNIFeFQACKbGVuUVZI1tgMO/TbaB7MOObmM+X2ewsECOYFpBNb8bY4t0DwKU49kzBHHPlic3b7rqU5/40I86Orbrw6iNqR0NQDtB8gJn6PPsca87adbpHxApx9vDJn0kgK1rq3Gf3NS+VZ3s/t7Mqw2omAIHkhVbIVJYsfankw8GtLL6bA3bE/TGACPZGIfP3ZlcA9tFYJteHrC4Xl62Pakrb3zzHyTtE9qTW399e7JbAp0wKz6TlMuws6Np02fyPFpS9DL7KdPs6VRehIF2bguBtbYEvafNVuSfXaX5w9+RdC55W+iZPnvak28iCZtad+HarQ9+qTzFeHQsW8AGydDRImoLpswelv0xec6HPQAfy+WOeYsWGCkLlL3O2V/Y7qwtI5D9+t9vuWN8c+NLGqV9NZBtxeogjdQ1YGCqH9G0hGHb29mddIK1FaYWrG3H7t1Jp7gAwxT5aS97GYMIrH5olYSVlQhCZJ4YQ0jLJS9oADaVBgAzCyA1BhWfWCxGN2EMCSuAS5jgaXNmJwvFI8I88WE7DTIECSYB7w3Ka0IpoYwyAi5oaFNlbNOFV/bK8AAD1NQaED5wEL5TM7+1fp2CxozpSplLm3736VZ2PCiMki7yEUggUiYYSM06TOdAzRw0M3ECFuiZxhcdGPIPe8gxLBjr71eds4N3Fy3g/nTRZW694EGA+mZjRwEuM28IGpQB0dDwLMExQ1PbVC+MLQY0FtnLWVVCJfPrxU7VgK0PGvJBGrQcBDRkae0T8gNjbN3NF+vVgQPPbN2y9XMXXnjud5566imsuKoF0PJxs3+v3L3dHHYHIeVsksQQg/1ESxROVRGDfc/CCSf8rZTjunDQgnMqQE9pK86mr8PrFbx4DbNmMggaC6FsdptsdqF4a61VwwO2uEIHpMVNmXpubukcsK0EhhxM2jWVrGUlIA9B8YSJ7QJu38AZhlt+dSsXG7I0Op2QbenrxcCpjT7dSYcOsIpVRFt4Ckj5TU9CntVfdWA6TwC39kFciYUUpFZfjBZekrHCuCYbKg84sLWyyi/PygmXrNv64PKSW8ZDY9wCUp/g//oM2TFIxoZoYYgahuhhcYsWiBao0QLVgK2DW5ciUGt74w03XTxt0qS/axAZgshsGZyBnS2BLcKcaghckLedAoywkGxvFxaR7ZPFZLpjURJA0UknnUg/qY+sfFija+mKMJ26JWBTWAYcR6BmQFdlCIiA1SyeEJoJbBvbxiczBNDOxS4LyKaKDGF8W5NMnyvzRzQE+QFAH6bolWc1YGvoh4DT5AnaaymwJZsr+k4CW7Uq4YWdH9rZgUgavrcMXcCTAf1gYdfO0Tcjjf0OBAec0add9M6wBV2BKf1L9kj9vKrGmTIKss7Gwclp6HwJbOnSSzpT+dTIXh4TXr0LIC+Y9oebLy48k2cJYMugD/SKADdvFrKWqgHt9Llozp4bga1TciCY+bzcxsHUrQNbglvsKm9AmgJwnn9mx9YvXbn8gq+vXLkSobjKtLPFY6MCaLVqDCyTD0wRAtwiBvv9ku/t/hwXtCxbXNc07ol8GzRJSU0NU+sEn3kACP3SEPilgNeqkQ+mqt2m3LGUjgR8ywNqZeNzANFOVL618hWiz19nF8rah047ZLIjrdkuEdArUuaWDCkWX1YaIrQDgja8/KyXMSrZPXfexzTKpvUzoK3eRvTELJduz/yP4b198KmLNzMgnB1ny2PTKHu92i2rAtvwmhBoa3I5fT6DovA+HdLOrthb17B827YH4PopbseQBaR+gzjCIPkky/bT8ol3yp5jqBgxq9ECY8YCQwHb3AKy7373x398wuIl32iQV7ou+AH4U1DDVcxgDwmsRA8p7GGffO+Cg3/ZEVIXjv77hdmFFrRNVjXPEZYV/m3XrX1cFinJb/BVKiAXoXfpkB8r8i2kLvpKTLUDkNYjdKx4QWhsktCxCCE7YUJynADa2bLPmjkjmTZxQtLeJr8JLEdYB+pyHdgC9BnPSmAYPooUHKBnZffK/llD3yqDTJBGQCqeBpyVQocjx+mn1TauSzPGSMGdgRXayYlHTUcXWWXgQt2LZa67AFiVzVKNbvjQ6KPXNMg4BTIE9+BA+O6sLLwaWFCFNJyuzW1SZwtgK/mgmzB5VoggB3YYxxGeF9pcBk5wIArAwfRRhmyxnMsQUnCbM7AZR65Vfa2Ca4bTZV6Svc/v2vkvn//cxdfde+8d0JS5oQZz3TWagBZ+u8CoTJR90Bjs4s/2aSnPLK8PqRkGATvFt0IR3KVpYeBn9jsUYJvOVAS1n/mzvBWBbXhfbQEO4orYVQc6fB+4vjssFOpMgKCVcPQFk+XAltnC7rJrK3s+Wc3Py886XaKSLaTWdrWEJw6BbTrgwh1R50qZZk01A7d+d3yWoGC8SXJvUCu/23JIYKvnVwLwLJ2MrdX3bTgEEfDcKbe4uq973GWbOh6Ki4mKDWiM/y11Eg8ag2SA2mbZAWSxMAyhv+MWLRAtcIgWGAzYEhfJnnpGeP3rX99+1fJrHmscV99GYILXvVKKxi46uE2ote0TcNrLMKgH6d+WrqgYJlcAq1wzUaYQJ0+ZSJnCjh3PGaOqWlGG0EXAB+g9AbRkMRMWpBE80j1UUzJAd1USNKK9PZk6bXoye+bMZKYEZpgiQHd8W7OAXtXRoi/F/fCd4DiMS6nITDs0lIiFso5MSVV1MeYdMopLVlLZaoJ7dLbpZQ5g3bT2C64J7YRcgYkF72OJY1CAG2r4WLUBPBsoYFbwBwlI2BGqf1jVCJOVNn+78PqAZwQwqy66dJEYfdUCUHKBln76lC3sjYGFA1tYAYAWgweAAbC+nD71PLAOqC0cODiwpUF9Ntrta2AMPyE9B2fi5qx79+6dX//a1675ws0334gO2gEtH13wt3/3Hl4fQn63h8cclMHqYTcVKdskuQiaNwBV3PMx2R+W/FeNwS7A9itinHeZhbKMjACw9QK4/YoFKkogwt/x1Mt+D4FtPr0Miep1NnuApoKmiFqUlskBmWrUKzY/j+0HdSDTq/JhBQND/Wrtkk0pe5TOSoegz6///Tf+XjJ9xnSG3H16K4gvTVeT8/R0sWLFlmF2/lQEnByn5mpUHtj6DAYZW02g8h52RMeUwwW2uDhdEPp5aeGfkGhhWCUft2PMAlInZ0uWMUjGu4WDZNnXS50YkXfWMWaOmN1ogRG1QLU3r4NaX0AGSQJ1tvfcteKzkyZOfCdW2fuqd4UWYEaV4QQ7CmaWoXCh/QRI46cAJzCRtoALrM7UqZNEb9uUPCu+bjuEvT2ICFmSnE/nY3U/gyMA5CI9ssLoYOqSXgJD9cHaJnKEaZOniL52cjJZFpK0SdhS+F4lNCeDpACcWl0AOme88LN2YwXDGkDlZRY1C+fw3gZsvcMtdJz8HVSqMcPs5kwoS52s+fzFfCXdjgEYyyfdmQH498mCKVm4BY0r8k79sbGtiBLm2jwAZbK5BMwAtZpPDxqBjhOBGBAxjMEMzE8sOlwPxqDslZaf3hAkuEavaGwxCIF7LwDbJvN7q54QAIy1Uwachy9jaqxNR6Eg3eUIQAKZWcnQehAIvWffnr0d3/3JT79z9U9+8i100NUAbXjcv48GoAWLcrrscEiLB/qU7DXFYF8wftmbhBm/aShgG7Kyh9Kyy6bbBwO2WmULfaex7yEbm+XFI8llR5j+EMA2CzGdB6yhVEK/Z+2uEthazbS+3oFlBgorLYb6isVkrRIc4/ab75Qw3kpkqpxBB1Na/Oy+6QI2t4v9VGbb/B0HAbZM41CArb83vOyahg5i8B45cF1yYNwn1u1cKQvE4nasWUDqIWZ7zpK95kHysVbGmN9ogaNtgcGArYPbnNuvb339e68886wzb4QUAZtLELS3wItXV+rDiwEAKcAavRpggRMXY0GPC4CJ03WKfeq0yQRgzz3XId4UunTqnwAN6ek1dPdFlhS6WbzpsTAMABgvfISIbU7aZEFauwSBaBUfoi0S+pdBBFJGUsGWywUUHGbmVwBinQi+B9PrDrLZH+ZYyExioEXX8iszGyRuoFp/R9k1ipm6HSOMp0YZQBaAEj5/e+UT2l7ky1lTdbOFx+G2Vz2tRkILgK2xySg7XXwhYhjcfKFjt6l/FMXBPb5ThiBgGmxtv8gQwBYjQlyDPBd6Q6DvWgPVBMMZOMqijTmI8WllBbYot3FT1kEn+/d1dv745zf+cPl3vvMV0GpF4DqYP9ojDmhpj4EB6N0wRYgBHWKwQ/M2LHZswYQTt0odE/mCC1E4Isi1+cFAaPHlUDntnVaF7NQi3+O343H7sdo5ZW8jDtqKF2QnZgxwQTObTnFkpddp9wzoDgZs9Q5s6PymZfd85LWn9iRCfAAAIABJREFUzu46EG0TUPsGAbew7a2/uj3pkncK63s6iENSEInnWdliJMIQ2PoAJW+icikCgTInRDL3fWXPksKiXB78YXn5snLKM/h2fd3AR9fuWLWx7DHFY2PbAlIXoceHLh/SA2wYJCPAAiRXcYsWiBYYQQsMBWzxew7Yyt8Nq1evvbupoUlYLJtyy7F0BmABtIxNROQw9WpgjC6AmC84kgQBTsHcouPZubODvnCx5IseADg9L+A2gEf0ZQBgy4VYAK+NyUHpRJrF12qLAFxMnTdg6r0wbQ+7eZjObNowtGY19siiZxGlYdcFLT416/oF1RtrevS8wDIH0/TU6mLPdLAEtjhOYNvHcKuMsKYiXQLKpiZoXLHASxduaVha9UaRA7bpvWSSUsqOxWIEp7Z4zIEtV+dTRqCdPcrhmuZeAFuAajkWLhqj5wQMEvCPAEFt7yw9i2E28UFBiKls2nqgs6vzhjvvuvmKa6+9YhMTKZcaFIGuon+1ru8wsyOd6shrmI1FyrBALoH7LsRgx8I1dD6HBCYWTFz6cbHRBZ5RBTJqlTTjPiDMgUenDHFiOZjL2MDqrGC+6EObqjQlAtvqG64pss5pkfyyXML51DgATPGrSXrsnmqq8PcM8IU5cimMAldNf+q0KcnvveG19JQA5hazEGQ9/Z3Fd0gBjBeY7FJgawM1jYSWLR7TSunDNwPMwUikUpVgUhwi26KhTEOtxf+pLKw9b+Nzq9YOsyrH08eIBQqD5F2SrRXDHSSPkaLEbEQLHBMWGAzYogCh2y/X2jbeffd97505Y9YF1Koaq5oGA5CLCGIVr+n0uk2Vg8V1doU8Ds6DGy68vyUteDPAtmvXHjKW7FJxDUCe5NTVfu60yLzdyFmSD2EVBWzT2T99o8qUfRD/QTtfdpgKijO20oBG0BsXO3IysPY4ISNA1DQtthaSnZqDWpYdbsWU6WJHagBXQ+9mU/Up6LUBQE+feIeAFAPuzyRNgNpm8fygvmbVJZdJhZkOmFpdLIZFYw6GlYmFZAFAlMDWAzFIGgT2Ani54TwDA/BdCylCnwCB/bLwD4vGCIxlBV79uEa1Jw1u07kBvnRwkgFb7eZT7xDyV29X5033/vaOyz73uUvWyZ8OXAdbFOZAdjBAi1KMCKiVvE+WtBBg4ThUYdlXy44Y7CVi0dra9vy2+XPGNbQEU8buGgr1J8x2iNX90QQeOux24TS+oqE8MBs8V5X3KJ5f5jGhFka5DNh68Th8Ckc43oo57sM7QH9UDKs2oTTHkCA/eTiYUXHcz0GevkdUakCYnRZrxqzjGJkMC1Rvv+VOhpdOda2ox/4Cqe1x5s7SfOl7ySthuihVDoTscLl0QgeJZTpck1n+Sn48b/2zKx88hOzFS8aABaROzpdsIAwuOjYMkh+SerNhDGQtZiFa4AVtgcHoHu05s0ANaRSy97733Fnnnvu+R9Snjb7Wlbtjr6SrfVQvQNY1dZslRwjuyHxqoAJ0gASsMjWIjmbypPHspDo69lK+AO0pAyjgRPQQuh7MsqXAkR2UyBHcF677SPVOI9XIGqGqnSmuw32z6T6cx/6Una5lDrfC/QnUlKVk9vE3y4j84RT1c+t5deBLvSuAqnXkvJh9osJ03JOSDQZWUAkGOuhGkw+4/1nILdSPrdqQ1wgIVjmH3pegWZLH9Q1NurCO3wGMHQTRVlpIZZ3UtpA/dEkYZCweQzng3qsRLDElCJAyyP1tUAB7p7bS8ULKXmsW9CDS7enpvuOBB+69dPnyjz9CY9XG0qphFaWEiKyIBq3+HfqHlBVRfdD5LLZU0PGMWAz2BROXic42eZOmXQ5sOe9BTBYUTytMvmB2TI9WA7Z+TbFpVwLbkIvlzEeJGWsBthWXselr/iqu9wGktwdri1okH7pmKaaaWLY53ZxpdaCfAWv8mtkMx2fNmZm8WsDtruc7kjtvvSv1Ay3zGYcMbHWuI59fta6/MovA1sB77pG4D9v8cxJQe6+8QM9d//yqe0seRzx0DFjABsnQ0SIaIbrDR2VffTiD5GOg2DGL0QJjxgK1AltfRJaytvf/buWnJ0+a+jfZGk4DVlI0rJtyl1OEvAh9a/0NIaJ3bsbE+LQ9OkIwhe0SNQzAafeefQLYLHKVo01HnriP9nLpFKP1NsrKQEOHzgZAG0CQ4E+BJME0ABjZU8cPmseKBSNgjwjWFQZoLAJHc6oRZnpEdAYyGX3MbaD3SBerAZs7QAGgNNZVPwGsBdQKqASQhC6WgTAIEFRGgWAVKRiGn1kB1KqxVQOr6y7zWRuEqE3D39JeGAQQ2hMHuAeGbgmqwaAMcphRyqitBfut2lwFFNl0r9pBDejPVLMBQNv74COrH/z0hRd+8Lf2qMpALY4VPR2EoFYTC9FK/vshNyTJLwpyiuwny456fURisM+fsOS/ywDip5pRX7xUnN7XgSGBWlmJvPH4fDbsbQxmVl+LVw4NbPOmrB3YFhna8ixn988zzfnHmQ4y/THbZXlAjHrqYFLv5uA2rYM8mh8guNnmzp+dnPV7ZyY7n30+uevWu+1dZGw3G7W2BX8qFe+AqrUs09gWga3mjzlNSdl8unnGVq5/aNzB5EPrn18pTG3cjkULSF3EYlMfJOPpb5Qdi017jsXyxDxHCxyrFhgK2GpvnGdt6R3hwx/++Jz/8a53rRDAJH63rFMBCDR1gjKcChYdx/p5ZZ2WJqGdM6bg29sF3ArQk0VGKftr0FLJLWdHcjSTMSa8p34nqLWpfgBoaFn5twV90GlMZxz1MeamQuXHcUgDq/8NCCq5pl0ZQ++mqN0AHrwdeHnQadKrgWpTaUwCf7CuGlghTIPuuTD974CSt7EwwADC8Fkr16o7NJFFMPSv5oEBF6Q3dbdeWGgGpQE6VJ2mheN4Bad4TuhaIQVBxDIEy+iTkMdwOUY3YZIHXTSmC9aIZ4sukuSeZKMJtHSgIP5vH1n/xJrLP/zh/3WrHHIwGwLY8Fj4fVQArT1fsLPwdtAmOxZvYIrwySPViBdMWAq2RgB0tUhTqICZ3KUWYKXDpYwh9HrLo5WCTtbVocYEw2FshwK3xbCzWZvPs7LqPcQIXkLLDKCHgBiDsWLZcu8Rv0xfDoXtYLJwsQZw2CYuwO67a4UN0PKn+f1y8okqlULPLdfY+iUOvr18FcAW7WlgQGYy6j72xM6VNvg5UrUwpnukLGCDZAyQXyo7KioGyVhsikWncYsWiBYYZQsMBmz5PrbdGdtcJLIVv3v401MmTf6bNM8GcAGeyJA6og07Gl8sEhQ066D0RIBWTJ+3iS9aMKGYIue0v1Kq6ZXgmNhZoJNJmR6gRg3Di0soQ5ArNCqX+aMFIJN0NQStMs0qK9DN/coyJ5BMyE8EqsbAkORhdkj7sjMGsHT2GvkCw5uytIoueZ5IVQkoVUoAkO33k9+kzPBiQBCKPo/3x42U/YVGGfpX+tWlphZ6XA2kQNYJl1E2IBIE+qy1IMUGbn0KFQwsi4N0BSgjGAMWrSFIBiQSyEeD+ACm/1vsWGCGCzyQAp+R2coioYkrtsc3bXp8+fnn/8ONPT09RfA6lJcDlx3o4z8CDC0THhiYLh+YIpwqO3zQwhctpgmP6DavffGfynP5sa+Cd+ORuOedffTn2SCFqM+oSs4yYDvYWeHFeqdSzKvGKb9TleO1AltPNGNW0YY1HzqoNGBreSsCW2bNZE0+O5NmNMxyEdCGhrNBw5Jli5NTX35K8qz4zIafWwwsq20pCC28c9InNASw9evDz7ztx60XO3x8w3MPf/uIVr6Y+BG1gNThRXIDsLQYJHfKDhnTERskH9HCxMSjBV4gFqgV2OK8ohyh4YMf/ODcd/3texApBa5MUuDHzgj/rONJGU7+nXVkGckS0i3eQwHo1Qm4bWHH1tml2s/sPp6WwjV0IJkEQgAbtKiyu742DbJAcszcY9H9GJhT81IATGxAN2SDAGxV9qBgMGVi2Efr9HEqT2AGAQSFTbVhgbOkwLcaflhtAw2x6m/hwUDD2zLkrRWSMgdoJuD9wPKa+gE2bxGM8OTDD/l0f7XwhAAQXSeZ5/0tEAU4YwmIkMkQRNuL4BeM/CaLx5Bp2B27B2agdEIAcwgs0qAS+/uf2vLkpis/+vH3/aSjo6MIYIcCtDCdo4sjCWjh4QCdz0JWTY3BvkrsPmox2MHaykM42aYbsjpbSS/mXi3+aIvvmzwkq3ZW8SrXettxVjRrU4o3K3ODAVsxmfDvsOnmjmueQqCathEDttp63CWWPf4qNzPVECq0tg6mYRpeXOrXhd89PwS22s4WSOjdVwhzu0u8r/zmjns4uFRZh20BkPckqzPoNliA3QDUAwa9KrAdSDbLVZ/a+Pzq6wYza/xtbFtA6vI0ySGCtmCwLC/OBGsIHpPnXn20NLaLFHMXLfCCscBQwJZ9iO1lrG3jb+9f+alJkyb/HU6Ey620f0GHmFIUyma6lIC9CE9Eb2AMjmli9ZKMiqlvqBO/tAJu5Wh3d2/ApuozyDoQ+LXNpA+6yErgpXgnyPmhhassc5NFvS3YXU7n63kePpfAXI4R1FnHR3wXdPPwjkCyzTpZfNdiIS8GOL3U7IkV2ALKaaQw2AiaAHXrRXdcKD3BNT4NcAvw1lDF6g/Y2WWei/co5QXa50PuAHCMlBA8AYan3fG7fMivJkdQ7TN81vbJgjGEL4bOl1IGhN8FuBWdLcPoIkIUdblZdZHBwPatW7Zc9d73/vl38OhL9mqg1gFs8dMbVfbwD7OZSeeDGYZTZYdPWnzfLjtc7Yx6DHZnbatTpuWFHQqyKqGvdStDd1m7yKeqptVrtE6kulIsoqwCYbVJhuMO0wMjnbTOF+5kTzHUrg76OHm+LSy1E1NpABY5OlzgzEdW1KJ9ykCougNT/To2yhLOfFmyV7wl3Hnrb8S9YCGAnIFbpl2V4qZR0iLpaea5IbgmALg7BuoGPr1p56NXH2a1jpcfRQvIOwXMLAbJi6wCrJfPlaM5SD6KxY+3jhY4JiwwHGCLc92nbeoh4Z3vfOfUD33kk78RMDU1VcjZi50vdQO4rsPMd+yEZoacgcocSIa2Uy8Bba2t7GS6xR+lTyFmWlgFduY6lgvDAAK5y1S7dsnmGijV1ypARFpIh7pb67x9gZn3n5hCJhYPgLv+ZoyTd8QODND5EnBm5SCjzKlXDZvLW6XAFuFuTeGIc0wycfCg+POF5MD0tAhqQdDr9zOtLO5DZwcISEG5QIZz9BGYVAHA1ha2IT8HJNRxv7C1ALZ9wtgifwzmQBdfIGk1DC8BBmUfAtgPHtz5zDM7vnDxxed/c8OGNVgUUQtLy9JaR3DEAS0hx8DAEvmAQ3R4PdgtOxZxbDuarVI8JDwoRkSeat5qBraskFmFqwRkXmts0JQCW8sKBz1lKttsZKuzGCnC5IU6U1/5GnHpgdYdvXfKsHrpwyEMdTwuX9ITvH1r+lneQkqM9gnSCV14pbMuDsqDbM5fOC8589VnJPv2dSa3/4eAW3mvpPIKy9/QwJa5tLJZngNfxfZIdsu757L+XR1Xbku2aaSIuB1zFrBBMjS0L5HdB8nQ0eLdErdogWiBMWSBWoEtsuyLyCo8JNzw85v/78VLllyjdKO96g1dpR2PUzvpAqSgE2YPYB0EvuY6aO1YoR0dL7IEbN3ic5XgM2BMSFqhEwXrSsCKsL4Kbh0MqlcE/139vtKjgIFFz6IypkZFecdt2dWp07BHZoa10ASUijKVu9Hws75hkZduaiQGR2DZdYU2wXcKtjVow37xUqAuw8wfcKqJMNkB9bsKQrl4jH84W54tSFJArR6AtZ8X9leAbQ8XjWGwoHkDkIXv2nFIg5HK1IOC2G7Pzp3PXnfVVRdft2rV/eignaUdzBft0QC0cLEDf7Qeg32VfH9c7Ft4aKPfCue3LT6zrrFhxXDuPLLANjOBD0LTQRLd3lk9LmSQOu+sFts3r9jlr5AMJOblCN5kKQ3IjfxsABa0aQXNfmOPFGjShXDQyOZk6RWzw6wbFC78Nnf+3OSsV58pbaA3uev2e5M9u5XI9/ePtc4hHlcG2rVl6xMT+c8+edN8trPjwOXPJ+tHfYZgOHUsnju4BaQuY7EpBqStsuNZPnC0B8nxmUULRAtUt0AtwJbvetuLHhJS918PPLTmRy2tLa9Fv0T3XeD4wtTR+Qw2rSe4I2RE+T1kSOU7WM221hYeR3SsXgloEHZEXkz6ZRWmth8Rz4jnFMwSsFKyamF6CXI9wIKWUDGfAs8wD1wc5sDVziEDy44wM3B6DX+A71fvKJWRIvRlOlkH6l4VwMgyn8xffwC8TWsr16j/WGdm1QOCsrTqEYHgmuQWkDP+VHkDl9Cp7oKgG0C2r++AMFUSRrenWxe0yXn1AmqbJIwuxBQAy5JY167nn//qV6//8rV33HFjB5PS/VAArWWM9hpRoCnPDE7QETFsnj0NLAp7RGwF/duY2eZPXPo5eVb/q9YM1Qpss3qmKZcztgVgm3sCVaQIqPdVMpvNmFQ7wY6jXTk4tnu65jV/pbcRPZpe4rM+TMfLF7DL2qzsoiDFNOOartskG5jWJTNnz0xe+VpZTyjnrrjngeTpbVCr6IUKbGurpp62NN8e0bB/fmBg36e37NkSV8XXWtHH4HlSTzBIho52iux9skNygAAzcYsWiBYYwxYYDrDVd72+9cMwuwS3n/zkp5e89e1/dqugV/Hl5wtCvOTaOdJdVpUNhJoDxBxjixsSsOm1mGpsbZGwuaL/BDiDNKHYiSuwRYhad4+lkgOCbkhc6TFB9bTpiuu0C1NQnk6DAuDab2H/iR5W59bzjA0zmV6jsIRgN+iHXUvrgJbAW/LCLNKVA/IrHg8IyJW5xfcQSHChmUUkUzBr2lraSSyNlWNqMZU8cAWcpgFpwn5ZKNYrMgTxN0tXXygPBg71iFQmGltJpm/P3o5vff97X/3cjTf+bCcTHRzUwhB+jiOCEBk4QqgNKdTYaKQ8cD93muwnyA4rb5YdsoMxGYN9enLihLaJA+vkscyqpYgObMNZgrC+6xhMdaf5mY5iW/Np/qy+Vsw8lEkRCsC2EhxWL0VF+v7kq74GisDW8oo2BJ23oVp4UnCXXK7hTWUOYe3ia0PbQ9mmkzLyPhnflrzq91+VTJw0IXn04TXJujVwWMC3WPpWGOpZ2f2/KJFOPvVk15NPD3V+/H3sWkDqWbvkDoNkRA5D5QGYxWLTMTVIHrsWjDmLFji6FqgV2BpCyjG3Ibilb9vb7rjv3ONmzPhn9ZyVT5pT4IN0E8ruoqexKVGzi3ohkD8C+hedCFjF5uYGAsEu6ONSZiWbzgew7YdLLfdZa9pb+OZXgBcwSX4/yhk06AIBKV16Wd7RUSKXKURTBJv+HbJGdlA7VvNKQLP4lKomRDRo7sYYipjQkBlVzS+OQQdsk5wEMOavtg7AlqDZZAjGcFOd4KwtuVj8cy2xsrXwg9sjbtR6ZRqW/nDlHyOUyd7Zuef7v/rVz5Z/5ztfQQddDdCWLRgbTUALwy6THaAWjtERgx0eOp47uk1q6LsvmLT0bVKhfzD0mVrftM5liK0IbHEGHsbhAVu/UyFXAbCtYIHZLqqPU4p5rgTSeq8UlHJAqSA0O4amr3IbNUH5Kys8PyzBYMDW7s4BN4DzGa98eTJ/wdxk6+ZtyYp7H9C2X8Mm+fq6uOH72LaeDU/VcHo8ZYxaQOonSBq8T06UHW/QLbJDdjAmB8lj1IwxW9ECR90CwwW23rOEkgSXIzRMnz698aab7/ppQ3OzaBzzSdcL6PKp+7JS52QLAbjVVBRAFjtu9ZjQzDtxUZmFqUV/RB+xws724ROSBMgO6GYLwFVhdjjVWcxTuPDEgYV7P0j1g9anEyQHfS6ZVfvN85yyzs48U88IaYQuWjsAFpUUsAHZtCzKKqf2oSRDXW+5RtcXeGm0XABnMLRqN6pueSvNED0rCKhFMAbxN8tFY8y63La3r+dfb7/9xuXXX/8FdNC1LAobdYaWpRoYgNwAK5Mnyo4FbPAdueGot6ZhZEAWkt0gVn9LekmVllgFbgZ3cl6xlqY8uOuuil8d1KI+lZRtMKBZ3RQ69tH6aIs+A9DusxJpG7N3gfu7NTVPDviy/tqA1O9rzUvRcOHdkc+bzi45PF+4eKG4Azs96ZAQvCvuWZF0dVZf7yVW+cH+gbqPbdu7du0wHn08dQxaQOobZnx8kAzJFRaG7RiDWY1ZihaIFhjCArX0hmES3s+SQ7UdwBbsLVnb97znfbP//r3/cIuALjjBTzecPBj/oW61ss1XNw8GbBFbHh1aS3MT2cZ+AWy94rYKnSDcfAHc9ooW1xeMEdSCgDXXYrhb2IF6EAif9kdnp4utQj6YV6UsrudYPTI40q3klVSOkC1HIdBleF/t5MGaYrGb/62eGTw9CZpg7rZgF4BXglt4QTCWVhd6qd5BP9ChK8B2y7pE44DYBWxtl2hrD4gkoa+355f33HPbZV/+8vIn7DGFGtrB3HapGiNPxocUXnU67xCaptgDQBaat9l2+cPyeUzGYF+ULJqcTGhZIy6gZmkIkfKN2p9C2whaCX4NZkLc3NWbNQaY1ZjTYg6ytlHlMaI9DfM5Zoxs/sIwT6k7O4JaB61WpkGKeGjrAyuHDhMnT0xe9XtnJS3iZvCRlauTjes3WhXXPEuz/Lks5jxvS+cG1L+4HcMWkHqHd8kZsvtiUwyS8R6MW7RAtMAxaoFDAbYoaghs0femrC2+f+u7P/6D0192xnftvNpM40wmO/KMIXItnXUphtJUsxr2902NjQS4AITd3RJwQCJ0YYdvVnpGwHIozuzjf8rSZBHG2F0REOtJOsWq+lsgQwDibIq0WCCkyV8d3Aa9va78Ru8M4KkrxFMo4tHQyNyCtdU8Oaglp8W01B7jAG5T+QEYW/VYQOBDwKvfVf1g67MDsE1gy4AMfSJB6El27e64/cH777ns6qsvhHPxWhaFOZAdbUALqQFC4C61OgWkgTC4x7T7pAUTTnid1Ik7B5vOr8bYahXLfh0KYGq9Y+yzYW0KODPgHU750w0e2xSFEFbvsldKCFadic2Pgcqz4oO7DNBrOf3e6SwIWpIxsun7waB29cFA8Z5lr0CdFTntFacmC4+fn+zY/kxyv0gTent67pL3w7mbuzbcPywjxpPHnAVskAxAO0d2DN7XyI7Fpu66ZszlOWYoWiBaoDYLDBfYhr2p96pF37YEubfdff/506ZOf09t2ZCzbK5dE1W3VNgI7gDY2IlLB8oTeKCCyUJn1NrcTE1eT3efRCvrkel91a0iJj01rNTPGni1TtEi42rgAyU6FdwCcLqFgunSYpkqgK1nHFklmHXdsOWbLK2xteZHl75rU2AbwBTeV+0B11vQwCpr654RGgxQqG0U2GqmaUNgXqarC9EQkGHv3t0r7rvvzosvueS8B9SoFV4Oiscc3Yw2oEVB4DcS/iMxIwD9LHS00NO+ILYFk074kBTk4mqFqQZsbZilD7iGzYHlcIEt5TKDzrUYuOT4jxUwzY0D23BWpAhs87/ppaEcAd+psTUQny7WZGUPCm4DwNRtYFWWeyhj5S0+Z97s5A/O/v31r339q77zJ2/74y9LGbcOlUL8fexaQOoTomRikAx9Ph72JtnB0h7Tg+Sxa/GYs2iB0bdAbb1iZb787Y9P9Dql4PaBBx/7YXNLy2uHYpOYvItI2ZExHIB2cnj7AJwZsCXQrAJsCerkguYmlSbA5dfezh5hJ+FhYJwBW/j/srTZaYMt1Rulbmatcw2LHXbAmURAS1YKbO1iRhbzTtaFfw5qcX8DtsrSKkhw4K1J6D3o5ADAVrxBEJzQxRfArQJbctI+OHCA64Y3Rri7u+vR1Y+suuLcc//qZklhuIvCHNR6psLHWtMjHk71FhtgRTJWJmOFMmKww9PBC3JxjoBbPI9zyuxztIFtkbEt5jFjZd1TASsj621W/TJXW9WAradbZFoJcm3Go7T+8AWhoFqZY+OyRwLYDgyskvZ5/pOdj/+HJPx62SGviguKhtOQx8i5Uo/QlLAoDJEIAW4xSIaOFh5f4hYtEC3wArLA4QBbmMGBbSm4Pfvss9svv+IL321saRFHkUNsaUekU/VAypQA6EclsMXx3IqzgMGV/q1eAGWzSBOwaKxX/LV2dYk8AZ4GSN+i81VQq9HA0B9qh6xTqxlOC7+HJVDwmZ3HdEqtaQyqly9ka12KkGptZYGdSR54r7TTBo5FOqqrBcitE9dcys7qp5pLP1OAa2n09/atXff46uV//3f/zy/l0FgHtJMlj6gv8CGJWKcPS7ngk/YFu82dMHdafV3bnfIAwU7ntqMNbIdibNMBXyq5qQS2+RLl9cQhqxvONlTawfTp3uS8rVkb0frvi9IqZ3NqqzzpYPoJwcjnb9637nuFNo+ZA7B92OACCn5NdfVl3MasBUoGyWBonxyzGY4ZixaIFjgsCxwqsGU/YncOfds6wE01t294wxvaL7/y2h80NzdjFXvVLe3AAdpSrseVBz69nkkRcD4DPgQlSNkedHZCzMLNV0Njk0TSaiCA7ZFgBJ2iv6XkAFPzgLYpQ4oO2VZI59z8ZDeoALwFAJyjMO0yMrYwloFOvZ/paFMZggaJgB9bbpZueg2ul2Sgqa2nrhZeDwLJgRyDITxIg2uU+/f3b9q0Yf1n/+e73/Yz8YAQAtpwcVjxeCg3SHOEXAUP70gwtAgrhzqy2O71oorBPqt96XGN4+p+I88cOuJ0C4Ft5QMogb1eJwuB1hT/ebiOMnQ4xCPFOC5XBcqacpafagNC1+sOJkEopqztQF305bbwT7K22aD00AjbuiflPfGJzXsf/2q1F5XkoU1+gzZzgezwa4oFZGslj3nEXi2BeHzULCDPKhwk41mtln1NfFaj9gjijaIFjooFDgfYIsPek5UXZN5xAAAYg0lEQVQxtw5u6885579MvOSKz36vZRBwG3bR4epmHjftHgGvRSjDzasCW+liNLqYLJZCcAIBrM0tIk+QwAOIitbV3SvuweA9QV1pKftaztiGyLnYsYasLQFr8Agz9lYB6GDAFkBWA0a4XrEwnUqGFqDEooxR3ZAtFnNQ68D24MH927Y8tfHqf3zf3/9gx44n8UKvFdSSuy7ZvWRHAtBCO3uy7C/6GOzHjV80q6W+6c4Q3BoXT/sXgaW2maJnAp2JqLYNxytCWRqVgLX4CjHWswBCs/oPyU1+MVrxPuE99DrbA3bWDJJeytmbAHznPSQM/pqTrD4tr5WLnty37vO1voUljwiwgdDNiHgHqQwc+G+o9fp43pGzgDyb8ZI6XHdhkIwNXg6w2BSuAeMWLRAt8AK3wEgAW5jIex9nbN1TAqhEAlwBtxMuuXz5t8WFDtw1VWz5RS1ZFDKeaMCQkoSAiRoM2A4gwpiA1j4EZ2CkMcmEhIuF5wT6f5XeDAC3SxaZqf5AAztUglcvXl6i4NhBz1cgEYJb+rxNF41pGdJzCoxtEdiGD4WML4AsPkSKAIlFCO7dxRfOk/vv3P70lmve8bZzwDiVsbJlrruQ+eKisKxQ+qSOBKBFvThJdoBagNsYg12MoOC2RcAtPUAMupXwtTx/MPdhIw9steWGkoQUWGMcWphV0dmKA3RTR5waUKuZLCGrcmirZcC2yPiqxjYbEHq7ZPIqzM/N7miek50i/rn0wN7ua7YkW7qHsnfZ73If6DYBoqDbRB2GPOEFqQU/FPuM5jXGpkND620H8ZERYAF+aeMWLRAt8CKxwOECW5jJ0whZ21Bz635uG17zmteMv+rzX/lKS2sbFmLkNk/EukllJMM+KdWR6mX8LcRb6Ld0FRV/dU8HDNAAYAtpLWUAErWsqUECOwjAldPBlHZ3AeCCwQVmtAVcae6UJnLJAgsp92GIXtvCfKRhcj0/Bm5xPfOMPEhmEEwiZXxNDkF2OdBWuIaWQBaMrYBXrhC3UQC7awG7AwMHOp555pkvX/zJf/7KypW/RQddC6g9WoAWgx2AAQBauPECGICbnY0vkjY3ZDEXtr1k9kDDwVvKNLdePUL/xGGCthyy6j1GGtimgRPsjsogZ+OgvLs+nKThoou6cP5Som2nv2b+Zm8ISzoFsYEkp5JNRjOwRW0BsJUkOkU4cGnXvuc/+2zy7GFHlZL7YmCGQRpmHfAdQAoAFwvN4naELSD2h4zJAS3ejs/KDh0tPuMWLRAt8CKzwEgAW5gsxKUhwA3D7pK9Pf7445u++f2ffal9woQ/cltn2j8FjZ6gAltjYUoXigWythywBVureln4sd1vsgRdHGZeZOXHluZGcQ/WSICL4wC33V19GsrWNge0aV4BfuUPD3eL4zzH+10AWCmD3F7LgcVdehJ3nAtQq4vW9JjmS4+rrEAv9lCi/APAFgvHRE+rbDDT3LfzuWe++oWrL7721lt/BYDokoOQmS2ytEcL0KLDB6AFAACgBaDA9G0EtGlty75MlgAOEye1YDX+y0MZS1oPWVN0MJcDhISV1Qn2Iwls08Fo0HbS/KbMbOanWdlY3dKBo83OhOyrgmUftFrBA5uFrG92OJx00HeB/K9Lkrnm4N7uS4Whfb7E7Id1yAAuwC12DOjhlg4BRJ48rITjxaUWMMkBBsiIGoYNQBYDihgxLNaZaIEXsQVGCtjChOxngx29Vilz29raWv+LW+6+bPKUye/QC31RiwFbA5Y+XUmypeCAUzuzEmCLBA3AQooArwj94vZLfdkqY6t9nMkH5IdWkScog4uwv3US4EE1uLg+mx4NWCjTxFpCBiVU8+rTq5RJGMCQ5V68t/vQ9dDCkEhoj6tAudiZuzYX4F4ZWwXKsvV0dOz85teuu/Kaf/u3H6PzrObpwEGtg9kyyYFZjNmojogOsZHY9OApcvkS2TG4AaCFp4OoRxzCpjOTmeObJ01G6N03Fk/1hlY8PqqMLcdkNhAtkRSwQtlAz7/rtIVGDCy2rRDohtfquXqfnATBa6sPanPGyANbaebX9CUHPrVj3xPPHGJVrvkyySNkCQ64MKCDBheePZ6QssQAADVbsvxEsS/crsFDBVwCYsMzxSA5AtrDtG28PFrghWCBkQS2sEfN4FbOrf/1rfe8b8asme8PgW3YYWfAVs4gngvA5WDAlh2gLSATKLdfwuuSDcUxMLlBB6knEo7Se0JrS3NS36AIFf5vO0WmsB+yg4DFJfOK7BD4KsuKIwxrax28Q+60PAZsGSQCMgTkQUOhaT3K9cPBgjNLgJ6+BNnu3tXxzZ/89BtXf/P6a/ESrwZoB/N0EN7JDXokAC1WJKPzwepxlAJsClYkb34hNJzRLMOCiSfdIBZ8S3hPb7hlDfhQNLZDVQC/T266nxcFupicUdSNXghE0xkKAlGr9kG7KjKvDopTYEsgrTlV2ZHl2lje/DOxaj4wcP2B/eM+tqV73agHVpD8g7WF3hOzFFjQBNdgcBOGdhDdhA2zEYk958olGDDAFSAeMLTMj4otR5x9H2bW4unRAtECY8gCRwLYst8J9mrMLWUKV37xyy///de98fNNDY0AQNy4XCRggLh4jFKE4mrqKowt3noObIUfgXYVOluVAujCsRTcmhQA8/ukM+WHRllk1trcIIEeGnleX3+/RDLrt0APmYsw6gdNhoDzwDh5fxvKGVAe3BOA1rW1ocShjh000jKFLRfcuP9bGuPA3q5dP/vlv/7wimuvvRK6vVq9HIwqQ2tM1fGSP+zTrPMBkMV0bOx8DqPhz5944ifFhh/1JHw+wH0ihA1Zh03lm0oR8JvVOTs3aEkVF4aDzbyOFQFRjEmteJNAQx4mFTKuhcWhhTuG98jeA5m7LygYVFqgzQabnpezwndEXf/xLXs2PH4YZh+RS6U8yBjeb5AooF3A3ADamLXYKnkfalwxIvk4FhMxuQFme/BOQbAWeHmBlwMMDmK0sGPxocY8RwscYQuMNLBlH2N5Hgzc5rS3r3r969suv+TKj0+eMvXPca0D2xTKpgxPFsFoUCkCEgGwpRShTqQIxpIC21J7WwlsGRbC3W3xegkSIT1oS0sjd3JFcn2fhKTtFk8KveITFwxtykhZwAR/Xr64LGWWoKuVfb/SWFxAljK/NBrkGBnja7qDgc59e39xy62/uPSqKz6+yTrEwfSzDnjRURZBrVmFORzRjlRssMg6HsRdxwa3Oui010n5MQ0btxGwwPyJJ5wlUpQfSlILs+Q0oEnKqPLhFkFednY1jW11YFtIP4dWK++TMbRZFdNLNIcKyPN3q9AJcwCq1dSBLVqH0ryVoFjvqW1Hvv6bhPM776l968dkUA/J60zJLFhctBlsYG43yr5J8o9oWC/6zQbIsA/cdWEggA1rCABoHxc7AdzGLVogWiBaoNQCRwLY4kZDgdvQHVgajvcb3/7xOaeefvpnGusbpqMPcykCp/kDzWra2YVEB8EvWE8rJxhY6eUAMPvpFQFg0rR6NqVJIoXuE1SNoIytgt5xij8ZxAFbs8gUmpsQzQwgF6D5IBncXgG6/f3ivkhWb3u+DognhnAJD7IJF0fU2RrA9WlZzy5BLVZ4GyiR8Le33X3vLZdecuF56KAdsA4FaocCtMj6YYNayTueH6YF58kOJgpTrogShqnBjWIHuNmJ2xGwwHHJye0tkw5cKfXkbzT50QW2XqSMVc2/QtBmeKSChATNqvmtDdhm1RTtKgS2XoVzgHig7uaBg+PO29y19v4jYPYRT9JkCmg7YCLhExfbXtkxI/O0lO3pEb/pGE7QwCw0s9jxbsHmA2SAfqwliFu0QLRAtMCQFjhSwJZdm929jLkNF5WlwFbOr3/DG97c/rGLLvrnadOO+0thl2TJlLI7Rf1dcfaOv/M/h4ZwyVVHfSx0rfCMoKHkAWbDhSs6ZUoQbJhPQacWgPJb5IGziQDYA0kTQK4A3CaRKphqQAAugG6/MLpwLwY4LNfoJbwWwPYgjhuwZaEgTzAGDLmGa6O+3p4V962461OfvOAfV+qNK1x31eKLlqnb7pXgsACt2ASIHkAWHQ+YWfXDlE2pbpFnMNiMtucjfo6ABeZPOPG/ir2/JABy9vAYW5vGL+Sh+oOThV5of4Xz85IE/zE8s5iir/40N3eD2EBlOlqFs0GsV7d8unLafXLuh7bsW3/bCJj1qCQh5W2VGy+yHQujfNsmXwBwt4sdXnC+WKXciOLmYBZMNjawsZAvbZAyx8VgR6VGxptGCxzbFjiSwLast3Nv6w5sywAuj11y+edOftOb/9OlEq2MsdndDViaaIERyjpAB7YSZYz6WuhaxTOCfCdeZSQyfFetoUdBUgSpnSbYXTcMgW0KCfUP7dThekukCqLFhduwBvGNi/PwG1jc/f37qaeFR4b9/SpDOCiuxwBsKUNASgZqkVp/X9+Dj619+PJ/+se/vYtZKQe1OF70dBCytEw2zHHhe821VfI2UU5GJztFdkwHFjseMEvbxO5xlXfNVh3ZE+ckc9rqJ034hAhiPhAS8YNJEdiOgnrnOao+6lFGON1SKYKP2sIyOXgtVsE84HXQml2paWWAVn/JFpjhO9zmYeRqwHYgeVDa6flbujbcOLJWPbqpVQF7yFSv7Fj9D7D37LGoWZey+fsE75Tj7P2CssH39pOyY3AcwezRrYLx7tECx7wFRgPYso8yS3kP5wvKwoVlRZDLv//1xpv/bNHCRe9vaKifEbK2pYwtO8OMsT0IxjYEtiBelYI1EApwax4KcMg6bbjlSslWugfTwAkKgrNOHvIBRELDPQ/I740N9bLwbFzS1NCgnhVsg1uvPgG6fb19AmDlE8BX5ArYhKFds37Duive97//8ib5czBAG/7mGQkzdMiAVsqNjgY7Oh7vfCAv8A36NrBHWOgSZQZjrNkvaF96slTF6+TZvFYrQRnHqpkueM3L6mjVMuUZ23Km1rGy1vkKKQKbDDSy+HRgmve26+0NA0CmES4e5ThScy5XrZER48e2dm/80Rh7DCOeHZue91kSeAKAGzHfIP2BJhfeRnbLDhlDx1iYNZF8g14P3yX+TglthMWkWEC3OcoMRrzqxASjBV7UFhgtYMu+yiw9mDQhBLcpq7tg2bKmK5df/ZZFi45/V0tzCxncWoAtmFrugiEzxla7R2SH3rbMV63OfIaMrFOf8EHr05+mv3XwLD641OuY3EMupccDoYkBgpsE4ILFbZJFZfUNsot+Fkwwu2ZGFe1/tLt7zw3btz91z44dO3Zt2LBht3z2bNq0qfu2227z6GFFMOtA1llaL0xIuJWSb9LZIDoPAiNghysu72zCqU9vDOgsfX9GOp7omugYeE0smLj0nfLwPyogUBzWVzbt6nA35xG6UNLBFo9lp6q2VrhjG/jl2mcJsA0BchlYzulnyRnXrZH2eenWzie+fgw8iiOSRbHTJEkYTCf26bJjVqW4wVMABqKQLmDhJv7mp9j0kMIGVyuMSSjwPoGUwgfG+CzmCyAc7xMwzgTjcabniFSRmGi0QLSAWGA0gS0MXg3c4ngZextKFvj7577wL68461Wv/OuJE9r/s7wcdSUXEjaGxxlb6lqhmxUoCFdfogiwIA3Zc1c3svifamyNxk2ZW5ypkgWIFDK8iJXlnBoFi0RwDLkD0hCpgZxbL8frRR1M+Ex9rx6XoGGd/X29v+rt2v3z1ta6rvb29vGyt4qbsIGGhoaD2PFdtLYS36GuVz67hcHqaWxs7Dlw4ECv/NbT0tLSLVufnNszefLk3p6enmY5t1k2sDkOXPGJvx3MpnYq1Hp0gGR67HO3pBVXZh/jr4YF45e9SaYS/n9ZjCi+bzNZjRYr42xz4LK0zD4JUF2oQG8EuWtNVlDwfOD35QwJZz607SmA5V+auyAamR4duFEGhFdu69yIGY24BRYwRhcAFwNVuMIC8AWoRLuvtjnYhZYV00YAnfj073g4aRj04DtYWH+v4DOc0fF7IQ28U3zHu2XXC1EfHCtitEC0wNi1wGgDW1giBLf423W3IbgtAlq8VHPyhb/+63dP/7N3/sX/NWvWzP/e1NT80kpgqwQsAG0KbE1n651oFh9BF3GRdeJn1pF7p8tzrfOFtlYFD+YTl0yt/65uwgTEmmZwQHzg9mzcsX3rt77w5au+f3cW+tZZ14Mf+MAHxp988smtixYtaj3uuOOaJ06c2NrW1tYinXybANY2AF0YCp8AvmF18t9Kqhg6Ge/EUtbGju0Te6HTidsL2ALzm5cuGddc935hT/9CavZEdadabPLVQWs4ixFKcDKTeZPVI2nK8mVABnn58/RXLKqE3IAA1tpUdh8FttL+hFms++ZA/8AVW3s3IKBB3IZhAZMCAOwiKAQWaIFRBfDFdxzD34eyAQxXe6fslXdK9Ct7KFaN10QLRAuMqAWOBrDN9YHWH1aTJ5RpcYsAuO6iiy5d9vqzz3n79KlT/1t9Q4No0ZSFJbCFVwRx8wVJqyoKHLgCzGYLyBS0StKpBpc0LvkuhMdVYlcZLAZi4GPQ4/RZS1SMsLe69x/oX7tr57O/eOC39/7iwgv/+TFeWBlYoUxqUNTPDrz73e+ue8c73lF/4oknjhP2tl72hkmTJjn4D9kWsi7SwUQ/jyPaTI79xBaOX/znA+Pq3yF1I41gNhgPm5aYGvQqZ1pwBgYTCU2E9oKVmyHS9T8w+2Eadh+MOmErTeh3Ej76e92ddV/elWyAbjRuR8gCBn5DZta90+C94uxtyubGd8oRehAx2WiBaIERt8DRArZekCJ76wA39J5QBLfFvx3o1snUfP1FF11y6imnnvq6yVOmvU48Kpwp/WvTfumAAWxVVgBZgHbUzti6HEGBqgBX+4SLLp4nWlq7gn8DuHLCFdiXEgedWt3f3/dwR8fOX955523/LgEVnjQgGwLaocCt/64IOr+7zWrCIyNeU2KCLwgLzGxfMqN5XN2fS1t4u4CVVw9VqOKCyfB8bUYWIa+YEKYwcm8XW/zFqQ0V9mgbGviN/O8nBwfG/ejpno1oM3GLFogWiBaIFogWOGQLHG1gqz1jtoXMbTWQW2RsiyA4TeP0009v+cAHzn/1rHnzzmpqbl/Y0NC0oKGhbv64cfVcMFUV2FI7C3lBytFSY4t/Gtl3oKe3r2ddZ1f3Y3t3d6zZtnXzYzf98qeP/PrXP4e2zAFpkXmtthDMj1cDsw5kI6A95GoeLyyzwJRk8aTx7fXnyDjtzVJtzxagu6wCn6bSnMynrJ/jwJaN2Fux+XuuDNBgUoSBgT3C2N4nvu9u6Ksb+PFzXZvhbSNu0QLRAtEC0QLRAiNigbEAbL0gQwHclJmVC5y1DUFu8fcykMx7nHHGa1r/65++deH0qTOnt7a3ja8f19Qqa69aZY6/TUBvG5x4Hezv79l/YH/P/v193eKaqwdItq+vt2vzpieevuyyCzZYpsvAaMi6huC22vcIaEekKsdEDtcCs1oWLWpoaDxD4mwcL0j1eElvsTCqxwujeqKO18DOhnexSH4Q7NgPLk9nrI6BZLVctUqw7sN1B+selMh/j2ztXg//x3GLFogWiBaIFogWOCIWGEvAtghwQ5nCUExuNVAbLkwrplcGqIcycsieOiDFNWUSgjLGdjCpQZGZjQztUE8j/j6aFqCme1GyqL4v6Rsne/3+pF2c2TUcrE92H2xMGg9uS9pEu7PeZyBi4I7RfDrxXtEC0QLRAtECtMBYBLZDAVzPdxG0DvW3g+Ow3EWWuKxahACzDHyGjGvoZ7aaJCE830Fx2T1iFY0WiBaIFogWiBaIFogWiBYYhgXGMrAtA95DsbjV5AfhcU+3WPbBbFEEnmXMbTVZQrXjDmr9cUWGdhgVN54aLRAtEC0QLRAtEC0QLVC0wFgHtmF+y9jVakA3BK9loLYaaztYDSkDt9UAbsjEFiULEdDGdhgtEC0QLRAtEC0QLRAtcAQscCwBWy9+Naa1TEM71LFqwDk8XmRSq2lhiwB2KM1sZGiPQIWOSUYLRAtEC0QLRAtEC7x4LXAsAtvBwGgIZItAuJqetlYbVNPBFgFsyMhWA8Uv3hoXSx4tEC0QLRAtEC0QLRAtcIQsUCuoO0K3H9Fkh9LMDvV7rZkZDKyWsbCRma3VsvG8aIFogWiBaIFogWiBaIHDsMALCdgWzVCtbCNV5mqANQLZw6iQ8dJogWiBaIFogWiBaIFogUO1wEiBvEO9/2hfN9LljSB2tJ9gvF+0QLRAtEC0QLRAtEC0QBULjDTQi4aOFogWiBaIFogWiBaIFogWiBY4KhaIwPaomD3eNFogWiBaIFogWiBaIFogWmCkLRCB7UhbNKYXLRAtEC0QLRAtEC0QLRAtcFQs8H8Awz0HHOmZSUQAAAAASUVORK5CYII=\"/>\r\n  </g>\r\n</svg>\r\n"

/***/ }),
/* 1704 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1366 600\">\r\n  <defs>\r\n    <style>\r\n      .hhyd-cls-1 {\r\n        clip-path: url(#clip-Banner_Home_Desktop_curve);\r\n      }\r\n\r\n      .hhyd-cls-2 {\r\n        fill: url(#pattern_Home_Desktop_curve);\r\n      }\r\n\r\n      .hhyd-cls-3 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .hhyd-cls-4 {\r\n        fill: #0064bf;\r\n      }\r\n\r\n      .hhyd-cls-5 {\r\n        fill: #561770;\r\n      }\r\n\r\n      .hhyd-cls-6 {\r\n        fill: #fe2b09;\r\n      }\r\n\r\n      .hhyd-cls-7 {\r\n        fill: #ffc000;\r\n      }\r\n\r\n      .hhyd-cls-8 {\r\n        fill: #5f9600;\r\n      }\r\n\r\n      .hhyd-cls-9 {\r\n        fill: #4a7e0b;\r\n      }\r\n\r\n      .hhyd-cls-10 {\r\n        fill: #61a50e;\r\n      }\r\n\r\n      .hhyd-cls-11, .hhyd-cls-14, .hhyd-cls-15, .hhyd-cls-16, .hhyd-cls-17, .hhyd-cls-18, .hhyd-cls-19 {\r\n        fill: none;\r\n      }\r\n\r\n      .hhyd-cls-12 {\r\n        fill: #ffce00;\r\n      }\r\n\r\n      .hhyd-cls-13 {\r\n        fill: #63a70a;\r\n      }\r\n\r\n      .hhyd-cls-14 {\r\n        stroke: #fff;\r\n        stroke-width: 0.488px;\r\n      }\r\n\r\n      .hhyd-cls-15 {\r\n        stroke: #0064bf;\r\n      }\r\n\r\n      .hhyd-cls-15, .hhyd-cls-16, .hhyd-cls-17, .hhyd-cls-18, .hhyd-cls-19 {\r\n        stroke-width: 0.488px;\r\n      }\r\n\r\n      .hhyd-cls-16 {\r\n        stroke: #561770;\r\n      }\r\n\r\n      .hhyd-cls-17 {\r\n        stroke: #fe2b09;\r\n      }\r\n\r\n      .hhyd-cls-18 {\r\n        stroke: #5f9600;\r\n      }\r\n\r\n      .hhyd-cls-19 {\r\n        stroke: #ffc000;\r\n      }\r\n    </style>\r\n    <pattern id=\"pattern_Home_Desktop_curve\" preserveAspectRatio=\"xMidYMid slice\" width=\"100%\" height=\"100%\" viewBox=\"0 0 1366 600\">\r\n      <image width=\"1366\" height=\"600\" xlink:href=\"data:image/jpeg;base64,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\"/>\r\n    </pattern>\r\n    <clipPath id=\"clip-Banner_Home_Desktop_curve\">\r\n      <rect width=\"1366\" height=\"600\"/>\r\n    </clipPath>\r\n  </defs>\r\n  <g id=\"Banner_Home_Desktop_curve\" class=\"hhyd-cls-1\">\r\n    <g id=\"BgDeskYou\">\r\n      <rect id=\"BG_voce_limpo_v2\" class=\"hhyd-cls-2\" width=\"1366\" height=\"600\"/>\r\n    </g>\r\n    <path id=\"TextoRodape\" class=\"hhyd-cls-3\" d=\"M-615.718-14.277h1.084L-619.976,0h-.879l-5.322-14.277h1.064l3.594,9.717q.82,2.2,1.1,3.3.2-.732.771-2.275Zm11.24,8.955a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1-609.214.2a4.5,4.5,0,0,1-2.461-.674,4.31,4.31,0,0,1-1.631-1.934,7.033,7.033,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1-604.478-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413,3.257,3.257,0,0,0,2.72,1.226,3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408,3.3,3.3,0,0,0-2.729-1.211,3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0-612.856-5.322ZM-597.3.2a4.546,4.546,0,0,1-3.564-1.436,5.782,5.782,0,0,1-1.289-4,5.879,5.879,0,0,1,1.338-4.106,4.7,4.7,0,0,1,3.662-1.47,7.363,7.363,0,0,1,2.637.479l-.264.859a7.74,7.74,0,0,0-2.393-.459,3.633,3.633,0,0,0-2.959,1.206,5.287,5.287,0,0,0-1.006,3.472A5.127,5.127,0,0,0-600.132-1.9a3.448,3.448,0,0,0,2.813,1.216,6.9,6.9,0,0,0,2.686-.518v.9A6.086,6.086,0,0,1-597.3.2Zm9.551,0a4.625,4.625,0,0,1-3.608-1.426,5.731,5.731,0,0,1-1.294-3.994,6.227,6.227,0,0,1,1.25-4.067,4.126,4.126,0,0,1,3.369-1.528,3.638,3.638,0,0,1,2.959,1.309,5.4,5.4,0,0,1,1.084,3.555v.781h-7.646a5.022,5.022,0,0,0,1.021,3.34,3.592,3.592,0,0,0,2.866,1.152,8.89,8.89,0,0,0,1.6-.127,9.7,9.7,0,0,0,1.743-.547v.879a7.774,7.774,0,0,1-1.66.532A9.214,9.214,0,0,1-587.749.2Zm-.283-10.156a3.18,3.18,0,0,0-2.461,1.011,4.767,4.767,0,0,0-1.084,2.915h6.563a4.629,4.629,0,0,0-.8-2.886A2.641,2.641,0,0,0-588.032-9.961Zm-2.949-2.314q.605-.654,1.284-1.523a16.806,16.806,0,0,0,1.079-1.523h.957a18.8,18.8,0,0,0,2.363,3.047v.156h-.684a23.125,23.125,0,0,1-2.158-2.021,23.9,23.9,0,0,1-2.158,2.021h-.684ZM-571.323.2A3.879,3.879,0,0,1-574.9-1.641h-.068l.029.82q.039.723.039,1.582V4.8h-.967v-15.42h.82l.186,1.514h.059a3.836,3.836,0,0,1,3.5-1.719,3.947,3.947,0,0,1,3.276,1.411A6.456,6.456,0,0,1-566.9-5.3a6.215,6.215,0,0,1-1.187,4.058A3.971,3.971,0,0,1-571.323.2Zm-.02-.859a2.953,2.953,0,0,0,2.524-1.211,5.615,5.615,0,0,0,.894-3.389q0-4.678-3.379-4.678a3.387,3.387,0,0,0-2.725,1.021A5.107,5.107,0,0,0-574.9-5.6v.313a5.846,5.846,0,0,0,.835,3.555A3.248,3.248,0,0,0-571.343-.664Zm16.162-4.658a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1-559.917.2a4.5,4.5,0,0,1-2.461-.674,4.31,4.31,0,0,1-1.631-1.934,7.033,7.033,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1-555.181-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413,3.257,3.257,0,0,0,2.72,1.226,3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408A3.3,3.3,0,0,0-559.9-9.941a3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0-563.56-5.322Zm15.205-5.5a4.407,4.407,0,0,1,1.992.42,3.965,3.965,0,0,1,1.5,1.436h.059q-.059-1.23-.059-2.412V-15.2h.957V0h-.635l-.244-1.621h-.078A3.928,3.928,0,0,1-548.335.2a4.164,4.164,0,0,1-3.359-1.367,6,6,0,0,1-1.162-3.984A6.655,6.655,0,0,1-551.7-9.365,4.018,4.018,0,0,1-548.354-10.82Zm0,.879a3,3,0,0,0-2.612,1.221,6.049,6.049,0,0,0-.874,3.545q0,4.512,3.506,4.512A3.182,3.182,0,0,0-545.7-1.709a5.546,5.546,0,0,0,.84-3.447v-.166a5.909,5.909,0,0,0-.825-3.54A3.15,3.15,0,0,0-548.354-9.941ZM-536.05.2a4.625,4.625,0,0,1-3.608-1.426,5.731,5.731,0,0,1-1.294-3.994,6.227,6.227,0,0,1,1.25-4.067,4.126,4.126,0,0,1,3.369-1.528,3.638,3.638,0,0,1,2.959,1.309,5.4,5.4,0,0,1,1.084,3.555v.781h-7.646a5.022,5.022,0,0,0,1.021,3.34A3.592,3.592,0,0,0-536.05-.684a8.89,8.89,0,0,0,1.6-.127,9.7,9.7,0,0,0,1.743-.547v.879a7.774,7.774,0,0,1-1.66.532A9.214,9.214,0,0,1-536.05.2Zm-.283-10.156a3.18,3.18,0,0,0-2.461,1.011,4.767,4.767,0,0,0-1.084,2.915h6.563a4.629,4.629,0,0,0-.8-2.886A2.641,2.641,0,0,0-536.333-9.961ZM-517.72,0l-.244-1.68h-.078a5.041,5.041,0,0,1-1.646,1.45,4.4,4.4,0,0,1-2,.425,3.455,3.455,0,0,1-2.432-.8,2.864,2.864,0,0,1-.869-2.217,2.735,2.735,0,0,1,1.294-2.412,7.036,7.036,0,0,1,3.745-.908l2.021-.059v-.7a3.61,3.61,0,0,0-.615-2.285,2.386,2.386,0,0,0-1.982-.771,6.631,6.631,0,0,0-3.057.82l-.361-.84a8.089,8.089,0,0,1,3.457-.82,3.446,3.446,0,0,1,2.612.908,3.99,3.99,0,0,1,.864,2.832V0Zm-3.906-.684a3.643,3.643,0,0,0,2.681-.972,3.629,3.629,0,0,0,.981-2.7V-5.4l-1.855.078a7.009,7.009,0,0,0-3.188.7,2.011,2.011,0,0,0-.952,1.841,1.98,1.98,0,0,0,.61,1.548A2.481,2.481,0,0,0-521.626-.684ZM-512.6,0h-.967V-10.615h.967Zm-1.1-13.564q0-.937.615-.937a.546.546,0,0,1,.474.244,1.2,1.2,0,0,1,.171.693,1.227,1.227,0,0,1-.171.693.541.541,0,0,1-.474.254Q-513.706-12.617-513.706-13.564ZM-501.646,0V-6.885a3.357,3.357,0,0,0-.674-2.329,2.72,2.72,0,0,0-2.09-.728,3.618,3.618,0,0,0-2.788.962,4.534,4.534,0,0,0-.884,3.12V0h-.967V-10.615h.82l.186,1.455h.059a3.99,3.99,0,0,1,3.682-1.66q3.613,0,3.613,3.877V0Zm8.281-10.82a4.407,4.407,0,0,1,1.992.42,3.965,3.965,0,0,1,1.5,1.436h.059q-.059-1.23-.059-2.412V-15.2h.957V0h-.635l-.244-1.621h-.078A3.928,3.928,0,0,1-493.345.2,4.164,4.164,0,0,1-496.7-1.172a6,6,0,0,1-1.162-3.984,6.656,6.656,0,0,1,1.152-4.209A4.018,4.018,0,0,1-493.364-10.82Zm0,.879a3,3,0,0,0-2.612,1.221,6.049,6.049,0,0,0-.874,3.545q0,4.512,3.506,4.512a3.182,3.182,0,0,0,2.637-1.045,5.546,5.546,0,0,0,.84-3.447v-.166a5.909,5.909,0,0,0-.825-3.54A3.15,3.15,0,0,0-493.364-9.941ZM-478.9,0l-.244-1.68h-.078a5.041,5.041,0,0,1-1.646,1.45,4.4,4.4,0,0,1-2,.425,3.455,3.455,0,0,1-2.432-.8,2.864,2.864,0,0,1-.869-2.217,2.735,2.735,0,0,1,1.294-2.412,7.036,7.036,0,0,1,3.745-.908l2.021-.059v-.7a3.61,3.61,0,0,0-.615-2.285,2.386,2.386,0,0,0-1.982-.771,6.631,6.631,0,0,0-3.057.82l-.361-.84a8.089,8.089,0,0,1,3.457-.82,3.446,3.446,0,0,1,2.612.908,3.99,3.99,0,0,1,.864,2.832V0Zm-3.906-.684a3.643,3.643,0,0,0,2.681-.972,3.629,3.629,0,0,0,.981-2.7V-5.4L-481-5.322a7.009,7.009,0,0,0-3.188.7,2.011,2.011,0,0,0-.952,1.841,1.98,1.98,0,0,0,.61,1.548A2.481,2.481,0,0,0-482.808-.684Zm17.49.879a4.546,4.546,0,0,1-3.564-1.436,5.782,5.782,0,0,1-1.289-4,5.879,5.879,0,0,1,1.338-4.106,4.7,4.7,0,0,1,3.662-1.47,7.363,7.363,0,0,1,2.637.479l-.264.859a7.739,7.739,0,0,0-2.393-.459,3.633,3.633,0,0,0-2.959,1.206,5.287,5.287,0,0,0-1.006,3.472A5.128,5.128,0,0,0-468.149-1.9a3.448,3.448,0,0,0,2.813,1.216,6.9,6.9,0,0,0,2.686-.518v.9A6.086,6.086,0,0,1-465.317.2Zm14.043-5.518a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1-456.011.2a4.5,4.5,0,0,1-2.461-.674A4.31,4.31,0,0,1-460.1-2.412a7.034,7.034,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1-451.274-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413,3.257,3.257,0,0,0,2.72,1.226,3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408,3.3,3.3,0,0,0-2.729-1.211,3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0-459.653-5.322ZM-440.933,0V-6.885a3.357,3.357,0,0,0-.674-2.329,2.72,2.72,0,0,0-2.09-.728,3.618,3.618,0,0,0-2.788.962,4.534,4.534,0,0,0-.884,3.12V0h-.967V-10.615h.82l.186,1.455h.059a3.99,3.99,0,0,1,3.682-1.66q3.613,0,3.613,3.877V0Zm10.977-2.764A2.523,2.523,0,0,1-431.04-.571,5.276,5.276,0,0,1-434.116.2,7.336,7.336,0,0,1-437.5-.459V-1.5a7.457,7.457,0,0,0,3.379.8,4.457,4.457,0,0,0,2.388-.522,1.588,1.588,0,0,0,.815-1.392,1.7,1.7,0,0,0-.649-1.348A7.141,7.141,0,0,0-433.7-5.039a12.222,12.222,0,0,1-2.236-.991,3.09,3.09,0,0,1-.972-.937,2.355,2.355,0,0,1-.327-1.274,2.177,2.177,0,0,1,1-1.885,4.863,4.863,0,0,1,2.8-.693,8.377,8.377,0,0,1,3.262.645l-.361.879a7.649,7.649,0,0,0-2.9-.645,4.2,4.2,0,0,0-2.061.43,1.319,1.319,0,0,0-.762,1.191,1.649,1.649,0,0,0,.591,1.328,8.237,8.237,0,0,0,2.31,1.113,11.364,11.364,0,0,1,2.09.933,3.038,3.038,0,0,1,.981.942A2.3,2.3,0,0,1-429.956-2.764Zm3.574-7.852V-3.74a3.357,3.357,0,0,0,.674,2.329,2.72,2.72,0,0,0,2.09.728,3.648,3.648,0,0,0,2.788-.957,4.481,4.481,0,0,0,.894-3.115v-5.859h.957V0h-.82l-.176-1.465h-.059A3.99,3.99,0,0,1-423.716.2q-3.623,0-3.623-3.877v-6.934ZM-414.458,0h-.967V-15.2h.967Zm6.357-.664a7.252,7.252,0,0,0,1.6-.156v.781A5.124,5.124,0,0,1-408.12.2,2.639,2.639,0,0,1-410.2-.557a3.491,3.491,0,0,1-.669-2.363V-9.775h-1.572v-.566l1.572-.439.488-2.4h.5v2.568h3.115v.84h-3.115v6.719a3.066,3.066,0,0,0,.43,1.807A1.56,1.56,0,0,0-408.1-.664ZM-397.759,0-398-1.68h-.078a5.041,5.041,0,0,1-1.646,1.45,4.4,4.4,0,0,1-2,.425,3.455,3.455,0,0,1-2.432-.8,2.864,2.864,0,0,1-.869-2.217,2.735,2.735,0,0,1,1.294-2.412,7.036,7.036,0,0,1,3.745-.908l2.021-.059v-.7a3.61,3.61,0,0,0-.615-2.285,2.386,2.386,0,0,0-1.982-.771,6.631,6.631,0,0,0-3.057.82l-.361-.84a8.089,8.089,0,0,1,3.457-.82,3.446,3.446,0,0,1,2.612.908,3.99,3.99,0,0,1,.864,2.832V0Zm-3.906-.684a3.643,3.643,0,0,0,2.681-.972,3.629,3.629,0,0,0,.981-2.7V-5.4l-1.855.078a7.009,7.009,0,0,0-3.188.7A2.011,2.011,0,0,0-404-2.783a1.98,1.98,0,0,0,.61,1.548A2.481,2.481,0,0,0-401.665-.684Zm12.236-10.137a8.307,8.307,0,0,1,1.445.137l-.186.928a5.656,5.656,0,0,0-1.377-.166,2.674,2.674,0,0,0-2.227,1.152,4.7,4.7,0,0,0-.869,2.91V0h-.967V-10.615h.82l.1,1.914h.068a4.5,4.5,0,0,1,1.4-1.646A3.271,3.271,0,0,1-389.429-10.82Zm15.381,8.057a2.523,2.523,0,0,1-1.084,2.192A5.276,5.276,0,0,1-378.208.2a7.336,7.336,0,0,1-3.379-.654V-1.5a7.457,7.457,0,0,0,3.379.8,4.457,4.457,0,0,0,2.388-.522A1.588,1.588,0,0,0-375-2.617a1.7,1.7,0,0,0-.649-1.348,7.141,7.141,0,0,0-2.134-1.074,12.222,12.222,0,0,1-2.236-.991A3.09,3.09,0,0,1-381-6.968a2.355,2.355,0,0,1-.327-1.274,2.177,2.177,0,0,1,1-1.885,4.863,4.863,0,0,1,2.8-.693,8.377,8.377,0,0,1,3.262.645l-.361.879a7.649,7.649,0,0,0-2.9-.645,4.2,4.2,0,0,0-2.061.43,1.319,1.319,0,0,0-.762,1.191,1.649,1.649,0,0,0,.591,1.328,8.237,8.237,0,0,0,2.31,1.113,11.364,11.364,0,0,1,2.09.933,3.038,3.038,0,0,1,.981.942A2.3,2.3,0,0,1-374.048-2.764ZM-364.868,0l-.244-1.68h-.078a5.041,5.041,0,0,1-1.646,1.45,4.4,4.4,0,0,1-2,.425,3.455,3.455,0,0,1-2.432-.8,2.864,2.864,0,0,1-.869-2.217,2.735,2.735,0,0,1,1.294-2.412,7.036,7.036,0,0,1,3.745-.908l2.021-.059v-.7a3.61,3.61,0,0,0-.615-2.285,2.386,2.386,0,0,0-1.982-.771,6.631,6.631,0,0,0-3.057.82l-.361-.84a8.089,8.089,0,0,1,3.457-.82,3.446,3.446,0,0,1,2.612.908,3.99,3.99,0,0,1,.864,2.832V0Zm-3.906-.684a3.643,3.643,0,0,0,2.681-.972,3.629,3.629,0,0,0,.981-2.7V-5.4l-1.855.078a7.009,7.009,0,0,0-3.188.7,2.011,2.011,0,0,0-.952,1.841,1.98,1.98,0,0,0,.61,1.548A2.481,2.481,0,0,0-368.774-.684Zm9.023.684h-.967V-15.2h.967Zm7.441-10.82a4.407,4.407,0,0,1,1.992.42,3.965,3.965,0,0,1,1.5,1.436h.059q-.059-1.23-.059-2.412V-15.2h.957V0h-.635l-.244-1.621h-.078A3.928,3.928,0,0,1-352.29.2a4.164,4.164,0,0,1-3.359-1.367,6,6,0,0,1-1.162-3.984,6.656,6.656,0,0,1,1.152-4.209A4.018,4.018,0,0,1-352.31-10.82Zm0,.879a3,3,0,0,0-2.612,1.221,6.049,6.049,0,0,0-.874,3.545q0,4.512,3.506,4.512a3.182,3.182,0,0,0,2.637-1.045,5.546,5.546,0,0,0,.84-3.447v-.166a5.909,5.909,0,0,0-.825-3.54A3.15,3.15,0,0,0-352.31-9.941Zm16.8,4.619a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1-340.249.2a4.5,4.5,0,0,1-2.461-.674,4.31,4.31,0,0,1-1.631-1.934,7.034,7.034,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1-335.513-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413,3.257,3.257,0,0,0,2.72,1.226,3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413A5.317,5.317,0,0,0-337.5-8.73a3.3,3.3,0,0,0-2.729-1.211,3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0-343.892-5.322Zm17.9,2.559a2.523,2.523,0,0,1-1.084,2.192A5.276,5.276,0,0,1-330.151.2a7.336,7.336,0,0,1-3.379-.654V-1.5a7.457,7.457,0,0,0,3.379.8,4.457,4.457,0,0,0,2.388-.522,1.588,1.588,0,0,0,.815-1.392,1.7,1.7,0,0,0-.649-1.348,7.141,7.141,0,0,0-2.134-1.074,12.222,12.222,0,0,1-2.236-.991,3.09,3.09,0,0,1-.972-.937,2.355,2.355,0,0,1-.327-1.274,2.177,2.177,0,0,1,1-1.885,4.863,4.863,0,0,1,2.8-.693,8.377,8.377,0,0,1,3.262.645l-.361.879a7.649,7.649,0,0,0-2.9-.645,4.2,4.2,0,0,0-2.061.43,1.319,1.319,0,0,0-.762,1.191,1.649,1.649,0,0,0,.591,1.328,8.237,8.237,0,0,0,2.31,1.113,11.364,11.364,0,0,1,2.09.933,3.038,3.038,0,0,1,.981.942A2.3,2.3,0,0,1-325.991-2.764Zm3.838.439.117.205a32.562,32.562,0,0,1-1.7,4.7h-.635a39.349,39.349,0,0,0,1.074-4.9ZM-309.478.2a4.625,4.625,0,0,1-3.608-1.426,5.73,5.73,0,0,1-1.294-3.994,6.227,6.227,0,0,1,1.25-4.067,4.126,4.126,0,0,1,3.369-1.528A3.638,3.638,0,0,1-306.8-9.512a5.4,5.4,0,0,1,1.084,3.555v.781h-7.646a5.022,5.022,0,0,0,1.021,3.34,3.592,3.592,0,0,0,2.866,1.152,8.89,8.89,0,0,0,1.6-.127,9.7,9.7,0,0,0,1.743-.547v.879a7.775,7.775,0,0,1-1.66.532A9.214,9.214,0,0,1-309.478.2Zm-.283-10.156a3.18,3.18,0,0,0-2.461,1.011,4.767,4.767,0,0,0-1.084,2.915h6.563a4.629,4.629,0,0,0-.8-2.886A2.641,2.641,0,0,0-309.761-9.961Zm9.18,4.5-3.7-5.156h1.113L-300-6.143l3.135-4.473h1.064l-3.643,5.156L-295.542,0h-1.123L-300-4.736-303.364,0h-1.064Zm10.156,4.795a7.252,7.252,0,0,0,1.6-.156v.781A5.124,5.124,0,0,1-290.444.2a2.639,2.639,0,0,1-2.075-.752,3.491,3.491,0,0,1-.669-2.363V-9.775h-1.572v-.566l1.572-.439.488-2.4h.5v2.568h3.115v.84H-292.2v6.719a3.066,3.066,0,0,0,.43,1.807A1.56,1.56,0,0,0-290.425-.664Zm8.076-10.156a8.307,8.307,0,0,1,1.445.137l-.186.928a5.656,5.656,0,0,0-1.377-.166,2.674,2.674,0,0,0-2.227,1.152,4.7,4.7,0,0,0-.869,2.91V0h-.967V-10.615h.82l.1,1.914h.068a4.5,4.5,0,0,1,1.4-1.646A3.271,3.271,0,0,1-282.349-10.82ZM-272.7,0l-.244-1.68h-.078a5.041,5.041,0,0,1-1.646,1.45,4.4,4.4,0,0,1-2,.425,3.455,3.455,0,0,1-2.432-.8,2.864,2.864,0,0,1-.869-2.217,2.735,2.735,0,0,1,1.294-2.412,7.036,7.036,0,0,1,3.745-.908l2.021-.059v-.7a3.61,3.61,0,0,0-.615-2.285,2.386,2.386,0,0,0-1.982-.771,6.631,6.631,0,0,0-3.057.82l-.361-.84a8.089,8.089,0,0,1,3.457-.82,3.446,3.446,0,0,1,2.612.908,3.99,3.99,0,0,1,.864,2.832V0Zm-3.906-.684a3.643,3.643,0,0,0,2.681-.972,3.629,3.629,0,0,0,.981-2.7V-5.4l-1.855.078a7.009,7.009,0,0,0-3.188.7,2.011,2.011,0,0,0-.952,1.841,1.98,1.98,0,0,0,.61,1.548A2.481,2.481,0,0,0-276.606-.684Zm10.859.02a7.252,7.252,0,0,0,1.6-.156v.781A5.124,5.124,0,0,1-265.767.2a2.639,2.639,0,0,1-2.075-.752,3.491,3.491,0,0,1-.669-2.363V-9.775h-1.572v-.566l1.572-.439.488-2.4h.5v2.568h3.115v.84h-3.115v6.719a3.066,3.066,0,0,0,.43,1.807A1.56,1.56,0,0,0-265.747-.664Zm12.676-4.658a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1-257.808.2a4.5,4.5,0,0,1-2.461-.674A4.31,4.31,0,0,1-261.9-2.412a7.034,7.034,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1-253.071-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413,3.257,3.257,0,0,0,2.72,1.226,3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408,3.3,3.3,0,0,0-2.729-1.211,3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0-261.45-5.322Zm17.9,2.559a2.523,2.523,0,0,1-1.084,2.192A5.276,5.276,0,0,1-247.71.2a7.336,7.336,0,0,1-3.379-.654V-1.5a7.457,7.457,0,0,0,3.379.8,4.457,4.457,0,0,0,2.388-.522,1.588,1.588,0,0,0,.815-1.392,1.7,1.7,0,0,0-.649-1.348,7.141,7.141,0,0,0-2.134-1.074,12.222,12.222,0,0,1-2.236-.991,3.09,3.09,0,0,1-.972-.937,2.355,2.355,0,0,1-.327-1.274,2.177,2.177,0,0,1,1-1.885,4.863,4.863,0,0,1,2.8-.693,8.377,8.377,0,0,1,3.262.645l-.361.879a7.649,7.649,0,0,0-2.9-.645,4.2,4.2,0,0,0-2.061.43,1.319,1.319,0,0,0-.762,1.191,1.649,1.649,0,0,0,.591,1.328,8.237,8.237,0,0,0,2.31,1.113,11.364,11.364,0,0,1,2.09.933,3.038,3.038,0,0,1,.981.942A2.3,2.3,0,0,1-243.55-2.764ZM-231.333.2a4.625,4.625,0,0,1-3.608-1.426,5.731,5.731,0,0,1-1.294-3.994,6.227,6.227,0,0,1,1.25-4.067,4.126,4.126,0,0,1,3.369-1.528,3.638,3.638,0,0,1,2.959,1.309,5.4,5.4,0,0,1,1.084,3.555v.781h-7.646a5.022,5.022,0,0,0,1.021,3.34,3.592,3.592,0,0,0,2.866,1.152,8.89,8.89,0,0,0,1.6-.127,9.7,9.7,0,0,0,1.743-.547v.879a7.775,7.775,0,0,1-1.66.532A9.214,9.214,0,0,1-231.333.2Zm-.283-10.156a3.18,3.18,0,0,0-2.461,1.011,4.767,4.767,0,0,0-1.084,2.915h6.563a4.629,4.629,0,0,0-.8-2.886A2.641,2.641,0,0,0-231.616-9.961Zm20.449-.654v.674l-2.2.137a3.75,3.75,0,0,1,.879,2.4,3.242,3.242,0,0,1-1.021,2.485,3.855,3.855,0,0,1-2.739.952,5.956,5.956,0,0,1-1.016-.059,2.527,2.527,0,0,0-.879.713,1.439,1.439,0,0,0-.3.869.8.8,0,0,0,.386.742,2.628,2.628,0,0,0,1.294.234h1.855a4.308,4.308,0,0,1,2.646.7,2.433,2.433,0,0,1,.918,2.065,2.94,2.94,0,0,1-1.362,2.593,6.948,6.948,0,0,1-3.882.913,5.342,5.342,0,0,1-3.1-.771,2.479,2.479,0,0,1-1.1-2.148,2.549,2.549,0,0,1,.679-1.816,3.517,3.517,0,0,1,1.841-.986,1.872,1.872,0,0,1-.767-.581,1.382,1.382,0,0,1-.288-.864,2.272,2.272,0,0,1,1.357-1.875,3.026,3.026,0,0,1-1.445-1.2,3.415,3.415,0,0,1-.518-1.87,3.361,3.361,0,0,1,1.011-2.554,3.8,3.8,0,0,1,2.729-.962,5.032,5.032,0,0,1,1.621.205ZM-219.761,1.8q0,2.188,3.252,2.188,4.18,0,4.18-2.666a1.536,1.536,0,0,0-.654-1.387A3.984,3.984,0,0,0-215.1-.5h-1.738Q-219.761-.5-219.761,1.8Zm.811-9.1A2.448,2.448,0,0,0-218.2-5.4a2.856,2.856,0,0,0,2,.679,2.841,2.841,0,0,0,2.036-.674,2.57,2.57,0,0,0,.708-1.953,2.654,2.654,0,0,0-.728-2.036,2.871,2.871,0,0,0-2.036-.679,2.7,2.7,0,0,0-2,.728A2.739,2.739,0,0,0-218.95-7.3ZM-204.7.2a4.625,4.625,0,0,1-3.608-1.426A5.731,5.731,0,0,1-209.6-5.225a6.227,6.227,0,0,1,1.25-4.067,4.126,4.126,0,0,1,3.369-1.528,3.638,3.638,0,0,1,2.959,1.309,5.4,5.4,0,0,1,1.084,3.555v.781h-7.646a5.022,5.022,0,0,0,1.021,3.34A3.592,3.592,0,0,0-204.7-.684a8.89,8.89,0,0,0,1.6-.127,9.7,9.7,0,0,0,1.743-.547v.879a7.775,7.775,0,0,1-1.66.532A9.214,9.214,0,0,1-204.7.2Zm-.283-10.156a3.18,3.18,0,0,0-2.461,1.011,4.767,4.767,0,0,0-1.084,2.915h6.563a4.629,4.629,0,0,0-.8-2.886A2.641,2.641,0,0,0-204.985-9.961Zm15.752,4.639a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1-193.97.2a4.5,4.5,0,0,1-2.461-.674,4.31,4.31,0,0,1-1.631-1.934,7.033,7.033,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1-189.233-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413,3.257,3.257,0,0,0,2.72,1.226,3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408,3.3,3.3,0,0,0-2.729-1.211,3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0-197.612-5.322ZM-185.327,0h-.967V-15.2h.967Zm12.334-5.322a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1-177.729.2a4.5,4.5,0,0,1-2.461-.674,4.31,4.31,0,0,1-1.631-1.934,7.033,7.033,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1-172.993-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413,3.257,3.257,0,0,0,2.72,1.226,3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408,3.3,3.3,0,0,0-2.729-1.211,3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0-181.372-5.322ZM-165.815.2A4.546,4.546,0,0,1-169.38-1.24a5.782,5.782,0,0,1-1.289-4,5.879,5.879,0,0,1,1.338-4.106,4.7,4.7,0,0,1,3.662-1.47,7.363,7.363,0,0,1,2.637.479l-.264.859a7.739,7.739,0,0,0-2.393-.459,3.633,3.633,0,0,0-2.959,1.206,5.287,5.287,0,0,0-1.006,3.472A5.128,5.128,0,0,0-168.647-1.9a3.448,3.448,0,0,0,2.813,1.216,6.9,6.9,0,0,0,2.686-.518v.9A6.086,6.086,0,0,1-165.815.2Zm11.709-.2-.244-1.68h-.078a5.041,5.041,0,0,1-1.646,1.45,4.4,4.4,0,0,1-2,.425,3.455,3.455,0,0,1-2.432-.8,2.864,2.864,0,0,1-.869-2.217,2.735,2.735,0,0,1,1.294-2.412,7.036,7.036,0,0,1,3.745-.908l2.021-.059v-.7a3.61,3.61,0,0,0-.615-2.285,2.386,2.386,0,0,0-1.982-.771,6.631,6.631,0,0,0-3.057.82l-.361-.84a8.089,8.089,0,0,1,3.457-.82,3.446,3.446,0,0,1,2.612.908,3.99,3.99,0,0,1,.864,2.832V0Zm-3.906-.684a3.643,3.643,0,0,0,2.681-.972,3.629,3.629,0,0,0,.981-2.7V-5.4l-1.855.078a7.009,7.009,0,0,0-3.188.7,2.011,2.011,0,0,0-.952,1.841,1.98,1.98,0,0,0,.61,1.548A2.481,2.481,0,0,0-158.013-.684Zm9.023.684h-.967V-15.2h.967Zm4.521,0h-.967V-10.615h.967Zm-1.1-13.564q0-.937.615-.937a.546.546,0,0,1,.474.244,1.2,1.2,0,0,1,.171.693,1.227,1.227,0,0,1-.171.693.541.541,0,0,1-.474.254Q-145.571-12.617-145.571-13.564ZM-134.312,0h-7.578V-.615l6.3-9.141h-5.84v-.859h7.1V-10l-6.338,9.141h6.357Zm9.063,0-.244-1.68h-.078a5.041,5.041,0,0,1-1.646,1.45,4.4,4.4,0,0,1-2,.425,3.455,3.455,0,0,1-2.432-.8,2.864,2.864,0,0,1-.869-2.217,2.735,2.735,0,0,1,1.294-2.412,7.036,7.036,0,0,1,3.745-.908l2.021-.059v-.7a3.61,3.61,0,0,0-.615-2.285,2.386,2.386,0,0,0-1.982-.771,6.631,6.631,0,0,0-3.057.82l-.361-.84a8.089,8.089,0,0,1,3.457-.82,3.446,3.446,0,0,1,2.612.908,3.99,3.99,0,0,1,.864,2.832V0Zm-3.906-.684a3.643,3.643,0,0,0,2.681-.972,3.629,3.629,0,0,0,.981-2.7V-5.4l-1.855.078a7.009,7.009,0,0,0-3.188.7,2.011,2.011,0,0,0-.952,1.841,1.98,1.98,0,0,0,.61,1.548A2.481,2.481,0,0,0-129.155-.684ZM-116.86.2a4.546,4.546,0,0,1-3.564-1.436,5.782,5.782,0,0,1-1.289-4,5.879,5.879,0,0,1,1.338-4.106,4.7,4.7,0,0,1,3.662-1.47,7.363,7.363,0,0,1,2.637.479l-.264.859a7.739,7.739,0,0,0-2.393-.459,3.633,3.633,0,0,0-2.959,1.206A5.287,5.287,0,0,0-120.7-5.264,5.128,5.128,0,0,0-119.692-1.9,3.448,3.448,0,0,0-116.88-.684a6.9,6.9,0,0,0,2.686-.518v.9A6.086,6.086,0,0,1-116.86.2Zm1.045,2.646a1.719,1.719,0,0,1-.659,1.47,3.018,3.018,0,0,1-1.841.493,2.662,2.662,0,0,1-.918-.107V3.838a3.052,3.052,0,0,0,.9.1,2.057,2.057,0,0,0,1.162-.273.89.89,0,0,0,.4-.781q0-.918-1.885-1.182l.908-1.7h.938l-.645,1.143Q-115.815,1.5-115.815,2.842ZM-105.151,0l-.244-1.68h-.078a5.041,5.041,0,0,1-1.646,1.45,4.4,4.4,0,0,1-2,.425,3.455,3.455,0,0,1-2.432-.8,2.864,2.864,0,0,1-.869-2.217,2.735,2.735,0,0,1,1.294-2.412,7.036,7.036,0,0,1,3.745-.908l2.021-.059v-.7a3.61,3.61,0,0,0-.615-2.285,2.386,2.386,0,0,0-1.982-.771,6.631,6.631,0,0,0-3.057.82l-.361-.84a8.089,8.089,0,0,1,3.457-.82,3.446,3.446,0,0,1,2.612.908,3.99,3.99,0,0,1,.864,2.832V0Zm-3.906-.684a3.643,3.643,0,0,0,2.681-.972,3.629,3.629,0,0,0,.981-2.7V-5.4l-1.855.078a7.009,7.009,0,0,0-3.188.7,2.011,2.011,0,0,0-.952,1.841,1.98,1.98,0,0,0,.61,1.548A2.481,2.481,0,0,0-109.058-.684Zm2.49-11.455a1.707,1.707,0,0,1-.732-.181,4.925,4.925,0,0,1-.986-.7,7.455,7.455,0,0,0-.61-.449,1.1,1.1,0,0,0-.61-.2.931.931,0,0,0-.732.337,2.7,2.7,0,0,0-.469,1.187h-.713a3.021,3.021,0,0,1,.615-1.7,1.662,1.662,0,0,1,1.338-.62,1.59,1.59,0,0,1,.859.244,8.117,8.117,0,0,1,.8.576q.332.273.645.488a1.061,1.061,0,0,0,.6.215.948.948,0,0,0,.752-.356,2.651,2.651,0,0,0,.469-1.167h.742a3.272,3.272,0,0,1-.674,1.729A1.639,1.639,0,0,1-106.567-12.139Zm14.346,6.816a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1-96.958.2a4.5,4.5,0,0,1-2.461-.674,4.31,4.31,0,0,1-1.631-1.934,7.034,7.034,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048A4.34,4.34,0,0,1-96.9-10.82a4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1-92.222-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413,3.257,3.257,0,0,0,2.72,1.226A3.257,3.257,0,0,0-94.2-1.909a5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408,3.3,3.3,0,0,0-2.729-1.211,3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0-100.6-5.322Zm20.4-5.5a4.407,4.407,0,0,1,1.992.42,3.965,3.965,0,0,1,1.5,1.436h.059q-.059-1.23-.059-2.412V-15.2h.957V0h-.635l-.244-1.621H-76.7A3.928,3.928,0,0,1-80.181.2,4.164,4.164,0,0,1-83.54-1.172,6,6,0,0,1-84.7-5.156,6.656,6.656,0,0,1-83.55-9.365,4.018,4.018,0,0,1-80.2-10.82Zm0,.879a3,3,0,0,0-2.612,1.221,6.049,6.049,0,0,0-.874,3.545q0,4.512,3.506,4.512a3.182,3.182,0,0,0,2.637-1.045,5.546,5.546,0,0,0,.84-3.447v-.166a5.909,5.909,0,0,0-.825-3.54A3.15,3.15,0,0,0-80.2-9.941Zm16.8,4.619a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1-68.14.2,4.5,4.5,0,0,1-70.6-.479a4.31,4.31,0,0,1-1.631-1.934,7.034,7.034,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1-63.4-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413A3.257,3.257,0,0,0-68.1-.684a3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408A3.3,3.3,0,0,0-68.12-9.941a3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0-71.782-5.322Zm17.9,2.559A2.523,2.523,0,0,1-54.966-.571,5.276,5.276,0,0,1-58.042.2a7.336,7.336,0,0,1-3.379-.654V-1.5a7.457,7.457,0,0,0,3.379.8,4.457,4.457,0,0,0,2.388-.522,1.588,1.588,0,0,0,.815-1.392,1.7,1.7,0,0,0-.649-1.348,7.141,7.141,0,0,0-2.134-1.074,12.222,12.222,0,0,1-2.236-.991,3.09,3.09,0,0,1-.972-.937,2.355,2.355,0,0,1-.327-1.274,2.177,2.177,0,0,1,1-1.885,4.863,4.863,0,0,1,2.8-.693,8.377,8.377,0,0,1,3.262.645l-.361.879a7.649,7.649,0,0,0-2.9-.645,4.2,4.2,0,0,0-2.061.43,1.319,1.319,0,0,0-.762,1.191,1.649,1.649,0,0,0,.591,1.328,8.237,8.237,0,0,0,2.31,1.113,11.364,11.364,0,0,1,2.09.933A3.038,3.038,0,0,1-54.209-4,2.3,2.3,0,0,1-53.882-2.764ZM-43.628,0l-4.1-10.615h1L-43.989-3.4a22.229,22.229,0,0,1,.82,2.422h.059q.4-1.328.82-2.441l2.744-7.2h1L-42.651,0Zm11.143.2A4.625,4.625,0,0,1-36.094-1.23a5.73,5.73,0,0,1-1.294-3.994,6.227,6.227,0,0,1,1.25-4.067,4.126,4.126,0,0,1,3.369-1.528A3.638,3.638,0,0,1-29.81-9.512a5.4,5.4,0,0,1,1.084,3.555v.781h-7.646a5.022,5.022,0,0,0,1.021,3.34A3.592,3.592,0,0,0-32.485-.684a8.89,8.89,0,0,0,1.6-.127,9.7,9.7,0,0,0,1.743-.547v.879a7.775,7.775,0,0,1-1.66.532A9.214,9.214,0,0,1-32.485.2Zm-.283-10.156A3.18,3.18,0,0,0-35.229-8.95a4.767,4.767,0,0,0-1.084,2.915h6.563a4.629,4.629,0,0,0-.8-2.886A2.641,2.641,0,0,0-32.769-9.961ZM-24.829,0H-25.8V-10.615h.967Zm-1.7-12.275q.713-.771,1.411-1.675a11.509,11.509,0,0,0,.952-1.372h1.377v.166a10.682,10.682,0,0,1-1.2,1.348q-.845.84-1.86,1.689h-.684ZM-17.036.2A4.546,4.546,0,0,1-20.6-1.24a5.782,5.782,0,0,1-1.289-4,5.879,5.879,0,0,1,1.338-4.106,4.7,4.7,0,0,1,3.662-1.47,7.363,7.363,0,0,1,2.637.479l-.264.859a7.739,7.739,0,0,0-2.393-.459,3.633,3.633,0,0,0-2.959,1.206,5.287,5.287,0,0,0-1.006,3.472A5.128,5.128,0,0,0-19.868-1.9,3.448,3.448,0,0,0-17.056-.684,6.9,6.9,0,0,0-14.37-1.2v.9A6.086,6.086,0,0,1-17.036.2Zm6.1-10.811V-3.74a3.357,3.357,0,0,0,.674,2.329,2.72,2.72,0,0,0,2.09.728,3.648,3.648,0,0,0,2.788-.957,4.481,4.481,0,0,0,.894-3.115v-5.859h.957V0h-.82l-.176-1.465h-.059A3.99,3.99,0,0,1-8.267.2Q-11.89.2-11.89-3.682v-6.934ZM.991,0H.024V-15.2H.991ZM13.325-5.322a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1,8.589.2,4.5,4.5,0,0,1,6.128-.479,4.31,4.31,0,0,1,4.5-2.412a7.034,7.034,0,0,1-.566-2.91A5.974,5.974,0,0,1,5.19-9.37a4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1,13.325-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413A3.257,3.257,0,0,0,8.628-.684a3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408A3.3,3.3,0,0,0,8.608-9.941,3.252,3.252,0,0,0,5.9-8.735,5.391,5.391,0,0,0,4.946-5.322Zm17.9,2.559A2.523,2.523,0,0,1,21.763-.571,5.276,5.276,0,0,1,18.687.2a7.336,7.336,0,0,1-3.379-.654V-1.5a7.457,7.457,0,0,0,3.379.8,4.457,4.457,0,0,0,2.388-.522,1.588,1.588,0,0,0,.815-1.392,1.7,1.7,0,0,0-.649-1.348,7.141,7.141,0,0,0-2.134-1.074A12.222,12.222,0,0,1,16.87-6.03a3.09,3.09,0,0,1-.972-.937,2.355,2.355,0,0,1-.327-1.274,2.177,2.177,0,0,1,1-1.885,4.863,4.863,0,0,1,2.8-.693,8.377,8.377,0,0,1,3.262.645l-.361.879a7.649,7.649,0,0,0-2.9-.645,4.2,4.2,0,0,0-2.061.43,1.319,1.319,0,0,0-.762,1.191,1.649,1.649,0,0,0,.591,1.328,8.237,8.237,0,0,0,2.31,1.113,11.364,11.364,0,0,1,2.09.933A3.038,3.038,0,0,1,22.52-4,2.3,2.3,0,0,1,22.847-2.764ZM34.663-10.82a4.407,4.407,0,0,1,1.992.42,3.965,3.965,0,0,1,1.5,1.436h.059q-.059-1.23-.059-2.412V-15.2h.957V0h-.635l-.244-1.621h-.078A3.928,3.928,0,0,1,34.683.2a4.164,4.164,0,0,1-3.359-1.367,6,6,0,0,1-1.162-3.984,6.655,6.655,0,0,1,1.152-4.209A4.018,4.018,0,0,1,34.663-10.82Zm0,.879a3,3,0,0,0-2.612,1.221,6.049,6.049,0,0,0-.874,3.545q0,4.512,3.506,4.512a3.182,3.182,0,0,0,2.637-1.045,5.546,5.546,0,0,0,.84-3.447v-.166a5.909,5.909,0,0,0-.825-3.54A3.15,3.15,0,0,0,34.663-9.941ZM43.647,0h-.967V-10.615h.967Zm-1.1-13.564q0-.937.615-.937a.546.546,0,0,1,.474.244,1.2,1.2,0,0,1,.171.693,1.227,1.227,0,0,1-.171.693.541.541,0,0,1-.474.254Q42.544-12.617,42.544-13.564Zm8.838,2.744a8.307,8.307,0,0,1,1.445.137l-.186.928a5.656,5.656,0,0,0-1.377-.166A2.674,2.674,0,0,0,49.038-8.77a4.7,4.7,0,0,0-.869,2.91V0H47.2V-10.615h.82l.1,1.914h.068a4.5,4.5,0,0,1,1.4-1.646A3.271,3.271,0,0,1,51.382-10.82ZM58.872.2A4.625,4.625,0,0,1,55.264-1.23,5.73,5.73,0,0,1,53.97-5.225a6.227,6.227,0,0,1,1.25-4.067,4.126,4.126,0,0,1,3.369-1.528,3.638,3.638,0,0,1,2.959,1.309,5.4,5.4,0,0,1,1.084,3.555v.781H54.985a5.022,5.022,0,0,0,1.021,3.34A3.592,3.592,0,0,0,58.872-.684a8.89,8.89,0,0,0,1.6-.127,9.7,9.7,0,0,0,1.743-.547v.879a7.775,7.775,0,0,1-1.66.532A9.214,9.214,0,0,1,58.872.2ZM58.589-9.961A3.18,3.18,0,0,0,56.128-8.95a4.767,4.767,0,0,0-1.084,2.915h6.563a4.629,4.629,0,0,0-.8-2.886A2.641,2.641,0,0,0,58.589-9.961Zm9.775,9.3a7.252,7.252,0,0,0,1.6-.156v.781A5.124,5.124,0,0,1,68.345.2,2.639,2.639,0,0,1,66.27-.557,3.491,3.491,0,0,1,65.6-2.92V-9.775H64.028v-.566l1.572-.439.488-2.4h.5v2.568H69.7v.84H66.587v6.719a3.066,3.066,0,0,0,.43,1.807A1.56,1.56,0,0,0,68.364-.664ZM78.706,0l-.244-1.68h-.078a5.041,5.041,0,0,1-1.646,1.45,4.4,4.4,0,0,1-2,.425,3.455,3.455,0,0,1-2.432-.8,2.864,2.864,0,0,1-.869-2.217,2.735,2.735,0,0,1,1.294-2.412,7.036,7.036,0,0,1,3.745-.908L78.5-6.2v-.7a3.61,3.61,0,0,0-.615-2.285A2.386,2.386,0,0,0,75.9-9.961a6.631,6.631,0,0,0-3.057.82l-.361-.84a8.089,8.089,0,0,1,3.457-.82,3.446,3.446,0,0,1,2.612.908,3.99,3.99,0,0,1,.864,2.832V0ZM74.8-.684a3.643,3.643,0,0,0,2.681-.972,3.629,3.629,0,0,0,.981-2.7V-5.4l-1.855.078a7.009,7.009,0,0,0-3.188.7,2.011,2.011,0,0,0-.952,1.841,1.98,1.98,0,0,0,.61,1.548A2.481,2.481,0,0,0,74.8-.684ZM96.118,0V-6.963a3.467,3.467,0,0,0-.605-2.266,2.3,2.3,0,0,0-1.855-.713,3.029,3.029,0,0,0-2.412.9,4.236,4.236,0,0,0-.781,2.822V0h-.986V-7.256q0-2.686-2.461-2.686a2.9,2.9,0,0,0-2.432.972,5.061,5.061,0,0,0-.762,3.11V0h-.967V-10.615h.8l.205,1.455h.059a3.043,3.043,0,0,1,1.25-1.226,3.722,3.722,0,0,1,1.787-.435q2.51,0,3.223,1.885h.039a3.609,3.609,0,0,1,1.392-1.4A4,4,0,0,1,93.6-10.82a3.407,3.407,0,0,1,2.607.928,4.213,4.213,0,0,1,.869,2.949V0ZM104.8.2a4.625,4.625,0,0,1-3.608-1.426A5.73,5.73,0,0,1,99.9-5.225a6.227,6.227,0,0,1,1.25-4.067,4.126,4.126,0,0,1,3.369-1.528,3.638,3.638,0,0,1,2.959,1.309,5.4,5.4,0,0,1,1.084,3.555v.781h-7.646a5.022,5.022,0,0,0,1.021,3.34A3.592,3.592,0,0,0,104.8-.684a8.89,8.89,0,0,0,1.6-.127,9.7,9.7,0,0,0,1.743-.547v.879a7.775,7.775,0,0,1-1.66.532A9.214,9.214,0,0,1,104.8.2Zm-.283-10.156a3.18,3.18,0,0,0-2.461,1.011,4.767,4.767,0,0,0-1.084,2.915h6.563a4.629,4.629,0,0,0-.8-2.886A2.641,2.641,0,0,0,104.517-9.961ZM118.892,0V-6.885a3.357,3.357,0,0,0-.674-2.329,2.72,2.72,0,0,0-2.09-.728,3.618,3.618,0,0,0-2.788.962,4.535,4.535,0,0,0-.884,3.12V0h-.967V-10.615h.82L112.5-9.16h.059a3.99,3.99,0,0,1,3.682-1.66q3.613,0,3.613,3.877V0Zm7.2-.664a7.252,7.252,0,0,0,1.6-.156v.781A5.124,5.124,0,0,1,126.069.2a2.639,2.639,0,0,1-2.075-.752,3.491,3.491,0,0,1-.669-2.363V-9.775h-1.572v-.566l1.572-.439.488-2.4h.5v2.568h3.115v.84h-3.115v6.719a3.066,3.066,0,0,0,.43,1.807A1.56,1.56,0,0,0,126.089-.664ZM134.272.2a4.625,4.625,0,0,1-3.608-1.426,5.731,5.731,0,0,1-1.294-3.994,6.227,6.227,0,0,1,1.25-4.067,4.126,4.126,0,0,1,3.369-1.528,3.638,3.638,0,0,1,2.959,1.309,5.4,5.4,0,0,1,1.084,3.555v.781h-7.646a5.022,5.022,0,0,0,1.021,3.34,3.592,3.592,0,0,0,2.866,1.152,8.89,8.89,0,0,0,1.6-.127,9.7,9.7,0,0,0,1.743-.547v.879a7.775,7.775,0,0,1-1.66.532A9.214,9.214,0,0,1,134.272.2Zm-.283-10.156a3.18,3.18,0,0,0-2.461,1.011,4.767,4.767,0,0,0-1.084,2.915h6.563a4.629,4.629,0,0,0-.8-2.886A2.641,2.641,0,0,0,133.989-9.961ZM153.56,0V-6.885a3.357,3.357,0,0,0-.674-2.329,2.72,2.72,0,0,0-2.09-.728,3.618,3.618,0,0,0-2.788.962,4.535,4.535,0,0,0-.884,3.12V0h-.967V-10.615h.82l.186,1.455h.059a3.99,3.99,0,0,1,3.682-1.66q3.613,0,3.613,3.877V0Zm13.174-5.322a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1,162,.2a4.5,4.5,0,0,1-2.461-.674,4.31,4.31,0,0,1-1.631-1.934,7.033,7.033,0,0,1-.566-2.91A5.974,5.974,0,0,1,158.6-9.37a4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1,166.733-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413,3.257,3.257,0,0,0,2.72,1.226,3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408,3.3,3.3,0,0,0-2.729-1.211,3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0,158.354-5.322ZM182.271,0V-6.885a3.357,3.357,0,0,0-.674-2.329,2.72,2.72,0,0,0-2.09-.728,3.618,3.618,0,0,0-2.788.962,4.535,4.535,0,0,0-.884,3.12V0h-.967V-10.615h.82l.186,1.455h.059a3.99,3.99,0,0,1,3.682-1.66q3.613,0,3.613,3.877V0Zm13.174-5.322a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1,190.708.2a4.5,4.5,0,0,1-2.461-.674,4.31,4.31,0,0,1-1.631-1.934,7.033,7.033,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1,195.444-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413,3.257,3.257,0,0,0,2.72,1.226,3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408,3.3,3.3,0,0,0-2.729-1.211,3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0,187.065-5.322Zm17.9,2.559a2.523,2.523,0,0,1-1.084,2.192A5.276,5.276,0,0,1,200.806.2a7.336,7.336,0,0,1-3.379-.654V-1.5a7.457,7.457,0,0,0,3.379.8,4.457,4.457,0,0,0,2.388-.522,1.588,1.588,0,0,0,.815-1.392,1.7,1.7,0,0,0-.649-1.348,7.141,7.141,0,0,0-2.134-1.074,12.222,12.222,0,0,1-2.236-.991,3.09,3.09,0,0,1-.972-.937,2.355,2.355,0,0,1-.327-1.274,2.177,2.177,0,0,1,1-1.885,4.863,4.863,0,0,1,2.8-.693,8.377,8.377,0,0,1,3.262.645l-.361.879a7.649,7.649,0,0,0-2.9-.645,4.2,4.2,0,0,0-2.061.43,1.319,1.319,0,0,0-.762,1.191,1.649,1.649,0,0,0,.591,1.328,8.237,8.237,0,0,0,2.31,1.113,11.364,11.364,0,0,1,2.09.933,3.038,3.038,0,0,1,.981.942A2.3,2.3,0,0,1,204.966-2.764Zm9.316,0A2.523,2.523,0,0,1,213.2-.571,5.276,5.276,0,0,1,210.122.2a7.336,7.336,0,0,1-3.379-.654V-1.5a7.457,7.457,0,0,0,3.379.8,4.457,4.457,0,0,0,2.388-.522,1.588,1.588,0,0,0,.815-1.392,1.7,1.7,0,0,0-.649-1.348,7.141,7.141,0,0,0-2.134-1.074,12.222,12.222,0,0,1-2.236-.991,3.09,3.09,0,0,1-.972-.937,2.355,2.355,0,0,1-.327-1.274,2.177,2.177,0,0,1,1-1.885,4.863,4.863,0,0,1,2.8-.693,8.377,8.377,0,0,1,3.262.645l-.361.879a7.649,7.649,0,0,0-2.9-.645,4.2,4.2,0,0,0-2.061.43,1.319,1.319,0,0,0-.762,1.191,1.649,1.649,0,0,0,.591,1.328,8.237,8.237,0,0,0,2.31,1.113,11.364,11.364,0,0,1,2.09.933,3.038,3.038,0,0,1,.981.942A2.3,2.3,0,0,1,214.282-2.764ZM225.8-5.322a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1,221.06.2,4.5,4.5,0,0,1,218.6-.479a4.31,4.31,0,0,1-1.631-1.934,7.033,7.033,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1,225.8-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413A3.257,3.257,0,0,0,221.1-.684a3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408,3.3,3.3,0,0,0-2.729-1.211,3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0,217.417-5.322Zm23.1,2.559a2.523,2.523,0,0,1-1.084,2.192A5.276,5.276,0,0,1,236.353.2a7.336,7.336,0,0,1-3.379-.654V-1.5a7.457,7.457,0,0,0,3.379.8,4.457,4.457,0,0,0,2.388-.522,1.588,1.588,0,0,0,.815-1.392,1.7,1.7,0,0,0-.649-1.348,7.141,7.141,0,0,0-2.134-1.074,12.222,12.222,0,0,1-2.236-.991,3.09,3.09,0,0,1-.972-.937,2.355,2.355,0,0,1-.327-1.274,2.177,2.177,0,0,1,1-1.885,4.863,4.863,0,0,1,2.8-.693,8.377,8.377,0,0,1,3.262.645l-.361.879a7.649,7.649,0,0,0-2.9-.645,4.2,4.2,0,0,0-2.061.43,1.319,1.319,0,0,0-.762,1.191,1.649,1.649,0,0,0,.591,1.328,8.237,8.237,0,0,0,2.31,1.113,11.364,11.364,0,0,1,2.09.933,3.038,3.038,0,0,1,.981.942A2.3,2.3,0,0,1,240.513-2.764ZM244.214,0h-.967V-10.615h.967Zm-1.1-13.564q0-.937.615-.937a.546.546,0,0,1,.474.244,1.2,1.2,0,0,1,.171.693,1.227,1.227,0,0,1-.171.693.541.541,0,0,1-.474.254Q243.11-12.617,243.11-13.564Zm7.461,12.9a7.252,7.252,0,0,0,1.6-.156v.781A5.124,5.124,0,0,1,250.552.2a2.639,2.639,0,0,1-2.075-.752,3.491,3.491,0,0,1-.669-2.363V-9.775h-1.572v-.566l1.572-.439.488-2.4h.5v2.568h3.115v.84h-3.115v6.719a3.066,3.066,0,0,0,.43,1.807A1.56,1.56,0,0,0,250.571-.664ZM258.755.2a4.625,4.625,0,0,1-3.608-1.426,5.731,5.731,0,0,1-1.294-3.994,6.227,6.227,0,0,1,1.25-4.067,4.126,4.126,0,0,1,3.369-1.528,3.638,3.638,0,0,1,2.959,1.309,5.4,5.4,0,0,1,1.084,3.555v.781h-7.646a5.022,5.022,0,0,0,1.021,3.34,3.592,3.592,0,0,0,2.866,1.152,8.89,8.89,0,0,0,1.6-.127,9.7,9.7,0,0,0,1.743-.547v.879a7.775,7.775,0,0,1-1.66.532A9.214,9.214,0,0,1,258.755.2Zm-.283-10.156a3.18,3.18,0,0,0-2.461,1.011,4.767,4.767,0,0,0-1.084,2.915h6.563a4.629,4.629,0,0,0-.8-2.886A2.641,2.641,0,0,0,258.472-9.961Zm20.947,4.639a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1,274.683.2a4.5,4.5,0,0,1-2.461-.674,4.31,4.31,0,0,1-1.631-1.934,7.034,7.034,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1,279.419-5.322Zm-8.379,0A5.4,5.4,0,0,0,272-1.909a3.257,3.257,0,0,0,2.72,1.226,3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408A3.3,3.3,0,0,0,274.7-9.941a3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0,271.04-5.322ZM283.2-10.615V-3.74a3.357,3.357,0,0,0,.674,2.329,2.72,2.72,0,0,0,2.09.728,3.648,3.648,0,0,0,2.788-.957,4.481,4.481,0,0,0,.894-3.115v-5.859h.957V0h-.82L289.6-1.465h-.059A3.99,3.99,0,0,1,285.864.2q-3.623,0-3.623-3.877v-6.934ZM306.753,0V-6.885a3.357,3.357,0,0,0-.674-2.329,2.72,2.72,0,0,0-2.09-.728,3.618,3.618,0,0,0-2.788.962,4.534,4.534,0,0,0-.884,3.12V0h-.967V-10.615h.82l.186,1.455h.059a3.99,3.99,0,0,1,3.682-1.66q3.613,0,3.613,3.877V0Zm13.174-5.322a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1,315.19.2a4.5,4.5,0,0,1-2.461-.674A4.31,4.31,0,0,1,311.1-2.412a7.034,7.034,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1,319.927-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413,3.257,3.257,0,0,0,2.72,1.226,3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408,3.3,3.3,0,0,0-2.729-1.211,3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0,311.548-5.322Zm23.633.283h-5.8L327.388,0h-1.1l5.742-14.336h.635L338.286,0h-1.123Zm-5.439-.9h5.107l-1.943-5.146q-.244-.605-.586-1.68a15.658,15.658,0,0,1-.576,1.7ZM344.6.2a3.878,3.878,0,0,1-3.574-1.836h-.068l.029.82q.039.723.039,1.582V4.8h-.967v-15.42h.82l.186,1.514h.059a3.836,3.836,0,0,1,3.5-1.719A3.947,3.947,0,0,1,347.9-9.409,6.456,6.456,0,0,1,349.028-5.3a6.215,6.215,0,0,1-1.187,4.058A3.971,3.971,0,0,1,344.6.2Zm-.02-.859a2.953,2.953,0,0,0,2.524-1.211A5.615,5.615,0,0,0,348-5.264q0-4.678-3.379-4.678A3.387,3.387,0,0,0,341.9-8.921,5.107,5.107,0,0,0,341.03-5.6v.313a5.846,5.846,0,0,0,.835,3.555A3.248,3.248,0,0,0,344.585-.664ZM356.509.2a3.878,3.878,0,0,1-3.574-1.836h-.068l.029.82q.039.723.039,1.582V4.8h-.967v-15.42h.82l.186,1.514h.059a3.836,3.836,0,0,1,3.5-1.719A3.947,3.947,0,0,1,359.8-9.409,6.456,6.456,0,0,1,360.933-5.3a6.215,6.215,0,0,1-1.187,4.058A3.971,3.971,0,0,1,356.509.2Zm-.02-.859a2.953,2.953,0,0,0,2.524-1.211,5.615,5.615,0,0,0,.894-3.389q0-4.678-3.379-4.678A3.387,3.387,0,0,0,353.8-8.921a5.107,5.107,0,0,0-.869,3.325v.313a5.846,5.846,0,0,0,.835,3.555A3.248,3.248,0,0,0,356.489-.664ZM373.608.2a3.878,3.878,0,0,1-3.574-1.836h-.068L370-.82q.039.723.039,1.582V4.8h-.967v-15.42h.82l.186,1.514h.059a3.836,3.836,0,0,1,3.5-1.719A3.947,3.947,0,0,1,376.9-9.409,6.456,6.456,0,0,1,378.032-5.3a6.215,6.215,0,0,1-1.187,4.058A3.971,3.971,0,0,1,373.608.2Zm-.02-.859a2.953,2.953,0,0,0,2.524-1.211,5.615,5.615,0,0,0,.894-3.389q0-4.678-3.379-4.678A3.387,3.387,0,0,0,370.9-8.921a5.107,5.107,0,0,0-.869,3.325v.313a5.846,5.846,0,0,0,.835,3.555A3.248,3.248,0,0,0,373.589-.664ZM387.417,0l-.244-1.68h-.078a5.041,5.041,0,0,1-1.646,1.45,4.4,4.4,0,0,1-2,.425,3.455,3.455,0,0,1-2.432-.8,2.864,2.864,0,0,1-.869-2.217,2.735,2.735,0,0,1,1.294-2.412,7.036,7.036,0,0,1,3.745-.908l2.021-.059v-.7a3.61,3.61,0,0,0-.615-2.285,2.386,2.386,0,0,0-1.982-.771,6.631,6.631,0,0,0-3.057.82l-.361-.84a8.089,8.089,0,0,1,3.457-.82,3.446,3.446,0,0,1,2.612.908,3.99,3.99,0,0,1,.864,2.832V0Zm-3.906-.684a3.643,3.643,0,0,0,2.681-.972,3.629,3.629,0,0,0,.981-2.7V-5.4l-1.855.078a7.009,7.009,0,0,0-3.188.7,2.011,2.011,0,0,0-.952,1.841,1.98,1.98,0,0,0,.61,1.548A2.481,2.481,0,0,0,383.511-.684ZM395.747-10.82a8.307,8.307,0,0,1,1.445.137l-.186.928a5.656,5.656,0,0,0-1.377-.166A2.674,2.674,0,0,0,393.4-8.77a4.7,4.7,0,0,0-.869,2.91V0h-.967V-10.615h.82l.1,1.914h.068a4.5,4.5,0,0,1,1.4-1.646A3.271,3.271,0,0,1,395.747-10.82ZM405.4,0l-.244-1.68h-.078a5.041,5.041,0,0,1-1.646,1.45,4.4,4.4,0,0,1-2,.425A3.455,3.455,0,0,1,399-.605a2.864,2.864,0,0,1-.869-2.217,2.735,2.735,0,0,1,1.294-2.412,7.036,7.036,0,0,1,3.745-.908L405.19-6.2v-.7a3.61,3.61,0,0,0-.615-2.285,2.386,2.386,0,0,0-1.982-.771,6.631,6.631,0,0,0-3.057.82l-.361-.84a8.089,8.089,0,0,1,3.457-.82,3.446,3.446,0,0,1,2.612.908,3.99,3.99,0,0,1,.864,2.832V0Zm-3.906-.684a3.643,3.643,0,0,0,2.681-.972,3.629,3.629,0,0,0,.981-2.7V-5.4l-1.855.078a7.009,7.009,0,0,0-3.188.7,2.011,2.011,0,0,0-.952,1.841,1.98,1.98,0,0,0,.61,1.548A2.481,2.481,0,0,0,401.489-.684ZM428,0V-6.963a3.467,3.467,0,0,0-.605-2.266,2.3,2.3,0,0,0-1.855-.713,3.029,3.029,0,0,0-2.412.9,4.236,4.236,0,0,0-.781,2.822V0h-.986V-7.256q0-2.686-2.461-2.686a2.9,2.9,0,0,0-2.432.972,5.061,5.061,0,0,0-.762,3.11V0h-.967V-10.615h.8l.205,1.455h.059a3.043,3.043,0,0,1,1.25-1.226,3.722,3.722,0,0,1,1.787-.435q2.51,0,3.223,1.885h.039a3.609,3.609,0,0,1,1.392-1.4,4,4,0,0,1,1.987-.488,3.407,3.407,0,0,1,2.607.928,4.213,4.213,0,0,1,.869,2.949V0Zm13.174-5.322a6.013,6.013,0,0,1-1.26,4.058A4.349,4.349,0,0,1,436.44.2a4.5,4.5,0,0,1-2.461-.674,4.31,4.31,0,0,1-1.631-1.934,7.034,7.034,0,0,1-.566-2.91,5.974,5.974,0,0,1,1.26-4.048,4.34,4.34,0,0,1,3.457-1.45,4.258,4.258,0,0,1,3.433,1.47A6.036,6.036,0,0,1,441.177-5.322Zm-8.379,0a5.4,5.4,0,0,0,.962,3.413,3.257,3.257,0,0,0,2.72,1.226,3.257,3.257,0,0,0,2.72-1.226,5.4,5.4,0,0,0,.962-3.413,5.317,5.317,0,0,0-.972-3.408,3.3,3.3,0,0,0-2.729-1.211,3.252,3.252,0,0,0-2.71,1.206A5.391,5.391,0,0,0,432.8-5.322Zm15.8-5.5a4.05,4.05,0,0,1,3.354,1.4,6.414,6.414,0,0,1,1.128,4.1,6.246,6.246,0,0,1-1.187,4.082A4.086,4.086,0,0,1,448.56.2a4.384,4.384,0,0,1-2.041-.469A3.575,3.575,0,0,1,445.083-1.6H445L444.722,0h-.605V-15.2h.967v3.818q0,.859-.039,1.582l-.029.83h.068a3.876,3.876,0,0,1,1.46-1.406A4.367,4.367,0,0,1,448.6-10.82Zm-.02.879a3.15,3.15,0,0,0-2.686,1.074,5.99,5.99,0,0,0-.811,3.545v.166a5.522,5.522,0,0,0,.845,3.447A3.184,3.184,0,0,0,448.56-.664a3.021,3.021,0,0,0,2.617-1.216,5.843,5.843,0,0,0,.879-3.462Q452.056-9.941,448.579-9.941ZM456.987,0h-.967V-10.615h.967Zm-1.1-13.564q0-.937.615-.937a.546.546,0,0,1,.474.244,1.2,1.2,0,0,1,.171.693,1.228,1.228,0,0,1-.171.693.541.541,0,0,1-.474.254Q455.884-12.617,455.884-13.564ZM461.509,0h-.967V-15.2h.967Zm7.842.2a4.625,4.625,0,0,1-3.608-1.426,5.73,5.73,0,0,1-1.294-3.994,6.227,6.227,0,0,1,1.25-4.067,4.126,4.126,0,0,1,3.369-1.528,3.638,3.638,0,0,1,2.959,1.309,5.4,5.4,0,0,1,1.084,3.555v.781h-7.646a5.022,5.022,0,0,0,1.021,3.34,3.592,3.592,0,0,0,2.866,1.152,8.89,8.89,0,0,0,1.6-.127,9.7,9.7,0,0,0,1.743-.547v.879a7.775,7.775,0,0,1-1.66.532A9.214,9.214,0,0,1,469.351.2Zm-.283-10.156a3.18,3.18,0,0,0-2.461,1.011,4.767,4.767,0,0,0-1.084,2.915h6.563a4.629,4.629,0,0,0-.8-2.886A2.641,2.641,0,0,0,469.067-9.961Zm11.191,4.482a15.133,15.133,0,0,1,.757-4.844,12.041,12.041,0,0,1,2.183-3.955h1.1a13.013,13.013,0,0,0-2.217,4.028,14.552,14.552,0,0,0-.771,4.751,14.087,14.087,0,0,0,2.969,8.662H483.2a11.509,11.509,0,0,1-2.187-3.877A14.74,14.74,0,0,1,480.259-5.479ZM495.64,0l-1.426-3.965h-5.459L487.358,0H484.9l5.342-14.336h2.539L498.12,0ZM493.6-5.977l-1.338-3.887q-.146-.391-.405-1.23t-.356-1.23a21.888,21.888,0,0,1-.771,2.627l-1.289,3.721ZM509.263,0h-2.3V-6.641a2.906,2.906,0,0,0-.5-1.865,1.944,1.944,0,0,0-1.6-.615,2.539,2.539,0,0,0-2.129.859,4.745,4.745,0,0,0-.674,2.881V0h-2.295V-10.8h1.8l.322,1.416H502a3.2,3.2,0,0,1,1.387-1.191,4.647,4.647,0,0,1,1.992-.42q3.887,0,3.887,3.955ZM516.1.2a3.762,3.762,0,0,1-3.154-1.465,6.584,6.584,0,0,1-1.133-4.111,6.606,6.606,0,0,1,1.147-4.136A3.8,3.8,0,0,1,516.138-11a3.724,3.724,0,0,1,3.242,1.572h.117a13.76,13.76,0,0,1-.166-1.836V-15.2h2.3V0h-1.8l-.4-1.416h-.107A3.669,3.669,0,0,1,516.1.2Zm.615-1.855a2.5,2.5,0,0,0,2.061-.8,4.19,4.19,0,0,0,.664-2.583v-.322a4.841,4.841,0,0,0-.664-2.9,2.463,2.463,0,0,0-2.08-.859,2.11,2.11,0,0,0-1.865.981,5.029,5.029,0,0,0-.654,2.8A4.9,4.9,0,0,0,514.81-2.6,2.143,2.143,0,0,0,516.714-1.66ZM530.4-11a5.525,5.525,0,0,1,1.143.1l-.225,2.139a4.337,4.337,0,0,0-1.016-.117,2.939,2.939,0,0,0-2.231.9,3.248,3.248,0,0,0-.854,2.334V0h-2.295V-10.8h1.8l.3,1.9h.117a4.279,4.279,0,0,1,1.4-1.533A3.331,3.331,0,0,1,530.4-11ZM542.72-5.42a5.9,5.9,0,0,1-1.357,4.131A4.864,4.864,0,0,1,537.583.2a5.178,5.178,0,0,1-2.676-.684,4.513,4.513,0,0,1-1.787-1.963A6.685,6.685,0,0,1,532.5-5.42a5.855,5.855,0,0,1,1.348-4.1,4.886,4.886,0,0,1,3.8-1.475,4.758,4.758,0,0,1,3.711,1.509A5.828,5.828,0,0,1,542.72-5.42Zm-7.861,0q0,3.74,2.764,3.74,2.734,0,2.734-3.74,0-3.7-2.754-3.7a2.348,2.348,0,0,0-2.095.957A4.87,4.87,0,0,0,534.858-5.42ZM547.651,0h-2.295V-10.8h2.295ZM545.22-13.662a1.271,1.271,0,0,1,.337-.947,1.313,1.313,0,0,1,.962-.332,1.285,1.285,0,0,1,.942.332,1.271,1.271,0,0,1,.337.947,1.247,1.247,0,0,1-.337.923,1.274,1.274,0,0,1-.942.337,1.3,1.3,0,0,1-.962-.337A1.247,1.247,0,0,1,545.22-13.662ZM554.575.2a3.762,3.762,0,0,1-3.154-1.465,6.584,6.584,0,0,1-1.133-4.111,6.606,6.606,0,0,1,1.147-4.136A3.8,3.8,0,0,1,554.614-11a3.724,3.724,0,0,1,3.242,1.572h.117a13.76,13.76,0,0,1-.166-1.836V-15.2h2.3V0h-1.8l-.4-1.416h-.107A3.669,3.669,0,0,1,554.575.2Zm.615-1.855a2.5,2.5,0,0,0,2.061-.8,4.19,4.19,0,0,0,.664-2.583v-.322a4.841,4.841,0,0,0-.664-2.9,2.463,2.463,0,0,0-2.08-.859,2.11,2.11,0,0,0-1.865.981,5.029,5.029,0,0,0-.654,2.8,4.9,4.9,0,0,0,.635,2.739A2.143,2.143,0,0,0,555.19-1.66ZM573.306.2a5.225,5.225,0,0,1-3.94-1.47,5.579,5.579,0,0,1-1.421-4.048,6.121,6.121,0,0,1,1.318-4.16A4.554,4.554,0,0,1,572.886-11a4.451,4.451,0,0,1,3.379,1.3,4.963,4.963,0,0,1,1.24,3.574v1.24h-7.2a3.547,3.547,0,0,0,.85,2.417,2.959,2.959,0,0,0,2.256.845A8.328,8.328,0,0,0,575.2-1.8a9.343,9.343,0,0,0,1.772-.6V-.537a7.046,7.046,0,0,1-1.7.566A10.42,10.42,0,0,1,573.306.2Zm-.42-9.453a2.306,2.306,0,0,0-1.753.693,3.3,3.3,0,0,0-.786,2.021h4.9a2.989,2.989,0,0,0-.645-2.026A2.2,2.2,0,0,0,572.886-9.258ZM587.6,0h-2.295V-10.8H587.6Zm-2.432-13.662a1.271,1.271,0,0,1,.337-.947,1.313,1.313,0,0,1,.962-.332,1.285,1.285,0,0,1,.942.332,1.271,1.271,0,0,1,.337.947,1.247,1.247,0,0,1-.337.923,1.274,1.274,0,0,1-.942.337,1.3,1.3,0,0,1-.962-.337A1.247,1.247,0,0,1,585.171-13.662Zm18.633,6.5a7.81,7.81,0,0,1-1.743,5.42A6.3,6.3,0,0,1,597.124.2a6.348,6.348,0,0,1-4.966-1.919,7.859,7.859,0,0,1-1.733-5.454,7.737,7.737,0,0,1,1.743-5.43,6.423,6.423,0,0,1,4.976-1.895,6.293,6.293,0,0,1,4.922,1.924A7.8,7.8,0,0,1,603.8-7.158Zm-10.9,0a6.4,6.4,0,0,0,1.064,4A3.758,3.758,0,0,0,597.124-1.8a3.751,3.751,0,0,0,3.14-1.348,6.413,6.413,0,0,0,1.06-4.014,6.427,6.427,0,0,0-1.05-3.984,3.712,3.712,0,0,0-3.13-1.357,3.789,3.789,0,0,0-3.169,1.357A6.34,6.34,0,0,0,592.905-7.158Zm22.2,3.281a3.593,3.593,0,0,1-1.377,2.988A5.993,5.993,0,0,1,609.927.2a9.064,9.064,0,0,1-3.965-.752V-2.764a10.777,10.777,0,0,0,2.075.723,8.8,8.8,0,0,0,2.046.264,3.255,3.255,0,0,0,2.046-.527,1.72,1.72,0,0,0,.659-1.416,1.775,1.775,0,0,0-.605-1.357,9.115,9.115,0,0,0-2.5-1.318A6.614,6.614,0,0,1,606.929-8.2a3.823,3.823,0,0,1-.8-2.441,3.419,3.419,0,0,1,1.27-2.812,5.266,5.266,0,0,1,3.408-1.025,10.014,10.014,0,0,1,4.082.9l-.742,1.9a8.918,8.918,0,0,0-3.4-.8,2.608,2.608,0,0,0-1.719.493,1.62,1.62,0,0,0-.586,1.3,1.835,1.835,0,0,0,.234.952,2.394,2.394,0,0,0,.771.747,13.052,13.052,0,0,0,1.934.928,10.58,10.58,0,0,1,2.3,1.221,3.59,3.59,0,0,1,1.074,1.279A3.848,3.848,0,0,1,615.1-3.877Zm5.518-1.6a14.716,14.716,0,0,1-.757,4.785,11.447,11.447,0,0,1-2.183,3.857H616.6A14.087,14.087,0,0,0,619.565-5.5a14.581,14.581,0,0,0-.771-4.761,12.89,12.89,0,0,0-2.217-4.019h1.1a11.979,11.979,0,0,1,2.188,3.97A15.205,15.205,0,0,1,620.62-5.479ZM623-.762q0-.957.781-.957.8,0,.8.957t-.8.957Q623,.2,623-.762Z\" transform=\"translate(683 574)\"/>\r\n    <g id=\"LineColor\" transform=\"translate(0 536)\">\r\n      <rect id=\"azul\" class=\"hhyd-cls-4\" width=\"454.86\" height=\"5\" transform=\"translate(705.511)\"/>\r\n      <rect id=\"roxo\" class=\"hhyd-cls-5\" width=\"326.97\" height=\"5\" transform=\"translate(526.807)\"/>\r\n      <rect id=\"laranja\" class=\"hhyd-cls-6\" width=\"424.01\" height=\"5\" transform=\"translate(241.765)\"/>\r\n      <rect id=\"amarelo\" class=\"hhyd-cls-7\" width=\"383.38\" height=\"5\"/>\r\n      <rect id=\"verde\" class=\"hhyd-cls-8\" width=\"334.38\" height=\"5\" transform=\"translate(1033.041)\"/>\r\n    </g>\r\n    <g id=\"botaoComprar\" transform=\"translate(504.243 407.23)\">\r\n      <g id=\"button_sombra\" transform=\"translate(0 6.511)\">\r\n        <path id=\"Caminho_28305\" data-name=\"Caminho 28305\" class=\"hhyd-cls-9\" d=\"M365.81,381H652.287a35.789,35.789,0,0,1,35.81,35.81h0a35.789,35.789,0,0,1-35.81,35.81H365.81A35.789,35.789,0,0,1,330,416.81h0A35.789,35.789,0,0,1,365.81,381Z\" transform=\"translate(-330 -381)\"/>\r\n      </g>\r\n      <g id=\"button\">\r\n        <path id=\"Caminho_28306\" data-name=\"Caminho 28306\" class=\"hhyd-cls-10\" d=\"M365.81,376H652.287a35.789,35.789,0,0,1,35.81,35.81h0a35.789,35.789,0,0,1-35.81,35.81H365.81A35.789,35.789,0,0,1,330,411.81h0A35.789,35.789,0,0,1,365.81,376Z\" transform=\"translate(-330 -376)\"/>\r\n      </g>\r\n      <g id=\"Seta_Direita\" transform=\"translate(305.394 15.01)\">\r\n        <g id=\"Elipse_3\" transform=\"translate(1.777 1.747)\">\r\n          <g id=\"Grupo_52\" data-name=\"Grupo 52\">\r\n            <circle id=\"Elipse_15\" data-name=\"Elipse 15\" class=\"hhyd-cls-11\" cx=\"19.595\" cy=\"19.595\" r=\"19.595\"/>\r\n          </g>\r\n          <g id=\"Grupo_53\" data-name=\"Grupo 53\" transform=\"translate(0.141 0.172)\">\r\n            <path id=\"Caminho_28317\" data-name=\"Caminho 28317\" class=\"hhyd-cls-3\" d=\"M19.533,39.065A19.533,19.533,0,1,1,39.065,19.533,19.506,19.506,0,0,1,19.533,39.065Zm0-36.461A16.928,16.928,0,1,0,36.461,19.533,16.894,16.894,0,0,0,19.533,2.6Z\"/>\r\n          </g>\r\n        </g>\r\n        <g id=\"ic-chevron-right-48px\">\r\n          <g id=\"Caminho_892\" transform=\"translate(15.366 10.678)\">\r\n            <path id=\"Caminho_28318\" data-name=\"Caminho 28318\" class=\"hhyd-cls-3\" d=\"M14.274,8.2,11.8,10.674l8.2,8.2-8.2,8.2,2.474,2.474L24.952,18.878Z\" transform=\"translate(-11.8 -8.2)\"/>\r\n          </g>\r\n          <g id=\"Caminho_893\">\r\n            <path id=\"Caminho_28319\" data-name=\"Caminho 28319\" class=\"hhyd-cls-11\" d=\"M0,0H42.841V42.841H0Z\"/>\r\n          </g>\r\n        </g>\r\n      </g>\r\n      <path id=\"QueroAgora\" class=\"hhyd-cls-3\" d=\"M18.09-48.348a15.718,15.718,0,0,1,6.416,1.209,12.9,12.9,0,0,1,4.53,3.259,13.711,13.711,0,0,1,2.706,4.715,17.147,17.147,0,0,1,.9,5.535,16.8,16.8,0,0,1-.8,5.1,14.49,14.49,0,0,1-2.4,4.571l3.567,3.485-1.968,2.05-3.608-3.526a12.942,12.942,0,0,1-4.079,2.255,16.688,16.688,0,0,1-5.268.861A16.079,16.079,0,0,1,11.653-20.1a13.289,13.289,0,0,1-4.571-3.28,13.256,13.256,0,0,1-2.706-4.735,17.185,17.185,0,0,1-.84-5.637,16.5,16.5,0,0,1,.922-5.473A13.8,13.8,0,0,1,7.184-43.9a13.028,13.028,0,0,1,4.53-3.239A15.607,15.607,0,0,1,18.09-48.348Zm0,2.706a12.136,12.136,0,0,0-4.879.943,10.825,10.825,0,0,0-3.69,2.583A11.337,11.337,0,0,0,7.2-38.324a13.141,13.141,0,0,0-.8,4.612,14.61,14.61,0,0,0,.717,4.571A11.143,11.143,0,0,0,9.3-25.265a10.567,10.567,0,0,0,3.649,2.685,12.689,12.689,0,0,0,5.145,1.045,12.689,12.689,0,0,0,5.145-1.045,10.445,10.445,0,0,0,3.649-2.706,11.394,11.394,0,0,0,2.173-3.874,13.524,13.524,0,0,0,.676-4.51,14.684,14.684,0,0,0-.717-4.633A10.547,10.547,0,0,0,26.843-42.1a10.549,10.549,0,0,0-3.628-2.583A12.562,12.562,0,0,0,18.09-45.642Zm22.386,6.191v11.357a6.523,6.523,0,0,0,1.783,4.92,6.566,6.566,0,0,0,4.858,1.681,6.588,6.588,0,0,0,2.685-.533A6.315,6.315,0,0,0,51.893-23.5,6.85,6.85,0,0,0,53.267-25.7a7.382,7.382,0,0,0,.492-2.726V-39.451h2.706V-19.2H53.923l-.082-3.4a7.713,7.713,0,0,1-3.157,2.87,9.633,9.633,0,0,1-4.018.943,9.63,9.63,0,0,1-3.608-.656,8.318,8.318,0,0,1-2.829-1.845,8.2,8.2,0,0,1-1.845-2.89,10.711,10.711,0,0,1-.656-3.874v-11.4ZM82.008-28.135H64.378a7.267,7.267,0,0,0,.779,2.849,6.92,6.92,0,0,0,1.681,2.111A7.23,7.23,0,0,0,69.2-21.862a8.83,8.83,0,0,0,2.849.451,10.238,10.238,0,0,0,1.886-.184,11.25,11.25,0,0,0,1.906-.533,9.213,9.213,0,0,0,1.722-.861A5.166,5.166,0,0,0,78.892-24.2l1.845,1.64a9.288,9.288,0,0,1-3.895,2.829,12.919,12.919,0,0,1-4.8.943,11.6,11.6,0,0,1-4.182-.738,9.518,9.518,0,0,1-3.321-2.111,9.847,9.847,0,0,1-2.193-3.321,11.4,11.4,0,0,1-.8-4.366,11.054,11.054,0,0,1,.779-4.182,10.024,10.024,0,0,1,2.152-3.321A9.69,9.69,0,0,1,67.76-39a10.389,10.389,0,0,1,4.161-.738,11.9,11.9,0,0,1,4.223.656,8.63,8.63,0,0,1,3.362,2.132A9.035,9.035,0,0,1,81.6-33.322,13.034,13.034,0,0,1,82.008-28.135Zm-17.63-2.337H79.425a7.385,7.385,0,0,0-.635-2.931,6.208,6.208,0,0,0-1.6-2.152,6.96,6.96,0,0,0-2.357-1.312,9.017,9.017,0,0,0-2.87-.451,7.582,7.582,0,0,0-5.125,1.763A7.645,7.645,0,0,0,64.378-30.472Zm25.092-8.979.164,3.321a5.975,5.975,0,0,1,1.209-1.722,6.3,6.3,0,0,1,1.578-1.127,7.037,7.037,0,0,1,1.8-.615,9.6,9.6,0,0,1,1.845-.184,8.17,8.17,0,0,1,2.439.328,7.879,7.879,0,0,1,2.152,1.107l-1.271,2.3a6.031,6.031,0,0,0-3.485-1.066,6.178,6.178,0,0,0-2.46.492,6.275,6.275,0,0,0-1.988,1.332,6.217,6.217,0,0,0-1.332,2.009,6.537,6.537,0,0,0-.492,2.562V-19.2H86.886V-39.451Zm22.919-.287a11.045,11.045,0,0,1,4.12.758,9.658,9.658,0,0,1,3.3,2.152A10.074,10.074,0,0,1,122-33.486a11.177,11.177,0,0,1,.8,4.284,11.278,11.278,0,0,1-.779,4.264,9.644,9.644,0,0,1-2.173,3.3,9.559,9.559,0,0,1-3.3,2.111,11.432,11.432,0,0,1-4.161.738,11.316,11.316,0,0,1-4.12-.738,9.559,9.559,0,0,1-3.3-2.111,9.894,9.894,0,0,1-2.193-3.3,11.023,11.023,0,0,1-.8-4.264,11.436,11.436,0,0,1,.779-4.284,9.977,9.977,0,0,1,2.152-3.341,9.444,9.444,0,0,1,3.28-2.152A11.272,11.272,0,0,1,112.388-39.738Zm0,2.5a7.909,7.909,0,0,0-3.1.594,7.226,7.226,0,0,0-2.439,1.66,7.332,7.332,0,0,0-1.578,2.542,9.156,9.156,0,0,0-.553,3.239,8.7,8.7,0,0,0,.574,3.218,7.343,7.343,0,0,0,1.578,2.48,6.816,6.816,0,0,0,2.419,1.578,8.423,8.423,0,0,0,3.1.553,8.379,8.379,0,0,0,3.116-.553,7.067,7.067,0,0,0,2.419-1.578,6.949,6.949,0,0,0,1.578-2.48,8.989,8.989,0,0,0,.553-3.218,8.864,8.864,0,0,0-.574-3.239,7.761,7.761,0,0,0-1.578-2.542,7.01,7.01,0,0,0-2.419-1.66A7.909,7.909,0,0,0,112.388-37.237Zm45.222,11.4H140.965L138.013-19.2h-3.034l12.874-28.7h2.87L163.6-19.2h-3.034Zm-15.5-2.624h14.35l-7.175-16.318Zm42.065-12.218,1.886,1.558-2.173,2.583a13.006,13.006,0,0,1,1.927,2.788,8.617,8.617,0,0,1,.779,3.936,9.8,9.8,0,0,1-.369,2.665,8.721,8.721,0,0,1-1.127,2.46,8.37,8.37,0,0,1-1.906,2.029,8.082,8.082,0,0,1-2.706,1.332,9.225,9.225,0,0,1,4.428,2.439,5.9,5.9,0,0,1,1.558,4.2,6.294,6.294,0,0,1-.881,3.362,7.751,7.751,0,0,1-2.316,2.4,10.792,10.792,0,0,1-3.321,1.455,15.367,15.367,0,0,1-3.895.492A14.354,14.354,0,0,1,172-7.533a9.5,9.5,0,0,1-3.259-1.64,7.757,7.757,0,0,1-2.152-2.644,7.777,7.777,0,0,1-.779-3.526h2.747a4.917,4.917,0,0,0,.615,2.5,5.442,5.442,0,0,0,1.66,1.783,7.488,7.488,0,0,0,2.419,1.066,11.375,11.375,0,0,0,2.808.348,13.5,13.5,0,0,0,2.767-.287,8.584,8.584,0,0,0,2.439-.881,5.175,5.175,0,0,0,1.742-1.558,3.928,3.928,0,0,0,.676-2.316A4.017,4.017,0,0,0,183.03-17a5.314,5.314,0,0,0-1.742-1.6,8.53,8.53,0,0,0-2.46-.943,12.63,12.63,0,0,0-2.767-.307,12.983,12.983,0,0,1-4.284-.676,9.75,9.75,0,0,1-3.362-1.947,8.646,8.646,0,0,1-2.193-3.116,10.774,10.774,0,0,1-.779-4.223,9.465,9.465,0,0,1,.943-4.325,9.578,9.578,0,0,1,2.46-3.116,10.342,10.342,0,0,1,3.4-1.865,12.23,12.23,0,0,1,3.813-.615,15.082,15.082,0,0,1,1.537.082,10.914,10.914,0,0,1,1.6.287,11.269,11.269,0,0,1,1.537.512,6.645,6.645,0,0,1,1.312.717ZM176.06-37.2a9.4,9.4,0,0,0-2.788.43,7.387,7.387,0,0,0-2.521,1.353,6.978,6.978,0,0,0-1.824,2.316,7.251,7.251,0,0,0-.7,3.28,8.073,8.073,0,0,0,.615,3.28,6.578,6.578,0,0,0,1.66,2.316,6.759,6.759,0,0,0,2.48,1.373,10.2,10.2,0,0,0,3.075.451,8.281,8.281,0,0,0,3.2-.594,7.656,7.656,0,0,0,2.46-1.6,6.945,6.945,0,0,0,1.578-2.357,7.506,7.506,0,0,0,.553-2.87,7.634,7.634,0,0,0-.656-3.28,6.563,6.563,0,0,0-1.742-2.3,7.382,7.382,0,0,0-2.5-1.353A9.46,9.46,0,0,0,176.06-37.2Zm24.8-2.542a11.045,11.045,0,0,1,4.12.758,9.658,9.658,0,0,1,3.3,2.152,10.074,10.074,0,0,1,2.193,3.341,11.177,11.177,0,0,1,.8,4.284,11.278,11.278,0,0,1-.779,4.264,9.644,9.644,0,0,1-2.173,3.3,9.559,9.559,0,0,1-3.3,2.111,11.432,11.432,0,0,1-4.161.738,11.316,11.316,0,0,1-4.12-.738,9.559,9.559,0,0,1-3.3-2.111,9.894,9.894,0,0,1-2.193-3.3,11.023,11.023,0,0,1-.8-4.264,11.436,11.436,0,0,1,.779-4.284,9.977,9.977,0,0,1,2.152-3.341,9.444,9.444,0,0,1,3.28-2.152A11.272,11.272,0,0,1,200.865-39.738Zm0,2.5a7.909,7.909,0,0,0-3.1.594,7.226,7.226,0,0,0-2.439,1.66,7.332,7.332,0,0,0-1.578,2.542A9.156,9.156,0,0,0,193.2-29.2a8.7,8.7,0,0,0,.574,3.218,7.344,7.344,0,0,0,1.578,2.48,6.816,6.816,0,0,0,2.419,1.578,8.423,8.423,0,0,0,3.1.553,8.379,8.379,0,0,0,3.116-.553A7.067,7.067,0,0,0,206.4-23.5a6.949,6.949,0,0,0,1.578-2.48,8.988,8.988,0,0,0,.553-3.218,8.863,8.863,0,0,0-.574-3.239,7.761,7.761,0,0,0-1.578-2.542,7.01,7.01,0,0,0-2.419-1.66A7.909,7.909,0,0,0,200.865-37.237Zm18.081-2.214.164,3.321a5.975,5.975,0,0,1,1.209-1.722A6.3,6.3,0,0,1,221.9-38.98a7.037,7.037,0,0,1,1.8-.615,9.6,9.6,0,0,1,1.845-.184,8.17,8.17,0,0,1,2.439.328,7.878,7.878,0,0,1,2.152,1.107l-1.271,2.3a6.032,6.032,0,0,0-3.485-1.066,6.178,6.178,0,0,0-2.46.492,6.275,6.275,0,0,0-1.988,1.332,6.217,6.217,0,0,0-1.332,2.009,6.537,6.537,0,0,0-.492,2.562V-19.2h-2.747V-39.451Zm31.569,4.018v-4.018H253.1V-19.2h-2.542v-4.018a8.429,8.429,0,0,1-1.578,1.947,9.561,9.561,0,0,1-1.968,1.394,9.035,9.035,0,0,1-2.193.82,10.123,10.123,0,0,1-2.3.266,10.879,10.879,0,0,1-4.038-.738,9.87,9.87,0,0,1-3.28-2.111,9.7,9.7,0,0,1-2.214-3.321,11.4,11.4,0,0,1-.8-4.366,10.89,10.89,0,0,1,.82-4.3,9.921,9.921,0,0,1,2.214-3.28A9.758,9.758,0,0,1,238.5-39a11.04,11.04,0,0,1,4.059-.738,10.664,10.664,0,0,1,2.337.266,9.447,9.447,0,0,1,2.234.8,8.463,8.463,0,0,1,1.927,1.353A7.256,7.256,0,0,1,250.515-35.433Zm-7.872-1.8a7.937,7.937,0,0,0-3.013.574,7.5,7.5,0,0,0-2.46,1.6,7.236,7.236,0,0,0-1.64,2.5,8.591,8.591,0,0,0-.595,3.239,8.548,8.548,0,0,0,.595,3.259,7.5,7.5,0,0,0,1.64,2.5,7.342,7.342,0,0,0,2.46,1.619,7.937,7.937,0,0,0,3.013.574,7.673,7.673,0,0,0,4.366-1.168,7.422,7.422,0,0,0,2.6-2.931,8.617,8.617,0,0,0,.861-3.833,8.617,8.617,0,0,0-.861-3.833,7.422,7.422,0,0,0-2.6-2.931A7.673,7.673,0,0,0,242.643-37.237ZM262.938-47.9V-25.47h-2.911V-47.9Zm-3.4,26.9a1.8,1.8,0,0,1,.635-1.517,2.227,2.227,0,0,1,1.394-.492,2.227,2.227,0,0,1,1.394.492A1.8,1.8,0,0,1,263.594-21a1.809,1.809,0,0,1-.635,1.5,2.172,2.172,0,0,1-1.394.512,2.172,2.172,0,0,1-1.394-.512A1.809,1.809,0,0,1,259.535-21Z\" transform=\"translate(22.994 68.512)\"/>\r\n    </g>\r\n    <g id=\"TextoCentro\">\r\n      <path id=\"voce\" class=\"hhyd-cls-12\" d=\"M39.644-104.728H-1.7L43.46.636h38.8L125.5-104.728H84.164L72.928-75.472l-10.6,33.92L51.092-75.472Zm147.34-2.332c-30.316,0-59.784,16.112-59.784,54.908,0,38.16,29.68,54.7,59.784,54.7,29.468,0,59.784-16.536,59.784-54.7S217.936-107.06,186.984-107.06Zm0,77.592c-13.78,0-21.624-10.6-21.624-22.684s7.844-22.9,21.624-22.9,21.624,10.812,21.624,22.9C208.608-39.432,200.128-29.468,186.984-29.468Zm151.58-9.54a26.426,26.426,0,0,1-19.5,8.692c-14.84,0-22.684-10.176-22.684-21.624,0-13.144,8.056-23.956,22.9-23.956a23.748,23.748,0,0,1,18.02,7.632l20.776-22.472c-11.024-11.024-26.076-16.324-41.128-16.324-29.468,0-58.724,16.748-58.724,54.908,0,39.22,28.832,54.272,59.36,54.272,15.688,0,30.74-6.572,43.248-17.808Zm66.78-27.348c2.544-17.172,36.888-16.536,37.948,0ZM424-107.272c-28.408,0-58.3,16.96-58.3,55.12S393.684,2.332,426.756,2.332c18.02,0,35.192-5.724,47.7-17.384l-19.08-21.412c-6.784,5.088-15.476,8.48-26.924,8.48-8.48,0-20.564-4.028-23.32-13.356h73.14C487.176-82.68,461.1-107.272,424-107.272Zm-11.66-43.46-32.224,33.284v1.7h33.5l10.812-9.964,10.812,9.964h33.5v-1.7l-32.224-33.284Z\" transform=\"translate(726 331)\"/>\r\n      <path id=\"para\" class=\"hhyd-cls-3\" d=\"M50.218-8.862C55.915-1.9,65.832,2.321,79.125,2.321c30.384,0,50.64-22.577,50.64-54.438,0-32.916-17.091-52.117-47.686-54.016-11.605-.633-25.531,2.954-34.393,13.082L46-104.234h-34.6v147.7H50.218ZM70.263-29.118c-13.715,0-20.889-11.394-20.889-24.054,0-10.972,7.807-21.733,20.889-21.733,11.605,0,20.889,8.229,20.889,22.788S81.868-29.118,70.263-29.118ZM222.605-93.051c-5.486-8.44-15.825-13.5-30.6-13.5-30.384,0-50.64,23.632-50.64,54.438C141.37-21.733,158.461,0,189.056,1.9c11.605.633,25.531-2.954,34.393-13.082L225.137,0h35.87V-104.234H224.5ZM200.872-75.116c13.715,0,21.522,9.073,21.522,23,0,12.238-8.44,22.788-21.522,22.788-11.605,0-20.889-8.229-20.889-22.788S189.267-75.116,200.872-75.116ZM283.8-104.234V0h38.824V-54.227c0-13.715,8.229-19.623,17.935-19.623,6.541,0,11.183,1.266,17.513,6.33l15.614-28.063c-6.752-7.174-16.88-11.183-27.43-11.183-10.128,0-19.834,4.22-25.32,13.926l-2.321-11.394ZM456.182-93.051c-5.486-8.44-15.825-13.5-30.6-13.5-30.384,0-50.64,23.632-50.64,54.438C374.947-21.733,392.038,0,422.633,1.9c11.605.633,25.531-2.954,34.393-13.082L458.714,0h35.87V-104.234h-36.5ZM434.449-75.116c13.715,0,21.522,9.073,21.522,23,0,12.238-8.44,22.788-21.522,22.788-11.605,0-20.889-8.229-20.889-22.788S422.844-75.116,434.449-75.116Z\" transform=\"translate(218 330)\"/>\r\n      <path id=\"mais\" class=\"hhyd-cls-13\" d=\"M8.44-84.4v32.283h28.7v28.063H71.951V-52.117h28.907V-84.4H71.951v-27.852H37.136V-84.4Z\" transform=\"translate(109 350)\"/>\r\n      <path id=\"TextoSlogan\" class=\"hhyd-cls-12\" d=\"M3.358-18.626H15.7V-20.09H1.837V0H16.043V-1.492H3.358V-9.414H15.125V-10.82H3.358ZM23.792,0h1.55l5.941-14.178h-1.55L24.567-1.636,19.4-14.178h-1.55ZM35.014-14.235V0H33.608V-14.235ZM33.206-18.8a1.134,1.134,0,0,1,2.267,0A1.134,1.134,0,0,1,33.206-18.8Zm7.692.488v4.133H37.884V-13H40.9v8.639C40.9-1.579,41.873.2,44.887.2a6.2,6.2,0,0,0,2.669-.718l-.488-1.148a5.259,5.259,0,0,1-2.181.574c-2.21,0-2.612-1.349-2.612-3.272V-13H47.1v-1.177H42.275v-4.276ZM56.74.2a7.794,7.794,0,0,0,6.113-2.726l-1-.8A6.668,6.668,0,0,1,56.74-1.177a5.578,5.578,0,0,1-5.769-5.252H63.743c.545-5.539-3.014-7.979-7-7.979a7.127,7.127,0,0,0-7.2,7.318A6.953,6.953,0,0,0,56.74.2ZM50.971-7.663a5.667,5.667,0,0,1,5.769-5.453c3.415,0,5.711,1.952,5.74,5.453ZM78.121,0V-12.829H82.8v-1.234H78.121v-1.263c0-2.468,1.033-3.559,2.813-3.559a3.88,3.88,0,0,1,2.181.717L83.8-19.2a4.639,4.639,0,0,0-2.813-.976c-3.128,0-4.248,2.038-4.248,4.85v1.263h-2.9v1.234h2.9V0Zm9.1-14.235V0H85.813V-14.235ZM85.411-18.8a1.134,1.134,0,0,1,2.267,0A1.134,1.134,0,0,1,85.411-18.8Zm5.826-1.292V0h1.406V-20.09ZM108.8-14.178v3.1A6.432,6.432,0,0,0,103-14.35a7.045,7.045,0,0,0-7.2,7.261A7.093,7.093,0,0,0,103,.23a6.629,6.629,0,0,0,5.8-3.243V0h1.406V-14.178ZM103-13c7.893,0,7.893,11.853,0,11.853a5.694,5.694,0,0,1-5.8-5.941A5.67,5.67,0,0,1,103-13Zm21.611.488a7.43,7.43,0,0,0-5.281-1.894c-2.87-.029-5.654,1.177-5.625,3.961.029,2.841,2.755,3.358,5.51,3.817,2.325.373,4.678.775,4.621,2.813-.086,2.239-2.7,2.7-4.42,2.7a6.292,6.292,0,0,1-5.195-2.411l-1.033.918c1.234,1.894,3.7,2.841,6.2,2.841s5.74-.832,5.826-3.961c.144-3.3-3.329-3.731-5.855-4.162-1.779-.316-4.248-.689-4.305-2.583-.057-1.808,2.066-2.64,4.276-2.612a6.062,6.062,0,0,1,4.42,1.492ZM142.639.2a7.794,7.794,0,0,0,6.113-2.726l-1-.8a6.668,6.668,0,0,1-5.109,2.152,5.578,5.578,0,0,1-5.769-5.252h12.771c.545-5.539-3.014-7.979-7-7.979a7.127,7.127,0,0,0-7.2,7.318A6.953,6.953,0,0,0,142.639.2ZM136.87-7.663a5.667,5.667,0,0,1,5.769-5.453c3.415,0,5.711,1.952,5.74,5.453Zm31.513,6.572a5.706,5.706,0,0,1-5.74-5.97,5.673,5.673,0,0,1,5.74-5.97c3.214,0,5.8,1.952,5.8,5.941S171.6-1.091,168.383-1.091Zm-5.855,7V-3.272a6.4,6.4,0,0,0,5.855,3.53c3.989,0,7.2-2.583,7.2-7.347a6.836,6.836,0,0,0-6.888-7.29,6.757,6.757,0,0,0-6.142,3.559v-3.358h-1.378V5.912Zm28.729-20.09v3.1a6.432,6.432,0,0,0-5.8-3.272,7.045,7.045,0,0,0-7.2,7.261,7.093,7.093,0,0,0,7.2,7.319,6.629,6.629,0,0,0,5.8-3.243V0h1.406V-14.178ZM185.459-13c7.893,0,7.893,11.853,0,11.853a5.694,5.694,0,0,1-5.8-5.941A5.67,5.67,0,0,1,185.459-13Zm11.021-1.177V0h1.406V-8.266A4.709,4.709,0,0,1,202.565-13a4.559,4.559,0,0,1,2.411.66l.631-1.148a5.535,5.535,0,0,0-3.042-.832,4.988,4.988,0,0,0-4.707,2.669l-.057-2.526Zm23.477,0v3.1a6.432,6.432,0,0,0-5.8-3.272,7.045,7.045,0,0,0-7.2,7.261,7.093,7.093,0,0,0,7.2,7.319,6.629,6.629,0,0,0,5.8-3.243V0h1.406V-14.178ZM214.159-13c7.893,0,7.893,11.853,0,11.853a5.694,5.694,0,0,1-5.8-5.941A5.67,5.67,0,0,1,214.159-13Zm17.421-.057a5.678,5.678,0,0,1,5.8,5.941,5.669,5.669,0,0,1-5.8,5.97c-3.186,0-5.8-2.009-5.8-5.941C225.783-11.078,228.395-13.059,231.58-13.059Zm5.826-7.031v9.012a6.276,6.276,0,0,0-5.883-3.329c-3.961,0-7.118,2.64-7.118,7.318,0,4.707,3.128,7.319,7.089,7.319a6.676,6.676,0,0,0,5.912-3.358V0h1.378V-20.09Zm17.651,5.912v3.1a6.432,6.432,0,0,0-5.8-3.272,7.045,7.045,0,0,0-7.2,7.261A7.093,7.093,0,0,0,249.26.23a6.629,6.629,0,0,0,5.8-3.243V0h1.406V-14.178ZM249.26-13c7.893,0,7.893,11.853,0,11.853a5.694,5.694,0,0,1-5.8-5.941A5.67,5.67,0,0,1,249.26-13Zm21.611.488a7.43,7.43,0,0,0-5.281-1.894c-2.87-.029-5.654,1.177-5.625,3.961.029,2.841,2.755,3.358,5.51,3.817,2.325.373,4.678.775,4.621,2.813-.086,2.239-2.7,2.7-4.42,2.7a6.292,6.292,0,0,1-5.195-2.411l-1.033.918c1.234,1.894,3.7,2.841,6.2,2.841s5.74-.832,5.826-3.961c.143-3.3-3.329-3.731-5.855-4.162-1.779-.316-4.248-.689-4.3-2.583-.057-1.808,2.066-2.64,4.276-2.612a6.062,6.062,0,0,1,4.42,1.492Zm11.624-1.665V0H283.9V-7.893a4.927,4.927,0,0,1,4.965-5.166c3.071-.029,5.051,1.693,5.051,4.908V0h1.406V-8.18c0-3.932-2.612-6.257-6.4-6.257a5.641,5.641,0,0,0-5.051,2.784v-2.526ZM305.54.2a6.93,6.93,0,0,0,7.2-7.261,7.025,7.025,0,0,0-7.2-7.376,7.025,7.025,0,0,0-7.2,7.376A6.93,6.93,0,0,0,305.54.2Zm0-1.378a5.6,5.6,0,0,1-5.826-5.884,5.747,5.747,0,0,1,5.826-6.056,5.747,5.747,0,0,1,5.826,6.056A5.6,5.6,0,0,1,305.54-1.177Zm21.037-11.336a7.43,7.43,0,0,0-5.281-1.894c-2.87-.029-5.654,1.177-5.625,3.961.029,2.841,2.755,3.358,5.51,3.817,2.325.373,4.678.775,4.621,2.813-.086,2.239-2.7,2.7-4.42,2.7a6.292,6.292,0,0,1-5.195-2.411l-1.033.918c1.234,1.894,3.7,2.841,6.2,2.841s5.74-.832,5.826-3.961c.143-3.3-3.329-3.731-5.855-4.162-1.779-.316-4.248-.689-4.3-2.583-.057-1.808,2.066-2.64,4.276-2.612a6.062,6.062,0,0,1,4.42,1.492ZM345.4-1.091a5.706,5.706,0,0,1-5.74-5.97,5.673,5.673,0,0,1,5.74-5.97c3.214,0,5.8,1.952,5.8,5.941S348.619-1.091,345.4-1.091Zm-5.855,7V-3.272A6.4,6.4,0,0,0,345.4.258c3.989,0,7.2-2.583,7.2-7.347a6.836,6.836,0,0,0-6.888-7.29,6.757,6.757,0,0,0-6.142,3.559v-3.358H338.2V5.912ZM362.452.2a7.794,7.794,0,0,0,6.113-2.726l-1-.8a6.668,6.668,0,0,1-5.109,2.152,5.578,5.578,0,0,1-5.769-5.252h12.772c.545-5.539-3.014-7.979-7-7.979a7.127,7.127,0,0,0-7.2,7.318A6.953,6.953,0,0,0,362.452.2Zm-5.769-7.864a5.667,5.667,0,0,1,5.769-5.453c3.415,0,5.711,1.952,5.74,5.453Zm22.816-5.4a5.678,5.678,0,0,1,5.8,5.941,5.669,5.669,0,0,1-5.8,5.97c-3.186,0-5.8-2.009-5.8-5.941C373.7-11.078,376.314-13.059,379.5-13.059Zm5.826-7.031v9.012a6.276,6.276,0,0,0-5.883-3.329c-3.961,0-7.118,2.64-7.118,7.318,0,4.707,3.128,7.319,7.089,7.319a6.676,6.676,0,0,0,5.912-3.358V0H386.7V-20.09Zm19.057,5.912V0h-1.406V-3.013a6.628,6.628,0,0,1-5.8,3.243,7.093,7.093,0,0,1-7.2-7.319,7.045,7.045,0,0,1,7.2-7.261,6.432,6.432,0,0,1,5.8,3.272v-3.1ZM397.179-13a5.67,5.67,0,0,0-5.8,5.912,5.694,5.694,0,0,0,5.8,5.941C405.072-1.148,405.072-13,397.179-13Zm-.89-3.7v-.115l2.152-3.444h1.865v.029l-2.64,3.53Zm21.927,3.559a7.2,7.2,0,0,0-4.018-1.292c-3.674,0-6.658,2.5-6.658,6.917A6.5,6.5,0,0,0,414.2-.66c2.64,0,5.367,1.205,5.367,4.248,0,3.014-2.526,4.276-5.367,4.276s-5.31-1.378-5.31-4.276h-1.406c0,3.588,2.956,5.654,6.716,5.654s6.744-1.837,6.744-5.654c0-2.44-1.378-4.19-3.874-5.08a6.7,6.7,0,0,0,3.817-6.027,6.645,6.645,0,0,0-1.751-4.822l1.378-1.607-.918-.8Zm-4.018.115a5.1,5.1,0,0,1,5.309,5.51A5.44,5.44,0,0,1,414.2-2.066a5.194,5.194,0,0,1-5.252-5.453C408.946-11.222,411.3-13.03,414.2-13.03Zm10.992-1.205V0h-1.406V-14.235ZM423.382-18.8a1.134,1.134,0,0,1,2.267,0A1.134,1.134,0,0,1,423.382-18.8ZM436.068.2a6.93,6.93,0,0,0,7.2-7.261,7.025,7.025,0,0,0-7.2-7.376,7.025,7.025,0,0,0-7.2,7.376A6.93,6.93,0,0,0,436.068.2Zm0-1.378a5.6,5.6,0,0,1-5.826-5.884,5.747,5.747,0,0,1,5.826-6.056,5.747,5.747,0,0,1,5.826,6.056A5.6,5.6,0,0,1,436.068-1.177ZM457.1-12.513a7.43,7.43,0,0,0-5.281-1.894c-2.87-.029-5.654,1.177-5.625,3.961.029,2.841,2.755,3.358,5.51,3.817,2.325.373,4.678.775,4.621,2.813-.086,2.239-2.7,2.7-4.42,2.7a6.292,6.292,0,0,1-5.195-2.411l-1.033.918c1.234,1.894,3.7,2.841,6.2,2.841s5.74-.832,5.826-3.961c.143-3.3-3.329-3.731-5.855-4.162-1.779-.316-4.248-.689-4.3-2.583-.057-1.808,2.066-2.64,4.276-2.612a6.062,6.062,0,0,1,4.42,1.492ZM460.291-.861a1.134,1.134,0,0,0,2.267,0A1.134,1.134,0,0,0,460.291-.861ZM492.119,0l-9.012-20.09h-1.693L472.4,0h1.665l2.181-4.936h12L490.454,0ZM476.851-6.371l5.4-12.226,5.4,12.226Zm27.9-6.773a7.2,7.2,0,0,0-4.018-1.292c-3.674,0-6.658,2.5-6.658,6.917A6.5,6.5,0,0,0,500.729-.66c2.64,0,5.367,1.205,5.367,4.248,0,3.014-2.526,4.276-5.367,4.276s-5.31-1.378-5.31-4.276h-1.406c0,3.588,2.956,5.654,6.716,5.654s6.744-1.837,6.744-5.654c0-2.44-1.378-4.19-3.874-5.08a6.7,6.7,0,0,0,3.817-6.027,6.645,6.645,0,0,0-1.751-4.822l1.378-1.607-.918-.8Zm-4.018.115a5.1,5.1,0,0,1,5.309,5.51,5.44,5.44,0,0,1-5.309,5.453,5.194,5.194,0,0,1-5.252-5.453C495.477-11.222,497.83-13.03,500.729-13.03Zm10.992-1.205V0h-1.406V-14.235ZM509.913-18.8a1.134,1.134,0,0,1,2.267,0A1.134,1.134,0,0,1,509.913-18.8Zm5.826-1.292V0h1.406V-20.09Zm6.745,5.855V0h-1.406V-14.235ZM520.675-18.8a1.134,1.134,0,0,1,2.267,0A1.134,1.134,0,0,1,520.675-18.8Zm12.226,5.74a5.678,5.678,0,0,1,5.8,5.941,5.669,5.669,0,0,1-5.8,5.97c-3.186,0-5.8-2.009-5.8-5.941C527.1-11.078,529.716-13.059,532.9-13.059Zm5.826-7.031v9.012a6.276,6.276,0,0,0-5.883-3.329c-3.961,0-7.118,2.64-7.118,7.318,0,4.707,3.128,7.319,7.089,7.319a6.676,6.676,0,0,0,5.912-3.358V0h1.378V-20.09Zm17.65,5.912v3.1a6.432,6.432,0,0,0-5.8-3.272,7.045,7.045,0,0,0-7.2,7.261,7.093,7.093,0,0,0,7.2,7.319,6.628,6.628,0,0,0,5.8-3.243V0h1.406V-14.178ZM550.581-13c7.892,0,7.892,11.853,0,11.853a5.694,5.694,0,0,1-5.8-5.941A5.67,5.67,0,0,1,550.581-13ZM568-13.059a5.678,5.678,0,0,1,5.8,5.941,5.669,5.669,0,0,1-5.8,5.97c-3.186,0-5.8-2.009-5.8-5.941C562.2-11.078,564.816-13.059,568-13.059Zm5.826-7.031v9.012a6.276,6.276,0,0,0-5.883-3.329c-3.961,0-7.118,2.64-7.118,7.318,0,4.707,3.128,7.319,7.089,7.319a6.676,6.676,0,0,0,5.912-3.358V0h1.378V-20.09ZM585.968.2a7.793,7.793,0,0,0,6.113-2.726l-1-.8a6.668,6.668,0,0,1-5.109,2.152A5.578,5.578,0,0,1,580.2-6.429h12.771c.545-5.539-3.013-7.979-7-7.979a7.127,7.127,0,0,0-7.2,7.318A6.953,6.953,0,0,0,585.968.2ZM580.2-7.663a5.667,5.667,0,0,1,5.769-5.453c3.415,0,5.711,1.952,5.74,5.453ZM610.908.2a7.793,7.793,0,0,0,6.113-2.726l-1-.8a6.668,6.668,0,0,1-5.109,2.152,5.578,5.578,0,0,1-5.769-5.252h12.771c.545-5.539-3.013-7.979-7-7.979a7.127,7.127,0,0,0-7.2,7.318A6.953,6.953,0,0,0,610.908.2ZM605.14-7.663a5.667,5.667,0,0,1,5.769-5.453c3.415,0,5.711,1.952,5.74,5.453Zm34.985,4.735a6,6,0,0,1-4.219,1.751,5.614,5.614,0,0,1-5.912-5.912A5.614,5.614,0,0,1,635.906-13a6.011,6.011,0,0,1,4.248,1.693l.918-.89a7.374,7.374,0,0,0-5.166-2.124,6.928,6.928,0,0,0-7.29,7.232,6.991,6.991,0,0,0,7.29,7.232,7.252,7.252,0,0,0,5.166-2.124ZM650.772.2a6.93,6.93,0,0,0,7.2-7.261,7.025,7.025,0,0,0-7.2-7.376,7.025,7.025,0,0,0-7.2,7.376A6.93,6.93,0,0,0,650.772.2Zm0-1.378a5.6,5.6,0,0,1-5.826-5.884,5.747,5.747,0,0,1,5.826-6.056A5.747,5.747,0,0,1,656.6-7.06,5.6,5.6,0,0,1,650.772-1.177Zm10.447-13V0h1.406V-7.893a4.927,4.927,0,0,1,4.965-5.166c3.071-.029,5.051,1.693,5.051,4.908V0h1.406V-8.18c0-3.932-2.612-6.257-6.4-6.257a5.641,5.641,0,0,0-5.051,2.784v-2.526ZM680.563,0V-12.829h4.678v-1.234h-4.678v-1.263c0-2.468,1.033-3.559,2.813-3.559a3.88,3.88,0,0,1,2.181.717l.689-1.033a4.639,4.639,0,0,0-2.813-.976c-3.128,0-4.248,2.038-4.248,4.85v1.263h-2.9v1.234h2.9V0Zm13.345.2a6.93,6.93,0,0,0,7.2-7.261,7.025,7.025,0,0,0-7.2-7.376,7.025,7.025,0,0,0-7.2,7.376A6.93,6.93,0,0,0,693.909.2Zm0-1.378a5.6,5.6,0,0,1-5.826-5.884,5.747,5.747,0,0,1,5.826-6.056,5.747,5.747,0,0,1,5.826,6.056A5.6,5.6,0,0,1,693.909-1.177Zm10.447-13V0h1.406V-8.266A4.709,4.709,0,0,1,710.44-13a4.559,4.559,0,0,1,2.411.66l.631-1.148a5.535,5.535,0,0,0-3.042-.832,4.988,4.988,0,0,0-4.707,2.669l-.057-2.526Zm14.006-4.133v4.133h-3.013V-13h3.013v8.639c0,2.784.976,4.563,3.989,4.563a6.2,6.2,0,0,0,2.669-.718l-.488-1.148a5.259,5.259,0,0,1-2.181.574c-2.21,0-2.612-1.349-2.612-3.272V-13h4.822v-1.177h-4.822v-4.276ZM734.347.2a6.93,6.93,0,0,0,7.2-7.261,7.025,7.025,0,0,0-7.2-7.376,7.025,7.025,0,0,0-7.2,7.376A6.93,6.93,0,0,0,734.347.2Zm0-1.378a5.6,5.6,0,0,1-5.826-5.884,5.747,5.747,0,0,1,5.826-6.056,5.747,5.747,0,0,1,5.826,6.056A5.6,5.6,0,0,1,734.347-1.177Zm18.339-13V0h1.406V-7.893a4.927,4.927,0,0,1,4.965-5.166c3.071-.029,5.051,1.693,5.051,4.908V0h1.406V-8.18c0-3.932-2.612-6.257-6.4-6.257a5.641,5.641,0,0,0-5.051,2.784v-2.526Zm28.729,0v3.1a6.432,6.432,0,0,0-5.8-3.272,7.045,7.045,0,0,0-7.2,7.261,7.093,7.093,0,0,0,7.2,7.319,6.628,6.628,0,0,0,5.8-3.243V0h1.406V-14.178ZM775.618-13c7.892,0,7.892,11.853,0,11.853a5.694,5.694,0,0,1-5.8-5.941A5.67,5.67,0,0,1,775.618-13Zm21.611.488a7.43,7.43,0,0,0-5.281-1.894c-2.87-.029-5.654,1.177-5.625,3.961.029,2.841,2.755,3.358,5.51,3.817,2.325.373,4.678.775,4.621,2.813-.086,2.239-2.7,2.7-4.42,2.7a6.292,6.292,0,0,1-5.195-2.411l-1.033.918c1.234,1.894,3.7,2.841,6.2,2.841s5.74-.832,5.826-3.961c.143-3.3-3.329-3.731-5.855-4.162-1.779-.316-4.248-.689-4.3-2.583-.057-1.808,2.066-2.64,4.276-2.612a6.062,6.062,0,0,1,4.42,1.492ZM815.252.2a7.793,7.793,0,0,0,6.113-2.726l-1-.8a6.668,6.668,0,0,1-5.109,2.152,5.578,5.578,0,0,1-5.769-5.252h12.771c.545-5.539-3.013-7.979-7-7.979a7.127,7.127,0,0,0-7.2,7.318A6.953,6.953,0,0,0,815.252.2Zm-5.769-7.864a5.667,5.667,0,0,1,5.769-5.453c3.415,0,5.711,1.952,5.74,5.453Zm27.007-4.85a7.43,7.43,0,0,0-5.281-1.894c-2.87-.029-5.654,1.177-5.625,3.961.029,2.841,2.755,3.358,5.51,3.817,2.325.373,4.678.775,4.621,2.813-.086,2.239-2.7,2.7-4.42,2.7A6.292,6.292,0,0,1,826.1-3.53l-1.033.918C826.3-.718,828.77.23,831.267.23s5.74-.832,5.826-3.961c.143-3.3-3.329-3.731-5.855-4.162-1.779-.316-4.248-.689-4.3-2.583-.057-1.808,2.066-2.64,4.276-2.612a6.062,6.062,0,0,1,4.42,1.492Zm5.6-5.8v4.133h-3.013V-13h3.013v8.639c0,2.784.976,4.563,3.989,4.563a6.2,6.2,0,0,0,2.669-.718l-.488-1.148a5.259,5.259,0,0,1-2.181.574c-2.21,0-2.612-1.349-2.612-3.272V-13h4.822v-1.177h-4.822v-4.276Zm9.442,4.133V0h1.406V-8.266A4.709,4.709,0,0,1,857.613-13a4.559,4.559,0,0,1,2.411.66l.631-1.148a5.535,5.535,0,0,0-3.042-.832,4.988,4.988,0,0,0-4.707,2.669l-.057-2.526Zm23.477,0v3.1a6.432,6.432,0,0,0-5.8-3.272A7.045,7.045,0,0,0,862-7.089a7.093,7.093,0,0,0,7.2,7.319,6.628,6.628,0,0,0,5.8-3.243V0h1.406V-14.178ZM869.208-13c7.892,0,7.892,11.853,0,11.853a5.694,5.694,0,0,1-5.8-5.941A5.67,5.67,0,0,1,869.208-13Zm17.421-.057a5.678,5.678,0,0,1,5.8,5.941,5.669,5.669,0,0,1-5.8,5.97c-3.186,0-5.8-2.009-5.8-5.941C880.832-11.078,883.443-13.059,886.629-13.059Zm5.826-7.031v9.012a6.276,6.276,0,0,0-5.883-3.329c-3.961,0-7.118,2.64-7.118,7.318,0,4.707,3.128,7.319,7.089,7.319a6.676,6.676,0,0,0,5.912-3.358V0h1.378V-20.09Zm17.651,5.912v3.1a6.432,6.432,0,0,0-5.8-3.272,7.045,7.045,0,0,0-7.2,7.261,7.093,7.093,0,0,0,7.2,7.319,6.628,6.628,0,0,0,5.8-3.243V0h1.406V-14.178ZM904.308-13c7.892,0,7.892,11.853,0,11.853a5.694,5.694,0,0,1-5.8-5.941A5.67,5.67,0,0,1,904.308-13Zm21.611.488a7.43,7.43,0,0,0-5.281-1.894c-2.87-.029-5.654,1.177-5.625,3.961.029,2.841,2.755,3.358,5.51,3.817,2.325.373,4.678.775,4.621,2.813-.086,2.239-2.7,2.7-4.42,2.7A6.292,6.292,0,0,1,915.53-3.53l-1.033.918C915.731-.718,918.2.23,920.7.23s5.74-.832,5.826-3.961c.143-3.3-3.329-3.731-5.855-4.162-1.779-.316-4.248-.689-4.3-2.583-.057-1.808,2.066-2.64,4.276-2.612a6.062,6.062,0,0,1,4.42,1.492ZM929.105-.861a1.134,1.134,0,0,0,2.267,0A1.134,1.134,0,0,0,929.105-.861Z\" transform=\"translate(277 371)\"/>\r\n    </g>\r\n    <g id=\"TextosTopo\" transform=\"translate(197.572 35.372)\">\r\n      <g id=\"FreteGratis\" transform=\"translate(869.47 69.137)\">\r\n        <path id=\"gratis\" class=\"hhyd-cls-12\" d=\"M-222.071-51.662a10.5,10.5,0,0,0-6.039-1.5c-7.375,0-13.36,5.13-13.36,13.36s5.13,13.253,13.36,13.253c3.26,0,6.68,1.657,6.68,5.291s-2.939,5.665-6.68,5.665S-235-17.835-235-21.255h-6.466c0,7.108,5.718,11.757,13.36,11.757s13.2-4.489,13.2-11.757c0-3.367-1.069-6.52-5.451-8.711,4.329-1.977,5.558-6.573,5.558-9.833a11.23,11.23,0,0,0-2.779-7.8l2.939-3.741-4.81-3.634Zm-6.039,4.436c3.741,0,6.84,2.886,6.84,7.428s-3.1,7.321-6.84,7.321C-231.9-32.477-235-35.2-235-39.8S-231.9-47.227-228.11-47.227Zm17.475-5.077v26.346h6.52V-39.852c0-4.863,3.153-6.68,6.573-6.68a6.513,6.513,0,0,1,4.7,1.71l2.939-5.665A10,10,0,0,0-196.687-53c-2.672,0-5.4.481-7.428,3.741L-204.6-52.3Zm43.874,3.634.214-3.634h6.252v26.346h-6.146l-.321-3.848c-1.5,3.1-5.611,4.6-8.55,4.649-7.8.053-13.574-4.756-13.574-14,0-9.085,6.039-13.841,13.734-13.788C-171.624-52.945-168.257-51.288-166.761-48.67Zm-7.8,1.55c-4.329,0-7.8,2.939-7.8,7.963s3.474,8.016,7.8,8.016C-164.3-31.141-164.3-47.12-174.563-47.12Zm7.428-16.513-5.878,7.321h-5.772v-.321l3.955-7.268h7.7Zm13.894,4.6v6.787h-4.916v5.611h4.916v11.383c0,6.573,3.741,9.833,9.459,9.619a14.564,14.564,0,0,0,5.4-1.122l-1.817-5.558a7.449,7.449,0,0,1-3.153.8c-2.031,0-3.42-1.229-3.42-3.741V-46.639h7.321V-52.25h-7.268v-7.482Zm25.17,6.627v26.453h-6.52V-52.41Zm-7.108-7.321c0-5.077,7.7-5.077,7.7,0S-135.178-54.655-135.178-59.732Zm33.828,10.154c-3.046-2.672-6.146-3.474-10.26-3.474-4.81,0-11.116,2.138-11.116,8.23,0,5.985,5.932,7.8,10.9,8.176,3.741.214,5.237.962,5.237,2.779,0,1.924-2.3,3.206-4.756,3.153-2.939-.053-7.214-1.6-9.085-3.687l-3.206,4.649c3.848,4.008,8.016,4.7,12.184,4.7,7.535,0,11.329-4.008,11.329-8.657,0-7-6.306-8.123-11.276-8.444-3.367-.214-4.916-1.176-4.916-2.886,0-1.657,1.71-2.619,4.81-2.619a8.885,8.885,0,0,1,6.52,2.351Z\" transform=\"translate(343.176 63.9)\"/>\r\n        <path id=\"frete\" class=\"hhyd-cls-3\" d=\"M6.085-18.9V-35.792H2.244v-2.273H6.085v-1.607a7.618,7.618,0,0,1,1.528-5.016,5.713,5.713,0,0,1,4.664-1.842,6.894,6.894,0,0,1,2.195.353,7,7,0,0,1,1.959,1.019L15.294-43.2a9.353,9.353,0,0,0-1.45-.725,4.26,4.26,0,0,0-1.528-.255A3.361,3.361,0,0,0,9.67-43.1a5.072,5.072,0,0,0-.96,3.429v1.607H14.9v2.273H8.71V-18.9Zm14.931-19.36.157,3.174a5.711,5.711,0,0,1,1.156-1.646,6.025,6.025,0,0,1,1.509-1.078,6.727,6.727,0,0,1,1.724-.588,9.173,9.173,0,0,1,1.764-.176,7.809,7.809,0,0,1,2.332.314A7.531,7.531,0,0,1,31.714-37.2L30.5-35.008a5.765,5.765,0,0,0-3.331-1.019,5.905,5.905,0,0,0-2.351.47,6,6,0,0,0-1.9,1.274,5.943,5.943,0,0,0-1.274,1.92,6.249,6.249,0,0,0-.47,2.449V-18.9H18.547v-19.36ZM53.229-27.445H36.378a6.947,6.947,0,0,0,.745,2.724A6.615,6.615,0,0,0,38.729-22.7a6.91,6.91,0,0,0,2.253,1.254,8.44,8.44,0,0,0,2.724.431,9.786,9.786,0,0,0,1.8-.176,10.753,10.753,0,0,0,1.822-.509,8.806,8.806,0,0,0,1.646-.823,4.938,4.938,0,0,0,1.274-1.156l1.764,1.568a8.878,8.878,0,0,1-3.723,2.7,12.349,12.349,0,0,1-4.585.9,11.084,11.084,0,0,1-4-.705,9.1,9.1,0,0,1-3.174-2.018,9.412,9.412,0,0,1-2.1-3.174,10.9,10.9,0,0,1-.764-4.174,10.566,10.566,0,0,1,.745-4,9.582,9.582,0,0,1,2.057-3.174,9.262,9.262,0,0,1,3.135-2.077,9.931,9.931,0,0,1,3.978-.705,11.375,11.375,0,0,1,4.037.627,8.249,8.249,0,0,1,3.214,2.038,8.636,8.636,0,0,1,2,3.468A12.458,12.458,0,0,1,53.229-27.445ZM36.378-29.679H50.76a7.058,7.058,0,0,0-.607-2.8,5.933,5.933,0,0,0-1.528-2.057,6.653,6.653,0,0,0-2.253-1.254,8.618,8.618,0,0,0-2.743-.431,7.248,7.248,0,0,0-4.9,1.685A7.308,7.308,0,0,0,36.378-29.679Zm26.179-14.3V-38.1h6.27v2.234h-6.27v10.816a5.629,5.629,0,0,0,.666,2.939,2.826,2.826,0,0,0,2.626,1.1,4.878,4.878,0,0,0,1.391-.216,11.8,11.8,0,0,0,1.43-.529l.823,2.195a12.413,12.413,0,0,1-1.861.686,6.953,6.953,0,0,1-1.862.255q-3.135.039-4.487-1.685a7.5,7.5,0,0,1-1.352-4.742V-35.871H55.973V-38.1h3.958v-5.6ZM91.321-27.445H74.47a6.947,6.947,0,0,0,.745,2.724A6.615,6.615,0,0,0,76.821-22.7a6.911,6.911,0,0,0,2.253,1.254,8.44,8.44,0,0,0,2.724.431,9.786,9.786,0,0,0,1.8-.176,10.754,10.754,0,0,0,1.822-.509,8.806,8.806,0,0,0,1.646-.823,4.938,4.938,0,0,0,1.274-1.156l1.764,1.568a8.878,8.878,0,0,1-3.723,2.7,12.349,12.349,0,0,1-4.585.9,11.084,11.084,0,0,1-4-.705,9.1,9.1,0,0,1-3.174-2.018,9.412,9.412,0,0,1-2.1-3.174,10.9,10.9,0,0,1-.764-4.174,10.566,10.566,0,0,1,.745-4,9.582,9.582,0,0,1,2.057-3.174A9.262,9.262,0,0,1,77.7-37.83a9.931,9.931,0,0,1,3.978-.705,11.376,11.376,0,0,1,4.037.627,8.249,8.249,0,0,1,3.214,2.038,8.636,8.636,0,0,1,2,3.468A12.458,12.458,0,0,1,91.321-27.445ZM74.47-29.679H88.853a7.059,7.059,0,0,0-.607-2.8,5.933,5.933,0,0,0-1.528-2.057,6.653,6.653,0,0,0-2.253-1.254,8.619,8.619,0,0,0-2.743-.431,7.248,7.248,0,0,0-4.9,1.685A7.308,7.308,0,0,0,74.47-29.679Z\" transform=\"translate(-2.244 56.844)\"/>\r\n      </g>\r\n      <g id=\"SemFidelizacao\" transform=\"translate(814.205 29.51)\">\r\n        <path id=\"fidelizacao\" class=\"hhyd-cls-3\" d=\"M-194.883,0V-16.809H-198.7v-2.262h3.822v-1.6a7.581,7.581,0,0,1,1.521-4.992,5.685,5.685,0,0,1,4.641-1.833,6.861,6.861,0,0,1,2.184.351,6.969,6.969,0,0,1,1.95,1.014l-1.131,1.95a9.309,9.309,0,0,0-1.443-.721,4.239,4.239,0,0,0-1.521-.253,3.345,3.345,0,0,0-2.632,1.072,5.048,5.048,0,0,0-.956,3.413v1.6h6.162v2.262h-6.162V0Zm15.015-19.344V0h-2.613V-19.344Zm-3.12-5.967a1.645,1.645,0,0,1,.585-1.365,1.964,1.964,0,0,1,1.248-.468,2.014,2.014,0,0,1,1.287.468,1.645,1.645,0,0,1,.585,1.365,1.634,1.634,0,0,1-.585,1.384,2.068,2.068,0,0,1-1.287.448,2.015,2.015,0,0,1-1.248-.448A1.634,1.634,0,0,1-182.988-25.311Zm17.862,8.229a8.025,8.025,0,0,0-2.827.487,6.777,6.777,0,0,0-2.3,1.424,6.486,6.486,0,0,0-1.56,2.34,8.616,8.616,0,0,0-.566,3.237,8.465,8.465,0,0,0,.566,3.218,6.719,6.719,0,0,0,1.56,2.34,6.63,6.63,0,0,0,2.3,1.443,8.025,8.025,0,0,0,2.827.488,7.506,7.506,0,0,0,2.886-.546,6.821,6.821,0,0,0,2.3-1.54A7.294,7.294,0,0,0-158.4-6.572a8.024,8.024,0,0,0,.565-3.061,7.918,7.918,0,0,0-.565-3.023,7.073,7.073,0,0,0-1.541-2.359,6.919,6.919,0,0,0-2.32-1.521A7.55,7.55,0,0,0-165.126-17.082ZM-155.1-27.261V0h-2.535l-.078-3.822a7.611,7.611,0,0,1-3.217,3.159A9.377,9.377,0,0,1-165.282.39,10.73,10.73,0,0,1-169.1-.273,9.024,9.024,0,0,1-172.185-2.2a8.735,8.735,0,0,1-2.067-3.12,11.437,11.437,0,0,1-.741-4.27,11.437,11.437,0,0,1,.741-4.271,8.735,8.735,0,0,1,2.067-3.12,9.024,9.024,0,0,1,3.081-1.931,10.178,10.178,0,0,1,3.822-.624,9.565,9.565,0,0,1,4.368.975,6.848,6.848,0,0,1,3.2,3.159V-27.261Zm24.3,18.759h-16.77a6.913,6.913,0,0,0,.741,2.711,6.583,6.583,0,0,0,1.6,2.008,6.877,6.877,0,0,0,2.243,1.248,8.4,8.4,0,0,0,2.71.429,9.738,9.738,0,0,0,1.794-.175,10.7,10.7,0,0,0,1.813-.507,8.764,8.764,0,0,0,1.638-.819,4.914,4.914,0,0,0,1.268-1.15l1.755,1.56A8.835,8.835,0,0,1-135.72-.507a12.29,12.29,0,0,1-4.563.9,11.031,11.031,0,0,1-3.978-.7,9.054,9.054,0,0,1-3.159-2.009,9.367,9.367,0,0,1-2.087-3.159,10.846,10.846,0,0,1-.76-4.153,10.515,10.515,0,0,1,.741-3.978,9.535,9.535,0,0,1,2.048-3.159,9.217,9.217,0,0,1,3.12-2.067,9.883,9.883,0,0,1,3.958-.7,11.321,11.321,0,0,1,4.017.624,8.209,8.209,0,0,1,3.2,2.028,8.6,8.6,0,0,1,1.989,3.451A12.4,12.4,0,0,1-130.806-8.5Zm-16.77-2.223h14.313a7.025,7.025,0,0,0-.6-2.788,5.9,5.9,0,0,0-1.521-2.047,6.621,6.621,0,0,0-2.242-1.248,8.577,8.577,0,0,0-2.73-.429,7.213,7.213,0,0,0-4.875,1.677A7.272,7.272,0,0,0-147.576-10.725Zm24.3-16.575V0h-2.613V-27.3Zm8.97,7.956V0h-2.613V-19.344Zm-3.12-5.967a1.645,1.645,0,0,1,.585-1.365,1.964,1.964,0,0,1,1.248-.468,2.014,2.014,0,0,1,1.287.468,1.645,1.645,0,0,1,.585,1.365,1.634,1.634,0,0,1-.585,1.384,2.068,2.068,0,0,1-1.287.448,2.015,2.015,0,0,1-1.248-.448A1.634,1.634,0,0,1-117.429-25.311Zm22.737,6.045v1.131L-106.08-2.5h11.427V0h-15.4V-.975l11.5-15.912h-10.842v-2.379Zm20.826,3.822v-3.822h2.457V0h-2.418V-3.822a8.018,8.018,0,0,1-1.5,1.852A9.1,9.1,0,0,1-77.2-.643a8.6,8.6,0,0,1-2.087.78A9.63,9.63,0,0,1-81.471.39a10.349,10.349,0,0,1-3.841-.7,9.389,9.389,0,0,1-3.12-2.009,9.224,9.224,0,0,1-2.106-3.159,10.846,10.846,0,0,1-.76-4.153,10.359,10.359,0,0,1,.78-4.1,9.438,9.438,0,0,1,2.106-3.12,9.282,9.282,0,0,1,3.12-1.989,10.5,10.5,0,0,1,3.861-.7,10.144,10.144,0,0,1,2.223.253,8.986,8.986,0,0,1,2.125.76,8.05,8.05,0,0,1,1.833,1.287A6.9,6.9,0,0,1-73.866-15.444Zm-7.488-1.716a7.55,7.55,0,0,0-2.867.546,7.136,7.136,0,0,0-2.34,1.521,6.884,6.884,0,0,0-1.56,2.379,8.173,8.173,0,0,0-.566,3.081,8.132,8.132,0,0,0,.566,3.1,7.137,7.137,0,0,0,1.56,2.379,6.984,6.984,0,0,0,2.34,1.54,7.55,7.55,0,0,0,2.867.546A7.3,7.3,0,0,0-77.2-3.178a7.06,7.06,0,0,0,2.477-2.789A8.2,8.2,0,0,0-73.9-9.613a8.2,8.2,0,0,0-.819-3.647A7.06,7.06,0,0,0-77.2-16.049,7.3,7.3,0,0,0-81.354-17.16ZM-56.394-.039-56.9,2.067a4.431,4.431,0,0,1,2.008.332,3.26,3.26,0,0,1,1.248.956A2.726,2.726,0,0,1-53.1,4.68a4.123,4.123,0,0,1-.059,1.443,3.371,3.371,0,0,1-1.677,2.262,5.308,5.308,0,0,1-2.73.663,5.53,5.53,0,0,1-2.4-.546,4.171,4.171,0,0,1-1.813-1.638l1.326-1.209A3.3,3.3,0,0,0-59.26,6.708a3.645,3.645,0,0,0,1.424.351,3.393,3.393,0,0,0,1.618-.234,1.637,1.637,0,0,0,.995-1.092,1.647,1.647,0,0,0-.02-1.033,1.574,1.574,0,0,0-.663-.8,2.8,2.8,0,0,0-1.229-.39,4.39,4.39,0,0,0-1.677.195l-.468-.351.858-3.393Zm6.942-2.5a10.132,10.132,0,0,1-3.334,2.2,10.192,10.192,0,0,1-3.8.722,11.214,11.214,0,0,1-3.881-.663,8.967,8.967,0,0,1-3.159-1.95,9.435,9.435,0,0,1-2.145-3.159,10.626,10.626,0,0,1-.8-4.212,10.676,10.676,0,0,1,.78-4.212,9.292,9.292,0,0,1,2.126-3.12,8.967,8.967,0,0,1,3.159-1.95,11.329,11.329,0,0,1,3.919-.663,9.678,9.678,0,0,1,3.646.682,9.547,9.547,0,0,1,3.179,2.165l-1.716,1.677a7.247,7.247,0,0,0-2.379-1.56,7.276,7.276,0,0,0-2.691-.507,8.221,8.221,0,0,0-2.886.507,6.755,6.755,0,0,0-2.36,1.463,6.947,6.947,0,0,0-1.579,2.34,8.106,8.106,0,0,0-.585,3.178,8.361,8.361,0,0,0,.585,3.237,6.569,6.569,0,0,0,1.6,2.34,6.946,6.946,0,0,0,2.34,1.424,8.186,8.186,0,0,0,2.847.488,7.746,7.746,0,0,0,2.867-.546A7.224,7.224,0,0,0-51.246-4.29ZM-28.9-15.444v-3.822h2.457V0H-28.86V-3.822a8.018,8.018,0,0,1-1.5,1.852A9.1,9.1,0,0,1-32.233-.643a8.6,8.6,0,0,1-2.087.78A9.63,9.63,0,0,1-36.5.39a10.349,10.349,0,0,1-3.842-.7,9.389,9.389,0,0,1-3.12-2.009,9.224,9.224,0,0,1-2.106-3.159,10.846,10.846,0,0,1-.761-4.153,10.359,10.359,0,0,1,.78-4.1,9.438,9.438,0,0,1,2.106-3.12,9.282,9.282,0,0,1,3.12-1.989,10.5,10.5,0,0,1,3.861-.7,10.144,10.144,0,0,1,2.223.253,8.986,8.986,0,0,1,2.125.76,8.05,8.05,0,0,1,1.833,1.287A6.9,6.9,0,0,1-28.9-15.444Zm-7.488-1.716a7.55,7.55,0,0,0-2.866.546,7.136,7.136,0,0,0-2.34,1.521,6.884,6.884,0,0,0-1.56,2.379,8.173,8.173,0,0,0-.565,3.081,8.132,8.132,0,0,0,.565,3.1,7.137,7.137,0,0,0,1.56,2.379,6.984,6.984,0,0,0,2.34,1.54,7.55,7.55,0,0,0,2.866.546,7.3,7.3,0,0,0,4.154-1.112,7.06,7.06,0,0,0,2.476-2.789,8.2,8.2,0,0,0,.819-3.646,8.2,8.2,0,0,0-.819-3.647,7.06,7.06,0,0,0-2.476-2.788A7.3,7.3,0,0,0-36.387-17.16Zm-4.446-7.293A3.379,3.379,0,0,1-39.448-26.7a3.106,3.106,0,0,1,2.438-.448,4.782,4.782,0,0,1,1.307.507,8.955,8.955,0,0,0,1.424.624,2.216,2.216,0,0,0,1.287.078q.585-.156.9-1.17l1.755.7a3.132,3.132,0,0,1-1.424,2.34,3.167,3.167,0,0,1-2.32.351,7.712,7.712,0,0,1-1.4-.585,7.5,7.5,0,0,0-1.424-.585,2.22,2.22,0,0,0-1.268-.019q-.585.175-.9,1.15ZM-11.7-19.539a10.506,10.506,0,0,1,3.919.722,9.187,9.187,0,0,1,3.14,2.047,9.582,9.582,0,0,1,2.087,3.179,10.632,10.632,0,0,1,.76,4.076A10.728,10.728,0,0,1-2.535-5.46,9.174,9.174,0,0,1-4.6-2.321,9.093,9.093,0,0,1-7.741-.312,10.875,10.875,0,0,1-11.7.39a10.764,10.764,0,0,1-3.92-.7,9.093,9.093,0,0,1-3.139-2.009A9.412,9.412,0,0,1-20.845-5.46a10.486,10.486,0,0,1-.76-4.056,10.878,10.878,0,0,1,.741-4.076,9.49,9.49,0,0,1,2.048-3.179,8.983,8.983,0,0,1,3.12-2.047A10.722,10.722,0,0,1-11.7-19.539Zm0,2.379a7.524,7.524,0,0,0-2.945.566,6.873,6.873,0,0,0-2.32,1.58,6.975,6.975,0,0,0-1.5,2.418,8.71,8.71,0,0,0-.527,3.081,8.277,8.277,0,0,0,.546,3.061,6.985,6.985,0,0,0,1.5,2.36,6.484,6.484,0,0,0,2.3,1.5,8.012,8.012,0,0,0,2.945.527,7.97,7.97,0,0,0,2.964-.527,6.723,6.723,0,0,0,2.3-1.5,6.61,6.61,0,0,0,1.5-2.36,8.55,8.55,0,0,0,.526-3.061A8.431,8.431,0,0,0-4.953-12.6a7.383,7.383,0,0,0-1.5-2.418,6.669,6.669,0,0,0-2.3-1.58A7.524,7.524,0,0,0-11.7-17.16Z\" transform=\"translate(301.223 27.118)\"/>\r\n        <path id=\"sem\" class=\"hhyd-cls-12\" d=\"M23.455-42.193c-3.046-2.672-6.146-3.474-10.26-3.474-4.81,0-11.116,2.138-11.116,8.23,0,5.985,5.932,7.8,10.9,8.176,3.741.214,5.237.962,5.237,2.779,0,1.924-2.3,3.206-4.756,3.153-2.939-.053-7.214-1.6-9.085-3.687L1.17-22.367c3.848,4.008,8.016,4.7,12.184,4.7,7.535,0,11.329-4.008,11.329-8.657,0-7-6.306-8.123-11.276-8.444-3.367-.214-4.916-1.176-4.916-2.886,0-1.657,1.71-2.619,4.81-2.619a8.885,8.885,0,0,1,6.52,2.351Zm31.53,12.772C56-40.269,50.5-45.72,41.678-45.72c-8.55,0-14,5.772-14,13.788,0,8.444,5.4,14.055,14.482,14.055,4.008,0,8.55-1.389,11.329-4.275l-4.168-4.115c-1.5,1.55-4.649,2.458-7.054,2.458-4.6,0-7.428-2.351-7.856-5.611Zm-20.468-5.4c.962-3.42,3.848-5.13,7.375-5.13,3.741,0,6.413,1.71,6.84,5.13Zm49,16.246V-32.681c0-3.474,2.191-6.52,5.718-6.52s4.97,2.939,4.97,6.413v14.215h6.52V-32.788c0-7.909-3.687-12.5-11.169-12.5a9.54,9.54,0,0,0-8.818,4.81c-1.5-3.634-4.649-4.916-7.8-4.916-2.512,0-5.558.962-6.947,3.634l-.481-3.206H59.473v26.4h6.52V-32.681c0-3.474,2.084-6.627,5.611-6.627,3.58,0,5.4,3.153,5.4,6.627v14.108Z\" transform=\"translate(-9.17 46.201)\"/>\r\n      </g>\r\n      <g id=\"SaldoNaoExpira\" transform=\"translate(-136.262 70.305)\">\r\n        <path id=\"expira\" class=\"hhyd-cls-3\" d=\"M-172.072-25.715h-18.191a7.5,7.5,0,0,0,.8,2.94,7.14,7.14,0,0,0,1.734,2.179,7.46,7.46,0,0,0,2.432,1.354,9.111,9.111,0,0,0,2.94.465,10.563,10.563,0,0,0,1.946-.19,11.607,11.607,0,0,0,1.967-.55,9.505,9.505,0,0,0,1.777-.888,5.33,5.33,0,0,0,1.375-1.248l1.9,1.692a9.583,9.583,0,0,1-4.019,2.919,13.33,13.33,0,0,1-4.95.973,11.965,11.965,0,0,1-4.315-.761,9.821,9.821,0,0,1-3.427-2.179,10.16,10.16,0,0,1-2.263-3.427,11.765,11.765,0,0,1-.825-4.505,11.405,11.405,0,0,1,.8-4.315,10.343,10.343,0,0,1,2.221-3.427,10,10,0,0,1,3.384-2.242,10.72,10.72,0,0,1,4.294-.761,12.28,12.28,0,0,1,4.357.677,8.9,8.9,0,0,1,3.469,2.2,9.323,9.323,0,0,1,2.158,3.744A13.449,13.449,0,0,1-172.072-25.715Zm-18.191-2.411h15.525a7.619,7.619,0,0,0-.656-3.025,6.405,6.405,0,0,0-1.65-2.221,7.181,7.181,0,0,0-2.432-1.354,9.3,9.3,0,0,0-2.961-.465,7.824,7.824,0,0,0-5.288,1.819A7.889,7.889,0,0,0-190.263-28.126Zm35.408-9.265h3.427v.127l-7.319,10.026,7.868,10.661v.085h-3.384l-6.261-8.757-6.261,8.757h-3.384v-.085l7.868-10.661-7.319-10.026v-.127h3.384l5.711,8.207Zm18.867,18.571a8.88,8.88,0,0,0,3.088-.529,6.941,6.941,0,0,0,2.5-1.565,7.44,7.44,0,0,0,1.671-2.538,9.182,9.182,0,0,0,.613-3.49,9.348,9.348,0,0,0-.592-3.448,6.983,6.983,0,0,0-1.65-2.517,7.09,7.09,0,0,0-2.5-1.544,9.005,9.005,0,0,0-3.13-.529,8.007,8.007,0,0,0-3.173.613,7.431,7.431,0,0,0-2.475,1.692,7.588,7.588,0,0,0-1.608,2.559,8.859,8.859,0,0,0-.571,3.215,8.578,8.578,0,0,0,.592,3.215,7.864,7.864,0,0,0,1.629,2.559,7.431,7.431,0,0,0,2.475,1.692A7.9,7.9,0,0,0-135.987-18.819Zm-10.872,12.31V-37.391h2.75l.085,4.442a8.839,8.839,0,0,1,3.469-3.511,9.644,9.644,0,0,1,4.992-1.227,11.378,11.378,0,0,1,4.082.8,9.531,9.531,0,0,1,3.257,2.157,9.991,9.991,0,0,1,2.157,3.363,11.871,11.871,0,0,1,.783,4.421,12.325,12.325,0,0,1-.8,4.569,9.954,9.954,0,0,1-2.2,3.427,9.373,9.373,0,0,1-3.342,2.136,11.8,11.8,0,0,1-4.23.74,10.256,10.256,0,0,1-4.675-1.142,8.09,8.09,0,0,1-3.532-3.511V-6.509Zm29.7-30.966v20.983H-120V-37.475Zm-3.384-6.472a1.784,1.784,0,0,1,.635-1.481,2.13,2.13,0,0,1,1.354-.508,2.184,2.184,0,0,1,1.4.508,1.784,1.784,0,0,1,.635,1.481,1.772,1.772,0,0,1-.635,1.5,2.243,2.243,0,0,1-1.4.486,2.186,2.186,0,0,1-1.354-.486A1.772,1.772,0,0,1-120.547-43.948Zm12.649,6.557.169,3.427a6.165,6.165,0,0,1,1.248-1.777,6.5,6.5,0,0,1,1.629-1.163,7.261,7.261,0,0,1,1.861-.635,9.9,9.9,0,0,1,1.9-.19,8.43,8.43,0,0,1,2.517.338,8.13,8.13,0,0,1,2.221,1.142l-1.311,2.369a6.223,6.223,0,0,0-3.6-1.1,6.375,6.375,0,0,0-2.538.508,6.475,6.475,0,0,0-2.052,1.375,6.415,6.415,0,0,0-1.375,2.073,6.745,6.745,0,0,0-.508,2.644v11.887h-2.834v-20.9Zm32.574,4.146v-4.146h2.665v20.9h-2.623v-4.146a8.7,8.7,0,0,1-1.629,2.009,9.866,9.866,0,0,1-2.031,1.438,9.323,9.323,0,0,1-2.263.846,10.446,10.446,0,0,1-2.369.275,11.226,11.226,0,0,1-4.167-.761,10.184,10.184,0,0,1-3.384-2.179,10.005,10.005,0,0,1-2.284-3.427,11.765,11.765,0,0,1-.825-4.505,11.237,11.237,0,0,1,.846-4.442A10.237,10.237,0,0,1-91.1-34.768a10.068,10.068,0,0,1,3.384-2.157,11.391,11.391,0,0,1,4.188-.761,11,11,0,0,1,2.411.275,9.747,9.747,0,0,1,2.306.825,8.732,8.732,0,0,1,1.988,1.4A7.487,7.487,0,0,1-75.324-33.245Zm-8.122-1.861a8.189,8.189,0,0,0-3.109.592,7.741,7.741,0,0,0-2.538,1.65,7.467,7.467,0,0,0-1.692,2.581,8.865,8.865,0,0,0-.613,3.342,8.821,8.821,0,0,0,.613,3.363A7.742,7.742,0,0,0-89.094-21a7.576,7.576,0,0,0,2.538,1.671,8.189,8.189,0,0,0,3.109.592,7.917,7.917,0,0,0,4.505-1.206,7.659,7.659,0,0,0,2.686-3.025,8.891,8.891,0,0,0,.888-3.955,8.891,8.891,0,0,0-.888-3.955A7.659,7.659,0,0,0-78.941-33.9,7.917,7.917,0,0,0-83.446-35.106Z\" transform=\"translate(428.016 57.742)\"/>\r\n        <path id=\"nao\" class=\"hhyd-cls-12\" d=\"M-48.394-23.106V-38.047c0-8.941-5.365-13.96-12.057-13.96-3.577,0-6.461,1.442-9.345,4.269l-.461-3.865h-6.288v28.5h6.98V-37.643c0-4.327,2.942-7.961,7.269-7.961,4.5,0,6.865,3.288,6.865,7.615v14.883Zm28.382-24.517c-1.615-2.827-5.25-4.615-9.057-4.615-8.307-.058-14.826,5.076-14.826,14.883,0,9.98,6.23,15.172,14.652,15.114,3.173-.058,7.615-1.673,9.23-5.019l.346,4.153h6.634v-28.44h-6.749Zm-8.422,1.673c11.076,0,11.076,17.248,0,17.248-4.673,0-8.422-3.23-8.422-8.653S-33.107-45.95-28.434-45.95Zm-4.1-10.9c2.25-4.211,4.73-.808,7.557,0,2.711.692,5.6-.635,7.269-5.076l-4.615-2.192c-1.788,3.577-4.442.577-7.153-.058-3.807-.865-6.057,1.558-7.442,4.961Zm38.823,4.73c-9.057,0-14.71,6.692-14.71,14.826,0,8.192,5.538,14.826,14.768,14.826S21.177-29.105,21.177-37.3C21.177-45.431,15.35-52.122,6.293-52.122Zm.058,6.4c4.73,0,7.73,4.153,7.73,8.422,0,4.327-2.6,8.365-7.73,8.365s-7.73-4.038-7.73-8.365C-1.379-41.566,1.275-45.719,6.351-45.719Z\" transform=\"translate(198.337 64.355)\"/>\r\n        <path id=\"saldo\" class=\"hhyd-cls-3\" d=\"M17.8-33.128a7.063,7.063,0,0,0-2.982-1.734,12.957,12.957,0,0,0-3.194-.381,12.045,12.045,0,0,0-2.179.19,6.136,6.136,0,0,0-1.819.613,3.693,3.693,0,0,0-1.248,1.058,2.168,2.168,0,0,0-.423,1.438,2.2,2.2,0,0,0,.529,1.523,4.071,4.071,0,0,0,1.354.973,8.535,8.535,0,0,0,1.84.592q1.015.212,1.988.338,1.4.212,2.919.508a10.836,10.836,0,0,1,2.792.931A5.675,5.675,0,0,1,19.469-25.3a5.1,5.1,0,0,1,.825,3.046,5.4,5.4,0,0,1-.783,2.813,5.782,5.782,0,0,1-1.946,1.883,9.152,9.152,0,0,1-2.75,1.058,14.482,14.482,0,0,1-3.109.338,14.312,14.312,0,0,1-5.182-.952,9.054,9.054,0,0,1-4.082-3.109l1.777-1.946a7.361,7.361,0,0,0,3.427,2.581,12.613,12.613,0,0,0,4.1.8,12.8,12.8,0,0,0,1.883-.148,6.776,6.776,0,0,0,1.861-.55,3.908,3.908,0,0,0,1.417-1.079,2.662,2.662,0,0,0,.55-1.734,2.819,2.819,0,0,0-.465-1.671,3.329,3.329,0,0,0-1.29-1.058,7.718,7.718,0,0,0-1.925-.613q-1.1-.212-2.369-.381-1.523-.212-2.982-.55a10.318,10.318,0,0,1-2.623-.973,5.593,5.593,0,0,1-1.9-1.671,4.44,4.44,0,0,1-.74-2.644,4.79,4.79,0,0,1,.74-2.665,6.136,6.136,0,0,1,1.925-1.883,8.573,8.573,0,0,1,2.707-1.079,14,14,0,0,1,3.046-.338,13.067,13.067,0,0,1,4.315.677,10.122,10.122,0,0,1,3.554,2.157Zm25.044-.212v-4.146h2.665v20.9H42.884v-4.146a8.7,8.7,0,0,1-1.629,2.009,9.866,9.866,0,0,1-2.031,1.438,9.324,9.324,0,0,1-2.263.846,10.446,10.446,0,0,1-2.369.275,11.226,11.226,0,0,1-4.167-.761A10.184,10.184,0,0,1,27.042-19.1a10.005,10.005,0,0,1-2.284-3.427,11.765,11.765,0,0,1-.825-4.505,11.237,11.237,0,0,1,.846-4.442,10.237,10.237,0,0,1,2.284-3.384,10.068,10.068,0,0,1,3.384-2.157,11.391,11.391,0,0,1,4.188-.761,11,11,0,0,1,2.411.275,9.747,9.747,0,0,1,2.306.825,8.732,8.732,0,0,1,1.988,1.4A7.487,7.487,0,0,1,42.842-33.34ZM34.72-35.2a8.189,8.189,0,0,0-3.109.592,7.741,7.741,0,0,0-2.538,1.65,7.467,7.467,0,0,0-1.692,2.581,8.865,8.865,0,0,0-.613,3.342,8.821,8.821,0,0,0,.613,3.363,7.741,7.741,0,0,0,1.692,2.581,7.576,7.576,0,0,0,2.538,1.671,8.189,8.189,0,0,0,3.109.592,7.917,7.917,0,0,0,4.505-1.206,7.659,7.659,0,0,0,2.686-3.025,8.891,8.891,0,0,0,.888-3.955,8.891,8.891,0,0,0-.888-3.955A7.659,7.659,0,0,0,39.225-34,7.917,7.917,0,0,0,34.72-35.2Zm20.517-11v29.613H52.4V-46.2ZM71.524-35.116a8.7,8.7,0,0,0-3.067.529,7.352,7.352,0,0,0-2.5,1.544,7.036,7.036,0,0,0-1.692,2.538,9.346,9.346,0,0,0-.613,3.511,9.182,9.182,0,0,0,.613,3.49,7.288,7.288,0,0,0,1.692,2.538,7.192,7.192,0,0,0,2.5,1.565,8.7,8.7,0,0,0,3.067.529,8.142,8.142,0,0,0,3.13-.592,7.4,7.4,0,0,0,2.5-1.671,7.913,7.913,0,0,0,1.671-2.581,8.7,8.7,0,0,0,.613-3.321,8.589,8.589,0,0,0-.613-3.279,7.672,7.672,0,0,0-1.671-2.559,7.505,7.505,0,0,0-2.517-1.65A8.189,8.189,0,0,0,71.524-35.116ZM82.4-46.158v29.57h-2.75l-.085-4.146a8.256,8.256,0,0,1-3.49,3.427,10.171,10.171,0,0,1-4.717,1.142,11.639,11.639,0,0,1-4.146-.719,9.788,9.788,0,0,1-3.342-2.094,9.475,9.475,0,0,1-2.242-3.384,12.406,12.406,0,0,1-.8-4.632,12.406,12.406,0,0,1,.8-4.632,9.475,9.475,0,0,1,2.242-3.384A9.788,9.788,0,0,1,67.209-37.1a11.04,11.04,0,0,1,4.146-.677,10.375,10.375,0,0,1,4.738,1.058A7.428,7.428,0,0,1,79.562-33.3v-12.86Zm15.991,8.376a11.4,11.4,0,0,1,4.252.783,9.965,9.965,0,0,1,3.405,2.221,10.394,10.394,0,0,1,2.263,3.448,11.532,11.532,0,0,1,.825,4.421,11.637,11.637,0,0,1-.8,4.4,9.951,9.951,0,0,1-2.242,3.405,9.863,9.863,0,0,1-3.405,2.179,11.8,11.8,0,0,1-4.294.761,11.676,11.676,0,0,1-4.252-.761A9.863,9.863,0,0,1,90.73-19.1a10.209,10.209,0,0,1-2.263-3.405,11.374,11.374,0,0,1-.825-4.4,11.8,11.8,0,0,1,.8-4.421,10.294,10.294,0,0,1,2.221-3.448A9.744,9.744,0,0,1,94.051-37,11.631,11.631,0,0,1,98.387-37.782Zm0,2.581a8.161,8.161,0,0,0-3.194.613,7.456,7.456,0,0,0-2.517,1.713,7.566,7.566,0,0,0-1.629,2.623,9.448,9.448,0,0,0-.571,3.342,8.978,8.978,0,0,0,.592,3.321A7.577,7.577,0,0,0,92.7-21.029a7.033,7.033,0,0,0,2.5,1.629,8.691,8.691,0,0,0,3.194.571A8.645,8.645,0,0,0,101.6-19.4a7.292,7.292,0,0,0,2.5-1.629,7.17,7.17,0,0,0,1.629-2.559,9.275,9.275,0,0,0,.571-3.321,9.145,9.145,0,0,0-.592-3.342,8.008,8.008,0,0,0-1.629-2.623,7.234,7.234,0,0,0-2.5-1.713A8.161,8.161,0,0,0,98.387-35.2Z\" transform=\"translate(-2.442 57.837)\"/>\r\n      </g>\r\n      <g id=\"SemMensalidade\" transform=\"translate(-139 27)\">\r\n        <path id=\"mensalidade\" class=\"hhyd-cls-3\" d=\"M-389.346-16.587v-12.1a7.292,7.292,0,0,0-.444-2.581,6.165,6.165,0,0,0-1.248-2.052,5.923,5.923,0,0,0-1.925-1.375,6.035,6.035,0,0,0-2.517-.508,6.035,6.035,0,0,0-2.517.508,5.924,5.924,0,0,0-1.925,1.375,6.166,6.166,0,0,0-1.248,2.052,7.292,7.292,0,0,0-.444,2.581v12.1h-2.834V-37.57h2.665l.127,3.342A5.723,5.723,0,0,1-398.864-37a9.038,9.038,0,0,1,3.68-.783,11.846,11.846,0,0,1,2.242.212,6.731,6.731,0,0,1,2.094.783,6.632,6.632,0,0,1,1.777,1.5,7.17,7.17,0,0,1,1.248,2.242,7.06,7.06,0,0,1,3.13-3.617,9.113,9.113,0,0,1,4.4-1.121,10.192,10.192,0,0,1,3.617.613,7.425,7.425,0,0,1,2.771,1.8,8.3,8.3,0,0,1,1.777,2.855,10.478,10.478,0,0,1,.635,3.744v12.183h-2.834V-28.771a7.622,7.622,0,0,0-.423-2.581,5.843,5.843,0,0,0-1.206-2.031,5.637,5.637,0,0,0-1.883-1.333,6.111,6.111,0,0,0-2.5-.486,6.035,6.035,0,0,0-2.517.508,6.168,6.168,0,0,0-1.946,1.375,5.991,5.991,0,0,0-1.269,2.052,7.294,7.294,0,0,0-.444,2.581v12.1Zm43.954-9.222h-18.191a7.5,7.5,0,0,0,.8,2.94,7.14,7.14,0,0,0,1.734,2.179,7.46,7.46,0,0,0,2.432,1.354,9.111,9.111,0,0,0,2.94.465,10.563,10.563,0,0,0,1.946-.19,11.608,11.608,0,0,0,1.967-.55,9.507,9.507,0,0,0,1.777-.888,5.331,5.331,0,0,0,1.375-1.248l1.9,1.692a9.583,9.583,0,0,1-4.019,2.919,13.331,13.331,0,0,1-4.95.973,11.965,11.965,0,0,1-4.315-.761,9.821,9.821,0,0,1-3.427-2.179,10.16,10.16,0,0,1-2.263-3.427,11.765,11.765,0,0,1-.825-4.505,11.4,11.4,0,0,1,.8-4.315,10.342,10.342,0,0,1,2.221-3.427,10,10,0,0,1,3.384-2.242,10.72,10.72,0,0,1,4.294-.761,12.279,12.279,0,0,1,4.357.677,8.9,8.9,0,0,1,3.469,2.2,9.323,9.323,0,0,1,2.157,3.744A13.448,13.448,0,0,1-345.392-25.81Zm-18.191-2.411h15.525a7.619,7.619,0,0,0-.656-3.025,6.406,6.406,0,0,0-1.65-2.221A7.182,7.182,0,0,0-352.8-34.82a9.3,9.3,0,0,0-2.961-.465,7.824,7.824,0,0,0-5.288,1.819A7.888,7.888,0,0,0-363.583-28.221Zm39.723,11.634V-28.306a6.748,6.748,0,0,0-1.819-5.119,6.937,6.937,0,0,0-4.992-1.734,6.725,6.725,0,0,0-2.792.571,6.485,6.485,0,0,0-2.157,1.544,7.266,7.266,0,0,0-1.4,2.263,7.617,7.617,0,0,0-.508,2.813v11.38h-2.834v-20.9h2.707l.085,3.511a7.878,7.878,0,0,1,3.215-2.94,9.162,9.162,0,0,1,4-.91,11.6,11.6,0,0,1,3.807.592,7.737,7.737,0,0,1,2.94,1.8,8.443,8.443,0,0,1,1.925,2.982,11.169,11.169,0,0,1,.7,4.1v11.76Zm22.844-16.541A7.063,7.063,0,0,0-304-34.863a12.957,12.957,0,0,0-3.194-.381,12.045,12.045,0,0,0-2.179.19,6.136,6.136,0,0,0-1.819.613,3.693,3.693,0,0,0-1.248,1.058,2.168,2.168,0,0,0-.423,1.438,2.2,2.2,0,0,0,.529,1.523,4.071,4.071,0,0,0,1.354.973,8.535,8.535,0,0,0,1.84.592q1.015.212,1.988.338,1.4.212,2.919.508a10.836,10.836,0,0,1,2.792.931,5.675,5.675,0,0,1,2.094,1.777,5.1,5.1,0,0,1,.825,3.046,5.4,5.4,0,0,1-.783,2.813,5.782,5.782,0,0,1-1.946,1.883A9.153,9.153,0,0,1-304-16.5a14.482,14.482,0,0,1-3.109.338,14.311,14.311,0,0,1-5.182-.952,9.054,9.054,0,0,1-4.082-3.109l1.777-1.946a7.361,7.361,0,0,0,3.427,2.581,12.613,12.613,0,0,0,4.1.8,12.8,12.8,0,0,0,1.883-.148,6.776,6.776,0,0,0,1.861-.55,3.908,3.908,0,0,0,1.417-1.079,2.662,2.662,0,0,0,.55-1.734,2.819,2.819,0,0,0-.465-1.671,3.329,3.329,0,0,0-1.29-1.058,7.717,7.717,0,0,0-1.925-.613q-1.1-.212-2.369-.381-1.523-.212-2.982-.55a10.318,10.318,0,0,1-2.623-.973,5.593,5.593,0,0,1-1.9-1.671,4.44,4.44,0,0,1-.74-2.644,4.79,4.79,0,0,1,.74-2.665,6.136,6.136,0,0,1,1.925-1.883,8.573,8.573,0,0,1,2.707-1.079,14,14,0,0,1,3.046-.338,13.067,13.067,0,0,1,4.315.677,10.122,10.122,0,0,1,3.553,2.157Zm25.044-.212v-4.146h2.665v20.9h-2.623v-4.146a8.7,8.7,0,0,1-1.629,2.009,9.866,9.866,0,0,1-2.031,1.438,9.324,9.324,0,0,1-2.263.846,10.446,10.446,0,0,1-2.369.275,11.226,11.226,0,0,1-4.167-.761,10.185,10.185,0,0,1-3.384-2.179,10,10,0,0,1-2.284-3.427,11.764,11.764,0,0,1-.825-4.505,11.237,11.237,0,0,1,.846-4.442,10.236,10.236,0,0,1,2.284-3.384,10.068,10.068,0,0,1,3.384-2.157,11.391,11.391,0,0,1,4.188-.761,11,11,0,0,1,2.411.275,9.747,9.747,0,0,1,2.306.825,8.733,8.733,0,0,1,1.988,1.4A7.487,7.487,0,0,1-275.972-33.34Zm-8.122-1.861a8.19,8.19,0,0,0-3.109.592,7.741,7.741,0,0,0-2.538,1.65,7.467,7.467,0,0,0-1.692,2.581,8.865,8.865,0,0,0-.613,3.342,8.821,8.821,0,0,0,.613,3.363,7.741,7.741,0,0,0,1.692,2.581,7.576,7.576,0,0,0,2.538,1.671,8.19,8.19,0,0,0,3.109.592,7.917,7.917,0,0,0,4.505-1.206A7.658,7.658,0,0,0-276.9-23.06a8.891,8.891,0,0,0,.888-3.955,8.891,8.891,0,0,0-.888-3.955A7.658,7.658,0,0,0-279.589-34,7.917,7.917,0,0,0-284.094-35.2Zm20.517-11v29.613h-2.834V-46.2Zm9.73,8.63v20.983h-2.834V-37.57Zm-3.384-6.472a1.784,1.784,0,0,1,.635-1.481,2.13,2.13,0,0,1,1.354-.508,2.184,2.184,0,0,1,1.4.508,1.784,1.784,0,0,1,.635,1.481,1.772,1.772,0,0,1-.635,1.5,2.243,2.243,0,0,1-1.4.486,2.186,2.186,0,0,1-1.354-.486A1.772,1.772,0,0,1-257.231-44.043Zm19.375,8.926a8.7,8.7,0,0,0-3.067.529,7.352,7.352,0,0,0-2.5,1.544,7.036,7.036,0,0,0-1.692,2.538,9.346,9.346,0,0,0-.613,3.511,9.182,9.182,0,0,0,.613,3.49,7.288,7.288,0,0,0,1.692,2.538,7.192,7.192,0,0,0,2.5,1.565,8.7,8.7,0,0,0,3.067.529,8.142,8.142,0,0,0,3.13-.592,7.4,7.4,0,0,0,2.5-1.671,7.912,7.912,0,0,0,1.671-2.581,8.7,8.7,0,0,0,.613-3.321,8.589,8.589,0,0,0-.613-3.279,7.672,7.672,0,0,0-1.671-2.559,7.505,7.505,0,0,0-2.517-1.65A8.189,8.189,0,0,0-237.856-35.116Zm10.872-11.041v29.57h-2.75l-.085-4.146a8.256,8.256,0,0,1-3.49,3.427,10.171,10.171,0,0,1-4.717,1.142,11.639,11.639,0,0,1-4.146-.719,9.788,9.788,0,0,1-3.342-2.094,9.475,9.475,0,0,1-2.242-3.384,12.406,12.406,0,0,1-.8-4.632,12.406,12.406,0,0,1,.8-4.632,9.475,9.475,0,0,1,2.242-3.384,9.788,9.788,0,0,1,3.342-2.094,11.04,11.04,0,0,1,4.146-.677,10.375,10.375,0,0,1,4.738,1.058,7.428,7.428,0,0,1,3.469,3.427v-12.86Zm24.155,12.818v-4.146h2.665v20.9h-2.623v-4.146a8.7,8.7,0,0,1-1.629,2.009,9.866,9.866,0,0,1-2.031,1.438,9.324,9.324,0,0,1-2.263.846,10.445,10.445,0,0,1-2.369.275,11.226,11.226,0,0,1-4.167-.761,10.184,10.184,0,0,1-3.384-2.179,10.005,10.005,0,0,1-2.284-3.427,11.765,11.765,0,0,1-.825-4.505,11.237,11.237,0,0,1,.846-4.442,10.237,10.237,0,0,1,2.284-3.384,10.068,10.068,0,0,1,3.384-2.157,11.391,11.391,0,0,1,4.188-.761,11,11,0,0,1,2.411.275,9.747,9.747,0,0,1,2.306.825,8.733,8.733,0,0,1,1.988,1.4A7.488,7.488,0,0,1-202.828-33.34Zm-8.122-1.861a8.189,8.189,0,0,0-3.109.592,7.741,7.741,0,0,0-2.538,1.65,7.467,7.467,0,0,0-1.692,2.581,8.865,8.865,0,0,0-.613,3.342,8.821,8.821,0,0,0,.613,3.363,7.741,7.741,0,0,0,1.692,2.581,7.576,7.576,0,0,0,2.538,1.671,8.189,8.189,0,0,0,3.109.592,7.917,7.917,0,0,0,4.505-1.206,7.659,7.659,0,0,0,2.686-3.025,8.892,8.892,0,0,0,.888-3.955,8.892,8.892,0,0,0-.888-3.955A7.659,7.659,0,0,0-206.445-34,7.917,7.917,0,0,0-210.951-35.2Zm26.778.085a8.7,8.7,0,0,0-3.067.529,7.352,7.352,0,0,0-2.5,1.544,7.036,7.036,0,0,0-1.692,2.538,9.346,9.346,0,0,0-.613,3.511,9.182,9.182,0,0,0,.613,3.49,7.288,7.288,0,0,0,1.692,2.538,7.192,7.192,0,0,0,2.5,1.565,8.7,8.7,0,0,0,3.067.529,8.142,8.142,0,0,0,3.13-.592,7.4,7.4,0,0,0,2.5-1.671,7.912,7.912,0,0,0,1.671-2.581,8.7,8.7,0,0,0,.613-3.321,8.589,8.589,0,0,0-.613-3.279,7.672,7.672,0,0,0-1.671-2.559,7.505,7.505,0,0,0-2.517-1.65A8.189,8.189,0,0,0-184.173-35.116ZM-173.3-46.158v29.57h-2.75l-.085-4.146a8.256,8.256,0,0,1-3.49,3.427,10.171,10.171,0,0,1-4.717,1.142,11.639,11.639,0,0,1-4.146-.719,9.788,9.788,0,0,1-3.342-2.094,9.475,9.475,0,0,1-2.242-3.384,12.406,12.406,0,0,1-.8-4.632,12.406,12.406,0,0,1,.8-4.632,9.475,9.475,0,0,1,2.242-3.384,9.788,9.788,0,0,1,3.342-2.094,11.04,11.04,0,0,1,4.146-.677,10.375,10.375,0,0,1,4.738,1.058,7.428,7.428,0,0,1,3.469,3.427v-12.86Zm26.355,20.348h-18.191a7.5,7.5,0,0,0,.8,2.94,7.141,7.141,0,0,0,1.734,2.179,7.46,7.46,0,0,0,2.432,1.354,9.111,9.111,0,0,0,2.94.465,10.563,10.563,0,0,0,1.946-.19,11.608,11.608,0,0,0,1.967-.55,9.506,9.506,0,0,0,1.777-.888,5.33,5.33,0,0,0,1.375-1.248l1.9,1.692a9.583,9.583,0,0,1-4.019,2.919,13.33,13.33,0,0,1-4.95.973,11.965,11.965,0,0,1-4.315-.761,9.821,9.821,0,0,1-3.427-2.179,10.16,10.16,0,0,1-2.263-3.427,11.765,11.765,0,0,1-.825-4.505,11.405,11.405,0,0,1,.8-4.315,10.343,10.343,0,0,1,2.221-3.427,10,10,0,0,1,3.384-2.242,10.72,10.72,0,0,1,4.294-.761,12.28,12.28,0,0,1,4.357.677,8.9,8.9,0,0,1,3.469,2.2,9.322,9.322,0,0,1,2.157,3.744A13.448,13.448,0,0,1-146.945-25.81Zm-18.191-2.411h15.525a7.619,7.619,0,0,0-.656-3.025,6.405,6.405,0,0,0-1.65-2.221,7.181,7.181,0,0,0-2.432-1.354,9.3,9.3,0,0,0-2.961-.465,7.824,7.824,0,0,0-5.288,1.819A7.888,7.888,0,0,0-165.136-28.221Z\" transform=\"translate(530.963 46.2)\"/>\r\n        <path id=\"sem-2\" data-name=\"sem\" class=\"hhyd-cls-12\" d=\"M25.225-41.913c-3.288-2.884-6.634-3.75-11.076-3.75-5.192,0-12,2.307-12,8.884,0,6.461,6.4,8.422,11.768,8.826,4.038.231,5.653,1.038,5.653,3,0,2.077-2.481,3.461-5.134,3.4-3.173-.058-7.788-1.731-9.807-3.98L1.17-20.511c4.153,4.327,8.653,5.076,13.153,5.076,8.134,0,12.23-4.327,12.23-9.345,0-7.557-6.807-8.768-12.172-9.115-3.634-.231-5.307-1.269-5.307-3.115,0-1.788,1.846-2.827,5.192-2.827A9.591,9.591,0,0,1,21.3-37.3ZM59.261-28.126c1.1-11.71-4.846-17.594-14.364-17.594-9.23,0-15.114,6.23-15.114,14.883,0,9.115,5.826,15.172,15.633,15.172,4.327,0,9.23-1.5,12.23-4.615l-4.5-4.442c-1.615,1.673-5.019,2.654-7.615,2.654-4.961,0-8.018-2.538-8.48-6.057ZM37.167-33.952c1.038-3.692,4.153-5.538,7.961-5.538,4.038,0,6.922,1.846,7.384,5.538Zm52.9,17.537V-31.644c0-3.75,2.365-7.038,6.173-7.038s5.365,3.173,5.365,6.922v15.345h7.038V-31.76c0-8.538-3.98-13.5-12.057-13.5a10.3,10.3,0,0,0-9.518,5.192c-1.615-3.923-5.019-5.307-8.422-5.307-2.711,0-6,1.038-7.5,3.923l-.519-3.461H64.106v28.5h7.038V-31.644c0-3.75,2.25-7.153,6.057-7.153,3.865,0,5.826,3.4,5.826,7.153v15.229Z\" transform=\"translate(-1.17 46.028)\"/>\r\n      </g>\r\n    </g>\r\n    <g id=\"Logo_Simbolo\" transform=\"translate(585.009 14.076)\">\r\n      <path id=\"Branco\" class=\"hhyd-cls-14\" d=\"M0,0H30.425V36.557H0Z\" transform=\"translate(98.316 97.018)\"/>\r\n      <path id=\"Azul-2\" data-name=\"Azul\" class=\"hhyd-cls-15\" d=\"M0,0H64.381V63.162H0Z\" transform=\"translate(64.347 133.561)\"/>\r\n      <path id=\"Roxo-2\" data-name=\"Roxo\" class=\"hhyd-cls-16\" d=\"M0,0H30.428V26.623H0Z\" transform=\"translate(98.313 69.205)\"/>\r\n      <path id=\"Laranja-2\" data-name=\"Laranja\" class=\"hhyd-cls-17\" d=\"M0,0H68.219V64.379H0Z\" transform=\"translate(128.741 69.193)\"/>\r\n      <path id=\"Verde-2\" data-name=\"Verde\" class=\"hhyd-cls-18\" d=\"M0,0H98.316V64.371H0Z\" transform=\"translate(0 69.194)\"/>\r\n      <path id=\"Amarelo-2\" data-name=\"Amarelo\" class=\"hhyd-cls-19\" d=\"M0,0H64.381V69.2H0Z\" transform=\"translate(64.36)\"/>\r\n    </g>\r\n  </g>\r\n</svg>\r\n"

/***/ }),
/* 1705 */
/***/ (function(module, exports) {

	module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\r\n<!-- Generator: Adobe Illustrator 21.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\r\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\r\n\t viewBox=\"0 0 832.8 800\" style=\"enable-background:new 0 0 832.8 800;\" xml:space=\"preserve\">\r\n<style type=\"text/css\">\r\n\t.estado-inactive {fill:#E5E5E5;stroke:#868686;stroke-width:2;stroke-miterlimit:10;}\r\n\t.label-inactive {font-size:18px; fill:#6F6F6E; font-family:'sans-serif', 'Arial', 'Helvetica'; font-weight: 650;}\r\n\t.estado-active {fill:#E5E5E5;stroke:#868686;stroke-width:2;stroke-miterlimit:10; cursor:pointer;}\r\n\t<!-- .estado-active {fill:#A280BC;stroke:#612082;stroke-width:2;stroke-miterlimit:10; cursor:pointer;} -->\r\n  .estado-active.selected {fill:#612082}\r\n  .label-active {fill:#868686;font-size:18px; font-family:'sans-serif', 'Arial', 'Helvetica'; font-weight: 650; cursor:pointer;}\r\n\t<!-- .label-active {fill:#622182;font-size:18px; font-family:'sans-serif', 'Arial', 'Helvetica'; font-weight: 650; cursor:pointer;} -->\r\n  .label-active-outside {fill:#868686;font-size:18px; font-family:'sans-serif', 'Arial', 'Helvetica'; font-weight: 650; cursor:pointer;}\r\n\t<!-- .label-active-outside {fill:#612082;font-size:18px; font-family:'sans-serif', 'Arial', 'Helvetica'; font-weight: 650; cursor:pointer;} -->\r\n  .label-active.selected {fill:#FFFFFF;}\r\n  .label-active.selected.outside {fill:#622182;}\r\n  g:hover .estado-active {fill:#612082}\r\n  g:hover .label-active {fill:#FFFFFF}\r\n  g:hover .label-active.outside,\r\n\tg:hover .label-active-outside {fill:#000000}\r\n\r\n\t#PE .estado-active.selected .label-active-outside {fill:#612082;}\r\n  #DF.estado-active.selected {fill:#612082; stroke:#FFFFFF;}\r\n</style>\r\n<g id=\"AC\">\r\n\t<g>\r\n\t\t<path class=\"estado-inactive\" d=\"M107,337.7c-2.4-0.1-4.7-1.1-6.8-1.9c-0.9-0.4-1.7-0.7-2.5-0.9c-1.7-0.5-3.2-0.5-4.8-0.5c-1,0-2.1,0-3.4-0.1\r\n\t\t\tc-0.5,0-1.1-0.1-1.6-0.1h-0.4c-0.8-0.1-1.5-0.1-2.1-0.1c-0.9,0-1.7,0.1-2.6,0.3c-0.9,0.2-1.7,0.3-2.5,0.4c-1,0.1-1.9,0.2-2.7,0.4\r\n\t\t\tc-0.7,0.1-1.4,0.5-2,0.9c-0.7,0.4-2,1.1-2.8,1.1c0,0-0.1,0-0.2,0c-0.7-0.1-1.3-0.6-1.8-1.2c-0.2-0.2-0.4-0.4-0.6-0.5\r\n\t\t\tc-0.2-0.2-0.3-0.5-0.4-0.8c-1.3-3.4-0.8-8.9-0.5-12.5l0.1-0.7c0.5-6.7,1.5-12.7,3.1-18.1c0-0.1,0-0.2-0.1-0.2h-0.1h-0.1\r\n\t\t\tc-2.3,1.2-4.8,3.4-6.5,5l-1.1,0.9c-0.7,0.6-1.3,1.3-2,1.9c-1.5,1.6-3.1,3.2-5.3,3.8l-0.3,0.1c-2.2,0.6-5.8,1.6-8.3,1.6\r\n\t\t\tc-0.5,0-1,0-1.4-0.1h-0.1c-0.3-0.1-0.6-0.3-0.9-0.4c-0.6-0.3-1.2-0.6-1.6-0.6c-0.1,0-0.1,0-0.2,0c-0.5-0.2-1.1-0.2-1.7-0.2h-0.7\r\n\t\t\tc-0.2,0-0.4,0-0.7,0c-0.8,0-1.3-0.1-1.7-0.3c-1.3-0.6-1.5-1.8-1.8-3c-0.2-0.9-0.4-1.7-0.9-2.7c-0.9-1.5-2.2-2.9-3.7-4.2\r\n\t\t\tc-1.8-1.6-5.2-3.1-8.4-3.1c-1.2,0-2.1,0.2-3,0.6c-0.1,0.1-0.3,0.1-0.5,0.1c-0.3,0-0.6-0.1-0.8-0.3c-0.4-0.4-0.6-0.8-0.6-1.2\r\n\t\t\tc0-0.8,0.7-1.5,1.5-2.4c1.6-1.6,2.7-3,0.9-5.2c-0.9-1.1-1.8-2.1-2.8-3.3l-0.2-0.2c-1.7-2-3.5-4-4.9-6.1c-0.7-0.9-1-1.9-1.2-3\r\n\t\t\tc-0.2-0.8-0.4-1.8-0.9-2.6l-0.3-0.6c-0.3-0.7-0.6-1.3-1.3-1.7c-0.4-0.2-0.9-0.2-1.3-0.3H9.4c-0.1,0-0.1,0-0.2,0\r\n\t\t\tc-0.1,0-0.2,0-0.3,0c-0.3,0-0.6-0.2-0.7-0.4c-0.2-0.2-0.2-0.6-0.1-0.9c0.1-0.3,0.3-0.7,0.4-1l0.1-0.3c0.1-0.3,0.4-0.5,0.7-0.6\r\n\t\t\tc0,0,0.1,0,0.2-0.1c0-0.1,0-0.1,0-0.2c-0.6-1.5-1.6-2.7-2.5-3.7l-0.1-0.1c-0.9-1-1.7-2-2.1-3.1c-0.4-1.2-0.4-2-0.1-2.5\r\n\t\t\ts0.9-0.7,2.5-0.9c0.5-0.1,0.9-0.1,1.5-0.3c0.1,0,0.1-0.1,0.2-0.2c0-0.4,0-0.7,0-1.2c-0.1-0.3,0.1-0.7,0.4-0.9\r\n\t\t\tc0.2-0.1,0.4-0.2,0.6-0.2c0.1,0,0.2,0,0.3,0.1c1.5,0.5,2.8,1.2,4.3,2.1c1.9,1.1,3.8,2.1,6.2,2.6c3,0.6,5.9,1.5,8.9,2.5\r\n\t\t\tc3.2,1.1,6.6,2.2,10.1,2.8c3.5,0.6,7.1,1.3,10.5,2.1l0.4,0.1c4,0.9,8.1,1.8,12.2,2.3c5.8,0.8,10.4,3.3,15.3,5.9\r\n\t\t\tc1.8,1,3.7,2,5.6,2.9c7.2,3.7,14.9,7.1,21.7,10.1l0.3,0.1c6.3,2.8,12.9,5.8,19.2,8.9c1.7,0.9,3.7,1.6,5.2,2.1\r\n\t\t\tc2.3,0.8,4.7,1.6,6.8,3.1c0.7,0.4,1.5,1.1,2.2,1.9l0.1,0.1c1.2,1.1,2.4,2.3,3.7,2.7l0,0c0,0,0.1,0,0.2,0l0,0l0,0\r\n\t\t\tc0.1,0,0.3-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1c1,0,2.5,0.2,3.2,0.4c0.4,0.1,0.7,0.5,0.7,1v0.3c0,0.2,0,0.4,0,0.6\r\n\t\t\tc0.1,0.5-0.1,1-0.5,1.2s-0.9,0.3-1.6,0.6h-0.1c-0.6,0.2-1.2,0.4-1.8,0.6c-1.2,0.6-2.2,1.5-3.1,2.3c-0.9,0.8-1.8,1.6-2.8,2.2\r\n\t\t\tc-1.1,0.6-2.3,1-3.6,1.4c-1.4,0.4-2.8,0.8-3.9,1.6c-1,0.7-1.2,1.6-1.5,2.3c-0.2,0.6-0.4,1.2-0.9,1.9c-0.5,0.7-1.1,1.5-2.1,1.5l0,0\r\n\t\t\tc-0.7,0-1.2-0.3-2-0.7c-0.7-0.4-1.4-0.7-2.1-0.9c-0.3-0.1-0.5-0.1-0.8-0.1c-1.9,0-3,1.6-4.1,3.5c-0.6,1.1-1.2,2.2-2.1,2.8\r\n\t\t\tC112.6,335.4,109.3,337.7,107,337.7C107.1,337.7,107,337.7,107,337.7z\"/>\r\n\r\n\t</g>\r\n\t<text transform=\"matrix(1 0 0 1 62.6166 299.8519)\" class=\"label-inactive\">AC</text>\r\n</g>\r\n<g id=\"RO\">\r\n\t<g>\r\n\t\t<path class=\"estado-inactive\" d=\"M269.3,387.4c-0.1,0-0.2,0-0.3-0.1l-0.4-0.1c-0.4-0.1-1-0.3-1.5-0.5c-2.4-1-6.3-2.2-9.5-2.3\r\n\t\t\tc-0.7,0-1.4,0.2-2.2,0.4l-0.2,0.1c-0.8,0.2-1.5,0.4-2.2,0.4h-0.1c-0.5-0.1-1-0.2-1.6-0.4c-0.8-0.3-1.5-0.5-2.3-0.5\r\n\t\t\tc-1.1,0-1.6,0.2-2.1,0.3c-0.4,0.1-0.7,0.2-1.1,0.2c-0.3,0-0.7-0.1-1.1-0.2c-0.7-0.2-1.8-1.1-3.4-2.3c-0.5-0.4-0.9-0.9-1.3-1.4\r\n\t\t\tl-0.1-0.1c-0.6-0.8-1.3-1.7-2.1-2c0,0-0.1,0-0.1-0.1c-0.6-0.4-1.4-0.6-2.1-0.8l-0.4-0.1c-0.4-0.1-0.8-0.2-1.1-0.3\r\n\t\t\tc-1.3-0.6-2.6-0.9-4-1.2c-1.9-0.4-3.8-0.8-5.4-2.1c-0.9-0.7-1.4-1.4-2-2.2c-0.9-1.3-1.8-2.5-4.5-2.8c-0.2,0-0.5,0-0.8,0\r\n\t\t\tc-0.4,0-0.9,0-1.3,0c-0.5,0-0.9,0.1-1.3,0.1c-0.6,0-1.1-0.1-1.5-0.2c-1.1-0.4-1.7-1.2-2.5-2c-0.7-0.8-1.4-1.6-2.4-2.1\r\n\t\t\tc-0.9-0.4-2-0.7-3.3-0.7s-2.7,0.2-4,0.4c-1.4,0.2-2.8,0.4-4,0.4c-0.4,0-0.7,0-1.1-0.1c-2.8-0.4-3.3-1.4-3.9-2.9\r\n\t\t\tc-0.4-1-0.8-2.1-2-3.2c-0.7-0.7-1.5-1.1-2.2-1.4c-0.9-0.4-1.7-0.8-2.5-1.9c-0.2-0.2-0.3-0.5-0.4-0.7l-0.2-0.3\r\n\t\t\tc-0.6-1-1.1-1.7-2.1-2.5c-3-2.2-5.2-3.9-6.7-7.6c-0.6-1.6-1.1-3.9-1.1-5.5c0-0.7,0.2-1.1,0.4-1.6s0.3-0.9,0.4-1.5\r\n\t\t\tc0.1-1.6-0.4-3-0.9-4.4l-0.4-1.1c-0.8-2.1-1.4-6.2-0.9-8.3c0.1-0.3,0.2-0.7,0.4-1c0.3-0.5,0.6-1,0.6-1.7c0.1-0.6,0.1-1.2,0-2\r\n\t\t\tc0-0.4,0.2-0.8,0.5-1c0,0,0.1-0.1,0.1-0.2c-0.3-0.9-0.3-1.7-0.2-2.6c0-0.9,0.1-1.7-0.2-2.6c-0.7-1.7-1.5-1.7-1.8-1.7\r\n\t\t\ts-0.7,0.1-1,0.2c-0.2,0.1-0.4,0.2-0.6,0.2c-0.4,0-0.7,0.2-1,0.4c-0.1,0-0.1,0.1-0.1,0.1c-0.2,0.2-0.4,0.3-0.7,0.3\r\n\t\t\tc-0.5,0-0.9-0.2-1.3-0.4c-0.4-0.2-0.7-0.4-1.3-0.5c-0.1,0-0.2,0-0.4,0c-1,0-1.8,0.2-2.8,0.5l-0.3,0.1c-0.3,0.1-0.6,0.1-0.9,0.2\r\n\t\t\tc-0.9,0.2-2,0.3-3.2,0.3c-1.6,0.1-3.2,0.1-4.5,0.8c-0.1,0.1-0.3,0.3-0.4,0.6c0,0-0.3,0.4-0.3,0.5s-0.1,0.2-0.2,0.3\r\n\t\t\tc-0.2,0.2-0.5,0.3-0.8,0.3c-0.1,0-0.2,0-0.3,0s-0.2,0-0.2,0h-0.3c-0.4-0.1-0.8-0.1-1-0.1c-0.1,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0\r\n\t\t\tc-0.3,0-0.6,0-0.9,0.1c-0.1,0-0.1,0-0.2,0c-0.2,0-0.5-0.1-0.6-0.2c-0.1,0-0.1,0-0.1,0c-0.5,0-0.9-0.3-1-0.8\r\n\t\t\tc-0.1-0.4-0.2-0.5-0.4-0.6s-0.8-0.4-2.1-0.5c-0.5-0.1-0.8-0.4-0.9-0.9c0-0.5,0.2-0.9,0.7-1c0.4-0.1,0.9-0.2,1.5-0.2\r\n\t\t\tc0.2,0,0.3,0,0.5,0s0.5,0,0.7,0c0.4,0,0.7,0,1-0.1c1.5-0.2,1.6-0.3,1.8-0.8c0.1-0.3,0.2-0.5,0.5-0.8c0.2-0.2,0.2-0.3,0.1-0.6\r\n\t\t\tc0-0.5,0.2-0.9,0.7-1c0.5-0.2,0.6-0.3,0.7-0.3l0.1-0.1c2.2-1.6,4.2-2.4,6.6-2.4c0.4,0,0.8,0,1.2,0.1c1.5,0.2,2.2,0.8,3,1.5\r\n\t\t\tc0.7,0.6,1.4,1.3,2.6,1.6l0,0c0.1,0,0.2-0.1,0.2-0.1c0.5-0.9,1.2-1.3,2.3-1.3c0.2,0,0.4,0,0.7,0c0.2,0,0.5,0,0.8,0\r\n\t\t\tc0.6,0,1.1-0.1,1.6-0.3c1.1-0.4,1.7-1.1,2.3-1.7c0.4-0.4,0.8-0.8,1.3-1.1c0.2-0.1,0.4-0.2,0.6-0.2c0.1,0,0.2,0,0.3,0.1\r\n\t\t\tc0.3,0.1,0.5,0.3,0.6,0.6c0.1,0.4,0.4,0.7,0.7,0.9c0.2,0.1,0.4,0.1,0.6,0.1c1.2,0,2.7-1.1,3.4-1.8c0.7-0.7,1.1-1.5,1.5-2.4\r\n\t\t\tl0.1-0.1c0.4-0.9,0.9-1.9,1.7-2.6c1.4-1.4,4-1.8,6.5-2.2c1.6-0.3,3.3-0.5,4.5-1.1h0.1l0.4-0.1c0.9-0.3,1.9-0.6,2.4-1.2l0.1-0.1\r\n\t\t\tc0.7-0.7,0.9-1.5,1.1-2.4c0.2-0.7,0.3-1.4,0.6-2c0.4-0.6,1-1.2,1.7-1.9l0.3-0.3c0.3-0.3,0.6-0.7,0.9-0.9c0.6-0.7,1.1-0.9,1.6-1.2\r\n\t\t\tc0.5-0.2,0.8-0.4,1.4-0.8c0.6-0.5,0.9-1,1.1-1.6c0.2-0.4,0.4-0.8,0.9-1.4c0.5-0.7,1.4-1.3,2.2-1.9c0.6-0.4,1.1-0.7,1.5-1.1\r\n\t\t\tc0.1-0.1,0.2-0.4,0.2-0.7c0-0.5,0.4-0.9,0.9-0.9c0.1,0,0.3,0,0.5,0c0.4,0,0.8,0,1.1,0h0.2c0.4,0,0.8,0,1.1,0c0.1,0,0.3,0,0.3,0\r\n\t\t\tc0.1,0,0.1,0,0.2,0c0.5,0,1.1-0.1,1.8-0.2c0.6-0.1,1.4-0.2,2.1-0.2c0.4,0,0.8,0,1.1,0.1c0.7,0.2,1,0.5,1.3,0.9l0.2,0.2\r\n\t\t\tc0.2,0.2,0.4,0.4,0.6,0.5l0.1,0.1c0.4,0.4,0.9,0.6,1.3,0.8h0.1c0.4,0.2,0.8,0.4,1.2,0.8c0.6,0.6,0.7,1.2,0.9,1.8\r\n\t\t\tc0.2,0.8,0.4,1.5,1.4,2c0.3,0.1,0.7,0.2,1.2,0.2h0.5c0.1,0,0.3,0,0.4,0c0.6,0,1,0.1,1.3,0.3c0.2,0.1,0.3,0.2,0.4,0.2\r\n\t\t\tc0.2,0.2,0.4,0.4,0.5,0.7c0,0.3,0.1,0.5,0.4,1c1.2,1.7,2.7,2.4,4.1,3.2l0.2,0.1c0.7,0.4,1.5,0.8,2.3,1.3c1,0.7,1.7,1.7,2.3,2.5\r\n\t\t\tc0.7,0.9,1.4,1.7,2.2,2.4h0.1c0,0,0.1,0,0.1-0.1c0.6-0.7,0.8-1.3,0.9-1.8c0-0.1,0-0.1,0-0.2c0.1-0.4,0.4-0.7,0.8-0.8\r\n\t\t\tc0.2,0,0.4-0.1,0.8-0.1c0.2,0,0.4,0,0.7,0l0,0c0.6,0,1.3,0.1,2,0.4c0.2,0.1,0.4,0.2,0.5,0.3l0,0c0,0,0.1,0.1,0.3,0.2\r\n\t\t\ts0.3,0.2,0.5,0.4c0,0.1,0.1,0.1,0.1,0.1c0.7,0.2,1.1,0.4,1.4,0.8c0.4,0.7,0.1,1.7-0.6,3.4l-0.1,0.1c-0.3,0.7-0.6,1.5-0.6,2\r\n\t\t\tc-0.2,1.2,0.1,2.2,0.4,3.3c0.2,0.6,0.4,1.2,0.5,1.9c0.4,2.2,0.2,4.3-0.2,6.7c-0.6,4.4-0.6,7.4,0,11.4l0.3,1.6\r\n\t\t\tc0.7,4.4,1.5,8.9,1.5,13.3c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.1c0.1-0.4,0.5-0.6,0.9-0.6h0.1c1,0.1,2,0.2,3.1,0.2\r\n\t\t\tc2.8,0,5.6-0.3,8-0.6c1.3-0.2,2.8-0.3,4.2-0.5c0.2,0,0.3,0,0.5,0c1.7,0,2.8,0.8,3.8,1.6c0.8,0.6,1.7,1.2,2.8,1.5\r\n\t\t\tc0.2,0.1,0.5,0.1,0.7,0.1c0.4,0,0.9-0.1,1.3-0.2c0.5-0.1,0.9-0.2,1.3-0.2c1.1,0,1.4,0,1.7,0.1c0.1,0,0.2,0.1,0.3,0.2\r\n\t\t\tc0.2,0.2,0.3,0.4,0.6,0.8l0.8,1.3c0.7,1.1,1.5,2.2,1,3.6c-0.1,0.2-0.2,0.4-0.9,1.1c-0.4,0.4-0.8,0.8-1.1,1.4\r\n\t\t\tc-0.8,2.2-0.3,6.8,0.9,8.8c0.3,0.5,0.6,0.9,0.9,1.2c0.6,0.6,0.9,1.1,1.1,2.2c0.2,1.6,0.2,3.2,0.2,4.8v1.6\r\n\t\t\tc-0.1,3.1-1.4,6.2-3.7,8.9c-0.4,0.5-0.9,1-1.4,1.5c-1,1-1.9,2-2.5,3.1c-0.2,0.5-0.4,0.9-0.6,1.3l-0.1,0.3\r\n\t\t\tc-0.4,0.9-0.7,1.6-1.4,2.5c-1.4,2-3,3-4.8,4.1c-0.5,0.3-1.1,0.7-1.7,1.1c-0.2,0.1-0.4,0.2-0.6,0.2l0,0c-0.1,0-0.1,0-0.1,0\r\n\t\t\tC269.7,387.3,269.5,387.4,269.3,387.4z\"/>\r\n\r\n\t</g>\r\n\t<text transform=\"matrix(1 0 0 1 214.5529 339.8771)\" class=\"label-inactive\">RO</text>\r\n</g>\r\n<g id=\"RR\">\r\n\t<g>\r\n\t\t<path class=\"estado-inactive\" d=\"M249.6,140.7c-0.1,0-0.2,0-0.3,0c-4.5-1.2-8.1-3.4-11.5-7.1c-0.5-0.5-1.1-1.1-1.8-1.8\r\n\t\t\tc-1.5-1.4-2.7-2.6-3.3-3.6l0,0c-0.1-0.2-0.1-0.3-0.1-0.5c0-0.3,0.1-0.5,0.3-0.7s0.4-0.3,0.7-0.3l0,0c0.9,0,1.4-0.2,1.7-0.6\r\n\t\t\tc0.9-1,0-3.8-1-6.4l-0.2-0.4c-0.8-1.9-0.9-3.9-0.9-5.8v-0.2c0-1.1,0-2.3-0.2-3.5c-0.2-1.4-0.5-2.8-0.8-4.3c-0.4-2-0.8-3.8-0.9-5.8\r\n\t\t\tc0-0.5,0-1.3,0.1-2.2v-0.3c0.2-2.5,0.5-5.7-0.8-6.6h-0.1h-0.1c-0.1,0-0.2,0.1-0.4,0.1c-0.3,0-0.6-0.2-0.8-0.4\r\n\t\t\tc-0.5-0.7-0.6-1.4-0.8-2.3c-0.1-0.5-0.2-1.1-0.4-1.7c-0.4-1.4-1.3-2.6-2.1-3.6c-0.9-1.1-1.8-2.3-2.1-3.9c-0.4-1.4-0.8-2.2-1.4-3.3\r\n\t\t\tl-0.3-0.7c-0.3-0.6-0.4-1.3-0.5-2v-0.1c-0.1-0.6-0.2-1.2-0.4-1.8c-0.6-1.3-2.2-2.3-4.9-2.8c-0.3-0.1-0.5-0.2-0.7-0.4\r\n\t\t\tc-0.1-0.2-0.2-0.5-0.1-0.8c0.4-1.5,0.4-3.5,0-4.6c-0.3-0.8-0.7-1.3-1.3-1.5c-0.3-0.1-0.5-0.1-0.8-0.1c-0.8,0-1.5,0.4-2.1,0.8\r\n\t\t\tc-0.6,0.4-0.9,0.6-1.3,0.7h-0.1c-0.1,0-0.2,0-0.3,0c-0.4,0-0.7-0.1-1.1-0.2h-0.1c-0.3-0.1-0.6-0.1-0.9-0.1c-0.2,0-0.4,0-0.6,0.1\r\n\t\t\tc-0.1,0-0.2,0-0.3,0c-0.2,0-0.4-0.1-0.6-0.2c-1-0.7-1.7-1.1-3.2-1.5c-0.6-0.2-1.3-0.2-1.8-0.2c-0.7,0-1.2,0-1.6-0.3\r\n\t\t\tc-0.1,0-0.1-0.1-0.2-0.1c-0.8-0.8-0.7-2.3-0.6-3.7v-0.1c0-0.6,0.1-1.4,0-1.9c0-1.3-0.2-2.5-0.3-3.7V50c-0.1-0.8-0.2-1.5-0.3-2.3\r\n\t\t\tc0-0.1-0.1-0.2-0.2-0.2c-0.2,0-0.8-0.1-1.1-0.6c-0.4-0.7-0.2-1.7,0-2.4c0.3-0.9,0.9-1.4,1.5-1.9c0.7-0.6,1.4-1.2,1.9-2.4\r\n\t\t\tc0.9-2.2,0.2-3.3-0.6-4.7c-0.5-0.8-1-1.7-1.2-2.9l-0.2-1c-0.4-2.4-0.5-2.4-2-2.7c-0.6-0.1-1.2-0.2-2.1-0.5c-1.2-0.3-3.3-1.6-3.7-3\r\n\t\t\tc-0.1-0.3-0.3-1,0.4-1.7c0.1-0.1,0.1-0.1,0.2-0.2c0.2-0.2,0.8-0.6,3.5-0.6c1.5,0,4.2,0.2,5.1,0.6c1.2,0.6,1.5,1.4,1.8,2.2\r\n\t\t\tc0.4,1.2,0.8,2.2,3.6,2.3c2,0.1,3.4,0.7,4.8,1.4c1.3,0.6,2.7,1.3,4.6,1.4c0.2,0,0.5,0,0.8,0h0.5c0.5,0,1.1-0.1,1.7-0.1\r\n\t\t\tc1.6,0,2.8,0.2,3.5,0.7c0.7,0.4,1,1,1.4,1.8s0.7,1.5,1.6,1.9c0.8,0.4,1.7,0.6,2.7,0.6c0.9,0,1.8-0.2,2.5-0.5\r\n\t\t\tc1-0.5,1.6-1.2,1.8-2.1c0.2-0.9,0-1.7-0.1-2.5c-0.3-1.3-0.5-2.3,0.7-3.1c1.7-1.3,6.3-1.5,10.6-1.5c0.4,0,0.8,0.1,1.4,0.1h0.3\r\n\t\t\tc1.1,0.1,2.1,0.2,2.9,0.2c1,0,1.6-0.1,2-0.4c0.8-0.5,0.8-0.9,0.7-1.4c-0.1-0.2-0.1-0.4-0.1-0.6s0-0.3,0.1-0.5\r\n\t\t\tc0.5-0.9,0.9-1.1,1.9-1.2c0.6-0.1,1.3-0.2,2.3-0.7c0.7-0.5,1-1.1,1.2-1.6c0.1-0.3,0.3-0.7,0.6-1c0.6-0.6,1.1-0.7,1.8-0.7\r\n\t\t\tc0.5,0,0.9-0.1,1.4-0.2c0.3-0.1,0.6-0.2,0.8-0.3c0,0,0.1,0,0.1-0.1c0.3-0.1,0.7-0.3,1.2-0.3c0.5-0.1,1.2-0.1,1.9-0.1\r\n\t\t\tc0.9,0,1.9,0,2.7-0.3c1.2-0.4,1.4-1.1,1.8-1.8c0.1-0.3,0.3-0.6,0.5-0.9c0.2-0.3,0.5-0.4,0.8-0.4h0.1h0.1c0,0,0.1-0.1,0.1-0.2\r\n\t\t\tc0-0.2,0-0.4,0.1-0.5V13c0-0.2,0-0.4,0.1-0.6c0.3-0.6,0.9-1.1,1.9-1.7c1.5-1,2.7-1.9,2.2-3.7c-0.1-0.1-0.5-0.6-1.1-1.2l-0.1-0.1\r\n\t\t\tc-0.3-0.3-0.4-0.8-0.2-1.2c0.2-0.3,0.5-0.5,0.9-0.5c0.1,0,0.1,0,0.2,0c0.4,0.1,0.9,0.1,1.4,0.1c1.1,0,2.4-0.2,3.5-0.3h0.1\r\n\t\t\tc0.8-0.1,1.4-0.2,1.9-0.2c0,0,0.1-0.1,0.1-0.3c0-0.3,0.1-0.6,0.4-0.8c0.2-0.1,0.5-0.2,0.7-0.2c0.4,0,0.9,0.2,1.4,0.5\r\n\t\t\tc0.8,0.5,0.8,1,0.9,1.7c0,0.5,0.1,1.1,0.4,1.5c0.4,0.7,0.7,0.8,0.9,0.9c0.6,0.1,0.8,0.8,1,1.2c0.3,1.5,0,3.4-0.8,4.3\r\n\t\t\tc-0.3,0.4-0.6,0.5-0.9,0.6c-0.5,0.2-0.9,0.3-1.1,1.6c-0.3,2,0.3,2.2,1.6,2.5h0.1c0.2,0,0.4,0.1,0.7,0.2l0.8,0.2\r\n\t\t\tc2.5,0.5,3.9,0.8,4.9,3.7c0.8,2.6,1.4,4.1,3.2,6.4c0.3,0.3,0.5,0.5,0.8,0.7l0.1,0.1c0.2,0.1,0.2,0.2,0.3,0.3\r\n\t\t\tc0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.2,0.1,0.4,0.1,0.8c-0.1,1.3-1.3,2.3-2.4,3.1c-0.6,0.4-1,0.8-1.3,1c-1.6,1.5-2.3,3.4-3,5.2\r\n\t\t\tl-0.1,0.1c-0.4,1-0.8,2-1.3,2.9c-0.9,1.6-0.9,3-1,4.4c0,1.2-0.1,2.4-0.6,3.8c0,0.1,0,0.2,0.1,0.2c0.2,0.2,0.3,0.5,0.3,0.7\r\n\t\t\tc0,1.6-0.2,6.5,1.2,8.7c0.3,0.4,0.6,0.7,0.8,0.9c0.3,0.2,0.5,0.4,0.5,0.5c0.1,0.1,0.2,0.2,0.2,0.3c0.3,0.7,0.6,1.9,0.8,2.9\r\n\t\t\tc0.1,0.4,0.2,0.8,0.3,1.2c0.2,0.6,0.3,1.2,0.4,1.9c0.3,1.8,0.7,3.9,2.1,5.1l0.1,0.1c1.5,1.5,2.3,2.3,3.4,4.3\r\n\t\t\tc0.9,1.4,1.6,1.8,2.6,2.3c0.5,0.2,0.9,0.5,1.4,0.8c0.5,0.4,0.9,0.8,1.2,1.2c0.5,0.6,1.1,1.2,1.8,1.5c0.7,0.2,1.4,0.2,2,0.2h0.2\r\n\t\t\tc0.6,0,1.2,0,1.7,0.2c2,0.8,2.3,2.4,2.3,4.1c0,0.3-0.2,0.7-0.5,0.9c0,0-0.1,0.1-0.1,0.2c0,0.5-0.2,0.8-0.5,1.3\r\n\t\t\tc-0.3,0.3-0.5,0.7-0.6,1v0.1c-0.3,1.2-0.1,3.6,0.1,4.4v0.1c0.1,0.5,0.3,0.9,0.4,1.3c0.2,0.5,0.4,0.9,0.5,1.7\r\n\t\t\tc0.2,1.2,0.3,4.9-0.1,5.9c-0.5,0.9-1.6,1.1-2.7,1.1c-0.8,0-1.7-0.1-2.3-0.1c-0.8-0.1-1.6-0.1-2.2-0.1c-0.4,0-0.8,0-1.1,0.1\r\n\t\t\tc-1.3,0.2-2.6,0.6-3.7,1l-0.4,0.1c-0.9,0.3-1.9,0.6-2.9,0.8c-0.5,0.1-1,0.1-1.7,0.1c-0.4,0-0.8,0-1.3,0c-0.4,0-0.9,0-1.3,0\r\n\t\t\tc-1.1,0-1.9,0.1-2.5,0.4c-2.3,0.8-3.5,4.3-4.4,6.7c-0.1,0.3-0.2,0.7-0.3,1.2v0.1c-0.2,0.7-0.3,1.4-0.6,1.8\r\n\t\t\tc-0.4,0.7-1.1,1.2-1.8,1.6c-0.6,0.4-1.2,0.7-1.8,1.4c-1,1.2-1.1,2.6-1.3,4h-1l1,0.1c-0.1,1.2-0.3,2.3-1,3.3c-0.7,1-1.8,1.1-3,1.2\r\n\t\t\tc-0.7,0.1-1.3,0.1-1.8,0.4c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2c-0.9-0.7-1.7-1.5-2.7-2.5c-0.6-0.6-1.2-1.3-2.1-2\r\n\t\t\tc-1.2-1.2-2.4-2.4-4-2.4c-0.4,0-0.7,0.1-1.1,0.2c-1,0.3-2.2,1.1-3.1,1.7c-0.7,0.5-1.4,0.9-2,1.3c-2.9,1.6-2.9,2.9-2.9,6.2\r\n\t\t\tc0,2.9-0.1,5.5-0.4,8c0,0.3-0.2,0.5-0.4,0.7C250,140.6,249.8,140.7,249.6,140.7z\"/>\r\n\r\n\t</g>\r\n\t<text transform=\"matrix(1 0 0 1 244.7928 74.7105)\" class=\"label-inactive\">RR</text>\r\n\t<g>\r\n\t\t<path class=\"estado-inactive\" d=\"M249.6,140.7c-0.1,0-0.2,0-0.3,0c-4.5-1.2-8.1-3.4-11.5-7.1c-0.5-0.5-1.1-1.1-1.8-1.8\r\n\t\t\tc-1.5-1.4-2.7-2.6-3.3-3.6l0,0c-0.1-0.2-0.1-0.3-0.1-0.5c0-0.3,0.1-0.5,0.3-0.7s0.4-0.3,0.7-0.3l0,0c0.9,0,1.4-0.2,1.7-0.6\r\n\t\t\tc0.9-1,0-3.8-1-6.4l-0.2-0.4c-0.8-1.9-0.9-3.9-0.9-5.8v-0.2c0-1.1,0-2.3-0.2-3.5c-0.2-1.4-0.5-2.8-0.8-4.3c-0.4-2-0.8-3.8-0.9-5.8\r\n\t\t\tc0-0.5,0-1.3,0.1-2.2v-0.3c0.2-2.5,0.5-5.7-0.8-6.6h-0.1h-0.1c-0.1,0-0.2,0.1-0.4,0.1c-0.3,0-0.6-0.2-0.8-0.4\r\n\t\t\tc-0.5-0.7-0.6-1.4-0.8-2.3c-0.1-0.5-0.2-1.1-0.4-1.7c-0.4-1.4-1.3-2.6-2.1-3.6c-0.9-1.1-1.8-2.3-2.1-3.9c-0.4-1.4-0.8-2.2-1.4-3.3\r\n\t\t\tl-0.3-0.7c-0.3-0.6-0.4-1.3-0.5-2v-0.1c-0.1-0.6-0.2-1.2-0.4-1.8c-0.6-1.3-2.2-2.3-4.9-2.8c-0.3-0.1-0.5-0.2-0.7-0.4\r\n\t\t\tc-0.1-0.2-0.2-0.5-0.1-0.8c0.4-1.5,0.4-3.5,0-4.6c-0.3-0.8-0.7-1.3-1.3-1.5c-0.3-0.1-0.5-0.1-0.8-0.1c-0.8,0-1.5,0.4-2.1,0.8\r\n\t\t\tc-0.6,0.4-0.9,0.6-1.3,0.7h-0.1c-0.1,0-0.2,0-0.3,0c-0.4,0-0.7-0.1-1.1-0.2h-0.1c-0.3-0.1-0.6-0.1-0.9-0.1c-0.2,0-0.4,0-0.6,0.1\r\n\t\t\tc-0.1,0-0.2,0-0.3,0c-0.2,0-0.4-0.1-0.6-0.2c-1-0.7-1.7-1.1-3.2-1.5c-0.6-0.2-1.3-0.2-1.8-0.2c-0.7,0-1.2,0-1.6-0.3\r\n\t\t\tc-0.1,0-0.1-0.1-0.2-0.1c-0.8-0.8-0.7-2.3-0.6-3.7v-0.1c0-0.6,0.1-1.4,0-1.9c0-1.3-0.2-2.5-0.3-3.7V50c-0.1-0.8-0.2-1.5-0.3-2.3\r\n\t\t\tc0-0.1-0.1-0.2-0.2-0.2c-0.2,0-0.8-0.1-1.1-0.6c-0.4-0.7-0.2-1.7,0-2.4c0.3-0.9,0.9-1.4,1.5-1.9c0.7-0.6,1.4-1.2,1.9-2.4\r\n\t\t\tc0.9-2.2,0.2-3.3-0.6-4.7c-0.5-0.8-1-1.7-1.2-2.9l-0.2-1c-0.4-2.4-0.5-2.4-2-2.7c-0.6-0.1-1.2-0.2-2.1-0.5c-1.2-0.3-3.3-1.6-3.7-3\r\n\t\t\tc-0.1-0.3-0.3-1,0.4-1.7c0.1-0.1,0.1-0.1,0.2-0.2c0.2-0.2,0.8-0.6,3.5-0.6c1.5,0,4.2,0.2,5.1,0.6c1.2,0.6,1.5,1.4,1.8,2.2\r\n\t\t\tc0.4,1.2,0.8,2.2,3.6,2.3c2,0.1,3.4,0.7,4.8,1.4c1.3,0.6,2.7,1.3,4.6,1.4c0.2,0,0.5,0,0.8,0h0.5c0.5,0,1.1-0.1,1.7-0.1\r\n\t\t\tc1.6,0,2.8,0.2,3.5,0.7c0.7,0.4,1,1,1.4,1.8s0.7,1.5,1.6,1.9c0.8,0.4,1.7,0.6,2.7,0.6c0.9,0,1.8-0.2,2.5-0.5\r\n\t\t\tc1-0.5,1.6-1.2,1.8-2.1c0.2-0.9,0-1.7-0.1-2.5c-0.3-1.3-0.5-2.3,0.7-3.1c1.7-1.3,6.3-1.5,10.6-1.5c0.4,0,0.8,0.1,1.4,0.1h0.3\r\n\t\t\tc1.1,0.1,2.1,0.2,2.9,0.2c1,0,1.6-0.1,2-0.4c0.8-0.5,0.8-0.9,0.7-1.4c-0.1-0.2-0.1-0.4-0.1-0.6s0-0.3,0.1-0.5\r\n\t\t\tc0.5-0.9,0.9-1.1,1.9-1.2c0.6-0.1,1.3-0.2,2.3-0.7c0.7-0.5,1-1.1,1.2-1.6c0.1-0.3,0.3-0.7,0.6-1c0.6-0.6,1.1-0.7,1.8-0.7\r\n\t\t\tc0.5,0,0.9-0.1,1.4-0.2c0.3-0.1,0.6-0.2,0.8-0.3c0,0,0.1,0,0.1-0.1c0.3-0.1,0.7-0.3,1.2-0.3c0.5-0.1,1.2-0.1,1.9-0.1\r\n\t\t\tc0.9,0,1.9,0,2.7-0.3c1.2-0.4,1.4-1.1,1.8-1.8c0.1-0.3,0.3-0.6,0.5-0.9c0.2-0.3,0.5-0.4,0.8-0.4h0.1h0.1c0,0,0.1-0.1,0.1-0.2\r\n\t\t\tc0-0.2,0-0.4,0.1-0.5V13c0-0.2,0-0.4,0.1-0.6c0.3-0.6,0.9-1.1,1.9-1.7c1.5-1,2.7-1.9,2.2-3.7c-0.1-0.1-0.5-0.6-1.1-1.2l-0.1-0.1\r\n\t\t\tc-0.3-0.3-0.4-0.8-0.2-1.2c0.2-0.3,0.5-0.5,0.9-0.5c0.1,0,0.1,0,0.2,0c0.4,0.1,0.9,0.1,1.4,0.1c1.1,0,2.4-0.2,3.5-0.3h0.1\r\n\t\t\tc0.8-0.1,1.4-0.2,1.9-0.2c0,0,0.1-0.1,0.1-0.3c0-0.3,0.1-0.6,0.4-0.8c0.2-0.1,0.5-0.2,0.7-0.2c0.4,0,0.9,0.2,1.4,0.5\r\n\t\t\tc0.8,0.5,0.8,1,0.9,1.7c0,0.5,0.1,1.1,0.4,1.5c0.4,0.7,0.7,0.8,0.9,0.9c0.6,0.1,0.8,0.8,1,1.2c0.3,1.5,0,3.4-0.8,4.3\r\n\t\t\tc-0.3,0.4-0.6,0.5-0.9,0.6c-0.5,0.2-0.9,0.3-1.1,1.6c-0.3,2,0.3,2.2,1.6,2.5h0.1c0.2,0,0.4,0.1,0.7,0.2l0.8,0.2\r\n\t\t\tc2.5,0.5,3.9,0.8,4.9,3.7c0.8,2.6,1.4,4.1,3.2,6.4c0.3,0.3,0.5,0.5,0.8,0.7l0.1,0.1c0.2,0.1,0.2,0.2,0.3,0.3\r\n\t\t\tc0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.2,0.1,0.4,0.1,0.8c-0.1,1.3-1.3,2.3-2.4,3.1c-0.6,0.4-1,0.8-1.3,1c-1.6,1.5-2.3,3.4-3,5.2\r\n\t\t\tl-0.1,0.1c-0.4,1-0.8,2-1.3,2.9c-0.9,1.6-0.9,3-1,4.4c0,1.2-0.1,2.4-0.6,3.8c0,0.1,0,0.2,0.1,0.2c0.2,0.2,0.3,0.5,0.3,0.7\r\n\t\t\tc0,1.6-0.2,6.5,1.2,8.7c0.3,0.4,0.6,0.7,0.8,0.9c0.3,0.2,0.5,0.4,0.5,0.5c0.1,0.1,0.2,0.2,0.2,0.3c0.3,0.7,0.6,1.9,0.8,2.9\r\n\t\t\tc0.1,0.4,0.2,0.8,0.3,1.2c0.2,0.6,0.3,1.2,0.4,1.9c0.3,1.8,0.7,3.9,2.1,5.1l0.1,0.1c1.5,1.5,2.3,2.3,3.4,4.3\r\n\t\t\tc0.9,1.4,1.6,1.8,2.6,2.3c0.5,0.2,0.9,0.5,1.4,0.8c0.5,0.4,0.9,0.8,1.2,1.2c0.5,0.6,1.1,1.2,1.8,1.5c0.7,0.2,1.4,0.2,2,0.2h0.2\r\n\t\t\tc0.6,0,1.2,0,1.7,0.2c2,0.8,2.3,2.4,2.3,4.1c0,0.3-0.2,0.7-0.5,0.9c0,0-0.1,0.1-0.1,0.2c0,0.5-0.2,0.8-0.5,1.3\r\n\t\t\tc-0.3,0.3-0.5,0.7-0.6,1v0.1c-0.3,1.2-0.1,3.6,0.1,4.4v0.1c0.1,0.5,0.3,0.9,0.4,1.3c0.2,0.5,0.4,0.9,0.5,1.7\r\n\t\t\tc0.2,1.2,0.3,4.9-0.1,5.9c-0.5,0.9-1.6,1.1-2.7,1.1c-0.8,0-1.7-0.1-2.3-0.1c-0.8-0.1-1.6-0.1-2.2-0.1c-0.4,0-0.8,0-1.1,0.1\r\n\t\t\tc-1.3,0.2-2.6,0.6-3.7,1l-0.4,0.1c-0.9,0.3-1.9,0.6-2.9,0.8c-0.5,0.1-1,0.1-1.7,0.1c-0.4,0-0.8,0-1.3,0c-0.4,0-0.9,0-1.3,0\r\n\t\t\tc-1.1,0-1.9,0.1-2.5,0.4c-2.3,0.8-3.5,4.3-4.4,6.7c-0.1,0.3-0.2,0.7-0.3,1.2v0.1c-0.2,0.7-0.3,1.4-0.6,1.8\r\n\t\t\tc-0.4,0.7-1.1,1.2-1.8,1.6c-0.6,0.4-1.2,0.7-1.8,1.4c-1,1.2-1.1,2.6-1.3,4h-1l1,0.1c-0.1,1.2-0.3,2.3-1,3.3c-0.7,1-1.8,1.1-3,1.2\r\n\t\t\tc-0.7,0.1-1.3,0.1-1.8,0.4c-0.2,0.1-0.3,0.1-0.5,0.1s-0.4-0.1-0.6-0.2c-0.9-0.7-1.7-1.5-2.7-2.5c-0.6-0.6-1.2-1.3-2.1-2\r\n\t\t\tc-1.2-1.2-2.4-2.4-4-2.4c-0.4,0-0.7,0.1-1.1,0.2c-1,0.3-2.2,1.1-3.1,1.7c-0.7,0.5-1.4,0.9-2,1.3c-2.9,1.6-2.9,2.9-2.9,6.2\r\n\t\t\tc0,2.9-0.1,5.5-0.4,8c0,0.3-0.2,0.5-0.4,0.7C250,140.6,249.8,140.7,249.6,140.7z\"/>\r\n\r\n\t</g>\r\n\t<text transform=\"matrix(1 0 0 1 244.7928 74.7105)\" class=\"label-inactive\">RR</text>\r\n</g>\r\n<g id=\"AM\">\r\n\t<g>\r\n\t\t<path class=\"estado-inactive\" d=\"M142.9,310.7c-0.1,0-0.3,0-0.4-0.1c-1.1-0.5-2.1-1.5-3-2.3l-0.1-0.1c-0.8-0.7-1.6-1.5-2.3-1.9\r\n\t\t\tc-2.2-1.5-4.7-2.4-6.9-3.1L130,303c-1.6-0.6-3.3-1.2-4.9-2c-6.2-3.1-12.6-5.9-18.8-8.7l-1.2-0.5c-7-3.1-14.2-6.3-21.1-9.8\r\n\t\t\tc-1.8-0.8-3.5-1.8-5.1-2.7l-0.4-0.2c-4.9-2.7-9.5-5.2-15.4-6c-4.2-0.6-8.6-1.5-12.4-2.4c-3.3-0.7-7-1.5-10.7-2.1\r\n\t\t\tc-3.5-0.6-7.1-1.8-10-2.7c-2.9-1-5.9-2-8.9-2.5c-2.2-0.4-4-1.5-6-2.5c-1.6-0.9-3.3-1.8-5.1-2.4c-0.2-0.1-0.5-0.2-0.6-0.5\r\n\t\t\tc-0.5-0.9-1.1-1.6-1.9-2.1c-0.4-0.3-0.5-0.9-0.3-1.3c1.7-2.7,4.9-6.5,8.2-8.2c0.4-0.2,0.8-0.4,1.2-0.5l0.2-0.1\r\n\t\t\tc1-0.3,2.1-0.7,2.5-2.1c0.3-1,0.1-2-0.1-3c-0.2-0.9-0.4-1.8-0.2-2.7c0-0.1,0-0.2,0-0.2c-0.2,0-0.4-0.1-0.6-0.3\r\n\t\t\tc-0.8-1-0.5-4.3-0.1-5.2c0.5-1.1,1.1-1.8,1.6-2.3c0.8-0.9,1.6-1.7,1.9-3.7L22,225c0.2-2.1,0.5-4.4,1.4-6c0.3-0.5,0.9-1,1.5-1.4\r\n\t\t\tl0.7,0.7l-0.6-0.8c0.8-0.6,1.6-1.2,1.7-2c0-0.2,0-0.3,0-0.5c-0.1-0.3,0-0.5,0.2-0.8c0.2-0.2,0.4-0.4,0.6-0.4\r\n\t\t\tc0.3,0,0.5-0.1,0.8-0.1l0.2,1l-0.1-1c1-0.1,2-0.3,3.1-1.1c1-0.7,1.9-1.5,2.6-2.2l0.1-0.1c0.9-0.8,1.7-1.6,2.8-2.2\r\n\t\t\tc4.7-2.9,13.8-6.2,19.9-6.3l0,0c0.5,0,0.9,0,1.4,0.1h0.3c0.6,0,1.2,0.1,1.8,0.1c1.4,0,2.5-0.3,3.4-1c0.6-0.5,1-1.2,1.3-1.9\r\n\t\t\tc0.5-1,1-1.9,2.3-2.3c0.5-0.1,1.1-0.2,1.8-0.2c2.1,0,5,0.5,6.5,1.7c0.7,0.5,1.1,1.1,1.1,1.8c0,0,0.1,0.1,0.2,0.1\r\n\t\t\tc0.6,0.1,1.1,0.2,1.6,0.2c1.2,0,2.2-0.3,2.9-0.9c1.2-1,1.9-2.7,2.1-5.5c0-0.3,0.1-0.5,0.3-0.7l0.1-0.1c0.3-4.4,1-8.9,1.9-12.8\r\n\t\t\tc0.5-2.2,0.9-4.5,1.2-6.6c0.4-2.6,0.8-5.3,1.5-7.9c2.3-8.7,4.4-17.1,4.5-25.4c0-3.7-0.3-4.4-2.7-6.8c-2.2-2.2-2.5-3-2.6-3.4\r\n\t\t\tc-0.1-0.7,0.3-1.1,0.7-1.5c0.3-0.3,0.5-0.6,0.6-0.9c0.7-3.5-3.7-7.7-7.2-9.1c-0.1,0-0.1-0.1-0.2-0.1c0,0-0.1,0-0.1-0.1\r\n\t\t\tc-1.5-0.9-1.7-2-1.8-3.8v-0.7c-0.2-2.9-0.4-7.4,0.2-10.2c0.6-2.7,3-3.2,5.6-3.7c0.6-0.1,1.2-0.2,1.7-0.4c0.3-0.1,0.5-0.1,0.8-0.2\r\n\t\t\tl0.2-0.1c0.8-0.2,1.6-0.5,2.5-0.5c0.3,0,0.6,0,0.9,0.1c0.8,0.2,1.3,0.5,1.9,0.9c0.5,0.3,0.9,0.6,1.4,0.7c0.4,0.1,0.8,0.2,1.1,0.2\r\n\t\t\tc1,0,1.5-0.5,1.8-0.9c1.3-1.7,0.5-5.2-0.5-6.9c-0.9-1.7-2.2-2.4-4.2-2.4c-0.8,0-1.6,0.1-2.3,0.2h-0.2c-0.6,0.1-1.1,0.2-1.7,0.2\r\n\t\t\tc-0.2,0-0.4,0-0.6,0c-1.2,0-2.1-0.3-2.7-0.9c-1-0.9-1-2.5-1-4.4v-0.1c0-1,0-2.1-0.2-3.1c-0.5-4.1,0.9-5.2,4.7-6.8\r\n\t\t\tc1-0.4,1.6-0.7,2.3-0.7c0.5,0,1,0.1,1.8,0.4c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.3,0.2,0.5,0.4c0.2,0.2,0.5,0.5,0.7,0.6h0.1\r\n\t\t\tc0.6,0.3,1.4,0.4,2.4,0.4s2-0.1,3-0.2l1.3-0.1h0.1c1.4,0,2.8-0.1,4.3-0.2c1.3-0.1,2.8-0.2,4.3-0.2c0.3,0,0.8,0,1.4,0.1l0.6,0.1\r\n\t\t\tc1.4,0.1,2.5,0.2,3.5,0.2c1.2,0,2-0.2,2.4-0.5c0.6-0.4,0.7-1.6,0.9-2.8c0-0.2,0.1-0.5,0.1-0.8c0.1-0.4,0.4-0.7,0.8-0.8\r\n\t\t\tc0.1,0,0.1,0,0.2,0c0.3,0,0.6,0.2,0.8,0.4c0.1,0.1,0.1,0.1,0.1,0.2c0.2,0.4,0.2,0.7,0.2,1.1c0,0.5-0.1,1,0.7,1.6\r\n\t\t\tc0.3,0.2,0.8,0.3,1.4,0.3c1.3,0,2.9-0.6,3.7-1.1c1-0.7,1.9-1.8,2.7-2.8c0.9-1.1,1.8-2.2,2.9-3c0.2-0.1,0.4-0.2,0.6-0.2\r\n\t\t\tc0.3,0,0.6,0.1,0.8,0.4c0.4,0.5,0.7,1,1.1,1.5l0.1,0.2c0.4,0.6,0.8,1.1,1.1,1.6c0.7,0.9,1.4,1.6,2,2.2l0.4,0.4\r\n\t\t\tc0.4,0.4,0.8,0.8,1.1,1.2l0.4,0.4c1.2,1.5,2,2.6,2.2,3c0.1,0.2,0.1,0.5,0,0.8c-0.1,0.4-0.4,0.6-1,1.1l-0.1,0.1\r\n\t\t\tc-0.9,0.7-1.6,1.3-1.5,2.4c0.3,2.3,3.3,3.3,6.2,4.2h0.1c1.5,0.5,3,0.9,3.7,1.6c0.8,0.6,1.2,1.5,1.6,2.3v0.1\r\n\t\t\tc0.4,0.9,0.8,1.8,1.6,2.3c0.9,0.7,2.6,1.1,4.7,1.1c1.5,0,2.6-0.2,3.2-0.4c1.1-0.4,1.7-1.1,2.2-1.7c0.5-0.7,1-1.3,2-1.7\r\n\t\t\tc0.8-0.3,3.9-0.8,4.8-0.8c0.2,0,0.3,0,0.4,0c0.1,0,0.3,0.1,0.4,0.1c0.6,0.4,0.7,1.3,0.5,2.7c-0.1,1.2-0.2,2,0.3,2.5\r\n\t\t\tc0.3,0.3,0.7,0.4,1.1,0.4c0.1,0,0.3,0,0.4,0c1.9-0.1,1.9-1,2-2c0-0.6,0-1.2,0.4-1.8c0.2-0.3,0.6-0.9,1.4-0.9c0.1,0,0.3,0,0.6,0\r\n\t\t\ts0.5,0.1,0.8,0.1c0.4,0,0.8-0.1,1.2-0.3c1.1-0.6,1.3-1.6,1.5-2.4c0.1-0.7,0.2-1.2,0.6-1.6c0.7-0.6,1.6-0.6,2.6-0.7\r\n\t\t\tc0.9,0,1.7-0.1,2.4-0.4c1-0.5,1.5-1.1,2-1.6c0.7-0.7,1.2-1.4,3-1.6c2.1-0.4,2.3-0.4,3.4-1.3l1-0.8c0.8-0.7,1.7-1,2.7-1.3\r\n\t\t\tc1.7-0.6,3.3-1.2,3.4-4.4c0-0.4-0.1-0.8-0.2-1.3v-0.2c-0.3-1.1-0.5-2.2,0.5-2.9l0.1-0.1c0.5-0.3,1.3-0.3,2.8-0.3\r\n\t\t\tc0.3,0,0.5,0,0.7,0c0.7,0,1.1-0.1,1.4-0.1l0.6-0.1c0.6-0.1,1.2-0.2,2.1-0.6c0.3-0.2,0.4-0.6,0.5-0.9c0-0.1,0-0.1,0-0.2\r\n\t\t\tc0.1-0.4,0.4-0.7,0.8-0.8c0.1,0,0.3,0,0.6,0c0.2,0,0.3,0,0.5,0c0.3,0,0.6,0.2,0.8,0.4l0.1,0.1c0.4,0,0.7,0.1,1,0.1h0.2\r\n\t\t\tc0.2,0,0.4,0.1,0.6,0.3c0,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0c0.1-0.1,0.3-0.1,0.5-0.1c0.1,0,0.1,0,0.2,0c3,0.5,4.8,1.3,5.3,2.7\r\n\t\t\tc0.2,0.5,0.3,1,0.4,1.7c0.1,0.7,0.2,1.5,0.6,2.2l0.3,0.7c0.6,1.2,1,1.9,1.3,3.2c0.3,1.6,1.2,2.8,2.1,4c0.8,1,1.6,2.1,2.1,3.5\r\n\t\t\tc0.2,0.6,0.3,1.1,0.4,1.6v0.1c0.3,1.6,0.6,2.8,2.5,3.9c0.3,0.2,0.5,0.4,0.5,0.8c0.1,1,0.1,2.5-0.1,4.6c-0.1,1-0.2,2-0.1,2.6\r\n\t\t\tc0.1,2,0.5,4,0.9,5.9c0.3,1.3,0.6,2.7,0.8,4.3c0.2,1.2,0.2,2.4,0.2,3.6c0,2,0,4.1,0.9,6l0.2,0.4c1.7,4.6,1.4,5.4,1.3,5.7\r\n\t\t\tc0,0.1-0.1,0.2-0.2,0.3c-0.3,0.4-0.8,0.4-1.2,0.4c-0.2,0-0.5,0-0.7,0s-0.4,0-0.6,0c-0.5,0-0.6,0.2-0.7,0.3\r\n\t\t\tc-0.3,0.4,0.1,1.1,0.5,1.9c0.6,1.1,2.1,2.5,3.3,3.7c0.8,0.7,1.4,1.3,1.9,1.8c3.7,4,7.8,6.4,13,7.5h0.1l0.1-0.1\r\n\t\t\tc0.4-2.8,0.6-5.8,0.6-9.3c0-3.3,0-4.4,2.7-5.9c0.7-0.3,1.4-0.8,2.1-1.3c1.1-0.7,2.1-1.4,3-1.7c0.4-0.1,0.7-0.1,1-0.1\r\n\t\t\tc1.6,0,2.7,1.1,3.8,2.2l0,0c0.1,0.1,0.2,0.2,0.2,0.2c0.7,0.6,1.3,1.3,1.9,1.8c1.1,1.1,2.2,2.3,3.6,3.1c0.1,0,0.1,0.1,0.1,0.1\r\n\t\t\tc0.1,0,0.1,0,0.1-0.1c0.1-0.2,0.2-0.3,0.3-0.4c0.3-0.2,0.8-0.3,1.6-0.4c1.2-0.1,2.5-0.2,3.3-1.4c0.8-1.1,0.9-2.3,1.1-3.6\r\n\t\t\tc0.2-1.4,0.3-2.7,1.2-3.8c0.5-0.5,1-0.9,1.6-1.2c0.8-0.5,1.5-1,1.9-1.6c0,0,0-0.1,0.1-0.1c0.3-0.4,0.5-1.2,0.7-2\r\n\t\t\tc0.1-0.5,0.2-0.8,0.3-1.2c1-2.8,2.2-5.7,4.1-6.4c0.6-0.2,1.3-0.3,2.4-0.3c0.4,0,0.8,0,1.2,0c0.4,0,0.8,0,1.3,0\r\n\t\t\tc0.8,0,1.3-0.1,1.8-0.2c1.2-0.2,2.3-0.6,3.3-0.9c1.3-0.4,2.5-0.7,3.7-1c0.3-0.1,0.6-0.1,1-0.1c0.6,0,1.4,0.1,2.1,0.1h0.1\r\n\t\t\tc0.8,0.1,1.5,0.1,2.2,0.1c0.3,0,0.6,0,0.9,0h0.1c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.3,0.5,0.3,0.8c-0.4,2.3,0.6,4.8,1.5,7\r\n\t\t\tc0.6,1.6,1.2,3,1.3,4.4c0.1,0.6,0.1,1,0.1,1.5c0,0.8,0,1.4,0.2,2.3c0.1,0.5,0.2,1.1,0.3,1.6c0.2,1.7,0.5,2.9,1.6,3.3\r\n\t\t\tc0.4,0.2,0.7,0.2,1.1,0.2c0.3,0,0.6,0,0.9-0.1c0.4-0.1,0.7-0.1,0.9-0.1c0.4,0,0.7,0.1,1,0.3l0.1,0.1c0.4,0.4,0.6,1.3,0.9,2.3\r\n\t\t\tl0.1,0.4c0.1,0.3,0.1,0.5,0.2,0.6v0.1c0.4,1.6,0.5,1.7,1.1,2.4c0.2,0.2,0.5,0.5,0.8,0.9c0.5,0.6,0.6,0.9,0.8,1.5\r\n\t\t\tc0.1,0.3,0.2,0.7,0.5,1.4c1,1.7,4.2,4.1,6,5c1.8,0.7,4.1,0.7,6.2,0.7c2,0,3.8,0.1,5.4,0.5l1.1,0.3c2.9,0.8,4.4,1.3,6.3,4.4\r\n\t\t\tc0.3,0.6,0.4,1,0.5,1.3c0.2,0.9,0.4,1.1,2.2,1.5c0.6,0.1,1.1,0.2,1.5,0.2c1.2,0.1,1.8,0.2,2.7,1.5c0,0.1,0.1,0.1,0.1,0.2\r\n\t\t\tc0.1,0.2,0.2,0.6,0.2,1.8c0,0.1,0.1,0.2,0.2,0.2h0.3c3.5,0,7.8-1.4,10.4-3.4l0.4-0.3c1-0.7,1.7-1.1,2.2-1.1c0.1,0,0.2,0,0.3,0\r\n\t\t\tc0.5,0.1,0.8,0.7,0.7,1.2c-0.1,0.6-0.7,1.1-2.2,2.2c-0.7,0.5-1.3,1-1.6,1.4v0.1c0,0.3-0.1,0.6-0.3,0.8c-3.9,3.8-6.8,9.3-9.2,14.2\r\n\t\t\tc-1.2,2.6-2.7,5.3-4.1,7.8L350,179c-1.8,3.4-3.7,6.9-5.2,10.4c-0.6,1.6-1.3,3.3-1.8,4.9l-0.2,0.4c-1.1,2.9-2.1,5.7-3.4,8.5\r\n\t\t\tc-0.3,0.8-0.8,1.6-1.2,2.4L338,206c-0.6,1.1-1.2,2.2-1.6,3.3c-0.6,1.5-1,3-1.5,4.6s-0.9,3.2-1.6,4.7c-1.2,2.8-2.8,5.1-4.5,7.6\r\n\t\t\tc-1.1,1.6-2.3,3.3-3.4,5.2c-1.4,2.6-3.1,5.5-4.2,8.6c-0.1,0.4-0.3,0.9-0.4,1.3l-0.2,0.5c-0.5,1.6-1,3.3-2,4.6\r\n\t\t\tc-0.1,0.1,0,0.2,0,0.3c0.2,0.2,0.3,0.5,0.3,0.8c-0.2,1.8,0.8,2.8,2.2,3.8c0.9,0.7,1.9,1.4,2.4,2.6c0.8,1.8,1,3.1,0.8,4.2\r\n\t\t\tc-0.1,0.4-0.3,0.8-0.5,1.3l-0.1,0.2c-0.4,0.8-0.9,1.8-0.5,2.7c0.1,0.3,0.1,0.6,0,0.8l-0.2,0.3c-1.8,3.4-3.5,6.8-3.4,10.7\r\n\t\t\tc0,0.7,0.1,1.4,0.2,2.1c0.2,2.3,0.4,5.2-0.2,7.5c-0.1,0.6-0.4,1.2-0.6,1.7l-0.1,0.1c-0.4,0.9-0.8,1.8-0.7,2.9c0,0.5-0.2,0.9-0.7,1\r\n\t\t\tc-1,0.3-2.3,0.5-4.1,0.5c-1,0-2-0.1-2.9-0.1h-0.7c-0.4,0-0.8-0.1-1.2-0.1c-0.1,0-0.3,0-0.4,0c-2.6,0.1-5.3,0.1-7.5,0.1h-3.2\r\n\t\t\tc-1.2,0-2.4,0-3.6,0c-3.6,0-6.6,0.1-9.2,0.2h-0.6c-4.5,0.3-8.8,0.6-13.3,0.6c-2.1,0-4-0.1-5.9-0.2c-0.4,0-1.1,0-2.1,0.1l-1,0.1\r\n\t\t\tc-1.9,0.1-4.7,0.2-6.9,0.2c-1.3,0-2.2,0-2.8-0.1c-0.1,0-0.3-0.1-0.4-0.2c-1-0.6-2.3-1-3.4-1c-0.3,0-0.5,0-0.7,0\r\n\t\t\tc-1.5,0-1.7,0.3-1.9,1.3v0.1v0.2c-0.1,0.4-0.4,0.6-0.8,0.7c-0.1,0-0.1,0-0.2,0c-0.3,0-0.6-0.1-0.8-0.4c-0.3-0.4-0.6-0.8-1-1.2\r\n\t\t\tc-0.7-0.9-1.4-1.8-2.4-2.6c-0.8-0.6-1.7-1-2.4-1.4H238c-1.5-0.7-2.8-1.4-3.9-3c-0.2-0.3-0.3-0.5-0.3-0.8c-0.1-0.4-0.1-0.7-1.1-1.2\r\n\t\t\tc-0.5-0.3-1-0.4-1.6-0.4h-0.4c-0.2,0-0.5,0-0.7,0s-0.4,0-0.6-0.1c0,0-0.1,0-0.1-0.1c-0.8-0.5-1-1.1-1.2-1.8c-0.2-0.6-0.4-1.3-1-2\r\n\t\t\tc-0.4-0.4-0.9-0.6-1.4-0.9c-0.4-0.2-0.8-0.4-1.3-0.8c-0.3-0.2-0.5-0.4-0.7-0.7c-0.4-0.4-0.8-0.8-1.5-1c-0.4-0.1-0.8-0.2-1.2-0.2\r\n\t\t\tc-0.7,0-1.5,0.1-2.1,0.2h-0.1c-0.5,0.1-1.1,0.2-1.7,0.2c-0.1,0-0.3,0-0.4,0c-0.3,0-0.7,0-1,0c-0.4,0-0.8-0.1-1.2-0.1\r\n\t\t\tc-0.7,0-1.1,0.1-1.5,0.3c-0.3,0.3-0.4,0.6-0.4,1c0,0.3-0.2,0.6-0.4,0.7c-0.3,0.3-0.7,0.5-1.1,0.8c-0.9,0.6-1.9,1.2-2.3,1.9\r\n\t\t\tl-0.1,0.1c-0.4,0.5-0.7,0.9-0.9,1.4v0.1c-0.3,0.5-0.5,1-1,1.4s-0.9,0.6-1.2,0.7c0,0-0.1,0-0.1,0.1c-0.5,0.2-1,0.5-1.8,1.3\r\n\t\t\tc-0.3,0.3-0.6,0.7-1,1l-0.4,0.4c-0.5,0.6-1.1,1.2-1.5,1.7c-0.4,0.7-0.5,1.3-0.7,2c-0.2,0.8-0.3,1.6-1.1,2.4\r\n\t\t\tc-0.4,0.5-1.3,0.8-2.3,1.1l-0.5,0.2c-1.1,0.5-2.8,0.8-4.4,1c-2.6,0.4-5.2,0.8-6.7,2.3c-0.9,0.8-1.4,1.8-1.8,2.8\r\n\t\t\tc-0.4,0.8-0.8,1.8-1.5,2.4c-0.9,0.9-2.4,1.7-3.1,1.7c-0.3,0-0.7-0.2-0.9-0.5s-0.3-0.9-0.2-1.6c0-0.1,0-0.1-0.1-0.2l-0.1-0.1\r\n\t\t\tc-1.6,0.4-2.4,1.2-3.2,1.9c-0.6,0.6-1.2,1.2-2.2,1.6c-0.6,0.2-1.1,0.2-1.5,0.2c-0.2,0-0.4,0-0.7,0s-0.5,0-0.7,0\r\n\t\t\tc-1,0-1.6,0.2-2.2,0.8c-0.2,0.2-0.5,0.3-0.7,0.3s-0.3,0-0.4-0.1c-0.6-0.3-1-0.7-1.5-1.1c-0.8-0.7-1.6-1.5-3.2-1.7\r\n\t\t\tc-0.5,0-0.9-0.1-1.3-0.1c-2.4,0-4.5,0.7-6.8,2.5c-0.2,0.1-0.4,0.2-0.7,0.3l-0.4-0.9l0.3,0.9c-0.3,0.1-0.4,0.1-0.6,0.3\r\n\t\t\tc-0.1,0.2-0.2,0.5-0.1,0.9c0,0.2-0.1,0.5-0.2,0.6c-0.1,0.2-0.2,0.4-0.3,0.5c-0.1,0.3-0.4,0.5-0.7,0.6c-0.2,0-0.5,0.1-0.9,0.2\r\n\t\t\tc-0.3,0-0.6,0.1-1,0.1c-0.2,0-0.4,0-0.6,0c-0.3,0-0.5,0-0.7,0c-0.6,0-1.3,0.1-2.1,0.4c-0.2,0.2-0.4,0.4-0.6,0.7\r\n\t\t\tc-0.3,0.3-0.5,0.6-0.7,0.9C143.5,310.5,143.2,310.7,142.9,310.7z\"/>\r\n\r\n\t</g>\r\n\t<text transform=\"matrix(1 0 0 1 175.9388 203.7916)\" class=\"label-inactive\">AM</text>\r\n</g>\r\n<g id=\"PA\">\r\n\t<g>\r\n\t\t<path class=\"estado-active\" d=\"M482,312c-2,0-4.4-0.5-5.8-0.8l-1.1-0.2c-9.6-1.9-18.8-2.8-27.2-2.8c-7.2,0-14.6-0.5-21.2-0.9\r\n\t\t\tc-6.3-0.4-12.7-0.8-19.2-0.9c-2.5,0-5-0.3-7.5-0.5l-2.6-0.2c-2.2-0.2-4.3-0.2-6.4-0.2h-0.5c-1.2,0-2.4,0-3.6-0.1\r\n\t\t\tc-3.4-0.3-6.6-0.5-10.1-0.6c-1.1-0.1-2-0.3-3-0.5h-0.1c-1.3-0.3-2.7-0.6-4.3-0.6c-0.7,0-1.5,0.1-2.2,0.1c-1,0-1.9,0-2.9-0.1\r\n\t\t\tc-1,0-2,0-2.9,0c-0.8,0-1.5,0-2.3,0c-0.5,0-1.2,0.2-1.8,0.3h-0.2c-0.9,0.2-1.8,0.3-2.6,0.3c-0.8,0-1.4-0.1-1.8-0.4\r\n\t\t\tc-0.6-0.4-0.8-0.8-1.2-1.2c-0.4-0.6-0.9-1.3-2.3-1.6c-0.3,0-0.6-0.1-1-0.1c-0.2,0-0.4,0-0.6,0s-0.4,0-0.5,0\r\n\t\t\tc-0.9,0-1.4-0.2-1.9-0.9c-0.5-0.5-1-1.4-1.4-2.3c-0.4-0.8-0.8-1.5-1.3-2.2c-0.9-0.9-1.7-1.7-2.8-2.4c0,0-0.1,0-0.1-0.1\r\n\t\t\tc-0.3-0.3-0.7-0.6-1-1l-0.1-0.1c-0.9-0.9-2-2.1-3.3-2.2c-0.5,0-0.9-0.4-1-0.9c0-0.8-0.1-1.7-0.1-2.5c0-1.1-0.1-2.3-0.2-3.3\r\n\t\t\tc0-2-0.7-3.9-1.4-5.7l-0.5-1.3c-0.5-1.1-1.3-2.2-2-3.1l-0.1-0.1c-0.9-1.2-1.7-2.3-2.1-3.5c-0.3-0.8-0.3-1.7-0.4-2.7\r\n\t\t\tc-0.2-2.6-0.5-4.6-2.9-5.3c-0.3-0.1-0.5-0.3-0.6-0.5s-0.1-0.6,0-0.8V260c0-0.1,0.1-0.2,0.1-0.3c0.2-0.6,0.5-1,0.6-1.5\r\n\t\t\tc0.4-1.7-0.3-3.4-0.8-4.5c-0.6-1.3-1.6-2.1-2.5-2.8c-1.4-1.1-2.6-1.9-1.9-4.1l0,0c0,0,0,0,0-0.1c-0.1-0.3-0.1-0.6,0.1-0.9\r\n\t\t\tc0.7-1.1,1.1-2.5,1.5-3.9l0.1-0.2c0.2-0.6,0.3-1.1,0.5-1.6c1.1-2.9,2.6-5.7,4.1-8.4l0.1-0.1c1-1.9,2.3-3.7,3.4-5.2\r\n\t\t\tc1.7-2.4,3.4-4.9,4.6-7.7c0.6-1.5,1.1-3,1.6-4.8c0.4-1.5,0.9-3,1.5-4.6c0.4-1.1,0.9-2.1,1.5-3.2l0.3-0.5c0.4-0.8,0.9-1.7,1.3-2.5\r\n\t\t\tc1.5-3,2.6-6.1,3.6-8.8l0.1-0.2c0.6-1.6,1.2-3.2,1.8-4.8c1.5-3.7,3.5-7.3,5.4-10.8l0.1-0.3c1.4-2.6,2.9-5.2,4.1-7.9\r\n\t\t\tc2.6-5.3,5.7-11.2,9.9-14.9c0,0,0.1-0.1,0-0.2c0-0.3,0.1-0.7,0.4-0.9c0.2-0.2,0.5-0.4,0.7-0.5c1.4-1.1,2.7-2.1,2.2-3.2\r\n\t\t\tc-0.2-0.5-0.5-0.9-0.9-1c-0.1,0-0.2,0-0.4,0c-0.8,0-1.8,0.7-2.5,1.3l-0.4,0.3c-2.4,1.8-6.1,3.2-9.2,3.3c0,0,0,0-0.1,0\r\n\t\t\tc-0.5,0-0.9-0.4-1-0.9s-0.2-0.8-0.3-1.1c-1-1.4-1.7-1.6-3-1.7c-0.4,0-0.9-0.1-1.5-0.2c-0.5-0.1-0.9-0.2-1.2-0.3\r\n\t\t\tc-0.3-0.1-0.6-0.4-0.6-0.8c-0.1-0.4-0.1-0.8-0.5-1.5c-2-3.2-3.6-3.7-6.5-4.6l-1.1-0.3c-1.7-0.4-3.6-0.5-5.4-0.5\r\n\t\t\tc-2.1,0-4.3-0.1-6-0.7h-0.1c-1.5-0.8-4.9-3.2-5.8-4.8c0,0,0-0.1-0.1-0.1c-0.2-0.5-0.3-0.9-0.4-1.3c-0.1-0.5-0.2-1-0.9-1.7\r\n\t\t\tc-0.3-0.3-0.5-0.6-0.6-0.7l-0.2-0.2c-0.7-0.8-0.7-1-1.1-2.4c-0.1-0.2-0.1-0.5-0.2-0.8v-0.1c-0.2-0.9-0.4-2-1.1-2.7\r\n\t\t\tc-0.4-0.3-0.8-0.5-1.4-0.5c-0.3,0-0.6,0-0.9,0.1c-0.3,0-0.6,0.1-0.9,0.1c-0.4,0-0.7-0.1-1-0.2c-1-0.4-1.2-1.6-1.4-3v-0.2\r\n\t\t\tc-0.1-0.5-0.1-1-0.2-1.4c-0.2-0.8-0.2-1.5-0.2-2.2c0-0.5,0-1-0.1-1.6c-0.2-1.4-0.8-3-1.3-4.5c-1-2.4-1.9-4.9-1.4-7.2\r\n\t\t\tc0.1-0.3,0.2-0.5,0.5-0.6c0,0,0.1-0.1,0.1-0.2v-0.6V105c0-0.2,0-0.3,0.1-0.5c0,0,0-0.1,0.1-0.1c0.4-1.1,0.3-5,0.1-6\r\n\t\t\tc-0.1-0.8-0.3-1.4-0.5-1.8l-0.1-0.1c-0.1-0.3-0.3-0.6-0.4-1.2c-0.3-1-0.4-2.6-0.2-3.7c0-0.3,0.2-0.6,0.5-0.8\r\n\t\t\tc0.2-0.1,0.3-0.1,0.5-0.1c0.1,0,0.3,0,0.4,0.1l0,0c0.2,0,0.2-0.1,0.2-0.1c0-0.5,0-1,0.1-1.5v-0.7c0-0.3,0.2-0.6,0.5-0.8\r\n\t\t\tc0.7-0.4,1.7-0.7,2.7-0.9c1.1-0.3,2.2-0.6,2.9-1.1c0.6-0.5,0.7-1,0.8-1.6c0.1-0.4,0.1-0.8,0.4-1.2c1.2-1.6,2.8-1.6,4.6-1.7\r\n\t\t\tc1.2,0,2.3,0,3.3-0.5s1.4-1.1,1.6-1.6c0.2-0.4,0.4-0.7,0.8-1c0.6-0.3,1.2-0.4,2-0.4c0.6,0,1.2,0.1,1.8,0.1h0.1\r\n\t\t\tc0.6,0.1,1.2,0.1,1.8,0.1c0.5,0,0.9-0.1,1.3-0.2c1.4-0.4,1.7-0.9,2-1.6c0.2-0.3,0.4-0.7,0.6-1c1.5-1.5,2.3-1.7,4.2-2.1\r\n\t\t\tc0.7-0.1,1.4-0.2,2.2-0.2c1,0,1.9,0.1,2.9,0.1c1.2,0.1,2.2,0.2,3.2,0.2c0.3,0,0.6,0,0.9,0c1.2-0.1,2.2-0.1,3.1-0.1\r\n\t\t\tc2.5,0,4.5,0.2,6.7,0.7c1.7,0.4,3.1,0.7,4.3,0.7c1.4,0,2.4-0.3,3-0.9c0.3-0.3,1.1-1.2,0.1-3.8c-0.2-0.4-0.5-0.8-0.8-1.2\r\n\t\t\tc-0.4-0.4-0.7-0.8-1-1.5c-0.3-0.4-0.5-0.7-0.6-0.9c-0.2-0.5-0.1-1,0.3-1.3s0.8-0.7,1.2-1.2l0.3-0.4c0.3-0.4,0.6-0.8,0.7-1.1\r\n\t\t\ts0.3-0.5,0.6-0.6c0.1,0,0.2,0,0.3,0c0.2,0,0.4,0.1,0.6,0.2l0.1,0.1c0.8,0.7,1.5,1.4,2.4,1.5c0.2,0,0.4,0,0.6,0\r\n\t\t\tc1.5,0,3.3-0.9,5-1.9c1.2-0.7,2.3-1.2,3.2-1.5c2-0.6,4.2-0.9,6.1-0.9c2.1,0,3.8,0.4,4.9,1.2c0.6,0.4,1,0.9,1.3,1.6\r\n\t\t\tc0.2,0.4,0,1-0.4,1.2c-0.1,0.1-0.1,0.2-0.1,0.3c0.1,0.2,0.3,0.4,0.4,0.5c0.2,0.2,0.3,0.5,0.3,0.7c0,1.1-0.2,2.1-0.3,3.3\r\n\t\t\tc-0.2,1.5-0.3,2.9-0.3,4.2c-0.1,1.5,0,2.2,0.4,2.7c0.4,0.4,1,0.5,2.3,0.5h1.1c2.4,0.1,5,1.5,6.9,3.6c0.1,0.1,0.2,0.3,0.2,0.5\r\n\t\t\tc0,0.1,0,0.1,0.1,0.1c0.1,0.1,0.4,0.2,0.5,0.3c0.4,0.5,0.6,1,0.9,1.4c0,0.1,0.1,0.1,0.2,0.1c0.1-0.1,0.2-0.1,0.2-0.2\r\n\t\t\tc0-0.3,0.2-0.5,0.4-0.7c0.2-0.1,0.4-0.2,0.6-0.2c0.1,0,0.1,0,0.2,0h0.1c1.1,0.2,2.2,0.4,3.1,1.1c0.5,0.4,0.9,0.9,1.3,1.4\r\n\t\t\tc0.6,0.7,1.2,1.5,2.3,1.9c0.5,0.1,0.9,0.1,1.3,0.1l0.2,1v-1c0.1,0,0.3,0,0.4,0c0.5,0,0.8,0,1.2,0.3c0.7,0.5,0.9,0.8,0.9,1.7\r\n\t\t\tc0,0.4,0,0.8,0.2,1.3c0.6,1.6,1.4,2.9,2.4,4.2l0.5,0.7c1.1,1.6,1.8,2.6,3.5,2.6c0.5,0,0.9,0.4,1,0.9c0,0.5,0.1,1.2,0.2,2.2\r\n\t\t\tl0.1,1.1c0.1,1.1,0.2,2,0.2,2.4s0,0.9-0.1,1.3v0.1c-0.1,0.9-0.1,1.7,0.1,2.6c0.1,0.1,0.3,0.3,0.5,0.4c0.3,0.1,0.5,0.2,0.6,0.5\r\n\t\t\tc0,0.1,0.1,0.1,0.1,0.2l0,0c0.1,0.4,0.2,0.8,0.4,1.2c0.1,0.4,0.2,0.9,0.5,1.5c0.8,2.1,2.3,6.1,4.1,7.3c0.8,0.5,1.4,0.7,2,0.9\r\n\t\t\tl-0.1,1l0.3-1c0.8,0.2,1.5,0.4,2.2,1.4c0.9,1.3,1.1,3.2,1.2,4.9c0.1,0.9,0.2,1.8,0.3,2.5c0.9,3.8,4,5.6,6.6,6.8\r\n\t\t\tc0.4,0.2,3.9,1.8,6.1,1.9c0.3,0,0.6,0.2,0.7,0.4c0.2,0.2,0.2,0.5,0.2,0.8c-0.2,1.1-0.7,2-1.5,2.8c-0.9,0.9-1.8,1-2.6,1.1\r\n\t\t\tc-0.7,0.1-1.2,0.1-1.8,0.5c-0.9,0.5-1.9,1.3-1.5,2.3c0.4,0.9,2.4,1.7,4.5,1.7c0.6,0,1.2-0.1,1.7-0.2c2.8-0.8,3.8-2.4,5.3-4.8\r\n\t\t\tc1.1-2.1,1.4-2.4,3.4-2.5h0.4c2-0.1,2.3-0.4,2.9-1.1c0.3-0.4,0.7-0.9,1.6-1.5s2.9-0.7,3.5-0.7c0.5,0,1,0,1.4,0.1\r\n\t\t\tc1.9,0.3,2.5,0.9,2.8,2.4c0.1,0.4,0,0.7-0.1,1.1v0.1c-0.2,0.5-0.3,1.1-0.1,1.6c0.2,0.7,0.7,1.2,1.2,1.8c0.2,0.2,0.4,0.4,0.5,0.5\r\n\t\t\tc0,0,0,0.1,0.1,0.1c0.7,1.1,1,2.3,1.2,3.4c0.3,1.3,0.6,2.4,1.3,3.5c1.1,1.4,4.6,3.9,6.6,3.9c0.1,0,0.2,0,0.4,0\r\n\t\t\tc0.8-0.2,1.6-0.7,2.4-1.2l0.1-0.1c0.8-0.5,1.6-1,2.6-1.3c0.2-0.1,0.5-0.1,0.8-0.2h0.2c0.5-0.1,0.9-0.1,1.2-0.3\r\n\t\t\tc0.2-0.1,0.4-0.2,0.6-0.2c0.1,0,0.1,0,0.2,0c0.3,0.1,0.5,0.2,0.7,0.5c0.1,0.1,0.3,0.6,0.4,0.7c0.7,1.2,1.4,2.4,2.3,3.4\r\n\t\t\tc0.1,0.1,0.1,0.1,0.2,0.1h0.1c0.9-0.7,1.3-1.6,1.6-2.4c0.4-0.9,0.7-1.8,2.1-2.4c0.4-0.2,0.8-0.2,1.2-0.2c0.7-0.1,1.3-0.1,2-0.7\r\n\t\t\tc0.4-0.2,0.7-0.5,1-0.8c0.2-0.2,0.4-0.3,0.7-0.3c0.2,0,0.3,0,0.5,0.1c0.4,0.2,0.6,0.6,0.5,1s-0.1,0.8-0.2,1.1l-0.2,0.8\r\n\t\t\tc0,0.1,0.1,0.2,0.2,0.2c0.2,0.1,0.5,0.1,0.7,0.1c1.5,0,2.4-1.3,3.2-2.8c0.4-0.7,0.7-1.3,1.1-1.7c1.4-1.7,3.6-3.2,5.5-4.5l0.9-0.7\r\n\t\t\tc0.8-0.5,1.6-0.9,2.4-1.2c1.5-0.7,3-1.4,4.1-2.6c0.5-0.5,0.9-1.1,1.3-1.6l0.1-0.1c0.8-1,1.5-2,2.6-2.7l0.7-0.5\r\n\t\t\tc1.7-1.1,2.3-1.5,3.6-3.4c0.9-1.2,2.9-2.9,4.5-3.5c0.6-0.3,1.2-0.4,1.9-0.4c1,0,1.9,0.3,2.8,0.6l0.3,0.1c0.4,0.1,0.8,0.3,1.2,0.4\r\n\t\t\tc1.1,0.2,2.3,0.3,3.4,0.4h0.2c0.8,0,1.7,0.1,2.7,0.2c0.6,0.1,1.3,0.1,2,0.1c0.2,0,0.4,0,0.6,0c0.3,0,0.6,0,0.9,0\r\n\t\t\tc1,0,2.5,0.1,3.8,0.9c0.4,0.2,0.8,0.6,1.1,0.9c0.4,0.5,0.9,0.9,1.7,1.2h0.1c0.5,0.2,1,0.2,1.5,0.2h0.6c0.2,0,0.4,0,0.6,0\r\n\t\t\tc0.3,0,0.6,0,0.8,0.1h0.1c0.9,0.3,1.7,1,2.5,1.6l0.2,0.2c0.6,0.4,1.1,0.9,1.7,1.1l0.8,0.4c0.8,0.4,1.4,0.8,1.8,1.5\r\n\t\t\tc0.3,0.7,0.4,2,0.3,2.4c0,1.2-0.3,2.7-0.5,4v0.2l-0.4,1.6c0,0,0,0.2-0.1,0.2c-0.3,0.8-0.4,1.2-1.2,1.8l-0.1,0.1\r\n\t\t\tc-0.1,0.1-0.3,0.2-1.1,0.4c-0.6,0.2-1.4,0.4-1.6,0.8c-0.3,0.4-0.7,0.9-0.6,1.4c0.1,0.5,0.7,0.8,1.5,1.2c1,0.4,2,0.8,1.8,1.9\r\n\t\t\tc0,0.1-0.1,0.2-0.1,0.3c0,0-0.1,0.1-0.1,0.2l0,0c-0.4,0.6-0.5,1.3-0.6,1.9v0.1c0,0.3-0.1,0.6-0.1,0.7c0,0.1,0,0.1-0.1,0.2\r\n\t\t\tc-0.3,0.7-0.7,1.4-1.1,2l-0.1,0.1c-0.5,0.8-0.9,1.4-1.1,2c-0.4,0.9-0.6,1.8-0.7,2.5c-0.1,0.8-0.3,1.6-0.7,2.4\r\n\t\t\tc-0.2,0.4-0.5,0.7-0.9,1.1l-0.1,0.1c-0.6,0.5-1.2,1.1-1.3,2.1c-0.1,0.7,0,1.2,0.1,1.7s0.2,1,0.2,1.7c0,0.5-0.7,2.8-1.1,3.4\r\n\t\t\tc-0.3,0.6-0.9,1.1-1.5,1.5s-1.1,0.8-1.6,1.4c-0.5,0.7-0.8,1.6-1.1,2.5l-0.1,0.2c-0.3,0.9-0.6,1.7-1.1,2.5c-0.3,0.4-0.7,0.7-1.1,1\r\n\t\t\tl-0.1,0.1c-0.4,0.3-0.9,0.6-1.1,1c-0.6,0.8-0.8,1.9-1,2.9c-0.2,0.8-0.4,1.6-0.7,2.3c-0.8,1.7-2,3.1-3.1,4.5l-0.1,0.1\r\n\t\t\tc-0.7,0.8-1.3,1.7-1.9,2.5c-0.4,0.6-0.8,1.3-1.2,2l-0.2,0.4c-1.1,2.1-2.2,4.1-4.8,5c-0.3,0.1-0.7,0.2-1.2,0.2c-0.2,0-0.4,0-0.6,0\r\n\t\t\tc-0.2,0-0.3,0-0.5,0c-0.4,0-0.8,0-1.1,0.2c-1.1,0.5-1.6,1.4-2.1,2.2c-0.2,0.4-0.5,0.7-0.7,1.1c-1.1,1.6-2.7,2.6-4.3,3.6\r\n\t\t\tc-1.4,0.9-2.8,1.8-4.1,3.2c-0.4,0.4-0.8,1.1-1.1,1.7l-0.1,0.1c-0.4,0.7-0.8,1.4-1.3,1.8c-0.5,0.5-1.2,0.8-1.9,1.2\r\n\t\t\tc-1,0.5-2.1,1-2.8,2.3c0,0.1,0,0.2,0,0.2c1.3,1.5,3.5,2,5.8,2.5c1.1,0.2,2.4,0.5,3.4,1c1.2,0.6,1.9,1.2,2.1,1.6\r\n\t\t\tc0.1,0.1,0.1,0.3,0.1,0.4c0,0.4-0.3,0.8-0.6,1.3l-0.1,0.2c-0.5,0.7-1,1.4-1.2,2.4c0,0.1,0.1,0.3,0.1,0.4c0.1,0.4,0.2,1.1,0.2,1.3\r\n\t\t\tv0.1c0,0.6-0.1,1.2-0.3,1.7c-0.1,0.2-0.1,0.4-0.1,0.5s0,0.1,0,0.2c-0.6,1.8-1.3,2.4-2.2,3.2l-0.2,0.2c-0.3,0.3-0.7,0.6-1,1\r\n\t\t\tc-1.2,1.3-1.7,2.9-2.1,4.5v0.1c-0.5,1.9-0.9,3.5-2.5,4.2c-0.1,0.1-0.3,0.1-0.4,0.1c-0.3,0-0.7-0.2-0.9-0.5c0,0-0.1-0.1-0.2-0.1\r\n\t\t\th-0.1c0,0,0,0.1-0.1,0.1c-0.2,0.4-0.5,0.6-0.9,0.6c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0-0.6,0c-1.2,0-2.8,0.5-4.2,1.4\r\n\t\t\tc-0.6,0.4-2.7,1.8-2.9,3.5c-0.1,0.7,0.1,1.4,0.3,2.1c0.3,1.1,0.6,2.3,0,3.5c-0.3,0.6-0.9,1.1-1.5,1.6s-1.2,0.9-1.6,1.6\r\n\t\t\tc-1.6,2.9-0.2,5.2,1.2,7.6c0.8,1.4,2.4,4.8,1,8.1c-0.6,1.5-1.6,2.8-2.6,4.1c-1.1,1.5-2.3,3-3,4.9c-0.3,1-0.5,1.8-0.7,2.5\r\n\t\t\tc-0.5,2.2-0.9,2.7-3.5,3.8c-3,1.2-3.7,3-4.5,5.1c-0.4,0.9-0.8,1.9-1.4,3c-0.2,0.4-0.4,0.7-0.7,1l-0.2,0.3\r\n\t\t\tc-0.4,0.6-0.9,1.1-1.2,2.2c-0.3,1.4-0.4,3-0.5,4.7c0,0.3,0,0.6-0.1,0.9c0,0.3-0.2,0.6-0.5,0.8C484.4,311.7,483.4,312,482,312z\"/>\r\n\r\n\t</g>\r\n\t<g>\r\n\t\t<path class=\"estado-active\" d=\"M485.8,147.3c-0.6,0-1.2-0.3-1.7-0.5l-0.2-0.1c-0.5-0.2-0.9-0.4-1.2-0.5c-2.8-0.8-3-1-4.2-3.5l-0.1-0.1\r\n\t\t\tc-0.1-0.2-0.1-0.3-0.2-0.4c-0.1-0.3-0.3-0.5-0.4-0.6s-0.3-0.2-0.4-0.3c-0.2-0.3-0.8-0.5-1.5-0.6l-0.3-0.1\r\n\t\t\tc-0.8-0.2-1.1-0.3-1.3-0.4c-0.2-0.1-0.3-0.3-0.4-0.6c-0.1-0.5,0-0.9,0.2-1.2c0.4-0.6,1.4-1,2.7-1.2c0.1,0,0.2,0,0.2-0.1\r\n\t\t\tc0.2-0.1,0.5-0.1,1.1-0.1c0.8,0,1.8,0,2.2-0.5c0.6-0.7,0.6-1.1,0.5-1.3c-0.2-0.6-0.9-0.9-1.7-1.2c-0.2-0.1-0.4-0.1-0.5-0.2\r\n\t\t\tc-0.3-0.1-0.5-0.2-0.7-0.4l0,0l0,0c-0.2-0.2-0.3-0.5-0.3-0.7c0-0.3,0.2-0.6,0.5-0.8c0.1-0.1,0.3-0.2,0.4-0.2\r\n\t\t\tc0.6-0.4,1.1-0.7,1.1-1.2c0.1-0.4-0.1-0.9-0.6-1.4c-0.7-0.9-1.9-1.7-3.9-2.4c-0.4-0.1-0.6-0.5-0.7-0.8c0-0.4,0.1-0.7,0.5-1\r\n\t\t\tc0.1-0.1,0.3-0.2,0.4-0.2c0.1-0.1,0.4-0.2,0.6-0.3c0.1,0,0.3,0,0.5,0c0.3,0,0.6,0,1,0h0.2c0.4,0,0.8,0.1,1.3,0.1\r\n\t\t\tc1,0,1.6-0.2,2.1-0.5c0.8-0.6,0.8-1.8,0.8-3.1c0-1.9,0.1-3.6,2.3-4c0.2,0,0.3,0,0.5,0c0.7,0,1.2,0.3,1.8,0.6l0.2,0.1\r\n\t\t\tc0.8,0.4,1.6,0.8,2.4,0.8c0.1,0,0.2,0,0.2,0c1.2-0.1,2.2-0.8,3.2-1.4c0.8-0.6,1.6-1.2,2.6-1.4c0.4-0.1,0.9-0.1,1.4-0.1\r\n\t\t\tc0.3,0,0.7,0,1,0h0.1c0.4,0,0.8,0,1.2,0c0.5,0,1,0,1.4-0.1s0.8-0.2,1.2-0.4c0.6-0.2,1.1-0.4,1.5-0.4h0.1c0.7,0.1,1.2,0.3,1.7,0.6\r\n\t\t\tc0.5,0.2,1,0.5,1.6,0.6c0.2,0,0.4,0,0.7,0c0.6,0,1.2-0.1,1.9-0.3c0.6-0.1,1.2-0.3,1.8-0.3c0.1,0,0.3,0,0.4,0\r\n\t\t\tc1.2,0.1,2.3,0.8,3.4,1.4c0.5,0.3,0.9,0.5,1.2,0.7c0.7,0.4,1.2,0.6,1.7,0.9l0.1,0.1c0.8,0.4,1.5,0.7,2.3,1.4\r\n\t\t\tc0.9,0.8,1.2,1.2,1.2,1.6v0.1c0,0.5-0.2,0.9-1,2c-0.1,0.2-0.3,0.4-0.4,0.7l-0.3,0.5l-0.9,1.6c-1.8,3-3.3,5.6-6.6,7.7l-0.5,0.3\r\n\t\t\tc-1,0.6-2.3,1.4-2.8,2.6c-0.1,0.4,0.1,0.8,0.3,1.1l0,0c0.2,0.2,0.3,0.5,0.2,0.8c0,0.2,0,0.4-0.1,0.6v0.2c-0.1,0.7-0.2,1.2-0.4,1.5\r\n\t\t\tc-0.2,0.2-0.5,0.4-0.8,0.4l0,0c-0.3,0-0.6-0.1-0.8-0.4c-0.1-0.1-0.2-0.3-0.4-0.7c-0.2-0.3-0.5-1-0.8-1c-0.1,0-0.1,0-0.2,0\r\n\t\t\tc-0.2-0.1-0.3-0.1-0.5-0.1s-0.4,0.1-0.5,0.1c-0.6,0.3-0.9,1.2-1.1,2.1c-0.3,1.2-0.5,1.6-0.7,1.8c-0.5,0.4-0.9,0.5-1.4,0.5\r\n\t\t\tc-0.4,0-0.9-0.1-1.4-0.3c-0.4-0.1-1-0.3-1.5-0.3c-0.4,0-0.8,0.1-1.2,0.4c-0.9,0.6-1.1,1.2-1.1,1.7s-0.4,0.9-0.9,0.9\r\n\t\t\tc-0.1,0-0.3,0-0.5,0c-0.9,0-1.9-0.2-2.8-0.6c-0.6-0.2-1.1-0.5-1.8-0.5h-0.4c-0.4,0-0.6,0-0.8,0c-0.2,0-0.3,0-0.7,0.2\r\n\t\t\tc-0.2,0.1-0.4,0.3-0.9,0.5c-0.2,0.2-0.4,0.4-0.6,0.6c-0.1,0.4-0.4,0.7-0.8,0.8C486,147.3,485.9,147.3,485.8,147.3z\"/>\r\n\r\n\t</g>\r\n\t<text transform=\"matrix(1 0 0 1 412.9206 216.8)\" class=\"label-active\">PA</text>\r\n</g>\r\n<g id=\"AP\">\r\n\t<g>\r\n\t\t<path class=\"estado-inactive\" d=\"M449.3,135.7c-1.3,0-4.5-1.2-6-1.9c-3.7-1.7-5.7-3.7-6.4-6.5c-0.1-0.7-0.2-1.4-0.3-2.2v-0.2\r\n\t\t\tc-0.1-1.7-0.3-3.7-1.3-5.2c-0.8-1.1-1.6-1.3-2.5-1.5c-0.6-0.1-1.2-0.3-1.9-0.8c-1.6-1-2.9-4.3-4.1-7.3c-0.2-0.4-0.3-0.8-0.4-1.2\r\n\t\t\tc-0.1-0.5-0.3-1-0.4-1.3s-0.4-0.5-0.9-0.9c-0.2-0.2-0.4-0.4-0.4-0.7c-0.1-0.6,0-1.4,0-2c0-0.5,0.1-0.9,0.1-1.3\r\n\t\t\tc0-0.5-0.1-2-0.3-3.5v-0.3c-0.1-1-0.2-1.9-0.2-2.3c0-0.1,0-0.1,0-0.2s0-0.1,0-0.2l0,0c-0.1-0.1-0.2-0.2-0.3-0.4\r\n\t\t\tc0-0.1-0.1-0.1-0.2-0.1c-0.3,0-0.5,0-0.7,0c-1.7,0-2.4-1.1-3.3-2.5l-0.5-0.7c-0.8-1.2-1.6-2.5-2.3-4.1c-0.2-0.4-0.2-0.8-0.1-1.1\r\n\t\t\tc0-0.7,0-1.3-1-2c-0.5-0.3-1-0.3-1.6-0.4h-0.2c-0.1,0-0.2,0-0.4,0c-0.3,0-0.6,0-0.8-0.1c-0.1,0-0.1,0-0.2-0.1\r\n\t\t\tc-0.8-0.3-1.4-1-2-1.7l-0.1-0.1c-0.4-0.6-0.8-1-1.4-1.4c-0.9-0.7-2-0.9-3.1-1.1c-0.7-0.1-1.5-0.3-2.4-0.7\r\n\t\t\tc-0.2-0.1-0.3-0.2-0.4-0.3c-2-2.4-4.9-4.1-7.6-4.2h-1.1c-0.3,0-0.5,0-0.7,0c-0.1,0-0.1,0-0.2,0s-0.2,0-0.3,0h-0.1\r\n\t\t\tc-0.3-0.1-0.6-0.3-0.8-0.6c-0.1-0.2-0.2-0.6-0.1-2.2c0-1.3,0.2-2.8,0.3-4.2c0.1-0.8,0.2-1.5,0.2-2.3c0-0.3,0.2-0.6,0.4-0.7\r\n\t\t\tc0.2-0.1,0.4-0.2,0.6-0.2c0.1,0,0.2,0,0.2,0c0.2,0,0.4,0.1,0.6,0.1c0.6,0.1,1.2,0.2,1.8,0.5c0.5,0.2,0.9,0.5,1.5,0.9\r\n\t\t\tc0.7,0.5,1.4,1,2.5,1.3c0.5,0.1,1.2,0.1,1.8,0.1c1.2,0,2.3-0.2,3.3-0.5s1.8-1.1,2.5-1.7c0.8-0.7,1.4-1.2,2.1-1.4\r\n\t\t\tc0.2-0.1,0.4-0.1,0.7-0.1c0.7,0,1.4,0.3,2.3,0.7c0.7,0.3,1.7,0.8,2.7,0.8c0.2,0,0.3,0,0.4,0c0.5,0,1.2-0.1,1.8-0.2\r\n\t\t\tc0.6-0.1,1-0.1,1.3-0.1c0.1,0,0.2,0,0.3,0c0.3,0.1,0.6,0.3,0.8,0.6c0,0.1,0.1,0.2,0.1,0.6s0.1,1,0.8,1.4c0,0,0.3,0.1,0.9,0.1\r\n\t\t\tc2.7,0,7.7-2,8.3-2.4c0,0,0,0,0.1,0c1.5-0.8,1.6-1.7,1.8-2.8v-0.2c0.1-0.6,0.2-1.2,0.6-2c0.4-0.9,1-2,1.7-3l0.2-0.4\r\n\t\t\tc0.5-0.8,0.9-1.4,1.3-2.1c0.6-1.1,1.1-2.2,1.7-3.3c1.9-3.8,3.8-7.7,6.5-11.4c0.6-0.8,1.3-1.4,2.2-2.1c0.8-0.7,1.6-1.3,2.3-2.2\r\n\t\t\tc0.4-0.6,0.8-1.2,1.1-1.9l0.1-0.2c0.5-0.9,0.9-1.7,1.6-2.6c0.6-1,1.4-2,2.1-3l0.3-0.4c0.9-1.3,1.7-2.3,2.3-3.3\r\n\t\t\tc0.2-0.3,0.5-0.5,0.8-0.5c0.2,0,0.4,0,0.5,0.1c0.3,0.2,0.7,0.4,1.1,0.5c0.7,0.3,1.3,0.5,1.8,1.1c0.3,0.4,0.5,0.8,0.7,1.1v0.1\r\n\t\t\tc0.3,0.8,0.6,1.2,1.6,1.3c0.5,0.1,0.9,0.5,0.9,1c0,0.6,0,1.2,0,1.7c-0.1,1.5-0.2,2.9,0.7,4c0.4,0.4,0.8,0.5,1,0.6\r\n\t\t\tc0.5,0.1,0.9,0.5,0.9,1v0.6c-0.1,1.5-0.2,3-0.4,4.4v0.1c-0.3,2.3-0.5,4.6-0.4,7c0,0.1,0.1,0.2,0.1,0.2c0.2,0,0.4,0.2,0.5,0.3\r\n\t\t\tc2.6,1.2,2.6,2.9,2.6,4.6c0,1.1,0,2.4,0.7,3.4c0,0,0,0.1,0.1,0.1c0.4,0.7,0.9,1.1,1.6,1.5c0.8,0.5,1.5,1,1.8,2.2\r\n\t\t\tc0.2,0.7,0.1,1.6-0.1,2.6c-0.1,0.9-0.3,1.7-0.1,2.5c0.3,1,0.6,1.1,1.1,1.4c0.3,0.1,0.7,0.3,1.2,0.8c0.2,0.2,0.4,0.5,0.6,0.7\r\n\t\t\tl0.1,0.2c0.3,0.4,0.5,0.7,0.8,0.9c0.3,0.3,0.7,0.5,1.1,0.7c0.6,0.4,1,0.6,1.5,1.4c0.2,0.3,0.3,0.6,0.5,1l0.1,0.2\r\n\t\t\tc0.3,0.7,0.5,1.4,1,1.8s1,0.6,1.5,0.6c0.4,0,0.7-0.1,1.1-0.2c0.5-0.2,1-0.3,1.7-0.3c1.4,0,2.7,0.9,3.7,2.5c1.8,3,2.3,7.9,1.1,10.3\r\n\t\t\tc-0.9,1.8-3.1,2.9-5.3,3.9c-1.1,0.5-2.3,1.1-3.3,1.7c-2.4,1.7-6.6,5.3-7.3,8.1c-0.1,0.4-0.4,0.6-0.7,0.7c-1.1,0.7-2.6,2.6-4.4,5.6\r\n\t\t\tc-0.3,0.7-0.5,1.6-0.7,2.4v0.1c-0.3,1.2-0.6,2.5-1.5,3.3c-0.6,0.6-1.6,1-2.6,1.4c-1.2,0.5-2.3,1-3,1.6c0,0-0.1,0-0.1,0.1\r\n\t\t\tc-2.4,1.8-4,3.3-5.3,5c-0.2,0.2-0.4,0.4-0.6,0.4c-0.4,0.1-0.8,1.6-1.4,3.6c-1.5,5.3-2.6,8.5-4.2,9.1h-0.1\r\n\t\t\tC449.6,135.7,449.4,135.7,449.3,135.7z\"/>\r\n\r\n\t</g>\r\n\t<text transform=\"matrix(1 0 0 1 436.9357 86.7184)\" class=\"label-inactive\">AP</text>\r\n</g>\r\n<g id=\"MA\">\r\n\t<g>\r\n\t\t<path class=\"estado-inactive\" d=\"M571.4,319.6c-0.1,0-0.3,0-0.4-0.1c-0.6-0.2-1.1-0.6-1.6-0.9s-0.9-0.6-1.5-0.8c-0.2,0-0.5-0.1-0.8-0.1\r\n\t\t\ts-0.5,0-0.7,0c-0.3,0-0.5,0-0.7,0c-0.6,0-1.2-0.1-1.8-0.6c-1-0.8-1.5-2.1-1.9-3.5c-0.5-1.5-1-3-2.1-4c-0.2-0.2-0.3-0.4-0.3-0.7\r\n\t\t\tc0-0.8-0.2-1.5-0.4-2.2v-0.1c-0.2-0.7-0.5-1.5-0.5-2.4c0-0.1-0.1-0.2-0.2-0.2c-2.7,0-3.1-0.8-3.4-2.9V301c-0.2-1-0.3-2.1-1.1-3.2\r\n\t\t\tc-0.6-0.9-1.8-1.3-2.8-1.6l-0.5-0.2c-0.3-0.1-0.5-0.2-0.6-0.2c-0.3-0.1-0.5-0.4-0.6-0.6s0-0.6,0.1-0.9c0-0.1,0.2-0.2,0.6-0.6\r\n\t\t\tc0.3-0.3,0.7-0.5,1-0.9c0.7-1.1,1.2-2.8,1.4-4.5c0.1-0.4,0-0.8,0-1.1c-0.1-1-0.1-1.3,0.1-1.6c0.1-0.1,0.1-0.2,0.2-0.3\r\n\t\t\tc0.6-0.5,3.3-1.7,4-1.8c0.2,0,0.4,0,0.5,0c0.3,0,0.6,0.2,0.8,0.4c0.1,0.2,0.3,0.4,0.5,0.5c0.1,0.1,0.1,0.1,0.2,0.2\r\n\t\t\tc0,0.1,0.2,0.3,0.3,0.4c0.4,0.6,0.8,1.2,1.4,1.2l0,0c0.4,0,0.8-0.2,1.2-0.7c0.8-0.9,0-3.6-1.7-7.6c-0.2-0.5-0.4-1-0.5-1.2\r\n\t\t\tc-0.6-1.9-1.3-3-2.3-3.5c-0.3-0.1-0.7-0.2-1-0.2c-1.1,0-2.4,0.6-3.8,1.3l-0.3,0.1c-0.5,0.2-1,0.5-1.6,0.7\r\n\t\t\tc-0.4,0.2-0.7,0.3-1.1,0.3c-1.6,0-2.5-1.7-3.6-4.1c-0.7-1.4-1.4-2.9-2.3-3.8c-0.5-0.5-0.8-0.7-1.2-1c-0.6-0.5-1.1-0.9-1.6-1.9\r\n\t\t\tc-0.2-0.4-0.3-0.7-0.4-1.1l-0.1-0.2c-0.2-0.6-0.4-1.2-0.8-1.8c-0.6-1-1.7-1.8-2.8-2.6c-0.2-0.2-0.4-0.4-0.4-0.7\r\n\t\t\tc0-0.3,0.1-0.6,0.3-0.8c3.1-2.9,3.1-6.5,3.1-10.9v-1c0-1.8,0.1-3.6,0.3-5.7c0.3-5,0.7-10.7-1.1-15c-1-2.4-2.4-3.5-4.8-3.9\r\n\t\t\tc-0.6-0.1-1-0.1-1.3-0.1c0,0-1,0-1.1,0c-0.8,0-1.5-0.1-2.3-0.5c-0.5-0.3-0.9-0.6-1.1-0.8c-0.5-0.4-0.9-0.7-2.1-1\r\n\t\t\tc-0.1,0-0.3,0-0.4,0c-0.5,0-1,0.1-1.4,0.2c-0.5,0.1-0.8,0.2-1.1,0.2c0,0,0,0-0.1,0h-0.1c-0.4,0-1-0.2-1.7-0.3l-1.4-0.3\r\n\t\t\tc-0.3-0.1-0.6-0.3-0.7-0.6c-0.1-0.3-0.1-0.7,0.1-0.9c0.2-0.3,0.3-0.5,0.5-0.8c0.3-0.6,0.7-1.2,1.1-1.7c1.3-1.4,2.7-2.3,4-3.1\r\n\t\t\tc1.6-1,3.2-2,4.4-3.7c0.3-0.4,0.5-0.8,0.8-1.1c0.6-0.9,1-1.7,1.9-2.1c0.1,0,0.1,0,0.2-0.1c0.2-0.1,0.5-0.1,0.8-0.1h0.6\r\n\t\t\tc0.2,0,0.3,0,0.5,0c0.4,0,0.9,0,1.3-0.2c2.7-0.9,3.8-3.1,5-5.2c0.4-0.8,0.9-1.6,1.4-2.4c0.5-0.8,1.1-1.5,1.7-2.3l0.3-0.3\r\n\t\t\tc1.2-1.4,2.3-2.9,3.1-4.5c0.4-0.8,0.6-1.6,0.8-2.4c0.2-1,0.5-2,1-2.7c0.2-0.3,0.5-0.6,1.1-1c0.4-0.3,0.9-0.6,1.2-1\r\n\t\t\tc0.6-0.9,1-1.9,1.2-2.8l0.1-0.2c0.3-0.8,0.5-1.6,1-2.2c0.4-0.6,1-1,1.5-1.3c0.7-0.5,1.3-1,1.6-1.5c0,0,0-0.1,0.1-0.1\r\n\t\t\tc0.3-0.5,1.1-3,1.1-3.5c0.1-0.7,0-1.3-0.2-1.8v-0.2c-0.1-0.4-0.2-0.9-0.1-1.5c0.1-0.8,0.6-1.3,1.2-1.8c0.5-0.4,0.9-0.8,1.1-1.3\r\n\t\t\tc0.4-0.8,0.6-1.6,0.7-2.5c0.2-0.9,0.3-1.7,0.7-2.4c0.3-0.7,0.7-1.3,1.1-2c0.4-0.7,0.9-1.4,1.2-2.2c0.1-0.3,0.1-0.7,0.2-1\r\n\t\t\tc0.1-0.7,0.2-1.2,0.6-1.9c0.2-0.4,0.5-0.6,0.8-0.9c0.5-0.4,1-0.8,0.4-1.9c-0.1-0.1-0.1-0.1-0.1-0.1h-0.1c-0.1,0.3-0.3,0.6-0.6,0.7\r\n\t\t\tc-0.1,0-0.2,0.1-0.3,0.1c-0.2,0-0.4-0.1-0.6-0.2c-0.4-0.3-0.9-0.5-1.2-0.7c-0.2-0.1-0.4-0.2-0.6-0.3c-0.3-0.1-0.5-0.4-0.6-0.7\r\n\t\t\ts0-0.6,0.3-0.9c0-0.1,0.1-0.1,0.1-0.1c0.1-0.1,0.3-0.3,1.4-0.6c0.5-0.2,1-0.3,1.3-0.6c0.9-0.7,1-1.2,1.3-2.1l0.5-1.8\r\n\t\t\tc0.3-1.5,0.6-3.2,0.6-4.5c0-0.5,0.4-1,0.9-1.1c0.2,0,0.5,0,0.7,0c1.6,0,3.5,0.4,4.9,0.8l0.3,0.1c0.6,0.1,1.2,0.3,2,0.4\r\n\t\t\tc2.6,0.5,6.1,1.1,7.9,2.6c0.2,0.2,0.4,0.5,0.6,0.8c0.4,0.7,0.8,1.4,1.7,1.8c0.6,0.3,1.5,0.4,2.4,0.5h0.1c0.5,0.1,1,0.1,1.5,0.3\r\n\t\t\tc2.2,0.5,2.8,1.3,3.7,2.5c0.4,0.6,0.9,1.2,1.6,1.8c0.5,0.5,1,0.8,1.3,1c0.7,0.4,1.1,0.7,1.5,1.6c0.3,0.6,0.4,1.1,0.5,1.6\r\n\t\t\tc0.2,0.8,0.3,1.5,1.1,2.5c0.1,0.2,0.3,0.3,0.4,0.5l0.3,0.4c1.5,1.9,3.2,4,1.9,6.4c-0.6,1.1-1.6,1.7-2.7,2.3\r\n\t\t\tc-1.3,0.8-2.7,1.5-2.9,3.2c-0.2,1.1,0,2.1,0.2,3.2c0.2,1.2,0.5,2.5,0.1,3.8c0,0.1,0,0.2,0.1,0.2h0.1h0.1c0.5-0.3,1-0.7,1.6-1\r\n\t\t\tc0.9-0.5,1.8-1.1,2.7-1.8c0.6-0.4,1.2-1.2,1.7-1.9c0.8-1.1,1.4-1.9,2-2.2c0.4-0.2,0.8-0.3,1.2-0.3c0.6,0,1.1,0.2,1.8,0.5\r\n\t\t\tc0.5,0.2,1.1,0.5,1.8,0.5c0.4,0,0.8-0.1,1.2-0.3c0.6-0.3,0.9-1,1.2-1.7c0.4-0.9,0.7-1.4,1.1-1.7l0.1-0.1c0.6-0.3,1.4-0.4,2.3-0.5\r\n\t\t\tc0.3,0,0.6-0.1,0.9-0.1c1.3-0.2,2.6-0.6,4-0.9h0.1c1.1-0.3,2.2-0.6,3.4-0.8c1-0.2,1.9-0.4,2.7-0.4c1.6,0,2.6,0.6,4.4,2\r\n\t\t\tc2.7,2.4,7,3,10.2,3.5c0.6,0.1,1.2,0.1,2,0.1s1.6,0,2.6-0.1c0.9,0,1.8-0.1,2.8-0.1c2.3,0,3.7,0.4,4.6,1.2c0.2,0.2,0.4,0.5,0.6,0.9\r\n\t\t\tc0.2,0.5,0,1.1-0.5,1.3c0,0-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0.1,0.2c0.5,0.2,0.8,0.7,0.7,1.1c-0.5,2.4-2.2,3.6-4.1,5\r\n\t\t\tc-0.5,0.4-1.1,0.8-1.6,1.2c-0.7,0.6-1.5,1.4-2.2,2.1c-1.1,1.1-2.2,2.1-3.3,2.9c-0.7,0.4-1.4,0.7-2.2,1c-0.7,0.3-1.4,0.5-2.1,1\r\n\t\t\tc-2.3,1.8-3.6,4.8-4.9,7.7c-0.5,1.1-1,2.3-1.5,3.3c-0.2,0.4-0.5,0.8-0.7,1.2l-0.1,0.2c-0.9,1.5-1.6,2.7-1.1,4.9\r\n\t\t\tc0.3,0.9,0.6,1.7,0.9,2.4c0.6,1.4,1.1,2.7,1,4.8c0,0.8,0,1.6,0,2.4v0.1c0,2.7,0.1,5.5-1.2,7.7c-0.3,0.6-0.6,1.1-1,1.5\r\n\t\t\tc-0.7,1-1.4,2-1.5,3.6l-0.1,1.6c-0.3,3.2-0.5,5.9,0.7,9c0.2,0.5,0,1-0.5,1.2c-0.1,0.1-0.1,0.3,0,0.3c0.6,0.5,1.4,0.8,2.1,1\r\n\t\t\tc0.8,0.3,1.5,0.6,2,1c0.3,0.2,0.5,0.4,0.6,0.5c0.2,0.2,0.3,0.5,0.3,0.7v0.1c0,0.4-0.1,0.7-0.1,1.2c0.3,4.1,0.1,4.7-3.1,6.1\r\n\t\t\tl-0.4,0.2c-2.6,1-4.8,1.9-7.1,1.9c-1.3,0-2.7-0.3-4.1-0.9c-1.3-0.5-3.5-1.4-5.7-1.4c-1.4,0-2.6,0.3-3.6,1\r\n\t\t\tc-1.6,1.3-4.5,4.3-6.3,6.3c-2.1,2.4-5,4.7-8.1,6.5c-1.9,1.1-4.2,1.7-6.7,2.2c-1.5,0.3-2.9,0.7-4.3,1.1c-4.6,1.6-5.1,6.3-5.7,10.9\r\n\t\t\tc-0.2,1.5-0.4,2.9-0.6,4.1c-0.7,2.3-1.5,3.9-2.6,5.4c-1.8,2.4-2.1,3.8-2.4,6.1c-0.1,0.5-0.2,1-0.2,1.5v0.1c-0.2,0.5-0.4,1-0.6,1.4\r\n\t\t\tl-0.1,0.2c-0.4,0.8-0.9,1.8-0.9,2.6c0,0.1,0,0.1,0,0.2c-0.1,0.6,0.1,1.1,0.3,1.7l0.1,0.3c0.1,0.2,0.2,0.4,0.2,0.7\r\n\t\t\tc0.1,0.5,0,1.1,0,1.6s-0.1,1.1,0,1.6c0.1,1.1,0.5,2.1,0.9,3.1l0.1,0.2c0.3,0.8,0.6,1.6,0.7,2.2c0.1,1.2-0.2,2.2-0.5,3.2v0.2\r\n\t\t\tc-0.3,0.9-0.6,1.9-0.6,2.9c0,0.8,0.2,1.6,0.3,2.3l0.1,0.7c0.1,0.4-0.1,0.7-0.3,1C571.8,319.5,571.6,319.6,571.4,319.6z\"/>\r\n\t</g>\r\n\t<text transform=\"matrix(1 0 0 1 570.1869 214.7987)\" class=\"label-inactive\">MA</text>\r\n</g>\r\n<g id=\"TO\">\r\n\t<g>\r\n\t\t<path class=\"estado-inactive\" d=\"M537.3,384.7c-0.7,0-1.5-0.3-2.8-1c-0.4-0.2-0.8-0.4-1.1-0.5c-3.3-1.5-6.5-1.7-9.5-2\r\n\t\t\tc-1.4-0.1-2.7-0.2-4.1-0.4c-0.3,0-0.5-0.2-0.7-0.4c-0.2-0.2-0.2-0.5-0.2-0.8c0-0.1,0-0.3,0-0.4c0-1.5-1.3-3.4-3.6-5.5\r\n\t\t\tc-1.2-1-2.1-1.5-2.7-1.5c-0.5,0-0.9,0.3-1.6,1c-0.3,0.3-0.7,0.7-1.1,1c-0.2,0.1-0.4,0.2-0.5,0.2s-0.2,0-0.3,0\r\n\t\t\tc-0.3-0.1-0.5-0.3-0.6-0.6c-0.4-0.9-1.1-2-2.4-2h-0.2c0,0-0.1,0-0.1,0.1s0,0.1,0,0.2l0.1,0.1c0.2,0.2,0.2,0.5,0.2,0.8\r\n\t\t\ts-0.2,0.5-0.5,0.7c-0.1,0.1-0.3,0.2-0.5,0.3c-0.2,0.1-0.4,0.2-0.7,0.4c-0.4,0.3-0.7,0.5-1,0.6l-0.2,0.1c-1.1,0.6-1.2,0.7-1.7,2.8\r\n\t\t\tc-0.2,0.9-0.4,1.4-0.5,1.6l0,0c0,0.2-0.1,0.4-0.3,0.6c-0.2,0.2-0.4,0.3-0.7,0.3c-0.1,0-0.2,0-0.3,0c-0.4-0.1-0.9-0.5-1.5-1\r\n\t\t\tl-0.2-0.2c-0.5-0.4-1-0.8-1.6-1.2c-1.7-1.2-3.9-2.2-5.4-2.6h-0.1c-0.5-0.2-1.1-0.3-1.9-0.3c-0.6,0-1.2,0-1.7,0.1h-0.2\r\n\t\t\tc-0.5,0-1,0.1-1.5,0.1c-1,0-1.6-0.1-2-0.5c-1.3-1.1-0.2-3.5,1-6.1c1.1-2.3,2.2-4.6,1.6-6.1c0-0.1-0.1-0.1-0.1-0.1h-0.2l-1.3,1.1\r\n\t\t\tc-1,0.8-2,1.6-3.3,2.6c-0.2,0.1-0.4,0.4-0.6,0.6c-0.1,0.1-0.3,0.2-0.4,0.3l-0.1,0.1c0,0.2-0.1,0.4-0.2,0.5c-0.4,0.5-0.7,1-0.9,1.5\r\n\t\t\tc-0.3,0.5-0.6,1-0.9,1.4c-0.2,0.3-0.5,0.4-0.8,0.4c-0.1,0-0.1,0-0.2,0c-0.4-0.1-0.7-0.4-0.8-0.8c-0.6-3.3-0.7-6.6-0.4-11.2\r\n\t\t\tc0.3-4.2,0.3-8.4,0-12.8c-0.2-2.2,0.2-3.3,0.7-4.9c0.2-0.5,0.3-1,0.5-1.7c0.5-1.8,0.7-3.9,0.8-5.9v-0.1c0.2-2.4,0.4-4.8,1.2-7\r\n\t\t\tc0.7-2.2,1.8-4,2.7-5.7c1.4-2.5,2.8-5,3.3-8.2v-0.2c0-0.3,0.2-0.6,0.5-0.7c0.1,0,0.1-0.1,0.1-0.1c0-0.1,0.1-0.3,0.2-0.4\r\n\t\t\ts0.2-0.2,0.2-0.3c0.1-0.1,0-0.2,0-0.2c-0.2-0.2-0.3-0.5-0.3-0.8v-0.1c0.1-1.6,0.2-3.2,0.5-4.4c0.3-1,0.7-1.5,1.1-2.1l0.1-0.1\r\n\t\t\tc0.3-0.4,0.6-0.7,0.8-1.1c0.7-1.1,1.1-2.1,1.4-3c0.8-2.1,1.5-3.7,4.3-4.9c3.1-1.3,3.3-2.2,3.7-4.1c0.1-0.6,0.3-1.4,0.7-2.5\r\n\t\t\tc0.6-1.7,1.7-3.1,2.8-4.6l0.2-0.3c1-1.3,1.9-2.6,2.6-4.1c1.1-2.5,0.8-5.6-0.9-8.4c-1.4-2.4-2.7-4.6-1.2-7.2\r\n\t\t\tc0.3-0.6,0.9-1.1,1.5-1.5c0.7-0.5,1.3-1,1.6-1.7c0.6-1.3,0.3-2.6,0-3.8v-0.2c-0.2-0.7-0.3-1.3-0.2-1.8c0.1-1,1.1-2.3,2.7-3.3\r\n\t\t\tc1.1-0.7,2.4-1.2,3.5-1.3h0.1c0.2,0,0.4,0.1,0.5,0.2c0,0,0,0,0.1,0.1c0.1,0,0.3,0.1,0.5,0.1c0.1,0,0.3,0,0.4,0c0,0,0,0,0.1,0\r\n\t\t\ts0.2,0,0.4,0.1h0.1c0.1-0.1,0.3-0.2,0.5-0.2c2.6-0.4,3.3-2.3,4-4.9v-0.1c0.4-1.5,0.8-3.1,2-4.3c0.4-0.5,0.8-0.8,1.2-1.2\r\n\t\t\tc0.9-0.8,1.7-1.5,2.3-3.5c0-0.1,0.1-0.3,0.1-0.5l0.1-0.3c0.1-0.5,0.3-1.1,0.3-1.7c0-0.6-0.1-1.1-0.2-1.5c-0.1-0.2-0.1-0.4,0-0.6\r\n\t\t\tc0.2-0.7,0.7-1.3,1-1.8c0.6-0.8,1-1.4,0.8-2.1c-0.1-0.5-0.5-1.1-2.4-2.1c-1-0.5-2.3-0.7-3.5-1c-1.6-0.4-3.3-0.7-4.6-1.6\r\n\t\t\tc-0.3-0.2-0.4-0.5-0.4-0.8s0.1-0.6,0.3-0.8c0.5-0.5,1.2-0.8,1.8-1.1c0.3-0.1,0.6-0.3,1-0.5c0.1-0.1,0.3-0.1,0.5-0.1h0.1\r\n\t\t\tc0.1,0,0.2,0,0.3,0s0.1,0,0.1,0c0.6,0.1,1.7,0.3,2.4,0.4c0.8,0.2,1.6,0.3,2.2,0.4c0.4,0,0.9-0.1,1.3-0.2c0.5-0.1,1-0.2,1.4-0.2\r\n\t\t\tc0.1,0,0.2,0,0.3,0c1,0.2,1.4,0.4,1.9,0.9c0.3,0.2,0.6,0.5,1.2,0.8c0.9,0.5,1.7,0.6,2.4,0.6c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.6,0\r\n\t\t\tc0.5,0,0.9,0,1.3,0.1c2.3,0.3,3.6,1.3,4.5,3.6c1.8,4.2,1.4,9.6,1,14.8v0.3c-0.1,1.9-0.2,3.8-0.2,5.5v1c0,5,0,8.6-4.1,11.6\r\n\t\t\tc-0.1,0-0.1,0.1-0.1,0.2s0,0.1,0.1,0.2c0.2,0.1,0.9,0.7,0.9,0.7c1.2,0.8,2.4,1.7,3,2.7c0.4,0.6,0.6,1.2,0.7,1.7\r\n\t\t\tc0.1,0.4,0.3,0.8,0.5,1.3c0.6,1.1,1.1,1.5,1.7,2l0.2,0.1c0.3,0.2,0.6,0.5,1,0.9c0.9,0.8,1.6,2.2,2.2,3.6c0.9,2,2.1,4.3,3.9,4.3\r\n\t\t\tc0.4,0,0.9-0.1,1.4-0.3c0.6-0.2,1.1-0.5,1.6-0.8l0.4-0.2c1.3-0.6,2.5-1.2,3.5-1.2c0.3,0,0.6,0.1,0.9,0.2c0.8,0.4,1.5,1.4,2,3.2\r\n\t\t\tc0,0.1,0.5,1.2,0.5,1.2c2.2,5.6,2,6.5,2,6.8c0,0.2-0.1,0.3-0.2,0.4c0,0.1-0.1,0.1-0.2,0.2c-0.2,0.1-0.4,0.2-0.6,0.2h-0.1\r\n\t\t\tc-0.3,0-0.6-0.2-0.7-0.5l-0.3-0.4c-0.2-0.2-0.3-0.4-0.5-0.7c-0.3-0.2-0.5-0.4-0.6-0.7v-0.1c-0.1-0.3-0.1-0.4-0.6-0.4\r\n\t\t\tc-0.2,0-0.5,0-0.7,0c-0.8,0-4.1,1.5-4.5,2c-0.5,0.6-0.5,1.3-0.4,2c0,0.3,0.1,0.7,0,1.1c-0.2,1.6-0.7,3.2-1.3,4.3\r\n\t\t\tc-0.3,0.4-0.6,0.6-0.9,0.8c-0.8,0.6-1.3,1.1-0.7,2.3c0.3,0.4,0.9,0.6,1.7,0.9c1.1,0.4,2.1,0.8,2.6,1.5c0.7,1,0.9,2.1,1,3\r\n\t\t\tc0.2,1.6,0.4,2.9,2.8,3.2c0.4,0.1,0.8,0.4,0.9,0.8c0.1,0.6,0.2,1.1,0.4,1.6c0.3,0.9,0.5,1.8,0.4,2.7c0,0,0,0.1,0.1,0.2\r\n\t\t\tc1.4,0.9,1.9,2.6,2.4,4.2v0.1c0.5,1.5,0.9,2.8,2,3.6c0.8,0.6,1.5,0.7,2.1,0.7c0.2,0,0.5,0,0.7,0h0.4c0.2,0,0.5,0,0.6,0\r\n\t\t\ts0.2,0,0.3,0s0.1,0,0.2,0.1c0.5,0.2,0.9,0.5,1.3,0.8c0.5,0.3,1.1,0.7,1.9,1c0.4,0.2,0.7,0.6,0.7,1c0,0.9,0.1,1.6,0.3,2.2\r\n\t\t\tc0.4,1.5,0.3,2.3-1.4,3.9c-0.8,0.7-1.7,1-2.6,1.2c-0.9,0.3-1.8,0.5-2.5,1.1c-0.6,0.5-0.9,1.4-1.2,2.1l-0.1,0.2\r\n\t\t\tc-0.2,0.4-0.3,0.9-0.6,1.2c-0.1,0.1-0.3,0.2-0.4,0.3c-0.6,0.2-0.6,0.3-0.6,0.3c0,0.1,0,0.1-0.1,0.2c-0.4,0.9-0.5,1.7-0.6,2.4\r\n\t\t\tc-0.1,0.9-0.2,1.7-0.8,2.6c-0.3,0.3-0.6,0.7-1.3,1.2c-1.8,1.5-3.1,2.7-2.5,4.2c0.2,0.4,0.7,1,2.5,1c0.6,0,1.1-0.1,1.6-0.1h0.2\r\n\t\t\tc0.4,0,0.7-0.1,1-0.1c1.6,0,3,0.4,4,0.8c0.3,0.1,0.6,0.4,0.6,0.7c0.1,0.3,0,0.7-0.3,0.9c-0.7,0.7-1.2,1.5-1.1,2.9\r\n\t\t\tc0.1,0.6,0.4,1,0.7,1.3c0.1,0.1,0.2,0.2,0.2,0.2c0.2,0.2,0.3,0.4,0.3,0.7c0,0.3-0.1,0.7-0.7,1.7c-0.5,0.8-1,1.4-1.6,2\r\n\t\t\tc-1.3,1.5-2.3,2.6-1.5,5.4c0.1,0.5,0.4,0.9,0.7,1.3c0.4,0.5,0.7,1,0.8,1.8c0.1,0.3,0,0.7-0.1,1.1c-0.1,0.3-0.2,0.8-0.1,1\r\n\t\t\tc0,0.1,0,0.2,0,0.2c0,1.4,0.3,2.2,0.7,3.1c0.2,0.5,0.4,1,0.6,1.6c0.1,0.3,0.1,0.5,0.2,0.7c0.1,0.3,0,0.6-0.2,0.8l0,0\r\n\t\t\tc0,0.5-0.4,0.9-0.9,1c-0.1,0-0.3,0-0.5,0c-0.1,0-0.3,0-0.4,0h-0.1c-0.4-0.1-0.9-0.3-1.3-0.5c-0.4-0.2-0.9-0.4-1.4-0.5\r\n\t\t\tc-0.4-0.1-0.8-0.1-1.1-0.1c-1.2,0-1.9,0.4-3.4,1.3l-0.3,0.2c-0.6,0.3-1.3,0.7-1.9,1l-0.4,0.2c-2,1.1-4.2,2.4-6.2,2.8\r\n\t\t\tc-0.2,0-0.4,0.1-0.7,0.1c-0.5,0-1.1-0.1-1.8-0.1h-0.2c-0.9-0.1-1.8-0.1-2.6-0.1c-1.4,0-2.2,0.2-2.6,0.7c-0.6,0.6-0.6,1.3-0.5,2.3\r\n\t\t\ts0.1,2-0.7,2.7C538.5,384.4,537.9,384.7,537.3,384.7z\"/>\r\n\r\n\t</g>\r\n\t<text transform=\"matrix(1 0 0 1 511.4688 319.8647)\" class=\"label-inactive\">TO</text>\r\n</g>\r\n<g id=\"PI\">\r\n\t<g>\r\n\t\t<path class=\"estado-active\" d=\"M592.2,331.2c-1.7,0-3.2-0.6-5-1.4c-0.6-0.3-1.3-0.5-2-0.8c-2.1-0.7-2.3-1.6-2-3.4c0.2-1.1,0.3-2.4-0.8-3.7\r\n\t\t\tc-0.9-1-2.9-1.6-5.2-1.6c-1,0-2.1,0.1-3,0.3c-0.1,0-0.2,0-0.2,0c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.4-0.5-0.4-0.8\r\n\t\t\tc0-0.7-0.2-1.5-0.3-2.1v-0.3c-0.1-0.7-0.2-1.3-0.2-2c0-0.9,0.2-1.8,0.5-2.6l0.1-0.2c0.3-1.1,0.6-2.1,0.5-3.5\r\n\t\t\tc-0.2-0.9-0.5-1.7-0.8-2.6c-0.4-1-0.8-2-0.9-3.1c-0.1-0.4,0-0.8,0-1.2v-0.3c0.1-0.5,0.1-1.1,0-1.7c-0.1-0.3-0.2-0.7-0.3-1\r\n\t\t\tc-0.2-0.5-0.4-1-0.3-1.6c0-0.9,0.4-1.7,0.8-2.5v-0.1c0.3-0.6,0.5-1.1,0.7-1.7c0.1-0.3,0.3-1.5,0.3-1.5c0.4-2.3,0.6-3.6,2.4-5.9\r\n\t\t\tc1.2-1.6,2-3.3,2.7-5.5c0.2-1.1,0.4-2.4,0.6-3.6l0.1-0.5c0.5-4.5,1.1-9.1,5.4-10.5c1.3-0.4,2.6-0.8,4-1.1l0.3-0.1\r\n\t\t\tc2.4-0.6,4.8-1.1,6.7-2.3c3.1-1.8,6-4.2,8.2-6.6c1.7-2,4.6-4.9,6.2-6.3c0,0,0.1,0,0.1-0.1c0.9-0.6,1.9-0.9,3.2-0.9\r\n\t\t\tc2,0,4,0.7,5.6,1.4c1.5,0.6,2.9,0.9,4.2,0.9c2.5,0,4.7-0.9,7.2-1.9l0.5-0.2c3.5-1.4,3.7-2.3,3.4-6.5c0-0.4,0-0.7,0-0.9v-0.1\r\n\t\t\tc0.1-0.8,0.1-0.9-1-1.8c-0.6-0.5-1.3-0.8-2.1-1.1h-0.1c-0.3-0.1-0.5-0.4-0.6-0.7v-0.1c-1.8-3.6-1.6-6.7-1.3-10.3l0.1-1.6\r\n\t\t\tc0.1-1.5,0.7-2.4,1.4-3.3c0.4-0.5,0.7-1.1,1-1.6c1.4-2.3,1.3-5.3,1.3-7.9v-0.4c0-0.7,0-1.5,0-2.2c0.1-2.1-0.4-3.4-1-4.9l-0.1-0.3\r\n\t\t\tc-0.2-0.6-0.5-1.3-0.7-2.1c-0.5-2,0.2-3.1,1.1-4.6c0.3-0.4,0.5-0.9,0.8-1.3c0.5-1,1-2.1,1.5-3.3c1.2-2.8,2.5-5.9,4.7-7.6l0.1-0.1\r\n\t\t\tc0.7-0.4,1.4-0.6,2-0.9l0.2-0.1c0.7-0.3,1.4-0.5,2.1-1c1.2-0.8,2.3-2,3.3-3l0.5-0.4c0.6-0.6,1.2-1.2,1.8-1.7\r\n\t\t\tc0.6-0.4,1.1-0.8,1.6-1.2c2-1.4,3.8-2.7,4.3-5.5c0.1-0.5,0.5-0.8,1-0.8h0.1c2.2,0.2,8.1,1.4,9.2,3.7c0.6,1.2,0,2.9-0.7,5\r\n\t\t\tc-0.6,1.8-1.3,3.6-1,5.4c0.2,1.4,0.3,1.5,1,2.1l0.1,0.1c0.2,0.2,0.5,0.4,0.7,0.6c1.2,1.2,1.3,1.5,1.4,2.7c0,0.4,0.1,0.8,0.2,1.4\r\n\t\t\tc0.4,1.7,1.2,2.8,2.1,4c0.1,0.2,0.2,0.3,0.3,0.4c0.2,0.2,0.3,0.4,0.5,0.7c1.2,1.5,1.1,2,0.9,3.6c-0.1,0.3-0.1,0.7-0.2,1.1\r\n\t\t\tc-0.1,1.4,0,1.9,0.3,2.9c0.1,0.2,0.1,0.5,0.2,0.8l0.1,0.4c0.3,1.1,0.1,2-0.1,3v0.1c-0.1,0.8-0.3,1.5-0.2,2.5\r\n\t\t\tc0.1,1.1,0.6,2.2,1.2,3.4c0.6,1.2,1.1,2.4,1.3,3.8c0.2,2.2,0.2,4.7,0,6.9c0,0.7-0.1,1.5-0.2,2.3c-0.3,3.2-0.7,7,1,9.2\r\n\t\t\tc0.4,0.5,0.7,0.7,1,0.9c0.5,0.2,0.8,0.4,1.1,1.1c0,0.1,0,0.1,0.1,0.2c0.1,0.6,0.1,1.3,0,2.1c0,0.2-0.1,0.3-0.1,0.4\r\n\t\t\tc0,0.1-0.1,0.1,0,0.2l0.1,0.1c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.2,0.3,0.2,0.4c0.3,0.8,0.3,1.5,0.4,2.3c0.2,1.8,0.5,3.1,2.2,3.9\r\n\t\t\tc0.6,0.2,1.2,0.3,1.7,0.4c1.6,0.2,2.1,0.5,2.2,2.1c0.1,1.2-0.7,3-1.7,5l-0.1,0.2c-0.3,0.7-0.7,1.4-0.9,1.9\r\n\t\t\tc-0.6,1.5-1.2,2.7-2.1,4.1c0,0.1-0.1,0.1-0.2,0.2l-0.2,0.2c-0.1,0.1-0.1,0.1-0.2,0.2c0,0-0.1,0.1-0.1,0.2s0,0.2,0,0.3v0.1\r\n\t\t\tc0,0,0,0.1,0.1,0.1c1.1,0.5,1.3,2.2,1.4,3.9v0.2c0.1,0.9,0.1,1.8,0.4,2.5c1.4,4.6-1.1,7.7-5.5,11.2c-0.7,0.5-1.4,1.1-2,1.6\r\n\t\t\tl-0.1,0.1c-0.9,0.8-1.8,1.5-2.8,2.1c-0.5,0.2-0.9,0.4-1.4,0.5c-1.1,0.4-2.2,0.8-2.8,1.6c-0.3,0.5-0.4,1-0.5,1.4s-0.1,0.6-0.3,1.1\r\n\t\t\tc-0.5,1.2-2.8,3.7-4.5,4.7c-0.1,0.1-0.3,0.1-0.5,0.1c-0.3,0-0.5-0.1-0.7-0.3l-0.1-0.1c0-0.1-0.1-0.1-0.2-0.2h-0.1h-0.1\r\n\t\t\tc-0.2,0.1-0.4,0.2-0.6,0.2c-0.1,0-0.2,0-0.4-0.1h-0.2l-0.1,0.1c0,0,0,0.1,0,0.2c0.2,0.4,0.7,0.9,1.5,0.9c0.4,0,0.7,0.2,0.9,0.6\r\n\t\t\tc0.4,0.8,0.2,1.4,0.1,1.7c-1.1,2.4-6.5,3.3-8.5,3.3c-0.2,0-0.4,0-0.6,0l-1-0.1c-0.6-0.1-1-0.1-1.5-0.1c-0.7,0-1.5,0.1-2.8,0.7\r\n\t\t\tc-0.4,0.2-0.8,0.4-1.1,0.6l-0.5,0.3c-0.9,0.5-1.8,1.1-3,1.4l-0.7,0.2c-1.1,0.3-2.4,0.6-3.4,0.6c-0.3,0-0.6,0-0.8-0.1\r\n\t\t\tc-0.9-0.3-1.4-0.9-1.9-1.4c-0.5-0.6-1-1.1-1.7-1.4c-0.5-0.2-1.1-0.3-1.7-0.3c-0.8,0-1.5,0.2-2.3,0.3c-0.7,0.2-1.4,0.3-2.1,0.3\r\n\t\t\tc-0.2,0-0.4,0-0.6,0c-1.1-0.2-1.5-0.8-2-1.5c-0.4-0.5-0.7-1.1-1.4-1.5h-0.1c0,0-0.1,0-0.1,0.1c-0.3,0.4-0.6,0.9-0.9,1.4\r\n\t\t\tc-0.4,0.8-0.8,1.5-1.5,2.2c-0.3,0.3-0.9,0.7-1.9,1.1l-0.1,0.1c-1.2,0.5-2.3,1.1-2.5,1.8c-0.5,1.6,0.7,2.9,2.1,4.2\r\n\t\t\tc0.8,0.8,1.3,1.3,1.5,1.9s0,1.7-1.5,4.8c-0.4,0.8-0.7,1.4-0.8,1.8c-0.8,2.3-1.5,3.8-3.5,5.3s-3.9,2.4-5.1,2.4\r\n\t\t\tc-0.5,0-1-0.1-1.5-0.3l-0.2-0.1c-0.6-0.2-1.1-0.3-1.8-0.3c-0.1,0-0.3,0-0.4,0c-1.1,0.1-1.5,0.6-2,1.1c-0.2,0.2-0.4,0.5-0.8,0.7\r\n\t\t\tc-1.5,1.2-3.2,2.4-5,3.2C594.1,331,593.2,331.2,592.2,331.2z\"/>\r\n\r\n\t</g>\r\n\t<text transform=\"matrix(1 0 0 1 626.2828 273.8358)\" class=\"label-active\">PI</text>\r\n</g>\r\n<g id=\"CE\">\r\n\t<g>\r\n\t\t<path class=\"estado-inactive\" d=\"M711.5,271.7c-0.4,0-0.7-0.2-0.9-0.6c-0.4-0.9-0.8-1.8-1.4-2.2c0,0-0.1,0-0.1-0.1c-0.6-0.5-1.3-0.6-1.8-0.6\r\n\t\t\tc-0.8-0.1-1.4-0.2-2.2-1.2c-0.3-0.4-0.5-0.7-0.7-1l-0.3-0.4c-1.8-2.5-2.5-3.6-6.7-4.1c-1.4-0.3-2.5-0.4-3.6-0.4\r\n\t\t\tc-0.9,0-1.8,0.1-2.9,0.2c-0.7,0.1-1.7,0.4-2.5,0.7h-0.1c-1.1,0.3-2.3,0.7-3.2,0.7c-1.3-0.1-2.2-0.5-3-0.8\r\n\t\t\tc-0.6-0.3-1.1-0.5-1.5-0.5c-0.3,0-0.6-0.2-0.7-0.5c-0.2-0.3-0.2-0.6,0-0.9c0.2-0.4,0.4-0.8,0.6-1.3c0.2-0.5,0.4-1,0.7-1.6l0.3-0.6\r\n\t\t\tc0.8-1.7,1.8-3.6,1.6-5c-0.1-2.2-1.3-2.3-2.5-2.5c-0.5,0-1.1-0.1-1.7-0.3c-1.6-0.7-1.7-2-1.9-3.5c-0.1-0.9-0.2-1.8-0.6-2.7\r\n\t\t\tc-0.1-0.1-0.1-0.3-0.1-0.4v-0.5c0-0.8,0.1-1.5-0.1-2.3c-0.4-1-0.9-1.2-1.3-1.4c-0.3-0.2-0.6-0.3-0.9-0.7c-1.6-2.1-1.2-5.8-0.9-8.8\r\n\t\t\tv-0.1c0.1-0.9,0.2-1.7,0.2-2.4c0.2-2.2,0.2-4.7,0-6.9c-0.2-1.5-0.8-2.8-1.3-3.9l-0.1-0.3c-0.5-1-0.9-2-1-3s0.1-1.8,0.3-2.5\r\n\t\t\tc0.2-1,0.4-2,0.1-3.1c-0.1-0.5-0.2-0.9-0.3-1.2c-0.3-1.1-0.4-1.5-0.3-2.8c0-0.3,0.1-0.6,0.1-0.9v-0.2c0.3-1.5,0.4-2.2-1-3.9\r\n\t\t\tc-0.3-0.4-0.6-0.8-0.9-1.1l-0.1-0.1c-0.9-1.1-1.6-2.1-2-3.7c-0.1-0.5-0.2-0.9-0.2-1.2V191c-0.2-1.2-0.3-1.7-1.6-3\r\n\t\t\tc-0.3-0.2-0.5-0.5-0.7-0.6l-0.1-0.1c-0.2-0.1-0.4-0.3-0.4-0.4c-0.1-0.1-0.2-0.2-0.2-0.4c-0.1-0.2-0.1-0.4-0.2-0.9l-0.1-0.5\r\n\t\t\tc-0.3-1.4,0.3-3.1,1-5c0.6-1.7,1.3-3.6,0.8-5.1c-0.2-0.4,0-0.9,0.3-1.1c0,0,0.1,0,0.1-0.1l0.3-0.3c1.2-1,1.9-1.5,3-1.5\r\n\t\t\tc0.6,0,1.2,0.2,2.3,0.6c0.4,0.2,0.7,0.3,1,0.5c0.4,0.2,0.9,0.5,1.5,0.5l0,0c0.4,0,0.8,0.2,1,0.6c0.3,0.8,0.9,1.4,1.5,1.7h0.2\r\n\t\t\tc0.1,0,0.1-0.1,0.1-0.2c0.1-0.5,0-1-0.1-1.6c-0.2-1.3-0.4-2.5,0.5-3.1c0.3-0.2,0.7-0.3,1.3-0.3c0.4,0,0.9,0.1,1.4,0.1h0.2\r\n\t\t\tc0.4,0,0.9,0.1,1.2,0.1c0.2,0,0.4,0,0.6-0.1c0.7-0.1,1.1-0.2,1.7-0.4c0.6-0.2,1.2-0.4,2-0.4c0.6,0,1.2,0.1,1.9,0.4\r\n\t\t\tc1.3,0.4,2.7,0.9,4.5,1.5c0.9,0.3,1.9,0.7,2.8,1c2.8,1,5.3,2.7,7.6,4.3c1.7,1.2,3.6,2.5,5.6,3.5c6.2,2.8,10.5,5.2,15.1,10.1\r\n\t\t\tc1.8,1.8,3.6,3.1,5.6,4.5l0.7,0.6c2,1.7,2.6,3,3.7,5.1l0.4,0.8c1.1,2.1,3.2,2.8,5.2,3.6c1.6,0.6,3.2,1.2,4.5,2.4\r\n\t\t\tc0.4,0.4,0.9,0.8,1.4,1.1c0.3,0.2,0.5,0.6,0.4,1s-0.4,0.7-0.8,0.8c-0.2,0-0.5,0.1-0.8,0.1c-3.6,0.5-4.4,1.8-5.7,3.9\r\n\t\t\tc-0.4,0.6-0.8,1.3-1.3,2c-0.7,0.9-1.9,2.4-2.3,4.1c-0.1,0.5-0.1,1-0.1,1.5c0,0.9-0.1,1.5-0.7,2.4c-0.4,0.7-1,1.3-1.6,1.9\r\n\t\t\tc-0.7,0.7-1.5,1.4-1.9,2.4c-0.3,0.6-0.4,1.2-0.6,1.7c-0.3,0.9-0.5,1.6-1.3,2.7c-0.4,0.6-0.9,1.2-1.5,1.9l-0.3,0.3\r\n\t\t\tc-0.6,0.7-1.2,1.5-1.8,2.3c-0.8,1.2-1.7,1.7-2.8,2.3c-0.5,0.3-1.1,0.6-1.8,1c-0.1,0.1-0.1,0.2-0.1,0.2c0.1,0.3,0.1,0.5,0,0.8\r\n\t\t\tc-0.5,1.2-0.3,2.9-0.2,3.8v0.3c0.1,1.2,0.1,1.5,0,1.8c0,0.1-0.1,0.2-0.1,0.3c-0.2,0.3-0.8,0.7-1.8,1.4l-0.2,0.2\r\n\t\t\tc-1.5,1-2.9,1.9-2.7,2.8c0,0.1,0.1,0.4,0.5,0.6c0.4,0.2,0.6,0.7,0.5,1.1c-0.3,1.5,1.4,3.1,2.8,4.3l0.2,0.2c1.2,1.1,2,2,2.3,2.8\r\n\t\t\tc0.5,1.7-0.1,2.4-1.4,3.4c-0.7,0.6-1.4,1.2-2,2c-0.1,0.3-0.4,0.6-0.8,0.7c-0.7,0.1-1.6,0.3-2.5,0.9c-0.8,0.6-1.1,1.6-1.4,2.4l0,0\r\n\t\t\tc0,0.1,0,0.1-0.1,0.2C712.2,271.5,711.9,271.7,711.5,271.7L711.5,271.7z\"/>\r\n\r\n\t</g>\r\n\t<text transform=\"matrix(1 0 0 1 689.1791 223.8043)\" class=\"label-inactive\">CE</text>\r\n</g>\r\n<g id=\"RN\">\r\n\t<g>\r\n\t\t<path class=\"estado-inactive\" d=\"M758.1,253.4c-0.1,0-0.1,0-0.2,0c-0.4-0.1-0.8-0.5-0.8-0.9c-0.1-1.3-0.3-2.4-2-3.2c-0.4-0.2-1-0.2-1.5-0.2\r\n\t\t\tc-2,0-4,1.2-4.9,1.8c-0.2,0.1-0.4,0.2-0.6,0.2c-0.3,0-0.6-0.1-0.8-0.3c-0.9-1-2.2-1.7-3-2h-0.1c-0.7-0.3-1.2-0.4-1.6-0.5h-0.1\r\n\t\t\tc0,0-0.1,0-0.2,0c-0.3-0.1-0.6-0.3-0.7-0.7c0-0.1-0.1-0.3-0.1-0.4c0-0.2,0-0.3,0.1-0.4c0.1-0.2,0.2-0.4,0.3-0.7l0.1-0.2\r\n\t\t\tc0.1-0.2,0.2-0.4,0.2-0.6c0-0.1,0.1-0.1,0.1-0.2c0.4-0.7,1.1-1.2,1.9-1.7l0.1-0.1c1-0.7,2.1-1.5,2.4-2.7c0.2-1-0.8-3.5-1.4-3.8\r\n\t\t\tc0,0-0.1,0-0.1-0.1c-0.5-0.4-1.3-0.5-2.2-0.5c-2.9,0-6.7,1.8-7.8,2.8c-0.5,0.5-1.1,1.2-1.6,2l-0.1,0.2c-0.8,1.2-1.5,2.2-2.3,2.6\r\n\t\t\tc-0.5,0.3-1.2,0.4-1.9,0.4s-1.4-0.1-2.2-0.3h-0.2c-0.2-0.1-0.4-0.1-0.6-0.1c-0.2,0-0.4,0-0.7,0c0,0,0,0-0.1,0\r\n\t\t\tc-0.2,0-0.5-0.1-0.7-0.3s-0.3-0.4-0.3-0.7c0-0.2,0-0.3-0.1-0.3s-0.1,0-0.2-0.1c-0.1-0.1-0.2-0.2-0.4-0.4l-0.2-0.2\r\n\t\t\tc-0.3-0.3-0.7-0.6-1-0.9c-0.2-0.2-0.4-0.5-0.4-0.8s0.2-0.6,0.4-0.8c0.7-0.5,1.1-0.9,1.6-1.6c0.5-0.7,1-1.3,1.5-1.9l0.3-0.4\r\n\t\t\tc0.6-0.7,1.2-1.5,1.8-2.2c0.9-1.1,1.1-1.9,1.3-2.8l0.1-0.3c0.1-0.4,0.3-0.9,0.5-1.4c0.4-1,1.1-1.6,1.8-2.3\r\n\t\t\tc0.6-0.6,1.3-1.2,1.6-1.9c0-0.1,0.1-0.1,0.1-0.1c0.6-0.8,0.7-1.6,0.7-2.5v-0.2c0-0.4,0-0.8,0.1-1.3c0.3-1.2,1-2.5,2.2-3.9\r\n\t\t\tc0.3-0.5,0.7-1,1-1.5l0.4-0.6c1.3-2.1,2.1-3.3,5.5-3.7c0.7-0.1,1.4-0.2,2-0.4c0.1,0,0.2,0,0.3,0c0.3,0,0.5,0.1,0.7,0.3l0.1,0.1\r\n\t\t\tc0.6-0.3,1.1-0.4,1.5-0.4c1.1,0,2,0.8,3.2,1.9c0.8,0.7,1.4,1.4,2.2,1.7s2,0.4,3.2,0.4h0.3c0.5,0,0.9,0,1.1,0c0.1,0,0.1,0,0.2,0\r\n\t\t\tc1.1,0.3,2.2,0.4,3.4,0.4c0.6,0,1.2,0,2-0.1c0.6,0,1.2-0.1,1.8-0.1c1.1,0,2.2,0.1,3.4,0.1h0.2c1.1,0.1,2.1,0.1,3.3,0.1\r\n\t\t\tc0.7,0,1.3,0,1.9-0.1l0.6-0.1c0.5-0.1,1.3-0.2,1.9-0.2c0.6,0,1.2,0.1,1.6,0.2c0.5,0.2,1,0.7,1.8,1.5c0.1,0.2,0.6,0.7,0.9,0.9\r\n\t\t\tc0.5,0.4,1,0.7,1.5,0.9l0.2,0.1c0.5,0.3,1,0.5,1.3,0.7l0.1,0.1c1.1,1.2,1,2.6,0.9,4.2v0.1c-0.1,1.1-0.1,2.3,0.2,3.4\r\n\t\t\tc0.3,1.3,1,2.1,1.6,2.7c0.4,0.4,0.9,0.9,1.2,1.5c0.2,0.5,0.2,1.2,0.1,2.4c-0.1,0.6-0.1,1.2-0.1,1.6c0,0.1,0,0.1,0,0.2v3.6v0.1\r\n\t\t\tc0.3,0.7,1,1,1.8,1.3c0.6,0.2,1.2,0.5,1.7,1c0.3,0.3,0.5,0.7,0.6,1.1c0.1,0.5-0.3,1.1-0.8,1.2c0,0-0.1,0-0.1,0.1\r\n\t\t\tc-0.2,0.2-0.5,0.5-1.1,0.5c-0.3,0-0.6-0.1-1-0.2c-0.4-0.1-0.7-0.2-1.2-0.3c-0.3,0-0.6,0-0.9,0c-0.4,0-0.7,0-1.1,0h-0.1\r\n\t\t\tc-0.3,0-0.7,0-1,0c-0.6,0-1.5,0-2.3-0.3c-0.7-0.2-1.2-0.5-1.6-0.7c-0.6-0.3-0.9-0.4-1.3-0.4c-0.4,0-0.8,0.1-1.4,0.3\r\n\t\t\tc-0.4,0.1-0.7,0.3-1.1,0.4c-0.7,0.3-1.4,0.6-2.3,0.7c-0.1,0-0.1,0-0.2,0c-0.2,0-0.5-0.1-0.7-0.2c0,0,0,0-0.1-0.1l0,0h-0.1\r\n\t\t\tc-0.4,0.2-0.9,0.3-1.5,0.3c-1.6,0-3.9-0.6-5.1-0.9l-0.6-0.1c-0.3-0.1-0.7-0.3-1.1-0.4l0.3-1l-0.4,0.9c-0.8-0.4-1.8-0.8-2.5-0.8\r\n\t\t\tc-0.3,0-0.5,0.1-0.7,0.2c-0.4,0.4-0.6,0.9-0.6,1.6c0,0.6,0.2,1.2,0.5,1.8c0.1,0.2,0.2,0.5,0.1,0.8c-0.1,0.3-0.3,0.5-0.5,0.6\r\n\t\t\tc-0.3,0.2-0.6,0.4-0.9,0.6c0,0,0,0.1,0,0.2c0,0,0,0.1,0.1,0.1c0.2,0.3,0.2,0.7-0.1,1.1c-0.5,0.7-0.6,1.5-0.8,2.2\r\n\t\t\tc-0.2,0.9-0.3,1.5-0.6,2.1C758.8,253.2,758.4,253.4,758.1,253.4z\"/>\r\n\r\n\t</g>\r\n\t<text transform=\"matrix(1 0 0 1 792.7628 233.8106)\" class=\"label-inactive\">RN</text>\r\n</g>\r\n<g id=\"PB\">\r\n\t<g>\r\n\t\t<path class=\"estado-inactive\" d=\"M751,280.6c-0.3,0-0.5-0.1-0.8-0.2l-0.1-0.1l0,0l0,0c-0.5-0.2-0.7-0.6-0.7-1.1c0-0.2,0.1-0.5,0.3-0.8\r\n\t\t\tc0.2-0.5,0.4-1,0.4-1.5c0.2-1.1,0-2.5-2.7-3.4c-0.3-0.1-0.6-0.4-0.7-0.7c-0.1-0.3,0-0.7,0.3-0.9c0.4-0.5,0.9-1,1-1.5\r\n\t\t\tc0.2-0.9-0.2-1.6-0.7-2.4s-0.6-1.1-0.6-1.2c-0.2-0.4,0-1,0.4-1.2c0.3-0.2,0.8-0.3,1.8-0.4h0.1c1.2-0.1,1.8-0.3,1.9-0.7\r\n\t\t\tc0.2-0.7-0.4-1.2-1.4-1.8l-0.1-0.1c-0.6-0.4-1-0.6-1.1-0.9c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.1-0.2-0.1\r\n\t\t\tc-0.7-0.2-1.4-0.3-2-0.3c-1.9,0-3.2,0.8-4.6,1.8c-0.5,0.3-1,0.7-1.5,1c-1.3,0.8-2.8,1.1-4.4,1.4l-0.3-1l0.2,1\r\n\t\t\tc-2.1,0.4-4.1,0.8-5.7,2.3c-0.3,0.3-0.4,0.7-0.5,1v0.1c-0.1,0.4-0.1,0.5-0.1,0.5c-0.1,0.2-0.2,0.4-0.4,0.5c-0.5,0.3-1.1,0.5-2,0.5\r\n\t\t\tc-1.2,0-2.5-0.3-3.4-0.4c-0.1,0-0.3-0.1-0.3-0.1c-1.5-0.2-2.4-0.4-3.2-0.9c-0.4-0.2-0.6-0.7-0.5-1.1c0-0.2-0.1-0.2-0.1-0.2\r\n\t\t\tc-0.3-0.2-0.5-0.5-0.5-0.8s0.1-0.6,0.3-0.8l0.2-0.2c0.1-0.1,0.2-0.2,0.3-0.3c1.2-1,2.2-1.8,1.5-3.9c-0.4-1-1.4-2-2.6-3.1\r\n\t\t\tc-1.8-1.6-3.6-3.3-2.3-4.9c0,0,0.1-0.1,0-0.2c0-0.1-0.1-0.1-0.2-0.1c0,0,0,0-0.1,0c-0.4-0.1-0.6-0.3-0.8-0.6\r\n\t\t\tc-0.1-0.4,0-0.8,0.3-1.1c0.5-0.4,1.2-0.9,1.7-1.2c1.2-0.8,2-1.4,2.2-1.9s0.1-1.4,0-2.4c-0.2-2-0.4-4.3,1.5-4.9c0.1,0,0.2,0,0.3,0\r\n\t\t\tc0.2,0,0.4,0.1,0.5,0.2c0.3,0.2,0.8,0.6,1.4,1.2c0,0,0.3,0.3,0.4,0.3c0.2,0.2,0.3,0.5,0.4,0.7c0,0.5,0.2,0.7,0.5,0.8\r\n\t\t\tc0.2,0.1,0.5,0.2,0.9,0.2c0.2,0,0.3,0,0.4,0h0.3c0.2,0,0.4,0,0.7,0.1c0.9,0.2,1.7,0.3,2.5,0.3s1.5-0.2,2.1-0.5\r\n\t\t\tc1-0.5,1.7-1.6,2.4-2.7l0.1-0.1c0.5-0.8,1-1.6,1.6-2.1c1.5-1.2,5.2-2.7,7.6-2.7c0.8,0,1.4,0.2,1.9,0.5c0.1,0,0.1,0.1,0.2,0.1\r\n\t\t\tc0.5,0.5,1.3,2.5,1.2,3.2v0.1c-0.2,1-1.2,1.6-2.2,2.4c-0.8,0.6-1.6,1.1-2.1,1.9c0,0,0,0,0,0.1c-0.1,0.1-0.2,0.4-0.3,0.6l-0.1,0.2\r\n\t\t\tc-0.1,0.3-0.2,0.6-0.3,0.8c0,0.1-0.1,0.2-0.1,0.2v0.1c0.1,1.4,0.5,1.6,1.3,1.7c0.4,0.1,0.9,0.2,1.7,0.5c1.3,0.4,2.9,1.5,3.5,2.8\r\n\t\t\tc0,0.1,0.1,0.1,0.1,0.1s0,0,0.1,0s0.1,0,0.1,0c1.3-1.2,3.6-2.6,5.6-2.6c0.5,0,1,0.1,1.4,0.2c1.6,0.7,1.7,1.8,1.8,3.3\r\n\t\t\tc0,0.6,0.1,1.2,0.2,1.8c0,0.1,0,0.1,0.1,0.1h0.2c2.2-0.9,2.5-2.5,2.8-4c0.2-1.1,0.4-2.2,1.4-2.9c0,0,0.1-0.1,0.1-0.2\r\n\t\t\tc-0.1-0.3-0.1-0.5,0-0.7s0.3-0.4,0.6-0.5s0.5-0.2,0.8-0.2c0.1,0,0.1-0.1,0.2-0.2c0-0.1,0-0.1-0.1-0.2c-0.6-0.5-1.3-1.6-1.4-2.7\r\n\t\t\tc0,0,0-0.1,0-0.2c0-0.2-0.1-0.4,0-0.5c0.1-0.4,0.5-0.7,1-0.7l0,0c0.5,0,1.1,0.3,2.2,0.7c0.4,0.2,1,0.4,1.4,0.5l0.6,0.1\r\n\t\t\tc1.5,0.4,3,0.7,4.4,0.9c0.5,0,0.9,0.4,0.9,0.9c0,0.1,0.1,0.1,0.2,0.1h1.2c0.1,0,0.2-0.1,0.2-0.2c0.1-0.4,0.4-0.7,0.8-0.8\r\n\t\t\tc0.9-0.2,1.7-0.5,2.4-0.7c0.3-0.1,0.7-0.3,1.1-0.4c0.5-0.2,0.9-0.3,1.2-0.3c0.5,0,0.8,0.2,1.1,0.3c0.5,0.2,0.9,0.5,1.7,0.7\r\n\t\t\tc0.7,0.2,1.4,0.3,2.4,0.3c0.4,0,0.8,0,1.2,0s0.8,0,1.2,0c0.3,0,0.6,0,0.8,0c0.5,0,0.9,0.2,1.2,0.3c0.4,0.1,0.8,0.2,1.1,0.2\r\n\t\t\tc0.2,0,0.4,0,0.7-0.1c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.3,0,0.4,0.1c0.3,0.1,0.5,0.4,0.5,0.6c0,0.2,0.1,0.3,0.2,0.5\r\n\t\t\tc0.1,0.1,0.1,0.2,0.1,0.3s0,0.2,0,0.3c0,0.6-0.3,1.1-0.8,1.5c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.1,0.2l0.5,0.2\r\n\t\t\tc1.7,0.5,2.6,0.8,3,2.7c0.3,1.3,0.1,1.9-0.4,2.6c-0.3,0.4-0.6,0.9-0.8,1.7c-0.3,1.1,0.2,1.9,0.6,2.6c0.3,0.5,0.6,1.1,0.6,1.8\r\n\t\t\tc0,0.5-0.2,1-0.5,1.6c-0.2,0.5-0.5,1.1-0.6,1.7c-0.1,0.5-0.5,0.8-1,0.8c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0.1-0.4,0.1\r\n\t\t\ts-0.5-0.1-0.6-0.2c-0.2-0.1-0.4-0.3-0.6-0.5c-0.8-0.7-1.6-1.4-2.8-1.6c-0.3-0.1-0.7-0.1-1.1-0.1c-1.8,0-3.9,0.6-4.7,2.1\r\n\t\t\tc-0.3,0.6-0.3,1-0.2,1.4c0.1,0.3,0,0.7-0.3,0.9c-0.1,0.1-0.3,0.3-0.9,0.6c-0.4,0.3-0.9,0.3-1.3,0.3c-0.2,0-0.4,0-0.7,0\r\n\t\t\ts-0.6,0-0.9,0c-0.4,0-0.8,0-1,0.1h-0.1c-0.9,0.2-1.5,0.7-2.2,1.2l-0.2,0.1c-0.4,0.3-0.8,0.6-1.2,0.8c-0.6,0.3-0.9,0.4-1.3,0.4\r\n\t\t\tc-0.2,0-0.3,0-0.4,0c-0.3-0.1-0.6-0.2-1.2-0.2c-4.6,0.3-7.7,1.4-8.7,3.2c-0.6,1.1-0.5,1.6-0.5,1.7c0,0.3-0.1,0.6-0.3,0.9\r\n\t\t\tc-0.2,0.2-0.4,0.3-1.4,0.6c-0.5,0.2-1,0.2-1.4,0.3c-0.8,0.1-1.5,0.2-2.3,0.8c-0.4,0.2-0.8,0.6-1.2,1.1l-0.3,0.4\r\n\t\t\tC753.1,279.6,752.1,280.6,751,280.6z\"/>\r\n\r\n\t</g>\r\n\t<text transform=\"matrix(1 0 0 1 801.3273 259.8269)\" class=\"label-inactive\">PB</text>\r\n</g>\r\n<g id=\"AL\">\r\n\t<g>\r\n\t\t<path class=\"estado-inactive\" d=\"M762.7,323.5c-0.4,0-0.7-0.2-0.9-0.6c-0.7-1.6-3.5-3.3-6.4-5l-0.4-0.2c-0.9-0.5-1.7-1-2.3-1.5\r\n\t\t\tc-0.8-0.6-1.5-1.5-2.2-2.4c-1-1.3-2.1-2.8-3.6-3.1h-0.1c-0.3-0.1-0.7-0.2-1.1-0.2c-0.4,0-0.7,0-1.1,0.1h-0.1\r\n\t\t\tc-0.3,0-0.6,0.1-0.9,0.1c-0.4,0-0.7,0-1-0.2c-0.9-0.3-1.8-1-2.7-1.6l-0.1-0.1c-0.9-0.7-1.8-1.3-2.7-1.7c-1-0.4-2.1-1.2-3.1-1.9\r\n\t\t\tc-1.4-1-2.8-2-4.4-2.4c-0.3-0.1-0.6-0.3-0.7-0.7c-0.2-0.8-0.6-1.6-1.1-2.4c-0.1-0.2-0.2-0.5-0.1-0.8c0.1-0.3,0.3-0.5,0.5-0.6\r\n\t\t\tc0.4-0.2,0.9-0.4,1.4-0.6c1.3-0.5,2.5-0.9,3.2-1.7c0.5-0.6,0.8-1.1,1-1.7c0.4-1,0.8-1.6,2.1-1.9c0.5-0.1,1.1-0.2,1.5-0.2\r\n\t\t\tc2.5,0,3.9,1.6,5.4,3.4c1,1.2,1.9,2.2,2.9,2.8c1.3,0.9,3.2,1,4.9,1c0.5,0,1,0,1.4,0c0,0,1.1,0,1.4,0c0.4,0,0.7,0,1,0l0,0\r\n\t\t\tc0.4,0,0.8,0,1.3,0h0.7c0.8,0,1.5,0,2.3,0c1.4,0,2.4-0.1,3.2-0.3c1.4-0.3,7.1-3.8,8-6.7c0.1-0.4,0.2-0.7,0.1-1.1\r\n\t\t\tc-0.1-0.5,0.2-0.9,0.6-1.1c0.2-0.1,0.4-0.1,0.5-0.2c1.1-0.4,2.3-0.9,3.2-0.9c0.1,0,0.3,0,0.4,0c0.4,0.1,0.8,0.3,1.2,0.5\r\n\t\t\tc0.5,0.3,1.1,0.6,1.8,0.7c0.4,0.1,0.9,0.1,1.5,0.1c0.7,0,1.4,0,2.1-0.1c0.7,0,1.4-0.1,2.1-0.1c0.6,0,1,0,1.5,0.1\r\n\t\t\tc0.2,0,0.2,0,0.3,0.1c0.3,0.1,0.6,0.3,0.7,0.7c0.1,0.3,0,0.7-0.2,1c-1.3,1.4-1.9,3.7-2.5,5.8c-0.3,1.2-0.7,2.4-1.1,3.3\r\n\t\t\tc-0.9,1.8-2.8,3.5-4.7,5.1l-0.1,0.1c-1,0.8-1.9,1.6-2.6,2.4c-1,1-1.6,2.1-2.2,3.5l-0.2,0.4c-0.4,0.7-0.7,1.4-1.1,2\r\n\t\t\tc-0.6,0.7-1.4,1.1-2.1,1.4c-0.7,0.3-1.4,0.6-1.8,1.1c-0.7,0.9-0.7,1.8-0.7,2.6c0,1.1,0,1.9-1.4,2.7c-0.5,0.4-1.5,0.5-2.3,0.6h-0.3\r\n\t\t\tC762.8,323.5,762.7,323.5,762.7,323.5z\"/>\r\n\r\n\t</g>\r\n\t<text transform=\"matrix(1 0 0 1 781.719 319.8646)\" class=\"label-inactive\">AL</text>\r\n</g>\r\n<g id=\"PE\">\r\n\t<g>\r\n\t\t<text transform=\"matrix(1 0 0 1 796.3651 283.8552)\" class=\"label-active outside\">PE</text>\r\n\t</g>\r\n\t<g>\r\n\t\t<path class=\"estado-active\" d=\"M679.2,303.6c-0.5,0-1.2,0-1.8-0.1c-0.3,0-0.6-0.3-0.8-0.6c-0.1-0.3-0.1-0.7,0.1-1c0.6-1,0.9-1.8,0.3-3.1\r\n\t\t\tc-0.2-0.3-0.6-0.5-0.9-0.7c-0.2-0.1-0.4-0.2-0.6-0.4c-0.3-0.2-0.4-0.6-0.3-0.9c0-0.1,0-0.2,0.1-0.2c0.1-0.3,0.1-0.4,0.1-0.7\r\n\t\t\tc0-0.5,0-1.1,0-1.5c0.1-1.3,0.1-2.5-1.2-3.5c-1.4-1.2-5.5-1.5-7.7-1.7c-0.5,0-0.9-0.4-0.9-0.9c-0.1-0.5,0.2-0.9,0.6-1.1l0.5-0.2\r\n\t\t\tc0.6-0.2,1-0.4,1.5-0.6c1.1-0.6,2.1-1.5,3.1-2.4c0.5-0.5,1.2-1.1,2-1.6c3.8-3.1,7.4-6.4,5.7-12c-0.2-0.7-0.3-1.5-0.3-2.6v-0.1\r\n\t\t\tc-0.1-1.4-0.2-2.9-0.9-3.8c-0.3-0.4-0.3-1,0.1-1.4c0.5-0.4,1.1-0.9,1.8-0.9c0.6,0,1.1,0.2,1.6,0.5c0.8,0.4,1.7,0.8,3.2,0.9\r\n\t\t\tc1,0,2.4-0.4,3.5-0.8c0.9-0.3,1.7-0.5,2.5-0.6c1.1-0.2,2-0.2,3-0.2c1.1,0,2.3,0.1,3.6,0.4c3.9,0.5,4.6,1.3,6.5,4.1l1,1.4\r\n\t\t\tc0.8,1.1,1.7,1.2,2.5,1.3c0.6,0.1,1.1,0.2,1.7,0.6c0.6,0.4,1,1.2,1.3,2.1l0.1,0.2c0.3,0.6,0.6,1.2,1,1.7c0.1,0.1,0.1,0.1,0.1,0.1\r\n\t\t\tc0.1,0,0.1,0,0.2,0c0.6-0.4,0.9-1.2,1.3-2.3v-0.1c0.3-0.8,0.6-1.6,1.2-2.1c1.1-0.8,2.3-0.8,3.5-0.9h0.1c0.2,0,0.5,0.1,0.7,0.2\r\n\t\t\tc1.2,1,2.4,1.5,4.8,1.8c1.1,0.2,2.4,0.5,3.6,0.5c1,0,1.8-0.2,2.5-0.6c0.4-0.3,0.5-0.8,0.6-1.2c0.1-0.4,0.2-0.6,0.4-0.9\r\n\t\t\tc1.5-1.5,3.6-1.9,5.6-2.4c1.6-0.3,3.3-0.6,4.7-1.5c0.5-0.3,1-0.6,1.5-1c1.5-1,2.7-1.8,4.4-1.8c0.4,0,0.9,0,1.4,0.1\r\n\t\t\tc0.3,0,0.5,0.2,0.6,0.4c0.3,0.4,0.7,0.7,1.2,1c0.4,0.2,0.6,0.6,0.5,1.1c-0.1,0.4-0.4,0.7-0.9,0.8c-0.9,0.1-1.8,0.2-2.1,0.8\r\n\t\t\tc-0.5,0.8-0.1,1.7,0.4,2.7c0.4,0.7,0.8,1.4,0.6,2.1c0,0.4-0.3,0.7-0.9,1.3c-0.2,0.2-0.4,0.4-0.6,0.7c-0.2,0.2-0.5,0.4-0.8,0.4\r\n\t\t\th-0.1c-0.1,0-0.2,0-0.2,0.1c0,0.1,0,0.2,0,0.3c0,0,0,0.1,0.1,0.1c0.2,0.2,0.4,0.4,0.4,0.7c0,0.1,0,0.2,0,0.4\r\n\t\t\tc0,0.1,0.1,0.2,0.2,0.2s0.1,0,0.2,0c0,0,0,0,0-0.1c0.2-0.3,0.5-0.5,0.9-0.5c0.1,0,0.2,0,0.3,0c0.9,0.3,3,0.9,2.7,3.1\r\n\t\t\tc0,0.4-0.2,0.8-0.4,1.3v0.1c-0.4,1.1-0.6,1.8,0.7,2.6c0.3,0.2,0.6,0.2,0.9,0.2c1.4,0,3.1-1.7,4-2.7l0.1-0.1c0.5-0.5,0.9-0.9,1.2-1\r\n\t\t\tc0.8-0.5,1.5-0.6,2.3-0.7c0.5-0.1,0.9-0.1,1.4-0.3c1.6-0.5,1.8-0.7,1.9-1.6c0-0.4,0.1-0.9,0.5-1.8c1.3-2.5,6.3-3,8.5-3.1l0,0\r\n\t\t\tc0.5,0,0.7,0.1,1,0.1c0.3,0.1,0.4,0.1,0.6,0.1c0.2,0,0.6,0,1.4-0.4c0.4-0.2,0.9-0.6,1.4-0.9c0.6-0.5,1.3-1,2.3-1.2\r\n\t\t\tc0.2-0.1,0.6-0.1,1-0.1c0.2,0,0.4,0,0.6,0h0.1c0.3,0,0.5,0,0.8,0c0.7,0,1.1-0.1,1.5-0.4c1.3-0.7,1.4-1.2,1.3-1.9\r\n\t\t\tc0-0.3-0.1-0.7,0.2-1.2c0.8-1.3,2.9-1.9,4.5-1.9c0.3,0,0.7,0,1,0.1c1,0.1,1.8,0.8,2.6,1.5l0.3,0.2c0.5,0.4,1,0.9,1.5,1.1\r\n\t\t\tc0.3,0.1,0.6,0.4,0.6,0.8c0.4,3.1-0.7,12.7-1.6,14.8l-1,1.9c-1.4,2.8-3.7,5.2-4.4,8.1c-0.1,0.3-0.2,0.5-0.5,0.6\r\n\t\t\tc-0.2,0.1-0.3,0.1-0.5,0.1c-0.1,0-0.2,0-0.3,0c-0.2-0.1-0.4-0.1-0.7-0.2c-0.4-0.1-0.9-0.1-1.5-0.1c-0.7,0-0.5,0-1.2,0.1\r\n\t\t\tc-0.7,0-1.4,0.1-2,0.1c-0.5,0-1,0-1.4-0.1c-0.6-0.1-1.1-0.4-1.6-0.6c-0.5-0.3-0.9-0.5-1.3-0.6c-0.2,0-0.4-0.1-0.5-0.1\r\n\t\t\tc-1,0-2.3,0.5-3.4,0.9c-0.6,0.2-1.2,0.5-1.7,0.6c-0.1,0-0.1,0.1-0.2,0.1c0,0.1,0,0.1,0,0.2c0.5,0.5,0.5,1.1,0.3,1.7\r\n\t\t\tc-0.9,2.8-6.5,6.2-7.9,6.5c-0.8,0.2-1.8,0.3-3.3,0.3c-0.8,0-1.6,0-2.5-0.1c-0.2,0-0.5,0-0.7,0c-0.3,0-0.5,0-0.7,0s-0.2,0-0.3,0\r\n\t\t\tc-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1,0c-0.3,0-0.7,0-1.1,0c-0.3,0-1.3,0-1.3,0c-0.5,0-0.9,0-1.3,0c-1.8,0-3.8-0.1-5-0.9\r\n\t\t\tc-1.1-0.7-1.9-1.7-2.9-2.8c-1.4-1.7-3.2-3.7-5.9-3.7c-0.5,0-1.1,0.1-1.6,0.2c-1.6,0.4-2,1.2-2.5,2.1c-0.2,0.4-0.4,1-1,1.6\r\n\t\t\tc-0.6,0.7-1.8,1.1-3,1.5h-0.1c-0.7,0.2-1.3,0.5-1.8,0.8c-0.1,0.1-0.3,0.1-0.4,0.1c-0.3,0-0.6-0.1-0.8-0.4\r\n\t\t\tc-1.2-1.6-2.5-2.5-4.2-3.6l-1.3-0.9c-3.2-2.1-7.1-4.7-10.6-5.7c-1.6-0.5-4.1-0.8-6.3-0.8c-1.9,0-3.5,0.2-4.5,0.7\r\n\t\t\tc-1.6,0.7-4.6,2.7-6.1,4.2c-0.5,0.5-0.9,1.2-1.2,2.1v0.1c-0.4,0.9-0.9,1.8-1.5,2.3c-0.2,0.1-0.3,0.2-0.4,0.2\r\n\t\t\tc-0.1,0.1-0.3,0.1-0.5,0.1c-0.1,0-0.2,0-0.4-0.1l-0.3-0.1c-0.4-0.2-0.8-0.4-1.5-0.5c-0.1,0-0.3,0-0.5,0c-2.3,0-3.6,1.2-4.1,3.7\r\n\t\t\tc-0.2,0.8-0.2,1.3-0.3,1.8c0,0.4-0.3,0.7-0.6,0.9c-0.3,0.1-0.7,0.3-0.9,0.3C681,303.5,680.2,303.6,679.2,303.6z\"/>\r\n\t</g>\r\n</g>\r\n<g id=\"SE\">\r\n\t<g>\r\n\t\t<path class=\"estado-inactive\" d=\"M738.1,345.5c-0.1,0-0.3,0-0.4,0c-1.9-0.2-3.6-1.5-4.9-4c-0.2-0.4-0.4-0.9-0.7-1.5c-1.5-3-3.2-6.7-3.4-8.2\r\n\t\t\tc0-0.3,0.1-0.6,0.3-0.8c0.2-0.2,0.5-0.3,0.7-0.3l0,0c0.5,0,1.2,0.2,1.9,0.4h0.1c0.7,0.2,1.3,0.4,1.9,0.4c0.2,0,0.3,0,0.5,0\r\n\t\t\tc1.6-0.4,1.8-1.5,1.8-3.2c0-0.6,0-1.3,0.2-2.2c0.1-0.6,0.2-1.3,0.3-2.1c0.5-3,1.1-6.6,0-8.7c-0.5-1.1-1.5-1.4-2.4-1.6\r\n\t\t\ts-1.6-0.4-2.1-1c-0.7-0.9-0.6-2.3-0.5-3.5c0.1-1.5,0.2-2.6-0.5-3.2c-0.1-0.1-0.2-0.2-0.2-0.2c-0.3-0.4-0.2-0.9,0.1-1.2\r\n\t\t\tc0.2-0.2,0.5-0.3,0.7-0.3s0.4,0,0.5,0.2c0.5,0.3,0.9,0.6,1.4,1l0.4,0.3c1,0.7,2,1.4,3,1.8c0.8,0.3,1.5,0.8,2.3,1.4l0.3,0.2\r\n\t\t\tc1,0.7,2,1.5,3,1.8c0.3,0.1,0.7,0.2,1.1,0.2c0.4,0,0.7,0,1.1-0.1c0.4,0,0.7-0.1,1.1-0.1c0.4,0,0.8,0.1,1.1,0.2\r\n\t\t\tc1.5,0.4,2.5,1.7,3.4,3c0.7,0.9,1.4,1.9,2.3,2.5c0.6,0.5,1.5,1,2.5,1.6l0.2,0.1c3.4,2,5.6,3.5,6.2,4.7c0.2,0.3,0.1,0.7-0.1,1\r\n\t\t\tc0,0.1,0,0.1,0,0.1c0,0.3-0.1,0.6-0.3,0.8c-0.1,0.1-0.3,0.3-0.6,0.5l-0.2,0.2c-0.1,0.1-0.3,0.2-0.4,0.4c-1.2,1-1.4,1.4-1.7,2.2\r\n\t\t\tc-0.1,0.4-0.3,0.8-0.6,1.3c-0.7,1.1-1.5,1.6-2.4,2.1l-0.1,0.1c-0.3,0.2-0.6,0.4-1,0.6c-0.9,0.7-1.8,1.9-2.6,2.8l-0.1,0.1\r\n\t\t\tc-0.4,0.5-0.8,0.9-1.2,1.4C745.2,342.6,741.3,345.5,738.1,345.5z\"/>\r\n\r\n\t</g>\r\n\t<text transform=\"matrix(1 0 0 1 752.9965 349.8835)\" class=\"label-inactive\">SE</text>\r\n</g>\r\n<g id=\"RS\">\r\n\t<g>\r\n\t\t<path class=\"estado-active\" d=\"M444.2,762c-0.2,0-0.4-0.1-0.6-0.2l0,0c0,0-0.1-0.1-0.2-0.1c-0.3-0.2-0.6-0.4-0.7-0.7\r\n\t\t\tc-0.6-1.1-0.7-4.8-0.3-5.9c0.4-1,1.1-1.3,2-1.7c0.3-0.1,0.7-0.3,1.1-0.6c1.4-1,1.5-1.4,2-2.6l0.3-0.8c0.9-2,2.2-2.4,3.6-3\r\n\t\t\tc0.8-0.3,1.9-0.7,2.9-1.5c2.6-2.2,3.5-6.4,4.2-9.5l0.3-1.5c0.7-3.2,2.5-4.8,5.4-6.4c0.3-0.1,0.5-0.2,0.7-0.4\r\n\t\t\tc0.5-0.3,0.8-0.5,1.1-0.6c0.1-0.1,0.3-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1s0.3,0.1,0.4,0.2c0.1,0.1,0.3,0.1,0.5,0.1\r\n\t\t\tc0.8-0.2,1.5-0.6,2.3-1.1l0.1-0.1c0.4-0.3,0.8-0.5,1.4-0.8c1.1-0.5,3.5-1.2,4.2-1.2c0.1,0,0.2,0,0.3,0c0.3,0.1,0.5,0.2,0.6,0.5\r\n\t\t\tc0.5,0.8,0.7,3.6,0.2,4.5c-0.2,0.3-0.5,0.5-0.9,0.5c-0.1,0-0.2,0-0.3,0s-0.3,0-0.4-0.1h-0.1c-0.2-0.1-0.5-0.1-0.8-0.1\r\n\t\t\ts-0.6,0.1-0.8,0.3c-0.9,0.8-0.8,2.2-0.7,3.6c0.1,1.4,0.1,2.4-0.3,3c-0.4,0.7-1,1-1.6,1.3c-0.3,0.2-0.7,0.3-1,0.5\r\n\t\t\tc-1.1,0.8-1.8,1.6-2.5,2.5c-0.3,0.4-0.6,0.7-0.9,1.1c-0.3,0.4-0.7,0.7-1.1,1c-0.8,0.7-1.6,1.3-2.2,2.4c-0.2,0.5-0.3,1-0.4,1.6\r\n\t\t\tl-0.1,0.2c-0.2,0.9-0.4,1.7-1.1,2.5c-0.5,0.7-1.2,1-1.8,1.3c-0.6,0.3-0.9,0.5-1.1,0.6l-0.1,0.1c-1.2,0.6-1.6,1.2-2,1.8l-0.2,0.3\r\n\t\t\tc-0.1,0.2-0.3,0.4-0.5,0.6c-2.3,2.5-4.7,2.9-8.1,3.3c-2.1,0.3-3,0.7-3.3,1.4c-0.1,0.3-0.3,0.9,0.4,2.2c0.2,0.4,0.1,0.9-0.2,1.2\r\n\t\t\tC444.6,761.9,444.4,762,444.2,762z\"/>\r\n\r\n\t</g>\r\n\t<g>\r\n\t\t<path class=\"estado-active\" d=\"M419.2,796.1c-0.1,0-0.3,0-0.4-0.1c-0.3-0.1-0.5-0.3-0.5-0.6c-0.2-0.6-0.6-1.1-0.9-1.5c-0.4-0.5-0.7-1-1-1.6\r\n\t\t\tc-0.6-1.2-0.6-2.8-0.6-4.4v-0.2c0-0.9,0-1.8-0.1-2.6c0-0.1-0.1-0.2-0.2-0.2c-0.4,0-0.8-0.3-0.9-0.7c-1.7-6.4-0.7-10.1,0.5-12.1\r\n\t\t\tc0.2-0.3,0.5-0.5,0.9-0.5c0.2,0,0.3,0,0.5,0.1c2,1.2,4.6,1.9,6.8,1.9c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.2\r\n\t\t\tc-4.2,0-9.5-2.6-10.4-6.4l-0.1-0.3c-0.8-3-1.5-5.9-4.8-7.4c-0.3-0.2-0.7-0.2-1.1-0.2s-0.8,0.1-1.1,0.1h-0.1\r\n\t\t\tc-0.3,0-0.6,0.1-0.8,0.1c-0.3,0-0.5,0-0.7-0.1c-0.3-0.1-0.7-0.3-0.9-1c-0.1-0.3-0.2-0.6-0.8-1.2c-0.6-0.4-1.3-0.6-1.8-0.7\r\n\t\t\tl-0.3-0.1c-0.4-0.1-0.8-0.2-1.1-0.4c-0.7-0.5-0.9-1.2-1.1-2c-0.2-0.6-0.3-1.1-0.6-1.5c-1.1-1.7-2.3-2.1-3.6-2.4\r\n\t\t\tc-0.8-0.2-1.5-0.4-2.4-0.9l-0.1-0.1c-0.2-0.1-0.3-0.3-0.5-0.6c-0.2-0.4-0.5-0.7-1-1s-1.6-0.4-2.6-0.6l-0.4-0.1\r\n\t\t\tc-0.5-0.1-1.1-0.2-1.6-0.3c-2.6-0.4-3-0.5-4-2.8L381,743c0,0,0-0.1-0.2-0.1c-0.3-0.1-0.6-0.2-0.7-0.5c-1.4-2.8-2.9-4.6-4.1-4.9\r\n\t\t\tc-0.2,0-0.4-0.1-0.6-0.1c-0.9,0-1.2,0.5-1.8,1.3c-0.4,0.6-0.8,1.3-1.8,1.8c-1.7,0.7-2.7,1-3.4,1c-0.3,0-0.6-0.1-0.9-0.2\r\n\t\t\tc0,0-0.1-0.1-0.3-0.2c-0.2-0.2-0.3-0.4-0.3-0.7c0-0.2-0.1-0.5-0.3-1c-0.4-0.9-0.7-1.8-0.9-2.7c-0.4-1.4-0.9-3.1-1.7-4.3\r\n\t\t\tc-1.1-1.9-2.9-2.8-4.8-3.8c-1.4-0.7-2.7-1.3-3.8-2.4c-0.5-0.5-1-1.3-1.5-2.3c-0.6-1-1-1.8-1.6-2.3c-0.5-0.4-1.5-0.6-2.6-0.6\r\n\t\t\tc-2.4,0-5.1,0.8-6,1.2l-0.1,0.1c0,0.1,0,0.1,0,0.2c0.2,0.3,0.4,0.6,0.5,0.8c0.1,0.3,0.1,0.6,0,0.8c-0.1,0.3-0.4,0.4-0.6,0.5\r\n\t\t\tc-0.4,0.1-1,0.2-1.9,0.2c-0.2,0-0.9,0-0.9,0c-2,0-3.3-0.2-4.5-0.7c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1-0.1-0.3-0.3-0.5\r\n\t\t\tc-0.3-0.4-0.3-1,0.1-1.3c1-1,1.9-2.1,2.9-3.2c1.3-1.5,2.6-3,4.1-4.3c0.9-0.8,1.9-1.6,2.9-2.3c1.5-1.2,3.2-2.5,4.4-4\r\n\t\t\tc0.5-0.7,1-1.5,1.5-2.2l0.1-0.2c0.8-1.2,1.6-2.4,2.7-3.5c0.8-0.7,1.7-1.3,2.7-2c1.3-0.8,2.4-1.6,3.4-2.7c0.5-0.6,0.9-1.2,1.4-1.8\r\n\t\t\tl0.2-0.2c0.9-1.3,1.8-2.4,2.9-3.5c0.3-0.3,0.6-0.7,1-1.2l0.1-0.2c1.7-2.2,3.2-3.9,4.9-3.9c0.4,0,0.7,0.1,1,0.2h0.1\r\n\t\t\tc0.1,0,0.1-0.1,0.1-0.1c0.1-0.5,0.1-1,0.2-1.5c0.1-0.9,0.1-2,0.7-2.8c0.6-0.9,2.1-1.7,4.1-2.7l0.3-0.2c0.7-0.3,1.3-0.7,1.8-1\r\n\t\t\tl2.2-1.5c3.1-2.1,6.3-4.3,9.7-6.1c3.4-1.8,6.4-3.7,9.4-5.7l3-1.9c2-1.2,3.8-1.7,6-1.7c0.5,0,1.1,0,1.7,0.1c1,0.1,2.4,0.3,2.8,0.4\r\n\t\t\tl1.4,0.2c2.6,0.3,5.5,0.4,8.2,0.5h0.8c7.9,0.3,16.1,0.6,22.9,4.3c0.4,0.2,0.8,0.4,1.1,0.6l0.3,0.1c1.3,0.7,2.6,1.4,4,1.7\r\n\t\t\tc1,0.2,1.9,0.3,2.8,0.4c1.6,0.1,3,0.3,4.6,1.1c3.4,1.9,7.5,5.9,9.6,9.2c2.5,4.1,5.9,5.5,9.9,7.1l0.9,0.4c0.4,0.2,0.8,0.3,1.3,0.5\r\n\t\t\tc1.9,0.8,6.1,1.9,9,1.9c0.3,0,0.6,0,0.9,0h0.1c0.4,0,0.8,0.3,0.9,0.7c0,0.1,0.1,0.3,0.2,0.5s0.1,0.3,0.1,0.5c0,1-0.8,1.4-1.6,1.9\r\n\t\t\tc-0.4,0.2-0.8,0.4-1.1,0.7c-1.3,1.1-1.7,2.1-2.1,3.3l-0.1,0.4c-0.1,0.3-0.2,0.6-0.4,1c-0.2,0.5-0.7,1.4-1.3,2.5\r\n\t\t\tc-1.1,1.8-2.1,3.5-1.6,4.1c0.1,0.1,0.2,0.2,0.5,0.2c0.5,0,1.2-0.3,1.6-0.5c0.3-0.2,0.5-0.3,0.8-0.5l0.3-0.2\r\n\t\t\tc0.6-0.4,1.1-0.8,1.7-0.9c0.1,0,0.2,0,0.2,0c0.6,0,1.2,0.4,1.8,1.3c0.3,0.3,0.5,0.8,0.6,1.4c0.1,0.3,0,0.6-0.3,0.9l-0.1,0.1\r\n\t\t\tc0,0,0,0.1,0.1,0.1c0.2,0.2,0.3,0.5,0.2,0.8c-0.4,1.8-1.6,3.6-2.5,4.8c-0.6,0.7-1.2,1.3-1.8,1.9l-0.8-0.6l0.7,0.7\r\n\t\t\tc-1,1-2,1.9-2.6,3.1c-0.5,1.1-0.5,2.1-0.6,3.1c0,0.4,0,0.9,0,1.4c-0.3,2.2-1.6,3.6-2.9,5.1l-0.1,0.2c-0.6,0.7-1.3,1.5-1.8,2.3\r\n\t\t\tl-0.7,0.9c-1.1,1.5-2.3,3.1-2.8,4.6c-0.2,0.6-0.3,1.1-0.4,1.7c-0.1,0.7-0.2,1.4-0.5,2c-1,1.9-3,3.2-4.8,4.5\r\n\t\t\tc-1.5,1.1-3.1,2.2-4.2,3.6c-0.5,0.6-1,1.1-1.4,1.7c-0.2,0.2-0.5,0.3-0.7,0.3s-0.4-0.1-0.5-0.2c-0.4-0.3-0.6-0.8-0.4-1.2\r\n\t\t\tc0.2-0.5,0.4-1.1,0.5-1.6l0.1-0.3c0.1-0.4,0.2-0.9,0.3-1.3c0,0,0-0.1,0.1-0.1c0.5-0.9,1.2-1.5,2.1-2.2l0.3-0.3\r\n\t\t\tc0.3-0.2,0.6-0.5,0.9-0.8s0.6-0.7,0.9-1.1l0.1-0.1c0.7-0.8,1.3-1.6,2.3-2.3c0.3-0.2,0.6-0.3,0.9-0.5c0.7-0.4,1.4-0.7,1.9-1.5\r\n\t\t\tc0.4-0.8,0.4-1.9,0.3-3V733c-0.1-1.8-0.1-2.6,0.4-3.1c0.2-0.2,0.5-0.4,0.8-0.4h0.1c0.1,0,0.1,0,0.2,0c0.2,0,0.3,0,0.3,0.1\r\n\t\t\tc0.3,0.1,0.5,0.1,0.8,0.1c0.5,0,0.9-0.2,1.2-0.6c0.4-0.5,0.5-1.8,0.3-3.3c-0.2-1.3-0.5-1.8-0.6-1.9c-0.3-0.2-0.7-0.4-1.3-0.4\r\n\t\t\tc-1.6,0-3.8,0.9-4.2,1.1l0,0c-0.5,0.2-0.9,0.5-1.3,0.7l-0.3,0.2c-0.8,0.5-1.3,0.8-1.7,1c-0.1,0.1-0.3,0.1-0.4,0.1\r\n\t\t\tc-0.2,0-0.3,0-0.5-0.1c-0.3-0.1-0.6-0.3-0.9-0.3h-0.1c-0.4,0.1-1,0.4-1.5,0.7c-0.2,0.1-0.4,0.2-0.6,0.3c-2.5,1.4-4.9,3-5.7,6.7\r\n\t\t\tl-0.3,1.4c-0.7,3.2-1.6,7.3-4.1,9.4c-1,0.8-2,1.2-2.8,1.5c-1.4,0.5-2.8,1.1-3.8,3.2l-0.3,0.8c-0.5,1.2-0.7,1.5-1.9,2.4\r\n\t\t\tc-0.4,0.3-0.7,0.4-1,0.5h-0.1c-0.9,0.5-1.7,0.8-2.2,1.9c-0.4,1.2-0.3,5,0.3,6.1c0.2,0.5,0.6,0.7,0.9,0.9c0.5,0.4,1,0.7,0.9,1.5\r\n\t\t\ts-0.7,1.1-1.4,1.4c-0.6,0.3-1.1,0.5-1.5,1c-0.7,0.8-0.8,1.7-0.8,2.4s0,1-0.1,1.1c0,0.1-0.1,0.2-0.1,0.3c-0.3,0.5-0.7,0.9-1.1,1.2\r\n\t\t\tl-0.1,0.1c-0.5,0.5-1,0.9-1.2,1.4c-1,1.5-1.1,3.2-1.2,4.8c-0.1,1.7-0.2,3.2-1.1,4.4c-4.9,7.2-10.1,11.9-16,14.4\r\n\t\t\tC419.5,796.1,419.4,796.1,419.2,796.1z\"/>\r\n\r\n\t</g>\r\n\t<g>\r\n\t\t<text transform=\"matrix(1 0 0 1 408.9151 717.1278)\" class=\"label-active\">RS</text>\r\n\t</g>\r\n</g>\r\n<g id=\"SC\">\r\n\t<path class=\"estado-active\" d=\"M492.7,705.5c-0.3,0-0.7-0.2-0.8-0.5c0-0.1-0.1-0.2-0.1-0.2c-0.5-0.7-1.2-1.4-2-1.4c-0.1,0-0.1,0-0.2,0\r\n\t\tc-0.8,0.1-1.4,0.5-2,1c-0.2,0.1-0.3,0.2-0.4,0.3l-0.1,0.1c-0.2,0.1-0.4,0.2-0.6,0.2s-0.5-0.1-0.7-0.3c-0.3-0.3-0.4-0.8-0.2-1.2\r\n\t\tc0.3-0.5,0.7-1.1,0.9-1.6c0.6-0.9,1.2-2,1.4-2.5c0.2-0.4,0.3-0.7,0.4-1c0.1-0.2,0.1-0.3,0.2-0.5c0.4-1.3,0.7-2.1,1.9-3.1\r\n\t\tc0.3-0.3,0.7-0.4,1.1-0.6c1.2-0.6,2-1.2,1.8-2.6l0,0c0,0,0,0-0.1-0.1c-0.1-0.2-0.2-0.4-0.3-0.7c0-0.1-0.1-0.2-0.1-0.3\r\n\t\tc0,0,0-0.1-0.1-0.1c-0.1-0.1-0.1-0.3-0.2-0.4c0,0,0,0,0-0.1s-0.1-0.1-0.2-0.1c-0.5,0.1-1.1,0.2-1.7,0.2c-2.7,0-6.9-1.1-8.9-1.9\r\n\t\tc-0.6-0.3-1.1-0.5-1.7-0.7l-0.5-0.2c-3.8-1.5-7.2-3-9.7-6.9c-2.2-3.5-6.2-7.4-9.7-9.4c-1.6-0.9-3.1-1-4.6-1.2h-0.1\r\n\t\tc-0.9-0.1-1.8-0.2-2.8-0.4c-1.4-0.3-2.7-1-3.9-1.7c-0.5-0.3-1-0.5-1.5-0.8c-6.9-3.7-15.1-4-23.1-4.3c-3.4-0.1-6.2-0.2-9-0.5\r\n\t\tl-2.2-0.3c-0.3,0-0.5-0.2-0.7-0.4s-0.2-0.5-0.1-0.8c0.1-0.5,0.2-0.9,0.4-1.4V659c0.4-1.2,0.7-2.4,0.6-3.9c0-0.5-0.1-0.9-0.2-1.4\r\n\t\tl-0.1-0.5c-0.4-2.4-0.8-5.2,0.5-7.5c0.2-0.3,0.3-0.5,0.4-0.7c0.2-0.3,0.5-0.5,0.8-0.5c0.2,0,0.6-0.1,0.9-0.1\r\n\t\tc0.9-0.1,1.8-0.1,2.5-0.1c1.6,0,2.9,0.1,4.1,0.4c1,0.2,1.5,0.4,2.1,0.7c0.3,0.2,0.6,0.3,0.9,0.4l0.1,0.1c2.1,1,4.2,1.1,6.2,1.2\r\n\t\tl2.8,0.3c4.6,0.5,9.4,0.9,13.9,2.7c0.9,0.3,2,0.4,3.2,0.5c1.4,0.1,2.8,0.2,3.9,0.8c0.6,0.3,1,0.7,1.2,1c0.5,0.5,0.8,0.8,1.8,0.8\r\n\t\tc0.2,0,0.5,0,0.8-0.1c3.4-0.4,4-2.4,4.5-5.6l0.1-0.4c0.1-0.5,0.2-1,0.3-1.5c0-0.1,0.2-0.9,0.2-0.9c0.1-0.4,0.4-0.8,0.9-0.8\r\n\t\tc0.2,0,0.4,0,0.6-0.1l0.8-0.1c1.2-0.1,2.2-0.2,3.3-0.3l1.2-0.1c1.5-0.3,2.5-1.1,3.4-1.7l0.2-0.1c1-0.7,1.9-1.4,3.6-1.4\r\n\t\tc0.2,0,0.5,0,0.8,0c0.6,0.1,1.4,0.3,2.1,0.5l0.2,0.1c0.8,0.2,1.6,0.4,2.3,0.4c0.2,0,0.5,0,0.7-0.1c0.2,0,0.4-0.1,0.5-0.5\r\n\t\tc0.1-0.3,0.4-0.6,0.7-0.7c0.8-0.2,1.5-0.3,2.2-0.3c0.4,0,0.7,0,1,0.1c1.5,0.2,2.9,0.8,4.1,1.4c1.6,0.7,3.2,1.4,5.2,1.4\r\n\t\tc0.3,0,0.6,0,0.9,0c1.9-0.3,3.5-1.2,5-2.1c1.7-1,3.5-2,5.7-2.2h0.8c0.6,0,1.1,0,1.6,0c0.7,0,1.3,0,1.7,0.1s0.7,0.4,0.8,0.8\r\n\t\tc0.1,0.3,0.2,0.7,0.5,1c0,0,0.1,0,0.1,0.1c0.2,0.2,0.4,0.5,0.3,0.8c0,0.3,0,0.6-0.1,0.9c-0.1,0.6-0.4,1.2-0.6,1.8\r\n\t\tc-0.3,0.6-0.6,1.3-0.6,1.7v0.1c-0.5,1.9,0,4,0.5,6c0.3,1.4,0.4,2.9,0.4,4.4v0.2c0,1.8,0,3.5,0.5,5.1c0.2,0.6,0.4,1.1,0.6,1.5\r\n\t\tc0.4,0.6,0.7,1.2,0.8,1.9c0.1,1.6-0.2,3.1-0.5,4.7c-0.2,1.7-0.4,3.5-0.5,5.2v0.4l-0.1,0.8c0,1,0.1,2.1,0.1,3.1\r\n\t\tc0.2,2.4,0.3,4.8-0.6,6.5c-0.4,0.9-1.4,1.7-2.3,2.4c-0.6,0.5-1.1,0.9-1.7,1.6l-0.1,0.1c-0.8,1-1.6,1.8-2.8,2.7\r\n\t\tc-1.2,1-2.5,2-3.8,2.9c-2.2,1.6-4.5,3.3-6.5,5.3c-0.6,0.5-1.2,1-1.7,1.4c-0.9,0.7-1.8,1.4-2.4,2.2c-0.2,0.3-0.4,0.7-0.5,0.9\r\n\t\tC493.5,705.3,493.1,705.5,492.7,705.5L492.7,705.5z\"/>\r\n\r\n\t<text transform=\"matrix(1 0 0 1 479.1658 671.0988)\" class=\"label-active\">SC</text>\r\n</g>\r\n<g id=\"PR\">\r\n\t<path class=\"estado-active\" d=\"M458.3,652.9c-0.8,0-1.2-0.4-1.5-0.7s-0.7-0.7-1.4-1c-1.2-0.6-2.5-0.7-3.9-0.9h-0.1c-1.1-0.1-2.2-0.2-3.1-0.5\r\n\t\tc-4.5-1.7-9.3-2.2-14-2.7l-2.7-0.3c-2-0.1-4.1-0.3-6.1-1.2c-0.4-0.2-0.7-0.3-1-0.5l-0.1-0.1c-0.6-0.3-1-0.5-2.1-0.7\r\n\t\tc-1.3-0.3-2.6-0.4-4.2-0.4c-0.8,0-1.6,0-2.5,0.1c-0.3,0.1-0.6,0.1-0.8,0.1h-0.1c-0.3,0-0.5,0.1-0.7,0.2c-0.2,0.1-0.3,0.1-0.5,0.1\r\n\t\tc-0.4,0-0.7-0.2-0.9-0.5c-0.1-0.3-0.3-0.5-0.3-0.6v-0.1c-0.1-0.4-0.1-0.8-0.1-1.2v-0.2c0-0.8,0-1.5-0.3-2.1s-0.9-1.1-1.4-1.4\r\n\t\tc-0.5-0.4-0.9-0.7-1.3-1.4c-0.1-0.2-0.3-0.6-0.6-1.8l-0.1-0.2c-0.1-0.3-0.2-0.6-0.3-0.9c-1.3-2.8-2-3.2-4.8-3.3c-0.3,0-0.6,0-1,0\r\n\t\ts-0.7,0-1.1,0h-0.2c-0.4,0-0.8,0-1.2,0c-1.9,0-3.2-0.2-3.8-1.1c-0.8-1.6,0.1-3,1.1-4.2c0.2-0.3,0.5-0.6,0.8-0.9\r\n\t\tc0.6-0.7,1.2-1.4,1.5-2.5c0.2-0.6,0.2-1.2,0.2-1.8v-0.4c0-0.3,0-0.5,0-0.7V619c1.4-5,3.1-11.1,1.1-16.4c-0.1-0.3-0.1-0.7,0.1-1\r\n\t\tc1.6-2.1,3.3-4.4,4.4-7c0.4-0.9,0.6-2,0.7-2.9s0.3-1.9,0.7-2.8c0.3-0.6,0.8-1.2,1.6-2c0.6-0.6,1.2-1.3,1.6-1.9c0.7-1,1-2.2,1.3-3.4\r\n\t\tv-0.2c0.4-1.8,0.8-3.6,2.6-4.5c0.5-0.3,1.1-0.5,1.6-0.7l0.2-0.1c0.9-0.3,1.8-0.5,2.6-1.3c0.4-0.3,0.7-0.7,1.1-1l0.3-0.3\r\n\t\tc1-1,1.9-1.8,2.9-2.5c0.8-0.5,1.6-0.8,2.5-0.9c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0c0,0,0,0,0.1,0c0.1-0.1,0.3-0.1,0.4-0.1\r\n\t\tc0.4,0,0.8-0.1,1.2-0.1c1.5,0,3,0.3,4.4,0.5c1.6,0.3,3.1,0.5,4.7,0.5c0.3,0,0.5,0,0.8,0c1.6-0.1,3.1-0.2,4.3-0.3\r\n\t\tc1.9-0.2,3.8-0.3,5.6-0.3c2.3,0,4.4,0.3,6.5,0.8l2.2,0.6c3.4,0.8,6.5,1.6,9.7,3.1c3.2,1.4,5.9,1.7,9,1.7c1,0,2.1,0,3.2-0.1h1.3\r\n\t\tc0.6,0,1.1,0,1.7,0h0.3c0.4,0,0.8,0,1.3,0c2.1,0,4.6,0.1,6.7,1.6c1.7,1.1,2.5,2.8,3.2,4.5c0.5,1.1,0.9,2,1.5,2.8\r\n\t\tc1.7,2.6,2.6,4.2,2.9,7.3c0.1,0.9,0,1.8,0,2.6c-0.1,2.1-0.2,4.1,0.8,5.9c0.5,0.8,1.1,1.6,1.6,2.2c1,1.2,1.9,2.2,2.2,3.8\r\n\t\tc0.1,0.7,0.1,1.3,0.1,1.9v0.1c0,1.4,0,2.8,1.6,3.7c0.7,0.3,1.9,0.4,2.7,0.4c0.6,0,1.1,0,1.7,0h0.2c0.6,0,1.1-0.1,1.6-0.1\r\n\t\tc0.3,0,0.6,0,0.9,0c0.4,0,0.9,0,1.5,0h0.3c0.4,0,0.9,0,1.3,0c0.9,0,2,0,3,0.2c0.9,0.2,1.4,0.4,1.6,0.4l0,0c0,0,0,0-0.1,0\r\n\t\tc0.2,0,0.4,0.2,0.6,0.3c0.2,0.2,0.3,0.5,0.2,0.8c-0.1,0.4-0.3,0.9-1.5,2.3c-0.6,0.7-1.2,1.5-1.6,2.3c0,0.1,0,0.1,0,0.2\r\n\t\tc0,0.1,0.1,0.1,0.1,0.1c0.6,0.3,1.4,0.5,2.3,0.5c0.5,0,1,0,1.5-0.1c0.5,0,1-0.1,1.4-0.1c0.8,0,1.4,0.1,2,0.4\r\n\t\tc0.6,0.2,0.8,0.7,1.1,1.2s0.6,0.9,1,1.2c0.2,0.1,0.4,0.2,0.8,0.2c0,0,0.2,0,0.3,0c0.4,0,0.7,0.2,0.9,0.6c0.2,0.4,0.1,0.8-0.1,1.1\r\n\t\tc-1,1.1-3.3,2.8-4.5,3.5c-0.4,0.2-1,0.3-1.8,0.5l-0.3-1l0.2,1c-1.4,0.2-2.4,0.5-2.7,1.2c0,0.1,0,0.2,0.1,0.3c1,0.5,1.6,1,1.7,1.6\r\n\t\tc0.1,0.8-0.6,1.7-2.4,3.3c-0.7,0.7-1.7,1.6-2.3,2.5c-0.2,0.3-0.5,0.5-0.9,0.5c-0.1,0-0.2,0-0.2,0c-0.5-0.1-1-0.2-1.8-0.2\r\n\t\tc-0.5,0-1,0-1.6,0h-0.8c-2.3,0.2-4.1,1.2-5.9,2.3c-1.4,0.8-3,1.8-4.9,2.1c-0.3,0-0.6,0-0.8,0c-1.9,0-3.6-0.8-5.1-1.4l-0.3-0.1\r\n\t\tc-1.3-0.6-2.5-1.1-3.9-1.2c-0.3,0-0.7-0.1-1.1-0.1c-0.9,0-1.8,0.1-2.8,0.4c-0.1,0-0.2,0.1-0.3,0.4c-0.1,0.4-0.5,0.7-0.9,0.7l0,0\r\n\t\tc-0.7,0-1.5-0.2-2.3-0.5h-0.1c-0.8-0.2-1.5-0.4-2.2-0.5c-0.2,0-0.5,0-0.7,0c-1.9,0-2.9,0.8-4,1.6c-0.9,0.7-1.9,1.4-3.3,1.7h-0.1\r\n\t\tl-1.1,0.1c-1.1,0.1-2.1,0.2-3.3,0.3l-0.8,0.1c-1.6,0.2-1.7,0.2-1.8,1.1v0.2c0,0.2-0.1,0.5-0.1,0.8c-0.1,0.5-0.2,0.9-0.3,1.4\r\n\t\tl-0.1,0.5c-0.4,2.6-0.8,4.8-4.1,5.2C458.8,652.9,458.5,652.9,458.3,652.9z\"/>\r\n\t<g>\r\n\r\n\t</g>\r\n\t<text transform=\"matrix(1 0 0 1 440.241 615.0635)\" class=\"label-active\">PR</text>\r\n</g>\r\n<g id=\"SP\">\r\n\t<g>\r\n\t\t<g>\r\n\t\t\t<path class=\"estado-active\" d=\"M528.9,623.9c-0.2,0-0.4-0.1-0.6-0.2c-0.3-0.2-0.8-0.2-1.1-0.2c-0.1,0-0.2,0-0.3,0s-0.2,0.1-0.3,0.1\r\n\t\t\t\tc-0.2,0-0.3,0-0.5-0.1c-0.4-0.3-0.7-0.7-1-1.1c-0.3-0.6-0.7-1.1-1.3-1.3c-0.6-0.3-1.2-0.4-2.1-0.4c-0.5,0-1,0-1.5,0.1\r\n\t\t\t\tc-0.2,0-0.3,0-0.5,0c-0.3,0-0.7,0.1-1,0.1c-0.2,0-0.3,0-0.5,0c-0.4,0-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1c0.1-0.2,0.3-0.4,0.4-0.6\r\n\t\t\t\tl0.2-0.3c1.2-1.5,1.8-2.4,1.5-3.2c-0.3-0.9-1.7-1.2-2.7-1.4c-0.9-0.1-1.9-0.2-3.1-0.2c-0.5,0-1,0-1.5,0h-1.4c-0.3,0-0.5,0-0.7,0\r\n\t\t\t\tc-0.5,0-1.1,0-1.8,0h-0.1c-0.6,0-1.3,0.1-1.9,0.1c-1.2,0-2-0.1-2.5-0.4c-1.4-0.8-1.4-2-1.4-3.4c0-0.7,0-1.4-0.1-2.2\r\n\t\t\t\tc-0.4-1.6-1.3-2.7-2.3-3.9l-0.2-0.3c-0.5-0.6-1-1.2-1.4-1.9c-1-1.7-0.9-3.7-0.8-5.6c0-0.9,0.1-1.8,0-2.7c-0.3-3.2-1.2-4.8-3-7.7\r\n\t\t\t\tc-0.6-0.8-1-1.8-1.4-2.7c-0.8-1.8-1.6-3.6-3.4-4.7c-2.2-1.5-4.5-1.7-6.8-1.7c-0.6,0-1.2,0-1.8,0c-0.5,0-1.1,0-1.7,0h-1.1\r\n\t\t\t\tc-1.3,0.1-2.5,0.1-3.6,0.1c-2.5,0-5.4-0.2-8.8-1.6c-3.2-1.5-6.4-2.3-9.8-3.2l-2.3-0.6c-2.1-0.6-4.2-0.8-6.6-0.8\r\n\t\t\t\tc-1.9,0-3.7,0.2-5.6,0.3l-0.8,0.1c-1.1,0.1-2.3,0.2-3.6,0.3c-0.3,0-0.5,0-0.8,0c-1.5,0-3-0.3-4.4-0.5h-0.1\r\n\t\t\t\tc-0.9-0.2-1.8-0.3-2.8-0.4c-0.4,0-0.7-0.3-0.9-0.7c-0.1-0.4,0-0.8,0.3-1.1l0.1-0.1c1.1-1,2.2-1.9,3.4-2.8\r\n\t\t\t\tc1.2-0.9,2.5-1.8,3.9-2.6c1.8-1.1,3.7-2.2,5.1-3.6c0.5-0.6,1-1.3,1.4-1.9c0.4-0.6,0.6-1,0.9-1.3l0.1-0.1c0.2-0.2,0.5-0.5,0.9-0.7\r\n\t\t\t\tl0.2-0.2c0.8-0.6,1.6-1.2,1.9-1.8c0.5-0.9,0.3-1.5,0-2c-0.2-0.5-0.3-0.8-0.2-1.1c0.1-0.5,0.4-0.9,1-1.1c0.3-0.1,0.7-0.3,1.2-0.8\r\n\t\t\t\tc0.8-1.1,0.6-2.7,0.3-4.3c-0.2-1.3-0.4-2.7,0.1-3.6c0.4-0.8,1.2-1.1,2-1.5c1.1-0.6,2.2-1.1,2.8-2.7c0.2-0.4,0.3-0.9,0.4-1.5\r\n\t\t\t\tc0.1-0.8,0.3-1.4,0.7-2.1c0.4-0.7,1.2-1.2,2-1.6c0.8-0.5,1.6-1,2.1-1.6c0,0,0-0.1,0.1-0.1c0.5-0.6,0.9-1.1,1.2-1.7l0.2-0.2\r\n\t\t\t\tc0.6-0.8,1.1-1.6,2.1-2.3c0.5-0.3,1.3-0.6,2.2-1c1.7-0.7,3-1.2,3.6-1.8c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.1-0.2\r\n\t\t\t\tl-0.1-0.4c-0.1-0.6-0.3-1.5-0.2-2.3c0.2-1.9,1.2-2.2,2.7-2.7c0.6-0.2,1.1-0.4,1.7-0.6c0.7-0.3,1.2-0.6,1.8-1l0.1-0.1\r\n\t\t\t\tc0.6-0.4,1.1-0.7,1.6-0.9c0.4-0.1,0.6-0.2,0.8-0.3c0.1,0,0.2,0,0.3,0c0.2,0,0.4,0,0.5,0.1c0.1,0.1,0.3,0.2,0.7,0.3\r\n\t\t\t\tc0.3,0.1,0.6,0.2,1,0.5s0.9,0.6,1.5,0.7c0.5,0.1,1.1,0.1,1.7,0.1s1.1,0,1.6-0.1c0.5,0,1-0.1,1.5-0.1c0.5,0,1.2-0.1,2-0.1h0.6\r\n\t\t\t\tc1.6-0.1,3.3-0.2,5.1-0.2c4.2,0,7,0.7,8.5,2.2c1,0.9,0.9,1.8,0.8,2.8c-0.1,0.8-0.1,1.7,0.3,2.5c0.5,1,1.2,1.6,2,1.6h0.1\r\n\t\t\t\tc0.4,0,0.8-0.2,1.1-0.5c0.2-0.2,0.4-0.3,0.7-0.3c0.1,0,0.2,0,0.2,0c0.3,0.1,0.6,0.3,0.7,0.6l0.1,0.3c0.1,0.2,0.1,0.4,0.2,0.5\r\n\t\t\t\tc0.4,1.2,0.8,2.3,1.5,2.5h0.1c0.1,0,0.2,0.1,0.4,0.1c0.2,0,0.4-0.1,0.6-0.2c0.8-0.6,1.2-2.3,1.3-5c0-0.5,0.4-0.9,0.8-1\r\n\t\t\t\ts0.8-0.1,1.3-0.1c0.7,0,1.5,0.1,2.3,0.2c0.8,0.1,1.6,0.2,2.4,0.2c0.5,0,1,0,1.5-0.1c0.9-0.1,1.8-0.3,2.9-0.5\r\n\t\t\t\tc1.2-0.3,2.3-0.5,3.4-0.6l0,0c0.3,0,0.7,0,1,0.1c0.4,0.1,0.8,0.1,1.1,0.1c0.2,0,0.4,0,0.6-0.1c0.7-0.2,1.1-0.6,1.4-1\r\n\t\t\t\tc0.2-0.2,0.4-0.5,0.8-0.6c0.3-0.1,0.5-0.1,0.8-0.1c0.5,0,1,0.1,1.4,0.1h0.2c0.4,0,0.9,0.1,1.4,0.1c0.7,0,1.2-0.1,1.6-0.3\r\n\t\t\t\tc0.1-0.1,0.3-0.1,0.4-0.1c0.3,0,0.5,0.1,0.7,0.3c0.4,0.4,0.9,0.8,1.5,1.3l0.2,0.1c1,0.8,1.9,1.6,2.4,2.5c0.4,0.7,0.4,1.4,0.5,2.2\r\n\t\t\t\tc0,0.3,0,0.7,0.1,0.9c0,0.1,0,0.1,0,0.2c0,1.6,0,3.2,0.2,3.5c0.1,0.1,0.1,0.1,0.2,0.2c0.6,0.7,1.3,0.8,1.8,0.9\r\n\t\t\t\tc0.5,0.1,0.9,0.6,0.9,1.1c0,0.2-0.1,0.6-0.3,1c-0.3,0.8-0.8,1.4-1.2,2c-0.6,0.8-1.1,1.5-1.3,2.3c0,0.1,0,0.2,0.1,0.2l0,0\r\n\t\t\t\tc0.1,0,0.3,0,0.4,0.1c0,0,0,0,0.1,0c0.1,0,0.2,0,0.3-0.1s0.3-0.1,0.5-0.1c0.2,0,0.3,0,0.4,0.1c0.3,0.1,0.5,0.4,0.5,0.7\r\n\t\t\t\tc0.1,0.4,0.1,0.8,0.1,1.1c0,0.5,0,1,0.1,1.3v0.1c0.5,2.7,2.3,3.8,3.8,4.8c1,0.6,2.2,1.1,3.4,1.5c1.3,0.4,2.5,0.9,3.4,1.5\r\n\t\t\t\tc1.1,0.8,1.3,1.2,1.4,1.5c0,0.1,0,0.2,0,0.3c0,0.4-0.2,0.8-0.7,1.5l-0.4,0.7c-1.4,2-1.9,3.6-1.8,5.8c0,0.4,0.1,0.9,0.2,1.4\r\n\t\t\t\tc0.2,1,0.4,1.9,0.1,2.9c-0.2,0.5-0.4,0.9-0.7,1.2c-0.3,0.4-0.6,0.7-0.7,1.4c0.1,0.6,0.8,3.1,1.4,3.8c0.4,0.5,0.7,0.5,0.9,0.5\r\n\t\t\t\tc0.1,0,0.2,0,0.4,0c0.1,0,0.3-0.1,0.5-0.1c0.2,0,0.4,0.1,0.6,0.1c1.3,0.6,2.4,1.8,2.6,3.1c0.1,0.7,0,1.6-1,2.4\r\n\t\t\t\tc0,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.1,0.1,0.2c1.2,0.8,1.9,2.1,1.8,3.5c0,0.1,0.1,0.2,0.2,0.2c0.5,0.1,1,0.1,1.5,0.1\r\n\t\t\t\tc1.8,0,3.3-0.4,5-0.9l0.6-0.2c0.6-0.2,1.2-0.3,1.9-0.5c0.1,0,0.3,0,0.4,0c0.2,0,0.4,0,0.6,0s0.4,0.1,0.6,0.1c0.3,0,0.7,0,1.1-0.4\r\n\t\t\t\tc0.5-0.4,0.6-1.1,0.7-1.8v-0.1c0.1-0.5,0.2-0.9,0.4-1.2c0.2-0.2,0.5-0.3,0.7-0.3c0.1,0,0.1,0,0.2,0c0.2,0,0.4,0.1,0.8,0.4\r\n\t\t\t\tc0.4,0.3,0.7,0.4,1.1,0.4c1.1,0,1.8-0.5,2.5-0.9c0.3-0.2,0.6-0.4,1.1-0.7c1.5-1,3.3-1.6,5.5-2.3c1.1-0.4,2.3-0.8,3.4-1.2l0.4-0.2\r\n\t\t\t\tl0.3-0.1c0.4-0.2,0.6-0.2,0.7-0.3c0.1,0,0.1,0,0.2,0c0.2,0,0.3,0,0.6,0.1c0.4,0.1,0.6,0.4,0.7,0.8c0,0,0,0.1,0.1,0.1l0.1,0.1\r\n\t\t\t\tc0.2-0.2,0.5-0.2,0.7-0.2c0.2,0,0.4,0,0.5,0.1c0.3,0.2,0.5,0.3,0.8,0.5c0.5,0.4,1.1,0.8,1.6,0.9c0.4,0.1,0.7,0.2,1.2,0.2\r\n\t\t\t\tc0.7,0,1.7-0.1,2.6-0.2c1-0.1,2.1-0.3,3-0.3c1.6,0,2.5,0.5,2.7,1.5c0.2,2.2-2.3,2.8-4.5,3.4c-0.6,0.2-1.3,0.3-1.8,0.5\r\n\t\t\t\tc-0.7,0.3-1.3,0.8-1.9,1.2l-0.1,0.1c-0.2,0.2-0.5,0.4-0.8,0.6c-0.2,0.1-0.4,0.2-0.8,0.4l-0.4,0.2c-0.4,0.2-1.1,0.5-1.3,0.6\r\n\t\t\t\tc0,0.1-0.1,0.1-0.1,0.2c-1.1,1-1,2.2-0.9,3.4c0,0.4,0,0.7,0,1.1c0,0,0,0.1,0.1,0.1c0.1,0.1,0.1,0.1,0.1,0.1\r\n\t\t\t\tc0.2,0,0.6-0.1,1.2-0.3c0.9-0.3,3-0.9,4.3-1h0.1c0.4,0,0.8,0.3,0.9,0.7c0.1,0.4,0,0.9-0.4,1.2c-1.3,0.9-4.5,1.7-6.8,2\r\n\t\t\t\tc-3.6,0.7-8.2,2.2-10.1,7.1c0,0.1,0,0.1,0,0.2c0,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.4,0c0.6,0,0.9,0.3,1,0.4c0.4,0.5,0.4,1.4,0,2.2\r\n\t\t\t\tc-0.2,0.4-0.9,1.6-2.3,1.7l0,0c-1.5,0-2-0.7-2.6-1.5c-0.6-0.9-1.4-1.8-3.2-1.8h-0.2c-0.5,0-1.3,0-2.1-0.1\r\n\t\t\t\tc-1.3-0.1-2.3-0.1-3.2-0.1c-1,0-1.7,0.1-2.1,0.2c-1,0.3-1.5,1-2,1.8l-0.9-0.5l0.8,0.6c-0.6,0.8-1.1,1.5-2,1.9\r\n\t\t\t\tc-1.1,0.3-2,0.3-2.9,0.4h-0.1c-1.6,0.1-2.9,0.2-4.4,1.3c-0.5,0.4-1.1,0.8-1.6,1.2l-0.7,0.5c-1.3,0.9-2.7,1.9-3.9,3.1l-1.1,1\r\n\t\t\t\tc-1.3,1.2-2.4,2.3-4.1,3.1c-0.4,0.2-0.9,0.4-1.4,0.6l-0.8,0.4c-0.5,0.2-1,0.4-1.5,0.7l-0.3,0.2c-0.9,0.4-2.1,1-2.9,2\r\n\t\t\t\tc-0.2,0.3-0.2,0.6-0.2,1c0.1,0.3,0.1,0.7-0.2,1c-0.9,1-2.4,1.6-3.8,2.1c-1.7,0.6-3.6,1.3-4.3,2.9c-0.3,0.6-0.2,1.1-0.1,1.7\r\n\t\t\t\tc0.1,0.6,0.1,0.9,0,1.2c0,0,0,0.1-0.1,0.1c-0.3,0.5-0.6,0.6-1,0.8C529.2,623.8,529.1,623.9,528.9,623.9z\"/>\r\n\r\n\t\t</g>\r\n\t</g>\r\n\t<g>\r\n\t\t<text transform=\"matrix(1 0 0 1 501.2632 568.0339)\" class=\"label-active\">SP</text>\r\n\t</g>\r\n</g>\r\n<g id=\"MG\">\r\n\t<g>\r\n\t\t<path class=\"estado-active\" d=\"M562.5,577.4c-0.2,0-0.5,0-0.7,0c-0.5,0-0.8-0.4-0.9-0.9c-0.1-0.8-0.5-1.6-1.1-2.2c-0.3-0.3-0.4-0.8-0.1-1.2\r\n\t\t\tc0.4-0.6,0.5-1.2,0.4-1.9c-0.2-1.4-1.3-2.8-2.8-3.4c-0.2-0.1-0.5-0.1-0.7-0.1c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.1,0-0.2,0\r\n\t\t\tc-0.2,0-0.4-0.1-0.6-0.2c-0.1-0.1-0.2-0.2-0.2-0.3c-0.2-0.3-0.5-1-1-2.6c-0.1-0.2-0.1-0.3-0.1-0.3c-0.1-0.2-0.1-0.4-0.1-0.6\r\n\t\t\tc0.1-0.4,0.3-0.7,0.6-1.1c0.3-0.4,0.6-0.8,0.8-1.4c0.3-1.1,0.1-2.1-0.1-3l-0.1-0.4c-0.1-0.3-0.1-0.7-0.2-1.1\r\n\t\t\tc-0.2-2.1,0.3-3.7,1.7-5.5l0.4-0.6c0.6-0.8,0.9-1.5,0.8-2c-0.1-0.6-0.6-1.2-1.6-1.8c-0.9-0.7-2.2-1.1-3.4-1.5\r\n\t\t\tc-1-0.4-2.3-0.8-3.3-1.4c-1.8-1.1-3.2-2.2-3.7-4.6c-0.1-0.3-0.1-0.7-0.1-1.1v-0.2c0-1,0-1.7-0.5-2.2c-0.1-0.1-0.2-0.1-0.3-0.2\r\n\t\t\tc-0.3-0.1-0.6-0.3-0.7-0.6s0-0.7,0.2-0.9l0.2-0.3c0.5-0.6,0.9-1.3,1.2-2.1c0.4-1.1,0.4-1.8,0.2-2.1s-0.5-0.4-1-0.5\r\n\t\t\ts-1.1-0.1-1.6-0.6c-0.2-0.2-0.3-0.4-0.3-0.7v-0.7c0-0.9-0.1-2.1-0.1-2.3c0-0.3-0.1-0.6-0.1-0.9v-0.1c-0.1-0.8-0.1-1.6-0.5-2.3\r\n\t\t\tc-0.5-0.9-1.5-1.8-2.5-2.6l-0.1-0.1c-0.9-0.7-1.8-1.5-2.3-2.2c-0.1-0.1-0.2-0.2-0.2-0.2c0,0.3-0.3,0.6-0.5,0.8\r\n\t\t\tc-0.3,0.2-0.7,0.3-1.4,0.3c-0.5,0-1.2-0.1-1.6-0.1h-0.1c-0.5,0-1-0.1-1.4-0.1s-0.8,0-0.9,0.1c-0.4,0.2-0.7,0.4-0.9,0.7\r\n\t\t\tc-0.3,0.3-0.6,0.7-1.2,0.9c-0.2,0-0.3,0.1-0.5,0.1c-0.3,0-0.7-0.1-1.1-0.1c-0.2,0-0.3,0-0.5,0s-0.5,0-0.7-0.1\r\n\t\t\tc-1.2,0.1-2.4,0.4-3.4,0.6c-0.8,0.2-1.8,0.4-2.9,0.5c-0.4,0.1-0.9,0.1-1.4,0.1c-0.8,0-1.6-0.1-2.4-0.2c-0.9-0.1-1.6-0.2-2.3-0.2\r\n\t\t\tc-0.9,0-1.7,0.1-2.4,0.4c-0.1,0-0.1,0.2-0.1,0.2c0,2.8-0.3,4.1-0.5,4.7v0.2c0,0.4-0.3,0.8-0.7,0.9c-0.1,0-0.2,0-0.3,0\r\n\t\t\tc-0.3,0-0.6-0.2-0.8-0.4c-0.2-0.3-0.4-0.8-0.7-1.8c-0.4-1.2-0.8-2.4-1.7-2.8h-0.1c-0.1,0-0.1,0.1-0.1,0.1c-0.2,0.8-1,1.5-1.6,1.5\r\n\t\t\th-0.1c-0.6-0.1-1.1-0.6-1.5-1.4c-0.4-0.8-0.3-1.6-0.3-2.3c0.1-1.1,0.1-2.1-1-3.1c-1.6-1.6-4.4-2.4-8.7-2.4c-1.9,0-3.8,0.1-5.4,0.3\r\n\t\t\tc-0.9,0.1-1.7,0.1-2.4,0.2c-0.5,0-1,0-1.5,0.1c-0.5,0-1.1,0.1-1.6,0.1c-0.6,0-1.2,0-1.7-0.1s-0.9-0.3-1.3-0.6\r\n\t\t\tc-0.5-0.3-0.9-0.6-1.4-0.7c-0.2,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.3-0.2-0.3-0.2c-0.3,0-0.9,0.2-1.5,0.4s-1.2,0.6-1.8,1\r\n\t\t\tc-0.6,0.4-1.2,0.8-1.8,1c-0.4,0.2-0.9,0.4-1.3,0.5l-0.3,0.1c-0.6,0.2-1.2,0.4-1.7,0.7c-0.2,0.1-0.3,0.2-0.5,0.2\r\n\t\t\tc-0.1,0-0.3,0-0.4-0.1c-0.3-0.1-0.5-0.4-0.6-0.8v-0.3c-0.1-1-0.3-2.1-0.1-3.2c0.1-0.7,0.5-1.3,1-1.9l0.1-0.1c0.5-0.6,0.9-1.2,1-2\r\n\t\t\tc0-0.5,0.5-0.9,1-0.9c1.2-0.1,2.1-0.3,2.7-1.3c0.2-0.5,0.1-1.1-0.1-1.7c-0.3-1-0.3-1.5-0.1-1.8c0.1-0.3,0.4-0.6,0.9-0.7h0.1\r\n\t\t\tc0.3,0,0.7,0,1.3-0.5c1.3-1.1,2.4-2.6,3.4-4.1l0.2-0.2c1.7-2.4,3.4-4.6,5.9-5.7c2.1-0.9,4.5-1.3,6.9-1.7h0.1\r\n\t\t\tc1.6-0.2,3-0.4,4.4-0.8c0.1,0,0.4-0.1,0.9-0.3c0.2-0.1,0.6-0.2,0.9-0.3c0.1,0,0.2,0,0.3,0c0.3,0,0.5,0.1,0.7,0.3l0.3,0.3\r\n\t\t\tc0.4,0.4,0.7,0.6,0.9,0.6c1.2,0,2.1-0.7,3.1-1.5l0.1-0.1c0.4-0.3,0.9-0.7,1.5-1.1c0.9-0.5,1.6-0.8,2.4-0.8c0.3,0,0.7,0,1.1,0.1\r\n\t\t\tl0.9,0.1c0.1,0,0.3,0,0.4,0c1.3,0,2.4-0.2,3.5-0.4c0.8-0.2,1.9-0.3,3-0.4l2-0.1c1.5-0.1,3.1-0.2,4.6-0.2c1.9,0,3.4,0.1,4.7,0.4\r\n\t\t\tc0.6,0.1,1.1,0.6,1.5,1c0.6,0.6,1.2,1.1,2,1.2h0.2c1.4,0,4.2-2.1,4.7-2.8c0.6-0.8,0.8-1.2,1-1.6c0.3-0.7,0.6-0.9,1.9-1.6l0.6-0.3\r\n\t\t\tc1.9-0.9,3.6-1.7,3.8-4.5c0.1-0.6-0.1-1.3-0.2-1.9l-0.1-0.4c-0.1-0.3-0.1-0.6-0.1-0.7s0-0.2,0-0.3c0.1-0.5,0.2-0.9,0.4-1.3\r\n\t\t\ts0.3-0.8,0.4-1.3c0.6-2.9-0.6-3.4-1.9-4c-0.6-0.3-1.1-0.5-1.6-0.9c-0.2-0.2-0.4-0.5-0.4-0.8s0.1-0.6,0.3-0.8\r\n\t\t\tc0.5-0.5,1.1-0.9,1.7-1.3l0.2-0.2c1.2-0.9,2.6-1.9,3.6-3.4c1.3-2.1,1-2.6-0.2-4c-0.2-0.2-0.4-0.5-0.7-0.8\r\n\t\t\tc-0.9-1.2-1.5-2.7-2.2-4.4c-0.6-1.7-1.3-3.4-2.4-4.8c-0.2-0.3-0.3-0.7-0.1-1c0.1-0.2,0.3-0.4,0.5-0.5l0,0c1-0.5,2.1-1.1,2.7-2\r\n\t\t\tc0.5-0.8,0.3-1.6,0.2-2.2c-0.1-0.5-0.2-0.9,0-1.4c0.6-1.6,4.1-2.9,6-3.3l0.9-0.2c2.6-0.5,4.4-1.1,3.8-4.2\r\n\t\t\tc-0.2-1.3-1.3-4.2-2.8-5.4c-0.4-0.3-0.5-0.8-0.2-1.2c0.8-1.4,1.6-3.2,1.9-4.3c0.2-0.9,0.1-1.6,0-2.2c-0.1-0.1-0.1-0.3-0.1-0.4\r\n\t\t\tc0-0.4,0.2-0.8,0.6-1c0.2-0.1,0.6-0.2,1.7-0.4h0.1c0.4,0,0.7,0.1,0.9,0.2s0.5,0.2,0.7,0.2s0.7,0,1.2-1c0.6-0.9,0.3-1.7-0.1-2.5\r\n\t\t\tc-0.3-0.5-0.4-0.8-0.4-1.1c0-0.3,0-0.5,0.2-0.7s0.4-0.3,0.7-0.4h0.2c0.2,0,0.4,0,0.5,0c0.4,0,0.8,0,1.2,0.4\r\n\t\t\tc0.3,0.2,0.4,0.6,0.4,0.9v0.1c0,0.4-0.1,0.9,0.2,1.1l0.1,0.1c0.3,0.3,0.7,0.4,1.2,0.4c0.1,0,0.3,0,0.4,0c0.2,0,0.4,0,0.6,0\r\n\t\t\tc0.5,0,1,0.4,1,0.9c0,0.2,0,0.5,0,0.7c0,0.4,0,0.9,0.1,1.2c0,0.1,0.1,0.1,0.2,0.1c0.5-0.1,0.9-0.2,1.2-0.3l0.3-0.1\r\n\t\t\tc0.2-0.1,0.4-0.1,0.6-0.1c0.1,0,0.1,0,0.1,0c0.4,0,0.8,0.3,1,0.7c0,0,0,0.1,0.1,0.1c0.3,0.2,0.4,0.4,0.5,0.7c0.1,1,0,2.7-0.4,4\r\n\t\t\tc0,0.1,0,0.2,0.1,0.2c0,0,0,0,0.1,0c0.2-0.1,0.4-0.2,0.6-0.2l0,0c0.1,0,0.1,0,0.2-0.1c1.5-1.8,3.8-2.5,6.3-3.2\r\n\t\t\tc2.1-0.6,4.4-1.3,6.3-2.8c2-1.7,4.1-3.5,6.8-4.8c0.5-0.2,1-0.4,1.4-0.6c2.2-0.9,3.4-1.5,5-3.9c0.4-0.6,0.4-0.8,0.4-0.8\r\n\t\t\tc0-0.2,0.1-0.3,0.3-0.5s0.4-0.3,0.8-0.6c0.6-0.4,1.4-0.5,2.3-0.7c1-0.2,1.8-0.3,2.5-0.7l1-0.5c0.8-0.4,1.3-0.7,2.3-0.7\r\n\t\t\tc0.4,0,0.9,0,1.6,0.1c0.4,0.1,0.9,0.1,1.5,0.1c0.5,0,0.9,0,1.4,0s1,0,1.6,0c1.8,0,2.9,0.2,3.6,0.6c0.1,0.1,0.3,0.1,0.3,0.2\r\n\t\t\tc0.3,0.2,0.6,0.5,0.6,0.9c0,0.2-0.1,0.5-0.2,1.1c-0.1,0.4-0.5,0.7-1,0.7h-0.4c-0.3,0-0.6,0-0.9-0.1l0,0c-0.1,0-0.2,0-0.2,0.1\r\n\t\t\tc-0.6,0.9-0.3,2,0,3c0.2,0.8,0.5,1.7,0.2,2.6c0,0.1,0,0.2,0,0.3c0,0.1,0.1,0.1,0.1,0.1l0.4-0.1c0.9-0.1,1.6-0.2,2.2-0.2\r\n\t\t\tc1.1,0,1.9,0.3,2.8,0.9c0.4,0.2,0.6,0.4,0.8,0.6c0.3,0.3,0.5,0.5,1.4,0.8c0.1,0,0.2,0,0.3,0c0.2,0,0.5-0.1,0.7-0.2\r\n\t\t\tc0.1-0.1,0.3-0.1,0.4-0.1c0.3,0,0.5,0.1,0.7,0.3h0.1c0.1,0,0.2-0.1,0.2-0.2c0-0.4,0-0.8-0.1-1.2c-0.1-1.2-0.2-2,0.8-2.5\r\n\t\t\tc0.3-0.2,0.7-0.2,1.2-0.2c1.2,0,3,0.4,4.6,1c0.8,0.3,1.1,0.8,1.4,1.2c0.2,0.3,0.5,0.7,0.9,0.9h0.1c1,0.6,1.7,0.7,2.2,0.8\r\n\t\t\tc1,0.2,1.5,0.4,2.6,1.8c2.2,2.7,4.3,2.8,7.2,3c0.8,0,1.6,0.1,2.4,0.2c2.2,0.2,3.6,0.8,4.7,1.2c1.3,0.5,2.4,0.9,4.2,1.1\r\n\t\t\tc2.5,0.3,3.4,1.7,4.6,3.8l0.1,0.2c0.2,0.3,0.3,0.6,0.6,0.9c0.9,1,1.7,2.2,2.3,3.2c0,0.1,0.1,0.1,0.1,0.2c0.1,0.3,0.2,0.6,0.2,0.9\r\n\t\t\tc0.3,1.4,0.6,2.4,1.1,3c0.3,0.2,1.1,0.4,2.3,0.4c0.7,0,1.3-0.1,1.6-0.1c0.8-0.3,1.4-1.1,1.8-1.7l0.1-0.2c0.1-0.3,0.4-0.6,0.7-0.7\r\n\t\t\tc0.2,0,0.4-0.1,0.7-0.1c2.1,0,7.3,1.4,9.4,2.4c2.4,1,10.6,4.8,11,8c0.1,0.5-0.1,1-0.5,1.5c-0.2,0.2-0.5,0.3-0.8,0.3h-0.1l0,0\r\n\t\t\tc-0.1,0-0.1,0-0.2,0c-0.1,0.1-0.1,0.2,0,0.3c0.3,0.3,0.5,0.6,0.5,0.8c0,0.1,0,0.3,0,0.4c-0.1,0.5-0.5,1-1.4,1.7l-0.2,0.1\r\n\t\t\tc-0.3,0.3-0.7,0.6-0.9,0.9c-0.3,0.4-0.4,0.7-0.5,1.1v0.1c-0.2,0.4-0.3,0.8-0.7,1.1c-0.3,0.3-0.7,0.4-1.1,0.6\r\n\t\t\tc-0.4,0.2-0.9,0.3-1.3,0.8c-0.3,0.5-0.4,1.2-0.4,1.7c0,0.2,0,0.4,0,0.5c0,0.2,0,0.4-0.2,0.6c-0.2,0.3-0.5,0.4-0.8,0.5\r\n\t\t\ts-0.7,0.2-0.9,0.5l-0.1,0.1c-1.5,0.9-2.8,1.8-3.3,3.4c-0.1,0.2-0.2,0.4-0.4,0.5c-0.1,0-0.1,0.1-0.1,0.2c0.4,2,0.4,4.7,0,8\r\n\t\t\tc0,0,0,0.1,0.1,0.1h0.1c0.1,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0.3,0,0.6,0.2,0.8,0.4c0.2,0.3,0.3,0.7,0.4,1.4l-1,0.3l1-0.2\r\n\t\t\tc0.1,0.8,0.3,1.6,0.9,2.2c0.5,0.4,1.1,0.6,1.8,0.8c1.2,0.4,2.2,0.6,2.5,2.2v0.1c0,0.7-0.1,1.2-0.4,1.5c-0.4,0.4-1,0.6-2,0.6\r\n\t\t\tc-0.5,0-1,0-1.5-0.1H681c-0.5,0-1.1-0.1-1.6-0.1h-0.2c-1.9,0-3.7,0.1-5.6,1.4c-0.1,0.1-0.1,0.2-0.1,0.2c0.1,0.5-0.2,1-0.6,1.1\r\n\t\t\tl-0.4,0.2c-3.9,1.6-7.2,3.4-5.6,7.2l0.1,0.1h0.1c0.1-0.1,0.3-0.1,0.4-0.1c0.2,0,0.4,0.1,0.6,0.2c0.6,0.4,1.2,1.4,1.5,6.2\r\n\t\t\tc0,0,0,0.7,0,0.8c0,0.4-0.3,0.8-0.7,0.9c-0.3,0.1-0.7,0.2-1.1,0.3c-1.2,0.4-2.1,0.6-2.4,1.4c-0.3,0.8,0.3,1.9,0.7,2.7\r\n\t\t\tc0,0.1,0.1,0.1,0.2,0.1c0,0,0.1,0,0.2-0.1l0,0c0,0,0,0,0-0.1c0.1-0.4,0.4-0.6,0.8-0.7c0.1,0,0.1,0,0.2,0c0.3,0,0.6,0.2,0.8,0.4\r\n\t\t\tc0.8,1.1,0.5,2.3,0.1,3.9l-0.3,1.4c-0.3,1.1-0.5,2.2-0.4,3.3c0.1,0.5,0.3,0.9,0.6,1.3l0.2,0.3c0.3,0.4,0.5,0.8,0.4,1.2\r\n\t\t\tc-0.2,0.8-0.9,1.4-1.9,2.2l-0.1,0.1c-0.6,0.5-1.2,0.9-1.5,1.4c-0.8,1.2-1.2,2.7-1.6,4.2c-0.3,1.3-0.7,2.6-1.3,3.7\r\n\t\t\tc-0.2,0.3-0.4,0.4-0.7,0.5c-0.1,0-0.1,0-0.2,0c-0.2,0-0.5-0.1-0.7-0.2c-0.2-0.2-0.6-0.4-1-0.5c-0.2,0-0.5-0.1-0.7-0.1\r\n\t\t\tc-2,0-4.6,1.1-5.2,2.3c0,0,0,0.1-0.1,0.1c-0.8,1.1-1.6,4.4-1.1,5.9c0.1,0.5,0.5,0.8,0.9,1.2c0.1,0.1,0.2,0.2,0.2,0.2\r\n\t\t\tc0.2,0.2,0.3,0.5,0.2,0.8c0,0.3-0.2,0.5-0.4,0.7c-0.7,0.4-1.1,1-1.5,1.6l-0.1,0.1c-0.4,0.6-0.9,1.2-1.6,1.8\r\n\t\t\tc-0.4,0.3-0.8,0.5-1.1,0.6l-0.1,0.1c-0.7,0.3-1.6,0.7-2,1.5c0,0,0,0.1-0.1,0.1c-0.7,0.8-0.6,1.8-0.6,2.6c0,0.6,0,1.3-0.2,2\r\n\t\t\ts-0.7,1.2-1.3,1.8c-0.5,0.5-0.9,0.9-1.2,1.5c-0.9,1.4-0.8,3-0.8,4.6v0.7c0.1,2.5,0,3.3-2.4,3.6c-0.8,0.1-1.5,0.2-2.5,0.5\r\n\t\t\tc-1.6,0.5-3.1,1.4-4.5,2.3l-0.4,0.2c-1.9,1.2-3.9,2.4-6.1,2.4c-0.3,0-0.6,0-0.9-0.1c-0.6,0-1.3-0.3-1.9-0.6h-0.1\r\n\t\t\tc-0.7-0.3-1.5-0.6-2.3-0.6c-1.2,0-2.2,0.4-3.2,0.7c-0.6,0.2-1.2,0.4-1.9,0.6c-0.9,0.2-1.8,0.3-2.8,0.4c-1.5,0.1-2.9,0.3-4.4,1\r\n\t\t\tl-0.8,0.5c-1.4,0.9-2.5,1.4-4.1,1.9c-1.1,0.3-2.2,0.4-3.2,0.5l-0.6,0.1c-3.2,0.4-6,0.8-8.4,3.1c-0.2,0.2-0.4,0.3-0.7,0.3\r\n\t\t\tc-0.1,0-0.2,0-0.3-0.1c-0.6-0.2-1-0.3-1.3-0.3s-0.6,0.1-1.3,0.4l-0.4,0.2c-1,0.4-2,0.7-2.9,1.1l-0.5,0.2c-2,0.6-4,1.3-5.6,2.3\r\n\t\t\tc0,0-0.1,0-0.1,0.1c-0.4,0.2-0.8,0.5-1.1,0.7c-0.7,0.5-1.3,0.9-2.2,0.9c-0.1,0-0.2,0-0.2,0c-0.1,0-0.3-0.1-0.7-0.3\r\n\t\t\ts-0.8-0.5-1.3-0.5c-0.1,0-0.2,0-0.4,0.1c-0.9,0.3-1.1,1-1.2,1.9v0.1c-0.1,0.6-0.2,1.1-0.6,1.4c-0.1,0.1-0.4,0.3-0.9,0.3\r\n\t\t\tc-0.1,0-0.3,0-0.5-0.1c-0.3,0-0.5-0.1-0.7-0.1s-0.3,0-0.5,0.1h-0.1c-0.6,0.1-1.3,0.3-1.9,0.5l-0.5,0.1l-0.4,0.1\r\n\t\t\tC565.5,577,564.1,577.4,562.5,577.4z\"/>\r\n\t\t<text transform=\"matrix(1 0 0 1 585.9246 493.9873)\" class=\"label-active\">MG</text>\r\n\t</g>\r\n\r\n</g>\r\n<g id=\"MS\">\r\n\t<g>\r\n\t\t<path class=\"estado-active\" d=\"M402,600.2c-0.3,0-0.6-0.2-0.8-0.5c-1.7-2.6-4.7-3.6-7.4-4.2c-1.2-0.2-2-0.4-2.8-0.4c-1.2,0-2,0.4-3.6,1.7\r\n\t\t\tc-0.7,0.6-1.6,1-2.6,1.5l-0.2,0.1c-0.1,0.1-0.3,0.1-0.4,0.1c-0.3,0-0.6,0-1,0c-0.5,0-1.1,0.1-1.6,0.1c-1.2,0-1.9-0.2-2.4-0.5\r\n\t\t\tc-1.4-1.2-1.2-3.3-1-5v-0.3c0-0.5,0.1-0.9,0.1-1.3c0-2.1-0.7-3.5-1.5-5.1c-0.4-0.7-0.6-1.2-0.9-1.8c-1.1-2.5-1-4.4-0.8-6.9\r\n\t\t\tl0.1-1.1c0.1-2.8-1.2-4.7-2.7-6.9l-0.6-0.8c-0.4-0.5-0.6-1.2-0.9-1.8c-0.3-0.7-0.6-1.4-1-1.9c-1.3-1.5-3.4-1.6-5.5-1.6h-0.1\r\n\t\t\tc-0.8,0-1.6,0-2.3-0.2s-1.4-0.7-2.2-1.3c-0.9-0.7-2-1.6-3.2-1.6c-0.3,0-0.6,0.1-0.9,0.2c0,0-0.1,0-0.1,0.1s0,0.1,0,0.1\r\n\t\t\tc0.1,0.2,0.1,0.3,0.1,0.4c0.1,0.3,0,0.7-0.2,1c-0.3,0.4-1,0.8-3.4,0.8c-1.2,0-2.7-0.1-4.6-0.3l-0.6-0.1c-0.2,0-0.4,0-0.6,0\r\n\t\t\tc-1.1,0-2.3,0.4-3.5,0.7l-0.3,0.1c-1.3,0.4-2.6,0.7-3.7,0.7c-0.6,0-1-0.1-1.5-0.3c-0.4-0.1-0.7-0.5-0.9-1l-0.1-0.1\r\n\t\t\tc-0.3-0.4-0.5-0.7-0.8-0.9c-0.7-0.5-1.4-0.8-2.2-1.1c-0.4-0.2-0.9-0.3-1.5-0.6c-0.1,0-0.9-0.3-1.2-0.3l-0.6-0.2\r\n\t\t\tc-1.6-0.4-2.2-0.6-2.4-0.8c-0.1-0.1-0.2-0.1-0.3-0.2c-0.6-0.7-0.6-2-0.4-3.9c0.1-0.6,0.1-1.1,0.1-1.6c0-1-0.2-2-0.4-3\r\n\t\t\tc-0.4-2.2-0.8-4.2,0.6-6c0.5-0.5,0.8-0.8,1.1-1l0.1-0.1c0.7-0.5,0.8-0.7,0.8-2.5c0-2.2-0.1-3.3-0.3-3.8c-0.4-0.8-1-1.1-1.5-1.3\r\n\t\t\tc-0.4-0.2-0.8-0.4-1.1-0.7c-0.9-1.1-1.2-2.8-1.3-4.3c-0.1-0.5-0.1-1-0.2-1.4c-0.2-1.2-0.7-2.3-1.2-3.3c-0.9-1.8-1.6-3.2-0.1-5\r\n\t\t\tc0.3-0.4,0.7-0.6,1-0.9c1.1-0.9,1.9-1.7,1.8-3c-0.1-1.1-0.8-1.4-1.7-1.8c-0.6-0.2-0.9-0.3-1.1-0.6c-1.2-1.6-0.5-3.5,0.1-5.1\r\n\t\t\tl0.1-0.1c0.1-0.4,0.3-0.8,0.4-1.1c0.2-0.6,0.3-1.2,0.5-2c0.2-1.2,0.4-2.6,1.2-3.5l0.1-0.1c0.5-0.4,1-0.6,1.6-0.8\r\n\t\t\tc0.7-0.2,1.2-0.4,1.8-0.9c1.5-1.4,1.2-3.3,0.9-5.1l-0.1-0.4c-0.4-2.5-0.6-3.6,0.6-6.1c0.3-0.7,0.5-1.5,0.6-2.3\r\n\t\t\tc0.2-0.8,0.3-1.5,0.6-2.1c0.3-0.7,0.8-1,1.4-1.4c0.5-0.3,0.9-0.6,1.4-1.1c0-0.1,0.1-0.1,0-0.2c0-0.1-0.1-0.1-0.1-0.1\r\n\t\t\tc-1-0.4-1.5-1.7-2.3-4.3c-0.4-1.4-0.8-2.7-1.3-3.4c-1.1-1.8-1.3-2.2-1.6-4l-0.1-0.5c-0.1-0.5-0.1-1-0.3-1.5\r\n\t\t\tc-0.2-0.4,0-0.9,0.3-1.2c0.4-0.3,0.6-0.7,0.8-1c0.1-0.2,0.2-0.4,0.4-0.6c0.2-0.2,0.5-0.4,0.8-0.4c0.2,0,0.4,0,0.5,0.1\r\n\t\t\tc0.3,0.2,0.8,0.6,2.1,2.1l0.6,0.7c0.2,0.3,0.5,0.6,0.7,0.9c0.7,1,1.5,2.2,3.2,2.5c0.3,0.1,0.5,0.1,0.8,0.1c1.2,0,2.3-0.6,3.3-1.1\r\n\t\t\tl0.2-0.1c0.4-0.2,0.8-0.4,1.2-0.6c1.9-0.8,2.9-2.1,3.9-3.4c0.8-1,1.6-2.1,2.8-3c1.5-1,2.5-1,4-1c0.5,0,1.1,0,1.9-0.1\r\n\t\t\tc2.4-0.2,5.6-1,6.5-2.4c0.2-0.3,0.5-0.5,0.9-0.5h0.2c1.7,0,4.6,1.2,7.5,2.6l0.6,0.3c0.6,0.3,1.1,0.5,1.5,0.6\r\n\t\t\tc2.4,0.8,3.8,1.8,5.5,3.1l0.8,0.6c1.7,1.2,2.8,1.5,4.1,1.5c0.7,0,1.5-0.1,2.6-0.2c1-0.1,1.9-0.2,2.9-0.2h0.1\r\n\t\t\tc1.7-0.1,3.3-0.2,5-0.6c0.3-0.1,0.5-0.2,0.7-0.3c0.5-0.3,0.8-0.4,1.5-0.4c0.6,0,1.2,0.1,1.8,0.3h0.1c0.6,0.1,1.2,0.3,1.8,0.3\r\n\t\t\tc3-0.1,6.7-1.3,10.7-3.7c0.2-0.1,0.3-0.1,0.5-0.1c0.1,0,0.2,0,0.3,0.1c0.3,0.1,0.5,0.3,0.6,0.6c1.1,2.7,1.2,5.4,0.3,8.2\r\n\t\t\tc-0.1,0.4-0.3,0.8-0.4,1.1c-0.4,0.9-0.6,1.4-0.3,1.9c0.2,0.6,1,0.9,1.7,1.2c0.7,0.3,1.6,0.3,2.4,0.3h0.9c0.3,0,0.5,0,0.8,0\r\n\t\t\tc0.7,0,1.2,0,1.5,0.1h0.1l1.1,0.4c2.3,0.9,2.6,1.1,2.8,1.2c0.3,0.2,0.5,0.4,0.7,0.6l0.1,0.1c0.2,0.2,0.3,0.3,0.4,0.5\r\n\t\t\tc0.5,0.6,1,1.2,2.4,1.7l0.9,0.3c2.1,0.8,3.4,1.3,3.8,2.2l0.1,0.2c0.2,0.3,0.2,0.6,0.1,0.8c-0.1,0.2-0.2,0.3-0.3,0.6l-0.1,0.2\r\n\t\t\tc-0.3,0.4-0.6,0.8-0.9,1.5c0,0.1,0,0.2,0.1,0.2c1.2,1,2.8,1.3,4.2,1.6c1.1,0.2,2,0.4,2.8,0.8c2,0.8,3.8,2.2,5.5,3.5l0.7,0.6\r\n\t\t\tc2.5,1.8,4.2,2.3,6.8,3.1l1.6,0.5c1.5,0.4,2.8,1.2,4.2,2c0.9,0.5,1.9,1.1,2.9,1.6c0.9,0.4,2.1,0.7,3.3,0.9c2.3,0.5,4.4,1,5.3,1.8\r\n\t\t\tc0.3,0.3,0.6,0.8,1.1,1.6c0.2,0.4,0.2,0.8-0.1,1.1c0,0-0.1,0.1-0.1,0.2s0.1,0.1,0.2,0.1c0.3,0.1,0.6,0.3,0.7,0.5\r\n\t\t\tc0.1,0.3,0.1,0.6,0,0.9c-0.2,0.4-0.4,0.8-0.7,1.1c-0.5,0.6-1,1.3-1.1,2.2c-0.2,1.1,0,2.3,0.1,3.4c0.2,1.2,0.3,2.3,0.2,3.5\r\n\t\t\tc0,0.1,0.1,0.1,0.1,0.2c0.2,0.2,0.4,0.4,0.4,0.7s0.1,0.6,0.2,0.9c0.1,0.4-0.1,0.8-0.4,1c-0.5,0.4-1.6,0.9-3.2,1.5\r\n\t\t\tc-0.9,0.4-1.8,0.7-2.3,1c-1.1,0.8-1.7,1.7-2.3,2.6c-0.3,0.5-0.7,1.1-1.3,1.8c-0.5,0.7-1.2,1.1-1.9,1.5l-0.1,0.1\r\n\t\t\tc-0.8,0.4-1.7,0.9-2.1,1.7c-0.5,0.7-0.6,1.4-0.8,2.1v0.1c-0.1,0.4-0.1,0.9-0.3,1.4c-0.6,1.4-1.6,2-2.6,2.5\r\n\t\t\tc-0.8,0.4-1.7,0.8-2.2,1.7c-0.6,1-0.4,2.3-0.2,3.7v0.2c0.2,1.5,0.5,3-0.2,4l-0.1,0.1c-0.4,0.4-0.7,0.5-1,0.6\r\n\t\t\tc-0.4,0.1-0.9,0.3-1.2,1.4c-0.1,0.6,0,1,0.2,1.4c0.3,0.6,0.3,1,0,1.7c-0.2,0.4-0.8,0.9-1.7,1.6l-0.1,0.1c-0.5,0.4-0.9,0.7-1.2,1\r\n\t\t\tc-0.3,0.3-0.6,0.8-0.9,1.3c-0.4,0.7-0.8,1.3-1.3,1.8c-1.4,1.3-3.1,2.4-5.1,3.5l-0.6,0.4c-1.2,0.7-2.5,1.5-3.5,2.4\r\n\t\t\tc-1.4,1-2.7,2.2-4.1,3.4c-0.5,0.5-1.1,0.9-1.6,1.4c-0.1,0.1-0.3,0.2-0.5,0.2c-1.1,0.2-2,0.5-2.9,1c-1.1,0.7-2.1,1.6-3,2.6\r\n\t\t\tc-0.5,0.5-0.9,0.9-1.4,1.3c-0.8,0.7-1.7,1-2.5,1.2l-0.2,0.1c-0.6,0.2-1.2,0.4-1.8,0.7c-1.9,1-2.4,2.9-2.8,4.8\r\n\t\t\tc-0.3,1.1-0.5,2.4-1.3,3.5c-0.3,0.6-0.9,1.2-1.5,1.8l-0.1,0.1c-0.6,0.7-1.3,1.3-1.6,2c-0.4,0.8-0.6,1.8-0.7,2.8v0.1\r\n\t\t\tc-0.2,1.1-0.3,2-0.7,2.8c-0.9,2.1-2.2,4-3.4,5.6C402.6,600.1,402.3,600.2,402,600.2L402,600.2z\"/>\r\n\r\n\t</g>\r\n\t<text transform=\"matrix(1 0 0 1 378.3531 528.0087)\" class=\"label-active\">MS</text>\r\n</g>\r\n<g id=\"RJ\">\r\n\t<g>\r\n\t\t<path class=\"estado-active\" d=\"M607.7,578.9c-0.3,0-0.5-0.1-0.7-0.3c-0.3-0.3-0.4-0.9-0.1-1.3c0.1-0.2,0.2-0.3,0.2-0.6c0-0.1,0-0.1,0-0.2\r\n\t\t\tc-0.1-0.1-0.1-0.1-0.1-0.1c-1.2,0.1-2.3,0.2-3.5,0.2h-0.1c-0.6,0-1.2,0-1.8,0.1c0,0,0,0-0.1,0c-0.5,0-0.9-0.4-1-0.9s0.2-1,0.7-1.1\r\n\t\t\tc2.7-0.7,4.5-1.6,4.3-3.7c-0.1-0.9-0.6-1.9-3.2-1.9c-1,0-2.1,0.1-2.9,0.3h-0.1c-0.8,0.1-1.7,0.2-2.4,0.2c-0.5,0-0.8,0-1.1-0.1\r\n\t\t\tc-0.5-0.1-1-0.5-1.5-0.9l-0.3-0.2c-0.3-0.2-0.4-0.5-0.4-0.8s0.1-0.6,0.4-0.8c2.2-1.7,4.8-2,7.5-2.4c1.4-0.2,2.7-0.3,3.9-0.6\r\n\t\t\tc1.8-0.5,2.9-1.2,4.2-2l0.8-0.5c1.4-0.7,2.7-0.9,4.1-1h0.2c1-0.1,1.9-0.2,2.8-0.4c0.7-0.1,1.4-0.4,2-0.6c1-0.3,1.9-0.6,2.8-0.7\r\n\t\t\tl0,0c0.7,0,1.5,0.2,2.4,0.6c0.7,0.3,1.3,0.6,2.1,0.6c0.3,0,0.5,0,0.7,0c2.6,0,4.8-1.4,6.9-2.7c1.4-0.9,2.9-1.8,4.4-2.3\r\n\t\t\tc0.9-0.3,1.7-0.4,2.3-0.5c2-0.3,2.9-0.4,2.8-4v-0.7c0-1.5,0-3.1,0.8-4.4c0.3-0.6,0.7-1,1.2-1.4c0.6-0.5,1.2-1.1,1.4-1.9v-0.1\r\n\t\t\tc0.3-0.7,0.3-1.3,0.2-2v-0.1c0-0.8-0.1-1.6,0.6-2.4c0.4-0.6,1.1-1,1.9-1.3c0.4-0.2,0.9-0.4,1.3-0.7c0.3-0.3,0.7-0.6,1-0.9\r\n\t\t\tc0.2-0.2,0.5-0.3,0.8-0.3c0.1,0,0.3,0,0.4,0.1c0.4,0.2,0.6,0.6,0.6,1c-0.1,1.5-0.1,3.2,0.7,4c0.3,0.3,0.8,0.4,1.5,0.4h0.2\r\n\t\t\tc0.6,0,1,0.1,1.3,0.3c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.3,0.4,0.6s0.4,0.7,0.6,0.8c0,0,0.1,0,0.1,0.1c0.8,0.6,1.8,0.8,3,0.8\r\n\t\t\tc1,0,2.1-0.2,3.1-0.4s2-0.4,3-0.4c0.4,0,0.8,0,1.2,0.1c0.3,0.1,0.6,0.3,0.7,0.7c0.1,0.3,0,0.7-0.2,1l-0.1,0.1l-0.1,0.1\r\n\t\t\tc-0.6,0.6-1.2,1.3-1.1,2.6c0.1,0.4,0.3,0.8,0.6,1.3c0.3,0.6,0.7,1.2,0.8,1.9c0.3,1.2,0.7,4.6,0.4,5.7c-0.1,0.3-0.3,1.3-1.2,1.3\r\n\t\t\th-0.1c-0.3,0.1-0.8,0.1-1.4,0.4c-1.2,0.4-2.2,1.3-3.2,2.2l-0.1,0.1c-1.1,0.9-2.2,1.8-3.6,2.3c-0.4,0.2-0.8,0.2-1.3,0.2\r\n\t\t\tc-0.7,0-1.3,0-2.2,0.7c-0.4,0.4-0.6,1.1-0.9,1.7c-0.3,0.7-0.7,1.5-1.2,2.1l-0.5,0.6c-1.1,1.3-2,2.5-2.3,4.2\r\n\t\t\tc-0.1,0.6-0.1,1-0.1,1.5c0,1.1,0,1.7-1.1,2.5c-1.2,1.1-3.5,1.6-6.9,1.6c-1.3,0-2.6-0.1-3.5-0.1l-1.1-0.1c-1.7-0.1-3.5-0.2-5.3-0.2\r\n\t\t\tc-0.9,0-1.8,0-2.6,0.1c-0.3,0-0.6,0.1-1,0.1c-0.8,0.1-1.6,0.2-2.4,0.2c-0.3,0-0.6,0-1,0c-0.3,0-0.8-0.2-1.5-0.5\r\n\t\t\tc-0.7-0.2-1.2-0.4-1.7-0.4c-0.1,0-0.1,0-0.2,0c-0.8,0.2-1.3,0.6-1.9,1.1c-0.5,0.4-1,0.8-1.7,1c-1.6,0.4-3.5,0.6-4.7,0.7l0,0\r\n\t\t\tc-0.4,0-0.7-0.2-0.9-0.5s-0.2-0.7,0-1c0.3-0.5,0.4-0.9,0.3-1.3c0-0.1-0.1-0.2-0.2-0.2c-2.4,0-3.9,1.2-5.4,2.3\r\n\t\t\tc-0.5,0.4-0.9,0.7-1.3,1C608.1,578.9,607.9,578.9,607.7,578.9z\"/>\r\n\t</g>\r\n\t<g>\r\n\t\t<text transform=\"matrix(1 0 0 1 661.0499 579.0409)\" class=\"label-active outside\">RJ</text>\r\n\t</g>\r\n</g>\r\n<g id=\"ES\">\r\n\t<g>\r\n\t\t<path class=\"estado-active\" d=\"M662.2,542c-1.2,0-2.1-0.3-2.9-0.8c0,0-0.1,0-0.1-0.1c-0.1-0.1-0.2-0.2-0.3-0.4l-0.1-0.2\r\n\t\t\tc-0.1-0.2-0.4-0.6-0.7-0.8c-0.5-0.3-1.1-0.3-1.7-0.4H656c-0.1,0-0.1,0-0.2,0c-0.2,0-0.5-0.1-0.7-0.3c-0.8-0.7-0.8-2.4-0.5-5\r\n\t\t\tc0.1-0.6,0.1-1.1,0.1-1.5c0,0,0,0,0-0.1c0-0.4,0.2-0.8,0.6-0.9c0.1-0.1,0.2-0.1,0.3-0.1s0.2-0.1,0.1-0.2c-0.2-0.6-0.6-1.1-1-1.5\r\n\t\t\ts-0.7-0.8-0.8-1.2c-0.5-1.4,0.4-4.6,1.1-5.6c0.6-1,3-2.1,4.8-2.1c0.3,0,0.5,0,0.8,0.1c0.8,0.2,1.3,0.7,1.3,1.4\r\n\t\t\tc0,0.1,0,0.1,0.1,0.2c0.1,0,0.1,0,0.1,0h0.1c1.6-1.2,2.1-3.2,2.7-5.3c0.4-1.5,0.8-2.9,1.6-4.1c0.3-0.4,0.8-0.9,1.5-1.4\r\n\t\t\tc0.9-0.7,1.9-1.4,2.1-2.5c0.1-0.6-0.2-1.2-0.5-1.7s-0.5-0.8-0.6-1.2c-0.1-1.1,0.1-2.1,0.4-3.1l0.4-1.5c0.6-2.5,0.8-4-1.5-5.4\r\n\t\t\tc-0.3-0.2-0.5-0.6-0.5-1s0.3-0.7,0.7-0.8l0.4-0.1c1-0.3,2.2-0.6,2.9-1.6c0,0,0-0.1-0.1-0.2c0,0-0.1-0.1-0.2-0.1\r\n\t\t\tc-0.4-0.1-0.6-0.5-0.7-0.9c-0.1-1.9-0.4-5.3-1.7-6.2c-0.1-0.1-0.3-0.1-0.5-0.2c-0.4-0.1-0.7-0.4-0.8-0.8c-0.4-2.8,2.4-4.2,5.7-5.6\r\n\t\t\tl0.3-0.1c0.4-0.2,0.8-0.3,1.1-0.5c0.1,0,0.1-0.1,0.1-0.2s0-0.1,0-0.2c-0.1-0.4,0.1-0.9,0.5-1.1c1.3-0.7,2.7-0.8,4.4-0.8\r\n\t\t\tc0.1,0,0.2,0,0.4,0c0.4,0,0.8,0,1.3,0.1h0.2c0.5,0,1.1,0.1,1.6,0.1c0.7,0,1.2-0.1,1.6-0.2c0.1,0,0.2-0.1,0.3-0.1\r\n\t\t\tc0.2,0,0.3,0,0.4,0.1c2,0,3.5,1.7,4.9,3.2c0.7,0.7,1.3,1.4,2,1.9c0.5,0.4,1.2,0.7,1.8,1c0.7,0.4,1.2,0.6,1.6,1\r\n\t\t\tc0.2,0.2,0.3,0.4,0.4,0.7c0,0.1,0,0.2,0,0.2c0,0.1,0.1,0.2,0.1,0.2c0.3,0.1,0.6,0.4,0.6,0.8c0.1,0.4,0.1,1,0,1.6\r\n\t\t\tc-0.1,1.1-0.4,2-0.8,2.9c-0.6,1.4-1.1,2.8-0.4,4.8c0.2,0.7,0.4,1.3,0.6,1.8v0.1c0.9,2.4,1.5,4.3,0.3,7.4c-1.3,3.3-3.4,5.9-5.4,8.4\r\n\t\t\tl-0.1,0.1c-2.2,2.8-4.5,5.7-5.7,9.2c-0.2,0.7-0.3,1.4-0.4,2.2v0.1c-0.1,1.3-0.3,2.9-1.3,4c-0.2,0.3-0.6,0.5-1,0.7\r\n\t\t\tc-0.6,0.3-1.2,0.7-1.6,1.3c-0.4,0.5-0.7,1-1,1.5l-0.1,0.1c-0.9,1.4-1.7,2.5-3.3,3.8c-1.2,1-2.2,1.6-3.7,2.4\r\n\t\t\tc-0.1,0.1-0.1,0.2-0.1,0.3c0.7,1.4,0.2,3-1.5,4.1c-0.2,0.1-0.4,0.2-0.6,0.2c-0.2,0-0.3,0-0.5-0.1c-0.7-0.4-1.5-0.6-2.5-0.6\r\n\t\t\ts-2,0.2-3,0.4h-0.1C664.1,541.9,663.1,542,662.2,542z\"/>\r\n\t</g>\r\n\t<g>\r\n\t\t<text transform=\"matrix(1 0 0 1 690.9927 534.0125)\" class=\"label-active outside\">ES</text>\r\n\t</g>\r\n</g>\r\n<g id=\"GO\">\r\n\t<g>\r\n\t\t<g>\r\n\t\t\t<path class=\"estado-active\" d=\"M470,506.5c-0.4,0-0.9-0.2-1.1-0.5c-0.6-1.1-1.3-2.1-1.5-2.3c-1.1-1-3.3-1.4-5.4-1.9\r\n\t\t\t\tc-1.3-0.3-2.5-0.5-3.3-0.9c-0.9-0.4-1.8-0.9-2.6-1.3l-0.3-0.2c-1.4-0.8-2.7-1.6-4.3-2.1l-1.6-0.5c-2.5-0.8-4.2-1.3-6.6-3.1\r\n\t\t\t\tl-0.7-0.6c-1.7-1.3-3.5-2.7-5.5-3.5c-0.9-0.4-1.8-0.6-2.8-0.8h-0.2c-1-0.2-2-0.4-2.9-0.9c-0.2-0.1-0.4-0.3-0.5-0.6\r\n\t\t\t\tc-0.1-0.3-0.1-0.5,0.1-0.8c0.1-0.1,0.2-0.3,0.3-0.4c0.5-0.7,0.8-1.3,0.4-2.1c-0.6-1.3-2.7-2-4.3-2.6l-0.7-0.2\r\n\t\t\t\tc-1.3-0.4-1.7-0.9-2.2-1.6c-0.2-0.3-0.3-0.7-0.1-1.1c1.5-2.8,2.8-6.7,1.8-9.1c-0.2-0.4-0.4-0.6-0.6-0.8c-0.4-0.4-0.5-0.6-0.6-1.1\r\n\t\t\t\ts0-0.9,0.1-1.3V466c0.1-0.3,0.2-0.7,0.2-1v-1.2c0-2.3,0-3.7,0.8-6.4c0.8-2.7,2.5-4.3,4.4-5.9l0.7,0.7l-0.7-0.7\r\n\t\t\t\tc1.4-1.3,2.9-2.6,3.9-4.5c1.1-2,2.4-3.5,3.8-5.1l0.2-0.2c0.8-0.9,1.6-1.8,2.3-2.7c0.5-0.6,0.9-1.3,1.2-2c0.5-1,1-2,1.8-2.5\r\n\t\t\t\tc0.9-0.6,2-0.7,3-0.8c1.1-0.1,2.3-0.2,3.4-1.1c1.7-1.4,1.9-3,2.1-4.5v-0.2c0.1-0.8,0.2-1.5,0.5-2.3c1.2-3,3.8-8.4,7.7-10\r\n\t\t\t\tc0.7-0.4,1.5-0.5,2.3-0.6h0.2c0.7-0.1,1.5-0.2,2.2-0.5c2.5-1.1,2.7-2.4,3.1-4.1c0-0.2,0.1-0.3,0.1-0.5c0.1-0.3,0.2-0.7,0.3-1.1\r\n\t\t\t\tc0.3-1.1,0.7-2.1,1.1-3.2l0.2-0.6c0.7-1.9,1.5-3.9,1.7-6l0.1-1c0.2-1.9,0.5-3.9,1.3-6.1c0.6-1.8,1.2-3.4,2.1-5.2\r\n\t\t\t\tc0.2-0.7,0.6-1.4,0.9-2.1l0.1-0.2c0.7-1.4,1.3-2.7,1.6-4.3c0.1-0.6,0.2-1.2,0.4-1.8l0.2-0.9c0.4-2.3,0.9-4.9,1.8-6.5\r\n\t\t\t\tc0.2-0.3,0.3-0.5,0.5-0.7l0.2-0.2c0.7-0.8,1.3-1.5,1.1-2.2c0-0.1,0-0.1-0.1-0.2c-0.2-0.4-0.1-0.9,0.2-1.2c0,0,0-0.1,0.1-0.1\r\n\t\t\t\tc0.9-0.6,1.5-1.2,2.3-1.8c0.2-0.1,0.4-0.2,0.6-0.2s0.4,0.1,0.6,0.2c0.4,0.3,0.5,0.7,0.4,1.2c-0.3,0.9-0.8,1.8-1.2,2.7l-1-0.3\r\n\t\t\t\tl0.9,0.4c-1.5,3.2-2.4,5.3-0.9,6.5c0.5,0.4,1.2,0.6,2.4,0.6c0.6,0,1.1,0,1.7-0.1c0.6,0,1.2-0.1,1.7-0.1c0.7,0,1.3,0.1,1.8,0.3\r\n\t\t\t\tc1.6,0.4,3.7,1.5,5.4,2.6c0.6,0.4,1.1,0.8,1.5,1.2c0.8,0.7,1.7,1.3,2.3,1.3c0.1,0,0.2,0,0.4-0.1c0.9-0.3,1.3-1.6,1.5-2.7\r\n\t\t\t\tc0.4-1.6,0.5-1.9,1.4-2.5l0.3-0.2c0.3-0.2,0.6-0.4,1-0.6c0.2-0.1,0.4-0.2,0.5-0.3l0.1-0.1c0.4-0.2,0.8-0.4,1-0.7\r\n\t\t\t\tc0.2-0.3,0.5-0.4,0.8-0.4h0.1c0.4,0,0.7,0.3,0.8,0.6c0.2,0.5,0.3,0.9,0.4,1.4c0,0,0,0.1,0.1,0.2l0,0h0.1c1.4-0.4,2.2-1.1,2.7-1.7\r\n\t\t\t\tl0.1-0.1c0.4-0.4,0.6-0.6,1-0.7l0,0c0.1,0,0.2,0,0.3,0c0.4,0,1,0.2,2.4,1.4c0.8,0.7,3.4,3.2,3.5,5.2c0,0.6-0.2,1.1-0.6,1.4\r\n\t\t\t\tc0,0,0,0.1,0,0.2s0.1,0.1,0.2,0.1c1.9,0.4,3.7,0.5,5.7,0.7c3.2,0.3,6.2,0.5,9.3,1.9c0.3,0.1,0.7,0.3,1.1,0.5c0.8,0.4,2,1,3,1\r\n\t\t\t\tc0.7,0,1.2-0.2,1.7-0.8c1-0.9,0.9-2,0.8-3c-0.1-1.1,0-1.6,0.3-2c0.4-0.4,1.1-0.6,2.4-0.6c0.9,0,2,0.1,2.6,0.1h0.2\r\n\t\t\t\tc0.7,0.1,1.3,0.1,1.8,0.1c0.3,0,0.6,0,0.8-0.1c2-0.5,4.4-1.8,6.3-2.8c0.8-0.4,1.5-0.8,2.3-1.2l0.4-0.2c1.4-0.8,2.1-1.2,3.2-1.2\r\n\t\t\t\tc0.3,0,0.6,0,1,0.1s0.8,0.3,1.3,0.4c0.5,0.2,0.9,0.4,1.5,0.5c0.1,0,0.3,0,0.5,0c0.5,0,1-0.1,1.3-0.2c0.1,0,0.2-0.1,0.4-0.1\r\n\t\t\t\ts0.5,0.1,0.6,0.2c0.3,0.2,0.4,0.6,0.3,1c-0.2,0.8-0.7,1.7-1.1,2.5c-0.4,0.6-0.7,1.2-0.9,1.7c0,0.1,0,0.1,0,0.1\r\n\t\t\t\tc0.1,0.1,0.1,0.1,0.1,0.1c1.5,0.2,1.8,1.1,1.9,1.5c0.1,0.7-0.2,1.3-0.7,1.5c-0.1,0.1-0.3,0.1-0.5,0.1c-0.4,0-0.7-0.2-1-0.5\r\n\t\t\t\tl-0.1-0.1c-0.1,0-0.2,0.1-0.2,0.1c-0.4,1.2-0.4,2.6-0.2,4.1v0.4c0,0.4,0.1,0.8,0.1,1.1c-0.1,0.8-0.1,1.5-0.2,2.2\r\n\t\t\t\tc-0.3,2-0.4,3.6-0.1,5.2c0.5,1.9,1.5,2.6,2.7,3.5c0.3,0.2,0.6,0.5,1,0.8c1.4,1,1.6,1.5,2,2.7c0.1,0.4,0.2,0.7,0.4,1.1v0.1\r\n\t\t\t\tl0.3,0.9c0.7,2.2,1.6,5.1-0.9,6.2c-0.1,0-0.1,0.1-0.1,0.2c0.1,0.9-0.1,2.4-0.4,3.4c-0.1,0.3-0.2,0.5-0.5,0.6\r\n\t\t\t\tc-0.2,0.1-0.3,0.1-0.5,0.1c-0.1,0-0.2,0-0.3,0s-0.3-0.1-0.5-0.1c-0.4,0-0.7,0.1-1,0.2c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4-0.1-0.6-0.2\r\n\t\t\t\tc-0.2-0.2-0.4-0.5-0.4-0.8c0-0.6-0.1-1-0.3-1.3c-0.2-0.2-0.5-0.3-1.1-0.3c-0.2,0-0.3,0-0.5,0H563c-0.2,0-0.3,0-0.5,0\r\n\t\t\t\tc-0.5-0.1-0.8-0.5-0.8-1v-0.1c0-0.5,0-0.9-0.2-1.1c-0.6-0.6-1.1-0.7-1.8-0.7c-0.2,0-0.4,0-0.6,0H559c-0.2,0-0.4,0-0.6,0\r\n\t\t\t\tc-0.2,0-0.3,0-0.5,0c-0.1,0-0.2,0.1-0.2,0.2v0.1c0.1,0.2,0.2,0.5,0.1,0.7c-0.1,0.6,0.2,1.2,0.4,1.8c0.3,0.7,0.7,1.4,0.1,2.2\r\n\t\t\t\tl-0.1,0.2c-0.1,0.2-0.3,0.4-0.5,0.5c-0.1,0.1-0.3,0.1-0.5,0.1c-0.1,0-0.2,0-0.3-0.1l-0.1-0.1h-0.1c-0.3-0.1-0.6-0.2-1.1-0.2\r\n\t\t\t\tc-1.2,0.1-2.1,0.3-2.4,0.8c-0.2,0.3-0.2,0.7-0.1,1.4c0.1,0.6,0.2,1.3,0,2v0.1c-0.5,1.4-1.7,4-2.5,5.2c0,0,0,0.1,0,0.2\r\n\t\t\t\ts0.1,0.1,0.2,0.1c1.6,0.3,3.1,4,3.4,5.6c0.5,2.8-1,3.2-3.5,3.8c-0.4,0.1-0.7,0.1-0.9,0.2c-1.4,0.3-5.6,1.6-6.3,3.5\r\n\t\t\t\tc-0.2,0.6-0.1,1.1,0,1.6s0.3,1.2-0.1,1.9c-0.5,0.8-1.5,1.3-2.5,1.8c-0.5,0.2-1,0.5-1.3,0.8c-0.1,0.1-0.1,0.1-0.1,0.2\r\n\t\t\t\ts0,0.1,0.1,0.1c1.5,1.5,2.3,3.6,3.1,5.6c0.6,1.6,1.3,3.3,2.3,4.6l0.1,0.2c0.2,0.2,0.3,0.4,0.5,0.6c1.2,1.4,1.2,1.9,0.2,3.6\r\n\t\t\t\tc-1,1.4-2.3,2.3-3.6,3.3c-1,0.8-2,1.5-2.8,2.4c-0.1,0.1-0.1,0.2,0,0.2c0.7,1.1,1.7,1.6,2.6,2c1.7,0.7,2.2,1.4,1.7,3.5\r\n\t\t\t\tc-0.1,0.5-0.2,0.8-0.3,1.2c-0.2,0.4-0.3,0.8-0.4,1.5c0,0.5,0.1,1,0.2,1.4c0.2,0.6,0.3,1.2,0.2,1.8c-0.3,2.5-1.7,3.2-3.6,4.1\r\n\t\t\t\tl-0.6,0.3c-1.7,0.8-1.8,1.1-2.1,1.7c-0.2,0.3-0.4,0.8-1,1.5c-0.5,0.8-3.2,2.6-4.3,2.7h-0.1c-0.8-0.1-1.3-0.6-1.8-1.1\r\n\t\t\t\tc-0.5-0.4-1-1-1.7-1.1c-1.3-0.3-2.8-0.4-4.7-0.4c-1.6,0-3.2,0.1-4.8,0.2l-1.8,0.1c-1.1,0.1-2,0.2-3.1,0.4h-0.2\r\n\t\t\t\tc-1,0.2-2,0.3-3,0.3c-0.2,0-0.5,0-0.7,0l-0.9-0.1c-0.5-0.1-0.8-0.1-1.1-0.1c-0.7,0-1.4,0.1-2.6,0.8c-0.6,0.4-1.2,0.8-1.7,1.2\r\n\t\t\t\tc-1,0.7-1.6,1.2-2.4,1.4c-0.1,0-0.1,0-0.2,0c-0.3,0-0.5-0.1-0.7-0.3l-0.2-0.2c-0.3-0.3-0.6-0.6-1.2-0.7c-0.4,0-1,0.3-1.4,0.5\r\n\t\t\t\tl-0.1,0.1c-0.2,0.1-0.5,0.2-0.7,0.3c-1.4,0.4-3,0.6-4.3,0.8h-0.2c-2.4,0.4-4.8,0.7-6.9,1.7c-2.7,1.2-4.5,3.6-6.2,5.9\r\n\t\t\t\tc-1.1,1.5-2.2,3-3.4,4.1l-0.1,0.1c-0.4,0.2-0.6,0.3-0.9,0.3c-0.5,0-0.9,0.1-1.4,1c-0.4,0.6-0.2,1.3,0,2.1\r\n\t\t\t\tc0.1,0.2,0.2,0.6,0.2,0.7c0.1,0.3,0.1,0.6-0.1,0.8C472.1,506.4,471.1,506.4,470,506.5L470,506.5z M532.1,436.7c0.7,0,1.2,0,2,0.1\r\n\t\t\t\tc1,0.1,2,0.2,2.9,0.2c1.2,0,2-0.1,2.6-0.5c2.3-1.1,2.1-3.1,1.7-5.7v-0.2c-0.1-0.9-0.2-1.7-0.2-2.4c0.1-0.7,0.3-1.2,0.5-1.7\r\n\t\t\t\tc0.3-0.9,0.4-1.3,0.1-1.7c-0.1-0.2-0.4-0.4-1.3-0.4c-0.3,0-0.6,0-0.9,0c-0.9,0.1-1.7,0.2-2.7,0.4h-0.2c-1.1,0.2-2.2,0.3-3.3,0.3\r\n\t\t\t\tc-1.3,0-2.5-0.2-3.8-0.7h-0.1c-0.1,0-0.1,0-0.2,0.1v0.1c-0.1,0.4-0.4,0.9-0.9,0.9h-0.1c-0.6,0.1-1.3,0.1-2,0.3\r\n\t\t\t\tc-3.2,0.5-3.3,1.7-3.2,3.8c0,0.7,0.1,1.5,0,2.4v0.1l-0.1,0.6l-0.1,0.6c-0.1,0.3-0.3,0.6-0.5,0.7c-0.1,0-0.1,0.1-0.2,0.1\r\n\t\t\t\tc-0.5,0.2-0.7,0.3-0.8,0.6c-0.1,0.3,0,0.6,0.5,1.2c0.8,0.9,3.3,1,5.1,1c1,0,2.3,0,3.9-0.1C531.2,436.7,531.7,436.7,532.1,436.7z\"\r\n\t\t\t\t/>\r\n\t\t</g>\r\n\t</g>\r\n\t<g>\r\n\t\t<path id=\"DF\" class=\"estado-active\" d=\"M536.9,436.6c-0.9,0-1.9-0.1-2.8-0.2c-0.8-0.1-1.5-0.1-2-0.1c-0.4,0-0.9,0-1.7,0.1c-1.4,0.1-2.6,0.1-3.7,0.1\r\n\t\t\tc-1.8,0-3.1-0.1-4-0.4c-0.4-0.1-0.6-0.4-0.7-0.8s0.1-0.8,0.4-1c0.2-0.1,0.3-0.2,0.3-0.4c0-0.3,0.1-0.6,0.2-1.1l0.2-0.7\r\n\t\t\tc0.1-0.8,0.1-1.6,0.1-2.2v-0.2c-0.1-2.3,0.2-3,2.9-3.4c1.7-0.3,3.2-0.4,4.5-0.4c3,0,3.5,0.7,3.7,0.9c0,0.1,0.1,0.1,0.1,0.1\r\n\t\t\ts0.1,0,0.1-0.1c0.1-0.1,0.1-0.2,0.1-0.2c-0.1-0.3,0-0.6,0.1-0.8s0.4-0.4,0.7-0.4c0.4-0.1,0.8-0.1,1.2-0.2c0.8-0.1,1.7-0.3,2.7-0.4\r\n\t\t\th0.2c0.2,0,0.4,0,0.6,0c0.3,0,0.7,0.2,0.8,0.5c0.2,0.3,0.2,0.6,0.1,1c0,0.1,0,0.1-0.1,0.2c-0.2,0.4-0.3,1-0.5,1.7\r\n\t\t\tc-0.1,0.7,0,1.7,0.2,2.7c0.3,2.1,0.6,4.3-1.5,5.3C538.9,436.4,538.1,436.6,536.9,436.6z\"/>\r\n\t</g>\r\n\t<g>\r\n\t\t<text transform=\"matrix(1 0 0 1 480.18 450.9601)\" class=\"label-active\">GO</text>\r\n\t</g>\r\n</g>\r\n<g id=\"MT\">\r\n\t<g>\r\n\t\t<path class=\"estado-active\" d=\"M423.2,478.3c-0.2,0-0.4-0.1-0.5-0.1c-0.5-0.3-1.5-0.7-2.7-1.2l-1.1-0.4c-0.6-0.1-1.2-0.2-1.9-0.2\r\n\t\t\tc-0.3,0-0.5,0-0.8,0h-0.5c-0.9,0-1.7,0-2.4-0.3c-0.4-0.2-0.7-0.3-0.8-0.4l0,0c0,0,0.1,0,0.2,0c-0.3,0-0.5-0.2-0.7-0.4\r\n\t\t\tc-0.2-0.2-0.3-0.5-0.2-0.8c0-0.2,0.2-0.6,0.4-1v-0.1c0.1-0.3,0.3-0.7,0.4-1.1c1-3.3,0.7-6.6-1-9.7c0-0.1-0.1-0.1-0.1-0.1l0,0\r\n\t\t\tc-0.1,0-0.1,0-0.1,0c-4.4,2.7-8.3,4.2-11.5,4.3l0,0c-0.7,0-1.3-0.1-1.9-0.3c-0.7-0.2-1.3-0.3-1.9-0.3c-0.8,0-1.2,0.2-1.6,0.4\r\n\t\t\tl-0.2,0.1c-0.2,0.1-0.3,0.2-0.5,0.2c-1.5,0.4-3,0.5-4.6,0.6H389c-1,0-2,0.1-3.1,0.2c-1,0.1-1.8,0.2-2.5,0.2\r\n\t\t\tc-1.4,0-2.4-0.4-3.9-1.4l-0.8-0.6c-1.8-1.3-3.1-2.3-5.5-3.1c-0.6-0.2-1.3-0.5-2-0.9c-2.8-1.3-5.7-2.6-7.6-2.6\r\n\t\t\tc-0.5,0-0.8,0.1-1.1,0.2c-0.1,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1-0.1,0.2c-0.6,1.5-4.7,2.2-6.1,2.3c-0.7,0-1.3,0-1.8,0\r\n\t\t\tc-1.7,0-2.7,0-4.3,1.1c-1.3,0.9-2.1,2-2.9,3c-1,1.3-2,2.5-3.8,3.3c-0.4,0.2-0.9,0.4-1.3,0.6l-0.2,0.1c-1.2,0.6-2.1,1-3.1,1\r\n\t\t\tc-0.2,0-0.5,0-0.7-0.1c-1.6-0.3-2.3-1.4-3-2.4c-0.2-0.3-0.5-0.7-0.8-1l-0.5-0.6c-1-1.2-2-2.5-3.2-2.5c-0.4,0.1-0.7,0.4-1,0.9\r\n\t\t\tc-0.2,0.3-0.4,0.4-0.8,0.5h-0.1c-0.3,0-0.5-0.1-0.7-0.3c-0.6-0.7-1.5-0.7-2.3-0.8c-0.6,0-1.3-0.1-1.9-0.4s-1-1-1.4-1.7\r\n\t\t\tc-0.4-0.6-0.7-1.2-1.1-1.6c-0.5-0.4-1-0.7-1.5-0.9c-0.4-0.2-1-0.4-1.4-0.9c-1.3-1.3-1.6-4.2-1.9-7.3v-0.2\r\n\t\t\tc-0.1-0.6-0.1-1.1-0.2-1.5v-0.3c-0.1-1.1-0.4-2.6,0.3-3.7c0-0.1,0.1-0.1,0.2-0.2c0.2-0.2,0.4-0.3,1-0.5s1.1-0.5,1.5-1.1\r\n\t\t\tc0.6-1.1,0.8-1.9,0.4-2.5c-0.4-0.7-1.4-1-3.1-1c-0.5,0-0.9,0-1.4,0.1s-1.1,0.1-1.7,0.2h-0.2c-1.5,0.2-3.3,0.4-5,0.4\r\n\t\t\tc-0.8,0-1.6,0-2.3-0.1c-1.1-0.1-2.1-0.4-3.2-0.6l-0.3-0.1c-1.3-0.3-2.6-0.6-4-0.6c-0.5,0-0.9,0-1.4,0.1c-1.2,0.2-2.4,0.5-3.6,0.8\r\n\t\t\tc-1.8,0.5-3.4,0.9-5,0.9c-2,0-3.6-0.7-5.1-2.1c-2.4-2.4-2.5-5.1-2.5-8v-0.2c0-1.1-0.1-2.3-0.2-3.4c-0.1-1.7-0.7-2.8-1.2-4.1\r\n\t\t\tl-0.1-0.3c-0.1-0.3-0.3-0.6-0.4-1c-0.5-0.9-1-1.6-1.5-2.3c-0.5-0.6-1-1.2-1.4-2.1c-0.2-0.3-0.2-0.8,0-1.1c0.2-0.3,0.5-0.5,0.8-0.5\r\n\t\t\th0.1c0.3,0,0.6,0,0.9,0c0.9,0,1.6-0.2,2-0.6c1.2-1.1,0.3-3.6-0.4-5.6l-0.1-0.1c-0.3-0.7-0.5-1.3-0.6-1.8l-0.1-0.7\r\n\t\t\tc-0.2-1.1-0.3-1.7-1-2.8c-0.3-0.4-0.6-0.7-0.9-1c-0.6-0.5-1-1-1.3-2c-0.3-1.2-0.5-3.5-0.3-4.5v-0.1c0.1-0.6,0.5-1.1,0.9-1.5\r\n\t\t\tc0.5-0.6,0.9-1.1,1-1.8c0.2-1.4-1.7-4.8-2.7-5.4c-0.7-0.5-1.6-0.6-2.4-0.7h-0.1c-0.4-0.1-0.8-0.4-0.9-0.8s0-0.8,0.4-1.1\r\n\t\t\tc0.4-0.2,0.7-0.4,1-0.7c1.8-1.1,3.4-2.1,4.9-4.2c0.8-1,1.1-1.8,1.4-2.6l1,0.3l-0.9-0.4c0.2-0.4,0.4-0.9,0.6-1.4\r\n\t\t\tc0.6-1.2,1.5-2.1,2.4-3c0.6-0.6,1-1.1,1.5-1.6c2.3-2.8,3.6-6,3.8-9.2V362c0-1.5,0-3.1-0.2-4.7c-0.2-1.3-0.7-1.8-1.2-2.4\r\n\t\t\tc-0.3-0.3-0.6-0.6-0.9-1.1c-1.2-1.9-1.7-6.3-1-8.4v-0.1c0.2-0.4,0.6-0.8,1-1.2c0.5-0.4,0.8-0.8,1-1.2c0.5-1.5-0.3-2.8-1-3.9\r\n\t\t\tl-0.8-1.2c-0.7-1.1-0.8-1.3-2.9-1.3c-0.5,0-1,0.1-1.4,0.2s-0.8,0.2-1.2,0.2c-0.2,0-0.4,0-0.6-0.1c-1-0.3-1.8-0.8-2.6-1.4\r\n\t\t\tc-1.1-0.8-2.2-1.7-4.3-1.7c-0.1,0-0.2,0-0.3,0c-1.4,0.1-2.7,0.3-4.2,0.5c-2.6,0.3-5.3,0.6-8,0.6c-1.2,0-2.2-0.1-3.3-0.2\r\n\t\t\tc-0.5-0.1-0.9-0.5-0.9-0.9c-0.2-3.8-0.8-7.6-1.4-11.5l-0.2-1.6c-0.6-4-0.6-7,0-11.5c0.3-2.3,0.6-4.4,0.1-6.7\r\n\t\t\tc-0.1-0.7-0.3-1.3-0.5-1.9c-0.3-1-0.6-1.9-0.4-3.1c0.1-0.5,0.3-1.2,0.7-2c0.5-1.1,1-2.3,0.8-3.3c-0.1-0.3,0-0.6,0.2-0.8\r\n\t\t\tc0.2-0.2,0.5-0.4,0.8-0.4h0.5c1.7,0,4-0.1,6.8-0.2l1.2-0.1c0.8,0,1.5-0.1,1.9-0.1c1.9,0.1,3.8,0.2,5.9,0.2c4.4,0,8.6-0.3,13.2-0.6\r\n\t\t\th0.8c2.6-0.2,5.3-0.2,9-0.2c1.3,0,2.5,0,3.8,0h3.6c2,0,4.5,0,7-0.1l0,0c0.5,0,1,0,1.6,0.1h0.8c0.9,0,1.9,0.1,2.9,0.1\r\n\t\t\tc2.4,0,4.1-0.3,5.2-1c0,0,0.1-0.1,0.1-0.2c-0.4-1.5,0-2.4,0.5-3.5c0.3-0.6,0.6-1.2,0.7-2c0.6-2.2,0.4-5,0.2-7.5v-0.5\r\n\t\t\tc-0.1-0.6-0.1-1.2-0.1-1.7c-0.1-3.7,1.6-7,3.3-10.4v-0.1c0.1-0.2,0.3-0.4,0.5-0.5c0.1-0.3,0.4-0.6,0.7-0.7c0.1,0,0.3-0.1,0.4-0.1\r\n\t\t\tc0.2,0,0.4,0,0.5,0.2c1.2,0.9,1.4,2.4,1.5,4.3c0.1,0.9,0.1,2,0.4,2.8c0.4,1.4,1.3,2.6,2.2,3.8c0.8,1,1.5,2,1.9,3l0.5,1.3\r\n\t\t\tc0.7,1.9,1.4,3.7,1.4,5.6c0.1,0.9,0.1,1.9,0.1,2.8v0.5c0,1.2,0.1,2.3,0.2,3.4c0,0,0,0.1,0.1,0.1c0.1,0.1,0.2,0.2,0.3,0.3\r\n\t\t\tc0,0.1,0.1,0.1,0.2,0.1c0.3-0.1,0.4-0.1,0.6-0.1c1.2,0,2.1,0.9,3.2,2c0.5,0.5,0.8,0.8,1.3,1.2c1.1,0.7,1.9,1.4,2.7,2.2\r\n\t\t\tc0,0,0.1,0.1,0.1,0.2c0.5,0.6,0.9,1.3,1.2,2c0.4,0.9,0.9,1.8,1.5,2.4c0.7,0.8,1.4,1,2.2,1c0.2,0,0.3,0,0.5,0s0.4,0,0.6,0\r\n\t\t\tc0.3,0,0.6,0,0.9,0.1c1.2,0.3,1.6,0.8,2.1,1.5c0.3,0.4,0.6,0.9,1.3,1.3c0.5,0.3,1.2,0.5,2.1,0.5s1.8-0.2,2.7-0.3\r\n\t\t\tc0.7-0.1,1.3-0.3,2-0.3c0.8,0,1.5,0,2.2,0c1,0,2,0,3,0s2,0,3,0c0.7,0,1.5,0,2.2,0l0,0c1.6,0,2.9,0.3,4.3,0.6\r\n\t\t\tc1.1,0.2,2,0.4,3.1,0.5c3.4,0.1,6.6,0.3,10.1,0.6c1.4,0.1,2.8,0.1,4.1,0.1h0.2c2.1,0,4.1,0,6.2,0.2l2.3,0.2\r\n\t\t\tc2.6,0.3,5.2,0.5,7.8,0.5c6.4,0.1,12.9,0.5,19.1,0.9h0.3c6.9,0.4,14,0.8,21,0.8c8.4,0,17.5,0.9,27.2,2.8l1,0.2\r\n\t\t\tc1.4,0.3,3.8,0.8,5.9,0.8c0.6,0,1.1,0,1.6-0.1c0.1,0,0.1,0,0.2,0c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.3,0.6,0.2,0.9\r\n\t\t\tc-0.6,2.6-1.8,4.7-3,6.9l-0.1,0.3c-1,1.7-1.9,3.5-2.6,5.5c-0.8,2.3-1,4.9-1.2,7.1c-0.2,1.9-0.3,4-0.8,5.9\r\n\t\t\tc-0.2,0.7-0.4,1.2-0.6,1.7v0.1c-0.5,1.6-0.9,2.8-0.7,5c0.3,4.4,0.3,8.6,0,12.8c-0.3,5.5-0.1,9.4,0.9,13.6c0,0.1,0.1,0.1,0.1,0.1\r\n\t\t\th0.1c0.1-0.1,0.3-0.1,0.4-0.1c0.2,0,0.5,0.1,0.7,0.2c0.3,0.2,0.4,0.6,0.3,1c-0.3,1.2-0.5,2.4-0.8,3.6l-0.1,0.7\r\n\t\t\tc-0.1,0.7-0.3,1.4-0.4,2c-0.3,1.6-0.9,2.9-1.6,4.2c-0.4,0.8-0.8,1.6-1,2.3v0.1c-0.8,1.7-1.4,3.5-2,5.1c-0.8,2.1-1,4-1.3,6.2\r\n\t\t\tl-0.1,1c-0.2,2.2-0.9,4.1-1.7,6c-0.5,1.2-0.9,2.4-1.3,3.6c-0.2,0.6-0.3,1.1-0.4,1.6c-0.4,1.9-0.7,2.9-2.9,3.9\r\n\t\t\tc-0.6,0.3-1.2,0.4-1.9,0.5h-0.2c-0.8,0.1-1.7,0.3-2.5,0.7c-4.1,1.7-6.7,7.2-8,10.3c-0.3,0.9-0.4,1.7-0.5,2.5v0.1\r\n\t\t\tc-0.2,1.6-0.4,3-2,4.2c-1,0.8-2.2,0.9-3.2,1s-2.1,0.2-3.2,0.9c-0.8,0.6-1.3,1.6-1.8,2.5l-0.1,0.3c-0.3,0.7-0.6,1.3-1.1,1.8\r\n\t\t\tc-0.7,0.8-1.4,1.6-2.1,2.4l-0.3,0.3c-1.4,1.6-2.9,3.2-4,5.3c-1,1.9-2.4,3.2-3.8,4.4c-2,1.8-3.8,3.4-4.6,6.2\r\n\t\t\tc-0.8,2.7-0.8,4.1-0.8,6.4v1.3c0,0.4-0.1,0.7-0.2,1c-0.1,0.5-0.3,1.1-0.2,1.5c0,0.1,0,0.1,0,0.2c0.1,0.5,0.4,0.8,0.7,1.1l0.2,0.2\r\n\t\t\tc0.1,0.1,0.3,0.3,0.4,0.6c0.8,2-0.2,5.5-1.4,8.1c-0.1,0.3-0.3,0.4-0.6,0.5C423.4,478.3,423.3,478.3,423.2,478.3z\"/>\r\n\t</g>\r\n\t<text transform=\"matrix(1 0 0 1 363.0887 385.9193)\" class=\"label-active\">MT</text>\r\n</g>\r\n<g id=\"BA\">\r\n\t<g>\r\n\t\t<g>\r\n\t\t\t<path class=\"estado-active\" d=\"M695.4,481.9c-0.2,0-0.3,0-0.5-0.1l-0.3-0.2c-0.6-0.3-1.2-0.6-1.8-1c-0.6-0.5-1.1-1-1.7-1.7l-0.2-0.2\r\n\t\t\t\tc-1.1-1.3-2.4-2.7-4.1-3.1c-0.5-0.1-0.8-0.7-0.7-1.2c0.1-0.3,0.1-0.7,0.1-1.1c-0.3-1.7-1.4-2.2-2.7-2.5c-0.7-0.2-1.3-0.4-1.7-0.8\r\n\t\t\t\ts-0.6-1.1-0.7-2c-0.1-0.9-0.3-1.6-0.8-1.9c-0.1,0-0.1-0.1-0.2-0.1c-0.4-0.2-0.7-0.6-0.7-1c0.1-1.5,0.3-3.8,0-6\r\n\t\t\t\tc0-0.2,0-0.5,0.2-0.7c0.3-1.8,1.3-2.7,3.4-4c0.3-0.2,0.6-0.3,0.8-0.4l0.5,0.9l-0.4-0.9c0.3-0.1,0.7-0.3,1-0.7\r\n\t\t\t\tc0.2-0.3,0.2-0.8,0.2-1.3c0-0.3,0-0.6,0-0.8c0-0.3,0.1-0.6,0.3-0.8c0.3-0.3,0.6-0.4,1-0.5l0.2-0.1c0.4-0.2,0.8-0.3,1.2-0.6\r\n\t\t\t\tc0.4-0.4,0.6-0.9,0.7-1.3l0.1-0.2c0.1-0.3,0.2-0.6,0.5-0.9c0.2-0.3,0.7-0.7,1-0.9c0.7-0.6,1.5-1.3,1.5-2.1c0-0.1,0-0.2-0.1-0.4\r\n\t\t\t\tc-0.1-0.3,0-0.7,0.3-1c0.6-0.6,0.9-1.3,0.8-2c-0.2-2.4-4.3-5.4-11.2-8.4c-1.5-0.7-6.5-2.5-9.4-2.5c-0.6,0-0.9,0.1-1.1,0.1\r\n\t\t\t\tc-0.3,0.1-0.6,0.5-0.9,1l-0.1,0.1c-0.4,0.6-0.8,1.2-1.4,1.4c-0.1,0-0.1,0-0.2,0c-0.5,0.1-1.2,0.1-1.6,0.1c-1.1,0-1.4-0.1-1.5-0.1\r\n\t\t\t\tc-0.2-0.1-0.4-0.2-0.5-0.3c-0.3-0.4-0.5-1-0.9-2.6c-0.1-0.4-0.2-0.8-0.3-1.1c-1-1.6-2-2.9-2.4-3.3c0,0-0.1-0.1-0.1-0.2\r\n\t\t\t\tc-0.2-0.4-0.4-0.7-0.6-1c-1.2-2-2.2-3.7-5-4c-1.8-0.1-2.9-0.6-4.1-1.1c-1.3-0.5-2.6-1-4.8-1.3c-0.9-0.1-1.7-0.2-2.5-0.2\r\n\t\t\t\tc-2.8-0.2-4.8-0.3-6.9-2.8c-1.3-1.7-2-1.8-2.8-2c-0.5-0.1-1.1-0.2-2.2-0.8c-0.4-0.2-0.6-0.5-0.9-0.8c-0.3-0.4-0.6-1-1.6-1.3\r\n\t\t\t\tc-0.8-0.3-3-1-4.7-1c-0.6,0-1.1,0.1-1.5,0.3c-0.9,0.5-1.1,1.3-1,2.4c0,0.5-0.2,0.9-0.7,1c-0.1,0-0.2,0.1-0.2,0.1\r\n\t\t\t\tc-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.1-0.3,0.1-0.5,0.1c-0.1,0-0.2,0-0.3-0.1c-0.6-0.2-0.8-0.4-1.1-0.7c-0.2-0.2-0.4-0.4-0.8-0.6\r\n\t\t\t\tc-0.1,0-0.1-0.1-0.2-0.1c-0.9-0.7-1.8-0.9-2.9-0.9c-0.3,0-0.7,0-1.2,0.1h-0.1c-0.2,0-0.5-0.1-0.6-0.2c-0.2-0.2-0.3-0.4-0.4-0.7\r\n\t\t\t\tc0-0.5-0.2-1.1-0.3-1.4c-0.2-0.6-0.3-1.1-0.3-1.5c0-0.3,0.1-0.6,0.3-0.8c0.2-0.2,0.4-0.3,0.7-0.3c0,0,0,0,0.1,0\r\n\t\t\t\tc0.5,0,0.8,0.1,1.2,0.2l0,0c0,0,0,0,0.1,0s0.2-0.1,0.2-0.2c0.1-0.3,0.2-0.7,0.2-0.9c0.4-1.5,0.5-2.2-0.9-2.8c0,0-0.1,0-0.1-0.1\r\n\t\t\t\tc-0.9-0.5-2.4-0.6-3.6-0.6c-0.5,0-1,0-1.5,0h-0.2c-0.4,0-0.9,0-1.3,0c-0.6,0-1.1,0-1.5-0.1c-0.7-0.1-1.2-0.1-1.6-0.1\r\n\t\t\t\tc-1,0-1.4,0.2-2.5,0.7l-1,0.5c-0.7,0.4-1.6,0.5-2.4,0.7c-1,0.2-1.8,0.3-2.5,0.8c-0.9,0.6-0.9,0.6-1.1,1c-0.1,0.2-0.2,0.4-0.5,0.9\r\n\t\t\t\tc-1.5,2.4-2.7,2.9-4.9,3.8l-1.5,0.6c-2.7,1.3-4.8,3.1-6.8,4.8c-1.8,1.5-4.1,2.1-6.2,2.8c-1.6,0.5-3.4,1-4.8,1.9\r\n\t\t\t\tc-0.2,0.1-0.3,0.2-0.5,0.2s-0.4,0-0.5-0.1c-0.3-0.2-0.5-0.5-0.5-0.9c0.1-0.8,0-1.6-0.2-2.1c-0.1-0.3-0.1-0.5,0-0.8\r\n\t\t\t\tc0.6-1.3,0.8-3.3,0.8-3.9c0-0.3,0.2-0.6,0.5-0.8c2-1.2,1.4-3.8,0.6-6.4l-0.3-0.9c-0.2-0.4-0.3-0.8-0.4-1.1\r\n\t\t\t\tc-0.4-1.2-0.6-1.7-2.1-2.9c-0.3-0.3-0.6-0.5-0.9-0.7l-0.1-0.1c-1.2-0.9-2.1-1.5-2.5-3.3c-0.3-1.6-0.1-3.4,0.1-5v-0.2\r\n\t\t\t\tc0.1-0.6,0.2-1.3,0.2-2c0-0.5,0-1-0.1-1.5c-0.1-0.8-0.1-1.6-0.1-2.3c0-0.3,0.1-0.5,0.3-0.7s0.4-0.2,0.6-0.2h0.2\r\n\t\t\t\tc0.2,0,0.5-0.1,0.7-0.2c0.6-0.3,1-1.2,0.9-2c-0.1-0.6-0.5-1.1-1-1.4c-0.2-0.1-0.4-0.3-0.5-0.6c-0.1-0.3,0-0.5,0.1-0.8\r\n\t\t\t\tc0.1-0.1,0.2-0.3,0.3-0.4c0.7-1.2,1.5-2.6,1.1-3.8c-0.1-0.3-0.3-0.6-0.6-0.8c-0.2-0.2-0.3-0.4-0.3-0.7c0-0.4-0.1-0.8-0.3-1.4\r\n\t\t\t\ts-0.4-1.1-0.6-1.6c-0.4-1-0.7-1.7-0.7-3.1c0-0.3,0-0.6,0.1-1c0.1-0.3,0.1-0.7,0.1-1.1c-0.1-0.9-0.5-1.5-0.9-2\r\n\t\t\t\tc-0.2-0.3-0.5-0.7-0.7-1.1c-0.7-2.7,0.2-3.7,1.4-5.1c0.5-0.6,1.1-1.2,1.6-2.1c1.2-1.9,0.7-2.4,0.2-3c-0.3-0.4-0.6-0.7-0.6-1.1\r\n\t\t\t\tc-0.1-1.6,0.7-2.3,1.9-3.3l0.6-0.5l0.1-0.1c0-0.1-0.1-0.2-0.1-0.2c-1.8-0.8-3.7-1.6-6-1.6c-0.3,0-0.7,0-1.2,0.1s-1.2,0.1-1.8,0.1\r\n\t\t\t\tc-0.5,0-1.5,0-1.9-0.8v-0.1c-0.4-1.2,0.8-2.3,2.3-3.6l0.2-0.1c0.5-0.4,0.9-0.8,1.2-1.1c0.7-0.9,0.8-1.8,0.9-2.7\r\n\t\t\t\tc0.1-0.7,0.1-1.3,0.4-2c0.1-0.3,0.3-0.5,0.6-0.6c0.2-0.1,0.6-0.2,0.8-0.5s0.4-0.8,0.6-1.3c0.3-0.8,0.6-1.5,1-1.9\r\n\t\t\t\tc0.8-0.6,1.6-0.8,2.4-1.1c0.9-0.3,1.9-0.5,2.8-1.3c2-1.8,1.8-2.7,1.5-4.2l-0.1-0.4c-0.1-0.4,0.1-0.9,0.5-1.1\r\n\t\t\t\tc1-0.5,2.6-0.9,4.3-0.9c1.1,0,3.7,0.1,5,1.5c1,1.2,0.9,2.3,0.7,3.4c-0.2,1.4-0.4,2.9,2.3,3.8c0.7,0.3,1.4,0.5,2,0.8\r\n\t\t\t\tc1.7,0.7,3.3,1.4,5.1,1.4c1,0,2.1-0.2,3.1-0.6c1.9-0.8,3.6-2.1,5.1-3.2c0,0,0.1,0,0.1-0.1c0.3-0.2,0.5-0.4,0.7-0.6l0.1-0.1\r\n\t\t\t\tc0.4-0.5,0.8-0.9,1.8-0.9h0.2c0.6,0,1.1,0.1,1.8,0.3c0.6,0.2,1.2,0.3,1.8,0.3c1.4,0,3.3-0.9,5.4-2.5c2.1-1.6,2.8-3.1,3.7-5.5\r\n\t\t\t\tc0.1-0.4,0.4-0.9,0.6-1.4l0.1-0.3c0.8-1.6,1.9-3.9,1.6-5c-0.2-0.7-0.9-1.4-1.6-2.1c-1.2-1.2-2.4-2.4-2-3.7c0-0.1,0.1-0.2,0.1-0.3\r\n\t\t\t\tc0.3-0.4,0.9-0.7,2.1-1.3c0.9-0.4,1.8-0.8,2.2-1.3c0.7-0.7,1.1-1.5,1.5-2.2V301c0.2-0.3,0.5-0.5,0.8-0.6c0,0,0,0,0.1,0\r\n\t\t\t\tc0.3,0,0.7,0.2,0.8,0.5l0.1,0.2c0.5,0.7,0.9,1.4,2.2,1.6c0.2,0,0.4,0,0.6,0c0.7,0,1.4-0.2,2-0.3h0.2c0.8-0.2,1.5-0.3,2.2-0.3\r\n\t\t\t\tc0.6,0,1,0.1,1.5,0.3c0.6,0.3,1.1,0.8,1.6,1.3c0.6,0.6,1.2,1.2,2.1,1.5c0.2,0,0.5,0.1,0.9,0.1c1.1,0,2.3-0.3,3.4-0.6l0.7-0.2\r\n\t\t\t\tc1.3-0.3,2.3-0.9,3.2-1.5c0.5-0.3,1-0.6,1.5-0.8c1-0.4,1.7-0.6,2.6-0.6c0.4,0,0.8,0,1.4,0.1l1,0.1c0.2,0,0.3,0,0.5,0\r\n\t\t\t\tc2.6,0,7.9-1.2,9-3.6c0.3-0.6,0.3-1.2,0-1.8c-0.2-0.5,0-1,0.4-1.2c2.2-1.3,4.2-3.9,4.5-4.6c0-0.1,0.1-0.1,0.1-0.2\r\n\t\t\t\tc0.2-0.3,0.2-0.5,0.3-0.8s0.3-0.6,0.6-0.7c0.1,0,0.2-0.1,0.3-0.1c0.2,0,0.4,0.1,0.6,0.2c0.3,0.1,0.6,0.1,1.1,0.2\r\n\t\t\t\tc4.1,0.3,6.3,0.8,7.2,1.6c1.2,0.9,1.1,1.8,1,3.1v0.4c0,0.4,0,0.9-0.1,1.4c0,0.1,0,0.1,0,0.2c-0.1,0.3-0.2,0.8-0.1,0.9\r\n\t\t\t\tc0,0.1,0,0.1,0.1,0.1c0.2,0.6,0.6,0.8,1.1,1l0.2,0.1c0.2,0.1,0.5,0.3,0.6,0.5c0.6,1.2,0,2.1-0.6,3c-0.2,0.3-0.4,0.6-0.6,0.9\r\n\t\t\t\tc0,0.1,0,0.1,0,0.2l0.1,0.1c0.8,0.2,2.2,0.5,3.7,0.5c0.9,0,1.7-0.1,2.3-0.3c1.7-0.6,1.8-0.7,1.8-1.6c0-0.3,0-0.8,0.2-1.7\r\n\t\t\t\tc0.5-2.3,1.6-3.3,3.5-3.3c0.2,0,0.4,0,0.6,0c0.5,0.1,0.9,0.2,1.2,0.4c0.4,0.2,0.7,0.3,1,0.3s0.7-0.1,1.1-0.4\r\n\t\t\t\tc0.7-0.5,1.2-1.4,1.7-2.4l0.1-0.1c0.4-0.7,0.7-1.4,1.1-1.9c1.4-1.4,4.2-3.3,5.8-4c1-0.4,2.4-0.6,4.2-0.6c2.1,0,4.6,0.3,6.1,0.8\r\n\t\t\t\tc3.5,1,7.3,3.6,10.3,5.6l1.3,0.9c1.9,1.3,3.2,2.1,4.6,4.2c0.8,1.1,1.4,2.4,1.8,3.5c0.1,0.2,0.1,0.4,0,0.6v0.1\r\n\t\t\t\tc0.1,0.1,0.2,0.3,0.2,0.5c0.1,0.8,0,1.5-0.2,2.1c0,0,0,0.1,0,0.2l-0.5,0.9l0.6-0.8c0.3,0,0.5,0,0.7,0c0.7,0,1.2,0.2,1.4,0.5\r\n\t\t\t\tc0.4,0.5,0.4,1.4,0.3,2.8c-0.1,1.3-0.3,2.8,0.6,3.9c0.6,0.7,1.4,0.9,2.3,1.2c0.9,0.3,1.7,0.5,2.2,1.4c1,2,0.4,5.5,0,8.4l-0.1,0.8\r\n\t\t\t\tc-0.1,0.5-0.1,0.9-0.2,1.2c-0.2,0.9-0.2,1.6-0.2,2.2c0,1.5-0.1,2.4-1.5,2.8c-0.1,0-0.1,0-0.2,0h-0.1c-0.5,0-1.2-0.2-1.9-0.4\r\n\t\t\t\tc-0.7-0.2-1.5-0.4-2.2-0.4s-1,0.3-1.1,0.5c-0.6,1,0.8,4.3,3.3,9.4c0.3,0.6,0.5,1.1,0.7,1.5c1.4,2.6,3.1,4,5.2,4.2\r\n\t\t\t\tc0.1,0,0.3,0,0.5,0c1,0,2.1-0.3,3.2-0.8c0.1-0.1,0.3-0.1,0.4-0.1c0.3,0,0.5,0.1,0.7,0.3c0.3,0.3,0.4,0.8,0.1,1.2\r\n\t\t\t\tc-1.5,2.7-3.4,5.3-5.2,7.7c-3.1,4.2-6.3,8.5-7.6,13.2c-0.1,0.4-0.2,0.7-0.3,0.9c-0.1,0.2-0.1,0.4-0.1,0.5c-0.6,2.1-0.8,2.7-3,3.7\r\n\t\t\t\tc-0.6,0.2-1.3,0.6-1.9,1c-1.1,0.6-2.3,1.4-3.4,1.5c-0.1,0-0.3,0-0.5,0c-0.6,0-1.2-0.2-1.8-0.3c-0.6-0.2-1.1-0.3-1.7-0.3\r\n\t\t\t\tc-0.6,0-1.2,0.2-1.8,0.6c-1.4,1.1-2.2,3.5-2.8,5.4l-0.2,0.6c-0.3,0.8-0.5,1.5-0.8,2.1c0,0.1,0,0.2,0,0.2c0.1,0.2,0.1,0.4,0.1,0.5\r\n\t\t\t\tc0,0.3,0,0.6,0,0.9v0.1c0,0.7-0.1,1.4-0.3,2.3c-0.1,0.7-0.5,1.4-0.8,2c-0.3,0.5-0.6,1.1-0.9,1.8l-0.1,0.5c-0.2,1-0.2,1,0.1,1.2\r\n\t\t\t\ts0.5,0.5,0.8,1c1.4,2.6,1.7,4.7,1.7,7.7c0,1.5-0.3,2.9-0.6,4.4v0.2c-0.4,1.9-0.8,3.9-0.5,5.9c0.1,0.6,0.2,1.2,0.3,1.7l0.1,0.4\r\n\t\t\t\tc0.1,0.7,0.3,1.4,0.3,2.1v1.9c0,3.7,0,7.4,0.6,11.1l0.1,1c0.3,2.2,0.5,3.8-0.6,6l-0.3,0.7c-0.8,1.7-1.5,2.9-1.9,4.8\r\n\t\t\t\tc-0.1,0.9-0.2,2-0.2,3v0.6c0,2-0.1,4-0.8,5.9c-0.2,0.5-0.5,0.9-0.6,1.3c-0.6,1.1-0.9,1.8-0.9,3.2v0.1c-0.1,0.8-0.2,1.6-0.4,2.6\r\n\t\t\t\tc-0.3,2.1-0.7,4.4-0.4,6.3c0.1,0.4,0.4,0.9,0.7,1.5l0.1,0.1c0.2,0.3,0.7,1.3,0.8,1.6c0.1,0.4,0,0.8-0.3,1.1\r\n\t\t\t\tc-0.3,0.2-0.7,0.3-1.5,0.5c-0.6,0.1-0.9,0.2-1.3,0.4c-0.9,0.7-1.7,1.8-2.6,2.8l-0.1,0.2c-0.5,0.6-1,1.2-1.5,1.7\r\n\t\t\t\tc-1.7,1.8-3.6,4.1-4,6.7c-0.1,0.3-0.3,0.6-0.6,0.7C695.7,481.9,695.5,481.9,695.4,481.9z\"/>\r\n\r\n\t\t</g>\r\n\t</g>\r\n\t<g>\r\n\t\t<text transform=\"matrix(1 0 0 1 633.6995 370.9099)\" class=\"label-active\">BA</text>\r\n\t</g>\r\n</g>\r\n</svg>\r\n"

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(83);


/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(483);
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(107));
	util.inherits = __webpack_require__(52);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(145).Buffer;
	var util = __webpack_require__(2238);
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();
	
	if (util && util.inspect && util.inspect.custom) {
	  module.exports.prototype[util.inspect.custom] = function () {
	    var obj = util.inspect({ length: this.length });
	    return this.constructor.name + ' ' + obj;
	  };
	}

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(220).PassThrough


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(220).Transform


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(219);


/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (function() { return this })() || Function("return this")();
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(1713);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}


/***/ }),
/* 1713 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = ripemd160
	
	
	
	/*
	CryptoJS v3.1.2
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.
	
	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	
	// Constants table
	var zl = [
	    0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	    7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	    3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	    1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	    4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13];
	var zr = [
	    5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	    6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	    15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	    8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	    12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11];
	var sl = [
	     11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	    7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	    11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	      11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	    9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ];
	var sr = [
	    8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	    9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	    9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	    15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	    8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ];
	
	var hl =  [ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E];
	var hr =  [ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000];
	
	var bytesToWords = function (bytes) {
	  var words = [];
	  for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
	    words[b >>> 5] |= bytes[i] << (24 - b % 32);
	  }
	  return words;
	};
	
	var wordsToBytes = function (words) {
	  var bytes = [];
	  for (var b = 0; b < words.length * 32; b += 8) {
	    bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	  }
	  return bytes;
	};
	
	var processBlock = function (H, M, offset) {
	
	  // Swap endian
	  for (var i = 0; i < 16; i++) {
	    var offset_i = offset + i;
	    var M_offset_i = M[offset_i];
	
	    // Swap
	    M[offset_i] = (
	        (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	        (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	    );
	  }
	
	  // Working variables
	  var al, bl, cl, dl, el;
	  var ar, br, cr, dr, er;
	
	  ar = al = H[0];
	  br = bl = H[1];
	  cr = cl = H[2];
	  dr = dl = H[3];
	  er = el = H[4];
	  // Computation
	  var t;
	  for (var i = 0; i < 80; i += 1) {
	    t = (al +  M[offset+zl[i]])|0;
	    if (i<16){
	        t +=  f1(bl,cl,dl) + hl[0];
	    } else if (i<32) {
	        t +=  f2(bl,cl,dl) + hl[1];
	    } else if (i<48) {
	        t +=  f3(bl,cl,dl) + hl[2];
	    } else if (i<64) {
	        t +=  f4(bl,cl,dl) + hl[3];
	    } else {// if (i<80) {
	        t +=  f5(bl,cl,dl) + hl[4];
	    }
	    t = t|0;
	    t =  rotl(t,sl[i]);
	    t = (t+el)|0;
	    al = el;
	    el = dl;
	    dl = rotl(cl, 10);
	    cl = bl;
	    bl = t;
	
	    t = (ar + M[offset+zr[i]])|0;
	    if (i<16){
	        t +=  f5(br,cr,dr) + hr[0];
	    } else if (i<32) {
	        t +=  f4(br,cr,dr) + hr[1];
	    } else if (i<48) {
	        t +=  f3(br,cr,dr) + hr[2];
	    } else if (i<64) {
	        t +=  f2(br,cr,dr) + hr[3];
	    } else {// if (i<80) {
	        t +=  f1(br,cr,dr) + hr[4];
	    }
	    t = t|0;
	    t =  rotl(t,sr[i]) ;
	    t = (t+er)|0;
	    ar = er;
	    er = dr;
	    dr = rotl(cr, 10);
	    cr = br;
	    br = t;
	  }
	  // Intermediate hash value
	  t    = (H[1] + cl + dr)|0;
	  H[1] = (H[2] + dl + er)|0;
	  H[2] = (H[3] + el + ar)|0;
	  H[3] = (H[4] + al + br)|0;
	  H[4] = (H[0] + bl + cr)|0;
	  H[0] =  t;
	};
	
	function f1(x, y, z) {
	  return ((x) ^ (y) ^ (z));
	}
	
	function f2(x, y, z) {
	  return (((x)&(y)) | ((~x)&(z)));
	}
	
	function f3(x, y, z) {
	  return (((x) | (~(y))) ^ (z));
	}
	
	function f4(x, y, z) {
	  return (((x) & (z)) | ((y)&(~(z))));
	}
	
	function f5(x, y, z) {
	  return ((x) ^ ((y) |(~(z))));
	}
	
	function rotl(x,n) {
	  return (x<<n) | (x>>>(32-n));
	}
	
	function ripemd160(message) {
	  var H = [0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0];
	
	  if (typeof message == 'string')
	    message = new Buffer(message, 'utf8');
	
	  var m = bytesToWords(message);
	
	  var nBitsLeft = message.length * 8;
	  var nBitsTotal = message.length * 8;
	
	  // Add padding
	  m[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	  m[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	      (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	      (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	  );
	
	  for (var i=0 ; i<m.length; i += 16) {
	    processBlock(H, m, i);
	  }
	
	  // Swap endian
	  for (var i = 0; i < 5; i++) {
	      // Shortcut
	    var H_i = H[i];
	
	    // Swap
	    H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	          (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	  }
	
	  var digestbytes = wordsToBytes(H);
	  return new Buffer(digestbytes);
	}
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32).Buffer))

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	var twoProduct = __webpack_require__(495)
	var twoSum = __webpack_require__(1760)
	
	module.exports = scaleLinearExpansion
	
	function scaleLinearExpansion(e, scale) {
	  var n = e.length
	  if(n === 1) {
	    var ts = twoProduct(e[0], scale)
	    if(ts[0]) {
	      return ts
	    }
	    return [ ts[1] ]
	  }
	  var g = new Array(2 * n)
	  var q = [0.1, 0.1]
	  var t = [0.1, 0.1]
	  var count = 0
	  twoProduct(e[0], scale, q)
	  if(q[0]) {
	    g[count++] = q[0]
	  }
	  for(var i=1; i<n; ++i) {
	    twoProduct(e[i], scale, t)
	    var pq = q[1]
	    twoSum(pq, t[0], q)
	    if(q[0]) {
	      g[count++] = q[0]
	    }
	    var a = t[1]
	    var b = q[1]
	    var x = a + b
	    var bv = x - a
	    var y = b - bv
	    q[1] = x
	    if(y) {
	      g[count++] = y
	    }
	  }
	  if(q[1]) {
	    g[count++] = q[1]
	  }
	  if(count === 0) {
	    g[count++] = 0.0
	  }
	  g.length = count
	  return g
	}

/***/ }),
/* 1716 */
/***/ (function(module, exports) {

	"use strict"
	
	module.exports = robustSubtract
	
	//Easy case: Add two scalars
	function scalarScalar(a, b) {
	  var x = a + b
	  var bv = x - a
	  var av = x - bv
	  var br = b - bv
	  var ar = a - av
	  var y = ar + br
	  if(y) {
	    return [y, x]
	  }
	  return [x]
	}
	
	function robustSubtract(e, f) {
	  var ne = e.length|0
	  var nf = f.length|0
	  if(ne === 1 && nf === 1) {
	    return scalarScalar(e[0], -f[0])
	  }
	  var n = ne + nf
	  var g = new Array(n)
	  var count = 0
	  var eptr = 0
	  var fptr = 0
	  var abs = Math.abs
	  var ei = e[eptr]
	  var ea = abs(ei)
	  var fi = -f[fptr]
	  var fa = abs(fi)
	  var a, b
	  if(ea < fa) {
	    b = ei
	    eptr += 1
	    if(eptr < ne) {
	      ei = e[eptr]
	      ea = abs(ei)
	    }
	  } else {
	    b = fi
	    fptr += 1
	    if(fptr < nf) {
	      fi = -f[fptr]
	      fa = abs(fi)
	    }
	  }
	  if((eptr < ne && ea < fa) || (fptr >= nf)) {
	    a = ei
	    eptr += 1
	    if(eptr < ne) {
	      ei = e[eptr]
	      ea = abs(ei)
	    }
	  } else {
	    a = fi
	    fptr += 1
	    if(fptr < nf) {
	      fi = -f[fptr]
	      fa = abs(fi)
	    }
	  }
	  var x = a + b
	  var bv = x - a
	  var y = b - bv
	  var q0 = y
	  var q1 = x
	  var _x, _bv, _av, _br, _ar
	  while(eptr < ne && fptr < nf) {
	    if(ea < fa) {
	      a = ei
	      eptr += 1
	      if(eptr < ne) {
	        ei = e[eptr]
	        ea = abs(ei)
	      }
	    } else {
	      a = fi
	      fptr += 1
	      if(fptr < nf) {
	        fi = -f[fptr]
	        fa = abs(fi)
	      }
	    }
	    b = q0
	    x = a + b
	    bv = x - a
	    y = b - bv
	    if(y) {
	      g[count++] = y
	    }
	    _x = q1 + x
	    _bv = _x - q1
	    _av = _x - _bv
	    _br = x - _bv
	    _ar = q1 - _av
	    q0 = _ar + _br
	    q1 = _x
	  }
	  while(eptr < ne) {
	    a = ei
	    b = q0
	    x = a + b
	    bv = x - a
	    y = b - bv
	    if(y) {
	      g[count++] = y
	    }
	    _x = q1 + x
	    _bv = _x - q1
	    _av = _x - _bv
	    _br = x - _bv
	    _ar = q1 - _av
	    q0 = _ar + _br
	    q1 = _x
	    eptr += 1
	    if(eptr < ne) {
	      ei = e[eptr]
	    }
	  }
	  while(fptr < nf) {
	    a = fi
	    b = q0
	    x = a + b
	    bv = x - a
	    y = b - bv
	    if(y) {
	      g[count++] = y
	    } 
	    _x = q1 + x
	    _bv = _x - q1
	    _av = _x - _bv
	    _br = x - _bv
	    _ar = q1 - _av
	    q0 = _ar + _br
	    q1 = _x
	    fptr += 1
	    if(fptr < nf) {
	      fi = -f[fptr]
	    }
	  }
	  if(q0) {
	    g[count++] = q0
	  }
	  if(q1) {
	    g[count++] = q1
	  }
	  if(!count) {
	    g[count++] = 0.0  
	  }
	  g.length = count
	  return g
	}

/***/ }),
/* 1717 */
/***/ (function(module, exports) {

	"use strict"
	
	module.exports = linearExpansionSum
	
	//Easy case: Add two scalars
	function scalarScalar(a, b) {
	  var x = a + b
	  var bv = x - a
	  var av = x - bv
	  var br = b - bv
	  var ar = a - av
	  var y = ar + br
	  if(y) {
	    return [y, x]
	  }
	  return [x]
	}
	
	function linearExpansionSum(e, f) {
	  var ne = e.length|0
	  var nf = f.length|0
	  if(ne === 1 && nf === 1) {
	    return scalarScalar(e[0], f[0])
	  }
	  var n = ne + nf
	  var g = new Array(n)
	  var count = 0
	  var eptr = 0
	  var fptr = 0
	  var abs = Math.abs
	  var ei = e[eptr]
	  var ea = abs(ei)
	  var fi = f[fptr]
	  var fa = abs(fi)
	  var a, b
	  if(ea < fa) {
	    b = ei
	    eptr += 1
	    if(eptr < ne) {
	      ei = e[eptr]
	      ea = abs(ei)
	    }
	  } else {
	    b = fi
	    fptr += 1
	    if(fptr < nf) {
	      fi = f[fptr]
	      fa = abs(fi)
	    }
	  }
	  if((eptr < ne && ea < fa) || (fptr >= nf)) {
	    a = ei
	    eptr += 1
	    if(eptr < ne) {
	      ei = e[eptr]
	      ea = abs(ei)
	    }
	  } else {
	    a = fi
	    fptr += 1
	    if(fptr < nf) {
	      fi = f[fptr]
	      fa = abs(fi)
	    }
	  }
	  var x = a + b
	  var bv = x - a
	  var y = b - bv
	  var q0 = y
	  var q1 = x
	  var _x, _bv, _av, _br, _ar
	  while(eptr < ne && fptr < nf) {
	    if(ea < fa) {
	      a = ei
	      eptr += 1
	      if(eptr < ne) {
	        ei = e[eptr]
	        ea = abs(ei)
	      }
	    } else {
	      a = fi
	      fptr += 1
	      if(fptr < nf) {
	        fi = f[fptr]
	        fa = abs(fi)
	      }
	    }
	    b = q0
	    x = a + b
	    bv = x - a
	    y = b - bv
	    if(y) {
	      g[count++] = y
	    }
	    _x = q1 + x
	    _bv = _x - q1
	    _av = _x - _bv
	    _br = x - _bv
	    _ar = q1 - _av
	    q0 = _ar + _br
	    q1 = _x
	  }
	  while(eptr < ne) {
	    a = ei
	    b = q0
	    x = a + b
	    bv = x - a
	    y = b - bv
	    if(y) {
	      g[count++] = y
	    }
	    _x = q1 + x
	    _bv = _x - q1
	    _av = _x - _bv
	    _br = x - _bv
	    _ar = q1 - _av
	    q0 = _ar + _br
	    q1 = _x
	    eptr += 1
	    if(eptr < ne) {
	      ei = e[eptr]
	    }
	  }
	  while(fptr < nf) {
	    a = fi
	    b = q0
	    x = a + b
	    bv = x - a
	    y = b - bv
	    if(y) {
	      g[count++] = y
	    } 
	    _x = q1 + x
	    _bv = _x - q1
	    _av = _x - _bv
	    _br = x - _bv
	    _ar = q1 - _av
	    q0 = _ar + _br
	    q1 = _x
	    fptr += 1
	    if(fptr < nf) {
	      fi = f[fptr]
	    }
	  }
	  if(q0) {
	    g[count++] = q0
	  }
	  if(q1) {
	    g[count++] = q1
	  }
	  if(!count) {
	    g[count++] = 0.0  
	  }
	  g.length = count
	  return g
	}

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(82)))

/***/ }),
/* 1719 */
/***/ (function(module, exports) {

	module.exports = function (Buffer) {
	
	  //prototype class for hash functions
	  function Hash (blockSize, finalSize) {
	    this._block = new Buffer(blockSize) //new Uint32Array(blockSize/4)
	    this._finalSize = finalSize
	    this._blockSize = blockSize
	    this._len = 0
	    this._s = 0
	  }
	
	  Hash.prototype.init = function () {
	    this._s = 0
	    this._len = 0
	  }
	
	  Hash.prototype.update = function (data, enc) {
	    if ("string" === typeof data) {
	      enc = enc || "utf8"
	      data = new Buffer(data, enc)
	    }
	
	    var l = this._len += data.length
	    var s = this._s = (this._s || 0)
	    var f = 0
	    var buffer = this._block
	
	    while (s < l) {
	      var t = Math.min(data.length, f + this._blockSize - (s % this._blockSize))
	      var ch = (t - f)
	
	      for (var i = 0; i < ch; i++) {
	        buffer[(s % this._blockSize) + i] = data[i + f]
	      }
	
	      s += ch
	      f += ch
	
	      if ((s % this._blockSize) === 0) {
	        this._update(buffer)
	      }
	    }
	    this._s = s
	
	    return this
	  }
	
	  Hash.prototype.digest = function (enc) {
	    // Suppose the length of the message M, in bits, is l
	    var l = this._len * 8
	
	    // Append the bit 1 to the end of the message
	    this._block[this._len % this._blockSize] = 0x80
	
	    // and then k zero bits, where k is the smallest non-negative solution to the equation (l + 1 + k) === finalSize mod blockSize
	    this._block.fill(0, this._len % this._blockSize + 1)
	
	    if (l % (this._blockSize * 8) >= this._finalSize * 8) {
	      this._update(this._block)
	      this._block.fill(0)
	    }
	
	    // to this append the block which is equal to the number l written in binary
	    // TODO: handle case where l is > Math.pow(2, 29)
	    this._block.writeInt32BE(l, this._blockSize - 4)
	
	    var hash = this._update(this._block) || this._hash()
	
	    return enc ? hash.toString(enc) : hash
	  }
	
	  Hash.prototype._update = function () {
	    throw new Error('_update must be implemented by subclass')
	  }
	
	  return Hash
	}


/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

	var exports = module.exports = function (alg) {
	  var Alg = exports[alg]
	  if(!Alg) throw new Error(alg + ' is not supported (we accept pull requests)')
	  return new Alg()
	}
	
	var Buffer = __webpack_require__(32).Buffer
	var Hash   = __webpack_require__(1719)(Buffer)
	
	exports.sha1 = __webpack_require__(1721)(Buffer, Hash)
	exports.sha256 = __webpack_require__(1722)(Buffer, Hash)
	exports.sha512 = __webpack_require__(1723)(Buffer, Hash)


/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */
	
	var inherits = __webpack_require__(159).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var A = 0|0
	  var B = 4|0
	  var C = 8|0
	  var D = 12|0
	  var E = 16|0
	
	  var W = new (typeof Int32Array === 'undefined' ? Array : Int32Array)(80)
	
	  var POOL = []
	
	  function Sha1 () {
	    if(POOL.length)
	      return POOL.pop().init()
	
	    if(!(this instanceof Sha1)) return new Sha1()
	    this._w = W
	    Hash.call(this, 16*4, 14*4)
	
	    this._h = null
	    this.init()
	  }
	
	  inherits(Sha1, Hash)
	
	  Sha1.prototype.init = function () {
	    this._a = 0x67452301
	    this._b = 0xefcdab89
	    this._c = 0x98badcfe
	    this._d = 0x10325476
	    this._e = 0xc3d2e1f0
	
	    Hash.prototype.init.call(this)
	    return this
	  }
	
	  Sha1.prototype._POOL = POOL
	  Sha1.prototype._update = function (X) {
	
	    var a, b, c, d, e, _a, _b, _c, _d, _e
	
	    a = _a = this._a
	    b = _b = this._b
	    c = _c = this._c
	    d = _d = this._d
	    e = _e = this._e
	
	    var w = this._w
	
	    for(var j = 0; j < 80; j++) {
	      var W = w[j] = j < 16 ? X.readInt32BE(j*4)
	        : rol(w[j - 3] ^ w[j -  8] ^ w[j - 14] ^ w[j - 16], 1)
	
	      var t = add(
	        add(rol(a, 5), sha1_ft(j, b, c, d)),
	        add(add(e, W), sha1_kt(j))
	      )
	
	      e = d
	      d = c
	      c = rol(b, 30)
	      b = a
	      a = t
	    }
	
	    this._a = add(a, _a)
	    this._b = add(b, _b)
	    this._c = add(c, _c)
	    this._d = add(d, _d)
	    this._e = add(e, _e)
	  }
	
	  Sha1.prototype._hash = function () {
	    if(POOL.length < 100) POOL.push(this)
	    var H = new Buffer(20)
	    //console.log(this._a|0, this._b|0, this._c|0, this._d|0, this._e|0)
	    H.writeInt32BE(this._a|0, A)
	    H.writeInt32BE(this._b|0, B)
	    H.writeInt32BE(this._c|0, C)
	    H.writeInt32BE(this._d|0, D)
	    H.writeInt32BE(this._e|0, E)
	    return H
	  }
	
	  /*
	   * Perform the appropriate triplet combination function for the current
	   * iteration
	   */
	  function sha1_ft(t, b, c, d) {
	    if(t < 20) return (b & c) | ((~b) & d);
	    if(t < 40) return b ^ c ^ d;
	    if(t < 60) return (b & c) | (b & d) | (c & d);
	    return b ^ c ^ d;
	  }
	
	  /*
	   * Determine the appropriate additive constant for the current iteration
	   */
	  function sha1_kt(t) {
	    return (t < 20) ?  1518500249 : (t < 40) ?  1859775393 :
	           (t < 60) ? -1894007588 : -899497514;
	  }
	
	  /*
	   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	   * to work around bugs in some JS interpreters.
	   * //dominictarr: this is 10 years old, so maybe this can be dropped?)
	   *
	   */
	  function add(x, y) {
	    return (x + y ) | 0
	  //lets see how this goes on testling.
	  //  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  //  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  //  return (msw << 16) | (lsw & 0xFFFF);
	  }
	
	  /*
	   * Bitwise rotate a 32-bit number to the left.
	   */
	  function rol(num, cnt) {
	    return (num << cnt) | (num >>> (32 - cnt));
	  }
	
	  return Sha1
	}


/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(159).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var K = [
	      0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
	      0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
	      0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
	      0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
	      0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
	      0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
	      0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
	      0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
	      0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
	      0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
	      0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
	      0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
	      0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
	      0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
	      0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
	      0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
	    ]
	
	  var W = new Array(64)
	
	  function Sha256() {
	    this.init()
	
	    this._w = W //new Array(64)
	
	    Hash.call(this, 16*4, 14*4)
	  }
	
	  inherits(Sha256, Hash)
	
	  Sha256.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, n) {
	    return (X >>> n) | (X << (32 - n));
	  }
	
	  function R (X, n) {
	    return (X >>> n);
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  function Sigma0256 (x) {
	    return (S(x, 2) ^ S(x, 13) ^ S(x, 22));
	  }
	
	  function Sigma1256 (x) {
	    return (S(x, 6) ^ S(x, 11) ^ S(x, 25));
	  }
	
	  function Gamma0256 (x) {
	    return (S(x, 7) ^ S(x, 18) ^ R(x, 3));
	  }
	
	  function Gamma1256 (x) {
	    return (S(x, 17) ^ S(x, 19) ^ R(x, 10));
	  }
	
	  Sha256.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var T1, T2
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    for (var j = 0; j < 64; j++) {
	      var w = W[j] = j < 16
	        ? M.readInt32BE(j * 4)
	        : Gamma1256(W[j - 2]) + W[j - 7] + Gamma0256(W[j - 15]) + W[j - 16]
	
	      T1 = h + Sigma1256(e) + Ch(e, f, g) + K[j] + w
	
	      T2 = Sigma0256(a) + Maj(a, b, c);
	      h = g; g = f; f = e; e = d + T1; d = c; c = b; b = a; a = T1 + T2;
	    }
	
	    this._a = (a + this._a) | 0
	    this._b = (b + this._b) | 0
	    this._c = (c + this._c) | 0
	    this._d = (d + this._d) | 0
	    this._e = (e + this._e) | 0
	    this._f = (f + this._f) | 0
	    this._g = (g + this._g) | 0
	    this._h = (h + this._h) | 0
	
	  };
	
	  Sha256.prototype._hash = function () {
	    var H = new Buffer(32)
	
	    H.writeInt32BE(this._a,  0)
	    H.writeInt32BE(this._b,  4)
	    H.writeInt32BE(this._c,  8)
	    H.writeInt32BE(this._d, 12)
	    H.writeInt32BE(this._e, 16)
	    H.writeInt32BE(this._f, 20)
	    H.writeInt32BE(this._g, 24)
	    H.writeInt32BE(this._h, 28)
	
	    return H
	  }
	
	  return Sha256
	
	}


/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(159).inherits
	
	module.exports = function (Buffer, Hash) {
	  var K = [
	    0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	    0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	    0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	    0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	    0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	    0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	    0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	    0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	    0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	    0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	    0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	    0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	    0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	    0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	    0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	    0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	    0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	    0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	    0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	    0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	    0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	    0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	    0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	    0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	    0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	    0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	    0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	    0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	    0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	    0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	    0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	    0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	    0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	    0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	    0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	    0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	    0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	    0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	    0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	    0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	  ]
	
	  var W = new Array(160)
	
	  function Sha512() {
	    this.init()
	    this._w = W
	
	    Hash.call(this, 128, 112)
	  }
	
	  inherits(Sha512, Hash)
	
	  Sha512.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._al = 0xf3bcc908|0
	    this._bl = 0x84caa73b|0
	    this._cl = 0xfe94f82b|0
	    this._dl = 0x5f1d36f1|0
	    this._el = 0xade682d1|0
	    this._fl = 0x2b3e6c1f|0
	    this._gl = 0xfb41bd6b|0
	    this._hl = 0x137e2179|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, Xl, n) {
	    return (X >>> n) | (Xl << (32 - n))
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  Sha512.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var al, bl, cl, dl, el, fl, gl, hl
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    al = this._al | 0
	    bl = this._bl | 0
	    cl = this._cl | 0
	    dl = this._dl | 0
	    el = this._el | 0
	    fl = this._fl | 0
	    gl = this._gl | 0
	    hl = this._hl | 0
	
	    for (var i = 0; i < 80; i++) {
	      var j = i * 2
	
	      var Wi, Wil
	
	      if (i < 16) {
	        Wi = W[j] = M.readInt32BE(j * 4)
	        Wil = W[j + 1] = M.readInt32BE(j * 4 + 4)
	
	      } else {
	        var x  = W[j - 15*2]
	        var xl = W[j - 15*2 + 1]
	        var gamma0  = S(x, xl, 1) ^ S(x, xl, 8) ^ (x >>> 7)
	        var gamma0l = S(xl, x, 1) ^ S(xl, x, 8) ^ S(xl, x, 7)
	
	        x  = W[j - 2*2]
	        xl = W[j - 2*2 + 1]
	        var gamma1  = S(x, xl, 19) ^ S(xl, x, 29) ^ (x >>> 6)
	        var gamma1l = S(xl, x, 19) ^ S(x, xl, 29) ^ S(xl, x, 6)
	
	        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	        var Wi7  = W[j - 7*2]
	        var Wi7l = W[j - 7*2 + 1]
	
	        var Wi16  = W[j - 16*2]
	        var Wi16l = W[j - 16*2 + 1]
	
	        Wil = gamma0l + Wi7l
	        Wi  = gamma0  + Wi7 + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0)
	        Wil = Wil + gamma1l
	        Wi  = Wi  + gamma1  + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0)
	        Wil = Wil + Wi16l
	        Wi  = Wi  + Wi16 + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0)
	
	        W[j] = Wi
	        W[j + 1] = Wil
	      }
	
	      var maj = Maj(a, b, c)
	      var majl = Maj(al, bl, cl)
	
	      var sigma0h = S(a, al, 28) ^ S(al, a, 2) ^ S(al, a, 7)
	      var sigma0l = S(al, a, 28) ^ S(a, al, 2) ^ S(a, al, 7)
	      var sigma1h = S(e, el, 14) ^ S(e, el, 18) ^ S(el, e, 9)
	      var sigma1l = S(el, e, 14) ^ S(el, e, 18) ^ S(e, el, 9)
	
	      // t1 = h + sigma1 + ch + K[i] + W[i]
	      var Ki = K[j]
	      var Kil = K[j + 1]
	
	      var ch = Ch(e, f, g)
	      var chl = Ch(el, fl, gl)
	
	      var t1l = hl + sigma1l
	      var t1 = h + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0)
	      t1l = t1l + chl
	      t1 = t1 + ch + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0)
	      t1l = t1l + Kil
	      t1 = t1 + Ki + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0)
	      t1l = t1l + Wil
	      t1 = t1 + Wi + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0)
	
	      // t2 = sigma0 + maj
	      var t2l = sigma0l + majl
	      var t2 = sigma0h + maj + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0)
	
	      h  = g
	      hl = gl
	      g  = f
	      gl = fl
	      f  = e
	      fl = el
	      el = (dl + t1l) | 0
	      e  = (d + t1 + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	      d  = c
	      dl = cl
	      c  = b
	      cl = bl
	      b  = a
	      bl = al
	      al = (t1l + t2l) | 0
	      a  = (t1 + t2 + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0
	    }
	
	    this._al = (this._al + al) | 0
	    this._bl = (this._bl + bl) | 0
	    this._cl = (this._cl + cl) | 0
	    this._dl = (this._dl + dl) | 0
	    this._el = (this._el + el) | 0
	    this._fl = (this._fl + fl) | 0
	    this._gl = (this._gl + gl) | 0
	    this._hl = (this._hl + hl) | 0
	
	    this._a = (this._a + a + ((this._al >>> 0) < (al >>> 0) ? 1 : 0)) | 0
	    this._b = (this._b + b + ((this._bl >>> 0) < (bl >>> 0) ? 1 : 0)) | 0
	    this._c = (this._c + c + ((this._cl >>> 0) < (cl >>> 0) ? 1 : 0)) | 0
	    this._d = (this._d + d + ((this._dl >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	    this._e = (this._e + e + ((this._el >>> 0) < (el >>> 0) ? 1 : 0)) | 0
	    this._f = (this._f + f + ((this._fl >>> 0) < (fl >>> 0) ? 1 : 0)) | 0
	    this._g = (this._g + g + ((this._gl >>> 0) < (gl >>> 0) ? 1 : 0)) | 0
	    this._h = (this._h + h + ((this._hl >>> 0) < (hl >>> 0) ? 1 : 0)) | 0
	  }
	
	  Sha512.prototype._hash = function () {
	    var H = new Buffer(64)
	
	    function writeInt64BE(h, l, offset) {
	      H.writeInt32BE(h, offset)
	      H.writeInt32BE(l, offset + 4)
	    }
	
	    writeInt64BE(this._a, this._al, 0)
	    writeInt64BE(this._b, this._bl, 8)
	    writeInt64BE(this._c, this._cl, 16)
	    writeInt64BE(this._d, this._dl, 24)
	    writeInt64BE(this._e, this._el, 32)
	    writeInt64BE(this._f, this._fl, 40)
	    writeInt64BE(this._g, this._gl, 48)
	    writeInt64BE(this._h, this._hl, 56)
	
	    return H
	  }
	
	  return Sha512
	
	}


/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"; "use restrict";
	
	var bits      = __webpack_require__(778)
	  , UnionFind = __webpack_require__(1765)
	
	//Returns the dimension of a cell complex
	function dimension(cells) {
	  var d = 0
	    , max = Math.max
	  for(var i=0, il=cells.length; i<il; ++i) {
	    d = max(d, cells[i].length)
	  }
	  return d-1
	}
	exports.dimension = dimension
	
	//Counts the number of vertices in faces
	function countVertices(cells) {
	  var vc = -1
	    , max = Math.max
	  for(var i=0, il=cells.length; i<il; ++i) {
	    var c = cells[i]
	    for(var j=0, jl=c.length; j<jl; ++j) {
	      vc = max(vc, c[j])
	    }
	  }
	  return vc+1
	}
	exports.countVertices = countVertices
	
	//Returns a deep copy of cells
	function cloneCells(cells) {
	  var ncells = new Array(cells.length)
	  for(var i=0, il=cells.length; i<il; ++i) {
	    ncells[i] = cells[i].slice(0)
	  }
	  return ncells
	}
	exports.cloneCells = cloneCells
	
	//Ranks a pair of cells up to permutation
	function compareCells(a, b) {
	  var n = a.length
	    , t = a.length - b.length
	    , min = Math.min
	  if(t) {
	    return t
	  }
	  switch(n) {
	    case 0:
	      return 0;
	    case 1:
	      return a[0] - b[0];
	    case 2:
	      var d = a[0]+a[1]-b[0]-b[1]
	      if(d) {
	        return d
	      }
	      return min(a[0],a[1]) - min(b[0],b[1])
	    case 3:
	      var l1 = a[0]+a[1]
	        , m1 = b[0]+b[1]
	      d = l1+a[2] - (m1+b[2])
	      if(d) {
	        return d
	      }
	      var l0 = min(a[0], a[1])
	        , m0 = min(b[0], b[1])
	        , d  = min(l0, a[2]) - min(m0, b[2])
	      if(d) {
	        return d
	      }
	      return min(l0+a[2], l1) - min(m0+b[2], m1)
	    
	    //TODO: Maybe optimize n=4 as well?
	    
	    default:
	      var as = a.slice(0)
	      as.sort()
	      var bs = b.slice(0)
	      bs.sort()
	      for(var i=0; i<n; ++i) {
	        t = as[i] - bs[i]
	        if(t) {
	          return t
	        }
	      }
	      return 0
	  }
	}
	exports.compareCells = compareCells
	
	function compareZipped(a, b) {
	  return compareCells(a[0], b[0])
	}
	
	//Puts a cell complex into normal order for the purposes of findCell queries
	function normalize(cells, attr) {
	  if(attr) {
	    var len = cells.length
	    var zipped = new Array(len)
	    for(var i=0; i<len; ++i) {
	      zipped[i] = [cells[i], attr[i]]
	    }
	    zipped.sort(compareZipped)
	    for(var i=0; i<len; ++i) {
	      cells[i] = zipped[i][0]
	      attr[i] = zipped[i][1]
	    }
	    return cells
	  } else {
	    cells.sort(compareCells)
	    return cells
	  }
	}
	exports.normalize = normalize
	
	//Removes all duplicate cells in the complex
	function unique(cells) {
	  if(cells.length === 0) {
	    return []
	  }
	  var ptr = 1
	    , len = cells.length
	  for(var i=1; i<len; ++i) {
	    var a = cells[i]
	    if(compareCells(a, cells[i-1])) {
	      if(i === ptr) {
	        ptr++
	        continue
	      }
	      cells[ptr++] = a
	    }
	  }
	  cells.length = ptr
	  return cells
	}
	exports.unique = unique;
	
	//Finds a cell in a normalized cell complex
	function findCell(cells, c) {
	  var lo = 0
	    , hi = cells.length-1
	    , r  = -1
	  while (lo <= hi) {
	    var mid = (lo + hi) >> 1
	      , s   = compareCells(cells[mid], c)
	    if(s <= 0) {
	      if(s === 0) {
	        r = mid
	      }
	      lo = mid + 1
	    } else if(s > 0) {
	      hi = mid - 1
	    }
	  }
	  return r
	}
	exports.findCell = findCell;
	
	//Builds an index for an n-cell.  This is more general than dual, but less efficient
	function incidence(from_cells, to_cells) {
	  var index = new Array(from_cells.length)
	  for(var i=0, il=index.length; i<il; ++i) {
	    index[i] = []
	  }
	  var b = []
	  for(var i=0, n=to_cells.length; i<n; ++i) {
	    var c = to_cells[i]
	    var cl = c.length
	    for(var k=1, kn=(1<<cl); k<kn; ++k) {
	      b.length = bits.popCount(k)
	      var l = 0
	      for(var j=0; j<cl; ++j) {
	        if(k & (1<<j)) {
	          b[l++] = c[j]
	        }
	      }
	      var idx=findCell(from_cells, b)
	      if(idx < 0) {
	        continue
	      }
	      while(true) {
	        index[idx++].push(i)
	        if(idx >= from_cells.length || compareCells(from_cells[idx], b) !== 0) {
	          break
	        }
	      }
	    }
	  }
	  return index
	}
	exports.incidence = incidence
	
	//Computes the dual of the mesh.  This is basically an optimized version of buildIndex for the situation where from_cells is just the list of vertices
	function dual(cells, vertex_count) {
	  if(!vertex_count) {
	    return incidence(unique(skeleton(cells, 0)), cells, 0)
	  }
	  var res = new Array(vertex_count)
	  for(var i=0; i<vertex_count; ++i) {
	    res[i] = []
	  }
	  for(var i=0, len=cells.length; i<len; ++i) {
	    var c = cells[i]
	    for(var j=0, cl=c.length; j<cl; ++j) {
	      res[c[j]].push(i)
	    }
	  }
	  return res
	}
	exports.dual = dual
	
	//Enumerates all cells in the complex
	function explode(cells) {
	  var result = []
	  for(var i=0, il=cells.length; i<il; ++i) {
	    var c = cells[i]
	      , cl = c.length|0
	    for(var j=1, jl=(1<<cl); j<jl; ++j) {
	      var b = []
	      for(var k=0; k<cl; ++k) {
	        if((j >>> k) & 1) {
	          b.push(c[k])
	        }
	      }
	      result.push(b)
	    }
	  }
	  return normalize(result)
	}
	exports.explode = explode
	
	//Enumerates all of the n-cells of a cell complex
	function skeleton(cells, n) {
	  if(n < 0) {
	    return []
	  }
	  var result = []
	    , k0     = (1<<(n+1))-1
	  for(var i=0; i<cells.length; ++i) {
	    var c = cells[i]
	    for(var k=k0; k<(1<<c.length); k=bits.nextCombination(k)) {
	      var b = new Array(n+1)
	        , l = 0
	      for(var j=0; j<c.length; ++j) {
	        if(k & (1<<j)) {
	          b[l++] = c[j]
	        }
	      }
	      result.push(b)
	    }
	  }
	  return normalize(result)
	}
	exports.skeleton = skeleton;
	
	//Computes the boundary of all cells, does not remove duplicates
	function boundary(cells) {
	  var res = []
	  for(var i=0,il=cells.length; i<il; ++i) {
	    var c = cells[i]
	    for(var j=0,cl=c.length; j<cl; ++j) {
	      var b = new Array(c.length-1)
	      for(var k=0, l=0; k<cl; ++k) {
	        if(k !== j) {
	          b[l++] = c[k]
	        }
	      }
	      res.push(b)
	    }
	  }
	  return normalize(res)
	}
	exports.boundary = boundary;
	
	//Computes connected components for a dense cell complex
	function connectedComponents_dense(cells, vertex_count) {
	  var labels = new UnionFind(vertex_count)
	  for(var i=0; i<cells.length; ++i) {
	    var c = cells[i]
	    for(var j=0; j<c.length; ++j) {
	      for(var k=j+1; k<c.length; ++k) {
	        labels.link(c[j], c[k])
	      }
	    }
	  }
	  var components = []
	    , component_labels = labels.ranks
	  for(var i=0; i<component_labels.length; ++i) {
	    component_labels[i] = -1
	  }
	  for(var i=0; i<cells.length; ++i) {
	    var l = labels.find(cells[i][0])
	    if(component_labels[l] < 0) {
	      component_labels[l] = components.length
	      components.push([cells[i].slice(0)])
	    } else {
	      components[component_labels[l]].push(cells[i].slice(0))
	    }
	  }
	  return components
	}
	
	//Computes connected components for a sparse graph
	function connectedComponents_sparse(cells) {
	  var vertices  = unique(normalize(skeleton(cells, 0)))
	    , labels    = new UnionFind(vertices.length)
	  for(var i=0; i<cells.length; ++i) {
	    var c = cells[i]
	    for(var j=0; j<c.length; ++j) {
	      var vj = findCell(vertices, [c[j]])
	      for(var k=j+1; k<c.length; ++k) {
	        labels.link(vj, findCell(vertices, [c[k]]))
	      }
	    }
	  }
	  var components        = []
	    , component_labels  = labels.ranks
	  for(var i=0; i<component_labels.length; ++i) {
	    component_labels[i] = -1
	  }
	  for(var i=0; i<cells.length; ++i) {
	    var l = labels.find(findCell(vertices, [cells[i][0]]));
	    if(component_labels[l] < 0) {
	      component_labels[l] = components.length
	      components.push([cells[i].slice(0)])
	    } else {
	      components[component_labels[l]].push(cells[i].slice(0))
	    }
	  }
	  return components
	}
	
	//Computes connected components for a cell complex
	function connectedComponents(cells, vertex_count) {
	  if(vertex_count) {
	    return connectedComponents_dense(cells, vertex_count)
	  }
	  return connectedComponents_sparse(cells)
	}
	exports.connectedComponents = connectedComponents


/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(218).EventEmitter;
	var inherits = __webpack_require__(52);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(220);
	Stream.Writable = __webpack_require__(1711);
	Stream.Duplex = __webpack_require__(1706);
	Stream.Transform = __webpack_require__(1710);
	Stream.PassThrough = __webpack_require__(1709);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

	var measureDistance = __webpack_require__(39);
	var point = __webpack_require__(17).point;
	var bearing = __webpack_require__(148);
	var destination = __webpack_require__(149);
	
	/**
	 * Takes a {@link LineString|line} and returns a {@link Point|point} at a specified distance along the line.
	 *
	 * @name along
	 * @param {Feature<LineString>} line input line
	 * @param {number} distance distance along the line
	 * @param {String} [units=miles] can be degrees, radians, miles, or kilometers
	 * @return {Feature<Point>} Point `distance` `units` along the line
	 * @example
	 * var line = {
	 *   "type": "Feature",
	 *   "properties": {},
	 *   "geometry": {
	 *     "type": "LineString",
	 *     "coordinates": [
	 *       [-77.031669, 38.878605],
	 *       [-77.029609, 38.881946],
	 *       [-77.020339, 38.884084],
	 *       [-77.025661, 38.885821],
	 *       [-77.021884, 38.889563],
	 *       [-77.019824, 38.892368]
	 *     ]
	 *   }
	 * };
	 *
	 * var along = turf.along(line, 1, 'miles');
	 *
	 * var result = {
	 *   "type": "FeatureCollection",
	 *   "features": [line, along]
	 * };
	 *
	 * //=result
	 */
	module.exports = function (line, distance, units) {
	    var coords;
	    if (line.type === 'Feature') coords = line.geometry.coordinates;
	    else if (line.type === 'LineString') coords = line.coordinates;
	    else throw new Error('input must be a LineString Feature or Geometry');
	
	    var travelled = 0;
	    for (var i = 0; i < coords.length; i++) {
	        if (distance >= travelled && i === coords.length - 1) break;
	        else if (travelled >= distance) {
	            var overshot = distance - travelled;
	            if (!overshot) return point(coords[i]);
	            else {
	                var direction = bearing(coords[i], coords[i - 1]) - 180;
	                var interpolated = destination(coords[i], overshot, direction, units);
	                return interpolated;
	            }
	        } else {
	            travelled += measureDistance(coords[i], coords[i + 1], units);
	        }
	    }
	    return point(coords[coords.length - 1]);
	};


/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

	var geometryArea = __webpack_require__(1687).geometry;
	
	/**
	 * Takes a one or more features and returns their area
	 * in square meters.
	 *
	 * @param {(Feature|FeatureCollection)} input input features
	 * @return {Number} area in square meters
	 * @example
	 * var polygons = {
	 *   "type": "FeatureCollection",
	 *   "features": [
	 *     {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Polygon",
	 *         "coordinates": [[
	 *           [-67.031021, 10.458102],
	 *           [-67.031021, 10.53372],
	 *           [-66.929397, 10.53372],
	 *           [-66.929397, 10.458102],
	 *           [-67.031021, 10.458102]
	 *         ]]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Polygon",
	 *         "coordinates": [[
	 *           [-66.919784, 10.397325],
	 *           [-66.919784, 10.513467],
	 *           [-66.805114, 10.513467],
	 *           [-66.805114, 10.397325],
	 *           [-66.919784, 10.397325]
	 *         ]]
	 *       }
	 *     }
	 *   ]
	 * };
	 *
	 * var area = turf.area(polygons);
	 *
	 * //=area
	 */
	function area(input) {
	    if (input.type === 'FeatureCollection') {
	        for (var i = 0, sum = 0; i < input.features.length; i++) {
	            if (input.features[i].geometry) {
	                sum += geometryArea(input.features[i].geometry);
	            }
	        }
	        return sum;
	    } else if (input.type === 'Feature') {
	        return geometryArea(input.geometry);
	    } else {
	        return geometryArea(input);
	    }
	}
	module.exports = area;


/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

	var linestring = __webpack_require__(17).lineString;
	var Spline = __webpack_require__(1729);
	
	/**
	 * Takes a {@link LineString|line} and returns a curved version
	 * by applying a [Bezier spline](http://en.wikipedia.org/wiki/B%C3%A9zier_spline)
	 * algorithm.
	 *
	 * The bezier spline implementation is by [Leszek Rybicki](http://leszek.rybicki.cc/).
	 *
	 * @name bezier
	 * @param {Feature<LineString>} line input LineString
	 * @param {Number} [resolution=10000] time in milliseconds between points
	 * @param {Number} [sharpness=0.85] a measure of how curvy the path should be between splines
	 * @returns {Feature<LineString>} curved line
	 * @example
	 * var line = {
	 *   "type": "Feature",
	 *   "properties": {
	 *     "stroke": "#f00"
	 *   },
	 *   "geometry": {
	 *     "type": "LineString",
	 *     "coordinates": [
	 *       [-76.091308, 18.427501],
	 *       [-76.695556, 18.729501],
	 *       [-76.552734, 19.40443],
	 *       [-74.61914, 19.134789],
	 *       [-73.652343, 20.07657],
	 *       [-73.157958, 20.210656]
	 *     ]
	 *   }
	 * };
	 *
	 * var curved = turf.bezier(line);
	 * curved.properties = { stroke: '#0f0' };
	 *
	 * var result = {
	 *   "type": "FeatureCollection",
	 *   "features": [line, curved]
	 * };
	 *
	 * //=result
	 */
	module.exports = function (line, resolution, sharpness) {
	    var lineOut = linestring([]);
	
	    lineOut.properties = line.properties;
	
	    var spline = new Spline({
	        points: line.geometry.coordinates.map(function (pt) {
	            return {x: pt[0], y: pt[1]};
	        }),
	        duration: resolution,
	        sharpness: sharpness
	    });
	
	    for (var i = 0; i < spline.duration; i += 10) {
	        var pos = spline.pos(i);
	        if (Math.floor(i / 100) % 2 === 0) {
	            lineOut.geometry.coordinates.push([pos.x, pos.y]);
	        }
	    }
	
	    return lineOut;
	};


/***/ }),
/* 1729 */
/***/ (function(module, exports) {

	/* eslint-disable */
	
	 /**
	   * BezierSpline
	   * https://github.com/leszekr/bezier-spline-js
	   *
	   * @private
	   * @copyright
	   * Copyright (c) 2013 Leszek Rybicki
	   *
	   * Permission is hereby granted, free of charge, to any person obtaining a copy
	   * of this software and associated documentation files (the "Software"), to deal
	   * in the Software without restriction, including without limitation the rights
	   * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	   * copies of the Software, and to permit persons to whom the Software is
	   * furnished to do so, subject to the following conditions:
	   *
	   * The above copyright notice and this permission notice shall be included in all
	   * copies or substantial portions of the Software.
	   *
	   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	   * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	   * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	   * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	   * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	   * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	   * SOFTWARE.
	   */
	var Spline = function (options) {
	    this.points = options.points || [];
	    this.duration = options.duration || 10000;
	    this.sharpness = options.sharpness || 0.85;
	    this.centers = [];
	    this.controls = [];
	    this.stepLength = options.stepLength || 60;
	    this.length = this.points.length;
	    this.delay = 0;
	    // this is to ensure compatibility with the 2d version
	    for (var i = 0; i < this.length; i++) this.points[i].z = this.points[i].z || 0;
	    for (var i = 0; i < this.length - 1; i++) {
	        var p1 = this.points[i];
	        var p2 = this.points[i + 1];
	        this.centers.push({
	            x: (p1.x + p2.x) / 2,
	            y: (p1.y + p2.y) / 2,
	            z: (p1.z + p2.z) / 2
	        });
	    }
	    this.controls.push([this.points[0], this.points[0]]);
	    for (var i = 0; i < this.centers.length - 1; i++) {
	        var p1 = this.centers[i];
	        var p2 = this.centers[i + 1];
	        var dx = this.points[i + 1].x - (this.centers[i].x + this.centers[i + 1].x) / 2;
	        var dy = this.points[i + 1].y - (this.centers[i].y + this.centers[i + 1].y) / 2;
	        var dz = this.points[i + 1].z - (this.centers[i].y + this.centers[i + 1].z) / 2;
	        this.controls.push([{
	            x: (1.0 - this.sharpness) * this.points[i + 1].x + this.sharpness * (this.centers[i].x + dx),
	            y: (1.0 - this.sharpness) * this.points[i + 1].y + this.sharpness * (this.centers[i].y + dy),
	            z: (1.0 - this.sharpness) * this.points[i + 1].z + this.sharpness * (this.centers[i].z + dz)},
	            {
	                x: (1.0 - this.sharpness) * this.points[i + 1].x + this.sharpness * (this.centers[i + 1].x + dx),
	                y: (1.0 - this.sharpness) * this.points[i + 1].y + this.sharpness * (this.centers[i + 1].y + dy),
	                z: (1.0 - this.sharpness) * this.points[i + 1].z + this.sharpness * (this.centers[i + 1].z + dz)}]);
	    }
	    this.controls.push([this.points[this.length - 1], this.points[this.length - 1]]);
	    this.steps = this.cacheSteps(this.stepLength);
	    return this;
	};
	
	  /*
	    Caches an array of equidistant (more or less) points on the curve.
	  */
	Spline.prototype.cacheSteps = function (mindist) {
	    var steps = [];
	    var laststep = this.pos(0);
	    steps.push(0);
	    for (var t = 0; t < this.duration; t += 10) {
	        var step = this.pos(t);
	        var dist = Math.sqrt((step.x - laststep.x) * (step.x - laststep.x) + (step.y - laststep.y) * (step.y - laststep.y) + (step.z - laststep.z) * (step.z - laststep.z));
	        if (dist > mindist) {
	            steps.push(t);
	            laststep = step;
	        }
	    }
	    return steps;
	};
	
	  /*
	    returns angle and speed in the given point in the curve
	  */
	Spline.prototype.vector = function (t) {
	    var p1 = this.pos(t + 10);
	    var p2 = this.pos(t - 10);
	    return {
	        angle:180 * Math.atan2(p1.y - p2.y, p1.x - p2.x) / 3.14,
	        speed:Math.sqrt((p2.x - p1.x) * (p2.x - p1.x) + (p2.y - p1.y) * (p2.y - p1.y) + (p2.z - p1.z) * (p2.z - p1.z))
	    };
	};
	
	  /*
	    Gets the position of the point, given time.
	
	    WARNING: The speed is not constant. The time it takes between control points is constant.
	
	    For constant speed, use Spline.steps[i];
	  */
	Spline.prototype.pos = function (time) {
	
	    function bezier(t, p1, c1, c2, p2) {
	        var B = function (t) {
	            var t2 = t * t, t3 = t2 * t;
	            return [(t3), (3 * t2 * (1 - t)), (3 * t * (1 - t) * (1 - t)), ((1 - t) * (1 - t) * (1 - t))];
	        };
	        var b = B(t);
	        var pos = {
	            x : p2.x * b[0] + c2.x * b[1] + c1.x * b[2] + p1.x * b[3],
	            y : p2.y * b[0] + c2.y * b[1] + c1.y * b[2] + p1.y * b[3],
	            z : p2.z * b[0] + c2.z * b[1] + c1.z * b[2] + p1.z * b[3]
	        };
	        return pos;
	    }
	    var t = time - this.delay;
	    if (t < 0) t = 0;
	    if (t > this.duration) t = this.duration - 1;
	    //t = t-this.delay;
	    var t2 = (t) / this.duration;
	    if (t2 >= 1) return this.points[this.length - 1];
	
	    var n = Math.floor((this.points.length - 1) * t2);
	    var t1 = (this.length - 1) * t2 - n;
	    return bezier(t1, this.points[n], this.controls[n][1], this.controls[n + 1][0], this.points[n + 1]);
	};
	
	module.exports = Spline;


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

	// http://stackoverflow.com/questions/839899/how-do-i-calculate-a-point-on-a-circles-circumference
	// radians = degrees * (pi/180)
	// https://github.com/bjornharrtell/jsts/blob/master/examples/buffer.html
	
	var helpers = __webpack_require__(17);
	var featureCollection = helpers.featureCollection;
	var jsts = __webpack_require__(143);
	var normalize = __webpack_require__(1688);
	
	/**
	 * Calculates a buffer for input features for a given radius. Units supported are miles, kilometers, and degrees.
	 *
	 * @name buffer
	 * @param {(Feature|FeatureCollection)} feature input to be buffered
	 * @param {number} distance distance to draw the buffer
	 * @param {string} unit any of the options supported by turf units
	 * @return {FeatureCollection<Polygon>|FeatureCollection<MultiPolygon>|Polygon|MultiPolygon} buffered features
	 *
	 * @example
	 * var pt = {
	 *   "type": "Feature",
	 *   "properties": {},
	 *   "geometry": {
	 *     "type": "Point",
	 *     "coordinates": [-90.548630, 14.616599]
	 *   }
	 * };
	 * var unit = 'miles';
	 *
	 * var buffered = turf.buffer(pt, 500, unit);
	 * var result = turf.featurecollection([buffered, pt]);
	 *
	 * //=result
	 */
	
	module.exports = function (feature, radius, units) {
	
	    var degrees = helpers.distanceToDegrees(radius, units);
	    var fc = normalize(feature);
	    var buffered = normalize(featureCollection(fc.features.map(function (f) {
	        return bufferOp(f, degrees);
	    })));
	
	    if (buffered.features.length > 1) return buffered;
	    else if (buffered.features.length === 1) return buffered.features[0];
	};
	
	function bufferOp(feature, radius) {
	    var reader = new jsts.io.GeoJSONReader();
	    var geom = reader.read(feature.geometry);
	    var buffered = geom.buffer(radius);
	    var writer = new jsts.io.GeoJSONWriter();
	    buffered = writer.write(buffered);
	
	    return {
	        type: 'Feature',
	        geometry: buffered,
	        properties: {}
	    };
	}


/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

	var each = __webpack_require__(95).coordEach;
	var point = __webpack_require__(17).point;
	
	/**
	 * Takes one or more features and calculates the centroid using
	 * the mean of all vertices.
	 * This lessens the effect of small islands and artifacts when calculating
	 * the centroid of a set of polygons.
	 *
	 * @name centroid
	 * @param {(Feature|FeatureCollection)} features input features
	 * @return {Feature<Point>} the centroid of the input features
	 * @example
	 * var poly = {
	 *   "type": "Feature",
	 *   "properties": {},
	 *   "geometry": {
	 *     "type": "Polygon",
	 *     "coordinates": [[
	 *       [105.818939,21.004714],
	 *       [105.818939,21.061754],
	 *       [105.890007,21.061754],
	 *       [105.890007,21.004714],
	 *       [105.818939,21.004714]
	 *     ]]
	 *   }
	 * };
	 *
	 * var centroidPt = turf.centroid(poly);
	 *
	 * var result = {
	 *   "type": "FeatureCollection",
	 *   "features": [poly, centroidPt]
	 * };
	 *
	 * //=result
	 */
	module.exports = function (features) {
	    var xSum = 0, ySum = 0, len = 0;
	    each(features, function (coord) {
	        xSum += coord[0];
	        ySum += coord[1];
	        len++;
	    }, true);
	    return point([xSum / len, ySum / len]);
	};


/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

	var inside = __webpack_require__(94);
	
	/**
	 * Joins attributes FeatureCollection of polygons with a FeatureCollection of
	 * points. Given an `inProperty` on points and an `outProperty` for polygons,
	 * this finds every point that lies within each polygon, collects the `inProperty`
	 * values from those points, and adds them as an array to `outProperty` on the
	 * polygon.
	 *
	 * @name collect
	 * @param {FeatureCollection<Polygon>} polygons polygons with values on which to aggregate
	 * @param {FeatureCollection<Point>} points points to be aggregated
	 * @param {string} inProperty property to be nested from
	 * @param {string} outProperty property to be nested into
	 * @return {FeatureCollection<Polygon>} polygons with properties listed based on `outField`
	 * @example
	 * var poly1 = polygon([[[0,0],[10,0],[10,10],[0,10],[0,0]]]);
	 * var poly2 = polygon([[[10,0],[20,10],[20,20],[20,0],[10,0]]]);
	 * var polyFC = featurecollection([poly1, poly2]);
	 * var pt1 = point([5,5], {population: 200});
	 * var pt2 = point([1,3], {population: 600});
	 * var pt3 = point([14,2], {population: 100});
	 * var pt4 = point([13,1], {population: 200});
	 * var pt5 = point([19,7], {population: 300});
	 * var ptFC = featurecollection([pt1, pt2, pt3, pt4, pt5]);
	 * var aggregated = aggregate(polyFC, ptFC, 'population', 'values');
	 *
	 * aggregated.features[0].properties.values // => [200, 600]);
	 */
	module.exports = function collect(polygons, points, inProperty, outProperty) {
	    polygons.features.forEach(function (poly) {
	        var values = points.features.filter(function (pt) {
	            return inside(pt, poly);
	        }).map(function (pt) {
	            return pt.properties[inProperty];
	        });
	
	        if (!poly.properties) {
	            poly.properties = {};
	        }
	
	        poly.properties[outProperty] = values;
	    });
	
	    return polygons;
	};


/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

	var meta = __webpack_require__(95);
	
	/**
	 * Combines a {@link FeatureCollection} of {@link Point},
	 * {@link LineString}, or {@link Polygon} features
	 * into {@link MultiPoint}, {@link MultiLineString}, or
	 * {@link MultiPolygon} features.
	 *
	 * @name combine
	 * @param {FeatureCollection<(Point|LineString|Polygon)>} fc a FeatureCollection of any type
	 * @return {FeatureCollection<(MultiPoint|MultiLineString|MultiPolygon)>} a FeatureCollection of corresponding type to input
	 * @example
	 * var fc = {
	 *   "type": "FeatureCollection",
	 *   "features": [
	 *     {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [19.026432, 47.49134]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [19.074497, 47.509548]
	 *       }
	 *     }
	 *   ]
	 * };
	 *
	 * var combined = turf.combine(fc);
	 *
	 * //=combined
	 */
	
	module.exports = function (fc) {
	    var groups = {
	        MultiPoint: {coordinates: [], properties: []},
	        MultiLineString: {coordinates: [], properties: []},
	        MultiPolygon: {coordinates: [], properties: []}
	    };
	
	    var multiMapping = Object.keys(groups).reduce(function (memo, item) {
	        memo[item.replace('Multi', '')] = item;
	        return memo;
	    }, {});
	
	    function addToGroup(feature, key, multi) {
	        if (!multi) {
	            groups[key].coordinates.push(feature.geometry.coordinates);
	        } else {
	            groups[key].coordinates = groups[key].coordinates.concat(feature.geometry.coordinates);
	        }
	        groups[key].properties.push(feature.properties);
	    }
	
	    meta.featureEach(fc, function (feature) {
	        if (!feature.geometry) return;
	        if (groups[feature.geometry.type]) {
	            addToGroup(feature, feature.geometry.type, true);
	        } else if (multiMapping[feature.geometry.type]) {
	            addToGroup(feature, multiMapping[feature.geometry.type], false);
	        }
	    });
	
	    return {
	        type: 'FeatureCollection',
	        features: Object.keys(groups)
	            .filter(function (key) {
	                return groups[key].coordinates.length;
	            })
	            .sort()
	            .map(function (key) {
	                return {
	                    type: 'Feature',
	                    properties: {
	                        collectedProperties: groups[key].properties
	                    },
	                    geometry: {
	                        type: key,
	                        coordinates: groups[key].coordinates
	                    }
	                };
	            })
	    };
	};


/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

	// 1. run tin on points
	// 2. calculate lenth of all edges and area of all triangles
	// 3. remove triangles that fail the max length test
	// 4. buffer the results slightly
	// 5. merge the results
	var tin = __webpack_require__(222);
	var union = __webpack_require__(494);
	var distance = __webpack_require__(39);
	
	/**
	 * Takes a set of {@link Point|points} and returns a concave hull polygon.
	 *
	 * Internally, this uses [turf-tin](https://github.com/Turfjs/turf-tin) to generate geometries.
	 *
	 * @param {FeatureCollection<Point>} points input points
	 * @param {number} maxEdge the size of an edge necessary for part of the
	 * hull to become concave (in miles)
	 * @param {string} units used for maxEdge distance (miles or kilometers)
	 * @returns {Feature<Polygon>} a concave hull
	 * @throws {Error} if maxEdge parameter is missing
	 * @throws {Error} if units parameter is missing
	 * @example
	 * var points = {
	 *   "type": "FeatureCollection",
	 *   "features": [
	 *     {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-63.601226, 44.642643]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-63.591442, 44.651436]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-63.580799, 44.648749]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-63.573589, 44.641788]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-63.587665, 44.64533]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-63.595218, 44.64765]
	 *       }
	 *     }
	 *   ]
	 * };
	 *
	 * var hull = turf.concave(points, 1, 'miles');
	 *
	 * var resultFeatures = points.features.concat(hull);
	 * var result = {
	 *   "type": "FeatureCollection",
	 *   "features": resultFeatures
	 * };
	 *
	 * //=result
	 */
	function concave(points, maxEdge, units) {
	    if (typeof maxEdge !== 'number') throw new Error('maxEdge parameter is required');
	    if (typeof units !== 'string') throw new Error('units parameter is required');
	
	    var tinPolys = tin(points);
	    var filteredPolys = tinPolys.features.filter(filterTriangles);
	    tinPolys.features = filteredPolys;
	
	    function filterTriangles(triangle) {
	        var pt1 = triangle.geometry.coordinates[0][0];
	        var pt2 = triangle.geometry.coordinates[0][1];
	        var pt3 = triangle.geometry.coordinates[0][2];
	        var dist1 = distance(pt1, pt2, units);
	        var dist2 = distance(pt2, pt3, units);
	        var dist3 = distance(pt1, pt3, units);
	        return (dist1 <= maxEdge && dist2 <= maxEdge && dist3 <= maxEdge);
	    }
	
	    return merge(tinPolys);
	}
	
	function merge(polygons) {
	    var merged = JSON.parse(JSON.stringify(polygons.features[0])),
	        features = polygons.features;
	
	    for (var i = 0, len = features.length; i < len; i++) {
	        var poly = features[i];
	        if (poly.geometry) {
	            merged = union(merged, poly);
	        }
	    }
	    return merged;
	}
	
	module.exports = concave;


/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	var each = __webpack_require__(95).coordEach,
	    convexHull = __webpack_require__(783),
	    polygon = __webpack_require__(17).polygon;
	
	/**
	 * Takes a set of {@link Point|points} and returns a
	 * [convex hull](http://en.wikipedia.org/wiki/Convex_hull) polygon.
	 *
	 * Internally this uses
	 * the [convex-hull](https://github.com/mikolalysenko/convex-hull) module that
	 * implements a [monotone chain hull](http://en.wikibooks.org/wiki/Algorithm_Implementation/Geometry/Convex_hull/Monotone_chain).
	 *
	 * @name convex
	 * @param {FeatureCollection<Point>} featurecollection input points
	 * @returns {Feature<Polygon>} a convex hull
	 * @example
	 * var points = {
	 *   "type": "FeatureCollection",
	 *   "features": [
	 *     {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [10.195312, 43.755225]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [10.404052, 43.8424511]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [10.579833, 43.659924]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [10.360107, 43.516688]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [10.14038, 43.588348]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [10.195312, 43.755225]
	 *       }
	 *     }
	 *   ]
	 * };
	 *
	 * var hull = turf.convex(points);
	 *
	 * var resultFeatures = points.features.concat(hull);
	 * var result = {
	 *   "type": "FeatureCollection",
	 *   "features": resultFeatures
	 * };
	 *
	 * //=result
	 */
	module.exports = function (featurecollection) {
	    var points = [];
	    each(featurecollection, function (coord) { points.push(coord); });
	    var hull = convexHull(points);
	    if (hull.length > 0) {
	        var ring = [];
	        for (var i = 0; i < hull.length; i++) {
	            ring.push(points[hull[i][0]]);
	        }
	        ring.push(points[hull[hull.length - 1][1]]);
	        return polygon([ring]);
	    }
	    return undefined;
	};


/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

	// depend on jsts for now https://github.com/bjornharrtell/jsts/blob/master/examples/overlay.html
	var jsts = __webpack_require__(143);
	
	/**
	 * Finds the difference between two {@link Polygon|polygons} by clipping the second
	 * polygon from the first.
	 *
	 * @name difference
	 * @param {Feature<Polygon>} poly1 input Polygon feaure
	 * @param {Feature<Polygon>} poly2 Polygon feature to difference from `poly1`
	 * @return {Feature<Polygon>} a Polygon feature showing the area of `poly1` excluding the area of `poly2`
	 * @example
	 * var poly1 = {
	 *   "type": "Feature",
	 *   "properties": {
	 *     "fill": "#0f0"
	 *   },
	 *   "geometry": {
	 *     "type": "Polygon",
	 *     "coordinates": [[
	 *       [-46.738586, -23.596711],
	 *       [-46.738586, -23.458207],
	 *       [-46.560058, -23.458207],
	 *       [-46.560058, -23.596711],
	 *       [-46.738586, -23.596711]
	 *     ]]
	 *   }
	 * };
	 * var poly2 = {
	 *   "type": "Feature",
	 *   "properties": {
	 *     "fill": "#00f"
	 *   },
	 *   "geometry": {
	 *     "type": "Polygon",
	 *     "coordinates": [[
	 *       [-46.650009, -23.631314],
	 *       [-46.650009, -23.5237],
	 *       [-46.509246, -23.5237],
	 *       [-46.509246, -23.631314],
	 *       [-46.650009, -23.631314]
	 *     ]]
	 *   }
	 * };
	 *
	 * var differenced = turf.difference(poly1, poly2);
	 * differenced.properties.fill = '#f00';
	 *
	 * var polygons = {
	 *   "type": "FeatureCollection",
	 *   "features": [poly1, poly2]
	 * };
	 *
	 * //=polygons
	 *
	 * //=differenced
	 */
	
	module.exports = function (p1, p2) {
	    var poly1 = JSON.parse(JSON.stringify(p1));
	    var poly2 = JSON.parse(JSON.stringify(p2));
	    if (poly1.type !== 'Feature') {
	        poly1 = {
	            type: 'Feature',
	            properties: {},
	            geometry: poly1
	        };
	    }
	    if (poly2.type !== 'Feature') {
	        poly2 = {
	            type: 'Feature',
	            properties: {},
	            geometry: poly2
	        };
	    }
	
	    var reader = new jsts.io.GeoJSONReader();
	    var a = reader.read(JSON.stringify(poly1.geometry));
	    var b = reader.read(JSON.stringify(poly2.geometry));
	    var differenced = a.difference(b);
	
	    if (differenced.isEmpty()) return undefined;
	
	    var writer = new jsts.io.GeoJSONWriter();
	    var geojsonGeometry = writer.write(differenced);
	
	    poly1.geometry = differenced;
	
	    return {
	        type: 'Feature',
	        properties: poly1.properties,
	        geometry: geojsonGeometry
	    };
	};


/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

	var bbox = __webpack_require__(147);
	var bboxPolygon = __webpack_require__(488);
	
	/**
	 * Takes any number of features and returns a rectangular {@link Polygon} that encompasses all vertices.
	 *
	 * @name envelope
	 * @param {FeatureCollection} fc input features
	 * @return {Feature<Polygon>} a rectangular Polygon feature that encompasses all vertices
	 * @example
	 * var fc = {
	 *   "type": "FeatureCollection",
	 *   "features": [
	 *     {
	 *       "type": "Feature",
	 *       "properties": {
	 *         "name": "Location A"
	 *       },
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-75.343, 39.984]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {
	 *         "name": "Location B"
	 *       },
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-75.833, 39.284]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {
	 *         "name": "Location C"
	 *       },
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-75.534, 39.123]
	 *       }
	 *     }
	 *   ]
	 * };
	 *
	 * var enveloped = turf.envelope(fc);
	 *
	 * var resultFeatures = fc.features.concat(enveloped);
	 * var result = {
	 *   "type": "FeatureCollection",
	 *   "features": resultFeatures
	 * };
	 *
	 * //=result
	 */
	
	module.exports = function (features) {
	    return bboxPolygon(bbox(features));
	};


/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

	var coordEach = __webpack_require__(95).coordEach;
	
	/**
	 * Takes input features and flips all of their coordinates
	 * from `[x, y]` to `[y, x]`.
	 *
	 * @name flip
	 * @param {(Feature|FeatureCollection)} input input features
	 * @returns {(Feature|FeatureCollection)} a feature or set of features of the same type as `input` with flipped coordinates
	 * @example
	 * var serbia = {
	 *   "type": "Feature",
	 *   "properties": {},
	 *   "geometry": {
	 *     "type": "Point",
	 *     "coordinates": [20.566406, 43.421008]
	 *   }
	 * };
	 *
	 * //=serbia
	 *
	 * var saudiArabia = turf.flip(serbia);
	 *
	 * //=saudiArabia
	 */
	module.exports = function flip(input) {
	    // ensure that we don't modify features in-place and changes to the
	    // output do not change the previous feature, including changes to nested
	    // properties.
	    input = JSON.parse(JSON.stringify(input));
	
	    coordEach(input, function (coord) {
	        coord.reverse();
	    });
	    return input;
	};


/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

	var point = __webpack_require__(1751);
	
	/**
	 * Takes a bounding box and a cell depth and returns a {@link FeatureCollection} of {@link Point} features in a grid.
	 *
	 * @module turf/grid
	 * @category interpolation
	 * @param {Array<number>} extent extent in [minX, minY, maxX, maxY] order
	 * @param {Number} depth how many cells to output
	 * @return {FeatureCollection} grid as FeatureCollection with {@link Point} features
	 * @example
	 * var extent = [-70.823364, -33.553984, -70.473175, -33.302986];
	 * var depth = 10;
	 *
	 * var grid = turf.grid(extent, depth);
	 *
	 * //=grid
	 */
	module.exports = function(extents, depth) {
	  var xmin = extents[0];
	  var ymin = extents[1];
	  var xmax = extents[2];
	  var ymax = extents[3];
	  var interval = (xmax - xmin) / depth;
	  var coords = [];
	  var fc = {
	    type: 'FeatureCollection',
	    features: []
	  };
	
	  for (var x=0; x<=depth; x++){
	    for (var y=0;y<=depth; y++){
	      fc.features.push(point([(x * interval) + xmin, (y * interval) + ymin]));
	    }
	  }
	  return fc;
	}


/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

	var point = __webpack_require__(17).point;
	var polygon = __webpack_require__(17).polygon;
	var distance = __webpack_require__(39);
	var featurecollection = __webpack_require__(17).featureCollection;
	
	//Precompute cosines and sines of angles used in hexagon creation
	// for performance gain
	var cosines = [];
	var sines = [];
	for (var i = 0; i < 6; i++) {
	    var angle = 2 * Math.PI / 6 * i;
	    cosines.push(Math.cos(angle));
	    sines.push(Math.sin(angle));
	}
	
	/**
	 * Takes a bounding box and a cell size in degrees and returns a {@link FeatureCollection} of flat-topped
	 * hexagons ({@link Polygon} features) aligned in an "odd-q" vertical grid as
	 * described in [Hexagonal Grids](http://www.redblobgames.com/grids/hexagons/).
	 *
	 * @name hexGrid
	 * @param {Array<number>} bbox bounding box in [minX, minY, maxX, maxY] order
	 * @param {number} cellSize dimension of cell in specified units
	 * @param {string} units used in calculating cellWidth ('miles' or 'kilometers')
	 * @param {boolean} triangles whether to return as triangles instead of hexagons
	 * @return {FeatureCollection<Polygon>} a hexagonal grid
	 * @example
	 * var bbox = [-96,31,-84,40];
	 * var cellWidth = 50;
	 * var units = 'miles';
	 *
	 * var hexgrid = turf.hexGrid(bbox, cellWidth, units);
	 *
	 * //=hexgrid
	 */
	module.exports = function hexGrid(bbox, cellSize, units, triangles) {
	    var xFraction = cellSize / (distance(point([bbox[0], bbox[1]]), point([bbox[2], bbox[1]]), units));
	    var cellWidth = xFraction * (bbox[2] - bbox[0]);
	    var yFraction = cellSize / (distance(point([bbox[0], bbox[1]]), point([bbox[0], bbox[3]]), units));
	    var cellHeight = yFraction * (bbox[3] - bbox[1]);
	    var radius = cellWidth / 2;
	
	    var hex_width = radius * 2;
	    var hex_height = Math.sqrt(3) / 2 * cellHeight;
	
	    var box_width = bbox[2] - bbox[0];
	    var box_height = bbox[3] - bbox[1];
	
	    var x_interval = 3 / 4 * hex_width;
	    var y_interval = hex_height;
	
	    var x_span = box_width / (hex_width - radius / 2);
	    var x_count = Math.ceil(x_span);
	    if (Math.round(x_span) === x_count) {
	        x_count++;
	    }
	
	    var x_adjust = ((x_count * x_interval - radius / 2) - box_width) / 2 - radius / 2;
	
	    var y_count = Math.ceil(box_height / hex_height);
	
	    var y_adjust = (box_height - y_count * hex_height) / 2;
	
	    var hasOffsetY = y_count * hex_height - box_height > hex_height / 2;
	    if (hasOffsetY) {
	        y_adjust -= hex_height / 4;
	    }
	
	    var fc = featurecollection([]);
	    for (var x = 0; x < x_count; x++) {
	        for (var y = 0; y <= y_count; y++) {
	
	            var isOdd = x % 2 === 1;
	            if (y === 0 && isOdd) {
	                continue;
	            }
	
	            if (y === 0 && hasOffsetY) {
	                continue;
	            }
	
	            var center_x = x * x_interval + bbox[0] - x_adjust;
	            var center_y = y * y_interval + bbox[1] + y_adjust;
	
	            if (isOdd) {
	                center_y -= hex_height / 2;
	            }
	            if (triangles) {
	                fc.features.push.apply(fc.features, hexTriangles([center_x, center_y], cellWidth / 2, cellHeight / 2));
	            } else {
	                fc.features.push(hexagon([center_x, center_y], cellWidth / 2, cellHeight / 2));
	            }
	        }
	    }
	
	    return fc;
	};
	
	//Center should be [x, y]
	function hexagon(center, rx, ry) {
	    var vertices = [];
	    for (var i = 0; i < 6; i++) {
	        var x = center[0] + rx * cosines[i];
	        var y = center[1] + ry * sines[i];
	        vertices.push([x, y]);
	    }
	    //first and last vertex must be the same
	    vertices.push(vertices[0]);
	    return polygon([vertices]);
	}
	
	//Center should be [x, y]
	function hexTriangles(center, rx, ry) {
	    var triangles = [];
	    for (var i = 0; i < 6; i++) {
	        var vertices = [];
	        vertices.push(center);
	        vertices.push([
	            center[0] + rx * cosines[i],
	            center[1] + ry * sines[i]
	        ]);
	        vertices.push([
	            center[0] + rx * cosines[(i + 1) % 6],
	            center[1] + ry * sines[(i + 1) % 6]
	        ]);
	        vertices.push(center);
	        triangles.push(polygon([vertices]));
	    }
	    return triangles;
	}


/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

	// depend on jsts for now https://github.com/bjornharrtell/jsts/blob/master/examples/overlay.html
	var jsts = __webpack_require__(143);
	
	/**
	 * Takes two {@link Polygon|polygons} and finds their intersection. If they share a border, returns the border; if they don't intersect, returns undefined.
	 *
	 * @name intersect
	 * @param {Feature<Polygon>} poly1 the first polygon
	 * @param {Feature<Polygon>} poly2 the second polygon
	 * @return {(Feature<Polygon>|undefined|Feature<MultiLineString>)} if `poly1` and `poly2` overlap, returns a Polygon feature representing the area they overlap; if `poly1` and `poly2` do not overlap, returns `undefined`; if `poly1` and `poly2` share a border, a MultiLineString of the locations where their borders are shared
	 * @example
	 * var poly1 = {
	 *   "type": "Feature",
	 *   "properties": {
	 *     "fill": "#0f0"
	 *   },
	 *   "geometry": {
	 *     "type": "Polygon",
	 *     "coordinates": [[
	 *       [-122.801742, 45.48565],
	 *       [-122.801742, 45.60491],
	 *       [-122.584762, 45.60491],
	 *       [-122.584762, 45.48565],
	 *       [-122.801742, 45.48565]
	 *     ]]
	 *   }
	 * }
	 * var poly2 = {
	 *   "type": "Feature",
	 *   "properties": {
	 *     "fill": "#00f"
	 *   },
	 *   "geometry": {
	 *     "type": "Polygon",
	 *     "coordinates": [[
	 *       [-122.520217, 45.535693],
	 *       [-122.64038, 45.553967],
	 *       [-122.720031, 45.526554],
	 *       [-122.669906, 45.507309],
	 *       [-122.723464, 45.446643],
	 *       [-122.532577, 45.408574],
	 *       [-122.487258, 45.477466],
	 *       [-122.520217, 45.535693]
	 *     ]]
	 *   }
	 * }
	 *
	 * var polygons = {
	 *   "type": "FeatureCollection",
	 *   "features": [poly1, poly2]
	 * };
	 *
	 * var intersection = turf.intersect(poly1, poly2);
	 *
	 * //=polygons
	 *
	 * //=intersection
	 */
	module.exports = function intersect(poly1, poly2) {
	    var geom1, geom2;
	    if (poly1.type === 'Feature') geom1 = poly1.geometry;
	    else geom1 = poly1;
	    if (poly2.type === 'Feature') geom2 = poly2.geometry;
	    else geom2 = poly2;
	    var reader = new jsts.io.GeoJSONReader();
	    var a = reader.read(JSON.stringify(geom1));
	    var b = reader.read(JSON.stringify(geom2));
	    var intersection = a.intersection(b);
	
	    if (intersection.isEmpty()) {
	        return undefined;
	    }
	
	    var writer = new jsts.io.GeoJSONWriter();
	
	    var geojsonGeometry = writer.write(intersection);
	    return {
	        type: 'Feature',
	        properties: {},
	        geometry: geojsonGeometry
	    };
	};


/***/ }),
/* 1742 */
/***/ (function(module, exports) {

	/* eslint-disable */
	
	/*
	 * Copyright (c) 2010, Jason Davies.
	 *
	 * All rights reserved.  This code is based on Bradley White's Java version,
	 * which is in turn based on Nicholas Yue's C++ version, which in turn is based
	 * on Paul D. Bourke's original Fortran version.  See below for the respective
	 * copyright notices.
	 *
	 * See http://local.wasp.uwa.edu.au/~pbourke/papers/conrec/ for the original
	 * paper by Paul D. Bourke.
	 *
	 * The vector conversion code is based on http://apptree.net/conrec.htm by
	 * Graham Cox.
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are met:
	 *     * Redistributions of source code must retain the above copyright
	 *       notice, this list of conditions and the following disclaimer.
	 *     * Redistributions in binary form must reproduce the above copyright
	 *       notice, this list of conditions and the following disclaimer in the
	 *       documentation and/or other materials provided with the distribution.
	 *     * Neither the name of the <organization> nor the
	 *       names of its contributors may be used to endorse or promote products
	 *       derived from this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
	 * ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
	 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
	 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
	 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
	 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
	 * THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	/*
	 * Copyright (c) 1996-1997 Nicholas Yue
	 *
	 * This software is copyrighted by Nicholas Yue. This code is based on Paul D.
	 * Bourke's CONREC.F routine.
	 *
	 * The authors hereby grant permission to use, copy, and distribute this
	 * software and its documentation for any purpose, provided that existing
	 * copyright notices are retained in all copies and that this notice is
	 * included verbatim in any distributions. Additionally, the authors grant
	 * permission to modify this software and its documentation for any purpose,
	 * provided that such modifications are not distributed without the explicit
	 * consent of the authors and that existing copyright notices are retained in
	 * all copies. Some of the algorithms implemented by this software are
	 * patented, observe all applicable patent law.
	 *
	 * IN NO EVENT SHALL THE AUTHORS OR DISTRIBUTORS BE LIABLE TO ANY PARTY FOR
	 * DIRECT, INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT
	 * OF THE USE OF THIS SOFTWARE, ITS DOCUMENTATION, OR ANY DERIVATIVES THEREOF,
	 * EVEN IF THE AUTHORS HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 *
	 * THE AUTHORS AND DISTRIBUTORS SPECIFICALLY DISCLAIM ANY WARRANTIES,
	 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.  THIS SOFTWARE IS
	 * PROVIDED ON AN "AS IS" BASIS, AND THE AUTHORS AND DISTRIBUTORS HAVE NO
	 * OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT, UPDATES, ENHANCEMENTS, OR
	 * MODIFICATIONS.
	 */
	
	
	  module.exports = Conrec;
	
	  var EPSILON = 1e-10;
	
	  function pointsEqual(a, b) {
	      var x = a.x - b.x, y = a.y - b.y;
	      return x * x + y * y < EPSILON;
	  }
	
	  function reverseList(list) {
	      var pp = list.head;
	
	      while (pp) {
	      // swap prev/next pointers
	          var temp = pp.next;
	          pp.next = pp.prev;
	          pp.prev = temp;
	
	      // continue through the list
	          pp = temp;
	      }
	
	    // swap head/tail pointers
	      var temp = list.head;
	      list.head = list.tail;
	      list.tail = temp;
	  }
	
	  function ContourBuilder(level) {
	      this.level = level;
	      this.s = null;
	      this.count = 0;
	  }
	  ContourBuilder.prototype.remove_seq = function (list) {
	    // if list is the first item, static ptr s is updated
	      if (list.prev) {
	          list.prev.next = list.next;
	      } else {
	          this.s = list.next;
	      }
	
	      if (list.next) {
	          list.next.prev = list.prev;
	      }
	      --this.count;
	  };
	  ContourBuilder.prototype.addSegment = function (a, b) {
	      var ss = this.s;
	      var ma = null;
	      var mb = null;
	      var prependA = false;
	      var prependB = false;
	
	      while (ss) {
	          if (ma == null) {
	        // no match for a yet
	              if (pointsEqual(a, ss.head.p)) {
	                  ma = ss;
	                  prependA = true;
	              } else if (pointsEqual(a, ss.tail.p)) {
	                  ma = ss;
	              }
	          }
	          if (mb == null) {
	        // no match for b yet
	              if (pointsEqual(b, ss.head.p)) {
	                  mb = ss;
	                  prependB = true;
	              } else if (pointsEqual(b, ss.tail.p)) {
	                  mb = ss;
	              }
	          }
	      // if we matched both no need to continue searching
	          if (mb != null && ma != null) {
	              break;
	          } else {
	              ss = ss.next;
	          }
	      }
	
	    // c is the case selector based on which of ma and/or mb are set
	      var c = ((ma != null) ? 1 : 0) | ((mb != null) ? 2 : 0);
	
	      switch (c) {
	      case 0:   // both unmatched, add as new sequence
	          var aa = {p: a, prev: null};
	          var bb = {p: b, next: null};
	          aa.next = bb;
	          bb.prev = aa;
	
	        // create sequence element and push onto head of main list. The order
	        // of items in this list is unimportant
	          ma = {head: aa, tail: bb, next: this.s, prev: null, closed: false};
	          if (this.s) {
	              this.s.prev = ma;
	          }
	          this.s = ma;
	
	          ++this.count;    // not essential - tracks number of unmerged sequences
	          break;
	
	      case 1:   // a matched, b did not - thus b extends sequence ma
	          var pp = {p: b};
	
	          if (prependA) {
	              pp.next = ma.head;
	              pp.prev = null;
	              ma.head.prev = pp;
	              ma.head = pp;
	          } else {
	              pp.next = null;
	              pp.prev = ma.tail;
	              ma.tail.next = pp;
	              ma.tail = pp;
	          }
	          break;
	
	      case 2:   // b matched, a did not - thus a extends sequence mb
	          var pp = {p: a};
	
	          if (prependB) {
	              pp.next = mb.head;
	              pp.prev = null;
	              mb.head.prev = pp;
	              mb.head = pp;
	          } else {
	              pp.next = null;
	              pp.prev = mb.tail;
	              mb.tail.next = pp;
	              mb.tail = pp;
	          }
	          break;
	
	      case 3:   // both matched, can merge sequences
	        // if the sequences are the same, do nothing, as we are simply closing this path (could set a flag)
	
	          if (ma === mb) {
	              var pp = {p: ma.tail.p, next: ma.head, prev: null};
	              ma.head.prev = pp;
	              ma.head = pp;
	              ma.closed = true;
	              break;
	          }
	
	        // there are 4 ways the sequence pair can be joined. The current setting of prependA and
	        // prependB will tell us which type of join is needed. For head/head and tail/tail joins
	        // one sequence needs to be reversed
	          switch ((prependA ? 1 : 0) | (prependB ? 2 : 0)) {
	          case 0:   // tail-tail
	            // reverse ma and append to mb
	              reverseList(ma);
	            // fall through to head/tail case
	          case 1:   // head-tail
	            // ma is appended to mb and ma discarded
	              mb.tail.next = ma.head;
	              ma.head.prev = mb.tail;
	              mb.tail = ma.tail;
	
	            //discard ma sequence record
	              this.remove_seq(ma);
	              break;
	
	          case 3:   // head-head
	            // reverse ma and append mb to it
	              reverseList(ma);
	            // fall through to tail/head case
	          case 2:   // tail-head
	            // mb is appended to ma and mb is discarded
	              ma.tail.next = mb.head;
	              mb.head.prev = ma.tail;
	              ma.tail = mb.tail;
	
	            //discard mb sequence record
	              this.remove_seq(mb);
	              break;
	          }
	      }
	  };
	
	  /*
	   * Implements CONREC.
	   *
	   * @private
	   * @param {function} drawContour function for drawing contour.  Defaults to a
	   *                               custom "contour builder", which populates the
	   *                               contours property.
	   */
	  function Conrec(drawContour) {
	      if (!drawContour) {
	          var c = this;
	          c.contours = {};
	      /**
	       * drawContour - interface for implementing the user supplied method to
	       * render the countours.
	       *
	       * Draws a line between the start and end coordinates.
	       *
	       * @private
	       * @param startX    - start coordinate for X
	       * @param startY    - start coordinate for Y
	       * @param endX      - end coordinate for X
	       * @param endY      - end coordinate for Y
	       * @param contourLevel - Contour level for line.
	       */
	          this.drawContour = function (startX, startY, endX, endY, contourLevel, k) {
	              var cb = c.contours[k];
	              if (!cb) {
	                  cb = c.contours[k] = new ContourBuilder(contourLevel);
	              }
	              cb.addSegment({x: startX, y: startY}, {x: endX, y: endY});
	          };
	          this.contourList = function () {
	              var l = [];
	              var a = c.contours;
	              for (var k in a) {
	                  var s = a[k].s;
	                  var level = a[k].level;
	                  while (s) {
	                      var h = s.head;
	                      var l2 = [];
	                      l2.level = level;
	                      l2.k = k;
	                      while (h && h.p) {
	                          l2.push(h.p);
	                          h = h.next;
	                      }
	                      l.push(l2);
	                      s = s.next;
	                  }
	              }
	              l.sort(function (a, b) { return a.k - b.k; });
	              return l;
	          };
	      } else {
	          this.drawContour = drawContour;
	      }
	      this.h  = new Array(5);
	      this.sh = new Array(5);
	      this.xh = new Array(5);
	      this.yh = new Array(5);
	  }
	
	  /*
	   * contour is a contouring subroutine for rectangularily spaced data
	   *
	   * It emits calls to a line drawing subroutine supplied by the user which
	   * draws a contour map corresponding to real*4data on a randomly spaced
	   * rectangular grid. The coordinates emitted are in the same units given in
	   * the x() and y() arrays.
	   *
	   * Any number of contour levels may be specified but they must be in order of
	   * increasing value.
	   *
	   *
	   * @param {number[][]} d - matrix of data to contour
	   * @param {number} ilb,iub,jlb,jub - index bounds of data matrix
	   *
	   *             The following two, one dimensional arrays (x and y) contain
	   *             the horizontal and vertical coordinates of each sample points.
	   * @param {number[]} x  - data matrix column coordinates
	   * @param {number[]} y  - data matrix row coordinates
	   * @param {number} nc   - number of contour levels
	   * @param {number[]} z  - contour levels in increasing order.
	   */
	  Conrec.prototype.contour = function (d, ilb, iub, jlb, jub, x, y, nc, z) {
	      var h = this.h, sh = this.sh, xh = this.xh, yh = this.yh;
	      var drawContour = this.drawContour;
	      this.contours = {};
	
	      var xsect = function (p1, p2) {
	          return (h[p2] * xh[p1] - h[p1] * xh[p2]) / (h[p2] - h[p1]);
	      };
	
	      var ysect = function (p1, p2) {
	          return (h[p2] * yh[p1] - h[p1] * yh[p2]) / (h[p2] - h[p1]);
	      };
	      var m1;
	      var m2;
	      var m3;
	      var case_value;
	      var dmin;
	      var dmax;
	      var x1 = 0.0;
	      var x2 = 0.0;
	      var y1 = 0.0;
	      var y2 = 0.0;
	
	    // The indexing of im and jm should be noted as it has to start from zero
	    // unlike the fortran counter part
	      var im = [0, 1, 1, 0];
	      var jm = [0, 0, 1, 1];
	
	    // Note that castab is arranged differently from the FORTRAN code because
	    // Fortran and C/C++ arrays are transposed of each other, in this case
	    // it is more tricky as castab is in 3 dimensions
	      var castab = [
	          [
	        [0, 0, 8], [0, 2, 5], [7, 6, 9]
	          ],
	          [
	        [0, 3, 4], [1, 3, 1], [4, 3, 0]
	          ],
	          [
	        [9, 6, 7], [5, 2, 0], [8, 0, 0]
	          ]
	      ];
	
	      for (var j = (jub - 1); j >= jlb; j--) {
	          for (var i = ilb; i <= iub - 1; i++) {
	              var temp1, temp2;
	              temp1 = Math.min(d[i][j], d[i][j + 1]);
	              temp2 = Math.min(d[i + 1][j], d[i + 1][j + 1]);
	              dmin  = Math.min(temp1, temp2);
	              temp1 = Math.max(d[i][j], d[i][j + 1]);
	              temp2 = Math.max(d[i + 1][j], d[i + 1][j + 1]);
	              dmax  = Math.max(temp1, temp2);
	
	              if (dmax >= z[0] && dmin <= z[nc - 1]) {
	                  for (var k = 0; k < nc; k++) {
	                      if (z[k] >= dmin && z[k] <= dmax) {
	                          for (var m = 4; m >= 0; m--) {
	                            if (m > 0) {
	                  // The indexing of im and jm should be noted as it has to
	                  // start from zero
	                              h[m] = d[i + im[m - 1]][j + jm[m - 1]] - z[k];
	                              xh[m] = x[i + im[m - 1]];
	                              yh[m] = y[j + jm[m - 1]];
	                          } else {
	                              h[0] = 0.25 * (h[1] + h[2] + h[3] + h[4]);
	                              xh[0] = 0.5 * (x[i] + x[i + 1]);
	                              yh[0] = 0.5 * (y[j] + y[j + 1]);
	                          }
	                            if (h[m] > EPSILON) {
	                              sh[m] = 1;
	                          } else if (h[m] < -EPSILON) {
	                            sh[m] = -1;
	                        } else
	                  sh[m] = 0;
	                        }
	              //
	              // Note: at this stage the relative heights of the corners and the
	              // centre are in the h array, and the corresponding coordinates are
	              // in the xh and yh arrays. The centre of the box is indexed by 0
	              // and the 4 corners by 1 to 4 as shown below.
	              // Each triangle is then indexed by the parameter m, and the 3
	              // vertices of each triangle are indexed by parameters m1,m2,and
	              // m3.
	              // It is assumed that the centre of the box is always vertex 2
	              // though this isimportant only when all 3 vertices lie exactly on
	              // the same contour level, in which case only the side of the box
	              // is drawn.
	              //
	              //
	              //      vertex 4 +-------------------+ vertex 3
	              //               | \               / |
	              //               |   \    m-3    /   |
	              //               |     \       /     |
	              //               |       \   /       |
	              //               |  m=2    X   m=2   |       the centre is vertex 0
	              //               |       /   \       |
	              //               |     /       \     |
	              //               |   /    m=1    \   |
	              //               | /               \ |
	              //      vertex 1 +-------------------+ vertex 2
	              //
	              //
	              //
	              //               Scan each triangle in the box
	              //
	                          for (m = 1; m <= 4; m++) {
	                            m1 = m;
	                            m2 = 0;
	                            if (m != 4) {
	                              m3 = m + 1;
	                          } else {
	                              m3 = 1;
	                          }
	                            case_value = castab[sh[m1] + 1][sh[m2] + 1][sh[m3] + 1];
	                            if (case_value != 0) {
	                              switch (case_value) {
	                            case 1: // Line between vertices 1 and 2
	                                x1 = xh[m1];
	                                y1 = yh[m1];
	                                x2 = xh[m2];
	                                y2 = yh[m2];
	                                break;
	                            case 2: // Line between vertices 2 and 3
	                                x1 = xh[m2];
	                                y1 = yh[m2];
	                                x2 = xh[m3];
	                                y2 = yh[m3];
	                                break;
	                            case 3: // Line between vertices 3 and 1
	                                x1 = xh[m3];
	                                y1 = yh[m3];
	                                x2 = xh[m1];
	                                y2 = yh[m1];
	                                break;
	                            case 4: // Line between vertex 1 and side 2-3
	                                x1 = xh[m1];
	                                y1 = yh[m1];
	                                x2 = xsect(m2, m3);
	                                y2 = ysect(m2, m3);
	                                break;
	                            case 5: // Line between vertex 2 and side 3-1
	                                x1 = xh[m2];
	                                y1 = yh[m2];
	                                x2 = xsect(m3, m1);
	                                y2 = ysect(m3, m1);
	                                break;
	                            case 6: //  Line between vertex 3 and side 1-2
	                                x1 = xh[m3];
	                                y1 = yh[m3];
	                                x2 = xsect(m1, m2);
	                                y2 = ysect(m1, m2);
	                                break;
	                            case 7: // Line between sides 1-2 and 2-3
	                                x1 = xsect(m1, m2);
	                                y1 = ysect(m1, m2);
	                                x2 = xsect(m2, m3);
	                                y2 = ysect(m2, m3);
	                                break;
	                            case 8: // Line between sides 2-3 and 3-1
	                                x1 = xsect(m2, m3);
	                                y1 = ysect(m2, m3);
	                                x2 = xsect(m3, m1);
	                                y2 = ysect(m3, m1);
	                                break;
	                            case 9: // Line between sides 3-1 and 1-2
	                                x1 = xsect(m3, m1);
	                                y1 = ysect(m3, m1);
	                                x2 = xsect(m1, m2);
	                                y2 = ysect(m1, m2);
	                                break;
	                            default:
	                                break;
	                            }
	                  // Put your processing code here and comment out the printf
	                  //printf("%f %f %f %f %f\n",x1,y1,x2,y2,z[k]);
	                              drawContour(x1, y1, x2, y2, z[k], k);
	                          }
	                        }
	                      }
	                  }
	              }
	          }
	      }
	  };


/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

	//https://github.com/jasondavies/conrec.js
	//http://stackoverflow.com/questions/263305/drawing-a-topographical-map
	var tin = __webpack_require__(222);
	var inside = __webpack_require__(94);
	var grid = __webpack_require__(1739);
	var bbox = __webpack_require__(147);
	var planepoint = __webpack_require__(491);
	var featurecollection = __webpack_require__(17).featureCollection;
	var linestring = __webpack_require__(17).lineString;
	var square = __webpack_require__(493);
	var Conrec = __webpack_require__(1742);
	
	/**
	 * Takes {@link Point|points} with z-values and an array of
	 * value breaks and generates [isolines](http://en.wikipedia.org/wiki/Isoline).
	 *
	 * @name isolines
	 * @param {FeatureCollection<Point>} points input points
	 * @param {string} z the property name in `points` from which z-values will be pulled
	 * @param {number} resolution resolution of the underlying grid
	 * @param {Array<number>} breaks where to draw contours
	 * @returns {FeatureCollection<LineString>} isolines
	 * @example
	 * // create random points with random
	 * // z-values in their properties
	 * var points = turf.random('point', 100, {
	 *   bbox: [0, 30, 20, 50]
	 * });
	 * for (var i = 0; i < points.features.length; i++) {
	 *   points.features[i].properties.z = Math.random() * 10;
	 * }
	 * var breaks = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
	 * var isolined = turf.isolines(points, 'z', 15, breaks);
	 * //=isolined
	 */
	module.exports = function (points, z, resolution, breaks) {
	    var tinResult = tin(points, z);
	    var bboxBBox = bbox(points);
	    var squareBBox = square(bboxBBox);
	    var gridResult = grid(squareBBox, resolution);
	    var data = [];
	
	    for (var i = 0; i < gridResult.features.length; i++) {
	        var pt = gridResult.features[i];
	        for (var j = 0; j < tinResult.features.length; j++) {
	            var triangle = tinResult.features[j];
	            if (inside(pt, triangle)) {
	                pt.properties = {};
	                pt.properties[z] = planepoint(pt, triangle);
	            }
	        }
	    }
	
	    var depth = Math.sqrt(gridResult.features.length);
	    for (var x = 0; x < depth; x++) {
	        var xGroup = gridResult.features.slice(x * depth, (x + 1) * depth);
	        var xFlat = [];
	
	        for (var g = 0; g < xGroup.length; g++) {
	            if (xGroup[g].properties) {
	                xFlat.push(xGroup[g].properties[z]);
	            } else {
	                xFlat.push(0);
	            }
	        }
	        data.push(xFlat);
	    }
	    var interval = (squareBBox[2] - squareBBox[0]) / depth;
	    var xCoordinates = [];
	    var yCoordinates = [];
	    for (var d = 0; d < depth; d++) {
	        xCoordinates.push(d * interval + squareBBox[0]);
	        yCoordinates.push(d * interval + squareBBox[1]);
	    }
	
	    var c = new Conrec();
	    c.contour(data, 0, resolution, 0, resolution, xCoordinates, yCoordinates, breaks.length, breaks);
	    var contourList = c.contourList();
	
	    var fc = featurecollection([]);
	    contourList.forEach(function (c) {
	        if (c.length > 2) {
	            var polyCoordinates = [];
	            c.forEach(function (coord) {
	                polyCoordinates.push([coord.x, coord.y]);
	            });
	            var poly = linestring(polyCoordinates);
	            poly.properties = {};
	            poly.properties[z] = c.level;
	
	            fc.features.push(poly);
	        }
	    });
	
	    return fc;
	};


/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Takes a {@link Polygon|polygon} and returns {@link Point|points} at all self-intersections.
	 *
	 * @name kinks
	 * @param {Feature<Polygon>|Polygon} polygon input polygon
	 * @returns {FeatureCollection<Point>} self-intersections
	 * @example
	 * var poly = {
	 *   "type": "Feature",
	 *   "properties": {},
	 *   "geometry": {
	 *     "type": "Polygon",
	 *     "coordinates": [[
	 *       [-12.034835, 8.901183],
	 *       [-12.060413, 8.899826],
	 *       [-12.03638, 8.873199],
	 *       [-12.059383, 8.871418],
	 *       [-12.034835, 8.901183]
	 *     ]]
	 *   }
	 * };
	 *
	 * var kinks = turf.kinks(poly);
	 *
	 * var resultFeatures = kinks.intersections.features.concat(poly);
	 * var result = {
	 *   "type": "FeatureCollection",
	 *   "features": resultFeatures
	 * };
	 *
	 * //=result
	 */
	
	var point = __webpack_require__(17).point;
	
	module.exports = function (polyIn) {
	    var poly;
	    var results = {
	        type: 'FeatureCollection',
	        features: []
	    };
	    if (polyIn.type === 'Feature') {
	        poly = polyIn.geometry;
	    } else {
	        poly = polyIn;
	    }
	    poly.coordinates.forEach(function (ring1) {
	        poly.coordinates.forEach(function (ring2) {
	            for (var i = 0; i < ring1.length - 1; i++) {
	                for (var k = 0; k < ring2.length - 1; k++) {
	                    // don't check adjacent sides of a given ring, since of course they intersect in a vertex.
	                    if (ring1 === ring2 && (Math.abs(i - k) === 1 || Math.abs(i - k) === ring1.length - 2)) {
	                        continue;
	                    }
	
	                    var intersection = lineIntersects(ring1[i][0], ring1[i][1], ring1[i + 1][0], ring1[i + 1][1],
	                        ring2[k][0], ring2[k][1], ring2[k + 1][0], ring2[k + 1][1]);
	                    if (intersection) {
	                        results.features.push(point([intersection[0], intersection[1]]));
	                    }
	                }
	            }
	        });
	    });
	    return results;
	};
	
	
	// modified from http://jsfiddle.net/justin_c_rounds/Gd2S2/light/
	function lineIntersects(line1StartX, line1StartY, line1EndX, line1EndY, line2StartX, line2StartY, line2EndX, line2EndY) {
	    // if the lines intersect, the result contains the x and y of the intersection (treating the lines as infinite) and booleans for whether line segment 1 or line segment 2 contain the point
	    var denominator, a, b, numerator1, numerator2,
	        result = {
	            x: null,
	            y: null,
	            onLine1: false,
	            onLine2: false
	        };
	    denominator = ((line2EndY - line2StartY) * (line1EndX - line1StartX)) - ((line2EndX - line2StartX) * (line1EndY - line1StartY));
	    if (denominator === 0) {
	        if (result.x !== null && result.y !== null) {
	            return result;
	        } else {
	            return false;
	        }
	    }
	    a = line1StartY - line2StartY;
	    b = line1StartX - line2StartX;
	    numerator1 = ((line2EndX - line2StartX) * a) - ((line2EndY - line2StartY) * b);
	    numerator2 = ((line1EndX - line1StartX) * a) - ((line1EndY - line1StartY) * b);
	    a = numerator1 / denominator;
	    b = numerator2 / denominator;
	
	    // if we cast these lines infinitely in both directions, they intersect here:
	    result.x = line1StartX + (a * (line1EndX - line1StartX));
	    result.y = line1StartY + (a * (line1EndY - line1StartY));
	
	    // if line1 is a segment and line2 is infinite, they intersect if:
	    if (a >= 0 && a <= 1) {
	        result.onLine1 = true;
	    }
	    // if line2 is a segment and line1 is infinite, they intersect if:
	    if (b >= 0 && b <= 1) {
	        result.onLine2 = true;
	    }
	    // if line1 and line2 are segments, they intersect if both of the above are true
	    if (result.onLine1 && result.onLine2) {
	        return [result.x, result.y];
	    } else {
	        return false;
	    }
	}


/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

	var distance = __webpack_require__(39);
	var point = __webpack_require__(17).point;
	
	/**
	 * Takes a {@link LineString|line} and measures its length in the specified units.
	 *
	 * @name lineDistance
	 * @param {Feature<LineString>} line line to measure
	 * @param {String} [units=kilometers] can be degrees, radians, miles, or kilometers
	 * @return {Number} length of the input line
	 * @example
	 * var line = {
	 *   "type": "Feature",
	 *   "properties": {},
	 *   "geometry": {
	 *     "type": "LineString",
	 *     "coordinates": [
	 *       [-77.031669, 38.878605],
	 *       [-77.029609, 38.881946],
	 *       [-77.020339, 38.884084],
	 *       [-77.025661, 38.885821],
	 *       [-77.021884, 38.889563],
	 *       [-77.019824, 38.892368]
	 *     ]
	 *   }
	 * };
	 *
	 * var length = turf.lineDistance(line, 'miles');
	 *
	 * //=line
	 *
	 * //=length
	 */
	module.exports = function lineDistance(line, units) {
	    if (line.type === 'FeatureCollection') {
	        return line.features.reduce(function (memo, feature) {
	            return memo + lineDistance(feature, units);
	        }, 0);
	    }
	
	    var geometry = line.type === 'Feature' ? line.geometry : line;
	    var d, i;
	
	    if (geometry.type === 'LineString') {
	        return length(geometry.coordinates, units);
	    } else if (geometry.type === 'Polygon' || geometry.type === 'MultiLineString') {
	        d = 0;
	        for (i = 0; i < geometry.coordinates.length; i++) {
	            d += length(geometry.coordinates[i], units);
	        }
	        return d;
	    } else if (line.type === 'MultiPolygon') {
	        d = 0;
	        for (i = 0; i < geometry.coordinates.length; i++) {
	            for (var j = 0; j < geometry.coordinates[i].length; j++) {
	                d += length(geometry.coordinates[i][j], units);
	            }
	        }
	        return d;
	    } else {
	        throw new Error('input must be a LineString, MultiLineString, ' +
	            'Polygon, or MultiPolygon Feature or Geometry (or a FeatureCollection ' +
	            'containing only those types)');
	    }
	
	};
	
	function length(coords, units) {
	    var travelled = 0;
	    var prevCoords = point(coords[0]);
	    var curCoords = point(coords[0]);
	    var temp;
	    for (var i = 1; i < coords.length; i++) {
	        curCoords.geometry.coordinates = coords[i];
	        travelled += distance(prevCoords, curCoords, units);
	        temp = prevCoords;
	        prevCoords = curCoords;
	        curCoords = temp;
	    }
	    return travelled;
	}


/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

	var linestring = __webpack_require__(17).lineString;
	var pointOnLine = __webpack_require__(492);
	
	/**
	 * Takes a {@link LineString|line}, a start {@link Point}, and a stop point
	 * and returns a subsection of the line in-between those points.
	 * The start & stop points don't need to fall exactly on the line.
	 *
	 * This can be useful for extracting only the part of a route between waypoints.
	 *
	 * @name lineSlice
	 * @param {Feature<Point>} point1 starting point
	 * @param {Feature<Point>} point2 stopping point
	 * @param {Feature<LineString>|LineString} line line to slice
	 * @return {Feature<LineString>} sliced line
	 * @example
	 * var line = {
	 *   "type": "Feature",
	 *   "properties": {},
	 *   "geometry": {
	 *     "type": "LineString",
	 *     "coordinates": [
	 *       [-77.031669, 38.878605],
	 *       [-77.029609, 38.881946],
	 *       [-77.020339, 38.884084],
	 *       [-77.025661, 38.885821],
	 *       [-77.021884, 38.889563],
	 *       [-77.019824, 38.892368]
	 *     ]
	 *   }
	 * };
	 * var start = {
	 *   "type": "Feature",
	 *   "properties": {},
	 *   "geometry": {
	 *     "type": "Point",
	 *     "coordinates": [-77.029609, 38.881946]
	 *   }
	 * };
	 * var stop = {
	 *   "type": "Feature",
	 *   "properties": {},
	 *   "geometry": {
	 *     "type": "Point",
	 *     "coordinates": [-77.021884, 38.889563]
	 *   }
	 * };
	 *
	 * var sliced = turf.lineSlice(start, stop, line);
	 *
	 * //=line
	 *
	 * //=sliced
	 */
	
	module.exports = function lineSlice(startPt, stopPt, line) {
	    var coords;
	    if (line.type === 'Feature') {
	        coords = line.geometry.coordinates;
	    } else if (line.type === 'LineString') {
	        coords = line.coordinates;
	    } else {
	        throw new Error('input must be a LineString Feature or Geometry');
	    }
	
	    var startVertex = pointOnLine(line, startPt);
	    var stopVertex = pointOnLine(line, stopPt);
	    var ends;
	    if (startVertex.properties.index <= stopVertex.properties.index) {
	        ends = [startVertex, stopVertex];
	    } else {
	        ends = [stopVertex, startVertex];
	    }
	    var clipLine = linestring([ends[0].geometry.coordinates], {});
	    for (var i = ends[0].properties.index + 1; i < ends[1].properties.index + 1; i++) {
	        clipLine.geometry.coordinates.push(coords[i]);
	    }
	    clipLine.geometry.coordinates.push(ends[1].geometry.coordinates);
	    return clipLine;
	};


/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

	var bearing = __webpack_require__(148);
	var destination = __webpack_require__(149);
	var distance = __webpack_require__(39);
	
	/**
	 * Takes two {@link Point|points} and returns a point midway between them.
	 * The midpoint is calculated geodesically, meaning the curvature of the earth is taken into account.
	 *
	 * @name midpoint
	 * @param {Feature<Point>} from first point
	 * @param {Feature<Point>} to second point
	 * @return {Feature<Point>} a point midway between `pt1` and `pt2`
	 * @example
	 * var pt1 = {
	 *   "type": "Feature",
	 *   "properties": {},
	 *   "geometry": {
	 *     "type": "Point",
	 *     "coordinates": [144.834823, -37.771257]
	 *   }
	 * };
	 * var pt2 = {
	 *   "type": "Feature",
	 *   "properties": {},
	 *   "geometry": {
	 *     "type": "Point",
	 *     "coordinates": [145.14244, -37.830937]
	 *   }
	 * };
	 *
	 * var midpointed = turf.midpoint(pt1, pt2);
	 * midpointed.properties['marker-color'] = '#f00';
	 *
	 *
	 * var result = {
	 *   "type": "FeatureCollection",
	 *   "features": [pt1, pt2, midpointed]
	 * };
	 *
	 * //=result
	 */
	module.exports = function (from, to) {
	    var dist = distance(from, to, 'miles');
	    var heading = bearing(from, to);
	    var midpoint = destination(from, dist / 2, heading, 'miles');
	
	    return midpoint;
	};


/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

	var distance = __webpack_require__(39);
	
	/**
	 * Takes a reference {@link Point|point} and a FeatureCollection of Features
	 * with Point geometries and returns the
	 * point from the FeatureCollection closest to the reference. This calculation
	 * is geodesic.
	 *
	 * @name nearest
	 * @param {Feature<Point>} targetPoint the reference point
	 * @param {FeatureCollection<Point>} points against input point set
	 * @return {Feature<Point>} the closest point in the set to the reference point
	 * @example
	 * var point = {
	 *   "type": "Feature",
	 *   "properties": {
	 *     "marker-color": "#0f0"
	 *   },
	 *   "geometry": {
	 *     "type": "Point",
	 *     "coordinates": [28.965797, 41.010086]
	 *   }
	 * };
	 * var against = {
	 *   "type": "FeatureCollection",
	 *   "features": [
	 *     {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [28.973865, 41.011122]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [28.948459, 41.024204]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [28.938674, 41.013324]
	 *       }
	 *     }
	 *   ]
	 * };
	 *
	 * var nearest = turf.nearest(point, against);
	 * nearest.properties['marker-color'] = '#f00';
	 *
	 * var resultFeatures = against.features.concat(point);
	 * var result = {
	 *   "type": "FeatureCollection",
	 *   "features": resultFeatures
	 * };
	 *
	 * //=result
	 */
	module.exports = function (targetPoint, points) {
	    var nearestPoint, minDist = Infinity;
	    for (var i = 0; i < points.features.length; i++) {
	        var distanceToPoint = distance(targetPoint, points.features[i], 'miles');
	        if (distanceToPoint < minDist) {
	            nearestPoint = points.features[i];
	            minDist = distanceToPoint;
	        }
	    }
	    return nearestPoint;
	};


/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

	var point = __webpack_require__(17).point;
	var featurecollection = __webpack_require__(17).featureCollection;
	var distance = __webpack_require__(39);
	/**
	 * Takes a bounding box and a cell depth and returns a set of {@link Point|points} in a grid.
	 *
	 * @name pointGrid
	 * @param {Array<number>} bbox extent in [minX, minY, maxX, maxY] order
	 * @param {number} cellSize the distance across each cell
	 * @param {string} [units=kilometers] used in calculating cellWidth, can be degrees, radians, miles, or kilometers
	 * @return {FeatureCollection<Point>} grid of points
	 * @example
	 * var extent = [-70.823364, -33.553984, -70.473175, -33.302986];
	 * var cellWidth = 3;
	 * var units = 'miles';
	 *
	 * var grid = turf.pointGrid(extent, cellWidth, units);
	 *
	 * //=grid
	 */
	module.exports = function pointGrid(bbox, cellSize, units) {
	    var fc = featurecollection([]);
	    var xFraction = cellSize / (distance(point([bbox[0], bbox[1]]), point([bbox[2], bbox[1]]), units));
	    var cellWidth = xFraction * (bbox[2] - bbox[0]);
	    var yFraction = cellSize / (distance(point([bbox[0], bbox[1]]), point([bbox[0], bbox[3]]), units));
	    var cellHeight = yFraction * (bbox[3] - bbox[1]);
	
	    var currentX = bbox[0];
	    while (currentX <= bbox[2]) {
	        var currentY = bbox[1];
	        while (currentY <= bbox[3]) {
	            fc.features.push(point([currentX, currentY]));
	
	            currentY += cellHeight;
	        }
	        currentX += cellWidth;
	    }
	
	    return fc;
	};


/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

	var featureCollection = __webpack_require__(17).featureCollection;
	var centroid = __webpack_require__(489);
	var distance = __webpack_require__(39);
	var inside = __webpack_require__(94);
	var explode = __webpack_require__(490);
	
	/**
	 * Takes a feature and returns a {@link Point} guaranteed to be on the surface of the feature.
	 *
	 * * Given a {@link Polygon}, the point will be in the area of the polygon
	 * * Given a {@link LineString}, the point will be along the string
	 * * Given a {@link Point}, the point will the same as the input
	 *
	 * @param {(Feature|FeatureCollection)} fc any feature or set of features
	 * @returns {Feature} a point on the surface of `input`
	 * @example
	 * // create a random polygon
	 * var polygon = turf.random('polygon');
	 *
	 * //=polygon
	 *
	 * var pointOnPolygon = turf.pointOnSurface(polygon);
	 *
	* var resultFeatures = polygon.features.concat(pointOnPolygon);
	* var result = {
	*   "type": "FeatureCollection",
	*   "features": resultFeatures
	* };
	 *
	 * //=result
	 */
	function pointOnSurface(fc) {
	    // normalize
	    if (fc.type !== 'FeatureCollection') {
	        if (fc.type !== 'Feature') {
	            fc = {
	                type: 'Feature',
	                geometry: fc,
	                properties: {}
	            };
	        }
	        fc = featureCollection([fc]);
	    }
	
	    //get centroid
	    var cent = centroid(fc);
	
	    // check to see if centroid is on surface
	    var onSurface = false;
	    var i = 0;
	    while (!onSurface && i < fc.features.length) {
	        var geom = fc.features[i].geometry;
	        var x, y, x1, y1, x2, y2, k;
	        var onLine = false;
	        if (geom.type === 'Point') {
	            if (cent.geometry.coordinates[0] === geom.coordinates[0] &&
	        cent.geometry.coordinates[1] === geom.coordinates[1]) {
	                onSurface = true;
	            }
	        } else if (geom.type === 'MultiPoint') {
	            var onMultiPoint = false;
	            k = 0;
	            while (!onMultiPoint && k < geom.coordinates.length) {
	                if (cent.geometry.coordinates[0] === geom.coordinates[k][0] &&
	          cent.geometry.coordinates[1] === geom.coordinates[k][1]) {
	                    onSurface = true;
	                    onMultiPoint = true;
	                }
	                k++;
	            }
	        } else if (geom.type === 'LineString') {
	            k = 0;
	            while (!onLine && k < geom.coordinates.length - 1) {
	                x = cent.geometry.coordinates[0];
	                y = cent.geometry.coordinates[1];
	                x1 = geom.coordinates[k][0];
	                y1 = geom.coordinates[k][1];
	                x2 = geom.coordinates[k + 1][0];
	                y2 = geom.coordinates[k + 1][1];
	                if (pointOnSegment(x, y, x1, y1, x2, y2)) {
	                    onLine = true;
	                    onSurface = true;
	                }
	                k++;
	            }
	        } else if (geom.type === 'MultiLineString') {
	            var j = 0;
	            while (j < geom.coordinates.length) {
	                onLine = false;
	                k = 0;
	                var line = geom.coordinates[j];
	                while (!onLine && k < line.length - 1) {
	                    x = cent.geometry.coordinates[0];
	                    y = cent.geometry.coordinates[1];
	                    x1 = line[k][0];
	                    y1 = line[k][1];
	                    x2 = line[k + 1][0];
	                    y2 = line[k + 1][1];
	                    if (pointOnSegment(x, y, x1, y1, x2, y2)) {
	                        onLine = true;
	                        onSurface = true;
	                    }
	                    k++;
	                }
	                j++;
	            }
	        } else if (geom.type === 'Polygon' || geom.type === 'MultiPolygon') {
	            var f = {
	                type: 'Feature',
	                geometry: geom,
	                properties: {}
	            };
	            if (inside(cent, f)) {
	                onSurface = true;
	            }
	        }
	        i++;
	    }
	    if (onSurface) {
	        return cent;
	    } else {
	        var vertices = featureCollection([]);
	        for (i = 0; i < fc.features.length; i++) {
	            vertices.features = vertices.features.concat(explode(fc.features[i]).features);
	        }
	        var closestVertex;
	        var closestDistance = Infinity;
	        for (i = 0; i < vertices.features.length; i++) {
	            var dist = distance(cent, vertices.features[i], 'miles');
	            if (dist < closestDistance) {
	                closestDistance = dist;
	                closestVertex = vertices.features[i];
	            }
	        }
	        return closestVertex;
	    }
	}
	
	function pointOnSegment(x, y, x1, y1, x2, y2) {
	    var ab = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
	    var ap = Math.sqrt((x - x1) * (x - x1) + (y - y1) * (y - y1));
	    var pb = Math.sqrt((x2 - x) * (x2 - x) + (y2 - y) * (y2 - y));
	    if (ab === ap + pb) {
	        return true;
	    }
	}
	
	module.exports = pointOnSurface;


/***/ }),
/* 1751 */
/***/ (function(module, exports) {

	/**
	 * Takes coordinates and properties (optional) and returns a new {@link Point} feature.
	 *
	 * @module turf/point
	 * @category helper
	 * @param {number} longitude position west to east in decimal degrees
	 * @param {number} latitude position south to north in decimal degrees
	 * @param {Object} properties an Object that is used as the {@link Feature}'s
	 * properties
	 * @return {Point} a Point feature
	 * @example
	 * var pt1 = turf.point([-75.343, 39.984]);
	 *
	 * //=pt1
	 */
	var isArray = Array.isArray || function(arg) {
	  return Object.prototype.toString.call(arg) === '[object Array]';
	};
	module.exports = function(coordinates, properties) {
	  if (!isArray(coordinates)) throw new Error('Coordinates must be an array');
	  if (coordinates.length < 2) throw new Error('Coordinates must be at least 2 numbers long');
	  return {
	    type: "Feature",
	    geometry: {
	      type: "Point",
	      coordinates: coordinates
	    },
	    properties: properties || {}
	  };
	};


/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

	var random = __webpack_require__(1689);
	
	/**
	 * Generates random {@link GeoJSON} data, including {@link Point|Points} and {@link Polygon|Polygons}, for testing
	 * and experimentation.
	 *
	 * @name random
	 * @param {String} [type='point'] type of features desired: 'points' or 'polygons'
	 * @param {Number} [count=1] how many geometries should be generated.
	 * @param {Object} options options relevant to the feature desired. Can include:
	 * @param {Array<number>} options.bbox a bounding box inside of which geometries
	 * are placed. In the case of {@link Point} features, they are guaranteed to be within this bounds,
	 * while {@link Polygon} features have their centroid within the bounds.
	 * @param {Number} [options.num_vertices=10] options.vertices the number of vertices added
	 * to polygon features.
	 * @param {Number} [options.max_radial_length=10] the total number of decimal
	 * degrees longitude or latitude that a polygon can extent outwards to
	 * from its center.
	 * @return {FeatureCollection} generated random features
	 * @example
	 * var points = turf.random('points', 100, {
	 *   bbox: [-70, 40, -60, 60]
	 * });
	 *
	 * //=points
	 *
	 * var polygons = turf.random('polygons', 4, {
	 *   bbox: [-70, 40, -60, 60]
	 * });
	 *
	 * //=polygons
	 */
	module.exports = function (type, count, options) {
	    options = options || {};
	    count = count || 1;
	    switch (type) {
	    case 'point':
	    case 'points':
	    case undefined:
	        return random.point(count, options.bbox);
	    case 'polygon':
	    case 'polygons':
	        return random.polygon(
	                count,
	                options.num_vertices,
	                options.max_radial_length,
	                options.bbox);
	    default:
	        throw new Error('Unknown type given: valid options are points and polygons');
	    }
	};


/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

	// http://stackoverflow.com/questions/11935175/sampling-a-random-subset-from-an-array
	var featureCollection = __webpack_require__(17).featureCollection;
	
	/**
	 * Takes a {@link FeatureCollection} and returns a FeatureCollection with given number of {@link Feature|features} at random.
	 *
	 * @name sample
	 * @param {FeatureCollection} featurecollection set of input features
	 * @param {number} num number of features to select
	 * @return {FeatureCollection} a FeatureCollection with `n` features
	 * @example
	 * var points = turf.random('points', 1000);
	 *
	 * //=points
	 *
	 * var sample = turf.sample(points, 10);
	 *
	 * //=sample
	 */
	module.exports = function (featurecollection, num) {
	    var outFC = featureCollection(getRandomSubarray(featurecollection.features, num));
	    return outFC;
	};
	
	function getRandomSubarray(arr, size) {
	    var shuffled = arr.slice(0), i = arr.length, min = i - size, temp, index;
	    while (i-- > min) {
	        index = Math.floor((i + 1) * Math.random());
	        temp = shuffled[index];
	        shuffled[index] = shuffled[i];
	        shuffled[i] = temp;
	    }
	    return shuffled.slice(min);
	}


/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

	var simplify = __webpack_require__(146);
	
	// supported GeoJSON geometries, used to check whether to wrap in simpleFeature()
	var supportedTypes = ['LineString', 'MultiLineString', 'Polygon', 'MultiPolygon'];
	
	/**
	 * Takes a {@link LineString} or {@link Polygon} and returns a simplified version. Internally uses [simplify-js](http://mourner.github.io/simplify-js/) to perform simplification.
	 *
	 * @name simplify
	 * @param {Feature<(LineString|Polygon|MultiLineString|MultiPolygon)>|FeatureCollection|GeometryCollection} feature feature to be simplified
	 * @param {number} tolerance simplification tolerance
	 * @param {boolean} highQuality whether or not to spend more time to create
	 * a higher-quality simplification with a different algorithm
	 * @return {Feature<(LineString|Polygon|MultiLineString|MultiPolygon)>|FeatureCollection|GeometryCollection} a simplified feature
	 * @example
	  * var feature = {
	 *   "type": "Feature",
	 *   "properties": {},
	 *   "geometry": {
	 *     "type": "Polygon",
	 *     "coordinates": [[
	 *       [-70.603637, -33.399918],
	 *       [-70.614624, -33.395332],
	 *       [-70.639343, -33.392466],
	 *       [-70.659942, -33.394759],
	 *       [-70.683975, -33.404504],
	 *       [-70.697021, -33.419406],
	 *       [-70.701141, -33.434306],
	 *       [-70.700454, -33.446339],
	 *       [-70.694274, -33.458369],
	 *       [-70.682601, -33.465816],
	 *       [-70.668869, -33.472117],
	 *       [-70.646209, -33.473835],
	 *       [-70.624923, -33.472117],
	 *       [-70.609817, -33.468107],
	 *       [-70.595397, -33.458369],
	 *       [-70.587158, -33.442901],
	 *       [-70.587158, -33.426283],
	 *       [-70.590591, -33.414248],
	 *       [-70.594711, -33.406224],
	 *       [-70.603637, -33.399918]
	 *     ]]
	 *   }
	 * };
	
	 * var tolerance = 0.01;
	 *
	 * var simplified = turf.simplify(
	 *  feature, tolerance, false);
	 *
	 * //=feature
	 *
	 * //=simplified
	 */
	module.exports = function (feature, tolerance, highQuality) {
	    if (feature.type === 'Feature') {
	        return simpleFeature(
	            simplifyHelper(feature, tolerance, highQuality),
	            feature.properties);
	    } else if (feature.type === 'FeatureCollection') {
	        return {
	            type: 'FeatureCollection',
	            features: feature.features.map(function (f) {
	                var simplified = simplifyHelper(f, tolerance, highQuality);
	
	                // we create simpleFeature here because it doesn't apply to GeometryCollection
	                // so we can't create it at simplifyHelper()
	                if (supportedTypes.indexOf(simplified.type) > -1) {
	                    return simpleFeature(simplified, f.properties);
	                } else {
	                    return simplified;
	                }
	            })
	        };
	    } else if (feature.type === 'GeometryCollection') {
	        return {
	            type: 'GeometryCollection',
	            geometries: feature.geometries.map(function (g) {
	                if (supportedTypes.indexOf(g.type) > -1) {
	                    return simplifyHelper({
	                        type: 'Feature',
	                        geometry: g
	                    }, tolerance, highQuality);
	                }
	                return g;
	            })
	        };
	    } else {
	        return feature;
	    }
	};
	
	
	function simplifyHelper(feature, tolerance, highQuality) {
	    if (feature.geometry.type === 'LineString') {
	        return {
	            type: 'LineString',
	            coordinates: simplifyLine(feature.geometry.coordinates, tolerance, highQuality)
	        };
	    } else if (feature.geometry.type === 'MultiLineString') {
	        return {
	            type: 'MultiLineString',
	            coordinates: feature.geometry.coordinates.map(function (lines) {
	                return simplifyLine(lines, tolerance, highQuality);
	            })
	        };
	    } else if (feature.geometry.type === 'Polygon') {
	        return {
	            type: 'Polygon',
	            coordinates: simplifyPolygon(feature.geometry.coordinates, tolerance, highQuality)
	        };
	    } else if (feature.geometry.type === 'MultiPolygon') {
	        return {
	            type: 'MultiPolygon',
	            coordinates: feature.geometry.coordinates.map(function (rings) {
	                return simplifyPolygon(rings, tolerance, highQuality);
	            })
	        };
	    } else {
	        // unsupported geometry type supplied
	        return feature;
	    }
	}
	
	/*
	* returns true if ring's first coordinate is the same as its last
	*/
	function checkValidity(ring) {
	    if (ring.length < 3) {
	        return false;
	    //if the last point is the same as the first, it's not a triangle
	    } else if (ring.length === 3 &&
	      ((ring[2][0] === ring[0][0]) && (ring[2][1] === ring[0][1]))) {
	        return false;
	    } else {
	        return true;
	    }
	}
	
	function simpleFeature(geom, properties) {
	    return {
	        type: 'Feature',
	        geometry: geom,
	        properties: properties
	    };
	}
	
	function simplifyLine(coordinates, tolerance, highQuality) {
	    return simplify(coordinates.map(function (coord) {
	        return {x: coord[0], y: coord[1]};
	    }), tolerance, highQuality).map(function (coords) {
	        return [coords.x, coords.y];
	    });
	}
	
	function simplifyPolygon(coordinates, tolerance, highQuality) {
	    return coordinates.map(function (ring) {
	        var pts = ring.map(function (coord) {
	            return {x: coord[0], y: coord[1]};
	        });
	        if (pts.length < 4) {
	            throw new Error('Invalid polygon');
	        }
	        var simpleRing = simplify(pts, tolerance, highQuality).map(function (coords) {
	            return [coords.x, coords.y];
	        });
	        //remove 1 percent of tolerance until enough points to make a triangle
	        while (!checkValidity(simpleRing)) {
	            tolerance -= tolerance * 0.01;
	            simpleRing = simplify(pts, tolerance, highQuality).map(function (coords) {
	                return [coords.x, coords.y];
	            });
	        }
	        if (
	            (simpleRing[simpleRing.length - 1][0] !== simpleRing[0][0]) ||
	                (simpleRing[simpleRing.length - 1][1] !== simpleRing[0][1])) {
	            simpleRing.push(simpleRing[0]);
	        }
	        return simpleRing;
	    });
	}


/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

	var featurecollection = __webpack_require__(17).featureCollection;
	var point = __webpack_require__(17).point;
	var polygon = __webpack_require__(17).polygon;
	var distance = __webpack_require__(39);
	
	/**
	 * Takes a bounding box and a cell depth and returns a set of square {@link Polygon|polygons} in a grid.
	 *
	 * @name squareGrid
	 * @param {Array<number>} bbox extent in [minX, minY, maxX, maxY] order
	 * @param {number} cellSize width of each cell
	 * @param {string} units units to use for cellWidth
	 * @return {FeatureCollection<Polygon>} grid a grid of polygons
	 * @example
	 * var extent = [-77.3876953125,38.71980474264239,-76.9482421875,39.027718840211605];
	 * var cellWidth = 10;
	 * var units = 'miles';
	 *
	 * var squareGrid = turf.squareGrid(extent, cellWidth, units);
	 *
	 * //=squareGrid
	 */
	module.exports = function squareGrid(bbox, cellSize, units) {
	    var fc = featurecollection([]);
	    var xFraction = cellSize / (distance(point([bbox[0], bbox[1]]), point([bbox[2], bbox[1]]), units));
	    var cellWidth = xFraction * (bbox[2] - bbox[0]);
	    var yFraction = cellSize / (distance(point([bbox[0], bbox[1]]), point([bbox[0], bbox[3]]), units));
	    var cellHeight = yFraction * (bbox[3] - bbox[1]);
	
	    var currentX = bbox[0];
	    while (currentX <= bbox[2]) {
	        var currentY = bbox[1];
	        while (currentY <= bbox[3]) {
	            var cellPoly = polygon([[
	                [currentX, currentY],
	                [currentX, currentY + cellHeight],
	                [currentX + cellWidth, currentY + cellHeight],
	                [currentX + cellWidth, currentY],
	                [currentX, currentY]
	            ]]);
	            fc.features.push(cellPoly);
	
	            currentY += cellHeight;
	        }
	        currentX += cellWidth;
	    }
	
	    return fc;
	};


/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

	var inside = __webpack_require__(94);
	
	/**
	 * Takes a set of {@link Point|points} and a set of {@link Polygon|polygons} and performs a spatial join.
	 *
	 * @name tag
	 * @param {FeatureCollection<Point>} points input points
	 * @param {FeatureCollection<Polygon>} polygons input polygons
	 * @param {string} field property in `polygons` to add to joined Point features
	 * @param {string} outField property in `points` in which to store joined property from `polygons
	 * @return {FeatureCollection<Point>} points with `containingPolyId` property containing values from `polyId`
	 * @example
	 * var bbox = [0, 0, 10, 10];
	 * // create a triangular grid of polygons
	 * var triangleGrid = turf.triangleGrid(bbox, 50, 'miles');
	 * triangleGrid.features.forEach(function(f) {
	 *   f.properties.fill = '#' +
	 *     (~~(Math.random() * 16)).toString(16) +
	 *     (~~(Math.random() * 16)).toString(16) +
	 *     (~~(Math.random() * 16)).toString(16);
	 *   f.properties.stroke = 0;
	 *   f.properties['fill-opacity'] = 1;
	 * });
	 * var randomPoints = turf.random('point', 30, {
	 *   bbox: bbox
	 * });
	 * var both = turf.featurecollection(
	 *   triangleGrid.features.concat(randomPoints.features));
	 *
	 * //=both
	 *
	 * var tagged = turf.tag(randomPoints, triangleGrid,
	 *                       'fill', 'marker-color');
	 *
	 * //=tagged
	 */
	module.exports = function (points, polygons, field, outField) {
	    // prevent mutations
	    points = JSON.parse(JSON.stringify(points));
	    polygons = JSON.parse(JSON.stringify(polygons));
	    points.features.forEach(function (pt) {
	        if (!pt.properties) {
	            pt.properties = {};
	        }
	        polygons.features.forEach(function (poly) {
	            if (pt.properties[outField] === undefined) {
	                var isInside = inside(pt, poly);
	                if (isInside) {
	                    pt.properties[outField] = poly.properties[field];
	                }
	            }
	        });
	    });
	    return points;
	};


/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

	var polygon = __webpack_require__(17).polygon;
	var earcut = __webpack_require__(1477);
	
	/**
	 * Tesselates a {@link Feature<Polygon>} into a {@link FeatureCollection<Polygon>} of triangles
	 * using [earcut](https://github.com/mapbox/earcut).
	 *
	 * @name tesselate
	 * @param {Feature<Polygon>} polygon the polygon to tesselate
	 * @returns {FeatureCollection<Polygon>} a geometrycollection feature
	 * @example
	 * var polygon = {"type":"Feature","id":"USA-CA","properties":{"name":"California"},"geometry":{"type":"Polygon","coordinates":[[[-123.233256,42.006186],[-122.378853,42.011663],[-121.037003,41.995232],[-120.001861,41.995232],[-119.996384,40.264519],[-120.001861,38.999346],[-118.71478,38.101128],[-117.498899,37.21934],[-116.540435,36.501861],[-115.85034,35.970598],[-114.634459,35.00118],[-114.634459,34.87521],[-114.470151,34.710902],[-114.333228,34.448009],[-114.136058,34.305608],[-114.256551,34.174162],[-114.415382,34.108438],[-114.535874,33.933176],[-114.497536,33.697668],[-114.524921,33.54979],[-114.727567,33.40739],[-114.661844,33.034958],[-114.524921,33.029481],[-114.470151,32.843265],[-114.524921,32.755634],[-114.72209,32.717295],[-116.04751,32.624187],[-117.126467,32.536556],[-117.24696,32.668003],[-117.252437,32.876127],[-117.329114,33.122589],[-117.471515,33.297851],[-117.7837,33.538836],[-118.183517,33.763391],[-118.260194,33.703145],[-118.413548,33.741483],[-118.391641,33.840068],[-118.566903,34.042715],[-118.802411,33.998899],[-119.218659,34.146777],[-119.278905,34.26727],[-119.558229,34.415147],[-119.875891,34.40967],[-120.138784,34.475393],[-120.472878,34.448009],[-120.64814,34.579455],[-120.609801,34.858779],[-120.670048,34.902595],[-120.631709,35.099764],[-120.894602,35.247642],[-120.905556,35.450289],[-121.004141,35.461243],[-121.168449,35.636505],[-121.283465,35.674843],[-121.332757,35.784382],[-121.716143,36.195153],[-121.896882,36.315645],[-121.935221,36.638785],[-121.858544,36.6114],[-121.787344,36.803093],[-121.929744,36.978355],[-122.105006,36.956447],[-122.335038,37.115279],[-122.417192,37.241248],[-122.400761,37.361741],[-122.515777,37.520572],[-122.515777,37.783465],[-122.329561,37.783465],[-122.406238,38.15042],[-122.488392,38.112082],[-122.504823,37.931343],[-122.701993,37.893004],[-122.937501,38.029928],[-122.97584,38.265436],[-123.129194,38.451652],[-123.331841,38.566668],[-123.44138,38.698114],[-123.737134,38.95553],[-123.687842,39.032208],[-123.824765,39.366301],[-123.764519,39.552517],[-123.85215,39.831841],[-124.109566,40.105688],[-124.361506,40.259042],[-124.410798,40.439781],[-124.158859,40.877937],[-124.109566,41.025814],[-124.158859,41.14083],[-124.065751,41.442061],[-124.147905,41.715908],[-124.257444,41.781632],[-124.213628,42.000709],[-123.233256,42.006186]]]}};
	 *
	 * var triangles = turf.tesselate(polygon);
	 *
	 * //=triangles
	 */
	
	module.exports = function (poly) {
	    if (!poly.geometry || (poly.geometry.type !== 'Polygon' && poly.geometry.type !== 'MultiPolygon')) {
	        throw new Error('input must be a Polygon or MultiPolygon');
	    }
	
	    var fc = {type: 'FeatureCollection', features: []};
	
	    if (poly.geometry.type === 'Polygon') {
	        fc.features = processPolygon(poly.geometry.coordinates);
	    } else {
	        poly.geometry.coordinates.forEach(function (coordinates) {
	            fc.features = fc.features.concat(processPolygon(coordinates));
	        });
	    }
	
	    return fc;
	};
	
	function processPolygon(coordinates) {
	    var data = flattenCoords(coordinates);
	    var dim = 2;
	    var result = earcut(data.vertices, data.holes, dim);
	
	    var features = [];
	    var vertices = [];
	
	    result.forEach(function (vert, i) {
	        var index = result[i];
	        vertices.push([data.vertices[index * dim], data.vertices[index * dim + 1]]);
	    });
	
	    for (var i = 0; i < vertices.length; i += 3) {
	        var coords = vertices.slice(i, i + 3);
	        coords.push(vertices[i]);
	        features.push(polygon([coords]));
	    }
	
	    return features;
	}
	
	function flattenCoords(data) {
	    var dim = data[0][0].length,
	        result = {vertices: [], holes: [], dimensions: dim},
	        holeIndex = 0;
	
	    for (var i = 0; i < data.length; i++) {
	        for (var j = 0; j < data[i].length; j++) {
	            for (var d = 0; d < dim; d++) result.vertices.push(data[i][j][d]);
	        }
	        if (i > 0) {
	            holeIndex += data[i - 1].length;
	            result.holes.push(holeIndex);
	        }
	    }
	
	    return result;
	}


/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

	var featurecollection = __webpack_require__(17).featureCollection;
	var polygon = __webpack_require__(17).polygon;
	var distance = __webpack_require__(39);
	
	/**
	 * Takes a bounding box and a cell depth and returns a set of triangular {@link Polygon|polygons} in a grid.
	 *
	 * @name triangleGrid
	 * @param {Array<number>} bbox extent in [minX, minY, maxX, maxY] order
	 * @param {number} cellSize dimension of each cell
	 * @param {string} units units to use for cellWidth
	 * @return {FeatureCollection<Polygon>} grid of polygons
	 * @example
	 * var extent = [-77.3876953125,38.71980474264239,-76.9482421875,39.027718840211605];
	 * var cellWidth = 10;
	 * var units = 'miles';
	 *
	 * var triangleGrid = turf.triangleGrid(extent, cellWidth, units);
	 *
	 * //=triangleGrid
	 */
	module.exports = function (bbox, cellSize, units) {
	    var fc = featurecollection([]);
	    var xFraction = cellSize / (distance([bbox[0], bbox[1]], [bbox[2], bbox[1]], units));
	    var cellWidth = xFraction * (bbox[2] - bbox[0]);
	    var yFraction = cellSize / (distance([bbox[0], bbox[1]], [bbox[0], bbox[3]], units));
	    var cellHeight = yFraction * (bbox[3] - bbox[1]);
	
	    var xi = 0;
	    var currentX = bbox[0];
	    while (currentX <= bbox[2]) {
	        var yi = 0;
	        var currentY = bbox[1];
	        while (currentY <= bbox[3]) {
	            if (xi % 2 === 0 && yi % 2 === 0) {
	                fc.features.push(polygon([[
	                    [currentX, currentY],
	                    [currentX, currentY + cellHeight],
	                    [currentX + cellWidth, currentY],
	                    [currentX, currentY]
	                ]]), polygon([[
	                    [currentX, currentY + cellHeight],
	                    [currentX + cellWidth, currentY + cellHeight],
	                    [currentX + cellWidth, currentY],
	                    [currentX, currentY + cellHeight]
	                ]]));
	            } else if (xi % 2 === 0 && yi % 2 === 1) {
	                fc.features.push(polygon([[
	                    [currentX, currentY],
	                    [currentX + cellWidth, currentY + cellHeight],
	                    [currentX + cellWidth, currentY],
	                    [currentX, currentY]
	                ]]), polygon([[
	                    [currentX, currentY],
	                    [currentX, currentY + cellHeight],
	                    [currentX + cellWidth, currentY + cellHeight],
	                    [currentX, currentY]
	                ]]));
	            } else if (yi % 2 === 0 && xi % 2 === 1) {
	                fc.features.push(polygon([[
	                    [currentX, currentY],
	                    [currentX, currentY + cellHeight],
	                    [currentX + cellWidth, currentY + cellHeight],
	                    [currentX, currentY]
	                ]]), polygon([[
	                    [currentX, currentY],
	                    [currentX + cellWidth, currentY + cellHeight],
	                    [currentX + cellWidth, currentY],
	                    [currentX, currentY]
	                ]]));
	            } else if (yi % 2 === 1 && xi % 2 === 1) {
	                fc.features.push(polygon([[
	                    [currentX, currentY],
	                    [currentX, currentY + cellHeight],
	                    [currentX + cellWidth, currentY],
	                    [currentX, currentY]
	                ]]), polygon([[
	                    [currentX, currentY + cellHeight],
	                    [currentX + cellWidth, currentY + cellHeight],
	                    [currentX + cellWidth, currentY],
	                    [currentX, currentY + cellHeight]
	                ]]));
	            }
	            currentY += cellHeight;
	            yi++;
	        }
	        xi++;
	        currentX += cellWidth;
	    }
	    return fc;
	};
	


/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

	var inside = __webpack_require__(94);
	var featureCollection = __webpack_require__(17).featureCollection;
	
	/**
	 * Takes a set of {@link Point|points} and a set of {@link Polygon|polygons} and returns the points that fall within the polygons.
	 *
	 * @name within
	 * @param {FeatureCollection<Point>} points input points
	 * @param {FeatureCollection<Polygon>} polygons input polygons
	 * @return {FeatureCollection<Point>} points that land within at least one polygon
	 * @example
	 * var searchWithin = {
	 *   "type": "FeatureCollection",
	 *   "features": [
	 *     {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Polygon",
	 *         "coordinates": [[
	 *           [-46.653,-23.543],
	 *           [-46.634,-23.5346],
	 *           [-46.613,-23.543],
	 *           [-46.614,-23.559],
	 *           [-46.631,-23.567],
	 *           [-46.653,-23.560],
	 *           [-46.653,-23.543]
	 *         ]]
	 *       }
	 *     }
	 *   ]
	 * };
	 * var points = {
	 *   "type": "FeatureCollection",
	 *   "features": [
	 *     {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-46.6318, -23.5523]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-46.6246, -23.5325]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-46.6062, -23.5513]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-46.663, -23.554]
	 *       }
	 *     }, {
	 *       "type": "Feature",
	 *       "properties": {},
	 *       "geometry": {
	 *         "type": "Point",
	 *         "coordinates": [-46.643, -23.557]
	 *       }
	 *     }
	 *   ]
	 * };
	 *
	 * var ptsWithin = turf.within(points, searchWithin);
	 *
	 * //=points
	 *
	 * //=searchWithin
	 *
	 * //=ptsWithin
	 */
	module.exports = function (points, polygons) {
	    var pointsWithin = featureCollection([]);
	    for (var i = 0; i < polygons.features.length; i++) {
	        for (var j = 0; j < points.features.length; j++) {
	            var isInside = inside(points.features[j], polygons.features[i]);
	            if (isInside) {
	                pointsWithin.features.push(points.features[j]);
	            }
	        }
	    }
	    return pointsWithin;
	};


/***/ }),
/* 1760 */
/***/ (function(module, exports) {

	"use strict"
	
	module.exports = fastTwoSum
	
	function fastTwoSum(a, b, result) {
		var x = a + b
		var bv = x - a
		var av = x - bv
		var br = b - bv
		var ar = a - av
		if(result) {
			result[0] = ar + br
			result[1] = x
			return result
		}
		return [ar+br, x]
	}

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var isPrototype = __webpack_require__(1764);
	
	module.exports = function (value) {
		if (typeof value !== "function") return false;
	
		if (!hasOwnProperty.call(value, "length")) return false;
	
		try {
			if (typeof value.length !== "number") return false;
			if (typeof value.call !== "function") return false;
			if (typeof value.apply !== "function") return false;
		} catch (error) {
			return false;
		}
	
		return !isPrototype(value);
	};


/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var isValue = __webpack_require__(496);
	
	// prettier-ignore
	var possibleTypes = { "object": true, "function": true, "undefined": true /* document.all */ };
	
	module.exports = function (value) {
		if (!isValue(value)) return false;
		return hasOwnProperty.call(possibleTypes, typeof value);
	};


/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var isFunction = __webpack_require__(1761);
	
	var classRe = /^\s*class[\s{/}]/, functionToString = Function.prototype.toString;
	
	module.exports = function (value) {
		if (!isFunction(value)) return false;
		if (classRe.test(functionToString.call(value))) return false;
		return true;
	};


/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var isObject = __webpack_require__(1762);
	
	module.exports = function (value) {
		if (!isObject(value)) return false;
		try {
			if (!value.constructor) return false;
			return value.constructor.prototype === value;
		} catch (error) {
			return false;
		}
	};


/***/ }),
/* 1765 */
/***/ (function(module, exports) {

	"use strict"; "use restrict";
	
	module.exports = UnionFind;
	
	function UnionFind(count) {
	  this.roots = new Array(count);
	  this.ranks = new Array(count);
	  
	  for(var i=0; i<count; ++i) {
	    this.roots[i] = i;
	    this.ranks[i] = 0;
	  }
	}
	
	var proto = UnionFind.prototype
	
	Object.defineProperty(proto, "length", {
	  "get": function() {
	    return this.roots.length
	  }
	})
	
	proto.makeSet = function() {
	  var n = this.roots.length;
	  this.roots.push(n);
	  this.ranks.push(0);
	  return n;
	}
	
	proto.find = function(x) {
	  var x0 = x
	  var roots = this.roots;
	  while(roots[x] !== x) {
	    x = roots[x]
	  }
	  while(roots[x0] !== x) {
	    var y = roots[x0]
	    roots[x0] = x
	    x0 = y
	  }
	  return x;
	}
	
	proto.link = function(x, y) {
	  var xr = this.find(x)
	    , yr = this.find(y);
	  if(xr === yr) {
	    return;
	  }
	  var ranks = this.ranks
	    , roots = this.roots
	    , xd    = ranks[xr]
	    , yd    = ranks[yr];
	  if(xd < yd) {
	    roots[xr] = yr;
	  } else if(yd < xd) {
	    roots[yr] = xr;
	  } else {
	    roots[yr] = xr;
	    ++ranks[xr];
	  }
	}

/***/ }),
/* 1766 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDQyIDQyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0MiA0MjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4NCgkuc3Qwe2ZpbGw6IzdDQUIwMDt9DQo8L3N0eWxlPg0KPHBhdGggY2xhc3M9InN0MCIgZD0iTTIxLDBDOS40LDAsMCw5LjQsMCwyMXM5LjQsMjEsMjEsMjFzMjEtOS40LDIxLTIxUzMyLjYsMCwyMSwweiBNMzAuNywxNS4yTDIwLjUsMzAuOGMtMC4zLDAuNC0wLjgsMC43LTEuMywwLjcNCgljLTAuNCwwLTAuOC0wLjEtMS0wLjRsLTYuMS01LjZjLTAuNy0wLjctMC44LTEuOS0wLjEtMi42YzAuNy0wLjcsMS45LTAuOCwyLjYtMC4xbDQuMiwzLjlsOC45LTEzLjVjMC42LTAuOCwxLjctMS4xLDIuNS0wLjUNCglDMzEsMTMuMiwzMS4zLDE0LjMsMzAuNywxNS4yeiIvPg0KPC9zdmc+DQo="

/***/ }),
/* 1767 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iSWNvbl9pb25pYy1pb3MtYWRkLWNpcmNsZS1vdXRsaW5lIiBkYXRhLW5hbWU9Ikljb24gaW9uaWMtaW9zLWFkZC1jaXJjbGUtb3V0bGluZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMjkuMjUiIGhlaWdodD0iMjkuMjUiIHZpZXdCb3g9IjAgMCAyOS4yNSAyOS4yNSI+DQogIDxwYXRoIGlkPSJDYW1pbmhvXzEwMDk2IiBkYXRhLW5hbWU9IkNhbWluaG8gMTAwOTYiIGQ9Ik0yNC4zNjMsMTYuODc1SDE5LjEyNVYxMS42MzdhMS4xMjUsMS4xMjUsMCwwLDAtMi4yNSwwdjUuMjM4SDExLjYzN0ExLjA3NywxLjA3NywwLDAsMCwxMC41MTIsMThhMS4wODksMS4wODksMCwwLDAsMS4xMjUsMS4xMjVoNS4yMzh2NS4yMzhBMS4wOSwxLjA5LDAsMCwwLDE4LDI1LjQ4OGExLjExOSwxLjExOSwwLDAsMCwxLjEyNS0xLjEyNVYxOS4xMjVoNS4yMzhhMS4xMjUsMS4xMjUsMCwwLDAsMC0yLjI1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMuMzc1IC0zLjM3NSkiIGZpbGw9IiM1NmEyZDUiLz4NCiAgPHBhdGggaWQ9IkNhbWluaG9fMTAwOTciIGRhdGEtbmFtZT0iQ2FtaW5obyAxMDA5NyIgZD0iTTE4LDUuMzQ0QTEyLjY1MSwxMi42NTEsMCwxLDEsOS4wNDksOS4wNDksMTIuNTczLDEyLjU3MywwLDAsMSwxOCw1LjM0NG0wLTEuOTY5QTE0LjYyNSwxNC42MjUsMCwxLDAsMzIuNjI1LDE4LDE0LjYyMywxNC42MjMsMCwwLDAsMTgsMy4zNzVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMy4zNzUgLTMuMzc1KSIgZmlsbD0iIzU2YTJkNSIvPg0KPC9zdmc+DQo="

/***/ }),
/* 1768 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMi41IiBoZWlnaHQ9IjI3IiB2aWV3Qm94PSIwIDAgMjIuNSAyNyI+DQogIDxwYXRoIGlkPSJJY29uX2lvbmljLW1kLXRyYXNoIiBkYXRhLW5hbWU9Ikljb24gaW9uaWMtbWQtdHJhc2giIGQ9Ik05LDI4LjUwN0EzLjAwNSwzLjAwNSwwLDAsMCwxMiwzMS41SDI0YTMuMDA1LDMuMDA1LDAsMCwwLDMtMi45OTNWMTEuMjVIOVpNMjkuMjUsNi43NUgyMy42MjVMMjEuNzQyLDQuNUgxNC4yNThMMTIuMzc1LDYuNzVINi43NVY5aDIyLjVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNi43NSAtNC41KSIgZmlsbD0iI2ZjNDUxMyIvPg0KPC9zdmc+DQo="

/***/ }),
/* 1769 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMy42MTYiIGhlaWdodD0iMTMuNTAzIiB2aWV3Qm94PSIwIDAgMjMuNjE2IDEzLjUwMyI+DQogIDxwYXRoIGlkPSJJY29uX2lvbmljLWlvcy1hcnJvdy1kb3duIiBkYXRhLW5hbWU9Ikljb24gaW9uaWMtaW9zLWFycm93LWRvd24iIGQ9Ik0xMS44MTMsOS40MzIsMjAuNzQyLjVhMS42ODEsMS42ODEsMCwwLDEsMi4zODQsMCwxLjcsMS43LDAsMCwxLDAsMi4zOTFMMTMuMDA4LDEzLjAxMWExLjY4NSwxLjY4NSwwLDAsMS0yLjMyNy4wNDlMLjQ5MiwyLjg5M0ExLjY4OCwxLjY4OCwwLDAsMSwyLjg3Ni41WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjMuNjE2IDEzLjUwMykgcm90YXRlKDE4MCkiIGZpbGw9IiM1NTUiLz4NCjwvc3ZnPg0K"

/***/ }),
/* 1770 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1771 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMSAyMUMxNi41MjI4IDIxIDIxIDE2LjUyMjggMjEgMTFDMjEgNS40NzcxNSAxNi41MjI4IDEgMTEgMUM1LjQ3NzE1IDEgMSA1LjQ3NzE1IDEgMTFDMSAxNi41MjI4IDUuNDc3MTUgMjEgMTEgMjFaIiBzdHJva2U9IiM0NDQ3NUMiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+DQo8cGF0aCBkPSJNMTYgMTFINiIgc3Ryb2tlPSIjNDQ0NzVDIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPg0KPHBhdGggZD0iTTExIDE2VjYiIHN0cm9rZT0iIzQ0NDc1QyIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4NCjwvc3ZnPg0K"

/***/ }),
/* 1772 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1773 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik04LjI1IDEzLjVIOS43NVYxMkg4LjI1VjEzLjVaTTkgMS41QzQuODYgMS41IDEuNSA0Ljg2IDEuNSA5QzEuNSAxMy4xNCA0Ljg2IDE2LjUgOSAxNi41QzEzLjE0IDE2LjUgMTYuNSAxMy4xNCAxNi41IDlDMTYuNSA0Ljg2IDEzLjE0IDEuNSA5IDEuNVpNOSAxNUM1LjY5MjUgMTUgMyAxMi4zMDc1IDMgOUMzIDUuNjkyNSA1LjY5MjUgMyA5IDNDMTIuMzA3NSAzIDE1IDUuNjkyNSAxNSA5QzE1IDEyLjMwNzUgMTIuMzA3NSAxNSA5IDE1Wk05IDQuNUM3LjM0MjUgNC41IDYgNS44NDI1IDYgNy41SDcuNUM3LjUgNi42NzUgOC4xNzUgNiA5IDZDOS44MjUgNiAxMC41IDYuNjc1IDEwLjUgNy41QzEwLjUgOSA4LjI1IDguODEyNSA4LjI1IDExLjI1SDkuNzVDOS43NSA5LjU2MjUgMTIgOS4zNzUgMTIgNy41QzEyIDUuODQyNSAxMC42NTc1IDQuNSA5IDQuNVoiIGZpbGw9ImJsYWNrIi8+DQo8L3N2Zz4NCg=="

/***/ }),
/* 1774 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNyIgaGVpZ2h0PSIyNy4wMDciIHZpZXdCb3g9IjAgMCAyNyAyNy4wMDciPg0KICA8cGF0aCBpZD0iSWNvbl9pb25pYy1pb3Mtc2VhcmNoIiBkYXRhLW5hbWU9Ikljb24gaW9uaWMtaW9zLXNlYXJjaCIgZD0iTTMxLjE4NCwyOS41NDVsLTcuNTA5LTcuNThhMTAuNywxMC43LDAsMSwwLTEuNjI0LDEuNjQ1bDcuNDYsNy41M2ExLjE1NiwxLjE1NiwwLDAsMCwxLjYzMS4wNDJBMS4xNjMsMS4xNjMsMCwwLDAsMzEuMTg0LDI5LjU0NVpNMTUuMjY1LDIzLjdhOC40NSw4LjQ1LDAsMSwxLDUuOTc3LTIuNDc1QTguNCw4LjQsMCwwLDEsMTUuMjY1LDIzLjdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNC41IC00LjQ5MykiIGZpbGw9IiM5ODk4OTgiLz4NCjwvc3ZnPg0K"

/***/ }),
/* 1775 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGlkPSJJY29uIj4NCjxwYXRoIGlkPSJWZWN0b3IiIGQ9Ik0xMy4wMDQgOS42NTkwNUwxMC43NjQgNy4xNTkwNkMxMC41MDQgNi44NTkwNiAxMC41MjQgNi4zNzkwNiAxMC44NDQgNi4wOTkwNkMxMS4xNDQgNS44MzkwNiAxMS42MjQgNS44NTkwNyAxMS44ODQgNi4xNzkwNkwxNS4yMjQgOS45MTkwNUMxNS40ODQgMTAuMjE5MSAxNS40ODQgMTAuNjM5MSAxNS4yMjQgMTAuOTE5MUwxMS44ODQgMTQuNjU5QzExLjYyNCAxNC45NzkgMTEuMTQ0IDE0Ljk5OSAxMC44NDQgMTQuNzE5QzEwLjUyNCAxNC40NTkgMTAuNTA0IDEzLjk3OSAxMC43NjQgMTMuNjc5TDEzLjAwNCAxMS4xNTlINi4zMjM5OEM1LjkyMzk4IDExLjE1OSA1LjU4Mzk4IDEwLjgzOTEgNS41ODM5OCAxMC40MTkxQzUuNTgzOTggOS45OTkwNSA1LjkyMzk4IDkuNjU5MDUgNi4zMjM5OCA5LjY1OTA1SDEzLjAwNFoiIGZpbGw9IndoaXRlIi8+DQo8L2c+DQo8L3N2Zz4NCg=="

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img-about-move-mais-2026.47eecfc.svg";

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img-ativar-tag-2026.93fd432.png";

/***/ }),
/* 1778 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1779 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1780 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img-install-tag-bus-bottom-detail-top.e6aec76.svg";

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img-install-tag-bus-bottom-detail.a1646c2.svg";

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img-install-tag-bus-bottom.6339aae.svg";

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img-install-tag-bus-detail.dc04274.svg";

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img-install-tag-bus-top.e1f24f7.svg";

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img-install-tag-bus.724cc0e.svg";

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img-install-tag-car-detail.e106257.svg";

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img-install-tag-car-grid-detail.fea2351.svg";

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img-install-tag-car-grid.fe7d20b.svg";

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img-install-tag-car-panoramic-view.0dd2c66.svg";

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img-install-tag-car-support-detail.51377b5.svg";

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img-install-tag-car-support.45cc80f.svg";

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img-install-tag-car.1d0f5e8.svg";

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img-install-tag-truck-detail.331676f.svg";

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img-install-tag-truck.9325473.svg";

/***/ }),
/* 1796 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1797 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxMjcuNiA1My45IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMjcuNiA1My45OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojMDA3NUM5O30NCgkuc3Qxe2ZpbGw6I0ZGRkZGRjt9DQoJLnN0MntmaWxsOiNGRkNFMDA7fQ0KCS5zdDN7ZmlsbDojRkY0NjEyO30NCgkuc3Q0e2ZpbGw6IzYzQTcwQTt9DQoJLnN0NXtmaWxsOiM3MzIyODI7fQ0KPC9zdHlsZT4NCjxnPg0KCTxnPg0KCQk8cG9seWdvbiBwb2ludHM9Ijc2LDM1IDc1LjksMzguNCA3OC4zLDM4LjQgNzguNCw1My41IDgyLjksNTMuNSA4Mi44LDM1IAkJIi8+DQoJCTxwb2x5Z29uIHBvaW50cz0iNTQuOSwzMy41IDYzLjQsMTQuOCA1OC4zLDE0LjggNTMuOCwyNS45IDQ4LjYsMTQuOSA0NCwxNC45IDUzLjMsMzMuNSAJCSIvPg0KCQk8cGF0aCBkPSJNNjEuNiwyNS41YzAuNSwyLjUsMS42LDQuNCwzLjMsNS45YzEuNywxLjQsMy43LDIuMSw2LDIuMWMyLjEsMCwzLjktMC4zLDUuMi0xTDc1LjgsMjhjLTAuNSwwLjUtMS4xLDAuOS0yLDEuMw0KCQkJYy0wLjksMC40LTEuNywwLjYtMi40LDAuNmMtMS40LDAtMi41LTAuMy0zLjQtMWMtMC45LTAuNy0xLjUtMS43LTEuNy0yLjljMC0wLjItMC4xLTAuNS0wLjEtMC44YzEuMywwLjQsMi43LDAuNiw0LDAuNg0KCQkJYzIuNywwLDQuOC0wLjYsNi40LTEuOGMxLjYtMS4yLDIuMi0yLjgsMS44LTQuOWMtMC4zLTEuNS0xLjEtMi43LTIuNS0zLjVjLTEuNC0wLjgtMy4xLTEuMi01LTEuMmMtMy40LDAtNS45LDEuMS03LjUsMy4xDQoJCQlDNjEuNiwxOS43LDYxLDIyLjMsNjEuNiwyNS41eiBNNjgsMTkuMmMwLjgtMC43LDIuMS0xLjIsMi45LTEuMmMyLjIsMCwyLjksMC42LDMuMSwxLjZjMC4yLDAuOS0wLjIsMS42LTEuMywyDQoJCQljLTEsMC41LTIuMywwLjctMy45LDAuN2MtMC45LDAtMS43LTAuMS0yLjUtMC4zQzY2LjcsMjAuOCw2Ny4yLDE5LjksNjgsMTkuMnoiLz4NCgkJPHBhdGggZD0iTTc0LjgsNDYuOWwwLTExLjRjLTEuNS0wLjYtMy45LTAuOS03LjEtMC45Yy0zLjMsMC01LjgsMS4zLTcuNSwzLjhjLTEuNywyLjUtMi4yLDUuNS0xLjUsOWMwLjQsMiwxLjMsMy42LDIuNiw0LjcNCgkJCWMxLjMsMS4xLDMuMSwxLjcsNS4xLDEuN2MyLjMsMCw0LTAuNyw1LjItMi4yYzAuNiwxLjIsMS40LDEuOSwyLjIsMS45bDIuOCwwYy0wLjYtMC45LTEuMS0yLjctMS42LTUuMg0KCQkJQzc0LjgsNDcuOCw3NC44LDQ3LjMsNzQuOCw0Ni45eiBNNjkuNyw0OGMtMC43LDEuNS0xLjYsMi4zLTIuOSwyLjNjLTIsMC0zLjItMS0zLjYtM2MtMC41LTIuNC0wLjMtNC41LDAuNS02LjQNCgkJCWMwLjgtMS45LDIuMi0yLjgsNC4yLTIuOGMwLjcsMCwxLjYsMC4xLDIuNCwwLjNDNzAuNiw0My4zLDcwLjQsNDYuNSw2OS43LDQ4eiIvPg0KCQk8cGF0aCBkPSJNOTcuNSw0Ny4yYy0wLjItMC44LTAuNS0xLjYtMS4xLTIuMmMtMC42LTAuNi0xLjItMS4xLTItMS41Yy0wLjgtMC40LTEuOC0wLjktMy4yLTEuNWMtMS40LTAuNi0yLjItMS4zLTIuMy0yDQoJCQljLTAuMS0wLjYsMC4xLTEsMC42LTEuM2MwLjUtMC4zLDEuMS0wLjUsMS44LTAuNWMxLjIsMCwyLjYsMC42LDQuMywxLjhsMS4zLTRjLTIuNS0xLTQuNS0xLjQtNi0xLjRjLTIuMSwwLTMuOCwwLjUtNS4xLDEuNg0KCQkJYy0xLjMsMS4xLTEuNywyLjUtMS40LDQuM2MwLjIsMC44LDAuNSwxLjYsMS4xLDIuMmMwLjYsMC43LDEuMywxLjIsMi4zLDEuN2MwLjksMC41LDIsMSwzLjIsMS41YzEuMiwwLjYsMS45LDEuMiwyLDEuOA0KCQkJYzAuMSwwLjcsMCwxLjMtMC41LDEuOGMtMC41LDAuNC0xLjIsMC43LTIuMSwwLjdjLTEuNCwwLTMtMC43LTQuNy0yTDg0LDUyLjFjMi4yLDEuMSw0LjQsMS43LDYuNCwxLjdjMi40LDAsNC4zLTAuNiw1LjctMS44DQoJCQlDOTcuNCw1MC45LDk3LjksNDkuMyw5Ny41LDQ3LjJ6Ii8+DQoJCTxwYXRoIGQ9Ik0yNy40LDE5LjVjLTAuNi0zLjMtMi44LTUtNi42LTVjLTIuMywwLTQsMC43LTUuMiwyYy0xLjMtMS4zLTMuMi0yLTUuNi0yYy0yLjEsMC0zLjgsMC41LTUsMS42Yy0wLjItMC41LTAuNC0xLjEtMC43LTEuNw0KCQkJbC00LjIsMC43YzAuNSwxLjEsMC45LDIuMiwxLjEsMy4zYzAuMSwwLjYsMC4yLDEuMSwwLjIsMS40bDAsMTMuMmw0LjUsMGwwLTEzLjFjMC4zLTAuNSwwLjgtMSwxLjQtMS40YzAuNi0wLjQsMS4yLTAuNiwxLjgtMC42DQoJCQljMS45LDAsMi45LDAuNiwzLjEsMS44YzAsMC4xLDAsMC4zLDAsMC40bDAsMTIuOWw0LjUsMGwwLTEzLjFjMC4zLTAuNSwwLjctMC45LDEuMy0xLjNjMC42LTAuNCwxLjMtMC42LDEuOS0wLjYNCgkJCWMxLjcsMCwyLjcsMC44LDMsMi40YzAuMSwwLjQsMC4xLDAuOCwwLjEsMS4ybDAsMTEuNWw0LjUsMGwwLTEyQzI3LjUsMjAuNiwyNy41LDIwLDI3LjQsMTkuNXoiLz4NCgkJPHBhdGggZD0iTTMxLjQsMzEuN2MxLjYsMS4yLDMuNSwxLjksNS45LDEuOGMzLjIsMCw1LjctMS4xLDcuMy0zLjRjMS42LTIuMywyLjEtNS4xLDEuNC04LjVjLTAuNC0yLjMtMS40LTQtMy01LjINCgkJCWMtMS41LTEuMi0zLjUtMS44LTUuOS0xLjhjLTMuMiwwLTUuNiwxLjEtNy4yLDMuNGMtMS42LDIuMy0yLjEsNS4xLTEuNSw4LjRDMjguOCwyOC42LDI5LjgsMzAuNCwzMS40LDMxLjd6IE0zMy40LDIwLjQNCgkJCWMwLjgtMS42LDItMi40LDMuOC0yLjRjMi4zLDAsMy43LDEuMiw0LjIsMy43YzAuNCwyLjMsMC4zLDQuMi0wLjUsNS45Yy0wLjcsMS42LTIsMi41LTMuOSwyLjVjLTIuMywwLTMuNy0xLjMtNC4yLTMuOQ0KCQkJQzMyLjQsMjQsMzIuNiwyMi4xLDMzLjQsMjAuNHoiLz4NCgkJPHBhdGggZD0iTTU3LjUsMzkuN2MtMC42LTMuNC0yLjktNS4xLTYuNy01Yy0yLjMsMC00LDAuNy01LjMsMmMtMS4zLTEuMy0zLjItMi01LjctMmMtMi4xLDAtMy44LDAuNS01LDEuNg0KCQkJYy0wLjItMC41LTAuNC0xLjEtMC43LTEuN2wtNC4yLDAuN2MwLjUsMS4xLDAuOSwyLjIsMS4xLDMuM2MwLjEsMC43LDAuMiwxLjEsMC4yLDEuNWwwLDEzLjRsNC41LDBsMC0xMy4zYzAuMy0wLjUsMC44LTEsMS40LTEuNA0KCQkJYzAuNi0wLjQsMS4yLTAuNiwxLjgtMC42YzEuOSwwLDIuOSwwLjYsMy4yLDEuOGMwLDAuMSwwLDAuMywwLDAuNGwwLDEzLjFsNC41LDBsMC0xMy4zYzAuMy0wLjUsMC43LTAuOSwxLjQtMS40DQoJCQljMC42LTAuNCwxLjMtMC42LDEuOS0wLjZjMS43LDAsMi44LDAuOCwzLjEsMi40YzAuMSwwLjQsMC4xLDAuOCwwLjEsMS4ybDAsMTEuN2w0LjUsMGwwLTEyLjJDNTcuNyw0MC43LDU3LjYsNDAuMiw1Ny41LDM5Ljd6Ii8+DQoJPC9nPg0KCTxnPg0KCQk8cG9seWdvbiBjbGFzcz0ic3QwIiBwb2ludHM9IjEwNy4yLDI3LjUgMTAwLDI3LjUgMTAwLDQwLjcgMTEzLjIsNDAuNyAxMTMuMiwyNy41IDEwNy4yLDI3LjUgCQkiLz4NCgkJPHBvbHlnb24gY2xhc3M9InN0MSIgcG9pbnRzPSIxMDcuMiwxOS43IDEwNy4yLDI3LjUgMTEzLjIsMjcuNSAxMTMuMiwyNy41IDExMy4yLDE5LjcgCQkiLz4NCgkJPHBvbHlnb24gY2xhc3M9InN0MiIgcG9pbnRzPSIxMTMuMiwwLjEgMTAwLDAuMSAxMDAsMTQuMyAxMDcuMiwxNC4zIDExMy4yLDE0LjMgCQkiLz4NCgkJPHBvbHlnb24gY2xhc3M9InN0MyIgcG9pbnRzPSIxMTMuMiwxOS43IDExMy4yLDI3LjUgMTI3LjQsMjcuNSAxMjcuNCwxNC4zIDExMy4yLDE0LjMgCQkiLz4NCgkJPHBvbHlnb24gY2xhc3M9InN0NCIgcG9pbnRzPSIxMDcuMiwyNy41IDEwNy4yLDE5LjcgMTA3LjIsMTkuNyAxMDcuMiwxNC4zIDg2LjgsMTQuMyA4Ni44LDI3LjUgMTAwLDI3LjUgMTA3LjIsMjcuNSAJCSIvPg0KCQk8cG9seWdvbiBjbGFzcz0ic3Q1IiBwb2ludHM9IjEwNy4yLDE5LjcgMTEzLjIsMTkuNyAxMTMuMiwxNC4zIDEwNy4yLDE0LjMgMTA3LjIsMTQuMyAxMDcuMiwxOS43IAkJIi8+DQoJPC9nPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),
/* 1798 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1799 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0icmdiKDk3LDU4LDEyNSkiIGNsYXNzPSJiaSBiaS1xci1jb2RlIiB2aWV3Qm94PSIwIDAgMTYgMTYiPg0KICA8cGF0aCBkPSJNMiAyaDJ2MkgyVjJaIi8+DQogIDxwYXRoIGQ9Ik02IDB2NkgwVjBoNlpNNSAxSDF2NGg0VjFaTTQgMTJIMnYyaDJ2LTJaIi8+DQogIDxwYXRoIGQ9Ik02IDEwdjZIMHYtNmg2Wm0tNSAxdjRoNHYtNEgxWm0xMS05aDJ2MmgtMlYyWiIvPg0KICA8cGF0aCBkPSJNMTAgMHY2aDZWMGgtNlptNSAxdjRoLTRWMWg0Wk04IDFWMGgxdjJIOHYySDdWMWgxWm0wIDVWNGgxdjJIOFpNNiA4VjdoMVY2aDF2MmgxVjdoNXYxaC00djFIN1Y4SDZabTAgMHYxSDJWOEgxdjFIMFY3aDN2MWgzWm0xMCAxaC0xVjdoMXYyWm0tMSAwaC0xdjJoMnYtMWgtMVY5Wm0tNCAwaDJ2MWgtMXYxaC0xVjlabTIgM3YtMWgtMXYxaC0xdjFIOXYxaDN2LTJoMVptMCAwaDN2MWgtMnYxaC0xdi0yWm0tNC0xdjFoMXYtMkg3djFoMloiLz4NCiAgPHBhdGggZD0iTTcgMTJoMXYzaDR2MUg3di00Wm05IDJ2MmgtM3YtMWgydi0xaDFaIi8+DQo8L3N2Zz4NCg=="

/***/ }),
/* 1800 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1801 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1802 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1803 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1804 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNjAuMTM3IiBoZWlnaHQ9IjMwLjA2OCIgdmlld0JveD0iMCAwIDYwLjEzNyAzMC4wNjgiPg0KICA8ZGVmcz4NCiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImxpbmVhci1ncmFkaWVudCIgeTE9IjAuNSIgeDI9IjEiIHkyPSIwLjUiIGdyYWRpZW50VW5pdHM9Im9iamVjdEJvdW5kaW5nQm94Ij4NCiAgICAgIDxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iIzI3MjE1OCIvPg0KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMTY0MTk0Ii8+DQogICAgPC9saW5lYXJHcmFkaWVudD4NCiAgPC9kZWZzPg0KICA8ZyBpZD0iQ2FyZENhcnRhb1Zpc2EiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMTI1IC0wLjIxNikiPg0KICAgIDxyZWN0IGlkPSJSZXTDom5ndWxvXzMiIGRhdGEtbmFtZT0iUmV0w6JuZ3VsbyAzIiB3aWR0aD0iNjAuMTM3IiBoZWlnaHQ9IjMwLjA2OCIgcng9IjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0wLjEyNSAwLjIxNikiIGZpbGw9IiNmZmYiIG9wYWNpdHk9IjAuOTk4Ii8+DQogICAgPHBhdGggaWQ9InZpc2Etc2Vla2xvZ28iIGQ9Ik0yOC40NzEsMTYuMDgybC02Ljk0NSwxNi41N0gxN0wxMy41NzgsMTkuNDI3YTEuODIyLDEuODIyLDAsMCwwLTEuMDE5LTEuNDU2LDE3Ljg0NSwxNy44NDUsMCwwLDAtNC4yMjktMS40MWwuMS0uNDgxaDcuMjk0YTIsMiwwLDAsMSwxLjk3NywxLjY5bDEuODA1LDkuNTg4TDIzLjk2OSwxNi4wOGg0LjVabTE3Ljc1NCwxMS4xNmMuMDItNC4zNzEtNi4wNDYtNC42MTUtNi02LjU2Ny4wMTItLjU5NC41OC0xLjIyNSwxLjgxNy0xLjM4OGE4LjA3Niw4LjA3NiwwLDAsMSw0LjIyNy43NDJsLjc1NC0zLjUxNGExMS40ODUsMTEuNDg1LDAsMCwwLTQuMDEtLjczNGMtNC4yMzYsMC03LjIxOCwyLjI1Mi03LjI0Miw1LjQ3Ny0uMDI5LDIuMzg3LDIuMTI5LDMuNzE2LDMuNzUzLDQuNTA5LDEuNjcuODEzLDIuMjMsMS4zMzQsMi4yMjMsMi4wNTgtLjAxMiwxLjExMy0xLjMzMSwxLjYtMi41NjYsMS42MjFhOC45Nyw4Ljk3LDAsMCwxLTQuNC0xLjA0NmwtLjc3NiwzLjYzMmExMi45ODEsMTIuOTgxLDAsMCwwLDQuNzY3Ljg3OWM0LjUwNywwLDcuNDUxLTIuMjIzLDcuNDYzLTUuNjY4bTExLjE4OSw1LjQxaDMuOTY0bC0zLjQ2LTE2LjU3SDU0LjI1N0ExLjk1MSwxLjk1MSwwLDAsMCw1Mi40MzMsMTcuM0w0NiwzMi42NTJoNC41bC44OTQtMi40NzZoNS41Wk01Mi42MzIsMjYuNzhsMi4yNTctNi4yMjEsMS4zLDYuMjIxWk0zNC42LDE2LjA4MmwtMy41NDQsMTYuNTdIMjYuNzY0bDMuNTQ2LTE2LjU3SDM0LjZaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNC42OTYgLTguNzk4KSIgZmlsbD0idXJsKCNsaW5lYXItZ3JhZGllbnQpIi8+DQogIDwvZz4NCjwvc3ZnPg0K"

/***/ }),
/* 1805 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1806 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGlkPSJDbG9zZSIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzYyXzE4NTIpIj4NCjxnIGlkPSJHcm91cCI+DQo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNMC4yNTI2OTkgMTUuMjQyOUMwLjU5NDQ5NiAxNS41NzUgMS4xNjA5IDE1LjU3NSAxLjQ5MjkzIDE1LjI0MjlMNy43NDI5MyA4Ljk5MjkzTDEzLjk5MjkgMTUuMjQyOUMxNC4zMjUgMTUuNTc1IDE0LjkwMTEgMTUuNTg0NyAxNS4yMzMyIDE1LjI0MjlDMTUuNTY1MiAxNC45MDExIDE1LjU2NTIgMTQuMzQ0NSAxNS4yMzMyIDE0LjAxMjVMOC45ODMxNyA3Ljc1MjdMMTUuMjMzMiAxLjUwMjdDMTUuNTY1MiAxLjE3MDY3IDE1LjU3NSAwLjYwNDI2MSAxNS4yMzMyIDAuMjcyMjNDMTQuODkxNCAtMC4wNjk1NjcyIDE0LjMyNSAtMC4wNjk1NjcyIDEzLjk5MjkgMC4yNzIyM0w3Ljc0MjkzIDYuNTIyMjNMMS40OTI5MyAwLjI3MjIzQzEuMTYwOSAtMC4wNjk1NjcyIDAuNTg0NzMgLTAuMDc5MzMyOCAwLjI1MjY5OSAwLjI3MjIzQy0wLjA3OTMzMjQgMC42MTQwMjcgLTAuMDc5MzMyNCAxLjE3MDY3IDAuMjUyNjk5IDEuNTAyN0w2LjUwMjcgNy43NTI3TDAuMjUyNjk5IDE0LjAxMjVDLTAuMDc5MzMyNCAxNC4zNDQ1IC0wLjA4OTA5ODIgMTQuOTEwOSAwLjI1MjY5OSAxNS4yNDI5WiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC44NSIvPg0KPC9nPg0KPC9nPg0KPGRlZnM+DQo8Y2xpcFBhdGggaWQ9ImNsaXAwXzYyXzE4NTIiPg0KPHJlY3Qgd2lkdGg9IjE1LjQ4NTkiIGhlaWdodD0iMTUuNDk1NiIgZmlsbD0id2hpdGUiLz4NCjwvY2xpcFBhdGg+DQo8L2RlZnM+DQo8L3N2Zz4NCg=="

/***/ }),
/* 1807 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNTEuOTMxIiBoZWlnaHQ9IjQxLjU0MiIgdmlld0JveD0iMCAwIDE1MS45MzEgNDEuNTQyIj4NCiAgPGcgaWQ9Ikdvb2dsZVBsYXkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTQ3KSI+DQogICAgPHBhdGggaWQ9IkNhbWluaG9fNzQ4IiBkYXRhLW5hbWU9IkNhbWluaG8gNzQ4IiBkPSJNNTIuODE1LDYyLjNhMy4wMTUsMy4wMTUsMCwxLDAsMy4wMTUsMy4wMTVBMy4wMTUsMy4wMTUsMCwwLDAsNTIuODE1LDYyLjNaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMy42MiAxMC4zMjkpIiBmaWxsPSIjZmZmIi8+DQogICAgPHBhdGggaWQ9IkNhbWluaG9fNzQ5IiBkYXRhLW5hbWU9IkNhbWluaG8gNzQ5IiBkPSJNNzAuMDgzLDU5LjRINjYuOXY1LjAyNWgzLjE4M2EyLjUxMywyLjUxMywwLDEsMCwwLTUuMDI1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDUuMTY0IDguMzcxKSIgZmlsbD0iI2ZmZiIvPg0KICAgIDxwYXRoIGlkPSJDYW1pbmhvXzc1MCIgZGF0YS1uYW1lPSJDYW1pbmhvIDc1MCIgZD0iTTM5Ljg4Myw2Mi4zYTMuMDE1LDMuMDE1LDAsMSwwLDIuODQ4LDMuMDE1QTIuODQ4LDIuODQ4LDAsMCwwLDM5Ljg4Myw2Mi4zWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjQuNzc2IDEwLjMyNykiIGZpbGw9IiNmZmYiLz4NCiAgICA8cGF0aCBpZD0iQ2FtaW5ob183NTEiIGRhdGEtbmFtZT0iQ2FtaW5obyA3NTEiIGQ9Ik02My41LDUzLjA3YTEsMSwwLDAsMC0uNS44MzguODM4LjgzOCwwLDAsMCwuMzM1LjY3aC44MzhhMS42NzUsMS42NzUsMCwwLDAsMS4xNzMtLjUsMS41MDgsMS41MDgsMCwwLDAsLjUtMS4xNzN2LS41SDY1LjAxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDIuNTMxIDMuNjQ2KSIgZmlsbD0iI2ZmZiIvPg0KICAgIDxwYXRoIGlkPSJDYW1pbmhvXzc1MiIgZGF0YS1uYW1lPSJDYW1pbmhvIDc1MiIgZD0iTTYxLjE4Miw2Mi4zYTIuNjgsMi42OCwwLDAsMC0yLjY4LDIuODQ4bDQuNTIzLTEuNjc1QTIuMDEsMi4wMSwwLDAsMCw2MS4xODIsNjIuM1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM5LjQ5MSAxMC4zMjkpIiBmaWxsPSIjZmZmIi8+DQogICAgPHBhdGggaWQ9IkNhbWluaG9fNzUzIiBkYXRhLW5hbWU9IkNhbWluaG8gNzUzIiBkPSJNMzEuMzIsNTMuMTU1YTMuMDE1LDMuMDE1LDAsMCwwLS42Ny0yLjE3OCwyLjg0OCwyLjg0OCwwLDAsMC0yLjE3OC0uNjdIMjcuM1Y1Ni4xN2gxLjAwNWEzLjE4MywzLjE4MywwLDAsMCwyLjM0NS0uODM4QTMuMDE1LDMuMDE1LDAsMCwwLDMxLjMyLDUzLjE1NVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4LjQzIDIuMjIpIiBmaWxsPSIjZmZmIi8+DQogICAgPHBhdGggaWQ9IkNhbWluaG9fNzU0IiBkYXRhLW5hbWU9IkNhbWluaG8gNzU0IiBkPSJNNDEuNyw1NS41NjFhMS41MDgsMS41MDgsMCwwLDAsMS4xNzMtLjUsMi42OCwyLjY4LDAsMCwwLC41LTEuNjc1LDIuNTEzLDIuNTEzLDAsMCwwLS41LTEuNjc1LDEuODE3LDEuODE3LDAsMCwwLTIuNTEzLDAsMy4zNSwzLjM1LDAsMCwwLDAsMy4xODNBMS41MDgsMS41MDgsMCwwLDAsNDEuNyw1NS41NjFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNi45NzcgMi44MykiIGZpbGw9IiNmZmYiLz4NCiAgICA8cGF0aCBpZD0iQ2FtaW5ob183NTUiIGRhdGEtbmFtZT0iQ2FtaW5obyA3NTUiIGQ9Ik0xNTEuOTMxLDg0LjM1NVY1MS4xODhBNC4xODgsNC4xODgsMCwwLDAsMTQ3Ljc0NCw0N0g0LjE4OEE0LjE4OCw0LjE4OCwwLDAsMCwwLDUxLjE4OFY4NC4zNTVhNC4xODgsNC4xODgsMCwwLDAsNC4xODgsNC4xODhIMTQ3Ljc0NEE0LjE4OCw0LjE4OCwwLDAsMCwxNTEuOTMxLDg0LjM1NVpNOTguNjYzLDUzLjUzM2guNjd2LjgzOGgwbC42Ny0uNjdoMS4wMDVhMi4xNzgsMi4xNzgsMCwwLDEsMS41MDguNSwyLjAxLDIuMDEsMCwwLDEsLjUsMS41MDhWNTkuNGgtLjgzOFY1NS41NDNhMS41MDgsMS41MDgsMCwwLDAtLjMzNS0xLjAwNWwtMS4wMDUtLjMzNWExLjY3NSwxLjY3NSwwLDAsMC0xLjM0LjUsMi4zNDUsMi4zNDUsMCwwLDAtLjMzNSwxLjUwOHYyLjg0OGgtLjgzOFptLTUuNTI4LTIuMzQ1aC44Mzh2Ny44NzNoLS44MzhaTTcyLjg2Nyw1My41MzNoLjY3di44MzhoMGwuNjctLjY3aDEuMTczYTIuMTc4LDIuMTc4LDAsMCwxLDEuNTA4LjUsMi4wMSwyLjAxLDAsMCwxLC41LDEuNTA4VjU5LjRoLS44MzhWNTUuNTQzYTEuNTA4LDEuNTA4LDAsMCwwLS4zMzUtMS4wMDVMNzUuMjEyLDU0LjJhMS42NzUsMS42NzUsMCwwLDAtMS4zNC41LDIuMzQ1LDIuMzQ1LDAsMCwwLS4zMzUsMS41MDh2Mi44NDhINzIuN1ptLTYuMDMuNjdhMi40NDYsMi40NDYsMCwwLDEsMy42ODUsMCwzLjUxOCwzLjUxOCwwLDAsMSwwLDQuMTg4LDIuMzQ1LDIuMzQ1LDAsMCwxLTEuODQzLjgzOGwtMS4zNC0uMzM1YTIuMzQ1LDIuMzQ1LDAsMCwxLS44MzgtMS4wMDUsMy41MTgsMy41MTgsMCwwLDEtLjMzNS0xLjUwOCwzLjAxNSwzLjAxNSwwLDAsMSwuNjctMi4xNzhabS02Ljg2OC0uNjdoLjY3di44MzhoMGwuNjctLjY3aDEuMDA1YTIuMDEsMi4wMSwwLDAsMSwxLjY3NS42Nyw0LjAyLDQuMDIsMCwwLDEsMCw0LjE4OCwyLjAxLDIuMDEsMCwwLDEtMS42NzUuODM4SDYxLjMwOWwtLjY3LS42N2gwYTcuNzA2LDcuNzA2LDAsMCwxLDAsLjgzOHYyLjM0NUg1OS44Wm0tNC44NTguMzM1LDEuNTA4LS4zMzUsMS42NzUuMzM1LS4zMzUuNjdMNTYuNDUxLDU0LjJoLS44MzhhLjUuNSwwLDAsMC0uMzM1LjV2LjMzNWwuMzM1LjMzNSwxLjAwNS4zMzUsMS4zNC42N2ExLjQyNiwxLjQyNiwwLDAsMS0uMTY4LDIuMDEsMi42OCwyLjY4LDAsMCwxLTEuNjc1LjMzNWwtMS42NzUtLjMzNXYtLjgzOGwuODM4LjMzNWgxLjg0M2EuNjcuNjcsMCwwLDAsMC0xLjE3M2wtMS4xNzMtLjUtMS4xNzMtLjUtLjUtLjVhMS4zNCwxLjM0LDAsMCwxLS4xNjgtLjY3LDEuMTczLDEuMTczLDAsMCwxLDEuMDA1LS42N1pNNTIuMjYzLDUxLjY5aC42N2EuNTkyLjU5MiwwLDAsMSwwLC44MzhoLS42N2EuODM4LjgzOCwwLDAsMSwwLTEuMDA1Wm0uODM4LDEuODQzdjUuNTI4aC0uODM4VjUzLjUzM1pNNDQuNzI1LDUxLjY5SDQ2LjlhMy4zNSwzLjM1LDAsMCwxLDMuNjg1LDMuNjg1LDMuNjg1LDMuNjg1LDAsMCwxLTEuMDA1LDIuODQ4LDMuODUzLDMuODUzLDAsMCwxLTIuODQ4LDEuMDA1aC0yLjAxWk0xMy4yMzMsNTQuNzA1bDE1LjkxMyw4Ljg3OGMuMTY4LjE2OC4xNjguMTY4LDAsLjMzNWwtMy41MTgsMy41MThjLS4xNjguMTY4LS4xNjguMTY4LS4zMzUsMGwtMTIuNzMxLTEyLjloLjY3Wk0xMS41NTgsODFhMS41MDgsMS41MDgsMCwwLDEtLjY3LTEuMzRWNjcuOTM5aDBWNTYuMjEzYTEuNjc1LDEuNjc1LDAsMCwxLC41LTEuMzRjLjE2OC0uMTY4LjE2OC0uMTY4LjMzNSwwbDcuODczLDguMDQsNS4wMjUsNS4xOTNhLjMxNC4zMTQsMCwwLDEsMCwuNWwtMTIuNCwxMi4yMjhhLjUuNSwwLDAsMS0uNjcuMTY4Wm0xNy4wODYtOC4zNzVMMTMuOSw4MC42NjloLS4xNjhMMjUuMjk0LDY4Ljk0NGEuMzE0LjMxNCwwLDAsMSwuNSwwbDMuMDE1LDMuMTgzYy4xNjguMTY4LjE2OC4xNjgtLjE2OC4zMzVabTYuNTMzLTMuNjg1LS42Ny41LTQuNTIzLDIuNTEzaC0uNUwyNi4zLDY4LjYwOWMtLjE2OC0uMTY4LS4xNjgtLjE2OCwwLS4zMzVsMy42ODUtMy42ODVoLjVMMzUuMDEsNjcuMWExLjM0LDEuMzQsMCwwLDEsLjgzOCwxLjE3MywxLjE3MywxLjE3MywwLDAsMS0uNjcuNjdabTIxLjc3Niw5LjcxNmE3LjAzNSw3LjAzNSwwLDAsMS01LjM2LDIuMTc4LDcuNzg5LDcuNzg5LDAsMSwxLDAtMTUuNTc4LDcuMzcsNy4zNywwLDAsMSw1LjM2LDIuMDFsLTEuNTA4LDEuNTA4YTUuMzYsNS4zNiwwLDAsMC0zLjg1My0xLjUwOCw1LjcsNS43LDAsMCwwLDAsMTEuMjIzLDUuMTkzLDUuMTkzLDAsMCwwLDMuODUzLTEuNTA4LDQuMzU1LDQuMzU1LDAsMCwwLDEuMTczLTIuNjhINTEuNTkzdi0yLjAxaDcuMDM1YTYuODY4LDYuODY4LDAsMCwxLC4xNjgsMS4zNCw3LjAzNSw3LjAzNSwwLDAsMS0xLjg0Myw0Ljg1OFptNy41MzgsMi4xNzhhNS4wMjUsNS4wMjUsMCwxLDEsNS4wMjUtNS4wMjUsNS4wMjUsNS4wMjUsMCwwLDEtNC44NTgsNC44NThabTEwLjg4OCwwQTUuMDI1LDUuMDI1LDAsMSwxLDgwLjQsNzUuODEyYTQuODU4LDQuODU4LDAsMCwxLTQuODU4LDQuODU4Wm0zLjY4NS0yMS42MDl2LTUuN0g3OS45djUuNTI4Wm0uNS02LjJoLS41bC41LS44MzguNS0uODM4aDEuMDA1bC0uNjcuODM4Wm0yLjE3OC42NywxLjE3MywzLjM1LjUsMS41MDhoMGwuMzM1LTEuMTczLDEuMzQtMy42ODVoLjgzOGwtMi4xNzgsNS41MjhIODIuNzVMODAuNTcyLDUzLjdaTTkwLjc5LDgwLjE2N2MwLDMuNjg1LTIuMTc4LDUuMTkzLTQuNjksNS4xOTNhNC42OSw0LjY5LDAsMCwxLTQuMzU1LTMuMDE1bDEuODQzLS44MzhBMi44NDgsMi44NDgsMCwwLDAsODYuMSw4My4zNWMxLjY3NSwwLDIuNjgtMS4wMDUsMi42OC0zLjAxNXYtLjY3aDBhMy4zNSwzLjM1LDAsMCwxLTIuNjgsMS4xNzMsNS4wMjUsNS4wMjUsMCwwLDEsMC0xMC4wNTEsMy41MTgsMy41MTgsMCwwLDEsMi42OCwxLjE3M2gwdi0uODM4aDIuMDFabS42Ny0yMy42MTlIODcuOTQzYTIuMTc4LDIuMTc4LDAsMCwwLC41LDEuNTA4LDEuNjc1LDEuNjc1LDAsMCwwLDEuMzQuNWwxLjg0My0uMzM1di42N2wtLjgzOC4zMzVIODkuNzg1YTIuNTEzLDIuNTEzLDAsMCwxLTIuMDEtLjY3LDIuODQ4LDIuODQ4LDAsMCwxLS42Ny0yLjAxLDMuMTgzLDMuMTgzLDAsMCwxLC42Ny0yLjE3OCwyLjQzOCwyLjQzOCwwLDAsMSwzLjUxOC0uMTY4LDIuNjgsMi42OCwwLDAsMSwuNjcsMS44NDNaTTk0LjgxMSw4MC41SDkyLjYzM1Y2NS43NjFoMi4xNzhabTYuMDMtMS42NzVhMi44NDgsMi44NDgsMCwwLDAsMi41MTMtMS4zNGwxLjY3NSwxLjE3M2E1LjAyNSw1LjAyNSwwLDAsMS00LjE4OCwyLjE3OCw0Ljg1OCw0Ljg1OCwwLDAsMS01LjAyNS01LjAyNSw0LjY0OSw0LjY0OSwwLDAsMSw5LjA0Ni0xLjg0M3YuNWwtNi43LDIuODQ4YTIuNTEzLDIuNTEzLDAsMCwwLDIuNjgsMS41MDhabTguMzc1LTE5Ljc2NmgtLjY3di0uODM4aDBsLS44MzguNjdIMTA2LjdhMS44NDMsMS44NDMsMCwwLDEtMS4zNC0uNSwxLjUwOCwxLjUwOCwwLDAsMS0uNS0xLjE3M3EwLTEuNjc1LDIuNjgtMS44NDNoMS4wMDVhMS4zNCwxLjM0LDAsMCwwLS4zMzUtMS4wMDVsLS44MzgtLjMzNS0xLjUwOC41LS4zMzUtLjY3LjgzOC0uMzM1aC44MzhhMi4xNzgsMi4xNzgsMCwwLDEsMS41MDguNSwxLjg0MywxLjg0MywwLDAsMSwuNSwxLjM0Wm01Ljg2MywxNS43NDZoLTMuMDE1djUuN2gtMi4xNzhWNjUuNzYxaDUuMTkzYTQuNjA3LDQuNjA3LDAsMCwxLDAsOS4yMTNabTguMzc1LDUuN0gxMjEuMTFWNjUuNzYxaDIuMTc4Wm05Ljg4MywwSDEzMS4xNlY3OS4zMjloMGEzLjAxNSwzLjAxNSwwLDAsMS0yLjg0OCwxLjUwOCwzLjM1LDMuMzUsMCwwLDEtMy42ODUtMy4xODNjMC0yLjE3OCwyLjE3OC0zLjM1LDQuMTg4LTMuMzVhNC44NTgsNC44NTgsMCwwLDEsMi4zNDUuNWgwYTIuMTc4LDIuMTc4LDAsMCwwLTIuMzQ1LTEuODQzLDIuMDEsMi4wMSwwLDAsMC0yLjAxLDEuMDA1bC0yLjAxLS44MzhhNC4xODgsNC4xODgsMCwwLDEsMy44NTMtMi4xNzgsNC4wMiw0LjAyLDAsMCwxLDQuNTIzLDQuMDJabTQuMDIsNC4zNTVoLTIuMzQ1bDIuMTc4LTUuMDI1LTMuODUzLTguODc4aDIuMzQ1bDIuNjgsNi4zNjVoMGwyLjUxMy02LjM2NWgyLjUxM1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDApIiBmaWxsPSIjZmZmIi8+DQogICAgPHBhdGggaWQ9IkNhbWluaG9fNzU2IiBkYXRhLW5hbWU9IkNhbWluaG8gNzU2IiBkPSJNNTQuMDA4LDUxLjNBMS4zNCwxLjM0LDAsMCwwLDUzLDUxLjhhMi4wMSwyLjAxLDAsMCwwLS41LDEuMTczaDIuODQ4YTEuODQzLDEuODQzLDAsMCwwLS4zMzUtMS4xNzNBMS4xNzMsMS4xNzMsMCwwLDAsNTQuMDA4LDUxLjNaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNS40NDMgMi45MDMpIiBmaWxsPSIjZmZmIi8+DQogICAgPHBhdGggaWQ9IkNhbWluaG9fNzU3IiBkYXRhLW5hbWU9IkNhbWluaG8gNzU3IiBkPSJNNDYuMzgzLDYyLjNhMy4wMTUsMy4wMTUsMCwxLDAsMi44NDgsMy4wMTVBMi44NDgsMi44NDgsMCwwLDAsNDYuMzgzLDYyLjNaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyOS4xNjQgMTAuMzI3KSIgZmlsbD0iI2ZmZiIvPg0KICAgIDxwYXRoIGlkPSJDYW1pbmhvXzc1OCIgZGF0YS1uYW1lPSJDYW1pbmhvIDc1OCIgZD0iTTc1LjcsNjUuODc2YzAsLjgzOCwxLjAwNSwxLjE3MywxLjY3NSwxLjE3M2EyLjY4LDIuNjgsMCwwLDAsMi42OC0yLjM0NSwzLjg1MywzLjg1MywwLDAsMC0yLjAxLS41Qzc2Ljg3Myw2NC4zNjgsNzUuNyw2NC43LDc1LjcsNjUuODc2WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTEuMTA1IDExLjYxMSkiIGZpbGw9IiNmZmYiLz4NCiAgICA8cGF0aCBpZD0iQ2FtaW5ob183NTkiIGRhdGEtbmFtZT0iQ2FtaW5obyA3NTkiIGQ9Ik0zNy45MTQsNTUuNDlhMS4zNCwxLjM0LDAsMCwwLDEuMTczLS41LDIuODQ4LDIuODQ4LDAsMCwwLC4zMzUtMS42NzUsMi42OCwyLjY4LDAsMCwwLS4zMzUtMS41MDgsMS4zNCwxLjM0LDAsMCwwLTEuMTczLS41LDEuNTA4LDEuNTA4LDAsMCwwLTEuMTczLjUsMi4zNDUsMi4zNDUsMCwwLDAtLjMzNSwxLjUwOGgwYTIuODQ4LDIuODQ4LDAsMCwwLC4zMzUsMS42NzVBMS41MDgsMS41MDgsMCwwLDAsMzcuOTE0LDU1LjQ5WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjQuNTY3IDIuOTAxKSIgZmlsbD0iI2ZmZiIvPg0KICA8L2c+DQo8L3N2Zz4NCg=="

/***/ }),
/* 1808 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1809 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iSW5zdGFncmFtIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMC40OCIgaGVpZ2h0PSIzMC40OCIgdmlld0JveD0iMCAwIDMwLjQ4IDMwLjQ4Ij4NCiAgPHBhdGggaWQ9IkNhbWluaG9fMTA0IiBkYXRhLW5hbWU9IkNhbWluaG8gMTA0IiBkPSJNMjguNjQsMzAuNDhoMEExNS4yNCwxNS4yNCwwLDAsMSwxMy40LDE1LjI0aDBBMTUuMjQsMTUuMjQsMCwwLDEsMjguNjQsMGgwQTE1LjI0LDE1LjI0LDAsMCwxLDQzLjg4LDE1LjI0aDBBMTUuMjQsMTUuMjQsMCwwLDEsMjguNjQsMzAuNDhaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTMuNCAwKSIgZmlsbD0iI2ZmZiIvPg0KICA8cGF0aCBpZD0iQ2FtaW5ob18xMDUiIGRhdGEtbmFtZT0iQ2FtaW5obyAxMDUiIGQ9Ik0yNS4zLDIxLjY1NkgxOS45MzhhNS4zNjIsNS4zNjIsMCwwLDEtNC41MTYtNC41MTZoMGE3NS42MzUsNzUuNjM1LDAsMCwxLDAtMTAuNzI0aDBBNS4zNjIsNS4zNjIsMCwwLDEsMTkuOTM4LDEuOUgzMC42NjNhNS4zNjIsNS4zNjIsMCwwLDEsNC41MTYsNC41MTZoMGE3NS42MzUsNzUuNjM1LDAsMCwxLDAsMTAuNzI0aDBhNS4zNjIsNS4zNjIsMCwwLDEtNC41MTYsNC41MTZabS01LjA4LTEuNDExSDMwLjY2M2EzLjk1MSwzLjk1MSwwLDAsMCwzLjM4Ny0zLjEsNzMuOTQxLDczLjk0MSwwLDAsMCwwLTEwLjQ0MiwzLjk1MSwzLjk1MSwwLDAsMC0zLjM4Ny0zLjFIMjAuMjIxYTMuOTUxLDMuOTUxLDAsMCwwLTMuMzg3LDMuMSw3My45NDQsNzMuOTQ0LDAsMCwwLDAsMTAuNDQyLDMuOTUxLDMuOTUxLDAsMCwwLDMuMzg3LDMuMVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMC4wNjEgMy40NjIpIiBmaWxsPSIjNGIxYjcxIi8+DQogIDxwYXRoIGlkPSJDYW1pbmhvXzEwNiIgZGF0YS1uYW1lPSJDYW1pbmhvIDEwNiIgZD0iTTIyLjA4LDEzLjc2YTUuMDgsNS4wOCwwLDEsMSw1LjA4LTUuMDhBNS4wOCw1LjA4LDAsMCwxLDIyLjA4LDEzLjc2Wm0wLTkuMDMxQTMuNjY5LDMuNjY5LDAsMSwwLDI1Ljc0OSw4LjRoMEEzLjY2OSwzLjY2OSwwLDAsMCwyMi4wOCw0LjcyOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02Ljg0IDYuNTYpIiBmaWxsPSIjNGIxYjcxIi8+DQogIDxlbGxpcHNlIGlkPSJFbGlwc2VfMiIgZGF0YS1uYW1lPSJFbGlwc2UgMiIgY3g9IjEuMTI5IiBjeT0iMS4xMjkiIHJ4PSIxLjEyOSIgcnk9IjEuMTI5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxOS43NTYgOC43NDkpIiBmaWxsPSIjNGIxYjcxIi8+DQo8L3N2Zz4NCg=="

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/consumidorgov.ec65090.svg";

/***/ }),
/* 1811 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iZmFjZWJvb2siIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjMyLjY3MiIgaGVpZ2h0PSIzMC41MjIiIHZpZXdCb3g9IjAgMCAzMi42NzIgMzAuNTIyIj4NCiAgPGcgaWQ9IkdydXBvXzY4IiBkYXRhLW5hbWU9IkdydXBvIDY4Ij4NCiAgICA8ZWxsaXBzZSBpZD0iRWxpcHNlXzQiIGRhdGEtbmFtZT0iRWxpcHNlIDQiIGN4PSIxNS4yNCIgY3k9IjE1LjI0IiByeD0iMTUuMjQiIHJ5PSIxNS4yNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS4xNzEgMC4wNDIpIiBmaWxsPSIjZmZmIi8+DQogICAgPGVsbGlwc2UgaWQ9IkVsaXBzZV81IiBkYXRhLW5hbWU9IkVsaXBzZSA1IiBjeD0iMTIuOTgyIiBjeT0iMTIuOTgyIiByeD0iMTIuOTgyIiByeT0iMTIuOTgyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzLjQyOSA0LjU1OCkiIGZpbGw9IiM0YjFiNzEiLz4NCiAgICA8cGF0aCBpZD0iaWNvbnM4LWZhY2Vib29rLW5vdm8iIGQ9Ik0xNiwuMDI3YTE1LjI4MiwxNS4yODIsMCwxLDAtMi4yNTgsMzAuNDhWMTkuNUgxMC4wN1YxNS4yNjdoMy42Njl2LTIuNTRjMC00LjUxNiwyLjI1OC02LjQ5MSw1LjkyNy02LjQ5MWgzLjFWOS45MDVIMjAuMjNjLTEuNjkzLDAtMS45NzYsMS40MTEtMS45NzYsMy4xdjIuMjU4aDQuMjMzTDIxLjkyMywxOS41SDE3Ljk3MlYzMC41MDdBMTUuMjcyLDE1LjI3MiwwLDAsMCwxNiwuMDI3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC40MTUgMC4wMTUpIiBmaWxsPSIjZmZmIi8+DQogIDwvZz4NCjwvc3ZnPg0K"

/***/ }),
/* 1812 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0ibGlua2VkaW4iIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjMwLjQ4IiBoZWlnaHQ9IjMwLjQ4IiB2aWV3Qm94PSIwIDAgMzAuNDggMzAuNDgiPg0KICA8cGF0aCBpZD0iQ2FtaW5ob18xMDkiIGRhdGEtbmFtZT0iQ2FtaW5obyAxMDkiIGQ9Ik00Mi4wNCwwQTE1LjI0LDE1LjI0LDAsMSwxLDI2LjgsMTUuMjRoMEExNS4yNCwxNS4yNCwwLDAsMSw0Mi4wNCwwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI2LjggMCkiIGZpbGw9IiNmZmYiLz4NCiAgPHBhdGggaWQ9IkNhbWluaG9fMTEwIiBkYXRhLW5hbWU9IkNhbWluaG8gMTEwIiBkPSJNMjkuNCwxNi4yNDdoMi44MjJWNi4zNjlIMjkuNFpNNDAuOTcxLDYuMDg3QTQuNTE2LDQuNTE2LDAsMCwwLDM3LjMsNy43OFY2LjM2OUgzNC40OHY5Ljg3OEgzNy4zVjEwLjg4NEEyLjI1OCwyLjI1OCwwLDAsMSwzOS41Niw4LjYyN2MxLjQxMSwwLDEuNjkzLDEuMTI5LDEuNjkzLDIuMjU4djUuMzYyaDIuODIyVjEwLjZjMC0zLjk1MS0xLjk3Ni00LjUxNi0zLjM4Ny00LjUxNlptLTkuODc4LS41NjRhMS40MTEsMS40MTEsMCwxLDAtMS40MTEtMS40MTFBMS40MTEsMS40MTEsMCwwLDAsMzEuMDkzLDUuNTIyWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIyLjA2MiA0LjkyKSIgZmlsbD0iIzRiMWI3MSIvPg0KPC9zdmc+DQo="

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/sectigo-siteseal@3x.2714ecf.png";

/***/ }),
/* 1814 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0ieW91dHViZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMzAuNDgiIGhlaWdodD0iMzAuNDgiIHZpZXdCb3g9IjAgMCAzMC40OCAzMC40OCI+DQogIDxlbGxpcHNlIGlkPSJFbGlwc2VfMyIgZGF0YS1uYW1lPSJFbGlwc2UgMyIgY3g9IjE1LjI0IiBjeT0iMTUuMjQiIHJ4PSIxNS4yNCIgcnk9IjE1LjI0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIiBmaWxsPSIjZmZmIi8+DQogIDxwYXRoIGlkPSJDYW1pbmhvXzIxOSIgZGF0YS1uYW1lPSJDYW1pbmhvIDIxOSIgZD0iTTcxLjQ0LDUuODU4QTIuMjU4LDIuMjU4LDAsMCwwLDY5LjE4MiwzLjZINTguNDU4QTIuMjU4LDIuMjU4LDAsMCwwLDU2LjIsNS44NTh2NS45MjdhMi4yNTgsMi4yNTgsMCwwLDAsMi4yNTgsMi4yNThINjkuMTgyYTIuMjU4LDIuMjU4LDAsMCwwLDIuMjU4LTIuMjU4Wk02Mi40MDksMTEuNVY1Ljg1OEw2Ni42NDIsOC42OFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00OC4yOTggNi41NikiIGZpbGw9IiM0YjFiNzEiLz4NCjwvc3ZnPg0K"

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/texto_parceria.7313b58.svg";

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/appStore.5318e2d.svg";

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/consumidor.gov.be0c76b.svg";

/***/ }),
/* 1818 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDUiIGhlaWdodD0iNDMiIHZpZXdCb3g9IjAgMCA0NSA0MyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0yMi40OTcgNDIuNjhDMzQuMDM0OCA0Mi42OCA0My4zODggMzMuMzI2NyA0My4zODggMjEuNzg5QzQzLjM4OCAxMC4yNTEyIDM0LjAzNDggMC44OTc5NjQgMjIuNDk3IDAuODk3OTY0QzEwLjk1OTIgMC44OTc5NjQgMS42MDYwMiAxMC4yNTEyIDEuNjA2MDIgMjEuNzg5QzEuNjA2MDIgMzMuMzI2NyAxMC45NTkyIDQyLjY4IDIyLjQ5NyA0Mi42OFoiIGZpbGw9IiM1RDNCODEiLz4NCjxwYXRoIGQ9Ik0yMi40OTcgNDIuNjhDMzIuMzI1NCA0Mi42OCA0MC4yOTMgMzQuNzEyNCA0MC4yOTMgMjQuODg0QzQwLjI5MyAxNS4wNTU1IDMyLjMyNTQgNy4wODc5NyAyMi40OTcgNy4wODc5N0MxMi42Njg1IDcuMDg3OTcgNC43MDA5OSAxNS4wNTU1IDQuNzAwOTkgMjQuODg0QzQuNzAwOTkgMzQuNzEyNCAxMi42Njg1IDQyLjY4IDIyLjQ5NyA0Mi42OFoiIGZpbGw9IndoaXRlIi8+DQo8cGF0aCBkPSJNMjIuNDk3IDAuODk3OTY2QzE2Ljk1NjQgMC40ODc1NDMgMTEuNDc5NiAyLjI5NDk0IDcuMjcxNTggNS45MjI1NUMzLjA2MzU1IDkuNTUwMTYgMC40Njg5MjYgMTQuNzAwOCAwLjA1ODUwMzMgMjAuMjQxNUMtMC4zNTE5MTkgMjUuNzgyMSAxLjQ1NTQ4IDMxLjI1ODkgNS4wODMwOSAzNS40NjY5QzguNzEwNyAzOS42NzQ5IDEzLjg2MTQgNDIuMjY5NSAxOS40MDIgNDIuNjhWMjcuNTkySDE0LjM3MlYyMS43OTJIMTkuNDAxVjE4LjMwN0MxOS40MDEgMTIuMTE3IDIyLjQ5NiA5LjQwNjk3IDI3LjUyNSA5LjQwNjk3SDMxLjc4MVYxNC40MzZIMjguM0MyNS45NzkgMTQuNDM2IDI1LjU5MiAxNi4zNyAyNS41OTIgMTguNjkyVjIxLjc4N0gzMS4zOTJMMzAuNjE4IDI3LjU4N0gyNS4yMDVWNDIuNjhDMzAuNzI5NyA0Mi4yOTk3IDM1Ljg3ODcgMzkuNzQ1OSAzOS41MjQ3IDM1LjU3NzdDNDMuMTcwNyAzMS40MDk1IDQ1LjAxNjcgMjUuOTY2NiA0NC42NTg1IDIwLjQ0MDRDNDQuMzAwNCAxNC45MTQyIDQxLjc2NzIgOS43NTUwMyAzNy42MTM3IDYuMDkyMzZDMzMuNDYwMSAyLjQyOTcgMjguMDI0NiAwLjU2MTkzMSAyMi40OTcgMC44OTc5NjZaIiBmaWxsPSIjNUQzQjgxIi8+DQo8L3N2Zz4NCg=="

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/googlePlay.7c36c0e.svg";

/***/ }),
/* 1820 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1821 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1822 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/sectigo-siteseal.2bb6921.svg";

/***/ }),
/* 1824 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1825 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik05IDBDNC4wMjk3NSAwIDAgNC4wMjk3NSAwIDlDMCAxMC42ODg0IDAuNDc0MjU2IDEyLjI2MjYgMS4yODMyIDEzLjYxMjhMMC4wODA1NjY0IDE4TDQuNTYxNTIgMTYuODIzN0M1Ljg3MjAyIDE3LjU2ODggNy4zODQ4NyAxOCA5IDE4QzEzLjk3MDMgMTggMTggMTMuOTcwMyAxOCA5QzE4IDQuMDI5NzUgMTMuOTcwMyAwIDkgMFpNNS45MTk0MyA0LjgwMTc2QzYuMDY1NjggNC44MDE3NiA2LjIxNTk1IDQuODAwODcgNi4zNDU3IDQuODA3NjJDNi41MDYyIDQuODExMzcgNi42ODA4OSA0LjgyMzEyIDYuODQ4MTQgNS4xOTI4N0M3LjA0Njg5IDUuNjMyMzcgNy40Nzk2NiA2LjczNDkzIDcuNTM1MTYgNi44NDY2OEM3LjU5MDY2IDYuOTU4NDMgNy42Mjk5OCA3LjA5MDA4IDcuNTUyNzMgNy4yMzYzM0M3LjQ3OTIzIDcuMzg2MzMgNy40NDEwMSA3LjQ3NzExIDcuMzMzMDEgNy42MDk4NkM3LjIyMTI2IDcuNzM4ODYgNy4wOTg4MSA3Ljg5OTA4IDYuOTk3NTYgNy45OTY1OEM2Ljg4NTgxIDguMTA4MzMgNi43NzA0MSA4LjIzMDg2IDYuODk5NDEgOC40NTM2MUM3LjAyODQxIDguNjc2MzYgNy40NzY0MiA5LjQwNjU5IDguMTM4NjcgOS45OTYwOUM4Ljk4OTkyIDEwLjc1NjYgOS43MDgxNCAxMC45OTAzIDkuOTMxNjQgMTEuMTAyMUMxMC4xNTUxIDExLjIxMzggMTAuMjg0NiAxMS4xOTY0IDEwLjQxMzYgMTEuMDQ2NEMxMC41NDYzIDEwLjkwMDEgMTAuOTcxMSAxMC4zOTgzIDExLjEyMTEgMTAuMTc0OEMxMS4yNjczIDkuOTUxMyAxMS40MTY2IDkuOTg5OTggMTEuNjE5MSAxMC4wNjM1QzExLjgyNDYgMTAuMTM3IDEyLjkyMDUgMTAuNjc2OCAxMy4xNDQgMTAuNzg4NkMxMy4zNjc1IDEwLjkwMDMgMTMuNTE0MSAxMC45NTU2IDEzLjU3MDMgMTEuMDQ2NEMxMy42MjgxIDExLjE0MDEgMTMuNjI4MSAxMS41ODY0IDEzLjQ0MjkgMTIuMTA2OUMxMy4yNTc2IDEyLjYyNjcgMTIuMzQ3OSAxMy4xMjkzIDExLjkzOTkgMTMuMTY0NkMxMS41MjgyIDEzLjIwMjggMTEuMTQzOSAxMy4zNDk2IDkuMjYzNjcgMTIuNjA5NEM2Ljk5NTY3IDExLjcxNjEgNS41NjUzNiA5LjM5MzE2IDUuNDUzNjEgOS4yNDMxNkM1LjM0MTg2IDkuMDk2OTEgNC41NDU0MSA4LjAzNTQzIDQuNTQ1NDEgNi45NDA0M0M0LjU0NTQxIDUuODQxNjggNS4xMjE0OSA1LjMwMzU4IDUuMzIzMjQgNS4wODAwOEM1LjUyODc0IDQuODU2NTggNS43Njk0MyA0LjgwMTc2IDUuOTE5NDMgNC44MDE3NloiIGZpbGw9IiM1RDNCODEiLz4NCjwvc3ZnPg0K"

/***/ }),
/* 1826 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDMiIHZpZXdCb3g9IjAgMCA0MiA0MyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0yMC44OTEgNDIuNjIyQzMyLjQyODggNDIuNjIyIDQxLjc4MiAzMy4yNjg3IDQxLjc4MiAyMS43MzFDNDEuNzgyIDEwLjE5MzIgMzIuNDI4OCAwLjgzOTk2NiAyMC44OTEgMC44Mzk5NjZDOS4zNTMyMiAwLjgzOTk2NiAwIDEwLjE5MzIgMCAyMS43MzFDMCAzMy4yNjg3IDkuMzUzMjIgNDIuNjIyIDIwLjg5MSA0Mi42MjJaIiBmaWxsPSIjNUQzQjgxIi8+DQo8cGF0aCBkPSJNMzEuNzIzIDE3Ljg2MkMzMS43MjE3IDE3LjA0MjIgMzEuMzk1OCAxNi4yNTY0IDMwLjgxNjUgMTUuNjc2M0MzMC4yMzcyIDE1LjA5NjMgMjkuNDUxOCAxNC43NjkzIDI4LjYzMiAxNC43NjdIMTMuOTMyQzEzLjExMDcgMTQuNzY3IDEyLjMyMyAxNS4wOTI5IDExLjc0MTggMTUuNjczMkMxMS4xNjA1IDE2LjI1MzQgMTAuODMzNCAxNy4wNDA3IDEwLjgzMiAxNy44NjJWMjUuOTg2QzEwLjgzMzQgMjYuODA2NCAxMS4xNTk5IDI3LjU5MjkgMTEuNzQgMjguMTczQzEyLjMyMDEgMjguNzUzMSAxMy4xMDY2IDI5LjA3OTYgMTMuOTI3IDI5LjA4MUgyOC42MzJDMjkuNDUyNSAyOS4wNzk2IDMwLjIzODkgMjguNzUzMSAzMC44MTkxIDI4LjE3M0MzMS4zOTkyIDI3LjU5MjkgMzEuNzI1NyAyNi44MDY0IDMxLjcyNyAyNS45ODZMMzEuNzIzIDE3Ljg2MlpNMTkuMzQzIDI1LjU5OVYxNy44NjJMMjUuMTQzIDIxLjczMUwxOS4zNDMgMjUuNTk5WiIgZmlsbD0id2hpdGUiLz4NCjwvc3ZnPg0K"

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/Logo_Move_Mais.444d5d5.svg";

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/Logo_Pamcard_Branco_seta_amarela.40e45a2.svg";

/***/ }),
/* 1829 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pamcardMob.c7a8a12.svg";

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/logo_pamcard_branco 1.4601900.svg";

/***/ }),
/* 1832 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik02Ljk2ODIxIDUuNTUwNzZDNi42ODcxNCA1LjIzNzMzIDYuNzEzMzggNC43NTUzOSA3LjAyNjgxIDQuNDc0MzJDNy4zNDAyNCA0LjE5MzI0IDcuODIyMTkgNC4yMTk0OCA4LjEwMzI2IDQuNTMyOTFDOC4xMDMyNiA0LjUzMjkxIDExLjc3MjMgOC41MzAzIDEyLjAzMiA4LjgxOTg5QzEyLjI5MTcgOS4xMDk0OSAxMi4yOTE3IDkuNDQ3NTIgMTIuMDMyIDkuNzM3MTFMOC4xMDMyNiAxNC4wMjA3QzcuODIyMTkgMTQuMzM0MSA3LjM0MDI0IDE0LjM2MDMgNy4wMjY4MSAxNC4wNzkzQzYuNzEzMzggMTMuNzk4MiA2LjY4NzE0IDEzLjMxNjIgNi45NjgyMSAxMy4wMDI4TDEwLjQ0MDUgOS4yNzY3OUw2Ljk2ODIxIDUuNTUwNzZaIiBmaWxsPSIjNUQzQjgxIi8+DQo8L3N2Zz4NCg=="

/***/ }),
/* 1833 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1834 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1835 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1836 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCAzOCAzOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNS40MjI1MSAzMy43NTQ1TDM0LjAxMTUgMy40ODI1MUwtMC4wMDA0ODgyODEgLTAuMDAwNDg4MjgxTDUuNDIyNTEgMzMuNzU0NVpNMi4zODg1MSAyLjI1NDUxTDI5Ljc3MDUgNS4wNTg1MUw2Ljc1NDUxIDI5LjQzMjVMMi4zODg1MSAyLjI1NDUxWiIgZmlsbD0iIzk5OTk5OSIvPg0KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi4wNDY2IDM3LjU4NDlMMzcuODQ4NiAxMC4yNjE5TDcuMTUyNTkgNy4xMTg5TDEyLjA0NjYgMzcuNTg0OVoiIGZpbGw9IiM1RDNCODEiLz4NCjwvc3ZnPg0K"

/***/ }),
/* 1837 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIyOS45MzEiIHZpZXdCb3g9IjAgMCAzMCAyOS45MzEiPjxkZWZzPjxzdHlsZT4uYXtmaWxsOm5vbmU7c3Ryb2tlOiM1ZDNiODE7fS5ie2ZpbGw6IzVkM2I4MTtmb250LXNpemU6OXB4O2ZvbnQtZmFtaWx5Ok9wZW5TYW5zLVJlZ3VsYXIsIE9wZW4gU2FucztsZXR0ZXItc3BhY2luZzowLjFlbTt9PC9zdHlsZT48L2RlZnM+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjUpIj48bGluZSBjbGFzcz0iYSIgeDI9IjI5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjUpIi8+PGxpbmUgY2xhc3M9ImEiIHgyPSIyOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC41IDEyKSIvPjx0ZXh0IGNsYXNzPSJiIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNSAyNi40MzEpIj48dHNwYW4geD0iLTE0LjU4NCIgeT0iMCI+TUVOVTwvdHNwYW4+PC90ZXh0PjwvZz48L3N2Zz4="

/***/ }),
/* 1838 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1839 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1840 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1841 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAAAyCAYAAACuwK6DAAAAAXNSR0IArs4c6QAADKNJREFUeAHtWwuQHEUZ/rtn9m5380ICSBEx4SUCCoUEQgJBRMoCAiWCXG4vyeXu9nII4gsLqIqKBCiggBKVV3HcXY6E2zsuJhhSEbU0IUhiIVAKgiIm0QR8J0Be+7idmfbrPXp2ZnZm93b3LmQhXbn06++/u/+v+++//+klOhjKkkBrf+TrHQk6rKxGFRDzCtp8qJswYqcYFHmueRVNHktBHASmAukyxk7U05GNYwnOQWAqAEY2GWtwDgJTITBjDY5exbioZZCO1MzIBYLY+YzECQIJLKW9TIht4LtNEP3d0s0/9zYM/bGafg7ktvmdkzpn2RW0c7TGyspiBMG3J+ovthi/CAO6EG1PGkl7APQ/Jmi1qRs/rnWQ2vqjj0BoHd55CyH+YoRHD5wRA9M+EDlbWOwB7IkzvIMqJy9IbCJBP+qJpVaAFzCrrRAEjJyFBCcbTp23/Ar6b7WzKgmMtNkNFr0H3S6UeqraDu32QvzO1M32WttBxYCRcwM4WwHOzGrBKXr44zL1ZZOibwCNlkJQRBLDWIW/ecyi6WRZ0+q15ITopGQY22CKqRmnMsucg5E+hLOncAUxdpZmai+090fm2mB9ABJQ8ceG0pHfLlhFR1QzncAdEO8PL8CR8pgXEKiiNwHGzVY6PdDbSukRdQ5GbYPh85nFboOheY63DYC8rSeWvNlb7sy39IenaYJ/WpZlw8lN8qBdsIzG1enRCxQdI2NbV9PQKyrf3ld/iWCapvIyFuOSz/R8kfaosnhfeCrjdIzKl4qFYNdDcVxWig49bTa11OzeBvp3adpCCl+rrK0v3EyCLQX6TuB2obMle7TUgysaaMjLquMRCpkTI+uxO85gzJjVHcv+3qbBWdJD6fXInxvvr58jBL8XrD+p6tHJ9+L9kcO6Y6lrVZk31hi7FGX3y3I9GwYY6fWhcP3HyKSnFK0QehfR0CKVtzh/ErzrVF7GVqbuVNDkrURGCwXxJU6aommnRIoTHs+NyMYFqypTawWqrG0gPI8468WqcNSJzaSZ0yG4+/xAkeMTk+qPkbsBAg9bpM8OGnN3LLNWn5CCASFWu2nYNfFE5EZ32djnxCgYINAiL2JBFpjKkIVUa8+1J+ij5c7EIXwiHGxHkcVgDuZ3Cg6z9WkzdUZ3Q2ZzMeZZS9i8OBgUo+28jJIA+XLQ3OmhuzP+RPg8T9kBn8Vkt2jcnAUbc4d3sADnBIsim8o9c2xh5hgKegyMxuWZizf26Kk5ffNpd77Mk8L50ZqIxDjTf6BqsHrmS/2u8kFxdyy5GLRL7XrsUmHxn7Stpgl2WY0kHm3MvMG5eU4AOGUbBPYZE0+E27HO5aVRhV3CEheviFFKFXjjqwapbsJAdCX2l9T/dsCGmS64thY78GWTmVc+1pjZYld6Evqe5NU4m3BRZWfLKqy+wykZWUKUut5Dut+y0BKvo7P/jLRDaMM/SVoJTkuibjYX+gbIxGWVYcEfG8pEnm8epHOXNaT+UYp3DhgpYDK4W60wsahnXnprEINbbiG+3YyugiDnBNGg7jTN0jYBoNNhdf3Tj67zasq2J1KXY7tvUbsVVtpXO5ZH7+lckPyXX5vRLINHokDxMibu6I6ll1fST2/T0OuLBthsy9KeBWfX2YKOpoUMsRHymBUkD9VnTpVNsKItYGJ//MFh9nx3I27mRcK2EyPX2aAIeomYaHCQ3477y+Myn1s5QnzTUVeQ7GrC6mQMl9jhgAnUmbpYrPK1Fsudw3RrJtRa4a5jbCp8iXKxHlVsXjlgQDjfSYT7wDXOvF8aK22YBgeepic/b1qmwwQVO3brqRaohAH87WHM2uDHw1mWzSbvxXljX0SRbv3az6jeSVNL6a6G9N+qAYdLDzFUx7lq0tgtL7juIKrCETf10UegdnL3EMFEorOBcMdxB5jVZk9TKoa/idJEdtcW5pY30z7srk5VI9Xa3nfDV6l8LcbVgMOZEb4YqgNaSQVWUoghrf5QRY3tut1OV5mAbnf1zYhfUCXL9715peBwzvhnPaN3CcdTl8taQxmnm2GqH00lZV1zU8+jnb37AFTN3Wn85q3AgTYqtMYCzhyOQ/okxQznwT5YCy+qfFAs1Q52yiuyHiqnueVJOiSItqxy2J0Y/Lp8G3ZcLZ8z+XkQSXAMjWYVA6d5MPJx1QaHP7NXPBRaIaKK0hOjg1vfK5qkpaPrNK7lHIwesvKzgt5yNtq7t+44Z76W07i/bC8Gjm7SJgUOh5nrvGX73jX8hIFDfSXW90/fqzsdTs9BRYdlH8Mng1kqX2bsHoOpjc5uDBiEn6/MwqoLIK+6WIJjkYCxJT+buAPO+ikhgzbGB+lQjhFEVDUEWuCIU3V+MUziuQD2bsxjyFmPDmYAcXmRWiPd6s66UmloM5e/CU6aaKk21dTnLpgeBqV8fR7ysrOceAs0lf+8GK3pbqC3ccaQjRxU2eRyepGeZlxEb+ImHQc+SrXZLGDqXSo4+005LxdxEbcvupIRQA50Cdkd1VACnzdugly+7z9k8bD69IHFQe8oIuyYKSpdTtw1P/WWSUa/o83t2Ko5lwYEezQ+Td/lqCuaxOJwjcFipj2+og1roDI+EPkGllqALPKgyKlA45DtzvcKpeK5MrEDyDdDTT4teQD8OA41l8CDeKONi278+KFAB2gQjwOxPAeKYD/0H5sbFEkjz5jX8sQs2t4XxUes0QmMzAcVJ92gnPdY5X1j6VAUzHF3EZvvv4QyvrQ1VFgcFOpR6ss5JQ71tdFZYHG3C99ZV27a1MR21QYqzeVpVeXOuP2JyAznOQej4lfO+lpMwwD6ChZbwE6RoCTjfvPieKT2a5i9Vr5SuL6t5MvLT2kmsy9M8KmVdOHj3Zqrb26JNeX3euC0kKBAjT8cMKJAUCQ9H37/xH6uGmNlT28dCH1G5YPi9kTdqfhGP9SWiL6mLkWFtNp1w2Uiw7TUhsL6fEnHGoriTtGhSqRXelco8wuVr7W4NRFurRQUOVfc/BGY+VAufu8/ZukPOPN+aQNPXeCPCUH1nKyb7CmdayfbdIIdFu+P9iJ/kSyDuuyUtrlMBwVjb/QGTORwu57RUumhtvM1lMiBwlh3wJCL7hTVRpcJ6ZbHtnsVgvmUzMP/NbMtEWnA7d6+zctyZ+idl/1DW3/oDrRZjL/T8N5qpaP+u3ZaiGfHHZK6wc77JND3UTj1b8zZb7l6YehGkFnpw2DUi/gyLKxlI2WL3T0IWc2V9LinNMGg6obmgVgKwohAka2Gd4xMMfPbMlIB4HTifdmxKu8Xw+H5HUFWBy6XvucHBjwQPST1hWKWlXyPhg91T2IA9k0Yxtmd++Ozst+cqimToEAWy6sFRY7BBqanMfNL6BznYTuJcfb0tYM0vthge2LpR7U9yalQWPnHE/ChYdWciVUUKwaK5GtOjD6KxXWW6gPtXt56ZPJWlR/r2M9XVm6f2BtCgYK52DJ18BnxTlFtXEzwGLoVJqrDw8w+kTEja+Y9ThNVA79YPqgwhZm7TObqOT0zks8HUJd3g35hnqcwiGUXPvM5MvJlNZGaiR3f5wuKoK4gk7jYzFzADP/whl0OcFL5Ruz8sBZ5KT5Yf3y+rDDFBbcdmThvigpWvjnGubIG6tI+e9Cn/HdNT2P25ULuY1fi58Qsv7f8tcDTtqe7KbnIUzairN8BhReZkS+h9QroSk1xgdh244viLbsD3i5LOuyAx7FyLjK5OSPoLZnf22WJCEJ8aVN6qerPG7cspTCeIuY+UYTeoXflLsWzKw161v7MDTd56qEG2qvaSudpVpceoXxA5dvVWHtYUL4/XMr3YKfKVl92SyRcg3ZWtD0RvhCv81c7D2VZDyG+if9H+bW/1SHPKmf/B2p6hMBUBYqceyAwsnJRou4Ui7S10J1TZd4dch965MV0pcWM17mp7awPpXdiCWf37YpOtjRjsp5lRwvOL4VquxIH5BHu9sgJ8ZbgVjxneBRUHpgFpYDBzu+D0TO/2tEXBUYyl1/ThBG9Fx/EWgLMwPLHIEQW9uB92rjUEvnAvHwG71+LYsDkQImlFmC5w7isLuQumMVYDN/Yk20tA9GHNSHkXedKbLSS7YJ4YsRrLWF9q7cx89cgmlosH01Q5PxHLODexuQLoG8c/gl5uB0emZh0x5QUIl5q4lxah922jllibTc+qpVsU2MEow2KnH5JVVZMRjmQjOiZEPw0nEPSOrL5wYLbAetsQ+9VQ6+OxtYuNo79WedVZWMBipzPiHeM3+SHf1+YdHoL/Mg+sGVjBYoUmOuC+YGV4BhMbCxBOQhMhYCNNSgVDuvD3UxevPeHBP4PoaXmbzabR2kAAAAASUVORK5CYII="

/***/ }),
/* 1842 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj48ZGVmcz48c3R5bGU+LmF7ZmlsbDojNGI0ZTVjO308L3N0eWxlPjwvZGVmcz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTAgLTEwKSI+PHBhdGggY2xhc3M9ImEiIGQ9Ik01NjkuOTI0LDMzMC4zNzVhMS4wNzMsMS4wNzMsMCwwLDAsMC0uODc1bC0uODc2LS44NzZjLS4xMjQtLjEyNC0uMjQ5LS4xMjQtLjUtLjEyNGEuNzU0Ljc1NCwwLDAsMC0uNS4xMjRsLTYuNzQ5LDYuNjI0VjMzN2gyWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU0MC4wNDkgLTMxMikiLz48cGF0aCBjbGFzcz0iYSIgZD0iTTE5My44LDE5My43aDEyLjV2MS4yNTFIMTkzLjhWMTkzLjdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTgwLjA0OSAtMTc5Ljk1MSkiLz48cGF0aCBjbGFzcz0iYSIgZD0iTTE5My44LDMxNy40NTFoMTEuNjI0bC44NzYtLjg3NlYzMTYuMkgxOTMuOFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xODAuMDQ5IC0yOTkuOTUxKSIvPjxwYXRoIGNsYXNzPSJhIiBkPSJNMTkzLjgsNjgzLjdoNi4yNDl2MS4yNTFIMTkzLjhWNjgzLjdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTgwLjA0OSAtNjU5Ljk1MSkiLz48cGF0aCBjbGFzcz0iYSIgZD0iTTE5My44LDQzOS45NTFoOS4xMjRsMS4yNDktMS4yNTFIMTkzLjhaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTgwLjA0OSAtNDE5Ljk1MSkiLz48cGF0aCBjbGFzcz0iYSIgZD0iTTI4Ljc0OSwyMS4yNDl2NWEyLjUwNywyLjUwNywwLDAsMS0yLjUsMi41aC0xMi41YTIuNTA3LDIuNTA3LDAsMCwxLTIuNS0yLjV2LTEyLjVhMi41MDcsMi41MDcsMCwwLDEsMi41LTIuNWgxMi41YTIuNTA3LDIuNTA3LDAsMCwxLDIuNSwyLjV2MS41YTIuMjI4LDIuMjI4LDAsMCwxLDEuMTI0LjVsLjEyNC4xMjRWMTMuNzUxQTMuNjgyLDMuNjgyLDAsMCwwLDI2LjI1MSwxMGgtMTIuNUEzLjY4MywzLjY4MywwLDAsMCwxMCwxMy43NTF2MTIuNUEzLjY4MiwzLjY4MiwwLDAsMCwxMy43NTEsMzBoMTIuNUEzLjY4MiwzLjY4MiwwLDAsMCwzMCwyNi4yNTFWMjBaIi8+PHBhdGggY2xhc3M9ImEiIGQ9Ik0xOTMuOCw1NjIuNTQ5aDYuNjI0bC4xMjQtLjEyNCwxLjEyNC0xLjEyNUgxOTMuOFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xODAuMDQ5IC01NDAuMDQ5KSIvPjwvZz48L3N2Zz4="

/***/ }),
/* 1843 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1844 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1845 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img_print_extrato.e230a52.png";

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img_so_falta_sua_empresa.2c0d886.png";

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/BGCaminhao_VP.d93c173.png";

/***/ }),
/* 1849 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1850 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/c12.e437135.png";

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/c14.d3f9370.png";

/***/ }),
/* 1853 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1854 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1855 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1856 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIMAAACECAYAAACzmJjeAAAAAXNSR0IArs4c6QAAH3RJREFUeAHtXQtgVMW5njlnN4EAkkCyaysIKmpF9LZ6q/Vx21i0PrBygWxABYnS+rgFkoBC2wuaYq34KElAsQo+8QHZ8LiKWB+3jVqvr6LVVq3aVkVAdzeQoJiQ7J4z95sTNm5O9uyZOXs22UCOhj1n5p9//vnPf/75559/Zijpv7KKA4HhlYcxVb+QEnoGJeR4RskIEJiPv8/w9zHV2VOxqGfthubffuI24aiv/8oGDkwa8rPhnjxPFSH0SryUnFQ0MVyAW09i2g3B3SveTQUrk9cvDDLcyhDsFH/lkQpjz1JKjpSqghGdEfZrEt65JEiCmlTZJMD9wpCEKT2ZNHV4xXHMQ15AnYVO64WeeOb4cP75VaRKd4qDl1PTKdxfNj0OTBs2b6Tu1V+GfVCUDiZolKMig1oHv/PVq8+kg0dJp3B/2fQ4oHu06nQFoZMCSueXFs49q/PZwU2f6iamDKs8XlX18YzSH4Lw0YSwIkaoD1+GJ952qMwvcf8sYWyLh5LNj4VrQ/G8bPoNFM49marKn92kCW3/VyScf2wDqYo5wdvJRCeFe6LMVN+coxhRZ2CIVUYJGwUrGv/Fr8T7jjQIxhDcTSaUTo7B6i71lW/QmH7T+siKN+OlsuJXUa50mw5ugPp8TeNJmDztBPfXfHVSOoNlAkUV3yaUXU8pneRGNRiLPakwrXxdeMU/3cCXDg4Yesq7/qZGCHZBOngsyt5XF6qZZZGXMjnrbIYAqRwY8FU8RBXypluCwDkAqZ+gU+XtQFG5I0al5KJk5tuFzf4MCQJ6TjZWkpxO8KwShoB/9hHUz7ZC3c3opNDFG3QqeVShq0v9FeuKSVWvdZEqoyNdbFYXVLChHOPOGmGYnD9/FOzA19Cy47q0LjMPpehb13J1nRn0NlipptlAOM+mzDHu3mGGqamXDL2mwJMT+18kO3a8mFDaP1I65R1f870A7HG7SSPKTnsCnUFQRhzjzgZhoNHc3P+B9X+Us+Y7L4XuqCzgr5zrHIOzkic25odg0IadlU5dCqOud1JDWOf2ujCUFFX8HC/lP6xJzGwOJfpSPnzNbC1dsaN70qlOHu2a6s4TNEPQKaZeFYYpvvITIQhLnBLvTjk6AKOMR4CrR7sLnRpT0u40YT8WTFp9FA4X8O7W0dWrwqAQugTCIG3Vw5f0rK7rVzCdfIeFaB5rZ6N0Rs8ljFyHodU/ZTmBUcapgcKKC2TLOYXnNhIkb5HT8lblGKOLGxx6HzlO6RdhRYhNOgUD8ttyvIUKVQpJNPdd3dNyJARhok25LtnoZ1/Tde3qbt7EJrINgPzvmWJSVeMrar6KUbYUforBXRCkelBYJbKfTAXiVl4sN+c3aDv3lLp2QStsrg/Xcg3n+MqYagyQqhxS2HwOnEcBeEImwUA8xDGVHQUfY6H8siCpahfBY/gsmPon1PtNEXgOw6La8W4GiySrNzBszljiUf4GQXWN9/hIGkgo/1xR3iSji6e53k1cPGR+YcBXfj3xN+2kKtmMnnhmuoKACZiX80MtM2UaGwzd8REl6gUoKzxpg4mjs60Y5VY69Sh3uSkIEOFgQajlRzK8sWqLq8JQ4qtYEMuLbUdjf4V+eLhVpTLpkPpWotHAPeSeqEw5DrsuvOwtfH41wuUoOVkY1gEgJs2m4MP4voOi3YpAyHfojF1dF6otdcKbbgiR4IrNwLsE6mu+D1rgUreNcsrYg3W7anYkI14kLUo9t3lYdL7I14ip8YwJw/lkTi58AMuk+gZGPoAtcDTKxEDbThjI2zB03IqRyIs0nL+5XrDLFOETh0lbGAzbwN/Mp0yLOUK3L4wSHk8H58bQ7eFSfzmPG/iuHR4wmrvC+fuCQnL3GuxXrwXiw0WxYsT0p2C4tkf9L+l2E5T4moJoZLFoI2XhoBn+JVvGDI/JGzFvHyVKoGBhuoauuXoyubDiG5CvX3bLsEiAIGiKRq+0yM5YclqaAV/czfiQLsoYdRzxPn13RvGbkLep8F64fHkUdiv4lCeKFl3aynW7at4ThXcLzrEwTPXPHYc47WvdGyBZNGmgppK9FnluJzMWfbzxVh4259o1xV9+KgRhujhC1rRPy/1vcfgOyEn+a30qiV2kEHY6NOEJcL6NgLE6DFo7BE3zCeyVp6murA1Gqv9hhdupMEB7Kw9CEFQrxK6la+ow4Po8PXywvUW8zZR6Eevgur0gQzs+sF/ICOSlw+YcEvWoiwmJzkYbB/B2cqMHghCvdiQ0zUg8nUkUdmPAX74Z3tvruznuAO3IZkAUbjFqPCleW0Z/VYULw8FxMfIWvIj3iDaWL8Vr9yov411c2yEI9iUhKhfCC7wV0WS/vZJc6U0s4UgYiEJLEpGkuoeKwuiIPIJ/Jnqj2lDE51FN149JVaZLniJugXcp1wcfWIfRKKSZuIeVqOxVvNyxsk3lw2wojnlNvoENiQLhpJvACIxM7lRCKSiBHOxFd3IB+qkXE8HWR5Z/CHX8KdJGJqYnu6eMno70jEz3JquvF9MeC+6qfk2kfm4fUBJ7HhrhMBF4KxhIxOnNvrxViKwo4zDSmiFQUM77oEOtKkhMh9D8rN4kCAn5QuHcwJG2xw5fj9DXlkBbj95Ca7bENDJftFIPif4GsLYfkhA+TBcEfHONCHRpYaBewYBLLAodFy542IogROptsspLTIc6O2Fq4TzxbiWxcB+5h6TevKGxhi+5t704L6AtL7cFlAKgK8tI2QBpYYBqEvOiwYHz9/xma9jG/GfBhFYRmpmiXS0C1xdhoBW2fRXSbxOlnSn6LLwD+feWogKu6VuKCjAslbyYzoSdJ1ouqbBCz2fZoLzrrPIT0yE0P+WWc2KazL1hxMoU6CFYThfT6dVPkRVtolUiTgMhARm4qF4qJQx8Lh7rDrhBJ3TByCxHjOMcK2Aw4n6rvMR0SO5gWM6rkCZityYWzd57OLgg5LPrIzVPiRLJFxjB/jlCFF4KjtKxtsIww3/tILzQX8BZ8Qn1qu+ggitkKlEoqUFI2YRkZYKN1c/j2/gwWZ45DbbD+ZgCfgDpfVcg+OYavL2M3U01+m/wKaw0tzPVs1IoaK+lQmKRh+5qVMqhJRwT17SR2BJF4esZHL4D3r+p5CEMh47jM4hmWrCYdhlw32VOT/pM6WWYDxmpMnJxJlZXc62NmULbDyQpbT2QqCOwA5ohMzUx2p604YGi/zoU0UrPoWYuuRCE9C6QPwwxBb9LhoWFh92HdyDhbqZnaYR8UFpUvvCiwgWCcYTZPbRMxpdkad5oe7ePKRmcszS2rZsw8N1E4KLHekc63hnS5KWAbxK6m/PNuR3hWnSJOT3lM4+nVOjSXLUtgu5rLQT3HMBn6JNJSUmPZj66564mo5vJSK30pS7CwHcc07waPFviQaQydFGF3Yno5W5dU0G4ZTWMKW6PSF1Qmbn4mwpBewZd2pM8mkgKQR8D5p5HyLyaCbIxcV/XKQxVWITqGeh9Asw9IhOVcZwcd1FR00wzfh7Dp2u0DHMYjmMJuIE5xKckneSByoCs9e1rWn7FaC+JvYp2Hul2SzB79Nf6xpqGTmHA5hE8lv80tyvqhk+hi7ngmdPXN1b/GV5jYeeLuXzHM50eKCw/Nnle302dMnz2t+CzeRUtGJ2RVjB9AcdrvBQudZAOIyEjlSUgxVc66t2ipjMTkjpvvwzpN+AT/kNnguwNRi5Qot+XLZbN8HC2naKoHuwIR9BFuH+B37XByPLfc8xG/63nsIXod1FfD10KmYKaXjDXxj1xgVDlhczPNoOYH5rzRZ7R9w0XgbOCKSmsKLbK6+l0LEAaCW15N3gxMCN1M3JnMFzT6SX28EiZdkqvkJEEWLR8wBvUmXI/pSwGX8FRIPYcaJcSMaEy4ibLkzUwSKpbDYHw6auB65JkMKnSEFL+gTkfDhVEfdm3kNMOzfJHc/kD7RnvDywhvwxGapcmts0T9SjngE05iYmp7rkaV3T1mnWNyxKZzlX7qhJ/5UTEw20A37vZBCaco+HLGByMrNxrSjceuUBgjv1SbPL1LL6MFXhFQmsm0cbtNKwIu3eT1X3gp7EtOtMXJQ97o/QCUQaA2e8PCjVPMAlCZ/H6UDU23WAPdiakuFEUdVyKbCMrGKl5gOxTRuHD/i1EeVdKeMZCuq5MMgQpJeABnMkjynQ2B+/pcXy0z+Prfw46YA26zpvAw5Io8fixAmtCMkHgXPGg0In2CrSDgWD29AfIA/tSsROVP4Yu5PJUMDwPuI7Hzyt2cMEvqneTL3iMH7kOxtR3qcouhMCdCcX/76hnCBdQ+BdXMhK9b31jck2DQS2aeYBfjD1UF64tQyt5W+9w0lpsokr8IgXxkj8zhn82wNF2+nqOiOtHPmSL7Q8Le82GhIMvm7FVEISr0PC0hB5h9kwohA1G4tsiXN7UXNMMwdljBysqhHZ4DvZ8dJ93QBCuBB/SEgTOR2yeQruES1sxFzW1WOV1S6fMVhiw0ENwkqkb9v6EOAcYuT0YqrWMF4mDif7aWf2ieLrCMWq7JwL6e5HOpCteh0/Qaml/NQ6rzlwxnf26LlxznZsVdJs0cgm57RwD1Jury9hcojvr0UCq2/G3sD5SK77vhGCrMiUMrXb141t9zw6mV/IZeQkeKlvN1uO0MTj3GH20jeUEZZbfydCZEWGAWn4Rw7kTrAiBVmjTY/o6q3y302Gf4P2KXdHW6MSNX96Z2qchhqrXoPhRRxpNGCVSqg2ONL1u5xbIiDCwmH4n4iVnghuDzByBimvFqH/Ght0rtpvz+p+dc8AIVvao0/ChlULyj+1qDDLylW/o3lJSvglnbyyzcjp1LeOcli4l+Y5pUGo/hEOoS7AruoYNWpt6HIZC67sU6H9wzAG+5jLgr3jVCFamZDFc90mn8A2XPqXTVUV9A4FAm3hEm7nSjGgGXsl+B9GxU4rmjvEwZUgryfkwU32duVEHy3Opv/JswvT1mAs6RKbNGMlN1Dx6McrPqAtVPxEvmzFh2F8B44ts45X11i9mVtE7iVoNvUWlXL0lReUBrMCB699ZGBwEYigXJLj4z4wv+M1INyHXrH5oWQ7gNJ0z8TIdC0Jnfdzh6NE3BwbPKeJpmdYMnfXK3PATYPExnwZJPRFeVr53Ig4tI+1wuG4DE97QdG2plREkU08yWO9A74LSgRW2Q+NkZXsqDbyYAT64EhiLOI8ikqfehq2SyrJKGLBi6lw0dD7U19lQf/v1escP/s2Bph8Dho+BEVSKWIfLjSluoTcgMWtJeyb8T4hsCyDXOzwsy8dw9Jas6Caw9uEiCAK2o6G/hwyc87UgWHADyRCVe3FwiKUvw7pkf04yDjCVXNyrmqGksPxCmD+3QFWNlbbvePArYXPRsJ8ma1x/mhwHsLr7R70iDHwxiJdEa/F9T5Mj2QTNmHCUlqlk/6OJA+hIR/aoMPD1Ejgk7CrCYr+Bns830ePkUciIgldOKCDWCQEHUJmiHhMGvonoO6zpEdgDGCG4dFHa6TBxCeNBiwaGe6hHDMjSooorMFn0upuCwGMf92k58w7at+dywzFC2Z5RzVCMRbY+X/NqGIczXfMAIgoagvWrSLhgVYPgeUxoKAS//0rFATDomYwJA99sssnfvBEEJN21JRVhyfL4pBeMnHtZRFl+UIfDJ2OOC2nYxX5tRoSBC0Kzf+AmfJFpWfuYUWjGvMJDfO8nrP75iwtttkeRrcEtiZQzdjK6XKGFRYnFrO7xoW2s21X7XkaEock/cA18B44FAdb/R4jVXYpVVWvqSE2Puob7QnBLia/8Knxov7N6uTLp6B7aSUxfxMu4bkBie50bIQhTZQjqhMWZlNAGlx0fKhgTDFXf4153IOGO7iQme2+wMdjdPDYkXQqhETT8NyV+Yp+rmgEHlk2GsWhImSShjbpOljRGCu7iRmFQsvDBCD6Aei5rY9FC+GscbUHANQIEanp9Y+3mOP+wiEZstxT0USkFh88TYL7g4Thiid8n2tvI0dgPcYXo6EAC9wELuiZ0+1f54daz8VIX8ZhSmYZCI3yO916MCOsu350Cn7Rg8Cc7wqrCAAmomGnkZ1UJ7yOABrRADGfhyIGL+CosK9xupKPx4NmBd/Htj4KhmpvUqHo0WrhGQCjeAysWkLByJPZleNnMEb7WMoREI7jBnNn1mY7jW+QEG2vf75qOJ98350FzJI296waLBBDeTDTl3DrBLfWT4ehP+5oDa3cv+xRPl2ED12va9PYfEKqMxfNg+OCjVMcB7ArdxlrJG8Yi5q+LdbvzQF28gX7ednk8L4mdRGqhBSYESRBbMXZcxslslFXFn+1+8YmGdS32g/W77vi7HWx/vhwHeNeBElv2/8kVBrQHgvAn/F4mVJLSc6n/sI1lobLSeAy+RyG3QUzyhMoT8hXORzoTgtDrcZFW9HryPGeU5FZ8YZXfW+l8h5xIpOCVTNpVlMe/0Tz1cwiF8DATfdM2qPpbaBRnXefQF9DVjLJlEt83mbDzsB3vs7awLgOU+ioeRvsudRltb6D7GJp8TX645Ua3jjxObIQS3LsiAtUtNfsHP8LhCqV30hz6iZAgoEbUcV1vCEJiYw+A+9EQ6sU4SmgL32He7fYY2kCn7OZMWtzQIs/Ael3mNvEHLT5KziZ+1iC+d7YYpwxhWB+qfRX9frVYEVko1kRatOmypRLhS4oq/wO7yVfytQIdW+Ym5orcQxwPsAsa+ZRcpf0lvsWzW03rtBOwf/PPocxfdwtxHA8ONv8J74rizzK/k4fNGQEh+IOisBcgrMsUhdZhy9wQlofd7yYTZGjKJlg4+U7AFs+vdJy1nT5lncLADRL2lT6BG4fpo+3AAFyb68M1jnzofC2g6lEgnPQsMz1gQhms/vexPOzH5ryD7Rm8wNIB9lqgqHJMum3vFAaOqOML1oqhVD9LFzE8S1GdKEk3/hTBjd3tV8KRdagVLIxYqEf2OLTE3YYH1ArwIEgHn0YQRX8lvnSgCrGmk/Pnj5rqn/M9viApQKqE9vlE19P94sfl6Yq2GZUc3T1XLAVaYSn2G/qFGHRXqI7o6Rj3jApdEN56Et4xLdEZllgQAvMQvqAZiWkH5D1jX8DruB3adAxebKcAYHDAnYQNGNI9RiLKo1azwV00Q5xBxqaf4YJx/IXC8pKOJ8DL2UP06E1xfLK/qq4Ju7Y5brzoErjEg8VJzrKQrbtPw+NQFmjMsYmC0MEfquLDHo/D5lZjFPJxib+iIhmvkmqGRIZcPGR+oTYgVg7/tvDUNCTxBvgUliTikbnnO48wD3lXpowBi42xsenVbHM5Kc2QVZFOzI+X+y1ze9x4xoe+VW2jJWubaz6O47MVBg4o83JQCWYjo36rfaHjFaf65VJb5Gv6NJXNkKy84Sth9CSswewSIoelew9CfQi53KMt0cJs2cbHiCP15a2F5pucrL3ppuFdRTScohc/bTdpN2GuRFfY6eY0y2dGt6QjCBxvAwJcKFPKZR1hEB5czrbKtWxPL2YYU9ThmhL09Q9mggxonSKMRJ7kQsfxCwkDoE4TJYbp2EnEhasuUl0HYZjFRyVS6Cg5o7Rw7llSZbIbmKHrK8NX7Gg/aLum4ev5zu6iPL43t5gwYK+0UXZI4/k50ejT8ft0f+sjy++nOv0eGCFlPzBFmZZu3dlWnu8Ei5m+hZmgC6EJi/kITkgz4GX4RIjAyGM3P25PBFYUZl1jzRt7Q/pJoGGraBn4H0yR2QdGQCwceLeCxw3ifBCDhOE40KNHxc7ChiopEELLyA4hOEkgflwR1dh1osVA74jAIZXDROH7FBwjJ2eEXkr+0yOEmMHXIDLuSNyIUgixOFBd4/I/YlOPCDd6hErl6jz0iwfuSF3ePG9jaV6FVBlZYNhC74OfS6D6H5Upy08ihoE8RKaMMCyOSBTqJqB2d4sghbz4AgULh4rAOoJh3LsmeFHWKTRQrfg/ey5ormMh1I/wmVgpqjQ1Y9oOHekIIWHAQlfhMDWmtp4v1UBB4CrjLEx6pCA43j42dsn6iy4LFFZMECVTJd4vRWFl4fC17BISBnxYfxVFDpdnqSisDNy7RXtwMh72LhS8EIn1hSBo74KpbKXosc2Igt4u63sRbhwlnwgJA86T+qMoUqjASfHZM9EydnB8Bg7rO+62g0vMp0T7PPE5W+/RXRw+qEidJ0gflDR1PebEqJuRp4WE4YTGoW+gQKMgwQDTV8W9WuJlkkPyABdPrvYUtEJ+cogkqQi+PS40rNM30bFDbBK4LEnCgfGL4htz2pEEzVBnB+Mkny/JFxIG9Nc8snmtaCWQ9lObfQPv6+jnRUt1h8OcwhSPV3kbOcd1z7VOAa1vcZqtIbIrB/zKo4OUW0Soatdz7wGcxIdpjxUCtnHdrpr3hITBQKfTe+3RJkBgB3Ns5rV1iq/8xIRUoVselBHwlb8FlViPCWoxH0dXzJu6Pmb/E6b9y7DR6bftKOWbsePLdG3sC8NRfkk+nwlEwSftiE3Mh2r/tkrom/APrObnISTmme956HfAN3cSppufxrHK/wfbQ1qI4jh1TTOp0uz3QKK9fOWKkF0ET+QjMOrvj7fX6S80gvMl+YqmzGOqNh5f6wBhAozNO+ks4lVn4VyEMDby/DPGfZ9CsEJQj/hhRTi/GoKinwbQ3A68zkeFaOCjfXXpHlp9Co8AN6+OTsbr/FDrVdgUpQg8vDBZvl0aGN9tSb4017Gj+WwMH1fYVdYb+RCEvZpOj4nPz8dpKPVX8C7uivhzql+34xmm+MtPhXZ8JVWdiXmwd7ZhLuYY7oJPTLe6x2qxazHS+hW3O6xgzOngE0ZadLJ5Jba4zbAfI/ZWugPTyq7NTJoJdfqMBuKipWZBkMXnoTn4aNy7jDUpOKNaFCNeqsxQk2B6+3ZPi2cUtjeoMcINU1eUckm+tGbgdRk+ciXnZdyO5s/ZcOENLuJ7FSSjBXbIJvTIE5PlJaZxcUK4Ht911lWB4OsaVJX9Q/TrhXZowRLl0bLrTXgUNPXvORcf60loAz+lTWpJviNh4Azk898eFnsOTD6BP/fWha8hhrqvgMpbY0UDhOFtETqBawfwjLDCk056ib98EY4XvlEcB7sfJ9oLdW3iOFNDOhYGjtaYJh7AGkQYnZoMx7lQe2SWue9LxMYX4+hefVtimtU91MFr0C6nWuWnk85dzoP9yge8GxDBY3R6hKyGcX00vvR9mOXcga7gH4hHqg9GqvHr/iVtMySSwHcC8ba1/QBK9bnE9Ezfg1Hb+RZAY0P541IJAqcDB3MtEaeHfSQOKwdpGIQ6nS9ayhhqUvpTfK3FuD8PQjQLhvvN8FZ+yE+r4w454ErrYzbT4hYyii3/FjCFXC/aL5oJsXvGV/sOvpAtRFeejDQOfalBYKtgg2GG48oOe0c+nDnTO8bwYvBOoEDT83Cmfd9JWXMZfBRvwo18KfcemvOcPLslDEbdhqGEeDrYXzhDyb0dTA3kOvt5XaRWyGXL4Uv8c8fDb7EFDcwxytv8A8ZqbXpuQaaPWzScbx7lb8aXb0OTSDY+En52109S2UwieDiMq8IQrxQbTQ1qJbGLFR7dTOn34uku/D4GP8CcVOsaMNIZTIl3Ier9JVon3A3C9ngKDL3ABRptUUA7/A70XWULKAjA7Qu8ypnpCkRGhCGxDdMKZ39TVz3crjgJg51RoPpw+B1H4vcbzr4O7PfAyDqdKr9XNfqe3sg+1fIVn+rRxqE/vQAG1zQ0algiDSL3TKPFwcbq50Vg04W5ZOg1BdHc3E9geLsWwsY1G2HKt9IxLjMuDKkYh8mo6yAQt6aC6ZE8ONFwJPN5PVLX/kqwm+4CxGIJd3uCtD3B99UUhO0GJqxGu5V0IyG8cxkk+n03UDnFwVUsDnIXDS5xWk23chAE8fiMbqUtE37Ml+Bb5tpk9KowGEvodXYpPG5CfnibtjjNvjG+kbZTBE7Koc0Z2X1OZazMCT28TK8KAycg2Lh8K9N7ae8ExlbB/XwDp6MnLx5BLup8kqULLugzZMvE4XtdGDghxpStTmZzjR0nLNO/qOkB2AmuWfQy9Oq0fYQMvAwsjo0eJQOfCJsVwsAJqovU3Ml0dgleUiyRQLfvOX7Ew1ViGHY5cPeY8CW2w+ONuTaKSMTL79GgQeY00eesEQZOcH3j8rU6006BghBepyHaUA6HfjpCNHpGfaimRqac27DRtpzP3MbZiY/SbZ33kjdZJQyc9vWRFW8OCu85EW/udkh5u2R7koIDTytE4ZacqD4mmAU72Rc2f7nTrbZ1b7D4Ghdz2V71M5iJMT/zGUc+0QTnTAB50uqPCwH60Iej1LtoY+j2sBl/bz7Dx7IBPpZJrtPA2HmwhRwFH2W1MMQZxYM2mG9PMSX62bDCvwOL+SQQbuFlZPsQ8bQFkR3r8iJNj8d3v4/jypbfEn/lRBwDtMlNetANfhQJFRwjMomXrN4+IQzJCOf7JnvpvkNVqvhwwEarrsaavPu05mP2+Pf0lTUT0A4IDqLjk7XPSVq6s659VhicMCvbykzLrxit5ZC/oBsUXkNq1QZohc1Y4v9jq3yR9KwzIEWIPlBg+LZ70Ax8A6+0Vn/BNmogoQIe7JLW1S8MabEv/cJ1oerniK7zU+gcGrgsWBBq+VGQVKU98urvJtJ/n65gME4EGqQuhlDw02xtA3LgPNuBruFGfuCpKwQASb8wuMVJl/AEhlceRj36TKC7GK9nnIEW2x8iTmMnupNtiAXZqlPyIg3nb3ZDG7hEdj+aA40D/w+Zsa2ua1SlxwAAAABJRU5ErkJggg=="

/***/ }),
/* 1857 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMS40NDUiIGhlaWdodD0iMjEuNDQ1IiB2aWV3Qm94PSIwIDAgMjEuNDQ1IDIxLjQ0NSI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6bm9uZTt9LmJ7b3BhY2l0eTowLjU0O308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iYSIgZD0iTTAsMEgyMS40NDVWMjEuNDQ1SDBaIi8+PHBhdGggY2xhc3M9ImIiIGQ9Ik02LjYyMSw5LjQ2M2wtNC4wOTItNC4xLDQuMDkyLTQuMUw1LjM2MSwwLDAsNS4zNjFsNS4zNjEsNS4zNjFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3LjE0OCA1LjgwOCkiLz48L3N2Zz4NCg=="

/***/ }),
/* 1858 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMS40NDUiIGhlaWdodD0iMjEuNDQ1IiB2aWV3Qm94PSIwIDAgMjEuNDQ1IDIxLjQ0NSI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6bm9uZTt9LmJ7b3BhY2l0eTowLjU0O308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iYSIgZD0iTTAsMEgyMS40NDVWMjEuNDQ1SDBaIi8+PHBhdGggY2xhc3M9ImIiIGQ9Ik0wLDkuNDYzbDQuMDkyLTQuMUwwLDEuMjYsMS4yNiwwLDYuNjIxLDUuMzYxLDEuMjYsMTAuNzIzWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNy42NzYgNS4xMzgpIi8+PC9zdmc+"

/***/ }),
/* 1859 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img-promo-bolt-pre-pays-option.dfd1c47.svg";

/***/ }),
/* 1861 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA1MDAgNTAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MDAgNTAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7b3BhY2l0eTowLjE7fQ0KCS5zdDF7ZmlsbDojRkZGRkZGO30NCgkuc3Qye2ZpbGw6IzlDNjM1RDtlbmFibGUtYmFja2dyb3VuZDpuZXcgICAgO30NCgkuc3Qze2ZpbGw6I0Y2QzQyRDt9DQoJLnN0NHtmaWxsOiNEQjlFMjc7fQ0KCS5zdDV7b3BhY2l0eTowLjI7fQ0KCS5zdDZ7ZmlsbDojMjIxRjFGO30NCgkuc3Q3e2ZpbGw6I0Y3QThBOTt9DQoJLnN0OHtvcGFjaXR5OjAuMjtmaWxsOiNGMzcwNjU7ZW5hYmxlLWJhY2tncm91bmQ6bmV3ICAgIDt9DQoJLnN0OXtvcGFjaXR5OjAuNTtmaWxsOiNGRkZDRkQ7ZW5hYmxlLWJhY2tncm91bmQ6bmV3ICAgIDt9DQoJLnN0MTB7b3BhY2l0eTowLjU7fQ0KCS5zdDExe2ZpbGw6I0ZGRkNGRDt9DQoJLnN0MTJ7b3BhY2l0eTowLjM7ZmlsbDojRjM3MDY1O2VuYWJsZS1iYWNrZ3JvdW5kOm5ldyAgICA7fQ0KCS5zdDEze29wYWNpdHk6MC42O2ZpbGw6IzlDNjM1RDtlbmFibGUtYmFja2dyb3VuZDpuZXcgICAgO30NCjwvc3R5bGU+DQo8Zz4NCgk8ZyBjbGFzcz0ic3QwIj4NCgkJPHBhdGggY2xhc3M9InN0MSIgZD0iTTQwNC42LDE2Mi43bC0xMjUuOCwyOS4xTDM4MiwwLjRMMjUyLjEsMjkuNUwxMzAuMywyODcuNmwxMDcuNS0yMS45TDEzMC4zLDUwMC40TDQwNC42LDE2Mi43eiIvPg0KCTwvZz4NCgk8Zz4NCgkJPGc+DQoJCQk8cGF0aCBjbGFzcz0ic3QyIiBkPSJNMjE2LjcsMTkwLjdoNjguNWMzLjgsMCw3LTMuMyw3LjEtNi44Yy00LjUtMC43LTktMS4xLTEzLjYtMS4xSDIyMmMtNC4xLDAtOC4zLDAuNC0xMi40LDAuOQ0KCQkJCUMyMDkuNywxODcuNiwyMTIuOSwxOTAuNywyMTYuNywxOTAuN3oiLz4NCgkJCTxnPg0KCQkJCTxnPg0KCQkJCQk8Y2lyY2xlIGNsYXNzPSJzdDMiIGN4PSIyNTEuMSIgY3k9IjE2NC4yIiByPSIzOC4yIi8+DQoJCQkJCTxnPg0KCQkJCQkJPHBhdGggY2xhc3M9InN0NCIgZD0iTTI1MS4xLDEyMi43Yy0yMi42LDAtNDEuMSwxOC40LTQxLjEsNDEuMWMwLDIyLjcsMTguNCw0MS4xLDQxLjEsNDEuMWMyMi43LDAsNDEuMS0xOC40LDQxLjEtNDEuMQ0KCQkJCQkJCUMyOTIuMywxNDEuMiwyNzMuOCwxMjIuNywyNTEuMSwxMjIuN3ogTTI1MS4xLDE5OS42Yy0xOS43LDAtMzUuNy0xNi4xLTM1LjctMzUuN2MwLTE5LjYsMTYuMS0zNS43LDM1LjctMzUuNw0KCQkJCQkJCXMzNS43LDE2LjEsMzUuNywzNS43QzI4Ni44LDE4My41LDI3MC45LDE5OS42LDI1MS4xLDE5OS42eiIvPg0KCQkJCQkJPHBhdGggY2xhc3M9InN0NCIgZD0iTTI1My44LDE2MS41VjE0NmMxLjYsMC42LDIuOCwxLjYsMy44LDIuOWMwLjgsMS40LDIuNSwxLjYsMy43LDAuOGMxLjItMC43LDEuNi0yLjUsMC44LTMuNw0KCQkJCQkJCWMtMi0yLjktNS01LTguNC01Ljh2LTQuMmMwLTEuNS0xLjItMi43LTIuNy0yLjdjLTEuNSwwLTIuNywxLjItMi43LDIuN3Y0LjNjLTYsMS40LTEwLjUsNi42LTEwLjUsMTIuOXM0LjUsMTEuNywxMC41LDEyLjkNCgkJCQkJCQlsMCwxNS41Yy0xLjYtMC42LTIuOC0xLjYtMy44LTIuOWMtMC44LTEuNC0yLjUtMS42LTMuNy0wLjhjLTEuMiwwLjctMS42LDIuNS0wLjgsMy43YzIsMi45LDUsNSw4LjQsNS44djQuMw0KCQkJCQkJCWMwLDEuNSwxLjIsMi43LDIuNywyLjdjMS41LDAsMi43LTEuMiwyLjctMi43di00LjNjNi0xLjQsMTAuNS02LjYsMTAuNS0xMi45QzI2NC40LDE2OC4xLDI1OS44LDE2Mi41LDI1My44LDE2MS41DQoJCQkJCQkJTDI1My44LDE2MS41eiBNMjQzLjMsMTUzLjRjMC0zLjUsMi4xLTYuMiw1LjEtNy4ydjE0LjdDMjQ1LjcsMTU5LjUsMjQzLjMsMTU2LjYsMjQzLjMsMTUzLjR6IE0yNTMuOCwxODEuNnYtMTQuNw0KCQkJCQkJCWMyLjksMS4yLDUuMSw0LDUuMSw3LjJDMjU5LDE3Ny40LDI1Ni45LDE4MC41LDI1My44LDE4MS42eiIvPg0KCQkJCQk8L2c+DQoJCQkJPC9nPg0KCQkJPC9nPg0KCQkJPGcgY2xhc3M9InN0NSI+DQoJCQkJPHBhdGggY2xhc3M9InN0NiIgZD0iTTM2Mi4yLDM3Ny4xYzAsMy4yLTIuOCw1LjgtNi4zLDUuOEgxMzQuMmMtMy40LDAtNi4zLTIuNi02LjMtNS44di01LjhjMC0zLjIsMi44LTUuOCw2LjMtNS44SDM1Ng0KCQkJCQljMy40LDAsNi4zLDIuNiw2LjMsNS44djUuOEgzNjIuMnoiLz4NCgkJCTwvZz4NCgkJCTxnPg0KCQkJCTxjaXJjbGUgY2xhc3M9InN0NyIgY3g9IjEzNC4zIiBjeT0iMjUxLjciIHI9IjEzLjYiLz4NCgkJCQk8cGF0aCBjbGFzcz0ic3Q4IiBkPSJNMTQ2LjYsMjU3LjZsLTI1LjYtOC43Yy0wLjEsMC44LTAuNCwxLjgtMC40LDIuOGMwLDcuNCw2LjEsMTMuNiwxMy42LDEzLjYNCgkJCQkJQzEzOS43LDI2NS40LDE0NC4zLDI2Mi4yLDE0Ni42LDI1Ny42eiIvPg0KCQkJCTxwYXRoIGNsYXNzPSJzdDciIGQ9Ik0zNzkuMywyOTQuN2MwLDcuMy01LjksMTMuMy0xMy4zLDEzLjNoLTEwYy03LjMsMC00LjUtNS45LTQuNS0xMy4zdi0zMi42YzAtNy4zLDEuNS0xMy4zLDktMTMuM2g1LjcNCgkJCQkJYzcuMywwLDEzLjMsNS45LDEzLjMsMTMuM0wzNzkuMywyOTQuN0wzNzkuMywyOTQuN3oiLz4NCgkJCQk8cGF0aCBjbGFzcz0ic3Q5IiBkPSJNMzUxLjUsMjYyLjF2NS4zaDI3Ljd2LTUuM2MwLTEuNy0wLjQtMy4zLTAuOS00LjhoLTI2LjZDMzUxLjgsMjU4LjgsMzUxLjUsMjYwLjQsMzUxLjUsMjYyLjF6Ii8+DQoJCQkJPHBhdGggY2xhc3M9InN0OCIgZD0iTTM1MS41LDI3Ni42djE3LjhjMCw3LjMtMi44LDEzLjMsNC41LDEzLjNoMTBjNy4zLDAsMTMuMy01LjksMTMuMy0xMy4zdi0xNy44DQoJCQkJCUMzNzkuNSwyNzYuNiwzNTEuNSwyNzYuNiwzNTEuNSwyNzYuNnoiLz4NCgkJCQk8Zz4NCgkJCQkJPHBhdGggY2xhc3M9InN0NyIgZD0iTTIxNi40LDE4M2MwLjYsMCwxLjMtMC4xLDEuOS0wLjFDMjE3LjcsMTgyLjksMjE3LjEsMTgyLjksMjE2LjQsMTgzeiIvPg0KCQkJCQk8cGF0aCBjbGFzcz0ic3Q3IiBkPSJNMjkyLjMsMTgzLjljLTAuMSwzLjUtMy4zLDYuOC03LjEsNi44aC02OC41Yy0zLjgsMC02LjktMy4xLTcuMS03Yy00MS43LDYuMS03NCw0Mi4yLTc0LDg1LjV2Mi40DQoJCQkJCQljMCwyOC4yLDEzLjksNTMuNiwzNS4xLDY5LjRsLTMsMjBjLTEuNSw5LjYsNS40LDE3LjUsMTUuMiwxNy41aDMuM2M5LjgsMCwxOC45LTcuOSwyMC4zLTE3LjVsMC43LTQuMw0KCQkJCQkJYzQuOCwwLjgsOS44LDEuMywxNC45LDEuM2g1Ni43YzAuOCwwLDEuNywwLDIuNSwwbDAuNSwzYzEuNSw5LjYsMTAuNiwxNy41LDIwLjMsMTcuNWgzLjNjOS44LDAsMTYuNS03LjksMTUuMi0xNy41bC0xLjgtMTIuOA0KCQkJCQkJYzI3LjYtMTQuNSw0Ni40LTQzLjUsNDYuNC03Ni41di0yLjRDMzY1LjMsMjI2LjQsMzMzLjcsMTkwLjQsMjkyLjMsMTgzLjlDMjkyLjIsMTgzLjksMjkyLjIsMTgzLjksMjkyLjMsMTgzLjl6Ii8+DQoJCQkJCTxwYXRoIGNsYXNzPSJzdDciIGQ9Ik0yMTMuMSwxODMuMmMwLjQsMCwwLjgtMC4xLDEuMS0wLjFDMjEzLjgsMTgzLjIsMjEzLjQsMTgzLjIsMjEzLjEsMTgzLjJ6Ii8+DQoJCQkJPC9nPg0KCQkJCTxnIGNsYXNzPSJzdDEwIj4NCgkJCQkJPHBhdGggY2xhc3M9InN0MTEiIGQ9Ik0xNjguMSwyNDguOWMtMS4zLDAtMi41LTAuNC0zLjctMS4yYy0zLjItMi00LTYuMS0yLTkuMmMxNC44LTIyLjcsMzkuMy0zNi4yLDY2LjItMzYuMmg0Mi4zDQoJCQkJCQljMy44LDAsNi43LDMsNi43LDYuN3MtMyw2LjctNi43LDYuN2gtNDIuMmMtMjIuMiwwLTQyLjYsMTEuMi01NC45LDMwLjFDMTcyLjMsMjQ3LjcsMTcwLjEsMjQ4LjksMTY4LjEsMjQ4Ljl6Ii8+DQoJCQkJPC9nPg0KCQkJCTxwYXRoIGNsYXNzPSJzdDciIGQ9Ik0yOTMuNSwxOTIuM2MtNC4zLTIuNS0zLjgtNS40LDAuOC02LjZsMzktMTAuNGM0LjgtMS4zLDcuNCwxLjUsNi4xLDYuM2wtNi41LDIzLjFjLTEuMyw0LjYtNS44LDYuNi0xMCw0LjENCgkJCQkJTDI5My41LDE5Mi4zeiIvPg0KCQkJCTxwYXRoIGNsYXNzPSJzdDEyIiBkPSJNMzY1LjEsMjcwdjEuNWMwLDM0LTQyLjIsNjItNzYuMiw2MmgtNzYuMmMtMzQsMC03Ni4yLTI4LTc2LjItNjJWMjcwaC0wLjd2MS41DQoJCQkJCWMwLDI4LjIsMTMuOSw1My42LDM1LjEsNjkuNGwtMywyMGMtMS41LDkuNiw1LjQsMTcuNSwxNS4yLDE3LjVoMy4zYzkuOCwwLDE4LjktNy45LDIwLjMtMTcuNWwwLjctNC4zYzQuOCwwLjgsOS44LDEuMywxNC45LDEuMw0KCQkJCQloNTYuN2MwLjgsMCwxLjcsMCwyLjUsMGwwLjUsM2MxLjUsOS42LDEwLjYsMTcuNSwyMC4zLDE3LjVoMy4zYzkuOCwwLDE2LjUtNy45LDE1LjItMTcuNWwtMS44LTEyLjgNCgkJCQkJYzI3LjYtMTQuNSw0Ni40LTQzLjUsNDYuNC03Ni41TDM2NS4xLDI3MEwzNjUuMSwyNzB6Ii8+DQoJCQkJPHBhdGggY2xhc3M9InN0OCIgZD0iTTMzNy40LDE3NS41bC0xOC4zLDMxLjRsMy44LDIuMWM0LjMsMi41LDguNywwLjUsMTAtNC4xbDYuNS0yMy4xQzM0MC4zLDE3OC40LDMzOS41LDE3Ni4zLDMzNy40LDE3NS41eiIvPg0KCQkJPC9nPg0KCQkJPGNpcmNsZSBjbGFzcz0ic3QxMyIgY3g9IjMzMy4yIiBjeT0iMjQ0LjQiIHI9IjYuNSIvPg0KCQk8L2c+DQoJPC9nPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),
/* 1862 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1863 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1864 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAzNjAgMzYwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAzNjAgMzYwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7Y2xpcC1wYXRoOnVybCgjU1ZHSURfMl8pO2ZpbGw6IzYxM0E3RDt9DQoJLnN0MXtjbGlwLXBhdGg6dXJsKCNTVkdJRF8yXyk7fQ0KCS5zdDJ7ZmlsbDojNUU5QTQyO30NCgkuc3Qze2ZpbGw6I0VGQ0I5Qzt9DQoJLnN0NHtmaWxsOiNENkFCODA7fQ0KCS5zdDV7ZmlsbDojRTVDMjk4O30NCgkuc3Q2e2ZpbGw6IzkzNUUzNzt9DQoJLnN0N3tmaWxsOiNBMzY4NDA7fQ0KCS5zdDh7ZmlsbDojRkZGRkZGO30NCgkuc3Q5e2ZpbGw6IzFEMUQxRTt9DQoJLnN0MTB7ZmlsbDojMTcxNzE5O30NCgkuc3QxMXtmaWxsOiMyMTIxMjM7fQ0KCS5zdDEye29wYWNpdHk6MC4xNTt9DQo8L3N0eWxlPg0KPGc+DQoJPGRlZnM+DQoJCTxjaXJjbGUgaWQ9IlNWR0lEXzFfIiBjeD0iMTgwIiBjeT0iMTc5LjkiIHI9IjE4MCIvPg0KCTwvZGVmcz4NCgk8Y2xpcFBhdGggaWQ9IlNWR0lEXzJfIj4NCgkJPHVzZSB4bGluazpocmVmPSIjU1ZHSURfMV8iICBzdHlsZT0ib3ZlcmZsb3c6dmlzaWJsZTsiLz4NCgk8L2NsaXBQYXRoPg0KCTxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjE4MCIgY3k9IjE3OS45IiByPSIxODAiLz4NCgk8ZyBjbGFzcz0ic3QxIj4NCgkJPGc+DQoJCQk8cGF0aCBjbGFzcz0ic3QyIiBkPSJNMjIyLjMsMzEzLjJMMjIyLjMsMzEzLjJjLTAuMi00LjItMC45LTguMS0yLjItMTEuOGMtMC4xLTAuMS0wLjEtMC4yLTAuMS0wLjJjLTAuMi0wLjQtMC4zLTAuOS0wLjUtMS4yDQoJCQkJYy0wLjEtMC4xLTAuMS0wLjItMC4xLTAuM2MtMC4yLTAuNC0wLjQtMC45LTAuNS0xLjNjLTAuMi0wLjMtMC4zLTAuNi0wLjUtMWMtMC4xLTAuMS0wLjEtMC4yLTAuMS0wLjINCgkJCQljLTUuMS0xMC45LTE0LjgtMTkuMy0yNi44LTIyLjJsLTcuMS0xLjdINzEuN2wtNy4xLDEuN2MtMTIsMi45LTIxLjgsMTEuMy0yNi44LDIyLjNjMCwwLjEtMC4xLDAuMS0wLjEsMC4yDQoJCQkJYy0wLjIsMC40LTAuMywwLjctMC41LDEuMWMtMC4yLDAuNC0wLjQsMC44LTAuNSwxLjJjLTAuMSwwLjEtMC4xLDAuMy0wLjIsMC40Yy0wLjIsMC40LTAuMywwLjgtMC40LDEuMg0KCQkJCWMtMC4xLDAuMS0wLjEsMC4yLTAuMSwwLjNjLTEuMiwzLjctMiw3LjYtMi4yLDExLjdjMCwwLjEsMCwwLjEsMCwwLjFjMCwwLjUtMC4xLDEuMS0wLjEsMS43djAuMXY2My44YzAsMS41LDE4OC42LDEuNSwxODguNiwwDQoJCQkJdi02My45QzIyMi40LDMxNC4zLDIyMi40LDMxMy44LDIyMi4zLDMxMy4yeiIvPg0KCQkJPHBhdGggY2xhc3M9InN0MyIgZD0iTTEyOC4xLDI5MS4yYzI0LjYsMCw0MS40LTE4LjEsNDEuNC0xOC4xYy05LjktMi4zLTE2LjgtMTEuMS0xNi44LTIxLjN2LTI1aC00OS4ydjI1YzAsMTAuMS03LDE5LTE2LjgsMjEuMw0KCQkJCUM4Ni42LDI3My4xLDEwMy41LDI5MS4yLDEyOC4xLDI5MS4yeiIvPg0KCQkJPHBhdGggY2xhc3M9InN0NCIgZD0iTTE1Mi43LDI1MS44di0yNWgtNDkuMnYyNWMwLDAuOC0wLjEsMS41LTAuMSwyLjJjNy4xLDMuNiwxNS4yLDUuNiwyMy43LDUuNmwwLDBjOS4zLDAsMTgtMi40LDI1LjctNi42DQoJCQkJQzE1Mi43LDI1Mi43LDE1Mi43LDI1Mi4zLDE1Mi43LDI1MS44eiIvPg0KCQk8L2c+DQoJCTxwYXRoIGNsYXNzPSJzdDMiIGQ9Ik0xMjcuMSwyNDcuN0wxMjcuMSwyNDcuN2MtMjkuNSwwLTUzLjMtMjMuOS01My4zLTUzLjN2LTQzLjZjMC0yOS41LDIzLjktNTMuMyw1My4zLTUzLjNsMCwwDQoJCQljMjkuNSwwLDUzLjMsMjMuOSw1My4zLDUzLjN2NDMuNkMxODAuNCwyMjMuOCwxNTYuNiwyNDcuNywxMjcuMSwyNDcuN3oiLz4NCgkJPHBhdGggY2xhc3M9InN0NSIgZD0iTTEzNS45LDk4LjJjMTQuMSw5LjYsMjMuMywyNS43LDIzLjMsNDQuMXY0My42YzAsMjkuNS0yMy45LDUzLjMtNTMuMyw1My4zbDAsMGMtMywwLTYtMC4zLTguOC0wLjcNCgkJCWM4LjUsNS44LDE4LjksOS4zLDMwLDkuM2wwLDBjMjkuNSwwLDUzLjMtMjMuOSw1My4zLTUzLjN2LTQzLjZDMTgwLjQsMTI0LjMsMTYxLjIsMTAyLjQsMTM1LjksOTguMnoiLz4NCgkJPHBhdGggY2xhc3M9InN0NiIgZD0iTTE3Ny4yLDExMi41YzIuNiw0LjEsOC4xLDEzLjQsOS45LDIyLjJjMC44LDMuOSwxLjEsNy42LDEuMiwxMC45bDAsMHYzOS4yaC0xMS4xdi0zNS4yDQoJCQljLTEuMy0wLjYtMi41LTEuMi0zLjYtMS44Yy0xLjMtMC43LTcuOC00LjItMTQuNi0xMC45bDAsMEwxNzcuMiwxMTIuNXoiLz4NCgkJPHBhdGggY2xhc3M9InN0NyIgZD0iTTE4OC4xLDE0MS40Yy0xLjktMTYuMi03LjMtMjYuOC0xOS0zOGMtMy44LTMuNy0xOC0xNy40LTM5LTE4LjRjMCwwLTIxLjktMS4xLTQwLjgsMTUNCgkJCWMtMi44LDIuNC0xMywxMi4xLTE0LjksMTUuM2MxNy42LDI1LjIsNDQuNyw0MC4yLDc0LjMsNDAuMkMxNzMuOCwxNTUuNCwxODguMSwxNDEuNCwxODguMSwxNDEuNHoiLz4NCgkJPHBhdGggY2xhc3M9InN0NiIgZD0iTTc0LjQsMTE1LjJjLTIuNiw0LjEtNiwxMC43LTcuOCwxOS41Yy0wLjgsMy45LTEuMSw3LjYtMS4yLDEwLjlsMCwwdjM5LjJoMTEuMXYtMzUuMg0KCQkJYzEuMy0wLjYsMi41LTEuMiwzLjYtMS44YzEuMy0wLjcsNy44LTQuMiwxNC42LTEwLjlsMCwwTDc0LjQsMTE1LjJ6Ii8+DQoJCTxwYXRoIGNsYXNzPSJzdDgiIGQ9Ik0xMDYuNSwxOTkuOWMwLDAsNS4zLDIuOSwxOS44LDMuMWMxMy45LDAuMiwxOS44LTMuMSwxOS44LTMuMXMtMy4yLDI3LTE5LDI3DQoJCQlDMTA5LjksMjI2LjksMTA2LjUsMTk5LjksMTA2LjUsMTk5Ljl6Ii8+DQoJCTxnPg0KCQkJPGVsbGlwc2UgY2xhc3M9InN0OSIgY3g9IjEwNiIgY3k9IjE3MS41IiByeD0iNS45IiByeT0iOC4xIi8+DQoJCQk8ZWxsaXBzZSBjbGFzcz0ic3Q5IiBjeD0iMTQ2LjEiIGN5PSIxNzEuNSIgcng9IjUuOSIgcnk9IjguMSIvPg0KCQk8L2c+DQoJCTxwYXRoIGNsYXNzPSJzdDEwIiBkPSJNMTI3LDgwLjdjLTM3LjMsMC02Ny41LDMwLjgtNjcuNSw2OC43YzAsMy43LDAsNy44LDAuMSwxMmwwLjEsMmg3bC0wLjEtMi4xYy0wLjEtNC4xLTAuMS04LjEtMC4xLTExLjkNCgkJCWMwLTM0LDI3LjItNjEuNyw2MC42LTYxLjdzNjAuNiwyNy42LDYwLjYsNjEuN2MwLDMuOCwwLDcuOC0wLjEsMTEuOWwtMC4xLDIuMWg3bDAuMS0yYzAuMS00LjIsMC4xLTguNCwwLjEtMTINCgkJCUMxOTQuNSwxMTEuNSwxNjQuMiw4MC43LDEyNyw4MC43eiIvPg0KCQk8cGF0aCBjbGFzcz0ic3QxMSIgZD0iTTYyLjUsMTU0LjhoMTEuM3Y0OC4zSDYyLjVjLTUuNCwwLTkuNy00LjMtOS43LTkuN3YtMjguOUM1Mi44LDE1OS4xLDU3LjEsMTU0LjgsNjIuNSwxNTQuOHoiLz4NCgkJPHJlY3QgeD0iNjUuOCIgeT0iMTU0LjgiIGNsYXNzPSJzdDEwIiB3aWR0aD0iOCIgaGVpZ2h0PSI0OC4zIi8+DQoJCTxwYXRoIGNsYXNzPSJzdDExIiBkPSJNMTkxLjcsMjAzLjJoLTExLjN2LTQ4LjNoMTEuM2M1LjQsMCw5LjcsNC4zLDkuNyw5Ljd2MjguOEMyMDEuNCwxOTguOCwxOTcuMSwyMDMuMiwxOTEuNywyMDMuMnoiLz4NCgkJPHJlY3QgeD0iMTgwLjQiIHk9IjE1NC44IiBjbGFzcz0ic3QxMCIgd2lkdGg9IjkiIGhlaWdodD0iNDguMyIvPg0KCQk8cGF0aCBjbGFzcz0ic3QxMCIgZD0iTTYyLjksMTk5LjloLTQuMmMtMS4xLDAtMiwwLjktMiwydjUuNGMwLDEyLjIsOS45LDIyLjIsMjIuMiwyMi4ySDExOWMyLjMsMCw0LjItMiw0LTQuMw0KCQkJYy0wLjItMi4xLTItMy44LTQuMS0zLjhoLTQwYy03LjgsMC0xNC4xLTYuMy0xNC4xLTE0LjF2LTUuNEM2NC44LDIwMC43LDYzLjksMTk5LjksNjIuOSwxOTkuOXoiLz4NCgkJPGVsbGlwc2UgY2xhc3M9InN0MTEiIGN4PSIxMTciIGN5PSIyMjUuNiIgcng9IjExLjEiIHJ5PSI4LjciLz4NCgk8L2c+DQo8L2c+DQo8ZyBjbGFzcz0ic3QxMiI+DQoJPGc+DQoJCTxnPg0KCQkJPGc+DQoJCQkJPHBhdGggY2xhc3M9InN0OCIgZD0iTTI3My42LDg2LjJjMC0xLjcsMC43LTMuMywxLjktNC41YzIuNC0yLjQsNi40LTIuNCw4LjgsMGM1NC4xLDU0LjEsNTQuMSwxNDIuMywwLDE5Ni4zDQoJCQkJCWMtMi40LDIuNC02LjQsMi40LTguOCwwYy0yLjQtMi40LTIuNC02LjQsMC04LjhjNDkuMy00OS4zLDQ5LjMtMTI5LjIsMC0xNzguNUMyNzQsODkuMywyNzMuNiw4Ny43LDI3My42LDg2LjJ6Ii8+DQoJCQk8L2c+DQoJCTwvZz4NCgk8L2c+DQoJPGc+DQoJCTxnPg0KCQkJPGc+DQoJCQkJPHBhdGggY2xhc3M9InN0OCIgZD0iTTI0Mi41LDExNy4zYzAtMS43LDAuNy0zLjMsMS45LTQuNWMyLjQtMi40LDYuNC0yLjQsOC44LDBjMTcuOCwxNy44LDI3LjcsNDEuNywyNy43LDY3LjENCgkJCQkJcy0xMCw0OS4xLTI3LjcsNjcuMWMtMi40LDIuNC02LjQsMi40LTguOCwwYy0yLjQtMi40LTIuNC02LjQsMC04LjhjMTUuNC0xNS40LDIzLjktMzYuMywyMy45LTU4LjFjMC0yMi4xLTguNS00Mi43LTIzLjktNTguMQ0KCQkJCQlDMjQzLDEyMC40LDI0Mi41LDExOC43LDI0Mi41LDExNy4zeiIvPg0KCQkJPC9nPg0KCQk8L2c+DQoJPC9nPg0KCTxnPg0KCQk8Zz4NCgkJCTxnPg0KCQkJCTxwYXRoIGNsYXNzPSJzdDgiIGQ9Ik0yMTEuMiwxNDguNGMwLTEuNywwLjctMy4zLDEuOS00LjVjMi40LTIuNCw2LjQtMi40LDguOCwwYzkuNyw5LjUsMTQuOSwyMi4zLDE0LjksMzYNCgkJCQkJYzAsMTMuNS01LjIsMjYuMy0xNC45LDM2Yy0yLjQsMi40LTYuNCwyLjQtOC44LDBjLTIuNC0yLjQtMi40LTYuNCwwLTguOGM3LjEtNy4xLDExLjEtMTYuOCwxMS4xLTI3YzAtMTAuMi00LTE5LjktMTEuMS0yNw0KCQkJCQlDMjExLjksMTUxLjQsMjExLjIsMTUwLDIxMS4yLDE0OC40eiIvPg0KCQkJPC9nPg0KCQk8L2c+DQoJPC9nPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),
/* 1865 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1866 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1867 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 1868 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * vue-carousel v0.6.14
	 * (c) 2018 todd.beauchamp@ssense.com
	 * https://github.com/ssense/vue-carousel#readme
	 */
	!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.VueCarousel=e():t.VueCarousel=e()}(this,function(){return function(t){function e(i){if(n[i])return n[i].exports;var r=n[i]={exports:{},id:i,loaded:!1};return t[i].call(r.exports,r,r.exports,e),r.loaded=!0,r.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0}),e.Slide=e.Carousel=void 0;var r=n(1),a=i(r),o=n(41),s=i(o),u=function(t){t.component("carousel",a.default),t.component("slide",s.default)};e.default={install:u},e.Carousel=a.default,e.Slide=s.default},function(t,e,n){function i(t){n(2)}var r=n(7)(n(8),n(46),i,null,null);t.exports=r.exports},function(t,e,n){var i=n(3);"string"==typeof i&&(i=[[t.id,i,""]]),i.locals&&(t.exports=i.locals);n(5)("80564c20",i,!0,{})},function(t,e,n){e=t.exports=n(4)(),e.push([t.id,".VueCarousel{position:relative}.VueCarousel-wrapper{width:100%;position:relative;overflow:hidden}.VueCarousel-inner{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-webkit-backface-visibility:hidden;backface-visibility:hidden}",""])},function(t,e){t.exports=function(){var t=[];return t.toString=function(){for(var t=[],e=0;e<this.length;e++){var n=this[e];n[2]?t.push("@media "+n[2]+"{"+n[1]+"}"):t.push(n[1])}return t.join("")},t.i=function(e,n){"string"==typeof e&&(e=[[null,e,""]]);for(var i={},r=0;r<this.length;r++){var a=this[r][0];"number"==typeof a&&(i[a]=!0)}for(r=0;r<e.length;r++){var o=e[r];"number"==typeof o[0]&&i[o[0]]||(n&&!o[2]?o[2]=n:n&&(o[2]="("+o[2]+") and ("+n+")"),t.push(o))}},t}},function(t,e,n){function i(t){for(var e=0;e<t.length;e++){var n=t[e],i=l[n.id];if(i){i.refs++;for(var r=0;r<i.parts.length;r++)i.parts[r](n.parts[r]);for(;r<n.parts.length;r++)i.parts.push(a(n.parts[r]));i.parts.length>n.parts.length&&(i.parts.length=n.parts.length)}else{for(var o=[],r=0;r<n.parts.length;r++)o.push(a(n.parts[r]));l[n.id]={id:n.id,refs:1,parts:o}}}}function r(){var t=document.createElement("style");return t.type="text/css",d.appendChild(t),t}function a(t){var e,n,i=document.querySelector("style["+m+'~="'+t.id+'"]');if(i){if(p)return g;i.parentNode.removeChild(i)}if(b){var a=h++;i=f||(f=r()),e=o.bind(null,i,a,!1),n=o.bind(null,i,a,!0)}else i=r(),e=s.bind(null,i),n=function(){i.parentNode.removeChild(i)};return e(t),function(i){if(i){if(i.css===t.css&&i.media===t.media&&i.sourceMap===t.sourceMap)return;e(t=i)}else n()}}function o(t,e,n,i){var r=n?"":i.css;if(t.styleSheet)t.styleSheet.cssText=y(e,r);else{var a=document.createTextNode(r),o=t.childNodes;o[e]&&t.removeChild(o[e]),o.length?t.insertBefore(a,o[e]):t.appendChild(a)}}function s(t,e){var n=e.css,i=e.media,r=e.sourceMap;if(i&&t.setAttribute("media",i),v.ssrId&&t.setAttribute(m,e.id),r&&(n+="\n/*# sourceURL="+r.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */"),t.styleSheet)t.styleSheet.cssText=n;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(n))}}var u="undefined"!=typeof document,c=n(6),l={},d=u&&(document.head||document.getElementsByTagName("head")[0]),f=null,h=0,p=!1,g=function(){},v=null,m="data-vue-ssr-id",b="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());t.exports=function(t,e,n,r){p=n,v=r||{};var a=c(t,e);return i(a),function(e){for(var n=[],r=0;r<a.length;r++){var o=a[r],s=l[o.id];s.refs--,n.push(s)}e?(a=c(t,e),i(a)):a=[];for(var r=0;r<n.length;r++){var s=n[r];if(0===s.refs){for(var u=0;u<s.parts.length;u++)s.parts[u]();delete l[s.id]}}}};var y=function(){var t=[];return function(e,n){return t[e]=n,t.filter(Boolean).join("\n")}}()},function(t,e){t.exports=function(t,e){for(var n=[],i={},r=0;r<e.length;r++){var a=e[r],o=a[0],s=a[1],u=a[2],c=a[3],l={id:t+":"+r,css:s,media:u,sourceMap:c};i[o]?i[o].parts.push(l):n.push(i[o]={id:o,parts:[l]})}return n}},function(t,e){t.exports=function(t,e,n,i,r){var a,o=t=t||{},s=typeof t.default;"object"!==s&&"function"!==s||(a=t,o=t.default);var u="function"==typeof o?o.options:o;e&&(u.render=e.render,u.staticRenderFns=e.staticRenderFns),i&&(u._scopeId=i);var c;if(r?(c=function(t){t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,t||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),n&&n.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(r)},u._ssrRegister=c):n&&(c=n),c){var l=u.functional,d=l?u.render:u.beforeCreate;l?u.render=function(t,e){return c.call(e),d(t,e)}:u.beforeCreate=d?[].concat(d,c):[c]}return{esModule:a,exports:o,options:u}}},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var r=n(9),a=i(r),o=n(29),s=i(o),u=n(30),c=i(u),l=n(31),d=i(l),f=n(36),h=i(f),p=n(41),g=i(p);e.default={name:"carousel",beforeUpdate:function(){this.computeCarouselWidth()},components:{Navigation:d.default,Pagination:h.default,Slide:g.default},data:function(){return{browserWidth:null,carouselWidth:null,currentPage:0,dragging:!1,dragMomentum:0,dragOffset:0,dragStartY:0,dragStartX:0,isTouch:"undefined"!=typeof window&&"ontouchstart"in window,offset:0,refreshRate:16,slideCount:0}},mixins:[s.default],props:{easing:{type:String,default:"ease"},minSwipeDistance:{type:Number,default:8},navigationClickTargetSize:{type:Number,default:8},mouseDrag:{type:Boolean,default:!0},navigationEnabled:{type:Boolean,default:!1},navigationNextLabel:{type:String,default:"▶"},navigationPrevLabel:{type:String,default:"◀"},paginationActiveColor:{type:String,default:"#000000"},paginationColor:{type:String,default:"#efefef"},paginationEnabled:{type:Boolean,default:!0},paginationPadding:{type:Number,default:10},paginationSize:{type:Number,default:10},perPage:{type:Number,default:2},perPageCustom:{type:Array},resistanceCoef:{type:Number,default:20},scrollPerPage:{type:Boolean,default:!0},speed:{type:Number,default:500},loop:{type:Boolean,default:!1},navigateTo:{type:Number,default:0},spacePadding:{type:Number,default:0}},watch:{navigateTo:function(t){t!==this.currentPage&&this.goToPage(t)},currentPage:function(t){this.$emit("pageChange",t)}},computed:{breakpointSlidesPerPage:function(){if(!this.perPageCustom)return this.perPage;var t=this.perPageCustom,e=this.browserWidth,n=t.sort(function(t,e){return t[0]>e[0]?-1:1}),i=n.filter(function(t){return e>=t[0]}),r=i[0]&&i[0][1];return r||this.perPage},canAdvanceForward:function(){return this.loop||this.offset<this.maxOffset},canAdvanceBackward:function(){return this.loop||this.currentPage>0},currentPerPage:function(){return!this.perPageCustom||this.$isServer?this.perPage:this.breakpointSlidesPerPage},currentOffset:function(){return(this.offset+this.dragOffset)*-1},isHidden:function(){return this.carouselWidth<=0},maxOffset:function(){return this.slideWidth*this.slideCount-this.carouselWidth+2*this.spacePadding},pageCount:function(){return this.scrollPerPage?Math.ceil(this.slideCount/this.currentPerPage):this.slideCount},slideWidth:function(){var t=this.carouselWidth-2*this.spacePadding,e=Math.min(this.currentPerPage,this.slideCount);return t/e},transitionStyle:function(){return this.speed/1e3+"s "+this.easing+" transform"},padding:function t(){var t=this.spacePadding;return t>0&&t}},methods:{getNextPage:function(){return this.currentPage<this.pageCount-1?this.currentPage+1:this.loop?0:this.currentPage},getPreviousPage:function(){return this.currentPage>0?this.currentPage-1:this.loop?this.pageCount-1:this.currentPage},advancePage:function(t){t&&"backward"===t&&this.canAdvanceBackward?this.goToPage(this.getPreviousPage(),"navigation"):(!t||t&&"backward"!==t)&&this.canAdvanceForward&&this.goToPage(this.getNextPage(),"navigation")},attachMutationObserver:function(){var t=this,e=window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver;if(e){var n={attributes:!0,data:!0};this.mutationObserver=new e(function(){t.$nextTick(function(){t.computeCarouselWidth()})}),this.$parent.$el&&this.mutationObserver.observe(this.$parent.$el,n)}},handleNavigation:function(t){this.advancePage(t)},detachMutationObserver:function(){this.mutationObserver&&this.mutationObserver.disconnect()},getBrowserWidth:function(){return this.browserWidth=window.innerWidth,this.browserWidth},getCarouselWidth:function(){var t=this.$refs["VueCarousel-inner"];return this.carouselWidth=t&&t.clientWidth||0,this.carouselWidth},getSlideCount:function(){this.slideCount=this.$slots&&this.$slots.default&&this.$slots.default.filter(function(t){return t.tag&&t.tag.indexOf("slide")>-1}).length||0},goToPage:function(t){t>=0&&t<=this.pageCount&&(this.offset=this.scrollPerPage?Math.min(this.slideWidth*this.currentPerPage*t,this.maxOffset):Math.min(this.slideWidth*t,this.maxOffset),this.currentPage=t)},onStart:function(t){document.addEventListener(this.isTouch?"touchend":"mouseup",this.onEnd,!0),document.addEventListener(this.isTouch?"touchmove":"mousemove",this.onDrag,!0),this.startTime=t.timeStamp,this.dragging=!0,this.dragStartX=this.isTouch?t.touches[0].clientX:t.clientX,this.dragStartY=this.isTouch?t.touches[0].clientY:t.clientY},onEnd:function(t){var e=this.isTouch?t.changedTouches[0].clientX:t.clientX,n=this.dragStartX-e;if(this.dragMomentum=n/(t.timeStamp-this.startTime),0!==this.minSwipeDistance&&Math.abs(n)>=this.minSwipeDistance){var i=this.scrollPerPage?this.slideWidth*this.currentPerPage:this.slideWidth;this.dragOffset=this.dragOffset+(0,a.default)(n)*(i/2)}this.offset+=this.dragOffset,this.dragOffset=0,this.dragging=!1,this.render(),document.removeEventListener(this.isTouch?"touchend":"mouseup",this.onEnd,!0),document.removeEventListener(this.isTouch?"touchmove":"mousemove",this.onDrag,!0)},onDrag:function(t){var e=this.isTouch?t.touches[0].clientX:t.clientX,n=this.isTouch?t.touches[0].clientY:t.clientY,i=this.dragStartX-e,r=this.dragStartY-n;if(!(this.isTouch&&Math.abs(i)<Math.abs(r))){t.preventDefault(),t.stopImmediatePropagation(),this.dragOffset=i;var a=this.offset+this.dragOffset;a<0?this.dragOffset=-Math.sqrt(-this.resistanceCoef*this.dragOffset):a>this.maxOffset&&(this.dragOffset=Math.sqrt(this.resistanceCoef*this.dragOffset))}},onResize:function(){var t=this;this.computeCarouselWidth(),this.dragging=!0,this.render(),setTimeout(function(){t.dragging=!1},this.refreshRate)},render:function(){this.offset+=Math.max(-this.currentPerPage+1,Math.min(Math.round(this.dragMomentum),this.currentPerPage-1))*this.slideWidth;var t=this.scrollPerPage?this.slideWidth*this.currentPerPage:this.slideWidth;this.offset=t*Math.round(this.offset/t),this.offset=Math.max(0,Math.min(this.offset,this.maxOffset)),this.currentPage=this.scrollPerPage?Math.round(this.offset/this.slideWidth/this.currentPerPage):Math.round(this.offset/this.slideWidth)},computeCarouselWidth:function(){this.getSlideCount(),this.getBrowserWidth(),this.getCarouselWidth(),this.setCurrentPageInBounds()},setCurrentPageInBounds:function(){if(!this.canAdvanceForward&&this.scrollPerPage){var t=this.pageCount-1;this.currentPage=t>=0?t:0,this.offset=Math.max(0,Math.min(this.offset,this.maxOffset))}}},mounted:function(){this.$isServer||(window.addEventListener("resize",(0,c.default)(this.onResize,this.refreshRate)),(this.isTouch||this.mouseDrag)&&this.$refs["VueCarousel-wrapper"].addEventListener(this.isTouch?"touchstart":"mousedown",this.onStart)),this.attachMutationObserver(),this.computeCarouselWidth()},beforeDestroy:function(){this.$isServer||(this.detachMutationObserver(),window.removeEventListener("resize",this.getBrowserWidth),this.$refs["VueCarousel-wrapper"].removeEventListener(this.isTouch?"touchstart":"mousedown",this.onStart))}}},function(t,e,n){t.exports={default:n(10),__esModule:!0}},function(t,e,n){n(11),t.exports=n(14).Math.sign},function(t,e,n){var i=n(12);i(i.S,"Math",{sign:n(28)})},function(t,e,n){var i=n(13),r=n(14),a=n(15),o=n(17),s=n(27),u="prototype",c=function(t,e,n){var l,d,f,h=t&c.F,p=t&c.G,g=t&c.S,v=t&c.P,m=t&c.B,b=t&c.W,y=p?r:r[e]||(r[e]={}),C=y[u],x=p?i:g?i[e]:(i[e]||{})[u];p&&(n=e);for(l in n)d=!h&&x&&void 0!==x[l],d&&s(y,l)||(f=d?x[l]:n[l],y[l]=p&&"function"!=typeof x[l]?n[l]:m&&d?a(f,i):b&&x[l]==f?function(t){var e=function(e,n,i){if(this instanceof t){switch(arguments.length){case 0:return new t;case 1:return new t(e);case 2:return new t(e,n)}return new t(e,n,i)}return t.apply(this,arguments)};return e[u]=t[u],e}(f):v&&"function"==typeof f?a(Function.call,f):f,v&&((y.virtual||(y.virtual={}))[l]=f,t&c.R&&C&&!C[l]&&o(C,l,f)))};c.F=1,c.G=2,c.S=4,c.P=8,c.B=16,c.W=32,c.U=64,c.R=128,t.exports=c},function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e){var n=t.exports={version:"2.5.4"};"number"==typeof __e&&(__e=n)},function(t,e,n){var i=n(16);t.exports=function(t,e,n){if(i(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,i){return t.call(e,n,i)};case 3:return function(n,i,r){return t.call(e,n,i,r)}}return function(){return t.apply(e,arguments)}}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e,n){var i=n(18),r=n(26);t.exports=n(22)?function(t,e,n){return i.f(t,e,r(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e,n){var i=n(19),r=n(21),a=n(25),o=Object.defineProperty;e.f=n(22)?Object.defineProperty:function(t,e,n){if(i(t),e=a(e,!0),i(n),r)try{return o(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e,n){var i=n(20);t.exports=function(t){if(!i(t))throw TypeError(t+" is not an object!");return t}},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e,n){t.exports=!n(22)&&!n(23)(function(){return 7!=Object.defineProperty(n(24)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){t.exports=!n(23)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){var i=n(20),r=n(13).document,a=i(r)&&i(r.createElement);t.exports=function(t){return a?r.createElement(t):{}}},function(t,e,n){var i=n(20);t.exports=function(t,e){if(!i(t))return t;var n,r;if(e&&"function"==typeof(n=t.toString)&&!i(r=n.call(t)))return r;if("function"==typeof(n=t.valueOf)&&!i(r=n.call(t)))return r;if(!e&&"function"==typeof(n=t.toString)&&!i(r=n.call(t)))return r;throw TypeError("Can't convert object to primitive value")}},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e){t.exports=Math.sign||function(t){return 0==(t=+t)||t!=t?t:t<0?-1:1}},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n={props:{autoplay:{type:Boolean,default:!1},autoplayTimeout:{type:Number,default:2e3},autoplayHoverPause:{type:Boolean,default:!0}},data:function(){return{autoplayInterval:null}},destroyed:function(){this.$isServer||(this.$el.removeEventListener("mouseenter",this.pauseAutoplay),this.$el.removeEventListener("mouseleave",this.startAutoplay))},methods:{pauseAutoplay:function(){this.autoplayInterval&&(this.autoplayInterval=clearInterval(this.autoplayInterval))},startAutoplay:function(){this.autoplay&&(this.autoplayInterval=setInterval(this.advancePage,this.autoplayTimeout))}},mounted:function(){!this.$isServer&&this.autoplayHoverPause&&(this.$el.addEventListener("mouseenter",this.pauseAutoplay),this.$el.addEventListener("mouseleave",this.startAutoplay)),this.startAutoplay()}};e.default=n},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=function(t,e,n){var i=void 0;return function(){var r=void 0,a=function(){i=null,n||t.apply(r)},o=n&&!i;clearTimeout(i),i=setTimeout(a,e),o&&t.apply(r)}};e.default=n},function(t,e,n){function i(t){n(32)}var r=n(7)(n(34),n(35),i,"data-v-7fed18e9",null);t.exports=r.exports},function(t,e,n){var i=n(33);"string"==typeof i&&(i=[[t.id,i,""]]),i.locals&&(t.exports=i.locals);n(5)("a1957e6c",i,!0,{})},function(t,e,n){e=t.exports=n(4)(),e.push([t.id,".VueCarousel-navigation-button[data-v-7fed18e9]{position:absolute;top:50%;box-sizing:border-box;color:#000;text-decoration:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;background-color:transparent;padding:0;cursor:pointer;outline:none}.VueCarousel-navigation-next[data-v-7fed18e9]{right:0;transform:translateY(-50%) translateX(100%)}.VueCarousel-navigation-prev[data-v-7fed18e9]{left:0;transform:translateY(-50%) translateX(-100%)}.VueCarousel-navigation--disabled[data-v-7fed18e9]{opacity:.5;cursor:default}",""])},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={name:"navigation",data:function(){return{parentContainer:this.$parent}},props:{clickTargetSize:{type:Number,default:8},nextLabel:{type:String,default:"▶"},prevLabel:{type:String,default:"◀"}},computed:{canAdvanceForward:function(){return this.parentContainer.canAdvanceForward||!1},canAdvanceBackward:function(){return this.parentContainer.canAdvanceBackward||!1}},methods:{triggerPageAdvance:function(t){this.$emit("navigationclick",t)}}}},function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"VueCarousel-navigation"},[n("button",{staticClass:"VueCarousel-navigation-button VueCarousel-navigation-prev",class:{"VueCarousel-navigation--disabled":!t.canAdvanceBackward},style:"padding: "+t.clickTargetSize+"px; margin-right: -"+t.clickTargetSize+"px;",attrs:{type:"button","aria-label":"Previous page",role:"button"},domProps:{innerHTML:t._s(t.prevLabel)},on:{click:function(e){e.preventDefault(),t.triggerPageAdvance("backward")}}}),t._v(" "),n("button",{staticClass:"VueCarousel-navigation-button VueCarousel-navigation-next",class:{"VueCarousel-navigation--disabled":!t.canAdvanceForward},style:"padding: "+t.clickTargetSize+"px; margin-left: -"+t.clickTargetSize+"px;",attrs:{type:"button","aria-label":"Next page",role:"button"},domProps:{innerHTML:t._s(t.nextLabel)},on:{click:function(e){e.preventDefault(),t.triggerPageAdvance()}}})])},staticRenderFns:[]}},function(t,e,n){function i(t){n(37)}var r=n(7)(n(39),n(40),i,"data-v-7e42136f",null);t.exports=r.exports},function(t,e,n){var i=n(38);"string"==typeof i&&(i=[[t.id,i,""]]),i.locals&&(t.exports=i.locals);n(5)("3ea8dd5f",i,!0,{})},function(t,e,n){e=t.exports=n(4)(),e.push([t.id,".VueCarousel-pagination[data-v-7e42136f]{width:100%;text-align:center}.VueCarousel-dot-container[data-v-7e42136f]{display:inline-block;margin:0 auto;padding:0}.VueCarousel-dot[data-v-7e42136f]{display:inline-block;cursor:pointer}.VueCarousel-dot-button[data-v-7e42136f]{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;background-color:transparent;padding:0;border-radius:100%;outline:none;cursor:pointer}.VueCarousel-dot-button[data-v-7e42136f]:focus{outline:1px solid #add8e6}",""])},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={name:"pagination",data:function(){return{parentContainer:this.$parent}},methods:{goToPage:function(t){this.$emit("paginationclick",t)},isCurrentDot:function(t){return t===this.parentContainer.currentPage}}}},function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{directives:[{name:"show",rawName:"v-show",value:t.parentContainer.pageCount>1,expression:"parentContainer.pageCount > 1"}],staticClass:"VueCarousel-pagination"},[n("ul",{staticClass:"VueCarousel-dot-container",attrs:{role:"tablist"}},t._l(t.parentContainer.pageCount,function(e,i){return n("li",{key:i,staticClass:"VueCarousel-dot",class:{"VueCarousel-dot--active":t.isCurrentDot(i)},style:"\n        margin-top: "+2*t.parentContainer.paginationPadding+"px;\n        padding: "+t.parentContainer.paginationPadding+"px;\n      ",attrs:{"aria-hidden":"false",role:"presentation","aria-selected":t.isCurrentDot(i)?"true":"false"},on:{click:function(e){t.goToPage(i)}}},[n("button",{staticClass:"VueCarousel-dot-button",style:"\n          width: "+t.parentContainer.paginationSize+"px;\n          height: "+t.parentContainer.paginationSize+"px;\n          background: "+(t.isCurrentDot(i)?t.parentContainer.paginationActiveColor:t.parentContainer.paginationColor)+";\n        ",attrs:{type:"button",role:"button",tabindex:i}})])}))])},staticRenderFns:[]}},function(t,e,n){function i(t){n(42)}var r=n(7)(n(44),n(45),i,null,null);t.exports=r.exports},function(t,e,n){var i=n(43);"string"==typeof i&&(i=[[t.id,i,""]]),i.locals&&(t.exports=i.locals);n(5)("e8ab14d8",i,!0,{})},function(t,e,n){e=t.exports=n(4)(),e.push([t.id,".VueCarousel-slide{-ms-flex-preferred-size:inherit;flex-basis:inherit;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-touch-callout:none;outline:none}",""])},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={name:"slide",data:function(){return{width:null}},mounted:function(){this.$isServer||this.$el.addEventListener("dragstart",function(t){return t.preventDefault()})}}},function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"VueCarousel-slide",attrs:{tabindex:"-1"}},[t._t("default")],2)},staticRenderFns:[]}},function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("section",{staticClass:"VueCarousel"},[n("div",{ref:"VueCarousel-wrapper",staticClass:"VueCarousel-wrapper"},[n("div",{ref:"VueCarousel-inner",staticClass:"VueCarousel-inner",style:"\n        transform: translate3d("+t.currentOffset+"px, 0, 0);\n        transition: "+(t.dragging?"none":t.transitionStyle)+";\n        ms-flex-preferred-size: "+t.slideWidth+"px;\n        webkit-flex-basis: "+t.slideWidth+"px;\n        flex-basis: "+t.slideWidth+"px;\n        visibility: "+(t.slideWidth?"visible":"hidden")+";\n        padding-left: "+t.padding+"px;\n        padding-right: "+t.padding+"px;\n      ",attrs:{role:"listbox"}},[t._t("default")],2)]),t._v(" "),t.paginationEnabled&&t.pageCount>0?n("pagination",{on:{paginationclick:function(e){t.goToPage(e,"pagination")}}}):t._e(),t._v(" "),t.navigationEnabled?n("navigation",{attrs:{clickTargetSize:t.navigationClickTargetSize,nextLabel:t.navigationNextLabel,prevLabel:t.navigationPrevLabel},on:{navigationclick:t.handleNavigation}}):t._e()],1)},staticRenderFns:[]}}])});

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1601)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(557),
	  /* template */
	  __webpack_require__(2136),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1613)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(613),
	  /* template */
	  __webpack_require__(2149),
	  /* scopeId */
	  "data-v-62a2e20e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1522)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(614),
	  /* template */
	  __webpack_require__(2054),
	  /* scopeId */
	  "data-v-17eb94bd",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1507)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(615),
	  /* template */
	  __webpack_require__(2037),
	  /* scopeId */
	  "data-v-03e82536",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1568)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(616),
	  /* template */
	  __webpack_require__(2103),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1519)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(618),
	  /* template */
	  __webpack_require__(2051),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1559)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(558),
	  /* template */
	  __webpack_require__(2093),
	  /* scopeId */
	  "data-v-369c3ae7",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1642)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(619),
	  /* template */
	  __webpack_require__(2182),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(621),
	  /* template */
	  __webpack_require__(2139),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1513)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(559),
	  /* template */
	  __webpack_require__(2045),
	  /* scopeId */
	  "data-v-0d5dec99",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1528)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(560),
	  /* template */
	  __webpack_require__(2060),
	  /* scopeId */
	  "data-v-1de58b2b",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1567)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(561),
	  /* template */
	  __webpack_require__(2102),
	  /* scopeId */
	  "data-v-3a17c892",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1635)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(562),
	  /* template */
	  __webpack_require__(2174),
	  /* scopeId */
	  "data-v-7866cdb0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1577)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(563),
	  /* template */
	  __webpack_require__(2112),
	  /* scopeId */
	  "data-v-430c8754",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1506)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(565),
	  /* template */
	  __webpack_require__(2036),
	  /* scopeId */
	  "data-v-03c9c61b",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1532)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(623),
	  /* template */
	  __webpack_require__(2064),
	  /* scopeId */
	  "data-v-2110c524",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1632)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(624),
	  /* template */
	  __webpack_require__(2171),
	  /* scopeId */
	  "data-v-76136784",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1617)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(625),
	  /* template */
	  __webpack_require__(2153),
	  /* scopeId */
	  "data-v-64cf7988",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(2166),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1574)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(566),
	  /* template */
	  __webpack_require__(2109),
	  /* scopeId */
	  "data-v-411485fe",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1611)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(567),
	  /* template */
	  __webpack_require__(2147),
	  /* scopeId */
	  "data-v-6246e9f0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1590)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(568),
	  /* template */
	  __webpack_require__(2125),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1549)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(2083),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1509)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(636),
	  /* template */
	  __webpack_require__(2039),
	  /* scopeId */
	  "data-v-04eaec87",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1585)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(637),
	  /* template */
	  __webpack_require__(2120),
	  /* scopeId */
	  "data-v-4ba6bf53",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1644)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(638),
	  /* template */
	  __webpack_require__(2184),
	  /* scopeId */
	  "data-v-7f70f35c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1564)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(641),
	  /* template */
	  __webpack_require__(2099),
	  /* scopeId */
	  "data-v-38f3837c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(644),
	  /* template */
	  __webpack_require__(2189),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1604)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(645),
	  /* template */
	  __webpack_require__(2140),
	  /* scopeId */
	  "data-v-5c57ffcc",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(647),
	  /* template */
	  __webpack_require__(2096),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(648),
	  /* template */
	  __webpack_require__(2164),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1510)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(649),
	  /* template */
	  __webpack_require__(2041),
	  /* scopeId */
	  "data-v-06321eb8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1533)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(650),
	  /* template */
	  __webpack_require__(2065),
	  /* scopeId */
	  "data-v-22576d48",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1645)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(652),
	  /* template */
	  __webpack_require__(2185),
	  /* scopeId */
	  "data-v-811ae500",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1526)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(653),
	  /* template */
	  __webpack_require__(2058),
	  /* scopeId */
	  "data-v-1a51a23d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1586)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(654),
	  /* template */
	  __webpack_require__(2121),
	  /* scopeId */
	  "data-v-4cf94050",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1571)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(570),
	  /* template */
	  __webpack_require__(2106),
	  /* scopeId */
	  "data-v-3cb6522b",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1676)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(656),
	  /* template */
	  __webpack_require__(2217),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1570)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(657),
	  /* template */
	  __webpack_require__(2105),
	  /* scopeId */
	  "data-v-3c217b3a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1580)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(658),
	  /* template */
	  __webpack_require__(2115),
	  /* scopeId */
	  "data-v-4556d46a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1547)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(659),
	  /* template */
	  __webpack_require__(2081),
	  /* scopeId */
	  "data-v-2cf72041",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1614)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(660),
	  /* template */
	  __webpack_require__(2150),
	  /* scopeId */
	  "data-v-636de27b",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1553)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(573),
	  /* template */
	  __webpack_require__(2087),
	  /* scopeId */
	  "data-v-32b42bf4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1685)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(661),
	  /* template */
	  __webpack_require__(2226),
	  /* scopeId */
	  "data-v-f76e9ae0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1524)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(574),
	  /* template */
	  __webpack_require__(2056),
	  /* scopeId */
	  "data-v-18ad0eec",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1647)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(662),
	  /* template */
	  __webpack_require__(2187),
	  /* scopeId */
	  "data-v-853aa90e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1649)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(2190),
	  /* scopeId */
	  "data-v-8f2892d2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1551)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(663),
	  /* template */
	  __webpack_require__(2085),
	  /* scopeId */
	  "data-v-31518f94",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1671)
	__webpack_require__(1672)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(235),
	  /* template */
	  __webpack_require__(2213),
	  /* scopeId */
	  "data-v-c8bebda2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1557)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(664),
	  /* template */
	  __webpack_require__(2091),
	  /* scopeId */
	  "data-v-34ad2bda",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1575)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(665),
	  /* template */
	  __webpack_require__(2110),
	  /* scopeId */
	  "data-v-42587548",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1652)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(666),
	  /* template */
	  __webpack_require__(2193),
	  /* scopeId */
	  "data-v-97a25e88",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1634)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(575),
	  /* template */
	  __webpack_require__(2173),
	  /* scopeId */
	  "data-v-78623cc9",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1512)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(667),
	  /* template */
	  __webpack_require__(2044),
	  /* scopeId */
	  "data-v-0c73e4ce",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1504)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(668),
	  /* template */
	  __webpack_require__(2034),
	  /* scopeId */
	  "data-v-02b10153",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1550)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(669),
	  /* template */
	  __webpack_require__(2084),
	  /* scopeId */
	  "data-v-30ab559c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1548)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(670),
	  /* template */
	  __webpack_require__(2082),
	  /* scopeId */
	  "data-v-2db17dd4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(671),
	  /* template */
	  __webpack_require__(2071),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1520)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(672),
	  /* template */
	  __webpack_require__(2052),
	  /* scopeId */
	  "data-v-178605f8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1657)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(673),
	  /* template */
	  __webpack_require__(2198),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1658)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(674),
	  /* template */
	  __webpack_require__(2199),
	  /* scopeId */
	  "data-v-aa9b4728",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1609)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(576),
	  /* template */
	  __webpack_require__(2145),
	  /* scopeId */
	  "data-v-5f4759c6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1508)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(675),
	  /* template */
	  __webpack_require__(2038),
	  /* scopeId */
	  "data-v-0412b9c1",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1561)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(677),
	  /* template */
	  __webpack_require__(2095),
	  /* scopeId */
	  "data-v-3792da5a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1581)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(678),
	  /* template */
	  __webpack_require__(2116),
	  /* scopeId */
	  "data-v-46ee6ee2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1618)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(577),
	  /* template */
	  __webpack_require__(2154),
	  /* scopeId */
	  "data-v-65914c75",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1554)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(679),
	  /* template */
	  __webpack_require__(2088),
	  /* scopeId */
	  "data-v-33c50a11",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1683)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(680),
	  /* template */
	  __webpack_require__(2224),
	  /* scopeId */
	  "data-v-f2781332",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1603)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(578),
	  /* template */
	  __webpack_require__(2138),
	  /* scopeId */
	  "data-v-5a166c2f",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1517)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(683),
	  /* template */
	  __webpack_require__(2049),
	  /* scopeId */
	  "data-v-1358ac6e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1552)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(684),
	  /* template */
	  __webpack_require__(2086),
	  /* scopeId */
	  "data-v-3239973e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1678)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(681),
	  /* template */
	  __webpack_require__(2219),
	  /* scopeId */
	  "data-v-dc13bdf0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1566)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(682),
	  /* template */
	  __webpack_require__(2101),
	  /* scopeId */
	  "data-v-39e6ecfc",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1516)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(685),
	  /* template */
	  __webpack_require__(2048),
	  /* scopeId */
	  "data-v-11754b0e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1659)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(579),
	  /* template */
	  __webpack_require__(2201),
	  /* scopeId */
	  "data-v-b3abd4c8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1589)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(686),
	  /* template */
	  __webpack_require__(2124),
	  /* scopeId */
	  "data-v-50191b96",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1675)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(687),
	  /* template */
	  __webpack_require__(2216),
	  /* scopeId */
	  "data-v-d079beac",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1674)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(688),
	  /* template */
	  __webpack_require__(2215),
	  /* scopeId */
	  "data-v-cb8e0b90",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1595)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(689),
	  /* template */
	  __webpack_require__(2130),
	  /* scopeId */
	  "data-v-54278734",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1588)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(690),
	  /* template */
	  __webpack_require__(2123),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1538)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(691),
	  /* template */
	  __webpack_require__(2070),
	  /* scopeId */
	  "data-v-2670fe86",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1544)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(692),
	  /* template */
	  __webpack_require__(2078),
	  /* scopeId */
	  "data-v-295baa12",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1638)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(693),
	  /* template */
	  __webpack_require__(2178),
	  /* scopeId */
	  "data-v-7c22637c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1563)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(694),
	  /* template */
	  __webpack_require__(2098),
	  /* scopeId */
	  "data-v-381ed819",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1531)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(695),
	  /* template */
	  __webpack_require__(2063),
	  /* scopeId */
	  "data-v-20d48a8a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1631)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(696),
	  /* template */
	  __webpack_require__(2170),
	  /* scopeId */
	  "data-v-7493b28c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1623)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(697),
	  /* template */
	  __webpack_require__(2159),
	  /* scopeId */
	  "data-v-6b15ee75",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1534)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(698),
	  /* template */
	  __webpack_require__(2066),
	  /* scopeId */
	  "data-v-226fe354",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1677)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(699),
	  /* template */
	  __webpack_require__(2218),
	  /* scopeId */
	  "data-v-d82f399c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(580),
	  /* template */
	  __webpack_require__(2042),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1536)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(700),
	  /* template */
	  __webpack_require__(2068),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1612)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(701),
	  /* template */
	  __webpack_require__(2148),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1616)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(702),
	  /* template */
	  __webpack_require__(2152),
	  /* scopeId */
	  "data-v-64a6d0a1",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1584)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(703),
	  /* template */
	  __webpack_require__(2119),
	  /* scopeId */
	  "data-v-48f5beb2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1679)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(704),
	  /* template */
	  __webpack_require__(2220),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1668)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(705),
	  /* template */
	  __webpack_require__(2210),
	  /* scopeId */
	  "data-v-be7de504",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1573)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(706),
	  /* template */
	  __webpack_require__(2108),
	  /* scopeId */
	  "data-v-407104b4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1667)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(707),
	  /* template */
	  __webpack_require__(2209),
	  /* scopeId */
	  "data-v-ba986cdc",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1686)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(709),
	  /* template */
	  __webpack_require__(2227),
	  /* scopeId */
	  "data-v-ffc999a2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1598)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(710),
	  /* template */
	  __webpack_require__(2133),
	  /* scopeId */
	  "data-v-58259f8e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1529)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(711),
	  /* template */
	  __webpack_require__(2061),
	  /* scopeId */
	  "data-v-1fd17b04",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1527)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(712),
	  /* template */
	  __webpack_require__(2059),
	  /* scopeId */
	  "data-v-1ca2fb6a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1511)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(713),
	  /* template */
	  __webpack_require__(2043),
	  /* scopeId */
	  "data-v-0bb7230a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1630)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(714),
	  /* template */
	  __webpack_require__(2169),
	  /* scopeId */
	  "data-v-73ed0caa",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1576)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(715),
	  /* template */
	  __webpack_require__(2111),
	  /* scopeId */
	  "data-v-42d4cfa4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1608)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(716),
	  /* template */
	  __webpack_require__(2144),
	  /* scopeId */
	  "data-v-5e660864",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1523)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(717),
	  /* template */
	  __webpack_require__(2055),
	  /* scopeId */
	  "data-v-18256f0b",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1682)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(718),
	  /* template */
	  __webpack_require__(2223),
	  /* scopeId */
	  "data-v-ec452d44",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1587)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(719),
	  /* template */
	  __webpack_require__(2122),
	  /* scopeId */
	  "data-v-4f8b1196",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1651)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(169),
	  /* template */
	  __webpack_require__(2192),
	  /* scopeId */
	  "data-v-93b519d2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1622)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(723),
	  /* template */
	  __webpack_require__(2158),
	  /* scopeId */
	  "data-v-6a47ce92",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1680)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(584),
	  /* template */
	  __webpack_require__(2221),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1579)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(585),
	  /* template */
	  __webpack_require__(2114),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1625)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(586),
	  /* template */
	  __webpack_require__(2162),
	  /* scopeId */
	  "data-v-6d0e011e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1624)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(587),
	  /* template */
	  __webpack_require__(2161),
	  /* scopeId */
	  "data-v-6cd6e6c4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1620)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(588),
	  /* template */
	  __webpack_require__(2156),
	  /* scopeId */
	  "data-v-68180e44",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1653)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(589),
	  /* template */
	  __webpack_require__(2194),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1662)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(590),
	  /* template */
	  __webpack_require__(2204),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1602)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(591),
	  /* template */
	  __webpack_require__(2137),
	  /* scopeId */
	  "data-v-59dbe89c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1606)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(592),
	  /* template */
	  __webpack_require__(2142),
	  /* scopeId */
	  "data-v-5cb7a55e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1621)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(727),
	  /* template */
	  __webpack_require__(2157),
	  /* scopeId */
	  "data-v-693b2a93",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1643)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(237),
	  /* template */
	  __webpack_require__(2183),
	  /* scopeId */
	  "data-v-7f315b42",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1560)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(728),
	  /* template */
	  __webpack_require__(2094),
	  /* scopeId */
	  "data-v-36fe3213",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1664)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(729),
	  /* template */
	  __webpack_require__(2206),
	  /* scopeId */
	  "data-v-b6d8aed8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1600)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(730),
	  /* template */
	  __webpack_require__(2135),
	  /* scopeId */
	  "data-v-58823a00",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1593)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(731),
	  /* template */
	  __webpack_require__(2128),
	  /* scopeId */
	  "data-v-53554200",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1599)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(732),
	  /* template */
	  __webpack_require__(2134),
	  /* scopeId */
	  "data-v-584d5185",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1514)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(595),
	  /* template */
	  __webpack_require__(2046),
	  /* scopeId */
	  "data-v-0ee6bbfb",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1565)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(596),
	  /* template */
	  __webpack_require__(2100),
	  /* scopeId */
	  "data-v-394c262f",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1666)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(597),
	  /* template */
	  __webpack_require__(2208),
	  /* scopeId */
	  "data-v-ba90fe00",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1596)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(598),
	  /* template */
	  __webpack_require__(2131),
	  /* scopeId */
	  "data-v-55e7e9a1",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1641)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(599),
	  /* template */
	  __webpack_require__(2181),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1626)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(600),
	  /* template */
	  __webpack_require__(2163),
	  /* scopeId */
	  "data-v-6e2950a3",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(601),
	  /* template */
	  __webpack_require__(2077),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1639)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(733),
	  /* template */
	  __webpack_require__(2179),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1505)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(734),
	  /* template */
	  __webpack_require__(2035),
	  /* scopeId */
	  "data-v-03a6807b",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1681)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(2222),
	  /* scopeId */
	  "data-v-eb309142",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1654)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(2195),
	  /* scopeId */
	  "data-v-9cc7f102",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1656)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(602),
	  /* template */
	  __webpack_require__(2197),
	  /* scopeId */
	  "data-v-a38f2440",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1610)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(2146),
	  /* scopeId */
	  "data-v-62138004",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1569)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(2104),
	  /* scopeId */
	  "data-v-3b7b1eb8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1670)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(2212),
	  /* scopeId */
	  "data-v-c707b468",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1605)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(2141),
	  /* scopeId */
	  "data-v-5c920c0a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1546)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(603),
	  /* template */
	  __webpack_require__(2080),
	  /* scopeId */
	  "data-v-2bdd7bbe",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1673)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(740),
	  /* template */
	  __webpack_require__(2214),
	  /* scopeId */
	  "data-v-c966caf6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1597)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(741),
	  /* template */
	  __webpack_require__(2132),
	  /* scopeId */
	  "data-v-56d9235d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1540)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(742),
	  /* template */
	  __webpack_require__(2073),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1663)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(743),
	  /* template */
	  __webpack_require__(2205),
	  /* scopeId */
	  "data-v-b642413c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1555)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(2089),
	  /* scopeId */
	  "data-v-33db85fb",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1556)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(2090),
	  /* scopeId */
	  "data-v-33e99d7c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(2200),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1646)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(744),
	  /* template */
	  __webpack_require__(2186),
	  /* scopeId */
	  "data-v-82ed9a0e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1637)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(604),
	  /* template */
	  __webpack_require__(2177),
	  /* scopeId */
	  "data-v-79aa7234",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1582)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(605),
	  /* template */
	  __webpack_require__(2117),
	  /* scopeId */
	  "data-v-472d28fc",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1542)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(606),
	  /* template */
	  __webpack_require__(2075),
	  /* scopeId */
	  "data-v-2796da64",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1583)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(607),
	  /* template */
	  __webpack_require__(2118),
	  /* scopeId */
	  "data-v-47dc4886",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1541)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(608),
	  /* template */
	  __webpack_require__(2074),
	  /* scopeId */
	  "data-v-277aab62",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1518)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(609),
	  /* template */
	  __webpack_require__(2050),
	  /* scopeId */
	  "data-v-151b2098",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1539)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(610),
	  /* template */
	  __webpack_require__(2072),
	  /* scopeId */
	  "data-v-2754a0b7",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1636)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(611),
	  /* template */
	  __webpack_require__(2175),
	  /* scopeId */
	  "data-v-78b4dbf1",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1640)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(612),
	  /* template */
	  __webpack_require__(2180),
	  /* scopeId */
	  "data-v-7e5332c9",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1627)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(745),
	  /* template */
	  __webpack_require__(2165),
	  /* scopeId */
	  "data-v-70ab1ec0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1503)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(2033),
	  /* scopeId */
	  "data-v-01f9e16a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "extract"
	  }, [_c('div', {
	    staticClass: "row-extract"
	  }, [_c('div', {
	    staticClass: "yellow-block"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "red-block"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "purple-block"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "blue-block"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "green-block"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row-extract"
	  }, [_c('div', {
	    staticClass: "box-mm"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1797),
	      "alt": "logo move mais",
	      "width": "255px"
	    }
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "title-extract bold"
	  }, [_vm._v("EXTRATO")])]), _vm._v(" "), _c('div', {
	    staticClass: "row-extract row-red margin-t20"
	  }, [_c('div', {
	    staticClass: "period bold"
	  }, [_c('p', [_vm._v("Período")]), _vm._v(" "), _c('p', {
	    staticClass: "date"
	  }, [_vm._v("01/06/2016 á 31/07/2016")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row-extract margin-t20"
	  }, [_c('table', {
	    staticClass: "table stripped-odd stripped"
	  }, [_c('thead', [_c('tr', {
	    staticClass: "row-red"
	  }, [_c('th', {
	    attrs: {
	      "width": "70%"
	    }
	  }, [_vm._v("Tipo de transação")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "right"
	    },
	    attrs: {
	      "width": "15%"
	    }
	  }, [_vm._v("Quantidade")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "right"
	    },
	    attrs: {
	      "width": "15%"
	    }
	  }, [_vm._v("Valor em R$")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("passagem")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_vm._v("741")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_vm._v("-6.008,70")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("taxa de recarga manual")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_vm._v("-1.600,00")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("adesao servico move mais")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_vm._v("-119,70")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("pagamento/credito manual")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_vm._v("4")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_vm._v("1.719,70")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row-extract margin-t20"
	  }, [_c('table', {
	    staticClass: "table detail stripped-odd stripped"
	  }, [_c('thead', [_c('tr', {
	    staticClass: "row-red"
	  }, [_c('th', {
	    attrs: {
	      "width": "17%"
	    }
	  }, [_vm._v("Data Processamento")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "15%"
	    }
	  }, [_vm._v("Data Ocorrência")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "23%"
	    }
	  }, [_vm._v("Tipo Transação")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "10%"
	    }
	  }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "10%"
	    }
	  }, [_vm._v("Categoria")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "15%"
	    }
	  }, [_vm._v("Local")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "text-align": "right"
	    },
	    attrs: {
	      "width": "10%"
	    }
	  }, [_vm._v("Valor")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("adesao servico move mais")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_vm._v("-39,90")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("adesao receita mm")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_vm._v("39,90")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("adesao servico move mais")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_vm._v("-39,90")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("adesao receita mm")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_vm._v("39,90")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("adesao adic serv move mais")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_vm._v("-119,70")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("passagem")]), _vm._v(" "), _c('td', [_vm._v("ABC1234")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("SP 300 - km 120")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_vm._v("-10,70")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("passagem")]), _vm._v(" "), _c('td', [_vm._v("ABC1234")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("SP 300 - km 120")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_vm._v("-10,70")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("passagem")]), _vm._v(" "), _c('td', [_vm._v("ABC1234")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("SP 300 - km 120")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_vm._v("-10,70")])])])])])])
	}]}

/***/ }),
/* 2034 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "container"
	  }, [_c('p', {
	    staticClass: "line-height-20 margin-t30"
	  }, [_vm._v("\n        Informe um valor de recarga, verifique a taxa de recarga e confirme.\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.rechargesData), function(r, n) {
	    return _c('div', {
	      staticClass: "col-md-3"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model.number",
	        value: (_vm.unit),
	        expression: "unit",
	        modifiers: {
	          "number": true
	        }
	      }],
	      attrs: {
	        "type": "radio",
	        "id": r.value,
	        "name": "recharge-value"
	      },
	      domProps: {
	        "value": r.value,
	        "checked": _vm._q(_vm.unit, _vm._n(r.value))
	      },
	      on: {
	        "change": function($event) {
	          _vm.unit = _vm._n(r.value)
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      staticClass: "force-link",
	      attrs: {
	        "for": r.value
	      }
	    }, [_c('span'), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('div', {
	      class: 'recharge-' + n % 4
	    }, [_c('div', {
	      class: 'recharge-label-' + n % 4
	    }, [_vm._v(_vm._s(_vm._f("moneyNoCents")(r.value)))]), _vm._v(" "), _c('div', {
	      staticClass: "recharge-tax-label"
	    }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v(_vm._s(_vm._f("cents")(r.tax)))])])])])])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.unit),
	      expression: "unit",
	      modifiers: {
	        "number": true
	      }
	    }],
	    attrs: {
	      "type": "radio",
	      "id": "rechargeOpen",
	      "name": "recharge-value",
	      "value": "-1"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.unit, _vm._n("-1"))
	    },
	    on: {
	      "change": function($event) {
	        _vm.unit = _vm._n("-1")
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "force-link",
	    attrs: {
	      "for": "rechargeOpen"
	    }
	  }, [_c('span'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "recharge-open-box"
	  }, [_c('div', {
	    staticClass: "recharge-open-label"
	  }, [_c('b', [_vm._v("Outro valor")]), _vm._v(" (deve ser maior que " + _vm._s(_vm._f("cents")(_vm.minValue)) + ").\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('valueTotal')
	    }
	  }, [(_vm.unit == -1) ? _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|recargaMinima:' + _vm.minValue),
	      expression: "'required|recargaMinima:'+minValue"
	    }],
	    staticClass: "form-control text-right recharge-input margin-t10",
	    attrs: {
	      "id": "valueTotal",
	      "type": "text",
	      "name": "valueTotal",
	      "placeholder": "R$ 00,00",
	      "spellcheck": "false",
	      "autocomplete": "off",
	      "autocorrect": "off",
	      "autocapitalize": "off",
	      "maxlength": "14"
	    },
	    domProps: {
	      "value": _vm.valueFormatted
	    },
	    on: {
	      "input": function($event) {
	        return _vm.setTotal($event.target.value)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "help-block has-errors"
	  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('valueTotal')) + "\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-open-tax-label"
	  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v(_vm._s(_vm._f("cents")(_vm.rate)))])])])])])]), _vm._v(" "), (_vm.msgError) ? _c('div', {
	    staticClass: "alert alert-danger margin-b20"
	  }, [_c('p', [_vm._v(_vm._s(_vm.msgError))])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "recharge-checkbox"
	  }, [_c('i', {
	    staticClass: "icon-checkmark"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "recharge-checkbox"
	  }, [_c('i', {
	    staticClass: "icon-checkmark"
	  })])
	}]}

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "row header"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'inicio'
	      }
	    }
	  }, [_c('div', {
	    staticClass: "logo-box"
	  }, [_c('div', {
	    staticClass: "logo-header"
	  })])]), _vm._v(" "), _vm._m(0)], 1)])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "row"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-offset-2 col-md-8"
	  }, [_c('div', {}, [(_vm.formState == 'ERROR') ? _c('div', {
	    staticClass: "alert alert-danger alert-dismissible margin-t20 margin-b20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Erro!")]), _vm._v(" " + _vm._s(_vm.errorMessage) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'LEAD-INFO') ? _c('div', {
	    staticClass: "alert alert-info alert-dismissible margin-t20 margin-b20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Informação!")]), _vm._v(" " + _vm._s(_vm.leadClient ? 'Caro cliente, sua solicitação encontra-se em análise. Em caso de dúvidas, por gentileza, entre em contato no número 08007651000' : 'Solicitação em análise. Em caso de dúvidas, por gentileza, entre em contato com o número 08007651000.') + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'SUCCESS') ? _c('div', {
	    staticClass: "alert alert-success alert-dismissible margin-t20 margin-b20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Sucesso!")]), _vm._v(" As informações foram enviadas, em breve entraremos em contato para finalizar a adesão, obrigado! ;)\n          ")]) : _vm._e(), _vm._v(" "), _c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "autocomplete": "false"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.doRequest.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('taxpayerIdNumber')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-3 control-label bold-600",
	    attrs: {
	      "for": "taxpayerIdNumber "
	    }
	  }, [_vm._v("\n                CNPJ\n              ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.taxpayerIdNumber),
	      expression: "taxpayerIdNumber",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "mask-cnpj",
	      rawName: "v-mask-cnpj"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cnpj'),
	      expression: "'required|cnpj'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2})$",
	      "name": "taxpayerIdNumber",
	      "id": "taxpayerIdNumber",
	      "data-vv-validate-on": "blur"
	    },
	    domProps: {
	      "value": (_vm.taxpayerIdNumber)
	    },
	    on: {
	      "change": function($event) {
	        _vm.taxpayerIdNumber = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('taxpayerIdNumber')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('companyName')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-3 control-label bold-600",
	    attrs: {
	      "for": "companyName"
	    }
	  }, [_vm._v("\n                Empresa\n              ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.companyName),
	      expression: "companyName"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "companyName",
	      "id": "companyName",
	      "data-vv-rules": "required"
	    },
	    domProps: {
	      "value": (_vm.companyName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.companyName = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('companyName')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('contactName')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-3 control-label bold-600",
	    attrs: {
	      "for": "contactName",
	      "required": ""
	    }
	  }, [_vm._v("\n                Nome do Contato\n              ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contactName),
	      expression: "contactName"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "contactName",
	      "id": "contactName",
	      "data-vv-rules": "required"
	    },
	    domProps: {
	      "value": (_vm.contactName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.contactName = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('contactName')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('contactEmail')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-3 control-label bold-600",
	    attrs: {
	      "for": "contactEmail"
	    }
	  }, [_vm._v("\n                E-mail\n              ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contactEmail),
	      expression: "contactEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "email",
	      "name": "contactEmail",
	      "id": "contactEmail",
	      "data-vv-rules": "required|email|email:email"
	    },
	    domProps: {
	      "value": (_vm.contactEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.contactEmail = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('contactEmail')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('contactJobTitle')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-3 control-label bold-600",
	    attrs: {
	      "for": "contactJobTitle"
	    }
	  }, [_vm._v("\n                Telefone\n              ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.contactJobTitle),
	      expression: "contactJobTitle",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "mask-tel",
	      rawName: "v-mask-tel"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|phone'),
	      expression: "'required|phone'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "contactJobTitle",
	      "id": "contactJobTitle"
	    },
	    domProps: {
	      "value": (_vm.contactJobTitle)
	    },
	    on: {
	      "change": function($event) {
	        _vm.contactJobTitle = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('contactJobTitle')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('sizeOfFleetVehicle')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-3 control-label bold-600",
	    attrs: {
	      "for": "sizeOfFleetVehicle"
	    }
	  }, [_vm._v("\n                Tamanho da Frota\n              ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sizeOfFleetVehicle),
	      expression: "sizeOfFleetVehicle"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }, {
	      name: "only-numbers",
	      rawName: "v-only-numbers"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "sizeOfFleetVehicle",
	      "id": "sizeOfFleetVehicle",
	      "data-vv-rules": "required|decimal|max:6",
	      "maxlength": "6"
	    },
	    domProps: {
	      "value": (_vm.sizeOfFleetVehicle)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.sizeOfFleetVehicle = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block-proposal help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('sizeOfFleetVehicle')))])])]), _vm._v(" "), _vm._m(5)])])])])]), _vm._v(" "), _vm._m(6)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title-header text-center"
	  }, [_c('h3', [_vm._v("A melhor solução para a sua frota, mais controle e comodidade para você!")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "background-purple"
	  }, [_c('div', {
	    staticClass: "box-slogan text-center"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1847),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "shadow"
	  }, [_vm._v("Com a "), _c('span', {
	    staticClass: "bold"
	  }, [_vm._v("Move Mais")]), _vm._v(" você tem:")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-icons text-center"
	  }, [_c('div', {
	    staticClass: "box-zoom"
	  }, [_c('div', {
	    staticClass: "icon"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1843),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('h3', {
	    staticClass: "bold upper shadow"
	  }, [_vm._v("rápida análise "), _c('br'), _vm._v(" de crédito")]), _vm._v(" "), _c('h4', {
	    staticClass: "shadow"
	  }, [_vm._v("Por que sabemos que sua "), _c('br'), _vm._v(" empresa não tem tempo a perder")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-paper"
	  }, [_c('div', {
	    staticClass: "icon"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1845),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('h3', {
	    staticClass: "bold upper shadow"
	  }, [_vm._v("relatório analítico "), _c('br'), _vm._v(" de passagens")])])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "background-arrows"
	  }, [_c('div', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6 color-purple content-text"
	  }, [_c('h3', [_vm._v("Informação é o que não falta por aqui.")]), _vm._v(" "), _c('h2', [_vm._v("Extrato definido pelo período que desejar e por placa.")]), _vm._v(" "), _c('h2', {
	    staticClass: "bold"
	  }, [_vm._v("Você no controle da sua frota.")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('img', {
	    staticClass: "content-img",
	    attrs: {
	      "src": __webpack_require__(1846),
	      "alt": ""
	    }
	  })])])])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "sac-box"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "box-icon"
	  }, [_c('div', {
	    staticClass: "sac-icon"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1844),
	      "alt": ""
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "sac-content"
	  }, [_c('h2', [_vm._v("O melhor tempo de resposta do mercado!")]), _vm._v(" "), _c('div', {
	    staticClass: "arrow_box"
	  }, [_c('h3', [_vm._v("Afinal, seus problemas precisam "), _c('br'), _vm._v(" ser resolvidos o quanto antes!")])])])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h2', {
	    staticClass: "text-center color-purple bold margin-30"
	  }, [_vm._v("Solicite uma proposta. Só falta a sua empresa com a gente:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-offset-4 col-sm-4 pad-fix text-center"
	  }, [_c('button', {
	    staticClass: "btn btn-lg btn-success bold-600 margin-30",
	    attrs: {
	      "id": "btn-enviar",
	      "type": "submit",
	      "name": "button"
	    }
	  }, [_vm._v("\n                Solicitar proposta\n              ")]), _vm._v(" "), _c('a', {
	    staticClass: "link",
	    attrs: {
	      "href": "https://movemais.com/"
	    }
	  }, [_vm._v("Visitar site da Move Mais")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "footer text-center"
	  }, [_c('small', {
	    staticClass: "block"
	  }, [_vm._v("Move Mais Meios de Pagamento Ltda. - CNPJ: 15.266.912/0001-87 - Inscrição Estadual: 181.239.134.110")]), _vm._v(" "), _c('small', {
	    staticClass: "block"
	  }, [_vm._v("Endereço: Avenida Rodrigo Fernando Grillo, 207, Edifício Victoria Business, 9° andar - Araraquara, SP, Brasil - 14801-534")])])])])
	}]}

/***/ }),
/* 2036 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "slide-up",
	      "appear": ""
	    }
	  }, [(_vm.isVisible) ? _c('div', {
	    directives: [{
	      name: "touch",
	      rawName: "v-touch:swipe.down",
	      value: (_vm.fecharModal),
	      expression: "fecharModal",
	      arg: "swipe",
	      modifiers: {
	        "down": true
	      }
	    }],
	    staticClass: "modal-horario"
	  }, [_c('div', {
	    directives: [{
	      name: "touch",
	      rawName: "v-touch:swipe.down",
	      value: (_vm.fecharModal),
	      expression: "fecharModal",
	      arg: "swipe",
	      modifiers: {
	        "down": true
	      }
	    }],
	    staticClass: "modal-content-horario"
	  }, [_c('div', {
	    directives: [{
	      name: "touch",
	      rawName: "v-touch:swipe.down",
	      value: (_vm.fecharModal),
	      expression: "fecharModal",
	      arg: "swipe",
	      modifiers: {
	        "down": true
	      }
	    }],
	    staticClass: "drag-area"
	  }, [_c('div', {
	    staticClass: "drag-indicator"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "modal-header-horario"
	  }, [_c('div', {
	    staticClass: "header-content-horario"
	  }, [_c('h1', [_vm._v("Horário de funcionamento")])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body-horario"
	  }, [_c('div', {
	    staticClass: "item-modal-left"
	  }, [_c('div', {
	    staticClass: "item-day"
	  }, [_c('label', {
	    staticClass: "item-day-topic"
	  }, [_vm._v("Segunda-feira")]), _vm._v(" "), _c('label', {
	    staticClass: "item-day-topic"
	  }, [_vm._v("Terça-feira")]), _vm._v(" "), _c('label', {
	    staticClass: "item-day-topic"
	  }, [_vm._v("Quarta-feira")]), _vm._v(" "), _c('label', {
	    staticClass: "item-day-topic"
	  }, [_vm._v("Quinta-feira")]), _vm._v(" "), _c('label', {
	    staticClass: "item-day-topic"
	  }, [_vm._v("Sexta-feira")]), _vm._v(" "), _c('label', {
	    staticClass: "item-day-topic"
	  }, [_vm._v("Sábado")]), _vm._v(" "), _c('label', {
	    staticClass: "item-day-topic"
	  }, [_vm._v("Domingo")]), _vm._v(" "), _c('label', {
	    staticClass: "item-day-topic"
	  }, [_vm._v("Feriados")])])]), _vm._v(" "), _c('div', {
	    staticClass: "item-modal-right"
	  }, [_c('div', {
	    staticClass: "item-horarios"
	  }, [_c('label', {
	    staticClass: "item-horarios-topic"
	  }, [_vm._v("\n              " + _vm._s(_vm.segundaPeriodo1) + "\n              "), (_vm.segundaPeriodo1 !== 'Aberto 24 horas' && _vm.segundaPeriodo1 !== 'Não informado') ? _c('span', [_vm._v(" | " + _vm._s(_vm.segundaPeriodo2))]) : _vm._e()]), _vm._v(" "), _c('label', {
	    staticClass: "item-horarios-topic"
	  }, [_vm._v("\n              " + _vm._s(_vm.tercaPeriodo1) + "\n              "), (_vm.tercaPeriodo1 !== 'Aberto 24 horas' && _vm.tercaPeriodo1 !== 'Não informado') ? _c('span', [_vm._v(" | " + _vm._s(_vm.tercaPeriodo2))]) : _vm._e()]), _vm._v(" "), _c('label', {
	    staticClass: "item-horarios-topic"
	  }, [_vm._v("\n              " + _vm._s(_vm.quartaPeriodo1) + "\n              "), (_vm.quartaPeriodo1 !== 'Aberto 24 horas' && _vm.quartaPeriodo1 !== 'Não informado') ? _c('span', [_vm._v(" | " + _vm._s(_vm.quartaPeriodo2))]) : _vm._e()]), _vm._v(" "), _c('label', {
	    staticClass: "item-horarios-topic"
	  }, [_vm._v("\n              " + _vm._s(_vm.quintaPeriodo1) + "\n              "), (_vm.quintaPeriodo1 !== 'Aberto 24 horas' && _vm.quintaPeriodo1 !== 'Não informado') ? _c('span', [_vm._v(" | " + _vm._s(_vm.quintaPeriodo2))]) : _vm._e()]), _vm._v(" "), _c('label', {
	    staticClass: "item-horarios-topic"
	  }, [_vm._v("\n              " + _vm._s(_vm.sextaPeriodo1) + "\n              "), (_vm.sextaPeriodo1 !== 'Aberto 24 horas' && _vm.sextaPeriodo1 !== 'Não informado') ? _c('span', [_vm._v(" | " + _vm._s(_vm.sextaPeriodo2))]) : _vm._e()]), _vm._v(" "), _c('label', {
	    staticClass: "item-horarios-topic"
	  }, [_vm._v("\n              " + _vm._s(_vm.sabadoPeriodo1) + "\n              "), (_vm.sabadoPeriodo1 !== 'Aberto 24 horas' && _vm.sabadoPeriodo1 !== 'Não informado') ? _c('span', [_vm._v(" | " + _vm._s(_vm.sabadoPeriodo2))]) : _vm._e()]), _vm._v(" "), _c('label', {
	    staticClass: "item-horarios-topic"
	  }, [_vm._v("\n              " + _vm._s(_vm.domingoPeriodo1) + "\n              "), (_vm.domingoPeriodo1 !== 'Aberto 24 horas' && _vm.domingoPeriodo1 !== 'Não informado') ? _c('span', [_vm._v(" | " + _vm._s(_vm.domingoPeriodo2))]) : _vm._e()]), _vm._v(" "), _c('label', {
	    staticClass: "item-horarios-topic"
	  }, [_vm._v("\n              " + _vm._s(_vm.feriadoPeriodo1) + "\n              "), (_vm.feriadoPeriodo1 !== 'Aberto 24 horas' && _vm.feriadoPeriodo1 !== 'Não informado') ? _c('span', [_vm._v(" | " + _vm._s(_vm.feriadoPeriodo2))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer-horario"
	  })])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', [_vm._l((_vm.ArrayVehicles), function(element) {
	    return _c('div', {
	      attrs: {
	        "id": "card-container"
	      }
	    }, [_c('div', {
	      attrs: {
	        "id": "info-container"
	      }
	    }, [_c('div', {
	      attrs: {
	        "id": "car-info-container"
	      }
	    }, [_c('div', {
	      attrs: {
	        "id": "car-info-plate-container"
	      }
	    }, [_c('h2', {
	      attrs: {
	        "id": "car-info-plate"
	      }
	    }, [_vm._v("Placa")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.PlateFormat(element.plate)))])]), _vm._v(" "), _c('div', {
	      attrs: {
	        "id": "car-info-brand-container"
	      }
	    }, [_c('h2', {
	      staticClass: "car-info",
	      attrs: {
	        "id": "car-brand-info"
	      }
	    }, [_vm._v("Marca "), _c('span', [_vm._v(_vm._s(element.model.brand.name))])])])]), _vm._v(" "), _c('div', {
	      attrs: {
	        "id": "car-info-model-container"
	      }
	    }, [_c('h2', {
	      staticClass: "car-info",
	      attrs: {
	        "id": "model-info"
	      }
	    }, [_vm._v("Modelo "), _c('span', [_vm._v(_vm._s(element.model.name))])])])]), _vm._v(" "), _c('div', {
	      attrs: {
	        "id": "icon-container"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.removePlate(element.plate, element.model.name, element.model.brand.name)
	        }
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": __webpack_require__(1768),
	        "alt": ""
	      }
	    })])])
	  }), _vm._v(" "), (!_vm.formVisibility) ? _c('button', {
	    attrs: {
	      "id": "button-add-vehicles"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('OpenForm')
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1767),
	      "alt": "icon-add-vehicles"
	    }
	  }), _vm._v("\n        Adicionar novo veículo\n    ")]) : _vm._e(), _vm._v(" "), (_vm.modalConfirmVisibility) ? _c('form-modal', {
	    attrs: {
	      "plate": _vm.plate,
	      "brand": _vm.brandName,
	      "model": _vm.modelName,
	      "type": '1'
	    },
	    on: {
	      "ClickHandlerCancel": _vm.RemoveModal,
	      "ClickHandlerContinue": _vm.rmvPlate
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 2038 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("\n        Planos\n        "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Contrato " + _vm._s(_vm.contractId) + "\n        "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Passagens Pendentes\n      ")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })], 1)]), _vm._v(" "), (_vm.contract.status.contractStatusId == 5) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('h3', {
	    staticClass: "alert-title"
	  }, [_vm._v("Contrato bloqueado!")]), _vm._v("\n    Seu contrato foi bloqueado, pois você possuí pagamentos pendentes, após 15 dias da data do bloqueio seu contrato será cancelado. Para que não ocorra o cancelamento do contrato, efetue o reprocessamento dos pagamentos pendentes.\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "margin-t20 table-white-header",
	    staticStyle: {
	      "min-height": "100px"
	    }
	  }, [(_vm.messageError) ? _c('div', {
	    staticClass: "alert alert-warning",
	    staticStyle: {
	      "margin-bottom": "10px"
	    },
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._v(_vm._s(_vm.messageError))]) : _vm._e(), _vm._v(" "), _c('table', {
	    staticClass: "table stripped-odd no-footer",
	    attrs: {
	      "role": "grid"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.orders), function(order, index) {
	    return _c('detail-order', {
	      key: order.orderId,
	      attrs: {
	        "order": order
	      }
	    })
	  }), 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('button', {
	    staticClass: "btn btn-success margin-t20 pull-right",
	    on: {
	      "click": function($event) {
	        _vm.showModal = true
	      }
	    }
	  }, [_vm._v("\n              Reprocessar\n              "), _c('i', {
	    staticClass: "icon-coin align-icon-right"
	  })])])])])]), _vm._v(" "), (_vm.showModal) ? _c('reprocess', {
	    attrs: {
	      "contractId": _vm.contractId,
	      "orderId": _vm.allOrderIds
	    },
	    on: {
	      "close": function($event) {
	        _vm.showModal = false
	      },
	      "reprocessConfirmed": _vm.loadData
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "vertical-center",
	    attrs: {
	      "width": "10%"
	    }
	  }, [_vm._v("N° Pedido")]), _vm._v(" "), _c('th', {
	    staticClass: "vertical-center",
	    attrs: {
	      "width": "18%"
	    }
	  }, [_vm._v("Solicitação do Pedido")]), _vm._v(" "), _c('th', {
	    staticClass: "vertical-center",
	    attrs: {
	      "width": "22%"
	    }
	  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
	    staticClass: "vertical-center",
	    attrs: {
	      "width": "35%"
	    }
	  }, [_vm._v("Tipo de Compra")]), _vm._v(" "), _c('th', {
	    staticClass: "vertical-center text-right",
	    attrs: {
	      "width": "10%"
	    }
	  }, [_vm._v("Valor em R$")]), _vm._v(" "), _c('th')])])
	}]}

/***/ }),
/* 2039 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("\n        Planos\n        "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Contrato " + _vm._s(_vm.contractId) + "\n        "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Agregadores\n      ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "header-action"
	  }, [_c('div', {
	    staticClass: "form-group search"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.plate),
	      expression: "plate",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "mask-plate",
	      rawName: "v-mask-plate"
	    }],
	    staticClass: "form-control upper",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "value": "",
	      "data-vv-validate-on": "blur",
	      "autofocus": "autofocus",
	      "placeholder": "Buscar por placa"
	    },
	    domProps: {
	      "value": (_vm.plate)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.search.apply(null, arguments)
	      },
	      "change": function($event) {
	        _vm.plate = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "icon-search-input",
	    on: {
	      "click": _vm.search
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 col-sm-6"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-square",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.modalAggregate()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-plus"
	  }), _vm._v("\n        Cadastrar Agregador\n      ")])])]), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
	    staticClass: "alert alert-warning margin-t20"
	  }, [_vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.data && _vm.data.length > 0) ? _c('div', {}, [_c('table', {
	    staticClass: "table table-flat"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.data), function(vehicle, index) {
	    return _c('tr', {
	      key: index
	    }, [_c('td', {
	      staticClass: "text-center bold"
	    }, [_vm._v(_vm._s(vehicle.plate))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(vehicle.tagSerialNumber == 0 ? '' : vehicle.tagSerialNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(vehicle.modelName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(vehicle.categoryAxesName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(vehicle.brandName))]), _vm._v(" "), _c('td', {
	      staticClass: "ico-info text-center"
	    }, [(vehicle.reason == 'Desbloqueado') ? _c('i', {
	      staticClass: "icomoon-truck-ok text-center"
	    }) : (vehicle.reason == 'Temporariamente') ? _c('i', {
	      staticClass: "icomoon-truck-block text-center"
	    }) : [_vm._v(_vm._s(vehicle.reason))]], 2), _vm._v(" "), _c('td', {
	      staticClass: "text-right"
	    }, [_c('div', {
	      staticClass: "dropdown drop-actions"
	    }, [_vm._m(1, true), _vm._v(" "), _c('ul', {
	      staticClass: "dropdown-menu",
	      attrs: {
	        "aria-labelledby": ""
	      }
	    }, [(vehicle.tagSerialNumber) ? _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.typeAggregate = 'replace';
	          _vm.showBlockModal(vehicle)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "icon-sync"
	    }), _vm._v("\n                    Substituir TAG\n                  ")])]) : _vm._e(), _vm._v(" "), _c('li', [(!_vm.showUnblock(vehicle)) ? _c('a', {
	      attrs: {
	        "data-toggle": "tooltip",
	        "title": "Bloquear veículo temporariamente"
	      },
	      on: {
	        "click": function($event) {
	          _vm.typeAggregate = 'block';
	          _vm.showBlockModal(vehicle)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "icomoon-blocked"
	    }), _vm._v("\n                    Bloquear veículo\n                  ")]) : _vm._e()]), _vm._v(" "), _c('li', [(_vm.showUnblock(vehicle)) ? _c('a', {
	      attrs: {
	        "data-toggle": "tooltip",
	        "title": "Bloquear veículo temporariamente"
	      },
	      on: {
	        "click": function($event) {
	          _vm.typeAggregate = 'unblock';
	          _vm.showBlockModal(vehicle)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "icomoon-blocked"
	    }), _vm._v("\n                    Desbloquear veículo\n                  ")]) : _vm._e()]), _vm._v(" "), _c('li', [_c('a', {
	      attrs: {
	        "data-toggle": "tooltip",
	        "title": "Excluir veículo"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showDeleteModal(vehicle)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "icomoon-delete"
	    }), _vm._v("\n                    Excluir veículo\n                  ")])])])])])])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.data && _vm.data.length > 0) ? _c('div', [_c('div', {
	    staticStyle: {
	      "display": "flex",
	      "justify-content": "space-between",
	      "align-items": "center"
	    }
	  }, [_c('div', {
	    staticClass: "result-table-count"
	  }, [_vm._v("\n        Mostrando resultados de " + _vm._s(_vm.page.firstIndexShown()) + " a " + _vm._s(_vm.page.lastIndexShown()) + " de um total de " + _vm._s(_vm.page.itemCount()) + "\n        encontrados.\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "row results"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('router-link', {
	    staticClass: "btn no-btn btn-square margin-10",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button"
	    }
	  }, [_vm._v("\n          Voltar\n        ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 text-center"
	  }, [_c('pagination', {
	    attrs: {
	      "model": _vm.page
	    },
	    on: {
	      "page-change": _vm.setCurrentPage
	    }
	  }), _vm._v(" "), _c('router-link', {
	    staticClass: "btn no-btn btn-square margin-10",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button"
	    }
	  }, [_vm._v("\n          Voltar\n        ")])], 1)])]) : _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('router-link', {
	    staticClass: "btn no-btn btn-square margin-10",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button"
	    }
	  }, [_vm._v("\n        Voltar\n      ")])], 1)]), _vm._v(" "), (_vm.showModalAggregate) ? _c('modal-aggregate', {
	    attrs: {
	      "contractAggregate": _vm.contractAggregate
	    },
	    on: {
	      "close": _vm.close
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.vehicleToBlock) ? _c('modal-block-vehicle', {
	    attrs: {
	      "vpSelected": _vm.vpSelected,
	      "type": _vm.typeAggregate
	    },
	    on: {
	      "close": _vm.close
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "width": "10%"
	    }
	  }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "width": "10%"
	    }
	  }, [_vm._v("TAG N°")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "25%"
	    }
	  }, [_vm._v("Modelo")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Eixos")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "13%"
	    }
	  }, [_vm._v("Marca")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "width": "12%"
	    }
	  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
	    staticClass: "text-right",
	    attrs: {
	      "width": "5%"
	    }
	  }, [_vm._v("Ações")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "no-btn",
	    attrs: {
	      "id": "",
	      "type": "button",
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/icon-actions.svg",
	      "alt": ""
	    }
	  })])
	}]}

/***/ }),
/* 2040 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.type == '1') ? _c('b2c', {
	    attrs: {
	      "type": 'newContract'
	    }
	  }) : _c('b2b', {
	    attrs: {
	      "type": 'newContract'
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2041 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "container-fluid"
	  }, [_c('div', {
	    staticClass: "header-action"
	  }, [_c('div', {
	    staticClass: "form-group search"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "content-grey"
	  }, [_c('p', {
	    staticClass: "bold no-margin"
	  }, [_vm._v("Validade")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row-dates"
	  }, [_c('div', {
	    staticClass: "form-group col-6"
	  }, [_c('label', {
	    attrs: {
	      "for": "dataInicioViagem"
	    }
	  }, [_vm._v("Início da viagem")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dataInicioViagem),
	      expression: "dataInicioViagem"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "name": "dataInicioViagem",
	      "type": "datetime-local",
	      "min": _vm.minDate,
	      "max": _vm.dataFimViagem,
	      "placeholder": "YYYY-MM-DDTHH:MM"
	    },
	    domProps: {
	      "value": (_vm.dataInicioViagem)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.dataInicioViagem = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group  col-6"
	  }, [_c('label', {
	    attrs: {
	      "for": "dataFimViagem"
	    }
	  }, [_vm._v("Fim da viagem")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dataFimViagem),
	      expression: "dataFimViagem"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "name": "dataFimViagem",
	      "type": "datetime-local",
	      "min": _vm.dataInicioViagem,
	      "max": _vm.maxDate,
	      "placeholder": "YYYY-MM-DDTHH:MM"
	    },
	    domProps: {
	      "value": (_vm.dataFimViagem)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.dataFimViagem = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "form-group search"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search),
	      expression: "search"
	    }],
	    staticClass: "form-control upper",
	    attrs: {
	      "placeholder": "Informe o nome da rota",
	      "type": "text",
	      "name": "search-route"
	    },
	    domProps: {
	      "value": (_vm.search)
	    },
	    on: {
	      "keypress": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.searchRoutes.apply(null, arguments)
	      },
	      "keyup": _vm.filter,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.search = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "icon-search-input",
	    on: {
	      "click": _vm.searchRoutes
	    }
	  })])])])])]), _vm._v(" "), (_vm.showAlert && !_vm.routeSelected) ? _c('div', {
	    staticClass: "content-box margin-b20"
	  }, [_c('div', {
	    staticClass: "alert alert-info alert-container",
	    class: _vm.warning && 'alert-warning'
	  }, [_c('p', {
	    staticClass: "no-margin"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.msgStrong))]), _vm._v("\n          " + _vm._s(_vm.msgAlert) + "\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showAlert = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-cross icon-close-modal",
	    class: _vm.warning && 'icon-warning'
	  })])])]) : _vm._e(), _vm._v(" "), (_vm.routes && _vm.routes.length > 0 || _vm.routeSelected) ? _c('div', {
	    staticClass: "content-box-npadd table-responsive"
	  }, [_c('table', {
	    staticClass: "table"
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.routesPaged), function(r) {
	    return _c('tr', {
	      key: r.routeId
	    }, [_c('td', [_c('div', {
	      staticClass: "methods-rbox"
	    }, [_c('div', {
	      staticClass: "radio-blue category"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.routeSelected),
	        expression: "routeSelected"
	      }],
	      staticClass: "radiobtn",
	      attrs: {
	        "id": r.routeId,
	        "type": "radio",
	        "name": "radio"
	      },
	      domProps: {
	        "value": r.routeId,
	        "checked": _vm._q(_vm.routeSelected, r.routeId)
	      },
	      on: {
	        "change": function($event) {
	          _vm.routeSelected = r.routeId
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      staticClass: "radio-label label-h4",
	      attrs: {
	        "for": r.routeId
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "check first"
	    })])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r.name) + " - v." + _vm._s(r.version))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getAddress(r, 'origin')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getAddress(r, 'destination')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r.totalDistance) + " KM")]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(r.tollFees.length))])])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.routesPaged != undefined && _vm.routesPaged.length != 0) ? [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 text-center"
	  }, [_c('pagination', {
	    attrs: {
	      "model": _vm.page
	    },
	    on: {
	      "page-change": _vm.setCurrentPage
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 result-table-count text-center"
	  }, [_vm._v("\n          Mostrando resultados de " + _vm._s(_vm.page.firstIndexShown()) + " a " + _vm._s(_vm.page.lastIndexShown()) + " de um total de " + _vm._s(_vm.page.itemCount()) + " encontrados.\n        ")])])] : _vm._e(), _vm._v(" "), (_vm.aggregate) ? _c('div', {
	    staticClass: "content-box-rounded desk margin-t50"
	  }, [_c('table', {
	    staticClass: "table"
	  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.aggregate.companyName))]), _vm._v(" "), _c('td', {
	    staticClass: "text-center"
	  }, [_vm._v(_vm._s(_vm.aggregate.plate))]), _vm._v(" "), _c('td', {
	    staticClass: "text-center"
	  }, [_vm._v(_vm._s(_vm.aggregate.tagSerialNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.aggregate.category))])])])])]) : _vm._e(), _vm._v(" "), (_vm.aggregate) ? _c('div', {
	    staticClass: "content-box-rounded mob"
	  }, [(_vm.aggregate.companyName) ? _c('p', [_vm._v(_vm._s(_vm.aggregate.companyName))]) : _c('p', [_vm._v(_vm._s(_vm.aggregate.personName + ' ' + _vm.aggregate.personLastName))]), _vm._v(" "), _c('div', {}, [_c('p', [_c('span', {
	    staticClass: "bold-600"
	  }, [_vm._v("Placa")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "mask-plate",
	      rawName: "v-mask-plate"
	    }]
	  }, [_vm._v(_vm._s(_vm.aggregate.plate))])]), _vm._v(" "), _c('p', [_c('span', {
	    staticClass: "bold-600"
	  }, [_vm._v("TAG Nº")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.aggregate.tagSerialNumber) + "\n        ")]), _vm._v(" "), _c('p', [_c('span', {
	    staticClass: "bold-600"
	  }, [_vm._v("Eixos")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.aggregate.category) + "\n        ")])])]) : _vm._e()], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('b', [_c('i', {
	    staticClass: "icon-info",
	    attrs: {
	      "data-toggle": "tooltip",
	      "data-placement": "bottom",
	      "title": "A validade é o período em dias que o transportador terá para realizar a viagem."
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Rota")]), _vm._v(" "), _c('th', [_vm._v("Origem")]), _vm._v(" "), _c('th', [_vm._v("Destino")]), _vm._v(" "), _c('th', [_vm._v("Distância")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center"
	  }, [_vm._v("Pedágios")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Agregador")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center"
	  }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center"
	  }, [_vm._v("TAG N°")]), _vm._v(" "), _c('th', [_vm._v("Eixos")])])])
	}]}

/***/ }),
/* 2042 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('success-page', {
	    attrs: {
	      "code": 0,
	      "boletoUrl": null,
	      "type": 'newVehicle',
	      "novoCartao": true,
	      "salesOrder": _vm.order
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2043 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("\n        Identificação \n        "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" "), (_vm.type == 'reset') ? [_vm._v("Esqueci minha senha")] : _vm._e(), _vm._v(" "), (_vm.type == 'desbloqueioConta') ? [_vm._v("Desbloqueio de conta")] : _vm._e(), _vm._v(" "), (_vm.type == 'login') ? [_vm._v("Autenticação de 2 fatores")] : _vm._e()], 2), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), (_vm.type == 'reset') ? _c('p', [_vm._v("Informe seu "), _c('b', [_vm._v("telefone celular")]), _vm._v(" ou "), _c('b', [_vm._v("e-mail")]), _vm._v(" cadastrado em sua conta para redefinir a senha.")]) : _vm._e(), _vm._v(" "), (_vm.type == 'login') ? _c('div', [_c('p', [_vm._v("Escolha um dos canais para receber o código de autenticação.")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "row border-row row-fix"
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "content-box-small margin-t80"
	  }, [(_vm.formState == 'ERROR') ? _c('div', {
	    staticClass: "alert alert-danger alert-dismissible margin-t20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Erro: ")]), _vm._v("\n              " + _vm._s(_vm.errorMessage) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'SUCCESS') ? _c('div', {
	    staticClass: "alert alert-success alert-dismissible margin-t20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Sucesso!")]), _vm._v(" "), _vm._v("\n              As orientações para redefinir sua senha foram enviadas para o e-mail ou telefone cadastrado.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'NEW' || _vm.formState == 'ERROR') ? _c('form', {
	    attrs: {
	      "autocomplete": "false"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.doRequest.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "chooseChannel"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.channelSelected),
	      expression: "channelSelected"
	    }],
	    attrs: {
	      "id": "chooseEmailId",
	      "type": "radio",
	      "value": "email",
	      "name": "chooseChannelForm"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.channelSelected, "email")
	    },
	    on: {
	      "change": function($event) {
	        _vm.channelSelected = "email"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "chooseEmailId"
	    }
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.channelSelected),
	      expression: "channelSelected"
	    }],
	    attrs: {
	      "id": "chooseCellphoneId",
	      "type": "radio",
	      "value": "cellphone",
	      "name": "chooseChannelForm"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.channelSelected, "cellphone")
	    },
	    on: {
	      "change": function($event) {
	        _vm.channelSelected = "cellphone"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "chooseCellphoneId"
	    }
	  }, [_vm._v("Celular")]), _vm._v(" "), (_vm.channelSelected == 'email') ? _c('div', {
	    staticClass: "form-group form-plate"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "email",
	      "name": "email",
	      "placeholder": "Digite seu E-mail"
	    },
	    domProps: {
	      "value": (_vm.email)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.doFilter(true)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.channelSelected == 'cellphone') ? _c('div', {
	    staticClass: "form-group form-plate"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cellphone),
	      expression: "cellphone"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "cellphone",
	      "placeholder": "Digite seu Telefone",
	      "maxlength": "13"
	    },
	    domProps: {
	      "value": (_vm.cellphone)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.doFilter(true)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.cellphone = $event.target.value
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-lg btn-purple",
	    attrs: {
	      "id": "btn-login",
	      "type": "submit",
	      "name": "button"
	    }
	  }, [_vm._v("\n                  Continuar\n                ")]), _vm._v(" "), _c('i', {
	    staticClass: "icon-circle-right align-icon"
	  })])]) : _vm._e()])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-back margin-t20",
	    attrs: {
	      "to": "/login",
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n        Voltar\n      ")])], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "circle-key"
	  })])
	}]}

/***/ }),
/* 2044 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('p', {
	    staticClass: "line-height-20 margin-t30"
	  }, [_vm._v("\n    Para recarregar é necessário informar um valor de recarga. O valor mínimo\n    por recarga é " + _vm._s(_vm._f("cents")(_vm.unit)) + ". Você pode\n    escolher quantos múltiplos de " + _vm._s(_vm._f("cents")(_vm.unit)) + " que quiser (quanto maior\n    o valor, menor será a taxa de recarga).\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "col-xs-12"
	  }, [_c('form', {
	    attrs: {
	      "id": "form-recarga",
	      "action": "index.html",
	      "method": "post",
	      "data-toggle": "validator"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.duplicityCheck.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "box margin-20 box-content-padding"
	  }, [_c('div', {
	    staticClass: "alert alert-danger text-center",
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "id": "error-recharge"
	    }
	  }), _vm._v(" "), _c('b', [_vm._v("Valor recarga")]), _vm._v(" "), (_vm.planId != 70 && _vm.planId != 71) ? _c('div', {
	    staticClass: "row margin-t5"
	  }, [_c('btn-recharge-value', {
	    staticClass: "small-padding-right",
	    attrs: {
	      "unit": 1,
	      "planId": _vm.planId
	    },
	    on: {
	      "increment": _vm.incrementTotal,
	      "valoresRecebidos": _vm.valoresRecebidos
	    }
	  }), _vm._v(" "), _c('btn-recharge-value', {
	    staticClass: "small-padding-right small-padding-left",
	    attrs: {
	      "unit": 2,
	      "planId": _vm.planId
	    },
	    on: {
	      "increment": _vm.incrementTotal,
	      "valoresRecebidos": _vm.valoresRecebidos
	    }
	  }), _vm._v(" "), _c('btn-recharge-value', {
	    staticClass: "small-padding-right small-padding-left",
	    attrs: {
	      "unit": 10,
	      "planId": _vm.planId
	    },
	    on: {
	      "increment": _vm.incrementTotal,
	      "valoresRecebidos": _vm.valoresRecebidos
	    }
	  }), _vm._v(" "), _c('btn-recharge-value', {
	    staticClass: "small-padding-left",
	    attrs: {
	      "unit": 20,
	      "planId": _vm.planId
	    },
	    on: {
	      "increment": _vm.incrementTotal,
	      "valoresRecebidos": _vm.valoresRecebidos
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.numeroDeVeiculos && (_vm.planId == 70 || _vm.planId == 71)) ? _c('div', {
	    staticClass: "row margin-t5"
	  }, [_c('btn-recharge-value', {
	    staticClass: "small-padding-right",
	    attrs: {
	      "unit": 1,
	      "roadCardUnit": _vm.numeroDeVeiculos,
	      "planId": _vm.planId
	    },
	    on: {
	      "increment": _vm.incrementTotal,
	      "valoresRecebidos": _vm.valoresRecebidos
	    }
	  }), _vm._v(" "), _c('btn-recharge-value', {
	    staticClass: "small-padding-right small-padding-left",
	    attrs: {
	      "unit": 2,
	      "roadCardUnit": _vm.numeroDeVeiculos,
	      "planId": _vm.planId
	    },
	    on: {
	      "increment": _vm.incrementTotal,
	      "valoresRecebidos": _vm.valoresRecebidos
	    }
	  }), _vm._v(" "), _c('btn-recharge-value', {
	    staticClass: "small-padding-right small-padding-left",
	    attrs: {
	      "unit": 10,
	      "planId": _vm.planId,
	      "roadCardUnit": _vm.numeroDeVeiculos
	    },
	    on: {
	      "increment": _vm.incrementTotal,
	      "valoresRecebidos": _vm.valoresRecebidos
	    }
	  }), _vm._v(" "), _c('btn-recharge-value', {
	    staticClass: "small-padding-left",
	    attrs: {
	      "unit": 20,
	      "roadCardUnit": _vm.numeroDeVeiculos,
	      "planId": _vm.planId
	    },
	    on: {
	      "increment": _vm.incrementTotal,
	      "valoresRecebidos": _vm.valoresRecebidos
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20"
	  }, [_c('div', {
	    staticClass: "form-group col-xs-12",
	    class: {
	      'has-error': _vm.errors.has('valueTotal')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|valorRecarga:' + _vm.unit),
	      expression: "'required|valorRecarga:' + unit"
	    }],
	    staticClass: "form-control text-right input-recharge",
	    attrs: {
	      "id": "valueTotal",
	      "type": "text",
	      "name": "valueTotal",
	      "placeholder": "R$ 00,00",
	      "spellcheck": "false",
	      "autocomplete": "off",
	      "autocorrect": "off",
	      "autocapitalize": "off"
	    },
	    domProps: {
	      "value": _vm.valueFormatted
	    },
	    on: {
	      "input": function($event) {
	        return _vm.setTotal($event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
	    staticClass: "errorMessage"
	  }, [_c('span', {
	    staticClass: "mensagem"
	  }, [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "help-block help-block-recharge with-errors"
	  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("valueTotal")) + "\n              ")])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loadingRates),
	      expression: "loadingRates"
	    }],
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "recharge-summary-box"
	  }, [_c('p', [_vm._v("\n                  Valor da taxa"), _c('span', {
	    staticClass: "rate-value pull-right bold"
	  }, [_vm._v(_vm._s(_vm.tax))])]), _vm._v(" "), _c('hr', {
	    staticClass: "hr-rule"
	  }), _vm._v(" "), _c('p', [_vm._v("\n                  Valor total"), _c('span', {
	    staticClass: "total-value pull-right bold"
	  }, [_vm._v(_vm._s(_vm.total))])])]), _vm._v(" "), _vm._m(0)])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "payment-info margin-b20"
	  }, [_c('small', [_vm._v("Esse valor que será debitado uma única vez na sua conta\n                  corrente, cartão de crédito ou no pagamento do boleto\n                  bancário.")])])
	}]}

/***/ }),
/* 2045 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "fade-in",
	      "appear": ""
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostrarModal),
	      expression: "mostrarModal"
	    }],
	    staticClass: "modal fade-in",
	    staticStyle: {
	      "z-index": "99999"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('span', {
	    staticClass: "close",
	    staticStyle: {
	      "position": "absolute",
	      "top": "10px",
	      "right": "10px"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.fecharModal()
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
	    staticClass: "header-content"
	  }, [_c('h2', [_vm._v("Mudança para padrão Mercosul")])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    staticClass: "information-container"
	  }, [_c('p', {
	    staticClass: "infoModal"
	  }, [_vm._v("\n            Não foi possível realizar a mudança do padrão da placa no momento!\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "close-button",
	    on: {
	      "click": function($event) {
	        return _vm.fecharModal()
	      }
	    }
	  }, [_vm._v("Fechar")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2046 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row margin-b30"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Não, devido nossos planos serem pré-pagos, é necessário somente o pagamento de adesão e recarga.\n                Para saber mais sobre nossa tabela de recargas e tarifas, acesse:\n                "), _c('router-link', {
	    staticClass: "link",
	    attrs: {
	      "to": {
	        name: 'services'
	      },
	      "tag": "a"
	    }
	  }, [_vm._v("\n                  Recargas\n                ")])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Estamos presentes em 100% dos Estados com vias pedagiadas do Brasil. Para consultar a cobertura completa da Move Mais, acesse:\n                "), _c('router-link', {
	    staticClass: "link",
	    attrs: {
	      "to": {
	        name: 'range'
	      },
	      "tag": "a"
	    }
	  }, [_vm._v("\n                  Cobertura\n                ")])], 1)])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10)])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
	    staticClass: "row margin-b30"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_vm._m(21), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Para Pessoa Física as recargas são múltiplas de R$50,00, enquanto que para Pessoa Jurídica,\n                os valores são múltiplos de R$ 500,00. Para verificar as formas de pagamento por plano, acesse:\n                "), _c('router-link', {
	    staticClass: "link",
	    attrs: {
	      "to": {
	        name: 'services'
	      },
	      "tag": "a"
	    }
	  }, [_vm._v("\n                  Serviços\n                ")])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_vm._m(22), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Nos planos Pré-Pagos você recarrega sua conta Move Mais quando achar conveniente. A recarga pode ser\n                feita a qualquer momento, através do site Move Mais ou pelo App. A recarga será disponibilizada em\n                até 30 minutos em sua conta Move Mais. Para verificar a tabela de recarga, acesse:\n                "), _c('router-link', {
	    staticClass: "link",
	    attrs: {
	      "to": {
	        name: 'services'
	      },
	      "tag": "a"
	    }
	  }, [_vm._v("\n                  Serviços\n                ")])], 1)])]), _vm._v(" "), _vm._m(23)])]), _vm._v(" "), _vm._m(24)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("F.A.Q. (Perguntas Frequentes)")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n          Confira aqui as as respostas das perguntas mais frequentes:\n        ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "plan-line-purple margin-b20"
	  }, [_c('p', {
	    staticClass: "bold upper"
	  }, [_vm._v("adesão")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Sou Pessoa física, existe cobrança de mensalidade?\n            ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Onde posso usar a Move Mais? Em qual cidade ou estado?\n            ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Quais são as vantagens que a Move Mais oferece?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Mais que um Sistema de Pagamento Automático de Pedágios, a Move Mais oferece um conjunto de serviços que\n                facilita a relação com o seu carro, onde você estiver. Através do Portal Move Mais ou do aplicativo para\n                smartphones (Android e IOS), você pode usufruir de todos os serviços que a Move Mais oferece, consultar o histórico\n                das passagens e transações, gerenciar sua conta e consultar seu saldo a qualquer hora e em qualquer lugar. Sem se\n                preocupar com mensalidades ou fidelidade, você escolhe um dos Planos Pré-pagos: Pré-pago Manual ou Pré-pago\n                Automático. E escolhe também um Valor de Recarga disponível. E contando sempre com a Central de Relacionamento,\n                "), _c('strong', [_vm._v("24 horas por dia e 7 dias por semana")]), _vm._v(".\n              ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Quais as formas de pagamento disponíveis?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Para os Planos Pré-pagos a forma de pagamento disponível é com cartão de crédito.\n              ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              O meu saldo expira?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Não expira e o saldo fica disponível em sua conta por tempo indeterminado ou até a próxima viagem.\n              ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Como eu sei a categoria do meu veículo?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                A categoria do veículo é definida pela quantidade de eixos que ele possui. Por exemplo, veículos com dois\n                eixos de rodagem simples (passeio e utilitários) correspondem à categoria 1, veículos com dois eixos de rodagem\n                dupla correspondem à categoria 2, veículos com três eixos de rodagem dupla correspondem à categoria 3, e assim por\n                diante. A categoria do seu veículo pode ser encontrada no documento CRLV. Para consultar as categorias completa de veículos, acesse:\n                "), _c('span', [_c('a', {
	    staticClass: "link",
	    attrs: {
	      "href": "/api/v2/archeion/downloadFileArcheion/categoria-veiculos",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tCategorias\n\t\t\t\t\t\t\t\t")])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              O TAG poderá ser usada para verificar outros dados (velocidade e/ou documentação do veículo) para aplicação de multas?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Não, o TAG é exclusiva para identificação e pagamento nas praças de pedágio conveniados à Move Mais.\n              ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Existe limite de veículos por contrato?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Não temos limite mínimo, sempre que você quiser pode adicionar outros veículos em um só contrato.\n                Além disso, na Move Mais você pode ter vários contratos em seu nome, com opções de planos e veículos diferentes em cada um deles.\n              ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Na Move Mais existe cláusula de fidelidade?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Não, em nossos planos Pré-pagos não existe cláusula de fidelidade, dando autonomia para encerrar o contrato quando preferir.\n              ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row margin-b30"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "plan-line-blue margin-b20"
	  }, [_c('p', {
	    staticClass: "bold upper"
	  }, [_vm._v("tag")])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Recebi meu TAG. O que fazer?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                O TAG é enviado bloqueada por motivo de segurança, neste caso basta acessar o site movemais.com\n                realizar a ativação ou entrar em contato através dos telefones 4000 2901 (Capitais e Regiões Metropolitanas)\n                e 0800 777 1022 (Demais Localidades). É de suma importância que o TAG seja desbloqueado para fazer o uso.\n                Após a ativação a concessionária tem o prazo de até 6h para atualização de lista.\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Vendi meu veículo. O que devo fazer?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Devido o TAG ser intransferível é necessário realizar a solicitação de cancelamento do veículo através\n                do e-mail : "), _c('a', {
	    attrs: {
	      "href": "mailto:relacionamento@movemais.com"
	    }
	  }, [_vm._v("relacionamento@movemais.com")]), _vm._v(", informando o motivo, a placa e o CPF.\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Como eu faço se meu veículo for roubado?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Entre em contato com a Central de Relacionamento Move Mais. Solicite o bloqueio de seu TAG ou realize o\n                bloqueio direto pela sua conta Move Mais, acessando a Área "), _c('strong', [_vm._v("\"Ver Veículos\"")]), _vm._v(". Caso preferir, temos outras formas de\n                contato. Pelos telefones 4000 2901 (Capitais e Regiões Metropolitanas) e 0800 777 1022 (Demais Localidades) ou e-mail:\n                "), _c('a', {
	    attrs: {
	      "href": "mailto:relacionamento@movemais.com"
	    }
	  }, [_vm._v("relacionamento@movemais.com")]), _vm._v(".\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Tenho dois equipamentos instalados no meu veículo (Move Mais e outro). Isso pode causar problema na\n              leitura dos TAGs ou confusão nos sistemas de captação do sinal?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                O sinal será captado por todos os leitores e o usuário deve ser cobrado em apenas um sistema.\n                O sistema da concessionária irá atribuir a cobrança ao TAG que foi lido primeiro e descartará a\n                leitura do segundo aparelho.\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Após recarregar o TAG bloqueado por insuficiência de saldo, já posso voltar a utilizar normalmente ou é preciso esperar algum período para utilização?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Após recarregar o TAG bloqueado por insuficiência de saldo, você precisará aguardar o tempo de processamento\n                de acordo com cada instituição bancária. Após a confirmação do pagamento, o crédito é disponibilizado na sua conta\n                Move Mais e estará liberado para uso nos pedágios. O prazo é de até "), _c('strong', [_vm._v("6 horas")]), _vm._v(", tempo necessário para atualização nas concessionárias.\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Meu TAG esta descolando. O que fazer?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Neste caso entre em contato através do e-mail "), _c('a', {
	    attrs: {
	      "href": "mailto:relacionamento@movemais.com"
	    }
	  }, [_vm._v("relacionamento@movemais.com")]), _vm._v(" enviando uma "), _c('strong', [_vm._v("foto")]), _vm._v(" do TAG,\n                informando o número da placa do veículo e o CPF.\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Solicitei o cancelamento do meu TAG mas tenho saldo. O que acontece com o saldo?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                O saldo disponível fica vinculado ao seu contrato e não ao TAG, sendo assim compartilhado entre os veículos cadastrados.\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Troquei de veículo, posso usar o mesmo TAG?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Não! Nesse caso, você precisa realizar uma nova adesão em seu contrato, pois o TAG é intransferível.\n                Essa adesão é realizada em nosso site, acesse: "), _c('strong', [_vm._v("\"Minha Conta\"")]), _vm._v(" e na área de "), _c('strong', [_vm._v("\"Planos”")]), _vm._v("\n                clique em "), _c('strong', [_vm._v("\"Adicionar veículo\"")]), _vm._v(", para incluir o novo veículo em seu contrato.\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Alterei minha placa para o modelo Mercosul. O que devo fazer?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Entre imediatamente em contato com a Move Mais, através do e-mail "), _c('a', {
	    attrs: {
	      "href": "mailto:relacionamento@movemais.com"
	    }
	  }, [_vm._v("relacionamento@movemais.com")]), _vm._v(",\n                solicitando alteração da placa antiga e enviando o documento do veículo atualizado, junto com o CPF.\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Como adicionar um novo veículo?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Basta acessar sua conta da Move Mais e clicar na opção "), _c('strong', [_vm._v("\"Adicionar Veículos\"")]), _vm._v(" e realizar a adesão.\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Caso a cancela não abra o que devo fazer?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Deverá entrar em contato com a Central de Relacionamento através dos telefones 4000 2901 (Capitais e Regiões Metropolitanas)\n                e 0800 777 1022 (Demais Localidades), informando o ocorrido. Será analisado o motivo da não abertura automática da cancela.\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              O Sistema de leitura dos TAGs pode ficar comprometido em dias de trânsito intenso?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Não! A funcionalidade de leitura do seu TAG não será comprometida com volume maior ou menor de veículos.\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Em caso de problemas com o TAG, o que devo fazer para substituí-lo?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Se seu TAG apresentar algum problema de leitura, você poderá solicitar uma análise à Central de Relacionamento\n                através do e-mail "), _c('a', {
	    attrs: {
	      "href": "mailto:relacionamento@movemais.com"
	    }
	  }, [_vm._v("relacionamento@movemais.com")]), _vm._v(" ou pelos telefones 4000 2901 (Capitais e Regiões Metropolitanas) e\n                0800 777 1022 (Demais Localidades). Se for confirmada a falha, você será orientado sobre o procedimento de troca.\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              O TAG pode ser removido e utilizado em outro veículo?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Não! O TAG é intransferível pois é vinculado a placa, caso for removido o mesmo ficará inutilizável.\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              O que acontece se eu não instalar o TAG no para-brisa do carro e usá-lo na mão quando estiver passando na cancela?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                O TAG possui um mecanismo de segurança que o inutiliza em caso de remoção ou tentativa de remoção do para-brisa.\n                Se for removido, é necessário adquirir um novo TAG. Se o TAG for utilizado de forma indevida (na mão, sem instalar no para-brisa),\n                o sistema identifica essa prática por meio de fotografias tiradas nas praças de pedágio e bloqueia a sua utilização,\n                fazendo assim com que a cancela não abra. Além disso, o cliente estará sujeito à multa por uso indevido do TAG.\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Em quais situações o TAG poderá ser bloqueado?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                O TAG poderá ser bloqueado em caso de uso indevido, insuficiência de saldo ou nos casos de perda, roubo ou extravio.\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Assim que ativar o TAG já posso passar pelo pedágio?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Não! Após o TAG ser ativado no sistema, é necessário aguardar um prazo de até "), _c('strong', [_vm._v("6 horas")]), _vm._v(" para poder\n                utilizar as praças de pedágios, pois as mesmas têm este prazo para consumirem as listas com as informações atuais do seu veículo.\n              ")])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "plan-line-red margin-b20"
	  }, [_c('p', {
	    staticClass: "bold upper"
	  }, [_vm._v("cobrança")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Caso meu veículo seja guinchado o que fazer?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Trabalhamos com as seguintes situações. "), _c('strong', [_vm._v("Guincho particular:")]), _vm._v(" caso o mesmo possua TAG, será atribuída a tarifa do pedágio ao mesmo.\n                "), _c('strong', [_vm._v("Guincho da concessionária:")]), _vm._v(" nesse caso é isento de tarifa pela ARTESP (Agência de Transporte do Estado de SP). A tarifa de\n                pedágio será cobrada pelo veículo. "), _c('strong', [_vm._v("Caso ambos os veículos possuirem TAG:")]), _vm._v(" nessa situação é necessário o cliente realizar\n                o bloqueio temporário antes da viagem, através de sua conta Move Mais ou via Central de Relacionamento. Não havendo bloqueio\n                temporário, a concessionária informa que a cobrança deve ser acordada entre o usuário e o Guincho. Caso haja o débito em ambos\n                os veículos, guincho e em seu TAG, será necessário o envio da solicitação de contestação, sendo analisado junto a concessionária.\n              ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              O que fazer se eu receber uma multa por evasão?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Entrar em contato com a Central de Relacionamento através do e-mail "), _c('a', {
	    attrs: {
	      "href": "mailto:relacionamento@movemais.com"
	    }
	  }, [_vm._v("relacionamento@movemais.com")]), _vm._v("\n                enviando uma cópia da autuação para analisarmos se a mesma será procedente ou improcedente.\n              ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Para caso de débito automático em conta, o titular deverá ser o mesmo que cadastrado na Move Mais?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Sim, o titular da conta corrente deve ser o mesmo da conta Move Mais.\n              ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Para caso de pagamento com Cartão de Crédito, o titular deverá ser o mesmo que cadastrado na Move Mais?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                O titular do cartão de crédito não precisa ser o mesmo cadastrado na Move Mais.\n              ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Tenho alguns veículos com TAG Move Mais. É possível recarregá-los separadamente?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Para facilitar a sua vida, aqui na Move Mais a recarga é feita por contrato e não por veículo cadastrado.\n                Assim, se você possui mais de um veículo no mesmo contrato, não precisa ficar se preocupando em fazer\n                recargas para cada um deles separadamente, pois os veículos desse contrato compartilham da recarga efetuada.\n                Para os casos em que o cliente desejar recarregar seus veículos de forma separada, é possível abrir novos\n                contratos e realizar recargas independentes para cada um deles.\n              ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Meu crédito é insuficiente e a viagem ainda não acabou. Como faço para recarregar créditos?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Você pode fazer a recarga através da sua contra acessando nosso site movemais.com ou através de nosso aplicativo.\n              ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Ao usar o serviço da Move Mais, eu pagarei a mesma tarifa praticada nos pedágios?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Sim, a tarifa é a mesma cobrada nos pedágios. Os valores são tabelados.\n              ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Se eu estiver inadimplente com o pagamento, serei bloqueado na passagem pelo pedágio? Ou serei multado por\n              evasão de pedágio?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Sim, será bloqueado. E, se não pagar o pedágio manualmente, será multado por evasão.\n              ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Quais são os valores disponíveis para recarga nos planos pré-pagos?\n            ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Nos planos Pré-pagos eu consigo colocar créditos do meu celular? O crédito é disponibilizado na hora?\n            ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              A Move Mais emite nota fiscal?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                A Move Mais é uma empresa de meios de pagamento eletrônico de pedágio, neste caso é feito a emissão apenas\n                de serviços prestados, no entanto a nota fiscal das passagens deve ser solicitada através das concessionárias\n                devido a mesma ser responsável pelas cobranças em seu TAG.\n              ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row margin-b30"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "plan-line-green margin-b20"
	  }, [_c('p', {
	    staticClass: "bold upper"
	  }, [_vm._v("serviços")])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Qual é a velocidade máxima nas praças de pedágio?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Para evitar acidentes e colisões nas praças de pedágio, respeite o limite de velocidade máxima\n                de "), _c('strong', [_vm._v("40 km/h")]), _vm._v(" sinalizado nas pistas de pedágio, sujeito à multa e pontos na carteira.\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              A Move Mais tem transferência de saldo? Como faço para transferir meu saldo?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Nesse caso, basta acessar sua conta através do site movemais.com, e clicar na opção "), _c('strong', [_vm._v("\"Transferir Saldo\"")]), _vm._v(".\n                À cada transferência é cobrado o valor de "), _c('strong', [_vm._v("2%")]), _vm._v(".\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Esqueci minha senha. E agora?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Basta entrar em contato com nossa Central de Relacionamento através dos telefones: 4000 2901 (Capitais e Regiões Metropolitanas)\n                e 0800 777 1022 (Demais Localidades). Enviaremos uma recuperação através do e-mail cadastrado.\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              A Move Mais tem uma cabine específica para passagens nos pedágios?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Nas praças de pedágio você deve usar as pistas com cobranças automáticas, que estarão devidamente sinalizadas.\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Como faço para solicitar o cancelamento do meu plano Pré-pago?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                O cancelamento dos serviços Move Mais poderá ser feito através do e-mail "), _c('a', {
	    attrs: {
	      "href": "mailto:relacionamento@movemais.com"
	    }
	  }, [_vm._v("relacionamento@movemais.com")]), _vm._v(",\n                contendo CPF ou CNPJ, motivo do cancelamento e uma conta bancária de titularidade do cliente.\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Sou pessoa física, solicitei o cancelamento do contrato mas tenho saldo disponível. O que devo fazer?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Nesse caso, realizamos o "), _c('strong', [_vm._v("estorno do saldo residual")]), _vm._v(" e o prazo para reembolso é de 60 dias à partir da data do cancelamento do contrato.\n                A taxa de cancelamento é de R$ 7,00.\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              De quem é a responsabilidade pela manutenção das praças de pedágios e rodovias?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                A manutenção das rodovias é de responsabilidade da administradora responsável pela concessão, ou seja, a concessionária.\n                Qualquer dano causado ao patrimônio particular e público, incluindo as praças de pedágio, rodovias e outros, está sujeito\n                a eventuais penalidades na forma da legislação brasileira.\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Em caso de parada de veículo em fila o que devo fazer?\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                Se o veículo a sua frente parar, aguarde que o mesmo saia da pista automática e passe normalmente.\n                Mantenha sempre uma distância e velocidade segura do veículo à sua frente, para evitar colisões e acidentes.\n                Se após a passagem do veículo à sua frente, o semáforo continuar vermelho, aguarde orientação de algum funcionário da\n                concessionária, para evitar autuação por evasão de pedágio.\n              ")])])])])])
	}]}

/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade in",
	    attrs: {
	      "id": "messageDialog",
	      "tabindex": "-1",
	      "role": "dialog"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header",
	    class: [_vm.headerClass, {
	      'block-header': _vm.title === 'Contrato bloqueado parcialmente'
	    }]
	  }, [_vm._m(0), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title",
	    class: {
	      'block-title': _vm.title === 'Contrato bloqueado parcialmente'
	    }
	  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), (_vm.type != 'BLANK') ? _c('div', {
	    staticClass: "modal-body",
	    domProps: {
	      "innerHTML": _vm._s(_vm.message)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'BLANK') ? _c('div', {
	    staticClass: "modal-body"
	  }, [_c('h3', {
	    attrs: {
	      "id": "BLANK-ACTIVE"
	    }
	  }, [_vm._v(_vm._s(_vm.message) + " "), _c('a', {
	    style: ([_vm.colorTxtBlank != '#000000' ? {
	      'color': _vm.colorTxtBlank
	    } : {
	      'color': _vm.colorTxtBlank
	    }]),
	    attrs: {
	      "href": _vm.urlBlank,
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.txtBlank))])])]) : _vm._e(), _vm._v(" "), (_vm.showContactText) ? _c('div', {
	    staticClass: "modal-body"
	  }, [_c('h3', {
	    staticClass: "contact-text",
	    style: (_vm.title === 'Contrato bloqueado parcialmente' ? {
	      marginTop: 'auto'
	    } : {})
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1773)
	    }
	  }), _vm._v(" "), _vm._m(1)])]) : _vm._e(), _vm._v(" "), (_vm.title !== 'Contrato bloqueado parcialmente') ? _c('div', {
	    staticClass: "modal-footer"
	  }, [(_vm.type == 'CLOSE') ? [_c('div', {
	    staticClass: "wrapper-new-close"
	  }, [_c('button', {
	    staticClass: "btn btn-back",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.result('OK')
	      }
	    }
	  }, [_vm._v("\n              Fechar\n            ")])])] : _vm._e(), _vm._v(" "), (_vm.type == 'OK' || _vm.type == 'BLANK') ? [_c('button', {
	    staticClass: "btn btn-option-outline",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.result('OK')
	      }
	    }
	  }, [_vm._v("\n            OK\n          ")])] : _vm._e(), _vm._v(" "), (_vm.type == 'OK-CANCEL-ADHESION') ? [_c('div', {
	    staticClass: "modal-center"
	  }, [_c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.result('OK')
	      }
	    }
	  }, [_vm._v("\n              Quero cancelar\n            ")])])] : _vm._e(), _vm._v(" "), (_vm.type == 'OK-CANCEL') ? [_c('button', {
	    staticClass: "btn btn-option-outline",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.result('CANCEL')
	      }
	    }
	  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-option-outline",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.result('OK')
	      }
	    }
	  }, [_vm._v("\n            OK\n          ")])] : _vm._e(), _vm._v(" "), (_vm.type == 'YES-NO') ? [_c('button', {
	    staticClass: "btn btn-option-outline",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.result('NO')
	      }
	    }
	  }, [_vm._v("\n            Não\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.result('YES')
	      }
	    }
	  }, [_vm._v("\n            Sim\n          ")])] : _vm._e(), _vm._v(" "), (_vm.type == 'DOWNLOAD') ? [_c('div', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('a', {
	    staticClass: "btn btn-error",
	    attrs: {
	      "href": _vm.urlPdf.url,
	      "download": _vm.urlPdf.file
	    },
	    on: {
	      "click": function($event) {
	        return _vm.close()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "align-icon-left-white icon-pdf"
	  }), _vm._v("\n            PDF\n          ")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-download-excel",
	    attrs: {
	      "href": _vm.urlExcel.url,
	      "download": _vm.urlExcel.file
	    },
	    on: {
	      "click": function($event) {
	        return _vm.close()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "align-icon-left-white icon-xls"
	  }), _vm._v("\n            EXCEL\n          ")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-info",
	    attrs: {
	      "href": _vm.urlJson.url,
	      "download": _vm.urlJson.file
	    },
	    on: {
	      "click": function($event) {
	        return _vm.close()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "align-icon-left-white icon-json"
	  }), _vm._v("\n            JSON\n          ")])])] : _vm._e()], 2) : _vm._e()])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_vm._v("\n            Está com dúvidas? Chama no "), _c('a', {
	    attrs: {
	      "href": "https://wa.me/5511966192193",
	      "target": "_blank"
	    }
	  }, [_vm._v("WhatsApp ")]), _vm._v("\n            ou ligue no "), _c('b', [_vm._v("0800 777 1022")]), _vm._v(" e fale com nossa Central de Atendimento.\n          ")])
	}]}

/***/ }),
/* 2048 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade modal-receipt-transfer",
	    attrs: {
	      "id": "modal-receipt-transfer",
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-labelledby": "modal-receipt-transfer-label"
	    },
	    on: {
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) { return null; }
	        return _vm.closeModal()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content window-print"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close hidden-print",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title text-center upper",
	    attrs: {
	      "id": "modal-receipt-transfer-label"
	    }
	  }, [_vm._v("comprovante de transferência de créditos")])]), _vm._v(" "), (_vm.dataTransfer) ? _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    staticClass: "receipt-header"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/Logo_Move_Mais_Horizontal+TAG_Pedagio.svg",
	      "alt": "Logo Move Mais TAG"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "text-right"
	  }, [_c('p', {
	    staticClass: "upper"
	  }, [_vm._v("n° comprovante")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dataTransfer.orderId))]), _vm._v(" "), _c('p', {
	    staticClass: "upper"
	  }, [_vm._v("data da transferência")]), _vm._v(" "), _c('p', {
	    attrs: {
	      "mask-date-hour": ""
	    }
	  }, [_vm._v(_vm._s(_vm._f("dateTime")(_vm.dataTransfer.createdDate)))])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "receipt-info"
	  }, [_c('div', {}, [_c('p', {
	    staticClass: "margin-b30 upper"
	  }, [_vm._v("conta creditada")]), _vm._v(" "), _c('p', {
	    staticClass: "upper"
	  }, [_vm._v(_vm._s(_vm.dataTransfer.userCred))]), _vm._v(" "), _c('p', [_vm._v("CNPJ: "), _c('span', [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.orderData.cnpjCred)))])]), _vm._v(" "), _c('p', [_vm._v("N° do CONTRATO: "), _c('span', [_vm._v(_vm._s(_vm.dataTransfer.contractIdCred))])]), _vm._v(" "), _c('p', [_vm._v("PLANO: "), _c('span', [_vm._v(_vm._s(_vm.orderData.planCred))])])]), _vm._v(" "), _c('div', {
	    staticClass: "text-right"
	  }, [_c('p', {
	    staticClass: "margin-b30 upper"
	  }, [_vm._v("conta debitada")]), _vm._v(" "), _c('p', {
	    staticClass: "upper"
	  }, [_vm._v(_vm._s(_vm.dataTransfer.userDeb))]), _vm._v(" "), _c('p', [_vm._v("CNPJ: "), _c('span', [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.orderData.cnpjDeb)))])]), _vm._v(" "), _c('p', [_vm._v("N° do CONTRATO: "), _c('span', [_vm._v(_vm._s(_vm.dataTransfer.contractIddeb))])]), _vm._v(" "), _c('p', [_vm._v("PLANO: "), _c('span', [_vm._v(_vm._s(_vm.orderData.planDeb))])])])]), _vm._v(" "), _c('h1', [_vm._v("\n          Valor da transferência\n          "), _c('strong', [_vm._v(_vm._s(_vm._f("cents")(_vm.dataTransfer.transferValue)))])]), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer hidden-print"
	  }, [_c('button', {
	    staticClass: "btn btn-outline",
	    attrs: {
	      "type": "button",
	      "name": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v("Fechar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-full",
	    on: {
	      "click": function($event) {
	        return _vm.window.print()
	      }
	    }
	  }, [_vm._v("\n          Imprimir comprovante\n        ")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2049 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("\n        Rotas\n        "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), (_vm.route.routeId) ? _c('span', [_vm._v(" Rota Nº " + _vm._s(_vm.route.routeId))]) : _c('span', [_vm._v(" Nova Rota")])])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "min-content"
	  }, [_c('div', {
	    staticClass: "route-box"
	  }, [(_vm.route) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-5 margin-t20"
	  }, [_c('div', {
	    staticClass: "route-name-title"
	  }, [_c('a', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.editName),
	      expression: "!editName"
	    }],
	    staticClass: "force-link",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "Alterar o nome da rota"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.startEditName()
	      }
	    }
	  }, [_c('label', {
	    staticClass: "route-title three-dots"
	  }, [_vm._v(_vm._s(_vm.route.name))]), _vm._v(" "), _c('i', {
	    staticClass: "icon-pencil icon-edit"
	  })]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.editName),
	      expression: "editName"
	    }],
	    staticClass: "editable"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('newName')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newName),
	      expression: "newName"
	    }],
	    staticClass: "form-control route-label-input",
	    attrs: {
	      "type": "search",
	      "name": "newName",
	      "maxlength": "100",
	      "placeholder": "Digite o nome da rota",
	      "autofocus": ""
	    },
	    domProps: {
	      "value": (_vm.newName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newName = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("newName")) + "\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "rntrc-box-edit"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "inline",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "Cancelar edição"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.cancelEditName()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-cancel-edit"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "inline",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "Salvar edição"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.confirmEditName()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-check-edit"
	  })])]), _vm._v(" "), _c('label', {
	    staticClass: "route-version"
	  }, [_vm._v("v." + _vm._s(_vm.route.version))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    ref: "scrollContainer",
	    staticClass: "scroll-ajuste"
	  }, _vm._l((_vm.locationPoints), function(w, i) {
	    return _c('input-ac', {
	      key: w.address + w.sequence,
	      ref: "ac",
	      refInFor: true,
	      attrs: {
	        "initLocation": w,
	        "sequence": i,
	        "totalPoints": _vm.locationPoints.length
	      },
	      on: {
	        "addPoint": _vm.addPoint,
	        "removePoint": _vm.removePoint,
	        "placeChanged": _vm.placeChanged
	      }
	    })
	  }), 1), _vm._v(" "), _c('div', {
	    staticClass: "content-box margin-t30"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('i', {
	    staticClass: "icon-road"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "bold"
	  }, [_vm._v("Distância:")]), _vm._v("\n                " + _vm._s(_vm.route.totalDistance) + " Km\n              ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "pull-right"
	  }, [_c('span', {
	    staticClass: "toll-label"
	  }, [_vm._v("Pedágios:")]), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  }, [_c('span', {
	    staticClass: "badge"
	  }, [_vm._v(_vm._s(_vm.route.tollFees && _vm.route.tollFees.length))])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "time-line"
	  }, [_c('span', {
	    staticClass: "bold"
	  }, [_vm._v("Tempo estimado:")]), _vm._v(" "), _c('a', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.editTime),
	      expression: "!editTime"
	    }]
	  }, [_vm._v("\n              " + _vm._s(_vm._f("secondsFormat")(_vm.route.totalTime)) + "\n              ")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.editTime),
	      expression: "editTime"
	    }],
	    staticClass: "editable edit-time"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('newTime')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newTime),
	      expression: "newTime"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('min:8|max:8'),
	      expression: "'min:8|max:8'"
	    }, {
	      name: "mask-hour",
	      rawName: "v-mask-hour"
	    }],
	    staticClass: "form-control rntrc-label-input",
	    attrs: {
	      "name": "newTime",
	      "placeholder": "dd:hh:mm",
	      "autofocus": ""
	    },
	    domProps: {
	      "value": (_vm.newTime)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newTime = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.errors.has('newTime')) ? _c('div', {
	    staticClass: "help-block margin-error"
	  }, [_vm._v("\n                  Formato inválido\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "rntrc-box-edit"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "inline",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "Cancelar edição"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.cancelEditTime()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-cancel-edit"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "inline",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "Salvar edição"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.confirmEditTime()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-check-edit"
	  })])])]), _vm._v(" "), (_vm.route.routeId > 0) ? _c('button', {
	    staticClass: "btn btn-primary btn-recalculate",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.calculate
	    }
	  }, [_vm._v("\n            Recalcular\n          ")]) : _c('button', {
	    staticClass: "btn btn-primary btn-recalculate",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.calculate
	    }
	  }, [_vm._v("\n            Calcular\n          ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "test"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "margin-20"
	  }, [_c('label', {
	    staticClass: "trip-label"
	  }, [_vm._v("Informações complementares:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.route.flexField1),
	      expression: "route.flexField1"
	    }],
	    staticClass: "form-control margin-b20",
	    attrs: {
	      "name": "extra-field-1",
	      "id": "extra-field-1",
	      "rows": "4"
	    },
	    domProps: {
	      "value": (_vm.route.flexField1)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.route, "flexField1", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _vm._m(1)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [(_vm.msg) ? _c('div', {
	    staticClass: "alert",
	    class: _vm.msgClass
	  }, [_vm._v("\n          " + _vm._s(_vm.msg) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.msgError) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_vm._v("\n          " + _vm._s(_vm.msgError) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-back",
	    attrs: {
	      "to": {
	        name: 'routes'
	      },
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n          Voltar\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success btn-save-route",
	    attrs: {
	      "disabled": !_vm.canSave
	    },
	    on: {
	      "click": function($event) {
	        return _vm.createRoute()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-check align-icon-left-white"
	  }), _vm._v("\n          Salvar\n        ")]), _vm._v(" "), (_vm.routeStatus) ? _c('button', {
	    staticClass: "btn btn-danger btn-cancel-adjustments",
	    attrs: {
	      "disabled": !_vm.route.routeId
	    },
	    on: {
	      "click": _vm.desativar
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-cancel align-icon-left-white"
	  }), _vm._v("\n          Desativar\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.routeStatus) ? _c('button', {
	    staticClass: "btn btn-danger btn-cancel-adjustments",
	    on: {
	      "click": _vm.ativar
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-cancel align-icon-left-white"
	  }), _vm._v("\n          Ativar\n        ")]) : _vm._e()], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "info-time",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "Digite os valores respeitando a sequência: dias, horas e minutos"
	    }
	  }, [_c('i', {
	    staticClass: "icon-info"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', {
	    attrs: {
	      "id": "map"
	    }
	  })])
	}]}

/***/ }),
/* 2050 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "bold margin-b0 margin-t30"
	  }, [_vm._v("PLANOS")]), _vm._v(" "), _c('p', [_vm._v("Temos dois planos, com certeza um deles é ideal para você, é só escolher:")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('div', {
	    staticClass: "row text-center"
	  }, [_c('div', {}, [_c('div', {
	    staticClass: "col-md-6 small-padding-right"
	  }, [_c('div', {
	    staticClass: "second-col-box margin-b10"
	  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "height-72 padding-t25"
	  }, [_c('a', {
	    directives: [{
	      name: "smooth-scroll",
	      rawName: "v-smooth-scroll"
	    }],
	    staticClass: "make-link",
	    attrs: {
	      "href": "#b2c-recharge"
	    }
	  }, [_vm._v("\n                          Veja Nossas Taxas de Recarga\n                        ")])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "row-button border-radius-bottom"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "tag": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.choose(21)
	      }
	    }
	  }, [_vm._v("\n                          Quero este plano!\n                        ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 small-padding-left"
	  }, [_c('div', {
	    staticClass: "third-col-box margin-b10"
	  }, [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
	    staticClass: "height-72 padding-t25"
	  }, [_c('a', {
	    directives: [{
	      name: "smooth-scroll",
	      rawName: "v-smooth-scroll"
	    }],
	    staticClass: "make-link",
	    attrs: {
	      "href": "#b2b-recharge"
	    }
	  }, [_vm._v("\n                          Veja Nossas Taxas de Recarga\n                        ")])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
	    staticClass: "row-button border-radius-bottom"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "tag": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.choose(31)
	      }
	    }
	  }, [_vm._v("\n                          Quero este plano!\n                        ")])])])])])])])])])])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('ul', {
	    staticClass: "choose-plan"
	  }, [_c('li', {
	    staticClass: "active"
	  }, [_vm._v("\n          Para Você\n        ")]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("\n          Para Sua Empresa\n        ")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-72 border-radius-top"
	  }, [_c('h3', {
	    staticClass: "sub-title plan upper no-margin margin-b10"
	  }, [_vm._v("Pré-pago Manual")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-100 padding-s10 padding-28"
	  }, [_c('p', {
	    staticClass: "bold"
	  }, [_vm._v("A quem se destina?")]), _vm._v(" "), _c('p', [_vm._v("Para quem deseja ter controle total sobre os custos e as recargas.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-112"
	  }, [_c('p', {
	    staticClass: "bold"
	  }, [_vm._v("Como funciona?")]), _vm._v(" "), _c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("Excelente para você que quer ter controle total dos seus gastos e tem tempo para planejar as suas recargas.")]), _vm._v(" "), _c('br')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-100 padding-14"
	  }, [_c('p', {
	    staticClass: "bold"
	  }, [_vm._v("Adesão")]), _vm._v(" "), _c('h4', [_vm._v("R$ 39,90")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-82 padding-20"
	  }, [_c('p', {
	    staticClass: "bold"
	  }, [_vm._v("Formas de Pagamento")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Cartão de Crédito")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-72 border-radius-top"
	  }, [_c('h3', {
	    staticClass: "sub-title plan upper no-margin margin-b10",
	    staticStyle: {
	      "line-height": "0",
	      "margin-top": "26px"
	    }
	  }, [_vm._v("Controle")]), _vm._v(" "), _c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("Pré-pago com recarga manual")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-100 padding-s10 padding-28"
	  }, [_c('p', {
	    staticClass: "bold"
	  }, [_vm._v("A quem se destina?")]), _vm._v(" "), _c('p', [_vm._v("Empresas que querem controle total dos seus gastos e querem planejar as recargas.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-112 height-72-big padding-18"
	  }, [_c('p', {
	    staticClass: "bold"
	  }, [_vm._v("Como funciona?")]), _vm._v(" "), _c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("\n                          O próprio cliente efetua a recarga, escolhendo um dos valores disponíveis ou qualquer valor acima de R$ 2.000,00*."), _c('br'), _vm._v("\n                          Sem taxa de mensalidade. Créditos não expiram. Sem caução."), _c('br'), _vm._v("\n                          Saldo compartilhado por todos os veículos."), _c('br'), _vm._v("\n                          Disponível no app e no site.\n                        ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-100 padding-14"
	  }, [_c('p', {
	    staticClass: "bold"
	  }, [_vm._v("Adesão")]), _vm._v(" "), _c('h4', [_vm._v("R$ 39,90")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-82 padding-20"
	  }, [_c('p', {
	    staticClass: "bold"
	  }, [_vm._v("Formas de Pagamento")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Cartão de Crédito")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "b2c-recharge"
	    }
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "rechargeB2C"
	    }
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-b10"
	  }, [_c('h3', {
	    staticClass: "bold upper"
	  }, [_vm._v("Recargas plano pré-pago manual")]), _vm._v(" "), _c('p', [_vm._v("As recargas estão sujeitas a taxas, verifique os valores:")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-red"
	  }, [_c('div', {
	    staticClass: "recharge-value-red"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-red"
	  }, [_vm._v("50")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("5,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-yellow"
	  }, [_c('div', {
	    staticClass: "recharge-value-yellow"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-yellow"
	  }, [_vm._v("100")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("9,40")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-green"
	  }, [_c('div', {
	    staticClass: "recharge-value-green"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-green"
	  }, [_vm._v("150")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("13,20")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-blue"
	  }, [_c('div', {
	    staticClass: "recharge-value-blue"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-blue"
	  }, [_vm._v("200")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("16,40")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge-last"
	  }, [_c('div', {
	    staticClass: "recharge-purple"
	  }, [_c('div', {
	    staticClass: "recharge-value-purple"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-purple"
	  }, [_vm._v("250")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("19,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-red"
	  }, [_c('div', {
	    staticClass: "recharge-value-red"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-red"
	  }, [_vm._v("300")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("21,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-yellow"
	  }, [_c('div', {
	    staticClass: "recharge-value-yellow"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-yellow"
	  }, [_vm._v("350")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("22,40")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-green"
	  }, [_c('div', {
	    staticClass: "recharge-value-green"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-green"
	  }, [_vm._v("400")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("22,40")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-blue"
	  }, [_c('div', {
	    staticClass: "recharge-value-blue"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-blue"
	  }, [_vm._v("450")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("21,60")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge-last"
	  }, [_c('div', {
	    staticClass: "recharge-purple"
	  }, [_c('div', {
	    staticClass: "recharge-value-purple"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-purple"
	  }, [_vm._v("500")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("20,00")])])])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "b2b-recharge"
	    }
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "rechargeB2B"
	    }
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-b10"
	  }, [_c('h3', {
	    staticClass: "bold upper"
	  }, [_vm._v("Recargas plano controle")]), _vm._v(" "), _c('p', [_vm._v("As recargas estão sujeitas a taxas, verifique os valores:")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-red"
	  }, [_c('div', {
	    staticClass: "recharge-value-red"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-red"
	  }, [_vm._v("500")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("40,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-yellow"
	  }, [_c('div', {
	    staticClass: "recharge-value-yellow"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-yellow"
	  }, [_vm._v("1000")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("70,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-green"
	  }, [_c('div', {
	    staticClass: "recharge-value-green"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-green"
	  }, [_vm._v("1500")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("90,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-blue"
	  }, [_c('div', {
	    staticClass: "recharge-value-blue"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-blue"
	  }, [_vm._v("2000")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("100,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge-last"
	  }, [_c('div', {
	    staticClass: "recharge-purple"
	  }, [_c('div', {
	    staticClass: "recharge-value-purple"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-purple"
	  }, [_vm._v("2000+")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("5%")])])])])])])])
	}]}

/***/ }),
/* 2051 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "captchaModal"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "captchaContainer"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "headerContainer"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "logoContainer"
	    }
	  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.perguntaCaptcha))])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "formularioCaptcha"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "captchaOnly"
	    }
	  }, [_c('section', [_c('div', {
	    staticClass: "labelsCaptcha",
	    style: ({
	      'background-color': _vm.backgroundColorsA1,
	      'border': _vm.borderA1
	    }),
	    attrs: {
	      "id": "LabelA1"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.captchaSelecionado(0, 'LabelA1')
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "labelsCaptcha",
	    style: ({
	      'background-color': _vm.backgroundColorsA2,
	      'border': _vm.borderA2
	    }),
	    attrs: {
	      "id": "LabelA2"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.captchaSelecionado(1, 'LabelA2')
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "labelsCaptcha",
	    style: ({
	      'background-color': _vm.backgroundColorsA3,
	      'border': _vm.borderA3
	    }),
	    attrs: {
	      "id": "LabelA3"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.captchaSelecionado(2, 'LabelA3')
	      }
	    }
	  })]), _vm._v(" "), _c('section', [_c('div', {
	    staticClass: "labelsCaptcha",
	    style: ({
	      'background-color': _vm.backgroundColorsB1,
	      'border': _vm.borderB1
	    }),
	    attrs: {
	      "id": "LabelB1"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.captchaSelecionado(3, 'LabelB1')
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "labelsCaptcha",
	    style: ({
	      'background-color': _vm.backgroundColorsB2,
	      'border': _vm.borderB2
	    }),
	    attrs: {
	      "id": "LabelB2"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.captchaSelecionado(4, 'LabelB2')
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "labelsCaptcha",
	    style: ({
	      'background-color': _vm.backgroundColorsB3,
	      'border': _vm.borderB3
	    }),
	    attrs: {
	      "id": "LabelB3"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.captchaSelecionado(5, 'LabelB3')
	      }
	    }
	  })]), _vm._v(" "), _c('section', [_c('div', {
	    staticClass: "labelsCaptcha",
	    style: ({
	      'background-color': _vm.backgroundColorsC1,
	      'border': _vm.borderC1
	    }),
	    attrs: {
	      "id": "LabelC1"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.captchaSelecionado(6, 'LabelC1')
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "labelsCaptcha",
	    style: ({
	      'background-color': _vm.backgroundColorsC2,
	      'border': _vm.borderC2
	    }),
	    attrs: {
	      "id": "LabelC2"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.captchaSelecionado(7, 'LabelC2')
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "labelsCaptcha",
	    style: ({
	      'background-color': _vm.backgroundColorsC3,
	      'border': _vm.borderC3
	    }),
	    attrs: {
	      "id": "LabelC3"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.captchaSelecionado(8, 'LabelC3')
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "buttonContainerCaptcha"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "BotaoSubmit"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.responderCaptcha()
	      }
	    }
	  }, [_vm._v("\r\n              Continuar\r\n          ")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2052 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [(_vm.code == undefined) ? _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("\n          Planos\n          "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Contrato\n          " + _vm._s(_vm.contractId) + "\n          "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Veículos\n          "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" " + _vm._s(_vm.plate) + "\n          "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Substituição de TAG\n        ")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })], 1)]), _vm._v(" "), (_vm.msgError) ? _c('div', {
	    staticClass: "alert alert-warning",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Atenção!")]), _vm._v(" " + _vm._s(_vm.msgError) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.shipmentType == 4 && _vm.activationError) ? _c('div', {
	    staticClass: "alert alert-danger",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.activationError) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.salesOrder) ? _c('generic-summary', {
	    ref: "GenericSummary",
	    attrs: {
	      "contract": _vm.contract,
	      "order": _vm.salesOrder,
	      "showAddress": true,
	      "addressInit": _vm.addressInit,
	      "account": _vm.user,
	      "disablePayment": true
	    },
	    on: {
	      "tag-activation-state": _vm.onTagActivationState
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.salesOrder && _vm.tagInHandActivated) ? _c('div', {
	    staticClass: "tag-success-banner"
	  }, [_c('div', {
	    staticClass: "tag-success-message"
	  }, [_c('svg', {
	    attrs: {
	      "width": "22",
	      "height": "22",
	      "viewBox": "0 0 22 22",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M11 20.1666C16.0627 20.1666 20.1667 16.0626 20.1667 11C20.1667 5.93737 16.0627 1.83331 11 1.83331C5.93743 1.83331 1.83337 5.93737 1.83337 11C1.83337 16.0626 5.93743 20.1666 11 20.1666Z",
	      "stroke": "#2E7D32",
	      "stroke-width": "1.83333",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  }), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M8.25 11L10.0833 12.8334L13.75 9.16669",
	      "stroke": "#2E7D32",
	      "stroke-width": "1.83333",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tagActivationSuccessMessage))])]), _vm._v(" "), _c('div', {
	    staticClass: "tag-success-actions"
	  }, [_c('button', {
	    staticClass: "btn-finish-tag-flow",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.finalizar()
	      }
	    }
	  }, [_vm._v("\n          Finalizar\n          "), _c('svg', {
	    attrs: {
	      "width": "6",
	      "height": "10",
	      "viewBox": "0 0 6 10",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M0.666748 8.66669L4.66675 4.66669L0.666748 0.666687",
	      "stroke": "white",
	      "stroke-width": "1.33333",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })])])])]) : _vm._e(), _vm._v(" "), (_vm.salesOrder && !_vm.tagInHandActivated) ? _c('div', [_c('div', {
	    staticClass: "action-buttons-box"
	  }, [_c('div', {
	    staticClass: "adhesion-footer-nav",
	    class: {
	      'adhesion-footer-nav--final-mobile': _vm.isMobile
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "btn-container-adhesion-back-cancel"
	    }
	  }, [_c('button', {
	    attrs: {
	      "id": "button-cancel-adhesion",
	      "type": "button",
	      "disabled": _vm.activationSuccess || _vm.tagInHandActivated
	    },
	    on: {
	      "click": function($event) {
	        return _vm.cancelar()
	      }
	    }
	  }, [_c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M12 4L4 12M4 4L12 12",
	      "stroke": "#E21C12",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })]), _vm._v("\n              Cancelar\n            ")])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "btn-container-adhesion-advance"
	    }
	  }, [(!_vm.isMobile && !(_vm.shipmentType == 4 && _vm.activationSuccess)) ? _c('button', {
	    attrs: {
	      "id": "button-concluir-adhesion",
	      "type": "button",
	      "disabled": _vm.activationSuccess
	    },
	    on: {
	      "click": function($event) {
	        return _vm.startRequest()
	      }
	    }
	  }, [_vm._v("\n              Finalizar\n              "), _c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
	      "stroke": "#F5F5F5",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.isMobile && !(_vm.shipmentType == 4 && _vm.activationSuccess)) ? _c('button', {
	    attrs: {
	      "id": "button-concluir-adhesion-mobile",
	      "type": "button",
	      "disabled": _vm.activationSuccess
	    },
	    on: {
	      "click": function($event) {
	        return _vm.startRequest()
	      }
	    }
	  }, [_vm._v("\n              Finalizar\n              "), _c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
	      "stroke": "#F5F5F5",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })])]) : _vm._e()])])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('success-page', {
	    attrs: {
	      "code": _vm.code,
	      "type": 'replaceTag',
	      "salesOrder": _vm.salesResponse
	    }
	  }), _vm._v(" "), _c('error-page', {
	    attrs: {
	      "code": _vm.code,
	      "type": 'replaceTag',
	      "salesOrder": _vm.salesResponse
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2053 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('form', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loadingAddress),
	      expression: "loadingAddress"
	    }],
	    attrs: {
	      "name": "form-address",
	      "id": "form-address"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loadingAddress),
	      expression: "loadingAddress"
	    }],
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('b', {
	    staticClass: "title-identification margin-b10"
	  }, [_vm._v("Endereço "), (_vm.type == 'BILLING') ? [_vm._v(" da fatura do cartão")] : _vm._e()], 2), _vm._v(" "), _c('div', {
	    staticClass: "form-content"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errorCep),
	      expression: "errorCep"
	    }],
	    staticClass: "alert alert-danger alert-dismissable margin-b10"
	  }, [_c('a', {
	    staticClass: "close",
	    attrs: {
	      "aria-label": "close"
	    },
	    on: {
	      "click": function($event) {
	        _vm.errorCep = undefined
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" " + _vm._s(_vm.errorCep) + "\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control input-box-cep",
	    class: {
	      'has-error': _vm.errors.has('cep')
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.address.zipCode),
	      expression: "address.zipCode"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:8|cep'),
	      expression: "'required|min:8|cep'"
	    }, {
	      name: "only-numbers",
	      rawName: "v-only-numbers"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "cep",
	      "maxlength": "8",
	      "placeholder": "00000-000"
	    },
	    domProps: {
	      "value": (_vm.address.zipCode)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.address, "zipCode", $event.target.value)
	      }, _vm.queryAddressTyping]
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('cep')) + "\n            ")])]), _vm._v(" "), _c('a', {
	    staticClass: "label-link",
	    on: {
	      "click": _vm.queryAddress
	    }
	  }, [_vm._v("Buscar CEP")])]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "form-group margin-b30 input-box-control inline",
	    class: {
	      'has-error': _vm.errors.has('logradouro')
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.address.address),
	      expression: "address.address"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:50'),
	      expression: "'required|max:50'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "logradouro",
	      "maxlength": "50"
	    },
	    domProps: {
	      "value": (_vm.address.address)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.address, "address", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first('logradouro')) + "\n                ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control inline input-box-number",
	    class: {
	      'has-error': _vm.errors.has('numero')
	    }
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.address.number),
	      expression: "address.number"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:5'),
	      expression: "'required|max:5'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "numero",
	      "maxlength": "5"
	    },
	    domProps: {
	      "value": (_vm.address.number)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.address, "number", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first('numero')) + "\n                ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control inline input-box-adjunct"
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.address.complement),
	      expression: "address.complement"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "complemento",
	      "maxlength": "20"
	    },
	    domProps: {
	      "value": (_vm.address.complement)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.address, "complement", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  })])])]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "form-group margin-b30 input-box-control inline input-box-medium",
	    class: {
	      'has-error': _vm.errors.has('bairro')
	    }
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.address.neighborhood),
	      expression: "address.neighborhood"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:30'),
	      expression: "'required|max:30'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "bairro",
	      "maxlength": "30"
	    },
	    domProps: {
	      "value": (_vm.address.neighborhood)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.address, "neighborhood", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first('bairro')) + "\n                ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control inline input-box-medium",
	    class: {
	      'has-error': _vm.errors.has('cidade')
	    }
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.address.city),
	      expression: "address.city"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:30'),
	      expression: "'required|max:30'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "cidade",
	      "maxlength": "30"
	    },
	    domProps: {
	      "value": (_vm.address.city)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.address, "city", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first('cidade')) + "\n                ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control inline input-box-state",
	    class: {
	      'has-error': _vm.errors.has('estado')
	    }
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.address.state),
	      expression: "address.state"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:2'),
	      expression: "'required|max:2'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "estado",
	      "maxlength": "2"
	    },
	    domProps: {
	      "value": (_vm.address.state)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.address, "state", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first('estado')) + "\n                ")])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("CEP:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Logradouro:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box number-box"
	  }, [_c('label', [_vm._v("Número:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Complemento:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Bairro:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Cidade:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Estado:*")])])
	}]}

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', [(_vm.stepForm <= 1) ? _c('div', {
	    attrs: {
	      "id": "title-container-form"
	    }
	  }, [_c('h2', {
	    attrs: {
	      "id": "title-form"
	    }
	  }, [_vm._v("Adicionar veículo(s) do plano")])]) : _vm._e(), _vm._v(" "), (_vm.stepForm == 404) ? _c('div', {
	    attrs: {
	      "id": "title-container-form-404"
	    }
	  }, [_c('h2', {
	    attrs: {
	      "id": "title-form-mobile"
	    }
	  }, [_vm._v("Adicionar veículo(s) do plano manualmente")]), _vm._v(" "), _c('h2', {
	    attrs: {
	      "id": "subtitle-form"
	    }
	  }, [_vm._v("( Todos os campos são obrigatórios )")])]) : _vm._e(), _vm._v(" "), (_vm.stepForm == 0) ? _c('div', [_c('label', {
	    attrs: {
	      "for": "plate-input",
	      "id": "plate-label"
	    }
	  }, [_vm._v("\n      Digite a placa do veículo\n    ")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "input-container"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|plateValid|plateExist'),
	      expression: "'required|plateValid|plateExist'"
	    }, {
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.plate),
	      expression: "plate",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    staticClass: "form-control text-uppercase plate margin-t5",
	    staticStyle: {
	      "outline": "none"
	    },
	    attrs: {
	      "id": "plate-input",
	      "type": "text",
	      "name": "plate",
	      "data-vv-validate-on": "blur",
	      "spellcheck": "false",
	      "autocomplete": "off",
	      "autocorrect": "off",
	      "maxlength": "7",
	      "autocapitalize": "off"
	    },
	    domProps: {
	      "value": (_vm.plate)
	    },
	    on: {
	      "keydown": _vm.verificarTecla,
	      "input": _vm.onPlateInput,
	      "paste": _vm.tratarTextoColado,
	      "change": function($event) {
	        _vm.plate = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    attrs: {
	      "id": "search-plate-button"
	    },
	    on: {
	      "click": _vm.NetrinValidation
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1774),
	      "alt": "Imagem de uma lupa"
	    }
	  })])]), _vm._v(" "), (_vm.plateAlreadyOn) ? _c('div', {
	    attrs: {
	      "id": "error-msg"
	    }
	  }, [_c('h2', [_vm._v("Placa já cadastrada!")])]) : _vm._e(), _vm._v(" "), (_vm.validatePlate || _vm.plateInvalida) ? _c('div', {
	    attrs: {
	      "id": "error-msg"
	    }
	  }, [_c('h2', [_vm._v("Placa Inválida!")])]) : _vm._e(), _vm._v(" "), (_vm.isMoto) ? _c('div', {
	    attrs: {
	      "id": "error-msg"
	    }
	  }, [_c('h2', [_vm._v("\n        Moto não tem permissão para fazer uso de tag. Cadastre outro tipo de\n        veículo.\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.plateValida) ? _c('div', {
	    attrs: {
	      "id": "transportador-container"
	    }
	  }, [_c('label', {
	    attrs: {
	      "id": "transportador-check"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.souTransportador),
	      expression: "souTransportador"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.souTransportador) ? _vm._i(_vm.souTransportador, null) > -1 : (_vm.souTransportador)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.souTransportador,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.souTransportador = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.souTransportador = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.souTransportador = $$c
	        }
	      }, _vm.onTransportadorToggle]
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Sou transportador e quero receber VPO.")])]), _vm._v(" "), (_vm.souTransportador) ? _c('div', {
	    attrs: {
	      "id": "antt-box"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "antt-input-row"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cpfCnpjTransportador),
	      expression: "cpfCnpjTransportador"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "cpf-cnpj-input",
	      "type": "text",
	      "name": "cpfCnpjTransportador",
	      "placeholder": "Digite o número CPF ou CNPJ do proprietário",
	      "maxlength": "18",
	      "spellcheck": "false",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": (_vm.cpfCnpjTransportador)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.cpfCnpjTransportador = $event.target.value
	      }, _vm.onCpfCnpjInput]
	    }
	  }), _vm._v(" "), _c('button', {
	    attrs: {
	      "id": "consultar-antt-button",
	      "type": "button",
	      "disabled": _vm.anttLoading || !_vm.cpfCnpjValido || _vm.anttStatus === 'error'
	    },
	    on: {
	      "click": _vm.consultarAntt
	    }
	  }, [(_vm.anttLoading) ? _c('span', {
	    staticClass: "antt-spinner"
	  }) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.anttLoading ? "Consultando..." : "Consultar na ANTT") + "\n          ")])]), _vm._v(" "), (_vm.anttStatus === 'success') ? _c('div', {
	    attrs: {
	      "id": "antt-feedback-success"
	    }
	  }, [_c('svg', {
	    attrs: {
	      "width": "18",
	      "height": "18",
	      "viewBox": "0 0 18 18",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('g', {
	    attrs: {
	      "clip-path": "url(#clip0_166_8935)"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M16.3502 7.50011C16.6927 9.18109 16.4486 10.9287 15.6586 12.4515C14.8686 13.9742 13.5804 15.1802 12.0088 15.8681C10.4373 16.5561 8.67743 16.6845 7.02269 16.2319C5.36794 15.7793 3.91836 14.7732 2.91567 13.3812C1.91298 11.9892 1.41781 10.2955 1.51271 8.58265C1.60762 6.86977 2.28687 5.24118 3.4372 3.96849C4.58753 2.6958 6.1394 1.85594 7.83401 1.58895C9.52863 1.32197 11.2636 1.64401 12.7495 2.50136M6.74976 8.24976L8.99976 10.4998L16.4998 2.99976",
	      "stroke": "#4CAF50",
	      "stroke-width": "2",
	      "stroke-linecap": "round"
	    }
	  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
	    attrs: {
	      "id": "clip0_166_8935"
	    }
	  }, [_c('rect', {
	    attrs: {
	      "width": "18",
	      "height": "18",
	      "fill": "white"
	    }
	  })])])]), _vm._v(" "), _c('span', [_vm._v("Transportador validado com sucesso na ANTT.")])]) : _vm._e(), _vm._v(" "), (_vm.anttStatus === 'error') ? _c('div', {
	    attrs: {
	      "id": "antt-feedback-error"
	    }
	  }, [_c('svg', {
	    attrs: {
	      "width": "20",
	      "height": "22",
	      "viewBox": "0 0 20 22",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('g', {
	    attrs: {
	      "clip-path": "url(#clip0_166_9400)"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M10.0001 20.3332C14.6025 20.3332 18.3334 16.6022 18.3334 11.9998C18.3334 7.39746 14.6025 3.6665 10.0001 3.6665C5.39771 3.6665 1.66675 7.39746 1.66675 11.9998C1.66675 16.6022 5.39771 20.3332 10.0001 20.3332Z",
	      "stroke": "#E00000",
	      "stroke-width": "1.66667",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  }), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M10 8.6665V11.9998",
	      "stroke": "#E00000",
	      "stroke-width": "1.66667",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  }), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M10 15.3335H10.0083",
	      "stroke": "#E00000",
	      "stroke-width": "1.66667",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
	    attrs: {
	      "id": "clip0_166_9400"
	    }
	  }, [_c('rect', {
	    attrs: {
	      "width": "20",
	      "height": "20",
	      "fill": "white",
	      "transform": "translate(0 2)"
	    }
	  })])])]), _vm._v(" "), _c('span', [_vm._v("Não foi possível validar na ANTT. Verifique se os dados estão corretos.")])]) : _vm._e(), _vm._v(" "), (_vm.mostrarAvisoAntt && _vm.transportadorPendente) ? _c('div', {
	    attrs: {
	      "id": "antt-aviso"
	    }
	  }, [_vm._v("\n          Valide o transportador na ANTT para continuar.\n        ")]) : _vm._e()]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.stepForm == 1) ? _c('div', {
	    attrs: {
	      "id": "details-container"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "plate-form-model-container"
	    }
	  }, [_c('h3', {
	    attrs: {
	      "id": "plate-form-model"
	    }
	  }, [_vm._v(_vm._s(_vm.PlateFormat(_vm.plate)))]), _vm._v(" "), _c('button', {
	    attrs: {
	      "id": "plate-edit-button"
	    },
	    on: {
	      "click": _vm.StepBack
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(225),
	      "id": "edit-svg"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "plate-container"
	    }
	  }, [_c('div', [_c('h5', {
	    attrs: {
	      "id": "brand-form-model"
	    }
	  }, [_vm._v("\n          Marca "), _c('span', {
	    attrs: {
	      "id": "brand-name"
	    }
	  }, [_vm._v(_vm._s(_vm.brandName))])])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "plate-form-model-container-mobile"
	    }
	  }, [_c('h3', {
	    attrs: {
	      "id": "plate-form-model"
	    }
	  }, [_vm._v(_vm._s(_vm.PlateFormat(_vm.plate)))]), _vm._v(" "), _c('button', {
	    attrs: {
	      "id": "plate-edit-button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.stepForm = 0
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(225),
	      "id": "edit-svg"
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "model-container-form-model"
	    }
	  }, [_c('dropdownV2', {
	    attrs: {
	      "placeholder": 'Modelo do veículo',
	      "arrayRender": _vm.arrayModelsByNetrin,
	      "disabled": false
	    },
	    on: {
	      "ClickHandler": _vm.getAxes
	    }
	  }), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "axes-container"
	    }
	  }, [(_vm.showAxes) ? _c('dropdownV2', {
	    attrs: {
	      "placeholder": _vm.placeHolderFixed == '' ? 'Eixos do veículo' : _vm.placeHolderFixed,
	      "disabled": _vm.disableAxes,
	      "arrayRender": _vm.axes
	    },
	    on: {
	      "ClickHandler": _vm.setAxes
	    }
	  }) : _vm._e()], 1)], 1)]) : _vm._e(), _vm._v(" "), (
	    _vm.stepForm == 1 &&
	    _vm.modelName &&
	    _vm.brandName &&
	    _vm.axeNameSelected &&
	    _vm.axeIdSelected
	  ) ? _c('div', {
	    staticClass: "btn-save-div"
	  }, [_c('button', {
	    attrs: {
	      "id": "btn-save"
	    },
	    on: {
	      "click": _vm.ShowModal
	    }
	  }, [_vm._v("Salvar")])]) : _vm._e(), _vm._v(" "), (_vm.stepForm == 404) ? _c('div', [_c('div', {
	    attrs: {
	      "id": "form-netrim-container"
	    }
	  }, [_c('div', {
	    staticClass: "inputs-netrim-off"
	  }, [_c('label', {
	    staticClass: "label-netrim-off"
	  }, [_vm._v("Placa")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|plateValid|plateExist'),
	      expression: "'required|plateValid|plateExist'"
	    }, {
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.plate),
	      expression: "plate",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    staticClass: "form-control text-uppercase plate-input-netrim-off margin-t5",
	    attrs: {
	      "id": "plate-input-netrin-off",
	      "type": "text",
	      "name": "plate",
	      "data-vv-validate-on": "blur",
	      "spellcheck": "false",
	      "autocomplete": "off",
	      "autocorrect": "off",
	      "autocapitalize": "off",
	      "maxlength": "7"
	    },
	    domProps: {
	      "value": (_vm.plate)
	    },
	    on: {
	      "change": function($event) {
	        _vm.plate = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "inputs-netrim-off"
	  }, [_c('label', {
	    staticClass: "label-netrim-off"
	  }, [_vm._v("Marca")]), _vm._v(" "), _c('dropdownV2', {
	    attrs: {
	      "placeholder": '',
	      "arrayRender": _vm.netrimErrorBrands,
	      "disabled": false
	    },
	    on: {
	      "ClickHandler": _vm.getModels
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "inputs-netrim-off"
	  }, [_c('label', {
	    staticClass: "label-netrim-off"
	  }, [_vm._v("Modelo")]), _vm._v(" "), _c('dropdownV2', {
	    attrs: {
	      "placeholder": '',
	      "arrayRender": _vm.models,
	      "disabled": false
	    },
	    on: {
	      "ClickHandler": _vm.setModels
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "inputs-netrim-off"
	  }, [_c('label', {
	    staticClass: "label-netrim-off"
	  }, [_vm._v("Eixos")]), _vm._v(" "), _c('dropdownV2', {
	    attrs: {
	      "placeholder": '',
	      "arrayRender": _vm.axes,
	      "disabled": false
	    },
	    on: {
	      "ClickHandler": _vm.setAxes
	    }
	  })], 1)]), _vm._v(" "), (_vm.validatePlate) ? _c('div', {
	    attrs: {
	      "id": "error-msg"
	    }
	  }, [_c('h2', [_vm._v("Placa Inválida!")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "button-container"
	    }
	  }, [(_vm.modelName && _vm.brandName && _vm.axeNameSelected && _vm.axeIdSelected) ? _c('div', {
	    staticClass: "btn-save-div"
	  }, [_c('button', {
	    attrs: {
	      "id": "btn-save"
	    },
	    on: {
	      "click": _vm.AddVehicleNetrimOff
	    }
	  }, [_vm._v("Salvar")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.modalConfirmVisibility) ? _c('form-modal', {
	    attrs: {
	      "plate": _vm.plate,
	      "brand": _vm.brandName,
	      "model": _vm.modelName
	    },
	    on: {
	      "ClickHandlerCancel": _vm.RemoveModal,
	      "ClickHandlerContinue": _vm.AddVehicle
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.modalNewSearch) ? _c('form-modal-new-search', {
	    on: {
	      "ClickHandlerCancel": _vm.CloseModalNewSearch,
	      "ClickHandlerContinue": _vm.refreshPage
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.netrinOffVisibility) ? _c('form-modal', {
	    attrs: {
	      "plate": _vm.plate,
	      "brand": _vm.brandName,
	      "model": _vm.modelName
	    },
	    on: {
	      "ClickHandlerCancel": _vm.RemoveModal,
	      "ClickHandlerContinue": _vm.AddVehicle
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('loadingV2') : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "id": "cpf-cnpj-label",
	      "for": "cpf-cnpj-input"
	    }
	  }, [_vm._v("\n          CNPJ ou CPF do transportador"), _c('span', {
	    staticClass: "required-asterisk"
	  }, [_vm._v("*")])])
	}]}

/***/ }),
/* 2055 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("\n        Identificação "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" "), (_vm.type == 'reset') ? [_vm._v("Esqueci minha senha")] : _vm._e(), _vm._v(" "), (_vm.type == 'desbloqueioConta') ? [_vm._v("Desbloqueio de conta")] : _vm._e(), _vm._v(" "), (_vm.type == 'primeiroacesso') ? [_vm._v("Primeiro Acesso")] : _vm._e()], 2), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), (_vm.type == 'reset') ? [_c('p', [_vm._v("Informe seu CPF ou CNPJ para redefinir a senha.")])] : _vm._e(), _vm._v(" "), (_vm.type == 'desbloqueioConta') ? [_c('p', [_vm._v("Informe seu CPF ou CNPJ para redefinir a senha.")])] : _vm._e(), _vm._v(" "), (_vm.type == 'primeiroacesso') ? [_c('p', [_vm._v("\n          O primeiro acesso destina-se aos novos clientes, que já fizeram uma\n          adesão Move Mais, mas ainda não criaram uma senha de acesso para\n          utilizar os serviços online.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Se você ainda não é cliente, conheça nossos\n          "), _c('router-link', {
	    staticClass: "make-link",
	    attrs: {
	      "to": {
	        name: 'services'
	      },
	      "tag": "a"
	    }
	  }, [_vm._v("serviços e planos.")])], 1)] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "row border-row row-fix"
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "content-box-small margin-t80"
	  }, [(_vm.formState == 'ERROR' && _vm.errorMessage) ? _c('div', {
	    staticClass: "alert alert-danger alert-dismissible margin-t20 margin-b20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Erro: ")]), _vm._v("\n              " + _vm._s(_vm.errorMessage) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'SUCCESS') ? _c('div', {
	    staticClass: "alert alert-success alert-dismissible margin-t20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Sucesso!")]), _vm._v("\n              Foi enviado um email para recuperação de senha\n            ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'NEW') ? _c('form', {
	    attrs: {
	      "autocomplete": "false",
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.doRequest.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group margin-b20",
	    class: {
	      'has-error': _vm.errors.has('taxIdNumber')
	    }
	  }, [_c('label', [_vm._v("CPF ou CNPJ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.taxIdNumber),
	      expression: "taxIdNumber",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cpfCnpj'),
	      expression: "'required|cpfCnpj'"
	    }, {
	      name: "mask-cpf-cnpj",
	      rawName: "v-mask-cpf-cnpj"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "tel",
	      "inputmode": "numeric",
	      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2}|[0-9]{3}\\.[0-9]{3}\\.[0-9]{3}-[0-9]{2}|[0-9]{11})$",
	      "name": "taxIdNumber",
	      "data-vv-validate-on": "blur",
	      "placeholder": "Digite seu CPF ou CNPJ",
	      "maxlength": "18",
	      "autofocus": "",
	      "novalidate": "",
	      "formnovalidate": ""
	    },
	    domProps: {
	      "value": (_vm.taxIdNumber)
	    },
	    on: {
	      "change": function($event) {
	        _vm.taxIdNumber = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("taxIdNumber")) + "\n                ")])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-lg btn-purple",
	    attrs: {
	      "id": "btn-login",
	      "type": "submit",
	      "name": "button"
	    }
	  }, [_vm._v("\n                Continuar\n              ")]), _vm._v(" "), _c('i', {
	    staticClass: "icon-circle-right align-icon"
	  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.type == 'reset') ? [_c('div', {
	    staticClass: "circle-key"
	  })] : _vm._e(), _vm._v(" "), (_vm.type == 'desbloqueioConta') ? [_c('div', {
	    staticClass: "circle-key"
	  })] : _vm._e(), _vm._v(" "), (_vm.type == 'primeiroacesso') ? [_c('div', {
	    staticClass: "circle"
	  })] : _vm._e()], 2)]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-back margin-t20",
	    attrs: {
	      "to": "/login",
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n        Voltar\n      ")])], 1)]), _vm._v(" "), _c('modal-validate', {
	    ref: "modalValidate",
	    attrs: {
	      "show": _vm.showValidationModal,
	      "email": _vm.userEmail,
	      "title": "Redefinição de senha",
	      "resend-cooldown": 60,
	      "initial-timer": _vm.initialTimerValue,
	      "close-on-backdrop": false,
	      "allow-close": true
	    },
	    on: {
	      "close": _vm.closeValidationModal,
	      "validate": _vm.onCodeValidate,
	      "resend": _vm.onResendCode,
	      "channel-selected": _vm.onChannelSelected
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "new-layout"
	  }, [(_vm.isMobile && _vm.showOverlayMobile) ? _c('div', {
	    staticClass: "action-bar"
	  }, [_vm._m(0), _vm._v(" "), _c('span', {
	    staticClass: "close-alert special-font",
	    on: {
	      "click": _vm.fecharActionBar
	    }
	  }, [_c('img', {
	    staticClass: "closeIcon",
	    attrs: {
	      "src": __webpack_require__(500)
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.companies) ? _c('div', {
	    staticClass: "container container-companies",
	    staticStyle: {
	      "z-index": "9997"
	    }
	  }, [_c('div', {
	    staticClass: "dropdown drop-full"
	  }, [_c('button', {
	    staticClass: "form-control dropdown-toggle btn-dropdown drop-dark drop-word-wrap",
	    attrs: {
	      "type": "button",
	      "id": "empresas",
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "true"
	    }
	  }, [_c('span', {
	    staticClass: "selected"
	  }, [_vm._v(_vm._s(_vm.currentUser.company.companyName) + " ")]), _vm._v(" -\n        "), _c('span', {
	    directives: [{
	      name: "mask-cpf-cnpj",
	      rawName: "v-mask-cpf-cnpj"
	    }]
	  }, [_vm._v(_vm._s(_vm.currentUser.taxIdNumber))]), _vm._v(" "), _c('i', {
	    staticClass: "icon-arrow-down-dropdown"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "aria-labelledby": "empresas"
	    }
	  }, _vm._l((_vm.companies), function(company, index) {
	    return _c('li', {
	      key: index
	    }, [_c('a', {
	      class: {
	        active: company.moveMaisId == _vm.currentUser.moveMaisId
	      },
	      on: {
	        "click": function($event) {
	          return _vm.changeUser(company.moveMaisId)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "word-wrap"
	    }, [_vm._v(_vm._s(company.companyName) + " ")]), _vm._v(" -\n            "), _c('span', {
	      directives: [{
	        name: "mask-cpf-cnpj",
	        rawName: "v-mask-cpf-cnpj"
	      }]
	    }, [_vm._v(" " + _vm._s(company.taxIdNumber))])])])
	  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "tabs-section hidden-print",
	    class: {
	      fixed: _vm.scrolling
	    },
	    staticStyle: {
	      "z-index": "9997"
	    },
	    attrs: {
	      "id": "tabs-section"
	    }
	  }, [(_vm.showOverlay && !_vm.isMobile) ? _c('div', {
	    staticClass: "action-bar"
	  }, [_vm._m(1), _vm._v(" "), _c('span', {
	    staticClass: "close-alert special-font",
	    on: {
	      "click": _vm.fecharActionBar
	    }
	  }, [_c('img', {
	    staticClass: "closeIcon",
	    attrs: {
	      "src": __webpack_require__(500)
	    }
	  })])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('router-link', {
	    staticClass: "tab-item",
	    attrs: {
	      "to": {
	        name: 'home'
	      }
	    }
	  }, [(!_vm.scrolling) ? _c('img', {
	    staticClass: "logo-img",
	    attrs: {
	      "src": __webpack_require__(1839),
	      "alt": "Logo Move Mais TAG",
	      "width": "130"
	    }
	  }) : _c('img', {
	    staticClass: "logo-img",
	    attrs: {
	      "src": __webpack_require__(1840),
	      "alt": "Logo Move Mais TAG",
	      "width": "130"
	    }
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "nav nav-tabs"
	  }, [_c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('router-link', {
	    staticClass: "tab-item",
	    attrs: {
	      "to": {
	        name: 'plans'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-padnote"
	  }), _vm._v(" "), _c('span', [_vm._v("Planos")])])], 1), _vm._v(" "), _c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('router-link', {
	    staticClass: "tab-item",
	    attrs: {
	      "to": {
	        name: 'requests'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-bell"
	  }), _vm._v(" "), _c('span', [_vm._v("Pedidos")])])], 1), _vm._v(" "), _c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('router-link', {
	    staticClass: "tab-item",
	    attrs: {
	      "to": {
	        name: 'tag-activate'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-active-tag"
	  }), _vm._v(" "), _c('span', [_vm._v("Ativar TAG")])])], 1), _vm._v(" "), _c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('router-link', {
	    staticClass: "tab-item",
	    attrs: {
	      "to": {
	        name: 'routing'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-routing"
	  }), _vm._v(" "), _c('span', [_vm._v("Viagem")])])], 1), _vm._v(" "), (false) ? _c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('router-link', {
	    staticClass: "tab-item",
	    attrs: {
	      "to": {
	        name: 'routing'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-key"
	  }), _vm._v(" "), _c('span', [_vm._v("Rotas")])])], 1) : _vm._e(), _vm._v(" "), (_vm.refund) ? _c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('router-link', {
	    staticClass: "tab-item",
	    attrs: {
	      "to": {
	        name: 'refund'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-road"
	  }), _vm._v(" "), _c('span', [_vm._v("Contestação")])])], 1) : _vm._e(), _vm._v(" "), _c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('router-link', {
	    staticClass: "tab-item",
	    attrs: {
	      "to": {
	        name: 'profile'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-my-data"
	  }), _vm._v(" "), _c('span', [_vm._v("Meus dados")])])], 1), _vm._v(" "), (_vm.is2FA) ? _c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('router-link', {
	    staticClass: "tab-item",
	    attrs: {
	      "to": {
	        name: 'password-change-confirmation'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-key"
	  }), _vm._v(" "), _c('span', [_vm._v("Alterar senha")])])], 1) : _vm._e(), _vm._v(" "), (!_vm.is2FA) ? _c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('router-link', {
	    staticClass: "tab-item",
	    attrs: {
	      "to": {
	        name: 'password-change'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-key"
	  }), _vm._v(" "), _c('span', [_vm._v("Alterar senha")])])], 1) : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "pull-right",
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    staticClass: "tab-item",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": _vm.logout
	    }
	  }, [_c('i', {
	    staticClass: "icon-logout"
	  }), _vm._v(" "), _c('span', [_vm._v("Sair")])])])])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "tabs-section hidden-print mob",
	    class: {
	      fixed: _vm.scrolling
	    },
	    staticStyle: {
	      "z-index": "9997"
	    },
	    attrs: {
	      "id": "tabs-section"
	    }
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('router-link', {
	    staticClass: "tab-item",
	    attrs: {
	      "to": {
	        name: 'home'
	      }
	    }
	  }, [_c('img', {
	    staticClass: "logo-img",
	    attrs: {
	      "src": __webpack_require__(1838),
	      "alt": "Logo Move Mais TAG",
	      "width": "210"
	    }
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "nav nav-tabs"
	  }, [_c('li', {
	    staticClass: "pull-right",
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    staticClass: "tab-item",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": _vm.logout
	    }
	  }, [_c('i', {
	    staticClass: "icon-logout"
	  }), _vm._v(" "), _c('span', [_vm._v("Sair")])])])])], 1)]), _vm._v(" "), _c('router-view', {
	    class: {
	      'fix-footer': _vm.fixFooter
	    }
	  }), _vm._v(" "), (!_vm.fixFooter) ? _c('div', {
	    staticClass: "footer-mobile hidden-print"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'plans'
	      }
	    }
	  }, [_c('div', {
	    staticClass: "footer-mobile-link word-wrap"
	  }, [_c('i', {
	    staticClass: "icon-padnote"
	  }), _vm._v("\n        Planos\n      ")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'requests'
	      }
	    }
	  }, [_c('div', {
	    staticClass: "footer-mobile-link word-wrap"
	  }, [_c('i', {
	    staticClass: "icon-bell"
	  }), _vm._v("\n        Pedidos\n      ")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'tag-activate'
	      }
	    }
	  }, [_c('div', {
	    staticClass: "footer-mobile-link word-wrap"
	  }, [_c('i', {
	    staticClass: "icon-active-tag"
	  }), _vm._v("\n        Ativar TAG\n      ")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'routing'
	      }
	    }
	  }, [_c('div', {
	    staticClass: "footer-mobile-link word-wrap"
	  }, [_c('i', {
	    staticClass: "icon-routing"
	  }), _vm._v("\n        Viagem\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "dropup footer-mobile-link"
	  }, [_vm._m(2), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu dropdown-menu-right"
	  }, [_c('li', {
	    staticClass: "divider",
	    attrs: {
	      "role": "separator"
	    }
	  }), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'notification'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-mail icon-footer-dropup"
	  }), _vm._v("\n            Notificações\n          ")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "divider",
	    attrs: {
	      "role": "separator"
	    }
	  }), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'profile'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-my-data icon-footer-dropup"
	  }), _vm._v("\n            Meus Dados\n          ")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "divider",
	    attrs: {
	      "role": "separator"
	    }
	  }), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'password-change'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-key icon-footer-dropup"
	  }), _vm._v("\n            Alterar senha\n          ")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "divider",
	    attrs: {
	      "role": "separator"
	    }
	  }), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": _vm.logout
	    }
	  }, [_c('i', {
	    staticClass: "icon-logout icon-footer-dropup"
	  }), _vm._v("\n            Sair\n          ")])])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "bottom-wrap"
	  }), _vm._v(" "), _vm._m(3)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "action-header-txt"
	  }, [_c('img', {
	    staticClass: "icon-exclamation",
	    attrs: {
	      "src": __webpack_require__(501)
	    }
	  }), _vm._v("\n      Trocou a placa do seu veículo para o padrão\n      "), _c('span', {
	    staticClass: "special-font"
	  }, [_vm._v("Mercosul")]), _vm._v("? Não esqueça de atualizar os\n      dados veiculares da sua TAG.\n      "), _c('span', {
	    staticClass: "special-font"
	  }, [_vm._v("Evite multas!")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "action-header-txt"
	  }, [_c('img', {
	    staticClass: "icon-exclamation",
	    attrs: {
	      "src": __webpack_require__(501)
	    }
	  }), _vm._v("\n        Trocou a placa do seu veículo para o padrão\n        "), _c('span', {
	    staticClass: "special-font"
	  }, [_vm._v("Mercosul")]), _vm._v("? Não esqueça de atualizar\n        os dados veiculares da sua TAG.\n        "), _c('span', {
	    staticClass: "special-font"
	  }, [_vm._v("Evite multas!")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, [_c('i', {
	    staticClass: "icon-ellipsis"
	  }), _vm._v("\n        Mais\n      ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    staticClass: "footer footer-inside"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-8 col-md-8"
	  }, [_c('div', {
	    staticClass: "sac-icon-circle"
	  }, [_c('i', {
	    staticClass: "icon-help-desk sac-icon-fix"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "sac-text"
	  }, [_c('p', {
	    staticClass: "bold"
	  }, [_vm._v("central de relacionamento")]), _vm._v(" "), _c('p', [_vm._v("\n              Capitais e regiões metropolitanas\n              "), _c('span', {
	    staticClass: "sac-phone-number"
	  }, [_vm._v("4000 2901")])]), _vm._v(" "), _c('p', [_vm._v("\n              Demais localidades\n              "), _c('span', {
	    staticClass: "sac-phone-number"
	  }, [_vm._v("0800 777 1022")])]), _vm._v(" "), _c('p', [_vm._v("E-mail: "), _c('span', [_vm._v("relacionamento@movemais.com")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4 col-md-4"
	  }, [_c('div', {
	    staticClass: "seals"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1800),
	      "alt": "Sectigo Secure Seal"
	    }
	  })])])])])])
	}]}

/***/ }),
/* 2057 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.vpSelected) ? _c('div', {
	    staticClass: "modal fade modal-block-vehicle",
	    attrs: {
	      "id": "modal-block-vehicle",
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-labelledby": "modal-block-vehicle-label"
	    },
	    on: {
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) { return null; }
	        return _vm.closeModal('close')
	      }
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loadingModal),
	      expression: "loadingModal",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [(!_vm.requestSuccess && _vm.type == 'block') ? _c('h4', {
	    staticClass: "modal-title",
	    attrs: {
	      "id": "modal-block-vehicle-label"
	    }
	  }, [_vm._v("Bloqueio temporário de veículo")]) : _vm._e(), _vm._v(" "), (_vm.requestSuccess && _vm.type == 'block') ? _c('h4', {
	    staticClass: "modal-title",
	    attrs: {
	      "id": "modal-block-vehicle-label"
	    }
	  }, [_vm._v("Bloqueio realizado com sucesso!")]) : _vm._e(), _vm._v(" "), (!_vm.requestSuccess && _vm.type == 'unblock') ? _c('h4', {
	    staticClass: "modal-title",
	    attrs: {
	      "id": "modal-block-vehicle-label"
	    }
	  }, [_vm._v("Desbloqueio temporário de veículo")]) : _vm._e(), _vm._v(" "), (_vm.requestSuccess && _vm.type == 'unblock') ? _c('h4', {
	    staticClass: "modal-title",
	    attrs: {
	      "id": "modal-block-vehicle-label"
	    }
	  }, [_vm._v("Desbloqueio realizado com sucesso!")]) : _vm._e(), _vm._v(" "), (!_vm.requestSuccess && _vm.type == 'delete') ? _c('h4', {
	    staticClass: "modal-title",
	    attrs: {
	      "id": "modal-block-vehicle-label"
	    }
	  }, [_vm._v("Exclusão permanente de veículo")]) : _vm._e(), _vm._v(" "), (_vm.requestSuccess && _vm.type == 'delete') ? _c('h4', {
	    staticClass: "modal-title",
	    attrs: {
	      "id": "modal-block-vehicle-label"
	    }
	  }, [_vm._v("Exclusão realizado com sucesso!")]) : _vm._e(), _vm._v(" "), (!_vm.requestSuccess && _vm.type == 'replace') ? _c('h4', {
	    staticClass: "modal-title",
	    attrs: {
	      "id": "modal-block-vehicle-label"
	    }
	  }, [_vm._v("Substituição de TAG")]) : _vm._e(), _vm._v(" "), (_vm.requestSuccess && _vm.type == 'replace') ? _c('h4', {
	    staticClass: "modal-title",
	    attrs: {
	      "id": "modal-block-vehicle-label"
	    }
	  }, [_vm._v("Substituição realizada com sucesso!")]) : _vm._e()]), _vm._v(" "), (_vm.vpSelected) ? _c('div', {
	    staticClass: "modal-body"
	  }, [(_vm.errorMessage) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('p', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), (!_vm.requestSuccess) ? _c('div', {}, [_c('div', {}, [_c('p', [_vm._v("\n              Agregador:\n              "), _c('span', [_vm._v(_vm._s(_vm.vpSelected.transportador))]), _vm._v("\n               \n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Placa:\n              "), _c('span', [_vm._v(_vm._s(_vm.vpSelected.plate))])]), _vm._v(" "), _c('p', [_vm._v("\n              N° TAG:\n              "), _c('span', [_vm._v(_vm._s(_vm.vpSelected.tagSerialNumber == 0 ? '' : _vm.vpSelected.tagSerialNumber))])])]), _vm._v(" "), (_vm.type == 'replace') ? _c('div', {
	    staticClass: "vehicle-box"
	  }, [_c('div', {
	    staticClass: "tag-box"
	  }, [(!_vm.linkedTag) ? _c('div', [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("N° TAG")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "only-numbers",
	      rawName: "v-only-numbers"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.serialNumber),
	      expression: "serialNumber"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "value": "",
	      "data-vv-rules": "required|numeric"
	    },
	    domProps: {
	      "value": (_vm.serialNumber)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.serialNumber = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "disabled": String(_vm.serialNumber).length == 0 || !_vm.serialNumber,
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.doReplaceTag()
	      }
	    }
	  }, [_vm._v("Ativar")])]) : (_vm.linkedTag == 'success') ? _c('div', {
	    staticClass: "alert alert-success"
	  }, [_c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("N° TAG: " + _vm._s(_vm.serialNumber == 0 ? '' : _vm.serialNumber))])]) : _c('div', [_c('div', {
	    staticClass: "alert alert-danger inline"
	  }, [_c('p', [_vm._v(_vm._s(_vm.msg))])]), _vm._v(" "), _c('button', {
	    staticClass: "no-btn",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.linkedTag = !_vm.linkedTag
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-repeat"
	  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    class: (_vm.type == 'delete' || _vm.type == 'unblock') ? 'margin-b30' : ''
	  }, [_c('button', {
	    staticClass: "no-btn",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("Cancelar")]), _vm._v(" "), (_vm.type == 'block') ? _c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.doRequestBlock()
	      }
	    }
	  }, [_vm._v("\n              Bloquear\n            ")]) : _vm._e(), _vm._v(" "), (_vm.type == 'unblock') ? _c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.doRequestUnblock()
	      }
	    }
	  }, [_vm._v("\n              Desbloquear\n            ")]) : _vm._e(), _vm._v(" "), (_vm.type == 'delete') ? _c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.doRequestDelete()
	      }
	    }
	  }, [_vm._v("\n              Excluir\n            ")]) : _vm._e(), _vm._v(" "), (_vm.type == 'block') ? _c('small', [_vm._v("O desbloqueio poderá ser feito na página de agregadores.")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.requestSuccess) ? _c('div', {
	    staticClass: "content-box success text-center"
	  }, [_c('p', [_vm._v("Agregador: "), _c('strong', {
	    staticStyle: {
	      "color": "#505050"
	    }
	  }, [_vm._v(_vm._s(_vm.vpSelected.transportador))])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "display": "flex",
	      "justify-content": "space-between",
	      "align-items": "center"
	    }
	  }, [_c('p', [_vm._v("Placa: "), _c('strong', {
	    staticStyle: {
	      "border": "1px solid #848484",
	      "padding": "3px",
	      "border-radius": "3px"
	    }
	  }, [_vm._v(_vm._s(_vm.vpSelected.plate))])]), _vm._v(" "), _c('p', [_vm._v("Nº TAG: "), _c('strong', [_vm._v(_vm._s(_vm.vpSelected.tagSerialNumber == 0 ? '' : _vm.vpSelected.tagSerialNumber))])])]), _vm._v(" "), _c('img', {
	    staticClass: "margin-10",
	    attrs: {
	      "src": "/static/Icon-check-circle.svg",
	      "alt": "icon-check-circle"
	    }
	  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeModal('ok')
	      }
	    }
	  }, [_vm._v("OK")])]) : _vm._e()]) : _vm._e()])])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2058 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("\n        Planos\n        "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Agregadores "), _vm._v(" "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Resgatar saldo\n      ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "header-action margin-t20"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-4 col-md-5"
	  }, [_c('div', {
	    staticClass: "form-group search"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.plate),
	      expression: "plate",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "mask-plate",
	      rawName: "v-mask-plate"
	    }],
	    staticClass: "form-control upper",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "value": "",
	      "data-vv-validate-on": "blur",
	      "autofocus": "autofocus",
	      "placeholder": "Buscar por placa"
	    },
	    domProps: {
	      "value": (_vm.plate)
	    },
	    on: {
	      "change": function($event) {
	        _vm.plate = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "icon-search-input"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-5 col-md-4"
	  }, [_c('div', {
	    staticClass: "text-center filter-inline middle"
	  }, [_c('p', {
	    staticClass: "no-margin inline"
	  }, [_vm._v("Filtros")]), _vm._v(" "), _c('div', {
	    staticClass: "btn-group",
	    attrs: {
	      "data-toggle": "buttons"
	    }
	  }, [_c('label', {
	    staticClass: "btn btn-filter",
	    class: {
	      'active': _vm.lastDays == '31'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.handleChangeDate('31')
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "radio",
	      "name": "options",
	      "id": "month",
	      "value": "31"
	    },
	    domProps: {
	      "checked": _vm.lastDays == '31'
	    }
	  }), _vm._v(" Mês\n              ")]), _vm._v(" "), _c('label', {
	    staticClass: "btn btn-filter",
	    class: {
	      'active': _vm.lastDays == '15'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.handleChangeDate('15')
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "radio",
	      "name": "options",
	      "id": "fortnight",
	      "value": "15"
	    },
	    domProps: {
	      "checked": _vm.lastDays == '15'
	    }
	  }), _vm._v(" Quinzena\n              ")]), _vm._v(" "), _c('label', {
	    staticClass: "btn btn-filter",
	    class: {
	      'active': _vm.lastDays == '7'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.handleChangeDate('7')
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "radio",
	      "name": "options",
	      "id": "week",
	      "value": "7"
	    },
	    domProps: {
	      "checked": _vm.lastDays == '7'
	    }
	  }), _vm._v(" Semana\n              ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3 col-md-3"
	  }, [_c('h4', [_vm._v(_vm._s(_vm._f("cents")(_vm.totalRescue)))]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-purple btn-square upper",
	    attrs: {
	      "type": "button",
	      "name": "button",
	      "disabled": _vm.rescueData.length == 0
	    },
	    on: {
	      "click": function($event) {
	        return _vm.rescueBalance()
	      }
	    }
	  }, [_vm._v("\n          Resgatar Saldo\n          "), _c('i', {
	    staticClass: "icomoon-arrow-right"
	  })])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    staticClass: "table-responsive"
	  }, [(_vm.searchState == 'FOUND') ? _c('table', {
	    staticClass: "table table-flat",
	    attrs: {
	      "id": "table-rescue-balance"
	    }
	  }, [_c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "width": "3%"
	    }
	  }, [_c('div', {}, [_c('input', {
	    staticClass: "check-item",
	    attrs: {
	      "type": "checkbox",
	      "name": "listTransactionRefund",
	      "id": "selectAll",
	      "value": "selectAll"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.checkAll()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "label-item",
	    attrs: {
	      "for": "selectAll"
	    }
	  })])]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "width": "10%"
	    }
	  }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "40%"
	    }
	  }, [_vm._v("Transportador")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "width": "15%"
	    }
	  }, [_vm._v("Último VP")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "width": "15%"
	    }
	  }, [_vm._v("Última passagem")]), _vm._v(" "), _c('th', {
	    staticClass: "text-right",
	    attrs: {
	      "width": "17%"
	    }
	  }, [_vm._v("Saldo VP")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.vehiclesBalance), function(item, index) {
	    return _c('tr', {
	      key: index
	    }, [_c('td', [_c('div', {
	      class: item.plate
	    }, [_c('input', {
	      staticClass: "check-item",
	      attrs: {
	        "type": "checkbox",
	        "name": "listTransactionRefund",
	        "id": index
	      },
	      domProps: {
	        "value": index
	      },
	      on: {
	        "click": function($event) {
	          return _vm.check(index)
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      staticClass: "label-item",
	      attrs: {
	        "for": index
	      }
	    })])]), _vm._v(" "), _c('td', {
	      staticClass: "text-center bold td-plate"
	    }, [_c('span', {
	      directives: [{
	        name: "mask-plate",
	        rawName: "v-mask-plate"
	      }]
	    }, [_vm._v(_vm._s(item.plate))]), _vm._v(" "), _c('span', {
	      staticClass: "hide"
	    }, [_vm._v(_vm._s(item.contractIdAgr))]), _vm._v(" "), _c('span', {
	      staticClass: "hide"
	    }, [_vm._v(_vm._s(item.contractIdVp))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.transportador))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(_vm._f("date")(item.lastVp)))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(_vm._f("date")(item.lastPassage)))]), _vm._v(" "), _c('td', {
	      staticClass: "text-right"
	    }, [_c('span', [_vm._v(_vm._s(_vm._f("cents")(item.saldoVp)))]), _vm._v(" "), _c('span', {
	      staticClass: "hide"
	    }, [_vm._v(_vm._s(item.transferValue))]), _vm._v(" "), _c('span', {
	      staticClass: "hide"
	    }, [_vm._v(_vm._s(item.taxValue))])])])
	  }), 0)]) : _c('div', {
	    staticClass: "alert alert-warning"
	  }, [_c('p', [_vm._v("Não existem veículos com saldo de Vale-pedágio.")])])]), _vm._v(" "), (_vm.vehiclesBalance && _vm.searchState == 'FOUND') ? [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 result-table-count"
	  }, [_vm._v("\n        Mostrando resultados de " + _vm._s(_vm.page.firstIndexShown()) + " a " + _vm._s(_vm.page.lastIndexShown()) + " de um total de " + _vm._s(_vm.page.itemCount()) + "\n        encontrados.\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "row results"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('router-link', {
	    staticClass: "btn no-btn btn-square margin-10",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button"
	    }
	  }, [_vm._v("\n          Voltar\n        ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 text-center"
	  }, [_c('pagination', {
	    attrs: {
	      "model": _vm.page
	    },
	    on: {
	      "page-change": _vm.setCurrentPage
	    }
	  }), _vm._v(" "), _c('router-link', {
	    staticClass: "btn no-btn btn-square margin-10",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button"
	    }
	  }, [_vm._v("\n          Voltar\n        ")])], 1)])] : _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('router-link', {
	    staticClass: "btn no-btn btn-square margin-10",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button"
	    }
	  }, [_vm._v("\n        Voltar\n      ")])], 1)]), _vm._v(" "), (_vm.showRescue) ? _c('modal-rescue-balance', {
	    attrs: {
	      "rescueData": _vm.rescueData
	    },
	    on: {
	      "close": _vm.close
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 2059 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("\n        Identificação \n        "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" "), [_vm._v("Validação de token")]], 2), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('p', [_vm._v("Escolha um canal para validar seu código: ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "row border-row row-fix"
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "content-box-small margin-t80"
	  }, [(_vm.errorMessage) ? _c('div', {
	    staticClass: "alert alert-danger margin-b20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.errorMessage) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('form', {
	    attrs: {
	      "autocomplete": "false"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.doRequest.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "chooseChannel"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.channelSelected),
	      expression: "channelSelected"
	    }],
	    attrs: {
	      "id": "chooseEmailId",
	      "type": "radio",
	      "value": "EMAIL",
	      "name": "chooseChannelForm"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.channelSelected, "EMAIL")
	    },
	    on: {
	      "change": function($event) {
	        _vm.channelSelected = "EMAIL"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "chooseEmailId"
	    }
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.channelSelected),
	      expression: "channelSelected"
	    }],
	    attrs: {
	      "id": "chooseCellphoneId",
	      "type": "radio",
	      "value": "SMS",
	      "name": "chooseChannelForm"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.channelSelected, "SMS")
	    },
	    on: {
	      "change": function($event) {
	        _vm.channelSelected = "SMS"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "chooseCellphoneId"
	    }
	  }, [_vm._v("Celular")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-lg btn-purple",
	    staticStyle: {
	      "margin-top": "2%"
	    },
	    attrs: {
	      "id": "btn-login",
	      "type": "submit",
	      "name": "button"
	    }
	  }, [_vm._v("\n                  Continuar\n                ")]), _vm._v(" "), _c('i', {
	    staticClass: "icon-circle-right align-icon"
	  })])])])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-back margin-t20",
	    attrs: {
	      "to": "/login",
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n        Voltar\n      ")])], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "circle-key"
	  })])
	}]}

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "fade-in",
	      "appear": ""
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostrarModal),
	      expression: "mostrarModal"
	    }],
	    staticClass: "modal-main fade-in",
	    staticStyle: {
	      "z-index": "99999"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('span', {
	    staticClass: "close",
	    staticStyle: {
	      "position": "absolute",
	      "top": "10px",
	      "right": "10px"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.fecharModal()
	      }
	    }
	  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "header-content"
	  }, [_c('h2', [_vm._v("Meus Contratos e Planos")])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [(_vm.contracts.length === 0) ? [_c('p', [_vm._v("Nenhuma placa no padrão antigo encontrada nos seus contratos!")])] : [_c('div', {
	    staticClass: "table-container"
	  }, [_c('table', {
	    staticClass: "styled-table"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Contrato")]), _vm._v(" "), _c('th', [_vm._v("Plano")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.contracts), function(contract, index) {
	    return _c('tr', {
	      key: index
	    }, [_c('td', [_vm._v(_vm._s(contract.contractId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(contract.name))]), _vm._v(" "), _c('td', [_c('router-link', {
	      attrs: {
	        "to": {
	          name: 'contract-vehicles',
	          params: {
	            contractId: contract.contractId
	          },
	        }
	      }
	    }, [(!_vm.isMobile) ? _c('button', {
	      staticClass: "stilizedButton"
	    }, [_vm._v("\n                        Veículos Cadastrados\n                        "), _c('img', {
	      staticClass: "redirect-button",
	      attrs: {
	        "src": __webpack_require__(498)
	      }
	    })]) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('button', {
	      staticClass: "stilizedButton"
	    }, [_c('img', {
	      staticClass: "redirect-button",
	      attrs: {
	        "src": __webpack_require__(498)
	      }
	    })]) : _vm._e()])], 1)])
	  }), 0)])])]], 2), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "close-button",
	    on: {
	      "click": function($event) {
	        return _vm.fecharModal()
	      }
	    }
	  }, [_vm._v("Fechar")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "row border-row row-fix"
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "content-box-small margin-t80"
	  }, [(_vm.formState == 'ERROR') ? _c('div', {
	    staticClass: "alert alert-danger alert-dismissible margin-t20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Erro!")]), _vm._v("\n              " + _vm._s(_vm.errorMessage) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'SUCCESS') ? _c('div', {
	    staticClass: "alert alert-success alert-dismissible margin-t20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Sucesso!")]), _vm._v("\n              " + _vm._s(_vm.successMessage) + ". Pode retornar à tela inicial!\n            ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'NEW' || _vm.formState == 'ERROR') ? _c('form', {
	    attrs: {
	      "autocomplete": "false"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.doRequest.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group margin-b20",
	    class: {
	      'has-error': _vm.errors.has('telefone')
	    }
	  }, [_c('label', [_vm._v("Telefone celular:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.phone),
	      expression: "phone"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "telefone",
	      "id": "telefone",
	      "placeholder": "Insira número de celular",
	      "data-vv-validate-on": "blur",
	      "autofocus": ""
	    },
	    domProps: {
	      "value": (_vm.phone)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.phone = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('telefone')))])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-lg btn-purple",
	    attrs: {
	      "id": "btn-login",
	      "type": "submit",
	      "name": "button"
	    }
	  }, [_vm._v("\n                Enviar\n              ")]), _vm._v(" "), _c('i', {
	    staticClass: "icon-circle-right align-icon"
	  })]) : _vm._e()])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-back margin-t20",
	    attrs: {
	      "to": "/login",
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n        Voltar\n      ")])], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("\n        Identificação "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n        Esqueci meu e-mail de autenticação\n      ")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('p', [_vm._v("Informe o número de celular cadastrado em sua conta.")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('img', {
	    staticClass: "img-contact",
	    attrs: {
	      "src": __webpack_require__(503),
	      "alt": "Contato"
	    }
	  })])
	}]}

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('form', {
	    staticClass: "credit-card",
	    attrs: {
	      "id": "adyen-encrypted-form"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-box margin-b20"
	  }, [_c('b', {
	    staticClass: "title-identification margin-b10"
	  }, [_vm._v("Informações do Cartão de Crédito dasdasds")]), _vm._v(" "), _c('div', {
	    staticClass: "form-content"
	  }, [(_vm.checkPromoSenff || _vm.creditCard.paymentMethodId == 22) ? _c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("\n              Para sua segurança, esta venda é permitida apenas com o Cartão Virtual.\n              "), _c('br'), _vm._v("\n              Acesse o App ou site Senff para gerá-lo e em caso de dúvidas,\n              "), _c('a', {
	    staticClass: "link-senff",
	    attrs: {
	      "target": "_blank",
	      "href": "https://www.senff.com.br/cartao-virtual-senff/"
	    }
	  }, [_vm._v("clique aqui.")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-t20"
	  }, [_c('div', {
	    staticClass: "cc-box"
	  }, [_c('label', {
	    staticClass: "bold",
	    attrs: {
	      "for": "brand"
	    }
	  }, [_vm._v("Bandeira:")]), _vm._v(" "), (!_vm.checkPromoSenff && _vm.showBandeira('Visa')) ? _c('div', {
	    staticClass: "radio inline",
	    on: {
	      "click": function($event) {
	        return _vm.select('visa')
	      }
	    }
	  }, [_c('label', [_c('input', {
	    attrs: {
	      "type": "radio",
	      "name": "optradio"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "credit-card-selection visa",
	    class: {
	      selected: _vm.creditCard.paymentMethodId == 6
	    },
	    attrs: {
	      "src": "/static/payment-methods/visa.svg",
	      "width": "31",
	      "height": "28"
	    }
	  })])]) : _vm._e(), _vm._v(" "), (!_vm.checkPromoSenff && _vm.showBandeira('Mastercard')) ? _c('div', {
	    staticClass: "radio inline",
	    on: {
	      "click": function($event) {
	        return _vm.select('master')
	      }
	    }
	  }, [_c('label', [_c('input', {
	    attrs: {
	      "type": "radio",
	      "name": "optradio"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "credit-card-selection master",
	    class: {
	      selected: _vm.creditCard.paymentMethodId == 7
	    },
	    attrs: {
	      "src": "/static/payment-methods/master.svg",
	      "width": "31",
	      "height": "28"
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.showElo && !_vm.checkPromoSenff && _vm.showBandeira('Elo')) ? _c('div', {
	    staticClass: "radio inline",
	    on: {
	      "click": function($event) {
	        return _vm.select('elo')
	      }
	    }
	  }, [_c('label', [_c('input', {
	    attrs: {
	      "type": "radio",
	      "name": "optradio"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "credit-card-selection elo",
	    class: {
	      selected: _vm.creditCard.paymentMethodId == 10
	    },
	    attrs: {
	      "src": "/static/payment-methods/elo.svg",
	      "width": "31",
	      "height": "28"
	    }
	  })])]) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.brand),
	      expression: "brand"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "type": "text",
	      "name": "brand",
	      "id": "brand"
	    },
	    domProps: {
	      "value": (_vm.brand)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.brand = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "info-card no-margin line-height-20"
	  }, [_vm._v("Selecione uma Bandeira.")]), _vm._v(" "), _c('div', {
	    staticClass: "msg-error-brand",
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "id": "msg-error-brand"
	    }
	  }, [_vm._v("\n              Por favor, selecione uma bandeira.\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-t20",
	    class: {
	      'has-error': _vm.errors.has('number')
	    }
	  }, [_c('div', {
	    staticClass: "cc-box"
	  }, [_c('label', {
	    staticClass: "bold",
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Número do cartão:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.creditCard.number),
	      expression: "creditCard.number",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "mask-card",
	      rawName: "v-mask-card"
	    }],
	    staticClass: "form-control number inline",
	    attrs: {
	      "name": "number",
	      "type": "text",
	      "data-vv-validate-on": "blur",
	      "data-encrypted-name": "number"
	    },
	    domProps: {
	      "value": (_vm.creditCard.number)
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.errorBrand()
	      },
	      "change": function($event) {
	        return _vm.$set(_vm.creditCard, "number", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "info-card no-margin line-height-20"
	  }, [_vm._v("Insira os números sem espaços ou sinais.")]), _vm._v(" "), _c('div', {
	    staticClass: "help-block cc"
	  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('number')) + "\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('expire')
	    }
	  }, [_c('label', {
	    staticClass: "bold",
	    staticStyle: {
	      "display": "block"
	    },
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Validade:")]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "width100 inline"
	  }, [_c('label', {
	    staticClass: "bold",
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Mês:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.creditCard.expirationMonth),
	      expression: "creditCard.expirationMonth"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:2|max_value:12|min_value:1'),
	      expression: "'required|min:2|max_value:12|min_value:1'"
	    }],
	    staticClass: "form-control block",
	    attrs: {
	      "name": "expire",
	      "type": "text",
	      "data-encrypted-name": "expiryMonth",
	      "minlength": "2",
	      "maxlength": "2",
	      "placeholder": "12"
	    },
	    domProps: {
	      "value": (_vm.creditCard.expirationMonth)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.creditCard, "expirationMonth", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "width100 inline"
	  }, [_c('label', {
	    staticClass: "bold",
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Ano:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.creditCard.expirationYear),
	      expression: "creditCard.expirationYear"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:4|min_value:' + _vm.thisYear),
	      expression: "'required|min:4|min_value:'+thisYear"
	    }],
	    staticClass: "form-control block",
	    attrs: {
	      "name": "expire",
	      "type": "text",
	      "data-encrypted-name": "expiryYear",
	      "minlength": "4",
	      "maxlength": "4",
	      "placeholder": "2030"
	    },
	    domProps: {
	      "value": (_vm.creditCard.expirationYear)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.creditCard, "expirationYear", $event.target.value)
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group help margin-b20",
	    class: {
	      'has-error': _vm.errors.has('ownerName')
	    },
	    staticStyle: {
	      "display": "inline-block"
	    }
	  }, [_c('label', {
	    staticClass: "bold",
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Nome do titular do Cartão de Crédito:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.creditCard.ownerName),
	      expression: "creditCard.ownerName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control name",
	    attrs: {
	      "type": "text",
	      "maxlength": "80",
	      "data-encrypted-name": "holderName",
	      "name": "ownerName"
	    },
	    domProps: {
	      "value": (_vm.creditCard.ownerName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.creditCard, "ownerName", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('ownerName')) + "\n            ")])]), _vm._v(" "), (_vm.showCvv) ? _c('div', {
	    staticClass: "form-group help right margin-b20",
	    class: {
	      'has-error': _vm.errors.has('cvv')
	    },
	    staticStyle: {
	      "display": "inline-block"
	    }
	  }, [_c('label', {
	    staticClass: "label-csc",
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Código de Segurança:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.creditCard.cvv),
	      expression: "creditCard.cvv"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:3'),
	      expression: "'required|min:3'"
	    }, {
	      name: "only-numbers",
	      rawName: "v-only-numbers"
	    }],
	    staticClass: "form-control csc",
	    attrs: {
	      "type": "text",
	      "name": "cvv",
	      "maxlength": "4",
	      "data-encrypted-name": "cvc"
	    },
	    domProps: {
	      "value": (_vm.creditCard.cvv)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.creditCard, "cvv", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(226),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('cvv')) + "\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "form-box"
	  }, [_c('address-comp', {
	    ref: "addressBilling",
	    attrs: {
	      "address": _vm.address,
	      "type": "BILLING"
	    }
	  })], 1)])]), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "data-encrypted-name": "generationtime"
	    },
	    domProps: {
	      "value": _vm.dateTime
	    }
	  }), _vm._v(" "), _c('input', {
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "type": "submit",
	      "value": "Pay",
	      "id": "adyenSubmit"
	    }
	  })])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('br'), _vm._v("O endereço abaixo "), _c('b', [_vm._v("NÃO")]), _vm._v(" é o de entrega de TAGs")])
	}]}

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [(_vm.dataTransfer) ? _c('title-user', [_vm._v("\n        Comprovantes\n        "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Comprovante " + _vm._s(_vm.dataTransfer.transferId) + "\n      ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    staticClass: "form-box margin-t20"
	  }, [(_vm.dataTransfer && _vm.dataTransfer.transferId) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-content"
	  }, [_c('img', {
	    staticClass: "rule-color",
	    attrs: {
	      "src": __webpack_require__(116),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "number-receipt"
	  }, [_vm._v(_vm._s(_vm.dataTransfer.transferId))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', {
	    staticClass: "title-toll-left upper bold"
	  }, [_vm._v("dados da conta debitada")]), _vm._v(" "), _c('p', {
	    staticClass: "title-toll-right"
	  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "box-toll-right"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', {
	    staticClass: "three-dots bold margin-l5"
	  }, [_vm._v(_vm._s(_vm.dataTransfer.userDeb) + "  ")]), _vm._v(" "), _c('p', {
	    staticClass: "three-dots bold margin-l5"
	  }, [_vm._v(_vm._s(_vm.dataTransfer.contractIddeb) + "  ")]), _vm._v(" "), _c('p', {
	    staticClass: "three-dots bold margin-l5"
	  }, [_vm._v(_vm._s(_vm._f("dateTime")(_vm.dataTransfer.createdDate)) + "  ")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', {
	    staticClass: "title-doc-left upper bold"
	  }, [_vm._v("dados da conta creditada")]), _vm._v(" "), _c('p', {
	    staticClass: "title-doc-right credit"
	  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "box-doc-right"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', {
	    staticClass: "three-dots bold margin-l5"
	  }, [_vm._v(_vm._s(_vm.dataTransfer.userCred) + "  ")]), _vm._v(" "), _c('p', {
	    staticClass: "three-dots bold margin-l5"
	  }, [_vm._v(_vm._s(_vm.dataTransfer.contractIdCred) + "  ")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', {
	    staticClass: "title-value-left upper bold"
	  }, [_vm._v("valor")]), _vm._v(" "), _c('p', {
	    staticClass: "title-value-right"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', {
	    staticClass: "three-dots text-center bold value-receipt"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.dataTransfer.transferValue)) + "  ")])])]), _vm._v(" "), _c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("   ")])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "row hidden-print"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "margin-t20"
	  }, [_c('div', {
	    staticClass: "back-button-box"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n            Voltar\n          ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "action-buttons-box"
	  }, [_c('button', {
	    staticClass: "btn btn-back",
	    on: {
	      "click": function($event) {
	        return _vm.window.print()
	      }
	    }
	  }, [_vm._v("\n            Imprimir\n            "), _c('i', {
	    staticClass: "icon-printer align-icon-left"
	  })])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('img', {
	    staticClass: "logo-receipt",
	    attrs: {
	      "src": __webpack_require__(158),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('h4', {
	    staticClass: "title-receipt"
	  }, [_vm._v("comprovante de transferência de créditos")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-toll-left"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', {
	    staticClass: "three-dots text-right margin-r5"
	  }, [_vm._v("Nome da empresa:")]), _vm._v(" "), _c('p', {
	    staticClass: "three-dots text-right margin-r5"
	  }, [_vm._v("N° do Contrato:")]), _vm._v(" "), _c('p', {
	    staticClass: "three-dots text-right margin-r5"
	  }, [_vm._v("Data da transferência:")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-doc-left"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', {
	    staticClass: "three-dots text-right margin-r5"
	  }, [_vm._v("Nome da empresa:")]), _vm._v(" "), _c('p', {
	    staticClass: "three-dots text-right margin-r5"
	  }, [_vm._v("N° do Contrato:")])])])])
	}]}

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "slide-down",
	      "appear": ""
	    }
	  }, [_c('div', {
	    staticClass: "modal-horario"
	  }, [_c('div', {
	    staticClass: "modal-content-horario"
	  }, [_c('div', {
	    staticClass: "modal-header-horario"
	  }, [_c('div', {
	    staticClass: "header-content-horario"
	  }, [_c('h1', [_vm._v("Horário de funcionamento")])]), _vm._v(" "), _c('div', {
	    staticClass: "container-icon",
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": _vm.fecharModal
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1806)
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body-horario"
	  }, [_c('div', {
	    staticClass: "item-modal-left"
	  }, [_c('div', {
	    staticClass: "item-day"
	  }, [_c('label', {
	    staticClass: "item-day-topic"
	  }, [_vm._v("Segunda-feira")]), _vm._v(" "), _c('label', {
	    staticClass: "item-day-topic"
	  }, [_vm._v("Terça-feira")]), _vm._v(" "), _c('label', {
	    staticClass: "item-day-topic"
	  }, [_vm._v("Quarta-feira")]), _vm._v(" "), _c('label', {
	    staticClass: "item-day-topic"
	  }, [_vm._v("Quinta-feira")]), _vm._v(" "), _c('label', {
	    staticClass: "item-day-topic"
	  }, [_vm._v("Sexta-feira")]), _vm._v(" "), _c('label', {
	    staticClass: "item-day-topic"
	  }, [_vm._v("Sábado")]), _vm._v(" "), _c('label', {
	    staticClass: "item-day-topic"
	  }, [_vm._v("Domingo")]), _vm._v(" "), _c('label', {
	    staticClass: "item-day-topic"
	  }, [_vm._v("Feriados")])])]), _vm._v(" "), _c('div', {
	    staticClass: "item-modal-right"
	  }, [_c('div', {
	    staticClass: "item-horarios"
	  }, [_c('label', {
	    staticClass: "item-horarios-topic"
	  }, [_vm._v("\n    " + _vm._s(_vm.segundaPeriodo1) + "\n    "), (_vm.segundaPeriodo1 !== 'Aberto 24 horas' && _vm.segundaPeriodo1 !== 'Não informado') ? _c('span', [_vm._v(" | " + _vm._s(_vm.segundaPeriodo2))]) : _vm._e()]), _vm._v(" "), _c('label', {
	    staticClass: "item-horarios-topic"
	  }, [_vm._v("\n    " + _vm._s(_vm.tercaPeriodo1) + "\n    "), (_vm.tercaPeriodo1 !== 'Aberto 24 horas' && _vm.tercaPeriodo1 !== 'Não informado') ? _c('span', [_vm._v(" | " + _vm._s(_vm.tercaPeriodo2))]) : _vm._e()]), _vm._v(" "), _c('label', {
	    staticClass: "item-horarios-topic"
	  }, [_vm._v("\n    " + _vm._s(_vm.quartaPeriodo1) + "\n    "), (_vm.quartaPeriodo1 !== 'Aberto 24 horas' && _vm.quartaPeriodo1 !== 'Não informado') ? _c('span', [_vm._v(" | " + _vm._s(_vm.quartaPeriodo2))]) : _vm._e()]), _vm._v(" "), _c('label', {
	    staticClass: "item-horarios-topic"
	  }, [_vm._v("\n    " + _vm._s(_vm.quintaPeriodo1) + "\n    "), (_vm.quintaPeriodo1 !== 'Aberto 24 horas' && _vm.quintaPeriodo1 !== 'Não informado') ? _c('span', [_vm._v(" | " + _vm._s(_vm.quintaPeriodo2))]) : _vm._e()]), _vm._v(" "), _c('label', {
	    staticClass: "item-horarios-topic"
	  }, [_vm._v("\n    " + _vm._s(_vm.sextaPeriodo1) + "\n    "), (_vm.sextaPeriodo1 !== 'Aberto 24 horas' && _vm.sextaPeriodo1 !== 'Não informado') ? _c('span', [_vm._v(" | " + _vm._s(_vm.sextaPeriodo2))]) : _vm._e()]), _vm._v(" "), _c('label', {
	    staticClass: "item-horarios-topic"
	  }, [_vm._v("\n    " + _vm._s(_vm.sabadoPeriodo1) + "\n    "), (_vm.sabadoPeriodo1 !== 'Aberto 24 horas' && _vm.sabadoPeriodo1 !== 'Não informado') ? _c('span', [_vm._v(" | " + _vm._s(_vm.sabadoPeriodo2))]) : _vm._e()]), _vm._v(" "), _c('label', {
	    staticClass: "item-horarios-topic"
	  }, [_vm._v("\n    " + _vm._s(_vm.domingoPeriodo1) + "\n    "), (_vm.domingoPeriodo1 !== 'Aberto 24 horas' && _vm.domingoPeriodo1 !== 'Não informado') ? _c('span', [_vm._v(" | " + _vm._s(_vm.domingoPeriodo2))]) : _vm._e()]), _vm._v(" "), _c('label', {
	    staticClass: "item-horarios-topic"
	  }, [_vm._v("\n    " + _vm._s(_vm.feriadoPeriodo1) + "\n    "), (_vm.feriadoPeriodo1 !== 'Aberto 24 horas' && _vm.feriadoPeriodo1 !== 'Não informado') ? _c('span', [_vm._v(" | " + _vm._s(_vm.feriadoPeriodo2))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer-horario"
	  })])])])])
	},staticRenderFns: []}

/***/ }),
/* 2065 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "container-fluid"
	  }, [_c('div', {
	    staticClass: "summary-desk"
	  }, [(_vm.aggregate) ? _c('div', {
	    staticClass: "content-box-npadd"
	  }, [_c('p', [_vm._v("Dados do agregador e veículo")]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("Nome/Razão Social: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.companyName))])]), _vm._v(" "), _c('p', [_vm._v("CPF/CNPJ: "), _c('span', [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.aggregate.taxIdNumber)))])])]), _vm._v(" "), (_vm.aggregate.taxpayerTransportador) ? _c('div', {}, [_c('p', [_vm._v("Dados do transportador")]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("Nome/Razão Social: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.nomeTransportador))])]), _vm._v(" "), _c('p', [_vm._v("CPF/CNPJ: "), _c('span', [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.aggregate.taxpayerTransportador)))])])])]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("Placa: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.plate))])]), _vm._v(" "), _c('p', [_vm._v("TAG N°: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.tagSerialNumber))])]), _vm._v(" "), _c('p', [_vm._v("Modelo: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.nodelName))])]), _vm._v(" "), _c('p', [_vm._v("Marca: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.brandName))])]), _vm._v(" "), _c('p', [_vm._v("Eixos: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.category))])])])]) : _vm._e(), _vm._v(" "), (_vm.showDetails) ? _c('div', {
	    staticClass: "content-box-npadd"
	  }, [_c('div', {
	    staticClass: "toll-info-box"
	  }, [_c('div', {}, [_c('div', {}, [_c('small', [_vm._v("De")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.origin.city))]), _vm._v(" "), _c('small', [_c('img', {
	    attrs: {
	      "src": "/static/icon-send.svg",
	      "alt": "icon send"
	    }
	  }), _vm._v("\n                " + _vm._s(_vm.origin.state) + "\n              ")])]), _vm._v(" "), _c('div', {}, [_c('small', [_vm._v("para")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.destination.city))]), _vm._v(" "), _c('small', [_c('img', {
	    attrs: {
	      "src": "/static/icon-location.svg",
	      "alt": "icon location"
	    }
	  }), _vm._v("\n                " + _vm._s(_vm.destination.state) + "\n              ")])])]), _vm._v(" "), _c('button', {
	    staticClass: "no-btn",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.open = !_vm.open
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-right",
	    class: !_vm.open ? 'open' : ''
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "toll-info-box",
	    style: ({
	      display: 'flex',
	      alignItems: 'left',
	      justifyContent: 'space-between',
	      width: '100%'
	    })
	  }, [_c('p', [_vm._v("\n              rota:\n              "), _c('span', [_vm._v(_vm._s(_vm.routeSelected.name))])]), _vm._v(" "), _c('p', [_vm._v("\n              distância:\n              "), _c('span', [_vm._v(_vm._s(_vm.routeSelected.totalDistance) + " KM")])]), _vm._v(" "), _c('p', [_vm._v("\n              valor:\n              "), _c('span', [_vm._v(_vm._s(_vm._f("cents")(_vm.priceTolls.totalValue)))])]), _vm._v(" "), _c('p', [_vm._v("\n              inicio:\n              "), _c('span', [_vm._v(" " + _vm._s(_vm._f("date")(_vm.routeSelected.startToll)))])]), _vm._v(" "), _c('p', [_vm._v("\n              expiração:\n              "), _c('span', [_vm._v(" " + _vm._s(_vm._f("date")(_vm.routeSelected.expirationToll)))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "table-toll-info",
	    class: !_vm.open ? 'open' : ''
	  }, [_c('table', {
	    staticClass: "table"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.priceTolls.tolls), function(p, index) {
	    return _c('tr', {
	      key: index
	    }, [_c('td', [_vm._v(_vm._s(p.praca))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.concessionaria))]), _vm._v(" "), _c('td', {
	      staticClass: "text-right"
	    }, [_vm._v(_vm._s(_vm._f("cents")(p.price)))])])
	  }), 0)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "summary-mob"
	  }, [(_vm.aggregate) ? _c('div', {
	    staticClass: "content-box"
	  }, [_c('p', {
	    staticClass: "bold-600"
	  }, [_vm._v("Dados do agregador e veículo")]), _vm._v(" "), _c('p', [_c('span', {
	    staticClass: "bold-600"
	  }, [_vm._v("Razão Social: ")]), _c('br'), _vm._v("\n          " + _vm._s(_vm.aggregate.companyName) + "\n        ")]), _vm._v(" "), _c('p', [_c('span', {
	    staticClass: "bold-600"
	  }, [_vm._v("CPF/CNPJ: ")]), _vm._v("\n          " + _vm._s(_vm._f("cpfCnpj")(_vm.aggregate.taxIdNumber)) + "\n        ")]), _vm._v(" "), _c('p', {
	    staticClass: "inline margin-r10"
	  }, [_c('span', {
	    staticClass: "bold-600"
	  }, [_vm._v("Placa: ")]), _vm._v("\n          " + _vm._s(_vm.aggregate.plate) + "\n        ")]), _vm._v(" "), _c('p', {
	    staticClass: "inline"
	  }, [_c('span', {
	    staticClass: "bold-600"
	  }, [_vm._v("TAG N°: ")]), _vm._v("\n          " + _vm._s(_vm.aggregate.tagSerialNumber) + "\n        ")]), _vm._v(" "), _c('p', [_c('span', {
	    staticClass: "bold-600"
	  }, [_vm._v("Modelo: ")]), _vm._v("\n          " + _vm._s(_vm.aggregate.modelName) + "\n        ")]), _vm._v(" "), _c('p', {
	    staticClass: "inline margin-r10"
	  }, [_c('span', {
	    staticClass: "bold-600"
	  }, [_vm._v("Marca: ")]), _vm._v("\n          " + _vm._s(_vm.aggregate.brandName) + "\n        ")]), _vm._v(" "), _c('p', {
	    staticClass: "inline"
	  }, [_c('span', {
	    staticClass: "bold-600"
	  }, [_vm._v("Eixos: ")]), _vm._v("\n          " + _vm._s(_vm.aggregate.category) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "content-box-npadd"
	  }, [_c('div', {
	    staticClass: "toll-info-box"
	  }, [_c('div', {}, [_c('div', {}, [_c('small', [_vm._v("De")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.origin.city))]), _vm._v(" "), _c('small', [_c('img', {
	    attrs: {
	      "src": "/static/icon-send.svg",
	      "alt": "icon send"
	    }
	  }), _vm._v("\n                " + _vm._s(_vm.origin.state) + "\n              ")])]), _vm._v(" "), _c('div', {}, [_c('small', [_vm._v("para")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.destination.city))]), _vm._v(" "), _c('small', [_c('img', {
	    attrs: {
	      "src": "/static/icon-location.svg",
	      "alt": "icon location"
	    }
	  }), _vm._v("\n                " + _vm._s(_vm.destination.state) + "\n              ")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("\n              rota:\n              "), _c('span', [_vm._v(_vm._s(_vm.routeSelected.name))])]), _vm._v(" "), _c('p', [_vm._v("\n              distância:\n              "), _c('span', [_vm._v(_vm._s(_vm.routeSelected.totalDistance) + " KM")])]), _vm._v(" "), _c('p', [_vm._v("\n              valor:\n              "), _c('span', [_vm._v(_vm._s(_vm._f("cents")(_vm.priceTolls.totalValue)))])]), _vm._v(" "), _c('p', [_vm._v("\n              vencimento:\n              "), _c('span', [_vm._v(_vm._s(_vm._f("date")(_vm.routeSelected.expirationToll)))])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Praça de pedágio")]), _vm._v(" "), _c('th', [_vm._v("Concessionária")]), _vm._v(" "), _c('th', {
	    staticClass: "text-right"
	  }, [_vm._v("Valor")])])])
	}]}

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 width-print"
	  }, [_c('title-user', [_c('div', {
	    staticClass: "print-title"
	  }, [_c('span', [_vm._v("Acompanhamento")]), _vm._v(" "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" "), _c('img', {
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "src": __webpack_require__(1798),
	      "alt": ""
	    }
	  }), _vm._v("\n          Comprovante Vale-pedágio\n        ")])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    staticClass: "form-box margin-b20 margin-t30 padding-b10"
	  }, [_c('div', {
	    staticClass: "title-identification"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('span', [_vm._v("N° Vale-pedágio: "), _c('b', [_vm._v(_vm._s(_vm.summaryVP.idProtocolo))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 text-center"
	  }, [(_vm.summaryVP.idProtocoloCanc) ? _c('span', {
	    staticClass: "red"
	  }, [_vm._v("Protocolo Cancelamento: "), _c('b', [_vm._v(_vm._s(_vm.summaryVP.idProtocoloCanc))])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('span', {
	    staticClass: "pull-right"
	  }, [_vm._v("Data Emissão: "), _c('b', [_vm._v(_vm._s(_vm._f("dateTime")(_vm.summaryVP.dataEmissao)))])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6 user-data-resume"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold upper"
	  }, [_vm._v(_vm._s(_vm.summaryVP.embarcador) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.summaryVP.CPFCNPJEmbarcador)) + " ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 user-data-resume"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold upper"
	  }, [_vm._v(_vm._s(_vm.summaryVP.transportador) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.summaryVP.CNPJTransportador)) + " ")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 user-data-resume"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold upper"
	  }, [_vm._v(_vm._s(_vm.summaryVP.rota) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm.summaryVP.origem) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(7), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm.summaryVP.destino) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(8), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm._f("dateTime")(_vm.summaryVP.startVP)) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(9), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm._f("dateTime")(_vm.summaryVP.expirationVP)) + " ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 user-data-resume"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(10), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm.summaryVP.tag) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(11), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold upper"
	  }, [_c('span', {
	    staticClass: "plate"
	  }, [_vm._v(_vm._s(_vm.summaryVP.placaVeiculo))]), _vm._v(" ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [(_vm.summaryVP.categoriaVolta == null) ? _c('p', {
	    staticClass: "three-dots"
	  }, [_vm._v("Categoria Veículo:")]) : _c('p', {
	    staticClass: "three-dots"
	  }, [_vm._v("Categoria Veículo (Ida):")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm.summaryVP.categoria) + " ")])]), _vm._v(" "), (_vm.summaryVP.categoriaVolta != null) ? _c('div', [_vm._m(12), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm.summaryVP.categoriaVolta) + " ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(13), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm.summaryVP.motorista) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(14), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm.summaryVP.externalId) + " ")])])])])]), _vm._v(" "), (_vm.summaryVP.extraInfoVP) ? _c('div', {
	    staticClass: "row margin-t20"
	  }, [_vm._m(15), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 user-data-resume"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(16), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm.summaryVP.extraInfoVP.campo1) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(17), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm.summaryVP.extraInfoVP.campo2) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(18), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm.summaryVP.extraInfoVP.campo3) + " ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 user-data-resume"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(19), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm.summaryVP.extraInfoVP.campo4) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(20), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm.summaryVP.extraInfoVP.campo5) + " ")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('b', [_vm._v("Rota Detalhada e Valores")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "width": "50%"
	    }
	  }, [_vm._v("PRAÇAS DE PEDÁGIO")]), _vm._v(" "), (_vm.summaryVP.categoriaVolta == null) ? [_c('th', {
	    attrs: {
	      "width": "35%"
	    }
	  }, [_vm._v("CONCESSIONÁRIA")]), _vm._v(" "), _c('th', {
	    staticClass: "text-right",
	    attrs: {
	      "width": "15%"
	    }
	  }, [_vm._v("VALOR (R$)")])] : [_c('th', {
	    attrs: {
	      "width": "30%"
	    }
	  }, [_vm._v("CONCESSIONÁRIA")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "10%"
	    }
	  }, [_vm._v("FLUXO")]), _vm._v(" "), _c('th', {
	    staticClass: "text-right",
	    attrs: {
	      "width": "10%"
	    }
	  }, [_vm._v("VALOR (R$)")])]], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.summaryVP.pracas), function(s, index) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(s.praca))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(s.concessionaria))]), _vm._v(" "), (s.fluxo != null && _vm.summaryVP.categoriaVolta != null) ? _c('td', [_vm._v(_vm._s(s.fluxo))]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "text-right"
	    }, [_vm._v(_vm._s(_vm._f("cents")(s.price)))])])
	  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [(_vm.summaryVP.categoriaVolta == null) ? _c('td', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("TOTAL")]) : _c('td', {
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("TOTAL")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.summaryVP.valorVP)))])])])])])])])])])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row hidden-print"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "back-button-box"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "action-buttons-box"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.handlePrint()
	      }
	    }
	  }, [_vm._v("\n            Imprimir\n          ")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": '/api/v2/vp/exportarExtratoValePedagio/' + _vm.summaryVP.idIntern,
	      "download": ""
	    }
	  }, [_vm._m(21)]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": '/api/v2/vp/comprovante/pdf/' + _vm.summaryVP.idIntern,
	      "target": "_blank"
	    }
	  }, [_vm._m(22)]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "disabled": _vm.summaryVP.idProtocoloCanc,
	      "tag": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.cancelar(_vm.summaryVP.idIntern, _vm.summaryVP.placaVeiculo)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-cancel align-icon-left-white"
	  }), _vm._v("\n            Excluir VP\n          ")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Emissor:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("CNPJ Emissor:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Transportador:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("CPF/CNPJ Transportador:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('b', [_vm._v("Dados da Rota e Veículo")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Rota:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Origem:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Destino:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Data Início VP:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Data Expiração VP:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("N° TAG:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Placa Veículo:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', {
	    staticClass: "three-dots"
	  }, [_vm._v("Categoria Veículo (Volta):")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Motorista:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Identificador Vp (cliente):")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('b', [_vm._v("Informações Complementares")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Campo 1:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Campo 2:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Campo 3:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Campo 4:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Campo 5:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn btn-default"
	  }, [_vm._v("\n              Extrato Excel\n              "), _c('i', {
	    staticClass: "icon-xls align-icon-left"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn btn-default"
	  }, [_vm._v("\n              Salvar PDF\n              "), _c('i', {
	    staticClass: "icon-pdf align-icon-left"
	  })])
	}]}

/***/ }),
/* 2067 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-box"
	  }, [_c('b', {
	    staticClass: "title-identification"
	  }, [_vm._v("Informações básicas")]), _vm._v(" "), _c('div', {
	    staticClass: "form-content"
	  }, [_c('div', {
	    staticClass: "form-group margin-b30 input-box-control",
	    class: {
	      'has-error': _vm.errors.has('taxIdNumber')
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.user.taxIdNumberFormatted),
	      expression: "user.taxIdNumberFormatted",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cpf|accountExists:cpf'),
	      expression: "'required|cpf|accountExists:cpf'"
	    }, {
	      name: "mask-cpf",
	      rawName: "v-mask-cpf"
	    }],
	    ref: "taxIdNumber",
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "id": "taxIdNumber",
	      "name": "taxIdNumber",
	      "title": "cpf",
	      "maxlength": "11",
	      "readonly": _vm.blockTaxIdNumber,
	      "spellcheck": "false",
	      "autocomplete": "off",
	      "autocorrect": "off",
	      "autocapitalize": "off",
	      "data-vv-validate-on": "blur",
	      "placeholder": "000.000.000-00"
	    },
	    domProps: {
	      "value": (_vm.user.taxIdNumberFormatted)
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.user, "taxIdNumberFormatted", $event.target.value)
	      }, function($event) {
	        return _vm.ValidacaoNetrim()
	      }]
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("taxIdNumber")) + "\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group input-box-control margin-b30",
	    class: {
	      'has-error': _vm.errors.has('birthDate')
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.user.person.birthDateBR),
	      expression: "user.person.birthDateBR",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|older|min:10'),
	      expression: "'required|older|min:10'"
	    }, {
	      name: "mask-birth",
	      rawName: "v-mask-birth"
	    }],
	    ref: "birthDate",
	    staticClass: "form-control small",
	    attrs: {
	      "name": "birthDate",
	      "type": "text",
	      "title": "data de nascimento",
	      "placeholder": "00/00/0000"
	    },
	    domProps: {
	      "value": (_vm.user.person.birthDateBR)
	    },
	    on: {
	      "change": [function($event) {
	        return _vm.$set(_vm.user.person, "birthDateBR", $event.target.value)
	      }, function($event) {
	        return _vm.ValidacaoNetrim()
	      }]
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("birthDate")) + "\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control",
	    class: {
	      'has-error': _vm.errors.has('nome')
	    }
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.person.fullName),
	      expression: "user.person.fullName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|complete-name'),
	      expression: "'required|complete-name'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "name": "nome",
	      "type": "text",
	      "title": "nome",
	      "spellcheck": "false",
	      "autocomplete": "off",
	      "autocorrect": "off",
	      "autocapitalize": "off",
	      "maxlength": "50"
	    },
	    domProps: {
	      "value": (_vm.user.person.fullName)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.ValidacaoNetrim()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.user.person, "fullName", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("nome")) + "\n              ")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-box"
	  }, [_c('b', {
	    staticClass: "title-identification"
	  }, [_vm._v("Contatos")]), _vm._v(" "), _c('div', {
	    staticClass: "form-content"
	  }, [_c('div', {
	    staticClass: "form-group margin-b30 input-box-control",
	    class: {
	      'has-error': _vm.errors.has('email')
	    }
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.accountAuthentication.login),
	      expression: "user.accountAuthentication.login"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "disabled": !this.validacao,
	      "type": "text",
	      "id": "email",
	      "name": "email",
	      "title": "email",
	      "placeholder": "Ex: nome@empresa.com.br"
	    },
	    domProps: {
	      "value": (_vm.user.accountAuthentication.login)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.user.accountAuthentication, "login", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("email")) + "\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control",
	    class: {
	      'has-error': _vm.errors.has('celular')
	    }
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cel),
	      expression: "cel"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cell'),
	      expression: "'required|cell'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "disabled": !this.validacao,
	      "type": "text",
	      "id": "celular",
	      "name": "celular",
	      "title": "celular",
	      "placeholder": "00-00000-0000",
	      "data-vv-validate-on": "blur",
	      "maxlength": "14"
	    },
	    domProps: {
	      "value": (_vm.cel)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.cel = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("celular")) + "\n              ")])]), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
	    staticClass: "form-group input-box-control margin-b30",
	    class: {
	      'has-error': _vm.errors.has('telefone')
	    }
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tel),
	      expression: "tel"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('phone'),
	      expression: "'phone'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "disabled": !this.validacao,
	      "type": "text",
	      "id": "telefone",
	      "name": "telefone",
	      "title": "telefone",
	      "placeholder": "00-0000-0000",
	      "data-vv-validate-on": "blur",
	      "maxlength": "13"
	    },
	    domProps: {
	      "value": (_vm.tel)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.tel = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("telefone")) + "\n              ")])]), _vm._v(" "), _vm._t("default")], 2)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-box"
	  }, [_c('b', {
	    staticClass: "title-identification margin-b10"
	  }, [_vm._v("Segurança")]), _vm._v(" "), _c('div', {
	    staticClass: "form-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group margin-b30 input-box-control margin-pass",
	    class: {
	      'has-error': _vm.errors.has('password')
	    }
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.accountAuthentication.password),
	      expression: "user.accountAuthentication.password"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:8|max:20|moveMaisCPF'),
	      expression: "'required|min:8|max:20|moveMaisCPF'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "disabled": !this.validacao,
	      "type": "password",
	      "id": "password",
	      "name": "password",
	      "title": "senha",
	      "maxlength": "20",
	      "data-vv-validate-on": "blur"
	    },
	    domProps: {
	      "value": (_vm.user.accountAuthentication.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.user.accountAuthentication, "password", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("password")) + "\n                  ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group margin-b30 input-box-control",
	    class: {
	      'has-error': _vm.errors.has('confirm-password')
	    }
	  }, [_vm._m(7), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.accountAuthentication.confirmPassword),
	      expression: "user.accountAuthentication.confirmPassword"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: (
	        'required|min:8|max:20|confirmed:password|moveMaisCPF'
	      ),
	      expression: "\n                      'required|min:8|max:20|confirmed:password|moveMaisCPF'\n                    "
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "disabled": !this.validacao,
	      "type": "password",
	      "id": "confirm-password",
	      "name": "confirm-password",
	      "title": "confirmar senha",
	      "maxlength": "20",
	      "data-vv-validate-on": "blur"
	    },
	    domProps: {
	      "value": (_vm.user.accountAuthentication.confirmPassword)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.user.accountAuthentication, "confirmPassword", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("confirm-password")) + "\n                  ")])])])])]), _vm._v(" "), _vm._m(8)])])]), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-box"
	  }, [_c('address-comp', {
	    ref: "addressMailing",
	    attrs: {
	      "address": _vm.address,
	      "type": "MAILING"
	    }
	  })], 1)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("CPF:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Data de nascimento:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Nome Completo:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("E-mail:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Tel .Celular:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Tel. Residencial:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Senha:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Confirme a Senha:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "box-dicas"
	  }, [_vm._v("Senha deve ter de 8 a 20 caracteres")]), _vm._v(" "), _c('div', {
	    staticClass: "box-dicas"
	  }, [_vm._v("Senha deve ter pelo menos um número")]), _vm._v(" "), _c('div', {
	    staticClass: "box-dicas"
	  }, [_vm._v("Senha deve ter uma letra maiúscula")]), _vm._v(" "), _c('div', {
	    staticClass: "box-dicas"
	  }, [_vm._v("Senha deve ter um caractere especial")])])
	}]}

/***/ }),
/* 2068 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container",
	    attrs: {
	      "id": "vehicle-edit"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("Meus planos "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Contrato " + _vm._s(_vm.contractId) + " "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Veículos "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Editar Veículo")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })], 1)]), _vm._v(" "), (_vm.vehicle) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "col-xs-12"
	  }, [_c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('div', {
	    staticClass: "box margin-20 box-content-padding",
	    attrs: {
	      "id": "box-category"
	    }
	  }, [_c('span', {
	    staticClass: "bold-600"
	  }, [_vm._v("Quantidade de eixos:")]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t5"
	  }, [_c('div', {
	    staticClass: "col-md-3 small-padding-right"
	  }, [_c('div', {
	    staticClass: "radio-box category axis-box",
	    class: {
	      'active': _vm.radioSelected == 1, 'disabled': _vm.axesSelected != 1
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.radioSelected),
	      expression: "radioSelected"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "2-simple-axis",
	      "type": "radio",
	      "name": "radio",
	      "value": "1",
	      "disabled": _vm.axesSelected != 1
	    },
	    domProps: {
	      "checked": _vm._q(_vm.radioSelected, "1")
	    },
	    on: {
	      "change": function($event) {
	        _vm.radioSelected = "1"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label radio-label-fix",
	    attrs: {
	      "for": "2-simple-axis"
	    }
	  }, [_vm._v("2 Eixos - Simples")]), _vm._v(" "), _c('div', {
	    staticClass: "check first"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 small-padding-right small-padding-left"
	  }, [_c('div', {
	    staticClass: "radio-box category axis-box",
	    class: {
	      'active': _vm.radioSelected == 7, 'disabled': _vm.axesSelected != 1
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.radioSelected),
	      expression: "radioSelected"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "3-simple-axis",
	      "type": "radio",
	      "name": "radio",
	      "value": "7",
	      "disabled": _vm.axesSelected != 1
	    },
	    domProps: {
	      "checked": _vm._q(_vm.radioSelected, "7")
	    },
	    on: {
	      "change": function($event) {
	        _vm.radioSelected = "7"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label radio-label-fix",
	    attrs: {
	      "for": "3-simple-axis"
	    }
	  }, [_vm._v("3 Eixos - Simples")]), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 small-padding-right small-padding-left"
	  }, [_c('div', {
	    staticClass: "radio-box category axis-box",
	    class: {
	      'active': _vm.radioSelected == 8, 'disabled': _vm.axesSelected != 1
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.radioSelected),
	      expression: "radioSelected"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "4-simple-axis",
	      "type": "radio",
	      "name": "radio",
	      "value": "8",
	      "disabled": _vm.axesSelected != 1
	    },
	    domProps: {
	      "checked": _vm._q(_vm.radioSelected, "8")
	    },
	    on: {
	      "change": function($event) {
	        _vm.radioSelected = "8"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label radio-label-fix",
	    attrs: {
	      "for": "4-simple-axis"
	    }
	  }, [_vm._v("4 Eixos - Simples")]), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 small-padding-left"
	  }, [_c('div', {
	    staticClass: "radio-box category axis-box",
	    class: {
	      'active': _vm.radioSelected == 2, 'disabled': _vm.axesSelected == 1
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.radioSelected),
	      expression: "radioSelected"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "2-double-axis",
	      "type": "radio",
	      "name": "radio",
	      "value": "2",
	      "disabled": _vm.axesSelected == 1
	    },
	    domProps: {
	      "checked": _vm._q(_vm.radioSelected, "2")
	    },
	    on: {
	      "change": function($event) {
	        _vm.radioSelected = "2"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label radio-label-fix",
	    attrs: {
	      "for": "2-double-axis"
	    }
	  }, [_vm._v("2 Eixos - Duplos")]), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3 small-padding-right"
	  }, [_c('div', {
	    staticClass: "radio-box category axis-box",
	    class: {
	      'active': _vm.radioSelected == 3, 'disabled': _vm.axesSelected == 1
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.radioSelected),
	      expression: "radioSelected"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "3-double-axis",
	      "type": "radio",
	      "name": "radio",
	      "value": "3",
	      "disabled": _vm.axesSelected == 1
	    },
	    domProps: {
	      "checked": _vm._q(_vm.radioSelected, "3")
	    },
	    on: {
	      "change": function($event) {
	        _vm.radioSelected = "3"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label radio-label-fix",
	    attrs: {
	      "for": "3-double-axis"
	    }
	  }, [_vm._v("3 Eixos - Duplos")]), _vm._v(" "), _c('div', {
	    staticClass: "check first"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 small-padding-right small-padding-left"
	  }, [_c('div', {
	    staticClass: "radio-box category axis-box",
	    class: {
	      'active': _vm.radioSelected == 4, 'disabled': _vm.axesSelected == 1
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.radioSelected),
	      expression: "radioSelected"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "4-double-axis",
	      "type": "radio",
	      "name": "radio",
	      "value": "4",
	      "disabled": _vm.axesSelected == 1
	    },
	    domProps: {
	      "checked": _vm._q(_vm.radioSelected, "4")
	    },
	    on: {
	      "change": function($event) {
	        _vm.radioSelected = "4"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label radio-label-fix",
	    attrs: {
	      "for": "4-double-axis"
	    }
	  }, [_vm._v("4 Eixos - Duplos")]), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 small-padding-right small-padding-left"
	  }, [_c('div', {
	    staticClass: "radio-box category axis-box",
	    class: {
	      'active': _vm.radioSelected == 5, 'disabled': _vm.axesSelected != 6
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.radioSelected),
	      expression: "radioSelected"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "5-double-axis",
	      "type": "radio",
	      "name": "radio",
	      "value": "5",
	      "disabled": _vm.axesSelected != 6
	    },
	    domProps: {
	      "checked": _vm._q(_vm.radioSelected, "5")
	    },
	    on: {
	      "change": function($event) {
	        _vm.radioSelected = "5"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label radio-label-fix",
	    attrs: {
	      "for": "5-double-axis"
	    }
	  }, [_vm._v("5 Eixos - Duplos")]), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 small-padding-left"
	  }, [_c('div', {
	    staticClass: "radio-box category axis-box",
	    class: {
	      'active': _vm.radioSelected == 6, 'disabled': _vm.axesSelected != 6
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.radioSelected),
	      expression: "radioSelected"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "6-double-axis",
	      "type": "radio",
	      "name": "radio",
	      "value": "6",
	      "disabled": _vm.axesSelected != 6
	    },
	    domProps: {
	      "checked": _vm._q(_vm.radioSelected, "6")
	    },
	    on: {
	      "change": function($event) {
	        _vm.radioSelected = "6"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label radio-label-fix",
	    attrs: {
	      "for": "6-double-axis"
	    }
	  }, [_vm._v("6 Eixos - Duplos")]), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3 small-padding-right"
	  }, [_c('div', {
	    staticClass: "radio-box category axis-box",
	    class: {
	      'active': _vm.radioSelected == 9, 'disabled': _vm.axesSelected != 6
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.radioSelected),
	      expression: "radioSelected"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "7-double-axis",
	      "type": "radio",
	      "name": "radio",
	      "value": "9",
	      "disabled": _vm.axesSelected != 6
	    },
	    domProps: {
	      "checked": _vm._q(_vm.radioSelected, "9")
	    },
	    on: {
	      "change": function($event) {
	        _vm.radioSelected = "9"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label radio-label-fix",
	    attrs: {
	      "for": "7-double-axis"
	    }
	  }, [_vm._v("7 Eixos - Duplos")]), _vm._v(" "), _c('div', {
	    staticClass: "check first"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 small-padding-right small-padding-left"
	  }, [_c('div', {
	    staticClass: "radio-box category axis-box",
	    class: {
	      'active': _vm.radioSelected == 10, 'disabled': _vm.axesSelected != 6
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.radioSelected),
	      expression: "radioSelected"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "8-double-axis",
	      "type": "radio",
	      "name": "radio",
	      "value": "10",
	      "disabled": _vm.axesSelected != 6
	    },
	    domProps: {
	      "checked": _vm._q(_vm.radioSelected, "10")
	    },
	    on: {
	      "change": function($event) {
	        _vm.radioSelected = "10"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label radio-label-fix",
	    attrs: {
	      "for": "8-double-axis"
	    }
	  }, [_vm._v("8 Eixos - Duplos")]), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 small-padding-right small-padding-left"
	  }, [_c('div', {
	    staticClass: "radio-box category axis-box",
	    class: {
	      'active': _vm.radioSelected == 11, 'disabled': _vm.axesSelected != 6
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.radioSelected),
	      expression: "radioSelected"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "9-double-axis",
	      "type": "radio",
	      "name": "radio",
	      "value": "11",
	      "disabled": _vm.axesSelected != 6
	    },
	    domProps: {
	      "checked": _vm._q(_vm.radioSelected, "11")
	    },
	    on: {
	      "change": function($event) {
	        _vm.radioSelected = "11"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label radio-label-fix",
	    attrs: {
	      "for": "9-double-axis"
	    }
	  }, [_vm._v("9 Eixos - Duplos")]), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 small-padding-left"
	  }, [_c('div', {
	    staticClass: "radio-box category box-other-axis",
	    class: {
	      'active': _vm.radioSelected == -1, 'disabled': _vm.axesSelected == 3 || _vm.axesSelected == 1
	    },
	    attrs: {
	      "id": "box-other-axis"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.radioSelected),
	      expression: "radioSelected"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "other-axis",
	      "type": "radio",
	      "name": "radio",
	      "value": "-1",
	      "disabled": _vm.axesSelected == 3 || _vm.axesSelected == 1
	    },
	    domProps: {
	      "checked": _vm._q(_vm.radioSelected, "-1")
	    },
	    on: {
	      "change": function($event) {
	        _vm.radioSelected = "-1"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label radio-label-fix",
	    attrs: {
	      "for": "other-axis"
	    }
	  }, [_vm._v("Outros")]), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  }), _vm._v(" "), _c('dropdown', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.radioSelected == -1),
	      expression: "radioSelected == -1"
	    }],
	    staticClass: "dropdown-lg",
	    attrs: {
	      "options": _vm.otherCategories,
	      "value": _vm.otherCategorySelected
	    },
	    model: {
	      value: (_vm.otherCategorySelected),
	      callback: function($$v) {
	        _vm.otherCategorySelected = $$v
	      },
	      expression: "otherCategorySelected"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-t20",
	    attrs: {
	      "id": "axes-category"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3 small-padding-right"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "bold-600 no-margin",
	    attrs: {
	      "for": "plate"
	    }
	  }, [_vm._v("Placa:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.vehicle.plate),
	      expression: "vehicle.plate"
	    }],
	    staticClass: "form-control text-uppercase plate margin-t5",
	    attrs: {
	      "id": "plate",
	      "maxlength": "7",
	      "type": "text",
	      "name": "plate",
	      "readonly": ""
	    },
	    domProps: {
	      "value": (_vm.vehicle.plate)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.vehicle, "plate", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 small-padding-right small-padding-left"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('span', {
	    staticClass: "bold-600"
	  }, [_vm._v("Marca:")]), _vm._v(" "), _c('dropdown', {
	    staticClass: "dropdown-lg margin-t5",
	    attrs: {
	      "options": _vm.brands,
	      "value": _vm.brandSelected
	    },
	    on: {
	      "itemSelected": _vm.loadModels
	    },
	    model: {
	      value: (_vm.brandSelected),
	      callback: function($$v) {
	        _vm.brandSelected = $$v
	      },
	      expression: "brandSelected"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 small-padding-left"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('span', {
	    staticClass: "bold-600"
	  }, [_vm._v("Modelo:")]), _vm._v(" "), _c('dropdown', {
	    staticClass: "dropdown-lg margin-t5",
	    attrs: {
	      "options": _vm.models
	    },
	    on: {
	      "itemSelected": _vm.onModelSelected
	    },
	    model: {
	      value: (_vm.modelSelected),
	      callback: function($$v) {
	        _vm.modelSelected = $$v
	      },
	      expression: "modelSelected"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3 small-padding-right"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "bold-600 no-margin",
	    attrs: {
	      "for": "plate"
	    }
	  }, [_vm._v("Renavam:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.vehicle.renavam),
	      expression: "vehicle.renavam"
	    }],
	    staticClass: "form-control text-uppercase  margin-t5 vehicle-edit-input",
	    attrs: {
	      "type": "text",
	      "name": "renavam"
	    },
	    domProps: {
	      "value": (_vm.vehicle.renavam)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.vehicle, "renavam", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 small-padding-right small-padding-left"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('rntrc')
	    }
	  }, [_c('span', {
	    staticClass: "bold-600"
	  }, [_vm._v("RNTRC:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('decimal|max:12'),
	      expression: "'decimal|max:12'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.vehicle.rntrc),
	      expression: "vehicle.rntrc"
	    }, {
	      name: "only-numbers",
	      rawName: "v-only-numbers"
	    }],
	    staticClass: "form-control text-uppercase margin-t5 vehicle-edit-input",
	    attrs: {
	      "maxlength": "12",
	      "type": "text",
	      "name": "rntrc"
	    },
	    domProps: {
	      "value": (_vm.vehicle.rntrc)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.vehicle, "rntrc", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('rntrc')) + "\n                  ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 small-padding-left"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('span', {
	    staticClass: "bold-600"
	  }, [_vm._v("Estado")]), _vm._v(" "), _c('dropdown', {
	    staticClass: "dropdown-lg margin-t5",
	    attrs: {
	      "options": _vm.states,
	      "value": _vm.vehicle.state
	    },
	    model: {
	      value: (_vm.vehicle.state),
	      callback: function($$v) {
	        _vm.$set(_vm.vehicle, "state", $$v)
	      },
	      expression: "vehicle.state"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3 small-padding-right"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "bold-600 no-margin",
	    attrs: {
	      "for": "plate"
	    }
	  }, [_vm._v("Ano de fabricação:")]), _vm._v(" "), _c('dropdown', {
	    staticClass: "dropdown-lg margin-t5",
	    attrs: {
	      "options": _vm.years,
	      "value": _vm.vehicle.assemblyYear
	    },
	    model: {
	      value: (_vm.vehicle.assemblyYear),
	      callback: function($$v) {
	        _vm.$set(_vm.vehicle, "assemblyYear", $$v)
	      },
	      expression: "vehicle.assemblyYear"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 small-padding-right small-padding-left"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('span', {
	    staticClass: "bold-600"
	  }, [_vm._v("Ano do modelo:")]), _vm._v(" "), _c('dropdown', {
	    staticClass: "dropdown-lg margin-t5",
	    attrs: {
	      "options": _vm.years,
	      "value": _vm.vehicle.modelYear
	    },
	    model: {
	      value: (_vm.vehicle.modelYear),
	      callback: function($$v) {
	        _vm.$set(_vm.vehicle, "modelYear", $$v)
	      },
	      expression: "vehicle.modelYear"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 small-padding-left"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('span', {
	    staticClass: "bold-600"
	  }, [_vm._v("Cor:")]), _vm._v(" "), _c('dropdown', {
	    staticClass: "dropdown-lg margin-t5",
	    attrs: {
	      "options": _vm.colors,
	      "value": _vm.vehicle.color
	    },
	    model: {
	      value: (_vm.vehicle.color),
	      callback: function($$v) {
	        _vm.$set(_vm.vehicle, "color", $$v)
	      },
	      expression: "vehicle.color"
	    }
	  })], 1)])]), _vm._v(" "), (_vm.vehicle.rntrc) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3 small-padding-right"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "bold-600 no-margin",
	    attrs: {
	      "for": "ownFleet"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ownFleet),
	      expression: "ownFleet"
	    }],
	    attrs: {
	      "id": "ownFleet",
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.ownFleet) ? _vm._i(_vm.ownFleet, null) > -1 : (_vm.ownFleet)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.ownFleet,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.ownFleet = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.ownFleet = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.ownFleet = $$c
	        }
	      }
	    }
	  }), _vm._v(" Frota própria")])])])]) : _vm._e(), _vm._v(" "), (!_vm.ownFleet && _vm.vehicle.rntrc) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3 small-padding-right"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('taxpayerIdNumber')
	    }
	  }, [_c('span', {
	    staticClass: "bold-600"
	  }, [_vm._v("CPF/CNPJ:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.driver.taxpayerIdNumber),
	      expression: "driver.taxpayerIdNumber",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:18|cpfCnpj'),
	      expression: "'required|max:18|cpfCnpj'"
	    }, {
	      name: "mask-cpf-cnpj",
	      rawName: "v-mask-cpf-cnpj"
	    }],
	    staticClass: "form-control text-uppercase margin-t5 vehicle-edit-input",
	    attrs: {
	      "type": "text",
	      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2}|[0-9]{3}\\.[0-9]{3}\\.[0-9]{3}-[0-9]{2}|[0-9]{11})$",
	      "name": "taxpayerIdNumber",
	      "data-vv-validate-on": "blur"
	    },
	    domProps: {
	      "value": (_vm.driver.taxpayerIdNumber)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.driver, "taxpayerIdNumber", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('taxpayerIdNumber')) + "\n                  ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 small-padding-right small-padding-left"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('name')
	    }
	  }, [_c('span', {
	    staticClass: "bold-600"
	  }, [_vm._v("Nome:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.driver.driverName),
	      expression: "driver.driverName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control text-uppercase margin-t5 vehicle-edit-input",
	    attrs: {
	      "type": "text",
	      "name": "name"
	    },
	    domProps: {
	      "value": (_vm.driver.driverName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.driver, "driverName", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('name')) + "\n                  ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 small-padding-left"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('email')
	    }
	  }, [_c('span', {
	    staticClass: "bold-600"
	  }, [_vm._v("Email:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.driver.driverEmail),
	      expression: "driver.driverEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }],
	    staticClass: "form-control text-uppercase margin-t5 vehicle-edit-input",
	    attrs: {
	      "type": "text",
	      "name": "email"
	    },
	    domProps: {
	      "value": (_vm.driver.driverEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.driver, "driverEmail", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('email')) + "\n                  ")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6 pull-right"
	  }, [(_vm.vehicle.installDate) ? _c('div', {
	    staticClass: "col-md-6",
	    class: _vm.classVehicle
	  }, [_c('span', {
	    staticClass: "bold-600"
	  }, [_vm._v("Ativado em: ")]), _vm._v(_vm._s(_vm._f("dateTime")(_vm.vehicle.installDate)))]) : _vm._e(), _vm._v(" "), (_vm.vehicle.cancelDate) ? _c('div', {
	    staticClass: "col-md-6 pull-right"
	  }, [_c('span', {
	    staticClass: "bold-600"
	  }, [_vm._v("Cancelado em: ")]), _vm._v(" " + _vm._s(_vm._f("dateTime")(_vm.vehicle.cancelDate)))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20"
	  }, [_c('div', {
	    staticClass: "col-xs-12 col-md-7 box-button"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back btn-edit-vehicle",
	    attrs: {
	      "to": {
	        name: 'contract-vehicles',
	        params: {
	          id: _vm.contractId
	        }
	      },
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v(" Voltar\n            ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 col-md-5 box-buttons"
	  }, [_c('router-link', {
	    staticClass: "btn-icon-left btn-danger btn-edit-vehicle",
	    attrs: {
	      "to": {
	        name: 'contract-vehicles',
	        params: {
	          contractId: _vm.contractId
	        }
	      },
	      "tag": "button",
	      "type": "button"
	    }
	  }, [_vm._v("\n              Cancelar\n              "), _c('i', {
	    staticClass: "icon-circle-left align-icon-left-white"
	  })]), _vm._v(" "), _vm._m(0)], 1)])])])]) : _c('div', {
	    staticClass: "row margin-t20"
	  }, [_vm._v("\n    Carregando veículo... Por favor aguarde...\n  ")])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn-icon-right btn-success btn-edit-vehicle",
	    attrs: {
	      "type": "submit",
	      "title": ""
	    }
	  }, [_vm._v("\n              Salvar\n              "), _c('i', {
	    staticClass: "icon-circle-right align-icon-right-sm no-top"
	  })])
	}]}

/***/ }),
/* 2069 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.contractAggregate) ? _c('div', {
	    staticClass: "modal fade modal-aggregate",
	    staticStyle: {
	      "width": "100%",
	      "left": "5%"
	    },
	    attrs: {
	      "id": "modal-aggregate",
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-labelledby": "modal-aggregate-label",
	      "aria-hidden": "true"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    staticStyle: {
	      "width": "90%"
	    },
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    staticClass: "modal-content",
	    staticStyle: {
	      "width": "90%"
	    }
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), (_vm.step == 0) ? _c('div', {
	    staticClass: "btn-group",
	    attrs: {
	      "data-toggle": "buttons"
	    }
	  }, [_c('label', {
	    staticClass: "btn",
	    class: {
	      'active': _vm.aggregateType == 'cnpj'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.handleAggregate('cnpj')
	      }
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aggregateType),
	      expression: "aggregateType"
	    }],
	    attrs: {
	      "type": "radio",
	      "disabled": "",
	      "name": "options",
	      "id": "cnpj",
	      "value": "cnpj"
	    },
	    domProps: {
	      "checked": _vm.aggregateType == 'cnpj',
	      "checked": _vm._q(_vm.aggregateType, "cnpj")
	    },
	    on: {
	      "change": function($event) {
	        _vm.aggregateType = "cnpj"
	      }
	    }
	  }), _vm._v(" CNPJ\n           ")]), _vm._v(" "), _c('label', {
	    staticClass: "btn",
	    class: {
	      'active': _vm.aggregateType == 'cpf'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.handleAggregate('cpf')
	      }
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.aggregateType),
	      expression: "aggregateType"
	    }],
	    attrs: {
	      "type": "radio",
	      "disabled": "",
	      "name": "options",
	      "id": "cpf",
	      "value": "cpf"
	    },
	    domProps: {
	      "checked": _vm.aggregateType == 'cpf',
	      "checked": _vm._q(_vm.aggregateType, "cpf")
	    },
	    on: {
	      "change": function($event) {
	        _vm.aggregateType = "cpf"
	      }
	    }
	  }), _vm._v(" CPF\n           ")])]) : _vm._e(), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "id": "modal-aggregate-label"
	    }
	  }, [_vm._v("Cadastro Agregador")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {}, [_c('ul', {
	    staticClass: "wizard margin-b20 "
	  }, [_c('li', {
	    class: {
	      active: _vm.step == 0, past: _vm.step > 0
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('big', [_vm._v("Dados pessoais")])], 1), _vm._v(" "), _c('li', {
	    class: {
	      active: _vm.step == 1, past: _vm.step > 1
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('big', [_vm._v("Endereço")])], 1), _vm._v(" "), _c('li', {
	    class: {
	      active: _vm.step == 2, past: _vm.step > 2
	    }
	  }, [_vm._m(2), _vm._v(" "), _c('big', [_vm._v("Dados do veículo")])], 1), _vm._v(" "), _c('li', {
	    class: {
	      active: _vm.step == 3, past: _vm.step > 3
	    }
	  }, [_vm._m(3), _vm._v(" "), _c('big', [_vm._v("Vincular TAG")])], 1)])]), _vm._v(" "), (_vm.step == 0 && _vm.aggregateType == 'cpf') ? _c('user', {
	    ref: "accountData",
	    attrs: {
	      "user": _vm.user,
	      "contact": _vm.contact
	    },
	    on: {
	      "addressExists": _vm.addressExists
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.step == 0 && _vm.aggregateType == 'cnpj') ? _c('company', {
	    ref: "accountData",
	    attrs: {
	      "company": _vm.company,
	      "contact": _vm.contact
	    },
	    on: {
	      "addressExists": _vm.addressExists
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.step == 1) ? _c('address-data', {
	    ref: "addressData",
	    attrs: {
	      "address": _vm.address
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.step == 2 && !_vm.vehiclesSaved) ? _c('div', {
	    staticClass: "vehicle-data"
	  }, [_c('p', {
	    staticClass: "aggregate-sub"
	  }, [_vm._v("Dados do veículo")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('plate')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "plate"
	    }
	  }, [_vm._v("Placa")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "mask-plate",
	      rawName: "v-mask-plate"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|plateValid|plateExist'),
	      expression: "'required|plateValid|plateExist'"
	    }, {
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.plate),
	      expression: "plate",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    staticClass: "form-control text-uppercase",
	    attrs: {
	      "type": "text",
	      "name": "plate",
	      "id": "plate",
	      "value": "",
	      "data-vv-validate-on": "blur",
	      "spellcheck": "false",
	      "autocomplete": "off",
	      "autocorrect": "off",
	      "autocapitalize": "off"
	    },
	    domProps: {
	      "value": (_vm.plate)
	    },
	    on: {
	      "input": _vm.onPlateInput,
	      "change": function($event) {
	        _vm.plate = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('plate')))])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Marca")]), _vm._v(" "), _c('dropdown', {
	    staticClass: "dropdown-vehicle",
	    attrs: {
	      "options": _vm.brands,
	      "value": _vm.brandId
	    },
	    on: {
	      "itemSelected": _vm.onBrandSelected
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Modelo")]), _vm._v(" "), _c('dropdown', {
	    staticClass: "dropdown-vehicle",
	    attrs: {
	      "options": _vm.models,
	      "value": _vm.modelId
	    },
	    on: {
	      "itemSelected": _vm.onModelSelected
	    },
	    model: {
	      value: (_vm.modelId),
	      callback: function($$v) {
	        _vm.modelId = $$v
	      },
	      expression: "modelId"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Eixos")]), _vm._v(" "), _c('dropdown', {
	    staticClass: "dropdown-vehicle",
	    attrs: {
	      "options": _vm.axes,
	      "value": _vm.axesId
	    },
	    model: {
	      value: (_vm.axesId),
	      callback: function($$v) {
	        _vm.axesId = $$v
	      },
	      expression: "axesId"
	    }
	  })], 1), _vm._v(" "), (_vm.plateValida) ? _c('div', {
	    staticClass: "transportador-container"
	  }, [_c('label', {
	    staticClass: "transportador-check"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.souTransportador),
	      expression: "souTransportador"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.souTransportador) ? _vm._i(_vm.souTransportador, null) > -1 : (_vm.souTransportador)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.souTransportador,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.souTransportador = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.souTransportador = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.souTransportador = $$c
	        }
	      }, _vm.onTransportadorToggle]
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Sou transportador e quero receber VPO.")])]), _vm._v(" "), (_vm.souTransportador) ? _c('div', {
	    staticClass: "antt-box"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "antt-input-row"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cpfCnpjTransportador),
	      expression: "cpfCnpjTransportador"
	    }],
	    staticClass: "form-control cpf-cnpj-input",
	    attrs: {
	      "type": "text",
	      "name": "cpfCnpjTransportador",
	      "placeholder": "Digite o número CPF ou CNPJ do proprietário",
	      "maxlength": "18",
	      "spellcheck": "false",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": (_vm.cpfCnpjTransportador)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.cpfCnpjTransportador = $event.target.value
	      }, _vm.onCpfCnpjInput]
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "consultar-antt-button",
	    attrs: {
	      "type": "button",
	      "disabled": _vm.anttLoading || !_vm.cpfCnpjValido || _vm.anttStatus === 'error'
	    },
	    on: {
	      "click": _vm.consultarAntt
	    }
	  }, [(_vm.anttLoading) ? _c('span', {
	    staticClass: "antt-spinner"
	  }) : _vm._e(), _vm._v("\n                   " + _vm._s(_vm.anttLoading ? "Consultando..." : "Consultar na ANTT") + "\n                 ")])]), _vm._v(" "), (_vm.anttStatus === 'success') ? _c('div', {
	    staticClass: "antt-feedback-success"
	  }, [_c('svg', {
	    attrs: {
	      "width": "18",
	      "height": "18",
	      "viewBox": "0 0 18 18",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('g', {
	    attrs: {
	      "clip-path": "url(#clip0_166_8935_agg)"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M16.3502 7.50011C16.6927 9.18109 16.4486 10.9287 15.6586 12.4515C14.8686 13.9742 13.5804 15.1802 12.0088 15.8681C10.4373 16.5561 8.67743 16.6845 7.02269 16.2319C5.36794 15.7793 3.91836 14.7732 2.91567 13.3812C1.91298 11.9892 1.41781 10.2955 1.51271 8.58265C1.60762 6.86977 2.28687 5.24118 3.4372 3.96849C4.58753 2.6958 6.1394 1.85594 7.83401 1.58895C9.52863 1.32197 11.2636 1.64401 12.7495 2.50136M6.74976 8.24976L8.99976 10.4998L16.4998 2.99976",
	      "stroke": "#4CAF50",
	      "stroke-width": "2",
	      "stroke-linecap": "round"
	    }
	  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
	    attrs: {
	      "id": "clip0_166_8935_agg"
	    }
	  }, [_c('rect', {
	    attrs: {
	      "width": "18",
	      "height": "18",
	      "fill": "white"
	    }
	  })])])]), _vm._v(" "), _c('span', [_vm._v("Transportador validado com sucesso na ANTT.")])]) : _vm._e(), _vm._v(" "), (_vm.anttStatus === 'error') ? _c('div', {
	    staticClass: "antt-feedback-error"
	  }, [_c('svg', {
	    attrs: {
	      "width": "20",
	      "height": "22",
	      "viewBox": "0 0 20 22",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('g', {
	    attrs: {
	      "clip-path": "url(#clip0_166_9400_agg)"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M10.0001 20.3332C14.6025 20.3332 18.3334 16.6022 18.3334 11.9998C18.3334 7.39746 14.6025 3.6665 10.0001 3.6665C5.39771 3.6665 1.66675 7.39746 1.66675 11.9998C1.66675 16.6022 5.39771 20.3332 10.0001 20.3332Z",
	      "stroke": "#E00000",
	      "stroke-width": "1.66667",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  }), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M10 8.6665V11.9998",
	      "stroke": "#E00000",
	      "stroke-width": "1.66667",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  }), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M10 15.3335H10.0083",
	      "stroke": "#E00000",
	      "stroke-width": "1.66667",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
	    attrs: {
	      "id": "clip0_166_9400_agg"
	    }
	  }, [_c('rect', {
	    attrs: {
	      "width": "20",
	      "height": "20",
	      "fill": "white",
	      "transform": "translate(0 2)"
	    }
	  })])])]), _vm._v(" "), _c('span', [_vm._v("Não foi possível validar na ANTT. Verifique se os dados estão corretos.")])]) : _vm._e(), _vm._v(" "), (_vm.mostrarAvisoAntt && _vm.transportadorPendente) ? _c('div', {
	    staticClass: "antt-aviso"
	  }, [_vm._v("\n                 Valide o transportador na ANTT para continuar.\n               ")]) : _vm._e()]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.step == 2 && _vm.vehiclesSaved) ? _c('div', {
	    staticClass: "vehicle-list"
	  }, [(_vm.msgError) ? _c('p', {
	    staticClass: "alert alert-danger margin-b10"
	  }, [_vm._v(_vm._s(_vm.msgError))]) : _vm._e(), _vm._v(" "), (_vm.vehicles.length > 0) ? _c('div', _vm._l((_vm.vehicles), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "content-box"
	    }, [_c('div', {
	      staticClass: "inline plate-box"
	    }, [_c('p', {
	      staticClass: "cell-plate info-car"
	    }, [_c('span', [_vm._v(_vm._s(item.plate))])])]), _vm._v(" "), _c('p', {
	      staticClass: "inline bold border-right-gray"
	    }, [_vm._v(_vm._s(item.model.brand.name))]), _vm._v(" "), _c('p', {
	      staticClass: "inline"
	    }, [_vm._v(_vm._s(item.categoryAxes.name))]), _vm._v(" "), _c('i', {
	      staticClass: "icomoon-delete",
	      on: {
	        "click": function($event) {
	          return _vm.remove(index)
	        }
	      }
	    })])
	  }), 0) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn-add",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.vehiclesSaved = false;
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icomoon-add-circle-outline"
	  }), _vm._v("\n             Adicionar veículo\n           ")])]) : _vm._e(), _vm._v(" "), (_vm.step == 3) ? _c('div', [_c('p', {
	    staticClass: "aggregate-sub"
	  }, [_vm._v("Ativar TAG")]), _vm._v(" "), _vm._l((_vm.vehiclesActive), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "vehicle-box"
	    }, [_c('tag', {
	      attrs: {
	        "vehicle": item,
	        "completeData": false
	      }
	    })], 1)
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.step == 4) ? _c('div', {}, [_c('div', {
	    staticClass: "content-box success text-center"
	  }, [_c('h4', [_vm._v("Agregador cadastrado com sucesso!")]), _vm._v(" "), _c('img', {
	    staticClass: "margin-10",
	    attrs: {
	      "src": "/static/Icon-check-circle.svg",
	      "alt": "icon-check-circle"
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v("OK")])])]) : _vm._e()], 1), _vm._v(" "), (_vm.step != 4) ? _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.step == 0),
	      expression: "step == 0"
	    }],
	    staticClass: "no-btn",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v("Cancelar")]), _vm._v(" "), (_vm.step != 2 && _vm.step != 0) ? _c('button', {
	    staticClass: "no-btn blue",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.backStep()
	      }
	    }
	  }, [_vm._v("Voltar")]) : (_vm.step == 2 && _vm.vehiclesSaved) ? _c('button', {
	    staticClass: "no-btn blue",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.backStep()
	      }
	    }
	  }, [_vm._v("Voltar")]) : (_vm.step == 2 && !_vm.vehiclesSaved) ? _c('button', {
	    staticClass: "no-btn blue",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.vehiclesSaved = !_vm.vehiclesSaved
	      }
	    }
	  }, [_vm._v("Voltar")]) : _vm._e(), _vm._v(" "), (_vm.step < 2) ? _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.nextStep()
	      }
	    }
	  }, [_vm._v("\n           Avançar\n           "), _c('i', {
	    staticClass: "icon-circle-right"
	  })]) : _vm._e(), _vm._v(" "), (_vm.step == 2 && !_vm.vehiclesSaved) ? _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.add()
	      }
	    }
	  }, [_vm._v("\n           Salvar\n           "), _c('i', {
	    staticClass: "icon-tick"
	  })]) : _vm._e(), _vm._v(" "), (_vm.step == 2 && _vm.vehiclesSaved) ? _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "disabled": _vm.vehicles.length == 0,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.doRequest()
	      }
	    }
	  }, [_vm._v("\n           Salvar\n           "), _c('i', {
	    staticClass: "icon-tick"
	  })]) : _vm._e(), _vm._v(" "), (_vm.step > 2) ? _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.nextStep()
	      }
	    }
	  }, [_vm._v("\n           Concluir cadastro\n           "), _c('i', {
	    staticClass: "icon-tick"
	  })]) : _vm._e()]) : _vm._e()])])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-tick"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-tick"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-tick"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-tick"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "cpf-cnpj-label",
	    attrs: {
	      "for": "cpfCnpjTransportador"
	    }
	  }, [_vm._v("\n                 CNPJ ou CPF do transportador"), _c('span', {
	    staticClass: "required-asterisk"
	  }, [_vm._v("*")])])
	}]}

/***/ }),
/* 2070 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('form', {
	    staticClass: "form form-inline margin-t20",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.doFilter(true)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "inline filter-period"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('span', {
	    staticClass: "period"
	  }, [_vm._v("Período:")]), _vm._v(" "), _c('dropdown', {
	    staticClass: "dropdown-lastdays",
	    attrs: {
	      "options": _vm.lastDaysOptions
	    },
	    model: {
	      value: (_vm.lastDays),
	      callback: function($$v) {
	        _vm.lastDays = $$v
	      },
	      expression: "lastDays"
	    }
	  }), _vm._v(" \n            "), _vm._v(" "), _vm._m(1)], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.lastDays == 'custom'),
	      expression: "lastDays == 'custom'"
	    }],
	    staticClass: "inline filter-range"
	  }, [_c('div', {
	    staticClass: "inline margin-side"
	  }, [_c('div', {
	    staticClass: "form-group form-inline",
	    class: {
	      'has-error': _vm.errors.has('Data-inicial')
	    }
	  }, [_c('label', [_vm._v("De:")]), _vm._v(" "), _c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control picker acc",
	    attrs: {
	      "name": "Data-inicial",
	      "format": "dd/MM/yyyy",
	      "language": "pt-br",
	      "data-vv-rules": "required"
	    },
	    model: {
	      value: (_vm.customStart),
	      callback: function($$v) {
	        _vm.customStart = $$v
	      },
	      expression: "customStart"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('Data-inicial')))])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "inline margin-side"
	  }, [_c('div', {
	    staticClass: "form-group form-inline",
	    class: {
	      'has-error': _vm.errors.has('Data-final')
	    }
	  }, [_c('label', [_vm._v("Até:")]), _vm._v(" "), _c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control picker acc",
	    attrs: {
	      "name": "Data-final",
	      "format": "dd/MM/yyyy",
	      "language": "pt-br",
	      "data-vv-as": "data inicial"
	    },
	    model: {
	      value: (_vm.customEnd),
	      callback: function($$v) {
	        _vm.customEnd = $$v
	      },
	      expression: "customEnd"
	    }
	  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('Data-final')))])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "inline filter-plate"
	  }, [_c('div', {
	    staticClass: "inline margin-10 margin-r10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.showToll),
	      expression: "showToll"
	    }],
	    staticClass: "check-terms",
	    attrs: {
	      "id": "filter-toll",
	      "type": "checkbox",
	      "name": "filter-toll",
	      "value": ""
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.showToll) ? _vm._i(_vm.showToll, "") > -1 : (_vm.showToll)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.showToll,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.showToll = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.showToll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.showToll = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "label-terms",
	    attrs: {
	      "for": "filter-toll"
	    }
	  }, [_vm._v("Filtrar N° Vale-pedágio")])]), _vm._v(" "), (_vm.showToll) ? _c('div', {
	    staticClass: "form-group form-plate margin-r10",
	    class: {
	      'has-error': _vm.errors.has('toll')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.toll),
	      expression: "toll"
	    }],
	    staticClass: "form-control plate-field",
	    attrs: {
	      "type": "text",
	      "name": "toll",
	      "placeholder": "Digite o N° VP"
	    },
	    domProps: {
	      "value": (_vm.toll)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.doFilter(true)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.toll = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('toll')))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "inline margin-10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.showPlate),
	      expression: "showPlate"
	    }],
	    staticClass: "check-terms",
	    attrs: {
	      "id": "filter-plate",
	      "type": "checkbox",
	      "name": "filter-plate",
	      "value": ""
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.showPlate) ? _vm._i(_vm.showPlate, "") > -1 : (_vm.showPlate)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.showPlate,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.showPlate = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.showPlate = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.showPlate = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "label-terms",
	    attrs: {
	      "for": "filter-plate"
	    }
	  }, [_vm._v("Filtrar por Placa")])]), _vm._v(" "), (_vm.showPlate) ? _c('div', {
	    staticClass: "form-group form-plate",
	    class: {
	      'has-error': _vm.errors.has('plate')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.plate),
	      expression: "plate"
	    }, {
	      name: "mask-plate",
	      rawName: "v-mask-plate"
	    }],
	    staticClass: "form-control plate-field upper",
	    attrs: {
	      "type": "text",
	      "name": "plate",
	      "placeholder": "Digite a Placa"
	    },
	    domProps: {
	      "value": (_vm.plate)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.doFilter(true)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.plate = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('plate')))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "inline margin-10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.showRoute),
	      expression: "showRoute"
	    }],
	    staticClass: "check-terms",
	    attrs: {
	      "id": "filter-route",
	      "type": "checkbox",
	      "name": "filter-route",
	      "value": ""
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.showRoute) ? _vm._i(_vm.showRoute, "") > -1 : (_vm.showRoute)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.showRoute,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.showRoute = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.showRoute = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.showRoute = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "label-terms",
	    attrs: {
	      "for": "filter-route"
	    }
	  }, [_vm._v("Filtrar por Rota")])]), _vm._v(" "), (_vm.showRoute) ? _c('div', {
	    staticClass: "form-group form-plate",
	    class: {
	      'has-error': _vm.errors.has('route')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.route),
	      expression: "route"
	    }],
	    staticClass: "form-control plate-field",
	    attrs: {
	      "type": "text",
	      "name": "route",
	      "placeholder": "Digite a Rota"
	    },
	    domProps: {
	      "value": (_vm.route)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.doFilter(true)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.route = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('route')))])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "inline filter-button text-center"
	  }, [_c('button', {
	    staticClass: "btn btn-purple btn-sm btn-filter",
	    attrs: {
	      "type": "button",
	      "name": "btnFind"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.doFilter(true)
	      }
	    }
	  }, [_vm._v("Filtrar")])])])])]), _vm._v(" "), (_vm.searchState == 'NOTFOUND') ? _c('div', {
	    staticClass: "alert alert-warning margin-t10"
	  }, [_vm._v("Nenhum dado encontrado no período.")]) : _vm._e(), _vm._v(" "), (_vm.searchState == 'ERROSEARCH') ? _c('div', {
	    staticClass: "alert alert-danger margin-t10"
	  }, [_c('ol', [_c('li', [_vm._v(_vm._s(_vm.messageError))])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    staticClass: "col-xs-12"
	  }, [(_vm.searchState == 'FOUND') ? [_c('div', {
	    staticClass: "row margin-t20 resumo-table",
	    attrs: {
	      "id": "resumeTable"
	    }
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table no-footer",
	    attrs: {
	      "role": "grid"
	    }
	  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.listValePedagio), function(l, index) {
	    return _c('tr', {
	      class: {
	        red: l.idProtocoloCanc != null
	      },
	      attrs: {
	        "role": "row"
	      }
	    }, [_c('td', [_vm._v(_vm._s(l.rota))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(l.idProtocolo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTime")(l.dataEmissao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTime")(l.startVP)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTime")(l.expirationVP)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(l.transportador))]), _vm._v(" "), _c('td', {
	      staticClass: "plate-box"
	    }, [_c('p', {
	      staticClass: "cell-plate"
	    }, [_c('a', [_c('span', [_vm._v(_vm._s(l.placaVeiculo))])])])]), _vm._v(" "), _c('td', {
	      staticClass: "text-right value no-wrapp"
	    }, [_vm._v(_vm._s(_vm._f("cents")(l.valorVP)))]), _vm._v(" "), _c('td', {
	      staticClass: "no-wrapp"
	    }, [_c('router-link', {
	      attrs: {
	        "to": {
	          name: 'summary-accompaniment',
	          params: {
	            contractId: _vm.contractId,
	            idVP: l.idIntern
	          }
	        },
	        "tag": "a",
	        "target": "_blank",
	        "data-toggle": "tooltip",
	        "data-placement": "bottom",
	        "title": "Comprovante do Vale-pedágio"
	      }
	    }, [_c('div', {
	      staticClass: "btn btn-icon"
	    }, [_c('i', {
	      staticClass: "icon-paper bold"
	    })])]), _vm._v(" "), (l.idProtocoloCanc != null) ? _c('button', {
	      staticClass: "btn btn-icon",
	      attrs: {
	        "disabled": "disabled"
	      }
	    }, [_c('i', {
	      staticClass: "icon-cross"
	    })]) : _c('button', {
	      staticClass: "btn btn-icon",
	      attrs: {
	        "data-toggle": "tooltip",
	        "data-placement": "bottom",
	        "title": "Excluir Vale-pedágio"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.cancelar(l.idIntern, l.placaVeiculo)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "icon-cross"
	    })])], 1)])
	  }), 0)])])])]), _vm._v(" "), (_vm.listValePedagio) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 text-center"
	  }, [_c('pagination', {
	    attrs: {
	      "model": _vm.page
	    },
	    on: {
	      "page-change": _vm.setCurrentPage
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 result-table-count text-center"
	  }, [_vm._v("\n            Mostrando resultados de " + _vm._s(_vm.page.firstIndexShown()) + " a " + _vm._s(_vm.page.lastIndexShown()) + " de um total de " + _vm._s(_vm.page.itemCount()) + "\n            encontrados.\n          ")])])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [(_vm.hasValePedagio) ? _c('div', {
	    staticClass: "action-buttons-box"
	  }, [_c('button', {
	    staticClass: "btn btn-default margin-t10",
	    on: {
	      "click": function($event) {
	        return _vm.exportarRelatorioCompleto()
	      }
	    }
	  }, [_vm._v("\n              Extrato Completo Excel\n              "), _c('i', {
	    staticClass: "icon-xls align-icon-left"
	  })]), _vm._v(" "), (_vm.parent) ? _c('button', {
	    staticClass: "btn btn-default margin-t10",
	    on: {
	      "click": function($event) {
	        return _vm.exportarRelatorioParent()
	      }
	    }
	  }, [_vm._v("\n            Extrato Unificado Excel\n            "), _c('i', {
	    staticClass: "icon-xls align-icon-left"
	  })]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default margin-t10",
	    on: {
	      "click": function($event) {
	        return _vm.exportarRelatorio('excel')
	      }
	    }
	  }, [_vm._v("\n            Exportar Excel\n            "), _c('i', {
	    staticClass: "icon-xls align-icon-left"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default margin-t10",
	    on: {
	      "click": function($event) {
	        return _vm.exportarRelatorio('pdf')
	      }
	    }
	  }, [_vm._v("\n              Exportar PDF\n              "), _c('i', {
	    staticClass: "icon-pdf align-icon-left"
	  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "back-button-box"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back margin-t20",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v(" Voltar\n          ")])], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title title-plans"
	  }, [_vm._v("Acompanhamento")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('b', [_c('i', {
	    staticClass: "icon-info",
	    attrs: {
	      "data-toggle": "tooltip",
	      "data-placement": "bottom",
	      "title": "A data de processamento que será considerada na filtragem."
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('b', [_c('i', {
	    staticClass: "icon-info",
	    attrs: {
	      "data-toggle": "tooltip",
	      "data-placement": "bottom",
	      "title": "A data de processamento que será considerada na filtragem."
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', {
	    attrs: {
	      "role": "row"
	    }
	  }, [_c('th', {
	    attrs: {
	      "width": "14%"
	    }
	  }, [_vm._v("Nome da rota")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "14%"
	    }
	  }, [_vm._v("N° Vale-pedágio")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "13%"
	    }
	  }, [_vm._v("Data de Emissão")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "13%"
	    }
	  }, [_vm._v("Data de Início")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "13%"
	    }
	  }, [_vm._v("Data de Expiração")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "18%"
	    }
	  }, [_vm._v("Transportador")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "8%"
	    }
	  }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
	    staticClass: "text-right",
	    attrs: {
	      "width": "11%"
	    }
	  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "8%"
	    }
	  })])])
	}]}

/***/ }),
/* 2071 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "col-md-2"
	  }, [_c('strong', [_vm._v("Placa")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filter.plate),
	      expression: "filter.plate"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "plate"
	    },
	    domProps: {
	      "value": (_vm.filter.plate)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.filter, "plate", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-inline col-md-3"
	  }, [_c('strong', [_vm._v("Data Passagem")]), _vm._v(" "), _c('datepicker', {
	    staticClass: "form-control",
	    attrs: {
	      "format": "dd/MM/yyyy",
	      "language": "pt-br",
	      "data-vv-as": "data passagem"
	    },
	    model: {
	      value: (_vm.occurrenceDate),
	      callback: function($$v) {
	        _vm.occurrenceDate = $$v
	      },
	      expression: "occurrenceDate"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('br'), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info",
	    on: {
	      "click": function($event) {
	        return _vm.searchRefunds()
	      }
	    }
	  }, [_vm._v("Buscar")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [(_vm.refunds.length > 0) ? _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    staticClass: "col-xs-12 min-content"
	  }, [_c('table', [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.refunds), function(r, i) {
	    return _c('tr', {
	      key: i
	    }, [_c('td', [_vm._v(_vm._s(r.refundPassageId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r.plate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTime")(r.occurrenceDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r.refundTypeDescription))]), _vm._v(" "), _c('td', {
	      attrs: {
	        "align": "center"
	      }
	    }, [_vm._v(_vm._s(r.classifiedClass))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("cents")(r.passageValue)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r.tagSerialNumber))]), _vm._v(" "), _c('td', {
	      attrs: {
	        "align": "center"
	      }
	    }, [_c('i', {
	      staticClass: "icon-info",
	      attrs: {
	        "title": 'Detalhes da contestação ' + r.refundPassageId
	      },
	      on: {
	        "click": function($event) {
	          return _vm.getRefundDetails(r)
	        }
	      }
	    })]), _vm._v(" "), (r.status == 1) ? _c('td', {
	      staticStyle: {
	        "color": "red"
	      }
	    }, [_vm._v("Pendente")]) : (r.status == 2) ? _c('td', {
	      staticStyle: {
	        "color": "red"
	      }
	    }, [_vm._v("Pendente")]) : (r.status == 3) ? _c('td', {
	      staticStyle: {
	        "color": "green"
	      }
	    }, [_vm._v("Aprovado")]) : (r.status == 4) ? _c('td', {
	      staticStyle: {
	        "color": "red"
	      }
	    }, [_vm._v("Pendente")]) : (r.status == 5) ? _c('td', {
	      staticStyle: {
	        "color": "green"
	      }
	    }, [_vm._v("Aprovado")]) : (r.status == 6) ? _c('td', {
	      staticStyle: {
	        "color": "red"
	      }
	    }, [_vm._v("Recusado")]) : (r.status == 7) ? _c('td', {
	      staticStyle: {
	        "color": "green"
	      }
	    }, [_vm._v("Aprovado")]) : _vm._e()])
	  }), 0)])]) : _vm._e()]), _vm._v(" "), (_vm.refundSelected) ? _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": "refundDetails",
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-labelledby": "refundDetails",
	      "aria-hidden": "true"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog modal-xl",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "modal-body scroll"
	  }, [_c('div', {
	    attrs: {
	      "id": "detailsCurrentPassage"
	    }
	  }, [_c('div', {
	    staticClass: "row mt-3"
	  }, [_c('div', {
	    staticClass: "col-md-2"
	  }, [_vm._m(3), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detailstransactionId"
	    }
	  }, [_vm._v("\n                    " + _vm._s(_vm.refundSelected.transactionId) + "\n                  ")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_vm._m(4), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detailsoccurrenceDate"
	    }
	  }, [_vm._v("\n                    " + _vm._s(_vm._f("dateTime")(_vm.refundSelected.occurrenceDate)) + "\n                  ")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_vm._m(5), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detailsinsertDate"
	    }
	  }, [_vm._v("\n                    " + _vm._s(_vm._f("dateTime")(_vm.refundSelected.insertDate)) + "\n                  ")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_vm._m(6), _vm._v(" "), (_vm.refundSelected.debitado == -1) ? _c('p', [_vm._v("Erro")]) : _vm._e(), _vm._v(" "), (_vm.refundSelected.debitado == 0) ? _c('p', [_vm._v("Não")]) : _vm._e(), _vm._v(" "), (_vm.refundSelected.debitado == 1) ? _c('p', [_vm._v("Sim")]) : _vm._e(), _vm._v(" "), (_vm.refundSelected.debitado == 2) ? _c('p', [_vm._v("Isento")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_vm._m(7), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detailsNameUser"
	    }
	  }, [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_vm._m(8), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detailsCpfCnpj"
	    }
	  }, [_vm._v("\n                    " + _vm._s(_vm._f("cpfCnpj")(_vm.refundSelected.taxPayerIdNumber)) + "\n                  ")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_vm._m(9), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detailsAssociate"
	    }
	  }, [_vm._v("\n                    " + _vm._s(_vm.refundSelected.associate) + "\n                    ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_vm._m(10), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detailsPraca"
	    }
	  }, [_vm._v("\n                    " + _vm._s(_vm.refundSelected.description) + "\n                    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_vm._m(11), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detailsPista"
	    }
	  }, [_vm._v("\n                    " + _vm._s(_vm.refundSelected.pista) + "\n                    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_vm._m(12), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detailsCategoriaCorreta"
	    }
	  }, [_vm._v("\n                    " + _vm._s(_vm.refundSelected.categoryCorrect) + "\n                    ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_vm._m(13), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detailsCategoriaCobrada"
	    }
	  }, [_vm._v("\n                    " + _vm._s(_vm.refundSelected.classifiedClass) + "\n                    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_vm._m(14), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detailsPassageValue"
	    }
	  }, [_vm._v("\n                    " + _vm._s(_vm._f("cents")(_vm.refundSelected.passageValue)) + "\n                  ")])]), _vm._v(" "), (_vm.dataEstorno) ? _c('div', {
	    staticClass: "col-md-3"
	  }, [_vm._m(15), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detailsDataDebitoRecusadoEst"
	    }
	  }, [_vm._v("\n                    " + _vm._s(_vm._f("dateTime")(_vm.dataEstorno)) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.dataCancelaEstorno) ? _c('div', {
	    staticClass: "col-md-3"
	  }, [_vm._m(16), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detailsDataDebitoRecusadoCanc"
	    }
	  }, [_vm._v("\n                    " + _vm._s(_vm._f("dateTime")(_vm.dataCancelaEstorno)) + "\n                    ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_vm._m(17), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detailsCategoriaCobrada"
	    }
	  }, [_vm._v("\n                    " + _vm._s(_vm._f("cents")(_vm.refundSelected.valueCategCorrect)) + "\n                    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_vm._m(18), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detailsReturnValue"
	    }
	  }, [_vm._v("\n                    " + _vm._s(_vm._f("cents")(_vm.refundSelected.returnValue)) + "\n                  ")])])]), _vm._v(" "), (_vm.hasComments) ? _c('div', [_c('br'), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._l((_vm.refundPassageHist), function(c) {
	    return _c('div', {
	      key: c.refundPassageHistId
	    }, [(c.userType == 2 && c.status == 6) ? _c('div', {
	      staticClass: "alert alert-warning"
	    }, [_c('p', [_c('strong', [_vm._v(_vm._s(c.userTypeString) + ":")]), _vm._v("\n                    " + _vm._s(c.comments) + "\n                    "), _c('strong', [_vm._v(" " + _vm._s(_vm._f("dateTime")(c.createdDate)) + " ")])])]) : _vm._e()])
	  })], 2) : _vm._e()])]), _vm._v(" "), _vm._m(20)])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title title-plans"
	  }, [_vm._v("Contestação")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "width": "8%"
	    }
	  }, [_vm._v("Cód. Contestação")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "8%"
	    }
	  }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "12%"
	    }
	  }, [_vm._v("Data da Passagem")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "10%"
	    }
	  }, [_vm._v("Praça")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "10%"
	    }
	  }, [_vm._v("Tipo")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "5%"
	    }
	  }, [_vm._v("Categoria Passagem")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "5%"
	    }
	  }, [_vm._v("Valor Cobrado")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "5%"
	    }
	  }, [_vm._v("Tag(serial)")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "3%"
	    }
	  }), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "5%"
	    }
	  }, [_vm._v("Status")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('h5', {
	    staticClass: "modal-title",
	    attrs: {
	      "id": "refundDetails"
	    }
	  }, [_vm._v("\n              Dados da Passagem\n            ")]), _vm._v(" "), _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "detailstransactionId"
	    }
	  }, [_c('strong', [_vm._v("Transação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "detailsoccurrenceDate"
	    }
	  }, [_c('strong', [_vm._v("Ocorrência")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "detailsinsertDate"
	    }
	  }, [_c('strong', [_vm._v("Contestação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "detailsDebitado"
	    }
	  }, [_c('strong', [_vm._v("Debitada")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "detailsNameUser"
	    }
	  }, [_c('strong', [_vm._v("Nome / Razão Social")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "detailsCpfCnpj"
	    }
	  }, [_c('strong', [_vm._v("CPF / CNPJ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "detailsAssociate"
	    }
	  }, [_c('strong', [_vm._v("Concessionária")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "detailsPraca"
	    }
	  }, [_c('strong', [_vm._v("Praça")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "detailsPista"
	    }
	  }, [_c('strong', [_vm._v("Pista")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "detailsCategoriaCorreta"
	    }
	  }, [_c('strong', [_vm._v("Categoria Correta")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "detailsCategoriaCobrada"
	    }
	  }, [_c('strong', [_vm._v("Categoria Cobrada")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "detailsPassageValue"
	    }
	  }, [_c('strong', [_vm._v("Valor")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "detailsDataDebitoRecusadoEst"
	    }
	  }, [_c('strong', [_vm._v("Data do estorno passagem")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "detailsDataDebitoRecusadoCanc"
	    }
	  }, [_c('strong', [_vm._v("Data canc. est. passagem")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "detailsCategoriaCobrada"
	    }
	  }, [_c('strong', [_vm._v("Valor Correto")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "detailsReturnValue"
	    }
	  }, [_c('strong', [_vm._v("Valor a Ressarcir")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "Motivo"
	    }
	  }, [_c('strong', [_vm._v("Comentários: ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-secondary",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("\n              Voltar\n            ")])])
	}]}

/***/ }),
/* 2072 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('ul', {
	    staticClass: "choose-plan"
	  }, [_c('li', {
	    class: {
	      active: _vm.changePlan == 'b2cSodre'
	    },
	    on: {
	      "click": function($event) {
	        _vm.changePlan = 'b2cSodre'
	      }
	    }
	  }, [_vm._v("\n              Para Você\n            ")]), _vm._v(" "), _c('li', {
	    class: {
	      active: _vm.changePlan == 'b2bSodre'
	    },
	    on: {
	      "click": function($event) {
	        _vm.changePlan = 'b2bSodre'
	      }
	    }
	  }, [_vm._v("\n              Para Sua Empresa\n            ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "bold margin-b0 margin-t30"
	  }, [_vm._v("PLANO")]), _vm._v(" "), (_vm.changePlan == 'b2cSodre') ? _c('p', [_vm._v("Ideal para você :")]) : _c('p', [_vm._v("Indispensável à sua empresa :")]), _vm._v(" "), (_vm.changePlan == 'b2cSodre') ? _c('b2cSodre', {
	    staticClass: "margin-t20",
	    attrs: {
	      "type": "adhesion"
	    }
	  }) : _c('b2bSodre', {
	    staticClass: "margin-t20",
	    attrs: {
	      "type": "adhesion"
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2073 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "map"
	  })])
	}]}

/***/ }),
/* 2074 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('b2c', {
	    attrs: {
	      "type": "adhesion"
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("Serviços para Você")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-b10"
	  }, [_c('h3', {
	    staticClass: "bold upper"
	  }, [_vm._v("Planos")]), _vm._v(" "), _c('p', [_vm._v("Temos dois planos, com certeza um deles é ideal para você, é só escolher:")])])])
	}]}

/***/ }),
/* 2075 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('b2b', {
	    attrs: {
	      "type": "adhesion"
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("Serviços para Empresas")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-b10"
	  }, [_c('h3', {
	    staticClass: "bold upper"
	  }, [_vm._v("Planos")]), _vm._v(" "), _c('p', [_vm._v("Conheça as vantagens que cada plano possui e escolha o que melhor se encaixa na necessidade do seu negócio:")])])])
	}]}

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [(_vm.orderResult) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-box margin-b20 padding-b10"
	  }, [_c('b', {
	    staticClass: "title-identification margin-b10"
	  }, [_vm._v("Resumo e Confirmação do pedido")]), _vm._v(" "), (_vm.rodosol) ? _c('div', {
	    staticClass: "teste bold"
	  }, [_c('span', [_vm._v("Saldo remanescente Plano Rodosol")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("cents")(_vm.contract.currentBalance.currentBalance)))])]) : _vm._e(), _vm._v(" "), (
	    _vm.contract &&
	    _vm.contract.plan &&
	    _vm.contract.plan.name &&
	    _vm.order &&
	    !(_vm.order.salesType === 'RECHARGE' || _vm.order.type === 'RECHARGE')
	  ) ? _c('div', {
	    staticClass: "text-center"
	  }, [_c('p', {
	    staticClass: "info-choose-plan"
	  }, [_vm._v("\n            Plano Escolhido: "), _c('b', [_vm._v(_vm._s(_vm.contract.plan.name))])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-content"
	  }, [(
	    _vm.orderResult.salesType != 'RECHARGE' &&
	    (_vm.isCaminhoParana || _vm.order.promotionCode == 'CAMINHOSDOPARANA')
	  ) ? _c('div', {
	    staticClass: "row"
	  }, [_vm._m(0)]) : (
	    _vm.orderResult.salesType != 'RECHARGE' &&
	    _vm.orderResult.salesType != 'MIGRATIONPLAN'
	  ) ? _c('div', [(!_vm.order.salesOrderId) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('b', [_vm._v("Forma de envio")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    class: _vm.possuiTagReserva ? 'col-md-4' : 'col-md-6'
	  }, [_c('div', {
	    staticClass: "content-box methods rbox",
	    class: {
	      active: '1' == _vm.shipmentType
	    },
	    attrs: {
	      "id": "freeBox"
	    },
	    on: {
	      "click": function($event) {
	        _vm.shipmentType = '1'
	      }
	    }
	  }, [_c('div', {
	    staticClass: "methods-rbox"
	  }, [_c('div', {
	    staticClass: "radio-blue category"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.shipmentType),
	      expression: "shipmentType"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "type": "radio",
	      "value": "1",
	      "id": "free",
	      "checked": "",
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.shipmentType, "1")
	    },
	    on: {
	      "change": function($event) {
	        _vm.shipmentType = "1"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label label-h4",
	    attrs: {
	      "for": "free"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "check first"
	  })])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
	    class: _vm.possuiTagReserva ? 'col-md-4' : 'col-md-6'
	  }, [(_vm.showRetiradaEmMaos) ? _c('div', {
	    staticClass: "content-box methods rbox",
	    class: {
	      active: '3' == _vm.shipmentType
	    },
	    attrs: {
	      "id": "emMaosBox"
	    },
	    on: {
	      "click": function($event) {
	        _vm.shipmentType = '3'
	      }
	    }
	  }, [_c('div', {
	    staticClass: "methods-rbox"
	  }, [_c('div', {
	    staticClass: "radio-blue category"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.shipmentType),
	      expression: "shipmentType"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "type": "radio",
	      "value": "3",
	      "id": "emMaos",
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.shipmentType, "3")
	    },
	    on: {
	      "change": function($event) {
	        _vm.shipmentType = "3"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label label-h4",
	    attrs: {
	      "for": "emMaos"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "check first"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "text-left"
	  }, [_vm._m(2), _vm._v(" "), _c('p', {
	    style: ({
	      color: _vm.shipmentType == '3' ? '#FFFFFF' : '#666666',
	    })
	  }, [_vm._v("\n                          Para retirada do TAG apenas em local autorizado\n                          (Parceiro).\n                        ")])])]) : _vm._e()]), _vm._v(" "), (_vm.possuiTagReserva) ? _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "content-box methods rbox",
	    class: {
	      active: '4' == _vm.shipmentType
	    },
	    attrs: {
	      "id": "tagEmMaosBox"
	    },
	    on: {
	      "click": function($event) {
	        _vm.shipmentType = '4'
	      }
	    }
	  }, [_c('div', {
	    staticClass: "methods-rbox"
	  }, [_c('div', {
	    staticClass: "radio-blue category"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.shipmentType),
	      expression: "shipmentType"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "type": "radio",
	      "value": "4",
	      "id": "possuiTagReserva",
	      "required": ""
	    },
	    domProps: {
	      "checked": _vm._q(_vm.shipmentType, "4")
	    },
	    on: {
	      "change": function($event) {
	        _vm.shipmentType = "4"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label label-h4",
	    attrs: {
	      "for": "possuiTagReserva"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "check first"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "text-left"
	  }, [_vm._m(3), _vm._v(" "), _c('p', {
	    style: ({
	      paddingRight: '10px',
	      color: _vm.shipmentType == '4' ? '#FFFFFF' : '#666666',
	    })
	  }, [_vm._v("\n                      TAG já disponível para ativação imediata.\n                      ")])])])]) : _vm._e()]), _vm._v(" "), (
	    _vm.shipmentType && _vm.shipmentType != 3 && _vm.shipmentType != 4
	  ) ? _c('div', {
	    staticClass: "alert alert-warning alert-dismissible margin-b10 margin-t20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._m(4), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Prazo de entrega")]), _vm._v(":\n                    "), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.prazoEntrega)
	    }
	  })])]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('section', [(
	    (!_vm.shipmentType || _vm.shipmentType == 1) &&
	    !_vm.order.salesOrderId &&
	    _vm.orderResult.salesType != 'RECHARGE' &&
	    !(
	      _vm.isCaminhoParana || _vm.order.promotionCode == 'CAMINHOSDOPARANA'
	    )
	  ) ? _c('div', {
	    staticClass: "margin-t20 sent-address-box"
	  }, [_c('div', {
	    staticClass: "row",
	    on: {
	      "click": function($event) {
	        _vm.toggle = !_vm.toggle
	      }
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('b', [_vm._v("Detalhes da entrega")]), _vm._v(" "), _c('i', {
	    staticClass: "icon-arrow-major-down",
	    class: {
	      open: !_vm.toggle
	    }
	  })])]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "form-horizontal",
	    class: {
	      open: !_vm.toggle
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6",
	    class: {
	      'col-md-12': '3' == _vm.shipmentType
	    }
	  }, [_c('br'), _vm._v(" "), _c('div', {
	    staticClass: "form-group no-margin"
	  }, [(_vm.account && _vm.account.person) ? _c('label', {
	    staticClass: "col-xs-4 text-right"
	  }, [_vm._v("\n                        Nome completo:\n                      ")]) : _c('label', {
	    staticClass: "col-xs-4 text-right"
	  }, [_vm._v("\n                        Empresa:\n                      ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-8 margin-t2"
	  }, [_c('p', {
	    staticClass: "no-margin bold"
	  }, [_vm._v(_vm._s(_vm.nomePfPj))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group no-margin"
	  }, [_c('label', {
	    staticClass: "col-xs-4 text-right"
	  }, [_vm._v(" E-mail: ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-8"
	  }, [_c('p', {
	    staticClass: "no-margin bold"
	  }, [_vm._v(_vm._s(_vm.email))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group no-margin"
	  }, [_c('label', {
	    staticClass: "col-xs-4 text-right",
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Tel. Celular:\n                      ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-8"
	  }, [_c('p', {
	    staticClass: "no-margin bold"
	  }, [_vm._v(_vm._s(_vm.cellPhone))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "address-box col-md-12"
	  }, [_c('div', {
	    staticClass: "address-info"
	  }, [_c('p', [_vm._v("\n                            " + _vm._s(_vm.address.address) + ", " + _vm._s(_vm.address.number) + " -\n                            " + _vm._s(_vm.address.neighborhood) + "\n                          ")]), _vm._v(" "), _c('p', [_vm._v("\n                            CEP " + _vm._s(_vm.address.zipCode) + " - " + _vm._s(_vm.address.city) + " -\n                            " + _vm._s(_vm.address.state) + "\n                          ")])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-sm bold",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.addNewAddress()
	      }
	    }
	  }, [_vm._v("\n                          Alterar Endereço\n                        ")])]), _vm._v(" "), _vm._m(5)])])]), _vm._v(" "), (
	    _vm.shipmentType &&
	    (!_vm.isCaminhoParana ||
	      _vm.order.promotionCode != 'CAMINHOSDOPARANA')
	  ) ? _c('div', [(_vm.shipmentType) ? _c('div', {
	    staticClass: "margin-t20"
	  }, [_c('b', [_vm._v("Veículo(s)")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "form-horizontal",
	    class: {
	      open: !_vm.toggle
	    }
	  }, _vm._l((_vm.listVehicles), function(vehicle, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "vehicle-box"
	    }, [_c('div', {
	      staticClass: "inline plate-box border-right-gray"
	    }, [_c('p', {
	      staticClass: "cell-plate info-car"
	    }, [_vm._v("\n                            Placa\n                            "), _c('span', [_vm._v(_vm._s(vehicle.plate))])])]), _vm._v(" "), _c('p', {
	      staticClass: "inline border-right-gray"
	    }, [_vm._v("\n                          Marca "), _c('b', [_vm._v(_vm._s(vehicle.model.brand.name))])]), _vm._v(" "), _c('p', {
	      staticClass: "inline"
	    }, [_vm._v("\n                          Modelo "), _c('b', [_vm._v(_vm._s(vehicle.model.name))])])])
	  }), 0)]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.shipmentType == 3) ? _c('div', {
	    staticClass: "margin-t20"
	  }, [_vm._m(6)]) : _vm._e(), _vm._v(" "), (
	    _vm.shipmentType &&
	    (_vm.shipmentType == 3 ||
	      _vm.shipmentType == 4 ||
	      _vm.isCaminhoParana ||
	      _vm.order.promotionCode == 'CAMINHOSDOPARANA')
	  ) ? _c('div', {
	    staticClass: "margin-t20 paranaway-vehicle",
	    class: {
	      'tag-in-hand-layout': _vm.shipmentType == 4
	    },
	    on: {
	      "click": function($event) {
	        _vm.shipmentType == 4 ? null : (_vm.toggle = !_vm.toggle)
	      }
	    }
	  }, [_c('b', [_vm._v("Veículo(s)")]), _vm._v(" "), (_vm.shipmentType != 4) ? _c('i', {
	    staticClass: "icon-arrow-major-down",
	    class: {
	      open: !_vm.toggle
	    }
	  }) : _vm._e(), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "form-horizontal",
	    class: {
	      open: _vm.shipmentType == 4 || !_vm.toggle
	    }
	  }, _vm._l((_vm.listVehicles), function(vehicle, index) {
	    return _c('div', {
	      key: vehicle.vehicleId || vehicle.plate || index,
	      staticClass: "vehicle-box"
	    }, [_c('div', {
	      staticClass: "vehicle-box-info"
	    }, [_c('div', {
	      staticClass: "inline"
	    }, [_c('p', {
	      staticClass: "cell-plate info-car"
	    }, [_vm._v("\n                        Placa\n                        "), _c('span', [_vm._v(_vm._s(vehicle.plate))])])]), _vm._v(" "), _c('p', {
	      staticClass: "inline"
	    }, [_vm._v("\n                      Marca "), _c('b', [_vm._v(_vm._s(vehicle.model.brand.name))])]), _vm._v(" "), _c('p', {
	      staticClass: "inline"
	    }, [_vm._v("\n                      Modelo "), _c('b', [_vm._v(_vm._s(vehicle.model.name))])])]), _vm._v(" "), (_vm.shipmentType == 4 && _vm.tagInHandStates[index]) ? _c('div', {
	      staticClass: "vehicle-tag-activation"
	    }, [_c('div', {
	      staticClass: "tag-input-wrapper",
	      class: {
	        'has-value':
	        _vm.tagInHandStates[index].serialNumber &&
	          _vm.tagInHandStates[index].serialNumber.length > 0,
	      }
	    }, [(
	      _vm.tagInHandStates[index].serialNumber &&
	      _vm.tagInHandStates[index].serialNumber.length > 0
	    ) ? _c('span', {
	      staticClass: "tag-input-floating-label"
	    }, [_vm._v("\n                        Número da TAG "), _c('span', [_vm._v("*")])]) : _vm._e(), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.tagInHandStates[index].serialNumber),
	        expression: "tagInHandStates[index].serialNumber"
	      }],
	      staticClass: "form-control input-tag-inline",
	      attrs: {
	        "type": "text",
	        "id": 'tagSerialNumberInHand-' + index,
	        "inputmode": "numeric",
	        "pattern": "[0-9]*",
	        "placeholder": "Digite o número da TAG",
	        "disabled": _vm.tagInHandStates[index].success ||
	          _vm.tagInHandStates[index].loading,
	        "maxlength": "18",
	        "minlength": "8"
	      },
	      domProps: {
	        "value": (_vm.tagInHandStates[index].serialNumber)
	      },
	      on: {
	        "input": [function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(_vm.tagInHandStates[index], "serialNumber", $event.target.value)
	        }, function($event) {
	          return _vm.handleTagSerialNumberInput(index)
	        }]
	      }
	    })]), _vm._v(" "), _c('button', {
	      staticClass: "btn btn-tag-activate",
	      attrs: {
	        "type": "button",
	        "disabled": !_vm.canActivateTagInHand(index)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.validateTagInHand(vehicle, index)
	        }
	      }
	    }, [(_vm.tagInHandStates[index].loading) ? _c('span', [_vm._v("Validando...")]) : _c('span', [_vm._v("Ativar TAG")])]), _vm._v(" "), (_vm.tagInHandStates[index].error) ? _c('div', {
	      staticClass: "tag-error"
	    }, [_c('svg', {
	      attrs: {
	        "width": "16",
	        "height": "16",
	        "viewBox": "0 0 16 16",
	        "fill": "none",
	        "xmlns": "http://www.w3.org/2000/svg"
	      }
	    }, [_c('g', {
	      attrs: {
	        "clip-path": "url(#clip0_15_906)"
	      }
	    }, [_c('path', {
	      attrs: {
	        "d": "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
	        "fill": "#D32F2F"
	      }
	    }), _vm._v(" "), _c('path', {
	      attrs: {
	        "d": "M5 5L11 11M11 5L5 11",
	        "stroke": "white",
	        "stroke-width": "1.5",
	        "stroke-linecap": "round"
	      }
	    })]), _vm._v(" "), _c('defs', [_c('clipPath', {
	      attrs: {
	        "id": "clip0_15_906"
	      }
	    }, [_c('rect', {
	      attrs: {
	        "width": "16",
	        "height": "16",
	        "fill": "white"
	      }
	    })])])]), _vm._v("\n\n                      " + _vm._s(_vm.tagInHandStates[index].error) + "\n                    ")]) : _vm._e()]) : _vm._e()])
	  }), 0)]) : _vm._e(), _vm._v(" "), (
	    _vm.shipmentType != 4 &&
	    (_vm.mostrarValores ||
	      _vm.isCaminhoParana ||
	      _vm.order.promotionCode == 'CAMINHOSDOPARANA' ||
	      _vm.orderResult.salesType == 'MIGRATIONPLAN')
	  ) ? _c('div', {
	    staticClass: "margin-20"
	  }, [_c('b', [_vm._v("Valores")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), [(_vm.orderResult && _vm.orderResult.products) ? _c('table', {
	    staticClass: "table stripped no-footer desk",
	    attrs: {
	      "role": "grid"
	    }
	  }, [_c('tbody', [_vm._l((_vm.orderResult.products), function(product) {
	    return [(product.productId != 11) ? _c('tr', [_c('td', {
	      attrs: {
	        "colspan": "2"
	      }
	    }, [_vm._v("\n                          " + _vm._s(product.productName) + "\n                          "), (_vm.showVehiclesPlates(product)) ? _c('span', [_vm._v("(" + _vm._s(product.quantity) + " veículos)")]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticClass: "text-right"
	    }, [_c('span', {
	      staticClass: "bold"
	    }, [_vm._v(_vm._s(_vm._f("cents")(product.valueTotal)))])])]) : _vm._e()]
	  }), _vm._v(" "), (
	    _vm.orderResult.salesType == 'ADHESION' ||
	    _vm.orderResult.salesType ==
	    'ADHESIONVEHICLEADDITIONAL' ||
	    _vm.orderResult.salesType ==
	    'ADHESIOACONTRACTADDITIONAL'
	  ) ? _c('tr', [_c('td', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("FRETE")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right bold"
	  }, [_vm._v("GRÁTIS")])]) : _vm._e(), _vm._v(" "), (_vm.orderResult.salesType != 'REPLACETAG') ? _c('tr', [_vm._m(7), _vm._v(" "), _c('td', {
	    staticClass: "text-center"
	  }, [(!_vm.reprocess) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cupom),
	      expression: "cupom"
	    }],
	    staticClass: "inline form-control discount discount-coupon",
	    attrs: {
	      "minlength": "5",
	      "maxlength": "25",
	      "type": "text",
	      "placeholder": "Digite o código",
	      "disabled": _vm.descontoCupom != 0
	    },
	    domProps: {
	      "value": (_vm.cupom)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.cupom = $event.target.value
	      }, _vm.handleInputChange]
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.reprocess) ? _c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.descontoCupom),
	      expression: "!descontoCupom"
	    }],
	    staticClass: "inline btn btn-primary btn-discount discount-coupon",
	    attrs: {
	      "type": "button",
	      "name": "button",
	      "disabled": !_vm.cupom
	    },
	    on: {
	      "click": function($event) {
	        return _vm.calculateDiscount()
	      }
	    }
	  }, [_vm._v("\n                          Aplicar Desconto\n                        ")]) : _vm._e(), _vm._v(" "), (!_vm.reprocess) ? _c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.descontoCupom == 2),
	      expression: "descontoCupom == 2"
	    }],
	    staticClass: "inline btn btn-primary btn-discount discount-coupon",
	    staticStyle: {
	      "color": "white",
	      "background-color": "green"
	    },
	    attrs: {
	      "type": "button",
	      "name": "button",
	      "disabled": !_vm.cupom
	    }
	  }, [_vm._v("\n                          Desconto Aplicado\n                        ")]) : _vm._e(), _vm._v(" "), (!_vm.reprocess && _vm.descontoCupom != 2) ? _c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.descontoCupom),
	      expression: "descontoCupom"
	    }],
	    staticClass: "inline btn btn-danger btn-discount discount-coupon",
	    attrs: {
	      "type": "button",
	      "name": "button",
	      "disabled": _vm.disableBf
	    },
	    on: {
	      "click": function($event) {
	        return _vm.removeDiscount()
	      }
	    }
	  }, [_vm._v("\n                          Remover Desconto\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.erroCupom && _vm.descontoCupom != 2) ? _c('div', {
	    staticClass: "discount-error-msg"
	  }, [_c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v(_vm._s(_vm.erroCupom))])]) : _vm._e()]), _vm._v(" "), (_vm.descontoCupom == 2 && _vm.reprocess) ? _c('td', {
	    staticClass: "text-right bold"
	  }, [_vm._v("\n                        " + _vm._s(_vm.cupom) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.descontoCupom != 2) ? _c('td', {
	    staticClass: "text-right bold"
	  }, [_vm._v("\n                        " + _vm._s(_vm._f("cents")(!_vm.descontoCupom ? "-" : (-1 * _vm.descontoCupom))) + "\n                      ")]) : _vm._e()]) : _vm._e()], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
	    staticClass: "bold-600",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("TOTAL")]), _vm._v(" "), (_vm.reprocess) ? _c('td', {
	    staticClass: "bold text-right"
	  }, [_vm._v("\n                        " + _vm._s(_vm._f("cents")(_vm.orderResult.price)) + "\n                      ")]) : _c('td', {
	    staticClass: "bold text-right"
	  }, [_vm._v("\n                        " + _vm._s(_vm._f("cents")(_vm.totalComDesconto)) + "\n                      ")])])])]) : _vm._e(), _vm._v(" "), (_vm.orderResult && _vm.orderResult.products) ? _c('table', {
	    staticClass: "table stripped no-footer mob",
	    attrs: {
	      "role": "grid"
	    }
	  }, [(_vm.orderResult && _vm.orderResult.products) ? _c('tbody', [_vm._l((_vm.orderResult.products), function(product) {
	    return [(product.productId != 11) ? _c('tr', [_c('td', [_vm._v("\n                          " + _vm._s(product.productName) + "\n                          "), (_vm.showVehiclesPlates(product)) ? _c('span', [_vm._v("(" + _vm._s(product.quantity) + " veículos)")]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticClass: "text-right"
	    }, [_c('span', {
	      staticClass: "bold"
	    }, [_vm._v(_vm._s(_vm._f("cents")(product.valueTotal)))])])]) : _vm._e()]
	  }), _vm._v(" "), (
	    _vm.orderResult.salesType == 'ADHESION' ||
	    _vm.orderResult.salesType ==
	    'ADHESIONVEHICLEADDITIONAL' ||
	    _vm.orderResult.salesType ==
	    'ADHESIOACONTRACTADDITIONAL'
	  ) ? _c('tr', [_c('td', [_vm._v("FRETE")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right bold"
	  }, [_vm._v("GRÁTIS")])]) : _vm._e(), _vm._v(" "), (_vm.orderResult.salesType != 'REPLACETAG') ? _c('tr', [_c('td', [_vm._m(8), _vm._v(" "), (!_vm.reprocess) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cupom),
	      expression: "cupom"
	    }],
	    staticClass: "inline form-control discount discount-coupon text-center",
	    attrs: {
	      "minlength": "5",
	      "maxlength": "25",
	      "type": "text",
	      "placeholder": "Digite o código",
	      "disabled": _vm.descontoCupom != 0
	    },
	    domProps: {
	      "value": (_vm.cupom)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.cupom = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.reprocess) ? _c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.descontoCupom),
	      expression: "!descontoCupom"
	    }],
	    staticClass: "inline btn btn-primary btn-discount discount-coupon",
	    attrs: {
	      "type": "button",
	      "name": "button",
	      "disabled": !_vm.cupom
	    },
	    on: {
	      "click": function($event) {
	        return _vm.calculateDiscount()
	      }
	    }
	  }, [_vm._v("\n                          Aplicar\n                        ")]) : _vm._e(), _vm._v(" "), (!_vm.reprocess) ? _c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.descontoCupom),
	      expression: "descontoCupom"
	    }],
	    staticClass: "inline btn btn-danger btn-discount discount-coupon",
	    attrs: {
	      "type": "button",
	      "name": "button",
	      "disabled": _vm.disableBf
	    },
	    on: {
	      "click": function($event) {
	        return _vm.removeDiscount()
	      }
	    }
	  }, [_vm._v("\n                          Remover\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.erroCupom && _vm.descontoCupom != 2) ? _c('div', {
	    staticClass: "discount-error-msg"
	  }, [_c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v(_vm._s(_vm.erroCupom))])]) : _vm._e()]), _vm._v(" "), (_vm.descontoCupom == 2 && _vm.reprocess) ? _c('td', {
	    staticClass: "text-right bold"
	  }, [_vm._v("\n                        " + _vm._s(_vm.cupom) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.descontoCupom != 2) ? _c('td', {
	    staticClass: "text-right bold"
	  }, [_vm._v("\n                        " + _vm._s(_vm._f("cents")(!_vm.descontoCupom ? "-" : (-1 * _vm.descontoCupom))) + "\n                      ")]) : _vm._e()]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
	    staticClass: "bold-600"
	  }, [_vm._v("TOTAL")]), _vm._v(" "), (_vm.reprocess) ? _c('td', {
	    staticClass: "bold text-right"
	  }, [_vm._v("\n                        " + _vm._s(_vm._f("cents")(_vm.orderResult.price)) + "\n                      ")]) : _c('td', {
	    staticClass: "bold text-right"
	  }, [_vm._v("\n                        " + _vm._s(_vm._f("cents")(_vm.totalComDesconto)) + "\n                      ")])])])]) : _vm._e()]], 2) : _vm._e()]), _vm._v(" "), (
	    !_vm.cpm.error &&
	    _vm.orderResult &&
	    !_vm.orderResult.salesOrderId &&
	    _vm.orderResult.salesType != 'RECHARGE'
	  ) ? _c('div', {
	    staticClass: "row"
	  }, [(_vm.orderResult.salesType === 'ADHESION' && (_vm.skipPaymentFlow || _vm.cpm.paymentMethod != null)) ? _c('div', {
	    staticClass: "col-xs-12 margin-t20"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.termsAccepted),
	      expression: "termsAccepted"
	    }],
	    staticClass: "check-terms",
	    attrs: {
	      "id": "terms",
	      "type": "checkbox",
	      "name": "terms",
	      "value": "1"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.termsAccepted) ? _vm._i(_vm.termsAccepted, "1") > -1 : (_vm.termsAccepted)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.termsAccepted,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "1",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.termsAccepted = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.termsAccepted = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.termsAccepted = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "label-terms",
	    attrs: {
	      "for": "terms"
	    }
	  }, [_vm._v("\n                Li e aceito as condições gerais de contratação do serviço\n                apresentadas:\n                "), _c('a', {
	    staticClass: "link",
	    attrs: {
	      "href": "/api/v2/archeion/downloadFileArcheion/termos-e-condicoes-gerais-movemais",
	      "target": "_blank"
	    }
	  }, [_vm._v("Termo Move Mais")]), _vm._v(" "), (_vm.orderResult.planId == 62 || _vm.orderResult.planId == 64) ? _c('span', [_vm._v("e")]) : _vm._e()]), _vm._v(" "), (_vm.orderResult.salesType != 'RECHARGE') ? _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.termsAdhesionShowError),
	      expression: "termsAdhesionShowError"
	    }],
	    staticClass: "alert alert-danger alert-terms",
	    attrs: {
	      "id": "alert-terms",
	      "role": "alert"
	    }
	  }, [_c('span', {
	    staticClass: "help-block term"
	  }, [_vm._v("É necessário ler e concordar com os termos para realizar a\n                  adesão")])]) : _vm._e()]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (
	    _vm.showAddress &&
	    _vm.order &&
	    _vm.order.salesType &&
	    _vm.order.salesType != 'RECHARGE'
	  ) ? _c('div', {}, [(_vm.address) ? _c('div', {
	    staticClass: "row margin-b20 address-resume"
	  }, [(
	    _vm.isCaminhoParana || _vm.order.promotionCode == 'CAMINHOSDOPARANA'
	  ) ? _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('b', [_vm._v("Endereço de retirada da TAG eletrônica")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _vm._m(9)]) : _c('div', {}, [(_vm.orderResult.salesOrderShipment) ? _c('div', {
	    staticClass: "col-xs-12"
	  }, [(_vm.orderResult.salesOrderShipment.shipmentType != 3) ? _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('b', [_vm._v("Endereço de entrega")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "radio-box content-box",
	    class: {
	      active: _vm.whereToDelivery == 0
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.whereToDelivery),
	      expression: "whereToDelivery"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "0",
	      "type": "radio",
	      "name": "radio-address",
	      "value": "0"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.whereToDelivery, "0")
	    },
	    on: {
	      "change": function($event) {
	        _vm.whereToDelivery = "0"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label",
	    attrs: {
	      "for": "0"
	    }
	  }, [_c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("\n                        " + _vm._s(_vm.addressOrderDelivery.address) + ",\n                        " + _vm._s(_vm.addressOrderDelivery.number) + "\n                      ")]), _vm._v(" "), _c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("\n                        " + _vm._s(_vm.addressOrderDelivery.neighborhood) + "\n                      ")]), _vm._v(" "), _c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("\n                        CEP " + _vm._s(_vm.addressOrderDelivery.zipCode) + "\n                      ")]), _vm._v(" "), _c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("\n                        " + _vm._s(_vm.addressOrderDelivery.city) + " -\n                        " + _vm._s(_vm.addressOrderDelivery.state) + " - Brasil\n                      ")]), _vm._v(" "), (
	    _vm.addressOrderDelivery.complement &&
	    _vm.addressOrderDelivery.complement.length > 0
	  ) ? _c('p', [_vm._v("\n                        Complemento - " + _vm._s(_vm.addressOrderDelivery.complement) + "\n                      ")]) : _vm._e(), _vm._v(" "), _c('small', {
	    staticClass: "block"
	  }, [_vm._v("Obs: Os Tags serão entregues no endereço\n                        informado.")])])])]) : _vm._e()]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (
	    _vm.orderResult.salesOrderShipment &&
	    _vm.orderResult.salesOrderShipment.shipmentService == 'PAC' &&
	    _vm.orderResult.salesOrderShipment.trackingNumber
	  ) ? _c('div', {
	    staticClass: "margin-t20 margin-b10"
	  }, [(
	    !_vm.orderResult.salesOrderShipment.trackingNumber ||
	    _vm.orderResult.salesOrderShipment.trackingNumber == 'N/A'
	  ) ? _c('div', [_vm._v("\n            O código de rastreio estará disponivel em breve.\n          ")]) : (_vm.orderResult.salesOrderShipment.carrier == 'CORREIOS') ? _c('form', {
	    attrs: {
	      "method": "GET",
	      "action": "https://www.websro.com.br/rastreamento-correios.php?",
	      "target": "popup",
	      "onsubmit": "window.open('', 'popup', 'width=800,height=400')"
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "P_COD_UNI",
	      "rows": "1",
	      "size": "14",
	      "wrap": "VIRTUAL"
	    },
	    domProps: {
	      "value": _vm.orderResult.salesOrderShipment.trackingNumber
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "inline track-order"
	  }, [_vm._v("\n              Código de Rastreamento:\n              "), _c('b', {
	    staticClass: "upper"
	  }, [_vm._v(_vm._s(_vm.orderResult.salesOrderShipment.trackingNumber))]), _vm._v("\n              - " + _vm._s(_vm.orderResult.salesOrderShipment.carrier) + "\n            ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary btn-sm",
	    attrs: {
	      "type": "submit",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n              Rastrear Entrega\n            ")])]) : (_vm.orderResult.salesOrderShipment.carrier == 'JADLOG') ? _c('form', {
	    attrs: {
	      "method": "POST",
	      "action": "https://www.jadlog.com.br/siteDpd/tracking.jad",
	      "target": "popup",
	      "onsubmit": "window.open('', 'popup', 'width=800,height=400')"
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "cte"
	    },
	    domProps: {
	      "value": _vm.orderResult.salesOrderShipment.trackingNumber
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "lang",
	      "value": ""
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "inline track-order"
	  }, [_vm._v("\n              Código de Rastreamento:\n              "), _c('b', {
	    staticClass: "upper"
	  }, [_vm._v(_vm._s(_vm.orderResult.salesOrderShipment.trackingNumber))]), _vm._v("\n              - " + _vm._s(_vm.orderResult.salesOrderShipment.carrier) + "\n            ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary btn-sm",
	    attrs: {
	      "type": "submit",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n              Rastrear Entrega\n            ")])]) : (
	    _vm.orderResult.salesOrderShipment.carrier == 'TOTALEXPRESS'
	  ) ? _c('form', {
	    attrs: {
	      "method": "GET",
	      "action": "https://tracking.totalexpress.com.br/tracking/0",
	      "target": "popup",
	      "onsubmit": "window.open('', 'popup', 'width=100%')"
	    }
	  }, [_c('p', {
	    staticClass: "inline track-order"
	  }, [_vm._v("\n              Código de Rastreamento:\n              "), _c('b', {
	    staticClass: "upper"
	  }, [_vm._v(_vm._s(_vm.orderResult.salesOrderShipment.trackingNumber))]), _vm._v("\n              - " + _vm._s(_vm.orderResult.salesOrderShipment.carrier) + "\n            ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary btn-sm",
	    attrs: {
	      "type": "submit",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n              Rastrear Entrega\n            ")])]) : (
	    _vm.orderResult.salesOrderShipment.carrier == 'TRANSLEVELOG'
	  ) ? _c('form', {
	    attrs: {
	      "method": "GET",
	      "action": "https://todo.com.br",
	      "target": "popup",
	      "onsubmit": "window.open('', 'popup', 'width=100%')"
	    }
	  }, [_c('p', {
	    staticClass: "inline track-order"
	  }, [_vm._v("\n              Código de Rastreamento:\n              "), _c('b', {
	    staticClass: "upper"
	  }, [_vm._v(_vm._s(_vm.orderResult.salesOrderShipment.trackingNumber))]), _vm._v("\n              - " + _vm._s(_vm.orderResult.salesOrderShipment.carrier) + "\n            ")]), _vm._v(" "), (false) ? _c('button', {
	    staticClass: "btn btn-primary btn-sm",
	    attrs: {
	      "type": "submit",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n              Rastrear Entrega\n            ")]) : _vm._e()]) : _vm._e()]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.showEntries) ? _c('div', {
	    staticClass: "modal fade in",
	    staticStyle: {
	      "display": "block"
	    },
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showEntries = false
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Praças")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('h3', [_vm._v("Praças onde a TAG pode ser retirada")]), _vm._v(" "), _vm._l((_vm.entries), function(item, index) {
	    return _c('div', {
	      key: index
	    }, [_c('p', [_vm._v(_vm._s(item.roadCode) + " KM " + _vm._s(item.km) + " - " + _vm._s(item.city))])])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showEntries = false
	      }
	    }
	  }, [_vm._v("\n            Fechar\n          ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.showVehicle) ? _c('div', {
	    staticClass: "modal fade in",
	    staticStyle: {
	      "display": "block",
	      "background": "rgba(230, 230, 230, 0.8)"
	    },
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header modal-info"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showVehicle = false
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Visualizar Veículos")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('p', {
	    staticClass: "bold-600 text-center"
	  }, [_vm._v("Placa dos Veículos:")]), _vm._v(" "), _c('div', {
	    staticClass: "cell-plate"
	  }, _vm._l((_vm.listVehicles), function(vehicle, index) {
	    return _c('div', {
	      key: index
	    }, [_vm._v("\n              " + _vm._s(vehicle.plate) + "\n            ")])
	  }), 0)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "modal fade agreed",
	    attrs: {
	      "id": "ModalConveniados",
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-labelledby": "ModalListaConveniados"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog modal-lg",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(10), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('table', {
	    staticClass: "table stripped"
	  }, [_vm._m(11), _vm._v(" "), _c('tbody', _vm._l((_vm.conveniados), function(v, index) {
	    return _c('tr', {
	      key: index
	    }, [_c('td', [_vm._v(_vm._s(v.cidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(v.nomeFantasia))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(v.endereco))])])
	  }), 0)]), _vm._v(" "), _vm._l((_vm.conveniados), function(v, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "info mob"
	    }, [_c('p', {
	      staticClass: "inline"
	    }, [_vm._v(_vm._s(v.cidade))]), _vm._v(" "), _c('p', {
	      staticClass: "inline bold"
	    }, [_vm._v(_vm._s(v.nomeFantasia))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(v.endereco))])])
	  })], 2), _vm._v(" "), _vm._m(12)])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": "ModalConveniados2",
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-labelledby": "ModalListaConveniados",
	      "aria-hidden": "true"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog modal-lg",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(13), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [
	    [_c('div', {
	      staticClass: "container"
	    }, [_c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col-xs-12"
	    }, [_c('title-user', [_vm._v(" Parceiros ")]), _vm._v(" "), _c('h3', {
	      staticClass: "bold"
	    }, [_vm._v("\n                    Caso não tenha um local próximo a você, altere a forma de\n                    envio.\n                  ")]), _vm._v(" "), _vm._m(14)], 1)]), _vm._v(" "), _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      directives: [{
	        name: "async",
	        rawName: "v-async.opacity",
	        value: (_vm.loading),
	        expression: "loading",
	        modifiers: {
	          "opacity": true
	        }
	      }],
	      staticClass: "col-xs-12"
	    }, [_c('div', {
	      staticClass: "form-content"
	    }, [_c('div', {
	      staticClass: "row"
	    }, [(_vm.conveniados) ? _c('table', {
	      staticClass: "table no-footer",
	      attrs: {
	        "role": "grid"
	      }
	    }, [_vm._m(15), _vm._v(" "), _c('tbody', _vm._l((_vm.conveniados), function(v, index) {
	      return _c('tr', {
	        key: index
	      }, [_c('td', [_vm._v(_vm._s(v.cidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(v.nomeFantasia))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(v.endereco))])])
	    }), 0)]) : _vm._e()])])])])])]
	  ], 2), _vm._v(" "), _vm._m(16)])])]), _vm._v(" "), (_vm.account || _vm.currentUser) ? _c('div', {
	    staticClass: "modal fade purchase-summary",
	    attrs: {
	      "id": "modalPurchase",
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-labelledby": "modalPurchaseLabel"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog modal-lg",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(17), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_vm._m(18), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "modal-data-box"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [(_vm.account && _vm.account.person) ? _c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Nome completo")]) : _c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Empresa")]), _vm._v(" "), _c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.nomePfPj
	    }
	  })]), _vm._v(" "), (
	    _vm.shipmentType &&
	    _vm.shipmentType != 3 &&
	    _vm.orderResult.salesType != 'RECHARGE' &&
	    !(
	      _vm.isCaminhoParana ||
	      _vm.order.promotionCode == 'CAMINHOSDOPARANA'
	    )
	  ) ? _c('div', [_c('div', {
	    staticClass: "form-group mob"
	  }, [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Endereço")]), _vm._v(" "), _c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.address.address +
	        ', ' +
	        _vm.address.number +
	        ' - ' +
	        _vm.address.neighborhood +
	        (_vm.address.complement ? ' - ' + _vm.address.complement : '')
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row mob"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Cidade")]), _vm._v(" "), _c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.address.city + '-' + _vm.address.state
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("CEP")]), _vm._v(" "), _c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.address.zipCode
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "info-mob"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Endereço")]), _vm._v(" "), _c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.address.address + ', ' + _vm.address.number
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Bairro")]), _vm._v(" "), _c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.address.neighborhood
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("CEP")]), _vm._v(" "), _c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.address.zipCode
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Cidade")]), _vm._v(" "), _c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.address.city + '-' + _vm.address.state
	    }
	  })])])]) : (_vm.shipmentType == 3) ? _c('div', [_vm._m(19)]) : (
	    _vm.orderResult.salesType != 'RECHARGE' &&
	    (_vm.isCaminhoParana ||
	      _vm.order.promotionCode == 'CAMINHOSDOPARANA')
	  ) ? _c('div', {
	    staticClass: "info-paranaway"
	  }, [_vm._m(20)]) : _vm._e()])]), _vm._v(" "), (!_vm.skipPaymentFlow) ? _c('div', {
	    staticClass: "col-md-4 info-purchase"
	  }, [_vm._m(21), _vm._v(" "), (_vm.orderResult && _vm.orderResult.products) ? _c('div', {
	    staticClass: "modal-info-box"
	  }, [_c('p', {
	    staticClass: "upper"
	  }, [_vm._v("seus valores")]), _vm._v(" "), _vm._l((_vm.orderResult.products), function(product, index) {
	    return _c('p', {
	      key: index
	    }, [(_vm.showVehiclesPlates(product)) ? _c('span', [_vm._v("TAG(s) (" + _vm._s(product.quantity) + ")")]) : _c('span', [_vm._v(_vm._s(product.productName))]), _vm._v(" "), (
	      _vm.reprocess &&
	      product.productId == 11 &&
	      product.valueUnit > 0
	    ) ? _c('span', {
	      staticClass: "pull-right"
	    }, [_vm._v(_vm._s(_vm._f("cents")((-1 * product.valueTotal))))]) : _c('span', {
	      staticClass: "pull-right"
	    }, [_vm._v(_vm._s(_vm._f("cents")(product.valueTotal)))])])
	  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\n                  Total da compra\n                  "), _c('span', {
	    staticClass: "pull-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.totalComDesconto)))])]), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', {
	    staticClass: "bold"
	  }, [_vm._v("\n                  Total\n                  "), _c('span', {
	    staticClass: "pull-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.totalComDesconto)))])])], 2) : _vm._e()]) : _vm._e()]), _vm._v(" "), (!_vm.skipPaymentFlow) ? _c('div', {
	    staticClass: "margin-b20 desk"
	  }, [_vm._m(23), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "/static/Lock.svg",
	      "alt": "",
	      "height": "11"
	    }
	  })]) : _vm._e(), _vm._v(" "), (!_vm.skipPaymentFlow) ? _c('div', {
	    staticClass: "row"
	  }, [(_vm.cpm && _vm.cpm.number) ? _c('div', {
	    staticClass: "col-md-8 cc"
	  }, [_c('div', {
	    staticClass: "modal-data-box"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Número do cartão")]), _vm._v(" "), _c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.cpm.number
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "credit-card-selection",
	    attrs: {
	      "src": '/static/payment-methods/' + _vm.cpm.paymentMethod.imagePath
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Títular do cartão")]), _vm._v(" "), _c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.cpm.ownerName
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 mob"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Válido até")]), _vm._v(" "), _c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.cpm.expirationMonth + '/' + _vm.cpm.expirationYear
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-data-box mobile"
	  }, [_c('div', {
	    staticClass: "form-group inline"
	  }, [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Número do cartão")]), _vm._v(" "), _c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.cpm.number
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group inline"
	  }, [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Válido até")]), _vm._v(" "), _c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.cpm.expirationMonth + '/' + _vm.cpm.expirationYear
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group inline"
	  }, [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Títular do cartão")]), _vm._v(" "), _c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.cpm.ownerName
	    }
	  })]), _vm._v(" "), _c('img', {
	    staticClass: "credit-card-selection",
	    attrs: {
	      "src": '/static/payment-methods/' + _vm.cpm.paymentMethod.imagePath
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.cpm && _vm.cpm.agencyNumber) ? _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "modal-data-box"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Banco")]), _vm._v(" "), _c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.cpm.paymentMethod.paymentName
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "credit-card-selection",
	    attrs: {
	      "src": '/static/payment-methods/' + _vm.cpm.paymentMethod.imagePath
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Agência")]), _vm._v(" "), _c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.cpm.agencyNumber
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 mob"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("CC")]), _vm._v(" "), _c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.cpm.accountNumber
	    }
	  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.cpm && _vm.cpm.paymentMethod) ? _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "modal-data-box"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [(_vm.cpm.paymentMethod.paymentMethodId == 12) ? _c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Boleto bancário")]) : _vm._e(), _vm._v(" "), (_vm.cpm.paymentMethod.paymentMethodId == 109) ? _c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Utilizar meu saldo para pagamento")]) : _vm._e()])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_vm._m(24), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success end",
	    on: {
	      "click": function($event) {
	        return _vm.endModal('YES')
	      }
	    }
	  }, [_vm._v("\n            Confirmar compra\n            "), _c('i', {
	    staticClass: "icon-tick align-icon-right-white"
	  })])])])])]) : _vm._e(), _vm._v(" "), _c('modal-address', {
	    attrs: {
	      "typePurchase": _vm.orderResult.salesType,
	      "address": _vm.selectedAddress,
	      "user": _vm.nomePfPj
	    },
	    on: {
	      "deliveryAddress": _vm.deliveryAddress,
	      "allAddresses": _vm.allAddresses
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('b', [_vm._v("Forma de retirada")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "alert alert-info generic-s",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('p', [_vm._v("\n                  Para você que fez a escola pelo Caminhos do Paraná, deverá\n                  retirar seu TAG no seguinte local:\n                ")]), _vm._v(" "), _c('p', [_c('strong', {
	    staticClass: "block"
	  }, [_vm._v("Base de Apoio Operacional da Conecessionária Caminhos do\n                    Paraná.")]), _vm._v(" "), _c('span', {
	    staticClass: "block"
	  }, [_vm._v("Rodovia 277, Km 249, 700. - Irati-PR")]), _vm._v("\n                  Atendimento: Segunda a Sexta, das 8 as 17h.\n                ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-left"
	  }, [_c('p', {
	    staticClass: "bold",
	    staticStyle: {
	      "font-size": "15px"
	    }
	  }, [_vm._v("Frete grátis")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "bold"
	  }, [_vm._v("Retirada em mãos"), _c('span', [_vm._v(": ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "bold"
	  }, [_vm._v("TAG em mãos"), _c('span', [_vm._v(": ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('em', {
	    staticClass: "color-purple"
	  }, [_vm._v("\n                          Obs: Os Tags serão entregues no endereço informado.\n                        ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('b', [_vm._v("Detalhes para retirada")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('button', {
	    staticClass: "btn-find-partner",
	    attrs: {
	      "type": "button",
	      "name": "button",
	      "data-toggle": "modal",
	      "data-target": "#ModalConveniados"
	    }
	  }, [_vm._v("\n                    Encontre um local para sua retirada.\n                    "), _c('i', {
	    staticClass: "icon-circle-right"
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_vm._v("\n                        Cupom de desconto\n                        "), _c('i', {
	    staticClass: "icon-info",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "O cupom de desconto é um código promocional que você pode utilizar para abater uma parte ou a totalidade do valor de uma compra. É só colar um código promocional válido e clicar em aplicar desconto e pronto, você já vai ter o desconto aplicado na sua compra Move Mais!"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {}, [_vm._v("\n                          Cupom de desconto\n                          "), _c('i', {
	    staticClass: "icon-info",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "O cupom de desconto é um código promocional que você pode utilizar para abater uma parte ou a totalidade do valor de uma compra. É só colar um código promocional válido e clicar em aplicar desconto e pronto, você já vai ter o desconto aplicado na sua compra Move Mais!"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-box"
	  }, [_c('p', [_vm._v("\n                  Base de apoio operacional da Concessionária Caminhos do\n                  Paraná\n                ")]), _vm._v(" "), _c('p', [_vm._v("Rodovia 277, Km 249, 700")]), _vm._v(" "), _c('p', [_vm._v("Irati - PR")]), _vm._v(" "), _c('p', [_vm._v("Atendimento: Segunda a Sexta, das 8 às 17h.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title upper",
	    attrs: {
	      "id": "ModalListaConveniados"
	    }
	  }, [_vm._v("\n            pontos de retirada\n          ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "width": "25%"
	    }
	  }, [_vm._v("Cidade")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "35%"
	    }
	  }, [_vm._v("Local de retirada")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "40%"
	    }
	  }, [_vm._v("Endereço")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("Fechar")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Fechar"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('img', {
	    staticClass: "rule-color",
	    attrs: {
	      "src": __webpack_require__(116),
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Cidade")]), _vm._v(" "), _c('th', [_vm._v("Parceiro")]), _vm._v(" "), _c('th', [_vm._v("Endereço")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-secondary",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("\n            Fechar\n          ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title upper",
	    attrs: {
	      "id": "modalPurchaseLabel"
	    }
	  }, [_vm._v("\n            Resumo da compra\n          ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "upper margin-b20"
	  }, [_c('span', {
	    staticClass: "badge"
	  }, [_vm._v("1")]), _vm._v(" dados pessoais\n          ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "alert alert-info margin-b10",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._v("\n                    Você escolheu pela \""), _c('b', [_vm._v("Retirada em mãos")]), _vm._v("\". Seu TAG\n                    poderá ser retirado em qualquer um de nossos parceiros.\n                  ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "alert alert-info margin-b10",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._v("\n                    Para você que fez a escolha pelo Caminhos do Paraná,\n                    deverá retirar seu TAG no seguinte local:\n                    "), _c('b', {
	    staticClass: "margin-t5 block"
	  }, [_vm._v("Base de Apoio Operacional da Concessionária Caminhos do\n                      Paraná.")]), _vm._v(" "), _c('span', {
	    staticClass: "block"
	  }, [_vm._v("Rodovia 277, Km 249, 700 - Irati-PR")]), _vm._v(" "), _c('span', {
	    staticClass: "block"
	  }, [_vm._v("Atendimento: Segunda a Sexta, das 8 às 17h.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "margin-b20 mob"
	  }, [_c('p', {
	    staticClass: "upper inline"
	  }, [_c('span', {
	    staticClass: "badge"
	  }, [_vm._v("2")]), _vm._v(" detalhes do pagamento\n                ")]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "/static/Lock.svg",
	      "alt": "",
	      "height": "11"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("\n                  Frete\n                  "), _c('span', {
	    staticClass: "pull-right"
	  }, [_vm._v("GRÁTIS")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "upper inline"
	  }, [_c('span', {
	    staticClass: "badge"
	  }, [_vm._v("2")]), _vm._v(" detalhes do pagamento\n            ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "data-dismiss": "modal"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n            Voltar\n          ")])
	}]}

/***/ }),
/* 2077 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._v("Carregando...")])
	},staticRenderFns: []}

/***/ }),
/* 2078 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('form', {
	    staticClass: "form form-inline",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.doFilter(true)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group form-plate",
	    class: {
	      'has-error': _vm.errors.has('plate')
	    }
	  }, [_c('label', {
	    staticClass: "label-terms margin-r10",
	    attrs: {
	      "for": "filter-plate"
	    }
	  }, [_vm._v("Placa:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.plate),
	      expression: "plate"
	    }, {
	      name: "mask-plate",
	      rawName: "v-mask-plate"
	    }],
	    staticClass: "form-control plate-field upper margin-r10",
	    attrs: {
	      "type": "search",
	      "name": "plate",
	      "placeholder": "Digite a Placa"
	    },
	    domProps: {
	      "value": (_vm.plate)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.plate = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('plate')) + "\n          ")])]), _vm._v(" "), _c('div', {
	    staticClass: "inline filter-button text-center"
	  }, [_c('button', {
	    staticClass: "btn btn-purple btn-sm btn-filter",
	    attrs: {
	      "type": "button",
	      "name": "btnFind"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.find()
	      }
	    }
	  }, [_vm._v("\n            Buscar\n          ")])])])])]), _vm._v(" "), [_c('div', {
	    staticClass: "row margin-t10 resumo-table",
	    attrs: {
	      "id": "resumeTable"
	    }
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [(_vm.searchState == 'FOUND') ? _c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table no-footer",
	    attrs: {
	      "role": "grid"
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', {
	    attrs: {
	      "role": "row"
	    }
	  }, [_c('td', {
	    staticClass: "plate-box"
	  }, [_c('p', {
	    staticClass: "cell-plate no-margin"
	  }, [_c('a', [_c('span', [_vm._v(_vm._s(_vm.saldoVeiculo.saldoVP.plate))])])])]), _vm._v(" "), _c('td', {
	    staticClass: "value bold"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.saldoVeiculo.saldoVP.saldo)))]), _vm._v(" "), _c('td', {
	    staticClass: "text-right"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'contract-statement',
	        params: {
	          contractId: _vm.saldoVeiculo.saldoVP.contractId,
	          planId: 7
	        }
	      },
	      "data-toggle": "tooltip",
	      "data-placement": "bottom",
	      "title": "Extrato do Vale-pedágio"
	    }
	  }, [_c('div', {
	    staticClass: "btn btn-icon"
	  }, [_c('i', {
	    staticClass: "icon-paper bold"
	  })])])], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.searchState == 'NOTFOUND') ? _c('div', {
	    staticClass: "alert alert-danger margin-b20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._v("Não foi encontrado nenhum resultado para sua consulta.")]) : _vm._e()])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  })], _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v(" Voltar\n      ")])], 1)])], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title title-plans"
	  }, [_vm._v("Saldo Vale-pedágio")]), _vm._v(" "), _c('p', [_vm._v("Para realizar uma consulta, digite uma placa:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', {
	    attrs: {
	      "role": "row"
	    }
	  }, [_c('th', {
	    attrs: {
	      "width": "45%"
	    }
	  }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "45%"
	    }
	  }, [_vm._v("Saldo")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "10%"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 text-center"
	  })])
	}]}

/***/ }),
/* 2079 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-box"
	  }, [_c('b', {
	    staticClass: "title-identification"
	  }, [_vm._v("Informações Básicas da Empresa")]), _vm._v(" "), _c('div', {
	    staticClass: "form-content"
	  }, [_c('div', {
	    staticClass: "form-group margin-b30 input-box-control",
	    class: {
	      'has-error': _vm.errors.has('taxIdNumber')
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.account.taxIdNumberFormatted),
	      expression: "account.taxIdNumberFormatted",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:18|cnpj|accountExists:cnpj'),
	      expression: "'required|max:18|cnpj|accountExists:cnpj'"
	    }, {
	      name: "mask-cnpj",
	      rawName: "v-mask-cnpj"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2})$",
	      "id": "taxIdNumber",
	      "name": "taxIdNumber",
	      "title": "cpnj",
	      "readonly": _vm.blockTaxIdNumber,
	      "data-vv-validate-on": "blur",
	      "placeholder": "00.000.000/0000-00"
	    },
	    domProps: {
	      "value": (_vm.account.taxIdNumberFormatted)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.account, "taxIdNumberFormatted", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("taxIdNumber")) + "\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control",
	    class: {
	      'has-error': _vm.errors.has('companyName')
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.account.company.companyName),
	      expression: "account.company.companyName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:100'),
	      expression: "'required|max:100'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "name": "companyName",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.account.company.companyName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.account.company, "companyName", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("companyName")) + "\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control",
	    class: {
	      'has-error': _vm.errors.has('companyTradeName')
	    }
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.account.company.companyTradeName),
	      expression: "account.company.companyTradeName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:100'),
	      expression: "'required|max:100'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "name": "companyTradeName",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.account.company.companyTradeName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.account.company, "companyTradeName", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("companyTradeName")) + "\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control"
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('max:20'),
	      expression: "'max:20'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.account.company.companyStateIdNumber),
	      expression: "account.company.companyStateIdNumber"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "name": "state-registration",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.account.company.companyStateIdNumber)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.account.company, "companyStateIdNumber", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control",
	    class: {
	      'has-error': _vm.errors.has('activity-branch')
	    }
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.account.company.businessActivity),
	      expression: "account.company.businessActivity"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "name": "activity-branch"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.account.company, "businessActivity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": "",
	      "value": ""
	    }
	  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.businessActivities), function(b) {
	    return _c('option', {
	      domProps: {
	        "value": b.value
	      }
	    }, [_vm._v("\n                  " + _vm._s(b.label) + "\n                ")])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("activity-branch")) + "\n              ")]), _vm._v(" "), (_vm.businessActivity == 'OUTRAS') ? _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('activity-branch2')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.otherActivity),
	      expression: "otherActivity"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:20'),
	      expression: "'required|max:20'"
	    }],
	    staticClass: "form-control margin-t10",
	    attrs: {
	      "type": "text",
	      "name": "activity-branch2"
	    },
	    domProps: {
	      "value": (_vm.otherActivity)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.otherActivity = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("activity-branch2")) + "\n                ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.account.company.site),
	      expression: "account.company.site"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('max:100'),
	      expression: "'max:100'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "name": "site",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.account.company.site)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.account.company, "site", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control"
	  }, [_c('div', {
	    staticClass: "fleet-switch"
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('div', {
	    staticClass: "onoffswitch"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.optanteNacional),
	      expression: "optanteNacional"
	    }],
	    staticClass: "onoffswitch-checkbox",
	    attrs: {
	      "type": "checkbox",
	      "id": "round-switch"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.optanteNacional) ? _vm._i(_vm.optanteNacional, null) > -1 : (_vm.optanteNacional)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.optanteNacional,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.optanteNacional = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.optanteNacional = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.optanteNacional = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _vm._m(7)])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-box"
	  }, [_c('b', {
	    staticClass: "title-identification"
	  }, [_vm._v("Representante Legal")]), _vm._v(" "), _c('div', {
	    staticClass: "form-content"
	  }, [_c('div', {
	    staticClass: "form-group margin-b30 input-box-control",
	    class: {
	      'has-error': _vm.errors.has('name')
	    }
	  }, [_vm._m(8), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.account.company.legalRepName),
	      expression: "account.company.legalRepName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:80'),
	      expression: "'required|max:80'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "name": "name",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.account.company.legalRepName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.account.company, "legalRepName", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("name")) + "\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control",
	    class: {
	      'has-error': _vm.errors.has('cpf')
	    }
	  }, [_vm._m(9), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.account.company.legalRepTaxpayerId),
	      expression: "account.company.legalRepTaxpayerId",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cpf'),
	      expression: "'required|cpf'"
	    }, {
	      name: "mask-cpf",
	      rawName: "v-mask-cpf"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "id": "taxIdNumberCPF",
	      "name": "cpf",
	      "title": "cpf",
	      "maxlength": "11",
	      "data-vv-validate-on": "blur"
	    },
	    domProps: {
	      "value": (_vm.account.company.legalRepTaxpayerId)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.account.company, "legalRepTaxpayerId", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("cpf")) + "\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control",
	    class: {
	      'has-error': _vm.errors.has('rg-number')
	    }
	  }, [_vm._m(10), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:14'),
	      expression: "'required|max:14'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.account.company.legalRepresentativeNationalIdNumber),
	      expression: "account.company.legalRepresentativeNationalIdNumber"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "name": "rg-number",
	      "type": "text",
	      "placeholder": "Número"
	    },
	    domProps: {
	      "value": (_vm.account.company.legalRepresentativeNationalIdNumber)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.account.company, "legalRepresentativeNationalIdNumber", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("rg-number")) + "\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control",
	    class: {
	      'has-error': _vm.errors.has('rg-orgao')
	    }
	  }, [_vm._m(11), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:10'),
	      expression: "'required|max:10'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.account.company.legalRepresentativeNationalIdIssuer),
	      expression: "account.company.legalRepresentativeNationalIdIssuer"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "name": "rg-orgao",
	      "type": "text",
	      "placeholder": "Orgão expedidor",
	      "maxlength": "10"
	    },
	    domProps: {
	      "value": (_vm.account.company.legalRepresentativeNationalIdIssuer)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.account.company, "legalRepresentativeNationalIdIssuer", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("rg-orgao")) + "\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control",
	    class: {
	      'has-error': _vm.errors.has('rg-state')
	    }
	  }, [_vm._m(12), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.account.company.legalRepresentativeNationalIdState),
	      expression: "account.company.legalRepresentativeNationalIdState"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "name": "rg-state"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.account.company, "legalRepresentativeNationalIdState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": "",
	      "value": ""
	    }
	  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.states), function(e) {
	    return _c('option', {
	      domProps: {
	        "value": e.sigla
	      }
	    }, [_vm._v("\n                  " + _vm._s(e.sigla) + "\n                ")])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("rg-state")) + "\n              ")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-box"
	  }, [_c('b', {
	    staticClass: "title-identification"
	  }, [_vm._v("Gestor de Contrato")]), _vm._v(" "), _c('div', {
	    staticClass: "form-content"
	  }, [_c('div', {
	    staticClass: "form-group margin-b30 input-box-control",
	    class: {
	      'has-error': _vm.errors.has('manager-name')
	    }
	  }, [_vm._m(13), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.account.company.contractManagerFullName),
	      expression: "account.company.contractManagerFullName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "id": "manager-name",
	      "name": "manager-name",
	      "maxlength": "50"
	    },
	    domProps: {
	      "value": (_vm.account.company.contractManagerFullName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.account.company, "contractManagerFullName", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("manager-name")) + "\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control",
	    class: {
	      'has-error': _vm.errors.has('email')
	    }
	  }, [_vm._m(14), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.account.accountAuthentication.login),
	      expression: "account.accountAuthentication.login"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "id": "email",
	      "name": "email",
	      "title": "email",
	      "placeholder": "Ex: nome@empresa.com.br",
	      "maxlength": "100"
	    },
	    domProps: {
	      "value": (_vm.account.accountAuthentication.login)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.account.accountAuthentication, "login", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("email")) + "\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control"
	  }, [_vm._m(15), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.account.company.contractManagerJobTitle),
	      expression: "account.company.contractManagerJobTitle"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "role",
	      "maxlength": "100"
	    },
	    domProps: {
	      "value": (_vm.account.company.contractManagerJobTitle)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.account.company, "contractManagerJobTitle", $event.target.value)
	      }
	    }
	  })])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-box"
	  }, [_c('b', {
	    staticClass: "title-identification"
	  }, [_vm._v("Telefones de Contato")]), _vm._v(" "), _c('div', {
	    staticClass: "form-content"
	  }, [_c('div', {
	    staticClass: "form-group margin-b30 input-box-control"
	  }, [_vm._m(16), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tel1),
	      expression: "tel1"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cell'),
	      expression: "'required|cell'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "name": "telephone1",
	      "id": "telephone1",
	      "placeholder": "(00) 00000-0000",
	      "type": "text",
	      "maxlength": "14",
	      "data-vv-validate-on": "blur"
	    },
	    domProps: {
	      "value": (_vm.tel1)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.tel1 = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("telephone1")) + "\n              ")])]), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control",
	    class: {
	      'has-error': _vm.errors.has('telephone2')
	    }
	  }, [_c('div', {
	    staticClass: "label-box"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.account.typePhone),
	      expression: "account.typePhone"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "id": "telephoneType2",
	      "name": "telephoneType2",
	      "data-unique-phone": "telephone2"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.account, "typePhone", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "CELULAR"
	    }
	  }, [_vm._v("Celular")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "COMERCIAL"
	    }
	  }, [_vm._v("Comercial")])])]), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tel2),
	      expression: "tel2"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('phone' | 'cell'),
	      expression: "'phone' | 'cell'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "name": "telephone2",
	      "id": "telephone2",
	      "placeholder": "(00) 0000-0000",
	      "type": "text",
	      "maxlength": "14",
	      "data-vv-validate-on": "blur"
	    },
	    domProps: {
	      "value": (_vm.tel2)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.tel2 = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("telephone2")) + "\n              ")])]), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control",
	    class: {
	      'has-error': _vm.errors.has('telephone3')
	    }
	  }, [_c('div', {
	    staticClass: "label-box"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.account.typePhone2),
	      expression: "account.typePhone2"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "id": "telephoneType3",
	      "name": "telephoneType3",
	      "data-unique-phone": "telephone3"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.account, "typePhone2", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "CELULAR"
	    }
	  }, [_vm._v("Celular")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "COMERCIAL"
	    }
	  }, [_vm._v("Comercial")])])]), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tel3),
	      expression: "tel3"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('phone'),
	      expression: "'phone'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "name": "telephone3",
	      "id": "telephone3",
	      "placeholder": "(00) 0000-0000",
	      "type": "text",
	      "maxlength": "14",
	      "data-vv-validate-on": "blur"
	    },
	    domProps: {
	      "value": (_vm.tel3)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.tel3 = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("telephone3")) + "\n              ")])]), _vm._v(" "), _vm._t("default")], 2)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-box"
	  }, [_c('b', {
	    staticClass: "title-identification margin-b10"
	  }, [_vm._v("Segurança")]), _vm._v(" "), _c('div', {
	    staticClass: "form-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group input-box-control margin-pass",
	    class: {
	      'has-error': _vm.errors.has('password')
	    }
	  }, [_vm._m(17), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:8|max:20|moveMaisCPF'),
	      expression: "'required|min:8|max:20|moveMaisCPF'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.account.accountAuthentication.password),
	      expression: "account.accountAuthentication.password"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "password",
	      "id": "password",
	      "name": "password",
	      "title": "senha",
	      "maxlength": "20",
	      "data-vv-validate-on": "blur"
	    },
	    domProps: {
	      "value": (_vm.account.accountAuthentication.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.account.accountAuthentication, "password", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("password")) + "\n                  ")])])]), _vm._v(" "), _vm._m(18)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group margin-b10 input-box-control",
	    class: {
	      'has-error': _vm.errors.has('confirm-password')
	    }
	  }, [_vm._m(19), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:8|max:20|confirmed:password'),
	      expression: "'required|min:8|max:20|confirmed:password'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.account.accountAuthentication.confirmPassword),
	      expression: "account.accountAuthentication.confirmPassword"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "password",
	      "id": "confirm-password",
	      "name": "confirm-password",
	      "title": "confirmar senha",
	      "maxlength": "20",
	      "data-vv-validate-on": "blur"
	    },
	    domProps: {
	      "value": (_vm.account.accountAuthentication.confirmPassword)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.account.accountAuthentication, "confirmPassword", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("confirm-password")) + "\n                  ")])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-box"
	  }, [_c('address-comp', {
	    ref: "addressMailing",
	    attrs: {
	      "address": _vm.address,
	      "type": "MAILING"
	    }
	  })], 1)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("CNPJ:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Razão social:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Nome fantasia:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Inscrição Estadual:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Ramo de Atividade:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Site:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Optante Pelo Simples Nacional")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "onoffswitch-label",
	    attrs: {
	      "for": "round-switch"
	    }
	  }, [_c('span', {
	    staticClass: "onoffswitch-inner"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "onoffswitch-switch"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Nome:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("CPF:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("RG:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Orgão Expedidor:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Estado:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Nome completo:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("E-mail:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Cargo:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('select', {
	    staticClass: "form-control small",
	    attrs: {
	      "id": "telephoneType1",
	      "name": "telephoneType1",
	      "data-unique-phone": "telephone1"
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "CELULAR"
	    }
	  }, [_vm._v("Celular*")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Senha:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('br'), _vm._v(" "), _c('div', {
	    staticClass: "box-dicas"
	  }, [_vm._v("\n                  Senha deve ter de 8 a 20 caracteres\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "box-dicas"
	  }, [_vm._v("\n                  Senha deve ter pelo menos um número\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "box-dicas"
	  }, [_vm._v("\n                  Senha deve ter uma letra maiúscula\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "box-dicas"
	  }, [_vm._v("\n                  Senha deve ter um caractere especial\n                ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Confirme a Senha:*")])])
	}]}

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "container options-box"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "pull-right button-box"
	  }, [_vm._m(3), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-warning margin-20 bold-600",
	    class: {
	      'disabled': _vm.isLoadPromo
	    },
	    on: {
	      "click": function($event) {
	        return _vm.choose(_vm.economicoManual)
	      }
	    }
	  }, [_vm._v("\n            Econômico Manual\n            "), _c('i', {
	    staticClass: "icon-circle-right align-icon-right"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-warning bold-600",
	    class: {
	      'disabled': _vm.isLoadPromo
	    },
	    on: {
	      "click": function($event) {
	        return _vm.choose(_vm.economicoAuto)
	      }
	    }
	  }, [_vm._v("\n            Econômico Automático\n            "), _c('i', {
	    staticClass: "icon-circle-right align-icon-right"
	  })])])])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "modal fade in",
	    attrs: {
	      "id": "messageDialog",
	      "tabindex": "-1",
	      "role": "dialog",
	      "data-keyboard": "false",
	      "data-backdrop": "static"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "text-center pull-right"
	  }, [_vm._m(7), _vm._v(" "), _c('h4', {
	    staticClass: "margin-t10"
	  }, [_vm._v("Veja nossos outros planos:")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-warning bold-600 margin-t10",
	    attrs: {
	      "href": "#/servicos-b2c"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v("Ver outros planos")])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row header-box"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "pull-left"
	  }, [_c('img', {
	    staticClass: "logo-promo",
	    attrs: {
	      "src": __webpack_require__(1863),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  }, [_c('img', {
	    staticClass: "logo-mm",
	    attrs: {
	      "src": __webpack_require__(1862),
	      "alt": ""
	    }
	  })])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "container margin-t20 economic-plan"
	  }, [_c('div', {
	    staticClass: "pull-left plan-box"
	  }, [_c('h1', {
	    staticClass: "bold text-center margin-b20"
	  }, [_vm._v("PLANO ECONÔMICO")]), _vm._v(" "), _c('span', {
	    staticClass: "text-yellow bold-600"
	  }, [_vm._v("Vantagens:")]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
	    staticClass: "icon-bolt",
	    attrs: {
	      "src": __webpack_require__(117),
	      "alt": ""
	    }
	  }), _vm._v("\n              Plano Pré-pago sem taxa de adesão\n            ")]), _vm._v(" "), _c('li', [_c('img', {
	    staticClass: "icon-bolt",
	    attrs: {
	      "src": __webpack_require__(117),
	      "alt": ""
	    }
	  }), _vm._v("\n              Receba sua(s) TAG(s) em casa, com frete grátis\n            ")]), _vm._v(" "), _c('li', [_c('img', {
	    staticClass: "icon-bolt",
	    attrs: {
	      "src": __webpack_require__(117),
	      "alt": ""
	    }
	  }), _vm._v("\n              R$ 25,00 ou mais para aderir\n            ")]), _vm._v(" "), _c('li', [_c('img', {
	    staticClass: "icon-bolt",
	    attrs: {
	      "src": __webpack_require__(117),
	      "alt": ""
	    }
	  }), _vm._v("\n              A primeira taxa de recarga é grátis\n            ")]), _vm._v(" "), _c('li', [_c('img', {
	    staticClass: "icon-bolt",
	    attrs: {
	      "src": __webpack_require__(117),
	      "alt": ""
	    }
	  }), _vm._v("\n              Receba seu dinheiro em crédito para utilização\n            ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  }, [_c('img', {
	    staticClass: "icon-bolt-money",
	    attrs: {
	      "src": __webpack_require__(1861),
	      "alt": ""
	    }
	  })])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pull-left bolt-option-box"
	  }, [_c('img', {
	    staticClass: "icon-bolt-option",
	    attrs: {
	      "src": __webpack_require__(1860),
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', {
	    staticClass: "text-center"
	  }, [_vm._v("Temos duas modalidades do plano,"), _c('br'), _vm._v(" selecione a melhor para você:")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "container margin-b80 faq-box"
	  }, [_c('h2', {
	    staticClass: "text-yellow bold"
	  }, [_vm._v("Dúvidas?")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("\n          Para tirar dúvidas ou saber mais informações sobre o plano, basta entrar em contato com a nossa Central de\n          Relacionamento nos telefones "), _c('b', [_vm._v("4000 2901")]), _vm._v(" (Capitais e regiões metropolitanas) ou "), _c('b', [_vm._v("0800 777 1022")]), _vm._v(" (demais localidades).\n        ")]), _vm._v(" "), _c('h4', [_vm._v("Você também pode tirar suas dúvidas no nosso FAQ:")]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-20"
	  }, [_c('div', {
	    staticClass: "accordion-click"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Quanto custa a adesão do Plano Econômico?\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_vm._v("\n              A taxa de adesão e o envio da(s) TAG(s) são grátis neste plano, você só irá investir o valor da\n              primeira recarga (que é necessária no ato da adesão), porém a primeira recarga será sem nenhuma taxa,\n              ou seja, você irá utilizar o valor total nas passagens de pedágio. O valor mínimo de recarga para este\n              plano é R$ 25,00 reais, mas você é livre para fazer uma recarga de maior valor.\n            ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('div', {
	    staticClass: "accordion-click"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Existe cobrança de mensalidade?\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_vm._v("\n              Não, este plano não tem mensalidade.\n            ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('div', {
	    staticClass: "accordion-click"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Pré-pago Manual ou Pré-pago Automático, qual escolho?\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_vm._v("\n              Se você deseja ter controle total sobre os custos vá de Econômico Manual, se você não quer se preocupar\n              com recargas ou saldo insuficiente, vá de Econômico Automático.\n            ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('div', {
	    staticClass: "accordion-click"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Tem limite de veículos?\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_vm._v("\n              Não, você pode incluir quantos veículos quiser.\n            ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box"
	  }, [_c('div', {
	    staticClass: "accordion-click"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n              Pessoa Jurídica pode escolher esse plano?\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_vm._v("\n              Não, este plano é destinado somente a pessoas físicas.\n            ")])])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('h1', {
	    staticClass: "modal-title bold text-center"
	  }, [_vm._v("TEMPO ESGOTADO!")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pull-left bolt-option-box"
	  }, [_c('img', {
	    staticClass: "icon-bolt-option",
	    attrs: {
	      "src": __webpack_require__(1859),
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "bold-600 margin-30"
	  }, [_vm._v("Infelizmente essa promoção "), _c('br'), _vm._v(" não está mais disponível.")])
	}]}

/***/ }),
/* 2081 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [(_vm.code == undefined) ? _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }]
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("Novo Plano")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('ul', {
	    staticClass: "wizard margin-b20 ad",
	    class: _vm.step == 1 ?
	      ' past1 ' :
	      _vm.step == 2 ?
	      ' past2 ' :
	      _vm.step > 2 ?
	      ' past4 ' :
	      ''
	  }, [_c('li', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    class: {
	      active: _vm.step == 0, past: _vm.step > 0
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('small', [_vm._v("Plano e condições")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    class: {
	      active: _vm.step == 1, past: _vm.step > 1
	    }
	  }, [_vm._m(2), _vm._v(" "), _c('small', [_vm._v("Carga Inicial")]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    class: {
	      active: _vm.step == 2, past: _vm.step > 2
	    }
	  }, [_vm._m(4), _vm._v(" "), _c('small', [_vm._v("Cadastro de veículos")]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    class: {
	      active: _vm.step == 3, past: _vm.step > 3
	    }
	  }, [_vm._m(6), _vm._v(" "), _c('small', [_vm._v("Resumo e confirmação")]), _vm._v(" "), _vm._m(7)])])])]), _vm._v(" "), (_vm.msgError) ? _c('div', {
	    staticClass: "alert alert-danger margin-b10",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', {
	    staticClass: "upper"
	  }, [_vm._v("Atenção!")]), _vm._v(" " + _vm._s(_vm.msgError) + ".\n    ")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.subtitle[_vm.step]))]), _vm._v(" "), (_vm.step == 0) ? _c('choose-new-plan', {
	    attrs: {
	      "type": _vm.user.type
	    },
	    on: {
	      "chooseNewPlan": _vm.choosePlan
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.step == 1) ? [(_vm.planId == 31 || _vm.planId == 32) ? _c('choose-recharge', {
	    ref: "chooseRecharge",
	    attrs: {
	      "contract": _vm.contract,
	      "newAhesionTax": _vm.newAhesionTax,
	      "newVehicleTax": _vm.newVehicleTax,
	      "planName": _vm.planName,
	      "guaranteeTax": _vm.guaranteeTax,
	      "minValue": _vm.minValue
	    },
	    on: {
	      "valorSelecionado": _vm.handleValorSelecionado
	    }
	  }) : _c('choose-plan', {
	    ref: "choosePlan",
	    attrs: {
	      "contract": _vm.contract,
	      "newAhesionTax": _vm.newAhesionTax,
	      "newVehicleTax": _vm.newVehicleTax,
	      "planName": _vm.planName,
	      "guaranteeTax": _vm.guaranteeTax
	    }
	  })] : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('vehicles', {
	    attrs: {
	      "vehicles": _vm.vehicles,
	      "type": _vm.user.type,
	      "allowVehicles": _vm.qtdAllowed,
	      "planId": _vm.planId
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.step == 3) ? _c('generic-summary', {
	    ref: "GenericSummary",
	    attrs: {
	      "order": this.salesOrder,
	      "request": _vm.request,
	      "showAddress": true,
	      "addressInit": _vm.newAddress,
	      "account": _vm.user,
	      "contract": _vm.contract,
	      "disablePayment": true
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.changeAddress),
	      expression: "changeAddress"
	    }]
	  }, [_c('address-comp', {
	    ref: "addressMailing",
	    attrs: {
	      "address": _vm.newAddress,
	      "type": "MAILING"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [(_vm.changeAddress) ? _c('div', {
	    staticClass: "action-buttons-box action-buttons-box--address"
	  }, [_c('button', {
	    staticClass: "btn btn-purple",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.saveAddress()
	      }
	    }
	  }, [_vm._v("\n          Alterar endereço\n          "), _c('i', {
	    staticClass: "icon-circle-right align-icon-right-white"
	  })])]) : _c('div', {
	    staticClass: "action-buttons-box"
	  }, [_c('div', {
	    staticClass: "adhesion-footer-nav",
	    class: {
	      'adhesion-footer-nav--final-mobile': _vm.isMobile && _vm.step === 3
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "btn-container-adhesion-back-cancel"
	    }
	  }, [(_vm.step > 0 && !(_vm.isMobile && _vm.step === 3)) ? _c('button', {
	    attrs: {
	      "id": "button-back-adhesion",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.backStep()
	      }
	    }
	  }, [_c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('g', {
	    attrs: {
	      "clip-path": "url(#clip0_newcontract_back)"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M8.00016 5.33398L5.3335 8.00065M5.3335 8.00065L8.00016 10.6673M5.3335 8.00065H10.6668M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
	      "stroke": "#5D3B81",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
	    attrs: {
	      "id": "clip0_newcontract_back"
	    }
	  }, [_c('rect', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "fill": "white"
	    }
	  })])])]), _vm._v("\n              Voltar\n            ")]) : _vm._e(), _vm._v(" "), _c('button', {
	    attrs: {
	      "id": "button-cancel-adhesion",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.cancelar()
	      }
	    }
	  }, [_c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M12 4L4 12M4 4L12 12",
	      "stroke": "#E21C12",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })]), _vm._v("\n              Cancelar\n            ")])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "btn-container-adhesion-advance"
	    }
	  }, [(
	    (_vm.planId == 21 || _vm.planId == 22) &&
	    _vm.isMobile &&
	    _vm.step < 3
	  ) ? _c('button', {
	    attrs: {
	      "id": "button-next-adhesion",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.nextStep()
	      }
	    }
	  }, [_vm._v("\n              Avançar\n              "), _c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
	      "stroke": "#F5F5F5",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })])]) : _vm._e(), _vm._v(" "), (
	    (_vm.step == 1 || _vm.step == 2) &&
	    _vm.isMobile &&
	    _vm.isRechargeSelected &&
	    (_vm.planId == 31 || _vm.planId == 32)
	  ) ? _c('button', {
	    attrs: {
	      "id": "button-next-adhesion",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.nextStep()
	      }
	    }
	  }, [_vm._v("\n              Avançar\n              "), _c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
	      "stroke": "#F5F5F5",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })])]) : _vm._e(), _vm._v(" "), (
	    _vm.step == 2 &&
	    !_vm.isMobile &&
	    (_vm.isRechargeSelected || !_vm.isRechargeSelected)
	  ) ? _c('button', {
	    attrs: {
	      "id": "button-next-adhesion",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.nextStep()
	      }
	    }
	  }, [_vm._v("\n              Avançar\n              "), _c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
	      "stroke": "#F5F5F5",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })])]) : _vm._e(), _vm._v(" "), (
	    _vm.planId != 31 &&
	    _vm.planId != 32 &&
	    _vm.step > 0 &&
	    _vm.step < 3 &&
	    !_vm.isMobile &&
	    _vm.step != 2
	  ) ? _c('button', {
	    attrs: {
	      "id": "button-next-adhesion",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.nextStep()
	      }
	    }
	  }, [_vm._v("\n              Avançar\n              "), _c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
	      "stroke": "#F5F5F5",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })])]) : _vm._e(), _vm._v(" "), (
	    _vm.step == 1 &&
	    !_vm.isMobile &&
	    _vm.isRechargeSelected &&
	    (_vm.planId == 31 || _vm.planId == 32)
	  ) ? _c('button', {
	    attrs: {
	      "id": "button-next-adhesion",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.nextStep()
	      }
	    }
	  }, [_vm._v("\n              Avançar\n              "), _c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
	      "stroke": "#F5F5F5",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.step == 3 && !_vm.isMobile) ? _c('button', {
	    attrs: {
	      "id": "button-concluir-adhesion",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.startRequest()
	      }
	    }
	  }, [_vm._v("\n              Finalizar pedido\n              "), _c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
	      "stroke": "#F5F5F5",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.step == 3 && _vm.isMobile) ? _c('button', {
	    attrs: {
	      "id": "button-concluir-adhesion-mobile",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.startRequest()
	      }
	    }
	  }, [_vm._v("\n              Finalizar pedido\n              "), _c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
	      "stroke": "#F5F5F5",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })])]) : _vm._e()])])])])], 2) : _vm._e(), _vm._v(" "), _c('success-page', {
	    attrs: {
	      "code": _vm.code,
	      "boletoUrl": _vm.boletoUrl,
	      "type": 'newVehicle'
	    }
	  }), _vm._v(" "), _c('error-page', {
	    attrs: {
	      "code": _vm.code,
	      "stepPayment": 1,
	      "type": 'newContract',
	      "validacaoFraude": _vm.validacaoFraude,
	      "salesOrder": _vm.salesResponse
	    },
	    on: {
	      "goToStep": _vm.goToStep
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-plans"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Plano e Condições")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-payment-methods"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Carga Inicial")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-vehicle"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Cadastro de veículos")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-confirmation-check"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Resumo e confirmação")])])
	}]}

/***/ }),
/* 2082 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }]
	  }, [(!_vm.finalize) ? _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("\n          Planos\n          "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Contrato\n          " + _vm._s(_vm.contractId) + "\n          "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Recarregar\n        ")])], 1)]), _vm._v(" "), (_vm.code == undefined) ? _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('ul', {
	    staticClass: "wizard margin-b20 ad",
	    class: _vm.step == 1 ? ' past4 ' : ''
	  }, [_c('li', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    class: {
	      active: _vm.step == 0, past: _vm.step > 0
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('small', [_vm._v("Definir os Valores")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    class: {
	      active: _vm.step == 1, past: _vm.step > 1
	    }
	  }, [_vm._m(2), _vm._v(" "), _c('small', [_vm._v("Resumo e confirmação")]), _vm._v(" "), _vm._m(3)])])])])]) : _vm._e(), _vm._v(" "), (_vm.step == 0) ? _c('div', [(
	    (_vm.contract.rechargeTax && _vm.contract.rechargeTax > 0) || _vm.planId == 6
	  ) ? _c('recharge-tax', {
	    ref: "rec"
	  }) : (_vm.planId == 31 || _vm.planId == 32) ? _c('recharge-open', {
	    ref: "rec"
	  }) : _c('recharge-multiple', {
	    ref: "rec"
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.step == 1 && _vm.order) ? _c('generic-summary', {
	    ref: "rechargeSummary",
	    staticClass: "container recharge-order-summary",
	    attrs: {
	      "contract": _vm.contract,
	      "account": _vm.user,
	      "order": _vm.order,
	      "showAddress": false,
	      "skipBillingSection": true
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "back-button-box"
	  }, [_c('router-link', {
	    staticClass: "btn btn-recharge-back margin-t20",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button"
	    }
	  }, [_c('svg', {
	    attrs: {
	      "width": "12",
	      "height": "12",
	      "viewBox": "0 0 12 12",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('g', {
	    attrs: {
	      "clip-path": "url(#clip0_1449_5)"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M5.97971 3.98597L3.98646 5.97922M3.98646 5.97922L5.97971 7.97247M3.98646 5.97922H7.97296M10.9628 5.97922C10.9628 8.73132 8.73181 10.9623 5.97971 10.9623C3.2276 10.9623 0.996582 8.73132 0.996582 5.97922C0.996582 3.22711 3.2276 0.996094 5.97971 0.996094C8.73181 0.996094 10.9628 3.22711 10.9628 5.97922Z",
	      "stroke": "#F5F5F5",
	      "stroke-width": "1.19595",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
	    attrs: {
	      "id": "clip0_1449_5"
	    }
	  }, [_c('rect', {
	    attrs: {
	      "width": "11.9595",
	      "height": "11.9595",
	      "fill": "white"
	    }
	  })])])]), _vm._v("\n            Voltar\n          ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "action-buttons-box"
	  }, [(_vm.step < 1) ? _c('button', {
	    staticClass: "btn btn-purple add margin-t20",
	    on: {
	      "click": function($event) {
	        return _vm.nextStep()
	      }
	    }
	  }, [_vm._v("\n            Avançar\n            "), _c('i', {
	    staticClass: "icon-circle-right align-icon-right-white"
	  })]) : _vm._e(), _vm._v(" "), (_vm.step == 1) ? _c('button', {
	    staticClass: "btn btn-success end margin-t20",
	    attrs: {
	      "id": "button-concluir-recharge",
	      "disabled": !_vm.on || !_vm.order
	    },
	    on: {
	      "click": function($event) {
	        return _vm.startRequest()
	      }
	    }
	  }, [_vm._v("\n            Finalizar pedido\n            "), _c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
	      "stroke": "#F5F5F5",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })])]) : _vm._e()])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('success-page', {
	    attrs: {
	      "code": _vm.code,
	      "type": 'recharge',
	      "salesOrder": _vm.salesResponse
	    }
	  }), _vm._v(" "), _c('error-page', {
	    attrs: {
	      "code": _vm.code,
	      "type": 'recharge',
	      "salesOrder": _vm.salesResponse,
	      "validacaoFraude": _vm.validacaoFraude,
	      "msgErrorResp": _vm.msgErrorResp
	    },
	    on: {
	      "goToStep": _vm.goToStep
	    }
	  })], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-money-transfer"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Definir os Valores")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step",
	    staticStyle: {
	      "margin-bottom": "1rem"
	    }
	  }, [_c('i', {
	    staticClass: "icon-confirmation-check"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Resumo e confirmação")])])
	}]}

/***/ }),
/* 2083 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("Planos "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Contrato 78426351 "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Histórico de contas "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Adesão e mensalidades")])], 1)]), _vm._v(" "), [_vm._m(0)], _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back margin-t20",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n        Voltar\n      ")])], 1)])], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "margin-t20 table-white-header",
	    staticStyle: {
	      "min-height": "100px"
	    }
	  }, [_c('table', {
	    staticClass: "table stripped-odd no-footer",
	    attrs: {
	      "role": "grid"
	    }
	  }, [_c('thead', [_c('tr', {
	    attrs: {
	      "role": "row"
	    }
	  }, [_c('th', {
	    staticStyle: {
	      "width": "15%"
	    }
	  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "15%"
	    }
	  }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "15%"
	    }
	  }, [_vm._v("Período")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "47%"
	    }
	  }, [_vm._v("Tipo de transação")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "8%",
	      "text-align": "right"
	    }
	  }, [_vm._v("Valor (R$)")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("01/01/2017")]), _vm._v(" "), _c('td', {
	    staticClass: "cell-plate"
	  }, [_c('div', [_vm._v("\n                AAA-9977\n              ")])]), _vm._v(" "), _c('td', [_vm._v("10 dias")]), _vm._v(" "), _c('td', [_vm._v("Mensalidade Move Mais")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_vm._v("13,20")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("01/01/2017")]), _vm._v(" "), _c('td', {
	    staticClass: "cell-plate"
	  }, [_c('div', [_vm._v("\n                AAA-9977\n              ")])]), _vm._v(" "), _c('td', [_vm._v("10 dias")]), _vm._v(" "), _c('td', [_vm._v("Mensalidade Move Mais")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_vm._v("13,20")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("01/01/2017")]), _vm._v(" "), _c('td', {
	    staticClass: "cell-plate"
	  }, [_c('div', [_vm._v("\n                AAA-9977\n              ")])]), _vm._v(" "), _c('td', [_vm._v("10 dias")]), _vm._v(" "), _c('td', [_vm._v("Mensalidade Move Mais")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_vm._v("13,20")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("01/01/2017")]), _vm._v(" "), _c('td', {
	    staticClass: "cell-plate"
	  }, [_c('div', [_vm._v("\n                AAA-9977\n              ")])]), _vm._v(" "), _c('td', [_vm._v("10 dias")]), _vm._v(" "), _c('td', [_vm._v("Mensalidade Move Mais")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_vm._v("13,20")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("01/01/2017")]), _vm._v(" "), _c('td', {
	    staticClass: "cell-plate"
	  }, [_c('div', [_vm._v("\n                AAA-9977\n              ")])]), _vm._v(" "), _c('td', [_vm._v("10 dias")]), _vm._v(" "), _c('td', [_vm._v("Mensalidade Move Mais")]), _vm._v(" "), _c('td', {
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_vm._v("13,20")])])])])])
	}]}

/***/ }),
/* 2084 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "container"
	  }, [_c('p', {
	    staticClass: "line-height-20 margin-t30"
	  }, [_vm._v("\n        Escolha um valor de recarga, verifique a taxa de recarga e confirme.\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group margin-b0",
	    class: {
	      'has-error': _vm.errors.has('valueTotal')
	    }
	  }, [(_vm.unit == -1) ? _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|recargaMinima:' + _vm.minValue),
	      expression: "'required|recargaMinima:'+minValue"
	    }],
	    staticClass: "form-control text-right recharge-input margin-t10",
	    attrs: {
	      "id": "valueTotal",
	      "type": "text",
	      "name": "valueTotal",
	      "placeholder": "R$ 00,00",
	      "spellcheck": "false",
	      "autocomplete": "off",
	      "autocorrect": "off",
	      "autocapitalize": "off",
	      "maxlength": "14"
	    },
	    domProps: {
	      "value": _vm.valueFormatted
	    },
	    on: {
	      "input": function($event) {
	        return _vm.setTotal($event.target.value)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.errors.first('valueTotal')) ? _c('div', {
	    staticClass: "help-block has-errors"
	  }, [_vm._v("\n          " + _vm._s(_vm.errors.first('valueTotal')) + "\n        ")]) : _vm._e()]), _vm._v(" "), (_vm.credit && !_vm.errors.first('valueTotal')) ? _c('div', {
	    staticClass: "text-center credit-box"
	  }, [_c('p', [_vm._v("Crédito: "), _c('span', {
	    staticClass: "bold"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.credit)))]), _vm._v(" | Taxa de Recarga: "), _c('span', {
	    staticClass: "bold"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.rate)))])])]) : _vm._e()])]), _vm._v(" "), (_vm.msgError) ? _c('div', {
	    staticClass: "alert alert-danger margin-b20"
	  }, [_c('p', [_vm._v(_vm._s(_vm.msgError))])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2085 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "notification-presentation row"
	  }, [_c('span', [_vm._v("Agora, é possível gerenciar quais notificações e serviços quer receber por email. É simples, rápido e fácil. Basta selecionar das opções abaixo")])]), _vm._v(" "), _c('div', {
	    staticClass: "notification-management-field row"
	  }, [_c('accordion', {
	    staticClass: "margin-t20",
	    attrs: {
	      "open": true
	    }
	  }, [_c('template', {
	    slot: "header"
	  }, [_c('span', {
	    staticClass: "notification-field-title"
	  }, [_vm._v("Notificações de Conta")])]), _vm._v(" "), _c('template', {
	    slot: "content"
	  }, _vm._l((_vm.notifications), function(notification) {
	    return _c('div', {
	      staticClass: "accordion-shipper notification-row"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (notification.email),
	        expression: "notification.email"
	      }],
	      attrs: {
	        "type": "checkbox",
	        "name": "2",
	        "id": "2"
	      },
	      domProps: {
	        "checked": Array.isArray(notification.email) ? _vm._i(notification.email, null) > -1 : (notification.email)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = notification.email,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = null,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.$set(notification, "email", $$a.concat([$$v])))
	            } else {
	              $$i > -1 && (_vm.$set(notification, "email", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	            }
	          } else {
	            _vm.$set(notification, "email", $$c)
	          }
	        }
	      }
	    }), _vm._v(" " + _vm._s(notification.description) + "\n\t\t\t\t")])
	  }), 0)], 2)], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title title-notification"
	  }, [_vm._v("Notificações")])])])
	}]}

/***/ }),
/* 2086 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6 mobile-width"
	  }, [_c('router-link', {
	    staticClass: "btn btn-primary btn-new-plan",
	    attrs: {
	      "tag": "button",
	      "to": {
	        name: 'route-detail',
	        params: {
	          routeId: 0,
	          version: 0
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-plus icon-plus-plan align-icon-right-sm"
	  }), _vm._v("\n        Nova Rota\n      ")])], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "min-content"
	  }, [_vm._m(1), _vm._v(" "), (_vm.showAlert) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "alert alert-info alert-container",
	    class: _vm.warning && 'alert-warning'
	  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.msgStrong))]), _vm._v("\n            " + _vm._s(_vm.msg) + "\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showAlert = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-cross icon-close-modal",
	    class: _vm.warning && 'icon-close-modal-warning'
	  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row search-container"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "search"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search),
	      expression: "search"
	    }],
	    staticClass: "form-control input-search-route",
	    attrs: {
	      "type": "text",
	      "name": "search-route",
	      "placeholder": "Digite o nome da rota"
	    },
	    domProps: {
	      "value": (_vm.search)
	    },
	    on: {
	      "keyup": _vm.filter,
	      "keypress": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.searchRoutes.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.search = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "btn btn-icon btn-search-routes",
	    on: {
	      "click": _vm.searchRoutes
	    }
	  }, [_c('i', {
	    staticClass: "icon-search"
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row-tiles"
	  }, _vm._l((_vm.routesPaged), function(r) {
	    return _c('div', {
	      key: r.routeId
	    }, [_c('div', {
	      staticClass: "route-tile",
	      attrs: {
	        "data-toggle": "tooltip",
	        "title": r.flexField1
	      },
	      on: {
	        "click": function($event) {
	          r.open = !r.open
	        }
	      }
	    }, [_c('div', {
	      staticClass: "question-box"
	    }, [_c('span', {
	      staticClass: "closed"
	    }, [_c('i', {
	      staticClass: "icon-arrow-major-breadcrumb"
	    }), _vm._v(" "), _c('h4', {
	      staticClass: "route-title inline"
	    }, [_vm._v(_vm._s(r.name))]), _vm._v(" "), _c('div', {
	      staticClass: "route-distance inline"
	    }, [_vm._v("\n                " + _vm._s(r.totalDistance) + " Km\n                "), _c('label', {
	      staticClass: "route-version"
	    }, [_vm._v("v." + _vm._s(r.version))])]), _vm._v(" "), _c('div', {
	      staticClass: "route-block inline"
	    }, [_c('label', {
	      staticClass: "label-pin"
	    }, [_vm._v(_vm._s(_vm.getAddress(r, 'origin')))]), _vm._v(" "), _c('i', {
	      staticClass: "pin-origin"
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "route-block inline"
	    }, [_c('label', {
	      staticClass: "label-pin"
	    }, [_vm._v(_vm._s(_vm.getAddress(r, 'destination')))]), _vm._v(" "), _c('i', {
	      staticClass: "pin-destination"
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "tolls-block inline"
	    }, [_c('span', {
	      staticClass: "bold"
	    }, [_vm._v("Pedágios:")]), _vm._v(" "), _c('div', {
	      staticClass: "pull-right"
	    }, [_c('span', {
	      staticClass: "badge"
	    }, [_vm._v(_vm._s(r.tollFees.length))])])]), _vm._v(" "), _c('div', {
	      staticClass: "tolls-btn inline pull-right"
	    }, [_c('router-link', {
	      attrs: {
	        "to": {
	          name: 'route-detail',
	          params: {
	            routeId: r.routeId,
	            version: r.version
	          }
	        },
	        "tag": "a",
	        "data-toggle": "tooltip",
	        "title": "Editar rota"
	      }
	    }, [_c('div', {
	      staticClass: "btn btn-icon"
	    }, [_c('i', {
	      staticClass: "icon-edit bold"
	    })])]), _vm._v(" "), _c('a', {
	      attrs: {
	        "data-toggle": "tooltip",
	        "title": "Excluir rota"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.desativar(r)
	        }
	      }
	    }, [_vm._m(2, true)])], 1)]), _vm._v(" "), _c('div', {
	      staticClass: "answer-box",
	      class: r.open ? 'open' : ''
	    }, [_c('div', {
	      staticClass: "thumb-map inline"
	    }, [_c('img', {
	      attrs: {
	        "src": _vm.imageMap(r),
	        "alt": "",
	        "width": "100%"
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "extra-info-block inline"
	    }, [_c('label', {
	      staticClass: "extra-field inline"
	    }, [_vm._v("Informações complementares:")]), _vm._v(" "), _c('label', {
	      staticClass: "inline"
	    }, [_vm._v(_vm._s(r.flexField1))])])])])])])
	  }), 0), _vm._v(" "), (_vm.routesPaged != undefined && _vm.routesPaged.length != 0) ? [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 text-center"
	  }, [_c('pagination', {
	    attrs: {
	      "model": _vm.page
	    },
	    on: {
	      "page-change": _vm.setCurrentPage
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 result-table-count text-center"
	  }, [_vm._v("\n          Mostrando resultados de " + _vm._s(_vm.page.firstIndexShown()) + " a " + _vm._s(_vm.page.lastIndexShown()) + " de um total de " + _vm._s(_vm.page.itemCount()) + " encontrados.\n        ")])])] : _vm._e()], 2)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-6 mobile-width"
	  }, [_c('h3', {
	    staticClass: "title title-route"
	  }, [_vm._v("Rotas")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('label', {
	    staticClass: "label-description-routes"
	  }, [_vm._v("Gerencie suas rotas, edite as atuais ou crie novas.")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "btn btn-icon"
	  }, [_c('i', {
	    staticClass: "icon-not-allowed bold"
	  })])
	}]}

/***/ }),
/* 2087 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "box-transfer-value"
	  }, [_c('label', {
	    staticClass: "label-transfer-value"
	  }, [_vm._v("Valor da Transferência (R$)*:")]), _vm._v(" "), _c('input', {
	    staticClass: "form-control input-transfer-value",
	    attrs: {
	      "type": "text",
	      "name": "input-transfer-value",
	      "placeholder": "0,00",
	      "autofocus": "autofocus"
	    },
	    domProps: {
	      "value": _vm.getValue
	    },
	    on: {
	      "input": function($event) {
	        return _vm.setValue($event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "btn-charge-minus",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.alterValue(_vm.step * -1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn-charge-plus",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.alterValue(_vm.step * 1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-plus"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2088 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title title-rntrc"
	  }, [_vm._v("RNTRC")]), _vm._v(" "), (false) ? _c('router-link', {
	    staticClass: "btn btn-primary btn-new-plan",
	    attrs: {
	      "tag": "button",
	      "to": {
	        name: 'new-contract'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-plus icon-plus-plan align-icon-right-sm"
	  }), _vm._v("\n        Nova Vinculação\n      ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "min-content"
	  }, [_vm._m(0), _vm._v(" "), _c('h4', {
	    staticClass: "bold"
	  }, [_vm._v("Vincular veículos")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "well-rntrc"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "label-company"
	  }, [_c('h4', {
	    staticClass: "label-company-name"
	  }, [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
	    staticClass: "label-cnpj"
	  }, [_c('b', [_vm._v("CNPJ:")]), _vm._v(" " + _vm._s(_vm._f("cpfCnpj")(_vm.user.taxIdNumber)) + "\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "label-rntrc"
	  }, [_c('b', [_vm._v("RNTRC:")]), _vm._v(" "), _c('a', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.editRntrc),
	      expression: "!editRntrc"
	    }],
	    staticClass: "force-link",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "Editar o código RNTRC"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.startEditRntrc()
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.rntrc) + " "), _c('i', {
	    staticClass: "icon-pencil icon-edit"
	  })]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.editRntrc),
	      expression: "editRntrc"
	    }],
	    staticClass: "editable"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newRntrc),
	      expression: "newRntrc"
	    }],
	    staticClass: "form-control rntrc-label-input",
	    attrs: {
	      "name": "name",
	      "placeholder": "00000000"
	    },
	    domProps: {
	      "value": (_vm.newRntrc)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newRntrc = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "rntrc-box-edit"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "inline",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "Cancelar edição"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.cancelEditRntrc()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-cancel-edit"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "inline",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "Salvar edição"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.confirmEditRntrc()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-check-edit"
	  })])])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), (false) ? _c('div', {
	    staticClass: "alert alert-success"
	  }, [_vm._v("\n      Não há TAGs para vincular no momento.\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle, index) {
	    return _c('vehicle-rntrc', {
	      key: vehicle.vehicleId,
	      attrs: {
	        "vehicle": vehicle,
	        "rntrc": _vm.rntrc
	      }
	    })
	  })], 2)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', [_vm._v("\n          A vinculação do Registro Nacional de Transportadores de Cargas (RNTRC) a um dispositivo eletrônico (TAG) tornou-se obrigatória pela ANTT. Se você é um transportador e ainda não possui um TAG vinculado, adquira já!\n        ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-b10 margin-t20"
	  }, [_vm._v("\n        Para vincular os veículos ao seu RNTRC é necessário informar os dados abaixo, clicar em vincular e pronto!\n      ")])])
	}]}

/***/ }),
/* 2089 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("Serviços para Empresas")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-b10"
	  }, [_c('h3', {
	    staticClass: "bold upper"
	  }, [_vm._v("Recargas")]), _vm._v(" "), _c('p', [_vm._v("As recargas estão sujeitas a taxas de serviço, verifique os valores:")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-red"
	  }, [_c('div', {
	    staticClass: "recharge-value-red"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-red"
	  }, [_vm._v("500")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de serviço:\n            "), _c('p', [_vm._v("40,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-yellow"
	  }, [_c('div', {
	    staticClass: "recharge-value-yellow"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-yellow"
	  }, [_vm._v("1.000")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de serviço:\n            "), _c('p', [_vm._v("70,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-green"
	  }, [_c('div', {
	    staticClass: "recharge-value-green"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-green"
	  }, [_vm._v("1.500")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de serviço:\n            "), _c('p', [_vm._v("90,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-blue"
	  }, [_c('div', {
	    staticClass: "recharge-value-blue"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-blue"
	  }, [_vm._v("2.000")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de serviço:\n            "), _c('p', [_vm._v("100,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge-last"
	  }, [_c('div', {
	    staticClass: "recharge-purple"
	  }, [_c('div', {
	    staticClass: "recharge-value-purple"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-purple"
	  }, [_vm._v("2.000+")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de serviço:\n            "), _c('p', [_vm._v("5%")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('a', {
	    staticClass: "btn btn-back",
	    attrs: {
	      "href": "javascript:window.history.back()"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n        Voltar\n      ")])])])])
	}]}

/***/ }),
/* 2090 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("Serviços para Você")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-b10"
	  }, [_c('h3', {
	    staticClass: "bold upper"
	  }, [_vm._v("Recargas")]), _vm._v(" "), _c('p', [_vm._v("As recargas estão sujeitas a taxas de serviço, verifique os valores:")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-red"
	  }, [_c('div', {
	    staticClass: "recharge-value-red"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-red"
	  }, [_vm._v("50")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de serviço:\n            "), _c('p', [_vm._v("5,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-yellow"
	  }, [_c('div', {
	    staticClass: "recharge-value-yellow"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-yellow"
	  }, [_vm._v("100")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de serviço:\n            "), _c('p', [_vm._v("9,40")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-green"
	  }, [_c('div', {
	    staticClass: "recharge-value-green"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-green"
	  }, [_vm._v("150")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de serviço:\n            "), _c('p', [_vm._v("13,20")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-blue"
	  }, [_c('div', {
	    staticClass: "recharge-value-blue"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-blue"
	  }, [_vm._v("200")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de serviço:\n            "), _c('p', [_vm._v("16,40")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge-last"
	  }, [_c('div', {
	    staticClass: "recharge-purple"
	  }, [_c('div', {
	    staticClass: "recharge-value-purple"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-purple"
	  }, [_vm._v("250")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de serviço:\n            "), _c('p', [_vm._v("19,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-red"
	  }, [_c('div', {
	    staticClass: "recharge-value-red"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-red"
	  }, [_vm._v("300")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de serviço:\n            "), _c('p', [_vm._v("21,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-yellow"
	  }, [_c('div', {
	    staticClass: "recharge-value-yellow"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-yellow"
	  }, [_vm._v("350")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de serviço:\n            "), _c('p', [_vm._v("22,40")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-green"
	  }, [_c('div', {
	    staticClass: "recharge-value-green"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-green"
	  }, [_vm._v("400")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de serviço:\n            "), _c('p', [_vm._v("22,40")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-blue"
	  }, [_c('div', {
	    staticClass: "recharge-value-blue"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-blue"
	  }, [_vm._v("450")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de serviço:\n            "), _c('p', [_vm._v("21,60")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge-last"
	  }, [_c('div', {
	    staticClass: "recharge-purple"
	  }, [_c('div', {
	    staticClass: "recharge-value-purple"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-purple"
	  }, [_vm._v("500")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de serviço:\n            "), _c('p', [_vm._v("20,00")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('a', {
	    staticClass: "btn btn-back",
	    attrs: {
	      "href": "javascript:window.history.back()"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n        Voltar\n      ")])])])])
	}]}

/***/ }),
/* 2091 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('form', {
	    attrs: {
	      "name": "form-address",
	      "id": "form-address"
	    }
	  }, [(_vm.address) ? _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loadingAddress),
	      expression: "loadingAddress"
	    }],
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-box"
	  }, [_c('b', {
	    staticClass: "title-identification margin-b10"
	  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    staticClass: "form-content"
	  }, [_c('div', {
	    staticClass: "form-content"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errorCep),
	      expression: "errorCep"
	    }],
	    staticClass: "alert alert-danger alert-dismissable margin-b30"
	  }, [_c('a', {
	    staticClass: "close",
	    attrs: {
	      "aria-label": "close"
	    },
	    on: {
	      "click": function($event) {
	        _vm.errorCep = undefined
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" " + _vm._s(_vm.errorCep) + "\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control input-box-cep",
	    class: {
	      'has-error': _vm.errors.has('cep')
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.address.zipCode),
	      expression: "address.zipCode"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:8|cep'),
	      expression: "'required|min:8|cep'"
	    }, {
	      name: "only-numbers",
	      rawName: "v-only-numbers"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "cep",
	      "maxlength": "8"
	    },
	    domProps: {
	      "value": (_vm.address.zipCode)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.address, "zipCode", $event.target.value)
	      }, _vm.queryAddressTyping]
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first('cep')) + "\n                ")])]), _vm._v(" "), _c('a', {
	    staticClass: "label-link",
	    staticStyle: {
	      "margin-left": "5px"
	    },
	    on: {
	      "click": _vm.queryAddress
	    }
	  }, [_vm._v("Buscar CEP")])]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "form-group margin-b30 input-box-control inline",
	    class: {
	      'has-error': _vm.errors.has('logradouro')
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.address.address),
	      expression: "address.address"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:50'),
	      expression: "'required|max:50'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "logradouro",
	      "maxlength": "50"
	    },
	    domProps: {
	      "value": (_vm.address.address)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.address, "address", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('logradouro')) + "\n                  ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control inline input-box-number",
	    class: {
	      'has-error': _vm.errors.has('numero')
	    }
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.address.number),
	      expression: "address.number"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:5'),
	      expression: "'required|max:5'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "maxlength": "5",
	      "name": "numero"
	    },
	    domProps: {
	      "value": (_vm.address.number)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.address, "number", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('numero')) + "\n                  ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control inline input-box-adjunct"
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.address.complement),
	      expression: "address.complement"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "maxlength": "20",
	      "name": "complemento"
	    },
	    domProps: {
	      "value": (_vm.address.complement)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.address, "complement", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  })])])]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "form-group margin-b30 input-box-control inline input-box-medium",
	    class: {
	      'has-error': _vm.errors.has('bairro')
	    }
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.address.neighborhood),
	      expression: "address.neighborhood"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:30'),
	      expression: "'required|max:30'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "maxlength": "30",
	      "name": "bairro"
	    },
	    domProps: {
	      "value": (_vm.address.neighborhood)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.address, "neighborhood", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('bairro')) + "\n                  ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control inline input-box-medium",
	    class: {
	      'has-error': _vm.errors.has('cidade')
	    }
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.address.city),
	      expression: "address.city"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:30'),
	      expression: "'required|max:30'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "maxlength": "30",
	      "name": "cidade"
	    },
	    domProps: {
	      "value": (_vm.address.city)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.address, "city", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('cidade')) + "\n                  ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group no-margin input-box-control inline input-box-state",
	    class: {
	      'has-error': _vm.errors.has('estado')
	    }
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.address.state),
	      expression: "address.state"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:2'),
	      expression: "'required|max:2'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "maxlength": "2",
	      "name": "estado"
	    },
	    domProps: {
	      "value": (_vm.address.state)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.address, "state", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('estado')) + "\n                  ")])])])])])])])])]) : _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loadingAddress),
	      expression: "loadingAddress"
	    }]
	  })])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("CEP")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Logradouro")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Número")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Complemento")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Bairro")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Cidade")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Estado")])])
	}]}

/***/ }),
/* 2092 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "accordion",
	    class: (_vm.isOpen ? 'current' : '')
	  }, [_c('div', {
	    staticClass: "accordion-header"
	  }, [_vm._t("header"), _vm._v(" "), _c('i', {
	    staticClass: "open-accordion",
	    class: _vm.iconClass,
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "Expandir / Diminuir"
	    },
	    on: {
	      "click": function($event) {
	        _vm.isOpen = !_vm.isOpen
	      }
	    }
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "accordion-content"
	  }, [_vm._t("content")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2093 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.showTaxes) ? _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', [_c('a', {
	    directives: [{
	      name: "smooth-scroll",
	      rawName: "v-smooth-scroll"
	    }],
	    staticClass: "make-link",
	    attrs: {
	      "href": "https://movemais.com/api/v2/archeion/downloadFileArcheion/tabela-de-tarifas-movemais"
	    }
	  }, [_vm._v("\n          *Conheça nossos valores de recarga.\n        ")])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, _vm._l((_vm.typeSelected.values), function(taxas) {
	    return _c('div', {
	      key: taxas.id
	    }, [_c('div', {
	      class: taxas.classLastChildInLine ?
	        'box-recharge-' + taxas.classLastChildInLine :
	        'box-recharge',
	      staticStyle: {
	        "margin-bottom": "2rem"
	      }
	    }, [_c('div', {
	      class: 'recharge-' + taxas.colorClass
	    }, [_c('div', {
	      class: 'recharge-value-' + taxas.colorClass
	    }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	      class: 'recharge-label-' + taxas.colorClass
	    }, [_vm._v("\n              " + _vm._s(taxas.rechargeValue) + "\n            ")]), _vm._v(" "), _c('div', {
	      staticClass: "recharge-tax-label"
	    }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v(_vm._s(_vm._f("cents")(taxas.rechargeTax)))])])]), _vm._v(" "), (taxas.additionalInformation) ? _c('small', [_vm._v(_vm._s(taxas.additionalInformation))]) : _vm._e()])])
	  }), 0)])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "rechargeB2B"
	    }
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-b10"
	  }, [_c('h3', {
	    staticClass: "bold upper"
	  }, [_vm._v("Recargas")]), _vm._v(" "), _c('p', [_vm._v("As recargas estão sujeitas a taxas, verifique os valores:")])])])
	}]}

/***/ }),
/* 2094 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade modal-info-block",
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog",
	      "id": "modal-2fa"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document",
	      "id": "modal-content-2fa"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-body"
	  }, [(_vm.showCellphone) ? _c('div', [_c('div', {
	    staticClass: "form-group info-transfer-box inline"
	  }, [_c('p', [_vm._v("Informe o código enviado para:")]), _vm._v(" "), _c('p', {
	    staticClass: "bold",
	    staticStyle: {
	      "letter-spacing": "2px"
	    }
	  }, [_vm._v(_vm._s(_vm.celFormated))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tokenCellphone),
	      expression: "tokenCellphone"
	    }],
	    staticClass: "inline form-control bold",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "maxlength": "6"
	    },
	    domProps: {
	      "value": (_vm.tokenCellphone)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.tokenCellphone = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "btn option-outline",
	    staticStyle: {
	      "margin-top": "0.5cm"
	    },
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.resetSentCellPhone()
	      }
	    }
	  }, [_vm._v("Alterar celular")]), _vm._v(" "), (_vm.errorCell) ? _c('p', {
	    staticClass: "error"
	  }, [_vm._v(_vm._s(_vm.errorCell))]) : _vm._e(), _vm._v(" "), (_vm.resentCell) ? _c('p', {
	    staticClass: "message",
	    staticStyle: {
	      "margin-top": "0.5cm"
	    }
	  }, [_vm._v("Código enviado com sucesso!")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.showEmail) ? _c('div', [_c('div', {
	    staticClass: "form-group info-transfer-box inline"
	  }, [_c('p', [_vm._v("Informe o código enviado para:")]), _vm._v(" "), _c('p', {
	    staticClass: "bold"
	  }, [_vm._v(_vm._s(_vm.emailUser))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tokenEmail),
	      expression: "tokenEmail"
	    }],
	    staticClass: "inline form-control bold",
	    staticStyle: {},
	    attrs: {
	      "type": "text",
	      "name": "",
	      "maxlength": "6"
	    },
	    domProps: {
	      "value": (_vm.tokenEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.tokenEmail = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "btn option-outline",
	    staticStyle: {
	      "margin-top": "1cm"
	    },
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("Alterar E-mail")]), _vm._v(" "), (_vm.errorEmail) ? _c('p', {
	    staticClass: "error"
	  }, [_vm._v(_vm._s(_vm.errorEmail))]) : _vm._e(), _vm._v(" "), (_vm.resentEmail) ? _c('p', {
	    staticClass: "message"
	  }, [_vm._v("Código enviado com sucesso!")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), (_vm.showCellphone) ? _c('div', {
	    staticClass: "modal-footer buttons-container"
	  }, [_c('button', {
	    staticClass: "btn option-outline",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sendCellphone()
	      }
	    }
	  }, [_vm._v("Re-enviar código")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info",
	    attrs: {
	      "type": "button",
	      "disabled": !_vm.tokenCellphone || _vm.tokenCellphone.length != 6
	    },
	    on: {
	      "click": function($event) {
	        return _vm.confirmCellphoneOTP()
	      }
	    }
	  }, [_vm._v("Confirmar")])]) : _vm._e(), _vm._v(" "), (_vm.showEmail) ? _c('div', {
	    staticClass: "modal-footer buttons-container"
	  }, [_c('button', {
	    staticClass: "btn option-outline",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.sendEmail()
	      }
	    }
	  }, [_vm._v("Re-enviar código")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info",
	    attrs: {
	      "type": "button",
	      "disabled": !_vm.tokenEmail || _vm.tokenEmail.length != 6
	    },
	    on: {
	      "click": function($event) {
	        return _vm.confirmEmailOTP()
	      }
	    }
	  }, [_vm._v("Confirmar")])]) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.order) ? _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("\n        Pedidos\n        "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Contrato " + _vm._s(_vm.order.contract) + "\n        "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" " + _vm._s(_vm.order.orderId) + "\n      ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.order.status.statusId == 3),
	      expression: "order.status.statusId == 3"
	    }],
	    staticClass: "alert alert-danger margin-b20",
	    staticStyle: {
	      "padding": "15px"
	    }
	  }, [_c('strong', [_vm._v("Ah, não! Seu pagamento não deu certo.")]), _vm._v(" Não se preocupe, você pode tentar reprocessar o pedido.\n      ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "content-box margin-t20"
	  }, [_c('h3', {
	    staticClass: "bold"
	  }, [_vm._v("Detalhes do Pedido")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 request-order"
	  }, [_c('p'), _c('div', {
	    staticClass: "request-status-label"
	  }, [_vm._v("N° Pedido:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.order.orderId))]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 request-date"
	  }, [_c('p'), _c('div', {
	    staticClass: "request-status-label"
	  }, [_vm._v("Data da Solicitação:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("date")(_vm.order.date)))]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 request-status"
	  }, [_c('p'), _c('div', {
	    staticClass: "request-status-label"
	  }, [_vm._v("Status:")]), _vm._v(" "), _c('span', {
	    class: _vm.statusPedido
	  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.order.status.name))]), _vm._v(" "), _c('p')])])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "content-box margin-t20"
	  }, [_c('h3', {
	    staticClass: "bold"
	  }, [_vm._v("Detalhes da Compra")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), [_c('div', {
	    staticClass: "margin-20 resumo-table"
	  }, [(_vm.order.products) ? _c('table', {
	    staticClass: "table no-footer",
	    attrs: {
	      "role": "grid"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.order.products.product), function(product, index) {
	    return _c('tr', {
	      key: index
	    }, [_c('td', [_vm._v("\n                    " + _vm._s(product.productName) + "\n                    "), (_vm.showVehiclesPlates(product)) ? _c('a', {
	      staticClass: "label-link",
	      on: {
	        "click": function($event) {
	          return _vm.toogleModal()
	        }
	      }
	    }, [_vm._v("Visualizar Veículos")]) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticClass: "text-align-right"
	    }, [_vm._v(" " + _vm._s(product.quantity))]), _vm._v(" "), _c('td', {
	      staticClass: "request-unity-value-col"
	    }, [_vm._v(" " + _vm._s(_vm._f("cents")(_vm.isDescont(product, product.valueUnit))))]), _vm._v(" "), _c('td', {
	      staticClass: "text-align-right"
	    }, [_vm._v(" " + _vm._s(_vm._f("cents")(_vm.isDescont(product, product.valueTotal))))])])
	  }), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "upper",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("total do pedido")]), _vm._v(" "), _c('td', {
	    staticClass: "request-unity-value-col"
	  }), _vm._v(" "), _c('td', {
	    staticClass: "text-align-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.order.price)))])])], 2)]) : _vm._e()])], _vm._v(" "), (_vm.order.bankBillUrl) ? _c('div', {
	    staticClass: "content-box margin-t20"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 text-align-right"
	  }, [_c('div', [_c('a', {
	    staticClass: "btn btn-default btn-sm bold",
	    attrs: {
	      "href": _vm.order.bankBillUrl,
	      "target": "_blank"
	    }
	  }, [_vm._v("\n                    Visualizar o Boleto\n                  ")]), _vm._v(" "), _c('small', {
	    staticStyle: {
	      "padding": "5px 0"
	    }
	  }, [_vm._v("* Caso não consiga visualizar o boleto verifique seu bloqueador de popup.")])])])])]) : _vm._e(), _vm._v(" "), (_vm.canReprocess()) ? _c('div', {
	    staticClass: "content-box margin-t20"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 text-right"
	  }, [(_vm.order.type == 'PAYMENTPERUSE') ? _c('router-link', {
	    staticClass: "btn btn-default btn-sm bold",
	    attrs: {
	      "to": {
	        name: 'reprocess-orders',
	        params: {
	          contractId: _vm.order.contract
	        }
	      },
	      "tag": "button",
	      "type": "button",
	      "name": "button",
	      "disabled": _vm.reprocessed
	    }
	  }, [_vm._v("Reprocessar")]) : _c('button', {
	    staticClass: "btn btn-default btn-sm bold",
	    attrs: {
	      "type": "button",
	      "name": "button",
	      "disabled": _vm.reprocessed
	    },
	    on: {
	      "click": function($event) {
	        return _vm.showModalReprocessPayout()
	      }
	    }
	  }, [_vm._v("Reprocessar")])], 1)])]) : _vm._e()], 2)])]), _vm._v(" "), (_vm.orderShipmentTracking) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "content-box margin-t20"
	  }, [_c('h3', {
	    staticClass: "bold"
	  }, [_vm._v("Detalhes da Entrega")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, _vm._l((_vm.orderShipmentTracking), function(track, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "delivery-box border-right-gray"
	    }, [_c('img', {
	      staticClass: "icon-check",
	      attrs: {
	        "src": __webpack_require__(1766),
	        "alt": "Check",
	        "width": "33px",
	        "height": "33px"
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "info-check"
	    }, [_c('div', {
	      staticClass: "info-title"
	    }, [_vm._v(_vm._s(track.statusTracking.name))]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin"
	    }, [_vm._v(_vm._s(_vm._f("dateTime")(track.dateOccurrence)))])]), _vm._v(" "), _c('small', [_vm._v(_vm._s(track.statusTracking.description))])])
	  }), 0)]), _vm._v(" "), (_vm.order.shipment.shipmentService == 'PAC' && _vm.order.shipment.trackingNumber) ? _c('div', {
	    staticClass: "margin-t20 margin-b10"
	  }, [(!_vm.order.shipment.trackingNumber || _vm.order.shipment.trackingNumber == 'N/A') ? _c('div', [_vm._v("\n            O código de rastreio estará disponivel em breve.\n          ")]) : (_vm.order.shipment.carrier == 'CORREIOS') ? _c('form', {
	    attrs: {
	      "method": "GET",
	      "action": "https://www.websro.com.br/rastreamento-correios.php?",
	      "target": "popup",
	      "onsubmit": "window.open('', 'popup', 'width=800,height=400');"
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "P_COD_UNI",
	      "rows": "1",
	      "size": "14",
	      "wrap": "VIRTUAL"
	    },
	    domProps: {
	      "value": _vm.order.shipment.trackingNumber
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "inline track-order"
	  }, [_vm._v("Código de Rastreamento: "), _c('b', {
	    staticClass: "upper"
	  }, [_vm._v(_vm._s(_vm.order.shipment.trackingNumber))]), _vm._v(" - " + _vm._s(_vm.order.shipment.carrier))]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary btn-sm",
	    attrs: {
	      "type": "submit",
	      "target": "_blank"
	    }
	  }, [_vm._v("Rastrear Entrega")])]) : (_vm.order.shipment.carrier == 'JADLOG') ? _c('form', {
	    attrs: {
	      "method": "POST",
	      "action": "https://www.jadlog.com.br/siteDpd/tracking.jad",
	      "target": "popup",
	      "onsubmit": "window.open('', 'popup', 'width=800,height=400');"
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "cte"
	    },
	    domProps: {
	      "value": _vm.order.shipment.trackingNumber
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "lang",
	      "value": ""
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "inline track-order"
	  }, [_vm._v("Código de Rastreamento: "), _c('b', {
	    staticClass: "upper"
	  }, [_vm._v(_vm._s(_vm.order.shipment.trackingNumber))]), _vm._v(" - " + _vm._s(_vm.order.shipment.carrier))]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary btn-sm",
	    attrs: {
	      "type": "submit",
	      "target": "_blank"
	    }
	  }, [_vm._v("Rastrear Entrega")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.order.shipment.shipmentService == 'PAC') ? [_c('p', [_vm._v("Endereço da entrega:")]), _vm._v(" "), _c('div', {
	    staticClass: "content-box background-solid"
	  }, [_c('p', [_vm._v(_vm._s(_vm.address))])])] : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back margin-t20",
	    attrs: {
	      "to": {
	        name: 'requests'
	      },
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v(" Voltar\n      ")])], 1)]), _vm._v(" "), (_vm.showVehicle) ? _c('div', {
	    staticClass: "modal fade in",
	    staticStyle: {
	      "display": "block",
	      "background": "rgba(230, 230, 230, 0.8)"
	    },
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header modal-info"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showVehicle = false
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Visualizar Veículos")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('p', {
	    staticClass: "bold-600 text-center"
	  }, [_vm._v("Placa dos Veículos:")]), _vm._v(" "), _c('div', {
	    staticClass: "cell-plate"
	  }, _vm._l((_vm.listVehicles), function(vehicle, index) {
	    return _c('div', {
	      key: index
	    }, [_vm._v("\n              " + _vm._s(vehicle.plate) + "\n            ")])
	  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.showModal) ? _c('reprocess', {
	    attrs: {
	      "orderId": _vm.order.orderId,
	      "contractId": _vm.order.contract
	    },
	    on: {
	      "close": function($event) {
	        _vm.showModal = false
	      },
	      "reprocessConfirmed": _vm.goToOrders,
	      "Reprocessar": function($event) {
	        _vm.reprocessed = true
	      }
	    }
	  }) : _vm._e()], 1) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "width": "40%"
	    }
	  }, [_vm._v("Descrição")]), _vm._v(" "), _c('th', {
	    staticClass: "request-amount-col"
	  }), _vm._v(" "), _c('th', {
	    staticClass: "request-unity-value-col"
	  }, [_vm._v("Valor Unitário")]), _vm._v(" "), _c('th', {
	    staticClass: "text-align-right",
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Valor Total")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "bold"
	  }, [_vm._v("Boleto Bancário")])])
	}]}

/***/ }),
/* 2096 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade modal-route-vp",
	    attrs: {
	      "id": "modal-route-vp",
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-labelledby": "modal-route-vp-label"
	    },
	    on: {
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) { return null; }
	        return _vm.closeModal()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title",
	    attrs: {
	      "id": "modal-route-vp-label"
	    }
	  }, [_vm._v("Rota do Vale-pedágio (VP)")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    staticClass: "aggregate-data"
	  }, [_c('p', [_vm._v("Transportador: "), _c('span', [_vm._v(_vm._s(_vm.summaryVP.transportador))])]), _vm._v(" "), _c('p', [_vm._v("Placa: "), _c('span', {
	    directives: [{
	      name: "mask-plate",
	      rawName: "v-mask-plate"
	    }]
	  }, [_vm._v(_vm._s(_vm.summaryVP.placaVeiculo))])]), _vm._v(" "), _c('p', [_vm._v("N° TAG: "), _c('span', [_vm._v(_vm._s(_vm.summaryVP.tag))])]), _vm._v(" "), _c('p', {
	    staticClass: "text-right"
	  }, [_vm._v("N° VP: "), _c('span', [_vm._v(_vm._s(_vm.summaryVP.idProtocolo))])])]), _vm._v(" "), _c('div', {
	    staticClass: "content-box-npadd"
	  }, [_c('p', [_vm._v("Detalhes da viagem")]), _vm._v(" "), _c('div', {
	    staticClass: "toll-info-box"
	  }, [_c('div', {}, [_c('div', {}, [_c('small', [_vm._v("De")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.origin.city))]), _vm._v(" "), _c('small', [_c('img', {
	    attrs: {
	      "src": "/static/icon-send.svg",
	      "alt": "icon send"
	    }
	  }), _vm._v("\n                  " + _vm._s(_vm.origin.state) + "\n                ")])]), _vm._v(" "), _c('div', {}, [_c('small', [_vm._v("para")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.destination.city))]), _vm._v(" "), _c('small', [_c('img', {
	    attrs: {
	      "src": "/static/icon-location.svg",
	      "alt": "icon location"
	    }
	  }), _vm._v("\n                  " + _vm._s(_vm.destination.state) + "\n                ")])])]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("\n                rota:\n                "), _c('span', [_vm._v(_vm._s(_vm.summaryVP.rota))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n                valor:\n                "), _c('span', [_vm._v(_vm._s(_vm._f("cents")(_vm.summaryVP.valorVP)))])]), _vm._v(" "), _c('p', [_vm._v("\n                expiração:\n                "), _c('span', [_vm._v(_vm._s(_vm._f("date")(_vm.summaryVP.expirationVP)))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "table-toll-info"
	  }, [_c('table', {
	    staticClass: "table"
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.summaryVP.pracas), function(s, index) {
	    return _c('tr', [_vm._m(2, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(s.praca))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(s.concessionaria))]), _vm._v(" "), _c('td', {
	      staticClass: "text-right"
	    }, [_vm._v(_vm._s(_vm._f("cents")(s.price)))])])
	  }), 0)])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("\n                distância:\n                "), _c('span', [_vm._v(" KM")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "width": "4%"
	    }
	  }), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "45%"
	    }
	  }, [_vm._v("Praça de pedágio")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "36%"
	    }
	  }, [_vm._v("Concessionária")]), _vm._v(" "), _c('th', {
	    staticClass: "text-right",
	    attrs: {
	      "width": "15%"
	    }
	  }, [_vm._v("Valor")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', [_c('div', {
	    staticClass: "wizard-vertical"
	  }, [_c('span')])])
	}]}

/***/ }),
/* 2097 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('div', {
	    staticClass: "row text-center"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "plain-box"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6 small-padding-left"
	  }, [_c('div', {
	    staticClass: "third-col-box margin-b20"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "height-112 height-72-big padding-18"
	  }, [_c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("Perfeito para você que gosta de comodidade e não quer se preocupar com recargas ou saldo insuficiente.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "tag": "a",
	      "to": "/servicos-sodre-plano-conforto"
	    }
	  }, [_vm._v("Saiba Mais")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "height-82 padding-28"
	  }, [(_vm.getNewAdhesionTax > 0) ? _c('h3', {
	    staticClass: "bold no-margin"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.getNewAdhesionTax)))]) : _c('span', [_c('h4', {
	    staticClass: "promo-value"
	  }, [_vm._v("R$ 39,90")]), _vm._v(" "), _c('b', {
	    staticClass: "promo-free"
	  }, [_vm._v("Grátis")])])]), _vm._v(" "), _c('div', {
	    staticClass: "height-82 padding-28"
	  }, [_c('h3', {
	    staticClass: "bold no-margin"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.getNewVehicleTax)))])]), _vm._v(" "), _c('div', {
	    staticClass: "height-82 padding-28"
	  }, [_c('h3', {
	    staticClass: "bold no-margin"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.getReplaceTax)))])]), _vm._v(" "), _c('div', {
	    staticClass: "height-82 padding-28"
	  }, [_c('h3', {
	    staticClass: "bold no-margin"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.getMonthlyTax)))])]), _vm._v(" "), _c('div', {
	    staticClass: "height-72 padding-t25"
	  }, [_c('a', {
	    directives: [{
	      name: "smooth-scroll",
	      rawName: "v-smooth-scroll"
	    }],
	    staticClass: "make-link",
	    attrs: {
	      "href": "#rechargeB2C"
	    }
	  }, [_vm._v("\n                      Veja Nossas Taxas de Recarga\n                    ")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "row-button border-radius-bottom"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "tag": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.choose(55)
	      }
	    }
	  }, [_vm._v("\n                      Quero este plano!\n                    ")])])])])])])])])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-2 first-col-box"
	  }, [_c('div', {
	    staticClass: "height-72 border-radius-top"
	  }, [_c('p', {
	    staticClass: "margin-10"
	  }, [_c('i', {
	    staticClass: "icon-plans icon-plans-table"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "height-112"
	  }, [_c('p', {
	    staticClass: "bold no-margin padding-t45"
	  }, [_vm._v("Como Funciona?")])]), _vm._v(" "), _c('div', {
	    staticClass: "height-82"
	  }, [_c('p', {
	    staticClass: "bold no-margin padding-t35"
	  }, [_vm._v("Adesão por Veículo")])]), _vm._v(" "), _c('div', {
	    staticClass: "height-82"
	  }, [_c('p', {
	    staticClass: "bold no-margin padding-12"
	  }, [_vm._v("Adesão Veículo Adicional")])]), _vm._v(" "), _c('div', {
	    staticClass: "height-82"
	  }, [_c('p', {
	    staticClass: "bold no-margin padding-12"
	  }, [_vm._v("Substituição (TAG)")])]), _vm._v(" "), _c('div', {
	    staticClass: "height-82"
	  }, [_c('p', {
	    staticClass: "bold no-margin padding-12"
	  }, [_vm._v("Mensalidade")])]), _vm._v(" "), _c('div', {
	    staticClass: "height-72"
	  }, [_c('p', {
	    staticClass: "bold no-margin padding-23"
	  }, [_vm._v("Taxa Recarga (2%)")])]), _vm._v(" "), _c('div', {
	    staticClass: "height-82 striped-line"
	  }, [_c('p', {
	    staticClass: "bold no-margin padding-12"
	  }, [_vm._v("Formas de Pagamento")])]), _vm._v(" "), _c('div', {
	    staticClass: "height-72 border-radius-bottom",
	    staticStyle: {
	      "height": "82px"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-72 border-radius-top"
	  }, [_c('h3', {
	    staticClass: "sub-title plan upper no-margin margin-b10"
	  }, [_vm._v("Pré-pago Automático sodré "), _c('br'), _vm._v("com mensalidade "), _c('br')])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-82 padding-20"
	  }, [_c('ul', [_c('li', [_vm._v("Cartão de Crédito")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "rechargeB2C"
	    }
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-b10"
	  }, [_c('h3', {
	    staticClass: "bold upper"
	  }, [_vm._v("Recargas")]), _vm._v(" "), _c('p', [_vm._v("As recargas consistem em taxa fixa de 2%, verifique os valores:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-red"
	  }, [_c('div', {
	    staticClass: "recharge-value-red"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-red"
	  }, [_vm._v("50")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("1,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-yellow"
	  }, [_c('div', {
	    staticClass: "recharge-value-yellow"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-yellow"
	  }, [_vm._v("100")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("2,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-green"
	  }, [_c('div', {
	    staticClass: "recharge-value-green"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-green"
	  }, [_vm._v("150")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("3,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-blue"
	  }, [_c('div', {
	    staticClass: "recharge-value-blue"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-blue"
	  }, [_vm._v("200")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("4,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge-last"
	  }, [_c('div', {
	    staticClass: "recharge-purple"
	  }, [_c('div', {
	    staticClass: "recharge-value-purple"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-purple"
	  }, [_vm._v("250")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("5,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-red"
	  }, [_c('div', {
	    staticClass: "recharge-value-red"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-red"
	  }, [_vm._v("300")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("6,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-yellow"
	  }, [_c('div', {
	    staticClass: "recharge-value-yellow"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-yellow"
	  }, [_vm._v("350")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("7,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-green"
	  }, [_c('div', {
	    staticClass: "recharge-value-green"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-green"
	  }, [_vm._v("400")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("8,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-blue"
	  }, [_c('div', {
	    staticClass: "recharge-value-blue"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-blue"
	  }, [_vm._v("450")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("9,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge-last"
	  }, [_c('div', {
	    staticClass: "recharge-purple"
	  }, [_c('div', {
	    staticClass: "recharge-value-purple"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-purple"
	  }, [_vm._v("500")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("10,00")])])])])])])
	}]}

/***/ }),
/* 2098 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('form', {
	    staticClass: "form form-inline margin-t20",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.doFilter(true)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "inline filter-period"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('span', {
	    staticClass: "period"
	  }, [_vm._v("Período:")]), _vm._v(" "), _c('dropdown', {
	    staticClass: "dropdown-lastdays",
	    attrs: {
	      "options": _vm.lastDaysOptions
	    },
	    model: {
	      value: (_vm.lastDays),
	      callback: function($$v) {
	        _vm.lastDays = $$v
	      },
	      expression: "lastDays"
	    }
	  }), _vm._v("\n             \n            "), _vm._v(" "), _vm._m(1)], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.lastDays == 'custom'),
	      expression: "lastDays == 'custom'"
	    }],
	    staticClass: "inline filter-range"
	  }, [_c('div', {
	    staticClass: "inline margin-side"
	  }, [_c('div', {
	    staticClass: "form-group form-inline",
	    class: {
	      'has-error': _vm.errors.has('Data-inicial')
	    }
	  }, [_c('label', [_vm._v("De:")]), _vm._v(" "), _c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control picker acc",
	    attrs: {
	      "name": "Data-inicial",
	      "format": "dd/MM/yyyy",
	      "language": "pt-br",
	      "data-vv-rules": "required"
	    },
	    model: {
	      value: (_vm.customStart),
	      callback: function($$v) {
	        _vm.customStart = $$v
	      },
	      expression: "customStart"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('Data-inicial')) + "\n              ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "inline margin-side"
	  }, [_c('div', {
	    staticClass: "form-group form-inline",
	    class: {
	      'has-error': _vm.errors.has('Data-final')
	    }
	  }, [_c('label', [_vm._v("Até:")]), _vm._v(" "), _c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control picker acc",
	    attrs: {
	      "name": "Data-final",
	      "format": "dd/MM/yyyy",
	      "language": "pt-br",
	      "data-vv-as": "data inicial"
	    },
	    model: {
	      value: (_vm.customEnd),
	      callback: function($$v) {
	        _vm.customEnd = $$v
	      },
	      expression: "customEnd"
	    }
	  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('Data-final')) + "\n              ")])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "inline filter-plate"
	  }, [_c('div', {
	    staticClass: "inline margin-10 margin-r10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.showToll),
	      expression: "showToll"
	    }],
	    staticClass: "check-terms",
	    attrs: {
	      "id": "filter-toll",
	      "type": "checkbox",
	      "name": "filter-toll",
	      "value": ""
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.showToll) ? _vm._i(_vm.showToll, "") > -1 : (_vm.showToll)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.showToll,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.showToll = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.showToll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.showToll = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "label-terms",
	    attrs: {
	      "for": "filter-toll"
	    }
	  }, [_vm._v("Filtrar N° Vale-pedágio")])]), _vm._v(" "), (_vm.showToll) ? _c('div', {
	    staticClass: "form-group form-plate margin-r10",
	    class: {
	      'has-error': _vm.errors.has('toll')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.toll),
	      expression: "toll"
	    }],
	    staticClass: "form-control plate-field",
	    attrs: {
	      "type": "search",
	      "name": "toll",
	      "placeholder": "Digite o N° VP"
	    },
	    domProps: {
	      "value": (_vm.toll)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.doFilter(true)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.toll = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('toll')) + "\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "inline margin-10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.showPlate),
	      expression: "showPlate"
	    }],
	    staticClass: "check-terms",
	    attrs: {
	      "id": "filter-plate",
	      "type": "checkbox",
	      "name": "filter-plate",
	      "value": ""
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.showPlate) ? _vm._i(_vm.showPlate, "") > -1 : (_vm.showPlate)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.showPlate,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.showPlate = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.showPlate = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.showPlate = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "label-terms",
	    attrs: {
	      "for": "filter-plate"
	    }
	  }, [_vm._v("Filtrar por Placa")])]), _vm._v(" "), (_vm.showPlate) ? _c('div', {
	    staticClass: "form-group form-plate",
	    class: {
	      'has-error': _vm.errors.has('plate')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.plate),
	      expression: "plate"
	    }, {
	      name: "mask-plate",
	      rawName: "v-mask-plate"
	    }],
	    staticClass: "form-control plate-field upper",
	    attrs: {
	      "type": "search",
	      "name": "plate",
	      "placeholder": "Digite a Placa"
	    },
	    domProps: {
	      "value": (_vm.plate)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.doFilter(true)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.plate = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('plate')) + "\n            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "inline filter-button text-center"
	  }, [_c('button', {
	    staticClass: "btn btn-purple btn-sm btn-filter",
	    attrs: {
	      "type": "button",
	      "name": "btnFind"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.doFilter(true)
	      }
	    }
	  }, [_vm._v("\n            Filtrar\n          ")])])])])]), _vm._v(" "), (_vm.searchState == 'NOTFOUND') ? _c('div', {
	    staticClass: "alert alert-warning margin-t10"
	  }, [_vm._v("Nenhum dado encontrado no período.")]) : _vm._e(), _vm._v(" "), (_vm.searchState == 'ERROSEARCH') ? _c('div', {
	    staticClass: "alert alert-danger margin-t10"
	  }, [_c('ol', [_c('li', [_vm._v(_vm._s(_vm.messageError))])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [(_vm.searchState == 'FOUND') ? [_c('div', {
	    staticClass: "row margin-t20 resumo-table",
	    attrs: {
	      "id": "resumeTable"
	    }
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table no-footer",
	    attrs: {
	      "role": "grid"
	    }
	  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.listValePedagio), function(l, index) {
	    return _c('tr', {
	      class: {
	        red: l.idProtocoloCanc != null
	      },
	      attrs: {
	        "role": "row"
	      }
	    }, [_c('td', [_vm._v(_vm._s(l.idProtocolo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(l.embarcador))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTime")(l.dataEmissao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(l.expirationVP)))]), _vm._v(" "), _c('td', {
	      staticClass: "plate-box"
	    }, [_c('p', {
	      staticClass: "cell-plate"
	    }, [_c('a', [_c('span', [_vm._v(_vm._s(l.placaVeiculo))])])])]), _vm._v(" "), _c('td', {
	      staticClass: "text-right value"
	    }, [_vm._v(_vm._s(_vm._f("cents")(l.valorVP)))]), _vm._v(" "), _c('td', [_c('router-link', {
	      attrs: {
	        "to": {
	          name: 'summary-accompaniment',
	          params: {
	            contractId: _vm.contractId,
	            idVP: l.idIntern
	          }
	        },
	        "data-toggle": "tooltip",
	        "data-placement": "bottom",
	        "title": "Resumo do Vale-pedágio"
	      }
	    }, [_c('div', {
	      staticClass: "btn btn-icon"
	    }, [_c('i', {
	      staticClass: "icon-zoom-in2 bold"
	    })])]), _vm._v(" "), _c('router-link', {
	      attrs: {
	        "to": {
	          name: 'receipt',
	          params: {
	            contractId: _vm.contractId,
	            idVP: l.idIntern
	          }
	        },
	        "data-toggle": "tooltip",
	        "data-placement": "bottom",
	        "title": "Comprovante do Vale-pedágio"
	      }
	    }, [_c('div', {
	      staticClass: "btn btn-icon"
	    }, [_c('i', {
	      staticClass: "icon-paper bold"
	    })])])], 1)])
	  }), 0)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 text-center"
	  }, [_c('pagination', {
	    attrs: {
	      "model": _vm.page
	    },
	    on: {
	      "page-change": _vm.setCurrentPage
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 result-table-count text-center"
	  }, [_vm._v("\n            Mostrando resultados de " + _vm._s(_vm.page.firstIndexShown()) + " a " + _vm._s(_vm.page.lastIndexShown()) + " de um total de " + _vm._s(_vm.page.itemCount()) + "\n            encontrados.\n          ")])])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back margin-t20",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v(" Voltar\n      ")])], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title title-plans"
	  }, [_vm._v("Meus Vales-pedágio")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('b', [_c('i', {
	    staticClass: "icon-info",
	    attrs: {
	      "data-toggle": "tooltip",
	      "data-placement": "bottom",
	      "title": "A data de processamento que será considerada na filtragem."
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('b', [_c('i', {
	    staticClass: "icon-info",
	    attrs: {
	      "data-toggle": "tooltip",
	      "data-placement": "bottom",
	      "title": "A data de processamento que será considerada na filtragem."
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', {
	    attrs: {
	      "role": "row"
	    }
	  }, [_c('th', {
	    attrs: {
	      "width": "12%"
	    }
	  }, [_vm._v("N° Vale-pedágio")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "29%"
	    }
	  }, [_vm._v("Emissor")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "13%"
	    }
	  }, [_vm._v("Data de Emissão")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "13%"
	    }
	  }, [_vm._v("Data de Expiração")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "15%"
	    }
	  }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "10%"
	    }
	  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "8%"
	    }
	  })])])
	}]}

/***/ }),
/* 2099 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('p', {
	    staticClass: "aggregate-sub"
	  }, [_vm._v("Dados pessoais")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('taxIdNumber')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "taxIdNumber"
	    }
	  }, [_vm._v("CPF")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "mask-cpf",
	      rawName: "v-mask-cpf"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cpf'),
	      expression: "'required|cpf'"
	    }, {
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.taxIdNumberFormatted),
	      expression: "taxIdNumberFormatted",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "taxIdNumber",
	      "maxlength": "11"
	    },
	    domProps: {
	      "value": (_vm.taxIdNumberFormatted)
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.userExists()
	      },
	      "change": function($event) {
	        _vm.taxIdNumberFormatted = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n      " + _vm._s(_vm.errors.first('taxIdNumber')) + "\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('nome')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "nome"
	    }
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fullName),
	      expression: "fullName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "nome",
	      "maxlength": "50"
	    },
	    domProps: {
	      "value": (_vm.fullName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.fullName = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n      " + _vm._s(_vm.errors.first('nome')) + "\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('birthDate')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "birthDate"
	    }
	  }, [_vm._v("Nascimento")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.birthDateBR),
	      expression: "birthDateBR",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:10'),
	      expression: "'required|min:10'"
	    }, {
	      name: "mask-birth",
	      rawName: "v-mask-birth"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "birthDate"
	    },
	    domProps: {
	      "value": (_vm.birthDateBR)
	    },
	    on: {
	      "change": function($event) {
	        _vm.birthDateBR = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n      " + _vm._s(_vm.errors.first('birthDate')) + "\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "contact-box"
	  }, [_c('p', {
	    staticClass: "aggregate-sub"
	  }, [_vm._v("Contato")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('email')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "email"
	    },
	    domProps: {
	      "value": (_vm.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n      " + _vm._s(_vm.errors.first('email')) + "\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('celular')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "celular"
	    }
	  }, [_vm._v("Telefone celular")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "mask-tel",
	      rawName: "v-mask-tel"
	    }, {
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.cel),
	      expression: "cel",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|phone'),
	      expression: "'required|phone'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "celular",
	      "name": "celular",
	      "title": "celular",
	      "data-vv-validate-on": "blur",
	      "maxlength": "14"
	    },
	    domProps: {
	      "value": (_vm.cel)
	    },
	    on: {
	      "input": _vm.correctCursor2,
	      "change": function($event) {
	        _vm.cel = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n        " + _vm._s(_vm.errors.first('celular')) + "\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_vm._m(0), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "mask-tel",
	      rawName: "v-mask-tel"
	    }, {
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.tel),
	      expression: "tel",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('phone'),
	      expression: "'phone'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "telefone",
	      "name": "telefone",
	      "title": "telefone",
	      "data-vv-validate-on": "blur",
	      "maxlength": "14"
	    },
	    domProps: {
	      "value": (_vm.tel)
	    },
	    on: {
	      "input": _vm.correctCursor2,
	      "change": function($event) {
	        _vm.tel = $event.target.value
	      }
	    }
	  })])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "phone"
	    }
	  }, [_vm._v("Telefone fixo "), _c('span', [_vm._v("(opcional)")])])
	}]}

/***/ }),
/* 2100 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bg-for-business"
	  })
	},staticRenderFns: []}

/***/ }),
/* 2101 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 map-sidebar"
	  }, [_c('div', {
	    ref: "scrollContainer",
	    staticClass: "scroll-ajuste"
	  }, [_vm._l((_vm.locationPoints), function(w, i) {
	    return _c('input-ac', {
	      key: w.address + w.sequence,
	      attrs: {
	        "initLocation": w,
	        "sequence": i,
	        "totalPoints": _vm.locationPoints.length
	      },
	      on: {
	        "addPoint": _vm.addPoint,
	        "removePoint": _vm.removePoint,
	        "placeChanged": _vm.placeChanged
	      }
	    })
	  }), _vm._v(" "), (_vm.msgError) ? _c('div', {
	    staticClass: "alert alert-error margin-t10"
	  }, [_vm._v("\n          " + _vm._s(_vm.msgError) + "\n        ")]) : _vm._e()], 2), _vm._v(" "), (false) ? _c('div', [_c('label', {
	    staticClass: "block-round-trip"
	  }, [_vm._v("Ida e volta?")]), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "block-axis"
	  }, [_c('label', {
	    staticClass: "block-round-trip"
	  }, [_vm._v("Quantidade de eixos:")]), _vm._v(" "), _c('dropdown', {
	    staticClass: "dropdown-lg margin-t5",
	    attrs: {
	      "options": _vm.axesOp,
	      "value": _vm.axes,
	      "fieldValue": "category_artesp_id"
	    },
	    model: {
	      value: (_vm.axes),
	      callback: function($$v) {
	        _vm.axes = $$v
	      },
	      expression: "axes"
	    }
	  })], 1), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary btn-calculate",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.calculate
	    }
	  }, [_vm._v("\n        Calcular\n      ")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.showSummary) ? _c('div', {
	    staticClass: "result-calculate-trip"
	  }, [_c('ul', {
	    staticClass: "trip-summary-box"
	  }, [_c('li', [_c('i', {
	    staticClass: "icon-road"
	  }), _vm._v(" "), _c('label', {
	    staticClass: "trip-summary-label"
	  }, [_vm._v("Distância:")]), _vm._v(" "), _c('label', {
	    staticClass: "pull-right"
	  }, [_vm._v(_vm._s(_vm.result.totalDistance) + " Km")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "icon-clock"
	  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('label', {
	    staticClass: "pull-right"
	  }, [_vm._v(_vm._s(_vm._f("secondsFormat")(_vm.result.totalTime)))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "icon-toll"
	  }), _vm._v(" "), _c('label', {
	    staticClass: "trip-summary-label"
	  }, [_vm._v("Qtd. de Pedágios:")]), _vm._v(" "), _c('label', {
	    staticClass: "pull-right"
	  }, [_vm._v(_vm._s(_vm.result.tolls.length))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "icon-coin"
	  }), _vm._v(" "), _c('label', {
	    staticClass: "trip-summary-label"
	  }, [_vm._v("Valor Pedágios:")]), _vm._v(" "), _c('label', {
	    staticClass: "pull-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.result.totaltollFeeCost)))])])]), _vm._v(" "), (false) ? _c('div', {
	    staticClass: "bs-callout bs-callout-primary"
	  }, [_vm._v("\n          Sua viagem irá custar "), _c('b', [_vm._v(_vm._s(_vm._f("cents")(_vm.result.totaltollFeeCost)))]), _vm._v(" em\n          pedágios. Deseja fazer uma recarga?\n        ")]) : _vm._e(), _vm._v(" "), (false) ? _c('button', {
	    staticClass: "btn btn-success btn-recharge-fit"
	  }, [_vm._v("\n          Recarregar "), _c('b', [_vm._v("R$ 50,00")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8 map-area"
	  }, [_c('div', {
	    ref: "map",
	    attrs: {
	      "id": "map"
	    }
	  })]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": _vm.image
	    }
	  })])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("Viagem")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', {
	    staticClass: "margin-b20"
	  }, [_vm._v("\n          Calcule a distância, o tempo estimado e o custo de pedágios da sua\n          viagem, para isso é só preencher os campos abaixo e clicar em\n          calcular:\n        ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pull-right"
	  }, [_c('div', {
	    staticClass: "onoffswitch"
	  }, [_c('input', {
	    staticClass: "onoffswitch-checkbox",
	    attrs: {
	      "type": "checkbox",
	      "id": "round-switch"
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "onoffswitch-label",
	    attrs: {
	      "for": "round-switch"
	    }
	  }, [_c('span', {
	    staticClass: "onoffswitch-inner"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "onoffswitch-switch"
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "trip-summary-label"
	  }, [_vm._v("\n              Tempo Estimado:\n              "), _c('i', {
	    staticClass: "icon-info",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "O tempo é estimado usando como base um veículo de passeio (2 eixos) na velocidade média das vias."
	    }
	  })])
	}]}

/***/ }),
/* 2102 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "fade-in",
	      "appear": ""
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostrarModal),
	      expression: "mostrarModal"
	    }],
	    staticClass: "modal fade-in",
	    staticStyle: {
	      "z-index": "99999"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('span', {
	    staticClass: "close",
	    staticStyle: {
	      "position": "absolute",
	      "top": "10px",
	      "right": "10px"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.fecharModal()
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
	    staticClass: "header-content"
	  }, [_c('h2', [_vm._v("Mudança para padrão Mercosul")])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    staticClass: "information-container"
	  }, [_c('p', {
	    staticClass: "infoModal"
	  }, [_vm._v("\n            Placa alterada para o padrão Mercosul com sucesso!\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "close-button",
	    on: {
	      "click": function($event) {
	        return _vm.fecharModal()
	      }
	    }
	  }, [_vm._v("Fechar")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2103 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-mask"
	  }, [_c('div', {
	    staticClass: "modal-wrapper"
	  }, [_c('div', {
	    staticClass: "modal-container"
	  }, [_c('div', {
	    staticClass: "form-modal-header"
	  }, [_c('h1', {
	    class: _vm.type == '1' ? 'remove' : ''
	  }, [_vm._v("\n          " + _vm._s(_vm.type == "1" ? "EXCLUSÃO DE VEÍCULO!" : "Atenção!") + "\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(_vm.type == "1" ?
	    "Deseja excluir o veículo selecionado?" :
	    "Confirme se você digitou os dados do veículo corretamente:") + "\n        ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-modal-body"
	  }, [_c('div', {
	    staticClass: "form-modal-container"
	  }, [_c('div', {
	    staticClass: "form-placa-desc"
	  }, [_c('label', {
	    attrs: {
	      "for": "form-placa-desc"
	    }
	  }, [_vm._v("Placa")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "form-placa-conf"
	    }
	  }, [_c('span', {
	    attrs: {
	      "id": "plate-span"
	    }
	  }, [_vm._v(_vm._s(_vm.plateExibe))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-marca-desc"
	  }, [_c('h4', [_vm._v("\n              Marca "), _c('span', {
	    attrs: {
	      "id": "brand-name-modal"
	    }
	  }, [_vm._v(_vm._s(_vm.brand))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-model-desc"
	  }, [_c('div', {
	    staticClass: "model-text"
	  }, [_c('h4', [_vm._v("\n              Modelo "), _c('span', {
	    attrs: {
	      "id": "model-name-modal"
	    }
	  }, [_vm._v(_vm._s(_vm.model))])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-modal-footer"
	  }, [_c('button', {
	    class: _vm.type == '1' ? 'cancel' : '',
	    attrs: {
	      "id": "cancel"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('ClickHandlerCancel')
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.type == "1" ? "Fechar" : "Cancelar") + "\n        ")]), _vm._v(" "), _c('button', {
	    class: _vm.type == '1' ? 'remove' : '',
	    attrs: {
	      "id": "confirm"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('ClickHandlerContinue')
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.type == "1" ? "Excluir" : "Continuar") + "\n        ")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2104 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "row color-row-4"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "txt-row-4"
	  }, [_c('h3', [_vm._v("Se você não quer se preocupar com recargas ou saldo insuficiente, este é o seu plano.")]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "to": "/adesao?planId=22",
	      "tag": "button"
	    }
	  }, [_vm._v("\n          Quero este plano!\n        ")])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back",
	    attrs: {
	      "to": "/servicos-b2c"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n        Voltar para planos\n      ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8 text-right padding-left-zero"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back",
	    attrs: {
	      "to": "/servicos-b2c-plano-controle"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n        Ver plano anterior\n      ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-back back-plan",
	    attrs: {
	      "to": "/servicos-b2c-plano-controle"
	    }
	  }, [_vm._v("\n        Ver próximo plano\n        "), _c('i', {
	    staticClass: "icon-circle-right align-icon-right"
	  })])], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("Serviços para Você")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-b10"
	  }, [_c('h3', {
	    staticClass: "bold upper"
	  }, [_vm._v("Plano Pré-pago Automático")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row color-row-1"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('div', {
	    staticClass: "txt-row-1"
	  }, [_c('span', [_vm._v("No "), _c('b', [_vm._v("PRÉ-PAGO AUTOMÁTICO")]), _vm._v(" você determina qual vai ser o valor da recarga automática (R$ 50,00 por exemplo), e toda vez que o seu saldo atingir 40% desse valor (no caso de R$ 50,00 será R$ 20,00), nós realizamos uma nova recarga automaticamente para você.")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "recharge-auto"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row color-row-2"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "payment-methods-confort"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "txt-row-2"
	  }, [_c('p', [_vm._v("A recarga automática é feita pela forma de pagamento que você cadastrou.")]), _vm._v(" "), _c('p', [_vm._v("Nossa taxa é a "), _c('b', [_vm._v("menor do mercado")]), _vm._v(" e quanto maior o valor da recarga menor é a porcentagem da taxa de recarga.")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row color-row-3"
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "txt-row-3"
	  }, [_c('span', [_vm._v("Você pode ainda consultar "), _c('b', [_vm._v("saldos")]), _vm._v(", "), _c('b', [_vm._v("extratos")]), _vm._v(" e "), _c('b', [_vm._v("geolocalização dos veículos")]), _vm._v(" diretamente no nosso site ou no app para mobile (Android e iOS).")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "gps-vehicle"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "confort-couch"
	  })])
	}]}

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("\n        Planos\n        "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n        Contrato " + _vm._s(_vm.contractId) + "\n      ")])], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "min-content"
	  }, [(_vm.contract) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-box margin-t20"
	  }, [_c('b', {
	    staticClass: "title-identification margin-b10"
	  }, [_vm._v("\n            " + _vm._s(_vm.contract.plan.name) + "\n            "), (!_vm.isPessoaJuridica()) ? _c('a', {
	    staticClass: "label-link",
	    attrs: {
	      "href": "/api/v2/archeion/downloadFileArcheion/termos-e-condicoes-gerais-movemais",
	      "target": "_blank"
	    }
	  }, [_vm._v("Ver as\n              Condições Gerais de Contratação")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "info-box-left"
	  }, [_c('p', [_c('label', {
	    staticClass: "label-detail"
	  }, [_vm._v("Ativação do Contrato:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("date")(_vm.contract.startDate)))])]), _vm._v(" "), _c('p', [_c('label', {
	    staticClass: "label-detail"
	  }, [_vm._v("Encerramento do Contrato:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.contract.endDate ? _vm.contract.endDate : '-'))])]), _vm._v(" "), _c('p', [_c('label', {
	    staticClass: "label-detail"
	  }, [_vm._v("Status do Contrato:")]), _vm._v(" "), _c('b', [_vm._v("\n                        " + _vm._s(_vm.contract.status.name) + "\n                        "), _c('span', {
	    class: _vm.contract.status.name == 'ATIVO' ? 'status-active' : 'status-inactive'
	  })])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.contract.plan.planId == 21 || _vm.contract.plan.planId == 28 || _vm.contract.plan.planId == 31) ? _c('div', [(_vm.contract.plan.planId == 21 || _vm.contract.plan.planId == 31) ? _c('div', [_c('label', {
	    staticClass: "label-detail"
	  }, [_vm._v("Ativar Alerta de Saldo: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "onoffswitch",
	    attrs: {
	      "id": "ptoAlm1"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contract.lcFlag),
	      expression: "contract.lcFlag"
	    }],
	    staticClass: "onoffswitch-checkbox",
	    attrs: {
	      "type": "checkbox",
	      "id": "round-switch"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.contract.lcFlag) ? _vm._i(_vm.contract.lcFlag, null) > -1 : (_vm.contract.lcFlag)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.contract.lcFlag,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.contract, "lcFlag", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.contract, "lcFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.contract, "lcFlag", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('input', {
	    staticClass: "inline form-control text-right",
	    attrs: {
	      "id": "limitValue",
	      "minlength": "5",
	      "maxlength": "10",
	      "type": "text",
	      "disabled": ""
	    },
	    domProps: {
	      "value": _vm.valueFormatted()
	    }
	  })])]) : (_vm.contract.plan.planId == 28) ? _c('div', [_c('label', {
	    staticClass: "label-detail-left"
	  }, [_vm._v("Alterar percentual de alerta de consumo de limite:")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "ptoAlm2"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contract.limitCredit),
	      expression: "contract.limitCredit"
	    }, {
	      name: "only-numbers",
	      rawName: "v-only-numbers"
	    }],
	    staticClass: "inline form-control text-right col-md-2",
	    attrs: {
	      "minlength": "1",
	      "maxlength": "2",
	      "type": "text",
	      "placeholder": "Digite o percentual",
	      "disabled": !_vm.contract.lcFlag
	    },
	    domProps: {
	      "value": (_vm.contract.limitCredit)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contract, "limitCredit", $event.target.value)
	      }, function($event) {
	        return _vm.setLimitValue($event.target.value)
	      }]
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "label-detail-left"
	  }, [_vm._v("Obs.: O percentual permitido é de 1% a 80%")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success btn-sm",
	    attrs: {
	      "id": "lc-confirma",
	      "data-toggle": "tooltip",
	      "title": "Confirma Alteração"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.getUpdateAlert()
	      }
	    }
	  }, [_vm._v("\n                        Confirma\n                      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.contract.plan.planId == 28 || _vm.contract.plan.planId == 30) ? _c('div', [_c('p', [_c('label', {
	    staticClass: "label-detail"
	  }, [_vm._v("Valor da Mensalidade:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("cents")(_vm.contract.monthlyTax)))])]), _vm._v(" "), _c('p', [_c('label', {
	    staticClass: "label-detail"
	  }, [_vm._v("Taxa de Adesão:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("cents")(_vm.contract.adhesionTax)))])]), _vm._v(" "), _c('p', [_c('label', {
	    staticClass: "label-detail"
	  }, [_vm._v("Taxa de Substituição:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("cents")(_vm.contract.replaceTax)))])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.invoice || _vm.contract.plan.planId == 28 || _vm.contract.plan.planId == 8) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "info-box"
	  }, [(_vm.contract.plan.planId == 28 || _vm.contract.plan.planId == 8) ? _c('p', [_c('label', {
	    staticClass: "label-detail"
	  }, [_vm._v("Limite de crédito:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("cents")(_vm.contract.currentBalance.creditLimit)))])]) : _vm._e(), _vm._v(" "), (_vm.contract.plan.planId == 28 || _vm.contract.plan.planId == 8) ? _c('p', [_c('label', {
	    staticClass: "label-detail"
	  }, [_vm._v("Dia(s) de Vencimento:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.vencimentos()))])]) : _vm._e(), _vm._v(" "), (_vm.invoice) ? _c('p', [_c('label', {
	    staticClass: "label-detail"
	  }, [_vm._v("Fechamento da Fatura:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("date")(_vm.invoice.endValidity)))])]) : _vm._e(), _vm._v(" "), (_vm.invoice) ? _c('p', [_c('label', {
	    staticClass: "label-detail"
	  }, [_vm._v("Vencimento da Fatura:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("date")(_vm.invoice.expiration)))])]) : _vm._e(), _vm._v(" "), (_vm.invoice) ? _c('p', [_c('label', {
	    staticClass: "label-detail"
	  }, [_vm._v("Valor da Última Fatura:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("cents")(_vm.invoice.total)))])]) : _vm._e(), _vm._v(" "), (_vm.isGrouper === true) ? _c('div', {
	    staticClass: "table-container"
	  }, [_c('table', {
	    staticClass: "table stripped-odd no-footer desk",
	    attrs: {
	      "role": "grid"
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.groupers), function(grouper) {
	    return _c('tr', {
	      key: grouper.idAgrupadorCliente
	    }, [_c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(grouper.nome))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(grouper.descricao))]), _vm._v(" "), _c('td', {
	      staticClass: "icons"
	    }, [_c('img', {
	      attrs: {
	        "width": "16px",
	        "src": __webpack_require__(225),
	        "alt": "Editar"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.openEditModal(grouper.nome, grouper.descricao, grouper.idAgrupadorCliente)
	        }
	      }
	    })])])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.isAddModalVisible) ? _c('div', [_c('div', {
	    staticClass: "modal-backdrop fade show"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "modal show",
	    staticStyle: {
	      "display": "block"
	    },
	    attrs: {
	      "role": "dialog"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.addGrouper.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "grouperName"
	    }
	  }, [_vm._v("Nome do Agrupador")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newGrouperName),
	      expression: "newGrouperName"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "grouperName",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.newGrouperName)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newGrouperName = $event.target.value
	      }, function($event) {
	        _vm.newGrouperName = _vm.mascaraApenasLetrasEAcentos(_vm.newGrouperName)
	      }]
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "grouperDescription"
	    }
	  }, [_vm._v("Descrição")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newGrouperDescription),
	      expression: "newGrouperDescription"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "grouperDescription",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.newGrouperDescription)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newGrouperDescription = $event.target.value
	      }, function($event) {
	        _vm.newGrouperDescription = _vm.mascaraApenasLetrasEAcentos(_vm.newGrouperDescription)
	      }]
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "display": "flex",
	      "justify-content": "flex-end",
	      "padding": "0.5rem 0"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-sm",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.closeAddModal
	    }
	  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success btn-sm",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Adicionar")])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.isEditModalVisible) ? _c('div', [_c('div', {
	    staticClass: "modal-backdrop fade show"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "modal show",
	    staticStyle: {
	      "display": "block"
	    },
	    attrs: {
	      "role": "dialog"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.submitEdit.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "editName"
	    }
	  }, [_vm._v("Nome do Agrupador")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editGrouperName),
	      expression: "editGrouperName"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "editName",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.editGrouperName)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.editGrouperName = $event.target.value
	      }, function($event) {
	        _vm.editGrouperName = _vm.mascaraApenasLetrasEAcentos(_vm.editGrouperName)
	      }]
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "editDescription"
	    }
	  }, [_vm._v("Descrição")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editGrouperDescription),
	      expression: "editGrouperDescription"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "editDescription",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.editGrouperDescription)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.editGrouperDescription = $event.target.value
	      }, function($event) {
	        _vm.editGrouperDescription = _vm.mascaraApenasLetrasEAcentos(_vm.editGrouperDescription)
	      }]
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "display": "flex",
	      "justify-content": "flex-end",
	      "padding": "0.5rem 0"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-sm",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.closeEditModal
	    }
	  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success btn-sm",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Salvar")])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.isGrouper === true) ? _c('div', {
	    staticClass: "add"
	  }, [_c('img', {
	    attrs: {
	      "width": "20px",
	      "src": __webpack_require__(1771),
	      "alt": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.openAddModal()
	      }
	    }
	  }), _vm._v("Novo Agrupador\n                    ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "info-box"
	  }, [(_vm.planHasRecharge(_vm.contract.plan.planId) && _vm.contract.plan.planId != 45) ? _c('p', [_c('label', {
	    staticClass: "label-detail"
	  }, [_vm._v("Saldo:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("cents")(_vm.contract.currentBalance.currentBalance)))]), _vm._v(" "), (_vm.contract.status.contractStatusId != 0) ? _c('router-link', {
	    staticClass: "btn btn-success btn-sm recharge",
	    class: {
	      'disabled': !_vm.checkVehicle
	    },
	    attrs: {
	      "to": {
	        name: 'contract-recharge',
	        params: {
	          contractId: _vm.contractId,
	          planId: _vm.contract.plan.planId
	        }
	      },
	      "tag": "button",
	      "data-toggle": "tooltip",
	      "title": "Fazer uma recarga manual",
	      "disabled": !_vm.checkVehicle || (_vm.contract.status.contractStatusId != 1 && _vm.contract.status.contractStatusId != 5)
	    }
	  }, [_vm._v("\n                        Recarregar\n                        "), _c('i', {
	    staticClass: "icon-coin align-icon-right-white"
	  })]) : _c('button', {
	    staticClass: "btn btn-success btn-sm recharge",
	    class: {
	      'disabled': !_vm.checkVehicle
	    },
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "Fazer uma recarga manual",
	      "disabled": !_vm.checkVehicle
	    },
	    on: {
	      "click": function($event) {
	        return _vm.showMessageContract()
	      }
	    }
	  }, [_vm._v("\n                        Recarregar\n                        "), _c('i', {
	    staticClass: "icon-coin align-icon-right-white"
	  })])], 1) : _vm._e(), _vm._v(" "), (_vm.planHasAutRecharge(_vm.contract.plan.planId) && _vm.contract.plan.planId != 45) ? _c('p', {
	    staticClass: "alt-value"
	  }, [_c('label', {
	    staticClass: "label-detail"
	  }, [_vm._v("Rec. Automática")]), _vm._v(" "), (_vm.getRechargeAut) ? _c('b', [_vm._v(_vm._s(_vm._f("cents")(_vm.getRechargeAut)))]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-back btn-sm",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.openModalRecharge(_vm.contract.contractId)
	      }
	    }
	  }, [_vm._v("\n                        Alterar Valor\n                        "), _c('i', {
	    staticClass: "icon-coin align-icon-right"
	  })])]) : _vm._e()])])])])])])]), _vm._v(" "), (_vm.planId == 32 && _vm.modalRecharge[_vm.contract.contractId]) ? _c('modal-automatic', {
	    attrs: {
	      "contract": _vm.contract
	    },
	    on: {
	      "closeModalRecharge": _vm.closeModalRecharge
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.planId != 32 && _vm.modalRecharge[_vm.contract.contractId]) ? _c('modal-recharge', {
	    attrs: {
	      "contract": _vm.contract
	    },
	    on: {
	      "closeModalRecharge": _vm.closeModalRecharge
	    }
	  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back margin-t20",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n        Voltar\n      ")])], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "onoffswitch-label",
	    attrs: {
	      "for": "round-switch"
	    }
	  }, [_c('span', {
	    staticClass: "onoffswitch-inner"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "onoffswitch-switch"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "text-center"
	  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center"
	  }, [_vm._v("Descrição")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center"
	  }, [_vm._v("Ações")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('h5', {
	    staticClass: "modal-title"
	  }, [_vm._v("Adicionar Agrupador")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('h5', {
	    staticClass: "modal-title"
	  }, [_vm._v("Editar Agrupador")])])
	}]}

/***/ }),
/* 2106 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "plan-name-box"
	  }, [_c('b', {
	    staticClass: "contract-number"
	  }, [_vm._v(_vm._s(_vm.contractId) + " -")]), _vm._v(" "), _c('div', {
	    staticClass: "editable"
	  }, [(_vm.editing) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newValue),
	      expression: "newValue"
	    }],
	    staticClass: "form-control plan-label-input",
	    attrs: {
	      "name": "name"
	    },
	    domProps: {
	      "value": (_vm.newValue)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newValue = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "plan-name-box-edit",
	    on: {
	      "click": _vm.edit
	    }
	  }, [(!_vm.editing) ? _c('div', {
	    staticClass: "edit-header",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "Editar o nome do plano"
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.newValue) + "\n      ")]) : _vm._e()]), _vm._v(" "), (_vm.currentBalance) ? _c('p', {
	    staticClass: "balance-box"
	  }, [_c('span', [_vm._v("Saldo: ")]), _vm._v(" "), _c('span', {
	    staticClass: "bold",
	    class: _vm.currentBalance >= 0 ? 'green' : 'red'
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.currentBalance)))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "inline",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "Cancelar edição"
	    },
	    on: {
	      "click": _vm.cancel
	    }
	  }, [(_vm.editing && !_vm.loading) ? _c('i', {
	    staticClass: "icon-cancel-edit"
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "inline",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "Salvar edição"
	    },
	    on: {
	      "click": _vm.confirm
	    }
	  }, [(_vm.editing && !_vm.loading) ? _c('i', {
	    staticClass: "icon-check-edit"
	  }) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),
/* 2107 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.code > 0) ? _c('div', {
	    staticClass: "success"
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [(!this.boletoUrl) ? _c('div', {
	    staticClass: "error-box text-center"
	  }, [_c('h1', {
	    staticClass: "bold"
	  }, [_vm._v("Oops!")]), _vm._v(" "), _c('p', {
	    staticClass: "bold"
	  }, [_vm._v("Alguma coisa deu errada!")]), _vm._v(" "), (_vm.cmpId === 120) ? _c('p', {
	    staticClass: "margin-20 line-height-20"
	  }, [_vm._v("No momento um dos canais de finalização está indisponível. Tente novamente mais tarde ou entre em contato com a Central de Relacionamento.")]) : [(_vm.validacaoFraude && _vm.type == 'newVehicle') ? _c('p', {
	    staticClass: "margin-20 line-height-20"
	  }, [_vm._v("Não foi possível concluir sua compra. Por favor, entre em contato com nossa Central de Relacionamento, através dos números 4000 2901 (Capitais e regiões metropolitanas) e 0800 777 1022 (Demais localidades).")]) : (!_vm.validacaoFraude && _vm.type == 'newVehicle') ? _c('p', {
	    staticClass: "margin-20 line-height-20"
	  }, [_vm._v("Não foi possível confirmar o pagamento da sua adesão, por favor verifique os dados do seu cartão.")]) : _vm._e(), _vm._v(" "), (_vm.validacaoFraude && _vm.type == 'newContract') ? _c('p', {
	    staticClass: "margin-20 line-height-20"
	  }, [_vm._v("Não foi possível concluir sua compra. Por favor, entre em contato com nossa Central de Relacionamento, através dos números 4000 2901 (Capitais e regiões metropolitanas) e 0800 777 1022 (Demais localidades).")]) : (!_vm.validacaoFraude && _vm.type == 'newContract') ? _c('p', {
	    staticClass: "margin-20 line-height-20"
	  }, [_vm._v("Não foi possível concluir sua solicitação. Tente novamente ou entre em contato com a Central de Relacionamento.")]) : _vm._e(), _vm._v(" "), (_vm.validacaoFraude && _vm.type == 'adhesion') ? _c('p', {
	    staticClass: "margin-20 line-height-20"
	  }, [_vm._v("Não foi possível concluir sua compra. Por favor, entre em contato com nossa Central de Relacionamento, através dos números 4000 2901 (Capitais e regiões metropolitanas) e 0800 777 1022 (Demais localidades).")]) : (!_vm.validacaoFraude && _vm.type == 'adhesion') ? _c('p', {
	    staticClass: "margin-20 line-height-20"
	  }, [_vm._v("Não foi possível concluir sua adesão. Tente novamente ou entre em contato com a Central de Relacionamento.")]) : _vm._e(), _vm._v(" "), (_vm.type == 'replaceTag') ? _c('p', {
	    staticClass: "margin-20 line-height-20"
	  }, [_vm._v("Não foi possível concluir a substituição do TAG. Tente novamente ou entre em contato com a Central de Relacionamento.")]) : _vm._e(), _vm._v(" "), (_vm.validacaoFraude && _vm.type == 'recharge') ? _c('p', {
	    staticClass: "margin-20 line-height-20"
	  }, [_vm._v("Não foi possível concluir sua compra. Por favor, entre em contato com nossa Central de Relacionamento, através dos números 4000 2901 (Capitais e regiões metropolitanas) e 0800 777 1022 (Demais localidades).")]) : (!_vm.validacaoFraude && _vm.type == 'recharge') ? _c('p', {
	    staticClass: "margin-20 line-height-20"
	  }, [_vm._v("Não foi possível concluir sua recarga. Tente novamente ou entre em contato com a Central de Relacionamento.")]) : _vm._e(), _vm._v(" "), (_vm.validacaoFraude && _vm.type == 'reprocess') ? _c('p', {
	    staticClass: "margin-20 line-height-20"
	  }, [_vm._v("Não foi possível concluir sua compra. Por favor, entre em contato com nossa Central de Relacionamento, através dos números 4000 2901 (Capitais e regiões metropolitanas) e 0800 777 1022 (Demais localidades).")]) : (!_vm.validacaoFraude && _vm.type == 'reprocess') ? _c('p', {
	    staticClass: "margin-20 line-height-20"
	  }, [_vm._v("Não foi possível reprocessar seu pedido. Tente novamente.")]) : _vm._e()], _vm._v(" "), _c('div', {
	    staticClass: "text-center margin-30"
	  }, [(_vm.type == 'adhesion') ? _c('button', {
	    staticClass: "btn btn-purple",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.doLogin()
	      }
	    }
	  }, [_vm._v("\n                Reprocessar\n              ")]) : (_vm.type == 'reprocess') ? _c('button', {
	    staticClass: "btn btn-purple",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.paraPedidosReprocessamento()
	      }
	    }
	  }, [_vm._v("\n                Reprocessar\n              ")]) : _c('button', {
	    staticClass: "btn btn-purple",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.paraPedidos()
	      }
	    }
	  }, [_vm._v("\n                Reprocessar\n              ")])])], 2) : _c('div', {
	    staticClass: "error-box text-center"
	  }, [_c('h1', {
	    staticClass: "bold"
	  }, [_vm._v("Oops!")]), _vm._v(" "), (this.msgErrorResp) ? _c('p', {
	    staticClass: "margin-20 line-height-20"
	  }, [_vm._v(_vm._s(this.msgErrorResp))]) : _c('p', {
	    staticClass: "margin-20 line-height-20"
	  }, [_vm._v("Não foi possível gerar o boleto da sua compra. Por favor, entre em contato com nossa Central de Relacionamento, através dos números 4000 2901 (Capitais e regiões metropolitanas) e 0800 777 1022 (Demais localidades).")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-purple",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.paraPlanos()
	      }
	    }
	  }, [_vm._v("\n            Voltar\n          ")])])])])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2108 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container",
	    attrs: {
	      "id": "vehicles"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("\n        Planos\n        "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Contrato " + _vm._s(_vm.contractId) + "\n        "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Veículos\n        "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Sistema ponto a ponto\n      ")]), _vm._v(" "), _vm._m(0)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "search",
	    staticStyle: {
	      "display": "none"
	    }
	  }, [_c('div', {
	    staticClass: "search-cell not-visible"
	  }, [_c('i', {
	    staticClass: "icon-search-input"
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filter),
	      expression: "filter"
	    }],
	    staticClass: "form-control input-search",
	    attrs: {
	      "type": "search",
	      "name": "",
	      "value": "",
	      "placeholder": "Buscar"
	    },
	    domProps: {
	      "value": (_vm.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.filter = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (_vm.state == 'LOADING') ? _c('div', {
	    staticClass: "margin-t20"
	  }, [_vm._v("\n        Carregando veículos. Aguarde...\n      ")]) : _vm._e(), _vm._v(" "), (_vm.state == 'LOADED' && _vm.data.itens.length == 0) ? _c('div', {
	    staticClass: "alert alert-warning margin-t20"
	  }, [_vm._v("\n        Nenhum veículo encontrado.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.data && _vm.data.itens && _vm.data.itens.length > 0) ? [_c('div', {
	    staticClass: "margin-t20 table-white-header",
	    staticStyle: {
	      "min-height": "100px"
	    }
	  }, [_c('table', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "table stripped-odd no-footer",
	    attrs: {
	      "role": "grid"
	    }
	  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.data.itens), function(itens) {
	    return _c('tr', [_c('td', {
	      staticStyle: {
	        "text-align": "center"
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.vehiclesChecked),
	        expression: "vehiclesChecked"
	      }],
	      staticClass: "check-p-to-p",
	      attrs: {
	        "id": itens.vehicleId,
	        "type": "checkbox"
	      },
	      domProps: {
	        "value": itens.vehicleId,
	        "checked": Array.isArray(_vm.vehiclesChecked) ? _vm._i(_vm.vehiclesChecked, itens.vehicleId) > -1 : (_vm.vehiclesChecked)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.tooglePtoP(itens)
	        },
	        "change": function($event) {
	          var $$a = _vm.vehiclesChecked,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = itens.vehicleId,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.vehiclesChecked = $$a.concat([$$v]))
	            } else {
	              $$i > -1 && (_vm.vehiclesChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.vehiclesChecked = $$c
	          }
	        }
	      }
	    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(itens.modelName))]), _vm._v(" "), _c('td', {
	      staticClass: "cell-plate"
	    }, [_c('div', [_vm._v("\n                  " + _vm._s(itens.plate) + "\n                ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(itens.categoryAxesName))])])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 text-center"
	  }, [_c('pagination', {
	    attrs: {
	      "model": _vm.page
	    },
	    on: {
	      "page-change": _vm.setCurrentPage
	    }
	  })], 1)]), _vm._v(" "), (_vm.data && _vm.data.vehicleList && _vm.data.vehicleList.vehicle) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 result-table-count text-center"
	  }, [_vm._v("\n            Mostrando resultados de " + _vm._s(_vm.page.firstIndexShown()) + "\n            a " + _vm._s(_vm.page.lastIndexShown()) + " de um total de " + _vm._s(_vm.page.itemCount()) + "\n            encontrados.\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back margin-t20",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n              Voltar\n            ")])], 1)])] : _vm._e()], 2)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "margin-t30"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n          O Sistema Ponto a Ponto é uma nova modalidade de cobrança de pedágio nas Rodovias Paulistas, feita de forma eletrônica\n          e com base no trecho percorrido pelo motorista. Funciona através de pórticos com antenas distribuídos ao longo da\n          rodovia que fazem a leitura dos dispositivos instalados e o valor cobrado do usuário será de acordo com o trecho\n          percorrido.\n        ")]), _vm._v(" "), _c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n          A adesão ao sistema Ponto a Ponto é feita por veículo, podendo um cliente possuir veículos com ou sem adesão ao\n          sistema Ponto a Ponto.\n        ")]), _vm._v(" "), _c('p', {
	    staticClass: "line-height-20"
	  }, [_c('b', [_vm._v("Regra de Cancelamento:")]), _vm._v(" O cliente pode solicitar o cancelamento ao sistema Ponto a Ponto a qualquer momento.\n          Após o cancelamento, o cliente deve aguardar pelo menos 30 dias para solicitar a adesão novamente do veículo.\n        ")]), _vm._v(" "), _c('p', {
	    staticClass: "line-height-20"
	  }, [_c('b', [_vm._v("Onde funciona?")]), _c('br'), _vm._v("\n          O Ponto a Ponto funciona nas rodovias Engenheiro Constâncio Cintra (SP-360), Santos Dumont (SP-75),\n          Governador Adhemar Pereira de Barros (SP-340) e na Rodovia Prof. Zeferino Vaz (SP 332).\n        ")]), _vm._v(" "), _c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n          Para solicitar o cadastramento nas rodovias SP075, SP332 e SP360, entre em contato com a concessionária.\n        ")]), _vm._v(" "), _c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n          O Ponto a Ponto na SP340 é aberto para qualquer usuário e qualquer veículo que trafegue na rodovia.\n        ")]), _vm._v(" "), _c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n          Para mais informações sobre o Ponto a Ponto consulte:\n          "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "http://www.artesp.sp.gov.br/Style%20Library/extranet/rodovias/sistema-ponto-a-ponto.aspx"
	    }
	  }, [_vm._v("http://www.artesp.sp.gov.br/Style%20Library/extranet/rodovias/sistema-ponto-a-ponto.aspx")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn btn-purple btn-search not-visible",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-plus"
	  }), _vm._v(" adicionar veículo")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', {
	    attrs: {
	      "role": "row"
	    }
	  }, [_c('th', {
	    staticStyle: {
	      "width": "15%"
	    }
	  }, [_vm._v("Ponto a ponto SP340")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "27%"
	    }
	  }, [_vm._v("Modelo")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    staticStyle: {
	      "width": "8em"
	    }
	  }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "20%"
	    }
	  }, [_vm._v("Eixos")])])])
	}]}

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    attrs: {
	      "id": "FooterSite"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "mainFooterContainer"
	    }
	  }, [_c('section', [_c('div', {
	    staticClass: "topicoFooterContainer"
	  }, [_c('h1', [_vm._v("Dúvidas?")]), _vm._v(" "), _c('ul', {
	    staticClass: "ulFooter"
	  }, [_c('li', [_c('router-link', {
	    staticClass: "scrollup",
	    attrs: {
	      "to": {
	        name: 'FAQ'
	      }
	    }
	  }, [_vm._v("\n              FAQ (Perguntas Frequentes)\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    staticClass: "scrollup",
	    attrs: {
	      "to": {
	        name: 'guide'
	      }
	    }
	  }, [_vm._v("\n              Guia de Instalação do TAG\n            ")])], 1), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "topicoFooterContainer"
	  }, [_c('h1', [_vm._v("Minha Conta")]), _vm._v(" "), _c('ul', {
	    staticClass: "ulFooter"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'plans'
	      }
	    }
	  }, [_vm._v(" Planos ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'requests'
	      },
	      "tag": "a"
	    }
	  }, [_vm._v("\n              Pedidos\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'tag-activate'
	      },
	      "tag": "a"
	    }
	  }, [_vm._v("\n              Ativar TAG\n            ")])], 1)])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
	    staticClass: "container-certificados"
	  }, [(
	    (_vm.selos[0] && _vm.selos[0].svg) ||
	    (_vm.selos[1] && _vm.selos[1].svg) ||
	    (_vm.selos[2] && _vm.selos[2].svg)
	  ) ? _c('div', {
	    staticClass: "wrapper-certificado"
	  }, [_c('p', {
	    attrs: {
	      "id": "title"
	    }
	  }, [_vm._v("Certificações ISO")]), _vm._v(" "), _c('div', {
	    staticClass: "certificados"
	  }, [(_vm.selos[0] && _vm.selos[0].svg) ? _c('div', [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.selos[0].svg)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.selos[1] && _vm.selos[1].svg) ? _c('div', [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.selos[1].svg)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.selos[2] && _vm.selos[2].svg) ? _c('div', [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.selos[2].svg)
	    }
	  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.selos[3] && _vm.selos[3].svg) ? _c('div', {
	    staticClass: "wrapper-certificado"
	  }, [_c('p', {
	    attrs: {
	      "id": "title"
	    }
	  }, [_vm._v("Selo MESC")]), _vm._v(" "), _c('div', {
	    staticClass: "certificados",
	    staticStyle: {
	      "display": "flex",
	      "justify-content": "center",
	      "align-items": "center"
	    }
	  }, [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.selos[3].svg)
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.selos[4] && _vm.selos[4].svg) ? _c('div', {
	    staticClass: "wrapper-certificado"
	  }, [_c('p', {
	    attrs: {
	      "id": "title"
	    }
	  }, [_vm._v("Reclame Aqui")]), _vm._v(" "), _c('div', {
	    staticClass: "certificados"
	  }, [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.selos[4].svg)
	    }
	  })])]) : _vm._e(), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _vm._m(7)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "suporteContainer"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "IconeCentralContainer"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1808)
	    }
	  }), _vm._v(" "), _c('h1', [_vm._v("CENTRAL DE RELACIONAMENTO")])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "numeroFooterContainer"
	    }
	  }, [_c('h1', [_vm._v("\n        Capitais e regiões metropolitanas\n        "), _c('span', {
	    staticClass: "numeroFooter"
	  }, [_vm._v("4000 2901")]), _vm._v(" ou\n        "), _c('span', {
	    staticClass: "numeroFooter"
	  }, [_vm._v("0800 777 1022")]), _vm._v(" demais localidades\n      ")])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "emailFooterContainer"
	    }
	  }, [_c('h1', [_vm._v("\n        E-mail:\n        "), _c('span', {
	    staticClass: "numeroFooter"
	  }, [_c('a', {
	    attrs: {
	      "href": "mailto:relacionamento@movemais.com"
	    }
	  }, [_vm._v("relacionamento@movemais.com")])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    attrs: {
	      "href": "/api/v2/archeion/downloadFileArcheion/tabela-de-tarifas-movemais",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n              Tarifas Move Mais\n            ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "topicoFooterContainer"
	  }, [_c('h1', [_vm._v("Políticas")]), _vm._v(" "), _c('ul', {
	    staticClass: "ulFooter"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "/api/v2/archeion/downloadFileArcheion/termos-e-condicoes-gerais-movemais",
	      "target": "_blank",
	      "title": "Termos e Condições"
	    }
	  }, [_vm._v("\n              Termos e Condições\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "/api/v2/archeion/downloadFileArcheion/aviso-de-privacidade-movemais",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n              Aviso de Privacidade\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "/api/v2/archeion/downloadFileArcheion/politica-de-cookies-movemais",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n              Política de Cookies\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "/api/v2/archeion/downloadFileArcheion/politica-de-reembolso-movemais",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n              Política de Reembolso\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "/api/v2/archeion/downloadFileArcheion/politica-da-qualidade-movemais",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n              Política da Qualidade\n            ")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "topicoFooterContainer"
	  }, [_c('h1', [_vm._v("Compliance")]), _vm._v(" "), _c('ul', {
	    staticClass: "ulFooter"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "/api/v2/archeion/downloadFileArcheion/codigo-de-conduta-movemais",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n              Código de Conduta\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://www.contatoseguro.com.br/movemais",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n              Canal de Ética\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "/api/v2/archeion/downloadFileArcheion/requisitos-pre-aprovacao-provedores-externos-movemais",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n              Requisitos Fornecedores\n            ")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "topicoFooterContainer"
	  }, [_c('h1', [_vm._v("Formas de Pagamento")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "bandeirasContainer"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1803)
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(1804)
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(1802)
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(1805)
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "wrapper"
	  }, [_c('div', {
	    staticClass: "iconesFooter"
	  }, [_c('p', {
	    attrs: {
	      "id": "title"
	    }
	  }, [_vm._v("Consumidor")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "consumidorContainer"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://consumidor.gov.br",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1810),
	      "id": "consumidor"
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "iconesFooter"
	  }, [_c('p', {
	    attrs: {
	      "id": "title"
	    }
	  }, [_vm._v("Certificado")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "certificadoContainer"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1813),
	      "id": "certificado"
	    }
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "iconesContainer"
	    }
	  }, [_c('div', {
	    staticClass: "iconesFooter"
	  }, [_c('h1', [_vm._v("Baixe nosso App")]), _vm._v(" "), _c('div', [_c('a', {
	    attrs: {
	      "href": "https://apps.apple.com/br/app/move-mais-ped%C3%A1gio-free-flow/id6747896915",
	      "target": "_blank",
	      "id": "appStoreContainer"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1801)
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://play.google.com/store/apps/details?id=com.movemais.morfeu",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1807)
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "redesContainer"
	    }
	  }, [_c('h1', [_vm._v("Acompanhe-nos")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "redesSociaisContainer"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://www.facebook.com/MoveMais/",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    staticClass: "iconesRedes",
	    attrs: {
	      "src": __webpack_require__(1811)
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://www.instagram.com/movemais/",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    staticClass: "iconesRedes",
	    attrs: {
	      "src": __webpack_require__(1809)
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://www.linkedin.com/company/move-mais/",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    staticClass: "iconesRedes",
	    attrs: {
	      "src": __webpack_require__(1812)
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://www.youtube.com/user/movemais",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    staticClass: "iconesRedes",
	    attrs: {
	      "src": __webpack_require__(1814)
	    }
	  })])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "footerCNPJ"
	    }
	  }, [_c('div', [_c('h1', [_vm._v("\n        Move Mais Meios de Pagamento Ltda - CNPJ: 15.266.912/0001-87 -\n        Inscrição Estadual: 181.239.134.110\n      ")]), _vm._v(" "), _c('h1', [_vm._v("\n        Endereço: Avenida Rodrigo Fernando Grillo, 207, Edifício Victoria\n        Business, 20º andar - Araraquara, SP, Brasil - 14801-534\n      ")])])])
	}]}

/***/ }),
/* 2110 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "container profile"
	  }, [_c('two-fa-interno', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show2fa),
	      expression: "show2fa"
	    }],
	    attrs: {
	      "origin": 'UPDATE_ACCOUNT'
	    },
	    on: {
	      "sucess2fa": _vm.save
	    }
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.show2fa),
	      expression: "!show2fa"
	    }]
	  }, [_c('user-data', {
	    ref: "userComponent"
	  }), _vm._v(" "), _c('address-data', {
	    ref: "addressComponent"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "text-right"
	  }, [_c('button', {
	    staticClass: "btn btn-default margin-t10",
	    attrs: {
	      "id": "btn-confirm-recharge",
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.save()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "text-btn-recharge"
	  }, [_vm._v("Salvar dados")]), _vm._v(" "), _c('i', {
	    staticClass: "icon-tick align-icon-right-lg"
	  })])])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2111 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("Alterar senha")])], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "row border-row row-fix"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "content-box-small margin-t10"
	  }, [_c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.doRequest.apply(null, arguments)
	      }
	    }
	  }, [(_vm.errorMessage) ? _c('div', {
	    staticClass: "alert alert-danger margin-t20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.errorMessage) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Deseja alterar sua senha? Ao clicar no botão abaixo você será redirecionado para a página de alteração.")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-lg btn-success",
	    attrs: {
	      "id": "btn-new-pass",
	      "type": "submit",
	      "name": "button"
	    }
	  }, [_vm._v("\n                  Definir nova senha\n                ")])])])]), _vm._v(" "), _vm._m(0)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "circle-key"
	  })])
	}]}

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade modal-transfer",
	    attrs: {
	      "id": "modal-transfer",
	      "tabindex": "-1",
	      "role": "dialog"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    attrs: {
	      "id": "someTab"
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "tab-content"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "tab-pane",
	    attrs: {
	      "role": "tabpanel",
	      "id": "profile"
	    }
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "pane-answer-box"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "simulation margin-t20"
	  }, [_c('h3', {
	    staticClass: "inline"
	  }, [_vm._v("Fazer simulação")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group info-transfer-box inline"
	  }, [_c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("Valor da Transferência (R$)*:")]), _vm._v(" "), _c('button', {
	    staticClass: "inline bold btn-charge btn-charge-minus",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.decrement()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-minus"
	  })]), _vm._v(" "), _c('input', {
	    staticClass: "inline form-control bold",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "placeholder": "0,00"
	    },
	    domProps: {
	      "value": _vm.transferValue
	    },
	    on: {
	      "input": function($event) {
	        return _vm.changeTransferValue($event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "inline bold btn-charge btn-charge-plus",
	    attrs: {
	      "type": "button",
	      "name": "button",
	      "autofocus": "autofocus"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.increment()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-plus"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group percentual-box inline"
	  }, [_c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("*Taxa de Transferência (2% sobre o valor) R$:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.taxTransferValue),
	      expression: "taxTransferValue"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "value": "",
	      "readonly": "readonly"
	    },
	    domProps: {
	      "value": (_vm.taxTransferValue)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.taxTransferValue = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group total-box inline"
	  }, [_c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("Transferência + Taxa (R$):")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.finalTransferValue),
	      expression: "finalTransferValue"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "value": "",
	      "readonly": "readonly"
	    },
	    domProps: {
	      "value": (_vm.finalTransferValue)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.finalTransferValue = $event.target.value
	      }
	    }
	  })])])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('div', {}, [_c('input', {
	    staticClass: "check-terms",
	    attrs: {
	      "id": "modal-info",
	      "type": "checkbox",
	      "name": "modal-info",
	      "value": "1"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.doNotShow()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "label-terms",
	    attrs: {
	      "for": "modal-info"
	    }
	  }, [_vm._v("\n            Não mostrar mais esta informação.\n          ")])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
	    staticClass: "inline"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(510),
	      "alt": "",
	      "width": "70"
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(1841),
	      "alt": "",
	      "width": "70"
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(510),
	      "alt": "",
	      "width": "70"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "inline"
	  }, [_c('h1', [_vm._v("move mais transferência de saldo")]), _vm._v(" "), _c('h4', [_vm._v("Precisando de créditos e não tem como fazer uma recarga?")])]), _vm._v(" "), _c('h4', [_vm._v("Faça sua recarga à distância através da transferência entre contas.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "nav nav-tabs",
	    attrs: {
	      "role": "tablist"
	    }
	  }, [_c('li', {
	    staticClass: "active",
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#home",
	      "aria-controls": "home",
	      "role": "tab",
	      "data-toggle": "tab"
	    }
	  }, [_vm._v("Descrição")])]), _vm._v(" "), _c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#profile",
	      "aria-controls": "profile",
	      "role": "tab",
	      "data-toggle": "tab"
	    }
	  }, [_vm._v("Taxa de serviço")])]), _vm._v(" "), _c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#messages",
	      "aria-controls": "messages",
	      "role": "tab",
	      "data-toggle": "tab"
	    }
	  }, [_vm._v("Quem pode")])]), _vm._v(" "), _c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#settings",
	      "aria-controls": "settings",
	      "role": "tab",
	      "data-toggle": "tab"
	    }
	  }, [_vm._v("Me ajuda")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tab-pane active",
	    attrs: {
	      "role": "tabpanel",
	      "id": "home"
	    }
	  }, [_c('h4', {
	    staticClass: "bold-600 upper"
	  }, [_vm._v("\n                descrição\n                "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "pane-answer-box"
	  }, [_c('p', [_vm._v("\n                  Agora você poderá receber e transferir saldo para qualquer outro contrato com toda comodidade e praticidade.\n                  "), _c('br'), _c('br'), _vm._v("\n                  Agora, mesmo quando você estiver sem saldo ou sem poder fazer uma recarga naquele momento, você poderá pedir aos\n                  seus amigos e familiares para lhe transferirem o saldo que necessita para passar pelas praças de pedágio automaticamente.\n                  "), _c('br'), _c('br'), _vm._v("\n                  Este serviço está disponível para todos os clientes "), _c('b', [_vm._v("Pré-pagos")]), _vm._v(" Pessoa Física.\n                  "), _c('br'), _c('br'), _vm._v("\n                  Para mais informações, leia o "), _c('a', {
	    attrs: {
	      "href": "/api/v2/archeion/downloadFileArcheion/termos-e-condicoes-gerais-movemais",
	      "target": "_blank",
	      "title": "Termos e Condições"
	    }
	  }, [_vm._v("Termo de Uso do Serviço")]), _vm._v(".\n                ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', {
	    staticClass: "bold-600 upper"
	  }, [_vm._v("\n                taxa\n                "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("\n                  A taxa de serviço é de "), _c('b', [_vm._v("2%")]), _vm._v(" sobre o valor a ser transferido.\n                  "), _c('br'), _c('br'), _vm._v("\n                  O contrato de origem tem que ter saldo igual ou maior à soma do valor a ser transferido mais o valor da taxa de serviço.\n                  Se tiver, qualquer valor de transferência é permitido.\n                ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tab-pane",
	    attrs: {
	      "role": "tabpanel",
	      "id": "messages"
	    }
	  }, [_c('h4', {
	    staticClass: "bold-600 upper"
	  }, [_vm._v("\n                quem pode\n                "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "pane-answer-box"
	  }, [_c('p', [_vm._v("\n                  Não é preciso contratar esse serviço. Para usar o Move Mais Transferência de Saldo, basta ter saldo em seu plano Pré-pago\n                  Pessoa Física com status "), _c('b', [_vm._v("Ativo")]), _vm._v(".\n                  "), _c('br'), _c('br'), _vm._v("\n                  O cliente que atender aos critérios para utilizar o serviço, poderá fazer transferência de saldo entre contratos Move Mais,\n                  na mesma conta ou entre contas diferentes.\n                  "), _c('br'), _c('br'), _vm._v("\n                  Pode receber o crédito da transferência se estiver com status "), _c('b', [_vm._v("Aguardando Ativação, Ativo, Inadimplente, Bloqueado por\n                  saldo ")]), _vm._v("e "), _c('b', [_vm._v("A encerrar")]), _vm._v(".\n                  "), _c('br'), _c('br'), _vm._v("\n                  Não pode receber a transferência de saldo se o contrato estiver com status "), _c('b', [_vm._v("Cancelado")]), _vm._v(".\n                ")]), _vm._v(" "), _c('p', {
	    staticClass: "red"
	  }, [_c('b', [_vm._v("IMPORTANTE:")]), _vm._v(" A transferência efetivada não poderá ser desfeita.")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tab-pane",
	    attrs: {
	      "role": "tabpanel",
	      "id": "settings"
	    }
	  }, [_c('h4', {
	    staticClass: "bold-600 upper"
	  }, [_vm._v("\n                me ajuda\n                "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "pane-answer-box"
	  }, [_c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n                    O que é a Transferência de Saldo?\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                      Trata-se de um serviço disponibilizado pela Move Mais aos seus clientes Pré-pagos Pessoa Física.\n                      O cliente que atender aos critérios para utilizar o serviço, poderá fazer transferência de saldo entre\n                      contratos Move Mais, na mesma conta ou entre contas diferentes.\n                    ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n                    Quem pode solicitar o serviço?\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                      Cliente Move Mais com situação "), _c('b', [_vm._v("“Ativo”")]), _vm._v(" e contrato Pré-pago Manual ou Pré-pago Automático.\n                      A transferência pode ser entre contratos de contas diferentes ou entre contratos de uma mesma conta.\n                    ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n                    Qual o valor/percentual da taxa de serviço?\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                      A "), _c('b', [_vm._v("Taxa")]), _vm._v(" cobrada será de "), _c('b', [_vm._v("2%")]), _vm._v(" sobre o valor transferido.\n                    ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n                    Quem pode receber a transferência?\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                      Clientes com as seguintes situações: "), _c('b', [_vm._v("\"Aguardando Ativação\", \"Ativo\", \"Inadimplente\", \"Bloqueado por\n                      saldo\" ")]), _vm._v("e "), _c('b', [_vm._v("\"A encerrar\"")]), _vm._v(".\n                    ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n                    Quem não pode receber a transferência?\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                      Clientes com situação "), _c('b', [_vm._v("\"Cancelado\"")]), _vm._v(".\n                    ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n                    Se houver erro na transferência de saldo, que segurança a MOVE MAIS me oferece?\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                      Todo o processo de transferência de saldo, desde os dados do receber da transferência quanto o valor,\n                      é de inteira responsabilidade de quem o fez. Todo o processo é feito através de senha, de uso exclusivo do\n                      titular da conta.\n                    ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n                    A taxa será descontada do cliente que enviar o crédito ou posso selecionar que o crédito seja descontado do recebedor?\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                      A taxa de 2% será descontado de quem fizer a transferência ("), _c('b', [_vm._v("emissor")]), _vm._v(").\n                    ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n                    Sou Pré-pago automático,  se eu transferir todo o meu saldo será  disparada uma nova recarga?\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                      Sim! Se você é cliente Pré-pago automático será disparada uma nova recarga caso faça a\n                      transferência de todo seu saldo ou após a transferência seu saldo fique abaixo dos 40% do valor\n                      estipulado para a recarga automática.\n                    ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n                    Não sei o CPF ou contrato do favorecido, a Central de Relacionamento poderá informar?\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                      Não!\n                    ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n                    Quem recebeu e quem fez a transferência será notificado?\n                  ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n                      Sim! Tanto quem fez a transferência quanto quem receber, será notificado através de SMS da efetivação da operação.\n                    ")])])])])])
	}]}

/***/ }),
/* 2113 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.show) ? _c('div', {
	    staticClass: "modal-backdrop fade show",
	    staticStyle: {
	      "background-color": "rgba(0, 0, 0, 0.6)",
	      "backdrop-filter": "blur(4px)"
	    },
	    on: {
	      "click": _vm.handleBackdropClick
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('div', {
	    staticClass: "email-container show",
	    attrs: {
	      "id": "email-validation-modal",
	      "role": "dialog"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-header modal-info"
	  }, [_c('h4', {
	    staticClass: "modal-title"
	  }, [_c('i', {
	    staticClass: "icon-envelope-check"
	  }), _vm._v("\n          Validar " + _vm._s(_vm.title) + "\n        ")]), _vm._v(" "), (_vm.allowClose) ? _c('button', {
	    staticClass: "close",
	    staticStyle: {
	      "position": "absolute",
	      "right": "15px",
	      "top": "15px",
	      "color": "white",
	      "opacity": "0.8",
	      "font-size": "28px",
	      "font-weight": "bold",
	      "background": "none",
	      "border": "none",
	      "cursor": "pointer"
	    },
	    attrs: {
	      "type": "button",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": _vm.handleClose
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [(_vm.loadingChannels) ? _c('div', {
	    staticClass: "loading-overlay"
	  }, [_c('div', {
	    staticClass: "loading-spinner"
	  }), _vm._v(" "), _c('p', {
	    staticClass: "loading-text"
	  }, [_vm._v("Carregando...")])]) : _vm._e(), _vm._v(" "), (_vm.step === 'channel-selection' && !_vm.loadingChannels) ? _c('div', {
	    staticClass: "channel-selection-step"
	  }, [_c('h3', {
	    staticClass: "channel-title"
	  }, [_vm._v("Como gostaria de ser notificado?")]), _vm._v(" "), _c('p', {
	    staticClass: "channel-subtitle"
	  }, [_vm._v("\n            Atenção: Verifique se você tem acesso ao e-mail ou telefone\n            cadastrado. Caso não tenha, entre em contato com a Central de\n            Relacionamento.\n          ")]), _vm._v(" "), (_vm.channels.length === 0) ? _c('div', {
	    staticClass: "no-channels"
	  }, [_c('p', {
	    staticClass: "error-message"
	  }, [_vm._v("\n              Nenhuma opção de notificação disponível no momento. Entre em\n              contato com a Central de Relacionamento.\n            ")])]) : _c('div', {
	    staticClass: "channel-options"
	  }, _vm._l((_vm.channels), function(channel) {
	    return _c('div', {
	      key: channel.value,
	      staticClass: "channel-option",
	      class: {
	        'channel-option-selected': _vm.selectedChannel === channel.value,
	      },
	      on: {
	        "click": function($event) {
	          return _vm.selectChannel(channel.value)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "channel-icon"
	    }, [_c('i', {
	      class: channel.icon
	    })]), _vm._v(" "), _c('span', {
	      staticClass: "channel-label"
	    }, [_vm._v(_vm._s(channel.label))]), _vm._v(" "), _c('div', {
	      staticClass: "channel-radio"
	    }, [_c('div', {
	      staticClass: "radio-button",
	      class: {
	        'radio-button-selected':
	        _vm.selectedChannel === channel.value,
	      }
	    })])])
	  }), 0), _vm._v(" "), (_vm.channelErrorMessage) ? _c('div', {
	    staticClass: "error-message"
	  }, [_vm._v("\n            " + _vm._s(_vm.channelErrorMessage) + "\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.loadingChannels && _vm.channels.length > 0) ? _c('button', {
	    staticClass: "btn btn-confirm",
	    attrs: {
	      "disabled": !_vm.selectedChannel || _vm.isProcessing
	    },
	    on: {
	      "click": _vm.handleConfirmChannel
	    }
	  }, [_vm._v("\n            Confirmar\n          ")]) : _vm._e(), _vm._v(" "), (_vm.allowClose) ? _c('button', {
	    staticClass: "btn-cancel-link",
	    attrs: {
	      "disabled": _vm.isProcessing
	    },
	    on: {
	      "click": _vm.handleClose
	    }
	  }, [_vm._v("\n            Cancelar\n          ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.step === 'code-input') ? _c('div', {
	    staticClass: "code-input-step"
	  }, [_c('p', {
	    staticClass: "instruction-text"
	  }, [_vm._v("\n            Digite o código de 6 dígitos que enviamos para o seu\n            " + _vm._s(_vm.selectedChannelLabel) + " para confirmar.\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "code-input-container"
	  }, [_c('label', {
	    staticClass: "code-label",
	    attrs: {
	      "for": "code-input-1"
	    }
	  }, [_vm._v("Digite o código de verificação")]), _vm._v(" "), _c('div', {
	    staticClass: "code-input-boxes"
	  }, _vm._l((6), function(n) {
	    return _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.code[n - 1]),
	        expression: "code[n - 1]"
	      }],
	      key: n,
	      ref: ("codeInput" + n),
	      refInFor: true,
	      staticClass: "code-box",
	      class: {
	        'code-box-error': _vm.hasError
	      },
	      attrs: {
	        "id": n === 1 ? 'code-input-1' : undefined,
	        "type": "text",
	        "maxlength": "1"
	      },
	      domProps: {
	        "value": (_vm.code[n - 1])
	      },
	      on: {
	        "input": [function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(_vm.code, n - 1, $event.target.value)
	        }, function($event) {
	          return _vm.handleCodeInput($event, n)
	        }],
	        "keydown": function($event) {
	          return _vm.handleCodeKeydown($event, n)
	        },
	        "paste": function($event) {
	          return _vm.handleCodePaste($event)
	        }
	      }
	    })
	  }), 0)]), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
	    staticClass: "error-message"
	  }, [_vm._v("\n            " + _vm._s(_vm.errorMessage) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "resend-container"
	  }, [_c('span', {
	    staticClass: "resend-question"
	  }, [_vm._v("Não recebeu o código?")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default resend-button",
	    attrs: {
	      "disabled": _vm.resendTimer > 0
	    },
	    on: {
	      "click": _vm.handleResendClick
	    }
	  }, [(_vm.resendTimer > 0) ? _c('span', [_vm._v("Reenviar em " + _vm._s(_vm.resendTimer) + "s")]) : _c('span', [_vm._v("Reenviar")])])])]) : _vm._e()])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "header-container"
	    }
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "info-container"
	    }
	  }, [_c('h4', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.scrollToElement('planos')
	      }
	    }
	  }, [_vm._v("PLANOS")]), _vm._v(" "), _c('h4', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.scrollToElement('beneficios')
	      }
	    }
	  }, [_vm._v("\n      BENEFÍCIOS\n    ")]), _vm._v(" "), _c('h4', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.scrollToElement('footer')
	      }
	    }
	  }, [_vm._v("\n      CONTATO\n    ")])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "logo-container-desk"
	    }
	  }, [_c('img', {
	    attrs: {
	      "id": "logo-mm",
	      "src": __webpack_require__(1827)
	    }
	  }), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "line"
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "id": "logo-pamcard",
	      "src": __webpack_require__(1828)
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "logo-container-mob"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1829)
	    }
	  }), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "line"
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(1830)
	    }
	  })])
	}]}

/***/ }),
/* 2115 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), (_vm.code == undefined) ? _c('div', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('ul', {
	    staticClass: "wizard margin-b20 ad",
	    class: _vm.step == 1 ? ' past3 ' : _vm.step > 1 ? ' past4 ' : ''
	  }, [_c('li', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    class: {
	      active: _vm.step == 0, past: _vm.step > 0
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('small', [_vm._v("Plano e condições")]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    class: {
	      active: _vm.step == 1, past: _vm.step > 1
	    }
	  }, [_vm._m(3), _vm._v(" "), _c('small', [_vm._v("Carga Inicial")]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    class: {
	      active: _vm.step == 2, past: _vm.step > 2
	    }
	  }, [_vm._m(5), _vm._v(" "), _c('small', [_vm._v("Resumo e confirmação")]), _vm._v(" "), _vm._m(6)])])])]), _vm._v(" "), (_vm.msgError) ? _c('div', {
	    staticClass: "alert alert-danger margin-b10",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', {
	    staticClass: "upper"
	  }, [_vm._v("Atenção!")]), _vm._v(" " + _vm._s(_vm.msgError) + ".\n    ")]) : _vm._e(), _vm._v(" "), (_vm.step == 0) ? _c('div', {
	    staticClass: "alert alert-warning margin-b10",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', {
	    staticClass: "upper"
	  }, [_vm._v("Atenção!")]), _vm._v(" Para migrar de plano, favor se\n      atentar nas informações abaixo.\n    ")]) : _vm._e(), _vm._v(" "), (_vm.step == 0 && _vm.user.type == '1') ? _c('b2c', {
	    attrs: {
	      "type": 'migration',
	      "rodosol": true
	    },
	    on: {
	      "migrationPlan": _vm.choosePlan
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.step == 0 && _vm.user.type == '2') ? _c('b2b', {
	    attrs: {
	      "type": 'migration',
	      "rodosol": true
	    },
	    on: {
	      "migrationPlan": _vm.choosePlan
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.step == 1) ? [(_vm.planId == 31 || _vm.planId == 32) ? _c('choose-recharge', {
	    ref: "chooseRecharge",
	    attrs: {
	      "contract": _vm.contract,
	      "newAhesionTax": _vm.newAhesionTax,
	      "newVehicleTax": _vm.newVehicleTax,
	      "planName": _vm.planName,
	      "guaranteeTax": _vm.guaranteeTax,
	      "minValue": _vm.minValue
	    }
	  }) : _c('choose-plan', {
	    ref: "choosePlan",
	    attrs: {
	      "contract": _vm.contract,
	      "newAhesionTax": _vm.newAhesionTax,
	      "newVehicleTax": _vm.newVehicleTax,
	      "planName": _vm.planName,
	      "guaranteeTax": _vm.guaranteeTax,
	      "newSalesType": _vm.salesOrder.salesType
	    }
	  })] : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('generic-summary', {
	    ref: "GenericSummary",
	    attrs: {
	      "order": _vm.salesOrder,
	      "request": _vm.request,
	      "showAddress": true,
	      "rodosol": _vm.rodosol,
	      "contract": _vm.contractProp,
	      "account": _vm.user
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.success) ? _c('div', [(_vm.step != 0) ? _c('div', {
	    staticClass: "back-button-box"
	  }, [_c('button', {
	    staticClass: "btn btn-back",
	    on: {
	      "click": function($event) {
	        return _vm.backStep()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n          Voltar\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "action-buttons-box"
	  }, [_c('button', {
	    staticClass: "btn btn-danger",
	    on: {
	      "click": function($event) {
	        return _vm.cancelar()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-cancel align-icon-left-white"
	  }), _vm._v("\n          Cancelar\n        ")]), _vm._v(" "), (_vm.step < 2) ? _c('button', {
	    staticClass: "btn btn-purple add",
	    on: {
	      "click": function($event) {
	        return _vm.nextStep()
	      }
	    }
	  }, [_vm._v("\n          Avançar\n          "), _c('i', {
	    staticClass: "icon-circle-right align-icon-right-white"
	  })]) : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('button', {
	    staticClass: "btn btn-success end",
	    attrs: {
	      "title": _vm.cpm.error
	    },
	    on: {
	      "click": function($event) {
	        return _vm.startRequest()
	      }
	    }
	  }, [_vm._v("\n          Concluir\n          "), _c('i', {
	    staticClass: "icon-tick align-icon-right-white"
	  })]) : _vm._e()])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('success-page', {
	    attrs: {
	      "code": _vm.code,
	      "type": 'newVehicle',
	      "novoCartao": _vm.novoCartao
	    }
	  }), _vm._v(" "), _c('error-page', {
	    attrs: {
	      "code": _vm.code,
	      "stepPayment": 1,
	      "type": 'newVehicle',
	      "salesOrder": _vm.salesResponse
	    },
	    on: {
	      "goToStep": _vm.goToStep
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("Novo Plano")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-plans"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Plano e condições")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step",
	    staticStyle: {
	      "margin-bottom": "1rem"
	    }
	  }, [_c('i', {
	    staticClass: "icon-avatar"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Carga Inicial")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step",
	    staticStyle: {
	      "margin-bottom": "1rem"
	    }
	  }, [_c('i', {
	    staticClass: "icon-confirmation-check"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Resumo e confirmação")])])
	}]}

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("Pedidos")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 min-content"
	  }, [
	    [(_vm.messageError) ? _c('div', {
	      staticClass: "alert alert-warning margin-b10",
	      attrs: {
	        "role": "alert"
	      }
	    }, [_vm._v("\n          " + _vm._s(_vm.messageError) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.orders), function(order) {
	      return _c('div', {
	        key: order.orderId,
	        staticClass: "content-box margin-10"
	      }, [(_vm.isChangeCard(order)) ? _c('div', {
	        staticClass: "request-kind-block"
	      }, [_c('a', {
	        staticClass: "purple",
	        on: {
	          "click": function($event) {
	            return _vm.showDetail(order)
	          }
	        }
	      }, [_vm._v("\n              " + _vm._s(order.salesOrderId) + "\n            ")]), _vm._v("\n            - TROCA DE CARTÃO\n          ")]) : _c('div', {
	        staticClass: "request-kind-block"
	      }, [_c('a', {
	        staticClass: "purple",
	        on: {
	          "click": function($event) {
	            return _vm.showDetail(order)
	          }
	        }
	      }, [_vm._v("\n              " + _vm._s(order.salesOrderId) + "\n            ")]), _vm._v("\n            - " + _vm._s(order.salesDescription) + "\n          ")]), _vm._v(" "), _c('div', {
	        staticClass: "request-status-block"
	      }, [_vm._v("\n            " + _vm._s(order.salesOrderStatus.description) + "\n          ")]), _vm._v(" "), _c('div', {
	        staticClass: "request-date-block"
	      }, [_c('i', {
	        staticClass: "icon-clock icon-date"
	      }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("date")(order.salesDate)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("time")(order.salesDate)))])]), _vm._v(" "), _c('div', {
	        staticClass: "request-value-block"
	      }, [_c('span', {
	        class: _vm.getValueClass(order.price)
	      }, [_vm._v(_vm._s(_vm._f("cents")(order.price)))])]), _vm._v(" "), _c('div', {
	        staticClass: "request-buttons-block"
	      }, [(order.salesDescription === 'TRANSFERÊNCIA') ? _c('span', [_c('a', {
	        staticClass: "btn btn-print",
	        attrs: {
	          "data-toggle": "tooltip",
	          "title": "Visualizar/Imprimir Comprovante"
	        },
	        on: {
	          "click": function($event) {
	            return _vm.showReceipt(order)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "icon-printer"
	      })])]) : _vm._e(), _vm._v(" "), (order.salesOrderShipment) ? _c('span', [(
	        order.salesOrderStatus.salesOrderStatusId == 2 &&
	        order.salesOrderShipment.shipmentType == 3
	      ) ? _c('span', [_c('a', {
	        staticClass: "btn btn-print",
	        attrs: {
	          "data-toggle": "tooltip",
	          "title": "Visualizar/Imprimir Voucher"
	        },
	        on: {
	          "click": function($event) {
	            return _vm.exibeVoucher(order)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "icon-tag"
	      })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (
	        order.pixCopiaCola &&
	        order.contractPaymentMethod.paymentMethod.paymentShortName ==
	        'PX' &&
	        order.salesOrderStatus.salesOrderStatusId == 0
	      ) ? _c('span', [_c('a', {
	        staticClass: "btn btn-icon",
	        attrs: {
	          "title": "QR Code Pix"
	        },
	        on: {
	          "click": function($event) {
	            return _vm.showQRCodePix(order)
	          }
	        }
	      }, [_c('img', {
	        staticStyle: {
	          "width": "15px",
	          "height": "15px"
	        },
	        attrs: {
	          "src": __webpack_require__(1799)
	        }
	      })])]) : _vm._e(), _vm._v(" "), (order.bankBillUrl) ? _c('span', [_c('a', {
	        staticClass: "btn btn-print",
	        attrs: {
	          "href": order.bankBillUrl,
	          "target": "_blank",
	          "data-toggle": "tooltip",
	          "title": "Visualizar/Imprimir Boleto"
	        }
	      }, [_c('i', {
	        staticClass: "icon-printer"
	      })])]) : _vm._e(), _vm._v(" "), _c('span', [(
	        _vm.nfeLinksMap[order.salesOrderId] ||
	        _vm.nfeLinksMap[String(order.salesOrderId)]
	      ) ? _c('a', {
	        staticClass: "btn btn-icon",
	        attrs: {
	          "data-toggle": "tooltip",
	          "title": "Acessar Nota Fiscal",
	          "href": _vm.nfeLinksMap[order.salesOrderId] ||
	            _vm.nfeLinksMap[String(order.salesOrderId)],
	          "target": "_blank"
	        }
	      }, [_c('img', {
	        staticStyle: {
	          "width": "18px",
	          "height": "18px"
	        },
	        attrs: {
	          "src": __webpack_require__(1772),
	          "alt": "Nota Fiscal"
	        }
	      })]) : _vm._e()]), _vm._v(" "), (!_vm.isChangeCard(order)) ? _c('span', [(_vm.isTransfer(order)) ? _c('a', {
	        staticClass: "btn btn-icon",
	        attrs: {
	          "data-toggle": "tooltip",
	          "title": "Detalhes do Pedido"
	        },
	        on: {
	          "click": function($event) {
	            return _vm.showReceipt(order)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "icon-zoom-in"
	      })]) : _c('a', {
	        staticClass: "btn btn-icon",
	        attrs: {
	          "data-toggle": "tooltip",
	          "title": "Detalhes do Pedido"
	        },
	        on: {
	          "click": function($event) {
	            return _vm.showDetail(order)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "icon-zoom-in"
	      })])]) : _vm._e()])])
	    }), _vm._v(" "), _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col-xs-12 text-center"
	    }, [_c('pagination', {
	      attrs: {
	        "model": _vm.page
	      },
	      on: {
	        "page-change": _vm.setCurrentPage
	      }
	    })], 1)]), _vm._v(" "), (_vm.orders) ? _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col-xs-12 result-table-count text-center"
	    }, [_vm._v("\n            Mostrando resultados de " + _vm._s(_vm.page.firstIndexShown()) + " a\n            " + _vm._s(_vm.page.lastIndexShown()) + " de um total de " + _vm._s(_vm.page.itemCount()) + "\n            encontrados.\n          ")])]) : _vm._e()]
	  ], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 2117 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('b2bSodre', {
	    attrs: {
	      "type": "adhesion"
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("Serviços para Empresas")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-b10"
	  }, [_c('h3', {
	    staticClass: "bold upper"
	  }, [_vm._v("Planos")]), _vm._v(" "), _c('p', [_vm._v("Conheça as vantagens que cada plano possui e escolha o que melhor se encaixa na necessidade do seu negócio:")])])])
	}]}

/***/ }),
/* 2118 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('b2cSodre', {
	    attrs: {
	      "type": "adhesion"
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("Serviços para Você")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-b10"
	  }, [_c('h3', {
	    staticClass: "bold upper"
	  }, [_vm._v("Planos")]), _vm._v(" "), _c('p', [_vm._v("Temos dois planos, com certeza um deles é ideal para você, é só escolher:")])])])
	}]}

/***/ }),
/* 2119 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }]
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-box margin-t20"
	  }, [_c('b', {
	    staticClass: "title-identification margin-b10"
	  }, [_vm._v("Resumo e Confirmação do Pedido")]), _vm._v(" "), _c('div', {
	    staticClass: "form-content"
	  }, [(_vm.type == 'newVehicle') ? _c('div', {
	    staticClass: "plan-line-purple margin-b30"
	  }, [_c('p', [_vm._v("Plano Escolhido: "), _c('b', [_vm._v(" " + _vm._s(_vm.plan && _vm.plan.name))])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('b', [_vm._v("Veículos")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _vm._l((_vm.vehicles), function(v, index) {
	    return _c('div', {
	      staticClass: "content-box margin-10"
	    }, [_c('div', {
	      staticClass: "inline plate-box"
	    }, [_c('p', {
	      staticClass: "cell-plate info-car"
	    }, [_c('span', [_vm._v(_vm._s(v.plate))])])]), _vm._v(" "), _c('div', {
	      staticClass: "inline info-car-box"
	    }, [_c('p', {
	      staticClass: "border-right-gray info-car block"
	    }, [_c('b', [_vm._v(_vm._s(v.model.brand.name))])]), _vm._v(" "), _c('p', {
	      staticClass: "model info-car block"
	    }, [_c('b', {
	      attrs: {
	        "title": v.model.name
	      }
	    }, [_vm._v(_vm._s(_vm._f("firstWord")(v.model.name)))])]), _vm._v(" "), _c('p', {
	      staticClass: "border-right-gray model info-car block",
	      attrs: {
	        "title": v.model.name
	      }
	    }, [_vm._v(_vm._s(_vm._f("fromSecWord")(v.model.name)))]), _vm._v(" "), _c('p', {
	      staticClass: "model info-car block",
	      attrs: {
	        "title": v.categoryAxes.name
	      }
	    }, [_vm._v(_vm._s(v.categoryAxes.name))])])])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t10"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('b', [_vm._v("Valores")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), (_vm.type == 'newVehicle') ? [_c('table', {
	    staticClass: "table stripped no-footer",
	    attrs: {
	      "role": "grid"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.vehicles.length), function(n) {
	    return [_c('tr', [_c('td', [_vm._v("Adesão Move Mais - " + _vm._s(_vm.vehicles[n - 1].plate))]), _vm._v(" "), _c('td', {
	      staticClass: "bold text-right"
	    }, [_vm._v(_vm._s(_vm._f("cents")(_vm.newVehicleTax)))])]), _vm._v(" "), (_vm.isCaminhoParana) ? _c('tr', [_c('td', [_vm._v("Desconto - " + _vm._s(_vm.vehicles[n - 1].plate) + " ")]), _vm._v(" "), _c('td', {
	      staticClass: "bold text-right"
	    }, [_vm._v("-" + _vm._s(_vm._f("cents")(_vm.newVehicleTax)))])]) : _vm._e(), _vm._v(" "), (_vm.guaranteeTax) ? _c('tr', [_c('td', [_vm._v("Caução - " + _vm._s(_vm.vehicles[n - 1].plate))]), _vm._v(" "), _c('td', {
	      staticClass: "bold text-right"
	    }, [_vm._v(_vm._s(_vm._f("cents")(_vm.guaranteeTax)))])]) : _vm._e(), _vm._v(" "), (_vm.monthlyTax) ? _c('tr', [_c('td', [_vm._v("Mensalidade - " + _vm._s(_vm.vehicles[n - 1].plate))]), _vm._v(" "), _c('td', {
	      staticClass: "bold text-right"
	    }, [_vm._v(_vm._s(_vm._f("cents")(_vm.monthlyTax)))])]) : _vm._e(), _vm._v(" "), (_vm.getKindPlan(_vm.planId) == 'RNTRC' && _vm.type != 'replaceTag') ? _c('tr', [_c('td', [_vm._v("Vinculação RNTRC - " + _vm._s(_vm.vehicles[n - 1].plate))]), _vm._v(" "), _c('td', {
	      staticClass: "bold text-right"
	    }, [_vm._v(_vm._s(_vm._f("cents")(_vm.linkRntrcTax)))])]) : _vm._e()]
	  }), _vm._v(" "), (_vm.showRecharge) ? _c('tr', [_c('td', [_vm._v("Carga Inicial")]), _vm._v(" "), _c('td', {
	    staticClass: "bold text-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.rechargeValueTotal)))])]) : _vm._e(), _vm._v(" "), (_vm.showRecharge) ? _c('tr', [_c('td', [_vm._v("Taxa de Recarga")]), _vm._v(" "), _c('td', {
	    staticClass: "bold text-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.rechargeTaxTotal)))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
	    staticStyle: {
	      "width": "70%"
	    }
	  }, [_vm._v("\n                        Cupom de Desconto\n                        "), _c('i', {
	    staticClass: "icon-info",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "O cupom de desconto é um código promocional que você pode utilizar para abater uma parte ou a totalidade do valor de uma compra. É só colar um código promocional válido e clicar em aplicar desconto e pronto, você já vai ter o desconto aplicado na sua compra Move Mais!"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "inline pull-right"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cupom),
	      expression: "cupom"
	    }],
	    staticClass: "inline form-control discount",
	    attrs: {
	      "minlength": "5",
	      "maxlength": "25",
	      "type": "text",
	      "placeholder": "Digite o código",
	      "disabled": _vm.descontoCupom != 0
	    },
	    domProps: {
	      "value": (_vm.cupom)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.cupom = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.cupomApplied),
	      expression: "!cupomApplied"
	    }],
	    staticClass: "inline btn btn-primary btn-discount",
	    attrs: {
	      "type": "button",
	      "name": "button",
	      "disabled": !_vm.cupom
	    },
	    on: {
	      "click": function($event) {
	        return _vm.calculateDiscount()
	      }
	    }
	  }, [_vm._v("\n                            Aplicar Desconto\n                          ")]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.cupomApplied),
	      expression: "cupomApplied"
	    }],
	    staticClass: "inline btn btn-danger btn-discount",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.removeDiscount()
	      }
	    }
	  }, [_vm._v("\n                            Remover Desconto\n                          ")]), _vm._v(" "), (_vm.erroCupom) ? _c('div', {
	    staticClass: "discount-error-msg"
	  }, [_c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v(_vm._s(_vm.erroCupom))])]) : _vm._e()])]), _vm._v(" "), _c('td', {
	    staticClass: "bold text-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(-1 * _vm.descontoCupom)))])])], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
	    staticClass: "bold-600"
	  }, [_vm._v("TOTAL")]), _vm._v(" "), _c('td', {
	    staticClass: "bold text-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.total)))])])])])] : _vm._e(), _vm._v(" "), (_vm.type == 'replaceTag') ? [_c('table', {
	    staticClass: "table stripped no-footer",
	    attrs: {
	      "role": "grid"
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.vehicles.length), function(n) {
	    return _c('tr', [_c('td', [_vm._v("Taxa de substituição de TAG")]), _vm._v(" "), _c('td', {
	      staticClass: "bold text-right"
	    }, [_vm._v(_vm._s(_vm._f("cents")(_vm.replaceTax)))])])
	  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
	    staticClass: "bold-600"
	  }, [_vm._v("TOTAL")]), _vm._v(" "), _c('td', {
	    staticClass: "bold text-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.replaceTax)))])])])])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [(_vm.isCaminhoParana) ? _c('div', {
	    staticClass: "col-md-6 address-resume"
	  }, [_c('b', [_vm._v("Endereço de retirada da TAG eletrônica")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _vm._m(2)]) : _c('div', {
	    staticClass: "col-md-12 address-resume"
	  }, [_c('div', {
	    staticClass: "radio-box content-box",
	    class: {
	      'active': _vm.whereToDelivrey == 0
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.whereToDelivrey),
	      expression: "whereToDelivrey"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "0",
	      "type": "radio",
	      "name": "radio",
	      "value": "0"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.whereToDelivrey, "0")
	    },
	    on: {
	      "change": function($event) {
	        _vm.whereToDelivrey = "0"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label",
	    attrs: {
	      "for": "0"
	    }
	  }, [_c('p', {
	    staticClass: "inline"
	  }, [_vm._v(_vm._s(_vm.address.zipCode.address) + ", " + _vm._s(_vm.address.number))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.address.zipCode.neighborhood))]), _vm._v(" "), _c('p', [_vm._v("CEP " + _vm._s(_vm.address.zipCode.zipCode))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.address.zipCode.city) + " - " + _vm._s(_vm.address.zipCode.state) + " - Brasil")]), _vm._v(" "), (_vm.address.complement && _vm.address.complement.length > 0) ? _c('p', [_vm._v("Complemento - " + _vm._s(_vm.address.complement))]) : _vm._e(), _vm._v(" "), _c('small', {
	    staticClass: "block"
	  }, [_vm._v("Obs: Os Tags serão entregues no endereço informado.")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-sm btn-back",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('eventChangeAddress', true)
	      }
	    }
	  }, [_vm._v("Alterar Endereço")])]), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "radio-box content-box",
	    class: {
	      'active': _vm.whereToDelivrey == 61800016
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.whereToDelivrey),
	      expression: "whereToDelivrey"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "61800016",
	      "type": "radio",
	      "name": "radio",
	      "value": "61800016"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.whereToDelivrey, "61800016")
	    },
	    on: {
	      "change": function($event) {
	        _vm.whereToDelivrey = "61800016"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label",
	    attrs: {
	      "for": "61800016"
	    }
	  }, [_c('p', [_vm._v("Retirar as TAGs na MSVIAS")]), _vm._v(" "), _c('small', {
	    staticClass: "block"
	  }, [_vm._v("As TAGs poderão ser retiradas após a confirmação do pagamento")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-sm btn-back",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.getTolls('MS', '61800016')
	      }
	    }
	  }, [_vm._v("Consultar praças")])]), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-t20",
	    class: {
	      'has-error': _vm.errors.has('terms')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "check-terms",
	    attrs: {
	      "id": "terms",
	      "type": "checkbox",
	      "name": "terms",
	      "value": "1"
	    }
	  }), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.errors.has('terms')) ? _c('div', {
	    staticClass: "alert alert-danger alert-terms",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('span', {
	    staticClass: "help-block"
	  }, [_vm._v("É necessário ler e concordar com os termos para realizar a adesão")])]) : _vm._e()])])])])])]), _vm._v(" "), (_vm.showEntries) ? _c('div', {
	    staticClass: "modal fade in",
	    staticStyle: {
	      "display": "block"
	    },
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showEntries = false
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Praças")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('h3', [_vm._v("Praças onde a TAG pode ser retirada")]), _vm._v(" "), _vm._l((_vm.entries), function(item, index) {
	    return _c('div', {
	      key: index
	    }, [_c('p', [_vm._v(_vm._s(item.roadCode) + " KM " + _vm._s(item.km) + " - " + _vm._s(item.city))])])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showEntries = false
	      }
	    }
	  }, [_vm._v("Fechar")])])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', {
	    staticClass: "hidden"
	  }, [_c('th', {
	    attrs: {
	      "width": "50%"
	    }
	  }), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "50%"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', {
	    staticClass: "hidden"
	  }, [_c('th', {
	    attrs: {
	      "width": "50%"
	    }
	  }), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "50%"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-box"
	  }, [_c('p', [_vm._v("Base de apoio operacional da Concessionária Caminhos do Paraná")]), _vm._v(" "), _c('p', [_vm._v("Rodovia 277, Km 249, 700")]), _vm._v(" "), _c('p', [_vm._v("Irati - PR")]), _vm._v(" "), _c('p', [_vm._v("Atendimento: Segunda a Sexta, das 8 às 17h.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "label-terms",
	    attrs: {
	      "for": "terms"
	    }
	  }, [_vm._v("\n                Li e aceito as condições gerais de contratação do serviço\n                "), _c('a', {
	    staticClass: "link",
	    attrs: {
	      "href": "/api/v2/archeion/downloadFileArcheion/termos-e-condicoes-gerais-movemais",
	      "target": "_blank"
	    }
	  }, [_vm._v("Ver contrato")])])
	}]}

/***/ }),
/* 2120 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loadingAddress),
	      expression: "loadingAddress",
	      modifiers: {
	        "opacity": true
	      }
	    }]
	  }, [_c('p', {
	    staticClass: "aggregate-sub"
	  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('cep')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "cep"
	    }
	  }, [_vm._v("CEP")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.zipCode),
	      expression: "zipCode"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:8|cep'),
	      expression: "'required|min:8|cep'"
	    }, {
	      name: "only-numbers",
	      rawName: "v-only-numbers"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "cep",
	      "value": "",
	      "maxlength": "8"
	    },
	    domProps: {
	      "value": (_vm.zipCode)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.zipCode = $event.target.value
	      }, _vm.queryAddressTyping]
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n      " + _vm._s(_vm.errors.first('cep')) + "\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    class: {
	      'has-error': _vm.errors.has('address')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "address"
	    }
	  }, [_vm._v("Logradouro")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.address2),
	      expression: "address2"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "address",
	      "value": "",
	      "maxlength": "100"
	    },
	    domProps: {
	      "value": (_vm.address2)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.address2 = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n        " + _vm._s(_vm.errors.first('address')) + "\n      ")])]), _vm._v(" "), _c('div', {
	    class: {
	      'has-error': _vm.errors.has('number')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "number"
	    }
	  }, [_vm._v("Número")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.number),
	      expression: "number"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:8'),
	      expression: "'required|max:8'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "number",
	      "value": "",
	      "maxlength": "8"
	    },
	    domProps: {
	      "value": (_vm.number)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.number = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n        " + _vm._s(_vm.errors.first('number')) + "\n      ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('neighborhood')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "neighborhood"
	    }
	  }, [_vm._v("Bairro")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.neighborhood),
	      expression: "neighborhood"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:50'),
	      expression: "'required|max:50'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "neighborhood",
	      "value": "",
	      "maxlength": "50"
	    },
	    domProps: {
	      "value": (_vm.neighborhood)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.neighborhood = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n      " + _vm._s(_vm.errors.first('neighborhood')) + "\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_vm._m(0), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.complement),
	      expression: "complement"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "value": "",
	      "maxlength": "100"
	    },
	    domProps: {
	      "value": (_vm.complement)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.complement = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('city')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "city"
	    }
	  }, [_vm._v("Cidade")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.city),
	      expression: "city"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:100'),
	      expression: "'required|max:100'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "city",
	      "value": "",
	      "maxlength": "100"
	    },
	    domProps: {
	      "value": (_vm.city)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.city = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n      " + _vm._s(_vm.errors.first('city')) + "\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('state')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "state"
	    }
	  }, [_vm._v("Estado")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.state),
	      expression: "state"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:2'),
	      expression: "'required|max:2'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "state",
	      "value": "",
	      "maxlength": "2"
	    },
	    domProps: {
	      "value": (_vm.state)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.state = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n      " + _vm._s(_vm.errors.first('state')) + "\n    ")])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Complemento "), _c('span', [_vm._v("(opcional)")])])
	}]}

/***/ }),
/* 2121 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container",
	    attrs: {
	      "id": "vp-vehicle-movement"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("Planos "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Contrato " + _vm._s(_vm.contractId) + " "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Veículos "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Movimentação do veículo")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "info-vehicle"
	  }, [_c('p', {
	    staticClass: "inline"
	  }, [_vm._v("Placa: "), _c('span', [_vm._v(_vm._s(_vm.vehicle.plate))])]), _vm._v(" "), _c('p', {
	    staticClass: "inline"
	  }, [_vm._v("TAG N°: "), _c('span', [_vm._v(_vm._s(_vm.vehicle.tagSerialNumber))])]), _vm._v(" "), _c('p', {
	    staticClass: "inline"
	  }, [_vm._v("Modelo: "), _c('span', [_vm._v(_vm._s(_vm.vehicle.modelName))])]), _vm._v(" "), _c('p', {
	    staticClass: "inline"
	  }, [_vm._v("Marca: "), _c('span', [_vm._v(_vm._s(_vm.vehicle.brandName))])]), _vm._v(" "), _c('p', {
	    staticClass: "inline"
	  }, [_vm._v("Eixos: "), _c('span', [_vm._v(_vm._s(_vm.vehicle.categoryAxesName))])])]), _vm._v(" "), _c('div', {
	    staticClass: "filter-box"
	  }, [_c('div', {
	    staticClass: "inline"
	  }, [_c('div', {
	    staticClass: "inline filter-inline"
	  }, [_c('p', {
	    staticClass: "no-margin inline"
	  }, [_vm._v("Filtros")]), _vm._v(" "), _c('div', {
	    staticClass: "btn-group",
	    attrs: {
	      "data-toggle": "buttons"
	    }
	  }, [_c('label', {
	    staticClass: "btn btn-filter",
	    class: {
	      'active': _vm.lastDays == '31'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.handleChangeDate('31')
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "radio",
	      "name": "options",
	      "id": "month",
	      "value": "31",
	      "checked": ""
	    },
	    domProps: {
	      "checked": _vm.lastDays == '31'
	    }
	  }), _vm._v(" Mês\n          ")]), _vm._v(" "), _c('label', {
	    staticClass: "btn btn-filter",
	    class: {
	      'active': _vm.lastDays == '7'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.handleChangeDate('7')
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "radio",
	      "name": "options",
	      "id": "week",
	      "value": "7"
	    },
	    domProps: {
	      "checked": _vm.lastDays == '7'
	    }
	  }), _vm._v(" Semana\n          ")]), _vm._v(" "), _c('label', {
	    staticClass: "btn btn-filter",
	    class: {
	      'active': _vm.lastDays == '1'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.handleChangeDate('1')
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "radio",
	      "name": "options",
	      "id": "day",
	      "value": "1"
	    },
	    domProps: {
	      "checked": _vm.lastDays == '1'
	    }
	  }), _vm._v(" Dia\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "inline"
	  }, [_c('vue-date-picker', {
	    attrs: {
	      "type": "date",
	      "range": "",
	      "lang": _vm.lang,
	      "formatter": _vm.momentFormat,
	      "placeholder": "00/00/0000 - 00/00/0000"
	    },
	    on: {
	      "change": _vm.handleChangeDate
	    },
	    model: {
	      value: (_vm.dateRange),
	      callback: function($$v) {
	        _vm.dateRange = $$v
	      },
	      expression: "dateRange"
	    }
	  })], 1)]), _vm._v(" "), _c('p', {
	    staticClass: "inline pull-right margin-t5"
	  }, [_vm._v("Total da consulta: "), _c('span', {
	    staticClass: "bold"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.totalValue)))])])]), _vm._v(" "), (_vm.searchState == 'NOTFOUND') ? _c('p', {
	    staticClass: "alert alert-warning margin-t10"
	  }, [_vm._v("Nenhum dado encontrado no período.")]) : _vm._e(), _vm._v(" "), (_vm.searchState == 'ERROSEARCH') ? _c('div', {
	    staticClass: "alert alert-danger margin-t10"
	  }, [_c('ol', [_c('li', [_vm._v(_vm._s(_vm.messageError))])])]) : _vm._e(), _vm._v(" "), (_vm.searchState == 'FOUND') ? _c('div', {
	    attrs: {
	      "id": "summary-box"
	    }
	  }, _vm._l((_vm.summaryVP), function(s, index) {
	    return _c('div', {
	      staticClass: "content-box-npadd margin-b20"
	    }, [_c('div', {
	      staticClass: "toll-info-box"
	    }, [_c('div', {}, [_c('div', {}, [_c('small', [_vm._v("De")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(s.origem.substring(0, s.origem.indexOf(','))))]), _vm._v(" "), _c('small', [_c('img', {
	      attrs: {
	        "src": "/static/icon-send.svg",
	        "alt": "icon send"
	      }
	    }), _vm._v("\n              " + _vm._s(s.origem.substring(s.origem.indexOf(',') + 1, s.origem.indexOf(',') + 4)) + "\n            ")])]), _vm._v(" "), _c('div', {}, [_c('small', [_vm._v("para")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(s.destino.substring(0, s.destino.indexOf(','))))]), _vm._v(" "), _c('small', [_c('img', {
	      attrs: {
	        "src": "/static/icon-location.svg",
	        "alt": "icon location"
	      }
	    }), _vm._v("\n              " + _vm._s(s.destino.substring(s.destino.indexOf(',') + 1, s.destino.indexOf(',') + 4)) + "\n            ")])])]), _vm._v(" "), _c('button', {
	      staticClass: "no-btn",
	      attrs: {
	        "type": "button",
	        "name": "button"
	      },
	      on: {
	        "click": function($event) {
	          s.open = !s.open
	        }
	      }
	    }, [_c('i', {
	      staticClass: "icon-circle-right",
	      class: s.open ? 'open' : ''
	    })]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("\n            rota:\n            "), _c('span', [_vm._v(_vm._s(s.rota))])]), _vm._v(" "), _c('p', [_vm._v("\n            distância:\n            "), _c('span', [_vm._v(_vm._s(s.totalDistance) + " KM")])]), _vm._v(" "), _c('p', [_vm._v("\n            valor:\n            "), _c('span', [_vm._v(_vm._s(_vm._f("cents")(s.valorVP)))])]), _vm._v(" "), _c('p', [_vm._v("\n            expiração:\n            "), _c('span', [_vm._v(_vm._s(_vm._f("date")(s.expirationVP)))])])])]), _vm._v(" "), _c('div', {
	      staticClass: "table-toll-info",
	      class: s.open ? 'open' : ''
	    }, [_c('table', {
	      staticClass: "table"
	    }, [_vm._m(0, true), _vm._v(" "), _c('tbody', _vm._l((s.pracas), function(p, index) {
	      return _c('tr', [_c('td', [_vm._v(_vm._s(p.praca))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.concessionaria))]), _vm._v(" "), _c('td', {
	        staticClass: "text-right"
	      }, [_vm._v(_vm._s(_vm._f("cents")(p.price)))])])
	    }), 0)])])])
	  }), 0) : _vm._e(), _vm._v(" "), (_vm.summaryVP.length > 0) ? _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 result-table-count"
	  }, [_vm._v("\n        Mostrando resultados de " + _vm._s(_vm.page.firstIndexShown()) + " a " + _vm._s(_vm.page.lastIndexShown()) + " de um total de " + _vm._s(_vm.page.itemCount()) + "\n        encontrados.\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('router-link', {
	    staticClass: "btn no-btn btn-square margin-10",
	    attrs: {
	      "to": {
	        name: 'aggregate-list',
	        params: {
	          contractId: 14591
	        }
	      },
	      "tag": "button"
	    }
	  }, [_vm._v("\n          Voltar\n        ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 text-center"
	  }, [_c('pagination', {
	    attrs: {
	      "model": _vm.page
	    },
	    on: {
	      "page-change": _vm.setCurrentPage
	    }
	  })], 1)])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Praça de pedágio")]), _vm._v(" "), _c('th', [_vm._v("Concessionária")]), _vm._v(" "), _c('th', {
	    staticClass: "text-right"
	  }, [_vm._v("Valor")])])])
	}]}

/***/ }),
/* 2122 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("Alterar Dados")])], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "row border-row row-fix"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "content-box-small margin-t10"
	  }, [(_vm.errorMessage) ? _c('div', {
	    staticClass: "alert alert-danger margin-t20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.errorMessage) + "\n            ")]) : _vm._e(), _vm._v(" "), (this.$route.params.type == 'UPDATE_USER_EMAIL') ? _c('form', {
	    attrs: {
	      "autocomplete": "off"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.doChange.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group margin-b20",
	    class: {
	      'has-error': _vm.errors.has('email')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "chooseEmailId"
	    }
	  }, [_vm._v("Novo e-mail")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-plate"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "email",
	      "placeholder": "Digite o novo e-email"
	    },
	    domProps: {
	      "value": (_vm.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("email")) + "\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('newEmail')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "chooseEmailId"
	    }
	  }, [_vm._v("confirmar novo e-mail")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-plate"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newEmail),
	      expression: "newEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('confirmed:email'),
	      expression: "'confirmed:email'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "newEmail",
	      "placeholder": "Digite seu novo e-mail",
	      "maxlength": "50",
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": (_vm.newEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newEmail = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("newEmail")) + "\n                ")])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-lg btn-success",
	    attrs: {
	      "id": "btn-new-pass",
	      "type": "button",
	      "name": "button",
	      "disabled": _vm.email != _vm.newEmail
	    },
	    on: {
	      "click": _vm.doChange
	    }
	  }, [_vm._v("\n                Definir novo E-mail\n              ")]), _vm._v(" "), _c('i', {
	    staticClass: "icon-circle-right align-icon"
	  })]) : _vm._e(), _vm._v(" "), (this.$route.params.type == 'UPDATE_USER_PHONE') ? _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.doChange.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('oldCellPhone')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "chooseEmailId"
	    }
	  }, [_vm._v("Novo celular")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-plate"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cell'),
	      expression: "'required|cell'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.oldCellPhone),
	      expression: "oldCellPhone"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "phone",
	      "name": "oldCellPhone",
	      "placeholder": "Digite o novo celular",
	      "maxlength": "14"
	    },
	    domProps: {
	      "value": (_vm.oldCellPhone)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.oldCellPhone = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("oldCellPhone")) + "\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('newPhone')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "chooseEmailId"
	    }
	  }, [_vm._v("Confirmar novo celular")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-plate"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cell'),
	      expression: "'required|cell'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newCellPhone),
	      expression: "newCellPhone"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "phone",
	      "name": "newPhone",
	      "placeholder": "Digite novamente o celular",
	      "maxlength": "14"
	    },
	    domProps: {
	      "value": (_vm.newCellPhone)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newCellPhone = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("newPhone")) + "\n                ")])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-lg btn-success",
	    attrs: {
	      "id": "btn-new-pass",
	      "type": "submit",
	      "name": "button",
	      "disabled": _vm.oldCellPhone != _vm.newCellPhone
	    }
	  }, [_vm._v("\n                Definir novo celular\n              ")]), _vm._v(" "), _c('i', {
	    staticClass: "icon-circle-right align-icon"
	  })]) : _vm._e()])]), _vm._v(" "), _vm._m(0)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "circle-key"
	  })])
	}]}

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("Ativar TAG")]), _vm._v(" "), _c('div', {
	    staticClass: "margin-30"
	  }, [_vm._m(0), _vm._v(" "), (_vm.window.document.mobile && _vm.window.document.android) ? _c('button', {
	    staticClass: "btn btn-primary btn-scan",
	    attrs: {
	      "onclick": "Native.openScanner()"
	    }
	  }, [_vm._v("\n          Escanear veículo\n        ")]) : _vm._e(), _vm._v(" "), _c('i', {
	    staticClass: "icon-marquee align-icon"
	  })])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "search"
	  }, [_c('i', {
	    staticClass: "icon-search-input"
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filter),
	      expression: "filter"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "search",
	      "name": "",
	      "value": "",
	      "placeholder": "Buscar"
	    },
	    domProps: {
	      "value": (_vm.filter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.filter = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), (_vm.loadingVehicles) ? _c('p', [_vm._v("carregando...")]) : [(_vm.hasAggregate) ? [_c('h3', {
	    staticClass: "margin-20 bold"
	  }, [_vm._v("Veículos de agregados")]), _vm._v(" "), _c('div', {
	    staticClass: "table-white-header tag-table"
	  }, [(_vm.aggregateVehicles.length == 0) ? _c('div', {
	    staticClass: "alert alert-success margin-t20"
	  }, [_vm._v("\n            Não há TAGs para ativar no momento. \n          ")]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "aggregate-tag-list"
	  }, _vm._l((_vm.aggregateVehicles), function(item, index) {
	    return _c('li', {
	      key: index,
	      staticClass: "tag-item"
	    }, [_c('tag', {
	      attrs: {
	        "vehicle": item,
	        "completeData": true
	      }
	    })], 1)
	  }), 0)])] : _vm._e(), _vm._v(" "), [(_vm.hasAggregate) ? _c('h3', {
	    staticClass: "margin-b20 margin-t40 bold"
	  }, [_vm._v("Veículos próprios")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "table-white-header tag-table"
	  }, [(!_vm.vehicles.length && _vm.vehicleStatic.length) ? _c('div', [_c('span', {
	    staticClass: "italic"
	  }, [_vm._v("Nenhum veículo encontrado.")])]) : _vm._e(), _vm._v(" "), (!_vm.vehicleStatic.length) ? _c('div', {
	    staticClass: "alert alert-success margin-t20"
	  }, [_vm._v("\n            Não há TAGs para ativar no momento.\n          ")]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "list-tag-activate"
	  }, _vm._l((_vm.vehicles), function(vehicle, index) {
	    return _c('li', {
	      key: index,
	      staticClass: "tag-item"
	    }, [_c('div', {
	      staticClass: "block-plate"
	    }, [_c('span', [_vm._v(_vm._s(vehicle.plate))])]), _vm._v(" "), _c('div', {
	      staticClass: "block-vehicle"
	    }, [_c('b', [_vm._v(_vm._s(vehicle.brandName))]), _vm._v(" "), _c('div', {
	      staticClass: "vehicle-model"
	    }, [_c('b', [_vm._v(_vm._s(_vm._f("firstWord")(vehicle.modelName)))])]), _vm._v("\n                " + _vm._s(_vm._f("fromSecWord")(vehicle.modelName)) + "\n              ")]), _vm._v(" "), _c('div', {
	      staticClass: "block-tag-activate"
	    }, [_c('ativar-tag-item', {
	      attrs: {
	        "vehicle": vehicle.vehicleId,
	        "loadings": _vm.loading
	      },
	      on: {
	        "deactivatetagLoading": _vm.deactivatetagLoading,
	        "activetagLoading": function($event) {
	          return _vm.activatingTag($event)
	        }
	      }
	    })], 1), _vm._v(" "), _c('button', {
	      staticClass: "btn show-webview",
	      staticStyle: {
	        "width": "100%",
	        "margin-top": "20px",
	        "display": "none"
	      },
	      attrs: {
	        "type": "button",
	        "data-vehicle-id": vehicle.vehicleId,
	        "onclick": "Native.openBarCodeScanner(this.dataset.vehicleId+'')"
	      }
	    }, [_vm._v("Escanear")])])
	  }), 0)])]]], 2)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n          Somente depois de fazer a ativação do TAG é que você poderá utilizar os serviços "), _c('b', [_vm._v("Move Mais")]), _vm._v(". Para ativar é\n          fácil, você só precisa informar o "), _c('b', [_vm._v("TAG Número")]), _vm._v(". Se você possui mais de um TAG certifique-se de que o número\n          informado é realmente do TAG fixado naquele veículo.\n        ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "img-tag-line"
	  }, [_c('img', {
	    staticClass: "img-tag-number",
	    attrs: {
	      "src": __webpack_require__(1777),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "info-tag-number"
	  }, [_vm._v("Este é o número que você deve informar para fazer a ativação do TAG.")])])])
	}]}

/***/ }),
/* 2124 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.dataTransfer) ? _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("\n        Comprovantes\n        "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Comprovante " + _vm._s(_vm.dataTransfer.idTransfer) + "\n      ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "box-transfer-voucher",
	    attrs: {
	      "id": "comprovante"
	    }
	  }, [_c('div', {
	    staticClass: "title-header-voucher"
	  }, [_vm._v("Move Mais - Comprovante de Transferência de Créditos")]), _vm._v(" "), _c('div', {
	    staticClass: "title-subheader-voucher"
	  }, [_vm._v("de conta embarcador para conta embarcador")]), _vm._v(" "), _c('hr', {
	    staticClass: "hrule-voucher"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "subtitle-voucher"
	  }, [_vm._v("\n          Dados da conta debitada\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "label-data-voucher"
	  }, [_vm._v(_vm._s(_vm.dataTransfer.accountDebit.name))])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "label-data-voucher"
	  }, [_vm._v(_vm._s(_vm.dataTransfer.accountDebit.contract))])])]), _vm._v(" "), _c('hr', {
	    staticClass: "hrule-voucher"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "subtitle-voucher"
	  }, [_vm._v("\n          Dados da conta creditada\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "label-data-voucher"
	  }, [_vm._v(_vm._s(_vm.dataTransfer.accountCredit.name))])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "label-data-voucher"
	  }, [_vm._v(_vm._s(_vm.dataTransfer.accountCredit.contract))])])]), _vm._v(" "), _c('hr', {
	    staticClass: "hrule-voucher"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "subtitle-voucher"
	  }, [_vm._v("\n          Valor\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('label', {
	    staticClass: "label-voucher-value"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.dataTransfer.value)))])])]), _vm._v(" "), _c('hr', {
	    staticClass: "hrule-voucher"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "label-voucher-date"
	  }, [_vm._v("\n          " + _vm._s(_vm.getDateTransfer) + "\n        ")]), _vm._v(" "), _c('hr', {
	    staticClass: "hrule-voucher"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "label-voucher-code"
	  }, [_vm._v("\n          " + _vm._s(_vm.dataTransfer.idTransfer) + "\n        ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-20"
	  }, [_c('div', {
	    staticClass: "back-button-box"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back",
	    attrs: {
	      "tag": "button",
	      "to": {
	        name: 'transfer-shipper-vouchers'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n          Voltar\n        ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "action-buttons-box"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "Imprimir comprovante"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.print()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-printer align-icon-left-white"
	  }), _vm._v("\n          Imprimir\n        ")]), _vm._v(" "), _vm._m(4)])])])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "label-voucher"
	  }, [_vm._v("Nome da Empresa:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "label-voucher"
	  }, [_vm._v("Nº do Contrato:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "label-voucher"
	  }, [_vm._v("Nome da Empresa:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "label-voucher"
	  }, [_vm._v("Nº do Contrato:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn btn-danger add",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "Baixar comprovante em PDF"
	    }
	  }, [_c('i', {
	    staticClass: "icon-pdf align-icon-left-white"
	  }), _vm._v("\n          Salvar PDF\n        ")])
	}]}

/***/ }),
/* 2125 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      backgray: _vm.$route.path == '/conta/meus-planos'
	    }
	  }, [(_vm.showMenu) ? _c('app-header') : _vm._e(), _vm._v(" "), _c('section', {
	    staticClass: "outside-section",
	    class: {
	      section:
	        !_vm.showMenu &&
	        _vm.$route.path != '/vale-pedagio' &&
	        _vm.$route.path != '/valepedagio',
	    },
	    style: (_vm.window.document.webview ? ("min-height: " + (_vm.window.screen.height) + "px") : '')
	  }, [_c('router-view')], 1), _vm._v(" "), (_vm.showMenu) ? _c('div', {
	    attrs: {
	      "id": "footer"
	    }
	  }, [_c('app-footer')], 1) : _vm._e(), _vm._v(" "), _c('message-dialog'), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isLoading),
	      expression: "isLoading"
	    }],
	    attrs: {
	      "id": "loading-box-100"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "loading-box-content-100"
	    }
	  }, [_c('svg', {
	    staticClass: "loading-draw-svg",
	    attrs: {
	      "viewBox": _vm.markViewBox,
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    staticClass: "loading-draw-path",
	    attrs: {
	      "fill-rule": "evenodd",
	      "clip-rule": "evenodd",
	      "d": _vm.markPath
	    }
	  })])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('div', {
	    staticClass: "row text-center"
	  }, [_c('div', {
	    staticClass: "col-md-2 first-col-box"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.sameTax) ? _c('div', {
	    staticClass: "height-100"
	  }, [_c('p', {
	    staticClass: "bold no-margin padding-28"
	  }, [_vm._v("Adesão por Veículo")])]) : _vm._e(), _vm._v(" "), (!_vm.sameTax) ? _c('div', {
	    staticClass: "height-82"
	  }, [_c('p', {
	    staticClass: "bold no-margin padding-12"
	  }, [_vm._v("Adesão Primeiro Veículo")])]) : _vm._e(), _vm._v(" "), (!_vm.sameTax) ? _c('div', {
	    staticClass: "height-82"
	  }, [_c('p', {
	    staticClass: "bold no-margin padding-12"
	  }, [_vm._v("\n                Adesão Veículo Adicional\n              ")])]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "height-72 border-radius-bottom",
	    staticStyle: {
	      "height": "82px"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "plain-box"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(!_vm.rodosol) ? _c('div', {
	    staticClass: "col-md-6 small-padding-right"
	  }, [_c('div', {
	    staticClass: "second-col-box margin-b20"
	  }, [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), (_vm.sameTax) ? _c('div', {
	    staticClass: "height-100 padding-28"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("Adesão por Veículo")]), _vm._v(" "), ( true) ? _c('span', [(_vm.newAhesionTaxCont > 0) ? _c('h3', {
	    staticClass: "bold no-margin margin-b10"
	  }, [_vm._v("\n                        " + _vm._s(_vm._f("cents")(_vm.newAhesionTaxCont)) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.newAhesionTaxCont > 0) ? _c('small', [_vm._v("*Descontos vigentes aparecerão somente ao final da\n                        compra.")]) : ( true) ? _c('span', [_c('h4', {
	    staticClass: "promo-value margin-b10"
	  }, [_vm._v("R$ 39,9099*")]), _vm._v(" "), _c('b', {
	    staticClass: "promo-free"
	  }, [_vm._v("Grátis")])]) : _vm._e()]) : _c('span', [_c('h1', {
	    staticClass: "bold no-margin margin-b10"
	  }, [_vm._v("Grátis")])])]) : _vm._e(), _vm._v(" "), (!_vm.sameTax) ? _c('div', {
	    staticClass: "height-82 padding-28"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("Adesão Primeiro Veículo")]), _vm._v(" "), _c('h3', {
	    staticClass: "bold no-margin"
	  }, [_vm._v("\n                      " + _vm._s(_vm._f("cents")(_vm.newAhesionTaxCont)) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (!_vm.sameTax) ? _c('div', {
	    staticClass: "height-82 padding-28"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("Adesão Veículo Adicional")]), _vm._v(" "), _c('h3', {
	    staticClass: "bold no-margin"
	  }, [_vm._v("\n                      " + _vm._s(_vm._f("cents")(_vm.newVehicleTaxCont)) + "\n                    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "height-72 padding-t25"
	  }, [_c('a', {
	    directives: [{
	      name: "smooth-scroll",
	      rawName: "v-smooth-scroll"
	    }],
	    staticClass: "make-link",
	    attrs: {
	      "href": "#rechargeB2B"
	    }
	  }, [_vm._v("\n                      Veja Nossas Taxas de Recarga\n                    ")])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
	    staticClass: "row-button border-radius-bottom"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "tag": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.choose(21)
	      }
	    }
	  }, [_vm._v("\n                      Quero este plano!\n                    ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "small-padding-left",
	    class: _vm.rodosol ? '' : 'col-md-6'
	  }, [_c('div', {
	    staticClass: "third-col-box margin-b20"
	  }, [_vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), (_vm.sameTax) ? _c('div', {
	    staticClass: "height-100 padding-28"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("Adesão por Veículo")]), _vm._v(" "), (!_vm.checkPromoSenff) ? _c('span', [(_vm.newAhesionTaxCont > 0) ? _c('h3', {
	    staticClass: "bold no-margin margin-b10"
	  }, [_vm._v("\n                        " + _vm._s(_vm._f("cents")(_vm.newAhesionTaxCont)) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.newAhesionTaxCont > 0) ? _c('small', [_vm._v("*Descontos vigentes aparecerão somente ao final da\n                        compra.")]) : (_vm.newAhesionTaxCont === 0) ? _c('span', [_c('h4', {
	    staticClass: "promo-value margin-b10"
	  }, [_vm._v("R$ 39,90*")]), _vm._v(" "), _c('b', {
	    staticClass: "promo-free"
	  }, [_vm._v("Grátis")])]) : _vm._e()]) : _c('span', [_c('h1', {
	    staticClass: "bold no-margin margin-b10"
	  }, [_vm._v("Grátis")])])]) : _vm._e(), _vm._v(" "), (!_vm.sameTax) ? _c('div', {
	    staticClass: "height-82 padding-28"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("Adesão Primeiro Veículo")]), _vm._v(" "), _c('h3', {
	    staticClass: "bold no-margin"
	  }, [_vm._v("\n                      " + _vm._s(_vm._f("cents")(_vm.newAhesionTaxConf)) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (!_vm.sameTax) ? _c('div', {
	    staticClass: "height-82 padding-28"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("Adesão Veículo Adicional")]), _vm._v(" "), _c('h3', {
	    staticClass: "bold no-margin"
	  }, [_vm._v("\n                      " + _vm._s(_vm._f("cents")(_vm.newVehicleTaxConf)) + "\n                    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "height-72 padding-t25"
	  }, [_c('a', {
	    directives: [{
	      name: "smooth-scroll",
	      rawName: "v-smooth-scroll"
	    }],
	    staticClass: "make-link",
	    attrs: {
	      "href": "#rechargeB2B"
	    }
	  }, [_vm._v("\n                      Veja Nossas Taxas de Recarga\n                    ")])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
	    staticClass: "row-button border-radius-bottom"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "tag": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.choose(22)
	      }
	    }
	  }, [_vm._v("\n                      Quero este plano!\n                    ")])])])])])])])])])]), _vm._v(" "), _c('card-taxes', {
	    attrs: {
	      "showTaxes": 'pf'
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-72 border-radius-top"
	  }, [_c('p', {
	    staticClass: "margin-10"
	  }, [_c('i', {
	    staticClass: "icon-plans icon-plans-table"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-112"
	  }, [_c('p', {
	    staticClass: "bold no-margin padding-t35"
	  }, [_vm._v("Como Funciona?")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-72"
	  }, [_c('p', {
	    staticClass: "bold no-margin padding-23"
	  }, [_vm._v("Taxas")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-82"
	  }, [_c('p', {
	    staticClass: "bold no-margin padding-10"
	  }, [_vm._v("Formas de Pagamento")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-82"
	  }, [_c('p', {
	    staticClass: "bold no-margin"
	  }, [_vm._v("Pode receber Vale-pedágio?")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-72 border-radius-top"
	  }, [_c('h3', {
	    staticClass: "sub-title plan upper no-margin margin-b10"
	  }, [_vm._v("\n                      Pré-pago Manual\n                    ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-112"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("Como funciona?")]), _vm._v(" "), _c('p', {
	    staticClass: "no-margin paragrafo-plano"
	  }, [_vm._v("\n                      Excelente para você que quer ter controle total dos seus\n                      gastos e tem tempo para planejar as suas recargas.\n                    ")]), _vm._v(" "), _c('br')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-82 padding-23"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("Formas de Pagamento")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Cartão de Crédito")]), _vm._v(" "), _c('li', [_vm._v("Pix")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-82 padding-28"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("Pode receber Vale-pedágio?")]), _vm._v(" "), _c('ul', [_c('p', [_vm._v("Sim")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-72 border-radius-top"
	  }, [_c('h3', {
	    staticClass: "sub-title plan upper no-margin margin-b10"
	  }, [_vm._v("\n                      Pré-pago Automático\n                    ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-112 height-72-big padding-18"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("Como funciona?")]), _vm._v(" "), _c('p', {
	    staticClass: "no-margin paragrafo-plano"
	  }, [_vm._v("\n                      Perfeito para você que gosta de comodidade e não quer se\n                      preocupar com recargas ou saldo insuficiente.\n                    ")]), _vm._v(" "), _c('br')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-82 padding-23"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("Formas de Pagamento")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Cartão de Crédito")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-82 padding-28"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("Pode receber Vale-pedágio?")]), _vm._v(" "), _c('ul', [_c('p', [_vm._v("Sim")])])])
	}]}

/***/ }),
/* 2127 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "row margin-b10"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "plain-box"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(!_vm.rodosol) ? _c('div', {
	    staticClass: "col-md-4 small-padding-right",
	    class: _vm.type != 'newContract' ? 'col-md-4' : 'col-md-6'
	  }, [_c('div', {
	    staticClass: "second-col"
	  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "fourty-line"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("Adesão por Veículo")]), _vm._v(" "), (_vm.newAhesionTaxMan > 0) ? _c('h3', {
	    staticClass: "bold no-margin"
	  }, [_vm._v("\n                " + _vm._s(_vm._f("cents")(_vm.newAhesionTaxMan)) + "\n              ")]) : _c('span', [_c('h4', {
	    staticClass: "promo-value"
	  }, [_vm._v("R$ 39,90")]), _vm._v(" "), _c('b', {
	    staticClass: "promo-free"
	  }, [_vm._v("Grátis")])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "row-button"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-large",
	    attrs: {
	      "tag": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.choose(31)
	      }
	    }
	  }, [_vm._v("\n                Quero este plano!\n              ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 small-padding-left small-padding-right",
	    class: _vm.type != 'newContract' ?
	      _vm.rodosol ?
	      'col-md-12' :
	      'col-md-4' :
	      'col-md-6'
	  }, [_c('div', {
	    staticClass: "third-col"
	  }, [_vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
	    staticClass: "fourty-line"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("Adesão por Veículo")]), _vm._v(" "), (_vm.newAhesionTaxMan > 0) ? _c('h3', {
	    staticClass: "bold no-margin"
	  }, [_vm._v("\n                " + _vm._s(_vm._f("cents")(_vm.newAhesionTaxMan)) + "\n              ")]) : _c('span', [_c('h4', {
	    staticClass: "promo-value"
	  }, [_vm._v("R$ 39,90")]), _vm._v(" "), _c('b', {
	    staticClass: "promo-free"
	  }, [_vm._v("Grátis")])])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
	    staticClass: "row-button"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-large",
	    attrs: {
	      "tag": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.choose(32)
	      }
	    }
	  }, [_vm._v("\n                Quero este plano!\n              ")])])])]), _vm._v(" "), (_vm.type != 'newContract' && !_vm.rodosol) ? _c('div', {
	    staticClass: "col-md-4 small-padding-left"
	  }, [_c('div', {
	    staticClass: "fourth-col"
	  }, [_vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
	    staticClass: "fourty-line"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("Adesão por Veículo")]), _vm._v(" "), (_vm.newAhesionTaxMan > 0) ? _c('h3', {
	    staticClass: "bold no-margin"
	  }, [_vm._v("\n                " + _vm._s(_vm._f("cents")(_vm.newAhesionTaxMan)) + "\n              ")]) : _c('span', [_c('h4', {
	    staticClass: "promo-value"
	  }, [_vm._v("R$ 39,90")]), _vm._v(" "), _c('b', {
	    staticClass: "promo-free"
	  }, [_vm._v("Grátis")])])]), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('div', {
	    staticClass: "row-button"
	  }, [_c('router-link', {
	    staticClass: "btn btn-primary btn-large",
	    attrs: {
	      "to": {
	        name: 'request-proposal',
	        query: {
	          plano: 'Frota'
	        }
	      },
	      "tag": "button"
	    }
	  }, [_vm._v("\n                Quero este plano!\n              ")])], 1)])]) : _vm._e()])])]), _vm._v(" "), _c('card-taxes', {
	    attrs: {
	      "showTaxes": 'pj'
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-2 first-col"
	  }, [_c('div', {
	    staticClass: "first-line border-radius-top"
	  }, [_c('p', {
	    staticClass: "margin-10"
	  }, [_c('i', {
	    staticClass: "icon-plans icon-plans-table"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "second-line"
	  }, [_c('p', {
	    staticClass: "text-question"
	  }, [_vm._v("A quem se destina?")])]), _vm._v(" "), _c('div', {
	    staticClass: "third-line"
	  }, [_c('p', {
	    staticClass: "text-question"
	  }, [_vm._v("Como Funciona?")])]), _vm._v(" "), _c('div', {
	    staticClass: "fourty-line"
	  }, [_c('p', {
	    staticClass: "text-question"
	  }, [_vm._v("Adesão por Veículo")])]), _vm._v(" "), _c('div', {
	    staticClass: "sixty-line"
	  }, [_c('p', {
	    staticClass: "text-question"
	  }, [_vm._v("Formas de Pagamento")])]), _vm._v(" "), _c('div', {
	    staticClass: "eighty-line"
	  }, [_c('p', {
	    staticClass: "text-question"
	  }, [_vm._v("Sujeito à análise de crédito?")])]), _vm._v(" "), _c('div', {
	    staticClass: "seventy-line"
	  }, [_c('p', {
	    staticClass: "text-question"
	  }, [_vm._v("Pode receber Vale-pedágio?")])]), _vm._v(" "), _c('div', {
	    staticClass: "ninety-line"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "first-line"
	  }, [_c('h3', {
	    staticClass: "sub-title plan upper"
	  }, [_vm._v("Controle")]), _vm._v(" "), _c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("Pré-pago com recarga manual")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "second-line"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("A quem se destina?")]), _vm._v(" "), _c('p', [_vm._v("\n                Empresas que querem controle total dos seus gastos e querem\n                planejar as recargas.\n              ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "third-line"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("Como funciona?")]), _vm._v(" "), _c('p', [_vm._v("\n                O próprio cliente efetua a recarga, escolhendo um dos valores\n                disponíveis ou qualquer valor acima de R$ 2.000,00*. Sem taxa\n                de mensalidade. Créditos não expiram. Sem caução."), _c('br'), _vm._v("\n                Saldo compartilhado por todos os veículos."), _c('br'), _vm._v("\n                Disponível no app e no site.\n              ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sixty-line"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("Formas de Pagamento")]), _vm._v(" "), _c('ul', {
	    staticClass: "payment-list"
	  }, [_c('li', [_vm._v("Cartão de Crédito")]), _vm._v(" "), _c('li', [_vm._v("Pix")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "eighty-line"
	  }, [_c('p', [_vm._v("Plano não está sujeito à análise de crédito.")]), _vm._v(" "), _c('p', [_vm._v("Não")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "seventy-line"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("Pode receber Vale-pedágio?")]), _vm._v(" "), _c('p', [_vm._v("Sim")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "first-line"
	  }, [_c('h3', {
	    staticClass: "sub-title plan upper"
	  }, [_vm._v("Estradeiro")]), _vm._v(" "), _c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("Pré-pago com recarga automática")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "second-line"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("A quem se destina?")]), _vm._v(" "), _c('p', [_vm._v("\n                Empresas que querem a certeza de sempre ter saldo disponível\n                para uso.\n              ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "third-line"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("Como funciona?")]), _vm._v(" "), _c('p', [_vm._v("\n                As recargas ocorrem automaticamente, quando o saldo atingir\n                30% do valor que o cliente escolher ou definir acima de R$\n                2.000,00*. Ex.: Cliente escolhe R$ 500,00. Quando o saldo\n                chegar a R$ 150,00, uma nova recarga é acionada\n                automaticamente."), _c('br'), _vm._v("\n                Sem taxa de mensalidade. Créditos não expiram. Sem caução."), _c('br'), _vm._v("\n                Saldo compartilhado por todos os veículos."), _c('br'), _vm._v("\n                Disponível no app e no site.\n              ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sixty-line"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("Formas de Pagamento")]), _vm._v(" "), _c('ul', {
	    staticClass: "payment-list"
	  }, [_c('li', [_vm._v("Cartão de Crédito")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "eighty-line"
	  }, [_c('p', [_vm._v("Plano não está sujeito à análise de crédito.")]), _vm._v(" "), _c('p', [_vm._v("Não")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "seventy-line"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("Pode receber Vale-pedágio?")]), _vm._v(" "), _c('p', [_vm._v("Sim")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "first-line"
	  }, [_c('h3', {
	    staticClass: "sub-title plan upper"
	  }, [_vm._v("Frota")]), _vm._v(" "), _c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("Pós-pago com mensalidade")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "second-line"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("A quem se destina?")]), _vm._v(" "), _c('p', [_vm._v("\n                Empresas que precisam da confiabilidade do serviço e da\n                tranquilidade financeira.\n              ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "third-line"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("Como funciona?")]), _vm._v(" "), _c('p', [_vm._v("\n                O cliente conta com uma linha de crédito para pagamento pós\n                uso e a facilidade de prever o custo por meio de mensalidades\n                fixas. A fatura será emitida em prazos pré-definidos. Sem\n                custo de recarga."), _c('br'), _vm._v("\n                Disponível no site.\n              ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sixty-line"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("Formas de Pagamento")]), _vm._v(" "), _c('ul', {
	    staticClass: "payment-list"
	  }, [_c('li', [_vm._v("Débito Automático")]), _vm._v(" "), _c('li', [_vm._v("Boleto Bancário")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "eighty-line"
	  }, [_c('p', [_vm._v("Plano está sujeito à análise de crédito.")]), _vm._v(" "), _c('p', [_vm._v("Sim")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "seventy-line"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }, [_vm._v("Pode receber Vale-pedágio?")]), _vm._v(" "), _c('p', [_vm._v("Sim")])])
	}]}

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "row row-fix"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {}, [(_vm.formState == 'ERROR') ? _c('div', {
	    staticClass: "alert alert-danger alert-dismissible margin-b20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Erro!")]), _vm._v(" " + _vm._s(_vm.errorMessage) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'SUCCESS') ? _c('div', {
	    staticClass: "alert alert-success alert-dismissible margin-t20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Sucesso!")]), _vm._v(" As informações foram enviadas, obrigado! ;)\n            ")]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.formState == 'NEW' || _vm.formState == 'ERROR') ? _c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "autocomplete": "false"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.doRequest.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('nome')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-4 control-label",
	    attrs: {
	      "for": "nome",
	      "required": ""
	    }
	  }, [_vm._v("\n                  Razão Social*\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.faleConosco.nome),
	      expression: "faleConosco.nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "nome",
	      "id": "nome",
	      "data-vv-rules": "required",
	      "autofocus": ""
	    },
	    domProps: {
	      "value": (_vm.faleConosco.nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.faleConosco, "nome", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('nome')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('telefone')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-4 control-label",
	    attrs: {
	      "for": "telefone"
	    }
	  }, [_vm._v("\n                  Telefone\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.faleConosco.telefone),
	      expression: "faleConosco.telefone",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "mask-tel",
	      rawName: "v-mask-tel"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "telefone",
	      "id": "telefone"
	    },
	    domProps: {
	      "value": (_vm.faleConosco.telefone)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.faleConosco, "telefone", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('telefone')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('documento')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-4 control-label",
	    attrs: {
	      "for": "documento"
	    }
	  }, [_vm._v("\n                  CNPJ*\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.faleConosco.documento),
	      expression: "faleConosco.documento",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "mask-cpf-cnpj",
	      rawName: "v-mask-cpf-cnpj"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cpfCnpj'),
	      expression: "'required|cpfCnpj'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2}|[0-9]{3}\\.[0-9]{3}\\.[0-9]{3}-[0-9]{2}|[0-9]{11})$",
	      "name": "documento",
	      "id": "documento",
	      "data-vv-validate-on": "blur"
	    },
	    domProps: {
	      "value": (_vm.faleConosco.documento)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.faleConosco, "documento", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('documento')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('email')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-4 control-label",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("\n                  E-mail*\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.faleConosco.email),
	      expression: "faleConosco.email"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "email",
	      "name": "email",
	      "id": "email",
	      "data-vv-rules": "required|email|email:email"
	    },
	    domProps: {
	      "value": (_vm.faleConosco.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.faleConosco, "email", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('email')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b0",
	    class: {
	      'has-error': _vm.errors.has('assunto')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-4 control-label",
	    attrs: {
	      "for": "assunto"
	    }
	  }, [_vm._v("\n                  Segmento*\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8"
	  }, [_c('dropdown', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "dropdown-lg",
	    attrs: {
	      "options": _vm.subject,
	      "name": "assunto",
	      "id": "assunto",
	      "data-vv-rules": "required"
	    },
	    model: {
	      value: (_vm.faleConosco.assuntoId),
	      callback: function($$v) {
	        _vm.$set(_vm.faleConosco, "assuntoId", $$v)
	      },
	      expression: "faleConosco.assuntoId"
	    }
	  }), _vm._v("\n                   \n                  "), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('assunto')))])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('mensagem')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-4 control-label",
	    attrs: {
	      "for": "mensagem"
	    }
	  }, [_vm._v("\n                  Informações complementares*\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.faleConosco.mensagem),
	      expression: "faleConosco.mensagem"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "mensagem",
	      "name": "mensagem",
	      "rows": "5",
	      "cols": "80",
	      "data-vv-rules": "required",
	      "placeholder": "Ex: nome completo, cidade, etc..."
	    },
	    domProps: {
	      "value": (_vm.faleConosco.mensagem)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.faleConosco, "mensagem", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block-proposal help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('mensagem')))])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)]) : _vm._e()])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("\n        Seja Nosso Parceiro\n      ")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('img', {
	    staticClass: "img-contact",
	    attrs: {
	      "src": __webpack_require__(1815),
	      "alt": "Contato"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', {
	    staticClass: "text-align-right"
	  }, [_c('strong', [_vm._v("Preencha os dados e saiba mais! ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-offset-4 col-sm-8 pad-fix"
	  }, [_c('div', {
	    attrs: {
	      "id": "privacyContainer"
	    }
	  }, [_c('span', [_vm._v(" Ao continuar você está de acordo com o nosso\n                      "), _c('a', {
	    attrs: {
	      "id": "spanPrivacyLink",
	      "href": "/api/v2/archeion/downloadFileArcheion/aviso-de-privacidade-movemais",
	      "target": "_blank"
	    }
	  }, [_vm._v("Aviso de Privacidade.\n                          ")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-offset-4 col-sm-8 pad-fix"
	  }, [_c('button', {
	    staticClass: "btn btn-lg btn-primary",
	    attrs: {
	      "id": "btn-enviar",
	      "type": "submit",
	      "name": "button"
	    }
	  }, [_vm._v("\n                Enviar\n              ")]), _vm._v(" "), _c('i', {
	    staticClass: "icon-circle-right align-icon"
	  })])
	}]}

/***/ }),
/* 2129 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade in modal-auto",
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header modal-info"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.hideModal()
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Alterar Valor da Recarga Automática")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('p', {
	    staticClass: "bold-600 text-center no-margin"
	  }, [_vm._v("Valor da Recarga")]), _vm._v(" "), _c('dropdown', {
	    staticClass: "dropdown-recharge text-right recharge-value-dropdown",
	    attrs: {
	      "options": _vm.rechargesData,
	      "value": _vm.value
	    },
	    on: {
	      "itemSelected": _vm.changeRecharge
	    },
	    model: {
	      value: (_vm.value),
	      callback: function($$v) {
	        _vm.value = $$v
	      },
	      expression: "value"
	    }
	  }), _vm._v(" "), (_vm.value == -1) ? _c('div', {
	    staticClass: "row margin-t20"
	  }, [_c('div', {
	    staticClass: "form-group col-xs-12",
	    class: {
	      'has-error': _vm.errors.has('valueTotal')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|recargaMinima:' + _vm.minValue),
	      expression: "'required|recargaMinima:' + minValue"
	    }],
	    staticClass: "form-control text-right input-recharge",
	    attrs: {
	      "id": "valueTotal",
	      "type": "text",
	      "name": "valueTotal",
	      "placeholder": "R$ 00,00",
	      "spellcheck": "false",
	      "autocomplete": "off",
	      "autocorrect": "off",
	      "autocapitalize": "off",
	      "autofocus": ""
	    },
	    domProps: {
	      "value": _vm.valueFormatted
	    },
	    on: {
	      "input": function($event) {
	        return _vm.setTotal($event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block help-block-recharge with-errors"
	  }, [_vm._v("\n              " + _vm._s(_vm.errors.first("valueTotal")) + "\n            ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "recharge-open-tax"
	  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v(_vm._s(_vm._f("cents")(_vm.tax)))])])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.hideModal()
	      }
	    }
	  }, [_vm._v("\n          Cancelar\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.alterRechargeUnit()
	      }
	    }
	  }, [_vm._v("\n          Confimar\n        ")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2130 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("\n        Planos\n        "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n        Contrato " + _vm._s(_vm.contractId) + "\n        "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Extrato\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t30"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('form', {
	    staticClass: "form form-inline",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.doFilter(true)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "inline filter-period"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('span', {
	    staticClass: "period"
	  }, [_vm._v("Período:")]), _vm._v(" "), _c('dropdown', {
	    staticClass: "dropdown-lastdays",
	    attrs: {
	      "options": _vm.lastDaysOptions
	    },
	    model: {
	      value: (_vm.lastDays),
	      callback: function($$v) {
	        _vm.lastDays = $$v
	      },
	      expression: "lastDays"
	    }
	  }), _vm._v(" \n                ")], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.lastDays == 'custom'),
	      expression: "lastDays == 'custom'"
	    }],
	    staticClass: "inline filter-range"
	  }, [_c('div', {
	    staticClass: "inline margin-side"
	  }, [_c('div', {
	    staticClass: "form-group form-inline",
	    class: {
	      'has-error': _vm.errors.has('Data-inicial')
	    }
	  }, [_c('label', [_vm._v("De:")]), _vm._v(" "), _c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control picker statement",
	    attrs: {
	      "name": "Data-inicial",
	      "format": "dd/MM/yyyy",
	      "language": "pt-br",
	      "data-vv-rules": "required"
	    },
	    model: {
	      value: (_vm.customStart),
	      callback: function($$v) {
	        _vm.customStart = $$v
	      },
	      expression: "customStart"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("Data-inicial")) + "\n                  ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "inline margin-side"
	  }, [_c('div', {
	    staticClass: "form-group form-inline",
	    class: {
	      'has-error': _vm.errors.has('Data-final')
	    }
	  }, [_c('label', [_vm._v("Até:")]), _vm._v(" "), _c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control picker statement",
	    attrs: {
	      "name": "Data-final",
	      "format": "dd/MM/yyyy",
	      "language": "pt-br",
	      "data-vv-as": "data inicial"
	    },
	    model: {
	      value: (_vm.customEnd),
	      callback: function($$v) {
	        _vm.customEnd = $$v
	      },
	      expression: "customEnd"
	    }
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("Data-final")) + "\n                  ")])], 1)])]), _vm._v(" "), (_vm.plan != 7) ? _c('div', {
	    staticClass: "inline filter-plate"
	  }, [_c('div', {
	    staticClass: "inline margin-10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.showPlate),
	      expression: "showPlate"
	    }],
	    staticClass: "check-terms",
	    attrs: {
	      "id": "filter-plate",
	      "type": "checkbox",
	      "name": "filter-plate",
	      "value": ""
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.showPlate) ? _vm._i(_vm.showPlate, "") > -1 : (_vm.showPlate)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.showPlate,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.showPlate = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.showPlate = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.showPlate = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "label-terms",
	    attrs: {
	      "for": "filter-plate"
	    }
	  }, [_vm._v("Filtrar por Placa")])]), _vm._v(" "), (_vm.showPlate) ? _c('div', {
	    staticClass: "form-group form-plate",
	    class: {
	      'has-error': _vm.errors.has('plate')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.plate),
	      expression: "plate"
	    }, {
	      name: "mask-plate",
	      rawName: "v-mask-plate"
	    }],
	    staticClass: "form-control plate-field upper",
	    attrs: {
	      "type": "search",
	      "name": "plate",
	      "placeholder": "Digite a Placa"
	    },
	    domProps: {
	      "value": (_vm.plate)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.doFilter(true)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.plate = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first("plate")))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "inline filter-button text-center"
	  }, [_c('button', {
	    staticClass: "btn btn-purple btn-sm btn-filter",
	    attrs: {
	      "type": "button",
	      "name": "btnFind"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.doFilter(true)
	      }
	    }
	  }, [_vm._v("\n                Filtrar\n              ")])]), _vm._v(" "), (_vm.plan != 7) ? _c('div', {
	    staticClass: "inline filter-button text-center"
	  }, [_c('a', {
	    staticClass: "btn btn-download-excel bold btn-filter",
	    class: {
	      'btn-consolidated-disabled': !_vm.canDownloadConsolidated || _vm.downloadingConsolidated
	    },
	    attrs: {
	      "target": "_blank",
	      "aria-disabled": !_vm.canDownloadConsolidated || _vm.downloadingConsolidated,
	      "type": "button",
	      "name": "button",
	      "download": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.doFilterDownload()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-xls align-icon-left-white"
	  }), _vm._v("\n                Extrato Consolidado\n              ")])]) : _vm._e()])])]), _vm._v(" "), (_vm.searchState == 'NOTFOUND') ? _c('div', {
	    staticClass: "alert alert-warning margin-t10"
	  }, [_vm._v("\n        Nenhum dado encontrado no período.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.searchState == 'ERROSEARCH') ? _c('div', {
	    staticClass: "alert alert-danger margin-t10"
	  }, [_c('ol', [_c('li', [_vm._v(_vm._s(_vm.messageError))])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [(_vm.searchState == 'FOUND') ? [(_vm.data) ? _c('div', {
	    staticClass: "row margin-t20 resumo-table",
	    attrs: {
	      "id": "resumeTable"
	    }
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('table', {
	    staticClass: "table no-footer",
	    attrs: {
	      "role": "grid"
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.data.summary), function(s, index) {
	    return _c('tr', {
	      attrs: {
	        "role": "row"
	      }
	    }, [_c('td', [_vm._v(_vm._s(_vm._f("barWrap")(s.historic)))]), _vm._v(" "), _c('td', {
	      staticClass: "text-right"
	    }, [_vm._v(_vm._s(s.quantity))]), _vm._v(" "), _c('td', {
	      staticClass: "text-right"
	    }, [_c('span', {
	      class: _vm.numberClass(s)
	    }, [_vm._v(_vm._s(s.type == "D" ? "R$ - " : "R$ ") + _vm._s(_vm._f("centsNoSymbol")(s.value)))])])])
	  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.checkPlan()) ? _c('div', {
	    staticClass: "statement-header-info"
	  }, [_c('p', {
	    staticClass: "inline description-box"
	  }), _vm._v(" "), _c('p', {
	    staticClass: "inline date-box"
	  }), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.data) ? _c('div', {
	    staticClass: "content-box result"
	  }, [_c('ul', {
	    staticClass: "result-list"
	  }, _vm._l((_vm.data.statements.itens), function(t, index) {
	    return _c('li', {
	      key: t.id
	    }, [_c('div', {
	      staticClass: "margin-t10"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.listTransactionRefund),
	        expression: "listTransactionRefund"
	      }],
	      staticClass: "check-item",
	      attrs: {
	        "type": "checkbox",
	        "name": "listTransactionRefund",
	        "id": t.id
	      },
	      domProps: {
	        "value": t.id,
	        "checked": Array.isArray(_vm.listTransactionRefund) ? _vm._i(_vm.listTransactionRefund, t.id) > -1 : (_vm.listTransactionRefund)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = _vm.listTransactionRefund,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = t.id,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.listTransactionRefund = $$a.concat([$$v]))
	            } else {
	              $$i > -1 && (_vm.listTransactionRefund = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.listTransactionRefund = $$c
	          }
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      staticClass: "label-item",
	      class: {
	        'passage-labelb':
	        t.idHistoric == 1101 || t.idHistoric == 2101,
	      },
	      attrs: {
	        "for": t.id
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "timeline",
	      class: {
	        'margin-b10': t.idHistoric == 1332
	      }
	    }, [_c('div', {
	      staticClass: "inline text-center timeline-icon"
	    }, [_c('div', {
	      staticClass: "icon-bg",
	      class: {
	        'margin-5':
	        t.idHistoric == 1101 ||
	          t.idHistoric == 2101 ||
	          t.idHistoric == 1327 ||
	          t.idHistoric == 2327,
	      }
	    }, [_c('i', {
	      class: _vm.getClassIcon(t)
	    })])]), _vm._v(" "), (
	      t.idHistoric == 1101 ||
	      t.idHistoric == 2101 ||
	      t.idHistoric == 1327 ||
	      t.idHistoric == 2327
	    ) ? _c('div', {
	      staticClass: "inline description-box"
	    }, [_c('div', {
	      staticClass: "inline line-height-1"
	    }, [_c('b', {
	      staticClass: "upper block"
	    }, [_vm._v(_vm._s(t.description))]), _vm._v(" "), _c('div', {
	      staticClass: "plate-box"
	    }, [_c('p', {
	      staticClass: "cell-plate"
	    }, [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.plate = t.plate;
	          _vm.doFilter(true);
	        }
	      }
	    }, [_c('span', [_vm._v(_vm._s(_vm._f("plate")(t.plate)))])])])]), _vm._v(" "), _c('div', {
	      staticClass: "inline"
	    }, [_c('div', {
	      staticClass: "expand-item"
	    }, [_c('i', {
	      staticClass: "icon-road"
	    }), _vm._v(" "), _c('p', {
	      staticClass: "inline no-margin"
	    }, [_vm._v("\n                              " + _vm._s(t.description) + "\n                            ")])]), _vm._v(" "), _c('div', {
	      staticClass: "expand-item"
	    }, [_c('i', {
	      staticClass: "icon-axis"
	    }), _vm._v(" "), _c('p', {
	      staticClass: "inline no-margin"
	    }, [_vm._v("\n                              CAT" + _vm._s(t.classifiedClass < 10 ?
	      "0" +
	      t.classifiedClass +
	      " - " +
	      t.categoryAxesName :
	      t.classifiedClass +
	      " - " +
	      t.categoryAxesName) + "\n                            ")])])])])]) : (t.idHistoric == 1313 || t.idHistoric == 1314) ? _c('div', {
	      staticClass: "inline middle description-box"
	    }, [_c('b', {
	      staticClass: "upper middle"
	    }, [_vm._v(_vm._s(t.description))])]) : (t.idHistoric == 1332) ? _c('div', {
	      staticClass: "inline middle description-box line-height-1"
	    }, [_c('b', {
	      staticClass: "upper middle block"
	    }, [_vm._v(_vm._s(t.description))]), _vm._v(" "), _c('div', {
	      staticClass: "plate-box"
	    }, [_c('p', {
	      staticClass: "cell-plate"
	    }, [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.plate = t.plate;
	          _vm.doFilter(true);
	        }
	      }
	    }, [_c('span', [_vm._v(_vm._s(_vm._f("plate")(t.plate)))])])])])]) : _c('div', {
	      staticClass: "inline middle description-box"
	    }, [_c('b', {
	      staticClass: "upper middle"
	    }, [_vm._v(_vm._s(_vm._f("barWrap")(t.description)))])]), _vm._v(" "), (
	      t.idHistoric == 1101 ||
	      t.idHistoric == 2101 ||
	      t.idHistoric == 1327 ||
	      t.idHistoric == 2327
	    ) ? _c('div', {
	      staticClass: "inline date-box pass-box"
	    }, [_c('div', {
	      staticClass: "inline pass"
	    }, [_c('b', {
	      staticClass: "middle block"
	    }, [_vm._v("Passagem em")]), _vm._v(" "), _c('div', {
	      staticClass: "inline line-height-2"
	    }, [_c('p', {
	      staticClass: "no-margin"
	    }, [_vm._v("\n                            " + _vm._s(_vm._f("date")(t.occurrenceDate)) + "\n                          ")]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin"
	    }, [_vm._v("\n                            " + _vm._s(_vm._f("time")(t.occurrenceDate)) + "\n                          ")])]), _vm._v(" "), _c('i', {
	      staticClass: "icon-info",
	      attrs: {
	        "data-toggle": "tooltip",
	        "data-placement": "top",
	        "title": "Data de ocorrência"
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "inline"
	    }, [_c('b', {
	      staticClass: "middle block"
	    }, [_vm._v("Recebida em")]), _vm._v(" "), _c('div', {
	      staticClass: "inline line-height-2"
	    }, [_c('p', {
	      staticClass: "no-margin"
	    }, [_vm._v("\n                            " + _vm._s(_vm._f("date")(t.processingDate)) + "\n                          ")]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin"
	    }, [_vm._v("\n                            " + _vm._s(_vm._f("time")(t.processingDate)) + "\n                          ")])]), _vm._v(" "), _c('i', {
	      staticClass: "icon-info",
	      attrs: {
	        "data-toggle": "tooltip",
	        "data-placement": "top",
	        "title": "Data de processamento"
	      }
	    })])]) : _c('div', {
	      staticClass: "inline date-box"
	    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
	      staticClass: "inline line-height-2"
	    }, [_c('p', {
	      staticClass: "no-margin"
	    }, [_vm._v(_vm._s(_vm._f("date")(t.processingDate)))]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin"
	    }, [_vm._v(_vm._s(_vm._f("time")(t.processingDate)))])]), _vm._v(" "), _c('i', {
	      staticClass: "icon-info",
	      attrs: {
	        "data-toggle": "tooltip",
	        "data-placement": "top",
	        "title": "Data de processamento"
	      }
	    })]), _vm._v(" "), (_vm.checkPlan()) ? _c('div', {
	      staticClass: "value-box"
	    }, [_vm._m(4, true), _vm._v(" "), _c('div', {}, [_c('p', {
	      staticClass: "inline text-right pass-box",
	      class: _vm.getValueClass(t)
	    }, [_vm._v("\n                          R$\n                          "), _c('b', [_vm._v(_vm._s(_vm._f("centsNoSymbol")(t.value)))])]), _vm._v(" "), _c('p', {
	      staticClass: "inline text-right pass-box balance",
	      class: t.saldoDepois >= 0 ? 'blue' : 'red'
	    }, [_vm._v("\n                          R$\n                          "), _c('b', [_vm._v(_vm._s(_vm._f("centsNoSymbol")(t.saldoDepois)))])])])]) : _c('div', {
	      staticClass: "value-box velse"
	    }, [_vm._m(5, true), _vm._v(" "), _c('div', {}, [_c('p', {
	      staticClass: "inline text-right pass-box",
	      class: _vm.getValueClass(t)
	    }, [_vm._v("\n                          R$\n                          "), _c('b', [_vm._v(_vm._s(_vm._f("centsNoSymbol")(t.value)))])])])])])]), _vm._v(" "), _c('hr', {
	      staticClass: "separator"
	    })])
	  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row row-fix result-bar"
	  }, [_c('div', {
	    staticClass: "text-left col-md-4"
	  }, [_c('p', [_vm._v("\n                Itens selecionados:\n                "), _c('span', [_vm._v(_vm._s(_vm.listTransactionRefund.length))])])]), _vm._v(" "), _c('div', {
	    staticClass: "export-content col-md-8"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-sm margin-10",
	    class: {
	      'btn-purple': _vm.listTransactionRefund.length > 0,
	        disabled: _vm.listTransactionRefund.length == 0,
	    },
	    attrs: {
	      "type": "button",
	      "name": "btnFind"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.downloadExtractFile('partial')
	      }
	    }
	  }, [_vm._v("\n                Exportar selecionados\n              ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-sm margin-10",
	    attrs: {
	      "type": "button",
	      "name": "btnFind"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.downloadExtractFile('full')
	      }
	    }
	  }, [_vm._v("\n                Exportar tudo\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 text-center"
	  }, [_c('pagination', {
	    attrs: {
	      "model": _vm.page
	    },
	    on: {
	      "page-change": _vm.setCurrentPage
	    }
	  })], 1)]), _vm._v(" "), (_vm.data && _vm.data.transactions && _vm.data.transactions.transaction) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 result-table-count text-center"
	  }, [_vm._v("\n              Mostrando resultados de " + _vm._s(_vm.page.firstIndexShown()) + " a\n              " + _vm._s(_vm.page.lastIndexShown()) + " de um total de\n              " + _vm._s(_vm.page.itemCount()) + "\n              encontrados.\n            ")])]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "myDiv"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back margin-t20",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v(" Voltar\n          ")])], 1)])], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('b', [_c('i', {
	    staticClass: "icon-info",
	    attrs: {
	      "data-toggle": "tooltip",
	      "data-placement": "bottom",
	      "title": "A data de processamento que será considerada na filtragem."
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_c('h4', {
	    staticClass: "title-box"
	  }, [_vm._v("Resumo do Período")])])]), _vm._v(" "), _c('tr', {
	    attrs: {
	      "role": "row"
	    }
	  }, [_c('th', {
	    staticClass: "resume-transaction-col"
	  }, [_vm._v("Tipo de transação")]), _vm._v(" "), _c('th', {
	    staticClass: "resume-amount-col"
	  }), _vm._v(" "), _c('th', {
	    staticClass: "resume-value-col"
	  }, [_vm._v("Valor em R$")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline value-box"
	  }, [_c('p', {
	    staticClass: "inline bold text-right",
	    staticStyle: {
	      "padding-right": "5px"
	    }
	  }, [_vm._v("\n                Valor\n              ")]), _vm._v(" "), _c('p', {
	    staticClass: "inline bold text-right",
	    staticStyle: {
	      "padding-right": "15px"
	    }
	  }, [_vm._v("\n                Saldo\n                "), _c('i', {
	    staticClass: "icon-info",
	    attrs: {
	      "data-toggle": "tooltip",
	      "data-placement": "top",
	      "title": "Saldo após transação"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "time-box inline"
	  }, [_c('i', {
	    staticClass: "icon-clock"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "statement-header-info-inside"
	  }, [_c('p', {
	    staticClass: "inline text-right bold"
	  }, [_vm._v("Valor")]), _vm._v(" "), _c('p', {
	    staticClass: "inline text-right bold"
	  }, [_vm._v("Saldo")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "statement-header-info-inside"
	  }, [_c('p', {
	    staticClass: "inline text-right bold"
	  }, [_vm._v("Valor")])])
	}]}

/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "row margin-20"
	  }, [_vm._v("\n      Para saber a posição correta de instalação, selecione a categoria do veículo abaixo:\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "row text-center"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.scroll('guide-light-vehicles')
	      }
	    }
	  }, [_vm._m(2)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.scroll('guide-heavy-vehicles')
	      }
	    }
	  }, [_vm._m(3)])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("Guia de instalação do TAG")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('h4', {
	    staticClass: "bold margin-20"
	  }, [_vm._v("Aprenda aqui como instalar seu TAG Move Mais, de maneira rápida e prática.")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "alert alert-info"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-10"
	  }, [_c('div', {
	    staticClass: "alert-info-title"
	  }, [_vm._v("Importante!")]), _vm._v(" "), _c('span', {
	    staticClass: "alert-info-txt"
	  }, [_vm._v("O TAG deve ser colado dentro do veículo, na parte interna do para-brisa e em posição horizontal, pois não irá funcionar se estiver em outra posição.")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('img', {
	    staticClass: "img-tag-fix",
	    attrs: {
	      "src": __webpack_require__(1796),
	      "alt": ""
	    }
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-light-vehicles"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1780),
	      "alt": "",
	      "width": "25%"
	    }
	  }), _vm._v(" "), _c('h4', {
	    staticClass: "sub-title light-vehicles"
	  }, [_vm._v("Veículos Leves")]), _vm._v(" "), _c('b', [_vm._v("Automóveis, Utilitários, Caminhonetes, etc.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-heavy-vehicles"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1779),
	      "alt": "",
	      "width": "25%"
	    }
	  }), _vm._v(" "), _c('h4', {
	    staticClass: "sub-title heavy-vehicles",
	    attrs: {
	      "id": "guide-light-vehicles"
	    }
	  }, [_vm._v("Veículos Pesados")]), _vm._v(" "), _c('b', [_vm._v("Ônibus, Micro-ônibus, Caminhões, etc.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "content-box"
	  }, [_c('h3', {
	    staticClass: "sub-title light-vehicles"
	  }, [_vm._v("Veiculos Leves")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row margin-b20"
	  }, [_c('div', {
	    staticClass: "col-md-7"
	  }, [_c('img', {
	    staticClass: "img-border",
	    attrs: {
	      "src": __webpack_require__(1793),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1787),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "text-caption"
	  }, [_vm._v("\n                  A maioria dos veículos leves possuem uma área livre próximo ao retrovisor para a aplicação do TAG.\n                ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-b20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h4', {
	    staticClass: "sub-title"
	  }, [_vm._v("Com retícula")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('img', {
	    staticClass: "img-border",
	    attrs: {
	      "src": __webpack_require__(1789),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1788),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "text-caption"
	  }, [_vm._v("\n                  Caso o veículo tenha retícula (área pontilhada), o TAG deve ser colado fora desta área, logo abaixo, de preferência centralizado no para-brisa.\n                ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-b20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h4', {
	    staticClass: "sub-title"
	  }, [_vm._v("Com suporte ao retrovisor")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('img', {
	    staticClass: "img-border",
	    attrs: {
	      "src": __webpack_require__(1792),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1791),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "text-caption"
	  }, [_vm._v("\n                  Há veículos que possuem um suporte ao retrovisor no centro do para-brisa. Neste tipo de veículo, o TAG deve ser colado\nem qualquer um dos lados desse suporte, mas deve também respeitar 4 dedos de distância do topo do para-brisa.\n                ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-b20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h4', {
	    staticClass: "sub-title"
	  }, [_vm._v("Com para-brisa panorâmico")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('img', {
	    staticClass: "img-border",
	    attrs: {
	      "src": __webpack_require__(1790),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "text-caption"
	  }, [_vm._v("\n                  Caso o veículo tenha retícula (área pontilhada), o TAG deve ser colado fora desta área, logo abaixo, de preferência centralizado no para-brisa.\n                ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "position-link",
	    attrs: {
	      "id": "guide-heavy-vehicles"
	    }
	  })])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "content-box"
	  }, [_c('h3', {
	    staticClass: "sub-title heavy-vehicles"
	  }, [_vm._v("Veículos Pesados")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row margin-b20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "text-caption"
	  }, [_vm._v("\n                  Independentemente de marca ou modelo, a posição do TAG no vidro nunca pode ser coberta pelo curso do limpador do para-brisa. Ache o melhor local com o limpador funcionando.\n                ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-b20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h4', {
	    staticClass: "sub-title upper"
	  }, [_vm._v("Caminhões")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('img', {
	    staticClass: "img-border",
	    attrs: {
	      "src": __webpack_require__(1795),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1794),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "text-caption"
	  }, [_vm._v("\n                  O TAG deve ser colado 10 dedos acima do rodapé do para-brisa, no centro do vidro.\n                ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-b20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h4', {
	    staticClass: "sub-title upper"
	  }, [_vm._v("Ônibus")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h4', {
	    staticClass: "sub-title"
	  }, [_vm._v("Com limpador de para-brisa de baixo para cima")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('img', {
	    staticClass: "img-border",
	    attrs: {
	      "src": __webpack_require__(1783),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1782),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "text-caption"
	  }, [_vm._v("\n                  O TAG deve ser colado a uma distância de 1,20m do chão. Caso exista uma barra central no vidro, cole a\n                  uma distância mínima lateral de 4 dedos da barra.\n                ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-b20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h4', {
	    staticClass: "sub-title"
	  }, [_vm._v("Com limpador de para-brisa de cima para baixo")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('img', {
	    staticClass: "img-border",
	    attrs: {
	      "src": __webpack_require__(1785),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1781),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "text-caption"
	  }, [_vm._v("\n                  O TAG deve ser colado a uma distância de 1,20m do chão. Caso exista uma barra central no vidro, cole a\n                  uma distância mínima lateral de 4 dedos da barra.\n                ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-b20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h4', {
	    staticClass: "sub-title"
	  }, [_vm._v("Com limpador de para-brisa de dentro para fora")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('img', {
	    staticClass: "img-border",
	    attrs: {
	      "src": __webpack_require__(1786),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1784),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "text-caption"
	  }, [_vm._v("\n                  O TAG deve ser colado a uma distância entre 1,40m e 1,90m a partir do chão do veículo. Caso exista uma barra central no\n                  vidro, cole a uma distância mínima lateral de 4 dedos da barra.\n                ")])])])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "alert alert-warning margin-t30"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "alert-info-title margin-b10"
	  }, [_vm._v("Veículos com particularidades")]), _vm._v("\n          Há veículos que possuem particularidades que podem atrapalhar ou mesmo impedir o funcionamento do TAG. Algumas particularidades que podem\n          ocasionar problemas de funcionamento: desembaçador de vidro, blindagem e películas com componentes metálicos etc.\n          "), _c('br'), _c('br'), _vm._v("\n          Verifique sempre com os fabricantes e, em caso de dúvida, entre em contato com nossa "), _c('b', [_vm._v("Central de Relacionamento pelo número 4000 2901\n          (regiões metropolitanas) ou 0800 777 1022 (demais localidades).")]), _vm._v(".\n        ")])])])
	}]}

/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "row row-fix"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {}, [(_vm.formState == 'ERROR') ? _c('div', {
	    staticClass: "alert alert-danger alert-dismissible margin-b20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Erro!")]), _vm._v(" " + _vm._s(_vm.errorMessage) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'LEAD-INFO') ? _c('div', {
	    staticClass: "alert alert-info alert-dismissible margin-b20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Informação!")]), _vm._v("\n              " + _vm._s(_vm.leadClient ?
	    "Caro cliente, sua solicitação encontra-se em análise. Em caso de dúvidas, por gentileza, entre em contato no número 08007651000" :
	    "Solicitação em análise. Em caso de dúvidas, por gentileza, entre em contato com o número 08007651000.") + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'SUCCESS') ? _c('div', {
	    staticClass: "alert alert-success alert-dismissible margin-t20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Sucesso!")]), _vm._v(" As informações foram enviadas, em\n              breve entraremos em contato para finalizar a adesão, obrigado!\n            ")]) : _vm._e(), _vm._v(" "), (
	    _vm.formState == 'LEAD-INFO' ||
	    _vm.formState == 'NEW' ||
	    _vm.formState == 'ERROR'
	  ) ? _c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "autocomplete": "false"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.doRequest.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('taxpayerIdNumber')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-4 control-label",
	    attrs: {
	      "for": "taxpayerIdNumber"
	    }
	  }, [_vm._v("\n                  CNPJ*\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.taxpayerIdNumber),
	      expression: "taxpayerIdNumber",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "mask-cnpj",
	      rawName: "v-mask-cnpj"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cnpj'),
	      expression: "'required|cnpj'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2})$",
	      "name": "taxpayerIdNumber",
	      "id": "taxpayerIdNumber",
	      "data-vv-validate-on": "blur"
	    },
	    domProps: {
	      "value": (_vm.taxpayerIdNumber)
	    },
	    on: {
	      "change": function($event) {
	        _vm.taxpayerIdNumber = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("taxpayerIdNumber")) + "\n                  ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('companyName')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-4 control-label",
	    attrs: {
	      "for": "companyName"
	    }
	  }, [_vm._v("\n                  Empresa*\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.companyName),
	      expression: "companyName"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "companyName",
	      "id": "companyName",
	      "data-vv-rules": "required"
	    },
	    domProps: {
	      "value": (_vm.companyName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.companyName = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("companyName")) + "\n                  ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('contactName')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-4 control-label",
	    attrs: {
	      "for": "contactName",
	      "required": ""
	    }
	  }, [_vm._v("\n                  Nome do Contato*\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contactName),
	      expression: "contactName"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "contactName",
	      "id": "contactName",
	      "data-vv-rules": "required"
	    },
	    domProps: {
	      "value": (_vm.contactName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.contactName = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("contactName")) + "\n                  ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('contactEmail')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-4 control-label",
	    attrs: {
	      "for": "contactEmail"
	    }
	  }, [_vm._v("\n                  E-mail*\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contactEmail),
	      expression: "contactEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "email",
	      "name": "contactEmail",
	      "id": "contactEmail",
	      "data-vv-rules": "required|email|email:email"
	    },
	    domProps: {
	      "value": (_vm.contactEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.contactEmail = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("contactEmail")) + "\n                  ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('contactJobTitle')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-4 control-label",
	    attrs: {
	      "for": "contactJobTitle"
	    }
	  }, [_vm._v("\n                  Telefone*\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.contactJobTitle),
	      expression: "contactJobTitle",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "mask-tel",
	      rawName: "v-mask-tel"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|generalMask'),
	      expression: "'required|generalMask'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "contactJobTitle",
	      "id": "contactJobTitle"
	    },
	    domProps: {
	      "value": (_vm.contactJobTitle)
	    },
	    on: {
	      "change": function($event) {
	        _vm.contactJobTitle = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("contactJobTitle")) + "\n                  ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('sizeOfFleetVehicle')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-4 control-label",
	    attrs: {
	      "for": "sizeOfFleetVehicle"
	    }
	  }, [_vm._v("\n                  Tamanho da Frota*\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sizeOfFleetVehicle),
	      expression: "sizeOfFleetVehicle"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }, {
	      name: "only-numbers",
	      rawName: "v-only-numbers"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "sizeOfFleetVehicle",
	      "id": "sizeOfFleetVehicle",
	      "data-vv-rules": "required|decimal|max:6",
	      "maxlength": "6"
	    },
	    domProps: {
	      "value": (_vm.sizeOfFleetVehicle)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.sizeOfFleetVehicle = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block-proposal help-block with-errors"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("sizeOfFleetVehicle")) + "\n                  ")])])]), _vm._v(" "), _vm._m(1)]) : _vm._e()])]), _vm._v(" "), _vm._m(2)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("Solicitar Proposta")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('p', [_vm._v("\n        Que legal você ter interesse em ser mais, para isto preencha os dados\n        abaixo que vamos analisar e retornar o mais breve possível uma\n        proposta!\n      ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-offset-4 col-sm-8 pad-fix"
	  }, [_c('button', {
	    staticClass: "btn btn-lg btn-success",
	    attrs: {
	      "id": "btn-enviar",
	      "type": "submit",
	      "name": "button"
	    }
	  }, [_vm._v("\n                  Enviar informações\n                ")]), _vm._v(" "), _c('i', {
	    staticClass: "icon-circle-right align-icon"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('img', {
	    staticClass: "img-contact",
	    attrs: {
	      "src": __webpack_require__(1778),
	      "alt": "Proposta"
	    }
	  })])
	}]}

/***/ }),
/* 2133 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "row border-row row-fix"
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "content-box-small margin-t80"
	  }, [(_vm.formState == 'ERROR') ? _c('div', {
	    staticClass: "alert alert-danger alert-dismissible margin-t20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Erro!")]), _vm._v("\n              " + _vm._s(_vm.errorMessage) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('form', {
	    attrs: {
	      "autocomplete": "false",
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.doRequest.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group margin-b20",
	    class: {
	      'has-error': _vm.errors.has('taxIdNumber')
	    }
	  }, [_c('label', [_vm._v("CNPJ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.taxIdNumber),
	      expression: "taxIdNumber",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cpfCnpj'),
	      expression: "'required|cpfCnpj'"
	    }, {
	      name: "mask-cpf-cnpj",
	      rawName: "v-mask-cpf-cnpj"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "tel",
	      "inputmode": "numeric",
	      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2}|[0-9]{3}\\.[0-9]{3}\\.[0-9]{3}-[0-9]{2}|[0-9]{11})$",
	      "name": "taxIdNumber",
	      "data-vv-validate-on": "blur",
	      "placeholder": "Digite seu CNPJ",
	      "maxlength": "18",
	      "autofocus": "",
	      "novalidate": "",
	      "formnovalidate": ""
	    },
	    domProps: {
	      "value": (_vm.taxIdNumber)
	    },
	    on: {
	      "change": function($event) {
	        _vm.taxIdNumber = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('taxIdNumber')))])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-lg btn-purple",
	    attrs: {
	      "id": "btn-login",
	      "type": "submit",
	      "name": "button"
	    }
	  }, [_vm._v("\n                Continuar\n              ")]), _vm._v(" "), _c('i', {
	    staticClass: "icon-circle-right align-icon"
	  })])])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-back margin-t20",
	    attrs: {
	      "to": "/login",
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n        Voltar\n      ")])], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("\n        Identificação "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("Esqueci o e-mail de autenticação\n      ")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('p', [_vm._v("Informe seu CNPJ para redefinir a senha.")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "circle-key"
	  })])
	}]}

/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "row row-fix"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {}, [(_vm.formState == 'ERROR') ? _c('div', {
	    staticClass: "alert alert-danger alert-dismissible margin-b20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Erro!")]), _vm._v(" " + _vm._s(_vm.errorMessage) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'SUCCESS') ? _c('div', {
	    staticClass: "alert alert-success alert-dismissible margin-t20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Sucesso!")]), _vm._v(" As informações foram enviadas, obrigado! ;)\n            ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'NEW' || _vm.formState == 'ERROR') ? _c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "autocomplete": "false"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.doRequest.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('nome')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-4 control-label",
	    attrs: {
	      "for": "nome",
	      "required": ""
	    }
	  }, [_vm._v("\n                  Nome completo*\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.faleConosco.nome),
	      expression: "faleConosco.nome"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "nome",
	      "id": "nome",
	      "data-vv-rules": "required",
	      "autofocus": ""
	    },
	    domProps: {
	      "value": (_vm.faleConosco.nome)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.faleConosco, "nome", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('nome')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('telefone')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-4 control-label",
	    attrs: {
	      "for": "telefone"
	    }
	  }, [_vm._v("\n                  Telefone\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.faleConosco.telefone),
	      expression: "faleConosco.telefone",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "mask-tel",
	      rawName: "v-mask-tel"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "telefone",
	      "id": "telefone"
	    },
	    domProps: {
	      "value": (_vm.faleConosco.telefone)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.faleConosco, "telefone", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('telefone')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('documento')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-4 control-label",
	    attrs: {
	      "for": "documento"
	    }
	  }, [_vm._v("\n                  CPF ou CNPJ*\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.faleConosco.documento),
	      expression: "faleConosco.documento",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "mask-cpf-cnpj",
	      rawName: "v-mask-cpf-cnpj"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cpfCnpj'),
	      expression: "'required|cpfCnpj'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2}|[0-9]{3}\\.[0-9]{3}\\.[0-9]{3}-[0-9]{2}|[0-9]{11})$",
	      "name": "documento",
	      "id": "documento",
	      "data-vv-validate-on": "blur"
	    },
	    domProps: {
	      "value": (_vm.faleConosco.documento)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.faleConosco, "documento", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('documento')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('email')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-4 control-label",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("\n                  E-mail*\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.faleConosco.email),
	      expression: "faleConosco.email"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "email",
	      "name": "email",
	      "id": "email",
	      "data-vv-rules": "required|email|email:email"
	    },
	    domProps: {
	      "value": (_vm.faleConosco.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.faleConosco, "email", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('email')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b0",
	    class: {
	      'has-error': _vm.errors.has('assunto')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-4 control-label",
	    attrs: {
	      "for": "assunto"
	    }
	  }, [_vm._v("\n                  Assunto*\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8"
	  }, [_c('dropdown', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "dropdown-lg",
	    attrs: {
	      "options": _vm.subject,
	      "name": "assunto",
	      "id": "assunto",
	      "data-vv-rules": "required"
	    },
	    model: {
	      value: (_vm.faleConosco.assuntoId),
	      callback: function($$v) {
	        _vm.$set(_vm.faleConosco, "assuntoId", $$v)
	      },
	      expression: "faleConosco.assuntoId"
	    }
	  }), _vm._v("\n                   \n                  "), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('assunto')))])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('mensagem')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-4 control-label",
	    attrs: {
	      "for": "mensagem"
	    }
	  }, [_vm._v("\n                  Mensagem*\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.faleConosco.mensagem),
	      expression: "faleConosco.mensagem"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "mensagem",
	      "name": "mensagem",
	      "rows": "5",
	      "cols": "80",
	      "data-vv-rules": "required"
	    },
	    domProps: {
	      "value": (_vm.faleConosco.mensagem)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.faleConosco, "mensagem", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block-proposal help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('mensagem')))])])]), _vm._v(" "), _vm._m(1)]) : _vm._e()])]), _vm._v(" "), _vm._m(2)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("\n        Contato\n      ")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('p', [_vm._v(" Tem alguma dúvida, crítica ou sugestão? Entre em contato:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-offset-4 col-sm-8 pad-fix"
	  }, [_c('div', {
	    staticClass: "terms-paragraph"
	  }, [_c('span', {
	    attrs: {
	      "id": "spanPrivacy"
	    }
	  }, [_vm._v(" Ao continuar você está de acordo com o nosso "), _c('a', {
	    attrs: {
	      "id": "spanPrivacyLink",
	      "href": "/api/v2/archeion/downloadFileArcheion/aviso-de-privacidade-movemais",
	      "target": "_blank"
	    }
	  }, [_vm._v("Aviso de Privacidade.")])])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-lg btn-primary",
	    attrs: {
	      "id": "btn-enviar",
	      "type": "submit",
	      "name": "button"
	    }
	  }, [_vm._v("\n                Enviar\n              ")]), _vm._v(" "), _c('i', {
	    staticClass: "icon-circle-right align-icon"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('img', {
	    staticClass: "img-contact",
	    attrs: {
	      "src": __webpack_require__(503),
	      "alt": "Contato"
	    }
	  })])
	}]}

/***/ }),
/* 2135 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [(_vm.isCaminhoParana) ? _c('h3', {
	    staticClass: "title"
	  }, [_vm._v("Adesão Caminhos do Paraná")]) : (_vm.planId == 62 || _vm.planId == 64) ? _c('h3', {
	    staticClass: "title"
	  }, [_vm._v("\n        Adesão Rodosol\n      ")]) : _c('h3', {
	    staticClass: "title"
	  }, [_vm._v("Adesão Move Mais")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })])]), _vm._v(" "), (_vm.code == undefined) ? _c('div', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('ul', {
	    staticClass: "wizard margin-b20 ad",
	    class: _vm.step == 1 ?
	      ' past1 ' :
	      _vm.step == 2 ?
	      ' past2 ' :
	      _vm.step > 2 ?
	      ' past4 ' :
	      ''
	  }, [_c('li', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    class: {
	      active: _vm.step == 0, past: _vm.step > 0
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('small', [_vm._v("Plano e condições")]), _vm._v(" "), _c('div', {
	    staticClass: "inline"
	  }, [(_vm.planId == 33) ? _c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("\n                Plano e condições\n              ")]) : _c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Plano e carga inicial")])])]), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    class: {
	      active: _vm.step == 1, past: _vm.step > 1
	    }
	  }, [_c('div', {
	    staticClass: "icon-step"
	  }, [(_vm.isPJ) ? _c('i', {
	    staticClass: "icon-globe"
	  }) : _c('i', {
	    staticClass: "icon-avatar"
	  })]), _vm._v(" "), _c('small', [_vm._v("Seus dados")]), _vm._v(" "), _c('div', {
	    staticClass: "inline"
	  }, [(_vm.isPJ) ? _c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Dados da Empresa")]) : _c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Seus dados")])])]), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    class: {
	      active: _vm.step == 2, past: _vm.step > 2
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('small', [_vm._v("Cadastro de veículos")]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    class: {
	      active: _vm.step == 3, past: _vm.step > 3
	    }
	  }, [_vm._m(3), _vm._v(" "), _c('small', [_vm._v("Resumo e confirmação")]), _vm._v(" "), _vm._m(4)])])])]), _vm._v(" "), (_vm.isCaminhoParana) ? _c('div', {
	    staticClass: "row"
	  }, [_vm._m(5)]) : _vm._e(), _vm._v(" "), (_vm.msgError) ? _c('div', {
	    staticClass: "alert alert-danger margin-b10",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Atenção!")]), _vm._v("\n      " + _vm._s(_vm.msgError) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.subtitle[_vm.step]) + "\n    ")]), _vm._v(" "), (_vm.step == 2 && _vm.planId == 6) ? _c('div', {
	    staticClass: "alert alert-warning margin-b10",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Atenção!")]), _vm._v(" Essa etapa não se aplica a este plano.\n    ")]) : _vm._e(), _vm._v(" "), (_vm.step == 0) ? [(_vm.checkPlan) ? _c('choose-recharge', {
	    ref: "chooseRecharge",
	    attrs: {
	      "contract": _vm.request.contract,
	      "minValue": _vm.minValue
	    },
	    on: {
	      "valorSelecionado": _vm.handleValorSelecionado
	    }
	  }) : _c('choose-plan', {
	    ref: "choosePlan",
	    attrs: {
	      "contract": _vm.request.contract
	    }
	  })] : _vm._e(), _vm._v(" "), (_vm.step == 1 && !_vm.isPJ) ? _c('user-data', {
	    ref: "userData",
	    attrs: {
	      "user": _vm.request.account,
	      "address": _vm.address,
	      "blockTaxIdNumber": _vm.isCaminhoParana
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.step == 1 && _vm.isPJ) ? _c('company-data', {
	    ref: "userData",
	    attrs: {
	      "account": _vm.request.account,
	      "address": _vm.address,
	      "blockTaxIdNumber": _vm.isCaminhoParana
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('vehicles', {
	    staticClass: "margin-b20",
	    attrs: {
	      "vehicles": _vm.vehicles,
	      "planId": _vm.planId,
	      "type": "",
	      "allowVehicles": _vm.qtdAllowed
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.step == 3) ? _c('generic-summary', {
	    ref: "GenericSummary",
	    attrs: {
	      "contract": _vm.request.contract,
	      "account": _vm.request.account,
	      "order": this.salesOrder,
	      "showAddress": true,
	      "addressInit": _vm.address,
	      "skipBillingSection": true,
	      "promotionCode": this.promotionCode
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.success) ? _c('div', [_c('div', {
	    staticClass: "action-buttons-box"
	  }, [_c('div', {
	    staticClass: "adhesion-footer-nav",
	    class: {
	      'adhesion-footer-nav--final-mobile': _vm.isMobile && _vm.step === 3
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "btn-container-adhesion-back-cancel"
	    }
	  }, [(_vm.step != 0 && !(_vm.isMobile && _vm.step === 3)) ? _c('button', {
	    attrs: {
	      "id": "button-back-adhesion"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.backStep()
	      }
	    }
	  }, [_c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('g', {
	    attrs: {
	      "clip-path": "url(#clip0_1449_206)"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M8.00016 5.33398L5.3335 8.00065M5.3335 8.00065L8.00016 10.6673M5.3335 8.00065H10.6668M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
	      "stroke": "#5D3B81",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
	    attrs: {
	      "id": "clip0_1449_206"
	    }
	  }, [_c('rect', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "fill": "white"
	    }
	  })])])]), _vm._v("\n\n              Voltar\n            ")]) : _vm._e(), _vm._v(" "), _c('button', {
	    attrs: {
	      "id": "button-cancel-adhesion"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.cancelar()
	      }
	    }
	  }, [_c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M12 4L4 12M4 4L12 12",
	      "stroke": "#E21C12",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })]), _vm._v("\n\n              Cancelar\n            ")])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "btn-container-adhesion-advance"
	    }
	  }, [(
	    _vm.step < 3 &&
	    !(_vm.isCaminhoParana && _vm.step == 0) &&
	    _vm.isMobile &&
	    _vm.planId != 31 &&
	    _vm.planId != 32
	  ) ? _c('button', {
	    attrs: {
	      "id": "button-next-adhesion"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.nextStep()
	      }
	    }
	  }, [_vm._v("\n              Avançar\n              "), _c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
	      "stroke": "#F5F5F5",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })])]) : _vm._e(), _vm._v(" "), (
	    _vm.step < 3 &&
	    !(_vm.isCaminhoParana && _vm.step == 0) &&
	    _vm.isMobile &&
	    _vm.isRechargeSelected &&
	    (_vm.planId == 31 || _vm.planId == 32)
	  ) ? _c('button', {
	    attrs: {
	      "id": "button-next-adhesion"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.nextStep()
	      }
	    }
	  }, [_vm._v("\n              Avançar\n              "), _c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
	      "stroke": "#F5F5F5",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })])]) : _vm._e(), _vm._v(" "), (
	    _vm.step < 3 &&
	    !(_vm.isCaminhoParana && _vm.step == 0) &&
	    !_vm.isMobile &&
	    _vm.planId != 31 &&
	    _vm.planId != 32
	  ) ? _c('button', {
	    attrs: {
	      "id": "button-next-adhesion"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.nextStep()
	      }
	    }
	  }, [_vm._v("\n              Avançar\n              "), _c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
	      "stroke": "#F5F5F5",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })])]) : _vm._e(), _vm._v(" "), (
	    _vm.step < 3 &&
	    !(_vm.isCaminhoParana && _vm.step == 0) &&
	    !_vm.isMobile &&
	    _vm.isRechargeSelected &&
	    (_vm.planId == 31 || _vm.planId == 32)
	  ) ? _c('button', {
	    attrs: {
	      "id": "button-next-adhesion"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.nextStep()
	      }
	    }
	  }, [_vm._v("\n              Avançar\n              "), _c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
	      "stroke": "#F5F5F5",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.step == 3 && !_vm.isMobile) ? _c('button', {
	    attrs: {
	      "id": "button-concluir-adhesion"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.startRequest()
	      }
	    }
	  }, [_vm._v("\n              Finalizar pedido\n              "), _c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
	      "stroke": "#F5F5F5",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.step == 3 && _vm.isMobile) ? _c('button', {
	    attrs: {
	      "id": "button-concluir-adhesion-mobile"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.startRequest()
	      }
	    }
	  }, [_vm._v("\n              Finalizar pedido\n              "), _c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
	      "stroke": "#F5F5F5",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })])]) : _vm._e()])])])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('success-page', {
	    attrs: {
	      "code": _vm.code,
	      "type": 'adhesion',
	      "salesOrder": _vm.salesResponse
	    }
	  }), _vm._v(" "), _c('error-page', {
	    attrs: {
	      "validacaoFraude": _vm.validacaoFraude,
	      "code": _vm.code,
	      "type": 'adhesion',
	      "taxIdNumber": _vm.request.account.taxIdNumber,
	      "password": _vm.request.account.accountAuthentication.password,
	      "salesOrder": _vm.salesResponse
	    }
	  }), _vm._v(" "), (_vm.step == 0 && !_vm.isPJ) ? _c('div', {
	    staticClass: "row"
	  }, [_vm._m(6)]) : _vm._e(), _vm._v(" "), _c('adhesion-confirm-2fa', {
	    ref: "confirm2fa",
	    attrs: {
	      "user": _vm.request.account
	    },
	    on: {
	      "nextStep": _vm.nextStep
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-plans"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-vehicle"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Cadastro de veículos")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-confirmation-check"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Resumo e confirmação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "alert alert-info margin-b10"
	  }, [_c('span', [_vm._v("\n            Você tem isenção na passagem nas praças de pedágio pelo Caminhos\n            do Paraná. Nada será cobrado pela passagem. Porém para adquirir\n            seu TAG é necessário, no ato da adesão, escolher um tipo de plano.\n          ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "bold"
	  }, [_vm._v("Dúvidas?")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('p', {
	    staticClass: "margin-b30"
	  }, [_vm._v("\n        Ficou com alguma dúvida sobre a adesão? Sem problemas, é só consultar\n        nosso\n        "), _c('b', [_vm._v("FAQ de Planos")]), _vm._v(" logo abaixo ou falar com a nossa\n        "), _c('b', [_vm._v("Central de Relaconamento")]), _vm._v(" nos telefones\n        "), _c('b', [_vm._v("4000 2901")]), _vm._v(" (capitais e regiões metropolitanas) ou\n        "), _c('b', [_vm._v("0800 777 1022")]), _vm._v(" (demais localidades).\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n          Existe cobrança de mensalidade?\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n            Não, nos nossos planos para você não há cobrança de mensalidade.\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n          Preciso fazer uma carga quando compro?\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n            Nos planos pré-pagos é necessário fazer uma carga inicial para\n            poder começar a utilizar nossos serviços, o valor pode ser: R$\n            50,00 - R$ 100,00 - R$ 150,00 R$ 200,00 - R$ 250,00 - R$ 300,00 -\n            R$ 350,00 - R$ 400,00 - R$ 450,00 ou R$ 500,00. Quanto maior o\n            valor escolhido menor é a porcentagem da nossa taxa de serviço.\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n          Há validade dos créditos?\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n            Não, seus créditos nunca expiram, aproveite!\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n          Como funciona o TAG?\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n            Após ativar e colar, o TAG permite que você passe em pedágios sem\n            fila! As cancelas automáticas identificam seu veículo através do\n            adesivo, liberam a passagem e cobram o valor do saldo em sua\n            conta.\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n          Como retiro ou recebo meu(s) TAG(s)?\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n            Você não precisa retirar, nós enviamos para você! Os TAGs serão\n            enviados para o endereço que você informar no cadastro, você pode\n            ainda acompanhar o status da entrega no menu pedidos da área do\n            cliente.\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "question-box margin-b20"
	  }, [_c('h4', {
	    staticClass: "bold-600"
	  }, [_c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n          Tem limite de veículos?\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "answer-box"
	  }, [_c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n            Não, você pode habilitar quantos veículos quiser.\n          ")])])])])
	}]}

/***/ }),
/* 2136 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-mask"
	  }, [_c('div', {
	    staticClass: "modal-wrapper"
	  }, [_c('div', {
	    staticClass: "loading-simple-container"
	  }, [_c('svg', {
	    staticClass: "loading-draw-svg",
	    attrs: {
	      "viewBox": _vm.markViewBox,
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    staticClass: "loading-draw-path",
	    attrs: {
	      "fill-rule": "evenodd",
	      "clip-rule": "evenodd",
	      "d": _vm.markPath
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "plans-container"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "plans-main-content"
	    }
	  }, [_c('div', {
	    staticClass: "form-beneficios"
	  }, [_c('div', {
	    attrs: {
	      "id": "beneficios-container"
	    }
	  }, [_c('div', {
	    staticClass: "card-container",
	    attrs: {
	      "id": "card-one"
	    }
	  }, [_vm._m(0), _vm._v(" "), (!_vm.isMobile) ? _c('ul', {
	    staticClass: "lista-beneficios"
	  }, [_vm._m(1), _vm._v(" "), (_vm.isAdhesionFree === 0) ? _c('li', {
	    staticStyle: {
	      "font-weight": "600"
	    }
	  }, [_vm._v("Adesão grátis")]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("Sem mensalidade")]), _vm._v(" "), _c('li', [_vm._v("Sem vínculo com o cartão de crédito")]), _vm._v(" "), _c('li', [_vm._v("Receba sua TAG em casa ou retire em um parceiro")])]) : _vm._e()]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "card-container",
	    attrs: {
	      "id": "last-card"
	    }
	  }, [_vm._m(3), _vm._v(" "), (_vm.isMobile) ? _c('ul', {
	    staticClass: "lista-beneficios"
	  }, [_vm._m(4), _vm._v(" "), (_vm.isAdhesionFree === 0) ? _c('li', {
	    staticStyle: {
	      "font-weight": "600"
	    }
	  }, [_vm._v("Adesão grátis")]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("Sem mensalidade")]), _vm._v(" "), _c('li', [_vm._v("Sem vínculo com o cartão de crédito")]), _vm._v(" "), _c('li', [_vm._v("Receba sua TAG em casa ou retire em um parceiro")])]) : _vm._e(), _vm._v(" "), _c('img', {
	    attrs: {
	      "id": "flag-absolute",
	      "src": __webpack_require__(1836)
	    }
	  })])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "cards-container"
	    }
	  }, [_c('PlanInfoPf'), _vm._v(" "), _c('PlanInfo')], 1), _vm._v(" "), _c('h3', {
	    attrs: {
	      "id": "vale-pedagio-text"
	    }
	  }, [_vm._v("Receba seu Vale-pedágio com tranquilidade.")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('Footer', {
	    attrs: {
	      "id": "footer-hotsite"
	    }
	  })], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "align-card-title"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1835)
	    }
	  }), _vm._v(" "), _c('h4', [_vm._v("Cobertura nacional")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_vm._v("Possibilidade de receber "), _c('b', [_vm._v("Vale-pedágio")]), _vm._v(" de qualquer contratante")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "card-container"
	  }, [_c('div', {
	    staticClass: "align-card-title"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1834)
	    }
	  }), _vm._v(" "), _c('h4', [_vm._v("Controle total")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "align-card-title"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1833)
	    }
	  }), _vm._v(" "), _c('h4', [_vm._v("Atendimento 24h")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_vm._v("Possibilidade de receber "), _c('b', [_vm._v("Vale-pedágio")]), _vm._v(" de qualquer contratante")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "plans-title"
	    }
	  }, [_c('p', {
	    staticClass: "textPlans"
	  }, [_vm._v("+ para você e sua empresa")]), _vm._v(" "), _c('h3', [_vm._v("Planos")]), _vm._v(" "), _c('h5', [_vm._v("\n        Temos planos que com certeza um deles é ideal para você, é só\n        escolher:\n      ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "graph-container"
	    }
	  }, [_c('div', [_c('h1', [_vm._v("+80")]), _vm._v(" "), _c('h3', [_vm._v("Concessionárias")])]), _vm._v(" "), _c('div', [_c('h1', [_vm._v("+410")]), _vm._v(" "), _c('h3', [_vm._v("Praças de pedágio")])]), _vm._v(" "), _c('div', [_c('h1', [_vm._v("+1100")]), _vm._v(" "), _c('h3', [_vm._v("Pistas com pedágio automático")])])])
	}]}

/***/ }),
/* 2138 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.invalid
	    }
	  }, [_c('label', {
	    staticClass: "trip-label"
	  }, [_vm._v(_vm._s(_vm.campos.label) + ":")]), _vm._v(" "), _c('i', {
	    class: _vm.campos.iconClass
	  }), _vm._v(" "), (_vm.sequence == 0) ? _c('button', {
	    staticClass: "btn btn-success btn-add-pin",
	    attrs: {
	      "type": "button",
	      "data-toggle": "tooltip",
	      "title": "Adicionar um local de passagem"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('addPoint')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon icon-plus"
	  })]) : (_vm.sequence != _vm.totalPoints - 1) ? _c('button', {
	    staticClass: "btn btn-danger btn-del-pin",
	    attrs: {
	      "type": "button",
	      "data-toggle": "tooltip",
	      "title": "Remover local de passagem"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('removePoint', _vm.sequence)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon icon-minus"
	  })]) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.model),
	      expression: "model"
	    }],
	    ref: "input",
	    class: _vm.campos.inputClass,
	    attrs: {
	      "name": _vm.id,
	      "id": _vm.id,
	      "placeholder": _vm.campos.placeholder
	    },
	    domProps: {
	      "value": (_vm.model)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.model = $event.target.value
	      }
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 2139 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade modal-address",
	    attrs: {
	      "id": "modal-address",
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-labelledby": "modalAddressLabel"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_vm._m(0), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title",
	    attrs: {
	      "id": "modalAddressLabel"
	    }
	  }, [(!_vm.registerAddress) ? _c('span', [_vm._v("Meus endereços")]) : _c('span', [_vm._v("Cadastrar novo endereço")])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "modal-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.registerAddress),
	      expression: "registerAddress"
	    }],
	    staticClass: "new-address"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('cep')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "cep"
	    }
	  }, [_vm._v(" CEP:* ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newAddress.zipCode),
	      expression: "newAddress.zipCode"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:8|cep'),
	      expression: "'required|min:8|cep'"
	    }, {
	      name: "only-numbers",
	      rawName: "v-only-numbers"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "cep",
	      "type": "text",
	      "name": "cep",
	      "maxlength": "8",
	      "placeholder": "00000-000"
	    },
	    domProps: {
	      "value": (_vm.newAddress.zipCode)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newAddress, "zipCode", $event.target.value)
	      }, _vm.queryAddressTyping]
	    }
	  }), _vm._v(" "), _c('a', {
	    on: {
	      "click": _vm.queryAddress
	    }
	  }, [_vm._v("Buscar CEP")]), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n              " + _vm._s(_vm.errors.first("cep")) + "\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('logradouro')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "logradouro"
	    }
	  }, [_vm._v(" Logradouro:* ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newAddress.address),
	      expression: "newAddress.address"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "logradouro",
	      "name": "logradouro",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.newAddress.address)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newAddress, "address", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n              " + _vm._s(_vm.errors.first("logradouro")) + "\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('numero')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "numero"
	    }
	  }, [_vm._v(" Número:* ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newAddress.number),
	      expression: "newAddress.number"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "numero",
	      "type": "text",
	      "name": "numero"
	    },
	    domProps: {
	      "value": (_vm.newAddress.number)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newAddress, "number", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n              " + _vm._s(_vm.errors.first("numero")) + "\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "complemento"
	    }
	  }, [_vm._v("Complemento:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newAddress.complement),
	      expression: "newAddress.complement"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "complemento",
	      "name": "complemento"
	    },
	    domProps: {
	      "value": (_vm.newAddress.complement)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newAddress, "complement", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('bairro')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "bairro"
	    }
	  }, [_vm._v("Bairro:*")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newAddress.neighborhood),
	      expression: "newAddress.neighborhood"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "bairro",
	      "id": "bairro"
	    },
	    domProps: {
	      "value": (_vm.newAddress.neighborhood)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newAddress, "neighborhood", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n              " + _vm._s(_vm.errors.first("bairro")) + "\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('cidade')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "cidade"
	    }
	  }, [_vm._v("Cidade:*")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newAddress.city),
	      expression: "newAddress.city"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "cidade",
	      "id": "cidade"
	    },
	    domProps: {
	      "value": (_vm.newAddress.city)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newAddress, "city", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n              " + _vm._s(_vm.errors.first("cidade")) + "\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('estado')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "estado"
	    }
	  }, [_vm._v("Estado:*")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newAddress.state),
	      expression: "newAddress.state"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "estado",
	      "id": "estado"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.newAddress, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("Selecione o estado")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AC"
	    }
	  }, [_vm._v("Acre")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AL"
	    }
	  }, [_vm._v("Alagoas")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AP"
	    }
	  }, [_vm._v("Amapá")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "AM"
	    }
	  }, [_vm._v("Amazonas")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "BA"
	    }
	  }, [_vm._v("Bahia")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "CE"
	    }
	  }, [_vm._v("Ceará")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "DF"
	    }
	  }, [_vm._v("Distrito Federal")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ES"
	    }
	  }, [_vm._v("Espírito Santo")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "GO"
	    }
	  }, [_vm._v("Goiás")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MA"
	    }
	  }, [_vm._v("Maranhão")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MT"
	    }
	  }, [_vm._v("Mato Grosso")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MS"
	    }
	  }, [_vm._v("Mato Grosso do Sul")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "MG"
	    }
	  }, [_vm._v("Minas Gerais")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PA"
	    }
	  }, [_vm._v("Pará")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PB"
	    }
	  }, [_vm._v("Paraíba")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PR"
	    }
	  }, [_vm._v("Paraná")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PE"
	    }
	  }, [_vm._v("Pernambuco")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "PI"
	    }
	  }, [_vm._v("Piauí")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RJ"
	    }
	  }, [_vm._v("Rio de Janeiro")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RN"
	    }
	  }, [_vm._v("Rio Grande do Norte")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RS"
	    }
	  }, [_vm._v("Rio Grande do Sul")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RO"
	    }
	  }, [_vm._v("Rondônia")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "RR"
	    }
	  }, [_vm._v("Roraima")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SC"
	    }
	  }, [_vm._v("Santa Catarina")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SP"
	    }
	  }, [_vm._v("São Paulo")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "SE"
	    }
	  }, [_vm._v("Sergipe")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "TO"
	    }
	  }, [_vm._v("Tocantins")])]), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n              " + _vm._s(_vm.errors.first("estado")) + "\n            ")])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.userAddress && !_vm.registerAddress),
	      expression: "userAddress && !registerAddress"
	    }],
	    staticClass: "select-address"
	  }, _vm._l((_vm.userAddress), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "content-box methods address"
	    }, [_c('div', {
	      staticClass: "methods-rbox"
	    }, [_c('div', {
	      staticClass: "radio-blue category"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.selectedAddress),
	        expression: "selectedAddress"
	      }],
	      staticClass: "radiobtn",
	      attrs: {
	        "type": "radio",
	        "id": 'address' + index,
	        "name": "selectedAddress"
	      },
	      domProps: {
	        "value": item,
	        "checked": _vm._q(_vm.selectedAddress, item)
	      },
	      on: {
	        "change": function($event) {
	          _vm.selectedAddress = item
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      staticClass: "radio-label label-h4",
	      attrs: {
	        "for": 'address' + index
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "check first"
	    })])]), _vm._v(" "), _c('div', {
	      staticClass: "text-left"
	    }, [_c('p', {
	      staticClass: "bold"
	    }, [_vm._v("\n                " + _vm._s(item.address) + ", " + _vm._s(item.number) + " -\n                " + _vm._s(item.neighborhood) + "\n              ")]), _vm._v(" "), _c('p', [(item.complement) ? _c('span', [_vm._v(_vm._s(item.complement) + " - ")]) : _vm._e(), _vm._v(_vm._s(item.city) + "-" + _vm._s(item.state) + " - CEP " + _vm._s(item.zipCode) + "\n              ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user))])])])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [(!_vm.registerAddress) ? _c('button', {
	    staticClass: "btn-new-address",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.registerAddress = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-plus"
	  }), _vm._v("\n          Adicionar novo endereço\n        ")]) : _vm._e(), _vm._v(" "), (_vm.registerAddress) ? _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "id": "create-address",
	      "disabled": !_vm.allFieldsValid,
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.createAddress()
	      }
	    }
	  }, [_vm._v("\n          Confirmar\n        ")]) : _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeAddress()
	      }
	    }
	  }, [_vm._v("\n          Confirmar\n        ")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	}]}

/***/ }),
/* 2140 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade modal-receipt-vp",
	    attrs: {
	      "id": "modal-receipt-vp",
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-labelledby": "modal-receipt-vp-label"
	    },
	    on: {
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) { return null; }
	        return _vm.closeModal()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content window-print"
	  }, [_c('div', {
	    staticClass: "modal-body"
	  }, [_c('button', {
	    staticClass: "close hidden-print",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
	    staticClass: "receipt-header"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/Logo_Move_Mais_Horizontal+TAG_Pedagio.svg",
	      "alt": "Logo Move Mais TAG",
	      "width": "120"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "text-right"
	  }, [_c('h3', [_vm._v("Comprovante Vale-pedágio")]), _vm._v(" "), _c('p', {
	    staticClass: "upper"
	  }, [_vm._v("n° comprovante")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.summaryVP.idProtocolo))]), _vm._v(" "), _c('p', {
	    staticClass: "upper"
	  }, [_vm._v("data de emissão")]), _vm._v(" "), _c('p', {
	    attrs: {
	      "mask-date-hour": ""
	    }
	  }, [_vm._v(_vm._s(_vm._f("dateTime")(_vm.summaryVP.dataHoraEmissao)))])])]), _vm._v(" "), _c('div', {
	    staticClass: "receipt-info"
	  }, [_c('div', {}, [_c('p', {
	    staticClass: "margin-b30 upper"
	  }, [_vm._v("transportador")]), _vm._v(" "), _c('p', {
	    staticClass: "upper"
	  }, [_vm._v(_vm._s(_vm.summaryVP.transportador))]), _vm._v(" "), _c('p', [_vm._v("CNPJ: "), _c('span', {
	    directives: [{
	      name: "mask-cnpj",
	      rawName: "v-mask-cnpj"
	    }]
	  }, [_vm._v(_vm._s(_vm.summaryVP.CNPJTransportador))])]), _vm._v(" "), _c('p', [_vm._v("N° do TAG: "), _c('span', [_vm._v(_vm._s(_vm.summaryVP.tagSerialNumber))])]), _vm._v(" "), _c('p', [_vm._v("PLACA: "), _c('span', [_vm._v(_vm._s(_vm.summaryVP.placaVeiculo))])]), _vm._v(" "), _c('p', [_vm._v("CATEGORIA: "), _c('span', [_vm._v(_vm._s(_vm.summaryVP.categoria))])])]), _vm._v(" "), _c('div', {
	    staticClass: "text-right"
	  }, [_c('p', {
	    staticClass: "margin-b30 upper"
	  }, [_vm._v("emissor")]), _vm._v(" "), _c('p', {
	    staticClass: "upper"
	  }, [_vm._v(_vm._s(_vm.summaryVP.embarcador))]), _vm._v(" "), _c('p', [_vm._v("CNPJ: "), _c('span', {
	    directives: [{
	      name: "mask-cnpj",
	      rawName: "v-mask-cnpj"
	    }]
	  }, [_vm._v(_vm._s(_vm.summaryVP.CPFCNPJEmbarcador))])]), _vm._v(" "), _c('p', [_vm._v("CONTRATO: "), _c('span', [_vm._v(_vm._s(_vm.summaryVP.contratoOrig))])])])]), _vm._v(" "), (_vm.summaryVP) ? _c('div', {
	    attrs: {
	      "id": "summary-box"
	    }
	  }, [_c('div', {
	    staticClass: "content-box-npadd margin-b20"
	  }, [_c('div', {
	    staticClass: "toll-info-box"
	  }, [_c('div', {}, [_c('div', {}, [_c('small', [_vm._v("De")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.origin.city))]), _vm._v(" "), _c('small', [_c('img', {
	    attrs: {
	      "src": "/static/icon-send.svg",
	      "alt": "icon send"
	    }
	  }), _vm._v("\n                    " + _vm._s(_vm.origin.state) + "\n                  ")])]), _vm._v(" "), _c('div', {}, [_c('small', [_vm._v("para")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.destination.city))]), _vm._v(" "), _c('small', [_c('img', {
	    attrs: {
	      "src": "/static/icon-location.svg",
	      "alt": "icon location"
	    }
	  }), _vm._v("\n                    " + _vm._s(_vm.destination.state) + "\n                  ")])])]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("\n                  rota:\n                  "), _c('span', [_vm._v(_vm._s(_vm.summaryVP.rota))])]), _vm._v(" "), _c('p', [_vm._v("\n                  distância:\n                  "), _c('span', [_vm._v(_vm._s(_vm.summaryVP.totalDistance) + " KM")])]), _vm._v(" "), _c('p', [_vm._v("\n                  valor:\n                  "), _c('span', [_vm._v(_vm._s(_vm._f("cents")(_vm.summaryVP.valorVP)))])]), _vm._v(" "), _c('p', [_vm._v("\n                  expiração:\n                  "), _c('span', [_vm._v(_vm._s(_vm._f("date")(_vm.summaryVP.expirationVP)))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "table-toll-info"
	  }, [_c('table', {
	    staticClass: "table"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.summaryVP.pracas), function(p, index) {
	    return _c('tr', {
	      key: index
	    }, [_c('td', [_vm._v(_vm._s(p.praca))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.concessionaria))]), _vm._v(" "), _c('td', {
	      staticClass: "text-right"
	    }, [_vm._v(_vm._s(_vm._f("cents")(p.price)))])])
	  }), 0)])]), _vm._v(" "), _c('h5', {
	    staticClass: "text-right upper"
	  }, [_vm._v("valor total: "), _c('span', [_vm._v(_vm._s(_vm._f("cents")(_vm.summaryVP.valorVP)))])])])]) : _vm._e(), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer text-right hidden-print"
	  }, [_c('button', {
	    staticClass: "bbtn no-btn btn-square",
	    on: {
	      "click": function($event) {
	        return _vm.window.print()
	      }
	    }
	  }, [_vm._v("\n          Imprimir\n        ")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Praça de pedágio")]), _vm._v(" "), _c('th', [_vm._v("Concessionária")]), _vm._v(" "), _c('th', {
	    staticClass: "text-right"
	  }, [_vm._v("Valor")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "receipt-footer"
	  }, [_c('div', {
	    staticClass: "flex between"
	  }, [_c('div', [_c('p', {
	    staticClass: "upper"
	  }, [_vm._v("move mais meios de pagamentos ltda")]), _vm._v(" "), _c('p', [_vm._v("\n                Avenida Rodrigo Fernando Grilo, 207, Edifício\n                "), _c('br'), _vm._v("\n                Victória Business 20° andar - Araraquara, SP,\n                "), _c('br'), _vm._v("\n                Brasil - 14801-534\n              ")])]), _vm._v(" "), _c('div', [_c('p', [_c('i'), _vm._v("\n                relacionamento@movemais.com\n              ")]), _vm._v(" "), _c('p', [_c('i'), _vm._v("\n                0800 777 1022\n              ")])]), _vm._v(" "), _c('div', {
	    staticClass: "text-right"
	  }, [_c('p', [_vm._v("Todos os direitos reservados.")]), _vm._v(" "), _c('p', [_vm._v("CNPJ: 15.266.912/0001-87")]), _vm._v(" "), _c('p', [_vm._v("Inscrição Estadual: 181.239.134.110")])])])])
	}]}

/***/ }),
/* 2141 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "row color-row-4"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "txt-row-4"
	  }, [_c('h3', [_vm._v("Se você deseja ter controle total sobre os custos e as recargas, este é o seu plano.")]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "to": "/adesao?planId=21",
	      "tag": "button"
	    }
	  }, [_vm._v("\n          Quero este plano!\n        ")])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back",
	    attrs: {
	      "to": "/servicos-b2c"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n        Voltar para planos\n      ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-back pull-right",
	    attrs: {
	      "to": "/servicos-b2c-plano-conforto"
	    }
	  }, [_vm._v("\n        Ver próximo plano\n        "), _c('i', {
	    staticClass: "icon-circle-right align-icon-right"
	  })])], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("Serviços para Você")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-b10"
	  }, [_c('h3', {
	    staticClass: "bold upper"
	  }, [_vm._v("Plano Pré-pago Manual")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row color-row-1"
	  }, [_c('div', {
	    staticClass: "col-md-10"
	  }, [_c('div', {
	    staticClass: "txt-row-1"
	  }, [_c('p', [_vm._v("Com o "), _c('b', [_vm._v("PRÉ-PAGO MANUAL")]), _vm._v(" você faz recargas e controla seu saldo para pegar a estrada.")]), _vm._v(" "), _c('p', [_vm._v("A recarga pode ser feita via app ou aqui no site da Move Mais.")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "recharge-manual"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row color-row-2"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "payment-methods-control"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "txt-row-2"
	  }, [_c('p', [_vm._v("A recarga pode ser feita via cartão de crédito.")]), _vm._v(" "), _c('p', [_vm._v("Nossa taxa é a "), _c('b', [_vm._v("menor do mercado")]), _vm._v(" e quanto maior o valor da recarga menor é a porcentagem da taxa de recarga.")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row color-row-3"
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "txt-row-3"
	  }, [_c('span', [_vm._v("Você pode ainda consultar "), _c('b', [_vm._v("saldos")]), _vm._v(", "), _c('b', [_vm._v("extratos")]), _vm._v(" e "), _c('b', [_vm._v("geolocalização dos veículos")]), _vm._v(" diretamente no nosso site ou no app para mobile (Android e iOS).")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "gps-vehicle"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "control-sheets"
	  })])
	}]}

/***/ }),
/* 2142 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "hotsite-container"
	    }
	  }, [_c('MainContentHotSite'), _vm._v(" "), _c('Plans')], 1)
	},staticRenderFns: []}

/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "row"
	  }, [(_vm.isCaminhoParana) ? _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "parana-way-box"
	  }, [_c('div', {
	    staticClass: "row text-center"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('div', {
	    staticClass: "second-col-box margin-b20"
	  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "height-72 padding-12"
	  }, [_c('button', {
	    staticClass: "inline bold btn-charge btn-charge-minus",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.calculateManParanaWay(_vm.rechargeMan - 1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-minus"
	  })]), _vm._v(" "), _c('input', {
	    staticClass: "inline form-control bold",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm._f("cents")(_vm.rechargeValueMan)
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "inline bold btn-charge btn-charge-plus",
	    attrs: {
	      "type": "button",
	      "name": "button",
	      "autofocus": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.calculateManParanaWay(_vm.rechargeMan + 1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-plus"
	  })])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "row-button border-radius-bottom"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "tag": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.nextParana('man')
	      }
	    }
	  }, [_vm._v("\n                Quero este plano!\n              ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('div', {
	    staticClass: "third-col-box margin-b20"
	  }, [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
	    staticClass: "height-72 padding-12"
	  }, [_c('button', {
	    staticClass: "inline bold btn-charge btn-charge-minus",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.calculateAutParanaWay(_vm.rechargeAut - 1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-minus"
	  })]), _vm._v(" "), _c('input', {
	    staticClass: "inline form-control bold",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm._f("cents")(_vm.rechargeValueAut)
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "inline bold btn-charge btn-charge-plus",
	    attrs: {
	      "type": "button",
	      "name": "button",
	      "autofocus": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.calculateAutParanaWay(_vm.rechargeAut + 1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-plus"
	  })])]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
	    staticClass: "row-button border-radius-bottom"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "tag": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.nextParana('aut')
	      }
	    }
	  }, [_vm._v("\n                Quero este plano!\n              ")])])])])])])]) : _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "col-md-4 box-plan",
	    staticStyle: {
	      "padding": "20px"
	    }
	  }, [(_vm.recVp === 'N') ? _c('div', {
	    staticClass: "alert-warning",
	    staticStyle: {
	      "background-color": "#fcdec1",
	      "margin-bottom": "25px",
	      "padding": "20px",
	      "margin": "23px",
	      "text-align": "left"
	    }
	  }, [_c('b', [_vm._v("Atenção!")]), _vm._v(" Este plano não recebe Vale-pedágio Eletrônico.\n      ")]) : _vm._e(), _vm._v(" "), _c('p', {
	    staticClass: "label-semibold"
	  }, [_vm._v("Plano Escolhido:")]), _vm._v(" "), _c('p', {
	    staticClass: "title-plan"
	  }, [_vm._v(_vm._s(_vm.plan && _vm.plan.name))]), _vm._v(" "), _c('img', {
	    staticClass: "choosed-plan-cart",
	    attrs: {
	      "src": __webpack_require__(504),
	      "alt": ""
	    }
	  })]), _vm._v(" "), (_vm.planId == _vm.CO.PLAN_EMBARCADOR_PJ) ? _c('div', {
	    staticClass: "col-md-8"
	  }, [_vm._m(9), _vm._v(" "), _vm._m(10)]) : (_vm.planId == _vm.CO.PLAN_MOVE_PAGUE) ? _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "second-col-box"
	  }, [_c('b', {
	    staticClass: "title-identification"
	  }, [_vm._v("Valores do plano")]), _vm._v(" "), _c('div', {
	    staticClass: "line-table two-lines"
	  }, [_vm._m(11), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [(_vm.newAdhesionTax > 0) ? _c('h4', {
	    staticClass: "label-plan-value"
	  }, [_vm._v("\n              " + _vm._s(_vm._f("cents")(_vm.newAdhesionTax)) + "\n            ")]) : _c('h4', {
	    staticClass: "label-plan-value"
	  }, [_vm._v("GRÁTIS")])]), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _c('div', {
	    staticClass: "line-table two-lines"
	  }, [_vm._m(13), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('h4', {
	    staticClass: "label-plan-value"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.guaranteeTax)))])])])])]) : (_vm.planId == 2 || _vm.planId == 3) ? _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "second-col-box"
	  }, [_c('b', {
	    staticClass: "title-identification"
	  }, [_vm._v("Informações")]), _vm._v(" "), _c('div', {
	    staticClass: "row row-fix"
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-t20"
	  }, [_c('div', {
	    staticClass: "margin-l-10 form-group text-left",
	    class: {
	      'has-error': _vm.errors.has('taxIdNumber')
	    }
	  }, [_c('label', [_vm._v("Digite o CPF ou CNPJ do seu RNTRC:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.taxIdNumber),
	      expression: "taxIdNumber",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cpfCnpj|accountExists:cpf'),
	      expression: "'required|cpfCnpj|accountExists:cpf'"
	    }, {
	      name: "mask-cpf-cnpj",
	      rawName: "v-mask-cpf-cnpj"
	    }],
	    staticClass: "form-control small rntrc-input",
	    attrs: {
	      "type": "text",
	      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2}|[0-9]{3}\\.[0-9]{3}\\.[0-9]{3}-[0-9]{2}|[0-9]{11})$",
	      "id": "taxIdNumber",
	      "name": "taxIdNumber",
	      "data-vv-validate-on": "blur",
	      "placeholder": "",
	      "maxlength": "18"
	    },
	    domProps: {
	      "value": (_vm.taxIdNumber)
	    },
	    on: {
	      "input": _vm.cleanErrors,
	      "change": function($event) {
	        _vm.taxIdNumber = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first("taxIdNumber")))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row row-fix"
	  }, [_c('div', {
	    staticClass: "col-xs-12 rntrc-adhesion-row"
	  }, [_vm._m(14), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('h4', {
	    staticClass: "label-plan-value"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.newAdhesionTax)))])])])]), _vm._v(" "), _vm._m(15)])]) : (_vm.planId == 51 || _vm.planId == 52) ? _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "second-col-box"
	  }, [_c('b', {
	    staticClass: "title-identification"
	  }, [_vm._v("Valores do plano")]), _vm._v(" "), _c('div', {
	    staticClass: "line-table"
	  }, [_vm._m(16), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.newAdhesionTax > 0) ? _c('h4', {
	    staticClass: "label-plan-value"
	  }, [_vm._v("\n              " + _vm._s(_vm._f("cents")(_vm.newAdhesionTax)) + "\n            ")]) : _c('h4', {
	    staticClass: "label-plan-value"
	  }, [_vm._v("GRÁTIS")])])]), _vm._v(" "), _c('div', {
	    staticClass: "line-table-striped"
	  }, [_vm._m(17), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('button', {
	    staticClass: "inline bold btn-charge btn-charge-minus",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.calculate(_vm.recharge - 1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-minus"
	  })]), _vm._v(" "), _c('input', {
	    staticClass: "inline form-control bold",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm._f("cents")(_vm.rechargeValue)
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "inline bold btn-charge btn-charge-plus",
	    attrs: {
	      "type": "button",
	      "name": "button",
	      "autofocus": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.calculate(_vm.recharge + 1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-plus"
	  })])])]), _vm._v(" "), _vm._m(18)]), _vm._v(" "), _vm._m(19)]) : _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "second-col-box"
	  }, [_c('b', {
	    staticClass: "title-identification"
	  }, [_vm._v("Valores do plano")]), _vm._v(" "), (_vm.sameTax) ? _c('div', {
	    staticClass: "line-table"
	  }, [_vm._m(20), _vm._v(" "), (!_vm.checkPromoSenff) ? _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.newAdhesionTax > 0 && !_vm.promoId) ? _c('h4', {
	    staticClass: "label-plan-value"
	  }, [_vm._v("\n              " + _vm._s(_vm._f("cents")(_vm.newAdhesionTax)) + "\n            ")]) : _c('h4', {
	    staticClass: "label-plan-value"
	  }, [_vm._v("GRÁTIS")])]) : _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h4', {
	    staticClass: "label-plan-value"
	  }, [_vm._v("GRÁTIS")])])]) : _vm._e(), _vm._v(" "), (!_vm.sameTax) ? _c('div', {
	    staticClass: "line-table"
	  }, [_vm._m(21), _vm._v(" "), (!_vm.checkPromoSenff) ? _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.newAdhesionTax > 0 && !_vm.promoId) ? _c('h4', {
	    staticClass: "label-plan-value"
	  }, [_vm._v("\n              " + _vm._s(_vm._f("cents")(_vm.newAdhesionTax)) + "\n            ")]) : _c('h4', {
	    staticClass: "label-plan-value"
	  }, [_vm._v("GRÁTIS")])]) : _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h4', {
	    staticClass: "label-plan-value"
	  }, [_vm._v("GRÁTIS")])])]) : _vm._e(), _vm._v(" "), (!_vm.sameTax) ? _c('div', {
	    staticClass: "line-table"
	  }, [_vm._m(22), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.newVehicleTax > 0) ? _c('h4', {
	    staticClass: "label-plan-value"
	  }, [_vm._v("\n              " + _vm._s(_vm._f("cents")(_vm.newVehicleTax)) + "\n            ")]) : _c('h4', {
	    staticClass: "label-plan-value"
	  }, [_vm._v("GRÁTIS")])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "line-table-striped"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "label-plan"
	  }, [_vm._v("Carga inicial:")]), _vm._v(" "), _c('p', {
	    staticClass: "label-first-charge margin-b0"
	  }, [_vm._v("\n              (É necessário no ato da\n              " + _vm._s(_vm.newSalesType == "MIGRATIONPLAN" ? "migração" : "adesão") + "\n              realizar uma carga inicial)\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('button', {
	    staticClass: "inline bold btn-charge btn-charge-minus",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.promoId
	          ?
	          _vm.firstValueRecharge(_vm.recharge - 1) :
	          _vm.calculate(_vm.recharge - 1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-minus"
	  })]), _vm._v(" "), _c('input', {
	    staticClass: "inline form-control bold",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm._f("cents")(_vm.rechargeValue)
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "inline bold btn-charge btn-charge-plus",
	    attrs: {
	      "type": "button",
	      "name": "button",
	      "autofocus": ""
	    },
	    on: {
	      "click": function($event) {
	        _vm.promoId
	          ?
	          _vm.firstValueRecharge(_vm.recharge + 1) :
	          _vm.calculate(_vm.recharge + 1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-plus"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "line-table"
	  }, [_vm._m(23), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h4', {
	    staticClass: "label-plan-value"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.taxRecharge)))])])]), _vm._v(" "), _c('div', {
	    staticClass: "line-table-striped"
	  }, [_vm._m(24), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 coupon-container"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.coupon),
	      expression: "coupon"
	    }],
	    staticClass: "form-control input-coupon",
	    attrs: {
	      "type": "text",
	      "name": "coupon",
	      "placeholder": "Digite o código",
	      "maxlength": "50"
	    },
	    domProps: {
	      "value": (_vm.coupon)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.coupon = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), (_vm.planId == 21) ? _c('div', [_c('div', {
	    staticClass: "line-table",
	    staticStyle: {
	      "background-color": "white"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.planId == 21) ? _c('div', {
	    staticClass: "label-plan"
	  }, [_vm._v("\n                Quero ser avisado quando meu saldo atingir o valor de:\n                " + _vm._s(_vm.limiteFormatado()) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "fleet-switch"
	  }, [_c('div', {
	    staticClass: "onoffswitch"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contract.lcFlag),
	      expression: "contract.lcFlag"
	    }],
	    staticClass: "onoffswitch-checkbox",
	    attrs: {
	      "type": "checkbox",
	      "id": "round-switch"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.contract.lcFlag) ? _vm._i(_vm.contract.lcFlag, null) > -1 : (_vm.contract.lcFlag)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.contract.lcFlag,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.contract, "lcFlag", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.contract, "lcFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.contract, "lcFlag", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _vm._m(25)])])])])]) : (_vm.planId == 22 || _vm.planId == 62 || _vm.planId == 64) ? _c('div', [_c('div', {
	    staticClass: "line-table-striped-white"
	  })]) : _vm._e()]), _vm._v(" "), _vm._m(26)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-2 first-col-box"
	  }, [_c('div', {
	    staticClass: "height-112 border-radius-top"
	  }, [_c('p', {
	    staticClass: "margin-10"
	  }, [_c('i', {
	    staticClass: "icon-plans icon-plans-table"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "height-72"
	  }, [_c('p', {
	    staticClass: "bold no-margin padding-23"
	  }, [_vm._v("Como Funciona?")])]), _vm._v(" "), _c('div', {
	    staticClass: "height-82"
	  }, [_c('p', {
	    staticClass: "bold no-margin padding-18"
	  }, [_vm._v("Adesão por Veículo")])]), _vm._v(" "), _c('div', {
	    staticClass: "height-72"
	  }, [_c('p', {
	    staticClass: "bold no-margin padding-t6"
	  }, [_vm._v("Carga Inicial")]), _vm._v(" "), _c('small', [_vm._v("(É necessário na adesão realizar uma carga inicial)")])]), _vm._v(" "), _c('div', {
	    staticClass: "height-82 striped-line"
	  }, [_c('p', {
	    staticClass: "bold no-margin padding-12"
	  }, [_vm._v("Formas de Pagamento")])]), _vm._v(" "), _c('div', {
	    staticClass: "height-72-exp border-radius-bottom"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-112 border-radius-top"
	  }, [_c('h3', {
	    staticClass: "title plan upper no-margin margin-b10"
	  }, [_vm._v("\n                Pré-pago Manual\n              ")]), _vm._v(" "), _c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("\n                Excelente para você que quer ter controle total dos seus\n                gastos e tem tempo para planejar as suas recargas.\n              ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-72 padding-t16"
	  }, [_c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("\n                Sempre que precisar realizar uma nova recarga, você deverá\n                acessar a área do cliente (Meus Planos) e recarregar.\n                Disponível no app e no site.\n              ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-82 padding-28"
	  }, [_c('h3', {
	    staticClass: "bold no-margin"
	  }, [_vm._v("Grátis")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-82 padding-12 center-flex-vertical"
	  }, [_c('ul', [_c('li', [_vm._v("Cartão de Crédito")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-112 border-radius-top"
	  }, [_c('h3', {
	    staticClass: "title plan upper no-margin margin-b10"
	  }, [_vm._v("\n                Pré-pago Automático\n              ")]), _vm._v(" "), _c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("\n                Perfeito para você que gosta de comodidade e não quer se\n                preocupar com recargas ou saldo insuficiente.\n              ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-72 height-72-big padding-18"
	  }, [_c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("\n                Você define o valor da recarga e sempre que o seu saldo\n                atingir 40%, nós realizamos uma nova recarga para você.\n              ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-82 padding-28"
	  }, [_c('h3', {
	    staticClass: "bold no-margin"
	  }, [_vm._v("Grátis")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-82 padding-20 center-flex-vertical"
	  }, [_c('ul', [_c('li', [_vm._v("Cartão de Crédito")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "second-col-box"
	  }, [_c('b', {
	    staticClass: "title-identification"
	  }, [_vm._v("Valores do plano")]), _vm._v(" "), _c('div', {
	    staticClass: "shipper-description"
	  }, [_vm._v("\n          Este plano tem adesão gratuita, aproveite!\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "shipper-tax-box"
	  }, [_vm._v("\n          Taxa de adesão:\n          "), _c('h3', {
	    staticClass: "shipper-tax-value"
	  }, [_vm._v("Grátis")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('p', {
	    staticStyle: {
	      "margin-bottom": "10px"
	    }
	  }, [_vm._v("\n          ¹ ² As condições promocionais estão sujeitas às regras de cada\n          campanha vigente.\n          "), _c('a', {
	    staticStyle: {
	      "text-decoration": "underline"
	    },
	    attrs: {
	      "href": "https://movemais.com/api/v2/archeion/downloadFileArcheion/regulamento-promocional-movemais",
	      "target": "_blank",
	      "rel": "noopener noreferrer"
	    }
	  }, [_vm._v("\n            Consulte o regulamento")]), _vm._v(".\n        ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('p', {
	    staticClass: "label-plan"
	  }, [_vm._v("Adesão por veículo (TAG)"), _c('sup', [_vm._v("1")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('p', {
	    staticStyle: {
	      "margin-bottom": "10px"
	    }
	  }, [_vm._v("\n              ¹ ² As condições promocionais estão sujeitas às regras de cada\n              campanha vigente.\n              "), _c('a', {
	    staticStyle: {
	      "text-decoration": "underline"
	    },
	    attrs: {
	      "href": "https://movemais.com/api/v2/archeion/downloadFileArcheion/regulamento-promocional-movemais",
	      "target": "_blank",
	      "rel": "noopener noreferrer"
	    }
	  }, [_vm._v("\n                Consulte o regulamento")]), _vm._v(".\n            ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('p', {
	    staticClass: "label-plan label-plan-garantee"
	  }, [_vm._v("\n              Saldo Caução por veículo:\n            ")]), _vm._v(" "), _c('p', {
	    staticClass: "no-margin sub"
	  }, [_vm._v("\n              Valor debitado uma única vez no ato da adesão.\n            ")]), _vm._v(" "), _c('p', {
	    staticClass: "sub margin-10"
	  }, [_vm._v("\n              * Valor devolvido no cancelamento do plano.\n            ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('p', {
	    staticClass: "label-plan"
	  }, [_vm._v("Adesão por veículo (TAG)"), _c('sup', [_vm._v("1")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row row-fix"
	  }, [_c('div', {
	    staticClass: "col-xs-12 rntrc-bind-value-row"
	  }, [_c('div', {
	    staticClass: "col-md-7"
	  }, [_c('p', {
	    staticClass: "label-plan"
	  }, [_vm._v("Vinculação RNTRC:")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('h4', {
	    staticClass: "label-plan-rntrc-value"
	  }, [_vm._v("GRÁTIS*\n              ")]), _vm._v(" "), _c('small', [_vm._v("* Conforme Deliberação Nº 400 da ANTT.")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "label-plan"
	  }, [_vm._v("Adesão por veículo (TAG)"), _c('sup', [_vm._v("1")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "label-plan"
	  }, [_vm._v("Carga inicial:")]), _vm._v(" "), _c('p', {
	    staticClass: "label-first-charge"
	  }, [_vm._v("\n              (É necessário no ato da adesão realizar uma carga inicial)\n            ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "line-table"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "label-plan"
	  }, [_vm._v("Taxa de Recarga"), _c('sup', [_vm._v("2")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h4', {
	    staticClass: "label-plan-value"
	  }, [_vm._v("GRÁTIS")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('p', {
	    staticStyle: {
	      "margin-bottom": "10px"
	    }
	  }, [_vm._v("\n          ¹ ² As condições promocionais estão sujeitas às regras de cada\n          campanha vigente.\n          "), _c('a', {
	    staticStyle: {
	      "text-decoration": "underline"
	    },
	    attrs: {
	      "href": "https://movemais.com/api/v2/archeion/downloadFileArcheion/regulamento-promocional-movemais",
	      "target": "_blank",
	      "rel": "noopener noreferrer"
	    }
	  }, [_vm._v("\n            Consulte o regulamento")]), _vm._v(".\n        ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "label-plan"
	  }, [_vm._v("Adesão por veículo (TAG)"), _c('sup', [_vm._v("1")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "label-plan"
	  }, [_vm._v("Adesão por veículo (TAG)"), _c('sup', [_vm._v("1")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "label-plan"
	  }, [_vm._v("Adesão por veículo (TAG)"), _c('sup', [_vm._v("1")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "label-plan"
	  }, [_vm._v("Taxa de Recarga"), _c('sup', [_vm._v("2")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "label-plan"
	  }, [_vm._v("Código do Vendedor:")]), _vm._v(" "), _c('p', {
	    staticClass: "label-first-charge"
	  }, [_vm._v("\n              (Opcional) Informe o código se possuir\n            ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "onoffswitch-label",
	    staticStyle: {
	      "text-align": "left"
	    },
	    attrs: {
	      "for": "round-switch"
	    }
	  }, [_c('span', {
	    staticClass: "onoffswitch-inner"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "onoffswitch-switch"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('p', {
	    staticStyle: {
	      "margin-bottom": "10px"
	    }
	  }, [_vm._v("\n          ¹ ² As condições promocionais estão sujeitas às regras de cada\n          campanha vigente.\n          "), _c('a', {
	    staticStyle: {
	      "text-decoration": "underline"
	    },
	    attrs: {
	      "href": "https://movemais.com/api/v2/archeion/downloadFileArcheion/regulamento-promocional-movemais",
	      "target": "_blank",
	      "rel": "noopener noreferrer"
	    }
	  }, [_vm._v("\n            Consulte o regulamento")]), _vm._v(".\n        ")])])
	}]}

/***/ }),
/* 2144 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("Alterar senha")])], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "row border-row row-fix"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "content-box-small margin-t10"
	  }, [(_vm.errorMessage) ? _c('div', {
	    staticClass: "alert alert-danger margin-t20 container-password-check",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Erro!")]), _vm._v("\n              " + _vm._s(_vm.errorMessage) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.doChange.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group margin-b20",
	    class: {
	      'has-error': _vm.errors.has('oldPassword')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "password"
	    }
	  }, [_vm._v("Senha atual")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.oldPassword),
	      expression: "oldPassword"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "id": "old-password",
	      "type": "password",
	      "name": "oldPassword",
	      "placeholder": "Digite sua senha atual"
	    },
	    domProps: {
	      "value": (_vm.oldPassword)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.oldPassword = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("oldPassword")) + "\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b20",
	    class: {
	      'has-error': _vm.errors.has('password')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "password"
	    }
	  }, [_vm._v("Nova senha")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.password),
	      expression: "password"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: (
	        'required|min:8|max:20|confirmed:password|moveMaisCPF'
	      ),
	      expression: "\n                    'required|min:8|max:20|confirmed:password|moveMaisCPF'\n                  "
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "id": "password",
	      "type": "password",
	      "name": "password",
	      "data-vv-validate-on": "blur",
	      "placeholder": "Digite sua nova senha"
	    },
	    domProps: {
	      "value": (_vm.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.password = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("password")) + "\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b20",
	    class: {
	      'has-error': _vm.errors.has('passwordRepeat')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "passwordRepeat"
	    }
	  }, [_vm._v("Confirme a nova senha")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.passwordRepeat),
	      expression: "passwordRepeat"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: (
	        'required|min:8|max:20|confirmed:password|moveMaisCPF'
	      ),
	      expression: "\n                    'required|min:8|max:20|confirmed:password|moveMaisCPF'\n                  "
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "id": "passwordRepeat",
	      "type": "password",
	      "name": "passwordRepeat",
	      "data-vv-validate-on": "blur",
	      "placeholder": "Confirme a nova senha"
	    },
	    domProps: {
	      "value": (_vm.passwordRepeat)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.passwordRepeat = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("passwordRepeat")) + "\n                ")])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-lg btn-success",
	    attrs: {
	      "id": "btn-new-pass",
	      "type": "submit",
	      "name": "button"
	    }
	  }, [_vm._v("\n                Definir nova senha\n              ")]), _vm._v(" "), _c('i', {
	    staticClass: "icon-circle-right align-icon"
	  })]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _vm._m(1)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "box-dicas"
	  }, [_vm._v("Senha deve ter de 8 a 20 caracteres")]), _vm._v(" "), _c('div', {
	    staticClass: "box-dicas"
	  }, [_vm._v("Senha deve ter pelo menos um número")]), _vm._v(" "), _c('div', {
	    staticClass: "box-dicas"
	  }, [_vm._v("Senha deve ter uma letra maiúscula")]), _vm._v(" "), _c('div', {
	    staticClass: "box-dicas"
	  }, [_vm._v("\n                Senha deve ter um caractere especial\n              ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "circle-key"
	  })])
	}]}

/***/ }),
/* 2145 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.order.orderId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTime")(_vm.order.date)))]), _vm._v(" "), _c('td', [_vm._v("\n    " + _vm._s(_vm.order.status.description) + "\n    "), _c('div', {
	    staticClass: "info-table-contracted",
	    class: {
	      'info-table-expanded': _vm.expanded
	    }
	  }, [(_vm.order.paymentMethod.type == 'CC') ? [_c('img', {
	    staticClass: "credit-card",
	    attrs: {
	      "src": _vm.urlPayment,
	      "width": "31",
	      "height": "28"
	    }
	  }), _vm._v("\n      " + _vm._s(_vm.order.paymentMethod.creditCard.number) + "\n    ")] : (_vm.order.paymentMethod.type == 'DC') ? [_c('img', {
	    staticClass: "credit-card",
	    attrs: {
	      "src": _vm.urlPayment,
	      "width": "31",
	      "height": "28"
	    }
	  }), _vm._v("\n      " + _vm._s(_vm.order.paymentMethod.bankAccount.agencyNumber) + " - " + _vm._s(_vm.order.paymentMethod.bankAccount.accountNumber) + " - " + _vm._s(_vm.order.paymentMethod.bankAccount.accountDigit) + "\n    ")] : [_c('img', {
	    staticClass: "credit-card",
	    attrs: {
	      "src": _vm.urlPayment,
	      "width": "31",
	      "height": "28"
	    }
	  }), _vm._v("\n      " + _vm._s(_vm.order.paymentMethod.name) + "\n    ")]], 2)]), _vm._v(" "), _c('td', [_vm._v("\n    " + _vm._s(_vm.order.type) + "\n    "), _c('div', {
	    staticClass: "info-table-contracted",
	    class: {
	      'info-table-expanded': _vm.expanded
	    }
	  }, _vm._l((_vm.order.products.product), function(d) {
	    return _c('p', {
	      key: d.productId,
	      staticClass: "no-margin"
	    }, [_vm._v(_vm._s(d.productName))])
	  }), 0)]), _vm._v(" "), _c('td', {
	    staticClass: "text-right"
	  }, [_c('b', [_vm._v(_vm._s(_vm._f("cents")(_vm.order.price)))]), _vm._v(" "), _c('div', {
	    staticClass: "info-table-contracted",
	    class: {
	      'info-table-expanded': _vm.expanded
	    }
	  }, _vm._l((_vm.order.products.product), function(d) {
	    return _c('p', {
	      key: d.productId,
	      staticClass: "no-margin"
	    }, [_vm._v(_vm._s(_vm._f("cents")(_vm.isDescont(d, d.valueTotal))))])
	  }), 0)]), _vm._v(" "), _c('td', {
	    staticClass: "text-right"
	  }, [_c('button', {
	    staticClass: "btn btn-expand",
	    attrs: {
	      "type": "button",
	      "data-toggle": "tooltip",
	      "data-placement": "top"
	    },
	    on: {
	      "click": function($event) {
	        _vm.expanded = !_vm.expanded
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-plus",
	    class: {
	      'icon-minus': _vm.expanded
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2146 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back",
	    attrs: {
	      "to": "/servicos-b2c"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n        Voltar para planos\n      ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-back pull-right",
	    attrs: {
	      "to": "/servicos-b2c-plano-conforto"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n        Ver plano anterior\n      ")])], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("Serviços para Você")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-b10"
	  }, [_c('h3', {
	    staticClass: "bold upper"
	  }, [_vm._v("Plano Pague Fácil")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row color-row-1"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('div', {
	    staticClass: "txt-row-1"
	  }, [_c('span', [_vm._v("Com o plano "), _c('b', [_vm._v("PAGUE FÁCIL")]), _vm._v(" você só irá pagar quando utilizar o serviço. Funciona assim: toda vez que passar numa praça de pedágio iremos debitar o valor do pedágio + uma taxa de serviço de R$ 1,50.")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "balloon"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row color-row-2"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "free_pass"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "txt-row-2"
	  }, [_c('h3', [_c('b', [_vm._v("Não precisa efetuar recargas e nem pagar mensalidade.")])]), _vm._v(" "), _c('p', [_vm._v("A forma de pagamento é o cartão de crédito e você pode adicionar quantos veículos quiser.")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row color-row-3"
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "txt-row-3"
	  }, [_c('span', [_vm._v("Você pode ainda consultar "), _c('b', [_vm._v("saldos")]), _vm._v(", "), _c('b', [_vm._v("extratos")]), _vm._v(" e "), _c('b', [_vm._v("geolocalização dos veículos")]), _vm._v(" diretamente no nosso site ou no app para mobile (Android e iOS).")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "gps-vehicle"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row color-row-4"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "freedom-trip"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "txt-row-4"
	  }, [_c('h3', [_vm._v("Se você não quer amarras e ainda assim não perder tempo nas estradas, este é o seu plano.")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "tag": "button"
	    }
	  }, [_vm._v("\n          Plano indisponível\n        ")])])])])
	}]}

/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main hidden-print"
	  }, [_c('header', {
	    class: [_vm.isScrolling && 'scrolling', _vm.openMenuMobile && _vm.window.document.webview ? 'open-menu-webview' : _vm.openMenuMobile && 'open-menu']
	  }, [_c('div', {
	    staticClass: "header-container"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'inicio'
	      }
	    }
	  }, [_c('div', {
	    staticClass: "logo"
	  }, [_c('img', {
	    class: {
	      'logo-pending-scroll-version': !_vm.isMobile && _vm.isScrolling
	    },
	    staticStyle: {
	      "pointer-events": "none"
	    },
	    attrs: {
	      "src": ("../../static/" + _vm.logo),
	      "alt": "Logo Move Mais"
	    }
	  })])]), _vm._v(" "), (!_vm.openMenuMobile) ? _c('div', {
	    staticClass: "button-menu",
	    on: {
	      "click": function($event) {
	        _vm.openMenuMobile = true
	      }
	    }
	  }, [_c('img', {
	    staticClass: "mobile-icon",
	    attrs: {
	      "src": __webpack_require__(1837),
	      "alt": "HotdogNewRoxo_375"
	    }
	  })]) : _c('div', {
	    staticClass: "button-menu",
	    on: {
	      "click": function($event) {
	        _vm.openMenuMobile = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-cancel mobile-icon",
	    staticStyle: {
	      "font-size": "19px",
	      "margin-right": "20px"
	    }
	  })])], 1), _vm._v(" "), (_vm.openMenuMobile || !_vm.isMobile) ? [_c('div', {
	    staticClass: "menu-container",
	    on: {
	      "click": function($event) {
	        _vm.openMenuMobile = false
	      }
	    }
	  }, [_c('router-link', {
	    staticClass: "item-menu",
	    attrs: {
	      "tag": "div",
	      "to": {
	        name: 'services'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-coin2 mobile-icon"
	  }), _vm._v(" "), _c('span', [_vm._v("Planos")])]), _vm._v(" "), _c('router-link', {
	    staticClass: "item-menu",
	    attrs: {
	      "tag": "div",
	      "to": {
	        name: 'promo-toll-ticket'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-toll-ticket mobile-icon"
	  }), _vm._v(" "), _c('span', [_vm._v("Vale-pedágio")])]), _vm._v(" "), _c('router-link', {
	    staticClass: "item-menu",
	    attrs: {
	      "tag": "div",
	      "to": {
	        name: 'range'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-pin mobile-icon"
	  }), _vm._v(" "), _c('span', [_vm._v("Cobertura")])]), _vm._v(" "), _c('router-link', {
	    staticClass: "item-menu",
	    attrs: {
	      "tag": "div",
	      "to": {
	        name: 'move-mais'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-move-plus mobile-icon"
	  }), _vm._v(" "), _c('span', [_vm._v("A Move Mais")])]), _vm._v(" "), _c('router-link', {
	    staticClass: "item-menu",
	    attrs: {
	      "tag": "div",
	      "to": {
	        name: 'withdrawall-points'
	      }
	    }
	  }, [_c('img', {
	    staticClass: "mobile-icon icon-img",
	    attrs: {
	      "src": __webpack_require__(1865)
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Retirar TAG")])]), _vm._v(" "), _c('router-link', {
	    staticClass: "item-menu",
	    attrs: {
	      "tag": "div",
	      "to": {
	        name: 'contact'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-mail mobile-icon"
	  }), _vm._v(" "), _c('span', [_vm._v("Contato")])]), _vm._v(" "), _c('div', {
	    staticClass: "item-menu"
	  }, [_c('span', {
	    on: {
	      "click": function($event) {
	        return _vm.open('https://blog.movemais.net/')
	      }
	    }
	  }, [_c('img', {
	    staticClass: "mobile-icon icon-img",
	    attrs: {
	      "src": __webpack_require__(1842)
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("blog+")])])]), _vm._v(" "), _c('router-link', {
	    staticClass: "item-menu account",
	    attrs: {
	      "tag": "div",
	      "to": {
	        name: 'login'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-avatar mobile-icon"
	  }), _vm._v(" "), _c('span', [_vm._v("Minha Conta")])])], 1), _vm._v(" "), _vm._m(0)] : _vm._e()], 2)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "footer mobile"
	  }, [_c('span', [_vm._v("Acompanhe-nos")]), _vm._v(" "), _c('div', {
	    staticClass: "media-container"
	  }, [_c('div', {
	    staticClass: "media"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://www.facebook.com/MoveMais/",
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "icon-facebook mobile",
	    staticStyle: {
	      "font-size": "15px"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "media"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://www.instagram.com/movemais/",
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "icon-instagram mobile",
	    staticStyle: {
	      "font-size": "15px"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "media"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://www.linkedin.com/company/move-mais/",
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "icon-linkedin mobile",
	    staticStyle: {
	      "font-size": "15px"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "media"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://twitter.com/Move_Mais",
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "icon-twitter mobile",
	    staticStyle: {
	      "font-size": "15px"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "media"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://www.youtube.com/user/movemais",
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "icon-youtube mobile",
	    staticStyle: {
	      "font-size": "15px"
	    }
	  })])])])])
	}]}

/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "row"
	  }, [(_vm.planId == 28) ? _c('div', {
	    staticClass: "col-xs-12"
	  }, [(_vm.planId == 28) ? _c('div', [_c('div', {
	    staticClass: "alert alert-info",
	    staticStyle: {
	      "margin-top": "1%"
	    }
	  }, [_vm._v("\n          O débito da sua tag será realizado na sua próxima fatura Move Mais\n        ")])]) : _vm._e()]) : _c('div', {
	    staticClass: "col-xs-12"
	  }, [(!_vm.hasValidActivePaymentMethod) ? _c('div', {
	    staticClass: "alert alert-warning",
	    staticStyle: {
	      "margin-bottom": "20px"
	    },
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('h4', {
	    staticClass: "bold"
	  }, [_vm._v("Nenhuma forma de pagamento disponível")]), _vm._v(" "), _c('p', [_vm._v("Não há formas de pagamento autorizadas para este CPF/CNPJ no plano selecionado. Entre em contato com a Central de Relacionamento pelo número 4000 2901 (regiões metropolitanas) ou 0800 777 1022 (demais localidades) para mais informações.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.arrayCartao), function(paymentC) {
	    return (_vm.isPaymentMethodAuthorized('CC')) ? _c('div', {
	      staticClass: "content-box methods cred margin-b20",
	      class: {
	        'active': paymentC.contractPaymentMethodId == _vm.contractPaymentMethodId
	      }
	    }, [_c('label', {
	      staticClass: "content-box-link",
	      attrs: {
	        "for": 'credit-card' + paymentC.contractPaymentMethodId
	      },
	      on: {
	        "click": function($event) {
	          _vm.paymentSelected = paymentC
	        }
	      }
	    }, [_c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col-md-3"
	    }, [_c('div', {
	      staticClass: "radio-blue category"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.contractPaymentMethodId),
	        expression: "contractPaymentMethodId"
	      }],
	      staticClass: "radiobtn",
	      attrs: {
	        "id": 'credit-card' + paymentC.contractPaymentMethodId,
	        "type": "radio",
	        "name": "contractPaymentMethod"
	      },
	      domProps: {
	        "value": paymentC.contractPaymentMethodId,
	        "checked": _vm._q(_vm.contractPaymentMethodId, paymentC.contractPaymentMethodId)
	      },
	      on: {
	        "change": function($event) {
	          _vm.contractPaymentMethodId = paymentC.contractPaymentMethodId
	        }
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "radio-label label-h4"
	    }, [_vm._v("Cartão de Crédito")]), _vm._v(" "), _c('div', {
	      staticClass: "check first"
	    })])]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-6 block-card-data"
	    }, [_c('img', {
	      staticClass: "credit-card",
	      attrs: {
	        "src": _vm.imageUrl(paymentC),
	        "alt": paymentC.name,
	        "width": "49",
	        "height": "33"
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "border-right-gray"
	    }, [_c('h5', {
	      staticClass: "bold no-margin"
	    }, [_vm._v(_vm._s(paymentC.number))]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin"
	    }, [_vm._v(_vm._s('Válido até ' + paymentC.expirationMonth + '/' + paymentC.expirationYear))])]), _vm._v(" "), _c('div', {
	      staticClass: "credit-card-holder"
	    }, [_c('h5', {
	      staticClass: "bold no-margin upper"
	    }, [_vm._v(_vm._s(paymentC.ownerName))]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin"
	    }, [_vm._v("Nome do titular do cartão")])])]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-3 payment-card-cvv"
	    }, [_c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.contractPaymentMethodId == paymentC.contractPaymentMethodId),
	        expression: "contractPaymentMethodId==paymentC.contractPaymentMethodId"
	      }],
	      staticClass: "form-group csc csc-position",
	      class: {
	        'has-error': _vm.errors.has('secureCodeCreditCard')
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.paymentSelected.secureCodeCreditCard),
	        expression: "paymentSelected.secureCodeCreditCard"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required|min:3'),
	        expression: "'required|min:3'"
	      }, {
	        name: "only-numbers",
	        rawName: "v-only-numbers"
	      }],
	      staticClass: "form-control csc inline",
	      attrs: {
	        "placeholder": "Digite o CVV",
	        "type": "text",
	        "name": "secureCodeCreditCard",
	        "maxlength": "4",
	        "autofocus": ""
	      },
	      domProps: {
	        "value": (_vm.paymentSelected.secureCodeCreditCard)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(_vm.paymentSelected, "secureCodeCreditCard", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), _c('img', {
	      attrs: {
	        "src": __webpack_require__(226),
	        "alt": "",
	        "data-toggle": "tooltip",
	        "title": "Informe o código de segurança do cartão"
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "help-block"
	    }, [_c('span', {
	      staticClass: "three-dots"
	    }, [_vm._v(_vm._s(_vm.errors.first('secureCodeCreditCard')))])])])])])])]) : _vm._e()
	  }), _vm._v(" "), _vm._l((_vm.arrayDebito), function(paymentD) {
	    return (_vm.isPaymentMethodAuthorized('DC')) ? _c('div', {
	      staticClass: "content-box methods margin-b20",
	      class: {
	        'active': paymentD.contractPaymentMethodId == _vm.contractPaymentMethodId
	      }
	    }, [_c('label', {
	      staticClass: "content-box-link",
	      attrs: {
	        "for": 'debit' + paymentD.contractPaymentMethodId
	      },
	      on: {
	        "click": function($event) {
	          _vm.paymentSelected = paymentD
	        }
	      }
	    }, [_c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col-md-3"
	    }, [_c('div', {
	      staticClass: "radio-blue category"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.contractPaymentMethodId),
	        expression: "contractPaymentMethodId"
	      }],
	      staticClass: "radiobtn",
	      attrs: {
	        "id": 'debit' + paymentD.contractPaymentMethodId,
	        "type": "radio",
	        "name": "contractPaymentMethod"
	      },
	      domProps: {
	        "value": paymentD.contractPaymentMethodId,
	        "checked": _vm._q(_vm.contractPaymentMethodId, paymentD.contractPaymentMethodId)
	      },
	      on: {
	        "change": function($event) {
	          _vm.contractPaymentMethodId = paymentD.contractPaymentMethodId
	        }
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "radio-label label-h4"
	    }, [_vm._v("Débito em Conta")]), _vm._v(" "), _c('div', {
	      staticClass: "check first"
	    })])]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-6 block-debit-data"
	    }, [_c('img', {
	      staticClass: "credit-card",
	      attrs: {
	        "src": _vm.imageUrl(paymentD),
	        "alt": paymentD.name,
	        "width": "49",
	        "height": "33"
	      }
	    }), _vm._v(" "), _c('p', {
	      staticClass: "info-bank"
	    }, [_vm._v("Banco "), _c('b', [_vm._v(_vm._s(paymentD.name))])]), _vm._v(" "), _c('p', {
	      staticClass: "info-bank"
	    }, [_vm._v("Agência "), _c('b', [_vm._v(_vm._s(paymentD.agencyNumber))])]), _vm._v(" "), _c('p', {
	      staticClass: "info-bank"
	    }, [_vm._v("C/C "), _c('b', [_vm._v(_vm._s(paymentD.accountNumber + ' -  ' + paymentD.accountDigit))])])])])])]) : _vm._e()
	  }), _vm._v(" "), (_vm.boletoCadastrato && _vm.isPaymentMethodAuthorized('BC')) ? _c('div', {
	    staticClass: "content-box methods margin-b20",
	    class: {
	      'active': _vm.boletoCadastrato.contractPaymentMethodId == _vm.contractPaymentMethodId
	    }
	  }, [_c('label', {
	    staticClass: "content-box-link",
	    attrs: {
	      "for": "invoice"
	    },
	    on: {
	      "click": function($event) {
	        _vm.paymentSelected = _vm.boletoCadastrato
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "radio-blue category"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contractPaymentMethodId),
	      expression: "contractPaymentMethodId"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "invoice",
	      "type": "radio",
	      "name": "contractPaymentMethod"
	    },
	    domProps: {
	      "value": _vm.boletoCadastrato.contractPaymentMethodId,
	      "checked": _vm._q(_vm.contractPaymentMethodId, _vm.boletoCadastrato.contractPaymentMethodId)
	    },
	    on: {
	      "change": function($event) {
	        _vm.contractPaymentMethodId = _vm.boletoCadastrato.contractPaymentMethodId
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "radio-label label-h4"
	  }, [_vm._v("Boleto Bancário")]), _vm._v(" "), _c('div', {
	    staticClass: "check first"
	  })])])])])]) : _vm._e(), _vm._v(" "), (!_vm.boletoCadastrato && _vm.bankBillOption && _vm.isPaymentMethodAuthorized('BC')) ? _c('div', {
	    staticClass: "content-box methods margin-b20",
	    class: {
	      'active': _vm.contractPaymentMethodId == 'newBankBill'
	    }
	  }, [_c('label', {
	    staticClass: "content-box-link",
	    attrs: {
	      "for": "new-invoice"
	    },
	    on: {
	      "click": function($event) {
	        _vm.paymentSelected = 'newBankBill'
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "radio-blue category"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contractPaymentMethodId),
	      expression: "contractPaymentMethodId"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "new-invoice",
	      "type": "radio",
	      "name": "contractPaymentMethod",
	      "value": "-1"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.contractPaymentMethodId, "-1")
	    },
	    on: {
	      "change": function($event) {
	        _vm.contractPaymentMethodId = "-1"
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "radio-label label-h4"
	  }, [_vm._v("Boleto Bancário")]), _vm._v(" "), _c('div', {
	    staticClass: "check first"
	  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.showNewPayment && _vm.planId != 22 && _vm.planId != 32 && (_vm.typesAllowed.creditCard || _vm.typesAllowed.bankAccount) && _vm.hasValidActivePaymentMethod) ? _c('div', {
	    staticClass: "content-box methods margin-b20",
	    class: {
	      'active': 'newPayment' == _vm.contractPaymentMethodId
	    }
	  }, [_c('label', {
	    staticClass: "content-box-link",
	    attrs: {
	      "for": "new-payment"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "radio-blue category"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contractPaymentMethodId),
	      expression: "contractPaymentMethodId"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "new-payment",
	      "type": "radio",
	      "name": "contractPaymentMethod",
	      "value": "newPayment"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.contractPaymentMethodId, "newPayment")
	    },
	    on: {
	      "change": function($event) {
	        _vm.contractPaymentMethodId = "newPayment"
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "radio-label label-h4"
	  }, [_vm._v("Nova Forma de Pagamento")]), _vm._v(" "), _c('div', {
	    staticClass: "check first"
	  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.contractPaymentMethodId == 'newPayment') ? _c('payment', {
	    ref: "payment",
	    attrs: {
	      "payment": _vm.payment,
	      "planId": _vm.planId,
	      "addressMailing": _vm.addressMailing,
	      "creditCardOptions": _vm.creditCardOptions,
	      "bankAccountOptions": _vm.bankAccountOptions,
	      "bankBillOption": undefined
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.contractPaymentMethodId == 'newBankBill' || (_vm.boletoCadastrato && _vm.boletoCadastrato.contractPaymentMethodId == _vm.contractPaymentMethodId)) ? _c('div', [_vm._m(0)]) : _vm._e()], 2)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "alert alert-info",
	    staticStyle: {
	      "margin-top": "1%"
	    }
	  }, [_vm._v("\n          O boleto será enviado por email dentro de algumas horas."), _c('br'), _vm._v("\n          O tempo mínimo para compensação e disponibilização do crédito de boletos bancários junto às praças de pedágio é de 3 dias úteis após o pagamento."), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Para mais informações, entre em contato com a Central de Relacionamento pelo número 4000 2901 (regiões metropolitanas) ou 0800 777 1022 (demais localidades).")])])
	}]}

/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    class: _vm.disabled ? 'disabledOn' : 'disabledOff',
	    attrs: {
	      "id": "dropdown-container"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "select-container"
	    },
	    on: {
	      "click": _vm.OnClickStatus
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "placeholder-container"
	    }
	  }, [_c('h2', [_vm._v(_vm._s(_vm.captionSelected === "" ? _vm.placeholder : _vm.captionSelected))])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "icon-container"
	    }
	  }, [(_vm.visibleOptions) ? _c('img', {
	    attrs: {
	      "src": __webpack_require__(499)
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.visibleOptions) ? _c('img', {
	    attrs: {
	      "src": __webpack_require__(1769)
	    }
	  }) : _vm._e()])]), _vm._v(" "), (!_vm.visibleOptions) ? _c('div', {
	    attrs: {
	      "id": "option-container"
	    }
	  }, _vm._l((_vm.arrayRender), function(element) {
	    return _c('div', {
	      attrs: {
	        "id": "option-item"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.clickHandlerOptions(element.caption, element.value)
	        }
	      }
	    }, [_c('h2', [_vm._v(_vm._s(element.caption))])])
	  }), 0) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("\n        Comprovantes\n        "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Comprovante " + _vm._s(_vm.$route.params.orderId) + "\n      ")])], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    staticClass: "form-box margin-t20"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-content"
	  }, [_c('img', {
	    staticClass: "rule-color",
	    attrs: {
	      "src": __webpack_require__(116),
	      "alt": ""
	    }
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', {
	    staticClass: "title-toll-left upper bold"
	  }, [_vm._v("dados da conta debitada")]), _vm._v(" "), _c('p', {
	    staticClass: "title-toll-right"
	  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "box-toll-right"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', {
	    staticClass: "three-dots bold margin-l5"
	  }, [_vm._v(_vm._s(_vm.dataTransfer.nomeDebito) + "  ")]), _vm._v(" "), _c('p', {
	    staticClass: "three-dots bold margin-l5"
	  }, [_vm._v(_vm._s(_vm.dataTransfer.contractIdDeb) + "  ")]), _vm._v(" "), _c('p', {
	    staticClass: "three-dots bold margin-l5"
	  }, [_vm._v(_vm._s(_vm._f("dateTime")(_vm.dataTransfer.dataTransfer)) + "  ")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', {
	    staticClass: "title-doc-left upper bold"
	  }, [_vm._v("dados da conta creditada")]), _vm._v(" "), _c('p', {
	    staticClass: "title-doc-right credit"
	  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "box-doc-right"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', {
	    staticClass: "three-dots bold margin-l5"
	  }, [_vm._v(_vm._s(_vm.dataTransfer.nomeCredito) + "  ")]), _vm._v(" "), _c('p', {
	    staticClass: "three-dots bold margin-l5"
	  }, [_vm._v(_vm._s(_vm.dataTransfer.contractIdCred) + "  ")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', {
	    staticClass: "title-value-left upper bold"
	  }, [_vm._v("valor")]), _vm._v(" "), _c('p', {
	    staticClass: "title-value-right"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', {
	    staticClass: "three-dots text-center bold value-receipt"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.dataTransfer.transferValue)) + "  ")])])]), _vm._v(" "), _c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("   ")])])]), _vm._v(" "), _c('p', {
	    staticClass: "number-receipt"
	  }, [_vm._v("Identificador de controle: " + _vm._s(_vm.$route.params.orderId))]), _vm._v(" "), _c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("   ")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row hidden-print"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "margin-t20"
	  }, [_c('div', {
	    staticClass: "back-button-box"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n            Voltar\n          ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "action-buttons-box"
	  }, [_c('button', {
	    staticClass: "btn btn-back",
	    on: {
	      "click": function($event) {
	        return _vm.window.print()
	      }
	    }
	  }, [_vm._v("\n            Imprimir\n            "), _c('i', {
	    staticClass: "icon-printer align-icon-left"
	  })])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('img', {
	    staticClass: "logo-receipt",
	    attrs: {
	      "src": __webpack_require__(158),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('h4', {
	    staticClass: "title-receipt"
	  }, [_vm._v("Comprovante de transferência de créditos")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-toll-left"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', {
	    staticClass: "three-dots text-right margin-r5"
	  }, [_vm._v("Nome do cliente:")]), _vm._v(" "), _c('p', {
	    staticClass: "three-dots text-right margin-r5"
	  }, [_vm._v("N° do Contrato:")]), _vm._v(" "), _c('p', {
	    staticClass: "three-dots text-right margin-r5"
	  }, [_vm._v("Data da transferência:")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-doc-left"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', {
	    staticClass: "three-dots text-right margin-r5"
	  }, [_vm._v("Nome do cliente:")]), _vm._v(" "), _c('p', {
	    staticClass: "three-dots text-right margin-r5"
	  }, [_vm._v("N° do Contrato:")])])])])
	}]}

/***/ }),
/* 2151 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "margin-b10"
	  }, [_c('div', {
	    staticClass: "plain-box"
	  }, [_c('div', [(_vm.type != 'newContract' && !_vm.rodosol) ? _c('div', {
	    staticClass: "col-md small-padding-left"
	  }, [_c('div', {
	    staticClass: "fourth-col"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "row-button"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-large",
	    attrs: {
	      "tag": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.window.open(_vm.urlMoveCargo, '_blank')
	      }
	    }
	  }, [_vm._v("\n                Ative sua TAG\n              ")])])])]) : _vm._e()])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "first-line"
	  }, [_c('h3', {
	    staticClass: "sub-title plan upper"
	  }, [_vm._v("Tag Move Cargo")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "second-line"
	  }, [_c('p', {
	    staticClass: "mob-title-info"
	  }), _vm._v(" "), _c('p', [_vm._v("\n                O Vale-Pedágio Obrigatório (VPO) é um direito assegurado pela Lei nº 10.209/2001 e regulamentado pela Resolução ANTT nº 6.024/2023. Ele deve ser pago, por viagem, aos transportadores — sejam pessoas físicas ou jurídicas — responsáveis pelo transporte rodoviário de cargas.\n              ")]), _vm._v(" "), _c('p', [_vm._v("  \n                Importante destacar que o valor do pedágio não pode ser incluído no frete. Caso isso ocorra, o embarcador estará sujeito à aplicação de multa, conforme previsto na legislação.\n              ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "third-line"
	  }, [_c('h3', [_vm._v("Sem mensalidade e sem taxa de adesão")]), _vm._v(" "), _c('p', [_vm._v("\n                Use quando precisar, sem custos fixos ou surpresas.\n              ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "fourty-line"
	  }, [_c('h3', [_vm._v("Pagamento automático pela tag")]), _vm._v(" "), _c('p', [_vm._v("\n                Funciona conforme as normas de regulamentação, garantindo praticidade e segurança nas passagens.\n              ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "fifty-line"
	  }, [_c('h3', [_vm._v("Pensado para o dia a dia dos transportadores")]), _vm._v(" "), _c('p', [_vm._v("\n                Solução sob medida para quem vive na estrada e precisa de agilidade para receber Vale-pedágio.\n              ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sixty-line"
	  }, [_c('h3', [_vm._v("Atendimento exclusivo e dedicado")]), _vm._v(" "), _c('p', [_vm._v("\n                Conte com uma equipe especializada para te atender sempre que precisar.\n              ")])])
	}]}

/***/ }),
/* 2152 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    staticClass: "container"
	  }, [(_vm.code == undefined) ? _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("\n          Planos\n          "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Contrato\n          " + _vm._s(_vm.contractId) + " "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Adesão\n          de Veículo Adicional\n        ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('ul', {
	    staticClass: "wizard margin-b20 ad",
	    class: _vm.step == 1 ? ' past4 ' : ''
	  }, [_c('li', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    class: {
	      active: _vm.step == 0, past: _vm.step > 0
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('small', [_vm._v("Cadastro de veículos")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    class: {
	      active: _vm.step == 1, past: _vm.step > 1
	    }
	  }, [_vm._m(2), _vm._v(" "), _c('small', [_vm._v("Resumo e confirmação")]), _vm._v(" "), _vm._m(3)])])])]), _vm._v(" "), (_vm.msgError) ? _c('div', {
	    staticClass: "alert alert-danger margin-b10",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', {
	    staticClass: "upper"
	  }, [_vm._v("Atenção!")]), _vm._v(" " + _vm._s(_vm.msgError) + ".\n    ")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.subtitle[_vm.step]))]), _vm._v(" "), (_vm.step == 0) ? _c('vehicles', {
	    key: _vm.tagInHandVehiclesKey,
	    attrs: {
	      "vehicles": _vm.vehicles,
	      "type": _vm.user.type,
	      "allowVehicles": _vm.qtdAllowed,
	      "planId": _vm.planId
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.step == 1) ? _c('generic-summary', {
	    ref: "GenericSummary",
	    attrs: {
	      "order": _vm.salesOrder,
	      "showAddress": true,
	      "addressInit": _vm.addressInit,
	      "account": _vm.user,
	      "disablePayment": true
	    },
	    on: {
	      "tag-activation-state": _vm.onTagActivationState,
	      "shipment-type-change": _vm.onShipmentTypeChange
	    },
	    model: {
	      value: (_vm.cpm),
	      callback: function($$v) {
	        _vm.cpm = $$v
	      },
	      expression: "cpm"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.step == 1 && _vm.tagInHandActivated) ? _c('div', {
	    staticClass: "tag-success-banner"
	  }, [_c('div', {
	    staticClass: "tag-success-message"
	  }, [_c('svg', {
	    attrs: {
	      "width": "22",
	      "height": "22",
	      "viewBox": "0 0 22 22",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M11 20.1666C16.0627 20.1666 20.1667 16.0626 20.1667 11C20.1667 5.93737 16.0627 1.83331 11 1.83331C5.93743 1.83331 1.83337 5.93737 1.83337 11C1.83337 16.0626 5.93743 20.1666 11 20.1666Z",
	      "stroke": "#2E7D32",
	      "stroke-width": "1.83333",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  }), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M8.25 11L10.0833 12.8334L13.75 9.16669",
	      "stroke": "#2E7D32",
	      "stroke-width": "1.83333",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tagActivationSuccessMessage))])]), _vm._v(" "), _c('div', {
	    staticClass: "tag-success-actions"
	  }, [(!_vm.isReplaceTagFlow) ? _c('button', {
	    staticClass: "btn-link-add-vehicle",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.addAnotherVehicle
	    }
	  }, [_vm._v("\n          Adicionar outro veículo\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn-finish-tag-flow",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.finalizeTagInHandFlow
	    }
	  }, [_vm._v("\n          Finalizar\n          "), _c('svg', {
	    attrs: {
	      "width": "6",
	      "height": "10",
	      "viewBox": "0 0 6 10",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M0.666748 8.66669L4.66675 4.66669L0.666748 0.666687",
	      "stroke": "white",
	      "stroke-width": "1.33333",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.changeAddress),
	      expression: "changeAddress"
	    }]
	  }, [_c('address-comp', {
	    ref: "addressMailing",
	    attrs: {
	      "address": _vm.newAddress,
	      "type": "MAILING"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20"
	  }, [_c('div', {
	    staticClass: "action-buttons-box"
	  }, [_c('div', {
	    staticClass: "adhesion-footer-nav",
	    class: {
	      'adhesion-footer-nav--final-mobile': _vm.isMobile && _vm.step === 1
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "btn-container-adhesion-back-cancel"
	    }
	  }, [(_vm.step != 0 && !(_vm.isMobile && _vm.step === 1)) ? _c('button', {
	    attrs: {
	      "id": "button-back-adhesion",
	      "disabled": _vm.tagInHandActivated
	    },
	    on: {
	      "click": function($event) {
	        return _vm.backStep()
	      }
	    }
	  }, [_c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('g', {
	    attrs: {
	      "clip-path": "url(#clip_nv_back)"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M8.00016 5.33398L5.3335 8.00065M5.3335 8.00065L8.00016 10.6673M5.3335 8.00065H10.6668M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
	      "stroke": "#5D3B81",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
	    attrs: {
	      "id": "clip_nv_back"
	    }
	  }, [_c('rect', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "fill": "white"
	    }
	  })])])]), _vm._v("\n              Voltar\n            ")]) : _vm._e(), _vm._v(" "), _c('button', {
	    attrs: {
	      "id": "button-cancel-adhesion",
	      "disabled": _vm.tagInHandActivated
	    },
	    on: {
	      "click": function($event) {
	        return _vm.cancelar()
	      }
	    }
	  }, [_c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M12 4L4 12M4 4L12 12",
	      "stroke": "#E21C12",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })]), _vm._v("\n              Cancelar\n            ")])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "btn-container-adhesion-advance"
	    }
	  }, [(!_vm.changeAddress) ? [(_vm.step == 0 && !(_vm.isCaminhoParana && _vm.step == 0) && _vm.isMobile) ? _c('button', {
	    attrs: {
	      "id": "button-next-adhesion"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.nextStep()
	      }
	    }
	  }, [_vm._v("\n                Avançar\n                "), _c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
	      "stroke": "#F5F5F5",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.step == 1 && _vm.isMobile && _vm.shipmentType != 4) ? _c('button', {
	    attrs: {
	      "id": "button-concluir-adhesion-mobile",
	      "disabled": _vm.cpm.error,
	      "title": _vm.cpm.error
	    },
	    on: {
	      "click": function($event) {
	        return _vm.startRequest()
	      }
	    }
	  }, [_vm._v("\n                Finalizar pedido\n                "), _c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
	      "stroke": "#F5F5F5",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.step == 0 && !(_vm.isCaminhoParana && _vm.step == 0) && !_vm.isMobile) ? _c('button', {
	    attrs: {
	      "id": "button-next-adhesion"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.nextStep()
	      }
	    }
	  }, [_vm._v("\n                Avançar\n                "), _c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
	      "stroke": "#F5F5F5",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.step == 1 && !_vm.isMobile && _vm.shipmentType != 4) ? _c('button', {
	    attrs: {
	      "id": "button-concluir-adhesion",
	      "disabled": _vm.cpm.error,
	      "title": _vm.cpm.error
	    },
	    on: {
	      "click": function($event) {
	        return _vm.startRequest()
	      }
	    }
	  }, [_vm._v("\n                Finalizar pedido\n                "), _c('svg', {
	    attrs: {
	      "width": "16",
	      "height": "16",
	      "viewBox": "0 0 16 16",
	      "fill": "none",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
	      "stroke": "#F5F5F5",
	      "stroke-width": "1.6",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round"
	    }
	  })])]) : _vm._e()] : [_c('button', {
	    staticClass: "btn btn-purple",
	    on: {
	      "click": function($event) {
	        return _vm.saveAddress()
	      }
	    }
	  }, [_vm._v("\n                Alterar endereço\n                "), _c('i', {
	    staticClass: "icon-circle-right align-icon-right-white"
	  })])]], 2)])])])], 1) : _vm._e(), _vm._v(" "), _c('success-page', {
	    attrs: {
	      "code": _vm.code,
	      "boletoUrl": _vm.boletoUrl,
	      "type": 'newVehicle',
	      "novoCartao": _vm.novoCartao,
	      "salesOrder": _vm.salesResponse,
	      "usuario": _vm.usuario,
	      "validado": _vm.validado
	    }
	  }), _vm._v(" "), _c('error-page', {
	    attrs: {
	      "code": _vm.code,
	      "stepPayment": 1,
	      "type": 'newVehicle',
	      "salesOrder": _vm.salesResponse,
	      "validacaoFraude": _vm.validacaoFraude,
	      "cmpId": _vm.cmpId
	    },
	    on: {
	      "goToStep": _vm.goToStep
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-vehicle"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Cadastro de veículos")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step",
	    staticStyle: {
	      "margin-bottom": "1rem"
	    }
	  }, [_c('i', {
	    staticClass: "icon-confirmation-check"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Resumo e confirmação")])])
	}]}

/***/ }),
/* 2153 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [(_vm.page.itemCount() >= 0) ? _c('div', {
	    staticClass: "row margin-t20 margin-b20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "search-box inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search),
	      expression: "search"
	    }],
	    staticClass: "form-control search text-center bold",
	    attrs: {
	      "type": "text",
	      "name": "search-route",
	      "placeholder": "Digite o nome da rota"
	    },
	    domProps: {
	      "value": (_vm.search)
	    },
	    on: {
	      "keyup": _vm.filter,
	      "keypress": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.searchRoutes()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.search = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "btn-box inline"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.searchRoutes()
	      },
	      "keyup": function($event) {
	        return _vm.filter()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-search align-icon-left-white"
	  }), _vm._v("\n          Buscar\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.showAlert && !_vm.routeIdSelected) ? _c('div', {
	    staticClass: "margin-t20 margin-b20"
	  }, [_c('div', {
	    staticClass: "alert alert-info alert-container",
	    class: _vm.warning && 'alert-warning'
	  }, [_c('p', {
	    staticClass: "no-margin"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.msgStrong))]), _vm._v("\n        " + _vm._s(_vm.msgAlert) + "\n      ")]), _vm._v(" "), _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showAlert = false
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-cross icon-close-modal",
	    class: _vm.warning && 'icon-warning'
	  })])])]) : _vm._e(), _vm._v(" "), (_vm.page.itemCount() > 0 || _vm.routeIdSelected) ? _c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.routesPaged), function(r, index) {
	    return _c('tr', {
	      class: {
	        'active': _vm.routeSelected == r.routeId
	      }
	    }, [_c('td', [_c('div', {
	      staticClass: "radio-box"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.routeSelected),
	        expression: "routeSelected"
	      }],
	      staticClass: "radiobtn",
	      attrs: {
	        "id": r.routeId,
	        "type": "radio",
	        "name": "radio"
	      },
	      domProps: {
	        "value": r.routeId,
	        "checked": _vm._q(_vm.routeSelected, r.routeId)
	      },
	      on: {
	        "change": function($event) {
	          _vm.routeSelected = r.routeId
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      staticClass: "radio-label",
	      attrs: {
	        "for": r.routeId
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "check"
	    })])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r.name) + " - v." + _vm._s(r.version))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getAddress(r, 'origin')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getAddress(r, 'destination')))]), _vm._v(" "), _c('td', {
	      staticClass: "text-right"
	    }, [_vm._v(_vm._s(r.totalDistance) + " KM")]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(r.tollFees.length))])])
	  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.routesPaged != undefined && _vm.routesPaged.length != 0) ? [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 text-center"
	  }, [_c('pagination', {
	    attrs: {
	      "model": _vm.page
	    },
	    on: {
	      "page-change": _vm.setCurrentPage
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-b20"
	  }, [_c('div', {
	    staticClass: "col-xs-12 result-table-count text-center"
	  }, [_vm._v("\n          Mostrando resultados de " + _vm._s(_vm.page.firstIndexShown()) + " a " + _vm._s(_vm.page.lastIndexShown()) + " de um total de " + _vm._s(_vm.page.itemCount()) + " encontrados.\n        ")])])] : _vm._e()], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Rota")]), _vm._v(" "), _c('th', [_vm._v("Origem")]), _vm._v(" "), _c('th', [_vm._v("Destino")]), _vm._v(" "), _c('th', {
	    staticClass: "text-right"
	  }, [_vm._v("Distância")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center"
	  }, [_vm._v("Pedágios")])])])
	}]}

/***/ }),
/* 2154 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("Ativar TAG")]), _vm._v(" "), _c('div', {
	    staticClass: "margin-t30"
	  }, [(_vm.vehicle) ? _c('div', {
	    staticClass: "row row-fix content-box vehicles"
	  }, [_c('div', {
	    staticClass: "col-md-4 text-center"
	  }, [_c('div', {
	    staticClass: "plate-box"
	  }, [_c('p', {
	    staticClass: "cell-plate info-car"
	  }, [_c('span', {
	    attrs: {
	      "data-v-214ba40a": ""
	    }
	  }, [_vm._v(_vm._s(_vm.plate))])])]), _vm._v(" "), _c('div', {
	    staticClass: "tag-box"
	  }, [_c('p', {
	    staticClass: "no-margin bold"
	  }, [_vm._v("TAG N°")]), _vm._v(" "), _c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v(_vm._s(_vm.serial))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "vehicle-box"
	  }, [_c('p', {
	    staticClass: "no-margin bold"
	  }, [_vm._v(_vm._s(_vm.vehicle.model.brand.name))]), _vm._v(" "), _c('p', {
	    staticClass: "no-margin bold"
	  }, [_vm._v(_vm._s(_vm._f("firstWord")(_vm.vehicle.model.name)))]), _vm._v(" "), _c('p', {
	    staticClass: "no-margin three-dots"
	  }, [_vm._v(_vm._s(_vm._f("fromSecWord")(_vm.vehicle.model.name)))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5"
	  }, [(_vm.msg) ? _c('div', {
	    staticClass: "margin-b20 alert",
	    class: _vm.errorClass
	  }, [_c('p', [_vm._v(_vm._s(_vm.msg))])]) : _vm._e()])]) : _c('div', [(_vm.msg) ? _c('div', {
	    staticClass: "margin-b20 alert",
	    class: _vm.errorClass
	  }, [_c('p', [_vm._v(_vm._s(_vm.msg))])]) : _vm._e()])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary btn-lg btn-xxl",
	    attrs: {
	      "onclick": "Native.openScanner()"
	    }
	  }, [_vm._v("\n        Escanear outro veículo\n      ")]), _vm._v(" "), _c('i', {
	    staticClass: "icon-marquee align-icon"
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back margin-t20",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n        Voltar\n      ")])], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2155 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('div', {
	    staticClass: "row text-center"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "plain-box"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6 small-padding-left"
	  }, [_c('div', {
	    staticClass: "third-col-box margin-b20"
	  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "height-82 padding-28"
	  }, [(_vm.getNewAdhesionTax > 0) ? _c('h3', {
	    staticClass: "bold no-margin"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.getNewAdhesionTax)))]) : _c('span', [_c('h4', {
	    staticClass: "promo-value"
	  }, [_vm._v("R$ 39,90")]), _vm._v(" "), _c('b', {
	    staticClass: "promo-free"
	  }, [_vm._v("Grátis")])])]), _vm._v(" "), _c('div', {
	    staticClass: "height-82 padding-28"
	  }, [_c('h3', {
	    staticClass: "bold no-margin"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.getNewVehicleTax)))])]), _vm._v(" "), _c('div', {
	    staticClass: "height-82 padding-28"
	  }, [_c('h3', {
	    staticClass: "bold no-margin"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.getReplaceTax)))])]), _vm._v(" "), _c('div', {
	    staticClass: "height-82 padding-28"
	  }, [_c('h3', {
	    staticClass: "bold no-margin"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.getMonthlyTax)))])]), _vm._v(" "), _c('div', {
	    staticClass: "height-72 padding-t25"
	  }, [_c('a', {
	    directives: [{
	      name: "smooth-scroll",
	      rawName: "v-smooth-scroll"
	    }],
	    staticClass: "make-link",
	    attrs: {
	      "href": "#rechargeB2C"
	    }
	  }, [_vm._v("\n                      Veja Nossas Taxas de Recarga\n                    ")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "row-button border-radius-bottom"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "tag": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.choose(45)
	      }
	    }
	  }, [_vm._v("\n                      Quero este plano!\n                    ")])])])])])])])])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-2 first-col-box"
	  }, [_c('div', {
	    staticClass: "height-72 border-radius-top"
	  }, [_c('p', {
	    staticClass: "margin-10"
	  }, [_c('i', {
	    staticClass: "icon-plans icon-plans-table"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "height-112"
	  }, [_c('p', {
	    staticClass: "bold no-margin padding-t45"
	  }, [_vm._v("Como Funciona?")])]), _vm._v(" "), _c('div', {
	    staticClass: "height-82"
	  }, [_c('p', {
	    staticClass: "bold no-margin padding-t35"
	  }, [_vm._v("Adesão por Veículo")])]), _vm._v(" "), _c('div', {
	    staticClass: "height-82"
	  }, [_c('p', {
	    staticClass: "bold no-margin padding-12"
	  }, [_vm._v("Adesão Veículo Adicional")])]), _vm._v(" "), _c('div', {
	    staticClass: "height-82"
	  }, [_c('p', {
	    staticClass: "bold no-margin padding-12"
	  }, [_vm._v("Substituição (TAG)")])]), _vm._v(" "), _c('div', {
	    staticClass: "height-82"
	  }, [_c('p', {
	    staticClass: "bold no-margin padding-12"
	  }, [_vm._v("Mensalidade")])]), _vm._v(" "), _c('div', {
	    staticClass: "height-72"
	  }, [_c('p', {
	    staticClass: "bold no-margin padding-23"
	  }, [_vm._v("Taxa Recarga (2%)")])]), _vm._v(" "), _c('div', {
	    staticClass: "height-82 striped-line"
	  }, [_c('p', {
	    staticClass: "bold no-margin padding-12"
	  }, [_vm._v("Formas de Pagamento")])]), _vm._v(" "), _c('div', {
	    staticClass: "height-72 border-radius-bottom",
	    staticStyle: {
	      "height": "82px"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-72 border-radius-top"
	  }, [_c('h3', {
	    staticClass: "sub-title plan upper no-margin margin-b10"
	  }, [_vm._v("Pré-pago Automático sodré "), _c('br'), _vm._v("com mensalidade ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-112 height-72-big padding-18"
	  }, [_c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("Perfeito para você que gosta de comodidade e não quer se preocupar com recargas ou saldo insuficiente.")]), _vm._v(" "), _c('br')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "height-82 padding-20"
	  }, [_c('ul', [_c('li', [_vm._v("Cartão de Crédito")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "rechargeB2C"
	    }
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-b10"
	  }, [_c('h3', {
	    staticClass: "bold upper"
	  }, [_vm._v("Recargas")]), _vm._v(" "), _c('p', [_vm._v("As recargas consistem em taxa fixa de 2%, verifique os valores:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-red"
	  }, [_c('div', {
	    staticClass: "recharge-value-red"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-red"
	  }, [_vm._v("50")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("1,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-yellow"
	  }, [_c('div', {
	    staticClass: "recharge-value-yellow"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-yellow"
	  }, [_vm._v("100")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("2,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-green"
	  }, [_c('div', {
	    staticClass: "recharge-value-green"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-green"
	  }, [_vm._v("150")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("3,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-blue"
	  }, [_c('div', {
	    staticClass: "recharge-value-blue"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-blue"
	  }, [_vm._v("200")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("4,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge-last"
	  }, [_c('div', {
	    staticClass: "recharge-purple"
	  }, [_c('div', {
	    staticClass: "recharge-value-purple"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-purple"
	  }, [_vm._v("250")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("5,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-red"
	  }, [_c('div', {
	    staticClass: "recharge-value-red"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-red"
	  }, [_vm._v("300")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("6,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-yellow"
	  }, [_c('div', {
	    staticClass: "recharge-value-yellow"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-yellow"
	  }, [_vm._v("350")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("7,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-green"
	  }, [_c('div', {
	    staticClass: "recharge-value-green"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-green"
	  }, [_vm._v("400")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("8,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge"
	  }, [_c('div', {
	    staticClass: "recharge-blue"
	  }, [_c('div', {
	    staticClass: "recharge-value-blue"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-blue"
	  }, [_vm._v("450")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("9,00")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-recharge-last"
	  }, [_c('div', {
	    staticClass: "recharge-purple"
	  }, [_c('div', {
	    staticClass: "recharge-value-purple"
	  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-label-purple"
	  }, [_vm._v("500")]), _vm._v(" "), _c('div', {
	    staticClass: "recharge-tax-label"
	  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v("10,00")])])])])])])
	}]}

/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": _vm.mostrarModal ? 'slide-right' : 'slide-left',
	      "appear": ""
	    }
	  }, [_c('div', {
	    key: _vm.mostrarModal,
	    staticClass: "modal"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('h2', [_vm._v("Tabela de recarga")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "cursor": "pointer",
	      "font-size": "24px",
	      "position": "absolute",
	      "top": "0px",
	      "right": "2px"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.fecharModal()
	      }
	    }
	  }, [(!_vm.isMobile) ? _c('img', {
	    attrs: {
	      "src": __webpack_require__(507),
	      "alt": "Fechar"
	    }
	  }) : _c('img', {
	    attrs: {
	      "src": __webpack_require__(508),
	      "alt": "Fechar"
	    }
	  })])]), _vm._v(" "), _c('p', {
	    staticClass: "subTitle"
	  }, [_vm._v("Pessoa Jurídica")]), _vm._v(" "), _c('div', {
	    staticClass: "price-cards"
	  }, [_c('div', {
	    staticClass: "card price-card"
	  }, [_vm._v("\n          R$ " + _vm._s(_vm.recarga1.valor / 100) + "\n          "), _c('div', {
	    staticClass: "taxValue"
	  }, [_vm._v("Taxa: " + _vm._s(_vm._f("cents")(_vm.recarga1.taxa)))])]), _vm._v(" "), _c('div', {
	    staticClass: "card price-card"
	  }, [_vm._v("\n          R$ " + _vm._s(_vm.recarga2.valor / 100) + "\n          "), _c('div', {
	    staticClass: "taxValue"
	  }, [_vm._v("Taxa: " + _vm._s(_vm._f("cents")(_vm.recarga2.taxa)))])]), _vm._v(" "), _c('div', {
	    staticClass: "card price-card"
	  }, [_vm._v("\n          R$ " + _vm._s(_vm.recarga3.valor / 100) + "\n          "), _c('div', {
	    staticClass: "taxValue"
	  }, [_vm._v("Taxa: " + _vm._s(_vm._f("cents")(_vm.recarga3.taxa)))])]), _vm._v(" "), _c('div', {
	    staticClass: "card price-card"
	  }, [_vm._v("\n          R$ " + _vm._s(_vm.recarga4.valor / 100) + "\n          "), _c('div', {
	    staticClass: "taxValue"
	  }, [_vm._v("Taxa: " + _vm._s(_vm._f("cents")(_vm.recarga4.taxa)))])]), _vm._v(" "), _c('div', {
	    staticClass: "card price-card"
	  }, [_vm._v("\n          R$ " + _vm._s(_vm.recarga5.valor / 100) + "\n          "), _c('div', {
	    staticClass: "taxValue"
	  }, [_vm._v("Taxa: " + _vm._s(_vm._f("cents")(_vm.recarga5.taxa)))])]), _vm._v(" "), _c('div', {
	    staticClass: "card price-card"
	  }, [_vm._v("\n          R$ " + _vm._s(_vm.recarga6.valor / 100) + "\n          "), _c('div', {
	    staticClass: "taxValue"
	  }, [_vm._v("Taxa: " + _vm._s(_vm._f("cents")(_vm.recarga6.taxa)))])]), _vm._v(" "), _c('div', {
	    staticClass: "card price-card"
	  }, [_vm._v("\n          R$ " + _vm._s(_vm.recarga7.valor / 100) + "\n          "), _c('div', {
	    staticClass: "taxValue"
	  }, [_vm._v("Taxa: " + _vm._s(_vm._f("cents")(_vm.recarga7.taxa)))])]), _vm._v(" "), _c('div', {
	    staticClass: "card price-card"
	  }, [_vm._v("\n          R$ " + _vm._s(_vm.recarga8.valor / 100) + "\n          "), _c('div', {
	    staticClass: "taxValue"
	  }, [_vm._v("Taxa: " + _vm._s(_vm._f("cents")(_vm.recarga8.taxa)))])]), _vm._v(" "), _c('div', {
	    staticClass: "card price-card"
	  }, [_vm._v("\n          R$ " + _vm._s(_vm.recarga9.valor / 100) + "\n          "), _c('div', {
	    staticClass: "taxValue"
	  }, [_vm._v("Taxa: " + _vm._s(_vm._f("cents")(_vm.recarga9.taxa)))])]), _vm._v(" "), _c('div', {
	    staticClass: "card price-card"
	  }, [_vm._v("\n          R$ " + _vm._s(_vm.recarga10.valor / 100) + "\n          "), _c('div', {
	    staticClass: "taxValue"
	  }, [_vm._v("Taxa: " + _vm._s(_vm._f("cents")(_vm.recarga10.taxa)))])]), _vm._v(" "), _c('div', {
	    staticClass: "card price-card"
	  }, [_vm._v("\n          R$ " + _vm._s(_vm.recarga11.valor / 100) + "+\n          "), _c('div', {
	    staticClass: "taxValue"
	  }, [_vm._v("Taxa: " + _vm._s(_vm.recarga11.taxa) + "%")])])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2157 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "row"
	  }, [(_vm.typesAllowed.creditCard) ? _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "radio-box category flex-center",
	    class: {
	      'active': _vm.type == 'CC'
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.type),
	      expression: "type"
	    }],
	    attrs: {
	      "type": "radio",
	      "id": "credit",
	      "name": "radio",
	      "value": "CC"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.type, "CC")
	    },
	    on: {
	      "change": function($event) {
	        _vm.type = "CC"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label bold",
	    attrs: {
	      "for": "credit"
	    }
	  }, [_vm._v("\n          Cartão de Crédito\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  })])]) : _vm._e(), _vm._v(" "), (_vm.typesAllowed.bankBill) ? _c('div', {
	    class: _vm.colClassPayment
	  }, [_c('div', {
	    staticClass: "radio-box category",
	    class: {
	      'active': _vm.type == 'BC'
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.type),
	      expression: "type"
	    }],
	    attrs: {
	      "type": "radio",
	      "id": "billet",
	      "name": "radio",
	      "value": "BC"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.type, "BC")
	    },
	    on: {
	      "change": function($event) {
	        _vm.type = "BC"
	      }
	    }
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  })])]) : _vm._e(), _vm._v(" "), (_vm.typesAllowed.doc) ? _c('div', {
	    class: _vm.colClassPayment
	  }, [_c('div', {
	    staticClass: "radio-box category",
	    class: {
	      'active': _vm.type == 'DO'
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.type),
	      expression: "type"
	    }],
	    attrs: {
	      "type": "radio",
	      "id": "doc",
	      "name": "radio",
	      "value": "DO"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.type, "DO")
	    },
	    on: {
	      "change": function($event) {
	        _vm.type = "DO"
	      }
	    }
	  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  })])]) : _vm._e(), _vm._v(" "), (_vm.typesAllowed.ted) ? _c('div', {
	    class: _vm.colClassPayment
	  }, [_c('div', {
	    staticClass: "radio-box category",
	    class: {
	      'active': _vm.type == 'TE'
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.type),
	      expression: "type"
	    }],
	    attrs: {
	      "type": "radio",
	      "id": "ted",
	      "name": "radio",
	      "value": "TE"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.type, "TE")
	    },
	    on: {
	      "change": function($event) {
	        _vm.type = "TE"
	      }
	    }
	  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  })])]) : _vm._e()]), _vm._v(" "), (_vm.type == 'BC') ? _c('div', {
	    staticClass: "margin-b20"
	  }, [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.type == 'DO') ? _c('div', {
	    staticClass: "margin-b20"
	  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.type == 'TE') ? _c('div', {
	    staticClass: "margin-b20"
	  }, [_vm._m(5)]) : _vm._e(), _vm._v(" "), (_vm.limiteCredito()) ? _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-box margin-t20"
	  }, [_c('b', {
	    staticClass: "title-identification margin-b10"
	  }, [_vm._v("Dados para Cartão de Crédito")]), _vm._v(" "), _c('div', {
	    staticClass: "form-content"
	  }, [_c('credit-card', {
	    ref: "creditCard",
	    attrs: {
	      "showCvv": true,
	      "planId": _vm.planId,
	      "addressStart": _vm.addressMailing
	    },
	    model: {
	      value: (_vm.creditCard),
	      callback: function($$v) {
	        _vm.creditCard = $$v
	      },
	      expression: "creditCard"
	    }
	  })], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.type == 'DC') ? _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-box margin-t20"
	  }, [_c('b', {
	    staticClass: "title-identification margin-b10"
	  }, [_vm._v("Dados para Débito em Conta")]), _vm._v(" "), _c('div', {
	    staticClass: "form-content"
	  }, [_c('bank-account', {
	    ref: "bankAccount",
	    attrs: {
	      "planId": _vm.planId
	    },
	    model: {
	      value: (_vm.bankAccount),
	      callback: function($$v) {
	        _vm.bankAccount = $$v
	      },
	      expression: "bankAccount"
	    }
	  }), _vm._v(" "), _c('small', [_vm._v("Obs: A adesão é efetuada após a confirmação do pagamento. Para o débito em conta, o prazo para confirmação é de até 5 dias úteis.")])], 1)])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "radio-label bold",
	    attrs: {
	      "for": "billet"
	    }
	  }, [_c('i', {
	    staticClass: "icon-bank-slip"
	  }), _vm._v("\n        Boleto Bancário\n      ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "radio-label bold",
	    attrs: {
	      "for": "doc"
	    }
	  }, [_c('i', {
	    staticClass: "icon-doc"
	  }), _vm._v("\n        DOC\n      ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "radio-label bold",
	    attrs: {
	      "for": "ted"
	    }
	  }, [_c('i', {
	    staticClass: "icon-ted"
	  }), _vm._v("\n        TED\n      ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "alert alert-info",
	    staticStyle: {
	      "margin-top": "1%"
	    }
	  }, [_vm._v("\n      O tempo mínimo para compensação e disponibilização do crédito de boletos bancários junto às praças de pedágio é de 3 dias úteis."), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Para mais informações, entre em contato com a Central de Relacionamento pelo número 4000 2901 (regiões metropolitanas) ou 0800 777 1022 (demais localidades).")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "alert alert-info",
	    staticStyle: {
	      "margin-top": "1%"
	    }
	  }, [_vm._v("\n      O tempo mínimo para compensação e disponibilização do crédito de Documento de Ordem de Crédito (DOC) junto às praças de pedágio é de 3 dias úteis."), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Para mais informações, entre em contato com a Central de Relacionamento pelo número 4000 2901 (regiões metropolitanas) ou 0800 777 1022 (demais localidades).")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "alert alert-info",
	    staticStyle: {
	      "margin-top": "1%"
	    }
	  }, [_vm._v("\n      O tempo mínimo para compensação e disponibilização do crédito de Transferência Eletrônica Disponível (TED) junto às praças de pedágio é de 3 dias úteis."), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Para mais informações, entre em contato com a Central de Relacionamento pelo número 4000 2901 (regiões metropolitanas) ou 0800 777 1022 (demais localidades).")])])
	}]}

/***/ }),
/* 2158 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-box margin-b20 padding-b10"
	  }, [_c('b', {
	    staticClass: "title-identification margin-b10"
	  }, [_vm._v("Resumo e Confirmação do Pedido")]), _vm._v(" "), _c('div', {
	    staticClass: "form-content"
	  }, [_c('div', {
	    staticClass: "plan-line-purple margin-b30"
	  }, [_c('p', [_vm._v("Plano Escolhido: "), _c('b', [_vm._v(" " + _vm._s(_vm.plan.name))])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [(_vm.isPF) ? _c('div', {
	    staticClass: "col-md-6 user-data-resume"
	  }, [_c('b', [_vm._v("Dados Pessoais")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots"
	  }, [_vm._v(_vm._s(_vm.account.taxIdNumberFormatted) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots"
	  }, [_vm._v(_vm._s(_vm.account.person.fullName) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots"
	  }, [_vm._v(_vm._s(_vm.account.person.birthDateBR) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots"
	  }, [_vm._v(_vm._s(_vm.account.accountAuthentication.login) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v(_vm._s(_vm.typeTel1) + ":")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', [_vm._v(_vm._s(_vm.tel1) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v(_vm._s(_vm.typeTel2) + ":")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', [_vm._v(_vm._s(_vm.tel2) + " ")])])])]) : _c('div', {
	    staticClass: "col-md-6 user-data-resume"
	  }, [_c('b', [_vm._v("Dados da Empresa")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots"
	  }, [_vm._v(_vm._s(_vm.account.taxIdNumberFormatted) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots"
	  }, [_vm._v(_vm._s(_vm.account.company.companyName) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots"
	  }, [_vm._v(_vm._s(_vm.account.company.companyTradeName) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(7), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots"
	  }, [_vm._v(_vm._s(_vm.account.accountAuthentication.login) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v(_vm._s(_vm.typeTel1) + ":")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', [_vm._v(_vm._s(_vm.tel1) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v(_vm._s(_vm.typeTel2) + ":")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', [_vm._v(_vm._s(_vm.tel2) + " ")])])])]), _vm._v(" "), (_vm.isCaminhoParana) ? _c('div', {
	    staticClass: "col-md-6 address-resume"
	  }, [_c('b', [_vm._v("Endereço de retirada da TAG eletrônica")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _vm._m(8)]) : _c('div', {
	    staticClass: "col-md-6 address-resume"
	  }, [_c('b', [_vm._v("Endereço")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "radio-box content-box",
	    class: {
	      'active': _vm.request.whereToDelivrey == 0
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.request.whereToDelivrey),
	      expression: "request.whereToDelivrey"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "0",
	      "type": "radio",
	      "name": "radio",
	      "value": "0"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.request.whereToDelivrey, "0")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.request, "whereToDelivrey", "0")
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label",
	    attrs: {
	      "for": "0"
	    }
	  }, [_c('p', {
	    staticClass: "break"
	  }, [_vm._v(_vm._s(_vm.address.zipCode.address) + ", " + _vm._s(_vm.address.number))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.address.zipCode.neighborhood))]), _vm._v(" "), _c('p', [_vm._v("CEP " + _vm._s(_vm.address.zipCode.zipCode))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.address.zipCode.city) + " - " + _vm._s(_vm.address.zipCode.state) + " - Brasil")]), _vm._v(" "), (_vm.address.complement && _vm.address.complement.length > 0) ? _c('p', [_vm._v("Complemento - " + _vm._s(_vm.address.complement))]) : _vm._e(), _vm._v(" "), _c('small', {
	    staticClass: "block"
	  }, [_vm._v("Obs: Os Tags serão entregues no endereço informado.")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-sm btn-back",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('goToStep', 1)
	      }
	    }
	  }, [_vm._v("Alterar Endereço")])]), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "radio-box content-box",
	    class: {
	      'active': _vm.request.whereToDelivrey == 61800016
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.request.whereToDelivrey),
	      expression: "request.whereToDelivrey"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "61800016",
	      "type": "radio",
	      "name": "radio",
	      "value": "61800016"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.request.whereToDelivrey, "61800016")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.request, "whereToDelivrey", "61800016")
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label",
	    attrs: {
	      "for": "61800016"
	    }
	  }, [_c('p', [_vm._v("Retirar as TAGs na MSVIAS")]), _vm._v(" "), _c('small', {
	    staticClass: "block break"
	  }, [_vm._v("As TAGs poderão ser retiradas após a confirmação do pagamento")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-sm btn-back",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.getTolls('MS', '61800016')
	      }
	    }
	  }, [_vm._v("Consultar praças")])]), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  })])])]), _vm._v(" "), (_vm.vehicles && _vm.vehicles.length > 0) ? _c('div', {
	    staticClass: "row margin-t30"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('b', [_vm._v("Veículos")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _vm._l((_vm.vehicles), function(v, index) {
	    return _c('div', {
	      key: v.plate,
	      staticClass: "content-box margin-10"
	    }, [_c('div', {
	      staticClass: "inline plate-box"
	    }, [_c('p', {
	      staticClass: "cell-plate info-car"
	    }, [_c('span', [_vm._v(_vm._s(v.plate))])])]), _vm._v(" "), _c('div', {
	      staticClass: "inline info-car-box"
	    }, [_c('p', {
	      staticClass: "border-right-gray info-car block"
	    }, [_c('b', [_vm._v(_vm._s(v.model.brand.name))])]), _vm._v(" "), _c('p', {
	      staticClass: "model info-car block"
	    }, [_c('b', {
	      attrs: {
	        "title": v.model.name
	      }
	    }, [_vm._v(_vm._s(_vm._f("firstWord")(v.model.name)))])]), _vm._v(" "), _c('p', {
	      staticClass: "border-right-gray model info-car block",
	      attrs: {
	        "title": v.model.name
	      }
	    }, [_vm._v(_vm._s(_vm._f("fromSecWord")(v.model.name)))]), _vm._v(" "), _c('p', {
	      staticClass: "model info-car block",
	      attrs: {
	        "title": v.categoryAxes.name
	      }
	    }, [_vm._v(_vm._s(v.categoryAxes.name))])])])
	  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('b', [_vm._v("Forma de Pagamento")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), (_vm.payment.creditCard) ? _c('div', {
	    staticClass: "content-box methods margin-20"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(9), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 text-center"
	  }, [_c('img', {
	    staticClass: "credit-card",
	    attrs: {
	      "src": _vm.image,
	      "width": "31",
	      "height": "28"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "border-right-gray"
	  }, [_c('h5', {
	    staticClass: "bold"
	  }, [_vm._v(_vm._s(_vm.payment.creditCard.number))]), _vm._v(" "), _c('small', [_vm._v("Válido até " + _vm._s(_vm.payment.creditCard.expirationMonth + '/ ' + _vm.payment.creditCard.expirationYear))])]), _vm._v(" "), _c('div', [_c('h5', {
	    staticClass: "bold"
	  }, [_vm._v(_vm._s(_vm.payment.creditCard.ownerName))]), _vm._v(" "), _c('small', [_vm._v("Nome do titular do cartão")])])])])]) : _vm._e(), _vm._v(" "), (_vm.payment.bankAccount) ? _c('div', {
	    staticClass: "content-box"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(10), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 text-center"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.image,
	      "width": "31",
	      "height": "28"
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "info-bank bank-name"
	  }, [_vm._v("Banco "), _c('b', [_vm._v(_vm._s(_vm.payment.bankAccount.name))])]), _vm._v(" "), _c('p', {
	    staticClass: "info-bank"
	  }, [_vm._v("Agência "), _c('b', [_vm._v(_vm._s(_vm.payment.bankAccount.agencyNumber))])]), _vm._v(" "), _c('p', {
	    staticClass: "info-bank"
	  }, [_vm._v("C/C "), _c('b', [_vm._v(_vm._s(_vm.payment.bankAccount.accountNumber + ' - ' + _vm.payment.bankAccount.accountDigit))])])])])]) : _vm._e(), _vm._v(" "), (_vm.payment.CR) ? _c('div', {
	    staticClass: "content-box"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(11), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 text-center"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.image,
	      "width": "31",
	      "height": "28"
	    }
	  }), _vm._v(" "), _vm._m(12)])])]) : _vm._e(), _vm._v(" "), (_vm.payment.type == 'BC' || _vm.payment.type == 'DO' || _vm.payment.type == 'TE') ? _c('div', {
	    staticClass: "content-box margin-t20"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('p', {
	    staticClass: "bold no-margin"
	  }, [_vm._v(_vm._s(_vm.payment.name))])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 text-center"
	  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('b', [_vm._v("Valores")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), [_c('table', {
	    staticClass: "table stripped no-footer",
	    attrs: {
	      "role": "grid"
	    }
	  }, [_vm._m(13), _vm._v(" "), _c('tbody', [(_vm.vehicles && _vm.vehicles.length) ? _c('tr', [_c('td', [_vm._v("Adesão Move Mais - " + _vm._s(_vm.vehicles[0].plate))]), _vm._v(" "), _c('td', {
	    staticClass: "bold text-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.newAdhesionTax)))])]) : _vm._e(), _vm._v(" "), (_vm.isCaminhoParana) ? _c('tr', [_c('td', [_vm._v("Desconto - " + _vm._s(_vm.vehicles[0].plate))]), _vm._v(" "), _c('td', {
	    staticClass: "bold text-right"
	  }, [_vm._v("-" + _vm._s(_vm._f("cents")(_vm.newAdhesionTax)))])]) : _vm._e(), _vm._v(" "), (_vm.monthlyTax) ? _c('tr', [_c('td', [_vm._v("Mensalidade - " + _vm._s(_vm.vehicles[0].plate))]), _vm._v(" "), _c('td', {
	    staticClass: "bold text-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.monthlyTax)))])]) : _vm._e(), _vm._v(" "), (_vm.planId == 2 || _vm.planId == 3) ? _c('tr', [_c('td', [_vm._v("Vinculação RNTRC - " + _vm._s(_vm.vehicles[0].plate))]), _vm._v(" "), _c('td', {
	    staticClass: "bold text-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.linkRntrcTax)))])]) : _vm._e(), _vm._v(" "), (_vm.vehicles && _vm.vehicles.length > 1) ? [_vm._l((_vm.vehicles.length - 1), function(n) {
	    return [_c('tr', [_c('td', [_vm._v("Adesão Move Mais - " + _vm._s(_vm.vehicles[n].plate))]), _vm._v(" "), _c('td', {
	      staticClass: "bold text-right"
	    }, [_vm._v(_vm._s(_vm._f("cents")(_vm.newVehicleTax)))])]), _vm._v(" "), (_vm.isCaminhoParana) ? _c('tr', [_c('td', [_vm._v("Desconto - " + _vm._s(_vm.vehicles[n].plate))]), _vm._v(" "), _c('td', {
	      staticClass: "bold text-right"
	    }, [_vm._v("-" + _vm._s(_vm._f("cents")(_vm.newVehicleTax)))])]) : _vm._e(), _vm._v(" "), (_vm.monthlyTax) ? _c('tr', [_c('td', [_vm._v("Mensalidade - " + _vm._s(_vm.vehicles[n].plate))]), _vm._v(" "), _c('td', {
	      staticClass: "bold text-right"
	    }, [_vm._v(_vm._s(_vm._f("cents")(_vm.monthlyTax)))])]) : _vm._e(), _vm._v(" "), (_vm.planId == 2 || _vm.planId == 3) ? _c('tr', [_c('td', [_vm._v("Vinculação RNTRC - " + _vm._s(_vm.vehicles[n].plate))]), _vm._v(" "), _c('td', {
	      staticClass: "bold text-right"
	    }, [_vm._v(_vm._s(_vm._f("cents")(_vm.linkRntrcTax)))])]) : _vm._e()]
	  })] : _vm._e(), _vm._v(" "), (_vm.planHasRecharge(_vm.planId)) ? _c('tr', [_c('td', [_vm._v("Carga Inicial")]), _vm._v(" "), _c('td', {
	    staticClass: "bold text-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.rechargeValueTotal)))])]) : _vm._e(), _vm._v(" "), (_vm.planHasRecharge(_vm.planId)) ? _c('tr', [_c('td', [_vm._v("Taxa de Recarga")]), _vm._v(" "), _c('td', {
	    staticClass: "bold text-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.rechargeTaxTotal)))])]) : _vm._e(), _vm._v(" "), (_vm.guaranteeTax) ? _vm._l((_vm.vehicles.length), function(n) {
	    return _c('tr', {
	      key: n.plate
	    }, [_c('td', [_vm._v("Caução - " + _vm._s(_vm.vehicles[n - 1].plate))]), _vm._v(" "), _c('td', {
	      staticClass: "bold text-right"
	    }, [_vm._v(_vm._s(_vm._f("cents")(_vm.guaranteeTax)))])])
	  }) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
	    staticStyle: {
	      "width": "70%"
	    }
	  }, [_vm._v("\n                        Cupom de Desconto\n                        "), _c('i', {
	    staticClass: "icon-info",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "O cupom de desconto é um código promocional que você pode utilizar para abater uma parte ou a totalidade do valor de uma compra. É só colar um código promocional válido e clicar em aplicar desconto e pronto, você já vai ter o desconto aplicado na sua compra Move Mais!"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "inline pull-right"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cupom),
	      expression: "cupom"
	    }],
	    staticClass: "inline form-control discount discount-coupon",
	    attrs: {
	      "minlength": "5",
	      "maxlength": "25",
	      "type": "text",
	      "placeholder": "Digite o código",
	      "disabled": _vm.descontoCupom != 0
	    },
	    domProps: {
	      "value": (_vm.cupom)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.cupom = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.descontoCupom),
	      expression: "!descontoCupom"
	    }],
	    staticClass: "inline btn btn-primary btn-discount discount-coupon",
	    attrs: {
	      "type": "button",
	      "name": "button",
	      "disabled": !_vm.cupom
	    },
	    on: {
	      "click": function($event) {
	        return _vm.calculateDiscount()
	      }
	    }
	  }, [_vm._v("\n                            Aplicar Desconto\n                          ")]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.descontoCupom),
	      expression: "descontoCupom"
	    }],
	    staticClass: "inline btn btn-danger btn-discount discount-coupon",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.removeDiscount()
	      }
	    }
	  }, [_vm._v("\n                            Remover Desconto\n                          ")]), _vm._v(" "), (_vm.erroCupom) ? _c('div', {
	    staticClass: "discount-error-msg"
	  }, [_c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v(_vm._s(_vm.erroCupom))])]) : _vm._e()])]), _vm._v(" "), _c('td', {
	    staticClass: "bold text-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(-1 * _vm.descontoCupom)))])])], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
	    staticClass: "bold-600"
	  }, [_vm._v("TOTAL")]), _vm._v(" "), _c('td', {
	    staticClass: "bold text-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.totalComDesconto)))])])])])]], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [(_vm.getKindPlan(_vm.planId) == 'RNTRC') ? _c('div', {
	    staticClass: "col-xs-12",
	    class: {
	      'has-error': _vm.errors.has('terms')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "check-terms",
	    attrs: {
	      "id": "termsRntrc",
	      "type": "checkbox",
	      "name": "terms",
	      "value": "1"
	    }
	  }), _vm._v(" "), _vm._m(14), _vm._v(" "), (_vm.errors.has('terms')) ? _c('div', {
	    staticClass: "alert alert-danger alert-terms",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('span', {
	    staticClass: "help-block"
	  }, [_vm._v("É necessário ler e concordar com os termos para realizar a vinculação")])]) : _vm._e()]) : _c('div', {
	    staticClass: "col-xs-12",
	    class: {
	      'has-error': _vm.errors.has('terms')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "check-terms",
	    attrs: {
	      "id": "terms",
	      "type": "checkbox",
	      "name": "terms",
	      "value": "1"
	    }
	  }), _vm._v(" "), _vm._m(15), _vm._v(" "), (_vm.errors.has('terms')) ? _c('div', {
	    staticClass: "alert alert-danger alert-terms",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('span', {
	    staticClass: "help-block"
	  }, [_vm._v("É necessário ler e concordar com os termos para realizar a adesão")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog",
	      "id": "modalTermsRntrc"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(16), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('p', {
	    staticClass: "margin-b20"
	  }, [_vm._v("\n                    Eu, inscrito sob " + _vm._s(_vm.taxIdType) + " nº " + _vm._s(_vm.account.taxIdNumberFormatted) + ", estou ciente da utilização do Transponder de Identificação Veicular - TIV/TAG para fins de identificação eletrônica do veículo automotor de cargas inscrito no Registro Nacional de Transportadores Rodoviários de Cargas (RNTRC), conforme previsto na Resolução ANTT nº 4.799, de 27 de julho de 2015 e Deliberação nº 301-A de 23 de novembro de 2016, estando sujeito à fiscalização das obrigações referentes ao exercício da atividade de transporte rodoviário remunerado de cargas.\n                  ")]), _vm._v(" "), _c('p', {
	    staticClass: "margin-20"
	  }, [_vm._v("Data: " + _vm._s(_vm._f("dateFull")(new Date())))]), _vm._v(" "), _vm._m(17)]), _vm._v(" "), _vm._m(18)])])])])])])]), _vm._v(" "), (_vm.showEntries) ? _c('div', {
	    staticClass: "modal fade in",
	    staticStyle: {
	      "display": "block"
	    },
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showEntries = false
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Praças")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('h3', [_vm._v("Praças onde a TAG pode ser retirada")]), _vm._v(" "), _vm._l((_vm.entries), function(item, index) {
	    return _c('div', [_c('p', [_vm._v(_vm._s(item.roadCode) + " KM " + _vm._s(item.km) + " - " + _vm._s(item.city))])])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showEntries = false
	      }
	    }
	  }, [_vm._v("Fechar")])])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("CPF:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Nome Completo:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Data de Nascimento:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("E-mail:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("CNPJ:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Razão Social:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Nome fantasia:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("E-mail:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-box"
	  }, [_c('p', [_vm._v("Base de apoio operacional da Concessionária Caminhos do Paraná")]), _vm._v(" "), _c('p', [_vm._v("Rodovia 277, Km 249, 700")]), _vm._v(" "), _c('p', [_vm._v("Irati - PR")]), _vm._v(" "), _c('p', [_vm._v("Atendimento: Segunda a Sexta, das 8 às 17h.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('p', {
	    staticClass: "bold no-margin"
	  }, [_vm._v("Cartão de Crédito")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('p', {
	    staticClass: "bold no-margin"
	  }, [_vm._v("Débito em Conta")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('p', {
	    staticClass: "bold no-margin"
	  }, [_vm._v("Pós-Pago")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "info-bank"
	  }, [_c('b', [_vm._v("Move Mais")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', {
	    staticClass: "hidden"
	  }, [_c('th', {
	    attrs: {
	      "width": "50%"
	    }
	  }), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "50%"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "label-terms",
	    attrs: {
	      "for": "termsRntrc"
	    }
	  }, [_vm._v("\n                Li e aceito as condições gerais de contratação do serviço.\n                "), _c('a', {
	    staticClass: "link",
	    attrs: {
	      "data-toggle": "modal",
	      "data-target": "#modalTermsRntrc"
	    }
	  }, [_vm._v("Ver contrato")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "label-terms",
	    attrs: {
	      "for": "terms"
	    }
	  }, [_vm._v("\n                Li e aceito as condições gerais de contratação do serviço.\n                "), _c('a', {
	    staticClass: "link",
	    attrs: {
	      "href": "/api/v2/archeion/downloadFileArcheion/termos-e-condicoes-gerais-movemais",
	      "target": "_blank"
	    }
	  }, [_vm._v("Ver contrato")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header modal-info"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Vinculação RNTRC - Termos de Aceite")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "term-subtitle"
	  }, [_vm._v("\n                    Versão 1.01"), _c('br'), _vm._v("\n                    Última Atualização: 12 de julho de 2017\n                  ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("OK")])])
	}]}

/***/ }),
/* 2159 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('title-user', [_vm._v("\n    Planos\n    "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n    Contrato " + _vm._s(_vm.contractId) + "\n    "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Extrato Consolidado\n  ")]), _vm._v(" "), _c('p', [_vm._v("Selecione as placas e o período desejado para extração do extrato.")]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('form', {
	    staticClass: "form form-inline"
	  }, [_c('div', {
	    staticClass: "inline margin-10"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-plate",
	    class: {
	      'has-error': _vm.errors.has('plate')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.plate),
	      expression: "plate"
	    }, {
	      name: "mask-plate",
	      rawName: "v-mask-plate"
	    }],
	    staticClass: "form-control plate-field upper",
	    attrs: {
	      "type": "search",
	      "name": "plate",
	      "placeholder": "Digite a Placa"
	    },
	    domProps: {
	      "value": (_vm.plate)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.doFilter(true)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.plate = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('plate')))])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-purple btn-sm btn-filter",
	    attrs: {
	      "type": "button",
	      "name": "btnFind"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.doFilter(true)
	      }
	    }
	  }, [_vm._v("Filtrar")])]), _vm._v(" "), _c('div', {
	    staticClass: "inline text-right"
	  }, [_c('div', {
	    staticClass: "inline filter-period"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('span', {
	    staticClass: "period"
	  }, [_vm._v("Período:")]), _vm._v(" "), _c('dropdown', {
	    staticClass: "dropdown-lastdays",
	    attrs: {
	      "options": _vm.lastDaysOptions
	    },
	    model: {
	      value: (_vm.lastDays),
	      callback: function($$v) {
	        _vm.lastDays = $$v
	      },
	      expression: "lastDays"
	    }
	  }), _vm._v(" \n              ")], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.lastDays == 'custom'),
	      expression: "lastDays == 'custom'"
	    }],
	    staticClass: "inline filter-range"
	  }, [_c('div', {
	    staticClass: "inline margin-side"
	  }, [_c('div', {
	    staticClass: "form-group form-inline",
	    class: {
	      'has-error': _vm.errors.has('Data-inicial')
	    }
	  }, [_c('label', [_vm._v("De:")]), _vm._v(" "), _c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control picker statement",
	    attrs: {
	      "name": "Data-inicial",
	      "format": "dd/MM/yyyy",
	      "language": "pt-br",
	      "data-vv-rules": "required"
	    },
	    model: {
	      value: (_vm.customStart),
	      callback: function($$v) {
	        _vm.customStart = $$v
	      },
	      expression: "customStart"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('Data-inicial')))])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "inline margin-side"
	  }, [_c('div', {
	    staticClass: "form-group form-inline",
	    class: {
	      'has-error': _vm.errors.has('Data-final')
	    }
	  }, [_c('label', [_vm._v("Até:")]), _vm._v(" "), _c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control picker statement",
	    attrs: {
	      "name": "Data-final",
	      "format": "dd/MM/yyyy",
	      "language": "pt-br",
	      "data-vv-as": "data inicial"
	    },
	    model: {
	      value: (_vm.customEnd),
	      callback: function($$v) {
	        _vm.customEnd = $$v
	      },
	      expression: "customEnd"
	    }
	  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('Data-final')))])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "inline filter-button text-center margin-l10"
	  }, [_c('a', {
	    staticClass: "btn btn-default btn-sm",
	    attrs: {
	      "target": "_blank",
	      "type": "button",
	      "name": "button",
	      "download": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.exportarExtratoConsolidado()
	      }
	    }
	  }, [_vm._v("\n          Exportar extrato\n        ")])])])])])]), _vm._v(" "), (_vm.vehiclesBalance) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('table', {
	    staticClass: "table table-striped",
	    attrs: {
	      "id": "vehicleFullTable"
	    }
	  }, [_c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "width": "5%"
	    }
	  }, [_c('div', {}, [_c('input', {
	    staticClass: "check-item",
	    attrs: {
	      "type": "checkbox",
	      "name": "listTransactionRefund",
	      "id": "selectAll",
	      "value": "selectAll"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.checkAll()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "label-item",
	    attrs: {
	      "for": "selectAll"
	    }
	  })])]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "45%"
	    }
	  }, [_vm._v("Modelo")]), _vm._v(" "), _c('th', {
	    staticClass: "text-right",
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Saldo VP")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "10%"
	    }
	  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.vehiclesBalance), function(item, index) {
	    return _c('tr', [_c('td', [_c('div', {
	      class: item.plate
	    }, [_c('input', {
	      staticClass: "check-item",
	      attrs: {
	        "type": "checkbox",
	        "name": "listTransactionRefund",
	        "id": index
	      },
	      domProps: {
	        "value": index
	      },
	      on: {
	        "click": function($event) {
	          return _vm.check(index)
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      staticClass: "label-item",
	      attrs: {
	        "for": index
	      }
	    })])]), _vm._v(" "), _c('td', {
	      staticClass: "td-plate"
	    }, [_vm._v(_vm._s(item.plate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
	      staticClass: "text-right"
	    }, [_vm._v(_vm._s(_vm._f("cents")(item.currentBalance)))]), _vm._v(" "), _c('td', {
	      staticClass: "text-right"
	    }, [_c('router-link', {
	      attrs: {
	        "to": {
	          name: 'contract-statement',
	          params: {
	            contractId: item.contractId,
	            planId: 7
	          }
	        },
	        "data-toggle": "tooltip",
	        "data-placement": "bottom",
	        "title": "Extrato do Vale-pedágio"
	      }
	    }, [_c('div', {
	      staticClass: "btn btn-icon"
	    }, [_c('i', {
	      staticClass: "icon-paper bold"
	    })])])], 1)])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('table', {
	    staticClass: "table table-striped"
	  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.arrayPlate), function(plate, index) {
	    return _c('tr', [_c('th', [_vm._v(_vm._s(plate))]), _vm._v(" "), _c('th', {
	      staticClass: "text-right"
	    }, [_c('button', {
	      staticClass: "btn btn-icon",
	      attrs: {
	        "type": "button",
	        "name": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.removePlate(plate)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "icon-cross bold"
	    })])])])
	  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.vehiclesBalance) ? _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 text-center"
	  }, [_c('pagination', {
	    attrs: {
	      "model": _vm.page
	    },
	    on: {
	      "page-change": _vm.setCurrentPage
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 result-table-count text-center"
	  }, [_vm._v("\n        Mostrando resultados de " + _vm._s(_vm.page.firstIndexShown()) + " a " + _vm._s(_vm.page.lastIndexShown()) + " de um total de " + _vm._s(_vm.page.itemCount()) + "\n        encontrados.\n      ")])])]) : _vm._e(), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-back margin-t20",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v(" Voltar\n  ")])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline filter-plate"
	  }, [_c('label', {
	    staticClass: "label-terms",
	    attrs: {
	      "for": "filter-plate"
	    }
	  }, [_vm._v("Filtrar por Placa")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('b', [_c('i', {
	    staticClass: "icon-info",
	    attrs: {
	      "data-toggle": "tooltip",
	      "data-placement": "bottom",
	      "title": "A data de processamento que será considerada na exportação do extrato."
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "width": "75%"
	    }
	  }, [_vm._v("Placas selecionadas")]), _vm._v(" "), _c('th', {
	    staticClass: "text-right",
	    attrs: {
	      "width": "25%"
	    }
	  })])])
	}]}

/***/ }),
/* 2160 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.rescueData) ? _c('div', {
	    staticClass: "modal fade modal-rescue-balance",
	    attrs: {
	      "id": "modal-rescue-balance",
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-labelledby": "modal-rescue-balance-label"
	    },
	    on: {
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) { return null; }
	        return _vm.closeModal()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    class: {
	      'small-modal': _vm.smallModal
	    },
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title",
	    attrs: {
	      "id": "modal-rescue-balance-label"
	    }
	  }, [_vm._v("Resgatar Vale-pedágio (VP)")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [(_vm.transferMsg.length == 0) ? _c('div', [(!_vm.smallModal) ? _c('div', [_c('div', {
	    staticClass: "aggregate-data"
	  }, [_c('p', [_vm._v("Transportador: "), _c('span', [_vm._v(_vm._s(_vm.rescueData.transportador))])]), _vm._v(" "), _c('p', [_vm._v("Placa: "), _c('span', {
	    directives: [{
	      name: "mask-plate",
	      rawName: "v-mask-plate"
	    }]
	  }, [_vm._v(_vm._s(_vm.rescueData.plate))])]), _vm._v(" "), _c('p', [_vm._v("N° TAG: "), _c('span', [_vm._v(_vm._s(_vm.rescueData.tagSerialNumber))])]), _vm._v(" "), _c('p', {
	    staticClass: "text-right"
	  }, [_vm._v("Última passagem: "), _c('span', [_vm._v(_vm._s(_vm._f("date")(_vm.rescueData.lastPassage)))])])]), _vm._v(" "), _c('h4', {
	    staticClass: "upper"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "rescue-info"
	  }, [_c('p', [_vm._v("Saldo do Vale-pedágio "), _c('span', {
	    staticClass: "pull-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.rescueData.saldoVp)))])]), _vm._v(" "), _c('p', [_vm._v("Taxa de transferência "), _c('span', {
	    staticClass: "pull-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.rescueData.taxValue)))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Valor líquido para transferência "), _c('span', {
	    staticClass: "pull-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.rescueData.transferValue)))])])])]) : _c('div', [_c('h4', {
	    staticClass: "upper"
	  }, [_vm._v("quantidade de veículos: "), _c('span', [_vm._v(_vm._s(_vm.rescueData.length))])]), _vm._v(" "), _c('div', {
	    staticClass: "rescue-info"
	  }, [_c('p', [_vm._v("Saldo do Vale-pedágio "), _c('span', {
	    staticClass: "pull-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.totalValueVP + _vm.totalFeeValue)))])]), _vm._v(" "), _c('p', [_vm._v("Taxa de transferência "), _c('span', {
	    staticClass: "pull-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.totalFeeValue)))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Valor líquido para transferência "), _c('span', {
	    staticClass: "pull-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.totalValueVP)))])])])])]) : _c('div', [_c('div', {
	    staticClass: "content-box success text-center"
	  }, [_vm._l((_vm.transferMsg), function(item, index) {
	    return _c('p', {
	      key: index,
	      staticClass: "no-margin"
	    }, [_vm._v(_vm._s(item))])
	  }), _vm._v(" "), _c('img', {
	    staticClass: "margin-10",
	    attrs: {
	      "src": "/static/Icon-check-circle.svg",
	      "alt": "icon-check-circle"
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v("OK")])], 2)])]), _vm._v(" "), (_vm.transferMsg.length == 0) ? _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn no-btn",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-purple",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.doRequest()
	      }
	    }
	  }, [_vm._v("\n          Resgatar saldo\n          "), _c('i', {
	    staticClass: "icomoon-arrow-right"
	  })])]) : _vm._e()])])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": _vm.mostrarModal ? 'slide-left' : 'slide-right',
	      "appear": ""
	    }
	  }, [_c('div', {
	    staticClass: "modal"
	  }, [_c('div', {
	    key: _vm.mostrarModal,
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('h2', [_vm._v("Tabela de recarga")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "cursor": "pointer",
	      "font-size": "24px",
	      "position": "absolute",
	      "top": "0px",
	      "right": "2px"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.fecharModal()
	      }
	    }
	  }, [(!_vm.isMobile) ? _c('img', {
	    attrs: {
	      "src": __webpack_require__(507),
	      "alt": "Fechar"
	    }
	  }) : _c('img', {
	    attrs: {
	      "src": __webpack_require__(508),
	      "alt": "Fechar"
	    }
	  })])]), _vm._v(" "), _c('p', {
	    staticClass: "subTitle"
	  }, [_vm._v("Pessoa Física")]), _vm._v(" "), _c('div', {
	    staticClass: "price-cards"
	  }, [_c('div', {
	    staticClass: "card price-card"
	  }, [_vm._v("\n          R$ " + _vm._s(_vm.recarga1.valor / 100) + "\n          "), _c('div', {
	    staticClass: "taxValue"
	  }, [_vm._v("Taxa: " + _vm._s(_vm._f("cents")(_vm.recarga1.taxa)))])]), _vm._v(" "), _c('div', {
	    staticClass: "card price-card"
	  }, [_vm._v("\n          R$ " + _vm._s(_vm.recarga2.valor / 100) + "\n          "), _c('div', {
	    staticClass: "taxValue"
	  }, [_vm._v("Taxa: " + _vm._s(_vm._f("cents")(_vm.recarga2.taxa)))])]), _vm._v(" "), _c('div', {
	    staticClass: "card price-card"
	  }, [_vm._v("\n          R$ " + _vm._s(_vm.recarga3.valor / 100) + "\n          "), _c('div', {
	    staticClass: "taxValue"
	  }, [_vm._v("Taxa: " + _vm._s(_vm._f("cents")(_vm.recarga3.taxa)))])]), _vm._v(" "), _c('div', {
	    staticClass: "card price-card"
	  }, [_vm._v("\n          R$ " + _vm._s(_vm.recarga4.valor / 100) + "\n          "), _c('div', {
	    staticClass: "taxValue"
	  }, [_vm._v("Taxa: " + _vm._s(_vm._f("cents")(_vm.recarga4.taxa)))])]), _vm._v(" "), _c('div', {
	    staticClass: "card price-card"
	  }, [_vm._v("\n          R$ " + _vm._s(_vm.recarga5.valor / 100) + "\n          "), _c('div', {
	    staticClass: "taxValue"
	  }, [_vm._v("Taxa: " + _vm._s(_vm._f("cents")(_vm.recarga5.taxa)))])]), _vm._v(" "), _c('div', {
	    staticClass: "card price-card"
	  }, [_vm._v("\n          R$ " + _vm._s(_vm.recarga6.valor / 100) + "\n          "), _c('div', {
	    staticClass: "taxValue"
	  }, [_vm._v("Taxa: " + _vm._s(_vm._f("cents")(_vm.recarga6.taxa)))])]), _vm._v(" "), _c('div', {
	    staticClass: "card price-card"
	  }, [_vm._v("\n          R$ " + _vm._s(_vm.recarga7.valor / 100) + "\n          "), _c('div', {
	    staticClass: "taxValue"
	  }, [_vm._v("Taxa: " + _vm._s(_vm._f("cents")(_vm.recarga7.taxa)))])]), _vm._v(" "), _c('div', {
	    staticClass: "card price-card"
	  }, [_vm._v("\n          R$ " + _vm._s(_vm.recarga8.valor / 100) + "\n          "), _c('div', {
	    staticClass: "taxValue"
	  }, [_vm._v("Taxa: " + _vm._s(_vm._f("cents")(_vm.recarga8.taxa)))])]), _vm._v(" "), _c('div', {
	    staticClass: "card price-card"
	  }, [_vm._v("\n          R$ " + _vm._s(_vm.recarga9.valor / 100) + "\n          "), _c('div', {
	    staticClass: "taxValue"
	  }, [_vm._v("Taxa: " + _vm._s(_vm._f("cents")(_vm.recarga9.taxa)))])]), _vm._v(" "), _c('div', {
	    staticClass: "card price-card"
	  }, [_vm._v("\n          R$ " + _vm._s(_vm.recarga10.valor / 100) + "+\n          "), _c('div', {
	    staticClass: "taxValue"
	  }, [_vm._v("Taxa: " + _vm._s(_vm.recarga10.taxa / 100 / 10) + "%")])])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "main-container-hot"
	    }
	  }, [_c('HeaderHotSite'), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "main-container"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "landing-intro-container"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1831),
	      "alt": "logo"
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "link-to",
	    on: {
	      "click": _vm.scrollToFooter
	    }
	  }, [_vm._m(0)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', [_vm._v("\n          Quero a minha\n          "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(1832)
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h2', {
	    staticClass: "pamMessage"
	  }, [_vm._v("\n        TAG do caminhoneiro. Uma iniciativa do "), _c('span', [_vm._v("Pamcard")]), _vm._v(" e da "), _c('span', [_vm._v("Move Mais")]), _vm._v(" para viabilizar o único plano de TAG sem taxa de adesão, sem mensalidade, sem vínculo de cartão de crédito.\n      ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "pamMessage"
	  }, [_vm._v("Confira as vantagens de ter a "), _c('span', [_vm._v("TAG do Caminhoneiro")])])
	}]}

/***/ }),
/* 2163 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "box col-md-5"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "margin-t20"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errorMessage),
	      expression: "errorMessage"
	    }],
	    staticClass: "alert alert-danger margin-b10"
	  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")]), _vm._v(" "), _c('form', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    attrs: {
	      "action": "index.html",
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.doLoginAtendente.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('password')
	    }
	  }, [_c('label', [_vm._v("Senha")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.passwordSiva),
	      expression: "passwordSiva"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "password",
	      "name": "password",
	      "data-vv-rules": "required",
	      "maxlength": "40"
	    },
	    domProps: {
	      "value": (_vm.passwordSiva)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.passwordSiva = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first("password")))])]), _vm._v(" "), _vm._m(1)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h1', [_vm._v("Login Atendente")]), _vm._v(" "), _c('p', [_vm._v("Para acessar essa página é necessário confirmar a senha do SIVA.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-center"
	  }, [_c('button', {
	    staticClass: "btn btn-lg btn-purple",
	    attrs: {
	      "id": "btn-login",
	      "type": "submit",
	      "name": "button"
	    }
	  }, [_vm._v("\n            Continuar\n          ")]), _vm._v(" "), _c('i', {
	    staticClass: "icon-circle-right align-icon"
	  })])
	}]}

/***/ }),
/* 2164 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade modal-toll-ticket",
	    attrs: {
	      "id": "modal-toll-ticket",
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-labelledby": "modal-toll-ticket-label"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog modal-lg",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title text-center",
	    attrs: {
	      "id": "modal-toll-ticket-label"
	    }
	  }, [_vm._v("Emissão de Vale-pedágio (VP)")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {}, [_c('ul', {
	    staticClass: "wizard margin-b20 "
	  }, [_c('li', {
	    class: {
	      active: _vm.step == 0, past: _vm.step > 0
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('medium', [_vm._v("Veículo Agregador")])], 1), _vm._v(" "), _c('li', {
	    class: {
	      active: _vm.step == 1, past: _vm.step > 1
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('big', [_vm._v("Data e Rotas")])], 1), _vm._v(" "), _c('li', {
	    class: {
	      active: _vm.step == 2, past: _vm.step > 2
	    }
	  }, [_vm._m(2), _vm._v(" "), _c('big', [_vm._v("Transportador")])], 1), _vm._v(" "), _c('li', {
	    class: {
	      active: _vm.step == 3, past: _vm.step > 3
	    }
	  }, [_vm._m(3), _vm._v(" "), _c('big', [_vm._v("Confirmação")])], 1)])]), _vm._v(" "), (_vm.msgError) ? _c('div', {
	    staticClass: "margin-t30",
	    staticStyle: {
	      "width": "97%",
	      "margin-left": "10px"
	    }
	  }, [_c('div', {
	    staticClass: "alert alert-danger alert-container"
	  }, [_c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("\n              " + _vm._s(_vm.msgError) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.step == 0) ? _c('vehicle-aggregate', {
	    attrs: {
	      "aggregate": _vm.aggregate,
	      "contract": _vm.contractShipper
	    },
	    on: {
	      "aggregateData": _vm.aggregateData
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.step == 1) ? _c('date-route', {
	    attrs: {
	      "routeIdSelected": _vm.routeSelected,
	      "confirmRouteSelected": _vm.confirmRouteSelected,
	      "aggregate": _vm.aggregate
	    },
	    on: {
	      "cleanErrors": _vm.cleanErrors,
	      "confirmRouteSelected": _vm.callback
	    },
	    model: {
	      value: (_vm.routeSelected),
	      callback: function($$v) {
	        _vm.routeSelected = $$v
	      },
	      expression: "routeSelected"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('transportador-rntrc', {
	    attrs: {
	      "transportadorRntrc": _vm.transportadorRntrc,
	      "aggregate": _vm.aggregate
	    },
	    on: {
	      "nxtStep": _vm.nextStep
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.step == 3) ? _c('summary-aggregate', {
	    attrs: {
	      "routeSelected": _vm.routeSelected,
	      "aggregate": _vm.aggregate
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.step == 4) ? _c('div', {}, [_c('div', {
	    staticClass: "content-box success text-center"
	  }, [_c('h4', [_vm._v("Vale-pedágio gerado com sucesso!")]), _vm._v(" "), _c('img', {
	    staticClass: "margin-10",
	    attrs: {
	      "src": "/static/Icon-check-circle.svg",
	      "alt": "icon-check-circle"
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v("OK")])])]) : _vm._e()], 1), _vm._v(" "), (_vm.step != 4) ? _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.step == 0),
	      expression: "step == 0"
	    }],
	    staticClass: "no-btn",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.step > 0),
	      expression: "step > 0"
	    }],
	    staticClass: "no-btn blue",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.backStep()
	      }
	    }
	  }, [_vm._v("Voltar")]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.step < 3 && _vm.aggregate),
	      expression: "step < 3 && aggregate"
	    }],
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.nextStep()
	      }
	    }
	  }, [_vm._v("\n          Avançar\n          "), _c('i', {
	    staticClass: "icon-circle-right"
	  })]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.step == 3),
	      expression: "step == 3"
	    }],
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.doRequest()
	      }
	    }
	  }, [_vm._v("\n          Finalizar\n          "), _c('i', {
	    staticClass: "icon-tick"
	  })])]) : _vm._e()])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-tick"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-tick"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-tick"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-tick"
	  })])
	}]}

/***/ }),
/* 2165 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "screen"
	  }, [_c('div', {
	    staticClass: "banner"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "arrow"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
	    staticClass: "p3"
	  }, [_vm._v("Localize o estabelecimento mais perto de você:")]), _vm._v(" "), _c('div', {
	    staticClass: "buttons-container"
	  }, [_c('button', {
	    class: _vm.showInputCep ? 'button-active' : '',
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.showInputCepFunc()
	      }
	    }
	  }, [_vm._v("Por CEP")]), _vm._v(" "), _c('button', {
	    class: _vm.showInputCity ? 'button-active' : '',
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.showInputCityFunc()
	      }
	    }
	  }, [_vm._v("Por cidade")]), _vm._v(" "), _c('div', {
	    staticClass: "local-desktop",
	    style: (_vm.showGetCurrentLocalization ? 'display: flex; align-items: center; cursor: pointer; font-size: 16px; color: #4F345E' : 'display: flex; align-items: center; cursor: pointer; font-size: 16px; color: #9C9C9C'),
	    on: {
	      "click": function($event) {
	        return _vm.searchByCurrentLocalization()
	      }
	    }
	  }, [_c('i', {
	    class: _vm.showGetCurrentLocalization ? 'my-location-active' : 'my-location'
	  }), _vm._v("\n        Usar minha localização\n      ")])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showInputCep),
	      expression: "showInputCep"
	    }],
	    staticClass: "search"
	  }, [_c('input', {
	    directives: [{
	      name: "mask-cep",
	      rawName: "v-mask-cep"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cep),
	      expression: "cep"
	    }],
	    staticClass: "form-control input-search",
	    attrs: {
	      "id": "cep",
	      "type": "tel",
	      "placeholder": "Digite o CEP"
	    },
	    domProps: {
	      "value": (_vm.cep)
	    },
	    on: {
	      "keypress": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        _vm.cep.length == 9 && _vm.searchByCep()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.cep = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    class: _vm.cep.length === 9 ? 'icon-search-input-right search-active' : 'icon-search-input-right',
	    on: {
	      "click": function($event) {
	        _vm.cep.length == 9 && _vm.searchByCep()
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showInputCity),
	      expression: "showInputCity"
	    }],
	    staticClass: "search"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.city),
	      expression: "city"
	    }],
	    staticClass: "form-control input-search",
	    attrs: {
	      "id": "city",
	      "type": "text",
	      "placeholder": "Digite a cidade",
	      "maxlength": "30"
	    },
	    domProps: {
	      "value": (_vm.city)
	    },
	    on: {
	      "keypress": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        _vm.city.length > 0 && _vm.searchByCity
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.city = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    class: _vm.city.length > 0 ? 'icon-search-input-right search-active' : 'icon-search-input-right',
	    on: {
	      "click": function($event) {
	        _vm.city.length > 0 && _vm.searchByCity()
	      }
	    }
	  })]), _vm._v(" "), (_vm.showMsgEror) ? _c('div', {
	    staticClass: "error-container alert alert-danger",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('span', [_vm._v("\n        " + _vm._s(_vm.msgError) + "\n      ")]), _vm._v(" "), _c('i', {
	    staticClass: "icon icon-cancel",
	    staticStyle: {
	      "cursor": "pointer",
	      "font-size": "10px",
	      "margin-left": "15px"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.hideMsgError()
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "local-mobile",
	    style: (_vm.showGetCurrentLocalization ? 'display: flex; align-items: center; cursor: pointer; font-size: 16px; color: #4F345E' : 'display: flex; align-items: center; cursor: pointer; font-size: 16px; color: #9C9C9C'),
	    on: {
	      "click": function($event) {
	        return _vm.searchByCurrentLocalization()
	      }
	    }
	  }, [_c('i', {
	    class: _vm.showGetCurrentLocalization ? 'my-location-active' : 'my-location'
	  }), _vm._v("\n      Usar minha localização\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "range"
	  }, [_c('p', {
	    staticClass: "range-title"
	  }, [_vm._v("Aumentar distância de busca")]), _vm._v(" "), _c('div', {
	    staticClass: "range-container"
	  }, [_c('span', {
	    staticClass: "text-range"
	  }, [_vm._v(_vm._s(_vm.range) + " Km")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.range),
	      expression: "range"
	    }],
	    attrs: {
	      "type": "range",
	      "step": "1",
	      "min": "0",
	      "max": _vm.maxRange
	    },
	    domProps: {
	      "value": (_vm.range)
	    },
	    on: {
	      "__r": function($event) {
	        _vm.range = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "text-range"
	  }, [_vm._v(_vm._s(_vm.maxRange) + " Km")])])]), _vm._v(" "), (_vm.loading) ? _c('div', {
	    staticClass: "loading-container"
	  }, [_c('div', {
	    attrs: {
	      "id": "loading"
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.showMsgErorFilter) ? _c('div', {
	    staticClass: "error-container alert alert-danger",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('span', [_vm._v("\n        " + _vm._s(_vm.msgError) + "\n      ")]), _vm._v(" "), _c('i', {
	    staticClass: "icon icon-cancel",
	    staticStyle: {
	      "cursor": "pointer",
	      "font-size": "10px",
	      "margin-left": "15px"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showMsgErorFilter = false
	      }
	    }
	  })]) : _c('div', {
	    staticClass: "partnes-container"
	  }, _vm._l((_vm.partnersFiltered), function(partner, index) {
	    return _c('PartnerInformation', {
	      key: partner.moveMaisId + '-' + index,
	      attrs: {
	        "partner": partner,
	        "userPosition": _vm.userPosition
	      },
	      on: {
	        "getMoveMaisId": _vm.preencheMoveMaisId,
	        "showModalHorarios": _vm.showModalHorarios
	      }
	    })
	  }), 1), _vm._v(" "), (_vm.showHorarios && !_vm.isMobile) ? _c('div', {
	    staticClass: "modal-partner"
	  }, [_c('partnerInformationModal', {
	    attrs: {
	      "moveMaisIdParceiroSelecionado": _vm.moveMaisIdParceiroSelecionado
	    },
	    on: {
	      "fecharModal": _vm.fecharModalHorarios
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "overlay-information"
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.showHorariosMobile && _vm.isMobile) ? _c('div', {
	    staticClass: "modal-partner-mobile"
	  }, [_c('partnerInformationModalMobile', {
	    attrs: {
	      "moveMaisIdParceiroSelecionado": _vm.moveMaisIdParceiroSelecionado
	    },
	    on: {
	      "fecharModal": _vm.fecharModalHorarios
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "overlay-information"
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "footer-container"
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "faq"
	  }, [_c('h3', [_vm._v("FAQ")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, _vm._l((_vm.faqs), function(faq, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "question-box"
	    }, [_c('h4', [_c('i', {
	      staticClass: "icon-arrow-major-breadcrumb",
	      staticStyle: {
	        "color": "#252525"
	      }
	    }), _vm._v("\n              " + _vm._s(faq.ask) + "\n            ")]), _vm._v(" "), _c('div', {
	      staticClass: "answer-box"
	    }, [_c('p', {
	      staticClass: "line-height-24",
	      staticStyle: {
	        "font-size": "14px"
	      }
	    }, [_vm._v("\n                " + _vm._s(faq.reply) + "\n              ")])])])
	  }), 0)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', [_vm._v("onde "), _c('br', {
	    staticClass: "mobile"
	  }), _vm._v(" retiro "), _c('br', {
	    staticClass: "mobile"
	  }), _vm._v(" meu "), _c('br', {
	    staticClass: "mobile"
	  }), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "#5D3B81",
	      "font-weight": "lighter"
	    }
	  }, [_vm._v("TAG")]), _vm._v("?")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "p1"
	  }, [_vm._v("Adquiriu o TAG Move Mais e escolheu “"), _c('b', [_vm._v("Retirada em mãos")]), _vm._v("”? Encontre aqui o local mais próximo para retirar seu TAG.")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "p2"
	  }, [_vm._v("Precisando de ajuda para saber onde retirar seu "), _c('b', [_vm._v("TAG")]), _vm._v("? Nós te ajudamos.")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "doubts"
	  }, [_c('h3', [_vm._v("Dúvidas?")]), _vm._v(" "), _c('div', {
	    staticClass: "line"
	  }, [_c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })]), _vm._v(" "), _c('p', [_vm._v("\n          Ficou com alguma dúvida? Sem problemas, é só consultar nosso FAQ ou falar com a nossa Central de Relacionamento.\n        ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "line"
	  }, [_c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })])
	}]}

/***/ }),
/* 2166 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h3', {
	    staticClass: "title"
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2167 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("Autenticação de 2 fatores")])], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "row border-row row-fix"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "content-box-small margin-t10"
	  }, [(_vm.errorMessage) ? _c('div', {
	    staticClass: "alert alert-danger margin-t20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.errorMessage) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.type == 'UPDATE_USER_EMAIL' || _vm.type == 'UPDATE_NEW_USER_EMAIL') ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.type == 'UPDATE_USER_PHONE' || _vm.type == 'UPDATE_NEW_USER_PHONE') ? _c('div', [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.type == 'UPDATE_PASSWORD' || _vm.type == 'UPDATE_ACCOUNT' || _vm.type == 'RESET_PASSWORD') ? _c('div', [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.type == 'SMS' || _vm.type == 'EMAIL') ? _c('div', [(_vm.type == 'SMS') ? _c('p', [_vm._v("Enviamos um código de 6 dígitos para o seu celular cadastrado. Para continuar, insira o código no campo abaixo:")]) : _vm._e(), _vm._v(" "), (_vm.type == 'EMAIL') ? _c('p', [_vm._v("Enviamos um código de 6 dígitos para o seu e-mail cadastrado. Para continuar, insira o código no campo abaixo:")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('form', {
	    attrs: {
	      "autocomplete": "false"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.doRequest.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group margin-b20"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tokenInput),
	      expression: "tokenInput"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "id": "tokenInput",
	      "maxlength": "6",
	      "type": "text",
	      "name": "tokenInput",
	      "placeholder": "Digite o código recebido",
	      "data-vv-validate-on": "blur",
	      "autofocus": ""
	    },
	    domProps: {
	      "value": (_vm.tokenInput)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.tokenInput = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(""))])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-lg btn-purple ",
	    attrs: {
	      "id": "btn-login",
	      "type": "submit",
	      "name": "button",
	      "disabled": _vm.tokenInput.length == 6 ? false : true
	    }
	  }, [_vm._v("\n                Continuar\n              ")]), _vm._v(" "), _c('i', {
	    staticClass: "icon-circle-right align-icon"
	  })])])]), _vm._v(" "), _vm._m(3)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("\n                Enviamos um código de 6 dígitos para o seu "), _c('b', [_vm._v("e-mail")]), _vm._v(" cadastrado. Para continuar, insira o código\n                no campo abaixo:\n              ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("\n                Enviamos um código de 6 dígitos para o seu "), _c('b', [_vm._v("celular")]), _vm._v(" cadastrado. Para continuar, insira o código\n                no campo abaixo:\n              ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("\n                Enviamos um código de 6 dígitos para o seu "), _c('b', [_vm._v("celular")]), _vm._v("  e "), _c('b', [_vm._v("e-mail")]), _vm._v(" cadastrados. Para continuar, insira o código\n                no campo abaixo:\n              ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "circle-key"
	  })])
	}]}

/***/ }),
/* 2168 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.code == 0) ? _c('div', {
	    staticClass: "success"
	  }, [(_vm.novoCartao && _vm.usuario === null && _vm.validado === 0) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "success-box"
	  }, [_c('h1', {
	    staticClass: "bold"
	  }, [_vm._v("Estamos quase lá!")]), _vm._v(" "), _c('h3', [_vm._v("Agora precisamos confirmar seu cartão de crédito.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "padding-l25"
	  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Valor debitado (R$):")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.valorDebitado),
	      expression: "valorDebitado",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "mask-one-real",
	      rawName: "v-mask-one-real"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "value": ""
	    },
	    domProps: {
	      "value": (_vm.valorDebitado)
	    },
	    on: {
	      "change": function($event) {
	        _vm.valorDebitado = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), (_vm.msgErro) ? _c('div', {
	    staticClass: "alert alert-danger alert-margin",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.msgErro) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.confirmCard()
	      }
	    }
	  }, [_vm._v("\n              Confirmar valor\n              "), _c('i', {
	    staticClass: "icon-tick align-icon-right-white"
	  })]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-cancel align-icon-left"
	  }), _vm._v("\n              Agora não!\n            ")])], 1)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _vm._m(5)])]) : (_vm.newPix) ? _c('div', {
	    staticClass: "welcome-box"
	  }, [(!_vm.isMobile) ? _c('h2', {
	    staticClass: "bold welcome",
	    staticStyle: {
	      "color": "#5d3b81"
	    }
	  }, [_vm._v("\n      Pagamento por Pix!\n    ")]) : _c('h2', {
	    staticClass: "bold welcome",
	    staticStyle: {
	      "color": "#5d3b81",
	      "font-size": "30px"
	    }
	  }, [_vm._v("\n      Pagamento por Pix!\n    ")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "display": "flex",
	      "flex-direction": "column",
	      "align-items": "center",
	      "margin-bottom": "50px"
	    }
	  }, [(_vm.pixCopiaCola) ? _c('qrcode-vue', {
	    attrs: {
	      "value": _vm.pixCopiaCola,
	      "size": 250,
	      "level": "H"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('label', {
	    staticStyle: {
	      "user-select": "none",
	      "width": "250px",
	      "padding": "8px",
	      "background-color": "#f5f5f5",
	      "overflow": "hidden",
	      "white-space": "nowrap"
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.pixCopiaCola) + "\n      ")]), _vm._v(" "), (_vm.pixCopiaCola) ? _c('button', {
	    staticClass: "btn btn-purple margin-5",
	    class: {
	      'btn-qr-copied': _vm.isQRCopied
	    },
	    staticStyle: {
	      "font-size": "12px"
	    },
	    attrs: {
	      "id": "qrcode",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.copyQRCodePix(_vm.pixCopiaCola)
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.isQRCopied ? "Copiado" : "Copiar") + "\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('p', {
	    staticClass: "margin-t30"
	  }, [_vm._v("\n      Após a conclusão do pagamento, você será notificado.\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "text-center"
	  }, [(!_vm.isMobile) ? _c('router-link', {
	    staticClass: "btn btn-purple margin-20",
	    attrs: {
	      "tag": "button",
	      "to": {
	        name: 'plans'
	      },
	      "type": "button",
	      "name": "button"
	    }
	  }, [_vm._v("\n        Acessar minha conta\n        "), _c('i', {
	    staticClass: "icon-circle-right align-icon-right-white"
	  })]) : _c('router-link', {
	    staticClass: "btn btn-purple margin-20",
	    staticStyle: {
	      "font-size": "12px"
	    },
	    attrs: {
	      "tag": "button",
	      "to": {
	        name: 'plans'
	      },
	      "type": "button",
	      "name": "button"
	    }
	  }, [_vm._v("\n        Acessar minha conta\n        "), _c('i', {
	    staticClass: "icon-circle-right align-icon-right-white"
	  })])], 1), _vm._v(" "), _vm._m(6)]) : _c('div', {
	    staticClass: "welcome-box"
	  }, [(!_vm.isMobile) ? _c('h2', {
	    staticClass: "bold welcome"
	  }, [_vm._v("Parabéns!")]) : _c('h2', {
	    staticClass: "bold welcome",
	    staticStyle: {
	      "font-size": "30px"
	    }
	  }, [_vm._v("Parabéns!")]), _vm._v(" "), (_vm.type == 'adhesion') ? _c('div', [_c('p', {
	    staticClass: "bold no-margin"
	  }, [_vm._v("Obrigado por nos escolher!")]), _vm._v(" "), _c('p', {
	    staticClass: "margin-b30"
	  }, [_vm._v("\n        Utilize os dados informados na sua adesão para acessar sua conta\n        (CPF/CNPJ e senha).\n      ")])]) : _vm._e(), _vm._v(" "), _c('p', {
	    staticClass: "bold no-margin"
	  }, [_vm._v("Fique atento!")]), _vm._v(" "), _c('p', {
	    staticClass: "margin-b30"
	  }, [_vm._v("\n      Para segurança de nossos clientes, não solicitamos informações de acesso\n      através de e-mail, WhatsApp, SMS ou qualquer outro meio.\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "text-center"
	  }, [(!_vm.isMobile) ? _c('router-link', {
	    staticClass: "btn btn-primary margin-20",
	    attrs: {
	      "tag": "button",
	      "to": {
	        name: 'plans'
	      },
	      "type": "button",
	      "name": "button"
	    }
	  }, [_vm._v("\n        Acessar minha conta\n        "), _c('i', {
	    staticClass: "icon-circle-right align-icon-right-white"
	  })]) : _c('router-link', {
	    staticClass: "btn btn-primary margin-20",
	    staticStyle: {
	      "font-size": "12px"
	    },
	    attrs: {
	      "tag": "button",
	      "to": {
	        name: 'plans'
	      },
	      "type": "button",
	      "name": "button"
	    }
	  }, [_vm._v("\n        Acessar minha conta\n        "), _c('i', {
	    staticClass: "icon-circle-right align-icon-right-white"
	  })])], 1), _vm._v(" "), _vm._m(7)])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "padding-l25"
	  }, [_c('p', {
	    staticClass: "sub-title"
	  }, [_c('span', {
	    staticClass: "badge"
	  }, [_vm._v("1")]), _vm._v(" Consulte o valor exato debitado.\n          ")]), _vm._v(" "), _c('p', {
	    staticClass: "sub-info"
	  }, [_vm._v("\n            Realizamos um débito em sua fatura de baixo valor (inferior a R$\n            2,00), que será estornado posteriormente. Esse valor pode ser\n            verificado em sua fatura ou no aplicativo do seu cartão de\n            crédito.\n          ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "sub-title"
	  }, [_c('span', {
	    staticClass: "badge"
	  }, [_vm._v("2")]), _vm._v(" Informando o valor debitado.\n          ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "sub-info"
	  }, [_vm._v("\n            Caso já tenha em mãos o valor simbólico debitado em seu cartão de\n            crédito, informe no campo abaixo e confirme. Importante lembrar\n            que o pedido tem 48 horas para ser confirmado, caso contrário,\n            será\n            "), _c('span', [_vm._v("cancelado")]), _vm._v(".\n          ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "padding-l25 margin-t30"
	  }, [_c('p', {
	    staticClass: "sub-title"
	  }, [_c('span', {
	    staticClass: "badge"
	  }, [_vm._v("3")]), _vm._v(" Ainda não tenho o valor simbólico\n            debitado no cartão.\n          ")]), _vm._v(" "), _c('p', {
	    staticClass: "sub-info"
	  }, [_vm._v("\n            Caso não tenha em mãos o valor simbólico debitado em seu cartão de\n            crédito, você poderá informar o valor posteriormente. Importante\n            lembrar que o pedido tem 48 horas para ser confirmado, caso\n            contrário, será cancelado.\n          ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {}, [_c('p', {
	    staticClass: "alert alert-info",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._v("\n            Para sua segurança, certifique-se de que as informações e valores\n            estão corretos. Após a efetivação de sua compra, você receberá um\n            e-mail com todas as informações para a ativação do seu contrato.\n            Em caso de dúvidas, entre em contato com nossa\n            "), _c('b', [_vm._v("Central de Relacionamento")]), _vm._v(".\n          ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade bs-example-modal-sm modal-success-adhesion",
	    attrs: {
	      "id": "modalSuccessAdhesion",
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-labelledby": "successAdhesionLabel"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content text-center"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title",
	    attrs: {
	      "id": "successAdhesionLabel"
	    }
	  }, [_vm._v("\n                Compra realizada com sucesso!\n              ")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('h4', [_vm._v("Seja bem vindo(a) a Move Mais!")]), _vm._v(" "), _c('img', {
	    staticClass: "margin-10",
	    attrs: {
	      "src": "/static/Icon-check-circle.svg",
	      "alt": "icon-check-circle"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("\n                OK\n              ")])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "margin-t30"
	  }, [_vm._v("\n      Em caso de dúvida entre em contato com a nossa\n      "), _c('b', [_vm._v("Central de Relacionamento")]), _vm._v(":\n    ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "margin-t30"
	  }, [_vm._v("\n      Em caso de dúvida entre em contato com a nossa\n      "), _c('b', [_vm._v("Central de Relacionamento")]), _vm._v(":\n    ")])
	}]}

/***/ }),
/* 2169 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 border-right margin-b50"
	  }, [_c('div', {
	    staticClass: "content-box-login margin-t20"
	  }, [(_vm.errorMessage == 'Usuário e/ou senha inválidos') ? _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errorMessage),
	      expression: "errorMessage"
	    }],
	    staticClass: "alert alert-danger margin-b10"
	  }, [_vm._v("\n              " + _vm._s(_vm.errorMessage) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.errorMessage != 'Usuário e/ou senha inválidos') ? _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errorMessage),
	      expression: "errorMessage"
	    }],
	    staticClass: "alert alert-danger margin-b10"
	  }, [_vm._v("\n              " + _vm._s(_vm.errorMessage) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('form', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    attrs: {
	      "action": "index.html",
	      "novalidate": "",
	      "autocomplete": "off"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.doLogin.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('taxIdNumber')
	    }
	  }, [_c('label', [_vm._v("CPF ou CNPJ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.taxIdNumber),
	      expression: "taxIdNumber",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cpfCnpj'),
	      expression: "'required|cpfCnpj'"
	    }, {
	      name: "mask-cpf-cnpj",
	      rawName: "v-mask-cpf-cnpj"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "tel",
	      "inputmode": "numeric",
	      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2}|[0-9]{3}\\.[0-9]{3}\\.[0-9]{3}-[0-9]{2}|[0-9]{11})$",
	      "name": "taxIdNumber",
	      "data-vv-validate-on": "blur",
	      "placeholder": "Digite seu CPF ou CNPJ",
	      "maxlength": "18",
	      "autofocus": "",
	      "novalidate": "",
	      "formnovalidate": ""
	    },
	    domProps: {
	      "value": (_vm.taxIdNumber)
	    },
	    on: {
	      "change": function($event) {
	        _vm.taxIdNumber = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('taxIdNumber')))])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('password')
	    }
	  }, [_c('label', [_vm._v("Senha")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.password),
	      expression: "password"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "password",
	      "name": "password",
	      "data-vv-rules": "required",
	      "placeholder": "Mínimo 8 e máximo 20 caracteres",
	      "maxlength": "20",
	      "autocomplete": "false"
	    },
	    domProps: {
	      "value": (_vm.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.password = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('password')))])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.saveTaxId),
	      expression: "saveTaxId"
	    }],
	    staticClass: "check-terms",
	    attrs: {
	      "id": "saveTaxId",
	      "type": "checkbox",
	      "name": "saveTaxId",
	      "value": ""
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.saveTaxId) ? _vm._i(_vm.saveTaxId, "") > -1 : (_vm.saveTaxId)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.saveTaxId,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.saveTaxId = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.saveTaxId = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.saveTaxId = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "label-terms",
	    attrs: {
	      "for": "saveTaxId"
	    }
	  }, [_vm._v("Lembrar usuário e senha")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "link-box-login row row-fix"
	  }, [_c('div', {
	    staticClass: "col-xs-6 col-fix"
	  }, [_c('router-link', {
	    staticClass: "forgot-pass make-link",
	    attrs: {
	      "to": {
	        name: 'password-request',
	        params: {
	          type: '2fa'
	        },
	        query: {
	          taxIdNumber: _vm.taxIdNumber
	        }
	      }
	    }
	  }, [_vm._v("Primeiros Passos")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6 col-fix text-right"
	  }, [_c('router-link', {
	    staticClass: "forgot-pass make-link",
	    attrs: {
	      "to": {
	        name: 'password-request',
	        params: {
	          type: 'reset'
	        },
	        query: {
	          taxIdNumber: _vm.taxIdNumber
	        }
	      }
	    }
	  }, [_vm._v("Esqueci minha senha")])], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 border-right margin-b50",
	    staticStyle: {
	      "margin-top": "-3px"
	    }
	  }, [_c('div', {
	    staticClass: "content-box-login text-center"
	  }, [_c('h2', {
	    staticClass: "head-info"
	  }, [_vm._v("+ para você")]), _vm._v(" "), _c('h3', {
	    staticClass: "title-info-new margin-b20"
	  }, [_vm._v("Conheça nossos serviços e planos")]), _vm._v(" "), _c('p', [_vm._v("Com certeza temos um ideal para você.")]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-lg btn-default margin-t15",
	    attrs: {
	      "to": {
	        name: 'services-b2c'
	      }
	    }
	  }, [_vm._v("\n              Ver Planos\n            ")]), _vm._v(" "), _c('i', {
	    staticClass: "icon-circle-right-inverse align-icon"
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4",
	    staticStyle: {
	      "margin-top": "-3px"
	    }
	  }, [_c('div', {
	    staticClass: "content-box-login text-center"
	  }, [_c('h2', {
	    staticClass: "head-info"
	  }, [_vm._v("+ para sua empresa")]), _vm._v(" "), _c('h3', {
	    staticClass: "title-info-new margin-b20"
	  }, [_vm._v("Tem uma frota e ainda não tem um plano?")]), _vm._v(" "), _c('p', [_vm._v("Temos soluções especiais para empresas.")]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-lg btn-default margin-t15",
	    attrs: {
	      "to": {
	        name: 'services-b2b'
	      }
	    }
	  }, [_vm._v("\n              Ver Planos\n            ")]), _vm._v(" "), _c('i', {
	    staticClass: "icon-circle-right-inverse align-icon"
	  })], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("Identificação")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('p', [_vm._v("Você precisa ter um cadastro para continuar:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-center"
	  }, [_c('button', {
	    staticClass: "btn btn-lg btn-purple",
	    attrs: {
	      "id": "btn-login",
	      "type": "submit",
	      "name": "button"
	    }
	  }, [_vm._v("\n                  Continuar\n                ")]), _vm._v(" "), _c('i', {
	    staticClass: "icon-circle-right align-icon"
	  })])
	}]}

/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("\n          Comprovantes\n          "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Comprovante " + _vm._s(_vm.summaryVP.idProtocolo) + "\n        ")])], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    staticClass: "form-box margin-t20"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-content"
	  }, [_c('img', {
	    staticClass: "rule-color",
	    attrs: {
	      "src": __webpack_require__(116),
	      "alt": ""
	    }
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "box-toll-left"
	  }, [_c('p', [_vm._v("N° VALE-PEDÁGIO: "), _c('b', [_vm._v(_vm._s(_vm.summaryVP.idProtocolo))])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "three-dots bold upper"
	  }, [_vm._v(_vm._s(_vm.summaryVP.embarcador) + " ")])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.summaryVP.CPFCNPJEmbarcador)) + " ")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-toll-right"
	  }, [_c('p', {
	    staticClass: "text-right"
	  }, [_vm._v("DATA EMISSÃO: "), _c('b', [_vm._v(_vm._s(_vm._f("dateTime")(_vm.summaryVP.dataEmissao)))])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "three-dots bold upper"
	  }, [_vm._v(_vm._s(_vm.summaryVP.transportador) + " ")])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.summaryVP.CNPJTransportador)) + " ")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [(_vm.summaryVP.idProtocoloCanc != null) ? _c('p', {
	    staticClass: "title-doc-left upper"
	  }, [_vm._v("protocolo cancelamento: "), _c('b', [_vm._v(_vm._s(_vm.summaryVP.idProtocoloCanc))])]) : _c('p', {
	    staticClass: "title-doc-left"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('p', {
	    staticClass: "title-doc-right",
	    class: {
	      credit: _vm.summaryVP.idProtocoloCanc
	    }
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "box-doc-left"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "three-dots bold upper"
	  }, [_vm._v(_vm._s(_vm.summaryVP.rota) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm.summaryVP.origem) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(7), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm.summaryVP.destino) + " ")])])]), _vm._v(" "), (_vm.summaryVP.categoriaVolta != null) ? _c('div', {
	    staticClass: "row row-date"
	  }, [_vm._m(8), _vm._v(" "), _vm._m(9)]) : _vm._e(), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _c('div', {
	    staticClass: "box-doc-right"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(12), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm.summaryVP.tag) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(13), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "three-dots bold upper"
	  }, [_vm._v(_vm._s(_vm.summaryVP.placaVeiculo) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6 text-right"
	  }, [(_vm.summaryVP.categoriaVolta == null) ? _c('p', {
	    staticClass: "three-dots"
	  }, [_vm._v("Categoria Veículo:")]) : _c('p', {
	    staticClass: "three-dots"
	  }, [_vm._v("Categoria Veículo (Ida):")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm.summaryVP.categoria) + " ")])]), _vm._v(" "), (_vm.summaryVP.categoriaVolta != null) ? _c('div', [_vm._m(14), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm.summaryVP.categoriaVolta) + " ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(15), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm._f("dateTime")(_vm.summaryVP.startVP)) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(16), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm._f("dateTime")(_vm.summaryVP.expirationVP)) + " ")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20 break"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table receipt"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "width": "50%"
	    }
	  }, [_vm._v("PRAÇAS DE PEDÁGIO")]), _vm._v(" "), (_vm.summaryVP.categoriaVolta == null) ? [_c('th', {
	    attrs: {
	      "width": "35%"
	    }
	  }, [_vm._v("CONCESSIONÁRIA")]), _vm._v(" "), _c('th', {
	    staticClass: "text-right",
	    attrs: {
	      "width": "15%"
	    }
	  }, [_vm._v("VALOR (R$)")])] : [_c('th', {
	    attrs: {
	      "width": "30%"
	    }
	  }, [_vm._v("CONCESSIONÁRIA")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "10%"
	    }
	  }, [_vm._v("FLUXO")]), _vm._v(" "), _c('th', {
	    staticClass: "text-right",
	    attrs: {
	      "width": "10%"
	    }
	  }, [_vm._v("VALOR (R$)")])]], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.summaryVP.pracas), function(s, index) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(s.praca))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(s.concessionaria))]), _vm._v(" "), (s.fluxo != null && _vm.summaryVP.categoriaVolta != null) ? _c('td', [_vm._v(_vm._s(s.fluxo))]) : _vm._e(), _vm._v(" "), _c('td', {
	      staticClass: "text-right"
	    }, [_vm._v(_vm._s(_vm._f("cents")(s.price)))])])
	  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [(_vm.summaryVP.categoriaVolta == null) ? _c('td', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("TOTAL")]) : _c('td', {
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("TOTAL")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.summaryVP.valorVP)))])])])])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row hidden-print"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "margin-t20"
	  }, [_c('div', {
	    staticClass: "back-button-box"
	  }, [_c('button', {
	    staticClass: "btn btn-back",
	    on: {
	      "click": function($event) {
	        return _vm.window.history.back()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n              Voltar\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "action-buttons-box"
	  }, [_c('a', {
	    attrs: {
	      "href": '/api/v2/vp/comprovante/pdf/' + _vm.summaryVP.idIntern,
	      "target": "_blank"
	    }
	  }, [_vm._m(17)])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('img', {
	    staticClass: "logo-receipt",
	    attrs: {
	      "src": __webpack_require__(158),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('h4', {
	    staticClass: "title-receipt"
	  }, [_vm._v("comprovante de emissão de vale-pedágio")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6 text-right"
	  }, [_c('p', {
	    staticClass: "three-dots"
	  }, [_vm._v("Emissor:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6 text-right"
	  }, [_c('p', {
	    staticClass: "three-dots"
	  }, [_vm._v("CNPJ Emissor:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6 text-right"
	  }, [_c('p', {
	    staticClass: "three-dots"
	  }, [_vm._v("Transportador:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6 text-right"
	  }, [_c('p', {
	    staticClass: "three-dots"
	  }, [_vm._v("CPF/CNPJ Transportador:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6 text-right"
	  }, [_c('p', [_vm._v("Rota:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6 text-right"
	  }, [_c('p', {
	    staticClass: "three-dots"
	  }, [_vm._v("Origem:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6 text-right"
	  }, [_c('p', {
	    staticClass: "three-dots"
	  }, [_vm._v("Destino:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6 text-right"
	  }, [_c('p', {
	    staticClass: "three-dots"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(" ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row row-date"
	  }, [_c('div', {
	    staticClass: "col-md-6 text-right"
	  }, [_c('p', {
	    staticClass: "three-dots"
	  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(" ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row row-date"
	  }, [_c('div', {
	    staticClass: "col-md-6 text-right"
	  }, [_c('p', {
	    staticClass: "three-dots"
	  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(" ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6 text-right"
	  }, [_c('p', [_vm._v("N° TAG:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6 text-right"
	  }, [_c('p', {
	    staticClass: "three-dots"
	  }, [_vm._v("Placa Veículo:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6 text-right"
	  }, [_c('p', {
	    staticClass: "three-dots"
	  }, [_vm._v("Categoria Veículo (Volta):")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6 text-right"
	  }, [_c('p', {
	    staticClass: "three-dots"
	  }, [_vm._v("Data Início VP:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6 text-right"
	  }, [_c('p', {
	    staticClass: "three-dots"
	  }, [_vm._v("Data Expiração VP:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn btn-danger"
	  }, [_vm._v("\n                Salvar PDF\n                "), _c('i', {
	    staticClass: "icon-pdf align-icon-right-white"
	  })])
	}]}

/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: _vm.open ?
	      'partner-information partner-information-open' :
	      'partner-information'
	  }, [_c('div', {
	    staticClass: "info-container"
	  }, [_c('div', {
	    staticClass: "info"
	  }, [_c('div', {
	    staticClass: "icon-container"
	  }, [_c('i', {
	    staticClass: "icon pin",
	    staticStyle: {
	      "color": "#5d3b81",
	      "font-size": "30px"
	    }
	  }), _vm._v(" "), (_vm.partner.distancia) ? _c('span', {
	    staticStyle: {
	      "margin-top": "3px"
	    }
	  }, [_vm._v(_vm._s(_vm._f("formatDistance")(_vm.partner.distancia)) + " Km")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    class: _vm.open ? 'group group-open' : 'group'
	  }, [_c('div', {
	    staticClass: "about"
	  }, [_c('span', {
	    staticClass: "name-partner",
	    staticStyle: {
	      "color": "#444444",
	      "font-weight": "600"
	    }
	  }, [_vm._v(_vm._s(_vm.partner.nomeFantasia))]), _vm._v(" "), (!_vm.open) ? _c('span', [_vm._v(_vm._s(_vm.partner.cidade) + "-" + _vm._s(_vm.partner.estado))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "about"
	  }, [_c('span', {
	    class: !_vm.open && 'right-span'
	  }, [_vm._v(_vm._s(_vm.partner.endereco) + ", " + _vm._s(_vm.partner.numero))]), _vm._v(" "), _c('span', {
	    class: !_vm.open && 'right-span'
	  }, [_vm._v(_vm._s(_vm.partner.bairro))]), _vm._v(" "), _c('span', {
	    class: !_vm.open && 'right-span'
	  }, [_vm._v(_vm._s(_vm._f("formatCep")(_vm.partner.cep)) + " - " + _vm._s(_vm.partner.cidade) + "-" + _vm._s(_vm.partner.estado))])])]), _vm._v(" "), (_vm.open) ? [_c('i', {
	    staticClass: "icon arrow-up icone mobile",
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": _vm.hideDetail
	    }
	  })] : [_c('i', {
	    staticClass: "icon arrow-down icone desktop",
	    staticStyle: {
	      "cursor": "pointer",
	      "margin-left": "20px"
	    },
	    on: {
	      "click": _vm.showDetail
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "icon arrow-right icone mobile",
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": _vm.showDetail
	    }
	  })]], 2), _vm._v(" "), (_vm.open) ? [_c('div', {
	    staticClass: "info"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    class: _vm.open ? 'group group-open' : 'group'
	  }, [_c('div', {
	    staticClass: "about"
	  }, [_c('span', {
	    staticStyle: {
	      "color": "#444444",
	      "font-weight": "600",
	      "font-size": "16px"
	    }
	  }, [_vm._v("Horário de funcionamento")]), _vm._v(" "), _c('div', {
	    staticClass: "consult-times",
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": _vm.showModalHorarios
	    }
	  }, [_c('span', {
	    staticClass: "text-consult-times"
	  }, [_vm._v("Consultar horário de funcionamento")])]), _vm._v(" "), (_vm.isMobile) ? _c('div', {
	    staticClass: "contact"
	  }, [_c('div', {
	    staticClass: "contact-icon"
	  }, [_c('img', {
	    staticClass: "icon-contact",
	    attrs: {
	      "src": __webpack_require__(505)
	    }
	  }), _vm._v(" "), (_vm.partner.telefone && _vm.partner.dddTelefone) ? _c('span', [_vm._v("Contato: (" + _vm._s(_vm.partner.dddTelefone) + ")\n                  " + _vm._s(_vm.partner.telefone))]) : _c('span', [_vm._v("Nenhum telefone de contato informado.")])])]) : _vm._e()])])]), _vm._v(" "), _c('i', {
	    staticClass: "icon arrow-up icone desktop",
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": _vm.hideDetail
	    }
	  })] : _vm._e()], 2), _vm._v(" "), (_vm.open && !_vm.window.document.webview) ? _c('div', {
	    staticClass: "buttons-container"
	  }, [(_vm.partner.latitude && _vm.partner.longitude) ? _c('div', {
	    staticClass: "button-container",
	    on: {
	      "click": _vm.openMapWindow
	    }
	  }, [_c('button', {
	    staticClass: "button-route",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("Rotas")]), _vm._v(" "), _c('i', {
	    staticClass: "icon directions left-icon",
	    staticStyle: {
	      "color": "#fff"
	    }
	  }), _vm._v(" "), (!_vm.isMobile) ? _c('div', {
	    staticClass: "contact-icon-desktop"
	  }, [_c('img', {
	    staticClass: "icon-contact",
	    attrs: {
	      "src": __webpack_require__(505)
	    }
	  }), _vm._v(" "), (_vm.partner.telefone && _vm.partner.dddTelefone) ? _c('span', {
	    staticClass: "text-contact"
	  }, [_vm._v("Contato: (" + _vm._s(_vm.partner.dddTelefone) + ")\n                  " + _vm._s(_vm.partner.telefone))]) : _c('span', [_vm._v("Nenhum telefone de contato informado.")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.partner.telefone && _vm.partner.dddTelefone) ? _c('div', {
	    staticClass: "button-container button-call",
	    on: {
	      "click": function($event) {
	        _vm.window.location.href = _vm.tel
	      }
	    }
	  }, [_c('a', [_vm._v("Ligar")]), _vm._v(" "), _c('i', {
	    staticClass: "icon phone left-icon",
	    staticStyle: {
	      "color": "#4f345e"
	    }
	  })]) : _vm._e()]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-container",
	    staticStyle: {
	      "width": "90px"
	    }
	  }, [_c('i', {
	    staticClass: "clock-icon icone-relogio",
	    staticStyle: {
	      "color": "#5d3b81"
	    }
	  })])
	}]}

/***/ }),
/* 2172 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-mask"
	  }, [_c('div', {
	    staticClass: "modal-wrapper"
	  }, [_c('div', {
	    staticClass: "modal-container"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "form-modal-footer"
	  }, [_c('button', {
	    staticClass: "modal-button-newSearch",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('ClickHandlerContinue')
	      }
	    }
	  }, [_vm._v("\n          Pesquisar novamente\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "modal-button-manualInsert",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('ClickHandlerCancel')
	      }
	    }
	  }, [_vm._v("\n          Cadastrar veículo manualmente\n        ")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-modal-header"
	  }, [_c('h1', {
	    staticStyle: {
	      "color": "#8a6d3b"
	    }
	  }, [_vm._v("Atenção!")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-modal-body"
	  }, [_c('div', {
	    staticClass: "form-modal-container"
	  }, [_c('div', {
	    staticClass: "form-modal-description"
	  }, [_c('p', {
	    staticClass: "modal-text"
	  }, [_vm._v("\n              Não foi possível consultar os dados do veículo nesse momento.\n              Por favor, pesquise novamente ou faça o cadastro manualmente.\n            ")])])])])
	}]}

/***/ }),
/* 2173 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-3",
	    on: {
	      "click": _vm.increment
	    }
	  }, [_c('button', {
	    staticClass: "btn-recharge",
	    attrs: {
	      "id": "btnRecharge1",
	      "type": "button",
	      "name": "button"
	    }
	  }, [_c('span', {
	    staticClass: "pull-right"
	  }, [_c('span', {
	    staticClass: "value-recharge",
	    attrs: {
	      "id": "valueRecharge1"
	    }
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.value)))])]), _vm._v(" "), _c('i', {
	    staticClass: "icon-plus pull-left icon-center-recharge"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 2174 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "fade-in",
	      "appear": ""
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mostrarModal),
	      expression: "mostrarModal"
	    }, {
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "modal fade-in",
	    style: ({
	      zIndex: _vm.updatePlateClicked ? 9999 : 99999
	    })
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('span', {
	    staticClass: "close",
	    staticStyle: {
	      "position": "absolute",
	      "top": "10px",
	      "right": "10px"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.fecharModal()
	      }
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
	    staticClass: "header-content"
	  }, [_c('h2', [_vm._v("Placa do veículo - Confira as informações")])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    staticClass: "labelContainer"
	  }, [_c('label', [_vm._v("Formato Antigo")]), _vm._v(" "), _c('label', [_vm._v("Padrão Mercosul")])]), _vm._v(" "), _c('div', {
	    staticClass: "plate-container"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.oldPlate),
	      expression: "oldPlate"
	    }, {
	      name: "only-numbers",
	      rawName: "v-only-numbers"
	    }],
	    staticClass: "input-old",
	    attrs: {
	      "disabled": "",
	      "id": "oldPlate",
	      "maxlength": "8"
	    },
	    domProps: {
	      "value": (_vm.oldPlate)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.oldPlate = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newPlate),
	      expression: "newPlate"
	    }],
	    staticClass: "input-new",
	    attrs: {
	      "disabled": "",
	      "autocomplete": "off",
	      "id": "newPlate"
	    },
	    domProps: {
	      "value": (_vm.newPlate)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newPlate = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "cancel-button",
	    on: {
	      "click": function($event) {
	        return _vm.fecharModal()
	      }
	    }
	  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
	    staticClass: "confirm-button",
	    on: {
	      "click": function($event) {
	        return _vm.doUpdatePlate()
	      }
	    }
	  }, [_vm._v("\n          Confirmar mudança\n        ")])]), _vm._v(" "), (_vm.loading) ? _c('loadingV2') : _vm._e()], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2175 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('vpo', {
	    attrs: {
	      "type": "adhesion"
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("Serviços Vale-pedágio")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-b10"
	  }, [_c('h3', {
	    staticClass: "bold upper"
	  }, [_vm._v("TAG Exclusiva para VPO: Pensou Vale-pedágio, pensou Move Cargo.")]), _vm._v(" "), _c('p', [_vm._v("Totalmente digital, SEM CUSTO e fácil de usar.")])])])
	}]}

/***/ }),
/* 2176 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade in",
	    staticStyle: {
	      "display": "block",
	      "background": "rgba(230, 230, 230, 0.8)"
	    },
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog modal-lg",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header modal-info"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close', '')
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Deseja reprocessar o pedido?")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-option-outline",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close', '')
	      }
	    }
	  }, [_vm._v("\n          Cancelar\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-option-outline",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        _vm.reprocessarPayout();
	        _vm.$emit('Reprocessar', true)
	      }
	    }
	  }, [_vm._v("\n          Reprocessar\n        ")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "content-box"
	  }, [_c('p', [_vm._v("Confirme para tentar novamente o processamento do pedido.")])])])])])
	}]}

/***/ }),
/* 2177 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('b2b', {
	    attrs: {
	      "type": "adhesion"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back",
	    attrs: {
	      "to": "/servicos-b2b"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n        Voltar\n      ")])], 1)])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("Serviços para Empresas")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-b10"
	  }, [_c('h3', {
	    staticClass: "bold upper"
	  }, [_vm._v("Planos Pré-pagos")]), _vm._v(" "), _c('p', [_vm._v("Conheça as vantagens que cada plano possui e escolha o que melhor se encaixa na necessidade do seu negócio:")])])])
	}]}

/***/ }),
/* 2178 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title title-plans inline"
	  }, [_vm._v("Comprar crédito")]), _vm._v(" "), _c('div', {
	    staticClass: "box-balance"
	  }, [_vm._v("\n        Saldo Disponível:\n        "), (_vm.contract) ? _c('b', {
	    staticClass: "balance-plus"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.contract.currentBalance.currentTotalBalance)))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('ul', {
	    staticClass: "wizard margin-20"
	  }, [_c('li', {
	    class: {
	      active: _vm.step == 0, past: _vm.step > 0
	    }
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('li', {
	    class: {
	      active: _vm.step == 1, past: _vm.step > 1
	    }
	  }, [_vm._m(2), _vm._v(" "), _vm._m(3)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [(_vm.step == 0) ? _c('div', {
	    staticClass: "margin-b20"
	  }, [_c('p', [_vm._v("Digite o valor da compra:")]), _vm._v(" "), _c('div', {
	    staticClass: "row border-row row-fix"
	  }, [_c('div', {
	    staticClass: "col-md-6",
	    staticStyle: {
	      "margin": "10% 0"
	    }
	  }, [_c('p', {
	    staticClass: "text-center bold margin-b0"
	  }, [_vm._v("Valor (R$):")]), _vm._v(" "), _c('button', {
	    staticClass: "inline bold btn-charge btn-charge-minus",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.alterValue(-100000)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-minus"
	  })]), _vm._v(" "), _c('input', {
	    staticClass: "inline form-control recharge",
	    attrs: {
	      "type": "text",
	      "pattern": "[0-9]*",
	      "inputmode": "numeric",
	      "placeholder": "0,00",
	      "autofocus": "autofocus"
	    },
	    domProps: {
	      "value": _vm.getValue
	    },
	    on: {
	      "input": function($event) {
	        return _vm.setValue($event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "inline bold btn-charge btn-charge-plus pull-right",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.alterValue(100000)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-plus"
	  })])]), _vm._v(" "), _vm._m(4)])]) : _vm._e(), _vm._v(" "), (_vm.step == 1) ? _c('div', {
	    staticClass: "form-box margin-b20 padding-b10"
	  }, [_c('b', {
	    staticClass: "title-identification margin-b10"
	  }, [_vm._v("Resumo e Confirmação do Pedido")]), _vm._v(" "), _c('div', {
	    staticClass: "form-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('b', [_vm._v("Valor da Compra")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "content-grey"
	  }, [_c('p', [_vm._v("Crédito: "), _c('span', {
	    staticClass: "pull-right bold"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.credit)))])]), _vm._v(" "), _c('p', [_vm._v("Taxa de Serviço: "), _c('span', {
	    staticClass: "pull-right bold"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.rate)))])]), _vm._v(" "), _c('p', [_vm._v("Total: "), _c('span', {
	    staticClass: "pull-right bold"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.currentValue)))])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('b', [_vm._v("Forma de Pagamento")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('choose-payment', {
	    ref: "choosePayment",
	    attrs: {
	      "contractId": _vm.contractId,
	      "payment": false,
	      "planId": _vm.planId,
	      "addressMailing": {},
	      "creditCardOptions": [],
	      "bankAccountOptions": [],
	      "bankBillOption": false,
	      "showNewPayment": false
	    },
	    on: {
	      "paymentSelected": function($event) {}
	    },
	    model: {
	      value: (_vm.contractPaymentMethodId),
	      callback: function($$v) {
	        _vm.contractPaymentMethodId = $$v
	      },
	      expression: "contractPaymentMethodId"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group form-inline custom-data",
	    class: {
	      'has-error': _vm.errors.has('Data-vencimento')
	    }
	  }, [_c('label', [_vm._v("Data de vencimento (Opcional):")]), _vm._v(" "), _c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control picker statement",
	    attrs: {
	      "name": "Data-vencimento",
	      "placeholder": "Selecione",
	      "format": "dd/MM/yyyy",
	      "language": "pt-br"
	    },
	    model: {
	      value: (_vm.expirationDate),
	      callback: function($$v) {
	        _vm.expirationDate = $$v
	      },
	      expression: "expirationDate"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first('Data-vencimento')) + "\n                  ")])], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.msgError) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-b20"
	  }, [_c('div', {
	    staticClass: "alert alert-danger",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._v(_vm._s(_vm.msgError))])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {}, [_c('div', {
	    staticClass: "back-button-box"
	  }, [(_vm.step > 0) ? _c('button', {
	    staticClass: "btn btn-back",
	    on: {
	      "click": function($event) {
	        return _vm.backStep()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n            Voltar\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "action-buttons-box"
	  }, [_c('button', {
	    staticClass: "btn btn-danger",
	    on: {
	      "click": function($event) {
	        return _vm.cancelar()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-cancel align-icon-left-white"
	  }), _vm._v("\n            Cancelar\n          ")]), _vm._v(" "), (_vm.step < 1) ? _c('button', {
	    staticClass: "btn btn-purple add",
	    attrs: {
	      "disabled": _vm.disabledButton || _vm.getValue == '' || _vm.getValue == '0,00'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.nextStep()
	      }
	    }
	  }, [_vm._v("\n            Avançar\n            "), _c('i', {
	    staticClass: "icon-circle-right align-icon-right-white"
	  })]) : _vm._e(), _vm._v(" "), (_vm.step == 1) ? _c('button', {
	    staticClass: "btn btn-success end",
	    on: {
	      "click": function($event) {
	        return _vm.doRecharge()
	      }
	    }
	  }, [_vm._v("\n            Concluir Compra\n            "), _c('i', {
	    staticClass: "icon-tick align-icon-right-white"
	  })]) : _vm._e()])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-coin"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Etapa 1")]), _vm._v(" "), _c('small', {
	    staticClass: "no-margin"
	  }, [_vm._v("Valor da compra")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-confirmation-check"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Etapa 2")]), _vm._v(" "), _c('small', {
	    staticClass: "no-margin"
	  }, [_vm._v("Resumo e confirmação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "circle-save-money"
	  })])
	}]}

/***/ }),
/* 2179 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vehicle-map"
	  })
	},staticRenderFns: []}

/***/ }),
/* 2180 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('ul', {
	    staticClass: "choose-plan"
	  }, [_c('li', {
	    class: {
	      active: _vm.changePlan == 'b2c'
	    },
	    on: {
	      "click": function($event) {
	        _vm.changePlan = 'b2c'
	      }
	    }
	  }, [_vm._v("\n              Para Você\n            ")]), _vm._v(" "), _c('li', {
	    class: {
	      active: _vm.changePlan == 'b2b'
	    },
	    on: {
	      "click": function($event) {
	        _vm.changePlan = 'b2b'
	      }
	    }
	  }, [_vm._v("\n              Para Sua Empresa\n            ")]), _vm._v(" "), _c('li', {
	    class: {
	      active: _vm.changePlan == 'vpo'
	    },
	    on: {
	      "click": function($event) {
	        _vm.changePlan = 'vpo'
	      }
	    }
	  }, [_vm._v("\n              Vale-pedágio\n            ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [(_vm.changePlan == 'vpo') ? _c('h3', {
	    staticClass: "bold margin-b0 margin-t30"
	  }, [_vm._v("TAG Exclusiva para VPO: Pensou Vale-pedágio, pensou Move Cargo.")]) : _c('h3', {
	    staticClass: "bold margin-b0 margin-t30"
	  }, [_vm._v("PLANOS")]), _vm._v(" "), (_vm.changePlan == 'b2c') ? _c('p', [_vm._v("Temos dois planos, com certeza um deles é ideal para você, é só escolher:")]) : (_vm.changePlan == 'vpo') ? _c('p', [_vm._v("Totalmente digital, "), _c('b', [_vm._v("SEM CUSTO")]), _vm._v(" e fácil de usar.")]) : _c('p', [_vm._v("Temos três planos, com certeza um deles é ideal para você, é só escolher:")]), _vm._v(" "), (_vm.changePlan == 'b2c') ? _c('b2c', {
	    staticClass: "margin-t20",
	    attrs: {
	      "type": "adhesion"
	    }
	  }) : (_vm.changePlan == 'vpo') ? _c('vpo', {
	    staticClass: "margin-t20",
	    attrs: {
	      "type": "adhesion"
	    }
	  }) : _c('b2b', {
	    staticClass: "margin-t20",
	    attrs: {
	      "type": "adhesion"
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2181 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bg-home"
	  }, [_c('carousel', {
	    ref: "carousel",
	    attrs: {
	      "loop": true,
	      "perPage": 1,
	      "autoplayHoverPause": false,
	      "paginationActiveColor": '#613A7D',
	      "autoplay": true,
	      "autoplayTimeout": 20000,
	      "navigationEnabled": true
	    }
	  }, _vm._l((_vm.svgListFinal), function(svg, index) {
	    return _c('slide', {
	      key: index
	    }, [_c('div', {
	      staticClass: "svg-container",
	      domProps: {
	        "innerHTML": _vm._s(svg)
	      }
	    })])
	  }), 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2182 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dropdown select"
	  }, [_c('button', {
	    staticClass: "form-control dropdown-toggle btn-dropdown",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "true"
	    }
	  }, [_c('div', {
	    staticClass: "selected word-wrap-dropdown"
	  }, [_vm._v(_vm._s(_vm.selected && _vm.getItemCaption(_vm.selected) || ''))]), _vm._v(" "), _c('i', {
	    staticClass: "icon-arrow-down-dropdown"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu option",
	    attrs: {
	      "role": "menu"
	    }
	  }, _vm._l((_vm.options), function(item) {
	    return (item) ? _c('li', [_c('a', {
	      attrs: {
	        "href": "javascript:;"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.selectItem(item)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.getItemCaption(item)) + " ")])]) : _vm._e()
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [(_vm.contaCorrente && _vm.planId == 28) ? _c('div', [_c('h3', [_vm._v("Valor cobrado na próxima fatura")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._l((_vm.arrayCartao), function(paymentC, index) {
	    return (index < 3 && _vm.isPaymentMethodAuthorized('CC')) ? _c('div', {
	      staticClass: "col-sm-6 col-md-4"
	    }, [_c('div', {
	      staticClass: "content-box methods cred margin-b20",
	      class: {
	        active:
	          paymentC.contractPaymentMethodId == _vm.contractPaymentMethodId,
	      }
	    }, [_c('div', {
	      staticClass: "methods-box"
	    }, [_c('div', {
	      staticClass: "radio-blue category",
	      class: {
	        active:
	          paymentC.contractPaymentMethodId == _vm.contractPaymentMethodId,
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.contractPaymentMethodId),
	        expression: "contractPaymentMethodId"
	      }],
	      staticClass: "radiobtn",
	      attrs: {
	        "id": 'credit-card' + paymentC.contractPaymentMethodId,
	        "type": "radio",
	        "name": "contractPaymentMethod"
	      },
	      domProps: {
	        "value": paymentC.contractPaymentMethodId,
	        "checked": _vm._q(_vm.contractPaymentMethodId, paymentC.contractPaymentMethodId)
	      },
	      on: {
	        "change": function($event) {
	          _vm.contractPaymentMethodId = paymentC.contractPaymentMethodId
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      staticClass: "radio-label label-h4",
	      attrs: {
	        "for": 'credit-card' + paymentC.contractPaymentMethodId
	      },
	      on: {
	        "click": function($event) {
	          _vm.paymentSelected = paymentC
	        }
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "check first"
	    })])]), _vm._v(" "), (paymentC.contractPaymentMethodId == _vm.contractPaymentMethodId) ? _c('div', {
	      staticClass: "expand-radio",
	      class: {
	        open: 'paymentC.contractPaymentMethodId == contractPaymentMethodId',
	      }
	    }, [_c('p', {}, [_vm._v("Cartão de Crédito")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	      staticClass: "inline"
	    }, [_c('div', {
	      staticClass: "inline"
	    }, [_c('p', [_vm._v(_vm._s(paymentC.ownerName))]), _vm._v(" "), _c('small', [_vm._v("Titular do cartão")]), _vm._v(" "), _c('div', {}, [_c('div', {}, [_c('p', {
	      staticClass: "margin-t5 inline"
	    }, [_vm._v(_vm._s(paymentC.number))]), _vm._v(" "), _c('small', [_vm._v(_vm._s("Validade: " +
	      paymentC.expirationMonth +
	      "/" +
	      paymentC.expirationYear))])]), _vm._v(" "), _c('div', {
	      class: {
	        'has-error': _vm.errors.has('secureCodeCreditCard'),
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.secureCodeCreditCard),
	        expression: "secureCodeCreditCard"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required|min:3'),
	        expression: "'required|min:3'"
	      }, {
	        name: "only-numbers",
	        rawName: "v-only-numbers"
	      }],
	      staticClass: "form-control csc inline",
	      attrs: {
	        "type": "text",
	        "name": "secureCodeCreditCard",
	        "maxlength": "4"
	      },
	      domProps: {
	        "value": (_vm.secureCodeCreditCard)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.secureCodeCreditCard = $event.target.value
	        }
	      }
	    }), _vm._v(" "), _c('img', {
	      attrs: {
	        "src": __webpack_require__(224),
	        "alt": "",
	        "width": "50",
	        "height": "33"
	      }
	    })])])])])]) : _c('div', [_c('div', {
	      staticClass: "text-left"
	    }, [_c('p', {
	      staticClass: "inline bold"
	    }, [_vm._v("Cartão de Crédito")]), _vm._v(" "), _c('div', {
	      staticClass: "inline"
	    }, [_c('p', [_vm._v(_vm._s(paymentC.ownerName))]), _vm._v(" "), _c('small', [_vm._v("Titular do cartão")]), _vm._v(" "), _c('p', {
	      staticClass: "margin-t5"
	    }, [_vm._v(_vm._s(paymentC.number))]), _vm._v(" "), _c('small', [_vm._v(_vm._s("Validade: " +
	      paymentC.expirationMonth +
	      "/" +
	      paymentC.expirationYear))])])]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (
	          paymentC.contractPaymentMethodId == _vm.contractPaymentMethodId
	        ),
	        expression: "\n                paymentC.contractPaymentMethodId == contractPaymentMethodId\n              "
	      }],
	      staticClass: "expand",
	      class: {
	        'has-error': _vm.errors.has('secureCodeCreditCard')
	      }
	    }, [_c('label', {
	      staticClass: "label-csc",
	      attrs: {
	        "for": ""
	      }
	    }, [_vm._v("Código de Segurança:")]), _vm._v(" "), _c('img', {
	      attrs: {
	        "src": __webpack_require__(224),
	        "alt": "",
	        "width": "50",
	        "height": "33"
	      }
	    })])])])]) : _vm._e()
	  }), _vm._v(" "), _vm._l((_vm.arrayDebito), function(paymentD) {
	    return (_vm.arrayDebito && _vm.planId != 28 && _vm.isPaymentMethodAuthorized('DC')) ? _c('div', {
	      staticClass: "col-sm-6 col-md-4"
	    }, [_c('div', {
	      staticClass: "content-box methods cred margin-b20",
	      class: {
	        active:
	          paymentD.contractPaymentMethodId == _vm.contractPaymentMethodId,
	      }
	    }, [_c('div', {
	      staticClass: "methods-box"
	    }, [_c('div', {
	      staticClass: "radio-blue category",
	      class: {
	        active:
	          paymentD.contractPaymentMethodId == _vm.contractPaymentMethodId,
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.contractPaymentMethodId),
	        expression: "contractPaymentMethodId"
	      }],
	      staticClass: "radiobtn",
	      attrs: {
	        "id": 'debit' + paymentD.contractPaymentMethodId,
	        "type": "radio",
	        "name": "contractPaymentMethod"
	      },
	      domProps: {
	        "value": paymentD.contractPaymentMethodId,
	        "checked": _vm._q(_vm.contractPaymentMethodId, paymentD.contractPaymentMethodId)
	      },
	      on: {
	        "change": function($event) {
	          _vm.contractPaymentMethodId = paymentD.contractPaymentMethodId
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      staticClass: "radio-label label-h4",
	      attrs: {
	        "for": 'debit' + paymentD.contractPaymentMethodId
	      },
	      on: {
	        "click": function($event) {
	          _vm.paymentSelected = paymentD
	        }
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "check first"
	    })])]), _vm._v(" "), _c('div', {}, [_c('div', {
	      staticClass: "text-left"
	    }, [_c('p', {
	      staticClass: "inline bold"
	    }, [_vm._v("Débito em conta")]), _vm._v(" "), _c('div', {
	      staticClass: "inline",
	      staticStyle: {
	        "margin-top": "5px"
	      }
	    }, [_c('p', [_vm._v("\n                  Banco "), _c('b', [_vm._v(_vm._s(paymentD.paymentMethod.paymentName))])]), _vm._v(" "), _c('p', [_vm._v("\n                  Agência "), _c('b', [_vm._v(_vm._s(paymentD.agencyNumber))])]), _vm._v(" "), _c('p', [_vm._v("\n                  C/C\n                  "), _c('b', [_vm._v(_vm._s(paymentD.accountNumber +
	      " -  " +
	      paymentD.accountNumberDigit))])])])])])])]) : _vm._e()
	  }), _vm._v(" "), (
	    (_vm.paymentMethodId == 106 ||
	      _vm.paymentMethodId == 12 ||
	      _vm.BC ||
	      _vm.planId == 6) &&
	    _vm.planId != 28 &&
	    _vm.isPaymentMethodAuthorized('BC')
	  ) ? _c('div', {
	    staticClass: "col-sm-6 col-md-4"
	  }, [_c('div', {
	    staticClass: "content-box methods margin-b20"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "radio-blue category",
	    class: {
	      active: 'BC' == _vm.contractPaymentMethodId
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contractPaymentMethodId),
	      expression: "contractPaymentMethodId"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "BC",
	      "type": "radio",
	      "name": "contractPaymentMethod",
	      "value": "BC"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.contractPaymentMethodId, "BC")
	    },
	    on: {
	      "change": function($event) {
	        _vm.contractPaymentMethodId = "BC"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label label-h4",
	    attrs: {
	      "for": "BC"
	    }
	  }, [_vm._v("Boleto Bancário")]), _vm._v(" "), _c('div', {
	    staticClass: "check first"
	  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.contaCorrente && _vm.planId == 28 && _vm.isPaymentMethodAuthorized('CR')) ? _c('div', {
	    staticClass: "col-sm-6 col-md-4;",
	    staticStyle: {
	      "display": "none"
	    }
	  }, [_c('div', {
	    staticClass: "content-box methods margin-b20"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "radio-blue category",
	    class: {
	      active:
	        _vm.contaCorrente.contractPaymentMethodId ==
	        _vm.contractPaymentMethodId,
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contractPaymentMethodId),
	      expression: "contractPaymentMethodId"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "contaCorrente.contractPaymentMethodId",
	      "type": "radio",
	      "name": "contractPaymentMethod"
	    },
	    domProps: {
	      "value": _vm.contaCorrente.contractPaymentMethodId,
	      "checked": _vm._q(_vm.contractPaymentMethodId, _vm.contaCorrente.contractPaymentMethodId)
	    },
	    on: {
	      "change": function($event) {
	        _vm.contractPaymentMethodId = _vm.contaCorrente.contractPaymentMethodId
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label label-h4",
	    attrs: {
	      "for": "contaCorrente.contractPaymentMethodId"
	    }
	  }, [_vm._v("Conta-corrente")]), _vm._v(" "), _c('div', {
	    staticClass: "check first"
	  })])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6 col-md-4"
	  }, [(_vm.planId != 28 && _vm.planId != 8 && _vm.mostrarNovaFormaDePagamento && _vm.hasValidActivePaymentMethod) ? _c('div', {
	    staticClass: "content-box methods margin-b20",
	    attrs: {
	      "id": "newPaymentBox"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "radio-blue category new",
	    class: {
	      active: 'newPayment' == _vm.contractPaymentMethodId
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contractPaymentMethodId),
	      expression: "contractPaymentMethodId"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "new-payment",
	      "type": "radio",
	      "name": "newContractPaymentMethod",
	      "value": "newPayment"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.contractPaymentMethodId, "newPayment")
	    },
	    on: {
	      "change": function($event) {
	        _vm.contractPaymentMethodId = "newPayment"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label label-h4",
	    attrs: {
	      "for": "new-payment"
	    }
	  }, [_vm._v("Nova forma de pagamento")]), _vm._v(" "), _c('div', {
	    staticClass: "check first"
	  })])])])]) : _vm._e(), _vm._v(" "), _c('form', {
	    staticClass: "no-margin",
	    attrs: {
	      "id": "adyen-encrypted-form-cvv"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.secureCodeCreditCard),
	      expression: "secureCodeCreditCard"
	    }],
	    attrs: {
	      "type": "hidden",
	      "size": "4",
	      "data-encrypted-name": "cvc"
	    },
	    domProps: {
	      "value": (_vm.secureCodeCreditCard)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.secureCodeCreditCard = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "data-encrypted-name": "generationtime"
	    },
	    domProps: {
	      "value": _vm.dateTime
	    }
	  }), _vm._v(" "), _c('input', {
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "type": "submit",
	      "value": "Pay",
	      "id": "submitAdyenCvv"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10 col-md-10 mx-auto"
	  }, [(!_vm.hasValidActivePaymentMethod) ? _c('div', {
	    staticClass: "alert alert-warning",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('h4', {
	    staticClass: "bold"
	  }, [_vm._v("Nenhuma forma de pagamento disponível")]), _vm._v(" "), _c('p', [_vm._v("Não há formas de pagamento autorizadas para este CPF/CNPJ no plano selecionado. Entre em contato com a Central de Relacionamento pelo número 4000 2901 (regiões metropolitanas) ou 0800 777 1022 (demais localidades) para mais informações.")])]) : _vm._e()]), _vm._v(" "), (
	    ((_vm.mostrarPagamentoPorSaldo &&
	        'newPayment' == _vm.contractPaymentMethodId) ||
	      'newBalance' == _vm.contractPaymentMethodId) &&
	    _vm.isPaymentMethodAuthorized('DC')
	  ) ? _c('div', {
	    staticClass: "col-sm-6 col-md-4"
	  }, [_c('div', {
	    staticClass: "content-box methods new-balance margin-b20",
	    class: {
	      ' active open': 'newBalance' == _vm.contractPaymentMethodId
	    }
	  }, [_c('div', {
	    staticClass: "radio-blue category"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contractPaymentMethodId),
	      expression: "contractPaymentMethodId"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "new-balance",
	      "type": "radio",
	      "name": "contractPaymentMethod",
	      "value": "newBalance"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.contractPaymentMethodId, "newBalance")
	    },
	    on: {
	      "change": function($event) {
	        _vm.contractPaymentMethodId = "newBalance"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label label-h4 three-dots",
	    attrs: {
	      "for": "new-balance"
	    }
	  }, [_vm._v("\n              Utilizar meu saldo para pagamento\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "expand-radio",
	    class: {
	      open: 'newBalance' == _vm.contractPaymentMethodId
	    }
	  }, [_c('hr'), _vm._v(" "), (true) ? _c('img', {
	    staticClass: "inline",
	    attrs: {
	      "src": "/static/Icon-check-circle.svg",
	      "alt": "Icon check"
	    }
	  }) : _c('img', {
	    staticClass: "inline",
	    attrs: {
	      "src": "/static/icon-cross.svg",
	      "alt": "Icon cross"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "inline"
	  }, [_c('div', {
	    staticClass: "inline"
	  }, [(_vm.saldoCorrente > _vm.totalComDesconto) ? _c('p', [_vm._v("\n                    Saldo disponível\n                  ")]) : _c('p', [_vm._v("Saldo indisponível")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm._f("cents")(_vm.saldoCorrente)))])]), _vm._v(" "), _c('div', {
	    staticClass: "inline"
	  }, [_c('p', [_vm._v("Valor Pedido")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm._f("cents")(_vm.totalComDesconto)))])]), _vm._v(" "), (_vm.saldoCorrente > _vm.totalComDesconto) ? _c('small', [_vm._v("A operação será autorizada.")]) : _c('small', {
	    staticClass: "red"
	  }, [_vm._v("A operação não será autorizada.")])])]), _vm._v(" "), _c('div', {
	    staticClass: "check first"
	  })])])]) : _vm._e(), _vm._v(" "), (
	    ('newPayment' == _vm.contractPaymentMethodId ||
	      'PX' == _vm.contractPaymentMethodId) &&
	    _vm.statusPix &&
	    _vm.isPaymentMethodAuthorized('PX')
	  ) ? _c('div', {
	    staticClass: "col-sm-6 col-md-4",
	    attrs: {
	      "id": "pix"
	    }
	  }, [_c('div', {
	    staticClass: "content-box methods new-balance margin-b20",
	    class: {
	      active: 'PX' == _vm.contractPaymentMethodId
	    }
	  }, [_c('div', {
	    staticClass: "radio-blue category"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contractPaymentMethodId),
	      expression: "contractPaymentMethodId"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "PX",
	      "type": "radio",
	      "name": "contractPaymentMethod",
	      "value": "PX"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.contractPaymentMethodId, "PX")
	    },
	    on: {
	      "click": function($event) {
	        _vm.paymentSelected = _vm.pix
	      },
	      "change": function($event) {
	        _vm.contractPaymentMethodId = "PX"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label label-h4",
	    attrs: {
	      "for": "PX"
	    }
	  }, [('PX' == _vm.contractPaymentMethodId) ? _c('input', {
	    staticStyle: {
	      "width": "40%"
	    },
	    attrs: {
	      "type": "image",
	      "name": "pagar",
	      "id": "pagar",
	      "src": "/static/payment-methods/logo-pix-branco.svg"
	    }
	  }) : _c('input', {
	    staticStyle: {
	      "width": "38%"
	    },
	    attrs: {
	      "type": "image",
	      "name": "pagar",
	      "id": "pagar",
	      "src": "/static/payment-methods/pix-logo.svg"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "inline",
	    staticStyle: {
	      "position": "absolute",
	      "top": "0",
	      "right": "30"
	    },
	    attrs: {
	      "src": "/static/payment-methods/novo.svg"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "check first"
	  })])])]) : _vm._e(), _vm._v(" "), ('newPayment' == _vm.contractPaymentMethodId && _vm.isPaymentMethodAuthorized('CC')) ? _c('div', {
	    staticClass: "col-sm-6 col-md-4"
	  }, [(
	    (_vm.arrayCartao == null || _vm.arrayCartao.length < 3) && _vm.planId != 6
	  ) ? _c('div', {
	    staticClass: "content-box methods new-balance margin-b20",
	    class: {
	      active: 'CC' == _vm.contractPaymentMethodId
	    }
	  }, [_c('div', {
	    staticClass: "radio-blue category center-flex-vertical"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contractPaymentMethodId),
	      expression: "contractPaymentMethodId"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "type": "radio",
	      "id": "credit",
	      "name": "radio",
	      "value": "CC"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.contractPaymentMethodId, "CC")
	    },
	    on: {
	      "change": function($event) {
	        _vm.contractPaymentMethodId = "CC"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label label-h4",
	    attrs: {
	      "for": "credit"
	    }
	  }, [_vm._v("\n              Cartão de Crédito\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  })])]) : _vm._e()]) : _vm._e()], 2), _vm._v(" "), _c('br'), _vm._v(" "), ('BC' == _vm.contractPaymentMethodId && _vm.isPaymentMethodAuthorized('BC')) ? _c('div', {
	    staticClass: "alert alert-info margin-b20"
	  }, [(_vm.planId == 6) ? _c('p', [_vm._v("\n        O boleto será enviado por email dentro de algumas horas."), _c('br')]) : _vm._e(), _vm._v("\n      O tempo mínimo para compensação e disponibilização do crédito de boletos\n      bancários junto às praças de pedágio é de 3 dias úteis."), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Para mais informações, entre em contato com a Central de\n        Relacionamento pelo número 4000 2901 (regiões metropolitanas) ou 0800\n        777 1022 (demais localidades).")])]) : _vm._e(), _vm._v(" "), ('PX' == _vm.contractPaymentMethodId && !_vm.isMobile && _vm.isPaymentMethodAuthorized('PX')) ? _c('div', {
	    staticClass: "margin-b20",
	    staticStyle: {
	      "font-size": "20px"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('p', {
	    staticClass: "font-sub-text"
	  }, [_vm._v("\n        Você será direcionado para um ambiente totalmente seguro para\n        finalizar sua compra.\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', {
	    staticClass: "font-sub-title"
	  }, [_vm._v("Leia com Atenção")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
	    staticClass: "font-sub-text"
	  }, [_vm._v("\n        Nessa etapa, preencha os dados solicitados, confirme o valor e clique\n        no botão \"Validar\".\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
	    staticClass: "font-sub-text"
	  }, [_vm._v("\n        Após validar seus dados, copie o código QR que aparecerá na proxima\n        tela.\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', {
	    staticClass: "font-sub-text"
	  }, [_vm._v("\n        Abra o app do seu banco, vá para o ambiente Pix, escolha a opção\n        \"Pagar com QR Code\", escaneie, confira as informações e conclua a\n        compra.\n      ")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), ('PX' == _vm.contractPaymentMethodId && _vm.isMobile && _vm.isPaymentMethodAuthorized('PX')) ? _c('div', {
	    staticClass: "margin-b20",
	    staticStyle: {
	      "font-size": "20px"
	    }
	  }, [_vm._m(4), _vm._v(" "), _c('p', {
	    staticClass: "font-sub-text-mobile"
	  }, [_vm._v("\n        Você será direcionado para um ambiente totalmente seguro para\n        finalizar sua compra.\n      ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
	    staticClass: "font-sub-title-mobile"
	  }, [_vm._v("Leia com Atenção")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', {
	    staticClass: "font-sub-text-mobile"
	  }, [_vm._v("\n        Nessa etapa, preencha os dados solicitados, confirme o valor e clique\n        no botão \"Validar\".\n      ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
	    staticClass: "font-sub-text-mobile"
	  }, [_vm._v("\n        Após validar seus dados, copie o código QR que aparecerá na proxima\n        tela.\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', {
	    staticClass: "font-sub-text-mobile"
	  }, [_vm._v("\n        Abra o app do seu banco, vá para o ambiente Pix, escolha a opção \"Pix\n        Copia e cola\", cole o código, confira as informações e conclua a\n        compra.\n      ")]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), ('CC' == _vm.contractPaymentMethodId && _vm.isPaymentMethodAuthorized('CC')) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "cc-box margin-b20"
	  }, [_c('label', {
	    staticClass: "bold block",
	    attrs: {
	      "for": "brand"
	    }
	  }, [_vm._v("Bandeira:")]), _vm._v(" "), (!_vm.checkPromoSenff && _vm.showBandeira('Mastercard')) ? _c('div', {
	    staticClass: "payments-rbox",
	    class: {
	      active: _vm.cpm.paymentMethodId == 7
	    },
	    attrs: {
	      "id": "paymentMasterBox"
	    }
	  }, [_c('div', {
	    staticClass: "radio-sm"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cpm.paymentMethodId),
	      expression: "cpm.paymentMethodId"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "type": "radio",
	      "value": "7",
	      "id": "paymentMaster",
	      "name": "optradio"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.cpm.paymentMethodId, "7")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.cpm, "paymentMethodId", "7")
	      }
	    }
	  }), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  })])]) : _vm._e(), _vm._v(" "), (!_vm.checkPromoSenff && _vm.showBandeira('Visa')) ? _c('div', {
	    staticClass: "payments-rbox",
	    class: {
	      active: _vm.cpm.paymentMethodId == 6
	    },
	    attrs: {
	      "id": "paymentVisaBox"
	    }
	  }, [_c('div', {
	    staticClass: "radio-sm"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cpm.paymentMethodId),
	      expression: "cpm.paymentMethodId"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "type": "radio",
	      "value": "6",
	      "id": "paymentVisa",
	      "name": "optradio"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.cpm.paymentMethodId, "6")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.cpm, "paymentMethodId", "6")
	      }
	    }
	  }), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  })])]) : _vm._e(), _vm._v(" "), (!_vm.checkPromoSenff && _vm.showBandeira('Elo')) ? _c('div', {
	    staticClass: "payments-rbox",
	    class: {
	      active: _vm.cpm.paymentMethodId == 10
	    },
	    attrs: {
	      "id": "paymentEloBox"
	    }
	  }, [_c('div', {
	    staticClass: "radio-sm"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cpm.paymentMethodId),
	      expression: "cpm.paymentMethodId"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "type": "radio",
	      "value": "10",
	      "id": "paymentElo",
	      "name": "optradio"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.cpm.paymentMethodId, "10")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.cpm, "paymentMethodId", "10")
	      }
	    }
	  }), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  })])]) : _vm._e(), _vm._v(" "), (!_vm.checkPromoSenff && _vm.showBandeira('HiperCard')) ? _c('div', {
	    staticClass: "payments-rbox",
	    class: {
	      active: _vm.cpm.paymentMethodId == 11
	    },
	    attrs: {
	      "id": "paymentHipercardBox"
	    }
	  }, [_c('div', {
	    staticClass: "radio-sm"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cpm.paymentMethodId),
	      expression: "cpm.paymentMethodId"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "type": "radio",
	      "value": "11",
	      "id": "paymentHipercard",
	      "name": "optradio"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.cpm.paymentMethodId, "11")
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.cpm, "paymentMethodId", "11")
	      }
	    }
	  }), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  })])]) : _vm._e()]), _vm._v(" "), (_vm.cpm.paymentMethodId) ? _c('div', {
	    staticClass: "cc-data-box"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('number')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Número do cartão:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "mask-card",
	      rawName: "v-mask-card"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cpm.number),
	      expression: "cpm.number"
	    }],
	    staticClass: "form-control number",
	    attrs: {
	      "name": "number",
	      "type": "text",
	      "data-vv-validate-on": "blur",
	      "data-encrypted-name": "number"
	    },
	    domProps: {
	      "value": (_vm.cpm.number)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.cpm, "number", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block cc"
	  }, [_vm._v("\n              " + _vm._s(_vm.errors.first("number")) + "\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('ownerName')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Nome do cartão:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cpm.ownerName),
	      expression: "cpm.ownerName"
	    }],
	    staticClass: "form-control name",
	    attrs: {
	      "type": "text",
	      "maxlength": "80",
	      "data-encrypted-name": "holderName",
	      "name": "ownerName"
	    },
	    domProps: {
	      "value": (_vm.cpm.ownerName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.cpm, "ownerName", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block cc"
	  }, [_vm._v("\n              " + _vm._s(_vm.errors.first("ownerName")) + "\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('expiryMonth')
	    }
	  }, [_c('label', {
	    staticClass: "block",
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Validade:")]), _vm._v(" "), _c('div', {
	    staticClass: "cc-month"
	  }, [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Mês")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:2|max_value:12|min_value:1'),
	      expression: "'required|min:2|max_value:12|min_value:1'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cpm.expirationMonth),
	      expression: "cpm.expirationMonth"
	    }],
	    staticClass: "form-control block",
	    attrs: {
	      "name": "expiryMonth",
	      "type": "text",
	      "data-encrypted-name": "expiryMonth",
	      "minlength": "2",
	      "maxlength": "2",
	      "placeholder": "MM"
	    },
	    domProps: {
	      "value": (_vm.cpm.expirationMonth)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.cpm, "expirationMonth", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "help-block cc"
	  }, [_vm._v("\n              " + _vm._s(_vm.errors.first("expiryMonth")) + "\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "cc-year",
	    class: {
	      'has-error': _vm.errors.has('expiryYear')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Ano:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:4|min_value:' + _vm.thisYear),
	      expression: "'required|min:4|min_value:' + thisYear"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cpm.expirationYear),
	      expression: "cpm.expirationYear"
	    }],
	    staticClass: "form-control block",
	    attrs: {
	      "name": "expiryYear",
	      "type": "text",
	      "data-encrypted-name": "expiryYear",
	      "minlength": "4",
	      "maxlength": "4",
	      "placeholder": "AAAA"
	    },
	    domProps: {
	      "value": (_vm.cpm.expirationYear)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.cpm, "expirationYear", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block cc"
	  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("expiryYear")) + "\n              ")])]), _vm._v(" "), _c('div', {
	    staticClass: "cc-cvv",
	    class: {
	      'has-error': _vm.errors.has('cvv')
	    }
	  }, [_c('label', {
	    staticClass: "label-csc",
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("Código de Segurança:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:3'),
	      expression: "'required|min:3'"
	    }, {
	      name: "only-numbers",
	      rawName: "v-only-numbers"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cpm.cvv),
	      expression: "cpm.cvv"
	    }],
	    staticClass: "form-control csc inline",
	    attrs: {
	      "type": "text",
	      "name": "cvv",
	      "maxlength": "4",
	      "data-encrypted-name": "cvc"
	    },
	    domProps: {
	      "value": (_vm.cpm.cvv)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.cpm, "cvv", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(224),
	      "alt": "",
	      "width": "50",
	      "height": "33"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block cc"
	  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("cvv")) + "\n              ")])])])]) : _vm._e()])]) : _vm._e()])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('b', [_c('div', {
	    staticStyle: {
	      "color": "#5d3b81",
	      "font-size": "30px"
	    }
	  }, [_vm._v("\n          Estamos quase lá!\n        ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('span', {
	    staticClass: "badge"
	  }, [_vm._v("1")]), _vm._v(" "), _c('b', {
	    staticClass: "font-sub-title"
	  }, [_vm._v("Preenchendo seus dados")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('span', {
	    staticClass: "badge"
	  }, [_vm._v("2")]), _vm._v(" "), _c('b', {
	    staticClass: "font-sub-title"
	  }, [_vm._v("Fazendo o Pagamento")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('span', {
	    staticClass: "badge"
	  }, [_vm._v("3")]), _vm._v(" "), _c('b', {
	    staticClass: "font-sub-title"
	  }, [_vm._v("Finalizando compra")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('b', [_c('div', {
	    staticStyle: {
	      "color": "#5d3b81",
	      "font-size": "30px"
	    }
	  }, [_vm._v("\n          Estamos quase lá!\n        ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('span', {
	    staticClass: "badge"
	  }, [_vm._v("1")]), _vm._v(" "), _c('b', {
	    staticClass: "font-sub-title-mobile"
	  }, [_vm._v("Preenchendo seus dados")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('span', {
	    staticClass: "badge"
	  }, [_vm._v("2")]), _vm._v(" "), _c('b', {
	    staticClass: "font-sub-title-mobile"
	  }, [_vm._v("Fazendo o Pagamento")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('span', {
	    staticClass: "badge"
	  }, [_vm._v("3")]), _vm._v(" "), _c('b', {
	    staticClass: "font-sub-title-mobile"
	  }, [_vm._v("Finalizando compra")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "radio-label label-h4",
	    attrs: {
	      "for": "paymentMaster"
	    }
	  }, [_c('img', {
	    staticClass: "credit-card-selection master",
	    attrs: {
	      "src": "/static/payment-methods/mastercard2.svg"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "radio-label label-h4",
	    attrs: {
	      "for": "paymentVisa"
	    }
	  }, [_c('img', {
	    staticClass: "credit-card-selection visa",
	    attrs: {
	      "src": "/static/payment-methods/visa2.svg"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "radio-label label-h4",
	    attrs: {
	      "for": "paymentElo"
	    }
	  }, [_c('img', {
	    staticClass: "credit-card-selection elo",
	    attrs: {
	      "src": "/static/payment-methods/elo2.svg"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "radio-label label-h4",
	    attrs: {
	      "for": "paymentHipercard"
	    }
	  }, [_c('img', {
	    staticClass: "credit-card-selection Hipercard",
	    attrs: {
	      "src": "/static/payment-methods/hipercard2.svg"
	    }
	  })])
	}]}

/***/ }),
/* 2184 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {}, [(_vm.error) ? _c('p', {
	    staticClass: "alert alert-danger margin-t30 margin-b10"
	  }, [_c('b', [_vm._v("Atenção!")]), _vm._v(" Não é possível cadastrar agregado com o mesmo CNPJ do\n    agregador.\n  ")]) : _c('p', {
	    staticClass: "alert alert-warning margin-t30 margin-b10"
	  }, [_c('b', [_vm._v("Atenção!")]), _vm._v(" Certifique-se de ter em mãos todos os dados para o\n    cadastro.\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('taxIdNumber')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "taxIdNumber"
	    }
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.taxIdNumberFormatted),
	      expression: "taxIdNumberFormatted",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:18|cnpj'),
	      expression: "'required|max:18|cnpj'"
	    }, {
	      name: "mask-cnpj",
	      rawName: "v-mask-cnpj"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2})$",
	      "name": "taxIdNumber",
	      "value": "",
	      "data-vv-validate-on": "blur"
	    },
	    domProps: {
	      "value": (_vm.taxIdNumberFormatted)
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.companyExists()
	      },
	      "change": function($event) {
	        _vm.taxIdNumberFormatted = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n      " + _vm._s(_vm.errors.first("taxIdNumber")) + "\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('company-name')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "company-name"
	    }
	  }, [_vm._v("Razão social")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.companyName),
	      expression: "companyName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:100'),
	      expression: "'required|max:100'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "company-name",
	      "value": ""
	    },
	    domProps: {
	      "value": (_vm.companyName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.companyName = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n      " + _vm._s(_vm.errors.first("company-name")) + "\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('company-trade-name')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "company-trade-name"
	    }
	  }, [_vm._v("Nome fantasia")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.companyTradeName),
	      expression: "companyTradeName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:100'),
	      expression: "'required|max:100'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "company-trade-name",
	      "value": ""
	    },
	    domProps: {
	      "value": (_vm.companyTradeName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.companyTradeName = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n      " + _vm._s(_vm.errors.first("company-trade-name")) + "\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "contact-box"
	  }, [_c('p', {
	    staticClass: "aggregate-sub"
	  }, [_vm._v("Contato")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('email')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "email"
	    },
	    domProps: {
	      "value": (_vm.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n        " + _vm._s(_vm.errors.first("email")) + "\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('celular')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "celular"
	    }
	  }, [_vm._v("Telefone celular")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "mask-tel",
	      rawName: "v-mask-tel"
	    }, {
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.cel),
	      expression: "cel",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cell'),
	      expression: "'required|cell'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "celular",
	      "name": "celular",
	      "title": "celular",
	      "data-vv-validate-on": "blur",
	      "maxlength": "14"
	    },
	    domProps: {
	      "value": (_vm.cel)
	    },
	    on: {
	      "input": _vm.correctCursor2,
	      "change": function($event) {
	        _vm.cel = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n        " + _vm._s(_vm.errors.first("celular")) + "\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_vm._m(0), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "mask-tel",
	      rawName: "v-mask-tel"
	    }, {
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.tel),
	      expression: "tel",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('phone'),
	      expression: "'phone'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "telefone",
	      "name": "telefone",
	      "title": "telefone",
	      "data-vv-validate-on": "blur",
	      "maxlength": "14"
	    },
	    domProps: {
	      "value": (_vm.tel)
	    },
	    on: {
	      "input": _vm.correctCursor2,
	      "change": function($event) {
	        _vm.tel = $event.target.value
	      }
	    }
	  })])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "phone"
	    }
	  }, [_vm._v("Telefone fixo "), _c('span', [_vm._v("(opcional)")])])
	}]}

/***/ }),
/* 2185 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "container-fluid"
	  }, [_c('div', {
	    staticClass: "header-action"
	  }, [_c('div', {
	    staticClass: "form-group search"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.plate),
	      expression: "plate",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "mask-plate",
	      rawName: "v-mask-plate"
	    }],
	    staticClass: "form-control upper",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "value": "",
	      "data-vv-validate-on": "blur",
	      "autofocus": "autofocus",
	      "placeholder": "Informe a placa do veículo"
	    },
	    domProps: {
	      "value": (_vm.plate)
	    },
	    on: {
	      "change": function($event) {
	        _vm.plate = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "icon-search-input"
	  })])]), _vm._v(" "), (_vm.msgError) ? _c('div', {
	    staticClass: "content-box"
	  }, [_c('div', {
	    staticClass: "alert alert-warning alert-container",
	    staticStyle: {
	      "background": "#FCDEC1"
	    }
	  }, [_c('p', {
	    staticClass: "no-margin",
	    staticStyle: {
	      "color": "#795336"
	    }
	  }, [_c('strong', [_vm._v(_vm._s(_vm.msgErrorBold))]), _vm._v(" " + _vm._s(_vm.msgError) + "\n      ")]), _vm._v(" "), _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.msgError = undefined
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-cross icon-close-modal"
	  })])])]) : _vm._e(), _vm._v(" "), (_vm.vehicle) ? _c('div', {
	    staticClass: "content-box-npadd desk"
	  }, [_c('table', {
	    staticClass: "table"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
	    staticClass: "text-center"
	  }, [_c('p', {
	    staticClass: "cell-plate info-car"
	  }, [_c('span', {
	    directives: [{
	      name: "mask-plate",
	      rawName: "v-mask-plate"
	    }]
	  }, [_vm._v(_vm._s(_vm.vehicle.plate))])])]), _vm._v(" "), _c('td', {
	    staticClass: "text-center"
	  }, [_vm._v(_vm._s(_vm.vehicle.tagSerialNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.vehicle.nodelName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.vehicle.brandName))]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "input-box"
	  }, [_c('dropdown', {
	    staticClass: "dropdown-lg dropdown-axes",
	    attrs: {
	      "options": _vm.axes,
	      "value": _vm.vehicle.category,
	      "fieldValue": "category_artesp_id"
	    },
	    model: {
	      value: (_vm.axesId),
	      callback: function($$v) {
	        _vm.axesId = $$v
	      },
	      expression: "axesId"
	    }
	  })], 1)])])])]), _vm._v(" "), (_vm.vehicle.companyName != null) ? _c('table', {
	    staticClass: "table"
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.vehicle.companyName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.vehicle.companyTradeName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.vehicle.taxIdNumber)))])])])]) : _c('table', {
	    staticClass: "table"
	  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.vehicle.personName + ' ' + _vm.vehicle.personLastName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.vehicle.taxIdNumber)))])])])])]) : _vm._e(), _vm._v(" "), (_vm.vehicle) ? _c('div', {
	    staticClass: "content-box-npadd mob"
	  }, [_c('div', {}, [_c('p', {
	    staticClass: "cell-plate info-car inline"
	  }, [_vm._v("\n        Placa:\n        "), _c('span', {
	    directives: [{
	      name: "mask-plate",
	      rawName: "v-mask-plate"
	    }]
	  }, [_vm._v(_vm._s(_vm.vehicle.plate))])]), _vm._v(" "), _c('p', {
	    staticClass: "inline"
	  }, [_c('span', {
	    staticClass: "bold"
	  }, [_vm._v("TAG Nº: ")]), _vm._v("\n        " + _vm._s(_vm.vehicle.tagSerialNumber) + "\n      ")]), _vm._v(" "), _c('p', {
	    staticClass: "inline bold"
	  }, [_vm._v(_vm._s(_vm.vehicle.brandName))]), _vm._v(" "), _c('div', {
	    staticClass: "input-box inline"
	  }, [_c('dropdown', {
	    staticClass: "dropdown-lg dropdown-axes",
	    attrs: {
	      "options": _vm.axes,
	      "value": _vm.vehicle.category,
	      "fieldValue": "category_artesp_id"
	    },
	    model: {
	      value: (_vm.axesId),
	      callback: function($$v) {
	        _vm.axesId = $$v
	      },
	      expression: "axesId"
	    }
	  })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.vehicle.personName + ' ' + _vm.vehicle.personLastName))]), _vm._v(" "), _c('p', [_c('span', {
	    staticClass: "bold"
	  }, [_vm._v("CNPJ: ")]), _vm._v("\n      " + _vm._s(_vm._f("cpfCnpj")(_vm.vehicle.taxIdNumber)) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.enableRNTRC) ? _c('div', {
	    staticClass: "col-xs-12 margin-t20"
	  }, [_c('p', {
	    staticClass: "no-margin"
	  }), _c('div', {
	    staticClass: "content-box-npadd"
	  }, [_c('div', {
	    staticClass: "content-grey"
	  }, [_c('p', {
	    staticClass: "bold margin-t10 margin-b0"
	  }, [_vm._v("Dados do transportador")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "form-group input-box-control",
	    class: {
	      'has-error': _vm.errors.has('rntrcDocument')
	    }
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "mask-cpf-cnpj",
	      rawName: "v-mask-cpf-cnpj"
	    }, {
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.rntrcDocument),
	      expression: "rntrcDocument",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cpfCnpj'),
	      expression: "'required|cpfCnpj'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2}|[0-9]{3}\\.[0-9]{3}\\.[0-9]{3}-[0-9]{2}|[0-9]{11})$",
	      "name": "rntrcDocument",
	      "data-vv-validate-on": "blur"
	    },
	    domProps: {
	      "value": (_vm.rntrcDocument)
	    },
	    on: {
	      "change": function($event) {
	        _vm.rntrcDocument = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('rntrcDocument')))])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "display": "flex",
	      "justify-content": "flex-end",
	      "margin-top": "15px",
	      "gap": "5px"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-back",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": _vm.cancelRNTRC
	    }
	  }, [_vm._v("\n                Cancelar\n              ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": _vm.validateDocument
	    }
	  }, [_vm._v("\n                Validar\n              ")])])])])]), _vm._v(" "), _c('p')]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "colspan": "5"
	    }
	  }, [_vm._v("Dados do Veículo")])]), _vm._v(" "), _c('tr', [_c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "width": "10%"
	    }
	  }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "width": "10%"
	    }
	  }, [_vm._v("TAG Nº")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Modelo")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Marca")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "30%"
	    }
	  }, [_vm._v("Eixos")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("Dados do agregador")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Razão Social")]), _vm._v(" "), _c('th', [_vm._v("Nome fantasia")]), _vm._v(" "), _c('th', [_vm._v("CNPJ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Dados do agregador")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transportador")]), _vm._v(" "), _c('th', [_vm._v("CPF")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', {
	    staticClass: "bold"
	  }, [_vm._v("CPF/CNPJ do RNTRC:")])])
	}]}

/***/ }),
/* 2186 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container",
	    attrs: {
	      "id": "senff-return"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("Obrigado por comprar com Senff.")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n        Seu pagamento está sendo processado. O notificaremos quando terminar. Você tambem pode monitorar seus pedidos abaixo.\n      ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn requests",
	    attrs: {
	      "id": "requests",
	      "type": "submit",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.goToRequests()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "text-btn-requests"
	  }, [_vm._v("Meus pedidos")]), _vm._v(" "), _c('i', {
	    staticClass: "icon-coin align-icon-right-lg"
	  })])], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [(_vm.toastNfeVisible) ? _c('div', {
	    staticClass: "toast-nota-fiscal"
	  }, [_vm._v("\n    Nota fiscal em processamento\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("\n        Planos\n        "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n        Contrato " + _vm._s(_vm.contractId) + "\n        "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Histórico de contas\n      ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [(_vm.messageError) ? _c('div', {
	    staticClass: "alert alert-warning",
	    staticStyle: {
	      "margin-bottom": "10px"
	    },
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.messageError) + "\n      ")]) : _vm._e(), _vm._v(" "), [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "margin-t20 table-white-header",
	    staticStyle: {
	      "min-height": "100px"
	    }
	  }, [(_vm.invoices && _vm.invoices.length > 0) ? _c('div', [(_vm.invoices[0].planId == 6) ? _c('div', [_c('table', {
	    staticClass: "table stripped-odd no-footer desk",
	    attrs: {
	      "role": "grid"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.invoices), function(inv) {
	    return _c('tr', {
	      key: inv.invoiceId
	    }, [_c('td', [_vm._v(_vm._s(_vm._f("date")(inv.endValidity)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(inv.expiration)))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(inv.invoiceId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(inv.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(inv.approvedDate)))]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "text-align": "right"
	      }
	    }, [_vm._v("\n                      " + _vm._s(_vm._f("centsNoSymbol")(inv.total)) + "\n                    ")]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_c('div', {
	      staticClass: "margin-t10 text-center action-menu-wrapper"
	    }, [_c('button', {
	      staticClass: "btn-action-toggle",
	      on: {
	        "click": function($event) {
	          return _vm.toggleMenu(inv.invoiceId)
	        }
	      }
	    }, [_c('img', {
	      staticStyle: {
	        "width": "18px",
	        "height": "18px"
	      },
	      attrs: {
	        "src": __webpack_require__(154),
	        "alt": "Ações"
	      }
	    })]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.visibleMenuId === inv.invoiceId),
	        expression: "visibleMenuId === inv.invoiceId"
	      }],
	      staticClass: "action-menu",
	      on: {
	        "mouseleave": function($event) {
	          _vm.visibleMenuId = null
	        }
	      }
	    }, [_c('div', {
	      staticClass: "menu-header"
	    }, [_vm._v("Documentos")]), _vm._v(" "), (inv.boleto) ? _c('a', {
	      staticClass: "menu-item",
	      attrs: {
	        "href": _vm.buildBoletoUrl(inv),
	        "target": "_blank",
	        "type": "button"
	      }
	    }, [_vm._m(1, true), _vm._v("\n                            Boleto\n                          ")]) : _vm._e(), _vm._v(" "), _c('a', {
	      staticClass: "menu-item",
	      attrs: {
	        "href": _vm.getPdf(inv.invoiceId, inv.planId),
	        "target": "_blank",
	        "type": "button"
	      }
	    }, [_vm._m(2, true), _vm._v("\n                            Fatura PDF\n                          ")]), _vm._v(" "), _c('a', {
	      staticClass: "menu-item",
	      attrs: {
	        "href": _vm.getXlsx(inv.invoiceId, inv.planId),
	        "target": "_blank",
	        "type": "button"
	      }
	    }, [_vm._m(3, true), _vm._v("\n                            Fatura Excel\n                          ")]), _vm._v(" "), _c('a', {
	      staticClass: "menu-item",
	      attrs: {
	        "href": _vm.getTxt(inv.invoiceId),
	        "target": "_blank",
	        "type": "button",
	        "download": ""
	      }
	    }, [_vm._m(4, true), _vm._v("\n                            Fatura TXT\n                          ")]), _vm._v(" "), (_vm.nfeChecked[inv.invoiceId]) ? _c('a', {
	      staticClass: "menu-item",
	      attrs: {
	        "href": _vm.nfeLinks[inv.invoiceId] || undefined,
	        "target": "_blank",
	        "tabindex": _vm.nfeLinks[inv.invoiceId] ? 0 : -1
	      }
	    }, [_vm._m(5, true), _vm._v(" "), _c('span', {
	      class: {
	        disabled: !_vm.nfeLinks[inv.invoiceId]
	      }
	    }, [_vm._v("\n                              Nota Fiscal\n                            ")]), _vm._v(" "), (!_vm.nfeLinks[inv.invoiceId]) ? _c('span', {
	      staticClass: "info-tooltip-wrapper",
	      staticStyle: {
	        "margin-left": "6px"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.showNfeToast()
	        }
	      }
	    }, [_c('img', {
	      staticStyle: {
	        "width": "18px",
	        "height": "18px"
	      },
	      attrs: {
	        "src": __webpack_require__(152),
	        "alt": "Info"
	      }
	    })]) : _vm._e()]) : _vm._e()])])])])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "mob"
	  }, _vm._l((_vm.invoices), function(inv) {
	    return _c('div', {
	      key: inv.invoiceId,
	      staticClass: "content-box"
	    }, [_c('p', {
	      staticClass: "no-margin"
	    }, [_c('strong', [_vm._v("Nº da fatura")]), _vm._v(" "), _c('span', {
	      staticClass: "pull-right"
	    }, [_vm._v(_vm._s(inv.invoiceId))])]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin"
	    }, [_c('strong', [_vm._v("Emissão")]), _vm._v(" "), _c('span', {
	      staticClass: "pull-right"
	    }, [_vm._v(_vm._s(_vm._f("shortDate")(inv.endValidity)))])]), _vm._v(" "), _c('div', {
	      staticClass: "margin-t10 text-center action-menu-wrapper"
	    }, [_c('button', {
	      staticClass: "btn-action-toggle",
	      on: {
	        "click": function($event) {
	          return _vm.toggleMenu(inv.invoiceId)
	        }
	      }
	    }, [_c('img', {
	      staticStyle: {
	        "width": "18px",
	        "height": "18px"
	      },
	      attrs: {
	        "src": __webpack_require__(154),
	        "alt": "Ações"
	      }
	    }), _vm._v("\n                      Clique para visualizar as ações\n                    ")]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.visibleMenuId === inv.invoiceId),
	        expression: "visibleMenuId === inv.invoiceId"
	      }],
	      staticClass: "action-menu",
	      on: {
	        "mouseleave": function($event) {
	          _vm.visibleMenuId = null
	        }
	      }
	    }, [_c('div', {
	      staticClass: "menu-header"
	    }, [_vm._v("Documentos")]), _vm._v(" "), (inv.boleto) ? _c('a', {
	      staticClass: "menu-item",
	      attrs: {
	        "href": _vm.buildBoletoUrl(inv),
	        "target": "_blank",
	        "type": "button"
	      }
	    }, [_vm._m(6, true), _vm._v("\n                        Boleto\n                      ")]) : _vm._e(), _vm._v(" "), _c('a', {
	      staticClass: "menu-item",
	      attrs: {
	        "href": _vm.getPdf(inv.invoiceId, inv.planId),
	        "target": "_blank",
	        "type": "button"
	      }
	    }, [_vm._m(7, true), _vm._v("\n                        Fatura PDF\n                      ")]), _vm._v(" "), _c('a', {
	      staticClass: "menu-item",
	      attrs: {
	        "href": _vm.getXlsx(inv.invoiceId, inv.planId),
	        "target": "_blank",
	        "type": "button"
	      }
	    }, [_vm._m(8, true), _vm._v("\n                        Fatura Excel\n                      ")]), _vm._v(" "), _c('a', {
	      staticClass: "menu-item",
	      attrs: {
	        "href": _vm.getTxt(inv.invoiceId),
	        "target": "_blank",
	        "type": "button",
	        "download": ""
	      }
	    }, [_vm._m(9, true), _vm._v("\n                        Fatura TXT\n                      ")]), _vm._v(" "), (_vm.nfeChecked[inv.invoiceId]) ? _c('a', {
	      staticClass: "menu-item",
	      attrs: {
	        "href": _vm.nfeLinks[inv.invoiceId] || undefined,
	        "target": "_blank",
	        "tabindex": _vm.nfeLinks[inv.invoiceId] ? 0 : -1
	      }
	    }, [_vm._m(10, true), _vm._v(" "), _c('span', {
	      class: {
	        disabled: !_vm.nfeLinks[inv.invoiceId]
	      }
	    }, [_vm._v("\n                          Nota Fiscal\n                        ")]), _vm._v(" "), (!_vm.nfeLinks[inv.invoiceId]) ? _c('span', {
	      staticClass: "info-tooltip-wrapper",
	      staticStyle: {
	        "margin-left": "6px"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.showNfeToast()
	        }
	      }
	    }, [_c('img', {
	      staticStyle: {
	        "width": "18px",
	        "height": "18px"
	      },
	      attrs: {
	        "src": __webpack_require__(152),
	        "alt": "Info"
	      }
	    })]) : _vm._e()]) : _vm._e()])])])
	  }), 0)]) : _c('div', [_c('table', {
	    staticClass: "table stripped-odd no-footer desk",
	    attrs: {
	      "role": "grid"
	    }
	  }, [_vm._m(11), _vm._v(" "), _c('tbody', _vm._l((_vm.invoices), function(inv) {
	    return _c('tr', {
	      key: inv.invoiceId
	    }, [_c('td', [_vm._v(_vm._s(_vm._f("date")(inv.endValidity)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(inv.expiration)))]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(inv.invoiceId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(inv.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(inv.approvedDate)))]), _vm._v(" "), _c('td', {
	      staticStyle: {
	        "text-align": "right"
	      }
	    }, [_vm._v("\n                      " + _vm._s(_vm._f("centsNoSymbol")(inv.total)) + "\n                    ")]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_c('div', {
	      staticClass: "margin-t10 text-center action-menu-wrapper"
	    }, [_c('button', {
	      staticClass: "btn-action-toggle",
	      on: {
	        "click": function($event) {
	          return _vm.toggleMenu(inv.invoiceId)
	        }
	      }
	    }, [_c('img', {
	      staticStyle: {
	        "width": "18px",
	        "height": "18px"
	      },
	      attrs: {
	        "src": __webpack_require__(154),
	        "alt": "Ações"
	      }
	    })]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.visibleMenuId === inv.invoiceId),
	        expression: "visibleMenuId === inv.invoiceId"
	      }],
	      staticClass: "action-menu",
	      on: {
	        "mouseleave": function($event) {
	          _vm.visibleMenuId = null
	        }
	      }
	    }, [_c('div', {
	      staticClass: "menu-header"
	    }, [_vm._v("Documentos")]), _vm._v(" "), (inv.boleto) ? _c('a', {
	      staticClass: "menu-item",
	      attrs: {
	        "href": _vm.buildBoletoUrl(inv),
	        "target": "_blank",
	        "type": "button"
	      }
	    }, [_vm._m(12, true), _vm._v("\n                            Boleto\n                          ")]) : _vm._e(), _vm._v(" "), _c('a', {
	      staticClass: "menu-item",
	      attrs: {
	        "href": _vm.getPdf(inv.invoiceId, inv.planId),
	        "target": "_blank",
	        "type": "button"
	      }
	    }, [_vm._m(13, true), _vm._v("\n                            Fatura PDF\n                          ")]), _vm._v(" "), _c('a', {
	      staticClass: "menu-item",
	      attrs: {
	        "href": _vm.getXlsx(inv.invoiceId, inv.planId),
	        "target": "_blank",
	        "type": "button"
	      }
	    }, [_vm._m(14, true), _vm._v("\n                            Fatura Excel\n                          ")]), _vm._v(" "), _c('a', {
	      staticClass: "menu-item",
	      attrs: {
	        "href": _vm.getTxt(inv.invoiceId),
	        "target": "_blank",
	        "type": "button",
	        "download": ""
	      }
	    }, [_vm._m(15, true), _vm._v("\n                            Fatura TXT\n                          ")]), _vm._v(" "), (_vm.nfeChecked[inv.invoiceId]) ? _c('a', {
	      staticClass: "menu-item",
	      attrs: {
	        "href": _vm.nfeLinks[inv.invoiceId] || undefined,
	        "target": "_blank",
	        "tabindex": _vm.nfeLinks[inv.invoiceId] ? 0 : -1
	      }
	    }, [_vm._m(16, true), _vm._v(" "), _c('span', {
	      class: {
	        disabled: !_vm.nfeLinks[inv.invoiceId]
	      }
	    }, [_vm._v("\n                              Nota Fiscal\n                            ")]), _vm._v(" "), (!_vm.nfeLinks[inv.invoiceId]) ? _c('span', {
	      staticClass: "info-tooltip-wrapper",
	      staticStyle: {
	        "margin-left": "6px"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.showNfeToast()
	        }
	      }
	    }, [_c('img', {
	      staticStyle: {
	        "width": "18px",
	        "height": "18px"
	      },
	      attrs: {
	        "src": __webpack_require__(152),
	        "alt": "Info"
	      }
	    })]) : _vm._e()]) : _vm._e()])])])])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "mob"
	  }, _vm._l((_vm.invoices), function(inv) {
	    return _c('div', {
	      key: inv.invoiceId,
	      staticClass: "content-box"
	    }, [_c('p', {
	      staticClass: "no-margin"
	    }, [_c('strong', [_vm._v("Nº da fatura")]), _vm._v(" "), _c('span', {
	      staticClass: "pull-right"
	    }, [_vm._v(_vm._s(inv.invoiceId))])]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin"
	    }, [_c('strong', [_vm._v("Valor (R$)")]), _vm._v(" "), _c('span', {
	      staticClass: "pull-right"
	    }, [_vm._v(_vm._s(_vm._f("centsNoSymbol")(inv.total)))])]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin"
	    }, [_c('strong', [_vm._v("Vencimento")]), _vm._v(" "), _c('span', {
	      staticClass: "pull-right"
	    }, [_vm._v(_vm._s(_vm._f("shortDate")(inv.expiration)))])]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin"
	    }, [_c('strong', [_vm._v("Fechamento")]), _vm._v(" "), _c('span', {
	      staticClass: "pull-right"
	    }, [_vm._v(_vm._s(_vm._f("shortDate")(inv.endValidity)))])]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin"
	    }, [_c('strong', [_vm._v("Status")]), _vm._v(" "), _c('span', {
	      staticClass: "pull-right"
	    }, [_vm._v(_vm._s(inv.shortName)), (inv.approvedDate) ? _c('span', [_vm._v("\n                        - " + _vm._s(_vm._f("shortDate")(inv.approvedDate)))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	      staticClass: "margin-t10 text-center action-menu-wrapper"
	    }, [_c('button', {
	      staticClass: "btn-action-toggle",
	      on: {
	        "click": function($event) {
	          return _vm.toggleMenu(inv.invoiceId)
	        }
	      }
	    }, [_c('img', {
	      staticStyle: {
	        "width": "18px",
	        "height": "18px"
	      },
	      attrs: {
	        "src": __webpack_require__(154),
	        "alt": "Ações"
	      }
	    }), _vm._v("\n                      Clique para visualizar as ações\n                    ")]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.visibleMenuId === inv.invoiceId),
	        expression: "visibleMenuId === inv.invoiceId"
	      }],
	      staticClass: "action-menu",
	      on: {
	        "mouseleave": function($event) {
	          _vm.visibleMenuId = null
	        }
	      }
	    }, [_c('div', {
	      staticClass: "menu-header"
	    }, [_vm._v("Documentos")]), _vm._v(" "), (inv.boleto) ? _c('a', {
	      staticClass: "menu-item",
	      attrs: {
	        "href": _vm.buildBoletoUrl(inv),
	        "target": "_blank",
	        "type": "button"
	      }
	    }, [_vm._m(17, true), _vm._v("\n                        Boleto\n                      ")]) : _vm._e(), _vm._v(" "), _c('a', {
	      staticClass: "menu-item",
	      attrs: {
	        "href": _vm.getPdf(inv.invoiceId, inv.planId),
	        "target": "_blank",
	        "type": "button"
	      }
	    }, [_vm._m(18, true), _vm._v("\n                        Fatura PDF\n                      ")]), _vm._v(" "), _c('a', {
	      staticClass: "menu-item",
	      attrs: {
	        "href": _vm.getXlsx(inv.invoiceId, inv.planId),
	        "target": "_blank",
	        "type": "button"
	      }
	    }, [_vm._m(19, true), _vm._v("\n                        Fatura Excel\n                      ")]), _vm._v(" "), _c('a', {
	      staticClass: "menu-item",
	      attrs: {
	        "href": _vm.getTxt(inv.invoiceId),
	        "target": "_blank",
	        "type": "button",
	        "download": ""
	      }
	    }, [_vm._m(20, true), _vm._v("\n                        Fatura TXT\n                      ")]), _vm._v(" "), (_vm.nfeChecked[inv.invoiceId]) ? _c('a', {
	      staticClass: "menu-item",
	      attrs: {
	        "href": _vm.nfeLinks[inv.invoiceId] || undefined,
	        "target": "_blank",
	        "tabindex": _vm.nfeLinks[inv.invoiceId] ? 0 : -1
	      }
	    }, [_vm._m(21, true), _vm._v(" "), _c('span', {
	      class: {
	        disabled: !_vm.nfeLinks[inv.invoiceId]
	      }
	    }, [_vm._v("\n                          Nota Fiscal\n                        ")]), _vm._v(" "), (!_vm.nfeLinks[inv.invoiceId]) ? _c('span', {
	      staticClass: "info-tooltip-wrapper",
	      staticStyle: {
	        "margin-left": "6px"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.showNfeToast()
	        }
	      }
	    }, [_c('img', {
	      staticStyle: {
	        "width": "18px",
	        "height": "18px"
	      },
	      attrs: {
	        "src": __webpack_require__(152),
	        "alt": "Info"
	      }
	    })]) : _vm._e()]) : _vm._e()])])])
	  }), 0)])]) : _vm._e()])], _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back margin-t20",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n            Voltar\n          ")])], 1)])], 2)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "width": "30%"
	    }
	  }, [_vm._v("Emissão")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "width": "30%"
	    }
	  }, [_vm._v("Nº Fatura")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "width": "40%"
	    }
	  }, [_vm._v("Tipo de documento")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "24px",
	      "height": "24px"
	    },
	    attrs: {
	      "src": __webpack_require__(153),
	      "alt": "Boleto"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "24px",
	      "height": "24px"
	    },
	    attrs: {
	      "src": __webpack_require__(156),
	      "alt": "Fatura PDF"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "24px",
	      "height": "24px"
	    },
	    attrs: {
	      "src": __webpack_require__(151),
	      "alt": "Fatura Excel"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "24px",
	      "height": "24px"
	    },
	    attrs: {
	      "src": __webpack_require__(157),
	      "alt": "Fatura TXT"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "24px",
	      "height": "24px"
	    },
	    attrs: {
	      "src": __webpack_require__(155),
	      "alt": "Nota Fiscal"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "24px",
	      "height": "24px"
	    },
	    attrs: {
	      "src": __webpack_require__(153),
	      "alt": "Boleto"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "24px",
	      "height": "24px"
	    },
	    attrs: {
	      "src": __webpack_require__(156),
	      "alt": "Fatura PDF"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "24px",
	      "height": "24px"
	    },
	    attrs: {
	      "src": __webpack_require__(151),
	      "alt": "Fatura Excel"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "24px",
	      "height": "24px"
	    },
	    attrs: {
	      "src": __webpack_require__(157),
	      "alt": "Fatura TXT"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "24px",
	      "height": "24px"
	    },
	    attrs: {
	      "src": __webpack_require__(155),
	      "alt": "Nota Fiscal"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "width": "9%"
	    }
	  }, [_vm._v("Fechamento")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "9%"
	    }
	  }, [_vm._v("Vencimento")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "width": "9%"
	    }
	  }, [_vm._v("Nº Fatura")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "15%"
	    }
	  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "9%"
	    }
	  }, [_vm._v("Evento")]), _vm._v(" "), _c('th', {
	    staticClass: "text-right",
	    attrs: {
	      "width": "9%"
	    }
	  }, [_vm._v("Valor (R$)")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "width": "40%"
	    }
	  }, [_vm._v("Ações")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "24px",
	      "height": "24px"
	    },
	    attrs: {
	      "src": __webpack_require__(153),
	      "alt": "Boleto"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "24px",
	      "height": "24px"
	    },
	    attrs: {
	      "src": __webpack_require__(156),
	      "alt": "Fatura PDF"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "24px",
	      "height": "24px"
	    },
	    attrs: {
	      "src": __webpack_require__(151),
	      "alt": "Fatura Excel"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "24px",
	      "height": "24px"
	    },
	    attrs: {
	      "src": __webpack_require__(157),
	      "alt": "Fatura TXT"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "24px",
	      "height": "24px"
	    },
	    attrs: {
	      "src": __webpack_require__(155),
	      "alt": "Nota Fiscal"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "18px",
	      "height": "18px"
	    },
	    attrs: {
	      "src": __webpack_require__(153),
	      "alt": "Ações"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "24px",
	      "height": "24px"
	    },
	    attrs: {
	      "src": __webpack_require__(156),
	      "alt": "Fatura PDF"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "24px",
	      "height": "24px"
	    },
	    attrs: {
	      "src": __webpack_require__(151),
	      "alt": "Fatura Excel"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "24px",
	      "height": "24px"
	    },
	    attrs: {
	      "src": __webpack_require__(157),
	      "alt": "Fatura TXT"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "24px",
	      "height": "24px"
	    },
	    attrs: {
	      "src": __webpack_require__(155),
	      "alt": "Nota Fiscal"
	    }
	  })])
	}]}

/***/ }),
/* 2188 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.formState == 'NEW') ? _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.vincularTag.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    class: {
	      'has-error': _vm.errors.has('serialNumber')
	    }
	  }, [_c('div', {
	    staticClass: "form-tag-activate"
	  }, [_c('b', [_vm._v("TAG Número")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.serialNumber),
	      expression: "serialNumber"
	    }],
	    staticClass: "form-control input-tag-number",
	    attrs: {
	      "data-vv-rules": "required|numeric",
	      "type": "text",
	      "name": "serialNumber",
	      "placeholder": "0000000000",
	      "id": _vm.vehicle
	    },
	    domProps: {
	      "value": (_vm.serialNumber)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.serialNumber = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-activate",
	    attrs: {
	      "type": "submit",
	      "name": "button"
	    }
	  }, [_vm._v("\n      Ativar\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n    " + _vm._s(_vm.errors.first('serialNumber')) + "\n  ")])]) : (_vm.formState == 'OLD') ? _c('form', [_c('div', {
	    class: {
	      'has-error': _vm.errors.has('serialNumber')
	    }
	  }, [_c('div', {
	    staticClass: "form-tag-activate"
	  }, [_c('b', [_vm._v("TAG Número")]), _vm._v(" "), _c('p', {
	    staticClass: "cell-activated-tag"
	  }, [_vm._v(_vm._s(_vm.serialNumber))])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-activate-tag",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    }
	  }, [_vm._v("\n      Ativo\n    ")])])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2189 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade modal-print-vp",
	    attrs: {
	      "id": "modal-print-vp",
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-labelledby": "modal-print-vp-label"
	    },
	    on: {
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) { return null; }
	        return _vm.closeModal()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-body"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('p', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "vp-info"
	  }, [_c('h4', [_vm._v("\n            N° Vale-pedágio:\n            "), _c('span', [_vm._v(_vm._s(_vm.vpSelected.idProtocolo))])]), _vm._v(" "), _c('h4', [_vm._v("\n            Valor:\n            "), _c('span', [_vm._v(_vm._s(_vm._f("cents")(_vm.vpSelected.valorVP)))])]), _vm._v(" "), _c('p', [_vm._v("\n            Transportador:\n            "), _c('span', [_vm._v(_vm._s(_vm.vpSelected.transportador))])]), _vm._v(" "), _c('p', {
	    staticClass: "inline"
	  }, [_vm._v("\n            N° TAG:\n            "), _c('span', [_vm._v(_vm._s(_vm.vpSelected.tag))])]), _vm._v(" "), _c('p', {
	    staticClass: "inline"
	  }, [_vm._v("\n            Placa:\n            "), _c('span', {
	    staticClass: "upper"
	  }, [_vm._v(_vm._s(_vm.vpSelected.placaVeiculo))])])]), _vm._v(" "), _c('div', {
	    staticClass: "text-center"
	  }, [_c('i', {
	    staticClass: "icon-circle-right"
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("Escolha o formato do arquivo para exportação.")]), _vm._v(" "), _c('div', {
	    staticClass: "btn-group"
	  }, [_c('div', {
	    staticClass: "btn-group",
	    attrs: {
	      "data-toggle": "buttons"
	    }
	  }, [_c('label', {
	    staticClass: "btn",
	    class: {
	      'active': _vm.downloadType == 'pdf'
	    },
	    on: {
	      "click": function($event) {
	        _vm.downloadType = 'pdf'
	      }
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.downloadType),
	      expression: "downloadType"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "options",
	      "id": "pdf",
	      "value": "pdf",
	      "checked": ""
	    },
	    domProps: {
	      "checked": _vm.downloadType == 'pdf',
	      "checked": _vm._q(_vm.downloadType, "pdf")
	    },
	    on: {
	      "change": function($event) {
	        _vm.downloadType = "pdf"
	      }
	    }
	  }), _vm._v(" PDF\n              ")]), _vm._v(" "), _c('label', {
	    staticClass: "btn",
	    class: {
	      'active': _vm.downloadType == 'xlsx'
	    },
	    on: {
	      "click": function($event) {
	        _vm.downloadType = 'xlsx'
	      }
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.downloadType),
	      expression: "downloadType"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "options",
	      "id": "xlsx",
	      "value": "xlsx"
	    },
	    domProps: {
	      "checked": _vm.downloadType == 'xlsx',
	      "checked": _vm._q(_vm.downloadType, "xlsx")
	    },
	    on: {
	      "change": function($event) {
	        _vm.downloadType = "xlsx"
	      }
	    }
	  }), _vm._v(" EXCEL\n              ")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "no-btn",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.download(_vm.vpSelected.idIntern)
	      }
	    }
	  }, [_vm._v("\n          Exportar\n          "), _c('i', {
	    staticClass: "icon-circle-right"
	  })])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('strong', [_c('span', [_vm._v(".pdf")]), _vm._v(" "), _c('span', [_vm._v(".xlsx")])])
	}]}

/***/ }),
/* 2190 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('ul', [(_vm.companies) ? _c('div', [_c('p', {
	    staticClass: "sub-title-list"
	  }, [_vm._v("Contas")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.companies), function(company) {
	    return (_vm.companies) ? _c('li', [_c('a', {
	      class: {
	        active: company.moveMaisId == _vm.currentUser.moveMaisId
	      },
	      on: {
	        "click": function($event) {
	          return _vm.changeUser(company.moveMaisId)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "dot"
	    }), _vm._v("\n            " + _vm._s(company.companyName) + "\n          ")])]) : _vm._e()
	  }), _vm._v(" "), (_vm.companies) ? _c('div', {
	    staticStyle: {
	      "border-bottom": "3px solid #eeeeee",
	      "margin": "10px -10px"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.companies) ? _c('div', [_c('p', {
	    staticClass: "sub-title-list"
	  }, [_vm._v("Mais opções")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'plans'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-padnote"
	  }), _vm._v("\n            Meus planos\n          ")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'requests'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-tick-box"
	  }), _vm._v("\n            Pedidos\n          ")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'profile'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-avatar"
	  }), _vm._v("\n            Meus dados\n          ")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'password-change'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-key"
	  }), _vm._v("\n            Alterar senha\n          ")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": _vm.logout
	    }
	  }, [_c('i', {
	    staticClass: "icon-logout"
	  }), _vm._v("\n            Sair\n          ")])])], 2)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("Minha Conta")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })])])
	}]}

/***/ }),
/* 2191 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', [_vm._m(0), _vm._v(" "), (_vm.formStep == 0) ? _c('div', {
	    staticClass: "form-container-adhesion"
	  }, [_c('form-vehicle', {
	    attrs: {
	      "plate": _vm.plate,
	      "ArrayVehicles": _vm.ArrayVehicles
	    },
	    on: {
	      "ValueChanger": _vm.ChangeByPropsStepOne,
	      "TurnOnLoading": _vm.ChangeLoadingStatusToOn,
	      "TurnOffLoading": _vm.ChangeLoadingStatusToOff,
	      "SaveVehicle": _vm.add,
	      "AxesChanger": _vm.ChangeAxesInfo,
	      "ModelChanger": _vm.ChangeModelInfo,
	      "ValueChangerNetrinOff": _vm.ChangeByPropsStepOneNetrinOff,
	      "TransportadorChanger": _vm.ChangeTransportadorInfo
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.formStep == 1) ? _c('div', {
	    staticClass: "form-container-adhesion"
	  }, [(_vm.formStep == 1) ? _c('form-add-vehicles', {
	    attrs: {
	      "ArrayVehicles": _vm.vehicles,
	      "formVisibility": _vm.formVisibility
	    },
	    on: {
	      "stepBack": _vm.stepBackZero,
	      "OpenForm": _vm.OpenForm
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.formVisibility) ? _c('form-vehicle', {
	    attrs: {
	      "plate": _vm.plate,
	      "ArrayVehicles": _vm.vehicles
	    },
	    on: {
	      "ValueChanger": _vm.ChangeByPropsStepOne,
	      "TurnOnLoading": _vm.ChangeLoadingStatusToOn,
	      "TurnOffLoading": _vm.ChangeLoadingStatusToOff,
	      "SaveVehicle": _vm.add,
	      "AxesChanger": _vm.ChangeAxesInfo,
	      "ModelChanger": _vm.ChangeModelInfo,
	      "ValueChangerNetrinOff": _vm.ChangeByPropsStepOneNetrinOff,
	      "TransportadorChanger": _vm.ChangeTransportadorInfo
	    }
	  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showModalInvalidPlate) ? _c('modal-simple', {
	    on: {
	      "close": function($event) {
	        _vm.showModalInvalidPlate = false
	      }
	    }
	  }, [_c('h4', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_vm._v("\n        ATENÇÃO!\n    ")]), _vm._v(" "), _c('p', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_vm._v("\n      Placa inválida."), _c('br'), _vm._v("Verifique se digitou a\n      placa correta.\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('loadingV2') : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "header-form"
	    }
	  }, [_c('h2', [_vm._v("Veículo(s) do plano")])])
	}]}

/***/ }),
/* 2192 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "row"
	  }, [(_vm.typesAllowed.bankAccount) ? _c('div', {
	    class: _vm.colClassPayment
	  }, [_c('div', {
	    staticClass: "radio-box category",
	    class: {
	      'active': _vm.type == 'DC'
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.type),
	      expression: "type"
	    }],
	    attrs: {
	      "type": "radio",
	      "id": "debit",
	      "name": "radio",
	      "value": "DC"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.type, "DC")
	    },
	    on: {
	      "change": function($event) {
	        _vm.type = "DC"
	      }
	    }
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "check first"
	  })])]) : _vm._e(), _vm._v(" "), (_vm.typesAllowed.creditCard) ? _c('div', {
	    class: _vm.colClassPayment
	  }, [_c('div', {
	    staticClass: "radio-box category",
	    class: {
	      'active': _vm.type == 'CC'
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.type),
	      expression: "type"
	    }],
	    attrs: {
	      "type": "radio",
	      "id": "credit",
	      "name": "radio",
	      "value": "CC"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.type, "CC")
	    },
	    on: {
	      "change": function($event) {
	        _vm.type = "CC"
	      }
	    }
	  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  })])]) : _vm._e(), _vm._v(" "), (_vm.typesAllowed.bankBill) ? _c('div', {
	    class: _vm.colClassPayment
	  }, [_c('div', {
	    staticClass: "radio-box category",
	    class: {
	      'active': _vm.type == 'BC'
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.type),
	      expression: "type"
	    }],
	    attrs: {
	      "type": "radio",
	      "id": "billet",
	      "name": "radio",
	      "value": "BC"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.type, "BC")
	    },
	    on: {
	      "change": function($event) {
	        _vm.type = "BC"
	      }
	    }
	  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  })])]) : _vm._e(), _vm._v(" "), (_vm.typesAllowed.doc) ? _c('div', {
	    class: _vm.colClassPayment
	  }, [_c('div', {
	    staticClass: "radio-box category",
	    class: {
	      'active': _vm.type == 'DO'
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.type),
	      expression: "type"
	    }],
	    attrs: {
	      "type": "radio",
	      "id": "doc",
	      "name": "radio",
	      "value": "DO"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.type, "DO")
	    },
	    on: {
	      "change": function($event) {
	        _vm.type = "DO"
	      }
	    }
	  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  })])]) : _vm._e(), _vm._v(" "), (_vm.typesAllowed.ted) ? _c('div', {
	    class: _vm.colClassPayment
	  }, [_c('div', {
	    staticClass: "radio-box category",
	    class: {
	      'active': _vm.type == 'TE'
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.type),
	      expression: "type"
	    }],
	    attrs: {
	      "type": "radio",
	      "id": "ted",
	      "name": "radio",
	      "value": "TE"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.type, "TE")
	    },
	    on: {
	      "change": function($event) {
	        _vm.type = "TE"
	      }
	    }
	  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "check"
	  })])]) : _vm._e()]), _vm._v(" "), (_vm.type == 'BC') ? _c('div', {
	    staticClass: "margin-b20"
	  }, [_vm._m(5)]) : _vm._e(), _vm._v(" "), (_vm.type == 'DO') ? _c('div', {
	    staticClass: "margin-b20"
	  }, [_vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.type == 'TE') ? _c('div', {
	    staticClass: "margin-b20"
	  }, [_vm._m(7)]) : _vm._e(), _vm._v(" "), (_vm.type == 'CC') ? _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-box margin-t20"
	  }, [_c('b', {
	    staticClass: "title-identification margin-b10"
	  }, [_vm._v("Dados para Cartão de Crédito")]), _vm._v(" "), _c('div', {
	    staticClass: "form-content"
	  }, [_c('credit-card', {
	    ref: "creditCard",
	    attrs: {
	      "valueStart": _vm.payment.creditCard,
	      "addressStart": _vm.addressStart,
	      "options": _vm.creditCardOptions,
	      "showCvv": true
	    },
	    model: {
	      value: (_vm.creditCard),
	      callback: function($$v) {
	        _vm.creditCard = $$v
	      },
	      expression: "creditCard"
	    }
	  })], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.type == 'DC') ? _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-box margin-t20"
	  }, [_c('b', {
	    staticClass: "title-identification margin-b10"
	  }, [_vm._v("Dados para Débito em Conta")]), _vm._v(" "), _c('div', {
	    staticClass: "form-content"
	  }, [_c('bank-account', {
	    ref: "bankAccount",
	    attrs: {
	      "valueStart": _vm.payment.bankAccount,
	      "options": _vm.bankAccountOptions
	    },
	    model: {
	      value: (_vm.bankAccount),
	      callback: function($$v) {
	        _vm.bankAccount = $$v
	      },
	      expression: "bankAccount"
	    }
	  }), _vm._v(" "), _c('small', [_vm._v("Obs: A adesão é efetuada após a confirmação do pagamento. Para o débito em conta, o prazo para confirmação é de até 5 dias úteis.")])], 1)])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "radio-label bold",
	    attrs: {
	      "for": "debit"
	    }
	  }, [_c('i', {
	    staticClass: "icon-bank"
	  }), _vm._v("\n        Débito em Conta\n      ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "radio-label bold",
	    attrs: {
	      "for": "credit"
	    }
	  }, [_c('i', {
	    staticClass: "icon-card"
	  }), _vm._v("\n        Cartão de Crédito\n      ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "radio-label bold",
	    attrs: {
	      "for": "billet"
	    }
	  }, [_c('i', {
	    staticClass: "icon-bank-slip"
	  }), _vm._v("\n        Boleto Bancário\n      ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "radio-label bold",
	    attrs: {
	      "for": "doc"
	    }
	  }, [_c('i', {
	    staticClass: "icon-doc"
	  }), _vm._v("\n        DOC\n      ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "radio-label bold",
	    attrs: {
	      "for": "ted"
	    }
	  }, [_c('i', {
	    staticClass: "icon-ted"
	  }), _vm._v("\n        TED\n      ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "alert alert-info",
	    staticStyle: {
	      "margin-top": "1%"
	    }
	  }, [_vm._v("\n      O tempo mínimo para compensação e disponibilização do crédito de boletos bancários junto às praças de pedágio é de 3 dias úteis."), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Para mais informações, entre em contato com a Central de Relacionamento pelo número 4000 2901 (regiões metropolitanas) ou 0800 777 1022 (demais localidades).")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "alert alert-info",
	    staticStyle: {
	      "margin-top": "1%"
	    }
	  }, [_vm._v("\n      O tempo mínimo para compensação e disponibilização do crédito de Documento de Ordem de Crédito (DOC) junto às praças de pedágio é de 3 dias úteis."), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Para mais informações, entre em contato com a Central de Relacionamento pelo número 4000 2901 (regiões metropolitanas) ou 0800 777 1022 (demais localidades).")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "alert alert-info",
	    staticStyle: {
	      "margin-top": "1%"
	    }
	  }, [_vm._v("\n      O tempo mínimo para compensação e disponibilização do crédito de Transferência Eletrônica Disponível (TED) junto às praças de pedágio é de 3 dias úteis."), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Para mais informações, entre em contato com a Central de Relacionamento pelo número 4000 2901 (regiões metropolitanas) ou 0800 777 1022 (demais localidades).")])])
	}]}

/***/ }),
/* 2193 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("Meus dados")])], 1)]), _vm._v(" "), _c('form', {
	    attrs: {
	      "action": "index.html",
	      "method": "post",
	      "id": "profile-form"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "row margin-t10"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.user.type == 2) ? _c('div', {
	    staticClass: "form-box margin-b20"
	  }, [_c('b', {
	    staticClass: "title-identification margin-b10"
	  }, [_vm._v("Informações básicas da empresa")]), _vm._v(" "), _c('div', {
	    staticClass: "form-content"
	  }, [_c('div', {
	    staticClass: "form-group margin-b30 input-box-control"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.taxIdNumber),
	      expression: "user.taxIdNumber"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "id": "taxIdNumber",
	      "name": "taxIdNumber",
	      "title": "cnpj",
	      "placeholder": "CNPJ",
	      "readonly": ""
	    },
	    domProps: {
	      "value": (_vm.user.taxIdNumber)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.user, "taxIdNumber", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.company.companyName),
	      expression: "user.company.companyName"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "title": "razão social",
	      "placeholder": "Razão social",
	      "readonly": ""
	    },
	    domProps: {
	      "value": (_vm.user.company.companyName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.user.company, "companyName", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group input-box-control margin-b10"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.company.companyTradeName),
	      expression: "user.company.companyTradeName"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "title": "razão social",
	      "placeholder": "Nome fantasia",
	      "readonly": ""
	    },
	    domProps: {
	      "value": (_vm.user.company.companyTradeName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.user.company, "companyTradeName", $event.target.value)
	      }
	    }
	  })])])])]) : _vm._e(), _vm._v(" "), (_vm.user.type == 1) ? _c('div', {
	    staticClass: "form-box margin-b20"
	  }, [_c('b', {
	    staticClass: "title-identification margin-b10"
	  }, [_vm._v("Informações básicas")]), _vm._v(" "), _c('div', {
	    staticClass: "form-content"
	  }, [_c('div', {
	    staticClass: "form-group margin-b30 input-box-control"
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.taxIdNumber),
	      expression: "user.taxIdNumber"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "id": "taxIdNumber",
	      "name": "taxIdNumber",
	      "title": "cpf",
	      "placeholder": "CPF",
	      "readonly": ""
	    },
	    domProps: {
	      "value": (_vm.user.taxIdNumber)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.user, "taxIdNumber", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "title": "nome",
	      "placeholder": "Nome Completo",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.user.person.name + ' ' + _vm.user.person.lastName
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group input-box-control margin-b10"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "title": "data de nascimento",
	      "placeholder": "Data de nascimento",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm._f("date")(_vm.user.person.birthDate)
	    }
	  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-box margin-b30"
	  }, [_c('b', {
	    staticClass: "title-identification margin-b10"
	  }, [_vm._v("Contatos")]), _vm._v(" "), _c('div', {
	    staticClass: "form-content"
	  }, [_c('div', {
	    staticClass: "form-group margin-b30 input-box-control margin-b10",
	    class: {
	      'has-error': _vm.errors.has('email')
	    }
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.email2),
	      expression: "user.email2"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "id": "email",
	      "name": "email",
	      "title": "email",
	      "placeholder": "E-mail",
	      "readonly": ""
	    },
	    domProps: {
	      "value": (_vm.user.email2)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.user, "email2", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group input-box-control"
	  }, [_c('div', {
	    staticClass: "label-box"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "input-box margin-t10"
	  }, [(_vm.is2faValid) ? _c('div', [_c('button', {
	    staticClass: "btn btn-default margin-t10",
	    attrs: {
	      "id": "btn-confirm-recharge",
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeEmail()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "text-btn-recharge"
	  }, [_vm._v("Alterar e-mail")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control margin-b10",
	    class: {
	      'has-error': _vm.errors.has('celular')
	    }
	  }, [_vm._m(7), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cell'),
	      expression: "'required|cell'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cel),
	      expression: "cel"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "id": "celular",
	      "name": "celular",
	      "title": "celular",
	      "placeholder": "Celular",
	      "disabled": _vm.isCampoDesabilitado
	    },
	    domProps: {
	      "value": (_vm.cel)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.cel = $event.target.value
	      }, _vm.correctCursor]
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("celular")) + "\n                ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group input-box-control"
	  }, [_c('div', {
	    staticClass: "label-box"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "input-box margin-t10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.allowSMS),
	      expression: "allowSMS"
	    }],
	    staticClass: "check-terms",
	    attrs: {
	      "type": "checkbox",
	      "id": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.allowSMS) ? _vm._i(_vm.allowSMS, null) > -1 : (_vm.allowSMS)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.allowSMS,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.allowSMS = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.allowSMS = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.allowSMS = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "label-terms",
	    attrs: {
	      "for": "checkbox"
	    }
	  }, [_vm._v("Deseja Receber SMS ?")]), _vm._v(" "), (_vm.is2faValid) ? _c('div', [_c('button', {
	    staticClass: "btn btn-default margin-t10",
	    attrs: {
	      "id": "btn-confirm-recharge",
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changePhone()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "text-btn-recharge"
	  }, [_vm._v("Alterar celular")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control",
	    class: {
	      'has-error': _vm.errors.has('telefone')
	    }
	  }, [_vm._m(8), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tel),
	      expression: "tel"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('phone'),
	      expression: "'phone'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "id": "telefone",
	      "name": "telefone",
	      "title": "telefone",
	      "placeholder": "Telefone",
	      "disabled": _vm.isTelDisable
	    },
	    domProps: {
	      "value": (_vm.tel)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.tel = $event.target.value
	      }, _vm.correctCursor]
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("telefone")) + "\n                ")])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("CNPJ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Razão social")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Nome fantasia")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("CPF")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Nome Completo")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Data de nascimento")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("E-mail")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Celular")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Telefone")])])
	}]}

/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "planInfoContainer"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "img-container"
	    }
	  }, [_c('div', {
	    staticClass: "img-plan",
	    attrs: {
	      "id": "img-plan"
	    }
	  }, [_c('h3', {
	    attrs: {
	      "id": "img-plan-title"
	    }
	  }, [_vm._v("Pré-pago Manual")]), _vm._v(" "), _c('h3', {
	    attrs: {
	      "id": "img-plan-subtitle"
	    }
	  }, [_vm._v("Pessoa Jurídica")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('h5', {
	    on: {
	      "click": function($event) {
	        return _vm.abrirModal()
	      }
	    }
	  }, [_vm._v("Tabela de recarga")])])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "card-info-container"
	    }
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": _vm.roadCardPJ
	    }
	  }, [_vm._m(6)])]), _vm._v(" "), (_vm.showModal) ? _c('div', {
	    staticClass: "modalContainer"
	  }, [_c('ModalRechargePj', {
	    on: {
	      "fechar-modal": _vm.fecharModal
	    }
	  }), _vm._v(" "), (_vm.showModal) ? _c('div', {
	    staticClass: "overlay"
	  }) : _vm._e()], 1) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "info-desc-container"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(43)
	    }
	  }), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detalhe1"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "info-desc-container"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(43)
	    }
	  }), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detalhe2"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "info-desc-container"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(43)
	    }
	  }), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detalhe3"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "info-desc-container"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(43)
	    }
	  }), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detalhe4"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "info-desc-container"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(43)
	    }
	  }), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detalhe5"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "info-desc-container"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(43)
	    }
	  }), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detalhe6"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "plan-button"
	    }
	  }, [_c('p', [_vm._v("Quero este plano")]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(509)
	    }
	  })])
	}]}

/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back",
	    attrs: {
	      "to": {
	        'name': 'contact'
	      },
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n        Voltar\n      ")])], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("\n        Ouvidoria\n      ")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-7"
	  }, [_c('p', [_vm._v("Nós queremos saber sua opinião para melhorar sempre nossos processos, produtos e serviços.")]), _vm._v(" "), _c('p', {
	    staticClass: "margin-20"
	  }, [_vm._v("\n        Se você tiver alguma crítica referente à prestação de nossos serviços ou reclamação não solucionada pelos outros Canais\n        de Relacionamento, entre em contato com a nossa "), _c('b', [_vm._v("Ouvidoria")])]), _vm._v(" "), _c('p', [_vm._v("Basta ligar para o "), _c('b', [_vm._v("0800 765 3000")]), _vm._v(", de segunda à sexta-feira, das 8h às 17h.")]), _vm._v(" "), _c('div', {
	    staticClass: "alert alert-info margin-30"
	  }, [_c('b', {
	    staticClass: "upper"
	  }, [_vm._v("importante:")]), _vm._v(" antes de entrar em contato com a nossa "), _c('b', [_vm._v("Ouvidoria")]), _vm._v(", é preferível que você já tenha buscado solução\n        junto à nossa Central de Relacionamento e tenha aguardado o prazo informado para o atendimento de sua solicitação.\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5 text-center"
	  }, [_c('img', {
	    staticClass: "ombudsman margin-20",
	    attrs: {
	      "src": __webpack_require__(1864),
	      "alt": ""
	    }
	  })])])
	}]}

/***/ }),
/* 2196 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade in",
	    staticStyle: {
	      "display": "block",
	      "background": "rgba(230, 230, 230, 0.8)"
	    },
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header modal-info"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.hideModal()
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Alterar Valor da Recarga Automática")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('p', {
	    staticClass: "bold-600 text-center no-margin"
	  }, [_vm._v("Valor da Recarga")]), _vm._v(" "), _c('div', {
	    staticClass: "box-plus-minus"
	  }, [_c('button', {
	    staticClass: "inline bold btn-charge",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.calculate(_vm.rechargeAlter.valueTotal - _vm.multiple)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-minus"
	  })]), _vm._v(" "), _c('input', {
	    staticClass: "inline form-control bold",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm._f("cents")(_vm.rechargeAlter.valueTotal)
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "inline bold btn-charge",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.calculate(_vm.rechargeAlter.valueTotal + _vm.multiple)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-plus"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "recharge-open-tax"
	  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v(_vm._s(_vm._f("cents")(_vm.rechargeAlter.taxTotal)))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.hideModal()
	      }
	    }
	  }, [_vm._v("\n          Cancelar\n        ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.alterRechargeUnit()
	      }
	    }
	  }, [_vm._v("\n          Confimar\n        ")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2197 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "row border-row row-fix"
	  }, [_c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', {
	    staticClass: "content-box-small mg-form-fix"
	  }, [_c('form', {
	    staticClass: "margin-50",
	    attrs: {
	      "action": "index.html"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.getLead.apply(null, arguments)
	      }
	    }
	  }, [(_vm.errorMessage) ? _c('div', {
	    staticClass: "alert alert-danger mg-fix",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Atenção!")]), _vm._v(" " + _vm._s(_vm.errorMessage) + "\n             ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('taxIdNumber')
	    }
	  }, [_c('label', [_vm._v("CPF ou CNPJ:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.taxIdNumber),
	      expression: "taxIdNumber",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cpfCnpj|accountExists:cpf'),
	      expression: "'required|cpfCnpj|accountExists:cpf'"
	    }, {
	      name: "mask-cpf-cnpj",
	      rawName: "v-mask-cpf-cnpj"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2}|[0-9]{3}\\.[0-9]{3}\\.[0-9]{3}-[0-9]{2}|[0-9]{11})$",
	      "name": "taxIdNumber",
	      "data-vv-validate-on": "blur",
	      "placeholder": "",
	      "maxlength": "18"
	    },
	    domProps: {
	      "value": (_vm.taxIdNumber)
	    },
	    on: {
	      "change": function($event) {
	        _vm.taxIdNumber = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('taxIdNumber')))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.isShow == 'SHOW') ? _c('div', {
	    staticClass: "text-center"
	  }, [(_vm.typePerson == 'PERSON') ? _c('div', [_c('router-link', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "to": {
	        'name': 'adhesion',
	        'query': {
	          'planId': '35'
	        }
	      },
	      "tag": "button"
	    }
	  }, [_vm._v("\n                              MANUAL PF\n                  ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "to": {
	        'name': 'adhesion',
	        'query': {
	          'planId': '36'
	        }
	      },
	      "tag": "button"
	    }
	  }, [_vm._v("\n                              Automático PF\n                  ")])], 1) : _c('div', [_c('router-link', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "to": {
	        'name': 'adhesion',
	        'query': {
	          'planId': '37'
	        }
	      },
	      "tag": "button"
	    }
	  }, [_vm._v("\n                              MANUAL PJ\n                  ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "to": {
	        'name': 'adhesion',
	        'query': {
	          'planId': '38'
	        }
	      },
	      "tag": "button"
	    }
	  }, [_vm._v("\n                              Automático PJ\n                  ")])], 1)]) : _vm._e()])])]), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t30"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back",
	    attrs: {
	      "to": "/inicio"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n        Voltar\n      ")])], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("\n        Plano Caminhos do Paraná\n      ")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('p', [_vm._v("Para aderir a esse plano é necessário estar na lista de isentos da Caminhos do Paraná, por isso digite seu CPF ou CNPJ para podermos continuar:")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-center"
	  }, [_c('button', {
	    staticClass: "btn btn-lg btn-primary mg-top-8 ",
	    attrs: {
	      "id": "btn-login",
	      "type": "submit",
	      "name": "button"
	    }
	  }, [_vm._v("\n                  Avançar\n                ")]), _vm._v(" "), _c('i', {
	    staticClass: "icon-circle-right align-icon"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-5"
	  }, [_c('div', {
	    staticClass: "parana-way"
	  })])
	}]}

/***/ }),
/* 2198 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "container"
	  }, [(_vm.salesOrder && _vm.newPix == false && !_vm.hideButton) ? _c('h3', {
	    staticClass: "title-info-reprocess",
	    class: _vm.salesOrder.salesOrderStatus.salesOrderStatusId == 2 ? 'green' : 'red'
	  }, [_vm._v(_vm._s(_vm.salesOrder.salesOrderStatus.description))]) : _vm._e(), _vm._v(" "), (_vm.salesOrder && _vm.code == null && !_vm.newPix) ? _c('generic-summary', {
	    attrs: {
	      "account": _vm.user,
	      "order": _vm.salesOrder,
	      "contract": _vm.contract,
	      "showAddress": true,
	      "reprocess": true,
	      "skipBillingSection": true
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.salesOrder && _vm.salesOrder.salesOrderStatus && _vm.salesOrder.salesOrderStatus.salesOrderStatusId == 3 && _vm.newPix == false) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [(!_vm.hideButton) ? _c('button', {
	    staticClass: "btn btn-success margin-t20 pull-right",
	    on: {
	      "click": _vm.getPayment
	    }
	  }, [_vm._v("\n        Reprocessar\n        "), _c('i', {
	    staticClass: "icon-coin align-icon-right-white"
	  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('success-page', {
	    attrs: {
	      "code": _vm.code,
	      "boletoUrl": null,
	      "type": 'reprocess',
	      "novoCartao": _vm.novoCartao,
	      "newPix": _vm.newPix,
	      "pixCopiaCola": _vm.pixCopiaCola,
	      "salesOrder": _vm.salesOrder,
	      "usuario": _vm.usuario,
	      "validado": _vm.validado
	    }
	  }), _vm._v(" "), _c('error-page', {
	    attrs: {
	      "code": _vm.code,
	      "stepPayment": 1,
	      "type": 'reprocess',
	      "salesOrder": _vm.salesOrder,
	      "validacaoFraude": _vm.validacaoFraude,
	      "cmpId": _vm.cpmId
	    },
	    on: {
	      "goToStep": _vm.goToStep
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("\n        Vouchers\n        "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Voucher\n      ")])], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    staticClass: "form-box margin-t20"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-content"
	  }, [_c('img', {
	    staticClass: "rule-color",
	    attrs: {
	      "src": __webpack_require__(116),
	      "alt": ""
	    }
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("Obs.: O(s) TAG(s) será(ão) ativado(s) somente após a validação do respectivo Voucher pelo Parceiro.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', {
	    staticClass: "title-doc-left upper bold"
	  }, [_vm._v("TITULAR")]), _vm._v(" "), _c('p', {
	    staticClass: "title-doc-right credit"
	  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "box-doc-right"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', {
	    staticClass: "three-dots margin-l5"
	  }, [_vm._v(_vm._s(_vm.nomeCliente) + "  ")]), _vm._v(" "), _c('p', {
	    staticClass: "three-dots margin-l5"
	  }, [_vm._v(_vm._s(_vm.contractId) + "  ")]), _vm._v(" "), _c('p', {
	    staticClass: "three-dots margin-l5"
	  }, [_vm._v(_vm._s(_vm.$route.params.orderId) + "  ")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', {
	    staticClass: "title-value-left upper bold"
	  }, [_vm._v("VOUCHER(s)")]), _vm._v(" "), _c('p', {
	    staticClass: "title-value-right"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, _vm._l((_vm.vouchers), function(v) {
	    return _c('p', {
	      key: v.voucher,
	      staticClass: "three-dots text-center bold value-receipt"
	    }, [_vm._v(_vm._s(v.voucher) + " - Status: " + _vm._s(v.descricao) + "  ")])
	  }), 0), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("   ")])])])]), _vm._v(" "), _c('div', [_c('p', [_c('b', [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("Para retirar o(s) TAG(s) você precisa  :")])], 1)]), _vm._v(" "), _c('p', [_c('b', [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("• Apresentar Voucher(s)")])], 1)]), _vm._v(" "), _c('p', [_c('b', [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("• Documento de identificação com foto")])], 1)]), _vm._v(" "), _c('p', [_c('b', [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("• Documento do veículo com número do RENAVAM")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('b', [_c('font', {
	    attrs: {
	      "color": "red"
	    }
	  }, [_vm._v("O cliente é responsável pela correta associação da placa e ativação do Tag, que será realizada no momento da retirada no parceiro.")])], 1)])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row hidden-print"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "margin-t20"
	  }, [_c('div', {
	    staticClass: "back-button-box"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n            Voltar\n          ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "action-buttons-box"
	  }, [_c('button', {
	    staticClass: "btn btn-back",
	    on: {
	      "click": function($event) {
	        return _vm.window.print()
	      }
	    }
	  }, [_vm._v("\n            Imprimir\n            "), _c('i', {
	    staticClass: "icon-printer align-icon-left"
	  })])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('img', {
	    staticClass: "logo-receipt",
	    attrs: {
	      "src": __webpack_require__(158),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('br'), _vm._v(" "), _c('h4', {
	    staticClass: "title-receipt"
	  }, [_vm._v("VOUCHER(S) PARA RETIRADA DE TAG(S) NOS PARCEIROS")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', {
	    staticClass: "title-toll-left upper bold"
	  }, [_vm._v("DADOS DA MOVE MAIS")]), _vm._v(" "), _c('p', {
	    staticClass: "title-toll-right"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticClass: "box-toll-left"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', {
	    staticClass: "three-dots bold text-right margin-r5"
	  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('p', {
	    staticClass: "three-dots bold text-right margin-r5"
	  }, [_vm._v("IE:")]), _vm._v(" "), _c('p', {
	    staticClass: "three-dots bold text-right margin-r5"
	  }, [_vm._v("WEB:")]), _vm._v(" "), _c('p', {
	    staticClass: "three-dots bold text-right margin-r5"
	  }, [_vm._v("E-MAIL:")]), _vm._v(" "), _c('p', {
	    staticClass: "three-dots bold text-right margin-r5"
	  }, [_vm._v("TEL:")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-toll-right"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', {
	    staticClass: "three-dots margin-l5"
	  }, [_vm._v("15.266.912/0001-87")]), _vm._v(" "), _c('p', {
	    staticClass: "three-dots margin-l5"
	  }, [_vm._v("206.318.529.117")]), _vm._v(" "), _c('p', {
	    staticClass: "three-dots margin-l5"
	  }, [_vm._v("www.movemais.com/#/contato")]), _vm._v(" "), _c('p', {
	    staticClass: "three-dots margin-l5"
	  }, [_vm._v("relacionamento@movemais.com")]), _vm._v(" "), _c('p', {
	    staticClass: "three-dots margin-l5"
	  }, [_vm._v("0800 777 1022/4000 2901(Capitais)")])])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-doc-left"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', {
	    staticClass: "three-dots bold text-right margin-r5"
	  }, [_vm._v("Nome do cliente:")]), _vm._v(" "), _c('p', {
	    staticClass: "three-dots bold text-right margin-r5"
	  }, [_vm._v("N° do Contrato:")]), _vm._v(" "), _c('p', {
	    staticClass: "three-dots bold text-right margin-r5"
	  }, [_vm._v("N° do Pedido:")])])])])
	}]}

/***/ }),
/* 2200 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container",
	    attrs: {
	      "id": "vehicles"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("Cliente Repom/Move Mais")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n        Identificamos que você é um cliente Repom/Move Mais!\n      ")]), _vm._v(" "), _c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n        Para atendimento, favor entrar em contato nos números abaixo:\n      ")]), _vm._v(" "), _vm._m(0)], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "line-height-20"
	  }, [_c('b', [_vm._v("0800 701 6744")]), _vm._v(" (Telefone Fixo)"), _c('br'), _vm._v(" "), _c('b', [_vm._v("11 4166 7500")]), _vm._v(" (Telefone Celular)"), _c('br'), _vm._v("\n        Atendimento 24 horas, 7 dias da semana\n      ")])
	}]}

/***/ }),
/* 2201 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-center"
	  }, [_c('h1', [_vm._v("\n    Favorecido:\n    "), _c('strong', [_vm._v(_vm._s(_vm.favored.company))])]), _vm._v(" "), _c('div', {
	    staticClass: "favored-mob"
	  }, [_c('b', [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.favored.cnpj)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.favored.company))]), _vm._v(" "), _c('p', [_vm._v("\n      Plano:\n      "), _c('strong', [_vm._v(_vm._s(_vm.favored.plan))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h1', {
	    staticClass: "bold"
	  }, [_vm._v("Qual o valor da transferência?")]), _vm._v(" "), (_vm.balance) ? _c('p', {
	    staticClass: "balance-mob"
	  }, [_vm._v("\n    Saldo disponível para transferência\n    "), _c('strong', [_vm._v(_vm._s(_vm._f("cents")(_vm.balance)))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "value-box"
	  }, [_c('input', {
	    staticClass: "form-control input-transfer-value",
	    attrs: {
	      "type": "text",
	      "name": "input-transfer-value",
	      "placeholder": "0,00",
	      "autofocus": "autofocus"
	    },
	    domProps: {
	      "value": _vm.getValue
	    },
	    on: {
	      "input": function($event) {
	        return _vm.setValue($event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.currentValue && !_vm.checkTransferValue) ? _c('div', {
	    staticClass: "values"
	  }, [_c('div', [_c('p', [_vm._v("Taxa (2%)")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("cents")(_vm.currentValue * 0.02)))])]), _vm._v(" "), _c('div', [_c('p', {
	    staticClass: "bold-600"
	  }, [_vm._v("Total")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("cents")(_vm.currentValue * 1.02)))])])]) : _vm._e()])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "ico-box"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/CarteiraEnvia.svg",
	      "alt": "",
	      "width": "90"
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "static/Transferencia_verde.png",
	      "alt": "",
	      "width": "90"
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "static/CarteiraEnvia.svg",
	      "alt": "",
	      "width": "90"
	    }
	  })])
	}]}

/***/ }),
/* 2202 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.activetagLoading),
	      expression: "activetagLoading",
	      modifiers: {
	        "opacity": true
	      }
	    }]
	  }, [_c('div', {}, [_c('div', {
	    staticClass: "inline plate-box"
	  }, [_c('p', {
	    staticClass: "cell-plate info-car"
	  }, [_c('span', [_vm._v(_vm._s(_vm.vehicle.plate))])])]), _vm._v(" "), _c('p', {
	    staticClass: "inline bold border-right-gray"
	  }, [_vm._v(_vm._s(_vm.vehicle.brandName))]), _vm._v(" "), (_vm.completeData) ? _c('p', {
	    staticClass: "inline bold margin-b0"
	  }, [_vm._v(_vm._s(_vm.vehicle.modelName))]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "tag-box"
	  }, [(!_vm.linkedTag) ? _c('div', [_c('label', {
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("N° TAG")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "only-numbers",
	      rawName: "v-only-numbers"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.serialNumber),
	      expression: "serialNumber"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "value": "",
	      "data-vv-rules": "required|numeric"
	    },
	    domProps: {
	      "value": (_vm.serialNumber)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.serialNumber = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "disabled": String(_vm.serialNumber).length == 0 || !_vm.serialNumber,
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.vincularTag()
	      }
	    }
	  }, [_vm._v("Ativar")])]) : (_vm.linkedTag == 'success') ? _c('div', {
	    staticClass: "alert alert-success"
	  }, [_c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("N° TAG: " + _vm._s(_vm.serialNumber))])]) : _c('div', [_c('div', {
	    staticClass: "alert alert-danger inline"
	  }, [_c('p', [_vm._v(_vm._s(_vm.msg))])]), _vm._v(" "), _c('button', {
	    staticClass: "no-btn",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.linkedTag = !_vm.linkedTag
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-repeat"
	  })])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2203 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "container-fluid"
	  }, [(_vm.aggregate) ? _c('div', {
	    staticClass: "content-box-npadd"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', [_vm._v("Dados do agregador e veículo")]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("Nome/Razão Social: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.companyName))])]), _vm._v(" "), _c('p', [_vm._v("CPF/CNPJ: "), _c('span', [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.aggregate.taxIdNumber)))])])]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("Placa: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.plate))])]), _vm._v(" "), _c('p', [_vm._v("TAG N°: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.tagSerialNumber))])]), _vm._v(" "), _c('p', [_vm._v("Modelo: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.nodelName))])]), _vm._v(" "), _c('p', [_vm._v("Marca: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.brandName))])]), _vm._v(" "), _c('p', [_vm._v("Eixos: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.category))])])]), _vm._v(" "), (!_vm.enableRNTRC) ? _c('div', {
	    staticStyle: {
	      "display": "flex",
	      "justify-content": "flex-end",
	      "margin": "15px 0"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-auto",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": _vm.showRNTRC
	    }
	  }, [_vm._v("\n            Alterar Transportador\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.msgError) ? _c('div', {
	    staticClass: "alert alert-danger alert-container"
	  }, [_c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("\n            " + _vm._s(_vm.msgError) + "\n          ")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.enableRNTRC) ? _c('div', {
	    staticClass: "col-xs-12 margin-b20n"
	  }, [_c('p', {
	    staticClass: "no-margin"
	  }), _c('div', {
	    staticClass: "content-box-npadd"
	  }, [_c('div', {
	    staticClass: "content-grey"
	  }, [_c('p', {
	    staticClass: "bold margin-t10 margin-b0"
	  }, [_vm._v("Dados do transportador")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "form-group input-box-control margin-t20"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rntrcOwnerName),
	      expression: "rntrcOwnerName"
	    }],
	    staticClass: "form-control small upper",
	    attrs: {
	      "autofocus": "autofocus",
	      "type": "text",
	      "name": "rntrcOwnerName"
	    },
	    domProps: {
	      "value": (_vm.rntrcOwnerName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.rntrcOwnerName = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group input-box-control",
	    class: {
	      'has-error': _vm.errors.has('rntrcDocument')
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "mask-cpf-cnpj",
	      rawName: "v-mask-cpf-cnpj"
	    }, {
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.rntrcDocument),
	      expression: "rntrcDocument",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cpfCnpj'),
	      expression: "'required|cpfCnpj'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2}|[0-9]{3}\\.[0-9]{3}\\.[0-9]{3}-[0-9]{2}|[0-9]{11})$",
	      "name": "rntrcDocument",
	      "data-vv-validate-on": "blur"
	    },
	    domProps: {
	      "value": (_vm.rntrcDocument)
	    },
	    on: {
	      "change": function($event) {
	        _vm.rntrcDocument = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('rntrcDocument')))])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "display": "flex",
	      "justify-content": "flex-end",
	      "margin-top": "15px",
	      "gap": "5px"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-back",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": _vm.cancelRNTRC
	    }
	  }, [_vm._v("\n                Cancelar\n              ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": _vm.validateDocument
	    }
	  }, [_vm._v("\n                Validar\n              ")])])])])]), _vm._v(" "), _c('p')]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', {
	    staticClass: "bold"
	  }, [_vm._v("Nome/Razão social:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', {
	    staticClass: "bold"
	  }, [_vm._v("CPF/CNPJ do RNTRC:")])])
	}]}

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "planInfoContainer"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "img-container"
	    }
	  }, [_c('div', {
	    staticClass: "img-plan",
	    attrs: {
	      "id": "img-plan-pf"
	    }
	  }, [_c('h3', {
	    attrs: {
	      "id": "img-plan-title"
	    }
	  }, [_vm._v("Pré-pago Manual")]), _vm._v(" "), _c('h3', {
	    attrs: {
	      "id": "img-plan-subtitle"
	    }
	  }, [_vm._v("\n        " + _vm._s("Pessoa Física") + "\n      ")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('h5', {
	    on: {
	      "click": function($event) {
	        return _vm.abrirModal()
	      }
	    }
	  }, [_vm._v("Tabela de recarga")])])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "card-info-container"
	    }
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": _vm.roadCardPF
	    }
	  }, [_vm._m(6)])]), _vm._v(" "), (_vm.showModal) ? _c('div', {
	    staticClass: "modalContainer"
	  }, [(_vm.showModal) ? _c('modal-recharge', {
	    on: {
	      "fechar-modal": _vm.fecharModal
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showModal) ? _c('div', {
	    staticClass: "overlay"
	  }) : _vm._e()], 1) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "info-desc-container"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(43)
	    }
	  }), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detalhe1PF"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "info-desc-container"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(43)
	    }
	  }), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detalhe2PF"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "info-desc-container"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(43)
	    }
	  }), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detalhe3PF"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "info-desc-container"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(43)
	    }
	  }), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detalhe4PF"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "info-desc-container"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(43)
	    }
	  }), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detalhe5PF"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "info-desc-container"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(43)
	    }
	  }), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "detalhe6PF"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "plan-button"
	    }
	  }, [_c('p', [_vm._v("Quero este plano")]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(509)
	    }
	  })])
	}]}

/***/ }),
/* 2205 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-fix"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-fix hidden"
	  }), _vm._v(" "), _c('range-map', {
	    on: {
	      "selected": function($event) {
	        _vm.selected = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "search margin-b20"
	  }, [_c('i', {
	    staticClass: "icon-search-input"
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search),
	      expression: "search"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "search",
	      "name": "search",
	      "placeholder": "Buscar concessionária"
	    },
	    domProps: {
	      "value": (_vm.search)
	    },
	    on: {
	      "keyup": _vm.filter,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.search = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "range-table"
	  }, [_c('table', {
	    staticClass: "table",
	    attrs: {
	      "role": "grid"
	    }
	  }, [_vm._m(1), _vm._v(" "), (_vm.pedagios) ? _c('tbody', [_vm._l((_vm.pedagios), function(concs, state) {
	    return [_c('tr', [_c('td', {
	      key: state,
	      attrs: {
	        "colspan": "5"
	      }
	    }, [_c('b', [_vm._v(_vm._s(state))])])]), _vm._v(" "), _vm._l((concs), function(peds, associateFinancialId) {
	      return _vm._l((peds), function(item, index) {
	        return _c('tr', [(index == 0) ? _c('td', {
	          staticClass: "col-dealership img-dealership",
	          attrs: {
	            "width": "",
	            "rowspan": peds.length
	          }
	        }, [_c('img', {
	          staticClass: "dealership",
	          attrs: {
	            "src": _vm.getImg(associateFinancialId)
	          }
	        })]) : _vm._e(), _vm._v(" "), _c('td', {
	          staticClass: "col-rod"
	        }, [_vm._v(_vm._s(item.roadCode))]), _vm._v(" "), _c('td', {
	          staticClass: "col-km"
	        }, [_vm._v(_vm._s(item.km))]), _vm._v(" "), _c('td', {
	          staticClass: "col-city"
	        }, [_vm._v(_vm._s(item.city))]), _vm._v(" "), _c('td', {
	          staticClass: "col-province"
	        }, [_vm._v(_vm._s(item.tipo))])])
	      })
	    })]
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.entriesKey) ? _c('tbody', [_vm._l((_vm.entriesKey), function(associate) {
	    return _vm._l((_vm.entries[associate]), function(item, index) {
	      return _c('tr', [(index == 0) ? _c('td', {
	        staticClass: "col-dealership img-dealership",
	        attrs: {
	          "width": "",
	          "rowspan": _vm.entries[associate].length
	        }
	      }, [_c('img', {
	        staticClass: "dealership",
	        attrs: {
	          "src": _vm.getImg(item.associateFinancialId)
	        }
	      })]) : _vm._e(), _vm._v(" "), _c('td', {
	        staticClass: "col-rod"
	      }, [_vm._v(_vm._s(item.roadCode))]), _vm._v(" "), _c('td', {
	        staticClass: "col-km"
	      }, [_vm._v(_vm._s(item.km))]), _vm._v(" "), _c('td', {
	        staticClass: "col-city"
	      }, [_vm._v(_vm._s(item.city))]), _vm._v(" "), _c('td', {
	        staticClass: "col-province"
	      }, [_vm._v(_vm._s(item.tipo))])])
	    })
	  })], 2) : _vm._e()])])]], 2)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("Cobertura")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('p', {
	    staticClass: "line-height-20"
	  }, [_vm._v("\n        Estamos presentes em 100% dos Estados com vias pedagiadas do Brasil. "), _c('br'), _vm._v(" Selecione o Estado:\n      ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "col-dealer"
	  }, [_vm._v("Concessionária")]), _vm._v(" "), _c('th', [_vm._v("Rod.")]), _vm._v(" "), _c('th', [_vm._v("KM")]), _vm._v(" "), _c('th', [_vm._v("Cidade")]), _vm._v(" "), _c('th', {
	    staticClass: "col-province"
	  }, [_vm._v("Adm.")])])])
	}]}

/***/ }),
/* 2206 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), (_vm.code == undefined) ? _c('div', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('ul', {
	    staticClass: "wizard margin-b20"
	  }, [_c('li', {
	    class: {
	      active: _vm.step == 0, past: _vm.step > 0
	    }
	  }, [_vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('li', {
	    class: {
	      active: _vm.step == 1, past: _vm.step > 1
	    }
	  }, [_c('div', {
	    staticClass: "icon-step"
	  }, [(_vm.isPJ) ? _c('i', {
	    staticClass: "icon-globe"
	  }) : _c('i', {
	    staticClass: "icon-avatar"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Etapa 2")]), _vm._v(" "), (_vm.isPJ) ? _c('small', {
	    staticClass: "no-margin"
	  }, [_vm._v("Dados da Empresa")]) : _c('small', {
	    staticClass: "no-margin"
	  }, [_vm._v("Seus dados")])])]), _vm._v(" "), _c('li', {
	    class: {
	      active: _vm.step == 2, past: _vm.step > 2
	    }
	  }, [_vm._m(3), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('li', {
	    class: {
	      active: _vm.step == 3, past: _vm.step > 3
	    }
	  }, [_vm._m(5), _vm._v(" "), _vm._m(6)])])])]), _vm._v(" "), (_vm.msgError) ? _c('div', {
	    staticClass: "alert alert-danger margin-b10",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Atenção!")]), _vm._v(" " + _vm._s(_vm.msgError) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.subtitle[_vm.step]))]), _vm._v(" "), (_vm.step == 0) ? [_c('choose-plan', {
	    ref: "choosePlan",
	    attrs: {
	      "contract": _vm.contract
	    }
	  })] : _vm._e(), _vm._v(" "), (_vm.step == 1) ? _c('company-data', {
	    ref: "userData",
	    attrs: {
	      "account": _vm.account,
	      "address": _vm.address
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('payment', {
	    ref: "payment",
	    staticClass: "margin-b20",
	    attrs: {
	      "payment": _vm.payment,
	      "planId": _vm.planId,
	      "addressMailing": _vm.address,
	      "creditCardOptions": _vm.creditCardOptions,
	      "tedOption": _vm.tedOption,
	      "docOption": _vm.docOption,
	      "bankAccountOptions": _vm.bankAccountOptions,
	      "bankBillOption": _vm.bankBillOption
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.step == 3) ? _c('summary-comp', {
	    ref: "summary",
	    attrs: {
	      "request": _vm.request,
	      "newAdhesionTax": _vm.newAdhesionTax,
	      "guaranteeTax": _vm.guaranteeTax,
	      "newVehicleTax": _vm.newVehicleTax,
	      "planName": _vm.planName,
	      "showRecharge": _vm.showRecharge,
	      "minValue": _vm.minValue
	    },
	    on: {
	      "goToStep": _vm.goToStep
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.success) ? _c('div', [(_vm.step != 0) ? _c('div', {
	    staticClass: "back-button-box"
	  }, [_c('button', {
	    staticClass: "btn btn-back",
	    on: {
	      "click": function($event) {
	        return _vm.backStep()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n          Voltar\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "action-buttons-box"
	  }, [_c('button', {
	    staticClass: "btn btn-danger",
	    on: {
	      "click": function($event) {
	        return _vm.cancelar()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-cancel align-icon-left-white"
	  }), _vm._v("\n          Cancelar\n        ")]), _vm._v(" "), (_vm.step < 3 && !(_vm.isCaminhoParana && _vm.step == 0)) ? _c('button', {
	    staticClass: "btn btn-purple add",
	    on: {
	      "click": function($event) {
	        return _vm.nextStep()
	      }
	    }
	  }, [_vm._v("\n          Avançar\n          "), _c('i', {
	    staticClass: "icon-circle-right align-icon-right-white"
	  })]) : _vm._e(), _vm._v(" "), (_vm.step == 3) ? _c('button', {
	    staticClass: "btn btn-success end",
	    on: {
	      "click": function($event) {
	        return _vm.doRequest()
	      }
	    }
	  }, [_vm._v("\n          Concluir\n          "), _c('i', {
	    staticClass: "icon-tick align-icon-right-white"
	  })]) : _vm._e()])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('success-page', {
	    attrs: {
	      "code": _vm.code,
	      "boletoUrl": _vm.boletoUrl,
	      "type": 'adhesion'
	    }
	  }), _vm._v(" "), _c('error-page', {
	    attrs: {
	      "code": _vm.code,
	      "stepPayment": 3,
	      "type": 'adhesion',
	      "taxIdNumber": _vm.account.taxIdNumber,
	      "password": _vm.account.accountAuthentication.password
	    },
	    on: {
	      "goToStep": _vm.goToStep
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("Adesão Move Mais")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-plans"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Etapa 1")]), _vm._v(" "), _c('small', {
	    staticClass: "no-margin"
	  }, [_vm._v("Plano e taxas")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-payment-methods"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Etapa 3")]), _vm._v(" "), _c('small', {
	    staticClass: "no-margin"
	  }, [_vm._v("Forma de pagamento")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-confirmation-check"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Etapa 4")]), _vm._v(" "), _c('small', {
	    staticClass: "no-margin"
	  }, [_vm._v("Resumo e confirmação")])])
	}]}

/***/ }),
/* 2207 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('form', [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group input-box-bank input-box-control"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('dropdown', {
	    staticClass: "dropdown-payment block margin-t5",
	    attrs: {
	      "options": _vm.options,
	      "value": _vm.selectOption,
	      "fieldValue": "paymentMethodId",
	      "fieldCaption": "name"
	    },
	    on: {
	      "itemSelected": _vm.onItemSelected
	    }
	  })], 1)]), _vm._v(" "), _c('div', {}, [_c('div', {
	    staticClass: "form-group margin-b30 input-box-control inline input-box-number",
	    class: {
	      'has-error': _vm.errors.has('agency')
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.bankAccount.agencyNumber),
	      expression: "bankAccount.agencyNumber"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:3'),
	      expression: "'required|min:3'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "agency",
	      "maxlength": "11"
	    },
	    domProps: {
	      "value": (_vm.bankAccount.agencyNumber)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.bankAccount, "agencyNumber", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('agency')) + "\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control inline input-box-adjunct",
	    class: {
	      'has-error': _vm.errors.has('accountNumber')
	    }
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.bankAccount.accountNumber),
	      expression: "bankAccount.accountNumber"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:3'),
	      expression: "'required|min:3'"
	    }, {
	      name: "only-numbers",
	      rawName: "v-only-numbers"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "accountNumber",
	      "maxlength": "20"
	    },
	    domProps: {
	      "value": (_vm.bankAccount.accountNumber)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.bankAccount, "accountNumber", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('accountNumber')) + "\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b30 input-box-control inline input-box-state",
	    class: {
	      'has-error': _vm.errors.has('accountDigit')
	    }
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.bankAccount.accountDigit),
	      expression: "bankAccount.accountDigit"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "only-numbers",
	      rawName: "v-only-numbers"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "accountDigit",
	      "maxlength": "3"
	    },
	    domProps: {
	      "value": (_vm.bankAccount.accountDigit)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.bankAccount, "accountDigit", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('accountDigit')) + "\n            ")])])]), _vm._v(" "), (_vm.bankAccount && _vm.bankAccount.paymentMethodId == 3) ? _c('div', {
	    staticClass: "alert alert-info margin-b10",
	    staticStyle: {
	      "margin-top": "1%"
	    }
	  }, [_c('strong', [_vm._v("Atenção cliente Itaú!")]), _c('br'), _vm._v("Não esqueça de autorizar a MOVE MAIS MEIOS DE PAGAMENTO LTDA a realizar débito automático em sua conta.\n          "), _c('br'), _vm._v(" "), _c('span', [_vm._v("  Para mais informações, entre em contato com a Central de Relacionamento pelo número 4000 2901 (regiões metropolitanas) ou 0800 777 1022 (demais localidades).")])]) : _vm._e()])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box-sm"
	  }, [_c('label', [_vm._v("Banco:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box-sm"
	  }, [_c('label', [_vm._v("Agência:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box-sm"
	  }, [_c('label', [_vm._v("Conta:*")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('label', [_vm._v("-")])])
	}]}

/***/ }),
/* 2208 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bg-for-you"
	  })
	},staticRenderFns: []}

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container",
	    attrs: {
	      "id": "vehicles"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("\n        Planos\n        "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Contrato " + _vm._s(_vm.contractId) + "\n        "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Veículos\n      ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "search"
	  }, [_c('div', {
	    staticClass: "search-cell"
	  }, [_c('i', {
	    staticClass: "icon-search-input"
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.plateOrObuid),
	      expression: "plateOrObuid"
	    }],
	    staticClass: "form-control input-search",
	    attrs: {
	      "type": "search",
	      "name": "",
	      "value": "",
	      "placeholder": "Digite a placa"
	    },
	    domProps: {
	      "value": (_vm.plateOrObuid)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.search.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.plateOrObuid = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary btn-search",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.search
	    }
	  }, [_vm._v("Buscar")])])]), _vm._v(" "), _c('br'), _c('div'), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 text-right"
	  }, [(_vm.contractActive) ? _c('router-link', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "to": {
	        name: 'contract-vehicles-new',
	        params: {
	          contractId: _vm.contractId
	        }
	      },
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-add-vehicle align-icon-left-white"
	  }), _vm._v("\n            Adicionar veículos\n          ")]) : _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.showMessageContract
	    }
	  }, [_c('i', {
	    staticClass: "icon-add-vehicle align-icon-left-white"
	  }), _vm._v("\n            Adicionar veículos\n          ")])], 1)]), _vm._v(" "), (_vm.state == 'LOADING') ? _c('div', {
	    staticClass: "margin-t20"
	  }, [_vm._v("\n        Carregando veículos. Aguarde...\n      ")]) : _vm._e(), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
	    staticClass: "alert alert-warning margin-t20"
	  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.data && _vm.data.itens && _vm.data.itens.length > 0) ? _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "margin-t20"
	  }, [_c('div', {
	    staticClass: "search point-line"
	  }, [(_vm.contractActive) ? _c('router-link', {
	    staticClass: "label-link pull-right",
	    attrs: {
	      "to": {
	        name: 'vehicles-p-to-p',
	        params: {
	          contractId: _vm.contractId
	        }
	      }
	    },
	    on: {
	      "click": _vm.search
	    }
	  }, [_vm._v("\n            Cadastrar veículos no sistema Ponto a Ponto\n          ")]) : _c('a', {
	    staticClass: "label-link pull-right",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": _vm.showMessageContract
	    }
	  }, [_vm._v("\n            Cadastrar veículos no sistema Ponto a Ponto\n          ")])], 1), _vm._v(" "), _vm._l((_vm.data.itens), function(vehicle, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "content-box vehicles margin-10"
	    }, [_c('div', {
	      staticClass: "newContainerStatusBox"
	    }, [_c('div', {
	      staticClass: "containerVehicleBox"
	    }, [_c('div', {
	      staticClass: "inline plate-box"
	    }, [_c('p', {
	      staticClass: "cell-plate info-car"
	    }, [_c('span', [_vm._v(_vm._s(vehicle.plate))])])]), _vm._v(" "), _c('div', {
	      staticClass: "inline tag-box"
	    }, [_c('p', {
	      staticClass: "no-margin bold"
	    }, [_vm._v("TAG N°")]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin"
	    }, [_vm._v(_vm._s(vehicle.tagSerialNumber || 'Não possui'))])]), _vm._v(" "), (/^\d$/.test(vehicle.plate.charAt(5))) ? _c('div', {
	      staticClass: "inline"
	    }, [_c('button', {
	      staticClass: "merc-button",
	      attrs: {
	        "alt": "ícone"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showSwitchPlate(vehicle.plate)
	        }
	      }
	    }, [_vm._v("Mudar para padrão Mercosul\n              "), _c('img', {
	      staticClass: "merc-icon",
	      attrs: {
	        "src": __webpack_require__(1775)
	      }
	    })])]) : _vm._e()]), _vm._v(" "), _c('div', {
	      staticClass: "inline vehicle-box"
	    }, [_c('p', {
	      staticClass: "no-margin bold"
	    }, [_vm._v(_vm._s(vehicle.brandName))]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin bold"
	    }, [_vm._v(_vm._s(_vm._f("firstWord")(vehicle.modelName)))]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin three-dots"
	    }, [_vm._v(_vm._s(_vm._f("fromSecWord")(vehicle.modelName)))])]), _vm._v(" "), _c('div', {
	      staticClass: "inline status-box"
	    }, [_c('p', {
	      staticClass: "no-margin"
	    }, [_c('span', {
	      class: _vm.getStatusClass(vehicle)
	    }), _vm._v("\n              " + _vm._s(_vm.getStatus(vehicle)) + "\n            ")]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin date-box"
	    }, [_c('i', {
	      staticClass: "icon-clock"
	    }), _vm._v(" " + _vm._s(_vm._f("dateTime")(vehicle.installDate || '00/00/0000 00:00')) + "\n              "), _c('i', {
	      staticClass: "icon-info",
	      attrs: {
	        "data-toggle": "tooltip",
	        "data-placement": "top",
	        "title": "Data da situação atual da TAG"
	      }
	    })]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin"
	    }, [_c('i', {
	      staticClass: "icon-axis"
	    }), _vm._v(" " + _vm._s(vehicle.catergoryAxesName))])]), _vm._v(" "), (_vm.isGrouper === true) ? _c('div', {
	      staticClass: "dropdown"
	    }, [_c('div', {
	      staticClass: "dropdown-select"
	    }, [_c('span', {
	      staticClass: "select"
	    }, [_vm._v(_vm._s(vehicle.nomeAgrupador ? vehicle.nomeAgrupador : "Selecione um Agrupador"))]), _vm._v(" "), _c('img', {
	      attrs: {
	        "width": "12px",
	        "src": __webpack_require__(499)
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "dropdown-list"
	    }, _vm._l((_vm.groupersOp), function(option) {
	      return _c('div', {
	        key: option.value,
	        staticClass: "dropdown-list-item",
	        attrs: {
	          "value": option.value
	        }
	      }, [_c('p', {
	        on: {
	          "click": function($event) {
	            return _vm.handleOptionChange(vehicle, option.value)
	          }
	        }
	      }, [_vm._v(_vm._s(option.caption))])])
	    }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "btn-group"
	    }, [_c('router-link', {
	      attrs: {
	        "to": {
	          name: 'vehicle-movement',
	          params: {
	            contractId: _vm.contractId,
	            vehicleId: vehicle.vehicleId
	          }
	        },
	        "tag": "a",
	        "data-toggle": "tooltip",
	        "title": "Movimentações do veículo"
	      }
	    }, [_c('div', {
	      staticClass: "btn btn-icon"
	    }, [_c('i', {
	      staticClass: "icon-place bold"
	    })])]), _vm._v(" "), (!_vm.showUnblock(vehicle)) ? _c('a', {
	      class: {
	        'link-disabled': !_vm.showBlock(vehicle)
	      },
	      attrs: {
	        "data-toggle": "tooltip",
	        "title": "Bloquear veículo temporariamente"
	      },
	      on: {
	        "click": function($event) {
	          _vm.vehicleToBlock = vehicle
	        }
	      }
	    }, [_vm._m(0, true)]) : _vm._e(), _vm._v(" "), (_vm.showUnblock(vehicle)) ? _c('a', {
	      class: {
	        'link-disabled': !_vm.showUnblock(vehicle)
	      },
	      attrs: {
	        "data-toggle": "tooltip",
	        "title": "Desbloquear veículo"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.unblockTag(vehicle)
	        }
	      }
	    }, [_vm._m(1, true)]) : _vm._e(), _vm._v(" "), _c('router-link', {
	      class: {
	        'link-disabled': !_vm.showReplace(vehicle)
	      },
	      attrs: {
	        "tag": "a",
	        "to": {
	          name: 'replace-tag',
	          params: {
	            contractId: _vm.contractId,
	            vehicleId: vehicle.vehicleId
	          }
	        },
	        "data-toggle": "tooltip",
	        "title": "Substituir TAG"
	      }
	    }, [_c('div', {
	      staticClass: "btn btn-icon"
	    }, [_c('i', {
	      staticClass: "icon-sync bold"
	    })])])], 1)])])
	  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 text-center"
	  }, [_c('pagination', {
	    attrs: {
	      "model": _vm.page
	    },
	    on: {
	      "page-change": _vm.setCurrentPage
	    }
	  })], 1)]), _vm._v(" "), (_vm.data && _vm.data.itens) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 result-table-count text-center"
	  }, [_vm._v("\n          Mostrando resultados de " + _vm._s(_vm.page.firstIndexShown()) + " a " + _vm._s(_vm.page.lastIndexShown()) + " de um total de " + _vm._s(_vm.page.itemCount()) + "\n          encontrados.\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [(_vm.exportError) ? _c('div', {
	    staticClass: "alert alert-danger",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.exportError) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.hasVehicles) ? _c('button', {
	    staticClass: "btn btn-default margin-10 pull-right",
	    attrs: {
	      "type": "button",
	      "disabled": _vm.exportingVehicles
	    },
	    on: {
	      "click": _vm.exportVehicles
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.exportingVehicles ? 'Exportando...' : 'Exportar Veículos') + "\n          ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-back margin-10",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n            Voltar\n          ")])], 1)])])]), _vm._v(" "), (_vm.vehicleToBlock) ? _c('div', {
	    staticClass: "modal fade in",
	    staticStyle: {
	      "display": "block",
	      "background": "rgba(230, 230, 230, 0.8)"
	    },
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loadingModal),
	      expression: "loadingModal"
	    }],
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header modal-info"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        _vm.vehicleToBlock = undefined
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Bloqueio Temporário da TAG")])]), _vm._v(" "), _c('form', [_c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errorMessage),
	      expression: "errorMessage"
	    }],
	    staticClass: "alert alert-danger margin-b20"
	  }, [_vm._v("\n              " + _vm._s(_vm.errorMessage) + "\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('reasonBlock')
	    }
	  }, [_vm._m(2), _vm._v(" "), _c('label', {
	    staticClass: "bold-600"
	  }, [_vm._v("Motivo do bloqueio:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.reasonBlock),
	      expression: "reasonBlock"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "resize": "none"
	    },
	    attrs: {
	      "name": "reasonBlock",
	      "cols": "35",
	      "rows": "3",
	      "maxlength": "200"
	    },
	    domProps: {
	      "value": (_vm.reasonBlock)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.reasonBlock = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('reasonBlock')))]), _vm._v(" "), _c('label', [_vm._v("Caracteres restantes " + _vm._s((200 - _vm.reasonBlock.length)) + ".")])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.cancelar()
	      }
	    }
	  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.blockTag()
	      }
	    }
	  }, [_vm._v("Bloquear")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showMercModal) ? _c('div', [_c('modal-switch-plate', {
	    attrs: {
	      "plateToConvert": _vm.plateToConvert
	    },
	    on: {
	      "fechar": function($event) {
	        return _vm.fecharModal()
	      },
	      "success": _vm.showSuccessModal,
	      "error": _vm.showErrorModal
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "overlay-new"
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.showSuccessConvertModal) ? _c('div', {
	    staticClass: "modalSucessMerc"
	  }, [_c('modal-sucess-merc', {
	    on: {
	      "fechar": function($event) {
	        return _vm.concluirSucesso()
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "overlay-new"
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.showModalErrorConvert) ? _c('div', {
	    staticClass: "modalErrorMerc"
	  }, [_c('modal-error-merc', {
	    on: {
	      "fechar": function($event) {
	        return _vm.concluirErro()
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "overlay-new"
	  })], 1) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "btn btn-icon"
	  }, [_c('i', {
	    staticClass: "icon-not-allowed bold"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "btn btn-icon"
	  }, [_c('i', {
	    staticClass: "icon-unlock bold"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', [_vm._v("É recomendado em situações onde deseja-se bloquear o veículo temporariamente, ex: ao enviar o veículo para oficina, sendo possível seu desbloqueio.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_vm._v("Pode levar até 6 horas para que aconteça o bloqueio em todas as praças de pedágios.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "alert alert-warning",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('i', {
	    staticClass: "icon-warning"
	  }), _vm._v(" Não isenta o pagamento de mensalidade.\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "alert alert-danger",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('i', {
	    staticClass: "icon-warning"
	  }), _vm._v(" Caso não possua mais o veículo, entre em contato com a central de atendimento e solicite o cancelamento da TAG.")]), _vm._v(" "), _c('br')])
	}]}

/***/ }),
/* 2210 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container",
	    attrs: {
	      "id": "vehicle-movement"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("Contrato " + _vm._s(_vm.contractId) + " "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Veículos "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Movimentação do veículo")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })], 1)]), _vm._v(" "), (_vm.vehicle) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "content-box margin-b20"
	  }, [_c('p', {
	    staticClass: "cell-plate border-right-gray info-car"
	  }, [_vm._v("\n          Placa\n          "), _c('span', [_vm._v(_vm._s(_vm.vehicle.plate))])]), _vm._v(" "), _c('p', {
	    staticClass: "border-right-gray info-car"
	  }, [_vm._v("Qtd. de eixos "), _c('b', [_vm._v(_vm._s(_vm.vehicle.categoryAxes.name))])]), _vm._v(" "), _c('p', {
	    staticClass: "border-right-gray info-car"
	  }, [_vm._v("Marca "), _c('b', [_vm._v(_vm._s(_vm.vehicle.model.brand.name))])]), _vm._v(" "), _c('p', {
	    staticClass: "model info-car"
	  }, [_vm._v("Modelo "), _c('b', {
	    attrs: {
	      "title": _vm.vehicle.model.name
	    }
	  }, [_vm._v(_vm._s(_vm.vehicle.model.name))])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-5"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "inline margin-side"
	  }, [_c('div', {
	    staticClass: "form-group form-inline",
	    class: {
	      'has-error': _vm.errors.has('dataInicial')
	    }
	  }, [_c('label', [_vm._v("De:")]), _vm._v(" "), _c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control picker",
	    attrs: {
	      "name": "dataInicial",
	      "format": "dd/MM/yyyy",
	      "language": "pt-br",
	      "data-vv-validate-on": "blur",
	      "data-vv-rules": "required"
	    },
	    model: {
	      value: (_vm.customStart),
	      callback: function($$v) {
	        _vm.customStart = $$v
	      },
	      expression: "customStart"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "inline margin-side"
	  }, [_c('div', {
	    staticClass: "form-group form-inline",
	    class: {
	      'has-error': _vm.errors.has('dataFinal')
	    }
	  }, [_c('label', [_vm._v("Até:")]), _vm._v(" "), _c('datepicker', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control picker",
	    attrs: {
	      "name": "dataFinal",
	      "format": "dd/MM/yyyy",
	      "language": "pt-br",
	      "data-vv-validate-on": "blur",
	      "data-vv-rules": "required"
	    },
	    model: {
	      value: (_vm.customEnd),
	      callback: function($$v) {
	        _vm.customEnd = $$v
	      },
	      expression: "customEnd"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "inline"
	  }, [_c('button', {
	    staticClass: "btn btn-purple btn-sm",
	    attrs: {
	      "type": "button",
	      "name": "btnFind"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.find(true)
	      }
	    }
	  }, [_vm._v("Filtrar")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [(_vm.searchState == 'ERROSEARCH') ? _c('div', {
	    staticClass: "alert alert-danger  margin-side",
	    staticStyle: {
	      "margin": "15px"
	    }
	  }, [_c('ol', [_c('li', [_vm._v(_vm._s(_vm.messageErro))])])]) : _vm._e(), _vm._v(" "), (!_vm.passages || _vm.passages.length == 0) ? _c('div', {
	    staticClass: "alert alert-warning  margin-side",
	    staticStyle: {
	      "margin": "15px"
	    }
	  }, [_vm._m(0)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-5"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "content-box margin-b20"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6 border-right-gray"
	  }, [_c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("Passagens "), _c('b', {
	    staticClass: "resume"
	  }, [_vm._v(_vm._s(_vm.totalPassages))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "no-margin"
	  }, [_vm._v("Total "), _c('b', {
	    staticClass: "resume"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.totalValue)))])])])])])])]), _vm._v(" "), [_c('div', {
	    staticClass: "table-white-header table-small-line",
	    staticStyle: {
	      "min-height": "100px"
	    }
	  }, [_c('table', {
	    staticClass: "table stripped-odd no-footer passagens",
	    attrs: {
	      "role": "grid"
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.passages), function(p) {
	    return _c('tr', {
	      on: {
	        "mouseenter": function($event) {
	          _vm.selection = p.maplinkId
	        },
	        "mouseleave": function($event) {
	          _vm.selection = undefined
	        }
	      }
	    }, [_c('td', [_vm._m(2, true), _vm._v(" "), _c('div', {
	      staticStyle: {
	        "padding-left": "15px"
	      }
	    }, [_vm._v("\n                  " + _vm._s(p.description) + "\n                ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTime")(p.occurrenceDate)))]), _vm._v(" "), _c('td', {
	      staticClass: "bold-600",
	      staticStyle: {
	        "color": "black",
	        "text-align": "right"
	      }
	    }, [_vm._v(_vm._s(_vm._f("cents")(p.value)))])])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 text-center"
	  }, [_c('pagination', {
	    attrs: {
	      "model": _vm.page
	    },
	    on: {
	      "page-change": _vm.setCurrentPage
	    }
	  })], 1)]), _vm._v(" "), (_vm.passages && _vm.passages.length > 0) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 result-table-count text-center"
	  }, [_vm._v("\n              Mostrando resultados de " + _vm._s(_vm.page.firstIndexShown()) + "\n              a " + _vm._s(_vm.page.lastIndexShown()) + " de um total de " + _vm._s(_vm.page.itemCount()) + "\n              encontrados.\n            ")])]) : _vm._e()])]], 2), _vm._v(" "), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('vehicle-map', {
	    attrs: {
	      "summary": _vm.summary,
	      "selection": _vm.selection
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back margin-t20",
	    attrs: {
	      "to": {
	        name: 'contract-vehicles',
	        params: {
	          id: _vm.contractId
	        }
	      },
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n        Voltar\n      ")])], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ol', [_c('li', [_vm._v("Nenhum registro encontrado")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', {
	    staticClass: "thead-invoice",
	    attrs: {
	      "role": "row"
	    }
	  }, [_c('th', {
	    staticStyle: {
	      "width": "51%"
	    }
	  }, [_vm._v("Local")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "30%"
	    }
	  }, [_vm._v("Data e hora")]), _vm._v(" "), _c('th', {
	    staticStyle: {
	      "width": "19%",
	      "text-align": "right"
	    }
	  }, [_vm._v("Valor (R$)")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pin-box"
	  }, [_c('div', {
	    staticClass: "pin-dot"
	  })])
	}]}

/***/ }),
/* 2211 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {}, [_c('p', {
	    staticClass: "aggregate-sub"
	  }, [_vm._v("Contato")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('email')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contact.email),
	      expression: "contact.email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "email",
	      "value": ""
	    },
	    domProps: {
	      "value": (_vm.contact.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contact, "email", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('cel')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "cel"
	    }
	  }, [_vm._v("Telefone celular")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "mask-tel",
	      rawName: "v-mask-tel"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cel),
	      expression: "cel"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|phone'),
	      expression: "'required|phone'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "celular",
	      "name": "celular",
	      "title": "celular",
	      "data-vv-validate-on": "blur",
	      "maxlength": "14"
	    },
	    domProps: {
	      "value": (_vm.cel)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.cel = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_vm._m(0), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "mask-tel",
	      rawName: "v-mask-tel"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tel),
	      expression: "tel"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('phone'),
	      expression: "'phone'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "telefone",
	      "name": "telefone",
	      "title": "telefone",
	      "data-vv-validate-on": "blur",
	      "maxlength": "14"
	    },
	    domProps: {
	      "value": (_vm.tel)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.tel = $event.target.value
	      }
	    }
	  })])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "phone"
	    }
	  }, [_vm._v("Telefone fixo "), _c('span', [_vm._v("(opcional)")])])
	}]}

/***/ }),
/* 2212 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "row color-row-4"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "txt-row-4"
	  }, [_c('h3', [_vm._v("Se você não quer se preocupar com recargas ou saldo insuficiente, este é o seu plano.")]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "to": "/adesao?planId=45",
	      "tag": "button"
	    }
	  }, [_vm._v("\n          Quero este plano!\n        ")])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back",
	    attrs: {
	      "to": "/sodre"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n        Voltar para planos\n      ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8 text-right padding-left-zero"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back",
	    attrs: {
	      "to": "/sodre"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n        Ver plano anterior\n      ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-back back-plan",
	    attrs: {
	      "to": "/sodre"
	    }
	  }, [_vm._v("\n        Ver próximo plano\n        "), _c('i', {
	    staticClass: "icon-circle-right align-icon-right"
	  })])], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("Serviços para Você")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-b10"
	  }, [_c('h3', {
	    staticClass: "bold upper"
	  }, [_vm._v("Plano Pré-pago Automático")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row color-row-1"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('div', {
	    staticClass: "txt-row-1"
	  }, [_c('span', [_vm._v("No "), _c('b', [_vm._v("PRÉ-PAGO AUTOMÁTICO")]), _vm._v(" você determina qual vai ser o valor da recarga automática (R$ 50,00 por exemplo), e toda vez que o seu saldo atingir 40% desse valor (no caso de R$ 50,00 será R$ 20,00), nós realizamos uma nova recarga automaticamente para você.")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "recharge-auto"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row color-row-2"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "payment-methods-confort"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "txt-row-2"
	  }, [_c('p', [_vm._v("A recarga automática é feita pela forma de pagamento que você cadastrou.")]), _vm._v(" "), _c('p', [_vm._v("Nossa taxa é a "), _c('b', [_vm._v("menor do mercado")]), _vm._v(" e quanto maior o valor da recarga menor é a porcentagem da taxa de recarga.")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row color-row-3"
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "txt-row-3"
	  }, [_c('span', [_vm._v("Você pode ainda consultar "), _c('b', [_vm._v("saldos")]), _vm._v(", "), _c('b', [_vm._v("extratos")]), _vm._v(" e "), _c('b', [_vm._v("geolocalização dos veículos")]), _vm._v(" diretamente no nosso site ou no app para mobile (Android e iOS).")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "gps-vehicle"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "confort-couch"
	  })])
	}]}

/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "modal fade modal-info-block",
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog",
	      "id": "valor-debitado"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-body"
	  }, [_vm._m(1), _vm._v(" "), _c('h4', {
	    staticClass: "valor-debitado-titulo"
	  }, [_vm._v("Informe o valor debitado na fatura do cartão " + _vm._s(_vm.numeroCartao))]), _vm._v(" "), _c('p', [_vm._v("Valor Debitado: ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.valorDebitado),
	      expression: "valorDebitado",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "mask-one-real",
	      rawName: "v-mask-one-real"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": " valor debitado"
	    },
	    domProps: {
	      "value": (_vm.valorDebitado)
	    },
	    on: {
	      "change": function($event) {
	        _vm.valorDebitado = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer buttons-container"
	  }, [_c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("Agora não")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.confirmCard()
	      }
	    }
	  }, [_vm._v("Confirmar")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal fade modal-info-block",
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog",
	      "id": "contrato-ativado"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-body"
	  }, [_c('h4', {
	    staticClass: "valor-debitado-titulo"
	  }, [_vm._v("Parabéns! Você conseguiu ativar o cartão " + _vm._s(_vm.numeroCartao) + ".")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [
	    [_c('button', {
	      staticClass: "btn btn-primary",
	      attrs: {
	        "type": "button",
	        "data-dismiss": "modal"
	      }
	    }, [_vm._v("OK")])]
	  ], 2)])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal fade modal-info-block",
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog",
	      "id": "erro-debito"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-body"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(497),
	      "alt": ""
	    }
	  }), _vm._v(" "), (_vm.erroDebito == 1) ? _c('h4', {
	    staticClass: "text-danger"
	  }, [_vm._v(_vm._s(_vm.msgErro))]) : _vm._e(), _vm._v(" "), (_vm.erroDebito == 2) ? _c('h4', {
	    staticClass: "text-danger"
	  }, [_vm._v("Valor informado incorreto, gerando descontinuidade no seu cadastro.")]) : _vm._e(), _vm._v(" "), (_vm.erroDebito == 2) ? _c('h4', {
	    staticClass: "text-danger"
	  }, [_vm._v("Favor realizar o cadastro novamente. O valor descontado será estornado na sua fatura.")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [
	    [_c('button', {
	      staticClass: "btn btn-primary",
	      attrs: {
	        "type": "button",
	        "data-dismiss": "modal"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.confirmaErro()
	        }
	      }
	    }, [_vm._v("OK")])]
	  ], 2)])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 plan-desk"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title title-plans"
	  }, [_vm._v("Planos")]), _vm._v(" "), (_vm.state == 'LOADED') ? _c('div', [_c('router-link', {
	    staticClass: "btn btn-primary btn-new-plan",
	    class: {
	      'disabled': !_vm.checkVehicle
	    },
	    attrs: {
	      "tag": "button",
	      "to": {
	        name: 'new-contract'
	      },
	      "disabled": !_vm.checkVehicle || _vm.bloqueiaRoadcard
	    }
	  }, [_c('i', {
	    staticClass: "icon-plus icon-plus-plan align-icon-right-sm"
	  }), _vm._v(" "), _c('span', [_vm._v("Novo Plano")])]), _vm._v(" "), _c('button', {
	    staticClass: "btn-merc",
	    on: {
	      "click": function($event) {
	        return _vm.openMyContractsModal()
	      }
	    }
	  }, [_vm._m(2), _vm._v(" "), _vm._m(3)])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 min-content"
	  }, [(_vm.state == 'LOADING') ? void 0 : _vm._e(), _vm._v(" "), (_vm.state == 'ERROR') ? [_c('div', {
	    staticClass: "error-block"
	  }, [_vm._v("Houve um erro carregando os contratos. Por favor, aguarde e tente novamente. ")])] : _vm._e(), _vm._v(" "), (_vm.vp) ? _c('accordion', {
	    staticClass: "margin-t20 vp-accordion",
	    attrs: {
	      "open": true
	    }
	  }, [_c('template', {
	    slot: "header"
	  }, [_c('span', {
	    staticClass: "upper bold"
	  }, [_vm._v("Vale-pedágio")])]), _vm._v(" "), _c('template', {
	    slot: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('table', {
	    staticClass: "table table-striped table-vp"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("No. Vale-pedágio")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "30%"
	    }
	  }, [_vm._v("Emissor")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "15%"
	    }
	  }, [_vm._v("Data expiração")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
	    staticClass: "text-right",
	    attrs: {
	      "width": "15%"
	    }
	  }, [_vm._v("Valor VP")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.vp), function(v, index) {
	    return _c('tr', {
	      key: index,
	      class: {
	        red: v.idProtocoloCanc != null
	      }
	    }, [(index < 6) ? [_c('td', [_vm._v(_vm._s(v.idProtocolo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(v.embarcador))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(v.expirationVP)))]), _vm._v(" "), _c('td', {
	      staticClass: "bold text-center"
	    }, [_vm._v(_vm._s(_vm._f("formatPlate")(v.placaVeiculo)))]), _vm._v(" "), _c('td', {
	      staticClass: "text-right"
	    }, [_vm._v(_vm._s(_vm._f("cents")(v.valorVP)))])] : _vm._e()], 2)
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "flex action-buttons margin-t10"
	  }, [_c('router-link', {
	    staticClass: "btn-act",
	    attrs: {
	      "to": {
	        name: 'my-toll-ticket',
	        params: {
	          contractId: _vm.vp[0].contratoDest,
	          planId: 7
	        }
	      },
	      "tag": "button"
	    }
	  }, [_vm._v("\r\n                          Ver Todos Vales-pedágio\r\n                        ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn-act",
	    attrs: {
	      "to": {
	        name: 'statement-consolidated',
	        params: {
	          contractId: _vm.vp[0].contratoDest
	        }
	      },
	      "tag": "button"
	    }
	  }, [_vm._v("\r\n                          Saldo & Extrato\r\n                        ")])], 1)])])])], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.contracts), function(c, n) {
	    return (_vm.state == 'LOADED' && c.plan.planId != 7) ? [((c.plan.planId == 21 || c.plan.planId == 22 || c.plan.planId == 35 || c.plan.planId == 36) && _vm.checkVehicle) ? _c('modal-transfer', {
	      key: n
	    }) : _vm._e(), _vm._v(" "), (c.plan.planId == 45 || c.plan.planId == 46) ? _c('accordion', {
	      key: n,
	      staticClass: "margin-t20 vp-accordion aggregate-acc",
	      attrs: {
	        "open": true
	      }
	    }, [_c('template', {
	      slot: "header"
	    }, [_c('contract-name', {
	      attrs: {
	        "contractId": c.contractId,
	        "planId": c.plan.planId,
	        "contractName": c.name,
	        "currentBalance": c.currentBalance.currentTotalBalance
	      },
	      model: {
	        value: (c.name),
	        callback: function($$v) {
	          _vm.$set(c, "name", $$v)
	        },
	        expression: "c.name"
	      }
	    })], 1), _vm._v(" "), _c('template', {
	      slot: "content"
	    }, [_c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col-xs-12"
	    }, [_c('div', {
	      staticClass: "vp-card-box"
	    }, [_c('div', {
	      staticClass: "vp-card-info"
	    }, [_c('small', [_vm._v("Saldo")]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin green"
	    }, [_vm._v(_vm._s(_vm._f("cents")(c.currentBalance.currentTotalBalance)))])]), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-redeem-balance",
	      attrs: {
	        "to": {
	          name: 'rescue-balance',
	          params: {
	            contractId: c.contractId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_c('i', {
	      staticClass: "icomoon-rescue"
	    }), _vm._v("\r\n                            Resgatar saldo\r\n                          ")]), _vm._v(" "), _c('button', {
	      staticClass: "btn-new-vp",
	      attrs: {
	        "type": "button",
	        "name": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.modalTollTicket()
	        }
	      }
	    }, [_c('i', {
	      staticClass: "icon-plus ie"
	    }), _vm._v("\r\n                            Novo VP\r\n                          ")]), _vm._v(" "), _c('button', {
	      staticClass: "btn-new-aggregate",
	      attrs: {
	        "type": "button",
	        "name": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.modalAggregate(c)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "icon-plus ie"
	    }), _vm._v("\r\n                            Novo Agregador\r\n                          ")])], 1), _vm._v(" "), (!_vm.loadingVehiclesAggregate && _vm.aggregateVehicles) ? _c('table', {
	      staticClass: "table table-striped table-vp"
	    }, [_c('thead', [_c('tr', [_c('th', {
	      staticClass: "text-center",
	      attrs: {
	        "width": "15%"
	      }
	    }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
	      staticClass: "text-center",
	      attrs: {
	        "width": "10%"
	      }
	    }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
	      attrs: {
	        "width": "35%"
	      }
	    }, [_vm._v("Transportador")]), _vm._v(" "), _c('th', {
	      staticClass: "text-center",
	      attrs: {
	        "width": "10%"
	      }
	    }, [_vm._v("Último VP")]), _vm._v(" "), _c('th', {
	      staticClass: "text-center",
	      attrs: {
	        "width": "10%"
	      }
	    }, [_vm._v("Última passagem")]), _vm._v(" "), _c('th', {
	      staticClass: "text-right",
	      attrs: {
	        "width": "10%"
	      }
	    }, [_vm._v("Saldo VP")]), _vm._v(" "), _c('th', {
	      staticClass: "text-center",
	      attrs: {
	        "width": "7%"
	      }
	    }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.aggregateVehicles), function(v, index) {
	      return _c('tr', {
	        key: index,
	        class: {
	          red: v.idProtocoloCanc != null
	        }
	      }, [(index < 6) ? [_c('td', {
	        staticClass: "text-center bold td-plate"
	      }, [_c('span', [_vm._v(_vm._s(v.plate))]), _vm._v(" "), _c('span', {
	        staticClass: "hide"
	      }, [_vm._v(_vm._s(v.contractIdAgr))]), _vm._v(" "), _c('span', {
	        staticClass: "hide"
	      }, [_vm._v(_vm._s(v.contractIdVp))])]), _vm._v(" "), _c('td', {
	        staticClass: "ico-info text-center"
	      }, [(v.reason == 'Desbloqueado') ? _c('i', {
	        staticClass: "icomoon-truck-ok text-center"
	      }) : (v.reason == 'Temporariamente') ? _c('i', {
	        staticClass: "icomoon-truck-block text-center"
	      }) : [_vm._v(_vm._s(v.reason))]], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(v.transportador))]), _vm._v(" "), _c('td', {
	        staticClass: "text-center"
	      }, [_vm._v(_vm._s(_vm._f("date")(v.lastVp)))]), _vm._v(" "), _c('td', {
	        staticClass: "text-center"
	      }, [_vm._v(_vm._s(_vm._f("date")(v.lastPassage)))]), _vm._v(" "), _c('td', {
	        staticClass: "text-right"
	      }, [_vm._v("\r\n                                  " + _vm._s(_vm._f("cents")(v.saldoVp)) + "\r\n                                  "), _c('span', {
	        staticClass: "hide"
	      }, [_vm._v(_vm._s(v.transferValue))]), _vm._v(" "), _c('span', {
	        staticClass: "hide"
	      }, [_vm._v(_vm._s(v.taxValue))])]), _vm._v(" "), _c('td', {
	        staticClass: "text-center"
	      }, [_c('div', {
	        staticClass: "dropdown drop-actions"
	      }, [_c('button', {
	        staticClass: "no-btn",
	        attrs: {
	          "id": "",
	          "type": "button",
	          "data-toggle": "dropdown",
	          "aria-haspopup": "true",
	          "aria-expanded": "false"
	        }
	      }, [_c('img', {
	        attrs: {
	          "src": "/static/icon-actions.svg",
	          "alt": ""
	        }
	      })]), _vm._v(" "), _c('ul', {
	        staticClass: "dropdown-menu",
	        attrs: {
	          "aria-labelledby": ""
	        }
	      }, [(v.saldoVp > 0) ? _c('li', [_c('a', {
	        on: {
	          "click": function($event) {
	            _vm.showRescue = true;
	            _vm.rescueBalance(v)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "icomoon-rescue"
	      }), _vm._v("\r\n                                          Resgatar saldo VP\r\n                                        ")])]) : _vm._e(), _vm._v(" "), (v.tagSerialNumber) ? _c('li', [_c('a', {
	        on: {
	          "click": function($event) {
	            _vm.typeAggregate = 'replace';
	            _vm.modalBlock(v)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "icon-sync"
	      }), _vm._v("\r\n                                          Substituir TAG\r\n                                        ")])]) : _vm._e(), _vm._v(" "), _c('li', {
	        staticClass: "divider",
	        attrs: {
	          "role": "separator"
	        }
	      }), _vm._v(" "), _c('li', [(!_vm.showUnblock(v)) ? _c('a', {
	        on: {
	          "click": function($event) {
	            _vm.typeAggregate = 'block';
	            _vm.modalBlock(v)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "icomoon-blocked"
	      }), _vm._v("\r\n                                          Bloquear veículo\r\n                                        ")]) : _vm._e()]), _vm._v(" "), _c('li', [(_vm.showUnblock(v)) ? _c('a', {
	        on: {
	          "click": function($event) {
	            _vm.typeAggregate = 'unblock';
	            _vm.modalBlock(v)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "icomoon-blocked"
	      }), _vm._v("\r\n                                          Desbloquear veículo\r\n                                        ")]) : _vm._e()]), _vm._v(" "), _c('li', [_c('a', {
	        on: {
	          "click": function($event) {
	            _vm.typeAggregate = 'delete';
	            _vm.modalBlock(v)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "icomoon-delete"
	      }), _vm._v("\r\n                                          Excluir veículo\r\n                                        ")])])])])])] : _vm._e()], 2)
	    }), 0)]) : (_vm.loadingVehiclesAggregate) ? _c('p', [_vm._v("Carregando...")]) : (!_vm.aggregateVehicles && !_vm.loadingVehiclesAggregate) ? _c('div', {
	      staticClass: "alert alert-warning alert-container margin-b20"
	    }, [_c('p', {
	      staticClass: "no-margin"
	    }, [_vm._v("\r\n                            Nenhum veículo encontrado para o contrato.\r\n                          ")])]) : _vm._e(), _vm._v(" "), (_vm.aggregateVehicles) ? _c('div', {
	      staticClass: "pagination-vp"
	    }, [_c('p', {
	      staticClass: "inline no-margin"
	    }, [_vm._v("\r\n                            " + _vm._s(_vm.pageSm.firstIndexShown()) + "-" + _vm._s(_vm.pageSm.lastIndexShown()) + " itens de " + _vm._s(_vm.pageSm.itemCount()) + " -\r\n                            "), _c('router-link', {
	      staticClass: "bold",
	      attrs: {
	        "to": {
	          name: 'aggregate-list',
	          params: {
	            contractId: c.contractId,
	            fullResult: true
	          }
	        },
	        "tag": "a"
	      }
	    }, [_vm._v("\r\n                              ver todos\r\n                              "), _c('img', {
	      attrs: {
	        "src": __webpack_require__(227),
	        "alt": ""
	      }
	    })])], 1), _vm._v(" "), _c('div', {
	      staticClass: "pull-right inline"
	    }, [_c('pagination-sm', {
	      attrs: {
	        "model": _vm.pageSm
	      },
	      on: {
	        "page-change": _vm.setCurrentPage
	      }
	    })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "flex action-buttons margin-t10"
	    }, [_c('router-link', {
	      staticClass: "btn-act button-icomoon",
	      attrs: {
	        "to": {
	          name: 'contract-statement',
	          params: {
	            contractId: c.contractId,
	            planId: c.plan.planId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_vm._v("\r\n                            Extrato\r\n                          ")]), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-act button-icomoon",
	      attrs: {
	        "to": {
	          name: 'contract-detail',
	          params: {
	            contractId: c.contractId,
	            planId: c.plan.planId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_vm._v("\r\n                            Mais Detalhes do Plano\r\n                          ")]), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-act button-icomoon",
	      attrs: {
	        "to": {
	          name: 'aggregate-list',
	          params: {
	            contractId: c.contractId,
	            moveMaisId: _vm.currentUser.moveMaisId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_vm._v("\r\n                            Veículos cadastrados\r\n                          ")]), _vm._v(" "), _c('a', {
	      staticClass: "btn-act button-icomoon btn-debitos-veiculares",
	      staticStyle: {
	        "white-space": "nowrap"
	      },
	      attrs: {
	        "href": "https://www.zignet.com.br/parceiro/movemais-interno",
	        "target": "_blank",
	        "rel": "noopener noreferrer"
	      }
	    }, [_vm._v("\r\n                            Débitos veiculares\r\n                          ")])], 1)])])])], 2) : _c('accordion', {
	      key: 'accordion' + n,
	      staticClass: "margin-t20",
	      attrs: {
	        "open": n == 0
	      }
	    }, [_c('template', {
	      slot: "header"
	    }, [_c('contract-name', {
	      attrs: {
	        "contractId": c.contractId,
	        "planId": c.plan.planId,
	        "contractName": c.name,
	        "currentBalance": c.currentBalance.currentTotalBalance
	      },
	      model: {
	        value: (c.name),
	        callback: function($$v) {
	          _vm.$set(c, "name", $$v)
	        },
	        expression: "c.name"
	      }
	    })], 1), _vm._v(" "), _c('template', {
	      slot: "content"
	    }, [(c.dashType == 'EMBARCADOR-PRE') ? _c('div', {
	      staticClass: "accordion-shipper"
	    }, [_c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col-xs-12"
	    }, [_c('div', {
	      staticClass: "flex info"
	    }, [_c('p', {
	      staticClass: "no-margin inline"
	    }, [_vm._v("\r\n                              Plano:\r\n                              "), _c('span', {
	      staticClass: "bold upper"
	    }, [_vm._v(_vm._s(c.dashType))])]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin inline"
	    }, [_vm._v("\r\n                              Saldo disponível:\r\n                              "), _c('span', {
	      staticClass: "bold upper",
	      style: (c.currentBalance.currentBalance >= 0 ? 'color: #61A60E' : 'color: #FC4513')
	    }, [_vm._v(_vm._s(_vm._f("cents")(c.currentBalance.currentTotalBalance)))])])]), _vm._v(" "), _c('div', {
	      staticClass: "flex between"
	    }, [_c('router-link', {
	      staticClass: "btn-tile credit",
	      attrs: {
	        "tag": "button",
	        "to": {
	          name: 'contract-recharge',
	          params: {
	            contractId: c.contractId,
	            planId: c.plan.planId
	          }
	        },
	        "data-toggle": "tooltip",
	        "data-placement": "bottom"
	      }
	    }, [_vm._v("\r\n                              Comprar Crédito\r\n                              "), _c('i', {
	      staticClass: "icon-share-money"
	    })]), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-tile route",
	      attrs: {
	        "tag": "button",
	        "to": {
	          name: 'routes'
	        }
	      }
	    }, [_vm._v("\r\n                              Gestão de Rotas\r\n                              "), _c('i', {
	      staticClass: "icon-route-chrono"
	    })]), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-tile toll",
	      attrs: {
	        "tag": "button",
	        "to": {
	          name: 'toll-ticket',
	          params: {
	            contractId: c.contractId
	          }
	        }
	      }
	    }, [_vm._v("\r\n                              Vale-pedágio\r\n                              "), _c('i', {
	      staticClass: "icon-toll-ticket"
	    })]), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-tile accomp",
	      attrs: {
	        "tag": "button",
	        "to": {
	          name: 'accompaniment',
	          params: {
	            contractId: c.contractId
	          }
	        }
	      }
	    }, [_vm._v("\r\n                              Acompanhamento\r\n                              "), _c('i', {
	      staticClass: "icon-truck-zoom"
	    })]), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-tile transfer",
	      attrs: {
	        "tag": "button",
	        "to": {
	          name: 'transfer-shipper',
	          params: {
	            contract: c
	          }
	        },
	        "data-toggle": "tooltip",
	        "data-placement": "bottom"
	      }
	    }, [_vm._v("\r\n                              Transferir Crédito\r\n                              "), _c('i', {
	      staticClass: "icon-money-transfer"
	    })])], 1), _vm._v(" "), (_vm.embarcadorVpPre && _vm.embarcadorVpPre.length > 0) ? _c('table', {
	      staticClass: "table table-striped table-vp"
	    }, [_c('thead', [_c('tr', [_c('th', {
	      attrs: {
	        "width": "15%"
	      }
	    }, [_vm._v("No. Vale-pedágio")]), _vm._v(" "), _c('th', {
	      attrs: {
	        "width": "30%"
	      }
	    }, [_vm._v("Transportador")]), _vm._v(" "), _c('th', {
	      staticClass: "text-center",
	      attrs: {
	        "width": "14%"
	      }
	    }, [_vm._v("Data emissão")]), _vm._v(" "), _c('th', {
	      staticClass: "text-center",
	      attrs: {
	        "width": "14%"
	      }
	    }, [_vm._v("Data expiração")]), _vm._v(" "), _c('th', {
	      staticClass: "text-center",
	      attrs: {
	        "width": "10%"
	      }
	    }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
	      staticClass: "text-right",
	      attrs: {
	        "width": "10%"
	      }
	    }, [_vm._v("Valor VP")]), _vm._v(" "), _c('th', {
	      staticClass: "text-center",
	      attrs: {
	        "width": "7%"
	      }
	    }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.embarcadorVpPre), function(v, index) {
	      return _c('tr', {
	        key: index,
	        class: {
	          red: v.idProtocoloCanc != null
	        }
	      }, [(index < 6) ? [_c('td', [_vm._v(_vm._s(v.idProtocolo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(v.transportador))]), _vm._v(" "), _c('td', {
	        staticClass: "text-center"
	      }, [_vm._v(_vm._s(_vm._f("date")(v.dataEmissao)))]), _vm._v(" "), _c('td', {
	        staticClass: "text-center"
	      }, [_vm._v(_vm._s(_vm._f("date")(v.expirationVP)))]), _vm._v(" "), _c('td', {
	        staticClass: "bold text-center"
	      }, [_vm._v(_vm._s(_vm._f("formatPlate")(v.placaVeiculo)))]), _vm._v(" "), _c('td', {
	        staticClass: "text-right"
	      }, [_vm._v(_vm._s(_vm._f("cents")(v.valorVP)))]), _vm._v(" "), _c('td', {
	        staticClass: "text-center"
	      }, [_c('div', {
	        staticClass: "dropdown drop-actions"
	      }, [_c('button', {
	        staticClass: "no-btn",
	        attrs: {
	          "id": "",
	          "type": "button",
	          "data-toggle": "dropdown",
	          "aria-haspopup": "true",
	          "aria-expanded": "false"
	        }
	      }, [_c('img', {
	        attrs: {
	          "src": "/static/icon-actions.svg",
	          "alt": ""
	        }
	      })]), _vm._v(" "), _c('ul', {
	        staticClass: "dropdown-menu",
	        attrs: {
	          "aria-labelledby": ""
	        }
	      }, [_c('li', [_c('a', {
	        on: {
	          "click": function($event) {
	            _vm.showReceiptVp = true;
	            _vm.modalReceiptVp(v.contractIdVp, v.idIntern)
	          }
	        }
	      }, [_c('img', {
	        attrs: {
	          "src": "/static/icon-eye.svg",
	          "alt": "icon eye"
	        }
	      }), _vm._v("\r\n                                            Visualizar/Imprimir\r\n                                          ")])]), _vm._v(" "), _c('li', [_c('a', {
	        on: {
	          "click": function($event) {
	            _vm.showRouteVp = true;
	            _vm.modalRouteVp(v.contractIdVp, v.idIntern)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "icomoon-truck-zoom_gray"
	      }), _vm._v("\r\n                                            Rota do VP\r\n                                          ")])]), _vm._v(" "), _c('li', [_c('a', {
	        on: {
	          "click": function($event) {
	            _vm.showPrintVp = true;
	            _vm.modalPrintVp(v)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "icomoon-file-export-gray"
	      }), _vm._v("\r\n                                            Comprovante VP\r\n                                          ")])]), _vm._v(" "), _c('li', [_c('a', {
	        on: {
	          "click": function($event) {
	            return _vm.cancelarVP(v.idIntern, v.placaVeiculo, 'pre')
	          }
	        }
	      }, [_c('i', {
	        staticClass: "icomoon-close",
	        staticStyle: {
	          "font-size": "14px"
	        }
	      }), _vm._v("\r\n                                              Cancelar VP\r\n                                            ")])])])])])] : _vm._e()], 2)
	    }), 0)]) : _c('div', {
	      staticClass: "alert alert-warning alert-container margin-b20"
	    }, [_c('p', {
	      staticClass: "no-margin"
	    }, [_vm._v("\r\n                              Nenhum vale-pedágio encontrado para o contrato em questão.\r\n                            ")])]), _vm._v(" "), (_vm.embarcadorVpPre && _vm.embarcadorVpPre.length > 0) ? _c('div', {
	      staticClass: "pagination-vp margin-b10"
	    }, [_c('p', {
	      staticClass: "inline no-margin"
	    }, [_vm._v("\r\n                              " + _vm._s(_vm.pageSmVpPre.firstIndexShown()) + "-" + _vm._s(_vm.pageSmVpPre.lastIndexShown()) + " itens de " + _vm._s(_vm.pageSmVpPre.itemCount()) + " -\r\n                              "), _c('router-link', {
	      staticClass: "bold",
	      attrs: {
	        "to": {
	          name: 'accompaniment',
	          params: {
	            contractId: c.contractId
	          }
	        },
	        "tag": "a"
	      }
	    }, [_vm._v("\r\n                                ver todos\r\n                                "), _c('img', {
	      attrs: {
	        "src": __webpack_require__(227),
	        "alt": ""
	      }
	    })])], 1), _vm._v(" "), _c('div', {
	      staticClass: "pull-right inline"
	    }, [_c('pagination-sm', {
	      attrs: {
	        "model": _vm.pageSmVpPre
	      },
	      on: {
	        "page-change": _vm.setCurrentPageVpPre
	      }
	    })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "flex action-buttons"
	    }, [_c('router-link', {
	      staticClass: "btn-act",
	      attrs: {
	        "to": {
	          name: 'contract-statement',
	          params: {
	            contractId: c.contractId,
	            planId: c.plan.planId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_vm._v("\r\n                              Extrato\r\n                            ")]), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-act button-icomoon",
	      attrs: {
	        "to": {
	          name: 'invoice-history',
	          params: {
	            contractId: c.contractId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_vm._v("\r\n                              Histórico de Contas\r\n                            ")]), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-act",
	      attrs: {
	        "to": {
	          name: 'contract-detail',
	          params: {
	            contractId: c.contractId,
	            planId: c.plan.planId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_vm._v("\r\n                              Mais Detalhes do Plano \r\n                            ")])], 1)])])]) : _vm._e(), _vm._v(" "), (c.dashType == 'EMBARCADOR-POS') ? _c('div', {
	      staticClass: "accordion-shipper"
	    }, [_c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col-xs-12"
	    }, [_c('div', {
	      staticClass: "flex info"
	    }, [_c('p', {
	      staticClass: "no-margin inline"
	    }, [_vm._v("\r\n                                Plano:\r\n                                "), _c('span', {
	      staticClass: "bold upper"
	    }, [_vm._v(_vm._s(c.dashType))])]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin inline"
	    }, [_vm._v("\r\n                                Crédito:\r\n                                "), _c('span', {
	      staticClass: "bold upper"
	    }, [_vm._v(_vm._s(_vm._f("cents")(c.currentBalance.currentTotalBalance)))])]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin inline"
	    }, [_vm._v("\r\n                                Limite disponível:\r\n                                "), _c('span', {
	      staticClass: "bold upper"
	    }, [_vm._v(_vm._s(_vm._f("cents")(c.currentBalance.currentTotalBalance)))])])]), _vm._v(" "), _c('div', {
	      staticClass: "flex between"
	    }, [_c('router-link', {
	      staticClass: "btn-tile route",
	      attrs: {
	        "tag": "button",
	        "to": {
	          name: 'routes'
	        }
	      }
	    }, [_vm._v("\r\n                                Gestão de Rotas\r\n                                "), _c('i', {
	      staticClass: "icon-route-chrono"
	    })]), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-tile toll",
	      attrs: {
	        "tag": "button",
	        "to": {
	          name: 'toll-ticket',
	          params: {
	            contractId: c.contractId
	          }
	        }
	      }
	    }, [_vm._v("\r\n                                Vale-pedágio\r\n                                "), _c('i', {
	      staticClass: "icon-toll-ticket"
	    })]), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-tile accomp",
	      attrs: {
	        "tag": "button",
	        "to": {
	          name: 'accompaniment',
	          params: {
	            contractId: c.contractId
	          }
	        }
	      }
	    }, [_vm._v("\r\n                                Acompanhamento\r\n                                "), _c('i', {
	      staticClass: "icon-truck-zoom"
	    })]), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-tile transfer",
	      attrs: {
	        "tag": "button",
	        "to": {
	          name: 'transfer-shipper',
	          params: {
	            contract: c
	          }
	        },
	        "data-toggle": "tooltip",
	        "data-placement": "bottom"
	      }
	    }, [_vm._v("\r\n                                Transferir Crédito\r\n                                "), _c('i', {
	      staticClass: "icon-money-transfer"
	    })])], 1), _vm._v(" "), (_vm.embarcadorVpPos && _vm.embarcadorVpPos.length > 0) ? _c('table', {
	      staticClass: "table table-striped table-vp"
	    }, [_c('thead', [_c('tr', [_c('th', {
	      attrs: {
	        "width": "15%"
	      }
	    }, [_vm._v("No. Vale-pedágio")]), _vm._v(" "), _c('th', {
	      attrs: {
	        "width": "38%"
	      }
	    }, [_vm._v("Transportador")]), _vm._v(" "), _c('th', {
	      staticClass: "text-center",
	      attrs: {
	        "width": "10%"
	      }
	    }, [_vm._v("Data emissão")]), _vm._v(" "), _c('th', {
	      staticClass: "text-center",
	      attrs: {
	        "width": "10%"
	      }
	    }, [_vm._v("Data expiração")]), _vm._v(" "), _c('th', {
	      staticClass: "text-center",
	      attrs: {
	        "width": "10%"
	      }
	    }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
	      staticClass: "text-right",
	      attrs: {
	        "width": "10%"
	      }
	    }, [_vm._v("Valor VP")]), _vm._v(" "), _c('th', {
	      staticClass: "text-center",
	      attrs: {
	        "width": "7%"
	      }
	    }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.embarcadorVpPos), function(v, index) {
	      return _c('tr', {
	        key: index,
	        class: {
	          red: v.idProtocoloCanc != null
	        }
	      }, [(index < 6) ? [_c('td', [_vm._v(_vm._s(v.idProtocolo))]), _vm._v(" "), _c('td', [_vm._v("\r\n                                      " + _vm._s(v.transportador) + "\r\n                                      "), (v.idProtocoloCanc != null) ? _c('span', [_vm._v(" (Cancelado)")]) : _vm._e()]), _vm._v(" "), _c('td', {
	        staticClass: "text-center"
	      }, [_vm._v(_vm._s(_vm._f("date")(v.dataEmissao)))]), _vm._v(" "), _c('td', {
	        staticClass: "text-center"
	      }, [_vm._v(_vm._s(_vm._f("date")(v.expirationVP)))]), _vm._v(" "), _c('td', {
	        staticClass: "bold text-center"
	      }, [_vm._v(_vm._s(_vm._f("formatPlate")(v.placaVeiculo)))]), _vm._v(" "), _c('td', {
	        staticClass: "text-right"
	      }, [_vm._v(_vm._s(_vm._f("cents")(v.valorVP)))]), _vm._v(" "), _c('td', {
	        staticClass: "text-center"
	      }, [_c('div', {
	        staticClass: "dropdown drop-actions"
	      }, [_c('button', {
	        staticClass: "no-btn",
	        attrs: {
	          "id": "",
	          "type": "button",
	          "data-toggle": "dropdown",
	          "aria-haspopup": "true",
	          "aria-expanded": "false"
	        }
	      }, [_c('img', {
	        attrs: {
	          "src": "/static/icon-actions.svg",
	          "alt": ""
	        }
	      })]), _vm._v(" "), _c('ul', {
	        staticClass: "dropdown-menu",
	        attrs: {
	          "aria-labelledby": ""
	        }
	      }, [_c('li', [_c('a', {
	        on: {
	          "click": function($event) {
	            _vm.showReceiptVp = true;
	            _vm.modalReceiptVp(v.contractIdVp, v.idIntern)
	          }
	        }
	      }, [_c('img', {
	        attrs: {
	          "src": "/static/icon-eye.svg",
	          "alt": "icon eye"
	        }
	      }), _vm._v("\r\n                                              Visualizar/Imprimir\r\n                                            ")])]), _vm._v(" "), _c('li', [_c('a', {
	        on: {
	          "click": function($event) {
	            _vm.showRouteVp = true;
	            _vm.modalRouteVp(v.contractIdVp, v.idIntern)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "icomoon-truck-zoom_gray"
	      }), _vm._v("\r\n                                              Rota do VP\r\n                                            ")])]), _vm._v(" "), _c('li', [_c('a', {
	        on: {
	          "click": function($event) {
	            _vm.showPrintVp = true;
	            _vm.modalPrintVp(v)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "icomoon-file-export-gray"
	      }), _vm._v("\r\n                                              Comprovante VP\r\n                                            ")])]), _vm._v(" "), _c('li', [_c('a', {
	        on: {
	          "click": function($event) {
	            return _vm.cancelarVP(v.idIntern, v.placaVeiculo, 'pos')
	          }
	        }
	      }, [_c('i', {
	        staticClass: "icomoon-close",
	        staticStyle: {
	          "font-size": "14px"
	        }
	      }), _vm._v("\r\n                                              Cancelar VP\r\n                                            ")])])])])])] : _vm._e()], 2)
	    }), 0)]) : _c('div', {
	      staticClass: "alert alert-warning alert-container margin-b20"
	    }, [_c('p', {
	      staticClass: "no-margin"
	    }, [_vm._v("\r\n                                Nenhum vale-pedágio encontrado para o contrato em questão.\r\n                              ")])]), _vm._v(" "), (_vm.embarcadorVpPos && _vm.embarcadorVpPos.length > 0) ? _c('div', {
	      staticClass: "pagination-vp margin-b10"
	    }, [_c('p', {
	      staticClass: "inline no-margin"
	    }, [_vm._v("\r\n                                " + _vm._s(_vm.pageSmVpPos.firstIndexShown()) + "-" + _vm._s(_vm.pageSmVpPos.lastIndexShown()) + " itens de " + _vm._s(_vm.pageSmVpPos.itemCount()) + " -\r\n                                "), _c('router-link', {
	      staticClass: "bold",
	      attrs: {
	        "to": {
	          name: 'accompaniment',
	          params: {
	            contractId: c.contractId
	          }
	        },
	        "tag": "a"
	      }
	    }, [_vm._v("\r\n                                  ver todos\r\n                                  "), _c('img', {
	      attrs: {
	        "src": __webpack_require__(227),
	        "alt": ""
	      }
	    })])], 1), _vm._v(" "), _c('div', {
	      staticClass: "pull-right inline"
	    }, [_c('pagination-sm', {
	      attrs: {
	        "model": _vm.pageSmVpPos
	      },
	      on: {
	        "page-change": _vm.setCurrentPageVpPos
	      }
	    })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "flex action-buttons"
	    }, [_c('router-link', {
	      staticClass: "btn-act button-icomoon",
	      attrs: {
	        "to": {
	          name: 'contract-statement',
	          params: {
	            contractId: c.contractId,
	            planId: c.plan.planId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_vm._v("\r\n                                Extrato\r\n                              ")]), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-act button-icomoon",
	      attrs: {
	        "to": {
	          name: 'invoice-history',
	          params: {
	            contractId: c.contractId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_vm._v("\r\n                                Histórico de Contas\r\n                              ")]), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-act button-icomoon",
	      attrs: {
	        "to": {
	          name: 'contract-detail',
	          params: {
	            contractId: c.contractId,
	            planId: c.plan.planId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_vm._v("\r\n                                Mais Detalhes do Plano \r\n                              ")])], 1)])])]) : _vm._e(), _vm._v(" "), (c.dashType == 'PRE_AUTO' || c.plan.planId == 62 || c.plan.planId == 64) ? _c('div', {
	      staticClass: "row pre"
	    }, [_c('div', {
	      staticClass: "col-md-4"
	    }, [_c('div', {
	      staticClass: "col-accordion"
	    }, [_c('p', {
	      staticClass: "no-margin accordion-pad"
	    }, [_vm._v("\r\n                            Saldo:\r\n                            "), _c('b', {
	      staticClass: "pull-right",
	      class: c.currentBalance.currentBalance >= 0 ? 'green' : 'red'
	    }, [_vm._v(_vm._s(_vm.getCurrentBalance(c)))])]), _vm._v(" "), _c('div', {
	      staticClass: "btn-group-accordion"
	    }, [(_vm.bloqueiaFuncionalidades(c.status.contractStatusId)) ? _c('router-link', {
	      staticClass: "btn btn-success padding-10",
	      class: {
	        'disabled': !_vm.checkVehicle
	      },
	      attrs: {
	        "to": {
	          name: 'contract-recharge',
	          params: {
	            contractId: c.contractId,
	            planId: c.plan.planId
	          }
	        },
	        "tag": "button",
	        "disabled": !_vm.checkVehicle
	      }
	    }, [_vm._v("\r\n                              Recarga extra\r\n                            ")]) : _c('button', {
	      staticClass: "btn btn-success padding-10",
	      class: {
	        'disabled': !_vm.checkVehicle
	      },
	      attrs: {
	        "disabled": !_vm.checkVehicle || c.status.contractStatusId != 1 || c.status.contractStatusId != 5
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showMessageContract()
	        }
	      }
	    }, [_vm._v("\r\n                              Recarga extra\r\n                            ")]), _vm._v(" "), (_vm.bloqueiaFuncionalidades(c.status.contractStatusId)) ? _c('router-link', {
	      staticClass: "btn btn-purple",
	      class: {
	        'disabled': !_vm.checkVehicle
	      },
	      attrs: {
	        "tag": "button",
	        "disabled": c.plan.planId != 21 && c.plan.planId != 22 && c.plan.planId != 35 && c.plan.planId != 36 || !_vm.checkVehicle,
	        "to": {
	          name: 'transfer-credit',
	          params: {
	            contractId: c.contractId,
	            planId: c.plan.planId
	          }
	        }
	      }
	    }, [_vm._v("\r\n                              Transferir Saldo\r\n                              "), _c('i', {
	      staticClass: "icon-money-transfer"
	    })]) : _c('button', {
	      staticClass: "btn btn-purple",
	      class: {
	        'disabled': !_vm.checkVehicle
	      },
	      attrs: {
	        "disabled": !_vm.checkVehicle
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showMessageContract()
	        }
	      }
	    }, [_vm._v("\r\n                                  Transferir Saldo\r\n                                  "), _c('i', {
	      staticClass: "icon-money-transfer"
	    })])], 1), _vm._v(" "), _c('div', {
	      staticClass: "box-btn-recharge bar"
	    }, [_c('p', {
	      class: 'limit-percent-' + _vm.getPercentRechargeAut(c.plan.planId)
	    }, [_vm._v("\r\n                              " + _vm._s(_vm.getPercentRechargeAut(c.plan.planId)) + "%\r\n                            ")]), _vm._v(" "), _c('div', {
	      staticClass: "progress progress-recharge"
	    }, [_c('div', {
	      staticClass: "progress-bar",
	      class: _vm.getRechargeClass(c),
	      style: (_vm.getRechargeStyle(c)),
	      attrs: {
	        "role": "progressbar",
	        "aria-valuenow": _vm.getRechargePercent(c),
	        "aria-valuemin": "0",
	        "aria-valuemax": "100",
	        "data-placement": "top",
	        "data-toggle": "tooltip",
	        "title": _vm.getRechargePercent(c) + '%'
	      }
	    }), _vm._v(" "), _c('div', {
	      class: 'limit-' + _vm.getPercentRechargeAut(c.plan.planId)
	    })]), _vm._v(" "), _c('p', {
	      staticClass: "txt-rec-auto no-margin",
	      on: {
	        "click": function($event) {
	          return _vm.openModalRecharge(c.contractId)
	        }
	      }
	    }, [_c('b', {
	      staticClass: "pull-right force-link",
	      attrs: {
	        "data-toggle": "tooltip",
	        "title": "Editar o valor da recarga automática"
	      }
	    }, [_vm._v("\r\n                                " + _vm._s(_vm._f("cents")(_vm.getAutomaticRechargeValue(c))) + "\r\n                                "), _c('i', {
	      staticClass: "icon-pencil icon-edit"
	    })])])])])]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-4"
	    }, [_c('div', {
	      staticClass: "col-accordion"
	    }, [_c('p', {
	      staticClass: "no-margin accordion-pad"
	    }, [_vm._v("\r\n                            N° Contrato:\r\n                            "), _c('b', {
	      staticClass: "pull-right purple"
	    }, [_vm._v(_vm._s(c.contractId))])]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin accordion-pad"
	    }, [_vm._v("\r\n                            Situação:\r\n                            "), _c('b', {
	      staticClass: "plan-status",
	      attrs: {
	        "data-toggle": "tooltip",
	        "data-html": "true",
	        "data-tooltip-style": "orange-tooltip",
	        "title": _vm.getTooltipText(c)
	      }
	    }, [(c.dashType == 'MOVE_PAGUE' && (c.status.contractStatusId == 4 || c.status.contractStatusId == 5)) ? _c('router-link', {
	      class: _vm.getStatusClass(c),
	      attrs: {
	        "tag": "a",
	        "to": {
	          name: 'reprocess-orders',
	          params: {
	            contractId: c.contractId
	          }
	        }
	      }
	    }, [_c('div', {
	      attrs: {
	        "id": "blockedContract"
	      }
	    }, [_vm._v(_vm._s(_vm.getMobileStatusName(c)))])]) : _c('div', {
	      staticStyle: {
	        "display": "inline-flex",
	        "align-items": "center",
	        "gap": "5px"
	      }
	    }, [(c.isEntryBlocked === 999) ? _c('img', {
	      staticClass: "has-click",
	      attrs: {
	        "src": __webpack_require__(115)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showMessage()
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), _c('div', {
	      class: _vm.getStatusClass(c),
	      attrs: {
	        "id": "statusContract"
	      }
	    }, [_vm._v("\r\n                                  " + _vm._s(_vm.getStatusContrato(c.status, c.isEntryBlocked)) + "\r\n                                ")])]), _vm._v(" "), _c('div', {
	      staticClass: "status-pull"
	    }, [_c('span', {
	      class: _vm.getStatusDotsClass(c)
	    })])], 1)]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin accordion-pad"
	    }, [_vm._v("\r\n                            Plano:\r\n                            "), _c('b', {
	      staticClass: "plan-name-label"
	    }, [_vm._v("\r\n                              " + _vm._s(c.plan.name) + "\r\n                            ")])]), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-default-plan",
	      attrs: {
	        "to": {
	          name: 'contract-detail',
	          params: {
	            contractId: c.contractId,
	            planId: c.plan.planId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_vm._v("\r\n                            Mais Detalhes do Plano \r\n                          ")])], 1)]), _vm._v(" "), (c.summary) ? _c('div', {
	      staticClass: "col-md-4"
	    }, [_c('div', {
	      staticClass: "col-accordion"
	    }, [_c('p', {
	      staticClass: "no-margin accordion-pad"
	    }, [_vm._v("\r\n                            Veículos Ativos:\r\n                            "), _c('b', {
	      staticClass: "pull-right purple"
	    }, [_vm._v(_vm._s(c.summary.desbloqueados))])]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin accordion-pad"
	    }, [_vm._v("\r\n                            Veículos Bloqueados:\r\n                            "), _c('b', {
	      staticClass: "pull-right purple"
	    }, [_vm._v(_vm._s(c.summary.bloqueados))])]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin accordion-pad"
	    }, [_vm._v("\r\n                            Veículos Cadastrados:\r\n                            "), _c('b', {
	      staticClass: "pull-right purple"
	    }, [_vm._v(_vm._s(c.summary.cadastrados))])]), _vm._v(" "), _c('div', {}, [(_vm.bloqueiaFuncionalidades(c.status.contractStatusId)) ? _c('router-link', {
	      staticClass: "btn-default-plan",
	      attrs: {
	        "to": {
	          name: 'contract-vehicles',
	          params: {
	            contractId: c.contractId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_vm._v("\r\n                              Ver veículos\r\n                            ")]) : _c('button', {
	      staticClass: "btn-default-plan",
	      class: {
	        'disabled': !_vm.checkVehicle
	      },
	      attrs: {
	        "disabled": !_vm.checkVehicle
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showMessageContract()
	        }
	      }
	    }, [_vm._v("\r\n                                Ver veículos\r\n                              ")])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "col-xs-12"
	    }, [_c('div', {
	      staticClass: "flex action-buttons margin-t20"
	    }, [_c('router-link', {
	      staticClass: "btn-act button-icomoon",
	      attrs: {
	        "to": {
	          name: 'contract-statement',
	          params: {
	            contractId: c.contractId,
	            planId: c.plan.planId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_vm._v("\r\n                            Extrato\r\n                          ")]), _vm._v(" "), _c('button', {
	      staticClass: "btn-act button-icomoon",
	      attrs: {
	        "type": "button",
	        "disabled": _vm.loadingPaymentMethods[c.contractId]
	      },
	      on: {
	        "click": function($event) {
	          return _vm.openPaymentMethods(c.contractId)
	        }
	      }
	    }, [(_vm.loadingPaymentMethods[c.contractId]) ? _c('span', {
	      staticClass: "loading-spinner"
	    }) : _c('span', [_vm._v("Formas de Pagamento")])]), _vm._v(" "), (c.plan.planId != 21 && c.plan.planId != 22 && c.plan.planId != 35 && c.plan.planId != 36) ? _c('button', {
	      staticClass: "btn-act button-icomoon disabled",
	      attrs: {
	        "type": "button"
	      }
	    }, [_vm._v("\r\n                            Informações sobre transferência\r\n                          ")]) : _c('button', {
	      staticClass: "btn-act button-icomoon",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showModalTransfer()
	        }
	      }
	    }, [_vm._v("\r\n                            Informações sobre transferência\r\n                          ")]), _vm._v(" "), _c('a', {
	      staticClass: "btn-act button-icomoon btn-debitos-veiculares",
	      staticStyle: {
	        "white-space": "nowrap"
	      },
	      attrs: {
	        "href": "https://www.zignet.com.br/parceiro/movemais-interno",
	        "target": "_blank",
	        "rel": "noopener noreferrer"
	      }
	    }, [_vm._v("\r\n                            Débitos veiculares\r\n                          ")])], 1)]), _vm._v(" "), (c.plan.planId == 32 && _vm.modalRecharge[c.contractId]) ? _c('modal-automatic', {
	      attrs: {
	        "contract": c
	      },
	      on: {
	        "closeModalRecharge": _vm.closeModalRecharge
	      }
	    }) : _vm._e(), _vm._v(" "), (c.plan.planId != 32 && _vm.modalRecharge[c.contractId]) ? _c('modal-recharge', {
	      attrs: {
	        "contract": c
	      },
	      on: {
	        "closeModalRecharge": _vm.closeModalRecharge
	      }
	    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (c.dashType == 'PRE_MAN') ? _c('div', {
	      staticClass: "row pre mn"
	    }, [_c('div', {
	      staticClass: "col-md-4"
	    }, [_c('div', {
	      staticClass: "col-accordion"
	    }, [_c('p', {
	      staticClass: "no-margin accordion-pad"
	    }, [_vm._v("\r\n                            Saldo:\r\n                            "), _c('b', {
	      staticClass: "pull-right",
	      class: c.currentBalance.currentBalance > 0 ? 'green' : 'red'
	    }, [_vm._v(_vm._s(_vm.getCurrentBalance(c)))])]), _vm._v(" "), _c('div', {
	      staticClass: "btn-group-accordion"
	    }, [(_vm.bloqueiaFuncionalidades(c.status.contractStatusId)) ? _c('router-link', {
	      staticClass: "btn btn-success",
	      class: {
	        'disabled': !_vm.checkVehicle
	      },
	      attrs: {
	        "to": {
	          name: 'contract-recharge',
	          params: {
	            contractId: c.contractId,
	            planId: c.plan.planId
	          }
	        },
	        "tag": "button",
	        "disabled": !_vm.checkVehicle
	      }
	    }, [_vm._v("\r\n                              Recarregar\r\n                              "), _c('i', {
	      staticClass: "icon-recharge"
	    })]) : _c('button', {
	      staticClass: "btn btn-success",
	      class: {
	        'disabled': !_vm.checkVehicle
	      },
	      attrs: {
	        "disabled": !_vm.checkVehicle || c.status.contractStatusId != 1 || c.status.contractStatusId != 5
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showMessageContract()
	        }
	      }
	    }, [_vm._v("\r\n                              Recarregar\r\n                              "), _c('i', {
	      staticClass: "icon-recharge"
	    })]), _vm._v(" "), (_vm.bloqueiaFuncionalidades(c.status.contractStatusId)) ? _c('router-link', {
	      staticClass: "btn btn-purple",
	      class: {
	        'disabled': !_vm.checkVehicle
	      },
	      attrs: {
	        "tag": "button",
	        "disabled": c.plan.planId != 21 && c.plan.planId != 22 && c.plan.planId != 35 && c.plan.planId != 36 && c.plan.planId != 70 && c.plan.planId != 71 || !_vm.checkVehicle,
	        "to": {
	          name: 'transfer-credit',
	          params: {
	            contractId: c.contractId,
	            planId: c.plan.planId
	          }
	        }
	      }
	    }, [_vm._v("\r\n                              Transferir Saldo\r\n                              "), _c('i', {
	      staticClass: "icon-money-transfer"
	    })]) : _c('button', {
	      staticClass: "btn btn-purple",
	      class: {
	        'disabled': !_vm.checkVehicle
	      },
	      attrs: {
	        "disabled": !_vm.checkVehicle
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showMessageContract()
	        }
	      }
	    }, [_vm._v("\r\n                                  Transferir Saldo\r\n                                  "), _c('i', {
	      staticClass: "icon-money-transfer"
	    })])], 1)])]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-4"
	    }, [_c('div', {
	      staticClass: "col-accordion"
	    }, [_c('p', {
	      staticClass: "no-margin accordion-pad"
	    }, [_vm._v("\r\n                            N° Contrato:\r\n                            "), _c('b', {
	      staticClass: "pull-right purple"
	    }, [_vm._v(_vm._s(c.contractId))])]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin accordion-pad"
	    }, [_vm._v("\r\n                            Situação:\r\n                            "), _c('b', {
	      staticClass: "plan-status",
	      attrs: {
	        "data-toggle": "tooltip",
	        "data-html": "true",
	        "data-tooltip-style": "orange-tooltip",
	        "title": _vm.getTooltipText(c)
	      }
	    }, [(c.dashType == 'MOVE_PAGUE' && (c.status.contractStatusId == 4 || c.status.contractStatusId == 5)) ? _c('router-link', {
	      class: _vm.getStatusClass(c),
	      attrs: {
	        "tag": "a",
	        "to": {
	          name: 'reprocess-orders',
	          params: {
	            contractId: c.contractId
	          }
	        }
	      }
	    }, [_c('div', {
	      attrs: {
	        "id": "blockedContract"
	      }
	    }, [_vm._v(_vm._s(_vm.getMobileStatusName(c)))])]) : _c('div', {
	      staticStyle: {
	        "display": "inline-flex",
	        "align-items": "center",
	        "gap": "5px"
	      }
	    }, [(c.isEntryBlocked === 999) ? _c('img', {
	      staticClass: "has-click",
	      attrs: {
	        "src": __webpack_require__(115)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showMessage()
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), _c('div', {
	      class: _vm.getStatusClass(c),
	      attrs: {
	        "id": "statusContract"
	      }
	    }, [_vm._v("\r\n                                  " + _vm._s(_vm.getStatusContrato(c.status, c.isEntryBlocked)) + "\r\n                                ")])]), _vm._v(" "), _c('div', {
	      staticClass: "status-pull"
	    }, [_c('span', {
	      class: _vm.getStatusDotsClass(c)
	    })])], 1)]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin accordion-pad"
	    }, [_vm._v("\r\n                            Plano:\r\n                            "), _c('b', {
	      staticClass: "plan-name-label"
	    }, [_vm._v("\r\n                              " + _vm._s(c.plan.name) + "\r\n                            ")])])])]), _vm._v(" "), (c.summary) ? _c('div', {
	      staticClass: "col-md-4"
	    }, [_c('div', {
	      staticClass: "col-accordion"
	    }, [_c('p', {
	      staticClass: "no-margin accordion-pad"
	    }, [_vm._v("\r\n                            Veículos Ativos:\r\n                            "), _c('b', {
	      staticClass: "pull-right purple"
	    }, [_vm._v(_vm._s(c.summary.desbloqueados))])]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin accordion-pad"
	    }, [_vm._v("\r\n                            Veículos Bloqueados:\r\n                            "), _c('b', {
	      staticClass: "pull-right purple"
	    }, [_vm._v(_vm._s(c.summary.bloqueados))])]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin accordion-pad"
	    }, [_vm._v("\r\n                            Veículos Cadastrados:\r\n                            "), _c('b', {
	      staticClass: "pull-right purple"
	    }, [_vm._v(_vm._s(c.summary.cadastrados))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "col-xs-12"
	    }, [_c('div', {
	      staticClass: "flex action-buttons margin-t20"
	    }, [_c('router-link', {
	      staticClass: "btn-act button-icomoon",
	      attrs: {
	        "to": {
	          name: 'contract-statement',
	          params: {
	            contractId: c.contractId,
	            planId: c.plan.planId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_vm._v("\r\n                            Extrato\r\n                          ")]), _vm._v(" "), _c('button', {
	      staticClass: "btn-act button-icomoon",
	      attrs: {
	        "type": "button",
	        "disabled": _vm.loadingPaymentMethods[c.contractId]
	      },
	      on: {
	        "click": function($event) {
	          return _vm.openPaymentMethods(c.contractId)
	        }
	      }
	    }, [(_vm.loadingPaymentMethods[c.contractId]) ? _c('span', {
	      staticClass: "loading-spinner"
	    }) : _c('span', [_vm._v("Formas de Pagamento")])]), _vm._v(" "), (c.plan.planId != 21 && c.plan.planId != 22 && c.plan.planId != 35 && c.plan.planId != 36) ? _c('button', {
	      staticClass: "btn-act button-icomoon disabled",
	      attrs: {
	        "type": "button"
	      }
	    }, [_vm._v("\r\n                            Informações sobre transferência\r\n                          ")]) : _c('button', {
	      staticClass: "btn-act button-icomoon",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showModalTransfer()
	        }
	      }
	    }, [_vm._v("\r\n                            Informações sobre transferência\r\n                          ")]), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-default-plan button-icomoon",
	      attrs: {
	        "to": {
	          name: 'contract-detail',
	          params: {
	            contractId: c.contractId,
	            planId: c.plan.planId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_vm._v("\r\n                            Mais Detalhes do Plano\r\n                          ")]), _vm._v(" "), (_vm.bloqueiaFuncionalidades(c.status.contractStatusId) && _vm.checkVehicle) ? _c('router-link', {
	      staticClass: "btn-default-plan button-icomoon",
	      attrs: {
	        "disabled": _vm.bloqueiaRoadcard,
	        "to": {
	          name: 'contract-vehicles',
	          params: {
	            contractId: c.contractId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_vm._v("\r\n                            Veículos cadastrados\r\n                          ")]) : _vm._e(), _vm._v(" "), _c('a', {
	      staticClass: "btn-act button-icomoon btn-debitos-veiculares",
	      staticStyle: {
	        "white-space": "nowrap"
	      },
	      attrs: {
	        "href": "https://www.zignet.com.br/parceiro/movemais-interno",
	        "target": "_blank",
	        "rel": "noopener noreferrer"
	      }
	    }, [_vm._v("\r\n                            Débitos veiculares\r\n                          ")])], 1)])]) : _vm._e(), _vm._v(" "), (c.dashType == 'POS_PAGO') ? _c('div', {
	      staticClass: "row pre mn",
	      class: {
	        'has-tag-reserva': _vm.possuiTagReserva
	      }
	    }, [_c('div', {
	      staticClass: "col-md-4"
	    }, [_c('div', {
	      staticClass: "col-accordion"
	    }, [_c('p', {
	      staticClass: "no-margin accordion-pad"
	    }, [_vm._v("\r\n                            Limite de Crédito:\r\n                            "), _c('b', {
	      staticClass: "pull-right"
	    }, [_vm._v(_vm._s(_vm._f("cents")(c.currentBalance.creditLimit)))])]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin accordion-pad"
	    }, [_vm._v("\r\n                            Limite Disponível:\r\n                            "), _c('b', {
	      staticClass: "pull-right"
	    }, [_vm._v(_vm._s(_vm._f("cents")(c.currentBalance.currentTotalBalance)))])]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin accordion-pad"
	    }, [_vm._v("\r\n                            Dias de Vencimento:\r\n                            "), _c('b', {
	      staticClass: "pull-right"
	    }, [_vm._v(_vm._s(_vm.getBillingDates(c)))])])])]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-4"
	    }, [_c('div', {
	      staticClass: "col-accordion"
	    }, [_c('p', {
	      staticClass: "no-margin accordion-pad"
	    }, [_vm._v("\r\n                            N° Contrato:\r\n                            "), _c('b', {
	      staticClass: "pull-right purple"
	    }, [_vm._v(_vm._s(c.contractId))])]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin accordion-pad"
	    }, [_vm._v("\r\n                            Situação:\r\n                            "), _c('b', {
	      staticClass: "plan-status",
	      attrs: {
	        "data-toggle": "tooltip",
	        "data-html": "true",
	        "data-tooltip-style": "orange-tooltip",
	        "title": _vm.getTooltipText(c)
	      }
	    }, [(c.dashType == 'MOVE_PAGUE' && (c.status.contractStatusId == 4 || c.status.contractStatusId == 5)) ? _c('router-link', {
	      class: _vm.getStatusClass(c),
	      attrs: {
	        "tag": "a",
	        "to": {
	          name: 'reprocess-orders',
	          params: {
	            contractId: c.contractId
	          }
	        }
	      }
	    }, [_c('div', {
	      attrs: {
	        "id": "blockedContract"
	      }
	    }, [_vm._v(_vm._s(_vm.getMobileStatusName(c)))])]) : _c('div', {
	      staticStyle: {
	        "display": "inline-flex",
	        "align-items": "center",
	        "gap": "5px"
	      }
	    }, [(c.isEntryBlocked === 999) ? _c('img', {
	      staticClass: "has-click",
	      attrs: {
	        "src": __webpack_require__(115)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showMessage()
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), _c('div', {
	      class: _vm.getStatusClass(c),
	      attrs: {
	        "id": "statusContract"
	      }
	    }, [_vm._v("\r\n                                  " + _vm._s(_vm.getStatusContrato(c.status, c.isEntryBlocked)) + "\r\n                                ")])]), _vm._v(" "), _c('div', {
	      staticClass: "status-pull"
	    }, [_c('span', {
	      class: _vm.getStatusDotsClass(c)
	    })])], 1)]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin accordion-pad"
	    }, [_vm._v("\r\n                            Plano:\r\n                            "), _c('b', {
	      staticClass: "plan-name-label"
	    }, [_vm._v("\r\n                              " + _vm._s(c.plan.name) + "\r\n                            ")])]), _vm._v(" "), (_vm.possuiTagReserva) ? _c('p', {
	      staticClass: "no-margin accordion-pad",
	      staticStyle: {
	        "clear": "both"
	      }
	    }, [_vm._v("\r\n                            Qtd. TAG reserva disponíveis:\r\n                            "), _c('b', {
	      staticClass: "pull-right purple"
	    }, [_vm._v(_vm._s(_vm.tagReservaSaldoByContract[c.contractId] != null ? _vm.tagReservaSaldoByContract[c.contractId] : 0))])]) : _vm._e()])]), _vm._v(" "), (c.summary) ? _c('div', {
	      staticClass: "col-md-4"
	    }, [_c('div', {
	      staticClass: "col-accordion"
	    }, [_c('p', {
	      staticClass: "no-margin accordion-pad"
	    }, [_vm._v("\r\n                            Veículos Ativos:\r\n                            "), _c('b', {
	      staticClass: "pull-right purple"
	    }, [_vm._v(_vm._s(c.summary.desbloqueados))])]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin accordion-pad"
	    }, [_vm._v("\r\n                            Veículos Bloqueados:\r\n                            "), _c('b', {
	      staticClass: "pull-right purple"
	    }, [_vm._v(_vm._s(c.summary.bloqueados))])]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin accordion-pad"
	    }, [_vm._v("\r\n                            Veículos Cadastrados:\r\n                            "), _c('b', {
	      staticClass: "pull-right purple"
	    }, [_vm._v(_vm._s(c.summary.cadastrados))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "col-xs-12"
	    }, [_c('div', {
	      staticClass: "flex action-buttons margin-t20"
	    }, [_c('router-link', {
	      staticClass: "btn-act button-icomoon",
	      attrs: {
	        "to": {
	          name: 'contract-statement',
	          params: {
	            contractId: c.contractId,
	            planId: c.plan.planId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_vm._v("\r\n                            Extrato\r\n                          ")]), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-act button-icomoon",
	      attrs: {
	        "to": {
	          name: 'invoice-history',
	          params: {
	            contractId: c.contractId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_vm._v("\r\n                            Histórico de Contas\r\n                          ")]), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-default-plan button-icomoon",
	      attrs: {
	        "to": {
	          name: 'contract-detail',
	          params: {
	            contractId: c.contractId,
	            planId: c.plan.planId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_vm._v("\r\n                            Mais Detalhes do Plano \r\n                          ")]), _vm._v(" "), (_vm.bloqueiaFuncionalidades(c.status.contractStatusId)) ? _c('router-link', {
	      staticClass: "btn-default-plan button-icomoon",
	      attrs: {
	        "to": {
	          name: 'contract-vehicles',
	          params: {
	            contractId: c.contractId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_vm._v("\r\n                            Veículos cadastrados\r\n                          ")]) : _vm._e(), _vm._v(" "), _c('a', {
	      staticClass: "btn-act button-icomoon btn-debitos-veiculares",
	      staticStyle: {
	        "white-space": "nowrap"
	      },
	      attrs: {
	        "href": "https://www.zignet.com.br/parceiro/movemais-interno",
	        "target": "_blank",
	        "rel": "noopener noreferrer"
	      }
	    }, [_vm._v("\r\n                            Débitos veiculares\r\n                          ")])], 1)])]) : _vm._e()])], 2)] : _vm._e()
	  })], 2)]), _vm._v(" "), (_vm.showModalMyContracts) ? _c('div', [_c('modal-my-contracts', {
	    on: {
	      "close": function($event) {
	        return _vm.fecharModal()
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "overlay-new"
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.svgContent) ? _c('div', {
	    staticClass: "zapay-banner",
	    on: {
	      "click": function($event) {
	        return _vm.onPartnerBannerClick('web')
	      }
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "max-width": "100%",
	      "object-fit": "cover"
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.svgContent)
	    }
	  })]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 plan-mobile hidden-print"
	  }, [(_vm.vp) ? _c('accordion', {
	    staticClass: "margin-t20 vp-accordion",
	    attrs: {
	      "open": true
	    }
	  }, [_c('template', {
	    slot: "header"
	  }, [_c('span', {
	    staticClass: "upper bold"
	  }, [_vm._v("Vale-pedágio")])]), _vm._v(" "), _c('template', {
	    slot: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('table', {
	    staticClass: "table table-striped table-vp"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "width": "30%"
	    }
	  }, [_vm._v("Emissor")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "15%"
	    }
	  }, [_vm._v("Expiração")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
	    staticClass: "text-right",
	    attrs: {
	      "width": "15%"
	    }
	  }, [_vm._v("Valor")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.vp), function(v, index) {
	    return _c('tr', {
	      key: index,
	      class: {
	        red: v.idProtocoloCanc != null
	      }
	    }, [(index < 6) ? [_c('td', [_vm._v(_vm._s(v.embarcador))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(v.expirationVP)))]), _vm._v(" "), _c('td', {
	      staticClass: "bold text-center"
	    }, [_vm._v(_vm._s(_vm._f("formatPlate")(v.placaVeiculo)))]), _vm._v(" "), _c('td', {
	      staticClass: "text-right"
	    }, [_vm._v(_vm._s(_vm._f("centsNoSymbol")(v.valorVP)))])] : _vm._e()], 2)
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "flex action-buttons margin-t10"
	  }, [_c('router-link', {
	    staticClass: "btn-act",
	    attrs: {
	      "to": {
	        name: 'my-toll-ticket',
	        params: {
	          contractId: _vm.vp[0].contratoDest,
	          planId: 7
	        }
	      },
	      "tag": "button"
	    }
	  }, [_vm._v("\r\n                        Ver Todos Vales-pedágio\r\n                      ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn-act",
	    attrs: {
	      "to": {
	        name: 'statement-consolidated',
	        params: {
	          contractId: _vm.vp[0].contratoDest
	        }
	      },
	      "tag": "button"
	    }
	  }, [_vm._v("\r\n                        Saldo & Extrato\r\n                      ")])], 1)])])])], 2) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.state == 'LOADED') ? _c('div', {}, _vm._l((_vm.contracts), function(c, n) {
	    return (c.plan.planId != 7 && c.plan.planId != 45 && c.plan.planId != 46) ? _c('div', {
	      key: n,
	      staticClass: "plan-box"
	    }, [_c('div', {}, [_c('h5', {
	      staticClass: "three-dots"
	    }, [_vm._v(_vm._s(c.plan.name))]), _vm._v(" "), _c('p', {
	      staticClass: "gray"
	    }, [_vm._v("Saldo disponível")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm._f("cents")(c.currentBalance.currentTotalBalance)))]), _vm._v(" "), (c.currentBalance.creditLimit) ? _c('p', {
	      staticClass: "bold-600 gray"
	    }, [_vm._v("\r\n                  Crédito:\r\n                  "), _c('span', {
	      staticClass: "blue"
	    }, [_vm._v(_vm._s(_vm._f("cents")(c.currentBalance.creditLimit)))])]) : _vm._e(), _vm._v(" "), (c.dashType == 'PRE_AUTO') ? _c('div', {
	      staticClass: "box-btn-recharge bar"
	    }, [_c('p', {
	      class: 'limit-percent-' + _vm.getPercentRechargeAut(c.plan.planId)
	    }, [_vm._v("\r\n                    " + _vm._s(_vm.getPercentRechargeAut(c.plan.planId)) + "%\r\n                  ")]), _vm._v(" "), _c('div', {
	      staticClass: "progress progress-recharge"
	    }, [_c('div', {
	      staticClass: "progress-bar",
	      class: _vm.getRechargeClass(c),
	      style: (_vm.getRechargeStyle(c)),
	      attrs: {
	        "role": "progressbar",
	        "aria-valuenow": _vm.getRechargePercent(c),
	        "aria-valuemin": "0",
	        "aria-valuemax": "100",
	        "data-placement": "top",
	        "data-toggle": "tooltip",
	        "title": _vm.getRechargePercent(c) + '%'
	      }
	    }), _vm._v(" "), _c('div', {
	      class: 'limit-' + _vm.getPercentRechargeAut(c.plan.planId)
	    })]), _vm._v(" "), _c('p', {
	      staticClass: "txt-rec-auto no-margin",
	      on: {
	        "click": function($event) {
	          return _vm.openModalRecharge(c.contractId)
	        }
	      }
	    }, [_c('b', {
	      staticClass: "pull-right force-link",
	      attrs: {
	        "data-toggle": "tooltip",
	        "title": "Editar o valor da recarga automática"
	      }
	    }, [_vm._v("\r\n                    " + _vm._s(_vm._f("cents")(_vm.getAutomaticRechargeValue(c))) + "\r\n                    "), _c('i', {
	      staticClass: "icon-pencil icon-edit"
	    })])])]) : _vm._e(), _vm._v(" "), _c('p', {
	      staticClass: "bold-600 margin-t10"
	    }, [(c.name) ? _c('span', [_vm._v(_vm._s(c.name))]) : _c('span', [_vm._v(" ")]), _vm._v(" "), _c('span', {
	      staticClass: "partial-blocked-text",
	      attrs: {
	        "data-toggle": "tooltip",
	        "data-html": "true",
	        "data-tooltip-style": "orange-tooltip",
	        "title": _vm.getTooltipText(c)
	      }
	    }, [(c.isEntryBlocked === 999) ? _c('img', {
	      staticClass: "has-click",
	      attrs: {
	        "src": __webpack_require__(115)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showMessage()
	        }
	      }
	    }) : _vm._e(), _vm._v("\r\n                  " + _vm._s(_vm.getMobileStatusName(c)) + "\r\n                  "), _c('span', {
	      class: _vm.getStatusDotsClass(c)
	    })])]), _vm._v(" "), _c('p', {
	      staticClass: "purple"
	    }, [_vm._v("\r\n                N° Contrato: " + _vm._s(c.contractId) + "\r\n                "), _c('span', {
	      staticClass: "pull-right"
	    }, [_vm._v(_vm._s(_vm._f("date")(c.createdDate)))])]), _vm._v(" "), _c('button', {
	      staticClass: "no-btn",
	      attrs: {
	        "type": "button",
	        "name": "button"
	      },
	      on: {
	        "click": function($event) {
	          c.open = !c.open
	        }
	      }
	    }, [_c('i', {
	      staticClass: "icon-arrow-major",
	      class: c.open ? 'open' : ''
	    })])]), _vm._v(" "), _c('div', {
	      staticClass: "expand-plan",
	      class: c.open ? 'open' : ''
	    }, [(_vm.bloqueiaFuncionalidades(c.status.contractStatusId) && (c.dashType == 'PRE_MAN' || c.dashType == 'PRE_AUTO')) ? _c('router-link', {
	      staticClass: "btn-card-plan",
	      class: {
	        'disabled': !_vm.checkVehicle
	      },
	      attrs: {
	        "to": {
	          name: 'contract-recharge',
	          params: {
	            contractId: c.contractId,
	            planId: c.plan.planId
	          }
	        },
	        "tag": "button",
	        "disabled": !_vm.checkVehicle
	      }
	    }, [_c('i', {
	      staticClass: "icomoon-money"
	    }), _vm._v(" "), (c.dashType == 'PRE_AUTO') ? _c('span', [_vm._v("\r\n                   Recarga"), _c('br'), _vm._v("extra\r\n                ")]) : _c('span', [_vm._v("\r\n                  Fazer"), _c('br'), _vm._v("recarga\r\n                ")])]) : (!_vm.bloqueiaFuncionalidades(c.status.contractStatusId) && (c.dashType == 'PRE_MAN' || c.dashType == 'PRE_AUTO')) ? _c('button', {
	      staticClass: "btn-card-plan",
	      class: {
	        'disabled': !_vm.checkVehicle
	      },
	      attrs: {
	        "disabled": !_vm.checkVehicle
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showMessageContract()
	        }
	      }
	    }, [_c('i', {
	      staticClass: "icomoon-money"
	    }), _vm._v(" "), (c.dashType == 'PRE_AUTO') ? _c('span', [_vm._v("\r\n                   Recarga"), _c('br'), _vm._v("extra\r\n                ")]) : _c('span', [_vm._v("\r\n                  Fazer"), _c('br'), _vm._v("recarga\r\n                ")])]) : _vm._e(), _vm._v(" "), (c.dashType == 'EMBARCADOR-PRE') ? _c('router-link', {
	      staticClass: "btn-card-plan",
	      attrs: {
	        "to": {
	          name: 'buy-credit'
	        },
	        "tag": "button"
	      }
	    }, [_c('i', {
	      staticClass: "icon-add-vehicle"
	    }), _vm._v("\r\n                Comprar"), _c('br'), _vm._v("crédito\r\n              ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-card-plan",
	      attrs: {
	        "to": {
	          name: 'contract-statement',
	          params: {
	            contractId: c.contractId,
	            planId: c.plan.planId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_c('i', {
	      staticClass: "icomoon-invoice"
	    }), _vm._v("\r\n                Extrato"), _c('br'), _vm._v("detalhado\r\n              ")]), _vm._v(" "), (_vm.bloqueiaFuncionalidades(c.status.contractStatusId) && (c.dashType == 'PRE_MAN' || c.dashType == 'PRE_AUTO')) ? _c('router-link', {
	      staticClass: "btn-card-plan",
	      class: {
	        'disabled': !_vm.checkVehicle
	      },
	      attrs: {
	        "tag": "button",
	        "disabled": c.plan.planId != 21 && c.plan.planId != 22 && c.plan.planId != 35 && c.plan.planId != 36 || !_vm.checkVehicle,
	        "to": {
	          name: 'transfer-credit',
	          params: {
	            contractId: c.contractId,
	            planId: c.plan.planId
	          }
	        }
	      }
	    }, [_c('i', {
	      staticClass: "icon-money-transfer"
	    }), _vm._v("\r\n                Transferir"), _c('br'), _vm._v("saldo\r\n              ")]) : (!_vm.bloqueiaFuncionalidades(c.status.contractStatusId) && (c.dashType == 'PRE_MAN' || c.dashType == 'PRE_AUTO')) ? _c('button', {
	      staticClass: "btn-card-plan",
	      class: {
	        'disabled': !_vm.checkVehicle
	      },
	      attrs: {
	        "disabled": !_vm.checkVehicle
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showMessageContract()
	        }
	      }
	    }, [_c('i', {
	      staticClass: "icon-money-transfer"
	    }), _vm._v("\r\n                Transferir"), _c('br'), _vm._v("saldo\r\n              ")]) : _vm._e(), _vm._v(" "), (_vm.bloqueiaFuncionalidades(c.status.contractStatusId) && (c.dashType == 'PRE_AUTO' || c.dashType == 'PRE_MAN')) ? _c('button', {
	      staticClass: "btn-card-plan",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.openPaymentMethods(c.contractId)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "icomoon-payment-method"
	    }), _vm._v("\r\n                Formas de"), _c('br'), _vm._v("Pagamento\r\n              ")]) : (!_vm.bloqueiaFuncionalidades(c.status.contractStatusId) && (c.dashType == 'PRE_AUTO' || c.dashType == 'PRE_MAN')) ? _c('button', {
	      staticClass: "btn-card-plan",
	      class: {
	        'disabled': !_vm.checkVehicle
	      },
	      attrs: {
	        "disabled": !_vm.checkVehicle
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showMessageContract()
	        }
	      }
	    }, [_c('i', {
	      staticClass: "icomoon-payment-method"
	    }), _vm._v("\r\n                Formas de"), _c('br'), _vm._v("Pagamento\r\n              ")]) : _vm._e(), _vm._v(" "), (c.dashType == 'EMBARCADOR-PRE' || c.dashType == 'EMBARCADOR-POS') ? _c('router-link', {
	      staticClass: "btn-card-plan",
	      attrs: {
	        "to": {
	          name: 'routes'
	        },
	        "tag": "button"
	      }
	    }, [_c('i', {
	      staticClass: "icomoon-route-management"
	    }), _vm._v("\r\n                Gestão"), _c('br'), _vm._v("de rotas\r\n              ")]) : _vm._e(), _vm._v(" "), (c.dashType == 'EMBARCADOR-PRE' || c.dashType == 'EMBARCADOR-POS') ? _c('router-link', {
	      staticClass: "btn-card-plan",
	      attrs: {
	        "to": {
	          name: 'toll-ticket',
	          params: {
	            contractId: c.contractId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_c('i', {
	      staticClass: "icomoon-toll-order"
	    }), _vm._v("\r\n                Emitir"), _c('br'), _vm._v("Vale-pedágio\r\n              ")]) : _vm._e(), _vm._v(" "), (c.plan.planId == 6 || c.plan.planId == 8) ? _c('router-link', {
	      staticClass: "btn-card-plan",
	      attrs: {
	        "to": {
	          name: 'accompaniment',
	          params: {
	            contractId: c.contractId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_c('i', {
	      staticClass: "icomoon-truck-zoom"
	    }), _vm._v("\r\n                Acompa-"), _c('br'), _vm._v("nhamento\r\n              ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-card-plan",
	      attrs: {
	        "to": {
	          name: 'contract-vehicles',
	          params: {
	            contractId: c.contractId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_c('i', {
	      class: c.plan.planId == 21 || c.plan.planId == 22 ? 'icon-vehicle' : 'icomoon-truck'
	    }), _vm._v("Veículos"), _c('br'), _vm._v("cadastrados\r\n              ")]), _vm._v(" "), (_vm.bloqueiaFuncionalidades(c.status.contractStatusId)) ? _c('router-link', {
	      staticClass: "btn-card-plan",
	      attrs: {
	        "to": {
	          name: 'contract-vehicles-new',
	          params: {
	            contractId: c.contractId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_c('i', {
	      class: c.plan.planId == 21 || c.plan.planId == 22 ? 'icon-add-vehicle' : 'icomoon-truck-add'
	    }), _vm._v("\r\n                Adicionar"), _c('br'), _vm._v("veículos\r\n              ")]) : _c('button', {
	      staticClass: "btn-card-plan",
	      on: {
	        "click": function($event) {
	          return _vm.showMessageContract()
	        }
	      }
	    }, [_c('i', {
	      class: c.plan.planId == 21 || c.plan.planId == 22 ? 'icon-add-vehicle' : 'icomoon-truck-add'
	    }), _vm._v("\r\n                Adicionar"), _c('br'), _vm._v("veículos\r\n              ")]), _vm._v(" "), _vm._m(4, true), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-card-plan",
	      attrs: {
	        "to": {
	          name: 'contract-detail',
	          params: {
	            contractId: c.contractId,
	            planId: c.plan.planId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_c('i', {
	      staticClass: "icomoon-plan-detail"
	    }), _vm._v("\r\n                Mais detalhes"), _c('br'), _vm._v("do plano \r\n              ")]), _vm._v(" "), (c.plan.planId !== 21 && c.plan.planId !== 22) ? _c('router-link', {
	      staticClass: "btn-card-plan",
	      attrs: {
	        "to": {
	          name: 'invoice-history',
	          params: {
	            contractId: c.contractId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_c('i', {
	      staticClass: "icomoon-count-history"
	    }), _vm._v("\r\n                Histórico"), _c('br'), _vm._v("de contas\r\n              ")]) : (!_vm.bloqueiaFuncionalidades(c.status.contractStatusId) && (c.dashType == 'PRE_MAN' || c.dashType == 'PRE_AUTO')) ? _c('button', {
	      staticClass: "btn-card-plan",
	      class: {
	        'disabled': !_vm.checkVehicle
	      },
	      attrs: {
	        "disabled": !_vm.checkVehicle
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showMessageContract()
	        }
	      }
	    }, [_c('i', {
	      staticClass: "icon-money-transfer"
	    }), _vm._v("\r\n                Transferir"), _c('br'), _vm._v("saldo\r\n              ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-card-plan",
	      class: {
	        'disabled': !_vm.checkVehicle || _vm.checkMigration == 1
	      },
	      attrs: {
	        "to": _vm.hasRodosol ? {
	          name: 'migration-plan',
	          params: {
	            rodosol: _vm.hasRodosol,
	            contract: _vm.contractSelected
	          }
	        } : {
	          name: 'new-contract'
	        },
	        "tag": "button",
	        "disabled": !_vm.checkVehicle || _vm.checkMigration == 1
	      }
	    }, [_c('i', {
	      class: _vm.hasRodosol ? 'new-icon-migrate-plan' : 'icomoon-new-plan'
	    }, [_c('span', {
	      staticClass: "path1"
	    }), _c('span', {
	      staticClass: "path2"
	    }), _c('span', {
	      staticClass: "path3"
	    }), _c('span', {
	      staticClass: "path4"
	    })]), _vm._v(" "), (_vm.hasRodosol) ? _c('span', {
	      staticStyle: {
	        "margin-top": "1rem"
	      }
	    }, [_vm._v("\r\n                  Migrar"), _c('br'), _vm._v("de plano\r\n                ")]) : _c('span', [_vm._v("\r\n                  Novo"), _c('br'), _vm._v("plano\r\n                ")])]), _vm._v(" "), _c('button', {
	      staticClass: "btn-card-plan btn-zapay-mobile",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": _vm.openMyContractsModal
	      }
	    }, [_vm._m(5, true), _vm._v(" "), _vm._m(6, true)]), _vm._v(" "), (c.dashType == 'EMBARCADOR-PRE' || c.dashType == 'EMBARCADOR-POS') ? _c('router-link', {
	      staticClass: "btn-card-plan",
	      attrs: {
	        "to": {
	          name: 'transfer-shipper',
	          params: {
	            contract: c
	          }
	        },
	        "tag": "button"
	      }
	    }, [_c('i', {
	      staticClass: "icomoon-money-transfer"
	    }), _vm._v("\r\n                Transferir"), _c('br'), _vm._v("crédito\r\n              ")]) : _vm._e()], 1), _vm._v(" "), ((c.plan.planId == 21 || c.plan.planId == 22 || c.plan.planId == 35 || c.plan.planId == 36) && _vm.checkVehicle) ? _c('modal-transfer', {
	      key: 'modal-transfer' + n
	    }) : _vm._e(), _vm._v(" "), (c.plan.planId == 32 && _vm.modalRecharge[c.contractId]) ? _c('modal-automatic', {
	      attrs: {
	        "contract": c
	      },
	      on: {
	        "closeModalRecharge": _vm.closeModalRecharge
	      }
	    }) : _vm._e(), _vm._v(" "), (c.plan.planId != 32 && _vm.modalRecharge[c.contractId]) ? _c('modal-recharge', {
	      attrs: {
	        "contract": c
	      },
	      on: {
	        "closeModalRecharge": _vm.closeModalRecharge
	      }
	    }) : _vm._e()], 1) : (c.plan.planId == 45 || c.plan.planId == 46) ? _c('div', {
	      staticClass: "plan-box"
	    }, [_c('div', {}, [_c('h5', {
	      staticClass: "three-dots"
	    }, [_vm._v(_vm._s(c.plan.name))]), _vm._v(" "), _c('p', {
	      staticClass: "gray"
	    }, [_vm._v("Saldo disponível")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm._f("cents")(c.currentBalance.currentTotalBalance)))]), _vm._v(" "), _c('p', {
	      staticClass: "bold-600 margin-t10"
	    }, [(c.name) ? _c('span', [_vm._v(_vm._s(c.name))]) : _c('span', [_vm._v(" ")]), _vm._v(" "), _c('span', {
	      staticClass: "partial-blocked-text",
	      attrs: {
	        "data-toggle": "tooltip",
	        "data-html": "true",
	        "data-tooltip-style": "orange-tooltip",
	        "title": _vm.getTooltipText(c)
	      }
	    }, [(c.isEntryBlocked === 999) ? _c('img', {
	      staticClass: "has-click",
	      attrs: {
	        "src": __webpack_require__(115)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showMessage()
	        }
	      }
	    }) : _vm._e(), _vm._v("\r\n                  " + _vm._s(_vm.getMobileStatusName(c)) + "\r\n                  "), _c('span', {
	      class: _vm.getStatusDotsClass(c)
	    })])]), _vm._v(" "), _c('p', {
	      staticClass: "purple"
	    }, [_vm._v("\r\n                N° Contrato: " + _vm._s(c.contractId) + "\r\n                "), _c('span', {
	      staticClass: "pull-right"
	    }, [_vm._v(_vm._s(_vm._f("date")(c.createdDate)))])]), _vm._v(" "), _c('button', {
	      staticClass: "no-btn",
	      attrs: {
	        "type": "button",
	        "name": "button"
	      },
	      on: {
	        "click": function($event) {
	          c.open = !c.open
	        }
	      }
	    }, [_c('i', {
	      staticClass: "icon-arrow-major",
	      class: c.open ? 'open' : ''
	    })])]), _vm._v(" "), _c('div', {
	      staticClass: "expand-plan",
	      class: c.open ? 'open' : ''
	    }, [_c('button', {
	      staticClass: "btn-card-plan",
	      attrs: {
	        "type": "button",
	        "name": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.modalAggregate(c)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "icomoon-truck-add"
	    }), _vm._v("\r\n                Novo"), _c('br'), _vm._v("agregador\r\n              ")]), _vm._v(" "), _c('button', {
	      staticClass: "btn-card-plan",
	      attrs: {
	        "type": "button",
	        "name": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.modalTollTicket()
	        }
	      }
	    }, [_c('i', {
	      staticClass: "icomoon-toll-order"
	    }), _vm._v("\r\n                Emitir"), _c('br'), _vm._v("Vale-pedágio\r\n              ")]), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-card-plan",
	      attrs: {
	        "to": {
	          name: 'rescue-balance',
	          params: {
	            contractId: c.contractId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_c('i', {
	      staticClass: "icomoon-rescue"
	    }), _vm._v("\r\n                Resgatar"), _c('br'), _vm._v("Saldo\r\n              ")]), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-card-plan",
	      attrs: {
	        "to": {
	          name: 'contract-statement',
	          params: {
	            contractId: c.contractId,
	            planId: c.plan.planId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_c('i', {
	      staticClass: "icomoon-invoice"
	    }), _vm._v("\r\n                Extrato"), _c('br'), _vm._v("detalhado\r\n              ")]), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-card-plan",
	      attrs: {
	        "to": {
	          name: 'aggregate-list',
	          params: {
	            contractId: c.contractId,
	            contract: c,
	            moveMaisId: _vm.currentUser.moveMaisId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_c('i', {
	      staticClass: "icomoon-truck"
	    }), _vm._v("\r\n                Veículos"), _c('br'), _vm._v("cadastrados\r\n              ")]), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-card-plan",
	      attrs: {
	        "to": {
	          name: 'contract-detail',
	          params: {
	            contractId: c.contractId,
	            planId: c.plan.planId
	          }
	        },
	        "tag": "button"
	      }
	    }, [_c('i', {
	      staticClass: "icomoon-plan-detail"
	    }), _vm._v("\r\n                Mais detalhes"), _c('br'), _vm._v("do plano\r\n              ")]), _vm._v(" "), _c('router-link', {
	      staticClass: "btn-card-plan",
	      attrs: {
	        "to": {
	          name: 'new-contract'
	        },
	        "tag": "button"
	      }
	    }, [_c('i', {
	      staticClass: "icomoon-new-plan"
	    }, [_c('span', {
	      staticClass: "path1"
	    }), _c('span', {
	      staticClass: "path2"
	    }), _c('span', {
	      staticClass: "path3"
	    }), _c('span', {
	      staticClass: "path4"
	    })]), _vm._v("\r\n                Novo"), _c('br'), _vm._v("plano\r\n              ")]), _vm._v(" "), _c('ul', _vm._l((_vm.aggregateVehicles), function(v, index) {
	      return (index < 6) ? _c('li', {
	        key: index,
	        class: {
	          red: v.idProtocoloCanc != null
	        }
	      }, [_c('p', [_vm._v("\r\n                    N° da placa\r\n                    "), _c('span', {
	        staticClass: "pull-right"
	      }, [_c('button', {
	        staticClass: "no-btn",
	        attrs: {
	          "type": "button",
	          "name": "button"
	        },
	        on: {
	          "click": function($event) {
	            v.open = !v.open
	          }
	        }
	      }, [_c('i', {
	        staticClass: "icon-arrow-major",
	        class: v.open ? 'open' : ''
	      })])]), _vm._v(" "), _c('span', {
	        directives: [{
	          name: "mask-plate",
	          rawName: "v-mask-plate"
	        }],
	        staticClass: "pull-right"
	      }, [_vm._v(_vm._s(v.plate))])]), _vm._v(" "), _c('div', {
	        staticClass: "expand-agg",
	        class: v.open ? 'open' : ''
	      }, [_c('p', [_vm._v("\r\n                      Status\r\n                      "), _c('span', {
	        staticClass: "pull-right"
	      }, [_vm._v(" ")]), _vm._v(" "), (v.reason == 'Desbloqueado') ? _c('i', {
	        staticClass: "icomoon-truck-ok pull-right"
	      }) : (v.reason == 'Temporariamente') ? _c('i', {
	        staticClass: "icomoon-truck-block pull-right"
	      }) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("\r\n                      Transportador\r\n                      "), _c('span', {
	        staticClass: "pull-right"
	      }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
	        staticClass: "pull-right"
	      }, [_vm._v(_vm._s(v.transportador))])]), _vm._v(" "), _c('p', [_vm._v("\r\n                      Último VP\r\n                      "), _c('span', {
	        staticClass: "pull-right"
	      }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
	        staticClass: "pull-right"
	      }, [_vm._v(_vm._s(_vm._f("date")(v.lastVp)))])]), _vm._v(" "), _c('p', [_vm._v("\r\n                      Última passagem\r\n                      "), _c('span', {
	        staticClass: "pull-right"
	      }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
	        staticClass: "pull-right"
	      }, [_vm._v(_vm._s(_vm._f("date")(v.lastPassage)))])]), _vm._v(" "), _c('p', [_vm._v("\r\n                      Saldo VP\r\n                      "), _c('span', {
	        staticClass: "pull-right"
	      }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
	        staticClass: "pull-right"
	      }, [_vm._v(_vm._s(_vm._f("cents")(v.saldoVp)))])]), _vm._v(" "), _c('span', [_vm._v("\r\n                      Ações\r\n                      "), _c('div', {
	        staticClass: "dropdown drop-actions pull-right"
	      }, [_vm._m(7, true), _vm._v(" "), _c('ul', {
	        staticClass: "dropdown-menu",
	        attrs: {
	          "aria-labelledby": ""
	        }
	      }, [(v.saldoVp > 0) ? _c('li', [_c('a', {
	        on: {
	          "click": function($event) {
	            _vm.showRescue = true;
	            _vm.rescueBalance(v)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "icomoon-rescue"
	      }), _vm._v("\r\n                              Resgatar saldo VP\r\n                            ")])]) : _vm._e(), _vm._v(" "), _c('li', {
	        staticClass: "divider",
	        attrs: {
	          "role": "separator"
	        }
	      }), _vm._v(" "), _c('li', [(!_vm.showUnblock(v)) ? _c('a', {
	        on: {
	          "click": function($event) {
	            _vm.typeAggregate = 'block';
	            _vm.modalBlock(v)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "icomoon-blocked"
	      }), _vm._v("\r\n                              Bloquear veículo\r\n                            ")]) : _vm._e()]), _vm._v(" "), _c('li', [(_vm.showUnblock(v)) ? _c('a', {
	        on: {
	          "click": function($event) {
	            _vm.typeAggregate = 'unblock';
	            _vm.modalBlock(v)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "icomoon-blocked"
	      }), _vm._v("\r\n                              Desbloquear veículo\r\n                            ")]) : _vm._e()]), _vm._v(" "), _c('li', [_c('a', {
	        on: {
	          "click": function($event) {
	            _vm.typeAggregate = 'delete';
	            _vm.modalBlock(v)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "icomoon-delete"
	      }), _vm._v("\r\n                              Excluir veículo\r\n                            ")])])])])])])]) : _vm._e()
	    }), 0)], 1)]) : _vm._e()
	  }), 0) : _vm._e(), _vm._v(" "), (_vm.svgContentMobile) ? _c('div', {
	    staticClass: "zapay-banner",
	    on: {
	      "click": function($event) {
	        return _vm.onPartnerBannerClick('mobile')
	      }
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "max-width": "100%",
	      "object-fit": "cover"
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.svgContentMobile)
	    }
	  })]) : _vm._e()], 1), _vm._v(" "), (_vm.showModalAggregate) ? _c('modal-aggregate', {
	    attrs: {
	      "contractAggregate": _vm.contractAggregate
	    },
	    on: {
	      "close": _vm.close
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showModalTollTicket) ? _c('modal-toll-ticket', {
	    attrs: {
	      "contractShipper": _vm.contractShipper
	    },
	    on: {
	      "close": _vm.close
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showRescue) ? _c('modal-rescue-balance', {
	    attrs: {
	      "rescueData": _vm.rescueData
	    },
	    on: {
	      "close": _vm.close
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showPrintVp) ? _c('modal-print-vp', {
	    attrs: {
	      "vpSelected": _vm.vpSelected
	    },
	    on: {
	      "close": _vm.close
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showBlock) ? _c('modal-block-vehicle', {
	    attrs: {
	      "v": _vm.v,
	      "vpSelected": _vm.vpSelected,
	      "type": _vm.typeAggregate
	    },
	    on: {
	      "close": _vm.close
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showRouteVp) ? _c('modal-route-vp', {
	    attrs: {
	      "vpData": _vm.vpData
	    },
	    on: {
	      "close": _vm.close
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showReceiptVp) ? _c('modal-receipt-vp', {
	    attrs: {
	      "vpData": _vm.vpData
	    },
	    on: {
	      "close": _vm.close
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showModalMyContracts) ? _c('div', [_c('modal-my-contracts', {
	    on: {
	      "close": function($event) {
	        return _vm.fecharModal()
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "overlay-new"
	  })], 1) : _vm._e()], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade modal-info-block",
	    attrs: {
	      "tabindex": "-2",
	      "role": "dialog",
	      "id": "info-block"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-body"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(497),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('h4', [_vm._v("Lembrando que para utilizar nossos serviços e fazer novas recargas, você deve primeiro ativar seu(s) TAG(s).")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("OK")])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close valor-debitado-titulo",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "btn-merc-text"
	  }, [_c('span', [_vm._v("novo")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-button"
	  }, [_c('span', {
	    staticClass: "font-button"
	  }, [_vm._v("Mudar placa para padrão Mercosul "), _c('img', {
	    staticClass: "repeat-icon",
	    attrs: {
	      "src": __webpack_require__(502)
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "btn-card-plan btn-debitos-veiculares-mobile",
	    attrs: {
	      "href": "https://www.zignet.com.br/parceiro/movemais-interno",
	      "target": "_blank",
	      "rel": "noopener noreferrer"
	    }
	  }, [_c('div', {
	    staticClass: "card-wrapper"
	  }, [_c('div', {
	    staticClass: "new-feature"
	  }, [_c('span', [_vm._v("novo")])]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(1770)
	    }
	  }), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "text-align": "center",
	      "margin": "0",
	      "line-height": "12px"
	    }
	  }, [_vm._v("Parcelamento"), _c('br'), _vm._v("de multas e débitos")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "btn-zapay-new"
	  }, [_c('span', [_vm._v("novo")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "merc-container"
	  }, [_c('img', {
	    staticClass: "repeat-icon",
	    attrs: {
	      "src": __webpack_require__(502)
	    }
	  }), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "9px",
	      "text-align": "center",
	      "margin-top": "3px"
	    }
	  }, [_vm._v("\r\n                  Padrão Mercosul\r\n                  ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "no-btn",
	    attrs: {
	      "id": "",
	      "type": "button",
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/icon-actions.svg",
	      "alt": ""
	    }
	  })])
	}]}

/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "home-vp"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "src": __webpack_require__(1848),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h3', [_vm._v("Tenha vantagens com o Vale-pedágio Move Mais.")]), _vm._v(" "), _c('button', {
	    attrs: {
	      "aria-pressed": "true"
	    },
	    on: {
	      "click": _vm.scroll
	    }
	  }, [_vm._v("Solicitar agora!")])])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('section', [_c('div', {
	    staticClass: "nine-act"
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "contact"
	  }, [_c('h3', [_vm._v("#valepedagioeletronico")]), _vm._v(" "), _c('h1', [_vm._v("Para saber como adquirir o Vale-pedágio Move Mais, entre em contato:")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-offset-2 col-md-8"
	  }, [(_vm.formState == 'ERROR') ? _c('div', {
	    staticClass: "alert alert-danger alert-dismissible margin-t20 margin-b20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Erro!")]), _vm._v("\n                    " + _vm._s(_vm.errorMessage) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'LEAD-INFO') ? _c('div', {
	    staticClass: "alert alert-info alert-dismissible margin-t20 margin-b20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Informação!")]), _vm._v("\n                  " + _vm._s(_vm.leadClient ? 'Caro cliente, sua solicitação encontra-se em análise. Em caso de dúvidas, por gentileza, entre em contato no número 08007651000' : 'Solicitação em análise. Em caso de dúvidas, por gentileza, entre em contato com o número 08007651000.') + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'SUCCESS') ? _c('div', {
	    staticClass: "alert alert-success alert-dismissible margin-t20 margin-b20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Sucesso!")]), _vm._v(" As informações foram enviadas, em breve entraremos em contato para finalizar a adesão, obrigado! ;)\n              ")]) : _vm._e(), _vm._v(" "), _c('form', {
	    staticClass: "form-horizontal",
	    attrs: {
	      "autocomplete": "false",
	      "id": "form"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.doRequest.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('taxpayerIdNumber')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-3 control-label bold-600",
	    attrs: {
	      "for": "taxpayerIdNumber"
	    }
	  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.taxpayerIdNumber),
	      expression: "taxpayerIdNumber",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "mask-cnpj",
	      rawName: "v-mask-cnpj"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cnpj'),
	      expression: "'required|cnpj'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2})$",
	      "name": "taxpayerIdNumber",
	      "placeholder": "00.000.000/0000-00",
	      "id": "taxpayerIdNumber",
	      "data-vv-validate-on": "blur"
	    },
	    domProps: {
	      "value": (_vm.taxpayerIdNumber)
	    },
	    on: {
	      "change": function($event) {
	        _vm.taxpayerIdNumber = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('taxpayerIdNumber')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('companyName')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-3 control-label bold-600",
	    attrs: {
	      "for": "companyName"
	    }
	  }, [_vm._v("Empresa")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.companyName),
	      expression: "companyName"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "companyName",
	      "id": "companyName",
	      "data-vv-rules": "required"
	    },
	    domProps: {
	      "value": (_vm.companyName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.companyName = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('companyName')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('contactName')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-3 control-label bold-600",
	    attrs: {
	      "for": "contactName",
	      "required": ""
	    }
	  }, [_vm._v("Nome do Contato")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contactName),
	      expression: "contactName"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "contactName",
	      "id": "contactName",
	      "data-vv-rules": "required"
	    },
	    domProps: {
	      "value": (_vm.contactName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.contactName = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('contactName')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('contactEmail')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-3 control-label bold-600",
	    attrs: {
	      "for": "contactEmail"
	    }
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contactEmail),
	      expression: "contactEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "email",
	      "name": "contactEmail",
	      "id": "contactEmail",
	      "placeholder": "Ex: nome@empresa.com",
	      "data-vv-rules": "required|email|email:email"
	    },
	    domProps: {
	      "value": (_vm.contactEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.contactEmail = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('contactEmail')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('contactJobTitle')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-3 control-label bold-600",
	    attrs: {
	      "for": "contactJobTitle"
	    }
	  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.contactJobTitle),
	      expression: "contactJobTitle",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "mask-tel",
	      rawName: "v-mask-tel"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|phone'),
	      expression: "'required|phone'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "contactJobTitle",
	      "id": "contactJobTitle"
	    },
	    domProps: {
	      "value": (_vm.contactJobTitle)
	    },
	    on: {
	      "change": function($event) {
	        _vm.contactJobTitle = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('contactJobTitle')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('sizeOfFleetVehicle')
	    }
	  }, [_c('label', {
	    staticClass: "col-sm-3 control-label bold-600",
	    attrs: {
	      "for": "sizeOfFleetVehicle"
	    }
	  }, [_vm._v("Tamanho da Frota")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sizeOfFleetVehicle),
	      expression: "sizeOfFleetVehicle"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }, {
	      name: "only-numbers",
	      rawName: "v-only-numbers"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "sizeOfFleetVehicle",
	      "id": "sizeOfFleetVehicle",
	      "data-vv-rules": "required|decimal|max:6",
	      "maxlength": "6"
	    },
	    domProps: {
	      "value": (_vm.sizeOfFleetVehicle)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.sizeOfFleetVehicle = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block-proposal help-block with-errors"
	  }, [_vm._v(_vm._s(_vm.errors.first('sizeOfFleetVehicle')))])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vp-info-box"
	  }, [_c('div', [_c('img', {
	    staticClass: "inline",
	    attrs: {
	      "src": __webpack_require__(1854),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "inline",
	    attrs: {
	      "src": __webpack_require__(1853),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('h1', [_c('span', [_vm._v("\n                VALE-PEDÁGIO\n                "), _c('br')]), _vm._v("\n              ELETRÔNICO\n            ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', [_c('strong', [_vm._v("\n              Bom para quem é Embarcador\n              "), _c('br'), _vm._v("e melhor ainda para quem é Transportador.\n            ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "second-act"
	  }, [_c('div', [_c('div', [_c('img', {
	    staticClass: "notebook",
	    attrs: {
	      "src": __webpack_require__(1852),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', [_c('p', [_vm._v("#valepedagioeletronico")]), _vm._v(" "), _c('h1', [_vm._v("Totalmente digital e fácil de usar")]), _vm._v(" "), _c('h2', [_vm._v("Você no controle total de sua frota.")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "card"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1851),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("Cobertura Nacional")]), _vm._v(" "), _c('p', [_vm._v("Estamos presentes em 100% dos Estados com vias pedagiadas, mais praticidade para suas viagens")])]), _vm._v(" "), _c('div', {
	    staticClass: "card"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1850),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("Gestão Total")]), _vm._v(" "), _c('p', [_vm._v("Controle total da conta corrente, dados online das passagens e extrato detalhado das movimentações.")])]), _vm._v(" "), _c('div', {
	    staticClass: "card"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1849),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("Integração")]), _vm._v(" "), _c('p', [_vm._v("Ferramenta de fácil integração via API, simplificando e otimizando custos nos processos de gerenciamento.")])]), _vm._v(" "), _c('div', {
	    staticClass: "card"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1856),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("Inteligência & Tecnologia")]), _vm._v(" "), _c('p', [_vm._v("O sistema calcula automaticamente o valor dos pedágios de acordo com a rota definida e a quantidade de eixos.")])]), _vm._v(" "), _c('div', {
	    staticClass: "card"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1855),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("Atendimento 24h")]), _vm._v(" "), _c('p', [_vm._v("Atendimento 24h por dia, 7 dias por semana, em vários canais.")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "container text-center"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "five-act"
	  }, [_c('div', {
	    staticClass: "counter"
	  }, [_c('h1', {
	    staticClass: "b1"
	  }, [_vm._v("+")]), _vm._v(" "), _c('h1', {
	    staticClass: "timer count-number b1",
	    attrs: {
	      "data-to": "65",
	      "data-speed": "1500"
	    }
	  }), _vm._v(" "), _c('h2', {
	    staticClass: "count-text"
	  }, [_vm._v("\n                Concessionárias\n                "), _c('br')])]), _vm._v(" "), _c('div', {
	    staticClass: "linha-vertical"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "counter"
	  }, [_c('h1', {
	    staticClass: "b2"
	  }, [_vm._v("+")]), _vm._v(" "), _c('h1', {
	    staticClass: "timer count-number b2",
	    attrs: {
	      "data-to": "370",
	      "data-speed": "1500"
	    }
	  }), _vm._v(" "), _c('h2', {
	    staticClass: "count-text"
	  }, [_vm._v("\n                Praças de\n                "), _c('br'), _vm._v("Pedágio\n              ")])]), _vm._v(" "), _c('div', {
	    staticClass: "linha-vertical"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "counter"
	  }, [_c('h1', {
	    staticClass: "b3"
	  }, [_vm._v("+")]), _vm._v(" "), _c('h1', {
	    staticClass: "timer count-number b3",
	    attrs: {
	      "data-to": "1600",
	      "data-speed": "2000"
	    }
	  }), _vm._v(" "), _c('h2', {
	    staticClass: "count-text"
	  }, [_vm._v("\n                Pistas para utilização\n                "), _c('br'), _vm._v("de TAG Move Mais\n              ")])])])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', [_c('div', {
	    staticClass: "third-act"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "seven-act"
	  }, [_c('h2', [_vm._v("#B2B")]), _vm._v(" "), _c('h1', [_vm._v("Planos Exclusivos para Empresas:")]), _vm._v(" "), _c('hr')])])]), _vm._v(" "), _c('div', {
	    staticClass: "sixty-act"
	  }, [_c('div', {
	    staticClass: "color-box"
	  }, [_c('div', {
	    attrs: {
	      "id": "box-orange"
	    }
	  }), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "box-purple"
	    }
	  }, [_c('div', {}, [_c('h1', [_vm._v("Estradeiro")]), _vm._v(" "), _c('h3', [_vm._v("Pré-pago com recarga automática")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("- As recargas ocorrem automaticamente, quando o saldo atingir 30% do valor que o cliente escolher.")]), _vm._v(" "), _c('li', [_vm._v("- Sem taxa de mensalidade.")]), _vm._v(" "), _c('li', [_vm._v("- Saldo não expira. Sem caução.")]), _vm._v(" "), _c('li', [_vm._v("- Saldo compartilhado por todos os veículos.")])])])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "box-blue"
	    }
	  }, [_c('div', {}, [_c('h1', [_vm._v("Frota")]), _vm._v(" "), _c('h3', [_vm._v("Pós-pago com mensalidade")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("- O cliente conta com uma linha de crédito para pagamento pós uso e a facilidade de prever o custo por meio de mensalidades fixas.")]), _vm._v(" "), _c('li', [_vm._v("- A fatura será emitida em prazos pré-definidos.")]), _vm._v(" "), _c('li', [_vm._v("- Sem custo de recarga.")])]), _vm._v(" "), _c('h6', [_vm._v("*sob análise de crédito")])])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "box-red"
	    }
	  })])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', [_c('div', {
	    staticClass: "fourth-act"
	  }, [_c('div', {
	    staticClass: "col-lg-12"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', [_c('h1', {
	    staticClass: "eight-act"
	  }, [_vm._v("Vale-pedágio Eletrônico")])])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "privacyContainer"
	    }
	  }, [_c('span', {
	    staticClass: "form-group",
	    attrs: {
	      "id": "spanPrivacyText"
	    }
	  }, [_vm._v(" Ao continuar você está de acordo com o nosso\n                      "), _c('a', {
	    attrs: {
	      "id": "spanPrivacyLink",
	      "href": "/api/v2/archeion/downloadFileArcheion/aviso-de-privacidade-movemais",
	      "target": "_blank"
	    }
	  }, [_vm._v("Aviso de Privacidade.\n                      ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-offset-3 col-sm-6 pad-fix text-center"
	  }, [_c('button', {
	    staticClass: "btn btn-lg btn-success bold-600 margin-30",
	    attrs: {
	      "id": "btn-enviar",
	      "type": "submit",
	      "name": "button"
	    }
	  }, [_vm._v("Solicitar proposta")])])
	}]}

/***/ }),
/* 2215 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "row hidden-print"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title title-transfer"
	  }, [_vm._v("Transferir crédito")]), _vm._v(" "), _c('div', {
	    staticClass: "box-balance"
	  }, [_vm._v("\n        Saldo Disponível:\n        "), (_vm.contractData) ? _c('b', {
	    staticClass: "balance-plus"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.contractData.currentBalance.currentTotalBalance)))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "content hidden-print"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('ul', {
	    staticClass: "wizard ad margin-b20"
	  }, [_c('li', {
	    class: {
	      active: _vm.step == 1, past: _vm.step > 1
	    }
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('li', {
	    class: {
	      active: _vm.step == 2, past: _vm.step > 2
	    }
	  }, [_vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('li', {
	    class: {
	      active: _vm.step == 3, past: _vm.step > 3
	    }
	  }, [_vm._m(4), _vm._v(" "), _vm._m(5)])])])]), _vm._v(" "), (_vm.step == 1) ? [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "searchStep1"
	    }
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "search-box",
	    class: {
	      found: _vm.status == 'FOUND'
	    }
	  }, [_c('h1', {
	    staticClass: "bold text-center margin-b20"
	  }, [_vm._v("\n              Informe o CNPJ do Favorecido:\n            ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.search),
	      expression: "search",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cnpj'),
	      expression: "'required|cnpj'"
	    }, {
	      name: "mask-cnpj",
	      rawName: "v-mask-cnpj"
	    }],
	    staticClass: "form-control search text-center bold",
	    attrs: {
	      "type": "tel",
	      "inputmode": "numeric",
	      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2})$",
	      "name": "taxIdNumber",
	      "data-vv-validate-on": "blur",
	      "placeholder": "Digite o CNPJ",
	      "maxlength": "18",
	      "autofocus": "",
	      "novalidate": "",
	      "formnovalidate": ""
	    },
	    domProps: {
	      "value": (_vm.search)
	    },
	    on: {
	      "change": function($event) {
	        _vm.search = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-purple",
	    attrs: {
	      "type": "button",
	      "name": "button",
	      "id": "cnpjSearch"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.filter()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-search"
	  })]), _vm._v(" "), (_vm.status == 'ERROR') ? _c('div', {
	    staticClass: "alert alert-warning margin-t20 text-center",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("CNPJ não encontrado ou inválido!")]), _vm._v(" Faça uma nova\n              busca.\n            ")]) : _vm._e()])])]), _vm._v(" "), (_vm.status == 'FOUND' && _vm.contracts && _vm.contracts.length > 0) ? _c('div', {
	    staticClass: "content-box"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "origin-info"
	  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.userReceive.taxIdNumber)))]), _vm._v(" "), _c('span', [_vm._v(" - " + _vm._s(_vm.userReceive.companyName))])])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-flat"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "width": "8%"
	    }
	  }, [_vm._v("Selecione")]), _vm._v(" "), _c('th', {
	    staticClass: "text-center",
	    attrs: {
	      "width": "10%"
	    }
	  }, [_vm._v("Contrato")]), _vm._v(" "), _c('th', [_vm._v("Razão Social")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "20%"
	    }
	  }, [_vm._v("Nome Fantasia")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "25%"
	    }
	  }, [_vm._v("Plano")]), _vm._v(" "), (_vm.checkBalance) ? _c('th', {
	    staticClass: "text-right",
	    attrs: {
	      "width": "10%"
	    }
	  }, [_vm._v("\n                    Saldo\n                  ")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.contracts), function(c, index) {
	    return _c('tr', {
	      key: c.contractId
	    }, [_c('td', [_c('div', {
	      staticClass: "radio-blue category",
	      class: c.contractId
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.contractCred),
	        expression: "contractCred"
	      }],
	      key: index,
	      staticClass: "radiobtn",
	      attrs: {
	        "type": "radio"
	      },
	      domProps: {
	        "value": c,
	        "checked": _vm._q(_vm.contractCred, c)
	      },
	      on: {
	        "change": function($event) {
	          _vm.contractCred = c
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      staticClass: "radio-label",
	      attrs: {
	        "for": index
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "check"
	    })])]), _vm._v(" "), _c('td', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(c.contractId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(c.companyName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(c.companyTradeName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(c.planName))]), _vm._v(" "), (_vm.checkBalance) ? _c('td', {
	      staticClass: "text-right"
	    }, [_vm._v("\n                    " + _vm._s(_vm._f("cents")(c.currentBalance)) + "\n                  ")]) : _vm._e()])
	  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
	    attrs: {
	      "colspan": "5"
	    }
	  }, [_vm._v(" ")]), _vm._v(" "), (_vm.checkBalance) ? _c('td', [_vm._v(" ")]) : _vm._e()])])]), _vm._v(" "), _c('ul', {
	    staticClass: "transfer-data-box"
	  }, [_vm._m(6), _vm._v(" "), _vm._l((_vm.contracts), function(c, index) {
	    return _c('li', {
	      key: c.contractId
	    }, [_c('div', {
	      staticClass: "radio-blue category",
	      class: c.contractId
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.contractCred),
	        expression: "contractCred"
	      }],
	      staticClass: "radiobtn",
	      attrs: {
	        "type": "radio",
	        "name": "contractCred",
	        "id": index
	      },
	      domProps: {
	        "value": c,
	        "checked": _vm._q(_vm.contractCred, c)
	      },
	      on: {
	        "change": function($event) {
	          _vm.contractCred = c
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      staticClass: "radio-label",
	      attrs: {
	        "for": index
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "check"
	    })]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v(_vm._s(c.contractId))]), _vm._v(" "), _c('p', {
	      staticClass: "three-dots"
	    }, [_vm._v(_vm._s(c.companyName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(c.planName))])])])
	  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "action-buttons-box",
	    class: {
	      'text-center': _vm.status != 'FOUND'
	    }
	  }, [_c('router-link', {
	    staticClass: "btn btn-danger",
	    class: {
	      found: _vm.status == 'FOUND'
	    },
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button",
	      "data-toggle": "tooltip",
	      "title": "Cancelar"
	    }
	  }, [_vm._v("\n          Cancelar\n        ")]), _vm._v(" "), (_vm.status == 'FOUND') ? _c('button', {
	    staticClass: "btn btn-primary add",
	    class: {
	      disabled: !_vm.contractCred
	    },
	    attrs: {
	      "id": "advanceStep2",
	      "disabled": !_vm.contractCred
	    },
	    on: {
	      "click": function($event) {
	        return _vm.nextStep()
	      }
	    }
	  }, [_vm._v("\n          Avançar\n          "), _c('i', {
	    staticClass: "icon-circle-right"
	  })]) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), (_vm.step == 2) ? [_c('div', {
	    attrs: {
	      "id": "step2"
	    }
	  }, [_c('div', {
	    staticClass: "margin-20"
	  }, [_c('div', {
	    staticClass: "row margin-b20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('transfer-shipper-value', {
	    attrs: {
	      "favored": _vm.favored,
	      "balance": _vm.contractData.currentBalance.currentTotalBalance
	    },
	    model: {
	      value: (_vm.transfValue),
	      callback: function($$v) {
	        _vm.transfValue = $$v
	      },
	      expression: "transfValue"
	    }
	  }), _vm._v(" "), (_vm.checkTransferValue) ? _c('div', {
	    staticClass: "alert alert-warning margin-t20 text-center",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._v("\n                Valor acima do saldo disponível.\n              ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "back-button-box"
	  }, [_c('button', {
	    staticClass: "btn no-btn",
	    attrs: {
	      "id": "backStep1"
	    },
	    on: {
	      "click": function($event) {
	        _vm.step = _vm.step - 1
	      }
	    }
	  }, [_vm._v("\n              Voltar\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "action-buttons-box"
	  }, [_c('router-link', {
	    staticClass: "btn btn-danger found",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button",
	      "data-toggle": "tooltip",
	      "title": "Cancelar"
	    }
	  }, [_vm._v("\n              Cancelar\n            ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary add",
	    class: {
	      disabled: _vm.checkValue || _vm.checkTransferValue
	    },
	    attrs: {
	      "disabled": _vm.checkValue || _vm.checkTransferValue,
	      "id": "advanceStep3"
	    },
	    on: {
	      "click": function($event) {
	        _vm.step = _vm.step + 1
	      }
	    }
	  }, [_vm._v("\n              Avançar\n              "), _c('i', {
	    staticClass: "icon-circle-right"
	  })])], 1)])])] : _vm._e(), _vm._v(" "), (_vm.step == 3) ? [_c('div', {
	    attrs: {
	      "id": "step3"
	    }
	  }, [_c('ul', {
	    staticClass: "transfer-summary"
	  }, [_c('li', [_vm._v("\n            Favorecido\n            "), _c('span', [_vm._v(_vm._s(_vm.userReceive.companyName))])]), _vm._v(" "), _c('li', [_vm._v("\n            CNPJ\n            "), _c('span', [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.userReceive.taxIdNumber)))])]), _vm._v(" "), _c('li', [_vm._v("\n            Contrato\n            "), _c('span', [_vm._v(_vm._s(_vm.contractCred.contractId))])]), _vm._v(" "), _c('li', [_vm._v("\n            Plano\n            "), _c('span', [_vm._v(_vm._s(_vm.contractCred.planName))])]), _vm._v(" "), _c('li', [_vm._v("\n            Valor da transferência\n            "), _c('span', [_vm._v("R$ " + _vm._s(_vm._f("cents")(_vm.fomatedValue)))])]), _vm._v(" "), _c('li', [_vm._v("\n            Taxa da transferência\n            "), _c('span', [_vm._v("R$ " + _vm._s(_vm._f("cents")(_vm.fomatedTax)))])]), _vm._v(" "), _c('li', [_vm._v("\n            Total da transferência\n            "), _c('span', [_vm._v("R$ " + _vm._s(_vm._f("cents")(_vm.fomatedTotal)))])])]), _vm._v(" "), _c('div', {
	    staticClass: "transfer-summary-mob"
	  }, [_c('p', [_vm._v("FAVORECIDO")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.userReceive.taxIdNumber)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.userReceive.companyName))]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n              Contrato\n              "), _c('span', [_vm._v(_vm._s(_vm.contractCred.contractId))])]), _vm._v(" "), _c('li', [_vm._v("\n              Plano\n              "), _c('span', [_vm._v(_vm._s(_vm.contractCred.planName))])]), _vm._v(" "), _c('li', [_vm._v("\n              Valor da transferência\n              "), _c('span', [_vm._v("R$ " + _vm._s(_vm._f("cents")(_vm.fomatedValue)))])]), _vm._v(" "), _c('li', [_vm._v("\n              Taxa da transferência\n              "), _c('span', [_vm._v("R$ " + _vm._s(_vm._f("cents")(_vm.fomatedTax)))])]), _vm._v(" "), _c('li', [_vm._v("\n              Total da transferência\n              "), _c('span', [_vm._v("R$ " + _vm._s(_vm._f("cents")(_vm.fomatedTotal)))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-b20"
	  }, [(_vm.status == 'ERROR') ? _c('div', {
	    staticClass: "alert alert-danger",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.messageError) + "\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "back-button-box"
	  }, [_c('button', {
	    staticClass: "btn no-btn",
	    attrs: {
	      "id": "backStep3"
	    },
	    on: {
	      "click": function($event) {
	        _vm.step = _vm.step - 1
	      }
	    }
	  }, [_vm._v("\n            Voltar\n          ")])]), _vm._v(" "), _c('div', {
	    staticClass: "action-buttons-box"
	  }, [_c('router-link', {
	    staticClass: "btn btn-danger found",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button",
	      "data-toggle": "tooltip",
	      "title": "Cancelar"
	    }
	  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary end",
	    on: {
	      "click": function($event) {
	        return _vm.transfer()
	      }
	    }
	  }, [_vm._v("\n            Transferir\n          ")])], 1)])] : _vm._e(), _vm._v(" "), (_vm.step == 4) ? [_c('div', {
	    attrs: {
	      "id": "step4"
	    }
	  }, [_c('h1', [_vm._v("Transferência realizada com sucesso!")]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "/static/Icon-check-circle.svg",
	      "alt": "icon-check-circle"
	    }
	  }), _vm._v(" "), _c('div', {}, [_c('router-link', {
	    staticClass: "btn btn-outline",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button",
	      "data-toggle": "tooltip",
	      "title": "Voltar a meus planos"
	    }
	  }, [_vm._v("\n            OK\n          ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-full",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showModalReceipt = true;
	        _vm.modalReceipt();
	      }
	    }
	  }, [_vm._v("\n            Comprovante de transferência\n          ")])], 1)])] : _vm._e()], 2), _vm._v(" "), (_vm.showModalReceipt) ? _c('modal-receipt-transfer', {
	    attrs: {
	      "orderData": _vm.orderData
	    },
	    on: {
	      "close": _vm.close
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-avatar"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Identificação do favorecido")]), _vm._v(" "), _c('small', [_vm._v("Identificação do favorecido")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-money-transfer"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Valor da transferência")]), _vm._v(" "), _c('small', [_vm._v("Valor da transferência")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-confirmation-check"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Resumo e confirmação")]), _vm._v(" "), _c('small', [_vm._v("Resumo e confirmação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('p', [_vm._v(" ")]), _vm._v(" "), _c('p', [_vm._v("Contrato")]), _vm._v(" "), _c('p', [_vm._v("Razão Social")])])
	}]}

/***/ }),
/* 2216 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('title-user', [_vm._v("Comprovantes")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20"
	  }, [_c('div', {
	    staticClass: "col-xs-12 min-content"
	  }, [_c('ul', [_c('li', {
	    staticClass: "content-box"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "request-kind-block"
	  }, [_c('router-link', {
	    staticClass: "purple",
	    attrs: {
	      "tag": "a",
	      "to": {
	        name: 'transfer-shipper-voucher-detail'
	      }
	    }
	  }, [_vm._v("\n              07348164723981\n            ")])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "buttons-block"
	  }, [_c('a', {
	    staticClass: "btn btn-back btn-line",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "Imprimir comprovante"
	    }
	  }, [_c('i', {
	    staticClass: "icon-printer"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-back btn-line",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "Baixar comprovante em PDF"
	    }
	  }, [_c('i', {
	    staticClass: "icon-pdf"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "category-block"
	  }, [_c('small', {
	    staticClass: "label-information"
	  }, [_vm._v("Tipo de Transação")]), _vm._v(" "), _c('div', {
	    staticClass: "label-category"
	  }, [_vm._v("Transferência de Crédito")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "favored-block"
	  }, [_c('small', {
	    staticClass: "label-information"
	  }, [_vm._v("Favorecido")]), _vm._v(" "), _c('div', {
	    staticClass: "label-favored"
	  }, [_vm._v("Transfolha Transportes")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "value-block green"
	  }, [_vm._v("\n            R$ "), _c('b', [_vm._v("5.000,00")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "date-block"
	  }, [_c('div', {
	    staticClass: "time-block"
	  }, [_c('i', {
	    staticClass: "icon-clock"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "inline"
	  }, [_c('div', [_vm._v("06/12/2017")]), _vm._v(" "), _c('div', [_vm._v("13:05")])])])
	}]}

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._l((_vm.arrayCartao), function(paymentC) {
	    return _c('div', {
	      staticClass: "content-box methods cred margin-b20"
	    }, [_c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col-md-3"
	    }, [_c('div', {
	      staticClass: "radio-blue category",
	      class: {
	        'active': paymentC.contractPaymentMethodId == _vm.contractPaymentMethodId
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.contractPaymentMethodId),
	        expression: "contractPaymentMethodId"
	      }],
	      staticClass: "radiobtn",
	      attrs: {
	        "id": 'credit-card' + paymentC.contractPaymentMethodId,
	        "type": "radio",
	        "name": "contractPaymentMethod"
	      },
	      domProps: {
	        "value": paymentC.contractPaymentMethodId,
	        "checked": _vm._q(_vm.contractPaymentMethodId, paymentC.contractPaymentMethodId)
	      },
	      on: {
	        "change": function($event) {
	          _vm.contractPaymentMethodId = paymentC.contractPaymentMethodId
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      staticClass: "radio-label label-h4",
	      attrs: {
	        "for": 'credit-card' + paymentC.contractPaymentMethodId
	      },
	      on: {
	        "click": function($event) {
	          _vm.paymentSelected = paymentC
	        }
	      }
	    }, [_vm._v("Cartão de Crédito")]), _vm._v(" "), _c('div', {
	      staticClass: "check first"
	    })])]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-6 text-center"
	    }, [_c('img', {
	      staticClass: "credit-card",
	      attrs: {
	        "src": _vm.imageUrl(paymentC),
	        "alt": paymentC.name,
	        "width": "49",
	        "height": "33"
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "border-right-gray"
	    }, [_c('h4', {
	      staticClass: "bold no-margin"
	    }, [_vm._v(_vm._s(paymentC.creditCard.number))]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin"
	    }, [_vm._v(_vm._s('Válido até ' + paymentC.creditCard.expirationMonth + '/' + paymentC.creditCard.expirationYear))])]), _vm._v(" "), _c('div', [_c('h4', {
	      staticClass: "bold no-margin"
	    }, [_vm._v(_vm._s(paymentC.creditCard.ownerName))]), _vm._v(" "), _c('p', {
	      staticClass: "no-margin"
	    }, [_vm._v("Nome do titular do cartão")])])]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-3 text-right"
	    }, [_c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.contractPaymentMethodId == paymentC.contractPaymentMethodId),
	        expression: "contractPaymentMethodId==paymentC.contractPaymentMethodId"
	      }],
	      staticClass: "form-group csc",
	      class: {
	        'has-error': _vm.errors.has('secureCodeCreditCard')
	      }
	    }, [_c('label', {
	      staticClass: "label-csc",
	      attrs: {
	        "for": ""
	      }
	    }, [_vm._v("Código de Segurança:")]), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.paymentSelected.secureCodeCreditCard),
	        expression: "paymentSelected.secureCodeCreditCard"
	      }, {
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required|min:3'),
	        expression: "'required|min:3'"
	      }, {
	        name: "only-numbers",
	        rawName: "v-only-numbers"
	      }],
	      staticClass: "form-control csc inline",
	      attrs: {
	        "type": "text",
	        "name": "secureCodeCreditCard",
	        "maxlength": "4"
	      },
	      domProps: {
	        "value": (_vm.paymentSelected.secureCodeCreditCard)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(_vm.paymentSelected, "secureCodeCreditCard", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), _c('img', {
	      attrs: {
	        "src": __webpack_require__(226),
	        "alt": ""
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "help-block"
	    }, [_c('span', {
	      staticClass: "three-dots"
	    }, [_vm._v(_vm._s(_vm.errors.first('secureCodeCreditCard')))])])])])])])
	  }), _vm._v(" "), _vm._l((_vm.arrayDebito), function(paymentD) {
	    return _c('div', {
	      staticClass: "content-box methods margin-b20"
	    }, [_c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col-md-3"
	    }, [_c('div', {
	      staticClass: "radio-blue category",
	      class: {
	        'active': paymentD.contractPaymentMethodId == _vm.contractPaymentMethodId
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.contractPaymentMethodId),
	        expression: "contractPaymentMethodId"
	      }],
	      staticClass: "radiobtn",
	      attrs: {
	        "id": 'debit' + paymentD.contractPaymentMethodId,
	        "type": "radio",
	        "name": "contractPaymentMethod"
	      },
	      domProps: {
	        "value": paymentD.contractPaymentMethodId,
	        "checked": _vm._q(_vm.contractPaymentMethodId, paymentD.contractPaymentMethodId)
	      },
	      on: {
	        "change": function($event) {
	          _vm.contractPaymentMethodId = paymentD.contractPaymentMethodId
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      staticClass: "radio-label label-h4",
	      attrs: {
	        "for": 'debit' + paymentD.contractPaymentMethodId
	      },
	      on: {
	        "click": function($event) {
	          _vm.paymentSelected = paymentD
	        }
	      }
	    }, [_vm._v("Débito em Conta")]), _vm._v(" "), _c('div', {
	      staticClass: "check first"
	    })])]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-6 text-center"
	    }, [_c('img', {
	      staticClass: "credit-card",
	      attrs: {
	        "src": _vm.imageUrl(paymentD),
	        "alt": paymentD.name,
	        "width": "49",
	        "height": "33"
	      }
	    }), _vm._v(" "), _c('p', {
	      staticClass: "info-bank"
	    }, [_vm._v("Banco "), _c('b', [_vm._v(_vm._s(paymentD.bankAccount.name))])]), _vm._v(" "), _c('p', {
	      staticClass: "info-bank"
	    }, [_vm._v("Agência "), _c('b', [_vm._v(_vm._s(paymentD.bankAccount.agencyNumber))])]), _vm._v(" "), _c('p', {
	      staticClass: "info-bank"
	    }, [_vm._v("C/C "), _c('b', [_vm._v(_vm._s(paymentD.bankAccount.accountNumber + ' -  ' + paymentD.bankAccount.accountDigit))])])])])])
	  }), _vm._v(" "), (_vm.bankBillOption) ? _c('div', {
	    staticClass: "content-box methods margin-b20"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "radio-blue category",
	    class: {
	      'active': 'newBankBill' == _vm.contractPaymentMethodId
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contractPaymentMethodId),
	      expression: "contractPaymentMethodId"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "new-invoice",
	      "type": "radio",
	      "name": "contractPaymentMethod",
	      "value": "newBankBill"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.contractPaymentMethodId, "newBankBill")
	    },
	    on: {
	      "change": function($event) {
	        _vm.contractPaymentMethodId = "newBankBill"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label label-h4",
	    attrs: {
	      "for": "new-invoice"
	    }
	  }, [_vm._v("Boleto Bancário")]), _vm._v(" "), _c('div', {
	    staticClass: "check first"
	  })])])])]) : _vm._e(), _vm._v(" "), (_vm.typesAlowed.creditCard || _vm.typesAlowed.bankAcount) ? _c('div', {
	    staticClass: "content-box methods margin-b20"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "radio-blue category",
	    class: {
	      'active': 'newPayment' == _vm.contractPaymentMethodId
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contractPaymentMethodId),
	      expression: "contractPaymentMethodId"
	    }],
	    staticClass: "radiobtn",
	    attrs: {
	      "id": "new-payment",
	      "type": "radio",
	      "name": "contractPaymentMethod",
	      "value": "newPayment"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.contractPaymentMethodId, "newPayment")
	    },
	    on: {
	      "change": function($event) {
	        _vm.contractPaymentMethodId = "newPayment"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "radio-label label-h4",
	    attrs: {
	      "for": "new-payment"
	    }
	  }, [_vm._v("Nova forma de pagamento")]), _vm._v(" "), _c('div', {
	    staticClass: "check first"
	  })])])])]) : _vm._e(), _vm._v(" "), (_vm.contractPaymentMethodId == 'newPayment') ? _c('payment', {
	    ref: "payment",
	    attrs: {
	      "payment": _vm.payment,
	      "planId": _vm.planId,
	      "addressMailing": _vm.addressMailing,
	      "creditCardOptions": _vm.creditCardOptions,
	      "bankAccountOptions": _vm.bankAccountOptions,
	      "bankBillOption": undefined
	    }
	  }) : _vm._e(), _vm._v(" "), ('newBankBill' == _vm.contractPaymentMethodId) ? _c('div', {
	    staticClass: "alert alert-info"
	  }, [_vm._v("\n        O tempo mínimo para compensação e disponibilização do crédito de  boletos bancários junto às praças de pedágio é de 3 dias úteis."), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Para mais informações, entre em contato com a Central de Relacionamento pelo número 4000 2901 (regiões metropolitanas) ou 0800 777 1022 (demais localidades).")])]) : _vm._e()], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 2218 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('ul', {
	    staticClass: "wizard margin-20"
	  }, [_c('li', {
	    class: {
	      active: _vm.step == 0, past: _vm.step > 0
	    }
	  }, [_vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('li', {
	    class: {
	      active: _vm.step == 1, past: _vm.step > 1
	    }
	  }, [_vm._m(3), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('li', {
	    class: {
	      active: _vm.step == 2, past: _vm.step > 2
	    }
	  }, [_vm._m(5), _vm._v(" "), _vm._m(6)])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [(_vm.step == 0) ? _c('div', {}, [_c('p', [_vm._v("Para começar informe a validade deste vale-pedágio e a rota a ser percorrida:")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "content-grey"
	  }, [_c('p', {
	    staticClass: "bold no-margin"
	  }, [_vm._v("Validade")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row-dates"
	  }, [_c('div', {
	    staticClass: "form-group col-6"
	  }, [_c('label', {
	    attrs: {
	      "for": "dataInicioViagem"
	    }
	  }, [_vm._v("Início da viagem")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dataInicioViagem),
	      expression: "dataInicioViagem"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "name": "dataInicioViagem",
	      "type": "datetime-local",
	      "min": _vm.minDate,
	      "max": _vm.dataFimViagem
	    },
	    domProps: {
	      "value": (_vm.dataInicioViagem)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.dataInicioViagem = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group  col-6"
	  }, [_c('label', {
	    attrs: {
	      "for": "dataFimViagem"
	    }
	  }, [_vm._v("Fim da viagem")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dataFimViagem),
	      expression: "dataFimViagem"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "name": "dataFimViagem",
	      "type": "datetime-local",
	      "min": _vm.dataInicioViagem,
	      "max": _vm.maxDate
	    },
	    domProps: {
	      "value": (_vm.dataFimViagem)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.dataFimViagem = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _vm._m(7)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('route-resume', {
	    attrs: {
	      "routeIdSelected": _vm.routeSelected
	    },
	    model: {
	      value: (_vm.routeSelected),
	      callback: function($$v) {
	        _vm.routeSelected = $$v
	      },
	      expression: "routeSelected"
	    }
	  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.step == 1) ? _c('div', {
	    staticClass: "margin-b20"
	  }, [_c('div', {
	    staticClass: "row margin-b30"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "search-box inline"
	  }, [_c('p', {
	    staticClass: "bold text-center no-margin"
	  }, [_vm._v("Informe a placa do veículo:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.plate),
	      expression: "plate",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "mask-plate",
	      rawName: "v-mask-plate"
	    }],
	    staticClass: "form-control search text-center bold upper",
	    attrs: {
	      "type": "text",
	      "name": "plate",
	      "data-vv-validate-on": "blur",
	      "placeholder": "Ex: ABC-0000",
	      "autofocus": "autofocus"
	    },
	    domProps: {
	      "value": (_vm.plate)
	    },
	    on: {
	      "keypress": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.findPlate.apply(null, arguments)
	      },
	      "change": function($event) {
	        _vm.plate = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "btn-box inline"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": _vm.findPlate
	    }
	  }, [_c('i', {
	    staticClass: "icon-search align-icon-left-white"
	  }), _vm._v("\n                Buscar\n              ")])])])]), _vm._v(" "), (_vm.vehicle) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "content-grey"
	  }, [_c('p', {
	    staticClass: "bold no-margin"
	  }, [_vm._v("Dados do veículo")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "form-group input-box-control"
	  }, [_vm._m(8), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "brandName",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.vehicle.brandName + ' ' + _vm.vehicle.nodelName
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group input-box-control"
	  }, [_vm._m(9), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "razao",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.vehicle.tagSerialNumber
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group input-box-control"
	  }, [_vm._m(10), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('dropdown', {
	    staticClass: "dropdown-lg",
	    attrs: {
	      "options": _vm.axes,
	      "value": _vm.vehicle.category,
	      "fieldValue": "category_artesp_id"
	    },
	    model: {
	      value: (_vm.axesId),
	      callback: function($$v) {
	        _vm.axesId = $$v
	      },
	      expression: "axesId"
	    }
	  })], 1)]), _vm._v(" "), (!_vm.enableRNTRC) ? _c('p', {
	    staticClass: "bold margin-t30 margin-b0"
	  }, [_vm._v("Dados do transportador")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.vehicle.companyName && !_vm.enableRNTRC) ? _c('div', {
	    staticClass: "form-group input-box-control"
	  }, [_vm._m(11), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [(_vm.nomeTransportador) ? _c('input', {
	    staticClass: "form-control small upper",
	    attrs: {
	      "type": "text",
	      "name": "razao",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.nomeTransportador
	    }
	  }) : _c('input', {
	    staticClass: "form-control small upper",
	    attrs: {
	      "type": "text",
	      "name": "razao",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.vehicle.companyName
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.vehicle.companyTradeName && !_vm.enableRNTRC) ? _c('div', {
	    staticClass: "form-group input-box-control"
	  }, [_vm._m(12), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    staticClass: "form-control small upper",
	    attrs: {
	      "type": "text",
	      "name": "razao",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.vehicle.companyTradeName
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.vehicle.companyTradeName && !_vm.enableRNTRC) ? _c('div', {
	    staticClass: "form-group input-box-control"
	  }, [_vm._m(13), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "razao",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.documentoTransportador || _vm.vehicle.taxIdNumber
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.vehicle.personName && !_vm.enableRNTRC) ? _c('div', {
	    staticClass: "form-group input-box-control"
	  }, [_vm._m(14), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [(_vm.nomeTransportador) ? _c('input', {
	    staticClass: "form-control small upper",
	    attrs: {
	      "type": "text",
	      "name": "cpf",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.nomeTransportador
	    }
	  }) : _c('input', {
	    staticClass: "form-control small upper",
	    attrs: {
	      "type": "text",
	      "name": "cpf",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.vehicle.personName + ' ' + _vm.vehicle.personLastName
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.vehicle.personName && !_vm.enableRNTRC) ? _c('div', {
	    staticClass: "form-group input-box-control"
	  }, [_vm._m(15), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "cpf",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.documentoTransportador || _vm.vehicle.taxIdNumber
	    }
	  })])]) : _vm._e(), _vm._v(" "), (!_vm.enableRNTRC) ? _c('div', {
	    staticClass: "form-group input-box-control"
	  }, [_vm._m(16), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "razao",
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.vehicle.rntrc
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.rntrcRejected && !_vm.enableRNTRC) ? _c('div', {
	    staticClass: "rntrc-exception"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.createException),
	      expression: "createException"
	    }],
	    staticClass: "rntrc-exception-check",
	    attrs: {
	      "id": "createException",
	      "type": "checkbox",
	      "name": "createException"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.createException) ? _vm._i(_vm.createException, null) > -1 : (_vm.createException)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.createException,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.createException = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.createException = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.createException = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "rntrc-exception-label",
	    attrs: {
	      "for": "createException"
	    }
	  }, [_vm._v("Criar exceção")]), _vm._v(" "), _c('p', {
	    staticClass: "rntrc-exception-hint"
	  }, [_vm._v("Ao marcar esta opção, você declara ser responsável pela veracidade dos dados e autoriza a emissão sem validação ANTT.")]), _vm._v(" "), (!_vm.createException) ? _c('p', {
	    staticClass: "rntrc-exception-required"
	  }, [_vm._v("Para continuar, selecione uma ação válida.")]) : _c('p', {
	    staticClass: "rntrc-exception-success"
	  }, [_vm._v("A exceção será criada no momento da emissão do Vale-Pedágio.")])]) : _vm._e(), _vm._v(" "), (!_vm.enableRNTRC) ? _c('hr', {
	    staticStyle: {
	      "margin": "20px 0"
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.enableRNTRC) ? _c('div', {
	    staticStyle: {
	      "display": "flex",
	      "justify-content": "flex-end",
	      "margin": "15px 0"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-auto",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": _vm.showRNTRC
	    }
	  }, [_vm._v("\n                  Alterar Transportador\n                ")])]) : _vm._e()])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('div', {
	    staticClass: "form-box margin-b20 padding-b10"
	  }, [_c('b', {
	    staticClass: "title-identification"
	  }, [_vm._v("Resumo e Confirmação do Pedido")]), _vm._v(" "), _c('div', {
	    staticClass: "form-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(17), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 user-data-resume"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(18), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold upper"
	  }, [_vm._v(_vm._s(_vm.emissor) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(19), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.user.taxIdNumber)) + " ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 user-data-resume"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(20), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold upper"
	  }, [_vm._v(_vm._s(_vm.transportador) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(21), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [(_vm.documentoTransportador) ? _c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.documentoTransportador)) + " ")]) : _c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.vehicle.taxIdNumber)) + " ")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20"
	  }, [_vm._m(22), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 user-data-resume"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(23), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold upper"
	  }, [_vm._v(_vm._s(_vm.routeSelected.name) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(24), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm.routeOrigin) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(25), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm.routeDestination) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(26), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm._f("dateTime")(_vm.dataInicioViagem)) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(27), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm._f("dateTime")(_vm.dataFimViagem)) + " ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 user-data-resume"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(28), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold upper"
	  }, [_c('span', {
	    staticClass: "plate"
	  }, [_vm._v(_vm._s(_vm.vehicle.plate))]), _vm._v(" ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(29), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm.category) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(30), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm.vehicle.brandName) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(31), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm.vehicle.nodelName) + " ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(32), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('p', {
	    staticClass: "three-dots bold"
	  }, [_vm._v(_vm._s(_vm.vehicle.tagSerialNumber) + " ")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('b', [_vm._v("Rota Detalhada e Valores")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table"
	  }, [_vm._m(33), _vm._v(" "), _c('tbody', _vm._l((_vm.priceTolls.tolls), function(p, index) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(p.praca))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.concessionaria))]), _vm._v(" "), _c('td', {
	      staticClass: "text-right"
	    }, [_vm._v(_vm._s(_vm._f("cents")(p.price)))])])
	  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("TOTAL")]), _vm._v(" "), _c('td', {
	    staticClass: "text-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.priceTolls.totalValue)))])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row margin-t20"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('b', [_vm._v("Informações opcionais")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "doc-box text-center"
	  }, [_c('div', {
	    staticClass: "inline text-right margin-b10"
	  }, [_vm._m(34), _vm._v(" "), _c('div', {
	    staticClass: "input-box doc"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.motorista),
	      expression: "motorista"
	    }],
	    staticClass: "form-control search",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "value": ""
	    },
	    domProps: {
	      "value": (_vm.motorista)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.motorista = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "inline text-left"
	  }, [_vm._m(35), _vm._v(" "), _c('div', {
	    staticClass: "input-box doc"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.externalId),
	      expression: "externalId"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control search",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "value": "",
	      "id": "externalId"
	    },
	    domProps: {
	      "value": (_vm.externalId)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.externalId = $event.target.value
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "doc-box text-center"
	  }, [_c('div', {
	    staticClass: "inline text-right margin-b10"
	  }, [_vm._m(36), _vm._v(" "), _c('div', {
	    staticClass: "input-box doc"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.campo1),
	      expression: "campo1"
	    }],
	    staticClass: "form-control search",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "value": "",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.campo1)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.campo1 = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "inline text-left"
	  }, [_vm._m(37), _vm._v(" "), _c('div', {
	    staticClass: "input-box doc"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.campo2),
	      expression: "campo2"
	    }],
	    staticClass: "form-control search",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "value": "",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.campo2)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.campo2 = $event.target.value
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "doc-box text-center"
	  }, [_c('div', {
	    staticClass: "inline text-right margin-b10"
	  }, [_vm._m(38), _vm._v(" "), _c('div', {
	    staticClass: "input-box doc"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.campo3),
	      expression: "campo3"
	    }],
	    staticClass: "form-control search",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "value": "",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.campo3)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.campo3 = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "inline text-left"
	  }, [_vm._m(39), _vm._v(" "), _c('div', {
	    staticClass: "input-box doc"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.campo4),
	      expression: "campo4"
	    }],
	    staticClass: "form-control search",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "value": "",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.campo4)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.campo4 = $event.target.value
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "doc-box text-center"
	  }, [_c('div', {
	    staticClass: "inline text-right margin-b10"
	  }, [_vm._m(40), _vm._v(" "), _c('div', {
	    staticClass: "input-box doc"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.campo5),
	      expression: "campo5"
	    }],
	    staticClass: "form-control search",
	    attrs: {
	      "type": "text",
	      "name": "",
	      "value": "",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.campo5)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.campo5 = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _vm._m(41)])])])])]) : _vm._e()]), _vm._v(" "), (_vm.enableRNTRC) ? _c('div', {
	    staticClass: "col-xs-12 margin-b20"
	  }, [_c('div', {
	    staticClass: "content-grey"
	  }, [_c('p', {
	    staticClass: "bold margin-t10 margin-b0"
	  }, [_vm._v("Dados do transportador")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "form-group input-box-control margin-t20"
	  }, [_vm._m(42), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rntrcOwnerName),
	      expression: "rntrcOwnerName"
	    }],
	    staticClass: "form-control small upper",
	    attrs: {
	      "autofocus": "autofocus",
	      "type": "text",
	      "name": "rntrcOwnerName"
	    },
	    domProps: {
	      "value": (_vm.rntrcOwnerName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.rntrcOwnerName = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group input-box-control",
	    class: {
	      'has-error': _vm.errors.has('rntrcDocument')
	    }
	  }, [_vm._m(43), _vm._v(" "), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "mask-cpf-cnpj",
	      rawName: "v-mask-cpf-cnpj"
	    }, {
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.rntrcDocument),
	      expression: "rntrcDocument",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cpfCnpj'),
	      expression: "'required|cpfCnpj'"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "rntrcDocument",
	      "data-vv-validate-on": "blur"
	    },
	    domProps: {
	      "value": (_vm.rntrcDocument)
	    },
	    on: {
	      "change": function($event) {
	        _vm.rntrcDocument = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('rntrcDocument')))])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "display": "flex",
	      "justify-content": "flex-end",
	      "margin-top": "15px",
	      "gap": "5px"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-back",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": _vm.cancelRNTRC
	    }
	  }, [_vm._v("\n              Cancelar\n            ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": _vm.validateDocument
	    }
	  }, [_vm._v("\n              Validar\n            ")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12"
	  }, [(_vm.msgError) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-b20"
	  }, [_c('div', {
	    staticClass: "alert alert-danger",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._v(_vm._s(_vm.msgError))])])]) : _vm._e()])]), _vm._v(" "), (_vm.showForceTransfer) ? _c('div', {
	    staticClass: "row col-md-12"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.forceTransfer),
	      expression: "forceTransfer"
	    }],
	    staticClass: "check-terms",
	    attrs: {
	      "id": "force",
	      "type": "checkbox",
	      "name": "forceTransfer"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.forceTransfer) ? _vm._i(_vm.forceTransfer, null) > -1 : (_vm.forceTransfer)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.forceTransfer,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.forceTransfer = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.forceTransfer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.forceTransfer = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "label-terms",
	    attrs: {
	      "for": "force"
	    }
	  }, [_vm._v("\n      A emissão do VPO se dará quando normalizado a falha de comunicação. O valor de recarga será confirmado de modo automático, deseja confirmar?\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "margin-t10"
	  }, [_c('div', {
	    staticClass: "back-button-box"
	  }, [(_vm.step > 0) ? _c('button', {
	    staticClass: "btn btn-back",
	    on: {
	      "click": function($event) {
	        return _vm.backStep()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n            Voltar\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "action-buttons-box"
	  }, [_c('button', {
	    staticClass: "btn btn-danger",
	    on: {
	      "click": function($event) {
	        return _vm.cancelar()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-cancel align-icon-left-white"
	  }), _vm._v("\n            Cancelar\n          ")]), _vm._v(" "), (_vm.step < 2) ? _c('button', {
	    staticClass: "btn btn-purple add",
	    attrs: {
	      "disabled": _vm.enableRNTRC || (_vm.rntrcRejected && !_vm.createException)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.nextStep()
	      }
	    }
	  }, [_vm._v("\n            Avançar\n            "), _c('i', {
	    staticClass: "icon-circle-right align-icon-right-white"
	  })]) : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('button', {
	    staticClass: "btn btn-success end",
	    on: {
	      "click": function($event) {
	        return _vm.doRequest()
	      }
	    }
	  }, [_vm._v("\n            Confirmar Emissão\n            "), _c('i', {
	    staticClass: "icon-tick align-icon-right-white"
	  })]) : _vm._e()])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title title-plans"
	  }, [_vm._v("Vale-pedágio")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-route-chrono"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Etapa 1")]), _vm._v(" "), _c('small', {
	    staticClass: "no-margin"
	  }, [_vm._v("Data e Rota")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-truck"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Etapa 2")]), _vm._v(" "), _c('small', {
	    staticClass: "no-margin"
	  }, [_vm._v("Veículo e Transportador")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-confirmation-check"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Etapa 3")]), _vm._v(" "), _c('small', {
	    staticClass: "no-margin"
	  }, [_vm._v("Resumo e confirmação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('b', [_c('i', {
	    staticClass: "icon-info",
	    attrs: {
	      "data-toggle": "tooltip",
	      "data-placement": "bottom",
	      "title": "A validade é o período em dias que o transportador terá para realizar a viagem."
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', {
	    staticClass: "bold"
	  }, [_vm._v("Marca e Modelo:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', {
	    staticClass: "bold"
	  }, [_vm._v("N° TAG:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', {
	    staticClass: "bold"
	  }, [_vm._v("Categoria:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', {
	    staticClass: "bold"
	  }, [_vm._v("Razão Social:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', {
	    staticClass: "bold"
	  }, [_vm._v("Nome Fantasia:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', {
	    staticClass: "bold"
	  }, [_vm._v("CNPJ:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', {
	    staticClass: "bold"
	  }, [_vm._v("Nome:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', {
	    staticClass: "bold"
	  }, [_vm._v("CPF:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', {
	    staticClass: "bold"
	  }, [_vm._v("RNTRC:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('b', [_vm._v("Dados dos Envolvidos")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Emissor:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("CNPJ Emissor:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Transportador:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("CPF/CNPJ Transportador:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('b', [_vm._v("Viagem e Veículo")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Rota:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Origem:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Destino:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Data Início VP:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Data Expiração VP:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Placa Veículo:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Categoria Veículo:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Marca:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("Modelo:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-5 text-right"
	  }, [_c('p', [_vm._v("N° TAG:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "width": "50%"
	    }
	  }, [_vm._v("PRAÇAS DE PEDÁGIO")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "35%"
	    }
	  }, [_vm._v("CONCESSIONÁRIA")]), _vm._v(" "), _c('th', {
	    staticClass: "text-right",
	    attrs: {
	      "width": "15%"
	    }
	  }, [_vm._v("VALOR(R$)")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Nome do motorista")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Identificador Vp (cliente):")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Campo 1:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Campo 2:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Campo 3:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Campo 4:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Campo 5:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline text-left"
	  }, [_c('div', {
	    staticClass: "label-box"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "input-box doc"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', {
	    staticClass: "bold"
	  }, [_vm._v("Nome/Razão social:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', {
	    staticClass: "bold"
	  }, [_vm._v("CPF/CNPJ do RNTRC:")])])
	}]}

/***/ }),
/* 2219 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async.opacity",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "opacity": true
	      }
	    }],
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 map-sidebar"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('origin')
	    }
	  }, [_c('label', {
	    staticClass: "label-trip"
	  }, [_vm._v("Origem:")]), _vm._v(" "), _c('i', {
	    staticClass: "pin-origin"
	  }), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success btn-add-pin",
	    attrs: {
	      "type": "button",
	      "data-toggle": "tooltip",
	      "title": "Adicionar um local de passagem"
	    },
	    on: {
	      "click": _vm.addWayPoint
	    }
	  }, [_c('i', {
	    staticClass: "icon icon-plus"
	  })]), _vm._v(" "), _c('input', {
	    staticClass: "form-control input-origin",
	    attrs: {
	      "name": "origin",
	      "id": "origin",
	      "placeholder": "Digite um local de origem"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n        " + _vm._s(_vm.errors.first('origin')) + "\n      ")])]), _vm._v(" "), _vm._l((20), function(o, i) {
	    return _c('div', {
	      key: i
	    }, [_c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (i < _vm.qtdWayPoints),
	        expression: "i < qtdWayPoints"
	      }],
	      staticClass: "form-group"
	    }, [_c('label', {
	      staticClass: "label-trip"
	    }, [_vm._v("Passagem:")]), _vm._v(" "), _c('i', {
	      staticClass: "pin-waypoint"
	    }), _vm._v(" "), _c('button', {
	      staticClass: "btn btn-danger btn-del-pin",
	      attrs: {
	        "type": "button",
	        "data-toggle": "tooltip",
	        "title": "Remover local de passagem"
	      },
	      on: {
	        "click": _vm.removeWayPoint
	      }
	    }, [_c('i', {
	      staticClass: "icon icon-minus"
	    })]), _vm._v(" "), _c('input', {
	      staticClass: "form-control input-origin",
	      attrs: {
	        "name": 'waypoint' + i,
	        "id": 'waypoint' + i,
	        "placeholder": "Digite um local de passagem"
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "help-block"
	    }, [_vm._v("\n          " + _vm._s(_vm.errors.first('waypoint' + i)) + "\n        ")])])])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('destination')
	    }
	  }, [_c('label', {
	    staticClass: "label-trip"
	  }, [_vm._v("Destino:")]), _vm._v(" "), _c('i', {
	    staticClass: "pin-destination"
	  }), _vm._v(" "), _c('input', {
	    staticClass: "form-control input-destination",
	    attrs: {
	      "name": "destination",
	      "id": "destination",
	      "placeholder": "Digite um local de destino"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n        " + _vm._s(_vm.errors.first('origin')) + "\n      ")])]), _vm._v(" "), (_vm.msgError) ? _c('div', {
	    staticClass: "alert alert-error margin-t10"
	  }, [_vm._v("\n      " + _vm._s(_vm.msgError) + "\n    ")]) : _vm._e(), _vm._v(" "), (false) ? _c('div', [_c('label', {
	    staticClass: "block-round-trip"
	  }, [_vm._v("Ida e volta?")]), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "block-axis"
	  }, [_c('label', {
	    staticClass: "block-round-trip"
	  }, [_vm._v("Quantidade de eixos:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.axes),
	      expression: "axes"
	    }],
	    staticClass: "form-control input-axis",
	    attrs: {
	      "type": "number",
	      "name": "axis-number",
	      "value": "2"
	    },
	    domProps: {
	      "value": (_vm.axes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.axes = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.coord),
	      expression: "coord"
	    }],
	    staticClass: "form-control input-destination",
	    attrs: {
	      "placeholder": "Coordenada"
	    },
	    domProps: {
	      "value": (_vm.coord)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.coord = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary btn-calculate",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.plotar
	    }
	  }, [_vm._v("\n      Plotar\n    ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.associateId),
	      expression: "associateId"
	    }],
	    staticClass: "form-control input-destination",
	    attrs: {
	      "placeholder": "associateId"
	    },
	    domProps: {
	      "value": (_vm.associateId)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.associateId = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary btn-calculate",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.plotAssociate
	    }
	  }, [_vm._v("\n      Plotar\n    ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary btn-calculate",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.inverter
	    }
	  }, [_vm._v("\n      Inverter\n    ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary btn-calculate",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.calculate
	    }
	  }, [_vm._v("\n      Calcular\n    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.showSummary) ? _c('div', {
	    staticClass: "result-calculate-trip"
	  }, [_c('ul', {
	    staticClass: "trip-summary-box"
	  }, [_c('li', [_c('i', {
	    staticClass: "icon-road"
	  }), _vm._v(" "), _c('label', {
	    staticClass: "trip-summary-label"
	  }, [_vm._v("Distância:")]), _vm._v(" "), _c('label', {
	    staticClass: "pull-right"
	  }, [_vm._v(_vm._s(_vm.result.totalDistance) + " Km")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "icon-clock"
	  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('label', {
	    staticClass: "pull-right"
	  }, [_vm._v(_vm._s(_vm._f("secondsFormat")(_vm.result.totalTime)))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "icon-toll"
	  }), _vm._v(" "), _c('label', {
	    staticClass: "trip-summary-label"
	  }, [_vm._v("Qtd. de Pedágios:")]), _vm._v(" "), _c('label', {
	    staticClass: "pull-right"
	  }, [_vm._v(_vm._s(_vm.result.tolls.length))])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "icon-coin"
	  }), _vm._v(" "), _c('label', {
	    staticClass: "trip-summary-label"
	  }, [_vm._v("Valor Pedágios:")]), _vm._v(" "), _c('label', {
	    staticClass: "pull-right"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.result.totaltollFeeCost)))])])]), _vm._v(" "), _c('div', {
	    staticClass: "bs-callout bs-callout-primary"
	  }, [_vm._v("\n        Sua viagem irá custar "), _c('b', [_vm._v(_vm._s(_vm._f("cents")(_vm.result.totaltollFeeCost)))]), _vm._v(" em pedágios.\n        Deseja fazer uma recarga?\n      ")]), _vm._v(" "), _vm._m(4)]) : _vm._e()], 2), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8 map-area"
	  }, [_c('div', {
	    ref: "map",
	    attrs: {
	      "id": "map"
	    }
	  })]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": _vm.image
	    }
	  })])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("Viagem")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('p', {
	    staticClass: "margin-b20"
	  }, [_vm._v("\n        Calcule a distância, o tempo estimado e o custo de pedágios da sua viagem, para isso é só preencher os campos abaixo e clicar em calcular:\n      ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pull-right"
	  }, [_c('div', {
	    staticClass: "onoffswitch"
	  }, [_c('input', {
	    staticClass: "onoffswitch-checkbox",
	    attrs: {
	      "type": "checkbox",
	      "id": "round-switch"
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "onoffswitch-label",
	    attrs: {
	      "for": "round-switch"
	    }
	  }, [_c('span', {
	    staticClass: "onoffswitch-inner"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "onoffswitch-switch"
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "trip-summary-label"
	  }, [_vm._v("\n            Tempo Estimado:\n            "), _c('i', {
	    staticClass: "icon-info",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "O tempo é estimado usando como base um veículo de passeio (2 eixos) na velocidade média das vias."
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn btn-success btn-recharge-fit"
	  }, [_vm._v("\n        Recarregar "), _c('b', [_vm._v("R$ 50,00")])])
	}]}

/***/ }),
/* 2220 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vehicle-map"
	  })
	},staticRenderFns: []}

/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "footer-container"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "footer-main"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "footer-top"
	    }
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "list-container"
	  }, [_c('h4', {
	    staticClass: "footer-titles"
	  }, [_vm._v("Dúvidas")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
	    staticClass: "scrollup",
	    attrs: {
	      "to": {
	        name: 'FAQ'
	      }
	    }
	  }, [_vm._v("\n              Perguntas Frequentes\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    staticClass: "scrollup",
	    attrs: {
	      "to": {
	        name: 'guide'
	      }
	    }
	  }, [_vm._v("\n              Guia de Instalação do TAG\n            ")])], 1), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "sales"
	    }
	  }, [_c('h4', {
	    staticClass: "footer-titles"
	  }, [_vm._v("Central de Vendas")]), _vm._v(" "), _c('div', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(506)
	    }
	  }), _vm._v(" "), _c('h5', [_vm._v("0800 777 1022")])]), _vm._v(" "), _c('div', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(506)
	    }
	  }), _vm._v(" "), _c('h5', [_vm._v("4000 2901")])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "phone-container"
	    }
	  }, [_c('div', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1825)
	    }
	  }), _vm._v(" "), _c('h6', [_c('a', {
	    attrs: {
	      "href": "https://wa.me/5511981192574",
	      "target": "_blank"
	    }
	  }, [_vm._v("WhatsApp\n              ")])])]), _vm._v(" "), _c('div', [_c('h6', [_c('a', {
	    attrs: {
	      "href": "https://www.movemais.com",
	      "target": "_blank"
	    }
	  }, [_vm._v("Visite-nos\n              ")])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-container"
	  }, [_c('h4', {
	    staticClass: "footer-titles"
	  }, [_vm._v("Políticas")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
	    attrs: {
	      "href": "/api/v2/archeion/downloadFileArcheion/termos-e-condicoes-gerais-movemais",
	      "target": "_blank"
	    }
	  }, [_vm._v("Termos e Condições\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "/api/v2/archeion/downloadFileArcheion/aviso-de-privacidade-movemais",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n              Aviso de Privacidade\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "/api/v2/archeion/downloadFileArcheion/politica-de-cookies-movemais",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n              Política de Cookies\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "/api/v2/archeion/downloadFileArcheion/politica-de-reembolso-movemais",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n              Política de Reembolso\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "/api/v2/archeion/downloadFileArcheion/regulamento-da-campanha-adesao-gratis-movemais-roadcard",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n              Regulamento da campanha\n            ")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-container"
	  }, [_c('h4', {
	    staticClass: "footer-titles"
	  }, [_vm._v("Compliance")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
	    attrs: {
	      "href": "/api/v2/archeion/downloadFileArcheion/codigo-de-conduta-movemais",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n              Código de Conduta\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://www.contatoseguro.com.br/movemais",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n              Canal de Ética\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "/api/v2/archeion/downloadFileArcheion/requisitos-pre-aprovacao-provedores-externos-movemais",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n              Requisitos Fornecedores\n            ")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    attrs: {
	      "href": "/api/v2/archeion/downloadFileArcheion/tabela-de-tarifas-movemais",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n              Tarifas Move Mais\n            ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "footer-bottom"
	    }
	  }, [_c('div', {
	    staticClass: "footer-bottom-container",
	    attrs: {
	      "id": "app-download"
	    }
	  }, [_c('h4', {
	    staticClass: "footer-titles"
	  }, [_vm._v("Baixe nosso App")]), _vm._v(" "), _c('div', [_c('a', {
	    attrs: {
	      "href": "https://apps.apple.com/br/app/move-mais-ped%C3%A1gio-free-flow/id6747896915",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1816)
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://play.google.com/store/apps/details?id=com.movemais.morfeu",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1819)
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "footer-bottom-container"
	  }, [_c('h4', {
	    staticClass: "footer-titles",
	    attrs: {
	      "id": "social-media-container"
	    }
	  }, [_vm._v("\n          Acompanhe-nos\n        ")]), _vm._v(" "), _c('div', [_c('a', {
	    attrs: {
	      "href": "https://www.facebook.com/MoveMais/",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1818),
	      "alt": "Facebook"
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://www.instagram.com/movemais/",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1820),
	      "alt": "Instagram"
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://www.linkedin.com/company/move-mais/",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1821),
	      "alt": "LinkedIn"
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://twitter.com/Move_Mais",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1824),
	      "alt": "Twitter"
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://www.youtube.com/user/movemais",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1826),
	      "alt": "YouTube"
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "footer-bottom-container"
	  }, [_c('h4', {
	    staticClass: "footer-titles"
	  }, [_vm._v("Certificado")]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(1823)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "footer-bottom-container"
	  }, [_c('h4', {
	    staticClass: "footer-titles"
	  }, [_vm._v("Consumidor")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://consumidor.gov.br",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1817)
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "footer-bottom-container"
	  }, [_c('h4', {
	    staticClass: "footer-titles"
	  }, [_vm._v("Reputação")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "reputation-ra"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "footer-text-container"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1822)
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("\n        © 2023 Todos os direitos reservados. Av. Rodrigo Fernando Grillo, 207,\n        Edifício Victoria Business, 20º andar - Araraquara-SP.\n      ")])])
	}]}

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("A Move Mais")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "rox"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-fix margin-t10"
	  }, [_c('p', {
	    staticClass: "line-height-20 margin-b20"
	  }, [_vm._v("A "), _c('b', [_vm._v("Move Mais")]), _vm._v(" é uma empresa de meios de pagamento eletrônico, autorizada pela ARTESP para operar como OSA\n        (Operadora de Serviços de Arrecadação), e pela ANTT para operar como AMAP (Administradora de Meios de Pagamento\n        para Arrecadação de Pedágio). Além dessas atividades, a "), _c('b', [_vm._v("Move Mais")]), _vm._v(" empenha recursos e esforços para desenvolver\n        e entregar novos serviços que venham agregar valor à oferta para o Cliente, Embarcadores, Transportadores, Concessionárias\n        e Credenciados.")]), _vm._v(" "), _c('p', {
	    staticClass: "line-height-20 margin-b20"
	  }, [_vm._v("Nosso foco é criar e ofertar serviços que promovam conveniência, economia e segurança nas interações entre o veículo,\n        o motorista e o Ambiente por onde tráfega. Para tanto, a "), _c('b', [_vm._v("Move Mais")]), _vm._v(" é responsável pelo cadastro, análise de crédito,\n        ativação, cobrança e conciliação das transações entre clientes e concessionárias e parceiros, seguindo melhores práticas\n        de governança corporativa e segurança da informação.")]), _vm._v(" "), _c('p', {
	    staticClass: "line-height-20 margin-b20"
	  }, [_vm._v("Suportando os processos está uma moderna e robusta estrutura de tecnologia da informação, com sistemas e infraestrutura\n        em constante atualização, sempre alinhada às áreas de negócio, atendimento ao cliente e back-office.")]), _vm._v(" "), _c('p', {
	    staticClass: "line-height-20 margin-b20"
	  }, [_vm._v("Completando o tripé de sustentação, a "), _c('b', [_vm._v("Move Mais")]), _vm._v(" conta com equipe comprometida, treinada e motivada, liderada por\n        executivos com significativas experiências em empresas brasileiras e multinacionais.")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Nossa razão de existir é você ter mais tempo para o que te move.")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-fix"
	  }, [_c('img', {
	    staticClass: "img-about-move-mais",
	    attrs: {
	      "src": __webpack_require__(1776),
	      "alt": ""
	    }
	  })])])])
	}]}

/***/ }),
/* 2223 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [(_vm.type == 'reset') ? [_vm._m(0)] : _vm._e(), _vm._v(" "), (_vm.type == 'primeiroacesso') ? [_vm._m(1)] : _vm._e(), _vm._v(" "), (_vm.type == 'desbloqueioConta') ? [_vm._m(2)] : _vm._e(), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), (_vm.type == 'reset') ? [_c('p', [_vm._v("Redefinir sua senha de acesso.")])] : _vm._e(), _vm._v(" "), (_vm.type == 'primeiroacessso') ? [_c('p', [_vm._v("Para começar defina uma senha de acesso.")])] : _vm._e(), _vm._v(" "), (_vm.type == 'desbloqueioConta') ? [_c('p', [_vm._v("Redefinir sua senha de acesso.")])] : _vm._e()], 2)]), _vm._v(" "), (_vm.is2FA) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "row border-row row-fix"
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "content-box-small margin-t10"
	  }, [(_vm.errorMessage) ? _c('div', {
	    staticClass: "alert alert-danger margin-t20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Erro: ")]), _vm._v("\n                " + _vm._s(_vm.errorMessage) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.doReset.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group margin-b20",
	    class: {
	      'has-error': _vm.errors.has('password')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "password"
	    }
	  }, [_vm._v("Nova senha")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.password),
	      expression: "password"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: (
	        'required|min:8|max:20|confirmed:password|moveMaisCPF'
	      ),
	      expression: "\n                      'required|min:8|max:20|confirmed:password|moveMaisCPF'\n                    "
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "id": "password",
	      "type": "password",
	      "name": "password",
	      "data-vv-validate-on": "blur",
	      "maxlength": "20",
	      "placeholder": "Mínimo 8 e máximo 20 caracteres"
	    },
	    domProps: {
	      "value": (_vm.password)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.password = $event.target.value
	      }, _vm.checkPassword]
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("password")) + "\n                  ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b20",
	    class: {
	      'has-error': _vm.errors.has('passwordRepeat')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "passwordRepeat"
	    }
	  }, [_vm._v("Confirme a nova senha")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.passwordRepeat),
	      expression: "passwordRepeat"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: (
	        'required|min:8|max:20|confirmed:password|moveMaisCPF'
	      ),
	      expression: "\n                      'required|min:8|max:20|confirmed:password|moveMaisCPF'\n                    "
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "id": "passwordRepeat",
	      "type": "password",
	      "name": "passwordRepeat",
	      "data-vv-validate-on": "blur",
	      "maxlength": "20",
	      "placeholder": "Mínimo 8 e máximo 20 caracteres"
	    },
	    domProps: {
	      "value": (_vm.passwordRepeat)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.passwordRepeat = $event.target.value
	      }, _vm.checkPasswordRepeat]
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("passwordRepeat")) + "\n                  ")]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-lg btn-success",
	    attrs: {
	      "id": "btn-new-pass",
	      "type": "submit",
	      "name": "button",
	      "disabled": _vm.validPasswordRepeat == false
	    }
	  }, [_vm._v("\n                  Definir nova senha\n                ")]), _vm._v(" "), _c('i', {
	    staticClass: "icon-circle-right align-icon"
	  })])])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back margin-t20",
	    attrs: {
	      "to": {
	        name: 'login'
	      },
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v(" Voltar\n            ")])], 1)])])]) : _vm._e(), _vm._v(" "), (!_vm.is2FA) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "row border-row row-fix"
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "content-box-small margin-t10"
	  }, [(_vm.errorMessage) ? _c('div', {
	    staticClass: "alert alert-danger margin-t20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Erro!")]), _vm._v("\n                " + _vm._s(_vm.errorMessage) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.doReset.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group margin-b20",
	    class: {
	      'has-error': _vm.errors.has('password')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "password"
	    }
	  }, [_vm._v("Nova senha")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.password),
	      expression: "password"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: (
	        'required|min:8|max:20|confirmed:password|moveMaisCPF'
	      ),
	      expression: "\n                      'required|min:8|max:20|confirmed:password|moveMaisCPF'\n                    "
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "id": "password",
	      "type": "password",
	      "name": "password",
	      "maxlength": "20",
	      "placeholder": "Digite sua nova senha"
	    },
	    domProps: {
	      "value": (_vm.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.password = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("password")) + "\n                  ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group margin-b20",
	    class: {
	      'has-error': _vm.errors.has('passwordRepeat')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "passwordRepeat"
	    }
	  }, [_vm._v("Confirme a nova senha")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.passwordRepeat),
	      expression: "passwordRepeat"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: (
	        'required|min:8|max:20|confirmed:password|moveMaisCPF'
	      ),
	      expression: "\n                      'required|min:8|max:20|confirmed:password|moveMaisCPF'\n                    "
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "id": "passwordRepeat",
	      "type": "password",
	      "name": "passwordRepeat",
	      "data-vv-validate-on": "blur",
	      "maxlength": "20",
	      "placeholder": "Confirme sua nova senha"
	    },
	    domProps: {
	      "value": (_vm.passwordRepeat)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.passwordRepeat = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("passwordRepeat")) + "\n                  ")])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-lg btn-success",
	    attrs: {
	      "id": "btn-new-pass",
	      "type": "submit",
	      "name": "button"
	    }
	  }, [_vm._v("\n                  Definir nova senha\n                ")]), _vm._v(" "), _c('i', {
	    staticClass: "icon-circle-right align-icon"
	  })]), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('router-link', {
	    staticClass: "btn btn-back margin-t20",
	    attrs: {
	      "to": {
	        name: 'login'
	      },
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v(" Voltar\n            ")])], 1)])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "title"
	  }, [_vm._v("\n            Identificação "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Redefinir\n            senha\n          ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "title"
	  }, [_vm._v("\n            Primeiro Acesso "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Definir\n            senha\n          ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "title"
	  }, [_vm._v("\n            Identificação "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v(" Redefinir\n            senha\n          ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('br'), _vm._v(" "), _c('div', {
	    staticClass: "box-dicas"
	  }, [_vm._v("\n                      Senha deve ter de 8 a 20 caracteres\n                    ")]), _vm._v(" "), _c('div', {
	    staticClass: "box-dicas"
	  }, [_vm._v("\n                      Senha deve ter pelo menos um número\n                    ")]), _vm._v(" "), _c('div', {
	    staticClass: "box-dicas"
	  }, [_vm._v("\n                      Senha deve ter uma letra maiúscula\n                    ")]), _vm._v(" "), _c('div', {
	    staticClass: "box-dicas"
	  }, [_vm._v("\n                      Senha deve ter um caractere especial\n                    ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "circle-key"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "box-dicas"
	  }, [_vm._v("Senha deve ter de 8 a 20 caracteres")]), _vm._v(" "), _c('div', {
	    staticClass: "box-dicas"
	  }, [_vm._v("Senha deve ter pelo menos um número")]), _vm._v(" "), _c('div', {
	    staticClass: "box-dicas"
	  }, [_vm._v("Senha deve ter uma letra maiúscula")]), _vm._v(" "), _c('div', {
	    staticClass: "box-dicas"
	  }, [_vm._v("\n                  Senha deve ter um caractere especial\n                ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "circle-key"
	  })])
	}]}

/***/ }),
/* 2224 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "row row-fix rntrc-box"
	  }, [_c('div', {
	    staticClass: "block-plate"
	  }, [_c('span', [_vm._v(_vm._s(_vm.vehicle.plate))])]), _vm._v(" "), _c('div', {
	    staticClass: "block-vehicle"
	  }, [_c('b', {
	    staticClass: "upper"
	  }, [_vm._v(_vm._s(_vm.vehicle.model.brand.name))]), _vm._v(" "), _c('div', {
	    staticClass: "vehicle-model"
	  }, [_c('b', [_vm._v(_vm._s(_vm._f("firstWord")(_vm.vehicle.model.name)))])]), _vm._v("\n          " + _vm._s(_vm._f("fromSecWord")(_vm.vehicle.model.name)) + "\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "block-rntrc-vinculate"
	  }, [_c('form', [_c('div', {
	    class: {
	      'has-error': _vm.errors.has('serialNumber')
	    }
	  }, [_c('b', [_vm._v("TAG Número")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|numeric'),
	      expression: "'required|numeric'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.serialNumber),
	      expression: "serialNumber"
	    }],
	    staticClass: "form-control input-tag-number",
	    attrs: {
	      "type": "text",
	      "name": "serialNumber",
	      "placeholder": "0000000000"
	    },
	    domProps: {
	      "value": (_vm.serialNumber)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.serialNumber = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('serialNumber')))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "block-fleet"
	  }, [_c('b', [_vm._v("Frota Própria?")]), _vm._v(" "), _c('div', {
	    staticClass: "fleet-switch"
	  }, [_c('div', {
	    staticClass: "onoffswitch"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ownFleet),
	      expression: "ownFleet"
	    }],
	    staticClass: "onoffswitch-checkbox",
	    attrs: {
	      "type": "checkbox",
	      "id": 'rntrc-switch' + _vm.vehicle.vehicleId
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.ownFleet) ? _vm._i(_vm.ownFleet, null) > -1 : (_vm.ownFleet)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.ownFleet,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.ownFleet = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.ownFleet = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.ownFleet = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "onoffswitch-label",
	    attrs: {
	      "for": 'rntrc-switch' + _vm.vehicle.vehicleId
	    }
	  }, [_c('span', {
	    staticClass: "onoffswitch-inner"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "onoffswitch-switch"
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "block-button-vinculate"
	  }, [(_vm.isVinculated) ? _c('button', {
	    staticClass: "btn btn-activate-tag",
	    attrs: {
	      "name": "button"
	    }
	  }, [_vm._v("\n          Vinculado\n        ")]) : _c('button', {
	    staticClass: "btn btn-activate",
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.vinculate()
	      }
	    }
	  }, [_vm._v("\n          Vincular\n        ")])]), _vm._v(" "), (_vm.errorMsg) ? _c('div', {
	    staticClass: "col-xs-12 no-padding margin-b20"
	  }, [_c('div', {
	    staticClass: "alert alert-danger"
	  }, [_vm._v("\n          " + _vm._s(_vm.errorMsg) + "\n        ")])]) : _vm._e()]), _vm._v(" "), (!_vm.ownFleet) ? _c('div', {
	    staticClass: "third-party-box"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('name')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "thirdPartyName"
	    }
	  }, [_vm._v("Nome:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.driver.driverName),
	      expression: "driver.driverName"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "name",
	      "placeholder": "Proprietário do veículo"
	    },
	    domProps: {
	      "value": (_vm.driver.driverName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.driver, "driverName", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('name')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('taxpayerIdNumber')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "thirdPartyCpfCnpj"
	    }
	  }, [_vm._v("CPF ou CNPJ:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.driver.taxpayerIdNumber),
	      expression: "driver.taxpayerIdNumber",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:18|cpfCnpj'),
	      expression: "'required|max:18|cpfCnpj'"
	    }, {
	      name: "mask-cpf-cnpj",
	      rawName: "v-mask-cpf-cnpj"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2}|[0-9]{3}\\.[0-9]{3}\\.[0-9]{3}-[0-9]{2}|[0-9]{11})$",
	      "name": "taxpayerIdNumber",
	      "placeholder": "CPF/CNPJ do proprietário",
	      "data-vv-validate-on": "blur"
	    },
	    domProps: {
	      "value": (_vm.driver.taxpayerIdNumber)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.driver, "taxpayerIdNumber", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('taxpayerIdNumber')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('rntrc')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "thirdPartyRntrc"
	    }
	  }, [_vm._v("Nº do RNTRC:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|decimal|max:12'),
	      expression: "'required|decimal|max:12'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.vehicle.rntrc),
	      expression: "vehicle.rntrc"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "rntrc",
	      "placeholder": "Número de registro",
	      "maxlength": "12"
	    },
	    domProps: {
	      "value": (_vm.vehicle.rntrc)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.vehicle, "rntrc", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('rntrc')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('email')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "thirdPartyEmail"
	    }
	  }, [_vm._v("E-mail:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.driver.driverEmail),
	      expression: "driver.driverEmail"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "email",
	      "placeholder": "E-mail do proprietário"
	    },
	    domProps: {
	      "value": (_vm.driver.driverEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.driver, "driverEmail", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('email')))])])])]) : _vm._e()])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h4', {
	    staticClass: "bold"
	  }, [_vm._v("Dados do Proprietário")]), _vm._v(" "), _c('hr')])
	}]}

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "row container"
	  }, [_c('div', {
	    staticClass: "col-md-4 box-plan",
	    staticStyle: {
	      "padding": "20px"
	    }
	  }, [(_vm.recVp === 'N') ? _c('div', {
	    staticClass: "alert-warning",
	    staticStyle: {
	      "background-color": "#fcdec1",
	      "margin-bottom": "25px",
	      "padding": "20px",
	      "margin": "23px",
	      "text-align": "left"
	    }
	  }, [_c('b', [_vm._v("Atenção!")]), _vm._v(" Este plano não recebe Vale-pedágio Eletrônico.\n    ")]) : _vm._e(), _vm._v(" "), _c('p', {
	    staticClass: "label-semibold"
	  }, [_vm._v("Plano Escolhido:")]), _vm._v(" "), _c('p', {
	    staticClass: "title-plan"
	  }, [_vm._v(_vm._s(_vm.plan && _vm.plan.name))]), _vm._v(" "), _c('img', {
	    staticClass: "choosed-plan-cart",
	    attrs: {
	      "src": __webpack_require__(504),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "second-col-box"
	  }, [_c('b', {
	    staticClass: "title-identification"
	  }, [_vm._v("Valores do plano")]), _vm._v(" "), (_vm.sameTax) ? _c('div', {
	    staticClass: "line-table"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.newAdhesionTax > 0 && !_vm.promoId) ? _c('h4', {
	    staticClass: "label-plan-value"
	  }, [_vm._v("\n            " + _vm._s(_vm._f("cents")(_vm.newAdhesionTax)) + "\n          ")]) : _c('h4', {
	    staticClass: "label-plan-value"
	  }, [_vm._v("GRÁTIS")])])]) : _vm._e(), _vm._v(" "), (!_vm.sameTax) ? _c('div', {
	    staticClass: "line-table"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.newAdhesionTax > 0 && !_vm.promoId) ? _c('h4', {
	    staticClass: "label-plan-value"
	  }, [_vm._v("\n            " + _vm._s(_vm._f("cents")(_vm.newAdhesionTax)) + "\n          ")]) : _c('h4', {
	    staticClass: "label-plan-value"
	  }, [_vm._v("GRÁTIS")])])]) : _vm._e(), _vm._v(" "), (!_vm.sameTax) ? _c('div', {
	    staticClass: "line-table"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.newVehicleTax > 0) ? _c('h4', {
	    staticClass: "label-plan-value"
	  }, [_vm._v("\n            " + _vm._s(_vm._f("cents")(_vm.newVehicleTax)) + "\n          ")]) : _c('h4', {
	    staticClass: "label-plan-value"
	  }, [_vm._v("GRÁTIS")])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "line-table-striped"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "label-plan"
	  }, [_vm._v("Carga inicial:")]), _vm._v(" "), (_vm.planId == 32) ? _c('p', {
	    staticClass: "label-first-charge margin-b0"
	  }, [_vm._v("\n            Será o valor da recarga inicial, obrigatória na adesão e sempre\n            que houver a necessidade de uma recarga\n          ")]) : _c('p', {
	    staticClass: "label-first-charge margin-b0"
	  }, [_vm._v("\n            (É necessário no ato da adesão realizar uma carga inicial)\n          ")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('dropdown', {
	    staticClass: "dropdown-recharge",
	    attrs: {
	      "options": _vm.rechargesData,
	      "value": _vm.value
	    },
	    on: {
	      "itemSelected": _vm.changeRecharge,
	      "change": function($event) {
	        _vm.selectedValue = _vm.value
	      }
	    },
	    model: {
	      value: (_vm.value),
	      callback: function($$v) {
	        _vm.value = $$v
	      },
	      expression: "value"
	    }
	  }, [_vm._v("\n            >\n          ")]), _vm._v(" "), (_vm.value == -1) ? _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('valueTotal')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: (
	        'required|recargaMinima:' + _vm.minValue + '|isMultiple:5000'
	      ),
	      expression: "\n                'required|recargaMinima:' + minValue + '|isMultiple:5000'\n              "
	    }],
	    staticClass: "form-control text-right input-recharge",
	    attrs: {
	      "id": "valueTotal",
	      "type": "text",
	      "name": "valueTotal",
	      "placeholder": "R$ 00,00",
	      "spellcheck": "false",
	      "autocomplete": "off",
	      "autocorrect": "off",
	      "autocapitalize": "off",
	      "maxlength": "14"
	    },
	    domProps: {
	      "value": _vm.valueFormatted
	    },
	    on: {
	      "input": function($event) {
	        return _vm.setTotal($event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block help-block-recharge with-errors"
	  }, [_vm._v("\n              " + _vm._s(_vm.errors.first("valueTotal")) + "\n            ")])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row row-fix",
	    class: {
	      'tax-value-only': !_vm.monthlyTax
	    }
	  }, [_c('div', {}, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h4', {
	    staticClass: "label-plan-value"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.tax)))])])])]), _vm._v(" "), (_vm.planId == 31 || _vm.planId == 32) ? _c('div', {
	    staticClass: "line-table padding-17"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.changeFlagEmail),
	      expression: "changeFlagEmail"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "email",
	      "value": "1"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.changeFlagEmail, "1")
	    },
	    on: {
	      "change": function($event) {
	        _vm.changeFlagEmail = "1"
	      }
	    }
	  }), _vm._v("\n          Sim"), _c('br'), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.changeFlagEmail),
	      expression: "changeFlagEmail"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "email",
	      "value": "0"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.changeFlagEmail, "0")
	    },
	    on: {
	      "change": function($event) {
	        _vm.changeFlagEmail = "0"
	      }
	    }
	  }), _vm._v("\n          Não\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.monthlyTax) ? _c('div', {
	    staticClass: "row row-fix"
	  }, [_c('div', {
	    staticClass: "label-monthly-value"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h4', {
	    staticClass: "label-plan-value"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.monthlyTax)))])])])]) : _vm._e(), _vm._v(" "), (_vm.planId == 31) ? _c('div', [_c('div', {
	    staticClass: "line-table-white"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.planId == 31) ? _c('div', {
	    staticClass: "label-plan"
	  }, [_vm._v("\n              Quero ser avisado quando meu saldo atingir o valor de:\n              " + _vm._s(_vm.limiteFormatado()) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "fleet-switch"
	  }, [_c('div', {
	    staticClass: "onoffswitch"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contract.lcFlag),
	      expression: "contract.lcFlag"
	    }],
	    staticClass: "onoffswitch-checkbox",
	    attrs: {
	      "type": "checkbox",
	      "id": "round-switch"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.contract.lcFlag) ? _vm._i(_vm.contract.lcFlag, null) > -1 : (_vm.contract.lcFlag)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.contract.lcFlag,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.contract, "lcFlag", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.contract, "lcFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.contract, "lcFlag", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _vm._m(6)])])])])])]) : (_vm.planId == 32) ? _c('div', [_c('div', {
	    staticClass: "line-table-white"
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "line-table-striped"
	  }, [_vm._m(7), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 coupon-container"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.coupon),
	      expression: "coupon"
	    }],
	    staticClass: "form-control input-coupon",
	    attrs: {
	      "type": "text",
	      "name": "coupon",
	      "placeholder": "Digite o código",
	      "maxlength": "50"
	    },
	    domProps: {
	      "value": (_vm.coupon)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.coupon = $event.target.value
	      }
	    }
	  })])])]), _vm._v(" "), _vm._m(8)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "label-plan"
	  }, [_vm._v("Adesão por veículo (TAG)"), _c('sup', [_vm._v("1")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "label-plan"
	  }, [_vm._v("Adesão por veículo (TAG)"), _c('sup', [_vm._v("1")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "label-plan"
	  }, [_vm._v("Adesão por veículo (TAG)"), _c('sup', [_vm._v("1")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "label-plan"
	  }, [_vm._v("Taxa de Recarga"), _c('sup', [_vm._v("2")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "label-plan"
	  }, [_vm._v("\n            Deseja receber fatura de conferência por e-mail?\n          ")]), _vm._v(" "), _c('p', {
	    staticClass: "label-first-charge"
	  }, [_vm._v("\n            Se sim, enviaremos no 1º dia de cada mês a fatura para conferência\n            referente à utilização do mês anterior.\n          ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('p', {
	    staticClass: "label-plan"
	  }, [_vm._v("Mensalidade:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "onoffswitch-label",
	    staticStyle: {
	      "text-align": "left"
	    },
	    attrs: {
	      "for": "round-switch"
	    }
	  }, [_c('span', {
	    staticClass: "onoffswitch-inner"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "onoffswitch-switch"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "label-plan"
	  }, [_vm._v("Código do Vendedor:")]), _vm._v(" "), _c('p', {
	    staticClass: "label-first-charge"
	  }, [_vm._v("\n            (Opcional) Informe o código se possuir\n          ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('p', [_vm._v("\n        ¹ ² As condições promocionais estão sujeitas às regras de cada\n        campanha vigente.\n        "), _c('a', {
	    staticStyle: {
	      "text-decoration": "underline"
	    },
	    attrs: {
	      "href": "https://movemais.com/api/v2/archeion/downloadFileArcheion/regulamento-promocional-movemais",
	      "target": "_blank",
	      "rel": "noopener noreferrer"
	    }
	  }, [_vm._v("\n          Consulte o regulamento")]), _vm._v(".\n      ")])])
	}]}

/***/ }),
/* 2226 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('h3', {
	    staticClass: "title title-transfer"
	  }, [_vm._v("Transferir Crédito")]), _vm._v(" "), _c('div', {
	    staticClass: "box-balance"
	  }, [_vm._v("\n        Saldo Disponível:\n        "), (_vm.contract) ? _c('b', {
	    staticClass: "balance-plus"
	  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.contract.currentBalance.currentTotalBalance)))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('ul', {
	    staticClass: "wizard margin-b20"
	  }, [_c('li', {
	    class: {
	      active: _vm.step == 1
	    }
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('li', {
	    class: {
	      active: _vm.step == 2
	    }
	  }, [_vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('li', {
	    class: {
	      active: _vm.step == 3
	    }
	  }, [_vm._m(4), _vm._v(" "), _vm._m(5)])])])]), _vm._v(" "), (_vm.step == 1) ? [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    attrs: {
	      "id": "searchStep1"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-5"
	  }, [_c('p', {
	    staticClass: "bold text-center no-margin"
	  }, [_vm._v("Informe o CPF do Favorecido:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.searchCpf),
	      expression: "searchCpf",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|cpf'),
	      expression: "'required|cpf'"
	    }, {
	      name: "mask-cpf",
	      rawName: "v-mask-cpf"
	    }],
	    staticClass: "form-control search text-center bold",
	    attrs: {
	      "type": "tel",
	      "inputmode": "numeric",
	      "pattern": "[0-9]*",
	      "name": "taxIdNumber",
	      "data-vv-validate-on": "blur",
	      "placeholder": "Digite o CPF",
	      "maxlength": "14",
	      "autofocus": "",
	      "novalidate": "",
	      "formnovalidate": ""
	    },
	    domProps: {
	      "value": (_vm.searchCpf)
	    },
	    on: {
	      "change": function($event) {
	        _vm.searchCpf = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "search-box inline"
	  }, [_c('p', {
	    staticClass: "bold text-center no-margin"
	  }, [_vm._v("Informe o Contrato do Favorecido:")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "only-numbers",
	      rawName: "v-only-numbers"
	    }, {
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.searchContract),
	      expression: "searchContract",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control search text-center bold",
	    attrs: {
	      "type": "tel",
	      "name": "contractIdCred",
	      "data-vv-validate-on": "blur",
	      "placeholder": "Digite o Contrato",
	      "maxlength": "14",
	      "autofocus": "",
	      "novalidate": "",
	      "formnovalidate": ""
	    },
	    domProps: {
	      "value": (_vm.searchContract)
	    },
	    on: {
	      "change": function($event) {
	        _vm.searchContract = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "btn-box inline"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button",
	      "name": "button",
	      "id": "cpfSearch"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.filter()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-search align-icon-left-white"
	  }), _vm._v("\n                    Buscar\n                  ")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-20"
	  }, [(_vm.status == 'ERROR') ? _c('div', {
	    staticClass: "alert alert-danger",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._v(_vm._s(_vm.messageError))]) : _vm._e()])]), _vm._v(" "), (_vm.status == 'FOUND') ? _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-box margin-20"
	  }, [_c('b', {
	    staticClass: "title-identification margin-b10"
	  }, [_vm._v("Dados do Favorecido")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "input-box-control"
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "input-box-credit-transfer"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.userReceive.cliente),
	      expression: "userReceive.cliente"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "Nome do Cliente",
	      "value": "Nome do cliente.",
	      "readonly": "readonly"
	    },
	    domProps: {
	      "value": (_vm.userReceive.cliente)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.userReceive, "cliente", $event.target.value)
	      }
	    }
	  })])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "action-buttons-box"
	  }, [_c('router-link', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button",
	      "data-toggle": "tooltip",
	      "title": "Cancelar Transferência"
	    }
	  }, [_vm._v("\n                    Cancelar\n                    "), _c('i', {
	    staticClass: "icon-circle-cancel align-icon-left-white"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-purple add",
	    attrs: {
	      "id": "advanceStep2"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.nextStep()
	      }
	    }
	  }, [_vm._v("\n            Avançar\n            "), _c('i', {
	    staticClass: "icon-circle-right align-icon-right-white"
	  })])], 1)]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.step == 2) ? [_c('div', {
	    attrs: {
	      "id": "step2"
	    }
	  }, [_c('div', {
	    staticClass: "margin-20"
	  }, [_c('div', {
	    staticClass: "row border-row row-fix margin-b20"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('transfer-credit-value', {
	    attrs: {
	      "step": "1000"
	    },
	    model: {
	      value: (_vm.transfValue),
	      callback: function($$v) {
	        _vm.transfValue = $$v
	      },
	      expression: "transfValue"
	    }
	  })], 1), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('label', [_vm._v("*Taxa de Transferência(" + _vm._s(_vm.fee) + "% sobre o valor): R$")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formattedFeeValue),
	      expression: "formattedFeeValue"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "Valor da Taxa",
	      "value": "Valor da Taxa",
	      "readonly": "readonly"
	    },
	    domProps: {
	      "value": (_vm.formattedFeeValue)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.formattedFeeValue = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "back-button-box"
	  }, [_c('button', {
	    staticClass: "btn btn-back",
	    attrs: {
	      "id": "backStep1"
	    },
	    on: {
	      "click": function($event) {
	        _vm.step = _vm.step - 1
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n              Voltar\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "action-buttons-box"
	  }, [_c('router-link', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button",
	      "data-toggle": "tooltip",
	      "title": "Cancelar Transferência"
	    }
	  }, [_vm._v("\n                    Cancelar\n                    "), _c('i', {
	    staticClass: "icon-circle-cancel align-icon-left-white"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-purple add",
	    attrs: {
	      "disabled": _vm.checkValue,
	      "id": "advanceStep3"
	    },
	    on: {
	      "click": function($event) {
	        _vm.step = _vm.step + 1
	      }
	    }
	  }, [_vm._v("\n              Avançar\n              "), _c('i', {
	    staticClass: "icon-circle-right align-icon-right-white"
	  })])], 1)])])] : _vm._e(), _vm._v(" "), (_vm.step == 3) ? [_c('div', {
	    attrs: {
	      "id": "step3"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-box margin-20"
	  }, [_c('b', {
	    staticClass: "title-identification margin-b10"
	  }, [_vm._v("Resumo e Confirmação da Transferência")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('b', [_vm._v("Dados do Favorecido:")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
	    staticClass: "input-box-credit-transfer"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.userReceive.cliente),
	      expression: "userReceive.cliente"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "Nome do Cliente",
	      "value": "Nome do cliente",
	      "readonly": "readonly"
	    },
	    domProps: {
	      "value": (_vm.userReceive.cliente)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.userReceive, "cliente", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
	    staticClass: "input-box-credit-transfer"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.taxIdNumber),
	      expression: "taxIdNumber"
	    }, {
	      name: "mask-cpf",
	      rawName: "v-mask-cpf"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "CPF",
	      "value": "CPF",
	      "readonly": "readonly"
	    },
	    domProps: {
	      "value": (_vm.taxIdNumber)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.taxIdNumber = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
	    staticClass: "input-box-credit-transfer"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contractIdCred),
	      expression: "contractIdCred"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "Contrato",
	      "value": "Contrato",
	      "readonly": "readonly"
	    },
	    domProps: {
	      "value": (_vm.contractIdCred)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.contractIdCred = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Dados da Transferência:")]), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
	    staticClass: "input-box-credit-transfer"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formattedValue),
	      expression: "formattedValue"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "input-transfer-value",
	      "readonly": "readonly"
	    },
	    domProps: {
	      "value": (_vm.formattedValue)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.formattedValue = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
	    staticClass: "input-box-credit-transfer"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formattedFeeValue),
	      expression: "formattedFeeValue"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "Valor da Taxa",
	      "value": "Valor da Taxa",
	      "readonly": "readonly"
	    },
	    domProps: {
	      "value": (_vm.formattedFeeValue)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.formattedFeeValue = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
	    staticClass: "input-box-credit-transfer"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formattedTotal),
	      expression: "formattedTotal"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "name": "Total",
	      "value": "Total",
	      "readonly": "readonly"
	    },
	    domProps: {
	      "value": (_vm.formattedTotal)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.formattedTotal = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
	    staticClass: "input-box-credit-transfer"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.password),
	      expression: "password"
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "password",
	      "name": "senha"
	    },
	    domProps: {
	      "value": (_vm.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.password = $event.target.value
	      }
	    }
	  })])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 margin-b20"
	  }, [(_vm.status == 'ERROR') ? _c('div', {
	    staticClass: "alert alert-danger",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._v(_vm._s(_vm.messageError))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "action-buttons-box"
	  }, [_c('router-link', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "to": {
	        name: 'plans'
	      },
	      "tag": "button",
	      "data-toggle": "tooltip",
	      "title": "Cancelar Transferência"
	    }
	  }, [_vm._v("\n                    Cancelar\n                    "), _c('i', {
	    staticClass: "icon-circle-cancel align-icon-left-white"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success end",
	    on: {
	      "click": function($event) {
	        return _vm.transfer()
	      }
	    }
	  }, [_vm._v("\n              Concluir transferência\n              "), _c('i', {
	    staticClass: "icon-tick align-icon-right-white"
	  })])], 1)])] : _vm._e()], 2)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-avatar"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Etapa 1")]), _vm._v(" "), _c('small', {
	    staticClass: "no-margin"
	  }, [_vm._v("Identificação do favorecido")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-payment-methods"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Etapa 2")]), _vm._v(" "), _c('small', {
	    staticClass: "no-margin"
	  }, [_vm._v("Valor da transferência")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon-step"
	  }, [_c('i', {
	    staticClass: "icon-confirmation-check"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline"
	  }, [_c('h5', {
	    staticClass: "txt-step no-margin"
	  }, [_vm._v("Etapa 3")]), _vm._v(" "), _c('small', {
	    staticClass: "no-margin"
	  }, [_vm._v("Resumo e confirmação")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Nome:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "circle-wallets"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Nome:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("CPF:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Contrato:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Valor da Transferência: R$")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_vm._v("Taxa de Transferência: R$")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_c('b', [_vm._v("Total: R$ ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "label-box"
	  }, [_c('label', [_c('b', [_vm._v("Informe sua senha: ")])])])
	}]}

/***/ }),
/* 2227 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._m(0), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-yellow"
	  }), _vm._v(" "), _c('hr', {
	    staticClass: "h-rule-side-yellow"
	  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_c('a', {
	    on: {
	      "click": _vm.requestAgain
	    }
	  }, [_vm._v("Clique aqui")]), _vm._v(" para reenviar o código.\n        ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "row border-row row-fix"
	  }, [_c('div', {
	    directives: [{
	      name: "async",
	      rawName: "v-async",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "content-box-small margin-t80"
	  }, [(_vm.formState == 'ERROR') ? _c('div', {
	    staticClass: "alert alert-danger alert-dismissible margin-t20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Erro: ")]), _vm._v("\n              " + _vm._s(_vm.errorMessage) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'SUCCESS') ? _c('div', {
	    staticClass: "alert alert-success alert-dismissible margin-t20",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('strong', [_vm._v("Sucesso!")]), _vm._v(" "), _vm._v("\n              Um SMS foi enviado para você contendo uma sequência de 6 dígitos.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'NEW' || _vm.formState == 'ERROR') ? _c('form', {
	    attrs: {
	      "autocomplete": "false"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.doRequest.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group margin-b20"
	  }, [_c('label', [_vm._v("Código")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.TFACode),
	      expression: "TFACode",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    staticClass: "form-control small",
	    attrs: {
	      "type": "text",
	      "maxlength": "6",
	      "oninput": "javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);",
	      "name": "TFACode",
	      "placeholder": "Digite os 6 números",
	      "data-vv-validate-on": "blur",
	      "autofocus": ""
	    },
	    domProps: {
	      "value": (_vm.TFACode)
	    },
	    on: {
	      "keypress": function($event) {
	        return _vm.isNumber($event)
	      },
	      "change": function($event) {
	        _vm.TFACode = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(""))])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-lg btn-purple",
	    attrs: {
	      "id": "btn-login",
	      "type": "submit",
	      "name": "button"
	    }
	  }, [_vm._v("\n                Continuar\n              ")]), _vm._v(" "), _c('i', {
	    staticClass: "icon-circle-right align-icon"
	  })]) : _vm._e()])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-back margin-t20",
	    attrs: {
	      "to": "/login",
	      "tag": "button"
	    }
	  }, [_c('i', {
	    staticClass: "icon-circle-left align-icon-left"
	  }), _vm._v("\n        Voltar\n      ")])], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "title"
	  }, [_vm._v("\n        Identificação "), _c('i', {
	    staticClass: "icon-arrow-major-breadcrumb"
	  }), _vm._v("\n        Autenticação de 2 fatores\n      ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("\n        Enviamos uma sequência numérica de 6 dígitos para o "), _c('b', [_vm._v("e-mail")]), _vm._v(" e "), _c('b', [_vm._v("número de celular")]), _vm._v(" cadastrados em sua conta. Para continuar, insira o código no campo abaixo:\n      ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "circle-key"
	  })])
	}]}

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	  * vue-scrollto v2.20.0
	  * (c) 2019 Randjelovic Igor
	  * @license MIT
	  */
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global['vue-scrollto'] = factory());
	}(this, (function () { 'use strict';
	
	  function _typeof(obj) {
	    "@babel/helpers - typeof";
	
	    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	      _typeof = function (obj) {
	        return typeof obj;
	      };
	    } else {
	      _typeof = function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	      };
	    }
	
	    return _typeof(obj);
	  }
	
	  function _extends() {
	    _extends = Object.assign || function (target) {
	      for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];
	
	        for (var key in source) {
	          if (Object.prototype.hasOwnProperty.call(source, key)) {
	            target[key] = source[key];
	          }
	        }
	      }
	
	      return target;
	    };
	
	    return _extends.apply(this, arguments);
	  }
	
	  /**
	   * https://github.com/gre/bezier-easing
	   * BezierEasing - use bezier curve for transition easing function
	   * by Gaëtan Renaudeau 2014 - 2015 – MIT License
	   */
	
	  // These values are established by empiricism with tests (tradeoff: performance VS precision)
	  var NEWTON_ITERATIONS = 4;
	  var NEWTON_MIN_SLOPE = 0.001;
	  var SUBDIVISION_PRECISION = 0.0000001;
	  var SUBDIVISION_MAX_ITERATIONS = 10;
	
	  var kSplineTableSize = 11;
	  var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
	
	  var float32ArraySupported = typeof Float32Array === 'function';
	
	  function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
	  function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
	  function C (aA1)      { return 3.0 * aA1; }
	
	  // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
	  function calcBezier (aT, aA1, aA2) { return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT; }
	
	  // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
	  function getSlope (aT, aA1, aA2) { return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1); }
	
	  function binarySubdivide (aX, aA, aB, mX1, mX2) {
	    var currentX, currentT, i = 0;
	    do {
	      currentT = aA + (aB - aA) / 2.0;
	      currentX = calcBezier(currentT, mX1, mX2) - aX;
	      if (currentX > 0.0) {
	        aB = currentT;
	      } else {
	        aA = currentT;
	      }
	    } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	    return currentT;
	  }
	
	  function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
	   for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	     var currentSlope = getSlope(aGuessT, mX1, mX2);
	     if (currentSlope === 0.0) {
	       return aGuessT;
	     }
	     var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	     aGuessT -= currentX / currentSlope;
	   }
	   return aGuessT;
	  }
	
	  function LinearEasing (x) {
	    return x;
	  }
	
	  var src = function bezier (mX1, mY1, mX2, mY2) {
	    if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
	      throw new Error('bezier x values must be in [0, 1] range');
	    }
	
	    if (mX1 === mY1 && mX2 === mY2) {
	      return LinearEasing;
	    }
	
	    // Precompute samples table
	    var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	    for (var i = 0; i < kSplineTableSize; ++i) {
	      sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	    }
	
	    function getTForX (aX) {
	      var intervalStart = 0.0;
	      var currentSample = 1;
	      var lastSample = kSplineTableSize - 1;
	
	      for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
	        intervalStart += kSampleStepSize;
	      }
	      --currentSample;
	
	      // Interpolate to provide an initial guess for t
	      var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
	      var guessForT = intervalStart + dist * kSampleStepSize;
	
	      var initialSlope = getSlope(guessForT, mX1, mX2);
	      if (initialSlope >= NEWTON_MIN_SLOPE) {
	        return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
	      } else if (initialSlope === 0.0) {
	        return guessForT;
	      } else {
	        return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
	      }
	    }
	
	    return function BezierEasing (x) {
	      // Because JavaScript number are imprecise, we should guarantee the extremes are right.
	      if (x === 0) {
	        return 0;
	      }
	      if (x === 1) {
	        return 1;
	      }
	      return calcBezier(getTForX(x), mY1, mY2);
	    };
	  };
	
	  var easings = {
	    ease: [0.25, 0.1, 0.25, 1.0],
	    linear: [0.0, 0.0, 1.0, 1.0],
	    'ease-in': [0.42, 0.0, 1.0, 1.0],
	    'ease-out': [0.0, 0.0, 0.58, 1.0],
	    'ease-in-out': [0.42, 0.0, 0.58, 1.0]
	  };
	
	  // https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
	  var supportsPassive = false;
	
	  try {
	    var opts = Object.defineProperty({}, 'passive', {
	      get: function get() {
	        supportsPassive = true;
	      }
	    });
	    window.addEventListener('test', null, opts);
	  } catch (e) {}
	
	  var _ = {
	    $: function $(selector) {
	      if (typeof selector !== 'string') {
	        return selector;
	      }
	
	      return document.querySelector(selector);
	    },
	    on: function on(element, events, handler) {
	      var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
	        passive: false
	      };
	
	      if (!(events instanceof Array)) {
	        events = [events];
	      }
	
	      for (var i = 0; i < events.length; i++) {
	        element.addEventListener(events[i], handler, supportsPassive ? opts : false);
	      }
	    },
	    off: function off(element, events, handler) {
	      if (!(events instanceof Array)) {
	        events = [events];
	      }
	
	      for (var i = 0; i < events.length; i++) {
	        element.removeEventListener(events[i], handler);
	      }
	    },
	    cumulativeOffset: function cumulativeOffset(element) {
	      var top = 0;
	      var left = 0;
	
	      do {
	        top += element.offsetTop || 0;
	        left += element.offsetLeft || 0;
	        element = element.offsetParent;
	      } while (element);
	
	      return {
	        top: top,
	        left: left
	      };
	    }
	  };
	
	  var abortEvents = ['mousedown', 'wheel', 'DOMMouseScroll', 'mousewheel', 'keyup', 'touchmove'];
	  var defaults = {
	    container: 'body',
	    duration: 500,
	    lazy: true,
	    easing: 'ease',
	    offset: 0,
	    force: true,
	    cancelable: true,
	    onStart: false,
	    onDone: false,
	    onCancel: false,
	    x: false,
	    y: true
	  };
	  function setDefaults(options) {
	    defaults = _extends({}, defaults, options);
	  }
	  var scroller = function scroller() {
	    var element; // element to scroll to
	
	    var container; // container to scroll
	
	    var duration; // duration of the scrolling
	
	    var easing; // easing to be used when scrolling
	
	    var lazy; // checks the target position at each step
	
	    var offset; // offset to be added (subtracted)
	
	    var force; // force scroll, even if element is visible
	
	    var cancelable; // indicates if user can cancel the scroll or not.
	
	    var onStart; // callback when scrolling is started
	
	    var onDone; // callback when scrolling is done
	
	    var onCancel; // callback when scrolling is canceled / aborted
	
	    var x; // scroll on x axis
	
	    var y; // scroll on y axis
	
	    var initialX; // initial X of container
	
	    var targetX; // target X of container
	
	    var initialY; // initial Y of container
	
	    var targetY; // target Y of container
	
	    var diffX; // difference
	
	    var diffY; // difference
	
	    var abort; // is scrolling aborted
	
	    var cumulativeOffsetContainer;
	    var cumulativeOffsetElement;
	    var abortEv; // event that aborted scrolling
	
	    var abortFn = function abortFn(e) {
	      if (!cancelable) return;
	      abortEv = e;
	      abort = true;
	    };
	
	    var easingFn;
	    var timeStart; // time when scrolling started
	
	    var timeElapsed; // time elapsed since scrolling started
	
	    var progress; // progress
	
	    function scrollTop(container) {
	      var scrollTop = container.scrollTop;
	
	      if (container.tagName.toLowerCase() === 'body') {
	        // in firefox body.scrollTop always returns 0
	        // thus if we are trying to get scrollTop on a body tag
	        // we need to get it from the documentElement
	        scrollTop = scrollTop || document.documentElement.scrollTop;
	      }
	
	      return scrollTop;
	    }
	
	    function scrollLeft(container) {
	      var scrollLeft = container.scrollLeft;
	
	      if (container.tagName.toLowerCase() === 'body') {
	        // in firefox body.scrollLeft always returns 0
	        // thus if we are trying to get scrollLeft on a body tag
	        // we need to get it from the documentElement
	        scrollLeft = scrollLeft || document.documentElement.scrollLeft;
	      }
	
	      return scrollLeft;
	    }
	
	    function recalculateTargets() {
	      cumulativeOffsetContainer = _.cumulativeOffset(container);
	      cumulativeOffsetElement = _.cumulativeOffset(element);
	
	      if (x) {
	        targetX = cumulativeOffsetElement.left - cumulativeOffsetContainer.left + offset;
	        diffX = targetX - initialX;
	      }
	
	      if (y) {
	        targetY = cumulativeOffsetElement.top - cumulativeOffsetContainer.top + offset;
	        diffY = targetY - initialY;
	      }
	    }
	
	    function step(timestamp) {
	      if (abort) return done();
	      if (!timeStart) timeStart = timestamp; // When a site has a lot of media that can be loaded asynchronously,
	      // the targetY/targetX may end up in the wrong place during scrolling.
	      // So we will check this at each step
	
	      if (!lazy) {
	        recalculateTargets();
	      }
	
	      timeElapsed = timestamp - timeStart;
	      progress = Math.min(timeElapsed / duration, 1);
	      progress = easingFn(progress);
	      topLeft(container, initialY + diffY * progress, initialX + diffX * progress);
	      timeElapsed < duration ? window.requestAnimationFrame(step) : done();
	    }
	
	    function done() {
	      if (!abort) topLeft(container, targetY, targetX);
	      timeStart = false;
	
	      _.off(container, abortEvents, abortFn);
	
	      if (abort && onCancel) onCancel(abortEv, element);
	      if (!abort && onDone) onDone(element);
	    }
	
	    function topLeft(element, top, left) {
	      if (y) element.scrollTop = top;
	      if (x) element.scrollLeft = left;
	
	      if (element.tagName.toLowerCase() === 'body') {
	        // in firefox body.scrollTop doesn't scroll the page
	        // thus if we are trying to scrollTop on a body tag
	        // we need to scroll on the documentElement
	        if (y) document.documentElement.scrollTop = top;
	        if (x) document.documentElement.scrollLeft = left;
	      }
	    }
	
	    function scrollTo(target, _duration) {
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      if (_typeof(_duration) === 'object') {
	        options = _duration;
	      } else if (typeof _duration === 'number') {
	        options.duration = _duration;
	      }
	
	      element = _.$(target);
	
	      if (!element) {
	        return console.warn('[vue-scrollto warn]: Trying to scroll to an element that is not on the page: ' + target);
	      }
	
	      container = _.$(options.container || defaults.container);
	      duration = options.hasOwnProperty('duration') ? options.duration : defaults.duration;
	      lazy = options.hasOwnProperty('lazy') ? options.lazy : defaults.lazy;
	      easing = options.easing || defaults.easing;
	      offset = options.hasOwnProperty('offset') ? options.offset : defaults.offset;
	      force = options.hasOwnProperty('force') ? options.force !== false : defaults.force;
	      cancelable = options.hasOwnProperty('cancelable') ? options.cancelable !== false : defaults.cancelable;
	      onStart = options.onStart || defaults.onStart;
	      onDone = options.onDone || defaults.onDone;
	      onCancel = options.onCancel || defaults.onCancel;
	      x = options.x === undefined ? defaults.x : options.x;
	      y = options.y === undefined ? defaults.y : options.y;
	
	      if (typeof offset === 'function') {
	        offset = offset(element, container);
	      }
	
	      initialX = scrollLeft(container);
	      initialY = scrollTop(container); // calculates cumulative offsets and targetX/Y + diffX/Y
	
	      recalculateTargets();
	      abort = false;
	
	      if (!force) {
	        // When the container is the default (body) we need to use the viewport
	        // height, not the entire body height
	        var containerHeight = container.tagName.toLowerCase() === 'body' ? document.documentElement.clientHeight || window.innerHeight : container.offsetHeight;
	        var containerTop = initialY;
	        var containerBottom = containerTop + containerHeight;
	        var elementTop = targetY - offset;
	        var elementBottom = elementTop + element.offsetHeight;
	
	        if (elementTop >= containerTop && elementBottom <= containerBottom) {
	          // make sure to call the onDone callback even if there is no need to
	          // scroll the container. Fixes #111 (ref #118)
	          if (onDone) onDone(element);
	          return;
	        }
	      }
	
	      if (onStart) onStart(element);
	
	      if (!diffY && !diffX) {
	        if (onDone) onDone(element);
	        return;
	      }
	
	      if (typeof easing === 'string') {
	        easing = easings[easing] || easings['ease'];
	      }
	
	      easingFn = src.apply(src, easing);
	
	      _.on(container, abortEvents, abortFn, {
	        passive: true
	      });
	
	      window.requestAnimationFrame(step);
	      return function () {
	        abortEv = null;
	        abort = true;
	      };
	    }
	
	    return scrollTo;
	  };
	
	  var _scroller = scroller();
	
	  var bindings = []; // store binding data
	
	  function deleteBinding(el) {
	    for (var i = 0; i < bindings.length; ++i) {
	      if (bindings[i].el === el) {
	        bindings.splice(i, 1);
	        return true;
	      }
	    }
	
	    return false;
	  }
	
	  function findBinding(el) {
	    for (var i = 0; i < bindings.length; ++i) {
	      if (bindings[i].el === el) {
	        return bindings[i];
	      }
	    }
	  }
	
	  function getBinding(el) {
	    var binding = findBinding(el);
	
	    if (binding) {
	      return binding;
	    }
	
	    bindings.push(binding = {
	      el: el,
	      binding: {}
	    });
	    return binding;
	  }
	
	  function handleClick(e) {
	    var ctx = getBinding(this).binding;
	    if (!ctx.value) return;
	    e.preventDefault();
	
	    if (typeof ctx.value === 'string') {
	      return _scroller(ctx.value);
	    }
	
	    _scroller(ctx.value.el || ctx.value.element, ctx.value);
	  }
	
	  var directiveHooks = {
	    bind: function bind(el, binding) {
	      getBinding(el).binding = binding;
	
	      _.on(el, 'click', handleClick);
	    },
	    unbind: function unbind(el) {
	      deleteBinding(el);
	
	      _.off(el, 'click', handleClick);
	    },
	    update: function update(el, binding) {
	      getBinding(el).binding = binding;
	    }
	  };
	  var VueScrollTo = {
	    bind: directiveHooks.bind,
	    unbind: directiveHooks.unbind,
	    update: directiveHooks.update,
	    beforeMount: directiveHooks.bind,
	    unmounted: directiveHooks.unbind,
	    updated: directiveHooks.update,
	    scrollTo: _scroller,
	    bindings: bindings
	  };
	
	  var install = function install(Vue, options) {
	    if (options) setDefaults(options);
	    Vue.directive('scroll-to', VueScrollTo);
	    var properties = Vue.config.globalProperties || Vue.prototype;
	    properties.$scrollTo = VueScrollTo.scrollTo;
	  };
	
	  if (typeof window !== 'undefined' && window.Vue) {
	    window.VueScrollTo = VueScrollTo;
	    window.VueScrollTo.setDefaults = setDefaults;
	    window.VueScrollTo.scroller = scroller;
	    if (window.Vue.use) window.Vue.use(install);
	  }
	
	  VueScrollTo.install = install;
	
	  return VueScrollTo;
	
	})));


/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.VueSmoothScroll=t():e.VueSmoothScroll=t()}(this,function(){return function(e){function t(n){if(o[n])return o[n].exports;var i=o[n]={exports:{},id:n,loaded:!1};return e[n].call(i.exports,i,i.exports,t),i.loaded=!0,i.exports}var o={};return t.m=e,t.c=o,t.p="",t(0)}([function(e,t){"use strict";function o(e){return e<.5?4*e*e*e:(e-1)*(2*e-2)*(2*e-2)+1}var n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};e.exports={install:function(e){e.directive("smooth-scroll",{inserted:function(e,t){"object"===("undefined"==typeof window?"undefined":n(window))&&void 0!==window.pageYOffset&&e.addEventListener("click",function(e){var n=document.getElementById(this.hash.substring(1));if(n){e.preventDefault(),window.history.pushState&&location.hash!==this.hash&&window.history.pushState("","",this.hash);var i=t.value&&t.value.duration?t.value.duration:500,r=t.value&&t.value.offset?t.value.offset:0,u=Date.now(),f="HTML"===n.nodeName?-window.pageYOffset:n.getBoundingClientRect().top+window.pageYOffset;f+=r;var a=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||function(e){window.setTimeout(e,15)},s=function e(){var t=Date.now()-u,r=f;t<i?(r=window.pageYOffset+(f-window.pageYOffset)*o(t/i),a(e)):location.replace("#"+n.id),window.scroll(0,r)};s()}})}})}}}])});

/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 *
	 * @author    Jerry Bendy
	 * @since     4/12/2017
	 */
	
	function touchX(event) {
	    if(event.type.indexOf('mouse') !== -1){
	        return event.clientX;
	    }
	    return event.touches[0].clientX;
	}
	
	function touchY(event) {
	    if(event.type.indexOf('mouse') !== -1){
	        return event.clientY;
	    }
	    return event.touches[0].clientY;
	}
	
	var isPassiveSupported = (function() {
	    var supportsPassive = false;
	    try {
	        var opts = Object.defineProperty({}, 'passive', {
	            get: function() {
	                supportsPassive = true;
	            }
	        });
	        window.addEventListener('test', null, opts);
	    } catch (e) {}
	    return supportsPassive;
	})();
	
	// Save last touch time globally (touch start time or touch end time), if a `click` event triggered,
	// and the time near by the last touch time, this `click` event will be ignored. This is used for
	// resolve touch through issue.
	var globalLastTouchTime = 0;
	
	var vueTouchEvents = {
	    install: function (Vue, constructorOptions) {
	
	        var globalOptions = Object.assign({}, {
	            disableClick: false,
	            tapTolerance: 10,  // px
	            swipeTolerance: 30,  // px
	            touchHoldTolerance: 400,  // ms
	            longTapTimeInterval: 400,  // ms
	            touchClass: '',
	            namespace: 'touch'
	        }, constructorOptions);
	
	        function touchStartEvent(event) {
	            var $this = this.$$touchObj,
	                isTouchEvent = event.type.indexOf('touch') >= 0,
	                isMouseEvent = event.type.indexOf('mouse') >= 0,
	                $el = this;
	
	            if (isTouchEvent) {
	                globalLastTouchTime = event.timeStamp;
	            }
	
	            if (isMouseEvent && globalLastTouchTime && event.timeStamp - globalLastTouchTime < 350) {
	                return;
	            }
	
	            if ($this.touchStarted) {
	                return;
	            }
	
	            addTouchClass(this);
	
	            $this.touchStarted = true;
	
	            $this.touchMoved = false;
	            $this.swipeOutBounded = false;
	
	            $this.startX = touchX(event);
	            $this.startY = touchY(event);
	
	            $this.currentX = 0;
	            $this.currentY = 0;
	
	            $this.touchStartTime = event.timeStamp;
	
	            // Trigger touchhold event after `touchHoldTolerance`ms
	            $this.touchHoldTimer = setTimeout(function() {
	                $this.touchHoldTimer = null;
	                triggerEvent(event, $el, 'touchhold');
	            }, $this.options.touchHoldTolerance);
	
	            triggerEvent(event, this, 'start');
	        }
	
	        function touchMoveEvent(event) {
	            var $this = this.$$touchObj;
	
	            $this.currentX = touchX(event);
	            $this.currentY = touchY(event);
	
	            if (!$this.touchMoved) {
	                var tapTolerance = $this.options.tapTolerance;
	
	                $this.touchMoved = Math.abs($this.startX - $this.currentX) > tapTolerance ||
	                    Math.abs($this.startY - $this.currentY) > tapTolerance;
	
	                if($this.touchMoved){
	                    cancelTouchHoldTimer($this);
	                    triggerEvent(event, this, 'moved');
	                }
	
	            } else if (!$this.swipeOutBounded) {
	                var swipeOutBounded = $this.options.swipeTolerance;
	
	                $this.swipeOutBounded = Math.abs($this.startX - $this.currentX) > swipeOutBounded &&
	                    Math.abs($this.startY - $this.currentY) > swipeOutBounded;
	            }
	
	            if($this.touchMoved){
	                triggerEvent(event, this, 'moving');
	            }
	        }
	
	        function touchCancelEvent() {
	            var $this = this.$$touchObj;
	
	            cancelTouchHoldTimer($this);
	            removeTouchClass(this);
	
	            $this.touchStarted = $this.touchMoved = false;
	            $this.startX = $this.startY = 0;
	        }
	
	        function touchEndEvent(event) {
	            var $this = this.$$touchObj,
	                isTouchEvent = event.type.indexOf('touch') >= 0,
	                isMouseEvent = event.type.indexOf('mouse') >= 0;
	
	            if (isTouchEvent) {
	                globalLastTouchTime = event.timeStamp;
	            }
	
	            var touchholdEnd = isTouchEvent && !$this.touchHoldTimer;
	            cancelTouchHoldTimer($this);
	
	            $this.touchStarted = false;
	
	            removeTouchClass(this);
	
	            if (isMouseEvent && globalLastTouchTime && event.timeStamp - globalLastTouchTime < 350) {
	                return;
	            }
	
	            // Fix #33, Trigger `end` event when touch stopped
	            triggerEvent(event, this, 'end');
	
	            if (!$this.touchMoved) {
	                // detect if this is a longTap event or not
	                if ($this.callbacks.longtap && event.timeStamp - $this.touchStartTime > $this.options.longTapTimeInterval) {
	                    if (event.cancelable) {
	                        event.preventDefault();
	                    }
	                    triggerEvent(event, this, 'longtap');
	
	                } else if ($this.callbacks.touchhold && touchholdEnd) {
	                    if (event.cancelable) {
	                        event.preventDefault();
	                    }
	                    return;
	                } else {
	                    // emit tap event
	                    triggerEvent(event, this, 'tap');
	                }
	
	            } else if (!$this.swipeOutBounded) {
	                var swipeOutBounded = $this.options.swipeTolerance,
	                    direction,
	                    distanceY = Math.abs($this.startY - $this.currentY),
	                    distanceX = Math.abs($this.startX - $this.currentX);
	
	                if (distanceY > swipeOutBounded || distanceX > swipeOutBounded) {
	                    if (distanceY > distanceX) {
	                        direction = $this.startY > $this.currentY ? 'top' : 'bottom';
	                    } else {
	                        direction = $this.startX > $this.currentX ? 'left' : 'right';
	                    }
	
	                    // Only emit the specified event when it has modifiers
	                    if ($this.callbacks['swipe.' + direction]) {
	                        triggerEvent(event, this, 'swipe.' + direction, direction);
	                    } else {
	                        // Emit a common event when it has no any modifier
	                        triggerEvent(event, this, 'swipe', direction);
	                    }
	                }
	            }
	        }
	
	        function mouseEnterEvent() {
	            addTouchClass(this);
	        }
	
	        function mouseLeaveEvent() {
	            removeTouchClass(this);
	        }
	
	        function triggerEvent(e, $el, eventType, param) {
	            var $this = $el.$$touchObj;
	
	            // get the callback list
	            var callbacks = $this && $this.callbacks[eventType] || [];
	            if (callbacks.length === 0) {
	                return null;
	            }
	
	            for (var i = 0; i < callbacks.length; i++) {
	                var binding = callbacks[i];
	
	                if (binding.modifiers.stop) {
	                    e.stopPropagation();
	                }
	
	                if (binding.modifiers.prevent && e.cancelable) {
	                    e.preventDefault();
	                }
	
	                // handle `self` modifier`
	                if (binding.modifiers.self && e.target !== e.currentTarget) {
	                    continue;
	                }
	
	                if (typeof binding.value === 'function') {
	                    if (param) {
	                        binding.value(param, e);
	                    } else {
	                        binding.value(e);
	                    }
	                }
	            }
	        }
	
	        function addTouchClass($el) {
	            var className = $el.$$touchObj.options.touchClass;
	            className && $el.classList.add(className);
	        }
	
	        function removeTouchClass($el) {
	            var className = $el.$$touchObj.options.touchClass;
	            className && $el.classList.remove(className);
	        }
	
	        function cancelTouchHoldTimer($this) {
	            if ($this.touchHoldTimer) {
	                clearTimeout($this.touchHoldTimer);
	                $this.touchHoldTimer = null;
	            }
	        }
	
	        function buildTouchObj($el, extraOptions) {
	            var touchObj = $el.$$touchObj || {
	                // an object contains all callbacks registered,
	                // key is event name, value is an array
	                callbacks: {},
	                // prevent bind twice, set to true when event bound
	                hasBindTouchEvents: false,
	                // default options, would be override by v-touch-options
	                options: globalOptions
	            };
	            if (extraOptions) {
	                touchObj.options = Object.assign({}, touchObj.options, extraOptions);
	            }
	            $el.$$touchObj = touchObj;
	            return $el.$$touchObj;
	        }
	
	        Vue.directive(globalOptions.namespace, {
	            bind: function ($el, binding) {
	                // build a touch configuration object
	                var $this = buildTouchObj($el);
	                // declare passive option for the event listener. Defaults to { passive: true } if supported
	                var passiveOpt = isPassiveSupported ? { passive: true } : false;
	                // register callback
	                var eventType = binding.arg || 'tap';
	                switch (eventType) {
	                    case 'swipe':
	                        var _m = binding.modifiers;
	                        if (_m.left || _m.right || _m.top || _m.bottom) {
	                            for (var i in binding.modifiers) {
	                                if (['left', 'right', 'top', 'bottom'].indexOf(i) >= 0) {
	                                    var _e = 'swipe.' + i;
	                                    $this.callbacks[_e] = $this.callbacks[_e] || [];
	                                    $this.callbacks[_e].push(binding);
	                                }
	                            }
	                        } else {
	                            $this.callbacks.swipe = $this.callbacks.swipe || [];
	                            $this.callbacks.swipe.push(binding);
	                        }
	                        break;
	                    
	                    case 'start':
	                    case 'moving':
	                        if (binding.modifiers.disablePassive) {
	                            // change the passive option for the moving event if disablePassive modifier exists
	                            passiveOpt = false;
	                        }
	                    // fallthrough
	                    default:
	                        $this.callbacks[eventType] = $this.callbacks[eventType] || [];
	                        $this.callbacks[eventType].push(binding);
	                }
	
	                // prevent bind twice
	                if ($this.hasBindTouchEvents) {
	                    return;
	                }
	
	                $el.addEventListener('touchstart', touchStartEvent, passiveOpt);
	                $el.addEventListener('touchmove', touchMoveEvent, passiveOpt);
	                $el.addEventListener('touchcancel', touchCancelEvent);
	                $el.addEventListener('touchend', touchEndEvent);
	
	                if (!$this.options.disableClick) {
	                    $el.addEventListener('mousedown', touchStartEvent);
	                    $el.addEventListener('mousemove', touchMoveEvent);
	                    $el.addEventListener('mouseup', touchEndEvent);
	                    $el.addEventListener('mouseenter', mouseEnterEvent);
	                    $el.addEventListener('mouseleave', mouseLeaveEvent);
	                }
	
	                // set bind mark to true
	                $this.hasBindTouchEvents = true;
	            },
	
	            unbind: function ($el) {
	                $el.removeEventListener('touchstart', touchStartEvent);
	                $el.removeEventListener('touchmove', touchMoveEvent);
	                $el.removeEventListener('touchcancel', touchCancelEvent);
	                $el.removeEventListener('touchend', touchEndEvent);
	
	                if ($el.$$touchObj && !$el.$$touchObj.options.disableClick) {
	                    $el.removeEventListener('mousedown', touchStartEvent);
	                    $el.removeEventListener('mousemove', touchMoveEvent);
	                    $el.removeEventListener('mouseup', touchEndEvent);
	                    $el.removeEventListener('mouseenter', mouseEnterEvent);
	                    $el.removeEventListener('mouseleave', mouseLeaveEvent);
	                }
	
	                // remove vars
	                delete $el.$$touchObj;
	            }
	        });
	
	        Vue.directive(globalOptions.namespace + '-class', {
	            bind: function ($el, binding) {
	                buildTouchObj($el, {
	                    touchClass: binding.value
	                });
	            }
	        });
	
	        Vue.directive(globalOptions.namespace + '-options', {
	            bind: function($el, binding) {
	                buildTouchObj($el, binding.value);
	            }
	        });
	    }
	};
	
	
	/*
	 * Exports
	 */
	if (true) {
	    module.exports = vueTouchEvents;
	
	} else if (typeof define === 'function' && define.amd) {
	    define([], function () {
	        return vueTouchEvents;
	    });
	} else if (window.Vue) {
	    window.vueTouchEvents = vueTouchEvents;
	    Vue.use(vueTouchEvents);
	}


/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
	 * Vue.js v2.6.14
	 * (c) 2014-2021 Evan You
	 * Released under the MIT License.
	 */
	"use strict";var e=Object.freeze({});function t(e){return null==e}function n(e){return null!=e}function r(e){return!0===e}function i(e){return"string"==typeof e||"number"==typeof e||"symbol"==typeof e||"boolean"==typeof e}function o(e){return null!==e&&"object"==typeof e}var a=Object.prototype.toString;function s(e){return"[object Object]"===a.call(e)}function c(e){var t=parseFloat(String(e));return t>=0&&Math.floor(t)===t&&isFinite(e)}function u(e){return n(e)&&"function"==typeof e.then&&"function"==typeof e.catch}function l(e){return null==e?"":Array.isArray(e)||s(e)&&e.toString===a?JSON.stringify(e,null,2):String(e)}function f(e){var t=parseFloat(e);return isNaN(t)?e:t}function p(e,t){for(var n=Object.create(null),r=e.split(","),i=0;i<r.length;i++)n[r[i]]=!0;return t?function(e){return n[e.toLowerCase()]}:function(e){return n[e]}}var d=p("slot,component",!0),v=p("key,ref,slot,slot-scope,is");function h(e,t){if(e.length){var n=e.indexOf(t);if(n>-1)return e.splice(n,1)}}var m=Object.prototype.hasOwnProperty;function y(e,t){return m.call(e,t)}function g(e){var t=Object.create(null);return function(n){return t[n]||(t[n]=e(n))}}var _=/-(\w)/g,b=g(function(e){return e.replace(_,function(e,t){return t?t.toUpperCase():""})}),$=g(function(e){return e.charAt(0).toUpperCase()+e.slice(1)}),w=/\B([A-Z])/g,C=g(function(e){return e.replace(w,"-$1").toLowerCase()});var x=Function.prototype.bind?function(e,t){return e.bind(t)}:function(e,t){function n(n){var r=arguments.length;return r?r>1?e.apply(t,arguments):e.call(t,n):e.call(t)}return n._length=e.length,n};function k(e,t){t=t||0;for(var n=e.length-t,r=new Array(n);n--;)r[n]=e[n+t];return r}function A(e,t){for(var n in t)e[n]=t[n];return e}function O(e){for(var t={},n=0;n<e.length;n++)e[n]&&A(t,e[n]);return t}function S(e,t,n){}var T=function(e,t,n){return!1},N=function(e){return e};function E(e,t){if(e===t)return!0;var n=o(e),r=o(t);if(!n||!r)return!n&&!r&&String(e)===String(t);try{var i=Array.isArray(e),a=Array.isArray(t);if(i&&a)return e.length===t.length&&e.every(function(e,n){return E(e,t[n])});if(e instanceof Date&&t instanceof Date)return e.getTime()===t.getTime();if(i||a)return!1;var s=Object.keys(e),c=Object.keys(t);return s.length===c.length&&s.every(function(n){return E(e[n],t[n])})}catch(e){return!1}}function j(e,t){for(var n=0;n<e.length;n++)if(E(e[n],t))return n;return-1}function D(e){var t=!1;return function(){t||(t=!0,e.apply(this,arguments))}}var L="data-server-rendered",I=["component","directive","filter"],M=["beforeCreate","created","beforeMount","mounted","beforeUpdate","updated","beforeDestroy","destroyed","activated","deactivated","errorCaptured","serverPrefetch"],F={optionMergeStrategies:Object.create(null),silent:!1,productionTip:!1,devtools:!1,performance:!1,errorHandler:null,warnHandler:null,ignoredElements:[],keyCodes:Object.create(null),isReservedTag:T,isReservedAttr:T,isUnknownElement:T,getTagNamespace:S,parsePlatformTagName:N,mustUseProp:T,async:!0,_lifecycleHooks:M},P=/a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;function R(e,t,n,r){Object.defineProperty(e,t,{value:n,enumerable:!!r,writable:!0,configurable:!0})}var H=new RegExp("[^"+P.source+".$_\\d]");var B,U="__proto__"in{},V="undefined"!=typeof window,z="undefined"!=typeof WXEnvironment&&!!WXEnvironment.platform,K=z&&WXEnvironment.platform.toLowerCase(),J=V&&window.navigator.userAgent.toLowerCase(),q=J&&/msie|trident/.test(J),W=J&&J.indexOf("msie 9.0")>0,Z=J&&J.indexOf("edge/")>0,G=(J&&J.indexOf("android"),J&&/iphone|ipad|ipod|ios/.test(J)||"ios"===K),X=(J&&/chrome\/\d+/.test(J),J&&/phantomjs/.test(J),J&&J.match(/firefox\/(\d+)/)),Y={}.watch,Q=!1;if(V)try{var ee={};Object.defineProperty(ee,"passive",{get:function(){Q=!0}}),window.addEventListener("test-passive",null,ee)}catch(e){}var te=function(){return void 0===B&&(B=!V&&!z&&"undefined"!=typeof global&&(global.process&&"server"===global.process.env.VUE_ENV)),B},ne=V&&window.__VUE_DEVTOOLS_GLOBAL_HOOK__;function re(e){return"function"==typeof e&&/native code/.test(e.toString())}var ie,oe="undefined"!=typeof Symbol&&re(Symbol)&&"undefined"!=typeof Reflect&&re(Reflect.ownKeys);ie="undefined"!=typeof Set&&re(Set)?Set:function(){function e(){this.set=Object.create(null)}return e.prototype.has=function(e){return!0===this.set[e]},e.prototype.add=function(e){this.set[e]=!0},e.prototype.clear=function(){this.set=Object.create(null)},e}();var ae=S,se=0,ce=function(){this.id=se++,this.subs=[]};ce.prototype.addSub=function(e){this.subs.push(e)},ce.prototype.removeSub=function(e){h(this.subs,e)},ce.prototype.depend=function(){ce.target&&ce.target.addDep(this)},ce.prototype.notify=function(){for(var e=this.subs.slice(),t=0,n=e.length;t<n;t++)e[t].update()},ce.target=null;var ue=[];function le(e){ue.push(e),ce.target=e}function fe(){ue.pop(),ce.target=ue[ue.length-1]}var pe=function(e,t,n,r,i,o,a,s){this.tag=e,this.data=t,this.children=n,this.text=r,this.elm=i,this.ns=void 0,this.context=o,this.fnContext=void 0,this.fnOptions=void 0,this.fnScopeId=void 0,this.key=t&&t.key,this.componentOptions=a,this.componentInstance=void 0,this.parent=void 0,this.raw=!1,this.isStatic=!1,this.isRootInsert=!0,this.isComment=!1,this.isCloned=!1,this.isOnce=!1,this.asyncFactory=s,this.asyncMeta=void 0,this.isAsyncPlaceholder=!1},de={child:{configurable:!0}};de.child.get=function(){return this.componentInstance},Object.defineProperties(pe.prototype,de);var ve=function(e){void 0===e&&(e="");var t=new pe;return t.text=e,t.isComment=!0,t};function he(e){return new pe(void 0,void 0,void 0,String(e))}function me(e){var t=new pe(e.tag,e.data,e.children&&e.children.slice(),e.text,e.elm,e.context,e.componentOptions,e.asyncFactory);return t.ns=e.ns,t.isStatic=e.isStatic,t.key=e.key,t.isComment=e.isComment,t.fnContext=e.fnContext,t.fnOptions=e.fnOptions,t.fnScopeId=e.fnScopeId,t.asyncMeta=e.asyncMeta,t.isCloned=!0,t}var ye=Array.prototype,ge=Object.create(ye);["push","pop","shift","unshift","splice","sort","reverse"].forEach(function(e){var t=ye[e];R(ge,e,function(){for(var n=[],r=arguments.length;r--;)n[r]=arguments[r];var i,o=t.apply(this,n),a=this.__ob__;switch(e){case"push":case"unshift":i=n;break;case"splice":i=n.slice(2)}return i&&a.observeArray(i),a.dep.notify(),o})});var _e=Object.getOwnPropertyNames(ge),be=!0;function $e(e){be=e}var we=function(e){var t;this.value=e,this.dep=new ce,this.vmCount=0,R(e,"__ob__",this),Array.isArray(e)?(U?(t=ge,e.__proto__=t):function(e,t,n){for(var r=0,i=n.length;r<i;r++){var o=n[r];R(e,o,t[o])}}(e,ge,_e),this.observeArray(e)):this.walk(e)};function Ce(e,t){var n;if(o(e)&&!(e instanceof pe))return y(e,"__ob__")&&e.__ob__ instanceof we?n=e.__ob__:be&&!te()&&(Array.isArray(e)||s(e))&&Object.isExtensible(e)&&!e._isVue&&(n=new we(e)),t&&n&&n.vmCount++,n}function xe(e,t,n,r,i){var o=new ce,a=Object.getOwnPropertyDescriptor(e,t);if(!a||!1!==a.configurable){var s=a&&a.get,c=a&&a.set;s&&!c||2!==arguments.length||(n=e[t]);var u=!i&&Ce(n);Object.defineProperty(e,t,{enumerable:!0,configurable:!0,get:function(){var t=s?s.call(e):n;return ce.target&&(o.depend(),u&&(u.dep.depend(),Array.isArray(t)&&function e(t){for(var n=void 0,r=0,i=t.length;r<i;r++)(n=t[r])&&n.__ob__&&n.__ob__.dep.depend(),Array.isArray(n)&&e(n)}(t))),t},set:function(t){var r=s?s.call(e):n;t===r||t!=t&&r!=r||s&&!c||(c?c.call(e,t):n=t,u=!i&&Ce(t),o.notify())}})}}function ke(e,t,n){if(Array.isArray(e)&&c(t))return e.length=Math.max(e.length,t),e.splice(t,1,n),n;if(t in e&&!(t in Object.prototype))return e[t]=n,n;var r=e.__ob__;return e._isVue||r&&r.vmCount?n:r?(xe(r.value,t,n),r.dep.notify(),n):(e[t]=n,n)}function Ae(e,t){if(Array.isArray(e)&&c(t))e.splice(t,1);else{var n=e.__ob__;e._isVue||n&&n.vmCount||y(e,t)&&(delete e[t],n&&n.dep.notify())}}we.prototype.walk=function(e){for(var t=Object.keys(e),n=0;n<t.length;n++)xe(e,t[n])},we.prototype.observeArray=function(e){for(var t=0,n=e.length;t<n;t++)Ce(e[t])};var Oe=F.optionMergeStrategies;function Se(e,t){if(!t)return e;for(var n,r,i,o=oe?Reflect.ownKeys(t):Object.keys(t),a=0;a<o.length;a++)"__ob__"!==(n=o[a])&&(r=e[n],i=t[n],y(e,n)?r!==i&&s(r)&&s(i)&&Se(r,i):ke(e,n,i));return e}function Te(e,t,n){return n?function(){var r="function"==typeof t?t.call(n,n):t,i="function"==typeof e?e.call(n,n):e;return r?Se(r,i):i}:t?e?function(){return Se("function"==typeof t?t.call(this,this):t,"function"==typeof e?e.call(this,this):e)}:t:e}function Ne(e,t){var n=t?e?e.concat(t):Array.isArray(t)?t:[t]:e;return n?function(e){for(var t=[],n=0;n<e.length;n++)-1===t.indexOf(e[n])&&t.push(e[n]);return t}(n):n}function Ee(e,t,n,r){var i=Object.create(e||null);return t?A(i,t):i}Oe.data=function(e,t,n){return n?Te(e,t,n):t&&"function"!=typeof t?e:Te(e,t)},M.forEach(function(e){Oe[e]=Ne}),I.forEach(function(e){Oe[e+"s"]=Ee}),Oe.watch=function(e,t,n,r){if(e===Y&&(e=void 0),t===Y&&(t=void 0),!t)return Object.create(e||null);if(!e)return t;var i={};for(var o in A(i,e),t){var a=i[o],s=t[o];a&&!Array.isArray(a)&&(a=[a]),i[o]=a?a.concat(s):Array.isArray(s)?s:[s]}return i},Oe.props=Oe.methods=Oe.inject=Oe.computed=function(e,t,n,r){if(!e)return t;var i=Object.create(null);return A(i,e),t&&A(i,t),i},Oe.provide=Te;var je=function(e,t){return void 0===t?e:t};function De(e,t,n){if("function"==typeof t&&(t=t.options),function(e,t){var n=e.props;if(n){var r,i,o={};if(Array.isArray(n))for(r=n.length;r--;)"string"==typeof(i=n[r])&&(o[b(i)]={type:null});else if(s(n))for(var a in n)i=n[a],o[b(a)]=s(i)?i:{type:i};e.props=o}}(t),function(e,t){var n=e.inject;if(n){var r=e.inject={};if(Array.isArray(n))for(var i=0;i<n.length;i++)r[n[i]]={from:n[i]};else if(s(n))for(var o in n){var a=n[o];r[o]=s(a)?A({from:o},a):{from:a}}}}(t),function(e){var t=e.directives;if(t)for(var n in t){var r=t[n];"function"==typeof r&&(t[n]={bind:r,update:r})}}(t),!t._base&&(t.extends&&(e=De(e,t.extends,n)),t.mixins))for(var r=0,i=t.mixins.length;r<i;r++)e=De(e,t.mixins[r],n);var o,a={};for(o in e)c(o);for(o in t)y(e,o)||c(o);function c(r){var i=Oe[r]||je;a[r]=i(e[r],t[r],n,r)}return a}function Le(e,t,n,r){if("string"==typeof n){var i=e[t];if(y(i,n))return i[n];var o=b(n);if(y(i,o))return i[o];var a=$(o);return y(i,a)?i[a]:i[n]||i[o]||i[a]}}function Ie(e,t,n,r){var i=t[e],o=!y(n,e),a=n[e],s=Re(Boolean,i.type);if(s>-1)if(o&&!y(i,"default"))a=!1;else if(""===a||a===C(e)){var c=Re(String,i.type);(c<0||s<c)&&(a=!0)}if(void 0===a){a=function(e,t,n){if(!y(t,"default"))return;var r=t.default;if(e&&e.$options.propsData&&void 0===e.$options.propsData[n]&&void 0!==e._props[n])return e._props[n];return"function"==typeof r&&"Function"!==Fe(t.type)?r.call(e):r}(r,i,e);var u=be;$e(!0),Ce(a),$e(u)}return a}var Me=/^\s*function (\w+)/;function Fe(e){var t=e&&e.toString().match(Me);return t?t[1]:""}function Pe(e,t){return Fe(e)===Fe(t)}function Re(e,t){if(!Array.isArray(t))return Pe(t,e)?0:-1;for(var n=0,r=t.length;n<r;n++)if(Pe(t[n],e))return n;return-1}function He(e,t,n){le();try{if(t)for(var r=t;r=r.$parent;){var i=r.$options.errorCaptured;if(i)for(var o=0;o<i.length;o++)try{if(!1===i[o].call(r,e,t,n))return}catch(e){Ue(e,r,"errorCaptured hook")}}Ue(e,t,n)}finally{fe()}}function Be(e,t,n,r,i){var o;try{(o=n?e.apply(t,n):e.call(t))&&!o._isVue&&u(o)&&!o._handled&&(o.catch(function(e){return He(e,r,i+" (Promise/async)")}),o._handled=!0)}catch(e){He(e,r,i)}return o}function Ue(e,t,n){if(F.errorHandler)try{return F.errorHandler.call(null,e,t,n)}catch(t){t!==e&&Ve(t,null,"config.errorHandler")}Ve(e,t,n)}function Ve(e,t,n){if(!V&&!z||"undefined"==typeof console)throw e;console.error(e)}var ze,Ke=!1,Je=[],qe=!1;function We(){qe=!1;var e=Je.slice(0);Je.length=0;for(var t=0;t<e.length;t++)e[t]()}if("undefined"!=typeof Promise&&re(Promise)){var Ze=Promise.resolve();ze=function(){Ze.then(We),G&&setTimeout(S)},Ke=!0}else if(q||"undefined"==typeof MutationObserver||!re(MutationObserver)&&"[object MutationObserverConstructor]"!==MutationObserver.toString())ze="undefined"!=typeof setImmediate&&re(setImmediate)?function(){setImmediate(We)}:function(){setTimeout(We,0)};else{var Ge=1,Xe=new MutationObserver(We),Ye=document.createTextNode(String(Ge));Xe.observe(Ye,{characterData:!0}),ze=function(){Ge=(Ge+1)%2,Ye.data=String(Ge)},Ke=!0}function Qe(e,t){var n;if(Je.push(function(){if(e)try{e.call(t)}catch(e){He(e,t,"nextTick")}else n&&n(t)}),qe||(qe=!0,ze()),!e&&"undefined"!=typeof Promise)return new Promise(function(e){n=e})}var et=new ie;function tt(e){!function e(t,n){var r,i;var a=Array.isArray(t);if(!a&&!o(t)||Object.isFrozen(t)||t instanceof pe)return;if(t.__ob__){var s=t.__ob__.dep.id;if(n.has(s))return;n.add(s)}if(a)for(r=t.length;r--;)e(t[r],n);else for(i=Object.keys(t),r=i.length;r--;)e(t[i[r]],n)}(e,et),et.clear()}var nt=g(function(e){var t="&"===e.charAt(0),n="~"===(e=t?e.slice(1):e).charAt(0),r="!"===(e=n?e.slice(1):e).charAt(0);return{name:e=r?e.slice(1):e,once:n,capture:r,passive:t}});function rt(e,t){function n(){var e=arguments,r=n.fns;if(!Array.isArray(r))return Be(r,null,arguments,t,"v-on handler");for(var i=r.slice(),o=0;o<i.length;o++)Be(i[o],null,e,t,"v-on handler")}return n.fns=e,n}function it(e,n,i,o,a,s){var c,u,l,f;for(c in e)u=e[c],l=n[c],f=nt(c),t(u)||(t(l)?(t(u.fns)&&(u=e[c]=rt(u,s)),r(f.once)&&(u=e[c]=a(f.name,u,f.capture)),i(f.name,u,f.capture,f.passive,f.params)):u!==l&&(l.fns=u,e[c]=l));for(c in n)t(e[c])&&o((f=nt(c)).name,n[c],f.capture)}function ot(e,i,o){var a;e instanceof pe&&(e=e.data.hook||(e.data.hook={}));var s=e[i];function c(){o.apply(this,arguments),h(a.fns,c)}t(s)?a=rt([c]):n(s.fns)&&r(s.merged)?(a=s).fns.push(c):a=rt([s,c]),a.merged=!0,e[i]=a}function at(e,t,r,i,o){if(n(t)){if(y(t,r))return e[r]=t[r],o||delete t[r],!0;if(y(t,i))return e[r]=t[i],o||delete t[i],!0}return!1}function st(e){return i(e)?[he(e)]:Array.isArray(e)?function e(o,a){var s=[];var c,u,l,f;for(c=0;c<o.length;c++)t(u=o[c])||"boolean"==typeof u||(l=s.length-1,f=s[l],Array.isArray(u)?u.length>0&&(ct((u=e(u,(a||"")+"_"+c))[0])&&ct(f)&&(s[l]=he(f.text+u[0].text),u.shift()),s.push.apply(s,u)):i(u)?ct(f)?s[l]=he(f.text+u):""!==u&&s.push(he(u)):ct(u)&&ct(f)?s[l]=he(f.text+u.text):(r(o._isVList)&&n(u.tag)&&t(u.key)&&n(a)&&(u.key="__vlist"+a+"_"+c+"__"),s.push(u)));return s}(e):void 0}function ct(e){return n(e)&&n(e.text)&&!1===e.isComment}function ut(e,t){if(e){for(var n=Object.create(null),r=oe?Reflect.ownKeys(e):Object.keys(e),i=0;i<r.length;i++){var o=r[i];if("__ob__"!==o){for(var a=e[o].from,s=t;s;){if(s._provided&&y(s._provided,a)){n[o]=s._provided[a];break}s=s.$parent}if(!s&&"default"in e[o]){var c=e[o].default;n[o]="function"==typeof c?c.call(t):c}}}return n}}function lt(e,t){if(!e||!e.length)return{};for(var n={},r=0,i=e.length;r<i;r++){var o=e[r],a=o.data;if(a&&a.attrs&&a.attrs.slot&&delete a.attrs.slot,o.context!==t&&o.fnContext!==t||!a||null==a.slot)(n.default||(n.default=[])).push(o);else{var s=a.slot,c=n[s]||(n[s]=[]);"template"===o.tag?c.push.apply(c,o.children||[]):c.push(o)}}for(var u in n)n[u].every(ft)&&delete n[u];return n}function ft(e){return e.isComment&&!e.asyncFactory||" "===e.text}function pt(e){return e.isComment&&e.asyncFactory}function dt(t,n,r){var i,o=Object.keys(n).length>0,a=t?!!t.$stable:!o,s=t&&t.$key;if(t){if(t._normalized)return t._normalized;if(a&&r&&r!==e&&s===r.$key&&!o&&!r.$hasNormal)return r;for(var c in i={},t)t[c]&&"$"!==c[0]&&(i[c]=vt(n,c,t[c]))}else i={};for(var u in n)u in i||(i[u]=ht(n,u));return t&&Object.isExtensible(t)&&(t._normalized=i),R(i,"$stable",a),R(i,"$key",s),R(i,"$hasNormal",o),i}function vt(e,t,n){var r=function(){var e=arguments.length?n.apply(null,arguments):n({}),t=(e=e&&"object"==typeof e&&!Array.isArray(e)?[e]:st(e))&&e[0];return e&&(!t||1===e.length&&t.isComment&&!pt(t))?void 0:e};return n.proxy&&Object.defineProperty(e,t,{get:r,enumerable:!0,configurable:!0}),r}function ht(e,t){return function(){return e[t]}}function mt(e,t){var r,i,a,s,c;if(Array.isArray(e)||"string"==typeof e)for(r=new Array(e.length),i=0,a=e.length;i<a;i++)r[i]=t(e[i],i);else if("number"==typeof e)for(r=new Array(e),i=0;i<e;i++)r[i]=t(i+1,i);else if(o(e))if(oe&&e[Symbol.iterator]){r=[];for(var u=e[Symbol.iterator](),l=u.next();!l.done;)r.push(t(l.value,r.length)),l=u.next()}else for(s=Object.keys(e),r=new Array(s.length),i=0,a=s.length;i<a;i++)c=s[i],r[i]=t(e[c],c,i);return n(r)||(r=[]),r._isVList=!0,r}function yt(e,t,n,r){var i,o=this.$scopedSlots[e];o?(n=n||{},r&&(n=A(A({},r),n)),i=o(n)||("function"==typeof t?t():t)):i=this.$slots[e]||("function"==typeof t?t():t);var a=n&&n.slot;return a?this.$createElement("template",{slot:a},i):i}function gt(e){return Le(this.$options,"filters",e)||N}function _t(e,t){return Array.isArray(e)?-1===e.indexOf(t):e!==t}function bt(e,t,n,r,i){var o=F.keyCodes[t]||n;return i&&r&&!F.keyCodes[t]?_t(i,r):o?_t(o,e):r?C(r)!==t:void 0===e}function $t(e,t,n,r,i){if(n)if(o(n)){var a;Array.isArray(n)&&(n=O(n));var s=function(o){if("class"===o||"style"===o||v(o))a=e;else{var s=e.attrs&&e.attrs.type;a=r||F.mustUseProp(t,s,o)?e.domProps||(e.domProps={}):e.attrs||(e.attrs={})}var c=b(o),u=C(o);c in a||u in a||(a[o]=n[o],i&&((e.on||(e.on={}))["update:"+o]=function(e){n[o]=e}))};for(var c in n)s(c)}else;return e}function wt(e,t){var n=this._staticTrees||(this._staticTrees=[]),r=n[e];return r&&!t?r:(xt(r=n[e]=this.$options.staticRenderFns[e].call(this._renderProxy,null,this),"__static__"+e,!1),r)}function Ct(e,t,n){return xt(e,"__once__"+t+(n?"_"+n:""),!0),e}function xt(e,t,n){if(Array.isArray(e))for(var r=0;r<e.length;r++)e[r]&&"string"!=typeof e[r]&&kt(e[r],t+"_"+r,n);else kt(e,t,n)}function kt(e,t,n){e.isStatic=!0,e.key=t,e.isOnce=n}function At(e,t){if(t)if(s(t)){var n=e.on=e.on?A({},e.on):{};for(var r in t){var i=n[r],o=t[r];n[r]=i?[].concat(i,o):o}}else;return e}function Ot(e,t,n,r){t=t||{$stable:!n};for(var i=0;i<e.length;i++){var o=e[i];Array.isArray(o)?Ot(o,t,n):o&&(o.proxy&&(o.fn.proxy=!0),t[o.key]=o.fn)}return r&&(t.$key=r),t}function St(e,t){for(var n=0;n<t.length;n+=2){var r=t[n];"string"==typeof r&&r&&(e[t[n]]=t[n+1])}return e}function Tt(e,t){return"string"==typeof e?t+e:e}function Nt(e){e._o=Ct,e._n=f,e._s=l,e._l=mt,e._t=yt,e._q=E,e._i=j,e._m=wt,e._f=gt,e._k=bt,e._b=$t,e._v=he,e._e=ve,e._u=Ot,e._g=At,e._d=St,e._p=Tt}function Et(t,n,i,o,a){var s,c=this,u=a.options;y(o,"_uid")?(s=Object.create(o))._original=o:(s=o,o=o._original);var l=r(u._compiled),f=!l;this.data=t,this.props=n,this.children=i,this.parent=o,this.listeners=t.on||e,this.injections=ut(u.inject,o),this.slots=function(){return c.$slots||dt(t.scopedSlots,c.$slots=lt(i,o)),c.$slots},Object.defineProperty(this,"scopedSlots",{enumerable:!0,get:function(){return dt(t.scopedSlots,this.slots())}}),l&&(this.$options=u,this.$slots=this.slots(),this.$scopedSlots=dt(t.scopedSlots,this.$slots)),u._scopeId?this._c=function(e,t,n,r){var i=Ht(s,e,t,n,r,f);return i&&!Array.isArray(i)&&(i.fnScopeId=u._scopeId,i.fnContext=o),i}:this._c=function(e,t,n,r){return Ht(s,e,t,n,r,f)}}function jt(e,t,n,r,i){var o=me(e);return o.fnContext=n,o.fnOptions=r,t.slot&&((o.data||(o.data={})).slot=t.slot),o}function Dt(e,t){for(var n in t)e[b(n)]=t[n]}Nt(Et.prototype);var Lt={init:function(e,t){if(e.componentInstance&&!e.componentInstance._isDestroyed&&e.data.keepAlive){var r=e;Lt.prepatch(r,r)}else{(e.componentInstance=function(e,t){var r={_isComponent:!0,_parentVnode:e,parent:t},i=e.data.inlineTemplate;n(i)&&(r.render=i.render,r.staticRenderFns=i.staticRenderFns);return new e.componentOptions.Ctor(r)}(e,Zt)).$mount(t?e.elm:void 0,t)}},prepatch:function(t,n){var r=n.componentOptions;!function(t,n,r,i,o){var a=i.data.scopedSlots,s=t.$scopedSlots,c=!!(a&&!a.$stable||s!==e&&!s.$stable||a&&t.$scopedSlots.$key!==a.$key||!a&&t.$scopedSlots.$key),u=!!(o||t.$options._renderChildren||c);t.$options._parentVnode=i,t.$vnode=i,t._vnode&&(t._vnode.parent=i);if(t.$options._renderChildren=o,t.$attrs=i.data.attrs||e,t.$listeners=r||e,n&&t.$options.props){$e(!1);for(var l=t._props,f=t.$options._propKeys||[],p=0;p<f.length;p++){var d=f[p],v=t.$options.props;l[d]=Ie(d,v,n,t)}$e(!0),t.$options.propsData=n}r=r||e;var h=t.$options._parentListeners;t.$options._parentListeners=r,Wt(t,r,h),u&&(t.$slots=lt(o,i.context),t.$forceUpdate())}(n.componentInstance=t.componentInstance,r.propsData,r.listeners,n,r.children)},insert:function(e){var t,n=e.context,r=e.componentInstance;r._isMounted||(r._isMounted=!0,Qt(r,"mounted")),e.data.keepAlive&&(n._isMounted?((t=r)._inactive=!1,tn.push(t)):Yt(r,!0))},destroy:function(e){var t=e.componentInstance;t._isDestroyed||(e.data.keepAlive?function e(t,n){if(n&&(t._directInactive=!0,Xt(t)))return;if(!t._inactive){t._inactive=!0;for(var r=0;r<t.$children.length;r++)e(t.$children[r]);Qt(t,"deactivated")}}(t,!0):t.$destroy())}},It=Object.keys(Lt);function Mt(i,a,s,c,l){if(!t(i)){var f=s.$options._base;if(o(i)&&(i=f.extend(i)),"function"==typeof i){var p;if(t(i.cid)&&void 0===(i=function(e,i){if(r(e.error)&&n(e.errorComp))return e.errorComp;if(n(e.resolved))return e.resolved;var a=Ut;a&&n(e.owners)&&-1===e.owners.indexOf(a)&&e.owners.push(a);if(r(e.loading)&&n(e.loadingComp))return e.loadingComp;if(a&&!n(e.owners)){var s=e.owners=[a],c=!0,l=null,f=null;a.$on("hook:destroyed",function(){return h(s,a)});var p=function(e){for(var t=0,n=s.length;t<n;t++)s[t].$forceUpdate();e&&(s.length=0,null!==l&&(clearTimeout(l),l=null),null!==f&&(clearTimeout(f),f=null))},d=D(function(t){e.resolved=Vt(t,i),c?s.length=0:p(!0)}),v=D(function(t){n(e.errorComp)&&(e.error=!0,p(!0))}),m=e(d,v);return o(m)&&(u(m)?t(e.resolved)&&m.then(d,v):u(m.component)&&(m.component.then(d,v),n(m.error)&&(e.errorComp=Vt(m.error,i)),n(m.loading)&&(e.loadingComp=Vt(m.loading,i),0===m.delay?e.loading=!0:l=setTimeout(function(){l=null,t(e.resolved)&&t(e.error)&&(e.loading=!0,p(!1))},m.delay||200)),n(m.timeout)&&(f=setTimeout(function(){f=null,t(e.resolved)&&v(null)},m.timeout)))),c=!1,e.loading?e.loadingComp:e.resolved}}(p=i,f)))return function(e,t,n,r,i){var o=ve();return o.asyncFactory=e,o.asyncMeta={data:t,context:n,children:r,tag:i},o}(p,a,s,c,l);a=a||{},wn(i),n(a.model)&&function(e,t){var r=e.model&&e.model.prop||"value",i=e.model&&e.model.event||"input";(t.attrs||(t.attrs={}))[r]=t.model.value;var o=t.on||(t.on={}),a=o[i],s=t.model.callback;n(a)?(Array.isArray(a)?-1===a.indexOf(s):a!==s)&&(o[i]=[s].concat(a)):o[i]=s}(i.options,a);var d=function(e,r,i){var o=r.options.props;if(!t(o)){var a={},s=e.attrs,c=e.props;if(n(s)||n(c))for(var u in o){var l=C(u);at(a,c,u,l,!0)||at(a,s,u,l,!1)}return a}}(a,i);if(r(i.options.functional))return function(t,r,i,o,a){var s=t.options,c={},u=s.props;if(n(u))for(var l in u)c[l]=Ie(l,u,r||e);else n(i.attrs)&&Dt(c,i.attrs),n(i.props)&&Dt(c,i.props);var f=new Et(i,c,a,o,t),p=s.render.call(null,f._c,f);if(p instanceof pe)return jt(p,i,f.parent,s);if(Array.isArray(p)){for(var d=st(p)||[],v=new Array(d.length),h=0;h<d.length;h++)v[h]=jt(d[h],i,f.parent,s);return v}}(i,d,a,s,c);var v=a.on;if(a.on=a.nativeOn,r(i.options.abstract)){var m=a.slot;a={},m&&(a.slot=m)}!function(e){for(var t=e.hook||(e.hook={}),n=0;n<It.length;n++){var r=It[n],i=t[r],o=Lt[r];i===o||i&&i._merged||(t[r]=i?Ft(o,i):o)}}(a);var y=i.options.name||l;return new pe("vue-component-"+i.cid+(y?"-"+y:""),a,void 0,void 0,void 0,s,{Ctor:i,propsData:d,listeners:v,tag:l,children:c},p)}}}function Ft(e,t){var n=function(n,r){e(n,r),t(n,r)};return n._merged=!0,n}var Pt=1,Rt=2;function Ht(e,a,s,c,u,l){return(Array.isArray(s)||i(s))&&(u=c,c=s,s=void 0),r(l)&&(u=Rt),function(e,i,a,s,c){if(n(a)&&n(a.__ob__))return ve();n(a)&&n(a.is)&&(i=a.is);if(!i)return ve();Array.isArray(s)&&"function"==typeof s[0]&&((a=a||{}).scopedSlots={default:s[0]},s.length=0);c===Rt?s=st(s):c===Pt&&(s=function(e){for(var t=0;t<e.length;t++)if(Array.isArray(e[t]))return Array.prototype.concat.apply([],e);return e}(s));var u,l;if("string"==typeof i){var f;l=e.$vnode&&e.$vnode.ns||F.getTagNamespace(i),u=F.isReservedTag(i)?new pe(F.parsePlatformTagName(i),a,s,void 0,void 0,e):a&&a.pre||!n(f=Le(e.$options,"components",i))?new pe(i,a,s,void 0,void 0,e):Mt(f,a,e,s,i)}else u=Mt(i,a,e,s);return Array.isArray(u)?u:n(u)?(n(l)&&function e(i,o,a){i.ns=o;"foreignObject"===i.tag&&(o=void 0,a=!0);if(n(i.children))for(var s=0,c=i.children.length;s<c;s++){var u=i.children[s];n(u.tag)&&(t(u.ns)||r(a)&&"svg"!==u.tag)&&e(u,o,a)}}(u,l),n(a)&&function(e){o(e.style)&&tt(e.style);o(e.class)&&tt(e.class)}(a),u):ve()}(e,a,s,c,u)}var Bt,Ut=null;function Vt(e,t){return(e.__esModule||oe&&"Module"===e[Symbol.toStringTag])&&(e=e.default),o(e)?t.extend(e):e}function zt(e){if(Array.isArray(e))for(var t=0;t<e.length;t++){var r=e[t];if(n(r)&&(n(r.componentOptions)||pt(r)))return r}}function Kt(e,t){Bt.$on(e,t)}function Jt(e,t){Bt.$off(e,t)}function qt(e,t){var n=Bt;return function r(){null!==t.apply(null,arguments)&&n.$off(e,r)}}function Wt(e,t,n){Bt=e,it(t,n||{},Kt,Jt,qt,e),Bt=void 0}var Zt=null;function Gt(e){var t=Zt;return Zt=e,function(){Zt=t}}function Xt(e){for(;e&&(e=e.$parent);)if(e._inactive)return!0;return!1}function Yt(e,t){if(t){if(e._directInactive=!1,Xt(e))return}else if(e._directInactive)return;if(e._inactive||null===e._inactive){e._inactive=!1;for(var n=0;n<e.$children.length;n++)Yt(e.$children[n]);Qt(e,"activated")}}function Qt(e,t){le();var n=e.$options[t],r=t+" hook";if(n)for(var i=0,o=n.length;i<o;i++)Be(n[i],e,null,e,r);e._hasHookEvent&&e.$emit("hook:"+t),fe()}var en=[],tn=[],nn={},rn=!1,on=!1,an=0;var sn=0,cn=Date.now;if(V&&!q){var un=window.performance;un&&"function"==typeof un.now&&cn()>document.createEvent("Event").timeStamp&&(cn=function(){return un.now()})}function ln(){var e,t;for(sn=cn(),on=!0,en.sort(function(e,t){return e.id-t.id}),an=0;an<en.length;an++)(e=en[an]).before&&e.before(),t=e.id,nn[t]=null,e.run();var n=tn.slice(),r=en.slice();an=en.length=tn.length=0,nn={},rn=on=!1,function(e){for(var t=0;t<e.length;t++)e[t]._inactive=!0,Yt(e[t],!0)}(n),function(e){var t=e.length;for(;t--;){var n=e[t],r=n.vm;r._watcher===n&&r._isMounted&&!r._isDestroyed&&Qt(r,"updated")}}(r),ne&&F.devtools&&ne.emit("flush")}var fn=0,pn=function(e,t,n,r,i){this.vm=e,i&&(e._watcher=this),e._watchers.push(this),r?(this.deep=!!r.deep,this.user=!!r.user,this.lazy=!!r.lazy,this.sync=!!r.sync,this.before=r.before):this.deep=this.user=this.lazy=this.sync=!1,this.cb=n,this.id=++fn,this.active=!0,this.dirty=this.lazy,this.deps=[],this.newDeps=[],this.depIds=new ie,this.newDepIds=new ie,this.expression="","function"==typeof t?this.getter=t:(this.getter=function(e){if(!H.test(e)){var t=e.split(".");return function(e){for(var n=0;n<t.length;n++){if(!e)return;e=e[t[n]]}return e}}}(t),this.getter||(this.getter=S)),this.value=this.lazy?void 0:this.get()};pn.prototype.get=function(){var e;le(this);var t=this.vm;try{e=this.getter.call(t,t)}catch(e){if(!this.user)throw e;He(e,t,'getter for watcher "'+this.expression+'"')}finally{this.deep&&tt(e),fe(),this.cleanupDeps()}return e},pn.prototype.addDep=function(e){var t=e.id;this.newDepIds.has(t)||(this.newDepIds.add(t),this.newDeps.push(e),this.depIds.has(t)||e.addSub(this))},pn.prototype.cleanupDeps=function(){for(var e=this.deps.length;e--;){var t=this.deps[e];this.newDepIds.has(t.id)||t.removeSub(this)}var n=this.depIds;this.depIds=this.newDepIds,this.newDepIds=n,this.newDepIds.clear(),n=this.deps,this.deps=this.newDeps,this.newDeps=n,this.newDeps.length=0},pn.prototype.update=function(){this.lazy?this.dirty=!0:this.sync?this.run():function(e){var t=e.id;if(null==nn[t]){if(nn[t]=!0,on){for(var n=en.length-1;n>an&&en[n].id>e.id;)n--;en.splice(n+1,0,e)}else en.push(e);rn||(rn=!0,Qe(ln))}}(this)},pn.prototype.run=function(){if(this.active){var e=this.get();if(e!==this.value||o(e)||this.deep){var t=this.value;if(this.value=e,this.user){var n='callback for watcher "'+this.expression+'"';Be(this.cb,this.vm,[e,t],this.vm,n)}else this.cb.call(this.vm,e,t)}}},pn.prototype.evaluate=function(){this.value=this.get(),this.dirty=!1},pn.prototype.depend=function(){for(var e=this.deps.length;e--;)this.deps[e].depend()},pn.prototype.teardown=function(){if(this.active){this.vm._isBeingDestroyed||h(this.vm._watchers,this);for(var e=this.deps.length;e--;)this.deps[e].removeSub(this);this.active=!1}};var dn={enumerable:!0,configurable:!0,get:S,set:S};function vn(e,t,n){dn.get=function(){return this[t][n]},dn.set=function(e){this[t][n]=e},Object.defineProperty(e,n,dn)}function hn(e){e._watchers=[];var t=e.$options;t.props&&function(e,t){var n=e.$options.propsData||{},r=e._props={},i=e.$options._propKeys=[];e.$parent&&$e(!1);var o=function(o){i.push(o);var a=Ie(o,t,n,e);xe(r,o,a),o in e||vn(e,"_props",o)};for(var a in t)o(a);$e(!0)}(e,t.props),t.methods&&function(e,t){e.$options.props;for(var n in t)e[n]="function"!=typeof t[n]?S:x(t[n],e)}(e,t.methods),t.data?function(e){var t=e.$options.data;s(t=e._data="function"==typeof t?function(e,t){le();try{return e.call(t,t)}catch(e){return He(e,t,"data()"),{}}finally{fe()}}(t,e):t||{})||(t={});var n=Object.keys(t),r=e.$options.props,i=(e.$options.methods,n.length);for(;i--;){var o=n[i];r&&y(r,o)||(a=void 0,36!==(a=(o+"").charCodeAt(0))&&95!==a&&vn(e,"_data",o))}var a;Ce(t,!0)}(e):Ce(e._data={},!0),t.computed&&function(e,t){var n=e._computedWatchers=Object.create(null),r=te();for(var i in t){var o=t[i],a="function"==typeof o?o:o.get;r||(n[i]=new pn(e,a||S,S,mn)),i in e||yn(e,i,o)}}(e,t.computed),t.watch&&t.watch!==Y&&function(e,t){for(var n in t){var r=t[n];if(Array.isArray(r))for(var i=0;i<r.length;i++)bn(e,n,r[i]);else bn(e,n,r)}}(e,t.watch)}var mn={lazy:!0};function yn(e,t,n){var r=!te();"function"==typeof n?(dn.get=r?gn(t):_n(n),dn.set=S):(dn.get=n.get?r&&!1!==n.cache?gn(t):_n(n.get):S,dn.set=n.set||S),Object.defineProperty(e,t,dn)}function gn(e){return function(){var t=this._computedWatchers&&this._computedWatchers[e];if(t)return t.dirty&&t.evaluate(),ce.target&&t.depend(),t.value}}function _n(e){return function(){return e.call(this,this)}}function bn(e,t,n,r){return s(n)&&(r=n,n=n.handler),"string"==typeof n&&(n=e[n]),e.$watch(t,n,r)}var $n=0;function wn(e){var t=e.options;if(e.super){var n=wn(e.super);if(n!==e.superOptions){e.superOptions=n;var r=function(e){var t,n=e.options,r=e.sealedOptions;for(var i in n)n[i]!==r[i]&&(t||(t={}),t[i]=n[i]);return t}(e);r&&A(e.extendOptions,r),(t=e.options=De(n,e.extendOptions)).name&&(t.components[t.name]=e)}}return t}function Cn(e){this._init(e)}function xn(e){e.cid=0;var t=1;e.extend=function(e){e=e||{};var n=this,r=n.cid,i=e._Ctor||(e._Ctor={});if(i[r])return i[r];var o=e.name||n.options.name,a=function(e){this._init(e)};return(a.prototype=Object.create(n.prototype)).constructor=a,a.cid=t++,a.options=De(n.options,e),a.super=n,a.options.props&&function(e){var t=e.options.props;for(var n in t)vn(e.prototype,"_props",n)}(a),a.options.computed&&function(e){var t=e.options.computed;for(var n in t)yn(e.prototype,n,t[n])}(a),a.extend=n.extend,a.mixin=n.mixin,a.use=n.use,I.forEach(function(e){a[e]=n[e]}),o&&(a.options.components[o]=a),a.superOptions=n.options,a.extendOptions=e,a.sealedOptions=A({},a.options),i[r]=a,a}}function kn(e){return e&&(e.Ctor.options.name||e.tag)}function An(e,t){return Array.isArray(e)?e.indexOf(t)>-1:"string"==typeof e?e.split(",").indexOf(t)>-1:(n=e,"[object RegExp]"===a.call(n)&&e.test(t));var n}function On(e,t){var n=e.cache,r=e.keys,i=e._vnode;for(var o in n){var a=n[o];if(a){var s=a.name;s&&!t(s)&&Sn(n,o,r,i)}}}function Sn(e,t,n,r){var i=e[t];!i||r&&i.tag===r.tag||i.componentInstance.$destroy(),e[t]=null,h(n,t)}!function(t){t.prototype._init=function(t){var n=this;n._uid=$n++,n._isVue=!0,t&&t._isComponent?function(e,t){var n=e.$options=Object.create(e.constructor.options),r=t._parentVnode;n.parent=t.parent,n._parentVnode=r;var i=r.componentOptions;n.propsData=i.propsData,n._parentListeners=i.listeners,n._renderChildren=i.children,n._componentTag=i.tag,t.render&&(n.render=t.render,n.staticRenderFns=t.staticRenderFns)}(n,t):n.$options=De(wn(n.constructor),t||{},n),n._renderProxy=n,n._self=n,function(e){var t=e.$options,n=t.parent;if(n&&!t.abstract){for(;n.$options.abstract&&n.$parent;)n=n.$parent;n.$children.push(e)}e.$parent=n,e.$root=n?n.$root:e,e.$children=[],e.$refs={},e._watcher=null,e._inactive=null,e._directInactive=!1,e._isMounted=!1,e._isDestroyed=!1,e._isBeingDestroyed=!1}(n),function(e){e._events=Object.create(null),e._hasHookEvent=!1;var t=e.$options._parentListeners;t&&Wt(e,t)}(n),function(t){t._vnode=null,t._staticTrees=null;var n=t.$options,r=t.$vnode=n._parentVnode,i=r&&r.context;t.$slots=lt(n._renderChildren,i),t.$scopedSlots=e,t._c=function(e,n,r,i){return Ht(t,e,n,r,i,!1)},t.$createElement=function(e,n,r,i){return Ht(t,e,n,r,i,!0)};var o=r&&r.data;xe(t,"$attrs",o&&o.attrs||e,null,!0),xe(t,"$listeners",n._parentListeners||e,null,!0)}(n),Qt(n,"beforeCreate"),function(e){var t=ut(e.$options.inject,e);t&&($e(!1),Object.keys(t).forEach(function(n){xe(e,n,t[n])}),$e(!0))}(n),hn(n),function(e){var t=e.$options.provide;t&&(e._provided="function"==typeof t?t.call(e):t)}(n),Qt(n,"created"),n.$options.el&&n.$mount(n.$options.el)}}(Cn),function(e){var t={get:function(){return this._data}},n={get:function(){return this._props}};Object.defineProperty(e.prototype,"$data",t),Object.defineProperty(e.prototype,"$props",n),e.prototype.$set=ke,e.prototype.$delete=Ae,e.prototype.$watch=function(e,t,n){if(s(t))return bn(this,e,t,n);(n=n||{}).user=!0;var r=new pn(this,e,t,n);if(n.immediate){var i='callback for immediate watcher "'+r.expression+'"';le(),Be(t,this,[r.value],this,i),fe()}return function(){r.teardown()}}}(Cn),function(e){var t=/^hook:/;e.prototype.$on=function(e,n){var r=this;if(Array.isArray(e))for(var i=0,o=e.length;i<o;i++)r.$on(e[i],n);else(r._events[e]||(r._events[e]=[])).push(n),t.test(e)&&(r._hasHookEvent=!0);return r},e.prototype.$once=function(e,t){var n=this;function r(){n.$off(e,r),t.apply(n,arguments)}return r.fn=t,n.$on(e,r),n},e.prototype.$off=function(e,t){var n=this;if(!arguments.length)return n._events=Object.create(null),n;if(Array.isArray(e)){for(var r=0,i=e.length;r<i;r++)n.$off(e[r],t);return n}var o,a=n._events[e];if(!a)return n;if(!t)return n._events[e]=null,n;for(var s=a.length;s--;)if((o=a[s])===t||o.fn===t){a.splice(s,1);break}return n},e.prototype.$emit=function(e){var t=this._events[e];if(t){t=t.length>1?k(t):t;for(var n=k(arguments,1),r='event handler for "'+e+'"',i=0,o=t.length;i<o;i++)Be(t[i],this,n,this,r)}return this}}(Cn),function(e){e.prototype._update=function(e,t){var n=this,r=n.$el,i=n._vnode,o=Gt(n);n._vnode=e,n.$el=i?n.__patch__(i,e):n.__patch__(n.$el,e,t,!1),o(),r&&(r.__vue__=null),n.$el&&(n.$el.__vue__=n),n.$vnode&&n.$parent&&n.$vnode===n.$parent._vnode&&(n.$parent.$el=n.$el)},e.prototype.$forceUpdate=function(){this._watcher&&this._watcher.update()},e.prototype.$destroy=function(){var e=this;if(!e._isBeingDestroyed){Qt(e,"beforeDestroy"),e._isBeingDestroyed=!0;var t=e.$parent;!t||t._isBeingDestroyed||e.$options.abstract||h(t.$children,e),e._watcher&&e._watcher.teardown();for(var n=e._watchers.length;n--;)e._watchers[n].teardown();e._data.__ob__&&e._data.__ob__.vmCount--,e._isDestroyed=!0,e.__patch__(e._vnode,null),Qt(e,"destroyed"),e.$off(),e.$el&&(e.$el.__vue__=null),e.$vnode&&(e.$vnode.parent=null)}}}(Cn),function(e){Nt(e.prototype),e.prototype.$nextTick=function(e){return Qe(e,this)},e.prototype._render=function(){var e,t=this,n=t.$options,r=n.render,i=n._parentVnode;i&&(t.$scopedSlots=dt(i.data.scopedSlots,t.$slots,t.$scopedSlots)),t.$vnode=i;try{Ut=t,e=r.call(t._renderProxy,t.$createElement)}catch(n){He(n,t,"render"),e=t._vnode}finally{Ut=null}return Array.isArray(e)&&1===e.length&&(e=e[0]),e instanceof pe||(e=ve()),e.parent=i,e}}(Cn);var Tn=[String,RegExp,Array],Nn={KeepAlive:{name:"keep-alive",abstract:!0,props:{include:Tn,exclude:Tn,max:[String,Number]},methods:{cacheVNode:function(){var e=this.cache,t=this.keys,n=this.vnodeToCache,r=this.keyToCache;if(n){var i=n.tag,o=n.componentInstance,a=n.componentOptions;e[r]={name:kn(a),tag:i,componentInstance:o},t.push(r),this.max&&t.length>parseInt(this.max)&&Sn(e,t[0],t,this._vnode),this.vnodeToCache=null}}},created:function(){this.cache=Object.create(null),this.keys=[]},destroyed:function(){for(var e in this.cache)Sn(this.cache,e,this.keys)},mounted:function(){var e=this;this.cacheVNode(),this.$watch("include",function(t){On(e,function(e){return An(t,e)})}),this.$watch("exclude",function(t){On(e,function(e){return!An(t,e)})})},updated:function(){this.cacheVNode()},render:function(){var e=this.$slots.default,t=zt(e),n=t&&t.componentOptions;if(n){var r=kn(n),i=this.include,o=this.exclude;if(i&&(!r||!An(i,r))||o&&r&&An(o,r))return t;var a=this.cache,s=this.keys,c=null==t.key?n.Ctor.cid+(n.tag?"::"+n.tag:""):t.key;a[c]?(t.componentInstance=a[c].componentInstance,h(s,c),s.push(c)):(this.vnodeToCache=t,this.keyToCache=c),t.data.keepAlive=!0}return t||e&&e[0]}}};!function(e){var t={get:function(){return F}};Object.defineProperty(e,"config",t),e.util={warn:ae,extend:A,mergeOptions:De,defineReactive:xe},e.set=ke,e.delete=Ae,e.nextTick=Qe,e.observable=function(e){return Ce(e),e},e.options=Object.create(null),I.forEach(function(t){e.options[t+"s"]=Object.create(null)}),e.options._base=e,A(e.options.components,Nn),function(e){e.use=function(e){var t=this._installedPlugins||(this._installedPlugins=[]);if(t.indexOf(e)>-1)return this;var n=k(arguments,1);return n.unshift(this),"function"==typeof e.install?e.install.apply(e,n):"function"==typeof e&&e.apply(null,n),t.push(e),this}}(e),function(e){e.mixin=function(e){return this.options=De(this.options,e),this}}(e),xn(e),function(e){I.forEach(function(t){e[t]=function(e,n){return n?("component"===t&&s(n)&&(n.name=n.name||e,n=this.options._base.extend(n)),"directive"===t&&"function"==typeof n&&(n={bind:n,update:n}),this.options[t+"s"][e]=n,n):this.options[t+"s"][e]}})}(e)}(Cn),Object.defineProperty(Cn.prototype,"$isServer",{get:te}),Object.defineProperty(Cn.prototype,"$ssrContext",{get:function(){return this.$vnode&&this.$vnode.ssrContext}}),Object.defineProperty(Cn,"FunctionalRenderContext",{value:Et}),Cn.version="2.6.14";var En=p("style,class"),jn=p("input,textarea,option,select,progress"),Dn=function(e,t,n){return"value"===n&&jn(e)&&"button"!==t||"selected"===n&&"option"===e||"checked"===n&&"input"===e||"muted"===n&&"video"===e},Ln=p("contenteditable,draggable,spellcheck"),In=p("events,caret,typing,plaintext-only"),Mn=function(e,t){return Bn(t)||"false"===t?"false":"contenteditable"===e&&In(t)?t:"true"},Fn=p("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,truespeed,typemustmatch,visible"),Pn="http://www.w3.org/1999/xlink",Rn=function(e){return":"===e.charAt(5)&&"xlink"===e.slice(0,5)},Hn=function(e){return Rn(e)?e.slice(6,e.length):""},Bn=function(e){return null==e||!1===e};function Un(e){for(var t=e.data,r=e,i=e;n(i.componentInstance);)(i=i.componentInstance._vnode)&&i.data&&(t=Vn(i.data,t));for(;n(r=r.parent);)r&&r.data&&(t=Vn(t,r.data));return function(e,t){if(n(e)||n(t))return zn(e,Kn(t));return""}(t.staticClass,t.class)}function Vn(e,t){return{staticClass:zn(e.staticClass,t.staticClass),class:n(e.class)?[e.class,t.class]:t.class}}function zn(e,t){return e?t?e+" "+t:e:t||""}function Kn(e){return Array.isArray(e)?function(e){for(var t,r="",i=0,o=e.length;i<o;i++)n(t=Kn(e[i]))&&""!==t&&(r&&(r+=" "),r+=t);return r}(e):o(e)?function(e){var t="";for(var n in e)e[n]&&(t&&(t+=" "),t+=n);return t}(e):"string"==typeof e?e:""}var Jn={svg:"http://www.w3.org/2000/svg",math:"http://www.w3.org/1998/Math/MathML"},qn=p("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"),Wn=p("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view",!0),Zn=function(e){return qn(e)||Wn(e)};function Gn(e){return Wn(e)?"svg":"math"===e?"math":void 0}var Xn=Object.create(null);var Yn=p("text,number,password,search,email,tel,url");function Qn(e){if("string"==typeof e){var t=document.querySelector(e);return t||document.createElement("div")}return e}var er=Object.freeze({createElement:function(e,t){var n=document.createElement(e);return"select"!==e?n:(t.data&&t.data.attrs&&void 0!==t.data.attrs.multiple&&n.setAttribute("multiple","multiple"),n)},createElementNS:function(e,t){return document.createElementNS(Jn[e],t)},createTextNode:function(e){return document.createTextNode(e)},createComment:function(e){return document.createComment(e)},insertBefore:function(e,t,n){e.insertBefore(t,n)},removeChild:function(e,t){e.removeChild(t)},appendChild:function(e,t){e.appendChild(t)},parentNode:function(e){return e.parentNode},nextSibling:function(e){return e.nextSibling},tagName:function(e){return e.tagName},setTextContent:function(e,t){e.textContent=t},setStyleScope:function(e,t){e.setAttribute(t,"")}}),tr={create:function(e,t){nr(t)},update:function(e,t){e.data.ref!==t.data.ref&&(nr(e,!0),nr(t))},destroy:function(e){nr(e,!0)}};function nr(e,t){var r=e.data.ref;if(n(r)){var i=e.context,o=e.componentInstance||e.elm,a=i.$refs;t?Array.isArray(a[r])?h(a[r],o):a[r]===o&&(a[r]=void 0):e.data.refInFor?Array.isArray(a[r])?a[r].indexOf(o)<0&&a[r].push(o):a[r]=[o]:a[r]=o}}var rr=new pe("",{},[]),ir=["create","activate","update","remove","destroy"];function or(e,i){return e.key===i.key&&e.asyncFactory===i.asyncFactory&&(e.tag===i.tag&&e.isComment===i.isComment&&n(e.data)===n(i.data)&&function(e,t){if("input"!==e.tag)return!0;var r,i=n(r=e.data)&&n(r=r.attrs)&&r.type,o=n(r=t.data)&&n(r=r.attrs)&&r.type;return i===o||Yn(i)&&Yn(o)}(e,i)||r(e.isAsyncPlaceholder)&&t(i.asyncFactory.error))}function ar(e,t,r){var i,o,a={};for(i=t;i<=r;++i)n(o=e[i].key)&&(a[o]=i);return a}var sr={create:cr,update:cr,destroy:function(e){cr(e,rr)}};function cr(e,t){(e.data.directives||t.data.directives)&&function(e,t){var n,r,i,o=e===rr,a=t===rr,s=lr(e.data.directives,e.context),c=lr(t.data.directives,t.context),u=[],l=[];for(n in c)r=s[n],i=c[n],r?(i.oldValue=r.value,i.oldArg=r.arg,pr(i,"update",t,e),i.def&&i.def.componentUpdated&&l.push(i)):(pr(i,"bind",t,e),i.def&&i.def.inserted&&u.push(i));if(u.length){var f=function(){for(var n=0;n<u.length;n++)pr(u[n],"inserted",t,e)};o?ot(t,"insert",f):f()}l.length&&ot(t,"postpatch",function(){for(var n=0;n<l.length;n++)pr(l[n],"componentUpdated",t,e)});if(!o)for(n in s)c[n]||pr(s[n],"unbind",e,e,a)}(e,t)}var ur=Object.create(null);function lr(e,t){var n,r,i=Object.create(null);if(!e)return i;for(n=0;n<e.length;n++)(r=e[n]).modifiers||(r.modifiers=ur),i[fr(r)]=r,r.def=Le(t.$options,"directives",r.name);return i}function fr(e){return e.rawName||e.name+"."+Object.keys(e.modifiers||{}).join(".")}function pr(e,t,n,r,i){var o=e.def&&e.def[t];if(o)try{o(n.elm,e,n,r,i)}catch(r){He(r,n.context,"directive "+e.name+" "+t+" hook")}}var dr=[tr,sr];function vr(e,r){var i=r.componentOptions;if(!(n(i)&&!1===i.Ctor.options.inheritAttrs||t(e.data.attrs)&&t(r.data.attrs))){var o,a,s=r.elm,c=e.data.attrs||{},u=r.data.attrs||{};for(o in n(u.__ob__)&&(u=r.data.attrs=A({},u)),u)a=u[o],c[o]!==a&&hr(s,o,a,r.data.pre);for(o in(q||Z)&&u.value!==c.value&&hr(s,"value",u.value),c)t(u[o])&&(Rn(o)?s.removeAttributeNS(Pn,Hn(o)):Ln(o)||s.removeAttribute(o))}}function hr(e,t,n,r){r||e.tagName.indexOf("-")>-1?mr(e,t,n):Fn(t)?Bn(n)?e.removeAttribute(t):(n="allowfullscreen"===t&&"EMBED"===e.tagName?"true":t,e.setAttribute(t,n)):Ln(t)?e.setAttribute(t,Mn(t,n)):Rn(t)?Bn(n)?e.removeAttributeNS(Pn,Hn(t)):e.setAttributeNS(Pn,t,n):mr(e,t,n)}function mr(e,t,n){if(Bn(n))e.removeAttribute(t);else{if(q&&!W&&"TEXTAREA"===e.tagName&&"placeholder"===t&&""!==n&&!e.__ieph){var r=function(t){t.stopImmediatePropagation(),e.removeEventListener("input",r)};e.addEventListener("input",r),e.__ieph=!0}e.setAttribute(t,n)}}var yr={create:vr,update:vr};function gr(e,r){var i=r.elm,o=r.data,a=e.data;if(!(t(o.staticClass)&&t(o.class)&&(t(a)||t(a.staticClass)&&t(a.class)))){var s=Un(r),c=i._transitionClasses;n(c)&&(s=zn(s,Kn(c))),s!==i._prevClass&&(i.setAttribute("class",s),i._prevClass=s)}}var _r,br,$r,wr,Cr,xr,kr={create:gr,update:gr},Ar=/[\w).+\-_$\]]/;function Or(e){var t,n,r,i,o,a=!1,s=!1,c=!1,u=!1,l=0,f=0,p=0,d=0;for(r=0;r<e.length;r++)if(n=t,t=e.charCodeAt(r),a)39===t&&92!==n&&(a=!1);else if(s)34===t&&92!==n&&(s=!1);else if(c)96===t&&92!==n&&(c=!1);else if(u)47===t&&92!==n&&(u=!1);else if(124!==t||124===e.charCodeAt(r+1)||124===e.charCodeAt(r-1)||l||f||p){switch(t){case 34:s=!0;break;case 39:a=!0;break;case 96:c=!0;break;case 40:p++;break;case 41:p--;break;case 91:f++;break;case 93:f--;break;case 123:l++;break;case 125:l--}if(47===t){for(var v=r-1,h=void 0;v>=0&&" "===(h=e.charAt(v));v--);h&&Ar.test(h)||(u=!0)}}else void 0===i?(d=r+1,i=e.slice(0,r).trim()):m();function m(){(o||(o=[])).push(e.slice(d,r).trim()),d=r+1}if(void 0===i?i=e.slice(0,r).trim():0!==d&&m(),o)for(r=0;r<o.length;r++)i=Sr(i,o[r]);return i}function Sr(e,t){var n=t.indexOf("(");if(n<0)return'_f("'+t+'")('+e+")";var r=t.slice(0,n),i=t.slice(n+1);return'_f("'+r+'")('+e+(")"!==i?","+i:i)}function Tr(e,t){console.error("[Vue compiler]: "+e)}function Nr(e,t){return e?e.map(function(e){return e[t]}).filter(function(e){return e}):[]}function Er(e,t,n,r,i){(e.props||(e.props=[])).push(Hr({name:t,value:n,dynamic:i},r)),e.plain=!1}function jr(e,t,n,r,i){(i?e.dynamicAttrs||(e.dynamicAttrs=[]):e.attrs||(e.attrs=[])).push(Hr({name:t,value:n,dynamic:i},r)),e.plain=!1}function Dr(e,t,n,r){e.attrsMap[t]=n,e.attrsList.push(Hr({name:t,value:n},r))}function Lr(e,t,n,r,i,o,a,s){(e.directives||(e.directives=[])).push(Hr({name:t,rawName:n,value:r,arg:i,isDynamicArg:o,modifiers:a},s)),e.plain=!1}function Ir(e,t,n){return n?"_p("+t+',"'+e+'")':e+t}function Mr(t,n,r,i,o,a,s,c){var u;(i=i||e).right?c?n="("+n+")==='click'?'contextmenu':("+n+")":"click"===n&&(n="contextmenu",delete i.right):i.middle&&(c?n="("+n+")==='click'?'mouseup':("+n+")":"click"===n&&(n="mouseup")),i.capture&&(delete i.capture,n=Ir("!",n,c)),i.once&&(delete i.once,n=Ir("~",n,c)),i.passive&&(delete i.passive,n=Ir("&",n,c)),i.native?(delete i.native,u=t.nativeEvents||(t.nativeEvents={})):u=t.events||(t.events={});var l=Hr({value:r.trim(),dynamic:c},s);i!==e&&(l.modifiers=i);var f=u[n];Array.isArray(f)?o?f.unshift(l):f.push(l):u[n]=f?o?[l,f]:[f,l]:l,t.plain=!1}function Fr(e,t,n){var r=Pr(e,":"+t)||Pr(e,"v-bind:"+t);if(null!=r)return Or(r);if(!1!==n){var i=Pr(e,t);if(null!=i)return JSON.stringify(i)}}function Pr(e,t,n){var r;if(null!=(r=e.attrsMap[t]))for(var i=e.attrsList,o=0,a=i.length;o<a;o++)if(i[o].name===t){i.splice(o,1);break}return n&&delete e.attrsMap[t],r}function Rr(e,t){for(var n=e.attrsList,r=0,i=n.length;r<i;r++){var o=n[r];if(t.test(o.name))return n.splice(r,1),o}}function Hr(e,t){return t&&(null!=t.start&&(e.start=t.start),null!=t.end&&(e.end=t.end)),e}function Br(e,t,n){var r=n||{},i=r.number,o="$$v";r.trim&&(o="(typeof $$v === 'string'? $$v.trim(): $$v)"),i&&(o="_n("+o+")");var a=Ur(t,o);e.model={value:"("+t+")",expression:JSON.stringify(t),callback:"function ($$v) {"+a+"}"}}function Ur(e,t){var n=function(e){if(e=e.trim(),_r=e.length,e.indexOf("[")<0||e.lastIndexOf("]")<_r-1)return(wr=e.lastIndexOf("."))>-1?{exp:e.slice(0,wr),key:'"'+e.slice(wr+1)+'"'}:{exp:e,key:null};br=e,wr=Cr=xr=0;for(;!zr();)Kr($r=Vr())?qr($r):91===$r&&Jr($r);return{exp:e.slice(0,Cr),key:e.slice(Cr+1,xr)}}(e);return null===n.key?e+"="+t:"$set("+n.exp+", "+n.key+", "+t+")"}function Vr(){return br.charCodeAt(++wr)}function zr(){return wr>=_r}function Kr(e){return 34===e||39===e}function Jr(e){var t=1;for(Cr=wr;!zr();)if(Kr(e=Vr()))qr(e);else if(91===e&&t++,93===e&&t--,0===t){xr=wr;break}}function qr(e){for(var t=e;!zr()&&(e=Vr())!==t;);}var Wr,Zr="__r",Gr="__c";function Xr(e,t,n){var r=Wr;return function i(){null!==t.apply(null,arguments)&&ei(e,i,n,r)}}var Yr=Ke&&!(X&&Number(X[1])<=53);function Qr(e,t,n,r){if(Yr){var i=sn,o=t;t=o._wrapper=function(e){if(e.target===e.currentTarget||e.timeStamp>=i||e.timeStamp<=0||e.target.ownerDocument!==document)return o.apply(this,arguments)}}Wr.addEventListener(e,t,Q?{capture:n,passive:r}:n)}function ei(e,t,n,r){(r||Wr).removeEventListener(e,t._wrapper||t,n)}function ti(e,r){if(!t(e.data.on)||!t(r.data.on)){var i=r.data.on||{},o=e.data.on||{};Wr=r.elm,function(e){if(n(e[Zr])){var t=q?"change":"input";e[t]=[].concat(e[Zr],e[t]||[]),delete e[Zr]}n(e[Gr])&&(e.change=[].concat(e[Gr],e.change||[]),delete e[Gr])}(i),it(i,o,Qr,ei,Xr,r.context),Wr=void 0}}var ni,ri={create:ti,update:ti};function ii(e,r){if(!t(e.data.domProps)||!t(r.data.domProps)){var i,o,a=r.elm,s=e.data.domProps||{},c=r.data.domProps||{};for(i in n(c.__ob__)&&(c=r.data.domProps=A({},c)),s)i in c||(a[i]="");for(i in c){if(o=c[i],"textContent"===i||"innerHTML"===i){if(r.children&&(r.children.length=0),o===s[i])continue;1===a.childNodes.length&&a.removeChild(a.childNodes[0])}if("value"===i&&"PROGRESS"!==a.tagName){a._value=o;var u=t(o)?"":String(o);oi(a,u)&&(a.value=u)}else if("innerHTML"===i&&Wn(a.tagName)&&t(a.innerHTML)){(ni=ni||document.createElement("div")).innerHTML="<svg>"+o+"</svg>";for(var l=ni.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;l.firstChild;)a.appendChild(l.firstChild)}else if(o!==s[i])try{a[i]=o}catch(e){}}}}function oi(e,t){return!e.composing&&("OPTION"===e.tagName||function(e,t){var n=!0;try{n=document.activeElement!==e}catch(e){}return n&&e.value!==t}(e,t)||function(e,t){var r=e.value,i=e._vModifiers;if(n(i)){if(i.number)return f(r)!==f(t);if(i.trim)return r.trim()!==t.trim()}return r!==t}(e,t))}var ai={create:ii,update:ii},si=g(function(e){var t={},n=/:(.+)/;return e.split(/;(?![^(]*\))/g).forEach(function(e){if(e){var r=e.split(n);r.length>1&&(t[r[0].trim()]=r[1].trim())}}),t});function ci(e){var t=ui(e.style);return e.staticStyle?A(e.staticStyle,t):t}function ui(e){return Array.isArray(e)?O(e):"string"==typeof e?si(e):e}var li,fi=/^--/,pi=/\s*!important$/,di=function(e,t,n){if(fi.test(t))e.style.setProperty(t,n);else if(pi.test(n))e.style.setProperty(C(t),n.replace(pi,""),"important");else{var r=hi(t);if(Array.isArray(n))for(var i=0,o=n.length;i<o;i++)e.style[r]=n[i];else e.style[r]=n}},vi=["Webkit","Moz","ms"],hi=g(function(e){if(li=li||document.createElement("div").style,"filter"!==(e=b(e))&&e in li)return e;for(var t=e.charAt(0).toUpperCase()+e.slice(1),n=0;n<vi.length;n++){var r=vi[n]+t;if(r in li)return r}});function mi(e,r){var i=r.data,o=e.data;if(!(t(i.staticStyle)&&t(i.style)&&t(o.staticStyle)&&t(o.style))){var a,s,c=r.elm,u=o.staticStyle,l=o.normalizedStyle||o.style||{},f=u||l,p=ui(r.data.style)||{};r.data.normalizedStyle=n(p.__ob__)?A({},p):p;var d=function(e,t){var n,r={};if(t)for(var i=e;i.componentInstance;)(i=i.componentInstance._vnode)&&i.data&&(n=ci(i.data))&&A(r,n);(n=ci(e.data))&&A(r,n);for(var o=e;o=o.parent;)o.data&&(n=ci(o.data))&&A(r,n);return r}(r,!0);for(s in f)t(d[s])&&di(c,s,"");for(s in d)(a=d[s])!==f[s]&&di(c,s,null==a?"":a)}}var yi={create:mi,update:mi},gi=/\s+/;function _i(e,t){if(t&&(t=t.trim()))if(e.classList)t.indexOf(" ")>-1?t.split(gi).forEach(function(t){return e.classList.add(t)}):e.classList.add(t);else{var n=" "+(e.getAttribute("class")||"")+" ";n.indexOf(" "+t+" ")<0&&e.setAttribute("class",(n+t).trim())}}function bi(e,t){if(t&&(t=t.trim()))if(e.classList)t.indexOf(" ")>-1?t.split(gi).forEach(function(t){return e.classList.remove(t)}):e.classList.remove(t),e.classList.length||e.removeAttribute("class");else{for(var n=" "+(e.getAttribute("class")||"")+" ",r=" "+t+" ";n.indexOf(r)>=0;)n=n.replace(r," ");(n=n.trim())?e.setAttribute("class",n):e.removeAttribute("class")}}function $i(e){if(e){if("object"==typeof e){var t={};return!1!==e.css&&A(t,wi(e.name||"v")),A(t,e),t}return"string"==typeof e?wi(e):void 0}}var wi=g(function(e){return{enterClass:e+"-enter",enterToClass:e+"-enter-to",enterActiveClass:e+"-enter-active",leaveClass:e+"-leave",leaveToClass:e+"-leave-to",leaveActiveClass:e+"-leave-active"}}),Ci=V&&!W,xi="transition",ki="animation",Ai="transition",Oi="transitionend",Si="animation",Ti="animationend";Ci&&(void 0===window.ontransitionend&&void 0!==window.onwebkittransitionend&&(Ai="WebkitTransition",Oi="webkitTransitionEnd"),void 0===window.onanimationend&&void 0!==window.onwebkitanimationend&&(Si="WebkitAnimation",Ti="webkitAnimationEnd"));var Ni=V?window.requestAnimationFrame?window.requestAnimationFrame.bind(window):setTimeout:function(e){return e()};function Ei(e){Ni(function(){Ni(e)})}function ji(e,t){var n=e._transitionClasses||(e._transitionClasses=[]);n.indexOf(t)<0&&(n.push(t),_i(e,t))}function Di(e,t){e._transitionClasses&&h(e._transitionClasses,t),bi(e,t)}function Li(e,t,n){var r=Mi(e,t),i=r.type,o=r.timeout,a=r.propCount;if(!i)return n();var s=i===xi?Oi:Ti,c=0,u=function(){e.removeEventListener(s,l),n()},l=function(t){t.target===e&&++c>=a&&u()};setTimeout(function(){c<a&&u()},o+1),e.addEventListener(s,l)}var Ii=/\b(transform|all)(,|$)/;function Mi(e,t){var n,r=window.getComputedStyle(e),i=(r[Ai+"Delay"]||"").split(", "),o=(r[Ai+"Duration"]||"").split(", "),a=Fi(i,o),s=(r[Si+"Delay"]||"").split(", "),c=(r[Si+"Duration"]||"").split(", "),u=Fi(s,c),l=0,f=0;return t===xi?a>0&&(n=xi,l=a,f=o.length):t===ki?u>0&&(n=ki,l=u,f=c.length):f=(n=(l=Math.max(a,u))>0?a>u?xi:ki:null)?n===xi?o.length:c.length:0,{type:n,timeout:l,propCount:f,hasTransform:n===xi&&Ii.test(r[Ai+"Property"])}}function Fi(e,t){for(;e.length<t.length;)e=e.concat(e);return Math.max.apply(null,t.map(function(t,n){return Pi(t)+Pi(e[n])}))}function Pi(e){return 1e3*Number(e.slice(0,-1).replace(",","."))}function Ri(e,r){var i=e.elm;n(i._leaveCb)&&(i._leaveCb.cancelled=!0,i._leaveCb());var a=$i(e.data.transition);if(!t(a)&&!n(i._enterCb)&&1===i.nodeType){for(var s=a.css,c=a.type,u=a.enterClass,l=a.enterToClass,p=a.enterActiveClass,d=a.appearClass,v=a.appearToClass,h=a.appearActiveClass,m=a.beforeEnter,y=a.enter,g=a.afterEnter,_=a.enterCancelled,b=a.beforeAppear,$=a.appear,w=a.afterAppear,C=a.appearCancelled,x=a.duration,k=Zt,A=Zt.$vnode;A&&A.parent;)k=A.context,A=A.parent;var O=!k._isMounted||!e.isRootInsert;if(!O||$||""===$){var S=O&&d?d:u,T=O&&h?h:p,N=O&&v?v:l,E=O&&b||m,j=O&&"function"==typeof $?$:y,L=O&&w||g,I=O&&C||_,M=f(o(x)?x.enter:x),F=!1!==s&&!W,P=Ui(j),R=i._enterCb=D(function(){F&&(Di(i,N),Di(i,T)),R.cancelled?(F&&Di(i,S),I&&I(i)):L&&L(i),i._enterCb=null});e.data.show||ot(e,"insert",function(){var t=i.parentNode,n=t&&t._pending&&t._pending[e.key];n&&n.tag===e.tag&&n.elm._leaveCb&&n.elm._leaveCb(),j&&j(i,R)}),E&&E(i),F&&(ji(i,S),ji(i,T),Ei(function(){Di(i,S),R.cancelled||(ji(i,N),P||(Bi(M)?setTimeout(R,M):Li(i,c,R)))})),e.data.show&&(r&&r(),j&&j(i,R)),F||P||R()}}}function Hi(e,r){var i=e.elm;n(i._enterCb)&&(i._enterCb.cancelled=!0,i._enterCb());var a=$i(e.data.transition);if(t(a)||1!==i.nodeType)return r();if(!n(i._leaveCb)){var s=a.css,c=a.type,u=a.leaveClass,l=a.leaveToClass,p=a.leaveActiveClass,d=a.beforeLeave,v=a.leave,h=a.afterLeave,m=a.leaveCancelled,y=a.delayLeave,g=a.duration,_=!1!==s&&!W,b=Ui(v),$=f(o(g)?g.leave:g),w=i._leaveCb=D(function(){i.parentNode&&i.parentNode._pending&&(i.parentNode._pending[e.key]=null),_&&(Di(i,l),Di(i,p)),w.cancelled?(_&&Di(i,u),m&&m(i)):(r(),h&&h(i)),i._leaveCb=null});y?y(C):C()}function C(){w.cancelled||(!e.data.show&&i.parentNode&&((i.parentNode._pending||(i.parentNode._pending={}))[e.key]=e),d&&d(i),_&&(ji(i,u),ji(i,p),Ei(function(){Di(i,u),w.cancelled||(ji(i,l),b||(Bi($)?setTimeout(w,$):Li(i,c,w)))})),v&&v(i,w),_||b||w())}}function Bi(e){return"number"==typeof e&&!isNaN(e)}function Ui(e){if(t(e))return!1;var r=e.fns;return n(r)?Ui(Array.isArray(r)?r[0]:r):(e._length||e.length)>1}function Vi(e,t){!0!==t.data.show&&Ri(t)}var zi=function(e){var o,a,s={},c=e.modules,u=e.nodeOps;for(o=0;o<ir.length;++o)for(s[ir[o]]=[],a=0;a<c.length;++a)n(c[a][ir[o]])&&s[ir[o]].push(c[a][ir[o]]);function l(e){var t=u.parentNode(e);n(t)&&u.removeChild(t,e)}function f(e,t,i,o,a,c,l){if(n(e.elm)&&n(c)&&(e=c[l]=me(e)),e.isRootInsert=!a,!function(e,t,i,o){var a=e.data;if(n(a)){var c=n(e.componentInstance)&&a.keepAlive;if(n(a=a.hook)&&n(a=a.init)&&a(e,!1),n(e.componentInstance))return d(e,t),v(i,e.elm,o),r(c)&&function(e,t,r,i){for(var o,a=e;a.componentInstance;)if(a=a.componentInstance._vnode,n(o=a.data)&&n(o=o.transition)){for(o=0;o<s.activate.length;++o)s.activate[o](rr,a);t.push(a);break}v(r,e.elm,i)}(e,t,i,o),!0}}(e,t,i,o)){var f=e.data,p=e.children,m=e.tag;n(m)?(e.elm=e.ns?u.createElementNS(e.ns,m):u.createElement(m,e),g(e),h(e,p,t),n(f)&&y(e,t),v(i,e.elm,o)):r(e.isComment)?(e.elm=u.createComment(e.text),v(i,e.elm,o)):(e.elm=u.createTextNode(e.text),v(i,e.elm,o))}}function d(e,t){n(e.data.pendingInsert)&&(t.push.apply(t,e.data.pendingInsert),e.data.pendingInsert=null),e.elm=e.componentInstance.$el,m(e)?(y(e,t),g(e)):(nr(e),t.push(e))}function v(e,t,r){n(e)&&(n(r)?u.parentNode(r)===e&&u.insertBefore(e,t,r):u.appendChild(e,t))}function h(e,t,n){if(Array.isArray(t))for(var r=0;r<t.length;++r)f(t[r],n,e.elm,null,!0,t,r);else i(e.text)&&u.appendChild(e.elm,u.createTextNode(String(e.text)))}function m(e){for(;e.componentInstance;)e=e.componentInstance._vnode;return n(e.tag)}function y(e,t){for(var r=0;r<s.create.length;++r)s.create[r](rr,e);n(o=e.data.hook)&&(n(o.create)&&o.create(rr,e),n(o.insert)&&t.push(e))}function g(e){var t;if(n(t=e.fnScopeId))u.setStyleScope(e.elm,t);else for(var r=e;r;)n(t=r.context)&&n(t=t.$options._scopeId)&&u.setStyleScope(e.elm,t),r=r.parent;n(t=Zt)&&t!==e.context&&t!==e.fnContext&&n(t=t.$options._scopeId)&&u.setStyleScope(e.elm,t)}function _(e,t,n,r,i,o){for(;r<=i;++r)f(n[r],o,e,t,!1,n,r)}function b(e){var t,r,i=e.data;if(n(i))for(n(t=i.hook)&&n(t=t.destroy)&&t(e),t=0;t<s.destroy.length;++t)s.destroy[t](e);if(n(t=e.children))for(r=0;r<e.children.length;++r)b(e.children[r])}function $(e,t,r){for(;t<=r;++t){var i=e[t];n(i)&&(n(i.tag)?(w(i),b(i)):l(i.elm))}}function w(e,t){if(n(t)||n(e.data)){var r,i=s.remove.length+1;for(n(t)?t.listeners+=i:t=function(e,t){function n(){0==--n.listeners&&l(e)}return n.listeners=t,n}(e.elm,i),n(r=e.componentInstance)&&n(r=r._vnode)&&n(r.data)&&w(r,t),r=0;r<s.remove.length;++r)s.remove[r](e,t);n(r=e.data.hook)&&n(r=r.remove)?r(e,t):t()}else l(e.elm)}function C(e,t,r,i){for(var o=r;o<i;o++){var a=t[o];if(n(a)&&or(e,a))return o}}function x(e,i,o,a,c,l){if(e!==i){n(i.elm)&&n(a)&&(i=a[c]=me(i));var p=i.elm=e.elm;if(r(e.isAsyncPlaceholder))n(i.asyncFactory.resolved)?O(e.elm,i,o):i.isAsyncPlaceholder=!0;else if(r(i.isStatic)&&r(e.isStatic)&&i.key===e.key&&(r(i.isCloned)||r(i.isOnce)))i.componentInstance=e.componentInstance;else{var d,v=i.data;n(v)&&n(d=v.hook)&&n(d=d.prepatch)&&d(e,i);var h=e.children,y=i.children;if(n(v)&&m(i)){for(d=0;d<s.update.length;++d)s.update[d](e,i);n(d=v.hook)&&n(d=d.update)&&d(e,i)}t(i.text)?n(h)&&n(y)?h!==y&&function(e,r,i,o,a){for(var s,c,l,p=0,d=0,v=r.length-1,h=r[0],m=r[v],y=i.length-1,g=i[0],b=i[y],w=!a;p<=v&&d<=y;)t(h)?h=r[++p]:t(m)?m=r[--v]:or(h,g)?(x(h,g,o,i,d),h=r[++p],g=i[++d]):or(m,b)?(x(m,b,o,i,y),m=r[--v],b=i[--y]):or(h,b)?(x(h,b,o,i,y),w&&u.insertBefore(e,h.elm,u.nextSibling(m.elm)),h=r[++p],b=i[--y]):or(m,g)?(x(m,g,o,i,d),w&&u.insertBefore(e,m.elm,h.elm),m=r[--v],g=i[++d]):(t(s)&&(s=ar(r,p,v)),t(c=n(g.key)?s[g.key]:C(g,r,p,v))?f(g,o,e,h.elm,!1,i,d):or(l=r[c],g)?(x(l,g,o,i,d),r[c]=void 0,w&&u.insertBefore(e,l.elm,h.elm)):f(g,o,e,h.elm,!1,i,d),g=i[++d]);p>v?_(e,t(i[y+1])?null:i[y+1].elm,i,d,y,o):d>y&&$(r,p,v)}(p,h,y,o,l):n(y)?(n(e.text)&&u.setTextContent(p,""),_(p,null,y,0,y.length-1,o)):n(h)?$(h,0,h.length-1):n(e.text)&&u.setTextContent(p,""):e.text!==i.text&&u.setTextContent(p,i.text),n(v)&&n(d=v.hook)&&n(d=d.postpatch)&&d(e,i)}}}function k(e,t,i){if(r(i)&&n(e.parent))e.parent.data.pendingInsert=t;else for(var o=0;o<t.length;++o)t[o].data.hook.insert(t[o])}var A=p("attrs,class,staticClass,staticStyle,key");function O(e,t,i,o){var a,s=t.tag,c=t.data,u=t.children;if(o=o||c&&c.pre,t.elm=e,r(t.isComment)&&n(t.asyncFactory))return t.isAsyncPlaceholder=!0,!0;if(n(c)&&(n(a=c.hook)&&n(a=a.init)&&a(t,!0),n(a=t.componentInstance)))return d(t,i),!0;if(n(s)){if(n(u))if(e.hasChildNodes())if(n(a=c)&&n(a=a.domProps)&&n(a=a.innerHTML)){if(a!==e.innerHTML)return!1}else{for(var l=!0,f=e.firstChild,p=0;p<u.length;p++){if(!f||!O(f,u[p],i,o)){l=!1;break}f=f.nextSibling}if(!l||f)return!1}else h(t,u,i);if(n(c)){var v=!1;for(var m in c)if(!A(m)){v=!0,y(t,i);break}!v&&c.class&&tt(c.class)}}else e.data!==t.text&&(e.data=t.text);return!0}return function(e,i,o,a){if(!t(i)){var c,l=!1,p=[];if(t(e))l=!0,f(i,p);else{var d=n(e.nodeType);if(!d&&or(e,i))x(e,i,p,null,null,a);else{if(d){if(1===e.nodeType&&e.hasAttribute(L)&&(e.removeAttribute(L),o=!0),r(o)&&O(e,i,p))return k(i,p,!0),e;c=e,e=new pe(u.tagName(c).toLowerCase(),{},[],void 0,c)}var v=e.elm,h=u.parentNode(v);if(f(i,p,v._leaveCb?null:h,u.nextSibling(v)),n(i.parent))for(var y=i.parent,g=m(i);y;){for(var _=0;_<s.destroy.length;++_)s.destroy[_](y);if(y.elm=i.elm,g){for(var w=0;w<s.create.length;++w)s.create[w](rr,y);var C=y.data.hook.insert;if(C.merged)for(var A=1;A<C.fns.length;A++)C.fns[A]()}else nr(y);y=y.parent}n(h)?$([e],0,0):n(e.tag)&&b(e)}}return k(i,p,l),i.elm}n(e)&&b(e)}}({nodeOps:er,modules:[yr,kr,ri,ai,yi,V?{create:Vi,activate:Vi,remove:function(e,t){!0!==e.data.show?Hi(e,t):t()}}:{}].concat(dr)});W&&document.addEventListener("selectionchange",function(){var e=document.activeElement;e&&e.vmodel&&Yi(e,"input")});var Ki={inserted:function(e,t,n,r){"select"===n.tag?(r.elm&&!r.elm._vOptions?ot(n,"postpatch",function(){Ki.componentUpdated(e,t,n)}):Ji(e,t,n.context),e._vOptions=[].map.call(e.options,Zi)):("textarea"===n.tag||Yn(e.type))&&(e._vModifiers=t.modifiers,t.modifiers.lazy||(e.addEventListener("compositionstart",Gi),e.addEventListener("compositionend",Xi),e.addEventListener("change",Xi),W&&(e.vmodel=!0)))},componentUpdated:function(e,t,n){if("select"===n.tag){Ji(e,t,n.context);var r=e._vOptions,i=e._vOptions=[].map.call(e.options,Zi);if(i.some(function(e,t){return!E(e,r[t])}))(e.multiple?t.value.some(function(e){return Wi(e,i)}):t.value!==t.oldValue&&Wi(t.value,i))&&Yi(e,"change")}}};function Ji(e,t,n){qi(e,t,n),(q||Z)&&setTimeout(function(){qi(e,t,n)},0)}function qi(e,t,n){var r=t.value,i=e.multiple;if(!i||Array.isArray(r)){for(var o,a,s=0,c=e.options.length;s<c;s++)if(a=e.options[s],i)o=j(r,Zi(a))>-1,a.selected!==o&&(a.selected=o);else if(E(Zi(a),r))return void(e.selectedIndex!==s&&(e.selectedIndex=s));i||(e.selectedIndex=-1)}}function Wi(e,t){return t.every(function(t){return!E(t,e)})}function Zi(e){return"_value"in e?e._value:e.value}function Gi(e){e.target.composing=!0}function Xi(e){e.target.composing&&(e.target.composing=!1,Yi(e.target,"input"))}function Yi(e,t){var n=document.createEvent("HTMLEvents");n.initEvent(t,!0,!0),e.dispatchEvent(n)}function Qi(e){return!e.componentInstance||e.data&&e.data.transition?e:Qi(e.componentInstance._vnode)}var eo={model:Ki,show:{bind:function(e,t,n){var r=t.value,i=(n=Qi(n)).data&&n.data.transition,o=e.__vOriginalDisplay="none"===e.style.display?"":e.style.display;r&&i?(n.data.show=!0,Ri(n,function(){e.style.display=o})):e.style.display=r?o:"none"},update:function(e,t,n){var r=t.value;!r!=!t.oldValue&&((n=Qi(n)).data&&n.data.transition?(n.data.show=!0,r?Ri(n,function(){e.style.display=e.__vOriginalDisplay}):Hi(n,function(){e.style.display="none"})):e.style.display=r?e.__vOriginalDisplay:"none")},unbind:function(e,t,n,r,i){i||(e.style.display=e.__vOriginalDisplay)}}},to={name:String,appear:Boolean,css:Boolean,mode:String,type:String,enterClass:String,leaveClass:String,enterToClass:String,leaveToClass:String,enterActiveClass:String,leaveActiveClass:String,appearClass:String,appearActiveClass:String,appearToClass:String,duration:[Number,String,Object]};function no(e){var t=e&&e.componentOptions;return t&&t.Ctor.options.abstract?no(zt(t.children)):e}function ro(e){var t={},n=e.$options;for(var r in n.propsData)t[r]=e[r];var i=n._parentListeners;for(var o in i)t[b(o)]=i[o];return t}function io(e,t){if(/\d-keep-alive$/.test(t.tag))return e("keep-alive",{props:t.componentOptions.propsData})}var oo=function(e){return e.tag||pt(e)},ao=function(e){return"show"===e.name},so={name:"transition",props:to,abstract:!0,render:function(e){var t=this,n=this.$slots.default;if(n&&(n=n.filter(oo)).length){var r=this.mode,o=n[0];if(function(e){for(;e=e.parent;)if(e.data.transition)return!0}(this.$vnode))return o;var a=no(o);if(!a)return o;if(this._leaving)return io(e,o);var s="__transition-"+this._uid+"-";a.key=null==a.key?a.isComment?s+"comment":s+a.tag:i(a.key)?0===String(a.key).indexOf(s)?a.key:s+a.key:a.key;var c=(a.data||(a.data={})).transition=ro(this),u=this._vnode,l=no(u);if(a.data.directives&&a.data.directives.some(ao)&&(a.data.show=!0),l&&l.data&&!function(e,t){return t.key===e.key&&t.tag===e.tag}(a,l)&&!pt(l)&&(!l.componentInstance||!l.componentInstance._vnode.isComment)){var f=l.data.transition=A({},c);if("out-in"===r)return this._leaving=!0,ot(f,"afterLeave",function(){t._leaving=!1,t.$forceUpdate()}),io(e,o);if("in-out"===r){if(pt(a))return u;var p,d=function(){p()};ot(c,"afterEnter",d),ot(c,"enterCancelled",d),ot(f,"delayLeave",function(e){p=e})}}return o}}},co=A({tag:String,moveClass:String},to);function uo(e){e.elm._moveCb&&e.elm._moveCb(),e.elm._enterCb&&e.elm._enterCb()}function lo(e){e.data.newPos=e.elm.getBoundingClientRect()}function fo(e){var t=e.data.pos,n=e.data.newPos,r=t.left-n.left,i=t.top-n.top;if(r||i){e.data.moved=!0;var o=e.elm.style;o.transform=o.WebkitTransform="translate("+r+"px,"+i+"px)",o.transitionDuration="0s"}}delete co.mode;var po={Transition:so,TransitionGroup:{props:co,beforeMount:function(){var e=this,t=this._update;this._update=function(n,r){var i=Gt(e);e.__patch__(e._vnode,e.kept,!1,!0),e._vnode=e.kept,i(),t.call(e,n,r)}},render:function(e){for(var t=this.tag||this.$vnode.data.tag||"span",n=Object.create(null),r=this.prevChildren=this.children,i=this.$slots.default||[],o=this.children=[],a=ro(this),s=0;s<i.length;s++){var c=i[s];c.tag&&null!=c.key&&0!==String(c.key).indexOf("__vlist")&&(o.push(c),n[c.key]=c,(c.data||(c.data={})).transition=a)}if(r){for(var u=[],l=[],f=0;f<r.length;f++){var p=r[f];p.data.transition=a,p.data.pos=p.elm.getBoundingClientRect(),n[p.key]?u.push(p):l.push(p)}this.kept=e(t,null,u),this.removed=l}return e(t,null,o)},updated:function(){var e=this.prevChildren,t=this.moveClass||(this.name||"v")+"-move";e.length&&this.hasMove(e[0].elm,t)&&(e.forEach(uo),e.forEach(lo),e.forEach(fo),this._reflow=document.body.offsetHeight,e.forEach(function(e){if(e.data.moved){var n=e.elm,r=n.style;ji(n,t),r.transform=r.WebkitTransform=r.transitionDuration="",n.addEventListener(Oi,n._moveCb=function e(r){r&&r.target!==n||r&&!/transform$/.test(r.propertyName)||(n.removeEventListener(Oi,e),n._moveCb=null,Di(n,t))})}}))},methods:{hasMove:function(e,t){if(!Ci)return!1;if(this._hasMove)return this._hasMove;var n=e.cloneNode();e._transitionClasses&&e._transitionClasses.forEach(function(e){bi(n,e)}),_i(n,t),n.style.display="none",this.$el.appendChild(n);var r=Mi(n);return this.$el.removeChild(n),this._hasMove=r.hasTransform}}}};Cn.config.mustUseProp=Dn,Cn.config.isReservedTag=Zn,Cn.config.isReservedAttr=En,Cn.config.getTagNamespace=Gn,Cn.config.isUnknownElement=function(e){if(!V)return!0;if(Zn(e))return!1;if(e=e.toLowerCase(),null!=Xn[e])return Xn[e];var t=document.createElement(e);return e.indexOf("-")>-1?Xn[e]=t.constructor===window.HTMLUnknownElement||t.constructor===window.HTMLElement:Xn[e]=/HTMLUnknownElement/.test(t.toString())},A(Cn.options.directives,eo),A(Cn.options.components,po),Cn.prototype.__patch__=V?zi:S,Cn.prototype.$mount=function(e,t){return function(e,t,n){var r;return e.$el=t,e.$options.render||(e.$options.render=ve),Qt(e,"beforeMount"),r=function(){e._update(e._render(),n)},new pn(e,r,S,{before:function(){e._isMounted&&!e._isDestroyed&&Qt(e,"beforeUpdate")}},!0),n=!1,null==e.$vnode&&(e._isMounted=!0,Qt(e,"mounted")),e}(this,e=e&&V?Qn(e):void 0,t)},V&&setTimeout(function(){F.devtools&&ne&&ne.emit("init",Cn)},0);var vo=/\{\{((?:.|\r?\n)+?)\}\}/g,ho=/[-.*+?^${}()|[\]\/\\]/g,mo=g(function(e){var t=e[0].replace(ho,"\\$&"),n=e[1].replace(ho,"\\$&");return new RegExp(t+"((?:.|\\n)+?)"+n,"g")});var yo={staticKeys:["staticClass"],transformNode:function(e,t){t.warn;var n=Pr(e,"class");n&&(e.staticClass=JSON.stringify(n));var r=Fr(e,"class",!1);r&&(e.classBinding=r)},genData:function(e){var t="";return e.staticClass&&(t+="staticClass:"+e.staticClass+","),e.classBinding&&(t+="class:"+e.classBinding+","),t}};var go,_o={staticKeys:["staticStyle"],transformNode:function(e,t){t.warn;var n=Pr(e,"style");n&&(e.staticStyle=JSON.stringify(si(n)));var r=Fr(e,"style",!1);r&&(e.styleBinding=r)},genData:function(e){var t="";return e.staticStyle&&(t+="staticStyle:"+e.staticStyle+","),e.styleBinding&&(t+="style:("+e.styleBinding+"),"),t}},bo=function(e){return(go=go||document.createElement("div")).innerHTML=e,go.textContent},$o=p("area,base,br,col,embed,frame,hr,img,input,isindex,keygen,link,meta,param,source,track,wbr"),wo=p("colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source"),Co=p("address,article,aside,base,blockquote,body,caption,col,colgroup,dd,details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,title,tr,track"),xo=/^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,ko=/^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,Ao="[a-zA-Z_][\\-\\.0-9_a-zA-Z"+P.source+"]*",Oo="((?:"+Ao+"\\:)?"+Ao+")",So=new RegExp("^<"+Oo),To=/^\s*(\/?)>/,No=new RegExp("^<\\/"+Oo+"[^>]*>"),Eo=/^<!DOCTYPE [^>]+>/i,jo=/^<!\--/,Do=/^<!\[/,Lo=p("script,style,textarea",!0),Io={},Mo={"&lt;":"<","&gt;":">","&quot;":'"',"&amp;":"&","&#10;":"\n","&#9;":"\t","&#39;":"'"},Fo=/&(?:lt|gt|quot|amp|#39);/g,Po=/&(?:lt|gt|quot|amp|#39|#10|#9);/g,Ro=p("pre,textarea",!0),Ho=function(e,t){return e&&Ro(e)&&"\n"===t[0]};function Bo(e,t){var n=t?Po:Fo;return e.replace(n,function(e){return Mo[e]})}var Uo,Vo,zo,Ko,Jo,qo,Wo,Zo,Go=/^@|^v-on:/,Xo=/^v-|^@|^:|^#/,Yo=/([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/,Qo=/,([^,\}\]]*)(?:,([^,\}\]]*))?$/,ea=/^\(|\)$/g,ta=/^\[.*\]$/,na=/:(.*)$/,ra=/^:|^\.|^v-bind:/,ia=/\.[^.\]]+(?=[^\]]*$)/g,oa=/^v-slot(:|$)|^#/,aa=/[\r\n]/,sa=/[ \f\t\r\n]+/g,ca=g(bo),ua="_empty_";function la(e,t,n){return{type:1,tag:e,attrsList:t,attrsMap:ya(t),rawAttrsMap:{},parent:n,children:[]}}function fa(e,t){Uo=t.warn||Tr,qo=t.isPreTag||T,Wo=t.mustUseProp||T,Zo=t.getTagNamespace||T;t.isReservedTag;zo=Nr(t.modules,"transformNode"),Ko=Nr(t.modules,"preTransformNode"),Jo=Nr(t.modules,"postTransformNode"),Vo=t.delimiters;var n,r,i=[],o=!1!==t.preserveWhitespace,a=t.whitespace,s=!1,c=!1;function u(e){if(l(e),s||e.processed||(e=pa(e,t)),i.length||e===n||n.if&&(e.elseif||e.else)&&va(n,{exp:e.elseif,block:e}),r&&!e.forbidden)if(e.elseif||e.else)a=e,(u=function(e){var t=e.length;for(;t--;){if(1===e[t].type)return e[t];e.pop()}}(r.children))&&u.if&&va(u,{exp:a.elseif,block:a});else{if(e.slotScope){var o=e.slotTarget||'"default"';(r.scopedSlots||(r.scopedSlots={}))[o]=e}r.children.push(e),e.parent=r}var a,u;e.children=e.children.filter(function(e){return!e.slotScope}),l(e),e.pre&&(s=!1),qo(e.tag)&&(c=!1);for(var f=0;f<Jo.length;f++)Jo[f](e,t)}function l(e){if(!c)for(var t;(t=e.children[e.children.length-1])&&3===t.type&&" "===t.text;)e.children.pop()}return function(e,t){for(var n,r,i=[],o=t.expectHTML,a=t.isUnaryTag||T,s=t.canBeLeftOpenTag||T,c=0;e;){if(n=e,r&&Lo(r)){var u=0,l=r.toLowerCase(),f=Io[l]||(Io[l]=new RegExp("([\\s\\S]*?)(</"+l+"[^>]*>)","i")),p=e.replace(f,function(e,n,r){return u=r.length,Lo(l)||"noscript"===l||(n=n.replace(/<!\--([\s\S]*?)-->/g,"$1").replace(/<!\[CDATA\[([\s\S]*?)]]>/g,"$1")),Ho(l,n)&&(n=n.slice(1)),t.chars&&t.chars(n),""});c+=e.length-p.length,e=p,A(l,c-u,c)}else{var d=e.indexOf("<");if(0===d){if(jo.test(e)){var v=e.indexOf("--\x3e");if(v>=0){t.shouldKeepComment&&t.comment(e.substring(4,v),c,c+v+3),C(v+3);continue}}if(Do.test(e)){var h=e.indexOf("]>");if(h>=0){C(h+2);continue}}var m=e.match(Eo);if(m){C(m[0].length);continue}var y=e.match(No);if(y){var g=c;C(y[0].length),A(y[1],g,c);continue}var _=x();if(_){k(_),Ho(_.tagName,e)&&C(1);continue}}var b=void 0,$=void 0,w=void 0;if(d>=0){for($=e.slice(d);!(No.test($)||So.test($)||jo.test($)||Do.test($)||(w=$.indexOf("<",1))<0);)d+=w,$=e.slice(d);b=e.substring(0,d)}d<0&&(b=e),b&&C(b.length),t.chars&&b&&t.chars(b,c-b.length,c)}if(e===n){t.chars&&t.chars(e);break}}function C(t){c+=t,e=e.substring(t)}function x(){var t=e.match(So);if(t){var n,r,i={tagName:t[1],attrs:[],start:c};for(C(t[0].length);!(n=e.match(To))&&(r=e.match(ko)||e.match(xo));)r.start=c,C(r[0].length),r.end=c,i.attrs.push(r);if(n)return i.unarySlash=n[1],C(n[0].length),i.end=c,i}}function k(e){var n=e.tagName,c=e.unarySlash;o&&("p"===r&&Co(n)&&A(r),s(n)&&r===n&&A(n));for(var u=a(n)||!!c,l=e.attrs.length,f=new Array(l),p=0;p<l;p++){var d=e.attrs[p],v=d[3]||d[4]||d[5]||"",h="a"===n&&"href"===d[1]?t.shouldDecodeNewlinesForHref:t.shouldDecodeNewlines;f[p]={name:d[1],value:Bo(v,h)}}u||(i.push({tag:n,lowerCasedTag:n.toLowerCase(),attrs:f,start:e.start,end:e.end}),r=n),t.start&&t.start(n,f,u,e.start,e.end)}function A(e,n,o){var a,s;if(null==n&&(n=c),null==o&&(o=c),e)for(s=e.toLowerCase(),a=i.length-1;a>=0&&i[a].lowerCasedTag!==s;a--);else a=0;if(a>=0){for(var u=i.length-1;u>=a;u--)t.end&&t.end(i[u].tag,n,o);i.length=a,r=a&&i[a-1].tag}else"br"===s?t.start&&t.start(e,[],!0,n,o):"p"===s&&(t.start&&t.start(e,[],!1,n,o),t.end&&t.end(e,n,o))}A()}(e,{warn:Uo,expectHTML:t.expectHTML,isUnaryTag:t.isUnaryTag,canBeLeftOpenTag:t.canBeLeftOpenTag,shouldDecodeNewlines:t.shouldDecodeNewlines,shouldDecodeNewlinesForHref:t.shouldDecodeNewlinesForHref,shouldKeepComment:t.comments,outputSourceRange:t.outputSourceRange,start:function(e,o,a,l,f){var p=r&&r.ns||Zo(e);q&&"svg"===p&&(o=function(e){for(var t=[],n=0;n<e.length;n++){var r=e[n];ga.test(r.name)||(r.name=r.name.replace(_a,""),t.push(r))}return t}(o));var d,v=la(e,o,r);p&&(v.ns=p),"style"!==(d=v).tag&&("script"!==d.tag||d.attrsMap.type&&"text/javascript"!==d.attrsMap.type)||te()||(v.forbidden=!0);for(var h=0;h<Ko.length;h++)v=Ko[h](v,t)||v;s||(!function(e){null!=Pr(e,"v-pre")&&(e.pre=!0)}(v),v.pre&&(s=!0)),qo(v.tag)&&(c=!0),s?function(e){var t=e.attrsList,n=t.length;if(n)for(var r=e.attrs=new Array(n),i=0;i<n;i++)r[i]={name:t[i].name,value:JSON.stringify(t[i].value)},null!=t[i].start&&(r[i].start=t[i].start,r[i].end=t[i].end);else e.pre||(e.plain=!0)}(v):v.processed||(da(v),function(e){var t=Pr(e,"v-if");if(t)e.if=t,va(e,{exp:t,block:e});else{null!=Pr(e,"v-else")&&(e.else=!0);var n=Pr(e,"v-else-if");n&&(e.elseif=n)}}(v),function(e){null!=Pr(e,"v-once")&&(e.once=!0)}(v)),n||(n=v),a?u(v):(r=v,i.push(v))},end:function(e,t,n){var o=i[i.length-1];i.length-=1,r=i[i.length-1],u(o)},chars:function(e,t,n){if(r&&(!q||"textarea"!==r.tag||r.attrsMap.placeholder!==e)){var i,u,l,f=r.children;if(e=c||e.trim()?"script"===(i=r).tag||"style"===i.tag?e:ca(e):f.length?a?"condense"===a&&aa.test(e)?"":" ":o?" ":"":"")c||"condense"!==a||(e=e.replace(sa," ")),!s&&" "!==e&&(u=function(e,t){var n=t?mo(t):vo;if(n.test(e)){for(var r,i,o,a=[],s=[],c=n.lastIndex=0;r=n.exec(e);){(i=r.index)>c&&(s.push(o=e.slice(c,i)),a.push(JSON.stringify(o)));var u=Or(r[1].trim());a.push("_s("+u+")"),s.push({"@binding":u}),c=i+r[0].length}return c<e.length&&(s.push(o=e.slice(c)),a.push(JSON.stringify(o))),{expression:a.join("+"),tokens:s}}}(e,Vo))?l={type:2,expression:u.expression,tokens:u.tokens,text:e}:" "===e&&f.length&&" "===f[f.length-1].text||(l={type:3,text:e}),l&&f.push(l)}},comment:function(e,t,n){if(r){var i={type:3,text:e,isComment:!0};r.children.push(i)}}}),n}function pa(e,t){var n,r;(r=Fr(n=e,"key"))&&(n.key=r),e.plain=!e.key&&!e.scopedSlots&&!e.attrsList.length,function(e){var t=Fr(e,"ref");t&&(e.ref=t,e.refInFor=function(e){var t=e;for(;t;){if(void 0!==t.for)return!0;t=t.parent}return!1}(e))}(e),function(e){var t;"template"===e.tag?(t=Pr(e,"scope"),e.slotScope=t||Pr(e,"slot-scope")):(t=Pr(e,"slot-scope"))&&(e.slotScope=t);var n=Fr(e,"slot");n&&(e.slotTarget='""'===n?'"default"':n,e.slotTargetDynamic=!(!e.attrsMap[":slot"]&&!e.attrsMap["v-bind:slot"]),"template"===e.tag||e.slotScope||jr(e,"slot",n,function(e,t){return e.rawAttrsMap[":"+t]||e.rawAttrsMap["v-bind:"+t]||e.rawAttrsMap[t]}(e,"slot")));if("template"===e.tag){var r=Rr(e,oa);if(r){var i=ha(r),o=i.name,a=i.dynamic;e.slotTarget=o,e.slotTargetDynamic=a,e.slotScope=r.value||ua}}else{var s=Rr(e,oa);if(s){var c=e.scopedSlots||(e.scopedSlots={}),u=ha(s),l=u.name,f=u.dynamic,p=c[l]=la("template",[],e);p.slotTarget=l,p.slotTargetDynamic=f,p.children=e.children.filter(function(e){if(!e.slotScope)return e.parent=p,!0}),p.slotScope=s.value||ua,e.children=[],e.plain=!1}}}(e),function(e){"slot"===e.tag&&(e.slotName=Fr(e,"name"))}(e),function(e){var t;(t=Fr(e,"is"))&&(e.component=t);null!=Pr(e,"inline-template")&&(e.inlineTemplate=!0)}(e);for(var i=0;i<zo.length;i++)e=zo[i](e,t)||e;return function(e){var t,n,r,i,o,a,s,c,u=e.attrsList;for(t=0,n=u.length;t<n;t++)if(r=i=u[t].name,o=u[t].value,Xo.test(r))if(e.hasBindings=!0,(a=ma(r.replace(Xo,"")))&&(r=r.replace(ia,"")),ra.test(r))r=r.replace(ra,""),o=Or(o),(c=ta.test(r))&&(r=r.slice(1,-1)),a&&(a.prop&&!c&&"innerHtml"===(r=b(r))&&(r="innerHTML"),a.camel&&!c&&(r=b(r)),a.sync&&(s=Ur(o,"$event"),c?Mr(e,'"update:"+('+r+")",s,null,!1,0,u[t],!0):(Mr(e,"update:"+b(r),s,null,!1,0,u[t]),C(r)!==b(r)&&Mr(e,"update:"+C(r),s,null,!1,0,u[t])))),a&&a.prop||!e.component&&Wo(e.tag,e.attrsMap.type,r)?Er(e,r,o,u[t],c):jr(e,r,o,u[t],c);else if(Go.test(r))r=r.replace(Go,""),(c=ta.test(r))&&(r=r.slice(1,-1)),Mr(e,r,o,a,!1,0,u[t],c);else{var l=(r=r.replace(Xo,"")).match(na),f=l&&l[1];c=!1,f&&(r=r.slice(0,-(f.length+1)),ta.test(f)&&(f=f.slice(1,-1),c=!0)),Lr(e,r,i,o,f,c,a,u[t])}else jr(e,r,JSON.stringify(o),u[t]),!e.component&&"muted"===r&&Wo(e.tag,e.attrsMap.type,r)&&Er(e,r,"true",u[t])}(e),e}function da(e){var t;if(t=Pr(e,"v-for")){var n=function(e){var t=e.match(Yo);if(!t)return;var n={};n.for=t[2].trim();var r=t[1].trim().replace(ea,""),i=r.match(Qo);i?(n.alias=r.replace(Qo,"").trim(),n.iterator1=i[1].trim(),i[2]&&(n.iterator2=i[2].trim())):n.alias=r;return n}(t);n&&A(e,n)}}function va(e,t){e.ifConditions||(e.ifConditions=[]),e.ifConditions.push(t)}function ha(e){var t=e.name.replace(oa,"");return t||"#"!==e.name[0]&&(t="default"),ta.test(t)?{name:t.slice(1,-1),dynamic:!0}:{name:'"'+t+'"',dynamic:!1}}function ma(e){var t=e.match(ia);if(t){var n={};return t.forEach(function(e){n[e.slice(1)]=!0}),n}}function ya(e){for(var t={},n=0,r=e.length;n<r;n++)t[e[n].name]=e[n].value;return t}var ga=/^xmlns:NS\d+/,_a=/^NS\d+:/;function ba(e){return la(e.tag,e.attrsList.slice(),e.parent)}var $a=[yo,_o,{preTransformNode:function(e,t){if("input"===e.tag){var n,r=e.attrsMap;if(!r["v-model"])return;if((r[":type"]||r["v-bind:type"])&&(n=Fr(e,"type")),r.type||n||!r["v-bind"]||(n="("+r["v-bind"]+").type"),n){var i=Pr(e,"v-if",!0),o=i?"&&("+i+")":"",a=null!=Pr(e,"v-else",!0),s=Pr(e,"v-else-if",!0),c=ba(e);da(c),Dr(c,"type","checkbox"),pa(c,t),c.processed=!0,c.if="("+n+")==='checkbox'"+o,va(c,{exp:c.if,block:c});var u=ba(e);Pr(u,"v-for",!0),Dr(u,"type","radio"),pa(u,t),va(c,{exp:"("+n+")==='radio'"+o,block:u});var l=ba(e);return Pr(l,"v-for",!0),Dr(l,":type",n),pa(l,t),va(c,{exp:i,block:l}),a?c.else=!0:s&&(c.elseif=s),c}}}}];var wa,Ca,xa={expectHTML:!0,modules:$a,directives:{model:function(e,t,n){var r=t.value,i=t.modifiers,o=e.tag,a=e.attrsMap.type;if(e.component)return Br(e,r,i),!1;if("select"===o)!function(e,t,n){var r='var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return '+(n&&n.number?"_n(val)":"val")+"});";r=r+" "+Ur(t,"$event.target.multiple ? $$selectedVal : $$selectedVal[0]"),Mr(e,"change",r,null,!0)}(e,r,i);else if("input"===o&&"checkbox"===a)!function(e,t,n){var r=n&&n.number,i=Fr(e,"value")||"null",o=Fr(e,"true-value")||"true",a=Fr(e,"false-value")||"false";Er(e,"checked","Array.isArray("+t+")?_i("+t+","+i+")>-1"+("true"===o?":("+t+")":":_q("+t+","+o+")")),Mr(e,"change","var $$a="+t+",$$el=$event.target,$$c=$$el.checked?("+o+"):("+a+");if(Array.isArray($$a)){var $$v="+(r?"_n("+i+")":i)+",$$i=_i($$a,$$v);if($$el.checked){$$i<0&&("+Ur(t,"$$a.concat([$$v])")+")}else{$$i>-1&&("+Ur(t,"$$a.slice(0,$$i).concat($$a.slice($$i+1))")+")}}else{"+Ur(t,"$$c")+"}",null,!0)}(e,r,i);else if("input"===o&&"radio"===a)!function(e,t,n){var r=n&&n.number,i=Fr(e,"value")||"null";Er(e,"checked","_q("+t+","+(i=r?"_n("+i+")":i)+")"),Mr(e,"change",Ur(t,i),null,!0)}(e,r,i);else if("input"===o||"textarea"===o)!function(e,t,n){var r=e.attrsMap.type,i=n||{},o=i.lazy,a=i.number,s=i.trim,c=!o&&"range"!==r,u=o?"change":"range"===r?Zr:"input",l="$event.target.value";s&&(l="$event.target.value.trim()"),a&&(l="_n("+l+")");var f=Ur(t,l);c&&(f="if($event.target.composing)return;"+f),Er(e,"value","("+t+")"),Mr(e,u,f,null,!0),(s||a)&&Mr(e,"blur","$forceUpdate()")}(e,r,i);else if(!F.isReservedTag(o))return Br(e,r,i),!1;return!0},text:function(e,t){t.value&&Er(e,"textContent","_s("+t.value+")",t)},html:function(e,t){t.value&&Er(e,"innerHTML","_s("+t.value+")",t)}},isPreTag:function(e){return"pre"===e},isUnaryTag:$o,mustUseProp:Dn,canBeLeftOpenTag:wo,isReservedTag:Zn,getTagNamespace:Gn,staticKeys:function(e){return e.reduce(function(e,t){return e.concat(t.staticKeys||[])},[]).join(",")}($a)},ka=g(function(e){return p("type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap"+(e?","+e:""))});function Aa(e,t){e&&(wa=ka(t.staticKeys||""),Ca=t.isReservedTag||T,function e(t){t.static=function(e){if(2===e.type)return!1;if(3===e.type)return!0;return!(!e.pre&&(e.hasBindings||e.if||e.for||d(e.tag)||!Ca(e.tag)||function(e){for(;e.parent;){if("template"!==(e=e.parent).tag)return!1;if(e.for)return!0}return!1}(e)||!Object.keys(e).every(wa)))}(t);if(1===t.type){if(!Ca(t.tag)&&"slot"!==t.tag&&null==t.attrsMap["inline-template"])return;for(var n=0,r=t.children.length;n<r;n++){var i=t.children[n];e(i),i.static||(t.static=!1)}if(t.ifConditions)for(var o=1,a=t.ifConditions.length;o<a;o++){var s=t.ifConditions[o].block;e(s),s.static||(t.static=!1)}}}(e),function e(t,n){if(1===t.type){if((t.static||t.once)&&(t.staticInFor=n),t.static&&t.children.length&&(1!==t.children.length||3!==t.children[0].type))return void(t.staticRoot=!0);if(t.staticRoot=!1,t.children)for(var r=0,i=t.children.length;r<i;r++)e(t.children[r],n||!!t.for);if(t.ifConditions)for(var o=1,a=t.ifConditions.length;o<a;o++)e(t.ifConditions[o].block,n)}}(e,!1))}var Oa=/^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/,Sa=/\([^)]*?\);*$/,Ta=/^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/,Na={esc:27,tab:9,enter:13,space:32,up:38,left:37,right:39,down:40,delete:[8,46]},Ea={esc:["Esc","Escape"],tab:"Tab",enter:"Enter",space:[" ","Spacebar"],up:["Up","ArrowUp"],left:["Left","ArrowLeft"],right:["Right","ArrowRight"],down:["Down","ArrowDown"],delete:["Backspace","Delete","Del"]},ja=function(e){return"if("+e+")return null;"},Da={stop:"$event.stopPropagation();",prevent:"$event.preventDefault();",self:ja("$event.target !== $event.currentTarget"),ctrl:ja("!$event.ctrlKey"),shift:ja("!$event.shiftKey"),alt:ja("!$event.altKey"),meta:ja("!$event.metaKey"),left:ja("'button' in $event && $event.button !== 0"),middle:ja("'button' in $event && $event.button !== 1"),right:ja("'button' in $event && $event.button !== 2")};function La(e,t){var n=t?"nativeOn:":"on:",r="",i="";for(var o in e){var a=Ia(e[o]);e[o]&&e[o].dynamic?i+=o+","+a+",":r+='"'+o+'":'+a+","}return r="{"+r.slice(0,-1)+"}",i?n+"_d("+r+",["+i.slice(0,-1)+"])":n+r}function Ia(e){if(!e)return"function(){}";if(Array.isArray(e))return"["+e.map(function(e){return Ia(e)}).join(",")+"]";var t=Ta.test(e.value),n=Oa.test(e.value),r=Ta.test(e.value.replace(Sa,""));if(e.modifiers){var i="",o="",a=[];for(var s in e.modifiers)if(Da[s])o+=Da[s],Na[s]&&a.push(s);else if("exact"===s){var c=e.modifiers;o+=ja(["ctrl","shift","alt","meta"].filter(function(e){return!c[e]}).map(function(e){return"$event."+e+"Key"}).join("||"))}else a.push(s);return a.length&&(i+=function(e){return"if(!$event.type.indexOf('key')&&"+e.map(Ma).join("&&")+")return null;"}(a)),o&&(i+=o),"function($event){"+i+(t?"return "+e.value+".apply(null, arguments)":n?"return ("+e.value+").apply(null, arguments)":r?"return "+e.value:e.value)+"}"}return t||n?e.value:"function($event){"+(r?"return "+e.value:e.value)+"}"}function Ma(e){var t=parseInt(e,10);if(t)return"$event.keyCode!=="+t;var n=Na[e],r=Ea[e];return"_k($event.keyCode,"+JSON.stringify(e)+","+JSON.stringify(n)+",$event.key,"+JSON.stringify(r)+")"}var Fa={on:function(e,t){e.wrapListeners=function(e){return"_g("+e+","+t.value+")"}},bind:function(e,t){e.wrapData=function(n){return"_b("+n+",'"+e.tag+"',"+t.value+","+(t.modifiers&&t.modifiers.prop?"true":"false")+(t.modifiers&&t.modifiers.sync?",true":"")+")"}},cloak:S},Pa=function(e){this.options=e,this.warn=e.warn||Tr,this.transforms=Nr(e.modules,"transformCode"),this.dataGenFns=Nr(e.modules,"genData"),this.directives=A(A({},Fa),e.directives);var t=e.isReservedTag||T;this.maybeComponent=function(e){return!!e.component||!t(e.tag)},this.onceId=0,this.staticRenderFns=[],this.pre=!1};function Ra(e,t){var n=new Pa(t);return{render:"with(this){return "+(e?"script"===e.tag?"null":Ha(e,n):'_c("div")')+"}",staticRenderFns:n.staticRenderFns}}function Ha(e,t){if(e.parent&&(e.pre=e.pre||e.parent.pre),e.staticRoot&&!e.staticProcessed)return Ba(e,t);if(e.once&&!e.onceProcessed)return Ua(e,t);if(e.for&&!e.forProcessed)return za(e,t);if(e.if&&!e.ifProcessed)return Va(e,t);if("template"!==e.tag||e.slotTarget||t.pre){if("slot"===e.tag)return function(e,t){var n=e.slotName||'"default"',r=Wa(e,t),i="_t("+n+(r?",function(){return "+r+"}":""),o=e.attrs||e.dynamicAttrs?Xa((e.attrs||[]).concat(e.dynamicAttrs||[]).map(function(e){return{name:b(e.name),value:e.value,dynamic:e.dynamic}})):null,a=e.attrsMap["v-bind"];!o&&!a||r||(i+=",null");o&&(i+=","+o);a&&(i+=(o?"":",null")+","+a);return i+")"}(e,t);var n;if(e.component)n=function(e,t,n){var r=t.inlineTemplate?null:Wa(t,n,!0);return"_c("+e+","+Ka(t,n)+(r?","+r:"")+")"}(e.component,e,t);else{var r;(!e.plain||e.pre&&t.maybeComponent(e))&&(r=Ka(e,t));var i=e.inlineTemplate?null:Wa(e,t,!0);n="_c('"+e.tag+"'"+(r?","+r:"")+(i?","+i:"")+")"}for(var o=0;o<t.transforms.length;o++)n=t.transforms[o](e,n);return n}return Wa(e,t)||"void 0"}function Ba(e,t){e.staticProcessed=!0;var n=t.pre;return e.pre&&(t.pre=e.pre),t.staticRenderFns.push("with(this){return "+Ha(e,t)+"}"),t.pre=n,"_m("+(t.staticRenderFns.length-1)+(e.staticInFor?",true":"")+")"}function Ua(e,t){if(e.onceProcessed=!0,e.if&&!e.ifProcessed)return Va(e,t);if(e.staticInFor){for(var n="",r=e.parent;r;){if(r.for){n=r.key;break}r=r.parent}return n?"_o("+Ha(e,t)+","+t.onceId+++","+n+")":Ha(e,t)}return Ba(e,t)}function Va(e,t,n,r){return e.ifProcessed=!0,function e(t,n,r,i){if(!t.length)return i||"_e()";var o=t.shift();return o.exp?"("+o.exp+")?"+a(o.block)+":"+e(t,n,r,i):""+a(o.block);function a(e){return r?r(e,n):e.once?Ua(e,n):Ha(e,n)}}(e.ifConditions.slice(),t,n,r)}function za(e,t,n,r){var i=e.for,o=e.alias,a=e.iterator1?","+e.iterator1:"",s=e.iterator2?","+e.iterator2:"";return e.forProcessed=!0,(r||"_l")+"(("+i+"),function("+o+a+s+"){return "+(n||Ha)(e,t)+"})"}function Ka(e,t){var n="{",r=function(e,t){var n=e.directives;if(!n)return;var r,i,o,a,s="directives:[",c=!1;for(r=0,i=n.length;r<i;r++){o=n[r],a=!0;var u=t.directives[o.name];u&&(a=!!u(e,o,t.warn)),a&&(c=!0,s+='{name:"'+o.name+'",rawName:"'+o.rawName+'"'+(o.value?",value:("+o.value+"),expression:"+JSON.stringify(o.value):"")+(o.arg?",arg:"+(o.isDynamicArg?o.arg:'"'+o.arg+'"'):"")+(o.modifiers?",modifiers:"+JSON.stringify(o.modifiers):"")+"},")}if(c)return s.slice(0,-1)+"]"}(e,t);r&&(n+=r+","),e.key&&(n+="key:"+e.key+","),e.ref&&(n+="ref:"+e.ref+","),e.refInFor&&(n+="refInFor:true,"),e.pre&&(n+="pre:true,"),e.component&&(n+='tag:"'+e.tag+'",');for(var i=0;i<t.dataGenFns.length;i++)n+=t.dataGenFns[i](e);if(e.attrs&&(n+="attrs:"+Xa(e.attrs)+","),e.props&&(n+="domProps:"+Xa(e.props)+","),e.events&&(n+=La(e.events,!1)+","),e.nativeEvents&&(n+=La(e.nativeEvents,!0)+","),e.slotTarget&&!e.slotScope&&(n+="slot:"+e.slotTarget+","),e.scopedSlots&&(n+=function(e,t,n){var r=e.for||Object.keys(t).some(function(e){var n=t[e];return n.slotTargetDynamic||n.if||n.for||Ja(n)}),i=!!e.if;if(!r)for(var o=e.parent;o;){if(o.slotScope&&o.slotScope!==ua||o.for){r=!0;break}o.if&&(i=!0),o=o.parent}var a=Object.keys(t).map(function(e){return qa(t[e],n)}).join(",");return"scopedSlots:_u(["+a+"]"+(r?",null,true":"")+(!r&&i?",null,false,"+function(e){var t=5381,n=e.length;for(;n;)t=33*t^e.charCodeAt(--n);return t>>>0}(a):"")+")"}(e,e.scopedSlots,t)+","),e.model&&(n+="model:{value:"+e.model.value+",callback:"+e.model.callback+",expression:"+e.model.expression+"},"),e.inlineTemplate){var o=function(e,t){var n=e.children[0];if(n&&1===n.type){var r=Ra(n,t.options);return"inlineTemplate:{render:function(){"+r.render+"},staticRenderFns:["+r.staticRenderFns.map(function(e){return"function(){"+e+"}"}).join(",")+"]}"}}(e,t);o&&(n+=o+",")}return n=n.replace(/,$/,"")+"}",e.dynamicAttrs&&(n="_b("+n+',"'+e.tag+'",'+Xa(e.dynamicAttrs)+")"),e.wrapData&&(n=e.wrapData(n)),e.wrapListeners&&(n=e.wrapListeners(n)),n}function Ja(e){return 1===e.type&&("slot"===e.tag||e.children.some(Ja))}function qa(e,t){var n=e.attrsMap["slot-scope"];if(e.if&&!e.ifProcessed&&!n)return Va(e,t,qa,"null");if(e.for&&!e.forProcessed)return za(e,t,qa);var r=e.slotScope===ua?"":String(e.slotScope),i="function("+r+"){return "+("template"===e.tag?e.if&&n?"("+e.if+")?"+(Wa(e,t)||"undefined")+":undefined":Wa(e,t)||"undefined":Ha(e,t))+"}",o=r?"":",proxy:true";return"{key:"+(e.slotTarget||'"default"')+",fn:"+i+o+"}"}function Wa(e,t,n,r,i){var o=e.children;if(o.length){var a=o[0];if(1===o.length&&a.for&&"template"!==a.tag&&"slot"!==a.tag){var s=n?t.maybeComponent(a)?",1":",0":"";return""+(r||Ha)(a,t)+s}var c=n?function(e,t){for(var n=0,r=0;r<e.length;r++){var i=e[r];if(1===i.type){if(Za(i)||i.ifConditions&&i.ifConditions.some(function(e){return Za(e.block)})){n=2;break}(t(i)||i.ifConditions&&i.ifConditions.some(function(e){return t(e.block)}))&&(n=1)}}return n}(o,t.maybeComponent):0,u=i||Ga;return"["+o.map(function(e){return u(e,t)}).join(",")+"]"+(c?","+c:"")}}function Za(e){return void 0!==e.for||"template"===e.tag||"slot"===e.tag}function Ga(e,t){return 1===e.type?Ha(e,t):3===e.type&&e.isComment?(r=e,"_e("+JSON.stringify(r.text)+")"):"_v("+(2===(n=e).type?n.expression:Ya(JSON.stringify(n.text)))+")";var n,r}function Xa(e){for(var t="",n="",r=0;r<e.length;r++){var i=e[r],o=Ya(i.value);i.dynamic?n+=i.name+","+o+",":t+='"'+i.name+'":'+o+","}return t="{"+t.slice(0,-1)+"}",n?"_d("+t+",["+n.slice(0,-1)+"])":t}function Ya(e){return e.replace(/\u2028/g,"\\u2028").replace(/\u2029/g,"\\u2029")}new RegExp("\\b"+"do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,super,throw,while,yield,delete,export,import,return,switch,default,extends,finally,continue,debugger,function,arguments".split(",").join("\\b|\\b")+"\\b");function Qa(e,t){try{return new Function(e)}catch(n){return t.push({err:n,code:e}),S}}function es(e){var t=Object.create(null);return function(n,r,i){(r=A({},r)).warn;delete r.warn;var o=r.delimiters?String(r.delimiters)+n:n;if(t[o])return t[o];var a=e(n,r),s={},c=[];return s.render=Qa(a.render,c),s.staticRenderFns=a.staticRenderFns.map(function(e){return Qa(e,c)}),t[o]=s}}var ts,ns,rs=(ts=function(e,t){var n=fa(e.trim(),t);!1!==t.optimize&&Aa(n,t);var r=Ra(n,t);return{ast:n,render:r.render,staticRenderFns:r.staticRenderFns}},function(e){function t(t,n){var r=Object.create(e),i=[],o=[];if(n)for(var a in n.modules&&(r.modules=(e.modules||[]).concat(n.modules)),n.directives&&(r.directives=A(Object.create(e.directives||null),n.directives)),n)"modules"!==a&&"directives"!==a&&(r[a]=n[a]);r.warn=function(e,t,n){(n?o:i).push(e)};var s=ts(t.trim(),r);return s.errors=i,s.tips=o,s}return{compile:t,compileToFunctions:es(t)}})(xa),is=(rs.compile,rs.compileToFunctions);function os(e){return(ns=ns||document.createElement("div")).innerHTML=e?'<a href="\n"/>':'<div a="\n"/>',ns.innerHTML.indexOf("&#10;")>0}var as=!!V&&os(!1),ss=!!V&&os(!0),cs=g(function(e){var t=Qn(e);return t&&t.innerHTML}),us=Cn.prototype.$mount;Cn.prototype.$mount=function(e,t){if((e=e&&Qn(e))===document.body||e===document.documentElement)return this;var n=this.$options;if(!n.render){var r=n.template;if(r)if("string"==typeof r)"#"===r.charAt(0)&&(r=cs(r));else{if(!r.nodeType)return this;r=r.innerHTML}else e&&(r=function(e){if(e.outerHTML)return e.outerHTML;var t=document.createElement("div");return t.appendChild(e.cloneNode(!0)),t.innerHTML}(e));if(r){var i=is(r,{outputSourceRange:!1,shouldDecodeNewlines:as,shouldDecodeNewlinesForHref:ss,delimiters:n.delimiters,comments:n.comments},this),o=i.render,a=i.staticRenderFns;n.render=o,n.staticRenderFns=a}}return us.call(this,e,t)},Cn.compile=is,module.exports=Cn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(487).setImmediate))

/***/ }),
/* 2232 */
/***/ (function(module, exports) {

	module.exports=function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={exports:{},id:r,loaded:!1};return e[r].call(i.exports,i,i.exports,t),i.loaded=!0,i.exports}var n={};return t.m=e,t.c=n,t.p="/dist/",t(0)}([function(e,t,n){"use strict";e.exports=n(75)},function(e,t){var n=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(e,t){var n={}.hasOwnProperty;e.exports=function(e,t){return n.call(e,t)}},function(e,t,n){var r=n(51),i=n(15);e.exports=function(e){return r(i(e))}},function(e,t,n){e.exports=!n(9)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(e,t,n){var r=n(6),i=n(12);e.exports=n(4)?function(e,t,n){return r.f(e,t,i(1,n))}:function(e,t,n){return e[t]=n,e}},function(e,t,n){var r=n(8),i=n(31),a=n(24),o=Object.defineProperty;t.f=n(4)?Object.defineProperty:function(e,t,n){if(r(e),t=a(t,!0),r(n),i)try{return o(e,t,n)}catch(e){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(e[t]=n.value),e}},function(e,t,n){var r=n(22)("wks"),i=n(13),a=n(1).Symbol,o="function"==typeof a,s=e.exports=function(e){return r[e]||(r[e]=o&&a[e]||(o?a:i)("Symbol."+e))};s.store=r},function(e,t,n){var r=n(10);e.exports=function(e){if(!r(e))throw TypeError(e+" is not an object!");return e}},function(e,t){e.exports=function(e){try{return!!e()}catch(e){return!0}}},function(e,t){e.exports=function(e){return"object"==typeof e?null!==e:"function"==typeof e}},function(e,t,n){var r=n(36),i=n(16);e.exports=Object.keys||function(e){return r(e,i)}},function(e,t){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}},function(e,t){var n=0,r=Math.random();e.exports=function(e){return"Symbol(".concat(void 0===e?"":e,")_",(++n+r).toString(36))}},function(e,t){var n=e.exports={version:"2.4.0"};"number"==typeof __e&&(__e=n)},function(e,t){e.exports=function(e){if(void 0==e)throw TypeError("Can't call method on  "+e);return e}},function(e,t){e.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(e,t){e.exports={}},function(e,t){e.exports=!0},function(e,t){t.f={}.propertyIsEnumerable},function(e,t,n){var r=n(6).f,i=n(2),a=n(7)("toStringTag");e.exports=function(e,t,n){e&&!i(e=n?e:e.prototype,a)&&r(e,a,{configurable:!0,value:t})}},function(e,t,n){var r=n(22)("keys"),i=n(13);e.exports=function(e){return r[e]||(r[e]=i(e))}},function(e,t,n){var r=n(1),i="__core-js_shared__",a=r[i]||(r[i]={});e.exports=function(e){return a[e]||(a[e]={})}},function(e,t){var n=Math.ceil,r=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?r:n)(e)}},function(e,t,n){var r=n(10);e.exports=function(e,t){if(!r(e))return e;var n,i;if(t&&"function"==typeof(n=e.toString)&&!r(i=n.call(e)))return i;if("function"==typeof(n=e.valueOf)&&!r(i=n.call(e)))return i;if(!t&&"function"==typeof(n=e.toString)&&!r(i=n.call(e)))return i;throw TypeError("Can't convert object to primitive value")}},function(e,t,n){var r=n(1),i=n(14),a=n(18),o=n(26),s=n(6).f;e.exports=function(e){var t=i.Symbol||(i.Symbol=a?{}:r.Symbol||{});"_"==e.charAt(0)||e in t||s(t,e,{value:o.f(e)})}},function(e,t,n){t.f=n(7)},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={translations:{da:{months:{original:["Januar","Februar","Marts","April","Maj","Juni","Juli","August","September","Oktober","November","December"],abbr:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"]},days:["Sø","Ma","Ti","On","To","Fr","Lø"]},en:{months:{original:["January","February","March","April","May","June","July","August","September","October","November","December"],abbr:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]},days:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"]},es:{months:{original:["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],abbr:["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"]},days:["Dom","Lun","Mar","Mié","Jue","Vie","Sab"]},fi:{months:{original:["tammikuu","helmikuu","maaliskuu","huhtikuu","toukokuu","kesäkuu","heinäkuu","elokuu","syyskuu","lokakuu","marraskuu","joulukuu"],abbr:["tammi","helmi","maalis","huhti","touko","kesä","heinä","elo","syys","loka","marras","joulu"]},days:["su","ma","ti","ke","to","pe","la"]},fr:{months:{original:["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"],abbr:["Jan","Fév","Mar","Avr","Mai","Jui","Juil","Aoû","Sep","Oct","Nov","Déc"]},days:["Dim","Lun","Mar","Mer","Jeu","Ven","Sam"]},hr:{months:{original:["Siječanj","Veljača","Ožujak","Travanj","Svibanj","Lipanj","Srpanj","Kolovoz","Rujan","Listopad","Studeni","Prosinac"],abbr:["Sij","Velj","Ožu","Tra","Svi","Lip","Srp","Kol","Ruj","Lis","Stu","Pro"]},days:["Ned","Pon","Uto","Sri","Čet","Pet","Sub"]},it:{months:{original:["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],abbr:["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"]},days:["Dom","Lun","Mar","Mer","Gio","Ven","Sab"]},nl:{months:{original:["Januari","Februari","Maart","April","Mei","Juni","Juli","Augustus","September","Oktober","November","December"],abbr:["Jan","Feb","Maa","Apr","Mei","Jun","Jul","Aug","Sep","Okt","Nov","Dec"]},days:["Zo","Ma","Di","Wo","Do","Vr","Za"]},de:{months:{original:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],abbr:["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"]},days:["So.","Mo.","Di.","Mi.","Do.","Fr.","Sa."]},"pt-br":{months:{original:["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],abbr:["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"]},days:["Dom","Seg","Ter","Qua","Qui","Sex","Sab"]},vi:{months:{original:["Tháng 1","Tháng 2","Tháng 3","Tháng 4","Tháng 5","Tháng 6","Tháng 7","Tháng 8","Tháng 9","Tháng 10","Tháng 11","Tháng 12"],abbr:["T 01","T 02","T 03","T 04","T 05","T 06","T 07","T 08","T 09","T 10","T 11","T 12"]},days:["CN","Thứ 2","Thứ 3","Thứ 4","Thứ 5","Thứ 6","Thứ 7"]},zh:{months:{original:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],abbr:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"]},days:["日","一","二","三","四","五","六"]},ja:{months:{original:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],abbr:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"]},days:["日","月","火","水","木","金","土"]},he:{months:{original:["ינואר","פברואר","מרץ","אפריל","מאי","יוני","יולי","אוגוסט","ספטמבר","אוקטובר","נובמבר","דצמבר"],abbr:["ינו","פבר","מרץ","אפר","מאי","יונ","יול","אוג","ספט","אוק","נוב","דצמ"]},days:["א","ב","ג","ד","ה","ו","ש"]},cs:{months:{original:["leden","únor","březen","duben","květen","červen","červenec","srpen","září","říjen","listopad","prosinec"],abbr:["led","úno","bře","dub","kvě","čer","čec","srp","zář","říj","lis","pro"]},days:["ne","po","út","st","čt","pá","so"]},ru:{months:{original:["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],abbr:["Янв","Февр","Март","Апр","Май","Июнь","Июль","Авг","Сент","Окт","Нояб","Дек"]},days:["Вс","Пн","Вт","Ср","Чт","Пт","Сб"]},sv:{months:{original:["Januari","Februari","Mars","April","Maj","Juni","Juli","Augusti","September","Oktober","November","December"],abbr:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]},days:["Sön","Mån","Tis","Ons","Tor","Fre","Lör"]},th:{months:{original:["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"],abbr:["ม.ค.","ก.พ.","มี.ค.","เม.ย.","พ.ค.","มิ.ย.","ก.ค.","ส.ค.","ก.ย.","ต.ค.","พ.ย.","ธ.ค."]},days:["อา","จ","อ","พ","พฤ","ศ","ส"]},ro:{months:{original:["Ianuarie","Februarie","Martie","Aprilie","Mai","Iunie","Iulie","August","Septembrie","Octombrie","Noiembrie","Decembrie"],abbr:["Ian","Feb","Mar","Apr","Mai","Iun","Iul","Aug","Sep","Oct","Noi","Dec"]},days:["D","L","Ma","Mi","J","V","S"]},"sl-si":{months:{original:["Januar","Februar","Marec","April","Maj","Junij","Julij","Avgust","September","Oktober","November","December"],abbr:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"]},days:["Ned","Pon","Tor","Sre","Čet","Pet","Sob"]}}}},function(e,t){var n={}.toString;e.exports=function(e){return n.call(e).slice(8,-1)}},function(e,t,n){var r=n(10),i=n(1).document,a=r(i)&&r(i.createElement);e.exports=function(e){return a?i.createElement(e):{}}},function(e,t,n){var r=n(1),i=n(14),a=n(48),o=n(5),s="prototype",u=function(e,t,n){var l,c,d,f=e&u.F,h=e&u.G,p=e&u.S,b=e&u.P,g=e&u.B,y=e&u.W,v=h?i:i[t]||(i[t]={}),m=v[s],D=h?r:p?r[t]:(r[t]||{})[s];h&&(n=t);for(l in n)c=!f&&D&&void 0!==D[l],c&&l in v||(d=c?D[l]:n[l],v[l]=h&&"function"!=typeof D[l]?n[l]:g&&c?a(d,r):y&&D[l]==d?function(e){var t=function(t,n,r){if(this instanceof e){switch(arguments.length){case 0:return new e;case 1:return new e(t);case 2:return new e(t,n)}return new e(t,n,r)}return e.apply(this,arguments)};return t[s]=e[s],t}(d):b&&"function"==typeof d?a(Function.call,d):d,b&&((v.virtual||(v.virtual={}))[l]=d,e&u.R&&m&&!m[l]&&o(m,l,d)))};u.F=1,u.G=2,u.S=4,u.P=8,u.B=16,u.W=32,u.U=64,u.R=128,e.exports=u},function(e,t,n){e.exports=!n(4)&&!n(9)(function(){return 7!=Object.defineProperty(n(29)("div"),"a",{get:function(){return 7}}).a})},function(e,t,n){"use strict";var r=n(18),i=n(30),a=n(37),o=n(5),s=n(2),u=n(17),l=n(53),c=n(20),d=n(60),f=n(7)("iterator"),h=!([].keys&&"next"in[].keys()),p="@@iterator",b="keys",g="values",y=function(){return this};e.exports=function(e,t,n,v,m,D,M){l(n,t,v);var w,x,S,O=function(e){if(!h&&e in Y)return Y[e];switch(e){case b:return function(){return new n(this,e)};case g:return function(){return new n(this,e)}}return function(){return new n(this,e)}},F=t+" Iterator",k=m==g,T=!1,Y=e.prototype,j=Y[f]||Y[p]||m&&Y[m],A=j||O(m),J=m?k?O("entries"):A:void 0,N="Array"==t?Y.entries||j:j;if(N&&(S=d(N.call(new e)),S!==Object.prototype&&(c(S,F,!0),r||s(S,f)||o(S,f,y))),k&&j&&j.name!==g&&(T=!0,A=function(){return j.call(this)}),r&&!M||!h&&!T&&Y[f]||o(Y,f,A),u[t]=A,u[F]=y,m)if(w={values:k?A:O(g),keys:D?A:O(b),entries:J},M)for(x in w)x in Y||a(Y,x,w[x]);else i(i.P+i.F*(h||T),t,w);return w}},function(e,t,n){var r=n(8),i=n(57),a=n(16),o=n(21)("IE_PROTO"),s=function(){},u="prototype",l=function(){var e,t=n(29)("iframe"),r=a.length,i="<",o=">";for(t.style.display="none",n(50).appendChild(t),t.src="javascript:",e=t.contentWindow.document,e.open(),e.write(i+"script"+o+"document.F=Object"+i+"/script"+o),e.close(),l=e.F;r--;)delete l[u][a[r]];return l()};e.exports=Object.create||function(e,t){var n;return null!==e?(s[u]=r(e),n=new s,s[u]=null,n[o]=e):n=l(),void 0===t?n:i(n,t)}},function(e,t,n){var r=n(36),i=n(16).concat("length","prototype");t.f=Object.getOwnPropertyNames||function(e){return r(e,i)}},function(e,t){t.f=Object.getOwnPropertySymbols},function(e,t,n){var r=n(2),i=n(3),a=n(47)(!1),o=n(21)("IE_PROTO");e.exports=function(e,t){var n,s=i(e),u=0,l=[];for(n in s)n!=o&&r(s,n)&&l.push(n);for(;t.length>u;)r(s,n=t[u++])&&(~a(l,n)||l.push(n));return l}},function(e,t,n){e.exports=n(5)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(42),a=r(i),o=n(27),s=r(o);t.default={isValidDate:function(e){return"[object Date]"===Object.prototype.toString.call(e)&&!isNaN(e.getTime())},getDayNameAbbr:function(e,t){if("object"!==("undefined"==typeof e?"undefined":(0,a.default)(e)))throw TypeError("Invalid Type");return t[e.getDay()]},getMonthName:function(e,t){if(!t)throw Error("missing 2nd parameter Months array");if("object"===("undefined"==typeof e?"undefined":(0,a.default)(e)))return t[e.getMonth()];if("number"==typeof e)return t[e];throw TypeError("Invalid type")},getMonthNameAbbr:function(e,t){if(!t)throw Error("missing 2nd paramter Months array");if("object"===("undefined"==typeof e?"undefined":(0,a.default)(e)))return t[e.getMonth()];if("number"==typeof e)return t[e];throw TypeError("Invalid type")},convertToUTC:function(e){return new Date(e.getTime()+6e4*e.getTimezoneOffset())},daysInMonth:function(e,t){return new Date(Date.UTC(e,t+1,0)).getUTCDate()},dayDiff:function(e,t){var n=864e5,r=Date.UTC(e.getFullYear(),e.getMonth(),e.getDate()),i=Date.UTC(t.getFullYear(),t.getMonth(),t.getDate());return Math.floor((i-r)/n)},getNthSuffix:function(e){switch(e){case 1:case 21:case 31:return"st";case 2:case 22:return"nd";case 3:case 23:return"rd";default:return"th"}},formatDate:function(e,t,n){n=n?n:s.default.translations.en;var r=e.getFullYear(),i=e.getMonth()+1,a=e.getDate(),o=t.replace(/dd/,("0"+a).slice(-2)).replace(/d/,a).replace(/yyyy/,r).replace(/yy/,String(r).slice(2)).replace(/MMMM/,this.getMonthName(e.getMonth(),n.months.original)).replace(/MMM/,this.getMonthNameAbbr(e.getMonth(),n.months.abbr)).replace(/MM/,("0"+i).slice(-2)).replace(/M(?!a)/,i).replace(/su/,this.getNthSuffix(e.getDate())).replace(/D(?!e)/,this.getDayNameAbbr(e,n.days));return o},createDateArray:function(e,t){for(var n=[];e<=t;)n.push(new Date(e)),e=new Date(e).setDate(new Date(e).getDate()+1);return n}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(38),a=r(i),o=n(27),s=r(o);t.default={props:{value:{validator:function(e){return null===e||e instanceof Date||"string"==typeof e}},name:{value:String},id:{value:String},format:{value:String,default:"dd MMM yyyy"},language:{value:String,default:"en"},disabled:{type:Object},highlighted:{type:Object},placeholder:{type:String},inline:{type:Boolean},inputClass:{type:String},wrapperClass:{type:String},mondayFirst:{type:Boolean,default:!1}},data:function(){return{currDate:new Date((new Date).getFullYear(),(new Date).getMonth(),1).getTime(),selectedDate:null,showDayView:!1,showMonthView:!1,showYearView:!1,calendarHeight:0}},watch:{value:function(e){this.setValue(e)}},computed:{formattedValue:function(){return this.selectedDate?a.default.formatDate(new Date(this.selectedDate),this.format,this.translation):null},translation:function(){return s.default.translations[this.language]},currMonthName:function(){var e=new Date(this.currDate);return a.default.getMonthNameAbbr(e.getMonth(),this.translation.months.abbr)},currYear:function(){var e=new Date(this.currDate);return e.getFullYear()},blankDays:function(){var e=new Date(this.currDate),t=new Date(e.getFullYear(),e.getMonth(),1,e.getHours(),e.getMinutes());return this.mondayFirst?t.getDay()>0?t.getDay()-1:6:t.getDay()},daysOfWeek:function(){if(this.mondayFirst){var e=this.translation.days.slice();return e.push(e.shift()),e}return this.translation.days},days:function e(){for(var t=new Date(this.currDate),e=[],n=new Date(t.getFullYear(),t.getMonth(),1,t.getHours(),t.getMinutes()),r=a.default.daysInMonth(n.getFullYear(),n.getMonth()),i=0;i<r;i++)e.push({date:n.getDate(),timestamp:n.getTime(),isSelected:this.isSelectedDate(n),isDisabled:this.isDisabledDate(n),isHighlighted:this.isHighlightedDate(n)}),n.setDate(n.getDate()+1);return e},months:function e(){for(var t=new Date(this.currDate),e=[],n=new Date(t.getFullYear(),0,t.getDate(),t.getHours(),t.getMinutes()),r=0;r<12;r++)e.push({month:a.default.getMonthName(r,this.translation.months.original),timestamp:n.getTime(),isSelected:this.isSelectedMonth(n),isDisabled:this.isDisabledMonth(n)}),n.setMonth(n.getMonth()+1);return e},years:function e(){for(var t=new Date(this.currDate),e=[],n=new Date(10*Math.floor(t.getFullYear()/10),t.getMonth(),t.getDate(),t.getHours(),t.getMinutes()),r=0;r<10;r++)e.push({year:n.getFullYear(),timestamp:n.getTime(),isSelected:this.isSelectedYear(n),isDisabled:this.isDisabledYear(n)}),n.setFullYear(n.getFullYear()+1);return e},calendarStyle:function(){var e={top:0,height:0};this.$el&&(e=this.$el.getBoundingClientRect());var t=e.top+e.height+this.calendarHeight||0,n={};return t>window.innerHeight&&(n={bottom:e.height+"px"}),this.isInline()&&(n.position="static"),n},calendarStyleSecondary:function(){return this.isInline()?{position:"static"}:{}}},methods:{close:function(){this.showDayView=this.showMonthView=this.showYearView=!1},isOpen:function(){return this.showDayView||this.showMonthView||this.showYearView},isInline:function(){return"undefined"!=typeof this.inline&&this.inline},showCalendar:function(){return!this.isInline()&&(this.isOpen()?this.close():void this.showDayCalendar())},showDayCalendar:function(){this.close(),this.showDayView=!0,this.$emit("opened")},showMonthCalendar:function(){this.close(),this.showMonthView=!0},showYearCalendar:function(){this.close(),this.showYearView=!0},setDate:function(e){this.selectedDate=new Date(e),this.currDate=new Date(this.selectedDate.getFullYear(),this.selectedDate.getMonth(),1).getTime(),this.$emit("selected",new Date(e)),this.$emit("input",new Date(e))},selectDate:function(e){return!e.isDisabled&&(this.setDate(e.timestamp),this.isInline()?this.showDayCalendar():void this.close())},selectMonth:function(e){return!e.isDisabled&&(this.currDate=e.timestamp,void this.showDayCalendar())},selectYear:function(e){return!e.isDisabled&&(this.currDate=e.timestamp,void this.showMonthCalendar())},getMonth:function(){var e=new Date(this.currDate);return e.getMonth()},getYear:function(){var e=new Date(this.currDate);return e.getFullYear()},getDecade:function(){var e=new Date(this.currDate),t=10*Math.floor(e.getFullYear()/10);return t+"'s"},previousMonth:function(){if(this.previousMonthDisabled())return!1;var e=new Date(this.currDate);e.setMonth(e.getMonth()-1),this.currDate=e.getTime()},previousMonthDisabled:function(){if("undefined"==typeof this.disabled||"undefined"==typeof this.disabled.to||!this.disabled.to)return!1;var e=new Date(this.currDate);return this.disabled.to.getMonth()>=e.getMonth()&&this.disabled.to.getFullYear()>=e.getFullYear()},nextMonth:function(){if(this.nextMonthDisabled())return!1;var e=new Date(this.currDate),t=a.default.daysInMonth(e.getFullYear(),e.getMonth());e.setDate(e.getDate()+t),this.currDate=e.getTime()},nextMonthDisabled:function(){if("undefined"==typeof this.disabled||"undefined"==typeof this.disabled.from||!this.disabled.from)return!1;var e=new Date(this.currDate);return this.disabled.from.getMonth()<=e.getMonth()&&this.disabled.from.getFullYear()<=e.getFullYear()},previousYear:function(){if(this.previousYearDisabled())return!1;var e=new Date(this.currDate);e.setYear(e.getFullYear()-1),this.currDate=e.getTime()},previousYearDisabled:function(){if("undefined"==typeof this.disabled||"undefined"==typeof this.disabled.to||!this.disabled.to)return!1;var e=new Date(this.currDate);return this.disabled.to.getFullYear()>=e.getFullYear()},nextYear:function(){if(this.nextYearDisabled())return!1;var e=new Date(this.currDate);e.setYear(e.getFullYear()+1),this.currDate=e.getTime()},nextYearDisabled:function(){if("undefined"==typeof this.disabled||"undefined"==typeof this.disabled.from||!this.disabled.from)return!1;var e=new Date(this.currDate);return this.disabled.from.getFullYear()<=e.getFullYear()},previousDecade:function(){if(this.previousDecadeDisabled())return!1;var e=new Date(this.currDate);e.setYear(e.getFullYear()-10),this.currDate=e.getTime()},previousDecadeDisabled:function(){if("undefined"==typeof this.disabled||"undefined"==typeof this.disabled.to||!this.disabled.to)return!1;var e=new Date(this.currDate);return 10*Math.floor(this.disabled.to.getFullYear()/10)>=10*Math.floor(e.getFullYear()/10)},nextDecade:function(){if(this.nextDecadeDisabled())return!1;var e=new Date(this.currDate);e.setYear(e.getFullYear()+10),this.currDate=e.getTime()},nextDecadeDisabled:function(){if("undefined"==typeof this.disabled||"undefined"==typeof this.disabled.from||!this.disabled.from)return!1;var e=new Date(this.currDate);return 10*Math.ceil(this.disabled.from.getFullYear()/10)<=10*Math.ceil(e.getFullYear()/10)},isSelectedDate:function(e){return this.selectedDate&&this.selectedDate.toDateString()===e.toDateString()},isDisabledDate:function(e){var t=!1;return"undefined"!=typeof this.disabled&&("undefined"!=typeof this.disabled.dates&&this.disabled.dates.forEach(function(n){if(e.toDateString()===n.toDateString())return t=!0,!0}),"undefined"!=typeof this.disabled.to&&this.disabled.to&&e<this.disabled.to&&(t=!0),"undefined"!=typeof this.disabled.from&&this.disabled.from&&e>this.disabled.from&&(t=!0),"undefined"!=typeof this.disabled.days&&this.disabled.days.indexOf(e.getDay())!==-1&&(t=!0),t)},isHighlightedDate:function(e){if(this.isDisabledDate(e))return!1;var t=!1;return"undefined"!=typeof this.highlighted&&("undefined"!=typeof this.highlighted.dates&&this.highlighted.dates.forEach(function(n){if(e.toDateString()===n.toDateString())return t=!0,!0}),this.isDefined(this.highlighted.from)&&this.isDefined(this.highlighted.to)&&(t=e>=this.highlighted.from&&e<=this.highlighted.to),"undefined"!=typeof this.highlighted.days&&this.highlighted.days.indexOf(e.getDay())!==-1&&(t=!0),t)},isDefined:function(e){return"undefined"!=typeof e&&e},isSelectedMonth:function(e){return this.selectedDate&&this.selectedDate.getFullYear()===e.getFullYear()&&this.selectedDate.getMonth()===e.getMonth()},isDisabledMonth:function(e){var t=!1;return"undefined"!=typeof this.disabled&&("undefined"!=typeof this.disabled.to&&this.disabled.to&&(e.getMonth()<this.disabled.to.getMonth()&&e.getFullYear()<=this.disabled.to.getFullYear()||e.getFullYear()<this.disabled.to.getFullYear())&&(t=!0),"undefined"!=typeof this.disabled.from&&this.disabled.from&&(this.disabled.from&&e.getMonth()>this.disabled.from.getMonth()&&e.getFullYear()>=this.disabled.from.getFullYear()||e.getFullYear()>this.disabled.from.getFullYear())&&(t=!0),t)},isSelectedYear:function(e){return this.selectedDate&&this.selectedDate.getFullYear()===e.getFullYear()},isDisabledYear:function(e){var t=!1;return!("undefined"==typeof this.disabled||!this.disabled)&&("undefined"!=typeof this.disabled.to&&this.disabled.to&&e.getFullYear()<this.disabled.to.getFullYear()&&(t=!0),"undefined"!=typeof this.disabled.from&&this.disabled.from&&e.getFullYear()>this.disabled.from.getFullYear()&&(t=!0),t)},setValue:function(e){if("string"==typeof e){var t=new Date(e);e=isNaN(t.valueOf())?null:t}if(!e){var n=new Date;return this.currDate=new Date(n.getFullYear(),n.getMonth(),1).getTime(),void(this.selectedDate=null)}this.selectedDate=e,this.currDate=new Date(e.getFullYear(),e.getMonth(),1).getTime()},init:function(){var e=this;this.value&&this.setValue(this.value),this.isInline()&&this.showDayCalendar(),this.$nextTick(function(){e.calendarHeight=e.$el.querySelector(".calendar").getBoundingClientRect().height}),document.addEventListener("click",function(t){if(e.$el&&!e.$el.contains(t.target)){if(e.isInline())return e.showDayCalendar();e.close()}},!1)}},ready:function(){this.init()},mounted:function(){this.init()}}},function(e,t,n){e.exports={default:n(43),__esModule:!0}},function(e,t,n){e.exports={default:n(44),__esModule:!0}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var i=n(41),a=r(i),o=n(40),s=r(o),u="function"==typeof s.default&&"symbol"==typeof a.default?function(e){return typeof e}:function(e){return e&&"function"==typeof s.default&&e.constructor===s.default&&e!==s.default.prototype?"symbol":typeof e};t.default="function"==typeof s.default&&"symbol"===u(a.default)?function(e){return"undefined"==typeof e?"undefined":u(e)}:function(e){return e&&"function"==typeof s.default&&e.constructor===s.default&&e!==s.default.prototype?"symbol":"undefined"==typeof e?"undefined":u(e)}},function(e,t,n){n(68),n(66),n(69),n(70),e.exports=n(14).Symbol},function(e,t,n){n(67),n(71),e.exports=n(26).f("iterator")},function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e}},function(e,t){e.exports=function(){}},function(e,t,n){var r=n(3),i=n(63),a=n(62);e.exports=function(e){return function(t,n,o){var s,u=r(t),l=i(u.length),c=a(o,l);if(e&&n!=n){for(;l>c;)if(s=u[c++],s!=s)return!0}else for(;l>c;c++)if((e||c in u)&&u[c]===n)return e||c||0;return!e&&-1}}},function(e,t,n){var r=n(45);e.exports=function(e,t,n){if(r(e),void 0===t)return e;switch(n){case 1:return function(n){return e.call(t,n)};case 2:return function(n,r){return e.call(t,n,r)};case 3:return function(n,r,i){return e.call(t,n,r,i)}}return function(){return e.apply(t,arguments)}}},function(e,t,n){var r=n(11),i=n(35),a=n(19);e.exports=function(e){var t=r(e),n=i.f;if(n)for(var o,s=n(e),u=a.f,l=0;s.length>l;)u.call(e,o=s[l++])&&t.push(o);return t}},function(e,t,n){e.exports=n(1).document&&document.documentElement},function(e,t,n){var r=n(28);e.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==r(e)?e.split(""):Object(e)}},function(e,t,n){var r=n(28);e.exports=Array.isArray||function(e){return"Array"==r(e)}},function(e,t,n){"use strict";var r=n(33),i=n(12),a=n(20),o={};n(5)(o,n(7)("iterator"),function(){return this}),e.exports=function(e,t,n){e.prototype=r(o,{next:i(1,n)}),a(e,t+" Iterator")}},function(e,t){e.exports=function(e,t){return{value:t,done:!!e}}},function(e,t,n){var r=n(11),i=n(3);e.exports=function(e,t){for(var n,a=i(e),o=r(a),s=o.length,u=0;s>u;)if(a[n=o[u++]]===t)return n}},function(e,t,n){var r=n(13)("meta"),i=n(10),a=n(2),o=n(6).f,s=0,u=Object.isExtensible||function(){return!0},l=!n(9)(function(){return u(Object.preventExtensions({}))}),c=function(e){o(e,r,{value:{i:"O"+ ++s,w:{}}})},d=function(e,t){if(!i(e))return"symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!a(e,r)){if(!u(e))return"F";if(!t)return"E";c(e)}return e[r].i},f=function(e,t){if(!a(e,r)){if(!u(e))return!0;if(!t)return!1;c(e)}return e[r].w},h=function(e){return l&&p.NEED&&u(e)&&!a(e,r)&&c(e),e},p=e.exports={KEY:r,NEED:!1,fastKey:d,getWeak:f,onFreeze:h}},function(e,t,n){var r=n(6),i=n(8),a=n(11);e.exports=n(4)?Object.defineProperties:function(e,t){i(e);for(var n,o=a(t),s=o.length,u=0;s>u;)r.f(e,n=o[u++],t[n]);return e}},function(e,t,n){var r=n(19),i=n(12),a=n(3),o=n(24),s=n(2),u=n(31),l=Object.getOwnPropertyDescriptor;t.f=n(4)?l:function(e,t){if(e=a(e),t=o(t,!0),u)try{return l(e,t)}catch(e){}if(s(e,t))return i(!r.f.call(e,t),e[t])}},function(e,t,n){var r=n(3),i=n(34).f,a={}.toString,o="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],s=function(e){try{return i(e)}catch(e){return o.slice()}};e.exports.f=function(e){return o&&"[object Window]"==a.call(e)?s(e):i(r(e))}},function(e,t,n){var r=n(2),i=n(64),a=n(21)("IE_PROTO"),o=Object.prototype;e.exports=Object.getPrototypeOf||function(e){return e=i(e),r(e,a)?e[a]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?o:null}},function(e,t,n){var r=n(23),i=n(15);e.exports=function(e){return function(t,n){var a,o,s=String(i(t)),u=r(n),l=s.length;return u<0||u>=l?e?"":void 0:(a=s.charCodeAt(u),a<55296||a>56319||u+1===l||(o=s.charCodeAt(u+1))<56320||o>57343?e?s.charAt(u):a:e?s.slice(u,u+2):(a-55296<<10)+(o-56320)+65536)}}},function(e,t,n){var r=n(23),i=Math.max,a=Math.min;e.exports=function(e,t){return e=r(e),e<0?i(e+t,0):a(e,t)}},function(e,t,n){var r=n(23),i=Math.min;e.exports=function(e){return e>0?i(r(e),9007199254740991):0}},function(e,t,n){var r=n(15);e.exports=function(e){return Object(r(e))}},function(e,t,n){"use strict";var r=n(46),i=n(54),a=n(17),o=n(3);e.exports=n(32)(Array,"Array",function(e,t){this._t=o(e),this._i=0,this._k=t},function(){var e=this._t,t=this._k,n=this._i++;return!e||n>=e.length?(this._t=void 0,i(1)):"keys"==t?i(0,n):"values"==t?i(0,e[n]):i(0,[n,e[n]])},"values"),a.Arguments=a.Array,r("keys"),r("values"),r("entries")},function(e,t){},function(e,t,n){"use strict";var r=n(61)(!0);n(32)(String,"String",function(e){this._t=String(e),this._i=0},function(){var e,t=this._t,n=this._i;return n>=t.length?{value:void 0,done:!0}:(e=r(t,n),this._i+=e.length,{value:e,done:!1})})},function(e,t,n){"use strict";var r=n(1),i=n(2),a=n(4),o=n(30),s=n(37),u=n(56).KEY,l=n(9),c=n(22),d=n(20),f=n(13),h=n(7),p=n(26),b=n(25),g=n(55),y=n(49),v=n(52),m=n(8),D=n(3),M=n(24),w=n(12),x=n(33),S=n(59),O=n(58),F=n(6),k=n(11),T=O.f,Y=F.f,j=S.f,A=r.Symbol,J=r.JSON,N=J&&J.stringify,_="prototype",C=h("_hidden"),E=h("toPrimitive"),P={}.propertyIsEnumerable,I=c("symbol-registry"),V=c("symbols"),L=c("op-symbols"),z=Object[_],R="function"==typeof A,H=r.QObject,B=!H||!H[_]||!H[_].findChild,U=a&&l(function(){return 7!=x(Y({},"a",{get:function(){return Y(this,"a",{value:7}).a}})).a})?function(e,t,n){var r=T(z,t);r&&delete z[t],Y(e,t,n),r&&e!==z&&Y(z,t,r)}:Y,W=function(e){var t=V[e]=x(A[_]);return t._k=e,t},$=R&&"symbol"==typeof A.iterator?function(e){return"symbol"==typeof e}:function(e){return e instanceof A},G=function(e,t,n){return e===z&&G(L,t,n),m(e),t=M(t,!0),m(n),i(V,t)?(n.enumerable?(i(e,C)&&e[C][t]&&(e[C][t]=!1),n=x(n,{enumerable:w(0,!1)})):(i(e,C)||Y(e,C,w(1,{})),e[C][t]=!0),U(e,t,n)):Y(e,t,n)},K=function(e,t){m(e);for(var n,r=y(t=D(t)),i=0,a=r.length;a>i;)G(e,n=r[i++],t[n]);return e},Q=function(e,t){return void 0===t?x(e):K(x(e),t)},X=function(e){var t=P.call(this,e=M(e,!0));return!(this===z&&i(V,e)&&!i(L,e))&&(!(t||!i(this,e)||!i(V,e)||i(this,C)&&this[C][e])||t)},Z=function(e,t){if(e=D(e),t=M(t,!0),e!==z||!i(V,t)||i(L,t)){var n=T(e,t);return!n||!i(V,t)||i(e,C)&&e[C][t]||(n.enumerable=!0),n}},q=function(e){for(var t,n=j(D(e)),r=[],a=0;n.length>a;)i(V,t=n[a++])||t==C||t==u||r.push(t);return r},ee=function(e){for(var t,n=e===z,r=j(n?L:D(e)),a=[],o=0;r.length>o;)!i(V,t=r[o++])||n&&!i(z,t)||a.push(V[t]);return a};R||(A=function(){if(this instanceof A)throw TypeError("Symbol is not a constructor!");var e=f(arguments.length>0?arguments[0]:void 0),t=function(n){this===z&&t.call(L,n),i(this,C)&&i(this[C],e)&&(this[C][e]=!1),U(this,e,w(1,n))};return a&&B&&U(z,e,{configurable:!0,set:t}),W(e)},s(A[_],"toString",function(){return this._k}),O.f=Z,F.f=G,n(34).f=S.f=q,n(19).f=X,n(35).f=ee,a&&!n(18)&&s(z,"propertyIsEnumerable",X,!0),p.f=function(e){return W(h(e))}),o(o.G+o.W+o.F*!R,{Symbol:A});for(var te="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),ne=0;te.length>ne;)h(te[ne++]);for(var te=k(h.store),ne=0;te.length>ne;)b(te[ne++]);o(o.S+o.F*!R,"Symbol",{for:function(e){return i(I,e+="")?I[e]:I[e]=A(e)},keyFor:function(e){if($(e))return g(I,e);throw TypeError(e+" is not a symbol!")},useSetter:function(){B=!0},useSimple:function(){B=!1}}),o(o.S+o.F*!R,"Object",{create:Q,defineProperty:G,defineProperties:K,getOwnPropertyDescriptor:Z,getOwnPropertyNames:q,getOwnPropertySymbols:ee}),J&&o(o.S+o.F*(!R||l(function(){var e=A();return"[null]"!=N([e])||"{}"!=N({a:e})||"{}"!=N(Object(e))})),"JSON",{stringify:function(e){if(void 0!==e&&!$(e)){for(var t,n,r=[e],i=1;arguments.length>i;)r.push(arguments[i++]);return t=r[1],"function"==typeof t&&(n=t),!n&&v(t)||(t=function(e,t){if(n&&(t=n.call(this,e,t)),!$(t))return t}),r[1]=t,N.apply(J,r)}}}),A[_][E]||n(5)(A[_],E,A[_].valueOf),d(A,"Symbol"),d(Math,"Math",!0),d(r.JSON,"JSON",!0)},function(e,t,n){n(25)("asyncIterator")},function(e,t,n){n(25)("observable")},function(e,t,n){n(65);for(var r=n(1),i=n(5),a=n(17),o=n(7)("toStringTag"),s=["NodeList","DOMTokenList","MediaList","StyleSheetList","CSSRuleList"],u=0;u<5;u++){var l=s[u],c=r[l],d=c&&c.prototype;d&&!d[o]&&i(d,o,l),a[l]=a.Array}},function(e,t,n){t=e.exports=n(73)(),t.push([e.id,'*{box-sizing:border-box}.datepicker{position:relative}.calendar{position:absolute;z-index:100;background:#fff;width:300px;border:1px solid #ccc}.calendar header{display:block;line-height:40px}.calendar header span{display:inline-block;text-align:center;width:71.42857142857143%;float:left}.calendar header .next,.calendar header .prev{width:14.285714285714286%;float:left;text-indent:-10000px;position:relative}.calendar header .next:after,.calendar header .prev:after{content:"";position:absolute;left:50%;top:50%;-webkit-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%);border:6px solid transparent}.calendar header .prev:after{border-right:10px solid #000;margin-left:-5px}.calendar header .prev.disabled:after{border-right:10px solid #ddd}.calendar header .next:after{border-left:10px solid #000;margin-left:5px}.calendar header .next.disabled:after{border-left:10px solid #ddd}.calendar header .next:not(.disabled),.calendar header .prev:not(.disabled),.calendar header .up:not(.disabled){cursor:pointer}.calendar header .next:not(.disabled):hover,.calendar header .prev:not(.disabled):hover,.calendar header .up:not(.disabled):hover{background:#eee}.calendar .disabled{color:#ddd;cursor:default}.calendar .cell{display:inline-block;padding:0 5px;width:14.285714285714286%;height:40px;line-height:40px;text-align:center;vertical-align:middle;border:1px solid transparent}.calendar .cell:not(.blank):not(.disabled).day,.calendar .cell:not(.blank):not(.disabled).month,.calendar .cell:not(.blank):not(.disabled).year{cursor:pointer}.calendar .cell:not(.blank):not(.disabled).day:hover,.calendar .cell:not(.blank):not(.disabled).month:hover,.calendar .cell:not(.blank):not(.disabled).year:hover{border:1px solid #4bd}.calendar .cell.selected,.calendar .cell.selected.highlighted,.calendar .cell.selected:hover{background:#4bd}.calendar .cell.highlighted{background:#cae5ed}.calendar .cell.grey{color:#888}.calendar .cell.grey:hover{background:inherit}.calendar .cell.day-header{font-size:75%;white-space:no-wrap;cursor:inherit}.calendar .cell.day-header:hover{background:inherit}.calendar .month,.calendar .year{width:33.333%}',""]);
	},function(e,t){e.exports=function(){var e=[];return e.toString=function(){for(var e=[],t=0;t<this.length;t++){var n=this[t];n[2]?e.push("@media "+n[2]+"{"+n[1]+"}"):e.push(n[1])}return e.join("")},e.i=function(t,n){"string"==typeof t&&(t=[[null,t,""]]);for(var r={},i=0;i<this.length;i++){var a=this[i][0];"number"==typeof a&&(r[a]=!0)}for(i=0;i<t.length;i++){var o=t[i];"number"==typeof o[0]&&r[o[0]]||(n&&!o[2]?o[2]=n:n&&(o[2]="("+o[2]+") and ("+n+")"),e.push(o))}},e}},function(e,t){e.exports=' <div class=datepicker :class=wrapperClass> <input :type="inline ? \'hidden\' : \'text\'" :class=inputClass :name=name :id=id @click=showCalendar() :value=formattedValue :placeholder=placeholder readonly=readonly> <div class=calendar v-show=showDayView v-bind:style=calendarStyle> <header> <span @click=previousMonth class=prev v-bind:class="{ \'disabled\' : previousMonthDisabled(currDate) }">&lt;</span> <span @click=showMonthCalendar class=up>{{ currMonthName }} {{ currYear }}</span> <span @click=nextMonth class=next v-bind:class="{ \'disabled\' : nextMonthDisabled(currDate) }">&gt;</span> </header> <span class="cell day-header" v-for="d in daysOfWeek">{{ d }}</span> <span class="cell day blank" v-for="d in blankDays"></span><span class="cell day" v-for="day in days" track-by=timestamp v-bind:class="{ \'selected\':day.isSelected, \'disabled\':day.isDisabled, \'highlighted\': day.isHighlighted}" @click=selectDate(day)>{{ day.date }}</span> </div> <div class=calendar v-show=showMonthView v-bind:style=calendarStyleSecondary> <header> <span @click=previousYear class=prev v-bind:class="{ \'disabled\' : previousYearDisabled(currDate) }">&lt;</span> <span @click=showYearCalendar class=up>{{ getYear() }}</span> <span @click=nextYear class=next v-bind:class="{ \'disabled\' : nextYearDisabled(currDate) }">&gt;</span> </header> <span class="cell month" v-for="month in months" track-by=timestamp v-bind:class="{ \'selected\': month.isSelected, \'disabled\': month.isDisabled }" @click.stop=selectMonth(month)>{{ month.month }}</span> </div> <div class=calendar v-show=showYearView v-bind:style=calendarStyleSecondary> <header> <span @click=previousDecade class=prev v-bind:class="{ \'disabled\' : previousDecadeDisabled(currDate) }">&lt;</span> <span>{{ getDecade() }}</span> <span @click=nextDecade class=next v-bind:class="{ \'disabled\' : nextMonthDisabled(currDate) }">&gt;</span> </header> <span class="cell year" v-for="year in years" track-by=timestamp v-bind:class="{ \'selected\': year.isSelected, \'disabled\': year.isDisabled }" @click.stop=selectYear(year)>{{ year.year }}</span> </div> </div> '},function(e,t,n){var r,i,a={};n(77),r=n(39),i=n(74),e.exports=r||{},e.exports.__esModule&&(e.exports=e.exports.default);var o="function"==typeof e.exports?e.exports.options||(e.exports.options={}):e.exports;i&&(o.template=i),o.computed||(o.computed={}),Object.keys(a).forEach(function(e){var t=a[e];o.computed[e]=function(){return t}})},function(e,t,n){function r(e,t){for(var n=0;n<e.length;n++){var r=e[n],i=d[r.id];if(i){i.refs++;for(var a=0;a<i.parts.length;a++)i.parts[a](r.parts[a]);for(;a<r.parts.length;a++)i.parts.push(u(r.parts[a],t))}else{for(var o=[],a=0;a<r.parts.length;a++)o.push(u(r.parts[a],t));d[r.id]={id:r.id,refs:1,parts:o}}}}function i(e){for(var t=[],n={},r=0;r<e.length;r++){var i=e[r],a=i[0],o=i[1],s=i[2],u=i[3],l={css:o,media:s,sourceMap:u};n[a]?n[a].parts.push(l):t.push(n[a]={id:a,parts:[l]})}return t}function a(e,t){var n=p(),r=y[y.length-1];if("top"===e.insertAt)r?r.nextSibling?n.insertBefore(t,r.nextSibling):n.appendChild(t):n.insertBefore(t,n.firstChild),y.push(t);else{if("bottom"!==e.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");n.appendChild(t)}}function o(e){e.parentNode.removeChild(e);var t=y.indexOf(e);t>=0&&y.splice(t,1)}function s(e){var t=document.createElement("style");return t.type="text/css",a(e,t),t}function u(e,t){var n,r,i;if(t.singleton){var a=g++;n=b||(b=s(t)),r=l.bind(null,n,a,!1),i=l.bind(null,n,a,!0)}else n=s(t),r=c.bind(null,n),i=function(){o(n)};return r(e),function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap)return;r(e=t)}else i()}}function l(e,t,n,r){var i=n?"":r.css;if(e.styleSheet)e.styleSheet.cssText=v(t,i);else{var a=document.createTextNode(i),o=e.childNodes;o[t]&&e.removeChild(o[t]),o.length?e.insertBefore(a,o[t]):e.appendChild(a)}}function c(e,t){var n=t.css,r=t.media,i=t.sourceMap;if(r&&e.setAttribute("media",r),i&&(n+="\n/*# sourceURL="+i.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(i))))+" */"),e.styleSheet)e.styleSheet.cssText=n;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(n))}}var d={},f=function(e){var t;return function(){return"undefined"==typeof t&&(t=e.apply(this,arguments)),t}},h=f(function(){return/msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase())}),p=f(function(){return document.head||document.getElementsByTagName("head")[0]}),b=null,g=0,y=[];e.exports=function(e,t){t=t||{},"undefined"==typeof t.singleton&&(t.singleton=h()),"undefined"==typeof t.insertAt&&(t.insertAt="bottom");var n=i(e);return r(n,t),function(e){for(var a=[],o=0;o<n.length;o++){var s=n[o],u=d[s.id];u.refs--,a.push(u)}if(e){var l=i(e);r(l,t)}for(var o=0;o<a.length;o++){var u=a[o];if(0===u.refs){for(var c=0;c<u.parts.length;c++)u.parts[c]();delete d[u.id]}}}};var v=function(){var e=[];return function(t,n){return e[t]=n,e.filter(Boolean).join("\n")}}()},function(e,t,n){var r=n(72);"string"==typeof r&&(r=[[e.id,r,""]]);n(76)(r,{});r.locals&&(e.exports=r.locals)}]);
	//# sourceMappingURL=build.js.map

/***/ }),
/* 2233 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Created by championswimmer on 22/07/17.
	 */
	var MockStorage = (function () {
	    function MockStorage() {
	    }
	    Object.defineProperty(MockStorage.prototype, "length", {
	        get: function () {
	            return Object.keys(this).length;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    MockStorage.prototype.key = function (index) {
	        return Object.keys(this)[index];
	    };
	    MockStorage.prototype.setItem = function (key, data) {
	        this[key] = data.toString();
	    };
	    MockStorage.prototype.getItem = function (key) {
	        return this[key];
	    };
	    MockStorage.prototype.removeItem = function (key) {
	        delete this[key];
	    };
	    MockStorage.prototype.clear = function () {
	        for (var _i = 0, _a = Object.keys(this); _i < _a.length; _i++) {
	            var key = _a[_i];
	            delete this[key];
	        }
	    };
	    return MockStorage;
	}());
	exports.default = MockStorage;
	//# sourceMappingURL=MockStorage.js.map

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var MockStorage_1 = __webpack_require__(2233);
	/**
	 * A class that implements the vuex persistence.
	 */
	var VuexPersistence = (function () {
	    /**
	     * Create a {@link VuexPersistence} object.
	     * Use the <code>plugin</code> function of this class as a
	     * Vuex plugin.
	     * @param {PersistOptions} options
	     */
	    function VuexPersistence(options) {
	        var _this = this;
	        /**
	         * Creates a subscriber on the store. automatically is used
	         * when this is used a vuex plugin. Not for manual usage.
	         * @param store
	         */
	        this.subscriber = function (store) {
	            return function (handler) { return store.subscribe(handler); };
	        };
	        this.key = ((options.key != null) ? options.key : 'vuex');
	        this.storage = ((options.storage != null)
	            ? options.storage
	            : (new MockStorage_1.default()));
	        this.restoreState = ((options.restoreState != null)
	            ? options.restoreState
	            : (function (key, storage) {
	                return JSON.parse((storage || _this.storage).getItem(key) || '{}');
	            }));
	        this.saveState = ((options.saveState != null)
	            ? options.saveState
	            : (function (key, state, storage) {
	                return (storage || _this.storage).setItem(key, JSON.stringify(state));
	            }));
	        this.reducer = ((options.reducer != null)
	            ? options.reducer
	            : (function (state) { return state; }));
	        this.filter = ((options.filter != null)
	            ? options.filter
	            : (function (mutation) { return true; }));
	        this.plugin = function (store) {
	            var savedState = _this.restoreState(_this.key, _this.storage);
	            store.replaceState(Object.assign({}, store.state, savedState));
	            _this.subscriber(store)(function (mutation, state) {
	                if (_this.filter(mutation)) {
	                    _this.saveState(_this.key, _this.reducer(state), _this.storage);
	                }
	            });
	        };
	    }
	    return VuexPersistence;
	}());
	exports.VuexPersistence = VuexPersistence;
	exports.default = VuexPersistence;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 2235 */
/***/ (function(module, exports) {

	module.exports.RADIUS = 6378137;
	module.exports.FLATTENING = 1/298.257223563;
	module.exports.POLAR_RADIUS = 6356752.3142;


/***/ }),
/* 2236 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 2237 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 2238 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.c2ec4b79af64c15f8b64.js